// modules are defined as an array
// [ module function, map of requires ]
//
// map of requires is short require name -> numeric require
//
// anything defined in a previous bundle is accessed via the
// orig method which is the require for previous bundles

(function (modules, entry, mainEntry, parcelRequireName, globalName) {
  /* eslint-disable no-undef */
  var globalObject =
    typeof globalThis !== 'undefined'
      ? globalThis
      : typeof self !== 'undefined'
        ? self
        : typeof window !== 'undefined'
          ? window
          : typeof global !== 'undefined'
            ? global
            : {};
  /* eslint-enable no-undef */

  // Save the require from previous bundle to this closure if any
  var previousRequire =
    typeof globalObject[parcelRequireName] === 'function' &&
    globalObject[parcelRequireName];

  var cache = previousRequire.cache || {};
  // Do not use `require` to prevent Webpack from trying to bundle this call
  var nodeRequire =
    typeof module !== 'undefined' &&
    typeof module.require === 'function' &&
    module.require.bind(module);

  function newRequire(name, jumped) {
    if (!cache[name]) {
      if (!modules[name]) {
        // if we cannot find the module within our internal map or
        // cache jump to the current global require ie. the last bundle
        // that was added to the page.
        var currentRequire =
          typeof globalObject[parcelRequireName] === 'function' &&
          globalObject[parcelRequireName];
        if (!jumped && currentRequire) {
          return currentRequire(name, true);
        }

        // If there are other bundles on this page the require from the
        // previous one is saved to 'previousRequire'. Repeat this as
        // many times as there are bundles until the module is found or
        // we exhaust the require chain.
        if (previousRequire) {
          return previousRequire(name, true);
        }

        // Try the node require function if it exists.
        if (nodeRequire && typeof name === 'string') {
          return nodeRequire(name);
        }

        var err = new Error("Cannot find module '" + name + "'");
        err.code = 'MODULE_NOT_FOUND';
        throw err;
      }

      localRequire.resolve = resolve;
      localRequire.cache = {};

      var module = (cache[name] = new newRequire.Module(name));

      modules[name][0].call(
        module.exports,
        localRequire,
        module,
        module.exports,
        globalObject
      );
    }

    return cache[name].exports;

    function localRequire(x) {
      var res = localRequire.resolve(x);
      return res === false ? {} : newRequire(res);
    }

    function resolve(x) {
      var id = modules[name][1][x];
      return id != null ? id : x;
    }
  }

  function Module(moduleName) {
    this.id = moduleName;
    this.bundle = newRequire;
    this.exports = {};
  }

  newRequire.isParcelRequire = true;
  newRequire.Module = Module;
  newRequire.modules = modules;
  newRequire.cache = cache;
  newRequire.parent = previousRequire;
  newRequire.register = function (id, exports) {
    modules[id] = [
      function (require, module) {
        module.exports = exports;
      },
      {},
    ];
  };

  Object.defineProperty(newRequire, 'root', {
    get: function () {
      return globalObject[parcelRequireName];
    },
  });

  globalObject[parcelRequireName] = newRequire;

  for (var i = 0; i < entry.length; i++) {
    newRequire(entry[i]);
  }

  if (mainEntry) {
    // Expose entry point to Node, AMD or browser globals
    // Based on https://github.com/ForbesLindesay/umd/blob/master/template.js
    var mainExports = newRequire(mainEntry);

    // CommonJS
    if (typeof exports === 'object' && typeof module !== 'undefined') {
      module.exports = mainExports;

      // RequireJS
    } else if (typeof define === 'function' && define.amd) {
      define(function () {
        return mainExports;
      });

      // <script>
    } else if (globalName) {
      this[globalName] = mainExports;
    }
  }
})({"ji5m3":[function(require,module,exports,__globalThis) {
// @ts-expect-error TS7017
var global = arguments[3];
var HMR_HOST = null;
var HMR_PORT = null;
var HMR_SECURE = false;
var HMR_ENV_HASH = "953d53f787114b14";
var HMR_USE_SSE = false;
var HMR_ENABLE_BUNDLE_VERSION = false;
module.bundle.HMR_BUNDLE_ID = "c7caee53dd1bf6bd";
"use strict";
/* global HMR_HOST, HMR_PORT, HMR_ENV_HASH, HMR_SECURE, HMR_USE_SSE, chrome, browser, __parcel__import__, __parcel__importScripts__, ServiceWorkerGlobalScope, HMR_ENABLE_BUNDLE_VERSION */ /*::
import type {
  HMRAsset,
  HMRMessage,
} from '@atlaspack/reporter-dev-server/src/HMRServer';
interface ParcelRequire {
  (string): mixed;
  cache: {|[string]: ParcelModule|};
  hotData: {|[string]: mixed|};
  Module: any;
  parent: ?ParcelRequire;
  isParcelRequire: true;
  modules: {|[string]: [Function, {|[string]: string|}]|};
  HMR_BUNDLE_ID: string;
  root: ParcelRequire;
}
interface ParcelModule {
  hot: {|
    data: mixed,
    accept(cb: (Function) => void): void,
    dispose(cb: (mixed) => void): void,
    // accept(deps: Array<string> | string, cb: (Function) => void): void,
    // decline(): void,
    _acceptCallbacks: Array<(Function) => void>,
    _disposeCallbacks: Array<(mixed) => void>,
  |};
}
interface ExtensionContext {
  runtime: {|
    reload(): void,
    getURL(url: string): string;
    getManifest(): {manifest_version: number, ...};
  |};
}
declare var module: {bundle: ParcelRequire, ...};
declare var HMR_HOST: string;
declare var HMR_PORT: string;
declare var HMR_ENV_HASH: string;
declare var HMR_SECURE: boolean;
declare var HMR_USE_SSE: boolean;
declare var HMR_ENABLE_BUNDLE_VERSION: boolean;
declare var chrome: ExtensionContext;
declare var browser: ExtensionContext;
declare var __parcel__import__: (string) => Promise<void>;
declare var __parcel__importScripts__: (string) => Promise<void>;
declare var globalThis: typeof self;
declare var ServiceWorkerGlobalScope: Object;
*/ // flow-to-ts helpers
// /flow-to-ts helpers
var OVERLAY_ID = '__parcel__error__overlay__';
var HMR_BUNDLE_VERSION = '__parcel__hmrBundleVersion';
// @ts-expect-error TS2339
var OldModule = module.bundle.Module;
function Module(moduleName) {
    // @ts-expect-error TS2683
    OldModule.call(this, moduleName);
    // @ts-expect-error TS2683
    this.hot = {
        // @ts-expect-error TS2339
        data: module.bundle.hotData[moduleName],
        _acceptCallbacks: [],
        _disposeCallbacks: [],
        // @ts-expect-error TS7006
        accept: function(fn) {
            this._acceptCallbacks.push(fn || function() {});
        },
        // @ts-expect-error TS7006
        dispose: function(fn) {
            this._disposeCallbacks.push(fn);
        }
    };
    // @ts-expect-error TS2339
    module.bundle.hotData[moduleName] = undefined;
}
// @ts-expect-error TS2339
module.bundle.Module = Module;
// @ts-expect-error TS2339
module.bundle.hotData = {};
// @ts-expect-error TS7034
var checkedAssets /*: {|[string]: boolean|} */ , // @ts-expect-error TS7034
disposedAssets /*: {|[string]: boolean|} */ , // @ts-expect-error TS7034
assetsToDispose /*: Array<[ParcelRequire, string]> */ , // @ts-expect-error TS7034
assetsToAccept /*: Array<[ParcelRequire, string]> */ ;
function getBundleVersion() {
    // @ts-expect-error TS7017
    return globalThis[HMR_BUNDLE_VERSION];
}
function bumpBundleVersion() {
    // @ts-expect-error TS2304
    if (!HMR_ENABLE_BUNDLE_VERSION) return;
    let version = getBundleVersion();
    let nextVersion = typeof version === 'number' && Number.isFinite(version) ? version + 1 : 1;
    // @ts-expect-error TS7017
    globalThis[HMR_BUNDLE_VERSION] = nextVersion;
    return nextVersion;
}
function appendBundleVersion(url) {
    // @ts-expect-error TS2304
    if (!HMR_ENABLE_BUNDLE_VERSION) return url + (url.includes('?') ? '&' : '?') + 't=' + Date.now();
    let version = getBundleVersion();
    if (version == null) return url;
    return url + (url.includes('?') ? '&' : '?') + 't=' + version;
}
function getHostname() {
    return(// @ts-expect-error TS2304
    HMR_HOST || (location.protocol.indexOf('http') === 0 ? location.hostname : 'localhost'));
}
function getPort() {
    // @ts-expect-error TS2304
    return HMR_PORT || location.port;
}
// eslint-disable-next-line no-redeclare
// @ts-expect-error TS2339
var parent = module.bundle.parent;
if ((!parent || !parent.isParcelRequire) && typeof WebSocket !== 'undefined') {
    var hostname = getHostname();
    var port = getPort();
    var protocol = // @ts-expect-error TS2304
    HMR_SECURE || location.protocol == 'https:' && ![
        'localhost',
        '127.0.0.1',
        '0.0.0.0'
    ].includes(hostname) ? 'wss' : 'ws';
    var ws;
    // @ts-expect-error TS2304
    if (HMR_USE_SSE) ws = new EventSource('/__parcel_hmr');
    else try {
        ws = new WebSocket(protocol + '://' + hostname + (port ? ':' + port : '') + '/');
    } catch (err) {
        if (err.message) console.error(err.message);
        ws = {};
    }
    // Web extension context
    var extCtx = // @ts-expect-error TS2304
    typeof browser === 'undefined' ? // @ts-expect-error TS2304
    typeof chrome === 'undefined' ? null : // @ts-expect-error TS2304
    chrome : // @ts-expect-error TS2304
    browser;
    // Safari doesn't support sourceURL in error stacks.
    // eval may also be disabled via CSP, so do a quick check.
    var supportsSourceURL = false;
    try {
        (0, eval)('throw new Error("test"); //# sourceURL=test.js');
    } catch (err) {
        supportsSourceURL = err.stack.includes('test.js');
    }
    // @ts-expect-error TS2339
    ws.onmessage = async function(event) {
        checkedAssets = {} /*: {|[string]: boolean|} */ ;
        disposedAssets = {} /*: {|[string]: boolean|} */ ;
        assetsToAccept = [];
        assetsToDispose = [];
        var data /*: HMRMessage */  = JSON.parse(event.data);
        if (data.type === 'reload') fullReload();
        else if (data.type === 'update') {
            // Remove error overlay if there is one
            if (typeof document !== 'undefined') removeErrorOverlay();
            let assets = data.assets.filter(// @ts-expect-error TS7006
            (asset)=>asset.envHash === HMR_ENV_HASH);
            // Handle HMR Update
            // @ts-expect-error TS7006
            let handled = assets.every((asset)=>{
                return asset.type === 'css' || asset.type === 'js' && // @ts-expect-error TS2339
                hmrAcceptCheck(module.bundle.root, asset.id, asset.depsByBundle);
            });
            if (handled) {
                bumpBundleVersion();
                console.clear();
                // Dispatch custom event so other runtimes (e.g React Refresh) are aware.
                if (typeof window !== 'undefined' && typeof CustomEvent !== 'undefined') window.dispatchEvent(new CustomEvent('parcelhmraccept'));
                await hmrApplyUpdates(assets);
                hmrDisposeQueue();
                // Run accept callbacks. This will also re-execute other disposed assets in topological order.
                let processedAssets = {};
                for(let i = 0; i < assetsToAccept.length; i++){
                    // @ts-expect-error TS7005
                    let id = assetsToAccept[i][1];
                    if (!processedAssets[id]) {
                        // @ts-expect-error TS7005
                        hmrAccept(assetsToAccept[i][0], id);
                        processedAssets[id] = true;
                    }
                }
            } else fullReload();
        }
        if (data.type === 'error') {
            // Log parcel errors to console
            for (let ansiDiagnostic of data.diagnostics.ansi){
                let stack = ansiDiagnostic.codeframe ? ansiDiagnostic.codeframe : ansiDiagnostic.stack;
                console.error("\uD83D\uDEA8 [parcel]: " + ansiDiagnostic.message + '\n' + stack + '\n\n' + ansiDiagnostic.hints.join('\n'));
            }
            if (typeof document !== 'undefined') {
                // Render the fancy html overlay
                removeErrorOverlay();
                var overlay = createErrorOverlay(data.diagnostics.html);
                document.body.appendChild(overlay);
            }
        }
    };
    if (ws instanceof WebSocket) {
        ws.onerror = function(e) {
            if (e.message) console.error(e.message);
        };
        ws.onclose = function(e) {
            console.warn("[parcel] \uD83D\uDEA8 Connection to the HMR server was lost");
        };
    }
}
function removeErrorOverlay() {
    var overlay = document.getElementById(OVERLAY_ID);
    if (overlay) {
        overlay.remove();
        console.log("[parcel] \u2728 Error resolved");
    }
}
function createErrorOverlay(diagnostics) {
    var overlay = document.createElement('div');
    overlay.id = OVERLAY_ID;
    let errorHTML = '<div style="background: black; opacity: 0.85; font-size: 16px; color: white; position: fixed; height: 100%; width: 100%; top: 0px; left: 0px; padding: 30px; font-family: Menlo, Consolas, monospace; z-index: 9999;">';
    for (let diagnostic of diagnostics){
        let stack = diagnostic.frames.length ? // @ts-expect-error TS7006
        diagnostic.frames.reduce((p, frame)=>{
            return `${p}
<a href="/__parcel_launch_editor?file=${encodeURIComponent(frame.location)}" style="text-decoration: underline; color: #888" onclick="fetch(this.href); return false">${frame.location}</a>
${frame.code}`;
        }, '') : diagnostic.stack;
        errorHTML += `
      <div>
        <div style="font-size: 18px; font-weight: bold; margin-top: 20px;">
          \u{1F6A8} ${diagnostic.message}
        </div>
        <pre>${stack}</pre>
        <div>
          ${diagnostic.hints// @ts-expect-error TS7006
        .map((hint)=>"<div>\uD83D\uDCA1 " + hint + '</div>').join('')}
        </div>
        ${diagnostic.documentation ? `<div>\u{1F4DD} <a style="color: violet" href="${diagnostic.documentation}" target="_blank">Learn more</a></div>` : ''}
      </div>
    `;
    }
    errorHTML += '</div>';
    overlay.innerHTML = errorHTML;
    return overlay;
}
function fullReload() {
    if ('reload' in location) location.reload();
    else if (extCtx && extCtx.runtime && extCtx.runtime.reload) extCtx.runtime.reload();
}
function getParents(// @ts-expect-error TS2304
bundle, id) /*: Array<[ParcelRequire, string]> */ {
    var modules = bundle.modules;
    if (!modules) return [];
    // @ts-expect-error TS2304
    var parents = [];
    var k, d, dep;
    for(k in modules)for(d in modules[k][1]){
        dep = modules[k][1][d];
        if (dep === id || Array.isArray(dep) && dep[dep.length - 1] === id) parents.push([
            bundle,
            k
        ]);
    }
    if (bundle.parent) parents = parents.concat(getParents(bundle.parent, id));
    return parents;
}
function updateLink(link) {
    var href = link.getAttribute('href');
    if (!href) return;
    var newLink = link.cloneNode();
    // @ts-expect-error TS2345
    newLink.onload = function() {
        if (link.parentNode !== null) link.parentNode.removeChild(link);
    };
    // @ts-expect-error TS2339
    newLink.setAttribute('href', appendBundleVersion(href));
    // @ts-expect-error TS18047
    link.parentNode.insertBefore(newLink, link.nextSibling);
}
// @ts-expect-error TS7034
var cssTimeout = null;
function reloadCSS() {
    // @ts-expect-error TS7005
    if (cssTimeout) return;
    cssTimeout = setTimeout(function() {
        var document1 = window.document;
        var links = document1.querySelectorAll('link[rel="stylesheet"]');
        for(var i = 0; i < links.length; i++){
            var href /*: string */  = links[i].getAttribute('href');
            var hostname = getHostname();
            var servedFromHMRServer = hostname === 'localhost' ? new RegExp('^(https?:\\/\\/(0.0.0.0|127.0.0.1)|localhost):' + getPort()) // @ts-expect-error TS2345
            .test(href) : // @ts-expect-error TS2345
            href.indexOf(hostname + ':' + getPort());
            var absolute = // @ts-expect-error TS2345
            /^https?:\/\//i.test(href) && // @ts-expect-error TS18047
            href.indexOf(location.origin) !== 0 && !servedFromHMRServer;
            if (!absolute) // @ts-expect-error TS2345
            updateLink(links[i]);
        }
        cssTimeout = null;
    }, 50);
}
// @ts-expect-error TS2304
function hmrDownload(asset) {
    if (asset.type === 'js') {
        if (typeof document !== 'undefined') {
            let script = document.createElement('script');
            script.src = appendBundleVersion(asset.url);
            if (asset.outputFormat === 'esmodule') script.type = 'module';
            return new Promise((resolve, reject)=>{
                var _document$head;
                script.onload = ()=>resolve(script);
                script.onerror = reject;
                (_document$head = document.head) === null || _document$head === void 0 || _document$head.appendChild(script);
            });
        // @ts-expect-error TS2304
        } else if (typeof importScripts === 'function') {
            // Worker scripts
            if (asset.outputFormat === 'esmodule') // @ts-expect-error TS2304
            return import(appendBundleVersion(asset.url));
            else return new Promise((resolve, reject)=>{
                try {
                    // @ts-expect-error TS2304
                    importScripts(appendBundleVersion(asset.url));
                    // @ts-expect-error TS2794
                    resolve();
                } catch (err) {
                    reject(err);
                }
            });
        }
    }
}
// @ts-expect-error TS2304
async function hmrApplyUpdates(assets) {
    global.parcelHotUpdate = Object.create(null);
    let scriptsToRemove;
    try {
        // If sourceURL comments aren't supported in eval, we need to load
        // the update from the dev server over HTTP so that stack traces
        // are correct in errors/logs. This is much slower than eval, so
        // we only do it if needed (currently just Safari).
        // https://bugs.webkit.org/show_bug.cgi?id=137297
        // This path is also taken if a CSP disallows eval.
        if (!supportsSourceURL) {
            let promises = assets.map((asset)=>{
                var _hmrDownload;
                return (_hmrDownload = hmrDownload(asset)) === null || _hmrDownload === void 0 ? void 0 : _hmrDownload.catch((err)=>{
                    // Web extension fix
                    if (extCtx && extCtx.runtime && extCtx.runtime.getManifest().manifest_version == 3 && // @ts-expect-error TS2304
                    typeof ServiceWorkerGlobalScope != 'undefined' && // @ts-expect-error TS2304
                    global instanceof ServiceWorkerGlobalScope) {
                        extCtx.runtime.reload();
                        return;
                    }
                    throw err;
                });
            });
            scriptsToRemove = await Promise.all(promises);
        }
        assets.forEach(function(asset) {
            // @ts-expect-error TS2339
            hmrApply(module.bundle.root, asset);
        });
    } finally{
        // @ts-expect-error TS7017
        delete global.parcelHotUpdate;
        if (scriptsToRemove) // @ts-expect-error TS7006
        scriptsToRemove.forEach((script)=>{
            if (script) {
                var _document$head2;
                (_document$head2 = document.head) === null || _document$head2 === void 0 || _document$head2.removeChild(script);
            }
        });
    }
}
function hmrApply(// @ts-expect-error TS2304
bundle, // @ts-expect-error TS2304
asset) {
    var modules = bundle.modules;
    if (!modules) return;
    if (asset.type === 'css') reloadCSS();
    else if (asset.type === 'js') {
        let deps = asset.depsByBundle[bundle.HMR_BUNDLE_ID];
        if (deps) {
            if (modules[asset.id]) {
                // Remove dependencies that are removed and will become orphaned.
                // This is necessary so that if the asset is added back again, the cache is gone, and we prevent a full page reload.
                let oldDeps = modules[asset.id][1];
                for(let dep in oldDeps)if (!deps[dep] || deps[dep] !== oldDeps[dep]) {
                    let id = oldDeps[dep];
                    // @ts-expect-error TS2339
                    let parents = getParents(module.bundle.root, id);
                    if (parents.length === 1) // @ts-expect-error TS2339
                    hmrDelete(module.bundle.root, id);
                }
            }
            if (supportsSourceURL) // Global eval. We would use `new Function` here but browser
            // support for source maps is better with eval.
            (0, eval)(asset.output);
            // @ts-expect-error TS7017
            let fn = global.parcelHotUpdate[asset.id];
            modules[asset.id] = [
                fn,
                deps
            ];
        }
        // Always traverse to the parent bundle, even if we already replaced the asset in this bundle.
        // This is required in case modules are duplicated. We need to ensure all instances have the updated code.
        if (bundle.parent) hmrApply(bundle.parent, asset);
    }
}
// @ts-expect-error TS2304
function hmrDelete(bundle, id) {
    let modules = bundle.modules;
    if (!modules) return;
    if (modules[id]) {
        // Collect dependencies that will become orphaned when this module is deleted.
        let deps = modules[id][1];
        let orphans = [];
        for(let dep in deps){
            // @ts-expect-error TS2339
            let parents = getParents(module.bundle.root, deps[dep]);
            if (parents.length === 1) orphans.push(deps[dep]);
        }
        // Delete the module. This must be done before deleting dependencies in case of circular dependencies.
        delete modules[id];
        delete bundle.cache[id];
        // Now delete the orphans.
        orphans.forEach((id)=>{
            // @ts-expect-error TS2339
            hmrDelete(module.bundle.root, id);
        });
    } else if (bundle.parent) hmrDelete(bundle.parent, id);
}
function hmrAcceptCheck(// @ts-expect-error TS2304
bundle, id, depsByBundle) {
    if (hmrAcceptCheckOne(bundle, id, depsByBundle)) return true;
    // Traverse parents breadth first. All possible ancestries must accept the HMR update, or we'll reload.
    // @ts-expect-error TS2339
    let parents = getParents(module.bundle.root, id);
    let accepted = false;
    while(parents.length > 0){
        let v = parents.shift();
        // @ts-expect-error TS18048
        let a = hmrAcceptCheckOne(v[0], v[1], null);
        if (a) // If this parent accepts, stop traversing upward, but still consider siblings.
        accepted = true;
        else {
            // Otherwise, queue the parents in the next level upward.
            // @ts-expect-error TS2339
            let p = getParents(module.bundle.root, v[1]);
            if (p.length === 0) {
                // If there are no parents, then we've reached an entry without accepting. Reload.
                accepted = false;
                break;
            }
            parents.push(...p);
        }
    }
    return accepted;
}
function hmrAcceptCheckOne(// @ts-expect-error TS2304
bundle, id, depsByBundle) {
    var modules = bundle.modules;
    if (!modules) return;
    if (depsByBundle && !depsByBundle[bundle.HMR_BUNDLE_ID]) {
        // If we reached the root bundle without finding where the asset should go,
        // there's nothing to do. Mark as "accepted" so we don't reload the page.
        if (!bundle.parent) return true;
        return hmrAcceptCheck(bundle.parent, id, depsByBundle);
    }
    // @ts-expect-error TS7005
    if (checkedAssets[id]) return true;
    // @ts-expect-error TS7005
    checkedAssets[id] = true;
    var cached = bundle.cache[id];
    assetsToDispose.push([
        bundle,
        id
    ]);
    if (!cached || cached.hot && cached.hot._acceptCallbacks.length) {
        assetsToAccept.push([
            bundle,
            id
        ]);
        return true;
    }
}
function hmrDisposeQueue() {
    // Dispose all old assets.
    for(let i = 0; i < assetsToDispose.length; i++){
        // @ts-expect-error TS7005
        let id = assetsToDispose[i][1];
        // @ts-expect-error TS7005
        if (!disposedAssets[id]) {
            // @ts-expect-error TS7005
            hmrDispose(assetsToDispose[i][0], id);
            disposedAssets[id] = true;
        }
    }
    assetsToDispose = [];
}
function hmrDispose(// @ts-expect-error TS2304
bundle, id) {
    var cached = bundle.cache[id];
    bundle.hotData[id] = {};
    if (cached && cached.hot) cached.hot.data = bundle.hotData[id];
    if (cached && cached.hot && cached.hot._disposeCallbacks.length) // @ts-expect-error TS7006
    cached.hot._disposeCallbacks.forEach(function(cb) {
        cb(bundle.hotData[id]);
    });
    delete bundle.cache[id];
}
function hmrAccept(// @ts-expect-error TS2304
bundle, id) {
    // Execute the module.
    bundle(id);
    // Run the accept callbacks in the new version of the module.
    var cached = bundle.cache[id];
    if (cached && cached.hot && cached.hot._acceptCallbacks.length) {
        let assetsToAlsoAccept = [];
        // @ts-expect-error TS7006
        cached.hot._acceptCallbacks.forEach(function(cb) {
            let additionalAssets = cb(function() {
                // @ts-expect-error TS2339
                return getParents(module.bundle.root, id);
            });
            if (Array.isArray(additionalAssets) && additionalAssets.length) // @ts-expect-error TS2345
            assetsToAlsoAccept.push(...additionalAssets);
        });
        if (assetsToAlsoAccept.length > 0) {
            let handled = assetsToAlsoAccept.every(function(a) {
                // @ts-expect-error TS2554
                return hmrAcceptCheck(a[0], a[1]);
            });
            if (!handled) return fullReload();
            hmrDisposeQueue();
        }
    }
}

},{}],"6hUoe":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _client = require("react-dom/client");
/* eslint-disable import/no-extraneous-dependencies -- see src/config/parcel-plugins/resolve-platform-workspace.cjs */ /* Placeholder import that'll be replaced with a static import to the consumer's
app's main component. See platform/packages/uip/stub-frontkit-app-component/README.md */ var _stubFrontkitAppComponent = require("@atlassian/stub-frontkit-app-component");
var _stubFrontkitAppComponentDefault = parcelHelpers.interopDefault(_stubFrontkitAppComponent);
/* eslint-enable import/no-extraneous-dependencies */ var _appWrapper = require("./app-wrapper");
var _adsGlobalStyles = require("./ads-global-styles");
const isStatic = typeof window !== 'undefined' && window.IS_STATIC;
const enableADS = true;
const AppWithWrapper = ()=>/*#__PURE__*/ (0, _reactDefault.default).createElement((0, _appWrapper.AppWrapper), null, /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _stubFrontkitAppComponentDefault.default), null));
const AppWithADS = ({ children })=>/*#__PURE__*/ (0, _reactDefault.default).createElement((0, _adsGlobalStyles.ADSGlobalStyles), {
        isStatic: isStatic
    }, children);
const RenderOrHydrate = ()=>{
    if (enableADS) return /*#__PURE__*/ (0, _reactDefault.default).createElement(AppWithADS, null, /*#__PURE__*/ (0, _reactDefault.default).createElement(AppWithWrapper, null));
    return /*#__PURE__*/ (0, _reactDefault.default).createElement(AppWithWrapper, null);
};
const renderApp = ()=>{
    const domNode = document.getElementById('pillar-root');
    const MaybeStrictMode = (0, (0, _reactDefault.default).Fragment);
    const rootComponent = /*#__PURE__*/ (0, _reactDefault.default).createElement(MaybeStrictMode, null, /*#__PURE__*/ (0, _reactDefault.default).createElement(RenderOrHydrate, null));
    if (isStatic) {
        const root = (0, _client.createRoot)(domNode);
        root.render(rootComponent);
    } else (0, _client.hydrateRoot)(domNode, rootComponent);
};
renderApp();

},{"react":"ltHCL","react-dom/client":"2ebWF","@atlassian/stub-frontkit-app-component":"jRpVs","./app-wrapper":"259XF","./ads-global-styles":"la54k","@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"ltHCL":[function(require,module,exports,__globalThis) {
'use strict';
module.exports = require("a94a675d5a7c6f10");

},{"a94a675d5a7c6f10":"526IC"}],"526IC":[function(require,module,exports,__globalThis) {
/**
 * @license React
 * react.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ 'use strict';
var l = Symbol.for("react.element"), n = Symbol.for("react.portal"), p = Symbol.for("react.fragment"), q = Symbol.for("react.strict_mode"), r = Symbol.for("react.profiler"), t = Symbol.for("react.provider"), u = Symbol.for("react.context"), v = Symbol.for("react.forward_ref"), w = Symbol.for("react.suspense"), x = Symbol.for("react.memo"), y = Symbol.for("react.lazy"), z = Symbol.iterator;
function A(a) {
    if (null === a || "object" !== typeof a) return null;
    a = z && a[z] || a["@@iterator"];
    return "function" === typeof a ? a : null;
}
var B = {
    isMounted: function() {
        return !1;
    },
    enqueueForceUpdate: function() {},
    enqueueReplaceState: function() {},
    enqueueSetState: function() {}
}, C = Object.assign, D = {};
function E(a, b, e) {
    this.props = a;
    this.context = b;
    this.refs = D;
    this.updater = e || B;
}
E.prototype.isReactComponent = {};
E.prototype.setState = function(a, b) {
    if ("object" !== typeof a && "function" !== typeof a && null != a) throw Error("setState(...): takes an object of state variables to update or a function which returns an object of state variables.");
    this.updater.enqueueSetState(this, a, b, "setState");
};
E.prototype.forceUpdate = function(a) {
    this.updater.enqueueForceUpdate(this, a, "forceUpdate");
};
function F() {}
F.prototype = E.prototype;
function G(a, b, e) {
    this.props = a;
    this.context = b;
    this.refs = D;
    this.updater = e || B;
}
var H = G.prototype = new F;
H.constructor = G;
C(H, E.prototype);
H.isPureReactComponent = !0;
var I = Array.isArray, J = Object.prototype.hasOwnProperty, K = {
    current: null
}, L = {
    key: !0,
    ref: !0,
    __self: !0,
    __source: !0
};
function M(a, b, e) {
    var d, c = {}, k = null, h = null;
    if (null != b) for(d in void 0 !== b.ref && (h = b.ref), void 0 !== b.key && (k = "" + b.key), b)J.call(b, d) && !L.hasOwnProperty(d) && (c[d] = b[d]);
    var g = arguments.length - 2;
    if (1 === g) c.children = e;
    else if (1 < g) {
        for(var f = Array(g), m = 0; m < g; m++)f[m] = arguments[m + 2];
        c.children = f;
    }
    if (a && a.defaultProps) for(d in g = a.defaultProps, g)void 0 === c[d] && (c[d] = g[d]);
    return {
        $$typeof: l,
        type: a,
        key: k,
        ref: h,
        props: c,
        _owner: K.current
    };
}
function N(a, b) {
    return {
        $$typeof: l,
        type: a.type,
        key: b,
        ref: a.ref,
        props: a.props,
        _owner: a._owner
    };
}
function O(a) {
    return "object" === typeof a && null !== a && a.$$typeof === l;
}
function escape(a) {
    var b = {
        "=": "=0",
        ":": "=2"
    };
    return "$" + a.replace(/[=:]/g, function(a) {
        return b[a];
    });
}
var P = /\/+/g;
function Q(a, b) {
    return "object" === typeof a && null !== a && null != a.key ? escape("" + a.key) : b.toString(36);
}
function R(a, b, e, d, c) {
    var k = typeof a;
    if ("undefined" === k || "boolean" === k) a = null;
    var h = !1;
    if (null === a) h = !0;
    else switch(k){
        case "string":
        case "number":
            h = !0;
            break;
        case "object":
            switch(a.$$typeof){
                case l:
                case n:
                    h = !0;
            }
    }
    if (h) return h = a, c = c(h), a = "" === d ? "." + Q(h, 0) : d, I(c) ? (e = "", null != a && (e = a.replace(P, "$&/") + "/"), R(c, b, e, "", function(a) {
        return a;
    })) : null != c && (O(c) && (c = N(c, e + (!c.key || h && h.key === c.key ? "" : ("" + c.key).replace(P, "$&/") + "/") + a)), b.push(c)), 1;
    h = 0;
    d = "" === d ? "." : d + ":";
    if (I(a)) for(var g = 0; g < a.length; g++){
        k = a[g];
        var f = d + Q(k, g);
        h += R(k, b, e, f, c);
    }
    else if (f = A(a), "function" === typeof f) for(a = f.call(a), g = 0; !(k = a.next()).done;)k = k.value, f = d + Q(k, g++), h += R(k, b, e, f, c);
    else if ("object" === k) throw b = String(a), Error("Objects are not valid as a React child (found: " + ("[object Object]" === b ? "object with keys {" + Object.keys(a).join(", ") + "}" : b) + "). If you meant to render a collection of children, use an array instead.");
    return h;
}
function S(a, b, e) {
    if (null == a) return a;
    var d = [], c = 0;
    R(a, d, "", "", function(a) {
        return b.call(e, a, c++);
    });
    return d;
}
function T(a) {
    if (-1 === a._status) {
        var b = a._result;
        b = b();
        b.then(function(b) {
            if (0 === a._status || -1 === a._status) a._status = 1, a._result = b;
        }, function(b) {
            if (0 === a._status || -1 === a._status) a._status = 2, a._result = b;
        });
        -1 === a._status && (a._status = 0, a._result = b);
    }
    if (1 === a._status) return a._result.default;
    throw a._result;
}
var U = {
    current: null
}, V = {
    transition: null
}, W = {
    ReactCurrentDispatcher: U,
    ReactCurrentBatchConfig: V,
    ReactCurrentOwner: K
};
function X() {
    throw Error("act(...) is not supported in production builds of React.");
}
exports.Children = {
    map: S,
    forEach: function(a, b, e) {
        S(a, function() {
            b.apply(this, arguments);
        }, e);
    },
    count: function(a) {
        var b = 0;
        S(a, function() {
            b++;
        });
        return b;
    },
    toArray: function(a) {
        return S(a, function(a) {
            return a;
        }) || [];
    },
    only: function(a) {
        if (!O(a)) throw Error("React.Children.only expected to receive a single React element child.");
        return a;
    }
};
exports.Component = E;
exports.Fragment = p;
exports.Profiler = r;
exports.PureComponent = G;
exports.StrictMode = q;
exports.Suspense = w;
exports.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED = W;
exports.act = X;
exports.cloneElement = function(a, b, e) {
    if (null === a || void 0 === a) throw Error("React.cloneElement(...): The argument must be a React element, but you passed " + a + ".");
    var d = C({}, a.props), c = a.key, k = a.ref, h = a._owner;
    if (null != b) {
        void 0 !== b.ref && (k = b.ref, h = K.current);
        void 0 !== b.key && (c = "" + b.key);
        if (a.type && a.type.defaultProps) var g = a.type.defaultProps;
        for(f in b)J.call(b, f) && !L.hasOwnProperty(f) && (d[f] = void 0 === b[f] && void 0 !== g ? g[f] : b[f]);
    }
    var f = arguments.length - 2;
    if (1 === f) d.children = e;
    else if (1 < f) {
        g = Array(f);
        for(var m = 0; m < f; m++)g[m] = arguments[m + 2];
        d.children = g;
    }
    return {
        $$typeof: l,
        type: a.type,
        key: c,
        ref: k,
        props: d,
        _owner: h
    };
};
exports.createContext = function(a) {
    a = {
        $$typeof: u,
        _currentValue: a,
        _currentValue2: a,
        _threadCount: 0,
        Provider: null,
        Consumer: null,
        _defaultValue: null,
        _globalName: null
    };
    a.Provider = {
        $$typeof: t,
        _context: a
    };
    return a.Consumer = a;
};
exports.createElement = M;
exports.createFactory = function(a) {
    var b = M.bind(null, a);
    b.type = a;
    return b;
};
exports.createRef = function() {
    return {
        current: null
    };
};
exports.forwardRef = function(a) {
    return {
        $$typeof: v,
        render: a
    };
};
exports.isValidElement = O;
exports.lazy = function(a) {
    return {
        $$typeof: y,
        _payload: {
            _status: -1,
            _result: a
        },
        _init: T
    };
};
exports.memo = function(a, b) {
    return {
        $$typeof: x,
        type: a,
        compare: void 0 === b ? null : b
    };
};
exports.startTransition = function(a) {
    var b = V.transition;
    V.transition = {};
    try {
        a();
    } finally{
        V.transition = b;
    }
};
exports.unstable_act = X;
exports.useCallback = function(a, b) {
    return U.current.useCallback(a, b);
};
exports.useContext = function(a) {
    return U.current.useContext(a);
};
exports.useDebugValue = function() {};
exports.useDeferredValue = function(a) {
    return U.current.useDeferredValue(a);
};
exports.useEffect = function(a, b) {
    return U.current.useEffect(a, b);
};
exports.useId = function() {
    return U.current.useId();
};
exports.useImperativeHandle = function(a, b, e) {
    return U.current.useImperativeHandle(a, b, e);
};
exports.useInsertionEffect = function(a, b) {
    return U.current.useInsertionEffect(a, b);
};
exports.useLayoutEffect = function(a, b) {
    return U.current.useLayoutEffect(a, b);
};
exports.useMemo = function(a, b) {
    return U.current.useMemo(a, b);
};
exports.useReducer = function(a, b, e) {
    return U.current.useReducer(a, b, e);
};
exports.useRef = function(a) {
    return U.current.useRef(a);
};
exports.useState = function(a) {
    return U.current.useState(a);
};
exports.useSyncExternalStore = function(a, b, e) {
    return U.current.useSyncExternalStore(a, b, e);
};
exports.useTransition = function() {
    return U.current.useTransition();
};
exports.version = "18.3.1";

},{}],"2ebWF":[function(require,module,exports,__globalThis) {
'use strict';
var m = require("f12fe9ca6f307f1");
var i;
exports.createRoot = m.createRoot;
exports.hydrateRoot = m.hydrateRoot;

},{"f12fe9ca6f307f1":"7Lblg"}],"7Lblg":[function(require,module,exports,__globalThis) {
'use strict';
function checkDCE() {
    /* global __REACT_DEVTOOLS_GLOBAL_HOOK__ */ if (typeof __REACT_DEVTOOLS_GLOBAL_HOOK__ === 'undefined' || typeof __REACT_DEVTOOLS_GLOBAL_HOOK__.checkDCE !== 'function') return;
    try {
        // Verify that the code above has been dead code eliminated (DCE'd).
        __REACT_DEVTOOLS_GLOBAL_HOOK__.checkDCE(checkDCE);
    } catch (err) {
        // DevTools shouldn't crash React, no matter what.
        // We should still report in case we break this code.
        console.error(err);
    }
}
// DCE check should happen before ReactDOM bundle executes so that
// DevTools can report bad minification during injection.
checkDCE();
module.exports = require("316613a537f55cce");

},{"316613a537f55cce":"bwu1z"}],"bwu1z":[function(require,module,exports,__globalThis) {
/**
 * @license React
 * react-dom.profiling.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ 'use strict';
/* global __REACT_DEVTOOLS_GLOBAL_HOOK__ */ if (typeof __REACT_DEVTOOLS_GLOBAL_HOOK__ !== 'undefined' && typeof __REACT_DEVTOOLS_GLOBAL_HOOK__.registerInternalModuleStart === 'function') __REACT_DEVTOOLS_GLOBAL_HOOK__.registerInternalModuleStart(new Error());
/*
 Modernizr 3.0.0pre (Custom Build) | MIT
*/ 'use strict';
var aa = require("9b7a2cbfda883b4f"), ba = require("3dd33f013095511");
function p(a) {
    for(var b = "https://reactjs.org/docs/error-decoder.html?invariant=" + a, c = 1; c < arguments.length; c++)b += "&args[]=" + encodeURIComponent(arguments[c]);
    return "Minified React error #" + a + "; visit " + b + " for the full message or use the non-minified dev environment for full errors and additional helpful warnings.";
}
var da = new Set, ea = {};
function fa(a, b) {
    ha(a, b);
    ha(a + "Capture", b);
}
function ha(a, b) {
    ea[a] = b;
    for(a = 0; a < b.length; a++)da.add(b[a]);
}
var ia = !("undefined" === typeof window || "undefined" === typeof window.document || "undefined" === typeof window.document.createElement), ja = Object.prototype.hasOwnProperty, ka = /^[:A-Z_a-z\u00C0-\u00D6\u00D8-\u00F6\u00F8-\u02FF\u0370-\u037D\u037F-\u1FFF\u200C-\u200D\u2070-\u218F\u2C00-\u2FEF\u3001-\uD7FF\uF900-\uFDCF\uFDF0-\uFFFD][:A-Z_a-z\u00C0-\u00D6\u00D8-\u00F6\u00F8-\u02FF\u0370-\u037D\u037F-\u1FFF\u200C-\u200D\u2070-\u218F\u2C00-\u2FEF\u3001-\uD7FF\uF900-\uFDCF\uFDF0-\uFFFD\-.0-9\u00B7\u0300-\u036F\u203F-\u2040]*$/, la = {}, ma = {};
function na(a) {
    if (ja.call(ma, a)) return !0;
    if (ja.call(la, a)) return !1;
    if (ka.test(a)) return ma[a] = !0;
    la[a] = !0;
    return !1;
}
function oa(a, b, c, d) {
    if (null !== c && 0 === c.type) return !1;
    switch(typeof b){
        case "function":
        case "symbol":
            return !0;
        case "boolean":
            if (d) return !1;
            if (null !== c) return !c.acceptsBooleans;
            a = a.toLowerCase().slice(0, 5);
            return "data-" !== a && "aria-" !== a;
        default:
            return !1;
    }
}
function pa(a, b, c, d) {
    if (null === b || "undefined" === typeof b || oa(a, b, c, d)) return !0;
    if (d) return !1;
    if (null !== c) switch(c.type){
        case 3:
            return !b;
        case 4:
            return !1 === b;
        case 5:
            return isNaN(b);
        case 6:
            return isNaN(b) || 1 > b;
    }
    return !1;
}
function qa(a, b, c, d, e, f, g) {
    this.acceptsBooleans = 2 === b || 3 === b || 4 === b;
    this.attributeName = d;
    this.attributeNamespace = e;
    this.mustUseProperty = c;
    this.propertyName = a;
    this.type = b;
    this.sanitizeURL = f;
    this.removeEmptyString = g;
}
var t = {};
"children dangerouslySetInnerHTML defaultValue defaultChecked innerHTML suppressContentEditableWarning suppressHydrationWarning style".split(" ").forEach(function(a) {
    t[a] = new qa(a, 0, !1, a, null, !1, !1);
});
[
    [
        "acceptCharset",
        "accept-charset"
    ],
    [
        "className",
        "class"
    ],
    [
        "htmlFor",
        "for"
    ],
    [
        "httpEquiv",
        "http-equiv"
    ]
].forEach(function(a) {
    var b = a[0];
    t[b] = new qa(b, 1, !1, a[1], null, !1, !1);
});
[
    "contentEditable",
    "draggable",
    "spellCheck",
    "value"
].forEach(function(a) {
    t[a] = new qa(a, 2, !1, a.toLowerCase(), null, !1, !1);
});
[
    "autoReverse",
    "externalResourcesRequired",
    "focusable",
    "preserveAlpha"
].forEach(function(a) {
    t[a] = new qa(a, 2, !1, a, null, !1, !1);
});
"allowFullScreen async autoFocus autoPlay controls default defer disabled disablePictureInPicture disableRemotePlayback formNoValidate hidden loop noModule noValidate open playsInline readOnly required reversed scoped seamless itemScope".split(" ").forEach(function(a) {
    t[a] = new qa(a, 3, !1, a.toLowerCase(), null, !1, !1);
});
[
    "checked",
    "multiple",
    "muted",
    "selected"
].forEach(function(a) {
    t[a] = new qa(a, 3, !0, a, null, !1, !1);
});
[
    "capture",
    "download"
].forEach(function(a) {
    t[a] = new qa(a, 4, !1, a, null, !1, !1);
});
[
    "cols",
    "rows",
    "size",
    "span"
].forEach(function(a) {
    t[a] = new qa(a, 6, !1, a, null, !1, !1);
});
[
    "rowSpan",
    "start"
].forEach(function(a) {
    t[a] = new qa(a, 5, !1, a.toLowerCase(), null, !1, !1);
});
var ra = /[\-:]([a-z])/g;
function ta(a) {
    return a[1].toUpperCase();
}
"accent-height alignment-baseline arabic-form baseline-shift cap-height clip-path clip-rule color-interpolation color-interpolation-filters color-profile color-rendering dominant-baseline enable-background fill-opacity fill-rule flood-color flood-opacity font-family font-size font-size-adjust font-stretch font-style font-variant font-weight glyph-name glyph-orientation-horizontal glyph-orientation-vertical horiz-adv-x horiz-origin-x image-rendering letter-spacing lighting-color marker-end marker-mid marker-start overline-position overline-thickness paint-order panose-1 pointer-events rendering-intent shape-rendering stop-color stop-opacity strikethrough-position strikethrough-thickness stroke-dasharray stroke-dashoffset stroke-linecap stroke-linejoin stroke-miterlimit stroke-opacity stroke-width text-anchor text-decoration text-rendering underline-position underline-thickness unicode-bidi unicode-range units-per-em v-alphabetic v-hanging v-ideographic v-mathematical vector-effect vert-adv-y vert-origin-x vert-origin-y word-spacing writing-mode xmlns:xlink x-height".split(" ").forEach(function(a) {
    var b = a.replace(ra, ta);
    t[b] = new qa(b, 1, !1, a, null, !1, !1);
});
"xlink:actuate xlink:arcrole xlink:role xlink:show xlink:title xlink:type".split(" ").forEach(function(a) {
    var b = a.replace(ra, ta);
    t[b] = new qa(b, 1, !1, a, "http://www.w3.org/1999/xlink", !1, !1);
});
[
    "xml:base",
    "xml:lang",
    "xml:space"
].forEach(function(a) {
    var b = a.replace(ra, ta);
    t[b] = new qa(b, 1, !1, a, "http://www.w3.org/XML/1998/namespace", !1, !1);
});
[
    "tabIndex",
    "crossOrigin"
].forEach(function(a) {
    t[a] = new qa(a, 1, !1, a.toLowerCase(), null, !1, !1);
});
t.xlinkHref = new qa("xlinkHref", 1, !1, "xlink:href", "http://www.w3.org/1999/xlink", !0, !1);
[
    "src",
    "href",
    "action",
    "formAction"
].forEach(function(a) {
    t[a] = new qa(a, 1, !1, a.toLowerCase(), null, !0, !0);
});
function ua(a, b, c, d) {
    var e = t.hasOwnProperty(b) ? t[b] : null;
    if (null !== e ? 0 !== e.type : d || !(2 < b.length) || "o" !== b[0] && "O" !== b[0] || "n" !== b[1] && "N" !== b[1]) pa(b, c, e, d) && (c = null), d || null === e ? na(b) && (null === c ? a.removeAttribute(b) : a.setAttribute(b, "" + c)) : e.mustUseProperty ? a[e.propertyName] = null === c ? 3 === e.type ? !1 : "" : c : (b = e.attributeName, d = e.attributeNamespace, null === c ? a.removeAttribute(b) : (e = e.type, c = 3 === e || 4 === e && !0 === c ? "" : "" + c, d ? a.setAttributeNS(d, b, c) : a.setAttribute(b, c)));
}
var va = aa.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED, wa = Symbol.for("react.element"), xa = Symbol.for("react.portal"), ya = Symbol.for("react.fragment"), za = Symbol.for("react.strict_mode"), Aa = Symbol.for("react.profiler"), Ba = Symbol.for("react.provider"), Ca = Symbol.for("react.context"), Da = Symbol.for("react.forward_ref"), Ea = Symbol.for("react.suspense"), Fa = Symbol.for("react.suspense_list"), Ga = Symbol.for("react.memo"), Ha = Symbol.for("react.lazy");
Symbol.for("react.scope");
Symbol.for("react.debug_trace_mode");
var Ia = Symbol.for("react.offscreen");
Symbol.for("react.legacy_hidden");
Symbol.for("react.cache");
Symbol.for("react.tracing_marker");
var Ja = Symbol.iterator;
function Ka(a) {
    if (null === a || "object" !== typeof a) return null;
    a = Ja && a[Ja] || a["@@iterator"];
    return "function" === typeof a ? a : null;
}
var u = Object.assign, La;
function Ma(a) {
    if (void 0 === La) try {
        throw Error();
    } catch (c) {
        var b = c.stack.trim().match(/\n( *(at )?)/);
        La = b && b[1] || "";
    }
    return "\n" + La + a;
}
var Na = !1;
function Oa(a, b) {
    if (!a || Na) return "";
    Na = !0;
    var c = Error.prepareStackTrace;
    Error.prepareStackTrace = void 0;
    try {
        if (b) {
            if (b = function() {
                throw Error();
            }, Object.defineProperty(b.prototype, "props", {
                set: function() {
                    throw Error();
                }
            }), "object" === typeof Reflect && Reflect.construct) {
                try {
                    Reflect.construct(b, []);
                } catch (l) {
                    var d = l;
                }
                Reflect.construct(a, [], b);
            } else {
                try {
                    b.call();
                } catch (l) {
                    d = l;
                }
                a.call(b.prototype);
            }
        } else {
            try {
                throw Error();
            } catch (l) {
                d = l;
            }
            a();
        }
    } catch (l) {
        if (l && d && "string" === typeof l.stack) {
            for(var e = l.stack.split("\n"), f = d.stack.split("\n"), g = e.length - 1, h = f.length - 1; 1 <= g && 0 <= h && e[g] !== f[h];)h--;
            for(; 1 <= g && 0 <= h; g--, h--)if (e[g] !== f[h]) {
                if (1 !== g || 1 !== h) {
                    do if (g--, h--, 0 > h || e[g] !== f[h]) {
                        var k = "\n" + e[g].replace(" at new ", " at ");
                        a.displayName && k.includes("<anonymous>") && (k = k.replace("<anonymous>", a.displayName));
                        return k;
                    }
                    while (1 <= g && 0 <= h);
                }
                break;
            }
        }
    } finally{
        Na = !1, Error.prepareStackTrace = c;
    }
    return (a = a ? a.displayName || a.name : "") ? Ma(a) : "";
}
function Pa(a) {
    switch(a.tag){
        case 5:
            return Ma(a.type);
        case 16:
            return Ma("Lazy");
        case 13:
            return Ma("Suspense");
        case 19:
            return Ma("SuspenseList");
        case 0:
        case 2:
        case 15:
            return a = Oa(a.type, !1), a;
        case 11:
            return a = Oa(a.type.render, !1), a;
        case 1:
            return a = Oa(a.type, !0), a;
        default:
            return "";
    }
}
function Qa(a) {
    if (null == a) return null;
    if ("function" === typeof a) return a.displayName || a.name || null;
    if ("string" === typeof a) return a;
    switch(a){
        case ya:
            return "Fragment";
        case xa:
            return "Portal";
        case Aa:
            return "Profiler";
        case za:
            return "StrictMode";
        case Ea:
            return "Suspense";
        case Fa:
            return "SuspenseList";
    }
    if ("object" === typeof a) switch(a.$$typeof){
        case Ca:
            return (a.displayName || "Context") + ".Consumer";
        case Ba:
            return (a._context.displayName || "Context") + ".Provider";
        case Da:
            var b = a.render;
            a = a.displayName;
            a || (a = b.displayName || b.name || "", a = "" !== a ? "ForwardRef(" + a + ")" : "ForwardRef");
            return a;
        case Ga:
            return b = a.displayName || null, null !== b ? b : Qa(a.type) || "Memo";
        case Ha:
            b = a._payload;
            a = a._init;
            try {
                return Qa(a(b));
            } catch (c) {}
    }
    return null;
}
function Ra(a) {
    var b = a.type;
    switch(a.tag){
        case 24:
            return "Cache";
        case 9:
            return (b.displayName || "Context") + ".Consumer";
        case 10:
            return (b._context.displayName || "Context") + ".Provider";
        case 18:
            return "DehydratedFragment";
        case 11:
            return a = b.render, a = a.displayName || a.name || "", b.displayName || ("" !== a ? "ForwardRef(" + a + ")" : "ForwardRef");
        case 7:
            return "Fragment";
        case 5:
            return b;
        case 4:
            return "Portal";
        case 3:
            return "Root";
        case 6:
            return "Text";
        case 16:
            return Qa(b);
        case 8:
            return b === za ? "StrictMode" : "Mode";
        case 22:
            return "Offscreen";
        case 12:
            return "Profiler";
        case 21:
            return "Scope";
        case 13:
            return "Suspense";
        case 19:
            return "SuspenseList";
        case 25:
            return "TracingMarker";
        case 1:
        case 0:
        case 17:
        case 2:
        case 14:
        case 15:
            if ("function" === typeof b) return b.displayName || b.name || null;
            if ("string" === typeof b) return b;
    }
    return null;
}
function Sa(a) {
    switch(typeof a){
        case "boolean":
        case "number":
        case "string":
        case "undefined":
            return a;
        case "object":
            return a;
        default:
            return "";
    }
}
function Ta(a) {
    var b = a.type;
    return (a = a.nodeName) && "input" === a.toLowerCase() && ("checkbox" === b || "radio" === b);
}
function Ua(a) {
    var b = Ta(a) ? "checked" : "value", c = Object.getOwnPropertyDescriptor(a.constructor.prototype, b), d = "" + a[b];
    if (!a.hasOwnProperty(b) && "undefined" !== typeof c && "function" === typeof c.get && "function" === typeof c.set) {
        var e = c.get, f = c.set;
        Object.defineProperty(a, b, {
            configurable: !0,
            get: function() {
                return e.call(this);
            },
            set: function(a) {
                d = "" + a;
                f.call(this, a);
            }
        });
        Object.defineProperty(a, b, {
            enumerable: c.enumerable
        });
        return {
            getValue: function() {
                return d;
            },
            setValue: function(a) {
                d = "" + a;
            },
            stopTracking: function() {
                a._valueTracker = null;
                delete a[b];
            }
        };
    }
}
function Va(a) {
    a._valueTracker || (a._valueTracker = Ua(a));
}
function Wa(a) {
    if (!a) return !1;
    var b = a._valueTracker;
    if (!b) return !0;
    var c = b.getValue();
    var d = "";
    a && (d = Ta(a) ? a.checked ? "true" : "false" : a.value);
    a = d;
    return a !== c ? (b.setValue(a), !0) : !1;
}
function Xa(a) {
    a = a || ("undefined" !== typeof document ? document : void 0);
    if ("undefined" === typeof a) return null;
    try {
        return a.activeElement || a.body;
    } catch (b) {
        return a.body;
    }
}
function Ya(a, b) {
    var c = b.checked;
    return u({}, b, {
        defaultChecked: void 0,
        defaultValue: void 0,
        value: void 0,
        checked: null != c ? c : a._wrapperState.initialChecked
    });
}
function Za(a, b) {
    var c = null == b.defaultValue ? "" : b.defaultValue, d = null != b.checked ? b.checked : b.defaultChecked;
    c = Sa(null != b.value ? b.value : c);
    a._wrapperState = {
        initialChecked: d,
        initialValue: c,
        controlled: "checkbox" === b.type || "radio" === b.type ? null != b.checked : null != b.value
    };
}
function $a(a, b) {
    b = b.checked;
    null != b && ua(a, "checked", b, !1);
}
function ab(a, b) {
    $a(a, b);
    var c = Sa(b.value), d = b.type;
    if (null != c) {
        if ("number" === d) {
            if (0 === c && "" === a.value || a.value != c) a.value = "" + c;
        } else a.value !== "" + c && (a.value = "" + c);
    } else if ("submit" === d || "reset" === d) {
        a.removeAttribute("value");
        return;
    }
    b.hasOwnProperty("value") ? bb(a, b.type, c) : b.hasOwnProperty("defaultValue") && bb(a, b.type, Sa(b.defaultValue));
    null == b.checked && null != b.defaultChecked && (a.defaultChecked = !!b.defaultChecked);
}
function cb(a, b, c) {
    if (b.hasOwnProperty("value") || b.hasOwnProperty("defaultValue")) {
        var d = b.type;
        if (!("submit" !== d && "reset" !== d || void 0 !== b.value && null !== b.value)) return;
        b = "" + a._wrapperState.initialValue;
        c || b === a.value || (a.value = b);
        a.defaultValue = b;
    }
    c = a.name;
    "" !== c && (a.name = "");
    a.defaultChecked = !!a._wrapperState.initialChecked;
    "" !== c && (a.name = c);
}
function bb(a, b, c) {
    if ("number" !== b || Xa(a.ownerDocument) !== a) null == c ? a.defaultValue = "" + a._wrapperState.initialValue : a.defaultValue !== "" + c && (a.defaultValue = "" + c);
}
var db = Array.isArray;
function eb(a, b, c, d) {
    a = a.options;
    if (b) {
        b = {};
        for(var e = 0; e < c.length; e++)b["$" + c[e]] = !0;
        for(c = 0; c < a.length; c++)e = b.hasOwnProperty("$" + a[c].value), a[c].selected !== e && (a[c].selected = e), e && d && (a[c].defaultSelected = !0);
    } else {
        c = "" + Sa(c);
        b = null;
        for(e = 0; e < a.length; e++){
            if (a[e].value === c) {
                a[e].selected = !0;
                d && (a[e].defaultSelected = !0);
                return;
            }
            null !== b || a[e].disabled || (b = a[e]);
        }
        null !== b && (b.selected = !0);
    }
}
function fb(a, b) {
    if (null != b.dangerouslySetInnerHTML) throw Error(p(91));
    return u({}, b, {
        value: void 0,
        defaultValue: void 0,
        children: "" + a._wrapperState.initialValue
    });
}
function gb(a, b) {
    var c = b.value;
    if (null == c) {
        c = b.children;
        b = b.defaultValue;
        if (null != c) {
            if (null != b) throw Error(p(92));
            if (db(c)) {
                if (1 < c.length) throw Error(p(93));
                c = c[0];
            }
            b = c;
        }
        null == b && (b = "");
        c = b;
    }
    a._wrapperState = {
        initialValue: Sa(c)
    };
}
function hb(a, b) {
    var c = Sa(b.value), d = Sa(b.defaultValue);
    null != c && (c = "" + c, c !== a.value && (a.value = c), null == b.defaultValue && a.defaultValue !== c && (a.defaultValue = c));
    null != d && (a.defaultValue = "" + d);
}
function ib(a) {
    var b = a.textContent;
    b === a._wrapperState.initialValue && "" !== b && null !== b && (a.value = b);
}
function jb(a) {
    switch(a){
        case "svg":
            return "http://www.w3.org/2000/svg";
        case "math":
            return "http://www.w3.org/1998/Math/MathML";
        default:
            return "http://www.w3.org/1999/xhtml";
    }
}
function kb(a, b) {
    return null == a || "http://www.w3.org/1999/xhtml" === a ? jb(b) : "http://www.w3.org/2000/svg" === a && "foreignObject" === b ? "http://www.w3.org/1999/xhtml" : a;
}
var mb, nb = function(a) {
    return "undefined" !== typeof MSApp && MSApp.execUnsafeLocalFunction ? function(b, c, d, e) {
        MSApp.execUnsafeLocalFunction(function() {
            return a(b, c, d, e);
        });
    } : a;
}(function(a, b) {
    if ("http://www.w3.org/2000/svg" !== a.namespaceURI || "innerHTML" in a) a.innerHTML = b;
    else {
        mb = mb || document.createElement("div");
        mb.innerHTML = "<svg>" + b.valueOf().toString() + "</svg>";
        for(b = mb.firstChild; a.firstChild;)a.removeChild(a.firstChild);
        for(; b.firstChild;)a.appendChild(b.firstChild);
    }
});
function ob(a, b) {
    if (b) {
        var c = a.firstChild;
        if (c && c === a.lastChild && 3 === c.nodeType) {
            c.nodeValue = b;
            return;
        }
    }
    a.textContent = b;
}
var pb = {
    animationIterationCount: !0,
    aspectRatio: !0,
    borderImageOutset: !0,
    borderImageSlice: !0,
    borderImageWidth: !0,
    boxFlex: !0,
    boxFlexGroup: !0,
    boxOrdinalGroup: !0,
    columnCount: !0,
    columns: !0,
    flex: !0,
    flexGrow: !0,
    flexPositive: !0,
    flexShrink: !0,
    flexNegative: !0,
    flexOrder: !0,
    gridArea: !0,
    gridRow: !0,
    gridRowEnd: !0,
    gridRowSpan: !0,
    gridRowStart: !0,
    gridColumn: !0,
    gridColumnEnd: !0,
    gridColumnSpan: !0,
    gridColumnStart: !0,
    fontWeight: !0,
    lineClamp: !0,
    lineHeight: !0,
    opacity: !0,
    order: !0,
    orphans: !0,
    tabSize: !0,
    widows: !0,
    zIndex: !0,
    zoom: !0,
    fillOpacity: !0,
    floodOpacity: !0,
    stopOpacity: !0,
    strokeDasharray: !0,
    strokeDashoffset: !0,
    strokeMiterlimit: !0,
    strokeOpacity: !0,
    strokeWidth: !0
}, qb = [
    "Webkit",
    "ms",
    "Moz",
    "O"
];
Object.keys(pb).forEach(function(a) {
    qb.forEach(function(b) {
        b = b + a.charAt(0).toUpperCase() + a.substring(1);
        pb[b] = pb[a];
    });
});
function rb(a, b, c) {
    return null == b || "boolean" === typeof b || "" === b ? "" : c || "number" !== typeof b || 0 === b || pb.hasOwnProperty(a) && pb[a] ? ("" + b).trim() : b + "px";
}
function sb(a, b) {
    a = a.style;
    for(var c in b)if (b.hasOwnProperty(c)) {
        var d = 0 === c.indexOf("--"), e = rb(c, b[c], d);
        "float" === c && (c = "cssFloat");
        d ? a.setProperty(c, e) : a[c] = e;
    }
}
var tb = u({
    menuitem: !0
}, {
    area: !0,
    base: !0,
    br: !0,
    col: !0,
    embed: !0,
    hr: !0,
    img: !0,
    input: !0,
    keygen: !0,
    link: !0,
    meta: !0,
    param: !0,
    source: !0,
    track: !0,
    wbr: !0
});
function ub(a, b) {
    if (b) {
        if (tb[a] && (null != b.children || null != b.dangerouslySetInnerHTML)) throw Error(p(137, a));
        if (null != b.dangerouslySetInnerHTML) {
            if (null != b.children) throw Error(p(60));
            if ("object" !== typeof b.dangerouslySetInnerHTML || !("__html" in b.dangerouslySetInnerHTML)) throw Error(p(61));
        }
        if (null != b.style && "object" !== typeof b.style) throw Error(p(62));
    }
}
function vb(a, b) {
    if (-1 === a.indexOf("-")) return "string" === typeof b.is;
    switch(a){
        case "annotation-xml":
        case "color-profile":
        case "font-face":
        case "font-face-src":
        case "font-face-uri":
        case "font-face-format":
        case "font-face-name":
        case "missing-glyph":
            return !1;
        default:
            return !0;
    }
}
var wb = null;
function xb(a) {
    a = a.target || a.srcElement || window;
    a.correspondingUseElement && (a = a.correspondingUseElement);
    return 3 === a.nodeType ? a.parentNode : a;
}
var yb = null, zb = null, Ab = null;
function Bb(a) {
    if (a = Cb(a)) {
        if ("function" !== typeof yb) throw Error(p(280));
        var b = a.stateNode;
        b && (b = Db(b), yb(a.stateNode, a.type, b));
    }
}
function Eb(a) {
    zb ? Ab ? Ab.push(a) : Ab = [
        a
    ] : zb = a;
}
function Fb() {
    if (zb) {
        var a = zb, b = Ab;
        Ab = zb = null;
        Bb(a);
        if (b) for(a = 0; a < b.length; a++)Bb(b[a]);
    }
}
function Gb(a, b) {
    return a(b);
}
function Hb() {}
var Ib = !1;
function Jb(a, b, c) {
    if (Ib) return a(b, c);
    Ib = !0;
    try {
        return Gb(a, b, c);
    } finally{
        if (Ib = !1, null !== zb || null !== Ab) Hb(), Fb();
    }
}
function Kb(a, b) {
    var c = a.stateNode;
    if (null === c) return null;
    var d = Db(c);
    if (null === d) return null;
    c = d[b];
    a: switch(b){
        case "onClick":
        case "onClickCapture":
        case "onDoubleClick":
        case "onDoubleClickCapture":
        case "onMouseDown":
        case "onMouseDownCapture":
        case "onMouseMove":
        case "onMouseMoveCapture":
        case "onMouseUp":
        case "onMouseUpCapture":
        case "onMouseEnter":
            (d = !d.disabled) || (a = a.type, d = !("button" === a || "input" === a || "select" === a || "textarea" === a));
            a = !d;
            break a;
        default:
            a = !1;
    }
    if (a) return null;
    if (c && "function" !== typeof c) throw Error(p(231, b, typeof c));
    return c;
}
var Lb = !1;
if (ia) try {
    var Mb = {};
    Object.defineProperty(Mb, "passive", {
        get: function() {
            Lb = !0;
        }
    });
    window.addEventListener("test", Mb, Mb);
    window.removeEventListener("test", Mb, Mb);
} catch (a) {
    Lb = !1;
}
function Nb(a, b, c, d, e, f, g, h, k) {
    var l = Array.prototype.slice.call(arguments, 3);
    try {
        b.apply(c, l);
    } catch (n) {
        this.onError(n);
    }
}
var Ob = !1, Pb = null, Qb = !1, Rb = null, Sb = {
    onError: function(a) {
        Ob = !0;
        Pb = a;
    }
};
function Tb(a, b, c, d, e, f, g, h, k) {
    Ob = !1;
    Pb = null;
    Nb.apply(Sb, arguments);
}
function Ub(a, b, c, d, e, f, g, h, k) {
    Tb.apply(this, arguments);
    if (Ob) {
        if (Ob) {
            var l = Pb;
            Ob = !1;
            Pb = null;
        } else throw Error(p(198));
        Qb || (Qb = !0, Rb = l);
    }
}
function Vb(a) {
    var b = a, c = a;
    if (a.alternate) for(; b.return;)b = b.return;
    else {
        a = b;
        do b = a, 0 !== (b.flags & 4098) && (c = b.return), a = b.return;
        while (a);
    }
    return 3 === b.tag ? c : null;
}
function Wb(a) {
    if (13 === a.tag) {
        var b = a.memoizedState;
        null === b && (a = a.alternate, null !== a && (b = a.memoizedState));
        if (null !== b) return b.dehydrated;
    }
    return null;
}
function Xb(a) {
    if (Vb(a) !== a) throw Error(p(188));
}
function Yb(a) {
    var b = a.alternate;
    if (!b) {
        b = Vb(a);
        if (null === b) throw Error(p(188));
        return b !== a ? null : a;
    }
    for(var c = a, d = b;;){
        var e = c.return;
        if (null === e) break;
        var f = e.alternate;
        if (null === f) {
            d = e.return;
            if (null !== d) {
                c = d;
                continue;
            }
            break;
        }
        if (e.child === f.child) {
            for(f = e.child; f;){
                if (f === c) return Xb(e), a;
                if (f === d) return Xb(e), b;
                f = f.sibling;
            }
            throw Error(p(188));
        }
        if (c.return !== d.return) c = e, d = f;
        else {
            for(var g = !1, h = e.child; h;){
                if (h === c) {
                    g = !0;
                    c = e;
                    d = f;
                    break;
                }
                if (h === d) {
                    g = !0;
                    d = e;
                    c = f;
                    break;
                }
                h = h.sibling;
            }
            if (!g) {
                for(h = f.child; h;){
                    if (h === c) {
                        g = !0;
                        c = f;
                        d = e;
                        break;
                    }
                    if (h === d) {
                        g = !0;
                        d = f;
                        c = e;
                        break;
                    }
                    h = h.sibling;
                }
                if (!g) throw Error(p(189));
            }
        }
        if (c.alternate !== d) throw Error(p(190));
    }
    if (3 !== c.tag) throw Error(p(188));
    return c.stateNode.current === c ? a : b;
}
function Zb(a) {
    a = Yb(a);
    return null !== a ? $b(a) : null;
}
function $b(a) {
    if (5 === a.tag || 6 === a.tag) return a;
    for(a = a.child; null !== a;){
        var b = $b(a);
        if (null !== b) return b;
        a = a.sibling;
    }
    return null;
}
var ac = ba.unstable_scheduleCallback, bc = ba.unstable_cancelCallback, cc = ba.unstable_shouldYield, dc = ba.unstable_requestPaint, A = ba.unstable_now, ec = ba.unstable_getCurrentPriorityLevel, fc = ba.unstable_ImmediatePriority, gc = ba.unstable_UserBlockingPriority, hc = ba.unstable_NormalPriority, ic = ba.unstable_LowPriority, jc = ba.unstable_IdlePriority, kc = null, lc = null, B = null, mc = "undefined" !== typeof __REACT_DEVTOOLS_GLOBAL_HOOK__;
function nc(a, b) {
    if (lc && "function" === typeof lc.onCommitFiberRoot) try {
        var c = 128 === (a.current.flags & 128);
        switch(b){
            case 1:
                var d = fc;
                break;
            case 4:
                d = gc;
                break;
            case 16:
                d = hc;
                break;
            case 536870912:
                d = jc;
                break;
            default:
                d = hc;
        }
        lc.onCommitFiberRoot(kc, a, d, c);
    } catch (e) {}
}
function oc(a) {
    B = a;
}
function pc() {
    for(var a = new Map, b = 1, c = 0; 31 > c; c++){
        var d = qc(b);
        a.set(b, d);
        b *= 2;
    }
    return a;
}
function rc() {
    null !== B && "function" === typeof B.markCommitStopped && B.markCommitStopped();
}
function sc(a) {
    null !== B && "function" === typeof B.markComponentRenderStarted && B.markComponentRenderStarted(a);
}
function tc() {
    null !== B && "function" === typeof B.markComponentRenderStopped && B.markComponentRenderStopped();
}
function uc(a) {
    null !== B && "function" === typeof B.markComponentLayoutEffectUnmountStarted && B.markComponentLayoutEffectUnmountStarted(a);
}
function vc() {
    null !== B && "function" === typeof B.markComponentLayoutEffectUnmountStopped && B.markComponentLayoutEffectUnmountStopped();
}
function wc(a) {
    null !== B && "function" === typeof B.markRenderStarted && B.markRenderStarted(a);
}
function xc() {
    null !== B && "function" === typeof B.markRenderStopped && B.markRenderStopped();
}
function yc(a, b) {
    null !== B && "function" === typeof B.markStateUpdateScheduled && B.markStateUpdateScheduled(a, b);
}
var Ac = Math.clz32 ? Math.clz32 : zc, Bc = Math.log, Cc = Math.LN2;
function zc(a) {
    a >>>= 0;
    return 0 === a ? 32 : 31 - (Bc(a) / Cc | 0) | 0;
}
function qc(a) {
    if (a & 1) return "Sync";
    if (a & 2) return "InputContinuousHydration";
    if (a & 4) return "InputContinuous";
    if (a & 8) return "DefaultHydration";
    if (a & 16) return "Default";
    if (a & 32) return "TransitionHydration";
    if (a & 4194240) return "Transition";
    if (a & 130023424) return "Retry";
    if (a & 134217728) return "SelectiveHydration";
    if (a & 268435456) return "IdleHydration";
    if (a & 536870912) return "Idle";
    if (a & 1073741824) return "Offscreen";
}
var Dc = 64, Ec = 4194304;
function Fc(a) {
    switch(a & -a){
        case 1:
            return 1;
        case 2:
            return 2;
        case 4:
            return 4;
        case 8:
            return 8;
        case 16:
            return 16;
        case 32:
            return 32;
        case 64:
        case 128:
        case 256:
        case 512:
        case 1024:
        case 2048:
        case 4096:
        case 8192:
        case 16384:
        case 32768:
        case 65536:
        case 131072:
        case 262144:
        case 524288:
        case 1048576:
        case 2097152:
            return a & 4194240;
        case 4194304:
        case 8388608:
        case 16777216:
        case 33554432:
        case 67108864:
            return a & 130023424;
        case 134217728:
            return 134217728;
        case 268435456:
            return 268435456;
        case 536870912:
            return 536870912;
        case 1073741824:
            return 1073741824;
        default:
            return a;
    }
}
function Gc(a, b) {
    var c = a.pendingLanes;
    if (0 === c) return 0;
    var d = 0, e = a.suspendedLanes, f = a.pingedLanes, g = c & 268435455;
    if (0 !== g) {
        var h = g & ~e;
        0 !== h ? d = Fc(h) : (f &= g, 0 !== f && (d = Fc(f)));
    } else g = c & ~e, 0 !== g ? d = Fc(g) : 0 !== f && (d = Fc(f));
    if (0 === d) return 0;
    if (0 !== b && b !== d && 0 === (b & e) && (e = d & -d, f = b & -b, e >= f || 16 === e && 0 !== (f & 4194240))) return b;
    0 !== (d & 4) && (d |= c & 16);
    b = a.entangledLanes;
    if (0 !== b) for(a = a.entanglements, b &= d; 0 < b;)c = 31 - Ac(b), e = 1 << c, d |= a[c], b &= ~e;
    return d;
}
function Hc(a, b) {
    switch(a){
        case 1:
        case 2:
        case 4:
            return b + 250;
        case 8:
        case 16:
        case 32:
        case 64:
        case 128:
        case 256:
        case 512:
        case 1024:
        case 2048:
        case 4096:
        case 8192:
        case 16384:
        case 32768:
        case 65536:
        case 131072:
        case 262144:
        case 524288:
        case 1048576:
        case 2097152:
            return b + 5E3;
        case 4194304:
        case 8388608:
        case 16777216:
        case 33554432:
        case 67108864:
            return -1;
        case 134217728:
        case 268435456:
        case 536870912:
        case 1073741824:
            return -1;
        default:
            return -1;
    }
}
function Ic(a, b) {
    for(var c = a.suspendedLanes, d = a.pingedLanes, e = a.expirationTimes, f = a.pendingLanes; 0 < f;){
        var g = 31 - Ac(f), h = 1 << g, k = e[g];
        if (-1 === k) {
            if (0 === (h & c) || 0 !== (h & d)) e[g] = Hc(h, b);
        } else k <= b && (a.expiredLanes |= h);
        f &= ~h;
    }
}
function Jc(a) {
    a = a.pendingLanes & -1073741825;
    return 0 !== a ? a : a & 1073741824 ? 1073741824 : 0;
}
function Kc() {
    var a = Dc;
    Dc <<= 1;
    0 === (Dc & 4194240) && (Dc = 64);
    return a;
}
function Lc(a) {
    for(var b = [], c = 0; 31 > c; c++)b.push(a);
    return b;
}
function Mc(a, b, c) {
    a.pendingLanes |= b;
    536870912 !== b && (a.suspendedLanes = 0, a.pingedLanes = 0);
    a = a.eventTimes;
    b = 31 - Ac(b);
    a[b] = c;
}
function Nc(a, b) {
    var c = a.pendingLanes & ~b;
    a.pendingLanes = b;
    a.suspendedLanes = 0;
    a.pingedLanes = 0;
    a.expiredLanes &= b;
    a.mutableReadLanes &= b;
    a.entangledLanes &= b;
    b = a.entanglements;
    var d = a.eventTimes;
    for(a = a.expirationTimes; 0 < c;){
        var e = 31 - Ac(c), f = 1 << e;
        b[e] = 0;
        d[e] = -1;
        a[e] = -1;
        c &= ~f;
    }
}
function Oc(a, b) {
    var c = a.entangledLanes |= b;
    for(a = a.entanglements; c;){
        var d = 31 - Ac(c), e = 1 << d;
        e & b | a[d] & b && (a[d] |= b);
        c &= ~e;
    }
}
function Pc(a, b, c) {
    if (mc) for(a = a.pendingUpdatersLaneMap; 0 < c;){
        var d = 31 - Ac(c), e = 1 << d;
        a[d].add(b);
        c &= ~e;
    }
}
function Qc(a, b) {
    if (mc) for(var c = a.pendingUpdatersLaneMap, d = a.memoizedUpdaters; 0 < b;){
        var e = 31 - Ac(b);
        a = 1 << e;
        e = c[e];
        0 < e.size && (e.forEach(function(a) {
            var b = a.alternate;
            null !== b && d.has(b) || d.add(a);
        }), e.clear());
        b &= ~a;
    }
}
var E = 0;
function Rc(a) {
    a &= -a;
    return 1 < a ? 4 < a ? 0 !== (a & 268435455) ? 16 : 536870912 : 4 : 1;
}
var Sc, Tc, Uc, Vc, Wc, Xc = !1, Yc = [], Zc = null, $c = null, ad = null, bd = new Map, cd = new Map, dd = [], ed = "mousedown mouseup touchcancel touchend touchstart auxclick dblclick pointercancel pointerdown pointerup dragend dragstart drop compositionend compositionstart keydown keypress keyup input textInput copy cut paste click change contextmenu reset submit".split(" ");
function fd(a, b) {
    switch(a){
        case "focusin":
        case "focusout":
            Zc = null;
            break;
        case "dragenter":
        case "dragleave":
            $c = null;
            break;
        case "mouseover":
        case "mouseout":
            ad = null;
            break;
        case "pointerover":
        case "pointerout":
            bd.delete(b.pointerId);
            break;
        case "gotpointercapture":
        case "lostpointercapture":
            cd.delete(b.pointerId);
    }
}
function gd(a, b, c, d, e, f) {
    if (null === a || a.nativeEvent !== f) return a = {
        blockedOn: b,
        domEventName: c,
        eventSystemFlags: d,
        nativeEvent: f,
        targetContainers: [
            e
        ]
    }, null !== b && (b = Cb(b), null !== b && Tc(b)), a;
    a.eventSystemFlags |= d;
    b = a.targetContainers;
    null !== e && -1 === b.indexOf(e) && b.push(e);
    return a;
}
function hd(a, b, c, d, e) {
    switch(b){
        case "focusin":
            return Zc = gd(Zc, a, b, c, d, e), !0;
        case "dragenter":
            return $c = gd($c, a, b, c, d, e), !0;
        case "mouseover":
            return ad = gd(ad, a, b, c, d, e), !0;
        case "pointerover":
            var f = e.pointerId;
            bd.set(f, gd(bd.get(f) || null, a, b, c, d, e));
            return !0;
        case "gotpointercapture":
            return f = e.pointerId, cd.set(f, gd(cd.get(f) || null, a, b, c, d, e)), !0;
    }
    return !1;
}
function id(a) {
    var b = jd(a.target);
    if (null !== b) {
        var c = Vb(b);
        if (null !== c) {
            if (b = c.tag, 13 === b) {
                if (b = Wb(c), null !== b) {
                    a.blockedOn = b;
                    Wc(a.priority, function() {
                        Uc(c);
                    });
                    return;
                }
            } else if (3 === b && c.stateNode.current.memoizedState.isDehydrated) {
                a.blockedOn = 3 === c.tag ? c.stateNode.containerInfo : null;
                return;
            }
        }
    }
    a.blockedOn = null;
}
function kd(a) {
    if (null !== a.blockedOn) return !1;
    for(var b = a.targetContainers; 0 < b.length;){
        var c = ld(a.domEventName, a.eventSystemFlags, b[0], a.nativeEvent);
        if (null === c) {
            c = a.nativeEvent;
            var d = new c.constructor(c.type, c);
            wb = d;
            c.target.dispatchEvent(d);
            wb = null;
        } else return b = Cb(c), null !== b && Tc(b), a.blockedOn = c, !1;
        b.shift();
    }
    return !0;
}
function md(a, b, c) {
    kd(a) && c.delete(b);
}
function nd() {
    Xc = !1;
    null !== Zc && kd(Zc) && (Zc = null);
    null !== $c && kd($c) && ($c = null);
    null !== ad && kd(ad) && (ad = null);
    bd.forEach(md);
    cd.forEach(md);
}
function od(a, b) {
    a.blockedOn === b && (a.blockedOn = null, Xc || (Xc = !0, ba.unstable_scheduleCallback(ba.unstable_NormalPriority, nd)));
}
function pd(a) {
    function b(b) {
        return od(b, a);
    }
    if (0 < Yc.length) {
        od(Yc[0], a);
        for(var c = 1; c < Yc.length; c++){
            var d = Yc[c];
            d.blockedOn === a && (d.blockedOn = null);
        }
    }
    null !== Zc && od(Zc, a);
    null !== $c && od($c, a);
    null !== ad && od(ad, a);
    bd.forEach(b);
    cd.forEach(b);
    for(c = 0; c < dd.length; c++)d = dd[c], d.blockedOn === a && (d.blockedOn = null);
    for(; 0 < dd.length && (c = dd[0], null === c.blockedOn);)id(c), null === c.blockedOn && dd.shift();
}
var qd = va.ReactCurrentBatchConfig, rd = !0;
function sd(a, b, c, d) {
    var e = E, f = qd.transition;
    qd.transition = null;
    try {
        E = 1, td(a, b, c, d);
    } finally{
        E = e, qd.transition = f;
    }
}
function ud(a, b, c, d) {
    var e = E, f = qd.transition;
    qd.transition = null;
    try {
        E = 4, td(a, b, c, d);
    } finally{
        E = e, qd.transition = f;
    }
}
function td(a, b, c, d) {
    if (rd) {
        var e = ld(a, b, c, d);
        if (null === e) vd(a, b, d, wd, c), fd(a, d);
        else if (hd(e, a, b, c, d)) d.stopPropagation();
        else if (fd(a, d), b & 4 && -1 < ed.indexOf(a)) {
            for(; null !== e;){
                var f = Cb(e);
                null !== f && Sc(f);
                f = ld(a, b, c, d);
                null === f && vd(a, b, d, wd, c);
                if (f === e) break;
                e = f;
            }
            null !== e && d.stopPropagation();
        } else vd(a, b, d, null, c);
    }
}
var wd = null;
function ld(a, b, c, d) {
    wd = null;
    a = xb(d);
    a = jd(a);
    if (null !== a) {
        if (b = Vb(a), null === b) a = null;
        else if (c = b.tag, 13 === c) {
            a = Wb(b);
            if (null !== a) return a;
            a = null;
        } else if (3 === c) {
            if (b.stateNode.current.memoizedState.isDehydrated) return 3 === b.tag ? b.stateNode.containerInfo : null;
            a = null;
        } else b !== a && (a = null);
    }
    wd = a;
    return null;
}
function xd(a) {
    switch(a){
        case "cancel":
        case "click":
        case "close":
        case "contextmenu":
        case "copy":
        case "cut":
        case "auxclick":
        case "dblclick":
        case "dragend":
        case "dragstart":
        case "drop":
        case "focusin":
        case "focusout":
        case "input":
        case "invalid":
        case "keydown":
        case "keypress":
        case "keyup":
        case "mousedown":
        case "mouseup":
        case "paste":
        case "pause":
        case "play":
        case "pointercancel":
        case "pointerdown":
        case "pointerup":
        case "ratechange":
        case "reset":
        case "resize":
        case "seeked":
        case "submit":
        case "touchcancel":
        case "touchend":
        case "touchstart":
        case "volumechange":
        case "change":
        case "selectionchange":
        case "textInput":
        case "compositionstart":
        case "compositionend":
        case "compositionupdate":
        case "beforeblur":
        case "afterblur":
        case "beforeinput":
        case "blur":
        case "fullscreenchange":
        case "focus":
        case "hashchange":
        case "popstate":
        case "select":
        case "selectstart":
            return 1;
        case "drag":
        case "dragenter":
        case "dragexit":
        case "dragleave":
        case "dragover":
        case "mousemove":
        case "mouseout":
        case "mouseover":
        case "pointermove":
        case "pointerout":
        case "pointerover":
        case "scroll":
        case "toggle":
        case "touchmove":
        case "wheel":
        case "mouseenter":
        case "mouseleave":
        case "pointerenter":
        case "pointerleave":
            return 4;
        case "message":
            switch(ec()){
                case fc:
                    return 1;
                case gc:
                    return 4;
                case hc:
                case ic:
                    return 16;
                case jc:
                    return 536870912;
                default:
                    return 16;
            }
        default:
            return 16;
    }
}
var yd = null, zd = null, Ad = null;
function Bd() {
    if (Ad) return Ad;
    var a, b = zd, c = b.length, d, e = "value" in yd ? yd.value : yd.textContent, f = e.length;
    for(a = 0; a < c && b[a] === e[a]; a++);
    var g = c - a;
    for(d = 1; d <= g && b[c - d] === e[f - d]; d++);
    return Ad = e.slice(a, 1 < d ? 1 - d : void 0);
}
function Cd(a) {
    var b = a.keyCode;
    "charCode" in a ? (a = a.charCode, 0 === a && 13 === b && (a = 13)) : a = b;
    10 === a && (a = 13);
    return 32 <= a || 13 === a ? a : 0;
}
function Dd() {
    return !0;
}
function Ed() {
    return !1;
}
function Fd(a) {
    function b(b, d, e, f, g) {
        this._reactName = b;
        this._targetInst = e;
        this.type = d;
        this.nativeEvent = f;
        this.target = g;
        this.currentTarget = null;
        for(var c in a)a.hasOwnProperty(c) && (b = a[c], this[c] = b ? b(f) : f[c]);
        this.isDefaultPrevented = (null != f.defaultPrevented ? f.defaultPrevented : !1 === f.returnValue) ? Dd : Ed;
        this.isPropagationStopped = Ed;
        return this;
    }
    u(b.prototype, {
        preventDefault: function() {
            this.defaultPrevented = !0;
            var a = this.nativeEvent;
            a && (a.preventDefault ? a.preventDefault() : "unknown" !== typeof a.returnValue && (a.returnValue = !1), this.isDefaultPrevented = Dd);
        },
        stopPropagation: function() {
            var a = this.nativeEvent;
            a && (a.stopPropagation ? a.stopPropagation() : "unknown" !== typeof a.cancelBubble && (a.cancelBubble = !0), this.isPropagationStopped = Dd);
        },
        persist: function() {},
        isPersistent: Dd
    });
    return b;
}
var Gd = {
    eventPhase: 0,
    bubbles: 0,
    cancelable: 0,
    timeStamp: function(a) {
        return a.timeStamp || Date.now();
    },
    defaultPrevented: 0,
    isTrusted: 0
}, Hd = Fd(Gd), Id = u({}, Gd, {
    view: 0,
    detail: 0
}), Jd = Fd(Id), Kd, Ld, Md, Od = u({}, Id, {
    screenX: 0,
    screenY: 0,
    clientX: 0,
    clientY: 0,
    pageX: 0,
    pageY: 0,
    ctrlKey: 0,
    shiftKey: 0,
    altKey: 0,
    metaKey: 0,
    getModifierState: Nd,
    button: 0,
    buttons: 0,
    relatedTarget: function(a) {
        return void 0 === a.relatedTarget ? a.fromElement === a.srcElement ? a.toElement : a.fromElement : a.relatedTarget;
    },
    movementX: function(a) {
        if ("movementX" in a) return a.movementX;
        a !== Md && (Md && "mousemove" === a.type ? (Kd = a.screenX - Md.screenX, Ld = a.screenY - Md.screenY) : Ld = Kd = 0, Md = a);
        return Kd;
    },
    movementY: function(a) {
        return "movementY" in a ? a.movementY : Ld;
    }
}), Pd = Fd(Od), Qd = u({}, Od, {
    dataTransfer: 0
}), Rd = Fd(Qd), Sd = u({}, Id, {
    relatedTarget: 0
}), Td = Fd(Sd), Ud = u({}, Gd, {
    animationName: 0,
    elapsedTime: 0,
    pseudoElement: 0
}), Vd = Fd(Ud), Wd = u({}, Gd, {
    clipboardData: function(a) {
        return "clipboardData" in a ? a.clipboardData : window.clipboardData;
    }
}), Xd = Fd(Wd), Yd = u({}, Gd, {
    data: 0
}), Zd = Fd(Yd), $d = {
    Esc: "Escape",
    Spacebar: " ",
    Left: "ArrowLeft",
    Up: "ArrowUp",
    Right: "ArrowRight",
    Down: "ArrowDown",
    Del: "Delete",
    Win: "OS",
    Menu: "ContextMenu",
    Apps: "ContextMenu",
    Scroll: "ScrollLock",
    MozPrintableKey: "Unidentified"
}, ae = {
    8: "Backspace",
    9: "Tab",
    12: "Clear",
    13: "Enter",
    16: "Shift",
    17: "Control",
    18: "Alt",
    19: "Pause",
    20: "CapsLock",
    27: "Escape",
    32: " ",
    33: "PageUp",
    34: "PageDown",
    35: "End",
    36: "Home",
    37: "ArrowLeft",
    38: "ArrowUp",
    39: "ArrowRight",
    40: "ArrowDown",
    45: "Insert",
    46: "Delete",
    112: "F1",
    113: "F2",
    114: "F3",
    115: "F4",
    116: "F5",
    117: "F6",
    118: "F7",
    119: "F8",
    120: "F9",
    121: "F10",
    122: "F11",
    123: "F12",
    144: "NumLock",
    145: "ScrollLock",
    224: "Meta"
}, be = {
    Alt: "altKey",
    Control: "ctrlKey",
    Meta: "metaKey",
    Shift: "shiftKey"
};
function ce(a) {
    var b = this.nativeEvent;
    return b.getModifierState ? b.getModifierState(a) : (a = be[a]) ? !!b[a] : !1;
}
function Nd() {
    return ce;
}
var de = u({}, Id, {
    key: function(a) {
        if (a.key) {
            var b = $d[a.key] || a.key;
            if ("Unidentified" !== b) return b;
        }
        return "keypress" === a.type ? (a = Cd(a), 13 === a ? "Enter" : String.fromCharCode(a)) : "keydown" === a.type || "keyup" === a.type ? ae[a.keyCode] || "Unidentified" : "";
    },
    code: 0,
    location: 0,
    ctrlKey: 0,
    shiftKey: 0,
    altKey: 0,
    metaKey: 0,
    repeat: 0,
    locale: 0,
    getModifierState: Nd,
    charCode: function(a) {
        return "keypress" === a.type ? Cd(a) : 0;
    },
    keyCode: function(a) {
        return "keydown" === a.type || "keyup" === a.type ? a.keyCode : 0;
    },
    which: function(a) {
        return "keypress" === a.type ? Cd(a) : "keydown" === a.type || "keyup" === a.type ? a.keyCode : 0;
    }
}), ee = Fd(de), fe = u({}, Od, {
    pointerId: 0,
    width: 0,
    height: 0,
    pressure: 0,
    tangentialPressure: 0,
    tiltX: 0,
    tiltY: 0,
    twist: 0,
    pointerType: 0,
    isPrimary: 0
}), ge = Fd(fe), he = u({}, Id, {
    touches: 0,
    targetTouches: 0,
    changedTouches: 0,
    altKey: 0,
    metaKey: 0,
    ctrlKey: 0,
    shiftKey: 0,
    getModifierState: Nd
}), ie = Fd(he), je = u({}, Gd, {
    propertyName: 0,
    elapsedTime: 0,
    pseudoElement: 0
}), ke = Fd(je), le = u({}, Od, {
    deltaX: function(a) {
        return "deltaX" in a ? a.deltaX : "wheelDeltaX" in a ? -a.wheelDeltaX : 0;
    },
    deltaY: function(a) {
        return "deltaY" in a ? a.deltaY : "wheelDeltaY" in a ? -a.wheelDeltaY : "wheelDelta" in a ? -a.wheelDelta : 0;
    },
    deltaZ: 0,
    deltaMode: 0
}), me = Fd(le), ne = [
    9,
    13,
    27,
    32
], oe = ia && "CompositionEvent" in window, pe = null;
ia && "documentMode" in document && (pe = document.documentMode);
var qe = ia && "TextEvent" in window && !pe, re = ia && (!oe || pe && 8 < pe && 11 >= pe), se = String.fromCharCode(32), te = !1;
function ue(a, b) {
    switch(a){
        case "keyup":
            return -1 !== ne.indexOf(b.keyCode);
        case "keydown":
            return 229 !== b.keyCode;
        case "keypress":
        case "mousedown":
        case "focusout":
            return !0;
        default:
            return !1;
    }
}
function ve(a) {
    a = a.detail;
    return "object" === typeof a && "data" in a ? a.data : null;
}
var we = !1;
function xe(a, b) {
    switch(a){
        case "compositionend":
            return ve(b);
        case "keypress":
            if (32 !== b.which) return null;
            te = !0;
            return se;
        case "textInput":
            return a = b.data, a === se && te ? null : a;
        default:
            return null;
    }
}
function ye(a, b) {
    if (we) return "compositionend" === a || !oe && ue(a, b) ? (a = Bd(), Ad = zd = yd = null, we = !1, a) : null;
    switch(a){
        case "paste":
            return null;
        case "keypress":
            if (!(b.ctrlKey || b.altKey || b.metaKey) || b.ctrlKey && b.altKey) {
                if (b.char && 1 < b.char.length) return b.char;
                if (b.which) return String.fromCharCode(b.which);
            }
            return null;
        case "compositionend":
            return re && "ko" !== b.locale ? null : b.data;
        default:
            return null;
    }
}
var ze = {
    color: !0,
    date: !0,
    datetime: !0,
    "datetime-local": !0,
    email: !0,
    month: !0,
    number: !0,
    password: !0,
    range: !0,
    search: !0,
    tel: !0,
    text: !0,
    time: !0,
    url: !0,
    week: !0
};
function Ae(a) {
    var b = a && a.nodeName && a.nodeName.toLowerCase();
    return "input" === b ? !!ze[a.type] : "textarea" === b ? !0 : !1;
}
function Be(a, b, c, d) {
    Eb(d);
    b = Ce(b, "onChange");
    0 < b.length && (c = new Hd("onChange", "change", null, c, d), a.push({
        event: c,
        listeners: b
    }));
}
var De = null, Ee = null;
function Fe(a) {
    Ge(a, 0);
}
function He(a) {
    var b = Ie(a);
    if (Wa(b)) return a;
}
function Je(a, b) {
    if ("change" === a) return b;
}
var Ke = !1;
if (ia) {
    var Le;
    if (ia) {
        var Me = "oninput" in document;
        if (!Me) {
            var Ne = document.createElement("div");
            Ne.setAttribute("oninput", "return;");
            Me = "function" === typeof Ne.oninput;
        }
        Le = Me;
    } else Le = !1;
    Ke = Le && (!document.documentMode || 9 < document.documentMode);
}
function Oe() {
    De && (De.detachEvent("onpropertychange", Pe), Ee = De = null);
}
function Pe(a) {
    if ("value" === a.propertyName && He(Ee)) {
        var b = [];
        Be(b, Ee, a, xb(a));
        Jb(Fe, b);
    }
}
function Qe(a, b, c) {
    "focusin" === a ? (Oe(), De = b, Ee = c, De.attachEvent("onpropertychange", Pe)) : "focusout" === a && Oe();
}
function Re(a) {
    if ("selectionchange" === a || "keyup" === a || "keydown" === a) return He(Ee);
}
function Se(a, b) {
    if ("click" === a) return He(b);
}
function Te(a, b) {
    if ("input" === a || "change" === a) return He(b);
}
function Ue(a, b) {
    return a === b && (0 !== a || 1 / a === 1 / b) || a !== a && b !== b;
}
var Ve = "function" === typeof Object.is ? Object.is : Ue;
function We(a, b) {
    if (Ve(a, b)) return !0;
    if ("object" !== typeof a || null === a || "object" !== typeof b || null === b) return !1;
    var c = Object.keys(a), d = Object.keys(b);
    if (c.length !== d.length) return !1;
    for(d = 0; d < c.length; d++){
        var e = c[d];
        if (!ja.call(b, e) || !Ve(a[e], b[e])) return !1;
    }
    return !0;
}
function Xe(a) {
    for(; a && a.firstChild;)a = a.firstChild;
    return a;
}
function Ye(a, b) {
    var c = Xe(a);
    a = 0;
    for(var d; c;){
        if (3 === c.nodeType) {
            d = a + c.textContent.length;
            if (a <= b && d >= b) return {
                node: c,
                offset: b - a
            };
            a = d;
        }
        a: {
            for(; c;){
                if (c.nextSibling) {
                    c = c.nextSibling;
                    break a;
                }
                c = c.parentNode;
            }
            c = void 0;
        }
        c = Xe(c);
    }
}
function Ze(a, b) {
    return a && b ? a === b ? !0 : a && 3 === a.nodeType ? !1 : b && 3 === b.nodeType ? Ze(a, b.parentNode) : "contains" in a ? a.contains(b) : a.compareDocumentPosition ? !!(a.compareDocumentPosition(b) & 16) : !1 : !1;
}
function $e() {
    for(var a = window, b = Xa(); b instanceof a.HTMLIFrameElement;){
        try {
            var c = "string" === typeof b.contentWindow.location.href;
        } catch (d) {
            c = !1;
        }
        if (c) a = b.contentWindow;
        else break;
        b = Xa(a.document);
    }
    return b;
}
function af(a) {
    var b = a && a.nodeName && a.nodeName.toLowerCase();
    return b && ("input" === b && ("text" === a.type || "search" === a.type || "tel" === a.type || "url" === a.type || "password" === a.type) || "textarea" === b || "true" === a.contentEditable);
}
function bf(a) {
    var b = $e(), c = a.focusedElem, d = a.selectionRange;
    if (b !== c && c && c.ownerDocument && Ze(c.ownerDocument.documentElement, c)) {
        if (null !== d && af(c)) {
            if (b = d.start, a = d.end, void 0 === a && (a = b), "selectionStart" in c) c.selectionStart = b, c.selectionEnd = Math.min(a, c.value.length);
            else if (a = (b = c.ownerDocument || document) && b.defaultView || window, a.getSelection) {
                a = a.getSelection();
                var e = c.textContent.length, f = Math.min(d.start, e);
                d = void 0 === d.end ? f : Math.min(d.end, e);
                !a.extend && f > d && (e = d, d = f, f = e);
                e = Ye(c, f);
                var g = Ye(c, d);
                e && g && (1 !== a.rangeCount || a.anchorNode !== e.node || a.anchorOffset !== e.offset || a.focusNode !== g.node || a.focusOffset !== g.offset) && (b = b.createRange(), b.setStart(e.node, e.offset), a.removeAllRanges(), f > d ? (a.addRange(b), a.extend(g.node, g.offset)) : (b.setEnd(g.node, g.offset), a.addRange(b)));
            }
        }
        b = [];
        for(a = c; a = a.parentNode;)1 === a.nodeType && b.push({
            element: a,
            left: a.scrollLeft,
            top: a.scrollTop
        });
        "function" === typeof c.focus && c.focus();
        for(c = 0; c < b.length; c++)a = b[c], a.element.scrollLeft = a.left, a.element.scrollTop = a.top;
    }
}
var cf = ia && "documentMode" in document && 11 >= document.documentMode, df = null, ef = null, ff = null, gf = !1;
function hf(a, b, c) {
    var d = c.window === c ? c.document : 9 === c.nodeType ? c : c.ownerDocument;
    gf || null == df || df !== Xa(d) || (d = df, "selectionStart" in d && af(d) ? d = {
        start: d.selectionStart,
        end: d.selectionEnd
    } : (d = (d.ownerDocument && d.ownerDocument.defaultView || window).getSelection(), d = {
        anchorNode: d.anchorNode,
        anchorOffset: d.anchorOffset,
        focusNode: d.focusNode,
        focusOffset: d.focusOffset
    }), ff && We(ff, d) || (ff = d, d = Ce(ef, "onSelect"), 0 < d.length && (b = new Hd("onSelect", "select", null, b, c), a.push({
        event: b,
        listeners: d
    }), b.target = df)));
}
function jf(a, b) {
    var c = {};
    c[a.toLowerCase()] = b.toLowerCase();
    c["Webkit" + a] = "webkit" + b;
    c["Moz" + a] = "moz" + b;
    return c;
}
var kf = {
    animationend: jf("Animation", "AnimationEnd"),
    animationiteration: jf("Animation", "AnimationIteration"),
    animationstart: jf("Animation", "AnimationStart"),
    transitionend: jf("Transition", "TransitionEnd")
}, lf = {}, mf = {};
ia && (mf = document.createElement("div").style, "AnimationEvent" in window || (delete kf.animationend.animation, delete kf.animationiteration.animation, delete kf.animationstart.animation), "TransitionEvent" in window || delete kf.transitionend.transition);
function nf(a) {
    if (lf[a]) return lf[a];
    if (!kf[a]) return a;
    var b = kf[a], c;
    for(c in b)if (b.hasOwnProperty(c) && c in mf) return lf[a] = b[c];
    return a;
}
var of = nf("animationend"), pf = nf("animationiteration"), qf = nf("animationstart"), rf = nf("transitionend"), sf = new Map, tf = "abort auxClick cancel canPlay canPlayThrough click close contextMenu copy cut drag dragEnd dragEnter dragExit dragLeave dragOver dragStart drop durationChange emptied encrypted ended error gotPointerCapture input invalid keyDown keyPress keyUp load loadedData loadedMetadata loadStart lostPointerCapture mouseDown mouseMove mouseOut mouseOver mouseUp paste pause play playing pointerCancel pointerDown pointerMove pointerOut pointerOver pointerUp progress rateChange reset resize seeked seeking stalled submit suspend timeUpdate touchCancel touchEnd touchStart volumeChange scroll toggle touchMove waiting wheel".split(" ");
function uf(a, b) {
    sf.set(a, b);
    fa(b, [
        a
    ]);
}
for(var vf = 0; vf < tf.length; vf++){
    var wf = tf[vf], xf = wf.toLowerCase(), yf = wf[0].toUpperCase() + wf.slice(1);
    uf(xf, "on" + yf);
}
uf(of, "onAnimationEnd");
uf(pf, "onAnimationIteration");
uf(qf, "onAnimationStart");
uf("dblclick", "onDoubleClick");
uf("focusin", "onFocus");
uf("focusout", "onBlur");
uf(rf, "onTransitionEnd");
ha("onMouseEnter", [
    "mouseout",
    "mouseover"
]);
ha("onMouseLeave", [
    "mouseout",
    "mouseover"
]);
ha("onPointerEnter", [
    "pointerout",
    "pointerover"
]);
ha("onPointerLeave", [
    "pointerout",
    "pointerover"
]);
fa("onChange", "change click focusin focusout input keydown keyup selectionchange".split(" "));
fa("onSelect", "focusout contextmenu dragend focusin keydown keyup mousedown mouseup selectionchange".split(" "));
fa("onBeforeInput", [
    "compositionend",
    "keypress",
    "textInput",
    "paste"
]);
fa("onCompositionEnd", "compositionend focusout keydown keypress keyup mousedown".split(" "));
fa("onCompositionStart", "compositionstart focusout keydown keypress keyup mousedown".split(" "));
fa("onCompositionUpdate", "compositionupdate focusout keydown keypress keyup mousedown".split(" "));
var zf = "abort canplay canplaythrough durationchange emptied encrypted ended error loadeddata loadedmetadata loadstart pause play playing progress ratechange resize seeked seeking stalled suspend timeupdate volumechange waiting".split(" "), Af = new Set("cancel close invalid load scroll toggle".split(" ").concat(zf));
function Bf(a, b, c) {
    var d = a.type || "unknown-event";
    a.currentTarget = c;
    Ub(d, b, void 0, a);
    a.currentTarget = null;
}
function Ge(a, b) {
    b = 0 !== (b & 4);
    for(var c = 0; c < a.length; c++){
        var d = a[c], e = d.event;
        d = d.listeners;
        a: {
            var f = void 0;
            if (b) for(var g = d.length - 1; 0 <= g; g--){
                var h = d[g], k = h.instance, l = h.currentTarget;
                h = h.listener;
                if (k !== f && e.isPropagationStopped()) break a;
                Bf(e, h, l);
                f = k;
            }
            else for(g = 0; g < d.length; g++){
                h = d[g];
                k = h.instance;
                l = h.currentTarget;
                h = h.listener;
                if (k !== f && e.isPropagationStopped()) break a;
                Bf(e, h, l);
                f = k;
            }
        }
    }
    if (Qb) throw a = Rb, Qb = !1, Rb = null, a;
}
function F(a, b) {
    var c = b[Cf];
    void 0 === c && (c = b[Cf] = new Set);
    var d = a + "__bubble";
    c.has(d) || (Df(b, a, 2, !1), c.add(d));
}
function Ef(a, b, c) {
    var d = 0;
    b && (d |= 4);
    Df(c, a, d, b);
}
var Ff = "_reactListening" + Math.random().toString(36).slice(2);
function Gf(a) {
    if (!a[Ff]) {
        a[Ff] = !0;
        da.forEach(function(b) {
            "selectionchange" !== b && (Af.has(b) || Ef(b, !1, a), Ef(b, !0, a));
        });
        var b = 9 === a.nodeType ? a : a.ownerDocument;
        null === b || b[Ff] || (b[Ff] = !0, Ef("selectionchange", !1, b));
    }
}
function Df(a, b, c, d) {
    switch(xd(b)){
        case 1:
            var e = sd;
            break;
        case 4:
            e = ud;
            break;
        default:
            e = td;
    }
    c = e.bind(null, b, c, a);
    e = void 0;
    !Lb || "touchstart" !== b && "touchmove" !== b && "wheel" !== b || (e = !0);
    d ? void 0 !== e ? a.addEventListener(b, c, {
        capture: !0,
        passive: e
    }) : a.addEventListener(b, c, !0) : void 0 !== e ? a.addEventListener(b, c, {
        passive: e
    }) : a.addEventListener(b, c, !1);
}
function vd(a, b, c, d, e) {
    var f = d;
    if (0 === (b & 1) && 0 === (b & 2) && null !== d) a: for(;;){
        if (null === d) return;
        var g = d.tag;
        if (3 === g || 4 === g) {
            var h = d.stateNode.containerInfo;
            if (h === e || 8 === h.nodeType && h.parentNode === e) break;
            if (4 === g) for(g = d.return; null !== g;){
                var k = g.tag;
                if (3 === k || 4 === k) {
                    if (k = g.stateNode.containerInfo, k === e || 8 === k.nodeType && k.parentNode === e) return;
                }
                g = g.return;
            }
            for(; null !== h;){
                g = jd(h);
                if (null === g) return;
                k = g.tag;
                if (5 === k || 6 === k) {
                    d = f = g;
                    continue a;
                }
                h = h.parentNode;
            }
        }
        d = d.return;
    }
    Jb(function() {
        var d = f, e = xb(c), g = [];
        a: {
            var h = sf.get(a);
            if (void 0 !== h) {
                var k = Hd, m = a;
                switch(a){
                    case "keypress":
                        if (0 === Cd(c)) break a;
                    case "keydown":
                    case "keyup":
                        k = ee;
                        break;
                    case "focusin":
                        m = "focus";
                        k = Td;
                        break;
                    case "focusout":
                        m = "blur";
                        k = Td;
                        break;
                    case "beforeblur":
                    case "afterblur":
                        k = Td;
                        break;
                    case "click":
                        if (2 === c.button) break a;
                    case "auxclick":
                    case "dblclick":
                    case "mousedown":
                    case "mousemove":
                    case "mouseup":
                    case "mouseout":
                    case "mouseover":
                    case "contextmenu":
                        k = Pd;
                        break;
                    case "drag":
                    case "dragend":
                    case "dragenter":
                    case "dragexit":
                    case "dragleave":
                    case "dragover":
                    case "dragstart":
                    case "drop":
                        k = Rd;
                        break;
                    case "touchcancel":
                    case "touchend":
                    case "touchmove":
                    case "touchstart":
                        k = ie;
                        break;
                    case of:
                    case pf:
                    case qf:
                        k = Vd;
                        break;
                    case rf:
                        k = ke;
                        break;
                    case "scroll":
                        k = Jd;
                        break;
                    case "wheel":
                        k = me;
                        break;
                    case "copy":
                    case "cut":
                    case "paste":
                        k = Xd;
                        break;
                    case "gotpointercapture":
                    case "lostpointercapture":
                    case "pointercancel":
                    case "pointerdown":
                    case "pointermove":
                    case "pointerout":
                    case "pointerover":
                    case "pointerup":
                        k = ge;
                }
                var w = 0 !== (b & 4), C = !w && "scroll" === a, x = w ? null !== h ? h + "Capture" : null : h;
                w = [];
                for(var y = d, v; null !== y;){
                    v = y;
                    var D = v.stateNode;
                    5 === v.tag && null !== D && (v = D, null !== x && (D = Kb(y, x), null != D && w.push(Hf(y, D, v))));
                    if (C) break;
                    y = y.return;
                }
                0 < w.length && (h = new k(h, m, null, c, e), g.push({
                    event: h,
                    listeners: w
                }));
            }
        }
        if (0 === (b & 7)) {
            a: {
                h = "mouseover" === a || "pointerover" === a;
                k = "mouseout" === a || "pointerout" === a;
                if (h && c !== wb && (m = c.relatedTarget || c.fromElement) && (jd(m) || m[If])) break a;
                if (k || h) {
                    h = e.window === e ? e : (h = e.ownerDocument) ? h.defaultView || h.parentWindow : window;
                    if (k) {
                        if (m = c.relatedTarget || c.toElement, k = d, m = m ? jd(m) : null, null !== m && (C = Vb(m), m !== C || 5 !== m.tag && 6 !== m.tag)) m = null;
                    } else k = null, m = d;
                    if (k !== m) {
                        w = Pd;
                        D = "onMouseLeave";
                        x = "onMouseEnter";
                        y = "mouse";
                        if ("pointerout" === a || "pointerover" === a) w = ge, D = "onPointerLeave", x = "onPointerEnter", y = "pointer";
                        C = null == k ? h : Ie(k);
                        v = null == m ? h : Ie(m);
                        h = new w(D, y + "leave", k, c, e);
                        h.target = C;
                        h.relatedTarget = v;
                        D = null;
                        jd(e) === d && (w = new w(x, y + "enter", m, c, e), w.target = v, w.relatedTarget = C, D = w);
                        C = D;
                        if (k && m) b: {
                            w = k;
                            x = m;
                            y = 0;
                            for(v = w; v; v = Jf(v))y++;
                            v = 0;
                            for(D = x; D; D = Jf(D))v++;
                            for(; 0 < y - v;)w = Jf(w), y--;
                            for(; 0 < v - y;)x = Jf(x), v--;
                            for(; y--;){
                                if (w === x || null !== x && w === x.alternate) break b;
                                w = Jf(w);
                                x = Jf(x);
                            }
                            w = null;
                        }
                        else w = null;
                        null !== k && Kf(g, h, k, w, !1);
                        null !== m && null !== C && Kf(g, C, m, w, !0);
                    }
                }
            }
            a: {
                h = d ? Ie(d) : window;
                k = h.nodeName && h.nodeName.toLowerCase();
                if ("select" === k || "input" === k && "file" === h.type) var ca = Je;
                else if (Ae(h)) {
                    if (Ke) ca = Te;
                    else {
                        ca = Re;
                        var R = Qe;
                    }
                } else (k = h.nodeName) && "input" === k.toLowerCase() && ("checkbox" === h.type || "radio" === h.type) && (ca = Se);
                if (ca && (ca = ca(a, d))) {
                    Be(g, ca, c, e);
                    break a;
                }
                R && R(a, h, d);
                "focusout" === a && (R = h._wrapperState) && R.controlled && "number" === h.type && bb(h, "number", h.value);
            }
            R = d ? Ie(d) : window;
            switch(a){
                case "focusin":
                    if (Ae(R) || "true" === R.contentEditable) df = R, ef = d, ff = null;
                    break;
                case "focusout":
                    ff = ef = df = null;
                    break;
                case "mousedown":
                    gf = !0;
                    break;
                case "contextmenu":
                case "mouseup":
                case "dragend":
                    gf = !1;
                    hf(g, c, e);
                    break;
                case "selectionchange":
                    if (cf) break;
                case "keydown":
                case "keyup":
                    hf(g, c, e);
            }
            var sa;
            if (oe) b: {
                switch(a){
                    case "compositionstart":
                        var V = "onCompositionStart";
                        break b;
                    case "compositionend":
                        V = "onCompositionEnd";
                        break b;
                    case "compositionupdate":
                        V = "onCompositionUpdate";
                        break b;
                }
                V = void 0;
            }
            else we ? ue(a, c) && (V = "onCompositionEnd") : "keydown" === a && 229 === c.keyCode && (V = "onCompositionStart");
            V && (re && "ko" !== c.locale && (we || "onCompositionStart" !== V ? "onCompositionEnd" === V && we && (sa = Bd()) : (yd = e, zd = "value" in yd ? yd.value : yd.textContent, we = !0)), R = Ce(d, V), 0 < R.length && (V = new Zd(V, a, null, c, e), g.push({
                event: V,
                listeners: R
            }), sa ? V.data = sa : (sa = ve(c), null !== sa && (V.data = sa))));
            if (sa = qe ? xe(a, c) : ye(a, c)) d = Ce(d, "onBeforeInput"), 0 < d.length && (e = new Zd("onBeforeInput", "beforeinput", null, c, e), g.push({
                event: e,
                listeners: d
            }), e.data = sa);
        }
        Ge(g, b);
    });
}
function Hf(a, b, c) {
    return {
        instance: a,
        listener: b,
        currentTarget: c
    };
}
function Ce(a, b) {
    for(var c = b + "Capture", d = []; null !== a;){
        var e = a, f = e.stateNode;
        5 === e.tag && null !== f && (e = f, f = Kb(a, c), null != f && d.unshift(Hf(a, f, e)), f = Kb(a, b), null != f && d.push(Hf(a, f, e)));
        a = a.return;
    }
    return d;
}
function Jf(a) {
    if (null === a) return null;
    do a = a.return;
    while (a && 5 !== a.tag);
    return a ? a : null;
}
function Kf(a, b, c, d, e) {
    for(var f = b._reactName, g = []; null !== c && c !== d;){
        var h = c, k = h.alternate, l = h.stateNode;
        if (null !== k && k === d) break;
        5 === h.tag && null !== l && (h = l, e ? (k = Kb(c, f), null != k && g.unshift(Hf(c, k, h))) : e || (k = Kb(c, f), null != k && g.push(Hf(c, k, h))));
        c = c.return;
    }
    0 !== g.length && a.push({
        event: b,
        listeners: g
    });
}
var Lf = /\r\n?/g, Mf = /\u0000|\uFFFD/g;
function Nf(a) {
    return ("string" === typeof a ? a : "" + a).replace(Lf, "\n").replace(Mf, "");
}
function Of(a, b, c) {
    b = Nf(b);
    if (Nf(a) !== b && c) throw Error(p(425));
}
function Pf() {}
var Qf = null, Rf = null;
function Sf(a, b) {
    return "textarea" === a || "noscript" === a || "string" === typeof b.children || "number" === typeof b.children || "object" === typeof b.dangerouslySetInnerHTML && null !== b.dangerouslySetInnerHTML && null != b.dangerouslySetInnerHTML.__html;
}
var Tf = "function" === typeof setTimeout ? setTimeout : void 0, Uf = "function" === typeof clearTimeout ? clearTimeout : void 0, Vf = "function" === typeof Promise ? Promise : void 0, Xf = "function" === typeof queueMicrotask ? queueMicrotask : "undefined" !== typeof Vf ? function(a) {
    return Vf.resolve(null).then(a).catch(Wf);
} : Tf;
function Wf(a) {
    setTimeout(function() {
        throw a;
    });
}
function Yf(a, b) {
    var c = b, d = 0;
    do {
        var e = c.nextSibling;
        a.removeChild(c);
        if (e && 8 === e.nodeType) {
            if (c = e.data, "/$" === c) {
                if (0 === d) {
                    a.removeChild(e);
                    pd(b);
                    return;
                }
                d--;
            } else "$" !== c && "$?" !== c && "$!" !== c || d++;
        }
        c = e;
    }while (c);
    pd(b);
}
function Zf(a) {
    for(; null != a; a = a.nextSibling){
        var b = a.nodeType;
        if (1 === b || 3 === b) break;
        if (8 === b) {
            b = a.data;
            if ("$" === b || "$!" === b || "$?" === b) break;
            if ("/$" === b) return null;
        }
    }
    return a;
}
function $f(a) {
    a = a.previousSibling;
    for(var b = 0; a;){
        if (8 === a.nodeType) {
            var c = a.data;
            if ("$" === c || "$!" === c || "$?" === c) {
                if (0 === b) return a;
                b--;
            } else "/$" === c && b++;
        }
        a = a.previousSibling;
    }
    return null;
}
var ag = Math.random().toString(36).slice(2), bg = "__reactFiber$" + ag, cg = "__reactProps$" + ag, If = "__reactContainer$" + ag, Cf = "__reactEvents$" + ag, dg = "__reactListeners$" + ag, eg = "__reactHandles$" + ag;
function jd(a) {
    var b = a[bg];
    if (b) return b;
    for(var c = a.parentNode; c;){
        if (b = c[If] || c[bg]) {
            c = b.alternate;
            if (null !== b.child || null !== c && null !== c.child) for(a = $f(a); null !== a;){
                if (c = a[bg]) return c;
                a = $f(a);
            }
            return b;
        }
        a = c;
        c = a.parentNode;
    }
    return null;
}
function Cb(a) {
    a = a[bg] || a[If];
    return !a || 5 !== a.tag && 6 !== a.tag && 13 !== a.tag && 3 !== a.tag ? null : a;
}
function Ie(a) {
    if (5 === a.tag || 6 === a.tag) return a.stateNode;
    throw Error(p(33));
}
function Db(a) {
    return a[cg] || null;
}
var fg = [], gg = -1;
function hg(a) {
    return {
        current: a
    };
}
function G(a) {
    0 > gg || (a.current = fg[gg], fg[gg] = null, gg--);
}
function H(a, b) {
    gg++;
    fg[gg] = a.current;
    a.current = b;
}
var ig = {}, I = hg(ig), jg = hg(!1), kg = ig;
function lg(a, b) {
    var c = a.type.contextTypes;
    if (!c) return ig;
    var d = a.stateNode;
    if (d && d.__reactInternalMemoizedUnmaskedChildContext === b) return d.__reactInternalMemoizedMaskedChildContext;
    var e = {}, f;
    for(f in c)e[f] = b[f];
    d && (a = a.stateNode, a.__reactInternalMemoizedUnmaskedChildContext = b, a.__reactInternalMemoizedMaskedChildContext = e);
    return e;
}
function mg(a) {
    a = a.childContextTypes;
    return null !== a && void 0 !== a;
}
function ng() {
    G(jg);
    G(I);
}
function og(a, b, c) {
    if (I.current !== ig) throw Error(p(168));
    H(I, b);
    H(jg, c);
}
function pg(a, b, c) {
    var d = a.stateNode;
    b = b.childContextTypes;
    if ("function" !== typeof d.getChildContext) return c;
    d = d.getChildContext();
    for(var e in d)if (!(e in b)) throw Error(p(108, Ra(a) || "Unknown", e));
    return u({}, c, d);
}
function qg(a) {
    a = (a = a.stateNode) && a.__reactInternalMemoizedMergedChildContext || ig;
    kg = I.current;
    H(I, a);
    H(jg, jg.current);
    return !0;
}
function rg(a, b, c) {
    var d = a.stateNode;
    if (!d) throw Error(p(169));
    c ? (a = pg(a, b, kg), d.__reactInternalMemoizedMergedChildContext = a, G(jg), G(I), H(I, a)) : G(jg);
    H(jg, c);
}
var sg = null, tg = !1, ug = !1;
function vg(a) {
    null === sg ? sg = [
        a
    ] : sg.push(a);
}
function wg(a) {
    tg = !0;
    vg(a);
}
function xg() {
    if (!ug && null !== sg) {
        ug = !0;
        var a = 0, b = E;
        try {
            var c = sg;
            for(E = 1; a < c.length; a++){
                var d = c[a];
                do d = d(!0);
                while (null !== d);
            }
            sg = null;
            tg = !1;
        } catch (e) {
            throw null !== sg && (sg = sg.slice(a + 1)), ac(fc, xg), e;
        } finally{
            E = b, ug = !1;
        }
    }
    return null;
}
var yg = [], zg = 0, Ag = null, Bg = 0, Cg = [], Dg = 0, Eg = null, Fg = 1, Gg = "";
function Hg(a, b) {
    yg[zg++] = Bg;
    yg[zg++] = Ag;
    Ag = a;
    Bg = b;
}
function Ig(a, b, c) {
    Cg[Dg++] = Fg;
    Cg[Dg++] = Gg;
    Cg[Dg++] = Eg;
    Eg = a;
    var d = Fg;
    a = Gg;
    var e = 32 - Ac(d) - 1;
    d &= ~(1 << e);
    c += 1;
    var f = 32 - Ac(b) + e;
    if (30 < f) {
        var g = e - e % 5;
        f = (d & (1 << g) - 1).toString(32);
        d >>= g;
        e -= g;
        Fg = 1 << 32 - Ac(b) + e | c << e | d;
        Gg = f + a;
    } else Fg = 1 << f | c << e | d, Gg = a;
}
function Jg(a) {
    null !== a.return && (Hg(a, 1), Ig(a, 1, 0));
}
function Kg(a) {
    for(; a === Ag;)Ag = yg[--zg], yg[zg] = null, Bg = yg[--zg], yg[zg] = null;
    for(; a === Eg;)Eg = Cg[--Dg], Cg[Dg] = null, Gg = Cg[--Dg], Cg[Dg] = null, Fg = Cg[--Dg], Cg[Dg] = null;
}
var Lg = null, Mg = null, J = !1, Ng = null;
function Og(a, b) {
    var c = Pg(5, null, null, 0);
    c.elementType = "DELETED";
    c.stateNode = b;
    c.return = a;
    b = a.deletions;
    null === b ? (a.deletions = [
        c
    ], a.flags |= 16) : b.push(c);
}
function Qg(a, b) {
    switch(a.tag){
        case 5:
            var c = a.type;
            b = 1 !== b.nodeType || c.toLowerCase() !== b.nodeName.toLowerCase() ? null : b;
            return null !== b ? (a.stateNode = b, Lg = a, Mg = Zf(b.firstChild), !0) : !1;
        case 6:
            return b = "" === a.pendingProps || 3 !== b.nodeType ? null : b, null !== b ? (a.stateNode = b, Lg = a, Mg = null, !0) : !1;
        case 13:
            return b = 8 !== b.nodeType ? null : b, null !== b ? (c = null !== Eg ? {
                id: Fg,
                overflow: Gg
            } : null, a.memoizedState = {
                dehydrated: b,
                treeContext: c,
                retryLane: 1073741824
            }, c = Pg(18, null, null, 0), c.stateNode = b, c.return = a, a.child = c, Lg = a, Mg = null, !0) : !1;
        default:
            return !1;
    }
}
function Rg(a) {
    return 0 !== (a.mode & 1) && 0 === (a.flags & 128);
}
function Sg(a) {
    if (J) {
        var b = Mg;
        if (b) {
            var c = b;
            if (!Qg(a, b)) {
                if (Rg(a)) throw Error(p(418));
                b = Zf(c.nextSibling);
                var d = Lg;
                b && Qg(a, b) ? Og(d, c) : (a.flags = a.flags & -4097 | 2, J = !1, Lg = a);
            }
        } else {
            if (Rg(a)) throw Error(p(418));
            a.flags = a.flags & -4097 | 2;
            J = !1;
            Lg = a;
        }
    }
}
function Tg(a) {
    for(a = a.return; null !== a && 5 !== a.tag && 3 !== a.tag && 13 !== a.tag;)a = a.return;
    Lg = a;
}
function Ug(a) {
    if (a !== Lg) return !1;
    if (!J) return Tg(a), J = !0, !1;
    var b;
    (b = 3 !== a.tag) && !(b = 5 !== a.tag) && (b = a.type, b = "head" !== b && "body" !== b && !Sf(a.type, a.memoizedProps));
    if (b && (b = Mg)) {
        if (Rg(a)) throw Vg(), Error(p(418));
        for(; b;)Og(a, b), b = Zf(b.nextSibling);
    }
    Tg(a);
    if (13 === a.tag) {
        a = a.memoizedState;
        a = null !== a ? a.dehydrated : null;
        if (!a) throw Error(p(317));
        a: {
            a = a.nextSibling;
            for(b = 0; a;){
                if (8 === a.nodeType) {
                    var c = a.data;
                    if ("/$" === c) {
                        if (0 === b) {
                            Mg = Zf(a.nextSibling);
                            break a;
                        }
                        b--;
                    } else "$" !== c && "$!" !== c && "$?" !== c || b++;
                }
                a = a.nextSibling;
            }
            Mg = null;
        }
    } else Mg = Lg ? Zf(a.stateNode.nextSibling) : null;
    return !0;
}
function Vg() {
    for(var a = Mg; a;)a = Zf(a.nextSibling);
}
function Wg() {
    Mg = Lg = null;
    J = !1;
}
function Xg(a) {
    null === Ng ? Ng = [
        a
    ] : Ng.push(a);
}
var Yg = va.ReactCurrentBatchConfig;
function Zg(a, b, c) {
    a = c.ref;
    if (null !== a && "function" !== typeof a && "object" !== typeof a) {
        if (c._owner) {
            c = c._owner;
            if (c) {
                if (1 !== c.tag) throw Error(p(309));
                var d = c.stateNode;
            }
            if (!d) throw Error(p(147, a));
            var e = d, f = "" + a;
            if (null !== b && null !== b.ref && "function" === typeof b.ref && b.ref._stringRef === f) return b.ref;
            b = function(a) {
                var b = e.refs;
                null === a ? delete b[f] : b[f] = a;
            };
            b._stringRef = f;
            return b;
        }
        if ("string" !== typeof a) throw Error(p(284));
        if (!c._owner) throw Error(p(290, a));
    }
    return a;
}
function $g(a, b) {
    a = Object.prototype.toString.call(b);
    throw Error(p(31, "[object Object]" === a ? "object with keys {" + Object.keys(b).join(", ") + "}" : a));
}
function ah(a) {
    var b = a._init;
    return b(a._payload);
}
function bh(a) {
    function b(b, c) {
        if (a) {
            var d = b.deletions;
            null === d ? (b.deletions = [
                c
            ], b.flags |= 16) : d.push(c);
        }
    }
    function c(c, d) {
        if (!a) return null;
        for(; null !== d;)b(c, d), d = d.sibling;
        return null;
    }
    function d(a, b) {
        for(a = new Map; null !== b;)null !== b.key ? a.set(b.key, b) : a.set(b.index, b), b = b.sibling;
        return a;
    }
    function e(a, b) {
        a = ch(a, b);
        a.index = 0;
        a.sibling = null;
        return a;
    }
    function f(b, c, d) {
        b.index = d;
        if (!a) return b.flags |= 1048576, c;
        d = b.alternate;
        if (null !== d) return d = d.index, d < c ? (b.flags |= 2, c) : d;
        b.flags |= 2;
        return c;
    }
    function g(b) {
        a && null === b.alternate && (b.flags |= 2);
        return b;
    }
    function h(a, b, c, d) {
        if (null === b || 6 !== b.tag) return b = dh(c, a.mode, d), b.return = a, b;
        b = e(b, c);
        b.return = a;
        return b;
    }
    function k(a, b, c, d) {
        var f = c.type;
        if (f === ya) return n(a, b, c.props.children, d, c.key);
        if (null !== b && (b.elementType === f || "object" === typeof f && null !== f && f.$$typeof === Ha && ah(f) === b.type)) return d = e(b, c.props), d.ref = Zg(a, b, c), d.return = a, d;
        d = eh(c.type, c.key, c.props, null, a.mode, d);
        d.ref = Zg(a, b, c);
        d.return = a;
        return d;
    }
    function l(a, b, c, d) {
        if (null === b || 4 !== b.tag || b.stateNode.containerInfo !== c.containerInfo || b.stateNode.implementation !== c.implementation) return b = fh(c, a.mode, d), b.return = a, b;
        b = e(b, c.children || []);
        b.return = a;
        return b;
    }
    function n(a, b, c, d, f) {
        if (null === b || 7 !== b.tag) return b = gh(c, a.mode, d, f), b.return = a, b;
        b = e(b, c);
        b.return = a;
        return b;
    }
    function q(a, b, c) {
        if ("string" === typeof b && "" !== b || "number" === typeof b) return b = dh("" + b, a.mode, c), b.return = a, b;
        if ("object" === typeof b && null !== b) {
            switch(b.$$typeof){
                case wa:
                    return c = eh(b.type, b.key, b.props, null, a.mode, c), c.ref = Zg(a, null, b), c.return = a, c;
                case xa:
                    return b = fh(b, a.mode, c), b.return = a, b;
                case Ha:
                    var d = b._init;
                    return q(a, d(b._payload), c);
            }
            if (db(b) || Ka(b)) return b = gh(b, a.mode, c, null), b.return = a, b;
            $g(a, b);
        }
        return null;
    }
    function r(a, b, c, d) {
        var e = null !== b ? b.key : null;
        if ("string" === typeof c && "" !== c || "number" === typeof c) return null !== e ? null : h(a, b, "" + c, d);
        if ("object" === typeof c && null !== c) {
            switch(c.$$typeof){
                case wa:
                    return c.key === e ? k(a, b, c, d) : null;
                case xa:
                    return c.key === e ? l(a, b, c, d) : null;
                case Ha:
                    return e = c._init, r(a, b, e(c._payload), d);
            }
            if (db(c) || Ka(c)) return null !== e ? null : n(a, b, c, d, null);
            $g(a, c);
        }
        return null;
    }
    function z(a, b, c, d, e) {
        if ("string" === typeof d && "" !== d || "number" === typeof d) return a = a.get(c) || null, h(b, a, "" + d, e);
        if ("object" === typeof d && null !== d) {
            switch(d.$$typeof){
                case wa:
                    return a = a.get(null === d.key ? c : d.key) || null, k(b, a, d, e);
                case xa:
                    return a = a.get(null === d.key ? c : d.key) || null, l(b, a, d, e);
                case Ha:
                    var f = d._init;
                    return z(a, b, c, f(d._payload), e);
            }
            if (db(d) || Ka(d)) return a = a.get(c) || null, n(b, a, d, e, null);
            $g(b, d);
        }
        return null;
    }
    function m(e, g, h, k) {
        for(var l = null, v = null, n = g, m = g = 0, y = null; null !== n && m < h.length; m++){
            n.index > m ? (y = n, n = null) : y = n.sibling;
            var x = r(e, n, h[m], k);
            if (null === x) {
                null === n && (n = y);
                break;
            }
            a && n && null === x.alternate && b(e, n);
            g = f(x, g, m);
            null === v ? l = x : v.sibling = x;
            v = x;
            n = y;
        }
        if (m === h.length) return c(e, n), J && Hg(e, m), l;
        if (null === n) {
            for(; m < h.length; m++)n = q(e, h[m], k), null !== n && (g = f(n, g, m), null === v ? l = n : v.sibling = n, v = n);
            J && Hg(e, m);
            return l;
        }
        for(n = d(e, n); m < h.length; m++)y = z(n, e, m, h[m], k), null !== y && (a && null !== y.alternate && n.delete(null === y.key ? m : y.key), g = f(y, g, m), null === v ? l = y : v.sibling = y, v = y);
        a && n.forEach(function(a) {
            return b(e, a);
        });
        J && Hg(e, m);
        return l;
    }
    function w(e, g, h, k) {
        var l = Ka(h);
        if ("function" !== typeof l) throw Error(p(150));
        h = l.call(h);
        if (null == h) throw Error(p(151));
        for(var n = l = null, m = g, v = g = 0, y = null, x = h.next(); null !== m && !x.done; v++, x = h.next()){
            m.index > v ? (y = m, m = null) : y = m.sibling;
            var w = r(e, m, x.value, k);
            if (null === w) {
                null === m && (m = y);
                break;
            }
            a && m && null === w.alternate && b(e, m);
            g = f(w, g, v);
            null === n ? l = w : n.sibling = w;
            n = w;
            m = y;
        }
        if (x.done) return c(e, m), J && Hg(e, v), l;
        if (null === m) {
            for(; !x.done; v++, x = h.next())x = q(e, x.value, k), null !== x && (g = f(x, g, v), null === n ? l = x : n.sibling = x, n = x);
            J && Hg(e, v);
            return l;
        }
        for(m = d(e, m); !x.done; v++, x = h.next())x = z(m, e, v, x.value, k), null !== x && (a && null !== x.alternate && m.delete(null === x.key ? v : x.key), g = f(x, g, v), null === n ? l = x : n.sibling = x, n = x);
        a && m.forEach(function(a) {
            return b(e, a);
        });
        J && Hg(e, v);
        return l;
    }
    function C(a, d, f, h) {
        "object" === typeof f && null !== f && f.type === ya && null === f.key && (f = f.props.children);
        if ("object" === typeof f && null !== f) {
            switch(f.$$typeof){
                case wa:
                    a: {
                        for(var k = f.key, l = d; null !== l;){
                            if (l.key === k) {
                                k = f.type;
                                if (k === ya) {
                                    if (7 === l.tag) {
                                        c(a, l.sibling);
                                        d = e(l, f.props.children);
                                        d.return = a;
                                        a = d;
                                        break a;
                                    }
                                } else if (l.elementType === k || "object" === typeof k && null !== k && k.$$typeof === Ha && ah(k) === l.type) {
                                    c(a, l.sibling);
                                    d = e(l, f.props);
                                    d.ref = Zg(a, l, f);
                                    d.return = a;
                                    a = d;
                                    break a;
                                }
                                c(a, l);
                                break;
                            } else b(a, l);
                            l = l.sibling;
                        }
                        f.type === ya ? (d = gh(f.props.children, a.mode, h, f.key), d.return = a, a = d) : (h = eh(f.type, f.key, f.props, null, a.mode, h), h.ref = Zg(a, d, f), h.return = a, a = h);
                    }
                    return g(a);
                case xa:
                    a: {
                        for(l = f.key; null !== d;){
                            if (d.key === l) {
                                if (4 === d.tag && d.stateNode.containerInfo === f.containerInfo && d.stateNode.implementation === f.implementation) {
                                    c(a, d.sibling);
                                    d = e(d, f.children || []);
                                    d.return = a;
                                    a = d;
                                    break a;
                                } else {
                                    c(a, d);
                                    break;
                                }
                            } else b(a, d);
                            d = d.sibling;
                        }
                        d = fh(f, a.mode, h);
                        d.return = a;
                        a = d;
                    }
                    return g(a);
                case Ha:
                    return l = f._init, C(a, d, l(f._payload), h);
            }
            if (db(f)) return m(a, d, f, h);
            if (Ka(f)) return w(a, d, f, h);
            $g(a, f);
        }
        return "string" === typeof f && "" !== f || "number" === typeof f ? (f = "" + f, null !== d && 6 === d.tag ? (c(a, d.sibling), d = e(d, f), d.return = a, a = d) : (c(a, d), d = dh(f, a.mode, h), d.return = a, a = d), g(a)) : c(a, d);
    }
    return C;
}
var hh = bh(!0), ih = bh(!1), jh = hg(null), kh = null, lh = null, mh = null;
function nh() {
    mh = lh = kh = null;
}
function oh(a) {
    var b = jh.current;
    G(jh);
    a._currentValue = b;
}
function ph(a, b, c) {
    for(; null !== a;){
        var d = a.alternate;
        (a.childLanes & b) !== b ? (a.childLanes |= b, null !== d && (d.childLanes |= b)) : null !== d && (d.childLanes & b) !== b && (d.childLanes |= b);
        if (a === c) break;
        a = a.return;
    }
}
function qh(a, b) {
    kh = a;
    mh = lh = null;
    a = a.dependencies;
    null !== a && null !== a.firstContext && (0 !== (a.lanes & b) && (rh = !0), a.firstContext = null);
}
function sh(a) {
    var b = a._currentValue;
    if (mh !== a) {
        if (a = {
            context: a,
            memoizedValue: b,
            next: null
        }, null === lh) {
            if (null === kh) throw Error(p(308));
            lh = a;
            kh.dependencies = {
                lanes: 0,
                firstContext: a
            };
        } else lh = lh.next = a;
    }
    return b;
}
var th = null;
function uh(a) {
    null === th ? th = [
        a
    ] : th.push(a);
}
function vh(a, b, c, d) {
    var e = b.interleaved;
    null === e ? (c.next = c, uh(b)) : (c.next = e.next, e.next = c);
    b.interleaved = c;
    return wh(a, d);
}
function wh(a, b) {
    a.lanes |= b;
    var c = a.alternate;
    null !== c && (c.lanes |= b);
    c = a;
    for(a = a.return; null !== a;)a.childLanes |= b, c = a.alternate, null !== c && (c.childLanes |= b), c = a, a = a.return;
    return 3 === c.tag ? c.stateNode : null;
}
var xh = !1;
function yh(a) {
    a.updateQueue = {
        baseState: a.memoizedState,
        firstBaseUpdate: null,
        lastBaseUpdate: null,
        shared: {
            pending: null,
            interleaved: null,
            lanes: 0
        },
        effects: null
    };
}
function zh(a, b) {
    a = a.updateQueue;
    b.updateQueue === a && (b.updateQueue = {
        baseState: a.baseState,
        firstBaseUpdate: a.firstBaseUpdate,
        lastBaseUpdate: a.lastBaseUpdate,
        shared: a.shared,
        effects: a.effects
    });
}
function Ah(a, b) {
    return {
        eventTime: a,
        lane: b,
        tag: 0,
        payload: null,
        callback: null,
        next: null
    };
}
function Bh(a, b, c) {
    var d = a.updateQueue;
    if (null === d) return null;
    d = d.shared;
    if (0 !== (K & 2)) {
        var e = d.pending;
        null === e ? b.next = b : (b.next = e.next, e.next = b);
        d.pending = b;
        return wh(a, c);
    }
    e = d.interleaved;
    null === e ? (b.next = b, uh(d)) : (b.next = e.next, e.next = b);
    d.interleaved = b;
    return wh(a, c);
}
function Ch(a, b, c) {
    b = b.updateQueue;
    if (null !== b && (b = b.shared, 0 !== (c & 4194240))) {
        var d = b.lanes;
        d &= a.pendingLanes;
        c |= d;
        b.lanes = c;
        Oc(a, c);
    }
}
function Dh(a, b) {
    var c = a.updateQueue, d = a.alternate;
    if (null !== d && (d = d.updateQueue, c === d)) {
        var e = null, f = null;
        c = c.firstBaseUpdate;
        if (null !== c) {
            do {
                var g = {
                    eventTime: c.eventTime,
                    lane: c.lane,
                    tag: c.tag,
                    payload: c.payload,
                    callback: c.callback,
                    next: null
                };
                null === f ? e = f = g : f = f.next = g;
                c = c.next;
            }while (null !== c);
            null === f ? e = f = b : f = f.next = b;
        } else e = f = b;
        c = {
            baseState: d.baseState,
            firstBaseUpdate: e,
            lastBaseUpdate: f,
            shared: d.shared,
            effects: d.effects
        };
        a.updateQueue = c;
        return;
    }
    a = c.lastBaseUpdate;
    null === a ? c.firstBaseUpdate = b : a.next = b;
    c.lastBaseUpdate = b;
}
function Eh(a, b, c, d) {
    var e = a.updateQueue;
    xh = !1;
    var f = e.firstBaseUpdate, g = e.lastBaseUpdate, h = e.shared.pending;
    if (null !== h) {
        e.shared.pending = null;
        var k = h, l = k.next;
        k.next = null;
        null === g ? f = l : g.next = l;
        g = k;
        var n = a.alternate;
        null !== n && (n = n.updateQueue, h = n.lastBaseUpdate, h !== g && (null === h ? n.firstBaseUpdate = l : h.next = l, n.lastBaseUpdate = k));
    }
    if (null !== f) {
        var q = e.baseState;
        g = 0;
        n = l = k = null;
        h = f;
        do {
            var r = h.lane, z = h.eventTime;
            if ((d & r) === r) {
                null !== n && (n = n.next = {
                    eventTime: z,
                    lane: 0,
                    tag: h.tag,
                    payload: h.payload,
                    callback: h.callback,
                    next: null
                });
                a: {
                    var m = a, w = h;
                    r = b;
                    z = c;
                    switch(w.tag){
                        case 1:
                            m = w.payload;
                            if ("function" === typeof m) {
                                q = m.call(z, q, r);
                                break a;
                            }
                            q = m;
                            break a;
                        case 3:
                            m.flags = m.flags & -65537 | 128;
                        case 0:
                            m = w.payload;
                            r = "function" === typeof m ? m.call(z, q, r) : m;
                            if (null === r || void 0 === r) break a;
                            q = u({}, q, r);
                            break a;
                        case 2:
                            xh = !0;
                    }
                }
                null !== h.callback && 0 !== h.lane && (a.flags |= 64, r = e.effects, null === r ? e.effects = [
                    h
                ] : r.push(h));
            } else z = {
                eventTime: z,
                lane: r,
                tag: h.tag,
                payload: h.payload,
                callback: h.callback,
                next: null
            }, null === n ? (l = n = z, k = q) : n = n.next = z, g |= r;
            h = h.next;
            if (null === h) {
                if (h = e.shared.pending, null === h) break;
                else r = h, h = r.next, r.next = null, e.lastBaseUpdate = r, e.shared.pending = null;
            }
        }while (1);
        null === n && (k = q);
        e.baseState = k;
        e.firstBaseUpdate = l;
        e.lastBaseUpdate = n;
        b = e.shared.interleaved;
        if (null !== b) {
            e = b;
            do g |= e.lane, e = e.next;
            while (e !== b);
        } else null === f && (e.shared.lanes = 0);
        Fh |= g;
        a.lanes = g;
        a.memoizedState = q;
    }
}
function Gh(a, b, c) {
    a = b.effects;
    b.effects = null;
    if (null !== a) for(b = 0; b < a.length; b++){
        var d = a[b], e = d.callback;
        if (null !== e) {
            d.callback = null;
            d = c;
            if ("function" !== typeof e) throw Error(p(191, e));
            e.call(d);
        }
    }
}
var Hh = {}, Ih = hg(Hh), Jh = hg(Hh), Kh = hg(Hh);
function Lh(a) {
    if (a === Hh) throw Error(p(174));
    return a;
}
function Mh(a, b) {
    H(Kh, b);
    H(Jh, a);
    H(Ih, Hh);
    a = b.nodeType;
    switch(a){
        case 9:
        case 11:
            b = (b = b.documentElement) ? b.namespaceURI : kb(null, "");
            break;
        default:
            a = 8 === a ? b.parentNode : b, b = a.namespaceURI || null, a = a.tagName, b = kb(b, a);
    }
    G(Ih);
    H(Ih, b);
}
function Nh() {
    G(Ih);
    G(Jh);
    G(Kh);
}
function Oh(a) {
    Lh(Kh.current);
    var b = Lh(Ih.current);
    var c = kb(b, a.type);
    b !== c && (H(Jh, a), H(Ih, c));
}
function Ph(a) {
    Jh.current === a && (G(Ih), G(Jh));
}
var L = hg(0);
function Qh(a) {
    for(var b = a; null !== b;){
        if (13 === b.tag) {
            var c = b.memoizedState;
            if (null !== c && (c = c.dehydrated, null === c || "$?" === c.data || "$!" === c.data)) return b;
        } else if (19 === b.tag && void 0 !== b.memoizedProps.revealOrder) {
            if (0 !== (b.flags & 128)) return b;
        } else if (null !== b.child) {
            b.child.return = b;
            b = b.child;
            continue;
        }
        if (b === a) break;
        for(; null === b.sibling;){
            if (null === b.return || b.return === a) return null;
            b = b.return;
        }
        b.sibling.return = b.return;
        b = b.sibling;
    }
    return null;
}
var Rh = [];
function Sh() {
    for(var a = 0; a < Rh.length; a++)Rh[a]._workInProgressVersionPrimary = null;
    Rh.length = 0;
}
var Th = va.ReactCurrentDispatcher, Uh = va.ReactCurrentBatchConfig, Vh = 0, M = null, N = null, O = null, Wh = !1, Xh = !1, Yh = 0, Zh = 0;
function P() {
    throw Error(p(321));
}
function $h(a, b) {
    if (null === b) return !1;
    for(var c = 0; c < b.length && c < a.length; c++)if (!Ve(a[c], b[c])) return !1;
    return !0;
}
function ai(a, b, c, d, e, f) {
    Vh = f;
    M = b;
    b.memoizedState = null;
    b.updateQueue = null;
    b.lanes = 0;
    Th.current = null === a || null === a.memoizedState ? bi : ci;
    a = c(d, e);
    if (Xh) {
        f = 0;
        do {
            Xh = !1;
            Yh = 0;
            if (25 <= f) throw Error(p(301));
            f += 1;
            O = N = null;
            b.updateQueue = null;
            Th.current = di;
            a = c(d, e);
        }while (Xh);
    }
    Th.current = ei;
    b = null !== N && null !== N.next;
    Vh = 0;
    O = N = M = null;
    Wh = !1;
    if (b) throw Error(p(300));
    return a;
}
function fi() {
    var a = 0 !== Yh;
    Yh = 0;
    return a;
}
function gi() {
    var a = {
        memoizedState: null,
        baseState: null,
        baseQueue: null,
        queue: null,
        next: null
    };
    null === O ? M.memoizedState = O = a : O = O.next = a;
    return O;
}
function hi() {
    if (null === N) {
        var a = M.alternate;
        a = null !== a ? a.memoizedState : null;
    } else a = N.next;
    var b = null === O ? M.memoizedState : O.next;
    if (null !== b) O = b, N = a;
    else {
        if (null === a) throw Error(p(310));
        N = a;
        a = {
            memoizedState: N.memoizedState,
            baseState: N.baseState,
            baseQueue: N.baseQueue,
            queue: N.queue,
            next: null
        };
        null === O ? M.memoizedState = O = a : O = O.next = a;
    }
    return O;
}
function ii(a, b) {
    return "function" === typeof b ? b(a) : b;
}
function ji(a) {
    var b = hi(), c = b.queue;
    if (null === c) throw Error(p(311));
    c.lastRenderedReducer = a;
    var d = N, e = d.baseQueue, f = c.pending;
    if (null !== f) {
        if (null !== e) {
            var g = e.next;
            e.next = f.next;
            f.next = g;
        }
        d.baseQueue = e = f;
        c.pending = null;
    }
    if (null !== e) {
        f = e.next;
        d = d.baseState;
        var h = g = null, k = null, l = f;
        do {
            var n = l.lane;
            if ((Vh & n) === n) null !== k && (k = k.next = {
                lane: 0,
                action: l.action,
                hasEagerState: l.hasEagerState,
                eagerState: l.eagerState,
                next: null
            }), d = l.hasEagerState ? l.eagerState : a(d, l.action);
            else {
                var q = {
                    lane: n,
                    action: l.action,
                    hasEagerState: l.hasEagerState,
                    eagerState: l.eagerState,
                    next: null
                };
                null === k ? (h = k = q, g = d) : k = k.next = q;
                M.lanes |= n;
                Fh |= n;
            }
            l = l.next;
        }while (null !== l && l !== f);
        null === k ? g = d : k.next = h;
        Ve(d, b.memoizedState) || (rh = !0);
        b.memoizedState = d;
        b.baseState = g;
        b.baseQueue = k;
        c.lastRenderedState = d;
    }
    a = c.interleaved;
    if (null !== a) {
        e = a;
        do f = e.lane, M.lanes |= f, Fh |= f, e = e.next;
        while (e !== a);
    } else null === e && (c.lanes = 0);
    return [
        b.memoizedState,
        c.dispatch
    ];
}
function ki(a) {
    var b = hi(), c = b.queue;
    if (null === c) throw Error(p(311));
    c.lastRenderedReducer = a;
    var d = c.dispatch, e = c.pending, f = b.memoizedState;
    if (null !== e) {
        c.pending = null;
        var g = e = e.next;
        do f = a(f, g.action), g = g.next;
        while (g !== e);
        Ve(f, b.memoizedState) || (rh = !0);
        b.memoizedState = f;
        null === b.baseQueue && (b.baseState = f);
        c.lastRenderedState = f;
    }
    return [
        f,
        d
    ];
}
function li() {}
function mi(a, b) {
    var c = M, d = hi(), e = b(), f = !Ve(d.memoizedState, e);
    f && (d.memoizedState = e, rh = !0);
    d = d.queue;
    ni(oi.bind(null, c, d, a), [
        a
    ]);
    if (d.getSnapshot !== b || f || null !== O && O.memoizedState.tag & 1) {
        c.flags |= 2048;
        pi(9, qi.bind(null, c, d, e, b), void 0, null);
        if (null === Q) throw Error(p(349));
        0 !== (Vh & 30) || ri(c, b, e);
    }
    return e;
}
function ri(a, b, c) {
    a.flags |= 16384;
    a = {
        getSnapshot: b,
        value: c
    };
    b = M.updateQueue;
    null === b ? (b = {
        lastEffect: null,
        stores: null
    }, M.updateQueue = b, b.stores = [
        a
    ]) : (c = b.stores, null === c ? b.stores = [
        a
    ] : c.push(a));
}
function qi(a, b, c, d) {
    b.value = c;
    b.getSnapshot = d;
    si(b) && ti(a);
}
function oi(a, b, c) {
    return c(function() {
        si(b) && ti(a);
    });
}
function si(a) {
    var b = a.getSnapshot;
    a = a.value;
    try {
        var c = b();
        return !Ve(a, c);
    } catch (d) {
        return !0;
    }
}
function ti(a) {
    var b = wh(a, 1);
    null !== b && ui(b, a, 1, -1);
}
function vi(a) {
    var b = gi();
    "function" === typeof a && (a = a());
    b.memoizedState = b.baseState = a;
    a = {
        pending: null,
        interleaved: null,
        lanes: 0,
        dispatch: null,
        lastRenderedReducer: ii,
        lastRenderedState: a
    };
    b.queue = a;
    a = a.dispatch = wi.bind(null, M, a);
    return [
        b.memoizedState,
        a
    ];
}
function pi(a, b, c, d) {
    a = {
        tag: a,
        create: b,
        destroy: c,
        deps: d,
        next: null
    };
    b = M.updateQueue;
    null === b ? (b = {
        lastEffect: null,
        stores: null
    }, M.updateQueue = b, b.lastEffect = a.next = a) : (c = b.lastEffect, null === c ? b.lastEffect = a.next = a : (d = c.next, c.next = a, a.next = d, b.lastEffect = a));
    return a;
}
function xi() {
    return hi().memoizedState;
}
function Ai(a, b, c, d) {
    var e = gi();
    M.flags |= a;
    e.memoizedState = pi(1 | b, c, void 0, void 0 === d ? null : d);
}
function Bi(a, b, c, d) {
    var e = hi();
    d = void 0 === d ? null : d;
    var f = void 0;
    if (null !== N) {
        var g = N.memoizedState;
        f = g.destroy;
        if (null !== d && $h(d, g.deps)) {
            e.memoizedState = pi(b, c, f, d);
            return;
        }
    }
    M.flags |= a;
    e.memoizedState = pi(1 | b, c, f, d);
}
function Ci(a, b) {
    return Ai(8390656, 8, a, b);
}
function ni(a, b) {
    return Bi(2048, 8, a, b);
}
function Di(a, b) {
    return Bi(4, 2, a, b);
}
function Ei(a, b) {
    return Bi(4, 4, a, b);
}
function Fi(a, b) {
    if ("function" === typeof b) return a = a(), b(a), function() {
        b(null);
    };
    if (null !== b && void 0 !== b) return a = a(), b.current = a, function() {
        b.current = null;
    };
}
function Gi(a, b, c) {
    c = null !== c && void 0 !== c ? c.concat([
        a
    ]) : null;
    return Bi(4, 4, Fi.bind(null, b, a), c);
}
function Hi() {}
function Ii(a, b) {
    var c = hi();
    b = void 0 === b ? null : b;
    var d = c.memoizedState;
    if (null !== d && null !== b && $h(b, d[1])) return d[0];
    c.memoizedState = [
        a,
        b
    ];
    return a;
}
function Ji(a, b) {
    var c = hi();
    b = void 0 === b ? null : b;
    var d = c.memoizedState;
    if (null !== d && null !== b && $h(b, d[1])) return d[0];
    a = a();
    c.memoizedState = [
        a,
        b
    ];
    return a;
}
function Ki(a, b, c) {
    if (0 === (Vh & 21)) return a.baseState && (a.baseState = !1, rh = !0), a.memoizedState = c;
    Ve(c, b) || (c = Kc(), M.lanes |= c, Fh |= c, a.baseState = !0);
    return b;
}
function Li(a, b) {
    var c = E;
    E = 0 !== c && 4 > c ? c : 4;
    a(!0);
    var d = Uh.transition;
    Uh.transition = {};
    try {
        a(!1), b();
    } finally{
        E = c, Uh.transition = d;
    }
}
function Mi() {
    return hi().memoizedState;
}
function Ni(a, b, c) {
    var d = Oi(a);
    c = {
        lane: d,
        action: c,
        hasEagerState: !1,
        eagerState: null,
        next: null
    };
    if (Pi(a)) Qi(b, c);
    else if (c = vh(a, b, c, d), null !== c) {
        var e = Ri();
        ui(c, a, d, e);
        Si(c, b, d);
    }
    yc(a, d);
}
function wi(a, b, c) {
    var d = Oi(a), e = {
        lane: d,
        action: c,
        hasEagerState: !1,
        eagerState: null,
        next: null
    };
    if (Pi(a)) Qi(b, e);
    else {
        var f = a.alternate;
        if (0 === a.lanes && (null === f || 0 === f.lanes) && (f = b.lastRenderedReducer, null !== f)) try {
            var g = b.lastRenderedState, h = f(g, c);
            e.hasEagerState = !0;
            e.eagerState = h;
            if (Ve(h, g)) {
                var k = b.interleaved;
                null === k ? (e.next = e, uh(b)) : (e.next = k.next, k.next = e);
                b.interleaved = e;
                return;
            }
        } catch (l) {} finally{}
        c = vh(a, b, e, d);
        null !== c && (e = Ri(), ui(c, a, d, e), Si(c, b, d));
    }
    yc(a, d);
}
function Pi(a) {
    var b = a.alternate;
    return a === M || null !== b && b === M;
}
function Qi(a, b) {
    Xh = Wh = !0;
    var c = a.pending;
    null === c ? b.next = b : (b.next = c.next, c.next = b);
    a.pending = b;
}
function Si(a, b, c) {
    if (0 !== (c & 4194240)) {
        var d = b.lanes;
        d &= a.pendingLanes;
        c |= d;
        b.lanes = c;
        Oc(a, c);
    }
}
var ei = {
    readContext: sh,
    useCallback: P,
    useContext: P,
    useEffect: P,
    useImperativeHandle: P,
    useInsertionEffect: P,
    useLayoutEffect: P,
    useMemo: P,
    useReducer: P,
    useRef: P,
    useState: P,
    useDebugValue: P,
    useDeferredValue: P,
    useTransition: P,
    useMutableSource: P,
    useSyncExternalStore: P,
    useId: P,
    unstable_isNewReconciler: !1
}, bi = {
    readContext: sh,
    useCallback: function(a, b) {
        gi().memoizedState = [
            a,
            void 0 === b ? null : b
        ];
        return a;
    },
    useContext: sh,
    useEffect: Ci,
    useImperativeHandle: function(a, b, c) {
        c = null !== c && void 0 !== c ? c.concat([
            a
        ]) : null;
        return Ai(4194308, 4, Fi.bind(null, b, a), c);
    },
    useLayoutEffect: function(a, b) {
        return Ai(4194308, 4, a, b);
    },
    useInsertionEffect: function(a, b) {
        return Ai(4, 2, a, b);
    },
    useMemo: function(a, b) {
        var c = gi();
        b = void 0 === b ? null : b;
        a = a();
        c.memoizedState = [
            a,
            b
        ];
        return a;
    },
    useReducer: function(a, b, c) {
        var d = gi();
        b = void 0 !== c ? c(b) : b;
        d.memoizedState = d.baseState = b;
        a = {
            pending: null,
            interleaved: null,
            lanes: 0,
            dispatch: null,
            lastRenderedReducer: a,
            lastRenderedState: b
        };
        d.queue = a;
        a = a.dispatch = Ni.bind(null, M, a);
        return [
            d.memoizedState,
            a
        ];
    },
    useRef: function(a) {
        var b = gi();
        a = {
            current: a
        };
        return b.memoizedState = a;
    },
    useState: vi,
    useDebugValue: Hi,
    useDeferredValue: function(a) {
        return gi().memoizedState = a;
    },
    useTransition: function() {
        var a = vi(!1), b = a[0];
        a = Li.bind(null, a[1]);
        gi().memoizedState = a;
        return [
            b,
            a
        ];
    },
    useMutableSource: function() {},
    useSyncExternalStore: function(a, b, c) {
        var d = M, e = gi();
        if (J) {
            if (void 0 === c) throw Error(p(407));
            c = c();
        } else {
            c = b();
            if (null === Q) throw Error(p(349));
            0 !== (Vh & 30) || ri(d, b, c);
        }
        e.memoizedState = c;
        var f = {
            value: c,
            getSnapshot: b
        };
        e.queue = f;
        Ci(oi.bind(null, d, f, a), [
            a
        ]);
        d.flags |= 2048;
        pi(9, qi.bind(null, d, f, c, b), void 0, null);
        return c;
    },
    useId: function() {
        var a = gi(), b = Q.identifierPrefix;
        if (J) {
            var c = Gg;
            var d = Fg;
            c = (d & ~(1 << 32 - Ac(d) - 1)).toString(32) + c;
            b = ":" + b + "R" + c;
            c = Yh++;
            0 < c && (b += "H" + c.toString(32));
            b += ":";
        } else c = Zh++, b = ":" + b + "r" + c.toString(32) + ":";
        return a.memoizedState = b;
    },
    unstable_isNewReconciler: !1
}, ci = {
    readContext: sh,
    useCallback: Ii,
    useContext: sh,
    useEffect: ni,
    useImperativeHandle: Gi,
    useInsertionEffect: Di,
    useLayoutEffect: Ei,
    useMemo: Ji,
    useReducer: ji,
    useRef: xi,
    useState: function() {
        return ji(ii);
    },
    useDebugValue: Hi,
    useDeferredValue: function(a) {
        var b = hi();
        return Ki(b, N.memoizedState, a);
    },
    useTransition: function() {
        var a = ji(ii)[0], b = hi().memoizedState;
        return [
            a,
            b
        ];
    },
    useMutableSource: li,
    useSyncExternalStore: mi,
    useId: Mi,
    unstable_isNewReconciler: !1
}, di = {
    readContext: sh,
    useCallback: Ii,
    useContext: sh,
    useEffect: ni,
    useImperativeHandle: Gi,
    useInsertionEffect: Di,
    useLayoutEffect: Ei,
    useMemo: Ji,
    useReducer: ki,
    useRef: xi,
    useState: function() {
        return ki(ii);
    },
    useDebugValue: Hi,
    useDeferredValue: function(a) {
        var b = hi();
        return null === N ? b.memoizedState = a : Ki(b, N.memoizedState, a);
    },
    useTransition: function() {
        var a = ki(ii)[0], b = hi().memoizedState;
        return [
            a,
            b
        ];
    },
    useMutableSource: li,
    useSyncExternalStore: mi,
    useId: Mi,
    unstable_isNewReconciler: !1
}, Ti = ba.unstable_now, Ui = 0, Vi = -1, Wi = -1, Xi = -1, Yi = !1, Zi = !1;
function $i(a, b) {
    if (0 <= Wi) {
        var c = Ti() - Wi;
        a.actualDuration += c;
        b && (a.selfBaseDuration = c);
        Wi = -1;
    }
}
function aj(a) {
    if (0 <= Vi) {
        var b = Ti() - Vi;
        Vi = -1;
        for(a = a.return; null !== a;){
            switch(a.tag){
                case 3:
                    a.stateNode.effectDuration += b;
                    return;
                case 12:
                    a.stateNode.effectDuration += b;
                    return;
            }
            a = a.return;
        }
    }
}
function bj(a) {
    if (0 <= Xi) {
        var b = Ti() - Xi;
        Xi = -1;
        for(a = a.return; null !== a;){
            switch(a.tag){
                case 3:
                    a = a.stateNode;
                    null !== a && (a.passiveEffectDuration += b);
                    return;
                case 12:
                    a = a.stateNode;
                    null !== a && (a.passiveEffectDuration += b);
                    return;
            }
            a = a.return;
        }
    }
}
function cj() {
    Vi = Ti();
}
function dj(a) {
    for(var b = a.child; b;)a.actualDuration += b.actualDuration, b = b.sibling;
}
function ej(a, b) {
    if (a && a.defaultProps) {
        b = u({}, b);
        a = a.defaultProps;
        for(var c in a)void 0 === b[c] && (b[c] = a[c]);
        return b;
    }
    return b;
}
function fj(a, b, c, d) {
    b = a.memoizedState;
    c = c(d, b);
    c = null === c || void 0 === c ? b : u({}, b, c);
    a.memoizedState = c;
    0 === a.lanes && (a.updateQueue.baseState = c);
}
var gj = {
    isMounted: function(a) {
        return (a = a._reactInternals) ? Vb(a) === a : !1;
    },
    enqueueSetState: function(a, b, c) {
        a = a._reactInternals;
        var d = Ri(), e = Oi(a), f = Ah(d, e);
        f.payload = b;
        void 0 !== c && null !== c && (f.callback = c);
        b = Bh(a, f, e);
        null !== b && (ui(b, a, e, d), Ch(b, a, e));
        yc(a, e);
    },
    enqueueReplaceState: function(a, b, c) {
        a = a._reactInternals;
        var d = Ri(), e = Oi(a), f = Ah(d, e);
        f.tag = 1;
        f.payload = b;
        void 0 !== c && null !== c && (f.callback = c);
        b = Bh(a, f, e);
        null !== b && (ui(b, a, e, d), Ch(b, a, e));
        yc(a, e);
    },
    enqueueForceUpdate: function(a, b) {
        a = a._reactInternals;
        var c = Ri(), d = Oi(a), e = Ah(c, d);
        e.tag = 2;
        void 0 !== b && null !== b && (e.callback = b);
        b = Bh(a, e, d);
        null !== b && (ui(b, a, d, c), Ch(b, a, d));
        null !== B && "function" === typeof B.markForceUpdateScheduled && B.markForceUpdateScheduled(a, d);
    }
};
function hj(a, b, c, d, e, f, g) {
    a = a.stateNode;
    return "function" === typeof a.shouldComponentUpdate ? a.shouldComponentUpdate(d, f, g) : b.prototype && b.prototype.isPureReactComponent ? !We(c, d) || !We(e, f) : !0;
}
function ij(a, b, c) {
    var d = !1, e = ig;
    var f = b.contextType;
    "object" === typeof f && null !== f ? f = sh(f) : (e = mg(b) ? kg : I.current, d = b.contextTypes, f = (d = null !== d && void 0 !== d) ? lg(a, e) : ig);
    b = new b(c, f);
    a.memoizedState = null !== b.state && void 0 !== b.state ? b.state : null;
    b.updater = gj;
    a.stateNode = b;
    b._reactInternals = a;
    d && (a = a.stateNode, a.__reactInternalMemoizedUnmaskedChildContext = e, a.__reactInternalMemoizedMaskedChildContext = f);
    return b;
}
function jj(a, b, c, d) {
    a = b.state;
    "function" === typeof b.componentWillReceiveProps && b.componentWillReceiveProps(c, d);
    "function" === typeof b.UNSAFE_componentWillReceiveProps && b.UNSAFE_componentWillReceiveProps(c, d);
    b.state !== a && gj.enqueueReplaceState(b, b.state, null);
}
function kj(a, b, c, d) {
    var e = a.stateNode;
    e.props = c;
    e.state = a.memoizedState;
    e.refs = {};
    yh(a);
    var f = b.contextType;
    "object" === typeof f && null !== f ? e.context = sh(f) : (f = mg(b) ? kg : I.current, e.context = lg(a, f));
    e.state = a.memoizedState;
    f = b.getDerivedStateFromProps;
    "function" === typeof f && (fj(a, b, f, c), e.state = a.memoizedState);
    "function" === typeof b.getDerivedStateFromProps || "function" === typeof e.getSnapshotBeforeUpdate || "function" !== typeof e.UNSAFE_componentWillMount && "function" !== typeof e.componentWillMount || (b = e.state, "function" === typeof e.componentWillMount && e.componentWillMount(), "function" === typeof e.UNSAFE_componentWillMount && e.UNSAFE_componentWillMount(), b !== e.state && gj.enqueueReplaceState(e, e.state, null), Eh(a, c, e, d), e.state = a.memoizedState);
    "function" === typeof e.componentDidMount && (a.flags |= 4194308);
}
function lj(a, b) {
    try {
        var c = "", d = b;
        do c += Pa(d), d = d.return;
        while (d);
        var e = c;
    } catch (f) {
        e = "\nError generating stack: " + f.message + "\n" + f.stack;
    }
    return {
        value: a,
        source: b,
        stack: e,
        digest: null
    };
}
function mj(a, b, c) {
    return {
        value: a,
        source: null,
        stack: null != c ? c : null,
        digest: null != b ? b : null
    };
}
function nj(a, b) {
    try {
        console.error(b.value);
    } catch (c) {
        setTimeout(function() {
            throw c;
        });
    }
}
var oj = "function" === typeof WeakMap ? WeakMap : Map;
function pj(a, b, c) {
    c = Ah(-1, c);
    c.tag = 3;
    c.payload = {
        element: null
    };
    var d = b.value;
    c.callback = function() {
        qj || (qj = !0, rj = d);
        nj(a, b);
    };
    return c;
}
function sj(a, b, c) {
    c = Ah(-1, c);
    c.tag = 3;
    var d = a.type.getDerivedStateFromError;
    if ("function" === typeof d) {
        var e = b.value;
        c.payload = function() {
            return d(e);
        };
        c.callback = function() {
            nj(a, b);
        };
    }
    var f = a.stateNode;
    null !== f && "function" === typeof f.componentDidCatch && (c.callback = function() {
        nj(a, b);
        "function" !== typeof d && (null === tj ? tj = new Set([
            this
        ]) : tj.add(this));
        var c = b.stack;
        this.componentDidCatch(b.value, {
            componentStack: null !== c ? c : ""
        });
    });
    return c;
}
function uj(a, b, c) {
    var d = a.pingCache;
    if (null === d) {
        d = a.pingCache = new oj;
        var e = new Set;
        d.set(b, e);
    } else e = d.get(b), void 0 === e && (e = new Set, d.set(b, e));
    e.has(c) || (e.add(c), d = vj.bind(null, a, b, c), mc && wj(a, c), b.then(d, d));
}
function xj(a) {
    do {
        var b;
        if (b = 13 === a.tag) b = a.memoizedState, b = null !== b ? null !== b.dehydrated ? !0 : !1 : !0;
        if (b) return a;
        a = a.return;
    }while (null !== a);
    return null;
}
function yj(a, b, c, d, e) {
    if (0 === (a.mode & 1)) return a === b ? a.flags |= 65536 : (a.flags |= 128, c.flags |= 131072, c.flags &= -52805, 1 === c.tag && (null === c.alternate ? c.tag = 17 : (b = Ah(-1, 1), b.tag = 2, Bh(c, b, 1))), c.lanes |= 1), a;
    a.flags |= 65536;
    a.lanes = e;
    return a;
}
var zj = va.ReactCurrentOwner, rh = !1;
function Aj(a, b, c, d) {
    b.child = null === a ? ih(b, null, c, d) : hh(b, a.child, c, d);
}
function Bj(a, b, c, d, e) {
    c = c.render;
    var f = b.ref;
    qh(b, e);
    sc(b);
    d = ai(a, b, c, d, f, e);
    c = fi();
    tc();
    if (null !== a && !rh) return b.updateQueue = a.updateQueue, b.flags &= -2053, a.lanes &= ~e, Cj(a, b, e);
    J && c && Jg(b);
    b.flags |= 1;
    Aj(a, b, d, e);
    return b.child;
}
function Dj(a, b, c, d, e) {
    if (null === a) {
        var f = c.type;
        if ("function" === typeof f && !Ej(f) && void 0 === f.defaultProps && null === c.compare && void 0 === c.defaultProps) return b.tag = 15, b.type = f, Fj(a, b, f, d, e);
        a = eh(c.type, null, d, b, b.mode, e);
        a.ref = b.ref;
        a.return = b;
        return b.child = a;
    }
    f = a.child;
    if (0 === (a.lanes & e)) {
        var g = f.memoizedProps;
        c = c.compare;
        c = null !== c ? c : We;
        if (c(g, d) && a.ref === b.ref) return Cj(a, b, e);
    }
    b.flags |= 1;
    a = ch(f, d);
    a.ref = b.ref;
    a.return = b;
    return b.child = a;
}
function Fj(a, b, c, d, e) {
    if (null !== a) {
        var f = a.memoizedProps;
        if (We(f, d) && a.ref === b.ref) {
            if (rh = !1, b.pendingProps = d = f, 0 !== (a.lanes & e)) 0 !== (a.flags & 131072) && (rh = !0);
            else return b.lanes = a.lanes, Cj(a, b, e);
        }
    }
    return Gj(a, b, c, d, e);
}
function Hj(a, b, c) {
    var d = b.pendingProps, e = d.children, f = null !== a ? a.memoizedState : null;
    if ("hidden" === d.mode) {
        if (0 === (b.mode & 1)) b.memoizedState = {
            baseLanes: 0,
            cachePool: null,
            transitions: null
        }, H(Ij, Jj), Jj |= c;
        else {
            if (0 === (c & 1073741824)) return a = null !== f ? f.baseLanes | c : c, b.lanes = b.childLanes = 1073741824, b.memoizedState = {
                baseLanes: a,
                cachePool: null,
                transitions: null
            }, b.updateQueue = null, H(Ij, Jj), Jj |= a, null;
            b.memoizedState = {
                baseLanes: 0,
                cachePool: null,
                transitions: null
            };
            d = null !== f ? f.baseLanes : c;
            H(Ij, Jj);
            Jj |= d;
        }
    } else null !== f ? (d = f.baseLanes | c, b.memoizedState = null) : d = c, H(Ij, Jj), Jj |= d;
    Aj(a, b, e, c);
    return b.child;
}
function Kj(a, b) {
    var c = b.ref;
    if (null === a && null !== c || null !== a && a.ref !== c) b.flags |= 512, b.flags |= 2097152;
}
function Gj(a, b, c, d, e) {
    var f = mg(c) ? kg : I.current;
    f = lg(b, f);
    qh(b, e);
    sc(b);
    c = ai(a, b, c, d, f, e);
    d = fi();
    tc();
    if (null !== a && !rh) return b.updateQueue = a.updateQueue, b.flags &= -2053, a.lanes &= ~e, Cj(a, b, e);
    J && d && Jg(b);
    b.flags |= 1;
    Aj(a, b, c, e);
    return b.child;
}
function Lj(a, b, c, d, e) {
    if (mg(c)) {
        var f = !0;
        qg(b);
    } else f = !1;
    qh(b, e);
    if (null === b.stateNode) Mj(a, b), ij(b, c, d), kj(b, c, d, e), d = !0;
    else if (null === a) {
        var g = b.stateNode, h = b.memoizedProps;
        g.props = h;
        var k = g.context, l = c.contextType;
        "object" === typeof l && null !== l ? l = sh(l) : (l = mg(c) ? kg : I.current, l = lg(b, l));
        var n = c.getDerivedStateFromProps, q = "function" === typeof n || "function" === typeof g.getSnapshotBeforeUpdate;
        q || "function" !== typeof g.UNSAFE_componentWillReceiveProps && "function" !== typeof g.componentWillReceiveProps || (h !== d || k !== l) && jj(b, g, d, l);
        xh = !1;
        var r = b.memoizedState;
        g.state = r;
        Eh(b, d, g, e);
        k = b.memoizedState;
        h !== d || r !== k || jg.current || xh ? ("function" === typeof n && (fj(b, c, n, d), k = b.memoizedState), (h = xh || hj(b, c, h, d, r, k, l)) ? (q || "function" !== typeof g.UNSAFE_componentWillMount && "function" !== typeof g.componentWillMount || ("function" === typeof g.componentWillMount && g.componentWillMount(), "function" === typeof g.UNSAFE_componentWillMount && g.UNSAFE_componentWillMount()), "function" === typeof g.componentDidMount && (b.flags |= 4194308)) : ("function" === typeof g.componentDidMount && (b.flags |= 4194308), b.memoizedProps = d, b.memoizedState = k), g.props = d, g.state = k, g.context = l, d = h) : ("function" === typeof g.componentDidMount && (b.flags |= 4194308), d = !1);
    } else {
        g = b.stateNode;
        zh(a, b);
        h = b.memoizedProps;
        l = b.type === b.elementType ? h : ej(b.type, h);
        g.props = l;
        q = b.pendingProps;
        r = g.context;
        k = c.contextType;
        "object" === typeof k && null !== k ? k = sh(k) : (k = mg(c) ? kg : I.current, k = lg(b, k));
        var z = c.getDerivedStateFromProps;
        (n = "function" === typeof z || "function" === typeof g.getSnapshotBeforeUpdate) || "function" !== typeof g.UNSAFE_componentWillReceiveProps && "function" !== typeof g.componentWillReceiveProps || (h !== q || r !== k) && jj(b, g, d, k);
        xh = !1;
        r = b.memoizedState;
        g.state = r;
        Eh(b, d, g, e);
        var m = b.memoizedState;
        h !== q || r !== m || jg.current || xh ? ("function" === typeof z && (fj(b, c, z, d), m = b.memoizedState), (l = xh || hj(b, c, l, d, r, m, k) || !1) ? (n || "function" !== typeof g.UNSAFE_componentWillUpdate && "function" !== typeof g.componentWillUpdate || ("function" === typeof g.componentWillUpdate && g.componentWillUpdate(d, m, k), "function" === typeof g.UNSAFE_componentWillUpdate && g.UNSAFE_componentWillUpdate(d, m, k)), "function" === typeof g.componentDidUpdate && (b.flags |= 4), "function" === typeof g.getSnapshotBeforeUpdate && (b.flags |= 1024)) : ("function" !== typeof g.componentDidUpdate || h === a.memoizedProps && r === a.memoizedState || (b.flags |= 4), "function" !== typeof g.getSnapshotBeforeUpdate || h === a.memoizedProps && r === a.memoizedState || (b.flags |= 1024), b.memoizedProps = d, b.memoizedState = m), g.props = d, g.state = m, g.context = k, d = l) : ("function" !== typeof g.componentDidUpdate || h === a.memoizedProps && r === a.memoizedState || (b.flags |= 4), "function" !== typeof g.getSnapshotBeforeUpdate || h === a.memoizedProps && r === a.memoizedState || (b.flags |= 1024), d = !1);
    }
    return Nj(a, b, c, d, f, e);
}
function Nj(a, b, c, d, e, f) {
    Kj(a, b);
    var g = 0 !== (b.flags & 128);
    if (!d && !g) return e && rg(b, c, !1), Cj(a, b, f);
    d = b.stateNode;
    zj.current = b;
    if (g && "function" !== typeof c.getDerivedStateFromError) {
        var h = null;
        Wi = -1;
    } else sc(b), h = d.render(), tc();
    b.flags |= 1;
    null !== a && g ? (g = h, b.child = hh(b, a.child, null, f), b.child = hh(b, null, g, f)) : Aj(a, b, h, f);
    b.memoizedState = d.state;
    e && rg(b, c, !0);
    return b.child;
}
function Oj(a) {
    var b = a.stateNode;
    b.pendingContext ? og(a, b.pendingContext, b.pendingContext !== b.context) : b.context && og(a, b.context, !1);
    Mh(a, b.containerInfo);
}
function Rj(a, b, c, d, e) {
    Wg();
    Xg(e);
    b.flags |= 256;
    Aj(a, b, c, d);
    return b.child;
}
var Sj = {
    dehydrated: null,
    treeContext: null,
    retryLane: 0
};
function Tj(a) {
    return {
        baseLanes: a,
        cachePool: null,
        transitions: null
    };
}
function Uj(a, b, c) {
    var d = b.pendingProps, e = L.current, f = !1, g = 0 !== (b.flags & 128), h;
    (h = g) || (h = null !== a && null === a.memoizedState ? !1 : 0 !== (e & 2));
    if (h) f = !0, b.flags &= -129;
    else if (null === a || null !== a.memoizedState) e |= 1;
    H(L, e & 1);
    if (null === a) {
        Sg(b);
        a = b.memoizedState;
        if (null !== a && (a = a.dehydrated, null !== a)) return 0 === (b.mode & 1) ? b.lanes = 1 : "$!" === a.data ? b.lanes = 8 : b.lanes = 1073741824, null;
        g = d.children;
        a = d.fallback;
        return f ? (d = b.mode, f = b.child, g = {
            mode: "hidden",
            children: g
        }, 0 === (d & 1) && null !== f ? (f.childLanes = 0, f.pendingProps = g, b.mode & 2 && (f.actualDuration = 0, f.actualStartTime = -1, f.selfBaseDuration = 0, f.treeBaseDuration = 0)) : f = Vj(g, d, 0, null), a = gh(a, d, c, null), f.return = b, a.return = b, f.sibling = a, b.child = f, b.child.memoizedState = Tj(c), b.memoizedState = Sj, a) : Wj(b, g);
    }
    e = a.memoizedState;
    if (null !== e && (h = e.dehydrated, null !== h)) return Xj(a, b, g, d, h, e, c);
    if (f) {
        f = d.fallback;
        g = b.mode;
        e = a.child;
        h = e.sibling;
        var k = {
            mode: "hidden",
            children: d.children
        };
        0 === (g & 1) && b.child !== e ? (d = b.child, d.childLanes = 0, d.pendingProps = k, b.mode & 2 && (d.actualDuration = 0, d.actualStartTime = -1, d.selfBaseDuration = e.selfBaseDuration, d.treeBaseDuration = e.treeBaseDuration), b.deletions = null) : (d = ch(e, k), d.subtreeFlags = e.subtreeFlags & 14680064);
        null !== h ? f = ch(h, f) : (f = gh(f, g, c, null), f.flags |= 2);
        f.return = b;
        d.return = b;
        d.sibling = f;
        b.child = d;
        d = f;
        f = b.child;
        g = a.child.memoizedState;
        g = null === g ? Tj(c) : {
            baseLanes: g.baseLanes | c,
            cachePool: null,
            transitions: g.transitions
        };
        f.memoizedState = g;
        f.childLanes = a.childLanes & ~c;
        b.memoizedState = Sj;
        return d;
    }
    f = a.child;
    a = f.sibling;
    d = ch(f, {
        mode: "visible",
        children: d.children
    });
    0 === (b.mode & 1) && (d.lanes = c);
    d.return = b;
    d.sibling = null;
    null !== a && (c = b.deletions, null === c ? (b.deletions = [
        a
    ], b.flags |= 16) : c.push(a));
    b.child = d;
    b.memoizedState = null;
    return d;
}
function Wj(a, b) {
    b = Vj({
        mode: "visible",
        children: b
    }, a.mode, 0, null);
    b.return = a;
    return a.child = b;
}
function Yj(a, b, c, d) {
    null !== d && Xg(d);
    hh(b, a.child, null, c);
    a = Wj(b, b.pendingProps.children);
    a.flags |= 2;
    b.memoizedState = null;
    return a;
}
function Xj(a, b, c, d, e, f, g) {
    if (c) {
        if (b.flags & 256) return b.flags &= -257, d = mj(Error(p(422))), Yj(a, b, g, d);
        if (null !== b.memoizedState) return b.child = a.child, b.flags |= 128, null;
        f = d.fallback;
        e = b.mode;
        d = Vj({
            mode: "visible",
            children: d.children
        }, e, 0, null);
        f = gh(f, e, g, null);
        f.flags |= 2;
        d.return = b;
        f.return = b;
        d.sibling = f;
        b.child = d;
        0 !== (b.mode & 1) && hh(b, a.child, null, g);
        b.child.memoizedState = Tj(g);
        b.memoizedState = Sj;
        return f;
    }
    if (0 === (b.mode & 1)) return Yj(a, b, g, null);
    if ("$!" === e.data) {
        d = e.nextSibling && e.nextSibling.dataset;
        if (d) var h = d.dgst;
        d = h;
        f = Error(p(419));
        d = mj(f, d, void 0);
        return Yj(a, b, g, d);
    }
    h = 0 !== (g & a.childLanes);
    if (rh || h) {
        d = Q;
        if (null !== d) {
            switch(g & -g){
                case 4:
                    e = 2;
                    break;
                case 16:
                    e = 8;
                    break;
                case 64:
                case 128:
                case 256:
                case 512:
                case 1024:
                case 2048:
                case 4096:
                case 8192:
                case 16384:
                case 32768:
                case 65536:
                case 131072:
                case 262144:
                case 524288:
                case 1048576:
                case 2097152:
                case 4194304:
                case 8388608:
                case 16777216:
                case 33554432:
                case 67108864:
                    e = 32;
                    break;
                case 536870912:
                    e = 268435456;
                    break;
                default:
                    e = 0;
            }
            e = 0 !== (e & (d.suspendedLanes | g)) ? 0 : e;
            0 !== e && e !== f.retryLane && (f.retryLane = e, wh(a, e), ui(d, a, e, -1));
        }
        Zj();
        d = mj(Error(p(421)));
        return Yj(a, b, g, d);
    }
    if ("$?" === e.data) return b.flags |= 128, b.child = a.child, b = ak.bind(null, a), e._reactRetry = b, null;
    a = f.treeContext;
    Mg = Zf(e.nextSibling);
    Lg = b;
    J = !0;
    Ng = null;
    null !== a && (Cg[Dg++] = Fg, Cg[Dg++] = Gg, Cg[Dg++] = Eg, Fg = a.id, Gg = a.overflow, Eg = b);
    b = Wj(b, d.children);
    b.flags |= 4096;
    return b;
}
function bk(a, b, c) {
    a.lanes |= b;
    var d = a.alternate;
    null !== d && (d.lanes |= b);
    ph(a.return, b, c);
}
function ck(a, b, c, d, e) {
    var f = a.memoizedState;
    null === f ? a.memoizedState = {
        isBackwards: b,
        rendering: null,
        renderingStartTime: 0,
        last: d,
        tail: c,
        tailMode: e
    } : (f.isBackwards = b, f.rendering = null, f.renderingStartTime = 0, f.last = d, f.tail = c, f.tailMode = e);
}
function dk(a, b, c) {
    var d = b.pendingProps, e = d.revealOrder, f = d.tail;
    Aj(a, b, d.children, c);
    d = L.current;
    if (0 !== (d & 2)) d = d & 1 | 2, b.flags |= 128;
    else {
        if (null !== a && 0 !== (a.flags & 128)) a: for(a = b.child; null !== a;){
            if (13 === a.tag) null !== a.memoizedState && bk(a, c, b);
            else if (19 === a.tag) bk(a, c, b);
            else if (null !== a.child) {
                a.child.return = a;
                a = a.child;
                continue;
            }
            if (a === b) break a;
            for(; null === a.sibling;){
                if (null === a.return || a.return === b) break a;
                a = a.return;
            }
            a.sibling.return = a.return;
            a = a.sibling;
        }
        d &= 1;
    }
    H(L, d);
    if (0 === (b.mode & 1)) b.memoizedState = null;
    else switch(e){
        case "forwards":
            c = b.child;
            for(e = null; null !== c;)a = c.alternate, null !== a && null === Qh(a) && (e = c), c = c.sibling;
            c = e;
            null === c ? (e = b.child, b.child = null) : (e = c.sibling, c.sibling = null);
            ck(b, !1, e, c, f);
            break;
        case "backwards":
            c = null;
            e = b.child;
            for(b.child = null; null !== e;){
                a = e.alternate;
                if (null !== a && null === Qh(a)) {
                    b.child = e;
                    break;
                }
                a = e.sibling;
                e.sibling = c;
                c = e;
                e = a;
            }
            ck(b, !0, c, null, f);
            break;
        case "together":
            ck(b, !1, null, null, void 0);
            break;
        default:
            b.memoizedState = null;
    }
    return b.child;
}
function Mj(a, b) {
    0 === (b.mode & 1) && null !== a && (a.alternate = null, b.alternate = null, b.flags |= 2);
}
function Cj(a, b, c) {
    null !== a && (b.dependencies = a.dependencies);
    Wi = -1;
    Fh |= b.lanes;
    if (0 === (c & b.childLanes)) return null;
    if (null !== a && b.child !== a.child) throw Error(p(153));
    if (null !== b.child) {
        a = b.child;
        c = ch(a, a.pendingProps);
        b.child = c;
        for(c.return = b; null !== a.sibling;)a = a.sibling, c = c.sibling = ch(a, a.pendingProps), c.return = b;
        c.sibling = null;
    }
    return b.child;
}
function ek(a, b, c) {
    switch(b.tag){
        case 3:
            Oj(b);
            Wg();
            break;
        case 5:
            Oh(b);
            break;
        case 1:
            mg(b.type) && qg(b);
            break;
        case 4:
            Mh(b, b.stateNode.containerInfo);
            break;
        case 10:
            var d = b.type._context, e = b.memoizedProps.value;
            H(jh, d._currentValue);
            d._currentValue = e;
            break;
        case 12:
            0 !== (c & b.childLanes) && (b.flags |= 4);
            d = b.stateNode;
            d.effectDuration = 0;
            d.passiveEffectDuration = 0;
            break;
        case 13:
            d = b.memoizedState;
            if (null !== d) {
                if (null !== d.dehydrated) return H(L, L.current & 1), b.flags |= 128, null;
                if (0 !== (c & b.child.childLanes)) return Uj(a, b, c);
                H(L, L.current & 1);
                a = Cj(a, b, c);
                return null !== a ? a.sibling : null;
            }
            H(L, L.current & 1);
            break;
        case 19:
            d = 0 !== (c & b.childLanes);
            if (0 !== (a.flags & 128)) {
                if (d) return dk(a, b, c);
                b.flags |= 128;
            }
            e = b.memoizedState;
            null !== e && (e.rendering = null, e.tail = null, e.lastEffect = null);
            H(L, L.current);
            if (d) break;
            else return null;
        case 22:
        case 23:
            return b.lanes = 0, Hj(a, b, c);
    }
    return Cj(a, b, c);
}
var fk, gk, hk, ik;
fk = function(a, b) {
    for(var c = b.child; null !== c;){
        if (5 === c.tag || 6 === c.tag) a.appendChild(c.stateNode);
        else if (4 !== c.tag && null !== c.child) {
            c.child.return = c;
            c = c.child;
            continue;
        }
        if (c === b) break;
        for(; null === c.sibling;){
            if (null === c.return || c.return === b) return;
            c = c.return;
        }
        c.sibling.return = c.return;
        c = c.sibling;
    }
};
gk = function() {};
hk = function(a, b, c, d) {
    var e = a.memoizedProps;
    if (e !== d) {
        a = b.stateNode;
        Lh(Ih.current);
        var f = null;
        switch(c){
            case "input":
                e = Ya(a, e);
                d = Ya(a, d);
                f = [];
                break;
            case "select":
                e = u({}, e, {
                    value: void 0
                });
                d = u({}, d, {
                    value: void 0
                });
                f = [];
                break;
            case "textarea":
                e = fb(a, e);
                d = fb(a, d);
                f = [];
                break;
            default:
                "function" !== typeof e.onClick && "function" === typeof d.onClick && (a.onclick = Pf);
        }
        ub(c, d);
        var g;
        c = null;
        for(l in e)if (!d.hasOwnProperty(l) && e.hasOwnProperty(l) && null != e[l]) {
            if ("style" === l) {
                var h = e[l];
                for(g in h)h.hasOwnProperty(g) && (c || (c = {}), c[g] = "");
            } else "dangerouslySetInnerHTML" !== l && "children" !== l && "suppressContentEditableWarning" !== l && "suppressHydrationWarning" !== l && "autoFocus" !== l && (ea.hasOwnProperty(l) ? f || (f = []) : (f = f || []).push(l, null));
        }
        for(l in d){
            var k = d[l];
            h = null != e ? e[l] : void 0;
            if (d.hasOwnProperty(l) && k !== h && (null != k || null != h)) {
                if ("style" === l) {
                    if (h) {
                        for(g in h)!h.hasOwnProperty(g) || k && k.hasOwnProperty(g) || (c || (c = {}), c[g] = "");
                        for(g in k)k.hasOwnProperty(g) && h[g] !== k[g] && (c || (c = {}), c[g] = k[g]);
                    } else c || (f || (f = []), f.push(l, c)), c = k;
                } else "dangerouslySetInnerHTML" === l ? (k = k ? k.__html : void 0, h = h ? h.__html : void 0, null != k && h !== k && (f = f || []).push(l, k)) : "children" === l ? "string" !== typeof k && "number" !== typeof k || (f = f || []).push(l, "" + k) : "suppressContentEditableWarning" !== l && "suppressHydrationWarning" !== l && (ea.hasOwnProperty(l) ? (null != k && "onScroll" === l && F("scroll", a), f || h === k || (f = [])) : (f = f || []).push(l, k));
            }
        }
        c && (f = f || []).push("style", c);
        var l = f;
        if (b.updateQueue = l) b.flags |= 4;
    }
};
ik = function(a, b, c, d) {
    c !== d && (b.flags |= 4);
};
function jk(a, b) {
    if (!J) switch(a.tailMode){
        case "hidden":
            b = a.tail;
            for(var c = null; null !== b;)null !== b.alternate && (c = b), b = b.sibling;
            null === c ? a.tail = null : c.sibling = null;
            break;
        case "collapsed":
            c = a.tail;
            for(var d = null; null !== c;)null !== c.alternate && (d = c), c = c.sibling;
            null === d ? b || null === a.tail ? a.tail = null : a.tail.sibling = null : d.sibling = null;
    }
}
function S(a) {
    var b = null !== a.alternate && a.alternate.child === a.child, c = 0, d = 0;
    if (b) {
        if (0 !== (a.mode & 2)) {
            for(var e = a.selfBaseDuration, f = a.child; null !== f;)c |= f.lanes | f.childLanes, d |= f.subtreeFlags & 14680064, d |= f.flags & 14680064, e += f.treeBaseDuration, f = f.sibling;
            a.treeBaseDuration = e;
        } else for(e = a.child; null !== e;)c |= e.lanes | e.childLanes, d |= e.subtreeFlags & 14680064, d |= e.flags & 14680064, e.return = a, e = e.sibling;
    } else if (0 !== (a.mode & 2)) {
        e = a.actualDuration;
        f = a.selfBaseDuration;
        for(var g = a.child; null !== g;)c |= g.lanes | g.childLanes, d |= g.subtreeFlags, d |= g.flags, e += g.actualDuration, f += g.treeBaseDuration, g = g.sibling;
        a.actualDuration = e;
        a.treeBaseDuration = f;
    } else for(e = a.child; null !== e;)c |= e.lanes | e.childLanes, d |= e.subtreeFlags, d |= e.flags, e.return = a, e = e.sibling;
    a.subtreeFlags |= d;
    a.childLanes = c;
    return b;
}
function kk(a, b, c) {
    var d = b.pendingProps;
    Kg(b);
    switch(b.tag){
        case 2:
        case 16:
        case 15:
        case 0:
        case 11:
        case 7:
        case 8:
        case 12:
        case 9:
        case 14:
            return S(b), null;
        case 1:
            return mg(b.type) && ng(), S(b), null;
        case 3:
            d = b.stateNode;
            Nh();
            G(jg);
            G(I);
            Sh();
            d.pendingContext && (d.context = d.pendingContext, d.pendingContext = null);
            if (null === a || null === a.child) Ug(b) ? b.flags |= 4 : null === a || a.memoizedState.isDehydrated && 0 === (b.flags & 256) || (b.flags |= 1024, null !== Ng && (lk(Ng), Ng = null));
            gk(a, b);
            S(b);
            return null;
        case 5:
            Ph(b);
            var e = Lh(Kh.current);
            c = b.type;
            if (null !== a && null != b.stateNode) hk(a, b, c, d, e), a.ref !== b.ref && (b.flags |= 512, b.flags |= 2097152);
            else {
                if (!d) {
                    if (null === b.stateNode) throw Error(p(166));
                    S(b);
                    return null;
                }
                a = Lh(Ih.current);
                if (Ug(b)) {
                    d = b.stateNode;
                    a = b.type;
                    c = b.memoizedProps;
                    d[bg] = b;
                    d[cg] = c;
                    var f = 0 !== (b.mode & 1);
                    switch(a){
                        case "dialog":
                            F("cancel", d);
                            F("close", d);
                            break;
                        case "iframe":
                        case "object":
                        case "embed":
                            F("load", d);
                            break;
                        case "video":
                        case "audio":
                            for(e = 0; e < zf.length; e++)F(zf[e], d);
                            break;
                        case "source":
                            F("error", d);
                            break;
                        case "img":
                        case "image":
                        case "link":
                            F("error", d);
                            F("load", d);
                            break;
                        case "details":
                            F("toggle", d);
                            break;
                        case "input":
                            Za(d, c);
                            F("invalid", d);
                            break;
                        case "select":
                            d._wrapperState = {
                                wasMultiple: !!c.multiple
                            };
                            F("invalid", d);
                            break;
                        case "textarea":
                            gb(d, c), F("invalid", d);
                    }
                    ub(a, c);
                    e = null;
                    for(var g in c)if (c.hasOwnProperty(g)) {
                        var h = c[g];
                        "children" === g ? "string" === typeof h ? d.textContent !== h && (!0 !== c.suppressHydrationWarning && Of(d.textContent, h, f), e = [
                            "children",
                            h
                        ]) : "number" === typeof h && d.textContent !== "" + h && (!0 !== c.suppressHydrationWarning && Of(d.textContent, h, f), e = [
                            "children",
                            "" + h
                        ]) : ea.hasOwnProperty(g) && null != h && "onScroll" === g && F("scroll", d);
                    }
                    switch(a){
                        case "input":
                            Va(d);
                            cb(d, c, !0);
                            break;
                        case "textarea":
                            Va(d);
                            ib(d);
                            break;
                        case "select":
                        case "option":
                            break;
                        default:
                            "function" === typeof c.onClick && (d.onclick = Pf);
                    }
                    d = e;
                    b.updateQueue = d;
                    null !== d && (b.flags |= 4);
                } else {
                    g = 9 === e.nodeType ? e : e.ownerDocument;
                    "http://www.w3.org/1999/xhtml" === a && (a = jb(c));
                    "http://www.w3.org/1999/xhtml" === a ? "script" === c ? (a = g.createElement("div"), a.innerHTML = "<script>\x3c/script>", a = a.removeChild(a.firstChild)) : "string" === typeof d.is ? a = g.createElement(c, {
                        is: d.is
                    }) : (a = g.createElement(c), "select" === c && (g = a, d.multiple ? g.multiple = !0 : d.size && (g.size = d.size))) : a = g.createElementNS(a, c);
                    a[bg] = b;
                    a[cg] = d;
                    fk(a, b, !1, !1);
                    b.stateNode = a;
                    a: {
                        g = vb(c, d);
                        switch(c){
                            case "dialog":
                                F("cancel", a);
                                F("close", a);
                                e = d;
                                break;
                            case "iframe":
                            case "object":
                            case "embed":
                                F("load", a);
                                e = d;
                                break;
                            case "video":
                            case "audio":
                                for(e = 0; e < zf.length; e++)F(zf[e], a);
                                e = d;
                                break;
                            case "source":
                                F("error", a);
                                e = d;
                                break;
                            case "img":
                            case "image":
                            case "link":
                                F("error", a);
                                F("load", a);
                                e = d;
                                break;
                            case "details":
                                F("toggle", a);
                                e = d;
                                break;
                            case "input":
                                Za(a, d);
                                e = Ya(a, d);
                                F("invalid", a);
                                break;
                            case "option":
                                e = d;
                                break;
                            case "select":
                                a._wrapperState = {
                                    wasMultiple: !!d.multiple
                                };
                                e = u({}, d, {
                                    value: void 0
                                });
                                F("invalid", a);
                                break;
                            case "textarea":
                                gb(a, d);
                                e = fb(a, d);
                                F("invalid", a);
                                break;
                            default:
                                e = d;
                        }
                        ub(c, e);
                        h = e;
                        for(f in h)if (h.hasOwnProperty(f)) {
                            var k = h[f];
                            "style" === f ? sb(a, k) : "dangerouslySetInnerHTML" === f ? (k = k ? k.__html : void 0, null != k && nb(a, k)) : "children" === f ? "string" === typeof k ? ("textarea" !== c || "" !== k) && ob(a, k) : "number" === typeof k && ob(a, "" + k) : "suppressContentEditableWarning" !== f && "suppressHydrationWarning" !== f && "autoFocus" !== f && (ea.hasOwnProperty(f) ? null != k && "onScroll" === f && F("scroll", a) : null != k && ua(a, f, k, g));
                        }
                        switch(c){
                            case "input":
                                Va(a);
                                cb(a, d, !1);
                                break;
                            case "textarea":
                                Va(a);
                                ib(a);
                                break;
                            case "option":
                                null != d.value && a.setAttribute("value", "" + Sa(d.value));
                                break;
                            case "select":
                                a.multiple = !!d.multiple;
                                f = d.value;
                                null != f ? eb(a, !!d.multiple, f, !1) : null != d.defaultValue && eb(a, !!d.multiple, d.defaultValue, !0);
                                break;
                            default:
                                "function" === typeof e.onClick && (a.onclick = Pf);
                        }
                        switch(c){
                            case "button":
                            case "input":
                            case "select":
                            case "textarea":
                                d = !!d.autoFocus;
                                break a;
                            case "img":
                                d = !0;
                                break a;
                            default:
                                d = !1;
                        }
                    }
                    d && (b.flags |= 4);
                }
                null !== b.ref && (b.flags |= 512, b.flags |= 2097152);
            }
            S(b);
            return null;
        case 6:
            if (a && null != b.stateNode) ik(a, b, a.memoizedProps, d);
            else {
                if ("string" !== typeof d && null === b.stateNode) throw Error(p(166));
                a = Lh(Kh.current);
                Lh(Ih.current);
                if (Ug(b)) {
                    d = b.stateNode;
                    a = b.memoizedProps;
                    d[bg] = b;
                    if (c = d.nodeValue !== a) {
                        if (f = Lg, null !== f) switch(f.tag){
                            case 3:
                                Of(d.nodeValue, a, 0 !== (f.mode & 1));
                                break;
                            case 5:
                                !0 !== f.memoizedProps.suppressHydrationWarning && Of(d.nodeValue, a, 0 !== (f.mode & 1));
                        }
                    }
                    c && (b.flags |= 4);
                } else d = (9 === a.nodeType ? a : a.ownerDocument).createTextNode(d), d[bg] = b, b.stateNode = d;
            }
            S(b);
            return null;
        case 13:
            G(L);
            d = b.memoizedState;
            if (null === a || null !== a.memoizedState && null !== a.memoizedState.dehydrated) {
                if (J && null !== Mg && 0 !== (b.mode & 1) && 0 === (b.flags & 128)) Vg(), Wg(), b.flags |= 98560, f = !1;
                else if (f = Ug(b), null !== d && null !== d.dehydrated) {
                    if (null === a) {
                        if (!f) throw Error(p(318));
                        f = b.memoizedState;
                        f = null !== f ? f.dehydrated : null;
                        if (!f) throw Error(p(317));
                        f[bg] = b;
                        S(b);
                        0 !== (b.mode & 2) && null !== d && (f = b.child, null !== f && (b.treeBaseDuration -= f.treeBaseDuration));
                    } else Wg(), 0 === (b.flags & 128) && (b.memoizedState = null), b.flags |= 4, S(b), 0 !== (b.mode & 2) && null !== d && (f = b.child, null !== f && (b.treeBaseDuration -= f.treeBaseDuration));
                    f = !1;
                } else null !== Ng && (lk(Ng), Ng = null), f = !0;
                if (!f) return b.flags & 65536 ? b : null;
            }
            if (0 !== (b.flags & 128)) return b.lanes = c, 0 !== (b.mode & 2) && dj(b), b;
            d = null !== d;
            d !== (null !== a && null !== a.memoizedState) && d && (b.child.flags |= 8192, 0 !== (b.mode & 1) && (null === a || 0 !== (L.current & 1) ? 0 === T && (T = 3) : Zj()));
            null !== b.updateQueue && (b.flags |= 4);
            S(b);
            0 !== (b.mode & 2) && d && (d = b.child, null !== d && (b.treeBaseDuration -= d.treeBaseDuration));
            return null;
        case 4:
            return Nh(), gk(a, b), null === a && Gf(b.stateNode.containerInfo), S(b), null;
        case 10:
            return oh(b.type._context), S(b), null;
        case 17:
            return mg(b.type) && ng(), S(b), null;
        case 19:
            G(L);
            f = b.memoizedState;
            if (null === f) return S(b), null;
            d = 0 !== (b.flags & 128);
            g = f.rendering;
            if (null === g) {
                if (d) jk(f, !1);
                else {
                    if (0 !== T || null !== a && 0 !== (a.flags & 128)) for(a = b.child; null !== a;){
                        g = Qh(a);
                        if (null !== g) {
                            b.flags |= 128;
                            jk(f, !1);
                            d = g.updateQueue;
                            null !== d && (b.updateQueue = d, b.flags |= 4);
                            b.subtreeFlags = 0;
                            d = c;
                            for(a = b.child; null !== a;)c = a, g = d, c.flags &= 14680066, f = c.alternate, null === f ? (c.childLanes = 0, c.lanes = g, c.child = null, c.subtreeFlags = 0, c.memoizedProps = null, c.memoizedState = null, c.updateQueue = null, c.dependencies = null, c.stateNode = null, c.selfBaseDuration = 0, c.treeBaseDuration = 0) : (c.childLanes = f.childLanes, c.lanes = f.lanes, c.child = f.child, c.subtreeFlags = 0, c.deletions = null, c.memoizedProps = f.memoizedProps, c.memoizedState = f.memoizedState, c.updateQueue = f.updateQueue, c.type = f.type, g = f.dependencies, c.dependencies = null === g ? null : {
                                lanes: g.lanes,
                                firstContext: g.firstContext
                            }, c.selfBaseDuration = f.selfBaseDuration, c.treeBaseDuration = f.treeBaseDuration), a = a.sibling;
                            H(L, L.current & 1 | 2);
                            return b.child;
                        }
                        a = a.sibling;
                    }
                    null !== f.tail && A() > mk && (b.flags |= 128, d = !0, jk(f, !1), b.lanes = 4194304);
                }
            } else {
                if (!d) {
                    if (a = Qh(g), null !== a) {
                        if (b.flags |= 128, d = !0, a = a.updateQueue, null !== a && (b.updateQueue = a, b.flags |= 4), jk(f, !0), null === f.tail && "hidden" === f.tailMode && !g.alternate && !J) return S(b), null;
                    } else 2 * A() - f.renderingStartTime > mk && 1073741824 !== c && (b.flags |= 128, d = !0, jk(f, !1), b.lanes = 4194304);
                }
                f.isBackwards ? (g.sibling = b.child, b.child = g) : (a = f.last, null !== a ? a.sibling = g : b.child = g, f.last = g);
            }
            if (null !== f.tail) return b = f.tail, f.rendering = b, f.tail = b.sibling, f.renderingStartTime = A(), b.sibling = null, a = L.current, H(L, d ? a & 1 | 2 : a & 1), b;
            S(b);
            return null;
        case 22:
        case 23:
            return nk(), d = null !== b.memoizedState, null !== a && null !== a.memoizedState !== d && (b.flags |= 8192), d && 0 !== (b.mode & 1) ? 0 !== (Jj & 1073741824) && (S(b), b.subtreeFlags & 6 && (b.flags |= 8192)) : S(b), null;
        case 24:
            return null;
        case 25:
            return null;
    }
    throw Error(p(156, b.tag));
}
function ok(a, b) {
    Kg(b);
    switch(b.tag){
        case 1:
            return mg(b.type) && ng(), a = b.flags, a & 65536 ? (b.flags = a & -65537 | 128, 0 !== (b.mode & 2) && dj(b), b) : null;
        case 3:
            return Nh(), G(jg), G(I), Sh(), a = b.flags, 0 !== (a & 65536) && 0 === (a & 128) ? (b.flags = a & -65537 | 128, b) : null;
        case 5:
            return Ph(b), null;
        case 13:
            G(L);
            a = b.memoizedState;
            if (null !== a && null !== a.dehydrated) {
                if (null === b.alternate) throw Error(p(340));
                Wg();
            }
            a = b.flags;
            return a & 65536 ? (b.flags = a & -65537 | 128, 0 !== (b.mode & 2) && dj(b), b) : null;
        case 19:
            return G(L), null;
        case 4:
            return Nh(), null;
        case 10:
            return oh(b.type._context), null;
        case 22:
        case 23:
            return nk(), null;
        case 24:
            return null;
        default:
            return null;
    }
}
var pk = !1, qk = !1, rk = "function" === typeof WeakSet ? WeakSet : Set, U = null, sk = null, tk = null;
function uk(a, b) {
    b.props = a.memoizedProps;
    b.state = a.memoizedState;
    if (a.mode & 2) try {
        cj(), b.componentWillUnmount();
    } finally{
        aj(a);
    }
    else b.componentWillUnmount();
}
function vk(a, b) {
    var c = a.ref;
    if (null !== c) {
        if ("function" === typeof c) try {
            if (a.mode & 2) try {
                cj(), c(null);
            } finally{
                aj(a);
            }
            else c(null);
        } catch (d) {
            W(a, b, d);
        }
        else c.current = null;
    }
}
function wk(a, b, c) {
    try {
        c();
    } catch (d) {
        W(a, b, d);
    }
}
var xk = !1;
function yk(a, b) {
    Qf = rd;
    a = $e();
    if (af(a)) {
        if ("selectionStart" in a) var c = {
            start: a.selectionStart,
            end: a.selectionEnd
        };
        else a: {
            c = (c = a.ownerDocument) && c.defaultView || window;
            var d = c.getSelection && c.getSelection();
            if (d && 0 !== d.rangeCount) {
                c = d.anchorNode;
                var e = d.anchorOffset, f = d.focusNode;
                d = d.focusOffset;
                try {
                    c.nodeType, f.nodeType;
                } catch (D) {
                    c = null;
                    break a;
                }
                var g = 0, h = -1, k = -1, l = 0, n = 0, q = a, r = null;
                b: for(;;){
                    for(var z;;){
                        q !== c || 0 !== e && 3 !== q.nodeType || (h = g + e);
                        q !== f || 0 !== d && 3 !== q.nodeType || (k = g + d);
                        3 === q.nodeType && (g += q.nodeValue.length);
                        if (null === (z = q.firstChild)) break;
                        r = q;
                        q = z;
                    }
                    for(;;){
                        if (q === a) break b;
                        r === c && ++l === e && (h = g);
                        r === f && ++n === d && (k = g);
                        if (null !== (z = q.nextSibling)) break;
                        q = r;
                        r = q.parentNode;
                    }
                    q = z;
                }
                c = -1 === h || -1 === k ? null : {
                    start: h,
                    end: k
                };
            } else c = null;
        }
        c = c || {
            start: 0,
            end: 0
        };
    } else c = null;
    Rf = {
        focusedElem: a,
        selectionRange: c
    };
    rd = !1;
    for(U = b; null !== U;)if (b = U, a = b.child, 0 !== (b.subtreeFlags & 1028) && null !== a) a.return = b, U = a;
    else for(; null !== U;){
        b = U;
        try {
            var m = b.alternate;
            if (0 !== (b.flags & 1024)) switch(b.tag){
                case 0:
                case 11:
                case 15:
                    break;
                case 1:
                    if (null !== m) {
                        var w = m.memoizedProps, C = m.memoizedState, x = b.stateNode, y = x.getSnapshotBeforeUpdate(b.elementType === b.type ? w : ej(b.type, w), C);
                        x.__reactInternalSnapshotBeforeUpdate = y;
                    }
                    break;
                case 3:
                    var v = b.stateNode.containerInfo;
                    1 === v.nodeType ? v.textContent = "" : 9 === v.nodeType && v.documentElement && v.removeChild(v.documentElement);
                    break;
                case 5:
                case 6:
                case 4:
                case 17:
                    break;
                default:
                    throw Error(p(163));
            }
        } catch (D) {
            W(b, b.return, D);
        }
        a = b.sibling;
        if (null !== a) {
            a.return = b.return;
            U = a;
            break;
        }
        U = b.return;
    }
    m = xk;
    xk = !1;
    return m;
}
function zk(a, b, c) {
    var d = b.updateQueue;
    d = null !== d ? d.lastEffect : null;
    if (null !== d) {
        var e = d = d.next;
        do {
            if ((e.tag & a) === a) {
                var f = e.destroy;
                e.destroy = void 0;
                void 0 !== f && (0 !== (a & 8) ? null !== B && "function" === typeof B.markComponentPassiveEffectUnmountStarted && B.markComponentPassiveEffectUnmountStarted(b) : 0 !== (a & 4) && uc(b), wk(b, c, f), 0 !== (a & 8) ? null !== B && "function" === typeof B.markComponentPassiveEffectUnmountStopped && B.markComponentPassiveEffectUnmountStopped() : 0 !== (a & 4) && vc());
            }
            e = e.next;
        }while (e !== d);
    }
}
function Ak(a, b) {
    var c = b.updateQueue;
    c = null !== c ? c.lastEffect : null;
    if (null !== c) {
        var d = c = c.next;
        do {
            if ((d.tag & a) === a) {
                0 !== (a & 8) ? null !== B && "function" === typeof B.markComponentPassiveEffectMountStarted && B.markComponentPassiveEffectMountStarted(b) : 0 !== (a & 4) && null !== B && "function" === typeof B.markComponentLayoutEffectMountStarted && B.markComponentLayoutEffectMountStarted(b);
                var e = d.create;
                d.destroy = e();
                0 !== (a & 8) ? null !== B && "function" === typeof B.markComponentPassiveEffectMountStopped && B.markComponentPassiveEffectMountStopped() : 0 !== (a & 4) && null !== B && "function" === typeof B.markComponentLayoutEffectMountStopped && B.markComponentLayoutEffectMountStopped();
            }
            d = d.next;
        }while (d !== c);
    }
}
function Bk(a) {
    var b = a.ref;
    if (null !== b) {
        var c = a.stateNode;
        if ("function" === typeof b) {
            if (a.mode & 2) try {
                cj(), b(c);
            } finally{
                aj(a);
            }
            else b(c);
        } else b.current = c;
    }
}
function Ck(a) {
    var b = a.alternate;
    null !== b && (a.alternate = null, Ck(b));
    a.child = null;
    a.deletions = null;
    a.sibling = null;
    5 === a.tag && (b = a.stateNode, null !== b && (delete b[bg], delete b[cg], delete b[Cf], delete b[dg], delete b[eg]));
    a.stateNode = null;
    a.return = null;
    a.dependencies = null;
    a.memoizedProps = null;
    a.memoizedState = null;
    a.pendingProps = null;
    a.stateNode = null;
    a.updateQueue = null;
}
function Dk(a) {
    return 5 === a.tag || 3 === a.tag || 4 === a.tag;
}
function Ek(a) {
    a: for(;;){
        for(; null === a.sibling;){
            if (null === a.return || Dk(a.return)) return null;
            a = a.return;
        }
        a.sibling.return = a.return;
        for(a = a.sibling; 5 !== a.tag && 6 !== a.tag && 18 !== a.tag;){
            if (a.flags & 2) continue a;
            if (null === a.child || 4 === a.tag) continue a;
            else a.child.return = a, a = a.child;
        }
        if (!(a.flags & 2)) return a.stateNode;
    }
}
function Fk(a, b, c) {
    var d = a.tag;
    if (5 === d || 6 === d) a = a.stateNode, b ? 8 === c.nodeType ? c.parentNode.insertBefore(a, b) : c.insertBefore(a, b) : (8 === c.nodeType ? (b = c.parentNode, b.insertBefore(a, c)) : (b = c, b.appendChild(a)), c = c._reactRootContainer, null !== c && void 0 !== c || null !== b.onclick || (b.onclick = Pf));
    else if (4 !== d && (a = a.child, null !== a)) for(Fk(a, b, c), a = a.sibling; null !== a;)Fk(a, b, c), a = a.sibling;
}
function Gk(a, b, c) {
    var d = a.tag;
    if (5 === d || 6 === d) a = a.stateNode, b ? c.insertBefore(a, b) : c.appendChild(a);
    else if (4 !== d && (a = a.child, null !== a)) for(Gk(a, b, c), a = a.sibling; null !== a;)Gk(a, b, c), a = a.sibling;
}
var X = null, Hk = !1;
function Ik(a, b, c) {
    for(c = c.child; null !== c;)Jk(a, b, c), c = c.sibling;
}
function Jk(a, b, c) {
    if (lc && "function" === typeof lc.onCommitFiberUnmount) try {
        lc.onCommitFiberUnmount(kc, c);
    } catch (h) {}
    switch(c.tag){
        case 5:
            qk || vk(c, b);
        case 6:
            var d = X, e = Hk;
            X = null;
            Ik(a, b, c);
            X = d;
            Hk = e;
            null !== X && (Hk ? (a = X, c = c.stateNode, 8 === a.nodeType ? a.parentNode.removeChild(c) : a.removeChild(c)) : X.removeChild(c.stateNode));
            break;
        case 18:
            null !== X && (Hk ? (a = X, c = c.stateNode, 8 === a.nodeType ? Yf(a.parentNode, c) : 1 === a.nodeType && Yf(a, c), pd(a)) : Yf(X, c.stateNode));
            break;
        case 4:
            d = X;
            e = Hk;
            X = c.stateNode.containerInfo;
            Hk = !0;
            Ik(a, b, c);
            X = d;
            Hk = e;
            break;
        case 0:
        case 11:
        case 14:
        case 15:
            if (!qk && (d = c.updateQueue, null !== d && (d = d.lastEffect, null !== d))) {
                e = d = d.next;
                do {
                    var f = e, g = f.destroy;
                    f = f.tag;
                    void 0 !== g && (0 !== (f & 2) ? wk(c, b, g) : 0 !== (f & 4) && (uc(c), c.mode & 2 ? (cj(), wk(c, b, g), aj(c)) : wk(c, b, g), vc()));
                    e = e.next;
                }while (e !== d);
            }
            Ik(a, b, c);
            break;
        case 1:
            if (!qk && (vk(c, b), d = c.stateNode, "function" === typeof d.componentWillUnmount)) try {
                uk(c, d);
            } catch (h) {
                W(c, b, h);
            }
            Ik(a, b, c);
            break;
        case 21:
            Ik(a, b, c);
            break;
        case 22:
            c.mode & 1 ? (qk = (d = qk) || null !== c.memoizedState, Ik(a, b, c), qk = d) : Ik(a, b, c);
            break;
        default:
            Ik(a, b, c);
    }
}
function Kk(a) {
    var b = a.updateQueue;
    if (null !== b) {
        a.updateQueue = null;
        var c = a.stateNode;
        null === c && (c = a.stateNode = new rk);
        b.forEach(function(b) {
            var d = Lk.bind(null, a, b);
            if (!c.has(b)) {
                c.add(b);
                if (mc) {
                    if (null !== sk && null !== tk) wj(tk, sk);
                    else throw Error(p(413));
                }
                b.then(d, d);
            }
        });
    }
}
function Mk(a, b, c) {
    sk = c;
    tk = a;
    Nk(b, a);
    tk = sk = null;
}
function Ok(a, b) {
    var c = b.deletions;
    if (null !== c) for(var d = 0; d < c.length; d++){
        var e = c[d];
        try {
            var f = a, g = b, h = g;
            a: for(; null !== h;){
                switch(h.tag){
                    case 5:
                        X = h.stateNode;
                        Hk = !1;
                        break a;
                    case 3:
                        X = h.stateNode.containerInfo;
                        Hk = !0;
                        break a;
                    case 4:
                        X = h.stateNode.containerInfo;
                        Hk = !0;
                        break a;
                }
                h = h.return;
            }
            if (null === X) throw Error(p(160));
            Jk(f, g, e);
            X = null;
            Hk = !1;
            var k = e.alternate;
            null !== k && (k.return = null);
            e.return = null;
        } catch (l) {
            W(e, b, l);
        }
    }
    if (b.subtreeFlags & 12854) for(b = b.child; null !== b;)Nk(b, a), b = b.sibling;
}
function Nk(a, b) {
    var c = a.alternate, d = a.flags;
    switch(a.tag){
        case 0:
        case 11:
        case 14:
        case 15:
            Ok(b, a);
            Pk(a);
            if (d & 4) {
                try {
                    zk(3, a, a.return), Ak(3, a);
                } catch (m) {
                    W(a, a.return, m);
                }
                if (a.mode & 2) {
                    try {
                        cj(), zk(5, a, a.return);
                    } catch (m) {
                        W(a, a.return, m);
                    }
                    aj(a);
                } else try {
                    zk(5, a, a.return);
                } catch (m) {
                    W(a, a.return, m);
                }
            }
            break;
        case 1:
            Ok(b, a);
            Pk(a);
            d & 512 && null !== c && vk(c, c.return);
            break;
        case 5:
            Ok(b, a);
            Pk(a);
            d & 512 && null !== c && vk(c, c.return);
            if (a.flags & 32) {
                var e = a.stateNode;
                try {
                    ob(e, "");
                } catch (m) {
                    W(a, a.return, m);
                }
            }
            if (d & 4 && (e = a.stateNode, null != e)) {
                var f = a.memoizedProps, g = null !== c ? c.memoizedProps : f, h = a.type, k = a.updateQueue;
                a.updateQueue = null;
                if (null !== k) try {
                    "input" === h && "radio" === f.type && null != f.name && $a(e, f);
                    vb(h, g);
                    var l = vb(h, f);
                    for(g = 0; g < k.length; g += 2){
                        var n = k[g], q = k[g + 1];
                        "style" === n ? sb(e, q) : "dangerouslySetInnerHTML" === n ? nb(e, q) : "children" === n ? ob(e, q) : ua(e, n, q, l);
                    }
                    switch(h){
                        case "input":
                            ab(e, f);
                            break;
                        case "textarea":
                            hb(e, f);
                            break;
                        case "select":
                            var r = e._wrapperState.wasMultiple;
                            e._wrapperState.wasMultiple = !!f.multiple;
                            var z = f.value;
                            null != z ? eb(e, !!f.multiple, z, !1) : r !== !!f.multiple && (null != f.defaultValue ? eb(e, !!f.multiple, f.defaultValue, !0) : eb(e, !!f.multiple, f.multiple ? [] : "", !1));
                    }
                    e[cg] = f;
                } catch (m) {
                    W(a, a.return, m);
                }
            }
            break;
        case 6:
            Ok(b, a);
            Pk(a);
            if (d & 4) {
                if (null === a.stateNode) throw Error(p(162));
                e = a.stateNode;
                f = a.memoizedProps;
                try {
                    e.nodeValue = f;
                } catch (m) {
                    W(a, a.return, m);
                }
            }
            break;
        case 3:
            Ok(b, a);
            Pk(a);
            if (d & 4 && null !== c && c.memoizedState.isDehydrated) try {
                pd(b.containerInfo);
            } catch (m) {
                W(a, a.return, m);
            }
            break;
        case 4:
            Ok(b, a);
            Pk(a);
            break;
        case 13:
            Ok(b, a);
            Pk(a);
            e = a.child;
            e.flags & 8192 && (f = null !== e.memoizedState, e.stateNode.isHidden = f, !f || null !== e.alternate && null !== e.alternate.memoizedState || (Qk = A()));
            d & 4 && Kk(a);
            break;
        case 22:
            n = null !== c && null !== c.memoizedState;
            a.mode & 1 ? (qk = (l = qk) || n, Ok(b, a), qk = l) : Ok(b, a);
            Pk(a);
            if (d & 8192) {
                l = null !== a.memoizedState;
                if ((a.stateNode.isHidden = l) && !n && 0 !== (a.mode & 1)) for(U = a, n = a.child; null !== n;){
                    for(q = U = n; null !== U;){
                        r = U;
                        z = r.child;
                        switch(r.tag){
                            case 0:
                            case 11:
                            case 14:
                            case 15:
                                if (r.mode & 2) try {
                                    cj(), zk(4, r, r.return);
                                } finally{
                                    aj(r);
                                }
                                else zk(4, r, r.return);
                                break;
                            case 1:
                                vk(r, r.return);
                                d = r.stateNode;
                                if ("function" === typeof d.componentWillUnmount) {
                                    c = r;
                                    b = r.return;
                                    try {
                                        uk(c, d);
                                    } catch (m) {
                                        W(c, b, m);
                                    }
                                }
                                break;
                            case 5:
                                vk(r, r.return);
                                break;
                            case 22:
                                if (null !== r.memoizedState) {
                                    Rk(q);
                                    continue;
                                }
                        }
                        null !== z ? (z.return = r, U = z) : Rk(q);
                    }
                    n = n.sibling;
                }
                a: for(n = null, q = a;;){
                    if (5 === q.tag) {
                        if (null === n) {
                            n = q;
                            try {
                                e = q.stateNode, l ? (f = e.style, "function" === typeof f.setProperty ? f.setProperty("display", "none", "important") : f.display = "none") : (h = q.stateNode, k = q.memoizedProps.style, g = void 0 !== k && null !== k && k.hasOwnProperty("display") ? k.display : null, h.style.display = rb("display", g));
                            } catch (m) {
                                W(a, a.return, m);
                            }
                        }
                    } else if (6 === q.tag) {
                        if (null === n) try {
                            q.stateNode.nodeValue = l ? "" : q.memoizedProps;
                        } catch (m) {
                            W(a, a.return, m);
                        }
                    } else if ((22 !== q.tag && 23 !== q.tag || null === q.memoizedState || q === a) && null !== q.child) {
                        q.child.return = q;
                        q = q.child;
                        continue;
                    }
                    if (q === a) break a;
                    for(; null === q.sibling;){
                        if (null === q.return || q.return === a) break a;
                        n === q && (n = null);
                        q = q.return;
                    }
                    n === q && (n = null);
                    q.sibling.return = q.return;
                    q = q.sibling;
                }
            }
            break;
        case 19:
            Ok(b, a);
            Pk(a);
            d & 4 && Kk(a);
            break;
        case 21:
            break;
        default:
            Ok(b, a), Pk(a);
    }
}
function Pk(a) {
    var b = a.flags;
    if (b & 2) {
        try {
            a: {
                for(var c = a.return; null !== c;){
                    if (Dk(c)) {
                        var d = c;
                        break a;
                    }
                    c = c.return;
                }
                throw Error(p(160));
            }
            switch(d.tag){
                case 5:
                    var e = d.stateNode;
                    d.flags & 32 && (ob(e, ""), d.flags &= -33);
                    var f = Ek(a);
                    Gk(a, f, e);
                    break;
                case 3:
                case 4:
                    var g = d.stateNode.containerInfo, h = Ek(a);
                    Fk(a, h, g);
                    break;
                default:
                    throw Error(p(161));
            }
        } catch (k) {
            W(a, a.return, k);
        }
        a.flags &= -3;
    }
    b & 4096 && (a.flags &= -4097);
}
function Sk(a, b, c) {
    sk = c;
    tk = b;
    U = a;
    Tk(a, b, c);
    tk = sk = null;
}
function Tk(a, b, c) {
    for(var d = 0 !== (a.mode & 1); null !== U;){
        var e = U, f = e.child;
        if (22 === e.tag && d) {
            var g = null !== e.memoizedState || pk;
            if (!g) {
                var h = e.alternate, k = null !== h && null !== h.memoizedState || qk;
                h = pk;
                var l = qk;
                pk = g;
                if ((qk = k) && !l) for(U = e; null !== U;)g = U, k = g.child, 22 === g.tag && null !== g.memoizedState ? Uk(e) : null !== k ? (k.return = g, U = k) : Uk(e);
                for(; null !== f;)U = f, Tk(f, b, c), f = f.sibling;
                U = e;
                pk = h;
                qk = l;
            }
            Vk(a, b, c);
        } else 0 !== (e.subtreeFlags & 8772) && null !== f ? (f.return = e, U = f) : Vk(a, b, c);
    }
}
function Vk(a) {
    for(; null !== U;){
        var b = U;
        if (0 !== (b.flags & 8772)) {
            var c = b.alternate;
            try {
                if (0 !== (b.flags & 8772)) switch(b.tag){
                    case 0:
                    case 11:
                    case 15:
                        if (!qk) {
                            if (b.mode & 2) try {
                                cj(), Ak(5, b);
                            } finally{
                                aj(b);
                            }
                            else Ak(5, b);
                        }
                        break;
                    case 1:
                        var d = b.stateNode;
                        if (b.flags & 4 && !qk) {
                            if (null === c) {
                                if (b.mode & 2) try {
                                    cj(), d.componentDidMount();
                                } finally{
                                    aj(b);
                                }
                                else d.componentDidMount();
                            } else {
                                var e = b.elementType === b.type ? c.memoizedProps : ej(b.type, c.memoizedProps), f = c.memoizedState;
                                if (b.mode & 2) try {
                                    cj(), d.componentDidUpdate(e, f, d.__reactInternalSnapshotBeforeUpdate);
                                } finally{
                                    aj(b);
                                }
                                else d.componentDidUpdate(e, f, d.__reactInternalSnapshotBeforeUpdate);
                            }
                        }
                        var g = b.updateQueue;
                        null !== g && Gh(b, g, d);
                        break;
                    case 3:
                        var h = b.updateQueue;
                        if (null !== h) {
                            var k = null;
                            if (null !== b.child) switch(b.child.tag){
                                case 5:
                                    k = b.child.stateNode;
                                    break;
                                case 1:
                                    k = b.child.stateNode;
                            }
                            Gh(b, h, k);
                        }
                        break;
                    case 5:
                        var l = b.stateNode;
                        if (null === c && b.flags & 4) {
                            k = l;
                            var n = b.memoizedProps;
                            switch(b.type){
                                case "button":
                                case "input":
                                case "select":
                                case "textarea":
                                    n.autoFocus && k.focus();
                                    break;
                                case "img":
                                    n.src && (k.src = n.src);
                            }
                        }
                        break;
                    case 6:
                        break;
                    case 4:
                        break;
                    case 12:
                        var q = b.memoizedProps, r = q.onCommit, z = q.onRender, m = b.stateNode.effectDuration;
                        k = Ui;
                        c = null === c ? "mount" : "update";
                        Yi && (c = "nested-update");
                        "function" === typeof z && z(b.memoizedProps.id, c, b.actualDuration, b.treeBaseDuration, b.actualStartTime, k);
                        "function" === typeof r && r(b.memoizedProps.id, c, m, k);
                        Wk(b);
                        var w = b.return;
                        a: for(; null !== w;){
                            switch(w.tag){
                                case 3:
                                    w.stateNode.effectDuration += m;
                                    break a;
                                case 12:
                                    w.stateNode.effectDuration += m;
                                    break a;
                            }
                            w = w.return;
                        }
                        break;
                    case 13:
                        if (null === b.memoizedState) {
                            var C = b.alternate;
                            if (null !== C) {
                                var x = C.memoizedState;
                                if (null !== x) {
                                    var y = x.dehydrated;
                                    null !== y && pd(y);
                                }
                            }
                        }
                        break;
                    case 19:
                    case 17:
                    case 21:
                    case 22:
                    case 23:
                    case 25:
                        break;
                    default:
                        throw Error(p(163));
                }
                qk || b.flags & 512 && Bk(b);
            } catch (v) {
                W(b, b.return, v);
            }
        }
        if (b === a) {
            U = null;
            break;
        }
        k = b.sibling;
        if (null !== k) {
            k.return = b.return;
            U = k;
            break;
        }
        U = b.return;
    }
}
function Rk(a) {
    for(; null !== U;){
        var b = U;
        if (b === a) {
            U = null;
            break;
        }
        var c = b.sibling;
        if (null !== c) {
            c.return = b.return;
            U = c;
            break;
        }
        U = b.return;
    }
}
function Uk(a) {
    for(; null !== U;){
        var b = U;
        try {
            switch(b.tag){
                case 0:
                case 11:
                case 15:
                    if (b.mode & 2) try {
                        cj();
                        var c = b.return;
                        try {
                            Ak(4, b);
                        } catch (l) {
                            W(b, c, l);
                        }
                    } finally{
                        aj(b);
                    }
                    else {
                        var d = b.return;
                        try {
                            Ak(4, b);
                        } catch (l) {
                            W(b, d, l);
                        }
                    }
                    break;
                case 1:
                    var e = b.stateNode;
                    if ("function" === typeof e.componentDidMount) {
                        var f = b.return;
                        try {
                            e.componentDidMount();
                        } catch (l) {
                            W(b, f, l);
                        }
                    }
                    var g = b.return;
                    try {
                        Bk(b);
                    } catch (l) {
                        W(b, g, l);
                    }
                    break;
                case 5:
                    var h = b.return;
                    try {
                        Bk(b);
                    } catch (l) {
                        W(b, h, l);
                    }
            }
        } catch (l) {
            W(b, b.return, l);
        }
        if (b === a) {
            U = null;
            break;
        }
        var k = b.sibling;
        if (null !== k) {
            k.return = b.return;
            U = k;
            break;
        }
        U = b.return;
    }
}
var Xk = Math.ceil, Yk = va.ReactCurrentDispatcher, Zk = va.ReactCurrentOwner, $k = va.ReactCurrentBatchConfig, K = 0, Q = null, Y = null, Z = 0, Jj = 0, Ij = hg(0), T = 0, al = null, Fh = 0, bl = 0, cl = 0, dl = null, el = null, Qk = 0, mk = Infinity, fl = null, qj = !1, rj = null, tj = null, gl = !1, hl = null, il = 0, jl = [], kl = 0, ll = null, ml = -1, nl = 0;
function Ri() {
    return 0 !== (K & 6) ? A() : -1 !== ml ? ml : ml = A();
}
function Oi(a) {
    if (0 === (a.mode & 1)) return 1;
    if (0 !== (K & 2) && 0 !== Z) return Z & -Z;
    if (null !== Yg.transition) return 0 === nl && (nl = Kc()), nl;
    a = E;
    if (0 !== a) return a;
    a = window.event;
    a = void 0 === a ? 16 : xd(a.type);
    return a;
}
function ui(a, b, c, d) {
    if (50 < kl) throw kl = 0, ll = null, Error(p(185));
    Mc(a, c, d);
    if (0 === (K & 2) || a !== Q) mc && Pc(a, b, c), a === Q && (0 === (K & 2) && (bl |= c), 4 === T && ol(a, Z)), pl(a, d), 1 === c && 0 === K && 0 === (b.mode & 1) && (mk = A() + 500, tg && xg());
}
function pl(a, b) {
    var c = a.callbackNode;
    Ic(a, b);
    var d = Gc(a, a === Q ? Z : 0);
    if (0 === d) null !== c && bc(c), a.callbackNode = null, a.callbackPriority = 0;
    else if (b = d & -d, a.callbackPriority !== b) {
        null != c && bc(c);
        if (1 === b) 0 === a.tag ? wg(ql.bind(null, a)) : vg(ql.bind(null, a)), Xf(function() {
            0 === (K & 6) && xg();
        }), c = null;
        else {
            switch(Rc(d)){
                case 1:
                    c = fc;
                    break;
                case 4:
                    c = gc;
                    break;
                case 16:
                    c = hc;
                    break;
                case 536870912:
                    c = jc;
                    break;
                default:
                    c = hc;
            }
            c = rl(c, sl.bind(null, a));
        }
        a.callbackPriority = b;
        a.callbackNode = c;
    }
}
function sl(a, b) {
    Zi = Yi = !1;
    ml = -1;
    nl = 0;
    if (0 !== (K & 6)) throw Error(p(327));
    var c = a.callbackNode;
    if (tl() && a.callbackNode !== c) return null;
    var d = Gc(a, a === Q ? Z : 0);
    if (0 === d) return null;
    if (0 !== (d & 30) || 0 !== (d & a.expiredLanes) || b) b = ul(a, d);
    else {
        b = d;
        var e = K;
        K |= 2;
        var f = vl();
        if (Q !== a || Z !== b) {
            if (mc) {
                var g = a.memoizedUpdaters;
                0 < g.size && (wj(a, Z), g.clear());
                Qc(a, b);
            }
            fl = null;
            mk = A() + 500;
            wl(a, b);
        }
        wc(b);
        for(;;)try {
            xl();
            break;
        } catch (h) {
            yl(a, h);
        }
        nh();
        Yk.current = f;
        K = e;
        null !== Y ? (null !== B && "function" === typeof B.markRenderYielded && B.markRenderYielded(), b = 0) : (xc(), Q = null, Z = 0, b = T);
    }
    if (0 !== b) {
        2 === b && (e = Jc(a), 0 !== e && (d = e, b = zl(a, e)));
        if (1 === b) throw c = al, wl(a, 0), ol(a, d), pl(a, A()), c;
        if (6 === b) ol(a, d);
        else {
            e = a.current.alternate;
            if (0 === (d & 30) && !Al(e) && (b = ul(a, d), 2 === b && (f = Jc(a), 0 !== f && (d = f, b = zl(a, f))), 1 === b)) throw c = al, wl(a, 0), ol(a, d), pl(a, A()), c;
            a.finishedWork = e;
            a.finishedLanes = d;
            switch(b){
                case 0:
                case 1:
                    throw Error(p(345));
                case 2:
                    Cl(a, el, fl);
                    break;
                case 3:
                    ol(a, d);
                    if ((d & 130023424) === d && (b = Qk + 500 - A(), 10 < b)) {
                        if (0 !== Gc(a, 0)) break;
                        e = a.suspendedLanes;
                        if ((e & d) !== d) {
                            Ri();
                            a.pingedLanes |= a.suspendedLanes & e;
                            break;
                        }
                        a.timeoutHandle = Tf(Cl.bind(null, a, el, fl), b);
                        break;
                    }
                    Cl(a, el, fl);
                    break;
                case 4:
                    ol(a, d);
                    if ((d & 4194240) === d) break;
                    b = a.eventTimes;
                    for(e = -1; 0 < d;)g = 31 - Ac(d), f = 1 << g, g = b[g], g > e && (e = g), d &= ~f;
                    d = e;
                    d = A() - d;
                    d = (120 > d ? 120 : 480 > d ? 480 : 1080 > d ? 1080 : 1920 > d ? 1920 : 3E3 > d ? 3E3 : 4320 > d ? 4320 : 1960 * Xk(d / 1960)) - d;
                    if (10 < d) {
                        a.timeoutHandle = Tf(Cl.bind(null, a, el, fl), d);
                        break;
                    }
                    Cl(a, el, fl);
                    break;
                case 5:
                    Cl(a, el, fl);
                    break;
                default:
                    throw Error(p(329));
            }
        }
    }
    pl(a, A());
    return a.callbackNode === c ? sl.bind(null, a) : null;
}
function zl(a, b) {
    var c = dl;
    a.current.memoizedState.isDehydrated && (wl(a, b).flags |= 256);
    a = ul(a, b);
    2 !== a && (b = el, el = c, null !== b && lk(b));
    return a;
}
function lk(a) {
    null === el ? el = a : el.push.apply(el, a);
}
function Al(a) {
    for(var b = a;;){
        if (b.flags & 16384) {
            var c = b.updateQueue;
            if (null !== c && (c = c.stores, null !== c)) for(var d = 0; d < c.length; d++){
                var e = c[d], f = e.getSnapshot;
                e = e.value;
                try {
                    if (!Ve(f(), e)) return !1;
                } catch (g) {
                    return !1;
                }
            }
        }
        c = b.child;
        if (b.subtreeFlags & 16384 && null !== c) c.return = b, b = c;
        else {
            if (b === a) break;
            for(; null === b.sibling;){
                if (null === b.return || b.return === a) return !0;
                b = b.return;
            }
            b.sibling.return = b.return;
            b = b.sibling;
        }
    }
    return !0;
}
function ol(a, b) {
    b &= ~cl;
    b &= ~bl;
    a.suspendedLanes |= b;
    a.pingedLanes &= ~b;
    for(a = a.expirationTimes; 0 < b;){
        var c = 31 - Ac(b), d = 1 << c;
        a[c] = -1;
        b &= ~d;
    }
}
function ql(a) {
    Yi = Zi;
    Zi = !1;
    if (0 !== (K & 6)) throw Error(p(327));
    tl();
    var b = Gc(a, 0);
    if (0 === (b & 1)) return pl(a, A()), null;
    var c = ul(a, b);
    if (0 !== a.tag && 2 === c) {
        var d = Jc(a);
        0 !== d && (b = d, c = zl(a, d));
    }
    if (1 === c) throw c = al, wl(a, 0), ol(a, b), pl(a, A()), c;
    if (6 === c) throw Error(p(345));
    a.finishedWork = a.current.alternate;
    a.finishedLanes = b;
    Cl(a, el, fl);
    pl(a, A());
    return null;
}
function Dl(a, b) {
    var c = K;
    K |= 1;
    try {
        return a(b);
    } finally{
        K = c, 0 === K && (mk = A() + 500, tg && xg());
    }
}
function El(a) {
    null !== hl && 0 === hl.tag && 0 === (K & 6) && tl();
    var b = K;
    K |= 1;
    var c = $k.transition, d = E;
    try {
        if ($k.transition = null, E = 1, a) return a();
    } finally{
        E = d, $k.transition = c, K = b, 0 === (K & 6) && xg();
    }
}
function nk() {
    Jj = Ij.current;
    G(Ij);
}
function wl(a, b) {
    a.finishedWork = null;
    a.finishedLanes = 0;
    var c = a.timeoutHandle;
    -1 !== c && (a.timeoutHandle = -1, Uf(c));
    if (null !== Y) for(c = Y.return; null !== c;){
        var d = c;
        Kg(d);
        switch(d.tag){
            case 1:
                d = d.type.childContextTypes;
                null !== d && void 0 !== d && ng();
                break;
            case 3:
                Nh();
                G(jg);
                G(I);
                Sh();
                break;
            case 5:
                Ph(d);
                break;
            case 4:
                Nh();
                break;
            case 13:
                G(L);
                break;
            case 19:
                G(L);
                break;
            case 10:
                oh(d.type._context);
                break;
            case 22:
            case 23:
                nk();
        }
        c = c.return;
    }
    Q = a;
    Y = a = ch(a.current, null);
    Z = Jj = b;
    T = 0;
    al = null;
    cl = bl = Fh = 0;
    el = dl = null;
    if (null !== th) {
        for(b = 0; b < th.length; b++)if (c = th[b], d = c.interleaved, null !== d) {
            c.interleaved = null;
            var e = d.next, f = c.pending;
            if (null !== f) {
                var g = f.next;
                f.next = e;
                d.next = g;
            }
            c.pending = d;
        }
        th = null;
    }
    return a;
}
function yl(a, b) {
    do {
        var c = Y;
        try {
            nh();
            Th.current = ei;
            if (Wh) {
                for(var d = M.memoizedState; null !== d;){
                    var e = d.queue;
                    null !== e && (e.pending = null);
                    d = d.next;
                }
                Wh = !1;
            }
            Vh = 0;
            O = N = M = null;
            Xh = !1;
            Yh = 0;
            Zk.current = null;
            if (null === c || null === c.return) {
                T = 1;
                al = b;
                Y = null;
                break;
            }
            c.mode & 2 && $i(c, !0);
            tc();
            if (null !== b && "object" === typeof b && "function" === typeof b.then) {
                var f = b;
                null !== B && "function" === typeof B.markComponentSuspended && B.markComponentSuspended(c, f, Z);
            } else null !== B && "function" === typeof B.markComponentErrored && B.markComponentErrored(c, b, Z);
            a: {
                var g = a, h = c.return, k = c;
                f = b;
                b = Z;
                k.flags |= 32768;
                mc && wj(g, b);
                if (null !== f && "object" === typeof f && "function" === typeof f.then) {
                    var l = f, n = k, q = n.tag;
                    if (0 === (n.mode & 1) && (0 === q || 11 === q || 15 === q)) {
                        var r = n.alternate;
                        r ? (n.updateQueue = r.updateQueue, n.memoizedState = r.memoizedState, n.lanes = r.lanes) : (n.updateQueue = null, n.memoizedState = null);
                    }
                    var z = xj(h);
                    if (null !== z) {
                        z.flags &= -257;
                        yj(z, h, k, g, b);
                        z.mode & 1 && uj(g, l, b);
                        b = z;
                        f = l;
                        var m = b.updateQueue;
                        if (null === m) {
                            var w = new Set;
                            w.add(f);
                            b.updateQueue = w;
                        } else m.add(f);
                        break a;
                    } else {
                        if (0 === (b & 1)) {
                            uj(g, l, b);
                            Zj();
                            break a;
                        }
                        f = Error(p(426));
                    }
                } else if (J && k.mode & 1) {
                    var C = xj(h);
                    if (null !== C) {
                        0 === (C.flags & 65536) && (C.flags |= 256);
                        yj(C, h, k, g, b);
                        Xg(lj(f, k));
                        break a;
                    }
                }
                g = f = lj(f, k);
                4 !== T && (T = 2);
                null === dl ? dl = [
                    g
                ] : dl.push(g);
                g = h;
                do {
                    switch(g.tag){
                        case 3:
                            g.flags |= 65536;
                            b &= -b;
                            g.lanes |= b;
                            var x = pj(g, f, b);
                            Dh(g, x);
                            break a;
                        case 1:
                            k = f;
                            var y = g.type, v = g.stateNode;
                            if (0 === (g.flags & 128) && ("function" === typeof y.getDerivedStateFromError || null !== v && "function" === typeof v.componentDidCatch && (null === tj || !tj.has(v)))) {
                                g.flags |= 65536;
                                b &= -b;
                                g.lanes |= b;
                                var D = sj(g, k, b);
                                Dh(g, D);
                                break a;
                            }
                    }
                    g = g.return;
                }while (null !== g);
            }
            Fl(c);
        } catch (ca) {
            b = ca;
            Y === c && null !== c && (Y = c = c.return);
            continue;
        }
        break;
    }while (1);
}
function vl() {
    var a = Yk.current;
    Yk.current = ei;
    return null === a ? ei : a;
}
function Zj() {
    if (0 === T || 3 === T || 2 === T) T = 4;
    null === Q || 0 === (Fh & 268435455) && 0 === (bl & 268435455) || ol(Q, Z);
}
function ul(a, b) {
    var c = K;
    K |= 2;
    var d = vl();
    if (Q !== a || Z !== b) {
        if (mc) {
            var e = a.memoizedUpdaters;
            0 < e.size && (wj(a, Z), e.clear());
            Qc(a, b);
        }
        fl = null;
        wl(a, b);
    }
    wc(b);
    for(;;)try {
        Gl();
        break;
    } catch (f) {
        yl(a, f);
    }
    nh();
    K = c;
    Yk.current = d;
    if (null !== Y) throw Error(p(261));
    xc();
    Q = null;
    Z = 0;
    return T;
}
function Gl() {
    for(; null !== Y;)Hl(Y);
}
function xl() {
    for(; null !== Y && !cc();)Hl(Y);
}
function Hl(a) {
    var b = a.alternate;
    0 !== (a.mode & 2) ? (Wi = Ti(), 0 > a.actualStartTime && (a.actualStartTime = Ti()), b = Il(b, a, Jj), $i(a, !0)) : b = Il(b, a, Jj);
    a.memoizedProps = a.pendingProps;
    null === b ? Fl(a) : Y = b;
    Zk.current = null;
}
function Fl(a) {
    var b = a;
    do {
        var c = b.alternate;
        a = b.return;
        if (0 === (b.flags & 32768)) {
            if (0 === (b.mode & 2)) c = kk(c, b, Jj);
            else {
                var d = b;
                Wi = Ti();
                0 > d.actualStartTime && (d.actualStartTime = Ti());
                c = kk(c, b, Jj);
                $i(b, !1);
            }
            if (null !== c) {
                Y = c;
                return;
            }
        } else {
            c = ok(c, b);
            if (null !== c) {
                c.flags &= 32767;
                Y = c;
                return;
            }
            if (0 !== (b.mode & 2)) {
                $i(b, !1);
                c = b.actualDuration;
                for(d = b.child; null !== d;)c += d.actualDuration, d = d.sibling;
                b.actualDuration = c;
            }
            if (null !== a) a.flags |= 32768, a.subtreeFlags = 0, a.deletions = null;
            else {
                T = 6;
                Y = null;
                return;
            }
        }
        b = b.sibling;
        if (null !== b) {
            Y = b;
            return;
        }
        Y = b = a;
    }while (null !== b);
    0 === T && (T = 5);
}
function Cl(a, b, c) {
    var d = E, e = $k.transition;
    try {
        $k.transition = null, E = 1, Jl(a, b, c, d);
    } finally{
        $k.transition = e, E = d;
    }
    return null;
}
function Jl(a, b, c, d) {
    do tl();
    while (null !== hl);
    if (0 !== (K & 6)) throw Error(p(327));
    c = a.finishedWork;
    var e = a.finishedLanes;
    null !== B && "function" === typeof B.markCommitStarted && B.markCommitStarted(e);
    if (null === c) return rc(), null;
    a.finishedWork = null;
    a.finishedLanes = 0;
    if (c === a.current) throw Error(p(177));
    a.callbackNode = null;
    a.callbackPriority = 0;
    var f = c.lanes | c.childLanes;
    Nc(a, f);
    a === Q && (Y = Q = null, Z = 0);
    0 === (c.subtreeFlags & 2064) && 0 === (c.flags & 2064) || gl || (gl = !0, rl(hc, function() {
        tl();
        return null;
    }));
    f = 0 !== (c.flags & 15990);
    if (0 !== (c.subtreeFlags & 15990) || f) {
        f = $k.transition;
        $k.transition = null;
        var g = E;
        E = 1;
        var h = K;
        K |= 4;
        Zk.current = null;
        yk(a, c);
        Ui = Ti();
        Mk(a, c, e);
        bf(Rf);
        rd = !!Qf;
        Rf = Qf = null;
        a.current = c;
        null !== B && "function" === typeof B.markLayoutEffectsStarted && B.markLayoutEffectsStarted(e);
        Sk(c, a, e);
        null !== B && "function" === typeof B.markLayoutEffectsStopped && B.markLayoutEffectsStopped();
        dc();
        K = h;
        E = g;
        $k.transition = f;
    } else a.current = c, Ui = Ti();
    gl && (gl = !1, hl = a, il = e);
    f = a.pendingLanes;
    0 === f && (tj = null);
    nc(c.stateNode, d);
    mc && a.memoizedUpdaters.clear();
    pl(a, A());
    if (null !== b) for(d = a.onRecoverableError, c = 0; c < b.length; c++)e = b[c], d(e.value, {
        componentStack: e.stack,
        digest: e.digest
    });
    if (qj) throw qj = !1, a = rj, rj = null, a;
    0 !== (il & 1) && 0 !== a.tag && tl();
    f = a.pendingLanes;
    0 !== (f & 1) ? (Zi = !0, a === ll ? kl++ : (kl = 0, ll = a)) : kl = 0;
    xg();
    rc();
    return null;
}
function tl() {
    if (null !== hl) {
        var a = Rc(il), b = $k.transition, c = E;
        try {
            $k.transition = null;
            E = 16 > a ? 16 : a;
            if (null === hl) var d = !1;
            else {
                a = hl;
                var e = il;
                hl = null;
                il = 0;
                if (0 !== (K & 6)) throw Error(p(331));
                null !== B && "function" === typeof B.markPassiveEffectsStarted && B.markPassiveEffectsStarted(e);
                e = K;
                K |= 4;
                for(U = a.current; null !== U;){
                    var f = U, g = f.child;
                    if (0 !== (U.flags & 16)) {
                        var h = f.deletions;
                        if (null !== h) {
                            for(var k = 0; k < h.length; k++){
                                var l = h[k];
                                for(U = l; null !== U;){
                                    var n = U, q = n;
                                    switch(q.tag){
                                        case 0:
                                        case 11:
                                        case 15:
                                            q.mode & 2 ? (Xi = Ti(), zk(8, q, f), bj(q)) : zk(8, q, f);
                                    }
                                    var r = n.child;
                                    if (null !== r) r.return = n, U = r;
                                    else for(; null !== U;){
                                        n = U;
                                        var z = n.sibling, m = n.return;
                                        Ck(n);
                                        if (n === l) {
                                            U = null;
                                            break;
                                        }
                                        if (null !== z) {
                                            z.return = m;
                                            U = z;
                                            break;
                                        }
                                        U = m;
                                    }
                                }
                            }
                            var w = f.alternate;
                            if (null !== w) {
                                var C = w.child;
                                if (null !== C) {
                                    w.child = null;
                                    do {
                                        var x = C.sibling;
                                        C.sibling = null;
                                        C = x;
                                    }while (null !== C);
                                }
                            }
                            U = f;
                        }
                    }
                    if (0 !== (f.subtreeFlags & 2064) && null !== g) g.return = f, U = g;
                    else b: for(; null !== U;){
                        f = U;
                        if (0 !== (f.flags & 2048)) switch(k = f, k.tag){
                            case 0:
                            case 11:
                            case 15:
                                k.mode & 2 ? (Xi = Ti(), zk(9, k, k.return), bj(k)) : zk(9, k, k.return);
                        }
                        var y = f.sibling;
                        if (null !== y) {
                            y.return = f.return;
                            U = y;
                            break b;
                        }
                        U = f.return;
                    }
                }
                var v = a.current;
                for(U = v; null !== U;){
                    g = U;
                    var D = g.child;
                    if (0 !== (g.subtreeFlags & 2064) && null !== D) D.return = g, U = D;
                    else b: for(g = v; null !== U;){
                        h = U;
                        if (0 !== (h.flags & 2048)) try {
                            switch(l = h, l.tag){
                                case 0:
                                case 11:
                                case 15:
                                    if (l.mode & 2) {
                                        Xi = Ti();
                                        try {
                                            Ak(9, l);
                                        } finally{
                                            bj(l);
                                        }
                                    } else Ak(9, l);
                            }
                        } catch (Pj) {
                            W(h, h.return, Pj);
                        }
                        if (h === g) {
                            U = null;
                            break b;
                        }
                        var ca = h.sibling;
                        if (null !== ca) {
                            ca.return = h.return;
                            U = ca;
                            break b;
                        }
                        U = h.return;
                    }
                }
                v = jl;
                jl = [];
                for(D = 0; D < v.length; D++){
                    var R = v[D];
                    if (0 !== (R.flags & 4)) switch(R.tag){
                        case 12:
                            var sa = R.stateNode.passiveEffectDuration, V = R.memoizedProps, Bl = V.id, yi = V.onPostCommit;
                            ca = Ui;
                            var zi = null === R.alternate ? "mount" : "update";
                            Yi && (zi = "nested-update");
                            "function" === typeof yi && yi(Bl, zi, sa, ca);
                            var lb = R.return;
                            b: for(; null !== lb;){
                                switch(lb.tag){
                                    case 3:
                                        lb.stateNode.passiveEffectDuration += sa;
                                        break b;
                                    case 12:
                                        lb.stateNode.passiveEffectDuration += sa;
                                        break b;
                                }
                                lb = lb.return;
                            }
                    }
                }
                null !== B && "function" === typeof B.markPassiveEffectsStopped && B.markPassiveEffectsStopped();
                K = e;
                xg();
                if (lc && "function" === typeof lc.onPostCommitFiberRoot) try {
                    lc.onPostCommitFiberRoot(kc, a);
                } catch (Pj) {}
                var Qj = a.current.stateNode;
                Qj.effectDuration = 0;
                Qj.passiveEffectDuration = 0;
                d = !0;
            }
            return d;
        } finally{
            E = c, $k.transition = b;
        }
    }
    return !1;
}
function Wk(a) {
    jl.push(a);
    gl || (gl = !0, rl(hc, function() {
        tl();
        return null;
    }));
}
function Kl(a, b, c) {
    b = lj(c, b);
    b = pj(a, b, 1);
    a = Bh(a, b, 1);
    b = Ri();
    null !== a && (Mc(a, 1, b), pl(a, b));
}
function W(a, b, c) {
    if (3 === a.tag) Kl(a, a, c);
    else for(; null !== b;){
        if (3 === b.tag) {
            Kl(b, a, c);
            break;
        } else if (1 === b.tag) {
            var d = b.stateNode;
            if ("function" === typeof b.type.getDerivedStateFromError || "function" === typeof d.componentDidCatch && (null === tj || !tj.has(d))) {
                a = lj(c, a);
                a = sj(b, a, 1);
                b = Bh(b, a, 1);
                a = Ri();
                null !== b && (Mc(b, 1, a), pl(b, a));
                break;
            }
        }
        b = b.return;
    }
}
function vj(a, b, c) {
    var d = a.pingCache;
    null !== d && d.delete(b);
    b = Ri();
    a.pingedLanes |= a.suspendedLanes & c;
    Q === a && (Z & c) === c && (4 === T || 3 === T && (Z & 130023424) === Z && 500 > A() - Qk ? wl(a, 0) : cl |= c);
    pl(a, b);
}
function Ll(a, b) {
    0 === b && (0 === (a.mode & 1) ? b = 1 : (b = Ec, Ec <<= 1, 0 === (Ec & 130023424) && (Ec = 4194304)));
    var c = Ri();
    a = wh(a, b);
    null !== a && (Mc(a, b, c), pl(a, c));
}
function ak(a) {
    var b = a.memoizedState, c = 0;
    null !== b && (c = b.retryLane);
    Ll(a, c);
}
function Lk(a, b) {
    var c = 0;
    switch(a.tag){
        case 13:
            var d = a.stateNode;
            var e = a.memoizedState;
            null !== e && (c = e.retryLane);
            break;
        case 19:
            d = a.stateNode;
            break;
        default:
            throw Error(p(314));
    }
    null !== d && d.delete(b);
    Ll(a, c);
}
var Il;
Il = function(a, b, c) {
    if (null !== a) {
        if (a.memoizedProps !== b.pendingProps || jg.current) rh = !0;
        else {
            if (0 === (a.lanes & c) && 0 === (b.flags & 128)) return rh = !1, ek(a, b, c);
            rh = 0 !== (a.flags & 131072) ? !0 : !1;
        }
    } else rh = !1, J && 0 !== (b.flags & 1048576) && Ig(b, Bg, b.index);
    b.lanes = 0;
    switch(b.tag){
        case 2:
            var d = b.type;
            Mj(a, b);
            a = b.pendingProps;
            var e = lg(b, I.current);
            qh(b, c);
            sc(b);
            e = ai(null, b, d, a, e, c);
            var f = fi();
            tc();
            b.flags |= 1;
            "object" === typeof e && null !== e && "function" === typeof e.render && void 0 === e.$$typeof ? (b.tag = 1, b.memoizedState = null, b.updateQueue = null, mg(d) ? (f = !0, qg(b)) : f = !1, b.memoizedState = null !== e.state && void 0 !== e.state ? e.state : null, yh(b), e.updater = gj, b.stateNode = e, e._reactInternals = b, kj(b, d, a, c), b = Nj(null, b, d, !0, f, c)) : (b.tag = 0, J && f && Jg(b), Aj(null, b, e, c), b = b.child);
            return b;
        case 16:
            d = b.elementType;
            a: {
                Mj(a, b);
                a = b.pendingProps;
                e = d._init;
                d = e(d._payload);
                b.type = d;
                e = b.tag = Ml(d);
                a = ej(d, a);
                switch(e){
                    case 0:
                        b = Gj(null, b, d, a, c);
                        break a;
                    case 1:
                        b = Lj(null, b, d, a, c);
                        break a;
                    case 11:
                        b = Bj(null, b, d, a, c);
                        break a;
                    case 14:
                        b = Dj(null, b, d, ej(d.type, a), c);
                        break a;
                }
                throw Error(p(306, d, ""));
            }
            return b;
        case 0:
            return d = b.type, e = b.pendingProps, e = b.elementType === d ? e : ej(d, e), Gj(a, b, d, e, c);
        case 1:
            return d = b.type, e = b.pendingProps, e = b.elementType === d ? e : ej(d, e), Lj(a, b, d, e, c);
        case 3:
            a: {
                Oj(b);
                if (null === a) throw Error(p(387));
                d = b.pendingProps;
                f = b.memoizedState;
                e = f.element;
                zh(a, b);
                Eh(b, d, null, c);
                var g = b.memoizedState;
                d = g.element;
                if (f.isDehydrated) {
                    if (f = {
                        element: d,
                        isDehydrated: !1,
                        cache: g.cache,
                        pendingSuspenseBoundaries: g.pendingSuspenseBoundaries,
                        transitions: g.transitions
                    }, b.updateQueue.baseState = f, b.memoizedState = f, b.flags & 256) {
                        e = lj(Error(p(423)), b);
                        b = Rj(a, b, d, c, e);
                        break a;
                    } else if (d !== e) {
                        e = lj(Error(p(424)), b);
                        b = Rj(a, b, d, c, e);
                        break a;
                    } else for(Mg = Zf(b.stateNode.containerInfo.firstChild), Lg = b, J = !0, Ng = null, c = ih(b, null, d, c), b.child = c; c;)c.flags = c.flags & -3 | 4096, c = c.sibling;
                } else {
                    Wg();
                    if (d === e) {
                        b = Cj(a, b, c);
                        break a;
                    }
                    Aj(a, b, d, c);
                }
                b = b.child;
            }
            return b;
        case 5:
            return Oh(b), null === a && Sg(b), d = b.type, e = b.pendingProps, f = null !== a ? a.memoizedProps : null, g = e.children, Sf(d, e) ? g = null : null !== f && Sf(d, f) && (b.flags |= 32), Kj(a, b), Aj(a, b, g, c), b.child;
        case 6:
            return null === a && Sg(b), null;
        case 13:
            return Uj(a, b, c);
        case 4:
            return Mh(b, b.stateNode.containerInfo), d = b.pendingProps, null === a ? b.child = hh(b, null, d, c) : Aj(a, b, d, c), b.child;
        case 11:
            return d = b.type, e = b.pendingProps, e = b.elementType === d ? e : ej(d, e), Bj(a, b, d, e, c);
        case 7:
            return Aj(a, b, b.pendingProps, c), b.child;
        case 8:
            return Aj(a, b, b.pendingProps.children, c), b.child;
        case 12:
            return b.flags |= 4, d = b.stateNode, d.effectDuration = 0, d.passiveEffectDuration = 0, Aj(a, b, b.pendingProps.children, c), b.child;
        case 10:
            a: {
                d = b.type._context;
                e = b.pendingProps;
                f = b.memoizedProps;
                g = e.value;
                H(jh, d._currentValue);
                d._currentValue = g;
                if (null !== f) {
                    if (Ve(f.value, g)) {
                        if (f.children === e.children && !jg.current) {
                            b = Cj(a, b, c);
                            break a;
                        }
                    } else for(f = b.child, null !== f && (f.return = b); null !== f;){
                        var h = f.dependencies;
                        if (null !== h) {
                            g = f.child;
                            for(var k = h.firstContext; null !== k;){
                                if (k.context === d) {
                                    if (1 === f.tag) {
                                        k = Ah(-1, c & -c);
                                        k.tag = 2;
                                        var l = f.updateQueue;
                                        if (null !== l) {
                                            l = l.shared;
                                            var n = l.pending;
                                            null === n ? k.next = k : (k.next = n.next, n.next = k);
                                            l.pending = k;
                                        }
                                    }
                                    f.lanes |= c;
                                    k = f.alternate;
                                    null !== k && (k.lanes |= c);
                                    ph(f.return, c, b);
                                    h.lanes |= c;
                                    break;
                                }
                                k = k.next;
                            }
                        } else if (10 === f.tag) g = f.type === b.type ? null : f.child;
                        else if (18 === f.tag) {
                            g = f.return;
                            if (null === g) throw Error(p(341));
                            g.lanes |= c;
                            h = g.alternate;
                            null !== h && (h.lanes |= c);
                            ph(g, c, b);
                            g = f.sibling;
                        } else g = f.child;
                        if (null !== g) g.return = f;
                        else for(g = f; null !== g;){
                            if (g === b) {
                                g = null;
                                break;
                            }
                            f = g.sibling;
                            if (null !== f) {
                                f.return = g.return;
                                g = f;
                                break;
                            }
                            g = g.return;
                        }
                        f = g;
                    }
                }
                Aj(a, b, e.children, c);
                b = b.child;
            }
            return b;
        case 9:
            return e = b.type, d = b.pendingProps.children, qh(b, c), e = sh(e), sc(b), d = d(e), tc(), b.flags |= 1, Aj(a, b, d, c), b.child;
        case 14:
            return d = b.type, e = ej(d, b.pendingProps), e = ej(d.type, e), Dj(a, b, d, e, c);
        case 15:
            return Fj(a, b, b.type, b.pendingProps, c);
        case 17:
            return d = b.type, e = b.pendingProps, e = b.elementType === d ? e : ej(d, e), Mj(a, b), b.tag = 1, mg(d) ? (a = !0, qg(b)) : a = !1, qh(b, c), ij(b, d, e), kj(b, d, e, c), Nj(null, b, d, !0, a, c);
        case 19:
            return dk(a, b, c);
        case 22:
            return Hj(a, b, c);
    }
    throw Error(p(156, b.tag));
};
function wj(a, b) {
    mc && a.memoizedUpdaters.forEach(function(c) {
        Pc(a, c, b);
    });
}
function rl(a, b) {
    return ac(a, b);
}
function Nl(a, b, c, d) {
    this.tag = a;
    this.key = c;
    this.sibling = this.child = this.return = this.stateNode = this.type = this.elementType = null;
    this.index = 0;
    this.ref = null;
    this.pendingProps = b;
    this.dependencies = this.memoizedState = this.updateQueue = this.memoizedProps = null;
    this.mode = d;
    this.subtreeFlags = this.flags = 0;
    this.deletions = null;
    this.childLanes = this.lanes = 0;
    this.alternate = null;
    this.actualDuration = 0;
    this.actualStartTime = -1;
    this.treeBaseDuration = this.selfBaseDuration = 0;
}
function Pg(a, b, c, d) {
    return new Nl(a, b, c, d);
}
function Ej(a) {
    a = a.prototype;
    return !(!a || !a.isReactComponent);
}
function Ml(a) {
    if ("function" === typeof a) return Ej(a) ? 1 : 0;
    if (void 0 !== a && null !== a) {
        a = a.$$typeof;
        if (a === Da) return 11;
        if (a === Ga) return 14;
    }
    return 2;
}
function ch(a, b) {
    var c = a.alternate;
    null === c ? (c = Pg(a.tag, b, a.key, a.mode), c.elementType = a.elementType, c.type = a.type, c.stateNode = a.stateNode, c.alternate = a, a.alternate = c) : (c.pendingProps = b, c.type = a.type, c.flags = 0, c.subtreeFlags = 0, c.deletions = null, c.actualDuration = 0, c.actualStartTime = -1);
    c.flags = a.flags & 14680064;
    c.childLanes = a.childLanes;
    c.lanes = a.lanes;
    c.child = a.child;
    c.memoizedProps = a.memoizedProps;
    c.memoizedState = a.memoizedState;
    c.updateQueue = a.updateQueue;
    b = a.dependencies;
    c.dependencies = null === b ? null : {
        lanes: b.lanes,
        firstContext: b.firstContext
    };
    c.sibling = a.sibling;
    c.index = a.index;
    c.ref = a.ref;
    c.selfBaseDuration = a.selfBaseDuration;
    c.treeBaseDuration = a.treeBaseDuration;
    return c;
}
function eh(a, b, c, d, e, f) {
    var g = 2;
    d = a;
    if ("function" === typeof a) Ej(a) && (g = 1);
    else if ("string" === typeof a) g = 5;
    else a: switch(a){
        case ya:
            return gh(c.children, e, f, b);
        case za:
            g = 8;
            e |= 8;
            break;
        case Aa:
            return a = Pg(12, c, b, e | 2), a.elementType = Aa, a.lanes = f, a.stateNode = {
                effectDuration: 0,
                passiveEffectDuration: 0
            }, a;
        case Ea:
            return a = Pg(13, c, b, e), a.elementType = Ea, a.lanes = f, a;
        case Fa:
            return a = Pg(19, c, b, e), a.elementType = Fa, a.lanes = f, a;
        case Ia:
            return Vj(c, e, f, b);
        default:
            if ("object" === typeof a && null !== a) switch(a.$$typeof){
                case Ba:
                    g = 10;
                    break a;
                case Ca:
                    g = 9;
                    break a;
                case Da:
                    g = 11;
                    break a;
                case Ga:
                    g = 14;
                    break a;
                case Ha:
                    g = 16;
                    d = null;
                    break a;
            }
            throw Error(p(130, null == a ? a : typeof a, ""));
    }
    b = Pg(g, c, b, e);
    b.elementType = a;
    b.type = d;
    b.lanes = f;
    return b;
}
function gh(a, b, c, d) {
    a = Pg(7, a, d, b);
    a.lanes = c;
    return a;
}
function Vj(a, b, c, d) {
    a = Pg(22, a, d, b);
    a.elementType = Ia;
    a.lanes = c;
    a.stateNode = {
        isHidden: !1
    };
    return a;
}
function dh(a, b, c) {
    a = Pg(6, a, null, b);
    a.lanes = c;
    return a;
}
function fh(a, b, c) {
    b = Pg(4, null !== a.children ? a.children : [], a.key, b);
    b.lanes = c;
    b.stateNode = {
        containerInfo: a.containerInfo,
        pendingChildren: null,
        implementation: a.implementation
    };
    return b;
}
function Ol(a, b, c, d, e) {
    this.tag = b;
    this.containerInfo = a;
    this.finishedWork = this.pingCache = this.current = this.pendingChildren = null;
    this.timeoutHandle = -1;
    this.callbackNode = this.pendingContext = this.context = null;
    this.callbackPriority = 0;
    this.eventTimes = Lc(0);
    this.expirationTimes = Lc(-1);
    this.entangledLanes = this.finishedLanes = this.mutableReadLanes = this.expiredLanes = this.pingedLanes = this.suspendedLanes = this.pendingLanes = 0;
    this.entanglements = Lc(0);
    this.identifierPrefix = d;
    this.onRecoverableError = e;
    this.mutableSourceEagerHydrationData = null;
    this.passiveEffectDuration = this.effectDuration = 0;
    this.memoizedUpdaters = new Set;
    a = this.pendingUpdatersLaneMap = [];
    for(b = 0; 31 > b; b++)a.push(new Set);
}
function Pl(a, b, c, d, e, f, g, h, k) {
    a = new Ol(a, b, c, h, k);
    1 === b ? (b = 1, !0 === f && (b |= 8)) : b = 0;
    mc && (b |= 2);
    f = Pg(3, null, null, b);
    a.current = f;
    f.stateNode = a;
    f.memoizedState = {
        element: d,
        isDehydrated: c,
        cache: null,
        transitions: null,
        pendingSuspenseBoundaries: null
    };
    yh(f);
    return a;
}
function Ql(a, b, c) {
    var d = 3 < arguments.length && void 0 !== arguments[3] ? arguments[3] : null;
    return {
        $$typeof: xa,
        key: null == d ? null : "" + d,
        children: a,
        containerInfo: b,
        implementation: c
    };
}
function Rl(a) {
    if (!a) return ig;
    a = a._reactInternals;
    a: {
        if (Vb(a) !== a || 1 !== a.tag) throw Error(p(170));
        var b = a;
        do {
            switch(b.tag){
                case 3:
                    b = b.stateNode.context;
                    break a;
                case 1:
                    if (mg(b.type)) {
                        b = b.stateNode.__reactInternalMemoizedMergedChildContext;
                        break a;
                    }
            }
            b = b.return;
        }while (null !== b);
        throw Error(p(171));
    }
    if (1 === a.tag) {
        var c = a.type;
        if (mg(c)) return pg(a, c, b);
    }
    return b;
}
function Sl(a, b, c, d, e, f, g, h, k) {
    a = Pl(c, d, !0, a, e, f, g, h, k);
    a.context = Rl(null);
    c = a.current;
    d = Ri();
    e = Oi(c);
    f = Ah(d, e);
    f.callback = void 0 !== b && null !== b ? b : null;
    Bh(c, f, e);
    a.current.lanes = e;
    Mc(a, e, d);
    pl(a, d);
    return a;
}
function Tl(a, b, c, d) {
    var e = b.current, f = Ri(), g = Oi(e);
    null !== B && "function" === typeof B.markRenderScheduled && B.markRenderScheduled(g);
    c = Rl(c);
    null === b.context ? b.context = c : b.pendingContext = c;
    b = Ah(f, g);
    b.payload = {
        element: a
    };
    d = void 0 === d ? null : d;
    null !== d && (b.callback = d);
    a = Bh(e, b, g);
    null !== a && (ui(a, e, g, f), Ch(a, e, g));
    return g;
}
function Ul(a) {
    a = a.current;
    if (!a.child) return null;
    switch(a.child.tag){
        case 5:
            return a.child.stateNode;
        default:
            return a.child.stateNode;
    }
}
function Vl(a, b) {
    a = a.memoizedState;
    if (null !== a && null !== a.dehydrated) {
        var c = a.retryLane;
        a.retryLane = 0 !== c && c < b ? c : b;
    }
}
function Wl(a, b) {
    Vl(a, b);
    (a = a.alternate) && Vl(a, b);
}
function Xl() {
    return null;
}
var Yl = "function" === typeof reportError ? reportError : function(a) {
    console.error(a);
};
function Zl(a) {
    this._internalRoot = a;
}
$l.prototype.render = Zl.prototype.render = function(a) {
    var b = this._internalRoot;
    if (null === b) throw Error(p(409));
    Tl(a, b, null, null);
};
$l.prototype.unmount = Zl.prototype.unmount = function() {
    var a = this._internalRoot;
    if (null !== a) {
        this._internalRoot = null;
        var b = a.containerInfo;
        El(function() {
            Tl(null, a, null, null);
        });
        b[If] = null;
    }
};
function $l(a) {
    this._internalRoot = a;
}
$l.prototype.unstable_scheduleHydration = function(a) {
    if (a) {
        var b = Vc();
        a = {
            blockedOn: null,
            target: a,
            priority: b
        };
        for(var c = 0; c < dd.length && 0 !== b && b < dd[c].priority; c++);
        dd.splice(c, 0, a);
        0 === c && id(a);
    }
};
function am(a) {
    return !(!a || 1 !== a.nodeType && 9 !== a.nodeType && 11 !== a.nodeType);
}
function bm(a) {
    return !(!a || 1 !== a.nodeType && 9 !== a.nodeType && 11 !== a.nodeType && (8 !== a.nodeType || " react-mount-point-unstable " !== a.nodeValue));
}
function cm() {}
function dm(a, b, c, d, e) {
    if (e) {
        if ("function" === typeof d) {
            var f = d;
            d = function() {
                var a = Ul(g);
                f.call(a);
            };
        }
        var g = Sl(b, d, a, 0, null, !1, !1, "", cm);
        a._reactRootContainer = g;
        a[If] = g.current;
        Gf(8 === a.nodeType ? a.parentNode : a);
        El();
        return g;
    }
    for(; e = a.lastChild;)a.removeChild(e);
    if ("function" === typeof d) {
        var h = d;
        d = function() {
            var a = Ul(k);
            h.call(a);
        };
    }
    var k = Pl(a, 0, !1, null, null, !1, !1, "", cm);
    a._reactRootContainer = k;
    a[If] = k.current;
    Gf(8 === a.nodeType ? a.parentNode : a);
    El(function() {
        Tl(b, k, c, d);
    });
    return k;
}
function em(a, b, c, d, e) {
    var f = c._reactRootContainer;
    if (f) {
        var g = f;
        if ("function" === typeof e) {
            var h = e;
            e = function() {
                var a = Ul(g);
                h.call(a);
            };
        }
        Tl(b, g, a, e);
    } else g = dm(c, b, a, e, d);
    return Ul(g);
}
Sc = function(a) {
    switch(a.tag){
        case 3:
            var b = a.stateNode;
            if (b.current.memoizedState.isDehydrated) {
                var c = Fc(b.pendingLanes);
                0 !== c && (Oc(b, c | 1), pl(b, A()), 0 === (K & 6) && (mk = A() + 500, xg()));
            }
            break;
        case 13:
            El(function() {
                var b = wh(a, 1);
                if (null !== b) {
                    var c = Ri();
                    ui(b, a, 1, c);
                }
            }), Wl(a, 1);
    }
};
Tc = function(a) {
    if (13 === a.tag) {
        var b = wh(a, 134217728);
        if (null !== b) {
            var c = Ri();
            ui(b, a, 134217728, c);
        }
        Wl(a, 134217728);
    }
};
Uc = function(a) {
    if (13 === a.tag) {
        var b = Oi(a), c = wh(a, b);
        if (null !== c) {
            var d = Ri();
            ui(c, a, b, d);
        }
        Wl(a, b);
    }
};
Vc = function() {
    return E;
};
Wc = function(a, b) {
    var c = E;
    try {
        return E = a, b();
    } finally{
        E = c;
    }
};
yb = function(a, b, c) {
    switch(b){
        case "input":
            ab(a, c);
            b = c.name;
            if ("radio" === c.type && null != b) {
                for(c = a; c.parentNode;)c = c.parentNode;
                c = c.querySelectorAll("input[name=" + JSON.stringify("" + b) + '][type="radio"]');
                for(b = 0; b < c.length; b++){
                    var d = c[b];
                    if (d !== a && d.form === a.form) {
                        var e = Db(d);
                        if (!e) throw Error(p(90));
                        Wa(d);
                        ab(d, e);
                    }
                }
            }
            break;
        case "textarea":
            hb(a, c);
            break;
        case "select":
            b = c.value, null != b && eb(a, !!c.multiple, b, !1);
    }
};
Gb = Dl;
Hb = El;
var fm = {
    usingClientEntryPoint: !1,
    Events: [
        Cb,
        Ie,
        Db,
        Eb,
        Fb,
        Dl
    ]
}, gm = {
    findFiberByHostInstance: jd,
    bundleType: 0,
    version: "18.3.1",
    rendererPackageName: "react-dom"
};
(function(a) {
    if ("undefined" === typeof __REACT_DEVTOOLS_GLOBAL_HOOK__) return !1;
    var b = __REACT_DEVTOOLS_GLOBAL_HOOK__;
    if (b.isDisabled || !b.supportsFiber) return !0;
    try {
        a = u({}, a, {
            getLaneLabelMap: pc,
            injectProfilingHooks: oc
        }), kc = b.inject(a), lc = b;
    } catch (c) {}
    return b.checkDCE ? !0 : !1;
})({
    bundleType: gm.bundleType,
    version: gm.version,
    rendererPackageName: gm.rendererPackageName,
    rendererConfig: gm.rendererConfig,
    overrideHookState: null,
    overrideHookStateDeletePath: null,
    overrideHookStateRenamePath: null,
    overrideProps: null,
    overridePropsDeletePath: null,
    overridePropsRenamePath: null,
    setErrorHandler: null,
    setSuspenseHandler: null,
    scheduleUpdate: null,
    currentDispatcherRef: va.ReactCurrentDispatcher,
    findHostInstanceByFiber: function(a) {
        a = Zb(a);
        return null === a ? null : a.stateNode;
    },
    findFiberByHostInstance: gm.findFiberByHostInstance || Xl,
    findHostInstancesForRefresh: null,
    scheduleRefresh: null,
    scheduleRoot: null,
    setRefreshHandler: null,
    getCurrentFiber: null,
    reconcilerVersion: "18.3.1-next-f1338f8080-20240426"
});
exports.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED = fm;
exports.createPortal = function(a, b) {
    var c = 2 < arguments.length && void 0 !== arguments[2] ? arguments[2] : null;
    if (!am(b)) throw Error(p(200));
    return Ql(a, b, null, c);
};
exports.createRoot = function(a, b) {
    if (!am(a)) throw Error(p(299));
    var c = !1, d = "", e = Yl;
    null !== b && void 0 !== b && (!0 === b.unstable_strictMode && (c = !0), void 0 !== b.identifierPrefix && (d = b.identifierPrefix), void 0 !== b.onRecoverableError && (e = b.onRecoverableError));
    b = Pl(a, 1, !1, null, null, c, !1, d, e);
    a[If] = b.current;
    Gf(8 === a.nodeType ? a.parentNode : a);
    return new Zl(b);
};
exports.findDOMNode = function(a) {
    if (null == a) return null;
    if (1 === a.nodeType) return a;
    var b = a._reactInternals;
    if (void 0 === b) {
        if ("function" === typeof a.render) throw Error(p(188));
        a = Object.keys(a).join(",");
        throw Error(p(268, a));
    }
    a = Zb(b);
    a = null === a ? null : a.stateNode;
    return a;
};
exports.flushSync = function(a) {
    return El(a);
};
exports.hydrate = function(a, b, c) {
    if (!bm(b)) throw Error(p(200));
    return em(null, a, b, !0, c);
};
exports.hydrateRoot = function(a, b, c) {
    if (!am(a)) throw Error(p(405));
    var d = null != c && c.hydratedSources || null, e = !1, f = "", g = Yl;
    null !== c && void 0 !== c && (!0 === c.unstable_strictMode && (e = !0), void 0 !== c.identifierPrefix && (f = c.identifierPrefix), void 0 !== c.onRecoverableError && (g = c.onRecoverableError));
    b = Sl(b, null, a, 1, null != c ? c : null, e, !1, f, g);
    a[If] = b.current;
    Gf(a);
    if (d) for(a = 0; a < d.length; a++)c = d[a], e = c._getVersion, e = e(c._source), null == b.mutableSourceEagerHydrationData ? b.mutableSourceEagerHydrationData = [
        c,
        e
    ] : b.mutableSourceEagerHydrationData.push(c, e);
    return new $l(b);
};
exports.render = function(a, b, c) {
    if (!bm(b)) throw Error(p(200));
    return em(null, a, b, !1, c);
};
exports.unmountComponentAtNode = function(a) {
    if (!bm(a)) throw Error(p(40));
    return a._reactRootContainer ? (El(function() {
        em(null, null, a, !1, function() {
            a._reactRootContainer = null;
            a[If] = null;
        });
    }), !0) : !1;
};
exports.unstable_batchedUpdates = Dl;
exports.unstable_renderSubtreeIntoContainer = function(a, b, c, d) {
    if (!bm(c)) throw Error(p(200));
    if (null == a || void 0 === a._reactInternals) throw Error(p(38));
    return em(a, b, c, !1, d);
};
exports.version = "18.3.1-next-f1338f8080-20240426";
/* global __REACT_DEVTOOLS_GLOBAL_HOOK__ */ if (typeof __REACT_DEVTOOLS_GLOBAL_HOOK__ !== 'undefined' && typeof __REACT_DEVTOOLS_GLOBAL_HOOK__.registerInternalModuleStop === 'function') __REACT_DEVTOOLS_GLOBAL_HOOK__.registerInternalModuleStop(new Error());

},{"9b7a2cbfda883b4f":"ltHCL","3dd33f013095511":"NHulo"}],"NHulo":[function(require,module,exports,__globalThis) {
'use strict';
module.exports = require("839efe1522e0edb9");

},{"839efe1522e0edb9":"flVYN"}],"flVYN":[function(require,module,exports,__globalThis) {
/**
 * @license React
 * scheduler.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ 'use strict';
function f(a, b) {
    var c = a.length;
    a.push(b);
    a: for(; 0 < c;){
        var d = c - 1 >>> 1, e = a[d];
        if (0 < g(e, b)) a[d] = b, a[c] = e, c = d;
        else break a;
    }
}
function h(a) {
    return 0 === a.length ? null : a[0];
}
function k(a) {
    if (0 === a.length) return null;
    var b = a[0], c = a.pop();
    if (c !== b) {
        a[0] = c;
        a: for(var d = 0, e = a.length, w = e >>> 1; d < w;){
            var m = 2 * (d + 1) - 1, C = a[m], n = m + 1, x = a[n];
            if (0 > g(C, c)) n < e && 0 > g(x, C) ? (a[d] = x, a[n] = c, d = n) : (a[d] = C, a[m] = c, d = m);
            else if (n < e && 0 > g(x, c)) a[d] = x, a[n] = c, d = n;
            else break a;
        }
    }
    return b;
}
function g(a, b) {
    var c = a.sortIndex - b.sortIndex;
    return 0 !== c ? c : a.id - b.id;
}
if ("object" === typeof performance && "function" === typeof performance.now) {
    var l = performance;
    exports.unstable_now = function() {
        return l.now();
    };
} else {
    var p = Date, q = p.now();
    exports.unstable_now = function() {
        return p.now() - q;
    };
}
var r = [], t = [], u = 1, v = null, y = 3, z = !1, A = !1, B = !1, D = "function" === typeof setTimeout ? setTimeout : null, E = "function" === typeof clearTimeout ? clearTimeout : null, F = "undefined" !== typeof setImmediate ? setImmediate : null;
"undefined" !== typeof navigator && void 0 !== navigator.scheduling && void 0 !== navigator.scheduling.isInputPending && navigator.scheduling.isInputPending.bind(navigator.scheduling);
function G(a) {
    for(var b = h(t); null !== b;){
        if (null === b.callback) k(t);
        else if (b.startTime <= a) k(t), b.sortIndex = b.expirationTime, f(r, b);
        else break;
        b = h(t);
    }
}
function H(a) {
    B = !1;
    G(a);
    if (!A) {
        if (null !== h(r)) A = !0, I(J);
        else {
            var b = h(t);
            null !== b && K(H, b.startTime - a);
        }
    }
}
function J(a, b) {
    A = !1;
    B && (B = !1, E(L), L = -1);
    z = !0;
    var c = y;
    try {
        G(b);
        for(v = h(r); null !== v && (!(v.expirationTime > b) || a && !M());){
            var d = v.callback;
            if ("function" === typeof d) {
                v.callback = null;
                y = v.priorityLevel;
                var e = d(v.expirationTime <= b);
                b = exports.unstable_now();
                "function" === typeof e ? v.callback = e : v === h(r) && k(r);
                G(b);
            } else k(r);
            v = h(r);
        }
        if (null !== v) var w = !0;
        else {
            var m = h(t);
            null !== m && K(H, m.startTime - b);
            w = !1;
        }
        return w;
    } finally{
        v = null, y = c, z = !1;
    }
}
var N = !1, O = null, L = -1, P = 5, Q = -1;
function M() {
    return exports.unstable_now() - Q < P ? !1 : !0;
}
function R() {
    if (null !== O) {
        var a = exports.unstable_now();
        Q = a;
        var b = !0;
        try {
            b = O(!0, a);
        } finally{
            b ? S() : (N = !1, O = null);
        }
    } else N = !1;
}
var S;
if ("function" === typeof F) S = function() {
    F(R);
};
else if ("undefined" !== typeof MessageChannel) {
    var T = new MessageChannel, U = T.port2;
    T.port1.onmessage = R;
    S = function() {
        U.postMessage(null);
    };
} else S = function() {
    D(R, 0);
};
function I(a) {
    O = a;
    N || (N = !0, S());
}
function K(a, b) {
    L = D(function() {
        a(exports.unstable_now());
    }, b);
}
exports.unstable_IdlePriority = 5;
exports.unstable_ImmediatePriority = 1;
exports.unstable_LowPriority = 4;
exports.unstable_NormalPriority = 3;
exports.unstable_Profiling = null;
exports.unstable_UserBlockingPriority = 2;
exports.unstable_cancelCallback = function(a) {
    a.callback = null;
};
exports.unstable_continueExecution = function() {
    A || z || (A = !0, I(J));
};
exports.unstable_forceFrameRate = function(a) {
    0 > a || 125 < a ? console.error("forceFrameRate takes a positive int between 0 and 125, forcing frame rates higher than 125 fps is not supported") : P = 0 < a ? Math.floor(1E3 / a) : 5;
};
exports.unstable_getCurrentPriorityLevel = function() {
    return y;
};
exports.unstable_getFirstCallbackNode = function() {
    return h(r);
};
exports.unstable_next = function(a) {
    switch(y){
        case 1:
        case 2:
        case 3:
            var b = 3;
            break;
        default:
            b = y;
    }
    var c = y;
    y = b;
    try {
        return a();
    } finally{
        y = c;
    }
};
exports.unstable_pauseExecution = function() {};
exports.unstable_requestPaint = function() {};
exports.unstable_runWithPriority = function(a, b) {
    switch(a){
        case 1:
        case 2:
        case 3:
        case 4:
        case 5:
            break;
        default:
            a = 3;
    }
    var c = y;
    y = a;
    try {
        return b();
    } finally{
        y = c;
    }
};
exports.unstable_scheduleCallback = function(a, b, c) {
    var d = exports.unstable_now();
    "object" === typeof c && null !== c ? (c = c.delay, c = "number" === typeof c && 0 < c ? d + c : d) : c = d;
    switch(a){
        case 1:
            var e = -1;
            break;
        case 2:
            e = 250;
            break;
        case 5:
            e = 1073741823;
            break;
        case 4:
            e = 1E4;
            break;
        default:
            e = 5E3;
    }
    e = c + e;
    a = {
        id: u++,
        callback: b,
        priorityLevel: a,
        startTime: c,
        expirationTime: e,
        sortIndex: -1
    };
    c > d ? (a.sortIndex = c, f(t, a), null === h(r) && a === h(t) && (B ? (E(L), L = -1) : B = !0, K(H, c - d))) : (a.sortIndex = e, f(r, a), A || z || (A = !0, I(J)));
    return a;
};
exports.unstable_shouldYield = M;
exports.unstable_wrapCallback = function(a) {
    var b = y;
    return function() {
        var c = y;
        y = b;
        try {
            return a.apply(this, arguments);
        } finally{
            y = c;
        }
    };
};

},{}],"jRpVs":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _studioFoundations = require("@atlassian/studio-foundations");
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-global-styles
var _globalCss = require("./global.css");
window.STUDIO_APP_VERSION = "44a48f4d3c3789c448a2920295d44995df9861f4";
const App = ()=>{
    return /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _studioFoundations.StudioFoundationsApp), null);
};
exports.default = App;

},{"react":"ltHCL","@atlassian/studio-foundations":"9t6qD","./global.css":"2rLHj","@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"9t6qD":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "StudioFoundationsApp", ()=>(0, _wrappedApp.WrappedApp));
var _wrappedApp = require("./WrappedApp");

},{"./WrappedApp":"kdbwZ","@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"kdbwZ":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "WrappedApp", ()=>WrappedApp);
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _reactQuery = require("@tanstack/react-query");
var _atlassianStudioApi = require("@atlassian/atlassian-studio-api");
var _atlassianStudioObservability = require("@atlassian/atlassian-studio-observability");
var _atlassianStudioUiComponents = require("@atlassian/atlassian-studio-ui-components");
var _relayEnvironmentProvider = require("@atlassian/relay-environment-provider");
var _appSelector = require("./AppSelector");
var _redirectUtils = require("./common/utils/redirect-utils");
(0, _atlassianStudioObservability.setupSentryClient)({
    packageName: '@atlassian/studio-foundations'
});
const WrappedApp = ()=>{
    return /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _react.Suspense), {
        fallback: /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _atlassianStudioUiComponents.PageMainContentLoadingLogo), {
            interactionName: "studio-foundations-wrapped-app"
        })
    }, /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _relayEnvironmentProvider.AtlassianRelayEnvironmentProvider), null, /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _reactQuery.QueryClientProvider), {
        client: (0, _atlassianStudioApi.queryClient)
    }, /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _atlassianStudioObservability.SentryErrorBoundary), {
        fallbackComponent: ()=>null,
        onError: (0, _redirectUtils.redirectToLogin)
    }, /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _appSelector.AppSelector), null)))));
};

},{"react":"ltHCL","@tanstack/react-query":"buDng","@atlassian/atlassian-studio-api":"dAFDt","@atlassian/atlassian-studio-observability":"5cVsH","@atlassian/atlassian-studio-ui-components":"k3dox","@atlassian/relay-environment-provider":"5UJMi","./AppSelector":"7U9xJ","./common/utils/redirect-utils":"37MGn","@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"buDng":[function(require,module,exports,__globalThis) {
// src/index.ts
var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "HydrationBoundary", ()=>(0, _hydrationBoundaryJs.HydrationBoundary));
parcelHelpers.export(exports, "IsRestoringProvider", ()=>(0, _isRestoringProviderJs.IsRestoringProvider));
parcelHelpers.export(exports, "QueryClientContext", ()=>(0, _queryClientProviderJs.QueryClientContext));
parcelHelpers.export(exports, "QueryClientProvider", ()=>(0, _queryClientProviderJs.QueryClientProvider));
parcelHelpers.export(exports, "QueryErrorResetBoundary", ()=>(0, _queryErrorResetBoundaryJs.QueryErrorResetBoundary));
parcelHelpers.export(exports, "infiniteQueryOptions", ()=>(0, _infiniteQueryOptionsJs.infiniteQueryOptions));
parcelHelpers.export(exports, "mutationOptions", ()=>(0, _mutationOptionsJs.mutationOptions));
parcelHelpers.export(exports, "queryOptions", ()=>(0, _queryOptionsJs.queryOptions));
parcelHelpers.export(exports, "useInfiniteQuery", ()=>(0, _useInfiniteQueryJs.useInfiniteQuery));
parcelHelpers.export(exports, "useIsFetching", ()=>(0, _useIsFetchingJs.useIsFetching));
parcelHelpers.export(exports, "useIsMutating", ()=>(0, _useMutationStateJs.useIsMutating));
parcelHelpers.export(exports, "useIsRestoring", ()=>(0, _isRestoringProviderJs.useIsRestoring));
parcelHelpers.export(exports, "useMutation", ()=>(0, _useMutationJs.useMutation));
parcelHelpers.export(exports, "useMutationState", ()=>(0, _useMutationStateJs.useMutationState));
parcelHelpers.export(exports, "usePrefetchInfiniteQuery", ()=>(0, _usePrefetchInfiniteQueryJs.usePrefetchInfiniteQuery));
parcelHelpers.export(exports, "usePrefetchQuery", ()=>(0, _usePrefetchQueryJs.usePrefetchQuery));
parcelHelpers.export(exports, "useQueries", ()=>(0, _useQueriesJs.useQueries));
parcelHelpers.export(exports, "useQuery", ()=>(0, _useQueryJs.useQuery));
parcelHelpers.export(exports, "useQueryClient", ()=>(0, _queryClientProviderJs.useQueryClient));
parcelHelpers.export(exports, "useQueryErrorResetBoundary", ()=>(0, _queryErrorResetBoundaryJs.useQueryErrorResetBoundary));
parcelHelpers.export(exports, "useSuspenseInfiniteQuery", ()=>(0, _useSuspenseInfiniteQueryJs.useSuspenseInfiniteQuery));
parcelHelpers.export(exports, "useSuspenseQueries", ()=>(0, _useSuspenseQueriesJs.useSuspenseQueries));
parcelHelpers.export(exports, "useSuspenseQuery", ()=>(0, _useSuspenseQueryJs.useSuspenseQuery));
var _queryCore = require("@tanstack/query-core");
parcelHelpers.exportAll(_queryCore, exports);
var _typesJs = require("./types.js");
parcelHelpers.exportAll(_typesJs, exports);
var _useQueriesJs = require("./useQueries.js");
var _useQueryJs = require("./useQuery.js");
var _useSuspenseQueryJs = require("./useSuspenseQuery.js");
var _useSuspenseInfiniteQueryJs = require("./useSuspenseInfiniteQuery.js");
var _useSuspenseQueriesJs = require("./useSuspenseQueries.js");
var _usePrefetchQueryJs = require("./usePrefetchQuery.js");
var _usePrefetchInfiniteQueryJs = require("./usePrefetchInfiniteQuery.js");
var _queryOptionsJs = require("./queryOptions.js");
var _infiniteQueryOptionsJs = require("./infiniteQueryOptions.js");
var _queryClientProviderJs = require("./QueryClientProvider.js");
var _hydrationBoundaryJs = require("./HydrationBoundary.js");
var _queryErrorResetBoundaryJs = require("./QueryErrorResetBoundary.js");
var _useIsFetchingJs = require("./useIsFetching.js");
var _useMutationStateJs = require("./useMutationState.js");
var _useMutationJs = require("./useMutation.js");
var _mutationOptionsJs = require("./mutationOptions.js");
var _useInfiniteQueryJs = require("./useInfiniteQuery.js");
var _isRestoringProviderJs = require("./IsRestoringProvider.js");

},{"@tanstack/query-core":"6f4TB","./types.js":"7BIr6","./useQueries.js":false,"./useQuery.js":"j7hrr","./useSuspenseQuery.js":"iHOqf","./useSuspenseInfiniteQuery.js":"gnaxx","./useSuspenseQueries.js":false,"./usePrefetchQuery.js":false,"./usePrefetchInfiniteQuery.js":false,"./queryOptions.js":"h8o4n","./infiniteQueryOptions.js":"c82q9","./QueryClientProvider.js":"3ogTH","./HydrationBoundary.js":false,"./QueryErrorResetBoundary.js":false,"./useIsFetching.js":false,"./useMutationState.js":"lq41E","./useMutation.js":"hhJXU","./mutationOptions.js":false,"./useInfiniteQuery.js":false,"./IsRestoringProvider.js":false,"@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"6f4TB":[function(require,module,exports,__globalThis) {
// src/index.ts
var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "CancelledError", ()=>(0, _retryerJs.CancelledError));
parcelHelpers.export(exports, "InfiniteQueryObserver", ()=>(0, _infiniteQueryObserverJs.InfiniteQueryObserver));
parcelHelpers.export(exports, "Mutation", ()=>(0, _mutationJs.Mutation));
parcelHelpers.export(exports, "MutationCache", ()=>(0, _mutationCacheJs.MutationCache));
parcelHelpers.export(exports, "MutationObserver", ()=>(0, _mutationObserverJs.MutationObserver));
parcelHelpers.export(exports, "QueriesObserver", ()=>(0, _queriesObserverJs.QueriesObserver));
parcelHelpers.export(exports, "Query", ()=>(0, _queryJs.Query));
parcelHelpers.export(exports, "QueryCache", ()=>(0, _queryCacheJs.QueryCache));
parcelHelpers.export(exports, "QueryClient", ()=>(0, _queryClientJs.QueryClient));
parcelHelpers.export(exports, "QueryObserver", ()=>(0, _queryObserverJs.QueryObserver));
parcelHelpers.export(exports, "defaultScheduler", ()=>(0, _notifyManagerJs.defaultScheduler));
parcelHelpers.export(exports, "defaultShouldDehydrateMutation", ()=>(0, _hydrationJs.defaultShouldDehydrateMutation));
parcelHelpers.export(exports, "defaultShouldDehydrateQuery", ()=>(0, _hydrationJs.defaultShouldDehydrateQuery));
parcelHelpers.export(exports, "dehydrate", ()=>(0, _hydrationJs.dehydrate));
parcelHelpers.export(exports, "experimental_streamedQuery", ()=>(0, _streamedQueryJs.streamedQuery));
parcelHelpers.export(exports, "focusManager", ()=>(0, _focusManagerJs.focusManager));
parcelHelpers.export(exports, "hashKey", ()=>(0, _utilsJs.hashKey));
parcelHelpers.export(exports, "hydrate", ()=>(0, _hydrationJs.hydrate));
parcelHelpers.export(exports, "isCancelledError", ()=>(0, _retryerJs.isCancelledError));
parcelHelpers.export(exports, "isServer", ()=>(0, _utilsJs.isServer));
parcelHelpers.export(exports, "keepPreviousData", ()=>(0, _utilsJs.keepPreviousData));
parcelHelpers.export(exports, "matchMutation", ()=>(0, _utilsJs.matchMutation));
parcelHelpers.export(exports, "matchQuery", ()=>(0, _utilsJs.matchQuery));
parcelHelpers.export(exports, "noop", ()=>(0, _utilsJs.noop));
parcelHelpers.export(exports, "notifyManager", ()=>(0, _notifyManagerJs.notifyManager));
parcelHelpers.export(exports, "onlineManager", ()=>(0, _onlineManagerJs.onlineManager));
parcelHelpers.export(exports, "partialMatchKey", ()=>(0, _utilsJs.partialMatchKey));
parcelHelpers.export(exports, "replaceEqualDeep", ()=>(0, _utilsJs.replaceEqualDeep));
parcelHelpers.export(exports, "shouldThrowError", ()=>(0, _utilsJs.shouldThrowError));
parcelHelpers.export(exports, "skipToken", ()=>(0, _utilsJs.skipToken));
parcelHelpers.export(exports, "timeoutManager", ()=>(0, _timeoutManagerJs.timeoutManager));
var _focusManagerJs = require("./focusManager.js");
var _hydrationJs = require("./hydration.js");
var _infiniteQueryObserverJs = require("./infiniteQueryObserver.js");
var _mutationCacheJs = require("./mutationCache.js");
var _mutationObserverJs = require("./mutationObserver.js");
var _notifyManagerJs = require("./notifyManager.js");
var _onlineManagerJs = require("./onlineManager.js");
var _queriesObserverJs = require("./queriesObserver.js");
var _queryCacheJs = require("./queryCache.js");
var _queryClientJs = require("./queryClient.js");
var _queryObserverJs = require("./queryObserver.js");
var _retryerJs = require("./retryer.js");
var _timeoutManagerJs = require("./timeoutManager.js");
var _utilsJs = require("./utils.js");
var _streamedQueryJs = require("./streamedQuery.js");
var _mutationJs = require("./mutation.js");
var _queryJs = require("./query.js");
var _typesJs = require("./types.js");
parcelHelpers.exportAll(_typesJs, exports);

},{"./focusManager.js":false,"./hydration.js":false,"./infiniteQueryObserver.js":"2DHf3","./mutationCache.js":false,"./mutationObserver.js":"5yYi9","./notifyManager.js":"zBbK9","./onlineManager.js":false,"./queriesObserver.js":false,"./queryCache.js":false,"./queryClient.js":"4q1ux","./queryObserver.js":"Q7hlL","./retryer.js":false,"./timeoutManager.js":false,"./utils.js":"iAuYt","./streamedQuery.js":false,"./mutation.js":false,"./query.js":false,"./types.js":false,"@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"d6FbS":[function(require,module,exports,__globalThis) {
// src/focusManager.ts
var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "FocusManager", ()=>FocusManager);
parcelHelpers.export(exports, "focusManager", ()=>focusManager);
var _classPrivateFieldGet = require("@swc/helpers/_/_class_private_field_get");
var _classPrivateFieldInit = require("@swc/helpers/_/_class_private_field_init");
var _classPrivateFieldSet = require("@swc/helpers/_/_class_private_field_set");
var _subscribableJs = require("./subscribable.js");
var _utilsJs = require("./utils.js");
var _focused, _cleanup, _setup;
var FocusManager = (_focused = /*#__PURE__*/ new WeakMap(), _cleanup = /*#__PURE__*/ new WeakMap(), _setup = /*#__PURE__*/ new WeakMap(), class extends (0, _subscribableJs.Subscribable) {
    onSubscribe() {
        if (!(0, _classPrivateFieldGet._)(this, _cleanup)) this.setEventListener((0, _classPrivateFieldGet._)(this, _setup));
    }
    onUnsubscribe() {
        var _this, _this1, _ref;
        if (!this.hasListeners()) {
            (_this = (0, _classPrivateFieldGet._)(_ref = _this1 = this, _cleanup)) === null || _this === void 0 ? void 0 : _this.call(_this1);
            (0, _classPrivateFieldSet._)(this, _cleanup, void 0);
        }
    }
    setEventListener(setup) {
        var _this, _this1, _ref;
        (0, _classPrivateFieldSet._)(this, _setup, setup);
        (_this = (0, _classPrivateFieldGet._)(_ref = _this1 = this, _cleanup)) === null || _this === void 0 ? void 0 : _this.call(_this1);
        (0, _classPrivateFieldSet._)(this, _cleanup, setup((focused)=>{
            if (typeof focused === "boolean") this.setFocused(focused);
            else this.onFocus();
        }));
    }
    setFocused(focused) {
        const changed = (0, _classPrivateFieldGet._)(this, _focused) !== focused;
        if (changed) {
            (0, _classPrivateFieldSet._)(this, _focused, focused);
            this.onFocus();
        }
    }
    onFocus() {
        const isFocused = this.isFocused();
        this.listeners.forEach((listener)=>{
            listener(isFocused);
        });
    }
    isFocused() {
        var _globalThis_document;
        if (typeof (0, _classPrivateFieldGet._)(this, _focused) === "boolean") return (0, _classPrivateFieldGet._)(this, _focused);
        return ((_globalThis_document = globalThis.document) === null || _globalThis_document === void 0 ? void 0 : _globalThis_document.visibilityState) !== "hidden";
    }
    constructor(){
        super(), (0, _classPrivateFieldInit._)(this, _focused, {
            writable: true,
            value: void 0
        }), (0, _classPrivateFieldInit._)(this, _cleanup, {
            writable: true,
            value: void 0
        }), (0, _classPrivateFieldInit._)(this, _setup, {
            writable: true,
            value: void 0
        });
        (0, _classPrivateFieldSet._)(this, _setup, (onFocus)=>{
            if (!(0, _utilsJs.isServer) && window.addEventListener) {
                const listener = ()=>onFocus();
                window.addEventListener("visibilitychange", listener, false);
                return ()=>{
                    window.removeEventListener("visibilitychange", listener);
                };
            }
            return;
        });
    }
});
var focusManager = new FocusManager();

},{"@swc/helpers/_/_class_private_field_get":"iWIk2","@swc/helpers/_/_class_private_field_init":"fKzMI","@swc/helpers/_/_class_private_field_set":"7xEQl","./subscribable.js":"94fke","./utils.js":"iAuYt","@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"iWIk2":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "_", ()=>_class_private_field_get);
var _classApplyDescriptorGetJs = require("./_class_apply_descriptor_get.js");
var _classExtractFieldDescriptorJs = require("./_class_extract_field_descriptor.js");
function _class_private_field_get(receiver, privateMap) {
    var descriptor = (0, _classExtractFieldDescriptorJs._)(receiver, privateMap, "get");
    return (0, _classApplyDescriptorGetJs._)(receiver, descriptor);
}

},{"./_class_apply_descriptor_get.js":"4mD2o","./_class_extract_field_descriptor.js":"dwhkO","@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"4mD2o":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "_", ()=>_class_apply_descriptor_get);
function _class_apply_descriptor_get(receiver, descriptor) {
    if (descriptor.get) return descriptor.get.call(receiver);
    return descriptor.value;
}

},{"@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"6QcHb":[function(require,module,exports,__globalThis) {
exports.interopDefault = function(a) {
    return a && a.__esModule ? a : {
        default: a
    };
};
exports.defineInteropFlag = function(a) {
    Object.defineProperty(a, '__esModule', {
        value: true
    });
};
exports.exportAll = function(source, dest) {
    Object.keys(source).forEach(function(key) {
        if (key === 'default' || key === '__esModule' || Object.prototype.hasOwnProperty.call(dest, key)) return;
        Object.defineProperty(dest, key, {
            enumerable: true,
            get: function() {
                return source[key];
            }
        });
    });
    return dest;
};
exports.export = function(dest, destName, get) {
    Object.defineProperty(dest, destName, {
        enumerable: true,
        get: get
    });
};

},{}],"dwhkO":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "_", ()=>_class_extract_field_descriptor);
function _class_extract_field_descriptor(receiver, privateMap, action) {
    if (!privateMap.has(receiver)) throw new TypeError("attempted to " + action + " private field on non-instance");
    return privateMap.get(receiver);
}

},{"@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"fKzMI":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "_", ()=>_class_private_field_init);
var _checkPrivateRedeclarationJs = require("./_check_private_redeclaration.js");
function _class_private_field_init(obj, privateMap, value) {
    (0, _checkPrivateRedeclarationJs._)(obj, privateMap);
    privateMap.set(obj, value);
}

},{"./_check_private_redeclaration.js":"eky69","@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"eky69":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "_", ()=>_check_private_redeclaration);
function _check_private_redeclaration(obj, privateCollection) {
    if (privateCollection.has(obj)) throw new TypeError("Cannot initialize the same private elements twice on an object");
}

},{"@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"7xEQl":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "_", ()=>_class_private_field_set);
var _classApplyDescriptorSetJs = require("./_class_apply_descriptor_set.js");
var _classExtractFieldDescriptorJs = require("./_class_extract_field_descriptor.js");
function _class_private_field_set(receiver, privateMap, value) {
    var descriptor = (0, _classExtractFieldDescriptorJs._)(receiver, privateMap, "set");
    (0, _classApplyDescriptorSetJs._)(receiver, descriptor, value);
    return value;
}

},{"./_class_apply_descriptor_set.js":"ecFua","./_class_extract_field_descriptor.js":"dwhkO","@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"ecFua":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "_", ()=>_class_apply_descriptor_set);
function _class_apply_descriptor_set(receiver, descriptor, value) {
    if (descriptor.set) descriptor.set.call(receiver, value);
    else {
        if (!descriptor.writable) // This should only throw in strict mode, but class bodies are
        // always strict and private fields can only be used inside
        // class bodies.
        throw new TypeError("attempted to set read only private field");
        descriptor.value = value;
    }
}

},{"@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"94fke":[function(require,module,exports,__globalThis) {
// src/subscribable.ts
var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "Subscribable", ()=>Subscribable);
var Subscribable = class {
    subscribe(listener) {
        this.listeners.add(listener);
        this.onSubscribe();
        return ()=>{
            this.listeners.delete(listener);
            this.onUnsubscribe();
        };
    }
    hasListeners() {
        return this.listeners.size > 0;
    }
    onSubscribe() {}
    onUnsubscribe() {}
    constructor(){
        this.listeners = /* @__PURE__ */ new Set();
        this.subscribe = this.subscribe.bind(this);
    }
};

},{"@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"iAuYt":[function(require,module,exports,__globalThis) {
// src/utils.ts
var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "addConsumeAwareSignal", ()=>addConsumeAwareSignal);
parcelHelpers.export(exports, "addToEnd", ()=>addToEnd);
parcelHelpers.export(exports, "addToStart", ()=>addToStart);
parcelHelpers.export(exports, "ensureQueryFn", ()=>ensureQueryFn);
parcelHelpers.export(exports, "functionalUpdate", ()=>functionalUpdate);
parcelHelpers.export(exports, "hashKey", ()=>hashKey);
parcelHelpers.export(exports, "hashQueryKeyByOptions", ()=>hashQueryKeyByOptions);
parcelHelpers.export(exports, "isPlainArray", ()=>isPlainArray);
parcelHelpers.export(exports, "isPlainObject", ()=>isPlainObject);
parcelHelpers.export(exports, "isServer", ()=>isServer);
parcelHelpers.export(exports, "isValidTimeout", ()=>isValidTimeout);
parcelHelpers.export(exports, "keepPreviousData", ()=>keepPreviousData);
parcelHelpers.export(exports, "matchMutation", ()=>matchMutation);
parcelHelpers.export(exports, "matchQuery", ()=>matchQuery);
parcelHelpers.export(exports, "noop", ()=>noop);
parcelHelpers.export(exports, "partialMatchKey", ()=>partialMatchKey);
parcelHelpers.export(exports, "replaceData", ()=>replaceData);
parcelHelpers.export(exports, "replaceEqualDeep", ()=>replaceEqualDeep);
parcelHelpers.export(exports, "resolveEnabled", ()=>resolveEnabled);
parcelHelpers.export(exports, "resolveStaleTime", ()=>resolveStaleTime);
parcelHelpers.export(exports, "shallowEqualObjects", ()=>shallowEqualObjects);
parcelHelpers.export(exports, "shouldThrowError", ()=>shouldThrowError);
parcelHelpers.export(exports, "skipToken", ()=>skipToken);
parcelHelpers.export(exports, "sleep", ()=>sleep);
parcelHelpers.export(exports, "timeUntilStale", ()=>timeUntilStale);
var _timeoutManagerJs = require("./timeoutManager.js");
var isServer = typeof window === "undefined" || "Deno" in globalThis;
function noop() {}
function functionalUpdate(updater, input) {
    return typeof updater === "function" ? updater(input) : updater;
}
function isValidTimeout(value) {
    return typeof value === "number" && value >= 0 && value !== Infinity;
}
function timeUntilStale(updatedAt, staleTime) {
    return Math.max(updatedAt + (staleTime || 0) - Date.now(), 0);
}
function resolveStaleTime(staleTime, query) {
    return typeof staleTime === "function" ? staleTime(query) : staleTime;
}
function resolveEnabled(enabled, query) {
    return typeof enabled === "function" ? enabled(query) : enabled;
}
function matchQuery(filters, query) {
    const { type = "all", exact, fetchStatus, predicate, queryKey, stale } = filters;
    if (queryKey) {
        if (exact) {
            if (query.queryHash !== hashQueryKeyByOptions(queryKey, query.options)) return false;
        } else if (!partialMatchKey(query.queryKey, queryKey)) return false;
    }
    if (type !== "all") {
        const isActive = query.isActive();
        if (type === "active" && !isActive) return false;
        if (type === "inactive" && isActive) return false;
    }
    if (typeof stale === "boolean" && query.isStale() !== stale) return false;
    if (fetchStatus && fetchStatus !== query.state.fetchStatus) return false;
    if (predicate && !predicate(query)) return false;
    return true;
}
function matchMutation(filters, mutation) {
    const { exact, status, predicate, mutationKey } = filters;
    if (mutationKey) {
        if (!mutation.options.mutationKey) return false;
        if (exact) {
            if (hashKey(mutation.options.mutationKey) !== hashKey(mutationKey)) return false;
        } else if (!partialMatchKey(mutation.options.mutationKey, mutationKey)) return false;
    }
    if (status && mutation.state.status !== status) return false;
    if (predicate && !predicate(mutation)) return false;
    return true;
}
function hashQueryKeyByOptions(queryKey, options) {
    const hashFn = (options === null || options === void 0 ? void 0 : options.queryKeyHashFn) || hashKey;
    return hashFn(queryKey);
}
function hashKey(queryKey) {
    return JSON.stringify(queryKey, (_, val)=>isPlainObject(val) ? Object.keys(val).sort().reduce((result, key)=>{
            result[key] = val[key];
            return result;
        }, {}) : val);
}
function partialMatchKey(a, b) {
    if (a === b) return true;
    if (typeof a !== typeof b) return false;
    if (a && b && typeof a === "object" && typeof b === "object") return Object.keys(b).every((key)=>partialMatchKey(a[key], b[key]));
    return false;
}
var hasOwn = Object.prototype.hasOwnProperty;
function replaceEqualDeep(a, b, depth = 0) {
    if (a === b) return a;
    if (depth > 500) return b;
    const array = isPlainArray(a) && isPlainArray(b);
    if (!array && !(isPlainObject(a) && isPlainObject(b))) return b;
    const aItems = array ? a : Object.keys(a);
    const aSize = aItems.length;
    const bItems = array ? b : Object.keys(b);
    const bSize = bItems.length;
    const copy = array ? new Array(bSize) : {};
    let equalItems = 0;
    for(let i = 0; i < bSize; i++){
        const key = array ? i : bItems[i];
        const aItem = a[key];
        const bItem = b[key];
        if (aItem === bItem) {
            copy[key] = aItem;
            if (array ? i < aSize : hasOwn.call(a, key)) equalItems++;
            continue;
        }
        if (aItem === null || bItem === null || typeof aItem !== "object" || typeof bItem !== "object") {
            copy[key] = bItem;
            continue;
        }
        const v = replaceEqualDeep(aItem, bItem, depth + 1);
        copy[key] = v;
        if (v === aItem) equalItems++;
    }
    return aSize === bSize && equalItems === aSize ? a : copy;
}
function shallowEqualObjects(a, b) {
    if (!b || Object.keys(a).length !== Object.keys(b).length) return false;
    for(const key in a){
        if (a[key] !== b[key]) return false;
    }
    return true;
}
function isPlainArray(value) {
    return Array.isArray(value) && value.length === Object.keys(value).length;
}
function isPlainObject(o) {
    if (!hasObjectPrototype(o)) return false;
    const ctor = o.constructor;
    if (ctor === void 0) return true;
    const prot = ctor.prototype;
    if (!hasObjectPrototype(prot)) return false;
    if (!prot.hasOwnProperty("isPrototypeOf")) return false;
    if (Object.getPrototypeOf(o) !== Object.prototype) return false;
    return true;
}
function hasObjectPrototype(o) {
    return Object.prototype.toString.call(o) === "[object Object]";
}
function sleep(timeout) {
    return new Promise((resolve)=>{
        (0, _timeoutManagerJs.timeoutManager).setTimeout(resolve, timeout);
    });
}
function replaceData(prevData, data, options) {
    if (typeof options.structuralSharing === "function") return options.structuralSharing(prevData, data);
    else if (options.structuralSharing !== false) {
        var error;
        return replaceEqualDeep(prevData, data);
    }
    return data;
}
function keepPreviousData(previousData) {
    return previousData;
}
function addToEnd(items, item, max = 0) {
    const newItems = [
        ...items,
        item
    ];
    return max && newItems.length > max ? newItems.slice(1) : newItems;
}
function addToStart(items, item, max = 0) {
    const newItems = [
        item,
        ...items
    ];
    return max && newItems.length > max ? newItems.slice(0, -1) : newItems;
}
var skipToken = /* @__PURE__ */ Symbol();
function ensureQueryFn(options, fetchOptions) {
    if (!options.queryFn && (fetchOptions === null || fetchOptions === void 0 ? void 0 : fetchOptions.initialPromise)) return ()=>fetchOptions.initialPromise;
    if (!options.queryFn || options.queryFn === skipToken) return ()=>Promise.reject(new Error(`Missing queryFn: '${options.queryHash}'`));
    return options.queryFn;
}
function shouldThrowError(throwOnError, params) {
    if (typeof throwOnError === "function") return throwOnError(...params);
    return !!throwOnError;
}
function addConsumeAwareSignal(object, getSignal, onCancelled) {
    let consumed = false;
    let signal;
    Object.defineProperty(object, "signal", {
        enumerable: true,
        get: ()=>{
            signal !== null && signal !== void 0 ? signal : signal = getSignal();
            if (consumed) return signal;
            consumed = true;
            if (signal.aborted) onCancelled();
            else signal.addEventListener("abort", onCancelled, {
                once: true
            });
            return signal;
        }
    });
    return object;
}

},{"./timeoutManager.js":"aejcn","@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"aejcn":[function(require,module,exports,__globalThis) {
// src/timeoutManager.ts
var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "TimeoutManager", ()=>TimeoutManager);
parcelHelpers.export(exports, "defaultTimeoutProvider", ()=>defaultTimeoutProvider);
parcelHelpers.export(exports, "systemSetTimeoutZero", ()=>systemSetTimeoutZero);
parcelHelpers.export(exports, "timeoutManager", ()=>timeoutManager);
var _classPrivateFieldGet = require("@swc/helpers/_/_class_private_field_get");
var _classPrivateFieldInit = require("@swc/helpers/_/_class_private_field_init");
var _classPrivateFieldSet = require("@swc/helpers/_/_class_private_field_set");
var // We cannot have TimeoutManager<T> as we must instantiate it with a concrete
// type at app boot; and if we leave that type, then any new timer provider
// would need to support ReturnType<typeof setTimeout>, which is infeasible.
//
// We settle for type safety for the TimeoutProvider type, and accept that
// this class is unsafe internally to allow for extension.
_provider, _providerCalled;
var defaultTimeoutProvider = {
    // We need the wrapper function syntax below instead of direct references to
    // global setTimeout etc.
    //
    // BAD: `setTimeout: setTimeout`
    // GOOD: `setTimeout: (cb, delay) => setTimeout(cb, delay)`
    //
    // If we use direct references here, then anything that wants to spy on or
    // replace the global setTimeout (like tests) won't work since we'll already
    // have a hard reference to the original implementation at the time when this
    // file was imported.
    setTimeout: (callback, delay)=>setTimeout(callback, delay),
    clearTimeout: (timeoutId)=>clearTimeout(timeoutId),
    setInterval: (callback, delay)=>setInterval(callback, delay),
    clearInterval: (intervalId)=>clearInterval(intervalId)
};
var TimeoutManager = (_provider = /*#__PURE__*/ new WeakMap(), _providerCalled = /*#__PURE__*/ new WeakMap(), class {
    setTimeoutProvider(provider) {
        (0, _classPrivateFieldSet._)(this, _provider, provider);
    }
    setTimeout(callback, delay) {
        return (0, _classPrivateFieldGet._)(this, _provider).setTimeout(callback, delay);
    }
    clearTimeout(timeoutId) {
        (0, _classPrivateFieldGet._)(this, _provider).clearTimeout(timeoutId);
    }
    setInterval(callback, delay) {
        return (0, _classPrivateFieldGet._)(this, _provider).setInterval(callback, delay);
    }
    clearInterval(intervalId) {
        (0, _classPrivateFieldGet._)(this, _provider).clearInterval(intervalId);
    }
    constructor(){
        (0, _classPrivateFieldInit._)(this, _provider, {
            writable: true,
            value: defaultTimeoutProvider
        });
        (0, _classPrivateFieldInit._)(this, _providerCalled, {
            writable: true,
            value: false
        });
    }
});
var timeoutManager = new TimeoutManager();
function systemSetTimeoutZero(callback) {
    setTimeout(callback, 0);
}

},{"@swc/helpers/_/_class_private_field_get":"iWIk2","@swc/helpers/_/_class_private_field_init":"fKzMI","@swc/helpers/_/_class_private_field_set":"7xEQl","@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"2DHf3":[function(require,module,exports,__globalThis) {
// src/infiniteQueryObserver.ts
var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "InfiniteQueryObserver", ()=>InfiniteQueryObserver);
var _objectSpread = require("@swc/helpers/_/_object_spread");
var _objectSpreadProps = require("@swc/helpers/_/_object_spread_props");
var _queryObserverJs = require("./queryObserver.js");
var _infiniteQueryBehaviorJs = require("./infiniteQueryBehavior.js");
var InfiniteQueryObserver = class extends (0, _queryObserverJs.QueryObserver) {
    bindMethods() {
        super.bindMethods();
        this.fetchNextPage = this.fetchNextPage.bind(this);
        this.fetchPreviousPage = this.fetchPreviousPage.bind(this);
    }
    setOptions(options) {
        super.setOptions((0, _objectSpreadProps._)((0, _objectSpread._)({}, options), {
            behavior: (0, _infiniteQueryBehaviorJs.infiniteQueryBehavior)()
        }));
    }
    getOptimisticResult(options) {
        options.behavior = (0, _infiniteQueryBehaviorJs.infiniteQueryBehavior)();
        return super.getOptimisticResult(options);
    }
    fetchNextPage(options) {
        return this.fetch((0, _objectSpreadProps._)((0, _objectSpread._)({}, options), {
            meta: {
                fetchMore: {
                    direction: "forward"
                }
            }
        }));
    }
    fetchPreviousPage(options) {
        return this.fetch((0, _objectSpreadProps._)((0, _objectSpread._)({}, options), {
            meta: {
                fetchMore: {
                    direction: "backward"
                }
            }
        }));
    }
    createResult(query, options) {
        var _state_fetchMeta_fetchMore, _state_fetchMeta;
        const { state } = query;
        const parentResult = super.createResult(query, options);
        const { isFetching, isRefetching, isError, isRefetchError } = parentResult;
        const fetchDirection = (_state_fetchMeta = state.fetchMeta) === null || _state_fetchMeta === void 0 ? void 0 : (_state_fetchMeta_fetchMore = _state_fetchMeta.fetchMore) === null || _state_fetchMeta_fetchMore === void 0 ? void 0 : _state_fetchMeta_fetchMore.direction;
        const isFetchNextPageError = isError && fetchDirection === "forward";
        const isFetchingNextPage = isFetching && fetchDirection === "forward";
        const isFetchPreviousPageError = isError && fetchDirection === "backward";
        const isFetchingPreviousPage = isFetching && fetchDirection === "backward";
        const result = (0, _objectSpreadProps._)((0, _objectSpread._)({}, parentResult), {
            fetchNextPage: this.fetchNextPage,
            fetchPreviousPage: this.fetchPreviousPage,
            hasNextPage: (0, _infiniteQueryBehaviorJs.hasNextPage)(options, state.data),
            hasPreviousPage: (0, _infiniteQueryBehaviorJs.hasPreviousPage)(options, state.data),
            isFetchNextPageError,
            isFetchingNextPage,
            isFetchPreviousPageError,
            isFetchingPreviousPage,
            isRefetchError: isRefetchError && !isFetchNextPageError && !isFetchPreviousPageError,
            isRefetching: isRefetching && !isFetchingNextPage && !isFetchingPreviousPage
        });
        return result;
    }
    constructor(client, options){
        super(client, options);
    }
};

},{"@swc/helpers/_/_object_spread":"9gdrV","@swc/helpers/_/_object_spread_props":"kANqQ","./queryObserver.js":"Q7hlL","./infiniteQueryBehavior.js":"eDkXW","@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"9gdrV":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "_", ()=>_object_spread);
var _definePropertyJs = require("./_define_property.js");
function _object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
            return Object.getOwnPropertyDescriptor(source, sym).enumerable;
        }));
        ownKeys.forEach(function(key) {
            (0, _definePropertyJs._)(target, key, source[key]);
        });
    }
    return target;
}

},{"./_define_property.js":"e80IS","@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"e80IS":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "_", ()=>_define_property);
function _define_property(obj, key, value) {
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}

},{"@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"kANqQ":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "_", ()=>_object_spread_props);
function ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) symbols = symbols.filter(function(sym) {
            return Object.getOwnPropertyDescriptor(object, sym).enumerable;
        });
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function _object_spread_props(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    else ownKeys(Object(source)).forEach(function(key) {
        Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
    });
    return target;
}

},{"@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"Q7hlL":[function(require,module,exports,__globalThis) {
// src/queryObserver.ts
var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "QueryObserver", ()=>QueryObserver);
var _classPrivateFieldGet = require("@swc/helpers/_/_class_private_field_get");
var _classPrivateFieldInit = require("@swc/helpers/_/_class_private_field_init");
var _classPrivateFieldSet = require("@swc/helpers/_/_class_private_field_set");
var _classPrivateMethodGet = require("@swc/helpers/_/_class_private_method_get");
var _classPrivateMethodInit = require("@swc/helpers/_/_class_private_method_init");
var _extends = require("@swc/helpers/_/_extends");
var _objectDestructuringEmpty = require("@swc/helpers/_/_object_destructuring_empty");
var _objectSpread = require("@swc/helpers/_/_object_spread");
var _objectSpreadProps = require("@swc/helpers/_/_object_spread_props");
var _focusManagerJs = require("./focusManager.js");
var _notifyManagerJs = require("./notifyManager.js");
var _queryJs = require("./query.js");
var _subscribableJs = require("./subscribable.js");
var _thenableJs = require("./thenable.js");
var _utilsJs = require("./utils.js");
var _timeoutManagerJs = require("./timeoutManager.js");
var _client, _currentQuery, _currentQueryInitialState, _currentResult, _currentResultState, _currentResultOptions, _currentThenable, _selectError, _selectFn, _selectResult, // This property keeps track of the last query with defined data.
// It will be used to pass the previous data and query to the placeholder function between renders.
_lastQueryWithDefinedData, _staleTimeoutId, _refetchIntervalId, _currentRefetchInterval, _trackedProps, _executeFetch, _updateStaleTimeout, _computeRefetchInterval, _updateRefetchInterval, _updateTimers, _clearStaleTimeout, _clearRefetchInterval, _updateQuery, _notify, _class;
var QueryObserver = (_client = /*#__PURE__*/ new WeakMap(), _currentQuery = /*#__PURE__*/ new WeakMap(), _currentQueryInitialState = /*#__PURE__*/ new WeakMap(), _currentResult = /*#__PURE__*/ new WeakMap(), _currentResultState = /*#__PURE__*/ new WeakMap(), _currentResultOptions = /*#__PURE__*/ new WeakMap(), _currentThenable = /*#__PURE__*/ new WeakMap(), _selectError = /*#__PURE__*/ new WeakMap(), _selectFn = /*#__PURE__*/ new WeakMap(), _selectResult = /*#__PURE__*/ new WeakMap(), _lastQueryWithDefinedData = /*#__PURE__*/ new WeakMap(), _staleTimeoutId = /*#__PURE__*/ new WeakMap(), _refetchIntervalId = /*#__PURE__*/ new WeakMap(), _currentRefetchInterval = /*#__PURE__*/ new WeakMap(), _trackedProps = /*#__PURE__*/ new WeakMap(), _executeFetch = /*#__PURE__*/ new WeakSet(), _updateStaleTimeout = /*#__PURE__*/ new WeakSet(), _computeRefetchInterval = /*#__PURE__*/ new WeakSet(), _updateRefetchInterval = /*#__PURE__*/ new WeakSet(), _updateTimers = /*#__PURE__*/ new WeakSet(), _clearStaleTimeout = /*#__PURE__*/ new WeakSet(), _clearRefetchInterval = /*#__PURE__*/ new WeakSet(), _updateQuery = /*#__PURE__*/ new WeakSet(), _notify = /*#__PURE__*/ new WeakSet(), _class = class extends (0, _subscribableJs.Subscribable) {
    bindMethods() {
        this.refetch = this.refetch.bind(this);
    }
    onSubscribe() {
        if (this.listeners.size === 1) {
            (0, _classPrivateFieldGet._)(this, _currentQuery).addObserver(this);
            if (shouldFetchOnMount((0, _classPrivateFieldGet._)(this, _currentQuery), this.options)) (0, _classPrivateMethodGet._)(this, _executeFetch, executeFetch).call(this);
            else this.updateResult();
            (0, _classPrivateMethodGet._)(this, _updateTimers, updateTimers).call(this);
        }
    }
    onUnsubscribe() {
        if (!this.hasListeners()) this.destroy();
    }
    shouldFetchOnReconnect() {
        return shouldFetchOn((0, _classPrivateFieldGet._)(this, _currentQuery), this.options, this.options.refetchOnReconnect);
    }
    shouldFetchOnWindowFocus() {
        return shouldFetchOn((0, _classPrivateFieldGet._)(this, _currentQuery), this.options, this.options.refetchOnWindowFocus);
    }
    destroy() {
        this.listeners = /* @__PURE__ */ new Set();
        (0, _classPrivateMethodGet._)(this, _clearStaleTimeout, clearStaleTimeout).call(this);
        (0, _classPrivateMethodGet._)(this, _clearRefetchInterval, clearRefetchInterval).call(this);
        (0, _classPrivateFieldGet._)(this, _currentQuery).removeObserver(this);
    }
    setOptions(options) {
        const prevOptions = this.options;
        const prevQuery = (0, _classPrivateFieldGet._)(this, _currentQuery);
        this.options = (0, _classPrivateFieldGet._)(this, _client).defaultQueryOptions(options);
        if (this.options.enabled !== void 0 && typeof this.options.enabled !== "boolean" && typeof this.options.enabled !== "function" && typeof (0, _utilsJs.resolveEnabled)(this.options.enabled, (0, _classPrivateFieldGet._)(this, _currentQuery)) !== "boolean") throw new Error("Expected enabled to be a boolean or a callback that returns a boolean");
        (0, _classPrivateMethodGet._)(this, _updateQuery, updateQuery).call(this);
        (0, _classPrivateFieldGet._)(this, _currentQuery).setOptions(this.options);
        if (prevOptions._defaulted && !(0, _utilsJs.shallowEqualObjects)(this.options, prevOptions)) (0, _classPrivateFieldGet._)(this, _client).getQueryCache().notify({
            type: "observerOptionsUpdated",
            query: (0, _classPrivateFieldGet._)(this, _currentQuery),
            observer: this
        });
        const mounted = this.hasListeners();
        if (mounted && shouldFetchOptionally((0, _classPrivateFieldGet._)(this, _currentQuery), prevQuery, this.options, prevOptions)) (0, _classPrivateMethodGet._)(this, _executeFetch, executeFetch).call(this);
        this.updateResult();
        if (mounted && ((0, _classPrivateFieldGet._)(this, _currentQuery) !== prevQuery || (0, _utilsJs.resolveEnabled)(this.options.enabled, (0, _classPrivateFieldGet._)(this, _currentQuery)) !== (0, _utilsJs.resolveEnabled)(prevOptions.enabled, (0, _classPrivateFieldGet._)(this, _currentQuery)) || (0, _utilsJs.resolveStaleTime)(this.options.staleTime, (0, _classPrivateFieldGet._)(this, _currentQuery)) !== (0, _utilsJs.resolveStaleTime)(prevOptions.staleTime, (0, _classPrivateFieldGet._)(this, _currentQuery)))) (0, _classPrivateMethodGet._)(this, _updateStaleTimeout, updateStaleTimeout).call(this);
        const nextRefetchInterval = (0, _classPrivateMethodGet._)(this, _computeRefetchInterval, computeRefetchInterval).call(this);
        if (mounted && ((0, _classPrivateFieldGet._)(this, _currentQuery) !== prevQuery || (0, _utilsJs.resolveEnabled)(this.options.enabled, (0, _classPrivateFieldGet._)(this, _currentQuery)) !== (0, _utilsJs.resolveEnabled)(prevOptions.enabled, (0, _classPrivateFieldGet._)(this, _currentQuery)) || nextRefetchInterval !== (0, _classPrivateFieldGet._)(this, _currentRefetchInterval))) (0, _classPrivateMethodGet._)(this, _updateRefetchInterval, updateRefetchInterval).call(this, nextRefetchInterval);
    }
    getOptimisticResult(options) {
        const query = (0, _classPrivateFieldGet._)(this, _client).getQueryCache().build((0, _classPrivateFieldGet._)(this, _client), options);
        const result = this.createResult(query, options);
        if (shouldAssignObserverCurrentProperties(this, result)) {
            (0, _classPrivateFieldSet._)(this, _currentResult, result);
            (0, _classPrivateFieldSet._)(this, _currentResultOptions, this.options);
            (0, _classPrivateFieldSet._)(this, _currentResultState, (0, _classPrivateFieldGet._)(this, _currentQuery).state);
        }
        return result;
    }
    getCurrentResult() {
        return (0, _classPrivateFieldGet._)(this, _currentResult);
    }
    trackResult(result, onPropTracked) {
        return new Proxy(result, {
            get: (target, key)=>{
                this.trackProp(key);
                onPropTracked === null || onPropTracked === void 0 ? void 0 : onPropTracked(key);
                if (key === "promise") {
                    this.trackProp("data");
                    if (!this.options.experimental_prefetchInRender && (0, _classPrivateFieldGet._)(this, _currentThenable).status === "pending") (0, _classPrivateFieldGet._)(this, _currentThenable).reject(new Error("experimental_prefetchInRender feature flag is not enabled"));
                }
                return Reflect.get(target, key);
            }
        });
    }
    trackProp(key) {
        (0, _classPrivateFieldGet._)(this, _trackedProps).add(key);
    }
    getCurrentQuery() {
        return (0, _classPrivateFieldGet._)(this, _currentQuery);
    }
    refetch(_param = {}) {
        var options = (0, _extends._)({}, (0, _objectDestructuringEmpty._)(_param));
        return this.fetch((0, _objectSpread._)({}, options));
    }
    fetchOptimistic(options) {
        const defaultedOptions = (0, _classPrivateFieldGet._)(this, _client).defaultQueryOptions(options);
        const query = (0, _classPrivateFieldGet._)(this, _client).getQueryCache().build((0, _classPrivateFieldGet._)(this, _client), defaultedOptions);
        return query.fetch().then(()=>this.createResult(query, defaultedOptions));
    }
    fetch(fetchOptions) {
        var _fetchOptions_cancelRefetch;
        return (0, _classPrivateMethodGet._)(this, _executeFetch, executeFetch).call(this, (0, _objectSpreadProps._)((0, _objectSpread._)({}, fetchOptions), {
            cancelRefetch: (_fetchOptions_cancelRefetch = fetchOptions.cancelRefetch) !== null && _fetchOptions_cancelRefetch !== void 0 ? _fetchOptions_cancelRefetch : true
        })).then(()=>{
            this.updateResult();
            return (0, _classPrivateFieldGet._)(this, _currentResult);
        });
    }
    createResult(query, options) {
        const prevQuery = (0, _classPrivateFieldGet._)(this, _currentQuery);
        const prevOptions = this.options;
        const prevResult = (0, _classPrivateFieldGet._)(this, _currentResult);
        const prevResultState = (0, _classPrivateFieldGet._)(this, _currentResultState);
        const prevResultOptions = (0, _classPrivateFieldGet._)(this, _currentResultOptions);
        const queryChange = query !== prevQuery;
        const queryInitialState = queryChange ? query.state : (0, _classPrivateFieldGet._)(this, _currentQueryInitialState);
        const { state } = query;
        let newState = (0, _objectSpread._)({}, state);
        let isPlaceholderData = false;
        let data;
        if (options._optimisticResults) {
            const mounted = this.hasListeners();
            const fetchOnMount = !mounted && shouldFetchOnMount(query, options);
            const fetchOptionally = mounted && shouldFetchOptionally(query, prevQuery, options, prevOptions);
            if (fetchOnMount || fetchOptionally) newState = (0, _objectSpread._)({}, newState, (0, _queryJs.fetchState)(state.data, query.options));
            if (options._optimisticResults === "isRestoring") newState.fetchStatus = "idle";
        }
        let { error, errorUpdatedAt, status } = newState;
        data = newState.data;
        let skipSelect = false;
        if (options.placeholderData !== void 0 && data === void 0 && status === "pending") {
            var _class_private_field_get;
            let placeholderData;
            if ((prevResult === null || prevResult === void 0 ? void 0 : prevResult.isPlaceholderData) && options.placeholderData === (prevResultOptions === null || prevResultOptions === void 0 ? void 0 : prevResultOptions.placeholderData)) {
                placeholderData = prevResult.data;
                skipSelect = true;
            } else placeholderData = typeof options.placeholderData === "function" ? options.placeholderData((_class_private_field_get = (0, _classPrivateFieldGet._)(this, _lastQueryWithDefinedData)) === null || _class_private_field_get === void 0 ? void 0 : _class_private_field_get.state.data, (0, _classPrivateFieldGet._)(this, _lastQueryWithDefinedData)) : options.placeholderData;
            if (placeholderData !== void 0) {
                status = "success";
                data = (0, _utilsJs.replaceData)(prevResult === null || prevResult === void 0 ? void 0 : prevResult.data, placeholderData, options);
                isPlaceholderData = true;
            }
        }
        if (options.select && data !== void 0 && !skipSelect) {
            if (prevResult && data === (prevResultState === null || prevResultState === void 0 ? void 0 : prevResultState.data) && options.select === (0, _classPrivateFieldGet._)(this, _selectFn)) data = (0, _classPrivateFieldGet._)(this, _selectResult);
            else try {
                (0, _classPrivateFieldSet._)(this, _selectFn, options.select);
                data = options.select(data);
                data = (0, _utilsJs.replaceData)(prevResult === null || prevResult === void 0 ? void 0 : prevResult.data, data, options);
                (0, _classPrivateFieldSet._)(this, _selectResult, data);
                (0, _classPrivateFieldSet._)(this, _selectError, null);
            } catch (selectError) {
                (0, _classPrivateFieldSet._)(this, _selectError, selectError);
            }
        }
        if ((0, _classPrivateFieldGet._)(this, _selectError)) {
            error = (0, _classPrivateFieldGet._)(this, _selectError);
            data = (0, _classPrivateFieldGet._)(this, _selectResult);
            errorUpdatedAt = Date.now();
            status = "error";
        }
        const isFetching = newState.fetchStatus === "fetching";
        const isPending = status === "pending";
        const isError = status === "error";
        const isLoading = isPending && isFetching;
        const hasData = data !== void 0;
        const result = {
            status,
            fetchStatus: newState.fetchStatus,
            isPending,
            isSuccess: status === "success",
            isError,
            isInitialLoading: isLoading,
            isLoading,
            data,
            dataUpdatedAt: newState.dataUpdatedAt,
            error,
            errorUpdatedAt,
            failureCount: newState.fetchFailureCount,
            failureReason: newState.fetchFailureReason,
            errorUpdateCount: newState.errorUpdateCount,
            isFetched: newState.dataUpdateCount > 0 || newState.errorUpdateCount > 0,
            isFetchedAfterMount: newState.dataUpdateCount > queryInitialState.dataUpdateCount || newState.errorUpdateCount > queryInitialState.errorUpdateCount,
            isFetching,
            isRefetching: isFetching && !isPending,
            isLoadingError: isError && !hasData,
            isPaused: newState.fetchStatus === "paused",
            isPlaceholderData,
            isRefetchError: isError && hasData,
            isStale: isStale(query, options),
            refetch: this.refetch,
            promise: (0, _classPrivateFieldGet._)(this, _currentThenable),
            isEnabled: (0, _utilsJs.resolveEnabled)(options.enabled, query) !== false
        };
        const nextResult = result;
        if (this.options.experimental_prefetchInRender) {
            const hasResultData = nextResult.data !== void 0;
            const isErrorWithoutData = nextResult.status === "error" && !hasResultData;
            const finalizeThenableIfPossible = (thenable)=>{
                if (isErrorWithoutData) thenable.reject(nextResult.error);
                else if (hasResultData) thenable.resolve(nextResult.data);
            };
            const recreateThenable = ()=>{
                const pending = (0, _classPrivateFieldSet._)(this, _currentThenable, nextResult.promise = (0, _thenableJs.pendingThenable)());
                finalizeThenableIfPossible(pending);
            };
            const prevThenable = (0, _classPrivateFieldGet._)(this, _currentThenable);
            switch(prevThenable.status){
                case "pending":
                    if (query.queryHash === prevQuery.queryHash) finalizeThenableIfPossible(prevThenable);
                    break;
                case "fulfilled":
                    if (isErrorWithoutData || nextResult.data !== prevThenable.value) recreateThenable();
                    break;
                case "rejected":
                    if (!isErrorWithoutData || nextResult.error !== prevThenable.reason) recreateThenable();
                    break;
            }
        }
        return nextResult;
    }
    updateResult() {
        const prevResult = (0, _classPrivateFieldGet._)(this, _currentResult);
        const nextResult = this.createResult((0, _classPrivateFieldGet._)(this, _currentQuery), this.options);
        (0, _classPrivateFieldSet._)(this, _currentResultState, (0, _classPrivateFieldGet._)(this, _currentQuery).state);
        (0, _classPrivateFieldSet._)(this, _currentResultOptions, this.options);
        if ((0, _classPrivateFieldGet._)(this, _currentResultState).data !== void 0) (0, _classPrivateFieldSet._)(this, _lastQueryWithDefinedData, (0, _classPrivateFieldGet._)(this, _currentQuery));
        if ((0, _utilsJs.shallowEqualObjects)(nextResult, prevResult)) return;
        (0, _classPrivateFieldSet._)(this, _currentResult, nextResult);
        const shouldNotifyListeners = ()=>{
            if (!prevResult) return true;
            const { notifyOnChangeProps } = this.options;
            const notifyOnChangePropsValue = typeof notifyOnChangeProps === "function" ? notifyOnChangeProps() : notifyOnChangeProps;
            if (notifyOnChangePropsValue === "all" || !notifyOnChangePropsValue && !(0, _classPrivateFieldGet._)(this, _trackedProps).size) return true;
            const includedProps = new Set(notifyOnChangePropsValue !== null && notifyOnChangePropsValue !== void 0 ? notifyOnChangePropsValue : (0, _classPrivateFieldGet._)(this, _trackedProps));
            if (this.options.throwOnError) includedProps.add("error");
            return Object.keys((0, _classPrivateFieldGet._)(this, _currentResult)).some((key)=>{
                const typedKey = key;
                const changed = (0, _classPrivateFieldGet._)(this, _currentResult)[typedKey] !== prevResult[typedKey];
                return changed && includedProps.has(typedKey);
            });
        };
        (0, _classPrivateMethodGet._)(this, _notify, notify).call(this, {
            listeners: shouldNotifyListeners()
        });
    }
    onQueryUpdate() {
        this.updateResult();
        if (this.hasListeners()) (0, _classPrivateMethodGet._)(this, _updateTimers, updateTimers).call(this);
    }
    constructor(client, options){
        super(), (0, _classPrivateMethodInit._)(this, _executeFetch), (0, _classPrivateMethodInit._)(this, _updateStaleTimeout), (0, _classPrivateMethodInit._)(this, _computeRefetchInterval), (0, _classPrivateMethodInit._)(this, _updateRefetchInterval), (0, _classPrivateMethodInit._)(this, _updateTimers), (0, _classPrivateMethodInit._)(this, _clearStaleTimeout), (0, _classPrivateMethodInit._)(this, _clearRefetchInterval), (0, _classPrivateMethodInit._)(this, _updateQuery), (0, _classPrivateMethodInit._)(this, _notify), (0, _classPrivateFieldInit._)(this, _client, {
            writable: true,
            value: void 0
        }), (0, _classPrivateFieldInit._)(this, _currentQuery, {
            writable: true,
            value: void 0
        }), (0, _classPrivateFieldInit._)(this, _currentQueryInitialState, {
            writable: true,
            value: void 0
        }), (0, _classPrivateFieldInit._)(this, _currentResult, {
            writable: true,
            value: void 0
        }), (0, _classPrivateFieldInit._)(this, _currentResultState, {
            writable: true,
            value: void 0
        }), (0, _classPrivateFieldInit._)(this, _currentResultOptions, {
            writable: true,
            value: void 0
        }), (0, _classPrivateFieldInit._)(this, _currentThenable, {
            writable: true,
            value: void 0
        }), (0, _classPrivateFieldInit._)(this, _selectError, {
            writable: true,
            value: void 0
        }), (0, _classPrivateFieldInit._)(this, _selectFn, {
            writable: true,
            value: void 0
        }), (0, _classPrivateFieldInit._)(this, _selectResult, {
            writable: true,
            value: void 0
        }), (0, _classPrivateFieldInit._)(this, _lastQueryWithDefinedData, {
            writable: true,
            value: void 0
        }), (0, _classPrivateFieldInit._)(this, _staleTimeoutId, {
            writable: true,
            value: void 0
        }), (0, _classPrivateFieldInit._)(this, _refetchIntervalId, {
            writable: true,
            value: void 0
        }), (0, _classPrivateFieldInit._)(this, _currentRefetchInterval, {
            writable: true,
            value: void 0
        }), (0, _classPrivateFieldInit._)(this, _trackedProps, {
            writable: true,
            value: /* @__PURE__ */ new Set()
        });
        this.options = options;
        (0, _classPrivateFieldSet._)(this, _client, client);
        (0, _classPrivateFieldSet._)(this, _selectError, null);
        (0, _classPrivateFieldSet._)(this, _currentThenable, (0, _thenableJs.pendingThenable)());
        this.bindMethods();
        this.setOptions(options);
    }
}, _class);
function shouldLoadOnMount(query, options) {
    return (0, _utilsJs.resolveEnabled)(options.enabled, query) !== false && query.state.data === void 0 && !(query.state.status === "error" && options.retryOnMount === false);
}
function shouldFetchOnMount(query, options) {
    return shouldLoadOnMount(query, options) || query.state.data !== void 0 && shouldFetchOn(query, options, options.refetchOnMount);
}
function shouldFetchOn(query, options, field) {
    if ((0, _utilsJs.resolveEnabled)(options.enabled, query) !== false && (0, _utilsJs.resolveStaleTime)(options.staleTime, query) !== "static") {
        const value = typeof field === "function" ? field(query) : field;
        return value === "always" || value !== false && isStale(query, options);
    }
    return false;
}
function shouldFetchOptionally(query, prevQuery, options, prevOptions) {
    return (query !== prevQuery || (0, _utilsJs.resolveEnabled)(prevOptions.enabled, query) === false) && (!options.suspense || query.state.status !== "error") && isStale(query, options);
}
function isStale(query, options) {
    return (0, _utilsJs.resolveEnabled)(options.enabled, query) !== false && query.isStaleByTime((0, _utilsJs.resolveStaleTime)(options.staleTime, query));
}
function shouldAssignObserverCurrentProperties(observer, optimisticResult) {
    if (!(0, _utilsJs.shallowEqualObjects)(observer.getCurrentResult(), optimisticResult)) return true;
    return false;
}
function executeFetch(fetchOptions) {
    (0, _classPrivateMethodGet._)(this, _updateQuery, updateQuery).call(this);
    let promise = (0, _classPrivateFieldGet._)(this, _currentQuery).fetch(this.options, fetchOptions);
    if (!(fetchOptions === null || fetchOptions === void 0 ? void 0 : fetchOptions.throwOnError)) promise = promise.catch((0, _utilsJs.noop));
    return promise;
}
function updateStaleTimeout() {
    (0, _classPrivateMethodGet._)(this, _clearStaleTimeout, clearStaleTimeout).call(this);
    const staleTime = (0, _utilsJs.resolveStaleTime)(this.options.staleTime, (0, _classPrivateFieldGet._)(this, _currentQuery));
    if ((0, _utilsJs.isServer) || (0, _classPrivateFieldGet._)(this, _currentResult).isStale || !(0, _utilsJs.isValidTimeout)(staleTime)) return;
    const time = (0, _utilsJs.timeUntilStale)((0, _classPrivateFieldGet._)(this, _currentResult).dataUpdatedAt, staleTime);
    const timeout = time + 1;
    (0, _classPrivateFieldSet._)(this, _staleTimeoutId, (0, _timeoutManagerJs.timeoutManager).setTimeout(()=>{
        if (!(0, _classPrivateFieldGet._)(this, _currentResult).isStale) this.updateResult();
    }, timeout));
}
function computeRefetchInterval() {
    var _ref;
    return (_ref = typeof this.options.refetchInterval === "function" ? this.options.refetchInterval((0, _classPrivateFieldGet._)(this, _currentQuery)) : this.options.refetchInterval) !== null && _ref !== void 0 ? _ref : false;
}
function updateRefetchInterval(nextInterval) {
    (0, _classPrivateMethodGet._)(this, _clearRefetchInterval, clearRefetchInterval).call(this);
    (0, _classPrivateFieldSet._)(this, _currentRefetchInterval, nextInterval);
    if ((0, _utilsJs.isServer) || (0, _utilsJs.resolveEnabled)(this.options.enabled, (0, _classPrivateFieldGet._)(this, _currentQuery)) === false || !(0, _utilsJs.isValidTimeout)((0, _classPrivateFieldGet._)(this, _currentRefetchInterval)) || (0, _classPrivateFieldGet._)(this, _currentRefetchInterval) === 0) return;
    (0, _classPrivateFieldSet._)(this, _refetchIntervalId, (0, _timeoutManagerJs.timeoutManager).setInterval(()=>{
        if (this.options.refetchIntervalInBackground || (0, _focusManagerJs.focusManager).isFocused()) (0, _classPrivateMethodGet._)(this, _executeFetch, executeFetch).call(this);
    }, (0, _classPrivateFieldGet._)(this, _currentRefetchInterval)));
}
function updateTimers() {
    (0, _classPrivateMethodGet._)(this, _updateStaleTimeout, updateStaleTimeout).call(this);
    (0, _classPrivateMethodGet._)(this, _updateRefetchInterval, updateRefetchInterval).call(this, (0, _classPrivateMethodGet._)(this, _computeRefetchInterval, computeRefetchInterval).call(this));
}
function clearStaleTimeout() {
    if ((0, _classPrivateFieldGet._)(this, _staleTimeoutId)) {
        (0, _timeoutManagerJs.timeoutManager).clearTimeout((0, _classPrivateFieldGet._)(this, _staleTimeoutId));
        (0, _classPrivateFieldSet._)(this, _staleTimeoutId, void 0);
    }
}
function clearRefetchInterval() {
    if ((0, _classPrivateFieldGet._)(this, _refetchIntervalId)) {
        (0, _timeoutManagerJs.timeoutManager).clearInterval((0, _classPrivateFieldGet._)(this, _refetchIntervalId));
        (0, _classPrivateFieldSet._)(this, _refetchIntervalId, void 0);
    }
}
function updateQuery() {
    const query = (0, _classPrivateFieldGet._)(this, _client).getQueryCache().build((0, _classPrivateFieldGet._)(this, _client), this.options);
    if (query === (0, _classPrivateFieldGet._)(this, _currentQuery)) return;
    const prevQuery = (0, _classPrivateFieldGet._)(this, _currentQuery);
    (0, _classPrivateFieldSet._)(this, _currentQuery, query);
    (0, _classPrivateFieldSet._)(this, _currentQueryInitialState, query.state);
    if (this.hasListeners()) {
        prevQuery === null || prevQuery === void 0 ? void 0 : prevQuery.removeObserver(this);
        query.addObserver(this);
    }
}
function notify(notifyOptions) {
    (0, _notifyManagerJs.notifyManager).batch(()=>{
        if (notifyOptions.listeners) this.listeners.forEach((listener)=>{
            listener((0, _classPrivateFieldGet._)(this, _currentResult));
        });
        (0, _classPrivateFieldGet._)(this, _client).getQueryCache().notify({
            query: (0, _classPrivateFieldGet._)(this, _currentQuery),
            type: "observerResultsUpdated"
        });
    });
}

},{"@swc/helpers/_/_class_private_field_get":"iWIk2","@swc/helpers/_/_class_private_field_init":"fKzMI","@swc/helpers/_/_class_private_field_set":"7xEQl","@swc/helpers/_/_class_private_method_get":"kBKHZ","@swc/helpers/_/_class_private_method_init":"ht2pn","@swc/helpers/_/_extends":"bXNuS","@swc/helpers/_/_object_destructuring_empty":"18aa3","@swc/helpers/_/_object_spread":"9gdrV","@swc/helpers/_/_object_spread_props":"kANqQ","./focusManager.js":"d6FbS","./notifyManager.js":"zBbK9","./query.js":"jtMv6","./subscribable.js":"94fke","./thenable.js":"kuHVw","./utils.js":"iAuYt","./timeoutManager.js":"aejcn","@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"kBKHZ":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "_", ()=>_class_private_method_get);
function _class_private_method_get(receiver, privateSet, fn) {
    if (!privateSet.has(receiver)) throw new TypeError("attempted to get private field on non-instance");
    return fn;
}

},{"@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"ht2pn":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "_", ()=>_class_private_method_init);
var _checkPrivateRedeclarationJs = require("./_check_private_redeclaration.js");
function _class_private_method_init(obj, privateSet) {
    (0, _checkPrivateRedeclarationJs._)(obj, privateSet);
    privateSet.add(obj);
}

},{"./_check_private_redeclaration.js":"eky69","@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"bXNuS":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "_", ()=>_extends);
function _extends() {
    _extends = Object.assign || function assign(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return _extends.apply(this, arguments);
}

},{"@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"18aa3":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "_", ()=>_object_destructuring_empty);
function _object_destructuring_empty(o) {
    if (o === null || o === void 0) throw new TypeError("Cannot destructure " + o);
    return o;
}

},{"@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"zBbK9":[function(require,module,exports,__globalThis) {
// src/notifyManager.ts
var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "createNotifyManager", ()=>createNotifyManager);
parcelHelpers.export(exports, "defaultScheduler", ()=>defaultScheduler);
parcelHelpers.export(exports, "notifyManager", ()=>notifyManager);
var _timeoutManagerJs = require("./timeoutManager.js");
var defaultScheduler = (0, _timeoutManagerJs.systemSetTimeoutZero);
function createNotifyManager() {
    let queue = [];
    let transactions = 0;
    let notifyFn = (callback)=>{
        callback();
    };
    let batchNotifyFn = (callback)=>{
        callback();
    };
    let scheduleFn = defaultScheduler;
    const schedule = (callback)=>{
        if (transactions) queue.push(callback);
        else scheduleFn(()=>{
            notifyFn(callback);
        });
    };
    const flush = ()=>{
        const originalQueue = queue;
        queue = [];
        if (originalQueue.length) scheduleFn(()=>{
            batchNotifyFn(()=>{
                originalQueue.forEach((callback)=>{
                    notifyFn(callback);
                });
            });
        });
    };
    return {
        batch: (callback)=>{
            let result;
            transactions++;
            try {
                result = callback();
            } finally{
                transactions--;
                if (!transactions) flush();
            }
            return result;
        },
        /**
     * All calls to the wrapped function will be batched.
     */ batchCalls: (callback)=>{
            return (...args)=>{
                schedule(()=>{
                    callback(...args);
                });
            };
        },
        schedule,
        /**
     * Use this method to set a custom notify function.
     * This can be used to for example wrap notifications with `React.act` while running tests.
     */ setNotifyFunction: (fn)=>{
            notifyFn = fn;
        },
        /**
     * Use this method to set a custom function to batch notifications together into a single tick.
     * By default React Query will use the batch function provided by ReactDOM or React Native.
     */ setBatchNotifyFunction: (fn)=>{
            batchNotifyFn = fn;
        },
        setScheduler: (fn)=>{
            scheduleFn = fn;
        }
    };
}
var notifyManager = createNotifyManager();

},{"./timeoutManager.js":"aejcn","@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"jtMv6":[function(require,module,exports,__globalThis) {
// src/query.ts
var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "Query", ()=>Query);
parcelHelpers.export(exports, "fetchState", ()=>fetchState);
var _classPrivateFieldGet = require("@swc/helpers/_/_class_private_field_get");
var _classPrivateFieldInit = require("@swc/helpers/_/_class_private_field_init");
var _classPrivateFieldSet = require("@swc/helpers/_/_class_private_field_set");
var _classPrivateMethodGet = require("@swc/helpers/_/_class_private_method_get");
var _classPrivateMethodInit = require("@swc/helpers/_/_class_private_method_init");
var _objectSpread = require("@swc/helpers/_/_object_spread");
var _objectSpreadProps = require("@swc/helpers/_/_object_spread_props");
var _utilsJs = require("./utils.js");
var _notifyManagerJs = require("./notifyManager.js");
var _retryerJs = require("./retryer.js");
var _removableJs = require("./removable.js");
var _initialState, _revertState, _cache, _client, _retryer, _defaultOptions, _abortSignalConsumed, _dispatch, _class;
var Query = (_initialState = /*#__PURE__*/ new WeakMap(), _revertState = /*#__PURE__*/ new WeakMap(), _cache = /*#__PURE__*/ new WeakMap(), _client = /*#__PURE__*/ new WeakMap(), _retryer = /*#__PURE__*/ new WeakMap(), _defaultOptions = /*#__PURE__*/ new WeakMap(), _abortSignalConsumed = /*#__PURE__*/ new WeakMap(), _dispatch = /*#__PURE__*/ new WeakSet(), _class = class extends (0, _removableJs.Removable) {
    get meta() {
        return this.options.meta;
    }
    get promise() {
        var _class_private_field_get;
        return (_class_private_field_get = (0, _classPrivateFieldGet._)(this, _retryer)) === null || _class_private_field_get === void 0 ? void 0 : _class_private_field_get.promise;
    }
    setOptions(options) {
        this.options = (0, _objectSpread._)({}, (0, _classPrivateFieldGet._)(this, _defaultOptions), options);
        this.updateGcTime(this.options.gcTime);
        if (this.state && this.state.data === void 0) {
            const defaultState = getDefaultState(this.options);
            if (defaultState.data !== void 0) {
                this.setState(successState(defaultState.data, defaultState.dataUpdatedAt));
                (0, _classPrivateFieldSet._)(this, _initialState, defaultState);
            }
        }
    }
    optionalRemove() {
        if (!this.observers.length && this.state.fetchStatus === "idle") (0, _classPrivateFieldGet._)(this, _cache).remove(this);
    }
    setData(newData, options) {
        const data = (0, _utilsJs.replaceData)(this.state.data, newData, this.options);
        (0, _classPrivateMethodGet._)(this, _dispatch, dispatch).call(this, {
            data,
            type: "success",
            dataUpdatedAt: options === null || options === void 0 ? void 0 : options.updatedAt,
            manual: options === null || options === void 0 ? void 0 : options.manual
        });
        return data;
    }
    setState(state, setStateOptions) {
        (0, _classPrivateMethodGet._)(this, _dispatch, dispatch).call(this, {
            type: "setState",
            state,
            setStateOptions
        });
    }
    cancel(options) {
        var _class_private_field_get, _class_private_field_get1;
        const promise = (_class_private_field_get = (0, _classPrivateFieldGet._)(this, _retryer)) === null || _class_private_field_get === void 0 ? void 0 : _class_private_field_get.promise;
        (_class_private_field_get1 = (0, _classPrivateFieldGet._)(this, _retryer)) === null || _class_private_field_get1 === void 0 ? void 0 : _class_private_field_get1.cancel(options);
        return promise ? promise.then((0, _utilsJs.noop)).catch((0, _utilsJs.noop)) : Promise.resolve();
    }
    destroy() {
        super.destroy();
        this.cancel({
            silent: true
        });
    }
    reset() {
        this.destroy();
        this.setState((0, _classPrivateFieldGet._)(this, _initialState));
    }
    isActive() {
        return this.observers.some((observer)=>(0, _utilsJs.resolveEnabled)(observer.options.enabled, this) !== false);
    }
    isDisabled() {
        if (this.getObserversCount() > 0) return !this.isActive();
        return this.options.queryFn === (0, _utilsJs.skipToken) || this.state.dataUpdateCount + this.state.errorUpdateCount === 0;
    }
    isStatic() {
        if (this.getObserversCount() > 0) return this.observers.some((observer)=>(0, _utilsJs.resolveStaleTime)(observer.options.staleTime, this) === "static");
        return false;
    }
    isStale() {
        if (this.getObserversCount() > 0) return this.observers.some((observer)=>observer.getCurrentResult().isStale);
        return this.state.data === void 0 || this.state.isInvalidated;
    }
    isStaleByTime(staleTime = 0) {
        if (this.state.data === void 0) return true;
        if (staleTime === "static") return false;
        if (this.state.isInvalidated) return true;
        return !(0, _utilsJs.timeUntilStale)(this.state.dataUpdatedAt, staleTime);
    }
    onFocus() {
        var _class_private_field_get;
        const observer = this.observers.find((x)=>x.shouldFetchOnWindowFocus());
        observer === null || observer === void 0 ? void 0 : observer.refetch({
            cancelRefetch: false
        });
        (_class_private_field_get = (0, _classPrivateFieldGet._)(this, _retryer)) === null || _class_private_field_get === void 0 ? void 0 : _class_private_field_get.continue();
    }
    onOnline() {
        var _class_private_field_get;
        const observer = this.observers.find((x)=>x.shouldFetchOnReconnect());
        observer === null || observer === void 0 ? void 0 : observer.refetch({
            cancelRefetch: false
        });
        (_class_private_field_get = (0, _classPrivateFieldGet._)(this, _retryer)) === null || _class_private_field_get === void 0 ? void 0 : _class_private_field_get.continue();
    }
    addObserver(observer) {
        if (!this.observers.includes(observer)) {
            this.observers.push(observer);
            this.clearGcTimeout();
            (0, _classPrivateFieldGet._)(this, _cache).notify({
                type: "observerAdded",
                query: this,
                observer
            });
        }
    }
    removeObserver(observer) {
        if (this.observers.includes(observer)) {
            this.observers = this.observers.filter((x)=>x !== observer);
            if (!this.observers.length) {
                if ((0, _classPrivateFieldGet._)(this, _retryer)) {
                    if ((0, _classPrivateFieldGet._)(this, _abortSignalConsumed)) (0, _classPrivateFieldGet._)(this, _retryer).cancel({
                        revert: true
                    });
                    else (0, _classPrivateFieldGet._)(this, _retryer).cancelRetry();
                }
                this.scheduleGc();
            }
            (0, _classPrivateFieldGet._)(this, _cache).notify({
                type: "observerRemoved",
                query: this,
                observer
            });
        }
    }
    getObserversCount() {
        return this.observers.length;
    }
    invalidate() {
        if (!this.state.isInvalidated) (0, _classPrivateMethodGet._)(this, _dispatch, dispatch).call(this, {
            type: "invalidate"
        });
    }
    async fetch(options, fetchOptions) {
        var _class_private_field_get, _this_options_behavior, _context_fetchOptions, _context_fetchOptions1;
        if (this.state.fetchStatus !== "idle" && // If the promise in the retryer is already rejected, we have to definitely
        // re-start the fetch; there is a chance that the query is still in a
        // pending state when that happens
        ((_class_private_field_get = (0, _classPrivateFieldGet._)(this, _retryer)) === null || _class_private_field_get === void 0 ? void 0 : _class_private_field_get.status()) !== "rejected") {
            if (this.state.data !== void 0 && (fetchOptions === null || fetchOptions === void 0 ? void 0 : fetchOptions.cancelRefetch)) this.cancel({
                silent: true
            });
            else if ((0, _classPrivateFieldGet._)(this, _retryer)) {
                (0, _classPrivateFieldGet._)(this, _retryer).continueRetry();
                return (0, _classPrivateFieldGet._)(this, _retryer).promise;
            }
        }
        if (options) this.setOptions(options);
        if (!this.options.queryFn) {
            const observer = this.observers.find((x)=>x.options.queryFn);
            if (observer) this.setOptions(observer.options);
        }
        const abortController = new AbortController();
        const addSignalProperty = (object)=>{
            Object.defineProperty(object, "signal", {
                enumerable: true,
                get: ()=>{
                    (0, _classPrivateFieldSet._)(this, _abortSignalConsumed, true);
                    return abortController.signal;
                }
            });
        };
        const fetchFn = ()=>{
            const queryFn = (0, _utilsJs.ensureQueryFn)(this.options, fetchOptions);
            const createQueryFnContext = ()=>{
                const queryFnContext2 = {
                    client: (0, _classPrivateFieldGet._)(this, _client),
                    queryKey: this.queryKey,
                    meta: this.meta
                };
                addSignalProperty(queryFnContext2);
                return queryFnContext2;
            };
            const queryFnContext = createQueryFnContext();
            (0, _classPrivateFieldSet._)(this, _abortSignalConsumed, false);
            if (this.options.persister) return this.options.persister(queryFn, queryFnContext, this);
            return queryFn(queryFnContext);
        };
        const createFetchContext = ()=>{
            const context2 = {
                fetchOptions,
                options: this.options,
                queryKey: this.queryKey,
                client: (0, _classPrivateFieldGet._)(this, _client),
                state: this.state,
                fetchFn
            };
            addSignalProperty(context2);
            return context2;
        };
        const context = createFetchContext();
        (_this_options_behavior = this.options.behavior) === null || _this_options_behavior === void 0 ? void 0 : _this_options_behavior.onFetch(context, this);
        (0, _classPrivateFieldSet._)(this, _revertState, this.state);
        if (this.state.fetchStatus === "idle" || this.state.fetchMeta !== ((_context_fetchOptions = context.fetchOptions) === null || _context_fetchOptions === void 0 ? void 0 : _context_fetchOptions.meta)) (0, _classPrivateMethodGet._)(this, _dispatch, dispatch).call(this, {
            type: "fetch",
            meta: (_context_fetchOptions1 = context.fetchOptions) === null || _context_fetchOptions1 === void 0 ? void 0 : _context_fetchOptions1.meta
        });
        (0, _classPrivateFieldSet._)(this, _retryer, (0, _retryerJs.createRetryer)({
            initialPromise: fetchOptions === null || fetchOptions === void 0 ? void 0 : fetchOptions.initialPromise,
            fn: context.fetchFn,
            onCancel: (error)=>{
                if (error instanceof (0, _retryerJs.CancelledError) && error.revert) this.setState((0, _objectSpreadProps._)((0, _objectSpread._)({}, (0, _classPrivateFieldGet._)(this, _revertState)), {
                    fetchStatus: "idle"
                }));
                abortController.abort();
            },
            onFail: (failureCount, error)=>{
                (0, _classPrivateMethodGet._)(this, _dispatch, dispatch).call(this, {
                    type: "failed",
                    failureCount,
                    error
                });
            },
            onPause: ()=>{
                (0, _classPrivateMethodGet._)(this, _dispatch, dispatch).call(this, {
                    type: "pause"
                });
            },
            onContinue: ()=>{
                (0, _classPrivateMethodGet._)(this, _dispatch, dispatch).call(this, {
                    type: "continue"
                });
            },
            retry: context.options.retry,
            retryDelay: context.options.retryDelay,
            networkMode: context.options.networkMode,
            canRun: ()=>true
        }));
        try {
            var _class_private_field_get_config_onSuccess, _class_private_field_get_config, _class_private_field_get_config_onSettled, _class_private_field_get_config1;
            const data = await (0, _classPrivateFieldGet._)(this, _retryer).start();
            if (data === void 0) throw new Error(`${this.queryHash} data is undefined`);
            this.setData(data);
            (_class_private_field_get_config_onSuccess = (_class_private_field_get_config = (0, _classPrivateFieldGet._)(this, _cache).config).onSuccess) === null || _class_private_field_get_config_onSuccess === void 0 ? void 0 : _class_private_field_get_config_onSuccess.call(_class_private_field_get_config, data, this);
            (_class_private_field_get_config_onSettled = (_class_private_field_get_config1 = (0, _classPrivateFieldGet._)(this, _cache).config).onSettled) === null || _class_private_field_get_config_onSettled === void 0 ? void 0 : _class_private_field_get_config_onSettled.call(_class_private_field_get_config1, data, this.state.error, this);
            return data;
        } catch (error) {
            var _class_private_field_get_config_onError, _class_private_field_get_config2, _class_private_field_get_config_onSettled1, _class_private_field_get_config3;
            if (error instanceof (0, _retryerJs.CancelledError)) {
                if (error.silent) return (0, _classPrivateFieldGet._)(this, _retryer).promise;
                else if (error.revert) {
                    if (this.state.data === void 0) throw error;
                    return this.state.data;
                }
            }
            (0, _classPrivateMethodGet._)(this, _dispatch, dispatch).call(this, {
                type: "error",
                error
            });
            (_class_private_field_get_config_onError = (_class_private_field_get_config2 = (0, _classPrivateFieldGet._)(this, _cache).config).onError) === null || _class_private_field_get_config_onError === void 0 ? void 0 : _class_private_field_get_config_onError.call(_class_private_field_get_config2, error, this);
            (_class_private_field_get_config_onSettled1 = (_class_private_field_get_config3 = (0, _classPrivateFieldGet._)(this, _cache).config).onSettled) === null || _class_private_field_get_config_onSettled1 === void 0 ? void 0 : _class_private_field_get_config_onSettled1.call(_class_private_field_get_config3, this.state.data, error, this);
            throw error;
        } finally{
            this.scheduleGc();
        }
    }
    constructor(config){
        super(), (0, _classPrivateMethodInit._)(this, _dispatch), (0, _classPrivateFieldInit._)(this, _initialState, {
            writable: true,
            value: void 0
        }), (0, _classPrivateFieldInit._)(this, _revertState, {
            writable: true,
            value: void 0
        }), (0, _classPrivateFieldInit._)(this, _cache, {
            writable: true,
            value: void 0
        }), (0, _classPrivateFieldInit._)(this, _client, {
            writable: true,
            value: void 0
        }), (0, _classPrivateFieldInit._)(this, _retryer, {
            writable: true,
            value: void 0
        }), (0, _classPrivateFieldInit._)(this, _defaultOptions, {
            writable: true,
            value: void 0
        }), (0, _classPrivateFieldInit._)(this, _abortSignalConsumed, {
            writable: true,
            value: void 0
        });
        (0, _classPrivateFieldSet._)(this, _abortSignalConsumed, false);
        (0, _classPrivateFieldSet._)(this, _defaultOptions, config.defaultOptions);
        this.setOptions(config.options);
        this.observers = [];
        (0, _classPrivateFieldSet._)(this, _client, config.client);
        (0, _classPrivateFieldSet._)(this, _cache, (0, _classPrivateFieldGet._)(this, _client).getQueryCache());
        this.queryKey = config.queryKey;
        this.queryHash = config.queryHash;
        (0, _classPrivateFieldSet._)(this, _initialState, getDefaultState(this.options));
        var _config_state;
        this.state = (_config_state = config.state) !== null && _config_state !== void 0 ? _config_state : (0, _classPrivateFieldGet._)(this, _initialState);
        this.scheduleGc();
    }
}, _class);
function fetchState(data, options) {
    return (0, _objectSpread._)({
        fetchFailureCount: 0,
        fetchFailureReason: null,
        fetchStatus: (0, _retryerJs.canFetch)(options.networkMode) ? "fetching" : "paused"
    }, data === void 0 && {
        error: null,
        status: "pending"
    });
}
function successState(data, dataUpdatedAt) {
    return {
        data,
        dataUpdatedAt: dataUpdatedAt !== null && dataUpdatedAt !== void 0 ? dataUpdatedAt : Date.now(),
        error: null,
        isInvalidated: false,
        status: "success"
    };
}
function getDefaultState(options) {
    const data = typeof options.initialData === "function" ? options.initialData() : options.initialData;
    const hasData = data !== void 0;
    const initialDataUpdatedAt = hasData ? typeof options.initialDataUpdatedAt === "function" ? options.initialDataUpdatedAt() : options.initialDataUpdatedAt : 0;
    return {
        data,
        dataUpdateCount: 0,
        dataUpdatedAt: hasData ? initialDataUpdatedAt !== null && initialDataUpdatedAt !== void 0 ? initialDataUpdatedAt : Date.now() : 0,
        error: null,
        errorUpdateCount: 0,
        errorUpdatedAt: 0,
        fetchFailureCount: 0,
        fetchFailureReason: null,
        fetchMeta: null,
        isInvalidated: false,
        status: hasData ? "success" : "pending",
        fetchStatus: "idle"
    };
}
function dispatch(action) {
    const reducer = (state)=>{
        switch(action.type){
            case "failed":
                return (0, _objectSpreadProps._)((0, _objectSpread._)({}, state), {
                    fetchFailureCount: action.failureCount,
                    fetchFailureReason: action.error
                });
            case "pause":
                return (0, _objectSpreadProps._)((0, _objectSpread._)({}, state), {
                    fetchStatus: "paused"
                });
            case "continue":
                return (0, _objectSpreadProps._)((0, _objectSpread._)({}, state), {
                    fetchStatus: "fetching"
                });
            case "fetch":
                var _action_meta;
                return (0, _objectSpreadProps._)((0, _objectSpread._)({}, state, fetchState(state.data, this.options)), {
                    fetchMeta: (_action_meta = action.meta) !== null && _action_meta !== void 0 ? _action_meta : null
                });
            case "success":
                const newState = (0, _objectSpread._)((0, _objectSpreadProps._)((0, _objectSpread._)({}, state, successState(action.data, action.dataUpdatedAt)), {
                    dataUpdateCount: state.dataUpdateCount + 1
                }), !action.manual && {
                    fetchStatus: "idle",
                    fetchFailureCount: 0,
                    fetchFailureReason: null
                });
                (0, _classPrivateFieldSet._)(this, _revertState, action.manual ? newState : void 0);
                return newState;
            case "error":
                const error = action.error;
                return (0, _objectSpreadProps._)((0, _objectSpread._)({}, state), {
                    error,
                    errorUpdateCount: state.errorUpdateCount + 1,
                    errorUpdatedAt: Date.now(),
                    fetchFailureCount: state.fetchFailureCount + 1,
                    fetchFailureReason: error,
                    fetchStatus: "idle",
                    status: "error",
                    // flag existing data as invalidated if we get a background error
                    // note that "no data" always means stale so we can set unconditionally here
                    isInvalidated: true
                });
            case "invalidate":
                return (0, _objectSpreadProps._)((0, _objectSpread._)({}, state), {
                    isInvalidated: true
                });
            case "setState":
                return (0, _objectSpread._)({}, state, action.state);
        }
    };
    this.state = reducer(this.state);
    (0, _notifyManagerJs.notifyManager).batch(()=>{
        this.observers.forEach((observer)=>{
            observer.onQueryUpdate();
        });
        (0, _classPrivateFieldGet._)(this, _cache).notify({
            query: this,
            type: "updated",
            action
        });
    });
}

},{"@swc/helpers/_/_class_private_field_get":"iWIk2","@swc/helpers/_/_class_private_field_init":"fKzMI","@swc/helpers/_/_class_private_field_set":"7xEQl","@swc/helpers/_/_class_private_method_get":"kBKHZ","@swc/helpers/_/_class_private_method_init":"ht2pn","@swc/helpers/_/_object_spread":"9gdrV","@swc/helpers/_/_object_spread_props":"kANqQ","./utils.js":"iAuYt","./notifyManager.js":"zBbK9","./retryer.js":"kC3c1","./removable.js":"9oJ1i","@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"kC3c1":[function(require,module,exports,__globalThis) {
// src/retryer.ts
var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "CancelledError", ()=>CancelledError);
parcelHelpers.export(exports, "canFetch", ()=>canFetch);
parcelHelpers.export(exports, "createRetryer", ()=>createRetryer);
parcelHelpers.export(exports, "isCancelledError", ()=>isCancelledError);
var _focusManagerJs = require("./focusManager.js");
var _onlineManagerJs = require("./onlineManager.js");
var _thenableJs = require("./thenable.js");
var _utilsJs = require("./utils.js");
function defaultRetryDelay(failureCount) {
    return Math.min(1e3 * 2 ** failureCount, 3e4);
}
function canFetch(networkMode) {
    return (networkMode !== null && networkMode !== void 0 ? networkMode : "online") === "online" ? (0, _onlineManagerJs.onlineManager).isOnline() : true;
}
var CancelledError = class extends Error {
    constructor(options){
        super("CancelledError");
        this.revert = options === null || options === void 0 ? void 0 : options.revert;
        this.silent = options === null || options === void 0 ? void 0 : options.silent;
    }
};
function isCancelledError(value) {
    return value instanceof CancelledError;
}
function createRetryer(config) {
    let isRetryCancelled = false;
    let failureCount = 0;
    let continueFn;
    const thenable = (0, _thenableJs.pendingThenable)();
    const isResolved = ()=>thenable.status !== "pending";
    const cancel = (cancelOptions)=>{
        if (!isResolved()) {
            var _config_onCancel;
            const error = new CancelledError(cancelOptions);
            reject(error);
            (_config_onCancel = config.onCancel) === null || _config_onCancel === void 0 ? void 0 : _config_onCancel.call(config, error);
        }
    };
    const cancelRetry = ()=>{
        isRetryCancelled = true;
    };
    const continueRetry = ()=>{
        isRetryCancelled = false;
    };
    const canContinue = ()=>(0, _focusManagerJs.focusManager).isFocused() && (config.networkMode === "always" || (0, _onlineManagerJs.onlineManager).isOnline()) && config.canRun();
    const canStart = ()=>canFetch(config.networkMode) && config.canRun();
    const resolve = (value)=>{
        if (!isResolved()) {
            continueFn === null || continueFn === void 0 ? void 0 : continueFn();
            thenable.resolve(value);
        }
    };
    const reject = (value)=>{
        if (!isResolved()) {
            continueFn === null || continueFn === void 0 ? void 0 : continueFn();
            thenable.reject(value);
        }
    };
    const pause = ()=>{
        return new Promise((continueResolve)=>{
            var _config_onPause;
            continueFn = (value)=>{
                if (isResolved() || canContinue()) continueResolve(value);
            };
            (_config_onPause = config.onPause) === null || _config_onPause === void 0 ? void 0 : _config_onPause.call(config);
        }).then(()=>{
            var _config_onContinue;
            continueFn = void 0;
            if (!isResolved()) (_config_onContinue = config.onContinue) === null || _config_onContinue === void 0 ? void 0 : _config_onContinue.call(config);
        });
    };
    const run = ()=>{
        if (isResolved()) return;
        let promiseOrValue;
        const initialPromise = failureCount === 0 ? config.initialPromise : void 0;
        try {
            promiseOrValue = initialPromise !== null && initialPromise !== void 0 ? initialPromise : config.fn();
        } catch (error) {
            promiseOrValue = Promise.reject(error);
        }
        Promise.resolve(promiseOrValue).then(resolve).catch((error)=>{
            var _config_onFail;
            if (isResolved()) return;
            var _config_retry;
            const retry = (_config_retry = config.retry) !== null && _config_retry !== void 0 ? _config_retry : (0, _utilsJs.isServer) ? 0 : 3;
            var _config_retryDelay;
            const retryDelay = (_config_retryDelay = config.retryDelay) !== null && _config_retryDelay !== void 0 ? _config_retryDelay : defaultRetryDelay;
            const delay = typeof retryDelay === "function" ? retryDelay(failureCount, error) : retryDelay;
            const shouldRetry = retry === true || typeof retry === "number" && failureCount < retry || typeof retry === "function" && retry(failureCount, error);
            if (isRetryCancelled || !shouldRetry) {
                reject(error);
                return;
            }
            failureCount++;
            (_config_onFail = config.onFail) === null || _config_onFail === void 0 ? void 0 : _config_onFail.call(config, failureCount, error);
            (0, _utilsJs.sleep)(delay).then(()=>{
                return canContinue() ? void 0 : pause();
            }).then(()=>{
                if (isRetryCancelled) reject(error);
                else run();
            });
        });
    };
    return {
        promise: thenable,
        status: ()=>thenable.status,
        cancel,
        continue: ()=>{
            continueFn === null || continueFn === void 0 ? void 0 : continueFn();
            return thenable;
        },
        cancelRetry,
        continueRetry,
        canStart,
        start: ()=>{
            if (canStart()) run();
            else pause().then(run);
            return thenable;
        }
    };
}

},{"./focusManager.js":"d6FbS","./onlineManager.js":"lWiWx","./thenable.js":"kuHVw","./utils.js":"iAuYt","@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"lWiWx":[function(require,module,exports,__globalThis) {
// src/onlineManager.ts
var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "OnlineManager", ()=>OnlineManager);
parcelHelpers.export(exports, "onlineManager", ()=>onlineManager);
var _classPrivateFieldGet = require("@swc/helpers/_/_class_private_field_get");
var _classPrivateFieldInit = require("@swc/helpers/_/_class_private_field_init");
var _classPrivateFieldSet = require("@swc/helpers/_/_class_private_field_set");
var _subscribableJs = require("./subscribable.js");
var _utilsJs = require("./utils.js");
var _online, _cleanup, _setup;
var OnlineManager = (_online = /*#__PURE__*/ new WeakMap(), _cleanup = /*#__PURE__*/ new WeakMap(), _setup = /*#__PURE__*/ new WeakMap(), class extends (0, _subscribableJs.Subscribable) {
    onSubscribe() {
        if (!(0, _classPrivateFieldGet._)(this, _cleanup)) this.setEventListener((0, _classPrivateFieldGet._)(this, _setup));
    }
    onUnsubscribe() {
        var _this, _this1, _ref;
        if (!this.hasListeners()) {
            (_this = (0, _classPrivateFieldGet._)(_ref = _this1 = this, _cleanup)) === null || _this === void 0 ? void 0 : _this.call(_this1);
            (0, _classPrivateFieldSet._)(this, _cleanup, void 0);
        }
    }
    setEventListener(setup) {
        var _this, _this1, _ref;
        (0, _classPrivateFieldSet._)(this, _setup, setup);
        (_this = (0, _classPrivateFieldGet._)(_ref = _this1 = this, _cleanup)) === null || _this === void 0 ? void 0 : _this.call(_this1);
        (0, _classPrivateFieldSet._)(this, _cleanup, setup(this.setOnline.bind(this)));
    }
    setOnline(online) {
        const changed = (0, _classPrivateFieldGet._)(this, _online) !== online;
        if (changed) {
            (0, _classPrivateFieldSet._)(this, _online, online);
            this.listeners.forEach((listener)=>{
                listener(online);
            });
        }
    }
    isOnline() {
        return (0, _classPrivateFieldGet._)(this, _online);
    }
    constructor(){
        super(), (0, _classPrivateFieldInit._)(this, _online, {
            writable: true,
            value: true
        }), (0, _classPrivateFieldInit._)(this, _cleanup, {
            writable: true,
            value: void 0
        }), (0, _classPrivateFieldInit._)(this, _setup, {
            writable: true,
            value: void 0
        });
        (0, _classPrivateFieldSet._)(this, _setup, (onOnline)=>{
            if (!(0, _utilsJs.isServer) && window.addEventListener) {
                const onlineListener = ()=>onOnline(true);
                const offlineListener = ()=>onOnline(false);
                window.addEventListener("online", onlineListener, false);
                window.addEventListener("offline", offlineListener, false);
                return ()=>{
                    window.removeEventListener("online", onlineListener);
                    window.removeEventListener("offline", offlineListener);
                };
            }
            return;
        });
    }
});
var onlineManager = new OnlineManager();

},{"@swc/helpers/_/_class_private_field_get":"iWIk2","@swc/helpers/_/_class_private_field_init":"fKzMI","@swc/helpers/_/_class_private_field_set":"7xEQl","./subscribable.js":"94fke","./utils.js":"iAuYt","@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"kuHVw":[function(require,module,exports,__globalThis) {
// src/thenable.ts
var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "pendingThenable", ()=>pendingThenable);
parcelHelpers.export(exports, "tryResolveSync", ()=>tryResolveSync);
var _utilsJs = require("./utils.js");
function pendingThenable() {
    let resolve;
    let reject;
    const thenable = new Promise((_resolve, _reject)=>{
        resolve = _resolve;
        reject = _reject;
    });
    thenable.status = "pending";
    thenable.catch(()=>{});
    function finalize(data) {
        Object.assign(thenable, data);
        delete thenable.resolve;
        delete thenable.reject;
    }
    thenable.resolve = (value)=>{
        finalize({
            status: "fulfilled",
            value
        });
        resolve(value);
    };
    thenable.reject = (reason)=>{
        finalize({
            status: "rejected",
            reason
        });
        reject(reason);
    };
    return thenable;
}
function tryResolveSync(promise) {
    var _promise_then;
    let data;
    (_promise_then = promise.then((result)=>{
        data = result;
        return result;
    }, (0, _utilsJs.noop))) === null || _promise_then === void 0 ? void 0 : _promise_then.catch((0, _utilsJs.noop));
    if (data !== void 0) return {
        data
    };
    return void 0;
}

},{"./utils.js":"iAuYt","@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"9oJ1i":[function(require,module,exports,__globalThis) {
// src/removable.ts
var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "Removable", ()=>Removable);
var _classPrivateFieldGet = require("@swc/helpers/_/_class_private_field_get");
var _classPrivateFieldInit = require("@swc/helpers/_/_class_private_field_init");
var _classPrivateFieldSet = require("@swc/helpers/_/_class_private_field_set");
var _timeoutManagerJs = require("./timeoutManager.js");
var _utilsJs = require("./utils.js");
var _gcTimeout;
var Removable = (_gcTimeout = /*#__PURE__*/ new WeakMap(), class {
    destroy() {
        this.clearGcTimeout();
    }
    scheduleGc() {
        this.clearGcTimeout();
        if ((0, _utilsJs.isValidTimeout)(this.gcTime)) (0, _classPrivateFieldSet._)(this, _gcTimeout, (0, _timeoutManagerJs.timeoutManager).setTimeout(()=>{
            this.optionalRemove();
        }, this.gcTime));
    }
    updateGcTime(newGcTime) {
        this.gcTime = Math.max(this.gcTime || 0, newGcTime !== null && newGcTime !== void 0 ? newGcTime : (0, _utilsJs.isServer) ? Infinity : 300000);
    }
    clearGcTimeout() {
        if ((0, _classPrivateFieldGet._)(this, _gcTimeout)) {
            (0, _timeoutManagerJs.timeoutManager).clearTimeout((0, _classPrivateFieldGet._)(this, _gcTimeout));
            (0, _classPrivateFieldSet._)(this, _gcTimeout, void 0);
        }
    }
    constructor(){
        (0, _classPrivateFieldInit._)(this, _gcTimeout, {
            writable: true,
            value: void 0
        });
    }
});

},{"@swc/helpers/_/_class_private_field_get":"iWIk2","@swc/helpers/_/_class_private_field_init":"fKzMI","@swc/helpers/_/_class_private_field_set":"7xEQl","./timeoutManager.js":"aejcn","./utils.js":"iAuYt","@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"eDkXW":[function(require,module,exports,__globalThis) {
// src/infiniteQueryBehavior.ts
var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "hasNextPage", ()=>hasNextPage);
parcelHelpers.export(exports, "hasPreviousPage", ()=>hasPreviousPage);
parcelHelpers.export(exports, "infiniteQueryBehavior", ()=>infiniteQueryBehavior);
var _utilsJs = require("./utils.js");
function infiniteQueryBehavior(pages) {
    return {
        onFetch: (context, query)=>{
            var _context_fetchOptions_meta_fetchMore, _context_fetchOptions_meta, _context_fetchOptions, _context_state_data, _context_state_data1;
            const options = context.options;
            const direction = (_context_fetchOptions = context.fetchOptions) === null || _context_fetchOptions === void 0 ? void 0 : (_context_fetchOptions_meta = _context_fetchOptions.meta) === null || _context_fetchOptions_meta === void 0 ? void 0 : (_context_fetchOptions_meta_fetchMore = _context_fetchOptions_meta.fetchMore) === null || _context_fetchOptions_meta_fetchMore === void 0 ? void 0 : _context_fetchOptions_meta_fetchMore.direction;
            const oldPages = ((_context_state_data = context.state.data) === null || _context_state_data === void 0 ? void 0 : _context_state_data.pages) || [];
            const oldPageParams = ((_context_state_data1 = context.state.data) === null || _context_state_data1 === void 0 ? void 0 : _context_state_data1.pageParams) || [];
            let result = {
                pages: [],
                pageParams: []
            };
            let currentPage = 0;
            const fetchFn = async ()=>{
                let cancelled = false;
                const addSignalProperty = (object)=>{
                    (0, _utilsJs.addConsumeAwareSignal)(object, ()=>context.signal, ()=>cancelled = true);
                };
                const queryFn = (0, _utilsJs.ensureQueryFn)(context.options, context.fetchOptions);
                const fetchPage = async (data, param, previous)=>{
                    if (cancelled) return Promise.reject();
                    if (param == null && data.pages.length) return Promise.resolve(data);
                    const createQueryFnContext = ()=>{
                        const queryFnContext2 = {
                            client: context.client,
                            queryKey: context.queryKey,
                            pageParam: param,
                            direction: previous ? "backward" : "forward",
                            meta: context.options.meta
                        };
                        addSignalProperty(queryFnContext2);
                        return queryFnContext2;
                    };
                    const queryFnContext = createQueryFnContext();
                    const page = await queryFn(queryFnContext);
                    const { maxPages } = context.options;
                    const addTo = previous ? (0, _utilsJs.addToStart) : (0, _utilsJs.addToEnd);
                    return {
                        pages: addTo(data.pages, page, maxPages),
                        pageParams: addTo(data.pageParams, param, maxPages)
                    };
                };
                if (direction && oldPages.length) {
                    const previous = direction === "backward";
                    const pageParamFn = previous ? getPreviousPageParam : getNextPageParam;
                    const oldData = {
                        pages: oldPages,
                        pageParams: oldPageParams
                    };
                    const param = pageParamFn(options, oldData);
                    result = await fetchPage(oldData, param, previous);
                } else {
                    const remainingPages = pages !== null && pages !== void 0 ? pages : oldPages.length;
                    do {
                        var _oldPageParams_;
                        const param = currentPage === 0 ? (_oldPageParams_ = oldPageParams[0]) !== null && _oldPageParams_ !== void 0 ? _oldPageParams_ : options.initialPageParam : getNextPageParam(options, result);
                        if (currentPage > 0 && param == null) break;
                        result = await fetchPage(result, param);
                        currentPage++;
                    }while (currentPage < remainingPages);
                }
                return result;
            };
            if (context.options.persister) context.fetchFn = ()=>{
                var _context_options_persister, _context_options;
                return (_context_options_persister = (_context_options = context.options).persister) === null || _context_options_persister === void 0 ? void 0 : _context_options_persister.call(_context_options, fetchFn, {
                    client: context.client,
                    queryKey: context.queryKey,
                    meta: context.options.meta,
                    signal: context.signal
                }, query);
            };
            else context.fetchFn = fetchFn;
        }
    };
}
function getNextPageParam(options, { pages, pageParams }) {
    const lastIndex = pages.length - 1;
    return pages.length > 0 ? options.getNextPageParam(pages[lastIndex], pages, pageParams[lastIndex], pageParams) : void 0;
}
function getPreviousPageParam(options, { pages, pageParams }) {
    var _options_getPreviousPageParam;
    return pages.length > 0 ? (_options_getPreviousPageParam = options.getPreviousPageParam) === null || _options_getPreviousPageParam === void 0 ? void 0 : _options_getPreviousPageParam.call(options, pages[0], pages, pageParams[0], pageParams) : void 0;
}
function hasNextPage(options, data) {
    if (!data) return false;
    return getNextPageParam(options, data) != null;
}
function hasPreviousPage(options, data) {
    if (!data || !options.getPreviousPageParam) return false;
    return getPreviousPageParam(options, data) != null;
}

},{"./utils.js":"iAuYt","@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"6G0Tw":[function(require,module,exports,__globalThis) {
// src/mutationCache.ts
var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "MutationCache", ()=>MutationCache);
var _classPrivateFieldGet = require("@swc/helpers/_/_class_private_field_get");
var _classPrivateFieldInit = require("@swc/helpers/_/_class_private_field_init");
var _classPrivateFieldSet = require("@swc/helpers/_/_class_private_field_set");
var _classPrivateFieldUpdate = require("@swc/helpers/_/_class_private_field_update");
var _objectSpread = require("@swc/helpers/_/_object_spread");
var _notifyManagerJs = require("./notifyManager.js");
var _mutationJs = require("./mutation.js");
var _utilsJs = require("./utils.js");
var _subscribableJs = require("./subscribable.js");
var _mutations, _scopes, _mutationId;
var MutationCache = (_mutations = /*#__PURE__*/ new WeakMap(), _scopes = /*#__PURE__*/ new WeakMap(), _mutationId = /*#__PURE__*/ new WeakMap(), class extends (0, _subscribableJs.Subscribable) {
    build(client, options, state) {
        const mutation = new (0, _mutationJs.Mutation)({
            client,
            mutationCache: this,
            mutationId: ++(0, _classPrivateFieldUpdate._)(this, _mutationId).value,
            options: client.defaultMutationOptions(options),
            state
        });
        this.add(mutation);
        return mutation;
    }
    add(mutation) {
        (0, _classPrivateFieldGet._)(this, _mutations).add(mutation);
        const scope = scopeFor(mutation);
        if (typeof scope === "string") {
            const scopedMutations = (0, _classPrivateFieldGet._)(this, _scopes).get(scope);
            if (scopedMutations) scopedMutations.push(mutation);
            else (0, _classPrivateFieldGet._)(this, _scopes).set(scope, [
                mutation
            ]);
        }
        this.notify({
            type: "added",
            mutation
        });
    }
    remove(mutation) {
        if ((0, _classPrivateFieldGet._)(this, _mutations).delete(mutation)) {
            const scope = scopeFor(mutation);
            if (typeof scope === "string") {
                const scopedMutations = (0, _classPrivateFieldGet._)(this, _scopes).get(scope);
                if (scopedMutations) {
                    if (scopedMutations.length > 1) {
                        const index = scopedMutations.indexOf(mutation);
                        if (index !== -1) scopedMutations.splice(index, 1);
                    } else if (scopedMutations[0] === mutation) (0, _classPrivateFieldGet._)(this, _scopes).delete(scope);
                }
            }
        }
        this.notify({
            type: "removed",
            mutation
        });
    }
    canRun(mutation) {
        const scope = scopeFor(mutation);
        if (typeof scope === "string") {
            const mutationsWithSameScope = (0, _classPrivateFieldGet._)(this, _scopes).get(scope);
            const firstPendingMutation = mutationsWithSameScope === null || mutationsWithSameScope === void 0 ? void 0 : mutationsWithSameScope.find((m)=>m.state.status === "pending");
            return !firstPendingMutation || firstPendingMutation === mutation;
        } else return true;
    }
    runNext(mutation) {
        const scope = scopeFor(mutation);
        if (typeof scope === "string") {
            var _class_private_field_get_get;
            const foundMutation = (_class_private_field_get_get = (0, _classPrivateFieldGet._)(this, _scopes).get(scope)) === null || _class_private_field_get_get === void 0 ? void 0 : _class_private_field_get_get.find((m)=>m !== mutation && m.state.isPaused);
            var _foundMutation_continue;
            return (_foundMutation_continue = foundMutation === null || foundMutation === void 0 ? void 0 : foundMutation.continue()) !== null && _foundMutation_continue !== void 0 ? _foundMutation_continue : Promise.resolve();
        } else return Promise.resolve();
    }
    clear() {
        (0, _notifyManagerJs.notifyManager).batch(()=>{
            (0, _classPrivateFieldGet._)(this, _mutations).forEach((mutation)=>{
                this.notify({
                    type: "removed",
                    mutation
                });
            });
            (0, _classPrivateFieldGet._)(this, _mutations).clear();
            (0, _classPrivateFieldGet._)(this, _scopes).clear();
        });
    }
    getAll() {
        return Array.from((0, _classPrivateFieldGet._)(this, _mutations));
    }
    find(filters) {
        const defaultedFilters = (0, _objectSpread._)({
            exact: true
        }, filters);
        return this.getAll().find((mutation)=>(0, _utilsJs.matchMutation)(defaultedFilters, mutation));
    }
    findAll(filters = {}) {
        return this.getAll().filter((mutation)=>(0, _utilsJs.matchMutation)(filters, mutation));
    }
    notify(event) {
        (0, _notifyManagerJs.notifyManager).batch(()=>{
            this.listeners.forEach((listener)=>{
                listener(event);
            });
        });
    }
    resumePausedMutations() {
        const pausedMutations = this.getAll().filter((x)=>x.state.isPaused);
        return (0, _notifyManagerJs.notifyManager).batch(()=>Promise.all(pausedMutations.map((mutation)=>mutation.continue().catch((0, _utilsJs.noop)))));
    }
    constructor(config = {}){
        super(), (0, _classPrivateFieldInit._)(this, _mutations, {
            writable: true,
            value: void 0
        }), (0, _classPrivateFieldInit._)(this, _scopes, {
            writable: true,
            value: void 0
        }), (0, _classPrivateFieldInit._)(this, _mutationId, {
            writable: true,
            value: void 0
        });
        this.config = config;
        (0, _classPrivateFieldSet._)(this, _mutations, /* @__PURE__ */ new Set());
        (0, _classPrivateFieldSet._)(this, _scopes, /* @__PURE__ */ new Map());
        (0, _classPrivateFieldSet._)(this, _mutationId, 0);
    }
});
function scopeFor(mutation) {
    var _mutation_options_scope;
    return (_mutation_options_scope = mutation.options.scope) === null || _mutation_options_scope === void 0 ? void 0 : _mutation_options_scope.id;
}

},{"@swc/helpers/_/_class_private_field_get":"iWIk2","@swc/helpers/_/_class_private_field_init":"fKzMI","@swc/helpers/_/_class_private_field_set":"7xEQl","@swc/helpers/_/_class_private_field_update":"7mTy2","@swc/helpers/_/_object_spread":"9gdrV","./notifyManager.js":"zBbK9","./mutation.js":"l9Yi6","./utils.js":"iAuYt","./subscribable.js":"94fke","@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"7mTy2":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "_", ()=>_class_private_field_update);
var _classApplyDescriptorUpdateJs = require("./_class_apply_descriptor_update.js");
var _classExtractFieldDescriptorJs = require("./_class_extract_field_descriptor.js");
function _class_private_field_update(receiver, privateMap) {
    var descriptor = (0, _classExtractFieldDescriptorJs._)(receiver, privateMap, "update");
    return (0, _classApplyDescriptorUpdateJs._)(receiver, descriptor);
}

},{"./_class_apply_descriptor_update.js":"7bnKV","./_class_extract_field_descriptor.js":"dwhkO","@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"7bnKV":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "_", ()=>_class_apply_descriptor_update);
function _class_apply_descriptor_update(receiver, descriptor) {
    if (descriptor.set) {
        if (!descriptor.get) throw new TypeError("attempted to read set only private field");
        if (!("__destrWrapper" in descriptor)) descriptor.__destrWrapper = {
            set value (v){
                descriptor.set.call(receiver, v);
            },
            get value () {
                return descriptor.get.call(receiver);
            }
        };
        return descriptor.__destrWrapper;
    } else {
        if (!descriptor.writable) // This should only throw in strict mode, but class bodies are
        // always strict and private fields can only be used inside
        // class bodies.
        throw new TypeError("attempted to set read only private field");
        return descriptor;
    }
}

},{"@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"l9Yi6":[function(require,module,exports,__globalThis) {
// src/mutation.ts
var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "Mutation", ()=>Mutation);
parcelHelpers.export(exports, "getDefaultState", ()=>getDefaultState);
var _classPrivateFieldGet = require("@swc/helpers/_/_class_private_field_get");
var _classPrivateFieldInit = require("@swc/helpers/_/_class_private_field_init");
var _classPrivateFieldSet = require("@swc/helpers/_/_class_private_field_set");
var _classPrivateMethodGet = require("@swc/helpers/_/_class_private_method_get");
var _classPrivateMethodInit = require("@swc/helpers/_/_class_private_method_init");
var _objectSpread = require("@swc/helpers/_/_object_spread");
var _objectSpreadProps = require("@swc/helpers/_/_object_spread_props");
var _notifyManagerJs = require("./notifyManager.js");
var _removableJs = require("./removable.js");
var _retryerJs = require("./retryer.js");
var _client, _observers, _mutationCache, _retryer, _dispatch, _class;
var Mutation = (_client = /*#__PURE__*/ new WeakMap(), _observers = /*#__PURE__*/ new WeakMap(), _mutationCache = /*#__PURE__*/ new WeakMap(), _retryer = /*#__PURE__*/ new WeakMap(), _dispatch = /*#__PURE__*/ new WeakSet(), _class = class extends (0, _removableJs.Removable) {
    setOptions(options) {
        this.options = options;
        this.updateGcTime(this.options.gcTime);
    }
    get meta() {
        return this.options.meta;
    }
    addObserver(observer) {
        if (!(0, _classPrivateFieldGet._)(this, _observers).includes(observer)) {
            (0, _classPrivateFieldGet._)(this, _observers).push(observer);
            this.clearGcTimeout();
            (0, _classPrivateFieldGet._)(this, _mutationCache).notify({
                type: "observerAdded",
                mutation: this,
                observer
            });
        }
    }
    removeObserver(observer) {
        (0, _classPrivateFieldSet._)(this, _observers, (0, _classPrivateFieldGet._)(this, _observers).filter((x)=>x !== observer));
        this.scheduleGc();
        (0, _classPrivateFieldGet._)(this, _mutationCache).notify({
            type: "observerRemoved",
            mutation: this,
            observer
        });
    }
    optionalRemove() {
        if (!(0, _classPrivateFieldGet._)(this, _observers).length) {
            if (this.state.status === "pending") this.scheduleGc();
            else (0, _classPrivateFieldGet._)(this, _mutationCache).remove(this);
        }
    }
    continue() {
        var _class_private_field_get;
        var _class_private_field_get_continue;
        return (_class_private_field_get_continue = (_class_private_field_get = (0, _classPrivateFieldGet._)(this, _retryer)) === null || _class_private_field_get === void 0 ? void 0 : _class_private_field_get.continue()) !== null && _class_private_field_get_continue !== void 0 ? _class_private_field_get_continue : // continuing a mutation assumes that variables are set, mutation must have been dehydrated before
        this.execute(this.state.variables);
    }
    async execute(variables) {
        const onContinue = ()=>{
            (0, _classPrivateMethodGet._)(this, _dispatch, dispatch).call(this, {
                type: "continue"
            });
        };
        const mutationFnContext = {
            client: (0, _classPrivateFieldGet._)(this, _client),
            meta: this.options.meta,
            mutationKey: this.options.mutationKey
        };
        var _this_options_retry;
        (0, _classPrivateFieldSet._)(this, _retryer, (0, _retryerJs.createRetryer)({
            fn: ()=>{
                if (!this.options.mutationFn) return Promise.reject(new Error("No mutationFn found"));
                return this.options.mutationFn(variables, mutationFnContext);
            },
            onFail: (failureCount, error)=>{
                (0, _classPrivateMethodGet._)(this, _dispatch, dispatch).call(this, {
                    type: "failed",
                    failureCount,
                    error
                });
            },
            onPause: ()=>{
                (0, _classPrivateMethodGet._)(this, _dispatch, dispatch).call(this, {
                    type: "pause"
                });
            },
            onContinue,
            retry: (_this_options_retry = this.options.retry) !== null && _this_options_retry !== void 0 ? _this_options_retry : 0,
            retryDelay: this.options.retryDelay,
            networkMode: this.options.networkMode,
            canRun: ()=>(0, _classPrivateFieldGet._)(this, _mutationCache).canRun(this)
        }));
        const restored = this.state.status === "pending";
        const isPaused = !(0, _classPrivateFieldGet._)(this, _retryer).canStart();
        try {
            var _class_private_field_get_config_onSuccess, _class_private_field_get_config, _this_options_onSuccess, _this_options, _class_private_field_get_config_onSettled, _class_private_field_get_config1, _this_options_onSettled, _this_options1;
            if (restored) onContinue();
            else {
                var _this_options_onMutate, _this_options2;
                (0, _classPrivateMethodGet._)(this, _dispatch, dispatch).call(this, {
                    type: "pending",
                    variables,
                    isPaused
                });
                if ((0, _classPrivateFieldGet._)(this, _mutationCache).config.onMutate) await (0, _classPrivateFieldGet._)(this, _mutationCache).config.onMutate(variables, this, mutationFnContext);
                const context = await ((_this_options_onMutate = (_this_options2 = this.options).onMutate) === null || _this_options_onMutate === void 0 ? void 0 : _this_options_onMutate.call(_this_options2, variables, mutationFnContext));
                if (context !== this.state.context) (0, _classPrivateMethodGet._)(this, _dispatch, dispatch).call(this, {
                    type: "pending",
                    context,
                    variables,
                    isPaused
                });
            }
            const data = await (0, _classPrivateFieldGet._)(this, _retryer).start();
            await ((_class_private_field_get_config_onSuccess = (_class_private_field_get_config = (0, _classPrivateFieldGet._)(this, _mutationCache).config).onSuccess) === null || _class_private_field_get_config_onSuccess === void 0 ? void 0 : _class_private_field_get_config_onSuccess.call(_class_private_field_get_config, data, variables, this.state.context, this, mutationFnContext));
            await ((_this_options_onSuccess = (_this_options = this.options).onSuccess) === null || _this_options_onSuccess === void 0 ? void 0 : _this_options_onSuccess.call(_this_options, data, variables, this.state.context, mutationFnContext));
            await ((_class_private_field_get_config_onSettled = (_class_private_field_get_config1 = (0, _classPrivateFieldGet._)(this, _mutationCache).config).onSettled) === null || _class_private_field_get_config_onSettled === void 0 ? void 0 : _class_private_field_get_config_onSettled.call(_class_private_field_get_config1, data, null, this.state.variables, this.state.context, this, mutationFnContext));
            await ((_this_options_onSettled = (_this_options1 = this.options).onSettled) === null || _this_options_onSettled === void 0 ? void 0 : _this_options_onSettled.call(_this_options1, data, null, variables, this.state.context, mutationFnContext));
            (0, _classPrivateMethodGet._)(this, _dispatch, dispatch).call(this, {
                type: "success",
                data
            });
            return data;
        } catch (error) {
            try {
                var _class_private_field_get_config_onError, _class_private_field_get_config2;
                await ((_class_private_field_get_config_onError = (_class_private_field_get_config2 = (0, _classPrivateFieldGet._)(this, _mutationCache).config).onError) === null || _class_private_field_get_config_onError === void 0 ? void 0 : _class_private_field_get_config_onError.call(_class_private_field_get_config2, error, variables, this.state.context, this, mutationFnContext));
            } catch (e) {
                Promise.reject(e);
            }
            try {
                var _this_options_onError, _this_options3;
                await ((_this_options_onError = (_this_options3 = this.options).onError) === null || _this_options_onError === void 0 ? void 0 : _this_options_onError.call(_this_options3, error, variables, this.state.context, mutationFnContext));
            } catch (e) {
                Promise.reject(e);
            }
            try {
                var _class_private_field_get_config_onSettled1, _class_private_field_get_config3;
                await ((_class_private_field_get_config_onSettled1 = (_class_private_field_get_config3 = (0, _classPrivateFieldGet._)(this, _mutationCache).config).onSettled) === null || _class_private_field_get_config_onSettled1 === void 0 ? void 0 : _class_private_field_get_config_onSettled1.call(_class_private_field_get_config3, void 0, error, this.state.variables, this.state.context, this, mutationFnContext));
            } catch (e) {
                Promise.reject(e);
            }
            try {
                var _this_options_onSettled1, _this_options4;
                await ((_this_options_onSettled1 = (_this_options4 = this.options).onSettled) === null || _this_options_onSettled1 === void 0 ? void 0 : _this_options_onSettled1.call(_this_options4, void 0, error, variables, this.state.context, mutationFnContext));
            } catch (e) {
                Promise.reject(e);
            }
            (0, _classPrivateMethodGet._)(this, _dispatch, dispatch).call(this, {
                type: "error",
                error
            });
            throw error;
        } finally{
            (0, _classPrivateFieldGet._)(this, _mutationCache).runNext(this);
        }
    }
    constructor(config){
        super(), (0, _classPrivateMethodInit._)(this, _dispatch), (0, _classPrivateFieldInit._)(this, _client, {
            writable: true,
            value: void 0
        }), (0, _classPrivateFieldInit._)(this, _observers, {
            writable: true,
            value: void 0
        }), (0, _classPrivateFieldInit._)(this, _mutationCache, {
            writable: true,
            value: void 0
        }), (0, _classPrivateFieldInit._)(this, _retryer, {
            writable: true,
            value: void 0
        });
        (0, _classPrivateFieldSet._)(this, _client, config.client);
        this.mutationId = config.mutationId;
        (0, _classPrivateFieldSet._)(this, _mutationCache, config.mutationCache);
        (0, _classPrivateFieldSet._)(this, _observers, []);
        this.state = config.state || getDefaultState();
        this.setOptions(config.options);
        this.scheduleGc();
    }
}, _class);
function getDefaultState() {
    return {
        context: void 0,
        data: void 0,
        error: null,
        failureCount: 0,
        failureReason: null,
        isPaused: false,
        status: "idle",
        variables: void 0,
        submittedAt: 0
    };
}
function dispatch(action) {
    const reducer = (state)=>{
        switch(action.type){
            case "failed":
                return (0, _objectSpreadProps._)((0, _objectSpread._)({}, state), {
                    failureCount: action.failureCount,
                    failureReason: action.error
                });
            case "pause":
                return (0, _objectSpreadProps._)((0, _objectSpread._)({}, state), {
                    isPaused: true
                });
            case "continue":
                return (0, _objectSpreadProps._)((0, _objectSpread._)({}, state), {
                    isPaused: false
                });
            case "pending":
                return (0, _objectSpreadProps._)((0, _objectSpread._)({}, state), {
                    context: action.context,
                    data: void 0,
                    failureCount: 0,
                    failureReason: null,
                    error: null,
                    isPaused: action.isPaused,
                    status: "pending",
                    variables: action.variables,
                    submittedAt: Date.now()
                });
            case "success":
                return (0, _objectSpreadProps._)((0, _objectSpread._)({}, state), {
                    data: action.data,
                    failureCount: 0,
                    failureReason: null,
                    error: null,
                    status: "success",
                    isPaused: false
                });
            case "error":
                return (0, _objectSpreadProps._)((0, _objectSpread._)({}, state), {
                    data: void 0,
                    error: action.error,
                    failureCount: state.failureCount + 1,
                    failureReason: action.error,
                    isPaused: false,
                    status: "error"
                });
        }
    };
    this.state = reducer(this.state);
    (0, _notifyManagerJs.notifyManager).batch(()=>{
        (0, _classPrivateFieldGet._)(this, _observers).forEach((observer)=>{
            observer.onMutationUpdate(action);
        });
        (0, _classPrivateFieldGet._)(this, _mutationCache).notify({
            mutation: this,
            type: "updated",
            action
        });
    });
}

},{"@swc/helpers/_/_class_private_field_get":"iWIk2","@swc/helpers/_/_class_private_field_init":"fKzMI","@swc/helpers/_/_class_private_field_set":"7xEQl","@swc/helpers/_/_class_private_method_get":"kBKHZ","@swc/helpers/_/_class_private_method_init":"ht2pn","@swc/helpers/_/_object_spread":"9gdrV","@swc/helpers/_/_object_spread_props":"kANqQ","./notifyManager.js":"zBbK9","./removable.js":"9oJ1i","./retryer.js":"kC3c1","@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"5yYi9":[function(require,module,exports,__globalThis) {
// src/mutationObserver.ts
var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "MutationObserver", ()=>MutationObserver);
var _classPrivateFieldGet = require("@swc/helpers/_/_class_private_field_get");
var _classPrivateFieldInit = require("@swc/helpers/_/_class_private_field_init");
var _classPrivateFieldSet = require("@swc/helpers/_/_class_private_field_set");
var _classPrivateMethodGet = require("@swc/helpers/_/_class_private_method_get");
var _classPrivateMethodInit = require("@swc/helpers/_/_class_private_method_init");
var _objectSpread = require("@swc/helpers/_/_object_spread");
var _objectSpreadProps = require("@swc/helpers/_/_object_spread_props");
var _mutationJs = require("./mutation.js");
var _notifyManagerJs = require("./notifyManager.js");
var _subscribableJs = require("./subscribable.js");
var _utilsJs = require("./utils.js");
var _client, _currentResult, _currentMutation, _mutateOptions, _updateResult, _notify, _class;
var MutationObserver = (_client = /*#__PURE__*/ new WeakMap(), _currentResult = /*#__PURE__*/ new WeakMap(), _currentMutation = /*#__PURE__*/ new WeakMap(), _mutateOptions = /*#__PURE__*/ new WeakMap(), _updateResult = /*#__PURE__*/ new WeakSet(), _notify = /*#__PURE__*/ new WeakSet(), _class = class extends (0, _subscribableJs.Subscribable) {
    bindMethods() {
        this.mutate = this.mutate.bind(this);
        this.reset = this.reset.bind(this);
    }
    setOptions(options) {
        var _class_private_field_get;
        const prevOptions = this.options;
        this.options = (0, _classPrivateFieldGet._)(this, _client).defaultMutationOptions(options);
        if (!(0, _utilsJs.shallowEqualObjects)(this.options, prevOptions)) (0, _classPrivateFieldGet._)(this, _client).getMutationCache().notify({
            type: "observerOptionsUpdated",
            mutation: (0, _classPrivateFieldGet._)(this, _currentMutation),
            observer: this
        });
        if ((prevOptions === null || prevOptions === void 0 ? void 0 : prevOptions.mutationKey) && this.options.mutationKey && (0, _utilsJs.hashKey)(prevOptions.mutationKey) !== (0, _utilsJs.hashKey)(this.options.mutationKey)) this.reset();
        else if (((_class_private_field_get = (0, _classPrivateFieldGet._)(this, _currentMutation)) === null || _class_private_field_get === void 0 ? void 0 : _class_private_field_get.state.status) === "pending") (0, _classPrivateFieldGet._)(this, _currentMutation).setOptions(this.options);
    }
    onUnsubscribe() {
        var _class_private_field_get;
        if (!this.hasListeners()) (_class_private_field_get = (0, _classPrivateFieldGet._)(this, _currentMutation)) === null || _class_private_field_get === void 0 ? void 0 : _class_private_field_get.removeObserver(this);
    }
    onMutationUpdate(action) {
        (0, _classPrivateMethodGet._)(this, _updateResult, updateResult).call(this);
        (0, _classPrivateMethodGet._)(this, _notify, notify).call(this, action);
    }
    getCurrentResult() {
        return (0, _classPrivateFieldGet._)(this, _currentResult);
    }
    reset() {
        var _class_private_field_get;
        (_class_private_field_get = (0, _classPrivateFieldGet._)(this, _currentMutation)) === null || _class_private_field_get === void 0 ? void 0 : _class_private_field_get.removeObserver(this);
        (0, _classPrivateFieldSet._)(this, _currentMutation, void 0);
        (0, _classPrivateMethodGet._)(this, _updateResult, updateResult).call(this);
        (0, _classPrivateMethodGet._)(this, _notify, notify).call(this);
    }
    mutate(variables, options) {
        var _class_private_field_get;
        (0, _classPrivateFieldSet._)(this, _mutateOptions, options);
        (_class_private_field_get = (0, _classPrivateFieldGet._)(this, _currentMutation)) === null || _class_private_field_get === void 0 ? void 0 : _class_private_field_get.removeObserver(this);
        (0, _classPrivateFieldSet._)(this, _currentMutation, (0, _classPrivateFieldGet._)(this, _client).getMutationCache().build((0, _classPrivateFieldGet._)(this, _client), this.options));
        (0, _classPrivateFieldGet._)(this, _currentMutation).addObserver(this);
        return (0, _classPrivateFieldGet._)(this, _currentMutation).execute(variables);
    }
    constructor(client, options){
        super(), (0, _classPrivateMethodInit._)(this, _updateResult), (0, _classPrivateMethodInit._)(this, _notify), (0, _classPrivateFieldInit._)(this, _client, {
            writable: true,
            value: void 0
        }), (0, _classPrivateFieldInit._)(this, _currentResult, {
            writable: true,
            value: void 0
        }), (0, _classPrivateFieldInit._)(this, _currentMutation, {
            writable: true,
            value: void 0
        }), (0, _classPrivateFieldInit._)(this, _mutateOptions, {
            writable: true,
            value: void 0
        });
        (0, _classPrivateFieldSet._)(this, _client, client);
        this.setOptions(options);
        this.bindMethods();
        (0, _classPrivateMethodGet._)(this, _updateResult, updateResult).call(this);
    }
}, _class);
function updateResult() {
    var _class_private_field_get;
    var _class_private_field_get_state;
    const state = (_class_private_field_get_state = (_class_private_field_get = (0, _classPrivateFieldGet._)(this, _currentMutation)) === null || _class_private_field_get === void 0 ? void 0 : _class_private_field_get.state) !== null && _class_private_field_get_state !== void 0 ? _class_private_field_get_state : (0, _mutationJs.getDefaultState)();
    (0, _classPrivateFieldSet._)(this, _currentResult, (0, _objectSpreadProps._)((0, _objectSpread._)({}, state), {
        isPending: state.status === "pending",
        isSuccess: state.status === "success",
        isError: state.status === "error",
        isIdle: state.status === "idle",
        mutate: this.mutate,
        reset: this.reset
    }));
}
function notify(action) {
    (0, _notifyManagerJs.notifyManager).batch(()=>{
        if ((0, _classPrivateFieldGet._)(this, _mutateOptions) && this.hasListeners()) {
            const variables = (0, _classPrivateFieldGet._)(this, _currentResult).variables;
            const onMutateResult = (0, _classPrivateFieldGet._)(this, _currentResult).context;
            const context = {
                client: (0, _classPrivateFieldGet._)(this, _client),
                meta: this.options.meta,
                mutationKey: this.options.mutationKey
            };
            if ((action === null || action === void 0 ? void 0 : action.type) === "success") {
                try {
                    var _class_private_field_get_onSuccess, _class_private_field_get;
                    (_class_private_field_get_onSuccess = (_class_private_field_get = (0, _classPrivateFieldGet._)(this, _mutateOptions)).onSuccess) === null || _class_private_field_get_onSuccess === void 0 ? void 0 : _class_private_field_get_onSuccess.call(_class_private_field_get, action.data, variables, onMutateResult, context);
                } catch (e) {
                    Promise.reject(e);
                }
                try {
                    var _class_private_field_get_onSettled, _class_private_field_get1;
                    (_class_private_field_get_onSettled = (_class_private_field_get1 = (0, _classPrivateFieldGet._)(this, _mutateOptions)).onSettled) === null || _class_private_field_get_onSettled === void 0 ? void 0 : _class_private_field_get_onSettled.call(_class_private_field_get1, action.data, null, variables, onMutateResult, context);
                } catch (e) {
                    Promise.reject(e);
                }
            } else if ((action === null || action === void 0 ? void 0 : action.type) === "error") {
                try {
                    var _class_private_field_get_onError, _class_private_field_get2;
                    (_class_private_field_get_onError = (_class_private_field_get2 = (0, _classPrivateFieldGet._)(this, _mutateOptions)).onError) === null || _class_private_field_get_onError === void 0 ? void 0 : _class_private_field_get_onError.call(_class_private_field_get2, action.error, variables, onMutateResult, context);
                } catch (e) {
                    Promise.reject(e);
                }
                try {
                    var _class_private_field_get_onSettled1, _class_private_field_get3;
                    (_class_private_field_get_onSettled1 = (_class_private_field_get3 = (0, _classPrivateFieldGet._)(this, _mutateOptions)).onSettled) === null || _class_private_field_get_onSettled1 === void 0 ? void 0 : _class_private_field_get_onSettled1.call(_class_private_field_get3, void 0, action.error, variables, onMutateResult, context);
                } catch (e) {
                    Promise.reject(e);
                }
            }
        }
        this.listeners.forEach((listener)=>{
            listener((0, _classPrivateFieldGet._)(this, _currentResult));
        });
    });
}

},{"@swc/helpers/_/_class_private_field_get":"iWIk2","@swc/helpers/_/_class_private_field_init":"fKzMI","@swc/helpers/_/_class_private_field_set":"7xEQl","@swc/helpers/_/_class_private_method_get":"kBKHZ","@swc/helpers/_/_class_private_method_init":"ht2pn","@swc/helpers/_/_object_spread":"9gdrV","@swc/helpers/_/_object_spread_props":"kANqQ","./mutation.js":"l9Yi6","./notifyManager.js":"zBbK9","./subscribable.js":"94fke","./utils.js":"iAuYt","@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"3VyC4":[function(require,module,exports,__globalThis) {
// src/queryCache.ts
var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "QueryCache", ()=>QueryCache);
var _classPrivateFieldGet = require("@swc/helpers/_/_class_private_field_get");
var _classPrivateFieldInit = require("@swc/helpers/_/_class_private_field_init");
var _classPrivateFieldSet = require("@swc/helpers/_/_class_private_field_set");
var _objectSpread = require("@swc/helpers/_/_object_spread");
var _utilsJs = require("./utils.js");
var _queryJs = require("./query.js");
var _notifyManagerJs = require("./notifyManager.js");
var _subscribableJs = require("./subscribable.js");
var _queries;
var QueryCache = (_queries = /*#__PURE__*/ new WeakMap(), class extends (0, _subscribableJs.Subscribable) {
    build(client, options, state) {
        const queryKey = options.queryKey;
        var _options_queryHash;
        const queryHash = (_options_queryHash = options.queryHash) !== null && _options_queryHash !== void 0 ? _options_queryHash : (0, _utilsJs.hashQueryKeyByOptions)(queryKey, options);
        let query = this.get(queryHash);
        if (!query) {
            query = new (0, _queryJs.Query)({
                client,
                queryKey,
                queryHash,
                options: client.defaultQueryOptions(options),
                state,
                defaultOptions: client.getQueryDefaults(queryKey)
            });
            this.add(query);
        }
        return query;
    }
    add(query) {
        if (!(0, _classPrivateFieldGet._)(this, _queries).has(query.queryHash)) {
            (0, _classPrivateFieldGet._)(this, _queries).set(query.queryHash, query);
            this.notify({
                type: "added",
                query
            });
        }
    }
    remove(query) {
        const queryInMap = (0, _classPrivateFieldGet._)(this, _queries).get(query.queryHash);
        if (queryInMap) {
            query.destroy();
            if (queryInMap === query) (0, _classPrivateFieldGet._)(this, _queries).delete(query.queryHash);
            this.notify({
                type: "removed",
                query
            });
        }
    }
    clear() {
        (0, _notifyManagerJs.notifyManager).batch(()=>{
            this.getAll().forEach((query)=>{
                this.remove(query);
            });
        });
    }
    get(queryHash) {
        return (0, _classPrivateFieldGet._)(this, _queries).get(queryHash);
    }
    getAll() {
        return [
            ...(0, _classPrivateFieldGet._)(this, _queries).values()
        ];
    }
    find(filters) {
        const defaultedFilters = (0, _objectSpread._)({
            exact: true
        }, filters);
        return this.getAll().find((query)=>(0, _utilsJs.matchQuery)(defaultedFilters, query));
    }
    findAll(filters = {}) {
        const queries = this.getAll();
        return Object.keys(filters).length > 0 ? queries.filter((query)=>(0, _utilsJs.matchQuery)(filters, query)) : queries;
    }
    notify(event) {
        (0, _notifyManagerJs.notifyManager).batch(()=>{
            this.listeners.forEach((listener)=>{
                listener(event);
            });
        });
    }
    onFocus() {
        (0, _notifyManagerJs.notifyManager).batch(()=>{
            this.getAll().forEach((query)=>{
                query.onFocus();
            });
        });
    }
    onOnline() {
        (0, _notifyManagerJs.notifyManager).batch(()=>{
            this.getAll().forEach((query)=>{
                query.onOnline();
            });
        });
    }
    constructor(config = {}){
        super(), (0, _classPrivateFieldInit._)(this, _queries, {
            writable: true,
            value: void 0
        });
        this.config = config;
        (0, _classPrivateFieldSet._)(this, _queries, /* @__PURE__ */ new Map());
    }
});

},{"@swc/helpers/_/_class_private_field_get":"iWIk2","@swc/helpers/_/_class_private_field_init":"fKzMI","@swc/helpers/_/_class_private_field_set":"7xEQl","@swc/helpers/_/_object_spread":"9gdrV","./utils.js":"iAuYt","./query.js":"jtMv6","./notifyManager.js":"zBbK9","./subscribable.js":"94fke","@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"4q1ux":[function(require,module,exports,__globalThis) {
// src/queryClient.ts
var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "QueryClient", ()=>QueryClient);
var _classPrivateFieldGet = require("@swc/helpers/_/_class_private_field_get");
var _classPrivateFieldInit = require("@swc/helpers/_/_class_private_field_init");
var _classPrivateFieldSet = require("@swc/helpers/_/_class_private_field_set");
var _classPrivateFieldUpdate = require("@swc/helpers/_/_class_private_field_update");
var _objectSpread = require("@swc/helpers/_/_object_spread");
var _objectSpreadProps = require("@swc/helpers/_/_object_spread_props");
var _utilsJs = require("./utils.js");
var _queryCacheJs = require("./queryCache.js");
var _mutationCacheJs = require("./mutationCache.js");
var _focusManagerJs = require("./focusManager.js");
var _onlineManagerJs = require("./onlineManager.js");
var _notifyManagerJs = require("./notifyManager.js");
var _infiniteQueryBehaviorJs = require("./infiniteQueryBehavior.js");
var _queryCache, _mutationCache, _defaultOptions, _queryDefaults, _mutationDefaults, _mountCount, _unsubscribeFocus, _unsubscribeOnline;
var QueryClient = (_queryCache = /*#__PURE__*/ new WeakMap(), _mutationCache = /*#__PURE__*/ new WeakMap(), _defaultOptions = /*#__PURE__*/ new WeakMap(), _queryDefaults = /*#__PURE__*/ new WeakMap(), _mutationDefaults = /*#__PURE__*/ new WeakMap(), _mountCount = /*#__PURE__*/ new WeakMap(), _unsubscribeFocus = /*#__PURE__*/ new WeakMap(), _unsubscribeOnline = /*#__PURE__*/ new WeakMap(), class {
    mount() {
        (0, _classPrivateFieldUpdate._)(this, _mountCount).value++;
        if ((0, _classPrivateFieldGet._)(this, _mountCount) !== 1) return;
        (0, _classPrivateFieldSet._)(this, _unsubscribeFocus, (0, _focusManagerJs.focusManager).subscribe(async (focused)=>{
            if (focused) {
                await this.resumePausedMutations();
                (0, _classPrivateFieldGet._)(this, _queryCache).onFocus();
            }
        }));
        (0, _classPrivateFieldSet._)(this, _unsubscribeOnline, (0, _onlineManagerJs.onlineManager).subscribe(async (online)=>{
            if (online) {
                await this.resumePausedMutations();
                (0, _classPrivateFieldGet._)(this, _queryCache).onOnline();
            }
        }));
    }
    unmount() {
        var _this, _this1, _ref, _this2, _this3, _ref1;
        (0, _classPrivateFieldUpdate._)(this, _mountCount).value--;
        if ((0, _classPrivateFieldGet._)(this, _mountCount) !== 0) return;
        (_this = (0, _classPrivateFieldGet._)(_ref = _this1 = this, _unsubscribeFocus)) === null || _this === void 0 ? void 0 : _this.call(_this1);
        (0, _classPrivateFieldSet._)(this, _unsubscribeFocus, void 0);
        (_this2 = (0, _classPrivateFieldGet._)(_ref1 = _this3 = this, _unsubscribeOnline)) === null || _this2 === void 0 ? void 0 : _this2.call(_this3);
        (0, _classPrivateFieldSet._)(this, _unsubscribeOnline, void 0);
    }
    isFetching(filters) {
        return (0, _classPrivateFieldGet._)(this, _queryCache).findAll((0, _objectSpreadProps._)((0, _objectSpread._)({}, filters), {
            fetchStatus: "fetching"
        })).length;
    }
    isMutating(filters) {
        return (0, _classPrivateFieldGet._)(this, _mutationCache).findAll((0, _objectSpreadProps._)((0, _objectSpread._)({}, filters), {
            status: "pending"
        })).length;
    }
    /**
   * Imperative (non-reactive) way to retrieve data for a QueryKey.
   * Should only be used in callbacks or functions where reading the latest data is necessary, e.g. for optimistic updates.
   *
   * Hint: Do not use this function inside a component, because it won't receive updates.
   * Use `useQuery` to create a `QueryObserver` that subscribes to changes.
   */ getQueryData(queryKey) {
        var _class_private_field_get_get;
        const options = this.defaultQueryOptions({
            queryKey
        });
        return (_class_private_field_get_get = (0, _classPrivateFieldGet._)(this, _queryCache).get(options.queryHash)) === null || _class_private_field_get_get === void 0 ? void 0 : _class_private_field_get_get.state.data;
    }
    ensureQueryData(options) {
        const defaultedOptions = this.defaultQueryOptions(options);
        const query = (0, _classPrivateFieldGet._)(this, _queryCache).build(this, defaultedOptions);
        const cachedData = query.state.data;
        if (cachedData === void 0) return this.fetchQuery(options);
        if (options.revalidateIfStale && query.isStaleByTime((0, _utilsJs.resolveStaleTime)(defaultedOptions.staleTime, query))) this.prefetchQuery(defaultedOptions);
        return Promise.resolve(cachedData);
    }
    getQueriesData(filters) {
        return (0, _classPrivateFieldGet._)(this, _queryCache).findAll(filters).map(({ queryKey, state })=>{
            const data = state.data;
            return [
                queryKey,
                data
            ];
        });
    }
    setQueryData(queryKey, updater, options) {
        const defaultedOptions = this.defaultQueryOptions({
            queryKey
        });
        const query = (0, _classPrivateFieldGet._)(this, _queryCache).get(defaultedOptions.queryHash);
        const prevData = query === null || query === void 0 ? void 0 : query.state.data;
        const data = (0, _utilsJs.functionalUpdate)(updater, prevData);
        if (data === void 0) return void 0;
        return (0, _classPrivateFieldGet._)(this, _queryCache).build(this, defaultedOptions).setData(data, (0, _objectSpreadProps._)((0, _objectSpread._)({}, options), {
            manual: true
        }));
    }
    setQueriesData(filters, updater, options) {
        return (0, _notifyManagerJs.notifyManager).batch(()=>(0, _classPrivateFieldGet._)(this, _queryCache).findAll(filters).map(({ queryKey })=>[
                    queryKey,
                    this.setQueryData(queryKey, updater, options)
                ]));
    }
    getQueryState(queryKey) {
        var _class_private_field_get_get;
        const options = this.defaultQueryOptions({
            queryKey
        });
        return (_class_private_field_get_get = (0, _classPrivateFieldGet._)(this, _queryCache).get(options.queryHash)) === null || _class_private_field_get_get === void 0 ? void 0 : _class_private_field_get_get.state;
    }
    removeQueries(filters) {
        const queryCache = (0, _classPrivateFieldGet._)(this, _queryCache);
        (0, _notifyManagerJs.notifyManager).batch(()=>{
            queryCache.findAll(filters).forEach((query)=>{
                queryCache.remove(query);
            });
        });
    }
    resetQueries(filters, options) {
        const queryCache = (0, _classPrivateFieldGet._)(this, _queryCache);
        return (0, _notifyManagerJs.notifyManager).batch(()=>{
            queryCache.findAll(filters).forEach((query)=>{
                query.reset();
            });
            return this.refetchQueries((0, _objectSpread._)({
                type: "active"
            }, filters), options);
        });
    }
    cancelQueries(filters, cancelOptions = {}) {
        const defaultedCancelOptions = (0, _objectSpread._)({
            revert: true
        }, cancelOptions);
        const promises = (0, _notifyManagerJs.notifyManager).batch(()=>(0, _classPrivateFieldGet._)(this, _queryCache).findAll(filters).map((query)=>query.cancel(defaultedCancelOptions)));
        return Promise.all(promises).then((0, _utilsJs.noop)).catch((0, _utilsJs.noop));
    }
    invalidateQueries(filters, options = {}) {
        return (0, _notifyManagerJs.notifyManager).batch(()=>{
            (0, _classPrivateFieldGet._)(this, _queryCache).findAll(filters).forEach((query)=>{
                query.invalidate();
            });
            if ((filters === null || filters === void 0 ? void 0 : filters.refetchType) === "none") return Promise.resolve();
            var _filters_refetchType, _ref;
            return this.refetchQueries((0, _objectSpreadProps._)((0, _objectSpread._)({}, filters), {
                type: (_ref = (_filters_refetchType = filters === null || filters === void 0 ? void 0 : filters.refetchType) !== null && _filters_refetchType !== void 0 ? _filters_refetchType : filters === null || filters === void 0 ? void 0 : filters.type) !== null && _ref !== void 0 ? _ref : "active"
            }), options);
        });
    }
    refetchQueries(filters, options = {}) {
        var _options_cancelRefetch;
        const fetchOptions = (0, _objectSpreadProps._)((0, _objectSpread._)({}, options), {
            cancelRefetch: (_options_cancelRefetch = options.cancelRefetch) !== null && _options_cancelRefetch !== void 0 ? _options_cancelRefetch : true
        });
        const promises = (0, _notifyManagerJs.notifyManager).batch(()=>(0, _classPrivateFieldGet._)(this, _queryCache).findAll(filters).filter((query)=>!query.isDisabled() && !query.isStatic()).map((query)=>{
                let promise = query.fetch(void 0, fetchOptions);
                if (!fetchOptions.throwOnError) promise = promise.catch((0, _utilsJs.noop));
                return query.state.fetchStatus === "paused" ? Promise.resolve() : promise;
            }));
        return Promise.all(promises).then((0, _utilsJs.noop));
    }
    fetchQuery(options) {
        const defaultedOptions = this.defaultQueryOptions(options);
        if (defaultedOptions.retry === void 0) defaultedOptions.retry = false;
        const query = (0, _classPrivateFieldGet._)(this, _queryCache).build(this, defaultedOptions);
        return query.isStaleByTime((0, _utilsJs.resolveStaleTime)(defaultedOptions.staleTime, query)) ? query.fetch(defaultedOptions) : Promise.resolve(query.state.data);
    }
    prefetchQuery(options) {
        return this.fetchQuery(options).then((0, _utilsJs.noop)).catch((0, _utilsJs.noop));
    }
    fetchInfiniteQuery(options) {
        options.behavior = (0, _infiniteQueryBehaviorJs.infiniteQueryBehavior)(options.pages);
        return this.fetchQuery(options);
    }
    prefetchInfiniteQuery(options) {
        return this.fetchInfiniteQuery(options).then((0, _utilsJs.noop)).catch((0, _utilsJs.noop));
    }
    ensureInfiniteQueryData(options) {
        options.behavior = (0, _infiniteQueryBehaviorJs.infiniteQueryBehavior)(options.pages);
        return this.ensureQueryData(options);
    }
    resumePausedMutations() {
        if ((0, _onlineManagerJs.onlineManager).isOnline()) return (0, _classPrivateFieldGet._)(this, _mutationCache).resumePausedMutations();
        return Promise.resolve();
    }
    getQueryCache() {
        return (0, _classPrivateFieldGet._)(this, _queryCache);
    }
    getMutationCache() {
        return (0, _classPrivateFieldGet._)(this, _mutationCache);
    }
    getDefaultOptions() {
        return (0, _classPrivateFieldGet._)(this, _defaultOptions);
    }
    setDefaultOptions(options) {
        (0, _classPrivateFieldSet._)(this, _defaultOptions, options);
    }
    setQueryDefaults(queryKey, options) {
        (0, _classPrivateFieldGet._)(this, _queryDefaults).set((0, _utilsJs.hashKey)(queryKey), {
            queryKey,
            defaultOptions: options
        });
    }
    getQueryDefaults(queryKey) {
        const defaults = [
            ...(0, _classPrivateFieldGet._)(this, _queryDefaults).values()
        ];
        const result = {};
        defaults.forEach((queryDefault)=>{
            if ((0, _utilsJs.partialMatchKey)(queryKey, queryDefault.queryKey)) Object.assign(result, queryDefault.defaultOptions);
        });
        return result;
    }
    setMutationDefaults(mutationKey, options) {
        (0, _classPrivateFieldGet._)(this, _mutationDefaults).set((0, _utilsJs.hashKey)(mutationKey), {
            mutationKey,
            defaultOptions: options
        });
    }
    getMutationDefaults(mutationKey) {
        const defaults = [
            ...(0, _classPrivateFieldGet._)(this, _mutationDefaults).values()
        ];
        const result = {};
        defaults.forEach((queryDefault)=>{
            if ((0, _utilsJs.partialMatchKey)(mutationKey, queryDefault.mutationKey)) Object.assign(result, queryDefault.defaultOptions);
        });
        return result;
    }
    defaultQueryOptions(options) {
        if (options._defaulted) return options;
        const defaultedOptions = (0, _objectSpreadProps._)((0, _objectSpread._)({}, (0, _classPrivateFieldGet._)(this, _defaultOptions).queries, this.getQueryDefaults(options.queryKey), options), {
            _defaulted: true
        });
        if (!defaultedOptions.queryHash) defaultedOptions.queryHash = (0, _utilsJs.hashQueryKeyByOptions)(defaultedOptions.queryKey, defaultedOptions);
        if (defaultedOptions.refetchOnReconnect === void 0) defaultedOptions.refetchOnReconnect = defaultedOptions.networkMode !== "always";
        if (defaultedOptions.throwOnError === void 0) defaultedOptions.throwOnError = !!defaultedOptions.suspense;
        if (!defaultedOptions.networkMode && defaultedOptions.persister) defaultedOptions.networkMode = "offlineFirst";
        if (defaultedOptions.queryFn === (0, _utilsJs.skipToken)) defaultedOptions.enabled = false;
        return defaultedOptions;
    }
    defaultMutationOptions(options) {
        if (options === null || options === void 0 ? void 0 : options._defaulted) return options;
        return (0, _objectSpreadProps._)((0, _objectSpread._)({}, (0, _classPrivateFieldGet._)(this, _defaultOptions).mutations, (options === null || options === void 0 ? void 0 : options.mutationKey) && this.getMutationDefaults(options.mutationKey), options), {
            _defaulted: true
        });
    }
    clear() {
        (0, _classPrivateFieldGet._)(this, _queryCache).clear();
        (0, _classPrivateFieldGet._)(this, _mutationCache).clear();
    }
    constructor(config = {}){
        (0, _classPrivateFieldInit._)(this, _queryCache, {
            writable: true,
            value: void 0
        });
        (0, _classPrivateFieldInit._)(this, _mutationCache, {
            writable: true,
            value: void 0
        });
        (0, _classPrivateFieldInit._)(this, _defaultOptions, {
            writable: true,
            value: void 0
        });
        (0, _classPrivateFieldInit._)(this, _queryDefaults, {
            writable: true,
            value: void 0
        });
        (0, _classPrivateFieldInit._)(this, _mutationDefaults, {
            writable: true,
            value: void 0
        });
        (0, _classPrivateFieldInit._)(this, _mountCount, {
            writable: true,
            value: void 0
        });
        (0, _classPrivateFieldInit._)(this, _unsubscribeFocus, {
            writable: true,
            value: void 0
        });
        (0, _classPrivateFieldInit._)(this, _unsubscribeOnline, {
            writable: true,
            value: void 0
        });
        (0, _classPrivateFieldSet._)(this, _queryCache, config.queryCache || new (0, _queryCacheJs.QueryCache)());
        (0, _classPrivateFieldSet._)(this, _mutationCache, config.mutationCache || new (0, _mutationCacheJs.MutationCache)());
        (0, _classPrivateFieldSet._)(this, _defaultOptions, config.defaultOptions || {});
        (0, _classPrivateFieldSet._)(this, _queryDefaults, /* @__PURE__ */ new Map());
        (0, _classPrivateFieldSet._)(this, _mutationDefaults, /* @__PURE__ */ new Map());
        (0, _classPrivateFieldSet._)(this, _mountCount, 0);
    }
});

},{"@swc/helpers/_/_class_private_field_get":"iWIk2","@swc/helpers/_/_class_private_field_init":"fKzMI","@swc/helpers/_/_class_private_field_set":"7xEQl","@swc/helpers/_/_class_private_field_update":"7mTy2","@swc/helpers/_/_object_spread":"9gdrV","@swc/helpers/_/_object_spread_props":"kANqQ","./utils.js":"iAuYt","./queryCache.js":"3VyC4","./mutationCache.js":"6G0Tw","./focusManager.js":"d6FbS","./onlineManager.js":"lWiWx","./notifyManager.js":"zBbK9","./infiniteQueryBehavior.js":"eDkXW","@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"7BIr6":[function(require,module,exports,__globalThis) {

},{}],"j7hrr":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "useQuery", ()=>useQuery);
// src/useQuery.ts
var _queryCore = require("@tanstack/query-core");
var _useBaseQueryJs = require("./useBaseQuery.js");
"use client";
function useQuery(options, queryClient) {
    return (0, _useBaseQueryJs.useBaseQuery)(options, (0, _queryCore.QueryObserver), queryClient);
}

},{"@tanstack/query-core":"6f4TB","./useBaseQuery.js":"27D6k","@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"27D6k":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "useBaseQuery", ()=>useBaseQuery);
// src/useBaseQuery.ts
var _react = require("react");
var _queryCore = require("@tanstack/query-core");
var _queryClientProviderJs = require("./QueryClientProvider.js");
var _queryErrorResetBoundaryJs = require("./QueryErrorResetBoundary.js");
var _errorBoundaryUtilsJs = require("./errorBoundaryUtils.js");
var _isRestoringProviderJs = require("./IsRestoringProvider.js");
var _suspenseJs = require("./suspense.js");
"use client";
function useBaseQuery(options, Observer, queryClient) {
    var _client_getDefaultOptions_queries__experimental_beforeQuery, _client_getDefaultOptions_queries, _client_getDefaultOptions_queries__experimental_afterQuery, _client_getDefaultOptions_queries1;
    const isRestoring = (0, _isRestoringProviderJs.useIsRestoring)();
    const errorResetBoundary = (0, _queryErrorResetBoundaryJs.useQueryErrorResetBoundary)();
    const client = (0, _queryClientProviderJs.useQueryClient)(queryClient);
    const defaultedOptions = client.defaultQueryOptions(options);
    (_client_getDefaultOptions_queries = client.getDefaultOptions().queries) === null || _client_getDefaultOptions_queries === void 0 ? void 0 : (_client_getDefaultOptions_queries__experimental_beforeQuery = _client_getDefaultOptions_queries._experimental_beforeQuery) === null || _client_getDefaultOptions_queries__experimental_beforeQuery === void 0 ? void 0 : _client_getDefaultOptions_queries__experimental_beforeQuery.call(_client_getDefaultOptions_queries, defaultedOptions);
    const query = client.getQueryCache().get(defaultedOptions.queryHash);
    defaultedOptions._optimisticResults = isRestoring ? "isRestoring" : "optimistic";
    (0, _suspenseJs.ensureSuspenseTimers)(defaultedOptions);
    (0, _errorBoundaryUtilsJs.ensurePreventErrorBoundaryRetry)(defaultedOptions, errorResetBoundary, query);
    (0, _errorBoundaryUtilsJs.useClearResetErrorBoundary)(errorResetBoundary);
    const isNewCacheEntry = !client.getQueryCache().get(defaultedOptions.queryHash);
    const [observer] = _react.useState(()=>new Observer(client, defaultedOptions));
    const result = observer.getOptimisticResult(defaultedOptions);
    const shouldSubscribe = !isRestoring && options.subscribed !== false;
    _react.useSyncExternalStore(_react.useCallback((onStoreChange)=>{
        const unsubscribe = shouldSubscribe ? observer.subscribe((0, _queryCore.notifyManager).batchCalls(onStoreChange)) : (0, _queryCore.noop);
        observer.updateResult();
        return unsubscribe;
    }, [
        observer,
        shouldSubscribe
    ]), ()=>observer.getCurrentResult(), ()=>observer.getCurrentResult());
    _react.useEffect(()=>{
        observer.setOptions(defaultedOptions);
    }, [
        defaultedOptions,
        observer
    ]);
    if ((0, _suspenseJs.shouldSuspend)(defaultedOptions, result)) throw (0, _suspenseJs.fetchOptimistic)(defaultedOptions, observer, errorResetBoundary);
    if ((0, _errorBoundaryUtilsJs.getHasError)({
        result,
        errorResetBoundary,
        throwOnError: defaultedOptions.throwOnError,
        query,
        suspense: defaultedOptions.suspense
    })) throw result.error;
    (_client_getDefaultOptions_queries1 = client.getDefaultOptions().queries) === null || _client_getDefaultOptions_queries1 === void 0 ? void 0 : (_client_getDefaultOptions_queries__experimental_afterQuery = _client_getDefaultOptions_queries1._experimental_afterQuery) === null || _client_getDefaultOptions_queries__experimental_afterQuery === void 0 ? void 0 : _client_getDefaultOptions_queries__experimental_afterQuery.call(_client_getDefaultOptions_queries1, defaultedOptions, result);
    if (defaultedOptions.experimental_prefetchInRender && !(0, _queryCore.isServer) && (0, _suspenseJs.willFetch)(result, isRestoring)) {
        const promise = isNewCacheEntry ? // Fetch immediately on render in order to ensure `.promise` is resolved even if the component is unmounted
        (0, _suspenseJs.fetchOptimistic)(defaultedOptions, observer, errorResetBoundary) : // subscribe to the "cache promise" so that we can finalize the currentThenable once data comes in
        query === null || query === void 0 ? void 0 : query.promise;
        promise === null || promise === void 0 ? void 0 : promise.catch((0, _queryCore.noop)).finally(()=>{
            observer.updateResult();
        });
    }
    return !defaultedOptions.notifyOnChangeProps ? observer.trackResult(result) : result;
}

},{"react":"ltHCL","@tanstack/query-core":"6f4TB","./QueryClientProvider.js":"3ogTH","./QueryErrorResetBoundary.js":"2FpMu","./errorBoundaryUtils.js":"bAKsA","./IsRestoringProvider.js":"bWluE","./suspense.js":"fzXzC","@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"3ogTH":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "QueryClientContext", ()=>QueryClientContext);
parcelHelpers.export(exports, "QueryClientProvider", ()=>QueryClientProvider);
parcelHelpers.export(exports, "useQueryClient", ()=>useQueryClient);
// src/QueryClientProvider.tsx
var _react = require("react");
var _jsxRuntime = require("react/jsx-runtime");
"use client";
var QueryClientContext = _react.createContext(void 0);
var useQueryClient = (queryClient)=>{
    const client = _react.useContext(QueryClientContext);
    if (queryClient) return queryClient;
    if (!client) throw new Error("No QueryClient set, use QueryClientProvider to set one");
    return client;
};
var QueryClientProvider = ({ client, children })=>{
    _react.useEffect(()=>{
        client.mount();
        return ()=>{
            client.unmount();
        };
    }, [
        client
    ]);
    return /* @__PURE__ */ (0, _jsxRuntime.jsx)(QueryClientContext.Provider, {
        value: client,
        children
    });
};

},{"react":"ltHCL","react/jsx-runtime":"bGvcw","@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"bGvcw":[function(require,module,exports,__globalThis) {
'use strict';
module.exports = require("8f6663d459303948");

},{"8f6663d459303948":"kXQRc"}],"kXQRc":[function(require,module,exports,__globalThis) {
/**
 * @license React
 * react-jsx-runtime.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ 'use strict';
var f = require("1fb5592ff6bdf302"), k = Symbol.for("react.element"), l = Symbol.for("react.fragment"), m = Object.prototype.hasOwnProperty, n = f.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED.ReactCurrentOwner, p = {
    key: !0,
    ref: !0,
    __self: !0,
    __source: !0
};
function q(c, a, g) {
    var b, d = {}, e = null, h = null;
    void 0 !== g && (e = "" + g);
    void 0 !== a.key && (e = "" + a.key);
    void 0 !== a.ref && (h = a.ref);
    for(b in a)m.call(a, b) && !p.hasOwnProperty(b) && (d[b] = a[b]);
    if (c && c.defaultProps) for(b in a = c.defaultProps, a)void 0 === d[b] && (d[b] = a[b]);
    return {
        $$typeof: k,
        type: c,
        key: e,
        ref: h,
        props: d,
        _owner: n.current
    };
}
exports.Fragment = l;
exports.jsx = q;
exports.jsxs = q;

},{"1fb5592ff6bdf302":"ltHCL"}],"2FpMu":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "QueryErrorResetBoundary", ()=>QueryErrorResetBoundary);
parcelHelpers.export(exports, "useQueryErrorResetBoundary", ()=>useQueryErrorResetBoundary);
// src/QueryErrorResetBoundary.tsx
var _react = require("react");
var _jsxRuntime = require("react/jsx-runtime");
"use client";
function createValue() {
    let isReset = false;
    return {
        clearReset: ()=>{
            isReset = false;
        },
        reset: ()=>{
            isReset = true;
        },
        isReset: ()=>{
            return isReset;
        }
    };
}
var QueryErrorResetBoundaryContext = _react.createContext(createValue());
var useQueryErrorResetBoundary = ()=>_react.useContext(QueryErrorResetBoundaryContext);
var QueryErrorResetBoundary = ({ children })=>{
    const [value] = _react.useState(()=>createValue());
    return /* @__PURE__ */ (0, _jsxRuntime.jsx)(QueryErrorResetBoundaryContext.Provider, {
        value,
        children: typeof children === "function" ? children(value) : children
    });
};

},{"react":"ltHCL","react/jsx-runtime":"bGvcw","@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"bAKsA":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "ensurePreventErrorBoundaryRetry", ()=>ensurePreventErrorBoundaryRetry);
parcelHelpers.export(exports, "getHasError", ()=>getHasError);
parcelHelpers.export(exports, "useClearResetErrorBoundary", ()=>useClearResetErrorBoundary);
// src/errorBoundaryUtils.ts
var _react = require("react");
var _queryCore = require("@tanstack/query-core");
"use client";
var ensurePreventErrorBoundaryRetry = (options, errorResetBoundary, query)=>{
    const throwOnError = (query === null || query === void 0 ? void 0 : query.state.error) && typeof options.throwOnError === "function" ? (0, _queryCore.shouldThrowError)(options.throwOnError, [
        query.state.error,
        query
    ]) : options.throwOnError;
    if (options.suspense || options.experimental_prefetchInRender || throwOnError) {
        if (!errorResetBoundary.isReset()) options.retryOnMount = false;
    }
};
var useClearResetErrorBoundary = (errorResetBoundary)=>{
    _react.useEffect(()=>{
        errorResetBoundary.clearReset();
    }, [
        errorResetBoundary
    ]);
};
var getHasError = ({ result, errorResetBoundary, throwOnError, query, suspense })=>{
    return result.isError && !errorResetBoundary.isReset() && !result.isFetching && query && (suspense && result.data === void 0 || (0, _queryCore.shouldThrowError)(throwOnError, [
        result.error,
        query
    ]));
};

},{"react":"ltHCL","@tanstack/query-core":"6f4TB","@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"bWluE":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "IsRestoringProvider", ()=>IsRestoringProvider);
parcelHelpers.export(exports, "useIsRestoring", ()=>useIsRestoring);
// src/IsRestoringProvider.ts
var _react = require("react");
"use client";
var IsRestoringContext = _react.createContext(false);
var useIsRestoring = ()=>_react.useContext(IsRestoringContext);
var IsRestoringProvider = IsRestoringContext.Provider;

},{"react":"ltHCL","@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"fzXzC":[function(require,module,exports,__globalThis) {
// src/suspense.ts
var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "defaultThrowOnError", ()=>defaultThrowOnError);
parcelHelpers.export(exports, "ensureSuspenseTimers", ()=>ensureSuspenseTimers);
parcelHelpers.export(exports, "fetchOptimistic", ()=>fetchOptimistic);
parcelHelpers.export(exports, "shouldSuspend", ()=>shouldSuspend);
parcelHelpers.export(exports, "willFetch", ()=>willFetch);
var defaultThrowOnError = (_error, query)=>query.state.data === void 0;
var ensureSuspenseTimers = (defaultedOptions)=>{
    if (defaultedOptions.suspense) {
        const MIN_SUSPENSE_TIME_MS = 1e3;
        const clamp = (value)=>value === "static" ? value : Math.max(value !== null && value !== void 0 ? value : MIN_SUSPENSE_TIME_MS, MIN_SUSPENSE_TIME_MS);
        const originalStaleTime = defaultedOptions.staleTime;
        defaultedOptions.staleTime = typeof originalStaleTime === "function" ? (...args)=>clamp(originalStaleTime(...args)) : clamp(originalStaleTime);
        if (typeof defaultedOptions.gcTime === "number") defaultedOptions.gcTime = Math.max(defaultedOptions.gcTime, MIN_SUSPENSE_TIME_MS);
    }
};
var willFetch = (result, isRestoring)=>result.isLoading && result.isFetching && !isRestoring;
var shouldSuspend = (defaultedOptions, result)=>(defaultedOptions === null || defaultedOptions === void 0 ? void 0 : defaultedOptions.suspense) && result.isPending;
var fetchOptimistic = (defaultedOptions, observer, errorResetBoundary)=>observer.fetchOptimistic(defaultedOptions).catch(()=>{
        errorResetBoundary.clearReset();
    });

},{"@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"iHOqf":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "useSuspenseQuery", ()=>useSuspenseQuery);
var _objectSpread = require("@swc/helpers/_/_object_spread");
var _objectSpreadProps = require("@swc/helpers/_/_object_spread_props");
// src/useSuspenseQuery.ts
var _queryCore = require("@tanstack/query-core");
var _useBaseQueryJs = require("./useBaseQuery.js");
var _suspenseJs = require("./suspense.js");
"use client";
function useSuspenseQuery(options, queryClient) {
    return (0, _useBaseQueryJs.useBaseQuery)((0, _objectSpreadProps._)((0, _objectSpread._)({}, options), {
        enabled: true,
        suspense: true,
        throwOnError: (0, _suspenseJs.defaultThrowOnError),
        placeholderData: void 0
    }), (0, _queryCore.QueryObserver), queryClient);
}

},{"@swc/helpers/_/_object_spread":"9gdrV","@swc/helpers/_/_object_spread_props":"kANqQ","@tanstack/query-core":"6f4TB","./useBaseQuery.js":"27D6k","./suspense.js":"fzXzC","@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"gnaxx":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "useSuspenseInfiniteQuery", ()=>useSuspenseInfiniteQuery);
var _objectSpread = require("@swc/helpers/_/_object_spread");
var _objectSpreadProps = require("@swc/helpers/_/_object_spread_props");
// src/useSuspenseInfiniteQuery.ts
var _queryCore = require("@tanstack/query-core");
var _useBaseQueryJs = require("./useBaseQuery.js");
var _suspenseJs = require("./suspense.js");
"use client";
function useSuspenseInfiniteQuery(options, queryClient) {
    return (0, _useBaseQueryJs.useBaseQuery)((0, _objectSpreadProps._)((0, _objectSpread._)({}, options), {
        enabled: true,
        suspense: true,
        throwOnError: (0, _suspenseJs.defaultThrowOnError)
    }), (0, _queryCore.InfiniteQueryObserver), queryClient);
}

},{"@swc/helpers/_/_object_spread":"9gdrV","@swc/helpers/_/_object_spread_props":"kANqQ","@tanstack/query-core":"6f4TB","./useBaseQuery.js":"27D6k","./suspense.js":"fzXzC","@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"h8o4n":[function(require,module,exports,__globalThis) {
// src/queryOptions.ts
var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "queryOptions", ()=>queryOptions);
function queryOptions(options) {
    return options;
}

},{"@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"c82q9":[function(require,module,exports,__globalThis) {
// src/infiniteQueryOptions.ts
var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "infiniteQueryOptions", ()=>infiniteQueryOptions);
function infiniteQueryOptions(options) {
    return options;
}

},{"@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"lq41E":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "useIsMutating", ()=>useIsMutating);
parcelHelpers.export(exports, "useMutationState", ()=>useMutationState);
var _objectSpread = require("@swc/helpers/_/_object_spread");
var _objectSpreadProps = require("@swc/helpers/_/_object_spread_props");
// src/useMutationState.ts
var _react = require("react");
var _queryCore = require("@tanstack/query-core");
var _queryClientProviderJs = require("./QueryClientProvider.js");
"use client";
function useIsMutating(filters, queryClient) {
    const client = (0, _queryClientProviderJs.useQueryClient)(queryClient);
    return useMutationState({
        filters: (0, _objectSpreadProps._)((0, _objectSpread._)({}, filters), {
            status: "pending"
        })
    }, client).length;
}
function getResult(mutationCache, options) {
    return mutationCache.findAll(options.filters).map((mutation)=>options.select ? options.select(mutation) : mutation.state);
}
function useMutationState(options = {}, queryClient) {
    const mutationCache = (0, _queryClientProviderJs.useQueryClient)(queryClient).getMutationCache();
    const optionsRef = _react.useRef(options);
    const result = _react.useRef(null);
    if (result.current === null) result.current = getResult(mutationCache, options);
    _react.useEffect(()=>{
        optionsRef.current = options;
    });
    return _react.useSyncExternalStore(_react.useCallback((onStoreChange)=>mutationCache.subscribe(()=>{
            const nextResult = (0, _queryCore.replaceEqualDeep)(result.current, getResult(mutationCache, optionsRef.current));
            if (result.current !== nextResult) {
                result.current = nextResult;
                (0, _queryCore.notifyManager).schedule(onStoreChange);
            }
        }), [
        mutationCache
    ]), ()=>result.current, ()=>result.current);
}

},{"@swc/helpers/_/_object_spread":"9gdrV","@swc/helpers/_/_object_spread_props":"kANqQ","react":"ltHCL","@tanstack/query-core":"6f4TB","./QueryClientProvider.js":"3ogTH","@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"hhJXU":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "useMutation", ()=>useMutation);
var _objectSpread = require("@swc/helpers/_/_object_spread");
var _objectSpreadProps = require("@swc/helpers/_/_object_spread_props");
// src/useMutation.ts
var _react = require("react");
var _queryCore = require("@tanstack/query-core");
var _queryClientProviderJs = require("./QueryClientProvider.js");
"use client";
function useMutation(options, queryClient) {
    const client = (0, _queryClientProviderJs.useQueryClient)(queryClient);
    const [observer] = _react.useState(()=>new (0, _queryCore.MutationObserver)(client, options));
    _react.useEffect(()=>{
        observer.setOptions(options);
    }, [
        observer,
        options
    ]);
    const result = _react.useSyncExternalStore(_react.useCallback((onStoreChange)=>observer.subscribe((0, _queryCore.notifyManager).batchCalls(onStoreChange)), [
        observer
    ]), ()=>observer.getCurrentResult(), ()=>observer.getCurrentResult());
    const mutate = _react.useCallback((variables, mutateOptions)=>{
        observer.mutate(variables, mutateOptions).catch((0, _queryCore.noop));
    }, [
        observer
    ]);
    if (result.error && (0, _queryCore.shouldThrowError)(observer.options.throwOnError, [
        result.error
    ])) throw result.error;
    return (0, _objectSpreadProps._)((0, _objectSpread._)({}, result), {
        mutate,
        mutateAsync: result.mutate
    });
}

},{"@swc/helpers/_/_object_spread":"9gdrV","@swc/helpers/_/_object_spread_props":"kANqQ","react":"ltHCL","@tanstack/query-core":"6f4TB","./QueryClientProvider.js":"3ogTH","@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"dAFDt":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "useAsync", ()=>(0, _useAsync.useAsync));
parcelHelpers.export(exports, "queryClient", ()=>(0, _reactQueryClient.queryClient));
var _useAsync = require("./hooks/use-async");
var _reactQueryClient = require("./react-query-client");

},{"./hooks/use-async":"7IZza","./react-query-client":"5VYPJ","@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"7IZza":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "useAsync", ()=>useAsync);
var _react = require("react");
const useAsync = (asyncFunction)=>{
    const [state, setState] = (0, _react.useState)({
        state: 'loading',
        result: undefined,
        error: undefined
    });
    const executeAsyncFunc = (0, _react.useCallback)((isCurrent)=>{
        setState({
            state: 'loading',
            result: undefined,
            error: undefined
        });
        asyncFunction().then((result)=>{
            if (isCurrent.current) setState({
                state: 'success',
                result: result,
                error: undefined
            });
        }).catch((err)=>{
            if (isCurrent.current) setState({
                state: 'error',
                result: undefined,
                error: err
            });
        });
    }, [
        asyncFunction
    ]);
    (0, _react.useEffect)(()=>{
        const isCurrent = {
            current: true
        };
        executeAsyncFunc(isCurrent);
        return ()=>{
            isCurrent.current = false;
        };
    }, [
        executeAsyncFunc
    ]);
    return state;
};

},{"react":"ltHCL","@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"5VYPJ":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "queryClient", ()=>queryClient);
var _reactQuery = require("@tanstack/react-query");
const queryClient = new (0, _reactQuery.QueryClient)({
    defaultOptions: {
        mutations: {
            retry: 3
        }
    }
});

},{"@tanstack/react-query":"buDng","@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"5cVsH":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "AnalyticsProvider", ()=>(0, _analytics.AnalyticsProvider));
parcelHelpers.export(exports, "useAnalytics", ()=>(0, _analytics.useAnalytics));
parcelHelpers.export(exports, "AnalyticsContext", ()=>(0, _analytics.AnalyticsContext));
parcelHelpers.export(exports, "initAnalyticsClient", ()=>(0, _analytics.initAnalyticsClient));
parcelHelpers.export(exports, "Action", ()=>(0, _utils.Action));
parcelHelpers.export(exports, "getUIEventName", ()=>(0, _utils.getUIEventName));
parcelHelpers.export(exports, "getTrackEventName", ()=>(0, _utils.getTrackEventName));
parcelHelpers.export(exports, "UIActionSubject", ()=>(0, _utils.UIActionSubject));
parcelHelpers.export(exports, "initReactUFO", ()=>(0, _reactUfo.initReactUFO));
parcelHelpers.export(exports, "useReactUFORouteWatcher", ()=>(0, _reactUfo.useReactUFORouteWatcher));
parcelHelpers.export(exports, "SentryErrorBoundary", ()=>(0, _sentry.SentryErrorBoundary));
parcelHelpers.export(exports, "setupSentryClient", ()=>(0, _sentry.setupSentryClient));
parcelHelpers.export(exports, "logException", ()=>(0, _sentry.logException));
parcelHelpers.export(exports, "logMessage", ()=>(0, _sentry.logMessage));
parcelHelpers.export(exports, "PageSegment", ()=>(0, _pageSegment.PageSegment));
var _analytics = require("./analytics");
var _utils = require("./analytics/utils");
var _reactUfo = require("./react-ufo");
var _sentry = require("./sentry");
var _pageSegment = require("./page-segment");

},{"./analytics":"inXK3","./analytics/utils":"4YobW","./react-ufo":"3pYh1","./sentry":"22o7a","./page-segment":"hi1dr","@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"inXK3":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "AnalyticsProvider", ()=>(0, _analyticsContext.AnalyticsProvider));
parcelHelpers.export(exports, "useAnalytics", ()=>(0, _analyticsContext.useAnalytics));
parcelHelpers.export(exports, "AnalyticsContext", ()=>(0, _analyticsContext.AnalyticsContext));
parcelHelpers.export(exports, "initAnalyticsClient", ()=>(0, _utils.initAnalyticsClient));
var _analyticsContext = require("./analytics-context");
var _utils = require("./utils");

},{"./analytics-context":"h43NJ","./utils":"4YobW","@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"h43NJ":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "AnalyticsContext", ()=>AnalyticsContext);
parcelHelpers.export(exports, "AnalyticsProvider", ()=>AnalyticsProvider);
parcelHelpers.export(exports, "useAnalytics", ()=>useAnalytics);
var _objectSpread = require("@swc/helpers/_/_object_spread");
var _objectSpreadProps = require("@swc/helpers/_/_object_spread_props");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _analyticsListeners = require("@atlaskit/analytics-listeners");
var _analyticsListenersDefault = parcelHelpers.interopDefault(_analyticsListeners);
var _analyticsNext = require("@atlaskit/analytics-next");
var _analyticsBridge = require("@atlassian/analytics-bridge");
var _errorHandling = require("@atlassian/error-handling");
var _subscribers = require("../../reliability-tracker/subscribers");
const AnalyticsContext = /*#__PURE__*/ (0, _react.createContext)(null);
/**
 * An adapter layer to translate between "@atlaskit/analytics-listeners" and
 * "@atlassiansox/analytics-web-client" due to discrepancy between the defined types
 */ const useAtlasKitAnalytics = (analyticsWebClient, containerId)=>{
    return (0, _react.useMemo)(()=>{
        const containerContext = containerId !== undefined ? {
            containerType: 'spaceId',
            containerId
        } : {};
        return {
            sendUIEvent: (event)=>{
                return analyticsWebClient.sendUIEvent((0, _objectSpread._)((0, _objectSpreadProps._)((0, _objectSpread._)({}, event), {
                    action: event.action || '',
                    source: event.source || 'atlassian-studio'
                }), containerContext));
            },
            sendOperationalEvent: (event)=>{
                return analyticsWebClient.sendOperationalEvent((0, _objectSpread._)((0, _objectSpreadProps._)((0, _objectSpread._)({}, event), {
                    action: event.action || '',
                    source: event.source || 'atlassian-studio'
                }), containerContext));
            },
            sendTrackEvent: (event)=>{
                return analyticsWebClient.sendTrackEvent((0, _objectSpread._)((0, _objectSpreadProps._)((0, _objectSpread._)({}, event), {
                    action: event.action || '',
                    source: event.source || 'atlassian-studio'
                }), containerContext));
            },
            sendScreenEvent: (event)=>{
                return analyticsWebClient.sendScreenEvent(event);
            }
        };
    }, [
        analyticsWebClient,
        containerId
    ]);
};
const AnalyticsProvider = ({ children, analyticsClient })=>{
    const [containerId, setContainerId] = (0, _react.useState)(undefined);
    const [customAttributes, setCustomAttributes] = (0, _react.useState)({});
    const updateCustomAttributes = (0, _react.useCallback)((key, value)=>{
        setCustomAttributes((prevConfig)=>(0, _objectSpreadProps._)((0, _objectSpread._)({}, prevConfig), {
                [key]: value
            }));
    }, []);
    const sendEvent = (0, _react.useCallback)((event)=>{
        const { type, payload } = event;
        const payloadWithSource = (0, _objectSpread._)({
            source: 'atlassian-studio'
        }, payload);
        switch(type){
            case 0, _analyticsBridge.UI_EVENT_TYPE:
                analyticsClient.sendUIEvent(payloadWithSource);
                break;
            case 0, _analyticsBridge.TRACK_EVENT_TYPE:
                analyticsClient.sendTrackEvent(payloadWithSource);
                break;
            case 0, _analyticsBridge.OPERATIONAL_EVENT_TYPE:
                analyticsClient.sendOperationalEvent(payloadWithSource);
                break;
            case 0, _analyticsBridge.SCREEN_EVENT_TYPE:
                analyticsClient.sendScreenEvent(payload.name, null, payload.attributes);
                break;
            default:
                break;
        }
    }, [
        analyticsClient
    ]);
    (0, _react.useEffect)(()=>{
        (0, _errorHandling.initialiseErrorAnalyticsClient)({
            sendOperationalEvent: (event)=>{
                analyticsClient.sendOperationalEvent((0, _objectSpread._)({
                    action: event.action || 'unknown',
                    actionSubject: event.actionSubject || 'error',
                    source: event.source || 'atlassian-studio'
                }, event));
            }
        });
    }, [
        analyticsClient
    ]);
    return /*#__PURE__*/ (0, _reactDefault.default).createElement(AnalyticsContext.Provider, {
        value: {
            analyticsClient,
            containerId,
            customAttributes,
            setContainerId,
            updateCustomAttributes
        }
    }, /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _analyticsNext.AnalyticsListener), {
        channel: (0, _analyticsBridge.ANALYTICS_BRIDGE_CHANNEL),
        onEvent: (event)=>sendEvent((0, _analyticsBridge.extractAWCDataFromEvent)(event))
    }, /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _analyticsListenersDefault.default), {
        client: useAtlasKitAnalytics(analyticsClient, containerId)
    }, /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _subscribers.ReliabilityTrackerSubscribers), null), children)));
};
const useAnalytics = ()=>{
    const context = (0, _react.useContext)(AnalyticsContext);
    if (!context) throw new Error('useAnalytics must be used within an AnalyticsProvider');
    const { containerId, customAttributes, setContainerId, updateCustomAttributes, analyticsClient } = context;
    const { setTenantInfo, setUserInfo, sendTrackEvent } = analyticsClient;
    return {
        containerId,
        customAttributes,
        setContainerId,
        setTenantInfo,
        setUserInfo,
        updateCustomAttributes,
        sendTrackEvent
    };
};

},{"@swc/helpers/_/_object_spread":"9gdrV","@swc/helpers/_/_object_spread_props":"kANqQ","react":"ltHCL","@atlaskit/analytics-listeners":"3vsKM","@atlaskit/analytics-next":"6PLie","@atlassian/analytics-bridge":"6YOyH","@atlassian/error-handling":"4E7E5","../../reliability-tracker/subscribers":"d1gwZ","@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"3vsKM":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>(0, _fabricAnalyticsListenersDefault.default));
parcelHelpers.export(exports, "LOG_LEVEL", ()=>(0, _logger.LOG_LEVEL));
parcelHelpers.export(exports, "FabricChannel", ()=>(0, _types.FabricChannel));
var _fabricAnalyticsListeners = require("./FabricAnalyticsListeners");
var _fabricAnalyticsListenersDefault = parcelHelpers.interopDefault(_fabricAnalyticsListeners);
var _logger = require("./helpers/logger");
var _types = require("./types");

},{"./FabricAnalyticsListeners":"6qdFo","./helpers/logger":"dkJpA","./types":"gOewg","@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"6qdFo":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _types = require("./types");
var _fabricElementsListener = require("./fabric/FabricElementsListener");
var _fabricElementsListenerDefault = parcelHelpers.interopDefault(_fabricElementsListener);
var _atlaskitListener = require("./atlaskit/AtlaskitListener");
var _atlaskitListenerDefault = parcelHelpers.interopDefault(_atlaskitListener);
var _logger = require("./helpers/logger");
var _loggerDefault = parcelHelpers.interopDefault(_logger);
var _navigationListener = require("./navigation/NavigationListener");
var _navigationListenerDefault = parcelHelpers.interopDefault(_navigationListener);
var _fabricEditorListener = require("./fabric/FabricEditorListener");
var _fabricEditorListenerDefault = parcelHelpers.interopDefault(_fabricEditorListener);
var _mediaAnalyticsListener = require("./media/MediaAnalyticsListener");
var _mediaAnalyticsListenerDefault = parcelHelpers.interopDefault(_mediaAnalyticsListener);
var _peopleTeamsAnalyticsListener = require("./peopleTeams/PeopleTeamsAnalyticsListener");
var _peopleTeamsAnalyticsListenerDefault = parcelHelpers.interopDefault(_peopleTeamsAnalyticsListener);
var _notificationsAnalyticsListener = require("./notifications/NotificationsAnalyticsListener");
var _notificationsAnalyticsListenerDefault = parcelHelpers.interopDefault(_notificationsAnalyticsListener);
var _recentWorkAnalyticsListener = require("./recentWork/RecentWorkAnalyticsListener");
var _recentWorkAnalyticsListenerDefault = parcelHelpers.interopDefault(_recentWorkAnalyticsListener);
var _atlasAnalyticsListener = require("./atlas/AtlasAnalyticsListener");
var _atlasAnalyticsListenerDefault = parcelHelpers.interopDefault(_atlasAnalyticsListener);
var _crossFlowAnalyticsListener = require("./cross-flow/CrossFlowAnalyticsListener");
var _crossFlowAnalyticsListenerDefault = parcelHelpers.interopDefault(_crossFlowAnalyticsListener);
var _linkingPlatformAnalyticsListener = require("./linkingPlatform/LinkingPlatformAnalyticsListener");
var _linkingPlatformAnalyticsListenerDefault = parcelHelpers.interopDefault(_linkingPlatformAnalyticsListener);
var _postOfficeAnalyticsListener = require("./postOffice/PostOfficeAnalyticsListener");
var _postOfficeAnalyticsListenerDefault = parcelHelpers.interopDefault(_postOfficeAnalyticsListener);
var _aimateAnalyticsListener = require("./aiMate/AIMateAnalyticsListener");
var _aimateAnalyticsListenerDefault = parcelHelpers.interopDefault(_aimateAnalyticsListener);
var _avpanalyticsListener = require("./avp/AVPAnalyticsListener");
var _avpanalyticsListenerDefault = parcelHelpers.interopDefault(_avpanalyticsListener);
var _growthAnalyticsListener = require("./growth/GrowthAnalyticsListener");
var _growthAnalyticsListenerDefault = parcelHelpers.interopDefault(_growthAnalyticsListener);
var _omniChannelAnalyticsListener = require("./omni-channel/OmniChannelAnalyticsListener");
var _omniChannelAnalyticsListenerDefault = parcelHelpers.interopDefault(_omniChannelAnalyticsListener);
var _townsquareHomeAnalyticsListener = require("./townsquareHome/TownsquareHomeAnalyticsListener");
var _townsquareHomeAnalyticsListenerDefault = parcelHelpers.interopDefault(_townsquareHomeAnalyticsListener);
var _rovoExtensionAnalyticsListener = require("./rovoExtension/RovoExtensionAnalyticsListener");
var _rovoExtensionAnalyticsListenerDefault = parcelHelpers.interopDefault(_rovoExtensionAnalyticsListener);
var _teamworkGraphAnalyticsListener = require("./teamworkGraph/TeamworkGraphAnalyticsListener");
var _teamworkGraphAnalyticsListenerDefault = parcelHelpers.interopDefault(_teamworkGraphAnalyticsListener);
const listenerMap = {
    [(0, _types.FabricChannel).elements]: (0, _fabricElementsListenerDefault.default),
    [(0, _types.FabricChannel).editor]: (0, _fabricEditorListenerDefault.default),
    [(0, _types.FabricChannel).atlaskit]: (0, _atlaskitListenerDefault.default),
    [(0, _types.FabricChannel).navigation]: (0, _navigationListenerDefault.default),
    [(0, _types.FabricChannel).media]: (0, _mediaAnalyticsListenerDefault.default),
    [(0, _types.FabricChannel).peopleTeams]: (0, _peopleTeamsAnalyticsListenerDefault.default),
    [(0, _types.FabricChannel).notifications]: (0, _notificationsAnalyticsListenerDefault.default),
    [(0, _types.FabricChannel).recentWork]: (0, _recentWorkAnalyticsListenerDefault.default),
    [(0, _types.FabricChannel).atlas]: (0, _atlasAnalyticsListenerDefault.default),
    [(0, _types.FabricChannel).crossFlow]: (0, _crossFlowAnalyticsListenerDefault.default),
    [(0, _types.FabricChannel).linkingPlatform]: (0, _linkingPlatformAnalyticsListenerDefault.default),
    [(0, _types.FabricChannel).postOffice]: (0, _postOfficeAnalyticsListenerDefault.default),
    [(0, _types.FabricChannel).aiMate]: (0, _aimateAnalyticsListenerDefault.default),
    [(0, _types.FabricChannel).avp]: (0, _avpanalyticsListenerDefault.default),
    [(0, _types.FabricChannel).growth]: (0, _growthAnalyticsListenerDefault.default),
    [(0, _types.FabricChannel).omniChannel]: (0, _omniChannelAnalyticsListenerDefault.default),
    [(0, _types.FabricChannel).townsquareHome]: (0, _townsquareHomeAnalyticsListenerDefault.default),
    [(0, _types.FabricChannel).rovoExtension]: (0, _rovoExtensionAnalyticsListenerDefault.default),
    [(0, _types.FabricChannel).teamworkGraph]: (0, _teamworkGraphAnalyticsListenerDefault.default)
};
class FabricAnalyticsListeners extends (0, _reactDefault.default).Component {
    render() {
        const { client, children, logLevel, excludedChannels } = this.props;
        if (typeof logLevel === 'number') this.logger.setLogLevel(logLevel);
        const listeners = Object.keys(listenerMap).filter((channel)=>!excludedChannels || excludedChannels.indexOf(channel) < 0).map((channel)=>listenerMap[channel]).reduce((prev, Listener)=>/*#__PURE__*/ (0, _reactDefault.default).createElement(Listener, {
                client: client,
                logger: this.logger
            }, prev), children);
        return listeners;
    }
    constructor(props){
        super(props);
        this.logger = new (0, _loggerDefault.default)({
            logLevel: props.logLevel
        });
    }
}
exports.default = FabricAnalyticsListeners;

},{"react":"ltHCL","./types":"gOewg","./fabric/FabricElementsListener":"jlgoM","./atlaskit/AtlaskitListener":"4Mwip","./helpers/logger":"dkJpA","./navigation/NavigationListener":"is6vG","./fabric/FabricEditorListener":"fKHX1","./media/MediaAnalyticsListener":"3e53P","./peopleTeams/PeopleTeamsAnalyticsListener":"8PUzs","./notifications/NotificationsAnalyticsListener":"4ZFUp","./recentWork/RecentWorkAnalyticsListener":"jT30b","./atlas/AtlasAnalyticsListener":"58Y9q","./cross-flow/CrossFlowAnalyticsListener":"6BOHI","./linkingPlatform/LinkingPlatformAnalyticsListener":"k8Wal","./postOffice/PostOfficeAnalyticsListener":"l6pHV","./aiMate/AIMateAnalyticsListener":"kKTF9","./avp/AVPAnalyticsListener":"6zJGt","./growth/GrowthAnalyticsListener":"lJFg1","./omni-channel/OmniChannelAnalyticsListener":"4Y88d","./townsquareHome/TownsquareHomeAnalyticsListener":"Xe2ZT","./rovoExtension/RovoExtensionAnalyticsListener":"k1BBM","./teamworkGraph/TeamworkGraphAnalyticsListener":"8wZlU","@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"gOewg":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "FabricChannel", ()=>FabricChannel);
var FabricChannel = /*#__PURE__*/ function(FabricChannel) {
    FabricChannel["atlaskit"] = "atlaskit";
    FabricChannel["elements"] = "fabric-elements";
    FabricChannel["navigation"] = "navigation";
    FabricChannel["editor"] = "editor";
    FabricChannel["media"] = "media";
    FabricChannel["peopleTeams"] = "peopleTeams";
    FabricChannel["notifications"] = "notifications";
    FabricChannel["recentWork"] = "recentWork";
    FabricChannel["atlas"] = "atlas";
    FabricChannel["crossFlow"] = "crossFlow";
    FabricChannel["linkingPlatform"] = "linkingPlatform";
    FabricChannel["postOffice"] = "postOffice";
    FabricChannel["aiMate"] = "aiMate";
    FabricChannel["avp"] = "avp";
    FabricChannel["growth"] = "growth";
    FabricChannel["omniChannel"] = "omniChannel";
    FabricChannel["townsquareHome"] = "townsquareHome";
    FabricChannel["rovoExtension"] = "rovoExtension";
    FabricChannel["teamworkGraph"] = "teamworkGraph";
    return FabricChannel;
}({});

},{"@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"jlgoM":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "ELEMENTS_TAG", ()=>ELEMENTS_TAG);
parcelHelpers.export(exports, "default", ()=>FabricElementsListener);
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _analyticsNext = require("@atlaskit/analytics-next");
var _types = require("../types");
var _handleEvent = require("./handle-event");
const ELEMENTS_TAG = 'fabricElements';
class FabricElementsListener extends (0, _reactDefault.default).Component {
    render() {
        return /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _analyticsNext.AnalyticsListener), {
            onEvent: this.handleEventWrapper,
            channel: (0, _types.FabricChannel).elements
        }, this.props.children);
    }
    constructor(...args){
        super(...args), this.handleEventWrapper = (event)=>{
            (0, _handleEvent.handleEvent)(event, ELEMENTS_TAG, this.props.logger, this.props.client);
        };
    }
}

},{"react":"ltHCL","@atlaskit/analytics-next":"6PLie","../types":"gOewg","./handle-event":"be2wK","@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"6PLie":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
// Analytics event classes
parcelHelpers.export(exports, "AnalyticsEvent", ()=>(0, _analyticsEventDefault.default));
parcelHelpers.export(exports, "isAnalyticsEvent", ()=>(0, _isAnalyticsEvent.isAnalyticsEvent));
parcelHelpers.export(exports, "UIAnalyticsEvent", ()=>(0, _uianalyticsEventDefault.default));
parcelHelpers.export(exports, "isUIAnalyticsEvent", ()=>(0, _isUIAnalyticsEvent.isUIAnalyticsEvent));
// AnalyticsListener component
parcelHelpers.export(exports, "AnalyticsListener", ()=>(0, _indexDefault.default));
// AnalyticsContext component and HOC
parcelHelpers.export(exports, "AnalyticsContext", ()=>(0, _indexDefault1.default));
parcelHelpers.export(exports, "withAnalyticsContext", ()=>(0, _withAnalyticsContextDefault.default));
// AnalyticsErrorBoundary component
parcelHelpers.export(exports, "AnalyticsErrorBoundary", ()=>(0, _analyticsErrorBoundaryDefault.default));
// createAnalyticsEvent HOC
parcelHelpers.export(exports, "withAnalyticsEvents", ()=>(0, _withAnalyticsEventsDefault.default));
// React context
parcelHelpers.export(exports, "AnalyticsReactContext", ()=>(0, _analyticsReactContextDefault.default));
// Hook for creating and firing analytics events
parcelHelpers.export(exports, "useAnalyticsEvents", ()=>(0, _useAnalyticsEvents.useAnalyticsEvents));
parcelHelpers.export(exports, "useCallbackWithAnalytics", ()=>(0, _useCallbackWithAnalytics.useCallbackWithAnalytics));
parcelHelpers.export(exports, "usePlatformLeafEventHandler", ()=>(0, _usePlatformLeafEventHandler.usePlatformLeafEventHandler));
parcelHelpers.export(exports, "usePlatformLeafSyntheticEventHandler", ()=>(0, _usePlatformLeafSyntheticEventHandler.usePlatformLeafSyntheticEventHandler));
// Helper functions
parcelHelpers.export(exports, "createAndFireEvent", ()=>(0, _createAndFireEventDefault.default));
parcelHelpers.export(exports, "cleanProps", ()=>(0, _cleanPropsDefault.default));
// Moved from deprecated @atlaskit/analytics
parcelHelpers.export(exports, "AnalyticsDecorator", ()=>(0, _analyticsDecoratorDefault.default));
parcelHelpers.export(exports, "AnalyticsDelegate", ()=>(0, _analyticsDelegateDefault.default));
parcelHelpers.export(exports, "withAnalytics", ()=>(0, _withAnalyticsDefault.default));
var _analyticsEvent = require("./events/AnalyticsEvent");
var _analyticsEventDefault = parcelHelpers.interopDefault(_analyticsEvent);
var _isAnalyticsEvent = require("./events/isAnalyticsEvent");
var _uianalyticsEvent = require("./events/UIAnalyticsEvent");
var _uianalyticsEventDefault = parcelHelpers.interopDefault(_uianalyticsEvent);
var _isUIAnalyticsEvent = require("./events/isUIAnalyticsEvent");
var _index = require("./components/AnalyticsListener/index");
var _indexDefault = parcelHelpers.interopDefault(_index);
var _index1 = require("./components/AnalyticsContext/index");
var _indexDefault1 = parcelHelpers.interopDefault(_index1);
var _withAnalyticsContext = require("./hocs/withAnalyticsContext");
var _withAnalyticsContextDefault = parcelHelpers.interopDefault(_withAnalyticsContext);
var _analyticsErrorBoundary = require("./components/AnalyticsErrorBoundary");
var _analyticsErrorBoundaryDefault = parcelHelpers.interopDefault(_analyticsErrorBoundary);
var _withAnalyticsEvents = require("./hocs/withAnalyticsEvents");
var _withAnalyticsEventsDefault = parcelHelpers.interopDefault(_withAnalyticsEvents);
var _analyticsReactContext = require("./components/AnalyticsReactContext");
var _analyticsReactContextDefault = parcelHelpers.interopDefault(_analyticsReactContext);
var _useAnalyticsEvents = require("./hooks/useAnalyticsEvents");
var _useCallbackWithAnalytics = require("./hooks/useCallbackWithAnalytics");
var _usePlatformLeafEventHandler = require("./hooks/usePlatformLeafEventHandler");
var _usePlatformLeafSyntheticEventHandler = require("./hooks/usePlatformLeafSyntheticEventHandler");
var _createAndFireEvent = require("./utils/createAndFireEvent");
var _createAndFireEventDefault = parcelHelpers.interopDefault(_createAndFireEvent);
var _cleanProps = require("./utils/cleanProps");
var _cleanPropsDefault = parcelHelpers.interopDefault(_cleanProps);
var _analyticsDecorator = require("./components/AnalyticsDecorator");
var _analyticsDecoratorDefault = parcelHelpers.interopDefault(_analyticsDecorator);
var _analyticsDelegate = require("./components/AnalyticsDelegate");
var _analyticsDelegateDefault = parcelHelpers.interopDefault(_analyticsDelegate);
var _withAnalytics = require("./utils/withAnalytics");
var _withAnalyticsDefault = parcelHelpers.interopDefault(_withAnalytics);

},{"./events/AnalyticsEvent":"7FA8d","./events/isAnalyticsEvent":"fuDGn","./events/UIAnalyticsEvent":"7JnK9","./events/isUIAnalyticsEvent":"3B3KF","./components/AnalyticsListener/index":"4Z7Wf","./components/AnalyticsContext/index":"8oEda","./hocs/withAnalyticsContext":"e8JZV","./components/AnalyticsErrorBoundary":"dOaVz","./hocs/withAnalyticsEvents":"9EUp7","./components/AnalyticsReactContext":"8O6Tj","./hooks/useAnalyticsEvents":"4ovq2","./hooks/useCallbackWithAnalytics":"1hM7U","./hooks/usePlatformLeafEventHandler":"dRWFk","./hooks/usePlatformLeafSyntheticEventHandler":"cHtVJ","./utils/createAndFireEvent":"krugf","./utils/cleanProps":"Q7E8P","./components/AnalyticsDecorator":"axS2O","./components/AnalyticsDelegate":"8YgQf","./utils/withAnalytics":"8wY1m","@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"7FA8d":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "isAnalyticsEvent", ()=>(0, _isAnalyticsEvent.isAnalyticsEvent));
parcelHelpers.export(exports, "default", ()=>AnalyticsEvent);
var _objectSpread = require("@swc/helpers/_/_object_spread");
var _isAnalyticsEvent = require("./isAnalyticsEvent");
class AnalyticsEvent {
    update(updater) {
        if (typeof updater === 'function') this.payload = updater(this.payload);
        if (typeof updater === 'object') this.payload = (0, _objectSpread._)({}, this.payload, updater);
        return this;
    }
    constructor(props){
        this._isAnalyticsEvent = true;
        this.clone = ()=>{
            // just a shallow clone, don't change sub refs unless you want to
            // affect the original's too
            const payload = (0, _objectSpread._)({}, this.payload);
            return new AnalyticsEvent({
                payload
            });
        };
        this.payload = props.payload;
    }
}

},{"@swc/helpers/_/_object_spread":"9gdrV","./isAnalyticsEvent":false,"@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"fuDGn":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "isAnalyticsEvent", ()=>isAnalyticsEvent);
var _analyticsEvent = require("./AnalyticsEvent");
var _analyticsEventDefault = parcelHelpers.interopDefault(_analyticsEvent);
const isAnalyticsEvent = (obj)=>{
    var // Backwards compatibility with older analytics-next packages
    _obj_constructor;
    return obj instanceof (0, _analyticsEventDefault.default) || !!(obj === null || obj === void 0 ? void 0 : obj._isAnalyticsEvent) || (obj === null || obj === void 0 ? void 0 : (_obj_constructor = obj.constructor) === null || _obj_constructor === void 0 ? void 0 : _obj_constructor.name) === 'AnalyticsEvent';
};

},{"./AnalyticsEvent":"7FA8d","@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"7JnK9":[function(require,module,exports,__globalThis) {
/// <reference types="node" />
var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "isUIAnalyticsEvent", ()=>(0, _isUIAnalyticsEvent.isUIAnalyticsEvent));
parcelHelpers.export(exports, "default", ()=>UIAnalyticsEvent);
var _objectSpread = require("@swc/helpers/_/_object_spread");
var _platformFeatureFlags = require("@atlaskit/platform-feature-flags");
var _analyticsEvent = require("./AnalyticsEvent");
var _analyticsEventDefault = parcelHelpers.interopDefault(_analyticsEvent);
var _isUIAnalyticsEvent = require("./isUIAnalyticsEvent");
class UIAnalyticsEvent extends (0, _analyticsEventDefault.default) {
    update(updater) {
        if (this.hasFired) return this;
        return super.update(updater);
    }
    constructor(props){
        super(props), this._isUIAnalyticsEvent = true, this.clone = ()=>{
            if (this.hasFired) return null;
            const context = [
                ...this.context
            ];
            const handlers = [
                ...this.handlers
            ];
            const payload = clonePayload(this.payload);
            return new UIAnalyticsEvent({
                context,
                handlers,
                payload
            });
        }, this.fire = (channel)=>{
            if (this.hasFired) return;
            this.handlers.forEach((handler)=>{
                try {
                    handler(this, channel);
                } catch (e) {}
            });
            this.hasFired = true;
        };
        this.context = props.context || [];
        this.handlers = props.handlers || [];
        this.hasFired = false;
    }
}
const clonePayload = (payload)=>{
    if ((0, _platformFeatureFlags.fg)('platform-analytics-next-safe-clone')) try {
        return JSON.parse(JSON.stringify(payload));
    } catch (e) {
        // Shallow clone keeps the event usable without crashing the UI.
        return (0, _objectSpread._)({}, payload);
    }
    /**
	 * A hacky "deep clone" of the object. This is limited in that it wont
	 * support functions, regexs, Maps, Sets, etc, but none of those need to
	 * be represented in our payload.
	 */ return JSON.parse(JSON.stringify(payload));
};

},{"@swc/helpers/_/_object_spread":"9gdrV","@atlaskit/platform-feature-flags":"8rD2i","./AnalyticsEvent":"7FA8d","./isUIAnalyticsEvent":false,"@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"8rD2i":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "setBooleanFeatureFlagResolver", ()=>(0, _setBooleanFeatureFlagResolver.setBooleanFeatureFlagResolver));
parcelHelpers.export(exports, "getBooleanFF", ()=>(0, _getBooleanFF.getBooleanFF));
parcelHelpers.export(exports, "fg", ()=>(0, _fg.fg));
var _setBooleanFeatureFlagResolver = require("./setBooleanFeatureFlagResolver");
var _getBooleanFF = require("./getBooleanFF");
var _fg = require("./fg");

},{"./setBooleanFeatureFlagResolver":"gLlzC","./getBooleanFF":false,"./fg":"8rdjP","@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"gLlzC":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "setBooleanFeatureFlagResolver", ()=>setBooleanFeatureFlagResolver);
var _setBooleanResolver = require("./setBooleanResolver");
function setBooleanFeatureFlagResolver(flagResolver) {
    (0, _setBooleanResolver.setBooleanResolver)(flagResolver);
}

},{"./setBooleanResolver":"kOq4y","@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"kOq4y":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "setBooleanResolver", ()=>setBooleanResolver);
var _globalVar = require("./globalVar");
var _resolvers = require("./resolvers");
function setBooleanResolver(resolver) {
    (0, _globalVar.globalVar)[0, _resolvers.PFF_GLOBAL_KEY].booleanResolver = resolver;
}

},{"./globalVar":"bTwoH","./resolvers":"9iGdh","@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"bTwoH":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "globalVar", ()=>globalVar);
var _resolvers = require("./resolvers");
const DEFAULT_PFF_GLOBAL = {
    booleanResolver: undefined
};
const globalVar = typeof window !== 'undefined' ? window : globalThis;
globalVar[0, _resolvers.PFF_GLOBAL_KEY] = globalVar[0, _resolvers.PFF_GLOBAL_KEY] || DEFAULT_PFF_GLOBAL;

},{"./resolvers":"9iGdh","@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"9iGdh":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "PFF_GLOBAL_KEY", ()=>PFF_GLOBAL_KEY);
parcelHelpers.export(exports, "pkgName", ()=>pkgName);
parcelHelpers.export(exports, "hasProcessEnv", ()=>hasProcessEnv);
var process = require("a47abbf2a929fe2d");
const PFF_GLOBAL_KEY = '__PLATFORM_FEATURE_FLAGS__';
const pkgName = '@atlaskit/platform-feature-flags';
const hasProcessEnv = typeof process !== 'undefined' && typeof process.env !== 'undefined';

},{"a47abbf2a929fe2d":"gNLf3","@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"gNLf3":[function(require,module,exports,__globalThis) {
// shim for using process in browser
var process = module.exports = {};
// cached from whatever global is present so that test runners that stub it
// don't break things.  But we need to wrap it in a try catch in case it is
// wrapped in strict mode code which doesn't define any globals.  It's inside a
// function because try/catches deoptimize in certain engines.
var cachedSetTimeout;
var cachedClearTimeout;
function defaultSetTimout() {
    throw new Error('setTimeout has not been defined');
}
function defaultClearTimeout() {
    throw new Error('clearTimeout has not been defined');
}
(function() {
    try {
        if (typeof setTimeout === 'function') cachedSetTimeout = setTimeout;
        else cachedSetTimeout = defaultSetTimout;
    } catch (e) {
        cachedSetTimeout = defaultSetTimout;
    }
    try {
        if (typeof clearTimeout === 'function') cachedClearTimeout = clearTimeout;
        else cachedClearTimeout = defaultClearTimeout;
    } catch (e) {
        cachedClearTimeout = defaultClearTimeout;
    }
})();
function runTimeout(fun) {
    if (cachedSetTimeout === setTimeout) //normal enviroments in sane situations
    return setTimeout(fun, 0);
    // if setTimeout wasn't available but was latter defined
    if ((cachedSetTimeout === defaultSetTimout || !cachedSetTimeout) && setTimeout) {
        cachedSetTimeout = setTimeout;
        return setTimeout(fun, 0);
    }
    try {
        // when when somebody has screwed with setTimeout but no I.E. maddness
        return cachedSetTimeout(fun, 0);
    } catch (e) {
        try {
            // When we are in I.E. but the script has been evaled so I.E. doesn't trust the global object when called normally
            return cachedSetTimeout.call(null, fun, 0);
        } catch (e) {
            // same as above but when it's a version of I.E. that must have the global object for 'this', hopfully our context correct otherwise it will throw a global error
            return cachedSetTimeout.call(this, fun, 0);
        }
    }
}
function runClearTimeout(marker) {
    if (cachedClearTimeout === clearTimeout) //normal enviroments in sane situations
    return clearTimeout(marker);
    // if clearTimeout wasn't available but was latter defined
    if ((cachedClearTimeout === defaultClearTimeout || !cachedClearTimeout) && clearTimeout) {
        cachedClearTimeout = clearTimeout;
        return clearTimeout(marker);
    }
    try {
        // when when somebody has screwed with setTimeout but no I.E. maddness
        return cachedClearTimeout(marker);
    } catch (e) {
        try {
            // When we are in I.E. but the script has been evaled so I.E. doesn't  trust the global object when called normally
            return cachedClearTimeout.call(null, marker);
        } catch (e) {
            // same as above but when it's a version of I.E. that must have the global object for 'this', hopfully our context correct otherwise it will throw a global error.
            // Some versions of I.E. have different rules for clearTimeout vs setTimeout
            return cachedClearTimeout.call(this, marker);
        }
    }
}
var queue = [];
var draining = false;
var currentQueue;
var queueIndex = -1;
function cleanUpNextTick() {
    if (!draining || !currentQueue) return;
    draining = false;
    if (currentQueue.length) queue = currentQueue.concat(queue);
    else queueIndex = -1;
    if (queue.length) drainQueue();
}
function drainQueue() {
    if (draining) return;
    var timeout = runTimeout(cleanUpNextTick);
    draining = true;
    var len = queue.length;
    while(len){
        currentQueue = queue;
        queue = [];
        while(++queueIndex < len)if (currentQueue) currentQueue[queueIndex].run();
        queueIndex = -1;
        len = queue.length;
    }
    currentQueue = null;
    draining = false;
    runClearTimeout(timeout);
}
process.nextTick = function(fun) {
    var args = new Array(arguments.length - 1);
    if (arguments.length > 1) for(var i = 1; i < arguments.length; i++)args[i - 1] = arguments[i];
    queue.push(new Item(fun, args));
    if (queue.length === 1 && !draining) runTimeout(drainQueue);
};
// v8 likes predictible objects
function Item(fun, array) {
    this.fun = fun;
    this.array = array;
}
Item.prototype.run = function() {
    this.fun.apply(null, this.array);
};
process.title = 'browser';
process.browser = true;
process.env = {};
process.argv = [];
process.version = ''; // empty string to avoid regexp issues
process.versions = {};
function noop() {}
process.on = noop;
process.addListener = noop;
process.once = noop;
process.off = noop;
process.removeListener = noop;
process.removeAllListeners = noop;
process.emit = noop;
process.prependListener = noop;
process.prependOnceListener = noop;
process.listeners = function(name) {
    return [];
};
process.binding = function(name) {
    throw new Error('process.binding is not supported');
};
process.cwd = function() {
    return '/';
};
process.chdir = function(dir) {
    throw new Error('process.chdir is not supported');
};
process.umask = function() {
    return 0;
};

},{}],"8rdjP":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "fg", ()=>fg);
var _resolveBooleanFlag = require("./resolveBooleanFlag");
function fg(name) {
    return (0, _resolveBooleanFlag.resolveBooleanFlag)(name);
}

},{"./resolveBooleanFlag":"jByhM","@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"jByhM":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "resolveBooleanFlag", ()=>resolveBooleanFlag);
var _featureGateJsClient = require("@atlaskit/feature-gate-js-client");
var _featureGateJsClientDefault = parcelHelpers.interopDefault(_featureGateJsClient);
var _debug = require("./debug");
var _envEnablePlatformFf = require("./env-enable-platform-ff");
var _envStorybookEnablePlatformFf = require("./env-storybook-enable-platform-ff");
var _globalVar = require("./globalVar");
var _resolvers = require("./resolvers");
const ENABLE_GLOBAL_PLATFORM_FF_OVERRIDE = (0, _envEnablePlatformFf.ENV_ENABLE_PLATFORM_FF) || (0, _envStorybookEnablePlatformFf.ENV_STORYBOOK_ENABLE_PLATFORM_FF);
function resolveBooleanFlag(flagKey) {
    if (ENABLE_GLOBAL_PLATFORM_FF_OVERRIDE) {
        (0, _debug.debug)('[%s]: The feature flags were enabled while running tests. The flag "%s" will be always enabled.', (0, _resolvers.pkgName), flagKey);
        return true;
    }
    try {
        var _globalVar_PFF_GLOBAL_KEY, _globalVar_PFF_GLOBAL_KEY1, _globalVar_PFF_GLOBAL_KEY2;
        // booleanResolver will be empty for products like Trello, Elevate, Recruit etc.
        // Currently only Confluence, Jira and Bitbucket has set it.
        if (((_globalVar_PFF_GLOBAL_KEY = (0, _globalVar.globalVar)[0, _resolvers.PFF_GLOBAL_KEY]) === null || _globalVar_PFF_GLOBAL_KEY === void 0 ? void 0 : _globalVar_PFF_GLOBAL_KEY.booleanResolver) === undefined || ((_globalVar_PFF_GLOBAL_KEY1 = (0, _globalVar.globalVar)[0, _resolvers.PFF_GLOBAL_KEY]) === null || _globalVar_PFF_GLOBAL_KEY1 === void 0 ? void 0 : _globalVar_PFF_GLOBAL_KEY1.booleanResolver) === null) // eslint-disable-next-line @atlaskit/platform/use-recommended-utils
        return (0, _featureGateJsClientDefault.default).checkGate(flagKey);
        const result = (_globalVar_PFF_GLOBAL_KEY2 = (0, _globalVar.globalVar)[0, _resolvers.PFF_GLOBAL_KEY]) === null || _globalVar_PFF_GLOBAL_KEY2 === void 0 ? void 0 : _globalVar_PFF_GLOBAL_KEY2.booleanResolver(flagKey);
        if (typeof result !== 'boolean') {
            // eslint-disable-next-line no-console
            console.warn(`${flagKey} resolved to a non-boolean value, returning false for safety`);
            return false;
        }
        return result;
    } catch (e) {
        return false;
    }
}

},{"@atlaskit/feature-gate-js-client":"27dQF","./debug":"cTh9L","./env-enable-platform-ff":"fRE6U","./env-storybook-enable-platform-ff":"egZrf","./globalVar":"bTwoH","./resolvers":"9iGdh","@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"27dQF":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>(0, _featureGatesDefault.default));
parcelHelpers.export(exports, "FeatureGateEnvironment", ()=>(0, _featureGates.FeatureGateEnvironment));
parcelHelpers.export(exports, "PerimeterType", ()=>(0, _featureGates.PerimeterType));
parcelHelpers.export(exports, "CLIENT_VERSION", ()=>(0, _featureGates.CLIENT_VERSION));
parcelHelpers.export(exports, "DynamicConfig", ()=>(0, _dynamicConfig.DynamicConfig));
parcelHelpers.export(exports, "Layer", ()=>(0, _layer.Layer));
parcelHelpers.export(exports, "EvaluationReason", ()=>(0, _types.EvaluationReason));
var _featureGates = require("./client/FeatureGates");
var _featureGatesDefault = parcelHelpers.interopDefault(_featureGates);
var _dynamicConfig = require("./client/compat/DynamicConfig");
var _layer = require("./client/compat/Layer");
var _types = require("./client/compat/types");

},{"./client/FeatureGates":"hjokc","./client/compat/DynamicConfig":"2uTD7","./client/compat/Layer":"0mwae","./client/compat/types":"iiV2Y","@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"hjokc":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "EvaluationReason", ()=>(0, _types.EvaluationReason));
parcelHelpers.export(exports, "DynamicConfig", ()=>(0, _dynamicConfig.DynamicConfig));
parcelHelpers.export(exports, "FeatureGateEnvironment", ()=>(0, _types1.FeatureGateEnvironment));
parcelHelpers.export(exports, "PerimeterType", ()=>(0, _types1.PerimeterType));
parcelHelpers.export(exports, "CLIENT_VERSION", ()=>(0, _version.CLIENT_VERSION));
var _client = require("./Client");
var _version = require("./version");
var _types = require("./compat/types");
var _dynamicConfig = require("./compat/DynamicConfig");
var _types1 = require("./types");
/**
 * Access the FeatureGates object via the default export.
 * ```ts
 * import FeatureGates from '@atlaskit/feature-gate-js-client';
 * ```
 */ class FeatureGates {
    static isGateExists(gateName) {
        return this.client.isGateExist(gateName);
    }
    static isExperimentExists(experimentName) {
        return this.client.isExperimentExist(experimentName);
    }
}
FeatureGates.client = new (0, _client.Client)();
FeatureGates.hasCheckGateErrorOccurred = false;
FeatureGates.hasGetExperimentValueErrorOccurred = false;
FeatureGates.checkGate = (gateName, options)=>{
    try {
        // Check if the CRITERION override mechanism is available
        if (typeof window !== 'undefined' && window.__CRITERION__ && typeof window.__CRITERION__.getFeatureFlagOverride === 'function') {
            // Attempt to retrieve an override value for the feature gate
            const overrideValue = window.__CRITERION__.getFeatureFlagOverride(gateName);
            // If an override value is found, return it immediately
            if (overrideValue !== undefined) return overrideValue;
        }
    } catch (error) {
        // Log the first occurrence of the error
        if (!FeatureGates.hasCheckGateErrorOccurred) {
            // eslint-disable-next-line no-console
            console.warn({
                msg: 'An error has occurred checking the feature gate from criterion override. Only the first occurrence of this error is logged.',
                gateName,
                error
            });
            FeatureGates.hasCheckGateErrorOccurred = true;
        }
    }
    // Proceed with the main logic if no override is found
    return FeatureGates.client.checkGate(gateName, options);
};
FeatureGates.getExperimentValue = (experimentName, parameterName, defaultValue, options)=>{
    try {
        // Check if the CRITERION override mechanism is available
        if (typeof window !== 'undefined' && window.__CRITERION__ && typeof window.__CRITERION__.getExperimentValueOverride === 'function') {
            const overrideValue = window.__CRITERION__.getExperimentValueOverride(experimentName, parameterName);
            if (overrideValue !== undefined && overrideValue !== null) return overrideValue;
        }
    } catch (error) {
        // Log the first occurrence of the error
        if (!FeatureGates.hasGetExperimentValueErrorOccurred) {
            // eslint-disable-next-line no-console
            console.warn({
                msg: 'An error has occurred getting the experiment value from criterion override. Only the first occurrence of this error is logged.',
                experimentName,
                defaultValue,
                options,
                error
            });
            FeatureGates.hasGetExperimentValueErrorOccurred = true;
        }
        return defaultValue;
    }
    // Proceed with the main logic if no override is found
    return FeatureGates.client.getExperimentValue(experimentName, parameterName, defaultValue, options);
};
FeatureGates.initializeCalled = FeatureGates.client.initializeCalled.bind(FeatureGates.client);
FeatureGates.initializeCompleted = FeatureGates.client.initializeCompleted.bind(FeatureGates.client);
FeatureGates.waitUntilInitializeCompleted = FeatureGates.client.waitUntilInitializeCompleted.bind(FeatureGates.client);
FeatureGates.initialize = FeatureGates.client.initialize.bind(FeatureGates.client);
FeatureGates.initializeWithProvider = FeatureGates.client.initializeWithProvider.bind(FeatureGates.client);
FeatureGates.initializeFromValues = FeatureGates.client.initializeFromValues.bind(FeatureGates.client);
FeatureGates.manuallyLogGateExposure = FeatureGates.client.manuallyLogGateExposure.bind(FeatureGates.client);
FeatureGates.getExperiment = FeatureGates.client.getExperiment.bind(FeatureGates.client);
FeatureGates.manuallyLogExperimentExposure = FeatureGates.client.manuallyLogExperimentExposure.bind(FeatureGates.client);
FeatureGates.manuallyLogLayerExposure = FeatureGates.client.manuallyLogLayerExposure.bind(FeatureGates.client);
FeatureGates.shutdownStatsig = FeatureGates.client.shutdownStatsig.bind(FeatureGates.client);
FeatureGates.overrideGate = FeatureGates.client.overrideGate.bind(FeatureGates.client);
FeatureGates.clearGateOverride = FeatureGates.client.clearGateOverride.bind(FeatureGates.client);
FeatureGates.overrideConfig = FeatureGates.client.overrideConfig.bind(FeatureGates.client);
FeatureGates.clearConfigOverride = FeatureGates.client.clearConfigOverride.bind(FeatureGates.client);
FeatureGates.setOverrides = FeatureGates.client.setOverrides.bind(FeatureGates.client);
FeatureGates.getOverrides = FeatureGates.client.getOverrides.bind(FeatureGates.client);
FeatureGates.clearAllOverrides = FeatureGates.client.clearAllOverrides.bind(FeatureGates.client);
FeatureGates.isCurrentUser = FeatureGates.client.isCurrentUser.bind(FeatureGates.client);
FeatureGates.onGateUpdated = FeatureGates.client.onGateUpdated.bind(FeatureGates.client);
FeatureGates.onExperimentValueUpdated = FeatureGates.client.onExperimentValueUpdated.bind(FeatureGates.client);
FeatureGates.onAnyUpdated = FeatureGates.client.onAnyUpdated.bind(FeatureGates.client);
FeatureGates.updateUser = FeatureGates.client.updateUser.bind(FeatureGates.client);
FeatureGates.updateUserWithProvider = FeatureGates.client.updateUserWithProvider.bind(FeatureGates.client);
FeatureGates.updateUserWithValues = FeatureGates.client.updateUserWithValues.bind(FeatureGates.client);
FeatureGates.getPackageVersion = FeatureGates.client.getPackageVersion.bind(FeatureGates.client);
FeatureGates.getTargetApp = FeatureGates.client.getTargetApp.bind(FeatureGates.client);
FeatureGates.getLayer = FeatureGates.client.getLayer.bind(FeatureGates.client);
FeatureGates.getLayerValue = FeatureGates.client.getLayerValue.bind(FeatureGates.client);
let boundFGJS = FeatureGates;
// This makes it possible to get a reference to the FeatureGates client at runtime.
// This is important for overriding values in Cypress tests, as there needs to be a
// way to get the exact instance for a window in order to mock some of its methods.
if (typeof window !== 'undefined') {
    if (window.__FEATUREGATES_JS__ === undefined) window.__FEATUREGATES_JS__ = FeatureGates;
    else {
        var _boundFGJS_getPackageVersion;
        boundFGJS = window.__FEATUREGATES_JS__;
        const boundVersion = (boundFGJS === null || boundFGJS === void 0 ? void 0 : (_boundFGJS_getPackageVersion = boundFGJS.getPackageVersion) === null || _boundFGJS_getPackageVersion === void 0 ? void 0 : _boundFGJS_getPackageVersion.call(boundFGJS)) || '4.10.0 or earlier';
        if (boundVersion !== (0, _version.CLIENT_VERSION)) {
            const message = `Multiple versions of FeatureGateClients found on the current page.
      The currently bound version is ${boundVersion} when module version ${(0, _version.CLIENT_VERSION)} was loading.`;
            // eslint-disable-next-line no-console
            console.warn(message);
        }
    }
}
/**
 * @property {FeatureGates} FeatureGate default export
 */ exports.default = boundFGJS;

},{"./Client":"iDJzC","./version":"gevk9","./compat/types":false,"./compat/DynamicConfig":false,"./types":"hcjz7","@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"iDJzC":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "Client", ()=>Client);
var _objectSpread = require("@swc/helpers/_/_object_spread");
var _objectSpreadProps = require("@swc/helpers/_/_object_spread_props");
var _objectWithoutProperties = require("@swc/helpers/_/_object_without_properties");
var _jsClient = require("@statsig/js-client");
var _subscriptions = require("../subscriptions");
var _subscriptionsDefault = parcelHelpers.interopDefault(_subscriptions);
var _dynamicConfig = require("./compat/DynamicConfig");
var _layer = require("./compat/Layer");
var _types = require("./compat/types");
var _fetcher = require("./fetcher");
var _fetcherDefault = parcelHelpers.interopDefault(_fetcher);
var _noFetchDataAdapter = require("./NoFetchDataAdapter");
var _persistentOverrideAdapter = require("./PersistentOverrideAdapter");
var _types1 = require("./types");
var _utils = require("./utils");
var _version = require("./version");
const DEFAULT_CLIENT_KEY = 'client-default-key';
// default event logging api is Atlassian proxy rather than Statsig's domain, to avoid ad blockers
const DEFAULT_EVENT_LOGGING_API = 'https://xp.atlassian.com/v1/rgstr';
class Client {
    /**
	 * @description
	 * This method initializes the client using a network call to fetch the bootstrap values.
	 * If the client is inialized with an `analyticsWebClient`, it will send an operational event
	 * to GASv3 with the following attributes:
	 * - targetApp: the target app of the client
	 * - clientVersion: the version of the client
	 * - success: whether the initialization was successful
	 * - startTime: the time when the initialization started
	 * - totalTime: the total time it took to initialize the client
	 * - apiKey: the api key used to initialize the client
	 * @param clientOptions {ClientOptions}
	 * @param identifiers {Identifiers}
	 * @param customAttributes {CustomAttributes}
	 * @returns {Promise<void>}
	 */ async initialize(clientOptions, identifiers, customAttributes) {
        const clientOptionsWithDefaults = (0, _utils.getOptionsWithDefaults)(clientOptions);
        if (this.initPromise) {
            if (!(0, _utils.shallowEquals)(clientOptionsWithDefaults, this.initOptions)) // eslint-disable-next-line no-console
            console.warn('Feature Gates client already initialized with different options. New options were not applied.');
            return this.initPromise;
        }
        const startTime = performance.now();
        this.initOptions = clientOptionsWithDefaults;
        this.initPromise = this.init(clientOptionsWithDefaults, identifiers, customAttributes).then(()=>{
            this.initCompleted = true;
            this.initWithDefaults = true;
        }).finally(()=>{
            const endTime = performance.now();
            const totalTime = endTime - startTime;
            this.fireClientEvent(startTime, totalTime, 'initialize', this.initCompleted, clientOptionsWithDefaults.apiKey);
        });
        return this.initPromise;
    }
    /**
	 * @description
	 * This method initializes the client using the provider given to call to fetch the bootstrap values.
	 * If the client is initialized with an `analyticsWebClient`, it will send an operational event
	 * to GASv3 with the following attributes:
	 * - targetApp: the target app of the client
	 * - clientVersion: the version of the client
	 * - success: whether the initialization was successful
	 * - startTime: the time when the initialization started
	 * - totalTime: the total time it took to initialize the client
	 * - apiKey: the api key used to initialize the client
	 * @param clientOptions {ClientOptions}
	 * @param provider {Provider}
	 * @param identifiers {Identifiers}
	 * @param customAttributes {CustomAttributes}
	 * @returns {Promise<void>}
	 */ async initializeWithProvider(clientOptions, provider, identifiers, customAttributes) {
        const clientOptionsWithDefaults = (0, _utils.getOptionsWithDefaults)(clientOptions);
        if (this.initPromise) {
            if (!(0, _utils.shallowEquals)(clientOptionsWithDefaults, this.initOptions)) // eslint-disable-next-line no-console
            console.warn('Feature Gates client already initialized with different options. New options were not applied.');
            return this.initPromise;
        }
        const startTime = performance.now();
        this.initOptions = clientOptionsWithDefaults;
        this.provider = provider;
        this.provider.setClientVersion((0, _version.CLIENT_VERSION));
        if (this.provider.setApplyUpdateCallback) this.provider.setApplyUpdateCallback(this.applyUpdateCallback.bind(this));
        this.initPromise = this.initWithProvider(clientOptionsWithDefaults, provider, identifiers, customAttributes).then(()=>{
            this.initCompleted = true;
            this.initWithDefaults = true;
        }).finally(()=>{
            const endTime = performance.now();
            const totalTime = endTime - startTime;
            this.fireClientEvent(startTime, totalTime, 'initializeWithProvider', this.initCompleted, provider.getApiKey ? provider.getApiKey() : undefined);
        });
        return this.initPromise;
    }
    applyUpdateCallback(experimentsResult) {
        try {
            if (this.initCompleted || this.initWithDefaults) {
                this.assertInitialized(this.statsigClient);
                this.dataAdapter.setBootstrapData(experimentsResult.experimentValues);
                this.dataAdapter.setData(JSON.stringify(experimentsResult.experimentValues));
                this.statsigValuesUpdated();
            }
        } catch (error) {
            // eslint-disable-next-line no-console
            console.warn('Error when attempting to apply update', error);
        }
    }
    fireClientEvent(startTime, totalTime, action, success, apiKey) {
        var _this_initOptions_analyticsWebClient;
        (_this_initOptions_analyticsWebClient = this.initOptions.analyticsWebClient) === null || _this_initOptions_analyticsWebClient === void 0 ? void 0 : _this_initOptions_analyticsWebClient.then((analyticsWebClient)=>{
            const attributes = (0, _objectSpread._)({
                targetApp: this.initOptions.targetApp,
                clientVersion: (0, _version.CLIENT_VERSION),
                success,
                startTime,
                totalTime
            }, apiKey && {
                apiKey
            });
            analyticsWebClient.sendOperationalEvent({
                action,
                actionSubject: 'featureGatesClient',
                attributes,
                tags: [
                    'measurement'
                ],
                source: '@atlaskit/feature-gate-js-client'
            });
        }).catch((err)=>{
            if (this.initOptions.environment !== (0, _types1.FeatureGateEnvironment).Production) // eslint-disable-next-line no-console
            console.error('Analytics web client promise did not resolve', err);
        });
    }
    async initializeFromValues(clientOptions, identifiers, customAttributes, initializeValues = {}) {
        const clientOptionsWithDefaults = (0, _utils.getOptionsWithDefaults)(clientOptions);
        if (this.initPromise) {
            if (!(0, _utils.shallowEquals)(clientOptionsWithDefaults, this.initOptions)) // eslint-disable-next-line no-console
            console.warn('Feature Gates client already initialized with different options. New options were not applied.');
            return this.initPromise;
        }
        // This makes sure the new Statsig client behaves like the old when bootstrap data is
        // passed, and `has_updates` isn't specified (which happens a lot in product integration tests).
        if (!Object.prototype.hasOwnProperty.call(initializeValues, 'has_updates')) initializeValues['has_updates'] = true;
        const startTime = performance.now();
        this.initOptions = clientOptionsWithDefaults;
        this.initPromise = this.initFromValues(clientOptionsWithDefaults, identifiers, customAttributes, initializeValues).then(()=>{
            this.initCompleted = true;
            this.initWithDefaults = true;
        }).finally(()=>{
            const endTime = performance.now();
            const totalTime = endTime - startTime;
            this.fireClientEvent(startTime, totalTime, 'initializeFromValues', this.initCompleted);
        });
        return this.initPromise;
    }
    assertInitialized(statsigClient) {
        if (!statsigClient) throw new Error('Client must be initialized before using this method');
    }
    /**
	 * This method updates the user using a network call to fetch the new set of values.
	 * @param fetchOptions {FetcherOptions}
	 * @param identifiers {Identifiers}
	 * @param customAttributes {CustomAttributes}
	 */ async updateUser(fetchOptions, identifiers, customAttributes) {
        this.assertInitialized(this.statsigClient);
        const fetchOptionsWithDefaults = (0, _utils.getOptionsWithDefaults)(fetchOptions);
        const initializeValuesProducer = ()=>(0, _fetcherDefault.default).fetchExperimentValues(fetchOptionsWithDefaults, identifiers, customAttributes).then(({ experimentValues, customAttributes })=>({
                    experimentValues,
                    customAttributesFromFetch: customAttributes
                }));
        await this.updateUserUsingInitializeValuesProducer(initializeValuesProducer, identifiers, customAttributes);
    }
    /**
	 * This method updates the user using the provider given on initialisation to get the new set of
	 * values.
	 * @param identifiers {Identifiers}
	 * @param customAttributes {CustomAttributes}
	 */ async updateUserWithProvider(identifiers, customAttributes) {
        this.assertInitialized(this.statsigClient);
        if (!this.provider) throw new Error('Cannot update user using provider as the client was not initialised with a provider');
        await this.provider.setProfile(this.initOptions, identifiers, customAttributes);
        await this.updateUserUsingInitializeValuesProducer(()=>this.provider.getExperimentValues(), identifiers, customAttributes);
    }
    /**
	 * This method updates the user given a new set of bootstrap values obtained from one of the
	 * server-side SDKs.
	 *
	 * @param identifiers {Identifiers}
	 * @param customAttributes {CustomAttributes}
	 * @param initializeValues {Record<string,unknown>}
	 */ async updateUserWithValues(identifiers, customAttributes, initializeValues = {}) {
        this.assertInitialized(this.statsigClient);
        const initializeValuesProducer = ()=>Promise.resolve({
                experimentValues: initializeValues,
                customAttributesFromFetch: customAttributes
            });
        await this.updateUserUsingInitializeValuesProducer(initializeValuesProducer, identifiers, customAttributes);
    }
    initializeCalled() {
        return this.initPromise != null;
    }
    initializeCompleted() {
        return this.initCompleted;
    }
    async waitUntilInitializeCompleted() {
        if (!this.initPromise) throw new Error('The client must be initialized before you can wait until initialized.');
        if (this.initCompleted) return;
        await this.initPromise;
    }
    /**
	 * Returns the value for a feature gate. Returns false if there are errors.
	 * @param {string} gateName - The name of the feature gate.
	 * @param {Object} options
	 * @param {boolean} options.fireGateExposure
	 *        Whether or not to fire the exposure event for the gate. Defaults to true.
	 *        To log an exposure event manually at a later time, use {@link Client.manuallyLogGateExposure}
	 *        (see [Statsig docs about manually logging exposures](https://docs.statsig.com/client/jsClientSDK#manual-exposures-)).
	 */ checkGate(gateName, options = {}) {
        try {
            this.assertInitialized(this.statsigClient);
            const { fireGateExposure = true } = options;
            return this.statsigClient.checkGate(gateName, {
                disableExposureLog: !fireGateExposure
            });
        } catch (error) {
            // Log the first occurrence of the error
            if (!this.hasCheckGateErrorOccurred) {
                // eslint-disable-next-line no-console
                console.warn({
                    msg: 'An error has occurred checking the feature gate. Only the first occurrence of this error is logged.',
                    gateName,
                    error
                });
                this.hasCheckGateErrorOccurred = true;
            }
            return false;
        }
    }
    isGateExist(gateName) {
        try {
            this.assertInitialized(this.statsigClient);
            const gate = this.statsigClient.getFeatureGate(gateName, {
                disableExposureLog: true
            });
            return !gate.details.reason.includes('Unrecognized');
        } catch (error) {
            // eslint-disable-next-line no-console
            console.error(`Error occurred when trying to check FeatureGate: ${error}`);
            // in case of error report true to avoid false positives.
            return true;
        }
    }
    isExperimentExist(experimentName) {
        try {
            this.assertInitialized(this.statsigClient);
            const config = this.statsigClient.getExperiment(experimentName, {
                disableExposureLog: true
            });
            return !config.details.reason.includes('Unrecognized');
        } catch (error) {
            // eslint-disable-next-line no-console
            console.error(`Error occurred when trying to check Experiment: ${error}`);
            // in case of error report true to avoid false positives.
            return true;
        }
    }
    /**
	 * Manually log a gate exposure (see [Statsig docs about manually logging exposures](https://docs.statsig.com/client/jsClientSDK#manual-exposures-)).
	 * This is useful if you have evaluated a gate earlier via {@link Client.checkGate} where
	 * <code>options.fireGateExposure</code> is false.
	 * @param gateName
	 */ manuallyLogGateExposure(gateName) {
        this.assertInitialized(this.statsigClient);
        // This is the approach recommended in the docs
        // https://docs.statsig.com/client/javascript-sdk/#manual-exposures-
        this.statsigClient.checkGate(gateName);
    }
    /**
	 * Returns the entire config for a given experiment.
	 *
	 * @param {string} experimentName - The name of the experiment
	 * @param {Object} options
	 * @param {boolean} options.fireExperimentExposure - Whether or not to fire the exposure event
	 * for the experiment. Defaults to true. To log an exposure event manually at a later time, use
	 * {@link Client.manuallyLogExperimentExposure} (see [Statsig docs about manually logging exposures](https://docs.statsig.com/client/jsClientSDK#manual-exposures-)).
	 * @returns The config for an experiment
	 * @example
	 * ```ts
	 * const experimentConfig = client.getExperiment('example-experiment-name');
	 * const backgroundColor: string = experimentConfig.get('backgroundColor', 'yellow');
	 * ```
	 */ getExperiment(experimentName, options = {}) {
        try {
            this.assertInitialized(this.statsigClient);
            const { fireExperimentExposure = true } = options;
            return (0, _dynamicConfig.DynamicConfig).fromExperiment(this.statsigClient.getExperiment(experimentName, {
                disableExposureLog: !fireExperimentExposure
            }));
        } catch (error) {
            // Log the first occurrence of the error
            if (!this.hasGetExperimentErrorOccurred) {
                // eslint-disable-next-line no-console
                console.warn({
                    msg: 'An error has occurred getting the experiment. Only the first occurrence of this error is logged.',
                    experimentName,
                    error
                });
                this.hasGetExperimentErrorOccurred = true;
            }
            // Return a default value
            return new (0, _dynamicConfig.DynamicConfig)(experimentName, {}, '', {
                time: Date.now(),
                reason: (0, _types.EvaluationReason).Error
            });
        }
    }
    /**
	 * Returns the value of a given parameter in an experiment config.
	 *
	 * @template T
	 * @param {string} experimentName - The name of the experiment
	 * @param {string} parameterName - The name of the parameter to fetch from the experiment config
	 * @param {T} defaultValue - The value to serve if the experiment or parameter do not exist, or
	 * if the returned value does not match the expected type.
	 * @param {Object} options
	 * @param {boolean} options.fireExperimentExposure - Whether or not to fire the exposure event
	 * for the experiment. Defaults to true. To log an exposure event manually at a later time, use
	 * {@link Client.manuallyLogExperimentExposure} (see [Statsig docs about manually logging exposures](https://docs.statsig.com/client/jsClientSDK#manual-exposures-))
	 * @param {function} options.typeGuard - A function that asserts that the return value has the
	 * expected type. If this function returns false, then the default value will be returned
	 * instead. This can be set to protect your code from unexpected values being set remotely. By
	 * default, this will be done by asserting that the default value and value are the same primitive
	 * type.
	 * @returns The value of the parameter if the experiment and parameter both exist, otherwise the
	 * default value.
	 * @example
	 ``` ts
	 type ValidColor = 'blue' | 'red' | 'yellow';
	 type ValidColorTypeCheck = (value: unknown) => value is ValidColor;

	 const isValidColor: ValidColorTypeCheck =
			(value: unknown) => typeof value === 'string' && ['blue', 'red', 'yellow'].includes(value);

	 const buttonColor: ValidColor = client.getExperimentValue(
			'example-experiment-name',
			'backgroundColor',
			'yellow',
			{
					typeGuard: isValidColor
			}
	 );
	 ```
	*/ getExperimentValue(experimentName, parameterName, defaultValue, options = {}) {
        const experiment = this.getExperiment(experimentName, options);
        try {
            const { typeGuard } = options;
            return experiment.get(parameterName, defaultValue, typeGuard);
        } catch (error) {
            // Log the first occurrence of the error
            if (!this.hasGetExperimentValueErrorOccurred) {
                // eslint-disable-next-line no-console
                console.warn({
                    msg: 'An error has occurred getting the experiment value. Only the first occurrence of this error is logged.',
                    experimentName,
                    defaultValue,
                    options,
                    error
                });
                this.hasGetExperimentValueErrorOccurred = true;
            }
            return defaultValue;
        }
    }
    /**
	 * Manually log an experiment exposure (see [Statsig docs about manually logging exposures](https://docs.statsig.com/client/jsClientSDK#manual-exposures-)).
	 * This is useful if you have evaluated an experiment earlier via {@link Client.getExperimentValue} or
	 * {@link Client.getExperiment} where <code>options.fireExperimentExposure</code> is false.
	 * @param experimentName
	 */ manuallyLogExperimentExposure(experimentName) {
        this.assertInitialized(this.statsigClient);
        // This is the approach recommended in the docs
        // https://docs.statsig.com/client/javascript-sdk/#manual-exposures-
        this.statsigClient.getExperiment(experimentName);
    }
    /**
	 * Manually log a layer exposure (see [Statsig docs about manually logging exposures](https://docs.statsig.com/client/jsClientSDK#manual-exposures-)).
	 * This is useful if you have evaluated a layer earlier via {@link Client.getLayerValue} where <code>options.fireExperimentExposure</code> is false.
	 * @param layerName
	 * @param parameterName
	 */ manuallyLogLayerExposure(layerName, parameterName) {
        var // This is the approach recommended in the docs
        // https://docs.statsig.com/client/javascript-sdk/#manual-exposures-
        _this_statsigClient_getLayer;
        this.assertInitialized(this.statsigClient);
        (_this_statsigClient_getLayer = this.statsigClient.getLayer(layerName)) === null || _this_statsigClient_getLayer === void 0 ? void 0 : _this_statsigClient_getLayer.get(parameterName);
    }
    shutdownStatsig() {
        this.assertInitialized(this.statsigClient);
        this.statsigClient.shutdown();
    }
    /**
	 * Adds a new override for the given gate.
	 *
	 * This method is additive, meaning you can call it multiple times with different gate names to
	 * build your full set of overrides.
	 *
	 * Overrides are persisted to the `STATSIG_OVERRIDES` key in localStorage, so they
	 * will continue to affect every client that is initialized on the same domain after this method
	 * is called. If you are using this API for testing purposes, you should call
	 * {@link Client.clearGateOverride} after your tests are completed to remove this
	 * localStorage entry.
	 *
	 * @param {string} gateName
	 * @param {boolean} value
	 */ overrideGate(gateName, value) {
        var _this_statsigClient;
        this.overrideAdapter.overrideGate(gateName, value);
        // Trigger a reset of the memoized gate value
        if (this.user) (_this_statsigClient = this.statsigClient) === null || _this_statsigClient === void 0 ? void 0 : _this_statsigClient.updateUserSync(this.user, {
            disableBackgroundCacheRefresh: true
        });
        this.statsigValuesUpdated();
    }
    /**
	 * Removes any overrides that have been set for the given gate.
	 */ clearGateOverride(gateName) {
        this.overrideAdapter.removeGateOverride(gateName);
        this.statsigValuesUpdated();
    }
    /**
	 * Adds a new override for the given config (or experiment).
	 *
	 * This method is additive, meaning you can call it multiple times with different experiment
	 * names to build your full set of overrides.
	 *
	 * Overrides are persisted to the `STATSIG_OVERRIDES` key in localStorage, so they
	 * will continue to affect every client that is initialized on the same domain after this method
	 * is called. If you are using this API for testing purposes, you should call
	 * {@link Client.clearConfigOverride} after your tests are completed to remove this
	 * localStorage entry.
	 *
	 * @param {string} experimentName
	 * @param {object} values
	 */ overrideConfig(experimentName, values) {
        this.overrideAdapter.overrideDynamicConfig(experimentName, values);
        this.statsigValuesUpdated();
    }
    /**
	 * Removes any overrides that have been set for the given experiment.
	 * @param {string} experimentName
	 */ clearConfigOverride(experimentName) {
        this.overrideAdapter.removeDynamicConfigOverride(experimentName);
        this.statsigValuesUpdated();
    }
    /**
	 * Set overrides for gates, experiments and layers in batch.
	 *
	 * Note that these overrides are **not** additive and will completely replace any that have been
	 * added via prior calls to {@link Client.overrideConfig} or
	 * {@link Client.overrideGate}.
	 *
	 * Overrides are persisted to the `STATSIG_OVERRIDES` key in localStorage, so they
	 * will continue to affect every client that is initialized on the same domain after this method
	 * is called. If you are using this API for testing purposes, you should call
	 * {@link Client.clearAllOverrides} after your tests are completed to remove this
	 * localStorage entry.
	 */ setOverrides(overrides) {
        this.overrideAdapter.setOverrides(overrides);
        this.statsigValuesUpdated();
    }
    /**
	 * @returns The current overrides for gates, configs (including experiments) and layers.
	 */ getOverrides() {
        return this.overrideAdapter.getOverrides();
    }
    /**
	 * Clears overrides for all gates, configs (including experiments) and layers.
	 */ clearAllOverrides() {
        this.overrideAdapter.removeAllOverrides();
        this.statsigValuesUpdated();
    }
    /**
	 * Returns whether the given identifiers and customAttributes align with the current
	 * set that is being used by the client.
	 *
	 * If this method returns false, then the {@link Client.updateUser},
	 * {@link Client.updateUserWithValues} or {@link Client.updateUserWithProvider}
	 * methods can be used to re-align these values.
	 *
	 * @param identifiers
	 * @param customAttributes
	 * @returns a flag indicating whether the clients current configuration aligns with the given values
	 */ isCurrentUser(identifiers, customAttributes) {
        return (0, _utils.shallowEquals)(this.currentIdentifiers, identifiers) && (0, _utils.shallowEquals)(this.currentAttributes, customAttributes);
    }
    /**
	 * Subscribe to updates where the given callback will be called with the current checkGate value
	 * @param gateName
	 * @param callback
	 * @param options
	 * @returns off function to unsubscribe from updates
	 */ onGateUpdated(gateName, callback, options = {}) {
        const wrapCallback = (value)=>{
            const { fireGateExposure = true } = options;
            if (fireGateExposure) this.manuallyLogGateExposure(gateName);
            try {
                callback(value);
            } catch (error) {
                // eslint-disable-next-line no-console
                console.warn(`Error calling callback for gate ${gateName} with value ${value}`, error);
            }
        };
        return this.subscriptions.onGateUpdated(gateName, wrapCallback, this.checkGate.bind(this), options);
    }
    /**
	 * Subscribe to updates where the given callback will be called with the current experiment value
	 * @param experimentName
	 * @param parameterName
	 * @param defaultValue
	 * @param callback
	 * @param options
	 * @returns off function to unsubscribe from updates
	 */ onExperimentValueUpdated(experimentName, parameterName, defaultValue, callback, options = {}) {
        const wrapCallback = (value)=>{
            const { fireExperimentExposure = true } = options;
            if (fireExperimentExposure) this.manuallyLogExperimentExposure(experimentName);
            try {
                callback(value);
            } catch (error) {
                // eslint-disable-next-line no-console
                console.warn(`Error calling callback for experiment ${experimentName} with value ${value}`, error);
            }
        };
        return this.subscriptions.onExperimentValueUpdated(experimentName, parameterName, defaultValue, wrapCallback, this.getExperimentValue.bind(this), options);
    }
    /**
	 * Subscribe so on any update the callback will be called.
	 * NOTE: The callback will be called whenever the values are updated even if the values have not
	 * changed.
	 * @param callback
	 * @returns off function to unsubscribe from updates
	 */ onAnyUpdated(callback) {
        return this.subscriptions.onAnyUpdated(callback);
    }
    /**
	 * This method initializes the client using a network call to fetch the bootstrap values for the
	 * given user.
	 *
	 * @param clientOptions
	 * @param identifiers
	 * @param customAttributes
	 * @private
	 */ async init(clientOptions, identifiers, customAttributes) {
        const fromValuesClientOptions = (0, _objectSpread._)({}, clientOptions);
        if (clientOptions.localMode) {
            await this.initFromValues(fromValuesClientOptions, identifiers, customAttributes);
            return;
        }
        let experimentValues;
        let customAttributesFromResult;
        try {
            // If client sdk key fetch fails, an error would be thrown and handled instead of waiting for
            // the experiment values request to be settled, and it will fall back to use default values.
            const clientSdkKeyPromise = (0, _fetcherDefault.default).fetchClientSdk(clientOptions).then((value)=>fromValuesClientOptions.sdkKey = value.clientSdkKey);
            const experimentValuesPromise = (0, _fetcherDefault.default).fetchExperimentValues(clientOptions, identifiers, customAttributes);
            // Only wait for the experiment values request to finish and try to initialise the client
            // with experiment values if both requests are successful. Else an error would be thrown and
            // handled by the catch
            const [, experimentValuesResult] = await Promise.all([
                clientSdkKeyPromise,
                experimentValuesPromise
            ]);
            experimentValues = experimentValuesResult.experimentValues;
            customAttributesFromResult = experimentValuesResult.customAttributes;
        } catch (error) {
            if (error instanceof Error) // eslint-disable-next-line no-console
            console.error(`Error occurred when trying to fetch the Feature Gates client values, error: ${error === null || error === void 0 ? void 0 : error.message}`);
            // eslint-disable-next-line no-console
            console.warn(`Initialising Statsig client without values`);
            await this.initFromValues(fromValuesClientOptions, identifiers, customAttributes);
            throw error;
        }
        return this.initFromValues(fromValuesClientOptions, identifiers, customAttributesFromResult, experimentValues);
    }
    async initWithProvider(baseClientOptions, provider, identifiers, customAttributes) {
        const fromValuesClientOptions = (0, _objectSpreadProps._)((0, _objectSpread._)({}, baseClientOptions), {
            disableCurrentPageLogging: true
        });
        let experimentValues;
        let customAttributesFromResult;
        try {
            await provider.setProfile(baseClientOptions, identifiers, customAttributes);
            // If client sdk key fetch fails, an error would be thrown and handled instead of waiting for
            // the experiment values request to be settled, and it will fall back to use default values.
            const clientSdkKeyPromise = provider.getClientSdkKey().then((value)=>fromValuesClientOptions.sdkKey = value);
            const experimentValuesPromise = provider.getExperimentValues();
            // Only wait for the experiment values request to finish and try to initialise the client
            // with experiment values if both requests are successful. Else an error would be thrown and
            // handled by the catch
            const [, experimentValuesResult] = await Promise.all([
                clientSdkKeyPromise,
                experimentValuesPromise
            ]);
            experimentValues = experimentValuesResult.experimentValues;
            customAttributesFromResult = experimentValuesResult.customAttributesFromFetch;
        } catch (error) {
            if (error instanceof Error) // eslint-disable-next-line no-console
            console.error(`Error occurred when trying to fetch the Feature Gates client values, error: ${error === null || error === void 0 ? void 0 : error.message}`);
            // eslint-disable-next-line no-console
            console.warn(`Initialising Statsig client without values`);
            await this.initFromValues(fromValuesClientOptions, identifiers, customAttributes);
            throw error;
        }
        return this.initFromValues(fromValuesClientOptions, identifiers, customAttributesFromResult, experimentValues);
    }
    /**
	 * This method initializes the client using a set of boostrap values obtained from one of the
	 * server-side SDKs.
	 *
	 * @param clientOptions
	 * @param identifiers
	 * @param customAttributes
	 * @param initializeValues
	 * @private
	 */ async initFromValues(clientOptions, identifiers, customAttributes, initializeValues = {}) {
        var _newClientOptions_networkConfig;
        this.overrideAdapter.initFromStoredOverrides();
        this.currentIdentifiers = identifiers;
        this.currentAttributes = customAttributes;
        const newClientOptions = (0, _utils.migrateInitializationOptions)(clientOptions);
        if (!newClientOptions.sdkKey) newClientOptions.sdkKey = DEFAULT_CLIENT_KEY;
        if (!((_newClientOptions_networkConfig = newClientOptions.networkConfig) === null || _newClientOptions_networkConfig === void 0 ? void 0 : _newClientOptions_networkConfig.logEventUrl)) newClientOptions.networkConfig = (0, _objectSpreadProps._)((0, _objectSpread._)({}, newClientOptions.networkConfig), {
            logEventUrl: DEFAULT_EVENT_LOGGING_API
        });
        if (newClientOptions.perimeter === (0, _types1.PerimeterType).FEDRAMP_MODERATE) // disable all logging in FedRAMP to prevent egress of sensitive data
        newClientOptions.disableLogging = true;
        const { sdkKey, environment, updateUserCompletionCallback: _updateUserCompletionCallback, perimeter: _perimeter } = newClientOptions, restClientOptions = (0, _objectWithoutProperties._)(newClientOptions, [
            "sdkKey",
            "environment",
            "updateUserCompletionCallback",
            "perimeter"
        ]);
        const frontendUser = (0, _utils.toStatsigUser)(identifiers, customAttributes);
        this.user = (0, _utils.deepAssign)({}, initializeValues.user, frontendUser);
        const statsigOptions = (0, _objectSpreadProps._)((0, _objectSpread._)({}, restClientOptions), {
            environment: {
                tier: environment
            },
            includeCurrentPageUrlWithEvents: false,
            dataAdapter: this.dataAdapter,
            overrideAdapter: this.overrideAdapter,
            logEventCompressionMode: (0, _jsClient.LogEventCompressionMode).Forced
        });
        // Statsig validates the provided stableId against their own cookie, so we either need
        // to update the cookie to match, or disable the validation completely.
        if (identifiers.stableId) (0, _jsClient.StableID).setOverride(identifiers.stableId, sdkKey);
        else statsigOptions.disableStableID = true;
        try {
            this.statsigClient = new (0, _jsClient.StatsigClient)(sdkKey, this.user, statsigOptions);
            this.dataAdapter.setBootstrapData(initializeValues);
            await this.statsigClient.initializeAsync();
        } catch (error) {
            if (error instanceof Error) // eslint-disable-next-line no-console
            console.error(`Error occurred when trying to initialise the Statsig client, error: ${error === null || error === void 0 ? void 0 : error.message}`);
            // eslint-disable-next-line no-console
            console.warn(`Initialising Statsig client with default sdk key and without values`);
            this.statsigClient = new (0, _jsClient.StatsigClient)(DEFAULT_CLIENT_KEY, this.user, statsigOptions);
            this.dataAdapter.setBootstrapData();
            await this.statsigClient.initializeAsync();
            this.initWithDefaults = true;
            throw error;
        }
    }
    /**
	 * This method updates the user for this client with the bootstrap values returned from a given
	 * Promise.
	 * It uses the customAttributes from fetching experiment values to update the Statsig user but
	 * uses the customAttributes from given input to check if the user has changed.
	 *
	 * @param {Identifiers} identifiers
	 * @param {CustomAttributes} customAttributes
	 * @param {Promise<InitializeValues>} getInitializeValues
	 * @private
	 */ async updateUserUsingInitializeValuesProducer(getInitializeValues, identifiers, customAttributes) {
        this.assertInitialized(this.statsigClient);
        if (!this.initPromise) throw new Error('The client must be initialized before you can update the user.');
        // If the user isn't changing at all, then exit immediately
        if (this.isCurrentUser(identifiers, customAttributes)) return this.initPromise;
        // Wait for the current initialize/update to finish
        const originalInitPromise = this.initPromise;
        try {
            await this.initPromise;
        } catch (err) {
        // Proceed with the user update even if the init failed, since this update
        // may put the client back into a valid state.
        }
        const initializeValuesPromise = getInitializeValues();
        const updateUserPromise = this.updateStatsigClientUser(initializeValuesPromise, identifiers, customAttributes);
        // We replace the init promise here since we are essentially re-initializing the client at this
        // point. Any subsequent calls to await client.initialize() or client.updateUser()
        // will now also await this user update.
        this.initPromise = updateUserPromise.catch(async ()=>{
            // If the update failed then it changed nothing, so revert back to the original promise.
            this.initPromise = originalInitPromise;
            // Set the user profile again to revert back to the current user
            if (this.provider) await this.provider.setProfile(this.initOptions, this.currentIdentifiers, this.currentAttributes);
        });
        return updateUserPromise;
    }
    /**
	 * This method updates the user on the nested Statsig client
	 *
	 * @param identifiers
	 * @param customAttributes
	 * @param initializeValuesPromise
	 * @private
	 */ async updateStatsigClientUser(initializeValuesPromise, identifiers, customAttributes) {
        var _this_initOptions_updateUserCompletionCallback, _this_initOptions;
        this.assertInitialized(this.statsigClient);
        let initializeValues, user;
        try {
            initializeValues = await initializeValuesPromise;
            const frontendUser = (0, _utils.toStatsigUser)(identifiers, initializeValues.customAttributesFromFetch);
            user = (0, _utils.deepAssign)({}, initializeValues.experimentValues.user, frontendUser);
        } catch (err) {
            var _this_initOptions_updateUserCompletionCallback1, _this_initOptions1;
            // Make sure the updateUserCompletionCallback is called for any errors in our custom code.
            // This is not necessary for the updateUserWithValues call, because the Statsig client will
            // already invoke the callback itself.
            const errMsg = err instanceof Error ? err.message : JSON.stringify(err);
            (_this_initOptions_updateUserCompletionCallback1 = (_this_initOptions1 = this.initOptions).updateUserCompletionCallback) === null || _this_initOptions_updateUserCompletionCallback1 === void 0 ? void 0 : _this_initOptions_updateUserCompletionCallback1.call(_this_initOptions1, false, errMsg);
            throw err;
        }
        let success = true;
        let errorMessage = null;
        try {
            this.dataAdapter.setBootstrapData(initializeValues.experimentValues);
            this.user = user;
            if (this.user) await this.statsigClient.updateUserAsync(this.user);
        } catch (err) {
            success = false;
            errorMessage = String(err);
        }
        (_this_initOptions = this.initOptions) === null || _this_initOptions === void 0 ? void 0 : (_this_initOptions_updateUserCompletionCallback = _this_initOptions.updateUserCompletionCallback) === null || _this_initOptions_updateUserCompletionCallback === void 0 ? void 0 : _this_initOptions_updateUserCompletionCallback.call(_this_initOptions, success, errorMessage);
        if (success) {
            this.currentIdentifiers = identifiers;
            this.currentAttributes = customAttributes;
            this.subscriptions.anyUpdated();
        } else throw new Error('Failed to update user. An unexpected error occured.');
    }
    /**
	 * @returns string version of the current package in semver style.
	 */ getPackageVersion() {
        return 0, _version.CLIENT_VERSION;
    }
    /**
	 * Returns the `targetApp` value that was provided during client initialization.
	 * This identifies the product/app context (e.g., `'confluence_web'`, `'jira_web'`).
	 *
	 * Returns `undefined` if `initialize` has never been called.
	 *
	 * @returns The targetApp string, or undefined if initialize has never been called.
	 */ getTargetApp() {
        var _this_initOptions;
        return (_this_initOptions = this.initOptions) === null || _this_initOptions === void 0 ? void 0 : _this_initOptions.targetApp;
    }
    /**
	 * Returns a specified layer otherwise returns an empty layer as a default value if the layer doesn't exist.
	 *
	 * @param {string} layerName - The name of the layer
	 * @param {Object} options
	 * @param {boolean} options.fireLayerExposure - Whether or not to fire the exposure event for the
	 * layer. Defaults to true. To log an exposure event manually at a later time, use
	 * {@link Client.manuallyLogLayerExposure} (see [Statsig docs about manually logging exposures](https://docs.statsig.com/client/jsClientSDK#manual-exposures-)).
	 * @returns A layer
	 * @example
	 * ```ts
	 * const layer = client.getLayer('example-layer-name');
	 * const exampletitle: string = layer.get("title", "Welcome to Statsig!");
	 * ```
	 */ getLayer(/** The name of the layer */ layerName, options = {}) {
        try {
            this.assertInitialized(this.statsigClient);
            const { fireLayerExposure = true } = options;
            return (0, _layer.Layer).fromLayer(this.statsigClient.getLayer(layerName, {
                disableExposureLog: !fireLayerExposure
            }));
        } catch (error) {
            // Log the first occurrence of the error
            if (!this.hasGetLayerErrorOccurred) {
                // eslint-disable-next-line no-console
                console.warn({
                    msg: 'An error has occurred getting the layer. Only the first occurrence of this error is logged.',
                    layerName,
                    error
                });
                this.hasGetLayerErrorOccurred = true;
            }
            // Return a default value
            return (0, _layer.Layer).fromLayer((0, _jsClient._makeLayer)(layerName, {
                reason: 'Error'
            }, null));
        }
    }
    /**
	 * Returns the value of a given parameter in a layer config.
	 *
	 * @template T
	 * @param {string} layerName - The name of the layer
	 * @param {string} parameterName - The name of the parameter to fetch from the layer config
	 * @param {T} defaultValue - The value to serve if the layer or parameter do not exist, or if the
	 * returned value does not match the expected type.
	 * @param {Object} options
	 * @param {boolean} options.fireLayerExposure - Whether or not to fire the exposure event for the
	 * layer. Defaults to true. To log an exposure event manually at a later time, use
	 * {@link Client.manuallyLogLayerExposure} (see [Statsig docs about manually logging exposures](https://docs.statsig.com/client/jsClientSDK#manual-exposures-))
	 * @param {function} options.typeGuard - A function that asserts that the return value has the expected type. If this function returns false, then the default value will be returned instead. This can be set to protect your code from unexpected values being set remotely. By default, this will be done by asserting that the default value and value are the same primitive type.
	 * @returns The value of the parameter if the layer and parameter both exist, otherwise the default value.
	 * @example
	 * ``` ts
	 * type ValidColor = 'blue' | 'red' | 'yellow';
	 * type ValidColorTypeCheck = (value: unknown) => value is ValidColor;
	 *
	 * const isValidColor: ValidColorTypeCheck =
	 *    (value: unknown) => typeof value === 'string' && ['blue', 'red', 'yellow'].includes(value);
	 *
	 * const buttonColor: ValidColor = client.getLayerValue(
	 *    'example-layer-name',
	 *    'backgroundColor',
	 *    'yellow',
	 *    {
	 *        typeGuard: isValidColor
	 *    }
	 * );
	 * ```
	 */ getLayerValue(layerName, parameterName, defaultValue, options = {}) {
        const layer = this.getLayer(layerName, options);
        try {
            const { typeGuard } = options;
            return layer.get(parameterName, defaultValue, typeGuard);
        } catch (error) {
            // Log the first occurrence of the error
            if (!this.hasGetLayerValueErrorOccurred) {
                // eslint-disable-next-line no-console
                console.warn({
                    msg: 'An error has occurred getting the layer value. Only the first occurrence of this error is logged.',
                    layerName,
                    defaultValue,
                    options,
                    error
                });
                this.hasGetLayerValueErrorOccurred = true;
            }
            return defaultValue;
        }
    }
    constructor({ localStorageKey = (0, _persistentOverrideAdapter.LOCAL_STORAGE_KEY), overrideAdapter } = {}){
        this.initPromise = null;
        /** True if an initialize method was called and completed successfully. */ this.initCompleted = false;
        /**
	 * True if an initialize method was called and completed, meaning the client is now usable.
	 * However if there was an error during initialization it may have initialized with default
	 * values. Use {@link initCompleted} to check for this.
	 */ this.initWithDefaults = false;
        this.hasCheckGateErrorOccurred = false;
        this.hasGetExperimentErrorOccurred = false;
        this.hasGetExperimentValueErrorOccurred = false;
        this.hasGetLayerErrorOccurred = false;
        this.hasGetLayerValueErrorOccurred = false;
        this.subscriptions = new (0, _subscriptionsDefault.default)();
        this.dataAdapter = new (0, _noFetchDataAdapter.NoFetchDataAdapter)();
        /**
	 * Call this if modifying the values being served by the Statsig library since it has its own
	 * memoization cache which will not be updated if the values are changed outside of the library.
	 */ this.statsigValuesUpdated = ()=>{
            if (this.user) // Trigger a reset of the memoize cache
            this.statsigClient.updateUserSync(this.user, {
                disableBackgroundCacheRefresh: true
            });
            this.subscriptions.anyUpdated();
        };
        this.overrideAdapter = overrideAdapter || new (0, _persistentOverrideAdapter.PersistentOverrideAdapter)(localStorageKey);
    }
}

},{"@swc/helpers/_/_object_spread":"9gdrV","@swc/helpers/_/_object_spread_props":"kANqQ","@swc/helpers/_/_object_without_properties":"6HqIM","@statsig/js-client":"7YWtw","../subscriptions":"kktF1","./compat/DynamicConfig":"2uTD7","./compat/Layer":"0mwae","./compat/types":"iiV2Y","./fetcher":"jIqZM","./NoFetchDataAdapter":"bfhqM","./PersistentOverrideAdapter":"59ioM","./types":"hcjz7","./utils":"2guUJ","./version":"gevk9","@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"6HqIM":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "_", ()=>_object_without_properties);
var _objectWithoutPropertiesLooseJs = require("./_object_without_properties_loose.js");
function _object_without_properties(source, excluded) {
    if (source == null) return {};
    var target = (0, _objectWithoutPropertiesLooseJs._)(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}

},{"./_object_without_properties_loose.js":"26Pwz","@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"26Pwz":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "_", ()=>_object_without_properties_loose);
function _object_without_properties_loose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}

},{"@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"7YWtw":[function(require,module,exports,__globalThis) {
"use strict";
var __createBinding = this && this.__createBinding || (Object.create ? function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) desc = {
        enumerable: true,
        get: function() {
            return m[k];
        }
    };
    Object.defineProperty(o, k2, desc);
} : function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
});
var __exportStar = this && this.__exportStar || function(m, exports1) {
    for(var p in m)if (p !== "default" && !Object.prototype.hasOwnProperty.call(exports1, p)) __createBinding(exports1, m, p);
};
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.StatsigClient = void 0;
const client_core_1 = require("3d3bf38b9d43120b");
const StatsigClient_1 = require("f4bfc8b2cfd2590c");
exports.StatsigClient = StatsigClient_1.default;
__exportStar(require("3d3bf38b9d43120b"), exports);
const __STATSIG__ = Object.assign((0, client_core_1._getStatsigGlobal)(), {
    StatsigClient: StatsigClient_1.default
});
exports.default = __STATSIG__;

},{"3d3bf38b9d43120b":"1MCdW","f4bfc8b2cfd2590c":"ccWNs"}],"1MCdW":[function(require,module,exports,__globalThis) {
"use strict";
var __createBinding = this && this.__createBinding || (Object.create ? function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) desc = {
        enumerable: true,
        get: function() {
            return m[k];
        }
    };
    Object.defineProperty(o, k2, desc);
} : function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
});
var __exportStar = this && this.__exportStar || function(m, exports1) {
    for(var p in m)if (p !== "default" && !Object.prototype.hasOwnProperty.call(exports1, p)) __createBinding(exports1, m, p);
};
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.Storage = exports.Log = exports.EventLogger = exports.Diagnostics = void 0;
/** Statsig Global should go first */ require("42774f31a1616e13");
const __StatsigGlobal_1 = require("42774f31a1616e13");
const Diagnostics_1 = require("36df617d5a278551");
Object.defineProperty(exports, "Diagnostics", {
    enumerable: true,
    get: function() {
        return Diagnostics_1.Diagnostics;
    }
});
const EventLogger_1 = require("71a6a45a5689058e");
Object.defineProperty(exports, "EventLogger", {
    enumerable: true,
    get: function() {
        return EventLogger_1.EventLogger;
    }
});
const Log_1 = require("40412872a906b14e");
Object.defineProperty(exports, "Log", {
    enumerable: true,
    get: function() {
        return Log_1.Log;
    }
});
const StatsigMetadata_1 = require("eb8b7151fabd9917");
const StorageProvider_1 = require("2fd708d4cd63f0a4");
Object.defineProperty(exports, "Storage", {
    enumerable: true,
    get: function() {
        return StorageProvider_1.Storage;
    }
});
__exportStar(require("42774f31a1616e13"), exports);
__exportStar(require("a3e14a053ae7e93f"), exports);
__exportStar(require("638bdf858a175a64"), exports);
__exportStar(require("56d2bc222563a7e4"), exports);
__exportStar(require("36df617d5a278551"), exports);
__exportStar(require("9025a1cfceeca017"), exports);
__exportStar(require("28c590708c775ec6"), exports);
__exportStar(require("2bcdaaa10862d79b"), exports);
__exportStar(require("77071a44f5a2af3c"), exports);
__exportStar(require("e4809ebf45fe7eea"), exports);
__exportStar(require("d2aa94537228047c"), exports);
__exportStar(require("40412872a906b14e"), exports);
__exportStar(require("73dcc751accb7cde"), exports);
__exportStar(require("7466fed582e8287d"), exports);
__exportStar(require("30bc33657781e8a4"), exports);
__exportStar(require("dcce1623e636841f"), exports);
__exportStar(require("4ea5cb149a8a5ee0"), exports);
__exportStar(require("9d391107459b25a6"), exports);
__exportStar(require("7f69c82400bf6da"), exports);
__exportStar(require("161ad6fd545d259d"), exports);
__exportStar(require("8774d4b872c6a02b"), exports);
__exportStar(require("8bed2aa646cb0578"), exports);
__exportStar(require("bc9d8dd3fd8a9b2e"), exports);
__exportStar(require("af46beaac6f710cf"), exports);
__exportStar(require("2053a6b4e12fe98d"), exports);
__exportStar(require("6f302d344e852fc5"), exports);
__exportStar(require("eb8b7151fabd9917"), exports);
__exportStar(require("3d2f0ba498f053ea"), exports);
__exportStar(require("66525ad00c06c692"), exports);
__exportStar(require("c619f26e028521b"), exports);
__exportStar(require("780f8cf607a42860"), exports);
__exportStar(require("4b285a3be5236641"), exports);
__exportStar(require("2fd708d4cd63f0a4"), exports);
__exportStar(require("78b01c8c632c9db8"), exports);
__exportStar(require("b2d4bb11634ddc91"), exports);
__exportStar(require("a05c2431f9a10e10"), exports);
__exportStar(require("67c65b125578826d"), exports);
__exportStar(require("14fb07e7590ae895"), exports);
__exportStar(require("f312382bfef1b346"), exports);
__exportStar(require("6ffe1efecdb20993"), exports);
Object.assign((0, __StatsigGlobal_1._getStatsigGlobal)(), {
    Log: Log_1.Log,
    SDK_VERSION: StatsigMetadata_1.SDK_VERSION
});

},{"42774f31a1616e13":"d5W7z","36df617d5a278551":"5Y3Ef","71a6a45a5689058e":"506Fu","40412872a906b14e":"jH0ho","eb8b7151fabd9917":"dJKdX","2fd708d4cd63f0a4":"8hatk","a3e14a053ae7e93f":"eqWfV","638bdf858a175a64":"2olc2","56d2bc222563a7e4":"jzjah","9025a1cfceeca017":"4fkIQ","28c590708c775ec6":"jvCQP","2bcdaaa10862d79b":"hvbPE","77071a44f5a2af3c":"4IBGu","e4809ebf45fe7eea":"6nhM9","d2aa94537228047c":"cLvkE","73dcc751accb7cde":"4FvMU","7466fed582e8287d":"evNAP","30bc33657781e8a4":"1eoAx","dcce1623e636841f":"jjzMX","4ea5cb149a8a5ee0":"kaTYM","9d391107459b25a6":"1m3HT","7f69c82400bf6da":"3UrIZ","161ad6fd545d259d":"5Fh6O","8774d4b872c6a02b":"htdWS","8bed2aa646cb0578":"iu1pY","bc9d8dd3fd8a9b2e":"4DqMB","af46beaac6f710cf":"50bPm","2053a6b4e12fe98d":"iA4hx","6f302d344e852fc5":"iSTt6","3d2f0ba498f053ea":"98Sh7","66525ad00c06c692":"g4gRv","c619f26e028521b":"egpWn","780f8cf607a42860":"6UaT7","4b285a3be5236641":"ddLSf","78b01c8c632c9db8":"bUb5z","b2d4bb11634ddc91":"4UasP","a05c2431f9a10e10":"qCB36","67c65b125578826d":"h64IW","14fb07e7590ae895":"dBhOj","f312382bfef1b346":"l6Jw0","6ffe1efecdb20993":"8kCTX"}],"d5W7z":[function(require,module,exports,__globalThis) {
var global = arguments[3];
"use strict";
/* eslint-disable @typescript-eslint/no-unsafe-assignment */ var _a, _b, _c;
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports._getInstance = exports._getStatsigGlobalFlag = exports._getStatsigGlobal = void 0;
const Log_1 = require("72b9026b442600ee");
const _getStatsigGlobal = ()=>{
    // Avoid ReferenceError, which is happening with Cloudflare pages
    try {
        return typeof __STATSIG__ !== 'undefined' ? __STATSIG__ : statsigGlobal;
    } catch (e) {
        return statsigGlobal;
    }
};
exports._getStatsigGlobal = _getStatsigGlobal;
const _getStatsigGlobalFlag = (flag)=>{
    return (0, exports._getStatsigGlobal)()[flag];
};
exports._getStatsigGlobalFlag = _getStatsigGlobalFlag;
const _getInstance = (sdkKey)=>{
    const gbl = (0, exports._getStatsigGlobal)();
    if (!sdkKey) {
        if (gbl.instances && Object.keys(gbl.instances).length > 1) Log_1.Log.warn('Call made to Statsig global instance without an SDK key but there is more than one client instance. If you are using mulitple clients, please specify the SDK key.');
        return gbl.firstInstance;
    }
    return gbl.instances && gbl.instances[sdkKey];
};
exports._getInstance = _getInstance;
const GLOBAL_KEY = '__STATSIG__';
const _window = typeof window !== 'undefined' ? window : {};
const _global = typeof global !== 'undefined' ? global : {};
const _globalThis = typeof globalThis !== 'undefined' ? globalThis : {};
const statsigGlobal = (_c = (_b = (_a = _window[GLOBAL_KEY]) !== null && _a !== void 0 ? _a : _global[GLOBAL_KEY]) !== null && _b !== void 0 ? _b : _globalThis[GLOBAL_KEY]) !== null && _c !== void 0 ? _c : {
    instance: exports._getInstance
};
_window[GLOBAL_KEY] = statsigGlobal;
_global[GLOBAL_KEY] = statsigGlobal;
_globalThis[GLOBAL_KEY] = statsigGlobal;

},{"72b9026b442600ee":"jH0ho"}],"jH0ho":[function(require,module,exports,__globalThis) {
"use strict";
/* eslint-disable no-console */ Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.Log = exports.LogLevel = void 0;
// intentionally spaced for formatting
const DEBUG = ' DEBUG ';
const _INFO = '  INFO ';
const _WARN = '  WARN ';
const ERROR = ' ERROR ';
function addTag(args) {
    args.unshift('[Statsig]');
    return args; // ['[Statsig]', ...args];
}
exports.LogLevel = {
    None: 0,
    Error: 1,
    Warn: 2,
    Info: 3,
    Debug: 4
};
class Log {
    static info(...args) {
        if (Log.level >= exports.LogLevel.Info) console.info(_INFO, ...addTag(args));
    }
    static debug(...args) {
        if (Log.level >= exports.LogLevel.Debug) console.debug(DEBUG, ...addTag(args));
    }
    static warn(...args) {
        if (Log.level >= exports.LogLevel.Warn) console.warn(_WARN, ...addTag(args));
    }
    static error(...args) {
        if (Log.level >= exports.LogLevel.Error) console.error(ERROR, ...addTag(args));
    }
}
exports.Log = Log;
Log.level = exports.LogLevel.Warn;

},{}],"5Y3Ef":[function(require,module,exports,__globalThis) {
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.Diagnostics = void 0;
const MARKER_MAP = new Map();
const ACT_START = 'start';
const ACT_END = 'end';
const DIAGNOSTICS_EVENT = 'statsig::diagnostics';
exports.Diagnostics = {
    _getMarkers: (sdkKey)=>{
        return MARKER_MAP.get(sdkKey);
    },
    _markInitOverallStart: (sdkKey)=>{
        _addMarker(sdkKey, _createMarker({}, ACT_START, 'overall'));
    },
    _markInitOverallEnd: (sdkKey, success, evaluationDetails)=>{
        _addMarker(sdkKey, _createMarker({
            success,
            error: success ? undefined : {
                name: 'InitializeError',
                message: 'Failed to initialize'
            },
            evaluationDetails
        }, ACT_END, 'overall'));
    },
    _markInitNetworkReqStart: (sdkKey, data)=>{
        _addMarker(sdkKey, _createMarker(data, ACT_START, 'initialize', 'network_request'));
    },
    _markInitNetworkReqEnd: (sdkKey, data)=>{
        _addMarker(sdkKey, _createMarker(data, ACT_END, 'initialize', 'network_request'));
    },
    _markInitProcessStart: (sdkKey)=>{
        _addMarker(sdkKey, _createMarker({}, ACT_START, 'initialize', 'process'));
    },
    _markInitProcessEnd: (sdkKey, data)=>{
        _addMarker(sdkKey, _createMarker(data, ACT_END, 'initialize', 'process'));
    },
    _clearMarkers: (sdkKey)=>{
        MARKER_MAP.delete(sdkKey);
    },
    _formatError (e) {
        if (!(e && typeof e === 'object')) return;
        return {
            code: _safeGetField(e, 'code'),
            name: _safeGetField(e, 'name'),
            message: _safeGetField(e, 'message')
        };
    },
    _getDiagnosticsData (res, attempt, body, e) {
        var _a;
        return {
            success: (res === null || res === void 0 ? void 0 : res.ok) === true,
            statusCode: res === null || res === void 0 ? void 0 : res.status,
            sdkRegion: (_a = res === null || res === void 0 ? void 0 : res.headers) === null || _a === void 0 ? void 0 : _a.get('x-statsig-region'),
            isDelta: body.includes('"is_delta":true') === true ? true : undefined,
            attempt,
            error: exports.Diagnostics._formatError(e)
        };
    },
    _enqueueDiagnosticsEvent (user, logger, sdk, options) {
        const markers = exports.Diagnostics._getMarkers(sdk);
        if (markers == null || markers.length <= 0) return -1;
        const overallInitDuration = markers[markers.length - 1].timestamp - markers[0].timestamp;
        exports.Diagnostics._clearMarkers(sdk);
        const event = _makeDiagnosticsEvent(user, {
            context: 'initialize',
            markers: markers.slice(),
            statsigOptions: options
        });
        logger.enqueue(event);
        return overallInitDuration;
    }
};
function _createMarker(data, action, key, step) {
    return Object.assign({
        key: key,
        action: action,
        step: step,
        timestamp: Date.now()
    }, data);
}
function _makeDiagnosticsEvent(user, data) {
    const latencyEvent = {
        eventName: DIAGNOSTICS_EVENT,
        user,
        value: null,
        metadata: data,
        time: Date.now()
    };
    return latencyEvent;
}
function _addMarker(sdkKey, marker) {
    var _a;
    const markers = (_a = MARKER_MAP.get(sdkKey)) !== null && _a !== void 0 ? _a : [];
    markers.push(marker);
    MARKER_MAP.set(sdkKey, markers);
}
function _safeGetField(data, field) {
    if (field in data) return data[field];
    return undefined;
}

},{}],"506Fu":[function(require,module,exports,__globalThis) {
"use strict";
var __awaiter = this && this.__awaiter || function(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.EventLogger = void 0;
const CacheKey_1 = require("ea9e7e51b616b9d8");
const Hashing_1 = require("61271087423b1759");
const Log_1 = require("74c9a18f8613ef4c");
const NetworkConfig_1 = require("10c8db90612f1d13");
const SafeJs_1 = require("d984907798e1f9c0");
const StatsigEvent_1 = require("e36f36dcdff98b73");
const StatsigOptionsCommon_1 = require("81d9df7ce8249977");
const StorageProvider_1 = require("66b2b879f40934fe");
const UrlConfiguration_1 = require("9c6e1167ccdc670b");
const VisibilityObserving_1 = require("f159217587a1095c");
const DEFAULT_QUEUE_SIZE = 100;
const DEFAULT_FLUSH_INTERVAL_MS = 10000;
const MAX_DEDUPER_KEYS = 1000;
const DEDUPER_WINDOW_DURATION_MS = 600000;
const MAX_FAILED_LOGS = 500;
const QUICK_FLUSH_WINDOW_MS = 200;
const EVENT_LOGGER_MAP = {};
class EventLogger {
    static _safeFlushAndForget(sdkKey) {
        var _a;
        (_a = EVENT_LOGGER_MAP[sdkKey]) === null || _a === void 0 || _a.flush().catch(()=>{
        // noop
        });
    }
    static _safeRetryFailedLogs(sdkKey) {
        var _a;
        (_a = EVENT_LOGGER_MAP[sdkKey]) === null || _a === void 0 || _a._retryFailedLogs();
    }
    setLogEventCompressionMode(mode) {
        this._network.setLogEventCompressionMode(mode);
    }
    setLoggingEnabled(loggingEnabled) {
        if (this._loggingEnabled === 'disabled' && loggingEnabled !== 'disabled') {
            // load any pre consented events into memory
            const storageKey = this._getStorageKey();
            const events = (0, StorageProvider_1._getObjectFromStorage)(storageKey);
            if (events) this._queue.push(...events);
            StorageProvider_1.Storage.removeItem(storageKey);
        }
        this._loggingEnabled = loggingEnabled;
    }
    enqueue(event) {
        if (!this._shouldLogEvent(event)) return;
        this._normalizeAndAppendEvent(event);
        this._quickFlushIfNeeded();
        if (this._queue.length > this._maxQueueSize) EventLogger._safeFlushAndForget(this._sdkKey);
    }
    incrementNonExposureCount(name) {
        var _a;
        const current = (_a = this._nonExposedChecks[name]) !== null && _a !== void 0 ? _a : 0;
        this._nonExposedChecks[name] = current + 1;
    }
    reset() {
        // attempt to flush any remaining events
        this.flush().catch(()=>{
        // noop
        });
        this._lastExposureTimeMap = {};
    }
    start() {
        var _a;
        const isServerEnv = (0, SafeJs_1._isServerEnv)();
        if (isServerEnv && ((_a = this._options) === null || _a === void 0 ? void 0 : _a.loggingEnabled) !== 'always') return;
        EVENT_LOGGER_MAP[this._sdkKey] = this;
        if (!isServerEnv) (0, VisibilityObserving_1._subscribeToVisiblityChanged)((visibility)=>{
            if (visibility === 'background') EventLogger._safeFlushAndForget(this._sdkKey);
            else if (visibility === 'foreground') EventLogger._safeRetryFailedLogs(this._sdkKey);
        });
        this._retryFailedLogs();
        this._startBackgroundFlushInterval();
    }
    stop() {
        return __awaiter(this, void 0, void 0, function*() {
            if (this._flushIntervalId) {
                clearInterval(this._flushIntervalId);
                this._flushIntervalId = null;
            }
            delete EVENT_LOGGER_MAP[this._sdkKey];
            yield this.flush();
        });
    }
    flush() {
        return __awaiter(this, void 0, void 0, function*() {
            this._appendAndResetNonExposedChecks();
            if (this._queue.length === 0) return;
            const events = this._queue;
            this._queue = [];
            yield this._sendEvents(events);
        });
    }
    /**
     * We 'Quick Flush' following the very first event enqueued
     * within the quick flush window
     */ _quickFlushIfNeeded() {
        if (this._hasRunQuickFlush) return;
        this._hasRunQuickFlush = true;
        if (Date.now() - this._creationTime > QUICK_FLUSH_WINDOW_MS) return;
        setTimeout(()=>EventLogger._safeFlushAndForget(this._sdkKey), QUICK_FLUSH_WINDOW_MS);
    }
    _shouldLogEvent(event) {
        var _a;
        if (((_a = this._options) === null || _a === void 0 ? void 0 : _a.loggingEnabled) !== 'always' && (0, SafeJs_1._isServerEnv)()) return false;
        if (!(0, StatsigEvent_1._isExposureEvent)(event)) return true;
        const user = event.user ? event.user : {
            statsigEnvironment: undefined
        };
        const userKey = (0, CacheKey_1._getUserStorageKey)(this._sdkKey, user);
        const metadata = event.metadata ? event.metadata : {};
        const key = [
            event.eventName,
            userKey,
            metadata['gate'],
            metadata['config'],
            metadata['ruleID'],
            metadata['allocatedExperiment'],
            metadata['parameterName'],
            String(metadata['isExplicitParameter']),
            metadata['reason']
        ].join('|');
        const previous = this._lastExposureTimeMap[key];
        const now = Date.now();
        if (previous && now - previous < DEDUPER_WINDOW_DURATION_MS) return false;
        if (Object.keys(this._lastExposureTimeMap).length > MAX_DEDUPER_KEYS) this._lastExposureTimeMap = {};
        this._lastExposureTimeMap[key] = now;
        return true;
    }
    _sendEvents(events) {
        return __awaiter(this, void 0, void 0, function*() {
            var _a, _b;
            if (this._loggingEnabled === 'disabled') {
                this._saveFailedLogsToStorage(events);
                return false;
            }
            try {
                const isClosing = (0, VisibilityObserving_1._isUnloading)();
                const shouldUseBeacon = isClosing && this._network.isBeaconSupported() && ((_b = (_a = this._options) === null || _a === void 0 ? void 0 : _a.networkConfig) === null || _b === void 0 ? void 0 : _b.networkOverrideFunc) == null;
                this._emitter({
                    name: 'pre_logs_flushed',
                    events
                });
                const response = shouldUseBeacon ? this._sendEventsViaBeacon(events) : yield this._sendEventsViaPost(events);
                if (response.success) {
                    this._emitter({
                        name: 'logs_flushed',
                        events
                    });
                    return true;
                } else {
                    Log_1.Log.warn('Failed to flush events.');
                    this._saveFailedLogsToStorage(events);
                    return false;
                }
            } catch (_c) {
                Log_1.Log.warn('Failed to flush events.');
                return false;
            }
        });
    }
    _sendEventsViaPost(events) {
        return __awaiter(this, void 0, void 0, function*() {
            var _a;
            const result = yield this._network.post(this._getRequestData(events));
            const code = (_a = result === null || result === void 0 ? void 0 : result.code) !== null && _a !== void 0 ? _a : -1;
            return {
                success: code >= 200 && code < 300
            };
        });
    }
    _sendEventsViaBeacon(events) {
        return {
            success: this._network.beacon(this._getRequestData(events))
        };
    }
    _getRequestData(events) {
        return {
            sdkKey: this._sdkKey,
            data: {
                events
            },
            urlConfig: this._logEventUrlConfig,
            retries: 3,
            isCompressable: true,
            params: {
                [NetworkConfig_1.NetworkParam.EventCount]: String(events.length)
            },
            credentials: 'same-origin'
        };
    }
    _saveFailedLogsToStorage(events) {
        while(events.length > MAX_FAILED_LOGS)events.shift();
        const storageKey = this._getStorageKey();
        try {
            const savedEvents = this._getFailedLogsFromStorage(storageKey);
            (0, StorageProvider_1._setObjectInStorage)(storageKey, [
                ...savedEvents,
                ...events
            ]);
        } catch (_a) {
            Log_1.Log.warn('Unable to save failed logs to storage');
        }
    }
    _getFailedLogsFromStorage(storageKey) {
        let savedEvents = [];
        try {
            const retrieved = (0, StorageProvider_1._getObjectFromStorage)(storageKey);
            if (Array.isArray(retrieved)) savedEvents = retrieved;
            return savedEvents;
        } catch (_a) {
            return [];
        }
    }
    _retryFailedLogs() {
        const storageKey = this._getStorageKey();
        (()=>__awaiter(this, void 0, void 0, function*() {
                if (!StorageProvider_1.Storage.isReady()) yield StorageProvider_1.Storage.isReadyResolver();
                const events = (0, StorageProvider_1._getObjectFromStorage)(storageKey);
                if (!events) return;
                StorageProvider_1.Storage.removeItem(storageKey);
                yield this._sendEvents(events);
            }))().catch(()=>{
            Log_1.Log.warn('Failed to flush stored logs');
        });
    }
    _getStorageKey() {
        return `statsig.failed_logs.${(0, Hashing_1._DJB2)(this._sdkKey)}`;
    }
    _normalizeAndAppendEvent(event) {
        if (event.user) {
            event.user = Object.assign({}, event.user);
            delete event.user.privateAttributes;
        }
        const extras = {};
        const currentPage = this._getCurrentPageUrl();
        if (currentPage) extras.statsigMetadata = {
            currentPage
        };
        const final = Object.assign(Object.assign({}, event), extras);
        Log_1.Log.debug('Enqueued Event:', final);
        this._queue.push(final);
    }
    _appendAndResetNonExposedChecks() {
        if (Object.keys(this._nonExposedChecks).length === 0) return;
        this._normalizeAndAppendEvent({
            eventName: 'statsig::non_exposed_checks',
            user: null,
            time: Date.now(),
            metadata: {
                checks: Object.assign({}, this._nonExposedChecks)
            }
        });
        this._nonExposedChecks = {};
    }
    _getCurrentPageUrl() {
        var _a;
        if (((_a = this._options) === null || _a === void 0 ? void 0 : _a.includeCurrentPageUrlWithEvents) === false) return;
        return (0, SafeJs_1._getCurrentPageUrlSafe)();
    }
    _startBackgroundFlushInterval() {
        var _a, _b;
        const flushInterval = (_b = (_a = this._options) === null || _a === void 0 ? void 0 : _a.loggingIntervalMs) !== null && _b !== void 0 ? _b : DEFAULT_FLUSH_INTERVAL_MS;
        const intervalId = setInterval(()=>{
            const logger = EVENT_LOGGER_MAP[this._sdkKey];
            if (!logger || logger._flushIntervalId !== intervalId) clearInterval(intervalId);
            else EventLogger._safeFlushAndForget(this._sdkKey);
        }, flushInterval);
        this._flushIntervalId = intervalId;
    }
    constructor(_sdkKey, _emitter, _network, _options){
        var _a, _b;
        this._sdkKey = _sdkKey;
        this._emitter = _emitter;
        this._network = _network;
        this._options = _options;
        this._queue = [];
        this._lastExposureTimeMap = {};
        this._nonExposedChecks = {};
        this._hasRunQuickFlush = false;
        this._creationTime = Date.now();
        this._loggingEnabled = (_a = _options === null || _options === void 0 ? void 0 : _options.loggingEnabled) !== null && _a !== void 0 ? _a : (_options === null || _options === void 0 ? void 0 : _options.disableLogging) === true ? StatsigOptionsCommon_1.LoggingEnabledOption.disabled : StatsigOptionsCommon_1.LoggingEnabledOption.browserOnly;
        if ((_options === null || _options === void 0 ? void 0 : _options.loggingEnabled) && _options.disableLogging !== undefined) Log_1.Log.warn('Detected both loggingEnabled and disableLogging options. loggingEnabled takes precedence - please remove disableLogging.');
        this._maxQueueSize = (_b = _options === null || _options === void 0 ? void 0 : _options.loggingBufferMaxSize) !== null && _b !== void 0 ? _b : DEFAULT_QUEUE_SIZE;
        const config = _options === null || _options === void 0 ? void 0 : _options.networkConfig;
        this._logEventUrlConfig = new UrlConfiguration_1.UrlConfiguration(NetworkConfig_1.Endpoint._rgstr, config === null || config === void 0 ? void 0 : config.logEventUrl, config === null || config === void 0 ? void 0 : config.api, config === null || config === void 0 ? void 0 : config.logEventFallbackUrls);
    }
}
exports.EventLogger = EventLogger;

},{"ea9e7e51b616b9d8":"eqWfV","61271087423b1759":"6nhM9","74c9a18f8613ef4c":"jH0ho","10c8db90612f1d13":"evNAP","d984907798e1f9c0":"1m3HT","e36f36dcdff98b73":"iSTt6","81d9df7ce8249977":"98Sh7","66b2b879f40934fe":"8hatk","9c6e1167ccdc670b":"qCB36","f159217587a1095c":"dBhOj"}],"eqWfV":[function(require,module,exports,__globalThis) {
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports._getStorageKey = exports._getUserStorageKey = void 0;
const Hashing_1 = require("e73d0ab2a080df3e");
function _getUserStorageKey(sdkKey, user, customKeyGenerator) {
    var _a;
    if (customKeyGenerator) return customKeyGenerator(sdkKey, user);
    const cids = user && user.customIDs ? user.customIDs : {};
    const parts = [
        `uid:${(_a = user === null || user === void 0 ? void 0 : user.userID) !== null && _a !== void 0 ? _a : ''}`,
        `cids:${Object.keys(cids).sort((leftKey, rightKey)=>leftKey.localeCompare(rightKey)).map((key)=>`${key}-${cids[key]}`).join(',')}`,
        `k:${sdkKey}`
    ];
    return (0, Hashing_1._DJB2)(parts.join('|'));
}
exports._getUserStorageKey = _getUserStorageKey;
function _getStorageKey(sdkKey, user, customKeyGenerator) {
    if (user) return _getUserStorageKey(sdkKey, user, customKeyGenerator);
    return (0, Hashing_1._DJB2)(`k:${sdkKey}`);
}
exports._getStorageKey = _getStorageKey;

},{"e73d0ab2a080df3e":"6nhM9"}],"6nhM9":[function(require,module,exports,__globalThis) {
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports._getSortedObject = exports._DJB2Object = exports._DJB2 = void 0;
const TypingUtils_1 = require("1465599b27b747e8");
const _DJB2 = (value)=>{
    let hash = 0;
    for(let i = 0; i < value.length; i++){
        const character = value.charCodeAt(i);
        hash = (hash << 5) - hash + character;
        hash = hash & hash; // Convert to 32bit integer
    }
    return String(hash >>> 0);
};
exports._DJB2 = _DJB2;
const _DJB2Object = (value, maxLevels)=>{
    return (0, exports._DJB2)(JSON.stringify((0, exports._getSortedObject)(value, maxLevels)));
};
exports._DJB2Object = _DJB2Object;
const _getSortedObject = (object, maxDepth)=>{
    if (object == null) return null;
    const keys = Object.keys(object).sort();
    const sortedObject = {};
    keys.forEach((key)=>{
        const value = object[key];
        if (maxDepth === 0 || (0, TypingUtils_1._typeOf)(value) !== 'object') {
            sortedObject[key] = value;
            return;
        }
        sortedObject[key] = (0, exports._getSortedObject)(value, maxDepth != null ? maxDepth - 1 : maxDepth);
    });
    return sortedObject;
};
exports._getSortedObject = _getSortedObject;

},{"1465599b27b747e8":"4UasP"}],"4UasP":[function(require,module,exports,__globalThis) {
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports._isTypeMatch = exports._typeOf = void 0;
function _typeOf(input) {
    return Array.isArray(input) ? 'array' : typeof input;
}
exports._typeOf = _typeOf;
function _isTypeMatch(a, b) {
    const typeOf = (x)=>Array.isArray(x) ? 'array' : x === null ? 'null' : typeof x;
    return typeOf(a) === typeOf(b);
}
exports._isTypeMatch = _isTypeMatch;

},{}],"evNAP":[function(require,module,exports,__globalThis) {
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.NetworkParam = exports.NetworkDefault = exports.Endpoint = void 0;
exports.Endpoint = {
    _initialize: 'initialize',
    _rgstr: 'rgstr',
    _download_config_specs: 'download_config_specs'
};
exports.NetworkDefault = {
    [exports.Endpoint._rgstr]: 'https://prodregistryv2.org/v1',
    [exports.Endpoint._initialize]: 'https://featureassets.org/v1',
    [exports.Endpoint._download_config_specs]: 'https://api.statsigcdn.com/v1'
};
exports.NetworkParam = {
    EventCount: 'ec',
    SdkKey: 'k',
    SdkType: 'st',
    SdkVersion: 'sv',
    Time: 't',
    SessionID: 'sid',
    StatsigEncoded: 'se',
    IsGzipped: 'gz'
};

},{}],"1m3HT":[function(require,module,exports,__globalThis) {
var process = require("a0f18ecaf71a6ee0");
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports._getUnloadEvent = exports._getCurrentPageUrlSafe = exports._addDocumentEventListenerSafe = exports._addWindowEventListenerSafe = exports._isServerEnv = exports._getDocumentSafe = exports._getWindowSafe = void 0;
const _getWindowSafe = ()=>{
    return typeof window !== 'undefined' ? window : null;
};
exports._getWindowSafe = _getWindowSafe;
const _getDocumentSafe = ()=>{
    var _a;
    const win = (0, exports._getWindowSafe)();
    return (_a = win === null || win === void 0 ? void 0 : win.document) !== null && _a !== void 0 ? _a : null;
};
exports._getDocumentSafe = _getDocumentSafe;
const _isServerEnv = ()=>{
    if ((0, exports._getDocumentSafe)() !== null) return false;
    const isNode = typeof process !== 'undefined' && process.versions != null && process.versions.node != null;
    const isVercel = typeof EdgeRuntime === 'string';
    return isVercel || isNode;
};
exports._isServerEnv = _isServerEnv;
const _addWindowEventListenerSafe = (key, listener)=>{
    const win = (0, exports._getWindowSafe)();
    if (typeof (win === null || win === void 0 ? void 0 : win.addEventListener) === 'function') win.addEventListener(key, listener);
};
exports._addWindowEventListenerSafe = _addWindowEventListenerSafe;
const _addDocumentEventListenerSafe = (key, listener)=>{
    const doc = (0, exports._getDocumentSafe)();
    if (typeof (doc === null || doc === void 0 ? void 0 : doc.addEventListener) === 'function') doc.addEventListener(key, listener);
};
exports._addDocumentEventListenerSafe = _addDocumentEventListenerSafe;
const _getCurrentPageUrlSafe = ()=>{
    var _a;
    try {
        return (_a = (0, exports._getWindowSafe)()) === null || _a === void 0 ? void 0 : _a.location.href.split(/[?#]/)[0];
    } catch (_b) {
        return;
    }
};
exports._getCurrentPageUrlSafe = _getCurrentPageUrlSafe;
const _getUnloadEvent = ()=>{
    const win = (0, exports._getWindowSafe)();
    if (!win) return 'beforeunload';
    const eventType = 'onpagehide' in win ? 'pagehide' : 'beforeunload';
    return eventType;
};
exports._getUnloadEvent = _getUnloadEvent;

},{"a0f18ecaf71a6ee0":"gNLf3"}],"iSTt6":[function(require,module,exports,__globalThis) {
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports._createLayerParameterExposure = exports._createConfigExposure = exports._mapExposures = exports._createGateExposure = exports._isExposureEvent = void 0;
const CONFIG_EXPOSURE_NAME = 'statsig::config_exposure';
const GATE_EXPOSURE_NAME = 'statsig::gate_exposure';
const LAYER_EXPOSURE_NAME = 'statsig::layer_exposure';
const _createExposure = (eventName, user, details, metadata, secondaryExposures)=>{
    if (details.bootstrapMetadata) metadata['bootstrapMetadata'] = details.bootstrapMetadata;
    return {
        eventName,
        user,
        value: null,
        metadata: _addEvaluationDetailsToMetadata(details, metadata),
        secondaryExposures,
        time: Date.now()
    };
};
const _isExposureEvent = ({ eventName })=>{
    return eventName === GATE_EXPOSURE_NAME || eventName === CONFIG_EXPOSURE_NAME || eventName === LAYER_EXPOSURE_NAME;
};
exports._isExposureEvent = _isExposureEvent;
const _createGateExposure = (user, gate, exposureMapping)=>{
    var _a, _b, _c;
    const metadata = {
        gate: gate.name,
        gateValue: String(gate.value),
        ruleID: gate.ruleID
    };
    if (((_a = gate.__evaluation) === null || _a === void 0 ? void 0 : _a.version) != null) metadata['configVersion'] = gate.__evaluation.version;
    return _createExposure(GATE_EXPOSURE_NAME, user, gate.details, metadata, _mapExposures((_c = (_b = gate.__evaluation) === null || _b === void 0 ? void 0 : _b.secondary_exposures) !== null && _c !== void 0 ? _c : [], exposureMapping));
};
exports._createGateExposure = _createGateExposure;
function _mapExposures(exposures, exposureMapping) {
    return exposures.map((exposure)=>{
        if (typeof exposure === 'string') return (exposureMapping !== null && exposureMapping !== void 0 ? exposureMapping : {})[exposure];
        return exposure;
    }).filter((exposure)=>exposure != null);
}
exports._mapExposures = _mapExposures;
const _createConfigExposure = (user, config, exposureMapping)=>{
    var _a, _b, _c, _d;
    const metadata = {
        config: config.name,
        ruleID: config.ruleID
    };
    if (((_a = config.__evaluation) === null || _a === void 0 ? void 0 : _a.version) != null) metadata['configVersion'] = config.__evaluation.version;
    if (((_b = config.__evaluation) === null || _b === void 0 ? void 0 : _b.passed) != null) metadata['rulePassed'] = String(config.__evaluation.passed);
    return _createExposure(CONFIG_EXPOSURE_NAME, user, config.details, metadata, _mapExposures((_d = (_c = config.__evaluation) === null || _c === void 0 ? void 0 : _c.secondary_exposures) !== null && _d !== void 0 ? _d : [], exposureMapping));
};
exports._createConfigExposure = _createConfigExposure;
const _createLayerParameterExposure = (user, layer, parameterName, exposureMapping)=>{
    var _a, _b, _c, _d, _e, _f, _g;
    const evaluation = layer.__evaluation;
    const isExplicit = ((_a = evaluation === null || evaluation === void 0 ? void 0 : evaluation.explicit_parameters) === null || _a === void 0 ? void 0 : _a.includes(parameterName)) === true;
    let allocatedExperiment = '';
    let secondaryExposures = (_b = evaluation === null || evaluation === void 0 ? void 0 : evaluation.undelegated_secondary_exposures) !== null && _b !== void 0 ? _b : [];
    if (isExplicit) {
        allocatedExperiment = (_c = evaluation.allocated_experiment_name) !== null && _c !== void 0 ? _c : '';
        secondaryExposures = (_d = evaluation.secondary_exposures) !== null && _d !== void 0 ? _d : [];
    }
    const parameterRuleIDs = (_e = layer.__evaluation) === null || _e === void 0 ? void 0 : _e.parameter_rule_ids;
    const metadata = {
        config: layer.name,
        parameterName,
        ruleID: (_f = parameterRuleIDs === null || parameterRuleIDs === void 0 ? void 0 : parameterRuleIDs[parameterName]) !== null && _f !== void 0 ? _f : layer.ruleID,
        allocatedExperiment,
        isExplicitParameter: String(isExplicit)
    };
    if (((_g = layer.__evaluation) === null || _g === void 0 ? void 0 : _g.version) != null) metadata['configVersion'] = layer.__evaluation.version;
    return _createExposure(LAYER_EXPOSURE_NAME, user, layer.details, metadata, _mapExposures(secondaryExposures, exposureMapping));
};
exports._createLayerParameterExposure = _createLayerParameterExposure;
const _addEvaluationDetailsToMetadata = (details, metadata)=>{
    metadata['reason'] = details.reason;
    if (details.lcut) metadata['lcut'] = String(details.lcut);
    if (details.receivedAt) metadata['receivedAt'] = String(details.receivedAt);
    return metadata;
};

},{}],"98Sh7":[function(require,module,exports,__globalThis) {
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.LoggingEnabledOption = exports.LogEventCompressionMode = void 0;
exports.LogEventCompressionMode = {
    /** Do not compress request bodies */ Disabled: 'd',
    /** Compress request bodies unless a network proxy is configured */ Enabled: 'e',
    /** Always compress request bodies, even when a proxy is configured */ Forced: 'f'
};
exports.LoggingEnabledOption = {
    disabled: 'disabled',
    browserOnly: 'browser-only',
    always: 'always'
};

},{}],"8hatk":[function(require,module,exports,__globalThis) {
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports._setObjectInStorage = exports._getObjectFromStorage = exports.Storage = void 0;
const Log_1 = require("28586ab5c5ee4f12");
const SafeJs_1 = require("4a6c3002da1493eb");
const inMemoryStore = {};
const _inMemoryProvider = {
    isReady: ()=>true,
    isReadyResolver: ()=>null,
    getProviderName: ()=>'InMemory',
    getItem: (key)=>inMemoryStore[key] ? inMemoryStore[key] : null,
    setItem: (key, value)=>{
        inMemoryStore[key] = value;
    },
    removeItem: (key)=>{
        delete inMemoryStore[key];
    },
    getAllKeys: ()=>Object.keys(inMemoryStore)
};
let _localStorageProvider = null;
try {
    const win = (0, SafeJs_1._getWindowSafe)();
    if (win && win.localStorage && typeof win.localStorage.getItem === 'function') _localStorageProvider = {
        isReady: ()=>true,
        isReadyResolver: ()=>null,
        getProviderName: ()=>'LocalStorage',
        getItem: (key)=>win.localStorage.getItem(key),
        setItem: (key, value)=>win.localStorage.setItem(key, value),
        removeItem: (key)=>win.localStorage.removeItem(key),
        getAllKeys: ()=>Object.keys(win.localStorage)
    };
} catch (error) {
    Log_1.Log.warn('Failed to setup localStorageProvider.');
}
let _main = _localStorageProvider !== null && _localStorageProvider !== void 0 ? _localStorageProvider : _inMemoryProvider;
let _current = _main;
function _inMemoryBreaker(action) {
    try {
        return action();
    } catch (error) {
        if (error instanceof Error && error.name === 'SecurityError') {
            exports.Storage._setProvider(_inMemoryProvider);
            return null;
        }
        throw error;
    }
}
exports.Storage = {
    isReady: ()=>_current.isReady(),
    isReadyResolver: ()=>_current.isReadyResolver(),
    getProviderName: ()=>_current.getProviderName(),
    getItem: (key)=>_inMemoryBreaker(()=>_current.getItem(key)),
    setItem: (key, value)=>_inMemoryBreaker(()=>_current.setItem(key, value)),
    removeItem: (key)=>_current.removeItem(key),
    getAllKeys: ()=>_current.getAllKeys(),
    // StorageProviderManagment
    _setProvider: (newProvider)=>{
        _main = newProvider;
        _current = newProvider;
    },
    _setDisabled: (isDisabled)=>{
        if (isDisabled) _current = _inMemoryProvider;
        else _current = _main;
    }
};
function _getObjectFromStorage(key) {
    const value = exports.Storage.getItem(key);
    try {
        return JSON.parse(value !== null && value !== void 0 ? value : 'null');
    } catch (e) {
        Log_1.Log.error(`Failed to parse value for key "${key}"`);
        return null;
    }
}
exports._getObjectFromStorage = _getObjectFromStorage;
function _setObjectInStorage(key, obj) {
    exports.Storage.setItem(key, JSON.stringify(obj));
}
exports._setObjectInStorage = _setObjectInStorage;

},{"28586ab5c5ee4f12":"jH0ho","4a6c3002da1493eb":"1m3HT"}],"qCB36":[function(require,module,exports,__globalThis) {
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.UrlConfiguration = void 0;
const Hashing_1 = require("dc20f21457bcfe8a");
const NetworkConfig_1 = require("cc0d9c54e09f93f2");
const ENDPOINT_DNS_KEY_MAP = {
    [NetworkConfig_1.Endpoint._initialize]: 'i',
    [NetworkConfig_1.Endpoint._rgstr]: 'e',
    [NetworkConfig_1.Endpoint._download_config_specs]: 'd'
};
class UrlConfiguration {
    getUrl() {
        var _a;
        return (_a = this.customUrl) !== null && _a !== void 0 ? _a : this.defaultUrl;
    }
    getChecksum() {
        var _a;
        const fallbacks = ((_a = this.fallbackUrls) !== null && _a !== void 0 ? _a : []).sort().join(',');
        return (0, Hashing_1._DJB2)(this.customUrl + fallbacks);
    }
    constructor(endpoint, customUrl, customApi, fallbackUrls){
        this.customUrl = null;
        this.fallbackUrls = null;
        this.endpoint = endpoint;
        this.endpointDnsKey = ENDPOINT_DNS_KEY_MAP[endpoint];
        if (customUrl) this.customUrl = customUrl;
        if (!customUrl && customApi) this.customUrl = customApi.endsWith('/') ? `${customApi}${endpoint}` : `${customApi}/${endpoint}`;
        if (fallbackUrls) this.fallbackUrls = fallbackUrls;
        const defaultApi = NetworkConfig_1.NetworkDefault[endpoint];
        this.defaultUrl = `${defaultApi}/${endpoint}`;
    }
}
exports.UrlConfiguration = UrlConfiguration;

},{"dc20f21457bcfe8a":"6nhM9","cc0d9c54e09f93f2":"evNAP"}],"dBhOj":[function(require,module,exports,__globalThis) {
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports._notifyVisibilityChanged = exports._subscribeToVisiblityChanged = exports._isUnloading = exports._isCurrentlyVisible = void 0;
const SafeJs_1 = require("783220254f29c7a8");
const FOREGROUND = 'foreground';
const BACKGROUND = 'background';
const LISTENERS = [];
let current = FOREGROUND;
let isUnloading = false;
const _isCurrentlyVisible = ()=>{
    return current === FOREGROUND;
};
exports._isCurrentlyVisible = _isCurrentlyVisible;
const _isUnloading = ()=>isUnloading;
exports._isUnloading = _isUnloading;
const _subscribeToVisiblityChanged = (listener)=>{
    LISTENERS.unshift(listener);
};
exports._subscribeToVisiblityChanged = _subscribeToVisiblityChanged;
const _notifyVisibilityChanged = (visibility)=>{
    if (visibility === current) return;
    current = visibility;
    LISTENERS.forEach((l)=>l(visibility));
};
exports._notifyVisibilityChanged = _notifyVisibilityChanged;
(0, SafeJs_1._addWindowEventListenerSafe)('focus', ()=>{
    isUnloading = false;
    (0, exports._notifyVisibilityChanged)(FOREGROUND);
});
(0, SafeJs_1._addWindowEventListenerSafe)('blur', ()=>(0, exports._notifyVisibilityChanged)(BACKGROUND));
(0, SafeJs_1._addDocumentEventListenerSafe)('visibilitychange', ()=>{
    (0, exports._notifyVisibilityChanged)(document.visibilityState === 'visible' ? FOREGROUND : BACKGROUND);
});
(0, SafeJs_1._addWindowEventListenerSafe)((0, SafeJs_1._getUnloadEvent)(), ()=>{
    isUnloading = true;
    (0, exports._notifyVisibilityChanged)(BACKGROUND);
});

},{"783220254f29c7a8":"1m3HT"}],"dJKdX":[function(require,module,exports,__globalThis) {
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.StatsigMetadataProvider = exports.SDK_VERSION = void 0;
exports.SDK_VERSION = '3.30.2';
let metadata = {
    sdkVersion: exports.SDK_VERSION,
    sdkType: 'js-mono'
};
exports.StatsigMetadataProvider = {
    get: ()=>metadata,
    add: (additions)=>{
        metadata = Object.assign(Object.assign({}, metadata), additions);
    }
};

},{}],"2olc2":[function(require,module,exports,__globalThis) {
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});

},{}],"jzjah":[function(require,module,exports,__globalThis) {
"use strict";
var __awaiter = this && this.__awaiter || function(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports._makeDataAdapterResult = exports.DataAdapterCore = void 0;
const Log_1 = require("730162e24827394");
const StableID_1 = require("302b43373d8ee203");
const StatsigUser_1 = require("e70520b380f0d673");
const StorageProvider_1 = require("a18ac851a9b8066");
const TypedJsonParse_1 = require("df40ce55c61d6bf9");
const CACHE_LIMIT = 10;
const MAX_CACHE_WRITE_ATTEMPTS = 8;
class DataAdapterCore {
    attach(sdkKey, options, _network) {
        this._sdkKey = sdkKey;
        this._options = options;
    }
    getDataSync(user) {
        const normalized = user && (0, StatsigUser_1._normalizeUser)(user, this._options);
        const cacheKey = this._getCacheKey(normalized);
        const inMem = this._inMemoryCache.get(cacheKey, normalized);
        if (inMem && this._getIsCacheValueValid(inMem)) return inMem;
        const cache = this._loadFromCache(cacheKey);
        if (cache && this._getIsCacheValueValid(cache)) {
            this._inMemoryCache.add(cacheKey, cache, this._cacheLimit);
            return this._inMemoryCache.get(cacheKey, normalized);
        }
        return null;
    }
    setData(data, user) {
        const normalized = user && (0, StatsigUser_1._normalizeUser)(user, this._options);
        const cacheKey = this._getCacheKey(normalized);
        this._inMemoryCache.add(cacheKey, _makeDataAdapterResult('Bootstrap', data, null, normalized), this._cacheLimit);
    }
    _getIsCacheValueValid(current) {
        return current.stableID == null || current.stableID === StableID_1.StableID.get(this._getSdkKey());
    }
    _getDataAsyncImpl(current, user, options) {
        return __awaiter(this, void 0, void 0, function*() {
            if (!StorageProvider_1.Storage.isReady()) yield StorageProvider_1.Storage.isReadyResolver();
            const cache = current !== null && current !== void 0 ? current : this.getDataSync(user);
            const ops = [
                this._fetchAndPrepFromNetwork(cache, user, options)
            ];
            if (options === null || options === void 0 ? void 0 : options.timeoutMs) ops.push(new Promise((r)=>setTimeout(r, options.timeoutMs)).then(()=>{
                Log_1.Log.debug('Fetching latest value timed out');
                return null;
            }));
            return yield Promise.race(ops);
        });
    }
    _prefetchDataImpl(user, options) {
        return __awaiter(this, void 0, void 0, function*() {
            const normalized = user && (0, StatsigUser_1._normalizeUser)(user, this._options);
            const cacheKey = this._getCacheKey(normalized);
            const result = yield this._getDataAsyncImpl(null, normalized, options);
            if (result) this._inMemoryCache.add(cacheKey, Object.assign(Object.assign({}, result), {
                source: 'Prefetch'
            }), this._cacheLimit);
        });
    }
    _fetchAndPrepFromNetwork(cachedResult, user, options) {
        return __awaiter(this, void 0, void 0, function*() {
            var _a;
            const cachedData = (_a = cachedResult === null || cachedResult === void 0 ? void 0 : cachedResult.data) !== null && _a !== void 0 ? _a : null;
            const isCacheValidFor204 = cachedResult != null && this._isCachedResultValidFor204(cachedResult, user);
            const latest = yield this._fetchFromNetwork(cachedData, user, options, isCacheValidFor204);
            if (!latest) {
                Log_1.Log.debug('No response returned for latest value');
                return null;
            }
            const response = (0, TypedJsonParse_1._typedJsonParse)(latest, 'has_updates', 'Response');
            const sdkKey = this._getSdkKey();
            const stableID = StableID_1.StableID.get(sdkKey);
            let result = null;
            if ((response === null || response === void 0 ? void 0 : response.has_updates) === true) result = _makeDataAdapterResult('Network', latest, stableID, user);
            else if (cachedData && (response === null || response === void 0 ? void 0 : response.has_updates) === false) result = _makeDataAdapterResult('NetworkNotModified', cachedData, stableID, user);
            else return null;
            const cacheKey = this._getCacheKey(user);
            this._inMemoryCache.add(cacheKey, result, this._cacheLimit);
            this._writeToCache(cacheKey, result);
            return result;
        });
    }
    _getSdkKey() {
        if (this._sdkKey != null) return this._sdkKey;
        Log_1.Log.error(`${this._adapterName} is not attached to a Client`);
        return '';
    }
    _loadFromCache(cacheKey) {
        var _a;
        const cache = (_a = StorageProvider_1.Storage.getItem) === null || _a === void 0 ? void 0 : _a.call(StorageProvider_1.Storage, cacheKey);
        if (cache == null) return null;
        const result = (0, TypedJsonParse_1._typedJsonParse)(cache, 'source', 'Cached Result');
        return result ? Object.assign(Object.assign({}, result), {
            source: 'Cache'
        }) : null;
    }
    _writeToCache(cacheKey, result) {
        const resultString = JSON.stringify(result);
        for(let i = 0; i < MAX_CACHE_WRITE_ATTEMPTS; i++)try {
            StorageProvider_1.Storage.setItem(cacheKey, resultString);
            break;
        } catch (error) {
            if (!(error instanceof Error) || !(error.toString().includes('QuotaExceededError') || error.toString().includes('QUOTA_EXCEEDED_ERR')) || this._cacheLimit <= 1) throw error;
            this._cacheLimit = Math.ceil(this._cacheLimit / 2);
            this._runLocalStorageCacheEviction(cacheKey, this._cacheLimit - 1);
        }
        this._runLocalStorageCacheEviction(cacheKey);
    }
    _runLocalStorageCacheEviction(cacheKey, cacheLimit = this._cacheLimit) {
        var _a;
        const lastModifiedTimeMap = (_a = (0, StorageProvider_1._getObjectFromStorage)(this._lastModifiedStoreKey)) !== null && _a !== void 0 ? _a : {};
        lastModifiedTimeMap[cacheKey] = Date.now();
        const evictableKeys = _getEvictableKeys(lastModifiedTimeMap, cacheLimit);
        for (const evictable of evictableKeys){
            delete lastModifiedTimeMap[evictable];
            StorageProvider_1.Storage.removeItem(evictable);
        }
        (0, StorageProvider_1._setObjectInStorage)(this._lastModifiedStoreKey, lastModifiedTimeMap);
    }
    constructor(_adapterName, _cacheSuffix){
        this._adapterName = _adapterName;
        this._cacheSuffix = _cacheSuffix;
        this._options = null;
        this._sdkKey = null;
        this._cacheLimit = CACHE_LIMIT;
        this._lastModifiedStoreKey = `statsig.last_modified_time.${_cacheSuffix}`;
        this._inMemoryCache = new InMemoryCache();
    }
}
exports.DataAdapterCore = DataAdapterCore;
function _makeDataAdapterResult(source, data, stableID, user) {
    return {
        source,
        data,
        receivedAt: Date.now(),
        stableID,
        fullUserHash: (0, StatsigUser_1._getFullUserHash)(user)
    };
}
exports._makeDataAdapterResult = _makeDataAdapterResult;
class InMemoryCache {
    get(cacheKey, user) {
        var _a;
        const result = this._data[cacheKey];
        const cached = result === null || result === void 0 ? void 0 : result.stableID;
        const provided = (_a = user === null || user === void 0 ? void 0 : user.customIDs) === null || _a === void 0 ? void 0 : _a.stableID;
        if (provided && cached && provided !== cached) {
            Log_1.Log.warn("'StatsigUser.customIDs.stableID' mismatch");
            return null;
        }
        return result;
    }
    add(cacheKey, value, cacheLimit) {
        const evictableKeys = _getEvictableKeys(this._data, cacheLimit - 1);
        for (const evictable of evictableKeys)delete this._data[evictable];
        this._data[cacheKey] = value;
    }
    merge(values) {
        this._data = Object.assign(Object.assign({}, this._data), values);
    }
    constructor(){
        this._data = {};
    }
}
function _getEvictableKeys(data, limit) {
    const keys = Object.keys(data);
    if (keys.length <= limit) return [];
    if (limit === 0) return keys;
    return keys.sort((keyA, keyB)=>{
        const valueA = data[keyA];
        const valueB = data[keyB];
        if (typeof valueA === 'object' && typeof valueB === 'object') return valueA.receivedAt - valueB.receivedAt;
        return valueA - valueB;
    }).slice(0, keys.length - limit);
}

},{"730162e24827394":"jH0ho","302b43373d8ee203":"iu1pY","e70520b380f0d673":"ddLSf","a18ac851a9b8066":"8hatk","df40ce55c61d6bf9":"bUb5z"}],"iu1pY":[function(require,module,exports,__globalThis) {
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.getCookieName = exports.StableID = void 0;
const CacheKey_1 = require("e6a4bd673648ffc0");
const Log_1 = require("e29d0854f09cc751");
const SafeJs_1 = require("c8ff7073fddedb9d");
const StorageProvider_1 = require("d93e0304bcfd3a2f");
const UUID_1 = require("d16013ab8f87266b");
const PROMISE_MAP = {};
const COOKIE_ENABLED_MAP = {};
const DISABLED_MAP = {};
exports.StableID = {
    cookiesEnabled: false,
    randomID: Math.random().toString(36),
    get: (sdkKey)=>{
        if (DISABLED_MAP[sdkKey]) return null;
        if (PROMISE_MAP[sdkKey] != null) return PROMISE_MAP[sdkKey];
        let stableID = null;
        stableID = _loadFromCookie(sdkKey);
        if (stableID != null) {
            PROMISE_MAP[sdkKey] = stableID;
            _persistToStorage(stableID, sdkKey);
            return stableID;
        }
        stableID = _loadFromStorage(sdkKey);
        if (stableID == null) stableID = (0, UUID_1.getUUID)();
        _persistToStorage(stableID, sdkKey);
        _persistToCookie(stableID, sdkKey);
        PROMISE_MAP[sdkKey] = stableID;
        return stableID;
    },
    setOverride: (override, sdkKey)=>{
        PROMISE_MAP[sdkKey] = override;
        _persistToStorage(override, sdkKey);
        _persistToCookie(override, sdkKey);
    },
    _setCookiesEnabled: (sdkKey, cookiesEnabled)=>{
        COOKIE_ENABLED_MAP[sdkKey] = cookiesEnabled;
    },
    _setDisabled: (sdkKey, disabled)=>{
        DISABLED_MAP[sdkKey] = disabled;
    }
};
function _getStableIDStorageKey(sdkKey) {
    return `statsig.stable_id.${(0, CacheKey_1._getStorageKey)(sdkKey)}`;
}
function _persistToStorage(stableID, sdkKey) {
    const storageKey = _getStableIDStorageKey(sdkKey);
    try {
        (0, StorageProvider_1._setObjectInStorage)(storageKey, stableID);
    } catch (e) {
        Log_1.Log.warn('Failed to save StableID to storage');
    }
}
function _loadFromStorage(sdkKey) {
    const storageKey = _getStableIDStorageKey(sdkKey);
    return (0, StorageProvider_1._getObjectFromStorage)(storageKey);
}
function _loadFromCookie(sdkKey) {
    if (!COOKIE_ENABLED_MAP[sdkKey] || (0, SafeJs_1._getDocumentSafe)() == null) return null;
    const cookies = document.cookie.split(';');
    for (const cookie of cookies){
        const [key, value] = cookie.trim().split('=');
        if (key === getCookieName(sdkKey)) return decodeURIComponent(value);
    }
    return null;
}
function _persistToCookie(stableID, sdkKey) {
    if (!COOKIE_ENABLED_MAP[sdkKey] || (0, SafeJs_1._getDocumentSafe)() == null) return;
    const expiryDate = new Date();
    expiryDate.setFullYear(expiryDate.getFullYear() + 1);
    document.cookie = `${getCookieName(sdkKey)}=${encodeURIComponent(stableID)}; expires=${expiryDate.toUTCString()}; path=/`;
}
function getCookieName(sdkKey) {
    return `statsig.stable_id.${(0, CacheKey_1._getStorageKey)(sdkKey)}`;
}
exports.getCookieName = getCookieName;

},{"e6a4bd673648ffc0":"eqWfV","e29d0854f09cc751":"jH0ho","c8ff7073fddedb9d":"1m3HT","d93e0304bcfd3a2f":"8hatk","d16013ab8f87266b":"h64IW"}],"h64IW":[function(require,module,exports,__globalThis) {
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.getUUID = void 0;
function getUUID() {
    if (typeof crypto !== 'undefined' && typeof crypto.randomUUID === 'function') return crypto.randomUUID();
    let d = new Date().getTime();
    let d2 = typeof performance !== 'undefined' && performance.now && performance.now() * 1000 || 0;
    const y = '89ab'[Math.floor(Math.random() * 4)];
    return `xxxxxxxx-xxxx-4xxx-${y}xxx-xxxxxxxxxxxx`.replace(/[xy]/g, (c)=>{
        let r = Math.random() * 16;
        if (d > 0) {
            r = (d + r) % 16 | 0;
            d = Math.floor(d / 16);
        } else {
            r = (d2 + r) % 16 | 0;
            d2 = Math.floor(d2 / 16);
        }
        return (c === 'x' ? r : r & 0x7 | 0x8).toString(16);
    });
}
exports.getUUID = getUUID;

},{}],"ddLSf":[function(require,module,exports,__globalThis) {
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports._getFullUserHash = exports._normalizeUser = void 0;
const Hashing_1 = require("bf764c282e755948");
const Log_1 = require("2513dc9d625e781f");
function _normalizeUser(original, options, fallbackEnvironment) {
    try {
        const copy = JSON.parse(JSON.stringify(original));
        if (options != null && options.environment != null) copy.statsigEnvironment = options.environment;
        else if (fallbackEnvironment != null) copy.statsigEnvironment = {
            tier: fallbackEnvironment
        };
        return copy;
    } catch (error) {
        Log_1.Log.error('Failed to JSON.stringify user');
        return {
            statsigEnvironment: undefined
        };
    }
}
exports._normalizeUser = _normalizeUser;
function _getFullUserHash(user) {
    return user ? (0, Hashing_1._DJB2Object)(user) : null;
}
exports._getFullUserHash = _getFullUserHash;

},{"bf764c282e755948":"6nhM9","2513dc9d625e781f":"jH0ho"}],"bUb5z":[function(require,module,exports,__globalThis) {
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports._typedJsonParse = void 0;
const Log_1 = require("f6ef0b21eef38827");
/**
 *
 * @param {string} data The values to parse into T
 * @param {string} guard A field that must exists on the parsed object for the parse to be valid
 * @param {string} error An error to print via Log.error() when parsing fails
 * @returns {T | null} The parse object T or null if it failed
 */ function _typedJsonParse(data, guard, typeName) {
    try {
        const result = JSON.parse(data);
        if (result && typeof result === 'object' && guard in result) return result;
    } catch (_a) {
    // noop
    }
    Log_1.Log.error(`Failed to parse ${typeName}`);
    return null;
}
exports._typedJsonParse = _typedJsonParse;

},{"f6ef0b21eef38827":"jH0ho"}],"4fkIQ":[function(require,module,exports,__globalThis) {
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});

},{}],"jvCQP":[function(require,module,exports,__globalThis) {
"use strict";
var __awaiter = this && this.__awaiter || function(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.ErrorBoundary = exports.EXCEPTION_ENDPOINT = void 0;
const Log_1 = require("85a7c2baf5aa8c84");
const SDKType_1 = require("d891669493246ec3");
const StatsigMetadata_1 = require("818305d558e94bc7");
exports.EXCEPTION_ENDPOINT = 'https://statsigapi.net/v1/sdk_exception';
const UNKNOWN_ERROR = '[Statsig] UnknownError';
class ErrorBoundary {
    wrap(instance, namePrefix) {
        try {
            const obj = instance;
            _getAllInstanceMethodNames(obj).forEach((name)=>{
                const original = obj[name];
                if ('$EB' in original) return;
                obj[name] = (...args)=>{
                    return this._capture(namePrefix ? `${namePrefix}:${name}` : name, ()=>original.apply(instance, args));
                };
                obj[name].$EB = true;
            });
        } catch (err) {
            this._onError('eb:wrap', err);
        }
    }
    logError(tag, error) {
        this._onError(tag, error);
    }
    getLastSeenErrorAndReset() {
        const tempError = this._lastSeenError;
        this._lastSeenError = undefined;
        return tempError !== null && tempError !== void 0 ? tempError : null;
    }
    attachErrorIfNoneExists(error) {
        if (this._lastSeenError) return;
        this._lastSeenError = _resolveError(error);
    }
    _capture(tag, task) {
        try {
            const res = task();
            if (res && res instanceof Promise) return res.catch((err)=>this._onError(tag, err));
            return res;
        } catch (error) {
            this._onError(tag, error);
            return null;
        }
    }
    _onError(tag, error) {
        try {
            Log_1.Log.warn(`Caught error in ${tag}`, {
                error
            });
            const impl = ()=>__awaiter(this, void 0, void 0, function*() {
                    var _a, _b, _c, _d, _e, _f, _g;
                    const unwrapped = error ? error : Error(UNKNOWN_ERROR);
                    const isError = unwrapped instanceof Error;
                    const name = isError ? unwrapped.name : 'No Name';
                    const resolvedError = _resolveError(unwrapped);
                    this._lastSeenError = resolvedError;
                    if (this._seen.has(name)) return;
                    this._seen.add(name);
                    if ((_b = (_a = this._options) === null || _a === void 0 ? void 0 : _a.networkConfig) === null || _b === void 0 ? void 0 : _b.preventAllNetworkTraffic) {
                        (_c = this._emitter) === null || _c === void 0 || _c.call(this, {
                            name: 'error',
                            error,
                            tag
                        });
                        return;
                    }
                    const sdkType = SDKType_1.SDKType._get(this._sdkKey);
                    const statsigMetadata = StatsigMetadata_1.StatsigMetadataProvider.get();
                    const info = isError ? unwrapped.stack : _getDescription(unwrapped);
                    const body = Object.assign({
                        tag,
                        exception: name,
                        info,
                        statsigOptions: _getStatsigOptionLoggingCopy(this._options)
                    }, Object.assign(Object.assign({}, statsigMetadata), {
                        sdkType
                    }));
                    const func = (_f = (_e = (_d = this._options) === null || _d === void 0 ? void 0 : _d.networkConfig) === null || _e === void 0 ? void 0 : _e.networkOverrideFunc) !== null && _f !== void 0 ? _f : fetch;
                    yield func(exports.EXCEPTION_ENDPOINT, {
                        method: 'POST',
                        headers: {
                            'STATSIG-API-KEY': this._sdkKey,
                            'STATSIG-SDK-TYPE': String(sdkType),
                            'STATSIG-SDK-VERSION': String(statsigMetadata.sdkVersion),
                            'Content-Type': 'application/json'
                        },
                        body: JSON.stringify(body)
                    });
                    (_g = this._emitter) === null || _g === void 0 || _g.call(this, {
                        name: 'error',
                        error,
                        tag
                    });
                });
            impl().then(()=>{
            /* noop */ }).catch(()=>{
            /* noop */ });
        } catch (_error) {
        /* noop */ }
    }
    constructor(_sdkKey, _options, _emitter, _lastSeenError){
        this._sdkKey = _sdkKey;
        this._options = _options;
        this._emitter = _emitter;
        this._lastSeenError = _lastSeenError;
        this._seen = new Set();
    }
}
exports.ErrorBoundary = ErrorBoundary;
function _resolveError(error) {
    if (error instanceof Error) return error;
    else if (typeof error === 'string') return new Error(error);
    else return new Error('An unknown error occurred.');
}
function _getDescription(obj) {
    try {
        return JSON.stringify(obj);
    } catch (_a) {
        return UNKNOWN_ERROR;
    }
}
function _getAllInstanceMethodNames(instance) {
    const names = new Set();
    let proto = Object.getPrototypeOf(instance);
    while(proto && proto !== Object.prototype){
        Object.getOwnPropertyNames(proto).filter((prop)=>typeof (proto === null || proto === void 0 ? void 0 : proto[prop]) === 'function').forEach((name)=>names.add(name));
        proto = Object.getPrototypeOf(proto);
    }
    return Array.from(names);
}
function _getStatsigOptionLoggingCopy(options) {
    if (!options) return {};
    const loggingCopy = {};
    Object.keys(options).forEach((key)=>{
        const option = key;
        const value = options[option];
        const valueType = typeof value;
        switch(valueType){
            case 'number':
            case 'bigint':
            case 'boolean':
                loggingCopy[String(option)] = value;
                break;
            case 'string':
                if (value.length < 50) loggingCopy[String(option)] = value;
                else loggingCopy[String(option)] = 'set';
                break;
            case 'object':
                if (option === 'environment') loggingCopy['environment'] = value;
                else if (option === 'networkConfig') loggingCopy['networkConfig'] = value;
                else loggingCopy[String(option)] = value != null ? 'set' : 'unset';
                break;
            default:
        }
    });
    return loggingCopy;
}

},{"85a7c2baf5aa8c84":"jH0ho","d891669493246ec3":"3UrIZ","818305d558e94bc7":"dJKdX"}],"3UrIZ":[function(require,module,exports,__globalThis) {
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.SDKType = void 0;
const SDK_CLIENT = {};
let suffix;
exports.SDKType = {
    _get: (sdkKey)=>{
        var _a;
        return ((_a = SDK_CLIENT[sdkKey]) !== null && _a !== void 0 ? _a : 'js-mono') + (suffix !== null && suffix !== void 0 ? suffix : '');
    },
    _setClientType (sdkKey, client) {
        SDK_CLIENT[sdkKey] = client;
    },
    _setBindingType (binding) {
        if (!suffix || suffix === '-react') suffix = '-' + binding;
    }
};

},{}],"hvbPE":[function(require,module,exports,__globalThis) {
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});

},{}],"4IBGu":[function(require,module,exports,__globalThis) {
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});

},{}],"cLvkE":[function(require,module,exports,__globalThis) {
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});

},{}],"4FvMU":[function(require,module,exports,__globalThis) {
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.createMemoKey = exports.MemoPrefix = void 0;
exports.MemoPrefix = {
    _gate: 'g',
    _dynamicConfig: 'c',
    _experiment: 'e',
    _configList: 'cl',
    _layer: 'l',
    _paramStore: 'p'
};
const EXIST_KEYS = new Set([]);
const DO_NOT_MEMO_KEYS = new Set([
    // Add keys that if exist, should not be memoized
    'userPersistedValues'
]);
function createMemoKey(prefix, name, options) {
    let cacheKey = `${prefix}|${name}`;
    if (!options) return cacheKey;
    for (const key of Object.keys(options)){
        if (DO_NOT_MEMO_KEYS.has(key)) return undefined;
        if (EXIST_KEYS.has(key)) cacheKey += `|${key}=true`;
        else cacheKey += `|${key}=${options[key]}`;
    }
    return cacheKey;
}
exports.createMemoKey = createMemoKey;

},{}],"1eoAx":[function(require,module,exports,__globalThis) {
"use strict";
var __awaiter = this && this.__awaiter || function(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.NetworkCore = void 0;
require("b7b53b3bb6ffe2e6");
const __StatsigGlobal_1 = require("b7b53b3bb6ffe2e6");
const Diagnostics_1 = require("29a23a4c1e1673f4");
const Log_1 = require("ecb6e18a107a073");
const NetworkConfig_1 = require("2651e07d3cc7fed6");
const NetworkFallbackResolver_1 = require("9369166c37b5d3f4");
const SDKFlags_1 = require("2fd9c0b9892d34e2");
const SDKType_1 = require("1f969a4f163e3dd3");
const SafeJs_1 = require("fcb203a50f0333b2");
const SessionID_1 = require("fc5634ee1e4f49c1");
const StableID_1 = require("7ae5e5ef538bd4da");
const StatsigClientEventEmitter_1 = require("486d61be2d247fa8");
const StatsigMetadata_1 = require("4fe8834821311ab");
const StatsigOptionsCommon_1 = require("b3df4191bd9aa1ed");
const VisibilityObserving_1 = require("573df593302ec4db");
const DEFAULT_TIMEOUT_MS = 10000;
const BACKOFF_BASE_MS = 500;
const BACKOFF_MAX_MS = 30000;
const RATE_LIMIT_WINDOW_MS = 1000;
const RATE_LIMIT_MAX_REQ_COUNT = 50;
const LEAK_RATE = RATE_LIMIT_MAX_REQ_COUNT / RATE_LIMIT_WINDOW_MS;
const RETRYABLE_CODES = new Set([
    408,
    500,
    502,
    503,
    504,
    522,
    524,
    599
]);
class NetworkCore {
    setLogEventCompressionMode(mode) {
        this._options.logEventCompressionMode = mode;
    }
    setErrorBoundary(errorBoundary) {
        this._errorBoundary = errorBoundary;
        this._errorBoundary.wrap(this);
        this._errorBoundary.wrap(this._fallbackResolver);
        this._fallbackResolver.setErrorBoundary(errorBoundary);
    }
    isBeaconSupported() {
        return typeof navigator !== 'undefined' && typeof navigator.sendBeacon === 'function';
    }
    getLastUsedInitUrlAndReset() {
        const tempUrl = this._lastUsedInitUrl;
        this._lastUsedInitUrl = null;
        return tempUrl;
    }
    beacon(args) {
        if (!_ensureValidSdkKey(args)) return false;
        const argsInternal = this._getInternalRequestArgs('POST', args);
        const url = this._getPopulatedURL(argsInternal);
        const nav = navigator;
        return nav.sendBeacon.bind(nav)(url, argsInternal.body);
    }
    post(args) {
        return __awaiter(this, void 0, void 0, function*() {
            const argsInternal = this._getInternalRequestArgs('POST', args);
            this._tryEncodeBody(argsInternal);
            yield this._tryToCompressBody(argsInternal);
            return this._sendRequest(argsInternal);
        });
    }
    get(args) {
        const argsInternal = this._getInternalRequestArgs('GET', args);
        return this._sendRequest(argsInternal);
    }
    _sendRequest(args) {
        return __awaiter(this, void 0, void 0, function*() {
            var _a, _b, _c, _d;
            if (!_ensureValidSdkKey(args)) return null;
            if (this._netConfig.preventAllNetworkTraffic) return null;
            const { method, body, retries, attempt } = args;
            const endpoint = args.urlConfig.endpoint;
            if (this._isRateLimited(endpoint)) {
                Log_1.Log.warn(`Request to ${endpoint} was blocked because you are making requests too frequently.`);
                return null;
            }
            const currentAttempt = attempt !== null && attempt !== void 0 ? attempt : 1;
            let reqTimedOut = false;
            const populatedUrl = this._getPopulatedURL(args);
            let response = null;
            const keepalive = (0, VisibilityObserving_1._isUnloading)();
            try {
                const config = {
                    method,
                    body,
                    headers: Object.assign({}, args.headers),
                    priority: args.priority,
                    keepalive
                };
                _tryMarkInitStart(args, currentAttempt);
                const bucket = this._leakyBucket[endpoint];
                if (bucket) {
                    bucket.lastRequestTime = Date.now();
                    this._leakyBucket[endpoint] = bucket;
                }
                const func = (_a = this._netConfig.networkOverrideFunc) !== null && _a !== void 0 ? _a : fetch;
                let timeoutId;
                response = yield Promise.race([
                    func(populatedUrl, config).finally(()=>clearTimeout(timeoutId)),
                    new Promise((_, reject)=>{
                        timeoutId = setTimeout(()=>{
                            reqTimedOut = true;
                            reject(new Error(`Timeout of ${this._timeout}ms expired.`));
                        }, this._timeout);
                    })
                ]);
                if (!response.ok) {
                    const text = yield response.text().catch(()=>'No Text');
                    const err = new Error(`NetworkError: ${populatedUrl} ${text}`);
                    err.name = 'NetworkError';
                    throw err;
                }
                const text = yield response.text();
                _tryMarkInitEnd(args, response, currentAttempt, text);
                this._fallbackResolver.tryBumpExpiryTime(args.sdkKey, args.urlConfig);
                return {
                    body: text,
                    code: response.status
                };
            } catch (error) {
                const errorMessage = _getErrorMessage(error);
                const timedOut = _didTimeout(errorMessage !== null && errorMessage !== void 0 ? errorMessage : '', reqTimedOut);
                _tryMarkInitEnd(args, response, currentAttempt, '', error);
                const fallbackUpdated = yield this._fallbackResolver.tryFetchUpdatedFallbackInfo(args.sdkKey, args.urlConfig, errorMessage, timedOut);
                if (fallbackUpdated) args.fallbackUrl = this._fallbackResolver.getActiveFallbackUrl(args.sdkKey, args.urlConfig);
                if (!retries || currentAttempt > retries || !RETRYABLE_CODES.has((_b = response === null || response === void 0 ? void 0 : response.status) !== null && _b !== void 0 ? _b : 500)) {
                    (_c = this._emitter) === null || _c === void 0 || _c.call(this, {
                        name: 'error',
                        error,
                        tag: StatsigClientEventEmitter_1.ErrorTag.NetworkError,
                        requestArgs: args
                    });
                    const formattedErrorMsg = `A networking error occurred during ${method} request to ${populatedUrl}.`;
                    Log_1.Log.error(formattedErrorMsg, errorMessage, error);
                    (_d = this._errorBoundary) === null || _d === void 0 || _d.attachErrorIfNoneExists(formattedErrorMsg);
                    return null;
                }
                yield _exponentialBackoff(currentAttempt);
                return this._sendRequest(Object.assign(Object.assign({}, args), {
                    retries,
                    attempt: currentAttempt + 1
                }));
            }
        });
    }
    _getLogEventCompressionMode(options) {
        // Handle backward compatibility for deprecated disableCompression flag
        let compressionMode = options === null || options === void 0 ? void 0 : options.logEventCompressionMode;
        if (!compressionMode && (options === null || options === void 0 ? void 0 : options.disableCompression) === true) compressionMode = StatsigOptionsCommon_1.LogEventCompressionMode.Disabled;
        // Default to enabled if unset
        if (!compressionMode) compressionMode = StatsigOptionsCommon_1.LogEventCompressionMode.Enabled;
        return compressionMode;
    }
    _isRateLimited(endpoint) {
        var _a;
        const now = Date.now();
        const bucket = (_a = this._leakyBucket[endpoint]) !== null && _a !== void 0 ? _a : {
            count: 0,
            lastRequestTime: now
        };
        const elapsed = now - bucket.lastRequestTime;
        const leakedRequests = Math.floor(elapsed * LEAK_RATE);
        bucket.count = Math.max(0, bucket.count - leakedRequests);
        if (bucket.count >= RATE_LIMIT_MAX_REQ_COUNT) return true;
        bucket.count += 1;
        bucket.lastRequestTime = now;
        this._leakyBucket[endpoint] = bucket;
        return false;
    }
    _getPopulatedURL(args) {
        var _a;
        const url = (_a = args.fallbackUrl) !== null && _a !== void 0 ? _a : args.urlConfig.getUrl();
        if (args.urlConfig.endpoint === NetworkConfig_1.Endpoint._initialize || args.urlConfig.endpoint === NetworkConfig_1.Endpoint._download_config_specs) this._lastUsedInitUrl = url;
        const params = Object.assign({
            [NetworkConfig_1.NetworkParam.SdkKey]: args.sdkKey,
            [NetworkConfig_1.NetworkParam.SdkType]: SDKType_1.SDKType._get(args.sdkKey),
            [NetworkConfig_1.NetworkParam.SdkVersion]: StatsigMetadata_1.SDK_VERSION,
            [NetworkConfig_1.NetworkParam.Time]: String(Date.now()),
            [NetworkConfig_1.NetworkParam.SessionID]: SessionID_1.SessionID.get(args.sdkKey)
        }, args.params);
        const query = Object.keys(params).map((key)=>{
            return `${encodeURIComponent(key)}=${encodeURIComponent(params[key])}`;
        }).join('&');
        return `${url}${query ? `?${query}` : ''}`;
    }
    _tryEncodeBody(args) {
        var _a;
        const win = (0, SafeJs_1._getWindowSafe)();
        const body = args.body;
        if (!args.isStatsigEncodable || this._options.disableStatsigEncoding || typeof body !== 'string' || (0, __StatsigGlobal_1._getStatsigGlobalFlag)('no-encode') != null || !(win === null || win === void 0 ? void 0 : win.btoa)) return;
        try {
            args.body = win.btoa(body).split('').reverse().join('');
            args.params = Object.assign(Object.assign({}, (_a = args.params) !== null && _a !== void 0 ? _a : {}), {
                [NetworkConfig_1.NetworkParam.StatsigEncoded]: '1'
            });
        } catch (e) {
            Log_1.Log.warn(`Request encoding failed for ${args.urlConfig.getUrl()}`, e);
        }
    }
    _tryToCompressBody(args) {
        return __awaiter(this, void 0, void 0, function*() {
            var _a;
            const body = args.body;
            if (typeof body !== 'string' || !_allowCompression(args, this._options)) return;
            try {
                const bytes = new TextEncoder().encode(body);
                const stream = new CompressionStream('gzip');
                const writer = stream.writable.getWriter();
                writer.write(bytes).catch(Log_1.Log.error);
                writer.close().catch(Log_1.Log.error);
                const reader = stream.readable.getReader();
                const chunks = [];
                let result;
                // eslint-disable-next-line no-await-in-loop
                while(!(result = yield reader.read()).done)chunks.push(result.value);
                const totalLength = chunks.reduce((acc, chunk)=>acc + chunk.length, 0);
                const combined = new Uint8Array(totalLength);
                let offset = 0;
                for (const chunk of chunks){
                    combined.set(chunk, offset);
                    offset += chunk.length;
                }
                args.body = combined;
                args.params = Object.assign(Object.assign({}, (_a = args.params) !== null && _a !== void 0 ? _a : {}), {
                    [NetworkConfig_1.NetworkParam.IsGzipped]: '1'
                });
            } catch (e) {
                Log_1.Log.warn(`Request compression failed for ${args.urlConfig.getUrl()}`, e);
            }
        });
    }
    _getInternalRequestArgs(method, args) {
        const fallbackUrl = this._fallbackResolver.getActiveFallbackUrl(args.sdkKey, args.urlConfig);
        const result = Object.assign(Object.assign({}, args), {
            method,
            fallbackUrl
        });
        if ('data' in args) _populateRequestBody(result, args.data);
        return result;
    }
    constructor(options, _emitter){
        this._emitter = _emitter;
        this._errorBoundary = null;
        this._timeout = DEFAULT_TIMEOUT_MS;
        this._netConfig = {};
        this._options = {};
        this._leakyBucket = {};
        this._lastUsedInitUrl = null;
        if (options) this._options = options;
        if (this._options.networkConfig) this._netConfig = this._options.networkConfig;
        if (this._netConfig.networkTimeoutMs) this._timeout = this._netConfig.networkTimeoutMs;
        this._fallbackResolver = new NetworkFallbackResolver_1.NetworkFallbackResolver(this._options);
        this.setLogEventCompressionMode(this._getLogEventCompressionMode(options));
    }
}
exports.NetworkCore = NetworkCore;
const _ensureValidSdkKey = (args)=>{
    if (!args.sdkKey) {
        Log_1.Log.warn('Unable to make request without an SDK key');
        return false;
    }
    return true;
};
const _populateRequestBody = (args, data)=>{
    const { sdkKey, fallbackUrl } = args;
    const stableID = StableID_1.StableID.get(sdkKey);
    const sessionID = SessionID_1.SessionID.get(sdkKey);
    const sdkType = SDKType_1.SDKType._get(sdkKey);
    args.body = JSON.stringify(Object.assign(Object.assign({}, data), {
        statsigMetadata: Object.assign(Object.assign({}, StatsigMetadata_1.StatsigMetadataProvider.get()), {
            stableID,
            sessionID,
            sdkType,
            fallbackUrl
        })
    }));
};
function _allowCompression(args, options) {
    if (!args.isCompressable) return false;
    // Never compress if 'no-compress' is set globally or required APIs are unavailable
    if ((0, __StatsigGlobal_1._getStatsigGlobalFlag)('no-compress') != null || typeof CompressionStream === 'undefined' || typeof TextEncoder === 'undefined') return false;
    const isProxy = args.urlConfig.customUrl != null || args.urlConfig.fallbackUrls != null;
    const flagEnabled = SDKFlags_1.SDKFlags.get(args.sdkKey, 'enable_log_event_compression') === true;
    switch(options.logEventCompressionMode){
        case StatsigOptionsCommon_1.LogEventCompressionMode.Disabled:
            return false;
        case StatsigOptionsCommon_1.LogEventCompressionMode.Enabled:
            // Only compress through proxy if flag is explicitly on
            if (isProxy && !flagEnabled) return false;
            return true;
        case StatsigOptionsCommon_1.LogEventCompressionMode.Forced:
            return true;
        default:
            return false;
    }
}
function _getErrorMessage(error) {
    if (typeof error === 'string') return error;
    if (error instanceof Error) return `${error.name}: ${error.message}`;
    return 'Unknown Error';
}
function _didTimeout(errorMsg, abortedByTimeout) {
    const timeout = errorMsg.includes('Timeout'); // probably not needed but just in case
    return timeout || abortedByTimeout;
}
function _tryMarkInitStart(args, attempt) {
    if (args.urlConfig.endpoint !== NetworkConfig_1.Endpoint._initialize) return;
    Diagnostics_1.Diagnostics._markInitNetworkReqStart(args.sdkKey, {
        attempt
    });
}
function _tryMarkInitEnd(args, response, attempt, body, err) {
    if (args.urlConfig.endpoint !== NetworkConfig_1.Endpoint._initialize) return;
    Diagnostics_1.Diagnostics._markInitNetworkReqEnd(args.sdkKey, Diagnostics_1.Diagnostics._getDiagnosticsData(response, attempt, body, err));
}
function _exponentialBackoff(attempt) {
    return __awaiter(this, void 0, void 0, function*() {
        // 1*1*1000 1s
        // 2*2*1000 4s
        // 3*3*1000 9s
        // 4*4*1000 16s
        // 5*5*1000 25s
        yield new Promise((r)=>setTimeout(r, Math.min(BACKOFF_BASE_MS * (attempt * attempt), BACKOFF_MAX_MS)));
    });
}

},{"b7b53b3bb6ffe2e6":"d5W7z","29a23a4c1e1673f4":"5Y3Ef","ecb6e18a107a073":"jH0ho","2651e07d3cc7fed6":"evNAP","9369166c37b5d3f4":"iQXnn","2fd9c0b9892d34e2":"8kCTX","1f969a4f163e3dd3":"3UrIZ","fcb203a50f0333b2":"1m3HT","fc5634ee1e4f49c1":"5Fh6O","7ae5e5ef538bd4da":"iu1pY","486d61be2d247fa8":"50bPm","4fe8834821311ab":"dJKdX","b3df4191bd9aa1ed":"98Sh7","573df593302ec4db":"dBhOj"}],"iQXnn":[function(require,module,exports,__globalThis) {
"use strict";
var __awaiter = this && this.__awaiter || function(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports._isDomainFailure = exports.NetworkFallbackResolver = void 0;
const DnsTxtQuery_1 = require("85035aee34a8486");
const Hashing_1 = require("6fd2975ce34dbb7a");
const Log_1 = require("4e1f612a80982c30");
const StorageProvider_1 = require("c1b875ef6477bd9d");
const DEFAULT_TTL_MS = 604800000; // 7 days
const COOLDOWN_TIME_MS = 14400000; // 4 hours
class NetworkFallbackResolver {
    setErrorBoundary(errorBoundary) {
        this._errorBoundary = errorBoundary;
    }
    tryBumpExpiryTime(sdkKey, urlConfig) {
        var _a;
        const info = (_a = this._fallbackInfo) === null || _a === void 0 ? void 0 : _a[urlConfig.endpoint];
        if (!info) return;
        info.expiryTime = Date.now() + DEFAULT_TTL_MS;
        _tryWriteFallbackInfoToCache(sdkKey, Object.assign(Object.assign({}, this._fallbackInfo), {
            [urlConfig.endpoint]: info
        }));
    }
    getActiveFallbackUrl(sdkKey, urlConfig) {
        var _a, _b;
        if (urlConfig.customUrl != null && urlConfig.fallbackUrls != null) return null;
        let info = this._fallbackInfo;
        if (info == null) {
            info = (_a = _readFallbackInfoFromCache(sdkKey)) !== null && _a !== void 0 ? _a : {};
            this._fallbackInfo = info;
        }
        const entry = info[urlConfig.endpoint];
        if (!entry || Date.now() > ((_b = entry.expiryTime) !== null && _b !== void 0 ? _b : 0) || urlConfig.getChecksum() !== entry.urlConfigChecksum) {
            delete info[urlConfig.endpoint];
            this._fallbackInfo = info;
            _tryWriteFallbackInfoToCache(sdkKey, this._fallbackInfo);
            return null;
        }
        if (entry.url) return entry.url;
        return null;
    }
    tryFetchUpdatedFallbackInfo(sdkKey, urlConfig, errorMessage, timedOut) {
        return __awaiter(this, void 0, void 0, function*() {
            var _a, _b;
            try {
                if (!_isDomainFailure(errorMessage, timedOut)) return false;
                const canUseNetworkFallbacks = urlConfig.customUrl == null && urlConfig.fallbackUrls == null;
                const urls = canUseNetworkFallbacks ? yield this._tryFetchFallbackUrlsFromNetwork(urlConfig) : urlConfig.fallbackUrls;
                const newUrl = this._pickNewFallbackUrl((_a = this._fallbackInfo) === null || _a === void 0 ? void 0 : _a[urlConfig.endpoint], urls);
                if (!newUrl) return false;
                this._updateFallbackInfoWithNewUrl(sdkKey, urlConfig, newUrl);
                return true;
            } catch (error) {
                (_b = this._errorBoundary) === null || _b === void 0 || _b.logError('tryFetchUpdatedFallbackInfo', error);
                return false;
            }
        });
    }
    _updateFallbackInfoWithNewUrl(sdkKey, urlConfig, newUrl) {
        var _a, _b, _c;
        const newFallbackInfo = {
            urlConfigChecksum: urlConfig.getChecksum(),
            url: newUrl,
            expiryTime: Date.now() + DEFAULT_TTL_MS,
            previous: []
        };
        const endpoint = urlConfig.endpoint;
        const previousInfo = (_a = this._fallbackInfo) === null || _a === void 0 ? void 0 : _a[endpoint];
        if (previousInfo) newFallbackInfo.previous.push(...previousInfo.previous);
        if (newFallbackInfo.previous.length > 10) newFallbackInfo.previous = [];
        const previousUrl = (_c = (_b = this._fallbackInfo) === null || _b === void 0 ? void 0 : _b[endpoint]) === null || _c === void 0 ? void 0 : _c.url;
        if (previousUrl != null) newFallbackInfo.previous.push(previousUrl);
        this._fallbackInfo = Object.assign(Object.assign({}, this._fallbackInfo), {
            [endpoint]: newFallbackInfo
        });
        _tryWriteFallbackInfoToCache(sdkKey, this._fallbackInfo);
    }
    _tryFetchFallbackUrlsFromNetwork(urlConfig) {
        return __awaiter(this, void 0, void 0, function*() {
            var _a;
            const cooldown = this._dnsQueryCooldowns[urlConfig.endpoint];
            if (cooldown && Date.now() < cooldown) return null;
            this._dnsQueryCooldowns[urlConfig.endpoint] = Date.now() + COOLDOWN_TIME_MS;
            const result = [];
            const records = yield (0, DnsTxtQuery_1._fetchTxtRecords)((_a = this._networkOverrideFunc) !== null && _a !== void 0 ? _a : fetch);
            const path = _extractPathFromUrl(urlConfig.defaultUrl);
            for (const record of records){
                if (!record.startsWith(urlConfig.endpointDnsKey + '=')) continue;
                const parts = record.split('=');
                if (parts.length > 1) {
                    let baseUrl = parts[1];
                    if (baseUrl.endsWith('/')) baseUrl = baseUrl.slice(0, -1);
                    result.push(`https://${baseUrl}${path}`);
                }
            }
            return result;
        });
    }
    _pickNewFallbackUrl(currentFallbackInfo, urls) {
        var _a;
        if (urls == null) return null;
        const previouslyUsed = new Set((_a = currentFallbackInfo === null || currentFallbackInfo === void 0 ? void 0 : currentFallbackInfo.previous) !== null && _a !== void 0 ? _a : []);
        const currentFallbackUrl = currentFallbackInfo === null || currentFallbackInfo === void 0 ? void 0 : currentFallbackInfo.url;
        let found = null;
        for (const loopUrl of urls){
            const url = loopUrl.endsWith('/') ? loopUrl.slice(0, -1) : loopUrl;
            if (!previouslyUsed.has(loopUrl) && url !== currentFallbackUrl) {
                found = url;
                break;
            }
        }
        return found;
    }
    constructor(options){
        var _a;
        this._fallbackInfo = null;
        this._errorBoundary = null;
        this._dnsQueryCooldowns = {};
        this._networkOverrideFunc = (_a = options.networkConfig) === null || _a === void 0 ? void 0 : _a.networkOverrideFunc;
    }
}
exports.NetworkFallbackResolver = NetworkFallbackResolver;
function _isDomainFailure(errorMsg, timedOut) {
    var _a;
    const lowerErrorMsg = (_a = errorMsg === null || errorMsg === void 0 ? void 0 : errorMsg.toLowerCase()) !== null && _a !== void 0 ? _a : '';
    return timedOut || lowerErrorMsg.includes('uncaught exception') || lowerErrorMsg.includes('failed to fetch') || lowerErrorMsg.includes('networkerror when attempting to fetch resource');
}
exports._isDomainFailure = _isDomainFailure;
function _getFallbackInfoStorageKey(sdkKey) {
    return `statsig.network_fallback.${(0, Hashing_1._DJB2)(sdkKey)}`;
}
function _tryWriteFallbackInfoToCache(sdkKey, info) {
    const hashKey = _getFallbackInfoStorageKey(sdkKey);
    if (!info || Object.keys(info).length === 0) {
        StorageProvider_1.Storage.removeItem(hashKey);
        return;
    }
    StorageProvider_1.Storage.setItem(hashKey, JSON.stringify(info));
}
function _readFallbackInfoFromCache(sdkKey) {
    const hashKey = _getFallbackInfoStorageKey(sdkKey);
    const data = StorageProvider_1.Storage.getItem(hashKey);
    if (!data) return null;
    try {
        return JSON.parse(data);
    } catch (_a) {
        Log_1.Log.error('Failed to parse FallbackInfo');
        return null;
    }
}
function _extractPathFromUrl(urlString) {
    try {
        const url = new URL(urlString);
        return url.pathname;
    } catch (error) {
        return null;
    }
}

},{"85035aee34a8486":"470Rm","6fd2975ce34dbb7a":"6nhM9","4e1f612a80982c30":"jH0ho","c1b875ef6477bd9d":"8hatk"}],"470Rm":[function(require,module,exports,__globalThis) {
"use strict";
var __awaiter = this && this.__awaiter || function(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports._fetchTxtRecords = void 0;
// See example: https://github.com/statsig-io/private-js-client-monorepo/pull/340
const FEATURE_ASSETS_DNS_QUERY = new Uint8Array([
    0x00,
    0x00,
    0x01,
    0x00,
    0x00,
    0x01,
    0x00,
    0x00,
    0x00,
    0x00,
    0x00,
    0x00,
    0x0d,
    0x66,
    0x65,
    0x61,
    0x74,
    0x75,
    0x72,
    0x65,
    0x61,
    0x73,
    0x73,
    0x65,
    0x74,
    0x73,
    0x03,
    0x6f,
    0x72,
    0x67,
    0x00,
    0x00,
    0x10,
    0x00,
    0x01
]);
const DNS_QUERY_ENDPOINT = 'https://cloudflare-dns.com/dns-query';
const DOMAIN_CHARS = [
    'i',
    'e',
    'd'
];
const MAX_START_LOOKUP = 200;
function _fetchTxtRecords(networkFunc) {
    return __awaiter(this, void 0, void 0, function*() {
        const response = yield networkFunc(DNS_QUERY_ENDPOINT, {
            method: 'POST',
            headers: {
                'Content-Type': 'application/dns-message',
                Accept: 'application/dns-message'
            },
            body: FEATURE_ASSETS_DNS_QUERY
        });
        if (!response.ok) {
            const err = new Error('Failed to fetch TXT records from DNS');
            err.name = 'DnsTxtFetchError';
            throw err;
        }
        const data = yield response.arrayBuffer();
        const bytes = new Uint8Array(data);
        return _parseDnsResponse(bytes);
    });
}
exports._fetchTxtRecords = _fetchTxtRecords;
function _parseDnsResponse(input) {
    // loop until we find the first valid domain char. One of [i=, e=, d=]
    const start = input.findIndex((byte, index)=>index < MAX_START_LOOKUP && String.fromCharCode(byte) === '=' && DOMAIN_CHARS.includes(String.fromCharCode(input[index - 1])));
    if (start === -1) {
        const err = new Error('Failed to parse TXT records from DNS');
        err.name = 'DnsTxtParseError';
        throw err;
    }
    // decode the remaining bytes as a string
    let result = '';
    for(let i = start - 1; i < input.length; i++)result += String.fromCharCode(input[i]);
    return result.split(',');
}

},{}],"8kCTX":[function(require,module,exports,__globalThis) {
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.SDKFlags = void 0;
const FLAGMAP = {};
exports.SDKFlags = {
    setFlags: (sdkKey, flags)=>{
        FLAGMAP[sdkKey] = flags;
    },
    get: (sdkKey, flagKey)=>{
        var _a, _b;
        return (_b = (_a = FLAGMAP[sdkKey]) === null || _a === void 0 ? void 0 : _a[flagKey]) !== null && _b !== void 0 ? _b : false;
    }
};

},{}],"5Fh6O":[function(require,module,exports,__globalThis) {
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.StatsigSession = exports.SessionID = void 0;
const __StatsigGlobal_1 = require("2e15ad46479f9adb");
const CacheKey_1 = require("f9bc1081c1379dc3");
const Log_1 = require("d0069d161455255");
const StorageProvider_1 = require("82c98556216f5032");
const UUID_1 = require("9d82e76f0a309c52");
const MAX_SESSION_IDLE_TIME = 1800000; // 30 minutes
const MAX_SESSION_AGE = 14400000; // 4 hours
const PROMISE_MAP = {};
exports.SessionID = {
    get: (sdkKey)=>{
        return exports.StatsigSession.get(sdkKey).data.sessionID;
    }
};
exports.StatsigSession = {
    get: (sdkKey)=>{
        if (PROMISE_MAP[sdkKey] == null) PROMISE_MAP[sdkKey] = _loadSession(sdkKey);
        const session = PROMISE_MAP[sdkKey];
        return _bumpSession(session);
    },
    overrideInitialSessionID: (override, sdkKey)=>{
        PROMISE_MAP[sdkKey] = _overrideSessionId(override, sdkKey);
    }
};
function _loadSession(sdkKey) {
    let data = _loadFromStorage(sdkKey);
    const now = Date.now();
    if (!data) data = {
        sessionID: (0, UUID_1.getUUID)(),
        startTime: now,
        lastUpdate: now
    };
    return {
        data,
        sdkKey
    };
}
function _overrideSessionId(override, sdkKey) {
    const now = Date.now();
    return {
        data: {
            sessionID: override,
            startTime: now,
            lastUpdate: now
        },
        sdkKey
    };
}
function _bumpSession(session) {
    const now = Date.now();
    const data = session.data;
    const sdkKey = session.sdkKey;
    if (_isIdle(data) || _hasRunTooLong(data)) {
        data.sessionID = (0, UUID_1.getUUID)();
        data.startTime = now;
        const client = __STATSIG__ === null || __STATSIG__ === void 0 ? void 0 : __STATSIG__.instance(sdkKey);
        if (client) client.$emt({
            name: 'session_expired'
        });
    }
    data.lastUpdate = now;
    _persistToStorage(data, session.sdkKey);
    clearTimeout(session.idleTimeoutID);
    clearTimeout(session.ageTimeoutID);
    const lifetime = now - data.startTime;
    session.idleTimeoutID = _createSessionTimeout(sdkKey, MAX_SESSION_IDLE_TIME);
    session.ageTimeoutID = _createSessionTimeout(sdkKey, MAX_SESSION_AGE - lifetime);
    return session;
}
function _createSessionTimeout(sdkKey, duration) {
    return setTimeout(()=>{
        var _a;
        const client = (_a = (0, __StatsigGlobal_1._getStatsigGlobal)()) === null || _a === void 0 ? void 0 : _a.instance(sdkKey);
        if (client) client.$emt({
            name: 'session_expired'
        });
    }, duration);
}
function _isIdle({ lastUpdate }) {
    return Date.now() - lastUpdate > MAX_SESSION_IDLE_TIME;
}
function _hasRunTooLong({ startTime }) {
    return Date.now() - startTime > MAX_SESSION_AGE;
}
function _getSessionIDStorageKey(sdkKey) {
    return `statsig.session_id.${(0, CacheKey_1._getStorageKey)(sdkKey)}`;
}
function _persistToStorage(session, sdkKey) {
    const storageKey = _getSessionIDStorageKey(sdkKey);
    try {
        (0, StorageProvider_1._setObjectInStorage)(storageKey, session);
    } catch (e) {
        Log_1.Log.warn('Failed to save SessionID');
    }
}
function _loadFromStorage(sdkKey) {
    const storageKey = _getSessionIDStorageKey(sdkKey);
    return (0, StorageProvider_1._getObjectFromStorage)(storageKey);
}

},{"2e15ad46479f9adb":"d5W7z","f9bc1081c1379dc3":"eqWfV","d0069d161455255":"jH0ho","82c98556216f5032":"8hatk","9d82e76f0a309c52":"h64IW"}],"50bPm":[function(require,module,exports,__globalThis) {
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.ErrorTag = void 0;
exports.ErrorTag = {
    NetworkError: 'NetworkError'
};

},{}],"jjzMX":[function(require,module,exports,__globalThis) {
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});

},{}],"kaTYM":[function(require,module,exports,__globalThis) {
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});

},{}],"htdWS":[function(require,module,exports,__globalThis) {
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports._fastApproxSizeOf = void 0;
const CURLY_AND_SQUARE_BRACKET_SIZE = 2; // [] for array, {} for object
const APPROX_ADDITIONAL_SIZE = 1; // additional size for comma and stuff
const _fastApproxSizeOf = (obj, max)=>{
    let size = 0;
    const keys = Object.keys(obj);
    for(let i = 0; i < keys.length; i++){
        const key = keys[i];
        const value = obj[key];
        size += key.length;
        if (typeof value === 'object' && value !== null) size += (0, exports._fastApproxSizeOf)(value, max) + CURLY_AND_SQUARE_BRACKET_SIZE;
        else size += String(value).length + APPROX_ADDITIONAL_SIZE;
        if (size >= max) // exit early if we've exceeded the max
        return size;
    }
    return size;
};
exports._fastApproxSizeOf = _fastApproxSizeOf;

},{}],"4DqMB":[function(require,module,exports,__globalThis) {
"use strict";
var __awaiter = this && this.__awaiter || function(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.StatsigClientBase = void 0;
require("c44f8fb3e5374534");
const __StatsigGlobal_1 = require("c44f8fb3e5374534");
const ErrorBoundary_1 = require("4da963955a257fa");
const EventLogger_1 = require("ef8da0094bd51dc6");
const Log_1 = require("135543c111a3beb5");
const MemoKey_1 = require("f3b558c0272910d3");
const SafeJs_1 = require("6eafc79afdbf2226");
const SessionID_1 = require("ba8c260cf5e23799");
const StableID_1 = require("a2f791897100df48");
const StatsigOptionsCommon_1 = require("58a0825917d8f3bf");
const StorageProvider_1 = require("650b86707dd4a4b4");
const MAX_MEMO_CACHE_SIZE = 3000;
class StatsigClientBase {
    /**
     * Updates runtime configuration options for the SDK, allowing toggling of certain behaviors such as logging and storage to comply with user preferences or regulations such as GDPR.
     *
     * @param {StatsigRuntimeMutableOptions} options - The configuration options that dictate the runtime behavior of the SDK.
     */ updateRuntimeOptions(options) {
        if (options.loggingEnabled) {
            this._options.loggingEnabled = options.loggingEnabled;
            this._logger.setLoggingEnabled(options.loggingEnabled);
        } else if (options.disableLogging != null) {
            this._options.disableLogging = options.disableLogging;
            this._logger.setLoggingEnabled(options.disableLogging ? 'disabled' : 'browser-only');
        }
        if (options.disableStorage != null) {
            this._options.disableStorage = options.disableStorage;
            StorageProvider_1.Storage._setDisabled(options.disableStorage);
        }
        if (options.enableCookies != null) {
            this._options.enableCookies = options.enableCookies;
            StableID_1.StableID._setCookiesEnabled(this._sdkKey, options.enableCookies);
        }
        if (options.logEventCompressionMode) this._logger.setLogEventCompressionMode(options.logEventCompressionMode);
        else if (options.disableCompression) this._logger.setLogEventCompressionMode(StatsigOptionsCommon_1.LogEventCompressionMode.Disabled);
    }
    /**
     * Flushes any currently queued events.
     */ flush() {
        return this._logger.flush();
    }
    /**
     * Gracefully shuts down the SDK, ensuring that all pending events are send before the SDK stops.
     * This function emits a 'pre_shutdown' event and then waits for the logger to complete its shutdown process.
     *
     * @returns {Promise<void>} A promise that resolves when all shutdown procedures, including logging shutdown, have been completed.
     */ shutdown() {
        return __awaiter(this, void 0, void 0, function*() {
            this.$emt({
                name: 'pre_shutdown'
            });
            this._setStatus('Uninitialized', null);
            this._initializePromise = null;
            yield this._logger.stop();
        });
    }
    /**
     * Subscribes a callback function to a specific {@link StatsigClientEvent} or all StatsigClientEvents if the wildcard '*' is used.
     * Once subscribed, the listener callback will be invoked whenever the specified event is emitted.
     *
     * @param {StatsigClientEventName} event - The name of the event to subscribe to, or '*' to subscribe to all events.
     * @param {StatsigClientEventCallback<T>} listener - The callback function to execute when the event occurs. The function receives event-specific data as its parameter.
     * @see {@link off} for unsubscribing from events.
     */ on(event, listener) {
        if (!this._listeners[event]) this._listeners[event] = [];
        this._listeners[event].push(listener);
    }
    /**
     * Unsubscribes a previously registered callback function from a specific {@link StatsigClientEvent} or all StatsigClientEvents if the wildcard '*' is used.
     *
     * @param {StatsigClientEventName} event - The name of the event from which to unsubscribe, or '*' to unsubscribe from all events.
     * @param {StatsigClientEventCallback<T>} listener - The callback function to remove from the event's notification list.
     * @see {@link on} for subscribing to events.
     */ off(event, listener) {
        if (this._listeners[event]) {
            const index = this._listeners[event].indexOf(listener);
            if (index !== -1) this._listeners[event].splice(index, 1);
        }
    }
    $on(event, listener) {
        listener.__isInternal = true;
        this.on(event, listener);
    }
    $emt(event) {
        var _a;
        const barrier = (listener)=>{
            try {
                listener(event);
            } catch (error) {
                if (listener.__isInternal === true) {
                    this._errorBoundary.logError(`__emit:${event.name}`, error);
                    return;
                }
                Log_1.Log.error(`An error occurred in a StatsigClientEvent listener. This is not an issue with Statsig.`, event);
            }
        };
        if (this._listeners[event.name]) this._listeners[event.name].forEach((l)=>barrier(l));
        (_a = this._listeners['*']) === null || _a === void 0 || _a.forEach(barrier);
    }
    _setStatus(newStatus, values) {
        this.loadingStatus = newStatus;
        this._memoCache = {};
        this.$emt({
            name: 'values_updated',
            status: newStatus,
            values
        });
    }
    _enqueueExposure(name, exposure, options) {
        if ((options === null || options === void 0 ? void 0 : options.disableExposureLog) === true) {
            this._logger.incrementNonExposureCount(name);
            return;
        }
        this._logger.enqueue(exposure);
    }
    _memoize(prefix, fn) {
        return (name, options)=>{
            if (this._options.disableEvaluationMemoization) return fn(name, options);
            const memoKey = (0, MemoKey_1.createMemoKey)(prefix, name, options);
            if (!memoKey) return fn(name, options);
            if (!(memoKey in this._memoCache)) {
                if (Object.keys(this._memoCache).length >= MAX_MEMO_CACHE_SIZE) this._memoCache = {};
                this._memoCache[memoKey] = fn(name, options);
            }
            return this._memoCache[memoKey];
        };
    }
    constructor(sdkKey, adapter, network, options){
        var _a, _b, _c, _d;
        this.loadingStatus = 'Uninitialized';
        this._initializePromise = null;
        this._listeners = {};
        const emitter = this.$emt.bind(this);
        (options === null || options === void 0 ? void 0 : options.logLevel) != null && (Log_1.Log.level = options.logLevel);
        (options === null || options === void 0 ? void 0 : options.disableStorage) && StorageProvider_1.Storage._setDisabled(true);
        (options === null || options === void 0 ? void 0 : options.initialSessionID) && SessionID_1.StatsigSession.overrideInitialSessionID(options.initialSessionID, sdkKey);
        (options === null || options === void 0 ? void 0 : options.storageProvider) && StorageProvider_1.Storage._setProvider(options.storageProvider);
        (options === null || options === void 0 ? void 0 : options.enableCookies) && StableID_1.StableID._setCookiesEnabled(sdkKey, options.enableCookies);
        (options === null || options === void 0 ? void 0 : options.disableStableID) && StableID_1.StableID._setDisabled(sdkKey, true);
        this._sdkKey = sdkKey;
        this._options = options !== null && options !== void 0 ? options : {};
        this._memoCache = {};
        this.overrideAdapter = (_a = options === null || options === void 0 ? void 0 : options.overrideAdapter) !== null && _a !== void 0 ? _a : null;
        this._logger = new EventLogger_1.EventLogger(sdkKey, emitter, network, options);
        this._errorBoundary = new ErrorBoundary_1.ErrorBoundary(sdkKey, options, emitter);
        this._errorBoundary.wrap(this);
        this._errorBoundary.wrap(adapter);
        this._errorBoundary.wrap(this._logger);
        network.setErrorBoundary(this._errorBoundary);
        this.dataAdapter = adapter;
        this.dataAdapter.attach(sdkKey, options, network);
        this.storageProvider = StorageProvider_1.Storage;
        (_d = (_c = (_b = this.overrideAdapter) === null || _b === void 0 ? void 0 : _b.loadFromStorage) === null || _c === void 0 ? void 0 : _c.call(_b)) === null || _d === void 0 || _d.catch((e)=>this._errorBoundary.logError('OA::loadFromStorage', e));
        this._primeReadyRipcord();
        _assignGlobalInstance(sdkKey, this);
    }
}
exports.StatsigClientBase = StatsigClientBase;
function _assignGlobalInstance(sdkKey, client) {
    var _a;
    if ((0, SafeJs_1._isServerEnv)()) return;
    const statsigGlobal = (0, __StatsigGlobal_1._getStatsigGlobal)();
    const instances = (_a = statsigGlobal.instances) !== null && _a !== void 0 ? _a : {};
    const inst = client;
    if (instances[sdkKey] != null) Log_1.Log.warn('Creating multiple Statsig clients with the same SDK key can lead to unexpected behavior. Multi-instance support requires different SDK keys.');
    instances[sdkKey] = inst;
    if (!statsigGlobal.firstInstance) statsigGlobal.firstInstance = inst;
    statsigGlobal.instances = instances;
    __STATSIG__ = statsigGlobal;
}

},{"c44f8fb3e5374534":"d5W7z","4da963955a257fa":"jvCQP","ef8da0094bd51dc6":"506Fu","135543c111a3beb5":"jH0ho","f3b558c0272910d3":"4FvMU","6eafc79afdbf2226":"1m3HT","ba8c260cf5e23799":"5Fh6O","a2f791897100df48":"iu1pY","58a0825917d8f3bf":"98Sh7","650b86707dd4a4b4":"8hatk"}],"iA4hx":[function(require,module,exports,__globalThis) {
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.DataAdapterCachePrefix = void 0;
exports.DataAdapterCachePrefix = 'statsig.cached';

},{}],"g4gRv":[function(require,module,exports,__globalThis) {
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});

},{}],"egpWn":[function(require,module,exports,__globalThis) {
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports._makeTypedGet = exports._mergeOverride = exports._makeLayer = exports._makeExperiment = exports._makeDynamicConfig = exports._makeFeatureGate = void 0;
const Log_1 = require("c99fc0324dc84901");
const TypingUtils_1 = require("86326d1a0c805af4");
function _makeEvaluation(name, details, evaluation, value) {
    var _a;
    return {
        name,
        details,
        ruleID: (_a = evaluation === null || evaluation === void 0 ? void 0 : evaluation.rule_id) !== null && _a !== void 0 ? _a : '',
        __evaluation: evaluation,
        value
    };
}
function _makeFeatureGate(name, details, evaluation) {
    var _a;
    return Object.assign(Object.assign({}, _makeEvaluation(name, details, evaluation, (evaluation === null || evaluation === void 0 ? void 0 : evaluation.value) === true)), {
        idType: (_a = evaluation === null || evaluation === void 0 ? void 0 : evaluation.id_type) !== null && _a !== void 0 ? _a : null
    });
}
exports._makeFeatureGate = _makeFeatureGate;
function _makeDynamicConfig(name, details, evaluation) {
    var _a, _b;
    const value = (_a = evaluation === null || evaluation === void 0 ? void 0 : evaluation.value) !== null && _a !== void 0 ? _a : {};
    return Object.assign(Object.assign({}, _makeEvaluation(name, details, evaluation, value)), {
        idType: (_b = evaluation === null || evaluation === void 0 ? void 0 : evaluation.id_type) !== null && _b !== void 0 ? _b : null,
        get: _makeTypedGet(name, evaluation === null || evaluation === void 0 ? void 0 : evaluation.value)
    });
}
exports._makeDynamicConfig = _makeDynamicConfig;
function _makeExperiment(name, details, evaluation) {
    var _a;
    const result = _makeDynamicConfig(name, details, evaluation);
    return Object.assign(Object.assign({}, result), {
        groupName: (_a = evaluation === null || evaluation === void 0 ? void 0 : evaluation.group_name) !== null && _a !== void 0 ? _a : null
    });
}
exports._makeExperiment = _makeExperiment;
function _makeLayer(name, details, evaluation, exposeFunc) {
    var _a, _b;
    return Object.assign(Object.assign({}, _makeEvaluation(name, details, evaluation, undefined)), {
        get: _makeTypedGet(name, evaluation === null || evaluation === void 0 ? void 0 : evaluation.value, exposeFunc),
        groupName: (_a = evaluation === null || evaluation === void 0 ? void 0 : evaluation.group_name) !== null && _a !== void 0 ? _a : null,
        __value: (_b = evaluation === null || evaluation === void 0 ? void 0 : evaluation.value) !== null && _b !== void 0 ? _b : {}
    });
}
exports._makeLayer = _makeLayer;
function _mergeOverride(original, overridden, value, exposeFunc) {
    return Object.assign(Object.assign(Object.assign({}, original), overridden), {
        get: _makeTypedGet(original.name, value, exposeFunc)
    });
}
exports._mergeOverride = _mergeOverride;
function _makeTypedGet(name, value, exposeFunc) {
    return (param, fallback)=>{
        var _a;
        const found = (_a = value === null || value === void 0 ? void 0 : value[param]) !== null && _a !== void 0 ? _a : null;
        if (found == null) return fallback !== null && fallback !== void 0 ? fallback : null;
        if (fallback != null && !(0, TypingUtils_1._isTypeMatch)(found, fallback)) {
            Log_1.Log.warn(`Parameter type mismatch. '${name}.${param}' was found to be type '${typeof found}' but fallback/return type is '${typeof fallback}'. See https://docs.statsig.com/client/javascript-sdk/#typed-getters`);
            return fallback !== null && fallback !== void 0 ? fallback : null;
        }
        exposeFunc === null || exposeFunc === void 0 || exposeFunc(param);
        return found;
    };
}
exports._makeTypedGet = _makeTypedGet;

},{"c99fc0324dc84901":"jH0ho","86326d1a0c805af4":"4UasP"}],"6UaT7":[function(require,module,exports,__globalThis) {
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});

},{}],"l6Jw0":[function(require,module,exports,__globalThis) {
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.UPDATE_DETAIL_ERROR_MESSAGES = exports.createUpdateDetails = void 0;
const createUpdateDetails = (success, source, initDuration, error, sourceUrl, warnings)=>{
    return {
        duration: initDuration,
        source,
        success,
        error,
        sourceUrl,
        warnings
    };
};
exports.createUpdateDetails = createUpdateDetails;
exports.UPDATE_DETAIL_ERROR_MESSAGES = {
    NO_NETWORK_DATA: 'No data was returned from the network. This may be due to a network timeout if a timeout value was specified in the options or ad blocker error.'
};

},{}],"ccWNs":[function(require,module,exports,__globalThis) {
"use strict";
var __awaiter = this && this.__awaiter || function(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(exports, "__esModule", {
    value: true
});
const client_core_1 = require("e0761d782e417a7b");
const EvaluationStore_1 = require("bb4d2d3cd4d58603");
const Network_1 = require("df3cb964060f8da9");
const ParamStoreGetterFactory_1 = require("3896ed2557d65a15");
const StatsigEvaluationsDataAdapter_1 = require("ccd804bf92a192aa");
class StatsigClient extends client_core_1.StatsigClientBase {
    /**
     * Retrieves an instance of the StatsigClient based on the provided SDK key.
     *  If no SDK key is provided, the method returns the most recently created instance of the StatsigClient.
     *  The method ensures that each unique SDK key corresponds to a single instance of StatsigClient, effectively implementing a singleton pattern for each key.
     *  If no instance exists for the given SDK key, a new StatsigClient instance will be created and returned.
     *
     * @param {string} [sdkKey] - Optional. The SDK key used to identify a specific instance of the StatsigClient. If omitted, the method returns the last created instance.
     * @returns {StatsigClient} Returns the StatsigClient instance associated with the given SDK key, creating a new one if needed.
     */ static instance(sdkKey) {
        const instance = (0, client_core_1._getStatsigGlobal)().instance(sdkKey);
        if (instance instanceof StatsigClient) return instance;
        client_core_1.Log.warn((0, client_core_1._isServerEnv)() ? 'StatsigClient.instance is not supported in server environments' : 'Unable to find StatsigClient instance');
        return new StatsigClient(sdkKey !== null && sdkKey !== void 0 ? sdkKey : '', {});
    }
    /**
     * Initializes the StatsigClient using cached values. This method sets up the client synchronously by utilizing previously cached values.
     * After initialization, cache values are updated in the background for future use, either in subsequent sessions or when `updateUser` is called.
     * This is useful for quickly starting with the last-known-good configurations while refreshing data to keep settings up-to-date.
     *
     * @see {@link initializeAsync} for the asynchronous version of this method.
     */ initializeSync(options) {
        var _a;
        if (this.loadingStatus !== 'Uninitialized') return (0, client_core_1.createUpdateDetails)(true, this._store.getSource(), -1, null, null, [
            'MultipleInitializations',
            ...(_a = this._store.getWarnings()) !== null && _a !== void 0 ? _a : []
        ]);
        this._logger.start();
        return this.updateUserSync(this._user, options);
    }
    /**
     * Initializes the StatsigClient asynchronously by first using cached values and then updating to the latest values from the network.
     * Once the network values are fetched, they replace the existing cached values. If this method's promise is not awaited,
     * there might be a transition from cached to network values during the session, which can affect consistency.
     * This method is useful when it's acceptable to begin with potentially stale data and switch to the latest configuration as it becomes available.
     *
     * @param {AsyncUpdateOptions} [options] - Optional. Additional options to customize the method call.
     * @returns {Promise<void>} A promise that resolves once the client is fully initialized with the latest values from the network or a timeout (if set) is hit.
     * @see {@link initializeSync} for the synchronous version of this method.
     */ initializeAsync(options) {
        return __awaiter(this, void 0, void 0, function*() {
            if (this._initializePromise) return this._initializePromise;
            this._initializePromise = this._initializeAsyncImpl(options);
            return this._initializePromise;
        });
    }
    /**
     * Synchronously updates the user in the Statsig client and switches the internal state to use cached values for the newly specified user.
     * After the initial switch to cached values, this method updates these values in the background, preparing them for future sessions or subsequent calls to updateUser.
     * This method ensures the client is quickly ready with available data.
     *
     * @param {StatsigUser} user - The new StatsigUser for which the client should update its internal state.
     * @see {@link updateUserAsync} for the asynchronous version of this method.
     */ updateUserSync(user, options) {
        const startTime = performance.now();
        try {
            return this._updateUserSyncImpl(user, options, startTime);
        } catch (e) {
            const err = e instanceof Error ? e : new Error(String(e));
            return this._createErrorUpdateDetails(err, startTime);
        }
    }
    _updateUserSyncImpl(user, options, startTime) {
        var _a;
        const warnings = [
            ...(_a = this._store.getWarnings()) !== null && _a !== void 0 ? _a : []
        ];
        this._resetForUser(user);
        const result = this.dataAdapter.getDataSync(this._user);
        if (result == null) warnings.push('NoCachedValues');
        this._store.setValues(result, this._user);
        this._finalizeUpdate(result);
        const disable = options === null || options === void 0 ? void 0 : options.disableBackgroundCacheRefresh;
        if (disable === true || disable == null && (result === null || result === void 0 ? void 0 : result.source) === 'Bootstrap') return (0, client_core_1.createUpdateDetails)(true, this._store.getSource(), performance.now() - startTime, this._errorBoundary.getLastSeenErrorAndReset(), this._network.getLastUsedInitUrlAndReset(), warnings);
        this._runPostUpdate(result !== null && result !== void 0 ? result : null, this._user);
        return (0, client_core_1.createUpdateDetails)(true, this._store.getSource(), performance.now() - startTime, this._errorBoundary.getLastSeenErrorAndReset(), this._network.getLastUsedInitUrlAndReset(), warnings);
    }
    /**
     * Asynchronously updates the user in the Statsig client by initially using cached values and then fetching the latest values from the network.
     * When the latest values are fetched, they replace the cached values. If the promise returned by this method is not awaited,
     * the client's state may shift from cached to updated network values during the session, potentially affecting consistency.
     * This method is best used in scenarios where up-to-date configuration is critical and initial delays are acceptable.
     *
     * @param {StatsigUser} user - The new StatsigUser for which the client should update its internal state.
     * @param {AsyncUpdateOptions} [options] - Optional. Additional options to customize the method call.
     * @returns {Promise<void>} A promise that resolves once the client is fully updated with the latest values from the network or a timeout (if set) is hit.
     * @see {@link updateUserSync} for the synchronous version of this method.
     */ updateUserAsync(user, options) {
        return __awaiter(this, void 0, void 0, function*() {
            const startTime = performance.now();
            try {
                return yield this._updateUserAsyncImpl(user, options);
            } catch (e) {
                const err = e instanceof Error ? e : new Error(String(e));
                return this._createErrorUpdateDetails(err, startTime);
            }
        });
    }
    _updateUserAsyncImpl(user, options) {
        return __awaiter(this, void 0, void 0, function*() {
            this._resetForUser(user);
            const initiator = this._user;
            client_core_1.Diagnostics._markInitOverallStart(this._sdkKey);
            let result = this.dataAdapter.getDataSync(initiator);
            this._store.setValues(result, this._user);
            this._setStatus('Loading', result);
            result = yield this.dataAdapter.getDataAsync(result, initiator, options);
            // ensure the user hasn't changed while we were waiting
            if (initiator !== this._user) return (0, client_core_1.createUpdateDetails)(false, this._store.getSource(), -1, new Error('User changed during update'), this._network.getLastUsedInitUrlAndReset());
            let isUsingNetworkValues = false;
            if (result != null) {
                client_core_1.Diagnostics._markInitProcessStart(this._sdkKey);
                isUsingNetworkValues = this._store.setValues(result, this._user);
                client_core_1.Diagnostics._markInitProcessEnd(this._sdkKey, {
                    success: isUsingNetworkValues
                });
            }
            this._finalizeUpdate(result);
            if (!isUsingNetworkValues) {
                this._errorBoundary.attachErrorIfNoneExists(client_core_1.UPDATE_DETAIL_ERROR_MESSAGES.NO_NETWORK_DATA);
                this.$emt({
                    name: 'initialization_failure'
                });
            }
            client_core_1.Diagnostics._markInitOverallEnd(this._sdkKey, isUsingNetworkValues, this._store.getCurrentSourceDetails());
            const initDuration = client_core_1.Diagnostics._enqueueDiagnosticsEvent(this._user, this._logger, this._sdkKey, this._options);
            return (0, client_core_1.createUpdateDetails)(isUsingNetworkValues, this._store.getSource(), initDuration, this._errorBoundary.getLastSeenErrorAndReset(), this._network.getLastUsedInitUrlAndReset(), this._store.getWarnings());
        });
    }
    /**
     * Retrieves a synchronous context containing data currently being used by the SDK. Represented as a {@link PrecomputedEvaluationsContext} object.
     *
     * @returns {PrecomputedEvaluationsContext} The current synchronous context for the this StatsigClient instance.
     */ getContext() {
        let user = {};
        try {
            user = JSON.parse(JSON.stringify(this._user));
        } catch (_a) {
            client_core_1.Log.error('Failed to parse user');
        }
        return {
            sdkKey: this._sdkKey,
            options: this._options,
            values: this._store.getValues(),
            user,
            errorBoundary: this._errorBoundary,
            session: client_core_1.StatsigSession.get(this._sdkKey),
            stableID: client_core_1.StableID.get(this._sdkKey),
            sdkInstanceID: this._sdkInstanceID
        };
    }
    /**
     * Retrieves the value of a feature gate for the current user, represented as a simple boolean.
     *
     * @param {string} name - The name of the feature gate to retrieve.
     * @param {FeatureGateEvaluationOptions} [options] - Optional. Additional options to customize the method call.
     * @returns {boolean} - The boolean value representing the gate's current evaluation results for the user.
     */ checkGate(name, options) {
        return this.getFeatureGate(name, options).value;
    }
    /**
     * Logs an event to the internal logging system. This function allows logging by either passing a fully formed event object or by specifying the event name with optional value and metadata.
     *
     * @param {StatsigEvent|string} eventOrName - The event object conforming to the StatsigEvent interface, or the name of the event as a string.
     * @param {string|number} value - Optional. The value associated with the event, which can be a string or a number. This parameter is ignored if the first parameter is a StatsigEvent object.
     * @param {Record<string, string>} metadata - Optional. A key-value record containing metadata about the event. This is also ignored if the first parameter is an event object.
     */ logEvent(eventOrName, value, metadata) {
        const event = typeof eventOrName === 'string' ? {
            eventName: eventOrName,
            value,
            metadata
        } : eventOrName;
        this.$emt({
            name: 'log_event_called',
            event
        });
        this._logger.enqueue(Object.assign(Object.assign({}, event), {
            user: this._user,
            time: Date.now()
        }));
    }
    /**
     * Updates the user with analytics only metadata. This will override any existing analytics only metadata.
     *
     * @param {Record<string, string | number | boolean>} metadata - The metadata to add to the user.
     */ updateUserWithAnalyticsOnlyMetadata(metadata) {
        this._user = this._configureUser(Object.assign(Object.assign({}, this._user), {
            analyticsOnlyMetadata: metadata
        }), this._options);
    }
    _primeReadyRipcord() {
        this.$on('error', ()=>{
            this.loadingStatus === 'Loading' && this._finalizeUpdate(null);
        });
    }
    _initializeAsyncImpl(options) {
        return __awaiter(this, void 0, void 0, function*() {
            if (!client_core_1.Storage.isReady()) yield client_core_1.Storage.isReadyResolver();
            this._logger.start();
            return this.updateUserAsync(this._user, options);
        });
    }
    _createErrorUpdateDetails(error, startTime) {
        var _a;
        return (0, client_core_1.createUpdateDetails)(false, this._store.getSource(), performance.now() - startTime, error, null, [
            ...(_a = this._store.getWarnings()) !== null && _a !== void 0 ? _a : []
        ]);
    }
    _finalizeUpdate(values) {
        this._store.finalize();
        this._setStatus('Ready', values);
    }
    _runPostUpdate(current, user) {
        this.dataAdapter.getDataAsync(current, user, {
            priority: 'low'
        }).catch((err)=>{
            client_core_1.Log.error('An error occurred after update.', err);
        });
    }
    _resetForUser(user) {
        this._logger.reset();
        this._store.reset();
        this._user = this._configureUser(user, this._options);
    }
    _configureUser(originalUser, options) {
        var _a, _b, _c;
        const user = (0, client_core_1._normalizeUser)(originalUser, options);
        const stableIdOverride = (_a = user.customIDs) === null || _a === void 0 ? void 0 : _a.stableID;
        if (stableIdOverride) {
            const readyPromise = (_c = (_b = this.storageProvider).isReadyResolver) === null || _c === void 0 ? void 0 : _c.call(_b);
            if (readyPromise) readyPromise.then(()=>client_core_1.StableID.setOverride(stableIdOverride, this._sdkKey), ()=>client_core_1.StableID.setOverride(stableIdOverride, this._sdkKey));
            else client_core_1.StableID.setOverride(stableIdOverride, this._sdkKey);
        }
        // Only attach first touch metadata if it's not empty
        if (Object.keys(this._possibleFirstTouchMetadata).length > 0) user.analyticsOnlyMetadata = Object.assign(Object.assign({}, user.analyticsOnlyMetadata), this._possibleFirstTouchMetadata);
        return user;
    }
    _getFeatureGateImpl(name, options) {
        var _a, _b;
        const { result: evaluation, details } = this._store.getGate(name);
        const gate = (0, client_core_1._makeFeatureGate)(name, details, evaluation);
        const overridden = (_b = (_a = this.overrideAdapter) === null || _a === void 0 ? void 0 : _a.getGateOverride) === null || _b === void 0 ? void 0 : _b.call(_a, gate, this._user, options);
        const result = overridden !== null && overridden !== void 0 ? overridden : gate;
        this._enqueueExposure(name, (0, client_core_1._createGateExposure)(this._user, result, this._store.getExposureMapping()), options);
        this.$emt({
            name: 'gate_evaluation',
            gate: result
        });
        return result;
    }
    _getDynamicConfigImpl(name, options) {
        var _a, _b;
        const { result: evaluation, details } = this._store.getConfig(name);
        const config = (0, client_core_1._makeDynamicConfig)(name, details, evaluation);
        const overridden = (_b = (_a = this.overrideAdapter) === null || _a === void 0 ? void 0 : _a.getDynamicConfigOverride) === null || _b === void 0 ? void 0 : _b.call(_a, config, this._user, options);
        const result = overridden !== null && overridden !== void 0 ? overridden : config;
        this._enqueueExposure(name, (0, client_core_1._createConfigExposure)(this._user, result, this._store.getExposureMapping()), options);
        this.$emt({
            name: 'dynamic_config_evaluation',
            dynamicConfig: result
        });
        return result;
    }
    _getExperimentImpl(name, options) {
        var _a, _b, _c, _d;
        const { result: evaluation, details } = this._store.getConfig(name);
        const experiment = (0, client_core_1._makeExperiment)(name, details, evaluation);
        if (experiment.__evaluation != null) experiment.__evaluation.secondary_exposures = (0, client_core_1._mapExposures)((_b = (_a = experiment.__evaluation) === null || _a === void 0 ? void 0 : _a.secondary_exposures) !== null && _b !== void 0 ? _b : [], this._store.getExposureMapping());
        const overridden = (_d = (_c = this.overrideAdapter) === null || _c === void 0 ? void 0 : _c.getExperimentOverride) === null || _d === void 0 ? void 0 : _d.call(_c, experiment, this._user, options);
        const result = overridden !== null && overridden !== void 0 ? overridden : experiment;
        this._enqueueExposure(name, (0, client_core_1._createConfigExposure)(this._user, result, this._store.getExposureMapping()), options);
        this.$emt({
            name: 'experiment_evaluation',
            experiment: result
        });
        return result;
    }
    _getConfigListImpl() {
        return this._store.getConfigList();
    }
    _getLayerImpl(name, options) {
        var _a, _b, _c;
        const { result: evaluation, details } = this._store.getLayer(name);
        const layer = (0, client_core_1._makeLayer)(name, details, evaluation);
        const overridden = (_b = (_a = this.overrideAdapter) === null || _a === void 0 ? void 0 : _a.getLayerOverride) === null || _b === void 0 ? void 0 : _b.call(_a, layer, this._user, options);
        if (options === null || options === void 0 ? void 0 : options.disableExposureLog) this._logger.incrementNonExposureCount(name);
        const result = (0, client_core_1._mergeOverride)(layer, overridden, (_c = overridden === null || overridden === void 0 ? void 0 : overridden.__value) !== null && _c !== void 0 ? _c : layer.__value, (param)=>{
            if (options === null || options === void 0 ? void 0 : options.disableExposureLog) return;
            this._enqueueExposure(name, (0, client_core_1._createLayerParameterExposure)(this._user, result, param, this._store.getExposureMapping()), options);
        });
        this.$emt({
            name: 'layer_evaluation',
            layer: result
        });
        return result;
    }
    _getParameterStoreImpl(name, options) {
        var _a, _b;
        const { result: configuration, details } = this._store.getParamStore(name);
        this._logger.incrementNonExposureCount(name);
        const paramStore = {
            name,
            details: details,
            __configuration: configuration,
            get: (0, ParamStoreGetterFactory_1._makeParamStoreGetter)(this, configuration, options)
        };
        const overridden = (_b = (_a = this.overrideAdapter) === null || _a === void 0 ? void 0 : _a.getParamStoreOverride) === null || _b === void 0 ? void 0 : _b.call(_a, paramStore, options);
        if (overridden != null) {
            paramStore.__configuration = overridden.config;
            paramStore.details = overridden.details;
            paramStore.get = (0, ParamStoreGetterFactory_1._makeParamStoreGetter)(this, overridden.config, options);
        }
        return paramStore;
    }
    /**
     * StatsigClient constructor
     *
     * @param {string} sdkKey A Statsig client SDK key. eg "client-xyz123..."
     * @param {StatsigUser} user StatsigUser object containing various attributes related to a user.
     * @param {StatsigOptions | null} options StatsigOptions, used to customize the behavior of the SDK.
     */ constructor(sdkKey, user, options = null){
        var _a, _b;
        client_core_1.SDKType._setClientType(sdkKey, 'javascript-client');
        const network = new Network_1.default(options, (e)=>{
            this.$emt(e);
        });
        super(sdkKey, (_a = options === null || options === void 0 ? void 0 : options.dataAdapter) !== null && _a !== void 0 ? _a : new StatsigEvaluationsDataAdapter_1.StatsigEvaluationsDataAdapter(), network, options);
        this._possibleFirstTouchMetadata = {};
        /**
         * Retrieves the value of a feature gate for the current user, represented as a {@link FeatureGate} object.
         *
         * @param {string} name - The name of the feature gate to retrieve.
         * @param {FeatureGateEvaluationOptions} [options] - Optional. Additional options to customize the method call.
         * @returns {FeatureGate} - The {@link FeatureGate} object representing the gate's current evaluation results for the user.
         */ this.getFeatureGate = this._memoize(client_core_1.MemoPrefix._gate, this._getFeatureGateImpl.bind(this));
        /**
         * Retrieves the value of a dynamic config for the current user.
         *
         * @param {string} name The name of the dynamic config to get.
         * @param {DynamicConfigEvaluationOptions} [options] - Optional. Additional options to customize the method call.
         * @returns {DynamicConfig} - The {@link DynamicConfig} object representing the dynamic configs's current evaluation results for the user.
         */ this.getDynamicConfig = this._memoize(client_core_1.MemoPrefix._dynamicConfig, this._getDynamicConfigImpl.bind(this));
        /**
         * Retrieves the value of a experiment for the current user.
         *
         * @param {string} name The name of the experiment to get.
         * @param {ExperimentEvaluationOptions} [options] - Optional. Additional options to customize the method call.
         * @returns {Experiment} - The {@link Experiment} object representing the experiments's current evaluation results for the user.
         */ this.getExperiment = this._memoize(client_core_1.MemoPrefix._experiment, this._getExperimentImpl.bind(this));
        /**
         * Retrieves the list of all Dynamic Configs and Experiments for the current user.
         *
         * @returns {string[]} The list of all Dynamic Config and Experiment names for the current user. Note - these will be hashed unless you've disabled hashing.
         * This is intended to be used for debugging.
         */ this.getConfigList = this._memoize(client_core_1.MemoPrefix._configList, this._getConfigListImpl.bind(this));
        /**
         * Retrieves the value of a layer for the current user.
         *
         * @param {string} name The name of the layer to get.
         * @param {LayerEvaluationOptions} [options] - Optional. Additional options to customize the method call.
         * @returns {Layer} - The {@link Layer} object representing the layers's current evaluation results for the user.
         */ this.getLayer = this._memoize(client_core_1.MemoPrefix._layer, this._getLayerImpl.bind(this));
        /**
         * Retrieves the value of a parameter store for the current user.
         *
         * @param {string} name The name of the parameter store to get.
         * @param {ParameterStoreEvaluationOptions} [options] - Optional. Additional options to customize the method call.
         * @returns {ParameterStore} - The {@link ParameterStore} object representing the parameter store's current mappings for the user.
         */ this.getParameterStore = this._memoize(client_core_1.MemoPrefix._paramStore, this._getParameterStoreImpl.bind(this));
        this._store = new EvaluationStore_1.default(sdkKey);
        this._network = network;
        this._user = this._configureUser(user, options);
        this._sdkInstanceID = (0, client_core_1.getUUID)();
        const plugins = (_b = options === null || options === void 0 ? void 0 : options.plugins) !== null && _b !== void 0 ? _b : [];
        for (const plugin of plugins)plugin.bind(this);
    }
}
exports.default = StatsigClient;

},{"e0761d782e417a7b":"1MCdW","bb4d2d3cd4d58603":"aYNNn","df3cb964060f8da9":"lW7K0","3896ed2557d65a15":"fCorX","ccd804bf92a192aa":"3ffDQ"}],"aYNNn":[function(require,module,exports,__globalThis) {
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
const client_core_1 = require("63e41baa1d8d3d48");
const V1InitializeContainer_1 = require("73b4423abedd5420");
const V2InitializeContainer_1 = require("d4ae3226366e1f7e");
class EvaluationStore {
    reset() {
        this._values = null;
        this._rawValues = null;
        this._source = 'Loading';
        this._lcut = 0;
        this._receivedAt = 0;
        this._bootstrapMetadata = null;
        this._warnings.clear();
    }
    finalize() {
        if (this._values) return;
        this._source = 'NoValues';
    }
    getValues() {
        return this._rawValues ? (0, client_core_1._typedJsonParse)(this._rawValues, 'has_updates', 'EvaluationStoreValues') : null;
    }
    setValues(result, user) {
        var _a, _b;
        if (!result) return false;
        const values = (0, client_core_1._typedJsonParse)(result.data, 'has_updates', 'EvaluationResponse');
        if (values == null) return false;
        this._source = result.source;
        if ((values === null || values === void 0 ? void 0 : values.has_updates) !== true) return true;
        const updatedLcut = (_a = values.time) !== null && _a !== void 0 ? _a : 0;
        if (updatedLcut < this._lcut) return true;
        this._rawValues = result.data;
        this._lcut = values.time;
        this._receivedAt = result.receivedAt;
        if (values.response_format === 'init-v2') this._values = new V2InitializeContainer_1.V2InitializeContainer(values);
        else this._values = new V1InitializeContainer_1.V1InitializeContainer(values);
        this._bootstrapMetadata = this._extractBootstrapMetadata(result.source, values);
        if (result.source && values.user) this._setWarningState(user, values);
        client_core_1.SDKFlags.setFlags(this._sdkKey, (_b = values.sdk_flags) !== null && _b !== void 0 ? _b : {});
        return true;
    }
    getWarnings() {
        if (this._warnings.size === 0) return undefined;
        return Array.from(this._warnings);
    }
    getGate(name) {
        const res = this._values ? this._values.getGate(name) : null;
        return this._getDetailedStoreResult(res);
    }
    getConfig(name) {
        const res = this._values ? this._values.getConfig(name) : null;
        return this._getDetailedStoreResult(res);
    }
    getConfigList() {
        if (!this._values) return [];
        return this._values.getConfigList();
    }
    getLayer(name) {
        const res = this._values ? this._values.getLayer(name) : null;
        return this._getDetailedStoreResult(res);
    }
    getParamStore(name) {
        const res = this._values ? this._values.getParamStore(name) : null;
        return this._getDetailedStoreResult(res);
    }
    getSource() {
        return this._source;
    }
    getExposureMapping() {
        var _a;
        return (_a = this._values) === null || _a === void 0 ? void 0 : _a.getExposureMapping();
    }
    _extractBootstrapMetadata(source, values) {
        if (source !== 'Bootstrap') return null;
        const bootstrapMetadata = {};
        if (values.user) bootstrapMetadata.user = values.user;
        if (values.sdkInfo) bootstrapMetadata.generatorSDKInfo = values.sdkInfo;
        bootstrapMetadata.lcut = values.time;
        return bootstrapMetadata;
    }
    _getDetailedStoreResult(result) {
        return {
            result,
            details: this._getDetails(result == null)
        };
    }
    _setWarningState(user, values) {
        var _a, _b;
        const stableID = client_core_1.StableID.get(this._sdkKey);
        if (((_a = user.customIDs) === null || _a === void 0 ? void 0 : _a.stableID) !== stableID && // don't throw if they're both undefined
        (((_b = user.customIDs) === null || _b === void 0 ? void 0 : _b.stableID) || stableID)) {
            this._warnings.add('StableIDMismatch');
            return;
        }
        if ('user' in values) {
            const bootstrapUser = values['user'];
            const userForComparison = Object.assign(Object.assign({}, user), {
                analyticsOnlyMetadata: undefined,
                privateAttributes: undefined
            });
            if ((0, client_core_1._getFullUserHash)(userForComparison) !== (0, client_core_1._getFullUserHash)(bootstrapUser)) this._warnings.add('PartialUserMatch');
        }
    }
    getCurrentSourceDetails() {
        if (this._source === 'Uninitialized' || this._source === 'NoValues') return {
            reason: this._source
        };
        const sourceDetails = {
            reason: this._source,
            lcut: this._lcut,
            receivedAt: this._receivedAt
        };
        if (this._warnings.size > 0) sourceDetails.warnings = Array.from(this._warnings);
        return sourceDetails;
    }
    _getDetails(isUnrecognized) {
        var _a, _b;
        const sourceDetails = this.getCurrentSourceDetails();
        let reason = sourceDetails.reason;
        const warnings = (_a = sourceDetails.warnings) !== null && _a !== void 0 ? _a : [];
        if (this._source === 'Bootstrap' && warnings.length > 0) reason = reason + warnings[0];
        if (reason !== 'Uninitialized' && reason !== 'NoValues') {
            const subreason = isUnrecognized ? 'Unrecognized' : 'Recognized';
            reason = `${reason}:${subreason}`;
        }
        const bootstrapMetadata = this._source === 'Bootstrap' ? (_b = this._bootstrapMetadata) !== null && _b !== void 0 ? _b : undefined : undefined;
        if (bootstrapMetadata) sourceDetails.bootstrapMetadata = bootstrapMetadata;
        return Object.assign(Object.assign({}, sourceDetails), {
            reason
        });
    }
    constructor(_sdkKey){
        this._sdkKey = _sdkKey;
        this._rawValues = null;
        this._values = null;
        this._source = 'Uninitialized';
        this._lcut = 0;
        this._receivedAt = 0;
        this._bootstrapMetadata = null;
        this._warnings = new Set();
    }
}
exports.default = EvaluationStore;

},{"63e41baa1d8d3d48":"1MCdW","73b4423abedd5420":"wnw8e","d4ae3226366e1f7e":"2hGBJ"}],"wnw8e":[function(require,module,exports,__globalThis) {
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.V1InitializeContainer = void 0;
const client_core_1 = require("9358090b69acd161");
class V1InitializeContainer {
    getGate(name) {
        return this._getResultFromLookup(this._values.feature_gates, name);
    }
    getConfig(name) {
        return this._getResultFromLookup(this._values.dynamic_configs, name);
    }
    getLayer(name) {
        return this._getResultFromLookup(this._values.layer_configs, name);
    }
    getParamStore(name) {
        return this._getResultFromLookup(this._values.param_stores, name);
    }
    getConfigList() {
        return Object.keys(this._values.dynamic_configs);
    }
    getExposureMapping() {
        return this._values.exposures;
    }
    _getResultFromLookup(lookup, name) {
        var _a, _b;
        if (!lookup) return null;
        return (_b = (_a = lookup[name]) !== null && _a !== void 0 ? _a : lookup[(0, client_core_1._DJB2)(name)]) !== null && _b !== void 0 ? _b : null;
    }
    constructor(_values){
        this._values = _values;
    }
}
exports.V1InitializeContainer = V1InitializeContainer;

},{"9358090b69acd161":"1MCdW"}],"2hGBJ":[function(require,module,exports,__globalThis) {
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.V2InitializeContainer = void 0;
const client_core_1 = require("45a23e44314f17fb");
class V2InitializeContainer {
    getGate(name) {
        var _a, _b, _c;
        const evalV2 = this._getResultFromLookup(this._values.feature_gates, name);
        if (!evalV2) return null;
        return {
            name: name,
            value: evalV2.v === true,
            rule_id: (_a = evalV2.r) !== null && _a !== void 0 ? _a : 'default',
            secondary_exposures: (_b = evalV2.s) !== null && _b !== void 0 ? _b : [],
            id_type: (_c = evalV2.i) !== null && _c !== void 0 ? _c : ''
        };
    }
    getConfig(name) {
        var _a, _b, _c, _d;
        const evalV2 = this._getResultFromLookup(this._values.dynamic_configs, name);
        if (!evalV2) return null;
        return {
            name: name,
            value: (_a = this._values.values[evalV2.v]) !== null && _a !== void 0 ? _a : {},
            rule_id: evalV2.r,
            secondary_exposures: (_b = evalV2.s) !== null && _b !== void 0 ? _b : [],
            id_type: (_c = evalV2.i) !== null && _c !== void 0 ? _c : '',
            is_user_in_experiment: evalV2.ue === true ? true : false,
            passed: evalV2.p === true,
            group_name: (_d = evalV2.gn) !== null && _d !== void 0 ? _d : undefined,
            is_experiment_active: evalV2.ea === true ? true : false,
            group: evalV2.r,
            is_device_based: evalV2.i === 'stableID'
        };
    }
    getLayer(name) {
        var _a, _b, _c, _d, _e, _f;
        const evalV2 = this._getResultFromLookup(this._values.layer_configs, name);
        if (!evalV2) return null;
        return {
            name: name,
            value: (_a = this._values.values[evalV2.v]) !== null && _a !== void 0 ? _a : {},
            rule_id: evalV2.r,
            secondary_exposures: (_b = evalV2.s) !== null && _b !== void 0 ? _b : [],
            is_user_in_experiment: evalV2.ue === true ? true : false,
            group_name: (_c = evalV2.gn) !== null && _c !== void 0 ? _c : undefined,
            is_experiment_active: evalV2.ea === true ? true : false,
            group: evalV2.r,
            is_device_based: evalV2.i === 'stableID',
            allocated_experiment_name: (_d = evalV2.ae) !== null && _d !== void 0 ? _d : '',
            explicit_parameters: (_e = evalV2.ep) !== null && _e !== void 0 ? _e : [],
            undelegated_secondary_exposures: (_f = evalV2.us) !== null && _f !== void 0 ? _f : [],
            parameter_rule_ids: evalV2.pr
        };
    }
    getParamStore(name) {
        return this._getResultFromLookup(this._values.param_stores, name);
    }
    getConfigList() {
        return Object.keys(this._values.dynamic_configs);
    }
    getExposureMapping() {
        return this._values.exposures;
    }
    _getResultFromLookup(lookup, name) {
        var _a, _b;
        if (!lookup) return null;
        return (_b = (_a = lookup[name]) !== null && _a !== void 0 ? _a : lookup[(0, client_core_1._DJB2)(name)]) !== null && _b !== void 0 ? _b : null;
    }
    constructor(_values){
        this._values = _values;
    }
}
exports.V2InitializeContainer = V2InitializeContainer;

},{"45a23e44314f17fb":"1MCdW"}],"lW7K0":[function(require,module,exports,__globalThis) {
"use strict";
var __awaiter = this && this.__awaiter || function(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(exports, "__esModule", {
    value: true
});
const client_core_1 = require("4962556b5b13a79f");
const EvaluationResponseDeltas_1 = require("7188ad6bd81811a6");
class StatsigNetwork extends client_core_1.NetworkCore {
    fetchEvaluations(sdkKey, current, priority, user, isCacheValidFor204) {
        return __awaiter(this, void 0, void 0, function*() {
            var _a, _b, _c, _d, _e, _f;
            const cache = current ? (0, client_core_1._typedJsonParse)(current, 'has_updates', 'InitializeResponse') : null;
            let data = {
                user,
                hash: (_c = (_b = (_a = this._option) === null || _a === void 0 ? void 0 : _a.networkConfig) === null || _b === void 0 ? void 0 : _b.initializeHashAlgorithm) !== null && _c !== void 0 ? _c : 'djb2',
                deltasResponseRequested: false,
                full_checksum: null
            };
            if (cache === null || cache === void 0 ? void 0 : cache.has_updates) {
                const hasHashChanged = (cache === null || cache === void 0 ? void 0 : cache.hash_used) !== ((_f = (_e = (_d = this._option) === null || _d === void 0 ? void 0 : _d.networkConfig) === null || _e === void 0 ? void 0 : _e.initializeHashAlgorithm) !== null && _f !== void 0 ? _f : 'djb2');
                data = Object.assign(Object.assign({}, data), {
                    sinceTime: isCacheValidFor204 && !hasHashChanged ? cache.time : 0,
                    previousDerivedFields: 'derived_fields' in cache && isCacheValidFor204 ? cache.derived_fields : {},
                    deltasResponseRequested: true,
                    full_checksum: cache.full_checksum,
                    partialUserMatchSinceTime: !hasHashChanged ? cache.time : 0
                });
            }
            return this._fetchEvaluations(sdkKey, cache, data, priority);
        });
    }
    _fetchEvaluations(sdkKey, cache, data, priority) {
        return __awaiter(this, void 0, void 0, function*() {
            var _a, _b;
            const response = yield this.post({
                sdkKey,
                urlConfig: this._initializeUrlConfig,
                data,
                retries: 2,
                isStatsigEncodable: true,
                priority
            });
            if ((response === null || response === void 0 ? void 0 : response.code) === 204) return '{"has_updates": false}';
            if ((response === null || response === void 0 ? void 0 : response.code) !== 200) return (_a = response === null || response === void 0 ? void 0 : response.body) !== null && _a !== void 0 ? _a : null;
            if ((cache === null || cache === void 0 ? void 0 : cache.has_updates) !== true || ((_b = response.body) === null || _b === void 0 ? void 0 : _b.includes('"is_delta":true')) !== true || data.deltasResponseRequested !== true) return response.body;
            const result = (0, EvaluationResponseDeltas_1._resolveDeltasResponse)(cache, response.body);
            if (typeof result === 'string') return result;
            // retry without deltas
            return this._fetchEvaluations(sdkKey, cache, Object.assign(Object.assign(Object.assign({}, data), result), {
                deltasResponseRequested: false
            }), priority);
        });
    }
    constructor(options, emitter){
        super(options, emitter);
        const config = options === null || options === void 0 ? void 0 : options.networkConfig;
        this._option = options;
        this._initializeUrlConfig = new client_core_1.UrlConfiguration(client_core_1.Endpoint._initialize, config === null || config === void 0 ? void 0 : config.initializeUrl, config === null || config === void 0 ? void 0 : config.api, config === null || config === void 0 ? void 0 : config.initializeFallbackUrls);
    }
}
exports.default = StatsigNetwork;

},{"4962556b5b13a79f":"1MCdW","7188ad6bd81811a6":"j8k79"}],"j8k79":[function(require,module,exports,__globalThis) {
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports._resolveDeltasResponse = void 0;
const client_core_1 = require("533eb7177f91f531");
const MAX_DELTAS_SORT_DEPTH = 2;
function _resolveDeltasResponse(cache, deltasString) {
    const deltas = (0, client_core_1._typedJsonParse)(deltasString, 'checksum', 'DeltasEvaluationResponse');
    if (!deltas) return {
        hadBadDeltaChecksum: true
    };
    const merged = _mergeDeltasIntoCache(cache, deltas);
    const resolved = _handleDeletedEntries(merged);
    const actualChecksum = (0, client_core_1._DJB2Object)({
        feature_gates: resolved.feature_gates,
        dynamic_configs: resolved.dynamic_configs,
        layer_configs: resolved.layer_configs
    }, MAX_DELTAS_SORT_DEPTH);
    const isMatch = actualChecksum === deltas.checksumV2;
    if (!isMatch) return {
        hadBadDeltaChecksum: true,
        badChecksum: actualChecksum,
        badMergedConfigs: resolved,
        badFullResponse: deltas.deltas_full_response
    };
    return JSON.stringify(resolved);
}
exports._resolveDeltasResponse = _resolveDeltasResponse;
function _mergeDeltasIntoCache(cache, deltas) {
    return Object.assign(Object.assign(Object.assign({}, cache), deltas), {
        feature_gates: Object.assign(Object.assign({}, cache.feature_gates), deltas.feature_gates),
        layer_configs: Object.assign(Object.assign({}, cache.layer_configs), deltas.layer_configs),
        dynamic_configs: Object.assign(Object.assign({}, cache.dynamic_configs), deltas.dynamic_configs)
    });
}
function _handleDeletedEntries(deltas) {
    const result = deltas;
    _deleteEntriesInRecord(deltas.deleted_gates, result.feature_gates);
    delete result.deleted_gates;
    _deleteEntriesInRecord(deltas.deleted_configs, result.dynamic_configs);
    delete result.deleted_configs;
    _deleteEntriesInRecord(deltas.deleted_layers, result.layer_configs);
    delete result.deleted_layers;
    return result;
}
function _deleteEntriesInRecord(keys, values) {
    keys === null || keys === void 0 || keys.forEach((key)=>{
        delete values[key];
    });
}

},{"533eb7177f91f531":"1MCdW"}],"fCorX":[function(require,module,exports,__globalThis) {
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports._makeParamStoreGetter = void 0;
const client_core_1 = require("fa6092abf73a0804");
const NO_EXPOSURE_OPT = {
    disableExposureLog: true
};
function _shouldLogExposure(options) {
    return options == null || options.disableExposureLog === false;
}
function _shouldReturnFallback(value, fallback) {
    return fallback != null && !(0, client_core_1._isTypeMatch)(value, fallback);
}
function _getMappedStaticValue(param, _options) {
    return param.value;
}
function _getMappedGateValue(client, param, options) {
    const gate = client.getFeatureGate(param.gate_name, _shouldLogExposure(options) ? undefined : NO_EXPOSURE_OPT);
    if (gate.value) return param.pass_value;
    return param.fail_value;
}
function _getMappedDynamicConfigValue(client, param, fallback, options) {
    const config = client.getDynamicConfig(param.config_name, _shouldLogExposure(options) ? undefined : NO_EXPOSURE_OPT);
    const value = config.get(param.param_name);
    if (_shouldReturnFallback(value, fallback)) return fallback;
    return value;
}
function _getMappedExperimentValue(client, param, fallback, options) {
    const experiment = client.getExperiment(param.experiment_name, _shouldLogExposure(options) ? undefined : NO_EXPOSURE_OPT);
    const value = experiment.get(param.param_name);
    if (_shouldReturnFallback(value, fallback)) return fallback;
    return value;
}
function _getMappedLayerValue(client, param, fallback, options) {
    const layer = client.getLayer(param.layer_name, _shouldLogExposure(options) ? undefined : NO_EXPOSURE_OPT);
    const value = layer.get(param.param_name);
    if (_shouldReturnFallback(value, fallback)) return fallback;
    return value;
}
function _makeParamStoreGetter(client, config, options) {
    return (paramName, fallback)=>{
        if (config == null) return fallback;
        const param = config[paramName];
        if (param == null || fallback != null && (0, client_core_1._typeOf)(fallback) !== param.param_type) return fallback;
        switch(param.ref_type){
            case 'static':
                return _getMappedStaticValue(param, options);
            case 'gate':
                return _getMappedGateValue(client, param, options);
            case 'dynamic_config':
                return _getMappedDynamicConfigValue(client, param, fallback, options);
            case 'experiment':
                return _getMappedExperimentValue(client, param, fallback, options);
            case 'layer':
                return _getMappedLayerValue(client, param, fallback, options);
            default:
                return fallback;
        }
    };
}
exports._makeParamStoreGetter = _makeParamStoreGetter;

},{"fa6092abf73a0804":"1MCdW"}],"3ffDQ":[function(require,module,exports,__globalThis) {
"use strict";
var __awaiter = this && this.__awaiter || function(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.StatsigEvaluationsDataAdapter = void 0;
const client_core_1 = require("af59f117077ccbb8");
const Network_1 = require("e2b0d15ace3c0be3");
class StatsigEvaluationsDataAdapter extends client_core_1.DataAdapterCore {
    attach(sdkKey, options, network) {
        super.attach(sdkKey, options, network);
        if (network !== null && network instanceof Network_1.default) this._network = network;
        else this._network = new Network_1.default(options !== null && options !== void 0 ? options : {});
    }
    getDataAsync(current, user, options) {
        return this._getDataAsyncImpl(current, (0, client_core_1._normalizeUser)(user, this._options), options);
    }
    prefetchData(user, options) {
        return this._prefetchDataImpl(user, options);
    }
    setData(data) {
        const values = (0, client_core_1._typedJsonParse)(data, 'has_updates', 'data');
        if (values && 'user' in values) super.setData(data, values.user);
        else client_core_1.Log.error('StatsigUser not found. You may be using an older server SDK version. Please upgrade your SDK or use setDataLegacy.');
    }
    setDataLegacy(data, user) {
        super.setData(data, user);
    }
    _fetchFromNetwork(current, user, options, isCacheValidFor204) {
        return __awaiter(this, void 0, void 0, function*() {
            var _a;
            const result = yield (_a = this._network) === null || _a === void 0 ? void 0 : _a.fetchEvaluations(this._getSdkKey(), current, options === null || options === void 0 ? void 0 : options.priority, user, isCacheValidFor204);
            return result !== null && result !== void 0 ? result : null;
        });
    }
    _getCacheKey(user) {
        var _a;
        const key = (0, client_core_1._getStorageKey)(this._getSdkKey(), user, (_a = this._options) === null || _a === void 0 ? void 0 : _a.customUserCacheKeyFunc);
        return `${client_core_1.DataAdapterCachePrefix}.${this._cacheSuffix}.${key}`;
    }
    _isCachedResultValidFor204(result, user) {
        return result.fullUserHash != null && result.fullUserHash === (0, client_core_1._getFullUserHash)(user);
    }
    constructor(){
        super('EvaluationsDataAdapter', 'evaluations');
        this._network = null;
        this._options = null;
    }
}
exports.StatsigEvaluationsDataAdapter = StatsigEvaluationsDataAdapter;

},{"af59f117077ccbb8":"1MCdW","e2b0d15ace3c0be3":"lW7K0"}],"kktF1":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>(0, _subscriptionsDefault.default));
var _subscriptions = require("./Subscriptions");
var _subscriptionsDefault = parcelHelpers.interopDefault(_subscriptions);

},{"./Subscriptions":"bYEKH","@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"bYEKH":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "ALL_FEATURE_VALUES", ()=>ALL_FEATURE_VALUES);
// eslint-disable-next-line @atlaskit/volt-strict-mode/no-multiple-exports
parcelHelpers.export(exports, "default", ()=>Subscriptions);
var _objectSpread = require("@swc/helpers/_/_object_spread");
var _objectSpreadProps = require("@swc/helpers/_/_object_spread_props");
var _eventemitter3 = require("eventemitter3");
var _eventemitter3Default = parcelHelpers.interopDefault(_eventemitter3);
const ALL_FEATURE_VALUES = '@all-features';
class Subscriptions {
    onGateUpdated(gateName, callback, checkGate, options) {
        const value = checkGate(gateName, (0, _objectSpreadProps._)((0, _objectSpread._)({}, options), {
            fireGateExposure: false
        }));
        if (this.eventToValue.get(callback) === undefined) this.eventToValue.set(callback, value);
        const wrapCallback = ()=>{
            const value = checkGate(gateName, (0, _objectSpreadProps._)((0, _objectSpread._)({}, options), {
                fireGateExposure: false
            }));
            const existingValue = this.eventToValue.get(callback);
            if (existingValue !== value) {
                this.eventToValue.set(callback, value);
                callback(value);
            }
        };
        this.emitter.on(gateName, wrapCallback);
        return ()=>{
            this.emitter.off(gateName, wrapCallback);
        };
    }
    onExperimentValueUpdated(experimentName, parameterName, defaultValue, callback, getExperimentValue, options) {
        const experimentEventName = `${experimentName}.${parameterName}`;
        const value = getExperimentValue(experimentName, parameterName, defaultValue, (0, _objectSpreadProps._)((0, _objectSpread._)({}, options), {
            fireExperimentExposure: false
        }));
        if (this.eventToValue.get(callback) === undefined) this.eventToValue.set(callback, value);
        const wrapCallback = ()=>{
            const value = getExperimentValue(experimentName, parameterName, defaultValue, (0, _objectSpreadProps._)((0, _objectSpread._)({}, options), {
                fireExperimentExposure: false
            }));
            const existingValue = this.eventToValue.get(callback);
            if (existingValue !== value) {
                this.eventToValue.set(callback, value);
                callback(value);
            }
        };
        this.emitter.on(experimentEventName, wrapCallback);
        return ()=>{
            this.emitter.off(experimentEventName, wrapCallback);
        };
    }
    onAnyUpdated(callback) {
        this.emitter.on(ALL_FEATURE_VALUES, callback);
        return ()=>{
            this.emitter.off(ALL_FEATURE_VALUES, callback);
        };
    }
    anyUpdated() {
        this.emitter.emit(ALL_FEATURE_VALUES);
        this.emitter.eventNames().filter((name)=>name !== ALL_FEATURE_VALUES).forEach((event)=>{
            this.emitter.emit(event);
        });
    }
    constructor(){
        this.eventToValue = new Map();
        this.emitter = new (0, _eventemitter3Default.default)();
    }
}

},{"@swc/helpers/_/_object_spread":"9gdrV","@swc/helpers/_/_object_spread_props":"kANqQ","eventemitter3":"cVv4h","@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"cVv4h":[function(require,module,exports,__globalThis) {
'use strict';
var has = Object.prototype.hasOwnProperty, prefix = '~';
/**
 * Constructor to create a storage for our `EE` objects.
 * An `Events` instance is a plain object whose properties are event names.
 *
 * @constructor
 * @private
 */ function Events() {}
//
// We try to not inherit from `Object.prototype`. In some engines creating an
// instance in this way is faster than calling `Object.create(null)` directly.
// If `Object.create(null)` is not supported we prefix the event names with a
// character to make sure that the built-in object properties are not
// overridden or used as an attack vector.
//
if (Object.create) {
    Events.prototype = Object.create(null);
    //
    // This hack is needed because the `__proto__` property is still inherited in
    // some old browsers like Android 4, iPhone 5.1, Opera 11 and Safari 5.
    //
    if (!new Events().__proto__) prefix = false;
}
/**
 * Representation of a single event listener.
 *
 * @param {Function} fn The listener function.
 * @param {*} context The context to invoke the listener with.
 * @param {Boolean} [once=false] Specify if the listener is a one-time listener.
 * @constructor
 * @private
 */ function EE(fn, context, once) {
    this.fn = fn;
    this.context = context;
    this.once = once || false;
}
/**
 * Add a listener for a given event.
 *
 * @param {EventEmitter} emitter Reference to the `EventEmitter` instance.
 * @param {(String|Symbol)} event The event name.
 * @param {Function} fn The listener function.
 * @param {*} context The context to invoke the listener with.
 * @param {Boolean} once Specify if the listener is a one-time listener.
 * @returns {EventEmitter}
 * @private
 */ function addListener(emitter, event, fn, context, once) {
    if (typeof fn !== 'function') throw new TypeError('The listener must be a function');
    var listener = new EE(fn, context || emitter, once), evt = prefix ? prefix + event : event;
    if (!emitter._events[evt]) emitter._events[evt] = listener, emitter._eventsCount++;
    else if (!emitter._events[evt].fn) emitter._events[evt].push(listener);
    else emitter._events[evt] = [
        emitter._events[evt],
        listener
    ];
    return emitter;
}
/**
 * Clear event by name.
 *
 * @param {EventEmitter} emitter Reference to the `EventEmitter` instance.
 * @param {(String|Symbol)} evt The Event name.
 * @private
 */ function clearEvent(emitter, evt) {
    if (--emitter._eventsCount === 0) emitter._events = new Events();
    else delete emitter._events[evt];
}
/**
 * Minimal `EventEmitter` interface that is molded against the Node.js
 * `EventEmitter` interface.
 *
 * @constructor
 * @public
 */ function EventEmitter() {
    this._events = new Events();
    this._eventsCount = 0;
}
/**
 * Return an array listing the events for which the emitter has registered
 * listeners.
 *
 * @returns {Array}
 * @public
 */ EventEmitter.prototype.eventNames = function eventNames() {
    var names = [], events, name;
    if (this._eventsCount === 0) return names;
    for(name in events = this._events)if (has.call(events, name)) names.push(prefix ? name.slice(1) : name);
    if (Object.getOwnPropertySymbols) return names.concat(Object.getOwnPropertySymbols(events));
    return names;
};
/**
 * Return the listeners registered for a given event.
 *
 * @param {(String|Symbol)} event The event name.
 * @returns {Array} The registered listeners.
 * @public
 */ EventEmitter.prototype.listeners = function listeners(event) {
    var evt = prefix ? prefix + event : event, handlers = this._events[evt];
    if (!handlers) return [];
    if (handlers.fn) return [
        handlers.fn
    ];
    for(var i = 0, l = handlers.length, ee = new Array(l); i < l; i++)ee[i] = handlers[i].fn;
    return ee;
};
/**
 * Return the number of listeners listening to a given event.
 *
 * @param {(String|Symbol)} event The event name.
 * @returns {Number} The number of listeners.
 * @public
 */ EventEmitter.prototype.listenerCount = function listenerCount(event) {
    var evt = prefix ? prefix + event : event, listeners = this._events[evt];
    if (!listeners) return 0;
    if (listeners.fn) return 1;
    return listeners.length;
};
/**
 * Calls each of the listeners registered for a given event.
 *
 * @param {(String|Symbol)} event The event name.
 * @returns {Boolean} `true` if the event had listeners, else `false`.
 * @public
 */ EventEmitter.prototype.emit = function emit(event, a1, a2, a3, a4, a5) {
    var evt = prefix ? prefix + event : event;
    if (!this._events[evt]) return false;
    var listeners = this._events[evt], len = arguments.length, args, i;
    if (listeners.fn) {
        if (listeners.once) this.removeListener(event, listeners.fn, undefined, true);
        switch(len){
            case 1:
                return listeners.fn.call(listeners.context), true;
            case 2:
                return listeners.fn.call(listeners.context, a1), true;
            case 3:
                return listeners.fn.call(listeners.context, a1, a2), true;
            case 4:
                return listeners.fn.call(listeners.context, a1, a2, a3), true;
            case 5:
                return listeners.fn.call(listeners.context, a1, a2, a3, a4), true;
            case 6:
                return listeners.fn.call(listeners.context, a1, a2, a3, a4, a5), true;
        }
        for(i = 1, args = new Array(len - 1); i < len; i++)args[i - 1] = arguments[i];
        listeners.fn.apply(listeners.context, args);
    } else {
        var length = listeners.length, j;
        for(i = 0; i < length; i++){
            if (listeners[i].once) this.removeListener(event, listeners[i].fn, undefined, true);
            switch(len){
                case 1:
                    listeners[i].fn.call(listeners[i].context);
                    break;
                case 2:
                    listeners[i].fn.call(listeners[i].context, a1);
                    break;
                case 3:
                    listeners[i].fn.call(listeners[i].context, a1, a2);
                    break;
                case 4:
                    listeners[i].fn.call(listeners[i].context, a1, a2, a3);
                    break;
                default:
                    if (!args) for(j = 1, args = new Array(len - 1); j < len; j++)args[j - 1] = arguments[j];
                    listeners[i].fn.apply(listeners[i].context, args);
            }
        }
    }
    return true;
};
/**
 * Add a listener for a given event.
 *
 * @param {(String|Symbol)} event The event name.
 * @param {Function} fn The listener function.
 * @param {*} [context=this] The context to invoke the listener with.
 * @returns {EventEmitter} `this`.
 * @public
 */ EventEmitter.prototype.on = function on(event, fn, context) {
    return addListener(this, event, fn, context, false);
};
/**
 * Add a one-time listener for a given event.
 *
 * @param {(String|Symbol)} event The event name.
 * @param {Function} fn The listener function.
 * @param {*} [context=this] The context to invoke the listener with.
 * @returns {EventEmitter} `this`.
 * @public
 */ EventEmitter.prototype.once = function once(event, fn, context) {
    return addListener(this, event, fn, context, true);
};
/**
 * Remove the listeners of a given event.
 *
 * @param {(String|Symbol)} event The event name.
 * @param {Function} fn Only remove the listeners that match this function.
 * @param {*} context Only remove the listeners that have this context.
 * @param {Boolean} once Only remove one-time listeners.
 * @returns {EventEmitter} `this`.
 * @public
 */ EventEmitter.prototype.removeListener = function removeListener(event, fn, context, once) {
    var evt = prefix ? prefix + event : event;
    if (!this._events[evt]) return this;
    if (!fn) {
        clearEvent(this, evt);
        return this;
    }
    var listeners = this._events[evt];
    if (listeners.fn) {
        if (listeners.fn === fn && (!once || listeners.once) && (!context || listeners.context === context)) clearEvent(this, evt);
    } else {
        for(var i = 0, events = [], length = listeners.length; i < length; i++)if (listeners[i].fn !== fn || once && !listeners[i].once || context && listeners[i].context !== context) events.push(listeners[i]);
        //
        // Reset the array, or remove it completely if we have no more listeners.
        //
        if (events.length) this._events[evt] = events.length === 1 ? events[0] : events;
        else clearEvent(this, evt);
    }
    return this;
};
/**
 * Remove all listeners, or those of the specified event.
 *
 * @param {(String|Symbol)} [event] The event name.
 * @returns {EventEmitter} `this`.
 * @public
 */ EventEmitter.prototype.removeAllListeners = function removeAllListeners(event) {
    var evt;
    if (event) {
        evt = prefix ? prefix + event : event;
        if (this._events[evt]) clearEvent(this, evt);
    } else {
        this._events = new Events();
        this._eventsCount = 0;
    }
    return this;
};
//
// Alias methods names because people roll like that.
//
EventEmitter.prototype.off = EventEmitter.prototype.removeListener;
EventEmitter.prototype.addListener = EventEmitter.prototype.on;
//
// Expose the prefix.
//
EventEmitter.prefixed = prefix;
//
// Allow `EventEmitter` to be imported as module namespace.
//
EventEmitter.EventEmitter = EventEmitter;
module.exports = EventEmitter;

},{}],"2uTD7":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
// Reference: https://github.com/statsig-io/js-lite/blob/main/src/DynamicConfig.ts
parcelHelpers.export(exports, "DynamicConfig", ()=>DynamicConfig);
var _utils = require("../utils");
class DynamicConfig {
    static fromExperiment(experiment) {
        var _experiment___evaluation;
        var _experiment___evaluation_secondary_exposures, _experiment_groupName;
        const config = new DynamicConfig(experiment.name, experiment.value, experiment.ruleID, (0, _utils.migrateEvaluationDetails)(experiment.details), (0, _utils.migrateSecondaryExposures)((_experiment___evaluation_secondary_exposures = (_experiment___evaluation = experiment.__evaluation) === null || _experiment___evaluation === void 0 ? void 0 : _experiment___evaluation.secondary_exposures) !== null && _experiment___evaluation_secondary_exposures !== void 0 ? _experiment___evaluation_secondary_exposures : []), (_experiment_groupName = experiment.groupName) !== null && _experiment_groupName !== void 0 ? _experiment_groupName : undefined);
        config.experiment = experiment;
        return config;
    }
    get(key, defaultValue, typeGuard) {
        var _this__onDefaultValueFallback, _this;
        const val = this.getValue(key, defaultValue);
        if (val == null) return defaultValue;
        const expectedType = Array.isArray(defaultValue) ? 'array' : typeof defaultValue;
        const actualType = Array.isArray(val) ? 'array' : typeof val;
        if (typeGuard) {
            var _this__onDefaultValueFallback1, _this1;
            if (typeGuard(val)) {
                this.fireExposure(key);
                return val;
            }
            (_this__onDefaultValueFallback1 = (_this1 = this)._onDefaultValueFallback) === null || _this__onDefaultValueFallback1 === void 0 ? void 0 : _this__onDefaultValueFallback1.call(_this1, this, key, expectedType, actualType);
            return defaultValue;
        }
        if (defaultValue == null || expectedType === actualType) {
            this.fireExposure(key);
            return val;
        }
        (_this__onDefaultValueFallback = (_this = this)._onDefaultValueFallback) === null || _this__onDefaultValueFallback === void 0 ? void 0 : _this__onDefaultValueFallback.call(_this, this, key, expectedType, actualType);
        return defaultValue;
    }
    getValue(key, defaultValue) {
        if (key == null) return this.value;
        if (defaultValue == null) defaultValue = null;
        if (this.value[key] == null) return defaultValue;
        this.fireExposure(key);
        return this.value[key];
    }
    fireExposure(key) {
        // Call the wrapped experiment's get method to fire exposure
        if (this.experiment) this.experiment.get(key);
    }
    constructor(configName, configValue, ruleID, evaluationDetails, secondaryExposures = [], allocatedExperimentName = '', onDefaultValueFallback = null){
        this.value = configValue;
        this._name = configName;
        this._ruleID = ruleID;
        this._secondaryExposures = secondaryExposures;
        this._allocatedExperimentName = allocatedExperimentName;
        this._evaluationDetails = evaluationDetails;
        this._onDefaultValueFallback = onDefaultValueFallback;
    }
}

},{"../utils":"2guUJ","@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"2guUJ":[function(require,module,exports,__globalThis) {
/* eslint-disable @atlaskit/volt-strict-mode/no-multiple-exports */ var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "getOptionsWithDefaults", ()=>getOptionsWithDefaults);
parcelHelpers.export(exports, "shallowEquals", ()=>shallowEquals);
parcelHelpers.export(exports, "toStatsigUser", ()=>toStatsigUser);
parcelHelpers.export(exports, "deepAssign", ()=>deepAssign);
parcelHelpers.export(exports, "migrateInitializationOptions", ()=>migrateInitializationOptions);
parcelHelpers.export(exports, "migrateEvaluationDetails", ()=>migrateEvaluationDetails);
parcelHelpers.export(exports, "migrateSecondaryExposures", ()=>migrateSecondaryExposures);
var _objectSpread = require("@swc/helpers/_/_object_spread");
var _objectSpreadProps = require("@swc/helpers/_/_object_spread_props");
var _objectWithoutProperties = require("@swc/helpers/_/_object_without_properties");
var _isFedramp = require("@atlaskit/atlassian-context/is-fedramp");
var _types = require("./compat/types");
var _types1 = require("./types");
const getOptionsWithDefaults = (options)=>(0, _objectSpread._)({
        /**
	 * If more federal PerimeterTypes are added in the future, this should be updated so
	 * that isFedRamp() === true always returns the strictest perimeter.
	 */ perimeter: (0, _isFedramp.isFedRamp)() ? (0, _types1.PerimeterType).FEDRAMP_MODERATE : (0, _types1.PerimeterType).COMMERCIAL
    }, options);
const shallowEquals = (objectA, objectB)=>{
    if (!objectA && !objectB) return true;
    if (!objectA || !objectB) return false;
    const aEntries = Object.entries(objectA);
    const bEntries = Object.entries(objectB);
    if (aEntries.length !== bEntries.length) return false;
    const ascendingKeyOrder = ([key1], [key2])=>key1.localeCompare(key2);
    aEntries.sort(ascendingKeyOrder);
    bEntries.sort(ascendingKeyOrder);
    for(let i = 0; i < aEntries.length; i++){
        const [, aValue] = aEntries[i];
        const [, bValue] = bEntries[i];
        if (aValue !== bValue) return false;
    }
    return true;
};
const toStatsigUser = (identifiers, customAttributes)=>{
    // Re-map `stableId` to `stableID` to match Statsig's native type.
    const { stableId } = identifiers, otherIdentifiers = (0, _objectWithoutProperties._)(identifiers, [
        "stableId"
    ]);
    const user = {
        customIDs: (0, _objectSpread._)({}, otherIdentifiers, stableId !== undefined ? {
            stableID: stableId
        } : {}),
        custom: customAttributes
    };
    if (identifiers.atlassianAccountId) user.userID = identifiers.atlassianAccountId;
    return user;
};
function deepAssign(target, ...sources) {
    if (!sources.length) return target;
    const source = sources.shift();
    if (source === undefined || source === null) return deepAssign(target, ...sources);
    for (const [key, src] of Object.entries(source)){
        const dst = target[key];
        const srcIsObj = src && typeof src === 'object' && !Array.isArray(src);
        const dstIsObj = dst && typeof dst === 'object' && !Array.isArray(dst);
        if (srcIsObj && dstIsObj) target[key] = deepAssign(dst, src);
        else target[key] = src;
    }
    return deepAssign(target, ...sources);
}
const migrateInitializationOptions = (options)=>{
    const { api, disableCurrentPageLogging, loggingIntervalMillis, loggingBufferMaxSize, localMode, eventLoggingApi, eventLoggingApiForRetries, disableLocalStorage, ignoreWindowUndefined, disableAllLogging, // No equivalent but is pointless anyway since our Statsig init is synchronous
    initTimeoutMs: _initTimeoutMs, // No equivalent in new client but probably not important?
    disableNetworkKeepalive: _disableNetworkKeepalive, // Needs to be implemented manually but unused according to zoekt
    overrideStableID: _overrideStableID, // No equivalent for these but can't see them actually used anywhere in old client?
    disableErrorLogging: _disableErrorLogging, disableAutoMetricsLogging: _disableAutoMetricsLogging } = options, rest = (0, _objectWithoutProperties._)(options, [
        "api",
        "disableCurrentPageLogging",
        "loggingIntervalMillis",
        "loggingBufferMaxSize",
        "localMode",
        "eventLoggingApi",
        "eventLoggingApiForRetries",
        "disableLocalStorage",
        "ignoreWindowUndefined",
        "disableAllLogging",
        "initTimeoutMs",
        "disableNetworkKeepalive",
        "overrideStableID",
        "disableErrorLogging",
        "disableAutoMetricsLogging"
    ]);
    return (0, _objectSpreadProps._)((0, _objectSpread._)({}, rest), {
        networkConfig: {
            api,
            logEventUrl: eventLoggingApi ? eventLoggingApi + 'rgstr' : undefined,
            logEventFallbackUrls: eventLoggingApiForRetries ? [
                eventLoggingApiForRetries
            ] : undefined,
            preventAllNetworkTraffic: localMode || !ignoreWindowUndefined && typeof window === 'undefined'
        },
        includeCurrentPageUrlWithEvents: !disableCurrentPageLogging,
        loggingIntervalMs: loggingIntervalMillis,
        loggingBufferMaxSize,
        disableStorage: disableLocalStorage === undefined ? localMode : disableLocalStorage,
        disableLogging: disableAllLogging === undefined ? localMode : disableAllLogging
    });
};
const evaluationReasonMappings = Object.entries((0, _types.EvaluationReason)).map(([key, value])=>[
        key.toLowerCase(),
        value
    ]);
const migrateEvaluationDetails = (details)=>{
    var _evaluationReasonMappings_find;
    const reasonLower = details.reason.toLowerCase();
    var _evaluationReasonMappings_find_, _details_receivedAt;
    return {
        reason: (_evaluationReasonMappings_find_ = (_evaluationReasonMappings_find = evaluationReasonMappings.find(([key])=>reasonLower.includes(key))) === null || _evaluationReasonMappings_find === void 0 ? void 0 : _evaluationReasonMappings_find[1]) !== null && _evaluationReasonMappings_find_ !== void 0 ? _evaluationReasonMappings_find_ : (0, _types.EvaluationReason).Unknown,
        time: (_details_receivedAt = details.receivedAt) !== null && _details_receivedAt !== void 0 ? _details_receivedAt : Date.now()
    };
};
const migrateSecondaryExposures = (secondaryExposures)=>{
    return secondaryExposures.map((exposure)=>{
        if (typeof exposure === 'string') // This should ideally have gateValue and ruleID fields too, but it's not possible for us
        // to determine the correct values for these.
        return {
            gate: exposure
        };
        return exposure;
    });
};

},{"@swc/helpers/_/_object_spread":"9gdrV","@swc/helpers/_/_object_spread_props":"kANqQ","@swc/helpers/_/_object_without_properties":"6HqIM","@atlaskit/atlassian-context/is-fedramp":"hsRFS","./compat/types":"iiV2Y","./types":"hcjz7","@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"hsRFS":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
/**
 * Caution: Consider Alternatives Use of this function is not recommended as a long term solution, as it creates an assumption
 * there are no other isolated environments than just FedRAMP Moderate. You are encouraged to consider alternate solutions,
 * such as Statsig or environment configuration, that don't require creating a hard dependency between your code features
 * and the FedRAMP environment.
 * See [go-is-fedramp](https://go.atlassian.com/is-fedramp)
 */ parcelHelpers.export(exports, "isFedRamp", ()=>isFedRamp);
var _constants = require("../../../common/constants/host-based-lookup/constants");
function isFedRamp() {
    var _global_location_hostname, _global_location;
    const global = globalThis;
    // MICROS_PERIMETER is already used by few products, so we need to keep it for backward compatibility
    const env = global.MICROS_PERIMETER || global.UNSAFE_ATL_CONTEXT_BOUNDARY;
    if (env) return env === (0, _constants.FEDRAMP_MODERATE);
    const matches = (_global_location = global.location) === null || _global_location === void 0 ? void 0 : (_global_location_hostname = _global_location.hostname) === null || _global_location_hostname === void 0 ? void 0 : _global_location_hostname.match(/atlassian-us-gov-mod\.(com|net)|atlassian-us-gov\.(com|net)|atlassian-fex\.(com|net)|atlassian-stg-fedm\.(com|net)/);
    return matches ? matches.length > 0 : false;
}

},{"../../../common/constants/host-based-lookup/constants":"h8Kjf","@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"h8Kjf":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "FEDRAMP_MODERATE", ()=>FEDRAMP_MODERATE);
parcelHelpers.export(exports, "COMMERCIAL", ()=>COMMERCIAL);
parcelHelpers.export(exports, "FEDRAMP_FEDEX", ()=>FEDRAMP_FEDEX);
parcelHelpers.export(exports, "STAGING", ()=>STAGING);
parcelHelpers.export(exports, "PRODUCTION", ()=>PRODUCTION);
parcelHelpers.export(exports, "DEV", ()=>DEV);
const FEDRAMP_MODERATE = 'fedramp-moderate';
const COMMERCIAL = 'commercial';
const FEDRAMP_FEDEX = 'fedramp-fedex';
const STAGING = 'stg';
const PRODUCTION = 'prod';
const DEV = 'dev';

},{"@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"iiV2Y":[function(require,module,exports,__globalThis) {
// Reference: https://github.com/statsig-io/js-lite/blob/main/src/StatsigStore.ts
var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "EvaluationReason", ()=>EvaluationReason);
const EvaluationReason = {
    // Order is important since the logic for migrating from a new client reason to an old one
    // returns the first which is a substring of the new client reason
    Error: 'Error',
    LocalOverride: 'LocalOverride',
    Unrecognized: 'Unrecognized',
    Uninitialized: 'Uninitialized',
    NetworkNotModified: 'NetworkNotModified',
    Network: 'Network',
    InvalidBootstrap: 'InvalidBootstrap',
    Bootstrap: 'Bootstrap',
    Cache: 'Cache',
    // For when we could not migrate the reason from the new client
    Unknown: 'Unknown'
};

},{"@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"hcjz7":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "FeatureGateEnvironment", ()=>FeatureGateEnvironment);
parcelHelpers.export(exports, "PerimeterType", ()=>PerimeterType);
parcelHelpers.export(exports, "NON_BOOLEAN_VALUE", ()=>NON_BOOLEAN_VALUE);
const FeatureGateEnvironment = {
    Development: 'development',
    Staging: 'staging',
    Production: 'production'
};
const PerimeterType = {
    COMMERCIAL: 'commercial',
    FEDRAMP_MODERATE: 'fedramp-moderate'
};
const NON_BOOLEAN_VALUE = 'non_boolean';

},{"@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"0mwae":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
// Reference: https://github.com/statsig-io/js-lite/blob/main/src/Layer.ts
parcelHelpers.export(exports, "Layer", ()=>Layer);
var _utils = require("../utils");
class Layer {
    static fromLayer(layer) {
        var _layer___evaluation, _layer___evaluation1, _layer___evaluation2, _layer___evaluation3;
        var _layer___evaluation_secondary_exposures, _layer___evaluation_undelegated_secondary_exposures;
        const value = new Layer(layer.name, layer.__value, layer.ruleID, (0, _utils.migrateEvaluationDetails)(layer.details), (_layer, parameterName)=>layer.get(parameterName), (0, _utils.migrateSecondaryExposures)((_layer___evaluation_secondary_exposures = (_layer___evaluation = layer.__evaluation) === null || _layer___evaluation === void 0 ? void 0 : _layer___evaluation.secondary_exposures) !== null && _layer___evaluation_secondary_exposures !== void 0 ? _layer___evaluation_secondary_exposures : []), (0, _utils.migrateSecondaryExposures)((_layer___evaluation_undelegated_secondary_exposures = (_layer___evaluation1 = layer.__evaluation) === null || _layer___evaluation1 === void 0 ? void 0 : _layer___evaluation1.undelegated_secondary_exposures) !== null && _layer___evaluation_undelegated_secondary_exposures !== void 0 ? _layer___evaluation_undelegated_secondary_exposures : []), (_layer___evaluation2 = layer.__evaluation) === null || _layer___evaluation2 === void 0 ? void 0 : _layer___evaluation2.allocated_experiment_name, (_layer___evaluation3 = layer.__evaluation) === null || _layer___evaluation3 === void 0 ? void 0 : _layer___evaluation3.explicit_parameters);
        return value;
    }
    get(key, defaultValue, typeGuard) {
        const val = this._value[key];
        if (val == null) return defaultValue;
        const logAndReturn = ()=>{
            this._logLayerParameterExposure(key);
            return val;
        };
        if (typeGuard) return typeGuard(val) ? logAndReturn() : defaultValue;
        if (defaultValue == null) return logAndReturn();
        if (typeof val === typeof defaultValue && Array.isArray(defaultValue) === Array.isArray(val)) return logAndReturn();
        return defaultValue;
    }
    getValue(key, defaultValue) {
        // eslint-disable-next-line eqeqeq
        if (defaultValue == undefined) defaultValue = null;
        const val = this._value[key];
        if (val != null) this._logLayerParameterExposure(key);
        return val !== null && val !== void 0 ? val : defaultValue;
    }
    _logLayerParameterExposure(parameterName) {
        var _this__logParameterFunction, _this;
        (_this__logParameterFunction = (_this = this)._logParameterFunction) === null || _this__logParameterFunction === void 0 ? void 0 : _this__logParameterFunction.call(_this, this, parameterName);
    }
    constructor(name, layerValue, ruleID, evaluationDetails, logParameterFunction = null, secondaryExposures = [], undelegatedSecondaryExposures = [], allocatedExperimentName = '', explicitParameters = []){
        this._logParameterFunction = logParameterFunction;
        this._name = name;
        this._value = JSON.parse(JSON.stringify(layerValue !== null && layerValue !== void 0 ? layerValue : {}));
        this._ruleID = ruleID !== null && ruleID !== void 0 ? ruleID : '';
        this._evaluationDetails = evaluationDetails;
        this._secondaryExposures = secondaryExposures;
        this._undelegatedSecondaryExposures = undelegatedSecondaryExposures;
        this._allocatedExperimentName = allocatedExperimentName;
        this._explicitParameters = explicitParameters;
    }
}

},{"../utils":"2guUJ","@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"jIqZM":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>(0, _fetcherDefault.default));
var _fetcher = require("./Fetcher");
var _fetcherDefault = parcelHelpers.interopDefault(_fetcher);

},{"./Fetcher":"hg5nF","@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"hg5nF":[function(require,module,exports,__globalThis) {
/* eslint-disable @atlaskit/volt-strict-mode/no-multiple-exports */ var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "PROD_BASE_URL", ()=>PROD_BASE_URL);
parcelHelpers.export(exports, "STAGING_BASE_URL", ()=>STAGING_BASE_URL);
parcelHelpers.export(exports, "DEV_BASE_URL", ()=>DEV_BASE_URL);
parcelHelpers.export(exports, "FEDM_STAGING_BASE_URL", ()=>FEDM_STAGING_BASE_URL);
parcelHelpers.export(exports, "FEDM_PROD_BASE_URL", ()=>FEDM_PROD_BASE_URL);
parcelHelpers.export(exports, "IC_FFS_BASE_URL", ()=>IC_FFS_BASE_URL);
parcelHelpers.export(exports, "IC_STAGING_BASE_DOMAIN_URL", ()=>IC_STAGING_BASE_DOMAIN_URL);
parcelHelpers.export(exports, "IC_PROD_BASE_DOMAIN_URL", ()=>IC_PROD_BASE_DOMAIN_URL);
parcelHelpers.export(exports, "GATEWAY_BASE_URL", ()=>GATEWAY_BASE_URL);
parcelHelpers.export(exports, "default", ()=>Fetcher);
var _objectSpread = require("@swc/helpers/_/_object_spread");
var _types = require("../types");
var _version = require("../version");
var _errors = require("./errors");
const DEFAULT_REQUEST_TIMEOUT_MS = 5000;
const PROD_BASE_URL = 'https://api.atlassian.com/flags';
const STAGING_BASE_URL = 'https://api.stg.atlassian.com/flags';
const DEV_BASE_URL = 'https://api.dev.atlassian.com/flags';
const FEDM_STAGING_BASE_URL = 'https://api.stg.atlassian-us-gov-mod.com/flags';
const FEDM_PROD_BASE_URL = 'https://api.atlassian-us-gov-mod.com/flags';
const IC_FFS_BASE_URL = 'https://atlassian-statsig-proxy-archetype.atl-paas.%s.atl-ic.net';
const IC_STAGING_BASE_DOMAIN_URL = 'oasis-stg.com/flags';
const IC_PROD_BASE_DOMAIN_URL = 'atlassian-isolated.net/flags';
const GATEWAY_BASE_URL = '/gateway/api/flags';
class Fetcher {
    static async fetchClientSdk(fetcherOptions) {
        const { targetApp } = fetcherOptions;
        const url = `/api/v2/frontend/clientSdkKey/${targetApp}`;
        try {
            return await this.fetchRequest(url, 'GET', fetcherOptions);
        } catch (error) {
            if (error instanceof Error) throw error;
            throw Error('Failed to retrieve client sdk key');
        }
    }
    static async fetchExperimentValues(fetcherOptions, identifiers, customAttributes) {
        const requestBody = {
            identifiers,
            customAttributes,
            targetApp: fetcherOptions.targetApp
        };
        try {
            return await this.fetchRequest('/api/v2/frontend/experimentValues', 'POST', fetcherOptions, requestBody);
        } catch (error) {
            if (error instanceof Error) throw error;
            throw Error('Failed to retrieve experiment values');
        }
    }
    static async handleResponseError(response) {
        if (!response.ok) {
            // Use text() instead of json() as the error body might not be json data
            const body = await response.text();
            throw new (0, _errors.ResponseError)(`Non 2xx response status received, status: ${response.status}, body: ${JSON.stringify(body)}`);
        }
        if (response.status === 204) throw new (0, _errors.ResponseError)('Unexpected 204 response');
    }
    static async extractResponseBody(response) {
        const value = await response.text();
        return JSON.parse(value);
    }
    static getBaseUrl(serviceEnv, useGatewayUrl = false, perimeter, isolationContextId = null) {
        if (useGatewayUrl) return GATEWAY_BASE_URL;
        if (perimeter === (0, _types.PerimeterType).FEDRAMP_MODERATE) switch(serviceEnv){
            case (0, _types.FeatureGateEnvironment).Production:
                return FEDM_PROD_BASE_URL;
            case (0, _types.FeatureGateEnvironment).Staging:
                return FEDM_STAGING_BASE_URL;
            default:
                throw new Error(`Invalid environment "${serviceEnv}" for "${perimeter}" perimeter`);
        }
        else if (perimeter === (0, _types.PerimeterType).COMMERCIAL) switch(serviceEnv){
            case (0, _types.FeatureGateEnvironment).Development:
                return DEV_BASE_URL;
            case (0, _types.FeatureGateEnvironment).Staging:
                const apiUrl = this.getApiUrl(isolationContextId);
                if (apiUrl !== null) return apiUrl;
                return STAGING_BASE_URL;
            default:
                const prodApiUrl = this.getApiUrl(isolationContextId);
                if (prodApiUrl !== null) return prodApiUrl;
                return PROD_BASE_URL;
        }
        else throw new Error(`Invalid perimeter "${perimeter}"`);
    }
    static async fetchRequest(path, method, fetcherOptions, body) {
        const baseUrl = Fetcher.getBaseUrl(fetcherOptions.environment, fetcherOptions.useGatewayURL, fetcherOptions.perimeter, fetcherOptions.isolationContextId);
        const fetchTimeout = fetcherOptions.fetchTimeoutMs || DEFAULT_REQUEST_TIMEOUT_MS;
        let abortSignal;
        if (AbortSignal.timeout) abortSignal = AbortSignal.timeout(fetchTimeout);
        else if (AbortController) {
            const abortController = new AbortController();
            abortSignal = abortController.signal;
            setTimeout(()=>abortController.abort(), fetchTimeout);
        }
        const response = await fetch(`${baseUrl}${path}`, (0, _objectSpread._)({
            method,
            headers: {
                'Content-Type': 'application/json',
                'X-Client-Name': 'feature-gate-js-client',
                'X-Client-Version': (0, _version.CLIENT_VERSION),
                'X-API-KEY': fetcherOptions.apiKey
            },
            signal: abortSignal
        }, body && {
            body: JSON.stringify(body)
        }));
        await this.handleResponseError(response);
        return await this.extractResponseBody(response);
    }
    static getApiUrl(isolationContextId) {
        const window1 = this.getWindowLocation();
        if (window1 === undefined) {
            //this is needed when this SDK is used for SSR or plugin use cases where secret keys not available to use backend SDKs
            if (!isolationContextId) return null;
            return IC_FFS_BASE_URL.replace('%s', isolationContextId);
        }
        const { protocol, hostname } = window1;
        // Match last subdomain fragment before oasis-stg.com
        const oasisMatch = hostname.match(/([^.]+)\.oasis-stg\.com$/);
        if (oasisMatch) return `${protocol}//api.${oasisMatch[1]}.${IC_STAGING_BASE_DOMAIN_URL}`;
        // Match last subdomain fragment before atlassian-isolated.net
        const isolatedMatch = hostname.match(/([^.]+)\.atlassian-isolated\.net$/);
        if (isolatedMatch) return `${protocol}//api.${isolatedMatch[1]}.${IC_PROD_BASE_DOMAIN_URL}`;
        return null;
    }
    static getWindowLocation() {
        if (typeof window !== 'undefined' && window.location) return window.location;
        return undefined;
    }
}

},{"@swc/helpers/_/_object_spread":"9gdrV","../types":"hcjz7","../version":"gevk9","./errors":"69oN7","@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"gevk9":[function(require,module,exports,__globalThis) {
/// <reference types="node" />
var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "CLIENT_VERSION", ()=>CLIENT_VERSION);
const CLIENT_VERSION = "0.16.1";

},{"@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"69oN7":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "ResponseError", ()=>ResponseError);
class ResponseError extends Error {
    constructor(message){
        super(message);
    }
}

},{"@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"bfhqM":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
/**
 * Data adapter which only uses bootstrap data and will never fetch from network or cache.
 * We do this because we control the fetching of bootstrap data from FFS in Client.ts whereas the
 * default data adapter fetches from Statsig servers.
 */ parcelHelpers.export(exports, "NoFetchDataAdapter", ()=>NoFetchDataAdapter);
var _objectSpread = require("@swc/helpers/_/_object_spread");
var _objectSpreadProps = require("@swc/helpers/_/_object_spread_props");
var _jsClient = require("@statsig/js-client");
class NoFetchDataAdapter extends (0, _jsClient.DataAdapterCore) {
    /**
	 * Make sure to call this **before** calling `initializeAsync` or `updateUserAsync` but
	 * after the Statsig client has been created!
	 */ setBootstrapData(data) {
        this.bootstrapResult = data ? {
            source: 'Bootstrap',
            data: JSON.stringify(data),
            receivedAt: Date.now(),
            stableID: (0, _jsClient.StableID).get(this._getSdkKey()),
            fullUserHash: null
        } : null;
    }
    async prefetchData(_user, _options) {}
    async getDataAsync(_current, user, _options) {
        return this.bootstrapResult && (0, _objectSpreadProps._)((0, _objectSpread._)({}, this.bootstrapResult), {
            fullUserHash: (0, _jsClient._getFullUserHash)(user)
        });
    }
    getDataSync(user) {
        return this.bootstrapResult && (0, _objectSpreadProps._)((0, _objectSpread._)({}, this.bootstrapResult), {
            fullUserHash: (0, _jsClient._getFullUserHash)(user)
        });
    }
    async _fetchFromNetwork(_current, _user, _options) {
        return null;
    }
    _getCacheKey(user) {
        // Same logic as default data adapter
        // https://github.com/statsig-io/js-client-monorepo/blob/main/packages/js-client/src/StatsigEvaluationsDataAdapter.ts
        const key = (0, _jsClient._getStorageKey)(this._getSdkKey(), user);
        return `${0, _jsClient.DataAdapterCachePrefix}.${this._cacheSuffix}.${key}`;
    }
    _isCachedResultValidFor204(_result, _user) {
        return false;
    }
    setDataLegacy(data, user) {
        super.setData(data, user);
    }
    // Do not stringify options property since that includes this adapter and will
    // cause a circular reference when Statsig sends diagnostic events and including
    // values is not necessary and makes the result huge
    toJSON() {
        const result = (0, _objectSpread._)({}, this);
        delete result._options;
        delete result._inMemoryCache;
        delete result.bootstrapResult;
        return result;
    }
    constructor(){
        super('NoFetchDataAdapter', 'nofetch'), this.bootstrapResult = null;
    }
}

},{"@swc/helpers/_/_object_spread":"9gdrV","@swc/helpers/_/_object_spread_props":"kANqQ","@statsig/js-client":"7YWtw","@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"59ioM":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "LOCAL_STORAGE_KEY", ()=>LOCAL_STORAGE_KEY);
/**
 * Custom implementation of `@statsig/js-local-overrides` package with support for local storage
 * so we can keep the existing behavior where overrides are cached locally. Also designed for
 * compatibility with the old override system (eg. no `experiments` field, `configs` is used
 * instead).
 *
 * [Reference](https://github.com/statsig-io/js-client-monorepo/blob/main/packages/js-local-overrides/src/LocalOverrideAdapter.ts)
 */ // eslint-disable-next-line @atlaskit/volt-strict-mode/no-multiple-exports
parcelHelpers.export(exports, "PersistentOverrideAdapter", ()=>PersistentOverrideAdapter);
var _objectSpread = require("@swc/helpers/_/_object_spread");
var _objectSpreadProps = require("@swc/helpers/_/_object_spread_props");
var _clientCore = require("@statsig/client-core");
const LOCAL_OVERRIDE_REASON = 'LocalOverride:Recognized';
const LOCAL_STORAGE_KEY = 'STATSIG_OVERRIDES';
const LEGACY_LOCAL_STORAGE_KEY = 'STATSIG_JS_LITE_LOCAL_OVERRIDES';
const makeEmptyStore = ()=>({
        gates: {},
        configs: {},
        layers: {}
    });
const djb2MapKey = (hash, kind)=>kind + ':' + hash;
class PersistentOverrideAdapter {
    parseStoredOverrides(localStorageKey) {
        try {
            // eslint-disable-next-line @atlaskit/platform/no-direct-web-storage-usage -- existing usage
            const json = window.localStorage.getItem(localStorageKey);
            if (!json) return makeEmptyStore();
            return JSON.parse(json);
        } catch (e) {
            return makeEmptyStore();
        }
    }
    mergeOverrides(...allOverrides) {
        const merged = makeEmptyStore();
        for (const overrides of allOverrides){
            var _overrides_gates;
            for (const [name, value] of Object.entries((_overrides_gates = overrides.gates) !== null && _overrides_gates !== void 0 ? _overrides_gates : {}))merged.gates[name] = value;
            var _overrides_configs;
            for (const [name, value] of Object.entries((_overrides_configs = overrides.configs) !== null && _overrides_configs !== void 0 ? _overrides_configs : {}))merged.configs[name] = value;
            var _overrides_layers;
            for (const [name, value] of Object.entries((_overrides_layers = overrides.layers) !== null && _overrides_layers !== void 0 ? _overrides_layers : {}))merged.layers[name] = value;
        }
        return merged;
    }
    initFromStoredOverrides() {
        const storedOverrides = this.mergeOverrides(this._overrides, this.parseStoredOverrides(LEGACY_LOCAL_STORAGE_KEY), this.parseStoredOverrides(this._localStorageKey));
        // Clear data from legacy local storage key now we've read from it.
        // This prevents things being stuck in there that are always read but never written to.
        try {
            // eslint-disable-next-line @atlaskit/platform/no-direct-web-storage-usage -- existing usage
            window.localStorage.removeItem(LEGACY_LOCAL_STORAGE_KEY);
        } catch (e) {
        // ignored - window is not defined in non-browser environments, and we don't save things there
        // (things like SSR, etc)
        }
        // In version 4.24.0 we introduced hashes in this override adapter, but had a bug which would cause
        // multiple hashes to continue being created. This code here removes these hashes since we've moved
        // to using a more reliable and easier to maintain map in `_djb2Map`.
        for (const container of Object.values(storedOverrides)){
            const allKeys = new Set(Object.keys(container));
            for (const name of allKeys){
                const hash = (0, _clientCore._DJB2)(name);
                if (allKeys.has(hash)) delete container[hash];
            }
        }
        this.applyOverrides(storedOverrides);
    }
    saveOverrides() {
        try {
            // eslint-disable-next-line @atlaskit/platform/no-direct-web-storage-usage -- existing usage
            window.localStorage.setItem(this._localStorageKey, JSON.stringify(this._overrides));
        } catch (e) {
        // ignored - window is not defined in non-browser environments, and we don't save things there
        // (things like SSR, etc)
        }
    }
    getOverrides() {
        return this.mergeOverrides(this._overrides);
    }
    applyOverrides(overrides) {
        const newOverrides = (0, _objectSpread._)({}, makeEmptyStore(), overrides);
        this._djb2Map.clear();
        for (const [containerName, container] of Object.entries(newOverrides))for (const [name, value] of Object.entries(container))this._djb2Map.set(djb2MapKey((0, _clientCore._DJB2)(name), containerName), value);
        this._overrides = newOverrides;
    }
    setOverrides(overrides) {
        this.applyOverrides(overrides);
        this.saveOverrides();
    }
    overrideGate(name, value) {
        this._overrides.gates[name] = value;
        this._djb2Map.set(djb2MapKey((0, _clientCore._DJB2)(name), 'gates'), value);
        this.saveOverrides();
    }
    removeGateOverride(name) {
        delete this._overrides.gates[name];
        this._djb2Map.delete(djb2MapKey((0, _clientCore._DJB2)(name), 'gates'));
        this.saveOverrides();
    }
    getGateOverride(current, _user) {
        var _this__overrides_gates_current_name;
        const overridden = (_this__overrides_gates_current_name = this._overrides.gates[current.name]) !== null && _this__overrides_gates_current_name !== void 0 ? _this__overrides_gates_current_name : this._djb2Map.get(djb2MapKey(current.name, 'gates'));
        if (overridden == null) return null;
        return (0, _objectSpreadProps._)((0, _objectSpread._)({}, current), {
            value: overridden,
            details: (0, _objectSpreadProps._)((0, _objectSpread._)({}, current.details), {
                reason: LOCAL_OVERRIDE_REASON
            })
        });
    }
    overrideDynamicConfig(name, value) {
        this._overrides.configs[name] = value;
        this._djb2Map.set(djb2MapKey((0, _clientCore._DJB2)(name), 'configs'), value);
        this.saveOverrides();
    }
    removeDynamicConfigOverride(name) {
        delete this._overrides.configs[name];
        this._djb2Map.delete(djb2MapKey((0, _clientCore._DJB2)(name), 'configs'));
        this.saveOverrides();
    }
    getDynamicConfigOverride(current, _user) {
        return this._getConfigOverride(current, this._overrides.configs);
    }
    overrideExperiment(name, value) {
        this._overrides.configs[name] = value;
        this._djb2Map.set(djb2MapKey((0, _clientCore._DJB2)(name), 'configs'), value);
        this.saveOverrides();
    }
    removeExperimentOverride(name) {
        delete this._overrides.configs[name];
        this._djb2Map.delete(djb2MapKey((0, _clientCore._DJB2)(name), 'configs'));
        this.saveOverrides();
    }
    getExperimentOverride(current, _user) {
        return this._getConfigOverride(current, this._overrides.configs);
    }
    overrideLayer(name, value) {
        this._overrides.layers[name] = value;
        this._djb2Map.set(djb2MapKey((0, _clientCore._DJB2)(name), 'layers'), value);
        this.saveOverrides();
    }
    removeLayerOverride(name) {
        delete this._overrides.layers[name];
        this._djb2Map.delete(djb2MapKey((0, _clientCore._DJB2)(name), 'layers'));
        this.saveOverrides();
    }
    removeAllOverrides() {
        this._overrides = makeEmptyStore();
        try {
            // eslint-disable-next-line @atlaskit/platform/no-direct-web-storage-usage -- existing usage
            window.localStorage.removeItem(this._localStorageKey);
        } catch (e) {
        // ignored - window is not defined in non-browser environments, and we don't save things there
        // (things like SSR, etc)
        }
    }
    getLayerOverride(current, _user) {
        var _this__overrides_layers_current_name;
        const overridden = (_this__overrides_layers_current_name = this._overrides.layers[current.name]) !== null && _this__overrides_layers_current_name !== void 0 ? _this__overrides_layers_current_name : this._djb2Map.get(djb2MapKey(current.name, 'layers'));
        if (overridden == null) return null;
        return (0, _objectSpreadProps._)((0, _objectSpread._)({}, current), {
            __value: overridden,
            get: (0, _clientCore._makeTypedGet)(current.name, overridden),
            details: (0, _objectSpreadProps._)((0, _objectSpread._)({}, current.details), {
                reason: LOCAL_OVERRIDE_REASON
            })
        });
    }
    _getConfigOverride(current, lookup) {
        var _lookup_current_name;
        const overridden = (_lookup_current_name = lookup[current.name]) !== null && _lookup_current_name !== void 0 ? _lookup_current_name : this._djb2Map.get(djb2MapKey(current.name, 'configs'));
        if (overridden == null) return null;
        return (0, _objectSpreadProps._)((0, _objectSpread._)({}, current), {
            value: overridden,
            get: (0, _clientCore._makeTypedGet)(current.name, overridden),
            details: (0, _objectSpreadProps._)((0, _objectSpread._)({}, current.details), {
                reason: LOCAL_OVERRIDE_REASON
            })
        });
    }
    constructor(localStorageKey){
        this._overrides = makeEmptyStore();
        this._djb2Map = new Map();
        this._localStorageKey = localStorageKey;
    }
}

},{"@swc/helpers/_/_object_spread":"9gdrV","@swc/helpers/_/_object_spread_props":"kANqQ","@statsig/client-core":"1MCdW","@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"cTh9L":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "debug", ()=>debug);
var _globalThis_process_env, _globalThis_process, _globalThis, _globalThis_process_env1, _globalThis_process1, _globalThis1;
// We can't rely on NODE_ENV === 'test' if its value is already configured by the consumer to some other value, so better to use JEST_WORKER_ID
// https://jestjs.io/docs/environment-variables#jest_worker_id
const TESTS_MODE = ((_globalThis = globalThis) === null || _globalThis === void 0 ? void 0 : (_globalThis_process = _globalThis.process) === null || _globalThis_process === void 0 ? void 0 : (_globalThis_process_env = _globalThis_process.env) === null || _globalThis_process_env === void 0 ? void 0 : _globalThis_process_env.JEST_WORKER_ID) !== undefined;
const DEBUG_MODE = !TESTS_MODE && ((_globalThis1 = globalThis) === null || _globalThis1 === void 0 ? void 0 : (_globalThis_process1 = _globalThis1.process) === null || _globalThis_process1 === void 0 ? void 0 : (_globalThis_process_env1 = _globalThis_process1.env) === null || _globalThis_process_env1 === void 0 ? void 0 : _globalThis_process_env1.NODE_ENV) !== 'production';
const debug = (...args)=>{
    if (!DEBUG_MODE) return;
    // eslint-disable-next-line no-console
    console.debug(...args);
};

},{"@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"fRE6U":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "ENV_ENABLE_PLATFORM_FF", ()=>ENV_ENABLE_PLATFORM_FF);
var _resolvers = require("./resolvers");
const ENV_ENABLE_PLATFORM_FF = (0, _resolvers.hasProcessEnv) ? false : false;

},{"./resolvers":"9iGdh","@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"egZrf":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "ENV_STORYBOOK_ENABLE_PLATFORM_FF", ()=>ENV_STORYBOOK_ENABLE_PLATFORM_FF);
var _resolvers = require("./resolvers");
const ENV_STORYBOOK_ENABLE_PLATFORM_FF = (0, _resolvers.hasProcessEnv) ? false : false;

},{"./resolvers":"9iGdh","@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"3B3KF":[function(require,module,exports,__globalThis) {
/// <reference types="node" />
var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "isUIAnalyticsEvent", ()=>isUIAnalyticsEvent);
var _uianalyticsEvent = require("./UIAnalyticsEvent");
var _uianalyticsEventDefault = parcelHelpers.interopDefault(_uianalyticsEvent);
const isUIAnalyticsEvent = (obj)=>{
    var // Backwards compatibility with older analytics-next packages
    _obj_constructor;
    return obj instanceof (0, _uianalyticsEventDefault.default) || !!(obj === null || obj === void 0 ? void 0 : obj._isUIAnalyticsEvent) || (obj === null || obj === void 0 ? void 0 : (_obj_constructor = obj.constructor) === null || _obj_constructor === void 0 ? void 0 : _obj_constructor.name) === 'UIAnalyticsEvent';
};

},{"./UIAnalyticsEvent":"7JnK9","@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"4Z7Wf":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _platformFeatureFlags = require("@atlaskit/platform-feature-flags");
var _isModernContextEnabledEnv = require("../../utils/isModernContextEnabledEnv");
var _isModernContextEnabledEnvDefault = parcelHelpers.interopDefault(_isModernContextEnabledEnv);
var _legacyAnalyticsListener = require("./LegacyAnalyticsListener");
var _legacyAnalyticsListenerDefault = parcelHelpers.interopDefault(_legacyAnalyticsListener);
var _modernAnalyticsListener = require("./ModernAnalyticsListener");
var _modernAnalyticsListenerDefault = parcelHelpers.interopDefault(_modernAnalyticsListener);
const AnalyticsListener = (props)=>{
    const computeIsModernContext = ()=>(0, _isModernContextEnabledEnvDefault.default) || (0, _platformFeatureFlags.fg)('analytics-next-use-legacy-context') === false;
    // Gated by analytics-next-lock-context-type: capture the value once at mount so a late gate flip can't swap the component type and remount the subtree. While locked the gate is not re-read on later renders.
    const [lockedIsModernContext] = (0, _reactDefault.default).useState(computeIsModernContext);
    const isModernContext = (0, _platformFeatureFlags.fg)('analytics-next-lock-context-type') ? lockedIsModernContext : computeIsModernContext();
    return isModernContext ? /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _modernAnalyticsListenerDefault.default), props) : /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _legacyAnalyticsListenerDefault.default), props);
};
exports.default = AnalyticsListener;

},{"react":"ltHCL","@atlaskit/platform-feature-flags":"8rD2i","../../utils/isModernContextEnabledEnv":"5ecK5","./LegacyAnalyticsListener":"3tbVW","./ModernAnalyticsListener":"dZu7G","@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"5ecK5":[function(require,module,exports,__globalThis) {
/// <reference types="node" />
var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _process_env;
var process = require("23f898439c085751");
const _default_1 = typeof process !== 'undefined' && process !== null && ((_process_env = process.env) === null || _process_env === void 0 ? void 0 : _process_env['ANALYTICS_NEXT_MODERN_CONTEXT']);
exports.default = _default_1;

},{"23f898439c085751":"gNLf3","@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"3tbVW":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _propTypes = require("prop-types");
var _propTypesDefault = parcelHelpers.interopDefault(_propTypes);
var _analyticsNextStableReactContext = require("@atlaskit/analytics-next-stable-react-context");
var _analyticsNextStableReactContextDefault = parcelHelpers.interopDefault(_analyticsNextStableReactContext);
const ContextTypes = {
    getAtlaskitAnalyticsEventHandlers: (0, _propTypesDefault.default).func,
    getAtlaskitAnalyticsContext: (0, _propTypesDefault.default).func
};
const noop = ()=>[];
// eslint-disable-next-line @repo/internal/react/no-class-components
class AnalyticsListener extends (0, _react.Component) {
    render() {
        const { children } = this.props;
        return /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _analyticsNextStableReactContextDefault.default).Provider, {
            value: this.contextValue
        }, children);
    }
    constructor(props){
        super(props), this.getChildContext = ()=>({
                getAtlaskitAnalyticsEventHandlers: this.getAnalyticsEventHandlers,
                getAtlaskitAnalyticsContext: this.getAtlaskitAnalyticsContext
            }), this.getAnalyticsEventHandlers = ()=>{
            const { channel, onEvent } = this.props;
            const { getAtlaskitAnalyticsEventHandlers = noop } = this.context;
            const handler = (event, eventChannel)=>{
                if (channel === '*' || channel === eventChannel) onEvent(event, eventChannel);
            };
            return [
                handler,
                ...getAtlaskitAnalyticsEventHandlers()
            ];
        }, this.getAtlaskitAnalyticsContext = ()=>{
            const { getAtlaskitAnalyticsContext = noop } = this.context;
            return getAtlaskitAnalyticsContext();
        };
        this.contextValue = {
            getAtlaskitAnalyticsContext: this.getAtlaskitAnalyticsContext,
            getAtlaskitAnalyticsEventHandlers: this.getAnalyticsEventHandlers
        };
    }
}
AnalyticsListener.contextTypes = ContextTypes;
AnalyticsListener.childContextTypes = ContextTypes;
exports.default = AnalyticsListener;

},{"react":"ltHCL","prop-types":"3k3Jl","@atlaskit/analytics-next-stable-react-context":"3ToEo","@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"3k3Jl":[function(require,module,exports,__globalThis) {
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ var ReactIs, throwOnDirectAccess;
// By explicitly using `prop-types` you are opting into new production behavior.
// http://fb.me/prop-types-in-prod
module.exports = require("ed6da1efdf0843df")();

},{"ed6da1efdf0843df":"aJ9MT"}],"aJ9MT":[function(require,module,exports,__globalThis) {
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ 'use strict';
var ReactPropTypesSecret = require("a14ca52499881b1e");
function emptyFunction() {}
function emptyFunctionWithReset() {}
emptyFunctionWithReset.resetWarningCache = emptyFunction;
module.exports = function() {
    function shim(props, propName, componentName, location, propFullName, secret) {
        if (secret === ReactPropTypesSecret) // It is still safe when called from React.
        return;
        var err = new Error("Calling PropTypes validators directly is not supported by the `prop-types` package. Use PropTypes.checkPropTypes() to call them. Read more at http://fb.me/use-check-prop-types");
        err.name = 'Invariant Violation';
        throw err;
    }
    shim.isRequired = shim;
    function getShim() {
        return shim;
    }
    // Important!
    // Keep this list in sync with production version in `./factoryWithTypeCheckers.js`.
    var ReactPropTypes = {
        array: shim,
        bigint: shim,
        bool: shim,
        func: shim,
        number: shim,
        object: shim,
        string: shim,
        symbol: shim,
        any: shim,
        arrayOf: getShim,
        element: shim,
        elementType: shim,
        instanceOf: getShim,
        node: shim,
        objectOf: getShim,
        oneOf: getShim,
        oneOfType: getShim,
        shape: getShim,
        exact: getShim,
        checkPropTypes: emptyFunctionWithReset,
        resetWarningCache: emptyFunction
    };
    ReactPropTypes.PropTypes = ReactPropTypes;
    return ReactPropTypes;
};

},{"a14ca52499881b1e":"fJTIM"}],"fJTIM":[function(require,module,exports,__globalThis) {
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ 'use strict';
var ReactPropTypesSecret = 'SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED';
module.exports = ReactPropTypesSecret;

},{}],"3ToEo":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _context = require("./context");
var _contextDefault = parcelHelpers.interopDefault(_context);
exports.default = (0, _contextDefault.default);

},{"./context":"cZSj1","@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"cZSj1":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _react = require("react");
var AnalyticsNextContext = (0, _react.createContext)({
    getAtlaskitAnalyticsContext: function() {
        return [];
    },
    getAtlaskitAnalyticsEventHandlers: function() {
        return [];
    }
});
exports.default = AnalyticsNextContext;

},{"react":"ltHCL","@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"dZu7G":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _analyticsNextStableReactContext = require("@atlaskit/analytics-next-stable-react-context");
var _analyticsNextStableReactContextDefault = parcelHelpers.interopDefault(_analyticsNextStableReactContext);
var _useAnalyticsContext = require("../../hooks/useAnalyticsContext");
var _useTrackedRef = require("../../hooks/useTrackedRef");
const AnalyticsListener = ({ children, channel, onEvent })=>{
    const { getAtlaskitAnalyticsEventHandlers = ()=>[], getAtlaskitAnalyticsContext } = (0, _useAnalyticsContext.useAnalyticsContext)();
    const onEventRef = (0, _useTrackedRef.useTrackedRef)(onEvent);
    const channelRef = (0, _useTrackedRef.useTrackedRef)(channel);
    const getAnalyticsEventHandlers = (0, _react.useCallback)(()=>{
        const thisHandler = (event, eventChannel)=>{
            if (channelRef.current === '*' || channelRef.current === eventChannel) onEventRef.current(event, eventChannel);
        };
        return [
            thisHandler,
            ...getAtlaskitAnalyticsEventHandlers()
        ];
    }, [
        channelRef,
        onEventRef,
        getAtlaskitAnalyticsEventHandlers
    ]);
    const value = (0, _react.useMemo)(()=>({
            getAtlaskitAnalyticsContext,
            getAtlaskitAnalyticsEventHandlers: getAnalyticsEventHandlers
        }), [
        getAtlaskitAnalyticsContext,
        getAnalyticsEventHandlers
    ]);
    return /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _analyticsNextStableReactContextDefault.default).Provider, {
        value: value
    }, children);
};
exports.default = AnalyticsListener;

},{"react":"ltHCL","@atlaskit/analytics-next-stable-react-context":"3ToEo","../../hooks/useAnalyticsContext":"xGHKb","../../hooks/useTrackedRef":"eemrC","@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"xGHKb":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "useAnalyticsContext", ()=>useAnalyticsContext);
var _react = require("react");
var _analyticsNextStableReactContext = require("@atlaskit/analytics-next-stable-react-context");
var _analyticsNextStableReactContextDefault = parcelHelpers.interopDefault(_analyticsNextStableReactContext);
const useAnalyticsContext = ()=>{
    return (0, _react.useContext)((0, _analyticsNextStableReactContextDefault.default));
};

},{"react":"ltHCL","@atlaskit/analytics-next-stable-react-context":"3ToEo","@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"eemrC":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "useTrackedRef", ()=>useTrackedRef);
var _react = require("react");
const useTrackedRef = (value)=>{
    const ref = (0, _react.useRef)(value);
    ref.current = value;
    return ref;
};

},{"react":"ltHCL","@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"8oEda":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _platformFeatureFlags = require("@atlaskit/platform-feature-flags");
var _isModernContextEnabledEnv = require("../../utils/isModernContextEnabledEnv");
var _isModernContextEnabledEnvDefault = parcelHelpers.interopDefault(_isModernContextEnabledEnv);
var _legacyAnalyticsContext = require("./LegacyAnalyticsContext");
var _legacyAnalyticsContextDefault = parcelHelpers.interopDefault(_legacyAnalyticsContext);
var _modernAnalyticsContext = require("./ModernAnalyticsContext");
var _modernAnalyticsContextDefault = parcelHelpers.interopDefault(_modernAnalyticsContext);
const AnalyticsContext = (props)=>{
    const computeIsModernContext = ()=>(0, _isModernContextEnabledEnvDefault.default) || (0, _platformFeatureFlags.fg)('analytics-next-use-legacy-context') === false;
    // Gated by analytics-next-lock-context-type: capture the value once at mount so a late gate flip can't swap the component type and remount the subtree. While locked the gate is not re-read on later renders.
    const [lockedIsModernContext] = (0, _reactDefault.default).useState(computeIsModernContext);
    const isModernContext = (0, _platformFeatureFlags.fg)('analytics-next-lock-context-type') ? lockedIsModernContext : computeIsModernContext();
    return isModernContext ? /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _modernAnalyticsContextDefault.default), props) : /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _legacyAnalyticsContextDefault.default), props);
};
exports.default = AnalyticsContext;

},{"react":"ltHCL","@atlaskit/platform-feature-flags":"8rD2i","../../utils/isModernContextEnabledEnv":"5ecK5","./LegacyAnalyticsContext":"9iDC1","./ModernAnalyticsContext":"81od6","@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"9iDC1":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _propTypes = require("prop-types");
var _propTypesDefault = parcelHelpers.interopDefault(_propTypes);
var _analyticsNextStableReactContext = require("@atlaskit/analytics-next-stable-react-context");
var _analyticsNextStableReactContextDefault = parcelHelpers.interopDefault(_analyticsNextStableReactContext);
const ContextTypes = {
    getAtlaskitAnalyticsContext: (0, _propTypesDefault.default).func,
    getAtlaskitAnalyticsEventHandlers: (0, _propTypesDefault.default).func
};
const noop = ()=>[];
// eslint-disable-next-line @repo/internal/react/no-class-components
class AnalyticsContext extends (0, _react.Component) {
    render() {
        const { children } = this.props;
        return /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _analyticsNextStableReactContextDefault.default).Provider, {
            value: this.contextValue
        }, children);
    }
    constructor(props){
        super(props), this.getChildContext = ()=>({
                getAtlaskitAnalyticsContext: this.getAnalyticsContext
            }), this.getAnalyticsContext = ()=>{
            const { data } = this.props;
            const { getAtlaskitAnalyticsContext = noop } = this.context;
            return [
                ...getAtlaskitAnalyticsContext(),
                data
            ];
        }, this.getAnalyticsEventHandlers = ()=>{
            const { getAtlaskitAnalyticsEventHandlers = noop } = this.context;
            return getAtlaskitAnalyticsEventHandlers();
        };
        this.contextValue = {
            getAtlaskitAnalyticsContext: this.getAnalyticsContext,
            getAtlaskitAnalyticsEventHandlers: this.getAnalyticsEventHandlers
        };
    }
}
AnalyticsContext.contextTypes = ContextTypes;
AnalyticsContext.childContextTypes = ContextTypes;
exports.default = AnalyticsContext;

},{"react":"ltHCL","prop-types":"3k3Jl","@atlaskit/analytics-next-stable-react-context":"3ToEo","@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"81od6":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _analyticsNextStableReactContext = require("@atlaskit/analytics-next-stable-react-context");
var _analyticsNextStableReactContextDefault = parcelHelpers.interopDefault(_analyticsNextStableReactContext);
var _useAnalyticsContext = require("../../hooks/useAnalyticsContext");
var _useTrackedRef = require("../../hooks/useTrackedRef");
const AnalyticsContext = ({ data, children })=>{
    const dataRef = (0, _useTrackedRef.useTrackedRef)(data);
    const { getAtlaskitAnalyticsEventHandlers, getAtlaskitAnalyticsContext: getOriginalAnalyticsContext } = (0, _useAnalyticsContext.useAnalyticsContext)();
    const getAtlaskitAnalyticsContext = (0, _react.useCallback)(()=>{
        return [
            ...getOriginalAnalyticsContext(),
            dataRef.current
        ];
    }, [
        getOriginalAnalyticsContext,
        dataRef
    ]);
    const value = (0, _react.useMemo)(()=>({
            getAtlaskitAnalyticsContext,
            getAtlaskitAnalyticsEventHandlers
        }), [
        getAtlaskitAnalyticsContext,
        getAtlaskitAnalyticsEventHandlers
    ]);
    return /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _analyticsNextStableReactContextDefault.default).Provider, {
        value: value
    }, children);
};
exports.default = AnalyticsContext;

},{"react":"ltHCL","@atlaskit/analytics-next-stable-react-context":"3ToEo","../../hooks/useAnalyticsContext":"xGHKb","../../hooks/useTrackedRef":"eemrC","@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"e8JZV":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _objectSpread = require("@swc/helpers/_/_object_spread");
var _objectSpreadProps = require("@swc/helpers/_/_object_spread_props");
var _objectWithoutProperties = require("@swc/helpers/_/_object_without_properties");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _analyticsContext = require("../components/AnalyticsContext");
var _analyticsContextDefault = parcelHelpers.interopDefault(_analyticsContext);
const withAnalyticsContext = (defaultData)=>(WrappedComponent)=>{
        const WithAnalyticsContext = /*#__PURE__*/ (0, _react.forwardRef)((_param, ref)=>{
            var { analyticsContext } = _param, rest = (0, _objectWithoutProperties._)(_param, [
                "analyticsContext"
            ]);
            const analyticsData = (0, _react.useMemo)(()=>(0, _objectSpread._)({}, defaultData, analyticsContext), [
                analyticsContext
            ]);
            return /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _analyticsContextDefault.default), {
                data: analyticsData
            }, /*#__PURE__*/ (0, _reactDefault.default).createElement(WrappedComponent, (0, _objectSpreadProps._)((0, _objectSpread._)({}, rest), {
                ref: ref
            })));
        });
        WithAnalyticsContext.displayName = `WithAnalyticsContext(${WrappedComponent.displayName || WrappedComponent.name})`;
        return WithAnalyticsContext;
    };
exports.default = withAnalyticsContext;

},{"@swc/helpers/_/_object_spread":"9gdrV","@swc/helpers/_/_object_spread_props":"kANqQ","@swc/helpers/_/_object_without_properties":"6HqIM","react":"ltHCL","../components/AnalyticsContext":"8oEda","@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"dOaVz":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
/**
 *  @private https://product-fabric.atlassian.net/browse/AFO-815
 *  @deprecated
 */ // eslint-disable-next-line @repo/internal/react/no-class-components
parcelHelpers.export(exports, "default", ()=>AnalyticsErrorBoundary);
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _platformFeatureFlags = require("@atlaskit/platform-feature-flags");
var _isModernContextEnabledEnv = require("../utils/isModernContextEnabledEnv");
var _isModernContextEnabledEnvDefault = parcelHelpers.interopDefault(_isModernContextEnabledEnv);
var _legacyAnalyticsContext = require("./AnalyticsContext/LegacyAnalyticsContext");
var _legacyAnalyticsContextDefault = parcelHelpers.interopDefault(_legacyAnalyticsContext);
var _modernAnalyticsContext = require("./AnalyticsContext/ModernAnalyticsContext");
var _modernAnalyticsContextDefault = parcelHelpers.interopDefault(_modernAnalyticsContext);
class AnalyticsErrorBoundary extends (0, _react.Component) {
    componentDidCatch(error, info) {
        const { onError } = this.props;
        onError && onError(error, info);
        this.setState({
            hasError: true
        });
    }
    render() {
        const { data, children, ErrorComponent } = this.props;
        const { hasError } = this.state;
        const isModernContext = (0, _platformFeatureFlags.fg)('analytics-next-lock-context-type') ? this.lockedIsModernContext : (0, _isModernContextEnabledEnvDefault.default) || (0, _platformFeatureFlags.fg)('analytics-next-use-legacy-context') === false;
        if (hasError) {
            if (ErrorComponent) {
                if (isModernContext) return /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _modernAnalyticsContextDefault.default), {
                    data: data
                }, /*#__PURE__*/ (0, _reactDefault.default).createElement(ErrorComponent, null));
                return /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _legacyAnalyticsContextDefault.default), {
                    data: data
                }, /*#__PURE__*/ (0, _reactDefault.default).createElement(ErrorComponent, null));
            }
            return null;
        }
        if (isModernContext) return /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _modernAnalyticsContextDefault.default), {
            data: data
        }, children);
        return /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _legacyAnalyticsContextDefault.default), {
            data: data
        }, children);
    }
    constructor(props){
        super(props), // Gated by analytics-next-lock-context-type: keep the value captured at construction so a late gate flip can't swap the context type and remount the subtree.
        this.lockedIsModernContext = (0, _isModernContextEnabledEnvDefault.default) || (0, _platformFeatureFlags.fg)('analytics-next-use-legacy-context') === false;
        this.state = {
            hasError: false
        };
    }
}

},{"react":"ltHCL","@atlaskit/platform-feature-flags":"8rD2i","../utils/isModernContextEnabledEnv":"5ecK5","./AnalyticsContext/LegacyAnalyticsContext":"9iDC1","./AnalyticsContext/ModernAnalyticsContext":"81od6","@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"9EUp7":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _objectSpread = require("@swc/helpers/_/_object_spread");
var _objectSpreadProps = require("@swc/helpers/_/_object_spread_props");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _useAnalyticsEvents = require("../hooks/useAnalyticsEvents");
var _usePatchedProps = require("../hooks/usePatchedProps");
const withAnalyticsEvents = (createEventMap = {})=>(WrappedComponent)=>{
        const WithAnalyticsEvents = /*#__PURE__*/ (0, _react.forwardRef)((props, ref)=>{
            // eslint-disable-next-line @typescript-eslint/ban-ts-comment
            // @ts-ignore: to unblock React 18.2.0 -> 18.3.1 version bump in Jira
            const { patchedEventProps } = (0, _usePatchedProps.usePatchedProps)(createEventMap, props);
            const { createAnalyticsEvent } = (0, _useAnalyticsEvents.useAnalyticsEvents)();
            return /*#__PURE__*/ (0, _reactDefault.default).createElement(WrappedComponent, (0, _objectSpreadProps._)((0, _objectSpread._)({}, props, patchedEventProps), {
                createAnalyticsEvent: createAnalyticsEvent,
                ref: ref
            }));
        });
        WithAnalyticsEvents.displayName = `WithAnalyticsEvents(${WrappedComponent.displayName || WrappedComponent.name})`;
        return WithAnalyticsEvents;
    };
exports.default = withAnalyticsEvents;

},{"@swc/helpers/_/_object_spread":"9gdrV","@swc/helpers/_/_object_spread_props":"kANqQ","react":"ltHCL","../hooks/useAnalyticsEvents":"4ovq2","../hooks/usePatchedProps":"lhAol","@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"4ovq2":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "useAnalyticsEvents", ()=>useAnalyticsEvents);
var _useMemoOne = require("use-memo-one");
var _uianalyticsEvent = require("../events/UIAnalyticsEvent");
var _uianalyticsEventDefault = parcelHelpers.interopDefault(_uianalyticsEvent);
var _useAnalyticsContext = require("./useAnalyticsContext");
function useAnalyticsEvents() {
    const analyticsContext = (0, _useAnalyticsContext.useAnalyticsContext)();
    const createAnalyticsEvent = (0, _useMemoOne.useCallbackOne)((payload)=>{
        return new (0, _uianalyticsEventDefault.default)({
            context: analyticsContext.getAtlaskitAnalyticsContext(),
            handlers: analyticsContext.getAtlaskitAnalyticsEventHandlers(),
            payload
        });
    }, [
        analyticsContext
    ]);
    return {
        createAnalyticsEvent
    };
}

},{"use-memo-one":"aSYah","../events/UIAnalyticsEvent":"7JnK9","./useAnalyticsContext":"xGHKb","@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"aSYah":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "useCallback", ()=>useCallback);
parcelHelpers.export(exports, "useCallbackOne", ()=>useCallbackOne);
parcelHelpers.export(exports, "useMemo", ()=>useMemo);
parcelHelpers.export(exports, "useMemoOne", ()=>useMemoOne);
var _react = require("react");
function areInputsEqual(newInputs, lastInputs) {
    if (newInputs.length !== lastInputs.length) return false;
    for(var i = 0; i < newInputs.length; i++){
        if (newInputs[i] !== lastInputs[i]) return false;
    }
    return true;
}
function useMemoOne(getResult, inputs) {
    var initial = (0, _react.useState)(function() {
        return {
            inputs: inputs,
            result: getResult()
        };
    })[0];
    var isFirstRun = (0, _react.useRef)(true);
    var committed = (0, _react.useRef)(initial);
    var useCache = isFirstRun.current || Boolean(inputs && committed.current.inputs && areInputsEqual(inputs, committed.current.inputs));
    var cache = useCache ? committed.current : {
        inputs: inputs,
        result: getResult()
    };
    (0, _react.useEffect)(function() {
        isFirstRun.current = false;
        committed.current = cache;
    }, [
        cache
    ]);
    return cache.result;
}
function useCallbackOne(callback, inputs) {
    return useMemoOne(function() {
        return callback;
    }, inputs);
}
var useMemo = useMemoOne;
var useCallback = useCallbackOne;

},{"react":"ltHCL","@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"lhAol":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "usePatchedProps", ()=>usePatchedProps);
var _objectSpread = require("@swc/helpers/_/_object_spread");
var _objectSpreadProps = require("@swc/helpers/_/_object_spread_props");
var _react = require("react");
var _useAnalyticsEvents = require("./useAnalyticsEvents");
function usePatchedProps(createEventMap = {}, wrappedComponentProps) {
    const { createAnalyticsEvent } = (0, _useAnalyticsEvents.useAnalyticsEvents)();
    const handlerCache = (0, _react.useRef)({});
    const patchedProps = (0, _react.useMemo)(()=>{
        const cache = handlerCache.current;
        // Clean up no longer used handlers in cache
        Object.keys(cache).filter((key)=>!(key in createEventMap)).forEach((key)=>delete cache[key]);
        return Object.keys(createEventMap).reduce((p, k)=>{
            const eventCreator = createEventMap[k];
            if (![
                'object',
                'function'
            ].includes(typeof eventCreator)) return p;
            const propValue = wrappedComponentProps[k];
            if (k in cache && cache[k].eventCreator === eventCreator && cache[k].propValue === propValue) return (0, _objectSpreadProps._)((0, _objectSpread._)({}, p), {
                [k]: cache[k].wrappedCallback
            });
            const wrappedCallback = (...args)=>{
                const analyticsEvent = typeof eventCreator === 'function' ? eventCreator(createAnalyticsEvent, wrappedComponentProps) : createAnalyticsEvent(eventCreator);
                if (propValue && typeof propValue === 'function') propValue(...args, analyticsEvent);
            };
            cache[k] = {
                eventCreator,
                wrappedCallback,
                propValue
            };
            return (0, _objectSpreadProps._)((0, _objectSpread._)({}, p), {
                [k]: wrappedCallback
            });
        }, {});
    }, [
        createEventMap,
        wrappedComponentProps,
        createAnalyticsEvent,
        handlerCache
    ]);
    return {
        patchedEventProps: patchedProps
    };
}

},{"@swc/helpers/_/_object_spread":"9gdrV","@swc/helpers/_/_object_spread_props":"kANqQ","react":"ltHCL","./useAnalyticsEvents":"4ovq2","@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"8O6Tj":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>(0, _analyticsNextStableReactContextDefault.default));
var _analyticsNextStableReactContext = require("@atlaskit/analytics-next-stable-react-context");
var _analyticsNextStableReactContextDefault = parcelHelpers.interopDefault(_analyticsNextStableReactContext);

},{"@atlaskit/analytics-next-stable-react-context":"3ToEo","@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"1hM7U":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "useCallbackWithAnalytics", ()=>useCallbackWithAnalytics);
var _react = require("react");
var _useAnalyticsEvents = require("./useAnalyticsEvents");
var _useTrackedRef = require("./useTrackedRef");
const useCallbackWithAnalytics = (method, payload, channel)=>{
    const { createAnalyticsEvent } = (0, _useAnalyticsEvents.useAnalyticsEvents)();
    const methodRef = (0, _useTrackedRef.useTrackedRef)(method);
    const payloadRef = (0, _useTrackedRef.useTrackedRef)(payload);
    return (0, _react.useCallback)((...args)=>{
        const pload = typeof payloadRef.current === 'function' ? payloadRef.current(...args) : payloadRef.current;
        createAnalyticsEvent(pload).fire(channel);
        methodRef.current(...args);
    }, [
        createAnalyticsEvent,
        methodRef,
        payloadRef,
        channel
    ]);
};

},{"react":"ltHCL","./useAnalyticsEvents":"4ovq2","./useTrackedRef":"eemrC","@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"dRWFk":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
// WARNING: This hook will only function correctly for leaf node components - as in
// no children inside the component will require analytics themselves.
// Ignoring this warning will mean the analytics context of child components will not
// include the context of this component, .e.g, lost data.
// If you are going to have child components that require analytics use withAnalytics
// or AnalyticsContext component instead.
parcelHelpers.export(exports, "usePlatformLeafEventHandler", ()=>usePlatformLeafEventHandler);
var _objectSpread = require("@swc/helpers/_/_object_spread");
var _react = require("react");
var _useAnalyticsEvents = require("./useAnalyticsEvents");
var _useTrackedRef = require("./useTrackedRef");
function usePlatformLeafEventHandler({ fn, action, componentName, actionSubject, packageName, packageVersion, analyticsData }) {
    const { createAnalyticsEvent } = (0, _useAnalyticsEvents.useAnalyticsEvents)();
    // We put analyticsData and fn in a ref so that we don't need to break
    // memoization.
    // Generally these could be defined by consumers inline
    // and so we do this to avoid breaking memoization of useCallback
    const dataRef = (0, _useTrackedRef.useTrackedRef)(analyticsData);
    const fnRef = (0, _useTrackedRef.useTrackedRef)(fn);
    const handler = (0, _react.useCallback)((value)=>{
        const analyticsEvent = createAnalyticsEvent({
            action,
            actionSubject: actionSubject || componentName,
            attributes: {
                componentName,
                packageName,
                packageVersion
            }
        });
        // To avoid wrapping this component in AnalyticsContext we manually
        // push the parent context's meta data into the context.
        // Note: this new 'context'
        const context = (0, _objectSpread._)({
            componentName,
            packageName,
            packageVersion
        }, dataRef.current);
        analyticsEvent.context.push(context);
        // fire an event on the atlaskit channel
        const clone = analyticsEvent.clone();
        if (clone) clone.fire('atlaskit');
        fnRef.current(value, analyticsEvent);
    }, [
        // These are strings and won't change
        action,
        componentName,
        actionSubject,
        packageName,
        packageVersion,
        // This function is memoized in the context
        createAnalyticsEvent,
        // these are a stable ref because of the useTrackedRef hook
        dataRef,
        fnRef
    ]);
    return handler;
}

},{"@swc/helpers/_/_object_spread":"9gdrV","react":"ltHCL","./useAnalyticsEvents":"4ovq2","./useTrackedRef":"eemrC","@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"cHtVJ":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
// WARNING: This hook will only function correctly for leaf node components - as in
// no children inside the component will require analytics themselves.
// Ignoring this warning will mean the analytics context of child components will not
// include the context of this component, .e.g, lost data.
// If you are going to have child components that require analytics use withAnalytics
// or AnalyticsContext component instead.
parcelHelpers.export(exports, "usePlatformLeafSyntheticEventHandler", ()=>usePlatformLeafSyntheticEventHandler);
var _objectSpread = require("@swc/helpers/_/_object_spread");
var _react = require("react");
var _useAnalyticsEvents = require("./useAnalyticsEvents");
var _useTrackedRef = require("./useTrackedRef");
function usePlatformLeafSyntheticEventHandler({ fn, action, componentName, packageName, packageVersion, analyticsData }) {
    const { createAnalyticsEvent } = (0, _useAnalyticsEvents.useAnalyticsEvents)();
    // We put analyticsData and fn in a ref so that we don't need to break
    // memoization.
    // Generally these could be defined by consumers inline
    // and so we do this to avoid breaking memoization of useCallback
    const dataRef = (0, _useTrackedRef.useTrackedRef)(analyticsData);
    const fnRef = (0, _useTrackedRef.useTrackedRef)(fn);
    const handler = (0, _react.useCallback)(()=>{
        const analyticsEvent = createAnalyticsEvent({
            action,
            actionSubject: componentName,
            attributes: {
                componentName,
                packageName,
                packageVersion
            }
        });
        // To avoid wrapping this component in AnalyticsContext we manually
        // push the parent context's meta data into the context.
        // Note: this new 'context'
        const context = (0, _objectSpread._)({
            componentName,
            packageName,
            packageVersion
        }, dataRef.current);
        analyticsEvent.context.push(context);
        // fire an event on the atlaskit channel
        const clone = analyticsEvent.clone();
        if (clone) clone.fire('atlaskit');
        fnRef.current(analyticsEvent);
    }, [
        // These are strings and won't change
        action,
        componentName,
        packageName,
        packageVersion,
        // This function is memoized in the context
        createAnalyticsEvent,
        // these are a stable ref because of the useTrackedRef hook
        dataRef,
        fnRef
    ]);
    return handler;
}

},{"@swc/helpers/_/_object_spread":"9gdrV","react":"ltHCL","./useAnalyticsEvents":"4ovq2","./useTrackedRef":"eemrC","@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"krugf":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
exports.default = (channel)=>(payload)=>(createAnalyticsEvent)=>{
            const consumerEvent = createAnalyticsEvent(payload);
            const clonedEvent = consumerEvent.clone();
            if (clonedEvent) clonedEvent.fire(channel);
            return consumerEvent;
        };

},{"@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"Q7E8P":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>cleanProps);
var _objectWithoutProperties = require("@swc/helpers/_/_object_without_properties");
function cleanProps(props) {
    const { createAnalyticsEvent } = props, cleanedProps = (0, _objectWithoutProperties._)(props, [
        "createAnalyticsEvent"
    ]);
    return cleanedProps;
}

},{"@swc/helpers/_/_object_without_properties":"6HqIM","@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"axS2O":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "ContextTypes", ()=>(0, _contextTypes.ContextTypes));
parcelHelpers.export(exports, "AnalyticsDecorator", ()=>(0, _analyticsDecorator.AnalyticsDecorator));
var _analyticsDecorator = require("./AnalyticsDecorator");
var _contextTypes = require("./ContextTypes");
exports.default = (0, _analyticsDecorator.AnalyticsDecorator);

},{"./AnalyticsDecorator":"9jy3h","./ContextTypes":false,"@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"9jy3h":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
// eslint-disable-next-line @repo/internal/react/no-class-components
parcelHelpers.export(exports, "AnalyticsDecorator", ()=>AnalyticsDecorator);
var _objectSpread = require("@swc/helpers/_/_object_spread");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _matchEvent = require("../matchEvent");
var _matchEventDefault = parcelHelpers.interopDefault(_matchEvent);
var _contextTypes = require("./ContextTypes");
class AnalyticsDecorator extends (0, _react.Component) {
    getChildContext() {
        return {
            onAnalyticsEvent: this.onAnalyticsEvent,
            getParentAnalyticsData: this.getParentAnalyticsData
        };
    }
    render() {
        const { children } = this.props;
        return (0, _reactDefault.default).Children.only(children);
    }
    constructor(...args){
        super(...args), this.getDecoratedAnalyticsData = (name, srcData, isPrivate)=>{
            const { data, getData, match, matchPrivate } = this.props;
            const decoratedData = (0, _objectSpread._)({}, srcData);
            if (matchPrivate === isPrivate && (0, _matchEventDefault.default)(match, name)) {
                if (typeof data === 'object') Object.assign(decoratedData, data);
                if (typeof getData === 'function') Object.assign(decoratedData, getData(name, decoratedData));
            }
            return decoratedData;
        }, this.onAnalyticsEvent = (name, srcData, isPrivate)=>{
            const { onAnalyticsEvent } = this.context;
            if (typeof onAnalyticsEvent !== 'function') return;
            const decoratedData = this.getDecoratedAnalyticsData(name, srcData, isPrivate);
            onAnalyticsEvent(name, decoratedData, isPrivate);
        }, this.getParentAnalyticsData = (name, isPrivate)=>{
            const parentData = this.getDecoratedAnalyticsData(name, {}, isPrivate);
            const { getParentAnalyticsData } = this.context;
            if (typeof getParentAnalyticsData === 'function') Object.assign(parentData, getParentAnalyticsData(name, isPrivate));
            return parentData;
        };
    }
}
AnalyticsDecorator.defaultProps = {
    match: '*',
    matchPrivate: false
};
AnalyticsDecorator.contextTypes = (0, _contextTypes.ContextTypes);
AnalyticsDecorator.childContextTypes = (0, _contextTypes.ContextTypes);

},{"@swc/helpers/_/_object_spread":"9gdrV","react":"ltHCL","../matchEvent":"jWGy6","./ContextTypes":"fzlD6","@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"jWGy6":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
const ENDS_WITH_DOT = /\.$/;
function matchEvent(matcher, name) {
    if (matcher === '*' || name === undefined) return true;
    if (typeof matcher === 'string') {
        if (ENDS_WITH_DOT.test(matcher)) return name.substr(0, matcher.length) === matcher;
        return name === matcher;
    }
    if (typeof matcher === 'function') return matcher(name);
    return matcher.test(name);
}
exports.default = matchEvent;

},{"@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"fzlD6":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "ContextTypes", ()=>ContextTypes);
var _propTypes = require("prop-types");
var _propTypesDefault = parcelHelpers.interopDefault(_propTypes);
const ContextTypes = {
    onAnalyticsEvent: (0, _propTypesDefault.default).func,
    getParentAnalyticsData: (0, _propTypesDefault.default).func
};

},{"prop-types":"3k3Jl","@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"8YgQf":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _objectSpread = require("@swc/helpers/_/_object_spread");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _propTypes = require("prop-types");
var _propTypesDefault = parcelHelpers.interopDefault(_propTypes);
const ContextTypes = {
    onAnalyticsEvent: (0, _propTypesDefault.default).func
};
/**
 * Listens to public and private events and delegates to an analytics
 * stack in a different React root.
 */ // eslint-disable-next-line @repo/internal/react/no-class-components
class AnalyticsDelegate extends (0, _react.Component) {
    getChildContext() {
        return {
            onAnalyticsEvent: this.onAnalyticsEvent
        };
    }
    render() {
        const { children } = this.props;
        return (0, _reactDefault.default).Children.only(children);
    }
    constructor(...args){
        super(...args), this.onAnalyticsEvent = (name, data, isPrivate)=>{
            const { delegateAnalyticsEvent } = this.props;
            const eventData = (0, _objectSpread._)({}, data);
            if (delegateAnalyticsEvent) delegateAnalyticsEvent(name, eventData, isPrivate);
            const { onAnalyticsEvent } = this.context;
            if (typeof onAnalyticsEvent === 'function') onAnalyticsEvent(name, data, isPrivate);
        };
    }
}
AnalyticsDelegate.contextTypes = ContextTypes;
AnalyticsDelegate.childContextTypes = ContextTypes;
exports.default = AnalyticsDelegate;

},{"@swc/helpers/_/_object_spread":"9gdrV","react":"ltHCL","prop-types":"3k3Jl","@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"8wY1m":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _objectSpread = require("@swc/helpers/_/_object_spread");
var _objectWithoutProperties = require("@swc/helpers/_/_object_without_properties");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _propTypes = require("prop-types");
var _propTypesDefault = parcelHelpers.interopDefault(_propTypes);
/**
 * The withAnalytics HOC wraps a component and provides the `fireAnalyticsEvent`
 * and `firePrivateAnalyticsEvent` methods to it as props. It contains the logic
 * for how to fire events, including handling the analyticsId and analyticsData
 * props. The `map` argument may be an object or a function that returns an object.
 * The properties of the `map` object/result can be strings (the name of the event
 * that will be fired) or functions (which are responsible for firing the event).
 * You can specify a default `analyticsId` and `analyticsData` with the `defaultProps`
 * param. Please be aware that specifying a default `analyticsId` will cause public
 * events to always fire for your component unless it has been set to a falsy by
 * the component consumer.
 *
 * @param WrappedComponent
 * @param map
 * @param defaultProps
 * @param withDelegation
 */ const withAnalytics = (WrappedComponent, map = {}, defaultProps = {}, withDelegation)=>{
    var _WithAnalytics;
    return _WithAnalytics = class WithAnalytics extends (0, _react.Component) {
        componentDidMount() {
            this.setState({
                evaluatedMap: typeof map === 'function' ? map(this.fireAnalyticsEvent) : map
            });
        }
        render() {
            const _this_props = this.props, { analyticsId, analyticsData } = _this_props, componentProps = (0, _objectWithoutProperties._)(_this_props, [
                "analyticsId",
                "analyticsData"
            ]);
            Object.keys(this.state.evaluatedMap).forEach((prop)=>{
                const handler = this.state.evaluatedMap[prop];
                const originalProp = componentProps[prop];
                componentProps[prop] = (...args)=>{
                    if (typeof handler === 'function') handler(...args);
                    else this.fireAnalyticsEvent(handler);
                    if (typeof originalProp === 'function') originalProp(...args);
                };
            });
            return /*#__PURE__*/ (0, _reactDefault.default).createElement(WrappedComponent, (0, _objectSpread._)({
                fireAnalyticsEvent: this.fireAnalyticsEvent,
                firePrivateAnalyticsEvent: this.privateAnalyticsEvent,
                getParentAnalyticsData: this.getParentAnalyticsData,
                delegateAnalyticsEvent: withDelegation ? this.delegateAnalyticsEvent : undefined,
                analyticsId: analyticsId,
                ref: this.props.innerRef
            }, componentProps));
        }
        constructor(props){
            super(props), this.delegateAnalyticsEvent = (analyticsId, data, isPrivate)=>{
                const { onAnalyticsEvent } = this.context;
                if (!onAnalyticsEvent) return;
                onAnalyticsEvent(analyticsId, data, isPrivate);
            }, this.fireAnalyticsEvent = (name, data)=>{
                const { analyticsData, analyticsId } = this.props;
                const { onAnalyticsEvent } = this.context;
                if (!analyticsId || !onAnalyticsEvent) return;
                const eventData = (0, _objectSpread._)({}, analyticsData, data);
                onAnalyticsEvent(`${analyticsId}.${name}`, eventData, false);
            }, this.privateAnalyticsEvent = (name, data)=>{
                const { onAnalyticsEvent } = this.context;
                if (!onAnalyticsEvent) return;
                onAnalyticsEvent(`${name}`, data, true);
            }, this.getParentAnalyticsData = (name)=>{
                const { getParentAnalyticsData } = this.context;
                let parentData = {};
                if (typeof getParentAnalyticsData === 'function' && this.props.analyticsId) {
                    const { analyticsId } = this.props;
                    parentData = getParentAnalyticsData(`${analyticsId}.${name}`, false);
                }
                return parentData;
            };
            this.state = {
                evaluatedMap: {}
            };
        }
    }, _WithAnalytics.displayName = `WithAnalytics(${WrappedComponent.displayName || WrappedComponent.name})`, _WithAnalytics.contextTypes = {
        onAnalyticsEvent: (0, _propTypesDefault.default).func,
        getParentAnalyticsData: (0, _propTypesDefault.default).func
    }, _WithAnalytics.defaultProps = {
        analyticsId: defaultProps.analyticsId,
        analyticsData: defaultProps.analyticsData
    }, _WithAnalytics;
};
exports.default = withAnalytics;

},{"@swc/helpers/_/_object_spread":"9gdrV","@swc/helpers/_/_object_without_properties":"6HqIM","react":"ltHCL","prop-types":"3k3Jl","@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"be2wK":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "handleEvent", ()=>handleEvent);
var _analyticsWebClientWrapper = require("../analytics-web-client-wrapper");
var _processEventPayload = require("./process-event-payload");
const handleEvent = (event, // If passing through multiple tags, the primary tag should be first in the array.
// The primary tag is used for matching context.
tags, logger, client)=>{
    if (!event.payload) return;
    const payload = (0, _processEventPayload.processEventPayload)(event, tags);
    (0, _analyticsWebClientWrapper.sendEvent)(logger, client)(payload);
};

},{"../analytics-web-client-wrapper":"jZkkN","./process-event-payload":"ghPNO","@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"jZkkN":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "sendEvent", ()=>sendEvent);
var _objectWithoutProperties = require("@swc/helpers/_/_object_without_properties");
const isPromise = (c)=>{
    return typeof c.then === 'function';
};
const sendEvent = (logger, client)=>(event)=>{
        if (client) {
            const { eventType } = event, gasEvent = (0, _objectWithoutProperties._)(event, [
                "eventType"
            ]);
            const withClient = (cb)=>{
                if (isPromise(client)) client.then(cb).catch((e)=>logger.warn('There was an error sending the event', e));
                else try {
                    cb(client);
                } catch (e) {
                    logger.warn('There was an error sending the event', e);
                }
            };
            switch(event.eventType){
                case 'ui':
                    logger.debug('Sending UI Event via analytics client', gasEvent);
                    withClient((client)=>client.sendUIEvent(gasEvent));
                    break;
                case 'operational':
                    logger.debug('Sending Operational Event via analytics client', gasEvent);
                    withClient((client)=>client.sendOperationalEvent(gasEvent));
                    break;
                case 'track':
                    logger.debug('Sending Track Event via analytics client', gasEvent);
                    withClient((client)=>client.sendTrackEvent(gasEvent));
                    break;
                case 'screen':
                    logger.debug('Sending Screen Event via analytics client', gasEvent);
                    withClient((client)=>client.sendScreenEvent(gasEvent));
                    break;
                default:
                    logger.error(`cannot map eventType ${event.eventType} to an analytics-web-client function`);
            }
        } else logger.warn('AnalyticsWebClient instance is not provided');
    };

},{"@swc/helpers/_/_object_without_properties":"6HqIM","@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"ghPNO":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "processEventPayload", ()=>processEventPayload);
var _objectSpread = require("@swc/helpers/_/_object_spread");
var _objectSpreadProps = require("@swc/helpers/_/_object_spread_props");
var _objectWithoutProperties = require("@swc/helpers/_/_object_without_properties");
var _toPropertyKey = require("@swc/helpers/_/_to_property_key");
var _analyticsGasTypes = require("@atlaskit/analytics-gas-types");
var _analyticsNamespacedContext = require("@atlaskit/analytics-namespaced-context");
var _merge = require("lodash/merge");
var _mergeDefault = parcelHelpers.interopDefault(_merge);
var _fabricElementsListener = require("./FabricElementsListener");
var _fabricEditorListener = require("./FabricEditorListener");
const extractFieldsFromContext = (fieldsToPick)=>(contexts)=>contexts.map((ctx)=>fieldsToPick.reduce((result, key)=>ctx[key] ? (0, _mergeDefault.default)(result, {
                    [key]: ctx[key]
                }) : result, {})).reduce((result, item)=>(0, _mergeDefault.default)(result, item), {});
const fieldExtractor = (contextKey)=>extractFieldsFromContext([
        'source',
        'objectType',
        'objectId',
        'containerType',
        'containerId',
        contextKey
    ]);
const getContextKey = (tag)=>{
    switch(tag){
        case 0, _fabricElementsListener.ELEMENTS_TAG:
            return 0, _analyticsNamespacedContext.ELEMENTS_CONTEXT;
        case 0, _fabricEditorListener.EDITOR_TAG:
            return 0, _analyticsNamespacedContext.EDITOR_CONTEXT;
        default:
            return '';
    }
};
const updatePayloadWithContext = (primaryTag, event)=>{
    if (event.context.length === 0) return (0, _objectSpread._)({
        source: (0, _analyticsGasTypes.DEFAULT_SOURCE)
    }, event.payload);
    const contextKey = getContextKey(primaryTag) || 'attributes';
    const _fieldExtractor = fieldExtractor(contextKey)(event.context), { [contextKey]: attributes } = _fieldExtractor, fields = (0, _objectWithoutProperties._)(_fieldExtractor, [
        contextKey
    ].map((0, _toPropertyKey._)));
    if (attributes) event.payload.attributes = (0, _mergeDefault.default)(attributes, event.payload.attributes || {});
    return (0, _objectSpread._)({
        source: (0, _analyticsGasTypes.DEFAULT_SOURCE)
    }, fields, event.payload);
};
const addTags = (tags, originalTags = [])=>{
    const mergedTags = new Set([
        ...originalTags,
        ...tags
    ]);
    return Array.from(mergedTags);
};
/**
 * The primary tag is used for matching the analytics event payload
 * with its context.
 */ function getPrimaryTag(tags) {
    if (typeof tags === 'string') return tags;
    if (!tags.length) throw new Error('Empty tags string array. Unable to match analytics event payload with context');
    return tags[0];
}
const processEventPayload = (event, tags)=>{
    const primaryTag = getPrimaryTag(tags);
    const tagsArray = typeof tags === 'string' ? [
        tags
    ] : tags;
    return (0, _objectSpreadProps._)((0, _objectSpread._)({}, updatePayloadWithContext(primaryTag, event)), {
        tags: addTags(tagsArray, event.payload.tags)
    });
};

},{"@swc/helpers/_/_object_spread":"9gdrV","@swc/helpers/_/_object_spread_props":"kANqQ","@swc/helpers/_/_object_without_properties":"6HqIM","@swc/helpers/_/_to_property_key":"6fsv0","@atlaskit/analytics-gas-types":"4JJns","@atlaskit/analytics-namespaced-context":"gQwAM","lodash/merge":"yJjRX","./FabricElementsListener":"jlgoM","./FabricEditorListener":"fKHX1","@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"6fsv0":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "_", ()=>_to_property_key);
var _toPrimitiveJs = require("./_to_primitive.js");
var _typeOfJs = require("./_type_of.js");
function _to_property_key(arg) {
    var key = (0, _toPrimitiveJs._)(arg, "string");
    return (0, _typeOfJs._)(key) === "symbol" ? key : String(key);
}

},{"./_to_primitive.js":"18g3k","./_type_of.js":"iFJdx","@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"18g3k":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "_", ()=>_to_primitive);
var _typeOfJs = require("./_type_of.js");
function _to_primitive(input, hint) {
    if ((0, _typeOfJs._)(input) !== "object" || input === null) return input;
    var prim = input[Symbol.toPrimitive];
    if (prim !== undefined) {
        var res = prim.call(input, hint || "default");
        if ((0, _typeOfJs._)(res) !== "object") return res;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return (hint === "string" ? String : Number)(input);
}

},{"./_type_of.js":"iFJdx","@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"iFJdx":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "_", ()=>_type_of);
function _type_of(obj) {
    "@swc/helpers - typeof";
    return obj && typeof Symbol !== "undefined" && obj.constructor === Symbol ? "symbol" : typeof obj;
}

},{"@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"4JJns":[function(require,module,exports,__globalThis) {
// same types defined in analytics-web-client but avoid creating dependency with that
var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "UI_EVENT_TYPE", ()=>UI_EVENT_TYPE);
parcelHelpers.export(exports, "TRACK_EVENT_TYPE", ()=>TRACK_EVENT_TYPE);
parcelHelpers.export(exports, "SCREEN_EVENT_TYPE", ()=>SCREEN_EVENT_TYPE);
parcelHelpers.export(exports, "OPERATIONAL_EVENT_TYPE", ()=>OPERATIONAL_EVENT_TYPE);
parcelHelpers.export(exports, "DEFAULT_SOURCE", ()=>DEFAULT_SOURCE);
const UI_EVENT_TYPE = 'ui';
const TRACK_EVENT_TYPE = 'track';
const SCREEN_EVENT_TYPE = 'screen';
const OPERATIONAL_EVENT_TYPE = 'operational';
const DEFAULT_SOURCE = 'unknown';

},{"@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"gQwAM":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "ELEMENTS_CONTEXT", ()=>(0, _fabricElementsAnalyticsContext.ELEMENTS_CONTEXT));
parcelHelpers.export(exports, "FabricElementsAnalyticsContext", ()=>(0, _fabricElementsAnalyticsContext.FabricElementsAnalyticsContext));
parcelHelpers.export(exports, "NAVIGATION_CONTEXT", ()=>(0, _navigationAnalyticsContext.NAVIGATION_CONTEXT));
parcelHelpers.export(exports, "NavigationAnalyticsContext", ()=>(0, _navigationAnalyticsContext.NavigationAnalyticsContext));
parcelHelpers.export(exports, "EDITOR_CONTEXT", ()=>(0, _fabricEditorAnalyticsContext.EDITOR_CONTEXT));
parcelHelpers.export(exports, "EDITOR_APPEARANCE_CONTEXT", ()=>(0, _fabricEditorAnalyticsContext.EDITOR_APPEARANCE_CONTEXT));
parcelHelpers.export(exports, "FabricEditorAnalyticsContext", ()=>(0, _fabricEditorAnalyticsContext.FabricEditorAnalyticsContext));
parcelHelpers.export(exports, "MEDIA_CONTEXT", ()=>(0, _mediaAnalyticsContext.MEDIA_CONTEXT));
parcelHelpers.export(exports, "PEOPLE_TEAMS_CONTEXT", ()=>(0, _peopleTeamsAnalyticsContext.PEOPLE_TEAMS_CONTEXT));
parcelHelpers.export(exports, "PeopleTeamsAnalyticsContext", ()=>(0, _peopleTeamsAnalyticsContext.PeopleTeamsAnalyticsContext));
parcelHelpers.export(exports, "NOTIFICATIONS_CONTEXT", ()=>(0, _notificationsAnalyticsContext.NOTIFICATIONS_CONTEXT));
parcelHelpers.export(exports, "NotificationsAnalyticsContext", ()=>(0, _notificationsAnalyticsContext.NotificationsAnalyticsContext));
parcelHelpers.export(exports, "RECENT_WORK_CONTEXT", ()=>(0, _recentWorkAnalyticsContext.RECENT_WORK_CONTEXT));
parcelHelpers.export(exports, "RecentWorkAnalyticsContext", ()=>(0, _recentWorkAnalyticsContext.RecentWorkAnalyticsContext));
parcelHelpers.export(exports, "ATLAS_CONTEXT", ()=>(0, _atlasAnalyticsContext.ATLAS_CONTEXT));
parcelHelpers.export(exports, "AtlasAnalyticsContext", ()=>(0, _atlasAnalyticsContext.AtlasAnalyticsContext));
parcelHelpers.export(exports, "TOWNSQUARE_HOME_CONTEXT", ()=>(0, _townsquareHomeAnalyticsContext.TOWNSQUARE_HOME_CONTEXT));
parcelHelpers.export(exports, "TownsquareHomeAnalyticsContext", ()=>(0, _townsquareHomeAnalyticsContext.TownsquareHomeAnalyticsContext));
parcelHelpers.export(exports, "LINKING_PLATFORM_CONTEXT", ()=>(0, _linkingPlatformAnalyticsContext.LINKING_PLATFORM_CONTEXT));
parcelHelpers.export(exports, "LinkingPlatformAnalyticsContext", ()=>(0, _linkingPlatformAnalyticsContext.LinkingPlatformAnalyticsContext));
parcelHelpers.export(exports, "POST_OFFICE_CONTEXT", ()=>(0, _postOfficeAnalyticsContext.POST_OFFICE_CONTEXT));
parcelHelpers.export(exports, "PostOfficeAnalyticsContext", ()=>(0, _postOfficeAnalyticsContext.PostOfficeAnalyticsContext));
parcelHelpers.export(exports, "AI_MATE_CONTEXT", ()=>(0, _aimateAnalyticsContext.AI_MATE_CONTEXT));
parcelHelpers.export(exports, "AIMateAnalyticsContext", ()=>(0, _aimateAnalyticsContext.AIMateAnalyticsContext));
parcelHelpers.export(exports, "AVP_CONTEXT", ()=>(0, _avpanalyticsContext.AVP_CONTEXT));
parcelHelpers.export(exports, "AVPAnalyticsContext", ()=>(0, _avpanalyticsContext.AVPAnalyticsContext));
parcelHelpers.export(exports, "GROWTH_CONTEXT", ()=>(0, _growthAnalyticsContext.GROWTH_CONTEXT));
parcelHelpers.export(exports, "GrowthAnalyticsContext", ()=>(0, _growthAnalyticsContext.GrowthAnalyticsContext));
parcelHelpers.export(exports, "OMNI_CHANNEL_CONTEXT", ()=>(0, _omniChannelAnalyticsContext.OMNI_CHANNEL_CONTEXT));
parcelHelpers.export(exports, "OmniChannelAnalyticsContext", ()=>(0, _omniChannelAnalyticsContext.OmniChannelAnalyticsContext));
parcelHelpers.export(exports, "ROVO_EXTENSION_CONTEXT", ()=>(0, _rovoExtensionAnalyticsContext.ROVO_EXTENSION_CONTEXT));
parcelHelpers.export(exports, "RovoExtensionAnalyticsContext", ()=>(0, _rovoExtensionAnalyticsContext.RovoExtensionAnalyticsContext));
var _fabricElementsAnalyticsContext = require("./FabricElementsAnalyticsContext");
var _navigationAnalyticsContext = require("./NavigationAnalyticsContext");
var _fabricEditorAnalyticsContext = require("./FabricEditorAnalyticsContext");
var _mediaAnalyticsContext = require("./MediaAnalyticsContext");
var _peopleTeamsAnalyticsContext = require("./PeopleTeamsAnalyticsContext");
var _notificationsAnalyticsContext = require("./NotificationsAnalyticsContext");
var _recentWorkAnalyticsContext = require("./RecentWorkAnalyticsContext");
var _atlasAnalyticsContext = require("./AtlasAnalyticsContext");
var _townsquareHomeAnalyticsContext = require("./TownsquareHomeAnalyticsContext");
var _linkingPlatformAnalyticsContext = require("./LinkingPlatformAnalyticsContext");
var _postOfficeAnalyticsContext = require("./PostOfficeAnalyticsContext");
var _aimateAnalyticsContext = require("./AIMateAnalyticsContext");
var _avpanalyticsContext = require("./AVPAnalyticsContext");
var _growthAnalyticsContext = require("./GrowthAnalyticsContext");
var _omniChannelAnalyticsContext = require("./OmniChannelAnalyticsContext");
var _rovoExtensionAnalyticsContext = require("./RovoExtensionAnalyticsContext");

},{"./FabricElementsAnalyticsContext":"dzmjy","./NavigationAnalyticsContext":"fXIgB","./FabricEditorAnalyticsContext":"bLkcw","./MediaAnalyticsContext":"e3aZR","./PeopleTeamsAnalyticsContext":"ltMjY","./NotificationsAnalyticsContext":"dvINK","./RecentWorkAnalyticsContext":"4wOUi","./AtlasAnalyticsContext":"Ouxod","./TownsquareHomeAnalyticsContext":"53wqh","./LinkingPlatformAnalyticsContext":"4QDV8","./PostOfficeAnalyticsContext":"96ozt","./AIMateAnalyticsContext":"jbUpZ","./AVPAnalyticsContext":"e8WxI","./GrowthAnalyticsContext":"3LqXe","./OmniChannelAnalyticsContext":"bin5I","./RovoExtensionAnalyticsContext":"8Kxgc","@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"dzmjy":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "ELEMENTS_CONTEXT", ()=>ELEMENTS_CONTEXT);
parcelHelpers.export(exports, "FabricElementsAnalyticsContext", ()=>FabricElementsAnalyticsContext);
var _createNamespaceContext = require("./helper/createNamespaceContext");
var _createNamespaceContextDefault = parcelHelpers.interopDefault(_createNamespaceContext);
const ELEMENTS_CONTEXT = 'fabricElementsCtx';
const FabricElementsAnalyticsContext = (0, _createNamespaceContextDefault.default)(ELEMENTS_CONTEXT, 'FabricElementsAnalyticsContext');

},{"./helper/createNamespaceContext":"gJWm2","@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"gJWm2":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _analyticsNext = require("@atlaskit/analytics-next");
const createNamespaceContext = (namespace, displayName = 'NamespacedContext')=>{
    const Component = (props)=>{
        const newData = {
            [namespace]: props.data
        };
        return /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _analyticsNext.AnalyticsContext), {
            data: newData
        }, (0, _reactDefault.default).Children.only(props.children));
    };
    Component.displayName = displayName;
    return Component;
};
exports.default = createNamespaceContext;

},{"react":"ltHCL","@atlaskit/analytics-next":"6PLie","@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"fXIgB":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "NAVIGATION_CONTEXT", ()=>NAVIGATION_CONTEXT);
parcelHelpers.export(exports, "NavigationAnalyticsContext", ()=>NavigationAnalyticsContext);
var _createNamespaceContext = require("./helper/createNamespaceContext");
var _createNamespaceContextDefault = parcelHelpers.interopDefault(_createNamespaceContext);
const NAVIGATION_CONTEXT = 'navigationCtx';
const NavigationAnalyticsContext = (0, _createNamespaceContextDefault.default)(NAVIGATION_CONTEXT, 'NavigationAnalyticsContext');

},{"./helper/createNamespaceContext":"gJWm2","@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"bLkcw":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "EDITOR_CONTEXT", ()=>EDITOR_CONTEXT);
parcelHelpers.export(exports, "EDITOR_APPEARANCE_CONTEXT", ()=>EDITOR_APPEARANCE_CONTEXT);
parcelHelpers.export(exports, "FabricEditorAnalyticsContext", ()=>FabricEditorAnalyticsContext);
var _createNamespaceContext = require("./helper/createNamespaceContext");
var _createNamespaceContextDefault = parcelHelpers.interopDefault(_createNamespaceContext);
const EDITOR_CONTEXT = 'fabricEditorCtx';
var EDITOR_APPEARANCE_CONTEXT = /*#__PURE__*/ function(EDITOR_APPEARANCE_CONTEXT) {
    EDITOR_APPEARANCE_CONTEXT["FIXED_WIDTH"] = "fixedWidth";
    EDITOR_APPEARANCE_CONTEXT["FULL_WIDTH"] = "fullWidth";
    EDITOR_APPEARANCE_CONTEXT["COMMENT"] = "comment";
    EDITOR_APPEARANCE_CONTEXT["CHROMELESS"] = "chromeless";
    EDITOR_APPEARANCE_CONTEXT["MOBILE"] = "mobile";
    EDITOR_APPEARANCE_CONTEXT["MAX"] = "max";
    return EDITOR_APPEARANCE_CONTEXT;
}({});
const FabricEditorAnalyticsContext = (0, _createNamespaceContextDefault.default)(EDITOR_CONTEXT, 'FabricEditorAnalyticsContext');

},{"./helper/createNamespaceContext":"gJWm2","@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"e3aZR":[function(require,module,exports,__globalThis) {
// Media uses a namespaced analytics context under the following key MEDIA_CONTEXT.
var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "MEDIA_CONTEXT", ()=>MEDIA_CONTEXT);
const MEDIA_CONTEXT = 'mediaCtx'; // However we don't export any JSX component to create that namespaced analytics context.
 // In media components, analytics context is being created by this component:
 // @see packages/media/media-common/src/analytics/withMediaAnalyticsContext.tsx

},{"@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"ltMjY":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "PEOPLE_TEAMS_CONTEXT", ()=>PEOPLE_TEAMS_CONTEXT);
parcelHelpers.export(exports, "PeopleTeamsAnalyticsContext", ()=>PeopleTeamsAnalyticsContext);
var _createNamespaceContext = require("./helper/createNamespaceContext");
var _createNamespaceContextDefault = parcelHelpers.interopDefault(_createNamespaceContext);
const PEOPLE_TEAMS_CONTEXT = 'peopleTeamsCtx';
const PeopleTeamsAnalyticsContext = (0, _createNamespaceContextDefault.default)(PEOPLE_TEAMS_CONTEXT, 'PeopleTeamsAnalyticsContext');

},{"./helper/createNamespaceContext":"gJWm2","@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"dvINK":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "NOTIFICATIONS_CONTEXT", ()=>NOTIFICATIONS_CONTEXT);
parcelHelpers.export(exports, "NotificationsAnalyticsContext", ()=>NotificationsAnalyticsContext);
var _createNamespaceContext = require("./helper/createNamespaceContext");
var _createNamespaceContextDefault = parcelHelpers.interopDefault(_createNamespaceContext);
const NOTIFICATIONS_CONTEXT = 'NotificationsCtx';
const NotificationsAnalyticsContext = (0, _createNamespaceContextDefault.default)(NOTIFICATIONS_CONTEXT, 'NotificationsAnalyticsContext');

},{"./helper/createNamespaceContext":"gJWm2","@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"4wOUi":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "RECENT_WORK_CONTEXT", ()=>RECENT_WORK_CONTEXT);
parcelHelpers.export(exports, "RecentWorkAnalyticsContext", ()=>RecentWorkAnalyticsContext);
var _createNamespaceContext = require("./helper/createNamespaceContext");
var _createNamespaceContextDefault = parcelHelpers.interopDefault(_createNamespaceContext);
const RECENT_WORK_CONTEXT = 'RecentWorkCtx';
const RecentWorkAnalyticsContext = (0, _createNamespaceContextDefault.default)(RECENT_WORK_CONTEXT, 'RecentWorkAnalyticsContext');

},{"./helper/createNamespaceContext":"gJWm2","@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"Ouxod":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "ATLAS_CONTEXT", ()=>ATLAS_CONTEXT);
parcelHelpers.export(exports, "AtlasAnalyticsContext", ()=>AtlasAnalyticsContext);
var _createNamespaceContext = require("./helper/createNamespaceContext");
var _createNamespaceContextDefault = parcelHelpers.interopDefault(_createNamespaceContext);
const ATLAS_CONTEXT = 'atlasCtx';
const AtlasAnalyticsContext = (0, _createNamespaceContextDefault.default)(ATLAS_CONTEXT, 'AtlasAnalyticsContext');

},{"./helper/createNamespaceContext":"gJWm2","@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"53wqh":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "TOWNSQUARE_HOME_CONTEXT", ()=>TOWNSQUARE_HOME_CONTEXT);
parcelHelpers.export(exports, "TownsquareHomeAnalyticsContext", ()=>TownsquareHomeAnalyticsContext);
var _createNamespaceContext = require("./helper/createNamespaceContext");
var _createNamespaceContextDefault = parcelHelpers.interopDefault(_createNamespaceContext);
const TOWNSQUARE_HOME_CONTEXT = 'townsquareHomeCtx';
const TownsquareHomeAnalyticsContext = (0, _createNamespaceContextDefault.default)(TOWNSQUARE_HOME_CONTEXT, 'TownsquareHomeAnalyticsContext');

},{"./helper/createNamespaceContext":"gJWm2","@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"4QDV8":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "LINKING_PLATFORM_CONTEXT", ()=>LINKING_PLATFORM_CONTEXT);
parcelHelpers.export(exports, "LinkingPlatformAnalyticsContext", ()=>LinkingPlatformAnalyticsContext);
var _createNamespaceContext = require("./helper/createNamespaceContext");
var _createNamespaceContextDefault = parcelHelpers.interopDefault(_createNamespaceContext);
const LINKING_PLATFORM_CONTEXT = 'linkingPlatformCtx';
const LinkingPlatformAnalyticsContext = (0, _createNamespaceContextDefault.default)(LINKING_PLATFORM_CONTEXT, 'LinkingPlatformAnalyticsContext');

},{"./helper/createNamespaceContext":"gJWm2","@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"96ozt":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "POST_OFFICE_CONTEXT", ()=>POST_OFFICE_CONTEXT);
parcelHelpers.export(exports, "PostOfficeAnalyticsContext", ()=>PostOfficeAnalyticsContext);
var _createNamespaceContext = require("./helper/createNamespaceContext");
var _createNamespaceContextDefault = parcelHelpers.interopDefault(_createNamespaceContext);
const POST_OFFICE_CONTEXT = 'postOfficeCtx';
const PostOfficeAnalyticsContext = (0, _createNamespaceContextDefault.default)(POST_OFFICE_CONTEXT, 'PostOfficeAnalyticsContext');

},{"./helper/createNamespaceContext":"gJWm2","@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"jbUpZ":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "AI_MATE_CONTEXT", ()=>AI_MATE_CONTEXT);
parcelHelpers.export(exports, "AIMateAnalyticsContext", ()=>AIMateAnalyticsContext);
var _createNamespaceContext = require("./helper/createNamespaceContext");
var _createNamespaceContextDefault = parcelHelpers.interopDefault(_createNamespaceContext);
const AI_MATE_CONTEXT = 'aiMateCtx';
const AIMateAnalyticsContext = (0, _createNamespaceContextDefault.default)(AI_MATE_CONTEXT, 'AIMateAnalyticsContext');

},{"./helper/createNamespaceContext":"gJWm2","@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"e8WxI":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "AVP_CONTEXT", ()=>AVP_CONTEXT);
parcelHelpers.export(exports, "AVPAnalyticsContext", ()=>AVPAnalyticsContext);
var _createNamespaceContext = require("./helper/createNamespaceContext");
var _createNamespaceContextDefault = parcelHelpers.interopDefault(_createNamespaceContext);
const AVP_CONTEXT = 'avpCtx';
const AVPAnalyticsContext = (0, _createNamespaceContextDefault.default)(AVP_CONTEXT, 'AVPAnalyticsContext');

},{"./helper/createNamespaceContext":"gJWm2","@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"3LqXe":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "GROWTH_CONTEXT", ()=>GROWTH_CONTEXT);
parcelHelpers.export(exports, "GrowthAnalyticsContext", ()=>GrowthAnalyticsContext);
var _createNamespaceContext = require("./helper/createNamespaceContext");
var _createNamespaceContextDefault = parcelHelpers.interopDefault(_createNamespaceContext);
const GROWTH_CONTEXT = 'editionAwarenessCtx';
const GrowthAnalyticsContext = (0, _createNamespaceContextDefault.default)(GROWTH_CONTEXT, 'GrowthAnalyticsContext');

},{"./helper/createNamespaceContext":"gJWm2","@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"bin5I":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "OMNI_CHANNEL_CONTEXT", ()=>OMNI_CHANNEL_CONTEXT);
parcelHelpers.export(exports, "OmniChannelAnalyticsContext", ()=>OmniChannelAnalyticsContext);
var _createNamespaceContext = require("./helper/createNamespaceContext");
var _createNamespaceContextDefault = parcelHelpers.interopDefault(_createNamespaceContext);
const OMNI_CHANNEL_CONTEXT = 'omniChannelCtx';
const OmniChannelAnalyticsContext = (0, _createNamespaceContextDefault.default)(OMNI_CHANNEL_CONTEXT, 'OmniChannelAnalyticsContext');

},{"./helper/createNamespaceContext":"gJWm2","@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"8Kxgc":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "ROVO_EXTENSION_CONTEXT", ()=>ROVO_EXTENSION_CONTEXT);
parcelHelpers.export(exports, "RovoExtensionAnalyticsContext", ()=>RovoExtensionAnalyticsContext);
var _createNamespaceContext = require("./helper/createNamespaceContext");
var _createNamespaceContextDefault = parcelHelpers.interopDefault(_createNamespaceContext);
const ROVO_EXTENSION_CONTEXT = 'rovoExtensionCtx';
const RovoExtensionAnalyticsContext = (0, _createNamespaceContextDefault.default)(ROVO_EXTENSION_CONTEXT, 'RovoExtensionAnalyticsContext');

},{"./helper/createNamespaceContext":"gJWm2","@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"yJjRX":[function(require,module,exports,__globalThis) {
var baseMerge = require("437a4ba6f4b8d0f8"), createAssigner = require("bac51cc9cc20662e");
/**
 * This method is like `_.assign` except that it recursively merges own and
 * inherited enumerable string keyed properties of source objects into the
 * destination object. Source properties that resolve to `undefined` are
 * skipped if a destination value exists. Array and plain object properties
 * are merged recursively. Other objects and value types are overridden by
 * assignment. Source objects are applied from left to right. Subsequent
 * sources overwrite property assignments of previous sources.
 *
 * **Note:** This method mutates `object`.
 *
 * @static
 * @memberOf _
 * @since 0.5.0
 * @category Object
 * @param {Object} object The destination object.
 * @param {...Object} [sources] The source objects.
 * @returns {Object} Returns `object`.
 * @example
 *
 * var object = {
 *   'a': [{ 'b': 2 }, { 'd': 4 }]
 * };
 *
 * var other = {
 *   'a': [{ 'c': 3 }, { 'e': 5 }]
 * };
 *
 * _.merge(object, other);
 * // => { 'a': [{ 'b': 2, 'c': 3 }, { 'd': 4, 'e': 5 }] }
 */ var merge = createAssigner(function(object, source, srcIndex) {
    baseMerge(object, source, srcIndex);
});
module.exports = merge;

},{"437a4ba6f4b8d0f8":"8M7ww","bac51cc9cc20662e":"biT2Z"}],"8M7ww":[function(require,module,exports,__globalThis) {
var Stack = require("2e14d7430cab0d3b"), assignMergeValue = require("7f6a5ab09465a048"), baseFor = require("17266b5db9438eb"), baseMergeDeep = require("323195e81ac9bf48"), isObject = require("945540e4a412e520"), keysIn = require("60e98c7e28e452f3"), safeGet = require("6cf52da84dfc5152");
/**
 * The base implementation of `_.merge` without support for multiple sources.
 *
 * @private
 * @param {Object} object The destination object.
 * @param {Object} source The source object.
 * @param {number} srcIndex The index of `source`.
 * @param {Function} [customizer] The function to customize merged values.
 * @param {Object} [stack] Tracks traversed source values and their merged
 *  counterparts.
 */ function baseMerge(object, source, srcIndex, customizer, stack) {
    if (object === source) return;
    baseFor(source, function(srcValue, key) {
        stack || (stack = new Stack);
        if (isObject(srcValue)) baseMergeDeep(object, source, key, srcIndex, baseMerge, customizer, stack);
        else {
            var newValue = customizer ? customizer(safeGet(object, key), srcValue, key + '', object, source, stack) : undefined;
            if (newValue === undefined) newValue = srcValue;
            assignMergeValue(object, key, newValue);
        }
    }, keysIn);
}
module.exports = baseMerge;

},{"2e14d7430cab0d3b":"klKXc","7f6a5ab09465a048":"5L61B","17266b5db9438eb":"8lORV","323195e81ac9bf48":"aNX3B","945540e4a412e520":"cGl8g","60e98c7e28e452f3":"jke6l","6cf52da84dfc5152":"4SOk0"}],"klKXc":[function(require,module,exports,__globalThis) {
var ListCache = require("87cc126d86eb4ab7"), stackClear = require("e1919e4b7ad7f4bb"), stackDelete = require("b127d0b08dacac2c"), stackGet = require("2a349e691867c700"), stackHas = require("17d159e23594520a"), stackSet = require("feae6d753331380c");
/**
 * Creates a stack cache object to store key-value pairs.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */ function Stack(entries) {
    var data = this.__data__ = new ListCache(entries);
    this.size = data.size;
}
// Add methods to `Stack`.
Stack.prototype.clear = stackClear;
Stack.prototype['delete'] = stackDelete;
Stack.prototype.get = stackGet;
Stack.prototype.has = stackHas;
Stack.prototype.set = stackSet;
module.exports = Stack;

},{"87cc126d86eb4ab7":"16MdZ","e1919e4b7ad7f4bb":"70dIe","b127d0b08dacac2c":"k1L1w","2a349e691867c700":"6bBkJ","17d159e23594520a":"kFmld","feae6d753331380c":"7Yj9R"}],"16MdZ":[function(require,module,exports,__globalThis) {
var listCacheClear = require("b71d75d4acf9d7eb"), listCacheDelete = require("a926e646705440b3"), listCacheGet = require("34815e5c91501dd1"), listCacheHas = require("630f4e79cd11ac37"), listCacheSet = require("7463d569c4a09448");
/**
 * Creates an list cache object.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */ function ListCache(entries) {
    var index = -1, length = entries == null ? 0 : entries.length;
    this.clear();
    while(++index < length){
        var entry = entries[index];
        this.set(entry[0], entry[1]);
    }
}
// Add methods to `ListCache`.
ListCache.prototype.clear = listCacheClear;
ListCache.prototype['delete'] = listCacheDelete;
ListCache.prototype.get = listCacheGet;
ListCache.prototype.has = listCacheHas;
ListCache.prototype.set = listCacheSet;
module.exports = ListCache;

},{"b71d75d4acf9d7eb":"aYCka","a926e646705440b3":"eqplm","34815e5c91501dd1":"j7r4n","630f4e79cd11ac37":"6Xuxr","7463d569c4a09448":"4JBNu"}],"aYCka":[function(require,module,exports,__globalThis) {
/**
 * Removes all key-value entries from the list cache.
 *
 * @private
 * @name clear
 * @memberOf ListCache
 */ function listCacheClear() {
    this.__data__ = [];
    this.size = 0;
}
module.exports = listCacheClear;

},{}],"eqplm":[function(require,module,exports,__globalThis) {
var assocIndexOf = require("ec997521b4cc6f54");
/** Used for built-in method references. */ var arrayProto = Array.prototype;
/** Built-in value references. */ var splice = arrayProto.splice;
/**
 * Removes `key` and its value from the list cache.
 *
 * @private
 * @name delete
 * @memberOf ListCache
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */ function listCacheDelete(key) {
    var data = this.__data__, index = assocIndexOf(data, key);
    if (index < 0) return false;
    var lastIndex = data.length - 1;
    if (index == lastIndex) data.pop();
    else splice.call(data, index, 1);
    --this.size;
    return true;
}
module.exports = listCacheDelete;

},{"ec997521b4cc6f54":"6wCl3"}],"6wCl3":[function(require,module,exports,__globalThis) {
var eq = require("4546935c2f35fbd9");
/**
 * Gets the index at which the `key` is found in `array` of key-value pairs.
 *
 * @private
 * @param {Array} array The array to inspect.
 * @param {*} key The key to search for.
 * @returns {number} Returns the index of the matched value, else `-1`.
 */ function assocIndexOf(array, key) {
    var length = array.length;
    while(length--){
        if (eq(array[length][0], key)) return length;
    }
    return -1;
}
module.exports = assocIndexOf;

},{"4546935c2f35fbd9":"cZv4K"}],"cZv4K":[function(require,module,exports,__globalThis) {
/**
 * Performs a
 * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
 * comparison between two values to determine if they are equivalent.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to compare.
 * @param {*} other The other value to compare.
 * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
 * @example
 *
 * var object = { 'a': 1 };
 * var other = { 'a': 1 };
 *
 * _.eq(object, object);
 * // => true
 *
 * _.eq(object, other);
 * // => false
 *
 * _.eq('a', 'a');
 * // => true
 *
 * _.eq('a', Object('a'));
 * // => false
 *
 * _.eq(NaN, NaN);
 * // => true
 */ function eq(value, other) {
    return value === other || value !== value && other !== other;
}
module.exports = eq;

},{}],"j7r4n":[function(require,module,exports,__globalThis) {
var assocIndexOf = require("4a0faf37d4fefe47");
/**
 * Gets the list cache value for `key`.
 *
 * @private
 * @name get
 * @memberOf ListCache
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */ function listCacheGet(key) {
    var data = this.__data__, index = assocIndexOf(data, key);
    return index < 0 ? undefined : data[index][1];
}
module.exports = listCacheGet;

},{"4a0faf37d4fefe47":"6wCl3"}],"6Xuxr":[function(require,module,exports,__globalThis) {
var assocIndexOf = require("e5d21baa4555ebc9");
/**
 * Checks if a list cache value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf ListCache
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */ function listCacheHas(key) {
    return assocIndexOf(this.__data__, key) > -1;
}
module.exports = listCacheHas;

},{"e5d21baa4555ebc9":"6wCl3"}],"4JBNu":[function(require,module,exports,__globalThis) {
var assocIndexOf = require("5ccd320c1b72467f");
/**
 * Sets the list cache `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf ListCache
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the list cache instance.
 */ function listCacheSet(key, value) {
    var data = this.__data__, index = assocIndexOf(data, key);
    if (index < 0) {
        ++this.size;
        data.push([
            key,
            value
        ]);
    } else data[index][1] = value;
    return this;
}
module.exports = listCacheSet;

},{"5ccd320c1b72467f":"6wCl3"}],"70dIe":[function(require,module,exports,__globalThis) {
var ListCache = require("e0ce0a3712ddf917");
/**
 * Removes all key-value entries from the stack.
 *
 * @private
 * @name clear
 * @memberOf Stack
 */ function stackClear() {
    this.__data__ = new ListCache;
    this.size = 0;
}
module.exports = stackClear;

},{"e0ce0a3712ddf917":"16MdZ"}],"k1L1w":[function(require,module,exports,__globalThis) {
/**
 * Removes `key` and its value from the stack.
 *
 * @private
 * @name delete
 * @memberOf Stack
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */ function stackDelete(key) {
    var data = this.__data__, result = data['delete'](key);
    this.size = data.size;
    return result;
}
module.exports = stackDelete;

},{}],"6bBkJ":[function(require,module,exports,__globalThis) {
/**
 * Gets the stack value for `key`.
 *
 * @private
 * @name get
 * @memberOf Stack
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */ function stackGet(key) {
    return this.__data__.get(key);
}
module.exports = stackGet;

},{}],"kFmld":[function(require,module,exports,__globalThis) {
/**
 * Checks if a stack value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf Stack
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */ function stackHas(key) {
    return this.__data__.has(key);
}
module.exports = stackHas;

},{}],"7Yj9R":[function(require,module,exports,__globalThis) {
var ListCache = require("efe48d836c19061f"), Map = require("e389201705577ae4"), MapCache = require("76501d422cd6f2fa");
/** Used as the size to enable large array optimizations. */ var LARGE_ARRAY_SIZE = 200;
/**
 * Sets the stack `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf Stack
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the stack cache instance.
 */ function stackSet(key, value) {
    var data = this.__data__;
    if (data instanceof ListCache) {
        var pairs = data.__data__;
        if (!Map || pairs.length < LARGE_ARRAY_SIZE - 1) {
            pairs.push([
                key,
                value
            ]);
            this.size = ++data.size;
            return this;
        }
        data = this.__data__ = new MapCache(pairs);
    }
    data.set(key, value);
    this.size = data.size;
    return this;
}
module.exports = stackSet;

},{"efe48d836c19061f":"16MdZ","e389201705577ae4":"ddZHY","76501d422cd6f2fa":"bRb09"}],"ddZHY":[function(require,module,exports,__globalThis) {
var getNative = require("eb532942a00857cb"), root = require("bab57800dedcf18");
/* Built-in method references that are verified to be native. */ var Map = getNative(root, 'Map');
module.exports = Map;

},{"eb532942a00857cb":"bCwni","bab57800dedcf18":"J0J3B"}],"bCwni":[function(require,module,exports,__globalThis) {
var baseIsNative = require("f3ea5cb499788536"), getValue = require("fefe7a576e864dfa");
/**
 * Gets the native function at `key` of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @param {string} key The key of the method to get.
 * @returns {*} Returns the function if it's native, else `undefined`.
 */ function getNative(object, key) {
    var value = getValue(object, key);
    return baseIsNative(value) ? value : undefined;
}
module.exports = getNative;

},{"f3ea5cb499788536":"g3kur","fefe7a576e864dfa":"fNxok"}],"g3kur":[function(require,module,exports,__globalThis) {
var isFunction = require("f40733f620f1b80c"), isMasked = require("329a124b9731f600"), isObject = require("993a407aabe61bf8"), toSource = require("3e89fecd5e9373b9");
/**
 * Used to match `RegExp`
 * [syntax characters](http://ecma-international.org/ecma-262/7.0/#sec-patterns).
 */ var reRegExpChar = /[\\^$.*+?()[\]{}|]/g;
/** Used to detect host constructors (Safari). */ var reIsHostCtor = /^\[object .+?Constructor\]$/;
/** Used for built-in method references. */ var funcProto = Function.prototype, objectProto = Object.prototype;
/** Used to resolve the decompiled source of functions. */ var funcToString = funcProto.toString;
/** Used to check objects for own properties. */ var hasOwnProperty = objectProto.hasOwnProperty;
/** Used to detect if a method is native. */ var reIsNative = RegExp('^' + funcToString.call(hasOwnProperty).replace(reRegExpChar, '\\$&').replace(/hasOwnProperty|(function).*?(?=\\\()| for .+?(?=\\\])/g, '$1.*?') + '$');
/**
 * The base implementation of `_.isNative` without bad shim checks.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a native function,
 *  else `false`.
 */ function baseIsNative(value) {
    if (!isObject(value) || isMasked(value)) return false;
    var pattern = isFunction(value) ? reIsNative : reIsHostCtor;
    return pattern.test(toSource(value));
}
module.exports = baseIsNative;

},{"f40733f620f1b80c":"3d98s","329a124b9731f600":"lPxmg","993a407aabe61bf8":"cGl8g","3e89fecd5e9373b9":"gZQCn"}],"3d98s":[function(require,module,exports,__globalThis) {
var baseGetTag = require("dadf40f87eaa441"), isObject = require("17283b6429b6418b");
/** `Object#toString` result references. */ var asyncTag = '[object AsyncFunction]', funcTag = '[object Function]', genTag = '[object GeneratorFunction]', proxyTag = '[object Proxy]';
/**
 * Checks if `value` is classified as a `Function` object.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a function, else `false`.
 * @example
 *
 * _.isFunction(_);
 * // => true
 *
 * _.isFunction(/abc/);
 * // => false
 */ function isFunction(value) {
    if (!isObject(value)) return false;
    // The use of `Object#toString` avoids issues with the `typeof` operator
    // in Safari 9 which returns 'object' for typed arrays and other constructors.
    var tag = baseGetTag(value);
    return tag == funcTag || tag == genTag || tag == asyncTag || tag == proxyTag;
}
module.exports = isFunction;

},{"dadf40f87eaa441":"5NOi0","17283b6429b6418b":"cGl8g"}],"5NOi0":[function(require,module,exports,__globalThis) {
var Symbol = require("3cb98bf9c668e127"), getRawTag = require("a890e443a6f63268"), objectToString = require("f7eacc55b23a363d");
/** `Object#toString` result references. */ var nullTag = '[object Null]', undefinedTag = '[object Undefined]';
/** Built-in value references. */ var symToStringTag = Symbol ? Symbol.toStringTag : undefined;
/**
 * The base implementation of `getTag` without fallbacks for buggy environments.
 *
 * @private
 * @param {*} value The value to query.
 * @returns {string} Returns the `toStringTag`.
 */ function baseGetTag(value) {
    if (value == null) return value === undefined ? undefinedTag : nullTag;
    return symToStringTag && symToStringTag in Object(value) ? getRawTag(value) : objectToString(value);
}
module.exports = baseGetTag;

},{"3cb98bf9c668e127":"c4qDk","a890e443a6f63268":"35s1v","f7eacc55b23a363d":"ixMi2"}],"c4qDk":[function(require,module,exports,__globalThis) {
var root = require("5958f3272a74759c");
/** Built-in value references. */ var Symbol = root.Symbol;
module.exports = Symbol;

},{"5958f3272a74759c":"J0J3B"}],"J0J3B":[function(require,module,exports,__globalThis) {
var freeGlobal = require("6ef3f2a7d95f0e9c");
/** Detect free variable `self`. */ var freeSelf = typeof self == 'object' && self && self.Object === Object && self;
/** Used as a reference to the global object. */ var root = freeGlobal || freeSelf || Function('return this')();
module.exports = root;

},{"6ef3f2a7d95f0e9c":"7le4G"}],"7le4G":[function(require,module,exports,__globalThis) {
/** Detect free variable `global` from Node.js. */ var global = arguments[3];
var freeGlobal = typeof global == 'object' && global && global.Object === Object && global;
module.exports = freeGlobal;

},{}],"35s1v":[function(require,module,exports,__globalThis) {
var Symbol = require("932ce2caebcad844");
/** Used for built-in method references. */ var objectProto = Object.prototype;
/** Used to check objects for own properties. */ var hasOwnProperty = objectProto.hasOwnProperty;
/**
 * Used to resolve the
 * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
 * of values.
 */ var nativeObjectToString = objectProto.toString;
/** Built-in value references. */ var symToStringTag = Symbol ? Symbol.toStringTag : undefined;
/**
 * A specialized version of `baseGetTag` which ignores `Symbol.toStringTag` values.
 *
 * @private
 * @param {*} value The value to query.
 * @returns {string} Returns the raw `toStringTag`.
 */ function getRawTag(value) {
    var isOwn = hasOwnProperty.call(value, symToStringTag), tag = value[symToStringTag];
    try {
        value[symToStringTag] = undefined;
        var unmasked = true;
    } catch (e) {}
    var result = nativeObjectToString.call(value);
    if (unmasked) {
        if (isOwn) value[symToStringTag] = tag;
        else delete value[symToStringTag];
    }
    return result;
}
module.exports = getRawTag;

},{"932ce2caebcad844":"c4qDk"}],"ixMi2":[function(require,module,exports,__globalThis) {
/** Used for built-in method references. */ var objectProto = Object.prototype;
/**
 * Used to resolve the
 * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
 * of values.
 */ var nativeObjectToString = objectProto.toString;
/**
 * Converts `value` to a string using `Object.prototype.toString`.
 *
 * @private
 * @param {*} value The value to convert.
 * @returns {string} Returns the converted string.
 */ function objectToString(value) {
    return nativeObjectToString.call(value);
}
module.exports = objectToString;

},{}],"cGl8g":[function(require,module,exports,__globalThis) {
/**
 * Checks if `value` is the
 * [language type](http://www.ecma-international.org/ecma-262/7.0/#sec-ecmascript-language-types)
 * of `Object`. (e.g. arrays, functions, objects, regexes, `new Number(0)`, and `new String('')`)
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an object, else `false`.
 * @example
 *
 * _.isObject({});
 * // => true
 *
 * _.isObject([1, 2, 3]);
 * // => true
 *
 * _.isObject(_.noop);
 * // => true
 *
 * _.isObject(null);
 * // => false
 */ function isObject(value) {
    var type = typeof value;
    return value != null && (type == 'object' || type == 'function');
}
module.exports = isObject;

},{}],"lPxmg":[function(require,module,exports,__globalThis) {
var coreJsData = require("e047657f967c70ba");
/** Used to detect methods masquerading as native. */ var maskSrcKey = function() {
    var uid = /[^.]+$/.exec(coreJsData && coreJsData.keys && coreJsData.keys.IE_PROTO || '');
    return uid ? 'Symbol(src)_1.' + uid : '';
}();
/**
 * Checks if `func` has its source masked.
 *
 * @private
 * @param {Function} func The function to check.
 * @returns {boolean} Returns `true` if `func` is masked, else `false`.
 */ function isMasked(func) {
    return !!maskSrcKey && maskSrcKey in func;
}
module.exports = isMasked;

},{"e047657f967c70ba":"kxrkS"}],"kxrkS":[function(require,module,exports,__globalThis) {
var root = require("e5b83e425b8616ab");
/** Used to detect overreaching core-js shims. */ var coreJsData = root['__core-js_shared__'];
module.exports = coreJsData;

},{"e5b83e425b8616ab":"J0J3B"}],"gZQCn":[function(require,module,exports,__globalThis) {
/** Used for built-in method references. */ var funcProto = Function.prototype;
/** Used to resolve the decompiled source of functions. */ var funcToString = funcProto.toString;
/**
 * Converts `func` to its source code.
 *
 * @private
 * @param {Function} func The function to convert.
 * @returns {string} Returns the source code.
 */ function toSource(func) {
    if (func != null) {
        try {
            return funcToString.call(func);
        } catch (e) {}
        try {
            return func + '';
        } catch (e) {}
    }
    return '';
}
module.exports = toSource;

},{}],"fNxok":[function(require,module,exports,__globalThis) {
/**
 * Gets the value at `key` of `object`.
 *
 * @private
 * @param {Object} [object] The object to query.
 * @param {string} key The key of the property to get.
 * @returns {*} Returns the property value.
 */ function getValue(object, key) {
    return object == null ? undefined : object[key];
}
module.exports = getValue;

},{}],"bRb09":[function(require,module,exports,__globalThis) {
var mapCacheClear = require("eca41cec9d1a8d64"), mapCacheDelete = require("171ab6cd80f56036"), mapCacheGet = require("20aae7204f55fc7e"), mapCacheHas = require("cdbfb0efad84062c"), mapCacheSet = require("d69da3af899858a8");
/**
 * Creates a map cache object to store key-value pairs.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */ function MapCache(entries) {
    var index = -1, length = entries == null ? 0 : entries.length;
    this.clear();
    while(++index < length){
        var entry = entries[index];
        this.set(entry[0], entry[1]);
    }
}
// Add methods to `MapCache`.
MapCache.prototype.clear = mapCacheClear;
MapCache.prototype['delete'] = mapCacheDelete;
MapCache.prototype.get = mapCacheGet;
MapCache.prototype.has = mapCacheHas;
MapCache.prototype.set = mapCacheSet;
module.exports = MapCache;

},{"eca41cec9d1a8d64":"f6wAn","171ab6cd80f56036":"cK1SO","20aae7204f55fc7e":"5dWaY","cdbfb0efad84062c":"9f8o2","d69da3af899858a8":"lbC5d"}],"f6wAn":[function(require,module,exports,__globalThis) {
var Hash = require("506417564ee3161b"), ListCache = require("f2e413efad8ea8cf"), Map = require("5437ca7a29f4bc77");
/**
 * Removes all key-value entries from the map.
 *
 * @private
 * @name clear
 * @memberOf MapCache
 */ function mapCacheClear() {
    this.size = 0;
    this.__data__ = {
        'hash': new Hash,
        'map': new (Map || ListCache),
        'string': new Hash
    };
}
module.exports = mapCacheClear;

},{"506417564ee3161b":"gUs1X","f2e413efad8ea8cf":"16MdZ","5437ca7a29f4bc77":"ddZHY"}],"gUs1X":[function(require,module,exports,__globalThis) {
var hashClear = require("6481539823ca8950"), hashDelete = require("6c05e6226adc292f"), hashGet = require("6e2d3dd823ec0e77"), hashHas = require("3a427f94863b9c10"), hashSet = require("4be22030e06ca330");
/**
 * Creates a hash object.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */ function Hash(entries) {
    var index = -1, length = entries == null ? 0 : entries.length;
    this.clear();
    while(++index < length){
        var entry = entries[index];
        this.set(entry[0], entry[1]);
    }
}
// Add methods to `Hash`.
Hash.prototype.clear = hashClear;
Hash.prototype['delete'] = hashDelete;
Hash.prototype.get = hashGet;
Hash.prototype.has = hashHas;
Hash.prototype.set = hashSet;
module.exports = Hash;

},{"6481539823ca8950":"bCfdP","6c05e6226adc292f":"6SkdX","6e2d3dd823ec0e77":"5B4bf","3a427f94863b9c10":"jEfsM","4be22030e06ca330":"ywX7S"}],"bCfdP":[function(require,module,exports,__globalThis) {
var nativeCreate = require("a7ea255eaa79442e");
/**
 * Removes all key-value entries from the hash.
 *
 * @private
 * @name clear
 * @memberOf Hash
 */ function hashClear() {
    this.__data__ = nativeCreate ? nativeCreate(null) : {};
    this.size = 0;
}
module.exports = hashClear;

},{"a7ea255eaa79442e":"9u5hO"}],"9u5hO":[function(require,module,exports,__globalThis) {
var getNative = require("daeeff9a870ee4a");
/* Built-in method references that are verified to be native. */ var nativeCreate = getNative(Object, 'create');
module.exports = nativeCreate;

},{"daeeff9a870ee4a":"bCwni"}],"6SkdX":[function(require,module,exports,__globalThis) {
/**
 * Removes `key` and its value from the hash.
 *
 * @private
 * @name delete
 * @memberOf Hash
 * @param {Object} hash The hash to modify.
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */ function hashDelete(key) {
    var result = this.has(key) && delete this.__data__[key];
    this.size -= result ? 1 : 0;
    return result;
}
module.exports = hashDelete;

},{}],"5B4bf":[function(require,module,exports,__globalThis) {
var nativeCreate = require("b7faaa6a88154935");
/** Used to stand-in for `undefined` hash values. */ var HASH_UNDEFINED = '__lodash_hash_undefined__';
/** Used for built-in method references. */ var objectProto = Object.prototype;
/** Used to check objects for own properties. */ var hasOwnProperty = objectProto.hasOwnProperty;
/**
 * Gets the hash value for `key`.
 *
 * @private
 * @name get
 * @memberOf Hash
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */ function hashGet(key) {
    var data = this.__data__;
    if (nativeCreate) {
        var result = data[key];
        return result === HASH_UNDEFINED ? undefined : result;
    }
    return hasOwnProperty.call(data, key) ? data[key] : undefined;
}
module.exports = hashGet;

},{"b7faaa6a88154935":"9u5hO"}],"jEfsM":[function(require,module,exports,__globalThis) {
var nativeCreate = require("85efa9aac148c890");
/** Used for built-in method references. */ var objectProto = Object.prototype;
/** Used to check objects for own properties. */ var hasOwnProperty = objectProto.hasOwnProperty;
/**
 * Checks if a hash value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf Hash
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */ function hashHas(key) {
    var data = this.__data__;
    return nativeCreate ? data[key] !== undefined : hasOwnProperty.call(data, key);
}
module.exports = hashHas;

},{"85efa9aac148c890":"9u5hO"}],"ywX7S":[function(require,module,exports,__globalThis) {
var nativeCreate = require("e469e7c3f514318e");
/** Used to stand-in for `undefined` hash values. */ var HASH_UNDEFINED = '__lodash_hash_undefined__';
/**
 * Sets the hash `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf Hash
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the hash instance.
 */ function hashSet(key, value) {
    var data = this.__data__;
    this.size += this.has(key) ? 0 : 1;
    data[key] = nativeCreate && value === undefined ? HASH_UNDEFINED : value;
    return this;
}
module.exports = hashSet;

},{"e469e7c3f514318e":"9u5hO"}],"cK1SO":[function(require,module,exports,__globalThis) {
var getMapData = require("74825ed5833ef6b9");
/**
 * Removes `key` and its value from the map.
 *
 * @private
 * @name delete
 * @memberOf MapCache
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */ function mapCacheDelete(key) {
    var result = getMapData(this, key)['delete'](key);
    this.size -= result ? 1 : 0;
    return result;
}
module.exports = mapCacheDelete;

},{"74825ed5833ef6b9":"j7hIy"}],"j7hIy":[function(require,module,exports,__globalThis) {
var isKeyable = require("18bcdd78709075b6");
/**
 * Gets the data for `map`.
 *
 * @private
 * @param {Object} map The map to query.
 * @param {string} key The reference key.
 * @returns {*} Returns the map data.
 */ function getMapData(map, key) {
    var data = map.__data__;
    return isKeyable(key) ? data[typeof key == 'string' ? 'string' : 'hash'] : data.map;
}
module.exports = getMapData;

},{"18bcdd78709075b6":"bKvxr"}],"bKvxr":[function(require,module,exports,__globalThis) {
/**
 * Checks if `value` is suitable for use as unique object key.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is suitable, else `false`.
 */ function isKeyable(value) {
    var type = typeof value;
    return type == 'string' || type == 'number' || type == 'symbol' || type == 'boolean' ? value !== '__proto__' : value === null;
}
module.exports = isKeyable;

},{}],"5dWaY":[function(require,module,exports,__globalThis) {
var getMapData = require("efc637365e213bed");
/**
 * Gets the map value for `key`.
 *
 * @private
 * @name get
 * @memberOf MapCache
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */ function mapCacheGet(key) {
    return getMapData(this, key).get(key);
}
module.exports = mapCacheGet;

},{"efc637365e213bed":"j7hIy"}],"9f8o2":[function(require,module,exports,__globalThis) {
var getMapData = require("b85f72e2a889a5e1");
/**
 * Checks if a map value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf MapCache
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */ function mapCacheHas(key) {
    return getMapData(this, key).has(key);
}
module.exports = mapCacheHas;

},{"b85f72e2a889a5e1":"j7hIy"}],"lbC5d":[function(require,module,exports,__globalThis) {
var getMapData = require("41ed7e34f8452705");
/**
 * Sets the map `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf MapCache
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the map cache instance.
 */ function mapCacheSet(key, value) {
    var data = getMapData(this, key), size = data.size;
    data.set(key, value);
    this.size += data.size == size ? 0 : 1;
    return this;
}
module.exports = mapCacheSet;

},{"41ed7e34f8452705":"j7hIy"}],"5L61B":[function(require,module,exports,__globalThis) {
var baseAssignValue = require("fe599186a88388a2"), eq = require("8a971c10e65740b4");
/**
 * This function is like `assignValue` except that it doesn't assign
 * `undefined` values.
 *
 * @private
 * @param {Object} object The object to modify.
 * @param {string} key The key of the property to assign.
 * @param {*} value The value to assign.
 */ function assignMergeValue(object, key, value) {
    if (value !== undefined && !eq(object[key], value) || value === undefined && !(key in object)) baseAssignValue(object, key, value);
}
module.exports = assignMergeValue;

},{"fe599186a88388a2":"g5uWh","8a971c10e65740b4":"cZv4K"}],"g5uWh":[function(require,module,exports,__globalThis) {
var defineProperty = require("904bd1a355ae3276");
/**
 * The base implementation of `assignValue` and `assignMergeValue` without
 * value checks.
 *
 * @private
 * @param {Object} object The object to modify.
 * @param {string} key The key of the property to assign.
 * @param {*} value The value to assign.
 */ function baseAssignValue(object, key, value) {
    if (key == '__proto__' && defineProperty) defineProperty(object, key, {
        'configurable': true,
        'enumerable': true,
        'value': value,
        'writable': true
    });
    else object[key] = value;
}
module.exports = baseAssignValue;

},{"904bd1a355ae3276":"8uJO6"}],"8uJO6":[function(require,module,exports,__globalThis) {
var getNative = require("9d7533243ab33474");
var defineProperty = function() {
    try {
        var func = getNative(Object, 'defineProperty');
        func({}, '', {});
        return func;
    } catch (e) {}
}();
module.exports = defineProperty;

},{"9d7533243ab33474":"bCwni"}],"8lORV":[function(require,module,exports,__globalThis) {
var createBaseFor = require("89add122c7c33df0");
/**
 * The base implementation of `baseForOwn` which iterates over `object`
 * properties returned by `keysFunc` and invokes `iteratee` for each property.
 * Iteratee functions may exit iteration early by explicitly returning `false`.
 *
 * @private
 * @param {Object} object The object to iterate over.
 * @param {Function} iteratee The function invoked per iteration.
 * @param {Function} keysFunc The function to get the keys of `object`.
 * @returns {Object} Returns `object`.
 */ var baseFor = createBaseFor();
module.exports = baseFor;

},{"89add122c7c33df0":"hX3BU"}],"hX3BU":[function(require,module,exports,__globalThis) {
/**
 * Creates a base function for methods like `_.forIn` and `_.forOwn`.
 *
 * @private
 * @param {boolean} [fromRight] Specify iterating from right to left.
 * @returns {Function} Returns the new base function.
 */ function createBaseFor(fromRight) {
    return function(object, iteratee, keysFunc) {
        var index = -1, iterable = Object(object), props = keysFunc(object), length = props.length;
        while(length--){
            var key = props[fromRight ? length : ++index];
            if (iteratee(iterable[key], key, iterable) === false) break;
        }
        return object;
    };
}
module.exports = createBaseFor;

},{}],"aNX3B":[function(require,module,exports,__globalThis) {
var assignMergeValue = require("c94a11e8b8c350cc"), cloneBuffer = require("8d693ac5d256514a"), cloneTypedArray = require("902e5391d95df522"), copyArray = require("ddb42bd934c905d2"), initCloneObject = require("46ae1620f449ef7"), isArguments = require("c84b7597418dce36"), isArray = require("7a1dc61084bf6179"), isArrayLikeObject = require("ada7b25f08ba0a09"), isBuffer = require("cbeff241b1d58e6"), isFunction = require("2a7d80465d8f5bbd"), isObject = require("5fbd431708cf37a3"), isPlainObject = require("60cf99b47159fbd1"), isTypedArray = require("6015fd7060284a5e"), safeGet = require("f375afab775ffa9"), toPlainObject = require("b0c3c4152961c9a2");
/**
 * A specialized version of `baseMerge` for arrays and objects which performs
 * deep merges and tracks traversed objects enabling objects with circular
 * references to be merged.
 *
 * @private
 * @param {Object} object The destination object.
 * @param {Object} source The source object.
 * @param {string} key The key of the value to merge.
 * @param {number} srcIndex The index of `source`.
 * @param {Function} mergeFunc The function to merge values.
 * @param {Function} [customizer] The function to customize assigned values.
 * @param {Object} [stack] Tracks traversed source values and their merged
 *  counterparts.
 */ function baseMergeDeep(object, source, key, srcIndex, mergeFunc, customizer, stack) {
    var objValue = safeGet(object, key), srcValue = safeGet(source, key), stacked = stack.get(srcValue);
    if (stacked) {
        assignMergeValue(object, key, stacked);
        return;
    }
    var newValue = customizer ? customizer(objValue, srcValue, key + '', object, source, stack) : undefined;
    var isCommon = newValue === undefined;
    if (isCommon) {
        var isArr = isArray(srcValue), isBuff = !isArr && isBuffer(srcValue), isTyped = !isArr && !isBuff && isTypedArray(srcValue);
        newValue = srcValue;
        if (isArr || isBuff || isTyped) {
            if (isArray(objValue)) newValue = objValue;
            else if (isArrayLikeObject(objValue)) newValue = copyArray(objValue);
            else if (isBuff) {
                isCommon = false;
                newValue = cloneBuffer(srcValue, true);
            } else if (isTyped) {
                isCommon = false;
                newValue = cloneTypedArray(srcValue, true);
            } else newValue = [];
        } else if (isPlainObject(srcValue) || isArguments(srcValue)) {
            newValue = objValue;
            if (isArguments(objValue)) newValue = toPlainObject(objValue);
            else if (!isObject(objValue) || isFunction(objValue)) newValue = initCloneObject(srcValue);
        } else isCommon = false;
    }
    if (isCommon) {
        // Recursively merge objects and arrays (susceptible to call stack limits).
        stack.set(srcValue, newValue);
        mergeFunc(newValue, srcValue, srcIndex, customizer, stack);
        stack['delete'](srcValue);
    }
    assignMergeValue(object, key, newValue);
}
module.exports = baseMergeDeep;

},{"c94a11e8b8c350cc":"5L61B","8d693ac5d256514a":"dZ1Ok","902e5391d95df522":"j0AQ4","ddb42bd934c905d2":"a6FPd","46ae1620f449ef7":"4Ax51","c84b7597418dce36":"8QyUt","7a1dc61084bf6179":"7eHCl","ada7b25f08ba0a09":"fB5QR","cbeff241b1d58e6":"chGID","2a7d80465d8f5bbd":"3d98s","5fbd431708cf37a3":"cGl8g","60cf99b47159fbd1":"kQ0vI","6015fd7060284a5e":"3JUwD","f375afab775ffa9":"4SOk0","b0c3c4152961c9a2":"1I2He"}],"dZ1Ok":[function(require,module,exports,__globalThis) {
var root = require("489d138e70b3cb18");
/** Detect free variable `exports`. */ var freeExports = exports && !exports.nodeType && exports;
/** Detect free variable `module`. */ var freeModule = freeExports && true && module && !module.nodeType && module;
/** Detect the popular CommonJS extension `module.exports`. */ var moduleExports = freeModule && freeModule.exports === freeExports;
/** Built-in value references. */ var Buffer = moduleExports ? root.Buffer : undefined, allocUnsafe = Buffer ? Buffer.allocUnsafe : undefined;
/**
 * Creates a clone of  `buffer`.
 *
 * @private
 * @param {Buffer} buffer The buffer to clone.
 * @param {boolean} [isDeep] Specify a deep clone.
 * @returns {Buffer} Returns the cloned buffer.
 */ function cloneBuffer(buffer, isDeep) {
    if (isDeep) return buffer.slice();
    var length = buffer.length, result = allocUnsafe ? allocUnsafe(length) : new buffer.constructor(length);
    buffer.copy(result);
    return result;
}
module.exports = cloneBuffer;

},{"489d138e70b3cb18":"J0J3B"}],"j0AQ4":[function(require,module,exports,__globalThis) {
var cloneArrayBuffer = require("3659c8461d307f88");
/**
 * Creates a clone of `typedArray`.
 *
 * @private
 * @param {Object} typedArray The typed array to clone.
 * @param {boolean} [isDeep] Specify a deep clone.
 * @returns {Object} Returns the cloned typed array.
 */ function cloneTypedArray(typedArray, isDeep) {
    var buffer = isDeep ? cloneArrayBuffer(typedArray.buffer) : typedArray.buffer;
    return new typedArray.constructor(buffer, typedArray.byteOffset, typedArray.length);
}
module.exports = cloneTypedArray;

},{"3659c8461d307f88":"iINWl"}],"iINWl":[function(require,module,exports,__globalThis) {
var Uint8Array = require("3ea45460e4370dda");
/**
 * Creates a clone of `arrayBuffer`.
 *
 * @private
 * @param {ArrayBuffer} arrayBuffer The array buffer to clone.
 * @returns {ArrayBuffer} Returns the cloned array buffer.
 */ function cloneArrayBuffer(arrayBuffer) {
    var result = new arrayBuffer.constructor(arrayBuffer.byteLength);
    new Uint8Array(result).set(new Uint8Array(arrayBuffer));
    return result;
}
module.exports = cloneArrayBuffer;

},{"3ea45460e4370dda":"8RJdf"}],"8RJdf":[function(require,module,exports,__globalThis) {
var root = require("5f3272ac1c6427d3");
/** Built-in value references. */ var Uint8Array = root.Uint8Array;
module.exports = Uint8Array;

},{"5f3272ac1c6427d3":"J0J3B"}],"a6FPd":[function(require,module,exports,__globalThis) {
/**
 * Copies the values of `source` to `array`.
 *
 * @private
 * @param {Array} source The array to copy values from.
 * @param {Array} [array=[]] The array to copy values to.
 * @returns {Array} Returns `array`.
 */ function copyArray(source, array) {
    var index = -1, length = source.length;
    array || (array = Array(length));
    while(++index < length)array[index] = source[index];
    return array;
}
module.exports = copyArray;

},{}],"4Ax51":[function(require,module,exports,__globalThis) {
var baseCreate = require("9a4af657acb4e69b"), getPrototype = require("d1220476b44fe74b"), isPrototype = require("da1f5ecd056bea63");
/**
 * Initializes an object clone.
 *
 * @private
 * @param {Object} object The object to clone.
 * @returns {Object} Returns the initialized clone.
 */ function initCloneObject(object) {
    return typeof object.constructor == 'function' && !isPrototype(object) ? baseCreate(getPrototype(object)) : {};
}
module.exports = initCloneObject;

},{"9a4af657acb4e69b":"9cE55","d1220476b44fe74b":"yFmWQ","da1f5ecd056bea63":"flb0y"}],"9cE55":[function(require,module,exports,__globalThis) {
var isObject = require("1e8a7aa91552dc69");
/** Built-in value references. */ var objectCreate = Object.create;
/**
 * The base implementation of `_.create` without support for assigning
 * properties to the created object.
 *
 * @private
 * @param {Object} proto The object to inherit from.
 * @returns {Object} Returns the new object.
 */ var baseCreate = function() {
    function object() {}
    return function(proto) {
        if (!isObject(proto)) return {};
        if (objectCreate) return objectCreate(proto);
        object.prototype = proto;
        var result = new object;
        object.prototype = undefined;
        return result;
    };
}();
module.exports = baseCreate;

},{"1e8a7aa91552dc69":"cGl8g"}],"yFmWQ":[function(require,module,exports,__globalThis) {
var overArg = require("d8b8ed7420c88021");
/** Built-in value references. */ var getPrototype = overArg(Object.getPrototypeOf, Object);
module.exports = getPrototype;

},{"d8b8ed7420c88021":"1iwkr"}],"1iwkr":[function(require,module,exports,__globalThis) {
/**
 * Creates a unary function that invokes `func` with its argument transformed.
 *
 * @private
 * @param {Function} func The function to wrap.
 * @param {Function} transform The argument transform.
 * @returns {Function} Returns the new function.
 */ function overArg(func, transform) {
    return function(arg) {
        return func(transform(arg));
    };
}
module.exports = overArg;

},{}],"flb0y":[function(require,module,exports,__globalThis) {
/** Used for built-in method references. */ var objectProto = Object.prototype;
/**
 * Checks if `value` is likely a prototype object.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a prototype, else `false`.
 */ function isPrototype(value) {
    var Ctor = value && value.constructor, proto = typeof Ctor == 'function' && Ctor.prototype || objectProto;
    return value === proto;
}
module.exports = isPrototype;

},{}],"8QyUt":[function(require,module,exports,__globalThis) {
var baseIsArguments = require("e6a6a615dab5a023"), isObjectLike = require("282ffad55172636f");
/** Used for built-in method references. */ var objectProto = Object.prototype;
/** Used to check objects for own properties. */ var hasOwnProperty = objectProto.hasOwnProperty;
/** Built-in value references. */ var propertyIsEnumerable = objectProto.propertyIsEnumerable;
/**
 * Checks if `value` is likely an `arguments` object.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an `arguments` object,
 *  else `false`.
 * @example
 *
 * _.isArguments(function() { return arguments; }());
 * // => true
 *
 * _.isArguments([1, 2, 3]);
 * // => false
 */ var isArguments = baseIsArguments(function() {
    return arguments;
}()) ? baseIsArguments : function(value) {
    return isObjectLike(value) && hasOwnProperty.call(value, 'callee') && !propertyIsEnumerable.call(value, 'callee');
};
module.exports = isArguments;

},{"e6a6a615dab5a023":"eABvh","282ffad55172636f":"eoT9f"}],"eABvh":[function(require,module,exports,__globalThis) {
var baseGetTag = require("20bb2badda4bf28e"), isObjectLike = require("49a052186032281");
/** `Object#toString` result references. */ var argsTag = '[object Arguments]';
/**
 * The base implementation of `_.isArguments`.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an `arguments` object,
 */ function baseIsArguments(value) {
    return isObjectLike(value) && baseGetTag(value) == argsTag;
}
module.exports = baseIsArguments;

},{"20bb2badda4bf28e":"5NOi0","49a052186032281":"eoT9f"}],"eoT9f":[function(require,module,exports,__globalThis) {
/**
 * Checks if `value` is object-like. A value is object-like if it's not `null`
 * and has a `typeof` result of "object".
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is object-like, else `false`.
 * @example
 *
 * _.isObjectLike({});
 * // => true
 *
 * _.isObjectLike([1, 2, 3]);
 * // => true
 *
 * _.isObjectLike(_.noop);
 * // => false
 *
 * _.isObjectLike(null);
 * // => false
 */ function isObjectLike(value) {
    return value != null && typeof value == 'object';
}
module.exports = isObjectLike;

},{}],"7eHCl":[function(require,module,exports,__globalThis) {
/**
 * Checks if `value` is classified as an `Array` object.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an array, else `false`.
 * @example
 *
 * _.isArray([1, 2, 3]);
 * // => true
 *
 * _.isArray(document.body.children);
 * // => false
 *
 * _.isArray('abc');
 * // => false
 *
 * _.isArray(_.noop);
 * // => false
 */ var isArray = Array.isArray;
module.exports = isArray;

},{}],"fB5QR":[function(require,module,exports,__globalThis) {
var isArrayLike = require("ea07d6e9ec9cc082"), isObjectLike = require("e73c9bb470f1a40e");
/**
 * This method is like `_.isArrayLike` except that it also checks if `value`
 * is an object.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an array-like object,
 *  else `false`.
 * @example
 *
 * _.isArrayLikeObject([1, 2, 3]);
 * // => true
 *
 * _.isArrayLikeObject(document.body.children);
 * // => true
 *
 * _.isArrayLikeObject('abc');
 * // => false
 *
 * _.isArrayLikeObject(_.noop);
 * // => false
 */ function isArrayLikeObject(value) {
    return isObjectLike(value) && isArrayLike(value);
}
module.exports = isArrayLikeObject;

},{"ea07d6e9ec9cc082":"d4PO7","e73c9bb470f1a40e":"eoT9f"}],"d4PO7":[function(require,module,exports,__globalThis) {
var isFunction = require("87fbba5fdd05275b"), isLength = require("236b61174fa9ad31");
/**
 * Checks if `value` is array-like. A value is considered array-like if it's
 * not a function and has a `value.length` that's an integer greater than or
 * equal to `0` and less than or equal to `Number.MAX_SAFE_INTEGER`.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is array-like, else `false`.
 * @example
 *
 * _.isArrayLike([1, 2, 3]);
 * // => true
 *
 * _.isArrayLike(document.body.children);
 * // => true
 *
 * _.isArrayLike('abc');
 * // => true
 *
 * _.isArrayLike(_.noop);
 * // => false
 */ function isArrayLike(value) {
    return value != null && isLength(value.length) && !isFunction(value);
}
module.exports = isArrayLike;

},{"87fbba5fdd05275b":"3d98s","236b61174fa9ad31":"axBps"}],"axBps":[function(require,module,exports,__globalThis) {
/** Used as references for various `Number` constants. */ var MAX_SAFE_INTEGER = 9007199254740991;
/**
 * Checks if `value` is a valid array-like length.
 *
 * **Note:** This method is loosely based on
 * [`ToLength`](http://ecma-international.org/ecma-262/7.0/#sec-tolength).
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a valid length, else `false`.
 * @example
 *
 * _.isLength(3);
 * // => true
 *
 * _.isLength(Number.MIN_VALUE);
 * // => false
 *
 * _.isLength(Infinity);
 * // => false
 *
 * _.isLength('3');
 * // => false
 */ function isLength(value) {
    return typeof value == 'number' && value > -1 && value % 1 == 0 && value <= MAX_SAFE_INTEGER;
}
module.exports = isLength;

},{}],"chGID":[function(require,module,exports,__globalThis) {
var root = require("24ee364a4c69a957"), stubFalse = require("8263c4f23efad726");
/** Detect free variable `exports`. */ var freeExports = exports && !exports.nodeType && exports;
/** Detect free variable `module`. */ var freeModule = freeExports && true && module && !module.nodeType && module;
/** Detect the popular CommonJS extension `module.exports`. */ var moduleExports = freeModule && freeModule.exports === freeExports;
/** Built-in value references. */ var Buffer = moduleExports ? root.Buffer : undefined;
/* Built-in method references for those with the same name as other `lodash` methods. */ var nativeIsBuffer = Buffer ? Buffer.isBuffer : undefined;
/**
 * Checks if `value` is a buffer.
 *
 * @static
 * @memberOf _
 * @since 4.3.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a buffer, else `false`.
 * @example
 *
 * _.isBuffer(new Buffer(2));
 * // => true
 *
 * _.isBuffer(new Uint8Array(2));
 * // => false
 */ var isBuffer = nativeIsBuffer || stubFalse;
module.exports = isBuffer;

},{"24ee364a4c69a957":"J0J3B","8263c4f23efad726":"8q6IA"}],"8q6IA":[function(require,module,exports,__globalThis) {
/**
 * This method returns `false`.
 *
 * @static
 * @memberOf _
 * @since 4.13.0
 * @category Util
 * @returns {boolean} Returns `false`.
 * @example
 *
 * _.times(2, _.stubFalse);
 * // => [false, false]
 */ function stubFalse() {
    return false;
}
module.exports = stubFalse;

},{}],"kQ0vI":[function(require,module,exports,__globalThis) {
var baseGetTag = require("241fad2c49e8a90f"), getPrototype = require("9c6d1b2265f2da98"), isObjectLike = require("78456322c636bc69");
/** `Object#toString` result references. */ var objectTag = '[object Object]';
/** Used for built-in method references. */ var funcProto = Function.prototype, objectProto = Object.prototype;
/** Used to resolve the decompiled source of functions. */ var funcToString = funcProto.toString;
/** Used to check objects for own properties. */ var hasOwnProperty = objectProto.hasOwnProperty;
/** Used to infer the `Object` constructor. */ var objectCtorString = funcToString.call(Object);
/**
 * Checks if `value` is a plain object, that is, an object created by the
 * `Object` constructor or one with a `[[Prototype]]` of `null`.
 *
 * @static
 * @memberOf _
 * @since 0.8.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a plain object, else `false`.
 * @example
 *
 * function Foo() {
 *   this.a = 1;
 * }
 *
 * _.isPlainObject(new Foo);
 * // => false
 *
 * _.isPlainObject([1, 2, 3]);
 * // => false
 *
 * _.isPlainObject({ 'x': 0, 'y': 0 });
 * // => true
 *
 * _.isPlainObject(Object.create(null));
 * // => true
 */ function isPlainObject(value) {
    if (!isObjectLike(value) || baseGetTag(value) != objectTag) return false;
    var proto = getPrototype(value);
    if (proto === null) return true;
    var Ctor = hasOwnProperty.call(proto, 'constructor') && proto.constructor;
    return typeof Ctor == 'function' && Ctor instanceof Ctor && funcToString.call(Ctor) == objectCtorString;
}
module.exports = isPlainObject;

},{"241fad2c49e8a90f":"5NOi0","9c6d1b2265f2da98":"yFmWQ","78456322c636bc69":"eoT9f"}],"3JUwD":[function(require,module,exports,__globalThis) {
var baseIsTypedArray = require("f5b04ce2c2fe315c"), baseUnary = require("da2dcc2c8cc96f81"), nodeUtil = require("dcb0828e51780b27");
/* Node.js helper references. */ var nodeIsTypedArray = nodeUtil && nodeUtil.isTypedArray;
/**
 * Checks if `value` is classified as a typed array.
 *
 * @static
 * @memberOf _
 * @since 3.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a typed array, else `false`.
 * @example
 *
 * _.isTypedArray(new Uint8Array);
 * // => true
 *
 * _.isTypedArray([]);
 * // => false
 */ var isTypedArray = nodeIsTypedArray ? baseUnary(nodeIsTypedArray) : baseIsTypedArray;
module.exports = isTypedArray;

},{"f5b04ce2c2fe315c":"9YuPZ","da2dcc2c8cc96f81":"a0ZXx","dcb0828e51780b27":"7dIbc"}],"9YuPZ":[function(require,module,exports,__globalThis) {
var baseGetTag = require("fa3f68ca211d314a"), isLength = require("a344ba57eae592fc"), isObjectLike = require("57790d11669978df");
/** `Object#toString` result references. */ var argsTag = '[object Arguments]', arrayTag = '[object Array]', boolTag = '[object Boolean]', dateTag = '[object Date]', errorTag = '[object Error]', funcTag = '[object Function]', mapTag = '[object Map]', numberTag = '[object Number]', objectTag = '[object Object]', regexpTag = '[object RegExp]', setTag = '[object Set]', stringTag = '[object String]', weakMapTag = '[object WeakMap]';
var arrayBufferTag = '[object ArrayBuffer]', dataViewTag = '[object DataView]', float32Tag = '[object Float32Array]', float64Tag = '[object Float64Array]', int8Tag = '[object Int8Array]', int16Tag = '[object Int16Array]', int32Tag = '[object Int32Array]', uint8Tag = '[object Uint8Array]', uint8ClampedTag = '[object Uint8ClampedArray]', uint16Tag = '[object Uint16Array]', uint32Tag = '[object Uint32Array]';
/** Used to identify `toStringTag` values of typed arrays. */ var typedArrayTags = {};
typedArrayTags[float32Tag] = typedArrayTags[float64Tag] = typedArrayTags[int8Tag] = typedArrayTags[int16Tag] = typedArrayTags[int32Tag] = typedArrayTags[uint8Tag] = typedArrayTags[uint8ClampedTag] = typedArrayTags[uint16Tag] = typedArrayTags[uint32Tag] = true;
typedArrayTags[argsTag] = typedArrayTags[arrayTag] = typedArrayTags[arrayBufferTag] = typedArrayTags[boolTag] = typedArrayTags[dataViewTag] = typedArrayTags[dateTag] = typedArrayTags[errorTag] = typedArrayTags[funcTag] = typedArrayTags[mapTag] = typedArrayTags[numberTag] = typedArrayTags[objectTag] = typedArrayTags[regexpTag] = typedArrayTags[setTag] = typedArrayTags[stringTag] = typedArrayTags[weakMapTag] = false;
/**
 * The base implementation of `_.isTypedArray` without Node.js optimizations.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a typed array, else `false`.
 */ function baseIsTypedArray(value) {
    return isObjectLike(value) && isLength(value.length) && !!typedArrayTags[baseGetTag(value)];
}
module.exports = baseIsTypedArray;

},{"fa3f68ca211d314a":"5NOi0","a344ba57eae592fc":"axBps","57790d11669978df":"eoT9f"}],"a0ZXx":[function(require,module,exports,__globalThis) {
/**
 * The base implementation of `_.unary` without support for storing metadata.
 *
 * @private
 * @param {Function} func The function to cap arguments for.
 * @returns {Function} Returns the new capped function.
 */ function baseUnary(func) {
    return function(value) {
        return func(value);
    };
}
module.exports = baseUnary;

},{}],"7dIbc":[function(require,module,exports,__globalThis) {
var freeGlobal = require("2463dd2c8ce28574");
/** Detect free variable `exports`. */ var freeExports = exports && !exports.nodeType && exports;
/** Detect free variable `module`. */ var freeModule = freeExports && true && module && !module.nodeType && module;
/** Detect the popular CommonJS extension `module.exports`. */ var moduleExports = freeModule && freeModule.exports === freeExports;
/** Detect free variable `process` from Node.js. */ var freeProcess = moduleExports && freeGlobal.process;
/** Used to access faster Node.js helpers. */ var nodeUtil = function() {
    try {
        // Use `util.types` for Node.js 10+.
        var types = freeModule && freeModule.require && freeModule.require('util').types;
        if (types) return types;
        // Legacy `process.binding('util')` for Node.js < 10.
        return freeProcess && freeProcess.binding && freeProcess.binding('util');
    } catch (e) {}
}();
module.exports = nodeUtil;

},{"2463dd2c8ce28574":"7le4G"}],"4SOk0":[function(require,module,exports,__globalThis) {
/**
 * Gets the value at `key`, unless `key` is "__proto__" or "constructor".
 *
 * @private
 * @param {Object} object The object to query.
 * @param {string} key The key of the property to get.
 * @returns {*} Returns the property value.
 */ function safeGet(object, key) {
    if (key === 'constructor' && typeof object[key] === 'function') return;
    if (key == '__proto__') return;
    return object[key];
}
module.exports = safeGet;

},{}],"1I2He":[function(require,module,exports,__globalThis) {
var copyObject = require("427c1e183d0a7183"), keysIn = require("844e38b8e53fceb8");
/**
 * Converts `value` to a plain object flattening inherited enumerable string
 * keyed properties of `value` to own properties of the plain object.
 *
 * @static
 * @memberOf _
 * @since 3.0.0
 * @category Lang
 * @param {*} value The value to convert.
 * @returns {Object} Returns the converted plain object.
 * @example
 *
 * function Foo() {
 *   this.b = 2;
 * }
 *
 * Foo.prototype.c = 3;
 *
 * _.assign({ 'a': 1 }, new Foo);
 * // => { 'a': 1, 'b': 2 }
 *
 * _.assign({ 'a': 1 }, _.toPlainObject(new Foo));
 * // => { 'a': 1, 'b': 2, 'c': 3 }
 */ function toPlainObject(value) {
    return copyObject(value, keysIn(value));
}
module.exports = toPlainObject;

},{"427c1e183d0a7183":"8WoZN","844e38b8e53fceb8":"jke6l"}],"8WoZN":[function(require,module,exports,__globalThis) {
var assignValue = require("b65151970ca99cdb"), baseAssignValue = require("29990736f7880d30");
/**
 * Copies properties of `source` to `object`.
 *
 * @private
 * @param {Object} source The object to copy properties from.
 * @param {Array} props The property identifiers to copy.
 * @param {Object} [object={}] The object to copy properties to.
 * @param {Function} [customizer] The function to customize copied values.
 * @returns {Object} Returns `object`.
 */ function copyObject(source, props, object, customizer) {
    var isNew = !object;
    object || (object = {});
    var index = -1, length = props.length;
    while(++index < length){
        var key = props[index];
        var newValue = customizer ? customizer(object[key], source[key], key, object, source) : undefined;
        if (newValue === undefined) newValue = source[key];
        if (isNew) baseAssignValue(object, key, newValue);
        else assignValue(object, key, newValue);
    }
    return object;
}
module.exports = copyObject;

},{"b65151970ca99cdb":"gVboZ","29990736f7880d30":"g5uWh"}],"gVboZ":[function(require,module,exports,__globalThis) {
var baseAssignValue = require("647968c96639d3e9"), eq = require("e454804d534f6e80");
/** Used for built-in method references. */ var objectProto = Object.prototype;
/** Used to check objects for own properties. */ var hasOwnProperty = objectProto.hasOwnProperty;
/**
 * Assigns `value` to `key` of `object` if the existing value is not equivalent
 * using [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
 * for equality comparisons.
 *
 * @private
 * @param {Object} object The object to modify.
 * @param {string} key The key of the property to assign.
 * @param {*} value The value to assign.
 */ function assignValue(object, key, value) {
    var objValue = object[key];
    if (!(hasOwnProperty.call(object, key) && eq(objValue, value)) || value === undefined && !(key in object)) baseAssignValue(object, key, value);
}
module.exports = assignValue;

},{"647968c96639d3e9":"g5uWh","e454804d534f6e80":"cZv4K"}],"jke6l":[function(require,module,exports,__globalThis) {
var arrayLikeKeys = require("eb5816a5c4bda01a"), baseKeysIn = require("3f661d9d4f298e28"), isArrayLike = require("1cb842d1fda9061e");
/**
 * Creates an array of the own and inherited enumerable property names of `object`.
 *
 * **Note:** Non-object values are coerced to objects.
 *
 * @static
 * @memberOf _
 * @since 3.0.0
 * @category Object
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names.
 * @example
 *
 * function Foo() {
 *   this.a = 1;
 *   this.b = 2;
 * }
 *
 * Foo.prototype.c = 3;
 *
 * _.keysIn(new Foo);
 * // => ['a', 'b', 'c'] (iteration order is not guaranteed)
 */ function keysIn(object) {
    return isArrayLike(object) ? arrayLikeKeys(object, true) : baseKeysIn(object);
}
module.exports = keysIn;

},{"eb5816a5c4bda01a":"b0EPV","3f661d9d4f298e28":"4Ky6j","1cb842d1fda9061e":"d4PO7"}],"b0EPV":[function(require,module,exports,__globalThis) {
var baseTimes = require("71f5e47cf09f4ee2"), isArguments = require("b6a480f1ccb92235"), isArray = require("f6451f22aff01079"), isBuffer = require("35e02109f4ce6ebc"), isIndex = require("63d12643a6b45538"), isTypedArray = require("3b2dc20eae96ba9e");
/** Used for built-in method references. */ var objectProto = Object.prototype;
/** Used to check objects for own properties. */ var hasOwnProperty = objectProto.hasOwnProperty;
/**
 * Creates an array of the enumerable property names of the array-like `value`.
 *
 * @private
 * @param {*} value The value to query.
 * @param {boolean} inherited Specify returning inherited property names.
 * @returns {Array} Returns the array of property names.
 */ function arrayLikeKeys(value, inherited) {
    var isArr = isArray(value), isArg = !isArr && isArguments(value), isBuff = !isArr && !isArg && isBuffer(value), isType = !isArr && !isArg && !isBuff && isTypedArray(value), skipIndexes = isArr || isArg || isBuff || isType, result = skipIndexes ? baseTimes(value.length, String) : [], length = result.length;
    for(var key in value)if ((inherited || hasOwnProperty.call(value, key)) && !(skipIndexes && // Safari 9 has enumerable `arguments.length` in strict mode.
    (key == 'length' || // Node.js 0.10 has enumerable non-index properties on buffers.
    isBuff && (key == 'offset' || key == 'parent') || // PhantomJS 2 has enumerable non-index properties on typed arrays.
    isType && (key == 'buffer' || key == 'byteLength' || key == 'byteOffset') || // Skip index properties.
    isIndex(key, length)))) result.push(key);
    return result;
}
module.exports = arrayLikeKeys;

},{"71f5e47cf09f4ee2":"k044f","b6a480f1ccb92235":"8QyUt","f6451f22aff01079":"7eHCl","35e02109f4ce6ebc":"chGID","63d12643a6b45538":"7YwKX","3b2dc20eae96ba9e":"3JUwD"}],"k044f":[function(require,module,exports,__globalThis) {
/**
 * The base implementation of `_.times` without support for iteratee shorthands
 * or max array length checks.
 *
 * @private
 * @param {number} n The number of times to invoke `iteratee`.
 * @param {Function} iteratee The function invoked per iteration.
 * @returns {Array} Returns the array of results.
 */ function baseTimes(n, iteratee) {
    var index = -1, result = Array(n);
    while(++index < n)result[index] = iteratee(index);
    return result;
}
module.exports = baseTimes;

},{}],"7YwKX":[function(require,module,exports,__globalThis) {
/** Used as references for various `Number` constants. */ var MAX_SAFE_INTEGER = 9007199254740991;
/** Used to detect unsigned integer values. */ var reIsUint = /^(?:0|[1-9]\d*)$/;
/**
 * Checks if `value` is a valid array-like index.
 *
 * @private
 * @param {*} value The value to check.
 * @param {number} [length=MAX_SAFE_INTEGER] The upper bounds of a valid index.
 * @returns {boolean} Returns `true` if `value` is a valid index, else `false`.
 */ function isIndex(value, length) {
    var type = typeof value;
    length = length == null ? MAX_SAFE_INTEGER : length;
    return !!length && (type == 'number' || type != 'symbol' && reIsUint.test(value)) && value > -1 && value % 1 == 0 && value < length;
}
module.exports = isIndex;

},{}],"4Ky6j":[function(require,module,exports,__globalThis) {
var isObject = require("55035c5a6d2bf429"), isPrototype = require("c03353ee57c174f2"), nativeKeysIn = require("46e2dc9ed626244b");
/** Used for built-in method references. */ var objectProto = Object.prototype;
/** Used to check objects for own properties. */ var hasOwnProperty = objectProto.hasOwnProperty;
/**
 * The base implementation of `_.keysIn` which doesn't treat sparse arrays as dense.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names.
 */ function baseKeysIn(object) {
    if (!isObject(object)) return nativeKeysIn(object);
    var isProto = isPrototype(object), result = [];
    for(var key in object)if (!(key == 'constructor' && (isProto || !hasOwnProperty.call(object, key)))) result.push(key);
    return result;
}
module.exports = baseKeysIn;

},{"55035c5a6d2bf429":"cGl8g","c03353ee57c174f2":"flb0y","46e2dc9ed626244b":"c5Mct"}],"c5Mct":[function(require,module,exports,__globalThis) {
/**
 * This function is like
 * [`Object.keys`](http://ecma-international.org/ecma-262/7.0/#sec-object.keys)
 * except that it includes inherited enumerable properties.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names.
 */ function nativeKeysIn(object) {
    var result = [];
    if (object != null) for(var key in Object(object))result.push(key);
    return result;
}
module.exports = nativeKeysIn;

},{}],"biT2Z":[function(require,module,exports,__globalThis) {
var baseRest = require("9c5cb8d67d1c627e"), isIterateeCall = require("e9a6a475ab12e84b");
/**
 * Creates a function like `_.assign`.
 *
 * @private
 * @param {Function} assigner The function to assign values.
 * @returns {Function} Returns the new assigner function.
 */ function createAssigner(assigner) {
    return baseRest(function(object, sources) {
        var index = -1, length = sources.length, customizer = length > 1 ? sources[length - 1] : undefined, guard = length > 2 ? sources[2] : undefined;
        customizer = assigner.length > 3 && typeof customizer == 'function' ? (length--, customizer) : undefined;
        if (guard && isIterateeCall(sources[0], sources[1], guard)) {
            customizer = length < 3 ? undefined : customizer;
            length = 1;
        }
        object = Object(object);
        while(++index < length){
            var source = sources[index];
            if (source) assigner(object, source, index, customizer);
        }
        return object;
    });
}
module.exports = createAssigner;

},{"9c5cb8d67d1c627e":"lv6wt","e9a6a475ab12e84b":"ikHo3"}],"lv6wt":[function(require,module,exports,__globalThis) {
var identity = require("5e233ded47909374"), overRest = require("4a259694d1a0a8fc"), setToString = require("4f3af83026c84060");
/**
 * The base implementation of `_.rest` which doesn't validate or coerce arguments.
 *
 * @private
 * @param {Function} func The function to apply a rest parameter to.
 * @param {number} [start=func.length-1] The start position of the rest parameter.
 * @returns {Function} Returns the new function.
 */ function baseRest(func, start) {
    return setToString(overRest(func, start, identity), func + '');
}
module.exports = baseRest;

},{"5e233ded47909374":"j4SfH","4a259694d1a0a8fc":"7gwIQ","4f3af83026c84060":"2lyVe"}],"j4SfH":[function(require,module,exports,__globalThis) {
/**
 * This method returns the first argument it receives.
 *
 * @static
 * @since 0.1.0
 * @memberOf _
 * @category Util
 * @param {*} value Any value.
 * @returns {*} Returns `value`.
 * @example
 *
 * var object = { 'a': 1 };
 *
 * console.log(_.identity(object) === object);
 * // => true
 */ function identity(value) {
    return value;
}
module.exports = identity;

},{}],"7gwIQ":[function(require,module,exports,__globalThis) {
var apply = require("615b28151d71be5d");
/* Built-in method references for those with the same name as other `lodash` methods. */ var nativeMax = Math.max;
/**
 * A specialized version of `baseRest` which transforms the rest array.
 *
 * @private
 * @param {Function} func The function to apply a rest parameter to.
 * @param {number} [start=func.length-1] The start position of the rest parameter.
 * @param {Function} transform The rest array transform.
 * @returns {Function} Returns the new function.
 */ function overRest(func, start, transform) {
    start = nativeMax(start === undefined ? func.length - 1 : start, 0);
    return function() {
        var args = arguments, index = -1, length = nativeMax(args.length - start, 0), array = Array(length);
        while(++index < length)array[index] = args[start + index];
        index = -1;
        var otherArgs = Array(start + 1);
        while(++index < start)otherArgs[index] = args[index];
        otherArgs[start] = transform(array);
        return apply(func, this, otherArgs);
    };
}
module.exports = overRest;

},{"615b28151d71be5d":"acB9Y"}],"acB9Y":[function(require,module,exports,__globalThis) {
/**
 * A faster alternative to `Function#apply`, this function invokes `func`
 * with the `this` binding of `thisArg` and the arguments of `args`.
 *
 * @private
 * @param {Function} func The function to invoke.
 * @param {*} thisArg The `this` binding of `func`.
 * @param {Array} args The arguments to invoke `func` with.
 * @returns {*} Returns the result of `func`.
 */ function apply(func, thisArg, args) {
    switch(args.length){
        case 0:
            return func.call(thisArg);
        case 1:
            return func.call(thisArg, args[0]);
        case 2:
            return func.call(thisArg, args[0], args[1]);
        case 3:
            return func.call(thisArg, args[0], args[1], args[2]);
    }
    return func.apply(thisArg, args);
}
module.exports = apply;

},{}],"2lyVe":[function(require,module,exports,__globalThis) {
var baseSetToString = require("46f3d6b7d1ef6b35"), shortOut = require("cd56625481ed641e");
/**
 * Sets the `toString` method of `func` to return `string`.
 *
 * @private
 * @param {Function} func The function to modify.
 * @param {Function} string The `toString` result.
 * @returns {Function} Returns `func`.
 */ var setToString = shortOut(baseSetToString);
module.exports = setToString;

},{"46f3d6b7d1ef6b35":"9O06a","cd56625481ed641e":"7Rh37"}],"9O06a":[function(require,module,exports,__globalThis) {
var constant = require("4aa3c49195edbb75"), defineProperty = require("1b075781a42b6ba3"), identity = require("8227706c9967b910");
/**
 * The base implementation of `setToString` without support for hot loop shorting.
 *
 * @private
 * @param {Function} func The function to modify.
 * @param {Function} string The `toString` result.
 * @returns {Function} Returns `func`.
 */ var baseSetToString = !defineProperty ? identity : function(func, string) {
    return defineProperty(func, 'toString', {
        'configurable': true,
        'enumerable': false,
        'value': constant(string),
        'writable': true
    });
};
module.exports = baseSetToString;

},{"4aa3c49195edbb75":"hb618","1b075781a42b6ba3":"8uJO6","8227706c9967b910":"j4SfH"}],"hb618":[function(require,module,exports,__globalThis) {
/**
 * Creates a function that returns `value`.
 *
 * @static
 * @memberOf _
 * @since 2.4.0
 * @category Util
 * @param {*} value The value to return from the new function.
 * @returns {Function} Returns the new constant function.
 * @example
 *
 * var objects = _.times(2, _.constant({ 'a': 1 }));
 *
 * console.log(objects);
 * // => [{ 'a': 1 }, { 'a': 1 }]
 *
 * console.log(objects[0] === objects[1]);
 * // => true
 */ function constant(value) {
    return function() {
        return value;
    };
}
module.exports = constant;

},{}],"7Rh37":[function(require,module,exports,__globalThis) {
/** Used to detect hot functions by number of calls within a span of milliseconds. */ var HOT_COUNT = 800, HOT_SPAN = 16;
/* Built-in method references for those with the same name as other `lodash` methods. */ var nativeNow = Date.now;
/**
 * Creates a function that'll short out and invoke `identity` instead
 * of `func` when it's called `HOT_COUNT` or more times in `HOT_SPAN`
 * milliseconds.
 *
 * @private
 * @param {Function} func The function to restrict.
 * @returns {Function} Returns the new shortable function.
 */ function shortOut(func) {
    var count = 0, lastCalled = 0;
    return function() {
        var stamp = nativeNow(), remaining = HOT_SPAN - (stamp - lastCalled);
        lastCalled = stamp;
        if (remaining > 0) {
            if (++count >= HOT_COUNT) return arguments[0];
        } else count = 0;
        return func.apply(undefined, arguments);
    };
}
module.exports = shortOut;

},{}],"ikHo3":[function(require,module,exports,__globalThis) {
var eq = require("5fb1ef43861dba97"), isArrayLike = require("c1aed03080e2f1bd"), isIndex = require("3fb98bb9ba544a70"), isObject = require("f3d889c9663e6d49");
/**
 * Checks if the given arguments are from an iteratee call.
 *
 * @private
 * @param {*} value The potential iteratee value argument.
 * @param {*} index The potential iteratee index or key argument.
 * @param {*} object The potential iteratee object argument.
 * @returns {boolean} Returns `true` if the arguments are from an iteratee call,
 *  else `false`.
 */ function isIterateeCall(value, index, object) {
    if (!isObject(object)) return false;
    var type = typeof index;
    if (type == 'number' ? isArrayLike(object) && isIndex(index, object.length) : type == 'string' && index in object) return eq(object[index], value);
    return false;
}
module.exports = isIterateeCall;

},{"5fb1ef43861dba97":"cZv4K","c1aed03080e2f1bd":"d4PO7","3fb98bb9ba544a70":"7YwKX","f3d889c9663e6d49":"cGl8g"}],"fKHX1":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "EDITOR_TAG", ()=>EDITOR_TAG);
parcelHelpers.export(exports, "LEGACY_EDITOR_TAG", ()=>LEGACY_EDITOR_TAG);
parcelHelpers.export(exports, "default", ()=>FabricEditorListener);
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _analyticsNext = require("@atlaskit/analytics-next");
var _types = require("../types");
var _handleEvent = require("./handle-event");
const EDITOR_TAG = 'editor';
const LEGACY_EDITOR_TAG = 'fabricEditor';
class FabricEditorListener extends (0, _reactDefault.default).Component {
    render() {
        return /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _analyticsNext.AnalyticsListener), {
            onEvent: this.handleEventWrapper,
            channel: (0, _types.FabricChannel).editor
        }, this.props.children);
    }
    constructor(...args){
        super(...args), this.handleEventWrapper = (event)=>{
            (0, _handleEvent.handleEvent)(event, [
                EDITOR_TAG,
                LEGACY_EDITOR_TAG
            ], this.props.logger, this.props.client);
        };
    }
}

},{"react":"ltHCL","@atlaskit/analytics-next":"6PLie","../types":"gOewg","./handle-event":"be2wK","@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"4Mwip":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>AtlaskitListener);
var _objectSpread = require("@swc/helpers/_/_object_spread");
var _objectSpreadProps = require("@swc/helpers/_/_object_spread_props");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _types = require("../types");
var _processEvent = require("./process-event");
var _processEventDefault = parcelHelpers.interopDefault(_processEvent);
var _genericAnalyticsListener = require("../GenericAnalyticsListener");
var _genericAnalyticsListenerDefault = parcelHelpers.interopDefault(_genericAnalyticsListener);
function AtlaskitListener(props) {
    return /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _genericAnalyticsListenerDefault.default), (0, _objectSpreadProps._)((0, _objectSpread._)({}, props), {
        channel: (0, _types.FabricChannel).atlaskit,
        processEvent: (0, _processEventDefault.default)
    }));
}

},{"@swc/helpers/_/_object_spread":"9gdrV","@swc/helpers/_/_object_spread_props":"kANqQ","react":"ltHCL","../types":"gOewg","./process-event":"dnzTs","../GenericAnalyticsListener":"j9F69","@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"dnzTs":[function(require,module,exports,__globalThis) {
/**
 * Inspired by analytics-web-react
 */ var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _objectSpread = require("@swc/helpers/_/_object_spread");
var _last = require("lodash/last");
var _lastDefault = parcelHelpers.interopDefault(_last);
var _merge = require("lodash/merge");
var _mergeDefault = parcelHelpers.interopDefault(_merge);
var _analyticsGasTypes = require("@atlaskit/analytics-gas-types");
var _extractDataFromEvent = require("./extract-data-from-event");
const ATLASKIT_TAG = 'atlaskit';
const listenerVersion = "0.16.1";
/**
 * This util exists to convert the Atlaskit event format into the analytics platform format.
 *
 * Atlaskit event format:
 * event {
 *      payload: {
 *          ...attributesFromLowestPointInTheTree
 *      },
 *      context: [{
 *          ...attributesFromHighestPointInTheTree
 *      }, {
 *          ...attributesFromSecondHighestPointInTheTree
 *      }]
 * }
 *
 * Analytics platform event format:
 *  event {
 *      type: @atlaskit/analytics-gas-types.EventType
 *      payload {
 *          ...mandatoryAttributesBasedOnEventType
 *          attributes: {
 *              ...arbitraryAttributes
 *          }
 *      }
 *  }
 */ exports.default = (event, logger)=>{
    const sources = (0, _extractDataFromEvent.getSources)(event);
    const source = (0, _lastDefault.default)(sources) || (0, _analyticsGasTypes.DEFAULT_SOURCE);
    const extraAttributes = (0, _extractDataFromEvent.getExtraAttributes)(event);
    const components = (0, _extractDataFromEvent.getComponents)(event);
    const { packageName, packageVersion } = (0, _lastDefault.default)((0, _extractDataFromEvent.getPackageInfo)(event)) || {};
    const { eventType = (0, _analyticsGasTypes.UI_EVENT_TYPE), action, actionSubjectId, attributes: payloadAttributes, containerId } = event.payload;
    const attributes = (0, _objectSpread._)({
        listenerVersion,
        sourceHierarchy: sources.join('.') || undefined,
        componentHierarchy: components.join('.') || undefined,
        packageHierarchy: (0, _extractDataFromEvent.getPackageHierarchy)(event) || undefined,
        packageName,
        packageVersion
    }, (0, _mergeDefault.default)(extraAttributes, payloadAttributes));
    // Ensure atlaskit tag is not duplicated by using Set
    const tags = new Set(event.payload.tags || []);
    tags.add(ATLASKIT_TAG);
    if (event.payload) {
        if (eventType === (0, _analyticsGasTypes.UI_EVENT_TYPE)) return {
            eventType,
            source,
            actionSubject: (0, _extractDataFromEvent.getActionSubject)(event),
            action,
            actionSubjectId,
            attributes,
            containerId,
            tags: Array.from(tags)
        };
        if (eventType === (0, _analyticsGasTypes.TRACK_EVENT_TYPE) || eventType === (0, _analyticsGasTypes.OPERATIONAL_EVENT_TYPE) || eventType === (0, _analyticsGasTypes.SCREEN_EVENT_TYPE)) logger.error('Track, screen and operational events are currently not supported for atlaskit events');
        else logger.error('Invalid event type', eventType);
    }
    return null;
};

},{"@swc/helpers/_/_object_spread":"9gdrV","lodash/last":"9zzEk","lodash/merge":"yJjRX","@atlaskit/analytics-gas-types":"4JJns","./extract-data-from-event":"88IeQ","@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"9zzEk":[function(require,module,exports,__globalThis) {
/**
 * Gets the last element of `array`.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Array
 * @param {Array} array The array to query.
 * @returns {*} Returns the last element of `array`.
 * @example
 *
 * _.last([1, 2, 3]);
 * // => 3
 */ function last(array) {
    var length = array == null ? 0 : array.length;
    return length ? array[length - 1] : undefined;
}
module.exports = last;

},{}],"88IeQ":[function(require,module,exports,__globalThis) {
/**
 * Largely taken from analytics-web-react
 */ var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "extractFromEventContext", ()=>extractFromEventContext);
parcelHelpers.export(exports, "getActionSubject", ()=>getActionSubject);
parcelHelpers.export(exports, "getSources", ()=>getSources);
parcelHelpers.export(exports, "getComponents", ()=>getComponents);
parcelHelpers.export(exports, "getExtraAttributes", ()=>getExtraAttributes);
parcelHelpers.export(exports, "getPackageInfo", ()=>getPackageInfo);
parcelHelpers.export(exports, "getPackageVersion", ()=>getPackageVersion);
// This function scans the whole context and looks for context data that includes packageName at the root of the object.
// Every package should include this info once, just to differentiate between packages, but no between internal components of each package
// If no context data brings a packageName, the map function retuns an empty string that is replaced for "undefined"
parcelHelpers.export(exports, "getPackageHierarchy", ()=>getPackageHierarchy);
var _merge = require("lodash/merge");
var _mergeDefault = parcelHelpers.interopDefault(_merge);
const extractFromEventContext = (propertyName, event)=>event.context.map((contextItem)=>contextItem[propertyName]).filter(Boolean);
const getActionSubject = (event)=>{
    const overrides = extractFromEventContext('actionSubjectOverride', event);
    const closestContext = event.context.length > 0 ? event.context[event.context.length - 1] : {};
    const actionSubject = event.payload.actionSubject || closestContext.component;
    return overrides.length > 0 ? overrides[0] : actionSubject;
};
const getSources = (event)=>extractFromEventContext('source', event);
const getComponents = (event)=>extractFromEventContext('component', event);
const getExtraAttributes = (event)=>extractFromEventContext('attributes', event).reduce((result, extraAttributes)=>(0, _mergeDefault.default)(result, extraAttributes), {});
const getPackageInfo = (event)=>event.context.map((contextItem)=>({
            packageName: contextItem.packageName,
            packageVersion: contextItem.packageVersion
        })).filter((p)=>p.packageName);
const getPackageVersion = (event)=>extractFromEventContext('packageVersion', event);
function getPackageHierarchy(event) {
    const packages = getPackageInfo(event) || [];
    return packages.map((p)=>p.packageVersion ? `${p.packageName}@${p.packageVersion}` : p.packageName).join(',') || undefined;
}

},{"lodash/merge":"yJjRX","@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"j9F69":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>GenericAnalyticsListener);
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _analyticsNext = require("@atlaskit/analytics-next");
var _analyticsWebClientWrapper = require("./analytics-web-client-wrapper");
class GenericAnalyticsListener extends (0, _reactDefault.default).Component {
    render() {
        return /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _analyticsNext.AnalyticsListener), {
            onEvent: this.listenerHandler,
            channel: this.props.channel
        }, this.props.children);
    }
    constructor(...args){
        super(...args), this.listenerHandler = (event)=>{
            const { client, logger, channel, processEvent } = this.props;
            if (!event.payload) return;
            logger.debug(`Received ${channel} event`, event);
            const payload = processEvent(event, logger);
            logger.debug(`Processed ${channel} event`, payload);
            if (payload) (0, _analyticsWebClientWrapper.sendEvent)(logger, client)(payload);
        };
    }
}

},{"react":"ltHCL","@atlaskit/analytics-next":"6PLie","./analytics-web-client-wrapper":"jZkkN","@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"dkJpA":[function(require,module,exports,__globalThis) {
/* eslint-disable no-console */ var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "LOG_LEVEL", ()=>LOG_LEVEL);
parcelHelpers.export(exports, "default", ()=>Logger);
const LOG_LEVEL = {
    DEBUG: 0,
    INFO: 1,
    WARN: 2,
    ERROR: 3,
    OFF: 4
};
class Logger {
    setLogLevel(logLevel) {
        if (logLevel >= LOG_LEVEL.DEBUG && logLevel <= LOG_LEVEL.OFF) this.logLevel = +logLevel;
        else this.logLevel = LOG_LEVEL.OFF;
    }
    logMessage(level, type, ...args) {
        if (level >= this.logLevel) console[type](...args);
    }
    debug(...args) {
        this.logMessage(LOG_LEVEL.DEBUG, 'log', ...args);
    }
    info(...args) {
        this.logMessage(LOG_LEVEL.INFO, 'info', ...args);
    }
    warn(...args) {
        this.logMessage(LOG_LEVEL.WARN, 'warn', ...args);
    }
    error(...args) {
        this.logMessage(LOG_LEVEL.ERROR, 'error', ...args);
    }
    constructor({ logLevel } = {}){
        this.logLevel = LOG_LEVEL.OFF;
        if (typeof logLevel === 'number') this.setLogLevel(logLevel);
    }
}

},{"@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"is6vG":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>NavigationListener);
var _objectSpread = require("@swc/helpers/_/_object_spread");
var _objectSpreadProps = require("@swc/helpers/_/_object_spread_props");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _types = require("../types");
var _processEvent = require("./process-event");
var _processEventDefault = parcelHelpers.interopDefault(_processEvent);
var _genericAnalyticsListener = require("../GenericAnalyticsListener");
var _genericAnalyticsListenerDefault = parcelHelpers.interopDefault(_genericAnalyticsListener);
function NavigationListener(props) {
    return /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _genericAnalyticsListenerDefault.default), (0, _objectSpreadProps._)((0, _objectSpread._)({}, props), {
        channel: (0, _types.FabricChannel).navigation,
        processEvent: (0, _processEventDefault.default)
    }));
}

},{"@swc/helpers/_/_object_spread":"9gdrV","@swc/helpers/_/_object_spread_props":"kANqQ","react":"ltHCL","../types":"gOewg","./process-event":"3Ei4h","../GenericAnalyticsListener":"j9F69","@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"3Ei4h":[function(require,module,exports,__globalThis) {
/**
 * Inspired by analytics-web-react
 */ var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _objectSpread = require("@swc/helpers/_/_object_spread");
var _last = require("lodash/last");
var _lastDefault = parcelHelpers.interopDefault(_last);
var _merge = require("lodash/merge");
var _mergeDefault = parcelHelpers.interopDefault(_merge);
var _analyticsGasTypes = require("@atlaskit/analytics-gas-types");
var _analyticsNamespacedContext = require("@atlaskit/analytics-namespaced-context");
var _extractDataFromEvent = require("../helpers/extract-data-from-event");
const NAVIGATION_TAG = 'navigation';
const listenerVersion = "0.16.1";
/**
 * This util exists to convert the analytics-next event format into the analytics platform format.
 *
 * Analytics-next event format:
 * event {
 *      payload: {
 *          ...attributesFromLowestPointInTheTree
 *      },
 *      context: [{
 *          ...attributesFromHighestPointInTheTree
 *      }, {
 *          ...attributesFromSecondHighestPointInTheTree
 *      }]
 * }
 *
 * Analytics platform event format:
 *  event {
 *      type: @atlaskit/analytics-gas-types.EventType
 *      payload {
 *          ...mandatoryAttributesBasedOnEventType
 *          attributes: {
 *              ...arbitraryAttributes
 *          }
 *      }
 *  }
 */ exports.default = (event, logger)=>{
    const sources = (0, _extractDataFromEvent.getSources)(event, (0, _analyticsNamespacedContext.NAVIGATION_CONTEXT));
    const source = (0, _lastDefault.default)(sources) || (0, _analyticsGasTypes.DEFAULT_SOURCE);
    const extraAttributes = (0, _extractDataFromEvent.getExtraAttributes)(event, (0, _analyticsNamespacedContext.NAVIGATION_CONTEXT));
    const components = (0, _extractDataFromEvent.getComponents)(event, (0, _analyticsNamespacedContext.NAVIGATION_CONTEXT));
    const packages = (0, _extractDataFromEvent.getPackageInfo)(event, (0, _analyticsNamespacedContext.NAVIGATION_CONTEXT));
    const { packageName, packageVersion } = (0, _lastDefault.default)((0, _extractDataFromEvent.getPackageInfo)(event, (0, _analyticsNamespacedContext.NAVIGATION_CONTEXT))) || {};
    const packageHierarchy = packages.map((p)=>p.packageVersion ? `${p.packageName}@${p.packageVersion}` : p.packageName);
    const { eventType = (0, _analyticsGasTypes.UI_EVENT_TYPE), action, actionSubject, actionSubjectId, attributes: payloadAttributes, name } = event.payload;
    const attributes = (0, _objectSpread._)({
        listenerVersion,
        sourceHierarchy: sources.join('.') || undefined,
        componentHierarchy: components.join('.') || undefined,
        packageHierarchy: packageHierarchy.join(',') || undefined,
        packageName,
        packageVersion
    }, (0, _mergeDefault.default)(extraAttributes, payloadAttributes));
    // Ensure navigation tag is not duplicated by using Set
    const tags = new Set(event.payload.tags || []);
    tags.add(NAVIGATION_TAG);
    if (event.payload) switch(eventType){
        case 0, _analyticsGasTypes.UI_EVENT_TYPE:
        case 0, _analyticsGasTypes.OPERATIONAL_EVENT_TYPE:
        case 0, _analyticsGasTypes.TRACK_EVENT_TYPE:
            return {
                eventType,
                source,
                actionSubject,
                action,
                actionSubjectId,
                attributes,
                tags: Array.from(tags)
            };
        case 0, _analyticsGasTypes.SCREEN_EVENT_TYPE:
            return {
                eventType,
                name,
                attributes,
                tags: Array.from(tags)
            };
        default:
            logger.error('Invalid event type', eventType);
            break;
    }
    return null;
};

},{"@swc/helpers/_/_object_spread":"9gdrV","lodash/last":"9zzEk","lodash/merge":"yJjRX","@atlaskit/analytics-gas-types":"4JJns","@atlaskit/analytics-namespaced-context":"gQwAM","../helpers/extract-data-from-event":"jUjVs","@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"jUjVs":[function(require,module,exports,__globalThis) {
/**
 * Largely taken from analytics-web-react
 */ var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "getSources", ()=>getSources);
parcelHelpers.export(exports, "getComponents", ()=>getComponents);
parcelHelpers.export(exports, "getExtraAttributes", ()=>getExtraAttributes);
parcelHelpers.export(exports, "getPackageInfo", ()=>getPackageInfo);
parcelHelpers.export(exports, "getPackageVersion", ()=>getPackageVersion);
var _merge = require("lodash/merge");
var _mergeDefault = parcelHelpers.interopDefault(_merge);
const extractFromEventContext = (propertyNames, event, namespacedContextOnly = true, contextName)=>event.context.reduce((acc, contextItem)=>{
        propertyNames.forEach((propertyName)=>{
            const navContext = contextItem[contextName];
            const navContextProp = navContext ? navContext[propertyName] : null;
            const value = namespacedContextOnly ? navContextProp : navContextProp || contextItem[propertyName];
            if (value) acc.push(value);
        });
        return acc;
    }, []);
const getSources = (event, contextName)=>extractFromEventContext([
        'source'
    ], event, false, contextName);
const getComponents = (event, contextName)=>extractFromEventContext([
        'component',
        'componentName'
    ], event, false, contextName);
const getExtraAttributes = (event, contextName)=>extractFromEventContext([
        'attributes'
    ], event, true, contextName).reduce((result, extraAttributes)=>(0, _mergeDefault.default)(result, extraAttributes), {});
const getPackageInfo = (event, contextName)=>event.context.map((contextItem)=>{
        const navContext = contextItem[contextName];
        const item = navContext ? navContext : contextItem;
        return {
            packageName: item.packageName,
            packageVersion: item.packageVersion
        };
    }).filter((p)=>p.packageName);
const getPackageVersion = (event, contextName)=>extractFromEventContext([
        'packageVersion'
    ], event, true, contextName);

},{"lodash/merge":"yJjRX","@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"3e53P":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>MediaAnalyticsListener);
var _objectSpread = require("@swc/helpers/_/_object_spread");
var _objectSpreadProps = require("@swc/helpers/_/_object_spread_props");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _types = require("../types");
var _processEvent = require("./process-event");
var _genericAnalyticsListener = require("../GenericAnalyticsListener");
var _genericAnalyticsListenerDefault = parcelHelpers.interopDefault(_genericAnalyticsListener);
function MediaAnalyticsListener(props) {
    return /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _genericAnalyticsListenerDefault.default), (0, _objectSpreadProps._)((0, _objectSpread._)({}, props), {
        channel: (0, _types.FabricChannel).media,
        processEvent: (0, _processEvent.processEvent)
    }));
}

},{"@swc/helpers/_/_object_spread":"9gdrV","@swc/helpers/_/_object_spread_props":"kANqQ","react":"ltHCL","../types":"gOewg","./process-event":"hQe58","../GenericAnalyticsListener":"j9F69","@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"hQe58":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "processEvent", ()=>processEvent);
var _objectSpread = require("@swc/helpers/_/_object_spread");
var _objectSpreadProps = require("@swc/helpers/_/_object_spread_props");
var _analyticsGasTypes = require("@atlaskit/analytics-gas-types");
var _analyticsNamespacedContext = require("@atlaskit/analytics-namespaced-context");
var _merge = require("lodash/merge");
var _mergeDefault = parcelHelpers.interopDefault(_merge);
var _last = require("lodash/last");
var _lastDefault = parcelHelpers.interopDefault(_last);
var _extractDataFromEvent = require("../atlaskit/extract-data-from-event");
const listenerVersion = "0.16.1";
function getMediaContexts(event) {
    return (0, _extractDataFromEvent.extractFromEventContext)((0, _analyticsNamespacedContext.MEDIA_CONTEXT), event);
}
function getMediaRegion() {
    try {
        // eslint-disable-next-line @atlaskit/platform/no-direct-web-storage-usage -- existing usage
        return window && window.sessionStorage && window.sessionStorage.getItem('media-api-region');
    } catch (e) {
        return;
    }
}
function processEvent(event) {
    const sources = (0, _extractDataFromEvent.getSources)(event);
    const { packageName, packageVersion } = (0, _lastDefault.default)((0, _extractDataFromEvent.getPackageInfo)(event)) || {};
    const extraAttributes = (0, _extractDataFromEvent.getExtraAttributes)(event);
    const mediaContexts = getMediaContexts(event) || [];
    const mediaAttributes = (0, _mergeDefault.default)({}, ...mediaContexts);
    const tags = new Set(event.payload.tags || []);
    tags.add('media');
    const components = (0, _extractDataFromEvent.getComponents)(event);
    const mediaRegion = getMediaRegion();
    const payload = {
        source: (0, _lastDefault.default)(sources) || (0, _analyticsGasTypes.DEFAULT_SOURCE),
        actionSubject: event.payload.actionSubject,
        action: event.payload.action,
        eventType: event.payload.eventType,
        actionSubjectId: event.payload.actionSubjectId,
        // for backward compatibilty
        name: event.payload.name,
        tags: Array.from(tags),
        attributes: (0, _objectSpread._)((0, _objectSpreadProps._)((0, _objectSpread._)({
            packageName,
            packageVersion
        }, (0, _mergeDefault.default)({}, extraAttributes, mediaAttributes, event.payload.attributes)), {
            componentHierarchy: components.join('.') || undefined,
            packageHierarchy: (0, _extractDataFromEvent.getPackageHierarchy)(event),
            sourceHierarchy: sources.join('.') || undefined,
            listenerVersion
        }), mediaRegion ? {
            mediaRegion
        } : undefined),
        nonPrivacySafeAttributes: event.payload.nonPrivacySafeAttributes
    };
    return payload;
}

},{"@swc/helpers/_/_object_spread":"9gdrV","@swc/helpers/_/_object_spread_props":"kANqQ","@atlaskit/analytics-gas-types":"4JJns","@atlaskit/analytics-namespaced-context":"gQwAM","lodash/merge":"yJjRX","lodash/last":"9zzEk","../atlaskit/extract-data-from-event":"88IeQ","@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"8PUzs":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>PeopleTeamsAnalyticsListener);
var _objectSpread = require("@swc/helpers/_/_object_spread");
var _objectSpreadProps = require("@swc/helpers/_/_object_spread_props");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _types = require("../types");
var _processEvent = require("./process-event");
var _processEventDefault = parcelHelpers.interopDefault(_processEvent);
var _genericAnalyticsListener = require("../GenericAnalyticsListener");
var _genericAnalyticsListenerDefault = parcelHelpers.interopDefault(_genericAnalyticsListener);
function PeopleTeamsAnalyticsListener(props) {
    return /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _genericAnalyticsListenerDefault.default), (0, _objectSpreadProps._)((0, _objectSpread._)({}, props), {
        channel: (0, _types.FabricChannel).peopleTeams,
        processEvent: (0, _processEventDefault.default)
    }));
}

},{"@swc/helpers/_/_object_spread":"9gdrV","@swc/helpers/_/_object_spread_props":"kANqQ","react":"ltHCL","../types":"gOewg","./process-event":"aZxHK","../GenericAnalyticsListener":"j9F69","@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"aZxHK":[function(require,module,exports,__globalThis) {
/**
 * Inspired by analytics-web-react
 */ var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _objectSpread = require("@swc/helpers/_/_object_spread");
var _last = require("lodash/last");
var _lastDefault = parcelHelpers.interopDefault(_last);
var _merge = require("lodash/merge");
var _mergeDefault = parcelHelpers.interopDefault(_merge);
var _analyticsGasTypes = require("@atlaskit/analytics-gas-types");
var _analyticsNamespacedContext = require("@atlaskit/analytics-namespaced-context");
var _extractDataFromEvent = require("../helpers/extract-data-from-event");
const PEOPLE_TEAMS_TAG = 'peopleTeams';
const listenerVersion = "0.16.1";
/**
 * This util exists to convert the analytics-next event format into the analytics platform format.
 *
 * Analytics-next event format:
 * event {
 *      payload: {
 *          ...attributesFromLowestPointInTheTree
 *      },
 *      context: [{
 *          ...attributesFromHighestPointInTheTree
 *      }, {
 *          ...attributesFromSecondHighestPointInTheTree
 *      }]
 * }
 *
 * Analytics platform event format:
 *  event {
 *      type: @atlaskit/analytics-gas-types.EventType
 *      payload {
 *          ...mandatoryAttributesBasedOnEventType
 *          attributes: {
 *              ...arbitraryAttributes
 *          }
 *      }
 *  }
 */ exports.default = (event, logger)=>{
    const sources = (0, _extractDataFromEvent.getSources)(event, (0, _analyticsNamespacedContext.PEOPLE_TEAMS_CONTEXT));
    const source = (0, _lastDefault.default)(sources) || (0, _analyticsGasTypes.DEFAULT_SOURCE);
    const extraAttributes = (0, _extractDataFromEvent.getExtraAttributes)(event, (0, _analyticsNamespacedContext.PEOPLE_TEAMS_CONTEXT));
    const components = (0, _extractDataFromEvent.getComponents)(event, (0, _analyticsNamespacedContext.PEOPLE_TEAMS_CONTEXT));
    const packages = (0, _extractDataFromEvent.getPackageInfo)(event, (0, _analyticsNamespacedContext.PEOPLE_TEAMS_CONTEXT));
    const { packageName, packageVersion } = (0, _lastDefault.default)((0, _extractDataFromEvent.getPackageInfo)(event, (0, _analyticsNamespacedContext.PEOPLE_TEAMS_CONTEXT))) || {};
    const packageHierarchy = packages.map((p)=>p.packageVersion ? `${p.packageName}@${p.packageVersion}` : p.packageName);
    const { eventType = (0, _analyticsGasTypes.UI_EVENT_TYPE), action, actionSubject, actionSubjectId, attributes: payloadAttributes, name } = event.payload;
    const attributes = (0, _objectSpread._)({
        listenerVersion,
        sourceHierarchy: sources.join('.') || undefined,
        componentHierarchy: components.join('.') || undefined,
        packageHierarchy: packageHierarchy.join(',') || undefined,
        packageName,
        packageVersion
    }, (0, _mergeDefault.default)(extraAttributes, payloadAttributes));
    // Ensure navigation tag is not duplicated by using Set
    const tags = new Set(event.payload.tags || []);
    tags.add(PEOPLE_TEAMS_TAG);
    if (event.payload) switch(eventType){
        case 0, _analyticsGasTypes.UI_EVENT_TYPE:
        case 0, _analyticsGasTypes.OPERATIONAL_EVENT_TYPE:
        case 0, _analyticsGasTypes.TRACK_EVENT_TYPE:
            return {
                eventType,
                source,
                actionSubject,
                action,
                actionSubjectId,
                attributes,
                tags: Array.from(tags)
            };
        case 0, _analyticsGasTypes.SCREEN_EVENT_TYPE:
            return {
                eventType,
                name,
                attributes,
                tags: Array.from(tags)
            };
        default:
            logger.error('Invalid event type', eventType);
            break;
    }
    return null;
};

},{"@swc/helpers/_/_object_spread":"9gdrV","lodash/last":"9zzEk","lodash/merge":"yJjRX","@atlaskit/analytics-gas-types":"4JJns","@atlaskit/analytics-namespaced-context":"gQwAM","../helpers/extract-data-from-event":"jUjVs","@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"4ZFUp":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>NotificationsAnalyticsListener);
var _objectSpread = require("@swc/helpers/_/_object_spread");
var _objectSpreadProps = require("@swc/helpers/_/_object_spread_props");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _types = require("../types");
var _processEvent = require("./process-event");
var _processEventDefault = parcelHelpers.interopDefault(_processEvent);
var _genericAnalyticsListener = require("../GenericAnalyticsListener");
var _genericAnalyticsListenerDefault = parcelHelpers.interopDefault(_genericAnalyticsListener);
function NotificationsAnalyticsListener(props) {
    return /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _genericAnalyticsListenerDefault.default), (0, _objectSpreadProps._)((0, _objectSpread._)({}, props), {
        channel: (0, _types.FabricChannel).notifications,
        processEvent: (0, _processEventDefault.default)
    }));
}

},{"@swc/helpers/_/_object_spread":"9gdrV","@swc/helpers/_/_object_spread_props":"kANqQ","react":"ltHCL","../types":"gOewg","./process-event":"4vjsT","../GenericAnalyticsListener":"j9F69","@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"4vjsT":[function(require,module,exports,__globalThis) {
/**
 * Inspired by analytics-web-react
 */ var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _objectSpread = require("@swc/helpers/_/_object_spread");
var _last = require("lodash/last");
var _lastDefault = parcelHelpers.interopDefault(_last);
var _merge = require("lodash/merge");
var _mergeDefault = parcelHelpers.interopDefault(_merge);
var _analyticsGasTypes = require("@atlaskit/analytics-gas-types");
var _extractDataFromEvent = require("../helpers/extract-data-from-event");
var _analyticsNamespacedContext = require("@atlaskit/analytics-namespaced-context");
var _types = require("../types");
const listenerVersion = "0.16.1";
/**
 * This util exists to convert the analytics-next event format into the analytics platform format.
 *
 * Analytics-next event format:
 * event {
 *      payload: {
 *          ...attributesFromLowestPointInTheTree
 *      },
 *      context: [{
 *          ...attributesFromHighestPointInTheTree
 *      }, {
 *          ...attributesFromSecondHighestPointInTheTree
 *      }]
 * }
 *
 * Analytics platform event format:
 *  event {
 *      type: @atlaskit/analytics-gas-types.EventType
 *      payload {
 *          ...mandatoryAttributesBasedOnEventType
 *          attributes: {
 *              ...arbitraryAttributes
 *          }
 *      }
 *  }
 */ exports.default = (event, logger)=>{
    const sources = (0, _extractDataFromEvent.getSources)(event, (0, _analyticsNamespacedContext.NOTIFICATIONS_CONTEXT));
    const source = (0, _lastDefault.default)(sources) || (0, _analyticsGasTypes.DEFAULT_SOURCE);
    const extraAttributes = (0, _extractDataFromEvent.getExtraAttributes)(event, (0, _analyticsNamespacedContext.NOTIFICATIONS_CONTEXT));
    const components = (0, _extractDataFromEvent.getComponents)(event, (0, _analyticsNamespacedContext.NOTIFICATIONS_CONTEXT));
    const packages = (0, _extractDataFromEvent.getPackageInfo)(event, (0, _analyticsNamespacedContext.NOTIFICATIONS_CONTEXT));
    const { packageName, packageVersion } = (0, _lastDefault.default)((0, _extractDataFromEvent.getPackageInfo)(event, (0, _analyticsNamespacedContext.NOTIFICATIONS_CONTEXT))) || {};
    const packageHierarchy = packages.map((p)=>p.packageVersion ? `${p.packageName}@${p.packageVersion}` : p.packageName);
    const { eventType = (0, _analyticsGasTypes.UI_EVENT_TYPE), action, actionSubject, actionSubjectId, attributes: payloadAttributes, name } = event.payload;
    const attributes = (0, _objectSpread._)({
        listenerVersion,
        sourceHierarchy: sources.join('.') || undefined,
        componentHierarchy: components.join('.') || undefined,
        packageHierarchy: packageHierarchy.join(',') || undefined,
        packageName,
        packageVersion
    }, (0, _mergeDefault.default)(extraAttributes, payloadAttributes));
    // Ensure navigation tag is not duplicated by using Set
    const tags = new Set(event.payload.tags || []);
    tags.add((0, _types.FabricChannel).notifications);
    if (event.payload) switch(eventType){
        case 0, _analyticsGasTypes.UI_EVENT_TYPE:
        case 0, _analyticsGasTypes.OPERATIONAL_EVENT_TYPE:
        case 0, _analyticsGasTypes.TRACK_EVENT_TYPE:
            return {
                eventType,
                source,
                actionSubject,
                action,
                actionSubjectId,
                attributes,
                tags: Array.from(tags)
            };
        case 0, _analyticsGasTypes.SCREEN_EVENT_TYPE:
            return {
                eventType,
                name,
                attributes,
                tags: Array.from(tags)
            };
        default:
            logger.error('Invalid event type', eventType);
            break;
    }
    return null;
};

},{"@swc/helpers/_/_object_spread":"9gdrV","lodash/last":"9zzEk","lodash/merge":"yJjRX","@atlaskit/analytics-gas-types":"4JJns","../helpers/extract-data-from-event":"jUjVs","@atlaskit/analytics-namespaced-context":"gQwAM","../types":"gOewg","@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"jT30b":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>RecentWorkAnalyticsListener);
var _objectSpread = require("@swc/helpers/_/_object_spread");
var _objectSpreadProps = require("@swc/helpers/_/_object_spread_props");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _types = require("../types");
var _processEvent = require("./process-event");
var _processEventDefault = parcelHelpers.interopDefault(_processEvent);
var _genericAnalyticsListener = require("../GenericAnalyticsListener");
var _genericAnalyticsListenerDefault = parcelHelpers.interopDefault(_genericAnalyticsListener);
function RecentWorkAnalyticsListener(props) {
    return /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _genericAnalyticsListenerDefault.default), (0, _objectSpreadProps._)((0, _objectSpread._)({}, props), {
        channel: (0, _types.FabricChannel).recentWork,
        processEvent: (0, _processEventDefault.default)
    }));
}

},{"@swc/helpers/_/_object_spread":"9gdrV","@swc/helpers/_/_object_spread_props":"kANqQ","react":"ltHCL","../types":"gOewg","./process-event":"f6Jac","../GenericAnalyticsListener":"j9F69","@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"f6Jac":[function(require,module,exports,__globalThis) {
/**
 * Inspired by analytics-web-react
 */ var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _objectSpread = require("@swc/helpers/_/_object_spread");
var _last = require("lodash/last");
var _lastDefault = parcelHelpers.interopDefault(_last);
var _merge = require("lodash/merge");
var _mergeDefault = parcelHelpers.interopDefault(_merge);
var _analyticsGasTypes = require("@atlaskit/analytics-gas-types");
var _extractDataFromEvent = require("../helpers/extract-data-from-event");
var _analyticsNamespacedContext = require("@atlaskit/analytics-namespaced-context");
var _types = require("../types");
const listenerVersion = "0.16.1";
/**
 * This util exists to convert the analytics-next event format into the analytics platform format.
 *
 * Analytics-next event format:
 * event {
 *      payload: {
 *          ...attributesFromLowestPointInTheTree
 *      },
 *      context: [{
 *          ...attributesFromHighestPointInTheTree
 *      }, {
 *          ...attributesFromSecondHighestPointInTheTree
 *      }]
 * }
 *
 * Analytics platform event format:
 *  event {
 *      type: @atlaskit/analytics-gas-types.EventType
 *      payload {
 *          ...mandatoryAttributesBasedOnEventType
 *          attributes: {
 *              ...arbitraryAttributes
 *          }
 *      }
 *  }
 */ exports.default = (event, logger)=>{
    const sources = (0, _extractDataFromEvent.getSources)(event, (0, _analyticsNamespacedContext.RECENT_WORK_CONTEXT));
    const source = (0, _lastDefault.default)(sources) || (0, _analyticsGasTypes.DEFAULT_SOURCE);
    const extraAttributes = (0, _extractDataFromEvent.getExtraAttributes)(event, (0, _analyticsNamespacedContext.RECENT_WORK_CONTEXT));
    const components = (0, _extractDataFromEvent.getComponents)(event, (0, _analyticsNamespacedContext.RECENT_WORK_CONTEXT));
    const packages = (0, _extractDataFromEvent.getPackageInfo)(event, (0, _analyticsNamespacedContext.RECENT_WORK_CONTEXT));
    const { packageName, packageVersion } = (0, _lastDefault.default)((0, _extractDataFromEvent.getPackageInfo)(event, (0, _analyticsNamespacedContext.RECENT_WORK_CONTEXT))) || {};
    const packageHierarchy = packages.map((p)=>p.packageVersion ? `${p.packageName}@${p.packageVersion}` : p.packageName);
    const { eventType = (0, _analyticsGasTypes.UI_EVENT_TYPE), action, actionSubject, actionSubjectId, attributes: payloadAttributes, name } = event.payload;
    const attributes = (0, _objectSpread._)({
        listenerVersion,
        sourceHierarchy: sources.join('.') || undefined,
        componentHierarchy: components.join('.') || undefined,
        packageHierarchy: packageHierarchy.join(',') || undefined,
        packageName,
        packageVersion
    }, (0, _mergeDefault.default)(extraAttributes, payloadAttributes));
    // Ensure navigation tag is not duplicated by using Set
    const tags = new Set(event.payload.tags || []);
    tags.add((0, _types.FabricChannel).recentWork);
    if (event.payload) switch(eventType){
        case 0, _analyticsGasTypes.UI_EVENT_TYPE:
        case 0, _analyticsGasTypes.OPERATIONAL_EVENT_TYPE:
        case 0, _analyticsGasTypes.TRACK_EVENT_TYPE:
            return {
                eventType,
                source,
                actionSubject,
                action,
                actionSubjectId,
                attributes,
                tags: Array.from(tags)
            };
        case 0, _analyticsGasTypes.SCREEN_EVENT_TYPE:
            return {
                eventType,
                name,
                attributes,
                tags: Array.from(tags)
            };
        default:
            logger.error('Invalid event type', eventType);
            break;
    }
    return null;
};

},{"@swc/helpers/_/_object_spread":"9gdrV","lodash/last":"9zzEk","lodash/merge":"yJjRX","@atlaskit/analytics-gas-types":"4JJns","../helpers/extract-data-from-event":"jUjVs","@atlaskit/analytics-namespaced-context":"gQwAM","../types":"gOewg","@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"58Y9q":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>AtlasAnalyticsListener);
var _objectSpread = require("@swc/helpers/_/_object_spread");
var _objectSpreadProps = require("@swc/helpers/_/_object_spread_props");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _types = require("../types");
var _processEvent = require("./process-event");
var _processEventDefault = parcelHelpers.interopDefault(_processEvent);
var _genericAnalyticsListener = require("../GenericAnalyticsListener");
var _genericAnalyticsListenerDefault = parcelHelpers.interopDefault(_genericAnalyticsListener);
function AtlasAnalyticsListener(props) {
    return /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _genericAnalyticsListenerDefault.default), (0, _objectSpreadProps._)((0, _objectSpread._)({}, props), {
        channel: (0, _types.FabricChannel).atlas,
        processEvent: (0, _processEventDefault.default)
    }));
}

},{"@swc/helpers/_/_object_spread":"9gdrV","@swc/helpers/_/_object_spread_props":"kANqQ","react":"ltHCL","../types":"gOewg","./process-event":"9WEkW","../GenericAnalyticsListener":"j9F69","@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"9WEkW":[function(require,module,exports,__globalThis) {
/**
 * Inspired by analytics-web-react
 */ var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _objectSpread = require("@swc/helpers/_/_object_spread");
var _last = require("lodash/last");
var _lastDefault = parcelHelpers.interopDefault(_last);
var _merge = require("lodash/merge");
var _mergeDefault = parcelHelpers.interopDefault(_merge);
var _analyticsGasTypes = require("@atlaskit/analytics-gas-types");
var _extractDataFromEvent = require("../helpers/extract-data-from-event");
var _analyticsNamespacedContext = require("@atlaskit/analytics-namespaced-context");
const ATLAS_TAG = 'atlas';
const listenerVersion = "0.16.1";
/**
 * This util exists to convert the analytics-next event format into the analytics platform format.
 *
 * Analytics-next event format:
 * event {
 *      payload: {
 *          ...attributesFromLowestPointInTheTree
 *      },
 *      context: [{
 *          ...attributesFromHighestPointInTheTree
 *      }, {
 *          ...attributesFromSecondHighestPointInTheTree
 *      }]
 * }
 *
 * Analytics platform event format:
 *  event {
 *      type: @atlaskit/analytics-gas-types.EventType
 *      payload {
 *          ...mandatoryAttributesBasedOnEventType
 *          attributes: {
 *              ...arbitraryAttributes
 *          }
 *      }
 *  }
 */ exports.default = (event, logger)=>{
    const sources = (0, _extractDataFromEvent.getSources)(event, (0, _analyticsNamespacedContext.ATLAS_CONTEXT));
    const source = (0, _lastDefault.default)(sources) || (0, _analyticsGasTypes.DEFAULT_SOURCE);
    const extraAttributes = (0, _extractDataFromEvent.getExtraAttributes)(event, (0, _analyticsNamespacedContext.ATLAS_CONTEXT));
    const components = (0, _extractDataFromEvent.getComponents)(event, (0, _analyticsNamespacedContext.ATLAS_CONTEXT));
    const packages = (0, _extractDataFromEvent.getPackageInfo)(event, (0, _analyticsNamespacedContext.ATLAS_CONTEXT));
    const { packageName, packageVersion } = (0, _lastDefault.default)((0, _extractDataFromEvent.getPackageInfo)(event, (0, _analyticsNamespacedContext.ATLAS_CONTEXT))) || {};
    const packageHierarchy = packages.map((p)=>p.packageVersion ? `${p.packageName}@${p.packageVersion}` : p.packageName);
    const { eventType = (0, _analyticsGasTypes.UI_EVENT_TYPE), action, actionSubject, actionSubjectId, attributes: payloadAttributes, name } = event.payload;
    const attributes = (0, _objectSpread._)({
        listenerVersion,
        sourceHierarchy: sources.join('.') || undefined,
        componentHierarchy: components.join('.') || undefined,
        packageHierarchy: packageHierarchy.join(',') || undefined,
        packageName,
        packageVersion
    }, (0, _mergeDefault.default)(extraAttributes, payloadAttributes));
    // Ensure navigation tag is not duplicated by using Set
    const tags = new Set(event.payload.tags || []);
    tags.add(ATLAS_TAG);
    if (event.payload) switch(eventType){
        case 0, _analyticsGasTypes.UI_EVENT_TYPE:
        case 0, _analyticsGasTypes.OPERATIONAL_EVENT_TYPE:
        case 0, _analyticsGasTypes.TRACK_EVENT_TYPE:
            return {
                eventType,
                source,
                actionSubject,
                action,
                actionSubjectId,
                attributes,
                tags: Array.from(tags)
            };
        case 0, _analyticsGasTypes.SCREEN_EVENT_TYPE:
            return {
                eventType,
                name,
                attributes,
                tags: Array.from(tags)
            };
        default:
            logger.error('Invalid event type', eventType);
            break;
    }
    return null;
};

},{"@swc/helpers/_/_object_spread":"9gdrV","lodash/last":"9zzEk","lodash/merge":"yJjRX","@atlaskit/analytics-gas-types":"4JJns","../helpers/extract-data-from-event":"jUjVs","@atlaskit/analytics-namespaced-context":"gQwAM","@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"6BOHI":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>CrossFlowAnalyticsListener);
var _objectSpread = require("@swc/helpers/_/_object_spread");
var _objectSpreadProps = require("@swc/helpers/_/_object_spread_props");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _types = require("../types");
var _processEvent = require("./process-event");
var _processEventDefault = parcelHelpers.interopDefault(_processEvent);
var _genericAnalyticsListener = require("../GenericAnalyticsListener");
var _genericAnalyticsListenerDefault = parcelHelpers.interopDefault(_genericAnalyticsListener);
function CrossFlowAnalyticsListener(props) {
    return /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _genericAnalyticsListenerDefault.default), (0, _objectSpreadProps._)((0, _objectSpread._)({}, props), {
        channel: (0, _types.FabricChannel).crossFlow,
        processEvent: (0, _processEventDefault.default)
    }));
}

},{"@swc/helpers/_/_object_spread":"9gdrV","@swc/helpers/_/_object_spread_props":"kANqQ","react":"ltHCL","../types":"gOewg","./process-event":"26neU","../GenericAnalyticsListener":"j9F69","@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"26neU":[function(require,module,exports,__globalThis) {
/**
 * Inspired by analytics-web-react
 */ var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _objectSpread = require("@swc/helpers/_/_object_spread");
var _objectSpreadProps = require("@swc/helpers/_/_object_spread_props");
var _analyticsGasTypes = require("@atlaskit/analytics-gas-types");
var _last = require("lodash/last");
var _lastDefault = parcelHelpers.interopDefault(_last);
var _analyticsNamespacedContext = require("@atlaskit/analytics-namespaced-context");
var _extractDataFromEvent = require("../atlaskit/extract-data-from-event");
var _extractDataFromEvent1 = require("../helpers/extract-data-from-event");
const CROSS_FLOW_TAG = 'crossFlow';
exports.default = (event, logger)=>{
    const { eventType = (0, _analyticsGasTypes.UI_EVENT_TYPE), action, actionSubject, actionSubjectId, name } = event.payload;
    let sources = (0, _extractDataFromEvent.getSources)(event);
    const lastSourceFromContext = (0, _lastDefault.default)(sources);
    var _event_payload_source;
    const source = (_event_payload_source = event.payload.source) !== null && _event_payload_source !== void 0 ? _event_payload_source : lastSourceFromContext;
    if (lastSourceFromContext !== source) sources.push(source);
    const attributes = (0, _objectSpreadProps._)((0, _objectSpread._)({}, (0, _extractDataFromEvent.getExtraAttributes)(event), (0, _extractDataFromEvent1.getExtraAttributes)(event, (0, _analyticsNamespacedContext.NAVIGATION_CONTEXT)), event.payload.attributes), {
        namespaces: sources.join('.')
    });
    // Ensure navigation tag is not duplicated by using Set
    const tags = new Set(event.payload.tags || []);
    tags.add(CROSS_FLOW_TAG);
    if (event.payload) switch(eventType){
        case 0, _analyticsGasTypes.UI_EVENT_TYPE:
        case 0, _analyticsGasTypes.OPERATIONAL_EVENT_TYPE:
        case 0, _analyticsGasTypes.TRACK_EVENT_TYPE:
            return {
                eventType,
                source,
                actionSubject,
                action,
                actionSubjectId,
                attributes,
                tags: Array.from(tags)
            };
        case 0, _analyticsGasTypes.SCREEN_EVENT_TYPE:
            return {
                eventType,
                name,
                attributes,
                tags: Array.from(tags)
            };
        default:
            logger.error('Invalid event type', eventType);
            break;
    }
    return null;
};

},{"@swc/helpers/_/_object_spread":"9gdrV","@swc/helpers/_/_object_spread_props":"kANqQ","@atlaskit/analytics-gas-types":"4JJns","lodash/last":"9zzEk","@atlaskit/analytics-namespaced-context":"gQwAM","../atlaskit/extract-data-from-event":"88IeQ","../helpers/extract-data-from-event":"jUjVs","@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"k8Wal":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>LinkingPlatformAnalyticsListener);
var _objectSpread = require("@swc/helpers/_/_object_spread");
var _objectSpreadProps = require("@swc/helpers/_/_object_spread_props");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _processEvent = require("./process-event");
var _processEventDefault = parcelHelpers.interopDefault(_processEvent);
var _types = require("../types");
var _genericAnalyticsListener = require("../GenericAnalyticsListener");
var _genericAnalyticsListenerDefault = parcelHelpers.interopDefault(_genericAnalyticsListener);
function LinkingPlatformAnalyticsListener(props) {
    return /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _genericAnalyticsListenerDefault.default), (0, _objectSpreadProps._)((0, _objectSpread._)({}, props), {
        channel: (0, _types.FabricChannel).linkingPlatform,
        processEvent: (0, _processEventDefault.default)
    }));
}

},{"@swc/helpers/_/_object_spread":"9gdrV","@swc/helpers/_/_object_spread_props":"kANqQ","react":"ltHCL","./process-event":"cvMDL","../types":"gOewg","../GenericAnalyticsListener":"j9F69","@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"cvMDL":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _objectSpread = require("@swc/helpers/_/_object_spread");
var _last = require("lodash/last");
var _lastDefault = parcelHelpers.interopDefault(_last);
var _merge = require("lodash/merge");
var _mergeDefault = parcelHelpers.interopDefault(_merge);
var _analyticsGasTypes = require("@atlaskit/analytics-gas-types");
var _analyticsNamespacedContext = require("@atlaskit/analytics-namespaced-context");
var _extractDataFromEvent = require("../helpers/extract-data-from-event");
var _types = require("../types");
const listenerVersion = "0.16.1";
exports.default = (event)=>{
    const sources = (0, _extractDataFromEvent.getSources)(event, (0, _analyticsNamespacedContext.LINKING_PLATFORM_CONTEXT));
    const packages = (0, _extractDataFromEvent.getPackageInfo)(event, (0, _analyticsNamespacedContext.LINKING_PLATFORM_CONTEXT));
    const components = (0, _extractDataFromEvent.getComponents)(event, (0, _analyticsNamespacedContext.LINKING_PLATFORM_CONTEXT));
    const extraAttributes = (0, _extractDataFromEvent.getExtraAttributes)(event, (0, _analyticsNamespacedContext.LINKING_PLATFORM_CONTEXT));
    const { packageName, packageVersion } = (0, _lastDefault.default)(packages) || {};
    const packageHierarchy = packages.map((p)=>p.packageVersion ? `${p.packageName}@${p.packageVersion}` : p.packageName);
    const tags = new Set(event.payload.tags || []);
    tags.add((0, _types.FabricChannel).linkingPlatform);
    const payload = {
        name: event.payload.name,
        action: event.payload.action,
        actionSubject: event.payload.actionSubject,
        actionSubjectId: event.payload.actionSubjectId,
        eventType: event.payload.eventType,
        attributes: (0, _objectSpread._)({
            packageName,
            packageVersion,
            listenerVersion,
            sourceHierarchy: sources.join('.') || undefined,
            componentHierarchy: components.join('.') || undefined,
            packageHierarchy: packageHierarchy.join(',') || undefined
        }, (0, _mergeDefault.default)(extraAttributes, event.payload.attributes)),
        tags: Array.from(tags),
        source: (0, _lastDefault.default)(sources) || (0, _analyticsGasTypes.DEFAULT_SOURCE),
        nonPrivacySafeAttributes: event.payload.nonPrivacySafeAttributes
    };
    return payload;
};

},{"@swc/helpers/_/_object_spread":"9gdrV","lodash/last":"9zzEk","lodash/merge":"yJjRX","@atlaskit/analytics-gas-types":"4JJns","@atlaskit/analytics-namespaced-context":"gQwAM","../helpers/extract-data-from-event":"jUjVs","../types":"gOewg","@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"l6pHV":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>PostOfficeAnalyticsListener);
var _objectSpread = require("@swc/helpers/_/_object_spread");
var _objectSpreadProps = require("@swc/helpers/_/_object_spread_props");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _types = require("../types");
var _processEvent = require("./process-event");
var _processEventDefault = parcelHelpers.interopDefault(_processEvent);
var _genericAnalyticsListener = require("../GenericAnalyticsListener");
var _genericAnalyticsListenerDefault = parcelHelpers.interopDefault(_genericAnalyticsListener);
function PostOfficeAnalyticsListener(props) {
    return /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _genericAnalyticsListenerDefault.default), (0, _objectSpreadProps._)((0, _objectSpread._)({}, props), {
        channel: (0, _types.FabricChannel).postOffice,
        processEvent: (0, _processEventDefault.default)
    }));
}

},{"@swc/helpers/_/_object_spread":"9gdrV","@swc/helpers/_/_object_spread_props":"kANqQ","react":"ltHCL","../types":"gOewg","./process-event":"krnff","../GenericAnalyticsListener":"j9F69","@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"krnff":[function(require,module,exports,__globalThis) {
/**
 * Inspired by analytics-web-react
 */ var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _objectSpread = require("@swc/helpers/_/_object_spread");
var _last = require("lodash/last");
var _lastDefault = parcelHelpers.interopDefault(_last);
var _merge = require("lodash/merge");
var _mergeDefault = parcelHelpers.interopDefault(_merge);
var _analyticsGasTypes = require("@atlaskit/analytics-gas-types");
var _analyticsNamespacedContext = require("@atlaskit/analytics-namespaced-context");
var _extractDataFromEvent = require("../helpers/extract-data-from-event");
var _types = require("../types");
const POST_OFFICE_TAG = (0, _types.FabricChannel).postOffice;
const listenerVersion = "0.16.1";
/**
 * This util exists to convert the analytics-next event format into the analytics platform format.
 *
 * Analytics-next event format:
 * event {
 *      payload: {
 *          ...attributesFromLowestPointInTheTree
 *      },
 *      context: [{
 *          ...attributesFromHighestPointInTheTree
 *      }, {
 *          ...attributesFromSecondHighestPointInTheTree
 *      }]
 * }
 *
 * Analytics platform event format:
 *  event {
 *      type: @atlaskit/analytics-gas-types.EventType
 *      payload {
 *          ...mandatoryAttributesBasedOnEventType
 *          attributes: {
 *              ...arbitraryAttributes
 *          }
 *      }
 *  }
 */ exports.default = (event, logger)=>{
    const sources = (0, _extractDataFromEvent.getSources)(event, (0, _analyticsNamespacedContext.POST_OFFICE_CONTEXT));
    const source = (0, _lastDefault.default)(sources) || (0, _analyticsGasTypes.DEFAULT_SOURCE);
    const extraAttributes = (0, _extractDataFromEvent.getExtraAttributes)(event, (0, _analyticsNamespacedContext.POST_OFFICE_CONTEXT));
    const components = (0, _extractDataFromEvent.getComponents)(event, (0, _analyticsNamespacedContext.POST_OFFICE_CONTEXT));
    const packages = (0, _extractDataFromEvent.getPackageInfo)(event, (0, _analyticsNamespacedContext.POST_OFFICE_CONTEXT));
    const { packageName, packageVersion } = (0, _lastDefault.default)((0, _extractDataFromEvent.getPackageInfo)(event, (0, _analyticsNamespacedContext.POST_OFFICE_CONTEXT))) || {};
    const packageHierarchy = packages.map((p)=>p.packageVersion ? `${p.packageName}@${p.packageVersion}` : p.packageName);
    const { eventType = (0, _analyticsGasTypes.UI_EVENT_TYPE), action, actionSubject, actionSubjectId, attributes: payloadAttributes, name } = event.payload;
    const attributes = (0, _objectSpread._)({
        listenerVersion,
        sourceHierarchy: sources.join('.') || undefined,
        componentHierarchy: components.join('.') || undefined,
        packageHierarchy: packageHierarchy.join(',') || undefined,
        packageName,
        packageVersion
    }, (0, _mergeDefault.default)(extraAttributes, payloadAttributes));
    // Ensure navigation tag is not duplicated by using Set
    const tags = new Set(event.payload.tags || []);
    tags.add(POST_OFFICE_TAG);
    if (event.payload) switch(eventType){
        case 0, _analyticsGasTypes.UI_EVENT_TYPE:
        case 0, _analyticsGasTypes.OPERATIONAL_EVENT_TYPE:
        case 0, _analyticsGasTypes.TRACK_EVENT_TYPE:
            return {
                eventType,
                source,
                actionSubject,
                action,
                actionSubjectId,
                attributes,
                tags: Array.from(tags)
            };
        case 0, _analyticsGasTypes.SCREEN_EVENT_TYPE:
            return {
                eventType,
                name,
                attributes,
                tags: Array.from(tags)
            };
        default:
            logger.error('Invalid event type', eventType);
            break;
    }
    return null;
};

},{"@swc/helpers/_/_object_spread":"9gdrV","lodash/last":"9zzEk","lodash/merge":"yJjRX","@atlaskit/analytics-gas-types":"4JJns","@atlaskit/analytics-namespaced-context":"gQwAM","../helpers/extract-data-from-event":"jUjVs","../types":"gOewg","@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"kKTF9":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>AIMateAnalyticsListener);
var _objectSpread = require("@swc/helpers/_/_object_spread");
var _objectSpreadProps = require("@swc/helpers/_/_object_spread_props");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _types = require("../types");
var _processEvent = require("./process-event");
var _processEventDefault = parcelHelpers.interopDefault(_processEvent);
var _genericAnalyticsListener = require("../GenericAnalyticsListener");
var _genericAnalyticsListenerDefault = parcelHelpers.interopDefault(_genericAnalyticsListener);
function AIMateAnalyticsListener(props) {
    return /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _genericAnalyticsListenerDefault.default), (0, _objectSpreadProps._)((0, _objectSpread._)({}, props), {
        channel: (0, _types.FabricChannel).aiMate,
        processEvent: (0, _processEventDefault.default)
    }));
}

},{"@swc/helpers/_/_object_spread":"9gdrV","@swc/helpers/_/_object_spread_props":"kANqQ","react":"ltHCL","../types":"gOewg","./process-event":"iyR97","../GenericAnalyticsListener":"j9F69","@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"iyR97":[function(require,module,exports,__globalThis) {
/**
 * Inspired by analytics-web-react
 */ var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _objectSpread = require("@swc/helpers/_/_object_spread");
var _last = require("lodash/last");
var _lastDefault = parcelHelpers.interopDefault(_last);
var _merge = require("lodash/merge");
var _mergeDefault = parcelHelpers.interopDefault(_merge);
var _analyticsGasTypes = require("@atlaskit/analytics-gas-types");
var _analyticsNamespacedContext = require("@atlaskit/analytics-namespaced-context");
var _extractDataFromEvent = require("../helpers/extract-data-from-event");
const AI_MATE_TAG = 'aiMate';
const listenerVersion = "0.16.1";
/**
 * This util exists to convert the analytics-next event format into the analytics platform format.
 *
 * Analytics-next event format:
 * event {
 *      payload: {
 *          ...attributesFromLowestPointInTheTree
 *      },
 *      context: [{
 *          ...attributesFromHighestPointInTheTree
 *      }, {
 *          ...attributesFromSecondHighestPointInTheTree
 *      }]
 * }
 *
 * Analytics platform event format:
 *  event {
 *      type: @atlaskit/analytics-gas-types.EventType
 *      payload {
 *          ...mandatoryAttributesBasedOnEventType
 *          attributes: {
 *              ...arbitraryAttributes
 *          }
 *      }
 *  }
 */ exports.default = (event, logger)=>{
    const sources = (0, _extractDataFromEvent.getSources)(event, (0, _analyticsNamespacedContext.AI_MATE_CONTEXT));
    const source = (0, _lastDefault.default)(sources) || (0, _analyticsGasTypes.DEFAULT_SOURCE);
    const extraAttributes = (0, _extractDataFromEvent.getExtraAttributes)(event, (0, _analyticsNamespacedContext.AI_MATE_CONTEXT));
    const components = (0, _extractDataFromEvent.getComponents)(event, (0, _analyticsNamespacedContext.AI_MATE_CONTEXT));
    const packages = (0, _extractDataFromEvent.getPackageInfo)(event, (0, _analyticsNamespacedContext.AI_MATE_CONTEXT));
    const { packageName, packageVersion } = (0, _lastDefault.default)((0, _extractDataFromEvent.getPackageInfo)(event, (0, _analyticsNamespacedContext.AI_MATE_CONTEXT))) || {};
    const packageHierarchy = packages.map((p)=>p.packageVersion ? `${p.packageName}@${p.packageVersion}` : p.packageName);
    const { eventType = (0, _analyticsGasTypes.UI_EVENT_TYPE), action, actionSubject, actionSubjectId, attributes: payloadAttributes, name, objectId, objectType, containerType, containerId } = event.payload;
    const attributes = (0, _objectSpread._)({
        listenerVersion,
        sourceHierarchy: sources.join('.') || undefined,
        componentHierarchy: components.join('.') || undefined,
        packageHierarchy: packageHierarchy.join(',') || undefined,
        packageName,
        packageVersion
    }, (0, _mergeDefault.default)(extraAttributes, payloadAttributes));
    // Ensure navigation tag is not duplicated by using Set
    const tags = new Set(event.payload.tags || []);
    tags.add(AI_MATE_TAG);
    if (event.payload) switch(eventType){
        case 0, _analyticsGasTypes.UI_EVENT_TYPE:
        case 0, _analyticsGasTypes.OPERATIONAL_EVENT_TYPE:
        case 0, _analyticsGasTypes.TRACK_EVENT_TYPE:
            return (0, _objectSpread._)({
                eventType,
                source: source,
                actionSubject,
                action,
                actionSubjectId,
                attributes,
                tags: Array.from(tags)
            }, objectId && {
                objectId
            }, objectType && {
                objectType
            }, containerType && {
                containerType
            }, containerId && {
                containerId
            });
        case 0, _analyticsGasTypes.SCREEN_EVENT_TYPE:
            return {
                eventType,
                name,
                attributes,
                tags: Array.from(tags)
            };
        default:
            logger.error('Invalid event type', eventType);
            break;
    }
    return null;
};

},{"@swc/helpers/_/_object_spread":"9gdrV","lodash/last":"9zzEk","lodash/merge":"yJjRX","@atlaskit/analytics-gas-types":"4JJns","@atlaskit/analytics-namespaced-context":"gQwAM","../helpers/extract-data-from-event":"jUjVs","@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"6zJGt":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>AVPAnalyticsListener);
var _objectSpread = require("@swc/helpers/_/_object_spread");
var _objectSpreadProps = require("@swc/helpers/_/_object_spread_props");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _types = require("../types");
var _processEvent = require("./process-event");
var _processEventDefault = parcelHelpers.interopDefault(_processEvent);
var _genericAnalyticsListener = require("../GenericAnalyticsListener");
var _genericAnalyticsListenerDefault = parcelHelpers.interopDefault(_genericAnalyticsListener);
function AVPAnalyticsListener(props) {
    return /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _genericAnalyticsListenerDefault.default), (0, _objectSpreadProps._)((0, _objectSpread._)({}, props), {
        channel: (0, _types.FabricChannel).avp,
        processEvent: (0, _processEventDefault.default)
    }));
}

},{"@swc/helpers/_/_object_spread":"9gdrV","@swc/helpers/_/_object_spread_props":"kANqQ","react":"ltHCL","../types":"gOewg","./process-event":"6BqIp","../GenericAnalyticsListener":"j9F69","@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"6BqIp":[function(require,module,exports,__globalThis) {
/**
 * Inspired by analytics-web-react
 */ var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _objectSpread = require("@swc/helpers/_/_object_spread");
var _last = require("lodash/last");
var _lastDefault = parcelHelpers.interopDefault(_last);
var _merge = require("lodash/merge");
var _mergeDefault = parcelHelpers.interopDefault(_merge);
var _analyticsGasTypes = require("@atlaskit/analytics-gas-types");
var _analyticsNamespacedContext = require("@atlaskit/analytics-namespaced-context");
var _extractDataFromEvent = require("../helpers/extract-data-from-event");
const AVP_TAG = 'avp';
const listenerVersion = "0.16.1";
/**
 * This util exists to convert the analytics-next event format into the analytics platform format.
 *
 * Analytics-next event format:
 * event {
 *      payload: {
 *          ...attributesFromLowestPointInTheTree
 *      },
 *      context: [{
 *          ...attributesFromHighestPointInTheTree
 *      }, {
 *          ...attributesFromSecondHighestPointInTheTree
 *      }]
 * }
 *
 * Analytics platform event format:
 *  event {
 *      type: @atlaskit/analytics-gas-types.EventType
 *      payload {
 *          ...mandatoryAttributesBasedOnEventType
 *          attributes: {
 *              ...arbitraryAttributes
 *          }
 *      }
 *  }
 */ exports.default = (event, logger)=>{
    const sources = (0, _extractDataFromEvent.getSources)(event, (0, _analyticsNamespacedContext.AVP_CONTEXT));
    const source = (0, _lastDefault.default)(sources) || (0, _analyticsGasTypes.DEFAULT_SOURCE);
    const extraAttributes = (0, _extractDataFromEvent.getExtraAttributes)(event, (0, _analyticsNamespacedContext.AVP_CONTEXT));
    const components = (0, _extractDataFromEvent.getComponents)(event, (0, _analyticsNamespacedContext.AVP_CONTEXT));
    const packages = (0, _extractDataFromEvent.getPackageInfo)(event, (0, _analyticsNamespacedContext.AVP_CONTEXT));
    const { packageName, packageVersion } = (0, _lastDefault.default)((0, _extractDataFromEvent.getPackageInfo)(event, (0, _analyticsNamespacedContext.AVP_CONTEXT))) || {};
    const packageHierarchy = packages.map((p)=>p.packageVersion ? `${p.packageName}@${p.packageVersion}` : p.packageName);
    const { eventType = (0, _analyticsGasTypes.UI_EVENT_TYPE), action, actionSubject, actionSubjectId, attributes: payloadAttributes, name } = event.payload;
    const attributes = (0, _objectSpread._)({
        listenerVersion,
        sourceHierarchy: sources.join('.') || undefined,
        componentHierarchy: components.join('.') || undefined,
        packageHierarchy: packageHierarchy.join(',') || undefined,
        packageName,
        packageVersion
    }, (0, _mergeDefault.default)(extraAttributes, payloadAttributes), (0, _mergeDefault.default)({}, ...event.context));
    // Ensure navigation tag is not duplicated by using Set
    const tags = new Set(event.payload.tags || []);
    tags.add(AVP_TAG);
    if (event.payload) switch(eventType){
        case 0, _analyticsGasTypes.UI_EVENT_TYPE:
        case 0, _analyticsGasTypes.OPERATIONAL_EVENT_TYPE:
        case 0, _analyticsGasTypes.TRACK_EVENT_TYPE:
            return {
                eventType,
                source,
                actionSubject,
                action,
                actionSubjectId,
                attributes,
                tags: Array.from(tags)
            };
        case 0, _analyticsGasTypes.SCREEN_EVENT_TYPE:
            return {
                eventType,
                name,
                attributes,
                tags: Array.from(tags)
            };
        default:
            logger.error('Invalid event type', eventType);
            break;
    }
    return null;
};

},{"@swc/helpers/_/_object_spread":"9gdrV","lodash/last":"9zzEk","lodash/merge":"yJjRX","@atlaskit/analytics-gas-types":"4JJns","@atlaskit/analytics-namespaced-context":"gQwAM","../helpers/extract-data-from-event":"jUjVs","@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"lJFg1":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>GrowthAnalyticsListener);
var _objectSpread = require("@swc/helpers/_/_object_spread");
var _objectSpreadProps = require("@swc/helpers/_/_object_spread_props");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _types = require("../types");
var _processEvent = require("./process-event");
var _processEventDefault = parcelHelpers.interopDefault(_processEvent);
var _genericAnalyticsListener = require("../GenericAnalyticsListener");
var _genericAnalyticsListenerDefault = parcelHelpers.interopDefault(_genericAnalyticsListener);
function GrowthAnalyticsListener(props) {
    return /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _genericAnalyticsListenerDefault.default), (0, _objectSpreadProps._)((0, _objectSpread._)({}, props), {
        channel: (0, _types.FabricChannel).growth,
        processEvent: (0, _processEventDefault.default)
    }));
}

},{"@swc/helpers/_/_object_spread":"9gdrV","@swc/helpers/_/_object_spread_props":"kANqQ","react":"ltHCL","../types":"gOewg","./process-event":"iVm9z","../GenericAnalyticsListener":"j9F69","@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"iVm9z":[function(require,module,exports,__globalThis) {
/**
 * Inspired by analytics-web-react
 */ var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _objectSpread = require("@swc/helpers/_/_object_spread");
var _last = require("lodash/last");
var _lastDefault = parcelHelpers.interopDefault(_last);
var _merge = require("lodash/merge");
var _mergeDefault = parcelHelpers.interopDefault(_merge);
var _analyticsGasTypes = require("@atlaskit/analytics-gas-types");
var _analyticsNamespacedContext = require("@atlaskit/analytics-namespaced-context");
var _extractDataFromEvent = require("../helpers/extract-data-from-event");
const GROWTH_TAG = 'growth';
const listenerVersion = "0.16.1";
/**
 * This util exists to convert the analytics-next event format into the analytics platform format.
 *
 * Analytics-next event format:
 * event {
 *      payload: {
 *          ...attributesFromLowestPointInTheTree
 *      },
 *      context: [{
 *          ...attributesFromHighestPointInTheTree
 *      }, {
 *          ...attributesFromSecondHighestPointInTheTree
 *      }]
 * }
 *
 * Analytics platform event format:
 *  event {
 *      type: @atlaskit/analytics-gas-types.EventType
 *      payload {
 *          ...mandatoryAttributesBasedOnEventType
 *          attributes: {
 *              ...arbitraryAttributes
 *          }
 *      }
 *  }
 */ exports.default = (event, logger)=>{
    const sources = (0, _extractDataFromEvent.getSources)(event, (0, _analyticsNamespacedContext.GROWTH_CONTEXT));
    const source = (0, _lastDefault.default)(sources) || (0, _analyticsGasTypes.DEFAULT_SOURCE);
    const extraAttributes = (0, _extractDataFromEvent.getExtraAttributes)(event, (0, _analyticsNamespacedContext.GROWTH_CONTEXT));
    const components = (0, _extractDataFromEvent.getComponents)(event, (0, _analyticsNamespacedContext.GROWTH_CONTEXT));
    const packages = (0, _extractDataFromEvent.getPackageInfo)(event, (0, _analyticsNamespacedContext.GROWTH_CONTEXT));
    const { packageName, packageVersion } = (0, _lastDefault.default)((0, _extractDataFromEvent.getPackageInfo)(event, (0, _analyticsNamespacedContext.GROWTH_CONTEXT))) || {};
    const packageHierarchy = packages.map((p)=>p.packageVersion ? `${p.packageName}@${p.packageVersion}` : p.packageName);
    const { eventType = (0, _analyticsGasTypes.UI_EVENT_TYPE), action, actionSubject, actionSubjectId, attributes: payloadAttributes, name } = event.payload;
    const attributes = (0, _objectSpread._)({
        listenerVersion,
        sourceHierarchy: sources.join('.') || undefined,
        componentHierarchy: components.join('.') || undefined,
        packageHierarchy: packageHierarchy.join(',') || undefined,
        packageName,
        packageVersion
    }, (0, _mergeDefault.default)(extraAttributes, payloadAttributes));
    // Ensure navigation tag is not duplicated by using Set
    const tags = new Set(event.payload.tags || []);
    tags.add(GROWTH_TAG);
    if (event.payload) switch(eventType){
        case 0, _analyticsGasTypes.UI_EVENT_TYPE:
        case 0, _analyticsGasTypes.OPERATIONAL_EVENT_TYPE:
        case 0, _analyticsGasTypes.TRACK_EVENT_TYPE:
            return {
                eventType,
                source,
                actionSubject,
                action,
                actionSubjectId,
                attributes,
                tags: Array.from(tags)
            };
        case 0, _analyticsGasTypes.SCREEN_EVENT_TYPE:
            return {
                eventType,
                name,
                attributes,
                tags: Array.from(tags)
            };
        default:
            logger.error('Invalid event type', eventType);
            break;
    }
    return null;
};

},{"@swc/helpers/_/_object_spread":"9gdrV","lodash/last":"9zzEk","lodash/merge":"yJjRX","@atlaskit/analytics-gas-types":"4JJns","@atlaskit/analytics-namespaced-context":"gQwAM","../helpers/extract-data-from-event":"jUjVs","@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"4Y88d":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _objectSpread = require("@swc/helpers/_/_object_spread");
var _objectSpreadProps = require("@swc/helpers/_/_object_spread_props");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _types = require("../types");
var _processEvent = require("./process-event");
var _processEventDefault = parcelHelpers.interopDefault(_processEvent);
var _genericAnalyticsListener = require("../GenericAnalyticsListener");
var _genericAnalyticsListenerDefault = parcelHelpers.interopDefault(_genericAnalyticsListener);
const OmniChannelAnalyticsListener = (props)=>{
    return /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _genericAnalyticsListenerDefault.default), (0, _objectSpreadProps._)((0, _objectSpread._)({}, props), {
        channel: (0, _types.FabricChannel).omniChannel,
        processEvent: (0, _processEventDefault.default)
    }));
};
exports.default = OmniChannelAnalyticsListener;

},{"@swc/helpers/_/_object_spread":"9gdrV","@swc/helpers/_/_object_spread_props":"kANqQ","react":"ltHCL","../types":"gOewg","./process-event":"dExLX","../GenericAnalyticsListener":"j9F69","@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"dExLX":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _objectSpread = require("@swc/helpers/_/_object_spread");
var _analyticsGasTypes = require("@atlaskit/analytics-gas-types");
var _analyticsNamespacedContext = require("@atlaskit/analytics-namespaced-context");
var _extractDataFromEvent = require("../helpers/extract-data-from-event");
var _last = require("lodash/last");
var _lastDefault = parcelHelpers.interopDefault(_last);
var _merge = require("lodash/merge");
var _mergeDefault = parcelHelpers.interopDefault(_merge);
var _types = require("../types");
const listenerVersion = "0.16.1";
exports.default = (event, logger)=>{
    const sources = (0, _extractDataFromEvent.getSources)(event, (0, _analyticsNamespacedContext.OMNI_CHANNEL_CONTEXT));
    const source = (0, _lastDefault.default)(sources) || (0, _analyticsGasTypes.DEFAULT_SOURCE);
    const extraAttributes = (0, _extractDataFromEvent.getExtraAttributes)(event, (0, _analyticsNamespacedContext.OMNI_CHANNEL_CONTEXT));
    const components = (0, _extractDataFromEvent.getComponents)(event, (0, _analyticsNamespacedContext.OMNI_CHANNEL_CONTEXT));
    const packages = (0, _extractDataFromEvent.getPackageInfo)(event, (0, _analyticsNamespacedContext.OMNI_CHANNEL_CONTEXT));
    const { packageName, packageVersion } = (0, _lastDefault.default)((0, _extractDataFromEvent.getPackageInfo)(event, (0, _analyticsNamespacedContext.OMNI_CHANNEL_CONTEXT))) || {};
    const packageHierarchy = packages.map((p)=>p.packageVersion ? `${p.packageName}@${p.packageVersion}` : p.packageName);
    const { eventType = (0, _analyticsGasTypes.UI_EVENT_TYPE), action, actionSubject, actionSubjectId, attributes: payloadAttributes, name } = event.payload;
    const attributes = (0, _objectSpread._)({
        listenerVersion,
        sourceHierarchy: sources.join('.') || undefined,
        componentHierarchy: components.join('.') || undefined,
        packageHierarchy: packageHierarchy.join(',') || undefined,
        packageName,
        packageVersion
    }, (0, _mergeDefault.default)(extraAttributes, payloadAttributes));
    // Ensure navigation tag is not duplicated by using Set
    const tags = new Set(event.payload.tags || []);
    tags.add((0, _types.FabricChannel).omniChannel);
    if (event.payload) switch(eventType){
        case 0, _analyticsGasTypes.UI_EVENT_TYPE:
        case 0, _analyticsGasTypes.OPERATIONAL_EVENT_TYPE:
        case 0, _analyticsGasTypes.TRACK_EVENT_TYPE:
            return {
                eventType,
                source,
                actionSubject,
                action,
                actionSubjectId,
                attributes,
                tags: Array.from(tags)
            };
        case 0, _analyticsGasTypes.SCREEN_EVENT_TYPE:
            return {
                eventType,
                name,
                attributes,
                tags: Array.from(tags)
            };
        default:
            logger.error('Invalid event type', eventType);
            break;
    }
    return null;
};

},{"@swc/helpers/_/_object_spread":"9gdrV","@atlaskit/analytics-gas-types":"4JJns","@atlaskit/analytics-namespaced-context":"gQwAM","../helpers/extract-data-from-event":"jUjVs","lodash/last":"9zzEk","lodash/merge":"yJjRX","../types":"gOewg","@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"Xe2ZT":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>TownsquareHomeAnalyticsListener);
var _objectSpread = require("@swc/helpers/_/_object_spread");
var _objectSpreadProps = require("@swc/helpers/_/_object_spread_props");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _types = require("../types");
var _processEvent = require("./process-event");
var _processEventDefault = parcelHelpers.interopDefault(_processEvent);
var _genericAnalyticsListener = require("../GenericAnalyticsListener");
var _genericAnalyticsListenerDefault = parcelHelpers.interopDefault(_genericAnalyticsListener);
function TownsquareHomeAnalyticsListener(props) {
    return /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _genericAnalyticsListenerDefault.default), (0, _objectSpreadProps._)((0, _objectSpread._)({}, props), {
        channel: (0, _types.FabricChannel).townsquareHome,
        processEvent: (0, _processEventDefault.default)
    }));
}

},{"@swc/helpers/_/_object_spread":"9gdrV","@swc/helpers/_/_object_spread_props":"kANqQ","react":"ltHCL","../types":"gOewg","./process-event":"bOyL9","../GenericAnalyticsListener":"j9F69","@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"bOyL9":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _objectSpread = require("@swc/helpers/_/_object_spread");
var _last = require("lodash/last");
var _lastDefault = parcelHelpers.interopDefault(_last);
var _merge = require("lodash/merge");
var _mergeDefault = parcelHelpers.interopDefault(_merge);
var _analyticsGasTypes = require("@atlaskit/analytics-gas-types");
var _extractDataFromEvent = require("../helpers/extract-data-from-event");
var _analyticsNamespacedContext = require("@atlaskit/analytics-namespaced-context");
const TOWNSQUARE_TAG = 'townsquare';
const TOWNSQUARE_HOME_TAG = 'townsquareHome';
const listenerVersion = "0.16.1";
/**
 * This util exists to convert the analytics-next event format into the analytics platform format.
 *
 * It's a copy paste from the other process-event mappers.
 */ exports.default = (event, logger)=>{
    const sources = (0, _extractDataFromEvent.getSources)(event, (0, _analyticsNamespacedContext.TOWNSQUARE_HOME_CONTEXT));
    const source = (0, _lastDefault.default)(sources) || (0, _analyticsGasTypes.DEFAULT_SOURCE);
    const extraAttributes = (0, _extractDataFromEvent.getExtraAttributes)(event, (0, _analyticsNamespacedContext.TOWNSQUARE_HOME_CONTEXT));
    const components = (0, _extractDataFromEvent.getComponents)(event, (0, _analyticsNamespacedContext.TOWNSQUARE_HOME_CONTEXT));
    const packages = (0, _extractDataFromEvent.getPackageInfo)(event, (0, _analyticsNamespacedContext.TOWNSQUARE_HOME_CONTEXT));
    const { packageName, packageVersion } = (0, _lastDefault.default)((0, _extractDataFromEvent.getPackageInfo)(event, (0, _analyticsNamespacedContext.TOWNSQUARE_HOME_CONTEXT))) || {};
    const packageHierarchy = packages.map((p)=>p.packageVersion ? `${p.packageName}@${p.packageVersion}` : p.packageName);
    const { eventType = (0, _analyticsGasTypes.UI_EVENT_TYPE), action, actionSubject, actionSubjectId, attributes: payloadAttributes, name } = event.payload;
    const attributes = (0, _objectSpread._)({
        listenerVersion,
        sourceHierarchy: sources.join('.') || undefined,
        componentHierarchy: components.join('.') || undefined,
        packageHierarchy: packageHierarchy.join(',') || undefined,
        packageName,
        packageVersion
    }, (0, _mergeDefault.default)(extraAttributes, payloadAttributes));
    const tags = new Set(event.payload.tags || []);
    // "townsquare" is our platform analytic for data portal
    tags.add(TOWNSQUARE_TAG);
    // "townsquareHome" allows us to differentiate our events from townsquare events.
    tags.add(TOWNSQUARE_HOME_TAG);
    if (event.payload) switch(eventType){
        case 0, _analyticsGasTypes.UI_EVENT_TYPE:
        case 0, _analyticsGasTypes.OPERATIONAL_EVENT_TYPE:
        case 0, _analyticsGasTypes.TRACK_EVENT_TYPE:
            return {
                eventType,
                source,
                actionSubject,
                action,
                actionSubjectId,
                attributes,
                tags: Array.from(tags)
            };
        case 0, _analyticsGasTypes.SCREEN_EVENT_TYPE:
            return {
                eventType,
                name,
                attributes,
                tags: Array.from(tags)
            };
        default:
            logger.error('Invalid event type', eventType);
            break;
    }
    return null;
};

},{"@swc/helpers/_/_object_spread":"9gdrV","lodash/last":"9zzEk","lodash/merge":"yJjRX","@atlaskit/analytics-gas-types":"4JJns","../helpers/extract-data-from-event":"jUjVs","@atlaskit/analytics-namespaced-context":"gQwAM","@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"k1BBM":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>RovoExtensionAnalyticsListener);
var _objectSpread = require("@swc/helpers/_/_object_spread");
var _objectSpreadProps = require("@swc/helpers/_/_object_spread_props");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _types = require("../types");
var _processEvent = require("./process-event");
var _processEventDefault = parcelHelpers.interopDefault(_processEvent);
var _genericAnalyticsListener = require("../GenericAnalyticsListener");
var _genericAnalyticsListenerDefault = parcelHelpers.interopDefault(_genericAnalyticsListener);
function RovoExtensionAnalyticsListener(props) {
    return /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _genericAnalyticsListenerDefault.default), (0, _objectSpreadProps._)((0, _objectSpread._)({}, props), {
        channel: (0, _types.FabricChannel).rovoExtension,
        processEvent: (0, _processEventDefault.default)
    }));
}

},{"@swc/helpers/_/_object_spread":"9gdrV","@swc/helpers/_/_object_spread_props":"kANqQ","react":"ltHCL","../types":"gOewg","./process-event":"6D11w","../GenericAnalyticsListener":"j9F69","@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"6D11w":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _objectSpread = require("@swc/helpers/_/_object_spread");
var _last = require("lodash/last");
var _lastDefault = parcelHelpers.interopDefault(_last);
var _merge = require("lodash/merge");
var _mergeDefault = parcelHelpers.interopDefault(_merge);
var _analyticsGasTypes = require("@atlaskit/analytics-gas-types");
var _extractDataFromEvent = require("../helpers/extract-data-from-event");
var _analyticsNamespacedContext = require("@atlaskit/analytics-namespaced-context");
const ROVO_EXTENSION_TAG = 'rovoExtension';
const listenerVersion = "0.16.1";
/**
 * This util exists to convert the analytics-next event format into the analytics platform format.
 *
 * It's a copy paste from the other process-event mappers.
 */ exports.default = (event, logger)=>{
    const sources = (0, _extractDataFromEvent.getSources)(event, (0, _analyticsNamespacedContext.ROVO_EXTENSION_CONTEXT));
    const source = (0, _lastDefault.default)(sources) || (0, _analyticsGasTypes.DEFAULT_SOURCE);
    const extraAttributes = (0, _extractDataFromEvent.getExtraAttributes)(event, (0, _analyticsNamespacedContext.ROVO_EXTENSION_CONTEXT));
    const components = (0, _extractDataFromEvent.getComponents)(event, (0, _analyticsNamespacedContext.ROVO_EXTENSION_CONTEXT));
    const packages = (0, _extractDataFromEvent.getPackageInfo)(event, (0, _analyticsNamespacedContext.ROVO_EXTENSION_CONTEXT));
    const { packageName, packageVersion } = (0, _lastDefault.default)((0, _extractDataFromEvent.getPackageInfo)(event, (0, _analyticsNamespacedContext.ROVO_EXTENSION_CONTEXT))) || {};
    const packageHierarchy = packages.map((p)=>p.packageVersion ? `${p.packageName}@${p.packageVersion}` : p.packageName);
    const { eventType = (0, _analyticsGasTypes.UI_EVENT_TYPE), action, actionSubject, actionSubjectId, attributes: payloadAttributes, name } = event.payload;
    const attributes = (0, _objectSpread._)({
        listenerVersion,
        sourceHierarchy: sources.join('.') || undefined,
        componentHierarchy: components.join('.') || undefined,
        packageHierarchy: packageHierarchy.join(',') || undefined,
        packageName,
        packageVersion
    }, (0, _mergeDefault.default)(extraAttributes, payloadAttributes));
    const tags = new Set(event.payload.tags || []);
    // "rovoExtension" allows us to differentiate our events from rovo events.
    tags.add(ROVO_EXTENSION_TAG);
    if (event.payload) switch(eventType){
        case 0, _analyticsGasTypes.UI_EVENT_TYPE:
        case 0, _analyticsGasTypes.OPERATIONAL_EVENT_TYPE:
        case 0, _analyticsGasTypes.TRACK_EVENT_TYPE:
            return {
                eventType,
                source,
                actionSubject,
                action,
                actionSubjectId,
                attributes,
                tags: Array.from(tags)
            };
        case 0, _analyticsGasTypes.SCREEN_EVENT_TYPE:
            return {
                eventType,
                name,
                attributes,
                tags: Array.from(tags)
            };
        default:
            logger.error('Invalid event type', eventType);
            break;
    }
    return null;
};

},{"@swc/helpers/_/_object_spread":"9gdrV","lodash/last":"9zzEk","lodash/merge":"yJjRX","@atlaskit/analytics-gas-types":"4JJns","../helpers/extract-data-from-event":"jUjVs","@atlaskit/analytics-namespaced-context":"gQwAM","@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"8wZlU":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>TeamworkGraphAnalyticsListener);
var _objectSpread = require("@swc/helpers/_/_object_spread");
var _objectSpreadProps = require("@swc/helpers/_/_object_spread_props");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _types = require("../types");
var _processEvent = require("./process-event");
var _genericAnalyticsListener = require("../GenericAnalyticsListener");
var _genericAnalyticsListenerDefault = parcelHelpers.interopDefault(_genericAnalyticsListener);
function TeamworkGraphAnalyticsListener(props) {
    return /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _genericAnalyticsListenerDefault.default), (0, _objectSpreadProps._)((0, _objectSpread._)({}, props), {
        channel: (0, _types.FabricChannel).teamworkGraph,
        processEvent: (0, _processEvent.processEvent)
    }));
}

},{"@swc/helpers/_/_object_spread":"9gdrV","@swc/helpers/_/_object_spread_props":"kANqQ","react":"ltHCL","../types":"gOewg","./process-event":"l8Q7C","../GenericAnalyticsListener":"j9F69","@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"l8Q7C":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "processEvent", ()=>processEvent);
var _objectSpread = require("@swc/helpers/_/_object_spread");
var _objectSpreadProps = require("@swc/helpers/_/_object_spread_props");
var _analyticsGasTypes = require("@atlaskit/analytics-gas-types");
var _merge = require("lodash/merge");
var _mergeDefault = parcelHelpers.interopDefault(_merge);
var _last = require("lodash/last");
var _lastDefault = parcelHelpers.interopDefault(_last);
var _extractDataFromEvent = require("../atlaskit/extract-data-from-event");
const listenerVersion = "0.16.1";
function processEvent(event) {
    const sources = (0, _extractDataFromEvent.getSources)(event);
    const { packageName, packageVersion } = (0, _lastDefault.default)((0, _extractDataFromEvent.getPackageInfo)(event)) || {};
    const extraAttributes = (0, _extractDataFromEvent.getExtraAttributes)(event);
    const tags = new Set(event.payload.tags || []);
    tags.add('teamworkGraph');
    const components = (0, _extractDataFromEvent.getComponents)(event);
    const payload = {
        source: (0, _lastDefault.default)(sources) || (0, _analyticsGasTypes.DEFAULT_SOURCE),
        actionSubject: event.payload.actionSubject,
        action: event.payload.action,
        eventType: event.payload.eventType,
        actionSubjectId: event.payload.actionSubjectId,
        name: event.payload.name,
        tags: Array.from(tags),
        attributes: (0, _objectSpreadProps._)((0, _objectSpread._)({
            packageName,
            packageVersion
        }, (0, _mergeDefault.default)({}, extraAttributes, event.payload.attributes)), {
            componentHierarchy: components.join('.') || undefined,
            packageHierarchy: (0, _extractDataFromEvent.getPackageHierarchy)(event),
            sourceHierarchy: sources.join('.') || undefined,
            listenerVersion
        }),
        nonPrivacySafeAttributes: event.payload.nonPrivacySafeAttributes
    };
    return payload;
}

},{"@swc/helpers/_/_object_spread":"9gdrV","@swc/helpers/_/_object_spread_props":"kANqQ","@atlaskit/analytics-gas-types":"4JJns","lodash/merge":"yJjRX","lodash/last":"9zzEk","../atlaskit/extract-data-from-event":"88IeQ","@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"6YOyH":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "ContextualAnalyticsData", ()=>// components and props
    (0, _contextWrapper.ContextWrapper));
parcelHelpers.export(exports, "FireOperationalAnalytics", ()=>(0, _fireAnalytics.FireOperationalAnalytics));
parcelHelpers.export(exports, "FireScreenAnalytics", ()=>(0, _fireAnalytics.FireScreenAnalytics));
parcelHelpers.export(exports, "FireTrackAnalytics", ()=>(0, _fireAnalytics.FireTrackAnalytics));
parcelHelpers.export(exports, "FireUIAnalytics", ()=>(0, _fireAnalytics.FireUIAnalytics));
parcelHelpers.export(exports, "MountEvent", ()=>(0, _mountEvent.MountEvent));
parcelHelpers.export(exports, "AnalyticsEventToProps", ()=>(0, _analyticsEventToProps.AnalyticsEventToProps));
parcelHelpers.export(exports, "fireAnalytics", ()=>// utilities
    (0, _fireAnalytics1.fireAnalytics));
parcelHelpers.export(exports, "fireOperationalAnalytics", ()=>(0, _fireAnalytics1.fireOperationalAnalytics));
parcelHelpers.export(exports, "fireScreenAnalytics", ()=>(0, _fireAnalytics1.fireScreenAnalytics));
parcelHelpers.export(exports, "fireTrackAnalytics", ()=>(0, _fireAnalytics1.fireTrackAnalytics));
parcelHelpers.export(exports, "fireUIAnalytics", ()=>(0, _fireAnalytics1.fireUIAnalytics));
parcelHelpers.export(exports, "createTestEvent", ()=>(0, _createTestEvent.createTestEvent));
parcelHelpers.export(exports, "extractAWCDataFromEvent", ()=>(0, _extractAwcDataFromEvent.extractAWCDataFromEvent));
parcelHelpers.export(exports, "DRAWER", ()=>(0, _constants.DRAWER));
parcelHelpers.export(exports, "DROPDOWN", ()=>(0, _constants.DROPDOWN));
parcelHelpers.export(exports, "INLINE_DIALOG", ()=>(0, _constants.INLINE_DIALOG));
parcelHelpers.export(exports, "MODAL", ()=>(0, _constants.MODAL));
parcelHelpers.export(exports, "SCREEN", ()=>(0, _constants.SCREEN));
parcelHelpers.export(exports, "OPERATIONAL_EVENT_TYPE", ()=>(0, _constants.OPERATIONAL_EVENT_TYPE));
parcelHelpers.export(exports, "SCREEN_EVENT_TYPE", ()=>(0, _constants.SCREEN_EVENT_TYPE));
parcelHelpers.export(exports, "TRACK_EVENT_TYPE", ()=>(0, _constants.TRACK_EVENT_TYPE));
parcelHelpers.export(exports, "UI_EVENT_TYPE", ()=>(0, _constants.UI_EVENT_TYPE));
parcelHelpers.export(exports, "ANALYTICS_BRIDGE_CHANNEL", ()=>(0, _constants.ANALYTICS_BRIDGE_CHANNEL));
var _constants = require("./constants");
var _analyticsEventToProps = require("./ui/analytics-event-to-props");
var _contextWrapper = require("./ui/context-wrapper");
var _fireAnalytics = require("./ui/fire-analytics");
var _mountEvent = require("./ui/mount-event");
var _createTestEvent = require("./utils/create-test-event");
var _extractAwcDataFromEvent = require("./utils/extract-awc-data-from-event");
var _fireAnalytics1 = require("./utils/fire-analytics");

},{"./constants":"6DjR0","./ui/analytics-event-to-props":false,"./ui/context-wrapper":"hkPN4","./ui/fire-analytics":"3TqXX","./ui/mount-event":false,"./utils/create-test-event":false,"./utils/extract-awc-data-from-event":"afXui","./utils/fire-analytics":"em7XG","@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"6DjR0":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "SCREEN", ()=>SCREEN);
parcelHelpers.export(exports, "DRAWER", ()=>DRAWER);
parcelHelpers.export(exports, "MODAL", ()=>MODAL);
parcelHelpers.export(exports, "INLINE_DIALOG", ()=>INLINE_DIALOG);
parcelHelpers.export(exports, "DROPDOWN", ()=>DROPDOWN);
parcelHelpers.export(exports, "UI_EVENT_TYPE", ()=>UI_EVENT_TYPE);
parcelHelpers.export(exports, "TRACK_EVENT_TYPE", ()=>TRACK_EVENT_TYPE);
parcelHelpers.export(exports, "SCREEN_EVENT_TYPE", ()=>SCREEN_EVENT_TYPE);
parcelHelpers.export(exports, "OPERATIONAL_EVENT_TYPE", ()=>OPERATIONAL_EVENT_TYPE);
parcelHelpers.export(exports, "ANALYTICS_BRIDGE_CHANNEL", ()=>ANALYTICS_BRIDGE_CHANNEL);
const SCREEN = 'Screen';
const DRAWER = 'Drawer';
const MODAL = 'Modal';
const INLINE_DIALOG = 'InlineDialog';
const DROPDOWN = 'Dropdown';
const UI_EVENT_TYPE = 'UI';
const TRACK_EVENT_TYPE = 'TRACK';
const SCREEN_EVENT_TYPE = 'SCREEN';
const OPERATIONAL_EVENT_TYPE = 'OPERATIONAL';
const ANALYTICS_BRIDGE_CHANNEL = 'analyticsBridge';

},{"@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"hkPN4":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "extractContextualData", ()=>extractContextualData);
parcelHelpers.export(exports, "ContextWrapper", ()=>ContextWrapper);
var _objectSpread = require("@swc/helpers/_/_object_spread");
var _objectWithoutProperties = require("@swc/helpers/_/_object_without_properties");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _isUndefined = require("lodash/isUndefined");
var _isUndefinedDefault = parcelHelpers.interopDefault(_isUndefined);
var _omitBy = require("lodash/omitBy");
var _omitByDefault = parcelHelpers.interopDefault(_omitBy);
var _analyticsNext = require("@atlaskit/analytics-next");
const extractContextualData = (props)=>{
    const { children, sourceName, sourceType } = props, rest = (0, _objectWithoutProperties._)(props, [
        "children",
        "sourceName",
        "sourceType"
    ]);
    const source = sourceName && sourceType ? `${sourceName}${sourceType}` : undefined;
    return (0, _omitByDefault.default)((0, _objectSpread._)({
        source
    }, rest), (0, _isUndefinedDefault.default));
};
const ContextWrapper = (props)=>{
    const data = extractContextualData(props);
    return /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _analyticsNext.AnalyticsContext), {
        data: data
    }, /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _reactDefault.default).Fragment, null, props.children));
};

},{"@swc/helpers/_/_object_spread":"9gdrV","@swc/helpers/_/_object_without_properties":"6HqIM","react":"ltHCL","lodash/isUndefined":"aoQJa","lodash/omitBy":"80W3G","@atlaskit/analytics-next":"6PLie","@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"aoQJa":[function(require,module,exports,__globalThis) {
/**
 * Checks if `value` is `undefined`.
 *
 * @static
 * @since 0.1.0
 * @memberOf _
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is `undefined`, else `false`.
 * @example
 *
 * _.isUndefined(void 0);
 * // => true
 *
 * _.isUndefined(null);
 * // => false
 */ function isUndefined(value) {
    return value === undefined;
}
module.exports = isUndefined;

},{}],"80W3G":[function(require,module,exports,__globalThis) {
var baseIteratee = require("974f8c863b63d6c7"), negate = require("86ca5fb93ab43b1c"), pickBy = require("5d351126ae51bf17");
/**
 * The opposite of `_.pickBy`; this method creates an object composed of
 * the own and inherited enumerable string keyed properties of `object` that
 * `predicate` doesn't return truthy for. The predicate is invoked with two
 * arguments: (value, key).
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Object
 * @param {Object} object The source object.
 * @param {Function} [predicate=_.identity] The function invoked per property.
 * @returns {Object} Returns the new object.
 * @example
 *
 * var object = { 'a': 1, 'b': '2', 'c': 3 };
 *
 * _.omitBy(object, _.isNumber);
 * // => { 'b': '2' }
 */ function omitBy(object, predicate) {
    return pickBy(object, negate(baseIteratee(predicate)));
}
module.exports = omitBy;

},{"974f8c863b63d6c7":"fEqZi","86ca5fb93ab43b1c":"9MIfu","5d351126ae51bf17":"9pFAG"}],"fEqZi":[function(require,module,exports,__globalThis) {
var baseMatches = require("b04355d31be8403b"), baseMatchesProperty = require("2b491ba8be3629ae"), identity = require("ae499cb7c50b3a7d"), isArray = require("e696697aba1271f0"), property = require("2165b2063fb6bdf1");
/**
 * The base implementation of `_.iteratee`.
 *
 * @private
 * @param {*} [value=_.identity] The value to convert to an iteratee.
 * @returns {Function} Returns the iteratee.
 */ function baseIteratee(value) {
    // Don't store the `typeof` result in a variable to avoid a JIT bug in Safari 9.
    // See https://bugs.webkit.org/show_bug.cgi?id=156034 for more details.
    if (typeof value == 'function') return value;
    if (value == null) return identity;
    if (typeof value == 'object') return isArray(value) ? baseMatchesProperty(value[0], value[1]) : baseMatches(value);
    return property(value);
}
module.exports = baseIteratee;

},{"b04355d31be8403b":"8ifwr","2b491ba8be3629ae":"iNFBG","ae499cb7c50b3a7d":"j4SfH","e696697aba1271f0":"7eHCl","2165b2063fb6bdf1":"2h1fo"}],"8ifwr":[function(require,module,exports,__globalThis) {
var baseIsMatch = require("de0d091955d15614"), getMatchData = require("30e43195d568172d"), matchesStrictComparable = require("498249580be58870");
/**
 * The base implementation of `_.matches` which doesn't clone `source`.
 *
 * @private
 * @param {Object} source The object of property values to match.
 * @returns {Function} Returns the new spec function.
 */ function baseMatches(source) {
    var matchData = getMatchData(source);
    if (matchData.length == 1 && matchData[0][2]) return matchesStrictComparable(matchData[0][0], matchData[0][1]);
    return function(object) {
        return object === source || baseIsMatch(object, source, matchData);
    };
}
module.exports = baseMatches;

},{"de0d091955d15614":"4qtBh","30e43195d568172d":"dRgMK","498249580be58870":"1rAPH"}],"4qtBh":[function(require,module,exports,__globalThis) {
var Stack = require("bd8f31dd5bea33e8"), baseIsEqual = require("ea26ad485f2df082");
/** Used to compose bitmasks for value comparisons. */ var COMPARE_PARTIAL_FLAG = 1, COMPARE_UNORDERED_FLAG = 2;
/**
 * The base implementation of `_.isMatch` without support for iteratee shorthands.
 *
 * @private
 * @param {Object} object The object to inspect.
 * @param {Object} source The object of property values to match.
 * @param {Array} matchData The property names, values, and compare flags to match.
 * @param {Function} [customizer] The function to customize comparisons.
 * @returns {boolean} Returns `true` if `object` is a match, else `false`.
 */ function baseIsMatch(object, source, matchData, customizer) {
    var index = matchData.length, length = index, noCustomizer = !customizer;
    if (object == null) return !length;
    object = Object(object);
    while(index--){
        var data = matchData[index];
        if (noCustomizer && data[2] ? data[1] !== object[data[0]] : !(data[0] in object)) return false;
    }
    while(++index < length){
        data = matchData[index];
        var key = data[0], objValue = object[key], srcValue = data[1];
        if (noCustomizer && data[2]) {
            if (objValue === undefined && !(key in object)) return false;
        } else {
            var stack = new Stack;
            if (customizer) var result = customizer(objValue, srcValue, key, object, source, stack);
            if (!(result === undefined ? baseIsEqual(srcValue, objValue, COMPARE_PARTIAL_FLAG | COMPARE_UNORDERED_FLAG, customizer, stack) : result)) return false;
        }
    }
    return true;
}
module.exports = baseIsMatch;

},{"bd8f31dd5bea33e8":"klKXc","ea26ad485f2df082":"ePleT"}],"ePleT":[function(require,module,exports,__globalThis) {
var baseIsEqualDeep = require("434b0335b6c287c5"), isObjectLike = require("a3cda01893ca66e1");
/**
 * The base implementation of `_.isEqual` which supports partial comparisons
 * and tracks traversed objects.
 *
 * @private
 * @param {*} value The value to compare.
 * @param {*} other The other value to compare.
 * @param {boolean} bitmask The bitmask flags.
 *  1 - Unordered comparison
 *  2 - Partial comparison
 * @param {Function} [customizer] The function to customize comparisons.
 * @param {Object} [stack] Tracks traversed `value` and `other` objects.
 * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
 */ function baseIsEqual(value, other, bitmask, customizer, stack) {
    if (value === other) return true;
    if (value == null || other == null || !isObjectLike(value) && !isObjectLike(other)) return value !== value && other !== other;
    return baseIsEqualDeep(value, other, bitmask, customizer, baseIsEqual, stack);
}
module.exports = baseIsEqual;

},{"434b0335b6c287c5":"8JYjk","a3cda01893ca66e1":"eoT9f"}],"8JYjk":[function(require,module,exports,__globalThis) {
var Stack = require("e4c6cb8de28a75f0"), equalArrays = require("1521d4290e58b90d"), equalByTag = require("f540f0ac0320d9c5"), equalObjects = require("b97fb63a43ea82c4"), getTag = require("f14b77b54b243bdf"), isArray = require("57b0bece5ec71e88"), isBuffer = require("d053a76d8916e153"), isTypedArray = require("a51953f57488fe2a");
/** Used to compose bitmasks for value comparisons. */ var COMPARE_PARTIAL_FLAG = 1;
/** `Object#toString` result references. */ var argsTag = '[object Arguments]', arrayTag = '[object Array]', objectTag = '[object Object]';
/** Used for built-in method references. */ var objectProto = Object.prototype;
/** Used to check objects for own properties. */ var hasOwnProperty = objectProto.hasOwnProperty;
/**
 * A specialized version of `baseIsEqual` for arrays and objects which performs
 * deep comparisons and tracks traversed objects enabling objects with circular
 * references to be compared.
 *
 * @private
 * @param {Object} object The object to compare.
 * @param {Object} other The other object to compare.
 * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
 * @param {Function} customizer The function to customize comparisons.
 * @param {Function} equalFunc The function to determine equivalents of values.
 * @param {Object} [stack] Tracks traversed `object` and `other` objects.
 * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
 */ function baseIsEqualDeep(object, other, bitmask, customizer, equalFunc, stack) {
    var objIsArr = isArray(object), othIsArr = isArray(other), objTag = objIsArr ? arrayTag : getTag(object), othTag = othIsArr ? arrayTag : getTag(other);
    objTag = objTag == argsTag ? objectTag : objTag;
    othTag = othTag == argsTag ? objectTag : othTag;
    var objIsObj = objTag == objectTag, othIsObj = othTag == objectTag, isSameTag = objTag == othTag;
    if (isSameTag && isBuffer(object)) {
        if (!isBuffer(other)) return false;
        objIsArr = true;
        objIsObj = false;
    }
    if (isSameTag && !objIsObj) {
        stack || (stack = new Stack);
        return objIsArr || isTypedArray(object) ? equalArrays(object, other, bitmask, customizer, equalFunc, stack) : equalByTag(object, other, objTag, bitmask, customizer, equalFunc, stack);
    }
    if (!(bitmask & COMPARE_PARTIAL_FLAG)) {
        var objIsWrapped = objIsObj && hasOwnProperty.call(object, '__wrapped__'), othIsWrapped = othIsObj && hasOwnProperty.call(other, '__wrapped__');
        if (objIsWrapped || othIsWrapped) {
            var objUnwrapped = objIsWrapped ? object.value() : object, othUnwrapped = othIsWrapped ? other.value() : other;
            stack || (stack = new Stack);
            return equalFunc(objUnwrapped, othUnwrapped, bitmask, customizer, stack);
        }
    }
    if (!isSameTag) return false;
    stack || (stack = new Stack);
    return equalObjects(object, other, bitmask, customizer, equalFunc, stack);
}
module.exports = baseIsEqualDeep;

},{"e4c6cb8de28a75f0":"klKXc","1521d4290e58b90d":"5Z6Wd","f540f0ac0320d9c5":"lSIxx","b97fb63a43ea82c4":"k3JQF","f14b77b54b243bdf":"4SOxL","57b0bece5ec71e88":"7eHCl","d053a76d8916e153":"chGID","a51953f57488fe2a":"3JUwD"}],"5Z6Wd":[function(require,module,exports,__globalThis) {
var SetCache = require("75a0b406934c8ec7"), arraySome = require("beb4b5d003fe3bbe"), cacheHas = require("b2a7e14ec4791c1b");
/** Used to compose bitmasks for value comparisons. */ var COMPARE_PARTIAL_FLAG = 1, COMPARE_UNORDERED_FLAG = 2;
/**
 * A specialized version of `baseIsEqualDeep` for arrays with support for
 * partial deep comparisons.
 *
 * @private
 * @param {Array} array The array to compare.
 * @param {Array} other The other array to compare.
 * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
 * @param {Function} customizer The function to customize comparisons.
 * @param {Function} equalFunc The function to determine equivalents of values.
 * @param {Object} stack Tracks traversed `array` and `other` objects.
 * @returns {boolean} Returns `true` if the arrays are equivalent, else `false`.
 */ function equalArrays(array, other, bitmask, customizer, equalFunc, stack) {
    var isPartial = bitmask & COMPARE_PARTIAL_FLAG, arrLength = array.length, othLength = other.length;
    if (arrLength != othLength && !(isPartial && othLength > arrLength)) return false;
    // Check that cyclic values are equal.
    var arrStacked = stack.get(array);
    var othStacked = stack.get(other);
    if (arrStacked && othStacked) return arrStacked == other && othStacked == array;
    var index = -1, result = true, seen = bitmask & COMPARE_UNORDERED_FLAG ? new SetCache : undefined;
    stack.set(array, other);
    stack.set(other, array);
    // Ignore non-index properties.
    while(++index < arrLength){
        var arrValue = array[index], othValue = other[index];
        if (customizer) var compared = isPartial ? customizer(othValue, arrValue, index, other, array, stack) : customizer(arrValue, othValue, index, array, other, stack);
        if (compared !== undefined) {
            if (compared) continue;
            result = false;
            break;
        }
        // Recursively compare arrays (susceptible to call stack limits).
        if (seen) {
            if (!arraySome(other, function(othValue, othIndex) {
                if (!cacheHas(seen, othIndex) && (arrValue === othValue || equalFunc(arrValue, othValue, bitmask, customizer, stack))) return seen.push(othIndex);
            })) {
                result = false;
                break;
            }
        } else if (!(arrValue === othValue || equalFunc(arrValue, othValue, bitmask, customizer, stack))) {
            result = false;
            break;
        }
    }
    stack['delete'](array);
    stack['delete'](other);
    return result;
}
module.exports = equalArrays;

},{"75a0b406934c8ec7":"6pKaT","beb4b5d003fe3bbe":"3fT9f","b2a7e14ec4791c1b":"2exP4"}],"6pKaT":[function(require,module,exports,__globalThis) {
var MapCache = require("cdd42c0f8763ae03"), setCacheAdd = require("78359c1bd7d5e6d7"), setCacheHas = require("e1aea408a55a7660");
/**
 *
 * Creates an array cache object to store unique values.
 *
 * @private
 * @constructor
 * @param {Array} [values] The values to cache.
 */ function SetCache(values) {
    var index = -1, length = values == null ? 0 : values.length;
    this.__data__ = new MapCache;
    while(++index < length)this.add(values[index]);
}
// Add methods to `SetCache`.
SetCache.prototype.add = SetCache.prototype.push = setCacheAdd;
SetCache.prototype.has = setCacheHas;
module.exports = SetCache;

},{"cdd42c0f8763ae03":"bRb09","78359c1bd7d5e6d7":"gRbva","e1aea408a55a7660":"jcVFZ"}],"gRbva":[function(require,module,exports,__globalThis) {
/** Used to stand-in for `undefined` hash values. */ var HASH_UNDEFINED = '__lodash_hash_undefined__';
/**
 * Adds `value` to the array cache.
 *
 * @private
 * @name add
 * @memberOf SetCache
 * @alias push
 * @param {*} value The value to cache.
 * @returns {Object} Returns the cache instance.
 */ function setCacheAdd(value) {
    this.__data__.set(value, HASH_UNDEFINED);
    return this;
}
module.exports = setCacheAdd;

},{}],"jcVFZ":[function(require,module,exports,__globalThis) {
/**
 * Checks if `value` is in the array cache.
 *
 * @private
 * @name has
 * @memberOf SetCache
 * @param {*} value The value to search for.
 * @returns {boolean} Returns `true` if `value` is found, else `false`.
 */ function setCacheHas(value) {
    return this.__data__.has(value);
}
module.exports = setCacheHas;

},{}],"3fT9f":[function(require,module,exports,__globalThis) {
/**
 * A specialized version of `_.some` for arrays without support for iteratee
 * shorthands.
 *
 * @private
 * @param {Array} [array] The array to iterate over.
 * @param {Function} predicate The function invoked per iteration.
 * @returns {boolean} Returns `true` if any element passes the predicate check,
 *  else `false`.
 */ function arraySome(array, predicate) {
    var index = -1, length = array == null ? 0 : array.length;
    while(++index < length){
        if (predicate(array[index], index, array)) return true;
    }
    return false;
}
module.exports = arraySome;

},{}],"2exP4":[function(require,module,exports,__globalThis) {
/**
 * Checks if a `cache` value for `key` exists.
 *
 * @private
 * @param {Object} cache The cache to query.
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */ function cacheHas(cache, key) {
    return cache.has(key);
}
module.exports = cacheHas;

},{}],"lSIxx":[function(require,module,exports,__globalThis) {
var Symbol = require("883e3f7dd0d1046"), Uint8Array = require("73c1d02ac1bce4a7"), eq = require("8e82eea2d42b7ad5"), equalArrays = require("83a82fa13d0d8e94"), mapToArray = require("6a38a3a1664048f8"), setToArray = require("d19474010ea852a7");
/** Used to compose bitmasks for value comparisons. */ var COMPARE_PARTIAL_FLAG = 1, COMPARE_UNORDERED_FLAG = 2;
/** `Object#toString` result references. */ var boolTag = '[object Boolean]', dateTag = '[object Date]', errorTag = '[object Error]', mapTag = '[object Map]', numberTag = '[object Number]', regexpTag = '[object RegExp]', setTag = '[object Set]', stringTag = '[object String]', symbolTag = '[object Symbol]';
var arrayBufferTag = '[object ArrayBuffer]', dataViewTag = '[object DataView]';
/** Used to convert symbols to primitives and strings. */ var symbolProto = Symbol ? Symbol.prototype : undefined, symbolValueOf = symbolProto ? symbolProto.valueOf : undefined;
/**
 * A specialized version of `baseIsEqualDeep` for comparing objects of
 * the same `toStringTag`.
 *
 * **Note:** This function only supports comparing values with tags of
 * `Boolean`, `Date`, `Error`, `Number`, `RegExp`, or `String`.
 *
 * @private
 * @param {Object} object The object to compare.
 * @param {Object} other The other object to compare.
 * @param {string} tag The `toStringTag` of the objects to compare.
 * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
 * @param {Function} customizer The function to customize comparisons.
 * @param {Function} equalFunc The function to determine equivalents of values.
 * @param {Object} stack Tracks traversed `object` and `other` objects.
 * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
 */ function equalByTag(object, other, tag, bitmask, customizer, equalFunc, stack) {
    switch(tag){
        case dataViewTag:
            if (object.byteLength != other.byteLength || object.byteOffset != other.byteOffset) return false;
            object = object.buffer;
            other = other.buffer;
        case arrayBufferTag:
            if (object.byteLength != other.byteLength || !equalFunc(new Uint8Array(object), new Uint8Array(other))) return false;
            return true;
        case boolTag:
        case dateTag:
        case numberTag:
            // Coerce booleans to `1` or `0` and dates to milliseconds.
            // Invalid dates are coerced to `NaN`.
            return eq(+object, +other);
        case errorTag:
            return object.name == other.name && object.message == other.message;
        case regexpTag:
        case stringTag:
            // Coerce regexes to strings and treat strings, primitives and objects,
            // as equal. See http://www.ecma-international.org/ecma-262/7.0/#sec-regexp.prototype.tostring
            // for more details.
            return object == other + '';
        case mapTag:
            var convert = mapToArray;
        case setTag:
            var isPartial = bitmask & COMPARE_PARTIAL_FLAG;
            convert || (convert = setToArray);
            if (object.size != other.size && !isPartial) return false;
            // Assume cyclic values are equal.
            var stacked = stack.get(object);
            if (stacked) return stacked == other;
            bitmask |= COMPARE_UNORDERED_FLAG;
            // Recursively compare objects (susceptible to call stack limits).
            stack.set(object, other);
            var result = equalArrays(convert(object), convert(other), bitmask, customizer, equalFunc, stack);
            stack['delete'](object);
            return result;
        case symbolTag:
            if (symbolValueOf) return symbolValueOf.call(object) == symbolValueOf.call(other);
    }
    return false;
}
module.exports = equalByTag;

},{"883e3f7dd0d1046":"c4qDk","73c1d02ac1bce4a7":"8RJdf","8e82eea2d42b7ad5":"cZv4K","83a82fa13d0d8e94":"5Z6Wd","6a38a3a1664048f8":"lyPFI","d19474010ea852a7":"2vW8W"}],"lyPFI":[function(require,module,exports,__globalThis) {
/**
 * Converts `map` to its key-value pairs.
 *
 * @private
 * @param {Object} map The map to convert.
 * @returns {Array} Returns the key-value pairs.
 */ function mapToArray(map) {
    var index = -1, result = Array(map.size);
    map.forEach(function(value, key) {
        result[++index] = [
            key,
            value
        ];
    });
    return result;
}
module.exports = mapToArray;

},{}],"2vW8W":[function(require,module,exports,__globalThis) {
/**
 * Converts `set` to an array of its values.
 *
 * @private
 * @param {Object} set The set to convert.
 * @returns {Array} Returns the values.
 */ function setToArray(set) {
    var index = -1, result = Array(set.size);
    set.forEach(function(value) {
        result[++index] = value;
    });
    return result;
}
module.exports = setToArray;

},{}],"k3JQF":[function(require,module,exports,__globalThis) {
var getAllKeys = require("d2c8bdf866da0ff1");
/** Used to compose bitmasks for value comparisons. */ var COMPARE_PARTIAL_FLAG = 1;
/** Used for built-in method references. */ var objectProto = Object.prototype;
/** Used to check objects for own properties. */ var hasOwnProperty = objectProto.hasOwnProperty;
/**
 * A specialized version of `baseIsEqualDeep` for objects with support for
 * partial deep comparisons.
 *
 * @private
 * @param {Object} object The object to compare.
 * @param {Object} other The other object to compare.
 * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
 * @param {Function} customizer The function to customize comparisons.
 * @param {Function} equalFunc The function to determine equivalents of values.
 * @param {Object} stack Tracks traversed `object` and `other` objects.
 * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
 */ function equalObjects(object, other, bitmask, customizer, equalFunc, stack) {
    var isPartial = bitmask & COMPARE_PARTIAL_FLAG, objProps = getAllKeys(object), objLength = objProps.length, othProps = getAllKeys(other), othLength = othProps.length;
    if (objLength != othLength && !isPartial) return false;
    var index = objLength;
    while(index--){
        var key = objProps[index];
        if (!(isPartial ? key in other : hasOwnProperty.call(other, key))) return false;
    }
    // Check that cyclic values are equal.
    var objStacked = stack.get(object);
    var othStacked = stack.get(other);
    if (objStacked && othStacked) return objStacked == other && othStacked == object;
    var result = true;
    stack.set(object, other);
    stack.set(other, object);
    var skipCtor = isPartial;
    while(++index < objLength){
        key = objProps[index];
        var objValue = object[key], othValue = other[key];
        if (customizer) var compared = isPartial ? customizer(othValue, objValue, key, other, object, stack) : customizer(objValue, othValue, key, object, other, stack);
        // Recursively compare objects (susceptible to call stack limits).
        if (!(compared === undefined ? objValue === othValue || equalFunc(objValue, othValue, bitmask, customizer, stack) : compared)) {
            result = false;
            break;
        }
        skipCtor || (skipCtor = key == 'constructor');
    }
    if (result && !skipCtor) {
        var objCtor = object.constructor, othCtor = other.constructor;
        // Non `Object` object instances with different constructors are not equal.
        if (objCtor != othCtor && 'constructor' in object && 'constructor' in other && !(typeof objCtor == 'function' && objCtor instanceof objCtor && typeof othCtor == 'function' && othCtor instanceof othCtor)) result = false;
    }
    stack['delete'](object);
    stack['delete'](other);
    return result;
}
module.exports = equalObjects;

},{"d2c8bdf866da0ff1":"aycXZ"}],"aycXZ":[function(require,module,exports,__globalThis) {
var baseGetAllKeys = require("b4066cfdc67967d3"), getSymbols = require("39253ecb82e90ce3"), keys = require("6f78add0081f91b7");
/**
 * Creates an array of own enumerable property names and symbols of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names and symbols.
 */ function getAllKeys(object) {
    return baseGetAllKeys(object, keys, getSymbols);
}
module.exports = getAllKeys;

},{"b4066cfdc67967d3":"eq3SY","39253ecb82e90ce3":"a1iC0","6f78add0081f91b7":"3Wi3D"}],"eq3SY":[function(require,module,exports,__globalThis) {
var arrayPush = require("806d8055c736569a"), isArray = require("2741132c0c46a7bd");
/**
 * The base implementation of `getAllKeys` and `getAllKeysIn` which uses
 * `keysFunc` and `symbolsFunc` to get the enumerable property names and
 * symbols of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @param {Function} keysFunc The function to get the keys of `object`.
 * @param {Function} symbolsFunc The function to get the symbols of `object`.
 * @returns {Array} Returns the array of property names and symbols.
 */ function baseGetAllKeys(object, keysFunc, symbolsFunc) {
    var result = keysFunc(object);
    return isArray(object) ? result : arrayPush(result, symbolsFunc(object));
}
module.exports = baseGetAllKeys;

},{"806d8055c736569a":"bkzAk","2741132c0c46a7bd":"7eHCl"}],"bkzAk":[function(require,module,exports,__globalThis) {
/**
 * Appends the elements of `values` to `array`.
 *
 * @private
 * @param {Array} array The array to modify.
 * @param {Array} values The values to append.
 * @returns {Array} Returns `array`.
 */ function arrayPush(array, values) {
    var index = -1, length = values.length, offset = array.length;
    while(++index < length)array[offset + index] = values[index];
    return array;
}
module.exports = arrayPush;

},{}],"a1iC0":[function(require,module,exports,__globalThis) {
var arrayFilter = require("5acb8da577de48de"), stubArray = require("4fe688218c31fbaf");
/** Used for built-in method references. */ var objectProto = Object.prototype;
/** Built-in value references. */ var propertyIsEnumerable = objectProto.propertyIsEnumerable;
/* Built-in method references for those with the same name as other `lodash` methods. */ var nativeGetSymbols = Object.getOwnPropertySymbols;
/**
 * Creates an array of the own enumerable symbols of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of symbols.
 */ var getSymbols = !nativeGetSymbols ? stubArray : function(object) {
    if (object == null) return [];
    object = Object(object);
    return arrayFilter(nativeGetSymbols(object), function(symbol) {
        return propertyIsEnumerable.call(object, symbol);
    });
};
module.exports = getSymbols;

},{"5acb8da577de48de":"f0c5M","4fe688218c31fbaf":"fHpuG"}],"f0c5M":[function(require,module,exports,__globalThis) {
/**
 * A specialized version of `_.filter` for arrays without support for
 * iteratee shorthands.
 *
 * @private
 * @param {Array} [array] The array to iterate over.
 * @param {Function} predicate The function invoked per iteration.
 * @returns {Array} Returns the new filtered array.
 */ function arrayFilter(array, predicate) {
    var index = -1, length = array == null ? 0 : array.length, resIndex = 0, result = [];
    while(++index < length){
        var value = array[index];
        if (predicate(value, index, array)) result[resIndex++] = value;
    }
    return result;
}
module.exports = arrayFilter;

},{}],"fHpuG":[function(require,module,exports,__globalThis) {
/**
 * This method returns a new empty array.
 *
 * @static
 * @memberOf _
 * @since 4.13.0
 * @category Util
 * @returns {Array} Returns the new empty array.
 * @example
 *
 * var arrays = _.times(2, _.stubArray);
 *
 * console.log(arrays);
 * // => [[], []]
 *
 * console.log(arrays[0] === arrays[1]);
 * // => false
 */ function stubArray() {
    return [];
}
module.exports = stubArray;

},{}],"3Wi3D":[function(require,module,exports,__globalThis) {
var arrayLikeKeys = require("2b412ae5b4f93b38"), baseKeys = require("455b1e8ccad68703"), isArrayLike = require("183866e6da4dcbb9");
/**
 * Creates an array of the own enumerable property names of `object`.
 *
 * **Note:** Non-object values are coerced to objects. See the
 * [ES spec](http://ecma-international.org/ecma-262/7.0/#sec-object.keys)
 * for more details.
 *
 * @static
 * @since 0.1.0
 * @memberOf _
 * @category Object
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names.
 * @example
 *
 * function Foo() {
 *   this.a = 1;
 *   this.b = 2;
 * }
 *
 * Foo.prototype.c = 3;
 *
 * _.keys(new Foo);
 * // => ['a', 'b'] (iteration order is not guaranteed)
 *
 * _.keys('hi');
 * // => ['0', '1']
 */ function keys(object) {
    return isArrayLike(object) ? arrayLikeKeys(object) : baseKeys(object);
}
module.exports = keys;

},{"2b412ae5b4f93b38":"b0EPV","455b1e8ccad68703":"dSRad","183866e6da4dcbb9":"d4PO7"}],"dSRad":[function(require,module,exports,__globalThis) {
var isPrototype = require("8bc365c63ddbc7fc"), nativeKeys = require("d75e05d021886f87");
/** Used for built-in method references. */ var objectProto = Object.prototype;
/** Used to check objects for own properties. */ var hasOwnProperty = objectProto.hasOwnProperty;
/**
 * The base implementation of `_.keys` which doesn't treat sparse arrays as dense.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names.
 */ function baseKeys(object) {
    if (!isPrototype(object)) return nativeKeys(object);
    var result = [];
    for(var key in Object(object))if (hasOwnProperty.call(object, key) && key != 'constructor') result.push(key);
    return result;
}
module.exports = baseKeys;

},{"8bc365c63ddbc7fc":"flb0y","d75e05d021886f87":"jHNRU"}],"jHNRU":[function(require,module,exports,__globalThis) {
var overArg = require("82529798bb9d1817");
/* Built-in method references for those with the same name as other `lodash` methods. */ var nativeKeys = overArg(Object.keys, Object);
module.exports = nativeKeys;

},{"82529798bb9d1817":"1iwkr"}],"4SOxL":[function(require,module,exports,__globalThis) {
var DataView = require("fde5e30a30f7fb6"), Map = require("5cb11e36214f886e"), Promise = require("cf7c10476c9fe522"), Set = require("35a2f01f5e41e283"), WeakMap = require("ee7530497de49048"), baseGetTag = require("da5b6efffb6f513e"), toSource = require("f54538f035a76e4b");
/** `Object#toString` result references. */ var mapTag = '[object Map]', objectTag = '[object Object]', promiseTag = '[object Promise]', setTag = '[object Set]', weakMapTag = '[object WeakMap]';
var dataViewTag = '[object DataView]';
/** Used to detect maps, sets, and weakmaps. */ var dataViewCtorString = toSource(DataView), mapCtorString = toSource(Map), promiseCtorString = toSource(Promise), setCtorString = toSource(Set), weakMapCtorString = toSource(WeakMap);
/**
 * Gets the `toStringTag` of `value`.
 *
 * @private
 * @param {*} value The value to query.
 * @returns {string} Returns the `toStringTag`.
 */ var getTag = baseGetTag;
// Fallback for data views, maps, sets, and weak maps in IE 11 and promises in Node.js < 6.
if (DataView && getTag(new DataView(new ArrayBuffer(1))) != dataViewTag || Map && getTag(new Map) != mapTag || Promise && getTag(Promise.resolve()) != promiseTag || Set && getTag(new Set) != setTag || WeakMap && getTag(new WeakMap) != weakMapTag) getTag = function(value) {
    var result = baseGetTag(value), Ctor = result == objectTag ? value.constructor : undefined, ctorString = Ctor ? toSource(Ctor) : '';
    if (ctorString) switch(ctorString){
        case dataViewCtorString:
            return dataViewTag;
        case mapCtorString:
            return mapTag;
        case promiseCtorString:
            return promiseTag;
        case setCtorString:
            return setTag;
        case weakMapCtorString:
            return weakMapTag;
    }
    return result;
};
module.exports = getTag;

},{"fde5e30a30f7fb6":"aJrZB","5cb11e36214f886e":"ddZHY","cf7c10476c9fe522":"iQJ17","35a2f01f5e41e283":"eKGpA","ee7530497de49048":"8oaDs","da5b6efffb6f513e":"5NOi0","f54538f035a76e4b":"gZQCn"}],"aJrZB":[function(require,module,exports,__globalThis) {
var getNative = require("b02da34458370ba3"), root = require("2953fe00d2198213");
/* Built-in method references that are verified to be native. */ var DataView = getNative(root, 'DataView');
module.exports = DataView;

},{"b02da34458370ba3":"bCwni","2953fe00d2198213":"J0J3B"}],"iQJ17":[function(require,module,exports,__globalThis) {
var getNative = require("37d079a42d39f8e9"), root = require("156d1e17109386e7");
/* Built-in method references that are verified to be native. */ var Promise = getNative(root, 'Promise');
module.exports = Promise;

},{"37d079a42d39f8e9":"bCwni","156d1e17109386e7":"J0J3B"}],"eKGpA":[function(require,module,exports,__globalThis) {
var getNative = require("8220f063e164ffe9"), root = require("5fb95e5d217ecc4e");
/* Built-in method references that are verified to be native. */ var Set = getNative(root, 'Set');
module.exports = Set;

},{"8220f063e164ffe9":"bCwni","5fb95e5d217ecc4e":"J0J3B"}],"8oaDs":[function(require,module,exports,__globalThis) {
var getNative = require("3e09fa9fe941b965"), root = require("7d9455061cdbb878");
/* Built-in method references that are verified to be native. */ var WeakMap = getNative(root, 'WeakMap');
module.exports = WeakMap;

},{"3e09fa9fe941b965":"bCwni","7d9455061cdbb878":"J0J3B"}],"dRgMK":[function(require,module,exports,__globalThis) {
var isStrictComparable = require("2f0b4b8c1d06221"), keys = require("69d69b5b4633b5b0");
/**
 * Gets the property names, values, and compare flags of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the match data of `object`.
 */ function getMatchData(object) {
    var result = keys(object), length = result.length;
    while(length--){
        var key = result[length], value = object[key];
        result[length] = [
            key,
            value,
            isStrictComparable(value)
        ];
    }
    return result;
}
module.exports = getMatchData;

},{"2f0b4b8c1d06221":"55652","69d69b5b4633b5b0":"3Wi3D"}],"55652":[function(require,module,exports,__globalThis) {
var isObject = require("85185374726bacf5");
/**
 * Checks if `value` is suitable for strict equality comparisons, i.e. `===`.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` if suitable for strict
 *  equality comparisons, else `false`.
 */ function isStrictComparable(value) {
    return value === value && !isObject(value);
}
module.exports = isStrictComparable;

},{"85185374726bacf5":"cGl8g"}],"1rAPH":[function(require,module,exports,__globalThis) {
/**
 * A specialized version of `matchesProperty` for source values suitable
 * for strict equality comparisons, i.e. `===`.
 *
 * @private
 * @param {string} key The key of the property to get.
 * @param {*} srcValue The value to match.
 * @returns {Function} Returns the new spec function.
 */ function matchesStrictComparable(key, srcValue) {
    return function(object) {
        if (object == null) return false;
        return object[key] === srcValue && (srcValue !== undefined || key in Object(object));
    };
}
module.exports = matchesStrictComparable;

},{}],"iNFBG":[function(require,module,exports,__globalThis) {
var baseIsEqual = require("31c1114a81d4b6bd"), get = require("13008159507fee1e"), hasIn = require("90bfb54c19a3c952"), isKey = require("11b845b8dfd6e58b"), isStrictComparable = require("403d9133f920f6f5"), matchesStrictComparable = require("7a04eb3a2598a9cb"), toKey = require("1fa8169fd3fc2fa5");
/** Used to compose bitmasks for value comparisons. */ var COMPARE_PARTIAL_FLAG = 1, COMPARE_UNORDERED_FLAG = 2;
/**
 * The base implementation of `_.matchesProperty` which doesn't clone `srcValue`.
 *
 * @private
 * @param {string} path The path of the property to get.
 * @param {*} srcValue The value to match.
 * @returns {Function} Returns the new spec function.
 */ function baseMatchesProperty(path, srcValue) {
    if (isKey(path) && isStrictComparable(srcValue)) return matchesStrictComparable(toKey(path), srcValue);
    return function(object) {
        var objValue = get(object, path);
        return objValue === undefined && objValue === srcValue ? hasIn(object, path) : baseIsEqual(srcValue, objValue, COMPARE_PARTIAL_FLAG | COMPARE_UNORDERED_FLAG);
    };
}
module.exports = baseMatchesProperty;

},{"31c1114a81d4b6bd":"ePleT","13008159507fee1e":"fUN5p","90bfb54c19a3c952":"2sG0U","11b845b8dfd6e58b":"8lMJI","403d9133f920f6f5":"55652","7a04eb3a2598a9cb":"1rAPH","1fa8169fd3fc2fa5":"20tbd"}],"fUN5p":[function(require,module,exports,__globalThis) {
var baseGet = require("c75aff21673756ff");
/**
 * Gets the value at `path` of `object`. If the resolved value is
 * `undefined`, the `defaultValue` is returned in its place.
 *
 * @static
 * @memberOf _
 * @since 3.7.0
 * @category Object
 * @param {Object} object The object to query.
 * @param {Array|string} path The path of the property to get.
 * @param {*} [defaultValue] The value returned for `undefined` resolved values.
 * @returns {*} Returns the resolved value.
 * @example
 *
 * var object = { 'a': [{ 'b': { 'c': 3 } }] };
 *
 * _.get(object, 'a[0].b.c');
 * // => 3
 *
 * _.get(object, ['a', '0', 'b', 'c']);
 * // => 3
 *
 * _.get(object, 'a.b.c', 'default');
 * // => 'default'
 */ function get(object, path, defaultValue) {
    var result = object == null ? undefined : baseGet(object, path);
    return result === undefined ? defaultValue : result;
}
module.exports = get;

},{"c75aff21673756ff":"bVje7"}],"bVje7":[function(require,module,exports,__globalThis) {
var castPath = require("b01b447d48033d7f"), toKey = require("619a953251ab2625");
/**
 * The base implementation of `_.get` without support for default values.
 *
 * @private
 * @param {Object} object The object to query.
 * @param {Array|string} path The path of the property to get.
 * @returns {*} Returns the resolved value.
 */ function baseGet(object, path) {
    path = castPath(path, object);
    var index = 0, length = path.length;
    while(object != null && index < length)object = object[toKey(path[index++])];
    return index && index == length ? object : undefined;
}
module.exports = baseGet;

},{"b01b447d48033d7f":"dcAtc","619a953251ab2625":"20tbd"}],"dcAtc":[function(require,module,exports,__globalThis) {
var isArray = require("8eba1034040ab83f"), isKey = require("b36b94566ba2ae39"), stringToPath = require("6ab0a7b5e77b3289"), toString = require("9b301dc4cabf70f1");
/**
 * Casts `value` to a path array if it's not one.
 *
 * @private
 * @param {*} value The value to inspect.
 * @param {Object} [object] The object to query keys on.
 * @returns {Array} Returns the cast property path array.
 */ function castPath(value, object) {
    if (isArray(value)) return value;
    return isKey(value, object) ? [
        value
    ] : stringToPath(toString(value));
}
module.exports = castPath;

},{"8eba1034040ab83f":"7eHCl","b36b94566ba2ae39":"8lMJI","6ab0a7b5e77b3289":"lTmin","9b301dc4cabf70f1":"hWGy5"}],"8lMJI":[function(require,module,exports,__globalThis) {
var isArray = require("cc1412d0e3a3674e"), isSymbol = require("f321ffcbb81c5993");
/** Used to match property names within property paths. */ var reIsDeepProp = /\.|\[(?:[^[\]]*|(["'])(?:(?!\1)[^\\]|\\.)*?\1)\]/, reIsPlainProp = /^\w*$/;
/**
 * Checks if `value` is a property name and not a property path.
 *
 * @private
 * @param {*} value The value to check.
 * @param {Object} [object] The object to query keys on.
 * @returns {boolean} Returns `true` if `value` is a property name, else `false`.
 */ function isKey(value, object) {
    if (isArray(value)) return false;
    var type = typeof value;
    if (type == 'number' || type == 'symbol' || type == 'boolean' || value == null || isSymbol(value)) return true;
    return reIsPlainProp.test(value) || !reIsDeepProp.test(value) || object != null && value in Object(object);
}
module.exports = isKey;

},{"cc1412d0e3a3674e":"7eHCl","f321ffcbb81c5993":"iaMVe"}],"iaMVe":[function(require,module,exports,__globalThis) {
var baseGetTag = require("e344678315216c84"), isObjectLike = require("9171f30f91feab88");
/** `Object#toString` result references. */ var symbolTag = '[object Symbol]';
/**
 * Checks if `value` is classified as a `Symbol` primitive or object.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a symbol, else `false`.
 * @example
 *
 * _.isSymbol(Symbol.iterator);
 * // => true
 *
 * _.isSymbol('abc');
 * // => false
 */ function isSymbol(value) {
    return typeof value == 'symbol' || isObjectLike(value) && baseGetTag(value) == symbolTag;
}
module.exports = isSymbol;

},{"e344678315216c84":"5NOi0","9171f30f91feab88":"eoT9f"}],"lTmin":[function(require,module,exports,__globalThis) {
var memoizeCapped = require("811272dee770c1ca");
/** Used to match property names within property paths. */ var rePropName = /[^.[\]]+|\[(?:(-?\d+(?:\.\d+)?)|(["'])((?:(?!\2)[^\\]|\\.)*?)\2)\]|(?=(?:\.|\[\])(?:\.|\[\]|$))/g;
/** Used to match backslashes in property paths. */ var reEscapeChar = /\\(\\)?/g;
/**
 * Converts `string` to a property path array.
 *
 * @private
 * @param {string} string The string to convert.
 * @returns {Array} Returns the property path array.
 */ var stringToPath = memoizeCapped(function(string) {
    var result = [];
    if (string.charCodeAt(0) === 46 /* . */ ) result.push('');
    string.replace(rePropName, function(match, number, quote, subString) {
        result.push(quote ? subString.replace(reEscapeChar, '$1') : number || match);
    });
    return result;
});
module.exports = stringToPath;

},{"811272dee770c1ca":"dp4mp"}],"dp4mp":[function(require,module,exports,__globalThis) {
var memoize = require("90070e2f8c45f70");
/** Used as the maximum memoize cache size. */ var MAX_MEMOIZE_SIZE = 500;
/**
 * A specialized version of `_.memoize` which clears the memoized function's
 * cache when it exceeds `MAX_MEMOIZE_SIZE`.
 *
 * @private
 * @param {Function} func The function to have its output memoized.
 * @returns {Function} Returns the new memoized function.
 */ function memoizeCapped(func) {
    var result = memoize(func, function(key) {
        if (cache.size === MAX_MEMOIZE_SIZE) cache.clear();
        return key;
    });
    var cache = result.cache;
    return result;
}
module.exports = memoizeCapped;

},{"90070e2f8c45f70":"d0eCX"}],"d0eCX":[function(require,module,exports,__globalThis) {
var MapCache = require("9af14f8ae5b88293");
/** Error message constants. */ var FUNC_ERROR_TEXT = 'Expected a function';
/**
 * Creates a function that memoizes the result of `func`. If `resolver` is
 * provided, it determines the cache key for storing the result based on the
 * arguments provided to the memoized function. By default, the first argument
 * provided to the memoized function is used as the map cache key. The `func`
 * is invoked with the `this` binding of the memoized function.
 *
 * **Note:** The cache is exposed as the `cache` property on the memoized
 * function. Its creation may be customized by replacing the `_.memoize.Cache`
 * constructor with one whose instances implement the
 * [`Map`](http://ecma-international.org/ecma-262/7.0/#sec-properties-of-the-map-prototype-object)
 * method interface of `clear`, `delete`, `get`, `has`, and `set`.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Function
 * @param {Function} func The function to have its output memoized.
 * @param {Function} [resolver] The function to resolve the cache key.
 * @returns {Function} Returns the new memoized function.
 * @example
 *
 * var object = { 'a': 1, 'b': 2 };
 * var other = { 'c': 3, 'd': 4 };
 *
 * var values = _.memoize(_.values);
 * values(object);
 * // => [1, 2]
 *
 * values(other);
 * // => [3, 4]
 *
 * object.a = 2;
 * values(object);
 * // => [1, 2]
 *
 * // Modify the result cache.
 * values.cache.set(object, ['a', 'b']);
 * values(object);
 * // => ['a', 'b']
 *
 * // Replace `_.memoize.Cache`.
 * _.memoize.Cache = WeakMap;
 */ function memoize(func, resolver) {
    if (typeof func != 'function' || resolver != null && typeof resolver != 'function') throw new TypeError(FUNC_ERROR_TEXT);
    var memoized = function() {
        var args = arguments, key = resolver ? resolver.apply(this, args) : args[0], cache = memoized.cache;
        if (cache.has(key)) return cache.get(key);
        var result = func.apply(this, args);
        memoized.cache = cache.set(key, result) || cache;
        return result;
    };
    memoized.cache = new (memoize.Cache || MapCache);
    return memoized;
}
// Expose `MapCache`.
memoize.Cache = MapCache;
module.exports = memoize;

},{"9af14f8ae5b88293":"bRb09"}],"hWGy5":[function(require,module,exports,__globalThis) {
var baseToString = require("8fd4ff256ab5ec10");
/**
 * Converts `value` to a string. An empty string is returned for `null`
 * and `undefined` values. The sign of `-0` is preserved.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to convert.
 * @returns {string} Returns the converted string.
 * @example
 *
 * _.toString(null);
 * // => ''
 *
 * _.toString(-0);
 * // => '-0'
 *
 * _.toString([1, 2, 3]);
 * // => '1,2,3'
 */ function toString(value) {
    return value == null ? '' : baseToString(value);
}
module.exports = toString;

},{"8fd4ff256ab5ec10":"cOyPZ"}],"cOyPZ":[function(require,module,exports,__globalThis) {
var Symbol = require("217861e8d34c6bfb"), arrayMap = require("165706c062fe5448"), isArray = require("5d192271a2353a2c"), isSymbol = require("b19f55f4c66ebc6a");
/** Used as references for various `Number` constants. */ var INFINITY = 1 / 0;
/** Used to convert symbols to primitives and strings. */ var symbolProto = Symbol ? Symbol.prototype : undefined, symbolToString = symbolProto ? symbolProto.toString : undefined;
/**
 * The base implementation of `_.toString` which doesn't convert nullish
 * values to empty strings.
 *
 * @private
 * @param {*} value The value to process.
 * @returns {string} Returns the string.
 */ function baseToString(value) {
    // Exit early for strings to avoid a performance hit in some environments.
    if (typeof value == 'string') return value;
    if (isArray(value)) // Recursively convert values (susceptible to call stack limits).
    return arrayMap(value, baseToString) + '';
    if (isSymbol(value)) return symbolToString ? symbolToString.call(value) : '';
    var result = value + '';
    return result == '0' && 1 / value == -INFINITY ? '-0' : result;
}
module.exports = baseToString;

},{"217861e8d34c6bfb":"c4qDk","165706c062fe5448":"aQnwt","5d192271a2353a2c":"7eHCl","b19f55f4c66ebc6a":"iaMVe"}],"aQnwt":[function(require,module,exports,__globalThis) {
/**
 * A specialized version of `_.map` for arrays without support for iteratee
 * shorthands.
 *
 * @private
 * @param {Array} [array] The array to iterate over.
 * @param {Function} iteratee The function invoked per iteration.
 * @returns {Array} Returns the new mapped array.
 */ function arrayMap(array, iteratee) {
    var index = -1, length = array == null ? 0 : array.length, result = Array(length);
    while(++index < length)result[index] = iteratee(array[index], index, array);
    return result;
}
module.exports = arrayMap;

},{}],"20tbd":[function(require,module,exports,__globalThis) {
var isSymbol = require("9df83a5f9c1faf53");
/** Used as references for various `Number` constants. */ var INFINITY = 1 / 0;
/**
 * Converts `value` to a string key if it's not a string or symbol.
 *
 * @private
 * @param {*} value The value to inspect.
 * @returns {string|symbol} Returns the key.
 */ function toKey(value) {
    if (typeof value == 'string' || isSymbol(value)) return value;
    var result = value + '';
    return result == '0' && 1 / value == -INFINITY ? '-0' : result;
}
module.exports = toKey;

},{"9df83a5f9c1faf53":"iaMVe"}],"2sG0U":[function(require,module,exports,__globalThis) {
var baseHasIn = require("3751838c817c8ecc"), hasPath = require("b36e75f6621933c9");
/**
 * Checks if `path` is a direct or inherited property of `object`.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Object
 * @param {Object} object The object to query.
 * @param {Array|string} path The path to check.
 * @returns {boolean} Returns `true` if `path` exists, else `false`.
 * @example
 *
 * var object = _.create({ 'a': _.create({ 'b': 2 }) });
 *
 * _.hasIn(object, 'a');
 * // => true
 *
 * _.hasIn(object, 'a.b');
 * // => true
 *
 * _.hasIn(object, ['a', 'b']);
 * // => true
 *
 * _.hasIn(object, 'b');
 * // => false
 */ function hasIn(object, path) {
    return object != null && hasPath(object, path, baseHasIn);
}
module.exports = hasIn;

},{"3751838c817c8ecc":"aupIa","b36e75f6621933c9":"8CLgK"}],"aupIa":[function(require,module,exports,__globalThis) {
/**
 * The base implementation of `_.hasIn` without support for deep paths.
 *
 * @private
 * @param {Object} [object] The object to query.
 * @param {Array|string} key The key to check.
 * @returns {boolean} Returns `true` if `key` exists, else `false`.
 */ function baseHasIn(object, key) {
    return object != null && key in Object(object);
}
module.exports = baseHasIn;

},{}],"8CLgK":[function(require,module,exports,__globalThis) {
var castPath = require("9075546b44ab7264"), isArguments = require("cfba684e19fcf20f"), isArray = require("e7f480b6bc204c1c"), isIndex = require("5b1d6ddb10133877"), isLength = require("88dc94b83f912dd8"), toKey = require("fe38f540245db2e3");
/**
 * Checks if `path` exists on `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @param {Array|string} path The path to check.
 * @param {Function} hasFunc The function to check properties.
 * @returns {boolean} Returns `true` if `path` exists, else `false`.
 */ function hasPath(object, path, hasFunc) {
    path = castPath(path, object);
    var index = -1, length = path.length, result = false;
    while(++index < length){
        var key = toKey(path[index]);
        if (!(result = object != null && hasFunc(object, key))) break;
        object = object[key];
    }
    if (result || ++index != length) return result;
    length = object == null ? 0 : object.length;
    return !!length && isLength(length) && isIndex(key, length) && (isArray(object) || isArguments(object));
}
module.exports = hasPath;

},{"9075546b44ab7264":"dcAtc","cfba684e19fcf20f":"8QyUt","e7f480b6bc204c1c":"7eHCl","5b1d6ddb10133877":"7YwKX","88dc94b83f912dd8":"axBps","fe38f540245db2e3":"20tbd"}],"2h1fo":[function(require,module,exports,__globalThis) {
var baseProperty = require("467574dc96bee900"), basePropertyDeep = require("e73b825207087621"), isKey = require("a19328b44a3c02e2"), toKey = require("2c4f0aa4035825a3");
/**
 * Creates a function that returns the value at `path` of a given object.
 *
 * @static
 * @memberOf _
 * @since 2.4.0
 * @category Util
 * @param {Array|string} path The path of the property to get.
 * @returns {Function} Returns the new accessor function.
 * @example
 *
 * var objects = [
 *   { 'a': { 'b': 2 } },
 *   { 'a': { 'b': 1 } }
 * ];
 *
 * _.map(objects, _.property('a.b'));
 * // => [2, 1]
 *
 * _.map(_.sortBy(objects, _.property(['a', 'b'])), 'a.b');
 * // => [1, 2]
 */ function property(path) {
    return isKey(path) ? baseProperty(toKey(path)) : basePropertyDeep(path);
}
module.exports = property;

},{"467574dc96bee900":"ccCQ5","e73b825207087621":"kuQSZ","a19328b44a3c02e2":"8lMJI","2c4f0aa4035825a3":"20tbd"}],"ccCQ5":[function(require,module,exports,__globalThis) {
/**
 * The base implementation of `_.property` without support for deep paths.
 *
 * @private
 * @param {string} key The key of the property to get.
 * @returns {Function} Returns the new accessor function.
 */ function baseProperty(key) {
    return function(object) {
        return object == null ? undefined : object[key];
    };
}
module.exports = baseProperty;

},{}],"kuQSZ":[function(require,module,exports,__globalThis) {
var baseGet = require("11660e0061c4d18c");
/**
 * A specialized version of `baseProperty` which supports deep paths.
 *
 * @private
 * @param {Array|string} path The path of the property to get.
 * @returns {Function} Returns the new accessor function.
 */ function basePropertyDeep(path) {
    return function(object) {
        return baseGet(object, path);
    };
}
module.exports = basePropertyDeep;

},{"11660e0061c4d18c":"bVje7"}],"9MIfu":[function(require,module,exports,__globalThis) {
/** Error message constants. */ var FUNC_ERROR_TEXT = 'Expected a function';
/**
 * Creates a function that negates the result of the predicate `func`. The
 * `func` predicate is invoked with the `this` binding and arguments of the
 * created function.
 *
 * @static
 * @memberOf _
 * @since 3.0.0
 * @category Function
 * @param {Function} predicate The predicate to negate.
 * @returns {Function} Returns the new negated function.
 * @example
 *
 * function isEven(n) {
 *   return n % 2 == 0;
 * }
 *
 * _.filter([1, 2, 3, 4, 5, 6], _.negate(isEven));
 * // => [1, 3, 5]
 */ function negate(predicate) {
    if (typeof predicate != 'function') throw new TypeError(FUNC_ERROR_TEXT);
    return function() {
        var args = arguments;
        switch(args.length){
            case 0:
                return !predicate.call(this);
            case 1:
                return !predicate.call(this, args[0]);
            case 2:
                return !predicate.call(this, args[0], args[1]);
            case 3:
                return !predicate.call(this, args[0], args[1], args[2]);
        }
        return !predicate.apply(this, args);
    };
}
module.exports = negate;

},{}],"9pFAG":[function(require,module,exports,__globalThis) {
var arrayMap = require("4f160044c82692fa"), baseIteratee = require("59e328974bbfa4b5"), basePickBy = require("b17ae649bd2394e7"), getAllKeysIn = require("a1cee24c7229e3f0");
/**
 * Creates an object composed of the `object` properties `predicate` returns
 * truthy for. The predicate is invoked with two arguments: (value, key).
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Object
 * @param {Object} object The source object.
 * @param {Function} [predicate=_.identity] The function invoked per property.
 * @returns {Object} Returns the new object.
 * @example
 *
 * var object = { 'a': 1, 'b': '2', 'c': 3 };
 *
 * _.pickBy(object, _.isNumber);
 * // => { 'a': 1, 'c': 3 }
 */ function pickBy(object, predicate) {
    if (object == null) return {};
    var props = arrayMap(getAllKeysIn(object), function(prop) {
        return [
            prop
        ];
    });
    predicate = baseIteratee(predicate);
    return basePickBy(object, props, function(value, path) {
        return predicate(value, path[0]);
    });
}
module.exports = pickBy;

},{"4f160044c82692fa":"aQnwt","59e328974bbfa4b5":"fEqZi","b17ae649bd2394e7":"5rUpH","a1cee24c7229e3f0":"jxBk1"}],"5rUpH":[function(require,module,exports,__globalThis) {
var baseGet = require("8ddb9190e399b3d1"), baseSet = require("766254714d417be6"), castPath = require("642dccb88dfef153");
/**
 * The base implementation of  `_.pickBy` without support for iteratee shorthands.
 *
 * @private
 * @param {Object} object The source object.
 * @param {string[]} paths The property paths to pick.
 * @param {Function} predicate The function invoked per property.
 * @returns {Object} Returns the new object.
 */ function basePickBy(object, paths, predicate) {
    var index = -1, length = paths.length, result = {};
    while(++index < length){
        var path = paths[index], value = baseGet(object, path);
        if (predicate(value, path)) baseSet(result, castPath(path, object), value);
    }
    return result;
}
module.exports = basePickBy;

},{"8ddb9190e399b3d1":"bVje7","766254714d417be6":"117LL","642dccb88dfef153":"dcAtc"}],"117LL":[function(require,module,exports,__globalThis) {
var assignValue = require("4b8a459255843724"), castPath = require("f34439c003d1a858"), isIndex = require("50cf4a15cc8c9371"), isObject = require("df62e2a3f5ec7efa"), toKey = require("72c6823d333373c7");
/**
 * The base implementation of `_.set`.
 *
 * @private
 * @param {Object} object The object to modify.
 * @param {Array|string} path The path of the property to set.
 * @param {*} value The value to set.
 * @param {Function} [customizer] The function to customize path creation.
 * @returns {Object} Returns `object`.
 */ function baseSet(object, path, value, customizer) {
    if (!isObject(object)) return object;
    path = castPath(path, object);
    var index = -1, length = path.length, lastIndex = length - 1, nested = object;
    while(nested != null && ++index < length){
        var key = toKey(path[index]), newValue = value;
        if (key === '__proto__' || key === 'constructor' || key === 'prototype') return object;
        if (index != lastIndex) {
            var objValue = nested[key];
            newValue = customizer ? customizer(objValue, key, nested) : undefined;
            if (newValue === undefined) newValue = isObject(objValue) ? objValue : isIndex(path[index + 1]) ? [] : {};
        }
        assignValue(nested, key, newValue);
        nested = nested[key];
    }
    return object;
}
module.exports = baseSet;

},{"4b8a459255843724":"gVboZ","f34439c003d1a858":"dcAtc","50cf4a15cc8c9371":"7YwKX","df62e2a3f5ec7efa":"cGl8g","72c6823d333373c7":"20tbd"}],"jxBk1":[function(require,module,exports,__globalThis) {
var baseGetAllKeys = require("e84ba0392dc1ac28"), getSymbolsIn = require("526fe0a0bdb2ac3d"), keysIn = require("a3ba0423da99313e");
/**
 * Creates an array of own and inherited enumerable property names and
 * symbols of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names and symbols.
 */ function getAllKeysIn(object) {
    return baseGetAllKeys(object, keysIn, getSymbolsIn);
}
module.exports = getAllKeysIn;

},{"e84ba0392dc1ac28":"eq3SY","526fe0a0bdb2ac3d":"4960N","a3ba0423da99313e":"jke6l"}],"4960N":[function(require,module,exports,__globalThis) {
var arrayPush = require("b25c40f3fc04e2c7"), getPrototype = require("5fcf810767c1018c"), getSymbols = require("34eae63be1b73046"), stubArray = require("6fb99c2801723b47");
/* Built-in method references for those with the same name as other `lodash` methods. */ var nativeGetSymbols = Object.getOwnPropertySymbols;
/**
 * Creates an array of the own and inherited enumerable symbols of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of symbols.
 */ var getSymbolsIn = !nativeGetSymbols ? stubArray : function(object) {
    var result = [];
    while(object){
        arrayPush(result, getSymbols(object));
        object = getPrototype(object);
    }
    return result;
};
module.exports = getSymbolsIn;

},{"b25c40f3fc04e2c7":"bkzAk","5fcf810767c1018c":"yFmWQ","34eae63be1b73046":"a1iC0","6fb99c2801723b47":"fHpuG"}],"3TqXX":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "FireUIAnalytics", ()=>FireUIAnalytics);
parcelHelpers.export(exports, "FireTrackAnalytics", ()=>FireTrackAnalytics);
parcelHelpers.export(exports, "FireOperationalAnalytics", ()=>FireOperationalAnalytics);
parcelHelpers.export(exports, "FireScreenAnalytics", ()=>FireScreenAnalytics);
var _objectSpread = require("@swc/helpers/_/_object_spread");
var _objectSpreadProps = require("@swc/helpers/_/_object_spread_props");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _analyticsNext = require("@atlaskit/analytics-next");
var _constants = require("../../constants");
var _fireAnalytics = require("../../utils/fire-analytics");
const getFixedActionAndActionSubject = (props)=>{
    const { eventName, action, actionSubject } = props;
    if (eventName && (action || actionSubject)) throw new Error('eventName is an alias for action & actionSubject, provide only one of those');
    const eventNameSplit = eventName ? eventName.split(' ') : [];
    const fixedAction = action || eventNameSplit[1];
    const fixedActionSubject = actionSubject || eventNameSplit[0];
    if (!fixedAction || !fixedActionSubject) throw new Error('eventName should exist and be in the format "subject action", i.e. "button clicked", "menu opened", "issue created", etc');
    return {
        action: fixedAction,
        actionSubject: fixedActionSubject
    };
};
const getFixedActionSubjectId = (props)=>{
    const { componentName, actionSubjectId } = props;
    if (componentName && actionSubjectId) throw new Error('componentName is an alias for actionSubjectId, provide only one of those');
    const fixedActionSubjectId = actionSubjectId || componentName;
    return {
        actionSubjectId: fixedActionSubjectId
    };
};
class FireComponent extends (0, _react.Component) {
    componentDidMount() {
        const { type, attributes } = this.props;
        if (!this.props.createAnalyticsEvent) throw new Error('Invalid use of component; must be wrapped by withAnalyticsEvents HOC');
        const { action, actionSubject } = getFixedActionAndActionSubject(this.props);
        const { actionSubjectId } = getFixedActionSubjectId(this.props);
        const analyticsEvent = this.props.createAnalyticsEvent({
            action
        });
        (0, _fireAnalytics.fireAnalytics)(analyticsEvent, type, {
            action,
            actionSubject,
            actionSubjectId,
            attributes
        });
    }
    render() {
        return null;
    }
}
const WithAnalytics = (0, _analyticsNext.withAnalyticsEvents)()(FireComponent);
const FireUIAnalytics = (props)=>/*#__PURE__*/ (0, _reactDefault.default).createElement(WithAnalytics, (0, _objectSpreadProps._)((0, _objectSpread._)({}, props), {
        type: (0, _constants.UI_EVENT_TYPE)
    }));
const FireTrackAnalytics = (props)=>/*#__PURE__*/ (0, _reactDefault.default).createElement(WithAnalytics, (0, _objectSpreadProps._)((0, _objectSpread._)({}, props), {
        type: (0, _constants.TRACK_EVENT_TYPE)
    }));
const FireOperationalAnalytics = (props)=>/*#__PURE__*/ (0, _reactDefault.default).createElement(WithAnalytics, (0, _objectSpreadProps._)((0, _objectSpread._)({}, props), {
        type: (0, _constants.OPERATIONAL_EVENT_TYPE)
    }));
const FireScreenAnalytics = (props)=>/*#__PURE__*/ (0, _reactDefault.default).createElement(WithAnalytics, (0, _objectSpreadProps._)((0, _objectSpread._)({}, props), {
        type: (0, _constants.SCREEN_EVENT_TYPE),
        eventName: "screen viewed"
    }));

},{"@swc/helpers/_/_object_spread":"9gdrV","@swc/helpers/_/_object_spread_props":"kANqQ","react":"ltHCL","@atlaskit/analytics-next":"6PLie","../../constants":"6DjR0","../../utils/fire-analytics":"em7XG","@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"em7XG":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "fireAnalytics", ()=>fireAnalytics);
parcelHelpers.export(exports, "fireUIAnalytics", ()=>fireUIAnalytics);
parcelHelpers.export(exports, "fireTrackAnalytics", ()=>fireTrackAnalytics);
parcelHelpers.export(exports, "fireOperationalAnalytics", ()=>fireOperationalAnalytics);
parcelHelpers.export(exports, "fireScreenAnalytics", ()=>fireScreenAnalytics);
var _objectSpread = require("@swc/helpers/_/_object_spread");
var _objectSpreadProps = require("@swc/helpers/_/_object_spread_props");
var _last = require("lodash/last");
var _lastDefault = parcelHelpers.interopDefault(_last);
var _constants = require("../../constants");
var _utils = require("./utils");
const fireAnalytics = (event, type, payload)=>{
    // TODO: the distinction between AnalyticsEvent and UIAnalyticsEvent is all odd in AK and needs to be understood better
    const castedEvent = event;
    const clonedEvent = castedEvent.clone();
    if (!clonedEvent) throw new Error("Cannot clone an event after it's been fired.");
    clonedEvent.update((0, _objectSpreadProps._)((0, _objectSpread._)({}, payload), {
        analyticsType: type
    })).fire((0, _constants.ANALYTICS_BRIDGE_CHANNEL));
};
const getActionSubjectFromContext = (event)=>{
    // TODO: the distinction between AnalyticsEvent and UIAnalyticsEvent is all odd in AK and needs to be understood better
    const castedEvent = event;
    return (0, _lastDefault.default)(castedEvent.context.map((i)=>i.component || i.componentName).filter(Boolean));
};
const fireUIAnalytics = (event, ...rest)=>{
    if (!event.clone) throw new Error('There is no analytics event from Atlaskit in UI event');
    const { action: argumentsAction, actionSubject: argumentsActionSubject, actionSubjectId, attributes } = (0, _utils.getImperativeAnalyticsDataFromArguments)(rest);
    const castedEvent = event;
    const action = event.payload && event.payload.action || argumentsAction;
    const actionSubject = event.payload && event.payload.actionSubject || argumentsActionSubject || getActionSubjectFromContext(castedEvent);
    if (!action) throw new Error('Mandatory "action" field is missing from UI event');
    if (!actionSubject) throw new Error('Mandatory "actionSubject" field is missing from UI event');
    fireAnalytics(event, (0, _constants.UI_EVENT_TYPE), {
        action,
        actionSubject,
        actionSubjectId,
        attributes
    });
};
const fireTrackAnalytics = (event, ...rest)=>{
    if (!event.clone) throw new Error('There is no analytics event from Atlaskit in Track event');
    const { action, actionSubject, actionSubjectId, attributes } = (0, _utils.getImperativeAnalyticsDataFromArguments)(rest);
    if (!action) throw new Error('Mandatory "action" field is missing from Track event');
    if (!actionSubject) throw new Error('Mandatory "actionSubject" field is missing from Track event');
    fireAnalytics(event, (0, _constants.TRACK_EVENT_TYPE), {
        action,
        actionSubject,
        actionSubjectId,
        attributes
    });
};
const fireOperationalAnalytics = (event, ...rest)=>{
    if (!event.clone) throw new Error('There is no analytics event from Atlaskit in Operational event');
    const { action, actionSubject, actionSubjectId, attributes } = (0, _utils.getImperativeAnalyticsDataFromArguments)(rest);
    if (!action) throw new Error('Mandatory "action" field is missing from Operational event');
    if (!actionSubject) throw new Error('Mandatory "actionSubject" field is missing from Operational event');
    fireAnalytics(event, (0, _constants.OPERATIONAL_EVENT_TYPE), {
        action,
        actionSubject,
        actionSubjectId,
        attributes
    });
};
const fireScreenAnalytics = (event, ...rest)=>{
    if (!event.clone) throw new Error('There is no analytics event from Atlaskit in Screen event');
    const { attributes } = (0, _utils.getImperativeAnalyticsDataFromArguments)(rest);
    fireAnalytics(event, (0, _constants.SCREEN_EVENT_TYPE), {
        attributes
    });
};

},{"@swc/helpers/_/_object_spread":"9gdrV","@swc/helpers/_/_object_spread_props":"kANqQ","lodash/last":"9zzEk","../../constants":"6DjR0","./utils":"cUru9","@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"cUru9":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "getImperativeAnalyticsDataFromArguments", ()=>getImperativeAnalyticsDataFromArguments);
const extractDataFromStringAttribute = (string)=>{
    const arr = string.split(' ');
    switch(arr.length){
        case 1:
            return {
                actionSubject: undefined,
                action: undefined,
                actionSubjectId: arr[0],
                attributes: undefined
            };
        case 2:
            return {
                actionSubject: arr[0],
                action: arr[1],
                actionSubjectId: undefined,
                attributes: undefined
            };
        default:
            throw Error('Event of this type is not supported');
    }
};
const extractDataFromOneAttribute = (one)=>{
    if (typeof one === 'string') return extractDataFromStringAttribute(one);
    if (typeof one === 'object') return {
        actionSubject: undefined,
        action: undefined,
        actionSubjectId: undefined,
        attributes: one
    };
    throw Error('Event of this type is not supported');
};
const extractDataFromTwoAttribute = (one, two)=>{
    if (typeof one === 'string' && typeof two === 'string') {
        const { action, actionSubject } = extractDataFromStringAttribute(one);
        const actionSubjectId = two;
        return {
            actionSubject,
            action,
            actionSubjectId,
            attributes: undefined
        };
    }
    if (typeof one === 'string' && typeof two === 'object') {
        const { action, actionSubject, actionSubjectId } = extractDataFromStringAttribute(one);
        return {
            actionSubject,
            action,
            actionSubjectId,
            attributes: two
        };
    }
    throw Error('Event of this type is not supported');
};
const extractDataFromThreeAttribute = (one, two, three)=>{
    if (typeof one === 'string' && typeof two === 'string' && typeof three === 'object') {
        const { action, actionSubject } = extractDataFromStringAttribute(one);
        const actionSubjectId = two;
        return {
            actionSubject,
            action,
            actionSubjectId,
            attributes: three
        };
    }
    throw Error('Event of this type is not supported');
};
const getImperativeAnalyticsDataFromArguments = (args)=>{
    switch(args.length){
        case 0:
            return {
                actionSubject: undefined,
                action: undefined,
                actionSubjectId: undefined,
                attributes: undefined
            };
        case 1:
            return extractDataFromOneAttribute(args[0]);
        case 2:
            return extractDataFromTwoAttribute(args[0], args[1]);
        case 3:
            return extractDataFromThreeAttribute(args[0], args[1], args[2]);
        default:
            throw Error('Can not fire an empty event');
    }
};

},{"@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"afXui":[function(require,module,exports,__globalThis) {
// oxlint-disable-next-line @atlassian/no-restricted-imports
var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "extractAWCDataFromEvent", ()=>extractAWCDataFromEvent);
var _isUndefined = require("lodash/isUndefined");
var _isUndefinedDefault = parcelHelpers.interopDefault(_isUndefined);
var _omitBy = require("lodash/omitBy");
var _omitByDefault = parcelHelpers.interopDefault(_omitBy);
var _constants = require("../../constants");
var _utils = require("./utils");
const extractAWCDataFromEvent = (event)=>{
    // TODO: the distinction between AnalyticsEvent and UIAnalyticsEvent is all odd in AK and needs to be understood better
    const castedEvent = event;
    const analyticsType = (0, _utils.getAnalyticsType)(castedEvent);
    const attributes = (0, _utils.getAttributes)(castedEvent);
    const source = (0, _utils.getSource)(castedEvent);
    const actionSubject = (0, _utils.getActionSubject)(castedEvent);
    if (analyticsType === (0, _constants.SCREEN_EVENT_TYPE)) return {
        type: (0, _constants.SCREEN_EVENT_TYPE),
        payload: {
            name: source,
            attributes
        }
    };
    switch(analyticsType){
        case 0, _constants.UI_EVENT_TYPE:
        case 0, _constants.TRACK_EVENT_TYPE:
        case 0, _constants.OPERATIONAL_EVENT_TYPE:
            {
                const action = (0, _utils.getAction)(castedEvent);
                const actionSubjectId = (0, _utils.getActionSubjectId)(castedEvent);
                const containerId = (0, _utils.getContainerId)(castedEvent);
                const containerType = (0, _utils.getContainerType)(castedEvent);
                const objectId = (0, _utils.getObjectId)(castedEvent);
                const objectType = (0, _utils.getObjectType)(castedEvent);
                const tags = (0, _utils.getTags)(castedEvent);
                return {
                    type: analyticsType,
                    payload: (0, _omitByDefault.default)({
                        action,
                        actionSubject,
                        actionSubjectId,
                        source,
                        tags,
                        containerType,
                        containerId,
                        objectType,
                        objectId,
                        attributes
                    }, (0, _isUndefinedDefault.default))
                };
            }
        default:
            return {
                payload: {
                    source,
                    actionSubject,
                    attributes
                },
                type: undefined
            };
    }
};

},{"lodash/isUndefined":"aoQJa","lodash/omitBy":"80W3G","../../constants":"6DjR0","./utils":"i221T","@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"i221T":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "getAnalyticsType", ()=>getAnalyticsType);
parcelHelpers.export(exports, "getAttributes", ()=>getAttributes);
parcelHelpers.export(exports, "getSource", ()=>getSource);
parcelHelpers.export(exports, "getActionSubject", ()=>getActionSubject);
parcelHelpers.export(exports, "getAction", ()=>getAction);
parcelHelpers.export(exports, "getActionSubjectId", ()=>getActionSubjectId);
parcelHelpers.export(exports, "getContainerId", ()=>getContainerId);
parcelHelpers.export(exports, "getContainerType", ()=>getContainerType);
parcelHelpers.export(exports, "getObjectId", ()=>getObjectId);
parcelHelpers.export(exports, "getObjectType", ()=>getObjectType);
parcelHelpers.export(exports, "getTags", ()=>getTags);
var _objectSpread = require("@swc/helpers/_/_object_spread");
var _objectSpreadProps = require("@swc/helpers/_/_object_spread_props");
var _flatten = require("lodash/flatten");
var _flattenDefault = parcelHelpers.interopDefault(_flatten);
var _isUndefined = require("lodash/isUndefined");
var _isUndefinedDefault = parcelHelpers.interopDefault(_isUndefined);
var _last = require("lodash/last");
var _lastDefault = parcelHelpers.interopDefault(_last);
var _merge = require("lodash/merge");
var _mergeDefault = parcelHelpers.interopDefault(_merge);
var _omitBy = require("lodash/omitBy");
var _omitByDefault = parcelHelpers.interopDefault(_omitBy);
var _uniq = require("lodash/uniq");
var _uniqDefault = parcelHelpers.interopDefault(_uniq);
const extractFromContext = (event, property)=>event.context.map((item)=>item[property]);
const getAnalyticsType = (event)=>event.payload.analyticsType;
const getAttributes = (event)=>{
    const contextAttributes = extractFromContext(event, 'attributes');
    const payloadAttributes = event.payload.attributes;
    const allAttributes = (0, _mergeDefault.default)(contextAttributes.reduce((result, extraAttributes)=>(0, _mergeDefault.default)(result, extraAttributes), {}), payloadAttributes);
    const sources = extractFromContext(event, 'source');
    const namespaces = sources.filter(Boolean).join('.');
    return (0, _omitByDefault.default)((0, _objectSpreadProps._)((0, _objectSpread._)({}, allAttributes), {
        namespaces
    }), (0, _isUndefinedDefault.default));
};
const getSource = (event)=>(0, _lastDefault.default)(extractFromContext(event, 'source').filter(Boolean));
const getActionSubject = (event)=>{
    const { actionSubject } = event.payload;
    if (actionSubject) return actionSubject;
    const component = (0, _lastDefault.default)(extractFromContext(event, 'component').filter(Boolean)) || (0, _lastDefault.default)(extractFromContext(event, 'componentName').filter(Boolean));
    return component;
};
const getAction = (event)=>event.payload.action;
const getActionSubjectId = (event)=>event.payload.actionSubjectId;
const getContainerId = (event)=>(0, _lastDefault.default)(extractFromContext(event, 'containerId').filter(Boolean));
const getContainerType = (event)=>(0, _lastDefault.default)(extractFromContext(event, 'containerType').filter(Boolean));
const getObjectId = (event)=>(0, _lastDefault.default)(extractFromContext(event, 'objectId').filter(Boolean));
const getObjectType = (event)=>(0, _lastDefault.default)(extractFromContext(event, 'objectType').filter(Boolean));
const getTags = (event)=>{
    const tags = (0, _uniqDefault.default)((0, _flattenDefault.default)(extractFromContext(event, 'tags'))).filter(Boolean);
    return tags.length ? tags : undefined;
};

},{"@swc/helpers/_/_object_spread":"9gdrV","@swc/helpers/_/_object_spread_props":"kANqQ","lodash/flatten":"Bqsuj","lodash/isUndefined":"aoQJa","lodash/last":"9zzEk","lodash/merge":"yJjRX","lodash/omitBy":"80W3G","lodash/uniq":"7Fx7t","@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"Bqsuj":[function(require,module,exports,__globalThis) {
var baseFlatten = require("bf965496f3abb351");
/**
 * Flattens `array` a single level deep.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Array
 * @param {Array} array The array to flatten.
 * @returns {Array} Returns the new flattened array.
 * @example
 *
 * _.flatten([1, [2, [3, [4]], 5]]);
 * // => [1, 2, [3, [4]], 5]
 */ function flatten(array) {
    var length = array == null ? 0 : array.length;
    return length ? baseFlatten(array, 1) : [];
}
module.exports = flatten;

},{"bf965496f3abb351":"47g7t"}],"47g7t":[function(require,module,exports,__globalThis) {
var arrayPush = require("db74588eff04330b"), isFlattenable = require("59ae7d006f73eab6");
/**
 * The base implementation of `_.flatten` with support for restricting flattening.
 *
 * @private
 * @param {Array} array The array to flatten.
 * @param {number} depth The maximum recursion depth.
 * @param {boolean} [predicate=isFlattenable] The function invoked per iteration.
 * @param {boolean} [isStrict] Restrict to values that pass `predicate` checks.
 * @param {Array} [result=[]] The initial result value.
 * @returns {Array} Returns the new flattened array.
 */ function baseFlatten(array, depth, predicate, isStrict, result) {
    var index = -1, length = array.length;
    predicate || (predicate = isFlattenable);
    result || (result = []);
    while(++index < length){
        var value = array[index];
        if (depth > 0 && predicate(value)) {
            if (depth > 1) // Recursively flatten arrays (susceptible to call stack limits).
            baseFlatten(value, depth - 1, predicate, isStrict, result);
            else arrayPush(result, value);
        } else if (!isStrict) result[result.length] = value;
    }
    return result;
}
module.exports = baseFlatten;

},{"db74588eff04330b":"bkzAk","59ae7d006f73eab6":"aAl7S"}],"aAl7S":[function(require,module,exports,__globalThis) {
var Symbol = require("8f0251017e65b7d7"), isArguments = require("118285ca35912452"), isArray = require("882569f7368932c6");
/** Built-in value references. */ var spreadableSymbol = Symbol ? Symbol.isConcatSpreadable : undefined;
/**
 * Checks if `value` is a flattenable `arguments` object or array.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is flattenable, else `false`.
 */ function isFlattenable(value) {
    return isArray(value) || isArguments(value) || !!(spreadableSymbol && value && value[spreadableSymbol]);
}
module.exports = isFlattenable;

},{"8f0251017e65b7d7":"c4qDk","118285ca35912452":"8QyUt","882569f7368932c6":"7eHCl"}],"7Fx7t":[function(require,module,exports,__globalThis) {
var baseUniq = require("14198cd22c9c74eb");
/**
 * Creates a duplicate-free version of an array, using
 * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
 * for equality comparisons, in which only the first occurrence of each element
 * is kept. The order of result values is determined by the order they occur
 * in the array.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Array
 * @param {Array} array The array to inspect.
 * @returns {Array} Returns the new duplicate free array.
 * @example
 *
 * _.uniq([2, 1, 2]);
 * // => [2, 1]
 */ function uniq(array) {
    return array && array.length ? baseUniq(array) : [];
}
module.exports = uniq;

},{"14198cd22c9c74eb":"fKJxW"}],"fKJxW":[function(require,module,exports,__globalThis) {
var SetCache = require("9ecb1b8596f264e"), arrayIncludes = require("b8456b35c2adb6a"), arrayIncludesWith = require("ce5fcb3b3417eb35"), cacheHas = require("ddbb6682682eb4cb"), createSet = require("1835d3c2e1d5edb3"), setToArray = require("824185daeb556a06");
/** Used as the size to enable large array optimizations. */ var LARGE_ARRAY_SIZE = 200;
/**
 * The base implementation of `_.uniqBy` without support for iteratee shorthands.
 *
 * @private
 * @param {Array} array The array to inspect.
 * @param {Function} [iteratee] The iteratee invoked per element.
 * @param {Function} [comparator] The comparator invoked per element.
 * @returns {Array} Returns the new duplicate free array.
 */ function baseUniq(array, iteratee, comparator) {
    var index = -1, includes = arrayIncludes, length = array.length, isCommon = true, result = [], seen = result;
    if (comparator) {
        isCommon = false;
        includes = arrayIncludesWith;
    } else if (length >= LARGE_ARRAY_SIZE) {
        var set = iteratee ? null : createSet(array);
        if (set) return setToArray(set);
        isCommon = false;
        includes = cacheHas;
        seen = new SetCache;
    } else seen = iteratee ? [] : result;
    outer: while(++index < length){
        var value = array[index], computed = iteratee ? iteratee(value) : value;
        value = comparator || value !== 0 ? value : 0;
        if (isCommon && computed === computed) {
            var seenIndex = seen.length;
            while(seenIndex--){
                if (seen[seenIndex] === computed) continue outer;
            }
            if (iteratee) seen.push(computed);
            result.push(value);
        } else if (!includes(seen, computed, comparator)) {
            if (seen !== result) seen.push(computed);
            result.push(value);
        }
    }
    return result;
}
module.exports = baseUniq;

},{"9ecb1b8596f264e":"6pKaT","b8456b35c2adb6a":"5URpm","ce5fcb3b3417eb35":"1GKvY","ddbb6682682eb4cb":"2exP4","1835d3c2e1d5edb3":"94FLX","824185daeb556a06":"2vW8W"}],"5URpm":[function(require,module,exports,__globalThis) {
var baseIndexOf = require("6e2eefc3e1cecfc2");
/**
 * A specialized version of `_.includes` for arrays without support for
 * specifying an index to search from.
 *
 * @private
 * @param {Array} [array] The array to inspect.
 * @param {*} target The value to search for.
 * @returns {boolean} Returns `true` if `target` is found, else `false`.
 */ function arrayIncludes(array, value) {
    var length = array == null ? 0 : array.length;
    return !!length && baseIndexOf(array, value, 0) > -1;
}
module.exports = arrayIncludes;

},{"6e2eefc3e1cecfc2":"357Ly"}],"357Ly":[function(require,module,exports,__globalThis) {
var baseFindIndex = require("4c756050d48e8630"), baseIsNaN = require("94562235088dfa19"), strictIndexOf = require("6f6a6cb80ad4fd2c");
/**
 * The base implementation of `_.indexOf` without `fromIndex` bounds checks.
 *
 * @private
 * @param {Array} array The array to inspect.
 * @param {*} value The value to search for.
 * @param {number} fromIndex The index to search from.
 * @returns {number} Returns the index of the matched value, else `-1`.
 */ function baseIndexOf(array, value, fromIndex) {
    return value === value ? strictIndexOf(array, value, fromIndex) : baseFindIndex(array, baseIsNaN, fromIndex);
}
module.exports = baseIndexOf;

},{"4c756050d48e8630":"c27ul","94562235088dfa19":"eixUr","6f6a6cb80ad4fd2c":"jVapG"}],"c27ul":[function(require,module,exports,__globalThis) {
/**
 * The base implementation of `_.findIndex` and `_.findLastIndex` without
 * support for iteratee shorthands.
 *
 * @private
 * @param {Array} array The array to inspect.
 * @param {Function} predicate The function invoked per iteration.
 * @param {number} fromIndex The index to search from.
 * @param {boolean} [fromRight] Specify iterating from right to left.
 * @returns {number} Returns the index of the matched value, else `-1`.
 */ function baseFindIndex(array, predicate, fromIndex, fromRight) {
    var length = array.length, index = fromIndex + (fromRight ? 1 : -1);
    while(fromRight ? index-- : ++index < length){
        if (predicate(array[index], index, array)) return index;
    }
    return -1;
}
module.exports = baseFindIndex;

},{}],"eixUr":[function(require,module,exports,__globalThis) {
/**
 * The base implementation of `_.isNaN` without support for number objects.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is `NaN`, else `false`.
 */ function baseIsNaN(value) {
    return value !== value;
}
module.exports = baseIsNaN;

},{}],"jVapG":[function(require,module,exports,__globalThis) {
/**
 * A specialized version of `_.indexOf` which performs strict equality
 * comparisons of values, i.e. `===`.
 *
 * @private
 * @param {Array} array The array to inspect.
 * @param {*} value The value to search for.
 * @param {number} fromIndex The index to search from.
 * @returns {number} Returns the index of the matched value, else `-1`.
 */ function strictIndexOf(array, value, fromIndex) {
    var index = fromIndex - 1, length = array.length;
    while(++index < length){
        if (array[index] === value) return index;
    }
    return -1;
}
module.exports = strictIndexOf;

},{}],"1GKvY":[function(require,module,exports,__globalThis) {
/**
 * This function is like `arrayIncludes` except that it accepts a comparator.
 *
 * @private
 * @param {Array} [array] The array to inspect.
 * @param {*} target The value to search for.
 * @param {Function} comparator The comparator invoked per element.
 * @returns {boolean} Returns `true` if `target` is found, else `false`.
 */ function arrayIncludesWith(array, value, comparator) {
    var index = -1, length = array == null ? 0 : array.length;
    while(++index < length){
        if (comparator(value, array[index])) return true;
    }
    return false;
}
module.exports = arrayIncludesWith;

},{}],"94FLX":[function(require,module,exports,__globalThis) {
var Set = require("2215594977a25f41"), noop = require("5e514fc92a2f90b6"), setToArray = require("38aec926dc10c01d");
/** Used as references for various `Number` constants. */ var INFINITY = 1 / 0;
/**
 * Creates a set object of `values`.
 *
 * @private
 * @param {Array} values The values to add to the set.
 * @returns {Object} Returns the new set.
 */ var createSet = !(Set && 1 / setToArray(new Set([
    ,
    -0
]))[1] == INFINITY) ? noop : function(values) {
    return new Set(values);
};
module.exports = createSet;

},{"2215594977a25f41":"eKGpA","5e514fc92a2f90b6":"rRLAN","38aec926dc10c01d":"2vW8W"}],"rRLAN":[function(require,module,exports,__globalThis) {
/**
 * This method returns `undefined`.
 *
 * @static
 * @memberOf _
 * @since 2.3.0
 * @category Util
 * @example
 *
 * _.times(2, _.noop);
 * // => [undefined, undefined]
 */ function noop() {
// No operation performed.
}
module.exports = noop;

},{}],"4E7E5":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "captureException", ()=>(0, _sentry.captureException));
parcelHelpers.export(exports, "installGlobalHandler", ()=>(0, _sentry.installGlobalHandler));
parcelHelpers.export(exports, "fireErrorAnalytics", ()=>(0, _fireErrorAnalyticsDefault.default));
parcelHelpers.export(exports, "trackFetchErrors", ()=>(0, _fireErrorAnalytics.trackFetchErrors));
parcelHelpers.export(exports, "initialiseErrorAnalyticsClient", ()=>(0, _fireErrorAnalytics.initialiseErrorAnalyticsClient));
parcelHelpers.export(exports, "ReportErrors", ()=>(0, _reportingErrorBoundaryDefault.default));
var _sentry = require("./utils/sentry");
var _fireErrorAnalytics = require("./utils/fire-error-analytics");
var _fireErrorAnalyticsDefault = parcelHelpers.interopDefault(_fireErrorAnalytics);
var _reportingErrorBoundary = require("./utils/reporting-error-boundary");
var _reportingErrorBoundaryDefault = parcelHelpers.interopDefault(_reportingErrorBoundary);

},{"./utils/sentry":"3AQCm","./utils/fire-error-analytics":"hez9K","./utils/reporting-error-boundary":"dUbhS","@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"3AQCm":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "installGlobalHandler", ()=>installGlobalHandler);
parcelHelpers.export(exports, "captureException", ()=>captureException);
var _sentryBrowser = require("./sentry-browser");
var _sentryBrowserDefault = parcelHelpers.interopDefault(_sentryBrowser);
const installGlobalHandler = (sentryUrl, config, getExtraContext)=>(0, _sentryBrowserDefault.default).installGlobalHandler(sentryUrl, config, getExtraContext);
const captureException = (location, error, details = {})=>(0, _sentryBrowserDefault.default).captureException(location, error, details);

},{"./sentry-browser":"1uDYC","@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"1uDYC":[function(require,module,exports,__globalThis) {
// This is the only file that should directly import Raven.
var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _objectSpread = require("@swc/helpers/_/_object_spread");
var _objectSpreadProps = require("@swc/helpers/_/_object_spread_props");
var _browser = require("@sentry/browser");
var _integrations = require("@sentry/integrations");
var _uniq = require("lodash/uniq");
var _uniqDefault = parcelHelpers.interopDefault(_uniq);
const getFragmentNames = (stackTrace)=>{
    const re = /(?:src\/entry|src|assets)\/([^,./]+)/g;
    const fragmentNames = [];
    let fragmentName = re.exec(stackTrace);
    while(fragmentName){
        fragmentNames.push(fragmentName[1]);
        fragmentName = re.exec(stackTrace);
    }
    const distinctfragmentNames = (0, _uniqDefault.default)(fragmentNames);
    return distinctfragmentNames;
};
// Add custom tags based on stack trace
const getTaggedData = (data, hint)=>{
    if (!hint) return data;
    const exception = hint.originalException || hint.syntheticException;
    if (!exception) return data;
    const stackTrace = exception.stack;
    if (!stackTrace) return data;
    const taggedData = data;
    const fragmentNames = getFragmentNames(stackTrace);
    if (!fragmentNames.length) taggedData.tags = (0, _objectSpreadProps._)((0, _objectSpread._)({}, taggedData.tags), {
        fragment: 'unknown'
    });
    else {
        taggedData.tags = (0, _objectSpreadProps._)((0, _objectSpread._)({}, taggedData.tags), {
            fragment: fragmentNames[0]
        });
        if (fragmentNames.length > 1) taggedData.extra = (0, _objectSpreadProps._)((0, _objectSpread._)({}, taggedData.extra), {
            allRelevantFragments: fragmentNames
        });
    }
    return taggedData;
};
// https://docs.sentry.io/platforms/javascript/#removing-an-integration
const getFilteredIntegrations = (integrations)=>integrations.filter(({ name })=>name !== 'Breadcrumbs');
const installGlobalHandler = (sentryUrl, config, getExtraContext)=>{
    // Check for sentry already enabled to be defensive in case two fragments are loaded in the same page, we
    // don't want duplicated error reports
    const sentryClient = _browser.getCurrentHub().getClient();
    if (sentryClient && sentryClient.getOptions().enabled) return;
    const defaultConfig = {
        dsn: sentryUrl,
        environment: "production",
        // This adds our tags to the data sent to sentry
        beforeSend: (event, hint)=>{
            // Yes, we're mutating the argument, but at this point in the error handling lifecycle
            // immutability is not important and it simplifies the logic
            // Event type is documented here: https://github.com/getsentry/sentry-javascript/blob/master/packages/types/src/event.ts
            const extraBeforeSend = config.beforeSend || (()=>null);
            let updatedData = extraBeforeSend(event, hint);
            updatedData = getTaggedData(updatedData, hint);
            return updatedData;
        },
        //Integration typing doesn't seem to work well so I'm just typing it to any
        integrations: (integrations)=>[
                ...getFilteredIntegrations(integrations),
                new _integrations.Dedupe(),
                new _integrations.ExtraErrorData(),
                new _integrations.Transaction(),
                new _integrations.CaptureConsole({
                    levels: [
                        'error'
                    ]
                }),
                // not supporting the case where config.integrations is a function that returns an array
                ...config.integrations && config.integrations instanceof Array ? config.integrations : []
            ]
    };
    // Because we don't want to completely override the platform defaults remove them from the config object.
    // They've been integrated into the defaultConfig above.
    config.beforeSend = undefined;
    config.integrations = undefined;
    _browser.init((0, _objectSpread._)({}, defaultConfig, config));
    try {
        _browser.setExtras(getExtraContext());
    } catch (e) {
        _browser.captureException(e);
    }
};
// structured tags that we send to Sentry
// everything else from details object will go into "extras"
const tags = [
    'packageName',
    'teamName'
];
const captureException = (location, error, details)=>{
    _browser.configureScope((scope)=>{
        scope.setTag('logger', location);
        if (details) Object.keys(details).forEach((key)=>{
            if (tags.includes(key)) scope.setTag(key, details[key]);
            else scope.setExtra(key, details[key]);
        });
    });
    _browser.captureException(error);
};
const sentryErrorHandler = {
    installGlobalHandler,
    captureException
};
exports.default = sentryErrorHandler;

},{"@swc/helpers/_/_object_spread":"9gdrV","@swc/helpers/_/_object_spread_props":"kANqQ","@sentry/browser":"iOLMF","@sentry/integrations":"f1O2Y","lodash/uniq":"7Fx7t","@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"iOLMF":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "Integrations", ()=>INTEGRATIONS);
parcelHelpers.export(exports, "Transports", ()=>_transports);
var _tslib = require("tslib");
var _exports = require("./exports");
parcelHelpers.exportAll(_exports, exports);
var _core = require("@sentry/core");
var _utils = require("@sentry/utils");
var _integrations = require("./integrations");
var _transports = require("./transports");
var windowIntegrations = {};
// This block is needed to add compatibility with the integrations packages when used with a CDN
var _window = (0, _utils.getGlobalObject)();
if (_window.Sentry && _window.Sentry.Integrations) windowIntegrations = _window.Sentry.Integrations;
var INTEGRATIONS = (0, _tslib.__assign)((0, _tslib.__assign)((0, _tslib.__assign)({}, windowIntegrations), (0, _core.Integrations)), _integrations);

},{"tslib":"6MhhU","./exports":"5LUFQ","@sentry/core":"lKLn3","@sentry/utils":"5wUYP","./integrations":"2eOJi","./transports":"2A5CV","@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"6MhhU":[function(require,module,exports,__globalThis) {
/******************************************************************************
Copyright (c) Microsoft Corporation.

Permission to use, copy, modify, and/or distribute this software for any
purpose with or without fee is hereby granted.

THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES WITH
REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF MERCHANTABILITY
AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR ANY SPECIAL, DIRECT,
INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES WHATSOEVER RESULTING FROM
LOSS OF USE, DATA OR PROFITS, WHETHER IN AN ACTION OF CONTRACT, NEGLIGENCE OR
OTHER TORTIOUS ACTION, ARISING OUT OF OR IN CONNECTION WITH THE USE OR
PERFORMANCE OF THIS SOFTWARE.
***************************************************************************** */ /* global Reflect, Promise, SuppressedError, Symbol, Iterator */ var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "__extends", ()=>__extends);
parcelHelpers.export(exports, "__assign", ()=>__assign);
parcelHelpers.export(exports, "__rest", ()=>__rest);
parcelHelpers.export(exports, "__decorate", ()=>__decorate);
parcelHelpers.export(exports, "__param", ()=>__param);
parcelHelpers.export(exports, "__esDecorate", ()=>__esDecorate);
parcelHelpers.export(exports, "__runInitializers", ()=>__runInitializers);
parcelHelpers.export(exports, "__propKey", ()=>__propKey);
parcelHelpers.export(exports, "__setFunctionName", ()=>__setFunctionName);
parcelHelpers.export(exports, "__metadata", ()=>__metadata);
parcelHelpers.export(exports, "__awaiter", ()=>__awaiter);
parcelHelpers.export(exports, "__generator", ()=>__generator);
parcelHelpers.export(exports, "__createBinding", ()=>__createBinding);
parcelHelpers.export(exports, "__exportStar", ()=>__exportStar);
parcelHelpers.export(exports, "__values", ()=>__values);
parcelHelpers.export(exports, "__read", ()=>__read);
/** @deprecated */ parcelHelpers.export(exports, "__spread", ()=>__spread);
/** @deprecated */ parcelHelpers.export(exports, "__spreadArrays", ()=>__spreadArrays);
parcelHelpers.export(exports, "__spreadArray", ()=>__spreadArray);
parcelHelpers.export(exports, "__await", ()=>__await);
parcelHelpers.export(exports, "__asyncGenerator", ()=>__asyncGenerator);
parcelHelpers.export(exports, "__asyncDelegator", ()=>__asyncDelegator);
parcelHelpers.export(exports, "__asyncValues", ()=>__asyncValues);
parcelHelpers.export(exports, "__makeTemplateObject", ()=>__makeTemplateObject);
parcelHelpers.export(exports, "__importStar", ()=>__importStar);
parcelHelpers.export(exports, "__importDefault", ()=>__importDefault);
parcelHelpers.export(exports, "__classPrivateFieldGet", ()=>__classPrivateFieldGet);
parcelHelpers.export(exports, "__classPrivateFieldSet", ()=>__classPrivateFieldSet);
parcelHelpers.export(exports, "__classPrivateFieldIn", ()=>__classPrivateFieldIn);
parcelHelpers.export(exports, "__addDisposableResource", ()=>__addDisposableResource);
parcelHelpers.export(exports, "__disposeResources", ()=>__disposeResources);
parcelHelpers.export(exports, "__rewriteRelativeImportExtension", ()=>__rewriteRelativeImportExtension);
var extendStatics = function(d, b) {
    extendStatics = Object.setPrototypeOf || ({
        __proto__: []
    }) instanceof Array && function(d, b) {
        d.__proto__ = b;
    } || function(d, b) {
        for(var p in b)if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p];
    };
    return extendStatics(d, b);
};
function __extends(d, b) {
    if (typeof b !== "function" && b !== null) throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
    extendStatics(d, b);
    function __() {
        this.constructor = d;
    }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
}
var __assign = function() {
    __assign = Object.assign || function __assign(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
function __rest(s, e) {
    var t = {};
    for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function") {
        for(var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++)if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
    }
    return t;
}
function __decorate(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
}
function __param(paramIndex, decorator) {
    return function(target, key) {
        decorator(target, key, paramIndex);
    };
}
function __esDecorate(ctor, descriptorIn, decorators, contextIn, initializers, extraInitializers) {
    function accept(f) {
        if (f !== void 0 && typeof f !== "function") throw new TypeError("Function expected");
        return f;
    }
    var kind = contextIn.kind, key = kind === "getter" ? "get" : kind === "setter" ? "set" : "value";
    var target = !descriptorIn && ctor ? contextIn["static"] ? ctor : ctor.prototype : null;
    var descriptor = descriptorIn || (target ? Object.getOwnPropertyDescriptor(target, contextIn.name) : {});
    var _, done = false;
    for(var i = decorators.length - 1; i >= 0; i--){
        var context = {};
        for(var p in contextIn)context[p] = p === "access" ? {} : contextIn[p];
        for(var p in contextIn.access)context.access[p] = contextIn.access[p];
        context.addInitializer = function(f) {
            if (done) throw new TypeError("Cannot add initializers after decoration has completed");
            extraInitializers.push(accept(f || null));
        };
        var result = (0, decorators[i])(kind === "accessor" ? {
            get: descriptor.get,
            set: descriptor.set
        } : descriptor[key], context);
        if (kind === "accessor") {
            if (result === void 0) continue;
            if (result === null || typeof result !== "object") throw new TypeError("Object expected");
            if (_ = accept(result.get)) descriptor.get = _;
            if (_ = accept(result.set)) descriptor.set = _;
            if (_ = accept(result.init)) initializers.unshift(_);
        } else if (_ = accept(result)) {
            if (kind === "field") initializers.unshift(_);
            else descriptor[key] = _;
        }
    }
    if (target) Object.defineProperty(target, contextIn.name, descriptor);
    done = true;
}
function __runInitializers(thisArg, initializers, value) {
    var useValue = arguments.length > 2;
    for(var i = 0; i < initializers.length; i++)value = useValue ? initializers[i].call(thisArg, value) : initializers[i].call(thisArg);
    return useValue ? value : void 0;
}
function __propKey(x) {
    return typeof x === "symbol" ? x : "".concat(x);
}
function __setFunctionName(f, name, prefix) {
    if (typeof name === "symbol") name = name.description ? "[".concat(name.description, "]") : "";
    return Object.defineProperty(f, "name", {
        configurable: true,
        value: prefix ? "".concat(prefix, " ", name) : name
    });
}
function __metadata(metadataKey, metadataValue) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(metadataKey, metadataValue);
}
function __awaiter(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
}
function __generator(thisArg, body) {
    var _ = {
        label: 0,
        sent: function() {
            if (t[0] & 1) throw t[1];
            return t[1];
        },
        trys: [],
        ops: []
    }, f, y, t, g = Object.create((typeof Iterator === "function" ? Iterator : Object).prototype);
    return g.next = verb(0), g["throw"] = verb(1), g["return"] = verb(2), typeof Symbol === "function" && (g[Symbol.iterator] = function() {
        return this;
    }), g;
    function verb(n) {
        return function(v) {
            return step([
                n,
                v
            ]);
        };
    }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while(g && (g = 0, op[0] && (_ = 0)), _)try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [
                op[0] & 2,
                t.value
            ];
            switch(op[0]){
                case 0:
                case 1:
                    t = op;
                    break;
                case 4:
                    _.label++;
                    return {
                        value: op[1],
                        done: false
                    };
                case 5:
                    _.label++;
                    y = op[1];
                    op = [
                        0
                    ];
                    continue;
                case 7:
                    op = _.ops.pop();
                    _.trys.pop();
                    continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
                        _ = 0;
                        continue;
                    }
                    if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
                        _.label = op[1];
                        break;
                    }
                    if (op[0] === 6 && _.label < t[1]) {
                        _.label = t[1];
                        t = op;
                        break;
                    }
                    if (t && _.label < t[2]) {
                        _.label = t[2];
                        _.ops.push(op);
                        break;
                    }
                    if (t[2]) _.ops.pop();
                    _.trys.pop();
                    continue;
            }
            op = body.call(thisArg, _);
        } catch (e) {
            op = [
                6,
                e
            ];
            y = 0;
        } finally{
            f = t = 0;
        }
        if (op[0] & 5) throw op[1];
        return {
            value: op[0] ? op[1] : void 0,
            done: true
        };
    }
}
var __createBinding = Object.create ? function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) desc = {
        enumerable: true,
        get: function() {
            return m[k];
        }
    };
    Object.defineProperty(o, k2, desc);
} : function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
};
function __exportStar(m, o) {
    for(var p in m)if (p !== "default" && !Object.prototype.hasOwnProperty.call(o, p)) __createBinding(o, m, p);
}
function __values(o) {
    var s = typeof Symbol === "function" && Symbol.iterator, m = s && o[s], i = 0;
    if (m) return m.call(o);
    if (o && typeof o.length === "number") return {
        next: function() {
            if (o && i >= o.length) o = void 0;
            return {
                value: o && o[i++],
                done: !o
            };
        }
    };
    throw new TypeError(s ? "Object is not iterable." : "Symbol.iterator is not defined.");
}
function __read(o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while((n === void 0 || n-- > 0) && !(r = i.next()).done)ar.push(r.value);
    } catch (error) {
        e = {
            error: error
        };
    } finally{
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        } finally{
            if (e) throw e.error;
        }
    }
    return ar;
}
function __spread() {
    for(var ar = [], i = 0; i < arguments.length; i++)ar = ar.concat(__read(arguments[i]));
    return ar;
}
function __spreadArrays() {
    for(var s = 0, i = 0, il = arguments.length; i < il; i++)s += arguments[i].length;
    for(var r = Array(s), k = 0, i = 0; i < il; i++)for(var a = arguments[i], j = 0, jl = a.length; j < jl; j++, k++)r[k] = a[j];
    return r;
}
function __spreadArray(to, from, pack) {
    if (pack || arguments.length === 2) {
        for(var i = 0, l = from.length, ar; i < l; i++)if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
}
function __await(v) {
    return this instanceof __await ? (this.v = v, this) : new __await(v);
}
function __asyncGenerator(thisArg, _arguments, generator) {
    if (!Symbol.asyncIterator) throw new TypeError("Symbol.asyncIterator is not defined.");
    var g = generator.apply(thisArg, _arguments || []), i, q = [];
    return i = Object.create((typeof AsyncIterator === "function" ? AsyncIterator : Object).prototype), verb("next"), verb("throw"), verb("return", awaitReturn), i[Symbol.asyncIterator] = function() {
        return this;
    }, i;
    function awaitReturn(f) {
        return function(v) {
            return Promise.resolve(v).then(f, reject);
        };
    }
    function verb(n, f) {
        if (g[n]) {
            i[n] = function(v) {
                return new Promise(function(a, b) {
                    q.push([
                        n,
                        v,
                        a,
                        b
                    ]) > 1 || resume(n, v);
                });
            };
            if (f) i[n] = f(i[n]);
        }
    }
    function resume(n, v) {
        try {
            step(g[n](v));
        } catch (e) {
            settle(q[0][3], e);
        }
    }
    function step(r) {
        r.value instanceof __await ? Promise.resolve(r.value.v).then(fulfill, reject) : settle(q[0][2], r);
    }
    function fulfill(value) {
        resume("next", value);
    }
    function reject(value) {
        resume("throw", value);
    }
    function settle(f, v) {
        if (f(v), q.shift(), q.length) resume(q[0][0], q[0][1]);
    }
}
function __asyncDelegator(o) {
    var i, p;
    return i = {}, verb("next"), verb("throw", function(e) {
        throw e;
    }), verb("return"), i[Symbol.iterator] = function() {
        return this;
    }, i;
    function verb(n, f) {
        i[n] = o[n] ? function(v) {
            return (p = !p) ? {
                value: __await(o[n](v)),
                done: false
            } : f ? f(v) : v;
        } : f;
    }
}
function __asyncValues(o) {
    if (!Symbol.asyncIterator) throw new TypeError("Symbol.asyncIterator is not defined.");
    var m = o[Symbol.asyncIterator], i;
    return m ? m.call(o) : (o = typeof __values === "function" ? __values(o) : o[Symbol.iterator](), i = {}, verb("next"), verb("throw"), verb("return"), i[Symbol.asyncIterator] = function() {
        return this;
    }, i);
    function verb(n) {
        i[n] = o[n] && function(v) {
            return new Promise(function(resolve, reject) {
                v = o[n](v), settle(resolve, reject, v.done, v.value);
            });
        };
    }
    function settle(resolve, reject, d, v) {
        Promise.resolve(v).then(function(v) {
            resolve({
                value: v,
                done: d
            });
        }, reject);
    }
}
function __makeTemplateObject(cooked, raw) {
    if (Object.defineProperty) Object.defineProperty(cooked, "raw", {
        value: raw
    });
    else cooked.raw = raw;
    return cooked;
}
var __setModuleDefault = Object.create ? function(o, v) {
    Object.defineProperty(o, "default", {
        enumerable: true,
        value: v
    });
} : function(o, v) {
    o["default"] = v;
};
var ownKeys = function(o) {
    ownKeys = Object.getOwnPropertyNames || function(o) {
        var ar = [];
        for(var k in o)if (Object.prototype.hasOwnProperty.call(o, k)) ar[ar.length] = k;
        return ar;
    };
    return ownKeys(o);
};
function __importStar(mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) {
        for(var k = ownKeys(mod), i = 0; i < k.length; i++)if (k[i] !== "default") __createBinding(result, mod, k[i]);
    }
    __setModuleDefault(result, mod);
    return result;
}
function __importDefault(mod) {
    return mod && mod.__esModule ? mod : {
        default: mod
    };
}
function __classPrivateFieldGet(receiver, state, kind, f) {
    if (kind === "a" && !f) throw new TypeError("Private accessor was defined without a getter");
    if (typeof state === "function" ? receiver !== state || !f : !state.has(receiver)) throw new TypeError("Cannot read private member from an object whose class did not declare it");
    return kind === "m" ? f : kind === "a" ? f.call(receiver) : f ? f.value : state.get(receiver);
}
function __classPrivateFieldSet(receiver, state, value, kind, f) {
    if (kind === "m") throw new TypeError("Private method is not writable");
    if (kind === "a" && !f) throw new TypeError("Private accessor was defined without a setter");
    if (typeof state === "function" ? receiver !== state || !f : !state.has(receiver)) throw new TypeError("Cannot write private member to an object whose class did not declare it");
    return kind === "a" ? f.call(receiver, value) : f ? f.value = value : state.set(receiver, value), value;
}
function __classPrivateFieldIn(state, receiver) {
    if (receiver === null || typeof receiver !== "object" && typeof receiver !== "function") throw new TypeError("Cannot use 'in' operator on non-object");
    return typeof state === "function" ? receiver === state : state.has(receiver);
}
function __addDisposableResource(env, value, async) {
    if (value !== null && value !== void 0) {
        if (typeof value !== "object" && typeof value !== "function") throw new TypeError("Object expected.");
        var dispose, inner;
        if (async) {
            if (!Symbol.asyncDispose) throw new TypeError("Symbol.asyncDispose is not defined.");
            dispose = value[Symbol.asyncDispose];
        }
        if (dispose === void 0) {
            if (!Symbol.dispose) throw new TypeError("Symbol.dispose is not defined.");
            dispose = value[Symbol.dispose];
            if (async) inner = dispose;
        }
        if (typeof dispose !== "function") throw new TypeError("Object not disposable.");
        if (inner) dispose = function() {
            try {
                inner.call(this);
            } catch (e) {
                return Promise.reject(e);
            }
        };
        env.stack.push({
            value: value,
            dispose: dispose,
            async: async
        });
    } else if (async) env.stack.push({
        async: true
    });
    return value;
}
var _SuppressedError = typeof SuppressedError === "function" ? SuppressedError : function(error, suppressed, message) {
    var e = new Error(message);
    return e.name = "SuppressedError", e.error = error, e.suppressed = suppressed, e;
};
function __disposeResources(env) {
    function fail(e) {
        env.error = env.hasError ? new _SuppressedError(e, env.error, "An error was suppressed during disposal.") : e;
        env.hasError = true;
    }
    var r, s = 0;
    function next() {
        while(r = env.stack.pop())try {
            if (!r.async && s === 1) return s = 0, env.stack.push(r), Promise.resolve().then(next);
            if (r.dispose) {
                var result = r.dispose.call(r.value);
                if (r.async) return s |= 2, Promise.resolve(result).then(next, function(e) {
                    fail(e);
                    return next();
                });
            } else s |= 1;
        } catch (e) {
            fail(e);
        }
        if (s === 1) return env.hasError ? Promise.reject(env.error) : Promise.resolve();
        if (env.hasError) throw env.error;
    }
    return next();
}
function __rewriteRelativeImportExtension(path, preserveJsx) {
    if (typeof path === "string" && /^\.\.?\//.test(path)) return path.replace(/\.(tsx)$|((?:\.d)?)((?:\.[^./]+?)?)\.([cm]?)ts$/i, function(m, tsx, d, ext, cm) {
        return tsx ? preserveJsx ? ".jsx" : ".js" : d && (!ext || !cm) ? m : d + ext + "." + cm.toLowerCase() + "js";
    });
    return path;
}
exports.default = {
    __extends,
    __assign,
    __rest,
    __decorate,
    __param,
    __esDecorate,
    __runInitializers,
    __propKey,
    __setFunctionName,
    __metadata,
    __awaiter,
    __generator,
    __createBinding,
    __exportStar,
    __values,
    __read,
    __spread,
    __spreadArrays,
    __spreadArray,
    __await,
    __asyncGenerator,
    __asyncDelegator,
    __asyncValues,
    __makeTemplateObject,
    __importStar,
    __importDefault,
    __classPrivateFieldGet,
    __classPrivateFieldSet,
    __classPrivateFieldIn,
    __addDisposableResource,
    __disposeResources,
    __rewriteRelativeImportExtension
};

},{"@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"5LUFQ":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "Severity", ()=>(0, _types.Severity));
parcelHelpers.export(exports, "addGlobalEventProcessor", ()=>(0, _core.addGlobalEventProcessor));
parcelHelpers.export(exports, "addBreadcrumb", ()=>(0, _core.addBreadcrumb));
parcelHelpers.export(exports, "captureException", ()=>(0, _core.captureException));
parcelHelpers.export(exports, "captureEvent", ()=>(0, _core.captureEvent));
parcelHelpers.export(exports, "captureMessage", ()=>(0, _core.captureMessage));
parcelHelpers.export(exports, "configureScope", ()=>(0, _core.configureScope));
parcelHelpers.export(exports, "getHubFromCarrier", ()=>(0, _core.getHubFromCarrier));
parcelHelpers.export(exports, "getCurrentHub", ()=>(0, _core.getCurrentHub));
parcelHelpers.export(exports, "Hub", ()=>(0, _core.Hub));
parcelHelpers.export(exports, "makeMain", ()=>(0, _core.makeMain));
parcelHelpers.export(exports, "Scope", ()=>(0, _core.Scope));
parcelHelpers.export(exports, "Session", ()=>(0, _core.Session));
parcelHelpers.export(exports, "startTransaction", ()=>(0, _core.startTransaction));
parcelHelpers.export(exports, "SDK_VERSION", ()=>(0, _core.SDK_VERSION));
parcelHelpers.export(exports, "setContext", ()=>(0, _core.setContext));
parcelHelpers.export(exports, "setExtra", ()=>(0, _core.setExtra));
parcelHelpers.export(exports, "setExtras", ()=>(0, _core.setExtras));
parcelHelpers.export(exports, "setTag", ()=>(0, _core.setTag));
parcelHelpers.export(exports, "setTags", ()=>(0, _core.setTags));
parcelHelpers.export(exports, "setUser", ()=>(0, _core.setUser));
parcelHelpers.export(exports, "withScope", ()=>(0, _core.withScope));
parcelHelpers.export(exports, "BrowserClient", ()=>(0, _client.BrowserClient));
parcelHelpers.export(exports, "injectReportDialog", ()=>(0, _helpers.injectReportDialog));
parcelHelpers.export(exports, "eventFromException", ()=>(0, _eventbuilder.eventFromException));
parcelHelpers.export(exports, "eventFromMessage", ()=>(0, _eventbuilder.eventFromMessage));
parcelHelpers.export(exports, "defaultIntegrations", ()=>(0, _sdk.defaultIntegrations));
parcelHelpers.export(exports, "forceLoad", ()=>(0, _sdk.forceLoad));
parcelHelpers.export(exports, "init", ()=>(0, _sdk.init));
parcelHelpers.export(exports, "lastEventId", ()=>(0, _sdk.lastEventId));
parcelHelpers.export(exports, "onLoad", ()=>(0, _sdk.onLoad));
parcelHelpers.export(exports, "showReportDialog", ()=>(0, _sdk.showReportDialog));
parcelHelpers.export(exports, "flush", ()=>(0, _sdk.flush));
parcelHelpers.export(exports, "close", ()=>(0, _sdk.close));
parcelHelpers.export(exports, "wrap", ()=>(0, _sdk.wrap));
parcelHelpers.export(exports, "SDK_NAME", ()=>(0, _version.SDK_NAME));
var _types = require("@sentry/types");
var _core = require("@sentry/core");
var _client = require("./client");
var _helpers = require("./helpers");
var _eventbuilder = require("./eventbuilder");
var _sdk = require("./sdk");
var _version = require("./version");

},{"@sentry/types":"92FRt","@sentry/core":"lKLn3","./client":"lvqfm","./helpers":"gVXVR","./eventbuilder":"1K1bH","./sdk":"aIaMj","./version":"7oOmp","@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"92FRt":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "Severity", ()=>(0, _severity.Severity));
parcelHelpers.export(exports, "SeverityLevels", ()=>(0, _severity.SeverityLevels));
var _severity = require("./severity");

},{"./severity":"1kEYX","@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"1kEYX":[function(require,module,exports,__globalThis) {
/**
 * TODO(v7): Remove this enum and replace with SeverityLevel
 */ var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "Severity", ()=>Severity);
parcelHelpers.export(exports, "SeverityLevels", ()=>SeverityLevels);
var Severity;
(function(Severity) {
    /** JSDoc */ Severity["Fatal"] = "fatal";
    /** JSDoc */ Severity["Error"] = "error";
    /** JSDoc */ Severity["Warning"] = "warning";
    /** JSDoc */ Severity["Log"] = "log";
    /** JSDoc */ Severity["Info"] = "info";
    /** JSDoc */ Severity["Debug"] = "debug";
    /** JSDoc */ Severity["Critical"] = "critical";
})(Severity || (Severity = {}));
var SeverityLevels = [
    'fatal',
    'error',
    'warning',
    'log',
    'info',
    'debug',
    'critical'
];

},{"@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"lKLn3":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "addBreadcrumb", ()=>(0, _minimal.addBreadcrumb));
parcelHelpers.export(exports, "captureException", ()=>(0, _minimal.captureException));
parcelHelpers.export(exports, "captureEvent", ()=>(0, _minimal.captureEvent));
parcelHelpers.export(exports, "captureMessage", ()=>(0, _minimal.captureMessage));
parcelHelpers.export(exports, "configureScope", ()=>(0, _minimal.configureScope));
parcelHelpers.export(exports, "startTransaction", ()=>(0, _minimal.startTransaction));
parcelHelpers.export(exports, "setContext", ()=>(0, _minimal.setContext));
parcelHelpers.export(exports, "setExtra", ()=>(0, _minimal.setExtra));
parcelHelpers.export(exports, "setExtras", ()=>(0, _minimal.setExtras));
parcelHelpers.export(exports, "setTag", ()=>(0, _minimal.setTag));
parcelHelpers.export(exports, "setTags", ()=>(0, _minimal.setTags));
parcelHelpers.export(exports, "setUser", ()=>(0, _minimal.setUser));
parcelHelpers.export(exports, "withScope", ()=>(0, _minimal.withScope));
parcelHelpers.export(exports, "addGlobalEventProcessor", ()=>(0, _hub.addGlobalEventProcessor));
parcelHelpers.export(exports, "getCurrentHub", ()=>(0, _hub.getCurrentHub));
parcelHelpers.export(exports, "getHubFromCarrier", ()=>(0, _hub.getHubFromCarrier));
parcelHelpers.export(exports, "Hub", ()=>(0, _hub.Hub));
parcelHelpers.export(exports, "makeMain", ()=>(0, _hub.makeMain));
parcelHelpers.export(exports, "Scope", ()=>(0, _hub.Scope));
parcelHelpers.export(exports, "Session", ()=>(0, _hub.Session));
parcelHelpers.export(exports, "API", ()=>(0, _api.API));
parcelHelpers.export(exports, "getEnvelopeEndpointWithUrlEncodedAuth", ()=>(0, _api.getEnvelopeEndpointWithUrlEncodedAuth));
parcelHelpers.export(exports, "getStoreEndpointWithUrlEncodedAuth", ()=>(0, _api.getStoreEndpointWithUrlEncodedAuth));
parcelHelpers.export(exports, "getRequestHeaders", ()=>(0, _api.getRequestHeaders));
parcelHelpers.export(exports, "initAPIDetails", ()=>(0, _api.initAPIDetails));
parcelHelpers.export(exports, "getReportDialogEndpoint", ()=>(0, _api.getReportDialogEndpoint));
parcelHelpers.export(exports, "BaseClient", ()=>(0, _baseclient.BaseClient));
parcelHelpers.export(exports, "BaseBackend", ()=>(0, _basebackend.BaseBackend));
parcelHelpers.export(exports, "eventToSentryRequest", ()=>(0, _request.eventToSentryRequest));
parcelHelpers.export(exports, "sessionToSentryRequest", ()=>(0, _request.sessionToSentryRequest));
parcelHelpers.export(exports, "initAndBind", ()=>(0, _sdk.initAndBind));
parcelHelpers.export(exports, "NoopTransport", ()=>(0, _noop.NoopTransport));
parcelHelpers.export(exports, "createTransport", ()=>(0, _base.createTransport));
parcelHelpers.export(exports, "SDK_VERSION", ()=>(0, _version.SDK_VERSION));
parcelHelpers.export(exports, "Integrations", ()=>_integrations);
var _minimal = require("@sentry/minimal");
var _hub = require("@sentry/hub");
var _api = require("./api");
var _baseclient = require("./baseclient");
var _basebackend = require("./basebackend");
var _request = require("./request");
var _sdk = require("./sdk");
var _noop = require("./transports/noop");
var _base = require("./transports/base");
var _version = require("./version");
var _integrations = require("./integrations");

},{"@sentry/minimal":"8Cdu2","@sentry/hub":"8w5kA","./api":"2DOw8","./baseclient":"7KRsD","./basebackend":"bkQLA","./request":"96gCW","./sdk":"7760M","./transports/noop":false,"./transports/base":"2EtCn","./version":"l0lUl","./integrations":"aivRK","@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"8Cdu2":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
/**
 * Captures an exception event and sends it to Sentry.
 *
 * @param exception An exception-like object.
 * @returns The generated eventId.
 */ // eslint-disable-next-line @typescript-eslint/no-explicit-any, @typescript-eslint/explicit-module-boundary-types
parcelHelpers.export(exports, "captureException", ()=>captureException);
/**
 * Captures a message event and sends it to Sentry.
 *
 * @param message The message to send to Sentry.
 * @param Severity Define the level of the message.
 * @returns The generated eventId.
 */ parcelHelpers.export(exports, "captureMessage", ()=>captureMessage);
/**
 * Captures a manually created event and sends it to Sentry.
 *
 * @param event The event to send to Sentry.
 * @returns The generated eventId.
 */ parcelHelpers.export(exports, "captureEvent", ()=>captureEvent);
/**
 * Callback to set context information onto the scope.
 * @param callback Callback function that receives Scope.
 */ parcelHelpers.export(exports, "configureScope", ()=>configureScope);
/**
 * Records a new breadcrumb which will be attached to future events.
 *
 * Breadcrumbs will be added to subsequent events to provide more context on
 * user's actions prior to an error or crash.
 *
 * @param breadcrumb The breadcrumb to record.
 */ parcelHelpers.export(exports, "addBreadcrumb", ()=>addBreadcrumb);
/**
 * Sets context data with the given name.
 * @param name of the context
 * @param context Any kind of data. This data will be normalized.
 */ // eslint-disable-next-line @typescript-eslint/no-explicit-any
parcelHelpers.export(exports, "setContext", ()=>setContext);
/**
 * Set an object that will be merged sent as extra data with the event.
 * @param extras Extras object to merge into current context.
 */ parcelHelpers.export(exports, "setExtras", ()=>setExtras);
/**
 * Set an object that will be merged sent as tags data with the event.
 * @param tags Tags context object to merge into current context.
 */ parcelHelpers.export(exports, "setTags", ()=>setTags);
/**
 * Set key:value that will be sent as extra data with the event.
 * @param key String of extra
 * @param extra Any kind of data. This data will be normalized.
 */ parcelHelpers.export(exports, "setExtra", ()=>setExtra);
/**
 * Set key:value that will be sent as tags data with the event.
 *
 * Can also be used to unset a tag, by passing `undefined`.
 *
 * @param key String key of tag
 * @param value Value of tag
 */ parcelHelpers.export(exports, "setTag", ()=>setTag);
/**
 * Updates user context information for future events.
 *
 * @param user User context object to be set in the current context. Pass `null` to unset the user.
 */ parcelHelpers.export(exports, "setUser", ()=>setUser);
/**
 * Creates a new scope with and executes the given operation within.
 * The scope is automatically removed once the operation
 * finishes or throws.
 *
 * This is essentially a convenience function for:
 *
 *     pushScope();
 *     callback();
 *     popScope();
 *
 * @param callback that will be enclosed into push/popScope.
 */ parcelHelpers.export(exports, "withScope", ()=>withScope);
/**
 * Calls a function on the latest client. Use this with caution, it's meant as
 * in "internal" helper so we don't need to expose every possible function in
 * the shim. It is not guaranteed that the client actually implements the
 * function.
 *
 * @param method The method to call on the client/client.
 * @param args Arguments to pass to the client/fontend.
 * @hidden
 */ // eslint-disable-next-line @typescript-eslint/no-explicit-any
parcelHelpers.export(exports, "_callOnClient", ()=>_callOnClient);
/**
 * Starts a new `Transaction` and returns it. This is the entry point to manual tracing instrumentation.
 *
 * A tree structure can be built by adding child spans to the transaction, and child spans to other spans. To start a
 * new child span within the transaction or any span, call the respective `.startChild()` method.
 *
 * Every child span must be finished before the transaction is finished, otherwise the unfinished spans are discarded.
 *
 * The transaction must be finished with a call to its `.finish()` method, at which point the transaction with all its
 * finished child spans will be sent to Sentry.
 *
 * @param context Properties of the new `Transaction`.
 * @param customSamplingContext Information given to the transaction sampling function (along with context-dependent
 * default values). See {@link Options.tracesSampler}.
 *
 * @returns The transaction which was just started
 */ parcelHelpers.export(exports, "startTransaction", ()=>startTransaction);
var _tslib = require("tslib");
var _hub = require("@sentry/hub");
/**
 * This calls a function on the current hub.
 * @param method function to call on hub.
 * @param args to pass to function.
 */ // eslint-disable-next-line @typescript-eslint/no-explicit-any
function callOnHub(method) {
    var args = [];
    for(var _i = 1; _i < arguments.length; _i++)args[_i - 1] = arguments[_i];
    var hub = (0, _hub.getCurrentHub)();
    if (hub && hub[method]) // eslint-disable-next-line @typescript-eslint/no-explicit-any
    return hub[method].apply(hub, (0, _tslib.__spread)(args));
    throw new Error("No hub defined or " + method + " was not found on the hub, please open a bug report.");
}
function captureException(exception, captureContext) {
    var syntheticException = new Error('Sentry syntheticException');
    return callOnHub('captureException', exception, {
        captureContext: captureContext,
        originalException: exception,
        syntheticException: syntheticException
    });
}
function captureMessage(message, captureContext) {
    var syntheticException = new Error(message);
    // This is necessary to provide explicit scopes upgrade, without changing the original
    // arity of the `captureMessage(message, level)` method.
    var level = typeof captureContext === 'string' ? captureContext : undefined;
    var context = typeof captureContext !== 'string' ? {
        captureContext: captureContext
    } : undefined;
    return callOnHub('captureMessage', message, level, (0, _tslib.__assign)({
        originalException: message,
        syntheticException: syntheticException
    }, context));
}
function captureEvent(event) {
    return callOnHub('captureEvent', event);
}
function configureScope(callback) {
    callOnHub('configureScope', callback);
}
function addBreadcrumb(breadcrumb) {
    callOnHub('addBreadcrumb', breadcrumb);
}
function setContext(name, context) {
    callOnHub('setContext', name, context);
}
function setExtras(extras) {
    callOnHub('setExtras', extras);
}
function setTags(tags) {
    callOnHub('setTags', tags);
}
function setExtra(key, extra) {
    callOnHub('setExtra', key, extra);
}
function setTag(key, value) {
    callOnHub('setTag', key, value);
}
function setUser(user) {
    callOnHub('setUser', user);
}
function withScope(callback) {
    callOnHub('withScope', callback);
}
function _callOnClient(method) {
    var args = [];
    for(var _i = 1; _i < arguments.length; _i++)args[_i - 1] = arguments[_i];
    callOnHub.apply(void 0, (0, _tslib.__spread)([
        '_invokeClient',
        method
    ], args));
}
function startTransaction(context, customSamplingContext) {
    return callOnHub('startTransaction', (0, _tslib.__assign)({}, context), customSamplingContext);
}

},{"tslib":"6MhhU","@sentry/hub":"8w5kA","@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"8w5kA":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "addGlobalEventProcessor", ()=>(0, _scope.addGlobalEventProcessor));
parcelHelpers.export(exports, "Scope", ()=>(0, _scope.Scope));
parcelHelpers.export(exports, "Session", ()=>(0, _session.Session));
parcelHelpers.export(exports, "SessionFlusher", ()=>(0, _sessionflusher.SessionFlusher));
parcelHelpers.export(exports, "getActiveDomain", ()=>(0, _hub.getActiveDomain));
parcelHelpers.export(exports, "getCurrentHub", ()=>(0, _hub.getCurrentHub));
parcelHelpers.export(exports, "getHubFromCarrier", ()=>(0, _hub.getHubFromCarrier));
parcelHelpers.export(exports, "getMainCarrier", ()=>(0, _hub.getMainCarrier));
parcelHelpers.export(exports, "Hub", ()=>(0, _hub.Hub));
parcelHelpers.export(exports, "makeMain", ()=>(0, _hub.makeMain));
parcelHelpers.export(exports, "setHubOnCarrier", ()=>(0, _hub.setHubOnCarrier));
var _scope = require("./scope");
var _session = require("./session");
var _sessionflusher = require("./sessionflusher");
var _hub = require("./hub");

},{"./scope":"9h4AU","./session":"j0xtB","./sessionflusher":false,"./hub":"bMEqP","@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"9h4AU":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "Scope", ()=>Scope);
/**
 * Add a EventProcessor to be kept globally.
 * @param callback EventProcessor to add
 */ parcelHelpers.export(exports, "addGlobalEventProcessor", ()=>addGlobalEventProcessor);
var _tslib = require("tslib");
var _utils = require("@sentry/utils");
/**
 * Absolute maximum number of breadcrumbs added to an event.
 * The `maxBreadcrumbs` option cannot be higher than this value.
 */ var MAX_BREADCRUMBS = 100;
/**
 * Holds additional event information. {@link Scope.applyToEvent} will be
 * called by the client before an event will be sent.
 */ var Scope = /** @class */ function() {
    function Scope() {
        /** Flag if notifying is happening. */ this._notifyingListeners = false;
        /** Callback for client to receive scope changes. */ this._scopeListeners = [];
        /** Callback list that will be called after {@link applyToEvent}. */ this._eventProcessors = [];
        /** Array of breadcrumbs. */ this._breadcrumbs = [];
        /** User */ this._user = {};
        /** Tags */ this._tags = {};
        /** Extra */ this._extra = {};
        /** Contexts */ this._contexts = {};
        /**
         * A place to stash data which is needed at some point in the SDK's event processing pipeline but which shouldn't get
         * sent to Sentry
         */ this._sdkProcessingMetadata = {};
    }
    /**
     * Inherit values from the parent scope.
     * @param scope to clone.
     */ Scope.clone = function(scope) {
        var newScope = new Scope();
        if (scope) {
            newScope._breadcrumbs = (0, _tslib.__spread)(scope._breadcrumbs);
            newScope._tags = (0, _tslib.__assign)({}, scope._tags);
            newScope._extra = (0, _tslib.__assign)({}, scope._extra);
            newScope._contexts = (0, _tslib.__assign)({}, scope._contexts);
            newScope._user = scope._user;
            newScope._level = scope._level;
            newScope._span = scope._span;
            newScope._session = scope._session;
            newScope._transactionName = scope._transactionName;
            newScope._fingerprint = scope._fingerprint;
            newScope._eventProcessors = (0, _tslib.__spread)(scope._eventProcessors);
            newScope._requestSession = scope._requestSession;
        }
        return newScope;
    };
    /**
     * Add internal on change listener. Used for sub SDKs that need to store the scope.
     * @hidden
     */ Scope.prototype.addScopeListener = function(callback) {
        this._scopeListeners.push(callback);
    };
    /**
     * @inheritDoc
     */ Scope.prototype.addEventProcessor = function(callback) {
        this._eventProcessors.push(callback);
        return this;
    };
    /**
     * @inheritDoc
     */ Scope.prototype.setUser = function(user) {
        this._user = user || {};
        if (this._session) this._session.update({
            user: user
        });
        this._notifyScopeListeners();
        return this;
    };
    /**
     * @inheritDoc
     */ Scope.prototype.getUser = function() {
        return this._user;
    };
    /**
     * @inheritDoc
     */ Scope.prototype.getRequestSession = function() {
        return this._requestSession;
    };
    /**
     * @inheritDoc
     */ Scope.prototype.setRequestSession = function(requestSession) {
        this._requestSession = requestSession;
        return this;
    };
    /**
     * @inheritDoc
     */ Scope.prototype.setTags = function(tags) {
        this._tags = (0, _tslib.__assign)((0, _tslib.__assign)({}, this._tags), tags);
        this._notifyScopeListeners();
        return this;
    };
    /**
     * @inheritDoc
     */ Scope.prototype.setTag = function(key, value) {
        var _a;
        this._tags = (0, _tslib.__assign)((0, _tslib.__assign)({}, this._tags), (_a = {}, _a[key] = value, _a));
        this._notifyScopeListeners();
        return this;
    };
    /**
     * @inheritDoc
     */ Scope.prototype.setExtras = function(extras) {
        this._extra = (0, _tslib.__assign)((0, _tslib.__assign)({}, this._extra), extras);
        this._notifyScopeListeners();
        return this;
    };
    /**
     * @inheritDoc
     */ Scope.prototype.setExtra = function(key, extra) {
        var _a;
        this._extra = (0, _tslib.__assign)((0, _tslib.__assign)({}, this._extra), (_a = {}, _a[key] = extra, _a));
        this._notifyScopeListeners();
        return this;
    };
    /**
     * @inheritDoc
     */ Scope.prototype.setFingerprint = function(fingerprint) {
        this._fingerprint = fingerprint;
        this._notifyScopeListeners();
        return this;
    };
    /**
     * @inheritDoc
     */ Scope.prototype.setLevel = function(level) {
        this._level = level;
        this._notifyScopeListeners();
        return this;
    };
    /**
     * @inheritDoc
     */ Scope.prototype.setTransactionName = function(name) {
        this._transactionName = name;
        this._notifyScopeListeners();
        return this;
    };
    /**
     * Can be removed in major version.
     * @deprecated in favor of {@link this.setTransactionName}
     */ Scope.prototype.setTransaction = function(name) {
        return this.setTransactionName(name);
    };
    /**
     * @inheritDoc
     */ Scope.prototype.setContext = function(key, context) {
        var _a;
        if (context === null) // eslint-disable-next-line @typescript-eslint/no-dynamic-delete
        delete this._contexts[key];
        else this._contexts = (0, _tslib.__assign)((0, _tslib.__assign)({}, this._contexts), (_a = {}, _a[key] = context, _a));
        this._notifyScopeListeners();
        return this;
    };
    /**
     * @inheritDoc
     */ Scope.prototype.setSpan = function(span) {
        this._span = span;
        this._notifyScopeListeners();
        return this;
    };
    /**
     * @inheritDoc
     */ Scope.prototype.getSpan = function() {
        return this._span;
    };
    /**
     * @inheritDoc
     */ Scope.prototype.getTransaction = function() {
        // Often, this span (if it exists at all) will be a transaction, but it's not guaranteed to be. Regardless, it will
        // have a pointer to the currently-active transaction.
        var span = this.getSpan();
        return span && span.transaction;
    };
    /**
     * @inheritDoc
     */ Scope.prototype.setSession = function(session) {
        if (!session) delete this._session;
        else this._session = session;
        this._notifyScopeListeners();
        return this;
    };
    /**
     * @inheritDoc
     */ Scope.prototype.getSession = function() {
        return this._session;
    };
    /**
     * @inheritDoc
     */ Scope.prototype.update = function(captureContext) {
        if (!captureContext) return this;
        if (typeof captureContext === 'function') {
            var updatedScope = captureContext(this);
            return updatedScope instanceof Scope ? updatedScope : this;
        }
        if (captureContext instanceof Scope) {
            this._tags = (0, _tslib.__assign)((0, _tslib.__assign)({}, this._tags), captureContext._tags);
            this._extra = (0, _tslib.__assign)((0, _tslib.__assign)({}, this._extra), captureContext._extra);
            this._contexts = (0, _tslib.__assign)((0, _tslib.__assign)({}, this._contexts), captureContext._contexts);
            if (captureContext._user && Object.keys(captureContext._user).length) this._user = captureContext._user;
            if (captureContext._level) this._level = captureContext._level;
            if (captureContext._fingerprint) this._fingerprint = captureContext._fingerprint;
            if (captureContext._requestSession) this._requestSession = captureContext._requestSession;
        } else if ((0, _utils.isPlainObject)(captureContext)) {
            // eslint-disable-next-line no-param-reassign
            captureContext;
            this._tags = (0, _tslib.__assign)((0, _tslib.__assign)({}, this._tags), captureContext.tags);
            this._extra = (0, _tslib.__assign)((0, _tslib.__assign)({}, this._extra), captureContext.extra);
            this._contexts = (0, _tslib.__assign)((0, _tslib.__assign)({}, this._contexts), captureContext.contexts);
            if (captureContext.user) this._user = captureContext.user;
            if (captureContext.level) this._level = captureContext.level;
            if (captureContext.fingerprint) this._fingerprint = captureContext.fingerprint;
            if (captureContext.requestSession) this._requestSession = captureContext.requestSession;
        }
        return this;
    };
    /**
     * @inheritDoc
     */ Scope.prototype.clear = function() {
        this._breadcrumbs = [];
        this._tags = {};
        this._extra = {};
        this._user = {};
        this._contexts = {};
        this._level = undefined;
        this._transactionName = undefined;
        this._fingerprint = undefined;
        this._requestSession = undefined;
        this._span = undefined;
        this._session = undefined;
        this._notifyScopeListeners();
        return this;
    };
    /**
     * @inheritDoc
     */ Scope.prototype.addBreadcrumb = function(breadcrumb, maxBreadcrumbs) {
        var maxCrumbs = typeof maxBreadcrumbs === 'number' ? Math.min(maxBreadcrumbs, MAX_BREADCRUMBS) : MAX_BREADCRUMBS;
        // No data has been changed, so don't notify scope listeners
        if (maxCrumbs <= 0) return this;
        var mergedBreadcrumb = (0, _tslib.__assign)({
            timestamp: (0, _utils.dateTimestampInSeconds)()
        }, breadcrumb);
        this._breadcrumbs = (0, _tslib.__spread)(this._breadcrumbs, [
            mergedBreadcrumb
        ]).slice(-maxCrumbs);
        this._notifyScopeListeners();
        return this;
    };
    /**
     * @inheritDoc
     */ Scope.prototype.clearBreadcrumbs = function() {
        this._breadcrumbs = [];
        this._notifyScopeListeners();
        return this;
    };
    /**
     * Applies the current context and fingerprint to the event.
     * Note that breadcrumbs will be added by the client.
     * Also if the event has already breadcrumbs on it, we do not merge them.
     * @param event Event
     * @param hint May contain additional information about the original exception.
     * @hidden
     */ Scope.prototype.applyToEvent = function(event, hint) {
        if (this._extra && Object.keys(this._extra).length) event.extra = (0, _tslib.__assign)((0, _tslib.__assign)({}, this._extra), event.extra);
        if (this._tags && Object.keys(this._tags).length) event.tags = (0, _tslib.__assign)((0, _tslib.__assign)({}, this._tags), event.tags);
        if (this._user && Object.keys(this._user).length) event.user = (0, _tslib.__assign)((0, _tslib.__assign)({}, this._user), event.user);
        if (this._contexts && Object.keys(this._contexts).length) event.contexts = (0, _tslib.__assign)((0, _tslib.__assign)({}, this._contexts), event.contexts);
        if (this._level) event.level = this._level;
        if (this._transactionName) event.transaction = this._transactionName;
        // We want to set the trace context for normal events only if there isn't already
        // a trace context on the event. There is a product feature in place where we link
        // errors with transaction and it relies on that.
        if (this._span) {
            event.contexts = (0, _tslib.__assign)({
                trace: this._span.getTraceContext()
            }, event.contexts);
            var transactionName = this._span.transaction && this._span.transaction.name;
            if (transactionName) event.tags = (0, _tslib.__assign)({
                transaction: transactionName
            }, event.tags);
        }
        this._applyFingerprint(event);
        event.breadcrumbs = (0, _tslib.__spread)(event.breadcrumbs || [], this._breadcrumbs);
        event.breadcrumbs = event.breadcrumbs.length > 0 ? event.breadcrumbs : undefined;
        event.sdkProcessingMetadata = this._sdkProcessingMetadata;
        return this._notifyEventProcessors((0, _tslib.__spread)(getGlobalEventProcessors(), this._eventProcessors), event, hint);
    };
    /**
     * Add data which will be accessible during event processing but won't get sent to Sentry
     */ Scope.prototype.setSDKProcessingMetadata = function(newData) {
        this._sdkProcessingMetadata = (0, _tslib.__assign)((0, _tslib.__assign)({}, this._sdkProcessingMetadata), newData);
        return this;
    };
    /**
     * This will be called after {@link applyToEvent} is finished.
     */ Scope.prototype._notifyEventProcessors = function(processors, event, hint, index) {
        var _this = this;
        if (index === void 0) index = 0;
        return new (0, _utils.SyncPromise)(function(resolve, reject) {
            var processor = processors[index];
            if (event === null || typeof processor !== 'function') resolve(event);
            else {
                var result = processor((0, _tslib.__assign)({}, event), hint);
                if ((0, _utils.isThenable)(result)) result.then(function(final) {
                    return _this._notifyEventProcessors(processors, final, hint, index + 1).then(resolve);
                }).then(null, reject);
                else _this._notifyEventProcessors(processors, result, hint, index + 1).then(resolve).then(null, reject);
            }
        });
    };
    /**
     * This will be called on every set call.
     */ Scope.prototype._notifyScopeListeners = function() {
        var _this = this;
        // We need this check for this._notifyingListeners to be able to work on scope during updates
        // If this check is not here we'll produce endless recursion when something is done with the scope
        // during the callback.
        if (!this._notifyingListeners) {
            this._notifyingListeners = true;
            this._scopeListeners.forEach(function(callback) {
                callback(_this);
            });
            this._notifyingListeners = false;
        }
    };
    /**
     * Applies fingerprint from the scope to the event if there's one,
     * uses message if there's one instead or get rid of empty fingerprint
     */ Scope.prototype._applyFingerprint = function(event) {
        // Make sure it's an array first and we actually have something in place
        event.fingerprint = event.fingerprint ? Array.isArray(event.fingerprint) ? event.fingerprint : [
            event.fingerprint
        ] : [];
        // If we have something on the scope, then merge it with event
        if (this._fingerprint) event.fingerprint = event.fingerprint.concat(this._fingerprint);
        // If we have no data at all, remove empty array default
        if (event.fingerprint && !event.fingerprint.length) delete event.fingerprint;
    };
    return Scope;
}();
/**
 * Returns the global event processors.
 */ function getGlobalEventProcessors() {
    return (0, _utils.getGlobalSingleton)('globalEventProcessors', function() {
        return [];
    });
}
function addGlobalEventProcessor(callback) {
    getGlobalEventProcessors().push(callback);
}

},{"tslib":"6MhhU","@sentry/utils":"2okam","@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"2okam":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _async = require("./async");
parcelHelpers.exportAll(_async, exports);
var _browser = require("./browser");
parcelHelpers.exportAll(_browser, exports);
var _dsn = require("./dsn");
parcelHelpers.exportAll(_dsn, exports);
var _enums = require("./enums");
parcelHelpers.exportAll(_enums, exports);
var _error = require("./error");
parcelHelpers.exportAll(_error, exports);
var _global = require("./global");
parcelHelpers.exportAll(_global, exports);
var _instrument = require("./instrument");
parcelHelpers.exportAll(_instrument, exports);
var _is = require("./is");
parcelHelpers.exportAll(_is, exports);
var _logger = require("./logger");
parcelHelpers.exportAll(_logger, exports);
var _memo = require("./memo");
parcelHelpers.exportAll(_memo, exports);
var _misc = require("./misc");
parcelHelpers.exportAll(_misc, exports);
var _node = require("./node");
parcelHelpers.exportAll(_node, exports);
var _normalize = require("./normalize");
parcelHelpers.exportAll(_normalize, exports);
var _object = require("./object");
parcelHelpers.exportAll(_object, exports);
var _path = require("./path");
parcelHelpers.exportAll(_path, exports);
var _promisebuffer = require("./promisebuffer");
parcelHelpers.exportAll(_promisebuffer, exports);
var _severity = require("./severity");
parcelHelpers.exportAll(_severity, exports);
var _stacktrace = require("./stacktrace");
parcelHelpers.exportAll(_stacktrace, exports);
var _status = require("./status");
parcelHelpers.exportAll(_status, exports);
var _string = require("./string");
parcelHelpers.exportAll(_string, exports);
var _supports = require("./supports");
parcelHelpers.exportAll(_supports, exports);
var _syncpromise = require("./syncpromise");
parcelHelpers.exportAll(_syncpromise, exports);
var _time = require("./time");
parcelHelpers.exportAll(_time, exports);
var _tracing = require("./tracing");
parcelHelpers.exportAll(_tracing, exports);
var _env = require("./env");
parcelHelpers.exportAll(_env, exports);
var _envelope = require("./envelope");
parcelHelpers.exportAll(_envelope, exports);
var _clientreport = require("./clientreport");
parcelHelpers.exportAll(_clientreport, exports);
var _ratelimit = require("./ratelimit");
parcelHelpers.exportAll(_ratelimit, exports);

},{"./async":false,"./browser":false,"./dsn":false,"./enums":false,"./error":false,"./global":"kDC3g","./instrument":false,"./is":"amUq0","./logger":"2S1B7","./memo":false,"./misc":"kPTFm","./node":"bzg7l","./normalize":false,"./object":"7CTrS","./path":false,"./promisebuffer":false,"./severity":false,"./stacktrace":false,"./status":false,"./string":false,"./supports":false,"./syncpromise":"485nF","./time":"2qcFX","./tracing":false,"./env":false,"./envelope":false,"./clientreport":false,"./ratelimit":false,"@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"aAf8s":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
/**
 * Given a child DOM element, returns a query-selector statement describing that
 * and its ancestors
 * e.g. [HTMLElement] => body > div > input#foo.btn[name=baz]
 * @returns generated DOM path
 */ parcelHelpers.export(exports, "htmlTreeAsString", ()=>htmlTreeAsString);
/**
 * A safe form of location.href
 */ parcelHelpers.export(exports, "getLocationHref", ()=>getLocationHref);
var _global = require("./global");
var _is = require("./is");
function htmlTreeAsString(elem, keyAttrs) {
    // try/catch both:
    // - accessing event.target (see getsentry/raven-js#838, #768)
    // - `htmlTreeAsString` because it's complex, and just accessing the DOM incorrectly
    // - can throw an exception in some circumstances.
    try {
        var currentElem = elem;
        var MAX_TRAVERSE_HEIGHT = 5;
        var MAX_OUTPUT_LEN = 80;
        var out = [];
        var height = 0;
        var len = 0;
        var separator = ' > ';
        var sepLength = separator.length;
        var nextStr = void 0;
        // eslint-disable-next-line no-plusplus
        while(currentElem && height++ < MAX_TRAVERSE_HEIGHT){
            nextStr = _htmlElementAsString(currentElem, keyAttrs);
            // bail out if
            // - nextStr is the 'html' element
            // - the length of the string that would be created exceeds MAX_OUTPUT_LEN
            //   (ignore this limit if we are on the first iteration)
            if (nextStr === 'html' || height > 1 && len + out.length * sepLength + nextStr.length >= MAX_OUTPUT_LEN) break;
            out.push(nextStr);
            len += nextStr.length;
            currentElem = currentElem.parentNode;
        }
        return out.reverse().join(separator);
    } catch (_oO) {
        return '<unknown>';
    }
}
/**
 * Returns a simple, query-selector representation of a DOM element
 * e.g. [HTMLElement] => input#foo.btn[name=baz]
 * @returns generated DOM path
 */ function _htmlElementAsString(el, keyAttrs) {
    var elem = el;
    var out = [];
    var className;
    var classes;
    var key;
    var attr;
    var i;
    if (!elem || !elem.tagName) return '';
    out.push(elem.tagName.toLowerCase());
    // Pairs of attribute keys defined in `serializeAttribute` and their values on element.
    var keyAttrPairs = keyAttrs && keyAttrs.length ? keyAttrs.filter(function(keyAttr) {
        return elem.getAttribute(keyAttr);
    }).map(function(keyAttr) {
        return [
            keyAttr,
            elem.getAttribute(keyAttr)
        ];
    }) : null;
    if (keyAttrPairs && keyAttrPairs.length) keyAttrPairs.forEach(function(keyAttrPair) {
        out.push("[" + keyAttrPair[0] + "=\"" + keyAttrPair[1] + "\"]");
    });
    else {
        if (elem.id) out.push("#" + elem.id);
        // eslint-disable-next-line prefer-const
        className = elem.className;
        if (className && (0, _is.isString)(className)) {
            classes = className.split(/\s+/);
            for(i = 0; i < classes.length; i++)out.push("." + classes[i]);
        }
    }
    var allowedAttrs = [
        'type',
        'name',
        'title',
        'alt'
    ];
    for(i = 0; i < allowedAttrs.length; i++){
        key = allowedAttrs[i];
        attr = elem.getAttribute(key);
        if (attr) out.push("[" + key + "=\"" + attr + "\"]");
    }
    return out.join('');
}
function getLocationHref() {
    var global = (0, _global.getGlobalObject)();
    try {
        return global.document.location.href;
    } catch (oO) {
        return '';
    }
}

},{"./global":"kDC3g","./is":"amUq0","@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"kDC3g":[function(require,module,exports,__globalThis) {
/**
 * NOTE: In order to avoid circular dependencies, if you add a function to this module and it needs to print something,
 * you must either a) use `console.log` rather than the logger, or b) put your function elsewhere.
 */ var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
/**
 * Safely get global scope object
 *
 * @returns Global scope object
 */ parcelHelpers.export(exports, "getGlobalObject", ()=>getGlobalObject);
/**
 * Returns a global singleton contained in the global `__SENTRY__` object.
 *
 * If the singleton doesn't already exist in `__SENTRY__`, it will be created using the given factory
 * function and added to the `__SENTRY__` object.
 *
 * @param name name of the global singleton on __SENTRY__
 * @param creator creator Factory function to create the singleton if it doesn't already exist on `__SENTRY__`
 * @param obj (Optional) The global object on which to look for `__SENTRY__`, if not `getGlobalObject`'s return value
 * @returns the singleton
 */ parcelHelpers.export(exports, "getGlobalSingleton", ()=>getGlobalSingleton);
var _node = require("./node");
var global = arguments[3];
var fallbackGlobalObject = {};
function getGlobalObject() {
    return (0, _node.isNodeEnv)() ? global : typeof window !== 'undefined' // eslint-disable-line no-restricted-globals
     ? window // eslint-disable-line no-restricted-globals
     : typeof self !== 'undefined' ? self : fallbackGlobalObject;
}
function getGlobalSingleton(name, creator, obj) {
    var global = obj || getGlobalObject();
    var __SENTRY__ = global.__SENTRY__ = global.__SENTRY__ || {};
    var singleton = __SENTRY__[name] || (__SENTRY__[name] = creator());
    return singleton;
}

},{"./node":"bzg7l","@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"bzg7l":[function(require,module,exports,__globalThis) {
/**
 * NOTE: In order to avoid circular dependencies, if you add a function to this module and it needs to print something,
 * you must either a) use `console.log` rather than the logger, or b) put your function elsewhere.
 */ var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
/**
 * Checks whether we're in the Node.js or Browser environment
 *
 * @returns Answer to given question
 */ parcelHelpers.export(exports, "isNodeEnv", ()=>isNodeEnv);
/**
 * Requires a module which is protected against bundler minification.
 *
 * @param request The module path to resolve
 */ // eslint-disable-next-line @typescript-eslint/explicit-module-boundary-types, @typescript-eslint/no-explicit-any
parcelHelpers.export(exports, "dynamicRequire", ()=>dynamicRequire);
/**
 * Helper for dynamically loading module that should work with linked dependencies.
 * The problem is that we _should_ be using `require(require.resolve(moduleName, { paths: [cwd()] }))`
 * However it's _not possible_ to do that with Webpack, as it has to know all the dependencies during
 * build time. `require.resolve` is also not available in any other way, so we cannot create,
 * a fake helper like we do with `dynamicRequire`.
 *
 * We always prefer to use local package, thus the value is not returned early from each `try/catch` block.
 * That is to mimic the behavior of `require.resolve` exactly.
 *
 * @param moduleName module name to require
 * @returns possibly required module
 */ parcelHelpers.export(exports, "loadModule", ()=>loadModule);
var _env = require("./env");
var process = require("76b1f05ddf2519c5");
function isNodeEnv() {
    // explicitly check for browser bundles as those can be optimized statically
    // by terser/rollup.
    return !(0, _env.isBrowserBundle)() && Object.prototype.toString.call(typeof process !== 'undefined' ? process : 0) === '[object process]';
}
function dynamicRequire(mod, request) {
    // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access
    return mod.require(request);
}
function loadModule(moduleName) {
    var mod;
    try {
        mod = dynamicRequire(module, moduleName);
    } catch (e) {
    // no-empty
    }
    try {
        var cwd = dynamicRequire(module, 'process').cwd;
        mod = dynamicRequire(module, cwd() + "/node_modules/" + moduleName);
    } catch (e) {
    // no-empty
    }
    return mod;
}

},{"76b1f05ddf2519c5":"gNLf3","./env":"7cIHf","@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"7cIHf":[function(require,module,exports,__globalThis) {
/*
 * This module exists for optimizations in the build process through rollup and terser.  We define some global
 * constants, which can be overridden during build. By guarding certain pieces of code with functions that return these
 * constants, we can control whether or not they appear in the final bundle. (Any code guarded by a false condition will
 * never run, and will hence be dropped during treeshaking.) The two primary uses for this are stripping out calls to
 * `logger` and preventing node-related code from appearing in browser bundles.
 *
 * Attention:
 * This file should not be used to define constants/flags that are intended to be used for tree-shaking conducted by
 * users. These fags should live in their respective packages, as we identified user tooling (specifically webpack)
 * having issues tree-shaking these constants across package boundaries.
 * An example for this is the __SENTRY_DEBUG__ constant. It is declared in each package individually because we want
 * users to be able to shake away expressions that it guards.
 */ /**
 * Figures out if we're building a browser bundle.
 *
 * @returns true if this is a browser bundle build.
 */ var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "isBrowserBundle", ()=>isBrowserBundle);
function isBrowserBundle() {
    return typeof __SENTRY_BROWSER_BUNDLE__ !== 'undefined' && !!__SENTRY_BROWSER_BUNDLE__;
}

},{"@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"amUq0":[function(require,module,exports,__globalThis) {
/* eslint-disable @typescript-eslint/no-explicit-any */ /* eslint-disable @typescript-eslint/explicit-module-boundary-types */ // eslint-disable-next-line @typescript-eslint/unbound-method
var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
/**
 * Checks whether given value's type is one of a few Error or Error-like
 * {@link isError}.
 *
 * @param wat A value to be checked.
 * @returns A boolean representing the result.
 */ parcelHelpers.export(exports, "isError", ()=>isError);
/**
 * Checks whether given value's type is ErrorEvent
 * {@link isErrorEvent}.
 *
 * @param wat A value to be checked.
 * @returns A boolean representing the result.
 */ parcelHelpers.export(exports, "isErrorEvent", ()=>isErrorEvent);
/**
 * Checks whether given value's type is DOMError
 * {@link isDOMError}.
 *
 * @param wat A value to be checked.
 * @returns A boolean representing the result.
 */ parcelHelpers.export(exports, "isDOMError", ()=>isDOMError);
/**
 * Checks whether given value's type is DOMException
 * {@link isDOMException}.
 *
 * @param wat A value to be checked.
 * @returns A boolean representing the result.
 */ parcelHelpers.export(exports, "isDOMException", ()=>isDOMException);
/**
 * Checks whether given value's type is a string
 * {@link isString}.
 *
 * @param wat A value to be checked.
 * @returns A boolean representing the result.
 */ parcelHelpers.export(exports, "isString", ()=>isString);
/**
 * Checks whether given value is a primitive (undefined, null, number, boolean, string, bigint, symbol)
 * {@link isPrimitive}.
 *
 * @param wat A value to be checked.
 * @returns A boolean representing the result.
 */ parcelHelpers.export(exports, "isPrimitive", ()=>isPrimitive);
/**
 * Checks whether given value's type is an object literal
 * {@link isPlainObject}.
 *
 * @param wat A value to be checked.
 * @returns A boolean representing the result.
 */ parcelHelpers.export(exports, "isPlainObject", ()=>isPlainObject);
/**
 * Checks whether given value's type is an Event instance
 * {@link isEvent}.
 *
 * @param wat A value to be checked.
 * @returns A boolean representing the result.
 */ parcelHelpers.export(exports, "isEvent", ()=>isEvent);
/**
 * Checks whether given value's type is an Element instance
 * {@link isElement}.
 *
 * @param wat A value to be checked.
 * @returns A boolean representing the result.
 */ parcelHelpers.export(exports, "isElement", ()=>isElement);
/**
 * Checks whether given value's type is an regexp
 * {@link isRegExp}.
 *
 * @param wat A value to be checked.
 * @returns A boolean representing the result.
 */ parcelHelpers.export(exports, "isRegExp", ()=>isRegExp);
/**
 * Checks whether given value has a then function.
 * @param wat A value to be checked.
 */ parcelHelpers.export(exports, "isThenable", ()=>isThenable);
/**
 * Checks whether given value's type is a SyntheticEvent
 * {@link isSyntheticEvent}.
 *
 * @param wat A value to be checked.
 * @returns A boolean representing the result.
 */ parcelHelpers.export(exports, "isSyntheticEvent", ()=>isSyntheticEvent);
/**
 * Checks whether given value is NaN
 * {@link isNaN}.
 *
 * @param wat A value to be checked.
 * @returns A boolean representing the result.
 */ parcelHelpers.export(exports, "isNaN", ()=>isNaN);
/**
 * Checks whether given value's type is an instance of provided constructor.
 * {@link isInstanceOf}.
 *
 * @param wat A value to be checked.
 * @param base A constructor to be used in a check.
 * @returns A boolean representing the result.
 */ parcelHelpers.export(exports, "isInstanceOf", ()=>isInstanceOf);
var objectToString = Object.prototype.toString;
function isError(wat) {
    switch(objectToString.call(wat)){
        case '[object Error]':
        case '[object Exception]':
        case '[object DOMException]':
            return true;
        default:
            return isInstanceOf(wat, Error);
    }
}
function isBuiltin(wat, ty) {
    return objectToString.call(wat) === "[object " + ty + "]";
}
function isErrorEvent(wat) {
    return isBuiltin(wat, 'ErrorEvent');
}
function isDOMError(wat) {
    return isBuiltin(wat, 'DOMError');
}
function isDOMException(wat) {
    return isBuiltin(wat, 'DOMException');
}
function isString(wat) {
    return isBuiltin(wat, 'String');
}
function isPrimitive(wat) {
    return wat === null || typeof wat !== 'object' && typeof wat !== 'function';
}
function isPlainObject(wat) {
    return isBuiltin(wat, 'Object');
}
function isEvent(wat) {
    return typeof Event !== 'undefined' && isInstanceOf(wat, Event);
}
function isElement(wat) {
    return typeof Element !== 'undefined' && isInstanceOf(wat, Element);
}
function isRegExp(wat) {
    return isBuiltin(wat, 'RegExp');
}
function isThenable(wat) {
    // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access
    return Boolean(wat && wat.then && typeof wat.then === 'function');
}
function isSyntheticEvent(wat) {
    return isPlainObject(wat) && 'nativeEvent' in wat && 'preventDefault' in wat && 'stopPropagation' in wat;
}
function isNaN(wat) {
    return typeof wat === 'number' && wat !== wat;
}
function isInstanceOf(wat, base) {
    try {
        return wat instanceof base;
    } catch (_e) {
        return false;
    }
}

},{"@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"2S1B7":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "CONSOLE_LEVELS", ()=>CONSOLE_LEVELS);
/**
 * Temporarily disable sentry console instrumentations.
 *
 * @param callback The function to run against the original `console` messages
 * @returns The results of the callback
 */ parcelHelpers.export(exports, "consoleSandbox", ()=>consoleSandbox);
parcelHelpers.export(exports, "logger", ()=>logger);
var _tslib = require("tslib");
var _flags = require("./flags");
var _global = require("./global");
// TODO: Implement different loggers for different environments
var global = (0, _global.getGlobalObject)();
/** Prefix for logging strings */ var PREFIX = 'Sentry Logger ';
var CONSOLE_LEVELS = [
    'debug',
    'info',
    'warn',
    'error',
    'log',
    'assert'
];
function consoleSandbox(callback) {
    var global = (0, _global.getGlobalObject)();
    if (!('console' in global)) return callback();
    var originalConsole = global.console;
    var wrappedLevels = {};
    // Restore all wrapped console methods
    CONSOLE_LEVELS.forEach(function(level) {
        // TODO(v7): Remove this check as it's only needed for Node 6
        var originalWrappedFunc = originalConsole[level] && originalConsole[level].__sentry_original__;
        if (level in global.console && originalWrappedFunc) {
            wrappedLevels[level] = originalConsole[level];
            originalConsole[level] = originalWrappedFunc;
        }
    });
    try {
        return callback();
    } finally{
        // Revert restoration to wrapped state
        Object.keys(wrappedLevels).forEach(function(level) {
            originalConsole[level] = wrappedLevels[level];
        });
    }
}
function makeLogger() {
    var enabled = false;
    var logger = {
        enable: function() {
            enabled = true;
        },
        disable: function() {
            enabled = false;
        }
    };
    if (0, _flags.IS_DEBUG_BUILD) CONSOLE_LEVELS.forEach(function(name) {
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        logger[name] = function() {
            var args = [];
            for(var _i = 0; _i < arguments.length; _i++)args[_i] = arguments[_i];
            if (enabled) consoleSandbox(function() {
                var _a;
                (_a = global.console)[name].apply(_a, (0, _tslib.__spread)([
                    PREFIX + "[" + name + "]:"
                ], args));
            });
        };
    });
    else CONSOLE_LEVELS.forEach(function(name) {
        logger[name] = function() {
            return undefined;
        };
    });
    return logger;
}
// Ensure we only have a single logger instance, even if multiple versions of @sentry/utils are being used
var logger;
if (0, _flags.IS_DEBUG_BUILD) logger = (0, _global.getGlobalSingleton)('logger', makeLogger);
else logger = makeLogger();

},{"tslib":"6MhhU","./flags":"8Otd7","./global":"kDC3g","@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"8Otd7":[function(require,module,exports,__globalThis) {
/*
 * This file defines flags and constants that can be modified during compile time in order to facilitate tree shaking
 * for users.
 *
 * Debug flags need to be declared in each package individually and must not be imported across package boundaries,
 * because some build tools have trouble tree-shaking imported guards.
 *
 * As a convention, we define debug flags in a `flags.ts` file in the root of a package's `src` folder.
 *
 * Debug flag files will contain "magic strings" like `__SENTRY_DEBUG__` that may get replaced with actual values during
 * our, or the user's build process. Take care when introducing new flags - they must not throw if they are not
 * replaced.
 */ /** Flag that is true for debug builds, false otherwise. */ var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "IS_DEBUG_BUILD", ()=>IS_DEBUG_BUILD);
var IS_DEBUG_BUILD = typeof __SENTRY_DEBUG__ === 'undefined' ? true : __SENTRY_DEBUG__;

},{"@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"kPTFm":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
/**
 * UUID4 generator
 *
 * @returns string Generated UUID4.
 */ parcelHelpers.export(exports, "uuid4", ()=>uuid4);
/**
 * Parses string form of URL into an object
 * // borrowed from https://tools.ietf.org/html/rfc3986#appendix-B
 * // intentionally using regex and not <a/> href parsing trick because React Native and other
 * // environments where DOM might not be available
 * @returns parsed URL object
 */ parcelHelpers.export(exports, "parseUrl", ()=>parseUrl);
/**
 * Extracts either message or type+value from an event that can be used for user-facing logs
 * @returns event's description
 */ parcelHelpers.export(exports, "getEventDescription", ()=>getEventDescription);
/**
 * Adds exception values, type and value to an synthetic Exception.
 * @param event The event to modify.
 * @param value Value of the exception.
 * @param type Type of the exception.
 * @hidden
 */ parcelHelpers.export(exports, "addExceptionTypeValue", ()=>addExceptionTypeValue);
/**
 * Adds exception mechanism data to a given event. Uses defaults if the second parameter is not passed.
 *
 * @param event The event to modify.
 * @param newMechanism Mechanism data to add to the event.
 * @hidden
 */ parcelHelpers.export(exports, "addExceptionMechanism", ()=>addExceptionMechanism);
/**
 * Parses input into a SemVer interface
 * @param input string representation of a semver version
 */ parcelHelpers.export(exports, "parseSemver", ()=>parseSemver);
/**
 * This function adds context (pre/post/line) lines to the provided frame
 *
 * @param lines string[] containing all lines
 * @param frame StackFrame that will be mutated
 * @param linesOfContext number of context lines we want to add pre/post
 */ parcelHelpers.export(exports, "addContextToFrame", ()=>addContextToFrame);
/**
 * Strip the query string and fragment off of a given URL or path (if present)
 *
 * @param urlPath Full URL or path, including possible query string and/or fragment
 * @returns URL or path without query string or fragment
 */ parcelHelpers.export(exports, "stripUrlQueryAndFragment", ()=>stripUrlQueryAndFragment);
/**
 * Checks whether or not we've already captured the given exception (note: not an identical exception - the very object
 * in question), and marks it captured if not.
 *
 * This is useful because it's possible for an error to get captured by more than one mechanism. After we intercept and
 * record an error, we rethrow it (assuming we've intercepted it before it's reached the top-level global handlers), so
 * that we don't interfere with whatever effects the error might have had were the SDK not there. At that point, because
 * the error has been rethrown, it's possible for it to bubble up to some other code we've instrumented. If it's not
 * caught after that, it will bubble all the way up to the global handlers (which of course we also instrument). This
 * function helps us ensure that even if we encounter the same error more than once, we only record it the first time we
 * see it.
 *
 * Note: It will ignore primitives (always return `false` and not mark them as seen), as properties can't be set on
 * them. {@link: Object.objectify} can be used on exceptions to convert any that are primitives into their equivalent
 * object wrapper forms so that this check will always work. However, because we need to flag the exact object which
 * will get rethrown, and because that rethrowing happens outside of the event processing pipeline, the objectification
 * must be done before the exception captured.
 *
 * @param A thrown exception to check or flag as having been seen
 * @returns `true` if the exception has already been captured, `false` if not (with the side effect of marking it seen)
 */ parcelHelpers.export(exports, "checkOrSetAlreadyCaught", ()=>checkOrSetAlreadyCaught);
var _tslib = require("tslib");
var _global = require("./global");
var _object = require("./object");
var _string = require("./string");
function uuid4() {
    var global = (0, _global.getGlobalObject)();
    var crypto = global.crypto || global.msCrypto;
    if (!(crypto === void 0) && crypto.getRandomValues) {
        // Use window.crypto API if available
        var arr = new Uint16Array(8);
        crypto.getRandomValues(arr);
        // set 4 in byte 7
        // eslint-disable-next-line no-bitwise
        arr[3] = arr[3] & 0xfff | 0x4000;
        // set 2 most significant bits of byte 9 to '10'
        // eslint-disable-next-line no-bitwise
        arr[4] = arr[4] & 0x3fff | 0x8000;
        var pad = function(num) {
            var v = num.toString(16);
            while(v.length < 4)v = "0" + v;
            return v;
        };
        return pad(arr[0]) + pad(arr[1]) + pad(arr[2]) + pad(arr[3]) + pad(arr[4]) + pad(arr[5]) + pad(arr[6]) + pad(arr[7]);
    }
    // http://stackoverflow.com/questions/105034/how-to-create-a-guid-uuid-in-javascript/2117523#2117523
    return 'xxxxxxxxxxxx4xxxyxxxxxxxxxxxxxxx'.replace(/[xy]/g, function(c) {
        // eslint-disable-next-line no-bitwise
        var r = Math.random() * 16 | 0;
        // eslint-disable-next-line no-bitwise
        var v = c === 'x' ? r : r & 0x3 | 0x8;
        return v.toString(16);
    });
}
function parseUrl(url) {
    if (!url) return {};
    var match = url.match(/^(([^:/?#]+):)?(\/\/([^/?#]*))?([^?#]*)(\?([^#]*))?(#(.*))?$/);
    if (!match) return {};
    // coerce to undefined values to empty string so we don't get 'undefined'
    var query = match[6] || '';
    var fragment = match[8] || '';
    return {
        host: match[4],
        path: match[5],
        protocol: match[2],
        relative: match[5] + query + fragment
    };
}
function getFirstException(event) {
    return event.exception && event.exception.values ? event.exception.values[0] : undefined;
}
function getEventDescription(event) {
    var message = event.message, eventId = event.event_id;
    if (message) return message;
    var firstException = getFirstException(event);
    if (firstException) {
        if (firstException.type && firstException.value) return firstException.type + ": " + firstException.value;
        return firstException.type || firstException.value || eventId || '<unknown>';
    }
    return eventId || '<unknown>';
}
function addExceptionTypeValue(event, value, type) {
    var exception = event.exception = event.exception || {};
    var values = exception.values = exception.values || [];
    var firstException = values[0] = values[0] || {};
    if (!firstException.value) firstException.value = value || '';
    if (!firstException.type) firstException.type = type || 'Error';
}
function addExceptionMechanism(event, newMechanism) {
    var firstException = getFirstException(event);
    if (!firstException) return;
    var defaultMechanism = {
        type: 'generic',
        handled: true
    };
    var currentMechanism = firstException.mechanism;
    firstException.mechanism = (0, _tslib.__assign)((0, _tslib.__assign)((0, _tslib.__assign)({}, defaultMechanism), currentMechanism), newMechanism);
    if (newMechanism && 'data' in newMechanism) {
        var mergedData = (0, _tslib.__assign)((0, _tslib.__assign)({}, currentMechanism && currentMechanism.data), newMechanism.data);
        firstException.mechanism.data = mergedData;
    }
}
// https://semver.org/#is-there-a-suggested-regular-expression-regex-to-check-a-semver-string
var SEMVER_REGEXP = /^(0|[1-9]\d*)\.(0|[1-9]\d*)\.(0|[1-9]\d*)(?:-((?:0|[1-9]\d*|\d*[a-zA-Z-][0-9a-zA-Z-]*)(?:\.(?:0|[1-9]\d*|\d*[a-zA-Z-][0-9a-zA-Z-]*))*))?(?:\+([0-9a-zA-Z-]+(?:\.[0-9a-zA-Z-]+)*))?$/;
function parseSemver(input) {
    var match = input.match(SEMVER_REGEXP) || [];
    var major = parseInt(match[1], 10);
    var minor = parseInt(match[2], 10);
    var patch = parseInt(match[3], 10);
    return {
        buildmetadata: match[5],
        major: isNaN(major) ? undefined : major,
        minor: isNaN(minor) ? undefined : minor,
        patch: isNaN(patch) ? undefined : patch,
        prerelease: match[4]
    };
}
function addContextToFrame(lines, frame, linesOfContext) {
    if (linesOfContext === void 0) linesOfContext = 5;
    var lineno = frame.lineno || 0;
    var maxLines = lines.length;
    var sourceLine = Math.max(Math.min(maxLines, lineno - 1), 0);
    frame.pre_context = lines.slice(Math.max(0, sourceLine - linesOfContext), sourceLine).map(function(line) {
        return (0, _string.snipLine)(line, 0);
    });
    frame.context_line = (0, _string.snipLine)(lines[Math.min(maxLines - 1, sourceLine)], frame.colno || 0);
    frame.post_context = lines.slice(Math.min(sourceLine + 1, maxLines), sourceLine + 1 + linesOfContext).map(function(line) {
        return (0, _string.snipLine)(line, 0);
    });
}
function stripUrlQueryAndFragment(urlPath) {
    // eslint-disable-next-line no-useless-escape
    return urlPath.split(/[\?#]/, 1)[0];
}
function checkOrSetAlreadyCaught(exception) {
    // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access
    if (exception && exception.__sentry_captured__) return true;
    try {
        // set it this way rather than by assignment so that it's not ennumerable and therefore isn't recorded by the
        // `ExtraErrorData` integration
        (0, _object.addNonEnumerableProperty)(exception, '__sentry_captured__', true);
    } catch (err) {
    // `exception` is a primitive, so we can't mark it seen
    }
    return false;
}

},{"tslib":"6MhhU","./global":"kDC3g","./object":"7CTrS","./string":"gSSx9","@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"7CTrS":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
/**
 * Replace a method in an object with a wrapped version of itself.
 *
 * @param source An object that contains a method to be wrapped.
 * @param name The name of the method to be wrapped.
 * @param replacementFactory A higher-order function that takes the original version of the given method and returns a
 * wrapped version. Note: The function returned by `replacementFactory` needs to be a non-arrow function, in order to
 * preserve the correct value of `this`, and the original method must be called using `origMethod.call(this, <other
 * args>)` or `origMethod.apply(this, [<other args>])` (rather than being called directly), again to preserve `this`.
 * @returns void
 */ parcelHelpers.export(exports, "fill", ()=>fill);
/**
 * Defines a non-enumerable property on the given object.
 *
 * @param obj The object on which to set the property
 * @param name The name of the property to be set
 * @param value The value to which to set the property
 */ parcelHelpers.export(exports, "addNonEnumerableProperty", ()=>addNonEnumerableProperty);
/**
 * Remembers the original function on the wrapped function and
 * patches up the prototype.
 *
 * @param wrapped the wrapper function
 * @param original the original function that gets wrapped
 */ parcelHelpers.export(exports, "markFunctionWrapped", ()=>markFunctionWrapped);
/**
 * This extracts the original function if available.  See
 * `markFunctionWrapped` for more information.
 *
 * @param func the function to unwrap
 * @returns the unwrapped version of the function if available.
 */ parcelHelpers.export(exports, "getOriginalFunction", ()=>getOriginalFunction);
/**
 * Encodes given object into url-friendly format
 *
 * @param object An object that contains serializable values
 * @returns string Encoded
 */ parcelHelpers.export(exports, "urlEncode", ()=>urlEncode);
/**
 * Transforms any object into an object literal with all its attributes
 * attached to it.
 *
 * @param value Initial source that we have to transform in order for it to be usable by the serializer
 */ parcelHelpers.export(exports, "convertToPlainObject", ()=>convertToPlainObject);
/**
 * Given any captured exception, extract its keys and create a sorted
 * and truncated list that will be used inside the event message.
 * eg. `Non-error exception captured with keys: foo, bar, baz`
 */ // eslint-disable-next-line @typescript-eslint/explicit-module-boundary-types
parcelHelpers.export(exports, "extractExceptionKeysForMessage", ()=>extractExceptionKeysForMessage);
/**
 * Given any object, return the new object with removed keys that value was `undefined`.
 * Works recursively on objects and arrays.
 */ parcelHelpers.export(exports, "dropUndefinedKeys", ()=>dropUndefinedKeys);
/**
 * Ensure that something is an object.
 *
 * Turns `undefined` and `null` into `String`s and all other primitives into instances of their respective wrapper
 * classes (String, Boolean, Number, etc.). Acts as the identity function on non-primitives.
 *
 * @param wat The subject of the objectification
 * @returns A version of `wat` which can safely be used with `Object` class methods
 */ parcelHelpers.export(exports, "objectify", ()=>objectify);
var _tslib = require("tslib");
var _browser = require("./browser");
var _is = require("./is");
var _string = require("./string");
function fill(source, name, replacementFactory) {
    if (!(name in source)) return;
    var original = source[name];
    var wrapped = replacementFactory(original);
    // Make sure it's a function first, as we need to attach an empty prototype for `defineProperties` to work
    // otherwise it'll throw "TypeError: Object.defineProperties called on non-object"
    if (typeof wrapped === 'function') try {
        markFunctionWrapped(wrapped, original);
    } catch (_Oo) {
    // This can throw if multiple fill happens on a global object like XMLHttpRequest
    // Fixes https://github.com/getsentry/sentry-javascript/issues/2043
    }
    source[name] = wrapped;
}
function addNonEnumerableProperty(obj, name, value) {
    Object.defineProperty(obj, name, {
        // enumerable: false, // the default, so we can save on bundle size by not explicitly setting it
        value: value,
        writable: true,
        configurable: true
    });
}
function markFunctionWrapped(wrapped, original) {
    var proto = original.prototype || {};
    wrapped.prototype = original.prototype = proto;
    addNonEnumerableProperty(wrapped, '__sentry_original__', original);
}
function getOriginalFunction(func) {
    return func.__sentry_original__;
}
function urlEncode(object) {
    return Object.keys(object).map(function(key) {
        return encodeURIComponent(key) + "=" + encodeURIComponent(object[key]);
    }).join('&');
}
function convertToPlainObject(value) {
    var newObj = value;
    if ((0, _is.isError)(value)) newObj = (0, _tslib.__assign)({
        message: value.message,
        name: value.name,
        stack: value.stack
    }, getOwnProperties(value));
    else if ((0, _is.isEvent)(value)) {
        var event_1 = value;
        newObj = (0, _tslib.__assign)({
            type: event_1.type,
            target: serializeEventTarget(event_1.target),
            currentTarget: serializeEventTarget(event_1.currentTarget)
        }, getOwnProperties(event_1));
        if (typeof CustomEvent !== 'undefined' && (0, _is.isInstanceOf)(value, CustomEvent)) newObj.detail = event_1.detail;
    }
    return newObj;
}
/** Creates a string representation of the target of an `Event` object */ function serializeEventTarget(target) {
    try {
        return (0, _is.isElement)(target) ? (0, _browser.htmlTreeAsString)(target) : Object.prototype.toString.call(target);
    } catch (_oO) {
        return '<unknown>';
    }
}
/** Filters out all but an object's own properties */ function getOwnProperties(obj) {
    var extractedProps = {};
    for(var property in obj)if (Object.prototype.hasOwnProperty.call(obj, property)) extractedProps[property] = obj[property];
    return extractedProps;
}
function extractExceptionKeysForMessage(exception, maxLength) {
    if (maxLength === void 0) maxLength = 40;
    var keys = Object.keys(convertToPlainObject(exception));
    keys.sort();
    if (!keys.length) return '[object has no keys]';
    if (keys[0].length >= maxLength) return (0, _string.truncate)(keys[0], maxLength);
    for(var includedKeys = keys.length; includedKeys > 0; includedKeys--){
        var serialized = keys.slice(0, includedKeys).join(', ');
        if (serialized.length > maxLength) continue;
        if (includedKeys === keys.length) return serialized;
        return (0, _string.truncate)(serialized, maxLength);
    }
    return '';
}
function dropUndefinedKeys(val) {
    var e_1, _a;
    if ((0, _is.isPlainObject)(val)) {
        var rv = {};
        try {
            for(var _b = (0, _tslib.__values)(Object.keys(val)), _c = _b.next(); !_c.done; _c = _b.next()){
                var key = _c.value;
                if (typeof val[key] !== 'undefined') rv[key] = dropUndefinedKeys(val[key]);
            }
        } catch (e_1_1) {
            e_1 = {
                error: e_1_1
            };
        } finally{
            try {
                if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
            } finally{
                if (e_1) throw e_1.error;
            }
        }
        return rv;
    }
    if (Array.isArray(val)) return val.map(dropUndefinedKeys);
    return val;
}
function objectify(wat) {
    var objectified;
    switch(true){
        case wat === undefined || wat === null:
            objectified = new String(wat);
            break;
        // Though symbols and bigints do have wrapper classes (`Symbol` and `BigInt`, respectively), for whatever reason
        // those classes don't have constructors which can be used with the `new` keyword. We therefore need to cast each as
        // an object in order to wrap it.
        case typeof wat === 'symbol' || typeof wat === 'bigint':
            objectified = Object(wat);
            break;
        // this will catch the remaining primitives: `String`, `Number`, and `Boolean`
        case (0, _is.isPrimitive)(wat):
            // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access
            objectified = new wat.constructor(wat);
            break;
        // by process of elimination, at this point we know that `wat` must already be an object
        default:
            objectified = wat;
            break;
    }
    return objectified;
}

},{"tslib":"6MhhU","./browser":"aAf8s","./is":"amUq0","./string":"gSSx9","@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"gSSx9":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
/**
 * Truncates given string to the maximum characters count
 *
 * @param str An object that contains serializable values
 * @param max Maximum number of characters in truncated string (0 = unlimited)
 * @returns string Encoded
 */ parcelHelpers.export(exports, "truncate", ()=>truncate);
/**
 * This is basically just `trim_line` from
 * https://github.com/getsentry/sentry/blob/master/src/sentry/lang/javascript/processor.py#L67
 *
 * @param str An object that contains serializable values
 * @param max Maximum number of characters in truncated string
 * @returns string Encoded
 */ parcelHelpers.export(exports, "snipLine", ()=>snipLine);
/**
 * Join values in array
 * @param input array of values to be joined together
 * @param delimiter string to be placed in-between values
 * @returns Joined values
 */ // eslint-disable-next-line @typescript-eslint/no-explicit-any
parcelHelpers.export(exports, "safeJoin", ()=>safeJoin);
/**
 * Checks if the value matches a regex or includes the string
 * @param value The string value to be checked against
 * @param pattern Either a regex or a string that must be contained in value
 */ parcelHelpers.export(exports, "isMatchingPattern", ()=>isMatchingPattern);
/**
 * Given a string, escape characters which have meaning in the regex grammar, such that the result is safe to feed to
 * `new RegExp()`.
 *
 * Based on https://github.com/sindresorhus/escape-string-regexp. Vendored to a) reduce the size by skipping the runtime
 * type-checking, and b) ensure it gets down-compiled for old versions of Node (the published package only supports Node
 * 12+).
 *
 * @param regexString The string to escape
 * @returns An version of the string with all special regex characters escaped
 */ parcelHelpers.export(exports, "escapeStringForRegex", ()=>escapeStringForRegex);
var _is = require("./is");
function truncate(str, max) {
    if (max === void 0) max = 0;
    if (typeof str !== 'string' || max === 0) return str;
    return str.length <= max ? str : str.substr(0, max) + "...";
}
function snipLine(line, colno) {
    var newLine = line;
    var lineLength = newLine.length;
    if (lineLength <= 150) return newLine;
    if (colno > lineLength) // eslint-disable-next-line no-param-reassign
    colno = lineLength;
    var start = Math.max(colno - 60, 0);
    if (start < 5) start = 0;
    var end = Math.min(start + 140, lineLength);
    if (end > lineLength - 5) end = lineLength;
    if (end === lineLength) start = Math.max(end - 140, 0);
    newLine = newLine.slice(start, end);
    if (start > 0) newLine = "'{snip} " + newLine;
    if (end < lineLength) newLine += ' {snip}';
    return newLine;
}
function safeJoin(input, delimiter) {
    if (!Array.isArray(input)) return '';
    var output = [];
    // eslint-disable-next-line @typescript-eslint/prefer-for-of
    for(var i = 0; i < input.length; i++){
        var value = input[i];
        try {
            output.push(String(value));
        } catch (e) {
            output.push('[value cannot be serialized]');
        }
    }
    return output.join(delimiter);
}
function isMatchingPattern(value, pattern) {
    if (!(0, _is.isString)(value)) return false;
    if ((0, _is.isRegExp)(pattern)) return pattern.test(value);
    if (typeof pattern === 'string') return value.indexOf(pattern) !== -1;
    return false;
}
function escapeStringForRegex(regexString) {
    // escape the hyphen separately so we can also replace it with a unicode literal hyphen, to avoid the problems
    // discussed in https://github.com/sindresorhus/escape-string-regexp/issues/20.
    return regexString.replace(/[|\\{}()[\]^$+*?.]/g, '\\$&').replace(/-/g, '\\x2d');
}

},{"./is":"amUq0","@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"485nF":[function(require,module,exports,__globalThis) {
/* eslint-disable @typescript-eslint/explicit-function-return-type */ /* eslint-disable @typescript-eslint/typedef */ /* eslint-disable @typescript-eslint/explicit-module-boundary-types */ /* eslint-disable @typescript-eslint/no-explicit-any */ var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
/**
 * Creates a resolved sync promise.
 *
 * @param value the value to resolve the promise with
 * @returns the resolved sync promise
 */ parcelHelpers.export(exports, "resolvedSyncPromise", ()=>resolvedSyncPromise);
/**
 * Creates a rejected sync promise.
 *
 * @param value the value to reject the promise with
 * @returns the rejected sync promise
 */ parcelHelpers.export(exports, "rejectedSyncPromise", ()=>rejectedSyncPromise);
parcelHelpers.export(exports, "SyncPromise", ()=>SyncPromise);
var _is = require("./is");
function resolvedSyncPromise(value) {
    return new SyncPromise(function(resolve) {
        resolve(value);
    });
}
function rejectedSyncPromise(reason) {
    return new SyncPromise(function(_, reject) {
        reject(reason);
    });
}
/**
 * Thenable class that behaves like a Promise and follows it's interface
 * but is not async internally
 */ var SyncPromise = /** @class */ function() {
    function SyncPromise(executor) {
        var _this = this;
        this._state = 0 /* PENDING */ ;
        this._handlers = [];
        /** JSDoc */ this._resolve = function(value) {
            _this._setResult(1 /* RESOLVED */ , value);
        };
        /** JSDoc */ this._reject = function(reason) {
            _this._setResult(2 /* REJECTED */ , reason);
        };
        /** JSDoc */ this._setResult = function(state, value) {
            if (_this._state !== 0 /* PENDING */ ) return;
            if ((0, _is.isThenable)(value)) {
                value.then(_this._resolve, _this._reject);
                return;
            }
            _this._state = state;
            _this._value = value;
            _this._executeHandlers();
        };
        /** JSDoc */ this._executeHandlers = function() {
            if (_this._state === 0 /* PENDING */ ) return;
            var cachedHandlers = _this._handlers.slice();
            _this._handlers = [];
            cachedHandlers.forEach(function(handler) {
                if (handler[0]) return;
                if (_this._state === 1 /* RESOLVED */ ) // eslint-disable-next-line @typescript-eslint/no-floating-promises
                handler[1](_this._value);
                if (_this._state === 2 /* REJECTED */ ) handler[2](_this._value);
                handler[0] = true;
            });
        };
        try {
            executor(this._resolve, this._reject);
        } catch (e) {
            this._reject(e);
        }
    }
    /** JSDoc */ SyncPromise.prototype.then = function(onfulfilled, onrejected) {
        var _this = this;
        return new SyncPromise(function(resolve, reject) {
            _this._handlers.push([
                false,
                function(result) {
                    if (!onfulfilled) // TODO: ¯\_(ツ)_/¯
                    // TODO: FIXME
                    resolve(result);
                    else try {
                        resolve(onfulfilled(result));
                    } catch (e) {
                        reject(e);
                    }
                },
                function(reason) {
                    if (!onrejected) reject(reason);
                    else try {
                        resolve(onrejected(reason));
                    } catch (e) {
                        reject(e);
                    }
                }
            ]);
            _this._executeHandlers();
        });
    };
    /** JSDoc */ SyncPromise.prototype.catch = function(onrejected) {
        return this.then(function(val) {
            return val;
        }, onrejected);
    };
    /** JSDoc */ SyncPromise.prototype.finally = function(onfinally) {
        var _this = this;
        return new SyncPromise(function(resolve, reject) {
            var val;
            var isRejected;
            return _this.then(function(value) {
                isRejected = false;
                val = value;
                if (onfinally) onfinally();
            }, function(reason) {
                isRejected = true;
                val = reason;
                if (onfinally) onfinally();
            }).then(function() {
                if (isRejected) {
                    reject(val);
                    return;
                }
                resolve(val);
            });
        });
    };
    return SyncPromise;
}();

},{"./is":"amUq0","@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"2qcFX":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "dateTimestampInSeconds", ()=>dateTimestampInSeconds);
parcelHelpers.export(exports, "timestampInSeconds", ()=>timestampInSeconds);
parcelHelpers.export(exports, "timestampWithMs", ()=>timestampWithMs);
parcelHelpers.export(exports, "usingPerformanceAPI", ()=>usingPerformanceAPI);
parcelHelpers.export(exports, "_browserPerformanceTimeOriginMode", ()=>_browserPerformanceTimeOriginMode);
parcelHelpers.export(exports, "browserPerformanceTimeOrigin", ()=>browserPerformanceTimeOrigin);
var _global = require("./global");
var _node = require("./node");
/**
 * A TimestampSource implementation for environments that do not support the Performance Web API natively.
 *
 * Note that this TimestampSource does not use a monotonic clock. A call to `nowSeconds` may return a timestamp earlier
 * than a previously returned value. We do not try to emulate a monotonic behavior in order to facilitate debugging. It
 * is more obvious to explain "why does my span have negative duration" than "why my spans have zero duration".
 */ var dateTimestampSource = {
    nowSeconds: function() {
        return Date.now() / 1000;
    }
};
/**
 * Returns a wrapper around the native Performance API browser implementation, or undefined for browsers that do not
 * support the API.
 *
 * Wrapping the native API works around differences in behavior from different browsers.
 */ function getBrowserPerformance() {
    var performance = (0, _global.getGlobalObject)().performance;
    if (!performance || !performance.now) return undefined;
    // Replace performance.timeOrigin with our own timeOrigin based on Date.now().
    //
    // This is a partial workaround for browsers reporting performance.timeOrigin such that performance.timeOrigin +
    // performance.now() gives a date arbitrarily in the past.
    //
    // Additionally, computing timeOrigin in this way fills the gap for browsers where performance.timeOrigin is
    // undefined.
    //
    // The assumption that performance.timeOrigin + performance.now() ~= Date.now() is flawed, but we depend on it to
    // interact with data coming out of performance entries.
    //
    // Note that despite recommendations against it in the spec, browsers implement the Performance API with a clock that
    // might stop when the computer is asleep (and perhaps under other circumstances). Such behavior causes
    // performance.timeOrigin + performance.now() to have an arbitrary skew over Date.now(). In laptop computers, we have
    // observed skews that can be as long as days, weeks or months.
    //
    // See https://github.com/getsentry/sentry-javascript/issues/2590.
    //
    // BUG: despite our best intentions, this workaround has its limitations. It mostly addresses timings of pageload
    // transactions, but ignores the skew built up over time that can aversely affect timestamps of navigation
    // transactions of long-lived web pages.
    var timeOrigin = Date.now() - performance.now();
    return {
        now: function() {
            return performance.now();
        },
        timeOrigin: timeOrigin
    };
}
/**
 * Returns the native Performance API implementation from Node.js. Returns undefined in old Node.js versions that don't
 * implement the API.
 */ function getNodePerformance() {
    try {
        var perfHooks = (0, _node.dynamicRequire)(module, 'perf_hooks');
        return perfHooks.performance;
    } catch (_) {
        return undefined;
    }
}
/**
 * The Performance API implementation for the current platform, if available.
 */ var platformPerformance = (0, _node.isNodeEnv)() ? getNodePerformance() : getBrowserPerformance();
var timestampSource = platformPerformance === undefined ? dateTimestampSource : {
    nowSeconds: function() {
        return (platformPerformance.timeOrigin + platformPerformance.now()) / 1000;
    }
};
var dateTimestampInSeconds = dateTimestampSource.nowSeconds.bind(dateTimestampSource);
var timestampInSeconds = timestampSource.nowSeconds.bind(timestampSource);
var timestampWithMs = timestampInSeconds;
var usingPerformanceAPI = platformPerformance !== undefined;
var _browserPerformanceTimeOriginMode;
var browserPerformanceTimeOrigin = function() {
    // Unfortunately browsers may report an inaccurate time origin data, through either performance.timeOrigin or
    // performance.timing.navigationStart, which results in poor results in performance data. We only treat time origin
    // data as reliable if they are within a reasonable threshold of the current time.
    var performance = (0, _global.getGlobalObject)().performance;
    if (!performance || !performance.now) {
        _browserPerformanceTimeOriginMode = 'none';
        return undefined;
    }
    var threshold = 3600000;
    var performanceNow = performance.now();
    var dateNow = Date.now();
    // if timeOrigin isn't available set delta to threshold so it isn't used
    var timeOriginDelta = performance.timeOrigin ? Math.abs(performance.timeOrigin + performanceNow - dateNow) : threshold;
    var timeOriginIsReliable = timeOriginDelta < threshold;
    // While performance.timing.navigationStart is deprecated in favor of performance.timeOrigin, performance.timeOrigin
    // is not as widely supported. Namely, performance.timeOrigin is undefined in Safari as of writing.
    // Also as of writing, performance.timing is not available in Web Workers in mainstream browsers, so it is not always
    // a valid fallback. In the absence of an initial time provided by the browser, fallback to the current time from the
    // Date API.
    // eslint-disable-next-line deprecation/deprecation
    var navigationStart = performance.timing && performance.timing.navigationStart;
    var hasNavigationStart = typeof navigationStart === 'number';
    // if navigationStart isn't available set delta to threshold so it isn't used
    var navigationStartDelta = hasNavigationStart ? Math.abs(navigationStart + performanceNow - dateNow) : threshold;
    var navigationStartIsReliable = navigationStartDelta < threshold;
    if (timeOriginIsReliable || navigationStartIsReliable) {
        // Use the more reliable time origin
        if (timeOriginDelta <= navigationStartDelta) {
            _browserPerformanceTimeOriginMode = 'timeOrigin';
            return performance.timeOrigin;
        } else {
            _browserPerformanceTimeOriginMode = 'navigationStart';
            return navigationStart;
        }
    }
    // Either both timeOrigin and navigationStart are skewed or neither is available, fallback to Date.
    _browserPerformanceTimeOriginMode = 'dateNow';
    return dateNow;
}();

},{"./global":"kDC3g","./node":"bzg7l","@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"j0xtB":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "Session", ()=>Session);
var _utils = require("@sentry/utils");
/**
 * @inheritdoc
 */ var Session = /** @class */ function() {
    function Session(context) {
        this.errors = 0;
        this.sid = (0, _utils.uuid4)();
        this.duration = 0;
        this.status = 'ok';
        this.init = true;
        this.ignoreDuration = false;
        // Both timestamp and started are in seconds since the UNIX epoch.
        var startingTime = (0, _utils.timestampInSeconds)();
        this.timestamp = startingTime;
        this.started = startingTime;
        if (context) this.update(context);
    }
    /** JSDoc */ // eslint-disable-next-line complexity
    Session.prototype.update = function(context) {
        if (context === void 0) context = {};
        if (context.user) {
            if (!this.ipAddress && context.user.ip_address) this.ipAddress = context.user.ip_address;
            if (!this.did && !context.did) this.did = context.user.id || context.user.email || context.user.username;
        }
        this.timestamp = context.timestamp || (0, _utils.timestampInSeconds)();
        if (context.ignoreDuration) this.ignoreDuration = context.ignoreDuration;
        if (context.sid) // Good enough uuid validation. — Kamil
        this.sid = context.sid.length === 32 ? context.sid : (0, _utils.uuid4)();
        if (context.init !== undefined) this.init = context.init;
        if (!this.did && context.did) this.did = "" + context.did;
        if (typeof context.started === 'number') this.started = context.started;
        if (this.ignoreDuration) this.duration = undefined;
        else if (typeof context.duration === 'number') this.duration = context.duration;
        else {
            var duration = this.timestamp - this.started;
            this.duration = duration >= 0 ? duration : 0;
        }
        if (context.release) this.release = context.release;
        if (context.environment) this.environment = context.environment;
        if (!this.ipAddress && context.ipAddress) this.ipAddress = context.ipAddress;
        if (!this.userAgent && context.userAgent) this.userAgent = context.userAgent;
        if (typeof context.errors === 'number') this.errors = context.errors;
        if (context.status) this.status = context.status;
    };
    /** JSDoc */ Session.prototype.close = function(status) {
        if (status) this.update({
            status: status
        });
        else if (this.status === 'ok') this.update({
            status: 'exited'
        });
        else this.update();
    };
    /** JSDoc */ Session.prototype.toJSON = function() {
        return (0, _utils.dropUndefinedKeys)({
            sid: "" + this.sid,
            init: this.init,
            // Make sure that sec is converted to ms for date constructor
            started: new Date(this.started * 1000).toISOString(),
            timestamp: new Date(this.timestamp * 1000).toISOString(),
            status: this.status,
            errors: this.errors,
            did: typeof this.did === 'number' || typeof this.did === 'string' ? "" + this.did : undefined,
            duration: this.duration,
            attrs: {
                release: this.release,
                environment: this.environment,
                ip_address: this.ipAddress,
                user_agent: this.userAgent
            }
        });
    };
    return Session;
}();

},{"@sentry/utils":"2okam","@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"bMEqP":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "API_VERSION", ()=>API_VERSION);
parcelHelpers.export(exports, "Hub", ()=>Hub);
/**
 * Returns the global shim registry.
 *
 * FIXME: This function is problematic, because despite always returning a valid Carrier,
 * it has an optional `__SENTRY__` property, which then in turn requires us to always perform an unnecessary check
 * at the call-site. We always access the carrier through this function, so we can guarantee that `__SENTRY__` is there.
 **/ parcelHelpers.export(exports, "getMainCarrier", ()=>getMainCarrier);
/**
 * Replaces the current main hub with the passed one on the global object
 *
 * @returns The old replaced hub
 */ parcelHelpers.export(exports, "makeMain", ()=>makeMain);
/**
 * Returns the default hub instance.
 *
 * If a hub is already registered in the global carrier but this module
 * contains a more recent version, it replaces the registered version.
 * Otherwise, the currently registered hub will be returned.
 */ parcelHelpers.export(exports, "getCurrentHub", ()=>getCurrentHub);
/**
 * Returns the active domain, if one exists
 * @deprecated No longer used; remove in v7
 * @returns The domain, or undefined if there is no active domain
 */ // eslint-disable-next-line deprecation/deprecation
parcelHelpers.export(exports, "getActiveDomain", ()=>getActiveDomain);
/**
 * This will create a new {@link Hub} and add to the passed object on
 * __SENTRY__.hub.
 * @param carrier object
 * @hidden
 */ parcelHelpers.export(exports, "getHubFromCarrier", ()=>getHubFromCarrier);
/**
 * This will set passed {@link Hub} on the passed object's __SENTRY__.hub attribute
 * @param carrier object
 * @param hub Hub
 * @returns A boolean indicating success or failure
 */ parcelHelpers.export(exports, "setHubOnCarrier", ()=>setHubOnCarrier);
var _tslib = require("tslib");
var _utils = require("@sentry/utils");
var _flags = require("./flags");
var _scope = require("./scope");
var _session = require("./session");
var API_VERSION = 4;
/**
 * Default maximum number of breadcrumbs added to an event. Can be overwritten
 * with {@link Options.maxBreadcrumbs}.
 */ var DEFAULT_BREADCRUMBS = 100;
/**
 * @inheritDoc
 */ var Hub = /** @class */ function() {
    /**
     * Creates a new instance of the hub, will push one {@link Layer} into the
     * internal stack on creation.
     *
     * @param client bound to the hub.
     * @param scope bound to the hub.
     * @param version number, higher number means higher priority.
     */ function Hub(client, scope, _version) {
        if (scope === void 0) scope = new (0, _scope.Scope)();
        if (_version === void 0) _version = API_VERSION;
        this._version = _version;
        /** Is a {@link Layer}[] containing the client and scope */ this._stack = [
            {}
        ];
        this.getStackTop().scope = scope;
        if (client) this.bindClient(client);
    }
    /**
     * @inheritDoc
     */ Hub.prototype.isOlderThan = function(version) {
        return this._version < version;
    };
    /**
     * @inheritDoc
     */ Hub.prototype.bindClient = function(client) {
        var top = this.getStackTop();
        top.client = client;
        if (client && client.setupIntegrations) client.setupIntegrations();
    };
    /**
     * @inheritDoc
     */ Hub.prototype.pushScope = function() {
        // We want to clone the content of prev scope
        var scope = (0, _scope.Scope).clone(this.getScope());
        this.getStack().push({
            client: this.getClient(),
            scope: scope
        });
        return scope;
    };
    /**
     * @inheritDoc
     */ Hub.prototype.popScope = function() {
        if (this.getStack().length <= 1) return false;
        return !!this.getStack().pop();
    };
    /**
     * @inheritDoc
     */ Hub.prototype.withScope = function(callback) {
        var scope = this.pushScope();
        try {
            callback(scope);
        } finally{
            this.popScope();
        }
    };
    /**
     * @inheritDoc
     */ Hub.prototype.getClient = function() {
        return this.getStackTop().client;
    };
    /** Returns the scope of the top stack. */ Hub.prototype.getScope = function() {
        return this.getStackTop().scope;
    };
    /** Returns the scope stack for domains or the process. */ Hub.prototype.getStack = function() {
        return this._stack;
    };
    /** Returns the topmost scope layer in the order domain > local > process. */ Hub.prototype.getStackTop = function() {
        return this._stack[this._stack.length - 1];
    };
    /**
     * @inheritDoc
     */ // eslint-disable-next-line @typescript-eslint/no-explicit-any, @typescript-eslint/explicit-module-boundary-types
    Hub.prototype.captureException = function(exception, hint) {
        var eventId = this._lastEventId = hint && hint.event_id ? hint.event_id : (0, _utils.uuid4)();
        var finalHint = hint;
        // If there's no explicit hint provided, mimic the same thing that would happen
        // in the minimal itself to create a consistent behavior.
        // We don't do this in the client, as it's the lowest level API, and doing this,
        // would prevent user from having full control over direct calls.
        if (!hint) {
            var syntheticException = void 0;
            try {
                throw new Error('Sentry syntheticException');
            } catch (exception) {
                syntheticException = exception;
            }
            finalHint = {
                originalException: exception,
                syntheticException: syntheticException
            };
        }
        this._invokeClient('captureException', exception, (0, _tslib.__assign)((0, _tslib.__assign)({}, finalHint), {
            event_id: eventId
        }));
        return eventId;
    };
    /**
     * @inheritDoc
     */ Hub.prototype.captureMessage = function(message, level, hint) {
        var eventId = this._lastEventId = hint && hint.event_id ? hint.event_id : (0, _utils.uuid4)();
        var finalHint = hint;
        // If there's no explicit hint provided, mimic the same thing that would happen
        // in the minimal itself to create a consistent behavior.
        // We don't do this in the client, as it's the lowest level API, and doing this,
        // would prevent user from having full control over direct calls.
        if (!hint) {
            var syntheticException = void 0;
            try {
                throw new Error(message);
            } catch (exception) {
                syntheticException = exception;
            }
            finalHint = {
                originalException: message,
                syntheticException: syntheticException
            };
        }
        this._invokeClient('captureMessage', message, level, (0, _tslib.__assign)((0, _tslib.__assign)({}, finalHint), {
            event_id: eventId
        }));
        return eventId;
    };
    /**
     * @inheritDoc
     */ Hub.prototype.captureEvent = function(event, hint) {
        var eventId = hint && hint.event_id ? hint.event_id : (0, _utils.uuid4)();
        if (event.type !== 'transaction') this._lastEventId = eventId;
        this._invokeClient('captureEvent', event, (0, _tslib.__assign)((0, _tslib.__assign)({}, hint), {
            event_id: eventId
        }));
        return eventId;
    };
    /**
     * @inheritDoc
     */ Hub.prototype.lastEventId = function() {
        return this._lastEventId;
    };
    /**
     * @inheritDoc
     */ Hub.prototype.addBreadcrumb = function(breadcrumb, hint) {
        var _a = this.getStackTop(), scope = _a.scope, client = _a.client;
        if (!scope || !client) return;
        // eslint-disable-next-line @typescript-eslint/unbound-method
        var _b = client.getOptions && client.getOptions() || {}, _c = _b.beforeBreadcrumb, beforeBreadcrumb = _c === void 0 ? null : _c, _d = _b.maxBreadcrumbs, maxBreadcrumbs = _d === void 0 ? DEFAULT_BREADCRUMBS : _d;
        if (maxBreadcrumbs <= 0) return;
        var timestamp = (0, _utils.dateTimestampInSeconds)();
        var mergedBreadcrumb = (0, _tslib.__assign)({
            timestamp: timestamp
        }, breadcrumb);
        var finalBreadcrumb = beforeBreadcrumb ? (0, _utils.consoleSandbox)(function() {
            return beforeBreadcrumb(mergedBreadcrumb, hint);
        }) : mergedBreadcrumb;
        if (finalBreadcrumb === null) return;
        scope.addBreadcrumb(finalBreadcrumb, maxBreadcrumbs);
    };
    /**
     * @inheritDoc
     */ Hub.prototype.setUser = function(user) {
        var scope = this.getScope();
        if (scope) scope.setUser(user);
    };
    /**
     * @inheritDoc
     */ Hub.prototype.setTags = function(tags) {
        var scope = this.getScope();
        if (scope) scope.setTags(tags);
    };
    /**
     * @inheritDoc
     */ Hub.prototype.setExtras = function(extras) {
        var scope = this.getScope();
        if (scope) scope.setExtras(extras);
    };
    /**
     * @inheritDoc
     */ Hub.prototype.setTag = function(key, value) {
        var scope = this.getScope();
        if (scope) scope.setTag(key, value);
    };
    /**
     * @inheritDoc
     */ Hub.prototype.setExtra = function(key, extra) {
        var scope = this.getScope();
        if (scope) scope.setExtra(key, extra);
    };
    /**
     * @inheritDoc
     */ // eslint-disable-next-line @typescript-eslint/no-explicit-any
    Hub.prototype.setContext = function(name, context) {
        var scope = this.getScope();
        if (scope) scope.setContext(name, context);
    };
    /**
     * @inheritDoc
     */ Hub.prototype.configureScope = function(callback) {
        var _a = this.getStackTop(), scope = _a.scope, client = _a.client;
        if (scope && client) callback(scope);
    };
    /**
     * @inheritDoc
     */ Hub.prototype.run = function(callback) {
        var oldHub = makeMain(this);
        try {
            callback(this);
        } finally{
            makeMain(oldHub);
        }
    };
    /**
     * @inheritDoc
     */ Hub.prototype.getIntegration = function(integration) {
        var client = this.getClient();
        if (!client) return null;
        try {
            return client.getIntegration(integration);
        } catch (_oO) {
            (0, _flags.IS_DEBUG_BUILD) && (0, _utils.logger).warn("Cannot retrieve integration " + integration.id + " from the current Hub");
            return null;
        }
    };
    /**
     * @inheritDoc
     */ Hub.prototype.startSpan = function(context) {
        return this._callExtensionMethod('startSpan', context);
    };
    /**
     * @inheritDoc
     */ Hub.prototype.startTransaction = function(context, customSamplingContext) {
        return this._callExtensionMethod('startTransaction', context, customSamplingContext);
    };
    /**
     * @inheritDoc
     */ Hub.prototype.traceHeaders = function() {
        return this._callExtensionMethod('traceHeaders');
    };
    /**
     * @inheritDoc
     */ Hub.prototype.captureSession = function(endSession) {
        if (endSession === void 0) endSession = false;
        // both send the update and pull the session from the scope
        if (endSession) return this.endSession();
        // only send the update
        this._sendSessionUpdate();
    };
    /**
     * @inheritDoc
     */ Hub.prototype.endSession = function() {
        var layer = this.getStackTop();
        var scope = layer && layer.scope;
        var session = scope && scope.getSession();
        if (session) session.close();
        this._sendSessionUpdate();
        // the session is over; take it off of the scope
        if (scope) scope.setSession();
    };
    /**
     * @inheritDoc
     */ Hub.prototype.startSession = function(context) {
        var _a = this.getStackTop(), scope = _a.scope, client = _a.client;
        var _b = client && client.getOptions() || {}, release = _b.release, environment = _b.environment;
        // Will fetch userAgent if called from browser sdk
        var global = (0, _utils.getGlobalObject)();
        var userAgent = (global.navigator || {}).userAgent;
        var session = new (0, _session.Session)((0, _tslib.__assign)((0, _tslib.__assign)((0, _tslib.__assign)({
            release: release,
            environment: environment
        }, scope && {
            user: scope.getUser()
        }), userAgent && {
            userAgent: userAgent
        }), context));
        if (scope) {
            // End existing session if there's one
            var currentSession = scope.getSession && scope.getSession();
            if (currentSession && currentSession.status === 'ok') currentSession.update({
                status: 'exited'
            });
            this.endSession();
            // Afterwards we set the new session on the scope
            scope.setSession(session);
        }
        return session;
    };
    /**
     * Sends the current Session on the scope
     */ Hub.prototype._sendSessionUpdate = function() {
        var _a = this.getStackTop(), scope = _a.scope, client = _a.client;
        if (!scope) return;
        var session = scope.getSession && scope.getSession();
        if (session) {
            if (client && client.captureSession) client.captureSession(session);
        }
    };
    /**
     * Internal helper function to call a method on the top client if it exists.
     *
     * @param method The method to call on the client.
     * @param args Arguments to pass to the client function.
     */ // eslint-disable-next-line @typescript-eslint/no-explicit-any
    Hub.prototype._invokeClient = function(method) {
        var _a;
        var args = [];
        for(var _i = 1; _i < arguments.length; _i++)args[_i - 1] = arguments[_i];
        var _b = this.getStackTop(), scope = _b.scope, client = _b.client;
        if (client && client[method]) // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access, @typescript-eslint/no-explicit-any
        (_a = client)[method].apply(_a, (0, _tslib.__spread)(args, [
            scope
        ]));
    };
    /**
     * Calls global extension method and binding current instance to the function call
     */ // @ts-ignore Function lacks ending return statement and return type does not include 'undefined'. ts(2366)
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    Hub.prototype._callExtensionMethod = function(method) {
        var args = [];
        for(var _i = 1; _i < arguments.length; _i++)args[_i - 1] = arguments[_i];
        var carrier = getMainCarrier();
        var sentry = carrier.__SENTRY__;
        if (sentry && sentry.extensions && typeof sentry.extensions[method] === 'function') return sentry.extensions[method].apply(this, args);
        (0, _flags.IS_DEBUG_BUILD) && (0, _utils.logger).warn("Extension method " + method + " couldn't be found, doing nothing.");
    };
    return Hub;
}();
function getMainCarrier() {
    var carrier = (0, _utils.getGlobalObject)();
    carrier.__SENTRY__ = carrier.__SENTRY__ || {
        extensions: {},
        hub: undefined
    };
    return carrier;
}
function makeMain(hub) {
    var registry = getMainCarrier();
    var oldHub = getHubFromCarrier(registry);
    setHubOnCarrier(registry, hub);
    return oldHub;
}
function getCurrentHub() {
    // Get main carrier (global for every environment)
    var registry = getMainCarrier();
    // If there's no hub, or its an old API, assign a new one
    if (!hasHubOnCarrier(registry) || getHubFromCarrier(registry).isOlderThan(API_VERSION)) setHubOnCarrier(registry, new Hub());
    // Prefer domains over global if they are there (applicable only to Node environment)
    if ((0, _utils.isNodeEnv)()) return getHubFromActiveDomain(registry);
    // Return hub that lives on a global object
    return getHubFromCarrier(registry);
}
function getActiveDomain() {
    (0, _flags.IS_DEBUG_BUILD) && (0, _utils.logger).warn('Function `getActiveDomain` is deprecated and will be removed in a future version.');
    var sentry = getMainCarrier().__SENTRY__;
    return sentry && sentry.extensions && sentry.extensions.domain && sentry.extensions.domain.active;
}
/**
 * Try to read the hub from an active domain, and fallback to the registry if one doesn't exist
 * @returns discovered hub
 */ function getHubFromActiveDomain(registry) {
    try {
        var sentry = getMainCarrier().__SENTRY__;
        var activeDomain = sentry && sentry.extensions && sentry.extensions.domain && sentry.extensions.domain.active;
        // If there's no active domain, just return global hub
        if (!activeDomain) return getHubFromCarrier(registry);
        // If there's no hub on current domain, or it's an old API, assign a new one
        if (!hasHubOnCarrier(activeDomain) || getHubFromCarrier(activeDomain).isOlderThan(API_VERSION)) {
            var registryHubTopStack = getHubFromCarrier(registry).getStackTop();
            setHubOnCarrier(activeDomain, new Hub(registryHubTopStack.client, (0, _scope.Scope).clone(registryHubTopStack.scope)));
        }
        // Return hub that lives on a domain
        return getHubFromCarrier(activeDomain);
    } catch (_Oo) {
        // Return hub that lives on a global object
        return getHubFromCarrier(registry);
    }
}
/**
 * This will tell whether a carrier has a hub on it or not
 * @param carrier object
 */ function hasHubOnCarrier(carrier) {
    return !!(carrier && carrier.__SENTRY__ && carrier.__SENTRY__.hub);
}
function getHubFromCarrier(carrier) {
    return (0, _utils.getGlobalSingleton)('hub', function() {
        return new Hub();
    }, carrier);
}
function setHubOnCarrier(carrier, hub) {
    if (!carrier) return false;
    var __SENTRY__ = carrier.__SENTRY__ = carrier.__SENTRY__ || {};
    __SENTRY__.hub = hub;
    return true;
}

},{"tslib":"6MhhU","@sentry/utils":"2okam","./flags":"3tp2g","./scope":"9h4AU","./session":"j0xtB","@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"3tp2g":[function(require,module,exports,__globalThis) {
/*
 * This file defines flags and constants that can be modified during compile time in order to facilitate tree shaking
 * for users.
 *
 * Debug flags need to be declared in each package individually and must not be imported across package boundaries,
 * because some build tools have trouble tree-shaking imported guards.
 *
 * As a convention, we define debug flags in a `flags.ts` file in the root of a package's `src` folder.
 *
 * Debug flag files will contain "magic strings" like `__SENTRY_DEBUG__` that may get replaced with actual values during
 * our, or the user's build process. Take care when introducing new flags - they must not throw if they are not
 * replaced.
 */ /** Flag that is true for debug builds, false otherwise. */ var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "IS_DEBUG_BUILD", ()=>IS_DEBUG_BUILD);
var IS_DEBUG_BUILD = typeof __SENTRY_DEBUG__ === 'undefined' ? true : __SENTRY_DEBUG__;

},{"@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"2DOw8":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "API", ()=>API);
/** Initializes API Details */ parcelHelpers.export(exports, "initAPIDetails", ()=>initAPIDetails);
/**
 * Returns the store endpoint URL with auth in the query string.
 *
 * Sending auth as part of the query string and not as custom HTTP headers avoids CORS preflight requests.
 */ parcelHelpers.export(exports, "getStoreEndpointWithUrlEncodedAuth", ()=>getStoreEndpointWithUrlEncodedAuth);
/**
 * Returns the envelope endpoint URL with auth in the query string.
 *
 * Sending auth as part of the query string and not as custom HTTP headers avoids CORS preflight requests.
 */ parcelHelpers.export(exports, "getEnvelopeEndpointWithUrlEncodedAuth", ()=>getEnvelopeEndpointWithUrlEncodedAuth);
/**
 * Returns an object that can be used in request headers.
 * This is needed for node and the old /store endpoint in sentry
 */ parcelHelpers.export(exports, "getRequestHeaders", ()=>getRequestHeaders);
/** Returns the url to the report dialog endpoint. */ parcelHelpers.export(exports, "getReportDialogEndpoint", ()=>getReportDialogEndpoint);
var _utils = require("@sentry/utils");
var SENTRY_API_VERSION = '7';
/**
 * Helper class to provide urls, headers and metadata that can be used to form
 * different types of requests to Sentry endpoints.
 * Supports both envelopes and regular event requests.
 *
 * @deprecated Please use APIDetails
 **/ var API = /** @class */ function() {
    /** Create a new instance of API */ function API(dsn, metadata, tunnel) {
        if (metadata === void 0) metadata = {};
        this.dsn = dsn;
        this._dsnObject = (0, _utils.makeDsn)(dsn);
        this.metadata = metadata;
        this._tunnel = tunnel;
    }
    /** Returns the Dsn object. */ API.prototype.getDsn = function() {
        return this._dsnObject;
    };
    /** Does this transport force envelopes? */ API.prototype.forceEnvelope = function() {
        return !!this._tunnel;
    };
    /** Returns the prefix to construct Sentry ingestion API endpoints. */ API.prototype.getBaseApiEndpoint = function() {
        return getBaseApiEndpoint(this._dsnObject);
    };
    /** Returns the store endpoint URL. */ API.prototype.getStoreEndpoint = function() {
        return getStoreEndpoint(this._dsnObject);
    };
    /**
     * Returns the store endpoint URL with auth in the query string.
     *
     * Sending auth as part of the query string and not as custom HTTP headers avoids CORS preflight requests.
     */ API.prototype.getStoreEndpointWithUrlEncodedAuth = function() {
        return getStoreEndpointWithUrlEncodedAuth(this._dsnObject);
    };
    /**
     * Returns the envelope endpoint URL with auth in the query string.
     *
     * Sending auth as part of the query string and not as custom HTTP headers avoids CORS preflight requests.
     */ API.prototype.getEnvelopeEndpointWithUrlEncodedAuth = function() {
        return getEnvelopeEndpointWithUrlEncodedAuth(this._dsnObject, this._tunnel);
    };
    return API;
}();
function initAPIDetails(dsn, metadata, tunnel) {
    return {
        initDsn: dsn,
        metadata: metadata || {},
        dsn: (0, _utils.makeDsn)(dsn),
        tunnel: tunnel
    };
}
/** Returns the prefix to construct Sentry ingestion API endpoints. */ function getBaseApiEndpoint(dsn) {
    var protocol = dsn.protocol ? dsn.protocol + ":" : '';
    var port = dsn.port ? ":" + dsn.port : '';
    return protocol + "//" + dsn.host + port + (dsn.path ? "/" + dsn.path : '') + "/api/";
}
/** Returns the ingest API endpoint for target. */ function _getIngestEndpoint(dsn, target) {
    return "" + getBaseApiEndpoint(dsn) + dsn.projectId + "/" + target + "/";
}
/** Returns a URL-encoded string with auth config suitable for a query string. */ function _encodedAuth(dsn) {
    return (0, _utils.urlEncode)({
        // We send only the minimum set of required information. See
        // https://github.com/getsentry/sentry-javascript/issues/2572.
        sentry_key: dsn.publicKey,
        sentry_version: SENTRY_API_VERSION
    });
}
/** Returns the store endpoint URL. */ function getStoreEndpoint(dsn) {
    return _getIngestEndpoint(dsn, 'store');
}
function getStoreEndpointWithUrlEncodedAuth(dsn) {
    return getStoreEndpoint(dsn) + "?" + _encodedAuth(dsn);
}
/** Returns the envelope endpoint URL. */ function _getEnvelopeEndpoint(dsn) {
    return _getIngestEndpoint(dsn, 'envelope');
}
function getEnvelopeEndpointWithUrlEncodedAuth(dsn, tunnel) {
    return tunnel ? tunnel : _getEnvelopeEndpoint(dsn) + "?" + _encodedAuth(dsn);
}
function getRequestHeaders(dsn, clientName, clientVersion) {
    // CHANGE THIS to use metadata but keep clientName and clientVersion compatible
    var header = [
        "Sentry sentry_version=" + SENTRY_API_VERSION
    ];
    header.push("sentry_client=" + clientName + "/" + clientVersion);
    header.push("sentry_key=" + dsn.publicKey);
    if (dsn.pass) header.push("sentry_secret=" + dsn.pass);
    return {
        'Content-Type': 'application/json',
        'X-Sentry-Auth': header.join(', ')
    };
}
function getReportDialogEndpoint(dsnLike, dialogOptions) {
    var dsn = (0, _utils.makeDsn)(dsnLike);
    var endpoint = getBaseApiEndpoint(dsn) + "embed/error-page/";
    var encodedOptions = "dsn=" + (0, _utils.dsnToString)(dsn);
    for(var key in dialogOptions){
        if (key === 'dsn') continue;
        if (key === 'user') {
            if (!dialogOptions.user) continue;
            if (dialogOptions.user.name) encodedOptions += "&name=" + encodeURIComponent(dialogOptions.user.name);
            if (dialogOptions.user.email) encodedOptions += "&email=" + encodeURIComponent(dialogOptions.user.email);
        } else encodedOptions += "&" + encodeURIComponent(key) + "=" + encodeURIComponent(dialogOptions[key]);
    }
    return endpoint + "?" + encodedOptions;
}

},{"@sentry/utils":"5wUYP","@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"5wUYP":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _async = require("./async");
parcelHelpers.exportAll(_async, exports);
var _browser = require("./browser");
parcelHelpers.exportAll(_browser, exports);
var _dsn = require("./dsn");
parcelHelpers.exportAll(_dsn, exports);
var _enums = require("./enums");
parcelHelpers.exportAll(_enums, exports);
var _error = require("./error");
parcelHelpers.exportAll(_error, exports);
var _global = require("./global");
parcelHelpers.exportAll(_global, exports);
var _instrument = require("./instrument");
parcelHelpers.exportAll(_instrument, exports);
var _is = require("./is");
parcelHelpers.exportAll(_is, exports);
var _logger = require("./logger");
parcelHelpers.exportAll(_logger, exports);
var _memo = require("./memo");
parcelHelpers.exportAll(_memo, exports);
var _misc = require("./misc");
parcelHelpers.exportAll(_misc, exports);
var _node = require("./node");
parcelHelpers.exportAll(_node, exports);
var _normalize = require("./normalize");
parcelHelpers.exportAll(_normalize, exports);
var _object = require("./object");
parcelHelpers.exportAll(_object, exports);
var _path = require("./path");
parcelHelpers.exportAll(_path, exports);
var _promisebuffer = require("./promisebuffer");
parcelHelpers.exportAll(_promisebuffer, exports);
var _severity = require("./severity");
parcelHelpers.exportAll(_severity, exports);
var _stacktrace = require("./stacktrace");
parcelHelpers.exportAll(_stacktrace, exports);
var _status = require("./status");
parcelHelpers.exportAll(_status, exports);
var _string = require("./string");
parcelHelpers.exportAll(_string, exports);
var _supports = require("./supports");
parcelHelpers.exportAll(_supports, exports);
var _syncpromise = require("./syncpromise");
parcelHelpers.exportAll(_syncpromise, exports);
var _time = require("./time");
parcelHelpers.exportAll(_time, exports);
var _tracing = require("./tracing");
parcelHelpers.exportAll(_tracing, exports);
var _env = require("./env");
parcelHelpers.exportAll(_env, exports);
var _envelope = require("./envelope");
parcelHelpers.exportAll(_envelope, exports);
var _clientreport = require("./clientreport");
parcelHelpers.exportAll(_clientreport, exports);
var _ratelimit = require("./ratelimit");
parcelHelpers.exportAll(_ratelimit, exports);

},{"./async":"3YTbo","./browser":"WNuVF","./dsn":"flOVt","./enums":false,"./error":"kax1I","./global":"PLhjt","./instrument":"c2nwY","./is":"kahuF","./logger":"3Rtdk","./memo":false,"./misc":"7MqaN","./node":"9VyDn","./normalize":"6pGFq","./object":"ikcFZ","./path":false,"./promisebuffer":"cR9yn","./severity":"fMTZ5","./stacktrace":"jXmbb","./status":"iWz6Y","./string":"ePLUW","./supports":"l5khV","./syncpromise":"lMIRb","./time":"70NNx","./tracing":false,"./env":false,"./envelope":"Op7jK","./clientreport":"cH2mT","./ratelimit":"8Wuev","@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"3YTbo":[function(require,module,exports,__globalThis) {
/**
 * Consumes the promise and logs the error when it rejects.
 * @param promise A promise to forget.
 */ // eslint-disable-next-line @typescript-eslint/no-explicit-any
var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "forget", ()=>forget);
function forget(promise) {
    promise.then(null, function(e) {
        // TODO: Use a better logging mechanism
        // eslint-disable-next-line no-console
        console.error(e);
    });
}

},{"@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"WNuVF":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
/**
 * Given a child DOM element, returns a query-selector statement describing that
 * and its ancestors
 * e.g. [HTMLElement] => body > div > input#foo.btn[name=baz]
 * @returns generated DOM path
 */ parcelHelpers.export(exports, "htmlTreeAsString", ()=>htmlTreeAsString);
/**
 * A safe form of location.href
 */ parcelHelpers.export(exports, "getLocationHref", ()=>getLocationHref);
var _global = require("./global");
var _is = require("./is");
function htmlTreeAsString(elem, keyAttrs) {
    // try/catch both:
    // - accessing event.target (see getsentry/raven-js#838, #768)
    // - `htmlTreeAsString` because it's complex, and just accessing the DOM incorrectly
    // - can throw an exception in some circumstances.
    try {
        var currentElem = elem;
        var MAX_TRAVERSE_HEIGHT = 5;
        var MAX_OUTPUT_LEN = 80;
        var out = [];
        var height = 0;
        var len = 0;
        var separator = ' > ';
        var sepLength = separator.length;
        var nextStr = void 0;
        // eslint-disable-next-line no-plusplus
        while(currentElem && height++ < MAX_TRAVERSE_HEIGHT){
            nextStr = _htmlElementAsString(currentElem, keyAttrs);
            // bail out if
            // - nextStr is the 'html' element
            // - the length of the string that would be created exceeds MAX_OUTPUT_LEN
            //   (ignore this limit if we are on the first iteration)
            if (nextStr === 'html' || height > 1 && len + out.length * sepLength + nextStr.length >= MAX_OUTPUT_LEN) break;
            out.push(nextStr);
            len += nextStr.length;
            currentElem = currentElem.parentNode;
        }
        return out.reverse().join(separator);
    } catch (_oO) {
        return '<unknown>';
    }
}
/**
 * Returns a simple, query-selector representation of a DOM element
 * e.g. [HTMLElement] => input#foo.btn[name=baz]
 * @returns generated DOM path
 */ function _htmlElementAsString(el, keyAttrs) {
    var elem = el;
    var out = [];
    var className;
    var classes;
    var key;
    var attr;
    var i;
    if (!elem || !elem.tagName) return '';
    out.push(elem.tagName.toLowerCase());
    // Pairs of attribute keys defined in `serializeAttribute` and their values on element.
    var keyAttrPairs = keyAttrs && keyAttrs.length ? keyAttrs.filter(function(keyAttr) {
        return elem.getAttribute(keyAttr);
    }).map(function(keyAttr) {
        return [
            keyAttr,
            elem.getAttribute(keyAttr)
        ];
    }) : null;
    if (keyAttrPairs && keyAttrPairs.length) keyAttrPairs.forEach(function(keyAttrPair) {
        out.push("[" + keyAttrPair[0] + "=\"" + keyAttrPair[1] + "\"]");
    });
    else {
        if (elem.id) out.push("#" + elem.id);
        // eslint-disable-next-line prefer-const
        className = elem.className;
        if (className && (0, _is.isString)(className)) {
            classes = className.split(/\s+/);
            for(i = 0; i < classes.length; i++)out.push("." + classes[i]);
        }
    }
    var allowedAttrs = [
        'type',
        'name',
        'title',
        'alt'
    ];
    for(i = 0; i < allowedAttrs.length; i++){
        key = allowedAttrs[i];
        attr = elem.getAttribute(key);
        if (attr) out.push("[" + key + "=\"" + attr + "\"]");
    }
    return out.join('');
}
function getLocationHref() {
    var global = (0, _global.getGlobalObject)();
    try {
        return global.document.location.href;
    } catch (oO) {
        return '';
    }
}

},{"./global":"PLhjt","./is":"kahuF","@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"PLhjt":[function(require,module,exports,__globalThis) {
/**
 * NOTE: In order to avoid circular dependencies, if you add a function to this module and it needs to print something,
 * you must either a) use `console.log` rather than the logger, or b) put your function elsewhere.
 */ var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
/**
 * Safely get global scope object
 *
 * @returns Global scope object
 */ parcelHelpers.export(exports, "getGlobalObject", ()=>getGlobalObject);
/**
 * Returns a global singleton contained in the global `__SENTRY__` object.
 *
 * If the singleton doesn't already exist in `__SENTRY__`, it will be created using the given factory
 * function and added to the `__SENTRY__` object.
 *
 * @param name name of the global singleton on __SENTRY__
 * @param creator creator Factory function to create the singleton if it doesn't already exist on `__SENTRY__`
 * @param obj (Optional) The global object on which to look for `__SENTRY__`, if not `getGlobalObject`'s return value
 * @returns the singleton
 */ parcelHelpers.export(exports, "getGlobalSingleton", ()=>getGlobalSingleton);
var _node = require("./node");
var global = arguments[3];
var fallbackGlobalObject = {};
function getGlobalObject() {
    return (0, _node.isNodeEnv)() ? global : typeof window !== 'undefined' // eslint-disable-line no-restricted-globals
     ? window // eslint-disable-line no-restricted-globals
     : typeof self !== 'undefined' ? self : fallbackGlobalObject;
}
function getGlobalSingleton(name, creator, obj) {
    var global = obj || getGlobalObject();
    var __SENTRY__ = global.__SENTRY__ = global.__SENTRY__ || {};
    var singleton = __SENTRY__[name] || (__SENTRY__[name] = creator());
    return singleton;
}

},{"./node":"9VyDn","@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"9VyDn":[function(require,module,exports,__globalThis) {
/**
 * NOTE: In order to avoid circular dependencies, if you add a function to this module and it needs to print something,
 * you must either a) use `console.log` rather than the logger, or b) put your function elsewhere.
 */ var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
/**
 * Checks whether we're in the Node.js or Browser environment
 *
 * @returns Answer to given question
 */ parcelHelpers.export(exports, "isNodeEnv", ()=>isNodeEnv);
/**
 * Requires a module which is protected against bundler minification.
 *
 * @param request The module path to resolve
 */ // eslint-disable-next-line @typescript-eslint/explicit-module-boundary-types, @typescript-eslint/no-explicit-any
parcelHelpers.export(exports, "dynamicRequire", ()=>dynamicRequire);
/**
 * Helper for dynamically loading module that should work with linked dependencies.
 * The problem is that we _should_ be using `require(require.resolve(moduleName, { paths: [cwd()] }))`
 * However it's _not possible_ to do that with Webpack, as it has to know all the dependencies during
 * build time. `require.resolve` is also not available in any other way, so we cannot create,
 * a fake helper like we do with `dynamicRequire`.
 *
 * We always prefer to use local package, thus the value is not returned early from each `try/catch` block.
 * That is to mimic the behavior of `require.resolve` exactly.
 *
 * @param moduleName module name to require
 * @returns possibly required module
 */ parcelHelpers.export(exports, "loadModule", ()=>loadModule);
var _env = require("./env");
var process = require("c8f539c7cf938176");
function isNodeEnv() {
    // explicitly check for browser bundles as those can be optimized statically
    // by terser/rollup.
    return !(0, _env.isBrowserBundle)() && Object.prototype.toString.call(typeof process !== 'undefined' ? process : 0) === '[object process]';
}
function dynamicRequire(mod, request) {
    // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access
    return mod.require(request);
}
function loadModule(moduleName) {
    var mod;
    try {
        mod = dynamicRequire(module, moduleName);
    } catch (e) {
    // no-empty
    }
    try {
        var cwd = dynamicRequire(module, 'process').cwd;
        mod = dynamicRequire(module, cwd() + "/node_modules/" + moduleName);
    } catch (e) {
    // no-empty
    }
    return mod;
}

},{"c8f539c7cf938176":"gNLf3","./env":"aRDbs","@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"aRDbs":[function(require,module,exports,__globalThis) {
/*
 * This module exists for optimizations in the build process through rollup and terser.  We define some global
 * constants, which can be overridden during build. By guarding certain pieces of code with functions that return these
 * constants, we can control whether or not they appear in the final bundle. (Any code guarded by a false condition will
 * never run, and will hence be dropped during treeshaking.) The two primary uses for this are stripping out calls to
 * `logger` and preventing node-related code from appearing in browser bundles.
 *
 * Attention:
 * This file should not be used to define constants/flags that are intended to be used for tree-shaking conducted by
 * users. These fags should live in their respective packages, as we identified user tooling (specifically webpack)
 * having issues tree-shaking these constants across package boundaries.
 * An example for this is the __SENTRY_DEBUG__ constant. It is declared in each package individually because we want
 * users to be able to shake away expressions that it guards.
 */ /**
 * Figures out if we're building a browser bundle.
 *
 * @returns true if this is a browser bundle build.
 */ var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "isBrowserBundle", ()=>isBrowserBundle);
function isBrowserBundle() {
    return typeof __SENTRY_BROWSER_BUNDLE__ !== 'undefined' && !!__SENTRY_BROWSER_BUNDLE__;
}

},{"@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"kahuF":[function(require,module,exports,__globalThis) {
/* eslint-disable @typescript-eslint/no-explicit-any */ /* eslint-disable @typescript-eslint/explicit-module-boundary-types */ // eslint-disable-next-line @typescript-eslint/unbound-method
var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
/**
 * Checks whether given value's type is one of a few Error or Error-like
 * {@link isError}.
 *
 * @param wat A value to be checked.
 * @returns A boolean representing the result.
 */ parcelHelpers.export(exports, "isError", ()=>isError);
/**
 * Checks whether given value's type is ErrorEvent
 * {@link isErrorEvent}.
 *
 * @param wat A value to be checked.
 * @returns A boolean representing the result.
 */ parcelHelpers.export(exports, "isErrorEvent", ()=>isErrorEvent);
/**
 * Checks whether given value's type is DOMError
 * {@link isDOMError}.
 *
 * @param wat A value to be checked.
 * @returns A boolean representing the result.
 */ parcelHelpers.export(exports, "isDOMError", ()=>isDOMError);
/**
 * Checks whether given value's type is DOMException
 * {@link isDOMException}.
 *
 * @param wat A value to be checked.
 * @returns A boolean representing the result.
 */ parcelHelpers.export(exports, "isDOMException", ()=>isDOMException);
/**
 * Checks whether given value's type is a string
 * {@link isString}.
 *
 * @param wat A value to be checked.
 * @returns A boolean representing the result.
 */ parcelHelpers.export(exports, "isString", ()=>isString);
/**
 * Checks whether given value is a primitive (undefined, null, number, boolean, string, bigint, symbol)
 * {@link isPrimitive}.
 *
 * @param wat A value to be checked.
 * @returns A boolean representing the result.
 */ parcelHelpers.export(exports, "isPrimitive", ()=>isPrimitive);
/**
 * Checks whether given value's type is an object literal
 * {@link isPlainObject}.
 *
 * @param wat A value to be checked.
 * @returns A boolean representing the result.
 */ parcelHelpers.export(exports, "isPlainObject", ()=>isPlainObject);
/**
 * Checks whether given value's type is an Event instance
 * {@link isEvent}.
 *
 * @param wat A value to be checked.
 * @returns A boolean representing the result.
 */ parcelHelpers.export(exports, "isEvent", ()=>isEvent);
/**
 * Checks whether given value's type is an Element instance
 * {@link isElement}.
 *
 * @param wat A value to be checked.
 * @returns A boolean representing the result.
 */ parcelHelpers.export(exports, "isElement", ()=>isElement);
/**
 * Checks whether given value's type is an regexp
 * {@link isRegExp}.
 *
 * @param wat A value to be checked.
 * @returns A boolean representing the result.
 */ parcelHelpers.export(exports, "isRegExp", ()=>isRegExp);
/**
 * Checks whether given value has a then function.
 * @param wat A value to be checked.
 */ parcelHelpers.export(exports, "isThenable", ()=>isThenable);
/**
 * Checks whether given value's type is a SyntheticEvent
 * {@link isSyntheticEvent}.
 *
 * @param wat A value to be checked.
 * @returns A boolean representing the result.
 */ parcelHelpers.export(exports, "isSyntheticEvent", ()=>isSyntheticEvent);
/**
 * Checks whether given value is NaN
 * {@link isNaN}.
 *
 * @param wat A value to be checked.
 * @returns A boolean representing the result.
 */ parcelHelpers.export(exports, "isNaN", ()=>isNaN);
/**
 * Checks whether given value's type is an instance of provided constructor.
 * {@link isInstanceOf}.
 *
 * @param wat A value to be checked.
 * @param base A constructor to be used in a check.
 * @returns A boolean representing the result.
 */ parcelHelpers.export(exports, "isInstanceOf", ()=>isInstanceOf);
var objectToString = Object.prototype.toString;
function isError(wat) {
    switch(objectToString.call(wat)){
        case '[object Error]':
        case '[object Exception]':
        case '[object DOMException]':
            return true;
        default:
            return isInstanceOf(wat, Error);
    }
}
function isBuiltin(wat, ty) {
    return objectToString.call(wat) === "[object " + ty + "]";
}
function isErrorEvent(wat) {
    return isBuiltin(wat, 'ErrorEvent');
}
function isDOMError(wat) {
    return isBuiltin(wat, 'DOMError');
}
function isDOMException(wat) {
    return isBuiltin(wat, 'DOMException');
}
function isString(wat) {
    return isBuiltin(wat, 'String');
}
function isPrimitive(wat) {
    return wat === null || typeof wat !== 'object' && typeof wat !== 'function';
}
function isPlainObject(wat) {
    return isBuiltin(wat, 'Object');
}
function isEvent(wat) {
    return typeof Event !== 'undefined' && isInstanceOf(wat, Event);
}
function isElement(wat) {
    return typeof Element !== 'undefined' && isInstanceOf(wat, Element);
}
function isRegExp(wat) {
    return isBuiltin(wat, 'RegExp');
}
function isThenable(wat) {
    // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access
    return Boolean(wat && wat.then && typeof wat.then === 'function');
}
function isSyntheticEvent(wat) {
    return isPlainObject(wat) && 'nativeEvent' in wat && 'preventDefault' in wat && 'stopPropagation' in wat;
}
function isNaN(wat) {
    return typeof wat === 'number' && wat !== wat;
}
function isInstanceOf(wat, base) {
    try {
        return wat instanceof base;
    } catch (_e) {
        return false;
    }
}

},{"@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"flOVt":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
/**
 * Renders the string representation of this Dsn.
 *
 * By default, this will render the public representation without the password
 * component. To get the deprecated private representation, set `withPassword`
 * to true.
 *
 * @param withPassword When set to true, the password will be included.
 */ parcelHelpers.export(exports, "dsnToString", ()=>dsnToString);
/** The Sentry Dsn, identifying a Sentry instance and project. */ parcelHelpers.export(exports, "makeDsn", ()=>makeDsn);
var _tslib = require("tslib");
var _error = require("./error");
var _flags = require("./flags");
/** Regular expression used to parse a Dsn. */ var DSN_REGEX = /^(?:(\w+):)\/\/(?:(\w+)(?::(\w+))?@)([\w.-]+)(?::(\d+))?\/(.+)/;
function isValidProtocol(protocol) {
    return protocol === 'http' || protocol === 'https';
}
function dsnToString(dsn, withPassword) {
    if (withPassword === void 0) withPassword = false;
    var host = dsn.host, path = dsn.path, pass = dsn.pass, port = dsn.port, projectId = dsn.projectId, protocol = dsn.protocol, publicKey = dsn.publicKey;
    return protocol + "://" + publicKey + (withPassword && pass ? ":" + pass : '') + ("@" + host + (port ? ":" + port : '') + "/" + (path ? path + "/" : path) + projectId);
}
function dsnFromString(str) {
    var match = DSN_REGEX.exec(str);
    if (!match) throw new (0, _error.SentryError)("Invalid Sentry Dsn: " + str);
    var _a = (0, _tslib.__read)(match.slice(1), 6), protocol = _a[0], publicKey = _a[1], _b = _a[2], pass = _b === void 0 ? '' : _b, host = _a[3], _c = _a[4], port = _c === void 0 ? '' : _c, lastPath = _a[5];
    var path = '';
    var projectId = lastPath;
    var split = projectId.split('/');
    if (split.length > 1) {
        path = split.slice(0, -1).join('/');
        projectId = split.pop();
    }
    if (projectId) {
        var projectMatch = projectId.match(/^\d+/);
        if (projectMatch) projectId = projectMatch[0];
    }
    return dsnFromComponents({
        host: host,
        pass: pass,
        path: path,
        projectId: projectId,
        port: port,
        protocol: protocol,
        publicKey: publicKey
    });
}
function dsnFromComponents(components) {
    // TODO this is for backwards compatibility, and can be removed in a future version
    if ('user' in components && !('publicKey' in components)) components.publicKey = components.user;
    return {
        user: components.publicKey || '',
        protocol: components.protocol,
        publicKey: components.publicKey || '',
        pass: components.pass || '',
        host: components.host,
        port: components.port || '',
        path: components.path || '',
        projectId: components.projectId
    };
}
function validateDsn(dsn) {
    if (!(0, _flags.IS_DEBUG_BUILD)) return;
    var port = dsn.port, projectId = dsn.projectId, protocol = dsn.protocol;
    var requiredComponents = [
        'protocol',
        'publicKey',
        'host',
        'projectId'
    ];
    requiredComponents.forEach(function(component) {
        if (!dsn[component]) throw new (0, _error.SentryError)("Invalid Sentry Dsn: " + component + " missing");
    });
    if (!projectId.match(/^\d+$/)) throw new (0, _error.SentryError)("Invalid Sentry Dsn: Invalid projectId " + projectId);
    if (!isValidProtocol(protocol)) throw new (0, _error.SentryError)("Invalid Sentry Dsn: Invalid protocol " + protocol);
    if (port && isNaN(parseInt(port, 10))) throw new (0, _error.SentryError)("Invalid Sentry Dsn: Invalid port " + port);
    return true;
}
function makeDsn(from) {
    var components = typeof from === 'string' ? dsnFromString(from) : dsnFromComponents(from);
    validateDsn(components);
    return components;
}

},{"tslib":"6MhhU","./error":"kax1I","./flags":"XrQpC","@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"kax1I":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "SentryError", ()=>SentryError);
var _tslib = require("tslib");
var _polyfill = require("./polyfill");
/** An error emitted by Sentry SDKs and related utilities. */ var SentryError = /** @class */ function(_super) {
    (0, _tslib.__extends)(SentryError, _super);
    function SentryError(message) {
        var _newTarget = this.constructor;
        var _this = _super.call(this, message) || this;
        _this.message = message;
        _this.name = _newTarget.prototype.constructor.name;
        (0, _polyfill.setPrototypeOf)(_this, _newTarget.prototype);
        return _this;
    }
    return SentryError;
}(Error);

},{"tslib":"6MhhU","./polyfill":"l711D","@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"l711D":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "setPrototypeOf", ()=>setPrototypeOf);
var setPrototypeOf = Object.setPrototypeOf || (({
    __proto__: []
}) instanceof Array ? setProtoOf : mixinProperties);
/**
 * setPrototypeOf polyfill using __proto__
 */ // eslint-disable-next-line @typescript-eslint/ban-types
function setProtoOf(obj, proto) {
    // @ts-ignore __proto__ does not exist on obj
    obj.__proto__ = proto;
    return obj;
}
/**
 * setPrototypeOf polyfill using mixin
 */ // eslint-disable-next-line @typescript-eslint/ban-types
function mixinProperties(obj, proto) {
    for(var prop in proto)if (!Object.prototype.hasOwnProperty.call(obj, prop)) // @ts-ignore typescript complains about indexing so we remove
    obj[prop] = proto[prop];
    return obj;
}

},{"@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"XrQpC":[function(require,module,exports,__globalThis) {
/*
 * This file defines flags and constants that can be modified during compile time in order to facilitate tree shaking
 * for users.
 *
 * Debug flags need to be declared in each package individually and must not be imported across package boundaries,
 * because some build tools have trouble tree-shaking imported guards.
 *
 * As a convention, we define debug flags in a `flags.ts` file in the root of a package's `src` folder.
 *
 * Debug flag files will contain "magic strings" like `__SENTRY_DEBUG__` that may get replaced with actual values during
 * our, or the user's build process. Take care when introducing new flags - they must not throw if they are not
 * replaced.
 */ /** Flag that is true for debug builds, false otherwise. */ var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "IS_DEBUG_BUILD", ()=>IS_DEBUG_BUILD);
var IS_DEBUG_BUILD = typeof __SENTRY_DEBUG__ === 'undefined' ? true : __SENTRY_DEBUG__;

},{"@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"9e2MQ":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "SeverityLevels", ()=>SeverityLevels);
var SeverityLevels = [
    'fatal',
    'error',
    'warning',
    'log',
    'info',
    'debug',
    'critical'
];

},{"@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"c2nwY":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
/**
 * Add handler that will be called when given type of instrumentation triggers.
 * Use at your own risk, this might break without changelog notice, only used internally.
 * @hidden
 */ parcelHelpers.export(exports, "addInstrumentationHandler", ()=>addInstrumentationHandler);
var _tslib = require("tslib");
var _flags = require("./flags");
var _global = require("./global");
var _is = require("./is");
var _logger = require("./logger");
var _object = require("./object");
var _stacktrace = require("./stacktrace");
var _supports = require("./supports");
var global = (0, _global.getGlobalObject)();
/**
 * Instrument native APIs to call handlers that can be used to create breadcrumbs, APM spans etc.
 *  - Console API
 *  - Fetch API
 *  - XHR API
 *  - History API
 *  - DOM API (click/typing)
 *  - Error API
 *  - UnhandledRejection API
 */ var handlers = {};
var instrumented = {};
/** Instruments given API */ function instrument(type) {
    if (instrumented[type]) return;
    instrumented[type] = true;
    switch(type){
        case 'console':
            instrumentConsole();
            break;
        case 'dom':
            instrumentDOM();
            break;
        case 'xhr':
            instrumentXHR();
            break;
        case 'fetch':
            instrumentFetch();
            break;
        case 'history':
            instrumentHistory();
            break;
        case 'error':
            instrumentError();
            break;
        case 'unhandledrejection':
            instrumentUnhandledRejection();
            break;
        default:
            (0, _flags.IS_DEBUG_BUILD) && (0, _logger.logger).warn('unknown instrumentation type:', type);
            return;
    }
}
function addInstrumentationHandler(type, callback) {
    handlers[type] = handlers[type] || [];
    handlers[type].push(callback);
    instrument(type);
}
/** JSDoc */ function triggerHandlers(type, data) {
    var e_1, _a;
    if (!type || !handlers[type]) return;
    try {
        for(var _b = (0, _tslib.__values)(handlers[type] || []), _c = _b.next(); !_c.done; _c = _b.next()){
            var handler = _c.value;
            try {
                handler(data);
            } catch (e) {
                (0, _flags.IS_DEBUG_BUILD) && (0, _logger.logger).error("Error while triggering instrumentation handler.\nType: " + type + "\nName: " + (0, _stacktrace.getFunctionName)(handler) + "\nError:", e);
            }
        }
    } catch (e_1_1) {
        e_1 = {
            error: e_1_1
        };
    } finally{
        try {
            if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
        } finally{
            if (e_1) throw e_1.error;
        }
    }
}
/** JSDoc */ function instrumentConsole() {
    if (!('console' in global)) return;
    (0, _logger.CONSOLE_LEVELS).forEach(function(level) {
        if (!(level in global.console)) return;
        (0, _object.fill)(global.console, level, function(originalConsoleMethod) {
            return function() {
                var args = [];
                for(var _i = 0; _i < arguments.length; _i++)args[_i] = arguments[_i];
                triggerHandlers('console', {
                    args: args,
                    level: level
                });
                // this fails for some browsers. :(
                if (originalConsoleMethod) originalConsoleMethod.apply(global.console, args);
            };
        });
    });
}
/** JSDoc */ function instrumentFetch() {
    if (!(0, _supports.supportsNativeFetch)()) return;
    (0, _object.fill)(global, 'fetch', function(originalFetch) {
        return function() {
            var args = [];
            for(var _i = 0; _i < arguments.length; _i++)args[_i] = arguments[_i];
            var handlerData = {
                args: args,
                fetchData: {
                    method: getFetchMethod(args),
                    url: getFetchUrl(args)
                },
                startTimestamp: Date.now()
            };
            triggerHandlers('fetch', (0, _tslib.__assign)({}, handlerData));
            // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access
            return originalFetch.apply(global, args).then(function(response) {
                triggerHandlers('fetch', (0, _tslib.__assign)((0, _tslib.__assign)({}, handlerData), {
                    endTimestamp: Date.now(),
                    response: response
                }));
                return response;
            }, function(error) {
                triggerHandlers('fetch', (0, _tslib.__assign)((0, _tslib.__assign)({}, handlerData), {
                    endTimestamp: Date.now(),
                    error: error
                }));
                // NOTE: If you are a Sentry user, and you are seeing this stack frame,
                //       it means the sentry.javascript SDK caught an error invoking your application code.
                //       This is expected behavior and NOT indicative of a bug with sentry.javascript.
                throw error;
            });
        };
    });
}
/* eslint-disable @typescript-eslint/no-unsafe-member-access */ /** Extract `method` from fetch call arguments */ function getFetchMethod(fetchArgs) {
    if (fetchArgs === void 0) fetchArgs = [];
    if ('Request' in global && (0, _is.isInstanceOf)(fetchArgs[0], Request) && fetchArgs[0].method) return String(fetchArgs[0].method).toUpperCase();
    if (fetchArgs[1] && fetchArgs[1].method) return String(fetchArgs[1].method).toUpperCase();
    return 'GET';
}
/** Extract `url` from fetch call arguments */ function getFetchUrl(fetchArgs) {
    if (fetchArgs === void 0) fetchArgs = [];
    if (typeof fetchArgs[0] === 'string') return fetchArgs[0];
    if ('Request' in global && (0, _is.isInstanceOf)(fetchArgs[0], Request)) return fetchArgs[0].url;
    return String(fetchArgs[0]);
}
/* eslint-enable @typescript-eslint/no-unsafe-member-access */ /** JSDoc */ function instrumentXHR() {
    if (!('XMLHttpRequest' in global)) return;
    var xhrproto = XMLHttpRequest.prototype;
    (0, _object.fill)(xhrproto, 'open', function(originalOpen) {
        return function() {
            var args = [];
            for(var _i = 0; _i < arguments.length; _i++)args[_i] = arguments[_i];
            // eslint-disable-next-line @typescript-eslint/no-this-alias
            var xhr = this;
            var url = args[1];
            var xhrInfo = xhr.__sentry_xhr__ = {
                // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access
                method: (0, _is.isString)(args[0]) ? args[0].toUpperCase() : args[0],
                url: args[1]
            };
            // if Sentry key appears in URL, don't capture it as a request
            // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access
            if ((0, _is.isString)(url) && xhrInfo.method === 'POST' && url.match(/sentry_key/)) xhr.__sentry_own_request__ = true;
            var onreadystatechangeHandler = function() {
                if (xhr.readyState === 4) {
                    try {
                        // touching statusCode in some platforms throws
                        // an exception
                        xhrInfo.status_code = xhr.status;
                    } catch (e) {
                    /* do nothing */ }
                    triggerHandlers('xhr', {
                        args: args,
                        endTimestamp: Date.now(),
                        startTimestamp: Date.now(),
                        xhr: xhr
                    });
                }
            };
            if ('onreadystatechange' in xhr && typeof xhr.onreadystatechange === 'function') (0, _object.fill)(xhr, 'onreadystatechange', function(original) {
                return function() {
                    var readyStateArgs = [];
                    for(var _i = 0; _i < arguments.length; _i++)readyStateArgs[_i] = arguments[_i];
                    onreadystatechangeHandler();
                    return original.apply(xhr, readyStateArgs);
                };
            });
            else xhr.addEventListener('readystatechange', onreadystatechangeHandler);
            return originalOpen.apply(xhr, args);
        };
    });
    (0, _object.fill)(xhrproto, 'send', function(originalSend) {
        return function() {
            var args = [];
            for(var _i = 0; _i < arguments.length; _i++)args[_i] = arguments[_i];
            if (this.__sentry_xhr__ && args[0] !== undefined) this.__sentry_xhr__.body = args[0];
            triggerHandlers('xhr', {
                args: args,
                startTimestamp: Date.now(),
                xhr: this
            });
            return originalSend.apply(this, args);
        };
    });
}
var lastHref;
/** JSDoc */ function instrumentHistory() {
    if (!(0, _supports.supportsHistory)()) return;
    var oldOnPopState = global.onpopstate;
    global.onpopstate = function() {
        var args = [];
        for(var _i = 0; _i < arguments.length; _i++)args[_i] = arguments[_i];
        var to = global.location.href;
        // keep track of the current URL state, as we always receive only the updated state
        var from = lastHref;
        lastHref = to;
        triggerHandlers('history', {
            from: from,
            to: to
        });
        if (oldOnPopState) // Apparently this can throw in Firefox when incorrectly implemented plugin is installed.
        // https://github.com/getsentry/sentry-javascript/issues/3344
        // https://github.com/bugsnag/bugsnag-js/issues/469
        try {
            return oldOnPopState.apply(this, args);
        } catch (_oO) {
        // no-empty
        }
    };
    /** @hidden */ function historyReplacementFunction(originalHistoryFunction) {
        return function() {
            var args = [];
            for(var _i = 0; _i < arguments.length; _i++)args[_i] = arguments[_i];
            var url = args.length > 2 ? args[2] : undefined;
            if (url) {
                // coerce to string (this is what pushState does)
                var from = lastHref;
                var to = String(url);
                // keep track of the current URL state, as we always receive only the updated state
                lastHref = to;
                triggerHandlers('history', {
                    from: from,
                    to: to
                });
            }
            return originalHistoryFunction.apply(this, args);
        };
    }
    (0, _object.fill)(global.history, 'pushState', historyReplacementFunction);
    (0, _object.fill)(global.history, 'replaceState', historyReplacementFunction);
}
var debounceDuration = 1000;
var debounceTimerID;
var lastCapturedEvent;
/**
 * Decide whether the current event should finish the debounce of previously captured one.
 * @param previous previously captured event
 * @param current event to be captured
 */ function shouldShortcircuitPreviousDebounce(previous, current) {
    // If there was no previous event, it should always be swapped for the new one.
    if (!previous) return true;
    // If both events have different type, then user definitely performed two separate actions. e.g. click + keypress.
    if (previous.type !== current.type) return true;
    try {
        // If both events have the same type, it's still possible that actions were performed on different targets.
        // e.g. 2 clicks on different buttons.
        if (previous.target !== current.target) return true;
    } catch (e) {
    // just accessing `target` property can throw an exception in some rare circumstances
    // see: https://github.com/getsentry/sentry-javascript/issues/838
    }
    // If both events have the same type _and_ same `target` (an element which triggered an event, _not necessarily_
    // to which an event listener was attached), we treat them as the same action, as we want to capture
    // only one breadcrumb. e.g. multiple clicks on the same button, or typing inside a user input box.
    return false;
}
/**
 * Decide whether an event should be captured.
 * @param event event to be captured
 */ function shouldSkipDOMEvent(event) {
    // We are only interested in filtering `keypress` events for now.
    if (event.type !== 'keypress') return false;
    try {
        var target = event.target;
        if (!target || !target.tagName) return true;
        // Only consider keypress events on actual input elements. This will disregard keypresses targeting body
        // e.g.tabbing through elements, hotkeys, etc.
        if (target.tagName === 'INPUT' || target.tagName === 'TEXTAREA' || target.isContentEditable) return false;
    } catch (e) {
    // just accessing `target` property can throw an exception in some rare circumstances
    // see: https://github.com/getsentry/sentry-javascript/issues/838
    }
    return true;
}
/**
 * Wraps addEventListener to capture UI breadcrumbs
 * @param handler function that will be triggered
 * @param globalListener indicates whether event was captured by the global event listener
 * @returns wrapped breadcrumb events handler
 * @hidden
 */ function makeDOMEventHandler(handler, globalListener) {
    if (globalListener === void 0) globalListener = false;
    return function(event) {
        // It's possible this handler might trigger multiple times for the same
        // event (e.g. event propagation through node ancestors).
        // Ignore if we've already captured that event.
        if (!event || lastCapturedEvent === event) return;
        // We always want to skip _some_ events.
        if (shouldSkipDOMEvent(event)) return;
        var name = event.type === 'keypress' ? 'input' : event.type;
        // If there is no debounce timer, it means that we can safely capture the new event and store it for future comparisons.
        if (debounceTimerID === undefined) {
            handler({
                event: event,
                name: name,
                global: globalListener
            });
            lastCapturedEvent = event;
        } else if (shouldShortcircuitPreviousDebounce(lastCapturedEvent, event)) {
            handler({
                event: event,
                name: name,
                global: globalListener
            });
            lastCapturedEvent = event;
        }
        // Start a new debounce timer that will prevent us from capturing multiple events that should be grouped together.
        clearTimeout(debounceTimerID);
        debounceTimerID = global.setTimeout(function() {
            debounceTimerID = undefined;
        }, debounceDuration);
    };
}
/** JSDoc */ function instrumentDOM() {
    if (!('document' in global)) return;
    // Make it so that any click or keypress that is unhandled / bubbled up all the way to the document triggers our dom
    // handlers. (Normally we have only one, which captures a breadcrumb for each click or keypress.) Do this before
    // we instrument `addEventListener` so that we don't end up attaching this handler twice.
    var triggerDOMHandler = triggerHandlers.bind(null, 'dom');
    var globalDOMEventHandler = makeDOMEventHandler(triggerDOMHandler, true);
    global.document.addEventListener('click', globalDOMEventHandler, false);
    global.document.addEventListener('keypress', globalDOMEventHandler, false);
    // After hooking into click and keypress events bubbled up to `document`, we also hook into user-handled
    // clicks & keypresses, by adding an event listener of our own to any element to which they add a listener. That
    // way, whenever one of their handlers is triggered, ours will be, too. (This is needed because their handler
    // could potentially prevent the event from bubbling up to our global listeners. This way, our handler are still
    // guaranteed to fire at least once.)
    [
        'EventTarget',
        'Node'
    ].forEach(function(target) {
        // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access
        var proto = global[target] && global[target].prototype;
        // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access, no-prototype-builtins
        if (!proto || !proto.hasOwnProperty || !proto.hasOwnProperty('addEventListener')) return;
        (0, _object.fill)(proto, 'addEventListener', function(originalAddEventListener) {
            return function(type, listener, options) {
                if (type === 'click' || type == 'keypress') try {
                    var el = this;
                    var handlers_1 = el.__sentry_instrumentation_handlers__ = el.__sentry_instrumentation_handlers__ || {};
                    var handlerForType = handlers_1[type] = handlers_1[type] || {
                        refCount: 0
                    };
                    if (!handlerForType.handler) {
                        var handler = makeDOMEventHandler(triggerDOMHandler);
                        handlerForType.handler = handler;
                        originalAddEventListener.call(this, type, handler, options);
                    }
                    handlerForType.refCount += 1;
                } catch (e) {
                // Accessing dom properties is always fragile.
                // Also allows us to skip `addEventListenrs` calls with no proper `this` context.
                }
                return originalAddEventListener.call(this, type, listener, options);
            };
        });
        (0, _object.fill)(proto, 'removeEventListener', function(originalRemoveEventListener) {
            return function(type, listener, options) {
                if (type === 'click' || type == 'keypress') try {
                    var el = this;
                    var handlers_2 = el.__sentry_instrumentation_handlers__ || {};
                    var handlerForType = handlers_2[type];
                    if (handlerForType) {
                        handlerForType.refCount -= 1;
                        // If there are no longer any custom handlers of the current type on this element, we can remove ours, too.
                        if (handlerForType.refCount <= 0) {
                            originalRemoveEventListener.call(this, type, handlerForType.handler, options);
                            handlerForType.handler = undefined;
                            delete handlers_2[type]; // eslint-disable-line @typescript-eslint/no-dynamic-delete
                        }
                        // If there are no longer any custom handlers of any type on this element, cleanup everything.
                        if (Object.keys(handlers_2).length === 0) delete el.__sentry_instrumentation_handlers__;
                    }
                } catch (e) {
                // Accessing dom properties is always fragile.
                // Also allows us to skip `addEventListenrs` calls with no proper `this` context.
                }
                return originalRemoveEventListener.call(this, type, listener, options);
            };
        });
    });
}
var _oldOnErrorHandler = null;
/** JSDoc */ function instrumentError() {
    _oldOnErrorHandler = global.onerror;
    global.onerror = function(msg, url, line, column, error) {
        triggerHandlers('error', {
            column: column,
            error: error,
            line: line,
            msg: msg,
            url: url
        });
        if (_oldOnErrorHandler) // eslint-disable-next-line prefer-rest-params
        return _oldOnErrorHandler.apply(this, arguments);
        return false;
    };
}
var _oldOnUnhandledRejectionHandler = null;
/** JSDoc */ function instrumentUnhandledRejection() {
    _oldOnUnhandledRejectionHandler = global.onunhandledrejection;
    global.onunhandledrejection = function(e) {
        triggerHandlers('unhandledrejection', e);
        if (_oldOnUnhandledRejectionHandler) // eslint-disable-next-line prefer-rest-params
        return _oldOnUnhandledRejectionHandler.apply(this, arguments);
        return true;
    };
}

},{"tslib":"6MhhU","./flags":"XrQpC","./global":"PLhjt","./is":"kahuF","./logger":"3Rtdk","./object":"ikcFZ","./stacktrace":"jXmbb","./supports":"l5khV","@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"3Rtdk":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "CONSOLE_LEVELS", ()=>CONSOLE_LEVELS);
/**
 * Temporarily disable sentry console instrumentations.
 *
 * @param callback The function to run against the original `console` messages
 * @returns The results of the callback
 */ parcelHelpers.export(exports, "consoleSandbox", ()=>consoleSandbox);
parcelHelpers.export(exports, "logger", ()=>logger);
var _tslib = require("tslib");
var _flags = require("./flags");
var _global = require("./global");
// TODO: Implement different loggers for different environments
var global = (0, _global.getGlobalObject)();
/** Prefix for logging strings */ var PREFIX = 'Sentry Logger ';
var CONSOLE_LEVELS = [
    'debug',
    'info',
    'warn',
    'error',
    'log',
    'assert'
];
function consoleSandbox(callback) {
    var global = (0, _global.getGlobalObject)();
    if (!('console' in global)) return callback();
    var originalConsole = global.console;
    var wrappedLevels = {};
    // Restore all wrapped console methods
    CONSOLE_LEVELS.forEach(function(level) {
        // TODO(v7): Remove this check as it's only needed for Node 6
        var originalWrappedFunc = originalConsole[level] && originalConsole[level].__sentry_original__;
        if (level in global.console && originalWrappedFunc) {
            wrappedLevels[level] = originalConsole[level];
            originalConsole[level] = originalWrappedFunc;
        }
    });
    try {
        return callback();
    } finally{
        // Revert restoration to wrapped state
        Object.keys(wrappedLevels).forEach(function(level) {
            originalConsole[level] = wrappedLevels[level];
        });
    }
}
function makeLogger() {
    var enabled = false;
    var logger = {
        enable: function() {
            enabled = true;
        },
        disable: function() {
            enabled = false;
        }
    };
    if (0, _flags.IS_DEBUG_BUILD) CONSOLE_LEVELS.forEach(function(name) {
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        logger[name] = function() {
            var args = [];
            for(var _i = 0; _i < arguments.length; _i++)args[_i] = arguments[_i];
            if (enabled) consoleSandbox(function() {
                var _a;
                (_a = global.console)[name].apply(_a, (0, _tslib.__spread)([
                    PREFIX + "[" + name + "]:"
                ], args));
            });
        };
    });
    else CONSOLE_LEVELS.forEach(function(name) {
        logger[name] = function() {
            return undefined;
        };
    });
    return logger;
}
// Ensure we only have a single logger instance, even if multiple versions of @sentry/utils are being used
var logger;
if (0, _flags.IS_DEBUG_BUILD) logger = (0, _global.getGlobalSingleton)('logger', makeLogger);
else logger = makeLogger();

},{"tslib":"6MhhU","./flags":"XrQpC","./global":"PLhjt","@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"ikcFZ":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
/**
 * Replace a method in an object with a wrapped version of itself.
 *
 * @param source An object that contains a method to be wrapped.
 * @param name The name of the method to be wrapped.
 * @param replacementFactory A higher-order function that takes the original version of the given method and returns a
 * wrapped version. Note: The function returned by `replacementFactory` needs to be a non-arrow function, in order to
 * preserve the correct value of `this`, and the original method must be called using `origMethod.call(this, <other
 * args>)` or `origMethod.apply(this, [<other args>])` (rather than being called directly), again to preserve `this`.
 * @returns void
 */ parcelHelpers.export(exports, "fill", ()=>fill);
/**
 * Defines a non-enumerable property on the given object.
 *
 * @param obj The object on which to set the property
 * @param name The name of the property to be set
 * @param value The value to which to set the property
 */ parcelHelpers.export(exports, "addNonEnumerableProperty", ()=>addNonEnumerableProperty);
/**
 * Remembers the original function on the wrapped function and
 * patches up the prototype.
 *
 * @param wrapped the wrapper function
 * @param original the original function that gets wrapped
 */ parcelHelpers.export(exports, "markFunctionWrapped", ()=>markFunctionWrapped);
/**
 * This extracts the original function if available.  See
 * `markFunctionWrapped` for more information.
 *
 * @param func the function to unwrap
 * @returns the unwrapped version of the function if available.
 */ parcelHelpers.export(exports, "getOriginalFunction", ()=>getOriginalFunction);
/**
 * Encodes given object into url-friendly format
 *
 * @param object An object that contains serializable values
 * @returns string Encoded
 */ parcelHelpers.export(exports, "urlEncode", ()=>urlEncode);
/**
 * Transforms any object into an object literal with all its attributes
 * attached to it.
 *
 * @param value Initial source that we have to transform in order for it to be usable by the serializer
 */ parcelHelpers.export(exports, "convertToPlainObject", ()=>convertToPlainObject);
/**
 * Given any captured exception, extract its keys and create a sorted
 * and truncated list that will be used inside the event message.
 * eg. `Non-error exception captured with keys: foo, bar, baz`
 */ // eslint-disable-next-line @typescript-eslint/explicit-module-boundary-types
parcelHelpers.export(exports, "extractExceptionKeysForMessage", ()=>extractExceptionKeysForMessage);
/**
 * Given any object, return the new object with removed keys that value was `undefined`.
 * Works recursively on objects and arrays.
 */ parcelHelpers.export(exports, "dropUndefinedKeys", ()=>dropUndefinedKeys);
/**
 * Ensure that something is an object.
 *
 * Turns `undefined` and `null` into `String`s and all other primitives into instances of their respective wrapper
 * classes (String, Boolean, Number, etc.). Acts as the identity function on non-primitives.
 *
 * @param wat The subject of the objectification
 * @returns A version of `wat` which can safely be used with `Object` class methods
 */ parcelHelpers.export(exports, "objectify", ()=>objectify);
var _tslib = require("tslib");
var _browser = require("./browser");
var _is = require("./is");
var _string = require("./string");
function fill(source, name, replacementFactory) {
    if (!(name in source)) return;
    var original = source[name];
    var wrapped = replacementFactory(original);
    // Make sure it's a function first, as we need to attach an empty prototype for `defineProperties` to work
    // otherwise it'll throw "TypeError: Object.defineProperties called on non-object"
    if (typeof wrapped === 'function') try {
        markFunctionWrapped(wrapped, original);
    } catch (_Oo) {
    // This can throw if multiple fill happens on a global object like XMLHttpRequest
    // Fixes https://github.com/getsentry/sentry-javascript/issues/2043
    }
    source[name] = wrapped;
}
function addNonEnumerableProperty(obj, name, value) {
    Object.defineProperty(obj, name, {
        // enumerable: false, // the default, so we can save on bundle size by not explicitly setting it
        value: value,
        writable: true,
        configurable: true
    });
}
function markFunctionWrapped(wrapped, original) {
    var proto = original.prototype || {};
    wrapped.prototype = original.prototype = proto;
    addNonEnumerableProperty(wrapped, '__sentry_original__', original);
}
function getOriginalFunction(func) {
    return func.__sentry_original__;
}
function urlEncode(object) {
    return Object.keys(object).map(function(key) {
        return encodeURIComponent(key) + "=" + encodeURIComponent(object[key]);
    }).join('&');
}
function convertToPlainObject(value) {
    var newObj = value;
    if ((0, _is.isError)(value)) newObj = (0, _tslib.__assign)({
        message: value.message,
        name: value.name,
        stack: value.stack
    }, getOwnProperties(value));
    else if ((0, _is.isEvent)(value)) {
        var event_1 = value;
        newObj = (0, _tslib.__assign)({
            type: event_1.type,
            target: serializeEventTarget(event_1.target),
            currentTarget: serializeEventTarget(event_1.currentTarget)
        }, getOwnProperties(event_1));
        if (typeof CustomEvent !== 'undefined' && (0, _is.isInstanceOf)(value, CustomEvent)) newObj.detail = event_1.detail;
    }
    return newObj;
}
/** Creates a string representation of the target of an `Event` object */ function serializeEventTarget(target) {
    try {
        return (0, _is.isElement)(target) ? (0, _browser.htmlTreeAsString)(target) : Object.prototype.toString.call(target);
    } catch (_oO) {
        return '<unknown>';
    }
}
/** Filters out all but an object's own properties */ function getOwnProperties(obj) {
    var extractedProps = {};
    for(var property in obj)if (Object.prototype.hasOwnProperty.call(obj, property)) extractedProps[property] = obj[property];
    return extractedProps;
}
function extractExceptionKeysForMessage(exception, maxLength) {
    if (maxLength === void 0) maxLength = 40;
    var keys = Object.keys(convertToPlainObject(exception));
    keys.sort();
    if (!keys.length) return '[object has no keys]';
    if (keys[0].length >= maxLength) return (0, _string.truncate)(keys[0], maxLength);
    for(var includedKeys = keys.length; includedKeys > 0; includedKeys--){
        var serialized = keys.slice(0, includedKeys).join(', ');
        if (serialized.length > maxLength) continue;
        if (includedKeys === keys.length) return serialized;
        return (0, _string.truncate)(serialized, maxLength);
    }
    return '';
}
function dropUndefinedKeys(val) {
    var e_1, _a;
    if ((0, _is.isPlainObject)(val)) {
        var rv = {};
        try {
            for(var _b = (0, _tslib.__values)(Object.keys(val)), _c = _b.next(); !_c.done; _c = _b.next()){
                var key = _c.value;
                if (typeof val[key] !== 'undefined') rv[key] = dropUndefinedKeys(val[key]);
            }
        } catch (e_1_1) {
            e_1 = {
                error: e_1_1
            };
        } finally{
            try {
                if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
            } finally{
                if (e_1) throw e_1.error;
            }
        }
        return rv;
    }
    if (Array.isArray(val)) return val.map(dropUndefinedKeys);
    return val;
}
function objectify(wat) {
    var objectified;
    switch(true){
        case wat === undefined || wat === null:
            objectified = new String(wat);
            break;
        // Though symbols and bigints do have wrapper classes (`Symbol` and `BigInt`, respectively), for whatever reason
        // those classes don't have constructors which can be used with the `new` keyword. We therefore need to cast each as
        // an object in order to wrap it.
        case typeof wat === 'symbol' || typeof wat === 'bigint':
            objectified = Object(wat);
            break;
        // this will catch the remaining primitives: `String`, `Number`, and `Boolean`
        case (0, _is.isPrimitive)(wat):
            // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access
            objectified = new wat.constructor(wat);
            break;
        // by process of elimination, at this point we know that `wat` must already be an object
        default:
            objectified = wat;
            break;
    }
    return objectified;
}

},{"tslib":"6MhhU","./browser":"WNuVF","./is":"kahuF","./string":"ePLUW","@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"ePLUW":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
/**
 * Truncates given string to the maximum characters count
 *
 * @param str An object that contains serializable values
 * @param max Maximum number of characters in truncated string (0 = unlimited)
 * @returns string Encoded
 */ parcelHelpers.export(exports, "truncate", ()=>truncate);
/**
 * This is basically just `trim_line` from
 * https://github.com/getsentry/sentry/blob/master/src/sentry/lang/javascript/processor.py#L67
 *
 * @param str An object that contains serializable values
 * @param max Maximum number of characters in truncated string
 * @returns string Encoded
 */ parcelHelpers.export(exports, "snipLine", ()=>snipLine);
/**
 * Join values in array
 * @param input array of values to be joined together
 * @param delimiter string to be placed in-between values
 * @returns Joined values
 */ // eslint-disable-next-line @typescript-eslint/no-explicit-any
parcelHelpers.export(exports, "safeJoin", ()=>safeJoin);
/**
 * Checks if the value matches a regex or includes the string
 * @param value The string value to be checked against
 * @param pattern Either a regex or a string that must be contained in value
 */ parcelHelpers.export(exports, "isMatchingPattern", ()=>isMatchingPattern);
/**
 * Given a string, escape characters which have meaning in the regex grammar, such that the result is safe to feed to
 * `new RegExp()`.
 *
 * Based on https://github.com/sindresorhus/escape-string-regexp. Vendored to a) reduce the size by skipping the runtime
 * type-checking, and b) ensure it gets down-compiled for old versions of Node (the published package only supports Node
 * 12+).
 *
 * @param regexString The string to escape
 * @returns An version of the string with all special regex characters escaped
 */ parcelHelpers.export(exports, "escapeStringForRegex", ()=>escapeStringForRegex);
var _is = require("./is");
function truncate(str, max) {
    if (max === void 0) max = 0;
    if (typeof str !== 'string' || max === 0) return str;
    return str.length <= max ? str : str.substr(0, max) + "...";
}
function snipLine(line, colno) {
    var newLine = line;
    var lineLength = newLine.length;
    if (lineLength <= 150) return newLine;
    if (colno > lineLength) // eslint-disable-next-line no-param-reassign
    colno = lineLength;
    var start = Math.max(colno - 60, 0);
    if (start < 5) start = 0;
    var end = Math.min(start + 140, lineLength);
    if (end > lineLength - 5) end = lineLength;
    if (end === lineLength) start = Math.max(end - 140, 0);
    newLine = newLine.slice(start, end);
    if (start > 0) newLine = "'{snip} " + newLine;
    if (end < lineLength) newLine += ' {snip}';
    return newLine;
}
function safeJoin(input, delimiter) {
    if (!Array.isArray(input)) return '';
    var output = [];
    // eslint-disable-next-line @typescript-eslint/prefer-for-of
    for(var i = 0; i < input.length; i++){
        var value = input[i];
        try {
            output.push(String(value));
        } catch (e) {
            output.push('[value cannot be serialized]');
        }
    }
    return output.join(delimiter);
}
function isMatchingPattern(value, pattern) {
    if (!(0, _is.isString)(value)) return false;
    if ((0, _is.isRegExp)(pattern)) return pattern.test(value);
    if (typeof pattern === 'string') return value.indexOf(pattern) !== -1;
    return false;
}
function escapeStringForRegex(regexString) {
    // escape the hyphen separately so we can also replace it with a unicode literal hyphen, to avoid the problems
    // discussed in https://github.com/sindresorhus/escape-string-regexp/issues/20.
    return regexString.replace(/[|\\{}()[\]^$+*?.]/g, '\\$&').replace(/-/g, '\\x2d');
}

},{"./is":"kahuF","@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"jXmbb":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
/**
 * Creates a stack parser with the supplied line parsers
 *
 * StackFrames are returned in the correct order for Sentry Exception
 * frames and with Sentry SDK internal frames removed from the top and bottom
 *
 */ parcelHelpers.export(exports, "createStackParser", ()=>createStackParser);
/**
 * @hidden
 */ parcelHelpers.export(exports, "stripSentryFramesAndReverse", ()=>stripSentryFramesAndReverse);
/**
 * Safely extract function name from itself
 */ parcelHelpers.export(exports, "getFunctionName", ()=>getFunctionName);
var _tslib = require("tslib");
var STACKTRACE_LIMIT = 50;
function createStackParser() {
    var parsers = [];
    for(var _i = 0; _i < arguments.length; _i++)parsers[_i] = arguments[_i];
    var sortedParsers = parsers.sort(function(a, b) {
        return a[0] - b[0];
    }).map(function(p) {
        return p[1];
    });
    return function(stack, skipFirst) {
        var e_1, _a, e_2, _b;
        if (skipFirst === void 0) skipFirst = 0;
        var frames = [];
        try {
            for(var _c = (0, _tslib.__values)(stack.split('\n').slice(skipFirst)), _d = _c.next(); !_d.done; _d = _c.next()){
                var line = _d.value;
                try {
                    for(var sortedParsers_1 = (e_2 = void 0, (0, _tslib.__values)(sortedParsers)), sortedParsers_1_1 = sortedParsers_1.next(); !sortedParsers_1_1.done; sortedParsers_1_1 = sortedParsers_1.next()){
                        var parser = sortedParsers_1_1.value;
                        var frame = parser(line);
                        if (frame) {
                            frames.push(frame);
                            break;
                        }
                    }
                } catch (e_2_1) {
                    e_2 = {
                        error: e_2_1
                    };
                } finally{
                    try {
                        if (sortedParsers_1_1 && !sortedParsers_1_1.done && (_b = sortedParsers_1.return)) _b.call(sortedParsers_1);
                    } finally{
                        if (e_2) throw e_2.error;
                    }
                }
            }
        } catch (e_1_1) {
            e_1 = {
                error: e_1_1
            };
        } finally{
            try {
                if (_d && !_d.done && (_a = _c.return)) _a.call(_c);
            } finally{
                if (e_1) throw e_1.error;
            }
        }
        return stripSentryFramesAndReverse(frames);
    };
}
function stripSentryFramesAndReverse(stack) {
    if (!stack.length) return [];
    var localStack = stack;
    var firstFrameFunction = localStack[0].function || '';
    var lastFrameFunction = localStack[localStack.length - 1].function || '';
    // If stack starts with one of our API calls, remove it (starts, meaning it's the top of the stack - aka last call)
    if (firstFrameFunction.indexOf('captureMessage') !== -1 || firstFrameFunction.indexOf('captureException') !== -1) localStack = localStack.slice(1);
    // If stack ends with one of our internal API calls, remove it (ends, meaning it's the bottom of the stack - aka top-most call)
    if (lastFrameFunction.indexOf('sentryWrapped') !== -1) localStack = localStack.slice(0, -1);
    // The frame where the crash happened, should be the last entry in the array
    return localStack.slice(0, STACKTRACE_LIMIT).map(function(frame) {
        return (0, _tslib.__assign)((0, _tslib.__assign)({}, frame), {
            filename: frame.filename || localStack[0].filename,
            function: frame.function || '?'
        });
    }).reverse();
}
var defaultFunctionName = '<anonymous>';
function getFunctionName(fn) {
    try {
        if (!fn || typeof fn !== 'function') return defaultFunctionName;
        return fn.name || defaultFunctionName;
    } catch (e) {
        // Just accessing custom props in some Selenium environments
        // can cause a "Permission denied" exception (see raven-js#495).
        return defaultFunctionName;
    }
}

},{"tslib":"6MhhU","@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"l5khV":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
/**
 * Tells whether current environment supports ErrorEvent objects
 * {@link supportsErrorEvent}.
 *
 * @returns Answer to the given question.
 */ parcelHelpers.export(exports, "supportsErrorEvent", ()=>supportsErrorEvent);
/**
 * Tells whether current environment supports DOMError objects
 * {@link supportsDOMError}.
 *
 * @returns Answer to the given question.
 */ parcelHelpers.export(exports, "supportsDOMError", ()=>supportsDOMError);
/**
 * Tells whether current environment supports DOMException objects
 * {@link supportsDOMException}.
 *
 * @returns Answer to the given question.
 */ parcelHelpers.export(exports, "supportsDOMException", ()=>supportsDOMException);
/**
 * Tells whether current environment supports Fetch API
 * {@link supportsFetch}.
 *
 * @returns Answer to the given question.
 */ parcelHelpers.export(exports, "supportsFetch", ()=>supportsFetch);
/**
 * isNativeFetch checks if the given function is a native implementation of fetch()
 */ // eslint-disable-next-line @typescript-eslint/ban-types
parcelHelpers.export(exports, "isNativeFetch", ()=>isNativeFetch);
/**
 * Tells whether current environment supports Fetch API natively
 * {@link supportsNativeFetch}.
 *
 * @returns true if `window.fetch` is natively implemented, false otherwise
 */ parcelHelpers.export(exports, "supportsNativeFetch", ()=>supportsNativeFetch);
/**
 * Tells whether current environment supports ReportingObserver API
 * {@link supportsReportingObserver}.
 *
 * @returns Answer to the given question.
 */ parcelHelpers.export(exports, "supportsReportingObserver", ()=>supportsReportingObserver);
/**
 * Tells whether current environment supports Referrer Policy API
 * {@link supportsReferrerPolicy}.
 *
 * @returns Answer to the given question.
 */ parcelHelpers.export(exports, "supportsReferrerPolicy", ()=>supportsReferrerPolicy);
/**
 * Tells whether current environment supports History API
 * {@link supportsHistory}.
 *
 * @returns Answer to the given question.
 */ parcelHelpers.export(exports, "supportsHistory", ()=>supportsHistory);
var _flags = require("./flags");
var _global = require("./global");
var _logger = require("./logger");
function supportsErrorEvent() {
    try {
        new ErrorEvent('');
        return true;
    } catch (e) {
        return false;
    }
}
function supportsDOMError() {
    try {
        // Chrome: VM89:1 Uncaught TypeError: Failed to construct 'DOMError':
        // 1 argument required, but only 0 present.
        // @ts-ignore It really needs 1 argument, not 0.
        new DOMError('');
        return true;
    } catch (e) {
        return false;
    }
}
function supportsDOMException() {
    try {
        new DOMException('');
        return true;
    } catch (e) {
        return false;
    }
}
function supportsFetch() {
    if (!('fetch' in (0, _global.getGlobalObject)())) return false;
    try {
        new Headers();
        new Request('');
        new Response();
        return true;
    } catch (e) {
        return false;
    }
}
function isNativeFetch(func) {
    return func && /^function fetch\(\)\s+\{\s+\[native code\]\s+\}$/.test(func.toString());
}
function supportsNativeFetch() {
    if (!supportsFetch()) return false;
    var global = (0, _global.getGlobalObject)();
    // Fast path to avoid DOM I/O
    // eslint-disable-next-line @typescript-eslint/unbound-method
    if (isNativeFetch(global.fetch)) return true;
    // window.fetch is implemented, but is polyfilled or already wrapped (e.g: by a chrome extension)
    // so create a "pure" iframe to see if that has native fetch
    var result = false;
    var doc = global.document;
    // eslint-disable-next-line deprecation/deprecation
    if (doc && typeof doc.createElement === 'function') try {
        var sandbox = doc.createElement('iframe');
        sandbox.hidden = true;
        doc.head.appendChild(sandbox);
        if (sandbox.contentWindow && sandbox.contentWindow.fetch) // eslint-disable-next-line @typescript-eslint/unbound-method
        result = isNativeFetch(sandbox.contentWindow.fetch);
        doc.head.removeChild(sandbox);
    } catch (err) {
        (0, _flags.IS_DEBUG_BUILD) && (0, _logger.logger).warn('Could not create sandbox iframe for pure fetch check, bailing to window.fetch: ', err);
    }
    return result;
}
function supportsReportingObserver() {
    return 'ReportingObserver' in (0, _global.getGlobalObject)();
}
function supportsReferrerPolicy() {
    // Despite all stars in the sky saying that Edge supports old draft syntax, aka 'never', 'always', 'origin' and 'default'
    // (see https://caniuse.com/#feat=referrer-policy),
    // it doesn't. And it throws an exception instead of ignoring this parameter...
    // REF: https://github.com/getsentry/raven-js/issues/1233
    if (!supportsFetch()) return false;
    try {
        new Request('_', {
            referrerPolicy: 'origin'
        });
        return true;
    } catch (e) {
        return false;
    }
}
function supportsHistory() {
    // NOTE: in Chrome App environment, touching history.pushState, *even inside
    //       a try/catch block*, will cause Chrome to output an error to console.error
    // borrowed from: https://github.com/angular/angular.js/pull/13945/files
    var global = (0, _global.getGlobalObject)();
    /* eslint-disable @typescript-eslint/no-unsafe-member-access */ // eslint-disable-next-line @typescript-eslint/no-explicit-any
    var chrome = global.chrome;
    var isChromePackagedApp = chrome && chrome.app && chrome.app.runtime;
    /* eslint-enable @typescript-eslint/no-unsafe-member-access */ var hasHistoryApi = 'history' in global && !!global.history.pushState && !!global.history.replaceState;
    return !isChromePackagedApp && hasHistoryApi;
}

},{"./flags":"XrQpC","./global":"PLhjt","./logger":"3Rtdk","@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"7vfZV":[function(require,module,exports,__globalThis) {
/* eslint-disable @typescript-eslint/no-unsafe-member-access */ /* eslint-disable @typescript-eslint/no-explicit-any */ /**
 * Helper to decycle json objects
 */ var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "memoBuilder", ()=>memoBuilder);
function memoBuilder() {
    var hasWeakSet = typeof WeakSet === 'function';
    var inner = hasWeakSet ? new WeakSet() : [];
    function memoize(obj) {
        if (hasWeakSet) {
            if (inner.has(obj)) return true;
            inner.add(obj);
            return false;
        }
        // eslint-disable-next-line @typescript-eslint/prefer-for-of
        for(var i = 0; i < inner.length; i++){
            var value = inner[i];
            if (value === obj) return true;
        }
        inner.push(obj);
        return false;
    }
    function unmemoize(obj) {
        if (hasWeakSet) inner.delete(obj);
        else {
            for(var i = 0; i < inner.length; i++)if (inner[i] === obj) {
                inner.splice(i, 1);
                break;
            }
        }
    }
    return [
        memoize,
        unmemoize
    ];
}

},{"@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"7MqaN":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
/**
 * UUID4 generator
 *
 * @returns string Generated UUID4.
 */ parcelHelpers.export(exports, "uuid4", ()=>uuid4);
/**
 * Parses string form of URL into an object
 * // borrowed from https://tools.ietf.org/html/rfc3986#appendix-B
 * // intentionally using regex and not <a/> href parsing trick because React Native and other
 * // environments where DOM might not be available
 * @returns parsed URL object
 */ parcelHelpers.export(exports, "parseUrl", ()=>parseUrl);
/**
 * Extracts either message or type+value from an event that can be used for user-facing logs
 * @returns event's description
 */ parcelHelpers.export(exports, "getEventDescription", ()=>getEventDescription);
/**
 * Adds exception values, type and value to an synthetic Exception.
 * @param event The event to modify.
 * @param value Value of the exception.
 * @param type Type of the exception.
 * @hidden
 */ parcelHelpers.export(exports, "addExceptionTypeValue", ()=>addExceptionTypeValue);
/**
 * Adds exception mechanism data to a given event. Uses defaults if the second parameter is not passed.
 *
 * @param event The event to modify.
 * @param newMechanism Mechanism data to add to the event.
 * @hidden
 */ parcelHelpers.export(exports, "addExceptionMechanism", ()=>addExceptionMechanism);
/**
 * Parses input into a SemVer interface
 * @param input string representation of a semver version
 */ parcelHelpers.export(exports, "parseSemver", ()=>parseSemver);
/**
 * This function adds context (pre/post/line) lines to the provided frame
 *
 * @param lines string[] containing all lines
 * @param frame StackFrame that will be mutated
 * @param linesOfContext number of context lines we want to add pre/post
 */ parcelHelpers.export(exports, "addContextToFrame", ()=>addContextToFrame);
/**
 * Strip the query string and fragment off of a given URL or path (if present)
 *
 * @param urlPath Full URL or path, including possible query string and/or fragment
 * @returns URL or path without query string or fragment
 */ parcelHelpers.export(exports, "stripUrlQueryAndFragment", ()=>stripUrlQueryAndFragment);
/**
 * Checks whether or not we've already captured the given exception (note: not an identical exception - the very object
 * in question), and marks it captured if not.
 *
 * This is useful because it's possible for an error to get captured by more than one mechanism. After we intercept and
 * record an error, we rethrow it (assuming we've intercepted it before it's reached the top-level global handlers), so
 * that we don't interfere with whatever effects the error might have had were the SDK not there. At that point, because
 * the error has been rethrown, it's possible for it to bubble up to some other code we've instrumented. If it's not
 * caught after that, it will bubble all the way up to the global handlers (which of course we also instrument). This
 * function helps us ensure that even if we encounter the same error more than once, we only record it the first time we
 * see it.
 *
 * Note: It will ignore primitives (always return `false` and not mark them as seen), as properties can't be set on
 * them. {@link: Object.objectify} can be used on exceptions to convert any that are primitives into their equivalent
 * object wrapper forms so that this check will always work. However, because we need to flag the exact object which
 * will get rethrown, and because that rethrowing happens outside of the event processing pipeline, the objectification
 * must be done before the exception captured.
 *
 * @param A thrown exception to check or flag as having been seen
 * @returns `true` if the exception has already been captured, `false` if not (with the side effect of marking it seen)
 */ parcelHelpers.export(exports, "checkOrSetAlreadyCaught", ()=>checkOrSetAlreadyCaught);
var _tslib = require("tslib");
var _global = require("./global");
var _object = require("./object");
var _string = require("./string");
function uuid4() {
    var global = (0, _global.getGlobalObject)();
    var crypto = global.crypto || global.msCrypto;
    if (!(crypto === void 0) && crypto.getRandomValues) {
        // Use window.crypto API if available
        var arr = new Uint16Array(8);
        crypto.getRandomValues(arr);
        // set 4 in byte 7
        // eslint-disable-next-line no-bitwise
        arr[3] = arr[3] & 0xfff | 0x4000;
        // set 2 most significant bits of byte 9 to '10'
        // eslint-disable-next-line no-bitwise
        arr[4] = arr[4] & 0x3fff | 0x8000;
        var pad = function(num) {
            var v = num.toString(16);
            while(v.length < 4)v = "0" + v;
            return v;
        };
        return pad(arr[0]) + pad(arr[1]) + pad(arr[2]) + pad(arr[3]) + pad(arr[4]) + pad(arr[5]) + pad(arr[6]) + pad(arr[7]);
    }
    // http://stackoverflow.com/questions/105034/how-to-create-a-guid-uuid-in-javascript/2117523#2117523
    return 'xxxxxxxxxxxx4xxxyxxxxxxxxxxxxxxx'.replace(/[xy]/g, function(c) {
        // eslint-disable-next-line no-bitwise
        var r = Math.random() * 16 | 0;
        // eslint-disable-next-line no-bitwise
        var v = c === 'x' ? r : r & 0x3 | 0x8;
        return v.toString(16);
    });
}
function parseUrl(url) {
    if (!url) return {};
    var match = url.match(/^(([^:/?#]+):)?(\/\/([^/?#]*))?([^?#]*)(\?([^#]*))?(#(.*))?$/);
    if (!match) return {};
    // coerce to undefined values to empty string so we don't get 'undefined'
    var query = match[6] || '';
    var fragment = match[8] || '';
    return {
        host: match[4],
        path: match[5],
        protocol: match[2],
        relative: match[5] + query + fragment
    };
}
function getFirstException(event) {
    return event.exception && event.exception.values ? event.exception.values[0] : undefined;
}
function getEventDescription(event) {
    var message = event.message, eventId = event.event_id;
    if (message) return message;
    var firstException = getFirstException(event);
    if (firstException) {
        if (firstException.type && firstException.value) return firstException.type + ": " + firstException.value;
        return firstException.type || firstException.value || eventId || '<unknown>';
    }
    return eventId || '<unknown>';
}
function addExceptionTypeValue(event, value, type) {
    var exception = event.exception = event.exception || {};
    var values = exception.values = exception.values || [];
    var firstException = values[0] = values[0] || {};
    if (!firstException.value) firstException.value = value || '';
    if (!firstException.type) firstException.type = type || 'Error';
}
function addExceptionMechanism(event, newMechanism) {
    var firstException = getFirstException(event);
    if (!firstException) return;
    var defaultMechanism = {
        type: 'generic',
        handled: true
    };
    var currentMechanism = firstException.mechanism;
    firstException.mechanism = (0, _tslib.__assign)((0, _tslib.__assign)((0, _tslib.__assign)({}, defaultMechanism), currentMechanism), newMechanism);
    if (newMechanism && 'data' in newMechanism) {
        var mergedData = (0, _tslib.__assign)((0, _tslib.__assign)({}, currentMechanism && currentMechanism.data), newMechanism.data);
        firstException.mechanism.data = mergedData;
    }
}
// https://semver.org/#is-there-a-suggested-regular-expression-regex-to-check-a-semver-string
var SEMVER_REGEXP = /^(0|[1-9]\d*)\.(0|[1-9]\d*)\.(0|[1-9]\d*)(?:-((?:0|[1-9]\d*|\d*[a-zA-Z-][0-9a-zA-Z-]*)(?:\.(?:0|[1-9]\d*|\d*[a-zA-Z-][0-9a-zA-Z-]*))*))?(?:\+([0-9a-zA-Z-]+(?:\.[0-9a-zA-Z-]+)*))?$/;
function parseSemver(input) {
    var match = input.match(SEMVER_REGEXP) || [];
    var major = parseInt(match[1], 10);
    var minor = parseInt(match[2], 10);
    var patch = parseInt(match[3], 10);
    return {
        buildmetadata: match[5],
        major: isNaN(major) ? undefined : major,
        minor: isNaN(minor) ? undefined : minor,
        patch: isNaN(patch) ? undefined : patch,
        prerelease: match[4]
    };
}
function addContextToFrame(lines, frame, linesOfContext) {
    if (linesOfContext === void 0) linesOfContext = 5;
    var lineno = frame.lineno || 0;
    var maxLines = lines.length;
    var sourceLine = Math.max(Math.min(maxLines, lineno - 1), 0);
    frame.pre_context = lines.slice(Math.max(0, sourceLine - linesOfContext), sourceLine).map(function(line) {
        return (0, _string.snipLine)(line, 0);
    });
    frame.context_line = (0, _string.snipLine)(lines[Math.min(maxLines - 1, sourceLine)], frame.colno || 0);
    frame.post_context = lines.slice(Math.min(sourceLine + 1, maxLines), sourceLine + 1 + linesOfContext).map(function(line) {
        return (0, _string.snipLine)(line, 0);
    });
}
function stripUrlQueryAndFragment(urlPath) {
    // eslint-disable-next-line no-useless-escape
    return urlPath.split(/[\?#]/, 1)[0];
}
function checkOrSetAlreadyCaught(exception) {
    // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access
    if (exception && exception.__sentry_captured__) return true;
    try {
        // set it this way rather than by assignment so that it's not ennumerable and therefore isn't recorded by the
        // `ExtraErrorData` integration
        (0, _object.addNonEnumerableProperty)(exception, '__sentry_captured__', true);
    } catch (err) {
    // `exception` is a primitive, so we can't mark it seen
    }
    return false;
}

},{"tslib":"6MhhU","./global":"PLhjt","./object":"ikcFZ","./string":"ePLUW","@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"6pGFq":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
/**
 * Recursively normalizes the given object.
 *
 * - Creates a copy to prevent original input mutation
 * - Skips non-enumerable properties
 * - When stringifying, calls `toJSON` if implemented
 * - Removes circular references
 * - Translates non-serializable values (`undefined`/`NaN`/functions) to serializable format
 * - Translates known global objects/classes to a string representations
 * - Takes care of `Error` object serialization
 * - Optionally limits depth of final output
 * - Optionally limits number of properties/elements included in any single object/array
 *
 * @param input The object to be normalized.
 * @param depth The max depth to which to normalize the object. (Anything deeper stringified whole.)
 * @param maxProperties The max number of elements or properties to be included in any single array or
 * object in the normallized output..
 * @returns A normalized version of the object, or `"**non-serializable**"` if any errors are thrown during normalization.
 */ parcelHelpers.export(exports, "normalize", ()=>normalize);
/** JSDoc */ parcelHelpers.export(exports, "normalizeToSize", ()=>normalizeToSize);
// TODO remove this in v7 (this means the method will no longer be exported, under any name)
parcelHelpers.export(exports, "walk", ()=>visit);
var _tslib = require("tslib");
var _is = require("./is");
var _memo = require("./memo");
var _object = require("./object");
var _stacktrace = require("./stacktrace");
var global = arguments[3];
function normalize(input, depth, maxProperties) {
    if (depth === void 0) depth = Infinity;
    if (maxProperties === void 0) maxProperties = Infinity;
    try {
        // since we're at the outermost level, there is no key
        return visit('', input, depth, maxProperties);
    } catch (err) {
        return {
            ERROR: "**non-serializable** (" + err + ")"
        };
    }
}
function normalizeToSize(object, // Default Node.js REPL depth
depth, // 100kB, as 200kB is max payload size, so half sounds reasonable
maxSize) {
    if (depth === void 0) depth = 3;
    if (maxSize === void 0) maxSize = 102400;
    var normalized = normalize(object, depth);
    if (jsonSize(normalized) > maxSize) return normalizeToSize(object, depth - 1, maxSize);
    return normalized;
}
/**
 * Visits a node to perform normalization on it
 *
 * @param key The key corresponding to the given node
 * @param value The node to be visited
 * @param depth Optional number indicating the maximum recursion depth
 * @param maxProperties Optional maximum number of properties/elements included in any single object/array
 * @param memo Optional Memo class handling decycling
 */ function visit(key, value, depth, maxProperties, memo) {
    if (depth === void 0) depth = Infinity;
    if (maxProperties === void 0) maxProperties = Infinity;
    if (memo === void 0) memo = (0, _memo.memoBuilder)();
    var _a = (0, _tslib.__read)(memo, 2), memoize = _a[0], unmemoize = _a[1];
    // If the value has a `toJSON` method, see if we can bail and let it do the work
    var valueWithToJSON = value;
    if (valueWithToJSON && typeof valueWithToJSON.toJSON === 'function') try {
        return valueWithToJSON.toJSON();
    } catch (err) {
    // pass (The built-in `toJSON` failed, but we can still try to do it ourselves)
    }
    // Get the simple cases out of the way first
    if (value === null || [
        'number',
        'boolean',
        'string'
    ].includes(typeof value) && !(0, _is.isNaN)(value)) return value;
    var stringified = stringifyValue(key, value);
    // Anything we could potentially dig into more (objects or arrays) will have come back as `"[object XXXX]"`.
    // Everything else will have already been serialized, so if we don't see that pattern, we're done.
    if (!stringified.startsWith('[object ')) return stringified;
    // We're also done if we've reached the max depth
    if (depth === 0) // At this point we know `serialized` is a string of the form `"[object XXXX]"`. Clean it up so it's just `"[XXXX]"`.
    return stringified.replace('object ', '');
    // If we've already visited this branch, bail out, as it's circular reference. If not, note that we're seeing it now.
    if (memoize(value)) return '[Circular ~]';
    // At this point we know we either have an object or an array, we haven't seen it before, and we're going to recurse
    // because we haven't yet reached the max depth. Create an accumulator to hold the results of visiting each
    // property/entry, and keep track of the number of items we add to it.
    var normalized = Array.isArray(value) ? [] : {};
    var numAdded = 0;
    // Before we begin, convert`Error` and`Event` instances into plain objects, since some of each of their relevant
    // properties are non-enumerable and otherwise would get missed.
    var visitable = (0, _is.isError)(value) || (0, _is.isEvent)(value) ? (0, _object.convertToPlainObject)(value) : value;
    for(var visitKey in visitable){
        // Avoid iterating over fields in the prototype if they've somehow been exposed to enumeration.
        if (!Object.prototype.hasOwnProperty.call(visitable, visitKey)) continue;
        if (numAdded >= maxProperties) {
            normalized[visitKey] = '[MaxProperties ~]';
            break;
        }
        // Recursively visit all the child nodes
        var visitValue = visitable[visitKey];
        normalized[visitKey] = visit(visitKey, visitValue, depth - 1, maxProperties, memo);
        numAdded += 1;
    }
    // Once we've visited all the branches, remove the parent from memo storage
    unmemoize(value);
    // Return accumulated values
    return normalized;
}
/**
 * Stringify the given value. Handles various known special values and types.
 *
 * Not meant to be used on simple primitives which already have a string representation, as it will, for example, turn
 * the number 1231 into "[Object Number]", nor on `null`, as it will throw.
 *
 * @param value The value to stringify
 * @returns A stringified representation of the given value
 */ function stringifyValue(key, // this type is a tiny bit of a cheat, since this function does handle NaN (which is technically a number), but for
// our internal use, it'll do
value) {
    try {
        if (key === 'domain' && value && typeof value === 'object' && value._events) return '[Domain]';
        if (key === 'domainEmitter') return '[DomainEmitter]';
        // It's safe to use `global`, `window`, and `document` here in this manner, as we are asserting using `typeof` first
        // which won't throw if they are not present.
        if (typeof global !== 'undefined' && value === global) return '[Global]';
        // eslint-disable-next-line no-restricted-globals
        if (typeof window !== 'undefined' && value === window) return '[Window]';
        // eslint-disable-next-line no-restricted-globals
        if (typeof document !== 'undefined' && value === document) return '[Document]';
        // React's SyntheticEvent thingy
        if ((0, _is.isSyntheticEvent)(value)) return '[SyntheticEvent]';
        if (typeof value === 'number' && value !== value) return '[NaN]';
        // this catches `undefined` (but not `null`, which is a primitive and can be serialized on its own)
        if (value === void 0) return '[undefined]';
        if (typeof value === 'function') return "[Function: " + (0, _stacktrace.getFunctionName)(value) + "]";
        if (typeof value === 'symbol') return "[" + String(value) + "]";
        // stringified BigInts are indistinguishable from regular numbers, so we need to label them to avoid confusion
        if (typeof value === 'bigint') return "[BigInt: " + String(value) + "]";
        // Now that we've knocked out all the special cases and the primitives, all we have left are objects. Simply casting
        // them to strings means that instances of classes which haven't defined their `toStringTag` will just come out as
        // `"[object Object]"`. If we instead look at the constructor's name (which is the same as the name of the class),
        // we can make sure that only plain objects come out that way.
        return "[object " + Object.getPrototypeOf(value).constructor.name + "]";
    } catch (err) {
        return "**non-serializable** (" + err + ")";
    }
}
/** Calculates bytes size of input string */ function utf8Length(value) {
    // eslint-disable-next-line no-bitwise
    return ~-encodeURI(value).split(/%..|./).length;
}
/** Calculates bytes size of input object */ function jsonSize(value) {
    return utf8Length(JSON.stringify(value));
}

},{"tslib":"6MhhU","./is":"kahuF","./memo":"7vfZV","./object":"ikcFZ","./stacktrace":"jXmbb","@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"cR9yn":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
/**
 * Creates an new PromiseBuffer object with the specified limit
 * @param limit max number of promises that can be stored in the buffer
 */ parcelHelpers.export(exports, "makePromiseBuffer", ()=>makePromiseBuffer);
var _error = require("./error");
var _syncpromise = require("./syncpromise");
function makePromiseBuffer(limit) {
    var buffer = [];
    function isReady() {
        return limit === undefined || buffer.length < limit;
    }
    /**
     * Remove a promise from the queue.
     *
     * @param task Can be any PromiseLike<T>
     * @returns Removed promise.
     */ function remove(task) {
        return buffer.splice(buffer.indexOf(task), 1)[0];
    }
    /**
     * Add a promise (representing an in-flight action) to the queue, and set it to remove itself on fulfillment.
     *
     * @param taskProducer A function producing any PromiseLike<T>; In previous versions this used to be `task:
     *        PromiseLike<T>`, but under that model, Promises were instantly created on the call-site and their executor
     *        functions therefore ran immediately. Thus, even if the buffer was full, the action still happened. By
     *        requiring the promise to be wrapped in a function, we can defer promise creation until after the buffer
     *        limit check.
     * @returns The original promise.
     */ function add(taskProducer) {
        if (!isReady()) return (0, _syncpromise.rejectedSyncPromise)(new (0, _error.SentryError)('Not adding Promise due to buffer limit reached.'));
        // start the task and add its promise to the queue
        var task = taskProducer();
        if (buffer.indexOf(task) === -1) buffer.push(task);
        task.then(function() {
            return remove(task);
        })// Use `then(null, rejectionHandler)` rather than `catch(rejectionHandler)` so that we can use `PromiseLike`
        // rather than `Promise`. `PromiseLike` doesn't have a `.catch` method, making its polyfill smaller. (ES5 didn't
        // have promises, so TS has to polyfill when down-compiling.)
        .then(null, function() {
            return remove(task).then(null, function() {
            // We have to add another catch here because `remove()` starts a new promise chain.
            });
        });
        return task;
    }
    /**
     * Wait for all promises in the queue to resolve or for timeout to expire, whichever comes first.
     *
     * @param timeout The time, in ms, after which to resolve to `false` if the queue is still non-empty. Passing `0` (or
     * not passing anything) will make the promise wait as long as it takes for the queue to drain before resolving to
     * `true`.
     * @returns A promise which will resolve to `true` if the queue is already empty or drains before the timeout, and
     * `false` otherwise
     */ function drain(timeout) {
        return new (0, _syncpromise.SyncPromise)(function(resolve, reject) {
            var counter = buffer.length;
            if (!counter) return resolve(true);
            // wait for `timeout` ms and then resolve to `false` (if not cancelled first)
            var capturedSetTimeout = setTimeout(function() {
                if (timeout && timeout > 0) resolve(false);
            }, timeout);
            // if all promises resolve in time, cancel the timer and resolve to `true`
            buffer.forEach(function(item) {
                (0, _syncpromise.resolvedSyncPromise)(item).then(function() {
                    // eslint-disable-next-line no-plusplus
                    if (!--counter) {
                        clearTimeout(capturedSetTimeout);
                        resolve(true);
                    }
                }, reject);
            });
        });
    }
    return {
        $: buffer,
        add: add,
        drain: drain
    };
}

},{"./error":"kax1I","./syncpromise":"lMIRb","@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"lMIRb":[function(require,module,exports,__globalThis) {
/* eslint-disable @typescript-eslint/explicit-function-return-type */ /* eslint-disable @typescript-eslint/typedef */ /* eslint-disable @typescript-eslint/explicit-module-boundary-types */ /* eslint-disable @typescript-eslint/no-explicit-any */ var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
/**
 * Creates a resolved sync promise.
 *
 * @param value the value to resolve the promise with
 * @returns the resolved sync promise
 */ parcelHelpers.export(exports, "resolvedSyncPromise", ()=>resolvedSyncPromise);
/**
 * Creates a rejected sync promise.
 *
 * @param value the value to reject the promise with
 * @returns the rejected sync promise
 */ parcelHelpers.export(exports, "rejectedSyncPromise", ()=>rejectedSyncPromise);
parcelHelpers.export(exports, "SyncPromise", ()=>SyncPromise);
var _is = require("./is");
function resolvedSyncPromise(value) {
    return new SyncPromise(function(resolve) {
        resolve(value);
    });
}
function rejectedSyncPromise(reason) {
    return new SyncPromise(function(_, reject) {
        reject(reason);
    });
}
/**
 * Thenable class that behaves like a Promise and follows it's interface
 * but is not async internally
 */ var SyncPromise = /** @class */ function() {
    function SyncPromise(executor) {
        var _this = this;
        this._state = 0 /* PENDING */ ;
        this._handlers = [];
        /** JSDoc */ this._resolve = function(value) {
            _this._setResult(1 /* RESOLVED */ , value);
        };
        /** JSDoc */ this._reject = function(reason) {
            _this._setResult(2 /* REJECTED */ , reason);
        };
        /** JSDoc */ this._setResult = function(state, value) {
            if (_this._state !== 0 /* PENDING */ ) return;
            if ((0, _is.isThenable)(value)) {
                value.then(_this._resolve, _this._reject);
                return;
            }
            _this._state = state;
            _this._value = value;
            _this._executeHandlers();
        };
        /** JSDoc */ this._executeHandlers = function() {
            if (_this._state === 0 /* PENDING */ ) return;
            var cachedHandlers = _this._handlers.slice();
            _this._handlers = [];
            cachedHandlers.forEach(function(handler) {
                if (handler[0]) return;
                if (_this._state === 1 /* RESOLVED */ ) // eslint-disable-next-line @typescript-eslint/no-floating-promises
                handler[1](_this._value);
                if (_this._state === 2 /* REJECTED */ ) handler[2](_this._value);
                handler[0] = true;
            });
        };
        try {
            executor(this._resolve, this._reject);
        } catch (e) {
            this._reject(e);
        }
    }
    /** JSDoc */ SyncPromise.prototype.then = function(onfulfilled, onrejected) {
        var _this = this;
        return new SyncPromise(function(resolve, reject) {
            _this._handlers.push([
                false,
                function(result) {
                    if (!onfulfilled) // TODO: ¯\_(ツ)_/¯
                    // TODO: FIXME
                    resolve(result);
                    else try {
                        resolve(onfulfilled(result));
                    } catch (e) {
                        reject(e);
                    }
                },
                function(reason) {
                    if (!onrejected) reject(reason);
                    else try {
                        resolve(onrejected(reason));
                    } catch (e) {
                        reject(e);
                    }
                }
            ]);
            _this._executeHandlers();
        });
    };
    /** JSDoc */ SyncPromise.prototype.catch = function(onrejected) {
        return this.then(function(val) {
            return val;
        }, onrejected);
    };
    /** JSDoc */ SyncPromise.prototype.finally = function(onfinally) {
        var _this = this;
        return new SyncPromise(function(resolve, reject) {
            var val;
            var isRejected;
            return _this.then(function(value) {
                isRejected = false;
                val = value;
                if (onfinally) onfinally();
            }, function(reason) {
                isRejected = true;
                val = reason;
                if (onfinally) onfinally();
            }).then(function() {
                if (isRejected) {
                    reject(val);
                    return;
                }
                resolve(val);
            });
        });
    };
    return SyncPromise;
}();

},{"./is":"kahuF","@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"fMTZ5":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
/**
 * Converts a string-based level into a {@link Severity}.
 *
 * @param level string representation of Severity
 * @returns Severity
 */ parcelHelpers.export(exports, "severityFromString", ()=>severityFromString);
var _types = require("@sentry/types");
var _enums = require("./enums");
function isSupportedSeverity(level) {
    return (0, _enums.SeverityLevels).indexOf(level) !== -1;
}
function severityFromString(level) {
    if (level === 'warn') return (0, _types.Severity).Warning;
    if (isSupportedSeverity(level)) return level;
    return (0, _types.Severity).Log;
}

},{"@sentry/types":"92FRt","./enums":"9e2MQ","@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"iWz6Y":[function(require,module,exports,__globalThis) {
/**
 * Converts an HTTP status code to sentry status {@link EventStatus}.
 *
 * @param code number HTTP status code
 * @returns EventStatus
 */ var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "eventStatusFromHttpCode", ()=>eventStatusFromHttpCode);
function eventStatusFromHttpCode(code) {
    if (code >= 200 && code < 300) return 'success';
    if (code === 429) return 'rate_limit';
    if (code >= 400 && code < 500) return 'invalid';
    if (code >= 500) return 'failed';
    return 'unknown';
}

},{"@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"70NNx":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "dateTimestampInSeconds", ()=>dateTimestampInSeconds);
parcelHelpers.export(exports, "timestampInSeconds", ()=>timestampInSeconds);
parcelHelpers.export(exports, "timestampWithMs", ()=>timestampWithMs);
parcelHelpers.export(exports, "usingPerformanceAPI", ()=>usingPerformanceAPI);
parcelHelpers.export(exports, "_browserPerformanceTimeOriginMode", ()=>_browserPerformanceTimeOriginMode);
parcelHelpers.export(exports, "browserPerformanceTimeOrigin", ()=>browserPerformanceTimeOrigin);
var _global = require("./global");
var _node = require("./node");
/**
 * A TimestampSource implementation for environments that do not support the Performance Web API natively.
 *
 * Note that this TimestampSource does not use a monotonic clock. A call to `nowSeconds` may return a timestamp earlier
 * than a previously returned value. We do not try to emulate a monotonic behavior in order to facilitate debugging. It
 * is more obvious to explain "why does my span have negative duration" than "why my spans have zero duration".
 */ var dateTimestampSource = {
    nowSeconds: function() {
        return Date.now() / 1000;
    }
};
/**
 * Returns a wrapper around the native Performance API browser implementation, or undefined for browsers that do not
 * support the API.
 *
 * Wrapping the native API works around differences in behavior from different browsers.
 */ function getBrowserPerformance() {
    var performance = (0, _global.getGlobalObject)().performance;
    if (!performance || !performance.now) return undefined;
    // Replace performance.timeOrigin with our own timeOrigin based on Date.now().
    //
    // This is a partial workaround for browsers reporting performance.timeOrigin such that performance.timeOrigin +
    // performance.now() gives a date arbitrarily in the past.
    //
    // Additionally, computing timeOrigin in this way fills the gap for browsers where performance.timeOrigin is
    // undefined.
    //
    // The assumption that performance.timeOrigin + performance.now() ~= Date.now() is flawed, but we depend on it to
    // interact with data coming out of performance entries.
    //
    // Note that despite recommendations against it in the spec, browsers implement the Performance API with a clock that
    // might stop when the computer is asleep (and perhaps under other circumstances). Such behavior causes
    // performance.timeOrigin + performance.now() to have an arbitrary skew over Date.now(). In laptop computers, we have
    // observed skews that can be as long as days, weeks or months.
    //
    // See https://github.com/getsentry/sentry-javascript/issues/2590.
    //
    // BUG: despite our best intentions, this workaround has its limitations. It mostly addresses timings of pageload
    // transactions, but ignores the skew built up over time that can aversely affect timestamps of navigation
    // transactions of long-lived web pages.
    var timeOrigin = Date.now() - performance.now();
    return {
        now: function() {
            return performance.now();
        },
        timeOrigin: timeOrigin
    };
}
/**
 * Returns the native Performance API implementation from Node.js. Returns undefined in old Node.js versions that don't
 * implement the API.
 */ function getNodePerformance() {
    try {
        var perfHooks = (0, _node.dynamicRequire)(module, 'perf_hooks');
        return perfHooks.performance;
    } catch (_) {
        return undefined;
    }
}
/**
 * The Performance API implementation for the current platform, if available.
 */ var platformPerformance = (0, _node.isNodeEnv)() ? getNodePerformance() : getBrowserPerformance();
var timestampSource = platformPerformance === undefined ? dateTimestampSource : {
    nowSeconds: function() {
        return (platformPerformance.timeOrigin + platformPerformance.now()) / 1000;
    }
};
var dateTimestampInSeconds = dateTimestampSource.nowSeconds.bind(dateTimestampSource);
var timestampInSeconds = timestampSource.nowSeconds.bind(timestampSource);
var timestampWithMs = timestampInSeconds;
var usingPerformanceAPI = platformPerformance !== undefined;
var _browserPerformanceTimeOriginMode;
var browserPerformanceTimeOrigin = function() {
    // Unfortunately browsers may report an inaccurate time origin data, through either performance.timeOrigin or
    // performance.timing.navigationStart, which results in poor results in performance data. We only treat time origin
    // data as reliable if they are within a reasonable threshold of the current time.
    var performance = (0, _global.getGlobalObject)().performance;
    if (!performance || !performance.now) {
        _browserPerformanceTimeOriginMode = 'none';
        return undefined;
    }
    var threshold = 3600000;
    var performanceNow = performance.now();
    var dateNow = Date.now();
    // if timeOrigin isn't available set delta to threshold so it isn't used
    var timeOriginDelta = performance.timeOrigin ? Math.abs(performance.timeOrigin + performanceNow - dateNow) : threshold;
    var timeOriginIsReliable = timeOriginDelta < threshold;
    // While performance.timing.navigationStart is deprecated in favor of performance.timeOrigin, performance.timeOrigin
    // is not as widely supported. Namely, performance.timeOrigin is undefined in Safari as of writing.
    // Also as of writing, performance.timing is not available in Web Workers in mainstream browsers, so it is not always
    // a valid fallback. In the absence of an initial time provided by the browser, fallback to the current time from the
    // Date API.
    // eslint-disable-next-line deprecation/deprecation
    var navigationStart = performance.timing && performance.timing.navigationStart;
    var hasNavigationStart = typeof navigationStart === 'number';
    // if navigationStart isn't available set delta to threshold so it isn't used
    var navigationStartDelta = hasNavigationStart ? Math.abs(navigationStart + performanceNow - dateNow) : threshold;
    var navigationStartIsReliable = navigationStartDelta < threshold;
    if (timeOriginIsReliable || navigationStartIsReliable) {
        // Use the more reliable time origin
        if (timeOriginDelta <= navigationStartDelta) {
            _browserPerformanceTimeOriginMode = 'timeOrigin';
            return performance.timeOrigin;
        } else {
            _browserPerformanceTimeOriginMode = 'navigationStart';
            return navigationStart;
        }
    }
    // Either both timeOrigin and navigationStart are skewed or neither is available, fallback to Date.
    _browserPerformanceTimeOriginMode = 'dateNow';
    return dateNow;
}();

},{"./global":"PLhjt","./node":"9VyDn","@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"Op7jK":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
/**
 * Creates an envelope.
 * Make sure to always explicitly provide the generic to this function
 * so that the envelope types resolve correctly.
 */ parcelHelpers.export(exports, "createEnvelope", ()=>createEnvelope);
/**
 * Add an item to an envelope.
 * Make sure to always explicitly provide the generic to this function
 * so that the envelope types resolve correctly.
 */ parcelHelpers.export(exports, "addItemToEnvelope", ()=>addItemToEnvelope);
/**
 * Get the type of the envelope. Grabs the type from the first envelope item.
 */ parcelHelpers.export(exports, "getEnvelopeType", ()=>getEnvelopeType);
/**
 * Serializes an envelope into a string.
 */ parcelHelpers.export(exports, "serializeEnvelope", ()=>serializeEnvelope);
var _tslib = require("tslib");
var _is = require("./is");
function createEnvelope(headers, items) {
    if (items === void 0) items = [];
    return [
        headers,
        items
    ];
}
function addItemToEnvelope(envelope, newItem) {
    var _a = (0, _tslib.__read)(envelope, 2), headers = _a[0], items = _a[1];
    return [
        headers,
        (0, _tslib.__spread)(items, [
            newItem
        ])
    ];
}
function getEnvelopeType(envelope) {
    var _a = (0, _tslib.__read)(envelope, 2), _b = (0, _tslib.__read)(_a[1], 1), _c = (0, _tslib.__read)(_b[0], 1), firstItemHeader = _c[0];
    return firstItemHeader.type;
}
function serializeEnvelope(envelope) {
    var _a = (0, _tslib.__read)(envelope, 2), headers = _a[0], items = _a[1];
    var serializedHeaders = JSON.stringify(headers);
    // Have to cast items to any here since Envelope is a union type
    // Fixed in Typescript 4.2
    // TODO: Remove any[] cast when we upgrade to TS 4.2
    // https://github.com/microsoft/TypeScript/issues/36390
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    return items.reduce(function(acc, item) {
        var _a = (0, _tslib.__read)(item, 2), itemHeaders = _a[0], payload = _a[1];
        // We do not serialize payloads that are primitives
        var serializedPayload = (0, _is.isPrimitive)(payload) ? String(payload) : JSON.stringify(payload);
        return acc + "\n" + JSON.stringify(itemHeaders) + "\n" + serializedPayload;
    }, serializedHeaders);
}

},{"tslib":"6MhhU","./is":"kahuF","@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"cH2mT":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
/**
 * Creates client report envelope
 * @param discarded_events An array of discard events
 * @param dsn A DSN that can be set on the header. Optional.
 */ parcelHelpers.export(exports, "createClientReportEnvelope", ()=>createClientReportEnvelope);
var _envelope = require("./envelope");
var _time = require("./time");
function createClientReportEnvelope(discarded_events, dsn, timestamp) {
    var clientReportItem = [
        {
            type: 'client_report'
        },
        {
            timestamp: timestamp || (0, _time.dateTimestampInSeconds)(),
            discarded_events: discarded_events
        }
    ];
    return (0, _envelope.createEnvelope)(dsn ? {
        dsn: dsn
    } : {}, [
        clientReportItem
    ]);
}

},{"./envelope":"Op7jK","./time":"70NNx","@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"8Wuev":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "DEFAULT_RETRY_AFTER", ()=>DEFAULT_RETRY_AFTER);
/**
 * Extracts Retry-After value from the request header or returns default value
 * @param header string representation of 'Retry-After' header
 * @param now current unix timestamp
 *
 */ parcelHelpers.export(exports, "parseRetryAfterHeader", ()=>parseRetryAfterHeader);
/**
 * Gets the time that given category is disabled until for rate limiting
 */ parcelHelpers.export(exports, "disabledUntil", ()=>disabledUntil);
/**
 * Checks if a category is rate limited
 */ parcelHelpers.export(exports, "isRateLimited", ()=>isRateLimited);
/**
 * Update ratelimits from incoming headers.
 * Returns true if headers contains a non-empty rate limiting header.
 */ parcelHelpers.export(exports, "updateRateLimits", ()=>updateRateLimits);
var _tslib = require("tslib");
var DEFAULT_RETRY_AFTER = 60000; // 60 seconds
function parseRetryAfterHeader(header, now) {
    if (now === void 0) now = Date.now();
    var headerDelay = parseInt("" + header, 10);
    if (!isNaN(headerDelay)) return headerDelay * 1000;
    var headerDate = Date.parse("" + header);
    if (!isNaN(headerDate)) return headerDate - now;
    return DEFAULT_RETRY_AFTER;
}
function disabledUntil(limits, category) {
    return limits[category] || limits.all || 0;
}
function isRateLimited(limits, category, now) {
    if (now === void 0) now = Date.now();
    return disabledUntil(limits, category) > now;
}
function updateRateLimits(limits, headers, now) {
    var e_1, _a, e_2, _b;
    if (now === void 0) now = Date.now();
    var updatedRateLimits = (0, _tslib.__assign)({}, limits);
    // "The name is case-insensitive."
    // https://developer.mozilla.org/en-US/docs/Web/API/Headers/get
    var rateLimitHeader = headers['x-sentry-rate-limits'];
    var retryAfterHeader = headers['retry-after'];
    if (rateLimitHeader) try {
        /**
             * rate limit headers are of the form
             *     <header>,<header>,..
             * where each <header> is of the form
             *     <retry_after>: <categories>: <scope>: <reason_code>
             * where
             *     <retry_after> is a delay in seconds
             *     <categories> is the event type(s) (error, transaction, etc) being rate limited and is of the form
             *         <category>;<category>;...
             *     <scope> is what's being limited (org, project, or key) - ignored by SDK
             *     <reason_code> is an arbitrary string like "org_quota" - ignored by SDK
             */ for(var _c = (0, _tslib.__values)(rateLimitHeader.trim().split(',')), _d = _c.next(); !_d.done; _d = _c.next()){
            var limit = _d.value;
            var parameters = limit.split(':', 2);
            var headerDelay = parseInt(parameters[0], 10);
            var delay = (!isNaN(headerDelay) ? headerDelay : 60) * 1000; // 60sec default
            if (!parameters[1]) updatedRateLimits.all = now + delay;
            else try {
                for(var _e = (e_2 = void 0, (0, _tslib.__values)(parameters[1].split(';'))), _f = _e.next(); !_f.done; _f = _e.next()){
                    var category = _f.value;
                    updatedRateLimits[category] = now + delay;
                }
            } catch (e_2_1) {
                e_2 = {
                    error: e_2_1
                };
            } finally{
                try {
                    if (_f && !_f.done && (_b = _e.return)) _b.call(_e);
                } finally{
                    if (e_2) throw e_2.error;
                }
            }
        }
    } catch (e_1_1) {
        e_1 = {
            error: e_1_1
        };
    } finally{
        try {
            if (_d && !_d.done && (_a = _c.return)) _a.call(_c);
        } finally{
            if (e_1) throw e_1.error;
        }
    }
    else if (retryAfterHeader) updatedRateLimits.all = now + parseRetryAfterHeader(retryAfterHeader, now);
    return updatedRateLimits;
}

},{"tslib":"6MhhU","@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"7KRsD":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "BaseClient", ()=>BaseClient);
var _tslib = require("tslib");
/* eslint-disable max-lines */ var _hub = require("@sentry/hub");
var _utils = require("@sentry/utils");
var _flags = require("./flags");
var _integration = require("./integration");
var ALREADY_SEEN_ERROR = "Not capturing exception because it's already been captured.";
/**
 * Base implementation for all JavaScript SDK clients.
 *
 * Call the constructor with the corresponding backend constructor and options
 * specific to the client subclass. To access these options later, use
 * {@link Client.getOptions}. Also, the Backend instance is available via
 * {@link Client.getBackend}.
 *
 * If a Dsn is specified in the options, it will be parsed and stored. Use
 * {@link Client.getDsn} to retrieve the Dsn at any moment. In case the Dsn is
 * invalid, the constructor will throw a {@link SentryException}. Note that
 * without a valid Dsn, the SDK will not send any events to Sentry.
 *
 * Before sending an event via the backend, it is passed through
 * {@link BaseClient._prepareEvent} to add SDK information and scope data
 * (breadcrumbs and context). To add more custom information, override this
 * method and extend the resulting prepared event.
 *
 * To issue automatically created events (e.g. via instrumentation), use
 * {@link Client.captureEvent}. It will prepare the event and pass it through
 * the callback lifecycle. To issue auto-breadcrumbs, use
 * {@link Client.addBreadcrumb}.
 *
 * @example
 * class NodeClient extends BaseClient<NodeBackend, NodeOptions> {
 *   public constructor(options: NodeOptions) {
 *     super(NodeBackend, options);
 *   }
 *
 *   // ...
 * }
 */ var BaseClient = /** @class */ function() {
    /**
     * Initializes this client instance.
     *
     * @param backendClass A constructor function to create the backend.
     * @param options Options for the client.
     */ function BaseClient(backendClass, options) {
        /** Array of used integrations. */ this._integrations = {};
        /** Number of calls being processed */ this._numProcessing = 0;
        this._backend = new backendClass(options);
        this._options = options;
        if (options.dsn) this._dsn = (0, _utils.makeDsn)(options.dsn);
    }
    /**
     * @inheritDoc
     */ // eslint-disable-next-line @typescript-eslint/no-explicit-any, @typescript-eslint/explicit-module-boundary-types
    BaseClient.prototype.captureException = function(exception, hint, scope) {
        var _this = this;
        // ensure we haven't captured this very object before
        if ((0, _utils.checkOrSetAlreadyCaught)(exception)) {
            (0, _flags.IS_DEBUG_BUILD) && (0, _utils.logger).log(ALREADY_SEEN_ERROR);
            return;
        }
        var eventId = hint && hint.event_id;
        this._process(this._getBackend().eventFromException(exception, hint).then(function(event) {
            return _this._captureEvent(event, hint, scope);
        }).then(function(result) {
            eventId = result;
        }));
        return eventId;
    };
    /**
     * @inheritDoc
     */ BaseClient.prototype.captureMessage = function(message, level, hint, scope) {
        var _this = this;
        var eventId = hint && hint.event_id;
        var promisedEvent = (0, _utils.isPrimitive)(message) ? this._getBackend().eventFromMessage(String(message), level, hint) : this._getBackend().eventFromException(message, hint);
        this._process(promisedEvent.then(function(event) {
            return _this._captureEvent(event, hint, scope);
        }).then(function(result) {
            eventId = result;
        }));
        return eventId;
    };
    /**
     * @inheritDoc
     */ BaseClient.prototype.captureEvent = function(event, hint, scope) {
        // ensure we haven't captured this very object before
        if (hint && hint.originalException && (0, _utils.checkOrSetAlreadyCaught)(hint.originalException)) {
            (0, _flags.IS_DEBUG_BUILD) && (0, _utils.logger).log(ALREADY_SEEN_ERROR);
            return;
        }
        var eventId = hint && hint.event_id;
        this._process(this._captureEvent(event, hint, scope).then(function(result) {
            eventId = result;
        }));
        return eventId;
    };
    /**
     * @inheritDoc
     */ BaseClient.prototype.captureSession = function(session) {
        if (!this._isEnabled()) {
            (0, _flags.IS_DEBUG_BUILD) && (0, _utils.logger).warn('SDK not enabled, will not capture session.');
            return;
        }
        if (!(typeof session.release === 'string')) (0, _flags.IS_DEBUG_BUILD) && (0, _utils.logger).warn('Discarded session because of missing or non-string release');
        else {
            this._sendSession(session);
            // After sending, we set init false to indicate it's not the first occurrence
            session.update({
                init: false
            });
        }
    };
    /**
     * @inheritDoc
     */ BaseClient.prototype.getDsn = function() {
        return this._dsn;
    };
    /**
     * @inheritDoc
     */ BaseClient.prototype.getOptions = function() {
        return this._options;
    };
    /**
     * @inheritDoc
     */ BaseClient.prototype.getTransport = function() {
        return this._getBackend().getTransport();
    };
    /**
     * @inheritDoc
     */ BaseClient.prototype.flush = function(timeout) {
        var _this = this;
        return this._isClientDoneProcessing(timeout).then(function(clientFinished) {
            return _this.getTransport().close(timeout).then(function(transportFlushed) {
                return clientFinished && transportFlushed;
            });
        });
    };
    /**
     * @inheritDoc
     */ BaseClient.prototype.close = function(timeout) {
        var _this = this;
        return this.flush(timeout).then(function(result) {
            _this.getOptions().enabled = false;
            return result;
        });
    };
    /**
     * Sets up the integrations
     */ BaseClient.prototype.setupIntegrations = function() {
        if (this._isEnabled() && !this._integrations.initialized) this._integrations = (0, _integration.setupIntegrations)(this._options);
    };
    /**
     * @inheritDoc
     */ BaseClient.prototype.getIntegration = function(integration) {
        try {
            return this._integrations[integration.id] || null;
        } catch (_oO) {
            (0, _flags.IS_DEBUG_BUILD) && (0, _utils.logger).warn("Cannot retrieve integration " + integration.id + " from the current Client");
            return null;
        }
    };
    /** Updates existing session based on the provided event */ BaseClient.prototype._updateSessionFromEvent = function(session, event) {
        var e_1, _a;
        var crashed = false;
        var errored = false;
        var exceptions = event.exception && event.exception.values;
        if (exceptions) {
            errored = true;
            try {
                for(var exceptions_1 = (0, _tslib.__values)(exceptions), exceptions_1_1 = exceptions_1.next(); !exceptions_1_1.done; exceptions_1_1 = exceptions_1.next()){
                    var ex = exceptions_1_1.value;
                    var mechanism = ex.mechanism;
                    if (mechanism && mechanism.handled === false) {
                        crashed = true;
                        break;
                    }
                }
            } catch (e_1_1) {
                e_1 = {
                    error: e_1_1
                };
            } finally{
                try {
                    if (exceptions_1_1 && !exceptions_1_1.done && (_a = exceptions_1.return)) _a.call(exceptions_1);
                } finally{
                    if (e_1) throw e_1.error;
                }
            }
        }
        // A session is updated and that session update is sent in only one of the two following scenarios:
        // 1. Session with non terminal status and 0 errors + an error occurred -> Will set error count to 1 and send update
        // 2. Session with non terminal status and 1 error + a crash occurred -> Will set status crashed and send update
        var sessionNonTerminal = session.status === 'ok';
        var shouldUpdateAndSend = sessionNonTerminal && session.errors === 0 || sessionNonTerminal && crashed;
        if (shouldUpdateAndSend) {
            session.update((0, _tslib.__assign)((0, _tslib.__assign)({}, crashed && {
                status: 'crashed'
            }), {
                errors: session.errors || Number(errored || crashed)
            }));
            this.captureSession(session);
        }
    };
    /** Deliver captured session to Sentry */ BaseClient.prototype._sendSession = function(session) {
        this._getBackend().sendSession(session);
    };
    /**
     * Determine if the client is finished processing. Returns a promise because it will wait `timeout` ms before saying
     * "no" (resolving to `false`) in order to give the client a chance to potentially finish first.
     *
     * @param timeout The time, in ms, after which to resolve to `false` if the client is still busy. Passing `0` (or not
     * passing anything) will make the promise wait as long as it takes for processing to finish before resolving to
     * `true`.
     * @returns A promise which will resolve to `true` if processing is already done or finishes before the timeout, and
     * `false` otherwise
     */ BaseClient.prototype._isClientDoneProcessing = function(timeout) {
        var _this = this;
        return new (0, _utils.SyncPromise)(function(resolve) {
            var ticked = 0;
            var tick = 1;
            var interval = setInterval(function() {
                if (_this._numProcessing == 0) {
                    clearInterval(interval);
                    resolve(true);
                } else {
                    ticked += tick;
                    if (timeout && ticked >= timeout) {
                        clearInterval(interval);
                        resolve(false);
                    }
                }
            }, tick);
        });
    };
    /** Returns the current backend. */ BaseClient.prototype._getBackend = function() {
        return this._backend;
    };
    /** Determines whether this SDK is enabled and a valid Dsn is present. */ BaseClient.prototype._isEnabled = function() {
        return this.getOptions().enabled !== false && this._dsn !== undefined;
    };
    /**
     * Adds common information to events.
     *
     * The information includes release and environment from `options`,
     * breadcrumbs and context (extra, tags and user) from the scope.
     *
     * Information that is already present in the event is never overwritten. For
     * nested objects, such as the context, keys are merged.
     *
     * @param event The original event.
     * @param hint May contain additional information about the original exception.
     * @param scope A scope containing event metadata.
     * @returns A new event with more information.
     */ BaseClient.prototype._prepareEvent = function(event, scope, hint) {
        var _this = this;
        var _a = this.getOptions(), _b = _a.normalizeDepth, normalizeDepth = _b === void 0 ? 3 : _b, _c = _a.normalizeMaxBreadth, normalizeMaxBreadth = _c === void 0 ? 1000 : _c;
        var prepared = (0, _tslib.__assign)((0, _tslib.__assign)({}, event), {
            event_id: event.event_id || (hint && hint.event_id ? hint.event_id : (0, _utils.uuid4)()),
            timestamp: event.timestamp || (0, _utils.dateTimestampInSeconds)()
        });
        this._applyClientOptions(prepared);
        this._applyIntegrationsMetadata(prepared);
        // If we have scope given to us, use it as the base for further modifications.
        // This allows us to prevent unnecessary copying of data if `captureContext` is not provided.
        var finalScope = scope;
        if (hint && hint.captureContext) finalScope = (0, _hub.Scope).clone(finalScope).update(hint.captureContext);
        // We prepare the result here with a resolved Event.
        var result = (0, _utils.resolvedSyncPromise)(prepared);
        // This should be the last thing called, since we want that
        // {@link Hub.addEventProcessor} gets the finished prepared event.
        if (finalScope) // In case we have a hub we reassign it.
        result = finalScope.applyToEvent(prepared, hint);
        return result.then(function(evt) {
            if (evt) // TODO this is more of the hack trying to solve https://github.com/getsentry/sentry-javascript/issues/2809
            // it is only attached as extra data to the event if the event somehow skips being normalized
            evt.sdkProcessingMetadata = (0, _tslib.__assign)((0, _tslib.__assign)({}, evt.sdkProcessingMetadata), {
                normalizeDepth: (0, _utils.normalize)(normalizeDepth) + " (" + typeof normalizeDepth + ")"
            });
            if (typeof normalizeDepth === 'number' && normalizeDepth > 0) return _this._normalizeEvent(evt, normalizeDepth, normalizeMaxBreadth);
            return evt;
        });
    };
    /**
     * Applies `normalize` function on necessary `Event` attributes to make them safe for serialization.
     * Normalized keys:
     * - `breadcrumbs.data`
     * - `user`
     * - `contexts`
     * - `extra`
     * @param event Event
     * @returns Normalized event
     */ BaseClient.prototype._normalizeEvent = function(event, depth, maxBreadth) {
        if (!event) return null;
        var normalized = (0, _tslib.__assign)((0, _tslib.__assign)((0, _tslib.__assign)((0, _tslib.__assign)((0, _tslib.__assign)({}, event), event.breadcrumbs && {
            breadcrumbs: event.breadcrumbs.map(function(b) {
                return (0, _tslib.__assign)((0, _tslib.__assign)({}, b), b.data && {
                    data: (0, _utils.normalize)(b.data, depth, maxBreadth)
                });
            })
        }), event.user && {
            user: (0, _utils.normalize)(event.user, depth, maxBreadth)
        }), event.contexts && {
            contexts: (0, _utils.normalize)(event.contexts, depth, maxBreadth)
        }), event.extra && {
            extra: (0, _utils.normalize)(event.extra, depth, maxBreadth)
        });
        // event.contexts.trace stores information about a Transaction. Similarly,
        // event.spans[] stores information about child Spans. Given that a
        // Transaction is conceptually a Span, normalization should apply to both
        // Transactions and Spans consistently.
        // For now the decision is to skip normalization of Transactions and Spans,
        // so this block overwrites the normalized event to add back the original
        // Transaction information prior to normalization.
        if (event.contexts && event.contexts.trace) // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access
        normalized.contexts.trace = event.contexts.trace;
        normalized.sdkProcessingMetadata = (0, _tslib.__assign)((0, _tslib.__assign)({}, normalized.sdkProcessingMetadata), {
            baseClientNormalized: true
        });
        return normalized;
    };
    /**
     *  Enhances event using the client configuration.
     *  It takes care of all "static" values like environment, release and `dist`,
     *  as well as truncating overly long values.
     * @param event event instance to be enhanced
     */ BaseClient.prototype._applyClientOptions = function(event) {
        var options = this.getOptions();
        var environment = options.environment, release = options.release, dist = options.dist, _a = options.maxValueLength, maxValueLength = _a === void 0 ? 250 : _a;
        if (!('environment' in event)) event.environment = 'environment' in options ? environment : 'production';
        if (event.release === undefined && release !== undefined) event.release = release;
        if (event.dist === undefined && dist !== undefined) event.dist = dist;
        if (event.message) event.message = (0, _utils.truncate)(event.message, maxValueLength);
        var exception = event.exception && event.exception.values && event.exception.values[0];
        if (exception && exception.value) exception.value = (0, _utils.truncate)(exception.value, maxValueLength);
        var request = event.request;
        if (request && request.url) request.url = (0, _utils.truncate)(request.url, maxValueLength);
    };
    /**
     * This function adds all used integrations to the SDK info in the event.
     * @param event The event that will be filled with all integrations.
     */ BaseClient.prototype._applyIntegrationsMetadata = function(event) {
        var integrationsArray = Object.keys(this._integrations);
        if (integrationsArray.length > 0) {
            event.sdk = event.sdk || {};
            event.sdk.integrations = (0, _tslib.__spread)(event.sdk.integrations || [], integrationsArray);
        }
    };
    /**
     * Tells the backend to send this event
     * @param event The Sentry event to send
     */ BaseClient.prototype._sendEvent = function(event) {
        this._getBackend().sendEvent(event);
    };
    /**
     * Processes the event and logs an error in case of rejection
     * @param event
     * @param hint
     * @param scope
     */ BaseClient.prototype._captureEvent = function(event, hint, scope) {
        return this._processEvent(event, hint, scope).then(function(finalEvent) {
            return finalEvent.event_id;
        }, function(reason) {
            (0, _flags.IS_DEBUG_BUILD) && (0, _utils.logger).error(reason);
            return undefined;
        });
    };
    /**
     * Processes an event (either error or message) and sends it to Sentry.
     *
     * This also adds breadcrumbs and context information to the event. However,
     * platform specific meta data (such as the User's IP address) must be added
     * by the SDK implementor.
     *
     *
     * @param event The event to send to Sentry.
     * @param hint May contain additional information about the original exception.
     * @param scope A scope containing event metadata.
     * @returns A SyncPromise that resolves with the event or rejects in case event was/will not be send.
     */ BaseClient.prototype._processEvent = function(event, hint, scope) {
        var _this = this;
        // eslint-disable-next-line @typescript-eslint/unbound-method
        var _a = this.getOptions(), beforeSend = _a.beforeSend, sampleRate = _a.sampleRate;
        var transport = this.getTransport();
        function recordLostEvent(outcome, category) {
            if (transport.recordLostEvent) transport.recordLostEvent(outcome, category);
        }
        if (!this._isEnabled()) return (0, _utils.rejectedSyncPromise)(new (0, _utils.SentryError)('SDK not enabled, will not capture event.'));
        var isTransaction = event.type === 'transaction';
        // 1.0 === 100% events are sent
        // 0.0 === 0% events are sent
        // Sampling for transaction happens somewhere else
        if (!isTransaction && typeof sampleRate === 'number' && Math.random() > sampleRate) {
            recordLostEvent('sample_rate', 'event');
            return (0, _utils.rejectedSyncPromise)(new (0, _utils.SentryError)("Discarding event because it's not included in the random sample (sampling rate = " + sampleRate + ")"));
        }
        return this._prepareEvent(event, scope, hint).then(function(prepared) {
            if (prepared === null) {
                recordLostEvent('event_processor', event.type || 'event');
                throw new (0, _utils.SentryError)('An event processor returned null, will not send event.');
            }
            var isInternalException = hint && hint.data && hint.data.__sentry__ === true;
            if (isInternalException || isTransaction || !beforeSend) return prepared;
            var beforeSendResult = beforeSend(prepared, hint);
            return _ensureBeforeSendRv(beforeSendResult);
        }).then(function(processedEvent) {
            if (processedEvent === null) {
                recordLostEvent('before_send', event.type || 'event');
                throw new (0, _utils.SentryError)('`beforeSend` returned `null`, will not send event.');
            }
            var session = scope && scope.getSession && scope.getSession();
            if (!isTransaction && session) _this._updateSessionFromEvent(session, processedEvent);
            _this._sendEvent(processedEvent);
            return processedEvent;
        }).then(null, function(reason) {
            if (reason instanceof (0, _utils.SentryError)) throw reason;
            _this.captureException(reason, {
                data: {
                    __sentry__: true
                },
                originalException: reason
            });
            throw new (0, _utils.SentryError)("Event processing pipeline threw an error, original event will not be sent. Details have been sent as a new event.\nReason: " + reason);
        });
    };
    /**
     * Occupies the client with processing and event
     */ BaseClient.prototype._process = function(promise) {
        var _this = this;
        this._numProcessing += 1;
        promise.then(function(value) {
            _this._numProcessing -= 1;
            return value;
        }, function(reason) {
            _this._numProcessing -= 1;
            return reason;
        });
    };
    return BaseClient;
}();
/**
 * Verifies that return value of configured `beforeSend` is of expected type.
 */ function _ensureBeforeSendRv(rv) {
    var nullErr = '`beforeSend` method has to return `null` or a valid event.';
    if ((0, _utils.isThenable)(rv)) return rv.then(function(event) {
        if (!((0, _utils.isPlainObject)(event) || event === null)) throw new (0, _utils.SentryError)(nullErr);
        return event;
    }, function(e) {
        throw new (0, _utils.SentryError)("beforeSend rejected with " + e);
    });
    else if (!((0, _utils.isPlainObject)(rv) || rv === null)) throw new (0, _utils.SentryError)(nullErr);
    return rv;
}

},{"tslib":"6MhhU","@sentry/hub":"8w5kA","@sentry/utils":"5wUYP","./flags":"31xzb","./integration":"l2qPk","@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"31xzb":[function(require,module,exports,__globalThis) {
/*
 * This file defines flags and constants that can be modified during compile time in order to facilitate tree shaking
 * for users.
 *
 * Debug flags need to be declared in each package individually and must not be imported across package boundaries,
 * because some build tools have trouble tree-shaking imported guards.
 *
 * As a convention, we define debug flags in a `flags.ts` file in the root of a package's `src` folder.
 *
 * Debug flag files will contain "magic strings" like `__SENTRY_DEBUG__` that may get replaced with actual values during
 * our, or the user's build process. Take care when introducing new flags - they must not throw if they are not
 * replaced.
 */ /** Flag that is true for debug builds, false otherwise. */ var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "IS_DEBUG_BUILD", ()=>IS_DEBUG_BUILD);
var IS_DEBUG_BUILD = typeof __SENTRY_DEBUG__ === 'undefined' ? true : __SENTRY_DEBUG__;

},{"@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"l2qPk":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "installedIntegrations", ()=>installedIntegrations);
/** Gets integration to install */ parcelHelpers.export(exports, "getIntegrationsToSetup", ()=>getIntegrationsToSetup);
/** Setup given integration */ parcelHelpers.export(exports, "setupIntegration", ()=>setupIntegration);
/**
 * Given a list of integration instances this installs them all. When `withDefaults` is set to `true` then all default
 * integrations are added unless they were already provided before.
 * @param integrations array of integration instances
 * @param withDefault should enable default integrations
 */ parcelHelpers.export(exports, "setupIntegrations", ()=>setupIntegrations);
var _tslib = require("tslib");
var _hub = require("@sentry/hub");
var _utils = require("@sentry/utils");
var _flags = require("./flags");
var installedIntegrations = [];
/**
 * @private
 */ function filterDuplicates(integrations) {
    return integrations.reduce(function(acc, integrations) {
        if (acc.every(function(accIntegration) {
            return integrations.name !== accIntegration.name;
        })) acc.push(integrations);
        return acc;
    }, []);
}
function getIntegrationsToSetup(options) {
    var defaultIntegrations = options.defaultIntegrations && (0, _tslib.__spread)(options.defaultIntegrations) || [];
    var userIntegrations = options.integrations;
    var integrations = (0, _tslib.__spread)(filterDuplicates(defaultIntegrations));
    if (Array.isArray(userIntegrations)) // Filter out integrations that are also included in user options
    integrations = (0, _tslib.__spread)(integrations.filter(function(integrations) {
        return userIntegrations.every(function(userIntegration) {
            return userIntegration.name !== integrations.name;
        });
    }), filterDuplicates(userIntegrations));
    else if (typeof userIntegrations === 'function') {
        integrations = userIntegrations(integrations);
        integrations = Array.isArray(integrations) ? integrations : [
            integrations
        ];
    }
    // Make sure that if present, `Debug` integration will always run last
    var integrationsNames = integrations.map(function(i) {
        return i.name;
    });
    var alwaysLastToRun = 'Debug';
    if (integrationsNames.indexOf(alwaysLastToRun) !== -1) integrations.push.apply(integrations, (0, _tslib.__spread)(integrations.splice(integrationsNames.indexOf(alwaysLastToRun), 1)));
    return integrations;
}
function setupIntegration(integration) {
    if (installedIntegrations.indexOf(integration.name) !== -1) return;
    integration.setupOnce((0, _hub.addGlobalEventProcessor), (0, _hub.getCurrentHub));
    installedIntegrations.push(integration.name);
    (0, _flags.IS_DEBUG_BUILD) && (0, _utils.logger).log("Integration installed: " + integration.name);
}
function setupIntegrations(options) {
    var integrations = {};
    getIntegrationsToSetup(options).forEach(function(integration) {
        integrations[integration.name] = integration;
        setupIntegration(integration);
    });
    // set the `initialized` flag so we don't run through the process again unecessarily; use `Object.defineProperty`
    // because by default it creates a property which is nonenumerable, which we want since `initialized` shouldn't be
    // considered a member of the index the way the actual integrations are
    (0, _utils.addNonEnumerableProperty)(integrations, 'initialized', true);
    return integrations;
}

},{"tslib":"6MhhU","@sentry/hub":"8w5kA","@sentry/utils":"5wUYP","./flags":"31xzb","@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"bkQLA":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "BaseBackend", ()=>BaseBackend);
var _tslib = require("tslib");
var _utils = require("@sentry/utils");
var _api = require("./api");
var _flags = require("./flags");
var _request = require("./request");
var _noop = require("./transports/noop");
/**
 * This is the base implemention of a Backend.
 * @hidden
 */ var BaseBackend = /** @class */ function() {
    /** Creates a new backend instance. */ function BaseBackend(options) {
        this._options = options;
        if (!this._options.dsn) (0, _flags.IS_DEBUG_BUILD) && (0, _utils.logger).warn('No DSN provided, backend will not do anything.');
        this._transport = this._setupTransport();
    }
    /**
     * @inheritDoc
     */ // eslint-disable-next-line @typescript-eslint/no-explicit-any, @typescript-eslint/explicit-module-boundary-types
    BaseBackend.prototype.eventFromException = function(_exception, _hint) {
        throw new (0, _utils.SentryError)('Backend has to implement `eventFromException` method');
    };
    /**
     * @inheritDoc
     */ BaseBackend.prototype.eventFromMessage = function(_message, _level, _hint) {
        throw new (0, _utils.SentryError)('Backend has to implement `eventFromMessage` method');
    };
    /**
     * @inheritDoc
     */ BaseBackend.prototype.sendEvent = function(event) {
        // TODO(v7): Remove the if-else
        if (this._newTransport && this._options.dsn && this._options._experiments && this._options._experiments.newTransport) {
            var api = (0, _api.initAPIDetails)(this._options.dsn, this._options._metadata, this._options.tunnel);
            var env = (0, _request.createEventEnvelope)(event, api);
            this._newTransport.send(env).then(null, function(reason) {
                (0, _flags.IS_DEBUG_BUILD) && (0, _utils.logger).error('Error while sending event:', reason);
            });
        } else this._transport.sendEvent(event).then(null, function(reason) {
            (0, _flags.IS_DEBUG_BUILD) && (0, _utils.logger).error('Error while sending event:', reason);
        });
    };
    /**
     * @inheritDoc
     */ BaseBackend.prototype.sendSession = function(session) {
        if (!this._transport.sendSession) {
            (0, _flags.IS_DEBUG_BUILD) && (0, _utils.logger).warn("Dropping session because custom transport doesn't implement sendSession");
            return;
        }
        // TODO(v7): Remove the if-else
        if (this._newTransport && this._options.dsn && this._options._experiments && this._options._experiments.newTransport) {
            var api = (0, _api.initAPIDetails)(this._options.dsn, this._options._metadata, this._options.tunnel);
            var _a = (0, _tslib.__read)((0, _request.createSessionEnvelope)(session, api), 1), env = _a[0];
            this._newTransport.send(env).then(null, function(reason) {
                (0, _flags.IS_DEBUG_BUILD) && (0, _utils.logger).error('Error while sending session:', reason);
            });
        } else this._transport.sendSession(session).then(null, function(reason) {
            (0, _flags.IS_DEBUG_BUILD) && (0, _utils.logger).error('Error while sending session:', reason);
        });
    };
    /**
     * @inheritDoc
     */ BaseBackend.prototype.getTransport = function() {
        return this._transport;
    };
    /**
     * Sets up the transport so it can be used later to send requests.
     */ BaseBackend.prototype._setupTransport = function() {
        return new (0, _noop.NoopTransport)();
    };
    return BaseBackend;
}();

},{"tslib":"6MhhU","@sentry/utils":"5wUYP","./api":"2DOw8","./flags":"31xzb","./request":"96gCW","./transports/noop":"aqDdq","@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"96gCW":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
/** Creates an envelope from a Session */ parcelHelpers.export(exports, "createSessionEnvelope", ()=>createSessionEnvelope);
/** Creates a SentryRequest from a Session. */ parcelHelpers.export(exports, "sessionToSentryRequest", ()=>sessionToSentryRequest);
/**
 * Create an Envelope from an event. Note that this is duplicated from below,
 * but on purpose as this will be refactored in v7.
 */ parcelHelpers.export(exports, "createEventEnvelope", ()=>createEventEnvelope);
/** Creates a SentryRequest from an event. */ parcelHelpers.export(exports, "eventToSentryRequest", ()=>eventToSentryRequest);
var _tslib = require("tslib");
var _utils = require("@sentry/utils");
var _api = require("./api");
/** Extract sdk info from from the API metadata */ function getSdkMetadataForEnvelopeHeader(api) {
    if (!api.metadata || !api.metadata.sdk) return;
    var _a = api.metadata.sdk, name = _a.name, version = _a.version;
    return {
        name: name,
        version: version
    };
}
/**
 * Apply SdkInfo (name, version, packages, integrations) to the corresponding event key.
 * Merge with existing data if any.
 **/ function enhanceEventWithSdkInfo(event, sdkInfo) {
    if (!sdkInfo) return event;
    event.sdk = event.sdk || {};
    event.sdk.name = event.sdk.name || sdkInfo.name;
    event.sdk.version = event.sdk.version || sdkInfo.version;
    event.sdk.integrations = (0, _tslib.__spread)(event.sdk.integrations || [], sdkInfo.integrations || []);
    event.sdk.packages = (0, _tslib.__spread)(event.sdk.packages || [], sdkInfo.packages || []);
    return event;
}
function createSessionEnvelope(session, api) {
    var sdkInfo = getSdkMetadataForEnvelopeHeader(api);
    var envelopeHeaders = (0, _tslib.__assign)((0, _tslib.__assign)({
        sent_at: new Date().toISOString()
    }, sdkInfo && {
        sdk: sdkInfo
    }), !!api.tunnel && {
        dsn: (0, _utils.dsnToString)(api.dsn)
    });
    // I know this is hacky but we don't want to add `sessions` to request type since it's never rate limited
    var type = 'aggregates' in session ? 'sessions' : 'session';
    // TODO (v7) Have to cast type because envelope items do not accept a `SentryRequestType`
    var envelopeItem = [
        {
            type: type
        },
        session
    ];
    var envelope = (0, _utils.createEnvelope)(envelopeHeaders, [
        envelopeItem
    ]);
    return [
        envelope,
        type
    ];
}
function sessionToSentryRequest(session, api) {
    var _a = (0, _tslib.__read)(createSessionEnvelope(session, api), 2), envelope = _a[0], type = _a[1];
    return {
        body: (0, _utils.serializeEnvelope)(envelope),
        type: type,
        url: (0, _api.getEnvelopeEndpointWithUrlEncodedAuth)(api.dsn, api.tunnel)
    };
}
function createEventEnvelope(event, api) {
    var sdkInfo = getSdkMetadataForEnvelopeHeader(api);
    var eventType = event.type || 'event';
    var transactionSampling = (event.sdkProcessingMetadata || {}).transactionSampling;
    var _a = transactionSampling || {}, samplingMethod = _a.method, sampleRate = _a.rate;
    // TODO: Below is a temporary hack in order to debug a serialization error - see
    // https://github.com/getsentry/sentry-javascript/issues/2809,
    // https://github.com/getsentry/sentry-javascript/pull/4425, and
    // https://github.com/getsentry/sentry-javascript/pull/4574.
    //
    // TL; DR: even though we normalize all events (which should prevent this), something is causing `JSON.stringify` to
    // throw a circular reference error.
    //
    // When it's time to remove it:
    // 1. Delete everything between here and where the request object `req` is created, EXCEPT the line deleting
    //    `sdkProcessingMetadata`
    // 2. Restore the original version of the request body, which is commented out
    // 3. Search for either of the PR URLs above and pull out the companion hacks in the browser playwright tests and the
    //    baseClient tests in this package
    enhanceEventWithSdkInfo(event, api.metadata.sdk);
    event.tags = event.tags || {};
    event.extra = event.extra || {};
    // In theory, all events should be marked as having gone through normalization and so
    // we should never set this tag/extra data
    if (!(event.sdkProcessingMetadata && event.sdkProcessingMetadata.baseClientNormalized)) {
        event.tags.skippedNormalization = true;
        event.extra.normalizeDepth = event.sdkProcessingMetadata ? event.sdkProcessingMetadata.normalizeDepth : 'unset';
    }
    // prevent this data from being sent to sentry
    // TODO: This is NOT part of the hack - DO NOT DELETE
    delete event.sdkProcessingMetadata;
    var envelopeHeaders = (0, _tslib.__assign)((0, _tslib.__assign)({
        event_id: event.event_id,
        sent_at: new Date().toISOString()
    }, sdkInfo && {
        sdk: sdkInfo
    }), !!api.tunnel && {
        dsn: (0, _utils.dsnToString)(api.dsn)
    });
    var eventItem = [
        {
            type: eventType,
            sample_rates: [
                {
                    id: samplingMethod,
                    rate: sampleRate
                }
            ]
        },
        event
    ];
    return (0, _utils.createEnvelope)(envelopeHeaders, [
        eventItem
    ]);
}
function eventToSentryRequest(event, api) {
    var sdkInfo = getSdkMetadataForEnvelopeHeader(api);
    var eventType = event.type || 'event';
    var useEnvelope = eventType === 'transaction' || !!api.tunnel;
    var transactionSampling = (event.sdkProcessingMetadata || {}).transactionSampling;
    var _a = transactionSampling || {}, samplingMethod = _a.method, sampleRate = _a.rate;
    // TODO: Below is a temporary hack in order to debug a serialization error - see
    // https://github.com/getsentry/sentry-javascript/issues/2809,
    // https://github.com/getsentry/sentry-javascript/pull/4425, and
    // https://github.com/getsentry/sentry-javascript/pull/4574.
    //
    // TL; DR: even though we normalize all events (which should prevent this), something is causing `JSON.stringify` to
    // throw a circular reference error.
    //
    // When it's time to remove it:
    // 1. Delete everything between here and where the request object `req` is created, EXCEPT the line deleting
    //    `sdkProcessingMetadata`
    // 2. Restore the original version of the request body, which is commented out
    // 3. Search for either of the PR URLs above and pull out the companion hacks in the browser playwright tests and the
    //    baseClient tests in this package
    enhanceEventWithSdkInfo(event, api.metadata.sdk);
    event.tags = event.tags || {};
    event.extra = event.extra || {};
    // In theory, all events should be marked as having gone through normalization and so
    // we should never set this tag/extra data
    if (!(event.sdkProcessingMetadata && event.sdkProcessingMetadata.baseClientNormalized)) {
        event.tags.skippedNormalization = true;
        event.extra.normalizeDepth = event.sdkProcessingMetadata ? event.sdkProcessingMetadata.normalizeDepth : 'unset';
    }
    // prevent this data from being sent to sentry
    // TODO: This is NOT part of the hack - DO NOT DELETE
    delete event.sdkProcessingMetadata;
    var body;
    try {
        // 99.9% of events should get through just fine - no change in behavior for them
        body = JSON.stringify(event);
    } catch (err) {
        // Record data about the error without replacing original event data, then force renormalization
        event.tags.JSONStringifyError = true;
        event.extra.JSONStringifyError = err;
        try {
            body = JSON.stringify((0, _utils.normalize)(event));
        } catch (newErr) {
            // At this point even renormalization hasn't worked, meaning something about the event data has gone very wrong.
            // Time to cut our losses and record only the new error. With luck, even in the problematic cases we're trying to
            // debug with this hack, we won't ever land here.
            var innerErr = newErr;
            body = JSON.stringify({
                message: 'JSON.stringify error after renormalization',
                // setting `extra: { innerErr }` here for some reason results in an empty object, so unpack manually
                extra: {
                    message: innerErr.message,
                    stack: innerErr.stack
                }
            });
        }
    }
    var req = {
        // this is the relevant line of code before the hack was added, to make it easy to undo said hack once we've solved
        // the mystery
        // body: JSON.stringify(sdkInfo ? enhanceEventWithSdkInfo(event, api.metadata.sdk) : event),
        body: body,
        type: eventType,
        url: useEnvelope ? (0, _api.getEnvelopeEndpointWithUrlEncodedAuth)(api.dsn, api.tunnel) : (0, _api.getStoreEndpointWithUrlEncodedAuth)(api.dsn)
    };
    // https://develop.sentry.dev/sdk/envelopes/
    // Since we don't need to manipulate envelopes nor store them, there is no
    // exported concept of an Envelope with operations including serialization and
    // deserialization. Instead, we only implement a minimal subset of the spec to
    // serialize events inline here.
    if (useEnvelope) {
        var envelopeHeaders = (0, _tslib.__assign)((0, _tslib.__assign)({
            event_id: event.event_id,
            sent_at: new Date().toISOString()
        }, sdkInfo && {
            sdk: sdkInfo
        }), !!api.tunnel && {
            dsn: (0, _utils.dsnToString)(api.dsn)
        });
        var eventItem = [
            {
                type: eventType,
                sample_rates: [
                    {
                        id: samplingMethod,
                        rate: sampleRate
                    }
                ]
            },
            req.body
        ];
        var envelope = (0, _utils.createEnvelope)(envelopeHeaders, [
            eventItem
        ]);
        req.body = (0, _utils.serializeEnvelope)(envelope);
    }
    return req;
}

},{"tslib":"6MhhU","@sentry/utils":"5wUYP","./api":"2DOw8","@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"aqDdq":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "NoopTransport", ()=>NoopTransport);
var _utils = require("@sentry/utils");
/** Noop transport */ var NoopTransport = /** @class */ function() {
    function NoopTransport() {}
    /**
     * @inheritDoc
     */ NoopTransport.prototype.sendEvent = function(_) {
        return (0, _utils.resolvedSyncPromise)({
            reason: 'NoopTransport: Event has been skipped because no Dsn is configured.',
            status: 'skipped'
        });
    };
    /**
     * @inheritDoc
     */ NoopTransport.prototype.close = function(_) {
        return (0, _utils.resolvedSyncPromise)(true);
    };
    return NoopTransport;
}();

},{"@sentry/utils":"5wUYP","@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"7760M":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
/**
 * Internal function to create a new SDK client instance. The client is
 * installed and then bound to the current scope.
 *
 * @param clientClass The client class to instantiate.
 * @param options Options to pass to the client.
 */ parcelHelpers.export(exports, "initAndBind", ()=>initAndBind);
var _hub = require("@sentry/hub");
var _utils = require("@sentry/utils");
var _flags = require("./flags");
function initAndBind(clientClass, options) {
    if (options.debug === true) {
        if (0, _flags.IS_DEBUG_BUILD) (0, _utils.logger).enable();
        else // use `console.warn` rather than `logger.warn` since by non-debug bundles have all `logger.x` statements stripped
        // eslint-disable-next-line no-console
        console.warn('[Sentry] Cannot initialize SDK with `debug` option using a non-debug bundle.');
    }
    var hub = (0, _hub.getCurrentHub)();
    var scope = hub.getScope();
    if (scope) scope.update(options.initialScope);
    var client = new clientClass(options);
    hub.bindClient(client);
}

},{"@sentry/hub":"8w5kA","@sentry/utils":"5wUYP","./flags":"31xzb","@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"2EtCn":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "ERROR_TRANSPORT_CATEGORY", ()=>ERROR_TRANSPORT_CATEGORY);
parcelHelpers.export(exports, "TRANSACTION_TRANSPORT_CATEGORY", ()=>TRANSACTION_TRANSPORT_CATEGORY);
parcelHelpers.export(exports, "ATTACHMENT_TRANSPORT_CATEGORY", ()=>ATTACHMENT_TRANSPORT_CATEGORY);
parcelHelpers.export(exports, "SESSION_TRANSPORT_CATEGORY", ()=>SESSION_TRANSPORT_CATEGORY);
parcelHelpers.export(exports, "DEFAULT_TRANSPORT_BUFFER_SIZE", ()=>DEFAULT_TRANSPORT_BUFFER_SIZE);
/**
 * Creates a `NewTransport`
 *
 * @param options
 * @param makeRequest
 */ parcelHelpers.export(exports, "createTransport", ()=>createTransport);
var _utils = require("@sentry/utils");
var ERROR_TRANSPORT_CATEGORY = 'error';
var TRANSACTION_TRANSPORT_CATEGORY = 'transaction';
var ATTACHMENT_TRANSPORT_CATEGORY = 'attachment';
var SESSION_TRANSPORT_CATEGORY = 'session';
var DEFAULT_TRANSPORT_BUFFER_SIZE = 30;
function createTransport(options, makeRequest, buffer) {
    if (buffer === void 0) buffer = (0, _utils.makePromiseBuffer)(options.bufferSize || DEFAULT_TRANSPORT_BUFFER_SIZE);
    var rateLimits = {};
    var flush = function(timeout) {
        return buffer.drain(timeout);
    };
    function send(envelope) {
        var envCategory = (0, _utils.getEnvelopeType)(envelope);
        var category = envCategory === 'event' ? 'error' : envCategory;
        var request = {
            category: category,
            body: (0, _utils.serializeEnvelope)(envelope)
        };
        // Don't add to buffer if transport is already rate-limited
        if ((0, _utils.isRateLimited)(rateLimits, category)) return (0, _utils.rejectedSyncPromise)({
            status: 'rate_limit',
            reason: getRateLimitReason(rateLimits, category)
        });
        var requestTask = function() {
            return makeRequest(request).then(function(_a) {
                var body = _a.body, headers = _a.headers, reason = _a.reason, statusCode = _a.statusCode;
                var status = (0, _utils.eventStatusFromHttpCode)(statusCode);
                if (headers) rateLimits = (0, _utils.updateRateLimits)(rateLimits, headers);
                if (status === 'success') return (0, _utils.resolvedSyncPromise)({
                    status: status,
                    reason: reason
                });
                return (0, _utils.rejectedSyncPromise)({
                    status: status,
                    reason: reason || body || (status === 'rate_limit' ? getRateLimitReason(rateLimits, category) : 'Unknown transport error')
                });
            });
        };
        return buffer.add(requestTask);
    }
    return {
        send: send,
        flush: flush
    };
}
function getRateLimitReason(rateLimits, category) {
    return "Too many " + category + " requests, backing off until: " + new Date((0, _utils.disabledUntil)(rateLimits, category)).toISOString();
}

},{"@sentry/utils":"5wUYP","@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"l0lUl":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "SDK_VERSION", ()=>SDK_VERSION);
var SDK_VERSION = '6.19.7';

},{"@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"aivRK":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "FunctionToString", ()=>(0, _functiontostring.FunctionToString));
parcelHelpers.export(exports, "InboundFilters", ()=>(0, _inboundfilters.InboundFilters));
var _functiontostring = require("./functiontostring");
var _inboundfilters = require("./inboundfilters");

},{"./functiontostring":"bN8A0","./inboundfilters":"dlQdl","@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"bN8A0":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "FunctionToString", ()=>FunctionToString);
var _utils = require("@sentry/utils");
var originalFunctionToString;
/** Patch toString calls to return proper name for wrapped functions */ var FunctionToString = /** @class */ function() {
    function FunctionToString() {
        /**
         * @inheritDoc
         */ this.name = FunctionToString.id;
    }
    /**
     * @inheritDoc
     */ FunctionToString.prototype.setupOnce = function() {
        // eslint-disable-next-line @typescript-eslint/unbound-method
        originalFunctionToString = Function.prototype.toString;
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        Function.prototype.toString = function() {
            var args = [];
            for(var _i = 0; _i < arguments.length; _i++)args[_i] = arguments[_i];
            var context = (0, _utils.getOriginalFunction)(this) || this;
            return originalFunctionToString.apply(context, args);
        };
    };
    /**
     * @inheritDoc
     */ FunctionToString.id = 'FunctionToString';
    return FunctionToString;
}();

},{"@sentry/utils":"5wUYP","@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"dlQdl":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "InboundFilters", ()=>InboundFilters);
/** JSDoc */ parcelHelpers.export(exports, "_mergeOptions", ()=>_mergeOptions);
/** JSDoc */ parcelHelpers.export(exports, "_shouldDropEvent", ()=>_shouldDropEvent);
var _tslib = require("tslib");
var _utils = require("@sentry/utils");
var _flags = require("../flags");
// "Script error." is hard coded into browsers for errors that it can't read.
// this is the result of a script being pulled in from an external domain and CORS.
var DEFAULT_IGNORE_ERRORS = [
    /^Script error\.?$/,
    /^Javascript error: Script error\.? on line 0$/
];
/** Inbound filters configurable by the user */ var InboundFilters = /** @class */ function() {
    function InboundFilters(_options) {
        if (_options === void 0) _options = {};
        this._options = _options;
        /**
         * @inheritDoc
         */ this.name = InboundFilters.id;
    }
    /**
     * @inheritDoc
     */ InboundFilters.prototype.setupOnce = function(addGlobalEventProcessor, getCurrentHub) {
        addGlobalEventProcessor(function(event) {
            var hub = getCurrentHub();
            if (hub) {
                var self_1 = hub.getIntegration(InboundFilters);
                if (self_1) {
                    var client = hub.getClient();
                    var clientOptions = client ? client.getOptions() : {};
                    var options = _mergeOptions(self_1._options, clientOptions);
                    return _shouldDropEvent(event, options) ? null : event;
                }
            }
            return event;
        });
    };
    /**
     * @inheritDoc
     */ InboundFilters.id = 'InboundFilters';
    return InboundFilters;
}();
function _mergeOptions(internalOptions, clientOptions) {
    if (internalOptions === void 0) internalOptions = {};
    if (clientOptions === void 0) clientOptions = {};
    return {
        allowUrls: (0, _tslib.__spread)(internalOptions.whitelistUrls || [], internalOptions.allowUrls || [], clientOptions.whitelistUrls || [], clientOptions.allowUrls || []),
        denyUrls: (0, _tslib.__spread)(internalOptions.blacklistUrls || [], internalOptions.denyUrls || [], clientOptions.blacklistUrls || [], clientOptions.denyUrls || []),
        ignoreErrors: (0, _tslib.__spread)(internalOptions.ignoreErrors || [], clientOptions.ignoreErrors || [], DEFAULT_IGNORE_ERRORS),
        ignoreInternal: internalOptions.ignoreInternal !== undefined ? internalOptions.ignoreInternal : true
    };
}
function _shouldDropEvent(event, options) {
    if (options.ignoreInternal && _isSentryError(event)) {
        (0, _flags.IS_DEBUG_BUILD) && (0, _utils.logger).warn("Event dropped due to being internal Sentry Error.\nEvent: " + (0, _utils.getEventDescription)(event));
        return true;
    }
    if (_isIgnoredError(event, options.ignoreErrors)) {
        (0, _flags.IS_DEBUG_BUILD) && (0, _utils.logger).warn("Event dropped due to being matched by `ignoreErrors` option.\nEvent: " + (0, _utils.getEventDescription)(event));
        return true;
    }
    if (_isDeniedUrl(event, options.denyUrls)) {
        (0, _flags.IS_DEBUG_BUILD) && (0, _utils.logger).warn("Event dropped due to being matched by `denyUrls` option.\nEvent: " + (0, _utils.getEventDescription)(event) + ".\nUrl: " + _getEventFilterUrl(event));
        return true;
    }
    if (!_isAllowedUrl(event, options.allowUrls)) {
        (0, _flags.IS_DEBUG_BUILD) && (0, _utils.logger).warn("Event dropped due to not being matched by `allowUrls` option.\nEvent: " + (0, _utils.getEventDescription)(event) + ".\nUrl: " + _getEventFilterUrl(event));
        return true;
    }
    return false;
}
function _isIgnoredError(event, ignoreErrors) {
    if (!ignoreErrors || !ignoreErrors.length) return false;
    return _getPossibleEventMessages(event).some(function(message) {
        return ignoreErrors.some(function(pattern) {
            return (0, _utils.isMatchingPattern)(message, pattern);
        });
    });
}
function _isDeniedUrl(event, denyUrls) {
    // TODO: Use Glob instead?
    if (!denyUrls || !denyUrls.length) return false;
    var url = _getEventFilterUrl(event);
    return !url ? false : denyUrls.some(function(pattern) {
        return (0, _utils.isMatchingPattern)(url, pattern);
    });
}
function _isAllowedUrl(event, allowUrls) {
    // TODO: Use Glob instead?
    if (!allowUrls || !allowUrls.length) return true;
    var url = _getEventFilterUrl(event);
    return !url ? true : allowUrls.some(function(pattern) {
        return (0, _utils.isMatchingPattern)(url, pattern);
    });
}
function _getPossibleEventMessages(event) {
    if (event.message) return [
        event.message
    ];
    if (event.exception) try {
        var _a = event.exception.values && event.exception.values[0] || {}, _b = _a.type, type = _b === void 0 ? '' : _b, _c = _a.value, value = _c === void 0 ? '' : _c;
        return [
            "" + value,
            type + ": " + value
        ];
    } catch (oO) {
        (0, _flags.IS_DEBUG_BUILD) && (0, _utils.logger).error("Cannot extract message for event " + (0, _utils.getEventDescription)(event));
        return [];
    }
    return [];
}
function _isSentryError(event) {
    try {
        // @ts-ignore can't be a sentry error if undefined
        // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access
        return event.exception.values[0].type === 'SentryError';
    } catch (e) {
    // ignore
    }
    return false;
}
function _getLastValidUrl(frames) {
    if (frames === void 0) frames = [];
    for(var i = frames.length - 1; i >= 0; i--){
        var frame = frames[i];
        if (frame && frame.filename !== '<anonymous>' && frame.filename !== '[native code]') return frame.filename || null;
    }
    return null;
}
function _getEventFilterUrl(event) {
    try {
        if (event.stacktrace) return _getLastValidUrl(event.stacktrace.frames);
        var frames_1;
        try {
            // @ts-ignore we only care about frames if the whole thing here is defined
            frames_1 = event.exception.values[0].stacktrace.frames;
        } catch (e) {
        // ignore
        }
        return frames_1 ? _getLastValidUrl(frames_1) : null;
    } catch (oO) {
        (0, _flags.IS_DEBUG_BUILD) && (0, _utils.logger).error("Cannot extract url for event " + (0, _utils.getEventDescription)(event));
        return null;
    }
}

},{"tslib":"6MhhU","@sentry/utils":"5wUYP","../flags":"31xzb","@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"lvqfm":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "BrowserClient", ()=>BrowserClient);
var _tslib = require("tslib");
var _core = require("@sentry/core");
var _utils = require("@sentry/utils");
var _backend = require("./backend");
var _flags = require("./flags");
var _helpers = require("./helpers");
var _integrations = require("./integrations");
/**
 * The Sentry Browser SDK Client.
 *
 * @see BrowserOptions for documentation on configuration options.
 * @see SentryClient for usage documentation.
 */ var BrowserClient = /** @class */ function(_super) {
    (0, _tslib.__extends)(BrowserClient, _super);
    /**
     * Creates a new Browser SDK instance.
     *
     * @param options Configuration options for this SDK.
     */ function BrowserClient(options) {
        if (options === void 0) options = {};
        var _this = this;
        options._metadata = options._metadata || {};
        options._metadata.sdk = options._metadata.sdk || {
            name: 'sentry.javascript.browser',
            packages: [
                {
                    name: 'npm:@sentry/browser',
                    version: (0, _core.SDK_VERSION)
                }
            ],
            version: (0, _core.SDK_VERSION)
        };
        _this = _super.call(this, (0, _backend.BrowserBackend), options) || this;
        return _this;
    }
    /**
     * Show a report dialog to the user to send feedback to a specific event.
     *
     * @param options Set individual options for the dialog
     */ BrowserClient.prototype.showReportDialog = function(options) {
        if (options === void 0) options = {};
        // doesn't work without a document (React Native)
        var document = (0, _utils.getGlobalObject)().document;
        if (!document) return;
        if (!this._isEnabled()) {
            (0, _flags.IS_DEBUG_BUILD) && (0, _utils.logger).error('Trying to call showReportDialog with Sentry Client disabled');
            return;
        }
        (0, _helpers.injectReportDialog)((0, _tslib.__assign)((0, _tslib.__assign)({}, options), {
            dsn: options.dsn || this.getDsn()
        }));
    };
    /**
     * @inheritDoc
     */ BrowserClient.prototype._prepareEvent = function(event, scope, hint) {
        event.platform = event.platform || 'javascript';
        return _super.prototype._prepareEvent.call(this, event, scope, hint);
    };
    /**
     * @inheritDoc
     */ BrowserClient.prototype._sendEvent = function(event) {
        var integration = this.getIntegration((0, _integrations.Breadcrumbs));
        if (integration) integration.addSentryBreadcrumb(event);
        _super.prototype._sendEvent.call(this, event);
    };
    return BrowserClient;
}((0, _core.BaseClient));

},{"tslib":"6MhhU","@sentry/core":"lKLn3","@sentry/utils":"5wUYP","./backend":"ipXO2","./flags":"hHpom","./helpers":"gVXVR","./integrations":"2eOJi","@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"ipXO2":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "BrowserBackend", ()=>BrowserBackend);
var _tslib = require("tslib");
var _core = require("@sentry/core");
var _types = require("@sentry/types");
var _utils = require("@sentry/utils");
var _eventbuilder = require("./eventbuilder");
var _transports = require("./transports");
/**
 * The Sentry Browser SDK Backend.
 * @hidden
 */ var BrowserBackend = /** @class */ function(_super) {
    (0, _tslib.__extends)(BrowserBackend, _super);
    function BrowserBackend() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    /**
     * @inheritDoc
     */ BrowserBackend.prototype.eventFromException = function(exception, hint) {
        return (0, _eventbuilder.eventFromException)(exception, hint, this._options.attachStacktrace);
    };
    /**
     * @inheritDoc
     */ BrowserBackend.prototype.eventFromMessage = function(message, level, hint) {
        if (level === void 0) level = (0, _types.Severity).Info;
        return (0, _eventbuilder.eventFromMessage)(message, level, hint, this._options.attachStacktrace);
    };
    /**
     * @inheritDoc
     */ BrowserBackend.prototype._setupTransport = function() {
        if (!this._options.dsn) // We return the noop transport here in case there is no Dsn.
        return _super.prototype._setupTransport.call(this);
        var transportOptions = (0, _tslib.__assign)((0, _tslib.__assign)({}, this._options.transportOptions), {
            dsn: this._options.dsn,
            tunnel: this._options.tunnel,
            sendClientReports: this._options.sendClientReports,
            _metadata: this._options._metadata
        });
        var api = (0, _core.initAPIDetails)(transportOptions.dsn, transportOptions._metadata, transportOptions.tunnel);
        var url = (0, _core.getEnvelopeEndpointWithUrlEncodedAuth)(api.dsn, api.tunnel);
        if (this._options.transport) return new this._options.transport(transportOptions);
        if ((0, _utils.supportsFetch)()) {
            var requestOptions = (0, _tslib.__assign)({}, transportOptions.fetchParameters);
            this._newTransport = (0, _transports.makeNewFetchTransport)({
                requestOptions: requestOptions,
                url: url
            });
            return new (0, _transports.FetchTransport)(transportOptions);
        }
        this._newTransport = (0, _transports.makeNewXHRTransport)({
            url: url,
            headers: transportOptions.headers
        });
        return new (0, _transports.XHRTransport)(transportOptions);
    };
    return BrowserBackend;
}((0, _core.BaseBackend));

},{"tslib":"6MhhU","@sentry/core":"lKLn3","@sentry/types":"92FRt","@sentry/utils":"5wUYP","./eventbuilder":"1K1bH","./transports":"2A5CV","@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"1K1bH":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
/**
 * This function creates an exception from an TraceKitStackTrace
 * @param stacktrace TraceKitStackTrace that will be converted to an exception
 * @hidden
 */ parcelHelpers.export(exports, "exceptionFromError", ()=>exceptionFromError);
/**
 * @hidden
 */ parcelHelpers.export(exports, "eventFromPlainObject", ()=>eventFromPlainObject);
/**
 * @hidden
 */ parcelHelpers.export(exports, "eventFromError", ()=>eventFromError);
/** Parses stack frames from an error */ parcelHelpers.export(exports, "parseStackFrames", ()=>parseStackFrames);
/**
 * Creates an {@link Event} from all inputs to `captureException` and non-primitive inputs to `captureMessage`.
 * @hidden
 */ parcelHelpers.export(exports, "eventFromException", ()=>eventFromException);
/**
 * Builds and Event from a Message
 * @hidden
 */ parcelHelpers.export(exports, "eventFromMessage", ()=>eventFromMessage);
/**
 * @hidden
 */ parcelHelpers.export(exports, "eventFromUnknownInput", ()=>eventFromUnknownInput);
/**
 * @hidden
 */ parcelHelpers.export(exports, "eventFromString", ()=>eventFromString);
var _tslib = require("tslib");
var _types = require("@sentry/types");
var _utils = require("@sentry/utils");
var _stackParsers = require("./stack-parsers");
function exceptionFromError(ex) {
    // Get the frames first since Opera can lose the stack if we touch anything else first
    var frames = parseStackFrames(ex);
    var exception = {
        type: ex && ex.name,
        value: extractMessage(ex)
    };
    if (frames.length) exception.stacktrace = {
        frames: frames
    };
    if (exception.type === undefined && exception.value === '') exception.value = 'Unrecoverable error caught';
    return exception;
}
function eventFromPlainObject(exception, syntheticException, isUnhandledRejection) {
    var event = {
        exception: {
            values: [
                {
                    type: (0, _utils.isEvent)(exception) ? exception.constructor.name : isUnhandledRejection ? 'UnhandledRejection' : 'Error',
                    value: "Non-Error " + (isUnhandledRejection ? 'promise rejection' : 'exception') + " captured with keys: " + (0, _utils.extractExceptionKeysForMessage)(exception)
                }
            ]
        },
        extra: {
            __serialized__: (0, _utils.normalizeToSize)(exception)
        }
    };
    if (syntheticException) {
        var frames_1 = parseStackFrames(syntheticException);
        if (frames_1.length) event.stacktrace = {
            frames: frames_1
        };
    }
    return event;
}
function eventFromError(ex) {
    return {
        exception: {
            values: [
                exceptionFromError(ex)
            ]
        }
    };
}
function parseStackFrames(ex) {
    // Access and store the stacktrace property before doing ANYTHING
    // else to it because Opera is not very good at providing it
    // reliably in other circumstances.
    var stacktrace = ex.stacktrace || ex.stack || '';
    var popSize = getPopSize(ex);
    try {
        return (0, _utils.createStackParser)((0, _stackParsers.opera10StackParser), (0, _stackParsers.opera11StackParser), (0, _stackParsers.chromeStackParser), (0, _stackParsers.winjsStackParser), (0, _stackParsers.geckoStackParser))(stacktrace, popSize);
    } catch (e) {
    // no-empty
    }
    return [];
}
// Based on our own mapping pattern - https://github.com/getsentry/sentry/blob/9f08305e09866c8bd6d0c24f5b0aabdd7dd6c59c/src/sentry/lang/javascript/errormapping.py#L83-L108
var reactMinifiedRegexp = /Minified React error #\d+;/i;
function getPopSize(ex) {
    if (ex) {
        if (typeof ex.framesToPop === 'number') return ex.framesToPop;
        if (reactMinifiedRegexp.test(ex.message)) return 1;
    }
    return 0;
}
/**
 * There are cases where stacktrace.message is an Event object
 * https://github.com/getsentry/sentry-javascript/issues/1949
 * In this specific case we try to extract stacktrace.message.error.message
 */ function extractMessage(ex) {
    var message = ex && ex.message;
    if (!message) return 'No error message';
    if (message.error && typeof message.error.message === 'string') return message.error.message;
    return message;
}
function eventFromException(exception, hint, attachStacktrace) {
    var syntheticException = hint && hint.syntheticException || undefined;
    var event = eventFromUnknownInput(exception, syntheticException, attachStacktrace);
    (0, _utils.addExceptionMechanism)(event); // defaults to { type: 'generic', handled: true }
    event.level = (0, _types.Severity).Error;
    if (hint && hint.event_id) event.event_id = hint.event_id;
    return (0, _utils.resolvedSyncPromise)(event);
}
function eventFromMessage(message, level, hint, attachStacktrace) {
    if (level === void 0) level = (0, _types.Severity).Info;
    var syntheticException = hint && hint.syntheticException || undefined;
    var event = eventFromString(message, syntheticException, attachStacktrace);
    event.level = level;
    if (hint && hint.event_id) event.event_id = hint.event_id;
    return (0, _utils.resolvedSyncPromise)(event);
}
function eventFromUnknownInput(exception, syntheticException, attachStacktrace, isUnhandledRejection) {
    var event;
    if ((0, _utils.isErrorEvent)(exception) && exception.error) {
        // If it is an ErrorEvent with `error` property, extract it to get actual Error
        var errorEvent = exception;
        return eventFromError(errorEvent.error);
    }
    // If it is a `DOMError` (which is a legacy API, but still supported in some browsers) then we just extract the name
    // and message, as it doesn't provide anything else. According to the spec, all `DOMExceptions` should also be
    // `Error`s, but that's not the case in IE11, so in that case we treat it the same as we do a `DOMError`.
    //
    // https://developer.mozilla.org/en-US/docs/Web/API/DOMError
    // https://developer.mozilla.org/en-US/docs/Web/API/DOMException
    // https://webidl.spec.whatwg.org/#es-DOMException-specialness
    if ((0, _utils.isDOMError)(exception) || (0, _utils.isDOMException)(exception)) {
        var domException = exception;
        if ('stack' in exception) event = eventFromError(exception);
        else {
            var name_1 = domException.name || ((0, _utils.isDOMError)(domException) ? 'DOMError' : 'DOMException');
            var message = domException.message ? name_1 + ": " + domException.message : name_1;
            event = eventFromString(message, syntheticException, attachStacktrace);
            (0, _utils.addExceptionTypeValue)(event, message);
        }
        if ('code' in domException) event.tags = (0, _tslib.__assign)((0, _tslib.__assign)({}, event.tags), {
            'DOMException.code': "" + domException.code
        });
        return event;
    }
    if ((0, _utils.isError)(exception)) // we have a real Error object, do nothing
    return eventFromError(exception);
    if ((0, _utils.isPlainObject)(exception) || (0, _utils.isEvent)(exception)) {
        // If it's a plain object or an instance of `Event` (the built-in JS kind, not this SDK's `Event` type), serialize
        // it manually. This will allow us to group events based on top-level keys which is much better than creating a new
        // group on any key/value change.
        var objectException = exception;
        event = eventFromPlainObject(objectException, syntheticException, isUnhandledRejection);
        (0, _utils.addExceptionMechanism)(event, {
            synthetic: true
        });
        return event;
    }
    // If none of previous checks were valid, then it means that it's not:
    // - an instance of DOMError
    // - an instance of DOMException
    // - an instance of Event
    // - an instance of Error
    // - a valid ErrorEvent (one with an error property)
    // - a plain Object
    //
    // So bail out and capture it as a simple message:
    event = eventFromString(exception, syntheticException, attachStacktrace);
    (0, _utils.addExceptionTypeValue)(event, "" + exception, undefined);
    (0, _utils.addExceptionMechanism)(event, {
        synthetic: true
    });
    return event;
}
function eventFromString(input, syntheticException, attachStacktrace) {
    var event = {
        message: input
    };
    if (attachStacktrace && syntheticException) {
        var frames_2 = parseStackFrames(syntheticException);
        if (frames_2.length) event.stacktrace = {
            frames: frames_2
        };
    }
    return event;
}

},{"tslib":"6MhhU","@sentry/types":"92FRt","@sentry/utils":"5wUYP","./stack-parsers":"tVnVD","@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"tVnVD":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "chromeStackParser", ()=>chromeStackParser);
parcelHelpers.export(exports, "geckoStackParser", ()=>geckoStackParser);
parcelHelpers.export(exports, "winjsStackParser", ()=>winjsStackParser);
parcelHelpers.export(exports, "opera10StackParser", ()=>opera10StackParser);
parcelHelpers.export(exports, "opera11StackParser", ()=>opera11StackParser);
var _tslib = require("tslib");
// global reference to slice
var UNKNOWN_FUNCTION = '?';
var OPERA10_PRIORITY = 10;
var OPERA11_PRIORITY = 20;
var CHROME_PRIORITY = 30;
var WINJS_PRIORITY = 40;
var GECKO_PRIORITY = 50;
function createFrame(filename, func, lineno, colno) {
    var frame = {
        filename: filename,
        function: func,
        // All browser frames are considered in_app
        in_app: true
    };
    if (lineno !== undefined) frame.lineno = lineno;
    if (colno !== undefined) frame.colno = colno;
    return frame;
}
// Chromium based browsers: Chrome, Brave, new Opera, new Edge
var chromeRegex = /^\s*at (?:(.*?) ?\((?:address at )?)?((?:file|https?|blob|chrome-extension|address|native|eval|webpack|<anonymous>|[-a-z]+:|.*bundle|\/).*?)(?::(\d+))?(?::(\d+))?\)?\s*$/i;
var chromeEvalRegex = /\((\S*)(?::(\d+))(?::(\d+))\)/;
var chrome = function(line) {
    var parts = chromeRegex.exec(line);
    if (parts) {
        var isEval = parts[2] && parts[2].indexOf('eval') === 0; // start of line
        if (isEval) {
            var subMatch = chromeEvalRegex.exec(parts[2]);
            if (subMatch) {
                // throw out eval line/column and use top-most line/column number
                parts[2] = subMatch[1]; // url
                parts[3] = subMatch[2]; // line
                parts[4] = subMatch[3]; // column
            }
        }
        // Kamil: One more hack won't hurt us right? Understanding and adding more rules on top of these regexps right now
        // would be way too time consuming. (TODO: Rewrite whole RegExp to be more readable)
        var _a = (0, _tslib.__read)(extractSafariExtensionDetails(parts[1] || UNKNOWN_FUNCTION, parts[2]), 2), func = _a[0], filename = _a[1];
        return createFrame(filename, func, parts[3] ? +parts[3] : undefined, parts[4] ? +parts[4] : undefined);
    }
    return;
};
var chromeStackParser = [
    CHROME_PRIORITY,
    chrome
];
// gecko regex: `(?:bundle|\d+\.js)`: `bundle` is for react native, `\d+\.js` also but specifically for ram bundles because it
// generates filenames without a prefix like `file://` the filenames in the stacktrace are just 42.js
// We need this specific case for now because we want no other regex to match.
var geckoREgex = /^\s*(.*?)(?:\((.*?)\))?(?:^|@)?((?:file|https?|blob|chrome|webpack|resource|moz-extension|capacitor).*?:\/.*?|\[native code\]|[^@]*(?:bundle|\d+\.js)|\/[\w\-. /=]+)(?::(\d+))?(?::(\d+))?\s*$/i;
var geckoEvalRegex = /(\S+) line (\d+)(?: > eval line \d+)* > eval/i;
var gecko = function(line) {
    var _a;
    var parts = geckoREgex.exec(line);
    if (parts) {
        var isEval = parts[3] && parts[3].indexOf(' > eval') > -1;
        if (isEval) {
            var subMatch = geckoEvalRegex.exec(parts[3]);
            if (subMatch) {
                // throw out eval line/column and use top-most line number
                parts[1] = parts[1] || 'eval';
                parts[3] = subMatch[1];
                parts[4] = subMatch[2];
                parts[5] = ''; // no column when eval
            }
        }
        var filename = parts[3];
        var func = parts[1] || UNKNOWN_FUNCTION;
        _a = (0, _tslib.__read)(extractSafariExtensionDetails(func, filename), 2), func = _a[0], filename = _a[1];
        return createFrame(filename, func, parts[4] ? +parts[4] : undefined, parts[5] ? +parts[5] : undefined);
    }
    return;
};
var geckoStackParser = [
    GECKO_PRIORITY,
    gecko
];
var winjsRegex = /^\s*at (?:((?:\[object object\])?.+) )?\(?((?:file|ms-appx|https?|webpack|blob):.*?):(\d+)(?::(\d+))?\)?\s*$/i;
var winjs = function(line) {
    var parts = winjsRegex.exec(line);
    return parts ? createFrame(parts[2], parts[1] || UNKNOWN_FUNCTION, +parts[3], parts[4] ? +parts[4] : undefined) : undefined;
};
var winjsStackParser = [
    WINJS_PRIORITY,
    winjs
];
var opera10Regex = / line (\d+).*script (?:in )?(\S+)(?:: in function (\S+))?$/i;
var opera10 = function(line) {
    var parts = opera10Regex.exec(line);
    return parts ? createFrame(parts[2], parts[3] || UNKNOWN_FUNCTION, +parts[1]) : undefined;
};
var opera10StackParser = [
    OPERA10_PRIORITY,
    opera10
];
var opera11Regex = / line (\d+), column (\d+)\s*(?:in (?:<anonymous function: ([^>]+)>|([^)]+))\(.*\))? in (.*):\s*$/i;
var opera11 = function(line) {
    var parts = opera11Regex.exec(line);
    return parts ? createFrame(parts[5], parts[3] || parts[4] || UNKNOWN_FUNCTION, +parts[1], +parts[2]) : undefined;
};
var opera11StackParser = [
    OPERA11_PRIORITY,
    opera11
];
/**
 * Safari web extensions, starting version unknown, can produce "frames-only" stacktraces.
 * What it means, is that instead of format like:
 *
 * Error: wat
 *   at function@url:row:col
 *   at function@url:row:col
 *   at function@url:row:col
 *
 * it produces something like:
 *
 *   function@url:row:col
 *   function@url:row:col
 *   function@url:row:col
 *
 * Because of that, it won't be captured by `chrome` RegExp and will fall into `Gecko` branch.
 * This function is extracted so that we can use it in both places without duplicating the logic.
 * Unfortunately "just" changing RegExp is too complicated now and making it pass all tests
 * and fix this case seems like an impossible, or at least way too time-consuming task.
 */ var extractSafariExtensionDetails = function(func, filename) {
    var isSafariExtension = func.indexOf('safari-extension') !== -1;
    var isSafariWebExtension = func.indexOf('safari-web-extension') !== -1;
    return isSafariExtension || isSafariWebExtension ? [
        func.indexOf('@') !== -1 ? func.split('@')[0] : UNKNOWN_FUNCTION,
        isSafariExtension ? "safari-extension:" + filename : "safari-web-extension:" + filename
    ] : [
        func,
        filename
    ];
};

},{"tslib":"6MhhU","@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"2A5CV":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "BaseTransport", ()=>(0, _base.BaseTransport));
parcelHelpers.export(exports, "FetchTransport", ()=>(0, _fetch.FetchTransport));
parcelHelpers.export(exports, "XHRTransport", ()=>(0, _xhr.XHRTransport));
parcelHelpers.export(exports, "makeNewFetchTransport", ()=>(0, _newFetch.makeNewFetchTransport));
parcelHelpers.export(exports, "makeNewXHRTransport", ()=>(0, _newXhr.makeNewXHRTransport));
var _base = require("./base");
var _fetch = require("./fetch");
var _xhr = require("./xhr");
var _newFetch = require("./new-fetch");
var _newXhr = require("./new-xhr");

},{"./base":"34tbC","./fetch":"hXzGs","./xhr":"keW4m","./new-fetch":"ePXJ3","./new-xhr":"hu3Bb","@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"34tbC":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "BaseTransport", ()=>BaseTransport);
var _tslib = require("tslib");
var _core = require("@sentry/core");
var _utils = require("@sentry/utils");
var _flags = require("../flags");
var _utils1 = require("./utils");
function requestTypeToCategory(ty) {
    var tyStr = ty;
    return tyStr === 'event' ? 'error' : tyStr;
}
var global = (0, _utils.getGlobalObject)();
/** Base Transport class implementation */ var BaseTransport = /** @class */ function() {
    function BaseTransport(options) {
        var _this = this;
        this.options = options;
        /** A simple buffer holding all requests. */ this._buffer = (0, _utils.makePromiseBuffer)(30);
        /** Locks transport after receiving rate limits in a response */ this._rateLimits = {};
        this._outcomes = {};
        this._api = (0, _core.initAPIDetails)(options.dsn, options._metadata, options.tunnel);
        // eslint-disable-next-line deprecation/deprecation
        this.url = (0, _core.getStoreEndpointWithUrlEncodedAuth)(this._api.dsn);
        if (this.options.sendClientReports && global.document) global.document.addEventListener('visibilitychange', function() {
            if (global.document.visibilityState === 'hidden') _this._flushOutcomes();
        });
    }
    /**
     * @inheritDoc
     */ BaseTransport.prototype.sendEvent = function(event) {
        return this._sendRequest((0, _core.eventToSentryRequest)(event, this._api), event);
    };
    /**
     * @inheritDoc
     */ BaseTransport.prototype.sendSession = function(session) {
        return this._sendRequest((0, _core.sessionToSentryRequest)(session, this._api), session);
    };
    /**
     * @inheritDoc
     */ BaseTransport.prototype.close = function(timeout) {
        return this._buffer.drain(timeout);
    };
    /**
     * @inheritDoc
     */ BaseTransport.prototype.recordLostEvent = function(reason, category) {
        var _a;
        if (!this.options.sendClientReports) return;
        // We want to track each category (event, transaction, session) separately
        // but still keep the distinction between different type of outcomes.
        // We could use nested maps, but it's much easier to read and type this way.
        // A correct type for map-based implementation if we want to go that route
        // would be `Partial<Record<SentryRequestType, Partial<Record<Outcome, number>>>>`
        var key = requestTypeToCategory(category) + ":" + reason;
        (0, _flags.IS_DEBUG_BUILD) && (0, _utils.logger).log("Adding outcome: " + key);
        this._outcomes[key] = (_a = this._outcomes[key], _a !== null && _a !== void 0 ? _a : 0) + 1;
    };
    /**
     * Send outcomes as an envelope
     */ BaseTransport.prototype._flushOutcomes = function() {
        if (!this.options.sendClientReports) return;
        var outcomes = this._outcomes;
        this._outcomes = {};
        // Nothing to send
        if (!Object.keys(outcomes).length) {
            (0, _flags.IS_DEBUG_BUILD) && (0, _utils.logger).log('No outcomes to flush');
            return;
        }
        (0, _flags.IS_DEBUG_BUILD) && (0, _utils.logger).log("Flushing outcomes:\n" + JSON.stringify(outcomes, null, 2));
        var url = (0, _core.getEnvelopeEndpointWithUrlEncodedAuth)(this._api.dsn, this._api.tunnel);
        var discardedEvents = Object.keys(outcomes).map(function(key) {
            var _a = (0, _tslib.__read)(key.split(':'), 2), category = _a[0], reason = _a[1];
            return {
                reason: reason,
                category: category,
                quantity: outcomes[key]
            };
        // TODO: Improve types on discarded_events to get rid of cast
        });
        var envelope = (0, _utils.createClientReportEnvelope)(discardedEvents, this._api.tunnel && (0, _utils.dsnToString)(this._api.dsn));
        try {
            (0, _utils1.sendReport)(url, (0, _utils.serializeEnvelope)(envelope));
        } catch (e) {
            (0, _flags.IS_DEBUG_BUILD) && (0, _utils.logger).error(e);
        }
    };
    /**
     * Handle Sentry repsonse for promise-based transports.
     */ BaseTransport.prototype._handleResponse = function(_a) {
        var requestType = _a.requestType, response = _a.response, headers = _a.headers, resolve = _a.resolve, reject = _a.reject;
        var status = (0, _utils.eventStatusFromHttpCode)(response.status);
        this._rateLimits = (0, _utils.updateRateLimits)(this._rateLimits, headers);
        // eslint-disable-next-line deprecation/deprecation
        if (this._isRateLimited(requestType)) (0, _flags.IS_DEBUG_BUILD) && // eslint-disable-next-line deprecation/deprecation
        (0, _utils.logger).warn("Too many " + requestType + " requests, backing off until: " + this._disabledUntil(requestType));
        if (status === 'success') {
            resolve({
                status: status
            });
            return;
        }
        reject(response);
    };
    /**
     * Gets the time that given category is disabled until for rate limiting
     *
     * @deprecated Please use `disabledUntil` from @sentry/utils
     */ BaseTransport.prototype._disabledUntil = function(requestType) {
        var category = requestTypeToCategory(requestType);
        return new Date((0, _utils.disabledUntil)(this._rateLimits, category));
    };
    /**
     * Checks if a category is rate limited
     *
     * @deprecated Please use `isRateLimited` from @sentry/utils
     */ BaseTransport.prototype._isRateLimited = function(requestType) {
        var category = requestTypeToCategory(requestType);
        return (0, _utils.isRateLimited)(this._rateLimits, category);
    };
    return BaseTransport;
}();

},{"tslib":"6MhhU","@sentry/core":"lKLn3","@sentry/utils":"5wUYP","../flags":"hHpom","./utils":"1o0xF","@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"hHpom":[function(require,module,exports,__globalThis) {
/*
 * This file defines flags and constants that can be modified during compile time in order to facilitate tree shaking
 * for users.
 *
 * Debug flags need to be declared in each package individually and must not be imported across package boundaries,
 * because some build tools have trouble tree-shaking imported guards.
 *
 * As a convention, we define debug flags in a `flags.ts` file in the root of a package's `src` folder.
 *
 * Debug flag files will contain "magic strings" like `__SENTRY_DEBUG__` that may get replaced with actual values during
 * our, or the user's build process. Take care when introducing new flags - they must not throw if they are not
 * replaced.
 */ /** Flag that is true for debug builds, false otherwise. */ var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "IS_DEBUG_BUILD", ()=>IS_DEBUG_BUILD);
var IS_DEBUG_BUILD = typeof __SENTRY_DEBUG__ === 'undefined' ? true : __SENTRY_DEBUG__;

},{"@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"1o0xF":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
/**
 * A special usecase for incorrectly wrapped Fetch APIs in conjunction with ad-blockers.
 * Whenever someone wraps the Fetch API and returns the wrong promise chain,
 * this chain becomes orphaned and there is no possible way to capture it's rejections
 * other than allowing it bubble up to this very handler. eg.
 *
 * const f = window.fetch;
 * window.fetch = function () {
 *   const p = f.apply(this, arguments);
 *
 *   p.then(function() {
 *     console.log('hi.');
 *   });
 *
 *   return p;
 * }
 *
 * `p.then(function () { ... })` is producing a completely separate promise chain,
 * however, what's returned is `p` - the result of original `fetch` call.
 *
 * This mean, that whenever we use the Fetch API to send our own requests, _and_
 * some ad-blocker blocks it, this orphaned chain will _always_ reject,
 * effectively causing another event to be captured.
 * This makes a whole process become an infinite loop, which we need to somehow
 * deal with, and break it in one way or another.
 *
 * To deal with this issue, we are making sure that we _always_ use the real
 * browser Fetch API, instead of relying on what `window.fetch` exposes.
 * The only downside to this would be missing our own requests as breadcrumbs,
 * but because we are already not doing this, it should be just fine.
 *
 * Possible failed fetch error messages per-browser:
 *
 * Chrome:  Failed to fetch
 * Edge:    Failed to Fetch
 * Firefox: NetworkError when attempting to fetch resource
 * Safari:  resource blocked by content blocker
 */ parcelHelpers.export(exports, "getNativeFetchImplementation", ()=>getNativeFetchImplementation);
/**
 * Sends sdk client report using sendBeacon or fetch as a fallback if available
 *
 * @param url report endpoint
 * @param body report payload
 */ parcelHelpers.export(exports, "sendReport", ()=>sendReport);
var _utils = require("@sentry/utils");
var _flags = require("../flags");
var global = (0, _utils.getGlobalObject)();
var cachedFetchImpl;
function getNativeFetchImplementation() {
    if (cachedFetchImpl) return cachedFetchImpl;
    /* eslint-disable @typescript-eslint/unbound-method */ // Fast path to avoid DOM I/O
    if ((0, _utils.isNativeFetch)(global.fetch)) return cachedFetchImpl = global.fetch.bind(global);
    var document = global.document;
    var fetchImpl = global.fetch;
    // eslint-disable-next-line deprecation/deprecation
    if (document && typeof document.createElement === 'function') try {
        var sandbox = document.createElement('iframe');
        sandbox.hidden = true;
        document.head.appendChild(sandbox);
        var contentWindow = sandbox.contentWindow;
        if (contentWindow && contentWindow.fetch) fetchImpl = contentWindow.fetch;
        document.head.removeChild(sandbox);
    } catch (e) {
        (0, _flags.IS_DEBUG_BUILD) && (0, _utils.logger).warn('Could not create sandbox iframe for pure fetch check, bailing to window.fetch: ', e);
    }
    return cachedFetchImpl = fetchImpl.bind(global);
/* eslint-enable @typescript-eslint/unbound-method */ }
function sendReport(url, body) {
    var isRealNavigator = Object.prototype.toString.call(global && global.navigator) === '[object Navigator]';
    var hasSendBeacon = isRealNavigator && typeof global.navigator.sendBeacon === 'function';
    if (hasSendBeacon) {
        // Prevent illegal invocations - https://xgwang.me/posts/you-may-not-know-beacon/#it-may-throw-error%2C-be-sure-to-catch
        var sendBeacon = global.navigator.sendBeacon.bind(global.navigator);
        return sendBeacon(url, body);
    }
    if ((0, _utils.supportsFetch)()) {
        var fetch_1 = getNativeFetchImplementation();
        return (0, _utils.forget)(fetch_1(url, {
            body: body,
            method: 'POST',
            credentials: 'omit',
            keepalive: true
        }));
    }
}

},{"@sentry/utils":"5wUYP","../flags":"hHpom","@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"hXzGs":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "FetchTransport", ()=>FetchTransport);
var _tslib = require("tslib");
var _utils = require("@sentry/utils");
var _base = require("./base");
var _utils1 = require("./utils");
/** `fetch` based transport */ var FetchTransport = /** @class */ function(_super) {
    (0, _tslib.__extends)(FetchTransport, _super);
    function FetchTransport(options, fetchImpl) {
        if (fetchImpl === void 0) fetchImpl = (0, _utils1.getNativeFetchImplementation)();
        var _this = _super.call(this, options) || this;
        _this._fetch = fetchImpl;
        return _this;
    }
    /**
     * @param sentryRequest Prepared SentryRequest to be delivered
     * @param originalPayload Original payload used to create SentryRequest
     */ FetchTransport.prototype._sendRequest = function(sentryRequest, originalPayload) {
        var _this = this;
        // eslint-disable-next-line deprecation/deprecation
        if (this._isRateLimited(sentryRequest.type)) {
            this.recordLostEvent('ratelimit_backoff', sentryRequest.type);
            return Promise.reject({
                event: originalPayload,
                type: sentryRequest.type,
                // eslint-disable-next-line deprecation/deprecation
                reason: "Transport for " + sentryRequest.type + " requests locked till " + this._disabledUntil(sentryRequest.type) + " due to too many requests.",
                status: 429
            });
        }
        var options = {
            body: sentryRequest.body,
            method: 'POST',
            // Despite all stars in the sky saying that Edge supports old draft syntax, aka 'never', 'always', 'origin' and 'default'
            // (see https://caniuse.com/#feat=referrer-policy),
            // it doesn't. And it throws an exception instead of ignoring this parameter...
            // REF: https://github.com/getsentry/raven-js/issues/1233
            referrerPolicy: (0, _utils.supportsReferrerPolicy)() ? 'origin' : ''
        };
        if (this.options.fetchParameters !== undefined) Object.assign(options, this.options.fetchParameters);
        if (this.options.headers !== undefined) options.headers = this.options.headers;
        return this._buffer.add(function() {
            return new (0, _utils.SyncPromise)(function(resolve, reject) {
                _this._fetch(sentryRequest.url, options).then(function(response) {
                    var headers = {
                        'x-sentry-rate-limits': response.headers.get('X-Sentry-Rate-Limits'),
                        'retry-after': response.headers.get('Retry-After')
                    };
                    _this._handleResponse({
                        requestType: sentryRequest.type,
                        response: response,
                        headers: headers,
                        resolve: resolve,
                        reject: reject
                    });
                }).catch(reject);
            });
        }).then(undefined, function(reason) {
            // It's either buffer rejection or any other xhr/fetch error, which are treated as NetworkError.
            if (reason instanceof (0, _utils.SentryError)) _this.recordLostEvent('queue_overflow', sentryRequest.type);
            else _this.recordLostEvent('network_error', sentryRequest.type);
            throw reason;
        });
    };
    return FetchTransport;
}((0, _base.BaseTransport));

},{"tslib":"6MhhU","@sentry/utils":"5wUYP","./base":"34tbC","./utils":"1o0xF","@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"keW4m":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "XHRTransport", ()=>XHRTransport);
var _tslib = require("tslib");
var _utils = require("@sentry/utils");
var _base = require("./base");
/** `XHR` based transport */ var XHRTransport = /** @class */ function(_super) {
    (0, _tslib.__extends)(XHRTransport, _super);
    function XHRTransport() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    /**
     * @param sentryRequest Prepared SentryRequest to be delivered
     * @param originalPayload Original payload used to create SentryRequest
     */ XHRTransport.prototype._sendRequest = function(sentryRequest, originalPayload) {
        var _this = this;
        // eslint-disable-next-line deprecation/deprecation
        if (this._isRateLimited(sentryRequest.type)) {
            this.recordLostEvent('ratelimit_backoff', sentryRequest.type);
            return Promise.reject({
                event: originalPayload,
                type: sentryRequest.type,
                // eslint-disable-next-line deprecation/deprecation
                reason: "Transport for " + sentryRequest.type + " requests locked till " + this._disabledUntil(sentryRequest.type) + " due to too many requests.",
                status: 429
            });
        }
        return this._buffer.add(function() {
            return new (0, _utils.SyncPromise)(function(resolve, reject) {
                var request = new XMLHttpRequest();
                request.onreadystatechange = function() {
                    if (request.readyState === 4) {
                        var headers = {
                            'x-sentry-rate-limits': request.getResponseHeader('X-Sentry-Rate-Limits'),
                            'retry-after': request.getResponseHeader('Retry-After')
                        };
                        _this._handleResponse({
                            requestType: sentryRequest.type,
                            response: request,
                            headers: headers,
                            resolve: resolve,
                            reject: reject
                        });
                    }
                };
                request.open('POST', sentryRequest.url);
                for(var header in _this.options.headers)if (Object.prototype.hasOwnProperty.call(_this.options.headers, header)) request.setRequestHeader(header, _this.options.headers[header]);
                request.send(sentryRequest.body);
            });
        }).then(undefined, function(reason) {
            // It's either buffer rejection or any other xhr/fetch error, which are treated as NetworkError.
            if (reason instanceof (0, _utils.SentryError)) _this.recordLostEvent('queue_overflow', sentryRequest.type);
            else _this.recordLostEvent('network_error', sentryRequest.type);
            throw reason;
        });
    };
    return XHRTransport;
}((0, _base.BaseTransport));

},{"tslib":"6MhhU","@sentry/utils":"5wUYP","./base":"34tbC","@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"ePXJ3":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
/**
 * Creates a Transport that uses the Fetch API to send events to Sentry.
 */ parcelHelpers.export(exports, "makeNewFetchTransport", ()=>makeNewFetchTransport);
var _tslib = require("tslib");
var _core = require("@sentry/core");
var _utils = require("./utils");
function makeNewFetchTransport(options, nativeFetch) {
    if (nativeFetch === void 0) nativeFetch = (0, _utils.getNativeFetchImplementation)();
    function makeRequest(request) {
        var requestOptions = (0, _tslib.__assign)({
            body: request.body,
            method: 'POST',
            referrerPolicy: 'origin'
        }, options.requestOptions);
        return nativeFetch(options.url, requestOptions).then(function(response) {
            return response.text().then(function(body) {
                return {
                    body: body,
                    headers: {
                        'x-sentry-rate-limits': response.headers.get('X-Sentry-Rate-Limits'),
                        'retry-after': response.headers.get('Retry-After')
                    },
                    reason: response.statusText,
                    statusCode: response.status
                };
            });
        });
    }
    return (0, _core.createTransport)({
        bufferSize: options.bufferSize
    }, makeRequest);
}

},{"tslib":"6MhhU","@sentry/core":"lKLn3","./utils":"1o0xF","@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"hu3Bb":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
/**
 * Creates a Transport that uses the XMLHttpRequest API to send events to Sentry.
 */ parcelHelpers.export(exports, "makeNewXHRTransport", ()=>makeNewXHRTransport);
var _core = require("@sentry/core");
var _utils = require("@sentry/utils");
/**
 * The DONE ready state for XmlHttpRequest
 *
 * Defining it here as a constant b/c XMLHttpRequest.DONE is not always defined
 * (e.g. during testing, it is `undefined`)
 *
 * @see {@link https://developer.mozilla.org/en-US/docs/Web/API/XMLHttpRequest/readyState}
 */ var XHR_READYSTATE_DONE = 4;
function makeNewXHRTransport(options) {
    function makeRequest(request) {
        return new (0, _utils.SyncPromise)(function(resolve, _reject) {
            var xhr = new XMLHttpRequest();
            xhr.onreadystatechange = function() {
                if (xhr.readyState === XHR_READYSTATE_DONE) {
                    var response = {
                        body: xhr.response,
                        headers: {
                            'x-sentry-rate-limits': xhr.getResponseHeader('X-Sentry-Rate-Limits'),
                            'retry-after': xhr.getResponseHeader('Retry-After')
                        },
                        reason: xhr.statusText,
                        statusCode: xhr.status
                    };
                    resolve(response);
                }
            };
            xhr.open('POST', options.url);
            for(var header in options.headers)if (Object.prototype.hasOwnProperty.call(options.headers, header)) xhr.setRequestHeader(header, options.headers[header]);
            xhr.send(request.body);
        });
    }
    return (0, _core.createTransport)({
        bufferSize: options.bufferSize
    }, makeRequest);
}

},{"@sentry/core":"lKLn3","@sentry/utils":"5wUYP","@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"gVXVR":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
/**
 * @hidden
 */ parcelHelpers.export(exports, "shouldIgnoreOnError", ()=>shouldIgnoreOnError);
/**
 * @hidden
 */ parcelHelpers.export(exports, "ignoreNextOnError", ()=>ignoreNextOnError);
/**
 * Instruments the given function and sends an event to Sentry every time the
 * function throws an exception.
 *
 * @param fn A function to wrap.
 * @returns The wrapped function.
 * @hidden
 */ parcelHelpers.export(exports, "wrap", ()=>wrap);
/**
 * Injects the Report Dialog script
 * @hidden
 */ parcelHelpers.export(exports, "injectReportDialog", ()=>injectReportDialog);
var _tslib = require("tslib");
var _core = require("@sentry/core");
var _utils = require("@sentry/utils");
var _flags = require("./flags");
var global = (0, _utils.getGlobalObject)();
var ignoreOnError = 0;
function shouldIgnoreOnError() {
    return ignoreOnError > 0;
}
function ignoreNextOnError() {
    // onerror should trigger before setTimeout
    ignoreOnError += 1;
    setTimeout(function() {
        ignoreOnError -= 1;
    });
}
function wrap(fn, options, before) {
    // for future readers what this does is wrap a function and then create
    // a bi-directional wrapping between them.
    //
    // example: wrapped = wrap(original);
    //  original.__sentry_wrapped__ -> wrapped
    //  wrapped.__sentry_original__ -> original
    if (options === void 0) options = {};
    if (typeof fn !== 'function') return fn;
    try {
        // if we're dealing with a function that was previously wrapped, return
        // the original wrapper.
        var wrapper = fn.__sentry_wrapped__;
        if (wrapper) return wrapper;
        // We don't wanna wrap it twice
        if ((0, _utils.getOriginalFunction)(fn)) return fn;
    } catch (e) {
        // Just accessing custom props in some Selenium environments
        // can cause a "Permission denied" exception (see raven-js#495).
        // Bail on wrapping and return the function as-is (defers to window.onerror).
        return fn;
    }
    /* eslint-disable prefer-rest-params */ // eslint-disable-next-line @typescript-eslint/no-explicit-any
    var sentryWrapped = function() {
        var args = Array.prototype.slice.call(arguments);
        try {
            if (before && typeof before === 'function') before.apply(this, arguments);
            // eslint-disable-next-line @typescript-eslint/no-explicit-any, @typescript-eslint/no-unsafe-member-access
            var wrappedArguments = args.map(function(arg) {
                return wrap(arg, options);
            });
            // Attempt to invoke user-land function
            // NOTE: If you are a Sentry user, and you are seeing this stack frame, it
            //       means the sentry.javascript SDK caught an error invoking your application code. This
            //       is expected behavior and NOT indicative of a bug with sentry.javascript.
            return fn.apply(this, wrappedArguments);
        } catch (ex) {
            ignoreNextOnError();
            (0, _core.withScope)(function(scope) {
                scope.addEventProcessor(function(event) {
                    if (options.mechanism) {
                        (0, _utils.addExceptionTypeValue)(event, undefined, undefined);
                        (0, _utils.addExceptionMechanism)(event, options.mechanism);
                    }
                    event.extra = (0, _tslib.__assign)((0, _tslib.__assign)({}, event.extra), {
                        arguments: args
                    });
                    return event;
                });
                (0, _core.captureException)(ex);
            });
            throw ex;
        }
    };
    /* eslint-enable prefer-rest-params */ // Accessing some objects may throw
    // ref: https://github.com/getsentry/sentry-javascript/issues/1168
    try {
        for(var property in fn)if (Object.prototype.hasOwnProperty.call(fn, property)) sentryWrapped[property] = fn[property];
    } catch (_oO) {} // eslint-disable-line no-empty
    // Signal that this function has been wrapped/filled already
    // for both debugging and to prevent it to being wrapped/filled twice
    (0, _utils.markFunctionWrapped)(sentryWrapped, fn);
    (0, _utils.addNonEnumerableProperty)(fn, '__sentry_wrapped__', sentryWrapped);
    // Restore original function name (not all browsers allow that)
    try {
        var descriptor = Object.getOwnPropertyDescriptor(sentryWrapped, 'name');
        if (descriptor.configurable) Object.defineProperty(sentryWrapped, 'name', {
            get: function() {
                return fn.name;
            }
        });
    // eslint-disable-next-line no-empty
    } catch (_oO) {}
    return sentryWrapped;
}
function injectReportDialog(options) {
    if (options === void 0) options = {};
    if (!global.document) return;
    if (!options.eventId) {
        (0, _flags.IS_DEBUG_BUILD) && (0, _utils.logger).error('Missing eventId option in showReportDialog call');
        return;
    }
    if (!options.dsn) {
        (0, _flags.IS_DEBUG_BUILD) && (0, _utils.logger).error('Missing dsn option in showReportDialog call');
        return;
    }
    var script = global.document.createElement('script');
    script.async = true;
    script.src = (0, _core.getReportDialogEndpoint)(options.dsn, options);
    if (options.onLoad) // eslint-disable-next-line @typescript-eslint/unbound-method
    script.onload = options.onLoad;
    var injectionPoint = global.document.head || global.document.body;
    if (injectionPoint) injectionPoint.appendChild(script);
}

},{"tslib":"6MhhU","@sentry/core":"lKLn3","@sentry/utils":"5wUYP","./flags":"hHpom","@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"2eOJi":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "GlobalHandlers", ()=>(0, _globalhandlers.GlobalHandlers));
parcelHelpers.export(exports, "TryCatch", ()=>(0, _trycatch.TryCatch));
parcelHelpers.export(exports, "Breadcrumbs", ()=>(0, _breadcrumbs.Breadcrumbs));
parcelHelpers.export(exports, "LinkedErrors", ()=>(0, _linkederrors.LinkedErrors));
parcelHelpers.export(exports, "UserAgent", ()=>(0, _useragent.UserAgent));
parcelHelpers.export(exports, "Dedupe", ()=>(0, _dedupe.Dedupe));
var _globalhandlers = require("./globalhandlers");
var _trycatch = require("./trycatch");
var _breadcrumbs = require("./breadcrumbs");
var _linkederrors = require("./linkederrors");
var _useragent = require("./useragent");
var _dedupe = require("./dedupe");

},{"./globalhandlers":"13lPF","./trycatch":"aUda3","./breadcrumbs":"dNC8N","./linkederrors":"4JYYe","./useragent":"2y7pK","./dedupe":"ikNUb","@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"13lPF":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "GlobalHandlers", ()=>GlobalHandlers);
var _tslib = require("tslib");
/* eslint-disable @typescript-eslint/no-unsafe-member-access */ var _core = require("@sentry/core");
var _types = require("@sentry/types");
var _utils = require("@sentry/utils");
var _eventbuilder = require("../eventbuilder");
var _flags = require("../flags");
var _helpers = require("../helpers");
/** Global handlers */ var GlobalHandlers = /** @class */ function() {
    /** JSDoc */ function GlobalHandlers(options) {
        /**
         * @inheritDoc
         */ this.name = GlobalHandlers.id;
        /**
         * Stores references functions to installing handlers. Will set to undefined
         * after they have been run so that they are not used twice.
         */ this._installFunc = {
            onerror: _installGlobalOnErrorHandler,
            onunhandledrejection: _installGlobalOnUnhandledRejectionHandler
        };
        this._options = (0, _tslib.__assign)({
            onerror: true,
            onunhandledrejection: true
        }, options);
    }
    /**
     * @inheritDoc
     */ GlobalHandlers.prototype.setupOnce = function() {
        Error.stackTraceLimit = 50;
        var options = this._options;
        // We can disable guard-for-in as we construct the options object above + do checks against
        // `this._installFunc` for the property.
        // eslint-disable-next-line guard-for-in
        for(var key in options){
            var installFunc = this._installFunc[key];
            if (installFunc && options[key]) {
                globalHandlerLog(key);
                installFunc();
                this._installFunc[key] = undefined;
            }
        }
    };
    /**
     * @inheritDoc
     */ GlobalHandlers.id = 'GlobalHandlers';
    return GlobalHandlers;
}();
/** JSDoc */ function _installGlobalOnErrorHandler() {
    (0, _utils.addInstrumentationHandler)('error', // eslint-disable-next-line @typescript-eslint/no-explicit-any
    function(data) {
        var _a = (0, _tslib.__read)(getHubAndAttachStacktrace(), 2), hub = _a[0], attachStacktrace = _a[1];
        if (!hub.getIntegration(GlobalHandlers)) return;
        var msg = data.msg, url = data.url, line = data.line, column = data.column, error = data.error;
        if ((0, _helpers.shouldIgnoreOnError)() || error && error.__sentry_own_request__) return;
        var event = error === undefined && (0, _utils.isString)(msg) ? _eventFromIncompleteOnError(msg, url, line, column) : _enhanceEventWithInitialFrame((0, _eventbuilder.eventFromUnknownInput)(error || msg, undefined, attachStacktrace, false), url, line, column);
        event.level = (0, _types.Severity).Error;
        addMechanismAndCapture(hub, error, event, 'onerror');
    });
}
/** JSDoc */ function _installGlobalOnUnhandledRejectionHandler() {
    (0, _utils.addInstrumentationHandler)('unhandledrejection', // eslint-disable-next-line @typescript-eslint/no-explicit-any
    function(e) {
        var _a = (0, _tslib.__read)(getHubAndAttachStacktrace(), 2), hub = _a[0], attachStacktrace = _a[1];
        if (!hub.getIntegration(GlobalHandlers)) return;
        var error = e;
        // dig the object of the rejection out of known event types
        try {
            // PromiseRejectionEvents store the object of the rejection under 'reason'
            // see https://developer.mozilla.org/en-US/docs/Web/API/PromiseRejectionEvent
            if ('reason' in e) error = e.reason;
            else if ('detail' in e && 'reason' in e.detail) error = e.detail.reason;
        } catch (_oO) {
        // no-empty
        }
        if ((0, _helpers.shouldIgnoreOnError)() || error && error.__sentry_own_request__) return true;
        var event = (0, _utils.isPrimitive)(error) ? _eventFromRejectionWithPrimitive(error) : (0, _eventbuilder.eventFromUnknownInput)(error, undefined, attachStacktrace, true);
        event.level = (0, _types.Severity).Error;
        addMechanismAndCapture(hub, error, event, 'onunhandledrejection');
        return;
    });
}
/**
 * Create an event from a promise rejection where the `reason` is a primitive.
 *
 * @param reason: The `reason` property of the promise rejection
 * @returns An Event object with an appropriate `exception` value
 */ function _eventFromRejectionWithPrimitive(reason) {
    return {
        exception: {
            values: [
                {
                    type: 'UnhandledRejection',
                    // String() is needed because the Primitive type includes symbols (which can't be automatically stringified)
                    value: "Non-Error promise rejection captured with value: " + String(reason)
                }
            ]
        }
    };
}
/**
 * This function creates a stack from an old, error-less onerror handler.
 */ // eslint-disable-next-line @typescript-eslint/no-explicit-any
function _eventFromIncompleteOnError(msg, url, line, column) {
    var ERROR_TYPES_RE = /^(?:[Uu]ncaught (?:exception: )?)?(?:((?:Eval|Internal|Range|Reference|Syntax|Type|URI|)Error): )?(.*)$/i;
    // If 'message' is ErrorEvent, get real message from inside
    var message = (0, _utils.isErrorEvent)(msg) ? msg.message : msg;
    var name = 'Error';
    var groups = message.match(ERROR_TYPES_RE);
    if (groups) {
        name = groups[1];
        message = groups[2];
    }
    var event = {
        exception: {
            values: [
                {
                    type: name,
                    value: message
                }
            ]
        }
    };
    return _enhanceEventWithInitialFrame(event, url, line, column);
}
/** JSDoc */ // eslint-disable-next-line @typescript-eslint/no-explicit-any
function _enhanceEventWithInitialFrame(event, url, line, column) {
    // event.exception
    var e = event.exception = event.exception || {};
    // event.exception.values
    var ev = e.values = e.values || [];
    // event.exception.values[0]
    var ev0 = ev[0] = ev[0] || {};
    // event.exception.values[0].stacktrace
    var ev0s = ev0.stacktrace = ev0.stacktrace || {};
    // event.exception.values[0].stacktrace.frames
    var ev0sf = ev0s.frames = ev0s.frames || [];
    var colno = isNaN(parseInt(column, 10)) ? undefined : column;
    var lineno = isNaN(parseInt(line, 10)) ? undefined : line;
    var filename = (0, _utils.isString)(url) && url.length > 0 ? url : (0, _utils.getLocationHref)();
    // event.exception.values[0].stacktrace.frames
    if (ev0sf.length === 0) ev0sf.push({
        colno: colno,
        filename: filename,
        function: '?',
        in_app: true,
        lineno: lineno
    });
    return event;
}
function globalHandlerLog(type) {
    (0, _flags.IS_DEBUG_BUILD) && (0, _utils.logger).log("Global Handler attached: " + type);
}
function addMechanismAndCapture(hub, error, event, type) {
    (0, _utils.addExceptionMechanism)(event, {
        handled: false,
        type: type
    });
    hub.captureEvent(event, {
        originalException: error
    });
}
function getHubAndAttachStacktrace() {
    var hub = (0, _core.getCurrentHub)();
    var client = hub.getClient();
    var attachStacktrace = client && client.getOptions().attachStacktrace;
    return [
        hub,
        attachStacktrace
    ];
}

},{"tslib":"6MhhU","@sentry/core":"lKLn3","@sentry/types":"92FRt","@sentry/utils":"5wUYP","../eventbuilder":"1K1bH","../flags":"hHpom","../helpers":"gVXVR","@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"aUda3":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "TryCatch", ()=>TryCatch);
var _tslib = require("tslib");
var _utils = require("@sentry/utils");
var _helpers = require("../helpers");
var DEFAULT_EVENT_TARGET = [
    'EventTarget',
    'Window',
    'Node',
    'ApplicationCache',
    'AudioTrackList',
    'ChannelMergerNode',
    'CryptoOperation',
    'EventSource',
    'FileReader',
    'HTMLUnknownElement',
    'IDBDatabase',
    'IDBRequest',
    'IDBTransaction',
    'KeyOperation',
    'MediaController',
    'MessagePort',
    'ModalWindow',
    'Notification',
    'SVGElementInstance',
    'Screen',
    'TextTrack',
    'TextTrackCue',
    'TextTrackList',
    'WebSocket',
    'WebSocketWorker',
    'Worker',
    'XMLHttpRequest',
    'XMLHttpRequestEventTarget',
    'XMLHttpRequestUpload'
];
/** Wrap timer functions and event targets to catch errors and provide better meta data */ var TryCatch = /** @class */ function() {
    /**
     * @inheritDoc
     */ function TryCatch(options) {
        /**
         * @inheritDoc
         */ this.name = TryCatch.id;
        this._options = (0, _tslib.__assign)({
            XMLHttpRequest: true,
            eventTarget: true,
            requestAnimationFrame: true,
            setInterval: true,
            setTimeout: true
        }, options);
    }
    /**
     * Wrap timer functions and event targets to catch errors
     * and provide better metadata.
     */ TryCatch.prototype.setupOnce = function() {
        var global = (0, _utils.getGlobalObject)();
        if (this._options.setTimeout) (0, _utils.fill)(global, 'setTimeout', _wrapTimeFunction);
        if (this._options.setInterval) (0, _utils.fill)(global, 'setInterval', _wrapTimeFunction);
        if (this._options.requestAnimationFrame) (0, _utils.fill)(global, 'requestAnimationFrame', _wrapRAF);
        if (this._options.XMLHttpRequest && 'XMLHttpRequest' in global) (0, _utils.fill)(XMLHttpRequest.prototype, 'send', _wrapXHR);
        var eventTargetOption = this._options.eventTarget;
        if (eventTargetOption) {
            var eventTarget = Array.isArray(eventTargetOption) ? eventTargetOption : DEFAULT_EVENT_TARGET;
            eventTarget.forEach(_wrapEventTarget);
        }
    };
    /**
     * @inheritDoc
     */ TryCatch.id = 'TryCatch';
    return TryCatch;
}();
/** JSDoc */ function _wrapTimeFunction(original) {
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    return function() {
        var args = [];
        for(var _i = 0; _i < arguments.length; _i++)args[_i] = arguments[_i];
        var originalCallback = args[0];
        args[0] = (0, _helpers.wrap)(originalCallback, {
            mechanism: {
                data: {
                    function: (0, _utils.getFunctionName)(original)
                },
                handled: true,
                type: 'instrument'
            }
        });
        return original.apply(this, args);
    };
}
/** JSDoc */ // eslint-disable-next-line @typescript-eslint/no-explicit-any
function _wrapRAF(original) {
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    return function(callback) {
        // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access
        return original.apply(this, [
            (0, _helpers.wrap)(callback, {
                mechanism: {
                    data: {
                        function: 'requestAnimationFrame',
                        handler: (0, _utils.getFunctionName)(original)
                    },
                    handled: true,
                    type: 'instrument'
                }
            })
        ]);
    };
}
/** JSDoc */ function _wrapXHR(originalSend) {
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    return function() {
        var args = [];
        for(var _i = 0; _i < arguments.length; _i++)args[_i] = arguments[_i];
        // eslint-disable-next-line @typescript-eslint/no-this-alias
        var xhr = this;
        var xmlHttpRequestProps = [
            'onload',
            'onerror',
            'onprogress',
            'onreadystatechange'
        ];
        xmlHttpRequestProps.forEach(function(prop) {
            if (prop in xhr && typeof xhr[prop] === 'function') // eslint-disable-next-line @typescript-eslint/no-explicit-any
            (0, _utils.fill)(xhr, prop, function(original) {
                var wrapOptions = {
                    mechanism: {
                        data: {
                            function: prop,
                            handler: (0, _utils.getFunctionName)(original)
                        },
                        handled: true,
                        type: 'instrument'
                    }
                };
                // If Instrument integration has been called before TryCatch, get the name of original function
                var originalFunction = (0, _utils.getOriginalFunction)(original);
                if (originalFunction) wrapOptions.mechanism.data.handler = (0, _utils.getFunctionName)(originalFunction);
                // Otherwise wrap directly
                return (0, _helpers.wrap)(original, wrapOptions);
            });
        });
        return originalSend.apply(this, args);
    };
}
/** JSDoc */ function _wrapEventTarget(target) {
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    var global = (0, _utils.getGlobalObject)();
    // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access
    var proto = global[target] && global[target].prototype;
    // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access, no-prototype-builtins
    if (!proto || !proto.hasOwnProperty || !proto.hasOwnProperty('addEventListener')) return;
    (0, _utils.fill)(proto, 'addEventListener', function(original) {
        return function(eventName, fn, options) {
            try {
                if (typeof fn.handleEvent === 'function') fn.handleEvent = (0, _helpers.wrap)(fn.handleEvent.bind(fn), {
                    mechanism: {
                        data: {
                            function: 'handleEvent',
                            handler: (0, _utils.getFunctionName)(fn),
                            target: target
                        },
                        handled: true,
                        type: 'instrument'
                    }
                });
            } catch (err) {
            // can sometimes get 'Permission denied to access property "handle Event'
            }
            return original.apply(this, [
                eventName,
                // eslint-disable-next-line @typescript-eslint/no-explicit-any
                (0, _helpers.wrap)(fn, {
                    mechanism: {
                        data: {
                            function: 'addEventListener',
                            handler: (0, _utils.getFunctionName)(fn),
                            target: target
                        },
                        handled: true,
                        type: 'instrument'
                    }
                }),
                options
            ]);
        };
    });
    (0, _utils.fill)(proto, 'removeEventListener', function(originalRemoveEventListener) {
        return function(eventName, fn, options) {
            /**
             * There are 2 possible scenarios here:
             *
             * 1. Someone passes a callback, which was attached prior to Sentry initialization, or by using unmodified
             * method, eg. `document.addEventListener.call(el, name, handler). In this case, we treat this function
             * as a pass-through, and call original `removeEventListener` with it.
             *
             * 2. Someone passes a callback, which was attached after Sentry was initialized, which means that it was using
             * our wrapped version of `addEventListener`, which internally calls `wrap` helper.
             * This helper "wraps" whole callback inside a try/catch statement, and attached appropriate metadata to it,
             * in order for us to make a distinction between wrapped/non-wrapped functions possible.
             * If a function was wrapped, it has additional property of `__sentry_wrapped__`, holding the handler.
             *
             * When someone adds a handler prior to initialization, and then do it again, but after,
             * then we have to detach both of them. Otherwise, if we'd detach only wrapped one, it'd be impossible
             * to get rid of the initial handler and it'd stick there forever.
             */ var wrappedEventHandler = fn;
            try {
                var originalEventHandler = wrappedEventHandler && wrappedEventHandler.__sentry_wrapped__;
                if (originalEventHandler) originalRemoveEventListener.call(this, eventName, originalEventHandler, options);
            } catch (e) {
            // ignore, accessing __sentry_wrapped__ will throw in some Selenium environments
            }
            return originalRemoveEventListener.call(this, eventName, wrappedEventHandler, options);
        };
    });
}

},{"tslib":"6MhhU","@sentry/utils":"5wUYP","../helpers":"gVXVR","@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"dNC8N":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "Breadcrumbs", ()=>Breadcrumbs);
var _tslib = require("tslib");
/* eslint-disable @typescript-eslint/no-unsafe-member-access */ /* eslint-disable max-lines */ var _core = require("@sentry/core");
var _types = require("@sentry/types");
var _utils = require("@sentry/utils");
/**
 * Default Breadcrumbs instrumentations
 * TODO: Deprecated - with v6, this will be renamed to `Instrument`
 */ var Breadcrumbs = /** @class */ function() {
    /**
     * @inheritDoc
     */ function Breadcrumbs(options) {
        /**
         * @inheritDoc
         */ this.name = Breadcrumbs.id;
        this._options = (0, _tslib.__assign)({
            console: true,
            dom: true,
            fetch: true,
            history: true,
            sentry: true,
            xhr: true
        }, options);
    }
    /**
     * Create a breadcrumb of `sentry` from the events themselves
     */ Breadcrumbs.prototype.addSentryBreadcrumb = function(event) {
        if (!this._options.sentry) return;
        (0, _core.getCurrentHub)().addBreadcrumb({
            category: "sentry." + (event.type === 'transaction' ? 'transaction' : 'event'),
            event_id: event.event_id,
            level: event.level,
            message: (0, _utils.getEventDescription)(event)
        }, {
            event: event
        });
    };
    /**
     * Instrument browser built-ins w/ breadcrumb capturing
     *  - Console API
     *  - DOM API (click/typing)
     *  - XMLHttpRequest API
     *  - Fetch API
     *  - History API
     */ Breadcrumbs.prototype.setupOnce = function() {
        if (this._options.console) (0, _utils.addInstrumentationHandler)('console', _consoleBreadcrumb);
        if (this._options.dom) (0, _utils.addInstrumentationHandler)('dom', _domBreadcrumb(this._options.dom));
        if (this._options.xhr) (0, _utils.addInstrumentationHandler)('xhr', _xhrBreadcrumb);
        if (this._options.fetch) (0, _utils.addInstrumentationHandler)('fetch', _fetchBreadcrumb);
        if (this._options.history) (0, _utils.addInstrumentationHandler)('history', _historyBreadcrumb);
    };
    /**
     * @inheritDoc
     */ Breadcrumbs.id = 'Breadcrumbs';
    return Breadcrumbs;
}();
/**
 * A HOC that creaes a function that creates breadcrumbs from DOM API calls.
 * This is a HOC so that we get access to dom options in the closure.
 */ // eslint-disable-next-line @typescript-eslint/no-explicit-any
function _domBreadcrumb(dom) {
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    function _innerDomBreadcrumb(handlerData) {
        var target;
        var keyAttrs = typeof dom === 'object' ? dom.serializeAttribute : undefined;
        if (typeof keyAttrs === 'string') keyAttrs = [
            keyAttrs
        ];
        // Accessing event.target can throw (see getsentry/raven-js#838, #768)
        try {
            target = handlerData.event.target ? (0, _utils.htmlTreeAsString)(handlerData.event.target, keyAttrs) : (0, _utils.htmlTreeAsString)(handlerData.event, keyAttrs);
        } catch (e) {
            target = '<unknown>';
        }
        if (target.length === 0) return;
        (0, _core.getCurrentHub)().addBreadcrumb({
            category: "ui." + handlerData.name,
            message: target
        }, {
            event: handlerData.event,
            name: handlerData.name,
            global: handlerData.global
        });
    }
    return _innerDomBreadcrumb;
}
/**
 * Creates breadcrumbs from console API calls
 */ // eslint-disable-next-line @typescript-eslint/no-explicit-any
function _consoleBreadcrumb(handlerData) {
    var breadcrumb = {
        category: 'console',
        data: {
            arguments: handlerData.args,
            logger: 'console'
        },
        level: (0, _utils.severityFromString)(handlerData.level),
        message: (0, _utils.safeJoin)(handlerData.args, ' ')
    };
    if (handlerData.level === 'assert') {
        if (handlerData.args[0] === false) {
            breadcrumb.message = "Assertion failed: " + ((0, _utils.safeJoin)(handlerData.args.slice(1), ' ') || 'console.assert');
            breadcrumb.data.arguments = handlerData.args.slice(1);
        } else // Don't capture a breadcrumb for passed assertions
        return;
    }
    (0, _core.getCurrentHub)().addBreadcrumb(breadcrumb, {
        input: handlerData.args,
        level: handlerData.level
    });
}
/**
 * Creates breadcrumbs from XHR API calls
 */ // eslint-disable-next-line @typescript-eslint/no-explicit-any
function _xhrBreadcrumb(handlerData) {
    if (handlerData.endTimestamp) {
        // We only capture complete, non-sentry requests
        if (handlerData.xhr.__sentry_own_request__) return;
        var _a = handlerData.xhr.__sentry_xhr__ || {}, method = _a.method, url = _a.url, status_code = _a.status_code, body = _a.body;
        (0, _core.getCurrentHub)().addBreadcrumb({
            category: 'xhr',
            data: {
                method: method,
                url: url,
                status_code: status_code
            },
            type: 'http'
        }, {
            xhr: handlerData.xhr,
            input: body
        });
        return;
    }
}
/**
 * Creates breadcrumbs from fetch API calls
 */ // eslint-disable-next-line @typescript-eslint/no-explicit-any
function _fetchBreadcrumb(handlerData) {
    // We only capture complete fetch requests
    if (!handlerData.endTimestamp) return;
    if (handlerData.fetchData.url.match(/sentry_key/) && handlerData.fetchData.method === 'POST') // We will not create breadcrumbs for fetch requests that contain `sentry_key` (internal sentry requests)
    return;
    if (handlerData.error) (0, _core.getCurrentHub)().addBreadcrumb({
        category: 'fetch',
        data: handlerData.fetchData,
        level: (0, _types.Severity).Error,
        type: 'http'
    }, {
        data: handlerData.error,
        input: handlerData.args
    });
    else (0, _core.getCurrentHub)().addBreadcrumb({
        category: 'fetch',
        data: (0, _tslib.__assign)((0, _tslib.__assign)({}, handlerData.fetchData), {
            status_code: handlerData.response.status
        }),
        type: 'http'
    }, {
        input: handlerData.args,
        response: handlerData.response
    });
}
/**
 * Creates breadcrumbs from history API calls
 */ // eslint-disable-next-line @typescript-eslint/no-explicit-any
function _historyBreadcrumb(handlerData) {
    var global = (0, _utils.getGlobalObject)();
    var from = handlerData.from;
    var to = handlerData.to;
    var parsedLoc = (0, _utils.parseUrl)(global.location.href);
    var parsedFrom = (0, _utils.parseUrl)(from);
    var parsedTo = (0, _utils.parseUrl)(to);
    // Initial pushState doesn't provide `from` information
    if (!parsedFrom.path) parsedFrom = parsedLoc;
    // Use only the path component of the URL if the URL matches the current
    // document (almost all the time when using pushState)
    if (parsedLoc.protocol === parsedTo.protocol && parsedLoc.host === parsedTo.host) to = parsedTo.relative;
    if (parsedLoc.protocol === parsedFrom.protocol && parsedLoc.host === parsedFrom.host) from = parsedFrom.relative;
    (0, _core.getCurrentHub)().addBreadcrumb({
        category: 'navigation',
        data: {
            from: from,
            to: to
        }
    });
}

},{"tslib":"6MhhU","@sentry/core":"lKLn3","@sentry/types":"92FRt","@sentry/utils":"5wUYP","@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"4JYYe":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "LinkedErrors", ()=>LinkedErrors);
/**
 * @inheritDoc
 */ parcelHelpers.export(exports, "_handler", ()=>_handler);
/**
 * JSDOC
 */ parcelHelpers.export(exports, "_walkErrorTree", ()=>_walkErrorTree);
var _tslib = require("tslib");
var _core = require("@sentry/core");
var _utils = require("@sentry/utils");
var _eventbuilder = require("../eventbuilder");
var DEFAULT_KEY = 'cause';
var DEFAULT_LIMIT = 5;
/** Adds SDK info to an event. */ var LinkedErrors = /** @class */ function() {
    /**
     * @inheritDoc
     */ function LinkedErrors(options) {
        if (options === void 0) options = {};
        /**
         * @inheritDoc
         */ this.name = LinkedErrors.id;
        this._key = options.key || DEFAULT_KEY;
        this._limit = options.limit || DEFAULT_LIMIT;
    }
    /**
     * @inheritDoc
     */ LinkedErrors.prototype.setupOnce = function() {
        (0, _core.addGlobalEventProcessor)(function(event, hint) {
            var self = (0, _core.getCurrentHub)().getIntegration(LinkedErrors);
            return self ? _handler(self._key, self._limit, event, hint) : event;
        });
    };
    /**
     * @inheritDoc
     */ LinkedErrors.id = 'LinkedErrors';
    return LinkedErrors;
}();
function _handler(key, limit, event, hint) {
    if (!event.exception || !event.exception.values || !hint || !(0, _utils.isInstanceOf)(hint.originalException, Error)) return event;
    var linkedErrors = _walkErrorTree(limit, hint.originalException, key);
    event.exception.values = (0, _tslib.__spread)(linkedErrors, event.exception.values);
    return event;
}
function _walkErrorTree(limit, error, key, stack) {
    if (stack === void 0) stack = [];
    if (!(0, _utils.isInstanceOf)(error[key], Error) || stack.length + 1 >= limit) return stack;
    var exception = (0, _eventbuilder.exceptionFromError)(error[key]);
    return _walkErrorTree(limit, error[key], key, (0, _tslib.__spread)([
        exception
    ], stack));
}

},{"tslib":"6MhhU","@sentry/core":"lKLn3","@sentry/utils":"5wUYP","../eventbuilder":"1K1bH","@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"2y7pK":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "UserAgent", ()=>UserAgent);
var _tslib = require("tslib");
var _core = require("@sentry/core");
var _utils = require("@sentry/utils");
var global = (0, _utils.getGlobalObject)();
/** UserAgent */ var UserAgent = /** @class */ function() {
    function UserAgent() {
        /**
         * @inheritDoc
         */ this.name = UserAgent.id;
    }
    /**
     * @inheritDoc
     */ UserAgent.prototype.setupOnce = function() {
        (0, _core.addGlobalEventProcessor)(function(event) {
            if ((0, _core.getCurrentHub)().getIntegration(UserAgent)) {
                // if none of the information we want exists, don't bother
                if (!global.navigator && !global.location && !global.document) return event;
                // grab as much info as exists and add it to the event
                var url = event.request && event.request.url || global.location && global.location.href;
                var referrer = (global.document || {}).referrer;
                var userAgent = (global.navigator || {}).userAgent;
                var headers = (0, _tslib.__assign)((0, _tslib.__assign)((0, _tslib.__assign)({}, event.request && event.request.headers), referrer && {
                    Referer: referrer
                }), userAgent && {
                    'User-Agent': userAgent
                });
                var request = (0, _tslib.__assign)((0, _tslib.__assign)({}, url && {
                    url: url
                }), {
                    headers: headers
                });
                return (0, _tslib.__assign)((0, _tslib.__assign)({}, event), {
                    request: request
                });
            }
            return event;
        });
    };
    /**
     * @inheritDoc
     */ UserAgent.id = 'UserAgent';
    return UserAgent;
}();

},{"tslib":"6MhhU","@sentry/core":"lKLn3","@sentry/utils":"5wUYP","@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"ikNUb":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "Dedupe", ()=>Dedupe);
var _utils = require("@sentry/utils");
var _flags = require("../flags");
/** Deduplication filter */ var Dedupe = /** @class */ function() {
    function Dedupe() {
        /**
         * @inheritDoc
         */ this.name = Dedupe.id;
    }
    /**
     * @inheritDoc
     */ Dedupe.prototype.setupOnce = function(addGlobalEventProcessor, getCurrentHub) {
        addGlobalEventProcessor(function(currentEvent) {
            var self = getCurrentHub().getIntegration(Dedupe);
            if (self) {
                // Juuust in case something goes wrong
                try {
                    if (_shouldDropEvent(currentEvent, self._previousEvent)) {
                        (0, _flags.IS_DEBUG_BUILD) && (0, _utils.logger).warn('Event dropped due to being a duplicate of previously captured event.');
                        return null;
                    }
                } catch (_oO) {
                    return self._previousEvent = currentEvent;
                }
                return self._previousEvent = currentEvent;
            }
            return currentEvent;
        });
    };
    /**
     * @inheritDoc
     */ Dedupe.id = 'Dedupe';
    return Dedupe;
}();
/** JSDoc */ function _shouldDropEvent(currentEvent, previousEvent) {
    if (!previousEvent) return false;
    if (_isSameMessageEvent(currentEvent, previousEvent)) return true;
    if (_isSameExceptionEvent(currentEvent, previousEvent)) return true;
    return false;
}
/** JSDoc */ function _isSameMessageEvent(currentEvent, previousEvent) {
    var currentMessage = currentEvent.message;
    var previousMessage = previousEvent.message;
    // If neither event has a message property, they were both exceptions, so bail out
    if (!currentMessage && !previousMessage) return false;
    // If only one event has a stacktrace, but not the other one, they are not the same
    if (currentMessage && !previousMessage || !currentMessage && previousMessage) return false;
    if (currentMessage !== previousMessage) return false;
    if (!_isSameFingerprint(currentEvent, previousEvent)) return false;
    if (!_isSameStacktrace(currentEvent, previousEvent)) return false;
    return true;
}
/** JSDoc */ function _isSameExceptionEvent(currentEvent, previousEvent) {
    var previousException = _getExceptionFromEvent(previousEvent);
    var currentException = _getExceptionFromEvent(currentEvent);
    if (!previousException || !currentException) return false;
    if (previousException.type !== currentException.type || previousException.value !== currentException.value) return false;
    if (!_isSameFingerprint(currentEvent, previousEvent)) return false;
    if (!_isSameStacktrace(currentEvent, previousEvent)) return false;
    return true;
}
/** JSDoc */ function _isSameStacktrace(currentEvent, previousEvent) {
    var currentFrames = _getFramesFromEvent(currentEvent);
    var previousFrames = _getFramesFromEvent(previousEvent);
    // If neither event has a stacktrace, they are assumed to be the same
    if (!currentFrames && !previousFrames) return true;
    // If only one event has a stacktrace, but not the other one, they are not the same
    if (currentFrames && !previousFrames || !currentFrames && previousFrames) return false;
    currentFrames;
    previousFrames;
    // If number of frames differ, they are not the same
    if (previousFrames.length !== currentFrames.length) return false;
    // Otherwise, compare the two
    for(var i = 0; i < previousFrames.length; i++){
        var frameA = previousFrames[i];
        var frameB = currentFrames[i];
        if (frameA.filename !== frameB.filename || frameA.lineno !== frameB.lineno || frameA.colno !== frameB.colno || frameA.function !== frameB.function) return false;
    }
    return true;
}
/** JSDoc */ function _isSameFingerprint(currentEvent, previousEvent) {
    var currentFingerprint = currentEvent.fingerprint;
    var previousFingerprint = previousEvent.fingerprint;
    // If neither event has a fingerprint, they are assumed to be the same
    if (!currentFingerprint && !previousFingerprint) return true;
    // If only one event has a fingerprint, but not the other one, they are not the same
    if (currentFingerprint && !previousFingerprint || !currentFingerprint && previousFingerprint) return false;
    currentFingerprint;
    previousFingerprint;
    // Otherwise, compare the two
    try {
        return !!(currentFingerprint.join('') === previousFingerprint.join(''));
    } catch (_oO) {
        return false;
    }
}
/** JSDoc */ function _getExceptionFromEvent(event) {
    return event.exception && event.exception.values && event.exception.values[0];
}
/** JSDoc */ function _getFramesFromEvent(event) {
    var exception = event.exception;
    if (exception) try {
        // @ts-ignore Object could be undefined
        return exception.values[0].stacktrace.frames;
    } catch (_oO) {
        return undefined;
    }
    else if (event.stacktrace) return event.stacktrace.frames;
    return undefined;
}

},{"@sentry/utils":"5wUYP","../flags":"hHpom","@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"aIaMj":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "defaultIntegrations", ()=>defaultIntegrations);
/**
 * The Sentry Browser SDK Client.
 *
 * To use this SDK, call the {@link init} function as early as possible when
 * loading the web page. To set context information or send manual events, use
 * the provided methods.
 *
 * @example
 *
 * ```
 *
 * import { init } from '@sentry/browser';
 *
 * init({
 *   dsn: '__DSN__',
 *   // ...
 * });
 * ```
 *
 * @example
 * ```
 *
 * import { configureScope } from '@sentry/browser';
 * configureScope((scope: Scope) => {
 *   scope.setExtra({ battery: 0.7 });
 *   scope.setTag({ user_mode: 'admin' });
 *   scope.setUser({ id: '4711' });
 * });
 * ```
 *
 * @example
 * ```
 *
 * import { addBreadcrumb } from '@sentry/browser';
 * addBreadcrumb({
 *   message: 'My Breadcrumb',
 *   // ...
 * });
 * ```
 *
 * @example
 *
 * ```
 *
 * import * as Sentry from '@sentry/browser';
 * Sentry.captureMessage('Hello, world!');
 * Sentry.captureException(new Error('Good bye'));
 * Sentry.captureEvent({
 *   message: 'Manual',
 *   stacktrace: [
 *     // ...
 *   ],
 * });
 * ```
 *
 * @see {@link BrowserOptions} for documentation on configuration options.
 */ parcelHelpers.export(exports, "init", ()=>init);
/**
 * Present the user with a report dialog.
 *
 * @param options Everything is optional, we try to fetch all info need from the global scope.
 */ parcelHelpers.export(exports, "showReportDialog", ()=>showReportDialog);
/**
 * This is the getter for lastEventId.
 *
 * @returns The last event id of a captured event.
 */ parcelHelpers.export(exports, "lastEventId", ()=>lastEventId);
/**
 * This function is here to be API compatible with the loader.
 * @hidden
 */ parcelHelpers.export(exports, "forceLoad", ()=>forceLoad);
/**
 * This function is here to be API compatible with the loader.
 * @hidden
 */ parcelHelpers.export(exports, "onLoad", ()=>onLoad);
/**
 * Call `flush()` on the current client, if there is one. See {@link Client.flush}.
 *
 * @param timeout Maximum time in ms the client should wait to flush its event queue. Omitting this parameter will cause
 * the client to wait until all events are sent before resolving the promise.
 * @returns A promise which resolves to `true` if the queue successfully drains before the timeout, or `false` if it
 * doesn't (or if there's no client defined).
 */ parcelHelpers.export(exports, "flush", ()=>flush);
/**
 * Call `close()` on the current client, if there is one. See {@link Client.close}.
 *
 * @param timeout Maximum time in ms the client should wait to flush its event queue before shutting down. Omitting this
 * parameter will cause the client to wait until all events are sent before disabling itself.
 * @returns A promise which resolves to `true` if the queue successfully drains before the timeout, or `false` if it
 * doesn't (or if there's no client defined).
 */ parcelHelpers.export(exports, "close", ()=>close);
/**
 * Wrap code within a try/catch block so the SDK is able to capture errors.
 *
 * @param fn A function to wrap.
 *
 * @returns The result of wrapped function call.
 */ // eslint-disable-next-line @typescript-eslint/no-explicit-any
parcelHelpers.export(exports, "wrap", ()=>wrap);
var _tslib = require("tslib");
var _core = require("@sentry/core");
var _utils = require("@sentry/utils");
var _client = require("./client");
var _flags = require("./flags");
var _helpers = require("./helpers");
var _integrations = require("./integrations");
var defaultIntegrations = [
    new (0, _core.Integrations).InboundFilters(),
    new (0, _core.Integrations).FunctionToString(),
    new (0, _integrations.TryCatch)(),
    new (0, _integrations.Breadcrumbs)(),
    new (0, _integrations.GlobalHandlers)(),
    new (0, _integrations.LinkedErrors)(),
    new (0, _integrations.Dedupe)(),
    new (0, _integrations.UserAgent)()
];
function init(options) {
    if (options === void 0) options = {};
    if (options.defaultIntegrations === undefined) options.defaultIntegrations = defaultIntegrations;
    if (options.release === undefined) {
        var window_1 = (0, _utils.getGlobalObject)();
        // This supports the variable that sentry-webpack-plugin injects
        if (window_1.SENTRY_RELEASE && window_1.SENTRY_RELEASE.id) options.release = window_1.SENTRY_RELEASE.id;
    }
    if (options.autoSessionTracking === undefined) options.autoSessionTracking = true;
    if (options.sendClientReports === undefined) options.sendClientReports = true;
    (0, _core.initAndBind)((0, _client.BrowserClient), options);
    if (options.autoSessionTracking) startSessionTracking();
}
function showReportDialog(options) {
    if (options === void 0) options = {};
    var hub = (0, _core.getCurrentHub)();
    var scope = hub.getScope();
    if (scope) options.user = (0, _tslib.__assign)((0, _tslib.__assign)({}, scope.getUser()), options.user);
    if (!options.eventId) options.eventId = hub.lastEventId();
    var client = hub.getClient();
    if (client) client.showReportDialog(options);
}
function lastEventId() {
    return (0, _core.getCurrentHub)().lastEventId();
}
function forceLoad() {
// Noop
}
function onLoad(callback) {
    callback();
}
function flush(timeout) {
    var client = (0, _core.getCurrentHub)().getClient();
    if (client) return client.flush(timeout);
    (0, _flags.IS_DEBUG_BUILD) && (0, _utils.logger).warn('Cannot flush events. No client defined.');
    return (0, _utils.resolvedSyncPromise)(false);
}
function close(timeout) {
    var client = (0, _core.getCurrentHub)().getClient();
    if (client) return client.close(timeout);
    (0, _flags.IS_DEBUG_BUILD) && (0, _utils.logger).warn('Cannot flush events and disable SDK. No client defined.');
    return (0, _utils.resolvedSyncPromise)(false);
}
function wrap(fn) {
    return (0, _helpers.wrap)(fn)();
}
function startSessionOnHub(hub) {
    hub.startSession({
        ignoreDuration: true
    });
    hub.captureSession();
}
/**
 * Enable automatic Session Tracking for the initial page load.
 */ function startSessionTracking() {
    var window = (0, _utils.getGlobalObject)();
    var document = window.document;
    if (typeof document === 'undefined') {
        (0, _flags.IS_DEBUG_BUILD) && (0, _utils.logger).warn('Session tracking in non-browser environment with @sentry/browser is not supported.');
        return;
    }
    var hub = (0, _core.getCurrentHub)();
    // The only way for this to be false is for there to be a version mismatch between @sentry/browser (>= 6.0.0) and
    // @sentry/hub (< 5.27.0). In the simple case, there won't ever be such a mismatch, because the two packages are
    // pinned at the same version in package.json, but there are edge cases where it's possible. See
    // https://github.com/getsentry/sentry-javascript/issues/3207 and
    // https://github.com/getsentry/sentry-javascript/issues/3234 and
    // https://github.com/getsentry/sentry-javascript/issues/3278.
    if (!hub.captureSession) return;
    // The session duration for browser sessions does not track a meaningful
    // concept that can be used as a metric.
    // Automatically captured sessions are akin to page views, and thus we
    // discard their duration.
    startSessionOnHub(hub);
    // We want to create a session for every navigation as well
    (0, _utils.addInstrumentationHandler)('history', function(_a) {
        var from = _a.from, to = _a.to;
        // Don't create an additional session for the initial route or if the location did not change
        if (!(from === undefined || from === to)) startSessionOnHub((0, _core.getCurrentHub)());
    });
}

},{"tslib":"6MhhU","@sentry/core":"lKLn3","@sentry/utils":"5wUYP","./client":"lvqfm","./flags":"hHpom","./helpers":"gVXVR","./integrations":"2eOJi","@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"7oOmp":[function(require,module,exports,__globalThis) {
// TODO: Remove in the next major release and rely only on @sentry/core SDK_VERSION and SdkInfo metadata
var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "SDK_NAME", ()=>SDK_NAME);
var SDK_NAME = 'sentry.javascript.browser';

},{"@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"f1O2Y":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "Angular", ()=>(0, _angular.Angular));
parcelHelpers.export(exports, "CaptureConsole", ()=>(0, _captureconsole.CaptureConsole));
parcelHelpers.export(exports, "Debug", ()=>(0, _debug.Debug));
parcelHelpers.export(exports, "Dedupe", ()=>(0, _dedupe.Dedupe));
parcelHelpers.export(exports, "Ember", ()=>(0, _ember.Ember));
parcelHelpers.export(exports, "ExtraErrorData", ()=>(0, _extraerrordata.ExtraErrorData));
parcelHelpers.export(exports, "Offline", ()=>(0, _offline.Offline));
parcelHelpers.export(exports, "ReportingObserver", ()=>(0, _reportingobserver.ReportingObserver));
parcelHelpers.export(exports, "RewriteFrames", ()=>(0, _rewriteframes.RewriteFrames));
parcelHelpers.export(exports, "SessionTiming", ()=>(0, _sessiontiming.SessionTiming));
parcelHelpers.export(exports, "Transaction", ()=>(0, _transaction.Transaction));
parcelHelpers.export(exports, "Vue", ()=>(0, _vue.Vue));
var _angular = require("./angular");
var _captureconsole = require("./captureconsole");
var _debug = require("./debug");
var _dedupe = require("./dedupe");
var _ember = require("./ember");
var _extraerrordata = require("./extraerrordata");
var _offline = require("./offline");
var _reportingobserver = require("./reportingobserver");
var _rewriteframes = require("./rewriteframes");
var _sessiontiming = require("./sessiontiming");
var _transaction = require("./transaction");
var _vue = require("./vue");

},{"./angular":"UnPB6","./captureconsole":"9p2x8","./debug":"1NZDu","./dedupe":"3g8wa","./ember":"dkCw5","./extraerrordata":"7IeG2","./offline":"8xoBF","./reportingobserver":"iDjHW","./rewriteframes":"j0Fpn","./sessiontiming":"7WJ3R","./transaction":"irfOu","./vue":"4MQaV","@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"UnPB6":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "Angular", ()=>Angular);
var _tslib = require("tslib");
var _utils = require("@sentry/utils");
var _flags = require("./flags");
// See https://github.com/angular/angular.js/blob/v1.4.7/src/minErr.js
var angularPattern = /^\[((?:[$a-zA-Z0-9]+:)?(?:[$a-zA-Z0-9]+))\] (.*?)\n?(\S+)$/;
/**
 * AngularJS integration
 *
 * Provides an $exceptionHandler for AngularJS
 */ var Angular = /** @class */ function() {
    /**
     * @inheritDoc
     */ // eslint-disable-next-line @typescript-eslint/no-explicit-any
    function Angular(options) {
        if (options === void 0) options = {};
        /**
         * @inheritDoc
         */ this.name = Angular.id;
        (0, _flags.IS_DEBUG_BUILD) && (0, _utils.logger).log('You are still using the Angular integration, consider moving to @sentry/angular');
        // eslint-disable-next-line @typescript-eslint/no-explicit-any, @typescript-eslint/no-unsafe-member-access
        this._angular = options.angular || (0, _utils.getGlobalObject)().angular;
        if (!this._angular) {
            (0, _flags.IS_DEBUG_BUILD) && (0, _utils.logger).error('AngularIntegration is missing an Angular instance');
            return;
        }
        // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access
        this._module = this._angular.module(Angular.moduleName, []);
    }
    /**
     * @inheritDoc
     */ Angular.prototype.setupOnce = function(_, getCurrentHub) {
        var _this = this;
        if (!this._module) return;
        this._getCurrentHub = getCurrentHub;
        // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access
        this._module.config([
            '$provide',
            // eslint-disable-next-line @typescript-eslint/no-explicit-any
            function($provide) {
                // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access
                $provide.decorator('$exceptionHandler', [
                    '$delegate',
                    _this._$exceptionHandlerDecorator.bind(_this)
                ]);
            }
        ]);
    };
    /**
     * Angular's exceptionHandler for Sentry integration
     */ // eslint-disable-next-line @typescript-eslint/no-explicit-any
    Angular.prototype._$exceptionHandlerDecorator = function($delegate) {
        var _this = this;
        return function(exception, cause) {
            var hub = _this._getCurrentHub && _this._getCurrentHub();
            if (hub && hub.getIntegration(Angular)) hub.withScope(function(scope) {
                if (cause) scope.setExtra('cause', cause);
                scope.addEventProcessor(function(event) {
                    var ex = event.exception && event.exception.values && event.exception.values[0];
                    if (ex) {
                        var matches = angularPattern.exec(ex.value || '');
                        if (matches) {
                            // This type now becomes something like: $rootScope:inprog
                            ex.type = matches[1];
                            ex.value = matches[2];
                            event.message = ex.type + ": " + ex.value;
                            // auto set a new tag specifically for the angular error url
                            event.extra = (0, _tslib.__assign)((0, _tslib.__assign)({}, event.extra), {
                                angularDocs: matches[3].substr(0, 250)
                            });
                        }
                    }
                    return event;
                });
                hub.captureException(exception);
            });
            $delegate(exception, cause);
        };
    };
    /**
     * @inheritDoc
     */ Angular.id = 'AngularJS';
    /**
     * moduleName used in Angular's DI resolution algorithm
     */ Angular.moduleName = 'ngSentry';
    return Angular;
}();

},{"tslib":"6MhhU","@sentry/utils":"agmfj","./flags":"9Knv0","@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"agmfj":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _async = require("./async");
parcelHelpers.exportAll(_async, exports);
var _browser = require("./browser");
parcelHelpers.exportAll(_browser, exports);
var _dsn = require("./dsn");
parcelHelpers.exportAll(_dsn, exports);
var _enums = require("./enums");
parcelHelpers.exportAll(_enums, exports);
var _error = require("./error");
parcelHelpers.exportAll(_error, exports);
var _global = require("./global");
parcelHelpers.exportAll(_global, exports);
var _instrument = require("./instrument");
parcelHelpers.exportAll(_instrument, exports);
var _is = require("./is");
parcelHelpers.exportAll(_is, exports);
var _logger = require("./logger");
parcelHelpers.exportAll(_logger, exports);
var _memo = require("./memo");
parcelHelpers.exportAll(_memo, exports);
var _misc = require("./misc");
parcelHelpers.exportAll(_misc, exports);
var _node = require("./node");
parcelHelpers.exportAll(_node, exports);
var _normalize = require("./normalize");
parcelHelpers.exportAll(_normalize, exports);
var _object = require("./object");
parcelHelpers.exportAll(_object, exports);
var _path = require("./path");
parcelHelpers.exportAll(_path, exports);
var _promisebuffer = require("./promisebuffer");
parcelHelpers.exportAll(_promisebuffer, exports);
var _severity = require("./severity");
parcelHelpers.exportAll(_severity, exports);
var _stacktrace = require("./stacktrace");
parcelHelpers.exportAll(_stacktrace, exports);
var _status = require("./status");
parcelHelpers.exportAll(_status, exports);
var _string = require("./string");
parcelHelpers.exportAll(_string, exports);
var _supports = require("./supports");
parcelHelpers.exportAll(_supports, exports);
var _syncpromise = require("./syncpromise");
parcelHelpers.exportAll(_syncpromise, exports);
var _time = require("./time");
parcelHelpers.exportAll(_time, exports);
var _tracing = require("./tracing");
parcelHelpers.exportAll(_tracing, exports);
var _env = require("./env");
parcelHelpers.exportAll(_env, exports);
var _envelope = require("./envelope");
parcelHelpers.exportAll(_envelope, exports);
var _clientreport = require("./clientreport");
parcelHelpers.exportAll(_clientreport, exports);
var _ratelimit = require("./ratelimit");
parcelHelpers.exportAll(_ratelimit, exports);

},{"./async":false,"./browser":false,"./dsn":false,"./enums":false,"./error":false,"./global":"fL2wD","./instrument":false,"./is":"146Cn","./logger":"aKz1P","./memo":false,"./misc":"glLsc","./node":"1fqDp","./normalize":"cM93L","./object":"f5595","./path":"IiyPy","./promisebuffer":false,"./severity":"kCtsv","./stacktrace":false,"./status":false,"./string":"cCvon","./supports":"k962Q","./syncpromise":false,"./time":"SOapb","./tracing":false,"./env":false,"./envelope":false,"./clientreport":false,"./ratelimit":false,"@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"1YURa":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
/**
 * Given a child DOM element, returns a query-selector statement describing that
 * and its ancestors
 * e.g. [HTMLElement] => body > div > input#foo.btn[name=baz]
 * @returns generated DOM path
 */ parcelHelpers.export(exports, "htmlTreeAsString", ()=>htmlTreeAsString);
/**
 * A safe form of location.href
 */ parcelHelpers.export(exports, "getLocationHref", ()=>getLocationHref);
var _global = require("./global");
var _is = require("./is");
function htmlTreeAsString(elem, keyAttrs) {
    // try/catch both:
    // - accessing event.target (see getsentry/raven-js#838, #768)
    // - `htmlTreeAsString` because it's complex, and just accessing the DOM incorrectly
    // - can throw an exception in some circumstances.
    try {
        var currentElem = elem;
        var MAX_TRAVERSE_HEIGHT = 5;
        var MAX_OUTPUT_LEN = 80;
        var out = [];
        var height = 0;
        var len = 0;
        var separator = ' > ';
        var sepLength = separator.length;
        var nextStr = void 0;
        // eslint-disable-next-line no-plusplus
        while(currentElem && height++ < MAX_TRAVERSE_HEIGHT){
            nextStr = _htmlElementAsString(currentElem, keyAttrs);
            // bail out if
            // - nextStr is the 'html' element
            // - the length of the string that would be created exceeds MAX_OUTPUT_LEN
            //   (ignore this limit if we are on the first iteration)
            if (nextStr === 'html' || height > 1 && len + out.length * sepLength + nextStr.length >= MAX_OUTPUT_LEN) break;
            out.push(nextStr);
            len += nextStr.length;
            currentElem = currentElem.parentNode;
        }
        return out.reverse().join(separator);
    } catch (_oO) {
        return '<unknown>';
    }
}
/**
 * Returns a simple, query-selector representation of a DOM element
 * e.g. [HTMLElement] => input#foo.btn[name=baz]
 * @returns generated DOM path
 */ function _htmlElementAsString(el, keyAttrs) {
    var elem = el;
    var out = [];
    var className;
    var classes;
    var key;
    var attr;
    var i;
    if (!elem || !elem.tagName) return '';
    out.push(elem.tagName.toLowerCase());
    // Pairs of attribute keys defined in `serializeAttribute` and their values on element.
    var keyAttrPairs = keyAttrs && keyAttrs.length ? keyAttrs.filter(function(keyAttr) {
        return elem.getAttribute(keyAttr);
    }).map(function(keyAttr) {
        return [
            keyAttr,
            elem.getAttribute(keyAttr)
        ];
    }) : null;
    if (keyAttrPairs && keyAttrPairs.length) keyAttrPairs.forEach(function(keyAttrPair) {
        out.push("[" + keyAttrPair[0] + "=\"" + keyAttrPair[1] + "\"]");
    });
    else {
        if (elem.id) out.push("#" + elem.id);
        // eslint-disable-next-line prefer-const
        className = elem.className;
        if (className && (0, _is.isString)(className)) {
            classes = className.split(/\s+/);
            for(i = 0; i < classes.length; i++)out.push("." + classes[i]);
        }
    }
    var allowedAttrs = [
        'type',
        'name',
        'title',
        'alt'
    ];
    for(i = 0; i < allowedAttrs.length; i++){
        key = allowedAttrs[i];
        attr = elem.getAttribute(key);
        if (attr) out.push("[" + key + "=\"" + attr + "\"]");
    }
    return out.join('');
}
function getLocationHref() {
    var global = (0, _global.getGlobalObject)();
    try {
        return global.document.location.href;
    } catch (oO) {
        return '';
    }
}

},{"./global":"fL2wD","./is":"146Cn","@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"fL2wD":[function(require,module,exports,__globalThis) {
/**
 * NOTE: In order to avoid circular dependencies, if you add a function to this module and it needs to print something,
 * you must either a) use `console.log` rather than the logger, or b) put your function elsewhere.
 */ var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
/**
 * Safely get global scope object
 *
 * @returns Global scope object
 */ parcelHelpers.export(exports, "getGlobalObject", ()=>getGlobalObject);
/**
 * Returns a global singleton contained in the global `__SENTRY__` object.
 *
 * If the singleton doesn't already exist in `__SENTRY__`, it will be created using the given factory
 * function and added to the `__SENTRY__` object.
 *
 * @param name name of the global singleton on __SENTRY__
 * @param creator creator Factory function to create the singleton if it doesn't already exist on `__SENTRY__`
 * @param obj (Optional) The global object on which to look for `__SENTRY__`, if not `getGlobalObject`'s return value
 * @returns the singleton
 */ parcelHelpers.export(exports, "getGlobalSingleton", ()=>getGlobalSingleton);
var _node = require("./node");
var global = arguments[3];
var fallbackGlobalObject = {};
function getGlobalObject() {
    return (0, _node.isNodeEnv)() ? global : typeof window !== 'undefined' // eslint-disable-line no-restricted-globals
     ? window // eslint-disable-line no-restricted-globals
     : typeof self !== 'undefined' ? self : fallbackGlobalObject;
}
function getGlobalSingleton(name, creator, obj) {
    var global = obj || getGlobalObject();
    var __SENTRY__ = global.__SENTRY__ = global.__SENTRY__ || {};
    var singleton = __SENTRY__[name] || (__SENTRY__[name] = creator());
    return singleton;
}

},{"./node":"1fqDp","@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"1fqDp":[function(require,module,exports,__globalThis) {
/**
 * NOTE: In order to avoid circular dependencies, if you add a function to this module and it needs to print something,
 * you must either a) use `console.log` rather than the logger, or b) put your function elsewhere.
 */ var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
/**
 * Checks whether we're in the Node.js or Browser environment
 *
 * @returns Answer to given question
 */ parcelHelpers.export(exports, "isNodeEnv", ()=>isNodeEnv);
/**
 * Requires a module which is protected against bundler minification.
 *
 * @param request The module path to resolve
 */ // eslint-disable-next-line @typescript-eslint/explicit-module-boundary-types, @typescript-eslint/no-explicit-any
parcelHelpers.export(exports, "dynamicRequire", ()=>dynamicRequire);
/**
 * Helper for dynamically loading module that should work with linked dependencies.
 * The problem is that we _should_ be using `require(require.resolve(moduleName, { paths: [cwd()] }))`
 * However it's _not possible_ to do that with Webpack, as it has to know all the dependencies during
 * build time. `require.resolve` is also not available in any other way, so we cannot create,
 * a fake helper like we do with `dynamicRequire`.
 *
 * We always prefer to use local package, thus the value is not returned early from each `try/catch` block.
 * That is to mimic the behavior of `require.resolve` exactly.
 *
 * @param moduleName module name to require
 * @returns possibly required module
 */ parcelHelpers.export(exports, "loadModule", ()=>loadModule);
var _env = require("./env");
var process = require("362500578dce3b90");
function isNodeEnv() {
    // explicitly check for browser bundles as those can be optimized statically
    // by terser/rollup.
    return !(0, _env.isBrowserBundle)() && Object.prototype.toString.call(typeof process !== 'undefined' ? process : 0) === '[object process]';
}
function dynamicRequire(mod, request) {
    // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access
    return mod.require(request);
}
function loadModule(moduleName) {
    var mod;
    try {
        mod = dynamicRequire(module, moduleName);
    } catch (e) {
    // no-empty
    }
    try {
        var cwd = dynamicRequire(module, 'process').cwd;
        mod = dynamicRequire(module, cwd() + "/node_modules/" + moduleName);
    } catch (e) {
    // no-empty
    }
    return mod;
}

},{"362500578dce3b90":"gNLf3","./env":"3jKeA","@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"3jKeA":[function(require,module,exports,__globalThis) {
/*
 * This module exists for optimizations in the build process through rollup and terser.  We define some global
 * constants, which can be overridden during build. By guarding certain pieces of code with functions that return these
 * constants, we can control whether or not they appear in the final bundle. (Any code guarded by a false condition will
 * never run, and will hence be dropped during treeshaking.) The two primary uses for this are stripping out calls to
 * `logger` and preventing node-related code from appearing in browser bundles.
 *
 * Attention:
 * This file should not be used to define constants/flags that are intended to be used for tree-shaking conducted by
 * users. These fags should live in their respective packages, as we identified user tooling (specifically webpack)
 * having issues tree-shaking these constants across package boundaries.
 * An example for this is the __SENTRY_DEBUG__ constant. It is declared in each package individually because we want
 * users to be able to shake away expressions that it guards.
 */ /**
 * Figures out if we're building a browser bundle.
 *
 * @returns true if this is a browser bundle build.
 */ var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "isBrowserBundle", ()=>isBrowserBundle);
function isBrowserBundle() {
    return typeof __SENTRY_BROWSER_BUNDLE__ !== 'undefined' && !!__SENTRY_BROWSER_BUNDLE__;
}

},{"@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"146Cn":[function(require,module,exports,__globalThis) {
/* eslint-disable @typescript-eslint/no-explicit-any */ /* eslint-disable @typescript-eslint/explicit-module-boundary-types */ // eslint-disable-next-line @typescript-eslint/unbound-method
var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
/**
 * Checks whether given value's type is one of a few Error or Error-like
 * {@link isError}.
 *
 * @param wat A value to be checked.
 * @returns A boolean representing the result.
 */ parcelHelpers.export(exports, "isError", ()=>isError);
/**
 * Checks whether given value's type is ErrorEvent
 * {@link isErrorEvent}.
 *
 * @param wat A value to be checked.
 * @returns A boolean representing the result.
 */ parcelHelpers.export(exports, "isErrorEvent", ()=>isErrorEvent);
/**
 * Checks whether given value's type is DOMError
 * {@link isDOMError}.
 *
 * @param wat A value to be checked.
 * @returns A boolean representing the result.
 */ parcelHelpers.export(exports, "isDOMError", ()=>isDOMError);
/**
 * Checks whether given value's type is DOMException
 * {@link isDOMException}.
 *
 * @param wat A value to be checked.
 * @returns A boolean representing the result.
 */ parcelHelpers.export(exports, "isDOMException", ()=>isDOMException);
/**
 * Checks whether given value's type is a string
 * {@link isString}.
 *
 * @param wat A value to be checked.
 * @returns A boolean representing the result.
 */ parcelHelpers.export(exports, "isString", ()=>isString);
/**
 * Checks whether given value is a primitive (undefined, null, number, boolean, string, bigint, symbol)
 * {@link isPrimitive}.
 *
 * @param wat A value to be checked.
 * @returns A boolean representing the result.
 */ parcelHelpers.export(exports, "isPrimitive", ()=>isPrimitive);
/**
 * Checks whether given value's type is an object literal
 * {@link isPlainObject}.
 *
 * @param wat A value to be checked.
 * @returns A boolean representing the result.
 */ parcelHelpers.export(exports, "isPlainObject", ()=>isPlainObject);
/**
 * Checks whether given value's type is an Event instance
 * {@link isEvent}.
 *
 * @param wat A value to be checked.
 * @returns A boolean representing the result.
 */ parcelHelpers.export(exports, "isEvent", ()=>isEvent);
/**
 * Checks whether given value's type is an Element instance
 * {@link isElement}.
 *
 * @param wat A value to be checked.
 * @returns A boolean representing the result.
 */ parcelHelpers.export(exports, "isElement", ()=>isElement);
/**
 * Checks whether given value's type is an regexp
 * {@link isRegExp}.
 *
 * @param wat A value to be checked.
 * @returns A boolean representing the result.
 */ parcelHelpers.export(exports, "isRegExp", ()=>isRegExp);
/**
 * Checks whether given value has a then function.
 * @param wat A value to be checked.
 */ parcelHelpers.export(exports, "isThenable", ()=>isThenable);
/**
 * Checks whether given value's type is a SyntheticEvent
 * {@link isSyntheticEvent}.
 *
 * @param wat A value to be checked.
 * @returns A boolean representing the result.
 */ parcelHelpers.export(exports, "isSyntheticEvent", ()=>isSyntheticEvent);
/**
 * Checks whether given value is NaN
 * {@link isNaN}.
 *
 * @param wat A value to be checked.
 * @returns A boolean representing the result.
 */ parcelHelpers.export(exports, "isNaN", ()=>isNaN);
/**
 * Checks whether given value's type is an instance of provided constructor.
 * {@link isInstanceOf}.
 *
 * @param wat A value to be checked.
 * @param base A constructor to be used in a check.
 * @returns A boolean representing the result.
 */ parcelHelpers.export(exports, "isInstanceOf", ()=>isInstanceOf);
var objectToString = Object.prototype.toString;
function isError(wat) {
    switch(objectToString.call(wat)){
        case '[object Error]':
        case '[object Exception]':
        case '[object DOMException]':
            return true;
        default:
            return isInstanceOf(wat, Error);
    }
}
function isBuiltin(wat, ty) {
    return objectToString.call(wat) === "[object " + ty + "]";
}
function isErrorEvent(wat) {
    return isBuiltin(wat, 'ErrorEvent');
}
function isDOMError(wat) {
    return isBuiltin(wat, 'DOMError');
}
function isDOMException(wat) {
    return isBuiltin(wat, 'DOMException');
}
function isString(wat) {
    return isBuiltin(wat, 'String');
}
function isPrimitive(wat) {
    return wat === null || typeof wat !== 'object' && typeof wat !== 'function';
}
function isPlainObject(wat) {
    return isBuiltin(wat, 'Object');
}
function isEvent(wat) {
    return typeof Event !== 'undefined' && isInstanceOf(wat, Event);
}
function isElement(wat) {
    return typeof Element !== 'undefined' && isInstanceOf(wat, Element);
}
function isRegExp(wat) {
    return isBuiltin(wat, 'RegExp');
}
function isThenable(wat) {
    // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access
    return Boolean(wat && wat.then && typeof wat.then === 'function');
}
function isSyntheticEvent(wat) {
    return isPlainObject(wat) && 'nativeEvent' in wat && 'preventDefault' in wat && 'stopPropagation' in wat;
}
function isNaN(wat) {
    return typeof wat === 'number' && wat !== wat;
}
function isInstanceOf(wat, base) {
    try {
        return wat instanceof base;
    } catch (_e) {
        return false;
    }
}

},{"@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"gJl6M":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "SeverityLevels", ()=>SeverityLevels);
var SeverityLevels = [
    'fatal',
    'error',
    'warning',
    'log',
    'info',
    'debug',
    'critical'
];

},{"@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"aKz1P":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "CONSOLE_LEVELS", ()=>CONSOLE_LEVELS);
/**
 * Temporarily disable sentry console instrumentations.
 *
 * @param callback The function to run against the original `console` messages
 * @returns The results of the callback
 */ parcelHelpers.export(exports, "consoleSandbox", ()=>consoleSandbox);
parcelHelpers.export(exports, "logger", ()=>logger);
var _tslib = require("tslib");
var _flags = require("./flags");
var _global = require("./global");
// TODO: Implement different loggers for different environments
var global = (0, _global.getGlobalObject)();
/** Prefix for logging strings */ var PREFIX = 'Sentry Logger ';
var CONSOLE_LEVELS = [
    'debug',
    'info',
    'warn',
    'error',
    'log',
    'assert'
];
function consoleSandbox(callback) {
    var global = (0, _global.getGlobalObject)();
    if (!('console' in global)) return callback();
    var originalConsole = global.console;
    var wrappedLevels = {};
    // Restore all wrapped console methods
    CONSOLE_LEVELS.forEach(function(level) {
        // TODO(v7): Remove this check as it's only needed for Node 6
        var originalWrappedFunc = originalConsole[level] && originalConsole[level].__sentry_original__;
        if (level in global.console && originalWrappedFunc) {
            wrappedLevels[level] = originalConsole[level];
            originalConsole[level] = originalWrappedFunc;
        }
    });
    try {
        return callback();
    } finally{
        // Revert restoration to wrapped state
        Object.keys(wrappedLevels).forEach(function(level) {
            originalConsole[level] = wrappedLevels[level];
        });
    }
}
function makeLogger() {
    var enabled = false;
    var logger = {
        enable: function() {
            enabled = true;
        },
        disable: function() {
            enabled = false;
        }
    };
    if (0, _flags.IS_DEBUG_BUILD) CONSOLE_LEVELS.forEach(function(name) {
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        logger[name] = function() {
            var args = [];
            for(var _i = 0; _i < arguments.length; _i++)args[_i] = arguments[_i];
            if (enabled) consoleSandbox(function() {
                var _a;
                (_a = global.console)[name].apply(_a, (0, _tslib.__spread)([
                    PREFIX + "[" + name + "]:"
                ], args));
            });
        };
    });
    else CONSOLE_LEVELS.forEach(function(name) {
        logger[name] = function() {
            return undefined;
        };
    });
    return logger;
}
// Ensure we only have a single logger instance, even if multiple versions of @sentry/utils are being used
var logger;
if (0, _flags.IS_DEBUG_BUILD) logger = (0, _global.getGlobalSingleton)('logger', makeLogger);
else logger = makeLogger();

},{"tslib":"6MhhU","./flags":"6Cel0","./global":"fL2wD","@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"6Cel0":[function(require,module,exports,__globalThis) {
/*
 * This file defines flags and constants that can be modified during compile time in order to facilitate tree shaking
 * for users.
 *
 * Debug flags need to be declared in each package individually and must not be imported across package boundaries,
 * because some build tools have trouble tree-shaking imported guards.
 *
 * As a convention, we define debug flags in a `flags.ts` file in the root of a package's `src` folder.
 *
 * Debug flag files will contain "magic strings" like `__SENTRY_DEBUG__` that may get replaced with actual values during
 * our, or the user's build process. Take care when introducing new flags - they must not throw if they are not
 * replaced.
 */ /** Flag that is true for debug builds, false otherwise. */ var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "IS_DEBUG_BUILD", ()=>IS_DEBUG_BUILD);
var IS_DEBUG_BUILD = typeof __SENTRY_DEBUG__ === 'undefined' ? true : __SENTRY_DEBUG__;

},{"@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"k871o":[function(require,module,exports,__globalThis) {
/* eslint-disable @typescript-eslint/no-unsafe-member-access */ /* eslint-disable @typescript-eslint/no-explicit-any */ /**
 * Helper to decycle json objects
 */ var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "memoBuilder", ()=>memoBuilder);
function memoBuilder() {
    var hasWeakSet = typeof WeakSet === 'function';
    var inner = hasWeakSet ? new WeakSet() : [];
    function memoize(obj) {
        if (hasWeakSet) {
            if (inner.has(obj)) return true;
            inner.add(obj);
            return false;
        }
        // eslint-disable-next-line @typescript-eslint/prefer-for-of
        for(var i = 0; i < inner.length; i++){
            var value = inner[i];
            if (value === obj) return true;
        }
        inner.push(obj);
        return false;
    }
    function unmemoize(obj) {
        if (hasWeakSet) inner.delete(obj);
        else {
            for(var i = 0; i < inner.length; i++)if (inner[i] === obj) {
                inner.splice(i, 1);
                break;
            }
        }
    }
    return [
        memoize,
        unmemoize
    ];
}

},{"@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"glLsc":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
/**
 * UUID4 generator
 *
 * @returns string Generated UUID4.
 */ parcelHelpers.export(exports, "uuid4", ()=>uuid4);
/**
 * Parses string form of URL into an object
 * // borrowed from https://tools.ietf.org/html/rfc3986#appendix-B
 * // intentionally using regex and not <a/> href parsing trick because React Native and other
 * // environments where DOM might not be available
 * @returns parsed URL object
 */ parcelHelpers.export(exports, "parseUrl", ()=>parseUrl);
/**
 * Extracts either message or type+value from an event that can be used for user-facing logs
 * @returns event's description
 */ parcelHelpers.export(exports, "getEventDescription", ()=>getEventDescription);
/**
 * Adds exception values, type and value to an synthetic Exception.
 * @param event The event to modify.
 * @param value Value of the exception.
 * @param type Type of the exception.
 * @hidden
 */ parcelHelpers.export(exports, "addExceptionTypeValue", ()=>addExceptionTypeValue);
/**
 * Adds exception mechanism data to a given event. Uses defaults if the second parameter is not passed.
 *
 * @param event The event to modify.
 * @param newMechanism Mechanism data to add to the event.
 * @hidden
 */ parcelHelpers.export(exports, "addExceptionMechanism", ()=>addExceptionMechanism);
/**
 * Parses input into a SemVer interface
 * @param input string representation of a semver version
 */ parcelHelpers.export(exports, "parseSemver", ()=>parseSemver);
/**
 * This function adds context (pre/post/line) lines to the provided frame
 *
 * @param lines string[] containing all lines
 * @param frame StackFrame that will be mutated
 * @param linesOfContext number of context lines we want to add pre/post
 */ parcelHelpers.export(exports, "addContextToFrame", ()=>addContextToFrame);
/**
 * Strip the query string and fragment off of a given URL or path (if present)
 *
 * @param urlPath Full URL or path, including possible query string and/or fragment
 * @returns URL or path without query string or fragment
 */ parcelHelpers.export(exports, "stripUrlQueryAndFragment", ()=>stripUrlQueryAndFragment);
/**
 * Checks whether or not we've already captured the given exception (note: not an identical exception - the very object
 * in question), and marks it captured if not.
 *
 * This is useful because it's possible for an error to get captured by more than one mechanism. After we intercept and
 * record an error, we rethrow it (assuming we've intercepted it before it's reached the top-level global handlers), so
 * that we don't interfere with whatever effects the error might have had were the SDK not there. At that point, because
 * the error has been rethrown, it's possible for it to bubble up to some other code we've instrumented. If it's not
 * caught after that, it will bubble all the way up to the global handlers (which of course we also instrument). This
 * function helps us ensure that even if we encounter the same error more than once, we only record it the first time we
 * see it.
 *
 * Note: It will ignore primitives (always return `false` and not mark them as seen), as properties can't be set on
 * them. {@link: Object.objectify} can be used on exceptions to convert any that are primitives into their equivalent
 * object wrapper forms so that this check will always work. However, because we need to flag the exact object which
 * will get rethrown, and because that rethrowing happens outside of the event processing pipeline, the objectification
 * must be done before the exception captured.
 *
 * @param A thrown exception to check or flag as having been seen
 * @returns `true` if the exception has already been captured, `false` if not (with the side effect of marking it seen)
 */ parcelHelpers.export(exports, "checkOrSetAlreadyCaught", ()=>checkOrSetAlreadyCaught);
var _tslib = require("tslib");
var _global = require("./global");
var _object = require("./object");
var _string = require("./string");
function uuid4() {
    var global = (0, _global.getGlobalObject)();
    var crypto = global.crypto || global.msCrypto;
    if (!(crypto === void 0) && crypto.getRandomValues) {
        // Use window.crypto API if available
        var arr = new Uint16Array(8);
        crypto.getRandomValues(arr);
        // set 4 in byte 7
        // eslint-disable-next-line no-bitwise
        arr[3] = arr[3] & 0xfff | 0x4000;
        // set 2 most significant bits of byte 9 to '10'
        // eslint-disable-next-line no-bitwise
        arr[4] = arr[4] & 0x3fff | 0x8000;
        var pad = function(num) {
            var v = num.toString(16);
            while(v.length < 4)v = "0" + v;
            return v;
        };
        return pad(arr[0]) + pad(arr[1]) + pad(arr[2]) + pad(arr[3]) + pad(arr[4]) + pad(arr[5]) + pad(arr[6]) + pad(arr[7]);
    }
    // http://stackoverflow.com/questions/105034/how-to-create-a-guid-uuid-in-javascript/2117523#2117523
    return 'xxxxxxxxxxxx4xxxyxxxxxxxxxxxxxxx'.replace(/[xy]/g, function(c) {
        // eslint-disable-next-line no-bitwise
        var r = Math.random() * 16 | 0;
        // eslint-disable-next-line no-bitwise
        var v = c === 'x' ? r : r & 0x3 | 0x8;
        return v.toString(16);
    });
}
function parseUrl(url) {
    if (!url) return {};
    var match = url.match(/^(([^:/?#]+):)?(\/\/([^/?#]*))?([^?#]*)(\?([^#]*))?(#(.*))?$/);
    if (!match) return {};
    // coerce to undefined values to empty string so we don't get 'undefined'
    var query = match[6] || '';
    var fragment = match[8] || '';
    return {
        host: match[4],
        path: match[5],
        protocol: match[2],
        relative: match[5] + query + fragment
    };
}
function getFirstException(event) {
    return event.exception && event.exception.values ? event.exception.values[0] : undefined;
}
function getEventDescription(event) {
    var message = event.message, eventId = event.event_id;
    if (message) return message;
    var firstException = getFirstException(event);
    if (firstException) {
        if (firstException.type && firstException.value) return firstException.type + ": " + firstException.value;
        return firstException.type || firstException.value || eventId || '<unknown>';
    }
    return eventId || '<unknown>';
}
function addExceptionTypeValue(event, value, type) {
    var exception = event.exception = event.exception || {};
    var values = exception.values = exception.values || [];
    var firstException = values[0] = values[0] || {};
    if (!firstException.value) firstException.value = value || '';
    if (!firstException.type) firstException.type = type || 'Error';
}
function addExceptionMechanism(event, newMechanism) {
    var firstException = getFirstException(event);
    if (!firstException) return;
    var defaultMechanism = {
        type: 'generic',
        handled: true
    };
    var currentMechanism = firstException.mechanism;
    firstException.mechanism = (0, _tslib.__assign)((0, _tslib.__assign)((0, _tslib.__assign)({}, defaultMechanism), currentMechanism), newMechanism);
    if (newMechanism && 'data' in newMechanism) {
        var mergedData = (0, _tslib.__assign)((0, _tslib.__assign)({}, currentMechanism && currentMechanism.data), newMechanism.data);
        firstException.mechanism.data = mergedData;
    }
}
// https://semver.org/#is-there-a-suggested-regular-expression-regex-to-check-a-semver-string
var SEMVER_REGEXP = /^(0|[1-9]\d*)\.(0|[1-9]\d*)\.(0|[1-9]\d*)(?:-((?:0|[1-9]\d*|\d*[a-zA-Z-][0-9a-zA-Z-]*)(?:\.(?:0|[1-9]\d*|\d*[a-zA-Z-][0-9a-zA-Z-]*))*))?(?:\+([0-9a-zA-Z-]+(?:\.[0-9a-zA-Z-]+)*))?$/;
function parseSemver(input) {
    var match = input.match(SEMVER_REGEXP) || [];
    var major = parseInt(match[1], 10);
    var minor = parseInt(match[2], 10);
    var patch = parseInt(match[3], 10);
    return {
        buildmetadata: match[5],
        major: isNaN(major) ? undefined : major,
        minor: isNaN(minor) ? undefined : minor,
        patch: isNaN(patch) ? undefined : patch,
        prerelease: match[4]
    };
}
function addContextToFrame(lines, frame, linesOfContext) {
    if (linesOfContext === void 0) linesOfContext = 5;
    var lineno = frame.lineno || 0;
    var maxLines = lines.length;
    var sourceLine = Math.max(Math.min(maxLines, lineno - 1), 0);
    frame.pre_context = lines.slice(Math.max(0, sourceLine - linesOfContext), sourceLine).map(function(line) {
        return (0, _string.snipLine)(line, 0);
    });
    frame.context_line = (0, _string.snipLine)(lines[Math.min(maxLines - 1, sourceLine)], frame.colno || 0);
    frame.post_context = lines.slice(Math.min(sourceLine + 1, maxLines), sourceLine + 1 + linesOfContext).map(function(line) {
        return (0, _string.snipLine)(line, 0);
    });
}
function stripUrlQueryAndFragment(urlPath) {
    // eslint-disable-next-line no-useless-escape
    return urlPath.split(/[\?#]/, 1)[0];
}
function checkOrSetAlreadyCaught(exception) {
    // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access
    if (exception && exception.__sentry_captured__) return true;
    try {
        // set it this way rather than by assignment so that it's not ennumerable and therefore isn't recorded by the
        // `ExtraErrorData` integration
        (0, _object.addNonEnumerableProperty)(exception, '__sentry_captured__', true);
    } catch (err) {
    // `exception` is a primitive, so we can't mark it seen
    }
    return false;
}

},{"tslib":"6MhhU","./global":"fL2wD","./object":"f5595","./string":"cCvon","@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"f5595":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
/**
 * Replace a method in an object with a wrapped version of itself.
 *
 * @param source An object that contains a method to be wrapped.
 * @param name The name of the method to be wrapped.
 * @param replacementFactory A higher-order function that takes the original version of the given method and returns a
 * wrapped version. Note: The function returned by `replacementFactory` needs to be a non-arrow function, in order to
 * preserve the correct value of `this`, and the original method must be called using `origMethod.call(this, <other
 * args>)` or `origMethod.apply(this, [<other args>])` (rather than being called directly), again to preserve `this`.
 * @returns void
 */ parcelHelpers.export(exports, "fill", ()=>fill);
/**
 * Defines a non-enumerable property on the given object.
 *
 * @param obj The object on which to set the property
 * @param name The name of the property to be set
 * @param value The value to which to set the property
 */ parcelHelpers.export(exports, "addNonEnumerableProperty", ()=>addNonEnumerableProperty);
/**
 * Remembers the original function on the wrapped function and
 * patches up the prototype.
 *
 * @param wrapped the wrapper function
 * @param original the original function that gets wrapped
 */ parcelHelpers.export(exports, "markFunctionWrapped", ()=>markFunctionWrapped);
/**
 * This extracts the original function if available.  See
 * `markFunctionWrapped` for more information.
 *
 * @param func the function to unwrap
 * @returns the unwrapped version of the function if available.
 */ parcelHelpers.export(exports, "getOriginalFunction", ()=>getOriginalFunction);
/**
 * Encodes given object into url-friendly format
 *
 * @param object An object that contains serializable values
 * @returns string Encoded
 */ parcelHelpers.export(exports, "urlEncode", ()=>urlEncode);
/**
 * Transforms any object into an object literal with all its attributes
 * attached to it.
 *
 * @param value Initial source that we have to transform in order for it to be usable by the serializer
 */ parcelHelpers.export(exports, "convertToPlainObject", ()=>convertToPlainObject);
/**
 * Given any captured exception, extract its keys and create a sorted
 * and truncated list that will be used inside the event message.
 * eg. `Non-error exception captured with keys: foo, bar, baz`
 */ // eslint-disable-next-line @typescript-eslint/explicit-module-boundary-types
parcelHelpers.export(exports, "extractExceptionKeysForMessage", ()=>extractExceptionKeysForMessage);
/**
 * Given any object, return the new object with removed keys that value was `undefined`.
 * Works recursively on objects and arrays.
 */ parcelHelpers.export(exports, "dropUndefinedKeys", ()=>dropUndefinedKeys);
/**
 * Ensure that something is an object.
 *
 * Turns `undefined` and `null` into `String`s and all other primitives into instances of their respective wrapper
 * classes (String, Boolean, Number, etc.). Acts as the identity function on non-primitives.
 *
 * @param wat The subject of the objectification
 * @returns A version of `wat` which can safely be used with `Object` class methods
 */ parcelHelpers.export(exports, "objectify", ()=>objectify);
var _tslib = require("tslib");
var _browser = require("./browser");
var _is = require("./is");
var _string = require("./string");
function fill(source, name, replacementFactory) {
    if (!(name in source)) return;
    var original = source[name];
    var wrapped = replacementFactory(original);
    // Make sure it's a function first, as we need to attach an empty prototype for `defineProperties` to work
    // otherwise it'll throw "TypeError: Object.defineProperties called on non-object"
    if (typeof wrapped === 'function') try {
        markFunctionWrapped(wrapped, original);
    } catch (_Oo) {
    // This can throw if multiple fill happens on a global object like XMLHttpRequest
    // Fixes https://github.com/getsentry/sentry-javascript/issues/2043
    }
    source[name] = wrapped;
}
function addNonEnumerableProperty(obj, name, value) {
    Object.defineProperty(obj, name, {
        // enumerable: false, // the default, so we can save on bundle size by not explicitly setting it
        value: value,
        writable: true,
        configurable: true
    });
}
function markFunctionWrapped(wrapped, original) {
    var proto = original.prototype || {};
    wrapped.prototype = original.prototype = proto;
    addNonEnumerableProperty(wrapped, '__sentry_original__', original);
}
function getOriginalFunction(func) {
    return func.__sentry_original__;
}
function urlEncode(object) {
    return Object.keys(object).map(function(key) {
        return encodeURIComponent(key) + "=" + encodeURIComponent(object[key]);
    }).join('&');
}
function convertToPlainObject(value) {
    var newObj = value;
    if ((0, _is.isError)(value)) newObj = (0, _tslib.__assign)({
        message: value.message,
        name: value.name,
        stack: value.stack
    }, getOwnProperties(value));
    else if ((0, _is.isEvent)(value)) {
        var event_1 = value;
        newObj = (0, _tslib.__assign)({
            type: event_1.type,
            target: serializeEventTarget(event_1.target),
            currentTarget: serializeEventTarget(event_1.currentTarget)
        }, getOwnProperties(event_1));
        if (typeof CustomEvent !== 'undefined' && (0, _is.isInstanceOf)(value, CustomEvent)) newObj.detail = event_1.detail;
    }
    return newObj;
}
/** Creates a string representation of the target of an `Event` object */ function serializeEventTarget(target) {
    try {
        return (0, _is.isElement)(target) ? (0, _browser.htmlTreeAsString)(target) : Object.prototype.toString.call(target);
    } catch (_oO) {
        return '<unknown>';
    }
}
/** Filters out all but an object's own properties */ function getOwnProperties(obj) {
    var extractedProps = {};
    for(var property in obj)if (Object.prototype.hasOwnProperty.call(obj, property)) extractedProps[property] = obj[property];
    return extractedProps;
}
function extractExceptionKeysForMessage(exception, maxLength) {
    if (maxLength === void 0) maxLength = 40;
    var keys = Object.keys(convertToPlainObject(exception));
    keys.sort();
    if (!keys.length) return '[object has no keys]';
    if (keys[0].length >= maxLength) return (0, _string.truncate)(keys[0], maxLength);
    for(var includedKeys = keys.length; includedKeys > 0; includedKeys--){
        var serialized = keys.slice(0, includedKeys).join(', ');
        if (serialized.length > maxLength) continue;
        if (includedKeys === keys.length) return serialized;
        return (0, _string.truncate)(serialized, maxLength);
    }
    return '';
}
function dropUndefinedKeys(val) {
    var e_1, _a;
    if ((0, _is.isPlainObject)(val)) {
        var rv = {};
        try {
            for(var _b = (0, _tslib.__values)(Object.keys(val)), _c = _b.next(); !_c.done; _c = _b.next()){
                var key = _c.value;
                if (typeof val[key] !== 'undefined') rv[key] = dropUndefinedKeys(val[key]);
            }
        } catch (e_1_1) {
            e_1 = {
                error: e_1_1
            };
        } finally{
            try {
                if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
            } finally{
                if (e_1) throw e_1.error;
            }
        }
        return rv;
    }
    if (Array.isArray(val)) return val.map(dropUndefinedKeys);
    return val;
}
function objectify(wat) {
    var objectified;
    switch(true){
        case wat === undefined || wat === null:
            objectified = new String(wat);
            break;
        // Though symbols and bigints do have wrapper classes (`Symbol` and `BigInt`, respectively), for whatever reason
        // those classes don't have constructors which can be used with the `new` keyword. We therefore need to cast each as
        // an object in order to wrap it.
        case typeof wat === 'symbol' || typeof wat === 'bigint':
            objectified = Object(wat);
            break;
        // this will catch the remaining primitives: `String`, `Number`, and `Boolean`
        case (0, _is.isPrimitive)(wat):
            // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access
            objectified = new wat.constructor(wat);
            break;
        // by process of elimination, at this point we know that `wat` must already be an object
        default:
            objectified = wat;
            break;
    }
    return objectified;
}

},{"tslib":"6MhhU","./browser":"1YURa","./is":"146Cn","./string":"cCvon","@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"cCvon":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
/**
 * Truncates given string to the maximum characters count
 *
 * @param str An object that contains serializable values
 * @param max Maximum number of characters in truncated string (0 = unlimited)
 * @returns string Encoded
 */ parcelHelpers.export(exports, "truncate", ()=>truncate);
/**
 * This is basically just `trim_line` from
 * https://github.com/getsentry/sentry/blob/master/src/sentry/lang/javascript/processor.py#L67
 *
 * @param str An object that contains serializable values
 * @param max Maximum number of characters in truncated string
 * @returns string Encoded
 */ parcelHelpers.export(exports, "snipLine", ()=>snipLine);
/**
 * Join values in array
 * @param input array of values to be joined together
 * @param delimiter string to be placed in-between values
 * @returns Joined values
 */ // eslint-disable-next-line @typescript-eslint/no-explicit-any
parcelHelpers.export(exports, "safeJoin", ()=>safeJoin);
/**
 * Checks if the value matches a regex or includes the string
 * @param value The string value to be checked against
 * @param pattern Either a regex or a string that must be contained in value
 */ parcelHelpers.export(exports, "isMatchingPattern", ()=>isMatchingPattern);
/**
 * Given a string, escape characters which have meaning in the regex grammar, such that the result is safe to feed to
 * `new RegExp()`.
 *
 * Based on https://github.com/sindresorhus/escape-string-regexp. Vendored to a) reduce the size by skipping the runtime
 * type-checking, and b) ensure it gets down-compiled for old versions of Node (the published package only supports Node
 * 12+).
 *
 * @param regexString The string to escape
 * @returns An version of the string with all special regex characters escaped
 */ parcelHelpers.export(exports, "escapeStringForRegex", ()=>escapeStringForRegex);
var _is = require("./is");
function truncate(str, max) {
    if (max === void 0) max = 0;
    if (typeof str !== 'string' || max === 0) return str;
    return str.length <= max ? str : str.substr(0, max) + "...";
}
function snipLine(line, colno) {
    var newLine = line;
    var lineLength = newLine.length;
    if (lineLength <= 150) return newLine;
    if (colno > lineLength) // eslint-disable-next-line no-param-reassign
    colno = lineLength;
    var start = Math.max(colno - 60, 0);
    if (start < 5) start = 0;
    var end = Math.min(start + 140, lineLength);
    if (end > lineLength - 5) end = lineLength;
    if (end === lineLength) start = Math.max(end - 140, 0);
    newLine = newLine.slice(start, end);
    if (start > 0) newLine = "'{snip} " + newLine;
    if (end < lineLength) newLine += ' {snip}';
    return newLine;
}
function safeJoin(input, delimiter) {
    if (!Array.isArray(input)) return '';
    var output = [];
    // eslint-disable-next-line @typescript-eslint/prefer-for-of
    for(var i = 0; i < input.length; i++){
        var value = input[i];
        try {
            output.push(String(value));
        } catch (e) {
            output.push('[value cannot be serialized]');
        }
    }
    return output.join(delimiter);
}
function isMatchingPattern(value, pattern) {
    if (!(0, _is.isString)(value)) return false;
    if ((0, _is.isRegExp)(pattern)) return pattern.test(value);
    if (typeof pattern === 'string') return value.indexOf(pattern) !== -1;
    return false;
}
function escapeStringForRegex(regexString) {
    // escape the hyphen separately so we can also replace it with a unicode literal hyphen, to avoid the problems
    // discussed in https://github.com/sindresorhus/escape-string-regexp/issues/20.
    return regexString.replace(/[|\\{}()[\]^$+*?.]/g, '\\$&').replace(/-/g, '\\x2d');
}

},{"./is":"146Cn","@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"cM93L":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
/**
 * Recursively normalizes the given object.
 *
 * - Creates a copy to prevent original input mutation
 * - Skips non-enumerable properties
 * - When stringifying, calls `toJSON` if implemented
 * - Removes circular references
 * - Translates non-serializable values (`undefined`/`NaN`/functions) to serializable format
 * - Translates known global objects/classes to a string representations
 * - Takes care of `Error` object serialization
 * - Optionally limits depth of final output
 * - Optionally limits number of properties/elements included in any single object/array
 *
 * @param input The object to be normalized.
 * @param depth The max depth to which to normalize the object. (Anything deeper stringified whole.)
 * @param maxProperties The max number of elements or properties to be included in any single array or
 * object in the normallized output..
 * @returns A normalized version of the object, or `"**non-serializable**"` if any errors are thrown during normalization.
 */ parcelHelpers.export(exports, "normalize", ()=>normalize);
/** JSDoc */ parcelHelpers.export(exports, "normalizeToSize", ()=>normalizeToSize);
// TODO remove this in v7 (this means the method will no longer be exported, under any name)
parcelHelpers.export(exports, "walk", ()=>visit);
var _tslib = require("tslib");
var _is = require("./is");
var _memo = require("./memo");
var _object = require("./object");
var _stacktrace = require("./stacktrace");
var global = arguments[3];
function normalize(input, depth, maxProperties) {
    if (depth === void 0) depth = Infinity;
    if (maxProperties === void 0) maxProperties = Infinity;
    try {
        // since we're at the outermost level, there is no key
        return visit('', input, depth, maxProperties);
    } catch (err) {
        return {
            ERROR: "**non-serializable** (" + err + ")"
        };
    }
}
function normalizeToSize(object, // Default Node.js REPL depth
depth, // 100kB, as 200kB is max payload size, so half sounds reasonable
maxSize) {
    if (depth === void 0) depth = 3;
    if (maxSize === void 0) maxSize = 102400;
    var normalized = normalize(object, depth);
    if (jsonSize(normalized) > maxSize) return normalizeToSize(object, depth - 1, maxSize);
    return normalized;
}
/**
 * Visits a node to perform normalization on it
 *
 * @param key The key corresponding to the given node
 * @param value The node to be visited
 * @param depth Optional number indicating the maximum recursion depth
 * @param maxProperties Optional maximum number of properties/elements included in any single object/array
 * @param memo Optional Memo class handling decycling
 */ function visit(key, value, depth, maxProperties, memo) {
    if (depth === void 0) depth = Infinity;
    if (maxProperties === void 0) maxProperties = Infinity;
    if (memo === void 0) memo = (0, _memo.memoBuilder)();
    var _a = (0, _tslib.__read)(memo, 2), memoize = _a[0], unmemoize = _a[1];
    // If the value has a `toJSON` method, see if we can bail and let it do the work
    var valueWithToJSON = value;
    if (valueWithToJSON && typeof valueWithToJSON.toJSON === 'function') try {
        return valueWithToJSON.toJSON();
    } catch (err) {
    // pass (The built-in `toJSON` failed, but we can still try to do it ourselves)
    }
    // Get the simple cases out of the way first
    if (value === null || [
        'number',
        'boolean',
        'string'
    ].includes(typeof value) && !(0, _is.isNaN)(value)) return value;
    var stringified = stringifyValue(key, value);
    // Anything we could potentially dig into more (objects or arrays) will have come back as `"[object XXXX]"`.
    // Everything else will have already been serialized, so if we don't see that pattern, we're done.
    if (!stringified.startsWith('[object ')) return stringified;
    // We're also done if we've reached the max depth
    if (depth === 0) // At this point we know `serialized` is a string of the form `"[object XXXX]"`. Clean it up so it's just `"[XXXX]"`.
    return stringified.replace('object ', '');
    // If we've already visited this branch, bail out, as it's circular reference. If not, note that we're seeing it now.
    if (memoize(value)) return '[Circular ~]';
    // At this point we know we either have an object or an array, we haven't seen it before, and we're going to recurse
    // because we haven't yet reached the max depth. Create an accumulator to hold the results of visiting each
    // property/entry, and keep track of the number of items we add to it.
    var normalized = Array.isArray(value) ? [] : {};
    var numAdded = 0;
    // Before we begin, convert`Error` and`Event` instances into plain objects, since some of each of their relevant
    // properties are non-enumerable and otherwise would get missed.
    var visitable = (0, _is.isError)(value) || (0, _is.isEvent)(value) ? (0, _object.convertToPlainObject)(value) : value;
    for(var visitKey in visitable){
        // Avoid iterating over fields in the prototype if they've somehow been exposed to enumeration.
        if (!Object.prototype.hasOwnProperty.call(visitable, visitKey)) continue;
        if (numAdded >= maxProperties) {
            normalized[visitKey] = '[MaxProperties ~]';
            break;
        }
        // Recursively visit all the child nodes
        var visitValue = visitable[visitKey];
        normalized[visitKey] = visit(visitKey, visitValue, depth - 1, maxProperties, memo);
        numAdded += 1;
    }
    // Once we've visited all the branches, remove the parent from memo storage
    unmemoize(value);
    // Return accumulated values
    return normalized;
}
/**
 * Stringify the given value. Handles various known special values and types.
 *
 * Not meant to be used on simple primitives which already have a string representation, as it will, for example, turn
 * the number 1231 into "[Object Number]", nor on `null`, as it will throw.
 *
 * @param value The value to stringify
 * @returns A stringified representation of the given value
 */ function stringifyValue(key, // this type is a tiny bit of a cheat, since this function does handle NaN (which is technically a number), but for
// our internal use, it'll do
value) {
    try {
        if (key === 'domain' && value && typeof value === 'object' && value._events) return '[Domain]';
        if (key === 'domainEmitter') return '[DomainEmitter]';
        // It's safe to use `global`, `window`, and `document` here in this manner, as we are asserting using `typeof` first
        // which won't throw if they are not present.
        if (typeof global !== 'undefined' && value === global) return '[Global]';
        // eslint-disable-next-line no-restricted-globals
        if (typeof window !== 'undefined' && value === window) return '[Window]';
        // eslint-disable-next-line no-restricted-globals
        if (typeof document !== 'undefined' && value === document) return '[Document]';
        // React's SyntheticEvent thingy
        if ((0, _is.isSyntheticEvent)(value)) return '[SyntheticEvent]';
        if (typeof value === 'number' && value !== value) return '[NaN]';
        // this catches `undefined` (but not `null`, which is a primitive and can be serialized on its own)
        if (value === void 0) return '[undefined]';
        if (typeof value === 'function') return "[Function: " + (0, _stacktrace.getFunctionName)(value) + "]";
        if (typeof value === 'symbol') return "[" + String(value) + "]";
        // stringified BigInts are indistinguishable from regular numbers, so we need to label them to avoid confusion
        if (typeof value === 'bigint') return "[BigInt: " + String(value) + "]";
        // Now that we've knocked out all the special cases and the primitives, all we have left are objects. Simply casting
        // them to strings means that instances of classes which haven't defined their `toStringTag` will just come out as
        // `"[object Object]"`. If we instead look at the constructor's name (which is the same as the name of the class),
        // we can make sure that only plain objects come out that way.
        return "[object " + Object.getPrototypeOf(value).constructor.name + "]";
    } catch (err) {
        return "**non-serializable** (" + err + ")";
    }
}
/** Calculates bytes size of input string */ function utf8Length(value) {
    // eslint-disable-next-line no-bitwise
    return ~-encodeURI(value).split(/%..|./).length;
}
/** Calculates bytes size of input object */ function jsonSize(value) {
    return utf8Length(JSON.stringify(value));
}

},{"tslib":"6MhhU","./is":"146Cn","./memo":"k871o","./object":"f5595","./stacktrace":"i6IYu","@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"i6IYu":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
/**
 * Creates a stack parser with the supplied line parsers
 *
 * StackFrames are returned in the correct order for Sentry Exception
 * frames and with Sentry SDK internal frames removed from the top and bottom
 *
 */ parcelHelpers.export(exports, "createStackParser", ()=>createStackParser);
/**
 * @hidden
 */ parcelHelpers.export(exports, "stripSentryFramesAndReverse", ()=>stripSentryFramesAndReverse);
/**
 * Safely extract function name from itself
 */ parcelHelpers.export(exports, "getFunctionName", ()=>getFunctionName);
var _tslib = require("tslib");
var STACKTRACE_LIMIT = 50;
function createStackParser() {
    var parsers = [];
    for(var _i = 0; _i < arguments.length; _i++)parsers[_i] = arguments[_i];
    var sortedParsers = parsers.sort(function(a, b) {
        return a[0] - b[0];
    }).map(function(p) {
        return p[1];
    });
    return function(stack, skipFirst) {
        var e_1, _a, e_2, _b;
        if (skipFirst === void 0) skipFirst = 0;
        var frames = [];
        try {
            for(var _c = (0, _tslib.__values)(stack.split('\n').slice(skipFirst)), _d = _c.next(); !_d.done; _d = _c.next()){
                var line = _d.value;
                try {
                    for(var sortedParsers_1 = (e_2 = void 0, (0, _tslib.__values)(sortedParsers)), sortedParsers_1_1 = sortedParsers_1.next(); !sortedParsers_1_1.done; sortedParsers_1_1 = sortedParsers_1.next()){
                        var parser = sortedParsers_1_1.value;
                        var frame = parser(line);
                        if (frame) {
                            frames.push(frame);
                            break;
                        }
                    }
                } catch (e_2_1) {
                    e_2 = {
                        error: e_2_1
                    };
                } finally{
                    try {
                        if (sortedParsers_1_1 && !sortedParsers_1_1.done && (_b = sortedParsers_1.return)) _b.call(sortedParsers_1);
                    } finally{
                        if (e_2) throw e_2.error;
                    }
                }
            }
        } catch (e_1_1) {
            e_1 = {
                error: e_1_1
            };
        } finally{
            try {
                if (_d && !_d.done && (_a = _c.return)) _a.call(_c);
            } finally{
                if (e_1) throw e_1.error;
            }
        }
        return stripSentryFramesAndReverse(frames);
    };
}
function stripSentryFramesAndReverse(stack) {
    if (!stack.length) return [];
    var localStack = stack;
    var firstFrameFunction = localStack[0].function || '';
    var lastFrameFunction = localStack[localStack.length - 1].function || '';
    // If stack starts with one of our API calls, remove it (starts, meaning it's the top of the stack - aka last call)
    if (firstFrameFunction.indexOf('captureMessage') !== -1 || firstFrameFunction.indexOf('captureException') !== -1) localStack = localStack.slice(1);
    // If stack ends with one of our internal API calls, remove it (ends, meaning it's the bottom of the stack - aka top-most call)
    if (lastFrameFunction.indexOf('sentryWrapped') !== -1) localStack = localStack.slice(0, -1);
    // The frame where the crash happened, should be the last entry in the array
    return localStack.slice(0, STACKTRACE_LIMIT).map(function(frame) {
        return (0, _tslib.__assign)((0, _tslib.__assign)({}, frame), {
            filename: frame.filename || localStack[0].filename,
            function: frame.function || '?'
        });
    }).reverse();
}
var defaultFunctionName = '<anonymous>';
function getFunctionName(fn) {
    try {
        if (!fn || typeof fn !== 'function') return defaultFunctionName;
        return fn.name || defaultFunctionName;
    } catch (e) {
        // Just accessing custom props in some Selenium environments
        // can cause a "Permission denied" exception (see raven-js#495).
        return defaultFunctionName;
    }
}

},{"tslib":"6MhhU","@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"IiyPy":[function(require,module,exports,__globalThis) {
// Slightly modified (no IE8 support, ES6) and transcribed to TypeScript
// https://raw.githubusercontent.com/calvinmetcalf/rollup-plugin-node-builtins/master/src/es6/path.js
/** JSDoc */ var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
// path.resolve([from ...], to)
// posix version
/** JSDoc */ parcelHelpers.export(exports, "resolve", ()=>resolve);
// path.relative(from, to)
// posix version
/** JSDoc */ parcelHelpers.export(exports, "relative", ()=>relative);
// path.normalize(path)
// posix version
/** JSDoc */ parcelHelpers.export(exports, "normalizePath", ()=>normalizePath);
// posix version
/** JSDoc */ parcelHelpers.export(exports, "isAbsolute", ()=>isAbsolute);
// posix version
/** JSDoc */ parcelHelpers.export(exports, "join", ()=>join);
/** JSDoc */ parcelHelpers.export(exports, "dirname", ()=>dirname);
/** JSDoc */ parcelHelpers.export(exports, "basename", ()=>basename);
function normalizeArray(parts, allowAboveRoot) {
    // if the path tries to go above the root, `up` ends up > 0
    var up = 0;
    for(var i = parts.length - 1; i >= 0; i--){
        var last = parts[i];
        if (last === '.') parts.splice(i, 1);
        else if (last === '..') {
            parts.splice(i, 1);
            // eslint-disable-next-line no-plusplus
            up++;
        } else if (up) {
            parts.splice(i, 1);
            // eslint-disable-next-line no-plusplus
            up--;
        }
    }
    // if the path is allowed to go above the root, restore leading ..s
    if (allowAboveRoot) // eslint-disable-next-line no-plusplus
    for(; up--; up)parts.unshift('..');
    return parts;
}
// Split a filename into [root, dir, basename, ext], unix version
// 'root' is just a slash, or nothing.
var splitPathRe = /^(\/?|)([\s\S]*?)((?:\.{1,2}|[^/]+?|)(\.[^./]*|))(?:[/]*)$/;
/** JSDoc */ function splitPath(filename) {
    var parts = splitPathRe.exec(filename);
    return parts ? parts.slice(1) : [];
}
function resolve() {
    var args = [];
    for(var _i = 0; _i < arguments.length; _i++)args[_i] = arguments[_i];
    var resolvedPath = '';
    var resolvedAbsolute = false;
    for(var i = args.length - 1; i >= -1 && !resolvedAbsolute; i--){
        var path = i >= 0 ? args[i] : '/';
        // Skip empty entries
        if (!path) continue;
        resolvedPath = path + "/" + resolvedPath;
        resolvedAbsolute = path.charAt(0) === '/';
    }
    // At this point the path should be resolved to a full absolute path, but
    // handle relative paths to be safe (might happen when process.cwd() fails)
    // Normalize the path
    resolvedPath = normalizeArray(resolvedPath.split('/').filter(function(p) {
        return !!p;
    }), !resolvedAbsolute).join('/');
    return (resolvedAbsolute ? '/' : '') + resolvedPath || '.';
}
/** JSDoc */ function trim(arr) {
    var start = 0;
    for(; start < arr.length; start++){
        if (arr[start] !== '') break;
    }
    var end = arr.length - 1;
    for(; end >= 0; end--){
        if (arr[end] !== '') break;
    }
    if (start > end) return [];
    return arr.slice(start, end - start + 1);
}
function relative(from, to) {
    /* eslint-disable no-param-reassign */ from = resolve(from).substr(1);
    to = resolve(to).substr(1);
    /* eslint-enable no-param-reassign */ var fromParts = trim(from.split('/'));
    var toParts = trim(to.split('/'));
    var length = Math.min(fromParts.length, toParts.length);
    var samePartsLength = length;
    for(var i = 0; i < length; i++)if (fromParts[i] !== toParts[i]) {
        samePartsLength = i;
        break;
    }
    var outputParts = [];
    for(var i = samePartsLength; i < fromParts.length; i++)outputParts.push('..');
    outputParts = outputParts.concat(toParts.slice(samePartsLength));
    return outputParts.join('/');
}
function normalizePath(path) {
    var isPathAbsolute = isAbsolute(path);
    var trailingSlash = path.substr(-1) === '/';
    // Normalize the path
    var normalizedPath = normalizeArray(path.split('/').filter(function(p) {
        return !!p;
    }), !isPathAbsolute).join('/');
    if (!normalizedPath && !isPathAbsolute) normalizedPath = '.';
    if (normalizedPath && trailingSlash) normalizedPath += '/';
    return (isPathAbsolute ? '/' : '') + normalizedPath;
}
function isAbsolute(path) {
    return path.charAt(0) === '/';
}
function join() {
    var args = [];
    for(var _i = 0; _i < arguments.length; _i++)args[_i] = arguments[_i];
    return normalizePath(args.join('/'));
}
function dirname(path) {
    var result = splitPath(path);
    var root = result[0];
    var dir = result[1];
    if (!root && !dir) // No dirname whatsoever
    return '.';
    if (dir) // It has a dirname, strip trailing slash
    dir = dir.substr(0, dir.length - 1);
    return root + dir;
}
function basename(path, ext) {
    var f = splitPath(path)[2];
    if (ext && f.substr(ext.length * -1) === ext) f = f.substr(0, f.length - ext.length);
    return f;
}

},{"@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"kCtsv":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
/**
 * Converts a string-based level into a {@link Severity}.
 *
 * @param level string representation of Severity
 * @returns Severity
 */ parcelHelpers.export(exports, "severityFromString", ()=>severityFromString);
var _types = require("@sentry/types");
var _enums = require("./enums");
function isSupportedSeverity(level) {
    return (0, _enums.SeverityLevels).indexOf(level) !== -1;
}
function severityFromString(level) {
    if (level === 'warn') return (0, _types.Severity).Warning;
    if (isSupportedSeverity(level)) return level;
    return (0, _types.Severity).Log;
}

},{"@sentry/types":"92FRt","./enums":"gJl6M","@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"k962Q":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
/**
 * Tells whether current environment supports ErrorEvent objects
 * {@link supportsErrorEvent}.
 *
 * @returns Answer to the given question.
 */ parcelHelpers.export(exports, "supportsErrorEvent", ()=>supportsErrorEvent);
/**
 * Tells whether current environment supports DOMError objects
 * {@link supportsDOMError}.
 *
 * @returns Answer to the given question.
 */ parcelHelpers.export(exports, "supportsDOMError", ()=>supportsDOMError);
/**
 * Tells whether current environment supports DOMException objects
 * {@link supportsDOMException}.
 *
 * @returns Answer to the given question.
 */ parcelHelpers.export(exports, "supportsDOMException", ()=>supportsDOMException);
/**
 * Tells whether current environment supports Fetch API
 * {@link supportsFetch}.
 *
 * @returns Answer to the given question.
 */ parcelHelpers.export(exports, "supportsFetch", ()=>supportsFetch);
/**
 * isNativeFetch checks if the given function is a native implementation of fetch()
 */ // eslint-disable-next-line @typescript-eslint/ban-types
parcelHelpers.export(exports, "isNativeFetch", ()=>isNativeFetch);
/**
 * Tells whether current environment supports Fetch API natively
 * {@link supportsNativeFetch}.
 *
 * @returns true if `window.fetch` is natively implemented, false otherwise
 */ parcelHelpers.export(exports, "supportsNativeFetch", ()=>supportsNativeFetch);
/**
 * Tells whether current environment supports ReportingObserver API
 * {@link supportsReportingObserver}.
 *
 * @returns Answer to the given question.
 */ parcelHelpers.export(exports, "supportsReportingObserver", ()=>supportsReportingObserver);
/**
 * Tells whether current environment supports Referrer Policy API
 * {@link supportsReferrerPolicy}.
 *
 * @returns Answer to the given question.
 */ parcelHelpers.export(exports, "supportsReferrerPolicy", ()=>supportsReferrerPolicy);
/**
 * Tells whether current environment supports History API
 * {@link supportsHistory}.
 *
 * @returns Answer to the given question.
 */ parcelHelpers.export(exports, "supportsHistory", ()=>supportsHistory);
var _flags = require("./flags");
var _global = require("./global");
var _logger = require("./logger");
function supportsErrorEvent() {
    try {
        new ErrorEvent('');
        return true;
    } catch (e) {
        return false;
    }
}
function supportsDOMError() {
    try {
        // Chrome: VM89:1 Uncaught TypeError: Failed to construct 'DOMError':
        // 1 argument required, but only 0 present.
        // @ts-ignore It really needs 1 argument, not 0.
        new DOMError('');
        return true;
    } catch (e) {
        return false;
    }
}
function supportsDOMException() {
    try {
        new DOMException('');
        return true;
    } catch (e) {
        return false;
    }
}
function supportsFetch() {
    if (!('fetch' in (0, _global.getGlobalObject)())) return false;
    try {
        new Headers();
        new Request('');
        new Response();
        return true;
    } catch (e) {
        return false;
    }
}
function isNativeFetch(func) {
    return func && /^function fetch\(\)\s+\{\s+\[native code\]\s+\}$/.test(func.toString());
}
function supportsNativeFetch() {
    if (!supportsFetch()) return false;
    var global = (0, _global.getGlobalObject)();
    // Fast path to avoid DOM I/O
    // eslint-disable-next-line @typescript-eslint/unbound-method
    if (isNativeFetch(global.fetch)) return true;
    // window.fetch is implemented, but is polyfilled or already wrapped (e.g: by a chrome extension)
    // so create a "pure" iframe to see if that has native fetch
    var result = false;
    var doc = global.document;
    // eslint-disable-next-line deprecation/deprecation
    if (doc && typeof doc.createElement === 'function') try {
        var sandbox = doc.createElement('iframe');
        sandbox.hidden = true;
        doc.head.appendChild(sandbox);
        if (sandbox.contentWindow && sandbox.contentWindow.fetch) // eslint-disable-next-line @typescript-eslint/unbound-method
        result = isNativeFetch(sandbox.contentWindow.fetch);
        doc.head.removeChild(sandbox);
    } catch (err) {
        (0, _flags.IS_DEBUG_BUILD) && (0, _logger.logger).warn('Could not create sandbox iframe for pure fetch check, bailing to window.fetch: ', err);
    }
    return result;
}
function supportsReportingObserver() {
    return 'ReportingObserver' in (0, _global.getGlobalObject)();
}
function supportsReferrerPolicy() {
    // Despite all stars in the sky saying that Edge supports old draft syntax, aka 'never', 'always', 'origin' and 'default'
    // (see https://caniuse.com/#feat=referrer-policy),
    // it doesn't. And it throws an exception instead of ignoring this parameter...
    // REF: https://github.com/getsentry/raven-js/issues/1233
    if (!supportsFetch()) return false;
    try {
        new Request('_', {
            referrerPolicy: 'origin'
        });
        return true;
    } catch (e) {
        return false;
    }
}
function supportsHistory() {
    // NOTE: in Chrome App environment, touching history.pushState, *even inside
    //       a try/catch block*, will cause Chrome to output an error to console.error
    // borrowed from: https://github.com/angular/angular.js/pull/13945/files
    var global = (0, _global.getGlobalObject)();
    /* eslint-disable @typescript-eslint/no-unsafe-member-access */ // eslint-disable-next-line @typescript-eslint/no-explicit-any
    var chrome = global.chrome;
    var isChromePackagedApp = chrome && chrome.app && chrome.app.runtime;
    /* eslint-enable @typescript-eslint/no-unsafe-member-access */ var hasHistoryApi = 'history' in global && !!global.history.pushState && !!global.history.replaceState;
    return !isChromePackagedApp && hasHistoryApi;
}

},{"./flags":"6Cel0","./global":"fL2wD","./logger":"aKz1P","@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"SOapb":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "dateTimestampInSeconds", ()=>dateTimestampInSeconds);
parcelHelpers.export(exports, "timestampInSeconds", ()=>timestampInSeconds);
parcelHelpers.export(exports, "timestampWithMs", ()=>timestampWithMs);
parcelHelpers.export(exports, "usingPerformanceAPI", ()=>usingPerformanceAPI);
parcelHelpers.export(exports, "_browserPerformanceTimeOriginMode", ()=>_browserPerformanceTimeOriginMode);
parcelHelpers.export(exports, "browserPerformanceTimeOrigin", ()=>browserPerformanceTimeOrigin);
var _global = require("./global");
var _node = require("./node");
/**
 * A TimestampSource implementation for environments that do not support the Performance Web API natively.
 *
 * Note that this TimestampSource does not use a monotonic clock. A call to `nowSeconds` may return a timestamp earlier
 * than a previously returned value. We do not try to emulate a monotonic behavior in order to facilitate debugging. It
 * is more obvious to explain "why does my span have negative duration" than "why my spans have zero duration".
 */ var dateTimestampSource = {
    nowSeconds: function() {
        return Date.now() / 1000;
    }
};
/**
 * Returns a wrapper around the native Performance API browser implementation, or undefined for browsers that do not
 * support the API.
 *
 * Wrapping the native API works around differences in behavior from different browsers.
 */ function getBrowserPerformance() {
    var performance = (0, _global.getGlobalObject)().performance;
    if (!performance || !performance.now) return undefined;
    // Replace performance.timeOrigin with our own timeOrigin based on Date.now().
    //
    // This is a partial workaround for browsers reporting performance.timeOrigin such that performance.timeOrigin +
    // performance.now() gives a date arbitrarily in the past.
    //
    // Additionally, computing timeOrigin in this way fills the gap for browsers where performance.timeOrigin is
    // undefined.
    //
    // The assumption that performance.timeOrigin + performance.now() ~= Date.now() is flawed, but we depend on it to
    // interact with data coming out of performance entries.
    //
    // Note that despite recommendations against it in the spec, browsers implement the Performance API with a clock that
    // might stop when the computer is asleep (and perhaps under other circumstances). Such behavior causes
    // performance.timeOrigin + performance.now() to have an arbitrary skew over Date.now(). In laptop computers, we have
    // observed skews that can be as long as days, weeks or months.
    //
    // See https://github.com/getsentry/sentry-javascript/issues/2590.
    //
    // BUG: despite our best intentions, this workaround has its limitations. It mostly addresses timings of pageload
    // transactions, but ignores the skew built up over time that can aversely affect timestamps of navigation
    // transactions of long-lived web pages.
    var timeOrigin = Date.now() - performance.now();
    return {
        now: function() {
            return performance.now();
        },
        timeOrigin: timeOrigin
    };
}
/**
 * Returns the native Performance API implementation from Node.js. Returns undefined in old Node.js versions that don't
 * implement the API.
 */ function getNodePerformance() {
    try {
        var perfHooks = (0, _node.dynamicRequire)(module, 'perf_hooks');
        return perfHooks.performance;
    } catch (_) {
        return undefined;
    }
}
/**
 * The Performance API implementation for the current platform, if available.
 */ var platformPerformance = (0, _node.isNodeEnv)() ? getNodePerformance() : getBrowserPerformance();
var timestampSource = platformPerformance === undefined ? dateTimestampSource : {
    nowSeconds: function() {
        return (platformPerformance.timeOrigin + platformPerformance.now()) / 1000;
    }
};
var dateTimestampInSeconds = dateTimestampSource.nowSeconds.bind(dateTimestampSource);
var timestampInSeconds = timestampSource.nowSeconds.bind(timestampSource);
var timestampWithMs = timestampInSeconds;
var usingPerformanceAPI = platformPerformance !== undefined;
var _browserPerformanceTimeOriginMode;
var browserPerformanceTimeOrigin = function() {
    // Unfortunately browsers may report an inaccurate time origin data, through either performance.timeOrigin or
    // performance.timing.navigationStart, which results in poor results in performance data. We only treat time origin
    // data as reliable if they are within a reasonable threshold of the current time.
    var performance = (0, _global.getGlobalObject)().performance;
    if (!performance || !performance.now) {
        _browserPerformanceTimeOriginMode = 'none';
        return undefined;
    }
    var threshold = 3600000;
    var performanceNow = performance.now();
    var dateNow = Date.now();
    // if timeOrigin isn't available set delta to threshold so it isn't used
    var timeOriginDelta = performance.timeOrigin ? Math.abs(performance.timeOrigin + performanceNow - dateNow) : threshold;
    var timeOriginIsReliable = timeOriginDelta < threshold;
    // While performance.timing.navigationStart is deprecated in favor of performance.timeOrigin, performance.timeOrigin
    // is not as widely supported. Namely, performance.timeOrigin is undefined in Safari as of writing.
    // Also as of writing, performance.timing is not available in Web Workers in mainstream browsers, so it is not always
    // a valid fallback. In the absence of an initial time provided by the browser, fallback to the current time from the
    // Date API.
    // eslint-disable-next-line deprecation/deprecation
    var navigationStart = performance.timing && performance.timing.navigationStart;
    var hasNavigationStart = typeof navigationStart === 'number';
    // if navigationStart isn't available set delta to threshold so it isn't used
    var navigationStartDelta = hasNavigationStart ? Math.abs(navigationStart + performanceNow - dateNow) : threshold;
    var navigationStartIsReliable = navigationStartDelta < threshold;
    if (timeOriginIsReliable || navigationStartIsReliable) {
        // Use the more reliable time origin
        if (timeOriginDelta <= navigationStartDelta) {
            _browserPerformanceTimeOriginMode = 'timeOrigin';
            return performance.timeOrigin;
        } else {
            _browserPerformanceTimeOriginMode = 'navigationStart';
            return navigationStart;
        }
    }
    // Either both timeOrigin and navigationStart are skewed or neither is available, fallback to Date.
    _browserPerformanceTimeOriginMode = 'dateNow';
    return dateNow;
}();

},{"./global":"fL2wD","./node":"1fqDp","@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"9Knv0":[function(require,module,exports,__globalThis) {
/*
 * This file defines flags and constants that can be modified during compile time in order to facilitate tree shaking
 * for users.
 *
 * Debug flags need to be declared in each package individually and must not be imported across package boundaries,
 * because some build tools have trouble tree-shaking imported guards.
 *
 * As a convention, we define debug flags in a `flags.ts` file in the root of a package's `src` folder.
 *
 * Debug flag files will contain "magic strings" like `__SENTRY_DEBUG__` that may get replaced with actual values during
 * our, or the user's build process. Take care when introducing new flags - they must not throw if they are not
 * replaced.
 */ /** Flag that is true for debug builds, false otherwise. */ var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "IS_DEBUG_BUILD", ()=>IS_DEBUG_BUILD);
var IS_DEBUG_BUILD = typeof __SENTRY_DEBUG__ === 'undefined' ? true : __SENTRY_DEBUG__;

},{"@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"9p2x8":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "CaptureConsole", ()=>CaptureConsole);
var _utils = require("@sentry/utils");
var global = (0, _utils.getGlobalObject)();
/** Send Console API calls as Sentry Events */ var CaptureConsole = /** @class */ function() {
    /**
     * @inheritDoc
     */ function CaptureConsole(options) {
        if (options === void 0) options = {};
        /**
         * @inheritDoc
         */ this.name = CaptureConsole.id;
        /**
         * @inheritDoc
         */ this._levels = (0, _utils.CONSOLE_LEVELS);
        if (options.levels) this._levels = options.levels;
    }
    /**
     * @inheritDoc
     */ CaptureConsole.prototype.setupOnce = function(_, getCurrentHub) {
        if (!('console' in global)) return;
        this._levels.forEach(function(level) {
            if (!(level in global.console)) return;
            // eslint-disable-next-line @typescript-eslint/no-explicit-any
            (0, _utils.fill)(global.console, level, function(originalConsoleMethod) {
                return function() {
                    var args = [];
                    for(var _i = 0; _i < arguments.length; _i++)args[_i] = arguments[_i];
                    var hub = getCurrentHub();
                    if (hub.getIntegration(CaptureConsole)) hub.withScope(function(scope) {
                        scope.setLevel((0, _utils.severityFromString)(level));
                        scope.setExtra('arguments', args);
                        scope.addEventProcessor(function(event) {
                            event.logger = 'console';
                            return event;
                        });
                        var message = (0, _utils.safeJoin)(args, ' ');
                        if (level === 'assert') {
                            if (args[0] === false) {
                                message = "Assertion failed: " + ((0, _utils.safeJoin)(args.slice(1), ' ') || 'console.assert');
                                scope.setExtra('arguments', args.slice(1));
                                hub.captureMessage(message);
                            }
                        } else if (level === 'error' && args[0] instanceof Error) hub.captureException(args[0]);
                        else hub.captureMessage(message);
                    });
                    // this fails for some browsers. :(
                    if (originalConsoleMethod) originalConsoleMethod.apply(global.console, args);
                };
            });
        });
    };
    /**
     * @inheritDoc
     */ CaptureConsole.id = 'CaptureConsole';
    return CaptureConsole;
}();

},{"@sentry/utils":"agmfj","@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"1NZDu":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "Debug", ()=>Debug);
var _tslib = require("tslib");
var _utils = require("@sentry/utils");
/**
 * Integration to debug sent Sentry events.
 * This integration should not be used in production
 */ var Debug = /** @class */ function() {
    function Debug(options) {
        /**
         * @inheritDoc
         */ this.name = Debug.id;
        this._options = (0, _tslib.__assign)({
            debugger: false,
            stringify: false
        }, options);
    }
    /**
     * @inheritDoc
     */ Debug.prototype.setupOnce = function(addGlobalEventProcessor, getCurrentHub) {
        addGlobalEventProcessor(function(event, hint) {
            var self = getCurrentHub().getIntegration(Debug);
            if (self) {
                if (self._options.debugger) // eslint-disable-next-line no-debugger
                debugger;
                /* eslint-disable no-console */ (0, _utils.consoleSandbox)(function() {
                    if (self._options.stringify) {
                        console.log(JSON.stringify(event, null, 2));
                        if (hint) console.log(JSON.stringify(hint, null, 2));
                    } else {
                        console.log(event);
                        if (hint) console.log(hint);
                    }
                });
            /* eslint-enable no-console */ }
            return event;
        });
    };
    /**
     * @inheritDoc
     */ Debug.id = 'Debug';
    return Debug;
}();

},{"tslib":"6MhhU","@sentry/utils":"agmfj","@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"3g8wa":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "Dedupe", ()=>Dedupe);
/** JSDoc */ parcelHelpers.export(exports, "_shouldDropEvent", ()=>_shouldDropEvent);
var _utils = require("@sentry/utils");
var _flags = require("./flags");
/** Deduplication filter */ var Dedupe = /** @class */ function() {
    function Dedupe() {
        /**
         * @inheritDoc
         */ this.name = Dedupe.id;
    }
    /**
     * @inheritDoc
     */ Dedupe.prototype.setupOnce = function(addGlobalEventProcessor, getCurrentHub) {
        addGlobalEventProcessor(function(currentEvent) {
            var self = getCurrentHub().getIntegration(Dedupe);
            if (self) {
                // Juuust in case something goes wrong
                try {
                    if (_shouldDropEvent(currentEvent, self._previousEvent)) {
                        (0, _flags.IS_DEBUG_BUILD) && (0, _utils.logger).warn('Event dropped due to being a duplicate of previously captured event.');
                        return null;
                    }
                } catch (_oO) {
                    return self._previousEvent = currentEvent;
                }
                return self._previousEvent = currentEvent;
            }
            return currentEvent;
        });
    };
    /**
     * @inheritDoc
     */ Dedupe.id = 'Dedupe';
    return Dedupe;
}();
function _shouldDropEvent(currentEvent, previousEvent) {
    if (!previousEvent) return false;
    if (_isSameMessageEvent(currentEvent, previousEvent)) return true;
    if (_isSameExceptionEvent(currentEvent, previousEvent)) return true;
    return false;
}
/** JSDoc */ function _isSameMessageEvent(currentEvent, previousEvent) {
    var currentMessage = currentEvent.message;
    var previousMessage = previousEvent.message;
    // If neither event has a message property, they were both exceptions, so bail out
    if (!currentMessage && !previousMessage) return false;
    // If only one event has a stacktrace, but not the other one, they are not the same
    if (currentMessage && !previousMessage || !currentMessage && previousMessage) return false;
    if (currentMessage !== previousMessage) return false;
    if (!_isSameFingerprint(currentEvent, previousEvent)) return false;
    if (!_isSameStacktrace(currentEvent, previousEvent)) return false;
    return true;
}
/** JSDoc */ function _isSameExceptionEvent(currentEvent, previousEvent) {
    var previousException = _getExceptionFromEvent(previousEvent);
    var currentException = _getExceptionFromEvent(currentEvent);
    if (!previousException || !currentException) return false;
    if (previousException.type !== currentException.type || previousException.value !== currentException.value) return false;
    if (!_isSameFingerprint(currentEvent, previousEvent)) return false;
    if (!_isSameStacktrace(currentEvent, previousEvent)) return false;
    return true;
}
/** JSDoc */ function _isSameStacktrace(currentEvent, previousEvent) {
    var currentFrames = _getFramesFromEvent(currentEvent);
    var previousFrames = _getFramesFromEvent(previousEvent);
    // If neither event has a stacktrace, they are assumed to be the same
    if (!currentFrames && !previousFrames) return true;
    // If only one event has a stacktrace, but not the other one, they are not the same
    if (currentFrames && !previousFrames || !currentFrames && previousFrames) return false;
    currentFrames;
    previousFrames;
    // If number of frames differ, they are not the same
    if (previousFrames.length !== currentFrames.length) return false;
    // Otherwise, compare the two
    for(var i = 0; i < previousFrames.length; i++){
        var frameA = previousFrames[i];
        var frameB = currentFrames[i];
        if (frameA.filename !== frameB.filename || frameA.lineno !== frameB.lineno || frameA.colno !== frameB.colno || frameA.function !== frameB.function) return false;
    }
    return true;
}
/** JSDoc */ function _isSameFingerprint(currentEvent, previousEvent) {
    var currentFingerprint = currentEvent.fingerprint;
    var previousFingerprint = previousEvent.fingerprint;
    // If neither event has a fingerprint, they are assumed to be the same
    if (!currentFingerprint && !previousFingerprint) return true;
    // If only one event has a fingerprint, but not the other one, they are not the same
    if (currentFingerprint && !previousFingerprint || !currentFingerprint && previousFingerprint) return false;
    currentFingerprint;
    previousFingerprint;
    // Otherwise, compare the two
    try {
        return !!(currentFingerprint.join('') === previousFingerprint.join(''));
    } catch (_oO) {
        return false;
    }
}
/** JSDoc */ function _getExceptionFromEvent(event) {
    return event.exception && event.exception.values && event.exception.values[0];
}
/** JSDoc */ function _getFramesFromEvent(event) {
    var exception = event.exception;
    if (exception) try {
        // @ts-ignore Object could be undefined
        return exception.values[0].stacktrace.frames;
    } catch (_oO) {
        return undefined;
    }
    else if (event.stacktrace) return event.stacktrace.frames;
    return undefined;
}

},{"@sentry/utils":"agmfj","./flags":"9Knv0","@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"dkCw5":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "Ember", ()=>Ember);
var _utils = require("@sentry/utils");
var _flags = require("./flags");
/** JSDoc */ var Ember = /** @class */ function() {
    /**
     * @inheritDoc
     */ // eslint-disable-next-line @typescript-eslint/no-explicit-any
    function Ember(options) {
        if (options === void 0) options = {};
        /**
         * @inheritDoc
         */ this.name = Ember.id;
        // eslint-disable-next-line @typescript-eslint/no-explicit-any, @typescript-eslint/no-unsafe-member-access
        this._Ember = options.Ember || (0, _utils.getGlobalObject)().Ember;
    }
    /**
     * @inheritDoc
     */ Ember.prototype.setupOnce = function(_, getCurrentHub) {
        var _this = this;
        if (!this._Ember) {
            (0, _flags.IS_DEBUG_BUILD) && (0, _utils.logger).error('EmberIntegration is missing an Ember instance');
            return;
        }
        /* eslint-disable @typescript-eslint/no-unsafe-member-access */ var oldOnError = this._Ember.onerror;
        this._Ember.onerror = function(error) {
            if (getCurrentHub().getIntegration(Ember)) getCurrentHub().captureException(error, {
                originalException: error
            });
            if (typeof oldOnError === 'function') oldOnError.call(_this._Ember, error);
            else if (_this._Ember.testing) throw error;
        };
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        this._Ember.RSVP.on('error', function(reason) {
            if (getCurrentHub().getIntegration(Ember)) getCurrentHub().withScope(function(scope) {
                if ((0, _utils.isInstanceOf)(reason, Error)) {
                    scope.setExtra('context', 'Unhandled Promise error detected');
                    getCurrentHub().captureException(reason, {
                        originalException: reason
                    });
                } else {
                    scope.setExtra('reason', reason);
                    getCurrentHub().captureMessage('Unhandled Promise error detected');
                }
            });
        });
    };
    /**
     * @inheritDoc
     */ Ember.id = 'Ember';
    return Ember;
}();

},{"@sentry/utils":"agmfj","./flags":"9Knv0","@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"7IeG2":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "ExtraErrorData", ()=>ExtraErrorData);
var _tslib = require("tslib");
var _utils = require("@sentry/utils");
var _flags = require("./flags");
/** Patch toString calls to return proper name for wrapped functions */ var ExtraErrorData = /** @class */ function() {
    /**
     * @inheritDoc
     */ function ExtraErrorData(options) {
        /**
         * @inheritDoc
         */ this.name = ExtraErrorData.id;
        this._options = (0, _tslib.__assign)({
            depth: 3
        }, options);
    }
    /**
     * @inheritDoc
     */ ExtraErrorData.prototype.setupOnce = function(addGlobalEventProcessor, getCurrentHub) {
        addGlobalEventProcessor(function(event, hint) {
            var self = getCurrentHub().getIntegration(ExtraErrorData);
            if (!self) return event;
            return self.enhanceEventWithErrorData(event, hint);
        });
    };
    /**
     * Attaches extracted information from the Error object to extra field in the Event
     */ ExtraErrorData.prototype.enhanceEventWithErrorData = function(event, hint) {
        var _a;
        if (!hint || !hint.originalException || !(0, _utils.isError)(hint.originalException)) return event;
        var name = hint.originalException.name || hint.originalException.constructor.name;
        var errorData = this._extractErrorData(hint.originalException);
        if (errorData) {
            var contexts = (0, _tslib.__assign)({}, event.contexts);
            var normalizedErrorData = (0, _utils.normalize)(errorData, this._options.depth);
            if ((0, _utils.isPlainObject)(normalizedErrorData)) contexts = (0, _tslib.__assign)((0, _tslib.__assign)({}, event.contexts), (_a = {}, _a[name] = (0, _tslib.__assign)({}, normalizedErrorData), _a));
            return (0, _tslib.__assign)((0, _tslib.__assign)({}, event), {
                contexts: contexts
            });
        }
        return event;
    };
    /**
     * Extract extra information from the Error object
     */ ExtraErrorData.prototype._extractErrorData = function(error) {
        var e_1, _a, e_2, _b;
        // We are trying to enhance already existing event, so no harm done if it won't succeed
        try {
            var nativeKeys = [
                'name',
                'message',
                'stack',
                'line',
                'column',
                'fileName',
                'lineNumber',
                'columnNumber',
                'toJSON'
            ];
            var extraErrorInfo = {};
            try {
                // We want only enumerable properties, thus `getOwnPropertyNames` is redundant here, as we filter keys anyway.
                for(var _c = (0, _tslib.__values)(Object.keys(error)), _d = _c.next(); !_d.done; _d = _c.next()){
                    var key = _d.value;
                    if (nativeKeys.indexOf(key) !== -1) continue;
                    var value = error[key];
                    extraErrorInfo[key] = (0, _utils.isError)(value) ? value.toString() : value;
                }
            } catch (e_1_1) {
                e_1 = {
                    error: e_1_1
                };
            } finally{
                try {
                    if (_d && !_d.done && (_a = _c.return)) _a.call(_c);
                } finally{
                    if (e_1) throw e_1.error;
                }
            }
            // Check if someone attached `toJSON` method to grab even more properties (eg. axios is doing that)
            if (typeof error.toJSON === 'function') {
                var serializedError = error.toJSON();
                try {
                    for(var _e = (0, _tslib.__values)(Object.keys(serializedError)), _f = _e.next(); !_f.done; _f = _e.next()){
                        var key = _f.value;
                        var value = serializedError[key];
                        extraErrorInfo[key] = (0, _utils.isError)(value) ? value.toString() : value;
                    }
                } catch (e_2_1) {
                    e_2 = {
                        error: e_2_1
                    };
                } finally{
                    try {
                        if (_f && !_f.done && (_b = _e.return)) _b.call(_e);
                    } finally{
                        if (e_2) throw e_2.error;
                    }
                }
            }
            return extraErrorInfo;
        } catch (oO) {
            (0, _flags.IS_DEBUG_BUILD) && (0, _utils.logger).error('Unable to extract extra data from the Error object:', oO);
        }
        return null;
    };
    /**
     * @inheritDoc
     */ ExtraErrorData.id = 'ExtraErrorData';
    return ExtraErrorData;
}();

},{"tslib":"6MhhU","@sentry/utils":"agmfj","./flags":"9Knv0","@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"8xoBF":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "Offline", ()=>Offline);
var _tslib = require("tslib");
var _utils = require("@sentry/utils");
var _localforage = require("localforage");
var _localforageDefault = parcelHelpers.interopDefault(_localforage);
var _flags = require("./flags");
/**
 * cache offline errors and send when connected
 */ var Offline = /** @class */ function() {
    /**
     * @inheritDoc
     */ function Offline(options) {
        if (options === void 0) options = {};
        /**
         * @inheritDoc
         */ this.name = Offline.id;
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        this.global = (0, _utils.getGlobalObject)();
        this.maxStoredEvents = options.maxStoredEvents || 30; // set a reasonable default
        // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access
        this.offlineEventStore = (0, _localforageDefault.default).createInstance({
            name: 'sentry/offlineEventStore'
        });
    }
    /**
     * @inheritDoc
     */ Offline.prototype.setupOnce = function(addGlobalEventProcessor, getCurrentHub) {
        var _this = this;
        this.hub = getCurrentHub();
        if ('addEventListener' in this.global) this.global.addEventListener('online', function() {
            _this._sendEvents().catch(function() {
                (0, _flags.IS_DEBUG_BUILD) && (0, _utils.logger).warn('could not send cached events');
            });
        });
        addGlobalEventProcessor(function(event) {
            if (_this.hub && _this.hub.getIntegration(Offline)) // cache if we are positively offline
            {
                if ('navigator' in _this.global && 'onLine' in _this.global.navigator && !_this.global.navigator.onLine) {
                    _this._cacheEvent(event).then(function(_event) {
                        return _this._enforceMaxEvents();
                    }).catch(function(_error) {
                        (0, _flags.IS_DEBUG_BUILD) && (0, _utils.logger).warn('could not cache event while offline');
                    });
                    // return null on success or failure, because being offline will still result in an error
                    return null;
                }
            }
            return event;
        });
        // if online now, send any events stored in a previous offline session
        if ('navigator' in this.global && 'onLine' in this.global.navigator && this.global.navigator.onLine) this._sendEvents().catch(function() {
            (0, _flags.IS_DEBUG_BUILD) && (0, _utils.logger).warn('could not send cached events');
        });
    };
    /**
     * cache an event to send later
     * @param event an event
     */ Offline.prototype._cacheEvent = function(event) {
        return (0, _tslib.__awaiter)(this, void 0, void 0, function() {
            return (0, _tslib.__generator)(this, function(_a) {
                return [
                    2 /*return*/ ,
                    this.offlineEventStore.setItem((0, _utils.uuid4)(), (0, _utils.normalize)(event))
                ];
            });
        });
    };
    /**
     * purge excess events if necessary
     */ Offline.prototype._enforceMaxEvents = function() {
        return (0, _tslib.__awaiter)(this, void 0, void 0, function() {
            var events;
            var _this = this;
            return (0, _tslib.__generator)(this, function(_a) {
                events = [];
                return [
                    2 /*return*/ ,
                    this.offlineEventStore.iterate(function(event, cacheKey, _index) {
                        // aggregate events
                        events.push({
                            cacheKey: cacheKey,
                            event: event
                        });
                    }).then(function() {
                        // this promise resolves when the iteration is finished
                        return _this._purgeEvents(// purge all events past maxStoredEvents in reverse chronological order
                        events.sort(function(a, b) {
                            return (b.event.timestamp || 0) - (a.event.timestamp || 0);
                        }).slice(_this.maxStoredEvents < events.length ? _this.maxStoredEvents : events.length).map(function(event) {
                            return event.cacheKey;
                        }));
                    }).catch(function(_error) {
                        (0, _flags.IS_DEBUG_BUILD) && (0, _utils.logger).warn('could not enforce max events');
                    })
                ];
            });
        });
    };
    /**
     * purge event from cache
     */ Offline.prototype._purgeEvent = function(cacheKey) {
        return (0, _tslib.__awaiter)(this, void 0, void 0, function() {
            return (0, _tslib.__generator)(this, function(_a) {
                return [
                    2 /*return*/ ,
                    this.offlineEventStore.removeItem(cacheKey)
                ];
            });
        });
    };
    /**
     * purge events from cache
     */ Offline.prototype._purgeEvents = function(cacheKeys) {
        return (0, _tslib.__awaiter)(this, void 0, void 0, function() {
            var _this = this;
            return (0, _tslib.__generator)(this, function(_a) {
                // trail with .then to ensure the return type as void and not void|void[]
                return [
                    2 /*return*/ ,
                    Promise.all(cacheKeys.map(function(cacheKey) {
                        return _this._purgeEvent(cacheKey);
                    })).then()
                ];
            });
        });
    };
    /**
     * send all events
     */ Offline.prototype._sendEvents = function() {
        return (0, _tslib.__awaiter)(this, void 0, void 0, function() {
            var _this = this;
            return (0, _tslib.__generator)(this, function(_a) {
                return [
                    2 /*return*/ ,
                    this.offlineEventStore.iterate(function(event, cacheKey, _index) {
                        if (_this.hub) {
                            _this.hub.captureEvent(event);
                            _this._purgeEvent(cacheKey).catch(function(_error) {
                                (0, _flags.IS_DEBUG_BUILD) && (0, _utils.logger).warn('could not purge event from cache');
                            });
                        } else (0, _flags.IS_DEBUG_BUILD) && (0, _utils.logger).warn('no hub found - could not send cached event');
                    })
                ];
            });
        });
    };
    /**
     * @inheritDoc
     */ Offline.id = 'Offline';
    return Offline;
}();

},{"tslib":"6MhhU","@sentry/utils":"agmfj","localforage":"dHPUx","./flags":"9Knv0","@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"dHPUx":[function(require,module,exports,__globalThis) {
var global = arguments[3];
/*!
    localForage -- Offline Storage, Improved
    Version 1.10.0
    https://localforage.github.io/localForage
    (c) 2013-2017 Mozilla, Apache License 2.0
*/ (function(f) {
    var g;
    module.exports = f();
})(function() {
    var define, module1, exports;
    return (function e(t, n, r) {
        function s(o, u) {
            if (!n[o]) {
                if (!t[o]) {
                    var a = undefined;
                    if (!u && a) return a(o, !0);
                    if (i) return i(o, !0);
                    var f = new Error("Cannot find module '" + o + "'");
                    throw f.code = "MODULE_NOT_FOUND", f;
                }
                var l = n[o] = {
                    exports: {}
                };
                t[o][0].call(l.exports, function(e) {
                    var n = t[o][1][e];
                    return s(n ? n : e);
                }, l, l.exports, e, t, n, r);
            }
            return n[o].exports;
        }
        var i = undefined;
        for(var o = 0; o < r.length; o++)s(r[o]);
        return s;
    })({
        1: [
            function(_dereq_, module1, exports) {
                (function(global) {
                    'use strict';
                    var Mutation = global.MutationObserver || global.WebKitMutationObserver;
                    var scheduleDrain;
                    if (Mutation) {
                        var called = 0;
                        var observer = new Mutation(nextTick);
                        var element = global.document.createTextNode('');
                        observer.observe(element, {
                            characterData: true
                        });
                        scheduleDrain = function() {
                            element.data = called = ++called % 2;
                        };
                    } else if (!global.setImmediate && typeof global.MessageChannel !== 'undefined') {
                        var channel = new global.MessageChannel();
                        channel.port1.onmessage = nextTick;
                        scheduleDrain = function() {
                            channel.port2.postMessage(0);
                        };
                    } else if ('document' in global && 'onreadystatechange' in global.document.createElement('script')) scheduleDrain = function() {
                        // Create a <script> element; its readystatechange event will be fired asynchronously once it is inserted
                        // into the document. Do so, thus queuing up the task. Remember to clean up once it's been called.
                        var scriptEl = global.document.createElement('script');
                        scriptEl.onreadystatechange = function() {
                            nextTick();
                            scriptEl.onreadystatechange = null;
                            scriptEl.parentNode.removeChild(scriptEl);
                            scriptEl = null;
                        };
                        global.document.documentElement.appendChild(scriptEl);
                    };
                    else scheduleDrain = function() {
                        setTimeout(nextTick, 0);
                    };
                    var draining;
                    var queue = [];
                    //named nextTick for less confusing stack traces
                    function nextTick() {
                        draining = true;
                        var i, oldQueue;
                        var len = queue.length;
                        while(len){
                            oldQueue = queue;
                            queue = [];
                            i = -1;
                            while(++i < len)oldQueue[i]();
                            len = queue.length;
                        }
                        draining = false;
                    }
                    module1.exports = immediate;
                    function immediate(task) {
                        if (queue.push(task) === 1 && !draining) scheduleDrain();
                    }
                }).call(this, typeof global !== "undefined" ? global : typeof self !== "undefined" ? self : typeof window !== "undefined" ? window : {});
            },
            {}
        ],
        2: [
            function(_dereq_, module1, exports) {
                'use strict';
                var immediate = _dereq_(1);
                /* istanbul ignore next */ function INTERNAL() {}
                var handlers = {};
                var REJECTED = [
                    'REJECTED'
                ];
                var FULFILLED = [
                    'FULFILLED'
                ];
                var PENDING = [
                    'PENDING'
                ];
                module1.exports = Promise1;
                function Promise1(resolver) {
                    if (typeof resolver !== 'function') throw new TypeError('resolver must be a function');
                    this.state = PENDING;
                    this.queue = [];
                    this.outcome = void 0;
                    if (resolver !== INTERNAL) safelyResolveThenable(this, resolver);
                }
                Promise1.prototype["catch"] = function(onRejected) {
                    return this.then(null, onRejected);
                };
                Promise1.prototype.then = function(onFulfilled, onRejected) {
                    if (typeof onFulfilled !== 'function' && this.state === FULFILLED || typeof onRejected !== 'function' && this.state === REJECTED) return this;
                    var promise = new this.constructor(INTERNAL);
                    if (this.state !== PENDING) {
                        var resolver = this.state === FULFILLED ? onFulfilled : onRejected;
                        unwrap(promise, resolver, this.outcome);
                    } else this.queue.push(new QueueItem(promise, onFulfilled, onRejected));
                    return promise;
                };
                function QueueItem(promise, onFulfilled, onRejected) {
                    this.promise = promise;
                    if (typeof onFulfilled === 'function') {
                        this.onFulfilled = onFulfilled;
                        this.callFulfilled = this.otherCallFulfilled;
                    }
                    if (typeof onRejected === 'function') {
                        this.onRejected = onRejected;
                        this.callRejected = this.otherCallRejected;
                    }
                }
                QueueItem.prototype.callFulfilled = function(value) {
                    handlers.resolve(this.promise, value);
                };
                QueueItem.prototype.otherCallFulfilled = function(value) {
                    unwrap(this.promise, this.onFulfilled, value);
                };
                QueueItem.prototype.callRejected = function(value) {
                    handlers.reject(this.promise, value);
                };
                QueueItem.prototype.otherCallRejected = function(value) {
                    unwrap(this.promise, this.onRejected, value);
                };
                function unwrap(promise, func, value) {
                    immediate(function() {
                        var returnValue;
                        try {
                            returnValue = func(value);
                        } catch (e) {
                            return handlers.reject(promise, e);
                        }
                        if (returnValue === promise) handlers.reject(promise, new TypeError('Cannot resolve promise with itself'));
                        else handlers.resolve(promise, returnValue);
                    });
                }
                handlers.resolve = function(self1, value) {
                    var result = tryCatch(getThen, value);
                    if (result.status === 'error') return handlers.reject(self1, result.value);
                    var thenable = result.value;
                    if (thenable) safelyResolveThenable(self1, thenable);
                    else {
                        self1.state = FULFILLED;
                        self1.outcome = value;
                        var i = -1;
                        var len = self1.queue.length;
                        while(++i < len)self1.queue[i].callFulfilled(value);
                    }
                    return self1;
                };
                handlers.reject = function(self1, error) {
                    self1.state = REJECTED;
                    self1.outcome = error;
                    var i = -1;
                    var len = self1.queue.length;
                    while(++i < len)self1.queue[i].callRejected(error);
                    return self1;
                };
                function getThen(obj) {
                    // Make sure we only access the accessor once as required by the spec
                    var then = obj && obj.then;
                    if (obj && (typeof obj === 'object' || typeof obj === 'function') && typeof then === 'function') return function appyThen() {
                        then.apply(obj, arguments);
                    };
                }
                function safelyResolveThenable(self1, thenable) {
                    // Either fulfill, reject or reject with error
                    var called = false;
                    function onError(value) {
                        if (called) return;
                        called = true;
                        handlers.reject(self1, value);
                    }
                    function onSuccess(value) {
                        if (called) return;
                        called = true;
                        handlers.resolve(self1, value);
                    }
                    function tryToUnwrap() {
                        thenable(onSuccess, onError);
                    }
                    var result = tryCatch(tryToUnwrap);
                    if (result.status === 'error') onError(result.value);
                }
                function tryCatch(func, value) {
                    var out = {};
                    try {
                        out.value = func(value);
                        out.status = 'success';
                    } catch (e) {
                        out.status = 'error';
                        out.value = e;
                    }
                    return out;
                }
                Promise1.resolve = resolve;
                function resolve(value) {
                    if (value instanceof this) return value;
                    return handlers.resolve(new this(INTERNAL), value);
                }
                Promise1.reject = reject;
                function reject(reason) {
                    var promise = new this(INTERNAL);
                    return handlers.reject(promise, reason);
                }
                Promise1.all = all;
                function all(iterable) {
                    var self1 = this;
                    if (Object.prototype.toString.call(iterable) !== '[object Array]') return this.reject(new TypeError('must be an array'));
                    var len = iterable.length;
                    var called = false;
                    if (!len) return this.resolve([]);
                    var values = new Array(len);
                    var resolved = 0;
                    var i = -1;
                    var promise = new this(INTERNAL);
                    while(++i < len)allResolver(iterable[i], i);
                    return promise;
                    function allResolver(value, i) {
                        self1.resolve(value).then(resolveFromAll, function(error) {
                            if (!called) {
                                called = true;
                                handlers.reject(promise, error);
                            }
                        });
                        function resolveFromAll(outValue) {
                            values[i] = outValue;
                            if (++resolved === len && !called) {
                                called = true;
                                handlers.resolve(promise, values);
                            }
                        }
                    }
                }
                Promise1.race = race;
                function race(iterable) {
                    var self1 = this;
                    if (Object.prototype.toString.call(iterable) !== '[object Array]') return this.reject(new TypeError('must be an array'));
                    var len = iterable.length;
                    var called = false;
                    if (!len) return this.resolve([]);
                    var i = -1;
                    var promise = new this(INTERNAL);
                    while(++i < len)resolver(iterable[i]);
                    return promise;
                    function resolver(value) {
                        self1.resolve(value).then(function(response) {
                            if (!called) {
                                called = true;
                                handlers.resolve(promise, response);
                            }
                        }, function(error) {
                            if (!called) {
                                called = true;
                                handlers.reject(promise, error);
                            }
                        });
                    }
                }
            },
            {
                "1": 1
            }
        ],
        3: [
            function(_dereq_, module1, exports) {
                (function(global) {
                    'use strict';
                    if (typeof global.Promise !== 'function') global.Promise = _dereq_(2);
                }).call(this, typeof global !== "undefined" ? global : typeof self !== "undefined" ? self : typeof window !== "undefined" ? window : {});
            },
            {
                "2": 2
            }
        ],
        4: [
            function(_dereq_, module1, exports) {
                'use strict';
                var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function(obj) {
                    return typeof obj;
                } : function(obj) {
                    return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
                };
                function _classCallCheck(instance, Constructor) {
                    if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
                }
                function getIDB() {
                    /* global indexedDB,webkitIndexedDB,mozIndexedDB,OIndexedDB,msIndexedDB */ try {
                        if (typeof indexedDB !== 'undefined') return indexedDB;
                        if (typeof webkitIndexedDB !== 'undefined') return webkitIndexedDB;
                        if (typeof mozIndexedDB !== 'undefined') return mozIndexedDB;
                        if (typeof OIndexedDB !== 'undefined') return OIndexedDB;
                        if (typeof msIndexedDB !== 'undefined') return msIndexedDB;
                    } catch (e) {
                        return;
                    }
                }
                var idb = getIDB();
                function isIndexedDBValid() {
                    try {
                        // Initialize IndexedDB; fall back to vendor-prefixed versions
                        // if needed.
                        if (!idb || !idb.open) return false;
                        // We mimic PouchDB here;
                        //
                        // We test for openDatabase because IE Mobile identifies itself
                        // as Safari. Oh the lulz...
                        var isSafari = typeof openDatabase !== 'undefined' && /(Safari|iPhone|iPad|iPod)/.test(navigator.userAgent) && !/Chrome/.test(navigator.userAgent) && !/BlackBerry/.test(navigator.platform);
                        var hasFetch = typeof fetch === 'function' && fetch.toString().indexOf('[native code') !== -1;
                        // Safari <10.1 does not meet our requirements for IDB support
                        // (see: https://github.com/pouchdb/pouchdb/issues/5572).
                        // Safari 10.1 shipped with fetch, we can use that to detect it.
                        // Note: this creates issues with `window.fetch` polyfills and
                        // overrides; see:
                        // https://github.com/localForage/localForage/issues/856
                        return (!isSafari || hasFetch) && typeof indexedDB !== 'undefined' && // some outdated implementations of IDB that appear on Samsung
                        // and HTC Android devices <4.4 are missing IDBKeyRange
                        // See: https://github.com/mozilla/localForage/issues/128
                        // See: https://github.com/mozilla/localForage/issues/272
                        typeof IDBKeyRange !== 'undefined';
                    } catch (e) {
                        return false;
                    }
                }
                // Abstracts constructing a Blob object, so it also works in older
                // browsers that don't support the native Blob constructor. (i.e.
                // old QtWebKit versions, at least).
                // Abstracts constructing a Blob object, so it also works in older
                // browsers that don't support the native Blob constructor. (i.e.
                // old QtWebKit versions, at least).
                function createBlob(parts, properties) {
                    /* global BlobBuilder,MSBlobBuilder,MozBlobBuilder,WebKitBlobBuilder */ parts = parts || [];
                    properties = properties || {};
                    try {
                        return new Blob(parts, properties);
                    } catch (e) {
                        if (e.name !== 'TypeError') throw e;
                        var Builder = typeof BlobBuilder !== 'undefined' ? BlobBuilder : typeof MSBlobBuilder !== 'undefined' ? MSBlobBuilder : typeof MozBlobBuilder !== 'undefined' ? MozBlobBuilder : WebKitBlobBuilder;
                        var builder = new Builder();
                        for(var i = 0; i < parts.length; i += 1)builder.append(parts[i]);
                        return builder.getBlob(properties.type);
                    }
                }
                // This is CommonJS because lie is an external dependency, so Rollup
                // can just ignore it.
                if (typeof Promise === 'undefined') // In the "nopromises" build this will just throw if you don't have
                // a global promise object, but it would throw anyway later.
                _dereq_(3);
                var Promise$1 = Promise;
                function executeCallback(promise, callback) {
                    if (callback) promise.then(function(result) {
                        callback(null, result);
                    }, function(error) {
                        callback(error);
                    });
                }
                function executeTwoCallbacks(promise, callback, errorCallback) {
                    if (typeof callback === 'function') promise.then(callback);
                    if (typeof errorCallback === 'function') promise["catch"](errorCallback);
                }
                function normalizeKey(key) {
                    // Cast the key to a string, as that's all we can set as a key.
                    if (typeof key !== 'string') {
                        console.warn(key + ' used as a key, but it is not a string.');
                        key = String(key);
                    }
                    return key;
                }
                function getCallback() {
                    if (arguments.length && typeof arguments[arguments.length - 1] === 'function') return arguments[arguments.length - 1];
                }
                // Some code originally from async_storage.js in
                // [Gaia](https://github.com/mozilla-b2g/gaia).
                var DETECT_BLOB_SUPPORT_STORE = 'local-forage-detect-blob-support';
                var supportsBlobs = void 0;
                var dbContexts = {};
                var toString = Object.prototype.toString;
                // Transaction Modes
                var READ_ONLY = 'readonly';
                var READ_WRITE = 'readwrite';
                // Transform a binary string to an array buffer, because otherwise
                // weird stuff happens when you try to work with the binary string directly.
                // It is known.
                // From http://stackoverflow.com/questions/14967647/ (continues on next line)
                // encode-decode-image-with-base64-breaks-image (2013-04-21)
                function _binStringToArrayBuffer(bin) {
                    var length = bin.length;
                    var buf = new ArrayBuffer(length);
                    var arr = new Uint8Array(buf);
                    for(var i = 0; i < length; i++)arr[i] = bin.charCodeAt(i);
                    return buf;
                }
                //
                // Blobs are not supported in all versions of IndexedDB, notably
                // Chrome <37 and Android <5. In those versions, storing a blob will throw.
                //
                // Various other blob bugs exist in Chrome v37-42 (inclusive).
                // Detecting them is expensive and confusing to users, and Chrome 37-42
                // is at very low usage worldwide, so we do a hacky userAgent check instead.
                //
                // content-type bug: https://code.google.com/p/chromium/issues/detail?id=408120
                // 404 bug: https://code.google.com/p/chromium/issues/detail?id=447916
                // FileReader bug: https://code.google.com/p/chromium/issues/detail?id=447836
                //
                // Code borrowed from PouchDB. See:
                // https://github.com/pouchdb/pouchdb/blob/master/packages/node_modules/pouchdb-adapter-idb/src/blobSupport.js
                //
                function _checkBlobSupportWithoutCaching(idb) {
                    return new Promise$1(function(resolve) {
                        var txn = idb.transaction(DETECT_BLOB_SUPPORT_STORE, READ_WRITE);
                        var blob = createBlob([
                            ''
                        ]);
                        txn.objectStore(DETECT_BLOB_SUPPORT_STORE).put(blob, 'key');
                        txn.onabort = function(e) {
                            // If the transaction aborts now its due to not being able to
                            // write to the database, likely due to the disk being full
                            e.preventDefault();
                            e.stopPropagation();
                            resolve(false);
                        };
                        txn.oncomplete = function() {
                            var matchedChrome = navigator.userAgent.match(/Chrome\/(\d+)/);
                            var matchedEdge = navigator.userAgent.match(/Edge\//);
                            // MS Edge pretends to be Chrome 42:
                            // https://msdn.microsoft.com/en-us/library/hh869301%28v=vs.85%29.aspx
                            resolve(matchedEdge || !matchedChrome || parseInt(matchedChrome[1], 10) >= 43);
                        };
                    })["catch"](function() {
                        return false; // error, so assume unsupported
                    });
                }
                function _checkBlobSupport(idb) {
                    if (typeof supportsBlobs === 'boolean') return Promise$1.resolve(supportsBlobs);
                    return _checkBlobSupportWithoutCaching(idb).then(function(value) {
                        supportsBlobs = value;
                        return supportsBlobs;
                    });
                }
                function _deferReadiness(dbInfo) {
                    var dbContext = dbContexts[dbInfo.name];
                    // Create a deferred object representing the current database operation.
                    var deferredOperation = {};
                    deferredOperation.promise = new Promise$1(function(resolve, reject) {
                        deferredOperation.resolve = resolve;
                        deferredOperation.reject = reject;
                    });
                    // Enqueue the deferred operation.
                    dbContext.deferredOperations.push(deferredOperation);
                    // Chain its promise to the database readiness.
                    if (!dbContext.dbReady) dbContext.dbReady = deferredOperation.promise;
                    else dbContext.dbReady = dbContext.dbReady.then(function() {
                        return deferredOperation.promise;
                    });
                }
                function _advanceReadiness(dbInfo) {
                    var dbContext = dbContexts[dbInfo.name];
                    // Dequeue a deferred operation.
                    var deferredOperation = dbContext.deferredOperations.pop();
                    // Resolve its promise (which is part of the database readiness
                    // chain of promises).
                    if (deferredOperation) {
                        deferredOperation.resolve();
                        return deferredOperation.promise;
                    }
                }
                function _rejectReadiness(dbInfo, err) {
                    var dbContext = dbContexts[dbInfo.name];
                    // Dequeue a deferred operation.
                    var deferredOperation = dbContext.deferredOperations.pop();
                    // Reject its promise (which is part of the database readiness
                    // chain of promises).
                    if (deferredOperation) {
                        deferredOperation.reject(err);
                        return deferredOperation.promise;
                    }
                }
                function _getConnection(dbInfo, upgradeNeeded) {
                    return new Promise$1(function(resolve, reject) {
                        dbContexts[dbInfo.name] = dbContexts[dbInfo.name] || createDbContext();
                        if (dbInfo.db) {
                            if (upgradeNeeded) {
                                _deferReadiness(dbInfo);
                                dbInfo.db.close();
                            } else return resolve(dbInfo.db);
                        }
                        var dbArgs = [
                            dbInfo.name
                        ];
                        if (upgradeNeeded) dbArgs.push(dbInfo.version);
                        var openreq = idb.open.apply(idb, dbArgs);
                        if (upgradeNeeded) openreq.onupgradeneeded = function(e) {
                            var db = openreq.result;
                            try {
                                db.createObjectStore(dbInfo.storeName);
                                if (e.oldVersion <= 1) // Added when support for blob shims was added
                                db.createObjectStore(DETECT_BLOB_SUPPORT_STORE);
                            } catch (ex) {
                                if (ex.name === 'ConstraintError') console.warn('The database "' + dbInfo.name + '"' + ' has been upgraded from version ' + e.oldVersion + ' to version ' + e.newVersion + ', but the storage "' + dbInfo.storeName + '" already exists.');
                                else throw ex;
                            }
                        };
                        openreq.onerror = function(e) {
                            e.preventDefault();
                            reject(openreq.error);
                        };
                        openreq.onsuccess = function() {
                            var db = openreq.result;
                            db.onversionchange = function(e) {
                                // Triggered when the database is modified (e.g. adding an objectStore) or
                                // deleted (even when initiated by other sessions in different tabs).
                                // Closing the connection here prevents those operations from being blocked.
                                // If the database is accessed again later by this instance, the connection
                                // will be reopened or the database recreated as needed.
                                e.target.close();
                            };
                            resolve(db);
                            _advanceReadiness(dbInfo);
                        };
                    });
                }
                function _getOriginalConnection(dbInfo) {
                    return _getConnection(dbInfo, false);
                }
                function _getUpgradedConnection(dbInfo) {
                    return _getConnection(dbInfo, true);
                }
                function _isUpgradeNeeded(dbInfo, defaultVersion) {
                    if (!dbInfo.db) return true;
                    var isNewStore = !dbInfo.db.objectStoreNames.contains(dbInfo.storeName);
                    var isDowngrade = dbInfo.version < dbInfo.db.version;
                    var isUpgrade = dbInfo.version > dbInfo.db.version;
                    if (isDowngrade) {
                        // If the version is not the default one
                        // then warn for impossible downgrade.
                        if (dbInfo.version !== defaultVersion) console.warn('The database "' + dbInfo.name + '"' + " can't be downgraded from version " + dbInfo.db.version + ' to version ' + dbInfo.version + '.');
                        // Align the versions to prevent errors.
                        dbInfo.version = dbInfo.db.version;
                    }
                    if (isUpgrade || isNewStore) {
                        // If the store is new then increment the version (if needed).
                        // This will trigger an "upgradeneeded" event which is required
                        // for creating a store.
                        if (isNewStore) {
                            var incVersion = dbInfo.db.version + 1;
                            if (incVersion > dbInfo.version) dbInfo.version = incVersion;
                        }
                        return true;
                    }
                    return false;
                }
                // encode a blob for indexeddb engines that don't support blobs
                function _encodeBlob(blob) {
                    return new Promise$1(function(resolve, reject) {
                        var reader = new FileReader();
                        reader.onerror = reject;
                        reader.onloadend = function(e) {
                            var base64 = btoa(e.target.result || '');
                            resolve({
                                __local_forage_encoded_blob: true,
                                data: base64,
                                type: blob.type
                            });
                        };
                        reader.readAsBinaryString(blob);
                    });
                }
                // decode an encoded blob
                function _decodeBlob(encodedBlob) {
                    var arrayBuff = _binStringToArrayBuffer(atob(encodedBlob.data));
                    return createBlob([
                        arrayBuff
                    ], {
                        type: encodedBlob.type
                    });
                }
                // is this one of our fancy encoded blobs?
                function _isEncodedBlob(value) {
                    return value && value.__local_forage_encoded_blob;
                }
                // Specialize the default `ready()` function by making it dependent
                // on the current database operations. Thus, the driver will be actually
                // ready when it's been initialized (default) *and* there are no pending
                // operations on the database (initiated by some other instances).
                function _fullyReady(callback) {
                    var self1 = this;
                    var promise = self1._initReady().then(function() {
                        var dbContext = dbContexts[self1._dbInfo.name];
                        if (dbContext && dbContext.dbReady) return dbContext.dbReady;
                    });
                    executeTwoCallbacks(promise, callback, callback);
                    return promise;
                }
                // Try to establish a new db connection to replace the
                // current one which is broken (i.e. experiencing
                // InvalidStateError while creating a transaction).
                function _tryReconnect(dbInfo) {
                    _deferReadiness(dbInfo);
                    var dbContext = dbContexts[dbInfo.name];
                    var forages = dbContext.forages;
                    for(var i = 0; i < forages.length; i++){
                        var forage = forages[i];
                        if (forage._dbInfo.db) {
                            forage._dbInfo.db.close();
                            forage._dbInfo.db = null;
                        }
                    }
                    dbInfo.db = null;
                    return _getOriginalConnection(dbInfo).then(function(db) {
                        dbInfo.db = db;
                        if (_isUpgradeNeeded(dbInfo)) // Reopen the database for upgrading.
                        return _getUpgradedConnection(dbInfo);
                        return db;
                    }).then(function(db) {
                        // store the latest db reference
                        // in case the db was upgraded
                        dbInfo.db = dbContext.db = db;
                        for(var i = 0; i < forages.length; i++)forages[i]._dbInfo.db = db;
                    })["catch"](function(err) {
                        _rejectReadiness(dbInfo, err);
                        throw err;
                    });
                }
                // FF doesn't like Promises (micro-tasks) and IDDB store operations,
                // so we have to do it with callbacks
                function createTransaction(dbInfo, mode, callback, retries) {
                    if (retries === undefined) retries = 1;
                    try {
                        var tx = dbInfo.db.transaction(dbInfo.storeName, mode);
                        callback(null, tx);
                    } catch (err) {
                        if (retries > 0 && (!dbInfo.db || err.name === 'InvalidStateError' || err.name === 'NotFoundError')) return Promise$1.resolve().then(function() {
                            if (!dbInfo.db || err.name === 'NotFoundError' && !dbInfo.db.objectStoreNames.contains(dbInfo.storeName) && dbInfo.version <= dbInfo.db.version) {
                                // increase the db version, to create the new ObjectStore
                                if (dbInfo.db) dbInfo.version = dbInfo.db.version + 1;
                                // Reopen the database for upgrading.
                                return _getUpgradedConnection(dbInfo);
                            }
                        }).then(function() {
                            return _tryReconnect(dbInfo).then(function() {
                                createTransaction(dbInfo, mode, callback, retries - 1);
                            });
                        })["catch"](callback);
                        callback(err);
                    }
                }
                function createDbContext() {
                    return {
                        // Running localForages sharing a database.
                        forages: [],
                        // Shared database.
                        db: null,
                        // Database readiness (promise).
                        dbReady: null,
                        // Deferred operations on the database.
                        deferredOperations: []
                    };
                }
                // Open the IndexedDB database (automatically creates one if one didn't
                // previously exist), using any options set in the config.
                function _initStorage(options) {
                    var self1 = this;
                    var dbInfo = {
                        db: null
                    };
                    if (options) for(var i in options)dbInfo[i] = options[i];
                    // Get the current context of the database;
                    var dbContext = dbContexts[dbInfo.name];
                    // ...or create a new context.
                    if (!dbContext) {
                        dbContext = createDbContext();
                        // Register the new context in the global container.
                        dbContexts[dbInfo.name] = dbContext;
                    }
                    // Register itself as a running localForage in the current context.
                    dbContext.forages.push(self1);
                    // Replace the default `ready()` function with the specialized one.
                    if (!self1._initReady) {
                        self1._initReady = self1.ready;
                        self1.ready = _fullyReady;
                    }
                    // Create an array of initialization states of the related localForages.
                    var initPromises = [];
                    function ignoreErrors() {
                        // Don't handle errors here,
                        // just makes sure related localForages aren't pending.
                        return Promise$1.resolve();
                    }
                    for(var j = 0; j < dbContext.forages.length; j++){
                        var forage = dbContext.forages[j];
                        if (forage !== self1) // Don't wait for itself...
                        initPromises.push(forage._initReady()["catch"](ignoreErrors));
                    }
                    // Take a snapshot of the related localForages.
                    var forages = dbContext.forages.slice(0);
                    // Initialize the connection process only when
                    // all the related localForages aren't pending.
                    return Promise$1.all(initPromises).then(function() {
                        dbInfo.db = dbContext.db;
                        // Get the connection or open a new one without upgrade.
                        return _getOriginalConnection(dbInfo);
                    }).then(function(db) {
                        dbInfo.db = db;
                        if (_isUpgradeNeeded(dbInfo, self1._defaultConfig.version)) // Reopen the database for upgrading.
                        return _getUpgradedConnection(dbInfo);
                        return db;
                    }).then(function(db) {
                        dbInfo.db = dbContext.db = db;
                        self1._dbInfo = dbInfo;
                        // Share the final connection amongst related localForages.
                        for(var k = 0; k < forages.length; k++){
                            var forage = forages[k];
                            if (forage !== self1) {
                                // Self is already up-to-date.
                                forage._dbInfo.db = dbInfo.db;
                                forage._dbInfo.version = dbInfo.version;
                            }
                        }
                    });
                }
                function getItem(key, callback) {
                    var self1 = this;
                    key = normalizeKey(key);
                    var promise = new Promise$1(function(resolve, reject) {
                        self1.ready().then(function() {
                            createTransaction(self1._dbInfo, READ_ONLY, function(err, transaction) {
                                if (err) return reject(err);
                                try {
                                    var store = transaction.objectStore(self1._dbInfo.storeName);
                                    var req = store.get(key);
                                    req.onsuccess = function() {
                                        var value = req.result;
                                        if (value === undefined) value = null;
                                        if (_isEncodedBlob(value)) value = _decodeBlob(value);
                                        resolve(value);
                                    };
                                    req.onerror = function() {
                                        reject(req.error);
                                    };
                                } catch (e) {
                                    reject(e);
                                }
                            });
                        })["catch"](reject);
                    });
                    executeCallback(promise, callback);
                    return promise;
                }
                // Iterate over all items stored in database.
                function iterate(iterator, callback) {
                    var self1 = this;
                    var promise = new Promise$1(function(resolve, reject) {
                        self1.ready().then(function() {
                            createTransaction(self1._dbInfo, READ_ONLY, function(err, transaction) {
                                if (err) return reject(err);
                                try {
                                    var store = transaction.objectStore(self1._dbInfo.storeName);
                                    var req = store.openCursor();
                                    var iterationNumber = 1;
                                    req.onsuccess = function() {
                                        var cursor = req.result;
                                        if (cursor) {
                                            var value = cursor.value;
                                            if (_isEncodedBlob(value)) value = _decodeBlob(value);
                                            var result = iterator(value, cursor.key, iterationNumber++);
                                            // when the iterator callback returns any
                                            // (non-`undefined`) value, then we stop
                                            // the iteration immediately
                                            if (result !== void 0) resolve(result);
                                            else cursor["continue"]();
                                        } else resolve();
                                    };
                                    req.onerror = function() {
                                        reject(req.error);
                                    };
                                } catch (e) {
                                    reject(e);
                                }
                            });
                        })["catch"](reject);
                    });
                    executeCallback(promise, callback);
                    return promise;
                }
                function setItem(key, value, callback) {
                    var self1 = this;
                    key = normalizeKey(key);
                    var promise = new Promise$1(function(resolve, reject) {
                        var dbInfo;
                        self1.ready().then(function() {
                            dbInfo = self1._dbInfo;
                            if (toString.call(value) === '[object Blob]') return _checkBlobSupport(dbInfo.db).then(function(blobSupport) {
                                if (blobSupport) return value;
                                return _encodeBlob(value);
                            });
                            return value;
                        }).then(function(value) {
                            createTransaction(self1._dbInfo, READ_WRITE, function(err, transaction) {
                                if (err) return reject(err);
                                try {
                                    var store = transaction.objectStore(self1._dbInfo.storeName);
                                    // The reason we don't _save_ null is because IE 10 does
                                    // not support saving the `null` type in IndexedDB. How
                                    // ironic, given the bug below!
                                    // See: https://github.com/mozilla/localForage/issues/161
                                    if (value === null) value = undefined;
                                    var req = store.put(value, key);
                                    transaction.oncomplete = function() {
                                        // Cast to undefined so the value passed to
                                        // callback/promise is the same as what one would get out
                                        // of `getItem()` later. This leads to some weirdness
                                        // (setItem('foo', undefined) will return `null`), but
                                        // it's not my fault localStorage is our baseline and that
                                        // it's weird.
                                        if (value === undefined) value = null;
                                        resolve(value);
                                    };
                                    transaction.onabort = transaction.onerror = function() {
                                        var err = req.error ? req.error : req.transaction.error;
                                        reject(err);
                                    };
                                } catch (e) {
                                    reject(e);
                                }
                            });
                        })["catch"](reject);
                    });
                    executeCallback(promise, callback);
                    return promise;
                }
                function removeItem(key, callback) {
                    var self1 = this;
                    key = normalizeKey(key);
                    var promise = new Promise$1(function(resolve, reject) {
                        self1.ready().then(function() {
                            createTransaction(self1._dbInfo, READ_WRITE, function(err, transaction) {
                                if (err) return reject(err);
                                try {
                                    var store = transaction.objectStore(self1._dbInfo.storeName);
                                    // We use a Grunt task to make this safe for IE and some
                                    // versions of Android (including those used by Cordova).
                                    // Normally IE won't like `.delete()` and will insist on
                                    // using `['delete']()`, but we have a build step that
                                    // fixes this for us now.
                                    var req = store["delete"](key);
                                    transaction.oncomplete = function() {
                                        resolve();
                                    };
                                    transaction.onerror = function() {
                                        reject(req.error);
                                    };
                                    // The request will be also be aborted if we've exceeded our storage
                                    // space.
                                    transaction.onabort = function() {
                                        var err = req.error ? req.error : req.transaction.error;
                                        reject(err);
                                    };
                                } catch (e) {
                                    reject(e);
                                }
                            });
                        })["catch"](reject);
                    });
                    executeCallback(promise, callback);
                    return promise;
                }
                function clear(callback) {
                    var self1 = this;
                    var promise = new Promise$1(function(resolve, reject) {
                        self1.ready().then(function() {
                            createTransaction(self1._dbInfo, READ_WRITE, function(err, transaction) {
                                if (err) return reject(err);
                                try {
                                    var store = transaction.objectStore(self1._dbInfo.storeName);
                                    var req = store.clear();
                                    transaction.oncomplete = function() {
                                        resolve();
                                    };
                                    transaction.onabort = transaction.onerror = function() {
                                        var err = req.error ? req.error : req.transaction.error;
                                        reject(err);
                                    };
                                } catch (e) {
                                    reject(e);
                                }
                            });
                        })["catch"](reject);
                    });
                    executeCallback(promise, callback);
                    return promise;
                }
                function length(callback) {
                    var self1 = this;
                    var promise = new Promise$1(function(resolve, reject) {
                        self1.ready().then(function() {
                            createTransaction(self1._dbInfo, READ_ONLY, function(err, transaction) {
                                if (err) return reject(err);
                                try {
                                    var store = transaction.objectStore(self1._dbInfo.storeName);
                                    var req = store.count();
                                    req.onsuccess = function() {
                                        resolve(req.result);
                                    };
                                    req.onerror = function() {
                                        reject(req.error);
                                    };
                                } catch (e) {
                                    reject(e);
                                }
                            });
                        })["catch"](reject);
                    });
                    executeCallback(promise, callback);
                    return promise;
                }
                function key(n, callback) {
                    var self1 = this;
                    var promise = new Promise$1(function(resolve, reject) {
                        if (n < 0) {
                            resolve(null);
                            return;
                        }
                        self1.ready().then(function() {
                            createTransaction(self1._dbInfo, READ_ONLY, function(err, transaction) {
                                if (err) return reject(err);
                                try {
                                    var store = transaction.objectStore(self1._dbInfo.storeName);
                                    var advanced = false;
                                    var req = store.openKeyCursor();
                                    req.onsuccess = function() {
                                        var cursor = req.result;
                                        if (!cursor) {
                                            // this means there weren't enough keys
                                            resolve(null);
                                            return;
                                        }
                                        if (n === 0) // We have the first key, return it if that's what they
                                        // wanted.
                                        resolve(cursor.key);
                                        else if (!advanced) {
                                            // Otherwise, ask the cursor to skip ahead n
                                            // records.
                                            advanced = true;
                                            cursor.advance(n);
                                        } else // When we get here, we've got the nth key.
                                        resolve(cursor.key);
                                    };
                                    req.onerror = function() {
                                        reject(req.error);
                                    };
                                } catch (e) {
                                    reject(e);
                                }
                            });
                        })["catch"](reject);
                    });
                    executeCallback(promise, callback);
                    return promise;
                }
                function keys(callback) {
                    var self1 = this;
                    var promise = new Promise$1(function(resolve, reject) {
                        self1.ready().then(function() {
                            createTransaction(self1._dbInfo, READ_ONLY, function(err, transaction) {
                                if (err) return reject(err);
                                try {
                                    var store = transaction.objectStore(self1._dbInfo.storeName);
                                    var req = store.openKeyCursor();
                                    var keys = [];
                                    req.onsuccess = function() {
                                        var cursor = req.result;
                                        if (!cursor) {
                                            resolve(keys);
                                            return;
                                        }
                                        keys.push(cursor.key);
                                        cursor["continue"]();
                                    };
                                    req.onerror = function() {
                                        reject(req.error);
                                    };
                                } catch (e) {
                                    reject(e);
                                }
                            });
                        })["catch"](reject);
                    });
                    executeCallback(promise, callback);
                    return promise;
                }
                function dropInstance(options, callback) {
                    callback = getCallback.apply(this, arguments);
                    var currentConfig = this.config();
                    options = typeof options !== 'function' && options || {};
                    if (!options.name) {
                        options.name = options.name || currentConfig.name;
                        options.storeName = options.storeName || currentConfig.storeName;
                    }
                    var self1 = this;
                    var promise;
                    if (!options.name) promise = Promise$1.reject('Invalid arguments');
                    else {
                        var isCurrentDb = options.name === currentConfig.name && self1._dbInfo.db;
                        var dbPromise = isCurrentDb ? Promise$1.resolve(self1._dbInfo.db) : _getOriginalConnection(options).then(function(db) {
                            var dbContext = dbContexts[options.name];
                            var forages = dbContext.forages;
                            dbContext.db = db;
                            for(var i = 0; i < forages.length; i++)forages[i]._dbInfo.db = db;
                            return db;
                        });
                        if (!options.storeName) promise = dbPromise.then(function(db) {
                            _deferReadiness(options);
                            var dbContext = dbContexts[options.name];
                            var forages = dbContext.forages;
                            db.close();
                            for(var i = 0; i < forages.length; i++){
                                var forage = forages[i];
                                forage._dbInfo.db = null;
                            }
                            var dropDBPromise = new Promise$1(function(resolve, reject) {
                                var req = idb.deleteDatabase(options.name);
                                req.onerror = function() {
                                    var db = req.result;
                                    if (db) db.close();
                                    reject(req.error);
                                };
                                req.onblocked = function() {
                                    // Closing all open connections in onversionchange handler should prevent this situation, but if
                                    // we do get here, it just means the request remains pending - eventually it will succeed or error
                                    console.warn('dropInstance blocked for database "' + options.name + '" until all open connections are closed');
                                };
                                req.onsuccess = function() {
                                    var db = req.result;
                                    if (db) db.close();
                                    resolve(db);
                                };
                            });
                            return dropDBPromise.then(function(db) {
                                dbContext.db = db;
                                for(var i = 0; i < forages.length; i++){
                                    var _forage = forages[i];
                                    _advanceReadiness(_forage._dbInfo);
                                }
                            })["catch"](function(err) {
                                (_rejectReadiness(options, err) || Promise$1.resolve())["catch"](function() {});
                                throw err;
                            });
                        });
                        else promise = dbPromise.then(function(db) {
                            if (!db.objectStoreNames.contains(options.storeName)) return;
                            var newVersion = db.version + 1;
                            _deferReadiness(options);
                            var dbContext = dbContexts[options.name];
                            var forages = dbContext.forages;
                            db.close();
                            for(var i = 0; i < forages.length; i++){
                                var forage = forages[i];
                                forage._dbInfo.db = null;
                                forage._dbInfo.version = newVersion;
                            }
                            var dropObjectPromise = new Promise$1(function(resolve, reject) {
                                var req = idb.open(options.name, newVersion);
                                req.onerror = function(err) {
                                    var db = req.result;
                                    db.close();
                                    reject(err);
                                };
                                req.onupgradeneeded = function() {
                                    var db = req.result;
                                    db.deleteObjectStore(options.storeName);
                                };
                                req.onsuccess = function() {
                                    var db = req.result;
                                    db.close();
                                    resolve(db);
                                };
                            });
                            return dropObjectPromise.then(function(db) {
                                dbContext.db = db;
                                for(var j = 0; j < forages.length; j++){
                                    var _forage2 = forages[j];
                                    _forage2._dbInfo.db = db;
                                    _advanceReadiness(_forage2._dbInfo);
                                }
                            })["catch"](function(err) {
                                (_rejectReadiness(options, err) || Promise$1.resolve())["catch"](function() {});
                                throw err;
                            });
                        });
                    }
                    executeCallback(promise, callback);
                    return promise;
                }
                var asyncStorage = {
                    _driver: 'asyncStorage',
                    _initStorage: _initStorage,
                    _support: isIndexedDBValid(),
                    iterate: iterate,
                    getItem: getItem,
                    setItem: setItem,
                    removeItem: removeItem,
                    clear: clear,
                    length: length,
                    key: key,
                    keys: keys,
                    dropInstance: dropInstance
                };
                function isWebSQLValid() {
                    return typeof openDatabase === 'function';
                }
                // Sadly, the best way to save binary data in WebSQL/localStorage is serializing
                // it to Base64, so this is how we store it to prevent very strange errors with less
                // verbose ways of binary <-> string data storage.
                var BASE_CHARS = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/';
                var BLOB_TYPE_PREFIX = '~~local_forage_type~';
                var BLOB_TYPE_PREFIX_REGEX = /^~~local_forage_type~([^~]+)~/;
                var SERIALIZED_MARKER = '__lfsc__:';
                var SERIALIZED_MARKER_LENGTH = SERIALIZED_MARKER.length;
                // OMG the serializations!
                var TYPE_ARRAYBUFFER = 'arbf';
                var TYPE_BLOB = 'blob';
                var TYPE_INT8ARRAY = 'si08';
                var TYPE_UINT8ARRAY = 'ui08';
                var TYPE_UINT8CLAMPEDARRAY = 'uic8';
                var TYPE_INT16ARRAY = 'si16';
                var TYPE_INT32ARRAY = 'si32';
                var TYPE_UINT16ARRAY = 'ur16';
                var TYPE_UINT32ARRAY = 'ui32';
                var TYPE_FLOAT32ARRAY = 'fl32';
                var TYPE_FLOAT64ARRAY = 'fl64';
                var TYPE_SERIALIZED_MARKER_LENGTH = SERIALIZED_MARKER_LENGTH + TYPE_ARRAYBUFFER.length;
                var toString$1 = Object.prototype.toString;
                function stringToBuffer(serializedString) {
                    // Fill the string into a ArrayBuffer.
                    var bufferLength = serializedString.length * 0.75;
                    var len = serializedString.length;
                    var i;
                    var p = 0;
                    var encoded1, encoded2, encoded3, encoded4;
                    if (serializedString[serializedString.length - 1] === '=') {
                        bufferLength--;
                        if (serializedString[serializedString.length - 2] === '=') bufferLength--;
                    }
                    var buffer = new ArrayBuffer(bufferLength);
                    var bytes = new Uint8Array(buffer);
                    for(i = 0; i < len; i += 4){
                        encoded1 = BASE_CHARS.indexOf(serializedString[i]);
                        encoded2 = BASE_CHARS.indexOf(serializedString[i + 1]);
                        encoded3 = BASE_CHARS.indexOf(serializedString[i + 2]);
                        encoded4 = BASE_CHARS.indexOf(serializedString[i + 3]);
                        /*jslint bitwise: true */ bytes[p++] = encoded1 << 2 | encoded2 >> 4;
                        bytes[p++] = (encoded2 & 15) << 4 | encoded3 >> 2;
                        bytes[p++] = (encoded3 & 3) << 6 | encoded4 & 63;
                    }
                    return buffer;
                }
                // Converts a buffer to a string to store, serialized, in the backend
                // storage library.
                function bufferToString(buffer) {
                    // base64-arraybuffer
                    var bytes = new Uint8Array(buffer);
                    var base64String = '';
                    var i;
                    for(i = 0; i < bytes.length; i += 3){
                        /*jslint bitwise: true */ base64String += BASE_CHARS[bytes[i] >> 2];
                        base64String += BASE_CHARS[(bytes[i] & 3) << 4 | bytes[i + 1] >> 4];
                        base64String += BASE_CHARS[(bytes[i + 1] & 15) << 2 | bytes[i + 2] >> 6];
                        base64String += BASE_CHARS[bytes[i + 2] & 63];
                    }
                    if (bytes.length % 3 === 2) base64String = base64String.substring(0, base64String.length - 1) + '=';
                    else if (bytes.length % 3 === 1) base64String = base64String.substring(0, base64String.length - 2) + '==';
                    return base64String;
                }
                // Serialize a value, afterwards executing a callback (which usually
                // instructs the `setItem()` callback/promise to be executed). This is how
                // we store binary data with localStorage.
                function serialize(value, callback) {
                    var valueType = '';
                    if (value) valueType = toString$1.call(value);
                    // Cannot use `value instanceof ArrayBuffer` or such here, as these
                    // checks fail when running the tests using casper.js...
                    //
                    // TODO: See why those tests fail and use a better solution.
                    if (value && (valueType === '[object ArrayBuffer]' || value.buffer && toString$1.call(value.buffer) === '[object ArrayBuffer]')) {
                        // Convert binary arrays to a string and prefix the string with
                        // a special marker.
                        var buffer;
                        var marker = SERIALIZED_MARKER;
                        if (value instanceof ArrayBuffer) {
                            buffer = value;
                            marker += TYPE_ARRAYBUFFER;
                        } else {
                            buffer = value.buffer;
                            if (valueType === '[object Int8Array]') marker += TYPE_INT8ARRAY;
                            else if (valueType === '[object Uint8Array]') marker += TYPE_UINT8ARRAY;
                            else if (valueType === '[object Uint8ClampedArray]') marker += TYPE_UINT8CLAMPEDARRAY;
                            else if (valueType === '[object Int16Array]') marker += TYPE_INT16ARRAY;
                            else if (valueType === '[object Uint16Array]') marker += TYPE_UINT16ARRAY;
                            else if (valueType === '[object Int32Array]') marker += TYPE_INT32ARRAY;
                            else if (valueType === '[object Uint32Array]') marker += TYPE_UINT32ARRAY;
                            else if (valueType === '[object Float32Array]') marker += TYPE_FLOAT32ARRAY;
                            else if (valueType === '[object Float64Array]') marker += TYPE_FLOAT64ARRAY;
                            else callback(new Error('Failed to get type for BinaryArray'));
                        }
                        callback(marker + bufferToString(buffer));
                    } else if (valueType === '[object Blob]') {
                        // Conver the blob to a binaryArray and then to a string.
                        var fileReader = new FileReader();
                        fileReader.onload = function() {
                            // Backwards-compatible prefix for the blob type.
                            var str = BLOB_TYPE_PREFIX + value.type + '~' + bufferToString(this.result);
                            callback(SERIALIZED_MARKER + TYPE_BLOB + str);
                        };
                        fileReader.readAsArrayBuffer(value);
                    } else try {
                        callback(JSON.stringify(value));
                    } catch (e) {
                        console.error("Couldn't convert value into a JSON string: ", value);
                        callback(null, e);
                    }
                }
                // Deserialize data we've inserted into a value column/field. We place
                // special markers into our strings to mark them as encoded; this isn't
                // as nice as a meta field, but it's the only sane thing we can do whilst
                // keeping localStorage support intact.
                //
                // Oftentimes this will just deserialize JSON content, but if we have a
                // special marker (SERIALIZED_MARKER, defined above), we will extract
                // some kind of arraybuffer/binary data/typed array out of the string.
                function deserialize(value) {
                    // If we haven't marked this string as being specially serialized (i.e.
                    // something other than serialized JSON), we can just return it and be
                    // done with it.
                    if (value.substring(0, SERIALIZED_MARKER_LENGTH) !== SERIALIZED_MARKER) return JSON.parse(value);
                    // The following code deals with deserializing some kind of Blob or
                    // TypedArray. First we separate out the type of data we're dealing
                    // with from the data itself.
                    var serializedString = value.substring(TYPE_SERIALIZED_MARKER_LENGTH);
                    var type = value.substring(SERIALIZED_MARKER_LENGTH, TYPE_SERIALIZED_MARKER_LENGTH);
                    var blobType;
                    // Backwards-compatible blob type serialization strategy.
                    // DBs created with older versions of localForage will simply not have the blob type.
                    if (type === TYPE_BLOB && BLOB_TYPE_PREFIX_REGEX.test(serializedString)) {
                        var matcher = serializedString.match(BLOB_TYPE_PREFIX_REGEX);
                        blobType = matcher[1];
                        serializedString = serializedString.substring(matcher[0].length);
                    }
                    var buffer = stringToBuffer(serializedString);
                    // Return the right type based on the code/type set during
                    // serialization.
                    switch(type){
                        case TYPE_ARRAYBUFFER:
                            return buffer;
                        case TYPE_BLOB:
                            return createBlob([
                                buffer
                            ], {
                                type: blobType
                            });
                        case TYPE_INT8ARRAY:
                            return new Int8Array(buffer);
                        case TYPE_UINT8ARRAY:
                            return new Uint8Array(buffer);
                        case TYPE_UINT8CLAMPEDARRAY:
                            return new Uint8ClampedArray(buffer);
                        case TYPE_INT16ARRAY:
                            return new Int16Array(buffer);
                        case TYPE_UINT16ARRAY:
                            return new Uint16Array(buffer);
                        case TYPE_INT32ARRAY:
                            return new Int32Array(buffer);
                        case TYPE_UINT32ARRAY:
                            return new Uint32Array(buffer);
                        case TYPE_FLOAT32ARRAY:
                            return new Float32Array(buffer);
                        case TYPE_FLOAT64ARRAY:
                            return new Float64Array(buffer);
                        default:
                            throw new Error('Unkown type: ' + type);
                    }
                }
                var localforageSerializer = {
                    serialize: serialize,
                    deserialize: deserialize,
                    stringToBuffer: stringToBuffer,
                    bufferToString: bufferToString
                };
                /*
 * Includes code from:
 *
 * base64-arraybuffer
 * https://github.com/niklasvh/base64-arraybuffer
 *
 * Copyright (c) 2012 Niklas von Hertzen
 * Licensed under the MIT license.
 */ function createDbTable(t, dbInfo, callback, errorCallback) {
                    t.executeSql('CREATE TABLE IF NOT EXISTS ' + dbInfo.storeName + ' ' + '(id INTEGER PRIMARY KEY, key unique, value)', [], callback, errorCallback);
                }
                // Open the WebSQL database (automatically creates one if one didn't
                // previously exist), using any options set in the config.
                function _initStorage$1(options) {
                    var self1 = this;
                    var dbInfo = {
                        db: null
                    };
                    if (options) for(var i in options)dbInfo[i] = typeof options[i] !== 'string' ? options[i].toString() : options[i];
                    var dbInfoPromise = new Promise$1(function(resolve, reject) {
                        // Open the database; the openDatabase API will automatically
                        // create it for us if it doesn't exist.
                        try {
                            dbInfo.db = openDatabase(dbInfo.name, String(dbInfo.version), dbInfo.description, dbInfo.size);
                        } catch (e) {
                            return reject(e);
                        }
                        // Create our key/value table if it doesn't exist.
                        dbInfo.db.transaction(function(t) {
                            createDbTable(t, dbInfo, function() {
                                self1._dbInfo = dbInfo;
                                resolve();
                            }, function(t, error) {
                                reject(error);
                            });
                        }, reject);
                    });
                    dbInfo.serializer = localforageSerializer;
                    return dbInfoPromise;
                }
                function tryExecuteSql(t, dbInfo, sqlStatement, args, callback, errorCallback) {
                    t.executeSql(sqlStatement, args, callback, function(t, error) {
                        if (error.code === error.SYNTAX_ERR) t.executeSql("SELECT name FROM sqlite_master WHERE type='table' AND name = ?", [
                            dbInfo.storeName
                        ], function(t, results) {
                            if (!results.rows.length) // if the table is missing (was deleted)
                            // re-create it table and retry
                            createDbTable(t, dbInfo, function() {
                                t.executeSql(sqlStatement, args, callback, errorCallback);
                            }, errorCallback);
                            else errorCallback(t, error);
                        }, errorCallback);
                        else errorCallback(t, error);
                    }, errorCallback);
                }
                function getItem$1(key, callback) {
                    var self1 = this;
                    key = normalizeKey(key);
                    var promise = new Promise$1(function(resolve, reject) {
                        self1.ready().then(function() {
                            var dbInfo = self1._dbInfo;
                            dbInfo.db.transaction(function(t) {
                                tryExecuteSql(t, dbInfo, 'SELECT * FROM ' + dbInfo.storeName + ' WHERE key = ? LIMIT 1', [
                                    key
                                ], function(t, results) {
                                    var result = results.rows.length ? results.rows.item(0).value : null;
                                    // Check to see if this is serialized content we need to
                                    // unpack.
                                    if (result) result = dbInfo.serializer.deserialize(result);
                                    resolve(result);
                                }, function(t, error) {
                                    reject(error);
                                });
                            });
                        })["catch"](reject);
                    });
                    executeCallback(promise, callback);
                    return promise;
                }
                function iterate$1(iterator, callback) {
                    var self1 = this;
                    var promise = new Promise$1(function(resolve, reject) {
                        self1.ready().then(function() {
                            var dbInfo = self1._dbInfo;
                            dbInfo.db.transaction(function(t) {
                                tryExecuteSql(t, dbInfo, 'SELECT * FROM ' + dbInfo.storeName, [], function(t, results) {
                                    var rows = results.rows;
                                    var length = rows.length;
                                    for(var i = 0; i < length; i++){
                                        var item = rows.item(i);
                                        var result = item.value;
                                        // Check to see if this is serialized content
                                        // we need to unpack.
                                        if (result) result = dbInfo.serializer.deserialize(result);
                                        result = iterator(result, item.key, i + 1);
                                        // void(0) prevents problems with redefinition
                                        // of `undefined`.
                                        if (result !== void 0) {
                                            resolve(result);
                                            return;
                                        }
                                    }
                                    resolve();
                                }, function(t, error) {
                                    reject(error);
                                });
                            });
                        })["catch"](reject);
                    });
                    executeCallback(promise, callback);
                    return promise;
                }
                function _setItem(key, value, callback, retriesLeft) {
                    var self1 = this;
                    key = normalizeKey(key);
                    var promise = new Promise$1(function(resolve, reject) {
                        self1.ready().then(function() {
                            // The localStorage API doesn't return undefined values in an
                            // "expected" way, so undefined is always cast to null in all
                            // drivers. See: https://github.com/mozilla/localForage/pull/42
                            if (value === undefined) value = null;
                            // Save the original value to pass to the callback.
                            var originalValue = value;
                            var dbInfo = self1._dbInfo;
                            dbInfo.serializer.serialize(value, function(value, error) {
                                if (error) reject(error);
                                else dbInfo.db.transaction(function(t) {
                                    tryExecuteSql(t, dbInfo, 'INSERT OR REPLACE INTO ' + dbInfo.storeName + ' ' + '(key, value) VALUES (?, ?)', [
                                        key,
                                        value
                                    ], function() {
                                        resolve(originalValue);
                                    }, function(t, error) {
                                        reject(error);
                                    });
                                }, function(sqlError) {
                                    // The transaction failed; check
                                    // to see if it's a quota error.
                                    if (sqlError.code === sqlError.QUOTA_ERR) {
                                        // We reject the callback outright for now, but
                                        // it's worth trying to re-run the transaction.
                                        // Even if the user accepts the prompt to use
                                        // more storage on Safari, this error will
                                        // be called.
                                        //
                                        // Try to re-run the transaction.
                                        if (retriesLeft > 0) {
                                            resolve(_setItem.apply(self1, [
                                                key,
                                                originalValue,
                                                callback,
                                                retriesLeft - 1
                                            ]));
                                            return;
                                        }
                                        reject(sqlError);
                                    }
                                });
                            });
                        })["catch"](reject);
                    });
                    executeCallback(promise, callback);
                    return promise;
                }
                function setItem$1(key, value, callback) {
                    return _setItem.apply(this, [
                        key,
                        value,
                        callback,
                        1
                    ]);
                }
                function removeItem$1(key, callback) {
                    var self1 = this;
                    key = normalizeKey(key);
                    var promise = new Promise$1(function(resolve, reject) {
                        self1.ready().then(function() {
                            var dbInfo = self1._dbInfo;
                            dbInfo.db.transaction(function(t) {
                                tryExecuteSql(t, dbInfo, 'DELETE FROM ' + dbInfo.storeName + ' WHERE key = ?', [
                                    key
                                ], function() {
                                    resolve();
                                }, function(t, error) {
                                    reject(error);
                                });
                            });
                        })["catch"](reject);
                    });
                    executeCallback(promise, callback);
                    return promise;
                }
                // Deletes every item in the table.
                // TODO: Find out if this resets the AUTO_INCREMENT number.
                function clear$1(callback) {
                    var self1 = this;
                    var promise = new Promise$1(function(resolve, reject) {
                        self1.ready().then(function() {
                            var dbInfo = self1._dbInfo;
                            dbInfo.db.transaction(function(t) {
                                tryExecuteSql(t, dbInfo, 'DELETE FROM ' + dbInfo.storeName, [], function() {
                                    resolve();
                                }, function(t, error) {
                                    reject(error);
                                });
                            });
                        })["catch"](reject);
                    });
                    executeCallback(promise, callback);
                    return promise;
                }
                // Does a simple `COUNT(key)` to get the number of items stored in
                // localForage.
                function length$1(callback) {
                    var self1 = this;
                    var promise = new Promise$1(function(resolve, reject) {
                        self1.ready().then(function() {
                            var dbInfo = self1._dbInfo;
                            dbInfo.db.transaction(function(t) {
                                // Ahhh, SQL makes this one soooooo easy.
                                tryExecuteSql(t, dbInfo, 'SELECT COUNT(key) as c FROM ' + dbInfo.storeName, [], function(t, results) {
                                    var result = results.rows.item(0).c;
                                    resolve(result);
                                }, function(t, error) {
                                    reject(error);
                                });
                            });
                        })["catch"](reject);
                    });
                    executeCallback(promise, callback);
                    return promise;
                }
                // Return the key located at key index X; essentially gets the key from a
                // `WHERE id = ?`. This is the most efficient way I can think to implement
                // this rarely-used (in my experience) part of the API, but it can seem
                // inconsistent, because we do `INSERT OR REPLACE INTO` on `setItem()`, so
                // the ID of each key will change every time it's updated. Perhaps a stored
                // procedure for the `setItem()` SQL would solve this problem?
                // TODO: Don't change ID on `setItem()`.
                function key$1(n, callback) {
                    var self1 = this;
                    var promise = new Promise$1(function(resolve, reject) {
                        self1.ready().then(function() {
                            var dbInfo = self1._dbInfo;
                            dbInfo.db.transaction(function(t) {
                                tryExecuteSql(t, dbInfo, 'SELECT key FROM ' + dbInfo.storeName + ' WHERE id = ? LIMIT 1', [
                                    n + 1
                                ], function(t, results) {
                                    var result = results.rows.length ? results.rows.item(0).key : null;
                                    resolve(result);
                                }, function(t, error) {
                                    reject(error);
                                });
                            });
                        })["catch"](reject);
                    });
                    executeCallback(promise, callback);
                    return promise;
                }
                function keys$1(callback) {
                    var self1 = this;
                    var promise = new Promise$1(function(resolve, reject) {
                        self1.ready().then(function() {
                            var dbInfo = self1._dbInfo;
                            dbInfo.db.transaction(function(t) {
                                tryExecuteSql(t, dbInfo, 'SELECT key FROM ' + dbInfo.storeName, [], function(t, results) {
                                    var keys = [];
                                    for(var i = 0; i < results.rows.length; i++)keys.push(results.rows.item(i).key);
                                    resolve(keys);
                                }, function(t, error) {
                                    reject(error);
                                });
                            });
                        })["catch"](reject);
                    });
                    executeCallback(promise, callback);
                    return promise;
                }
                // https://www.w3.org/TR/webdatabase/#databases
                // > There is no way to enumerate or delete the databases available for an origin from this API.
                function getAllStoreNames(db) {
                    return new Promise$1(function(resolve, reject) {
                        db.transaction(function(t) {
                            t.executeSql("SELECT name FROM sqlite_master WHERE type='table' AND name <> '__WebKitDatabaseInfoTable__'", [], function(t, results) {
                                var storeNames = [];
                                for(var i = 0; i < results.rows.length; i++)storeNames.push(results.rows.item(i).name);
                                resolve({
                                    db: db,
                                    storeNames: storeNames
                                });
                            }, function(t, error) {
                                reject(error);
                            });
                        }, function(sqlError) {
                            reject(sqlError);
                        });
                    });
                }
                function dropInstance$1(options, callback) {
                    callback = getCallback.apply(this, arguments);
                    var currentConfig = this.config();
                    options = typeof options !== 'function' && options || {};
                    if (!options.name) {
                        options.name = options.name || currentConfig.name;
                        options.storeName = options.storeName || currentConfig.storeName;
                    }
                    var self1 = this;
                    var promise;
                    if (!options.name) promise = Promise$1.reject('Invalid arguments');
                    else promise = new Promise$1(function(resolve) {
                        var db;
                        if (options.name === currentConfig.name) // use the db reference of the current instance
                        db = self1._dbInfo.db;
                        else db = openDatabase(options.name, '', '', 0);
                        if (!options.storeName) // drop all database tables
                        resolve(getAllStoreNames(db));
                        else resolve({
                            db: db,
                            storeNames: [
                                options.storeName
                            ]
                        });
                    }).then(function(operationInfo) {
                        return new Promise$1(function(resolve, reject) {
                            operationInfo.db.transaction(function(t) {
                                function dropTable(storeName) {
                                    return new Promise$1(function(resolve, reject) {
                                        t.executeSql('DROP TABLE IF EXISTS ' + storeName, [], function() {
                                            resolve();
                                        }, function(t, error) {
                                            reject(error);
                                        });
                                    });
                                }
                                var operations = [];
                                for(var i = 0, len = operationInfo.storeNames.length; i < len; i++)operations.push(dropTable(operationInfo.storeNames[i]));
                                Promise$1.all(operations).then(function() {
                                    resolve();
                                })["catch"](function(e) {
                                    reject(e);
                                });
                            }, function(sqlError) {
                                reject(sqlError);
                            });
                        });
                    });
                    executeCallback(promise, callback);
                    return promise;
                }
                var webSQLStorage = {
                    _driver: 'webSQLStorage',
                    _initStorage: _initStorage$1,
                    _support: isWebSQLValid(),
                    iterate: iterate$1,
                    getItem: getItem$1,
                    setItem: setItem$1,
                    removeItem: removeItem$1,
                    clear: clear$1,
                    length: length$1,
                    key: key$1,
                    keys: keys$1,
                    dropInstance: dropInstance$1
                };
                function isLocalStorageValid() {
                    try {
                        return typeof localStorage !== 'undefined' && 'setItem' in localStorage && // in IE8 typeof localStorage.setItem === 'object'
                        !!localStorage.setItem;
                    } catch (e) {
                        return false;
                    }
                }
                function _getKeyPrefix(options, defaultConfig) {
                    var keyPrefix = options.name + '/';
                    if (options.storeName !== defaultConfig.storeName) keyPrefix += options.storeName + '/';
                    return keyPrefix;
                }
                // Check if localStorage throws when saving an item
                function checkIfLocalStorageThrows() {
                    var localStorageTestKey = '_localforage_support_test';
                    try {
                        localStorage.setItem(localStorageTestKey, true);
                        localStorage.removeItem(localStorageTestKey);
                        return false;
                    } catch (e) {
                        return true;
                    }
                }
                // Check if localStorage is usable and allows to save an item
                // This method checks if localStorage is usable in Safari Private Browsing
                // mode, or in any other case where the available quota for localStorage
                // is 0 and there wasn't any saved items yet.
                function _isLocalStorageUsable() {
                    return !checkIfLocalStorageThrows() || localStorage.length > 0;
                }
                // Config the localStorage backend, using options set in the config.
                function _initStorage$2(options) {
                    var self1 = this;
                    var dbInfo = {};
                    if (options) for(var i in options)dbInfo[i] = options[i];
                    dbInfo.keyPrefix = _getKeyPrefix(options, self1._defaultConfig);
                    if (!_isLocalStorageUsable()) return Promise$1.reject();
                    self1._dbInfo = dbInfo;
                    dbInfo.serializer = localforageSerializer;
                    return Promise$1.resolve();
                }
                // Remove all keys from the datastore, effectively destroying all data in
                // the app's key/value store!
                function clear$2(callback) {
                    var self1 = this;
                    var promise = self1.ready().then(function() {
                        var keyPrefix = self1._dbInfo.keyPrefix;
                        for(var i = localStorage.length - 1; i >= 0; i--){
                            var key = localStorage.key(i);
                            if (key.indexOf(keyPrefix) === 0) localStorage.removeItem(key);
                        }
                    });
                    executeCallback(promise, callback);
                    return promise;
                }
                // Retrieve an item from the store. Unlike the original async_storage
                // library in Gaia, we don't modify return values at all. If a key's value
                // is `undefined`, we pass that value to the callback function.
                function getItem$2(key, callback) {
                    var self1 = this;
                    key = normalizeKey(key);
                    var promise = self1.ready().then(function() {
                        var dbInfo = self1._dbInfo;
                        var result = localStorage.getItem(dbInfo.keyPrefix + key);
                        // If a result was found, parse it from the serialized
                        // string into a JS object. If result isn't truthy, the key
                        // is likely undefined and we'll pass it straight to the
                        // callback.
                        if (result) result = dbInfo.serializer.deserialize(result);
                        return result;
                    });
                    executeCallback(promise, callback);
                    return promise;
                }
                // Iterate over all items in the store.
                function iterate$2(iterator, callback) {
                    var self1 = this;
                    var promise = self1.ready().then(function() {
                        var dbInfo = self1._dbInfo;
                        var keyPrefix = dbInfo.keyPrefix;
                        var keyPrefixLength = keyPrefix.length;
                        var length = localStorage.length;
                        // We use a dedicated iterator instead of the `i` variable below
                        // so other keys we fetch in localStorage aren't counted in
                        // the `iterationNumber` argument passed to the `iterate()`
                        // callback.
                        //
                        // See: github.com/mozilla/localForage/pull/435#discussion_r38061530
                        var iterationNumber = 1;
                        for(var i = 0; i < length; i++){
                            var key = localStorage.key(i);
                            if (key.indexOf(keyPrefix) !== 0) continue;
                            var value = localStorage.getItem(key);
                            // If a result was found, parse it from the serialized
                            // string into a JS object. If result isn't truthy, the
                            // key is likely undefined and we'll pass it straight
                            // to the iterator.
                            if (value) value = dbInfo.serializer.deserialize(value);
                            value = iterator(value, key.substring(keyPrefixLength), iterationNumber++);
                            if (value !== void 0) return value;
                        }
                    });
                    executeCallback(promise, callback);
                    return promise;
                }
                // Same as localStorage's key() method, except takes a callback.
                function key$2(n, callback) {
                    var self1 = this;
                    var promise = self1.ready().then(function() {
                        var dbInfo = self1._dbInfo;
                        var result;
                        try {
                            result = localStorage.key(n);
                        } catch (error) {
                            result = null;
                        }
                        // Remove the prefix from the key, if a key is found.
                        if (result) result = result.substring(dbInfo.keyPrefix.length);
                        return result;
                    });
                    executeCallback(promise, callback);
                    return promise;
                }
                function keys$2(callback) {
                    var self1 = this;
                    var promise = self1.ready().then(function() {
                        var dbInfo = self1._dbInfo;
                        var length = localStorage.length;
                        var keys = [];
                        for(var i = 0; i < length; i++){
                            var itemKey = localStorage.key(i);
                            if (itemKey.indexOf(dbInfo.keyPrefix) === 0) keys.push(itemKey.substring(dbInfo.keyPrefix.length));
                        }
                        return keys;
                    });
                    executeCallback(promise, callback);
                    return promise;
                }
                // Supply the number of keys in the datastore to the callback function.
                function length$2(callback) {
                    var self1 = this;
                    var promise = self1.keys().then(function(keys) {
                        return keys.length;
                    });
                    executeCallback(promise, callback);
                    return promise;
                }
                // Remove an item from the store, nice and simple.
                function removeItem$2(key, callback) {
                    var self1 = this;
                    key = normalizeKey(key);
                    var promise = self1.ready().then(function() {
                        var dbInfo = self1._dbInfo;
                        localStorage.removeItem(dbInfo.keyPrefix + key);
                    });
                    executeCallback(promise, callback);
                    return promise;
                }
                // Set a key's value and run an optional callback once the value is set.
                // Unlike Gaia's implementation, the callback function is passed the value,
                // in case you want to operate on that value only after you're sure it
                // saved, or something like that.
                function setItem$2(key, value, callback) {
                    var self1 = this;
                    key = normalizeKey(key);
                    var promise = self1.ready().then(function() {
                        // Convert undefined values to null.
                        // https://github.com/mozilla/localForage/pull/42
                        if (value === undefined) value = null;
                        // Save the original value to pass to the callback.
                        var originalValue = value;
                        return new Promise$1(function(resolve, reject) {
                            var dbInfo = self1._dbInfo;
                            dbInfo.serializer.serialize(value, function(value, error) {
                                if (error) reject(error);
                                else try {
                                    localStorage.setItem(dbInfo.keyPrefix + key, value);
                                    resolve(originalValue);
                                } catch (e) {
                                    // localStorage capacity exceeded.
                                    // TODO: Make this a specific error/event.
                                    if (e.name === 'QuotaExceededError' || e.name === 'NS_ERROR_DOM_QUOTA_REACHED') reject(e);
                                    reject(e);
                                }
                            });
                        });
                    });
                    executeCallback(promise, callback);
                    return promise;
                }
                function dropInstance$2(options, callback) {
                    callback = getCallback.apply(this, arguments);
                    options = typeof options !== 'function' && options || {};
                    if (!options.name) {
                        var currentConfig = this.config();
                        options.name = options.name || currentConfig.name;
                        options.storeName = options.storeName || currentConfig.storeName;
                    }
                    var self1 = this;
                    var promise;
                    if (!options.name) promise = Promise$1.reject('Invalid arguments');
                    else promise = new Promise$1(function(resolve) {
                        if (!options.storeName) resolve(options.name + '/');
                        else resolve(_getKeyPrefix(options, self1._defaultConfig));
                    }).then(function(keyPrefix) {
                        for(var i = localStorage.length - 1; i >= 0; i--){
                            var key = localStorage.key(i);
                            if (key.indexOf(keyPrefix) === 0) localStorage.removeItem(key);
                        }
                    });
                    executeCallback(promise, callback);
                    return promise;
                }
                var localStorageWrapper = {
                    _driver: 'localStorageWrapper',
                    _initStorage: _initStorage$2,
                    _support: isLocalStorageValid(),
                    iterate: iterate$2,
                    getItem: getItem$2,
                    setItem: setItem$2,
                    removeItem: removeItem$2,
                    clear: clear$2,
                    length: length$2,
                    key: key$2,
                    keys: keys$2,
                    dropInstance: dropInstance$2
                };
                var sameValue = function sameValue(x, y) {
                    return x === y || typeof x === 'number' && typeof y === 'number' && isNaN(x) && isNaN(y);
                };
                var includes = function includes(array, searchElement) {
                    var len = array.length;
                    var i = 0;
                    while(i < len){
                        if (sameValue(array[i], searchElement)) return true;
                        i++;
                    }
                    return false;
                };
                var isArray = Array.isArray || function(arg) {
                    return Object.prototype.toString.call(arg) === '[object Array]';
                };
                // Drivers are stored here when `defineDriver()` is called.
                // They are shared across all instances of localForage.
                var DefinedDrivers = {};
                var DriverSupport = {};
                var DefaultDrivers = {
                    INDEXEDDB: asyncStorage,
                    WEBSQL: webSQLStorage,
                    LOCALSTORAGE: localStorageWrapper
                };
                var DefaultDriverOrder = [
                    DefaultDrivers.INDEXEDDB._driver,
                    DefaultDrivers.WEBSQL._driver,
                    DefaultDrivers.LOCALSTORAGE._driver
                ];
                var OptionalDriverMethods = [
                    'dropInstance'
                ];
                var LibraryMethods = [
                    'clear',
                    'getItem',
                    'iterate',
                    'key',
                    'keys',
                    'length',
                    'removeItem',
                    'setItem'
                ].concat(OptionalDriverMethods);
                var DefaultConfig = {
                    description: '',
                    driver: DefaultDriverOrder.slice(),
                    name: 'localforage',
                    // Default DB size is _JUST UNDER_ 5MB, as it's the highest size
                    // we can use without a prompt.
                    size: 4980736,
                    storeName: 'keyvaluepairs',
                    version: 1.0
                };
                function callWhenReady(localForageInstance, libraryMethod) {
                    localForageInstance[libraryMethod] = function() {
                        var _args = arguments;
                        return localForageInstance.ready().then(function() {
                            return localForageInstance[libraryMethod].apply(localForageInstance, _args);
                        });
                    };
                }
                function extend() {
                    for(var i = 1; i < arguments.length; i++){
                        var arg = arguments[i];
                        if (arg) {
                            for(var _key in arg)if (arg.hasOwnProperty(_key)) {
                                if (isArray(arg[_key])) arguments[0][_key] = arg[_key].slice();
                                else arguments[0][_key] = arg[_key];
                            }
                        }
                    }
                    return arguments[0];
                }
                var LocalForage = function() {
                    function LocalForage(options) {
                        _classCallCheck(this, LocalForage);
                        for(var driverTypeKey in DefaultDrivers)if (DefaultDrivers.hasOwnProperty(driverTypeKey)) {
                            var driver = DefaultDrivers[driverTypeKey];
                            var driverName = driver._driver;
                            this[driverTypeKey] = driverName;
                            if (!DefinedDrivers[driverName]) // we don't need to wait for the promise,
                            // since the default drivers can be defined
                            // in a blocking manner
                            this.defineDriver(driver);
                        }
                        this._defaultConfig = extend({}, DefaultConfig);
                        this._config = extend({}, this._defaultConfig, options);
                        this._driverSet = null;
                        this._initDriver = null;
                        this._ready = false;
                        this._dbInfo = null;
                        this._wrapLibraryMethodsWithReady();
                        this.setDriver(this._config.driver)["catch"](function() {});
                    }
                    // Set any config values for localForage; can be called anytime before
                    // the first API call (e.g. `getItem`, `setItem`).
                    // We loop through options so we don't overwrite existing config
                    // values.
                    LocalForage.prototype.config = function config(options) {
                        // If the options argument is an object, we use it to set values.
                        // Otherwise, we return either a specified config value or all
                        // config values.
                        if ((typeof options === 'undefined' ? 'undefined' : _typeof(options)) === 'object') {
                            // If localforage is ready and fully initialized, we can't set
                            // any new configuration values. Instead, we return an error.
                            if (this._ready) return new Error("Can't call config() after localforage has been used.");
                            for(var i in options){
                                if (i === 'storeName') options[i] = options[i].replace(/\W/g, '_');
                                if (i === 'version' && typeof options[i] !== 'number') return new Error('Database version must be a number.');
                                this._config[i] = options[i];
                            }
                            // after all config options are set and
                            // the driver option is used, try setting it
                            if ('driver' in options && options.driver) return this.setDriver(this._config.driver);
                            return true;
                        } else if (typeof options === 'string') return this._config[options];
                        else return this._config;
                    };
                    // Used to define a custom driver, shared across all instances of
                    // localForage.
                    LocalForage.prototype.defineDriver = function defineDriver(driverObject, callback, errorCallback) {
                        var promise = new Promise$1(function(resolve, reject) {
                            try {
                                var driverName = driverObject._driver;
                                var complianceError = new Error("Custom driver not compliant; see https://mozilla.github.io/localForage/#definedriver");
                                // A driver name should be defined and not overlap with the
                                // library-defined, default drivers.
                                if (!driverObject._driver) {
                                    reject(complianceError);
                                    return;
                                }
                                var driverMethods = LibraryMethods.concat('_initStorage');
                                for(var i = 0, len = driverMethods.length; i < len; i++){
                                    var driverMethodName = driverMethods[i];
                                    // when the property is there,
                                    // it should be a method even when optional
                                    var isRequired = !includes(OptionalDriverMethods, driverMethodName);
                                    if ((isRequired || driverObject[driverMethodName]) && typeof driverObject[driverMethodName] !== 'function') {
                                        reject(complianceError);
                                        return;
                                    }
                                }
                                var configureMissingMethods = function configureMissingMethods() {
                                    var methodNotImplementedFactory = function methodNotImplementedFactory(methodName) {
                                        return function() {
                                            var error = new Error('Method ' + methodName + ' is not implemented by the current driver');
                                            var promise = Promise$1.reject(error);
                                            executeCallback(promise, arguments[arguments.length - 1]);
                                            return promise;
                                        };
                                    };
                                    for(var _i = 0, _len = OptionalDriverMethods.length; _i < _len; _i++){
                                        var optionalDriverMethod = OptionalDriverMethods[_i];
                                        if (!driverObject[optionalDriverMethod]) driverObject[optionalDriverMethod] = methodNotImplementedFactory(optionalDriverMethod);
                                    }
                                };
                                configureMissingMethods();
                                var setDriverSupport = function setDriverSupport(support) {
                                    if (DefinedDrivers[driverName]) console.info('Redefining LocalForage driver: ' + driverName);
                                    DefinedDrivers[driverName] = driverObject;
                                    DriverSupport[driverName] = support;
                                    // don't use a then, so that we can define
                                    // drivers that have simple _support methods
                                    // in a blocking manner
                                    resolve();
                                };
                                if ('_support' in driverObject) {
                                    if (driverObject._support && typeof driverObject._support === 'function') driverObject._support().then(setDriverSupport, reject);
                                    else setDriverSupport(!!driverObject._support);
                                } else setDriverSupport(true);
                            } catch (e) {
                                reject(e);
                            }
                        });
                        executeTwoCallbacks(promise, callback, errorCallback);
                        return promise;
                    };
                    LocalForage.prototype.driver = function driver() {
                        return this._driver || null;
                    };
                    LocalForage.prototype.getDriver = function getDriver(driverName, callback, errorCallback) {
                        var getDriverPromise = DefinedDrivers[driverName] ? Promise$1.resolve(DefinedDrivers[driverName]) : Promise$1.reject(new Error('Driver not found.'));
                        executeTwoCallbacks(getDriverPromise, callback, errorCallback);
                        return getDriverPromise;
                    };
                    LocalForage.prototype.getSerializer = function getSerializer(callback) {
                        var serializerPromise = Promise$1.resolve(localforageSerializer);
                        executeTwoCallbacks(serializerPromise, callback);
                        return serializerPromise;
                    };
                    LocalForage.prototype.ready = function ready(callback) {
                        var self1 = this;
                        var promise = self1._driverSet.then(function() {
                            if (self1._ready === null) self1._ready = self1._initDriver();
                            return self1._ready;
                        });
                        executeTwoCallbacks(promise, callback, callback);
                        return promise;
                    };
                    LocalForage.prototype.setDriver = function setDriver(drivers, callback, errorCallback) {
                        var self1 = this;
                        if (!isArray(drivers)) drivers = [
                            drivers
                        ];
                        var supportedDrivers = this._getSupportedDrivers(drivers);
                        function setDriverToConfig() {
                            self1._config.driver = self1.driver();
                        }
                        function extendSelfWithDriver(driver) {
                            self1._extend(driver);
                            setDriverToConfig();
                            self1._ready = self1._initStorage(self1._config);
                            return self1._ready;
                        }
                        function initDriver(supportedDrivers) {
                            return function() {
                                var currentDriverIndex = 0;
                                function driverPromiseLoop() {
                                    while(currentDriverIndex < supportedDrivers.length){
                                        var driverName = supportedDrivers[currentDriverIndex];
                                        currentDriverIndex++;
                                        self1._dbInfo = null;
                                        self1._ready = null;
                                        return self1.getDriver(driverName).then(extendSelfWithDriver)["catch"](driverPromiseLoop);
                                    }
                                    setDriverToConfig();
                                    var error = new Error('No available storage method found.');
                                    self1._driverSet = Promise$1.reject(error);
                                    return self1._driverSet;
                                }
                                return driverPromiseLoop();
                            };
                        }
                        // There might be a driver initialization in progress
                        // so wait for it to finish in order to avoid a possible
                        // race condition to set _dbInfo
                        var oldDriverSetDone = this._driverSet !== null ? this._driverSet["catch"](function() {
                            return Promise$1.resolve();
                        }) : Promise$1.resolve();
                        this._driverSet = oldDriverSetDone.then(function() {
                            var driverName = supportedDrivers[0];
                            self1._dbInfo = null;
                            self1._ready = null;
                            return self1.getDriver(driverName).then(function(driver) {
                                self1._driver = driver._driver;
                                setDriverToConfig();
                                self1._wrapLibraryMethodsWithReady();
                                self1._initDriver = initDriver(supportedDrivers);
                            });
                        })["catch"](function() {
                            setDriverToConfig();
                            var error = new Error('No available storage method found.');
                            self1._driverSet = Promise$1.reject(error);
                            return self1._driverSet;
                        });
                        executeTwoCallbacks(this._driverSet, callback, errorCallback);
                        return this._driverSet;
                    };
                    LocalForage.prototype.supports = function supports(driverName) {
                        return !!DriverSupport[driverName];
                    };
                    LocalForage.prototype._extend = function _extend(libraryMethodsAndProperties) {
                        extend(this, libraryMethodsAndProperties);
                    };
                    LocalForage.prototype._getSupportedDrivers = function _getSupportedDrivers(drivers) {
                        var supportedDrivers = [];
                        for(var i = 0, len = drivers.length; i < len; i++){
                            var driverName = drivers[i];
                            if (this.supports(driverName)) supportedDrivers.push(driverName);
                        }
                        return supportedDrivers;
                    };
                    LocalForage.prototype._wrapLibraryMethodsWithReady = function _wrapLibraryMethodsWithReady() {
                        // Add a stub for each driver API method that delays the call to the
                        // corresponding driver method until localForage is ready. These stubs
                        // will be replaced by the driver methods as soon as the driver is
                        // loaded, so there is no performance impact.
                        for(var i = 0, len = LibraryMethods.length; i < len; i++)callWhenReady(this, LibraryMethods[i]);
                    };
                    LocalForage.prototype.createInstance = function createInstance(options) {
                        return new LocalForage(options);
                    };
                    return LocalForage;
                }();
                // The actual localForage object that we expose as a module or via a
                // global. It's extended by pulling in one of our other libraries.
                var localforage_js = new LocalForage();
                module1.exports = localforage_js;
            },
            {
                "3": 3
            }
        ]
    }, {}, [
        4
    ])(4);
});

},{}],"iDjHW":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "ReportingObserver", ()=>ReportingObserver);
var _tslib = require("tslib");
var _utils = require("@sentry/utils");
/** Reporting API integration - https://w3c.github.io/reporting/ */ var ReportingObserver = /** @class */ function() {
    /**
     * @inheritDoc
     */ function ReportingObserver(_options) {
        if (_options === void 0) _options = {
            types: [
                'crash',
                'deprecation',
                'intervention'
            ]
        };
        this._options = _options;
        /**
         * @inheritDoc
         */ this.name = ReportingObserver.id;
    }
    /**
     * @inheritDoc
     */ ReportingObserver.prototype.setupOnce = function(_, getCurrentHub) {
        if (!(0, _utils.supportsReportingObserver)()) return;
        this._getCurrentHub = getCurrentHub;
        // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access, @typescript-eslint/no-explicit-any
        var observer = new ((0, _utils.getGlobalObject)()).ReportingObserver(this.handler.bind(this), {
            buffered: true,
            types: this._options.types
        });
        // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access
        observer.observe();
    };
    /**
     * @inheritDoc
     */ ReportingObserver.prototype.handler = function(reports) {
        var e_1, _a;
        var hub = this._getCurrentHub && this._getCurrentHub();
        if (!hub || !hub.getIntegration(ReportingObserver)) return;
        var _loop_1 = function(report) {
            hub.withScope(function(scope) {
                scope.setExtra('url', report.url);
                var label = "ReportingObserver [" + report.type + "]";
                var details = 'No details available';
                if (report.body) {
                    // Object.keys doesn't work on ReportBody, as all properties are inheirted
                    var plainBody = {};
                    // eslint-disable-next-line guard-for-in
                    for(var prop in report.body)plainBody[prop] = report.body[prop];
                    scope.setExtra('body', plainBody);
                    if (report.type === 'crash') {
                        var body = report.body;
                        // A fancy way to create a message out of crashId OR reason OR both OR fallback
                        details = [
                            body.crashId || '',
                            body.reason || ''
                        ].join(' ').trim() || details;
                    } else {
                        var body = report.body;
                        details = body.message || details;
                    }
                }
                hub.captureMessage(label + ": " + details);
            });
        };
        try {
            for(var reports_1 = (0, _tslib.__values)(reports), reports_1_1 = reports_1.next(); !reports_1_1.done; reports_1_1 = reports_1.next()){
                var report = reports_1_1.value;
                _loop_1(report);
            }
        } catch (e_1_1) {
            e_1 = {
                error: e_1_1
            };
        } finally{
            try {
                if (reports_1_1 && !reports_1_1.done && (_a = reports_1.return)) _a.call(reports_1);
            } finally{
                if (e_1) throw e_1.error;
            }
        }
    };
    /**
     * @inheritDoc
     */ ReportingObserver.id = 'ReportingObserver';
    return ReportingObserver;
}();

},{"tslib":"6MhhU","@sentry/utils":"agmfj","@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"j0Fpn":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "RewriteFrames", ()=>RewriteFrames);
var _tslib = require("tslib");
var _utils = require("@sentry/utils");
/** Rewrite event frames paths */ var RewriteFrames = /** @class */ function() {
    /**
     * @inheritDoc
     */ function RewriteFrames(options) {
        var _this = this;
        if (options === void 0) options = {};
        /**
         * @inheritDoc
         */ this.name = RewriteFrames.id;
        /**
         * @inheritDoc
         */ this._prefix = 'app:///';
        /**
         * @inheritDoc
         */ this._iteratee = function(frame) {
            if (!frame.filename) return frame;
            // Check if the frame filename begins with `/` or a Windows-style prefix such as `C:\`
            var isWindowsFrame = /^[A-Z]:\\/.test(frame.filename);
            var startsWithSlash = /^\//.test(frame.filename);
            if (isWindowsFrame || startsWithSlash) {
                var filename = isWindowsFrame ? frame.filename.replace(/^[A-Z]:/, '') // remove Windows-style prefix
                .replace(/\\/g, '/') // replace all `\\` instances with `/`
                 : frame.filename;
                var base = _this._root ? (0, _utils.relative)(_this._root, filename) : (0, _utils.basename)(filename);
                frame.filename = "" + _this._prefix + base;
            }
            return frame;
        };
        if (options.root) this._root = options.root;
        if (options.prefix) this._prefix = options.prefix;
        if (options.iteratee) this._iteratee = options.iteratee;
    }
    /**
     * @inheritDoc
     */ RewriteFrames.prototype.setupOnce = function(addGlobalEventProcessor, getCurrentHub) {
        addGlobalEventProcessor(function(event) {
            var self = getCurrentHub().getIntegration(RewriteFrames);
            if (self) return self.process(event);
            return event;
        });
    };
    /** JSDoc */ RewriteFrames.prototype.process = function(originalEvent) {
        var processedEvent = originalEvent;
        if (originalEvent.exception && Array.isArray(originalEvent.exception.values)) processedEvent = this._processExceptionsEvent(processedEvent);
        if (originalEvent.stacktrace) processedEvent = this._processStacktraceEvent(processedEvent);
        return processedEvent;
    };
    /** JSDoc */ RewriteFrames.prototype._processExceptionsEvent = function(event) {
        var _this = this;
        try {
            return (0, _tslib.__assign)((0, _tslib.__assign)({}, event), {
                exception: (0, _tslib.__assign)((0, _tslib.__assign)({}, event.exception), {
                    // The check for this is performed inside `process` call itself, safe to skip here
                    // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
                    values: event.exception.values.map(function(value) {
                        return (0, _tslib.__assign)((0, _tslib.__assign)({}, value), {
                            stacktrace: _this._processStacktrace(value.stacktrace)
                        });
                    })
                })
            });
        } catch (_oO) {
            return event;
        }
    };
    /** JSDoc */ RewriteFrames.prototype._processStacktraceEvent = function(event) {
        try {
            return (0, _tslib.__assign)((0, _tslib.__assign)({}, event), {
                stacktrace: this._processStacktrace(event.stacktrace)
            });
        } catch (_oO) {
            return event;
        }
    };
    /** JSDoc */ RewriteFrames.prototype._processStacktrace = function(stacktrace) {
        var _this = this;
        return (0, _tslib.__assign)((0, _tslib.__assign)({}, stacktrace), {
            frames: stacktrace && stacktrace.frames && stacktrace.frames.map(function(f) {
                return _this._iteratee(f);
            })
        });
    };
    /**
     * @inheritDoc
     */ RewriteFrames.id = 'RewriteFrames';
    return RewriteFrames;
}();

},{"tslib":"6MhhU","@sentry/utils":"agmfj","@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"7WJ3R":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "SessionTiming", ()=>SessionTiming);
var _tslib = require("tslib");
/** This function adds duration since Sentry was initialized till the time event was sent */ var SessionTiming = /** @class */ function() {
    function SessionTiming() {
        /**
         * @inheritDoc
         */ this.name = SessionTiming.id;
        /** Exact time Client was initialized expressed in milliseconds since Unix Epoch. */ this._startTime = Date.now();
    }
    /**
     * @inheritDoc
     */ SessionTiming.prototype.setupOnce = function(addGlobalEventProcessor, getCurrentHub) {
        addGlobalEventProcessor(function(event) {
            var self = getCurrentHub().getIntegration(SessionTiming);
            if (self) return self.process(event);
            return event;
        });
    };
    /**
     * @inheritDoc
     */ SessionTiming.prototype.process = function(event) {
        var _a;
        var now = Date.now();
        return (0, _tslib.__assign)((0, _tslib.__assign)({}, event), {
            extra: (0, _tslib.__assign)((0, _tslib.__assign)({}, event.extra), (_a = {}, _a['session:start'] = this._startTime, _a['session:duration'] = now - this._startTime, _a['session:end'] = now, _a))
        });
    };
    /**
     * @inheritDoc
     */ SessionTiming.id = 'SessionTiming';
    return SessionTiming;
}();

},{"tslib":"6MhhU","@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"irfOu":[function(require,module,exports,__globalThis) {
/** Add node transaction to the event */ var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "Transaction", ()=>Transaction);
var Transaction = /** @class */ function() {
    function Transaction() {
        /**
         * @inheritDoc
         */ this.name = Transaction.id;
    }
    /**
     * @inheritDoc
     */ Transaction.prototype.setupOnce = function(addGlobalEventProcessor, getCurrentHub) {
        addGlobalEventProcessor(function(event) {
            var self = getCurrentHub().getIntegration(Transaction);
            if (self) return self.process(event);
            return event;
        });
    };
    /**
     * @inheritDoc
     */ Transaction.prototype.process = function(event) {
        var frames = this._getFramesFromEvent(event);
        // use for loop so we don't have to reverse whole frames array
        for(var i = frames.length - 1; i >= 0; i--){
            var frame = frames[i];
            if (frame.in_app === true) {
                event.transaction = this._getTransaction(frame);
                break;
            }
        }
        return event;
    };
    /** JSDoc */ Transaction.prototype._getFramesFromEvent = function(event) {
        var exception = event.exception && event.exception.values && event.exception.values[0];
        return exception && exception.stacktrace && exception.stacktrace.frames || [];
    };
    /** JSDoc */ Transaction.prototype._getTransaction = function(frame) {
        return frame.module || frame.function ? (frame.module || '?') + "/" + (frame.function || '?') : '<unknown>';
    };
    /**
     * @inheritDoc
     */ Transaction.id = 'Transaction';
    return Transaction;
}();

},{"@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"4MQaV":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "Vue", ()=>Vue);
/** Grabs active transaction off scope */ parcelHelpers.export(exports, "getActiveTransaction", ()=>getActiveTransaction);
var _tslib = require("tslib");
var _utils = require("@sentry/utils");
var _flags = require("./flags");
/**
 * Used to extract Tracing integration from the current client,
 * without the need to import `Tracing` itself from the @sentry/apm package.
 * @deprecated as @sentry/tracing should be used over @sentry/apm.
 */ var TRACING_GETTER = {
    id: 'Tracing'
};
/**
 * Used to extract BrowserTracing integration from @sentry/tracing
 */ var BROWSER_TRACING_GETTER = {
    id: 'BrowserTracing'
};
var VUE_OP = 'ui.vue';
// Mappings from operation to corresponding lifecycle hook.
var HOOKS = {
    activate: [
        'activated',
        'deactivated'
    ],
    create: [
        'beforeCreate',
        'created'
    ],
    destroy: [
        'beforeDestroy',
        'destroyed'
    ],
    mount: [
        'beforeMount',
        'mounted'
    ],
    update: [
        'beforeUpdate',
        'updated'
    ]
};
var COMPONENT_NAME_REGEXP = /(?:^|[-_/])(\w)/g;
var ROOT_COMPONENT_NAME = 'root';
var ANONYMOUS_COMPONENT_NAME = 'anonymous component';
/** JSDoc */ var Vue = /** @class */ function() {
    /**
     * @inheritDoc
     */ function Vue(options) {
        var _this = this;
        /**
         * @inheritDoc
         */ this.name = Vue.id;
        /**
         * Cache holding already processed component names
         */ this._componentsCache = {};
        /** Keep it as attribute function, to keep correct `this` binding inside the hooks callbacks  */ // eslint-disable-next-line @typescript-eslint/typedef
        this._applyTracingHooks = function(vm, getCurrentHub) {
            // Don't attach twice, just in case
            if (vm.$options.$_sentryPerfHook) return;
            vm.$options.$_sentryPerfHook = true;
            var name = _this._getComponentName(vm);
            var rootMount = name === ROOT_COMPONENT_NAME;
            var spans = {};
            // Render hook starts after once event is emitted,
            // but it ends before the second event of the same type.
            //
            // Because of this, we start measuring inside the first event,
            // but finish it before it triggers, to skip the event emitter timing itself.
            var rootHandler = function(hook) {
                var now = (0, _utils.timestampWithMs)();
                // On the first handler call (before), it'll be undefined, as `$once` will add it in the future.
                // However, on the second call (after), it'll be already in place.
                if (_this._rootSpan) _this._finishRootSpan(now, getCurrentHub);
                else vm.$once("hook:" + hook, function() {
                    // Create an activity on the first event call. There'll be no second call, as rootSpan will be in place,
                    // thus new event handler won't be attached.
                    // We do this whole dance with `TRACING_GETTER` to prevent `@sentry/apm` from becoming a peerDependency.
                    // We also need to ask for the `.constructor`, as `pushActivity` and `popActivity` are static, not instance methods.
                    /* eslint-disable @typescript-eslint/no-unsafe-member-access */ // eslint-disable-next-line deprecation/deprecation
                    var tracingIntegration = getCurrentHub().getIntegration(TRACING_GETTER);
                    if (tracingIntegration) {
                        _this._tracingActivity = tracingIntegration.constructor.pushActivity('Vue Application Render');
                        var transaction = tracingIntegration.constructor.getTransaction();
                        if (transaction) _this._rootSpan = transaction.startChild({
                            description: 'Application Render',
                            op: VUE_OP
                        });
                    // Use functionality from @sentry/tracing
                    } else {
                        var activeTransaction = getActiveTransaction(getCurrentHub());
                        if (activeTransaction) _this._rootSpan = activeTransaction.startChild({
                            description: 'Application Render',
                            op: VUE_OP
                        });
                    }
                /* eslint-enable @typescript-eslint/no-unsafe-member-access */ });
            };
            var childHandler = function(hook, operation) {
                // Skip components that we don't want to track to minimize the noise and give a more granular control to the user
                var shouldTrack = Array.isArray(_this._options.tracingOptions.trackComponents) ? _this._options.tracingOptions.trackComponents.indexOf(name) > -1 : _this._options.tracingOptions.trackComponents;
                if (!_this._rootSpan || !shouldTrack) return;
                var now = (0, _utils.timestampWithMs)();
                var span = spans[operation];
                // On the first handler call (before), it'll be undefined, as `$once` will add it in the future.
                // However, on the second call (after), it'll be already in place.
                if (span) {
                    span.finish();
                    _this._finishRootSpan(now, getCurrentHub);
                } else vm.$once("hook:" + hook, function() {
                    if (_this._rootSpan) spans[operation] = _this._rootSpan.startChild({
                        description: "Vue <" + name + ">",
                        op: VUE_OP + "." + operation
                    });
                });
            };
            // Each component has it's own scope, so all activities are only related to one of them
            _this._options.tracingOptions.hooks.forEach(function(operation) {
                // Retrieve corresponding hooks from Vue lifecycle.
                // eg. mount => ['beforeMount', 'mounted']
                var internalHooks = HOOKS[operation];
                if (!internalHooks) {
                    (0, _flags.IS_DEBUG_BUILD) && (0, _utils.logger).warn("Unknown hook: " + operation);
                    return;
                }
                internalHooks.forEach(function(internalHook) {
                    var handler = rootMount ? rootHandler.bind(_this, internalHook) : childHandler.bind(_this, internalHook, operation);
                    var currentValue = vm.$options[internalHook];
                    if (Array.isArray(currentValue)) vm.$options[internalHook] = (0, _tslib.__spread)([
                        handler
                    ], currentValue);
                    else if (typeof currentValue === 'function') vm.$options[internalHook] = [
                        handler,
                        currentValue
                    ];
                    else vm.$options[internalHook] = [
                        handler
                    ];
                });
            });
        };
        (0, _flags.IS_DEBUG_BUILD) && (0, _utils.logger).log('You are still using the Vue.js integration, consider moving to @sentry/vue');
        this._options = (0, _tslib.__assign)((0, _tslib.__assign)({
            // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access
            Vue: (0, _utils.getGlobalObject)().Vue,
            attachProps: true,
            logErrors: false,
            tracing: false
        }, options), {
            tracingOptions: (0, _tslib.__assign)({
                hooks: [
                    'mount',
                    'update'
                ],
                timeout: 2000,
                trackComponents: false
            }, options.tracingOptions)
        });
    }
    /**
     * @inheritDoc
     */ Vue.prototype.setupOnce = function(_, getCurrentHub) {
        if (!this._options.Vue) {
            (0, _flags.IS_DEBUG_BUILD) && (0, _utils.logger).error('Vue integration is missing a Vue instance');
            return;
        }
        this._attachErrorHandler(getCurrentHub);
        if (this._options.tracing) this._startTracing(getCurrentHub);
    };
    /**
     * Extract component name from the ViewModel
     */ Vue.prototype._getComponentName = function(vm) {
        // Such level of granularity is most likely not necessary, but better safe than sorry. — Kamil
        if (!vm) return ANONYMOUS_COMPONENT_NAME;
        if (vm.$root === vm) return ROOT_COMPONENT_NAME;
        if (!vm.$options) return ANONYMOUS_COMPONENT_NAME;
        if (vm.$options.name) return vm.$options.name;
        if (vm.$options._componentTag) return vm.$options._componentTag;
        // injected by vue-loader
        if (vm.$options.__file) {
            var unifiedFile = vm.$options.__file.replace(/^[a-zA-Z]:/, '').replace(/\\/g, '/');
            var filename = (0, _utils.basename)(unifiedFile, '.vue');
            return this._componentsCache[filename] || (this._componentsCache[filename] = filename.replace(COMPONENT_NAME_REGEXP, function(_, c) {
                return c ? c.toUpperCase() : '';
            }));
        }
        return ANONYMOUS_COMPONENT_NAME;
    };
    /** Finish top-level span and activity with a debounce configured using `timeout` option */ Vue.prototype._finishRootSpan = function(timestamp, getCurrentHub) {
        var _this = this;
        if (this._rootSpanTimer) clearTimeout(this._rootSpanTimer);
        this._rootSpanTimer = setTimeout(function() {
            if (_this._tracingActivity) {
                // We do this whole dance with `TRACING_GETTER` to prevent `@sentry/apm` from becoming a peerDependency.
                // We also need to ask for the `.constructor`, as `pushActivity` and `popActivity` are static, not instance methods.
                // eslint-disable-next-line deprecation/deprecation
                var tracingIntegration = getCurrentHub().getIntegration(TRACING_GETTER);
                if (tracingIntegration) // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access
                tracingIntegration.constructor.popActivity(_this._tracingActivity);
            }
            // We should always finish the span, only should pop activity if using @sentry/apm
            if (_this._rootSpan) _this._rootSpan.finish(timestamp);
        }, this._options.tracingOptions.timeout);
    };
    /** Inject configured tracing hooks into Vue's component lifecycles */ Vue.prototype._startTracing = function(getCurrentHub) {
        var applyTracingHooks = this._applyTracingHooks;
        this._options.Vue.mixin({
            beforeCreate: function() {
                // eslint-disable-next-line deprecation/deprecation
                if (getCurrentHub().getIntegration(TRACING_GETTER) || getCurrentHub().getIntegration(BROWSER_TRACING_GETTER)) // `this` points to currently rendered component
                applyTracingHooks(this, getCurrentHub);
                else (0, _flags.IS_DEBUG_BUILD) && (0, _utils.logger).error('Vue integration has tracing enabled, but Tracing integration is not configured');
            }
        });
    };
    /** Inject Sentry's handler into owns Vue's error handler  */ Vue.prototype._attachErrorHandler = function(getCurrentHub) {
        var _this = this;
        // eslint-disable-next-line @typescript-eslint/unbound-method
        var currentErrorHandler = this._options.Vue.config.errorHandler;
        this._options.Vue.config.errorHandler = function(error, vm, info) {
            var metadata = {};
            if (vm) try {
                metadata.componentName = _this._getComponentName(vm);
                if (_this._options.attachProps) metadata.propsData = vm.$options.propsData;
            } catch (_oO) {
                (0, _flags.IS_DEBUG_BUILD) && (0, _utils.logger).warn('Unable to extract metadata from Vue component.');
            }
            if (info) metadata.lifecycleHook = info;
            if (getCurrentHub().getIntegration(Vue)) // Capture exception in the next event loop, to make sure that all breadcrumbs are recorded in time.
            setTimeout(function() {
                getCurrentHub().withScope(function(scope) {
                    scope.setContext('vue', metadata);
                    getCurrentHub().captureException(error);
                });
            });
            if (typeof currentErrorHandler === 'function') currentErrorHandler.call(_this._options.Vue, error, vm, info);
            if (_this._options.logErrors) {
                if (_this._options.Vue.util) _this._options.Vue.util.warn("Error in " + info + ": \"" + (error && error.toString()) + "\"", vm);
                // eslint-disable-next-line no-console
                console.error(error);
            }
        };
    };
    /**
     * @inheritDoc
     */ Vue.id = 'Vue';
    return Vue;
}();
function getActiveTransaction(hub) {
    if (hub && hub.getScope) {
        var scope = hub.getScope();
        if (scope) return scope.getTransaction();
    }
    return undefined;
}

},{"tslib":"6MhhU","@sentry/utils":"agmfj","./flags":"9Knv0","@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"hez9K":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "initialiseErrorAnalyticsClient", ()=>initialiseErrorAnalyticsClient);
parcelHelpers.export(exports, "clearErrorAnalyticsClient", ()=>clearErrorAnalyticsClient);
parcelHelpers.export(exports, "trackFetchErrors", ()=>trackFetchErrors);
var _objectSpread = require("@swc/helpers/_/_object_spread");
var _objectSpreadProps = require("@swc/helpers/_/_object_spread_props");
var _isEmpty = require("lodash/isEmpty");
var _isEmptyDefault = parcelHelpers.interopDefault(_isEmpty);
var _omitBy = require("lodash/omitBy");
var _omitByDefault = parcelHelpers.interopDefault(_omitBy);
var _analyticsBridge = require("@atlassian/analytics-bridge");
var _sentry = require("./sentry");
let analyticsClient;
const initialiseErrorAnalyticsClient = (client)=>{
    analyticsClient = client;
};
const clearErrorAnalyticsClient = ()=>{
    analyticsClient = undefined;
};
const fireErrorAnalytics = ({ event, error, errorInfo, meta, attributes })=>{
    const { id, packageName, teamName } = meta;
    if (__SERVER__) {
        if (error) throw error;
        else {
            const payload = event && (0, _analyticsBridge.extractAWCDataFromEvent)(event).payload;
            throw new Error(JSON.stringify({
                event: payload,
                errorInfo,
                meta,
                attributes
            }));
        }
    }
    const fullAnalyticsId = `${packageName}.${id}`;
    if (error) {
        const details = (0, _omitByDefault.default)((0, _objectSpreadProps._)((0, _objectSpread._)({}, attributes), {
            packageName,
            teamName,
            errorInfo
        }), (0, _isEmptyDefault.default));
        if (event && event.context) {
            const fullEvent = (0, _analyticsBridge.extractAWCDataFromEvent)(event);
            (0, _sentry.captureException)(fullAnalyticsId, error, (0, _objectSpread._)({}, details, fullEvent.payload));
        } else (0, _sentry.captureException)(fullAnalyticsId, error, details);
    }
    if (event && event.handlers && event.handlers.length > 0) {
        const attrs = attributes || {};
        (0, _analyticsBridge.fireOperationalAnalytics)(event, `${fullAnalyticsId} failed`, attrs);
    } else //Allow this to pass in a promise so that we can avoid blocking render for firing these events.
    if (analyticsClient && analyticsClient.sendOperationalEvent) {
        const gasV3Event = {
            action: 'failed',
            actionSubject: fullAnalyticsId,
            source: 'unknownErrorSource',
            attributes
        };
        analyticsClient.sendOperationalEvent(gasV3Event);
    } else {
        const analyticsClientUninitialisedError = new Error("Analytics client hasn't been initialised, unable to fire error operational event");
        (0, _sentry.captureException)(fullAnalyticsId, analyticsClientUninitialisedError);
    }
};
const trackFetchErrors = async ({ error, id, packageName })=>{
    if (error.statusCode) {
        const { statusCode } = error;
        let statusCodeGroup;
        if (statusCode >= 300 && statusCode < 400) statusCodeGroup = '3xx';
        else if (statusCode >= 400 && statusCode < 500) statusCodeGroup = '4xx';
        else if (statusCode >= 500 && statusCode < 600) statusCodeGroup = '5xx';
        else statusCodeGroup = 'unknown';
        await fireErrorAnalytics({
            meta: {
                id,
                packageName
            },
            attributes: {
                statusCodeGroup
            }
        });
    } else await fireErrorAnalytics({
        error,
        meta: {
            id,
            packageName
        }
    });
};
exports.default = fireErrorAnalytics;

},{"@swc/helpers/_/_object_spread":"9gdrV","@swc/helpers/_/_object_spread_props":"kANqQ","lodash/isEmpty":"dsS55","lodash/omitBy":"80W3G","@atlassian/analytics-bridge":"6YOyH","./sentry":"3AQCm","@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"dsS55":[function(require,module,exports,__globalThis) {
var baseKeys = require("ec4a750028c3f468"), getTag = require("b7d64f002249da90"), isArguments = require("f21d8f81d42f8a8c"), isArray = require("30aafb279d3057cf"), isArrayLike = require("6bad5117a6321f93"), isBuffer = require("e26e6737775922f6"), isPrototype = require("82ebbdc751dc1bc2"), isTypedArray = require("cc7073065656b186");
/** `Object#toString` result references. */ var mapTag = '[object Map]', setTag = '[object Set]';
/** Used for built-in method references. */ var objectProto = Object.prototype;
/** Used to check objects for own properties. */ var hasOwnProperty = objectProto.hasOwnProperty;
/**
 * Checks if `value` is an empty object, collection, map, or set.
 *
 * Objects are considered empty if they have no own enumerable string keyed
 * properties.
 *
 * Array-like values such as `arguments` objects, arrays, buffers, strings, or
 * jQuery-like collections are considered empty if they have a `length` of `0`.
 * Similarly, maps and sets are considered empty if they have a `size` of `0`.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is empty, else `false`.
 * @example
 *
 * _.isEmpty(null);
 * // => true
 *
 * _.isEmpty(true);
 * // => true
 *
 * _.isEmpty(1);
 * // => true
 *
 * _.isEmpty([1, 2, 3]);
 * // => false
 *
 * _.isEmpty({ 'a': 1 });
 * // => false
 */ function isEmpty(value) {
    if (value == null) return true;
    if (isArrayLike(value) && (isArray(value) || typeof value == 'string' || typeof value.splice == 'function' || isBuffer(value) || isTypedArray(value) || isArguments(value))) return !value.length;
    var tag = getTag(value);
    if (tag == mapTag || tag == setTag) return !value.size;
    if (isPrototype(value)) return !baseKeys(value).length;
    for(var key in value){
        if (hasOwnProperty.call(value, key)) return false;
    }
    return true;
}
module.exports = isEmpty;

},{"ec4a750028c3f468":"dSRad","b7d64f002249da90":"4SOxL","f21d8f81d42f8a8c":"8QyUt","30aafb279d3057cf":"7eHCl","6bad5117a6321f93":"d4PO7","e26e6737775922f6":"chGID","82ebbdc751dc1bc2":"flb0y","cc7073065656b186":"3JUwD"}],"dUbhS":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _analyticsNext = require("@atlaskit/analytics-next");
var _fireErrorAnalytics = require("./fire-error-analytics");
var _fireErrorAnalyticsDefault = parcelHelpers.interopDefault(_fireErrorAnalytics);
class CatchAndReportErrors extends (0, _react.Component) {
    componentDidCatch(error, errorInfo) {
        const { packageName, id, attributes, createAnalyticsEvent } = this.props;
        const analyticsEvent = createAnalyticsEvent({
            action: 'failed'
        });
        (0, _fireErrorAnalyticsDefault.default)({
            event: analyticsEvent,
            errorInfo,
            error,
            meta: {
                id,
                packageName
            },
            attributes
        });
        throw error;
    }
    render() {
        const { children } = this.props;
        return /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _reactDefault.default).Fragment, null, children);
    }
}
const reportingErrorBoundary = (0, _analyticsNext.withAnalyticsEvents)()(CatchAndReportErrors);
exports.default = reportingErrorBoundary;

},{"react":"ltHCL","@atlaskit/analytics-next":"6PLie","./fire-error-analytics":"hez9K","@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"d1gwZ":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "ReliabilityTrackerSubscribers", ()=>ReliabilityTrackerSubscribers);
var _objectSpread = require("@swc/helpers/_/_object_spread");
var _react = require("react");
var _analyticsNext = require("@atlaskit/analytics-next");
var _analyticsBridge = require("@atlassian/analytics-bridge");
var _sentry = require("../sentry");
var _studioReliabilityTracker = require("./studio-reliability-tracker");
const ACTION_BY_TYPE = {
    start: 'taskStart',
    succeed: 'taskSuccess',
    fail: 'taskFail',
    abort: 'taskAbort'
};
const buildAnalyticsAttributes = (event)=>{
    const base = {
        task: event.task
    };
    if (event.taskId !== undefined) base.taskId = event.taskId;
    if (event.touchpointId !== undefined) base.touchpointId = event.touchpointId;
    if (event.type !== 'start') base.duration = event.duration;
    if (event.type === 'fail' && event.traceId !== undefined) base.atlTraceId = event.traceId;
    if (event.type === 'abort' && event.reason !== undefined) base.reason = event.reason;
    if (event.attributes) Object.entries(event.attributes).forEach(([key, value])=>{
        if (value !== undefined) base[key] = value;
    });
    return base;
};
const reportFailToSentry = (event)=>{
    (0, _sentry.logException)(event.error, (0, _objectSpread._)({
        loggerName: `StudioReliability-${event.task}`,
        touchpointId: event.touchpointId,
        task: event.task,
        taskId: event.taskId,
        atlTraceId: event.traceId,
        duration: event.duration,
        reliabilityEvent: 'fail'
    }, event.attributes));
};
const reportAbortToSentry = (event)=>{
    var _event_reason;
    (0, _sentry.logException)(new Error((_event_reason = event.reason) !== null && _event_reason !== void 0 ? _event_reason : `Reliability tracker aborted: ${event.task}`), (0, _objectSpread._)({
        loggerName: `StudioReliability-${event.task}`,
        touchpointId: event.touchpointId,
        task: event.task,
        taskId: event.taskId,
        duration: event.duration,
        reason: event.reason,
        reliabilityEvent: 'abort'
    }, event.attributes));
};
const ReliabilityTrackerSubscribers = ()=>{
    const { createAnalyticsEvent } = (0, _analyticsNext.useAnalyticsEvents)();
    (0, _react.useEffect)(()=>{
        return (0, _studioReliabilityTracker.studioReliabilityTracker).subscribe((event)=>{
            const action = ACTION_BY_TYPE[event.type];
            const analyticsEvent = createAnalyticsEvent({
                action,
                actionSubject: 'ui'
            });
            (0, _analyticsBridge.fireOperationalAnalytics)(analyticsEvent, `ui ${action}`, buildAnalyticsAttributes(event));
            if (event.type === 'fail') reportFailToSentry(event);
            else if (event.type === 'abort') reportAbortToSentry(event);
        });
    }, [
        createAnalyticsEvent
    ]);
    return null;
};

},{"@swc/helpers/_/_object_spread":"9gdrV","react":"ltHCL","@atlaskit/analytics-next":"6PLie","@atlassian/analytics-bridge":"6YOyH","../sentry":"22o7a","./studio-reliability-tracker":"cMbGI","@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"22o7a":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "setupSentryClient", ()=>setupSentryClient);
parcelHelpers.export(exports, "logException", ()=>logException);
parcelHelpers.export(exports, "logMessage", ()=>logMessage);
parcelHelpers.export(exports, "SentryErrorBoundary", ()=>SentryErrorBoundary);
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _browser = require("@sentry/browser");
var _integrations = require("@sentry/integrations");
var _reactErrorBoundary = require("react-error-boundary");
var _atlassianStudioEnvUtils = require("@atlassian/atlassian-studio-env-utils");
var _atlassianStudioRouting = require("@atlassian/atlassian-studio-routing");
const setupSentryClient = ({ packageName, sentryDsn } = {})=>{
    const accountId = 'UNKNOWN_AAID'; // TODO: Mock AAID for when app is fetching accountId or if accountId is otherwise not available
    const product = 'atlassianStudio';
    const defaultLogger = 'logger.default';
    const environment = window.location.href.includes('localhost') ? 'dev' : (0, _atlassianStudioEnvUtils.getIdentityEnv)() === 'prod' ? 'production' : (0, _atlassianStudioEnvUtils.getIdentityEnv)();
    const defaultSentryDsn = 'https://ae44830611a6df6a7da952dd70a22f95@o55978.ingest.us.sentry.io/4509031091929088';
    _browser.init({
        dsn: sentryDsn !== null && sentryDsn !== void 0 ? sentryDsn : defaultSentryDsn,
        environment: environment,
        beforeSend: (event)=>{
            var _event_tags;
            // We only want errors captured explicitly via logException/logMessage or SentryErrorBoundary, to avoid unwanted errors being sent
            if (((_event_tags = event.tags) === null || _event_tags === void 0 ? void 0 : _event_tags.name) === undefined) return null;
            return event;
        },
        integrations: [
            new _integrations.ExtraErrorData()
        ],
        initialScope: {
            user: {
                id: accountId
            },
            tags: {
                packageName: packageName !== null && packageName !== void 0 ? packageName : '@atlassian/atlassian-studio',
                product
            }
        },
        attachStacktrace: true,
        // https://github.com/getsentry/sentry-javascript/issues/2292
        ignoreErrors: [
            'Non-Error exception captured'
        ]
    });
    _browser.setTag('product', product);
    _browser.setTag('logger', defaultLogger);
    _browser.setUser({
        id: accountId
    });
};
const setTagsFromExtras = (scope, extrasAndTags)=>{
    scope.setTag('name', 'studio');
    if (extrasAndTags.loggerName) scope.setTag('logger', `logger.${extrasAndTags.loggerName}`);
    if (extrasAndTags.accountId) scope.setUser({
        id: extrasAndTags.accountId
    });
    if (extrasAndTags.teamName) scope.setTag('teamName', extrasAndTags.teamName);
    if (extrasAndTags.touchpointId) scope.setTag('touchpointId', extrasAndTags.touchpointId);
    if (extrasAndTags.traceId) scope.setTag('traceId', extrasAndTags.traceId);
    if (extrasAndTags.task) scope.setTag('task', extrasAndTags.task);
    if (extrasAndTags.reliabilityEvent) scope.setTag('reliabilityEvent', extrasAndTags.reliabilityEvent);
};
const logException = (exception, extrasAndTags)=>{
    const version = (0, _atlassianStudioRouting.isStudioV2)() ? 'v2' : 'v1';
    _browser.withScope((scope)=>{
        scope.setTag('name', 'studio');
        scope.setTag('version', version);
        if (extrasAndTags) {
            scope.setExtras(extrasAndTags);
            // @ts-ignore - TS2345 - Added during confluence root integration
            setTagsFromExtras(scope, extrasAndTags);
        }
        _browser.captureException(exception, scope);
    });
};
const logMessage = (msg, extrasAndTags)=>{
    const version = (0, _atlassianStudioRouting.isStudioV2)() ? 'v2' : 'v1';
    _browser.withScope((scope)=>{
        scope.setTag('name', 'studio');
        scope.setTag('version', version);
        if (extrasAndTags) {
            scope.setExtras(extrasAndTags);
            // @ts-ignore - TS2345 - Added during confluence root integration
            setTagsFromExtras(scope, extrasAndTags);
        }
        try {
            _browser.captureMessage(msg, scope);
        } catch (error) {
            // all targeted errors include update is not a function even if minified differently
            if (error instanceof Error && error.message.includes('update is not a function')) ;
            else throw error;
        }
    });
};
const SentryErrorBoundary = ({ children, fallbackComponent, loggerName, accountId, onError, teamName, touchpointId })=>{
    return /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _reactErrorBoundary.ErrorBoundary), {
        FallbackComponent: fallbackComponent,
        onError: (err)=>{
            logException(err, {
                loggerName,
                accountId,
                teamName,
                touchpointId
            });
            onError === null || onError === void 0 ? void 0 : onError(err);
        }
    }, children);
};

},{"react":"ltHCL","@sentry/browser":"iOLMF","@sentry/integrations":"f1O2Y","react-error-boundary":"cC53c","@atlassian/atlassian-studio-env-utils":"lO9Ek","@atlassian/atlassian-studio-routing":"aRetS","@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"cC53c":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "ErrorBoundary", ()=>ErrorBoundary);
parcelHelpers.export(exports, "ErrorBoundaryContext", ()=>ErrorBoundaryContext);
parcelHelpers.export(exports, "useErrorBoundary", ()=>useErrorBoundary);
parcelHelpers.export(exports, "withErrorBoundary", ()=>withErrorBoundary);
var _objectSpread = require("@swc/helpers/_/_object_spread");
var _objectSpreadProps = require("@swc/helpers/_/_object_spread_props");
var _react = require("react");
'use client';
const ErrorBoundaryContext = (0, _react.createContext)(null);
const initialState = {
    didCatch: false,
    error: null
};
class ErrorBoundary extends (0, _react.Component) {
    static getDerivedStateFromError(error) {
        return {
            didCatch: true,
            error
        };
    }
    resetErrorBoundary() {
        const { error } = this.state;
        if (error !== null) {
            var _this$props$onReset, _this$props;
            for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
            (_this$props$onReset = (_this$props = this.props).onReset) === null || _this$props$onReset === void 0 || _this$props$onReset.call(_this$props, {
                args,
                reason: "imperative-api"
            });
            this.setState(initialState);
        }
    }
    componentDidCatch(error, info) {
        var _this$props$onError, _this$props2;
        (_this$props$onError = (_this$props2 = this.props).onError) === null || _this$props$onError === void 0 || _this$props$onError.call(_this$props2, error, info);
    }
    componentDidUpdate(prevProps, prevState) {
        const { didCatch } = this.state;
        const { resetKeys } = this.props;
        // There's an edge case where if the thing that triggered the error happens to *also* be in the resetKeys array,
        // we'd end up resetting the error boundary immediately.
        // This would likely trigger a second error to be thrown.
        // So we make sure that we don't check the resetKeys on the first call of cDU after the error is set.
        if (didCatch && prevState.error !== null && hasArrayChanged(prevProps.resetKeys, resetKeys)) {
            var _this$props$onReset2, _this$props3;
            (_this$props$onReset2 = (_this$props3 = this.props).onReset) === null || _this$props$onReset2 === void 0 || _this$props$onReset2.call(_this$props3, {
                next: resetKeys,
                prev: prevProps.resetKeys,
                reason: "keys"
            });
            this.setState(initialState);
        }
    }
    render() {
        const { children, fallbackRender, FallbackComponent, fallback } = this.props;
        const { didCatch, error } = this.state;
        let childToRender = children;
        if (didCatch) {
            const props = {
                error,
                resetErrorBoundary: this.resetErrorBoundary
            };
            if (typeof fallbackRender === "function") childToRender = fallbackRender(props);
            else if (FallbackComponent) childToRender = (0, _react.createElement)(FallbackComponent, props);
            else if (fallback !== undefined) childToRender = fallback;
            else throw error;
        }
        return (0, _react.createElement)(ErrorBoundaryContext.Provider, {
            value: {
                didCatch,
                error,
                resetErrorBoundary: this.resetErrorBoundary
            }
        }, childToRender);
    }
    constructor(props){
        super(props);
        this.resetErrorBoundary = this.resetErrorBoundary.bind(this);
        this.state = initialState;
    }
}
function hasArrayChanged() {
    let a = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
    let b = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : [];
    return a.length !== b.length || a.some((item, index)=>!Object.is(item, b[index]));
}
function assertErrorBoundaryContext(value) {
    if (value == null || typeof value.didCatch !== "boolean" || typeof value.resetErrorBoundary !== "function") throw new Error("ErrorBoundaryContext not found");
}
function useErrorBoundary() {
    const context = (0, _react.useContext)(ErrorBoundaryContext);
    assertErrorBoundaryContext(context);
    const [state, setState] = (0, _react.useState)({
        error: null,
        hasError: false
    });
    const memoized = (0, _react.useMemo)(()=>({
            resetBoundary: ()=>{
                context.resetErrorBoundary();
                setState({
                    error: null,
                    hasError: false
                });
            },
            showBoundary: (error)=>setState({
                    error,
                    hasError: true
                })
        }), [
        context.resetErrorBoundary
    ]);
    if (state.hasError) throw state.error;
    return memoized;
}
function withErrorBoundary(component, errorBoundaryProps) {
    const Wrapped = (0, _react.forwardRef)((props, ref)=>(0, _react.createElement)(ErrorBoundary, errorBoundaryProps, (0, _react.createElement)(component, (0, _objectSpreadProps._)((0, _objectSpread._)({}, props), {
            ref
        }))));
    // Format for display in DevTools
    const name = component.displayName || component.name || "Unknown";
    Wrapped.displayName = "withErrorBoundary(".concat(name, ")");
    return Wrapped;
}

},{"@swc/helpers/_/_object_spread":"9gdrV","@swc/helpers/_/_object_spread_props":"kANqQ","react":"ltHCL","@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"lO9Ek":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "getIdentityEnv", ()=>getIdentityEnv);
parcelHelpers.export(exports, "getEnv", ()=>getEnv);
parcelHelpers.export(exports, "getMappedEnv", ()=>getMappedEnv);
var MicrosEnv = /*#__PURE__*/ function(MicrosEnv) {
    MicrosEnv["ADEV"] = "adev";
    MicrosEnv["STG_EAST"] = "stg-east";
    MicrosEnv["PROD_EAST"] = "prod-east";
    return MicrosEnv;
}(MicrosEnv || {});
const envMap = {
    local: 'local',
    test: 'test',
    prod: 'production',
    stg: 'staging',
    ["adev"]: 'staging',
    ["stg-east"]: 'staging',
    ["prod-east"]: 'production'
};
const ENV_TO_IDENTITY_ENV = {
    ddev: 'dev',
    test: 'dev',
    local: 'dev',
    staging: 'staging',
    production: 'prod',
    unknown: 'prod'
};
function getIdentityEnv() {
    var _ENV_TO_IDENTITY_ENV_getMappedEnv;
    return (_ENV_TO_IDENTITY_ENV_getMappedEnv = ENV_TO_IDENTITY_ENV[getMappedEnv()]) !== null && _ENV_TO_IDENTITY_ENV_getMappedEnv !== void 0 ? _ENV_TO_IDENTITY_ENV_getMappedEnv : 'staging';
}
function getEnv() {
    const appEnv = "prod-east";
    if (appEnv) return appEnv;
    // @ts-ignore
    return window.__env__;
}
function getMappedEnv() {
    return envMap[getEnv()];
}

},{"@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"aRetS":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "useGeneratePath", ()=>(0, _useGeneratePath.useGeneratePath));
parcelHelpers.export(exports, "LayoutFieldType", ()=>(0, _usePageLayoutEntryPoint.LayoutFieldType));
parcelHelpers.export(exports, "usePageLayoutEntryPoint", ()=>(0, _usePageLayoutEntryPoint.usePageLayoutEntryPoint));
parcelHelpers.export(exports, "createEntryPointPlugin", ()=>(0, _entryPointPlugin.createEntryPointPlugin));
parcelHelpers.export(exports, "getRouteEntryPointReference", ()=>(0, _entryPointPlugin.getRouteEntryPointReference));
parcelHelpers.export(exports, "useCloudId", ()=>(0, _useCloudId.useCloudId));
parcelHelpers.export(exports, "isEntryPointRoute", ()=>(0, _types.isEntryPointRoute));
parcelHelpers.export(exports, "getCloudIdFromPathOrFetch", ()=>(0, _cloudIdUtils.getCloudIdFromPathOrFetch));
parcelHelpers.export(exports, "getStudioPath", ()=>(0, _getStudioPath.getStudioPath));
parcelHelpers.export(exports, "getCachedWorkspaceId", ()=>(0, _getStudioVersion.getCachedWorkspaceId));
parcelHelpers.export(exports, "isStudioV2", ()=>(0, _getStudioVersion.isStudioV2));
parcelHelpers.export(exports, "setCachedWorkspaceId", ()=>(0, _getStudioVersion.setCachedWorkspaceId));
parcelHelpers.export(exports, "setIsStudioV2", ()=>(0, _getStudioVersion.setIsStudioV2));
parcelHelpers.export(exports, "extractWorkspaceOrSiteIdFromPath", ()=>(0, _urlInspection.extractWorkspaceOrSiteIdFromPath));
parcelHelpers.export(exports, "generateWorkspacePath", ()=>(0, _workspace.generateWorkspacePath));
parcelHelpers.export(exports, "getWorkspacePath", ()=>(0, _workspace.getWorkspacePath));
parcelHelpers.export(exports, "SPACE_PREFIX", ()=>(0, _workspace.SPACE_PREFIX));
parcelHelpers.export(exports, "WORKSPACE_PREFIX", ()=>(0, _workspace.WORKSPACE_PREFIX));
parcelHelpers.export(exports, "useTransformStudioRoute", ()=>(0, _useTransformStudioRoute.useTransformStudioRoute));
parcelHelpers.export(exports, "getStudioBaseUrl", ()=>(0, _getStudioBaseUrl.getStudioBaseUrl));
var _useGeneratePath = require("./hooks/use-generate-path");
var _usePageLayoutEntryPoint = require("./hooks/use-page-layout-entry-point");
var _entryPointPlugin = require("./utils/entry-point-plugin");
var _useCloudId = require("./utils/use-cloud-id");
var _types = require("./types");
var _cloudIdUtils = require("./utils/cloud-id-utils");
var _getStudioPath = require("./utils/get-studio-path");
var _getStudioVersion = require("./utils/get-studio-version");
var _urlInspection = require("./utils/url-inspection");
var _workspace = require("./utils/workspace");
var _useTransformStudioRoute = require("./hooks/use-transform-studio-route");
var _getStudioBaseUrl = require("./utils/get-studio-base-url");

},{"./hooks/use-generate-path":"5fi2M","./hooks/use-page-layout-entry-point":"4Bxlf","./utils/entry-point-plugin":"2ov8Q","./utils/use-cloud-id":"f9cxV","./types":"2oelf","./utils/cloud-id-utils":false,"./utils/get-studio-path":"fqTIO","./utils/get-studio-version":"fpbIA","./utils/url-inspection":"cZnbR","./utils/workspace":"1xq6C","./hooks/use-transform-studio-route":"d9T2z","./utils/get-studio-base-url":"jNYYE","@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"5fi2M":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "useGeneratePath", ()=>useGeneratePath);
var _objectSpread = require("@swc/helpers/_/_object_spread");
var _react = require("react");
var _reactMagneticDi = require("react-magnetic-di");
var _reactResourceRouterNext = require("react-resource-router-next");
var _getStudioPath = require("../../utils/get-studio-path");
var _getStudioVersion = require("../../utils/get-studio-version");
const useGeneratePath = ()=>{
    (0, _reactMagneticDi.di)((0, _reactResourceRouterNext.usePathParam), (0, _getStudioVersion.isStudioV2));
    const [workspaceId] = (0, _reactResourceRouterNext.usePathParam)('workspaceId');
    const [spaceId] = (0, _reactResourceRouterNext.usePathParam)('spaceId');
    /**
	 * Given a v1 path, generate a v2 path if we are in v2.
	 */ const generatePath = (0, _react.useCallback)((path, params)=>{
        return (0, _reactResourceRouterNext.generatePath)((0, _getStudioPath.getStudioPath)(path), (0, _objectSpread._)({}, params, (0, _getStudioVersion.isStudioV2)() ? {
            workspaceId,
            spaceId
        } : {}));
    }, [
        spaceId,
        workspaceId
    ]);
    return generatePath;
};

},{"@swc/helpers/_/_object_spread":"9gdrV","react":"ltHCL","react-magnetic-di":"hCzc8","react-resource-router-next":"6gkfP","../../utils/get-studio-path":"fqTIO","../../utils/get-studio-version":"fpbIA","@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"hCzc8":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "di", ()=>(0, _consumer.di));
parcelHelpers.export(exports, "runWithDi", ()=>(0, _global.runWithDi));
parcelHelpers.export(exports, "unstable_globalDi", ()=>(0, _global.globalDi));
parcelHelpers.export(exports, "DiProvider", ()=>(0, _provider.DiProvider));
parcelHelpers.export(exports, "withDi", ()=>(0, _provider.withDi));
parcelHelpers.export(exports, "injectable", ()=>(0, _injectable.injectable));
parcelHelpers.export(exports, "debug", ()=>(0, _utils.debug));
parcelHelpers.export(exports, "stats", ()=>(0, _stats.stats));
var _consumer = require("./react/consumer");
var _global = require("./react/global");
var _provider = require("./react/provider");
var _injectable = require("./react/injectable");
var _utils = require("./react/utils");
var _stats = require("./react/stats");

},{"./react/consumer":"ctpN0","./react/global":false,"./react/provider":false,"./react/injectable":false,"./react/utils":false,"./react/stats":false,"@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"ctpN0":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "di", ()=>di);
var _context = require("./context");
var _global = require("./global");
function di(target, ...deps) {
    // Read context and grab all the dependencies override Providers in the tree
    const { getDependencies } = // grab value from alt renderer (eg react-test-renderer)
    (0, _context.Context)._currentRenderer2 && (0, _context.Context)._currentValue2 || // grab value from default renderer
    (0, _context.Context)._currentValue || (0, _global.globalDi);
    return getDependencies(deps, target);
}

},{"./context":"aFARE","./global":"6PCsb","@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"aFARE":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "Context", ()=>Context);
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _global = require("./global");
const Context = /*#__PURE__*/ (0, _reactDefault.default).createContext({
    getDependencies: (0, _global.globalDi).getDependencies
});

},{"react":"ltHCL","./global":"6PCsb","@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"6PCsb":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "globalDi", ()=>globalDi);
parcelHelpers.export(exports, "runWithDi", ()=>runWithDi);
var _constants = require("./constants");
var _utils = require("./utils");
const replacementMap = new Map();
const globalDi = {
    getDependencies (realDeps, targetChild) {
        if (replacementMap.size) for(let i = 0; i < realDeps.length; i++){
            const replacedInj = (0, _utils.findInjectable)(replacementMap, realDeps[i], targetChild);
            if (replacedInj) realDeps[i] = replacedInj.value;
        }
        return realDeps;
    },
    use (injs) {
        if (replacementMap.size) throw new Error(`${(0, _constants.PACKAGE_NAME)} has replacements configured already. ` + `Implicit merging is not supported, so please concatenate injectables. ` + `If this is not expected, please file a bug report`);
        injs.forEach((inj)=>(0, _utils.addInjectableToMap)(replacementMap, inj));
    },
    clear () {
        replacementMap.clear();
    },
    _fromProvider (injs, props = {}) {
        injs.forEach((inj)=>{
            if (props.global || (0, _constants.diRegistry).get(inj).global) (0, _utils.addInjectableToMap)(replacementMap, inj);
        });
    },
    _remove (injs) {
        injs.forEach((inj)=>(0, _utils.removeInjectableFromMap)(replacementMap, inj));
    }
};
function runWithDi(thunk, deps) {
    globalDi.use(deps);
    let result;
    try {
        result = thunk();
        return result;
    } finally{
        // autocleanup dependences if either async or sync
        if (result && typeof result === 'object' && typeof result.then === 'function') // dont use finally as it "multiplies" rejected promises
        result.then(globalDi.clear, globalDi.clear);
        else globalDi.clear();
    }
}

},{"./constants":"d88lK","./utils":"j9A4D","@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"d88lK":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "diRegistry", ()=>diRegistry);
parcelHelpers.export(exports, "PACKAGE_NAME", ()=>PACKAGE_NAME);
const diRegistry = new WeakMap();
const PACKAGE_NAME = 'react-magnetic-di';

},{"@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"j9A4D":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "warnOnce", ()=>warnOnce);
parcelHelpers.export(exports, "addInjectableToMap", ()=>addInjectableToMap);
parcelHelpers.export(exports, "removeInjectableFromMap", ()=>removeInjectableFromMap);
parcelHelpers.export(exports, "getDisplayName", ()=>getDisplayName);
parcelHelpers.export(exports, "debug", ()=>debug);
parcelHelpers.export(exports, "findInjectable", ()=>findInjectable);
var _constants = require("./constants");
var _stats = require("./stats");
let hasWarned = false;
function warnOnce(message) {
    if (!hasWarned) {
        // eslint-disable-next-line no-console
        console.warn('Warning:', message);
        hasWarned = true;
    }
}
function addInjectableToMap(replacementMap, inj) {
    const injObj = (0, _constants.diRegistry).get(inj);
    if (!injObj) throw new Error(`Seems like you are trying to use "${inj}" as injectable, but magnetic-di needs the return value of "injectable()"`);
    if (injObj.track) (0, _stats.stats).set(injObj);
    if (replacementMap.has(injObj.from)) replacementMap.get(injObj.from).add(injObj);
    else replacementMap.set(injObj.from, new Set([
        injObj
    ]));
    return replacementMap;
}
function removeInjectableFromMap(replacementMap, inj) {
    const injObj = (0, _constants.diRegistry).get(inj);
    const injectables = replacementMap.get(injObj.from) || new Set();
    if (injectables.size === 1) replacementMap.delete(injObj.from);
    else injectables.delete(injObj);
}
function getDisplayName(Comp, wrapper = '') {
    const name = Comp.displayName || Comp.name;
    return !name || !wrapper ? name : `${wrapper}(${name})`;
}
function debug(fn) {
    const source = fn.toString();
    const [, args] = source.match(/const \[[^\]]+\] = .*di.*\(\w+[,\s]+([^)]+)/) || [];
    return args;
}
function findInjectable(replacementMap, dep, targetChild) {
    const injectables = replacementMap.get(dep);
    if (!injectables) return null;
    // loop all injectables for the dep, with targeted ones preferred
    let anyCandidate = null;
    let targetCandidate = null;
    for (const inj of injectables){
        var _inj$targets;
        if (!inj.targets) anyCandidate = inj;
        if ((_inj$targets = inj.targets) != null && _inj$targets.has(targetChild)) targetCandidate = inj;
    }
    const candidate = targetCandidate || anyCandidate;
    (0, _stats.stats).track(candidate);
    return candidate;
}

},{"./constants":"d88lK","./stats":"4TSI9","@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"4TSI9":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "stats", ()=>stats);
const createState = ()=>({
        unused: new Map(),
        used: new Set(),
        provided: new Set()
    });
const stats = {
    state: createState(),
    set (inj) {
        var _inj$value;
        // allow injectable override without flagging as unused
        for (let unusedInj of this.state.unused.keys())if (unusedInj.from === inj.from) this.state.unused.delete(unusedInj);
        this.state.unused.set(inj, new Error(`Unused "di" injectable: ${((_inj$value = inj.value) == null ? void 0 : _inj$value.displayName) || inj.value}.`, {
            cause: inj.cause
        }));
    },
    track (inj) {
        if (!inj) return;
        this.state.unused.delete(inj);
        this.state.used.add(inj);
        this.state.provided.add(inj.from);
        // reset to avoid potential memory leaks via stack traces
        inj.cause = null;
    },
    reset () {
        this.state = createState();
    },
    unused () {
        return Array.from(this.state.unused.entries()).map(([inj, error])=>({
                get: ()=>inj.value,
                error: ()=>error
            }));
    }
};

},{"@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"6gkfP":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "createBrowserHistory", ()=>(0, _history.createBrowserHistory));
parcelHelpers.export(exports, "createMemoryHistory", ()=>(0, _history.createMemoryHistory));
parcelHelpers.export(exports, "createRouterSelector", ()=>(0, _controllers.createRouterSelector));
parcelHelpers.export(exports, "MemoryRouter", ()=>(0, _controllers.MemoryRouter));
parcelHelpers.export(exports, "Redirect", ()=>(0, _controllers.Redirect));
parcelHelpers.export(exports, "Router", ()=>(0, _controllers.Router));
parcelHelpers.export(exports, "RouterActions", ()=>(0, _controllers.RouterActions));
parcelHelpers.export(exports, "RouterSubscriber", ()=>(0, _controllers.RouterSubscriber));
parcelHelpers.export(exports, "usePathParam", ()=>(0, _controllers.usePathParam));
parcelHelpers.export(exports, "useQueryParam", ()=>(0, _controllers.useQueryParam));
parcelHelpers.export(exports, "useRouter", ()=>(0, _controllers.useRouter));
parcelHelpers.export(exports, "useRouterActions", ()=>(0, _controllers.useRouterActions));
parcelHelpers.export(exports, "withRouter", ()=>(0, _controllers.withRouter));
parcelHelpers.export(exports, "RouteComponent", ()=>(0, _ui.RouteComponent));
parcelHelpers.export(exports, "Link", ()=>(0, _ui.Link));
parcelHelpers.export(exports, "createLegacyHistory", ()=>(0, _utils.createLegacyHistory));
parcelHelpers.export(exports, "createRouterContext", ()=>(0, _utils.createRouterContext));
parcelHelpers.export(exports, "findRouterContext", ()=>(0, _utils.findRouterContext));
parcelHelpers.export(exports, "generatePath", ()=>(0, _utils.generatePath));
parcelHelpers.export(exports, "matchRoute", ()=>(0, _utils.matchRoute));
parcelHelpers.export(exports, "invokePluginLoad", ()=>(0, _plugins.invokePluginLoad));
// extra exports for resources only
parcelHelpers.export(exports, "RouterStore", ()=>(0, _routerStore.RouterStore));
parcelHelpers.export(exports, "useRouterStoreActions", ()=>(0, _routerStore.useRouterStoreActions));
parcelHelpers.export(exports, "getRouterState", ()=>(0, _routerStore.getRouterState));
parcelHelpers.export(exports, "DEFAULT_MATCH", ()=>(0, _constants.DEFAULT_MATCH));
parcelHelpers.export(exports, "DEFAULT_ROUTE", ()=>(0, _constants.DEFAULT_ROUTE));
// re-export resources entry-point to keep it backwards compatible with 0.20.x version
parcelHelpers.export(exports, "createResource", ()=>(0, _resources.createResource));
parcelHelpers.export(exports, "ResourceDependencyError", ()=>(0, _resources.ResourceDependencyError));
parcelHelpers.export(exports, "ResourceSubscriber", ()=>(0, _resources.ResourceSubscriber));
parcelHelpers.export(exports, "useResource", ()=>(0, _resources.useResource));
parcelHelpers.export(exports, "useResourceStoreContext", ()=>(0, _resources.useResourceStoreContext));
var _history = require("history");
var _controllers = require("./controllers");
var _ui = require("./ui");
var _utils = require("./common/utils");
var _plugins = require("./controllers/plugins");
var _routerStore = require("./controllers/router-store");
var _constants = require("./common/constants");
var _resources = require("./resources");

},{"history":"de6OM","./controllers":"kk7tw","./ui":"dIzCr","./common/utils":"c9Uvk","./controllers/plugins":"izQoo","./controllers/router-store":"bWF6v","./common/constants":"cYZ0C","./resources":"2yUjo","@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"de6OM":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "createBrowserHistory", ()=>createBrowserHistory);
parcelHelpers.export(exports, "createHashHistory", ()=>createHashHistory);
parcelHelpers.export(exports, "createMemoryHistory", ()=>createMemoryHistory);
parcelHelpers.export(exports, "createLocation", ()=>createLocation);
parcelHelpers.export(exports, "locationsAreEqual", ()=>locationsAreEqual);
parcelHelpers.export(exports, "parsePath", ()=>parsePath);
parcelHelpers.export(exports, "createPath", ()=>createPath);
var _extends = require("@babel/runtime/helpers/esm/extends");
var _extendsDefault = parcelHelpers.interopDefault(_extends);
var _resolvePathname = require("resolve-pathname");
var _resolvePathnameDefault = parcelHelpers.interopDefault(_resolvePathname);
var _valueEqual = require("value-equal");
var _valueEqualDefault = parcelHelpers.interopDefault(_valueEqual);
var _tinyWarning = require("tiny-warning");
var _tinyWarningDefault = parcelHelpers.interopDefault(_tinyWarning);
var _tinyInvariant = require("tiny-invariant");
var _tinyInvariantDefault = parcelHelpers.interopDefault(_tinyInvariant);
function addLeadingSlash(path) {
    return path.charAt(0) === '/' ? path : '/' + path;
}
function stripLeadingSlash(path) {
    return path.charAt(0) === '/' ? path.substr(1) : path;
}
function hasBasename(path, prefix) {
    return path.toLowerCase().indexOf(prefix.toLowerCase()) === 0 && '/?#'.indexOf(path.charAt(prefix.length)) !== -1;
}
function stripBasename(path, prefix) {
    return hasBasename(path, prefix) ? path.substr(prefix.length) : path;
}
function stripTrailingSlash(path) {
    return path.charAt(path.length - 1) === '/' ? path.slice(0, -1) : path;
}
function parsePath(path) {
    var pathname = path || '/';
    var search = '';
    var hash = '';
    var hashIndex = pathname.indexOf('#');
    if (hashIndex !== -1) {
        hash = pathname.substr(hashIndex);
        pathname = pathname.substr(0, hashIndex);
    }
    var searchIndex = pathname.indexOf('?');
    if (searchIndex !== -1) {
        search = pathname.substr(searchIndex);
        pathname = pathname.substr(0, searchIndex);
    }
    return {
        pathname: pathname,
        search: search === '?' ? '' : search,
        hash: hash === '#' ? '' : hash
    };
}
function createPath(location) {
    var pathname = location.pathname, search = location.search, hash = location.hash;
    var path = pathname || '/';
    if (search && search !== '?') path += search.charAt(0) === '?' ? search : "?" + search;
    if (hash && hash !== '#') path += hash.charAt(0) === '#' ? hash : "#" + hash;
    return path;
}
function createLocation(path, state, key, currentLocation) {
    var location;
    if (typeof path === 'string') {
        // Two-arg form: push(path, state)
        location = parsePath(path);
        location.state = state;
    } else {
        // One-arg form: push(location)
        location = (0, _extendsDefault.default)({}, path);
        if (location.pathname === undefined) location.pathname = '';
        if (location.search) {
            if (location.search.charAt(0) !== '?') location.search = '?' + location.search;
        } else location.search = '';
        if (location.hash) {
            if (location.hash.charAt(0) !== '#') location.hash = '#' + location.hash;
        } else location.hash = '';
        if (state !== undefined && location.state === undefined) location.state = state;
    }
    try {
        location.pathname = decodeURI(location.pathname);
    } catch (e) {
        if (e instanceof URIError) throw new URIError('Pathname "' + location.pathname + '" could not be decoded. ' + 'This is likely caused by an invalid percent-encoding.');
        else throw e;
    }
    if (key) location.key = key;
    if (currentLocation) {
        // Resolve incomplete/relative pathname relative to current location.
        if (!location.pathname) location.pathname = currentLocation.pathname;
        else if (location.pathname.charAt(0) !== '/') location.pathname = (0, _resolvePathnameDefault.default)(location.pathname, currentLocation.pathname);
    } else // When there is no prior location and pathname is empty, set it to /
    if (!location.pathname) location.pathname = '/';
    return location;
}
function locationsAreEqual(a, b) {
    return a.pathname === b.pathname && a.search === b.search && a.hash === b.hash && a.key === b.key && (0, _valueEqualDefault.default)(a.state, b.state);
}
function createTransitionManager() {
    var prompt = null;
    function setPrompt(nextPrompt) {
        prompt = nextPrompt;
        return function() {
            if (prompt === nextPrompt) prompt = null;
        };
    }
    function confirmTransitionTo(location, action, getUserConfirmation, callback) {
        // TODO: If another transition starts while we're still confirming
        // the previous one, we may end up in a weird state. Figure out the
        // best way to handle this.
        if (prompt != null) {
            var result = typeof prompt === 'function' ? prompt(location, action) : prompt;
            if (typeof result === 'string') {
                if (typeof getUserConfirmation === 'function') getUserConfirmation(result, callback);
                else callback(true);
            } else // Return false from a transition hook to cancel the transition.
            callback(result !== false);
        } else callback(true);
    }
    var listeners = [];
    function appendListener(fn) {
        var isActive = true;
        function listener() {
            if (isActive) fn.apply(void 0, arguments);
        }
        listeners.push(listener);
        return function() {
            isActive = false;
            listeners = listeners.filter(function(item) {
                return item !== listener;
            });
        };
    }
    function notifyListeners() {
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        listeners.forEach(function(listener) {
            return listener.apply(void 0, args);
        });
    }
    return {
        setPrompt: setPrompt,
        confirmTransitionTo: confirmTransitionTo,
        appendListener: appendListener,
        notifyListeners: notifyListeners
    };
}
var canUseDOM = !!(typeof window !== 'undefined' && window.document && window.document.createElement);
function getConfirmation(message, callback) {
    callback(window.confirm(message)); // eslint-disable-line no-alert
}
/**
 * Returns true if the HTML5 history API is supported. Taken from Modernizr.
 *
 * https://github.com/Modernizr/Modernizr/blob/master/LICENSE
 * https://github.com/Modernizr/Modernizr/blob/master/feature-detects/history.js
 * changed to avoid false negatives for Windows Phones: https://github.com/reactjs/react-router/issues/586
 */ function supportsHistory() {
    var ua = window.navigator.userAgent;
    if ((ua.indexOf('Android 2.') !== -1 || ua.indexOf('Android 4.0') !== -1) && ua.indexOf('Mobile Safari') !== -1 && ua.indexOf('Chrome') === -1 && ua.indexOf('Windows Phone') === -1) return false;
    return window.history && 'pushState' in window.history;
}
/**
 * Returns true if browser fires popstate on hash change.
 * IE10 and IE11 do not.
 */ function supportsPopStateOnHashChange() {
    return window.navigator.userAgent.indexOf('Trident') === -1;
}
/**
 * Returns false if using go(n) with hash history causes a full page reload.
 */ function supportsGoWithoutReloadUsingHash() {
    return window.navigator.userAgent.indexOf('Firefox') === -1;
}
/**
 * Returns true if a given popstate event is an extraneous WebKit event.
 * Accounts for the fact that Chrome on iOS fires real popstate events
 * containing undefined state when pressing the back button.
 */ function isExtraneousPopstateEvent(event) {
    return event.state === undefined && navigator.userAgent.indexOf('CriOS') === -1;
}
var PopStateEvent = 'popstate';
var HashChangeEvent = 'hashchange';
function getHistoryState() {
    try {
        return window.history.state || {};
    } catch (e) {
        // IE 11 sometimes throws when accessing window.history.state
        // See https://github.com/ReactTraining/history/pull/289
        return {};
    }
}
/**
 * Creates a history object that uses the HTML5 history API including
 * pushState, replaceState, and the popstate event.
 */ function createBrowserHistory(props) {
    if (props === void 0) props = {};
    !canUseDOM && (0, _tinyInvariantDefault.default)(false);
    var globalHistory = window.history;
    var canUseHistory = supportsHistory();
    var needsHashChangeListener = !supportsPopStateOnHashChange();
    var _props = props, _props$forceRefresh = _props.forceRefresh, forceRefresh = _props$forceRefresh === void 0 ? false : _props$forceRefresh, _props$getUserConfirm = _props.getUserConfirmation, getUserConfirmation = _props$getUserConfirm === void 0 ? getConfirmation : _props$getUserConfirm, _props$keyLength = _props.keyLength, keyLength = _props$keyLength === void 0 ? 6 : _props$keyLength;
    var basename = props.basename ? stripTrailingSlash(addLeadingSlash(props.basename)) : '';
    function getDOMLocation(historyState) {
        var _ref = historyState || {}, key = _ref.key, state = _ref.state;
        var _window$location = window.location, pathname = _window$location.pathname, search = _window$location.search, hash = _window$location.hash;
        var path = pathname + search + hash;
        if (basename) path = stripBasename(path, basename);
        return createLocation(path, state, key);
    }
    function createKey() {
        return Math.random().toString(36).substr(2, keyLength);
    }
    var transitionManager = createTransitionManager();
    function setState(nextState) {
        (0, _extendsDefault.default)(history, nextState);
        history.length = globalHistory.length;
        transitionManager.notifyListeners(history.location, history.action);
    }
    function handlePopState(event) {
        // Ignore extraneous popstate events in WebKit.
        if (isExtraneousPopstateEvent(event)) return;
        handlePop(getDOMLocation(event.state));
    }
    function handleHashChange() {
        handlePop(getDOMLocation(getHistoryState()));
    }
    var forceNextPop = false;
    function handlePop(location) {
        if (forceNextPop) {
            forceNextPop = false;
            setState();
        } else {
            var action = 'POP';
            transitionManager.confirmTransitionTo(location, action, getUserConfirmation, function(ok) {
                if (ok) setState({
                    action: action,
                    location: location
                });
                else revertPop(location);
            });
        }
    }
    function revertPop(fromLocation) {
        var toLocation = history.location; // TODO: We could probably make this more reliable by
        // keeping a list of keys we've seen in sessionStorage.
        // Instead, we just default to 0 for keys we don't know.
        var toIndex = allKeys.indexOf(toLocation.key);
        if (toIndex === -1) toIndex = 0;
        var fromIndex = allKeys.indexOf(fromLocation.key);
        if (fromIndex === -1) fromIndex = 0;
        var delta = toIndex - fromIndex;
        if (delta) {
            forceNextPop = true;
            go(delta);
        }
    }
    var initialLocation = getDOMLocation(getHistoryState());
    var allKeys = [
        initialLocation.key
    ]; // Public interface
    function createHref(location) {
        return basename + createPath(location);
    }
    function push(path, state) {
        var action = 'PUSH';
        var location = createLocation(path, state, createKey(), history.location);
        transitionManager.confirmTransitionTo(location, action, getUserConfirmation, function(ok) {
            if (!ok) return;
            var href = createHref(location);
            var key = location.key, state = location.state;
            if (canUseHistory) {
                globalHistory.pushState({
                    key: key,
                    state: state
                }, null, href);
                if (forceRefresh) window.location.href = href;
                else {
                    var prevIndex = allKeys.indexOf(history.location.key);
                    var nextKeys = allKeys.slice(0, prevIndex + 1);
                    nextKeys.push(location.key);
                    allKeys = nextKeys;
                    setState({
                        action: action,
                        location: location
                    });
                }
            } else window.location.href = href;
        });
    }
    function replace(path, state) {
        var action = 'REPLACE';
        var location = createLocation(path, state, createKey(), history.location);
        transitionManager.confirmTransitionTo(location, action, getUserConfirmation, function(ok) {
            if (!ok) return;
            var href = createHref(location);
            var key = location.key, state = location.state;
            if (canUseHistory) {
                globalHistory.replaceState({
                    key: key,
                    state: state
                }, null, href);
                if (forceRefresh) window.location.replace(href);
                else {
                    var prevIndex = allKeys.indexOf(history.location.key);
                    if (prevIndex !== -1) allKeys[prevIndex] = location.key;
                    setState({
                        action: action,
                        location: location
                    });
                }
            } else window.location.replace(href);
        });
    }
    function go(n) {
        globalHistory.go(n);
    }
    function goBack() {
        go(-1);
    }
    function goForward() {
        go(1);
    }
    var listenerCount = 0;
    function checkDOMListeners(delta) {
        listenerCount += delta;
        if (listenerCount === 1 && delta === 1) {
            window.addEventListener(PopStateEvent, handlePopState);
            if (needsHashChangeListener) window.addEventListener(HashChangeEvent, handleHashChange);
        } else if (listenerCount === 0) {
            window.removeEventListener(PopStateEvent, handlePopState);
            if (needsHashChangeListener) window.removeEventListener(HashChangeEvent, handleHashChange);
        }
    }
    var isBlocked = false;
    function block(prompt) {
        if (prompt === void 0) prompt = false;
        var unblock = transitionManager.setPrompt(prompt);
        if (!isBlocked) {
            checkDOMListeners(1);
            isBlocked = true;
        }
        return function() {
            if (isBlocked) {
                isBlocked = false;
                checkDOMListeners(-1);
            }
            return unblock();
        };
    }
    function listen(listener) {
        var unlisten = transitionManager.appendListener(listener);
        checkDOMListeners(1);
        return function() {
            checkDOMListeners(-1);
            unlisten();
        };
    }
    var history = {
        length: globalHistory.length,
        action: 'POP',
        location: initialLocation,
        createHref: createHref,
        push: push,
        replace: replace,
        go: go,
        goBack: goBack,
        goForward: goForward,
        block: block,
        listen: listen
    };
    return history;
}
var HashChangeEvent$1 = 'hashchange';
var HashPathCoders = {
    hashbang: {
        encodePath: function encodePath(path) {
            return path.charAt(0) === '!' ? path : '!/' + stripLeadingSlash(path);
        },
        decodePath: function decodePath(path) {
            return path.charAt(0) === '!' ? path.substr(1) : path;
        }
    },
    noslash: {
        encodePath: stripLeadingSlash,
        decodePath: addLeadingSlash
    },
    slash: {
        encodePath: addLeadingSlash,
        decodePath: addLeadingSlash
    }
};
function stripHash(url) {
    var hashIndex = url.indexOf('#');
    return hashIndex === -1 ? url : url.slice(0, hashIndex);
}
function getHashPath() {
    // We can't use window.location.hash here because it's not
    // consistent across browsers - Firefox will pre-decode it!
    var href = window.location.href;
    var hashIndex = href.indexOf('#');
    return hashIndex === -1 ? '' : href.substring(hashIndex + 1);
}
function pushHashPath(path) {
    window.location.hash = path;
}
function replaceHashPath(path) {
    window.location.replace(stripHash(window.location.href) + '#' + path);
}
function createHashHistory(props) {
    if (props === void 0) props = {};
    !canUseDOM && (0, _tinyInvariantDefault.default)(false);
    var globalHistory = window.history;
    var canGoWithoutReload = supportsGoWithoutReloadUsingHash();
    var _props = props, _props$getUserConfirm = _props.getUserConfirmation, getUserConfirmation = _props$getUserConfirm === void 0 ? getConfirmation : _props$getUserConfirm, _props$hashType = _props.hashType, hashType = _props$hashType === void 0 ? 'slash' : _props$hashType;
    var basename = props.basename ? stripTrailingSlash(addLeadingSlash(props.basename)) : '';
    var _HashPathCoders$hashT = HashPathCoders[hashType], encodePath = _HashPathCoders$hashT.encodePath, decodePath = _HashPathCoders$hashT.decodePath;
    function getDOMLocation() {
        var path = decodePath(getHashPath());
        if (basename) path = stripBasename(path, basename);
        return createLocation(path);
    }
    var transitionManager = createTransitionManager();
    function setState(nextState) {
        (0, _extendsDefault.default)(history, nextState);
        history.length = globalHistory.length;
        transitionManager.notifyListeners(history.location, history.action);
    }
    var forceNextPop = false;
    var ignorePath = null;
    function locationsAreEqual$$1(a, b) {
        return a.pathname === b.pathname && a.search === b.search && a.hash === b.hash;
    }
    function handleHashChange() {
        var path = getHashPath();
        var encodedPath = encodePath(path);
        if (path !== encodedPath) // Ensure we always have a properly-encoded hash.
        replaceHashPath(encodedPath);
        else {
            var location = getDOMLocation();
            var prevLocation = history.location;
            if (!forceNextPop && locationsAreEqual$$1(prevLocation, location)) return; // A hashchange doesn't always == location change.
            if (ignorePath === createPath(location)) return; // Ignore this change; we already setState in push/replace.
            ignorePath = null;
            handlePop(location);
        }
    }
    function handlePop(location) {
        if (forceNextPop) {
            forceNextPop = false;
            setState();
        } else {
            var action = 'POP';
            transitionManager.confirmTransitionTo(location, action, getUserConfirmation, function(ok) {
                if (ok) setState({
                    action: action,
                    location: location
                });
                else revertPop(location);
            });
        }
    }
    function revertPop(fromLocation) {
        var toLocation = history.location; // TODO: We could probably make this more reliable by
        // keeping a list of paths we've seen in sessionStorage.
        // Instead, we just default to 0 for paths we don't know.
        var toIndex = allPaths.lastIndexOf(createPath(toLocation));
        if (toIndex === -1) toIndex = 0;
        var fromIndex = allPaths.lastIndexOf(createPath(fromLocation));
        if (fromIndex === -1) fromIndex = 0;
        var delta = toIndex - fromIndex;
        if (delta) {
            forceNextPop = true;
            go(delta);
        }
    } // Ensure the hash is encoded properly before doing anything else.
    var path = getHashPath();
    var encodedPath = encodePath(path);
    if (path !== encodedPath) replaceHashPath(encodedPath);
    var initialLocation = getDOMLocation();
    var allPaths = [
        createPath(initialLocation)
    ]; // Public interface
    function createHref(location) {
        var baseTag = document.querySelector('base');
        var href = '';
        if (baseTag && baseTag.getAttribute('href')) href = stripHash(window.location.href);
        return href + '#' + encodePath(basename + createPath(location));
    }
    function push(path, state) {
        var action = 'PUSH';
        var location = createLocation(path, undefined, undefined, history.location);
        transitionManager.confirmTransitionTo(location, action, getUserConfirmation, function(ok) {
            if (!ok) return;
            var path = createPath(location);
            var encodedPath = encodePath(basename + path);
            var hashChanged = getHashPath() !== encodedPath;
            if (hashChanged) {
                // We cannot tell if a hashchange was caused by a PUSH, so we'd
                // rather setState here and ignore the hashchange. The caveat here
                // is that other hash histories in the page will consider it a POP.
                ignorePath = path;
                pushHashPath(encodedPath);
                var prevIndex = allPaths.lastIndexOf(createPath(history.location));
                var nextPaths = allPaths.slice(0, prevIndex + 1);
                nextPaths.push(path);
                allPaths = nextPaths;
                setState({
                    action: action,
                    location: location
                });
            } else setState();
        });
    }
    function replace(path, state) {
        var action = 'REPLACE';
        var location = createLocation(path, undefined, undefined, history.location);
        transitionManager.confirmTransitionTo(location, action, getUserConfirmation, function(ok) {
            if (!ok) return;
            var path = createPath(location);
            var encodedPath = encodePath(basename + path);
            var hashChanged = getHashPath() !== encodedPath;
            if (hashChanged) {
                // We cannot tell if a hashchange was caused by a REPLACE, so we'd
                // rather setState here and ignore the hashchange. The caveat here
                // is that other hash histories in the page will consider it a POP.
                ignorePath = path;
                replaceHashPath(encodedPath);
            }
            var prevIndex = allPaths.indexOf(createPath(history.location));
            if (prevIndex !== -1) allPaths[prevIndex] = path;
            setState({
                action: action,
                location: location
            });
        });
    }
    function go(n) {
        globalHistory.go(n);
    }
    function goBack() {
        go(-1);
    }
    function goForward() {
        go(1);
    }
    var listenerCount = 0;
    function checkDOMListeners(delta) {
        listenerCount += delta;
        if (listenerCount === 1 && delta === 1) window.addEventListener(HashChangeEvent$1, handleHashChange);
        else if (listenerCount === 0) window.removeEventListener(HashChangeEvent$1, handleHashChange);
    }
    var isBlocked = false;
    function block(prompt) {
        if (prompt === void 0) prompt = false;
        var unblock = transitionManager.setPrompt(prompt);
        if (!isBlocked) {
            checkDOMListeners(1);
            isBlocked = true;
        }
        return function() {
            if (isBlocked) {
                isBlocked = false;
                checkDOMListeners(-1);
            }
            return unblock();
        };
    }
    function listen(listener) {
        var unlisten = transitionManager.appendListener(listener);
        checkDOMListeners(1);
        return function() {
            checkDOMListeners(-1);
            unlisten();
        };
    }
    var history = {
        length: globalHistory.length,
        action: 'POP',
        location: initialLocation,
        createHref: createHref,
        push: push,
        replace: replace,
        go: go,
        goBack: goBack,
        goForward: goForward,
        block: block,
        listen: listen
    };
    return history;
}
function clamp(n, lowerBound, upperBound) {
    return Math.min(Math.max(n, lowerBound), upperBound);
}
/**
 * Creates a history object that stores locations in memory.
 */ function createMemoryHistory(props) {
    if (props === void 0) props = {};
    var _props = props, getUserConfirmation = _props.getUserConfirmation, _props$initialEntries = _props.initialEntries, initialEntries = _props$initialEntries === void 0 ? [
        '/'
    ] : _props$initialEntries, _props$initialIndex = _props.initialIndex, initialIndex = _props$initialIndex === void 0 ? 0 : _props$initialIndex, _props$keyLength = _props.keyLength, keyLength = _props$keyLength === void 0 ? 6 : _props$keyLength;
    var transitionManager = createTransitionManager();
    function setState(nextState) {
        (0, _extendsDefault.default)(history, nextState);
        history.length = history.entries.length;
        transitionManager.notifyListeners(history.location, history.action);
    }
    function createKey() {
        return Math.random().toString(36).substr(2, keyLength);
    }
    var index = clamp(initialIndex, 0, initialEntries.length - 1);
    var entries = initialEntries.map(function(entry) {
        return typeof entry === 'string' ? createLocation(entry, undefined, createKey()) : createLocation(entry, undefined, entry.key || createKey());
    }); // Public interface
    var createHref = createPath;
    function push(path, state) {
        var action = 'PUSH';
        var location = createLocation(path, state, createKey(), history.location);
        transitionManager.confirmTransitionTo(location, action, getUserConfirmation, function(ok) {
            if (!ok) return;
            var prevIndex = history.index;
            var nextIndex = prevIndex + 1;
            var nextEntries = history.entries.slice(0);
            if (nextEntries.length > nextIndex) nextEntries.splice(nextIndex, nextEntries.length - nextIndex, location);
            else nextEntries.push(location);
            setState({
                action: action,
                location: location,
                index: nextIndex,
                entries: nextEntries
            });
        });
    }
    function replace(path, state) {
        var action = 'REPLACE';
        var location = createLocation(path, state, createKey(), history.location);
        transitionManager.confirmTransitionTo(location, action, getUserConfirmation, function(ok) {
            if (!ok) return;
            history.entries[history.index] = location;
            setState({
                action: action,
                location: location
            });
        });
    }
    function go(n) {
        var nextIndex = clamp(history.index + n, 0, history.entries.length - 1);
        var action = 'POP';
        var location = history.entries[nextIndex];
        transitionManager.confirmTransitionTo(location, action, getUserConfirmation, function(ok) {
            if (ok) setState({
                action: action,
                location: location,
                index: nextIndex
            });
            else // Mimic the behavior of DOM histories by
            // causing a render after a cancelled POP.
            setState();
        });
    }
    function goBack() {
        go(-1);
    }
    function goForward() {
        go(1);
    }
    function canGo(n) {
        var nextIndex = history.index + n;
        return nextIndex >= 0 && nextIndex < history.entries.length;
    }
    function block(prompt) {
        if (prompt === void 0) prompt = false;
        return transitionManager.setPrompt(prompt);
    }
    function listen(listener) {
        return transitionManager.appendListener(listener);
    }
    var history = {
        length: entries.length,
        action: 'POP',
        location: entries[index],
        index: index,
        entries: entries,
        createHref: createHref,
        push: push,
        replace: replace,
        go: go,
        goBack: goBack,
        goForward: goForward,
        canGo: canGo,
        block: block,
        listen: listen
    };
    return history;
}

},{"@babel/runtime/helpers/esm/extends":"3LZYG","resolve-pathname":"bnyq9","value-equal":"91iMR","tiny-warning":"6MVuu","tiny-invariant":"9VWeJ","@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"3LZYG":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>_extends);
function _extends() {
    return _extends = Object.assign ? Object.assign.bind() : function(n) {
        for(var e = 1; e < arguments.length; e++){
            var t = arguments[e];
            for(var r in t)({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
        }
        return n;
    }, _extends.apply(null, arguments);
}

},{"@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"bnyq9":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
function isAbsolute(pathname) {
    return pathname.charAt(0) === '/';
}
// About 1.5x faster than the two-arg version of Array#splice()
function spliceOne(list, index) {
    for(var i = index, k = i + 1, n = list.length; k < n; i += 1, k += 1)list[i] = list[k];
    list.pop();
}
// This implementation is based heavily on node's url.parse
function resolvePathname(to, from) {
    if (from === undefined) from = '';
    var toParts = to && to.split('/') || [];
    var fromParts = from && from.split('/') || [];
    var isToAbs = to && isAbsolute(to);
    var isFromAbs = from && isAbsolute(from);
    var mustEndAbs = isToAbs || isFromAbs;
    if (to && isAbsolute(to)) // to is absolute
    fromParts = toParts;
    else if (toParts.length) {
        // to is relative, drop the filename
        fromParts.pop();
        fromParts = fromParts.concat(toParts);
    }
    if (!fromParts.length) return '/';
    var hasTrailingSlash;
    if (fromParts.length) {
        var last = fromParts[fromParts.length - 1];
        hasTrailingSlash = last === '.' || last === '..' || last === '';
    } else hasTrailingSlash = false;
    var up = 0;
    for(var i = fromParts.length; i >= 0; i--){
        var part = fromParts[i];
        if (part === '.') spliceOne(fromParts, i);
        else if (part === '..') {
            spliceOne(fromParts, i);
            up++;
        } else if (up) {
            spliceOne(fromParts, i);
            up--;
        }
    }
    if (!mustEndAbs) for(; up--; up)fromParts.unshift('..');
    if (mustEndAbs && fromParts[0] !== '' && (!fromParts[0] || !isAbsolute(fromParts[0]))) fromParts.unshift('');
    var result = fromParts.join('/');
    if (hasTrailingSlash && result.substr(-1) !== '/') result += '/';
    return result;
}
exports.default = resolvePathname;

},{"@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"91iMR":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
function valueOf(obj) {
    return obj.valueOf ? obj.valueOf() : Object.prototype.valueOf.call(obj);
}
function valueEqual(a, b) {
    // Test for strict equality first.
    if (a === b) return true;
    // Otherwise, if either of them == null they are not equal.
    if (a == null || b == null) return false;
    if (Array.isArray(a)) return Array.isArray(b) && a.length === b.length && a.every(function(item, index) {
        return valueEqual(item, b[index]);
    });
    if (typeof a === 'object' || typeof b === 'object') {
        var aValue = valueOf(a);
        var bValue = valueOf(b);
        if (aValue !== a || bValue !== b) return valueEqual(aValue, bValue);
        return Object.keys(Object.assign({}, a, b)).every(function(key) {
            return valueEqual(a[key], b[key]);
        });
    }
    return false;
}
exports.default = valueEqual;

},{"@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"6MVuu":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var isProduction = true;
function warning(condition, message) {
    if (!isProduction) {
        if (condition) return;
        var text = "Warning: " + message;
        if (typeof console !== 'undefined') console.warn(text);
        try {
            throw Error(text);
        } catch (x) {}
    }
}
exports.default = warning;

},{"@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"9VWeJ":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>invariant);
var isProduction = true;
var prefix = 'Invariant failed';
function invariant(condition, message) {
    if (condition) return;
    if (isProduction) throw new Error(prefix);
    var provided = typeof message === 'function' ? message() : message;
    var value = provided ? "".concat(prefix, ": ").concat(provided) : prefix;
    throw new Error(value);
}

},{"@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"kk7tw":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "Redirect", ()=>(0, _redirect.Redirect));
parcelHelpers.export(exports, "MemoryRouter", ()=>(0, _router.MemoryRouter));
parcelHelpers.export(exports, "Router", ()=>(0, _router.Router));
parcelHelpers.export(exports, "RouterActions", ()=>(0, _routerActions.RouterActions));
parcelHelpers.export(exports, "RouterSubscriber", ()=>(0, _routerSubscriber.RouterSubscriber));
parcelHelpers.export(exports, "createRouterSelector", ()=>(0, _routerStore.createRouterSelector));
parcelHelpers.export(exports, "usePathParam", ()=>(0, _usePathParam.usePathParam));
parcelHelpers.export(exports, "useQueryParam", ()=>(0, _useQueryParam.useQueryParam));
parcelHelpers.export(exports, "useRouter", ()=>(0, _useRouter.useRouter));
parcelHelpers.export(exports, "useRouterActions", ()=>(0, _useRouterActions.useRouterActions));
parcelHelpers.export(exports, "withRouter", ()=>(0, _withRouter.withRouter));
var _redirect = require("./redirect");
var _router = require("./router");
var _routerActions = require("./router-actions");
var _routerSubscriber = require("./router-subscriber");
var _routerStore = require("./router-store");
var _usePathParam = require("./use-path-param");
var _useQueryParam = require("./use-query-param");
var _useRouter = require("./use-router");
var _useRouterActions = require("./use-router-actions");
var _withRouter = require("./with-router");

},{"./redirect":"hsTvX","./router":"fEGHD","./router-actions":"2Y612","./router-subscriber":"9WdtL","./router-store":"bWF6v","./use-path-param":"7E9WY","./use-query-param":"kNkp7","./use-router":"cWUwl","./use-router-actions":"cJVir","./with-router":"1DmXX","@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"hsTvX":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "Redirect", ()=>Redirect);
var _extends = require("@babel/runtime/helpers/extends");
var _extendsDefault = parcelHelpers.interopDefault(_extends);
var _defineProperty = require("@babel/runtime/helpers/defineProperty");
var _definePropertyDefault = parcelHelpers.interopDefault(_defineProperty);
var _history = require("history");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _utils = require("../../common/utils");
var _useRouter = require("../use-router");
class Redirector extends (0, _react.Component) {
    componentDidMount() {
        const { to, location, push, params, query, actions } = this.props;
        const routeAttributes = {
            params,
            query,
            basePath: actions.getBasePath()
        };
        const newPath = typeof to === 'object' ? 'path' in to ? (0, _history.createPath)((0, _utils.generateLocationFromPath)(to.path, routeAttributes)) : (0, _history.createPath)(to) : to;
        const currentPath = (0, _history.createPath)(location);
        const action = push ? actions.push : actions.replace;
        if (currentPath === newPath) return;
        action(newPath);
    }
    render() {
        return null;
    }
}
(0, _definePropertyDefault.default)(Redirector, "defaultProps", {
    push: false
});
const Redirect = (props)=>{
    const [{ location }, actions] = (0, _useRouter.useRouter)();
    return /*#__PURE__*/ (0, _reactDefault.default).createElement(Redirector, (0, _extendsDefault.default)({
        actions: actions,
        location: location
    }, props));
};

},{"@babel/runtime/helpers/extends":"3LZYG","@babel/runtime/helpers/defineProperty":"8oXwS","history":"de6OM","react":"ltHCL","../../common/utils":"c9Uvk","../use-router":"cWUwl","@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"8oXwS":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>_defineProperty);
var _toPropertyKeyJs = require("./toPropertyKey.js");
var _toPropertyKeyJsDefault = parcelHelpers.interopDefault(_toPropertyKeyJs);
function _defineProperty(e, r, t) {
    return (r = (0, _toPropertyKeyJsDefault.default)(r)) in e ? Object.defineProperty(e, r, {
        value: t,
        enumerable: !0,
        configurable: !0,
        writable: !0
    }) : e[r] = t, e;
}

},{"./toPropertyKey.js":"5Jbo9","@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"5Jbo9":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>toPropertyKey);
var _typeofJs = require("./typeof.js");
var _typeofJsDefault = parcelHelpers.interopDefault(_typeofJs);
var _toPrimitiveJs = require("./toPrimitive.js");
var _toPrimitiveJsDefault = parcelHelpers.interopDefault(_toPrimitiveJs);
function toPropertyKey(t) {
    var i = (0, _toPrimitiveJsDefault.default)(t, "string");
    return "symbol" == (0, _typeofJsDefault.default)(i) ? i : i + "";
}

},{"./typeof.js":"jvCfw","./toPrimitive.js":"g96z4","@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"jvCfw":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>_typeof);
function _typeof(o) {
    "@babel/helpers - typeof";
    return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(o) {
        return typeof o;
    } : function(o) {
        return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
    }, _typeof(o);
}

},{"@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"g96z4":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>toPrimitive);
var _typeofJs = require("./typeof.js");
var _typeofJsDefault = parcelHelpers.interopDefault(_typeofJs);
function toPrimitive(t, r) {
    if ("object" != (0, _typeofJsDefault.default)(t) || !t) return t;
    var e = t[Symbol.toPrimitive];
    if (void 0 !== e) {
        var i = e.call(t, r || "default");
        if ("object" != (0, _typeofJsDefault.default)(i)) return i;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return ("string" === r ? String : Number)(t);
}

},{"./typeof.js":"jvCfw","@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"c9Uvk":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "createLegacyHistory", ()=>(0, _createLegacyHistory.createLegacyHistory));
parcelHelpers.export(exports, "generateLocationFromPath", ()=>(0, _generateLocation.generateLocationFromPath));
parcelHelpers.export(exports, "generatePath", ()=>(0, _generatePath.generatePath));
parcelHelpers.export(exports, "isServerEnvironment", ()=>(0, _isServerEnvironment.isServerEnvironment));
parcelHelpers.export(exports, "matchRoute", ()=>(0, _matchRouteDefault.default));
parcelHelpers.export(exports, "matchInvariantRoute", ()=>(0, _matchRoute.matchInvariantRoute));
parcelHelpers.export(exports, "warmupMatchRouteCache", ()=>(0, _matchRoute.warmupMatchRouteCache));
parcelHelpers.export(exports, "findRouterContext", ()=>(0, _routerContext.findRouterContext));
parcelHelpers.export(exports, "createRouterContext", ()=>(0, _routerContext.createRouterContext));
parcelHelpers.export(exports, "isSameRouteMatch", ()=>(0, _isSameRoute.isSameRouteMatch));
var _createLegacyHistory = require("./create-legacy-history");
var _generateLocation = require("./generate-location");
var _generatePath = require("./generate-path");
var _isServerEnvironment = require("./is-server-environment");
var _matchRoute = require("./match-route");
var _matchRouteDefault = parcelHelpers.interopDefault(_matchRoute);
var _routerContext = require("./router-context");
var _isSameRoute = require("./is-same-route");

},{"./create-legacy-history":"g4LEi","./generate-location":"7H81u","./generate-path":"5R6yQ","./is-server-environment":"80fz4","./match-route":"hyHJh","./router-context":"4hTEH","./is-same-route":"2ef2p","@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"g4LEi":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "createLegacyHistory", ()=>createLegacyHistory);
var _extends = require("@babel/runtime/helpers/extends");
var _extendsDefault = parcelHelpers.interopDefault(_extends);
var _history = require("history");
var _lodashDebounce = require("lodash.debounce");
var _lodashDebounceDefault = parcelHelpers.interopDefault(_lodashDebounce);
var _lodashNoop = require("lodash.noop");
var _lodashNoopDefault = parcelHelpers.interopDefault(_lodashNoop);
const hasWindow = ()=>typeof window !== 'undefined';
const methodsPlaceholders = {
    push: (0, _lodashNoopDefault.default),
    replace: (0, _lodashNoopDefault.default),
    goBack: (0, _lodashNoopDefault.default),
    goForward: (0, _lodashNoopDefault.default),
    listen: ()=>(0, _lodashNoopDefault.default),
    block: ()=>(0, _lodashNoopDefault.default)
};
const getLocation = ()=>{
    // todo - don't force non-optional search and hash
    const { pathname = '', search = '', hash = '' } = hasWindow() && window.location || {};
    return {
        pathname,
        search,
        hash
    };
};
const createLegacyListener = (updateExposedLocation)=>{
    const node = document.querySelector('#content');
    let prevHref = window.location.href;
    let listeners = [];
    const historyStack = [
        prevHref
    ];
    // note: window.history.length is capped at 50 entries
    let prevHistoryLength = window.history.length;
    let historyIndex = 0;
    const getAction = ()=>{
        const currentHref = window.location.href;
        if (prevHistoryLength === window.history.length) {
            if (historyStack[historyIndex - 1] === currentHref) {
                historyIndex -= 1;
                return 'POP';
            }
            if (historyStack[historyIndex + 1] === currentHref) {
                historyIndex += 1;
                return 'POP';
            }
            historyStack[historyStack.length - 1] = currentHref;
            return 'REPLACE';
        }
        historyStack.push(currentHref);
        historyIndex += 1;
        prevHistoryLength = window.history.length;
        return 'PUSH';
    };
    const onNodeChanges = (0, _lodashDebounceDefault.default)(()=>{
        if (prevHref !== window.location.href) {
            const newLocation = getLocation();
            const action = getAction();
            updateExposedLocation(newLocation, action);
            listeners.forEach((listener)=>listener(newLocation, action));
            prevHref = window.location.href;
        }
    }, 50);
    if (node) {
        const observer = new window.MutationObserver(onNodeChanges);
        observer.observe(node, {
            childList: true,
            subtree: true,
            attributes: true,
            characterData: true
        });
    }
    return (listener)=>{
        listeners = listeners.concat(listener);
        return ()=>{
            listeners = listeners.filter((lst)=>lst !== listener);
        };
    };
};
const createLegacyHistory = ()=>{
    let currentLocation = getLocation();
    let currentAction = 'PUSH';
    const updateExposedLocation = (v, a)=>{
        currentLocation = v;
        currentAction = a;
    };
    return (0, _extendsDefault.default)({
        get location () {
            return currentLocation;
        },
        get length () {
            return hasWindow() ? window.history.length : 1; // default length is 1
        },
        get action () {
            return currentAction;
        }
    }, hasWindow() ? {
        push: (path)=>window.location.assign(typeof path === 'string' ? path : (0, _history.createPath)(path || {})),
        replace: (path)=>window.history.replaceState({}, document.title, typeof path === 'string' ? path : (0, _history.createPath)(path || {})),
        goBack: ()=>window.history.back(),
        goForward: ()=>window.history.forward(),
        listen: createLegacyListener(updateExposedLocation),
        block: ()=>(0, _lodashNoopDefault.default),
        createHref: (location)=>(0, _history.createPath)(location)
    } : methodsPlaceholders);
};

},{"@babel/runtime/helpers/extends":"3LZYG","history":"de6OM","lodash.debounce":"3LxnQ","lodash.noop":"d72U3","@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"3LxnQ":[function(require,module,exports,__globalThis) {
/**
 * lodash (Custom Build) <https://lodash.com/>
 * Build: `lodash modularize exports="npm" -o ./`
 * Copyright jQuery Foundation and other contributors <https://jquery.org/>
 * Released under MIT license <https://lodash.com/license>
 * Based on Underscore.js 1.8.3 <http://underscorejs.org/LICENSE>
 * Copyright Jeremy Ashkenas, DocumentCloud and Investigative Reporters & Editors
 */ /** Used as the `TypeError` message for "Functions" methods. */ var global = arguments[3];
var FUNC_ERROR_TEXT = 'Expected a function';
/** Used as references for various `Number` constants. */ var NAN = 0 / 0;
/** `Object#toString` result references. */ var symbolTag = '[object Symbol]';
/** Used to match leading and trailing whitespace. */ var reTrim = /^\s+|\s+$/g;
/** Used to detect bad signed hexadecimal string values. */ var reIsBadHex = /^[-+]0x[0-9a-f]+$/i;
/** Used to detect binary string values. */ var reIsBinary = /^0b[01]+$/i;
/** Used to detect octal string values. */ var reIsOctal = /^0o[0-7]+$/i;
/** Built-in method references without a dependency on `root`. */ var freeParseInt = parseInt;
/** Detect free variable `global` from Node.js. */ var freeGlobal = typeof global == 'object' && global && global.Object === Object && global;
/** Detect free variable `self`. */ var freeSelf = typeof self == 'object' && self && self.Object === Object && self;
/** Used as a reference to the global object. */ var root = freeGlobal || freeSelf || Function('return this')();
/** Used for built-in method references. */ var objectProto = Object.prototype;
/**
 * Used to resolve the
 * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
 * of values.
 */ var objectToString = objectProto.toString;
/* Built-in method references for those with the same name as other `lodash` methods. */ var nativeMax = Math.max, nativeMin = Math.min;
/**
 * Gets the timestamp of the number of milliseconds that have elapsed since
 * the Unix epoch (1 January 1970 00:00:00 UTC).
 *
 * @static
 * @memberOf _
 * @since 2.4.0
 * @category Date
 * @returns {number} Returns the timestamp.
 * @example
 *
 * _.defer(function(stamp) {
 *   console.log(_.now() - stamp);
 * }, _.now());
 * // => Logs the number of milliseconds it took for the deferred invocation.
 */ var now = function() {
    return root.Date.now();
};
/**
 * Creates a debounced function that delays invoking `func` until after `wait`
 * milliseconds have elapsed since the last time the debounced function was
 * invoked. The debounced function comes with a `cancel` method to cancel
 * delayed `func` invocations and a `flush` method to immediately invoke them.
 * Provide `options` to indicate whether `func` should be invoked on the
 * leading and/or trailing edge of the `wait` timeout. The `func` is invoked
 * with the last arguments provided to the debounced function. Subsequent
 * calls to the debounced function return the result of the last `func`
 * invocation.
 *
 * **Note:** If `leading` and `trailing` options are `true`, `func` is
 * invoked on the trailing edge of the timeout only if the debounced function
 * is invoked more than once during the `wait` timeout.
 *
 * If `wait` is `0` and `leading` is `false`, `func` invocation is deferred
 * until to the next tick, similar to `setTimeout` with a timeout of `0`.
 *
 * See [David Corbacho's article](https://css-tricks.com/debouncing-throttling-explained-examples/)
 * for details over the differences between `_.debounce` and `_.throttle`.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Function
 * @param {Function} func The function to debounce.
 * @param {number} [wait=0] The number of milliseconds to delay.
 * @param {Object} [options={}] The options object.
 * @param {boolean} [options.leading=false]
 *  Specify invoking on the leading edge of the timeout.
 * @param {number} [options.maxWait]
 *  The maximum time `func` is allowed to be delayed before it's invoked.
 * @param {boolean} [options.trailing=true]
 *  Specify invoking on the trailing edge of the timeout.
 * @returns {Function} Returns the new debounced function.
 * @example
 *
 * // Avoid costly calculations while the window size is in flux.
 * jQuery(window).on('resize', _.debounce(calculateLayout, 150));
 *
 * // Invoke `sendMail` when clicked, debouncing subsequent calls.
 * jQuery(element).on('click', _.debounce(sendMail, 300, {
 *   'leading': true,
 *   'trailing': false
 * }));
 *
 * // Ensure `batchLog` is invoked once after 1 second of debounced calls.
 * var debounced = _.debounce(batchLog, 250, { 'maxWait': 1000 });
 * var source = new EventSource('/stream');
 * jQuery(source).on('message', debounced);
 *
 * // Cancel the trailing debounced invocation.
 * jQuery(window).on('popstate', debounced.cancel);
 */ function debounce(func, wait, options) {
    var lastArgs, lastThis, maxWait, result, timerId, lastCallTime, lastInvokeTime = 0, leading = false, maxing = false, trailing = true;
    if (typeof func != 'function') throw new TypeError(FUNC_ERROR_TEXT);
    wait = toNumber(wait) || 0;
    if (isObject(options)) {
        leading = !!options.leading;
        maxing = 'maxWait' in options;
        maxWait = maxing ? nativeMax(toNumber(options.maxWait) || 0, wait) : maxWait;
        trailing = 'trailing' in options ? !!options.trailing : trailing;
    }
    function invokeFunc(time) {
        var args = lastArgs, thisArg = lastThis;
        lastArgs = lastThis = undefined;
        lastInvokeTime = time;
        result = func.apply(thisArg, args);
        return result;
    }
    function leadingEdge(time) {
        // Reset any `maxWait` timer.
        lastInvokeTime = time;
        // Start the timer for the trailing edge.
        timerId = setTimeout(timerExpired, wait);
        // Invoke the leading edge.
        return leading ? invokeFunc(time) : result;
    }
    function remainingWait(time) {
        var timeSinceLastCall = time - lastCallTime, timeSinceLastInvoke = time - lastInvokeTime, result = wait - timeSinceLastCall;
        return maxing ? nativeMin(result, maxWait - timeSinceLastInvoke) : result;
    }
    function shouldInvoke(time) {
        var timeSinceLastCall = time - lastCallTime, timeSinceLastInvoke = time - lastInvokeTime;
        // Either this is the first call, activity has stopped and we're at the
        // trailing edge, the system time has gone backwards and we're treating
        // it as the trailing edge, or we've hit the `maxWait` limit.
        return lastCallTime === undefined || timeSinceLastCall >= wait || timeSinceLastCall < 0 || maxing && timeSinceLastInvoke >= maxWait;
    }
    function timerExpired() {
        var time = now();
        if (shouldInvoke(time)) return trailingEdge(time);
        // Restart the timer.
        timerId = setTimeout(timerExpired, remainingWait(time));
    }
    function trailingEdge(time) {
        timerId = undefined;
        // Only invoke if we have `lastArgs` which means `func` has been
        // debounced at least once.
        if (trailing && lastArgs) return invokeFunc(time);
        lastArgs = lastThis = undefined;
        return result;
    }
    function cancel() {
        if (timerId !== undefined) clearTimeout(timerId);
        lastInvokeTime = 0;
        lastArgs = lastCallTime = lastThis = timerId = undefined;
    }
    function flush() {
        return timerId === undefined ? result : trailingEdge(now());
    }
    function debounced() {
        var time = now(), isInvoking = shouldInvoke(time);
        lastArgs = arguments;
        lastThis = this;
        lastCallTime = time;
        if (isInvoking) {
            if (timerId === undefined) return leadingEdge(lastCallTime);
            if (maxing) {
                // Handle invocations in a tight loop.
                timerId = setTimeout(timerExpired, wait);
                return invokeFunc(lastCallTime);
            }
        }
        if (timerId === undefined) timerId = setTimeout(timerExpired, wait);
        return result;
    }
    debounced.cancel = cancel;
    debounced.flush = flush;
    return debounced;
}
/**
 * Checks if `value` is the
 * [language type](http://www.ecma-international.org/ecma-262/7.0/#sec-ecmascript-language-types)
 * of `Object`. (e.g. arrays, functions, objects, regexes, `new Number(0)`, and `new String('')`)
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an object, else `false`.
 * @example
 *
 * _.isObject({});
 * // => true
 *
 * _.isObject([1, 2, 3]);
 * // => true
 *
 * _.isObject(_.noop);
 * // => true
 *
 * _.isObject(null);
 * // => false
 */ function isObject(value) {
    var type = typeof value;
    return !!value && (type == 'object' || type == 'function');
}
/**
 * Checks if `value` is object-like. A value is object-like if it's not `null`
 * and has a `typeof` result of "object".
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is object-like, else `false`.
 * @example
 *
 * _.isObjectLike({});
 * // => true
 *
 * _.isObjectLike([1, 2, 3]);
 * // => true
 *
 * _.isObjectLike(_.noop);
 * // => false
 *
 * _.isObjectLike(null);
 * // => false
 */ function isObjectLike(value) {
    return !!value && typeof value == 'object';
}
/**
 * Checks if `value` is classified as a `Symbol` primitive or object.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a symbol, else `false`.
 * @example
 *
 * _.isSymbol(Symbol.iterator);
 * // => true
 *
 * _.isSymbol('abc');
 * // => false
 */ function isSymbol(value) {
    return typeof value == 'symbol' || isObjectLike(value) && objectToString.call(value) == symbolTag;
}
/**
 * Converts `value` to a number.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to process.
 * @returns {number} Returns the number.
 * @example
 *
 * _.toNumber(3.2);
 * // => 3.2
 *
 * _.toNumber(Number.MIN_VALUE);
 * // => 5e-324
 *
 * _.toNumber(Infinity);
 * // => Infinity
 *
 * _.toNumber('3.2');
 * // => 3.2
 */ function toNumber(value) {
    if (typeof value == 'number') return value;
    if (isSymbol(value)) return NAN;
    if (isObject(value)) {
        var other = typeof value.valueOf == 'function' ? value.valueOf() : value;
        value = isObject(other) ? other + '' : other;
    }
    if (typeof value != 'string') return value === 0 ? value : +value;
    value = value.replace(reTrim, '');
    var isBinary = reIsBinary.test(value);
    return isBinary || reIsOctal.test(value) ? freeParseInt(value.slice(2), isBinary ? 2 : 8) : reIsBadHex.test(value) ? NAN : +value;
}
module.exports = debounce;

},{}],"d72U3":[function(require,module,exports,__globalThis) {
/**
 * lodash 3.0.1 (Custom Build) <https://lodash.com/>
 * Build: `lodash modularize include="noop" exports="npm" -o ./foo`
 * Copyright 2012-2016 The Dojo Foundation <http://dojofoundation.org/>
 * Based on Underscore.js 1.8.3 <http://underscorejs.org/LICENSE>
 * Copyright 2009-2016 Jeremy Ashkenas, DocumentCloud and Investigative Reporters & Editors
 * Available under MIT license <https://lodash.com/license>
 */ /**
 * A no-operation function that returns `undefined` regardless of the
 * arguments it receives.
 *
 * @static
 * @memberOf _
 * @category Util
 * @example
 *
 * var object = { 'user': 'fred' };
 *
 * _.noop(object) === undefined;
 * // => true
 */ function noop() {
// No operation performed.
}
module.exports = noop;

},{}],"7H81u":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "generateLocationFromPath", ()=>generateLocationFromPath);
var _pathToRegexp = require("path-to-regexp");
var _urlParse = require("url-parse");
function generateLocationFromPath(pattern = '/', options = {}) {
    const { params = {}, query = {}, basePath = '' } = options;
    // @ts-ignore stringify accepts two params but it's type doesn't say so
    const stringifiedQuery = (0, _urlParse.qs).stringify(query, true);
    const pathname = pattern === '/' ? pattern : (0, _pathToRegexp.compile)(pattern)(params);
    return {
        pathname: `${basePath}${pathname}`,
        search: stringifiedQuery,
        hash: ''
    };
}

},{"path-to-regexp":"avfmR","url-parse":"ik7D1","@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"avfmR":[function(require,module,exports,__globalThis) {
/**
 * Tokenize input string.
 */ var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
/**
 * Parse a string for the raw tokens.
 */ parcelHelpers.export(exports, "parse", ()=>parse);
/**
 * Compile a string to a template function for the path.
 */ parcelHelpers.export(exports, "compile", ()=>compile);
/**
 * Expose a method for transforming tokens into the path function.
 */ parcelHelpers.export(exports, "tokensToFunction", ()=>tokensToFunction);
/**
 * Create path match function from `path-to-regexp` spec.
 */ parcelHelpers.export(exports, "match", ()=>match);
/**
 * Create a path match function from `path-to-regexp` output.
 */ parcelHelpers.export(exports, "regexpToFunction", ()=>regexpToFunction);
/**
 * Expose a function for taking tokens and returning a RegExp.
 */ parcelHelpers.export(exports, "tokensToRegexp", ()=>tokensToRegexp);
/**
 * Normalize the given path string, returning a regular expression.
 *
 * An empty array can be passed in for the keys, which will hold the
 * placeholder key descriptions. For example, using `/user/:id`, `keys` will
 * contain `[{ name: 'id', delimiter: '/', optional: false, repeat: false }]`.
 */ parcelHelpers.export(exports, "pathToRegexp", ()=>pathToRegexp);
function lexer(str) {
    var tokens = [];
    var i = 0;
    while(i < str.length){
        var char = str[i];
        if (char === "*" || char === "+" || char === "?") {
            tokens.push({
                type: "MODIFIER",
                index: i,
                value: str[i++]
            });
            continue;
        }
        if (char === "\\") {
            tokens.push({
                type: "ESCAPED_CHAR",
                index: i++,
                value: str[i++]
            });
            continue;
        }
        if (char === "{") {
            tokens.push({
                type: "OPEN",
                index: i,
                value: str[i++]
            });
            continue;
        }
        if (char === "}") {
            tokens.push({
                type: "CLOSE",
                index: i,
                value: str[i++]
            });
            continue;
        }
        if (char === ":") {
            var name = "";
            var j = i + 1;
            while(j < str.length){
                var code = str.charCodeAt(j);
                if (// `0-9`
                code >= 48 && code <= 57 || // `A-Z`
                code >= 65 && code <= 90 || // `a-z`
                code >= 97 && code <= 122 || // `_`
                code === 95) {
                    name += str[j++];
                    continue;
                }
                break;
            }
            if (!name) throw new TypeError("Missing parameter name at ".concat(i));
            tokens.push({
                type: "NAME",
                index: i,
                value: name
            });
            i = j;
            continue;
        }
        if (char === "(") {
            var count = 1;
            var pattern = "";
            var j = i + 1;
            if (str[j] === "?") throw new TypeError("Pattern cannot start with \"?\" at ".concat(j));
            while(j < str.length){
                if (str[j] === "\\") {
                    pattern += str[j++] + str[j++];
                    continue;
                }
                if (str[j] === ")") {
                    count--;
                    if (count === 0) {
                        j++;
                        break;
                    }
                } else if (str[j] === "(") {
                    count++;
                    if (str[j + 1] !== "?") throw new TypeError("Capturing groups are not allowed at ".concat(j));
                }
                pattern += str[j++];
            }
            if (count) throw new TypeError("Unbalanced pattern at ".concat(i));
            if (!pattern) throw new TypeError("Missing pattern at ".concat(i));
            tokens.push({
                type: "PATTERN",
                index: i,
                value: pattern
            });
            i = j;
            continue;
        }
        tokens.push({
            type: "CHAR",
            index: i,
            value: str[i++]
        });
    }
    tokens.push({
        type: "END",
        index: i,
        value: ""
    });
    return tokens;
}
function parse(str, options) {
    if (options === void 0) options = {};
    var tokens = lexer(str);
    var _a = options.prefixes, prefixes = _a === void 0 ? "./" : _a, _b = options.delimiter, delimiter = _b === void 0 ? "/#?" : _b;
    var result = [];
    var key = 0;
    var i = 0;
    var path = "";
    var tryConsume = function(type) {
        if (i < tokens.length && tokens[i].type === type) return tokens[i++].value;
    };
    var mustConsume = function(type) {
        var value = tryConsume(type);
        if (value !== undefined) return value;
        var _a = tokens[i], nextType = _a.type, index = _a.index;
        throw new TypeError("Unexpected ".concat(nextType, " at ").concat(index, ", expected ").concat(type));
    };
    var consumeText = function() {
        var result = "";
        var value;
        while(value = tryConsume("CHAR") || tryConsume("ESCAPED_CHAR"))result += value;
        return result;
    };
    var isSafe = function(value) {
        for(var _i = 0, delimiter_1 = delimiter; _i < delimiter_1.length; _i++){
            var char = delimiter_1[_i];
            if (value.indexOf(char) > -1) return true;
        }
        return false;
    };
    var safePattern = function(prefix) {
        var prev = result[result.length - 1];
        var prevText = prefix || (prev && typeof prev === "string" ? prev : "");
        if (prev && !prevText) throw new TypeError("Must have text between two parameters, missing text after \"".concat(prev.name, "\""));
        if (!prevText || isSafe(prevText)) return "[^".concat(escapeString(delimiter), "]+?");
        return "(?:(?!".concat(escapeString(prevText), ")[^").concat(escapeString(delimiter), "])+?");
    };
    while(i < tokens.length){
        var char = tryConsume("CHAR");
        var name = tryConsume("NAME");
        var pattern = tryConsume("PATTERN");
        if (name || pattern) {
            var prefix = char || "";
            if (prefixes.indexOf(prefix) === -1) {
                path += prefix;
                prefix = "";
            }
            if (path) {
                result.push(path);
                path = "";
            }
            result.push({
                name: name || key++,
                prefix: prefix,
                suffix: "",
                pattern: pattern || safePattern(prefix),
                modifier: tryConsume("MODIFIER") || ""
            });
            continue;
        }
        var value = char || tryConsume("ESCAPED_CHAR");
        if (value) {
            path += value;
            continue;
        }
        if (path) {
            result.push(path);
            path = "";
        }
        var open = tryConsume("OPEN");
        if (open) {
            var prefix = consumeText();
            var name_1 = tryConsume("NAME") || "";
            var pattern_1 = tryConsume("PATTERN") || "";
            var suffix = consumeText();
            mustConsume("CLOSE");
            result.push({
                name: name_1 || (pattern_1 ? key++ : ""),
                pattern: name_1 && !pattern_1 ? safePattern(prefix) : pattern_1,
                prefix: prefix,
                suffix: suffix,
                modifier: tryConsume("MODIFIER") || ""
            });
            continue;
        }
        mustConsume("END");
    }
    return result;
}
function compile(str, options) {
    return tokensToFunction(parse(str, options), options);
}
function tokensToFunction(tokens, options) {
    if (options === void 0) options = {};
    var reFlags = flags(options);
    var _a = options.encode, encode = _a === void 0 ? function(x) {
        return x;
    } : _a, _b = options.validate, validate = _b === void 0 ? true : _b;
    // Compile all the tokens into regexps.
    var matches = tokens.map(function(token) {
        if (typeof token === "object") return new RegExp("^(?:".concat(token.pattern, ")$"), reFlags);
    });
    return function(data) {
        var path = "";
        for(var i = 0; i < tokens.length; i++){
            var token = tokens[i];
            if (typeof token === "string") {
                path += token;
                continue;
            }
            var value = data ? data[token.name] : undefined;
            var optional = token.modifier === "?" || token.modifier === "*";
            var repeat = token.modifier === "*" || token.modifier === "+";
            if (Array.isArray(value)) {
                if (!repeat) throw new TypeError("Expected \"".concat(token.name, "\" to not repeat, but got an array"));
                if (value.length === 0) {
                    if (optional) continue;
                    throw new TypeError("Expected \"".concat(token.name, "\" to not be empty"));
                }
                for(var j = 0; j < value.length; j++){
                    var segment = encode(value[j], token);
                    if (validate && !matches[i].test(segment)) throw new TypeError("Expected all \"".concat(token.name, "\" to match \"").concat(token.pattern, "\", but got \"").concat(segment, "\""));
                    path += token.prefix + segment + token.suffix;
                }
                continue;
            }
            if (typeof value === "string" || typeof value === "number") {
                var segment = encode(String(value), token);
                if (validate && !matches[i].test(segment)) throw new TypeError("Expected \"".concat(token.name, "\" to match \"").concat(token.pattern, "\", but got \"").concat(segment, "\""));
                path += token.prefix + segment + token.suffix;
                continue;
            }
            if (optional) continue;
            var typeOfMessage = repeat ? "an array" : "a string";
            throw new TypeError("Expected \"".concat(token.name, "\" to be ").concat(typeOfMessage));
        }
        return path;
    };
}
function match(str, options) {
    var keys = [];
    var re = pathToRegexp(str, keys, options);
    return regexpToFunction(re, keys, options);
}
function regexpToFunction(re, keys, options) {
    if (options === void 0) options = {};
    var _a = options.decode, decode = _a === void 0 ? function(x) {
        return x;
    } : _a;
    return function(pathname) {
        var m = re.exec(pathname);
        if (!m) return false;
        var path = m[0], index = m.index;
        var params = Object.create(null);
        var _loop_1 = function(i) {
            if (m[i] === undefined) return "continue";
            var key = keys[i - 1];
            if (key.modifier === "*" || key.modifier === "+") params[key.name] = m[i].split(key.prefix + key.suffix).map(function(value) {
                return decode(value, key);
            });
            else params[key.name] = decode(m[i], key);
        };
        for(var i = 1; i < m.length; i++)_loop_1(i);
        return {
            path: path,
            index: index,
            params: params
        };
    };
}
/**
 * Escape a regular expression string.
 */ function escapeString(str) {
    return str.replace(/([.+*?=^!:${}()[\]|/\\])/g, "\\$1");
}
/**
 * Get the flags for a regexp from the options.
 */ function flags(options) {
    return options && options.sensitive ? "" : "i";
}
/**
 * Pull out keys from a regexp.
 */ function regexpToRegexp(path, keys) {
    if (!keys) return path;
    var groupsRegex = /\((?:\?<(.*?)>)?(?!\?)/g;
    var index = 0;
    var execResult = groupsRegex.exec(path.source);
    while(execResult){
        keys.push({
            // Use parenthesized substring match if available, index otherwise
            name: execResult[1] || index++,
            prefix: "",
            suffix: "",
            modifier: "",
            pattern: ""
        });
        execResult = groupsRegex.exec(path.source);
    }
    return path;
}
/**
 * Transform an array into a regexp.
 */ function arrayToRegexp(paths, keys, options) {
    var parts = paths.map(function(path) {
        return pathToRegexp(path, keys, options).source;
    });
    return new RegExp("(?:".concat(parts.join("|"), ")"), flags(options));
}
/**
 * Create a path regexp from string input.
 */ function stringToRegexp(path, keys, options) {
    return tokensToRegexp(parse(path, options), keys, options);
}
function tokensToRegexp(tokens, keys, options) {
    if (options === void 0) options = {};
    var _a = options.strict, strict = _a === void 0 ? false : _a, _b = options.start, start = _b === void 0 ? true : _b, _c = options.end, end = _c === void 0 ? true : _c, _d = options.encode, encode = _d === void 0 ? function(x) {
        return x;
    } : _d, _e = options.delimiter, delimiter = _e === void 0 ? "/#?" : _e, _f = options.endsWith, endsWith = _f === void 0 ? "" : _f;
    var endsWithRe = "[".concat(escapeString(endsWith), "]|$");
    var delimiterRe = "[".concat(escapeString(delimiter), "]");
    var route = start ? "^" : "";
    // Iterate over the tokens and create our regexp string.
    for(var _i = 0, tokens_1 = tokens; _i < tokens_1.length; _i++){
        var token = tokens_1[_i];
        if (typeof token === "string") route += escapeString(encode(token));
        else {
            var prefix = escapeString(encode(token.prefix));
            var suffix = escapeString(encode(token.suffix));
            if (token.pattern) {
                if (keys) keys.push(token);
                if (prefix || suffix) {
                    if (token.modifier === "+" || token.modifier === "*") {
                        var mod = token.modifier === "*" ? "?" : "";
                        route += "(?:".concat(prefix, "((?:").concat(token.pattern, ")(?:").concat(suffix).concat(prefix, "(?:").concat(token.pattern, "))*)").concat(suffix, ")").concat(mod);
                    } else route += "(?:".concat(prefix, "(").concat(token.pattern, ")").concat(suffix, ")").concat(token.modifier);
                } else {
                    if (token.modifier === "+" || token.modifier === "*") throw new TypeError("Can not repeat \"".concat(token.name, "\" without a prefix and suffix"));
                    route += "(".concat(token.pattern, ")").concat(token.modifier);
                }
            } else route += "(?:".concat(prefix).concat(suffix, ")").concat(token.modifier);
        }
    }
    if (end) {
        if (!strict) route += "".concat(delimiterRe, "?");
        route += !options.endsWith ? "$" : "(?=".concat(endsWithRe, ")");
    } else {
        var endToken = tokens[tokens.length - 1];
        var isEndDelimited = typeof endToken === "string" ? delimiterRe.indexOf(endToken[endToken.length - 1]) > -1 : endToken === undefined;
        if (!strict) route += "(?:".concat(delimiterRe, "(?=").concat(endsWithRe, "))?");
        if (!isEndDelimited) route += "(?=".concat(delimiterRe, "|").concat(endsWithRe, ")");
    }
    return new RegExp(route, flags(options));
}
function pathToRegexp(path, keys, options) {
    if (path instanceof RegExp) return regexpToRegexp(path, keys);
    if (Array.isArray(path)) return arrayToRegexp(path, keys, options);
    return stringToRegexp(path, keys, options);
}

},{"@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"ik7D1":[function(require,module,exports,__globalThis) {
var global = arguments[3];
'use strict';
var required = require("329ec8a109bdc597"), qs = require("905a608e5c8dc11d"), controlOrWhitespace = /^[\x00-\x20\u00a0\u1680\u2000-\u200a\u2028\u2029\u202f\u205f\u3000\ufeff]+/, CRHTLF = /[\n\r\t]/g, slashes = /^[A-Za-z][A-Za-z0-9+-.]*:\/\//, port = /:\d+$/, protocolre = /^([a-z][a-z0-9.+-]*:)?(\/\/)?([\\/]+)?([\S\s]*)/i, windowsDriveLetter = /^[a-zA-Z]:/;
/**
 * Remove control characters and whitespace from the beginning of a string.
 *
 * @param {Object|String} str String to trim.
 * @returns {String} A new string representing `str` stripped of control
 *     characters and whitespace from its beginning.
 * @public
 */ function trimLeft(str) {
    return (str ? str : '').toString().replace(controlOrWhitespace, '');
}
/**
 * These are the parse rules for the URL parser, it informs the parser
 * about:
 *
 * 0. The char it Needs to parse, if it's a string it should be done using
 *    indexOf, RegExp using exec and NaN means set as current value.
 * 1. The property we should set when parsing this value.
 * 2. Indication if it's backwards or forward parsing, when set as number it's
 *    the value of extra chars that should be split off.
 * 3. Inherit from location if non existing in the parser.
 * 4. `toLowerCase` the resulting value.
 */ var rules = [
    [
        '#',
        'hash'
    ],
    [
        '?',
        'query'
    ],
    function sanitize(address, url) {
        return isSpecial(url.protocol) ? address.replace(/\\/g, '/') : address;
    },
    [
        '/',
        'pathname'
    ],
    [
        '@',
        'auth',
        1
    ],
    [
        NaN,
        'host',
        undefined,
        1,
        1
    ],
    [
        /:(\d*)$/,
        'port',
        undefined,
        1
    ],
    [
        NaN,
        'hostname',
        undefined,
        1,
        1
    ] // Set left over.
];
/**
 * These properties should not be copied or inherited from. This is only needed
 * for all non blob URL's as a blob URL does not include a hash, only the
 * origin.
 *
 * @type {Object}
 * @private
 */ var ignore = {
    hash: 1,
    query: 1
};
/**
 * The location object differs when your code is loaded through a normal page,
 * Worker or through a worker using a blob. And with the blobble begins the
 * trouble as the location object will contain the URL of the blob, not the
 * location of the page where our code is loaded in. The actual origin is
 * encoded in the `pathname` so we can thankfully generate a good "default"
 * location from it so we can generate proper relative URL's again.
 *
 * @param {Object|String} loc Optional default location object.
 * @returns {Object} lolcation object.
 * @public
 */ function lolcation(loc) {
    var globalVar;
    if (typeof window !== 'undefined') globalVar = window;
    else if (typeof global !== 'undefined') globalVar = global;
    else if (typeof self !== 'undefined') globalVar = self;
    else globalVar = {};
    var location = globalVar.location || {};
    loc = loc || location;
    var finaldestination = {}, type = typeof loc, key;
    if ('blob:' === loc.protocol) finaldestination = new Url(unescape(loc.pathname), {});
    else if ('string' === type) {
        finaldestination = new Url(loc, {});
        for(key in ignore)delete finaldestination[key];
    } else if ('object' === type) {
        for(key in loc){
            if (key in ignore) continue;
            finaldestination[key] = loc[key];
        }
        if (finaldestination.slashes === undefined) finaldestination.slashes = slashes.test(loc.href);
    }
    return finaldestination;
}
/**
 * Check whether a protocol scheme is special.
 *
 * @param {String} The protocol scheme of the URL
 * @return {Boolean} `true` if the protocol scheme is special, else `false`
 * @private
 */ function isSpecial(scheme) {
    return scheme === 'file:' || scheme === 'ftp:' || scheme === 'http:' || scheme === 'https:' || scheme === 'ws:' || scheme === 'wss:';
}
/**
 * @typedef ProtocolExtract
 * @type Object
 * @property {String} protocol Protocol matched in the URL, in lowercase.
 * @property {Boolean} slashes `true` if protocol is followed by "//", else `false`.
 * @property {String} rest Rest of the URL that is not part of the protocol.
 */ /**
 * Extract protocol information from a URL with/without double slash ("//").
 *
 * @param {String} address URL we want to extract from.
 * @param {Object} location
 * @return {ProtocolExtract} Extracted information.
 * @private
 */ function extractProtocol(address, location) {
    address = trimLeft(address);
    address = address.replace(CRHTLF, '');
    location = location || {};
    var match = protocolre.exec(address);
    var protocol = match[1] ? match[1].toLowerCase() : '';
    var forwardSlashes = !!match[2];
    var otherSlashes = !!match[3];
    var slashesCount = 0;
    var rest;
    if (forwardSlashes) {
        if (otherSlashes) {
            rest = match[2] + match[3] + match[4];
            slashesCount = match[2].length + match[3].length;
        } else {
            rest = match[2] + match[4];
            slashesCount = match[2].length;
        }
    } else if (otherSlashes) {
        rest = match[3] + match[4];
        slashesCount = match[3].length;
    } else rest = match[4];
    if (protocol === 'file:') {
        if (slashesCount >= 2) rest = rest.slice(2);
    } else if (isSpecial(protocol)) rest = match[4];
    else if (protocol) {
        if (forwardSlashes) rest = rest.slice(2);
    } else if (slashesCount >= 2 && isSpecial(location.protocol)) rest = match[4];
    return {
        protocol: protocol,
        slashes: forwardSlashes || isSpecial(protocol),
        slashesCount: slashesCount,
        rest: rest
    };
}
/**
 * Resolve a relative URL pathname against a base URL pathname.
 *
 * @param {String} relative Pathname of the relative URL.
 * @param {String} base Pathname of the base URL.
 * @return {String} Resolved pathname.
 * @private
 */ function resolve(relative, base) {
    if (relative === '') return base;
    var path = (base || '/').split('/').slice(0, -1).concat(relative.split('/')), i = path.length, last = path[i - 1], unshift = false, up = 0;
    while(i--){
        if (path[i] === '.') path.splice(i, 1);
        else if (path[i] === '..') {
            path.splice(i, 1);
            up++;
        } else if (up) {
            if (i === 0) unshift = true;
            path.splice(i, 1);
            up--;
        }
    }
    if (unshift) path.unshift('');
    if (last === '.' || last === '..') path.push('');
    return path.join('/');
}
/**
 * The actual URL instance. Instead of returning an object we've opted-in to
 * create an actual constructor as it's much more memory efficient and
 * faster and it pleases my OCD.
 *
 * It is worth noting that we should not use `URL` as class name to prevent
 * clashes with the global URL instance that got introduced in browsers.
 *
 * @constructor
 * @param {String} address URL we want to parse.
 * @param {Object|String} [location] Location defaults for relative paths.
 * @param {Boolean|Function} [parser] Parser for the query string.
 * @private
 */ function Url(address, location, parser) {
    address = trimLeft(address);
    address = address.replace(CRHTLF, '');
    if (!(this instanceof Url)) return new Url(address, location, parser);
    var relative, extracted, parse, instruction, index, key, instructions = rules.slice(), type = typeof location, url = this, i = 0;
    //
    // The following if statements allows this module two have compatibility with
    // 2 different API:
    //
    // 1. Node.js's `url.parse` api which accepts a URL, boolean as arguments
    //    where the boolean indicates that the query string should also be parsed.
    //
    // 2. The `URL` interface of the browser which accepts a URL, object as
    //    arguments. The supplied object will be used as default values / fall-back
    //    for relative paths.
    //
    if ('object' !== type && 'string' !== type) {
        parser = location;
        location = null;
    }
    if (parser && 'function' !== typeof parser) parser = qs.parse;
    location = lolcation(location);
    //
    // Extract protocol information before running the instructions.
    //
    extracted = extractProtocol(address || '', location);
    relative = !extracted.protocol && !extracted.slashes;
    url.slashes = extracted.slashes || relative && location.slashes;
    url.protocol = extracted.protocol || location.protocol || '';
    address = extracted.rest;
    //
    // When the authority component is absent the URL starts with a path
    // component.
    //
    if (extracted.protocol === 'file:' && (extracted.slashesCount !== 2 || windowsDriveLetter.test(address)) || !extracted.slashes && (extracted.protocol || extracted.slashesCount < 2 || !isSpecial(url.protocol))) instructions[3] = [
        /(.*)/,
        'pathname'
    ];
    for(; i < instructions.length; i++){
        instruction = instructions[i];
        if (typeof instruction === 'function') {
            address = instruction(address, url);
            continue;
        }
        parse = instruction[0];
        key = instruction[1];
        if (parse !== parse) url[key] = address;
        else if ('string' === typeof parse) {
            index = parse === '@' ? address.lastIndexOf(parse) : address.indexOf(parse);
            if (~index) {
                if ('number' === typeof instruction[2]) {
                    url[key] = address.slice(0, index);
                    address = address.slice(index + instruction[2]);
                } else {
                    url[key] = address.slice(index);
                    address = address.slice(0, index);
                }
            }
        } else if (index = parse.exec(address)) {
            url[key] = index[1];
            address = address.slice(0, index.index);
        }
        url[key] = url[key] || (relative && instruction[3] ? location[key] || '' : '');
        //
        // Hostname, host and protocol should be lowercased so they can be used to
        // create a proper `origin`.
        //
        if (instruction[4]) url[key] = url[key].toLowerCase();
    }
    //
    // Also parse the supplied query string in to an object. If we're supplied
    // with a custom parser as function use that instead of the default build-in
    // parser.
    //
    if (parser) url.query = parser(url.query);
    //
    // If the URL is relative, resolve the pathname against the base URL.
    //
    if (relative && location.slashes && url.pathname.charAt(0) !== '/' && (url.pathname !== '' || location.pathname !== '')) url.pathname = resolve(url.pathname, location.pathname);
    //
    // Default to a / for pathname if none exists. This normalizes the URL
    // to always have a /
    //
    if (url.pathname.charAt(0) !== '/' && isSpecial(url.protocol)) url.pathname = '/' + url.pathname;
    //
    // We should not add port numbers if they are already the default port number
    // for a given protocol. As the host also contains the port number we're going
    // override it with the hostname which contains no port number.
    //
    if (!required(url.port, url.protocol)) {
        url.host = url.hostname;
        url.port = '';
    }
    //
    // Parse down the `auth` for the username and password.
    //
    url.username = url.password = '';
    if (url.auth) {
        index = url.auth.indexOf(':');
        if (~index) {
            url.username = url.auth.slice(0, index);
            url.username = encodeURIComponent(decodeURIComponent(url.username));
            url.password = url.auth.slice(index + 1);
            url.password = encodeURIComponent(decodeURIComponent(url.password));
        } else url.username = encodeURIComponent(decodeURIComponent(url.auth));
        url.auth = url.password ? url.username + ':' + url.password : url.username;
    }
    url.origin = url.protocol !== 'file:' && isSpecial(url.protocol) && url.host ? url.protocol + '//' + url.host : 'null';
    //
    // The href is just the compiled result.
    //
    url.href = url.toString();
}
/**
 * This is convenience method for changing properties in the URL instance to
 * insure that they all propagate correctly.
 *
 * @param {String} part          Property we need to adjust.
 * @param {Mixed} value          The newly assigned value.
 * @param {Boolean|Function} fn  When setting the query, it will be the function
 *                               used to parse the query.
 *                               When setting the protocol, double slash will be
 *                               removed from the final url if it is true.
 * @returns {URL} URL instance for chaining.
 * @public
 */ function set(part, value, fn) {
    var url = this;
    switch(part){
        case 'query':
            if ('string' === typeof value && value.length) value = (fn || qs.parse)(value);
            url[part] = value;
            break;
        case 'port':
            url[part] = value;
            if (!required(value, url.protocol)) {
                url.host = url.hostname;
                url[part] = '';
            } else if (value) url.host = url.hostname + ':' + value;
            break;
        case 'hostname':
            url[part] = value;
            if (url.port) value += ':' + url.port;
            url.host = value;
            break;
        case 'host':
            url[part] = value;
            if (port.test(value)) {
                value = value.split(':');
                url.port = value.pop();
                url.hostname = value.join(':');
            } else {
                url.hostname = value;
                url.port = '';
            }
            break;
        case 'protocol':
            url.protocol = value.toLowerCase();
            url.slashes = !fn;
            break;
        case 'pathname':
        case 'hash':
            if (value) {
                var char = part === 'pathname' ? '/' : '#';
                url[part] = value.charAt(0) !== char ? char + value : value;
            } else url[part] = value;
            break;
        case 'username':
        case 'password':
            url[part] = encodeURIComponent(value);
            break;
        case 'auth':
            var index = value.indexOf(':');
            if (~index) {
                url.username = value.slice(0, index);
                url.username = encodeURIComponent(decodeURIComponent(url.username));
                url.password = value.slice(index + 1);
                url.password = encodeURIComponent(decodeURIComponent(url.password));
            } else url.username = encodeURIComponent(decodeURIComponent(value));
    }
    for(var i = 0; i < rules.length; i++){
        var ins = rules[i];
        if (ins[4]) url[ins[1]] = url[ins[1]].toLowerCase();
    }
    url.auth = url.password ? url.username + ':' + url.password : url.username;
    url.origin = url.protocol !== 'file:' && isSpecial(url.protocol) && url.host ? url.protocol + '//' + url.host : 'null';
    url.href = url.toString();
    return url;
}
/**
 * Transform the properties back in to a valid and full URL string.
 *
 * @param {Function} stringify Optional query stringify function.
 * @returns {String} Compiled version of the URL.
 * @public
 */ function toString(stringify) {
    if (!stringify || 'function' !== typeof stringify) stringify = qs.stringify;
    var query, url = this, host = url.host, protocol = url.protocol;
    if (protocol && protocol.charAt(protocol.length - 1) !== ':') protocol += ':';
    var result = protocol + (url.protocol && url.slashes || isSpecial(url.protocol) ? '//' : '');
    if (url.username) {
        result += url.username;
        if (url.password) result += ':' + url.password;
        result += '@';
    } else if (url.password) {
        result += ':' + url.password;
        result += '@';
    } else if (url.protocol !== 'file:' && isSpecial(url.protocol) && !host && url.pathname !== '/') //
    // Add back the empty userinfo, otherwise the original invalid URL
    // might be transformed into a valid one with `url.pathname` as host.
    //
    result += '@';
    //
    // Trailing colon is removed from `url.host` when it is parsed. If it still
    // ends with a colon, then add back the trailing colon that was removed. This
    // prevents an invalid URL from being transformed into a valid one.
    //
    if (host[host.length - 1] === ':' || port.test(url.hostname) && !url.port) host += ':';
    result += host + url.pathname;
    query = 'object' === typeof url.query ? stringify(url.query) : url.query;
    if (query) result += '?' !== query.charAt(0) ? '?' + query : query;
    if (url.hash) result += url.hash;
    return result;
}
Url.prototype = {
    set: set,
    toString: toString
};
//
// Expose the URL parser and some additional properties that might be useful for
// others or testing.
//
Url.extractProtocol = extractProtocol;
Url.location = lolcation;
Url.trimLeft = trimLeft;
Url.qs = qs;
module.exports = Url;

},{"329ec8a109bdc597":"c0hje","905a608e5c8dc11d":"51Vqi"}],"c0hje":[function(require,module,exports,__globalThis) {
'use strict';
/**
 * Check if we're required to add a port number.
 *
 * @see https://url.spec.whatwg.org/#default-port
 * @param {Number|String} port Port number we need to check
 * @param {String} protocol Protocol we need to check against.
 * @returns {Boolean} Is it a default port for the given protocol
 * @api private
 */ module.exports = function required(port, protocol) {
    protocol = protocol.split(':')[0];
    port = +port;
    if (!port) return false;
    switch(protocol){
        case 'http':
        case 'ws':
            return port !== 80;
        case 'https':
        case 'wss':
            return port !== 443;
        case 'ftp':
            return port !== 21;
        case 'gopher':
            return port !== 70;
        case 'file':
            return false;
    }
    return port !== 0;
};

},{}],"51Vqi":[function(require,module,exports,__globalThis) {
'use strict';
var has = Object.prototype.hasOwnProperty, undef;
/**
 * Decode a URI encoded string.
 *
 * @param {String} input The URI encoded string.
 * @returns {String|Null} The decoded string.
 * @api private
 */ function decode(input) {
    try {
        return decodeURIComponent(input.replace(/\+/g, ' '));
    } catch (e) {
        return null;
    }
}
/**
 * Attempts to encode a given input.
 *
 * @param {String} input The string that needs to be encoded.
 * @returns {String|Null} The encoded string.
 * @api private
 */ function encode(input) {
    try {
        return encodeURIComponent(input);
    } catch (e) {
        return null;
    }
}
/**
 * Simple query string parser.
 *
 * @param {String} query The query string that needs to be parsed.
 * @returns {Object}
 * @api public
 */ function querystring(query) {
    var parser = /([^=?#&]+)=?([^&]*)/g, result = {}, part;
    while(part = parser.exec(query)){
        var key = decode(part[1]), value = decode(part[2]);
        //
        // Prevent overriding of existing properties. This ensures that build-in
        // methods like `toString` or __proto__ are not overriden by malicious
        // querystrings.
        //
        // In the case if failed decoding, we want to omit the key/value pairs
        // from the result.
        //
        if (key === null || value === null || key in result) continue;
        result[key] = value;
    }
    return result;
}
/**
 * Transform a query string to an object.
 *
 * @param {Object} obj Object that should be transformed.
 * @param {String} prefix Optional prefix.
 * @returns {String}
 * @api public
 */ function querystringify(obj, prefix) {
    prefix = prefix || '';
    var pairs = [], value, key;
    //
    // Optionally prefix with a '?' if needed
    //
    if ('string' !== typeof prefix) prefix = '?';
    for(key in obj)if (has.call(obj, key)) {
        value = obj[key];
        //
        // Edge cases where we actually want to encode the value to an empty
        // string instead of the stringified value.
        //
        if (!value && (value === null || value === undef || isNaN(value))) value = '';
        key = encode(key);
        value = encode(value);
        //
        // If we failed to encode the strings, we should bail out as we don't
        // want to add invalid strings to the query.
        //
        if (key === null || value === null) continue;
        pairs.push(key + '=' + value);
    }
    return pairs.length ? prefix + pairs.join('&') : '';
}
//
// Expose the module.
//
exports.stringify = querystringify;
exports.parse = querystring;

},{}],"5R6yQ":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "generatePath", ()=>generatePath);
var _pathToRegexp = require("path-to-regexp");
const generatePath = (pattern = '/', params)=>pattern === '/' ? pattern : (0, _pathToRegexp.compile)(pattern)(params);

},{"path-to-regexp":"avfmR","@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"80fz4":[function(require,module,exports,__globalThis) {
/**
 * @see https://github.com/jsdom/jsdom/releases/tag/12.0.0
 * @see https://github.com/jsdom/jsdom/issues/1537
 */ var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "isServerEnvironment", ()=>isServerEnvironment);
var process = require("3d2480246865d012");
const isJsDomEnvironment = ()=>{
    var _navigator, _navigator2;
    return window.name === 'nodejs' || ((_navigator = navigator) == null ? void 0 : _navigator.userAgent.includes('Node.js')) || ((_navigator2 = navigator) == null ? void 0 : _navigator2.userAgent.includes('jsdom'));
};
const isServerEnvironment = ()=>{
    if (typeof window === 'undefined' || typeof process !== 'undefined' && process.versions != null && process.versions.node != null) return true;
    if (isJsDomEnvironment()) return true;
    return false;
};

},{"3d2480246865d012":"gNLf3","@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"hyHJh":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "matchInvariantRoute", ()=>matchInvariantRoute);
parcelHelpers.export(exports, "warmupMatchRouteCache", ()=>warmupMatchRouteCache);
var _urlParse = require("url-parse");
var _execRouteMatching = require("./exec-route-matching");
var _execRouteMatchingDefault = parcelHelpers.interopDefault(_execRouteMatching);
var _utils = require("./utils");
/**
 * Does the given `pathname` and `queryStr` match a route in `routes`.
 *
 * Heavily based on https://github.com/ReactTraining/react-router/blob/master/packages/react-router-config/modules/matchRoute.js
 *
 * Note: This does not support nested routes at this stage.
 */ const matchRoute = (routes, pathname, queryParams = {}, basePath = '')=>{
    const queryParamObject = typeof queryParams === 'string' ? (0, _urlParse.qs).parse(queryParams) : queryParams;
    const cachedMatch = (0, _utils.matchRouteCache).get(pathname, queryParamObject, basePath);
    if (cachedMatch && routes.includes(cachedMatch.route)) return cachedMatch;
    for(let i = 0; i < routes.length; i++){
        const matchedRoute = (0, _execRouteMatchingDefault.default)(routes[i], pathname, queryParamObject, basePath);
        if (matchedRoute) {
            (0, _utils.matchRouteCache).set(pathname, queryParamObject, basePath, matchedRoute);
            return matchedRoute;
        }
    }
    return null;
};
const matchInvariantRoute = (routes, pathname, queryParams, basePath = '')=>matchRoute(routes, pathname, queryParams, basePath);
const warmupMatchRouteCache = (route, pathname, queryParams, basePath = '')=>{
    matchRoute([
        route
    ], pathname, queryParams, basePath);
};
exports.default = (routes, pathname, queryParams, basePath = '')=>matchRoute(routes, pathname, queryParams, basePath);

},{"url-parse":"ik7D1","./exec-route-matching":"kzY7m","./utils":"e9U9x","@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"kzY7m":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _extends = require("@babel/runtime/helpers/extends");
var _extendsDefault = parcelHelpers.interopDefault(_extends);
var _matchPath = require("./matchPath");
var _matchPathDefault = parcelHelpers.interopDefault(_matchPath);
var _matchQuery = require("./matchQuery");
var _matchQueryDefault = parcelHelpers.interopDefault(_matchQuery);
/* This should match what react-router does to compute a root match. */ const computeRootMatch = (pathname)=>({
        path: '/',
        url: '/',
        params: {},
        isExact: pathname === '/',
        query: {}
    });
function execRouteMatching(route, pathname, queryObj, basePath) {
    const pathMatch = route.path ? (0, _matchPathDefault.default)(pathname, {
        path: route.path,
        exact: route.exact,
        basePath
    }) : computeRootMatch(pathname);
    let match = pathMatch;
    if (pathMatch && route.query) match = (0, _matchQueryDefault.default)(route.query, queryObj, pathMatch);
    else if (pathMatch) match = (0, _extendsDefault.default)({}, pathMatch, {
        query: {}
    });
    if (match) return {
        match,
        route
    };
    return null;
}
exports.default = execRouteMatching;

},{"@babel/runtime/helpers/extends":"3LZYG","./matchPath":"9gI1X","./matchQuery":"bLdQz","@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"9gI1X":[function(require,module,exports,__globalThis) {
// TAKEN FROM https://github.com/ReactTraining/react-router/blob/master/packages/react-router/modules/matchPath.js
var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _pathToRegexp = require("path-to-regexp");
const cache = {};
const cacheLimit = 10000;
let cacheCount = 0;
function compilePath(path, options) {
    const cacheKey = `${options.end}${options.strict}${options.sensitive}`;
    const pathCache = cache[cacheKey] || (cache[cacheKey] = {});
    if (pathCache[path]) return pathCache[path];
    const keys = [];
    const regexp = (0, _pathToRegexp.pathToRegexp)(path, keys, options);
    const result = {
        regexp,
        keys
    };
    if (cacheCount < cacheLimit) {
        pathCache[path] = result;
        cacheCount++;
    }
    return result;
}
/**
 * Public API for matching a URL pathname to a path.
 * TODO: reduce returns Array<never>
 */ function matchPath(pathname, options = {}) {
    if (typeof options === 'string' || Array.isArray(options)) options = {
        path: options
    };
    const { path: p, exact = false, strict = false, sensitive = false, basePath = '' } = options;
    const paths = [].concat(basePath + p);
    return paths.reduce((matched, path)=>{
        if (!path && path !== '') return null;
        if (matched) return matched;
        const { regexp, keys } = compilePath(path, {
            end: exact,
            strict,
            sensitive
        });
        const match = regexp.exec(pathname);
        if (!match) return null;
        const [url, ...values] = match;
        const isExact = pathname === url;
        if (exact && !isExact) return null;
        return {
            path,
            // the path used to match
            url: path === '/' && url === '' ? '/' : url,
            // the matched portion of the URL
            isExact,
            // whether or not we matched exactly
            params: keys.reduce((memo, key, index)=>{
                memo[key.name] = values[index];
                return memo;
            }, {})
        };
    }, null);
}
exports.default = matchPath;

},{"path-to-regexp":"avfmR","@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"bLdQz":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _extends = require("@babel/runtime/helpers/extends");
var _extendsDefault = parcelHelpers.interopDefault(_extends);
/**
 * Matches `queryStr` against config stored in `queryConfig`.
 *
 * Returns `pathMatch` with an additional query prop with query params if the match succeeds,
 * otherwise returns null.
 *
 */ function matchQuery(queryConfig, queryParams, pathMatch) {
    const queryMatch = {};
    const isMatchingQuery = queryConfig.every((query)=>{
        // eslint-disable-next-line prefer-const
        let [names, value] = query.split('=');
        let negation = false;
        /* Check if negative matching query param (eg 'foo!=1') */ if (query.includes('!=')) {
            names = names.substring(0, names.length - 1);
            negation = true;
        }
        /* Allow alternate query params presence (eg 'foo|bar') */ const matched = names.split('|').map((name)=>{
            let isOptional = false;
            /* Check if optional query param (eg 'foo?') */ if (name.includes('?')) {
                // eslint-disable-next-line no-param-reassign
                name = name.substring(0, name.length - 1);
                isOptional = true;
            }
            /* First check if queryParams contains the relevant param */ let match = Object.prototype.hasOwnProperty.call(queryParams, name);
            /* Save actual value so we expose it as part of match object */ if (match) queryMatch[name] = queryParams[name] || '';
            /* If no value matching required or it is optional and the param is missing */ if (!value || isOptional && !match) return isOptional || match;
            if (value.startsWith('(')) /* Handle value being a regexp eg 's=(\\d+)' */ match = new RegExp(`^${value}$`).test(queryParams[name] || '');
            else /* Handle value exact matching eg 's=123' */ match = queryParams[name] === value;
            return negation ? !match : match;
        });
        /* If at least one of alternate query params matches then it is a match */ return matched.includes(true);
    });
    return isMatchingQuery ? (0, _extendsDefault.default)({}, pathMatch, {
        query: queryMatch
    }) : null;
}
exports.default = matchQuery;

},{"@babel/runtime/helpers/extends":"3LZYG","@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"e9U9x":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "matchRouteCache", ()=>matchRouteCache);
const hasOwnProperty = Object.prototype.hasOwnProperty;
const MAX_CACHE_SIZE = 1000;
function shallowEqual(objA, objB) {
    if (objA === objB) return true;
    if (typeof objA !== 'object' || objA === null || typeof objB !== 'object' || objB === null) return false;
    const keysA = Object.keys(objA);
    const keysB = Object.keys(objB);
    if (keysA.length !== keysB.length) return false;
    // Test for A's keys different from B.
    for(let i = 0; i < keysA.length; i++){
        if (!hasOwnProperty.call(objB, keysA[i]) || objA[keysA[i]] !== objB[keysA[i]]) return false;
    }
    return true;
}
const matchRouteCache = {
    cache: new Map(),
    get (pathname, queryObj, basePath) {
        const pathCache = this.cache.get(basePath + pathname);
        if (pathCache) for (const [key, value] of pathCache){
            if (shallowEqual(key, queryObj)) return value;
        }
    },
    set (pathname, queryObj, basePath, matchRoute) {
        if (this.cache.size > MAX_CACHE_SIZE) this.cache.clear();
        const pathCache = this.cache.get(basePath + pathname);
        if (pathCache) {
            if (pathCache.size > MAX_CACHE_SIZE / 10) pathCache.clear();
            pathCache.set(queryObj, matchRoute);
        } else this.cache.set(basePath + pathname, new Map([
            [
                queryObj,
                matchRoute
            ]
        ]));
    }
};

},{"@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"4hTEH":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "createRouterContext", ()=>createRouterContext);
parcelHelpers.export(exports, "findRouterContext", ()=>findRouterContext);
var _urlParse = require("url-parse");
var _constants = require("../../constants");
var _generatePath = require("../generate-path");
var _matchRoute = require("../match-route");
var _matchRouteDefault = parcelHelpers.interopDefault(_matchRoute);
const createRouterContext = (route, options = {})=>{
    const { params = {}, query = {}, basePath = '' } = options;
    const pathname = (0, _generatePath.generatePath)(route.path, params);
    const matchedRoute = (0, _matchRouteDefault.default)([
        route
    ], pathname, query, basePath);
    return {
        route,
        match: matchedRoute ? matchedRoute.match : (0, _constants.DEFAULT_MATCH),
        query
    };
};
const findRouterContext = (routes, options)=>{
    const { location, basePath = '' } = options;
    const { pathname, search } = location;
    const query = (0, _urlParse.qs).parse(search);
    const matchedRoute = (0, _matchRouteDefault.default)(routes, pathname, query, basePath);
    return {
        query,
        route: matchedRoute ? matchedRoute.route : (0, _constants.DEFAULT_ROUTE),
        match: matchedRoute ? matchedRoute.match : (0, _constants.DEFAULT_MATCH)
    };
};

},{"url-parse":"ik7D1","../../constants":"cYZ0C","../generate-path":"5R6yQ","../match-route":"hyHJh","@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"cYZ0C":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "DEFAULT_LOCATION", ()=>DEFAULT_LOCATION);
parcelHelpers.export(exports, "DEFAULT_MATCH", ()=>DEFAULT_MATCH);
parcelHelpers.export(exports, "DEFAULT_ROUTE", ()=>DEFAULT_ROUTE);
parcelHelpers.export(exports, "DEFAULT_HISTORY", ()=>DEFAULT_HISTORY);
parcelHelpers.export(exports, "NOOP_HISTORY", ()=>NOOP_HISTORY);
parcelHelpers.export(exports, "DEFAULT_ACTION", ()=>DEFAULT_ACTION);
var _lodashNoop = require("lodash.noop");
var _lodashNoopDefault = parcelHelpers.interopDefault(_lodashNoop);
var _createLegacyHistory = require("./utils/create-legacy-history");
const DEFAULT_LOCATION = {
    pathname: '',
    search: '',
    hash: ''
};
const DEFAULT_MATCH = {
    params: {},
    isExact: false,
    path: '',
    url: '',
    query: {}
};
const DEFAULT_ROUTE = {
    path: '',
    component: ()=>null,
    name: ''
};
const DEFAULT_HISTORY = (0, _createLegacyHistory.createLegacyHistory)();
const NOOP_HISTORY = {
    location: DEFAULT_LOCATION,
    push: (0, _lodashNoopDefault.default),
    replace: (0, _lodashNoopDefault.default),
    goBack: (0, _lodashNoopDefault.default),
    goForward: (0, _lodashNoopDefault.default),
    listen: (0, _lodashNoopDefault.default),
    block: (0, _lodashNoopDefault.default),
    createHref: (0, _lodashNoopDefault.default)
};
const DEFAULT_ACTION = 'POP';

},{"lodash.noop":"d72U3","./utils/create-legacy-history":"g4LEi","@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"2ef2p":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "isSameRouteMatch", ()=>isSameRouteMatch);
const isShallowEqual = (o1, o2)=>{
    const objKeys1 = Object.keys(o1);
    const objKeys2 = Object.keys(o2);
    if (objKeys1.length !== objKeys2.length) return false;
    return objKeys1.every((key)=>o1[key] === o2[key]);
};
const isSameRouteMatch = ({ prevContextMatch, nextContextMatch })=>prevContextMatch.path === nextContextMatch.path && isShallowEqual(prevContextMatch.query, nextContextMatch.query) && isShallowEqual(prevContextMatch.params, nextContextMatch.params);

},{"@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"cWUwl":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "useRouter", ()=>useRouter);
var _routerStore = require("../router-store");
const useRouter = (0, _routerStore.useRouterStore);

},{"../router-store":"bWF6v","@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"bWF6v":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "INITIAL_STATE", ()=>INITIAL_STATE);
parcelHelpers.export(exports, "RouterStore", ()=>RouterStore);
parcelHelpers.export(exports, "RouterContainer", ()=>RouterContainer);
parcelHelpers.export(exports, "useRouterStore", ()=>useRouterStore);
parcelHelpers.export(exports, "useRouterStoreActions", ()=>useRouterStoreActions);
/**
 * Utility to create custom hooks without re-rendering on route change
 */ parcelHelpers.export(exports, "createRouterSelector", ()=>createRouterSelector);
parcelHelpers.export(exports, "getRouterStore", ()=>getRouterStore);
parcelHelpers.export(exports, "getRouterState", ()=>getRouterState);
var _extends = require("@babel/runtime/helpers/extends");
var _extendsDefault = parcelHelpers.interopDefault(_extends);
var _history = require("history");
var _reactSweetState = require("react-sweet-state");
var _constants = require("../../common/constants");
var _utils = require("../../common/utils");
var _utils1 = require("./utils");
const INITIAL_STATE = {
    action: (0, _constants.DEFAULT_ACTION),
    basePath: '',
    location: (0, _constants.DEFAULT_HISTORY).location,
    history: (0, _constants.DEFAULT_HISTORY),
    match: (0, _constants.DEFAULT_MATCH),
    onPrefetch: undefined,
    query: {},
    route: (0, _constants.DEFAULT_ROUTE),
    routes: [],
    unlisten: null,
    plugins: []
};
const actions = {
    /**
   * Bootstraps the store with initial data.
   *
   */ bootstrapStore: (props)=>({ setState, dispatch })=>{
            const { basePath = '', history, initialRoute, onPrefetch, routes, plugins } = props;
            const routerContext = (0, _utils.findRouterContext)(initialRoute ? [
                initialRoute
            ] : routes, {
                location: history.location,
                basePath
            });
            setState((0, _extendsDefault.default)({}, routerContext, {
                basePath,
                history,
                onPrefetch,
                routes,
                location: history.location,
                action: history.action,
                plugins
            }));
            if (!(0, _utils.isServerEnvironment)()) dispatch(actions.listen());
        },
    /**
   * Starts listening to browser history and sets the unlisten function in state.
   * Will request route resources on route change.
   *
   */ listen: ()=>({ getState, setState })=>{
            const { history, unlisten } = getState();
            if (unlisten) unlisten();
            const stopListening = history.listen((...update)=>{
                const location = update.length === 2 ? update[0] : update[0].location;
                const action = update.length === 2 ? update[1] : update[0].action;
                const { plugins, routes, basePath, match: currentMatch, route: currentRoute, query: currentQuery } = getState();
                const nextContext = (0, _utils.findRouterContext)(routes, {
                    location,
                    basePath
                });
                const prevContext = {
                    route: currentRoute,
                    match: currentMatch,
                    query: currentQuery
                };
                const shouldReloadByPlugin = new Map(plugins.map((plugin)=>[
                        plugin.id,
                        (0, _utils1.shouldReload)({
                            context: nextContext,
                            prevContext,
                            pluginId: plugin.id
                        })
                    ]));
                /* Explicitly batch update
       * as we need resources cleaned + route changed + resource fetch started together
       * If we do not batch, React might be re-render when route changes but resource
       * fetching has not started yet, making the app render with data null */ (0, _reactSweetState.batch)(()=>{
                    plugins.forEach((p)=>{
                        if (shouldReloadByPlugin.get(p.id)) p.beforeRouteLoad == null || p.beforeRouteLoad({
                            context: prevContext,
                            nextContext
                        });
                    });
                    setState((0, _extendsDefault.default)({}, nextContext, {
                        location,
                        action
                    }));
                    plugins.forEach((p)=>{
                        if (shouldReloadByPlugin.get(p.id)) p.routeLoad == null || p.routeLoad({
                            context: nextContext,
                            prevContext
                        });
                    });
                });
            });
            setState({
                unlisten: stopListening
            });
        },
    push: (path, state)=>({ getState })=>{
            const { history, basePath } = getState();
            if ((0, _utils1.isExternalAbsolutePath)(path)) window.location.assign(path);
            else history.push((0, _utils1.getRelativePath)(path, basePath), state);
        },
    pushTo: (route, attributes = {})=>({ getState })=>{
            const { history, basePath } = getState();
            const location = (0, _utils.generateLocationFromPath)(route.path, (0, _extendsDefault.default)({}, attributes, {
                basePath
            }));
            (0, _utils.warmupMatchRouteCache)(route, location.pathname, attributes.query, basePath);
            history.push(location, attributes == null ? void 0 : attributes.state);
        },
    replace: (path, state)=>({ getState })=>{
            const { history, basePath } = getState();
            if ((0, _utils1.isExternalAbsolutePath)(path)) window.location.replace(path);
            else history.replace((0, _utils1.getRelativePath)(path, basePath), state);
        },
    replaceTo: (route, attributes = {})=>({ getState })=>{
            const { history, basePath } = getState();
            const location = (0, _utils.generateLocationFromPath)(route.path, (0, _extendsDefault.default)({}, attributes, {
                basePath
            }));
            (0, _utils.warmupMatchRouteCache)(route, location.pathname, attributes.query, basePath);
            history.replace(location, attributes == null ? void 0 : attributes.state);
        },
    goBack: ()=>({ getState })=>{
            const { history } = getState();
            // history@4 uses goBack(), history@5 uses back()
            if ('goBack' in history) history.goBack();
            else if ('back' in history) history.back();
            else throw new Error('History does not support goBack');
        },
    goForward: ()=>({ getState })=>{
            const { history } = getState();
            // history@4 uses goForward(), history@5 uses forward()
            if ('goForward' in history) history.goForward();
            else if ('forward' in history) history.forward();
            else throw new Error('History does not support goForward');
        },
    registerBlock: (blocker)=>({ getState })=>{
            const { history } = getState();
            return history.block(blocker);
        },
    getContext: ()=>({ getState })=>{
            const { query, route, match } = getState();
            return {
                query,
                route,
                match
            };
        },
    getBasePath: ()=>({ getState })=>{
            const { basePath } = getState();
            return basePath;
        },
    updateQueryParam: (params, updateType = 'push')=>({ getState })=>{
            const { query: existingQueryParams, history, location } = getState();
            const updatedQueryParams = (0, _extendsDefault.default)({}, existingQueryParams, params);
            // remove undefined keys
            Object.keys(updatedQueryParams).forEach((key)=>updatedQueryParams[key] === undefined && delete updatedQueryParams[key]);
            const existingPath = (0, _utils1.updateQueryParams)(location, existingQueryParams);
            const updatedPath = (0, _utils1.updateQueryParams)(location, updatedQueryParams);
            if (updatedPath !== existingPath) history[updateType](updatedPath);
        },
    updatePathParam: (params, updateType = 'push')=>({ getState })=>{
            const { history, location, route: { path }, match: { params: existingPathParams }, basePath } = getState();
            const pathWithBasePath = basePath + path;
            const updatedPathParams = (0, _extendsDefault.default)({}, existingPathParams, params);
            const updatedPath = (0, _utils.generatePath)(pathWithBasePath, updatedPathParams);
            const updatedLocation = (0, _extendsDefault.default)({}, location, {
                pathname: updatedPath
            });
            const existingRelativePath = (0, _utils1.getRelativeURLFromLocation)(location);
            const updatedRelativePath = (0, _utils1.getRelativeURLFromLocation)(updatedLocation);
            if (updatedRelativePath !== existingRelativePath) history[updateType](updatedRelativePath);
        },
    loadPlugins: ()=>({ getState })=>{
            const { plugins, match, query, route } = getState();
            plugins.forEach((p)=>p.routeLoad == null ? void 0 : p.routeLoad({
                    context: {
                        match,
                        query,
                        route
                    }
                }));
        },
    prefetchRoute: (path, nextContext)=>({ getState })=>{
            const { plugins, routes, basePath, onPrefetch } = getState();
            const { route, match, query } = getRouterState();
            if (!nextContext && !(0, _utils1.isExternalAbsolutePath)(path)) {
                const location = (0, _history.parsePath)((0, _utils1.getRelativePath)(path, basePath));
                nextContext = (0, _utils.findRouterContext)(routes, {
                    location,
                    basePath
                });
            }
            if (nextContext == null) return;
            const nextLocationContext = nextContext;
            (0, _reactSweetState.batch)(()=>{
                plugins.forEach((p)=>p.routePrefetch == null ? void 0 : p.routePrefetch({
                        context: {
                            route,
                            match,
                            query
                        },
                        nextContext: nextLocationContext
                    }));
                if (onPrefetch) onPrefetch(nextLocationContext);
            });
        }
};
const RouterStore = (0, _reactSweetState.createStore)({
    initialState: INITIAL_STATE,
    actions,
    name: 'router'
});
const RouterContainer = (0, _reactSweetState.createContainer)(RouterStore, {
    displayName: 'RouterContainer',
    onInit: ()=>({ dispatch }, props)=>{
            dispatch(actions.bootstrapStore(props));
            !(0, _utils.isServerEnvironment)() && dispatch(actions.loadPlugins());
        },
    onCleanup: ()=>(state)=>{
            if (!(0, _utils.isServerEnvironment)()) {
                const { unlisten } = state.getState();
                unlisten && unlisten();
            }
        }
});
const useRouterStore = (0, _reactSweetState.createHook)(RouterStore);
const useRouterStoreActions = (0, _reactSweetState.createActionsHook)(RouterStore);
function createRouterSelector(selector) {
    const useHook = (0, _reactSweetState.createHook)(RouterStore, {
        selector
    });
    return function useRouterSelector(...args) {
        return useHook(...args)[0];
    };
}
const getRouterStore = ()=>// @ts-ignore calling `getStore` without providing a scopeId
    (0, _reactSweetState.defaultRegistry).getStore(RouterStore);
const getRouterState = ()=>getRouterStore().storeState.getState();

},{"@babel/runtime/helpers/extends":"3LZYG","history":"de6OM","react-sweet-state":"b2YYl","../../common/constants":"cYZ0C","../../common/utils":"c9Uvk","./utils":"95QN1","@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"b2YYl":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "createContainer", ()=>(0, _container.createContainer));
parcelHelpers.export(exports, "createSubscriber", ()=>(0, _subscriber.createSubscriber));
parcelHelpers.export(exports, "createHook", ()=>(0, _hook.createHook));
parcelHelpers.export(exports, "createActionsHook", ()=>(0, _hook.createActionsHook));
parcelHelpers.export(exports, "createStateHook", ()=>(0, _hook.createStateHook));
parcelHelpers.export(exports, "defaults", ()=>(0, _defaultsDefault.default));
parcelHelpers.export(exports, "createStore", ()=>(0, _store.createStore));
parcelHelpers.export(exports, "defaultRegistry", ()=>(0, _store.defaultRegistry));
parcelHelpers.export(exports, "batch", ()=>(0, _batchedUpdates.batch));
parcelHelpers.export(exports, "createSelector", ()=>(0, _createSelector.createSelector));
var _container = require("./components/container");
var _subscriber = require("./components/subscriber");
var _hook = require("./components/hook");
var _defaults = require("./defaults");
var _defaultsDefault = parcelHelpers.interopDefault(_defaults);
var _store = require("./store");
var _batchedUpdates = require("./utils/batched-updates");
var _createSelector = require("./utils/create-selector");

},{"./components/container":"jP0or","./components/subscriber":"8NNQo","./components/hook":"bfSa5","./defaults":"8E710","./store":"6fmkS","./utils/batched-updates":"9S6Im","./utils/create-selector":"cx73r","@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"jP0or":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "createContainer", ()=>createContainer);
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _propTypes = require("prop-types");
var _propTypesDefault = parcelHelpers.interopDefault(_propTypes);
var _context = require("../context");
var _store = require("../store");
var _shallowEqual = require("../utils/shallow-equal");
var _shallowEqualDefault = parcelHelpers.interopDefault(_shallowEqual);
const _excluded = [
    "children"
], _excluded2 = [
    "scope",
    "isGlobal"
];
function _objectWithoutPropertiesLoose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
const noop = ()=>()=>{};
function createContainer(StoreOrOptions, _temp) {
    if (StoreOrOptions === void 0) StoreOrOptions = {};
    let { onInit: _onInit = noop, onUpdate = noop, onCleanup = noop, displayName = '' } = _temp === void 0 ? {} : _temp;
    if ('key' in StoreOrOptions) {
        const Store = StoreOrOptions;
        const dn = displayName || `Container(${Store.key.split('__')[0]})`;
        return createFunctionContainer({
            displayName: dn,
            // compat fields
            override: {
                Store,
                handlers: Object.assign({}, _onInit !== noop && {
                    onInit: ()=>_onInit()
                }, onCleanup !== noop && {
                    onDestroy: ()=>onCleanup()
                }, onUpdate !== noop && {
                    onContainerUpdate: ()=>onUpdate()
                })
            }
        });
    }
    return createFunctionContainer(StoreOrOptions);
}
function useRegistry(scope, isGlobal, _ref) {
    let { globalRegistry } = _ref;
    return (0, _react.useMemo)(()=>{
        const isLocal = !scope && !isGlobal;
        return isLocal ? new (0, _store.StoreRegistry)('__local__') : globalRegistry;
    }, [
        scope,
        isGlobal,
        globalRegistry
    ]);
}
function useContainedStore(scope, registry, propsRef, check, override) {
    // Store contained scopes in a map, but throwing it away on scope change
    // eslint-disable-next-line react-hooks/exhaustive-deps
    const containedStores = (0, _react.useMemo)(()=>new Map(), [
        scope
    ]);
    const getContainedStore = (0, _react.useCallback)((Store)=>{
        let containedStore = containedStores.get(Store); // first time it gets called we add store to contained map bound
        // so we can provide props to actions (only triggered by children)
        if (!containedStore) {
            const isExisting = registry.hasStore(Store, scope);
            const config = {
                props: ()=>propsRef.current.sub,
                contained: check
            };
            const { storeState } = registry.getStore(Store, scope, config);
            const actions = (0, _store.bindActions)(Store.actions, storeState, config);
            const handlers = (0, _store.bindActions)(Object.assign({}, Store.handlers, override == null ? void 0 : override.handlers), storeState, config, actions);
            containedStore = {
                storeState,
                actions,
                handlers,
                unsubscribe: undefined
            };
            containedStores.set(Store, containedStore); // Signal store is contained and ready now, so by the time
            // consumers subscribe we already have updated the store (if needed).
            // Also if override maintain legacy behaviour, triggered on every mount
            if (!isExisting || override) handlers.onInit == null || handlers.onInit();
        }
        return containedStore;
    }, [
        containedStores,
        scope,
        registry,
        propsRef,
        check,
        override
    ]);
    return [
        containedStores,
        getContainedStore
    ];
}
function useApi(check, getContainedStore, _ref2) {
    let { globalRegistry, retrieveStore } = _ref2;
    const retrieveRef = (0, _react.useRef)();
    retrieveRef.current = (Store)=>check(Store) ? getContainedStore(Store) : retrieveStore(Store); // This api is "frozen", as changing it will trigger re-render across all consumers
    // so we link retrieveStore dynamically and manually call notify() on scope change
    return (0, _react.useMemo)(()=>({
            globalRegistry,
            retrieveStore: (s)=>retrieveRef.current(s)
        }), [
        globalRegistry
    ]);
}
function createFunctionContainer(_temp2) {
    let { displayName, override } = _temp2 === void 0 ? {} : _temp2;
    const check = (store)=>override ? store === override.Store : store.containedBy === FunctionContainer;
    function FunctionContainer(props) {
        const { children } = props, restProps = _objectWithoutPropertiesLoose(props, _excluded);
        const { scope, isGlobal } = restProps, subProps = _objectWithoutPropertiesLoose(restProps, _excluded2);
        const ctx = (0, _react.useContext)((0, _context.Context));
        const registry = useRegistry(scope, isGlobal, ctx); // Store props in a ref to avoid re-binding actions when they change and re-rendering all
        // consumers unnecessarily. The update is handled by an effect on the component instead
        const propsRef = (0, _react.useRef)({
            prev: null,
            next: restProps,
            sub: subProps
        });
        propsRef.current = {
            prev: propsRef.current.next,
            next: restProps,
            sub: subProps // TODO remove on next major
        };
        const [containedStores, getContainedStore] = useContainedStore(scope, registry, propsRef, check, override); // Use a stable object as is passed as value to context Provider
        const api = useApi(check, getContainedStore, ctx); // This listens for custom props change, and so we trigger container update actions
        // before the re-render gets to consumers (hence why side effect on render).
        // We do not use React hooks because num of restProps might change and react will throws
        if (!(0, _shallowEqualDefault.default)(propsRef.current.next, propsRef.current.prev)) containedStores.forEach((_ref3)=>{
            let { handlers } = _ref3;
            handlers.onContainerUpdate == null || handlers.onContainerUpdate(propsRef.current.next, propsRef.current.prev);
        });
         // Every time we add/remove a contained store, we ensure we are subscribed to the updates
        // as an effect to properly handle strict mode
        (0, _react.useEffect)(()=>{
            containedStores.forEach((containedStore)=>{
                if (!containedStore.unsubscribe) {
                    const unsub = containedStore.storeState.subscribe(()=>containedStore.handlers.onUpdate == null ? void 0 : containedStore.handlers.onUpdate());
                    containedStore.unsubscribe = ()=>{
                        unsub();
                        containedStore.unsubscribe = undefined;
                    };
                }
            });
        }, [
            containedStores,
            containedStores.size
        ]); // We support renderding "bootstrap" containers without children with override API
        // so in this case we call getCS to initialize the store globally asap
        if (override && !containedStores.size && (scope || isGlobal)) getContainedStore(override.Store);
         // This listens for scope change or component unmount, to notify all consumers
        // so all work is done on cleanup
        (0, _react.useEffect)(()=>{
            return ()=>{
                containedStores.forEach((_ref4, Store)=>{
                    let { storeState, handlers, unsubscribe } = _ref4;
                    // Detatch container from subscription
                    unsubscribe == null || unsubscribe(); // Trigger a forced update on all subscribers as we opted out from context
                    // Some might have already re-rendered naturally, but we "force update" all anyway.
                    // This is sub-optimal as if there are other containers with the same
                    // old scope id we will re-render those too, but still better than context
                    storeState.notify(); // Given unsubscription is handled by useSyncExternalStore, we have no control on when
                    // React decides to do it. So we schedule on next tick to run last
                    Promise.resolve().then(()=>{
                        var _registry$getStore;
                        if (!storeState.listeners().size && // ensure registry has not already created a new store with same scope
                        storeState === ((_registry$getStore = registry.getStore(Store, scope, null)) == null ? void 0 : _registry$getStore.storeState)) {
                            handlers.onDestroy == null || handlers.onDestroy(); // We only delete scoped stores, as global shall persist and local are auto-deleted
                            if (!isGlobal) registry.deleteStore(Store, scope);
                        }
                    });
                }); // no need to reset containedStores as the map is already bound to scope
            };
        }, [
            registry,
            scope,
            isGlobal,
            containedStores
        ]);
        return /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _context.Context).Provider, {
            value: api
        }, children);
    }
    FunctionContainer.displayName = displayName || `Container`;
    FunctionContainer.propTypes = {
        children: (0, _propTypesDefault.default).node,
        scope: (0, _propTypesDefault.default).string,
        isGlobal: (0, _propTypesDefault.default).bool
    };
    return FunctionContainer;
}

},{"react":"ltHCL","prop-types":"3k3Jl","../context":"hPWjQ","../store":"6fmkS","../utils/shallow-equal":"bJC2B","@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"hPWjQ":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "Context", ()=>Context);
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _store = require // Provide static calculateChangedBit to opt-out from context updates
("./store");
const Context = /*#__PURE__*/ (0, _reactDefault.default).createContext({
    globalRegistry: (0, _store.defaultRegistry),
    retrieveStore: (Store)=>(0, _store.defaultRegistry).getStore(Store)
}, ()=>0);

},{"react":"ltHCL","./store":"6fmkS","@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"6fmkS":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "bindAction", ()=>(0, _bindActions.bindAction));
parcelHelpers.export(exports, "bindActions", ()=>(0, _bindActions.bindActions));
parcelHelpers.export(exports, "createStore", ()=>(0, _create.createStore));
parcelHelpers.export(exports, "StoreRegistry", ()=>(0, _registry.StoreRegistry));
parcelHelpers.export(exports, "defaultRegistry", ()=>(0, _registry.defaultRegistry));
var _bindActions = require("./bind-actions");
var _create = require("./create");
var _registry = require("./registry");

},{"./bind-actions":"90CyA","./create":"a0rqy","./registry":"bq4Th","@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"90CyA":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "bindAction", ()=>bindAction);
parcelHelpers.export(exports, "bindActions", ()=>bindActions);
var _defaults = require("../defaults");
var _defaultsDefault = parcelHelpers.interopDefault(_defaults);
const namedMutator = (storeState, actionName)=>function() {
        storeState.mutator.actionName = actionName;
        return storeState.mutator(...arguments);
    };
const warnings = new WeakMap();
const bindAction = (storeState, actionFn, actionKey, config, actions)=>{
    const callThunk = (instance, thunkFn, actionName)=>thunkFn({
            setState: (0, _defaultsDefault.default).devtools ? namedMutator(instance.storeState, actionName) : instance.storeState.mutator,
            getState: instance.storeState.getState,
            get actions () {
                if (!warnings.has(actionFn)) warnings.set(actionFn, console.warn(`react-sweet-state 'actions' property has been deprecated and will be removed in the next mayor. ` + `Please check action '${actionName}' of Store '${instance.storeState.key}' and use 'dispatch' instead`));
                return actions;
            },
            dispatch: (tFn)=>callThunk(instance, tFn, `${actionName}.dispatch`)
        }, config.props());
    return function() {
        return callThunk({
            storeState,
            actions
        }, actionFn(...arguments), actionKey);
    };
};
const bindActions = function bindActions(actions, storeState, config, boundActions) {
    if (boundActions === void 0) boundActions = null;
    return Object.keys(actions).reduce((acc, k)=>{
        acc[k] = bindAction(storeState, actions[k], k, config, boundActions || acc);
        return acc;
    }, {});
};

},{"../defaults":"8E710","@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"8E710":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
const defaultMutator = (prevState, partialState)=>{
    // Merge the partial state and the previous state.
    return Object.assign({}, prevState, partialState);
};
const defaults = {
    batchUpdates: 'useSyncExternalStore' in (0, _reactDefault.default),
    devtools: false,
    middlewares: new Set(),
    mutator: defaultMutator
};
exports.default = defaults;

},{"react":"ltHCL","@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"a0rqy":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "createStore", ()=>createStore);
var _hash = require("../utils/hash");
var _hashDefault = parcelHelpers.interopDefault(_hash);
function createKey(initialState, actions, name) {
    const src = !name ? Object.keys(actions).reduce((acc, k)=>acc + actions[k].toString(), '') : '';
    return [
        name,
        (0, _hashDefault.default)(src + JSON.stringify(initialState))
    ].filter(Boolean).join('__');
}
function createStore(_ref) {
    let { name = '', initialState, actions, containedBy, handlers = {} } = _ref;
    let key;
    return {
        get key () {
            // lazy evaluate key on first access
            return key || (key = createKey(initialState, actions, name));
        },
        initialState,
        actions,
        containedBy,
        handlers
    };
}

},{"../utils/hash":"dp6IL","@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"dp6IL":[function(require,module,exports,__globalThis) {
/* eslint-disable */ // murmurhash2 via https://github.com/garycourt/murmurhash-js/blob/master/murmurhash2_gc.js
var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>murmurhash2_32_gc);
function murmurhash2_32_gc(str) {
    var l = str.length, h = l ^ l, i = 0, k;
    while(l >= 4){
        k = str.charCodeAt(i) & 0xff | (str.charCodeAt(++i) & 0xff) << 8 | (str.charCodeAt(++i) & 0xff) << 16 | (str.charCodeAt(++i) & 0xff) << 24;
        k = (k & 0xffff) * 0x5bd1e995 + (((k >>> 16) * 0x5bd1e995 & 0xffff) << 16);
        k ^= k >>> 24;
        k = (k & 0xffff) * 0x5bd1e995 + (((k >>> 16) * 0x5bd1e995 & 0xffff) << 16);
        h = (h & 0xffff) * 0x5bd1e995 + (((h >>> 16) * 0x5bd1e995 & 0xffff) << 16) ^ k;
        l -= 4;
        ++i;
    }
    switch(l){
        case 3:
            h ^= (str.charCodeAt(i + 2) & 0xff) << 16;
        case 2:
            h ^= (str.charCodeAt(i + 1) & 0xff) << 8;
        case 1:
            h ^= str.charCodeAt(i) & 0xff;
            h = (h & 0xffff) * 0x5bd1e995 + (((h >>> 16) * 0x5bd1e995 & 0xffff) << 16);
    }
    h ^= h >>> 13;
    h = (h & 0xffff) * 0x5bd1e995 + (((h >>> 16) * 0x5bd1e995 & 0xffff) << 16);
    h ^= h >>> 15;
    return (h >>> 0).toString(36);
}

},{"@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"bq4Th":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "GLOBAL_SCOPE", ()=>GLOBAL_SCOPE);
parcelHelpers.export(exports, "StoreRegistry", ()=>StoreRegistry);
parcelHelpers.export(exports, "defaultRegistry", ()=>defaultRegistry);
var _supportedFeatures = require("../utils/supported-features");
var _supportedFeaturesDefault = parcelHelpers.interopDefault(_supportedFeatures);
var _bindActions = require("./bind-actions");
var _createState = require("./create-state");
var _createStateDefault = parcelHelpers.interopDefault(_createState);
const GLOBAL_SCOPE = '__global__';
class StoreRegistry {
    constructor(defaultScope){
        var _this = this;
        if (defaultScope === void 0) defaultScope = GLOBAL_SCOPE;
        this.stores = new Map();
        this.initStore = (key, Store, config)=>{
            const { initialState, actions } = Store;
            if (Store.containedBy && !config.contained(Store)) {
                const err = new Error(`Store ${Store.key} should be contained by a container but it is used globally. ` + `While it might still work, it will likely cause unexpected behaviours.`);
                if ((0, _supportedFeaturesDefault.default).scheduling()) Promise.reject(err);
                else throw err;
            }
            const storeState = (0, _createStateDefault.default)(key, initialState);
            let boundActions;
            const store = {
                storeState,
                // these are used only when container-less, so we generate them on-demand
                get actions () {
                    if (!boundActions) boundActions = (0, _bindActions.bindActions)(actions, storeState, config);
                    return boundActions;
                }
            };
            this.stores.set(key, store);
            return store;
        };
        this.hasStore = function(Store, scopeId) {
            if (scopeId === void 0) scopeId = _this.defaultScope;
            const key = _this.generateKey(Store, scopeId);
            return _this.stores.has(key);
        };
        this.getStore = function(Store, scopeId, config) {
            if (scopeId === void 0) scopeId = _this.defaultScope;
            if (config === void 0) config = {
                props: ()=>({}),
                contained: ()=>false
            };
            const key = _this.generateKey(Store, scopeId);
            return _this.stores.get(key) || config && _this.initStore(key, Store, config);
        };
        this.deleteStore = function(Store, scopeId) {
            if (scopeId === void 0) scopeId = _this.defaultScope;
            const key = _this.generateKey(Store, scopeId);
            _this.stores.delete(key);
        };
        this.generateKey = (Store, scopeId)=>`${Store.key}@${scopeId}`;
        this.defaultScope = defaultScope;
    }
}
const defaultRegistry = new StoreRegistry();

},{"../utils/supported-features":"e93ls","./bind-actions":"90CyA","./create-state":"e1aMx","@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"e93ls":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
const supports = {
    scheduling () {
        return typeof window !== 'undefined' && typeof MessageChannel === 'function';
    }
};
exports.default = supports;

},{"@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"e1aMx":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _middlewares = require("../middlewares");
var _middlewaresDefault = parcelHelpers.interopDefault(_middlewares);
var _devtools = require("../enhancers/devtools");
var _devtoolsDefault = parcelHelpers.interopDefault(_devtools);
var _defaults = require("../defaults");
var _defaultsDefault = parcelHelpers.interopDefault(_defaults);
var _schedule = require("../utils/schedule");
var _scheduleDefault = parcelHelpers.interopDefault(_schedule);
function createStoreState(key, initialState) {
    let listeners = new Set();
    let currentState = initialState;
    const storeState = {
        key,
        getState () {
            return currentState;
        },
        setState (nextState) {
            currentState = nextState; // Instead of notifying all handlers immediately, we wait next tick
            // so multiple actions affecting the same store gets combined
            (0, _scheduleDefault.default)(storeState.notify);
        },
        resetState () {
            storeState.setState(initialState);
        },
        notify () {
            for (const listener of listeners)listener(storeState.getState());
        },
        subscribe (listener) {
            listeners.add(listener);
            return function unsubscribe() {
                listeners.delete(listener);
            };
        },
        listeners () {
            return listeners;
        }
    };
    storeState.mutator = (0, _middlewaresDefault.default)(storeState, (0, _defaultsDefault.default).middlewares);
    return storeState;
}
exports.default = (0, _devtoolsDefault.default)(createStoreState);

},{"../middlewares":"7LaTP","../enhancers/devtools":"33R4l","../defaults":"8E710","../utils/schedule":"h1md3","@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"7LaTP":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _defaults = require("../defaults");
var _defaultsDefault = parcelHelpers.interopDefault(_defaults);
var _update = require("./update");
var _updateDefault = parcelHelpers.interopDefault(_update);
const applyMiddleware = (storeState, middlewares)=>Array.from(middlewares).concat((0, _updateDefault.default)).reduceRight((next, mw)=>mw(storeState)(next), (0, _defaultsDefault.default).mutator);
exports.default = applyMiddleware;

},{"../defaults":"8E710","./update":"1sjAO","@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"1sjAO":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _shallowEqual = require("../utils/shallow-equal");
var _shallowEqualDefault = parcelHelpers.interopDefault(_shallowEqual);
const updateMiddleware = (storeState)=>(next)=>(arg)=>{
            let output;
            const state = storeState.getState();
            const nextState = next(state, arg, (out)=>{
                output = out;
            });
            if (!(0, _shallowEqualDefault.default)(nextState, state)) storeState.setState(nextState);
            return output;
        };
exports.default = updateMiddleware;

},{"../utils/shallow-equal":"bJC2B","@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"bJC2B":[function(require,module,exports,__globalThis) {
// Mostly copied from fbjs/packages/fbjs/src/core/shallowEqual.js
// enhanced with keys cache as might get called multiple times with same args
var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>shallowEqual);
const hasOwnProperty = Object.prototype.hasOwnProperty;
const CACHE = new WeakMap();
function shallowEqual(objA, objB) {
    if (objA === objB) return true;
    if (typeof objA !== 'object' || objA === null || typeof objB !== 'object' || objB === null) return false;
    if (Array.isArray(objA) && Array.isArray(objB)) {
        // do array comparison
        if (objA.length !== objB.length) return false;
        for(let i = 0; i < objA.length; i++){
            if (objA[i] !== objB[i]) return false;
        }
        return true;
    } else {
        // Handle Date, RegExp, String, Number, ... and complex objects
        const strA = '' + objA;
        const strB = '' + objB;
        if (strA !== strB || strA[0] === '[' && strA !== '[object Object]') return false;
         // do object comparison
        let keysA;
        if (CACHE.has(objA)) keysA = CACHE.get(objA);
        else {
            keysA = Object.keys(objA);
            CACHE.set(objA, keysA);
        }
        let keysB;
        if (CACHE.has(objB)) keysB = CACHE.get(objB);
        else {
            keysB = Object.keys(objB);
            CACHE.set(objB, keysB);
        }
        if (keysA.length !== keysB.length) return false;
         // Test for A's keys different from B.
        for(let i = 0; i < keysA.length; i++){
            if (!hasOwnProperty.call(objB, keysA[i]) || objA[keysA[i]] !== objB[keysA[i]]) return false;
        }
        return true;
    }
}

},{"@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"33R4l":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _defaults = require("../defaults");
var _defaultsDefault = parcelHelpers.interopDefault(_defaults);
const connectDevTools = (storeState, config)=>{
    const devTools = window.__REDUX_DEVTOOLS_EXTENSION__.connect(Object.assign({
        name: `Store ${storeState.key}`,
        serialize: true,
        trace: true
    }, config));
    devTools.init(storeState.getState());
    devTools.subscribe((message)=>{
        if (message.type === 'DISPATCH') switch(message.payload.type){
            case 'RESET':
                storeState.resetState();
                devTools.init(storeState.getState());
                return;
            case 'COMMIT':
                devTools.init(storeState.getState());
                return;
            case 'ROLLBACK':
                storeState.setState(JSON.parse(message.state));
                devTools.init(storeState.getState());
                return;
            case 'JUMP_TO_STATE':
            case 'JUMP_TO_ACTION':
                storeState.setState(JSON.parse(message.state));
                return;
        }
        else if (message.type === 'ACTION') {
            let action = JSON.parse(message.payload);
            storeState.setState(action.payload);
        }
    });
    return devTools;
};
const withDevtools = (createStoreState)=>function() {
        const storeState = createStoreState(...arguments);
        if ((0, _defaultsDefault.default).devtools && window && window.__REDUX_DEVTOOLS_EXTENSION__) {
            const origMutator = storeState.mutator;
            let devTools;
            const devtoolMutator = (arg)=>{
                const result = origMutator(arg);
                try {
                    if (!devTools) {
                        const config = typeof (0, _defaultsDefault.default).devtools === 'function' ? (0, _defaultsDefault.default).devtools(storeState) : {};
                        devTools = connectDevTools(storeState, config);
                    }
                    devTools.send({
                        type: storeState.mutator.actionName,
                        payload: arg
                    }, storeState.getState(), {}, storeState.key);
                } catch (err) {
                /* ignore devtools errors */ }
                return result;
            };
            storeState.mutator = devtoolMutator;
        }
        return storeState;
    };
exports.default = withDevtools;

},{"../defaults":"8E710","@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"h1md3":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>schedule);
var _defaults = require("../defaults");
var _defaultsDefault = parcelHelpers.interopDefault(_defaults);
var _batchedUpdates = require("./batched-updates");
var _supportedFeatures = require("./supported-features");
var _supportedFeaturesDefault = parcelHelpers.interopDefault(_supportedFeatures);
const QUEUE = [];
let scheduled;
function schedule(fn) {
    // if we are in node/tests or feature disabled, make updates sync batched
    if (!(0, _defaultsDefault.default).batchUpdates || !(0, _supportedFeaturesDefault.default).scheduling()) return (0, _batchedUpdates.batch)(()=>fn()); // Add to queue if not already there
    // so we avoid multiple notifications to same store listeners
    if (!QUEUE.includes(fn)) QUEUE.push(fn); // if something already started schedule, skip
    if (scheduled) return;
    scheduled = (0, _batchedUpdates.batch)(()=>{
        let queueFn;
        while(queueFn = QUEUE.shift())queueFn();
        scheduled = null;
    });
}

},{"../defaults":"8E710","./batched-updates":"9S6Im","./supported-features":"e93ls","@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"9S6Im":[function(require,module,exports,__globalThis) {
/* eslint-disable import/no-unresolved */ var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "batch", ()=>batch);
var _reactDom = require("react-dom");
var _scheduler = require("scheduler");
var _defaults = require("../defaults");
var _defaultsDefault = parcelHelpers.interopDefault(_defaults);
var _supportedFeatures = require("./supported-features");
var _supportedFeaturesDefault = parcelHelpers.interopDefault(_supportedFeatures);
let isInsideBatchedSchedule = false;
function batch(fn) {
    // if we are in node/tests or nested schedule
    if (!(0, _defaultsDefault.default).batchUpdates || !(0, _supportedFeaturesDefault.default).scheduling() || isInsideBatchedSchedule) return (0, _reactDom.unstable_batchedUpdates)(fn);
    isInsideBatchedSchedule = true; // Use ImmediatePriority as it has -1ms timeout
    // https://github.com/facebook/react/blob/main/packages/scheduler/src/forks/Scheduler.js#L65
    return (0, _scheduler.unstable_scheduleCallback)((0, _scheduler.unstable_ImmediatePriority), function scheduleBatchedUpdates() {
        (0, _reactDom.unstable_batchedUpdates)(fn);
        isInsideBatchedSchedule = false;
    });
}

},{"react-dom":"7Lblg","scheduler":"NHulo","../defaults":"8E710","./supported-features":"e93ls","@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"8NNQo":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "createSubscriber", ()=>createSubscriber);
var _hook = require("./hook");
const _excluded = [
    "children"
];
function _objectWithoutPropertiesLoose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
function hasAdditionalProps(props) {
    for(let i in props)return true;
    return false;
}
function createSubscriber(Store, _temp) {
    let { selector, displayName = '' } = _temp === void 0 ? {} : _temp;
    const useStore = (0, _hook.createHook)(Store, {
        selector
    });
    const Subscriber = function Subscriber(_ref) {
        let { children } = _ref, rest = _objectWithoutPropertiesLoose(_ref, _excluded);
        const api = useStore(hasAdditionalProps(rest) ? rest : undefined);
        return children(...api);
    };
    Subscriber.displayName = displayName || `Subscriber(${Store.key.split('__')[0]})`;
    return Subscriber;
}

},{"./hook":"bfSa5","@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"bfSa5":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "createHook", ()=>createHook);
parcelHelpers.export(exports, "createActionsHook", ()=>createActionsHook);
parcelHelpers.export(exports, "createStateHook", ()=>createStateHook);
var _react = require("react");
var _shim = require("use-sync-external-store/shim");
var _context = require("../context");
var _createSelector = require("../utils/create-selector");
const EMPTY_SELECTOR = ()=>undefined;
const DEFAULT_SELECTOR = (state)=>state;
function createHook(Store, _temp) {
    let { selector } = _temp === void 0 ? {} : _temp;
    return function useSweetState(propsArg) {
        const { retrieveStore } = (0, _react.useContext)((0, _context.Context));
        const { storeState, actions } = retrieveStore(Store);
        const hasPropsArg = propsArg !== undefined;
        const propsArgRef = (0, _react.useRef)(propsArg);
        propsArgRef.current = propsArg;
        const stateSelector = (0, _react.useMemo)(()=>selector ? (0, _createSelector.getSelectorInstance)(selector, storeState, hasPropsArg) : selector === null ? EMPTY_SELECTOR : DEFAULT_SELECTOR, [
            hasPropsArg,
            storeState
        ]);
        const forceUpdate = (0, _react.useState)({})[1];
        const getSnapshot = (0, _react.useCallback)(()=>{
            // parent scope has changed and notify was explicitly triggered by the container
            // we need to force the hook to re-render to listen new storeState
            if (retrieveStore(Store).storeState !== storeState) forceUpdate({});
            const state = storeState.getState();
            return stateSelector(state, propsArgRef.current);
        }, [
            retrieveStore,
            storeState,
            stateSelector,
            forceUpdate
        ]);
        const currentState = (0, _shim.useSyncExternalStore)(storeState.subscribe, getSnapshot, getSnapshot);
        return [
            currentState,
            actions
        ];
    };
}
function createActionsHook(Store) {
    const useHook = createHook(Store, {
        selector: null
    });
    return function useSweetStateActions() {
        return useHook()[1];
    };
}
function createStateHook(Store, _temp2) {
    let { selector } = _temp2 === void 0 ? {} : _temp2;
    const useHook = createHook(Store, {
        selector
    });
    return function useSweetStateState(propsArg) {
        return useHook(propsArg)[0];
    };
}

},{"react":"ltHCL","use-sync-external-store/shim":"lEL2n","../context":"hPWjQ","../utils/create-selector":"cx73r","@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"lEL2n":[function(require,module,exports,__globalThis) {
'use strict';
module.exports = require("1e1c6acead2dffba");

},{"1e1c6acead2dffba":"7JumU"}],"7JumU":[function(require,module,exports,__globalThis) {
/**
 * @license React
 * use-sync-external-store-shim.production.js
 *
 * Copyright (c) Meta Platforms, Inc. and affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ "use strict";
var React = require("76d9c8c36382bc5e");
function is(x, y) {
    return x === y && (0 !== x || 1 / x === 1 / y) || x !== x && y !== y;
}
var objectIs = "function" === typeof Object.is ? Object.is : is, useState = React.useState, useEffect = React.useEffect, useLayoutEffect = React.useLayoutEffect, useDebugValue = React.useDebugValue;
function useSyncExternalStore$2(subscribe, getSnapshot) {
    var value = getSnapshot(), _useState = useState({
        inst: {
            value: value,
            getSnapshot: getSnapshot
        }
    }), inst = _useState[0].inst, forceUpdate = _useState[1];
    useLayoutEffect(function() {
        inst.value = value;
        inst.getSnapshot = getSnapshot;
        checkIfSnapshotChanged(inst) && forceUpdate({
            inst: inst
        });
    }, [
        subscribe,
        value,
        getSnapshot
    ]);
    useEffect(function() {
        checkIfSnapshotChanged(inst) && forceUpdate({
            inst: inst
        });
        return subscribe(function() {
            checkIfSnapshotChanged(inst) && forceUpdate({
                inst: inst
            });
        });
    }, [
        subscribe
    ]);
    useDebugValue(value);
    return value;
}
function checkIfSnapshotChanged(inst) {
    var latestGetSnapshot = inst.getSnapshot;
    inst = inst.value;
    try {
        var nextValue = latestGetSnapshot();
        return !objectIs(inst, nextValue);
    } catch (error) {
        return !0;
    }
}
function useSyncExternalStore$1(subscribe, getSnapshot) {
    return getSnapshot();
}
var shim = "undefined" === typeof window || "undefined" === typeof window.document || "undefined" === typeof window.document.createElement ? useSyncExternalStore$1 : useSyncExternalStore$2;
exports.useSyncExternalStore = void 0 !== React.useSyncExternalStore ? React.useSyncExternalStore : shim;

},{"76d9c8c36382bc5e":"ltHCL"}],"cx73r":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "createSelector", ()=>createSelector);
parcelHelpers.export(exports, "createMemoizedSelector", ()=>createMemoizedSelector);
parcelHelpers.export(exports, "getSelectorInstance", ()=>getSelectorInstance);
var _memoize = require // customised version of reselect
("./memoize");
var _memoizeDefault = parcelHelpers.interopDefault(_memoize);
function createSelector() {
    for(var _len = arguments.length, funcs = new Array(_len), _key = 0; _key < _len; _key++)funcs[_key] = arguments[_key];
    const resultFunc = funcs.pop();
    const dependencies = Array.isArray(funcs[0]) ? funcs[0] : funcs;
    const memoizedResultFunc = (0, _memoizeDefault.default)(function() {
        return resultFunc.apply(null, arguments);
    }); // this memoisation is optimised for 2 arguments (state, props)
    const selector = (0, _memoizeDefault.default)(function() {
        // calculate all dependencies results
        const params = [];
        for(let i = 0; i < dependencies.length; i++)params.push(dependencies[i].apply(null, arguments));
         // then call the final func with all them as arguments
        return memoizedResultFunc.apply(null, params);
    }, true); // expose so we can create per scope selectors
    // API compatible with reselect@^4
    selector.resultFunc = resultFunc;
    selector.dependencies = dependencies;
    return selector;
}
function createMemoizedSelector(selector) {
    const isReselector = typeof selector.resultFunc === 'function' && Array.isArray(selector.dependencies);
    const dependencies = isReselector ? selector.dependencies : [
        (s)=>s,
        (_, p)=>p
    ];
    const resultFunc = isReselector ? selector.resultFunc : selector;
    return createSelector(dependencies, resultFunc);
}
const cache = new WeakMap();
function getSelectorInstance(selector, storeState, hasProps) {
    if (!hasProps) {
        if (!cache.has(storeState)) cache.set(storeState, new WeakMap());
        const scopeSelectors = cache.get(storeState);
        if (!scopeSelectors.has(selector)) scopeSelectors.set(selector, createMemoizedSelector(selector));
        return scopeSelectors.get(selector);
    }
    return createMemoizedSelector(selector);
}

},{"./memoize":"kUSg9","@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"kUSg9":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
/**
 * Tailor made memoisation
 */ parcelHelpers.export(exports, "default", ()=>function(resultFn, propsMode) {
        if (propsMode === void 0) propsMode = false;
        let lastArgs = [];
        let lastResult;
        let calledOnce = false;
        const result = function result() {
            if (calledOnce && areArgumentsEqual(propsMode, arguments, lastArgs)) return lastResult;
            const nextResult = resultFn.apply(this, arguments);
            if (!propsMode && (0, _shallowEqualDefault.default)(nextResult, lastResult)) return lastResult;
            lastResult = nextResult;
            calledOnce = true;
            lastArgs = arguments;
            return lastResult;
        };
        return result;
    });
var _shallowEqual = require("./shallow-equal");
var _shallowEqualDefault = parcelHelpers.interopDefault(_shallowEqual);
function exactEqual(objA, objB) {
    return objA === objB;
}
function areArgumentsEqual(propsMode, prev, next) {
    if (prev === null || next === null || prev.length !== next.length) return false; // If propsMode and 2 arguments, means it is an input selector
    // and we check for shallow equality on 2nd one to optimise props
    if (propsMode && prev.length === 2) return prev[0] === next[0] && (0, _shallowEqualDefault.default)(prev[1], next[1]);
    for(let i = 0; i < prev.length; i++){
        if (!exactEqual(prev[i], next[i])) return false;
    }
    return true;
}

},{"./shallow-equal":"bJC2B","@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"95QN1":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "sanitizePath", ()=>sanitizePath);
parcelHelpers.export(exports, "isAbsolutePath", ()=>isAbsolutePath);
parcelHelpers.export(exports, "isExternalAbsolutePath", ()=>isExternalAbsolutePath);
parcelHelpers.export(exports, "getRelativePath", ()=>getRelativePath);
parcelHelpers.export(exports, "updateQueryParams", ()=>updateQueryParams);
parcelHelpers.export(exports, "getRelativeURLFromLocation", ()=>getRelativeURLFromLocation);
parcelHelpers.export(exports, "shouldReload", ()=>shouldReload);
var _urlParse = require("url-parse");
var _urlParseDefault = parcelHelpers.interopDefault(_urlParse);
var _utils = require("../../../common/utils");
const stripTrailingSlash = (path)=>path.charAt(path.length - 1) === '/' ? path.slice(0, -1) : path;
const addLeadingSlash = (path)=>path.charAt(0) === '/' ? path : '/' + path;
const sanitizePath = (path, prefix = '')=>{
    if (prefix) {
        prefix = stripTrailingSlash(prefix);
        prefix = addLeadingSlash(prefix);
        path = addLeadingSlash(path);
    }
    return prefix + path;
};
const isAbsolutePath = (path)=>{
    const regex = new RegExp('^([a-z]+://|//)', 'i');
    return regex.test(path);
};
const isExternalAbsolutePath = (path)=>{
    if (typeof path !== 'string' || !isAbsolutePath(path)) return false;
    const pathHostname = new (0, _urlParseDefault.default)(path).hostname;
    const currentHostname = new (0, _urlParseDefault.default)(window.location.href).hostname;
    return pathHostname !== currentHostname;
};
const getRelativePath = (path, prefix = '')=>{
    if (typeof path !== 'string') return path;
    if (!isAbsolutePath(path)) {
        path = sanitizePath(path, prefix);
        return path;
    }
    const url = new (0, _urlParseDefault.default)(path);
    return `${url.pathname}${url.query}${url.hash}`;
};
const updateQueryParams = (location, query)=>{
    // @ts-ignore stringify accepts two params but it's type doesn't say so
    const stringifiedQuery = (0, _urlParse.qs).stringify(query, true);
    return `${location.pathname}${stringifiedQuery}${location.hash}`;
};
const getRelativeURLFromLocation = (location)=>{
    return `${location.pathname}${location.search}${location.hash}`;
};
const shouldReload = ({ context, prevContext, pluginId })=>{
    const sameRoute = (0, _utils.isSameRouteMatch)({
        prevContextMatch: prevContext.match,
        nextContextMatch: context.match
    });
    // keep old behaviour for Resources plugin
    // load Route only if path/query/params changed, and ignore the rest of query-params
    const defaultShouldReload = pluginId === 'resources-plugin' || !sameRoute;
    if (context.route === prevContext.route && context.route.EXPERIMENTAL__shouldReload) {
        const routeChoice = context.route.EXPERIMENTAL__shouldReload({
            context,
            prevContext,
            pluginId,
            defaultShouldReload
        });
        if (typeof routeChoice === 'boolean') return routeChoice;
    }
    return defaultShouldReload;
};

},{"url-parse":"ik7D1","../../../common/utils":"c9Uvk","@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"fEGHD":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "Router", ()=>Router);
parcelHelpers.export(exports, "MemoryRouter", ()=>MemoryRouter);
var _extends = require("@babel/runtime/helpers/extends");
var _extendsDefault = parcelHelpers.interopDefault(_extends);
var _history = require("history");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _routerStore = require("../router-store");
const Router = ({ basePath, children, history, initialRoute, isGlobal = true, plugins, onPrefetch, routes })=>{
    return /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _routerStore.RouterContainer), {
        basePath: basePath,
        history: history,
        initialRoute: initialRoute,
        isGlobal: isGlobal,
        onPrefetch: onPrefetch,
        plugins: plugins != null ? plugins : [],
        routes: routes
    }, children);
};
function MemoryRouter(props) {
    var _props$plugins;
    const history = (0, _react.useMemo)(()=>(0, _history.createMemoryHistory)(props.location ? {
            initialEntries: [
                props.location
            ]
        } : {}), [
        props.location
    ]);
    return /*#__PURE__*/ (0, _reactDefault.default).createElement(Router, (0, _extendsDefault.default)({}, props, {
        history: history,
        isGlobal: false,
        plugins: (_props$plugins = props == null ? void 0 : props.plugins) != null ? _props$plugins : []
    }));
}

},{"@babel/runtime/helpers/extends":"3LZYG","history":"de6OM","react":"ltHCL","../router-store":"bWF6v","@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"2Y612":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "RouterActions", ()=>RouterActions);
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _useRouterActions = require("../use-router-actions");
const RouterActions = ({ children })=>{
    const actions = (0, _useRouterActions.useRouterActions)();
    return /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _reactDefault.default).Fragment, null, children(actions));
};
RouterActions.displayName = 'RouterActions';

},{"react":"ltHCL","../use-router-actions":"cJVir","@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"cJVir":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "useRouterActions", ()=>useRouterActions);
var _routerStore = require("../router-store");
const useRouterActions = (0, _routerStore.useRouterStoreActions);

},{"../router-store":"bWF6v","@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"9WdtL":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "RouterSubscriber", ()=>RouterSubscriber);
var _objectWithoutPropertiesLoose = require("@babel/runtime/helpers/objectWithoutPropertiesLoose");
var _objectWithoutPropertiesLooseDefault = parcelHelpers.interopDefault(_objectWithoutPropertiesLoose);
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _utils = require("../../common/utils");
var _routerStore = require("../router-store");
const _excluded = [
    "listen"
];
const RouterSubscriber = ({ children })=>{
    const [state, _ref] = (0, _routerStore.useRouterStore)();
    const { listen } = _ref, actions = (0, _objectWithoutPropertiesLooseDefault.default)(_ref, _excluded);
    if (!state.unlisten && !(0, _utils.isServerEnvironment)()) listen();
    return /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _reactDefault.default).Fragment, null, children(state, actions));
};

},{"@babel/runtime/helpers/objectWithoutPropertiesLoose":"5JG3D","react":"ltHCL","../../common/utils":"c9Uvk","../router-store":"bWF6v","@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"5JG3D":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>_objectWithoutPropertiesLoose);
function _objectWithoutPropertiesLoose(r, e) {
    if (null == r) return {};
    var t = {};
    for(var n in r)if (({}).hasOwnProperty.call(r, n)) {
        if (-1 !== e.indexOf(n)) continue;
        t[n] = r[n];
    }
    return t;
}

},{"@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"7E9WY":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "usePathParam", ()=>usePathParam);
var _react = require("react");
var _reactSweetState = require("react-sweet-state");
var _routerStore = require("../router-store");
const createPathParamHook = (0, _reactSweetState.createHook)((0, _routerStore.RouterStore), {
    selector: ({ match: { params } }, { paramKey })=>params[paramKey]
});
const usePathParam = (paramKey)=>{
    const [paramVal, routerActions] = createPathParamHook({
        paramKey
    });
    const setPathParam = (0, _react.useCallback)((newValue, updateType)=>{
        routerActions.updatePathParam({
            [paramKey]: newValue
        }, updateType);
    }, [
        paramKey,
        routerActions
    ]);
    return [
        paramVal,
        setPathParam
    ];
};

},{"react":"ltHCL","react-sweet-state":"b2YYl","../router-store":"bWF6v","@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"kNkp7":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "useQueryParam", ()=>useQueryParam);
var _react = require("react");
var _reactSweetState = require("react-sweet-state");
var _routerStore = require("../router-store");
const createQueryParamHook = (0, _reactSweetState.createHook)((0, _routerStore.RouterStore), {
    selector: ({ query }, { paramKey })=>query[paramKey]
});
const useQueryParam = (paramKey)=>{
    const [paramVal, routerActions] = createQueryParamHook({
        paramKey
    });
    const setQueryParam = (0, _react.useCallback)((newValue, updateType)=>{
        routerActions.updateQueryParam({
            [paramKey]: newValue
        }, updateType);
    }, [
        paramKey,
        routerActions
    ]);
    return [
        paramVal,
        setQueryParam
    ];
};

},{"react":"ltHCL","react-sweet-state":"b2YYl","../router-store":"bWF6v","@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"1DmXX":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "withRouter", ()=>withRouter);
var _extends = require("@babel/runtime/helpers/extends");
var _extendsDefault = parcelHelpers.interopDefault(_extends);
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _routerStore = require("../router-store");
const getWrappedComponentDisplayName = (component)=>{
    let componentDisplayName = 'UNDEFINED';
    const { displayName, name } = component;
    if (displayName) componentDisplayName = displayName;
    if (name) componentDisplayName = name;
    return `withRouter(${componentDisplayName})`;
};
const withRouter = (WrappedComponent)=>{
    const displayName = getWrappedComponentDisplayName(WrappedComponent);
    const Component = WrappedComponent;
    const ComponentWithRouter = (props)=>{
        const [{ action, history, location, match, query, route }, { push, replace }] = (0, _routerStore.useRouterStore)();
        return /*#__PURE__*/ (0, _reactDefault.default).createElement(Component, (0, _extendsDefault.default)({}, props, {
            action: action,
            history: history,
            location: location,
            match: match,
            push: push,
            query: query,
            replace: replace,
            route: route
        }));
    };
    ComponentWithRouter.displayName = displayName;
    return ComponentWithRouter;
};

},{"@babel/runtime/helpers/extends":"3LZYG","react":"ltHCL","../router-store":"bWF6v","@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"dIzCr":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "Link", ()=>(0, _linkDefault.default));
parcelHelpers.export(exports, "RouteComponent", ()=>(0, _routeComponent.RouteComponent));
var _link = require("./link");
var _linkDefault = parcelHelpers.interopDefault(_link);
var _routeComponent = require("./route-component");

},{"./link":"lIqZT","./route-component":"jPhgn","@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"lIqZT":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _extends = require("@babel/runtime/helpers/extends");
var _extendsDefault = parcelHelpers.interopDefault(_extends);
var _objectWithoutPropertiesLoose = require("@babel/runtime/helpers/objectWithoutPropertiesLoose");
var _objectWithoutPropertiesLooseDefault = parcelHelpers.interopDefault(_objectWithoutPropertiesLoose);
var _history = require("history");
var _react = require("react");
var _utils = require("../../common/utils");
var _routerStore = require("../../controllers/router-store");
var _useTimeout = require("../../controllers/use-timeout");
var _utils1 = require("./utils");
const _excluded = [
    "children",
    "target",
    "replace",
    "href",
    "to",
    "onClick",
    "onMouseEnter",
    "onMouseLeave",
    "onPointerDown",
    "onFocus",
    "onBlur",
    "type",
    "params",
    "query",
    "prefetch",
    "state"
];
const PREFETCH_DELAY = 225;
const Link = /*#__PURE__*/ (0, _react.forwardRef)((_ref, ref)=>{
    let { children, target = '_self', replace = false, href, to, onClick, onMouseEnter, onMouseLeave, onPointerDown, onFocus, onBlur, type: linkType = 'a', params, query, prefetch = false, state } = _ref, rest = (0, _objectWithoutPropertiesLooseDefault.default)(_ref, _excluded);
    const routerActions = (0, _routerStore.useRouterStoreActions)();
    const { schedule, cancel } = (0, _useTimeout.useTimeout)(PREFETCH_DELAY);
    const validLinkType = (0, _utils1.getValidLinkType)(linkType);
    const [route, setRoute] = (0, _react.useState)(()=>{
        if (to && typeof to !== 'string') {
            if ('then' in to) to.then((r)=>setRoute('default' in r ? r.default : r));
            else return to;
        }
    });
    const routeAttributes = {
        params,
        query,
        basePath: routerActions.getBasePath()
    };
    const linkDestination = href != null ? href : typeof to !== 'string' ? route && (0, _history.createPath)((0, _utils.generateLocationFromPath)(route.path, routeAttributes)) || '' : to;
    const IS_ABSOLUTE_LINK_REGEX = /^((?:(http|https):\/\/)|\/\/)/;
    const staticBasePath = href != null && !IS_ABSOLUTE_LINK_REGEX.test(href) || typeof to === 'string' ? routeAttributes.basePath : '';
    const triggerPrefetch = (0, _react.useCallback)(()=>{
        // ignore if async route not ready yet
        if (typeof to !== 'string' && !route) return;
        const context = typeof to !== 'string' && route ? (0, _utils.createRouterContext)(route, {
            params,
            query
        }) : null;
        routerActions.prefetchRoute(linkDestination, context);
    // omit params & query as already in linkDestination
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        route,
        linkDestination,
        routerActions
    ]);
    (0, _react.useEffect)(()=>{
        if (prefetch === 'mount') schedule(triggerPrefetch);
        return cancel;
    }, [
        prefetch,
        schedule,
        cancel,
        triggerPrefetch
    ]);
    const handleLinkPress = (e)=>(0, _utils1.handleNavigation)(e, {
            onClick,
            target,
            replace,
            routerActions,
            href: linkDestination,
            to: route && [
                route,
                {
                    params,
                    query
                }
            ],
            state
        });
    const handleMouseEnter = (e)=>{
        if (prefetch === 'hover') schedule(triggerPrefetch);
        onMouseEnter && onMouseEnter(e);
    };
    const handleMouseLeave = (e)=>{
        if (prefetch === 'hover') cancel();
        onMouseLeave && onMouseLeave(e);
    };
    const handleFocus = (e)=>{
        if (prefetch === 'hover') schedule(triggerPrefetch);
        onFocus && onFocus(e);
    };
    const handleBlur = (e)=>{
        if (prefetch === 'hover') cancel();
        onBlur && onBlur(e);
    };
    const handlePointerDown = (e)=>{
        if (prefetch === 'hover') {
            cancel();
            triggerPrefetch();
        }
        onPointerDown && onPointerDown(e);
    };
    return /*#__PURE__*/ (0, _react.createElement)(validLinkType, (0, _extendsDefault.default)({}, rest, {
        href: `${staticBasePath}${linkDestination}`,
        target,
        onClick: handleLinkPress,
        onKeyDown: handleLinkPress,
        onMouseEnter: handleMouseEnter,
        onMouseLeave: handleMouseLeave,
        onFocus: handleFocus,
        onBlur: handleBlur,
        onPointerDown: handlePointerDown,
        ref
    }), children);
});
Link.displayName = 'Link';
exports.default = Link;

},{"@babel/runtime/helpers/extends":"3LZYG","@babel/runtime/helpers/objectWithoutPropertiesLoose":"5JG3D","history":"de6OM","react":"ltHCL","../../common/utils":"c9Uvk","../../controllers/router-store":"bWF6v","../../controllers/use-timeout":"czIvJ","./utils":"jmylz","@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"czIvJ":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "useTimeout", ()=>useTimeout);
var _react = require("react");
const useTimeout = (delay)=>{
    const timeoutId = (0, _react.useRef)();
    const schedule = (0, _react.useCallback)((callback)=>{
        if (timeoutId.current) clearTimeout(timeoutId.current);
        timeoutId.current = setTimeout(callback, delay);
    }, [
        delay
    ]);
    const cancel = (0, _react.useCallback)(()=>{
        clearTimeout(timeoutId.current);
    }, []);
    return {
        schedule,
        cancel
    };
};

},{"react":"ltHCL","@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"jmylz":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "getValidLinkType", ()=>(0, _getValidLinkType.getValidLinkType));
parcelHelpers.export(exports, "handleNavigation", ()=>(0, _handleNavigation.handleNavigation));
var _getValidLinkType = require("./get-valid-link-type");
var _handleNavigation = require("./handle-navigation");

},{"./get-valid-link-type":"h4NFV","./handle-navigation":"3XIeA","@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"h4NFV":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "getValidLinkType", ()=>getValidLinkType);
const VALID_LINK_TYPES = [
    'a',
    'button'
];
const getValidLinkType = (type)=>VALID_LINK_TYPES.includes(type) ? type : 'a';

},{"@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"3XIeA":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "handleNavigation", ()=>handleNavigation);
var _event = require("../../../common/utils/event");
const handleNavigation = (event, { onClick, target, replace, routerActions, href, to, state })=>{
    if ((0, _event.isKeyboardEvent)(event) && event.key !== 'Enter') return;
    onClick && onClick(event);
    if (!event.defaultPrevented && // onClick prevented default
    ((0, _event.isKeyboardEvent)(event) && event.key === 'Enter' || event.button === 0) && // ignore everything but left clicks and Enter key
    (!target || target === '_self') && // let browser handle "target=_blank" etc.
    !(0, _event.isModifiedEvent)(event) // ignore clicks with modifier keys
    ) {
        event.preventDefault();
        if (to) {
            const method = replace ? routerActions.replaceTo : routerActions.pushTo;
            method(...to, state);
        } else {
            const method = replace ? routerActions.replace : routerActions.push;
            method(href, state);
        }
    }
};

},{"../../../common/utils/event":"fmYL0","@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"fmYL0":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "isModifiedEvent", ()=>isModifiedEvent);
parcelHelpers.export(exports, "isKeyboardEvent", ()=>isKeyboardEvent);
const isModifiedEvent = (event)=>!!(event.metaKey || event.altKey || event.ctrlKey || event.shiftKey);
const isKeyboardEvent = (event)=>[
        'keypress',
        'keydown',
        'keyup'
    ].includes(event.type);

},{"@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"jPhgn":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "RouteComponent", ()=>RouteComponent);
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _controllers = require("../../controllers");
const RouteComponent = ()=>{
    const [{ action, location, match, query, route }] = (0, _controllers.useRouter)();
    if (!route || !route.component) return null;
    return /*#__PURE__*/ (0, _reactDefault.default).createElement(route.component, {
        action: action,
        location: location,
        match: match,
        query: query,
        route: route
    });
};

},{"react":"ltHCL","../../controllers":"kk7tw","@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"izQoo":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "invokePluginLoad", ()=>invokePluginLoad);
var _utils = require("../../common/utils");
const invokePluginLoad = (plugins, { routes, history, basePath })=>{
    const context = (0, _utils.findRouterContext)(routes, {
        location: history.location,
        basePath
    });
    plugins.forEach((p)=>{
        p.routeLoad == null || p.routeLoad({
            context
        });
    });
};

},{"../../common/utils":"c9Uvk","@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"2yUjo":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "createResourcesPlugin", ()=>(0, _plugin.createResourcesPlugin));
parcelHelpers.export(exports, "ResourceSubscriber", ()=>(0, _resourceSubscriber.ResourceSubscriber));
parcelHelpers.export(exports, "useResource", ()=>(0, _useResource.useResource));
parcelHelpers.export(exports, "addResourcesListener", ()=>(0, _addResourceListener.addResourcesListener));
parcelHelpers.export(exports, "createResource", ()=>(0, _resourceStore.createResource));
parcelHelpers.export(exports, "useResourceStoreContext", ()=>(0, _resourceStore.useResourceStoreContext));
parcelHelpers.export(exports, "ResourceDependencyError", ()=>(0, _resourceStore.ResourceDependencyError));
parcelHelpers.export(exports, "getResourceStore", ()=>(0, _resourceStore.getResourceStore));
parcelHelpers.export(exports, "ResourceStore", ()=>(0, _resourceStore.ResourceStore));
parcelHelpers.export(exports, "PLUGIN_ID", ()=>(0, _index.PLUGIN_ID));
parcelHelpers.export(exports, "mockRouteResourceResponse", ()=>(0, _mocks.mockRouteResourceResponse));
var _plugin = require("./plugin");
var _resourceSubscriber = require("./controllers/resource-subscriber");
var _useResource = require("./controllers/use-resource");
var _addResourceListener = require("./controllers/add-resource-listener");
var _resourceStore = require("./controllers/resource-store");
var _index = require("./plugin/index");
var _mocks = require("./common/mocks");

},{"./plugin":"5tKi3","./controllers/resource-subscriber":"hJnua","./controllers/use-resource":"cxy6U","./controllers/add-resource-listener":"97DYC","./controllers/resource-store":"fd8OL","./plugin/index":"5tKi3","./common/mocks":"3p51E","@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"5tKi3":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "PLUGIN_ID", ()=>PLUGIN_ID);
parcelHelpers.export(exports, "createResourcesPlugin", ()=>createResourcesPlugin);
var _resourceStore = require("../controllers/resource-store");
var _utils = require("../controllers/resource-store/utils");
const PLUGIN_ID = 'resources-plugin';
const loadOnUrlChange = (context, prevContext)=>{
    const { requestResources, getContext: getResourceStoreContext } = (0, _resourceStore.getResourceStore)().actions;
    const nextResources = (0, _utils.getResourcesForNextLocation)(prevContext, context, getResourceStoreContext());
    return Promise.all(requestResources(nextResources, context, {}));
};
const beforeLoad = ({ context, nextContext })=>{
    const { cleanExpiredResources, getContext: getResourceStoreContext } = (0, _resourceStore.getResourceStore)().actions;
    const nextResources = (0, _utils.getResourcesForNextLocation)(context, nextContext, getResourceStoreContext());
    cleanExpiredResources(nextResources, nextContext);
};
const createResourcesPlugin = ({ context: initialResourceContext, resourceData: initialResourceData, timeout })=>{
    let latestLoadedResources = Promise.resolve([]);
    (0, _resourceStore.getResourceStore)().actions.hydrate({
        resourceContext: initialResourceContext,
        resourceData: initialResourceData
    });
    return {
        id: PLUGIN_ID,
        beforeRouteLoad: beforeLoad,
        routeLoad: ({ context, prevContext })=>{
            const { route, match, query } = context;
            // TODO: in next refactoring add `if (route.resources)` check
            // For now requesting resources for every route even if `resources` prop is missing on Route
            if (prevContext) latestLoadedResources = loadOnUrlChange(context, prevContext);
            else latestLoadedResources = (0, _resourceStore.getResourceStore)().actions.requestAllResources({
                route,
                match,
                query
            }, {
                timeout
            });
        },
        routePrefetch: ({ context, nextContext })=>{
            const { prefetchResources, getContext: getResourceStoreContext } = (0, _resourceStore.getResourceStore)().actions;
            const nextResources = (0, _utils.getResourcesForNextLocation)(context, nextContext, getResourceStoreContext());
            return {
                resources: prefetchResources(nextResources, nextContext, {})
            };
        },
        getLatestResources: ()=>latestLoadedResources,
        getSerializedResources: async ()=>{
            await latestLoadedResources;
            return (0, _resourceStore.getResourceStore)().actions.getSafeData();
        }
    };
};

},{"../controllers/resource-store":"fd8OL","../controllers/resource-store/utils":"kZEFN","@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"fd8OL":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "createResource", ()=>(0, _utils1.createResource));
parcelHelpers.export(exports, "ResourceDependencyError", ()=>(0, _utils1.ResourceDependencyError));
parcelHelpers.export(exports, "privateActions", ()=>privateActions);
parcelHelpers.export(exports, "actions", ()=>actions);
parcelHelpers.export(exports, "ResourceStore", ()=>ResourceStore);
parcelHelpers.export(exports, "ResourceContainer", ()=>ResourceContainer);
parcelHelpers.export(exports, "ResourceSubscriber", ()=>ResourceSubscriber);
parcelHelpers.export(exports, "getResourceStore", ()=>getResourceStore);
parcelHelpers.export(exports, "useResourceStore", ()=>useResourceStore);
parcelHelpers.export(exports, "useResourceStoreActions", ()=>useResourceStoreActions);
parcelHelpers.export(exports, "useResourceStoreContext", ()=>useResourceStoreContext);
var _extends = require("@babel/runtime/helpers/extends");
var _extendsDefault = parcelHelpers.interopDefault(_extends);
var _objectWithoutPropertiesLoose = require("@babel/runtime/helpers/objectWithoutPropertiesLoose");
var _objectWithoutPropertiesLooseDefault = parcelHelpers.interopDefault(_objectWithoutPropertiesLoose);
var _reactSweetState = require("react-sweet-state");
var _utils = require("../../../common/utils");
var _selectors = require("./selectors");
var _utils1 = require("./utils");
const _excluded = [
    "context"
], _excluded2 = [
    "error",
    "expiresAt",
    "loading"
];
const privateActions = {
    /**
   * Clears a resource for the current key, or where context is not provided all keys.
   */ clearResource: (resource, routerStoreContext)=>({ getState, dispatch })=>{
            const { type, getKey } = resource;
            const { context } = getState();
            if (routerStoreContext) {
                const key = getKey(routerStoreContext, context);
                dispatch((0, _utils1.deleteResourceState)(type, key));
                dispatch((0, _utils1.executeForDependents)(resource, (dependentResource)=>privateActions.clearResource(dependentResource, routerStoreContext)));
            } else dispatch((0, _utils1.deleteResourceState)(type));
        },
    /**
   * Update the data property for a resource in the cache and reset expiresAt based
   * on maxAge.
   */ updateResourceState: (resource, routerStoreContext, getNewSliceData)=>({ getState, dispatch })=>{
            const { type, getKey, maxAge } = resource;
            const _getState = getState(), { context } = _getState, resourceStoreState = (0, _objectWithoutPropertiesLooseDefault.default)(_getState, _excluded);
            const key = getKey(routerStoreContext, context);
            const prevSlice = (0, _selectors.getSliceForResource)(resourceStoreState, {
                type,
                key
            });
            const data = getNewSliceData(prevSlice.data);
            const changes = prevSlice.loading ? {
                data,
                error: null,
                loading: true
            } : {
                data,
                error: null,
                loading: false,
                promise: Promise.resolve(data)
            };
            const newSlice = (0, _extendsDefault.default)({}, prevSlice, changes, {
                expiresAt: (0, _utils1.getExpiresAt)(maxAge),
                accessedAt: (0, _utils1.getAccessedAt)()
            });
            dispatch((0, _utils1.setResourceState)(type, key, newSlice));
            // trigger dependent resources on change
            if (newSlice.data !== prevSlice.data) dispatch((0, _utils1.executeForDependents)(resource, (dependentResource)=>privateActions.getResourceFromRemote(dependentResource, routerStoreContext, {})));
        },
    /**
   * Get a single resource, either from the cache if it exists and has not expired, or
   * the remote if it has expired.
   */ getResource: (resource, routerStoreContext, options)=>async ({ getState, dispatch })=>{
            const { type, getKey, maxAge } = resource;
            const { context } = getState();
            const key = getKey(routerStoreContext, context);
            let cached = dispatch((0, _utils1.getResourceState)(type, key));
            if (cached && (0, _utils1.shouldUseCache)(cached)) {
                if ((0, _utils1.isFromSsr)(cached)) {
                    const withResolvedPromise = (0, _utils1.setSsrDataPromise)(cached);
                    cached = (0, _utils1.setExpiresAt)(withResolvedPromise, maxAge);
                }
                cached.accessedAt = (0, _utils1.getAccessedAt)();
                dispatch((0, _utils1.setResourceState)(type, key, cached));
                return cached;
            }
            return dispatch(privateActions.getResourceFromRemote(resource, routerStoreContext, options));
        },
    /**
   * Request a single resource and update the resource cache.
   */ getResourceFromRemote: (resource, routerStoreContext, options)=>async ({ getState, dispatch })=>{
            const { type, getKey, maxAge } = resource;
            const { context } = getState();
            const key = getKey(routerStoreContext, context);
            const prevSlice = dispatch((0, _utils1.getResourceState)(type, key)) || (0, _utils1.getDefaultStateSlice)();
            // abort request if already in flight
            if (prevSlice.loading) return prevSlice;
            dispatch((0, _utils1.validateLRUCache)(resource, key));
            const loadingSlice = dispatch((0, _utils1.getPrefetchSlice)(type, key)) || (0, _utils1.createLoadingSlice)({
                context,
                dependencies: ()=>dispatch((0, _utils1.getDependencies)(resource, routerStoreContext, options)),
                options,
                resource,
                routerStoreContext
            });
            let resolvedSlice;
            if (loadingSlice.data === prevSlice.data) // same data (by reference) means nothing has changed and we can avoid loading state
            resolvedSlice = {};
            else {
                // enter loading state
                dispatch((0, _utils1.setResourceState)(type, key, (0, _extendsDefault.default)({}, prevSlice, loadingSlice, {
                    data: maxAge === 0 ? null : prevSlice.data,
                    error: maxAge === 0 ? null : prevSlice.error,
                    loading: true,
                    accessedAt: (0, _utils1.getAccessedAt)()
                })));
                // trigger dependent resources to also load
                dispatch((0, _utils1.executeForDependents)(resource, (dependentResource)=>privateActions.getResourceFromRemote(dependentResource, routerStoreContext, options)));
                // in case another action occurred while loading promise may not be the one we started with
                // we need to re-assign promise consistent with error/data that we are assigning here
                try {
                    var _loadingSlice$data;
                    const data = (_loadingSlice$data = loadingSlice.data) != null ? _loadingSlice$data : await loadingSlice.promise;
                    resolvedSlice = {
                        data,
                        error: null,
                        // any existing error is cleared
                        loading: false,
                        promise: loadingSlice.promise
                    };
                } catch (error) {
                    if (error instanceof (0, _utils1.TimeoutError)) resolvedSlice = {
                        // data: do not replace existing data
                        error,
                        loading: true,
                        // this condition cannot recover so must only be present in static/server router
                        promise: null // special case for timeout
                    };
                    else resolvedSlice = {
                        // data: do not replace existing data
                        // @ts-ignore
                        error,
                        loading: false,
                        promise: loadingSlice.promise
                    };
                }
            }
            // ensure most recent data when return occurs
            const recentSlice = dispatch((0, _utils1.getResourceState)(type, key));
            const finalSlice = (0, _extendsDefault.default)({}, recentSlice || prevSlice, resolvedSlice, {
                accessedAt: (0, _utils1.getAccessedAt)(),
                expiresAt: (0, _utils1.getExpiresAt)(maxAge)
            });
            // protect against race conditions: if resources get cleared while await happens, we discard the result
            if (recentSlice || loadingSlice.data !== undefined) dispatch((0, _utils1.setResourceState)(type, key, finalSlice));
            return finalSlice;
        },
    /**
   * Prefetch a single resource and store in the prefetch cache.
   */ prefetchResourceFromRemote: (resource, routerStoreContext, options)=>async ({ getState, dispatch })=>{
            const { type, getKey } = resource;
            const { context } = getState();
            const key = getKey(routerStoreContext, context);
            const loadingSlice = dispatch((0, _utils1.getPrefetchSlice)(type, key)) || (0, _utils1.createLoadingSlice)({
                context,
                dependencies: ()=>dispatch((0, _utils1.getDependencies)(resource, routerStoreContext, options)),
                options,
                resource,
                routerStoreContext
            });
            // save deferred value to be used also by dependants
            dispatch((0, _utils1.setPrefetchSlice)(type, key, loadingSlice));
            // trigger dependent resources to also prefetch
            dispatch((0, _utils1.executeForDependents)(resource, (dependentResource)=>privateActions.prefetchResourceFromRemote(dependentResource, routerStoreContext, options)));
        }
};
const actions = {
    /**
   * Clears a resource for the current key, or where context is not provided all keys.
   * Execute such that dependencies on current route will be cleared.
   */ clearResource: (resource, routerStoreContext)=>{
        var _routerStoreContext$r;
        return (0, _utils1.actionWithDependencies)(routerStoreContext == null || (_routerStoreContext$r = routerStoreContext.route) == null ? void 0 : _routerStoreContext$r.resources, resource, privateActions.clearResource(resource, routerStoreContext != null ? routerStoreContext : null));
    },
    /**
   * Update the data property for a resource in the cache and reset expiresAt based
   * on maxAge.
   * Execute such that dependencies on current route will be updated.
   */ updateResourceState: (resource, routerStoreContext, getNewSliceData)=>(0, _utils1.actionWithDependencies)(routerStoreContext.route.resources, resource, privateActions.updateResourceState(resource, routerStoreContext, getNewSliceData)),
    /**
   * Get a single resource, either from the cache if it exists and has not expired, or
   * the remote if it has expired.
   * Execute such that dependencies on current route will be updated.
   */ getResource: (resource, routerStoreContext, options)=>(0, _utils1.actionWithDependencies)(routerStoreContext.route.resources, resource, privateActions.getResource(resource, routerStoreContext, options)),
    /**
   * Request a single resource and update the resource cache.
   * Execute such that dependencies on current route will be updated.
   */ getResourceFromRemote: (resource, routerStoreContext, options)=>(0, _utils1.actionWithDependencies)(routerStoreContext.route.resources, resource, privateActions.getResourceFromRemote(resource, routerStoreContext, options)),
    /**
   * Request all resources.
   */ requestAllResources: (routerStoreContext, options = {})=>({ dispatch })=>{
            const { route: routeDefault } = routerStoreContext || {};
            const route = routeDefault;
            if (!route || !route.resources) return Promise.all([]);
            return Promise.all(dispatch(actions.requestResources(route.resources, routerStoreContext, options)));
        },
    /**
   * Cleans expired resources and resets them back to their initial state.
   * We need to do this when transitioning into a route.
   */ cleanExpiredResources: (resources, routerStoreContext)=>({ getState, dispatch })=>{
            const { context: resourceContext } = getState();
            resources.forEach((resource)=>{
                const { type, getKey } = resource;
                const key = getKey(routerStoreContext, resourceContext);
                const slice = dispatch((0, _utils1.getResourceState)(type, key));
                if (slice && (!slice.expiresAt || slice.expiresAt < Date.now())) dispatch((0, _utils1.deleteResourceState)(type, key));
            });
        },
    /**
   * Requests a specific set of resources.
   */ requestResources: (resources, routerStoreContext, options)=>{
        var _resources;
        const predicate = (0, _utils.isServerEnvironment)() ? ({ isBrowserOnly })=>!isBrowserOnly : ()=>true;
        return (0, _utils1.mapActionWithDependencies)((_resources = routerStoreContext.route.resources) == null ? void 0 : _resources.filter(predicate), resources.filter(predicate), (resource)=>privateActions.getResource(resource, routerStoreContext, options));
    },
    /**
   * Prefetch a specific set of resources.
   */ prefetchResources: (resources, routerStoreContext, options)=>(0, _utils1.mapActionWithDependencies)(routerStoreContext.route.resources, resources, (resource)=>privateActions.prefetchResourceFromRemote(resource, routerStoreContext, (0, _extendsDefault.default)({}, options, {
                prefetch: true
            }))),
    /**
   * Hydrates the store with state.
   * Will not override pre-hydrated state.
   */ hydrate: ({ resourceData, resourceContext })=>({ getState, setState })=>{
            const { data, context } = getState();
            function getNextStateValue(prev, next) {
                if (!Object.keys(prev).length && next && Object.keys(next).length) return next;
                return prev;
            }
            const hydratedData = (0, _utils1.transformData)(getNextStateValue(data, resourceData), (_ref)=>{
                let { error, expiresAt, loading } = _ref, rest = (0, _objectWithoutPropertiesLooseDefault.default)(_ref, _excluded2);
                const deserializedError = !error ? null : (0, _utils1.deserializeError)(error);
                const isTimeoutError = (deserializedError == null ? void 0 : deserializedError.name) === 'TimeoutError';
                return (0, _extendsDefault.default)({}, rest, {
                    expiresAt: isTimeoutError ? Date.now() - 1 : expiresAt,
                    loading: isTimeoutError ? false : loading,
                    error: deserializedError
                });
            });
            setState({
                data: hydratedData,
                context: getNextStateValue(context, resourceContext)
            });
        },
    /**
   * Gets the store's context
   */ getContext: ()=>({ getState })=>getState().context,
    /**
   * Returns safe, portable and rehydratable data.
   */ getSafeData: ()=>({ getState })=>(0, _utils1.transformData)(getState().data, ({ data, key, error, loading })=>({
                    data,
                    key,
                    promise: null,
                    expiresAt: null,
                    accessedAt: null,
                    error: !error ? null : (0, _utils1.serializeError)(error instanceof Error ? error : new Error(JSON.stringify(error))),
                    loading: error instanceof (0, _utils1.TimeoutError) ? loading : false
                }))
};
const ResourceStore = (0, _reactSweetState.createStore)({
    initialState: {
        data: {},
        context: {},
        executing: null,
        prefetching: null
    },
    actions,
    name: 'router-resources'
});
const ResourceContainer = (0, _reactSweetState.createContainer)(ResourceStore, {
    displayName: 'ResourceContainer'
});
const ResourceSubscriber = (0, _reactSweetState.createSubscriber)(ResourceStore, {
    displayName: 'ResourceSelectorSubscriber',
    selector: (state, props)=>(0, _selectors.getSliceForResource)(state, {
            type: props.resourceType,
            key: props.resourceKey
        })
});
const getResourceStore = ()=>// @ts-ignore not providing a scopeId param
    (0, _reactSweetState.defaultRegistry).getStore(ResourceStore);
const useResourceStore = (0, _reactSweetState.createHook)(ResourceStore, {
    selector: (0, _selectors.getSliceForResource)
});
const useResourceStoreActions = (0, _reactSweetState.createActionsHook)(ResourceStore);
const useResourceStoreContext = (0, _reactSweetState.createHook)(ResourceStore, {
    selector: (0, _selectors.getResourceStoreContext)
});

},{"@babel/runtime/helpers/extends":"3LZYG","@babel/runtime/helpers/objectWithoutPropertiesLoose":"5JG3D","react-sweet-state":"b2YYl","../../../common/utils":"c9Uvk","./selectors":"75rcf","./utils":"kZEFN","@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"75rcf":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "getSliceForResource", ()=>getSliceForResource);
parcelHelpers.export(exports, "getResourceStoreContext", ()=>getResourceStoreContext);
var _extends = require("@babel/runtime/helpers/extends");
var _extendsDefault = parcelHelpers.interopDefault(_extends);
var _utils = require("./utils");
const getSliceForResource = (state, props)=>{
    const { type, key } = props;
    const slice = state.data[type] && state.data[type][key];
    return slice ? (0, _extendsDefault.default)({}, slice) : (0, _utils.getDefaultStateSlice)();
};
const getResourceStoreContext = (state)=>state.context;

},{"@babel/runtime/helpers/extends":"3LZYG","./utils":"kZEFN","@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"kZEFN":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "getAccessedAt", ()=>(0, _accessedAt.getAccessedAt));
parcelHelpers.export(exports, "createLoadingSlice", ()=>(0, _createLoadingSlice.createLoadingSlice));
parcelHelpers.export(exports, "createResource", ()=>(0, _createResource.createResource));
parcelHelpers.export(exports, "ResourceDependencyError", ()=>(0, _dependentResources.ResourceDependencyError));
parcelHelpers.export(exports, "actionWithDependencies", ()=>(0, _dependentResources.actionWithDependencies));
parcelHelpers.export(exports, "mapActionWithDependencies", ()=>(0, _dependentResources.mapActionWithDependencies));
parcelHelpers.export(exports, "executeForDependents", ()=>(0, _dependentResources.executeForDependents));
parcelHelpers.export(exports, "getDependencies", ()=>(0, _dependentResources.getDependencies));
parcelHelpers.export(exports, "getExpiresAt", ()=>(0, _expiresAt.getExpiresAt));
parcelHelpers.export(exports, "setExpiresAt", ()=>(0, _expiresAt.setExpiresAt));
parcelHelpers.export(exports, "generateTimeGuard", ()=>(0, _generateTimeGuard.generateTimeGuard));
parcelHelpers.export(exports, "getDefaultStateSlice", ()=>(0, _getDefaultStateSlice.getDefaultStateSlice));
parcelHelpers.export(exports, "getResourceIdentifier", ()=>(0, _getResourceIdentifier.getResourceIdentifier));
parcelHelpers.export(exports, "getResourcesForNextLocation", ()=>(0, _getResourcesForNextLocation.getResourcesForNextLocation));
parcelHelpers.export(exports, "validateLRUCache", ()=>(0, _lruCache.validateLRUCache));
parcelHelpers.export(exports, "deleteResourceState", ()=>(0, _manageResourceState.deleteResourceState));
parcelHelpers.export(exports, "getResourceState", ()=>(0, _manageResourceState.getResourceState));
parcelHelpers.export(exports, "setResourceState", ()=>(0, _manageResourceState.setResourceState));
parcelHelpers.export(exports, "getPrefetchSlice", ()=>(0, _manageResourceState.getPrefetchSlice));
parcelHelpers.export(exports, "setPrefetchSlice", ()=>(0, _manageResourceState.setPrefetchSlice));
parcelHelpers.export(exports, "routeHasChanged", ()=>(0, _routeChecks.routeHasChanged));
parcelHelpers.export(exports, "routeHasResources", ()=>(0, _routeChecks.routeHasResources));
parcelHelpers.export(exports, "serializeError", ()=>(0, _serializeError.serializeError));
parcelHelpers.export(exports, "deserializeError", ()=>(0, _serializeError.deserializeError));
parcelHelpers.export(exports, "shouldUseCache", ()=>(0, _shouldUseCache.shouldUseCache));
parcelHelpers.export(exports, "isFromSsr", ()=>(0, _shouldUseCache.isFromSsr));
parcelHelpers.export(exports, "setSsrDataPromise", ()=>(0, _ssrDataPromise.setSsrDataPromise));
parcelHelpers.export(exports, "TimeoutError", ()=>(0, _timeoutError.TimeoutError));
parcelHelpers.export(exports, "transformData", ()=>(0, _transformData.transformData));
var _accessedAt = require("./accessed-at");
var _createLoadingSlice = require("./create-loading-slice");
var _createResource = require("./create-resource");
var _dependentResources = require("./dependent-resources");
var _expiresAt = require("./expires-at");
var _generateTimeGuard = require("./generate-time-guard");
var _getDefaultStateSlice = require("./get-default-state-slice");
var _getResourceIdentifier = require("./get-resource-identifier");
var _getResourcesForNextLocation = require("./get-resources-for-next-location");
var _lruCache = require("./lru-cache");
var _manageResourceState = require("./manage-resource-state");
var _routeChecks = require("./route-checks");
var _serializeError = require("./serialize-error");
var _shouldUseCache = require("./should-use-cache");
var _ssrDataPromise = require("./ssr-data-promise");
var _timeoutError = require("./timeout-error");
var _transformData = require("./transform-data");

},{"./accessed-at":"4X8uX","./create-loading-slice":"aQCOS","./create-resource":"dEqo2","./dependent-resources":"4heVk","./expires-at":"6ptGD","./generate-time-guard":"dfbBg","./get-default-state-slice":"cJmeZ","./get-resource-identifier":"8Xthv","./get-resources-for-next-location":"3bB0c","./lru-cache":"9ibAU","./manage-resource-state":"37ND1","./route-checks":"gUmkK","./serialize-error":"hrNo1","./should-use-cache":"eoQYy","./ssr-data-promise":"2p7n8","./timeout-error":"c5S1U","./transform-data":"9ZoQK","@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"4X8uX":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "getAccessedAt", ()=>getAccessedAt);
const getAccessedAt = ()=>Date.now();

},{"@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"aQCOS":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "createLoadingSlice", ()=>createLoadingSlice);
var _extends = require("@babel/runtime/helpers/extends");
var _extendsDefault = parcelHelpers.interopDefault(_extends);
var _constants = require("../create-resource/constants");
var _expiresAt = require("../expires-at");
var _generateTimeGuard = require("../generate-time-guard");
var _timeoutError = require("../timeout-error");
var _constants1 = require("./constants");
function createLoadingSlice({ context, dependencies, options, resource, routerStoreContext }) {
    var _promiseOrData, _resource$maxAge;
    const { type, getData } = resource;
    const { prefetch, timeout } = options;
    // hard errors in dependencies or getData are converted into softer async error
    let promiseOrData;
    try {
        promiseOrData = getData((0, _extendsDefault.default)({}, routerStoreContext, {
            isPrefetch: !!prefetch,
            dependencies: dependencies()
        }), context);
    } catch (error) {
        promiseOrData = Promise.reject(error);
    }
    // ensure the promise includes any timeout error
    const timeoutGuard = timeout ? (0, _generateTimeGuard.generateTimeGuard)(timeout) : null;
    // check if getData was sync, by looking for a Promise-like shape
    const data = typeof ((_promiseOrData = promiseOrData) == null ? void 0 : _promiseOrData.then) === 'function' ? undefined : promiseOrData;
    const promise = timeout ? Promise.race([
        promiseOrData,
        timeoutGuard == null ? void 0 : timeoutGuard.promise
    ]).then((maybeData)=>{
        if (timeoutGuard && !timeoutGuard.isPending) throw new (0, _timeoutError.TimeoutError)(type);
        (timeoutGuard == null ? void 0 : timeoutGuard.timerId) && clearTimeout(timeoutGuard.timerId);
        return maybeData;
    }) : // if we already have a result, wrap it so consumers can access it via same API
    data !== undefined ? Promise.resolve(data) : promiseOrData;
    const resourceMaxAge = (0, _expiresAt.getExpiresAt)((_resource$maxAge = resource.maxAge) != null ? _resource$maxAge : (0, _constants.DEFAULT_RESOURCE_MAX_AGE));
    return {
        promise,
        data,
        expiresAt: prefetch ? Math.max(resourceMaxAge, (0, _expiresAt.getExpiresAt)((0, _constants1.DEFAULT_PREFETCH_MAX_AGE))) : resourceMaxAge
    };
}

},{"@babel/runtime/helpers/extends":"3LZYG","../create-resource/constants":"dTOQe","../expires-at":"6ptGD","../generate-time-guard":"dfbBg","../timeout-error":"c5S1U","./constants":"8uELT","@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"dTOQe":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "DEFAULT_CACHE_MAX_LIMIT", ()=>DEFAULT_CACHE_MAX_LIMIT);
parcelHelpers.export(exports, "DEFAULT_RESOURCE_BROWSER_ONLY", ()=>DEFAULT_RESOURCE_BROWSER_ONLY);
parcelHelpers.export(exports, "DEFAULT_RESOURCE_MAX_AGE", ()=>DEFAULT_RESOURCE_MAX_AGE);
const DEFAULT_CACHE_MAX_LIMIT = 100;
const DEFAULT_RESOURCE_BROWSER_ONLY = false;
const DEFAULT_RESOURCE_MAX_AGE = 0;

},{"@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"6ptGD":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "getExpiresAt", ()=>getExpiresAt);
parcelHelpers.export(exports, "setExpiresAt", ()=>setExpiresAt);
var _extends = require("@babel/runtime/helpers/extends");
var _extendsDefault = parcelHelpers.interopDefault(_extends);
const getExpiresAt = (maxAge)=>Date.now() + maxAge;
const setExpiresAt = (slice, maxAge)=>slice.expiresAt === null ? (0, _extendsDefault.default)({}, slice, {
        expiresAt: getExpiresAt(maxAge)
    }) : slice;

},{"@babel/runtime/helpers/extends":"3LZYG","@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"dfbBg":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "generateTimeGuard", ()=>generateTimeGuard);
const generateTimeGuard = (duration)=>{
    const promiseState = {
        timerId: null,
        isPending: true,
        promise: undefined
    };
    promiseState.promise = new Promise((r)=>{
        const timerId = setTimeout(()=>{
            promiseState.isPending = false;
            r();
        }, duration);
        promiseState.timerId = timerId;
    });
    return promiseState;
};

},{"@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"c5S1U":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "TimeoutError", ()=>TimeoutError);
class TimeoutError extends Error {
    constructor(message){
        super('Resource timed out: ' + message);
        this.name = 'TimeoutError';
    }
}

},{"@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"8uELT":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "DEFAULT_PREFETCH_MAX_AGE", ()=>DEFAULT_PREFETCH_MAX_AGE);
const DEFAULT_PREFETCH_MAX_AGE = 10000;

},{"@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"dEqo2":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "createResource", ()=>createResource);
var _constants = require("./constants");
/**
 * Utility method to created async versions of getData functions
 */ const handleGetDataLoader = (asyncImport)=>async (...args)=>{
        const { default: getDataFn } = await asyncImport();
        return getDataFn(...args);
    };
const createResource = (arg)=>{
    var _getData, _arg$depends;
    return {
        type: arg.type,
        getKey: arg.getKey,
        getData: (_getData = arg.getData) != null ? _getData : handleGetDataLoader(arg.getDataLoader),
        maxAge: typeof arg.maxAge === 'number' ? arg.maxAge : (0, _constants.DEFAULT_RESOURCE_MAX_AGE),
        maxCache: typeof arg.maxCache === 'number' ? arg.maxCache : (0, _constants.DEFAULT_CACHE_MAX_LIMIT),
        isBrowserOnly: typeof arg.isBrowserOnly === 'boolean' ? arg.isBrowserOnly : (0, _constants.DEFAULT_RESOURCE_BROWSER_ONLY),
        depends: (_arg$depends = arg.depends) != null ? _arg$depends : null
    };
};

},{"./constants":"dTOQe","@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"4heVk":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "ResourceDependencyError", ()=>ResourceDependencyError);
parcelHelpers.export(exports, "executeTuples", ()=>executeTuples);
parcelHelpers.export(exports, "actionWithDependencies", ()=>actionWithDependencies);
parcelHelpers.export(exports, "mapActionWithDependencies", ()=>mapActionWithDependencies);
parcelHelpers.export(exports, "executeForDependents", ()=>executeForDependents);
parcelHelpers.export(exports, "getDependencies", ()=>getDependencies);
var _extends = require("@babel/runtime/helpers/extends");
var _extendsDefault = parcelHelpers.interopDefault(_extends);
var _getDefaultStateSlice = require("../get-default-state-slice");
var _manageResourceState = require("../manage-resource-state");
var _Object$fromEntries;
// https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Object/fromEntries
const fromEntries = (_Object$fromEntries = Object.fromEntries) != null ? _Object$fromEntries : (entries)=>Object.assign({}, ...entries.map(([k, v])=>({
            [k]: v
        })));
const matchType = (a)=>(b)=>{
        const [{ type: typeA }] = Array.isArray(a) ? a : [
            a
        ];
        const [{ type: typeB }] = Array.isArray(b) ? b : [
            b
        ];
        return typeA === typeB;
    };
class ResourceDependencyError extends Error {
    constructor(message){
        super(message);
        this.name = 'ResourceDependencyError';
    }
}
const executeTuples = (routeResources, tuples)=>({ getState, setState, dispatch })=>{
        var _routeResources$some;
        if (getState().executing) throw new Error('execution is already in progress');
        // check if there are resources and if so if there are any resources with dependencies
        const hasDependentResources = (_routeResources$some = routeResources == null ? void 0 : routeResources.some(({ depends })=>depends == null ? void 0 : depends.length)) != null ? _routeResources$some : false;
        if (!hasDependentResources) return tuples.map(([, action])=>dispatch(action));
        // some resources might not be listed on the route resources so must be dispatched separate from executing state
        const listedTuples = tuples.filter(([resource])=>routeResources == null ? void 0 : routeResources.some(matchType(resource)));
        if (listedTuples.length === 0) return tuples.map(([, action])=>dispatch(action));
        // accumulate the dependency types for all executing resources
        // find downstream resources that may also execute and include their dependencies too
        // include the resource type as well in the list
        // we don't validate that these are legal dependencies
        const [dependentTypes] = routeResources.reduce((acc, { type, depends })=>{
            const [dependencies, executableTypes] = acc;
            const isExecutable = executableTypes.includes(type) || !!(depends != null && depends.some((dependency)=>executableTypes.includes(dependency)));
            return isExecutable ? [
                depends ? [
                    ...dependencies,
                    ...depends,
                    type
                ] : dependencies,
                [
                    ...executableTypes,
                    type
                ]
            ] : acc;
        }, [
            [],
            listedTuples.map(([{ type }])=>type)
        ]).filter((v, i, a)=>a.indexOf(v) === i);
        // resources that are completely independent are preferable to be dispatched separate from executing state
        const dependentTuples = listedTuples.filter(([{ type }])=>dependentTypes.includes(type));
        if (dependentTuples.length === 0) return tuples.map(([, action])=>dispatch(action));
        // additionally find all direct dependencies of these executing or possibly executing resources
        // we don't validate that these are legal dependencies
        const dependentAndDependencyTypes = routeResources.filter(({ type })=>dependentTypes.includes(type)).reduce((acc, { type, depends })=>depends ? [
                ...acc,
                ...depends,
                type
            ] : [
                ...acc,
                type
            ], []).filter((v, i, a)=>a.indexOf(v) === i);
        // setup executing tuples in route resource order
        // this state allows actions to call executeForDependents() to influence actions that follow
        // the list includes dependency resources so that getDependencies() may validate without needing route resources
        // we use the resource definition of the given tuple where present or otherwise the definition from route resources
        const executingTuples = routeResources.filter(({ type })=>dependentAndDependencyTypes.includes(type)).map((resource)=>{
            var _tuples$find;
            return (_tuples$find = tuples.find(matchType(resource))) != null ? _tuples$find : [
                resource,
                null
            ];
        });
        setState({
            executing: executingTuples
        });
        // dispatch sequentially during which executeForDependents() can cause tuples to change
        const executedResults = executingTuples.map(([{ type: expectedType }], i)=>{
            var _getState$executing;
            const latestTuple = (_getState$executing = getState().executing) == null ? void 0 : _getState$executing[i];
            const [{ type: latestType }, maybeAction] = latestTuple != null ? latestTuple : [
                {}
            ];
            if (latestType !== expectedType) {
                setState({
                    executing: null
                });
                throw new Error('execution reached an inconsistent state');
            }
            return maybeAction ? dispatch(maybeAction) : undefined;
        });
        setState({
            executing: null
        });
        // pick existing execution result or dispatch any remaining independent actions
        return tuples.map(([resource, action])=>{
            const index = executingTuples.findIndex(matchType(resource));
            return index < 0 ? dispatch(action) : executedResults[index];
        });
    };
const actionWithDependencies = (routeResources, resource, action)=>({ dispatch })=>dispatch(executeTuples(routeResources, [
            [
                resource,
                action
            ]
        ]))[0];
const mapActionWithDependencies = (routeResources, resources, actionCreator)=>executeTuples(routeResources, resources.map((resource)=>[
            resource,
            actionCreator(resource)
        ]));
const executeForDependents = (resource, actionCreator)=>({ getState, setState })=>{
        var _tuples$findIndex;
        const { executing: tuples } = getState();
        // find the given resource in the currently executing tuples
        const indexForResource = (_tuples$findIndex = tuples == null ? void 0 : tuples.findIndex(matchType(resource))) != null ? _tuples$findIndex : -1;
        if (indexForResource < 0) return;
        // find dependent resources following given resource and revise their action
        const executing = tuples.map((tuple, i)=>{
            var _tupleResource$depend;
            const [tupleResource] = tuple;
            return i > indexForResource && (_tupleResource$depend = tupleResource.depends) != null && _tupleResource$depend.includes(resource.type) ? [
                tupleResource,
                actionCreator(tupleResource)
            ] : tuple;
        });
        setState({
            executing
        });
    };
const getDependencies = (resource, routerStoreContext, options)=>({ getState, dispatch })=>{
        var _tuples$findIndex2;
        const { type, depends } = resource;
        // optimise the case of no dependencies
        if (!(depends != null && depends.length)) return {};
        const { executing: tuples, context: resourceStoreContext } = getState();
        // dependent resource cannot be called outside execution state
        // find the given resource type in the currently executing tuples
        const indexForResource = (_tuples$findIndex2 = tuples == null ? void 0 : tuples.findIndex(matchType(resource))) != null ? _tuples$findIndex2 : -1;
        if (indexForResource < 0) throw new ResourceDependencyError(`Missing resource: "${type}" has dependencies so must not be missing`);
        // find tuples index for all the dependency elements
        const dependencyIndexTuples = depends.map((dependency)=>[
                dependency,
                tuples.findIndex(matchType({
                    type: dependency
                }))
            ]);
        // we rely on executing tuples including all dependencies of the caller resource
        dependencyIndexTuples.forEach(([dependency, index])=>{
            if (index < 0) throw new ResourceDependencyError(`Missing resource: "${type}" depends "${dependency}" which is missing`);
            if (index > indexForResource) throw new ResourceDependencyError(`Illegal dependency: "${type}" depends "${dependency}" so "${dependency}" must precede "${type}"`);
        });
        return fromEntries(dependencyIndexTuples.map(([dependencyType, index])=>{
            const { getKey } = tuples[index][0];
            const key = getKey(routerStoreContext, resourceStoreContext);
            let slice = dispatch((0, _manageResourceState.getResourceState)(dependencyType, key)) || (0, _getDefaultStateSlice.getDefaultStateSlice)();
            // when prefetching we provide only the promise to dependands
            const prefetchSlice = options.prefetch ? dispatch((0, _manageResourceState.getPrefetchSlice)(dependencyType, key)) : undefined;
            if (prefetchSlice) slice = (0, _extendsDefault.default)({}, slice, {
                // not spreading prefetchSlice to persist previous slice data
                promise: prefetchSlice.promise,
                expiresAt: prefetchSlice.expiresAt,
                loading: true
            });
            return [
                dependencyType,
                slice
            ];
        }));
    };

},{"@babel/runtime/helpers/extends":"3LZYG","../get-default-state-slice":"cJmeZ","../manage-resource-state":"37ND1","@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"cJmeZ":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "getDefaultStateSlice", ()=>getDefaultStateSlice);
var _extends = require("@babel/runtime/helpers/extends");
var _extendsDefault = parcelHelpers.interopDefault(_extends);
var _accessedAt = require("../accessed-at");
var _constants = require("../create-resource/constants");
var _expiresAt = require("../expires-at");
var _constants1 = require("./constants");
const getDefaultStateSlice = ()=>(0, _extendsDefault.default)({}, (0, _constants1.BASE_DEFAULT_STATE_SLICE), {
        expiresAt: (0, _expiresAt.getExpiresAt)((0, _constants.DEFAULT_RESOURCE_MAX_AGE)),
        accessedAt: (0, _accessedAt.getAccessedAt)()
    });

},{"@babel/runtime/helpers/extends":"3LZYG","../accessed-at":"4X8uX","../create-resource/constants":"dTOQe","../expires-at":"6ptGD","./constants":"fjjWF","@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"fjjWF":[function(require,module,exports,__globalThis) {
/**
 * The base defaults which should be fed into any factory that needs to derive other props.
 */ var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "BASE_DEFAULT_STATE_SLICE", ()=>BASE_DEFAULT_STATE_SLICE);
const BASE_DEFAULT_STATE_SLICE = {
    data: null,
    error: null,
    loading: false,
    promise: null
};

},{"@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"37ND1":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "getPrefetchSlice", ()=>getPrefetchSlice);
parcelHelpers.export(exports, "setPrefetchSlice", ()=>setPrefetchSlice);
parcelHelpers.export(exports, "setResourceState", ()=>setResourceState);
parcelHelpers.export(exports, "getResourceState", ()=>getResourceState);
parcelHelpers.export(exports, "deleteResourceState", ()=>deleteResourceState);
var _objectWithoutPropertiesLoose = require("@babel/runtime/helpers/objectWithoutPropertiesLoose");
var _objectWithoutPropertiesLooseDefault = parcelHelpers.interopDefault(_objectWithoutPropertiesLoose);
var _extends = require("@babel/runtime/helpers/extends");
var _extendsDefault = parcelHelpers.interopDefault(_extends);
function _toPropertyKey(t) {
    var i = _toPrimitive(t, "string");
    return "symbol" == typeof i ? i : String(i);
}
function _toPrimitive(t, r) {
    if ("object" != typeof t || !t) return t;
    var e = t[Symbol.toPrimitive];
    if (void 0 !== e) {
        var i = e.call(t, r || "default");
        if ("object" != typeof i) return i;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return ("string" === r ? String : Number)(t);
}
const getPrefetchSlice = (type, key)=>({ getState })=>{
        var _prefetching$type;
        const { prefetching } = getState();
        const slice = prefetching == null || (_prefetching$type = prefetching[type]) == null ? void 0 : _prefetching$type[key];
        // check if slice is still fresh
        if (slice && Date.now() < Number(slice.expiresAt)) return slice;
        return undefined;
    };
const setPrefetchSlice = (type, key, slice)=>({ setState, getState })=>{
        var _prefetching$type2, _slice$promise;
        const { prefetching } = getState();
        // avoid doing extra set if same value
        if ((prefetching == null || (_prefetching$type2 = prefetching[type]) == null ? void 0 : _prefetching$type2[key]) === slice) return;
        // cheap optimisation to provide prefetched result syncronously
        slice == null || (_slice$promise = slice.promise) == null || _slice$promise.then((maybeData)=>slice.data = maybeData);
        setState({
            prefetching: (0, _extendsDefault.default)({}, prefetching, {
                [type]: (0, _extendsDefault.default)({}, prefetching == null ? void 0 : prefetching[type], {
                    [key]: slice
                })
            })
        });
    };
const setResourceState = (type, key, state)=>({ setState, getState, dispatch })=>{
        const { data } = getState();
        // every time we override a resource we kill its prefetched
        dispatch(setPrefetchSlice(type, key, undefined));
        setState({
            data: (0, _extendsDefault.default)({}, data, {
                [type]: (0, _extendsDefault.default)({}, data[type] || {}, {
                    [key]: state
                })
            })
        });
    };
const getResourceState = (type, key)=>({ getState })=>{
        const { data: { [type]: resourceDataForType } } = getState();
        return resourceDataForType == null ? void 0 : resourceDataForType[key];
    };
const deleteResourceState = (type, key)=>({ getState, setState })=>{
        const { data } = getState();
        const { [type]: resourceForType } = data, remainingData = (0, _objectWithoutPropertiesLooseDefault.default)(data, [
            type
        ].map(_toPropertyKey));
        if (key === undefined) setState({
            data: remainingData
        });
        else if (resourceForType) {
            const remainingForType = (0, _objectWithoutPropertiesLooseDefault.default)(resourceForType, [
                key
            ].map(_toPropertyKey));
            setState({
                data: (0, _extendsDefault.default)({}, remainingData, {
                    [type]: remainingForType
                })
            });
        }
    };

},{"@babel/runtime/helpers/objectWithoutPropertiesLoose":"5JG3D","@babel/runtime/helpers/extends":"3LZYG","@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"8Xthv":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "getResourceIdentifier", ()=>getResourceIdentifier);
parcelHelpers.export(exports, "getResourceIdentifiers", ()=>getResourceIdentifiers);
const getResourceIdentifier = (resource, routerStoreContext, resourceStoreContext)=>{
    const { type, getKey } = resource;
    const key = getKey(routerStoreContext, resourceStoreContext);
    return `${type}/${key}`;
};
const getResourceIdentifiers = (resources, routerStoreContext, resourceStoreContext)=>resources.map((resource)=>getResourceIdentifier(resource, routerStoreContext, resourceStoreContext));

},{"@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"3bB0c":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "getResourcesForNextLocation", ()=>getResourcesForNextLocation);
var _getResourceIdentifier = require("../get-resource-identifier");
var _routeChecks = require("../route-checks");
const getResourcesForNextLocation = (prevRouterStoreContext, nextRouterStoreContext, resourceStoreContext)=>{
    const { route: prevRoute } = prevRouterStoreContext;
    const { resources: prevResources = [] } = prevRoute || {};
    const { route: nextRoute } = nextRouterStoreContext;
    const { resources: nextResources = [] } = nextRoute || {};
    if (!(0, _routeChecks.routeHasResources)(nextRoute)) return [];
    if ((0, _routeChecks.routeHasChanged)(prevRoute, nextRoute)) return nextResources;
    const prevResourceIdentifiers = (0, _getResourceIdentifier.getResourceIdentifiers)(prevResources, prevRouterStoreContext, resourceStoreContext);
    return nextResources.filter((resource)=>!prevResourceIdentifiers.includes((0, _getResourceIdentifier.getResourceIdentifier)(resource, nextRouterStoreContext, resourceStoreContext)));
};

},{"../get-resource-identifier":"8Xthv","../route-checks":"gUmkK","@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"gUmkK":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "routeHasResources", ()=>routeHasResources);
parcelHelpers.export(exports, "routeHasChanged", ()=>routeHasChanged);
const routeHasResources = (route)=>!!(route && route.resources && route.resources.length > 0);
const routeHasChanged = (prev, next)=>prev.name !== next.name || prev.path !== next.path;

},{"@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"9ibAU":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "getExpiredResourceDataKeys", ()=>getExpiredResourceDataKeys);
parcelHelpers.export(exports, "getLRUResourceKey", ()=>getLRUResourceKey);
parcelHelpers.export(exports, "validateLRUCache", ()=>validateLRUCache);
var _manageResourceState = require("../manage-resource-state");
const getExpiredResourceDataKeys = (routeResourceDataForType, currentKey)=>Object.keys(routeResourceDataForType).filter((resourceDataKey)=>{
        const { [resourceDataKey]: { expiresAt } } = routeResourceDataForType;
        return resourceDataKey !== currentKey && expiresAt && expiresAt <= Date.now();
    });
const getLRUResourceKey = (maxCache, resourceDataForType, currentKey)=>{
    if (maxCache === Infinity || maxCache < 1) return null;
    const resourceDataKeys = Object.keys(resourceDataForType);
    if (resourceDataKeys.length < maxCache) return null;
    const expiredResourceDataKeys = getExpiredResourceDataKeys(resourceDataForType, currentKey);
    if (expiredResourceDataKeys.length > 0) return expiredResourceDataKeys[0];
    return resourceDataKeys.reduce((leastRecentKey, key)=>{
        const { [key]: { accessedAt }, [leastRecentKey]: { accessedAt: leastRecentAccessedAt } } = resourceDataForType;
        if (accessedAt && leastRecentAccessedAt && accessedAt < leastRecentAccessedAt) return key;
        return leastRecentKey;
    }, resourceDataKeys[0]);
};
const validateLRUCache = (resource, key)=>({ getState, dispatch })=>{
        const { type, maxCache } = resource;
        const { data: { [type]: resourceDataForType } } = getState();
        if (!resourceDataForType) return;
        const keyTobeDeleted = getLRUResourceKey(maxCache, resourceDataForType, key);
        if (!keyTobeDeleted) return;
        dispatch((0, _manageResourceState.deleteResourceState)(type, keyTobeDeleted));
    };

},{"../manage-resource-state":"37ND1","@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"hrNo1":[function(require,module,exports,__globalThis) {
// NOTE! This has been copy pasted from https://github.com/sindresorhus/serialize-error/blob/master/index.js
// When the router moves to its own package, this must become a dependency
// For now, we have put it here so that we don't need to get it included in Jira's vendor bundle
var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "serializeError", ()=>serializeError);
parcelHelpers.export(exports, "deserializeError", ()=>deserializeError);
class NonError extends Error {
    constructor(message){
        super(message);
        this.name = 'NonError';
        if (Error.captureStackTrace) Error.captureStackTrace(this, NonError);
    }
}
const commonProperties = [
    'name',
    'message',
    'stack',
    'code'
];
const destroyCircular = (from, seen, to_)=>{
    const to = to_ || (Array.isArray(from) ? [] : {});
    seen.push(from);
    for (const [key, value] of Object.entries(from)){
        if (typeof value === 'function') continue;
        if (!value || typeof value !== 'object') {
            to[key] = value;
            continue;
        }
        if (!seen.includes(from[key])) {
            to[key] = destroyCircular(from[key], seen.slice());
            continue;
        }
        to[key] = '[Circular]';
    }
    for (const property of commonProperties)if (typeof from[property] === 'string') to[property] = from[property];
    return to;
};
const serializeError = (value)=>{
    if (typeof value === 'object' && value !== null) return destroyCircular(value, []);
    // People sometimes throw things besides Error objects…
    if (typeof value === 'function') // `JSON.stringify()` discards functions. We do too, unless a function is thrown directly.
    return `[Function: ${value.name || 'anonymous'}]`;
    return value;
};
const deserializeError = (value)=>{
    if (value instanceof Error) return value;
    if (typeof value === 'object' && value !== null && !Array.isArray(value)) {
        const newError = new Error();
        destroyCircular(value, [], newError);
        return newError;
    }
    return new NonError(value);
};

},{"@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"eoQYy":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "isFromSsr", ()=>isFromSsr);
parcelHelpers.export(exports, "shouldUseCache", ()=>shouldUseCache);
const isFromSsr = ({ expiresAt })=>expiresAt === null;
const isFresh = (resource)=>{
    if (isFromSsr(resource)) return true;
    return Date.now() < Number(resource.expiresAt);
};
const shouldUseCache = (resource)=>{
    var _resource$error;
    if ((resource == null || (_resource$error = resource.error) == null ? void 0 : _resource$error.name) === 'TimeoutError') return false;
    if (resource.loading) return true;
    if (isFresh(resource)) return true;
    return false;
};

},{"@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"2p7n8":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "setSsrDataPromise", ()=>setSsrDataPromise);
var _extends = require("@babel/runtime/helpers/extends");
var _extendsDefault = parcelHelpers.interopDefault(_extends);
const setSsrDataPromise = (slice)=>slice.promise === null ? (0, _extendsDefault.default)({}, slice, {
        promise: Promise.resolve(slice.data)
    }) : slice;

},{"@babel/runtime/helpers/extends":"3LZYG","@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"9ZoQK":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "transformData", ()=>transformData);
const transformData = (data, transformer)=>Object.keys(data).reduce((acc, type)=>{
        if (!acc[type]) acc[type] = {};
        Object.keys(data[type]).forEach((key)=>{
            const slice = data[type][key];
            acc[type][key] = transformer(slice);
        });
        return acc;
    }, {});

},{"@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"hJnua":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "ResourceSubscriber", ()=>ResourceSubscriber);
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _useResource = require("../use-resource");
const ResourceSubscriber = ({ children, resource, options })=>{
    const result = (0, _useResource.useResource)(resource, options);
    return /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _reactDefault.default).Fragment, null, children(result));
};

},{"react":"ltHCL","../use-resource":"cxy6U","@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"cxy6U":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "useResource", ()=>useResource);
var _extends = require("@babel/runtime/helpers/extends");
var _extendsDefault = parcelHelpers.interopDefault(_extends);
var _react = require("react");
var _reactSweetState = require("react-sweet-state");
var _routerStore = require("../../../controllers/router-store");
var _resourceStore = require("../resource-store");
const useResource = (resource, options)=>{
    const actions = (0, _resourceStore.useResourceStoreActions)();
    const { getContext: getRouterContext } = (0, _routerStore.useRouterStoreActions)();
    // Dynamically generate a router subscriber based on the resource:
    // makes the component re-render only when key changes instead of
    // after every route change
    const useKey = (0, _react.useMemo)(()=>(0, _reactSweetState.createHook)((0, _routerStore.RouterStore), {
            selector: ({ match, query, route }, keyArg)=>resource.getKey(keyArg != null ? keyArg : {
                    match,
                    query,
                    route
                }, actions.getContext())
        }), [
        resource,
        actions
    ]);
    // eslint-disable-next-line @typescript-eslint/no-non-null-asserted-optional-chain
    const key = useKey(options == null ? void 0 : options.routerContext)[0];
    const [slice] = (0, _resourceStore.useResourceStore)({
        type: resource.type,
        key
    });
    // we keep route context bound to key, so route context won't refresh
    // unless key changes. This allows refresh to be called on effect cleanup
    // or asynchronously, when route context might already have changed
    const routerContext = (0, _react.useMemo)(// eslint-disable-next-line @typescript-eslint/no-non-null-asserted-optional-chain
    ()=>(options == null ? void 0 : options.routerContext) || getRouterContext(), // eslint-disable-next-line react-hooks/exhaustive-deps
    [
        key
    ]);
    const update = (0, _react.useCallback)((updater)=>{
        actions.updateResourceState(resource, routerContext, updater);
    }, [
        resource,
        routerContext,
        actions
    ]);
    const clear = (0, _react.useCallback)(()=>{
        actions.clearResource(resource, routerContext);
    }, [
        resource,
        routerContext,
        actions
    ]);
    const clearAll = (0, _react.useCallback)(()=>{
        actions.clearResource(resource);
    }, [
        resource,
        actions
    ]);
    const refresh = (0, _react.useCallback)(()=>{
        actions.getResourceFromRemote(resource, routerContext, {
            prefetch: false
        });
    }, [
        resource,
        routerContext,
        actions
    ]);
    return (0, _extendsDefault.default)({}, slice, {
        update,
        key,
        refresh,
        clear,
        clearAll
    });
};

},{"@babel/runtime/helpers/extends":"3LZYG","react":"ltHCL","react-sweet-state":"b2YYl","../../../controllers/router-store":"bWF6v","../resource-store":"fd8OL","@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"97DYC":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "addResourcesListener", ()=>addResourcesListener);
var _resourceStore = require("../resource-store");
const addResourcesListener = (fn)=>(0, _resourceStore.getResourceStore)().storeState.subscribe(fn);

},{"../resource-store":"fd8OL","@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"3p51E":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "mockRouteResourceResponse", ()=>mockRouteResourceResponse);
const mockRouteResourceResponse = {
    loading: false,
    error: null,
    data: {
        foo: 'bar'
    },
    promise: null,
    expiresAt: Date.now(),
    accessedAt: Date.now(),
    key: ''
};

},{"@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"fqTIO":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "getStudioPath", ()=>getStudioPath);
var _reactMagneticDi = require("react-magnetic-di");
var _getStudioVersion = require("../get-studio-version");
var _workspace = require("../workspace");
const getStudioPath = (path)=>{
    (0, _reactMagneticDi.di)((0, _getStudioVersion.isStudioV2));
    if (!path.startsWith(`${(0, _workspace.WORKSPACE_PREFIX)}${(0, _workspace.SPACE_PREFIX)}`) && (0, _getStudioVersion.isStudioV2)()) return (0, _workspace.getWorkspacePath)(path, {
        appendSpacePrefix: true
    });
    return path;
};

},{"react-magnetic-di":"hCzc8","../get-studio-version":"fpbIA","../workspace":"1xq6C","@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"fpbIA":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "setIsStudioV2", ()=>setIsStudioV2);
parcelHelpers.export(exports, "setCachedWorkspaceId", ()=>setCachedWorkspaceId);
parcelHelpers.export(exports, "getCachedWorkspaceId", ()=>getCachedWorkspaceId);
parcelHelpers.export(exports, "isStudioV2", ()=>isStudioV2);
var _platformFeatureFlags = require("@atlaskit/platform-feature-flags");
let isV2;
let cachedWorkspaceId;
const setIsStudioV2 = (value)=>{
    isV2 = value;
};
const setCachedWorkspaceId = (workspaceId)=>{
    cachedWorkspaceId = workspaceId;
};
const getCachedWorkspaceId = ()=>cachedWorkspaceId;
const isStudioV2 = ()=>{
    // This can be set by the dev tools modal to force v1
    if ((0, _platformFeatureFlags.fg)('toggle-studio-v1')) return false;
    if (isV2 !== undefined) return isV2;
    return false;
};

},{"@atlaskit/platform-feature-flags":"8rD2i","@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"1xq6C":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "WORKSPACE_PREFIX", ()=>WORKSPACE_PREFIX);
parcelHelpers.export(exports, "SPACE_PREFIX", ()=>SPACE_PREFIX);
parcelHelpers.export(exports, "SITE_PREFIX", ()=>SITE_PREFIX);
parcelHelpers.export(exports, "generateWorkspacePath", ()=>generateWorkspacePath);
parcelHelpers.export(exports, "getWorkspacePath", ()=>getWorkspacePath);
var _objectSpread = require("@swc/helpers/_/_object_spread");
var _objectSpreadProps = require("@swc/helpers/_/_object_spread_props");
var _reactResourceRouterNext = require("react-resource-router-next");
const WORKSPACE_PREFIX = '/w/:workspaceId';
const SPACE_PREFIX = '/spaces/:spaceId';
const SITE_PREFIX = '/s/:cloudId';
const generateWorkspacePath = (subPath, workspaceId, params = {})=>{
    return (0, _reactResourceRouterNext.generatePath)(getWorkspacePath(subPath), (0, _objectSpreadProps._)((0, _objectSpread._)({}, params), {
        workspaceId
    }));
};
const getWorkspacePath = (subPath = '', opts = {})=>`${WORKSPACE_PREFIX}${!!opts.appendSpacePrefix ? SPACE_PREFIX : ''}${subPath}`;

},{"@swc/helpers/_/_object_spread":"9gdrV","@swc/helpers/_/_object_spread_props":"kANqQ","react-resource-router-next":"6gkfP","@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"4Bxlf":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "LayoutFieldType", ()=>LayoutFieldType);
parcelHelpers.export(exports, "usePageLayoutEntryPoint", ()=>usePageLayoutEntryPoint);
var _reactResourceRouterNext = require("react-resource-router-next");
var _entryPointPlugin = require("../../utils/entry-point-plugin");
var LayoutFieldType = /*#__PURE__*/ function(LayoutFieldType) {
    LayoutFieldType["layout"] = "layout";
    LayoutFieldType["pageContent"] = "pageContent";
    LayoutFieldType["sideNavigation"] = "sideNavigation";
    return LayoutFieldType;
}({});
const usePageLayoutEntryPoint = (layoutField)=>{
    const [routerState] = (0, _reactResourceRouterNext.useRouter)();
    const entryPointReference = (0, _entryPointPlugin.getRouteEntryPointReference)(routerState.route);
    if (layoutField === "pageContent") return entryPointReference;
    return entryPointReference ? entryPointReference.entryPoints[layoutField] : null;
};

},{"react-resource-router-next":"6gkfP","../../utils/entry-point-plugin":"2ov8Q","@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"2ov8Q":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "getRouteEntryPointReference", ()=>getRouteEntryPointReference);
parcelHelpers.export(exports, "createEntryPointPlugin", ()=>createEntryPointPlugin);
var _objectSpread = require("@swc/helpers/_/_object_spread");
var _reactRelay = require("react-relay");
var _utils = require("./utils");
const entryPointReferences = {};
const getRouteEntryPointReference = (route)=>entryPointReferences[route.name] || null;
const handleRouteLoad = ({ environment, entryPointParams }, context)=>{
    var _context_route_entryPoint, _context_route;
    const entryPoint = (_context_route_entryPoint = (_context_route = context.route).entryPoint) === null || _context_route_entryPoint === void 0 ? void 0 : _context_route_entryPoint.call(_context_route);
    const entryPointParamsWithContext = (0, _objectSpread._)({
        context
    }, entryPointParams);
    if (entryPoint) {
        if ((0, _utils.prevPrefetchingRoute).isSameRouteMatch(context)) return;
        entryPointReferences[context.route.name] = (0, _reactRelay.loadEntryPoint)({
            getEnvironment: ()=>environment
        }, entryPoint, entryPointParamsWithContext);
    }
    // Store the current route context as the previous prefetching route
    (0, _utils.prevPrefetchingRoute).setPrevRouteContext(context);
};
const createEntryPointPlugin = (pluginOptions)=>({
        id: 'entry-points-plugin',
        routeLoad: ({ context })=>handleRouteLoad(pluginOptions, context),
        routePrefetch: ({ nextContext })=>handleRouteLoad(pluginOptions, nextContext)
    });

},{"@swc/helpers/_/_object_spread":"9gdrV","react-relay":"9HAyN","./utils":"49JAT","@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"9HAyN":[function(require,module,exports,__globalThis) {
/**
 * Relay v20.1.1
 *
 * Copyright (c) Meta Platforms, Inc. and affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ module.exports = require("5158af750bd9b316");

},{"5158af750bd9b316":"7G3Xt"}],"7G3Xt":[function(require,module,exports,__globalThis) {
'use strict';
var ReactRelayContext = require("8b308b7c63a6ba30");
var ReactRelayFragmentContainer = require("1da2692b8f4bbe65");
var ReactRelayLocalQueryRenderer = require("b6890125c83438ac");
var ReactRelayPaginationContainer = require("25811d5f63763c93");
var ReactRelayQueryRenderer = require("33e1a30c56cc4f78");
var ReactRelayRefetchContainer = require("be2e8cf4a4114081");
var EntryPointContainer = require("de6ffb3fab52af55");
var loadEntryPoint = require("9845f85fcf4112a9");
var _require = require("80316ccbfd7d3b4"), loadQuery = _require.loadQuery;
var ProfilerContext = require("b4855ef250ebe53");
var RelayEnvironmentProvider = require("48d81c687bd4bbcf");
var useClientQuery = require("c869a23f6f46496");
var useEntryPointLoader = require("7069c72978017b36");
var useFragment = require("2a9ad66c86d65a59");
var useLazyLoadQuery = require("5498c88692bba4fb");
var useMutation = require("86cd9abb4c0a7753");
var usePaginationFragment = require("fd7afa0d04aa1b3e");
var usePrefetchableForwardPaginationFragment = require("2760dbf71d6fcd76");
var usePreloadedQuery = require("cf041356c3d44a67");
var useQueryLoader = require("1f26946fcc34eb8c");
var useRefetchableFragment = require("d4db1f8e4edd018e");
var useRelayEnvironment = require("b0d0118c2aad16fa");
var useSubscribeToInvalidationState = require("17b32c753d09af4");
var useSubscription = require("8f54404b9202981a");
var RelayRuntime = require("f7a34d92a049ca9b");
module.exports = {
    ConnectionHandler: RelayRuntime.ConnectionHandler,
    QueryRenderer: ReactRelayQueryRenderer,
    LocalQueryRenderer: ReactRelayLocalQueryRenderer,
    MutationTypes: RelayRuntime.MutationTypes,
    RangeOperations: RelayRuntime.RangeOperations,
    ReactRelayContext: ReactRelayContext,
    applyOptimisticMutation: RelayRuntime.applyOptimisticMutation,
    commitLocalUpdate: RelayRuntime.commitLocalUpdate,
    commitMutation: RelayRuntime.commitMutation,
    createFragmentContainer: ReactRelayFragmentContainer.createContainer,
    createPaginationContainer: ReactRelayPaginationContainer.createContainer,
    createRefetchContainer: ReactRelayRefetchContainer.createContainer,
    fetchQuery_DEPRECATED: RelayRuntime.fetchQuery_DEPRECATED,
    graphql: RelayRuntime.graphql,
    readInlineData: RelayRuntime.readInlineData,
    requestSubscription: RelayRuntime.requestSubscription,
    EntryPointContainer: EntryPointContainer,
    RelayEnvironmentProvider: RelayEnvironmentProvider,
    ProfilerContext: ProfilerContext,
    fetchQuery: RelayRuntime.fetchQuery,
    loadQuery: loadQuery,
    loadEntryPoint: loadEntryPoint,
    useClientQuery: useClientQuery,
    useFragment: useFragment,
    useLazyLoadQuery: useLazyLoadQuery,
    useEntryPointLoader: useEntryPointLoader,
    useQueryLoader: useQueryLoader,
    useMutation: useMutation,
    usePaginationFragment: usePaginationFragment,
    usePreloadedQuery: usePreloadedQuery,
    useRefetchableFragment: useRefetchableFragment,
    usePrefetchableForwardPaginationFragment: usePrefetchableForwardPaginationFragment,
    useRelayEnvironment: useRelayEnvironment,
    useSubscribeToInvalidationState: useSubscribeToInvalidationState,
    useSubscription: useSubscription
};

},{"8b308b7c63a6ba30":"7NW2h","1da2692b8f4bbe65":"ds2RZ","b6890125c83438ac":"33cI7","25811d5f63763c93":"eYnmn","33e1a30c56cc4f78":"l9rE8","be2e8cf4a4114081":"1nKeO","de6ffb3fab52af55":"d2ChJ","9845f85fcf4112a9":"iKwbK","80316ccbfd7d3b4":"4CbeJ","b4855ef250ebe53":"1lEHI","48d81c687bd4bbcf":"aIt8X","c869a23f6f46496":"c5QiX","7069c72978017b36":"lV0xn","2a9ad66c86d65a59":"1zoWc","5498c88692bba4fb":"jPRDt","86cd9abb4c0a7753":"gIJ5I","fd7afa0d04aa1b3e":"cs6Pn","2760dbf71d6fcd76":"lnoQc","cf041356c3d44a67":"kylpw","1f26946fcc34eb8c":"aiqzn","d4db1f8e4edd018e":"d2wqG","b0d0118c2aad16fa":"bs9Iy","17b32c753d09af4":"dtX5o","8f54404b9202981a":"6fzbF","f7a34d92a049ca9b":"2IxFR"}],"7NW2h":[function(require,module,exports,__globalThis) {
'use strict';
var React = require("b48f9da34f26f544");
var _require = require("a4bce2dbe7496983"), createRelayContext = _require.__internal.createRelayContext;
module.exports = createRelayContext(React);

},{"b48f9da34f26f544":"ltHCL","a4bce2dbe7496983":"2IxFR"}],"2IxFR":[function(require,module,exports,__globalThis) {
/**
 * Relay v20.1.1
 *
 * Copyright (c) Meta Platforms, Inc. and affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ module.exports = require("660d7607c251850d");

},{"660d7607c251850d":"2rcWz"}],"2rcWz":[function(require,module,exports,__globalThis) {
'use strict';
var _require = require("ab3c3645550040ae"), isErrorResult = _require.isErrorResult, isValueResult = _require.isValueResult;
var ConnectionHandler = require("8188ae2e22062c04");
var ConnectionInterface = require("9878f12e4d57f49f");
var MutationHandlers = require("9ab0fc1b93a027fe");
var RelayDefaultHandlerProvider = require("a0ca36000bc16662");
var applyOptimisticMutation = require("1a19e12b86ca7844");
var commitLocalUpdate = require("249b083be6ee863f");
var commitMutation = require("b99aa80d9a0f8cb9");
var RelayDeclarativeMutationConfig = require("3039a513d5fd5c6");
var RelayNetwork = require("110ec4dc4df70756");
var RelayObservable = require("2a50dda6bedbe7de");
var RelayQueryResponseCache = require("b7d8d322db70f6c");
var fetchQuery = require("f836796860310832");
var fetchQuery_DEPRECATED = require("1164e0aeaab3f350");
var fetchQueryInternal = require("735ae29e1c255fcf");
var GraphQLTag = require("4914aafb5f3fdc68");
var PreloadableQueryRegistry = require("6600e0465f3a778e");
var _require2 = require("34fb914551b4365e"), generateClientID = _require2.generateClientID, generateUniqueClientID = _require2.generateUniqueClientID, isClientID = _require2.isClientID;
var createFragmentSpecResolver = require("438470f4c2d195c5");
var createRelayContext = require("8860e6a31fdca9c4");
var createRelayLoggingContext = require("1b3cdc4d22d0d0c1");
var isRelayModernEnvironment = require("6a763e3c852564b8");
var _require3 = require("5e3c548d74aeed57"), isSuspenseSentinel = _require3.isSuspenseSentinel, suspenseSentinel = _require3.suspenseSentinel;
var normalizeResponse = require("65fc2de8cd60932e");
var readInlineData = require("567eda9de309f218");
var RelayConcreteVariables = require("dfffbd41fc70cd39");
var RelayModernEnvironment = require("e2b118780d500de1");
var RelayModernOperationDescriptor = require("6b8a7600cdf84a63");
var RelayModernRecord = require("355a821958e8c4e8");
var RelayModernSelector = require("6a9e7721dfd9f016");
var RelayModernStore = require("3e7f0bba202ee3c7");
var RelayOperationTracker = require("a644e396eae6af3b");
var RelayRecordSource = require("1fd48de7cb8e9c88");
var RelayStoreUtils = require("b906b813921f2c6d");
var ResolverFragments = require("ab3e6d75921916ac");
var ViewerPattern = require("b5d41abd377e2ca0");
var requestSubscription = require("93b238f47c124377");
var createPayloadFor3DField = require("2608344a99e76af0");
var deepFreeze = require("1893916e3ddf485c");
var getFragmentIdentifier = require("405665a0329d4c8d");
var getPaginationMetadata = require("80ac10e2a73c55ca");
var getPaginationVariables = require("b635b62bc4b2ab16");
var getPendingOperationsForFragment = require("905d206ed7fa2839");
var getRefetchMetadata = require("7de8e63f749f7420");
var getRelayHandleKey = require("21962ba74ccc19f2");
var getRequestIdentifier = require("478040846eca158a");
var getValueAtPath = require("9f140c3040d5a746");
var _require4 = require("219749c0671405be"), handlePotentialSnapshotErrors = _require4.handlePotentialSnapshotErrors;
var isPromise = require("fe54edbcfbee4a28");
var isScalarAndEqual = require("e6b100b95199cf27");
var recycleNodesInto = require("82fee06f336d4fe5");
var RelayConcreteNode = require("50ed2f684de7b1fc");
var RelayDefaultHandleKey = require("16365d33d7b18392");
var RelayError = require("8ec4ed35d2d0a290");
var RelayFeatureFlags = require("1a57c1a19b29c571");
var RelayProfiler = require("de6ed554b2abd02b");
var RelayReplaySubject = require("d12459c61eaba2e5");
var _require5 = require("342ba6a8b0e785c6"), hasCycle = _require5.hasCycle, stableCopy = _require5.stableCopy;
var withProvidedVariables = require("da70b8312ac5832");
var mapStr, setStr, promiseStr, objStr;
module.exports = {
    Environment: RelayModernEnvironment,
    Network: RelayNetwork,
    Observable: RelayObservable,
    QueryResponseCache: RelayQueryResponseCache,
    RecordSource: RelayRecordSource,
    Record: RelayModernRecord,
    ReplaySubject: RelayReplaySubject,
    Store: RelayModernStore,
    areEqualSelectors: RelayModernSelector.areEqualSelectors,
    createFragmentSpecResolver: createFragmentSpecResolver,
    createNormalizationSelector: RelayModernSelector.createNormalizationSelector,
    createOperationDescriptor: RelayModernOperationDescriptor.createOperationDescriptor,
    createReaderSelector: RelayModernSelector.createReaderSelector,
    createRequestDescriptor: RelayModernOperationDescriptor.createRequestDescriptor,
    getArgumentValues: RelayStoreUtils.getArgumentValues,
    getDataIDsFromFragment: RelayModernSelector.getDataIDsFromFragment,
    getDataIDsFromObject: RelayModernSelector.getDataIDsFromObject,
    getNode: GraphQLTag.getNode,
    getFragment: GraphQLTag.getFragment,
    getInlineDataFragment: GraphQLTag.getInlineDataFragment,
    getModuleComponentKey: RelayStoreUtils.getModuleComponentKey,
    getModuleOperationKey: RelayStoreUtils.getModuleOperationKey,
    getPaginationFragment: GraphQLTag.getPaginationFragment,
    getPluralSelector: RelayModernSelector.getPluralSelector,
    getRefetchableFragment: GraphQLTag.getRefetchableFragment,
    getRequest: GraphQLTag.getRequest,
    getRequestIdentifier: getRequestIdentifier,
    getSelector: RelayModernSelector.getSelector,
    getSelectorsFromObject: RelayModernSelector.getSelectorsFromObject,
    getSingularSelector: RelayModernSelector.getSingularSelector,
    getStorageKey: RelayStoreUtils.getStorageKey,
    getVariablesFromFragment: RelayModernSelector.getVariablesFromFragment,
    getVariablesFromObject: RelayModernSelector.getVariablesFromObject,
    getVariablesFromPluralFragment: RelayModernSelector.getVariablesFromPluralFragment,
    getVariablesFromSingularFragment: RelayModernSelector.getVariablesFromSingularFragment,
    handlePotentialSnapshotErrors: handlePotentialSnapshotErrors,
    graphql: GraphQLTag.graphql,
    isErrorResult: isErrorResult,
    isValueResult: isValueResult,
    isFragment: GraphQLTag.isFragment,
    isInlineDataFragment: GraphQLTag.isInlineDataFragment,
    isSuspenseSentinel: isSuspenseSentinel,
    suspenseSentinel: suspenseSentinel,
    isRequest: GraphQLTag.isRequest,
    readInlineData: readInlineData,
    readFragment: ResolverFragments.readFragment,
    MutationTypes: RelayDeclarativeMutationConfig.MutationTypes,
    RangeOperations: RelayDeclarativeMutationConfig.RangeOperations,
    DefaultHandlerProvider: RelayDefaultHandlerProvider,
    ConnectionHandler: ConnectionHandler,
    MutationHandlers: MutationHandlers,
    VIEWER_ID: ViewerPattern.VIEWER_ID,
    VIEWER_TYPE: ViewerPattern.VIEWER_TYPE,
    applyOptimisticMutation: applyOptimisticMutation,
    commitLocalUpdate: commitLocalUpdate,
    commitMutation: commitMutation,
    fetchQuery: fetchQuery,
    fetchQuery_DEPRECATED: fetchQuery_DEPRECATED,
    isRelayModernEnvironment: isRelayModernEnvironment,
    requestSubscription: requestSubscription,
    ConnectionInterface: ConnectionInterface,
    PreloadableQueryRegistry: PreloadableQueryRegistry,
    RelayProfiler: RelayProfiler,
    createPayloadFor3DField: createPayloadFor3DField,
    RelayConcreteNode: RelayConcreteNode,
    RelayError: RelayError,
    RelayFeatureFlags: RelayFeatureFlags,
    DEFAULT_HANDLE_KEY: RelayDefaultHandleKey.DEFAULT_HANDLE_KEY,
    FRAGMENTS_KEY: RelayStoreUtils.FRAGMENTS_KEY,
    FRAGMENT_OWNER_KEY: RelayStoreUtils.FRAGMENT_OWNER_KEY,
    ID_KEY: RelayStoreUtils.ID_KEY,
    REF_KEY: RelayStoreUtils.REF_KEY,
    REFS_KEY: RelayStoreUtils.REFS_KEY,
    ROOT_ID: RelayStoreUtils.ROOT_ID,
    ROOT_TYPE: RelayStoreUtils.ROOT_TYPE,
    TYPENAME_KEY: RelayStoreUtils.TYPENAME_KEY,
    deepFreeze: deepFreeze,
    generateClientID: generateClientID,
    generateUniqueClientID: generateUniqueClientID,
    getRelayHandleKey: getRelayHandleKey,
    isClientID: isClientID,
    isPromise: isPromise,
    isScalarAndEqual: isScalarAndEqual,
    recycleNodesInto: recycleNodesInto,
    stableCopy: stableCopy,
    hasCycle: hasCycle,
    getFragmentIdentifier: getFragmentIdentifier,
    getRefetchMetadata: getRefetchMetadata,
    getPaginationMetadata: getPaginationMetadata,
    getPaginationVariables: getPaginationVariables,
    getPendingOperationsForFragment: getPendingOperationsForFragment,
    getValueAtPath: getValueAtPath,
    __internal: {
        ResolverFragments: ResolverFragments,
        OperationTracker: RelayOperationTracker,
        createRelayContext: createRelayContext,
        createRelayLoggingContext: createRelayLoggingContext,
        getOperationVariables: RelayConcreteVariables.getOperationVariables,
        getLocalVariables: RelayConcreteVariables.getLocalVariables,
        fetchQuery: fetchQueryInternal.fetchQuery,
        fetchQueryDeduped: fetchQueryInternal.fetchQueryDeduped,
        getPromiseForActiveRequest: fetchQueryInternal.getPromiseForActiveRequest,
        getObservableForActiveRequest: fetchQueryInternal.getObservableForActiveRequest,
        normalizeResponse: normalizeResponse,
        withProvidedVariables: withProvidedVariables
    }
};

},{"ab3c3645550040ae":"kETaC","8188ae2e22062c04":"ccBOd","9878f12e4d57f49f":"dTLQR","9ab0fc1b93a027fe":"egZkc","a0ca36000bc16662":"kUOrY","1a19e12b86ca7844":"8KmZz","249b083be6ee863f":"5KZg6","b99aa80d9a0f8cb9":"1H0OQ","3039a513d5fd5c6":"1lmKe","110ec4dc4df70756":"gtE7n","2a50dda6bedbe7de":"hYmcP","b7d8d322db70f6c":"ejl8F","f836796860310832":"khAY2","1164e0aeaab3f350":"jMRnb","735ae29e1c255fcf":"75uB6","4914aafb5f3fdc68":"8UTII","6600e0465f3a778e":"kmRfk","34fb914551b4365e":"gL1rB","438470f4c2d195c5":"84PBa","8860e6a31fdca9c4":"fJ0BV","1b3cdc4d22d0d0c1":"li736","6a763e3c852564b8":"bBdVI","5e3c548d74aeed57":"9sE63","65fc2de8cd60932e":"afJiB","567eda9de309f218":"6Td1y","dfffbd41fc70cd39":"138Hd","e2b118780d500de1":"3xHmQ","6b8a7600cdf84a63":"dSeB3","355a821958e8c4e8":"daXOB","6a9e7721dfd9f016":"9k2Dg","3e7f0bba202ee3c7":"UtVKb","a644e396eae6af3b":"5bEuR","1fd48de7cb8e9c88":"6w3KR","b906b813921f2c6d":"3QcrW","ab3e6d75921916ac":"1JmVd","b5d41abd377e2ca0":"i6PYa","93b238f47c124377":"7OgOE","2608344a99e76af0":"7pZoN","1893916e3ddf485c":"eLea7","405665a0329d4c8d":"giGUC","80ac10e2a73c55ca":"idmUY","b635b62bc4b2ab16":"f4llA","905d206ed7fa2839":"ak3d6","7de8e63f749f7420":"5aHRx","21962ba74ccc19f2":"etrZd","478040846eca158a":"h3zzW","9f140c3040d5a746":"6JAxU","219749c0671405be":"kq97W","fe54edbcfbee4a28":"8csDP","e6b100b95199cf27":"fysSA","82fee06f336d4fe5":"ij1IQ","50ed2f684de7b1fc":"jKskk","16365d33d7b18392":"bYgdD","8ec4ed35d2d0a290":"fAMd2","1a57c1a19b29c571":"a0FL5","de6ed554b2abd02b":"j0ygY","d12459c61eaba2e5":"8ePJJ","342ba6a8b0e785c6":"c3NLR","da70b8312ac5832":"1N2Sg"}],"kETaC":[function(require,module,exports,__globalThis) {
'use strict';
var resolverDataInjector = require("972cfc25aca0f10f");
var _require = require("8a25303d111c1a81"), observeFragment = _require.observeFragment;
var _require2 = require("710702f109664c7"), observeQuery = _require2.observeQuery;
var _require3 = require("bd535c987572608e"), waitForFragmentData = _require3.waitForFragmentData;
function isValueResult(input) {
    return input.ok === true;
}
function isErrorResult(input) {
    return input.ok === false;
}
module.exports = {
    resolverDataInjector: resolverDataInjector,
    isValueResult: isValueResult,
    isErrorResult: isErrorResult,
    observeQuery: observeQuery,
    observeFragment: observeFragment,
    waitForFragmentData: waitForFragmentData
};

},{"972cfc25aca0f10f":"6k4t2","8a25303d111c1a81":"lRP4u","710702f109664c7":"631vm","bd535c987572608e":"iZeEE"}],"6k4t2":[function(require,module,exports,__globalThis) {
'use strict';
var _require = require("254c5ed9ab3cc7fe"), readFragment = _require.readFragment;
var invariant = require("6effdcc033e9bbee");
function resolverDataInjector(fragment, _resolverFn, fieldName, isRequiredField) {
    var resolverFn = _resolverFn;
    return function(fragmentKey, args, resolverContext) {
        var data = readFragment(fragment, fragmentKey);
        if (fieldName != null) {
            if (data == null) {
                if (isRequiredField === true) invariant(false);
                else return resolverFn(null, args, resolverContext);
            }
            if (fieldName in data) {
                if (isRequiredField === true) !(data[fieldName] != null) && invariant(false);
                return resolverFn(data[fieldName], args, resolverContext);
            } else invariant(false);
        } else return resolverFn(null, args, resolverContext);
    };
}
module.exports = resolverDataInjector;

},{"254c5ed9ab3cc7fe":"1JmVd","6effdcc033e9bbee":"e2sci"}],"1JmVd":[function(require,module,exports,__globalThis) {
'use strict';
var _require = require("600f6b79f68bca6f"), getFragment = _require.getFragment;
var _require2 = require("9820817ec81cea36"), eventShouldThrow = _require2.eventShouldThrow;
var _require3 = require("ed6a063285578c76"), getSelector = _require3.getSelector;
var invariant = require("5065659723cd98f9");
var contextStack = [];
function withResolverContext(context, cb) {
    contextStack.push(context);
    try {
        return cb();
    } finally{
        contextStack.pop();
    }
}
function readFragment(fragmentInput, fragmentKey) {
    if (!contextStack.length) throw new Error('readFragment should be called only from within a Relay Resolver function.');
    var context = contextStack[contextStack.length - 1];
    var fragmentNode = getFragment(fragmentInput);
    var fragmentSelector = getSelector(fragmentNode, fragmentKey);
    !(fragmentSelector != null) && invariant(false);
    !(fragmentSelector.kind === 'SingularReaderSelector') && invariant(false);
    var _context$getDataForRe = context.getDataForResolverFragment(fragmentSelector, fragmentKey), data = _context$getDataForRe.data, isMissingData = _context$getDataForRe.isMissingData, fieldErrors = _context$getDataForRe.fieldErrors;
    if (isMissingData || fieldErrors != null && fieldErrors.some(eventShouldThrow)) throw RESOLVER_FRAGMENT_ERRORED_SENTINEL;
    return data;
}
var RESOLVER_FRAGMENT_ERRORED_SENTINEL = {};
module.exports = {
    readFragment: readFragment,
    withResolverContext: withResolverContext,
    RESOLVER_FRAGMENT_ERRORED_SENTINEL: RESOLVER_FRAGMENT_ERRORED_SENTINEL
};

},{"600f6b79f68bca6f":"8UTII","9820817ec81cea36":"kq97W","ed6a063285578c76":"9k2Dg","5065659723cd98f9":"e2sci"}],"8UTII":[function(require,module,exports,__globalThis) {
'use strict';
var RelayConcreteNode = require("215af52733b51617");
var invariant = require("105406c14db77d5");
var warning = require("67b4d2feca4bcbca");
function graphql(strings) {
    invariant(false);
}
function getNode(taggedNode) {
    var node = taggedNode;
    if (typeof node === 'function') node = node();
    else if (node["default"]) node = node["default"];
    return node;
}
function isFragment(node) {
    var fragment = getNode(node);
    return typeof fragment === 'object' && fragment !== null && fragment.kind === RelayConcreteNode.FRAGMENT;
}
function isRequest(node) {
    var request = getNode(node);
    return typeof request === 'object' && request !== null && request.kind === RelayConcreteNode.REQUEST;
}
function isUpdatableQuery(node) {
    var updatableQuery = getNode(node);
    return typeof updatableQuery === 'object' && updatableQuery !== null && updatableQuery.kind === RelayConcreteNode.UPDATABLE_QUERY;
}
function isInlineDataFragment(node) {
    var fragment = getNode(node);
    return typeof fragment === 'object' && fragment !== null && fragment.kind === RelayConcreteNode.INLINE_DATA_FRAGMENT;
}
function getFragment(taggedNode) {
    var fragment = getNode(taggedNode);
    !isFragment(fragment) && invariant(false);
    return fragment;
}
function getPaginationFragment(taggedNode) {
    var _fragment$metadata;
    var fragment = getFragment(taggedNode);
    var refetch = (_fragment$metadata = fragment.metadata) === null || _fragment$metadata === void 0 ? void 0 : _fragment$metadata.refetch;
    var connection = refetch === null || refetch === void 0 ? void 0 : refetch.connection;
    if (refetch === null || typeof refetch !== 'object' || connection === null || typeof connection !== 'object') return null;
    return fragment;
}
function getRefetchableFragment(taggedNode) {
    var _fragment$metadata2;
    var fragment = getFragment(taggedNode);
    var refetch = (_fragment$metadata2 = fragment.metadata) === null || _fragment$metadata2 === void 0 ? void 0 : _fragment$metadata2.refetch;
    if (refetch === null || typeof refetch !== 'object') return null;
    return fragment;
}
function getRequest(taggedNode) {
    var request = getNode(taggedNode);
    !isRequest(request) && invariant(false);
    return request;
}
function getUpdatableQuery(taggedNode) {
    var updatableQuery = getNode(taggedNode);
    !isUpdatableQuery(updatableQuery) && invariant(false);
    return updatableQuery;
}
function getInlineDataFragment(taggedNode) {
    var fragment = getNode(taggedNode);
    !isInlineDataFragment(fragment) && invariant(false);
    return fragment;
}
module.exports = {
    getFragment: getFragment,
    getNode: getNode,
    getPaginationFragment: getPaginationFragment,
    getRefetchableFragment: getRefetchableFragment,
    getRequest: getRequest,
    getUpdatableQuery: getUpdatableQuery,
    getInlineDataFragment: getInlineDataFragment,
    graphql: graphql,
    isFragment: isFragment,
    isRequest: isRequest,
    isUpdatableQuery: isUpdatableQuery,
    isInlineDataFragment: isInlineDataFragment
};

},{"215af52733b51617":"jKskk","105406c14db77d5":"e2sci","67b4d2feca4bcbca":"j64TH"}],"jKskk":[function(require,module,exports,__globalThis) {
'use strict';
var RelayConcreteNode = {
    ACTOR_CHANGE: 'ActorChange',
    CATCH_FIELD: 'CatchField',
    CONDITION: 'Condition',
    CLIENT_COMPONENT: 'ClientComponent',
    CLIENT_EDGE_TO_SERVER_OBJECT: 'ClientEdgeToServerObject',
    CLIENT_EDGE_TO_CLIENT_OBJECT: 'ClientEdgeToClientObject',
    CLIENT_EXTENSION: 'ClientExtension',
    DEFER: 'Defer',
    CONNECTION: 'Connection',
    FRAGMENT: 'Fragment',
    FRAGMENT_SPREAD: 'FragmentSpread',
    INLINE_DATA_FRAGMENT_SPREAD: 'InlineDataFragmentSpread',
    INLINE_DATA_FRAGMENT: 'InlineDataFragment',
    INLINE_FRAGMENT: 'InlineFragment',
    LINKED_FIELD: 'LinkedField',
    LINKED_HANDLE: 'LinkedHandle',
    LITERAL: 'Literal',
    LIST_VALUE: 'ListValue',
    LOCAL_ARGUMENT: 'LocalArgument',
    MODULE_IMPORT: 'ModuleImport',
    ALIASED_FRAGMENT_SPREAD: 'AliasedFragmentSpread',
    ALIASED_INLINE_FRAGMENT_SPREAD: 'AliasedInlineFragmentSpread',
    RELAY_RESOLVER: 'RelayResolver',
    RELAY_LIVE_RESOLVER: 'RelayLiveResolver',
    REQUIRED_FIELD: 'RequiredField',
    OBJECT_VALUE: 'ObjectValue',
    OPERATION: 'Operation',
    REQUEST: 'Request',
    ROOT_ARGUMENT: 'RootArgument',
    SCALAR_FIELD: 'ScalarField',
    SCALAR_HANDLE: 'ScalarHandle',
    SPLIT_OPERATION: 'SplitOperation',
    STREAM: 'Stream',
    TYPE_DISCRIMINATOR: 'TypeDiscriminator',
    UPDATABLE_QUERY: 'UpdatableQuery',
    VARIABLE: 'Variable'
};
module.exports = RelayConcreteNode;

},{}],"e2sci":[function(require,module,exports,__globalThis) {
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ 'use strict';
/**
 * Use invariant() to assert state which your program assumes to be true.
 *
 * Provide sprintf-style format (only %s is supported) and arguments
 * to provide information about what broke and what you were
 * expecting.
 *
 * The invariant message will be stripped in production, but the invariant
 * will remain to ensure logic does not differ in production.
 */ var invariant = function(condition, format, a, b, c, d, e, f) {
    if (!condition) {
        var error;
        if (format === undefined) error = new Error("Minified exception occurred; use the non-minified dev environment for the full error message and additional helpful warnings.");
        else {
            var args = [
                a,
                b,
                c,
                d,
                e,
                f
            ];
            var argIndex = 0;
            error = new Error(format.replace(/%s/g, function() {
                return args[argIndex++];
            }));
            error.name = 'Invariant Violation';
        }
        error.framesToPop = 1; // we don't care about invariant's own frame
        throw error;
    }
};
module.exports = invariant;

},{}],"j64TH":[function(require,module,exports,__globalThis) {
/**
 * Copyright (c) 2014-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 */ 'use strict';
var emptyFunction = require("26da6f212d2c65fc");
/**
 * Similar to invariant but only logs a warning if the condition is not met.
 * This can be used to log issues in development environments in critical
 * paths. Removing the logging code for production environments will keep the
 * same logic and follow the same code paths.
 */ function printWarning(format) {
    for(var _len = arguments.length, args = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++)args[_key - 1] = arguments[_key];
    var argIndex = 0;
    var message = 'Warning: ' + format.replace(/%s/g, function() {
        return args[argIndex++];
    });
    if (typeof console !== 'undefined') console.error(message);
    try {
        // --- Welcome to debugging React ---
        // This error was thrown as a convenience so that you can use this stack
        // to find the callsite that caused this warning to fire.
        throw new Error(message);
    } catch (x) {}
}
var warning = emptyFunction;
module.exports = warning;

},{"26da6f212d2c65fc":"caHn0"}],"caHn0":[function(require,module,exports,__globalThis) {
"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * 
 */ function makeEmptyFunction(arg) {
    return function() {
        return arg;
    };
}
/**
 * This function accepts and discards inputs; it has no side effects. This is
 * primarily useful idiomatically for overridable function endpoints which
 * always need to be callable, since JS lacks a null-call idiom ala Cocoa.
 */ var emptyFunction = function emptyFunction() {};
emptyFunction.thatReturns = makeEmptyFunction;
emptyFunction.thatReturnsFalse = makeEmptyFunction(false);
emptyFunction.thatReturnsTrue = makeEmptyFunction(true);
emptyFunction.thatReturnsNull = makeEmptyFunction(null);
emptyFunction.thatReturnsThis = function() {
    return this;
};
emptyFunction.thatReturnsArgument = function(arg) {
    return arg;
};
module.exports = emptyFunction;

},{}],"kq97W":[function(require,module,exports,__globalThis) {
'use strict';
var _interopRequireDefault = require("5ab3e0d9eda62480")["default"];
var _objectSpread2 = _interopRequireDefault(require("d10d675761c8fa53"));
var _createForOfIteratorHelper2 = _interopRequireDefault(require("3a97a807ddb451aa"));
var invariant = require("f28640bb1f062bcf");
function handleFieldErrors(environment, fieldErrors, loggingContext) {
    var _iterator = (0, _createForOfIteratorHelper2["default"])(fieldErrors), _step;
    try {
        for(_iterator.s(); !(_step = _iterator.n()).done;){
            var fieldError = _step.value;
            environment.relayFieldLogger((0, _objectSpread2["default"])((0, _objectSpread2["default"])({}, fieldError), {}, {
                uiContext: loggingContext
            }));
        }
    } catch (err) {
        _iterator.e(err);
    } finally{
        _iterator.f();
    }
    var _iterator2 = (0, _createForOfIteratorHelper2["default"])(fieldErrors), _step2;
    try {
        for(_iterator2.s(); !(_step2 = _iterator2.n()).done;){
            var _fieldError = _step2.value;
            if (eventShouldThrow(_fieldError)) switch(_fieldError.kind){
                case 'relay_resolver.error':
                    throw new Error("Relay: Resolver error at path '".concat(_fieldError.fieldPath, "' in '").concat(_fieldError.owner, "'. Message: ").concat(_fieldError.error.message));
                case 'relay_field_payload.error':
                    throw new Error("Relay: Unexpected response payload - check server logs for details.");
                case 'missing_expected_data.throw':
                    throw new Error("Relay: Missing expected data at path '".concat(_fieldError.fieldPath, "' in '").concat(_fieldError.owner, "'."));
                case 'missing_required_field.throw':
                    throw new Error("Relay: Missing @required value at path '".concat(_fieldError.fieldPath, "' in '").concat(_fieldError.owner, "'."));
                case 'missing_required_field.log':
                case 'missing_expected_data.log':
                    break;
                default:
                    _fieldError.kind;
                    invariant(false);
            }
        }
    } catch (err) {
        _iterator2.e(err);
    } finally{
        _iterator2.f();
    }
}
function eventShouldThrow(event) {
    switch(event.kind){
        case 'relay_resolver.error':
        case 'relay_field_payload.error':
            return event.shouldThrow && !event.handled;
        case 'missing_expected_data.throw':
        case 'missing_required_field.throw':
            return !event.handled;
        case 'missing_required_field.log':
        case 'missing_expected_data.log':
            return false;
        default:
            event.kind;
            throw new Error('Relay: Unexpected event kind');
    }
}
function handlePotentialSnapshotErrors(environment, fieldErrors, loggingContext) {
    if (fieldErrors != null) handleFieldErrors(environment, fieldErrors, loggingContext);
}
module.exports = {
    handlePotentialSnapshotErrors: handlePotentialSnapshotErrors,
    eventShouldThrow: eventShouldThrow
};

},{"5ab3e0d9eda62480":"590td","d10d675761c8fa53":"2Bj1n","3a97a807ddb451aa":"fMaLa","f28640bb1f062bcf":"e2sci"}],"590td":[function(require,module,exports,__globalThis) {
function _interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        "default": e
    };
}
module.exports = _interopRequireDefault, module.exports.__esModule = true, module.exports["default"] = module.exports;

},{}],"2Bj1n":[function(require,module,exports,__globalThis) {
var defineProperty = require("b5c9231705b4e48e");
function ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function _objectSpread2(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? ownKeys(Object(t), !0).forEach(function(r) {
            defineProperty(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
module.exports = _objectSpread2, module.exports.__esModule = true, module.exports["default"] = module.exports;

},{"b5c9231705b4e48e":"2paQ8"}],"2paQ8":[function(require,module,exports,__globalThis) {
var toPropertyKey = require("f7ac22421bd3394b");
function _defineProperty(e, r, t) {
    return (r = toPropertyKey(r)) in e ? Object.defineProperty(e, r, {
        value: t,
        enumerable: !0,
        configurable: !0,
        writable: !0
    }) : e[r] = t, e;
}
module.exports = _defineProperty, module.exports.__esModule = true, module.exports["default"] = module.exports;

},{"f7ac22421bd3394b":"ipoCP"}],"ipoCP":[function(require,module,exports,__globalThis) {
var _typeof = require("389263fe926d4163")["default"];
var toPrimitive = require("2d213a9b2e3e2f98");
function toPropertyKey(t) {
    var i = toPrimitive(t, "string");
    return "symbol" == _typeof(i) ? i : i + "";
}
module.exports = toPropertyKey, module.exports.__esModule = true, module.exports["default"] = module.exports;

},{"389263fe926d4163":"r9vQs","2d213a9b2e3e2f98":"lDPGd"}],"r9vQs":[function(require,module,exports,__globalThis) {
function _typeof(o) {
    "@babel/helpers - typeof";
    return module.exports = _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(o) {
        return typeof o;
    } : function(o) {
        return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
    }, module.exports.__esModule = true, module.exports["default"] = module.exports, _typeof(o);
}
module.exports = _typeof, module.exports.__esModule = true, module.exports["default"] = module.exports;

},{}],"lDPGd":[function(require,module,exports,__globalThis) {
var _typeof = require("cb886826e8f1c745")["default"];
function toPrimitive(t, r) {
    if ("object" != _typeof(t) || !t) return t;
    var e = t[Symbol.toPrimitive];
    if (void 0 !== e) {
        var i = e.call(t, r || "default");
        if ("object" != _typeof(i)) return i;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return ("string" === r ? String : Number)(t);
}
module.exports = toPrimitive, module.exports.__esModule = true, module.exports["default"] = module.exports;

},{"cb886826e8f1c745":"r9vQs"}],"fMaLa":[function(require,module,exports,__globalThis) {
var unsupportedIterableToArray = require("cc141f168bb6bdd6");
function _createForOfIteratorHelper(r, e) {
    var t = "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"];
    if (!t) {
        if (Array.isArray(r) || (t = unsupportedIterableToArray(r)) || e && r && "number" == typeof r.length) {
            t && (r = t);
            var _n = 0, F = function F() {};
            return {
                s: F,
                n: function n() {
                    return _n >= r.length ? {
                        done: !0
                    } : {
                        done: !1,
                        value: r[_n++]
                    };
                },
                e: function e(r) {
                    throw r;
                },
                f: F
            };
        }
        throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
    }
    var o, a = !0, u = !1;
    return {
        s: function s() {
            t = t.call(r);
        },
        n: function n() {
            var r = t.next();
            return a = r.done, r;
        },
        e: function e(r) {
            u = !0, o = r;
        },
        f: function f() {
            try {
                a || null == t["return"] || t["return"]();
            } finally{
                if (u) throw o;
            }
        }
    };
}
module.exports = _createForOfIteratorHelper, module.exports.__esModule = true, module.exports["default"] = module.exports;

},{"cc141f168bb6bdd6":"i55CV"}],"i55CV":[function(require,module,exports,__globalThis) {
var arrayLikeToArray = require("9593e59e64aac430");
function _unsupportedIterableToArray(r, a) {
    if (r) {
        if ("string" == typeof r) return arrayLikeToArray(r, a);
        var t = ({}).toString.call(r).slice(8, -1);
        return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? arrayLikeToArray(r, a) : void 0;
    }
}
module.exports = _unsupportedIterableToArray, module.exports.__esModule = true, module.exports["default"] = module.exports;

},{"9593e59e64aac430":"ew5Gq"}],"ew5Gq":[function(require,module,exports,__globalThis) {
function _arrayLikeToArray(r, a) {
    (null == a || a > r.length) && (a = r.length);
    for(var e = 0, n = Array(a); e < a; e++)n[e] = r[e];
    return n;
}
module.exports = _arrayLikeToArray, module.exports.__esModule = true, module.exports["default"] = module.exports;

},{}],"9k2Dg":[function(require,module,exports,__globalThis) {
'use strict';
var _require = require("a0169a50ff2fbd9d"), getFragmentVariables = _require.getFragmentVariables;
var _require2 = require("a3b8f7c0e5e243c0"), CLIENT_EDGE_TRAVERSAL_PATH = _require2.CLIENT_EDGE_TRAVERSAL_PATH, FRAGMENT_OWNER_KEY = _require2.FRAGMENT_OWNER_KEY, FRAGMENT_POINTER_IS_WITHIN_UNMATCHED_TYPE_REFINEMENT = _require2.FRAGMENT_POINTER_IS_WITHIN_UNMATCHED_TYPE_REFINEMENT, FRAGMENTS_KEY = _require2.FRAGMENTS_KEY, ID_KEY = _require2.ID_KEY;
var areEqual = require("5f29e20aafea982a");
var invariant = require("db320263417ac2fa");
var warning = require("cfb748599f67db39");
function getSingularSelector(fragment, item) {
    !(typeof item === 'object' && item !== null && !Array.isArray(item)) && invariant(false);
    var dataID = item[ID_KEY];
    var fragments = item[FRAGMENTS_KEY];
    var mixedOwner = item[FRAGMENT_OWNER_KEY];
    var mixedClientEdgeTraversalPath = item[CLIENT_EDGE_TRAVERSAL_PATH];
    if (typeof dataID === 'string' && typeof fragments === 'object' && fragments !== null && typeof fragments[fragment.name] === 'object' && fragments[fragment.name] !== null && typeof mixedOwner === 'object' && mixedOwner !== null && (mixedClientEdgeTraversalPath == null || Array.isArray(mixedClientEdgeTraversalPath))) {
        var owner = mixedOwner;
        var clientEdgeTraversalPath = mixedClientEdgeTraversalPath;
        var argumentVariables = fragments[fragment.name];
        var fragmentVariables = getFragmentVariables(fragment, owner.variables, argumentVariables);
        var isWithinUnmatchedTypeRefinement = argumentVariables[FRAGMENT_POINTER_IS_WITHIN_UNMATCHED_TYPE_REFINEMENT] === true;
        return createReaderSelector(fragment, dataID, fragmentVariables, owner, isWithinUnmatchedTypeRefinement, clientEdgeTraversalPath);
    }
    var stringifiedItem;
    return null;
}
function getPluralSelector(fragment, items) {
    var selectors = null;
    items.forEach(function(item, ii) {
        var selector = item != null ? getSingularSelector(fragment, item) : null;
        if (selector != null) {
            selectors = selectors || [];
            selectors.push(selector);
        }
    });
    if (selectors == null) return null;
    else return {
        kind: 'PluralReaderSelector',
        selectors: selectors
    };
}
function getSelector(fragment, item) {
    if (item == null) return item;
    else if (fragment.metadata && fragment.metadata.plural === true) {
        !Array.isArray(item) && invariant(false);
        return getPluralSelector(fragment, item);
    } else {
        !!Array.isArray(item) && invariant(false);
        return getSingularSelector(fragment, item);
    }
}
function getSelectorsFromObject(fragments, object) {
    var selectors = {};
    for(var key in fragments)if (fragments.hasOwnProperty(key)) {
        var fragment = fragments[key];
        var item = object[key];
        selectors[key] = getSelector(fragment, item);
    }
    return selectors;
}
function getDataIDsFromObject(fragments, object) {
    var ids = {};
    for(var key in fragments)if (fragments.hasOwnProperty(key)) {
        var fragment = fragments[key];
        var item = object[key];
        ids[key] = getDataIDsFromFragment(fragment, item);
    }
    return ids;
}
function getDataIDsFromFragment(fragment, item) {
    if (item == null) return item;
    else if (fragment.metadata && fragment.metadata.plural === true) {
        !Array.isArray(item) && invariant(false);
        return getDataIDs(fragment, item);
    } else {
        !!Array.isArray(item) && invariant(false);
        return getDataID(fragment, item);
    }
}
function getDataIDs(fragment, items) {
    var ids = null;
    items.forEach(function(item) {
        var id = item != null ? getDataID(fragment, item) : null;
        if (id != null) {
            ids = ids || [];
            ids.push(id);
        }
    });
    return ids;
}
function getDataID(fragment, item) {
    !(typeof item === 'object' && item !== null && !Array.isArray(item)) && invariant(false);
    var dataID = item[ID_KEY];
    if (typeof dataID === 'string') return dataID;
    return null;
}
function getVariablesFromObject(fragments, object) {
    var variables = {};
    for(var key in fragments)if (fragments.hasOwnProperty(key)) {
        var fragment = fragments[key];
        var item = object[key];
        var itemVariables = getVariablesFromFragment(fragment, item);
        Object.assign(variables, itemVariables);
    }
    return variables;
}
function getVariablesFromFragment(fragment, item) {
    var _fragment$metadata;
    if (item == null) return {};
    else if (((_fragment$metadata = fragment.metadata) === null || _fragment$metadata === void 0 ? void 0 : _fragment$metadata.plural) === true) {
        !Array.isArray(item) && invariant(false);
        return getVariablesFromPluralFragment(fragment, item);
    } else {
        !!Array.isArray(item) && invariant(false);
        return getVariablesFromSingularFragment(fragment, item) || {};
    }
}
function getVariablesFromSingularFragment(fragment, item) {
    var selector = getSingularSelector(fragment, item);
    if (!selector) return null;
    return selector.variables;
}
function getVariablesFromPluralFragment(fragment, items) {
    var variables = {};
    items.forEach(function(value, ii) {
        if (value != null) {
            var itemVariables = getVariablesFromSingularFragment(fragment, value);
            if (itemVariables != null) Object.assign(variables, itemVariables);
        }
    });
    return variables;
}
function areEqualSingularSelectors(thisSelector, thatSelector) {
    return thisSelector.dataID === thatSelector.dataID && thisSelector.node === thatSelector.node && areEqual(thisSelector.variables, thatSelector.variables) && areEqualOwners(thisSelector.owner, thatSelector.owner) && thisSelector.isWithinUnmatchedTypeRefinement === thatSelector.isWithinUnmatchedTypeRefinement && areEqualClientEdgeTraversalPaths(thisSelector.clientEdgeTraversalPath, thatSelector.clientEdgeTraversalPath);
}
function areEqualOwners(thisOwner, thatOwner) {
    if (thisOwner === thatOwner) return true;
    else return thisOwner.identifier === thatOwner.identifier && areEqual(thisOwner.cacheConfig, thatOwner.cacheConfig);
}
function areEqualClientEdgeTraversalPaths(thisPath, thatPath) {
    if (thisPath === thatPath) return true;
    if (thisPath == null || thatPath == null || thisPath.length !== thatPath.length) return false;
    var idx = thisPath.length;
    while(idx--){
        var a = thisPath[idx];
        var b = thatPath[idx];
        if (a === b) continue;
        if (a == null || b == null || a.clientEdgeDestinationID !== b.clientEdgeDestinationID || a.readerClientEdge !== b.readerClientEdge) return false;
    }
    return true;
}
function areEqualSelectors(a, b) {
    if (a === b) return true;
    else if (a == null) return b == null;
    else if (b == null) return a == null;
    else if (a.kind === 'SingularReaderSelector' && b.kind === 'SingularReaderSelector') return areEqualSingularSelectors(a, b);
    else if (a.kind === 'PluralReaderSelector' && b.kind === 'PluralReaderSelector') return a.selectors.length === b.selectors.length && a.selectors.every(function(s, i) {
        return areEqualSingularSelectors(s, b.selectors[i]);
    });
    else return false;
}
function createReaderSelector(fragment, dataID, variables, request) {
    var isWithinUnmatchedTypeRefinement = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : false;
    var clientEdgeTraversalPath = arguments.length > 5 ? arguments[5] : undefined;
    return {
        kind: 'SingularReaderSelector',
        dataID: dataID,
        isWithinUnmatchedTypeRefinement: isWithinUnmatchedTypeRefinement,
        clientEdgeTraversalPath: clientEdgeTraversalPath !== null && clientEdgeTraversalPath !== void 0 ? clientEdgeTraversalPath : null,
        node: fragment,
        variables: variables,
        owner: request
    };
}
function createNormalizationSelector(node, dataID, variables) {
    return {
        dataID: dataID,
        node: node,
        variables: variables
    };
}
module.exports = {
    areEqualSelectors: areEqualSelectors,
    createReaderSelector: createReaderSelector,
    createNormalizationSelector: createNormalizationSelector,
    getDataIDsFromFragment: getDataIDsFromFragment,
    getDataIDsFromObject: getDataIDsFromObject,
    getSingularSelector: getSingularSelector,
    getPluralSelector: getPluralSelector,
    getSelector: getSelector,
    getSelectorsFromObject: getSelectorsFromObject,
    getVariablesFromSingularFragment: getVariablesFromSingularFragment,
    getVariablesFromPluralFragment: getVariablesFromPluralFragment,
    getVariablesFromFragment: getVariablesFromFragment,
    getVariablesFromObject: getVariablesFromObject
};

},{"a0169a50ff2fbd9d":"138Hd","a3b8f7c0e5e243c0":"3QcrW","5f29e20aafea982a":"eJLuG","db320263417ac2fa":"e2sci","cfb748599f67db39":"j64TH"}],"138Hd":[function(require,module,exports,__globalThis) {
'use strict';
var _interopRequireDefault = require("67a101b2e385978c")["default"];
var _objectSpread2 = _interopRequireDefault(require("2f18dbe495dc5f1d"));
var _require = require("55099d1f43cc4ced"), getArgumentValues = _require.getArgumentValues;
var invariant = require("dad77247c37d9687");
function getFragmentVariables(fragment, rootVariables, argumentVariables) {
    if (fragment.argumentDefinitions == null) return argumentVariables;
    var variables;
    fragment.argumentDefinitions.forEach(function(definition) {
        if (argumentVariables.hasOwnProperty(definition.name)) return;
        variables = variables || (0, _objectSpread2["default"])({}, argumentVariables);
        switch(definition.kind){
            case 'LocalArgument':
                variables[definition.name] = definition.defaultValue;
                break;
            case 'RootArgument':
                if (!rootVariables.hasOwnProperty(definition.name)) {
                    variables[definition.name] = undefined;
                    break;
                }
                variables[definition.name] = rootVariables[definition.name];
                break;
            default:
                definition;
                invariant(false);
        }
    });
    return variables || argumentVariables;
}
function getOperationVariables(operation, providedVariables, variables) {
    var operationVariables = {};
    operation.argumentDefinitions.forEach(function(def) {
        var value = def.defaultValue;
        if (variables[def.name] != null) value = variables[def.name];
        operationVariables[def.name] = value;
    });
    if (providedVariables != null) Object.keys(providedVariables).forEach(function(varName) {
        operationVariables[varName] = providedVariables[varName].get();
    });
    return operationVariables;
}
function getLocalVariables(currentVariables, argumentDefinitions, args) {
    if (argumentDefinitions == null) return currentVariables;
    var nextVariables = (0, _objectSpread2["default"])({}, currentVariables);
    var nextArgs = args ? getArgumentValues(args, currentVariables) : {};
    argumentDefinitions.forEach(function(def) {
        var _nextArgs$def$name;
        var value = (_nextArgs$def$name = nextArgs[def.name]) !== null && _nextArgs$def$name !== void 0 ? _nextArgs$def$name : def.defaultValue;
        nextVariables[def.name] = value;
    });
    return nextVariables;
}
module.exports = {
    getLocalVariables: getLocalVariables,
    getFragmentVariables: getFragmentVariables,
    getOperationVariables: getOperationVariables
};

},{"67a101b2e385978c":"590td","2f18dbe495dc5f1d":"2Bj1n","55099d1f43cc4ced":"3QcrW","dad77247c37d9687":"e2sci"}],"3QcrW":[function(require,module,exports,__globalThis) {
'use strict';
var _interopRequireDefault = require("9b76c7721777306c")["default"];
var _toConsumableArray2 = _interopRequireDefault(require("a8d0283c12d1f4b7"));
var getRelayHandleKey = require("3c291ab4f1767305");
var RelayConcreteNode = require("95e06ba53de00388");
var RelayFeatureFlags = require("c9f1094dec31d993");
var _require = require("cd76dd17e18dd8c3"), stableCopy = _require.stableCopy;
var invariant = require("16b3884f510a8fd8");
var VARIABLE = RelayConcreteNode.VARIABLE, LITERAL = RelayConcreteNode.LITERAL, OBJECT_VALUE = RelayConcreteNode.OBJECT_VALUE, LIST_VALUE = RelayConcreteNode.LIST_VALUE;
var ERRORS_KEY = '__errors';
var MODULE_COMPONENT_KEY_PREFIX = '__module_component_';
var MODULE_OPERATION_KEY_PREFIX = '__module_operation_';
var RELAY_READ_TIME_RESOLVER_KEY_PREFIX = '$r:';
function getArgumentValue(arg, variables) {
    if (arg.kind === VARIABLE) return getStableVariableValue(arg.variableName, variables);
    else if (arg.kind === LITERAL) return arg.value;
    else if (arg.kind === OBJECT_VALUE) {
        var value = {};
        arg.fields.forEach(function(field) {
            value[field.name] = getArgumentValue(field, variables);
        });
        return value;
    } else if (arg.kind === LIST_VALUE) {
        var _value = [];
        arg.items.forEach(function(item) {
            item != null && _value.push(getArgumentValue(item, variables));
        });
        return _value;
    }
}
function getArgumentValues(args, variables, isWithinUnmatchedTypeRefinement) {
    var values = {};
    if (isWithinUnmatchedTypeRefinement) values[RelayStoreUtils.FRAGMENT_POINTER_IS_WITHIN_UNMATCHED_TYPE_REFINEMENT] = true;
    if (args) args.forEach(function(arg) {
        values[arg.name] = getArgumentValue(arg, variables);
    });
    return values;
}
function getHandleStorageKey(handleField, variables) {
    var dynamicKey = handleField.dynamicKey, handle = handleField.handle, key = handleField.key, name = handleField.name, args = handleField.args, filters = handleField.filters;
    var handleName = getRelayHandleKey(handle, key, name);
    var filterArgs = null;
    if (args && filters && args.length !== 0 && filters.length !== 0) filterArgs = args.filter(function(arg) {
        return filters.indexOf(arg.name) > -1;
    });
    if (dynamicKey) filterArgs = filterArgs != null ? [
        dynamicKey
    ].concat((0, _toConsumableArray2["default"])(filterArgs)) : [
        dynamicKey
    ];
    if (filterArgs === null) return handleName;
    else return formatStorageKey(handleName, getArgumentValues(filterArgs, variables));
}
function getStorageKey(field, variables) {
    if (field.storageKey) return field.storageKey;
    var args = getArguments(field);
    var name = field.name;
    return args && args.length !== 0 ? formatStorageKey(name, getArgumentValues(args, variables)) : name;
}
function getReadTimeResolverStorageKey(field, variables) {
    var storageKey = getStorageKey(field, variables);
    return RelayFeatureFlags.ENABLE_READ_TIME_RESOLVER_STORAGE_KEY_PREFIX ? '$r:' + storageKey : storageKey;
}
function getArguments(field) {
    if (field.kind === 'RelayResolver' || field.kind === 'RelayLiveResolver') {
        var _field$fragment2;
        if (field.args == null) {
            var _field$fragment;
            return (_field$fragment = field.fragment) === null || _field$fragment === void 0 ? void 0 : _field$fragment.args;
        }
        if (((_field$fragment2 = field.fragment) === null || _field$fragment2 === void 0 ? void 0 : _field$fragment2.args) == null) return field.args;
        return field.args.concat(field.fragment.args);
    }
    var args = typeof field.args === 'undefined' ? undefined : field.args;
    return args;
}
function getStableStorageKey(name, args) {
    return formatStorageKey(name, stableCopy(args));
}
function formatStorageKey(name, argValues) {
    if (!argValues) return name;
    var values = [];
    for(var argName in argValues)if (argValues.hasOwnProperty(argName)) {
        var value = argValues[argName];
        if (value != null) {
            var _JSON$stringify;
            values.push(argName + ':' + ((_JSON$stringify = JSON.stringify(value)) !== null && _JSON$stringify !== void 0 ? _JSON$stringify : 'undefined'));
        }
    }
    return values.length === 0 ? name : name + "(".concat(values.join(','), ")");
}
function getStableVariableValue(name, variables) {
    !variables.hasOwnProperty(name) && invariant(false);
    return stableCopy(variables[name]);
}
function getModuleComponentKey(documentName) {
    return "".concat(MODULE_COMPONENT_KEY_PREFIX).concat(documentName);
}
function getModuleOperationKey(documentName) {
    return "".concat(MODULE_OPERATION_KEY_PREFIX).concat(documentName);
}
var RelayStoreUtils = {
    ACTOR_IDENTIFIER_KEY: '__actorIdentifier',
    CLIENT_EDGE_TRAVERSAL_PATH: '__clientEdgeTraversalPath',
    FRAGMENTS_KEY: '__fragments',
    FRAGMENT_OWNER_KEY: '__fragmentOwner',
    FRAGMENT_POINTER_IS_WITHIN_UNMATCHED_TYPE_REFINEMENT: '$isWithinUnmatchedTypeRefinement',
    FRAGMENT_PROP_NAME_KEY: '__fragmentPropName',
    MODULE_COMPONENT_KEY: '__module_component',
    ERRORS_KEY: ERRORS_KEY,
    ID_KEY: '__id',
    REF_KEY: '__ref',
    REFS_KEY: '__refs',
    ROOT_ID: 'client:root',
    ROOT_TYPE: '__Root',
    TYPENAME_KEY: '__typename',
    INVALIDATED_AT_KEY: '__invalidated_at',
    RELAY_RESOLVER_VALUE_KEY: '__resolverValue',
    RELAY_RESOLVER_INVALIDATION_KEY: '__resolverValueMayBeInvalid',
    RELAY_RESOLVER_SNAPSHOT_KEY: '__resolverSnapshot',
    RELAY_RESOLVER_ERROR_KEY: '__resolverError',
    RELAY_RESOLVER_OUTPUT_TYPE_RECORD_IDS: '__resolverOutputTypeRecordIDs',
    RELAY_READ_TIME_RESOLVER_KEY_PREFIX: RELAY_READ_TIME_RESOLVER_KEY_PREFIX,
    formatStorageKey: formatStorageKey,
    getArgumentValue: getArgumentValue,
    getArgumentValues: getArgumentValues,
    getHandleStorageKey: getHandleStorageKey,
    getStorageKey: getStorageKey,
    getReadTimeResolverStorageKey: getReadTimeResolverStorageKey,
    getStableStorageKey: getStableStorageKey,
    getModuleComponentKey: getModuleComponentKey,
    getModuleOperationKey: getModuleOperationKey
};
module.exports = RelayStoreUtils;

},{"9b76c7721777306c":"590td","a8d0283c12d1f4b7":"7EBX0","3c291ab4f1767305":"etrZd","95e06ba53de00388":"jKskk","c9f1094dec31d993":"a0FL5","cd76dd17e18dd8c3":"c3NLR","16b3884f510a8fd8":"e2sci"}],"7EBX0":[function(require,module,exports,__globalThis) {
var arrayWithoutHoles = require("fd560f157b55f0e0");
var iterableToArray = require("ec0ff5d363fedfed");
var unsupportedIterableToArray = require("d80187be8dc82286");
var nonIterableSpread = require("9b8d6603e51a38ae");
function _toConsumableArray(r) {
    return arrayWithoutHoles(r) || iterableToArray(r) || unsupportedIterableToArray(r) || nonIterableSpread();
}
module.exports = _toConsumableArray, module.exports.__esModule = true, module.exports["default"] = module.exports;

},{"fd560f157b55f0e0":"8kYNU","ec0ff5d363fedfed":"dzwW5","d80187be8dc82286":"i55CV","9b8d6603e51a38ae":"aASV2"}],"8kYNU":[function(require,module,exports,__globalThis) {
var arrayLikeToArray = require("9be48c8bb8238bc0");
function _arrayWithoutHoles(r) {
    if (Array.isArray(r)) return arrayLikeToArray(r);
}
module.exports = _arrayWithoutHoles, module.exports.__esModule = true, module.exports["default"] = module.exports;

},{"9be48c8bb8238bc0":"ew5Gq"}],"dzwW5":[function(require,module,exports,__globalThis) {
function _iterableToArray(r) {
    if ("undefined" != typeof Symbol && null != r[Symbol.iterator] || null != r["@@iterator"]) return Array.from(r);
}
module.exports = _iterableToArray, module.exports.__esModule = true, module.exports["default"] = module.exports;

},{}],"aASV2":[function(require,module,exports,__globalThis) {
function _nonIterableSpread() {
    throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
module.exports = _nonIterableSpread, module.exports.__esModule = true, module.exports["default"] = module.exports;

},{}],"etrZd":[function(require,module,exports,__globalThis) {
'use strict';
var _require = require("cf78938049ab07ef"), DEFAULT_HANDLE_KEY = _require.DEFAULT_HANDLE_KEY;
var invariant = require("cfa400fca0a44e4a");
function getRelayHandleKey(handleName, key, fieldName) {
    if (key && key !== DEFAULT_HANDLE_KEY) return "__".concat(key, "_").concat(handleName);
    !(fieldName != null) && invariant(false);
    return "__".concat(fieldName, "_").concat(handleName);
}
module.exports = getRelayHandleKey;

},{"cf78938049ab07ef":"bYgdD","cfa400fca0a44e4a":"e2sci"}],"bYgdD":[function(require,module,exports,__globalThis) {
'use strict';
module.exports = {
    DEFAULT_HANDLE_KEY: ''
};

},{}],"a0FL5":[function(require,module,exports,__globalThis) {
'use strict';
var RelayFeatureFlags = {
    ENABLE_VARIABLE_CONNECTION_KEY: false,
    ENABLE_RELAY_RESOLVERS: false,
    ENABLE_GETFRAGMENTIDENTIFIER_OPTIMIZATION: false,
    ENABLE_FRIENDLY_QUERY_NAME_GQL_URL: false,
    ENABLE_DO_NOT_WRAP_LIVE_QUERY: false,
    ENABLE_NOTIFY_SUBSCRIPTION: false,
    BATCH_ASYNC_MODULE_UPDATES_FN: null,
    ENABLE_CONTAINERS_SUBSCRIBE_ON_COMMIT: false,
    MAX_DATA_ID_LENGTH: null,
    STRING_INTERN_LEVEL: 0,
    LOG_MISSING_RECORDS_IN_PROD: false,
    ENABLE_STORE_ID_COLLISION_LOGGING: false,
    ENABLE_NONCOMPLIANT_ERROR_HANDLING_ON_LISTS: false,
    ENABLE_LOOSE_SUBSCRIPTION_ATTRIBUTION: false,
    ENABLE_OPERATION_TRACKER_OPTIMISTIC_UPDATES: false,
    ENABLE_RELAY_OPERATION_TRACKER_SUSPENSE: false,
    PROCESS_OPTIMISTIC_UPDATE_BEFORE_SUBSCRIPTION: false,
    MARK_RESOLVER_VALUES_AS_CLEAN_AFTER_FRAGMENT_REREAD: false,
    ENABLE_CYLE_DETECTION_IN_VARIABLES: false,
    ENABLE_ACTIVITY_COMPATIBILITY: false,
    ENABLE_READ_TIME_RESOLVER_STORAGE_KEY_PREFIX: true,
    ENABLE_USE_PAGINATION_IS_LOADING_FIX: false,
    DISALLOW_NESTED_UPDATES: false,
    ENABLE_TYPENAME_PREFIXED_DATA_ID: false,
    ENABLE_UI_CONTEXT_ON_RELAY_LOGGER: false,
    CHECK_ALL_FRAGMENTS_FOR_MISSING_CLIENT_EDGES: false
};
module.exports = RelayFeatureFlags;

},{}],"c3NLR":[function(require,module,exports,__globalThis) {
'use strict';
function stableCopy(value) {
    if (!value || typeof value !== 'object') return value;
    if (Array.isArray(value)) return value.map(stableCopy);
    var keys = Object.keys(value).sort();
    var stable = {};
    for(var i = 0; i < keys.length; i++)stable[keys[i]] = stableCopy(value[keys[i]]);
    return stable;
}
function hasCycle(value) {
    var parents = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : new Set();
    if (!value || typeof value !== 'object') return false;
    if (parents.has(value)) return true;
    var newParents = new Set(parents);
    newParents.add(value);
    var children = Array.isArray(value) ? value : Object.values(value);
    return children.some(function(v) {
        return hasCycle(v, newParents);
    });
}
module.exports = {
    stableCopy: stableCopy,
    hasCycle: hasCycle
};

},{}],"eJLuG":[function(require,module,exports,__globalThis) {
"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * 
 */ var aStackPool = [];
var bStackPool = [];
/**
 * Checks if two values are equal. Values may be primitives, arrays, or objects.
 * Returns true if both arguments have the same keys and values.
 *
 * @see http://underscorejs.org
 * @copyright 2009-2013 Jeremy Ashkenas, DocumentCloud Inc.
 * @license MIT
 */ function areEqual(a, b) {
    var aStack = aStackPool.length ? aStackPool.pop() : [];
    var bStack = bStackPool.length ? bStackPool.pop() : [];
    var result = eq(a, b, aStack, bStack);
    aStack.length = 0;
    bStack.length = 0;
    aStackPool.push(aStack);
    bStackPool.push(bStack);
    return result;
}
function eq(a, b, aStack, bStack) {
    if (a === b) // Identical objects are equal. `0 === -0`, but they aren't identical.
    return a !== 0 || 1 / a == 1 / b;
    if (a == null || b == null) // a or b can be `null` or `undefined`
    return false;
    if (typeof a != 'object' || typeof b != 'object') return false;
    var objToStr = Object.prototype.toString;
    var className = objToStr.call(a);
    if (className != objToStr.call(b)) return false;
    switch(className){
        case '[object String]':
            return a == String(b);
        case '[object Number]':
            return isNaN(a) || isNaN(b) ? false : a == Number(b);
        case '[object Date]':
        case '[object Boolean]':
            return +a == +b;
        case '[object RegExp]':
            return a.source == b.source && a.global == b.global && a.multiline == b.multiline && a.ignoreCase == b.ignoreCase;
    } // Assume equality for cyclic structures.
    var length = aStack.length;
    while(length--){
        if (aStack[length] == a) return bStack[length] == b;
    }
    aStack.push(a);
    bStack.push(b);
    var size = 0; // Recursively compare objects and arrays.
    if (className === '[object Array]') {
        size = a.length;
        if (size !== b.length) return false;
         // Deep compare the contents, ignoring non-numeric properties.
        while(size--){
            if (!eq(a[size], b[size], aStack, bStack)) return false;
        }
    } else {
        if (a.constructor !== b.constructor) return false;
        if (a.hasOwnProperty('valueOf') && b.hasOwnProperty('valueOf')) return a.valueOf() == b.valueOf();
        var keys = Object.keys(a);
        if (keys.length != Object.keys(b).length) return false;
        for(var i = 0; i < keys.length; i++){
            if (!eq(a[keys[i]], b[keys[i]], aStack, bStack)) return false;
        }
    }
    aStack.pop();
    bStack.pop();
    return true;
}
module.exports = areEqual;

},{}],"lRP4u":[function(require,module,exports,__globalThis) {
"use strict";
var _interopRequireDefault = require("a9f8abda96aa1ad5")["default"];
var _asyncToGenerator = require("4a3eb73bedab2e1f").default;
var _createForOfIteratorHelper2 = _interopRequireDefault(require("16c5d791f5673ef2"));
var Observable = require("11386da7f40c4c6e");
var _require = require("39c4a91637c9938e"), getObservableForActiveRequest = _require.getObservableForActiveRequest;
var _require2 = require("25a8d3ddcf62633c"), getFragment = _require2.getFragment;
var _require3 = require("e941b1d3eb96fb16"), handlePotentialSnapshotErrors = _require3.handlePotentialSnapshotErrors;
var _require4 = require("26e4582e60a741d2"), getSelector = _require4.getSelector;
var invariant = require("4269e0123344fc71");
function waitForFragmentData(_x, _x2, _x3) {
    return _waitForFragmentData.apply(this, arguments);
}
function _waitForFragmentData() {
    _waitForFragmentData = _asyncToGenerator(function*(environment, fragment, fragmentRef) {
        var subscription;
        try {
            var _subscription;
            var data = yield new Promise(function(resolve, reject) {
                subscription = observeFragment(environment, fragment, fragmentRef).subscribe({
                    next: function next(val) {
                        if (val.state === 'ok') resolve(val.value);
                        else if (val.state === 'error') reject(val.error);
                    }
                });
            });
            (_subscription = subscription) === null || _subscription === void 0 || _subscription.unsubscribe();
            return data;
        } catch (e) {
            var _subscription2;
            (_subscription2 = subscription) === null || _subscription2 === void 0 || _subscription2.unsubscribe();
            throw e;
        }
    });
    return _waitForFragmentData.apply(this, arguments);
}
function observeFragment(environment, fragment, fragmentRef) {
    var _fragmentNode$metadat;
    var fragmentNode = getFragment(fragment);
    var fragmentSelector = getSelector(fragmentNode, fragmentRef);
    !(((_fragmentNode$metadat = fragmentNode.metadata) === null || _fragmentNode$metadat === void 0 ? void 0 : _fragmentNode$metadat.hasClientEdges) == null) && invariant(false);
    !(fragmentSelector != null) && invariant(false);
    switch(fragmentSelector.kind){
        case 'SingularReaderSelector':
            return observeSingularSelector(environment, fragment, fragmentSelector);
        case 'PluralReaderSelector':
            return observePluralSelector(environment, fragment, fragmentSelector);
    }
    invariant(false);
}
function observeSingularSelector(environment, fragmentNode, fragmentSelector) {
    var snapshot = environment.lookup(fragmentSelector);
    return Observable.create(function(sink) {
        sink.next(snapshotToFragmentState(environment, fragmentNode, fragmentSelector.owner, snapshot));
        var subscription = environment.subscribe(snapshot, function(nextSnapshot) {
            sink.next(snapshotToFragmentState(environment, fragmentNode, fragmentSelector.owner, nextSnapshot));
        });
        return function() {
            return subscription.dispose();
        };
    });
}
function observePluralSelector(environment, fragmentNode, fragmentSelector) {
    var snapshots = fragmentSelector.selectors.map(function(selector) {
        return environment.lookup(selector);
    });
    return Observable.create(function(sink) {
        var states = snapshots.map(function(snapshot, index) {
            return snapshotToFragmentState(environment, fragmentNode, fragmentSelector.selectors[index].owner, snapshot);
        });
        sink.next(mergeFragmentStates(states));
        var subscriptions = snapshots.map(function(snapshot, index) {
            return environment.subscribe(snapshot, function(latestSnapshot) {
                states[index] = snapshotToFragmentState(environment, fragmentNode, fragmentSelector.selectors[index].owner, latestSnapshot);
                sink.next(mergeFragmentStates(states));
            });
        });
        return function() {
            return subscriptions.forEach(function(subscription) {
                return subscription.dispose();
            });
        };
    });
}
function snapshotToFragmentState(environment, fragmentNode, owner, snapshot) {
    var missingLiveResolverFields = snapshot.missingLiveResolverFields != null && snapshot.missingLiveResolverFields.length > 0;
    var missingClientEdges = snapshot.missingClientEdges != null && snapshot.missingClientEdges.length > 0;
    if (missingLiveResolverFields || missingClientEdges) return {
        state: 'loading'
    };
    if (snapshot.isMissingData) {
        if (getObservableForActiveRequest(environment, owner) != null || environment.getOperationTracker().getPendingOperationsAffectingOwner(owner) != null) return {
            state: 'loading'
        };
    }
    try {
        handlePotentialSnapshotErrors(environment, snapshot.fieldErrors);
    } catch (error) {
        return {
            error: error,
            state: 'error'
        };
    }
    !(snapshot.data != null) && invariant(false);
    return {
        state: 'ok',
        value: snapshot.data
    };
}
function mergeFragmentStates(states) {
    var value = [];
    var _iterator = (0, _createForOfIteratorHelper2["default"])(states), _step;
    try {
        for(_iterator.s(); !(_step = _iterator.n()).done;){
            var state = _step.value;
            if (state.state === 'ok') value.push(state.value);
            else return state;
        }
    } catch (err) {
        _iterator.e(err);
    } finally{
        _iterator.f();
    }
    return {
        state: 'ok',
        value: value
    };
}
module.exports = {
    observeFragment: observeFragment,
    waitForFragmentData: waitForFragmentData
};

},{"a9f8abda96aa1ad5":"590td","4a3eb73bedab2e1f":"kHQRf","16c5d791f5673ef2":"fMaLa","11386da7f40c4c6e":"hYmcP","39c4a91637c9938e":"75uB6","25a8d3ddcf62633c":"8UTII","e941b1d3eb96fb16":"kq97W","26e4582e60a741d2":"9k2Dg","4269e0123344fc71":"e2sci"}],"kHQRf":[function(require,module,exports,__globalThis) {
function asyncGeneratorStep(n, t, e, r, o, a, c) {
    try {
        var i = n[a](c), u = i.value;
    } catch (n) {
        return void e(n);
    }
    i.done ? t(u) : Promise.resolve(u).then(r, o);
}
function _asyncToGenerator(n) {
    return function() {
        var t = this, e = arguments;
        return new Promise(function(r, o) {
            var a = n.apply(t, e);
            function _next(n) {
                asyncGeneratorStep(a, r, o, _next, _throw, "next", n);
            }
            function _throw(n) {
                asyncGeneratorStep(a, r, o, _next, _throw, "throw", n);
            }
            _next(void 0);
        });
    };
}
module.exports = _asyncToGenerator, module.exports.__esModule = true, module.exports["default"] = module.exports;

},{}],"hYmcP":[function(require,module,exports,__globalThis) {
'use strict';
var isPromise = require("622f95f90dce29ad");
var hostReportError = swallowError;
var RelayObservable = /*#__PURE__*/ function() {
    RelayObservable.create = function create(source) {
        return new RelayObservable(source);
    };
    function RelayObservable(source) {
        this._source = source;
    }
    RelayObservable.onUnhandledError = function onUnhandledError(callback) {
        hostReportError = callback;
    };
    RelayObservable.from = function from(obj) {
        return isObservable(obj) ? fromObservable(obj) : isPromise(obj) ? fromPromise(obj) : fromValue(obj);
    };
    var _proto = RelayObservable.prototype;
    _proto["catch"] = function _catch(fn) {
        var _this = this;
        return RelayObservable.create(function(sink) {
            var subscription;
            _this.subscribe({
                start: function start(sub) {
                    subscription = sub;
                },
                next: sink.next,
                complete: sink.complete,
                error: function error(_error2) {
                    try {
                        fn(_error2).subscribe({
                            start: function start(sub) {
                                subscription = sub;
                            },
                            next: sink.next,
                            complete: sink.complete,
                            error: sink.error
                        });
                    } catch (error2) {
                        sink.error(error2, true);
                    }
                }
            });
            return function() {
                return subscription.unsubscribe();
            };
        });
    };
    _proto.concat = function concat(next) {
        var _this2 = this;
        return RelayObservable.create(function(sink) {
            var current;
            _this2.subscribe({
                start: function start(subscription) {
                    current = subscription;
                },
                next: sink.next,
                error: sink.error,
                complete: function complete() {
                    current = next.subscribe(sink);
                }
            });
            return function() {
                current && current.unsubscribe();
            };
        });
    };
    _proto["do"] = function _do(observer) {
        var _this3 = this;
        return RelayObservable.create(function(sink) {
            var both = function both(action) {
                return function() {
                    try {
                        observer[action] && observer[action].apply(observer, arguments);
                    } catch (error) {
                        hostReportError(error, true);
                    }
                    sink[action] && sink[action].apply(sink, arguments);
                };
            };
            return _this3.subscribe({
                start: both('start'),
                next: both('next'),
                error: both('error'),
                complete: both('complete'),
                unsubscribe: both('unsubscribe')
            });
        });
    };
    _proto["finally"] = function _finally(fn) {
        var _this4 = this;
        return RelayObservable.create(function(sink) {
            var subscription = _this4.subscribe(sink);
            return function() {
                subscription.unsubscribe();
                fn();
            };
        });
    };
    _proto.ifEmpty = function ifEmpty(alternate) {
        var _this5 = this;
        return RelayObservable.create(function(sink) {
            var hasValue = false;
            var current;
            current = _this5.subscribe({
                next: function next(value) {
                    hasValue = true;
                    sink.next(value);
                },
                error: sink.error,
                complete: function complete() {
                    if (hasValue) sink.complete();
                    else current = alternate.subscribe(sink);
                }
            });
            return function() {
                current && current.unsubscribe();
            };
        });
    };
    _proto.subscribe = function subscribe(observer) {
        return _subscribe(this._source, observer);
    };
    _proto.map = function map(fn) {
        var _this6 = this;
        return RelayObservable.create(function(sink) {
            var subscription = _this6.subscribe({
                complete: sink.complete,
                error: sink.error,
                next: function next(value) {
                    try {
                        var mapValue = fn(value);
                        sink.next(mapValue);
                    } catch (error) {
                        sink.error(error, true);
                    }
                }
            });
            return function() {
                subscription.unsubscribe();
            };
        });
    };
    _proto.mergeMap = function mergeMap(fn) {
        var _this7 = this;
        return RelayObservable.create(function(sink) {
            var subscriptions = [];
            function start(subscription) {
                this._sub = subscription;
                subscriptions.push(subscription);
            }
            function complete() {
                subscriptions.splice(subscriptions.indexOf(this._sub), 1);
                if (subscriptions.length === 0) sink.complete();
            }
            _this7.subscribe({
                start: start,
                next: function next(value) {
                    try {
                        if (!sink.closed) RelayObservable.from(fn(value)).subscribe({
                            start: start,
                            next: sink.next,
                            error: sink.error,
                            complete: complete
                        });
                    } catch (error) {
                        sink.error(error, true);
                    }
                },
                error: sink.error,
                complete: complete
            });
            return function() {
                subscriptions.forEach(function(sub) {
                    return sub.unsubscribe();
                });
                subscriptions.length = 0;
            };
        });
    };
    _proto.poll = function poll(pollInterval) {
        var _this8 = this;
        return RelayObservable.create(function(sink) {
            var subscription;
            var timeout;
            var poll = function poll() {
                subscription = _this8.subscribe({
                    next: sink.next,
                    error: sink.error,
                    complete: function complete() {
                        timeout = setTimeout(poll, pollInterval);
                    }
                });
            };
            poll();
            return function() {
                clearTimeout(timeout);
                subscription.unsubscribe();
            };
        });
    };
    _proto.toPromise = function toPromise() {
        var _this9 = this;
        return new Promise(function(resolve, reject) {
            var resolved = false;
            _this9.subscribe({
                next: function next(val) {
                    if (!resolved) {
                        resolved = true;
                        resolve(val);
                    }
                },
                error: reject,
                complete: resolve
            });
        });
    };
    return RelayObservable;
}();
function isObservable(obj) {
    return typeof obj === 'object' && obj !== null && typeof obj.subscribe === 'function';
}
function fromObservable(obj) {
    return obj instanceof RelayObservable ? obj : RelayObservable.create(function(sink) {
        return obj.subscribe(sink);
    });
}
function fromPromise(promise) {
    return RelayObservable.create(function(sink) {
        promise.then(function(value) {
            sink.next(value);
            sink.complete();
        }, sink.error);
    });
}
function fromValue(value) {
    return RelayObservable.create(function(sink) {
        sink.next(value);
        sink.complete();
    });
}
function _subscribe(source, observer) {
    var closed = false;
    var cleanup;
    var withClosed = function withClosed(obj) {
        return Object.defineProperty(obj, 'closed', {
            get: function get() {
                return closed;
            }
        });
    };
    function doCleanup() {
        if (cleanup) {
            if (cleanup.unsubscribe) cleanup.unsubscribe();
            else try {
                cleanup();
            } catch (error) {
                hostReportError(error, true);
            }
            cleanup = undefined;
        }
    }
    var subscription = withClosed({
        unsubscribe: function unsubscribe() {
            if (!closed) {
                closed = true;
                try {
                    observer.unsubscribe && observer.unsubscribe(subscription);
                } catch (error) {
                    hostReportError(error, true);
                } finally{
                    doCleanup();
                }
            }
        }
    });
    try {
        observer.start && observer.start(subscription);
    } catch (error) {
        hostReportError(error, true);
    }
    if (closed) return subscription;
    var sink = withClosed({
        next: function next(value) {
            if (!closed && observer.next) try {
                observer.next(value);
            } catch (error) {
                hostReportError(error, true);
            }
        },
        error: function error(_error3, isUncaughtThrownError) {
            if (closed || !observer.error) {
                closed = true;
                hostReportError(_error3, isUncaughtThrownError || false);
                doCleanup();
            } else {
                closed = true;
                try {
                    observer.error(_error3);
                } catch (error2) {
                    hostReportError(error2, true);
                } finally{
                    doCleanup();
                }
            }
        },
        complete: function complete() {
            if (!closed) {
                closed = true;
                try {
                    observer.complete && observer.complete();
                } catch (error) {
                    hostReportError(error, true);
                } finally{
                    doCleanup();
                }
            }
        }
    });
    try {
        cleanup = source(sink);
    } catch (error) {
        sink.error(error, true);
    }
    if (closed) doCleanup();
    return subscription;
}
function swallowError(_error, _isUncaughtThrownError) {}
module.exports = RelayObservable;

},{"622f95f90dce29ad":"8csDP"}],"8csDP":[function(require,module,exports,__globalThis) {
'use strict';
function isPromise(p) {
    return p != null && typeof p === 'object' && typeof p.then === 'function';
}
module.exports = isPromise;

},{}],"75uB6":[function(require,module,exports,__globalThis) {
'use strict';
var Observable = require("2163e36dd1f6930c");
var RelayReplaySubject = require("582da384b4907e4b");
var invariant = require("25145deae6b53917");
var WEAKMAP_SUPPORTED = typeof WeakMap === 'function';
var requestCachesByEnvironment = WEAKMAP_SUPPORTED ? new WeakMap() : new Map();
function fetchQuery(environment, operation) {
    return fetchQueryDeduped(environment, operation.request.identifier, function() {
        return environment.execute({
            operation: operation
        });
    });
}
function fetchQueryDeduped(environment, identifier, fetchFn) {
    return Observable.create(function(sink) {
        var requestCache = getRequestCache(environment);
        var cachedRequest = requestCache.get(identifier);
        if (!cachedRequest) fetchFn()["finally"](function() {
            return requestCache["delete"](identifier);
        }).subscribe({
            start: function start(subscription) {
                cachedRequest = {
                    identifier: identifier,
                    subject: new RelayReplaySubject(),
                    subjectForInFlightStatus: new RelayReplaySubject(),
                    subscription: subscription,
                    promise: null
                };
                requestCache.set(identifier, cachedRequest);
            },
            next: function next(response) {
                var cachedReq = getCachedRequest(requestCache, identifier);
                cachedReq.subject.next(response);
                cachedReq.subjectForInFlightStatus.next(response);
            },
            error: function error(_error) {
                var cachedReq = getCachedRequest(requestCache, identifier);
                cachedReq.subject.error(_error);
                cachedReq.subjectForInFlightStatus.error(_error);
            },
            complete: function complete() {
                var cachedReq = getCachedRequest(requestCache, identifier);
                cachedReq.subject.complete();
                cachedReq.subjectForInFlightStatus.complete();
            },
            unsubscribe: function unsubscribe(subscription) {
                var cachedReq = getCachedRequest(requestCache, identifier);
                cachedReq.subject.unsubscribe();
                cachedReq.subjectForInFlightStatus.unsubscribe();
            }
        });
        !(cachedRequest != null) && invariant(false);
        return getObservableForCachedRequest(requestCache, cachedRequest).subscribe(sink);
    });
}
function getObservableForCachedRequest(requestCache, cachedRequest) {
    return Observable.create(function(sink) {
        var subscription = cachedRequest.subject.subscribe(sink);
        return function() {
            subscription.unsubscribe();
            var cachedRequestInstance = requestCache.get(cachedRequest.identifier);
            if (cachedRequestInstance) {
                var requestSubscription = cachedRequestInstance.subscription;
                if (requestSubscription != null && cachedRequestInstance.subject.getObserverCount() === 0) {
                    requestSubscription.unsubscribe();
                    requestCache["delete"](cachedRequest.identifier);
                }
            }
        };
    });
}
function getActiveStatusObservableForCachedRequest(environment, requestCache, cachedRequest) {
    return Observable.create(function(sink) {
        var subscription = cachedRequest.subjectForInFlightStatus.subscribe({
            error: sink.error,
            next: function next(response) {
                if (!environment.isRequestActive(cachedRequest.identifier)) {
                    sink.complete();
                    return;
                }
                sink.next();
            },
            complete: sink.complete,
            unsubscribe: sink.complete
        });
        return function() {
            subscription.unsubscribe();
        };
    });
}
function getPromiseForActiveRequest(environment, request) {
    var requestCache = getRequestCache(environment);
    var cachedRequest = requestCache.get(request.identifier);
    if (!cachedRequest) return null;
    if (!environment.isRequestActive(cachedRequest.identifier)) return null;
    var promise = new Promise(function(resolve, reject) {
        var resolveOnNext = false;
        getActiveStatusObservableForCachedRequest(environment, requestCache, cachedRequest).subscribe({
            complete: resolve,
            error: reject,
            next: function next(response) {
                if (resolveOnNext) resolve(response);
            }
        });
        resolveOnNext = true;
    });
    return promise;
}
function getObservableForActiveRequest(environment, request) {
    var requestCache = getRequestCache(environment);
    var cachedRequest = requestCache.get(request.identifier);
    if (!cachedRequest) return null;
    if (!environment.isRequestActive(cachedRequest.identifier)) return null;
    return getActiveStatusObservableForCachedRequest(environment, requestCache, cachedRequest);
}
function getRequestCache(environment) {
    var cached = requestCachesByEnvironment.get(environment);
    if (cached != null) return cached;
    var requestCache = new Map();
    requestCachesByEnvironment.set(environment, requestCache);
    return requestCache;
}
function getCachedRequest(requestCache, identifier) {
    var cached = requestCache.get(identifier);
    !(cached != null) && invariant(false);
    return cached;
}
module.exports = {
    fetchQuery: fetchQuery,
    fetchQueryDeduped: fetchQueryDeduped,
    getPromiseForActiveRequest: getPromiseForActiveRequest,
    getObservableForActiveRequest: getObservableForActiveRequest
};

},{"2163e36dd1f6930c":"hYmcP","582da384b4907e4b":"8ePJJ","25145deae6b53917":"e2sci"}],"8ePJJ":[function(require,module,exports,__globalThis) {
'use strict';
var _interopRequireDefault = require("1433172d09a9782e")["default"];
var _createForOfIteratorHelper2 = _interopRequireDefault(require("91e07a75a158d2ed"));
var _defineProperty2 = _interopRequireDefault(require("ea69697b96222e9e"));
var RelayObservable = require("5eecab5c47ccc0f");
var invariant = require("841bc2545ed06ce1");
var RelayReplaySubject = /*#__PURE__*/ function() {
    function RelayReplaySubject() {
        var _this = this;
        (0, _defineProperty2["default"])(this, "_complete", false);
        (0, _defineProperty2["default"])(this, "_events", []);
        (0, _defineProperty2["default"])(this, "_sinks", new Set());
        (0, _defineProperty2["default"])(this, "_subscription", []);
        this._observable = RelayObservable.create(function(sink) {
            _this._sinks.add(sink);
            var events = _this._events;
            for(var i = 0; i < events.length; i++){
                if (sink.closed) break;
                var event = events[i];
                switch(event.kind){
                    case 'complete':
                        sink.complete();
                        break;
                    case 'error':
                        sink.error(event.error);
                        break;
                    case 'next':
                        sink.next(event.data);
                        break;
                    default:
                        event.kind;
                        invariant(false);
                }
            }
            return function() {
                _this._sinks["delete"](sink);
            };
        });
    }
    var _proto = RelayReplaySubject.prototype;
    _proto.complete = function complete() {
        if (this._complete === true) return;
        this._complete = true;
        this._events.push({
            kind: 'complete'
        });
        this._sinks.forEach(function(sink) {
            return sink.complete();
        });
    };
    _proto.error = function error(_error) {
        if (this._complete === true) return;
        this._complete = true;
        this._events.push({
            kind: 'error',
            error: _error
        });
        this._sinks.forEach(function(sink) {
            return sink.error(_error);
        });
    };
    _proto.next = function next(data) {
        if (this._complete === true) return;
        this._events.push({
            kind: 'next',
            data: data
        });
        this._sinks.forEach(function(sink) {
            return sink.next(data);
        });
    };
    _proto.subscribe = function subscribe(observer) {
        var subscription = this._observable.subscribe(observer);
        this._subscription.push(subscription);
        return subscription;
    };
    _proto.unsubscribe = function unsubscribe() {
        var _iterator = (0, _createForOfIteratorHelper2["default"])(this._subscription), _step;
        try {
            for(_iterator.s(); !(_step = _iterator.n()).done;){
                var subscription = _step.value;
                subscription.unsubscribe();
            }
        } catch (err) {
            _iterator.e(err);
        } finally{
            _iterator.f();
        }
        this._subscription = [];
    };
    _proto.getObserverCount = function getObserverCount() {
        return this._sinks.size;
    };
    return RelayReplaySubject;
}();
module.exports = RelayReplaySubject;

},{"1433172d09a9782e":"590td","91e07a75a158d2ed":"fMaLa","ea69697b96222e9e":"2paQ8","5eecab5c47ccc0f":"hYmcP","841bc2545ed06ce1":"e2sci"}],"631vm":[function(require,module,exports,__globalThis) {
'use strict';
var _interopRequireDefault = require("6c408e18ff57cab9")["default"];
var _defineProperty2 = _interopRequireDefault(require("6078c703422065dc"));
var _require = require("69dd318453cc5f2a"), observeFragment = _require.observeFragment;
var _require2 = require("d7196abdcf137d97"), createOperationDescriptor = _require2.createOperationDescriptor;
function observeQuery(environment, gqlQuery, variables) {
    var operation = createOperationDescriptor(gqlQuery, variables);
    var rootFragmentRef = {
        __id: operation.fragment.dataID,
        __fragments: (0, _defineProperty2["default"])({}, operation.fragment.node.name, operation.request.variables),
        __fragmentOwner: operation.request
    };
    var fragmentNode = operation.request.node.fragment;
    return observeFragment(environment, fragmentNode, rootFragmentRef);
}
module.exports = {
    observeQuery: observeQuery
};

},{"6c408e18ff57cab9":"590td","6078c703422065dc":"2paQ8","69dd318453cc5f2a":"lRP4u","d7196abdcf137d97":"dSeB3"}],"dSeB3":[function(require,module,exports,__globalThis) {
'use strict';
var deepFreeze = require("653e57175c1c4351");
var getRequestIdentifier = require("1110d9e24d3b7949");
var RelayFeatureFlags = require("e95d474c89fd961");
var _require = require("71ded777b9f42107"), hasCycle = _require.hasCycle;
var _require2 = require("cf874f98c5766775"), getOperationVariables = _require2.getOperationVariables;
var _require3 = require("29b660c3c915ce16"), createNormalizationSelector = _require3.createNormalizationSelector, createReaderSelector = _require3.createReaderSelector;
var _require4 = require("9113d30cba7df03c"), ROOT_ID = _require4.ROOT_ID;
var invariant = require("cc2c8d74bfd1a062");
function createOperationDescriptor(request, variables, cacheConfig) {
    var dataID = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : ROOT_ID;
    var operation = request.operation;
    var operationVariables = getOperationVariables(operation, request.params.providedVariables, variables);
    if (RelayFeatureFlags.ENABLE_CYLE_DETECTION_IN_VARIABLES) !!hasCycle(operationVariables) && invariant(false);
    var requestDescriptor = createRequestDescriptor(request, operationVariables, cacheConfig);
    var operationDescriptor = {
        fragment: createReaderSelector(request.fragment, dataID, operationVariables, requestDescriptor),
        request: requestDescriptor,
        root: createNormalizationSelector(operation, dataID, operationVariables)
    };
    return operationDescriptor;
}
function createRequestDescriptor(request, variables, cacheConfig) {
    var requestDescriptor = {
        identifier: getRequestIdentifier(request.params, variables),
        node: request,
        variables: variables,
        cacheConfig: cacheConfig
    };
    return requestDescriptor;
}
module.exports = {
    createOperationDescriptor: createOperationDescriptor,
    createRequestDescriptor: createRequestDescriptor
};

},{"653e57175c1c4351":"eLea7","1110d9e24d3b7949":"h3zzW","e95d474c89fd961":"a0FL5","71ded777b9f42107":"c3NLR","cf874f98c5766775":"138Hd","29b660c3c915ce16":"9k2Dg","9113d30cba7df03c":"3QcrW","cc2c8d74bfd1a062":"e2sci"}],"eLea7":[function(require,module,exports,__globalThis) {
'use strict';
function deepFreeze(object) {
    if (!shouldBeFrozen(object)) return object;
    Object.freeze(object);
    Object.getOwnPropertyNames(object).forEach(function(name) {
        var property = object[name];
        if (property && typeof property === 'object' && !Object.isFrozen(property)) deepFreeze(property);
    });
    return object;
}
function shouldBeFrozen(value) {
    return value != null && (Array.isArray(value) || typeof value === 'object' && value.constructor === Object);
}
module.exports = deepFreeze;

},{}],"h3zzW":[function(require,module,exports,__globalThis) {
'use strict';
var _require = require("7af3034ed811f4af"), stableCopy = _require.stableCopy;
var invariant = require("7bb20374905c2d7d");
function getRequestIdentifier(parameters, variables) {
    var requestID = parameters.cacheID != null ? parameters.cacheID : parameters.id;
    !(requestID != null) && invariant(false);
    return requestID + JSON.stringify(stableCopy(variables));
}
module.exports = getRequestIdentifier;

},{"7af3034ed811f4af":"c3NLR","7bb20374905c2d7d":"e2sci"}],"iZeEE":[function(require,module,exports,__globalThis) {
"use strict";
var _asyncToGenerator = require("64a73eed5cad2b6a").default;
var _require = require("5ae02964ccce712"), observeFragment = _require.observeFragment;
function waitForFragmentData(_x, _x2, _x3) {
    return _waitForFragmentData.apply(this, arguments);
}
function _waitForFragmentData() {
    _waitForFragmentData = _asyncToGenerator(function*(environment, fragment, fragmentRef) {
        var subscription;
        try {
            var _subscription;
            var data = yield new Promise(function(resolve, reject) {
                subscription = observeFragment(environment, fragment, fragmentRef).subscribe({
                    next: function next(val) {
                        if (val.state === 'ok') resolve(val.value);
                        else if (val.state === 'error') reject(val.error);
                    }
                });
            });
            (_subscription = subscription) === null || _subscription === void 0 || _subscription.unsubscribe();
            return data;
        } catch (e) {
            var _subscription2;
            (_subscription2 = subscription) === null || _subscription2 === void 0 || _subscription2.unsubscribe();
            throw e;
        }
    });
    return _waitForFragmentData.apply(this, arguments);
}
module.exports = {
    waitForFragmentData: waitForFragmentData
};

},{"64a73eed5cad2b6a":"kHQRf","5ae02964ccce712":"lRP4u"}],"ccBOd":[function(require,module,exports,__globalThis) {
'use strict';
var _require = require("60e01bbce22327e7"), generateClientID = _require.generateClientID;
var _require2 = require("7c959de913c78b67"), getStableStorageKey = _require2.getStableStorageKey;
var getRelayHandleKey = require("4cdb8a1175ec60a0");
var ConnectionInterface = require("7d8f562c63fa1740");
var invariant = require("d275f1a0937a36df");
var warning = require("7e269e3fc97eb8c8");
var CONNECTION = 'connection';
var NEXT_EDGE_INDEX = '__connection_next_edge_index';
function update(store, payload) {
    var record = store.get(payload.dataID);
    if (!record) return;
    var _ConnectionInterface$ = ConnectionInterface.get(), EDGES = _ConnectionInterface$.EDGES, END_CURSOR = _ConnectionInterface$.END_CURSOR, HAS_NEXT_PAGE = _ConnectionInterface$.HAS_NEXT_PAGE, HAS_PREV_PAGE = _ConnectionInterface$.HAS_PREV_PAGE, PAGE_INFO = _ConnectionInterface$.PAGE_INFO, PAGE_INFO_TYPE = _ConnectionInterface$.PAGE_INFO_TYPE, START_CURSOR = _ConnectionInterface$.START_CURSOR;
    var serverConnection = record.getLinkedRecord(payload.fieldKey);
    var serverPageInfo = serverConnection && serverConnection.getLinkedRecord(PAGE_INFO);
    if (!serverConnection) {
        record.setValue(null, payload.handleKey, undefined, record.getErrors(payload.fieldKey));
        return;
    }
    var clientConnectionID = generateClientID(record.getDataID(), payload.handleKey);
    var clientConnectionField = record.getLinkedRecord(payload.handleKey);
    var clientConnection = clientConnectionField !== null && clientConnectionField !== void 0 ? clientConnectionField : store.get(clientConnectionID);
    var clientPageInfo = clientConnection && clientConnection.getLinkedRecord(PAGE_INFO);
    if (!clientConnection) {
        var connection = store.create(clientConnectionID, serverConnection.getType());
        connection.setValue(0, NEXT_EDGE_INDEX);
        connection.copyFieldsFrom(serverConnection);
        var serverEdges = serverConnection.getLinkedRecords(EDGES);
        if (serverEdges) {
            serverEdges = serverEdges.map(function(edge) {
                return buildConnectionEdge(store, connection, edge);
            });
            connection.setLinkedRecords(serverEdges, EDGES);
        }
        record.setLinkedRecord(connection, payload.handleKey);
        clientPageInfo = store.create(generateClientID(connection.getDataID(), PAGE_INFO), PAGE_INFO_TYPE);
        clientPageInfo.setValue(false, HAS_NEXT_PAGE);
        clientPageInfo.setValue(false, HAS_PREV_PAGE);
        clientPageInfo.setValue(null, END_CURSOR);
        clientPageInfo.setValue(null, START_CURSOR);
        if (serverPageInfo) clientPageInfo.copyFieldsFrom(serverPageInfo);
        connection.setLinkedRecord(clientPageInfo, PAGE_INFO);
    } else {
        if (clientConnectionField == null) record.setLinkedRecord(clientConnection, payload.handleKey);
        var _connection = clientConnection;
        var _serverEdges = serverConnection.getLinkedRecords(EDGES);
        if (_serverEdges) _serverEdges = _serverEdges.map(function(edge) {
            return buildConnectionEdge(store, _connection, edge);
        });
        var prevEdges = _connection.getLinkedRecords(EDGES);
        var prevPageInfo = _connection.getLinkedRecord(PAGE_INFO);
        _connection.copyFieldsFrom(serverConnection);
        if (prevEdges) _connection.setLinkedRecords(prevEdges, EDGES);
        if (prevPageInfo) _connection.setLinkedRecord(prevPageInfo, PAGE_INFO);
        var nextEdges = [];
        var args = payload.args;
        if (prevEdges && _serverEdges) {
            if (args.after != null) {
                var _clientPageInfo;
                var clientEndCursor = (_clientPageInfo = clientPageInfo) === null || _clientPageInfo === void 0 ? void 0 : _clientPageInfo.getValue(END_CURSOR);
                var serverEndCursor = serverPageInfo === null || serverPageInfo === void 0 ? void 0 : serverPageInfo.getValue(END_CURSOR);
                var isAddingEdgesAfterCurrentPage = clientPageInfo && args.after === clientEndCursor;
                var isFillingOutCurrentPage = clientPageInfo && clientEndCursor === serverEndCursor;
                if (isAddingEdgesAfterCurrentPage || isFillingOutCurrentPage) {
                    var nodeIDs = new Set();
                    mergeEdges(prevEdges, nextEdges, nodeIDs);
                    mergeEdges(_serverEdges, nextEdges, nodeIDs);
                } else return;
            } else if (args.before != null) {
                if (clientPageInfo && args.before === clientPageInfo.getValue(START_CURSOR)) {
                    var _nodeIDs = new Set();
                    mergeEdges(_serverEdges, nextEdges, _nodeIDs);
                    mergeEdges(prevEdges, nextEdges, _nodeIDs);
                } else return;
            } else nextEdges = _serverEdges;
        } else if (_serverEdges) nextEdges = _serverEdges;
        else nextEdges = prevEdges;
        if (nextEdges != null && nextEdges !== prevEdges) _connection.setLinkedRecords(nextEdges, EDGES);
        if (clientPageInfo && serverPageInfo) {
            if (args.after == null && args.before == null) clientPageInfo.copyFieldsFrom(serverPageInfo);
            else if (args.before != null || args.after == null && args.last) {
                clientPageInfo.setValue(!!serverPageInfo.getValue(HAS_PREV_PAGE), HAS_PREV_PAGE);
                var startCursor = serverPageInfo.getValue(START_CURSOR);
                if (typeof startCursor === 'string') clientPageInfo.setValue(startCursor, START_CURSOR);
            } else if (args.after != null || args.before == null && args.first) {
                clientPageInfo.setValue(!!serverPageInfo.getValue(HAS_NEXT_PAGE), HAS_NEXT_PAGE);
                var endCursor = serverPageInfo.getValue(END_CURSOR);
                if (typeof endCursor === 'string') clientPageInfo.setValue(endCursor, END_CURSOR);
            }
        }
    }
}
function getConnection(record, key, filters) {
    var handleKey = getRelayHandleKey(CONNECTION, key, null);
    return record.getLinkedRecord(handleKey, filters);
}
function getConnectionID(recordID, key, filters) {
    var handleKey = getRelayHandleKey(CONNECTION, key, null);
    var storageKey = getStableStorageKey(handleKey, filters);
    return generateClientID(recordID, storageKey);
}
function insertEdgeAfter(record, newEdge, cursor) {
    var _ConnectionInterface$2 = ConnectionInterface.get(), CURSOR = _ConnectionInterface$2.CURSOR, EDGES = _ConnectionInterface$2.EDGES;
    var edges = record.getLinkedRecords(EDGES);
    if (!edges) {
        record.setLinkedRecords([
            newEdge
        ], EDGES);
        return;
    }
    var nextEdges;
    if (cursor == null) nextEdges = edges.concat(newEdge);
    else {
        nextEdges = [];
        var foundCursor = false;
        for(var ii = 0; ii < edges.length; ii++){
            var edge = edges[ii];
            nextEdges.push(edge);
            if (edge == null) continue;
            var edgeCursor = edge.getValue(CURSOR);
            if (cursor === edgeCursor) {
                nextEdges.push(newEdge);
                foundCursor = true;
            }
        }
        if (!foundCursor) nextEdges.push(newEdge);
    }
    record.setLinkedRecords(nextEdges, EDGES);
}
function createEdge(store, record, node, edgeType) {
    var _ConnectionInterface$3 = ConnectionInterface.get(), NODE = _ConnectionInterface$3.NODE;
    var edgeID = generateClientID(record.getDataID(), node.getDataID());
    var edge = store.get(edgeID);
    if (!edge) edge = store.create(edgeID, edgeType);
    edge.setLinkedRecord(node, NODE);
    if (edge.getValue('cursor') == null) edge.setValue(null, 'cursor');
    return edge;
}
function insertEdgeBefore(record, newEdge, cursor) {
    var _ConnectionInterface$4 = ConnectionInterface.get(), CURSOR = _ConnectionInterface$4.CURSOR, EDGES = _ConnectionInterface$4.EDGES;
    var edges = record.getLinkedRecords(EDGES);
    if (!edges) {
        record.setLinkedRecords([
            newEdge
        ], EDGES);
        return;
    }
    var nextEdges;
    if (cursor == null) nextEdges = [
        newEdge
    ].concat(edges);
    else {
        nextEdges = [];
        var foundCursor = false;
        for(var ii = 0; ii < edges.length; ii++){
            var edge = edges[ii];
            if (edge != null) {
                var edgeCursor = edge.getValue(CURSOR);
                if (cursor === edgeCursor) {
                    nextEdges.push(newEdge);
                    foundCursor = true;
                }
            }
            nextEdges.push(edge);
        }
        if (!foundCursor) nextEdges.unshift(newEdge);
    }
    record.setLinkedRecords(nextEdges, EDGES);
}
function deleteNode(record, nodeID) {
    var _ConnectionInterface$5 = ConnectionInterface.get(), EDGES = _ConnectionInterface$5.EDGES, NODE = _ConnectionInterface$5.NODE;
    var edges = record.getLinkedRecords(EDGES);
    if (!edges) return;
    var nextEdges;
    for(var ii = 0; ii < edges.length; ii++){
        var edge = edges[ii];
        var node = edge && edge.getLinkedRecord(NODE);
        if (node != null && node.getDataID() === nodeID) {
            if (nextEdges === undefined) nextEdges = edges.slice(0, ii);
        } else if (nextEdges !== undefined) nextEdges.push(edge);
    }
    if (nextEdges !== undefined) record.setLinkedRecords(nextEdges, EDGES);
}
function buildConnectionEdge(store, connection, edge) {
    if (edge == null) return edge;
    var _ConnectionInterface$6 = ConnectionInterface.get(), EDGES = _ConnectionInterface$6.EDGES;
    var edgeIndex = connection.getValue(NEXT_EDGE_INDEX);
    !(typeof edgeIndex === 'number') && invariant(false);
    var edgeID = generateClientID(connection.getDataID(), EDGES, edgeIndex);
    var connectionEdge = store.create(edgeID, edge.getType());
    connectionEdge.copyFieldsFrom(edge);
    if (connectionEdge.getValue('cursor') == null) connectionEdge.setValue(null, 'cursor');
    connection.setValue(edgeIndex + 1, NEXT_EDGE_INDEX);
    return connectionEdge;
}
function mergeEdges(sourceEdges, targetEdges, nodeIDs) {
    var _ConnectionInterface$7 = ConnectionInterface.get(), NODE = _ConnectionInterface$7.NODE;
    for(var ii = 0; ii < sourceEdges.length; ii++){
        var edge = sourceEdges[ii];
        if (!edge) continue;
        var node = edge.getLinkedRecord(NODE);
        var nodeID = node && node.getDataID();
        if (nodeID) {
            if (nodeIDs.has(nodeID)) continue;
            nodeIDs.add(nodeID);
        }
        targetEdges.push(edge);
    }
}
module.exports = {
    buildConnectionEdge: buildConnectionEdge,
    createEdge: createEdge,
    deleteNode: deleteNode,
    getConnection: getConnection,
    getConnectionID: getConnectionID,
    insertEdgeAfter: insertEdgeAfter,
    insertEdgeBefore: insertEdgeBefore,
    update: update
};

},{"60e01bbce22327e7":"gL1rB","7c959de913c78b67":"3QcrW","4cdb8a1175ec60a0":"etrZd","7d8f562c63fa1740":"dTLQR","d275f1a0937a36df":"e2sci","7e269e3fc97eb8c8":"j64TH"}],"gL1rB":[function(require,module,exports,__globalThis) {
'use strict';
var RelayFeatureFlags = require("85e38f231a95ca06");
var _require = require("5e0db616cadc2e46"), intern = _require.intern;
var PREFIX = 'client:';
function generateClientID(id, storageKey, index) {
    var internedId = RelayFeatureFlags.STRING_INTERN_LEVEL <= 0 ? id : intern(id, RelayFeatureFlags.MAX_DATA_ID_LENGTH);
    var key = internedId + ':' + storageKey;
    if (index != null) key += ':' + index;
    if (key.indexOf(PREFIX) !== 0) key = PREFIX + key;
    return key;
}
function isClientID(id) {
    return id.indexOf(PREFIX) === 0;
}
var localID = 0;
function generateUniqueClientID() {
    return "".concat(PREFIX, "local:").concat(localID++);
}
function generateClientObjectClientID(typename, localId, index) {
    var key = "".concat(PREFIX).concat(typename, ":").concat(localId);
    if (index != null) key += ':' + index;
    return key;
}
module.exports = {
    generateClientID: generateClientID,
    generateClientObjectClientID: generateClientObjectClientID,
    generateUniqueClientID: generateUniqueClientID,
    isClientID: isClientID
};

},{"85e38f231a95ca06":"a0FL5","5e0db616cadc2e46":"3S1QY"}],"3S1QY":[function(require,module,exports,__globalThis) {
'use strict';
var internTable = new Map();
var nextIndex = 1;
var digits = initDigitTable();
var INTERN_PREFIX = '\t';
var ESCAPE_PREFIX = '\v';
function initDigitTable() {
    var digits = new Set();
    for(var i = 0; i < 10; ++i)digits.add(i.toString());
    return digits;
}
function escape(str) {
    if (str[0] === INTERN_PREFIX && digits.has(str[1]) || str[0] === ESCAPE_PREFIX) return ESCAPE_PREFIX + str;
    return str;
}
function intern(str, limit) {
    if (limit == null || str.length < limit) return escape(str);
    var internedString = internTable.get(str);
    if (internedString != null) return internedString;
    internedString = INTERN_PREFIX + nextIndex++;
    internTable.set(str, internedString);
    return internedString;
}
module.exports = {
    intern: intern
};

},{}],"dTLQR":[function(require,module,exports,__globalThis) {
'use strict';
var CONNECTION_CALLS = {
    after: true,
    before: true,
    find: true,
    first: true,
    last: true,
    surrounds: true
};
var config = {
    CURSOR: 'cursor',
    EDGES: 'edges',
    END_CURSOR: 'endCursor',
    HAS_NEXT_PAGE: 'hasNextPage',
    HAS_PREV_PAGE: 'hasPreviousPage',
    NODE: 'node',
    PAGE_INFO_TYPE: 'PageInfo',
    PAGE_INFO: 'pageInfo',
    START_CURSOR: 'startCursor'
};
var ConnectionInterface = {
    inject: function inject(newConfig) {
        config = newConfig;
    },
    get: function get() {
        return config;
    },
    isConnectionCall: function isConnectionCall(call) {
        return CONNECTION_CALLS.hasOwnProperty(call.name);
    }
};
module.exports = ConnectionInterface;

},{}],"egZkc":[function(require,module,exports,__globalThis) {
'use strict';
var _interopRequireDefault = require("d03d157df1d0d577")["default"];
var _createForOfIteratorHelper2 = _interopRequireDefault(require("96c1c2c1aed03328"));
var ConnectionHandler = require("eee31943aaa350cd");
var ConnectionInterface = require("b5bc3a6bee25ed35");
var invariant = require("16aa9c711c3df27");
var warning = require("2a351171c9e5f420");
var DeleteRecordHandler = {
    update: function update(store, payload) {
        var record = store.get(payload.dataID);
        if (record != null) {
            var idOrIds = record.getValue(payload.fieldKey);
            if (typeof idOrIds === 'string') store["delete"](idOrIds);
            else if (Array.isArray(idOrIds)) idOrIds.forEach(function(id) {
                if (typeof id === 'string') store["delete"](id);
            });
        }
    }
};
var DeleteEdgeHandler = {
    update: function update(store, payload) {
        var record = store.get(payload.dataID);
        if (record == null) return;
        var connections = payload.handleArgs.connections;
        !(connections != null) && invariant(false);
        var idOrIds = record.getValue(payload.fieldKey);
        var idList = Array.isArray(idOrIds) ? idOrIds : [
            idOrIds
        ];
        idList.forEach(function(id) {
            if (typeof id === 'string') {
                var _iterator = (0, _createForOfIteratorHelper2["default"])(connections), _step;
                try {
                    for(_iterator.s(); !(_step = _iterator.n()).done;){
                        var connectionID = _step.value;
                        var connection = store.get(connectionID);
                        if (connection == null) continue;
                        ConnectionHandler.deleteNode(connection, id);
                    }
                } catch (err) {
                    _iterator.e(err);
                } finally{
                    _iterator.f();
                }
            }
        });
    }
};
var AppendEdgeHandler = {
    update: edgeUpdater(ConnectionHandler.insertEdgeAfter)
};
var PrependEdgeHandler = {
    update: edgeUpdater(ConnectionHandler.insertEdgeBefore)
};
var AppendNodeHandler = {
    update: nodeUpdater(ConnectionHandler.insertEdgeAfter)
};
var PrependNodeHandler = {
    update: nodeUpdater(ConnectionHandler.insertEdgeBefore)
};
function edgeUpdater(insertFn) {
    return function(store, payload) {
        var _serverEdges;
        var record = store.get(payload.dataID);
        if (record == null) return;
        var connections = payload.handleArgs.connections;
        !(connections != null) && invariant(false);
        var singleServerEdge, serverEdges;
        try {
            singleServerEdge = record.getLinkedRecord(payload.fieldKey);
        } catch (_unused) {}
        if (!singleServerEdge) try {
            serverEdges = record.getLinkedRecords(payload.fieldKey);
        } catch (_unused2) {}
        if (singleServerEdge == null && serverEdges == null) return;
        var _ConnectionInterface$ = ConnectionInterface.get(), NODE = _ConnectionInterface$.NODE, EDGES = _ConnectionInterface$.EDGES;
        var serverEdgeList = (_serverEdges = serverEdges) !== null && _serverEdges !== void 0 ? _serverEdges : [
            singleServerEdge
        ];
        var _iterator2 = (0, _createForOfIteratorHelper2["default"])(serverEdgeList), _step2;
        try {
            var _loop = function _loop() {
                var serverEdge = _step2.value;
                if (serverEdge == null) return "continue";
                var serverNode = serverEdge.getLinkedRecord('node');
                if (!serverNode) return "continue";
                var serverNodeId = serverNode.getDataID();
                var _iterator3 = (0, _createForOfIteratorHelper2["default"])(connections), _step3;
                try {
                    for(_iterator3.s(); !(_step3 = _iterator3.n()).done;){
                        var connectionID = _step3.value;
                        var connection = store.get(connectionID);
                        if (connection == null) continue;
                        var nodeAlreadyExistsInConnection = (_connection$getLinked = connection.getLinkedRecords(EDGES)) === null || _connection$getLinked === void 0 ? void 0 : _connection$getLinked.some(function(edge) {
                            var _edge$getLinkedRecord;
                            return (edge === null || edge === void 0 ? void 0 : (_edge$getLinkedRecord = edge.getLinkedRecord(NODE)) === null || _edge$getLinkedRecord === void 0 ? void 0 : _edge$getLinkedRecord.getDataID()) === serverNodeId;
                        });
                        if (nodeAlreadyExistsInConnection) continue;
                        var clientEdge = ConnectionHandler.buildConnectionEdge(store, connection, serverEdge);
                        !(clientEdge != null) && invariant(false);
                        insertFn(connection, clientEdge);
                    }
                } catch (err) {
                    _iterator3.e(err);
                } finally{
                    _iterator3.f();
                }
            };
            for(_iterator2.s(); !(_step2 = _iterator2.n()).done;){
                var _connection$getLinked;
                var _ret = _loop();
                if (_ret === "continue") continue;
            }
        } catch (err) {
            _iterator2.e(err);
        } finally{
            _iterator2.f();
        }
    };
}
function nodeUpdater(insertFn) {
    return function(store, payload) {
        var _serverNodes;
        var record = store.get(payload.dataID);
        if (record == null) return;
        var _payload$handleArgs = payload.handleArgs, connections = _payload$handleArgs.connections, edgeTypeName = _payload$handleArgs.edgeTypeName;
        !(connections != null) && invariant(false);
        !(edgeTypeName != null) && invariant(false);
        var singleServerNode;
        var serverNodes;
        try {
            singleServerNode = record.getLinkedRecord(payload.fieldKey);
        } catch (_unused3) {}
        if (!singleServerNode) try {
            serverNodes = record.getLinkedRecords(payload.fieldKey);
        } catch (_unused4) {}
        if (singleServerNode == null && serverNodes == null) return;
        var _ConnectionInterface$2 = ConnectionInterface.get(), NODE = _ConnectionInterface$2.NODE, EDGES = _ConnectionInterface$2.EDGES;
        var serverNodeList = (_serverNodes = serverNodes) !== null && _serverNodes !== void 0 ? _serverNodes : [
            singleServerNode
        ];
        var _iterator4 = (0, _createForOfIteratorHelper2["default"])(serverNodeList), _step4;
        try {
            var _loop2 = function _loop2() {
                var serverNode = _step4.value;
                if (serverNode == null) return "continue";
                var serverNodeId = serverNode.getDataID();
                var _iterator5 = (0, _createForOfIteratorHelper2["default"])(connections), _step5;
                try {
                    for(_iterator5.s(); !(_step5 = _iterator5.n()).done;){
                        var connectionID = _step5.value;
                        var connection = store.get(connectionID);
                        if (connection == null) continue;
                        var nodeAlreadyExistsInConnection = (_connection$getLinked2 = connection.getLinkedRecords(EDGES)) === null || _connection$getLinked2 === void 0 ? void 0 : _connection$getLinked2.some(function(edge) {
                            var _edge$getLinkedRecord2;
                            return (edge === null || edge === void 0 ? void 0 : (_edge$getLinkedRecord2 = edge.getLinkedRecord(NODE)) === null || _edge$getLinkedRecord2 === void 0 ? void 0 : _edge$getLinkedRecord2.getDataID()) === serverNodeId;
                        });
                        if (nodeAlreadyExistsInConnection) continue;
                        var clientEdge = ConnectionHandler.createEdge(store, connection, serverNode, edgeTypeName);
                        !(clientEdge != null) && invariant(false);
                        insertFn(connection, clientEdge);
                    }
                } catch (err) {
                    _iterator5.e(err);
                } finally{
                    _iterator5.f();
                }
            };
            for(_iterator4.s(); !(_step4 = _iterator4.n()).done;){
                var _connection$getLinked2;
                var _ret2 = _loop2();
                if (_ret2 === "continue") continue;
            }
        } catch (err) {
            _iterator4.e(err);
        } finally{
            _iterator4.f();
        }
    };
}
module.exports = {
    AppendEdgeHandler: AppendEdgeHandler,
    DeleteRecordHandler: DeleteRecordHandler,
    PrependEdgeHandler: PrependEdgeHandler,
    AppendNodeHandler: AppendNodeHandler,
    PrependNodeHandler: PrependNodeHandler,
    DeleteEdgeHandler: DeleteEdgeHandler
};

},{"d03d157df1d0d577":"590td","96c1c2c1aed03328":"fMaLa","eee31943aaa350cd":"ccBOd","b5bc3a6bee25ed35":"dTLQR","16aa9c711c3df27":"e2sci","2a351171c9e5f420":"j64TH"}],"kUOrY":[function(require,module,exports,__globalThis) {
'use strict';
var ConnectionHandler = require("88ddeac36e255fd8");
var MutationHandlers = require("28e2d51bf435b8b1");
var invariant = require("9218549c1c36d1cd");
function RelayDefaultHandlerProvider(handle) {
    switch(handle){
        case 'connection':
            return ConnectionHandler;
        case 'deleteRecord':
            return MutationHandlers.DeleteRecordHandler;
        case 'deleteEdge':
            return MutationHandlers.DeleteEdgeHandler;
        case 'appendEdge':
            return MutationHandlers.AppendEdgeHandler;
        case 'prependEdge':
            return MutationHandlers.PrependEdgeHandler;
        case 'appendNode':
            return MutationHandlers.AppendNodeHandler;
        case 'prependNode':
            return MutationHandlers.PrependNodeHandler;
    }
    invariant(false);
}
module.exports = RelayDefaultHandlerProvider;

},{"88ddeac36e255fd8":"ccBOd","28e2d51bf435b8b1":"egZkc","9218549c1c36d1cd":"e2sci"}],"8KmZz":[function(require,module,exports,__globalThis) {
'use strict';
var _require = require("6f2594a96ed55953"), getRequest = _require.getRequest;
var isRelayModernEnvironment = require("964639c49853ca57");
var _require2 = require("64481f29b393a3ed"), createOperationDescriptor = _require2.createOperationDescriptor;
var RelayDeclarativeMutationConfig = require("cccbc2f618f05cbb");
var invariant = require("a2c09bbe09bb7322");
function applyOptimisticMutation(environment, config) {
    !isRelayModernEnvironment(environment) && invariant(false);
    var mutation = getRequest(config.mutation);
    if (mutation.params.operationKind !== 'mutation') throw new Error('commitMutation: Expected mutation operation');
    var optimisticUpdater = config.optimisticUpdater;
    var configs = config.configs, optimisticResponse = config.optimisticResponse, variables = config.variables;
    var operation = createOperationDescriptor(mutation, variables);
    if (configs) {
        var _RelayDeclarativeMuta = RelayDeclarativeMutationConfig.convert(configs, mutation, optimisticUpdater);
        optimisticUpdater = _RelayDeclarativeMuta.optimisticUpdater;
    }
    return environment.applyMutation({
        operation: operation,
        response: optimisticResponse,
        updater: optimisticUpdater
    });
}
module.exports = applyOptimisticMutation;

},{"6f2594a96ed55953":"8UTII","964639c49853ca57":"bBdVI","64481f29b393a3ed":"dSeB3","cccbc2f618f05cbb":"1lmKe","a2c09bbe09bb7322":"e2sci"}],"bBdVI":[function(require,module,exports,__globalThis) {
'use strict';
function isRelayModernEnvironment(environment) {
    return Boolean(environment && environment['@@RelayModernEnvironment']);
}
module.exports = isRelayModernEnvironment;

},{}],"1lmKe":[function(require,module,exports,__globalThis) {
'use strict';
var _interopRequireDefault = require("c78afc10dc7f55aa")["default"];
var _createForOfIteratorHelper2 = _interopRequireDefault(require("5b666b6aff03d5af"));
var ConnectionHandler = require("41f218f58f287b70");
var warning = require("a359290e1df6bbbf");
var MutationTypes = Object.freeze({
    RANGE_ADD: 'RANGE_ADD',
    RANGE_DELETE: 'RANGE_DELETE',
    NODE_DELETE: 'NODE_DELETE'
});
var RangeOperations = Object.freeze({
    APPEND: 'append',
    PREPEND: 'prepend'
});
function convert(configs, request, optimisticUpdater, updater) {
    var configOptimisticUpdates = optimisticUpdater ? [
        optimisticUpdater
    ] : [];
    var configUpdates = updater ? [
        updater
    ] : [];
    configs.forEach(function(config) {
        switch(config.type){
            case 'NODE_DELETE':
                var nodeDeleteResult = nodeDelete(config, request);
                if (nodeDeleteResult) {
                    configOptimisticUpdates.push(nodeDeleteResult);
                    configUpdates.push(nodeDeleteResult);
                }
                break;
            case 'RANGE_ADD':
                var rangeAddResult = rangeAdd(config, request);
                if (rangeAddResult) {
                    configOptimisticUpdates.push(rangeAddResult);
                    configUpdates.push(rangeAddResult);
                }
                break;
            case 'RANGE_DELETE':
                var rangeDeleteResult = rangeDelete(config, request);
                if (rangeDeleteResult) {
                    configOptimisticUpdates.push(rangeDeleteResult);
                    configUpdates.push(rangeDeleteResult);
                }
                break;
        }
    });
    return {
        optimisticUpdater: function optimisticUpdater(store, data) {
            configOptimisticUpdates.forEach(function(eachOptimisticUpdater) {
                eachOptimisticUpdater(store, data);
            });
        },
        updater: function updater(store, data) {
            configUpdates.forEach(function(eachUpdater) {
                eachUpdater(store, data);
            });
        }
    };
}
function nodeDelete(config, request) {
    var deletedIDFieldName = config.deletedIDFieldName;
    var rootField = getRootField(request);
    if (!rootField) return null;
    return function(store, data) {
        var payload = store.getRootField(rootField);
        if (!payload) return;
        var deleteID = payload.getValue(deletedIDFieldName);
        var deleteIDs = Array.isArray(deleteID) ? deleteID : [
            deleteID
        ];
        deleteIDs.forEach(function(id) {
            if (id && typeof id === 'string') store["delete"](id);
        });
    };
}
function rangeAdd(config, request) {
    var parentID = config.parentID, connectionInfo = config.connectionInfo, edgeName = config.edgeName;
    if (!parentID) return null;
    var rootField = getRootField(request);
    if (!connectionInfo || !rootField) return null;
    return function(store, data) {
        var parent = store.get(parentID);
        if (!parent) return;
        var payload = store.getRootField(rootField);
        if (!payload) return;
        var serverEdge = payload.getLinkedRecord(edgeName);
        var _iterator = (0, _createForOfIteratorHelper2["default"])(connectionInfo), _step;
        try {
            for(_iterator.s(); !(_step = _iterator.n()).done;){
                var info = _step.value;
                if (!serverEdge) continue;
                var connection = ConnectionHandler.getConnection(parent, info.key, info.filters);
                if (!connection) continue;
                var clientEdge = ConnectionHandler.buildConnectionEdge(store, connection, serverEdge);
                if (!clientEdge) continue;
                switch(info.rangeBehavior){
                    case 'append':
                        ConnectionHandler.insertEdgeAfter(connection, clientEdge);
                        break;
                    case 'prepend':
                        ConnectionHandler.insertEdgeBefore(connection, clientEdge);
                        break;
                    default:
                        break;
                }
            }
        } catch (err) {
            _iterator.e(err);
        } finally{
            _iterator.f();
        }
    };
}
function rangeDelete(config, request) {
    var parentID = config.parentID, connectionKeys = config.connectionKeys, pathToConnection = config.pathToConnection, deletedIDFieldName = config.deletedIDFieldName;
    if (!parentID) return null;
    var rootField = getRootField(request);
    if (!rootField) return null;
    return function(store, data) {
        if (!data) return;
        var deleteIDs = [];
        var deletedIDField = data[rootField];
        if (deletedIDField && Array.isArray(deletedIDFieldName)) {
            var _iterator2 = (0, _createForOfIteratorHelper2["default"])(deletedIDFieldName), _step2;
            try {
                for(_iterator2.s(); !(_step2 = _iterator2.n()).done;){
                    var eachField = _step2.value;
                    if (deletedIDField && typeof deletedIDField === 'object') deletedIDField = deletedIDField[eachField];
                }
            } catch (err) {
                _iterator2.e(err);
            } finally{
                _iterator2.f();
            }
            if (Array.isArray(deletedIDField)) deletedIDField.forEach(function(idObject) {
                if (idObject && idObject.id && typeof idObject === 'object' && typeof idObject.id === 'string') deleteIDs.push(idObject.id);
            });
            else if (deletedIDField && deletedIDField.id && typeof deletedIDField.id === 'string') deleteIDs.push(deletedIDField.id);
        } else if (deletedIDField && typeof deletedIDFieldName === 'string' && typeof deletedIDField === 'object') {
            deletedIDField = deletedIDField[deletedIDFieldName];
            if (typeof deletedIDField === 'string') deleteIDs.push(deletedIDField);
            else if (Array.isArray(deletedIDField)) deletedIDField.forEach(function(id) {
                if (typeof id === 'string') deleteIDs.push(id);
            });
        }
        deleteNode(parentID, connectionKeys, pathToConnection, store, deleteIDs);
    };
}
function deleteNode(parentID, connectionKeys, pathToConnection, store, deleteIDs) {
    var parent = store.get(parentID);
    if (!parent) return;
    if (pathToConnection.length < 2) return;
    var recordProxy = parent;
    for(var i = 1; i < pathToConnection.length - 1; i++)if (recordProxy) recordProxy = recordProxy.getLinkedRecord(pathToConnection[i]);
    if (!connectionKeys || !recordProxy) return;
    var _iterator3 = (0, _createForOfIteratorHelper2["default"])(connectionKeys), _step3;
    try {
        var _loop = function _loop() {
            var key = _step3.value;
            var connection = ConnectionHandler.getConnection(recordProxy, key.key, key.filters);
            if (connection) deleteIDs.forEach(function(deleteID) {
                ConnectionHandler.deleteNode(connection, deleteID);
            });
        };
        for(_iterator3.s(); !(_step3 = _iterator3.n()).done;)_loop();
    } catch (err) {
        _iterator3.e(err);
    } finally{
        _iterator3.f();
    }
}
function getRootField(request) {
    if (request.fragment.selections && request.fragment.selections.length > 0 && request.fragment.selections[0].kind === 'LinkedField') return request.fragment.selections[0].name;
    return null;
}
module.exports = {
    MutationTypes: MutationTypes,
    RangeOperations: RangeOperations,
    convert: convert
};

},{"c78afc10dc7f55aa":"590td","5b666b6aff03d5af":"fMaLa","41f218f58f287b70":"ccBOd","a359290e1df6bbbf":"j64TH"}],"5KZg6":[function(require,module,exports,__globalThis) {
'use strict';
function commitLocalUpdate(environment, updater) {
    environment.commitUpdate(updater);
}
module.exports = commitLocalUpdate;

},{}],"1H0OQ":[function(require,module,exports,__globalThis) {
'use strict';
var _interopRequireDefault = require("6d39cd0e270b8aec")["default"];
var _toConsumableArray2 = _interopRequireDefault(require("5c9e1274f34388f5"));
var _require = require("67edf200634e6c87"), getRequest = _require.getRequest;
var _require2 = require("bbeed2b28422964"), generateUniqueClientID = _require2.generateUniqueClientID;
var isRelayModernEnvironment = require("c906eac592a2369b");
var _require3 = require("1f0571eb15c24db"), createOperationDescriptor = _require3.createOperationDescriptor;
var RelayDeclarativeMutationConfig = require("5c7d0bf96d99d7a6");
var validateMutation = require("ebb05b416036134c");
var invariant = require("a1c1e4fe2d13d416");
var warning = require("a2d529af2ce20c4f");
function commitMutation(environment, config) {
    !isRelayModernEnvironment(environment) && invariant(false);
    var mutation = getRequest(config.mutation);
    if (mutation.params.operationKind !== 'mutation') throw new Error('commitMutation: Expected mutation operation');
    if (mutation.kind !== 'Request') throw new Error('commitMutation: Expected mutation to be of type request');
    var optimisticResponse = config.optimisticResponse, optimisticUpdater = config.optimisticUpdater, updater = config.updater;
    var configs = config.configs, cacheConfig = config.cacheConfig, onError = config.onError, onUnsubscribe = config.onUnsubscribe, variables = config.variables, uploadables = config.uploadables;
    var operation = createOperationDescriptor(mutation, variables, cacheConfig, generateUniqueClientID());
    if (typeof optimisticResponse === 'function') optimisticResponse = optimisticResponse();
    if (configs) {
        var _RelayDeclarativeMuta = RelayDeclarativeMutationConfig.convert(configs, mutation, optimisticUpdater, updater);
        optimisticUpdater = _RelayDeclarativeMuta.optimisticUpdater;
        updater = _RelayDeclarativeMuta.updater;
    }
    var errors = [];
    var subscription = environment.executeMutation({
        operation: operation,
        optimisticResponse: optimisticResponse,
        optimisticUpdater: optimisticUpdater,
        updater: updater,
        uploadables: uploadables
    }).subscribe({
        next: function next(payload) {
            var _config$onNext;
            if (Array.isArray(payload)) payload.forEach(function(item) {
                if (item.errors) errors.push.apply(errors, (0, _toConsumableArray2["default"])(item.errors));
            });
            else if (payload.errors) errors.push.apply(errors, (0, _toConsumableArray2["default"])(payload.errors));
            (_config$onNext = config.onNext) === null || _config$onNext === void 0 || _config$onNext.call(config);
        },
        complete: function complete() {
            var onCompleted = config.onCompleted;
            if (onCompleted) {
                var snapshot = environment.lookup(operation.fragment);
                onCompleted(snapshot.data, errors.length !== 0 ? errors : null);
            }
        },
        error: onError,
        unsubscribe: onUnsubscribe
    });
    return {
        dispose: subscription.unsubscribe
    };
}
module.exports = commitMutation;

},{"6d39cd0e270b8aec":"590td","5c9e1274f34388f5":"7EBX0","67edf200634e6c87":"8UTII","bbeed2b28422964":"gL1rB","c906eac592a2369b":"bBdVI","1f0571eb15c24db":"dSeB3","5c7d0bf96d99d7a6":"1lmKe","ebb05b416036134c":"5s4Eu","a1c1e4fe2d13d416":"e2sci","a2d529af2ce20c4f":"j64TH"}],"5s4Eu":[function(require,module,exports,__globalThis) {
'use strict';
var _interopRequireDefault = require("5592140b5bb330fb")["default"];
var _objectSpread2 = _interopRequireDefault(require("57cddd40b9e9c2ee"));
var warning = require("a99edeb0085b242e");
var hasOwnProperty = Object.prototype.hasOwnProperty;
var validateMutation = function validateMutation() {};
var addFieldToDiff, validateSelections, validateSelection, validateModuleImport, validateAbstractKey, validateField, validateOptimisticResponse;
module.exports = validateMutation;

},{"5592140b5bb330fb":"590td","57cddd40b9e9c2ee":"2Bj1n","a99edeb0085b242e":"j64TH"}],"gtE7n":[function(require,module,exports,__globalThis) {
'use strict';
var withProvidedVariables = require("29d5e2059830cbf");
var _require = require("619be278d7fcd836"), convertFetch = _require.convertFetch;
var invariant = require("9268cc175a6b6859");
function create(fetchFn, subscribe) {
    var observeFetch = convertFetch(fetchFn);
    function execute(request, variables, cacheConfig, uploadables, logRequestInfo) {
        var operationVariables = withProvidedVariables(variables, request.providedVariables);
        if (request.operationKind === 'subscription') {
            !subscribe && invariant(false);
            !!uploadables && invariant(false);
            return subscribe(request, operationVariables, cacheConfig);
        }
        var pollInterval = cacheConfig.poll;
        if (pollInterval != null) {
            !!uploadables && invariant(false);
            return observeFetch(request, operationVariables, {
                force: true
            }).poll(pollInterval);
        }
        return observeFetch(request, operationVariables, cacheConfig, uploadables, logRequestInfo);
    }
    return {
        execute: execute
    };
}
module.exports = {
    create: create
};

},{"29d5e2059830cbf":"1N2Sg","619be278d7fcd836":"baXis","9268cc175a6b6859":"e2sci"}],"1N2Sg":[function(require,module,exports,__globalThis) {
'use strict';
var areEqual = require("12f707750c3648af");
var warning = require("57d4af0a2ea5673b");
var WEAKMAP_SUPPORTED = typeof WeakMap === 'function';
var debugCache = WEAKMAP_SUPPORTED ? new WeakMap() : new Map();
function withProvidedVariables(userSuppliedVariables, providedVariables) {
    if (providedVariables != null) {
        var operationVariables = {};
        Object.assign(operationVariables, userSuppliedVariables);
        Object.keys(providedVariables).forEach(function(varName) {
            var providerFunction = providedVariables[varName].get;
            var providerResult = providerFunction();
            if (!debugCache.has(providerFunction)) {
                debugCache.set(providerFunction, providerResult);
                operationVariables[varName] = providerResult;
            } else {
                var cachedResult = debugCache.get(providerFunction);
                operationVariables[varName] = cachedResult;
            }
        });
        return operationVariables;
    } else return userSuppliedVariables;
}
withProvidedVariables.tests_only_resetDebugCache = undefined;
module.exports = withProvidedVariables;

},{"12f707750c3648af":"eJLuG","57d4af0a2ea5673b":"j64TH"}],"baXis":[function(require,module,exports,__globalThis) {
'use strict';
var RelayObservable = require("a489b440edc36379");
function convertFetch(fn) {
    return function fetch(request, variables, cacheConfig, uploadables, logRequestInfo) {
        var result = fn(request, variables, cacheConfig, uploadables, logRequestInfo);
        if (result instanceof Error) return RelayObservable.create(function(sink) {
            return sink.error(result);
        });
        return RelayObservable.from(result);
    };
}
module.exports = {
    convertFetch: convertFetch
};

},{"a489b440edc36379":"hYmcP"}],"ejl8F":[function(require,module,exports,__globalThis) {
'use strict';
var _interopRequireDefault = require("5eb6f02be12a2204")["default"];
var _objectSpread2 = _interopRequireDefault(require("2c3b67d95a9cca5c"));
var _require = require("ba35c3d3c24d6b7a"), stableCopy = _require.stableCopy;
var invariant = require("1fbdf4cfed2afc69");
var RelayQueryResponseCache = /*#__PURE__*/ function() {
    function RelayQueryResponseCache(_ref) {
        var size = _ref.size, ttl = _ref.ttl;
        !(size > 0) && invariant(false);
        !(ttl > 0) && invariant(false);
        this._responses = new Map();
        this._size = size;
        this._ttl = ttl;
    }
    var _proto = RelayQueryResponseCache.prototype;
    _proto.clear = function clear() {
        this._responses.clear();
    };
    _proto.get = function get(queryID, variables) {
        var _this = this;
        var cacheKey = getCacheKey(queryID, variables);
        this._responses.forEach(function(response, key) {
            if (!isCurrent(response.fetchTime, _this._ttl)) _this._responses["delete"](key);
        });
        var response = this._responses.get(cacheKey);
        if (response == null) return null;
        if (Array.isArray(response.payload)) return response.payload.map(function(payload) {
            return (0, _objectSpread2["default"])((0, _objectSpread2["default"])({}, payload), {}, {
                extensions: (0, _objectSpread2["default"])((0, _objectSpread2["default"])({}, payload.extensions), {}, {
                    cacheTimestamp: response.fetchTime
                })
            });
        });
        return (0, _objectSpread2["default"])((0, _objectSpread2["default"])({}, response.payload), {}, {
            extensions: (0, _objectSpread2["default"])((0, _objectSpread2["default"])({}, response.payload.extensions), {}, {
                cacheTimestamp: response.fetchTime
            })
        });
    };
    _proto.set = function set(queryID, variables, payload) {
        var fetchTime = Date.now();
        var cacheKey = getCacheKey(queryID, variables);
        this._responses["delete"](cacheKey);
        this._responses.set(cacheKey, {
            fetchTime: fetchTime,
            payload: payload
        });
        if (this._responses.size > this._size) {
            var firstKey = this._responses.keys().next();
            if (!firstKey.done) this._responses["delete"](firstKey.value);
        }
    };
    return RelayQueryResponseCache;
}();
function getCacheKey(queryID, variables) {
    return JSON.stringify(stableCopy({
        queryID: queryID,
        variables: variables
    }));
}
function isCurrent(fetchTime, ttl) {
    return fetchTime + ttl >= Date.now();
}
module.exports = RelayQueryResponseCache;

},{"5eb6f02be12a2204":"590td","2c3b67d95a9cca5c":"2Bj1n","ba35c3d3c24d6b7a":"c3NLR","1fbdf4cfed2afc69":"e2sci"}],"khAY2":[function(require,module,exports,__globalThis) {
'use strict';
var _interopRequireDefault = require("2ffe84bd824cbf0")["default"];
var _objectSpread2 = _interopRequireDefault(require("cd90c30c44aa0fdc"));
var RelayObservable = require("ba3953ef4f803526");
var _require = require("cb14f63cc725d8f"), createOperationDescriptor = _require.createOperationDescriptor;
var _require2 = require("32213b8207276ab5"), handlePotentialSnapshotErrors = _require2.handlePotentialSnapshotErrors;
var fetchQueryInternal = require("b8582f9e9d2828cc");
var _require3 = require("98b9ff07c67a6501"), getRequest = _require3.getRequest;
var invariant = require("7e0d30b75b47d07b");
function fetchQuery(environment, query, variables, options) {
    var _options$fetchPolicy;
    var queryNode = getRequest(query);
    !(queryNode.params.operationKind === 'query') && invariant(false);
    var networkCacheConfig = (0, _objectSpread2["default"])({
        force: true
    }, options === null || options === void 0 ? void 0 : options.networkCacheConfig);
    var operation = createOperationDescriptor(queryNode, variables, networkCacheConfig);
    var fetchPolicy = (_options$fetchPolicy = options === null || options === void 0 ? void 0 : options.fetchPolicy) !== null && _options$fetchPolicy !== void 0 ? _options$fetchPolicy : 'network-only';
    function readData(snapshot) {
        handlePotentialSnapshotErrors(environment, snapshot.fieldErrors);
        return snapshot.data;
    }
    switch(fetchPolicy){
        case 'network-only':
            return getNetworkObservable(environment, operation).map(readData);
        case 'store-or-network':
            if (environment.check(operation).status === 'available') return RelayObservable.from(environment.lookup(operation.fragment)).map(readData);
            return getNetworkObservable(environment, operation).map(readData);
        default:
            fetchPolicy;
            throw new Error('fetchQuery: Invalid fetchPolicy ' + fetchPolicy);
    }
}
function getNetworkObservable(environment, operation) {
    return fetchQueryInternal.fetchQuery(environment, operation).map(function() {
        return environment.lookup(operation.fragment);
    });
}
module.exports = fetchQuery;

},{"2ffe84bd824cbf0":"590td","cd90c30c44aa0fdc":"2Bj1n","ba3953ef4f803526":"hYmcP","cb14f63cc725d8f":"dSeB3","32213b8207276ab5":"kq97W","b8582f9e9d2828cc":"75uB6","98b9ff07c67a6501":"8UTII","7e0d30b75b47d07b":"e2sci"}],"jMRnb":[function(require,module,exports,__globalThis) {
'use strict';
var _require = require("b4015b45e4de24a7"), createOperationDescriptor = _require.createOperationDescriptor;
var _require2 = require("1069830bc1d06686"), getRequest = _require2.getRequest;
function fetchQuery_DEPRECATED(environment, taggedNode, variables, cacheConfig) {
    var query = getRequest(taggedNode);
    if (query.params.operationKind !== 'query') throw new Error('fetchQuery: Expected query operation');
    var operation = createOperationDescriptor(query, variables, cacheConfig);
    return environment.execute({
        operation: operation
    }).map(function() {
        return environment.lookup(operation.fragment).data;
    }).toPromise();
}
module.exports = fetchQuery_DEPRECATED;

},{"b4015b45e4de24a7":"dSeB3","1069830bc1d06686":"8UTII"}],"kmRfk":[function(require,module,exports,__globalThis) {
'use strict';
var PreloadableQueryRegistry = /*#__PURE__*/ function() {
    function PreloadableQueryRegistry() {
        this._preloadableQueries = new Map();
        this._callbacks = new Map();
    }
    var _proto = PreloadableQueryRegistry.prototype;
    _proto.set = function set(key, value) {
        this._preloadableQueries.set(key, value);
        var callbacks = this._callbacks.get(key);
        if (callbacks != null) callbacks.forEach(function(cb) {
            try {
                cb(value);
            } catch (e) {
                setTimeout(function() {
                    throw e;
                }, 0);
            }
        });
    };
    _proto.get = function get(key) {
        return this._preloadableQueries.get(key);
    };
    _proto.onLoad = function onLoad(key, callback) {
        var _this$_callbacks$get;
        var callbacks = (_this$_callbacks$get = this._callbacks.get(key)) !== null && _this$_callbacks$get !== void 0 ? _this$_callbacks$get : new Set();
        callbacks.add(callback);
        var dispose = function dispose() {
            callbacks["delete"](callback);
        };
        this._callbacks.set(key, callbacks);
        return {
            dispose: dispose
        };
    };
    _proto.clear = function clear() {
        this._preloadableQueries.clear();
    };
    return PreloadableQueryRegistry;
}();
var preloadableQueryRegistry = new PreloadableQueryRegistry();
module.exports = preloadableQueryRegistry;

},{}],"84PBa":[function(require,module,exports,__globalThis) {
'use strict';
var RelayModernFragmentSpecResolver = require("45605511b64611e0");
var warning = require("58f3a30a91459ca9");
function createFragmentSpecResolver(context, containerName, fragments, props, rootIsQueryRenderer, callback) {
    var fragmentNames;
    return new RelayModernFragmentSpecResolver(context, fragments, props, callback, rootIsQueryRenderer);
}
module.exports = createFragmentSpecResolver;

},{"45605511b64611e0":"5arEx","58f3a30a91459ca9":"j64TH"}],"5arEx":[function(require,module,exports,__globalThis) {
'use strict';
var _interopRequireDefault = require("ad8baba28e3b35dc")["default"];
var _objectSpread2 = _interopRequireDefault(require("266ef77c6cb1398b"));
var _defineProperty2 = _interopRequireDefault(require("f1ddfed2757219b7"));
var getPendingOperationsForFragment = require("6ca91a2ed6422b98");
var _require = require("10d6ed44056564aa"), handlePotentialSnapshotErrors = _require.handlePotentialSnapshotErrors;
var isScalarAndEqual = require("60eb81baa99d85bf");
var recycleNodesInto = require("5130119e2b42fda0");
var RelayFeatureFlags = require("c706806a8bac27e2");
var _require2 = require("546831a14eeefb1c"), createRequestDescriptor = _require2.createRequestDescriptor;
var _require3 = require("3a8aec6e2824d4e7"), areEqualSelectors = _require3.areEqualSelectors, createReaderSelector = _require3.createReaderSelector, getSelectorsFromObject = _require3.getSelectorsFromObject;
var areEqual = require("eba19665d75b5d0c");
var invariant = require("4c512455b6aa4960");
var warning = require("fad069af64d062c6");
var RelayModernFragmentSpecResolver = /*#__PURE__*/ function() {
    function RelayModernFragmentSpecResolver(context, fragments, props, callback, rootIsQueryRenderer) {
        var _this = this;
        (0, _defineProperty2["default"])(this, "_onChange", function() {
            _this._stale = true;
            if (typeof _this._callback === 'function') _this._callback();
        });
        this._callback = callback;
        this._context = context;
        this._data = {};
        this._fragments = fragments;
        this._props = {};
        this._resolvers = {};
        this._stale = false;
        this._rootIsQueryRenderer = rootIsQueryRenderer;
        this.setProps(props);
    }
    var _proto = RelayModernFragmentSpecResolver.prototype;
    _proto.dispose = function dispose() {
        for(var key in this._resolvers)if (this._resolvers.hasOwnProperty(key)) disposeCallback(this._resolvers[key]);
    };
    _proto.resolve = function resolve() {
        if (this._stale) {
            var prevData = this._data;
            var nextData;
            for(var key in this._resolvers)if (this._resolvers.hasOwnProperty(key)) {
                var resolver = this._resolvers[key];
                var prevItem = prevData[key];
                if (resolver) {
                    var nextItem = resolver.resolve();
                    if (nextData || nextItem !== prevItem) {
                        nextData = nextData || (0, _objectSpread2["default"])({}, prevData);
                        nextData[key] = nextItem;
                    }
                } else {
                    var prop = this._props[key];
                    var _nextItem = prop !== undefined ? prop : null;
                    if (nextData || !isScalarAndEqual(_nextItem, prevItem)) {
                        nextData = nextData || (0, _objectSpread2["default"])({}, prevData);
                        nextData[key] = _nextItem;
                    }
                }
            }
            this._data = nextData || prevData;
            this._stale = false;
        }
        return this._data;
    };
    _proto.setCallback = function setCallback(props, callback) {
        this._callback = callback;
        if (RelayFeatureFlags.ENABLE_CONTAINERS_SUBSCRIBE_ON_COMMIT === true) this.setProps(props);
    };
    _proto.setProps = function setProps(props) {
        this._props = {};
        var ownedSelectors = getSelectorsFromObject(this._fragments, props);
        for(var key in ownedSelectors)if (ownedSelectors.hasOwnProperty(key)) {
            var ownedSelector = ownedSelectors[key];
            var resolver = this._resolvers[key];
            if (ownedSelector == null) {
                if (resolver != null) resolver.dispose();
                resolver = null;
            } else if (ownedSelector.kind === 'PluralReaderSelector') {
                if (resolver == null) resolver = new SelectorListResolver(this._context.environment, this._rootIsQueryRenderer, ownedSelector, this._callback != null, this._onChange);
                else {
                    !(resolver instanceof SelectorListResolver) && invariant(false);
                    resolver.setSelector(ownedSelector);
                }
            } else if (resolver == null) resolver = new SelectorResolver(this._context.environment, this._rootIsQueryRenderer, ownedSelector, this._callback != null, this._onChange);
            else {
                !(resolver instanceof SelectorResolver) && invariant(false);
                resolver.setSelector(ownedSelector);
            }
            this._props[key] = props[key];
            this._resolvers[key] = resolver;
        }
        this._stale = true;
    };
    _proto.setVariables = function setVariables(variables, request) {
        for(var key in this._resolvers)if (this._resolvers.hasOwnProperty(key)) {
            var resolver = this._resolvers[key];
            if (resolver) resolver.setVariables(variables, request);
        }
        this._stale = true;
    };
    return RelayModernFragmentSpecResolver;
}();
var SelectorResolver = /*#__PURE__*/ function() {
    function SelectorResolver(environment, rootIsQueryRenderer, selector, subscribeOnConstruction, callback) {
        var _this2 = this;
        (0, _defineProperty2["default"])(this, "_onChange", function(snapshot) {
            _this2._data = snapshot.data;
            _this2._isMissingData = snapshot.isMissingData;
            _this2._fieldErrors = snapshot.fieldErrors;
            _this2._callback();
        });
        var _snapshot = environment.lookup(selector);
        this._callback = callback;
        this._data = _snapshot.data;
        this._isMissingData = _snapshot.isMissingData;
        this._fieldErrors = _snapshot.fieldErrors;
        this._environment = environment;
        this._rootIsQueryRenderer = rootIsQueryRenderer;
        this._selector = selector;
        if (RelayFeatureFlags.ENABLE_CONTAINERS_SUBSCRIBE_ON_COMMIT === true) {
            if (subscribeOnConstruction) this._subscription = environment.subscribe(_snapshot, this._onChange);
        } else this._subscription = environment.subscribe(_snapshot, this._onChange);
    }
    var _proto2 = SelectorResolver.prototype;
    _proto2.dispose = function dispose() {
        if (this._subscription) {
            this._subscription.dispose();
            this._subscription = null;
        }
    };
    _proto2.resolve = function resolve() {
        if (this._isMissingData === true) {
            var pendingOperationsResult = getPendingOperationsForFragment(this._environment, this._selector.node, this._selector.owner);
            var promise = pendingOperationsResult === null || pendingOperationsResult === void 0 ? void 0 : pendingOperationsResult.promise;
            if (promise != null) {
                if (this._rootIsQueryRenderer) ;
                else {
                    var _pendingOperationsRes;
                    var pendingOperations = (_pendingOperationsRes = pendingOperationsResult === null || pendingOperationsResult === void 0 ? void 0 : pendingOperationsResult.pendingOperations) !== null && _pendingOperationsRes !== void 0 ? _pendingOperationsRes : [];
                    this._environment.__log({
                        name: 'suspense.fragment',
                        data: this._data,
                        fragment: this._selector.node,
                        isRelayHooks: false,
                        isMissingData: this._isMissingData,
                        isPromiseCached: false,
                        pendingOperations: pendingOperations
                    });
                    throw promise;
                }
            }
        }
        handlePotentialSnapshotErrors(this._environment, this._fieldErrors);
        return this._data;
    };
    _proto2.setSelector = function setSelector(selector) {
        if (this._subscription != null && areEqualSelectors(selector, this._selector)) return;
        this.dispose();
        var snapshot = this._environment.lookup(selector);
        this._data = recycleNodesInto(this._data, snapshot.data);
        this._isMissingData = snapshot.isMissingData;
        this._fieldErrors = snapshot.fieldErrors;
        this._selector = selector;
        this._subscription = this._environment.subscribe(snapshot, this._onChange);
    };
    _proto2.setVariables = function setVariables(variables, request) {
        if (areEqual(variables, this._selector.variables)) return;
        var requestDescriptor = createRequestDescriptor(request, variables);
        var selector = createReaderSelector(this._selector.node, this._selector.dataID, variables, requestDescriptor);
        this.setSelector(selector);
    };
    return SelectorResolver;
}();
var SelectorListResolver = /*#__PURE__*/ function() {
    function SelectorListResolver(environment, rootIsQueryRenderer, selector, subscribeOnConstruction, callback) {
        var _this3 = this;
        (0, _defineProperty2["default"])(this, "_onChange", function(data) {
            _this3._stale = true;
            _this3._callback();
        });
        this._callback = callback;
        this._data = [];
        this._environment = environment;
        this._resolvers = [];
        this._stale = true;
        this._rootIsQueryRenderer = rootIsQueryRenderer;
        this._subscribeOnConstruction = subscribeOnConstruction;
        this.setSelector(selector);
    }
    var _proto3 = SelectorListResolver.prototype;
    _proto3.dispose = function dispose() {
        this._resolvers.forEach(disposeCallback);
    };
    _proto3.resolve = function resolve() {
        if (this._stale) {
            var prevData = this._data;
            var nextData;
            for(var ii = 0; ii < this._resolvers.length; ii++){
                var prevItem = prevData[ii];
                var nextItem = this._resolvers[ii].resolve();
                if (nextData || nextItem !== prevItem) {
                    nextData = nextData || prevData.slice(0, ii);
                    nextData.push(nextItem);
                }
            }
            if (!nextData && this._resolvers.length !== prevData.length) nextData = prevData.slice(0, this._resolvers.length);
            this._data = nextData || prevData;
            this._stale = false;
        }
        return this._data;
    };
    _proto3.setSelector = function setSelector(selector) {
        var selectors = selector.selectors;
        while(this._resolvers.length > selectors.length){
            var resolver = this._resolvers.pop();
            resolver.dispose();
        }
        for(var ii = 0; ii < selectors.length; ii++)if (ii < this._resolvers.length) this._resolvers[ii].setSelector(selectors[ii]);
        else this._resolvers[ii] = new SelectorResolver(this._environment, this._rootIsQueryRenderer, selectors[ii], this._subscribeOnConstruction, this._onChange);
        this._stale = true;
    };
    _proto3.setVariables = function setVariables(variables, request) {
        this._resolvers.forEach(function(resolver) {
            return resolver.setVariables(variables, request);
        });
        this._stale = true;
    };
    return SelectorListResolver;
}();
function disposeCallback(disposable) {
    disposable && disposable.dispose();
}
module.exports = RelayModernFragmentSpecResolver;

},{"ad8baba28e3b35dc":"590td","266ef77c6cb1398b":"2Bj1n","f1ddfed2757219b7":"2paQ8","6ca91a2ed6422b98":"ak3d6","10d6ed44056564aa":"kq97W","60eb81baa99d85bf":"fysSA","5130119e2b42fda0":"ij1IQ","c706806a8bac27e2":"a0FL5","546831a14eeefb1c":"dSeB3","3a8aec6e2824d4e7":"9k2Dg","eba19665d75b5d0c":"eJLuG","4c512455b6aa4960":"e2sci","fad069af64d062c6":"j64TH"}],"ak3d6":[function(require,module,exports,__globalThis) {
'use strict';
var _require = require("92e4c2c72b8a252a"), getPromiseForActiveRequest = _require.getPromiseForActiveRequest;
function getPendingOperationsForFragment(environment, fragmentNode, fragmentOwner) {
    var _pendingOperations$ma, _pendingOperations;
    var pendingOperations = [];
    var promise = getPromiseForActiveRequest(environment, fragmentOwner);
    if (promise != null) pendingOperations = [
        fragmentOwner
    ];
    else {
        var _result$pendingOperat, _result$promise;
        var operationTracker = environment.getOperationTracker();
        var result = operationTracker.getPendingOperationsAffectingOwner(fragmentOwner);
        pendingOperations = (_result$pendingOperat = result === null || result === void 0 ? void 0 : result.pendingOperations) !== null && _result$pendingOperat !== void 0 ? _result$pendingOperat : [];
        promise = (_result$promise = result === null || result === void 0 ? void 0 : result.promise) !== null && _result$promise !== void 0 ? _result$promise : null;
    }
    if (!promise) return null;
    var pendingOperationName = (_pendingOperations$ma = (_pendingOperations = pendingOperations) === null || _pendingOperations === void 0 ? void 0 : _pendingOperations.map(function(op) {
        return op.node.params.name;
    }).join(',')) !== null && _pendingOperations$ma !== void 0 ? _pendingOperations$ma : null;
    if (pendingOperationName == null || pendingOperationName.length === 0) pendingOperationName = 'Unknown pending operation';
    var fragmentName = fragmentNode.name;
    var promiseDisplayName = pendingOperationName === fragmentName ? "Relay(".concat(pendingOperationName, ")") : "Relay(".concat(pendingOperationName, ":").concat(fragmentName, ")");
    promise.displayName = promiseDisplayName;
    environment.__log({
        name: 'pendingoperation.found',
        fragment: fragmentNode,
        fragmentOwner: fragmentOwner,
        pendingOperations: pendingOperations
    });
    return {
        promise: promise,
        pendingOperations: pendingOperations
    };
}
module.exports = getPendingOperationsForFragment;

},{"92e4c2c72b8a252a":"75uB6"}],"fysSA":[function(require,module,exports,__globalThis) {
'use strict';
function isScalarAndEqual(valueA, valueB) {
    return valueA === valueB && (valueA === null || typeof valueA !== 'object');
}
module.exports = isScalarAndEqual;

},{}],"ij1IQ":[function(require,module,exports,__globalThis) {
'use strict';
function recycleNodesInto(prevData, nextData) {
    return recycleNodesIntoImpl(prevData, nextData, true);
}
function recycleNodesIntoImpl(prevData, nextData, canMutate) {
    if (prevData === nextData || typeof prevData !== 'object' || !prevData || prevData.constructor !== Object && !Array.isArray(prevData) || typeof nextData !== 'object' || !nextData || nextData.constructor !== Object && !Array.isArray(nextData)) return nextData;
    var canRecycle = false;
    var prevArray = Array.isArray(prevData) ? prevData : null;
    var nextArray = Array.isArray(nextData) ? nextData : null;
    if (prevArray && nextArray) {
        var canMutateNext = canMutate && !Object.isFrozen(nextArray);
        canRecycle = nextArray.reduce(function(wasEqual, nextItem, ii) {
            var prevValue = prevArray[ii];
            var nextValue = recycleNodesIntoImpl(prevValue, nextItem, canMutateNext);
            if (nextValue !== nextArray[ii] && canMutateNext) nextArray[ii] = nextValue;
            return wasEqual && nextValue === prevArray[ii];
        }, true) && prevArray.length === nextArray.length;
    } else if (!prevArray && !nextArray) {
        var prevObject = prevData;
        var nextObject = nextData;
        var prevKeys = Object.keys(prevObject);
        var nextKeys = Object.keys(nextObject);
        var _canMutateNext = canMutate && !Object.isFrozen(nextObject);
        canRecycle = nextKeys.reduce(function(wasEqual, key) {
            var prevValue = prevObject[key];
            var nextValue = recycleNodesIntoImpl(prevValue, nextObject[key], _canMutateNext);
            if (nextValue !== nextObject[key] && _canMutateNext) nextObject[key] = nextValue;
            return wasEqual && nextValue === prevObject[key];
        }, true) && prevKeys.length === nextKeys.length;
    }
    return canRecycle ? prevData : nextData;
}
module.exports = recycleNodesInto;

},{}],"fJ0BV":[function(require,module,exports,__globalThis) {
'use strict';
var invariant = require("6094b624c44af8ff");
var relayContext;
var firstReact;
function createRelayContext(react) {
    if (!relayContext) {
        relayContext = react.createContext(null);
        firstReact = react;
    }
    !(react === firstReact) && invariant(false);
    return relayContext;
}
module.exports = createRelayContext;

},{"6094b624c44af8ff":"e2sci"}],"li736":[function(require,module,exports,__globalThis) {
'use strict';
var invariant = require("92cbdcbf7f9dd4ef");
var relayLoggingContext;
var firstReact;
function createRelayLoggingContext(react) {
    if (!relayLoggingContext) {
        relayLoggingContext = react.createContext(null);
        firstReact = react;
    }
    !(react === firstReact) && invariant(false);
    return relayLoggingContext;
}
module.exports = createRelayLoggingContext;

},{"92cbdcbf7f9dd4ef":"e2sci"}],"9sE63":[function(require,module,exports,__globalThis) {
'use strict';
var LIVE_RESOLVER_SUSPENSE_SENTINEL = Object.freeze({
    __LIVE_RESOLVER_SUSPENSE_SENTINEL: true
});
function suspenseSentinel() {
    return LIVE_RESOLVER_SUSPENSE_SENTINEL;
}
function isSuspenseSentinel(value) {
    return value === LIVE_RESOLVER_SUSPENSE_SENTINEL;
}
module.exports = {
    isSuspenseSentinel: isSuspenseSentinel,
    suspenseSentinel: suspenseSentinel
};

},{}],"afJiB":[function(require,module,exports,__globalThis) {
'use strict';
var _interopRequireDefault = require("89a6f60a7fe0471f")["default"];
var _objectSpread2 = _interopRequireDefault(require("5fd80aa7c8d507b7"));
var _RelayModernRecord = _interopRequireDefault(require("abeecd2d3612def0"));
var _RelayRecordSource = _interopRequireDefault(require("6894c9f08269101"));
var _RelayResponseNormalizer = _interopRequireDefault(require("873761baf9790bf9"));
function normalizeResponse(response, selector, typeName, options, useExecTimeResolvers) {
    var _response$extensions;
    var data = response.data, errors = response.errors;
    var source = _RelayRecordSource["default"].create();
    var record = _RelayModernRecord["default"].create(selector.dataID, typeName);
    source.set(selector.dataID, record);
    var relayPayload = _RelayResponseNormalizer["default"].normalize(source, selector, data, options, errors, useExecTimeResolvers);
    return (0, _objectSpread2["default"])((0, _objectSpread2["default"])({}, relayPayload), {}, {
        isFinal: ((_response$extensions = response.extensions) === null || _response$extensions === void 0 ? void 0 : _response$extensions.is_final) === true
    });
}
module.exports = normalizeResponse;

},{"89a6f60a7fe0471f":"590td","5fd80aa7c8d507b7":"2Bj1n","abeecd2d3612def0":"daXOB","6894c9f08269101":"6w3KR","873761baf9790bf9":"1Dhjb"}],"daXOB":[function(require,module,exports,__globalThis) {
'use strict';
var _interopRequireDefault = require("e20934cce7870264")["default"];
var _defineProperty2 = _interopRequireDefault(require("e08036c033b0f038"));
var _objectWithoutPropertiesLoose2 = _interopRequireDefault(require("282f98f2b83101fd"));
var _toPropertyKey2 = _interopRequireDefault(require("12c6bd56199fa732"));
var _objectSpread2 = _interopRequireDefault(require("5f7272e8a766f1ca"));
var deepFreeze = require("bb1eb520f7249af5");
var _require = require("f69f2f81d03f7f45"), generateClientObjectClientID = _require.generateClientObjectClientID, isClientID = _require.isClientID;
var _require2 = require("6582277efdb6cc75"), isSuspenseSentinel = _require2.isSuspenseSentinel;
var _require3 = require("260160fd026eb8a"), ACTOR_IDENTIFIER_KEY = _require3.ACTOR_IDENTIFIER_KEY, ERRORS_KEY = _require3.ERRORS_KEY, ID_KEY = _require3.ID_KEY, INVALIDATED_AT_KEY = _require3.INVALIDATED_AT_KEY, REF_KEY = _require3.REF_KEY, REFS_KEY = _require3.REFS_KEY, RELAY_RESOLVER_VALUE_KEY = _require3.RELAY_RESOLVER_VALUE_KEY, ROOT_ID = _require3.ROOT_ID, TYPENAME_KEY = _require3.TYPENAME_KEY;
var areEqual = require("94ae5de66fe5c308");
var invariant = require("76863a3a6402fa54");
var warning = require("f92f3aed29cf0106");
function clone(record) {
    return (0, _objectSpread2["default"])({}, record);
}
function copyFields(source, sink) {
    for(var key in source){
        if (source.hasOwnProperty(key)) {
            if (key !== ID_KEY && key !== TYPENAME_KEY) sink[key] = source[key];
        }
    }
}
function create(dataID, typeName) {
    var record = {};
    record[ID_KEY] = dataID;
    record[TYPENAME_KEY] = typeName;
    return record;
}
function fromObject(json) {
    return json;
}
function getDataID(record) {
    return record[ID_KEY];
}
function getFields(record) {
    if (ERRORS_KEY in record) return Object.keys(record).filter(function(field) {
        return field !== ERRORS_KEY;
    });
    return Object.keys(record);
}
function getType(record) {
    return record[TYPENAME_KEY];
}
function getErrors(record, storageKey) {
    var _record$ERRORS_KEY;
    return (_record$ERRORS_KEY = record[ERRORS_KEY]) === null || _record$ERRORS_KEY === void 0 ? void 0 : _record$ERRORS_KEY[storageKey];
}
function getValue(record, storageKey) {
    var value = record[storageKey];
    if (value && typeof value === 'object') !(!value.hasOwnProperty(REF_KEY) && !value.hasOwnProperty(REFS_KEY)) && invariant(false);
    return value;
}
function hasValue(record, storageKey) {
    return storageKey in record;
}
function getLinkedRecordID(record, storageKey) {
    var maybeLink = record[storageKey];
    if (maybeLink == null) return maybeLink;
    var link = maybeLink;
    !(typeof link === 'object' && link && typeof link[REF_KEY] === 'string') && invariant(false);
    return link[REF_KEY];
}
function hasLinkedRecordID(record, storageKey) {
    var maybeLink = record[storageKey];
    if (maybeLink == null) return false;
    var link = maybeLink;
    return typeof link === 'object' && link && typeof link[REF_KEY] === 'string';
}
function getLinkedRecordIDs(record, storageKey) {
    var links = record[storageKey];
    if (links == null) return links;
    !(typeof links === 'object' && Array.isArray(links[REFS_KEY])) && invariant(false);
    return links[REFS_KEY];
}
function hasLinkedRecordIDs(record, storageKey) {
    var links = record[storageKey];
    if (links == null) return false;
    return typeof links === 'object' && Array.isArray(links[REFS_KEY]) && links[REFS_KEY].every(function(link) {
        return typeof link === 'string';
    });
}
function getInvalidationEpoch(record) {
    if (record == null) return null;
    var invalidatedAt = record[INVALIDATED_AT_KEY];
    if (typeof invalidatedAt !== 'number') return null;
    return invalidatedAt;
}
function update(prevRecord, nextRecord) {
    var _updated2;
    var _getType, _getType2, prevID, nextID, prevType, nextType;
    var prevErrorsByKey = prevRecord[ERRORS_KEY];
    var nextErrorsByKey = nextRecord[ERRORS_KEY];
    var updated = null;
    if (prevErrorsByKey == null && nextErrorsByKey == null) {
        var _updated;
        for(var storageKey in nextRecord)if (updated || !areEqual(prevRecord[storageKey], nextRecord[storageKey])) {
            updated = updated !== null ? updated : (0, _objectSpread2["default"])({}, prevRecord);
            updated[storageKey] = nextRecord[storageKey];
        }
        return (_updated = updated) !== null && _updated !== void 0 ? _updated : prevRecord;
    }
    for(var _storageKey2 in nextRecord){
        if (_storageKey2 === ERRORS_KEY) continue;
        var nextValue = nextRecord[_storageKey2];
        var nextErrors = nextErrorsByKey === null || nextErrorsByKey === void 0 ? void 0 : nextErrorsByKey[_storageKey2];
        if (updated == null) {
            var prevValue = prevRecord[_storageKey2];
            var prevErrors = prevErrorsByKey === null || prevErrorsByKey === void 0 ? void 0 : prevErrorsByKey[_storageKey2];
            if (areEqual(prevValue, nextValue) && areEqual(prevErrors, nextErrors)) continue;
            updated = (0, _objectSpread2["default"])({}, prevRecord);
            if (prevErrorsByKey != null) updated[ERRORS_KEY] = (0, _objectSpread2["default"])({}, prevErrorsByKey);
        }
        setValue(updated, _storageKey2, nextValue);
        setErrors(updated, _storageKey2, nextErrors);
    }
    return (_updated2 = updated) !== null && _updated2 !== void 0 ? _updated2 : prevRecord;
}
function merge(record1, record2) {
    var _getType3, _getType4, prevID, nextID, prevType, nextType;
    if (ERRORS_KEY in record1 || ERRORS_KEY in record2) {
        var errors1 = record1[ERRORS_KEY], fields1 = (0, _objectWithoutPropertiesLoose2["default"])(record1, [
            ERRORS_KEY
        ].map(_toPropertyKey2["default"]));
        var errors2 = record2[ERRORS_KEY], fields2 = (0, _objectWithoutPropertiesLoose2["default"])(record2, [
            ERRORS_KEY
        ].map(_toPropertyKey2["default"]));
        var updated = (0, _objectSpread2["default"])((0, _objectSpread2["default"])({}, fields1), fields2);
        if (errors1 == null && errors2 == null) return updated;
        var updatedErrors = {};
        for(var storageKey in errors1){
            if (fields2.hasOwnProperty(storageKey)) continue;
            updatedErrors[storageKey] = errors1[storageKey];
        }
        for(var _storageKey3 in errors2)updatedErrors[_storageKey3] = errors2[_storageKey3];
        for(var _storageKey in updatedErrors){
            updated[ERRORS_KEY] = updatedErrors;
            break;
        }
        return updated;
    } else return (0, _objectSpread2["default"])((0, _objectSpread2["default"])({}, record1), record2);
}
function freeze(record) {
    deepFreeze(record);
}
function setErrors(record, storageKey, errors) {
    var errorsByStorageKey = record[ERRORS_KEY];
    if (errors != null && errors.length > 0) {
        if (errorsByStorageKey == null) record[ERRORS_KEY] = (0, _defineProperty2["default"])({}, storageKey, errors);
        else errorsByStorageKey[storageKey] = errors;
    } else if (errorsByStorageKey != null) {
        if (delete errorsByStorageKey[storageKey]) {
            for(var otherStorageKey in errorsByStorageKey){
                if (errorsByStorageKey.hasOwnProperty(otherStorageKey)) return;
            }
            delete record[ERRORS_KEY];
        }
    }
}
function setValue(record, storageKey, value) {
    var prevID, _getType5, prevType, nextType;
    record[storageKey] = value;
}
function setLinkedRecordID(record, storageKey, linkedID) {
    var link = {};
    link[REF_KEY] = linkedID;
    record[storageKey] = link;
}
function setLinkedRecordIDs(record, storageKey, linkedIDs) {
    var links = {};
    links[REFS_KEY] = linkedIDs;
    record[storageKey] = links;
}
function setActorLinkedRecordID(record, storageKey, actorIdentifier, linkedID) {
    var link = {};
    link[REF_KEY] = linkedID;
    link[ACTOR_IDENTIFIER_KEY] = actorIdentifier;
    record[storageKey] = link;
}
function getActorLinkedRecordID(record, storageKey) {
    var link = record[storageKey];
    if (link == null) return link;
    !(typeof link === 'object' && typeof link[REF_KEY] === 'string' && link[ACTOR_IDENTIFIER_KEY] != null) && invariant(false);
    return [
        link[ACTOR_IDENTIFIER_KEY],
        link[REF_KEY]
    ];
}
function getResolverLinkedRecordID(record, typeName) {
    var id = getValue(record, RELAY_RESOLVER_VALUE_KEY);
    if (id == null || isSuspenseSentinel(id)) return null;
    if (typeof id === 'object') id = id.id;
    !(typeof id === 'string') && invariant(false);
    return generateClientObjectClientID(typeName, id);
}
function getResolverLinkedRecordIDs(record, typeName) {
    var resolverValue = getValue(record, RELAY_RESOLVER_VALUE_KEY);
    if (resolverValue == null || isSuspenseSentinel(resolverValue)) return null;
    !Array.isArray(resolverValue) && invariant(false);
    return resolverValue.map(function(id) {
        if (id == null) return null;
        if (typeof id === 'object') id = id.id;
        !(typeof id === 'string') && invariant(false);
        return generateClientObjectClientID(typeName, id);
    });
}
function toJSON(record) {
    return record;
}
module.exports = {
    clone: clone,
    copyFields: copyFields,
    create: create,
    freeze: freeze,
    fromObject: fromObject,
    getDataID: getDataID,
    getErrors: getErrors,
    getFields: getFields,
    getInvalidationEpoch: getInvalidationEpoch,
    getLinkedRecordID: getLinkedRecordID,
    getLinkedRecordIDs: getLinkedRecordIDs,
    getType: getType,
    getValue: getValue,
    hasValue: hasValue,
    hasLinkedRecordID: hasLinkedRecordID,
    hasLinkedRecordIDs: hasLinkedRecordIDs,
    merge: merge,
    setErrors: setErrors,
    setValue: setValue,
    setLinkedRecordID: setLinkedRecordID,
    setLinkedRecordIDs: setLinkedRecordIDs,
    update: update,
    getActorLinkedRecordID: getActorLinkedRecordID,
    setActorLinkedRecordID: setActorLinkedRecordID,
    getResolverLinkedRecordID: getResolverLinkedRecordID,
    getResolverLinkedRecordIDs: getResolverLinkedRecordIDs,
    toJSON: toJSON
};

},{"e20934cce7870264":"590td","e08036c033b0f038":"2paQ8","282f98f2b83101fd":"fkx57","12c6bd56199fa732":"ipoCP","5f7272e8a766f1ca":"2Bj1n","bb1eb520f7249af5":"eLea7","f69f2f81d03f7f45":"gL1rB","6582277efdb6cc75":"9sE63","260160fd026eb8a":"3QcrW","94ae5de66fe5c308":"eJLuG","76863a3a6402fa54":"e2sci","f92f3aed29cf0106":"j64TH"}],"fkx57":[function(require,module,exports,__globalThis) {
function _objectWithoutPropertiesLoose(r, e) {
    if (null == r) return {};
    var t = {};
    for(var n in r)if (({}).hasOwnProperty.call(r, n)) {
        if (-1 !== e.indexOf(n)) continue;
        t[n] = r[n];
    }
    return t;
}
module.exports = _objectWithoutPropertiesLoose, module.exports.__esModule = true, module.exports["default"] = module.exports;

},{}],"6w3KR":[function(require,module,exports,__globalThis) {
'use strict';
var _interopRequireDefault = require("2571edd9ed37d478")["default"];
var _createForOfIteratorHelper2 = _interopRequireDefault(require("2f61beb282e04314"));
var RelayModernRecord = require("fdfab58980a672ff");
var RelayRecordState = require("aa2b59f778ea6d7b");
var EXISTENT = RelayRecordState.EXISTENT, NONEXISTENT = RelayRecordState.NONEXISTENT, UNKNOWN = RelayRecordState.UNKNOWN;
var RelayRecordSource = /*#__PURE__*/ function() {
    function RelayRecordSource(records) {
        var _this = this;
        this._records = new Map();
        if (records != null) Object.keys(records).forEach(function(key) {
            var object = records[key];
            var record = RelayModernRecord.fromObject(object);
            _this._records.set(key, record);
        });
    }
    RelayRecordSource.create = function create(records) {
        return new RelayRecordSource(records);
    };
    var _proto = RelayRecordSource.prototype;
    _proto.clear = function clear() {
        this._records = new Map();
    };
    _proto["delete"] = function _delete(dataID) {
        this._records.set(dataID, null);
    };
    _proto.get = function get(dataID) {
        return this._records.get(dataID);
    };
    _proto.getRecordIDs = function getRecordIDs() {
        return Array.from(this._records.keys());
    };
    _proto.getStatus = function getStatus(dataID) {
        if (!this._records.has(dataID)) return UNKNOWN;
        return this._records.get(dataID) == null ? NONEXISTENT : EXISTENT;
    };
    _proto.has = function has(dataID) {
        return this._records.has(dataID);
    };
    _proto.remove = function remove(dataID) {
        this._records["delete"](dataID);
    };
    _proto.set = function set(dataID, record) {
        this._records.set(dataID, record);
    };
    _proto.size = function size() {
        return this._records.size;
    };
    _proto.toJSON = function toJSON() {
        var obj = {};
        var _iterator = (0, _createForOfIteratorHelper2["default"])(this._records), _step;
        try {
            for(_iterator.s(); !(_step = _iterator.n()).done;){
                var _step$value = _step.value, key = _step$value[0], record = _step$value[1];
                obj[key] = RelayModernRecord.toJSON(record);
            }
        } catch (err) {
            _iterator.e(err);
        } finally{
            _iterator.f();
        }
        return obj;
    };
    return RelayRecordSource;
}();
module.exports = RelayRecordSource;

},{"2571edd9ed37d478":"590td","2f61beb282e04314":"fMaLa","fdfab58980a672ff":"daXOB","aa2b59f778ea6d7b":"7LnXj"}],"7LnXj":[function(require,module,exports,__globalThis) {
'use strict';
var RelayRecordState = {
    EXISTENT: 'EXISTENT',
    NONEXISTENT: 'NONEXISTENT',
    UNKNOWN: 'UNKNOWN'
};
module.exports = RelayRecordState;

},{}],"1Dhjb":[function(require,module,exports,__globalThis) {
'use strict';
var _interopRequireDefault = require("df873de760308e88")["default"];
var _createForOfIteratorHelper2 = _interopRequireDefault(require("19e4715e54880d79"));
var _toConsumableArray2 = _interopRequireDefault(require("376bd52f74ec2411"));
var _require = require("1fd477e672927e5d"), ACTOR_IDENTIFIER_FIELD_NAME = _require.ACTOR_IDENTIFIER_FIELD_NAME, getActorIdentifierFromPayload = _require.getActorIdentifierFromPayload;
var RelayFeatureFlags = require("1920e0109bf1eee3");
var _require2 = require("5e368c51eb018148"), generateClientID = _require2.generateClientID, isClientID = _require2.isClientID;
var _require3 = require("371725a1b48f4443"), getLocalVariables = _require3.getLocalVariables;
var _require4 = require("fc29a7bfd7cc2cca"), buildErrorTrie = _require4.buildErrorTrie, getErrorsByKey = _require4.getErrorsByKey, getNestedErrorTrieByKey = _require4.getNestedErrorTrieByKey;
var RelayModernRecord = require("501de5d45a194d3d");
var _require5 = require("5d77e8646a841006"), createNormalizationSelector = _require5.createNormalizationSelector;
var _require6 = require("a74ea9d1e672473e"), ROOT_ID = _require6.ROOT_ID, TYPENAME_KEY = _require6.TYPENAME_KEY, getArgumentValues = _require6.getArgumentValues, getHandleStorageKey = _require6.getHandleStorageKey, getModuleComponentKey = _require6.getModuleComponentKey, getModuleOperationKey = _require6.getModuleOperationKey, getStorageKey = _require6.getStorageKey;
var _require7 = require("b80a2e178be1bab0"), TYPE_SCHEMA_TYPE = _require7.TYPE_SCHEMA_TYPE, generateTypeID = _require7.generateTypeID;
var areEqual = require("59b07874f96837bc");
var invariant = require("da88fa14bc87d3ff");
var warning = require("54c27045d9023979");
function normalize(recordSource, selector, response, options, errors, useExecTimeResolvers) {
    var dataID = selector.dataID, node = selector.node, variables = selector.variables;
    var normalizer = new RelayResponseNormalizer(recordSource, variables, options, useExecTimeResolvers !== null && useExecTimeResolvers !== void 0 ? useExecTimeResolvers : false);
    return normalizer.normalizeResponse(node, dataID, response, errors);
}
var RelayResponseNormalizer = /*#__PURE__*/ function() {
    function RelayResponseNormalizer(recordSource, variables, options, useExecTimeResolvers) {
        this._actorIdentifier = options.actorIdentifier;
        this._getDataId = options.getDataID;
        this._handleFieldPayloads = [];
        this._treatMissingFieldsAsNull = options.treatMissingFieldsAsNull;
        this._incrementalPlaceholders = [];
        this._isClientExtension = false;
        this._isUnmatchedAbstractType = false;
        this._useExecTimeResolvers = useExecTimeResolvers;
        this._followupPayloads = [];
        this._path = options.path ? (0, _toConsumableArray2["default"])(options.path) : [];
        this._recordSource = recordSource;
        this._variables = variables;
        this._shouldProcessClientComponents = options.shouldProcessClientComponents;
        this._log = options.log;
    }
    var _proto = RelayResponseNormalizer.prototype;
    _proto.normalizeResponse = function normalizeResponse(node, dataID, data, errors) {
        var record = this._recordSource.get(dataID);
        !record && invariant(false);
        this._assignClientAbstractTypes(node);
        this._errorTrie = buildErrorTrie(errors);
        this._traverseSelections(node, record, data);
        return {
            errors: errors,
            fieldPayloads: this._handleFieldPayloads,
            incrementalPlaceholders: this._incrementalPlaceholders,
            followupPayloads: this._followupPayloads,
            source: this._recordSource,
            isFinal: false
        };
    };
    _proto._assignClientAbstractTypes = function _assignClientAbstractTypes(node) {
        var clientAbstractTypes = node.clientAbstractTypes;
        if (clientAbstractTypes != null) for(var _i = 0, _Object$keys = Object.keys(clientAbstractTypes); _i < _Object$keys.length; _i++){
            var abstractType = _Object$keys[_i];
            var _iterator = (0, _createForOfIteratorHelper2["default"])(clientAbstractTypes[abstractType]), _step;
            try {
                for(_iterator.s(); !(_step = _iterator.n()).done;){
                    var concreteType = _step.value;
                    var typeID = generateTypeID(concreteType);
                    var typeRecord = this._recordSource.get(typeID);
                    if (typeRecord == null) {
                        typeRecord = RelayModernRecord.create(typeID, TYPE_SCHEMA_TYPE);
                        this._recordSource.set(typeID, typeRecord);
                    }
                    RelayModernRecord.setValue(typeRecord, abstractType, true);
                }
            } catch (err) {
                _iterator.e(err);
            } finally{
                _iterator.f();
            }
        }
    };
    _proto._getVariableValue = function _getVariableValue(name) {
        !this._variables.hasOwnProperty(name) && invariant(false);
        return this._variables[name];
    };
    _proto._getRecordType = function _getRecordType(data) {
        var typeName = data[TYPENAME_KEY];
        !(typeName != null) && invariant(false);
        return typeName;
    };
    _proto._traverseSelections = function _traverseSelections(node, record, data) {
        for(var i = 0; i < node.selections.length; i++){
            var selection = node.selections[i];
            switch(selection.kind){
                case 'ScalarField':
                case 'LinkedField':
                    this._normalizeField(selection, record, data);
                    break;
                case 'Condition':
                    var conditionValue = Boolean(this._getVariableValue(selection.condition));
                    if (conditionValue === selection.passingValue) this._traverseSelections(selection, record, data);
                    break;
                case 'FragmentSpread':
                    var prevVariables = this._variables;
                    this._variables = getLocalVariables(this._variables, selection.fragment.argumentDefinitions, selection.args);
                    this._traverseSelections(selection.fragment, record, data);
                    this._variables = prevVariables;
                    break;
                case 'InlineFragment':
                    var abstractKey = selection.abstractKey;
                    if (abstractKey == null) {
                        var typeName = RelayModernRecord.getType(record);
                        if (typeName === selection.type) this._traverseSelections(selection, record, data);
                    } else {
                        var implementsInterface = Object.prototype.hasOwnProperty.call(data, abstractKey);
                        var _typeName = RelayModernRecord.getType(record);
                        var typeID = generateTypeID(_typeName);
                        var typeRecord = this._recordSource.get(typeID);
                        if (typeRecord == null) {
                            typeRecord = RelayModernRecord.create(typeID, TYPE_SCHEMA_TYPE);
                            this._recordSource.set(typeID, typeRecord);
                        }
                        RelayModernRecord.setValue(typeRecord, abstractKey, implementsInterface);
                        if (implementsInterface) this._traverseSelections(selection, record, data);
                    }
                    break;
                case 'TypeDiscriminator':
                    var _abstractKey = selection.abstractKey;
                    var _implementsInterface = Object.prototype.hasOwnProperty.call(data, _abstractKey);
                    var _typeName2 = RelayModernRecord.getType(record);
                    var _typeID = generateTypeID(_typeName2);
                    var _typeRecord = this._recordSource.get(_typeID);
                    if (_typeRecord == null) {
                        _typeRecord = RelayModernRecord.create(_typeID, TYPE_SCHEMA_TYPE);
                        this._recordSource.set(_typeID, _typeRecord);
                    }
                    RelayModernRecord.setValue(_typeRecord, _abstractKey, _implementsInterface);
                    break;
                case 'LinkedHandle':
                case 'ScalarHandle':
                    var args = selection.args ? getArgumentValues(selection.args, this._variables) : {};
                    var fieldKey = getStorageKey(selection, this._variables);
                    var handleKey = getHandleStorageKey(selection, this._variables);
                    this._handleFieldPayloads.push({
                        args: args,
                        dataID: RelayModernRecord.getDataID(record),
                        fieldKey: fieldKey,
                        handle: selection.handle,
                        handleKey: handleKey,
                        handleArgs: selection.handleArgs ? getArgumentValues(selection.handleArgs, this._variables) : {}
                    });
                    break;
                case 'ModuleImport':
                    this._normalizeModuleImport(selection, record, data);
                    break;
                case 'Defer':
                    this._normalizeDefer(selection, record, data);
                    break;
                case 'Stream':
                    this._normalizeStream(selection, record, data);
                    break;
                case 'ClientExtension':
                    var isClientExtension = this._isClientExtension;
                    this._isClientExtension = true;
                    this._traverseSelections(selection, record, data);
                    this._isClientExtension = isClientExtension;
                    break;
                case 'ClientComponent':
                    if (this._shouldProcessClientComponents === false) break;
                    this._traverseSelections(selection.fragment, record, data);
                    break;
                case 'ActorChange':
                    this._normalizeActorChange(selection, record, data);
                    break;
                case 'RelayResolver':
                case 'RelayLiveResolver':
                    if (!this._useExecTimeResolvers) this._normalizeResolver(selection, record, data);
                    break;
                case 'ClientEdgeToClientObject':
                    if (!this._useExecTimeResolvers) this._normalizeResolver(selection.backingField, record, data);
                    break;
                default:
                    selection;
                    invariant(false);
            }
        }
    };
    _proto._normalizeResolver = function _normalizeResolver(resolver, record, data) {
        if (resolver.fragment != null) this._traverseSelections(resolver.fragment, record, data);
    };
    _proto._normalizeDefer = function _normalizeDefer(defer, record, data) {
        var isDeferred = defer["if"] === null || this._getVariableValue(defer["if"]);
        if (isDeferred === false) this._traverseSelections(defer, record, data);
        else this._incrementalPlaceholders.push({
            kind: 'defer',
            data: data,
            label: defer.label,
            path: (0, _toConsumableArray2["default"])(this._path),
            selector: createNormalizationSelector(defer, RelayModernRecord.getDataID(record), this._variables),
            typeName: RelayModernRecord.getType(record),
            actorIdentifier: this._actorIdentifier
        });
    };
    _proto._normalizeStream = function _normalizeStream(stream, record, data) {
        this._traverseSelections(stream, record, data);
        var isStreamed = stream["if"] === null || this._getVariableValue(stream["if"]);
        if (isStreamed === true) this._incrementalPlaceholders.push({
            kind: 'stream',
            label: stream.label,
            path: (0, _toConsumableArray2["default"])(this._path),
            parentID: RelayModernRecord.getDataID(record),
            node: stream,
            variables: this._variables,
            actorIdentifier: this._actorIdentifier
        });
    };
    _proto._normalizeModuleImport = function _normalizeModuleImport(moduleImport, record, data) {
        !(typeof data === 'object' && data) && invariant(false);
        var typeName = RelayModernRecord.getType(record);
        var componentKey = getModuleComponentKey(moduleImport.documentName);
        var componentReference = moduleImport.componentModuleProvider || data[componentKey];
        RelayModernRecord.setValue(record, componentKey, componentReference !== null && componentReference !== void 0 ? componentReference : null);
        var operationKey = getModuleOperationKey(moduleImport.documentName);
        var operationReference = moduleImport.operationModuleProvider || data[operationKey];
        RelayModernRecord.setValue(record, operationKey, operationReference !== null && operationReference !== void 0 ? operationReference : null);
        if (operationReference != null) this._followupPayloads.push({
            kind: 'ModuleImportPayload',
            args: moduleImport.args,
            data: data,
            dataID: RelayModernRecord.getDataID(record),
            operationReference: operationReference,
            path: (0, _toConsumableArray2["default"])(this._path),
            typeName: typeName,
            variables: this._variables,
            actorIdentifier: this._actorIdentifier
        });
    };
    _proto._normalizeField = function _normalizeField(selection, record, data) {
        !(typeof data === 'object' && data) && invariant(false);
        var responseKey = selection.alias || selection.name;
        var storageKey = getStorageKey(selection, this._variables);
        var fieldValue = data[responseKey];
        var isNoncompliantlyNullish = RelayFeatureFlags.ENABLE_NONCOMPLIANT_ERROR_HANDLING_ON_LISTS && Array.isArray(fieldValue) && fieldValue.length === 0;
        if (fieldValue == null || isNoncompliantlyNullish) {
            if (fieldValue === undefined) {
                var isOptionalField = this._isClientExtension || this._isUnmatchedAbstractType;
                if (isOptionalField) return;
                else if (!this._treatMissingFieldsAsNull) return;
            }
            if (selection.kind === 'ScalarField') this._validateConflictingFieldsWithIdenticalId(record, storageKey, null);
            if (isNoncompliantlyNullish) {
                if (selection.kind === 'LinkedField') RelayModernRecord.setLinkedRecordIDs(record, storageKey, []);
                else RelayModernRecord.setValue(record, storageKey, []);
            } else RelayModernRecord.setValue(record, storageKey, null);
            var errorTrie = this._errorTrie;
            if (errorTrie != null) {
                var errors = getErrorsByKey(errorTrie, responseKey);
                if (errors != null) RelayModernRecord.setErrors(record, storageKey, errors);
            }
            return;
        }
        if (selection.kind === 'ScalarField') {
            this._validateConflictingFieldsWithIdenticalId(record, storageKey, fieldValue);
            RelayModernRecord.setValue(record, storageKey, fieldValue);
        } else if (selection.kind === 'LinkedField') {
            this._path.push(responseKey);
            var oldErrorTrie = this._errorTrie;
            this._errorTrie = oldErrorTrie == null ? null : getNestedErrorTrieByKey(oldErrorTrie, responseKey);
            if (selection.plural) this._normalizePluralLink(selection, record, storageKey, fieldValue);
            else this._normalizeLink(selection, record, storageKey, fieldValue);
            this._errorTrie = oldErrorTrie;
            this._path.pop();
        } else {
            selection;
            invariant(false);
        }
    };
    _proto._normalizeActorChange = function _normalizeActorChange(selection, record, data) {
        var _field$concreteType;
        var field = selection.linkedField;
        !(typeof data === 'object' && data) && invariant(false);
        var responseKey = field.alias || field.name;
        var storageKey = getStorageKey(field, this._variables);
        var fieldValue = data[responseKey];
        if (fieldValue == null) {
            if (fieldValue === undefined) {
                var isOptionalField = this._isClientExtension || this._isUnmatchedAbstractType;
                if (isOptionalField) return;
                else if (!this._treatMissingFieldsAsNull) return;
            }
            RelayModernRecord.setValue(record, storageKey, null);
            return;
        }
        var actorIdentifier = getActorIdentifierFromPayload(fieldValue);
        if (actorIdentifier == null) {
            RelayModernRecord.setValue(record, storageKey, null);
            return;
        }
        var typeName = (_field$concreteType = field.concreteType) !== null && _field$concreteType !== void 0 ? _field$concreteType : this._getRecordType(fieldValue);
        var nextID = this._getDataId(fieldValue, typeName) || RelayModernRecord.getLinkedRecordID(record, storageKey) || generateClientID(RelayModernRecord.getDataID(record), storageKey);
        !(typeof nextID === 'string') && invariant(false);
        RelayModernRecord.setActorLinkedRecordID(record, storageKey, actorIdentifier, nextID);
        this._followupPayloads.push({
            kind: 'ActorPayload',
            data: fieldValue,
            dataID: nextID,
            path: [].concat((0, _toConsumableArray2["default"])(this._path), [
                responseKey
            ]),
            typeName: typeName,
            variables: this._variables,
            node: field,
            actorIdentifier: actorIdentifier
        });
    };
    _proto._normalizeLink = function _normalizeLink(field, record, storageKey, fieldValue) {
        var _field$concreteType2;
        !(typeof fieldValue === 'object' && fieldValue) && invariant(false);
        var nextID = this._getDataId(fieldValue, (_field$concreteType2 = field.concreteType) !== null && _field$concreteType2 !== void 0 ? _field$concreteType2 : this._getRecordType(fieldValue)) || RelayModernRecord.getLinkedRecordID(record, storageKey) || generateClientID(RelayModernRecord.getDataID(record), storageKey);
        !(typeof nextID === 'string') && invariant(false);
        this._validateConflictingLinkedFieldsWithIdenticalId(RelayModernRecord.getLinkedRecordID(record, storageKey), nextID, storageKey);
        RelayModernRecord.setLinkedRecordID(record, storageKey, nextID);
        var nextRecord = this._recordSource.get(nextID);
        if (!nextRecord) {
            var typeName = field.concreteType || this._getRecordType(fieldValue);
            nextRecord = RelayModernRecord.create(nextID, typeName);
            this._recordSource.set(nextID, nextRecord);
        } else this._validateRecordType(nextRecord, field, fieldValue);
        this._traverseSelections(field, nextRecord, fieldValue);
    };
    _proto._normalizePluralLink = function _normalizePluralLink(field, record, storageKey, fieldValue) {
        var _this = this;
        !Array.isArray(fieldValue) && invariant(false);
        var prevIDs = RelayModernRecord.getLinkedRecordIDs(record, storageKey);
        var nextIDs = [];
        fieldValue.forEach(function(item, nextIndex) {
            var _field$concreteType3;
            if (item == null) {
                nextIDs.push(item);
                return;
            }
            _this._path.push(String(nextIndex));
            var oldErrorTrie = _this._errorTrie;
            _this._errorTrie = oldErrorTrie == null ? null : getNestedErrorTrieByKey(oldErrorTrie, nextIndex);
            !(typeof item === 'object') && invariant(false);
            var nextID = _this._getDataId(item, (_field$concreteType3 = field.concreteType) !== null && _field$concreteType3 !== void 0 ? _field$concreteType3 : _this._getRecordType(item)) || prevIDs && prevIDs[nextIndex] || generateClientID(RelayModernRecord.getDataID(record), storageKey, nextIndex);
            !(typeof nextID === 'string') && invariant(false);
            nextIDs.push(nextID);
            var nextRecord = _this._recordSource.get(nextID);
            if (!nextRecord) {
                var typeName = field.concreteType || _this._getRecordType(item);
                nextRecord = RelayModernRecord.create(nextID, typeName);
                _this._recordSource.set(nextID, nextRecord);
            } else _this._validateRecordType(nextRecord, field, item);
            if (prevIDs) _this._validateConflictingLinkedFieldsWithIdenticalId(prevIDs[nextIndex], nextID, storageKey);
            _this._traverseSelections(field, nextRecord, item);
            _this._errorTrie = oldErrorTrie;
            _this._path.pop();
        });
        RelayModernRecord.setLinkedRecordIDs(record, storageKey, nextIDs);
    };
    _proto._validateRecordType = function _validateRecordType(record, field, payload) {
        if (RelayFeatureFlags.ENABLE_STORE_ID_COLLISION_LOGGING) {
            var _field$concreteType4;
            var typeName = (_field$concreteType4 = field.concreteType) !== null && _field$concreteType4 !== void 0 ? _field$concreteType4 : this._getRecordType(payload);
            var dataID = RelayModernRecord.getDataID(record);
            var expected = isClientID(dataID) && dataID !== ROOT_ID || RelayModernRecord.getType(record) === typeName;
            if (!expected) {
                var logEvent = {
                    name: 'idCollision.typename',
                    previous_typename: RelayModernRecord.getType(record),
                    new_typename: typeName
                };
                if (this._log != null) this._log(logEvent);
            }
        }
        var _field$concreteType5, _typeName3, _dataID, _expected;
    };
    _proto._validateConflictingFieldsWithIdenticalId = function _validateConflictingFieldsWithIdenticalId(record, storageKey, fieldValue) {
        var previousValue, dataID, expected;
    };
    _proto._validateConflictingLinkedFieldsWithIdenticalId = function _validateConflictingLinkedFieldsWithIdenticalId(prevID, nextID, storageKey) {
        var expected;
    };
    return RelayResponseNormalizer;
}();
module.exports = {
    normalize: normalize
};

},{"df873de760308e88":"590td","19e4715e54880d79":"fMaLa","376bd52f74ec2411":"7EBX0","1fd477e672927e5d":"fHHco","1920e0109bf1eee3":"a0FL5","5e368c51eb018148":"gL1rB","371725a1b48f4443":"138Hd","fc29a7bfd7cc2cca":"dj062","501de5d45a194d3d":"daXOB","5d77e8646a841006":"9k2Dg","a74ea9d1e672473e":"3QcrW","b80a2e178be1bab0":"32ztQ","59b07874f96837bc":"eJLuG","da88fa14bc87d3ff":"e2sci","54c27045d9023979":"j64TH"}],"fHHco":[function(require,module,exports,__globalThis) {
'use strict';
var ACTOR_IDENTIFIER_FIELD_NAME = 'actor_key';
var _require = require("6331126f47d7c070"), getActorIdentifier = _require.getActorIdentifier;
function getActorIdentifierFromPayload(payload) {
    if (payload != null && typeof payload === 'object' && typeof payload[ACTOR_IDENTIFIER_FIELD_NAME] === 'string') return getActorIdentifier(payload[ACTOR_IDENTIFIER_FIELD_NAME]);
}
module.exports = {
    ACTOR_IDENTIFIER_FIELD_NAME: ACTOR_IDENTIFIER_FIELD_NAME,
    getActorIdentifierFromPayload: getActorIdentifierFromPayload
};

},{"6331126f47d7c070":"cFrVW"}],"cFrVW":[function(require,module,exports,__globalThis) {
'use strict';
var invariant = require("defa775d903de379");
var INTERNAL_ACTOR_IDENTIFIER_DO_NOT_USE = 'INTERNAL_ACTOR_IDENTIFIER_DO_NOT_USE';
function assertInternalActorIdentifier(actorIdentifier) {
    !(actorIdentifier === INTERNAL_ACTOR_IDENTIFIER_DO_NOT_USE) && invariant(false);
}
module.exports = {
    assertInternalActorIdentifier: assertInternalActorIdentifier,
    getActorIdentifier: function getActorIdentifier(actorID) {
        return actorID;
    },
    getDefaultActorIdentifier: function getDefaultActorIdentifier() {
        throw new Error('Not Implemented');
    },
    INTERNAL_ACTOR_IDENTIFIER_DO_NOT_USE: INTERNAL_ACTOR_IDENTIFIER_DO_NOT_USE
};

},{"defa775d903de379":"e2sci"}],"dj062":[function(require,module,exports,__globalThis) {
'use strict';
var _interopRequireDefault = require("1a8a6c412d7b45de")["default"];
var _objectSpread2 = _interopRequireDefault(require("3ad82f5e1735e8de"));
var _objectWithoutPropertiesLoose2 = _interopRequireDefault(require("19c9531be19392f3"));
var _createForOfIteratorHelper2 = _interopRequireDefault(require("780cd31b871a2c1e"));
var _toConsumableArray2 = _interopRequireDefault(require("d4b725a3935a02a3"));
var _excluded = [
    "path",
    "locations"
];
var SELF = Symbol('$SELF');
function buildErrorTrie(errors) {
    if (errors == null) return null;
    var trie = new Map();
    var _iterator = (0, _createForOfIteratorHelper2["default"])(errors), _step;
    try {
        ERRORS: for(_iterator.s(); !(_step = _iterator.n()).done;){
            var _step$value = _step.value, path = _step$value.path, _ = _step$value.locations, error = (0, _objectWithoutPropertiesLoose2["default"])(_step$value, _excluded);
            if (path == null) continue;
            var length = path.length;
            if (length === 0) continue;
            var lastIndex = length - 1;
            var currentTrie = trie;
            for(var index = 0; index < lastIndex; index++){
                var key = path[index];
                var existingValue = currentTrie.get(key);
                if (existingValue instanceof Map) {
                    currentTrie = existingValue;
                    continue;
                }
                var newValue = new Map();
                if (Array.isArray(existingValue)) newValue.set(SELF, existingValue);
                currentTrie.set(key, newValue);
                currentTrie = newValue;
            }
            var lastKey = path[lastIndex];
            var container = currentTrie.get(lastKey);
            if (container instanceof Map) {
                currentTrie = container;
                container = currentTrie.get(lastKey);
                lastKey = SELF;
            }
            if (Array.isArray(container)) container.push(error);
            else currentTrie.set(lastKey, [
                error
            ]);
        }
    } catch (err) {
        _iterator.e(err);
    } finally{
        _iterator.f();
    }
    return trie;
}
function getErrorsByKey(trie, key) {
    var value = trie.get(key);
    if (value == null) return null;
    if (Array.isArray(value)) return value;
    var errors = [];
    recursivelyCopyErrorsIntoArray(value, errors);
    return errors;
}
function recursivelyCopyErrorsIntoArray(trieOrSet, errors) {
    var _iterator2 = (0, _createForOfIteratorHelper2["default"])(trieOrSet), _step2;
    try {
        for(_iterator2.s(); !(_step2 = _iterator2.n()).done;){
            var _step2$value = _step2.value, childKey = _step2$value[0], value = _step2$value[1];
            var oldLength = errors.length;
            if (Array.isArray(value)) errors.push.apply(errors, (0, _toConsumableArray2["default"])(value));
            else recursivelyCopyErrorsIntoArray(value, errors);
            if (childKey === SELF) continue;
            var newLength = errors.length;
            for(var index = oldLength; index < newLength; index++){
                var error = errors[index];
                if (error.path == null) errors[index] = (0, _objectSpread2["default"])((0, _objectSpread2["default"])({}, error), {}, {
                    path: [
                        childKey
                    ]
                });
                else error.path.unshift(childKey);
            }
        }
    } catch (err) {
        _iterator2.e(err);
    } finally{
        _iterator2.f();
    }
}
function getNestedErrorTrieByKey(trie, key) {
    var value = trie.get(key);
    if (value instanceof Map) return value;
    return null;
}
module.exports = {
    SELF: SELF,
    buildErrorTrie: buildErrorTrie,
    getNestedErrorTrieByKey: getNestedErrorTrieByKey,
    getErrorsByKey: getErrorsByKey
};

},{"1a8a6c412d7b45de":"590td","3ad82f5e1735e8de":"2Bj1n","19c9531be19392f3":"fkx57","780cd31b871a2c1e":"fMaLa","d4b725a3935a02a3":"7EBX0"}],"32ztQ":[function(require,module,exports,__globalThis) {
'use strict';
var PREFIX = 'client:__type:';
var TYPE_SCHEMA_TYPE = '__TypeSchema';
function generateTypeID(typeName) {
    return PREFIX + typeName;
}
function isTypeID(id) {
    return id.indexOf(PREFIX) === 0;
}
module.exports = {
    generateTypeID: generateTypeID,
    isTypeID: isTypeID,
    TYPE_SCHEMA_TYPE: TYPE_SCHEMA_TYPE
};

},{}],"6Td1y":[function(require,module,exports,__globalThis) {
'use strict';
var _require = require("dc63f63d5b302131"), getInlineDataFragment = _require.getInlineDataFragment;
var _require2 = require("9f47d4cdd836a0f0"), FRAGMENTS_KEY = _require2.FRAGMENTS_KEY;
var invariant = require("21b0e475cc65ae48");
function readInlineData(fragment, fragmentRef) {
    var _fragmentRef$FRAGMENT;
    var inlineDataFragment = getInlineDataFragment(fragment);
    if (fragmentRef == null) return fragmentRef;
    !(typeof fragmentRef === 'object') && invariant(false);
    var inlineData = (_fragmentRef$FRAGMENT = fragmentRef[FRAGMENTS_KEY]) === null || _fragmentRef$FRAGMENT === void 0 ? void 0 : _fragmentRef$FRAGMENT[inlineDataFragment.name];
    !(inlineData != null) && invariant(false);
    return inlineData;
}
module.exports = readInlineData;

},{"dc63f63d5b302131":"8UTII","9f47d4cdd836a0f0":"3QcrW","21b0e475cc65ae48":"e2sci"}],"3xHmQ":[function(require,module,exports,__globalThis) {
'use strict';
var _interopRequireDefault = require("7e7a4d1fbf8c82fe")["default"];
var _objectSpread2 = _interopRequireDefault(require("6b4f3b63f4065ac0"));
var RelayDefaultHandlerProvider = require("7cea7b1ea2aa8697");
var _require = require("bc2448eae6d9e860"), INTERNAL_ACTOR_IDENTIFIER_DO_NOT_USE = _require.INTERNAL_ACTOR_IDENTIFIER_DO_NOT_USE, assertInternalActorIdentifier = _require.assertInternalActorIdentifier;
var RelayObservable = require("98122506f5fdd2ff");
var wrapNetworkWithLogObserver = require("f7617b7cd8a4e2b");
var RelayOperationTracker = require("83a7c02ef79bf09f");
var registerEnvironmentWithDevTools = require("e6be5f00728d6970");
var defaultGetDataID = require("b7c0545674dd33ad");
var defaultRelayFieldLogger = require("32f88f20a98f5fb0");
var normalizeResponse = require("7080a5669857b59a");
var OperationExecutor = require("c106ae6e1db32a6");
var RelayModernStore = require("9a7a29970442f76d");
var RelayPublishQueue = require("dddf5d64bb73e9cf");
var RelayRecordSource = require("c7afdb12a0678cff");
var invariant = require("d019df3102764664");
var RelayModernEnvironment = /*#__PURE__*/ function() {
    function RelayModernEnvironment(config) {
        var _this = this;
        var _config$store, _config$log, _config$relayFieldLog, _config$UNSTABLE_defa, _config$getDataID, _config$missingFieldH, _config$handlerProvid, _config$scheduler, _config$isServer, _config$normalizeResp, _config$operationTrac;
        this.configName = config.configName;
        this._treatMissingFieldsAsNull = config.treatMissingFieldsAsNull === true;
        var operationLoader = config.operationLoader;
        var store = (_config$store = config.store) !== null && _config$store !== void 0 ? _config$store : new RelayModernStore(new RelayRecordSource(), {
            log: config.log,
            operationLoader: config.operationLoader,
            getDataID: config.getDataID,
            shouldProcessClientComponents: config.shouldProcessClientComponents
        });
        this.__log = (_config$log = config.log) !== null && _config$log !== void 0 ? _config$log : emptyFunction;
        this.relayFieldLogger = (_config$relayFieldLog = config.relayFieldLogger) !== null && _config$relayFieldLog !== void 0 ? _config$relayFieldLog : defaultRelayFieldLogger;
        this._defaultRenderPolicy = (_config$UNSTABLE_defa = config.UNSTABLE_defaultRenderPolicy) !== null && _config$UNSTABLE_defa !== void 0 ? _config$UNSTABLE_defa : 'partial';
        this._operationLoader = operationLoader;
        this._operationExecutions = new Map();
        this._network = wrapNetworkWithLogObserver(this, config.network);
        this._getDataID = (_config$getDataID = config.getDataID) !== null && _config$getDataID !== void 0 ? _config$getDataID : defaultGetDataID;
        this._missingFieldHandlers = (_config$missingFieldH = config.missingFieldHandlers) !== null && _config$missingFieldH !== void 0 ? _config$missingFieldH : [];
        this._publishQueue = new RelayPublishQueue(store, (_config$handlerProvid = config.handlerProvider) !== null && _config$handlerProvid !== void 0 ? _config$handlerProvid : RelayDefaultHandlerProvider, this._getDataID, this._missingFieldHandlers, this.__log);
        this._scheduler = (_config$scheduler = config.scheduler) !== null && _config$scheduler !== void 0 ? _config$scheduler : null;
        this._store = store;
        this.options = config.options;
        this._isServer = (_config$isServer = config.isServer) !== null && _config$isServer !== void 0 ? _config$isServer : false;
        this._normalizeResponse = (_config$normalizeResp = config.normalizeResponse) !== null && _config$normalizeResp !== void 0 ? _config$normalizeResp : normalizeResponse;
        this.__setNet = function(newNet) {
            return _this._network = wrapNetworkWithLogObserver(_this, newNet);
        };
        var _require2, inspect;
        this._operationTracker = (_config$operationTrac = config.operationTracker) !== null && _config$operationTrac !== void 0 ? _config$operationTrac : new RelayOperationTracker();
        this._shouldProcessClientComponents = config.shouldProcessClientComponents;
        registerEnvironmentWithDevTools(this);
    }
    var _proto = RelayModernEnvironment.prototype;
    _proto.getStore = function getStore() {
        return this._store;
    };
    _proto.getNetwork = function getNetwork() {
        return this._network;
    };
    _proto.getOperationTracker = function getOperationTracker() {
        return this._operationTracker;
    };
    _proto.getScheduler = function getScheduler() {
        return this._scheduler;
    };
    _proto.isRequestActive = function isRequestActive(requestIdentifier) {
        var activeState = this._operationExecutions.get(requestIdentifier);
        return activeState === 'active';
    };
    _proto.UNSTABLE_getDefaultRenderPolicy = function UNSTABLE_getDefaultRenderPolicy() {
        return this._defaultRenderPolicy;
    };
    _proto.applyUpdate = function applyUpdate(optimisticUpdate) {
        var _this2 = this;
        var dispose = function dispose() {
            _this2._scheduleUpdates(function() {
                _this2._publishQueue.revertUpdate(optimisticUpdate);
                _this2._publishQueue.run();
            });
        };
        this._scheduleUpdates(function() {
            _this2._publishQueue.applyUpdate(optimisticUpdate);
            _this2._publishQueue.run();
        });
        return {
            dispose: dispose
        };
    };
    _proto.revertUpdate = function revertUpdate(update) {
        var _this3 = this;
        this._scheduleUpdates(function() {
            _this3._publishQueue.revertUpdate(update);
            _this3._publishQueue.run();
        });
    };
    _proto.replaceUpdate = function replaceUpdate(update, newUpdate) {
        var _this4 = this;
        this._scheduleUpdates(function() {
            _this4._publishQueue.revertUpdate(update);
            _this4._publishQueue.applyUpdate(newUpdate);
            _this4._publishQueue.run();
        });
    };
    _proto.applyMutation = function applyMutation(optimisticConfig) {
        var subscription = this._execute({
            createSource: function createSource() {
                return RelayObservable.create(function(_sink) {});
            },
            isClientPayload: false,
            operation: optimisticConfig.operation,
            optimisticConfig: optimisticConfig,
            updater: null
        }).subscribe({});
        return {
            dispose: function dispose() {
                return subscription.unsubscribe();
            }
        };
    };
    _proto.check = function check(operation) {
        if (this._missingFieldHandlers.length === 0 && !operationHasClientAbstractTypes(operation)) return this._store.check(operation);
        return this._checkSelectorAndHandleMissingFields(operation, this._missingFieldHandlers);
    };
    _proto.commitPayload = function commitPayload(operation, payload) {
        this._execute({
            createSource: function createSource() {
                return RelayObservable.from({
                    data: payload
                });
            },
            isClientPayload: true,
            operation: operation,
            optimisticConfig: null,
            updater: null
        }).subscribe({});
    };
    _proto.commitUpdate = function commitUpdate(updater) {
        var _this5 = this;
        this._scheduleUpdates(function() {
            _this5._publishQueue.commitUpdate(updater);
            _this5._publishQueue.run();
        });
    };
    _proto.lookup = function lookup(readSelector) {
        return this._store.lookup(readSelector);
    };
    _proto.subscribe = function subscribe(snapshot, callback) {
        return this._store.subscribe(snapshot, callback);
    };
    _proto.retain = function retain(operation) {
        return this._store.retain(operation);
    };
    _proto.isServer = function isServer() {
        return this._isServer;
    };
    _proto._checkSelectorAndHandleMissingFields = function _checkSelectorAndHandleMissingFields(operation, handlers) {
        var _this6 = this;
        var target = RelayRecordSource.create();
        var source = this._store.getSource();
        var result = this._store.check(operation, {
            handlers: handlers,
            defaultActorIdentifier: INTERNAL_ACTOR_IDENTIFIER_DO_NOT_USE,
            getSourceForActor: function getSourceForActor(actorIdentifier) {
                assertInternalActorIdentifier(actorIdentifier);
                return source;
            },
            getTargetForActor: function getTargetForActor(actorIdentifier) {
                assertInternalActorIdentifier(actorIdentifier);
                return target;
            }
        });
        if (target.size() > 0) this._scheduleUpdates(function() {
            _this6._publishQueue.commitSource(target);
            _this6._publishQueue.run();
        });
        return result;
    };
    _proto._scheduleUpdates = function _scheduleUpdates(task) {
        var scheduler = this._scheduler;
        if (scheduler != null) scheduler.schedule(task);
        else task();
    };
    _proto.execute = function execute(_ref) {
        var _this7 = this;
        var operation = _ref.operation;
        return this._execute({
            createSource: function createSource() {
                return _this7.getNetwork().execute(operation.request.node.params, operation.request.variables, operation.request.cacheConfig || {}, null, undefined, undefined, undefined, function() {
                    return _this7.check(operation);
                });
            },
            isClientPayload: false,
            operation: operation,
            optimisticConfig: null,
            updater: null
        });
    };
    _proto.executeSubscription = function executeSubscription(_ref2) {
        var _this8 = this;
        var operation = _ref2.operation, updater = _ref2.updater;
        return this._execute({
            createSource: function createSource() {
                return _this8.getNetwork().execute(operation.request.node.params, operation.request.variables, operation.request.cacheConfig || {}, null);
            },
            isClientPayload: false,
            operation: operation,
            optimisticConfig: null,
            updater: updater
        });
    };
    _proto.executeMutation = function executeMutation(_ref3) {
        var _this9 = this;
        var operation = _ref3.operation, optimisticResponse = _ref3.optimisticResponse, optimisticUpdater = _ref3.optimisticUpdater, updater = _ref3.updater, uploadables = _ref3.uploadables;
        var optimisticConfig;
        if (optimisticResponse || optimisticUpdater) optimisticConfig = {
            operation: operation,
            response: optimisticResponse,
            updater: optimisticUpdater
        };
        return this._execute({
            createSource: function createSource() {
                return _this9.getNetwork().execute(operation.request.node.params, operation.request.variables, (0, _objectSpread2["default"])((0, _objectSpread2["default"])({}, operation.request.cacheConfig), {}, {
                    force: true
                }), uploadables);
            },
            isClientPayload: false,
            operation: operation,
            optimisticConfig: optimisticConfig,
            updater: updater
        });
    };
    _proto.executeWithSource = function executeWithSource(_ref4) {
        var operation = _ref4.operation, source = _ref4.source;
        return this._execute({
            createSource: function createSource() {
                return source;
            },
            isClientPayload: false,
            operation: operation,
            optimisticConfig: null,
            updater: null
        });
    };
    _proto.toJSON = function toJSON() {
        var _this$configName;
        return "RelayModernEnvironment(".concat((_this$configName = this.configName) !== null && _this$configName !== void 0 ? _this$configName : '', ")");
    };
    _proto._execute = function _execute(_ref5) {
        var _this10 = this;
        var createSource = _ref5.createSource, isClientPayload = _ref5.isClientPayload, operation = _ref5.operation, optimisticConfig = _ref5.optimisticConfig, updater = _ref5.updater;
        var publishQueue = this._publishQueue;
        var store = this._store;
        return RelayObservable.create(function(sink) {
            var executor = OperationExecutor.execute({
                actorIdentifier: INTERNAL_ACTOR_IDENTIFIER_DO_NOT_USE,
                getDataID: _this10._getDataID,
                isClientPayload: isClientPayload,
                log: _this10.__log,
                operation: operation,
                operationExecutions: _this10._operationExecutions,
                operationLoader: _this10._operationLoader,
                operationTracker: _this10._operationTracker,
                optimisticConfig: optimisticConfig,
                getPublishQueue: function getPublishQueue(actorIdentifier) {
                    assertInternalActorIdentifier(actorIdentifier);
                    return publishQueue;
                },
                scheduler: _this10._scheduler,
                shouldProcessClientComponents: _this10._shouldProcessClientComponents,
                sink: sink,
                source: createSource(),
                getStore: function getStore(actorIdentifier) {
                    assertInternalActorIdentifier(actorIdentifier);
                    return store;
                },
                treatMissingFieldsAsNull: _this10._treatMissingFieldsAsNull,
                updater: updater,
                normalizeResponse: _this10._normalizeResponse
            });
            return function() {
                return executor.cancel();
            };
        });
    };
    return RelayModernEnvironment;
}();
function operationHasClientAbstractTypes(operation) {
    return operation.root.node.kind === 'Operation' && operation.root.node.clientAbstractTypes != null;
}
RelayModernEnvironment.prototype['@@RelayModernEnvironment'] = true;
function emptyFunction() {}
module.exports = RelayModernEnvironment;

},{"7e7a4d1fbf8c82fe":"590td","6b4f3b63f4065ac0":"2Bj1n","7cea7b1ea2aa8697":"kUOrY","bc2448eae6d9e860":"cFrVW","98122506f5fdd2ff":"hYmcP","f7617b7cd8a4e2b":"7uVpm","83a7c02ef79bf09f":"5bEuR","e6be5f00728d6970":"ffTSI","b7c0545674dd33ad":"febBR","32f88f20a98f5fb0":"h7crC","7080a5669857b59a":"afJiB","c106ae6e1db32a6":"jI7gk","9a7a29970442f76d":"UtVKb","dddf5d64bb73e9cf":"8vVqI","c7afdb12a0678cff":"6w3KR","d019df3102764664":"e2sci"}],"7uVpm":[function(require,module,exports,__globalThis) {
'use strict';
var generateID = require("4a0bfb7e5aa469bd");
function wrapNetworkWithLogObserver(env, network) {
    return {
        execute: function execute(params, variables, cacheConfig, uploadables, _, encryptedVariables, preprocessResponse, checkOperation) {
            var networkRequestId = generateID();
            var logObserver = {
                start: function start(subscription) {
                    env.__log({
                        name: 'network.start',
                        networkRequestId: networkRequestId,
                        params: params,
                        variables: variables,
                        cacheConfig: cacheConfig
                    });
                },
                next: function next(response) {
                    env.__log({
                        name: 'network.next',
                        networkRequestId: networkRequestId,
                        response: response
                    });
                },
                error: function error(_error) {
                    env.__log({
                        name: 'network.error',
                        networkRequestId: networkRequestId,
                        error: _error
                    });
                },
                complete: function complete() {
                    env.__log({
                        name: 'network.complete',
                        networkRequestId: networkRequestId
                    });
                },
                unsubscribe: function unsubscribe() {
                    env.__log({
                        name: 'network.unsubscribe',
                        networkRequestId: networkRequestId
                    });
                }
            };
            var logRequestInfo = function logRequestInfo(info) {
                env.__log({
                    name: 'network.info',
                    networkRequestId: networkRequestId,
                    info: info
                });
            };
            return network.execute(params, variables, cacheConfig, uploadables, logRequestInfo, encryptedVariables, preprocessResponse, checkOperation)["do"](logObserver);
        }
    };
}
module.exports = wrapNetworkWithLogObserver;

},{"4a0bfb7e5aa469bd":"cvLlA"}],"cvLlA":[function(require,module,exports,__globalThis) {
'use strict';
var id = 100000;
function generateID() {
    return id++;
}
module.exports = generateID;

},{}],"5bEuR":[function(require,module,exports,__globalThis) {
'use strict';
var _interopRequireDefault = require("d681fd1d763c54ce")["default"];
var _createForOfIteratorHelper2 = _interopRequireDefault(require("d7dc30eb72da9d66"));
var invariant = require("b22180a8fec7d2d3");
var RelayOperationTracker = /*#__PURE__*/ function() {
    function RelayOperationTracker() {
        this._ownersToPendingOperations = new Map();
        this._pendingOperationsToOwners = new Map();
        this._ownersToPendingPromise = new Map();
    }
    var _proto = RelayOperationTracker.prototype;
    _proto.update = function update(pendingOperation, affectedOwners) {
        if (affectedOwners.size === 0) return;
        var pendingOperationIdentifier = pendingOperation.identifier;
        var newlyAffectedOwnersIdentifier = new Set();
        var _iterator = (0, _createForOfIteratorHelper2["default"])(affectedOwners), _step;
        try {
            for(_iterator.s(); !(_step = _iterator.n()).done;){
                var owner = _step.value;
                var ownerIdentifier = owner.identifier;
                var pendingOperationsAffectingOwner = this._ownersToPendingOperations.get(ownerIdentifier);
                if (pendingOperationsAffectingOwner != null) {
                    if (!pendingOperationsAffectingOwner.has(pendingOperationIdentifier)) {
                        pendingOperationsAffectingOwner.set(pendingOperationIdentifier, pendingOperation);
                        newlyAffectedOwnersIdentifier.add(ownerIdentifier);
                    }
                } else {
                    this._ownersToPendingOperations.set(ownerIdentifier, new Map([
                        [
                            pendingOperationIdentifier,
                            pendingOperation
                        ]
                    ]));
                    newlyAffectedOwnersIdentifier.add(ownerIdentifier);
                }
            }
        } catch (err) {
            _iterator.e(err);
        } finally{
            _iterator.f();
        }
        if (newlyAffectedOwnersIdentifier.size === 0) return;
        var ownersAffectedByPendingOperation = this._pendingOperationsToOwners.get(pendingOperationIdentifier) || new Set();
        var _iterator2 = (0, _createForOfIteratorHelper2["default"])(newlyAffectedOwnersIdentifier), _step2;
        try {
            for(_iterator2.s(); !(_step2 = _iterator2.n()).done;){
                var _ownerIdentifier = _step2.value;
                this._resolveOwnerResolvers(_ownerIdentifier);
                ownersAffectedByPendingOperation.add(_ownerIdentifier);
            }
        } catch (err) {
            _iterator2.e(err);
        } finally{
            _iterator2.f();
        }
        this._pendingOperationsToOwners.set(pendingOperationIdentifier, ownersAffectedByPendingOperation);
    };
    _proto.complete = function complete(pendingOperation) {
        var pendingOperationIdentifier = pendingOperation.identifier;
        var affectedOwnersIdentifier = this._pendingOperationsToOwners.get(pendingOperationIdentifier);
        if (affectedOwnersIdentifier == null) return;
        var completedOwnersIdentifier = new Set();
        var updatedOwnersIdentifier = new Set();
        var _iterator3 = (0, _createForOfIteratorHelper2["default"])(affectedOwnersIdentifier), _step3;
        try {
            for(_iterator3.s(); !(_step3 = _iterator3.n()).done;){
                var ownerIdentifier = _step3.value;
                var pendingOperationsAffectingOwner = this._ownersToPendingOperations.get(ownerIdentifier);
                if (!pendingOperationsAffectingOwner) continue;
                pendingOperationsAffectingOwner["delete"](pendingOperationIdentifier);
                if (pendingOperationsAffectingOwner.size > 0) updatedOwnersIdentifier.add(ownerIdentifier);
                else completedOwnersIdentifier.add(ownerIdentifier);
            }
        } catch (err) {
            _iterator3.e(err);
        } finally{
            _iterator3.f();
        }
        var _iterator4 = (0, _createForOfIteratorHelper2["default"])(completedOwnersIdentifier), _step4;
        try {
            for(_iterator4.s(); !(_step4 = _iterator4.n()).done;){
                var _ownerIdentifier2 = _step4.value;
                this._resolveOwnerResolvers(_ownerIdentifier2);
                this._ownersToPendingOperations["delete"](_ownerIdentifier2);
            }
        } catch (err) {
            _iterator4.e(err);
        } finally{
            _iterator4.f();
        }
        var _iterator5 = (0, _createForOfIteratorHelper2["default"])(updatedOwnersIdentifier), _step5;
        try {
            for(_iterator5.s(); !(_step5 = _iterator5.n()).done;){
                var _ownerIdentifier3 = _step5.value;
                this._resolveOwnerResolvers(_ownerIdentifier3);
            }
        } catch (err) {
            _iterator5.e(err);
        } finally{
            _iterator5.f();
        }
        this._pendingOperationsToOwners["delete"](pendingOperationIdentifier);
    };
    _proto._resolveOwnerResolvers = function _resolveOwnerResolvers(ownerIdentifier) {
        var promiseEntry = this._ownersToPendingPromise.get(ownerIdentifier);
        if (promiseEntry != null) promiseEntry.resolve();
        this._ownersToPendingPromise["delete"](ownerIdentifier);
    };
    _proto.getPendingOperationsAffectingOwner = function getPendingOperationsAffectingOwner(owner) {
        var ownerIdentifier = owner.identifier;
        var pendingOperationsForOwner = this._ownersToPendingOperations.get(ownerIdentifier);
        if (pendingOperationsForOwner == null || pendingOperationsForOwner.size === 0) return null;
        var cachedPromiseEntry = this._ownersToPendingPromise.get(ownerIdentifier);
        if (cachedPromiseEntry != null) return {
            promise: cachedPromiseEntry.promise,
            pendingOperations: cachedPromiseEntry.pendingOperations
        };
        var resolve;
        var promise = new Promise(function(r) {
            resolve = r;
        });
        !(resolve != null) && invariant(false);
        var pendingOperations = Array.from(pendingOperationsForOwner.values());
        this._ownersToPendingPromise.set(ownerIdentifier, {
            promise: promise,
            resolve: resolve,
            pendingOperations: pendingOperations
        });
        return {
            promise: promise,
            pendingOperations: pendingOperations
        };
    };
    return RelayOperationTracker;
}();
module.exports = RelayOperationTracker;

},{"d681fd1d763c54ce":"590td","d7dc30eb72da9d66":"fMaLa","b22180a8fec7d2d3":"e2sci"}],"ffTSI":[function(require,module,exports,__globalThis) {
var global = arguments[3];
'use strict';
function registerEnvironmentWithDevTools(environment) {
    var _global = typeof global !== 'undefined' ? global : typeof window !== 'undefined' ? window : undefined;
    var devToolsHook = _global && _global.__RELAY_DEVTOOLS_HOOK__;
    if (devToolsHook) devToolsHook.registerEnvironment(environment);
}
module.exports = registerEnvironmentWithDevTools;

},{}],"febBR":[function(require,module,exports,__globalThis) {
'use strict';
var _require = require("7f38a4a85e97e8a4"), VIEWER_ID = _require.VIEWER_ID, VIEWER_TYPE = _require.VIEWER_TYPE;
function defaultGetDataID(fieldValue, typeName) {
    if (typeName === VIEWER_TYPE) return fieldValue.id == null ? VIEWER_ID : fieldValue.id;
    return fieldValue.id;
}
module.exports = defaultGetDataID;

},{"7f38a4a85e97e8a4":"i6PYa"}],"i6PYa":[function(require,module,exports,__globalThis) {
'use strict';
var _require = require("c9810fa63539abb4"), generateClientID = _require.generateClientID;
var _require2 = require("4df55ace433cec4f"), ROOT_ID = _require2.ROOT_ID;
var VIEWER_ID = generateClientID(ROOT_ID, 'viewer');
var VIEWER_TYPE = 'Viewer';
module.exports = {
    VIEWER_ID: VIEWER_ID,
    VIEWER_TYPE: VIEWER_TYPE
};

},{"c9810fa63539abb4":"gL1rB","4df55ace433cec4f":"3QcrW"}],"h7crC":[function(require,module,exports,__globalThis) {
'use strict';
var defaultRelayFieldLogger = function defaultRelayFieldLogger(event) {};
module.exports = defaultRelayFieldLogger;

},{}],"jI7gk":[function(require,module,exports,__globalThis) {
'use strict';
var _interopRequireDefault = require("49580c31bcbf7d59")["default"];
var _createForOfIteratorHelper2 = _interopRequireDefault(require("eeb3dd86519eed11"));
var _toConsumableArray2 = _interopRequireDefault(require("1ad75e1e684ac8da"));
var RelayObservable = require("e0d2f76365dd12f8");
var generateID = require("53effba0aa0a9f3b");
var getOperation = require("63f8b694e282c34e");
var RelayError = require("c563ec7552178872");
var RelayFeatureFlags = require("684c4bb17ec7a904");
var _require = require("756e65a1b1e2b98a"), stableCopy = _require.stableCopy;
var withStartAndDuration = require("4496f0b8b2f0b455");
var _require2 = require("252789120f8e7534"), generateClientID = _require2.generateClientID, generateUniqueClientID = _require2.generateUniqueClientID;
var _require3 = require("a01ca47262c4e73f"), getLocalVariables = _require3.getLocalVariables;
var RelayModernRecord = require("f9d3e7aecfe62c60");
var _require4 = require("4efc4864b1deda57"), createNormalizationSelector = _require4.createNormalizationSelector, createReaderSelector = _require4.createReaderSelector;
var RelayRecordSource = require("83eea5189beedbbd");
var _require5 = require("792fd666f198e19"), ROOT_TYPE = _require5.ROOT_TYPE, TYPENAME_KEY = _require5.TYPENAME_KEY, getStorageKey = _require5.getStorageKey;
var invariant = require("cdbd9f2d618fa355");
var warning = require("a122a32f941a9238");
function execute(config) {
    return new Executor(config);
}
var Executor = /*#__PURE__*/ function() {
    function Executor(_ref3) {
        var _this = this;
        var _ref, _this$_operation$requ, _this$_operation$requ2;
        var actorIdentifier = _ref3.actorIdentifier, getDataID = _ref3.getDataID, getPublishQueue = _ref3.getPublishQueue, getStore = _ref3.getStore, isClientPayload = _ref3.isClientPayload, operation = _ref3.operation, operationExecutions = _ref3.operationExecutions, operationLoader = _ref3.operationLoader, operationTracker = _ref3.operationTracker, optimisticConfig = _ref3.optimisticConfig, scheduler = _ref3.scheduler, shouldProcessClientComponents = _ref3.shouldProcessClientComponents, sink = _ref3.sink, source = _ref3.source, treatMissingFieldsAsNull = _ref3.treatMissingFieldsAsNull, updater = _ref3.updater, log = _ref3.log, normalizeResponse = _ref3.normalizeResponse;
        this._actorIdentifier = actorIdentifier;
        this._getDataID = getDataID;
        this._treatMissingFieldsAsNull = treatMissingFieldsAsNull;
        this._incrementalPayloadsPending = false;
        this._incrementalResults = new Map();
        this._log = log;
        this._executeId = generateID();
        this._nextSubscriptionId = 0;
        this._operation = operation;
        this._operationExecutions = operationExecutions;
        this._operationLoader = operationLoader;
        this._operationTracker = operationTracker;
        this._operationUpdateEpochs = new Map();
        this._optimisticUpdates = null;
        this._useExecTimeResolvers = (_ref = (_this$_operation$requ = this._operation.request.node.operation.use_exec_time_resolvers) !== null && _this$_operation$requ !== void 0 ? _this$_operation$requ : ((_this$_operation$requ2 = this._operation.request.node.operation.exec_time_resolvers_enabled_provider) === null || _this$_operation$requ2 === void 0 ? void 0 : _this$_operation$requ2.get()) === true) !== null && _ref !== void 0 ? _ref : false;
        this._execTimeResolverResponseComplete = false;
        this._pendingModulePayloadsCount = 0;
        this._getPublishQueue = getPublishQueue;
        this._scheduler = scheduler;
        this._sink = sink;
        this._source = new Map();
        this._state = 'started';
        this._getStore = getStore;
        this._subscriptions = new Map();
        this._updater = updater;
        this._isClientPayload = isClientPayload === true;
        this._isSubscriptionOperation = this._operation.request.node.params.operationKind === 'subscription';
        this._shouldProcessClientComponents = shouldProcessClientComponents;
        this._retainDisposables = new Map();
        this._seenActors = new Set();
        this._completeFns = [];
        this._normalizeResponse = normalizeResponse;
        var id = this._nextSubscriptionId++;
        if (RelayFeatureFlags.PROCESS_OPTIMISTIC_UPDATE_BEFORE_SUBSCRIPTION && optimisticConfig != null) this._processOptimisticResponse(optimisticConfig.response != null ? {
            data: optimisticConfig.response
        } : null, optimisticConfig.updater, false);
        source.subscribe({
            complete: function complete() {
                return _this._complete(id);
            },
            error: function error(_error2) {
                return _this._error(_error2);
            },
            next: function next(response) {
                try {
                    _this._next(id, response);
                } catch (error) {
                    sink.error(error);
                }
            },
            start: function start(subscription) {
                var _this$_operation$requ3;
                _this._start(id, subscription);
                _this._log({
                    name: 'execute.start',
                    executeId: _this._executeId,
                    params: _this._operation.request.node.params,
                    variables: _this._operation.request.variables,
                    cacheConfig: (_this$_operation$requ3 = _this._operation.request.cacheConfig) !== null && _this$_operation$requ3 !== void 0 ? _this$_operation$requ3 : {}
                });
            },
            unsubscribe: function unsubscribe() {
                _this._log({
                    name: 'execute.unsubscribe',
                    executeId: _this._executeId
                });
            }
        });
        if (!RelayFeatureFlags.PROCESS_OPTIMISTIC_UPDATE_BEFORE_SUBSCRIPTION && optimisticConfig != null) this._processOptimisticResponse(optimisticConfig.response != null ? {
            data: optimisticConfig.response
        } : null, optimisticConfig.updater, false);
    }
    var _proto = Executor.prototype;
    _proto.cancel = function cancel() {
        var _this2 = this;
        if (this._state === 'completed') return;
        this._state = 'completed';
        this._operationExecutions["delete"](this._operation.request.identifier);
        if (this._subscriptions.size !== 0) {
            this._subscriptions.forEach(function(sub) {
                return sub.unsubscribe();
            });
            this._subscriptions.clear();
        }
        var optimisticUpdates = this._optimisticUpdates;
        if (optimisticUpdates !== null) {
            this._optimisticUpdates = null;
            optimisticUpdates.forEach(function(update) {
                return _this2._getPublishQueueAndSaveActor().revertUpdate(update);
            });
            this._runPublishQueue();
        }
        this._incrementalResults.clear();
        if (this._asyncStoreUpdateDisposable != null) {
            this._asyncStoreUpdateDisposable.dispose();
            this._asyncStoreUpdateDisposable = null;
        }
        this._completeFns = [];
        this._completeOperationTracker();
        this._disposeRetainedData();
    };
    _proto._updateActiveState = function _updateActiveState() {
        var activeState;
        switch(this._state){
            case 'started':
                activeState = 'active';
                break;
            case 'loading_incremental':
                activeState = 'active';
                break;
            case 'completed':
                activeState = 'inactive';
                break;
            case 'loading_final':
                activeState = this._pendingModulePayloadsCount > 0 || this._useExecTimeResolvers && !this._execTimeResolverResponseComplete ? 'active' : 'inactive';
                break;
            default:
                this._state;
                invariant(false);
        }
        this._operationExecutions.set(this._operation.request.identifier, activeState);
    };
    _proto._schedule = function _schedule(task, priority) {
        var _this3 = this;
        var scheduler = this._scheduler;
        if (scheduler != null) {
            var id = this._nextSubscriptionId++;
            RelayObservable.create(function(sink) {
                var cancellationToken = scheduler.schedule(function() {
                    try {
                        task();
                        sink.complete();
                    } catch (error) {
                        sink.error(error);
                    }
                }, priority);
                return function() {
                    return scheduler.cancel(cancellationToken);
                };
            }).subscribe({
                complete: function complete() {
                    return _this3._complete(id);
                },
                error: function error(_error3) {
                    return _this3._error(_error3);
                },
                start: function start(subscription) {
                    return _this3._start(id, subscription);
                }
            });
        } else task();
    };
    _proto._complete = function _complete(id) {
        this._subscriptions["delete"](id);
        if (this._subscriptions.size === 0) {
            this.cancel();
            this._sink.complete();
            this._log({
                name: 'execute.complete',
                executeId: this._executeId
            });
        }
    };
    _proto._error = function _error(error) {
        this.cancel();
        this._sink.error(error);
        this._log({
            name: 'execute.error',
            executeId: this._executeId,
            error: error
        });
    };
    _proto._start = function _start(id, subscription) {
        this._subscriptions.set(id, subscription);
        this._updateActiveState();
    };
    _proto._next = function _next(_id, response) {
        var _this4 = this;
        var priority = this._state === 'loading_incremental' ? 'low' : 'default';
        this._schedule(function() {
            _this4._log({
                name: 'execute.next.start',
                executeId: _this4._executeId,
                response: response,
                operation: _this4._operation
            });
            _this4._handleNext(response);
            _this4._maybeCompleteSubscriptionOperationTracking();
            _this4._log({
                name: 'execute.next.end',
                executeId: _this4._executeId,
                response: response,
                operation: _this4._operation
            });
        }, priority);
    };
    _proto._handleErrorResponse = function _handleErrorResponse(responses) {
        var _this5 = this;
        var results = [];
        responses.forEach(function(response) {
            if (response.data === null && response.extensions != null && !response.hasOwnProperty('errors')) return;
            else if (response.data == null) {
                var errors = response.hasOwnProperty('errors') && response.errors != null ? response.errors : null;
                var messages = errors ? errors.map(function(_ref4) {
                    var message = _ref4.message;
                    return message;
                }).join('\n') : '(No errors)';
                var error = RelayError.create('RelayNetwork', 'No data returned for operation `' + _this5._operation.request.node.params.name + '`, got error(s):\n' + messages + '\n\nSee the error `source` property for more information.');
                error.source = {
                    errors: errors,
                    operation: _this5._operation.request.node,
                    variables: _this5._operation.request.variables
                };
                error.stack;
                throw error;
            } else {
                var responseWithData = response;
                results.push(responseWithData);
            }
        });
        return results;
    };
    _proto._handleOptimisticResponses = function _handleOptimisticResponses(responses) {
        var _response$extensions;
        if (responses.length > 1) {
            if (responses.some(function(responsePart) {
                var _responsePart$extensi;
                return ((_responsePart$extensi = responsePart.extensions) === null || _responsePart$extensi === void 0 ? void 0 : _responsePart$extensi.isOptimistic) === true;
            })) invariant(false);
            return false;
        }
        var response = responses[0];
        var isOptimistic = ((_response$extensions = response.extensions) === null || _response$extensions === void 0 ? void 0 : _response$extensions.isOptimistic) === true;
        if (isOptimistic && this._state !== 'started') invariant(false);
        if (isOptimistic) {
            this._processOptimisticResponse(response, null, this._treatMissingFieldsAsNull);
            this._sink.next(response);
            return true;
        }
        return false;
    };
    _proto._handleNext = function _handleNext(response) {
        if (this._state === 'completed') return;
        this._seenActors.clear();
        var responses = Array.isArray(response) ? response : [
            response
        ];
        var responsesWithData = this._handleErrorResponse(responses);
        if (responsesWithData.length === 0) {
            var isFinal = responses.some(function(x) {
                var _x$extensions;
                return ((_x$extensions = x.extensions) === null || _x$extensions === void 0 ? void 0 : _x$extensions.is_final) === true;
            });
            if (isFinal) {
                this._state = 'loading_final';
                this._updateActiveState();
                this._incrementalPayloadsPending = false;
            }
            this._sink.next(response);
            return;
        }
        var isOptimistic = this._handleOptimisticResponses(responsesWithData);
        if (isOptimistic) return;
        var _partitionGraphQLResp = partitionGraphQLResponses(responsesWithData), nonIncrementalResponses = _partitionGraphQLResp[0], incrementalResponses = _partitionGraphQLResp[1], normalizedResponses = _partitionGraphQLResp[2];
        var hasNonIncrementalResponses = nonIncrementalResponses.length > 0;
        var hasNormalizedResponses = normalizedResponses.length > 0;
        if (hasNonIncrementalResponses) {
            if (this._isSubscriptionOperation) {
                var nextID = generateUniqueClientID();
                this._operation = {
                    request: this._operation.request,
                    fragment: createReaderSelector(this._operation.fragment.node, nextID, this._operation.fragment.variables, this._operation.fragment.owner),
                    root: createNormalizationSelector(this._operation.root.node, nextID, this._operation.root.variables)
                };
            }
            var payloadFollowups = this._processResponses(nonIncrementalResponses);
            this._processPayloadFollowups(payloadFollowups);
        }
        if (hasNormalizedResponses) {
            var _payloadFollowups = [];
            for(var i = 0; i < normalizedResponses.length; i++){
                var _response$extensions2;
                var _response = normalizedResponses[i];
                var source = new RelayRecordSource(_response.data);
                var isFinal = ((_response$extensions2 = _response.extensions) === null || _response$extensions2 === void 0 ? void 0 : _response$extensions2.is_final) === true;
                var payload = {
                    errors: [],
                    fieldPayloads: [],
                    followupPayloads: [],
                    incrementalPlaceholders: [],
                    isFinal: isFinal,
                    source: source
                };
                this._getPublishQueueAndSaveActor().commitPayload(this._operation, payload, this._updater);
                _payloadFollowups.push(payload);
                this._execTimeResolverResponseComplete = isFinal;
                if (isFinal) this._updateActiveState();
            }
        }
        if (incrementalResponses.length > 0) {
            var _payloadFollowups2 = this._processIncrementalResponses(incrementalResponses);
            this._processPayloadFollowups(_payloadFollowups2);
        }
        if (this._isSubscriptionOperation) {
            if (responsesWithData[0].extensions == null) responsesWithData[0].extensions = {
                __relay_subscription_root_id: this._operation.fragment.dataID
            };
            else responsesWithData[0].extensions.__relay_subscription_root_id = this._operation.fragment.dataID;
        }
        var updatedOwners = this._runPublishQueue(hasNonIncrementalResponses || hasNormalizedResponses ? this._operation : undefined);
        if (hasNonIncrementalResponses) {
            if (this._incrementalPayloadsPending) this._retainData();
        }
        this._updateOperationTracker(updatedOwners);
        this._sink.next(response);
    };
    _proto._processOptimisticResponse = function _processOptimisticResponse(response, updater, treatMissingFieldsAsNull) {
        var _this6 = this;
        !(this._optimisticUpdates === null) && invariant(false);
        if (response == null && updater == null) return;
        var optimisticUpdates = [];
        if (response) {
            var payload = this._normalizeResponse(response, this._operation.root, ROOT_TYPE, {
                actorIdentifier: this._actorIdentifier,
                getDataID: this._getDataID,
                log: this._log,
                path: [],
                shouldProcessClientComponents: this._shouldProcessClientComponents,
                treatMissingFieldsAsNull: treatMissingFieldsAsNull
            }, this._useExecTimeResolvers);
            validateOptimisticResponsePayload(payload);
            optimisticUpdates.push({
                operation: this._operation,
                payload: payload,
                updater: updater
            });
            this._processOptimisticFollowups(payload, optimisticUpdates);
        } else if (updater) optimisticUpdates.push({
            operation: this._operation,
            payload: {
                errors: null,
                fieldPayloads: null,
                incrementalPlaceholders: null,
                followupPayloads: null,
                source: RelayRecordSource.create(),
                isFinal: false
            },
            updater: updater
        });
        this._optimisticUpdates = optimisticUpdates;
        optimisticUpdates.forEach(function(update) {
            return _this6._getPublishQueueAndSaveActor().applyUpdate(update);
        });
        var updatedOwners = this._runPublishQueue();
        if (RelayFeatureFlags.ENABLE_OPERATION_TRACKER_OPTIMISTIC_UPDATES) this._updateOperationTracker(updatedOwners);
    };
    _proto._processOptimisticFollowups = function _processOptimisticFollowups(payload, optimisticUpdates) {
        if (payload.followupPayloads && payload.followupPayloads.length) {
            var followupPayloads = payload.followupPayloads;
            var _iterator = (0, _createForOfIteratorHelper2["default"])(followupPayloads), _step;
            try {
                for(_iterator.s(); !(_step = _iterator.n()).done;){
                    var followupPayload = _step.value;
                    switch(followupPayload.kind){
                        case 'ModuleImportPayload':
                            var operationLoader = this._expectOperationLoader();
                            var operation = operationLoader.get(followupPayload.operationReference);
                            if (operation == null) this._processAsyncOptimisticModuleImport(followupPayload);
                            else {
                                var moduleImportOptimisticUpdates = this._processOptimisticModuleImport(operation, followupPayload);
                                optimisticUpdates.push.apply(optimisticUpdates, (0, _toConsumableArray2["default"])(moduleImportOptimisticUpdates));
                            }
                            break;
                        case 'ActorPayload':
                            break;
                        default:
                            followupPayload;
                            invariant(false);
                    }
                }
            } catch (err) {
                _iterator.e(err);
            } finally{
                _iterator.f();
            }
        }
    };
    _proto._normalizeFollowupPayload = function _normalizeFollowupPayload(followupPayload, normalizationNode) {
        var variables;
        if (normalizationNode.kind === 'SplitOperation' && followupPayload.kind === 'ModuleImportPayload') variables = getLocalVariables(followupPayload.variables, normalizationNode.argumentDefinitions, followupPayload.args);
        else variables = followupPayload.variables;
        var selector = createNormalizationSelector(normalizationNode, followupPayload.dataID, variables);
        var nextResponse = {
            data: followupPayload.data,
            extensions: this._state === 'loading_final' ? {
                is_final: true
            } : undefined
        };
        return this._normalizeResponse(nextResponse, selector, followupPayload.typeName, {
            actorIdentifier: this._actorIdentifier,
            getDataID: this._getDataID,
            log: this._log,
            path: followupPayload.path,
            treatMissingFieldsAsNull: this._treatMissingFieldsAsNull,
            shouldProcessClientComponents: this._shouldProcessClientComponents
        }, this._useExecTimeResolvers);
    };
    _proto._processOptimisticModuleImport = function _processOptimisticModuleImport(normalizationRootNode, moduleImportPayload) {
        var operation = getOperation(normalizationRootNode);
        var optimisticUpdates = [];
        var modulePayload = this._normalizeFollowupPayload(moduleImportPayload, operation);
        validateOptimisticResponsePayload(modulePayload);
        optimisticUpdates.push({
            operation: this._operation,
            payload: modulePayload,
            updater: null
        });
        this._processOptimisticFollowups(modulePayload, optimisticUpdates);
        return optimisticUpdates;
    };
    _proto._processAsyncOptimisticModuleImport = function _processAsyncOptimisticModuleImport(moduleImportPayload) {
        var _this7 = this;
        this._expectOperationLoader().load(moduleImportPayload.operationReference).then(function(operation) {
            if (operation == null || _this7._state !== 'started') return;
            var moduleImportOptimisticUpdates = _this7._processOptimisticModuleImport(operation, moduleImportPayload);
            moduleImportOptimisticUpdates.forEach(function(update) {
                return _this7._getPublishQueueAndSaveActor().applyUpdate(update);
            });
            if (_this7._optimisticUpdates == null) ;
            else {
                var _this$_optimisticUpda;
                (_this$_optimisticUpda = _this7._optimisticUpdates).push.apply(_this$_optimisticUpda, (0, _toConsumableArray2["default"])(moduleImportOptimisticUpdates));
                _this7._runPublishQueue();
            }
        });
    };
    _proto._processResponses = function _processResponses(responses) {
        var _this8 = this;
        this._log({
            name: 'execute.normalize.start',
            operation: this._operation
        });
        if (this._optimisticUpdates !== null) {
            this._optimisticUpdates.forEach(function(update) {
                _this8._getPublishQueueAndSaveActor().revertUpdate(update);
            });
            this._optimisticUpdates = null;
        }
        this._incrementalPayloadsPending = false;
        this._incrementalResults.clear();
        this._source.clear();
        return responses.map(function(payloadPart) {
            var relayPayload = _this8._normalizeResponse(payloadPart, _this8._operation.root, ROOT_TYPE, {
                actorIdentifier: _this8._actorIdentifier,
                getDataID: _this8._getDataID,
                log: _this8._log,
                path: [],
                treatMissingFieldsAsNull: _this8._treatMissingFieldsAsNull,
                shouldProcessClientComponents: _this8._shouldProcessClientComponents
            }, _this8._useExecTimeResolvers);
            _this8._getPublishQueueAndSaveActor().commitPayload(_this8._operation, relayPayload, _this8._updater);
            _this8._log({
                name: 'execute.normalize.end',
                operation: _this8._operation
            });
            return relayPayload;
        });
    };
    _proto._processPayloadFollowups = function _processPayloadFollowups(payloads) {
        var _this9 = this;
        if (this._state === 'completed') return;
        payloads.forEach(function(payload) {
            var incrementalPlaceholders = payload.incrementalPlaceholders, followupPayloads = payload.followupPayloads, isFinal = payload.isFinal;
            _this9._state = isFinal ? 'loading_final' : 'loading_incremental';
            _this9._updateActiveState();
            if (isFinal) _this9._incrementalPayloadsPending = false;
            if (followupPayloads && followupPayloads.length !== 0) followupPayloads.forEach(function(followupPayload) {
                var _followupPayload$acto;
                var prevActorIdentifier = _this9._actorIdentifier;
                _this9._actorIdentifier = (_followupPayload$acto = followupPayload.actorIdentifier) !== null && _followupPayload$acto !== void 0 ? _followupPayload$acto : _this9._actorIdentifier;
                _this9._processFollowupPayload(followupPayload);
                _this9._actorIdentifier = prevActorIdentifier;
            });
            if (incrementalPlaceholders && incrementalPlaceholders.length !== 0) {
                _this9._incrementalPayloadsPending = _this9._state !== 'loading_final';
                incrementalPlaceholders.forEach(function(incrementalPlaceholder) {
                    var _incrementalPlacehold;
                    var prevActorIdentifier = _this9._actorIdentifier;
                    _this9._actorIdentifier = (_incrementalPlacehold = incrementalPlaceholder.actorIdentifier) !== null && _incrementalPlacehold !== void 0 ? _incrementalPlacehold : _this9._actorIdentifier;
                    _this9._processIncrementalPlaceholder(payload, incrementalPlaceholder);
                    _this9._actorIdentifier = prevActorIdentifier;
                });
                if (_this9._isClientPayload || _this9._state === 'loading_final') {
                    var relayPayloads = [];
                    incrementalPlaceholders.forEach(function(placeholder) {
                        if (placeholder.kind === 'defer') relayPayloads.push(_this9._processDeferResponse(placeholder.label, placeholder.path, placeholder, {
                            data: placeholder.data,
                            extensions: {
                                is_final: true
                            }
                        }));
                    });
                    if (relayPayloads.length > 0) _this9._processPayloadFollowups(relayPayloads);
                }
            }
        });
    };
    _proto._maybeCompleteSubscriptionOperationTracking = function _maybeCompleteSubscriptionOperationTracking() {
        if (!this._isSubscriptionOperation && !(this._useExecTimeResolvers && this._execTimeResolverResponseComplete && this._state === 'loading_final')) return;
        if (this._pendingModulePayloadsCount === 0 && this._incrementalPayloadsPending === false) this._completeOperationTracker();
    };
    _proto._processFollowupPayload = function _processFollowupPayload(followupPayload) {
        var _this10 = this;
        switch(followupPayload.kind){
            case 'ModuleImportPayload':
                var operationLoader = this._expectOperationLoader();
                var node = operationLoader.get(followupPayload.operationReference);
                if (node != null) this._processFollowupPayloadWithNormalizationNode(followupPayload, getOperation(node));
                else {
                    var id = this._nextSubscriptionId++;
                    this._pendingModulePayloadsCount++;
                    var decrementPendingCount = function decrementPendingCount() {
                        _this10._pendingModulePayloadsCount--;
                        _this10._maybeCompleteSubscriptionOperationTracking();
                    };
                    var networkObservable = RelayObservable.from(new Promise(function(resolve, reject) {
                        operationLoader.load(followupPayload.operationReference).then(resolve, reject);
                    }));
                    RelayObservable.create(function(sink) {
                        var cancellationToken;
                        var subscription = networkObservable.subscribe({
                            next: function next(loadedNode) {
                                if (loadedNode != null) {
                                    var publishModuleImportPayload = function publishModuleImportPayload() {
                                        try {
                                            var operation = getOperation(loadedNode);
                                            var batchAsyncModuleUpdatesFN = RelayFeatureFlags.BATCH_ASYNC_MODULE_UPDATES_FN;
                                            var shouldScheduleAsyncStoreUpdate = batchAsyncModuleUpdatesFN != null && _this10._pendingModulePayloadsCount > 1;
                                            var _withStartAndDuration = withStartAndDuration(function() {
                                                _this10._handleFollowupPayload(followupPayload, operation);
                                                if (shouldScheduleAsyncStoreUpdate) _this10._scheduleAsyncStoreUpdate(batchAsyncModuleUpdatesFN, sink.complete);
                                                else {
                                                    var updatedOwners = _this10._runPublishQueue();
                                                    _this10._updateOperationTracker(updatedOwners);
                                                }
                                            }), _ = _withStartAndDuration[0], duration = _withStartAndDuration[1];
                                            _this10._log({
                                                name: 'execute.async.module',
                                                executeId: _this10._executeId,
                                                operationName: operation.name,
                                                duration: duration
                                            });
                                            if (!shouldScheduleAsyncStoreUpdate) sink.complete();
                                        } catch (error) {
                                            sink.error(error);
                                        }
                                    };
                                    var scheduler = _this10._scheduler;
                                    if (scheduler == null) publishModuleImportPayload();
                                    else cancellationToken = scheduler.schedule(publishModuleImportPayload);
                                } else sink.complete();
                            },
                            error: sink.error
                        });
                        return function() {
                            subscription.unsubscribe();
                            if (_this10._scheduler != null && cancellationToken != null) _this10._scheduler.cancel(cancellationToken);
                        };
                    }).subscribe({
                        complete: function complete() {
                            _this10._complete(id);
                            decrementPendingCount();
                        },
                        error: function error(_error4) {
                            _this10._error(_error4);
                            decrementPendingCount();
                        },
                        start: function start(subscription) {
                            return _this10._start(id, subscription);
                        }
                    });
                }
                break;
            case 'ActorPayload':
                this._processFollowupPayloadWithNormalizationNode(followupPayload, followupPayload.node);
                break;
            default:
                followupPayload;
                invariant(false);
        }
    };
    _proto._processFollowupPayloadWithNormalizationNode = function _processFollowupPayloadWithNormalizationNode(followupPayload, normalizationNode) {
        this._handleFollowupPayload(followupPayload, normalizationNode);
        this._maybeCompleteSubscriptionOperationTracking();
    };
    _proto._handleFollowupPayload = function _handleFollowupPayload(followupPayload, normalizationNode) {
        var relayPayload = this._normalizeFollowupPayload(followupPayload, normalizationNode);
        this._getPublishQueueAndSaveActor().commitPayload(this._operation, relayPayload);
        this._processPayloadFollowups([
            relayPayload
        ]);
    };
    _proto._processIncrementalPlaceholder = function _processIncrementalPlaceholder(relayPayload, placeholder) {
        var _relayPayload$fieldPa;
        var label = placeholder.label, path = placeholder.path;
        var pathKey = path.map(String).join('.');
        var resultForLabel = this._incrementalResults.get(label);
        if (resultForLabel == null) {
            resultForLabel = new Map();
            this._incrementalResults.set(label, resultForLabel);
        }
        var resultForPath = resultForLabel.get(pathKey);
        var pendingResponses = resultForPath != null && resultForPath.kind === 'response' ? resultForPath.responses : null;
        resultForLabel.set(pathKey, {
            kind: 'placeholder',
            placeholder: placeholder
        });
        var parentID;
        if (placeholder.kind === 'stream') parentID = placeholder.parentID;
        else if (placeholder.kind === 'defer') parentID = placeholder.selector.dataID;
        else {
            placeholder;
            invariant(false);
        }
        var parentRecord = relayPayload.source.get(parentID);
        var parentPayloads = ((_relayPayload$fieldPa = relayPayload.fieldPayloads) !== null && _relayPayload$fieldPa !== void 0 ? _relayPayload$fieldPa : []).filter(function(fieldPayload) {
            var fieldID = generateClientID(fieldPayload.dataID, fieldPayload.fieldKey);
            return fieldPayload.dataID === parentID || fieldID === parentID;
        });
        !(parentRecord != null) && invariant(false);
        var nextParentRecord;
        var nextParentPayloads;
        var previousParentEntry = this._source.get(parentID);
        if (previousParentEntry != null) {
            nextParentRecord = RelayModernRecord.update(previousParentEntry.record, parentRecord);
            var handlePayloads = new Map();
            var dedupePayload = function dedupePayload(payload) {
                var key = stableStringify(payload);
                handlePayloads.set(key, payload);
            };
            previousParentEntry.fieldPayloads.forEach(dedupePayload);
            parentPayloads.forEach(dedupePayload);
            nextParentPayloads = Array.from(handlePayloads.values());
        } else {
            nextParentRecord = parentRecord;
            nextParentPayloads = parentPayloads;
        }
        this._source.set(parentID, {
            record: nextParentRecord,
            fieldPayloads: nextParentPayloads
        });
        if (pendingResponses != null) {
            var payloadFollowups = this._processIncrementalResponses(pendingResponses);
            this._processPayloadFollowups(payloadFollowups);
        }
    };
    _proto._processIncrementalResponses = function _processIncrementalResponses(incrementalResponses) {
        var _this11 = this;
        var relayPayloads = [];
        incrementalResponses.forEach(function(incrementalResponse) {
            var label = incrementalResponse.label, path = incrementalResponse.path, response = incrementalResponse.response;
            var resultForLabel = _this11._incrementalResults.get(label);
            if (resultForLabel == null) {
                resultForLabel = new Map();
                _this11._incrementalResults.set(label, resultForLabel);
            }
            if (label.indexOf('$defer$') !== -1) {
                var pathKey = path.map(String).join('.');
                var resultForPath = resultForLabel.get(pathKey);
                if (resultForPath == null) {
                    resultForPath = {
                        kind: 'response',
                        responses: [
                            incrementalResponse
                        ]
                    };
                    resultForLabel.set(pathKey, resultForPath);
                    return;
                } else if (resultForPath.kind === 'response') {
                    resultForPath.responses.push(incrementalResponse);
                    return;
                }
                var placeholder = resultForPath.placeholder;
                !(placeholder.kind === 'defer') && invariant(false);
                relayPayloads.push(_this11._processDeferResponse(label, path, placeholder, response));
            } else {
                var _pathKey = path.slice(0, -2).map(String).join('.');
                var _resultForPath = resultForLabel.get(_pathKey);
                if (_resultForPath == null) {
                    _resultForPath = {
                        kind: 'response',
                        responses: [
                            incrementalResponse
                        ]
                    };
                    resultForLabel.set(_pathKey, _resultForPath);
                    return;
                } else if (_resultForPath.kind === 'response') {
                    _resultForPath.responses.push(incrementalResponse);
                    return;
                }
                var _placeholder = _resultForPath.placeholder;
                !(_placeholder.kind === 'stream') && invariant(false);
                relayPayloads.push(_this11._processStreamResponse(label, path, _placeholder, response));
            }
        });
        return relayPayloads;
    };
    _proto._processDeferResponse = function _processDeferResponse(label, path, placeholder, response) {
        var _placeholder$actorIde;
        var parentID = placeholder.selector.dataID;
        var prevActorIdentifier = this._actorIdentifier;
        this._actorIdentifier = (_placeholder$actorIde = placeholder.actorIdentifier) !== null && _placeholder$actorIde !== void 0 ? _placeholder$actorIde : this._actorIdentifier;
        var relayPayload = this._normalizeResponse(response, placeholder.selector, placeholder.typeName, {
            actorIdentifier: this._actorIdentifier,
            getDataID: this._getDataID,
            log: this._log,
            path: placeholder.path,
            treatMissingFieldsAsNull: this._treatMissingFieldsAsNull,
            shouldProcessClientComponents: this._shouldProcessClientComponents
        }, this._useExecTimeResolvers);
        this._getPublishQueueAndSaveActor().commitPayload(this._operation, relayPayload);
        var parentEntry = this._source.get(parentID);
        !(parentEntry != null) && invariant(false);
        var fieldPayloads = parentEntry.fieldPayloads;
        if (fieldPayloads.length !== 0) {
            var _response$extensions3;
            var handleFieldsRelayPayload = {
                errors: null,
                fieldPayloads: fieldPayloads,
                incrementalPlaceholders: null,
                followupPayloads: null,
                source: RelayRecordSource.create(),
                isFinal: ((_response$extensions3 = response.extensions) === null || _response$extensions3 === void 0 ? void 0 : _response$extensions3.is_final) === true
            };
            this._getPublishQueueAndSaveActor().commitPayload(this._operation, handleFieldsRelayPayload);
        }
        this._actorIdentifier = prevActorIdentifier;
        return relayPayload;
    };
    _proto._processStreamResponse = function _processStreamResponse(label, path, placeholder, response) {
        var parentID = placeholder.parentID, node = placeholder.node, variables = placeholder.variables, actorIdentifier = placeholder.actorIdentifier;
        var prevActorIdentifier = this._actorIdentifier;
        this._actorIdentifier = actorIdentifier !== null && actorIdentifier !== void 0 ? actorIdentifier : this._actorIdentifier;
        var field = node.selections[0];
        !(field != null && field.kind === 'LinkedField' && field.plural === true) && invariant(false);
        var _this$_normalizeStrea = this._normalizeStreamItem(response, parentID, field, variables, path, placeholder.path), fieldPayloads = _this$_normalizeStrea.fieldPayloads, itemID = _this$_normalizeStrea.itemID, itemIndex = _this$_normalizeStrea.itemIndex, prevIDs = _this$_normalizeStrea.prevIDs, relayPayload = _this$_normalizeStrea.relayPayload, storageKey = _this$_normalizeStrea.storageKey;
        this._getPublishQueueAndSaveActor().commitPayload(this._operation, relayPayload, function(store) {
            var currentParentRecord = store.get(parentID);
            if (currentParentRecord == null) return;
            var currentItems = currentParentRecord.getLinkedRecords(storageKey);
            if (currentItems == null) return;
            if (currentItems.length !== prevIDs.length || currentItems.some(function(currentItem, index) {
                return prevIDs[index] !== (currentItem && currentItem.getDataID());
            })) return;
            var nextItems = (0, _toConsumableArray2["default"])(currentItems);
            nextItems[itemIndex] = store.get(itemID);
            currentParentRecord.setLinkedRecords(nextItems, storageKey);
        });
        if (fieldPayloads.length !== 0) {
            var handleFieldsRelayPayload = {
                errors: null,
                fieldPayloads: fieldPayloads,
                incrementalPlaceholders: null,
                followupPayloads: null,
                source: RelayRecordSource.create(),
                isFinal: false
            };
            this._getPublishQueueAndSaveActor().commitPayload(this._operation, handleFieldsRelayPayload);
        }
        this._actorIdentifier = prevActorIdentifier;
        return relayPayload;
    };
    _proto._normalizeStreamItem = function _normalizeStreamItem(response, parentID, field, variables, path, normalizationPath) {
        var _field$alias, _field$concreteType, _ref2, _this$_getDataID;
        var data = response.data;
        !(typeof data === 'object') && invariant(false);
        var responseKey = (_field$alias = field.alias) !== null && _field$alias !== void 0 ? _field$alias : field.name;
        var storageKey = getStorageKey(field, variables);
        var parentEntry = this._source.get(parentID);
        !(parentEntry != null) && invariant(false);
        var parentRecord = parentEntry.record, fieldPayloads = parentEntry.fieldPayloads;
        var prevIDs = RelayModernRecord.getLinkedRecordIDs(parentRecord, storageKey);
        !(prevIDs != null) && invariant(false);
        var finalPathEntry = path[path.length - 1];
        var itemIndex = parseInt(finalPathEntry, 10);
        !(itemIndex === finalPathEntry && itemIndex >= 0) && invariant(false);
        var typeName = (_field$concreteType = field.concreteType) !== null && _field$concreteType !== void 0 ? _field$concreteType : data[TYPENAME_KEY];
        !(typeof typeName === 'string') && invariant(false);
        var itemID = (_ref2 = (_this$_getDataID = this._getDataID(data, typeName)) !== null && _this$_getDataID !== void 0 ? _this$_getDataID : prevIDs === null || prevIDs === void 0 ? void 0 : prevIDs[itemIndex]) !== null && _ref2 !== void 0 ? _ref2 : generateClientID(parentID, storageKey, itemIndex);
        !(typeof itemID === 'string') && invariant(false);
        var selector = createNormalizationSelector(field, itemID, variables);
        var nextParentRecord = RelayModernRecord.clone(parentRecord);
        var nextIDs = (0, _toConsumableArray2["default"])(prevIDs);
        nextIDs[itemIndex] = itemID;
        RelayModernRecord.setLinkedRecordIDs(nextParentRecord, storageKey, nextIDs);
        this._source.set(parentID, {
            record: nextParentRecord,
            fieldPayloads: fieldPayloads
        });
        var relayPayload = this._normalizeResponse(response, selector, typeName, {
            actorIdentifier: this._actorIdentifier,
            getDataID: this._getDataID,
            log: this._log,
            path: [].concat((0, _toConsumableArray2["default"])(normalizationPath), [
                responseKey,
                String(itemIndex)
            ]),
            treatMissingFieldsAsNull: this._treatMissingFieldsAsNull,
            shouldProcessClientComponents: this._shouldProcessClientComponents
        }, this._useExecTimeResolvers);
        return {
            fieldPayloads: fieldPayloads,
            itemID: itemID,
            itemIndex: itemIndex,
            prevIDs: prevIDs,
            relayPayload: relayPayload,
            storageKey: storageKey
        };
    };
    _proto._scheduleAsyncStoreUpdate = function _scheduleAsyncStoreUpdate(scheduleFn, completeFn) {
        var _this12 = this;
        this._completeFns.push(completeFn);
        if (this._asyncStoreUpdateDisposable != null) return;
        this._asyncStoreUpdateDisposable = scheduleFn(function() {
            _this12._asyncStoreUpdateDisposable = null;
            var updatedOwners = _this12._runPublishQueue();
            _this12._updateOperationTracker(updatedOwners);
            var _iterator2 = (0, _createForOfIteratorHelper2["default"])(_this12._completeFns), _step2;
            try {
                for(_iterator2.s(); !(_step2 = _iterator2.n()).done;){
                    var complete = _step2.value;
                    complete();
                }
            } catch (err) {
                _iterator2.e(err);
            } finally{
                _iterator2.f();
            }
            _this12._completeFns = [];
        });
    };
    _proto._updateOperationTracker = function _updateOperationTracker(updatedOwners) {
        if (updatedOwners != null && updatedOwners.length > 0) this._operationTracker.update(this._operation.request, new Set(updatedOwners));
    };
    _proto._completeOperationTracker = function _completeOperationTracker() {
        this._operationTracker.complete(this._operation.request);
    };
    _proto._getPublishQueueAndSaveActor = function _getPublishQueueAndSaveActor() {
        this._seenActors.add(this._actorIdentifier);
        return this._getPublishQueue(this._actorIdentifier);
    };
    _proto._getActorsToVisit = function _getActorsToVisit() {
        if (this._seenActors.size === 0) return new Set([
            this._actorIdentifier
        ]);
        else return this._seenActors;
    };
    _proto._runPublishQueue = function _runPublishQueue(operation) {
        var updatedOwners = new Set();
        var _iterator3 = (0, _createForOfIteratorHelper2["default"])(this._getActorsToVisit()), _step3;
        try {
            for(_iterator3.s(); !(_step3 = _iterator3.n()).done;){
                var actorIdentifier = _step3.value;
                var owners = this._getPublishQueue(actorIdentifier).run(operation);
                owners.forEach(function(owner) {
                    return updatedOwners.add(owner);
                });
            }
        } catch (err) {
            _iterator3.e(err);
        } finally{
            _iterator3.f();
        }
        return Array.from(updatedOwners);
    };
    _proto._retainData = function _retainData() {
        var _iterator4 = (0, _createForOfIteratorHelper2["default"])(this._getActorsToVisit()), _step4;
        try {
            for(_iterator4.s(); !(_step4 = _iterator4.n()).done;){
                var actorIdentifier = _step4.value;
                if (!this._retainDisposables.has(actorIdentifier)) this._retainDisposables.set(actorIdentifier, this._getStore(actorIdentifier).retain(this._operation));
            }
        } catch (err) {
            _iterator4.e(err);
        } finally{
            _iterator4.f();
        }
    };
    _proto._disposeRetainedData = function _disposeRetainedData() {
        var _iterator5 = (0, _createForOfIteratorHelper2["default"])(this._retainDisposables.values()), _step5;
        try {
            for(_iterator5.s(); !(_step5 = _iterator5.n()).done;){
                var disposable = _step5.value;
                disposable.dispose();
            }
        } catch (err) {
            _iterator5.e(err);
        } finally{
            _iterator5.f();
        }
        this._retainDisposables.clear();
    };
    _proto._expectOperationLoader = function _expectOperationLoader() {
        var operationLoader = this._operationLoader;
        !operationLoader && invariant(false);
        return operationLoader;
    };
    return Executor;
}();
function partitionGraphQLResponses(responses) {
    var nonIncrementalResponses = [];
    var incrementalResponses = [];
    var normalizedResponses = [];
    responses.forEach(function(response) {
        var _response$extensions4;
        if (response.path != null || response.label != null) {
            var label = response.label, path = response.path;
            if (label == null || path == null) invariant(false);
            incrementalResponses.push({
                label: label,
                path: path,
                response: response
            });
        } else if (((_response$extensions4 = response.extensions) === null || _response$extensions4 === void 0 ? void 0 : _response$extensions4.is_normalized) === true) normalizedResponses.push(response);
        else nonIncrementalResponses.push(response);
    });
    return [
        nonIncrementalResponses,
        incrementalResponses,
        normalizedResponses
    ];
}
function stableStringify(value) {
    var _JSON$stringify;
    return (_JSON$stringify = JSON.stringify(stableCopy(value))) !== null && _JSON$stringify !== void 0 ? _JSON$stringify : '';
}
function validateOptimisticResponsePayload(payload) {
    var incrementalPlaceholders = payload.incrementalPlaceholders;
    if (incrementalPlaceholders != null && incrementalPlaceholders.length !== 0) invariant(false);
}
module.exports = {
    execute: execute
};

},{"49580c31bcbf7d59":"590td","eeb3dd86519eed11":"fMaLa","1ad75e1e684ac8da":"7EBX0","e0d2f76365dd12f8":"hYmcP","53effba0aa0a9f3b":"cvLlA","63f8b694e282c34e":"4vplj","c563ec7552178872":"fAMd2","684c4bb17ec7a904":"a0FL5","756e65a1b1e2b98a":"c3NLR","4496f0b8b2f0b455":"hkQdA","252789120f8e7534":"gL1rB","a01ca47262c4e73f":"138Hd","f9d3e7aecfe62c60":"daXOB","4efc4864b1deda57":"9k2Dg","83eea5189beedbbd":"6w3KR","792fd666f198e19":"3QcrW","cdbd9f2d618fa355":"e2sci","a122a32f941a9238":"j64TH"}],"4vplj":[function(require,module,exports,__globalThis) {
'use strict';
var _require = require("684bc1d68b06346"), REQUEST = _require.REQUEST, SPLIT_OPERATION = _require.SPLIT_OPERATION;
function getOperation(node) {
    switch(node.kind){
        case REQUEST:
            return node.operation;
        case SPLIT_OPERATION:
        default:
            return node;
    }
}
module.exports = getOperation;

},{"684bc1d68b06346":"jKskk"}],"fAMd2":[function(require,module,exports,__globalThis) {
'use strict';
function createError(type, name, messageFormat) {
    for(var _len = arguments.length, messageParams = new Array(_len > 3 ? _len - 3 : 0), _key = 3; _key < _len; _key++)messageParams[_key - 3] = arguments[_key];
    var index = 0;
    var message = messageFormat.replace(/%s/g, function() {
        return String(messageParams[index++]);
    });
    var err = new Error(message);
    var error = Object.assign(err, {
        name: name,
        messageFormat: messageFormat,
        messageParams: messageParams,
        type: type,
        taalOpcodes: [
            2,
            2
        ]
    });
    if (error.stack === undefined) try {
        throw error;
    } catch (_unused) {}
    return error;
}
module.exports = {
    create: function create(name, messageFormat) {
        for(var _len2 = arguments.length, messageParams = new Array(_len2 > 2 ? _len2 - 2 : 0), _key2 = 2; _key2 < _len2; _key2++)messageParams[_key2 - 2] = arguments[_key2];
        return createError.apply(void 0, [
            'error',
            name,
            messageFormat
        ].concat(messageParams));
    },
    createWarning: function createWarning(name, messageFormat) {
        for(var _len3 = arguments.length, messageParams = new Array(_len3 > 2 ? _len3 - 2 : 0), _key3 = 2; _key3 < _len3; _key3++)messageParams[_key3 - 2] = arguments[_key3];
        return createError.apply(void 0, [
            'warn',
            name,
            messageFormat
        ].concat(messageParams));
    }
};

},{}],"hkQdA":[function(require,module,exports,__globalThis) {
'use strict';
var _window, _window$performance;
var isPerformanceNowAvailable = typeof window !== 'undefined' && typeof ((_window = window) === null || _window === void 0 ? void 0 : (_window$performance = _window.performance) === null || _window$performance === void 0 ? void 0 : _window$performance.now) === 'function';
function currentTimestamp() {
    if (isPerformanceNowAvailable) return window.performance.now();
    return Date.now();
}
function withStartAndDuration(cb) {
    var startTime = currentTimestamp();
    var result = cb();
    return [
        startTime,
        currentTimestamp() - startTime,
        result
    ];
}
module.exports = withStartAndDuration;

},{}],"UtVKb":[function(require,module,exports,__globalThis) {
'use strict';
var _interopRequireDefault = require("f64bad905160f4d3")["default"];
var _createForOfIteratorHelper2 = _interopRequireDefault(require("190ddba815fb3f62"));
var _defineProperty2 = _interopRequireDefault(require("4e19f290ff1978d3"));
var _require = require("f54af5ebfb4311fb"), INTERNAL_ACTOR_IDENTIFIER_DO_NOT_USE = _require.INTERNAL_ACTOR_IDENTIFIER_DO_NOT_USE, assertInternalActorIdentifier = _require.assertInternalActorIdentifier;
var deepFreeze = require("18bb9ecbee002a2f");
var resolveImmediate = require("78c56959720021c2");
var DataChecker = require("b18862e0e0a93819");
var defaultGetDataID = require("a6ca7ceb1bb7cf83");
var _require2 = require("9b885f7225ee3db8"), LiveResolverCache = _require2.LiveResolverCache, RELAY_RESOLVER_LIVE_STATE_SUBSCRIPTION_KEY = _require2.RELAY_RESOLVER_LIVE_STATE_SUBSCRIPTION_KEY, getUpdatedDataIDs = _require2.getUpdatedDataIDs;
var RelayModernRecord = require("7b35a99c396ef879");
var RelayOptimisticRecordSource = require("55c75281919d2ce0");
var RelayReader = require("6230dc04d7f3579e");
var RelayReferenceMarker = require("9a40e7b3af11c655");
var RelayStoreSubscriptions = require("9f472790b702f603");
var RelayStoreUtils = require("6d0b52660284d11");
var _require3 = require("6d0b52660284d11"), ROOT_ID = _require3.ROOT_ID, ROOT_TYPE = _require3.ROOT_TYPE;
var invariant = require("769ab6f0a6ad31c1");
var DEFAULT_RELEASE_BUFFER_SIZE = 10;
var RelayModernStore = /*#__PURE__*/ function() {
    function RelayModernStore(source, options) {
        var _this = this;
        var _options$gcReleaseBuf, _options$shouldRetain, _options$gcScheduler, _options$getDataID, _options$log, _options$operationLoa, _options$shouldProces, _options$treatMissing;
        (0, _defineProperty2["default"])(this, "_gcStep", function() {
            if (_this._gcRun) {
                if (_this._gcRun.next().done) _this._gcRun = null;
                else _this._gcScheduler(_this._gcStep);
            }
        });
        var storeIDs, ii, record;
        this._currentWriteEpoch = 0;
        this._gcHoldCounter = 0;
        this._gcReleaseBufferSize = (_options$gcReleaseBuf = options === null || options === void 0 ? void 0 : options.gcReleaseBufferSize) !== null && _options$gcReleaseBuf !== void 0 ? _options$gcReleaseBuf : DEFAULT_RELEASE_BUFFER_SIZE;
        this._shouldRetainWithinTTL_EXPERIMENTAL = (_options$shouldRetain = options === null || options === void 0 ? void 0 : options.shouldRetainWithinTTL_EXPERIMENTAL) !== null && _options$shouldRetain !== void 0 ? _options$shouldRetain : false;
        this._gcRun = null;
        this._gcScheduler = (_options$gcScheduler = options === null || options === void 0 ? void 0 : options.gcScheduler) !== null && _options$gcScheduler !== void 0 ? _options$gcScheduler : resolveImmediate;
        this._getDataID = (_options$getDataID = options === null || options === void 0 ? void 0 : options.getDataID) !== null && _options$getDataID !== void 0 ? _options$getDataID : defaultGetDataID;
        this._globalInvalidationEpoch = null;
        this._invalidationSubscriptions = new Set();
        this._invalidatedRecordIDs = new Set();
        this.__log = (_options$log = options === null || options === void 0 ? void 0 : options.log) !== null && _options$log !== void 0 ? _options$log : null;
        this._queryCacheExpirationTime = options === null || options === void 0 ? void 0 : options.queryCacheExpirationTime;
        this._operationLoader = (_options$operationLoa = options === null || options === void 0 ? void 0 : options.operationLoader) !== null && _options$operationLoa !== void 0 ? _options$operationLoa : null;
        this._optimisticSource = null;
        this._recordSource = source;
        this._releaseBuffer = [];
        this._roots = new Map();
        this._shouldScheduleGC = false;
        this._resolverCache = new LiveResolverCache(function() {
            return _this._getMutableRecordSource();
        }, this);
        this._resolverContext = options === null || options === void 0 ? void 0 : options.resolverContext;
        this._storeSubscriptions = new RelayStoreSubscriptions(options === null || options === void 0 ? void 0 : options.log, this._resolverCache, this._resolverContext);
        this._updatedRecordIDs = new Set();
        this._shouldProcessClientComponents = (_options$shouldProces = options === null || options === void 0 ? void 0 : options.shouldProcessClientComponents) !== null && _options$shouldProces !== void 0 ? _options$shouldProces : false;
        this._treatMissingFieldsAsNull = (_options$treatMissing = options === null || options === void 0 ? void 0 : options.treatMissingFieldsAsNull) !== null && _options$treatMissing !== void 0 ? _options$treatMissing : false;
        this._actorIdentifier = options === null || options === void 0 ? void 0 : options.actorIdentifier;
        initializeRecordSource(this._recordSource);
    }
    var _proto = RelayModernStore.prototype;
    _proto.getSource = function getSource() {
        var _this$_optimisticSour;
        return (_this$_optimisticSour = this._optimisticSource) !== null && _this$_optimisticSour !== void 0 ? _this$_optimisticSour : this._recordSource;
    };
    _proto.getOperationLoader = function getOperationLoader() {
        return this._operationLoader;
    };
    _proto._getMutableRecordSource = function _getMutableRecordSource() {
        var _this$_optimisticSour2;
        return (_this$_optimisticSour2 = this._optimisticSource) !== null && _this$_optimisticSour2 !== void 0 ? _this$_optimisticSour2 : this._recordSource;
    };
    _proto.getLiveResolverPromise = function getLiveResolverPromise(recordID) {
        return this._resolverCache.getLiveResolverPromise(recordID);
    };
    _proto.batchLiveStateUpdates = function batchLiveStateUpdates(callback) {
        if (this.__log != null) this.__log({
            name: 'liveresolver.batch.start'
        });
        try {
            this._resolverCache.batchLiveStateUpdates(callback);
        } finally{
            if (this.__log != null) this.__log({
                name: 'liveresolver.batch.end'
            });
        }
    };
    _proto.check = function check(operation, options) {
        var _ref, _operation$request$no, _operation$request$no2, _options$handlers, _options$getSourceFor, _options$getTargetFor, _options$defaultActor;
        var selector = operation.root;
        var source = this._getMutableRecordSource();
        var globalInvalidationEpoch = this._globalInvalidationEpoch;
        var useExecTimeResolvers = (_ref = (_operation$request$no = operation.request.node.operation.use_exec_time_resolvers) !== null && _operation$request$no !== void 0 ? _operation$request$no : ((_operation$request$no2 = operation.request.node.operation.exec_time_resolvers_enabled_provider) === null || _operation$request$no2 === void 0 ? void 0 : _operation$request$no2.get()) === true) !== null && _ref !== void 0 ? _ref : false;
        var rootEntry = this._roots.get(operation.request.identifier);
        var operationLastWrittenAt = rootEntry != null ? rootEntry.epoch : null;
        if (globalInvalidationEpoch != null) {
            if (operationLastWrittenAt == null || operationLastWrittenAt <= globalInvalidationEpoch) return {
                status: 'stale'
            };
        }
        var handlers = (_options$handlers = options === null || options === void 0 ? void 0 : options.handlers) !== null && _options$handlers !== void 0 ? _options$handlers : [];
        var getSourceForActor = (_options$getSourceFor = options === null || options === void 0 ? void 0 : options.getSourceForActor) !== null && _options$getSourceFor !== void 0 ? _options$getSourceFor : function(actorIdentifier) {
            assertInternalActorIdentifier(actorIdentifier);
            return source;
        };
        var getTargetForActor = (_options$getTargetFor = options === null || options === void 0 ? void 0 : options.getTargetForActor) !== null && _options$getTargetFor !== void 0 ? _options$getTargetFor : function(actorIdentifier) {
            assertInternalActorIdentifier(actorIdentifier);
            return source;
        };
        var operationAvailability = DataChecker.check(getSourceForActor, getTargetForActor, (_options$defaultActor = options === null || options === void 0 ? void 0 : options.defaultActorIdentifier) !== null && _options$defaultActor !== void 0 ? _options$defaultActor : INTERNAL_ACTOR_IDENTIFIER_DO_NOT_USE, selector, handlers, this._operationLoader, this._getDataID, this._shouldProcessClientComponents, this.__log, useExecTimeResolvers);
        return getAvailabilityStatus(operationAvailability, operationLastWrittenAt, rootEntry === null || rootEntry === void 0 ? void 0 : rootEntry.fetchTime, this._queryCacheExpirationTime);
    };
    _proto.retain = function retain(operation) {
        var _this2 = this;
        var id = operation.request.identifier;
        var disposed = false;
        var dispose = function dispose() {
            if (disposed) return;
            disposed = true;
            var rootEntry = _this2._roots.get(id);
            if (rootEntry == null) return;
            rootEntry.refCount--;
            if (rootEntry.refCount === 0) {
                var _queryCacheExpirationTime = _this2._queryCacheExpirationTime;
                var rootEntryIsStale = rootEntry.fetchTime != null && _queryCacheExpirationTime != null && rootEntry.fetchTime <= Date.now() - _queryCacheExpirationTime;
                if (rootEntryIsStale) {
                    if (!_this2._shouldRetainWithinTTL_EXPERIMENTAL) _this2._roots["delete"](id);
                    _this2.scheduleGC();
                } else {
                    _this2._releaseBuffer.push(id);
                    if (_this2._releaseBuffer.length > _this2._gcReleaseBufferSize) {
                        var _id = _this2._releaseBuffer.shift();
                        if (!_this2._shouldRetainWithinTTL_EXPERIMENTAL) _this2._roots["delete"](_id);
                        _this2.scheduleGC();
                    }
                }
            }
        };
        var rootEntry = this._roots.get(id);
        if (rootEntry != null) {
            if (rootEntry.refCount === 0) this._releaseBuffer = this._releaseBuffer.filter(function(_id) {
                return _id !== id;
            });
            rootEntry.refCount += 1;
        } else this._roots.set(id, {
            operation: operation,
            refCount: 1,
            epoch: null,
            fetchTime: null
        });
        return {
            dispose: dispose
        };
    };
    _proto.lookup = function lookup(selector) {
        var log = this.__log;
        if (log != null) log({
            name: 'store.lookup.start',
            selector: selector
        });
        var source = this.getSource();
        var snapshot = RelayReader.read(source, selector, this._resolverCache, this._resolverContext);
        if (log != null) log({
            name: 'store.lookup.end',
            selector: selector
        });
        return snapshot;
    };
    _proto.notify = function notify(sourceOperation, invalidateStore) {
        var _this3 = this;
        var log = this.__log;
        if (log != null) log({
            name: 'store.notify.start',
            sourceOperation: sourceOperation
        });
        this._currentWriteEpoch++;
        if (invalidateStore === true) this._globalInvalidationEpoch = this._currentWriteEpoch;
        this._resolverCache.invalidateDataIDs(this._updatedRecordIDs);
        var source = this.getSource();
        var updatedOwners = [];
        this._storeSubscriptions.updateSubscriptions(source, this._updatedRecordIDs, updatedOwners, sourceOperation);
        this._invalidationSubscriptions.forEach(function(subscription) {
            _this3._updateInvalidationSubscription(subscription, invalidateStore === true);
        });
        if (sourceOperation != null) {
            var id = sourceOperation.request.identifier;
            var rootEntry = this._roots.get(id);
            if (rootEntry != null) {
                rootEntry.epoch = this._currentWriteEpoch;
                rootEntry.fetchTime = Date.now();
            } else if (sourceOperation.request.node.params.operationKind === 'query' && this._gcReleaseBufferSize > 0 && this._releaseBuffer.length < this._gcReleaseBufferSize) {
                var temporaryRootEntry = {
                    operation: sourceOperation,
                    refCount: 0,
                    epoch: this._currentWriteEpoch,
                    fetchTime: Date.now()
                };
                this._releaseBuffer.push(id);
                this._roots.set(id, temporaryRootEntry);
            }
        }
        if (log != null) log({
            name: 'store.notify.complete',
            sourceOperation: sourceOperation,
            updatedRecordIDs: this._updatedRecordIDs,
            invalidatedRecordIDs: this._invalidatedRecordIDs,
            subscriptionsSize: this._storeSubscriptions.size(),
            updatedOwners: updatedOwners
        });
        this._updatedRecordIDs.clear();
        this._invalidatedRecordIDs.clear();
        return updatedOwners;
    };
    _proto.publish = function publish(source, idsMarkedForInvalidation) {
        var target = this._getMutableRecordSource();
        updateTargetFromSource(target, source, this._currentWriteEpoch + 1, idsMarkedForInvalidation, this._updatedRecordIDs, this._invalidatedRecordIDs);
        var log = this.__log;
        if (log != null) log({
            name: 'store.publish',
            source: source,
            optimistic: target === this._optimisticSource
        });
    };
    _proto.subscribe = function subscribe(snapshot, callback) {
        return this._storeSubscriptions.subscribe(snapshot, callback);
    };
    _proto.holdGC = function holdGC() {
        var _this4 = this;
        if (this._gcRun) {
            this._gcRun = null;
            this._shouldScheduleGC = true;
        }
        this._gcHoldCounter++;
        var dispose = function dispose() {
            if (_this4._gcHoldCounter > 0) {
                _this4._gcHoldCounter--;
                if (_this4._gcHoldCounter === 0 && _this4._shouldScheduleGC) {
                    _this4.scheduleGC();
                    _this4._shouldScheduleGC = false;
                }
            }
        };
        return {
            dispose: dispose
        };
    };
    _proto.toJSON = function toJSON() {
        return 'RelayModernStore()';
    };
    _proto.getEpoch = function getEpoch() {
        return this._currentWriteEpoch;
    };
    _proto.__getUpdatedRecordIDs = function __getUpdatedRecordIDs() {
        return this._updatedRecordIDs;
    };
    _proto.lookupInvalidationState = function lookupInvalidationState(dataIDs) {
        var _this5 = this;
        var invalidations = new Map();
        dataIDs.forEach(function(dataID) {
            var _RelayModernRecord$ge;
            var record = _this5.getSource().get(dataID);
            invalidations.set(dataID, (_RelayModernRecord$ge = RelayModernRecord.getInvalidationEpoch(record)) !== null && _RelayModernRecord$ge !== void 0 ? _RelayModernRecord$ge : null);
        });
        invalidations.set('global', this._globalInvalidationEpoch);
        return {
            dataIDs: dataIDs,
            invalidations: invalidations
        };
    };
    _proto.checkInvalidationState = function checkInvalidationState(prevInvalidationState) {
        var latestInvalidationState = this.lookupInvalidationState(prevInvalidationState.dataIDs);
        var currentInvalidations = latestInvalidationState.invalidations;
        var prevInvalidations = prevInvalidationState.invalidations;
        if (currentInvalidations.get('global') !== prevInvalidations.get('global')) return true;
        var _iterator = (0, _createForOfIteratorHelper2["default"])(prevInvalidationState.dataIDs), _step;
        try {
            for(_iterator.s(); !(_step = _iterator.n()).done;){
                var dataID = _step.value;
                if (currentInvalidations.get(dataID) !== prevInvalidations.get(dataID)) return true;
            }
        } catch (err) {
            _iterator.e(err);
        } finally{
            _iterator.f();
        }
        return false;
    };
    _proto.subscribeToInvalidationState = function subscribeToInvalidationState(invalidationState, callback) {
        var _this6 = this;
        var subscription = {
            callback: callback,
            invalidationState: invalidationState
        };
        var dispose = function dispose() {
            _this6._invalidationSubscriptions["delete"](subscription);
        };
        this._invalidationSubscriptions.add(subscription);
        return {
            dispose: dispose
        };
    };
    _proto._updateInvalidationSubscription = function _updateInvalidationSubscription(subscription, invalidatedStore) {
        var _this7 = this;
        var callback = subscription.callback, invalidationState = subscription.invalidationState;
        var dataIDs = invalidationState.dataIDs;
        var isSubscribedToInvalidatedIDs = invalidatedStore || dataIDs.some(function(dataID) {
            return _this7._invalidatedRecordIDs.has(dataID);
        });
        if (!isSubscribedToInvalidatedIDs) return;
        callback();
    };
    _proto.snapshot = function snapshot() {
        !(this._optimisticSource == null) && invariant(false);
        var log = this.__log;
        if (log != null) log({
            name: 'store.snapshot'
        });
        this._storeSubscriptions.snapshotSubscriptions(this.getSource());
        if (this._gcRun) {
            this._gcRun = null;
            this._shouldScheduleGC = true;
        }
        this._optimisticSource = RelayOptimisticRecordSource.create(this.getSource());
    };
    _proto.restore = function restore() {
        var optimisticSource = this._optimisticSource;
        !optimisticSource && invariant(false);
        var log = this.__log;
        if (log != null) log({
            name: 'store.restore'
        });
        var optimisticIDs = RelayOptimisticRecordSource.getOptimisticRecordIDs(optimisticSource);
        this._resolverCache.unsubscribeFromLiveResolverRecords(optimisticIDs);
        this._optimisticSource = null;
        if (this._shouldScheduleGC) this.scheduleGC();
        this._storeSubscriptions.restoreSubscriptions();
        this._resolverCache.invalidateResolverRecords(optimisticIDs);
    };
    _proto.scheduleGC = function scheduleGC() {
        if (this._gcHoldCounter > 0) {
            this._shouldScheduleGC = true;
            return;
        }
        if (this._gcRun) return;
        this._gcRun = this._collect();
        this._gcScheduler(this._gcStep);
    };
    _proto.__gc = function __gc() {
        if (this._optimisticSource != null) return;
        var gcRun = this._collect();
        while(!gcRun.next().done);
    };
    _proto._collect = function* _collect() {
        if (this._shouldRetainWithinTTL_EXPERIMENTAL && this._queryCacheExpirationTime == null) return;
        var log = this.__log;
        top: while(true){
            if (log != null) log({
                name: 'store.gc.start'
            });
            var startEpoch = this._currentWriteEpoch;
            var references = new Set();
            var _iterator2 = (0, _createForOfIteratorHelper2["default"])(this._roots.entries()), _step2;
            try {
                for(_iterator2.s(); !(_step2 = _iterator2.n()).done;){
                    var _ref2, _operation$request$no3, _operation$request$no4;
                    var _step2$value = _step2.value, _dataID = _step2$value[0], _step2$value$ = _step2$value[1], operation = _step2$value$.operation, refCount = _step2$value$.refCount, fetchTime = _step2$value$.fetchTime;
                    if (this._shouldRetainWithinTTL_EXPERIMENTAL) {
                        var _queryCacheExpirationTime = this._queryCacheExpirationTime;
                        !(_queryCacheExpirationTime != null) && invariant(false);
                        var recordHasExpired = fetchTime == null || fetchTime <= Date.now() - _queryCacheExpirationTime;
                        var recordShouldBeCollected = recordHasExpired && refCount === 0 && !this._releaseBuffer.includes(_dataID);
                        if (recordShouldBeCollected) continue;
                    }
                    var selector = operation.root;
                    var useExecTimeResolvers = (_ref2 = (_operation$request$no3 = operation.request.node.operation.use_exec_time_resolvers) !== null && _operation$request$no3 !== void 0 ? _operation$request$no3 : ((_operation$request$no4 = operation.request.node.operation.exec_time_resolvers_enabled_provider) === null || _operation$request$no4 === void 0 ? void 0 : _operation$request$no4.get()) === true) !== null && _ref2 !== void 0 ? _ref2 : false;
                    RelayReferenceMarker.mark(this._recordSource, selector, references, this._operationLoader, this._shouldProcessClientComponents, useExecTimeResolvers);
                    yield;
                    if (startEpoch !== this._currentWriteEpoch) {
                        if (log != null) log({
                            name: 'store.gc.interrupted'
                        });
                        continue top;
                    }
                }
            } catch (err) {
                _iterator2.e(err);
            } finally{
                _iterator2.f();
            }
            var storeIDs = this._recordSource.getRecordIDs();
            for(var ii = 0; ii < storeIDs.length; ii++){
                var dataID = storeIDs[ii];
                if (!references.has(dataID)) {
                    var record = this._recordSource.get(dataID);
                    if (record != null) {
                        var maybeResolverSubscription = RelayModernRecord.getValue(record, RELAY_RESOLVER_LIVE_STATE_SUBSCRIPTION_KEY);
                        if (maybeResolverSubscription != null) maybeResolverSubscription();
                    }
                    this._recordSource.remove(dataID);
                    if (this._shouldRetainWithinTTL_EXPERIMENTAL) this._roots["delete"](dataID);
                }
            }
            if (log != null) log({
                name: 'store.gc.end',
                references: references
            });
            return;
        }
    };
    _proto.__getNormalizationOptions = function __getNormalizationOptions(path) {
        return {
            path: path,
            getDataID: this._getDataID,
            log: this.__log,
            treatMissingFieldsAsNull: this._treatMissingFieldsAsNull,
            shouldProcessClientComponents: this._shouldProcessClientComponents,
            actorIdentifier: this._actorIdentifier
        };
    };
    _proto.__notifyUpdatedSubscribers = function __notifyUpdatedSubscribers(updatedRecords) {
        var nextUpdatedRecordIDs = getUpdatedDataIDs(updatedRecords);
        var prevUpdatedRecordIDs = this._updatedRecordIDs;
        this._updatedRecordIDs = nextUpdatedRecordIDs;
        this.notify();
        this._updatedRecordIDs = prevUpdatedRecordIDs;
    };
    return RelayModernStore;
}();
function initializeRecordSource(target) {
    if (!target.has(ROOT_ID)) {
        var rootRecord = RelayModernRecord.create(ROOT_ID, ROOT_TYPE);
        target.set(ROOT_ID, rootRecord);
    }
}
function updateTargetFromSource(target, source, currentWriteEpoch, idsMarkedForInvalidation, updatedRecordIDs, invalidatedRecordIDs) {
    if (idsMarkedForInvalidation) idsMarkedForInvalidation.forEach(function(dataID) {
        var targetRecord = target.get(dataID);
        var sourceRecord = source.get(dataID);
        if (sourceRecord === null) return;
        var nextRecord;
        if (targetRecord != null) nextRecord = RelayModernRecord.clone(targetRecord);
        else nextRecord = sourceRecord != null ? RelayModernRecord.clone(sourceRecord) : null;
        if (!nextRecord) return;
        RelayModernRecord.setValue(nextRecord, RelayStoreUtils.INVALIDATED_AT_KEY, currentWriteEpoch);
        invalidatedRecordIDs.add(dataID);
        target.set(dataID, nextRecord);
    });
    var dataIDs = source.getRecordIDs();
    for(var ii = 0; ii < dataIDs.length; ii++){
        var dataID = dataIDs[ii];
        var sourceRecord = source.get(dataID);
        var targetRecord = target.get(dataID);
        if (sourceRecord && targetRecord) {
            var nextRecord = RelayModernRecord.update(targetRecord, sourceRecord);
            if (nextRecord !== targetRecord) {
                updatedRecordIDs.add(dataID);
                target.set(dataID, nextRecord);
            }
        } else if (sourceRecord === null) {
            target["delete"](dataID);
            if (targetRecord !== null) updatedRecordIDs.add(dataID);
        } else if (sourceRecord) {
            target.set(dataID, sourceRecord);
            updatedRecordIDs.add(dataID);
        }
    }
}
function getAvailabilityStatus(operationAvailability, operationLastWrittenAt, operationFetchTime, queryCacheExpirationTime) {
    var mostRecentlyInvalidatedAt = operationAvailability.mostRecentlyInvalidatedAt, status = operationAvailability.status;
    if (typeof mostRecentlyInvalidatedAt === 'number') {
        if (operationLastWrittenAt == null || mostRecentlyInvalidatedAt > operationLastWrittenAt) return {
            status: 'stale'
        };
    }
    if (status === 'missing') return {
        status: 'missing'
    };
    if (operationFetchTime != null && queryCacheExpirationTime != null) {
        var isStale = operationFetchTime <= Date.now() - queryCacheExpirationTime;
        if (isStale) return {
            status: 'stale'
        };
    }
    return {
        status: 'available',
        fetchTime: operationFetchTime !== null && operationFetchTime !== void 0 ? operationFetchTime : null
    };
}
module.exports = RelayModernStore;

},{"f64bad905160f4d3":"590td","190ddba815fb3f62":"fMaLa","4e19f290ff1978d3":"2paQ8","f54af5ebfb4311fb":"cFrVW","18bb9ecbee002a2f":"eLea7","78c56959720021c2":"b0sng","b18862e0e0a93819":"hp2zf","a6ca7ceb1bb7cf83":"febBR","9b885f7225ee3db8":"7eTWP","7b35a99c396ef879":"daXOB","55c75281919d2ce0":"4BdDg","6230dc04d7f3579e":"hTh0M","9a40e7b3af11c655":"7FTk2","9f472790b702f603":"idAWU","6d0b52660284d11":"3QcrW","769ab6f0a6ad31c1":"e2sci"}],"b0sng":[function(require,module,exports,__globalThis) {
'use strict';
var resolvedPromise = Promise.resolve();
function resolveImmediate(callback) {
    resolvedPromise.then(callback)["catch"](throwNext);
}
function throwNext(error) {
    setTimeout(function() {
        throw error;
    }, 0);
}
module.exports = resolveImmediate;

},{}],"hp2zf":[function(require,module,exports,__globalThis) {
'use strict';
var _interopRequireDefault = require("cacb16c80358f382")["default"];
var _createForOfIteratorHelper2 = _interopRequireDefault(require("c9437aaebe2e50fb"));
var RelayRecordSourceMutator = require("67275ac85415bb64");
var RelayRecordSourceProxy = require("9bc9307a48a617b6");
var getOperation = require("42765387566e697a");
var _require = require("1734def79cf4224f"), isClientID = _require.isClientID;
var cloneRelayHandleSourceField = require("99184f9281e13032");
var cloneRelayScalarHandleSourceField = require("267fdc08bd0843b8");
var _require2 = require("79f7dc7c88f08046"), getLocalVariables = _require2.getLocalVariables;
var RelayModernRecord = require("4cad14c75485f3d5");
var _require3 = require("9fc303a9caffd777"), EXISTENT = _require3.EXISTENT, UNKNOWN = _require3.UNKNOWN;
var RelayStoreUtils = require("cee3709b7a61c6f4");
var _require4 = require("18895cbeaffca9ef"), TYPE_SCHEMA_TYPE = _require4.TYPE_SCHEMA_TYPE, generateTypeID = _require4.generateTypeID;
var invariant = require("f36c90befa49e5c9");
var getModuleOperationKey = RelayStoreUtils.getModuleOperationKey, getStorageKey = RelayStoreUtils.getStorageKey, getArgumentValues = RelayStoreUtils.getArgumentValues;
function check(getSourceForActor, getTargetForActor, defaultActorIdentifier, selector, handlers, operationLoader, getDataID, shouldProcessClientComponents, log, useExecTimeResolvers) {
    if (log != null) log({
        name: 'store.datachecker.start',
        selector: selector
    });
    var dataID = selector.dataID, node = selector.node, variables = selector.variables;
    var checker = new DataChecker(getSourceForActor, getTargetForActor, defaultActorIdentifier, variables, handlers, operationLoader, getDataID, shouldProcessClientComponents, log, useExecTimeResolvers);
    var result = checker.check(node, dataID);
    if (log != null) log({
        name: 'store.datachecker.end',
        selector: selector
    });
    return result;
}
var DataChecker = /*#__PURE__*/ function() {
    function DataChecker(getSourceForActor, getTargetForActor, defaultActorIdentifier, variables, handlers, operationLoader, getDataID, shouldProcessClientComponents, log, useExecTimeResolvers) {
        this._getSourceForActor = getSourceForActor;
        this._getTargetForActor = getTargetForActor;
        this._getDataID = getDataID;
        this._source = getSourceForActor(defaultActorIdentifier);
        this._mutatorRecordSourceProxyCache = new Map();
        var _this$_getMutatorAndR = this._getMutatorAndRecordProxyForActor(defaultActorIdentifier), mutator = _this$_getMutatorAndR[0], recordSourceProxy = _this$_getMutatorAndR[1];
        this._useExecTimeResolvers = useExecTimeResolvers !== null && useExecTimeResolvers !== void 0 ? useExecTimeResolvers : false;
        this._mostRecentlyInvalidatedAt = null;
        this._handlers = handlers;
        this._mutator = mutator;
        this._operationLoader = operationLoader !== null && operationLoader !== void 0 ? operationLoader : null;
        this._recordSourceProxy = recordSourceProxy;
        this._recordWasMissing = false;
        this._variables = variables;
        this._shouldProcessClientComponents = shouldProcessClientComponents;
        this._log = log;
    }
    var _proto = DataChecker.prototype;
    _proto._getMutatorAndRecordProxyForActor = function _getMutatorAndRecordProxyForActor(actorIdentifier) {
        var tuple = this._mutatorRecordSourceProxyCache.get(actorIdentifier);
        if (tuple == null) {
            var target = this._getTargetForActor(actorIdentifier);
            var mutator = new RelayRecordSourceMutator(this._getSourceForActor(actorIdentifier), target);
            var recordSourceProxy = new RelayRecordSourceProxy(mutator, this._getDataID, undefined, this._handlers, this._log);
            tuple = [
                mutator,
                recordSourceProxy
            ];
            this._mutatorRecordSourceProxyCache.set(actorIdentifier, tuple);
        }
        return tuple;
    };
    _proto.check = function check(node, dataID) {
        this._assignClientAbstractTypes(node);
        this._traverse(node, dataID);
        return this._recordWasMissing === true ? {
            status: 'missing',
            mostRecentlyInvalidatedAt: this._mostRecentlyInvalidatedAt
        } : {
            status: 'available',
            mostRecentlyInvalidatedAt: this._mostRecentlyInvalidatedAt
        };
    };
    _proto._getVariableValue = function _getVariableValue(name) {
        !this._variables.hasOwnProperty(name) && invariant(false);
        return this._variables[name];
    };
    _proto._handleMissing = function _handleMissing() {
        this._recordWasMissing = true;
    };
    _proto._handleMissingScalarField = function _handleMissingScalarField(field, dataID) {
        if (field.name === 'id' && field.alias == null && isClientID(dataID)) return undefined;
        var args = field.args != undefined ? getArgumentValues(field.args, this._variables) : {};
        var _iterator = (0, _createForOfIteratorHelper2["default"])(this._handlers), _step;
        try {
            for(_iterator.s(); !(_step = _iterator.n()).done;){
                var handler = _step.value;
                if (handler.kind === 'scalar') {
                    var newValue = handler.handle(field, this._recordSourceProxy.get(dataID), args, this._recordSourceProxy);
                    if (newValue !== undefined) return newValue;
                }
            }
        } catch (err) {
            _iterator.e(err);
        } finally{
            _iterator.f();
        }
        this._handleMissing();
    };
    _proto._handleMissingLinkField = function _handleMissingLinkField(field, dataID) {
        var args = field.args != undefined ? getArgumentValues(field.args, this._variables) : {};
        var _iterator2 = (0, _createForOfIteratorHelper2["default"])(this._handlers), _step2;
        try {
            for(_iterator2.s(); !(_step2 = _iterator2.n()).done;){
                var handler = _step2.value;
                if (handler.kind === 'linked') {
                    var newValue = handler.handle(field, this._recordSourceProxy.get(dataID), args, this._recordSourceProxy);
                    if (newValue !== undefined && (newValue === null || this._mutator.getStatus(newValue) === EXISTENT)) return newValue;
                }
            }
        } catch (err) {
            _iterator2.e(err);
        } finally{
            _iterator2.f();
        }
        this._handleMissing();
    };
    _proto._handleMissingPluralLinkField = function _handleMissingPluralLinkField(field, dataID) {
        var _this = this;
        var args = field.args != undefined ? getArgumentValues(field.args, this._variables) : {};
        var _iterator3 = (0, _createForOfIteratorHelper2["default"])(this._handlers), _step3;
        try {
            for(_iterator3.s(); !(_step3 = _iterator3.n()).done;){
                var handler = _step3.value;
                if (handler.kind === 'pluralLinked') {
                    var newValue = handler.handle(field, this._recordSourceProxy.get(dataID), args, this._recordSourceProxy);
                    if (newValue != null) {
                        var allItemsKnown = newValue.every(function(linkedID) {
                            return linkedID != null && _this._mutator.getStatus(linkedID) === EXISTENT;
                        });
                        if (allItemsKnown) return newValue;
                    } else if (newValue === null) return null;
                }
            }
        } catch (err) {
            _iterator3.e(err);
        } finally{
            _iterator3.f();
        }
        this._handleMissing();
    };
    _proto._traverse = function _traverse(node, dataID) {
        var status = this._mutator.getStatus(dataID);
        if (status === UNKNOWN) this._handleMissing();
        if (status === EXISTENT) {
            var record = this._source.get(dataID);
            var invalidatedAt = RelayModernRecord.getInvalidationEpoch(record);
            if (invalidatedAt != null) this._mostRecentlyInvalidatedAt = this._mostRecentlyInvalidatedAt != null ? Math.max(this._mostRecentlyInvalidatedAt, invalidatedAt) : invalidatedAt;
            this._traverseSelections(node.selections, dataID);
        }
    };
    _proto._traverseSelections = function _traverseSelections(selections, dataID) {
        var _this2 = this;
        selections.forEach(function(selection) {
            switch(selection.kind){
                case 'ScalarField':
                    _this2._checkScalar(selection, dataID);
                    break;
                case 'LinkedField':
                    if (selection.plural) _this2._checkPluralLink(selection, dataID);
                    else _this2._checkLink(selection, dataID);
                    break;
                case 'ActorChange':
                    _this2._checkActorChange(selection.linkedField, dataID);
                    break;
                case 'Condition':
                    var conditionValue = Boolean(_this2._getVariableValue(selection.condition));
                    if (conditionValue === selection.passingValue) _this2._traverseSelections(selection.selections, dataID);
                    break;
                case 'InlineFragment':
                    var _abstractKey = selection.abstractKey;
                    if (_abstractKey == null) {
                        var typeName = _this2._mutator.getType(dataID);
                        if (typeName === selection.type) _this2._traverseSelections(selection.selections, dataID);
                    } else {
                        var _recordType = _this2._mutator.getType(dataID);
                        !(_recordType != null) && invariant(false);
                        var _typeID = generateTypeID(_recordType);
                        var _implementsInterface = _this2._mutator.getValue(_typeID, _abstractKey);
                        if (_implementsInterface === true) _this2._traverseSelections(selection.selections, dataID);
                        else if (_implementsInterface == null) _this2._handleMissing();
                    }
                    break;
                case 'LinkedHandle':
                    var handleField = cloneRelayHandleSourceField(selection, selections, _this2._variables);
                    if (handleField.plural) _this2._checkPluralLink(handleField, dataID);
                    else _this2._checkLink(handleField, dataID);
                    break;
                case 'ScalarHandle':
                    var _handleField = cloneRelayScalarHandleSourceField(selection, selections, _this2._variables);
                    _this2._checkScalar(_handleField, dataID);
                    break;
                case 'ModuleImport':
                    _this2._checkModuleImport(selection, dataID);
                    break;
                case 'Defer':
                case 'Stream':
                    _this2._traverseSelections(selection.selections, dataID);
                    break;
                case 'FragmentSpread':
                    var prevVariables = _this2._variables;
                    _this2._variables = getLocalVariables(_this2._variables, selection.fragment.argumentDefinitions, selection.args);
                    _this2._traverseSelections(selection.fragment.selections, dataID);
                    _this2._variables = prevVariables;
                    break;
                case 'ClientExtension':
                    var recordWasMissing = _this2._recordWasMissing;
                    _this2._traverseSelections(selection.selections, dataID);
                    _this2._recordWasMissing = recordWasMissing;
                    break;
                case 'TypeDiscriminator':
                    var abstractKey = selection.abstractKey;
                    var recordType = _this2._mutator.getType(dataID);
                    !(recordType != null) && invariant(false);
                    var typeID = generateTypeID(recordType);
                    var implementsInterface = _this2._mutator.getValue(typeID, abstractKey);
                    if (implementsInterface == null) _this2._handleMissing();
                    break;
                case 'ClientComponent':
                    if (_this2._shouldProcessClientComponents === false) break;
                    _this2._traverseSelections(selection.fragment.selections, dataID);
                    break;
                case 'RelayResolver':
                case 'RelayLiveResolver':
                    if (!_this2._useExecTimeResolvers) _this2._checkResolver(selection, dataID);
                    break;
                case 'ClientEdgeToClientObject':
                    if (!_this2._useExecTimeResolvers) _this2._checkResolver(selection.backingField, dataID);
                    break;
                default:
                    selection;
                    invariant(false);
            }
        });
    };
    _proto._checkResolver = function _checkResolver(resolver, dataID) {
        if (resolver.fragment) this._traverseSelections([
            resolver.fragment
        ], dataID);
    };
    _proto._checkModuleImport = function _checkModuleImport(moduleImport, dataID) {
        var operationLoader = this._operationLoader;
        !(operationLoader !== null) && invariant(false);
        var operationKey = getModuleOperationKey(moduleImport.documentName);
        var operationReference = this._mutator.getValue(dataID, operationKey);
        if (operationReference == null) {
            if (operationReference === undefined) this._handleMissing();
            return;
        }
        var normalizationRootNode = operationLoader.get(operationReference);
        if (normalizationRootNode != null) {
            var operation = getOperation(normalizationRootNode);
            var prevVariables = this._variables;
            this._variables = getLocalVariables(this._variables, operation.argumentDefinitions, moduleImport.args);
            this._traverse(operation, dataID);
            this._variables = prevVariables;
        } else this._handleMissing();
    };
    _proto._checkScalar = function _checkScalar(field, dataID) {
        var storageKey = getStorageKey(field, this._variables);
        var fieldValue = this._mutator.getValue(dataID, storageKey);
        if (fieldValue === undefined) {
            fieldValue = this._handleMissingScalarField(field, dataID);
            if (fieldValue !== undefined) this._mutator.setValue(dataID, storageKey, fieldValue);
        }
    };
    _proto._checkLink = function _checkLink(field, dataID) {
        var storageKey = getStorageKey(field, this._variables);
        var linkedID = this._mutator.getLinkedRecordID(dataID, storageKey);
        if (linkedID === undefined) {
            linkedID = this._handleMissingLinkField(field, dataID);
            if (linkedID != null) this._mutator.setLinkedRecordID(dataID, storageKey, linkedID);
            else if (linkedID === null) this._mutator.setValue(dataID, storageKey, null);
        }
        if (linkedID != null) this._traverse(field, linkedID);
    };
    _proto._checkPluralLink = function _checkPluralLink(field, dataID) {
        var _this3 = this;
        var storageKey = getStorageKey(field, this._variables);
        var linkedIDs = this._mutator.getLinkedRecordIDs(dataID, storageKey);
        if (linkedIDs === undefined) {
            linkedIDs = this._handleMissingPluralLinkField(field, dataID);
            if (linkedIDs != null) this._mutator.setLinkedRecordIDs(dataID, storageKey, linkedIDs);
            else if (linkedIDs === null) this._mutator.setValue(dataID, storageKey, null);
        }
        if (linkedIDs) linkedIDs.forEach(function(linkedID) {
            if (linkedID != null) _this3._traverse(field, linkedID);
        });
    };
    _proto._checkActorChange = function _checkActorChange(field, dataID) {
        var storageKey = getStorageKey(field, this._variables);
        var record = this._source.get(dataID);
        var tuple = record != null ? RelayModernRecord.getActorLinkedRecordID(record, storageKey) : record;
        if (tuple == null) {
            if (tuple === undefined) this._handleMissing();
        } else {
            var actorIdentifier = tuple[0], linkedID = tuple[1];
            var prevSource = this._source;
            var prevMutator = this._mutator;
            var prevRecordSourceProxy = this._recordSourceProxy;
            var _this$_getMutatorAndR2 = this._getMutatorAndRecordProxyForActor(actorIdentifier), mutator = _this$_getMutatorAndR2[0], recordSourceProxy = _this$_getMutatorAndR2[1];
            this._source = this._getSourceForActor(actorIdentifier);
            this._mutator = mutator;
            this._recordSourceProxy = recordSourceProxy;
            this._assignClientAbstractTypes(field);
            this._traverse(field, linkedID);
            this._source = prevSource;
            this._mutator = prevMutator;
            this._recordSourceProxy = prevRecordSourceProxy;
        }
    };
    _proto._assignClientAbstractTypes = function _assignClientAbstractTypes(node) {
        var clientAbstractTypes = node.clientAbstractTypes;
        if (clientAbstractTypes != null) for(var _i = 0, _Object$keys = Object.keys(clientAbstractTypes); _i < _Object$keys.length; _i++){
            var abstractType = _Object$keys[_i];
            var _iterator4 = (0, _createForOfIteratorHelper2["default"])(clientAbstractTypes[abstractType]), _step4;
            try {
                for(_iterator4.s(); !(_step4 = _iterator4.n()).done;){
                    var concreteType = _step4.value;
                    var typeID = generateTypeID(concreteType);
                    if (this._source.get(typeID) == null) this._mutator.create(typeID, TYPE_SCHEMA_TYPE);
                    if (this._mutator.getValue(typeID, abstractType) == null) this._mutator.setValue(typeID, abstractType, true);
                }
            } catch (err) {
                _iterator4.e(err);
            } finally{
                _iterator4.f();
            }
        }
    };
    return DataChecker;
}();
module.exports = {
    check: check
};

},{"cacb16c80358f382":"590td","c9437aaebe2e50fb":"fMaLa","67275ac85415bb64":"kKEFB","9bc9307a48a617b6":"7OCKP","42765387566e697a":"4vplj","1734def79cf4224f":"gL1rB","99184f9281e13032":"hUbQm","267fdc08bd0843b8":"6XW3k","79f7dc7c88f08046":"138Hd","4cad14c75485f3d5":"daXOB","9fc303a9caffd777":"7LnXj","cee3709b7a61c6f4":"3QcrW","18895cbeaffca9ef":"32ztQ","f36c90befa49e5c9":"e2sci"}],"kKEFB":[function(require,module,exports,__globalThis) {
'use strict';
var RelayModernRecord = require("f7566715ac011ace");
var _require = require("cadd642407d15db9"), EXISTENT = _require.EXISTENT;
var invariant = require("15734011101e0993");
var RelayRecordSourceMutator = /*#__PURE__*/ function() {
    function RelayRecordSourceMutator(base, sink) {
        this.__sources = [
            sink,
            base
        ];
        this._base = base;
        this._sink = sink;
    }
    var _proto = RelayRecordSourceMutator.prototype;
    _proto.unstable_getRawRecordWithChanges = function unstable_getRawRecordWithChanges(dataID) {
        var baseRecord = this._base.get(dataID);
        var sinkRecord = this._sink.get(dataID);
        if (sinkRecord === undefined) {
            if (baseRecord == null) return baseRecord;
            var nextRecord = RelayModernRecord.clone(baseRecord);
            return nextRecord;
        } else if (sinkRecord === null) return null;
        else if (baseRecord != null) {
            var _nextRecord = RelayModernRecord.update(baseRecord, sinkRecord);
            return _nextRecord;
        } else {
            var _nextRecord2 = RelayModernRecord.clone(sinkRecord);
            return _nextRecord2;
        }
    };
    _proto._getSinkRecord = function _getSinkRecord(dataID) {
        var sinkRecord = this._sink.get(dataID);
        if (!sinkRecord) {
            var baseRecord = this._base.get(dataID);
            !baseRecord && invariant(false);
            sinkRecord = RelayModernRecord.create(dataID, RelayModernRecord.getType(baseRecord));
            this._sink.set(dataID, sinkRecord);
        }
        return sinkRecord;
    };
    _proto.copyFields = function copyFields(sourceID, sinkID) {
        var sinkSource = this._sink.get(sourceID);
        var baseSource = this._base.get(sourceID);
        !(sinkSource || baseSource) && invariant(false);
        var sink = this._getSinkRecord(sinkID);
        if (baseSource) RelayModernRecord.copyFields(baseSource, sink);
        if (sinkSource) RelayModernRecord.copyFields(sinkSource, sink);
    };
    _proto.copyFieldsFromRecord = function copyFieldsFromRecord(record, sinkID) {
        var sink = this._getSinkRecord(sinkID);
        RelayModernRecord.copyFields(record, sink);
    };
    _proto.create = function create(dataID, typeName) {
        !(this._base.getStatus(dataID) !== EXISTENT && this._sink.getStatus(dataID) !== EXISTENT) && invariant(false);
        var record = RelayModernRecord.create(dataID, typeName);
        this._sink.set(dataID, record);
    };
    _proto["delete"] = function _delete(dataID) {
        this._sink["delete"](dataID);
    };
    _proto.getStatus = function getStatus(dataID) {
        return this._sink.has(dataID) ? this._sink.getStatus(dataID) : this._base.getStatus(dataID);
    };
    _proto.getType = function getType(dataID) {
        for(var ii = 0; ii < this.__sources.length; ii++){
            var record = this.__sources[ii].get(dataID);
            if (record) return RelayModernRecord.getType(record);
            else if (record === null) return null;
        }
    };
    _proto.getValue = function getValue(dataID, storageKey) {
        for(var ii = 0; ii < this.__sources.length; ii++){
            var record = this.__sources[ii].get(dataID);
            if (record) {
                var value = RelayModernRecord.getValue(record, storageKey);
                if (value !== undefined) return value;
            } else if (record === null) return null;
        }
    };
    _proto.setValue = function setValue(dataID, storageKey, value) {
        var sinkRecord = this._getSinkRecord(dataID);
        RelayModernRecord.setValue(sinkRecord, storageKey, value);
    };
    _proto.getErrors = function getErrors(dataID, storageKey) {
        for(var ii = 0; ii < this.__sources.length; ii++){
            var record = this.__sources[ii].get(dataID);
            if (record) {
                var value = RelayModernRecord.getErrors(record, storageKey);
                if (value !== undefined) return value;
            } else if (record === null) return null;
        }
    };
    _proto.setErrors = function setErrors(dataID, storageKey, errors) {
        var sinkRecord = this._getSinkRecord(dataID);
        RelayModernRecord.setErrors(sinkRecord, storageKey, errors);
    };
    _proto.getLinkedRecordID = function getLinkedRecordID(dataID, storageKey) {
        for(var ii = 0; ii < this.__sources.length; ii++){
            var record = this.__sources[ii].get(dataID);
            if (record) {
                var linkedID = RelayModernRecord.getLinkedRecordID(record, storageKey);
                if (linkedID !== undefined) return linkedID;
            } else if (record === null) return null;
        }
    };
    _proto.setLinkedRecordID = function setLinkedRecordID(dataID, storageKey, linkedID) {
        var sinkRecord = this._getSinkRecord(dataID);
        RelayModernRecord.setLinkedRecordID(sinkRecord, storageKey, linkedID);
    };
    _proto.getLinkedRecordIDs = function getLinkedRecordIDs(dataID, storageKey) {
        for(var ii = 0; ii < this.__sources.length; ii++){
            var record = this.__sources[ii].get(dataID);
            if (record) {
                var linkedIDs = RelayModernRecord.getLinkedRecordIDs(record, storageKey);
                if (linkedIDs !== undefined) return linkedIDs;
            } else if (record === null) return null;
        }
    };
    _proto.setLinkedRecordIDs = function setLinkedRecordIDs(dataID, storageKey, linkedIDs) {
        var sinkRecord = this._getSinkRecord(dataID);
        RelayModernRecord.setLinkedRecordIDs(sinkRecord, storageKey, linkedIDs);
    };
    return RelayRecordSourceMutator;
}();
module.exports = RelayRecordSourceMutator;

},{"f7566715ac011ace":"daXOB","cadd642407d15db9":"7LnXj","15734011101e0993":"e2sci"}],"7OCKP":[function(require,module,exports,__globalThis) {
'use strict';
var RelayModernRecord = require("2d0374478be282f8");
var _require = require("6edb7b533917499f"), EXISTENT = _require.EXISTENT, NONEXISTENT = _require.NONEXISTENT;
var _require2 = require("61ac24ad43bdb688"), ROOT_ID = _require2.ROOT_ID, ROOT_TYPE = _require2.ROOT_TYPE;
var _require3 = require("f12e4092bdced584"), _readUpdatableFragment = _require3.readUpdatableFragment;
var _require4 = require("221b8709f9263d2"), _readUpdatableQuery = _require4.readUpdatableQuery;
var RelayRecordProxy = require("c9b916d38891ead6");
var invariant = require("d73775d13d747a03");
var RelayRecordSourceProxy = /*#__PURE__*/ function() {
    function RelayRecordSourceProxy(mutator, getDataID, handlerProvider, missingFieldHandlers, log) {
        this.__mutator = mutator;
        this._handlerProvider = handlerProvider || null;
        this._proxies = {};
        this._getDataID = getDataID;
        this._invalidatedStore = false;
        this._idsMarkedForInvalidation = new Set();
        this._missingFieldHandlers = missingFieldHandlers;
        this._log = log !== null && log !== void 0 ? log : function(LogEvent) {};
    }
    var _proto = RelayRecordSourceProxy.prototype;
    _proto.publishSource = function publishSource(source, fieldPayloads) {
        var _this = this;
        var dataIDs = source.getRecordIDs();
        dataIDs.forEach(function(dataID) {
            var status = source.getStatus(dataID);
            if (status === EXISTENT) {
                var sourceRecord = source.get(dataID);
                if (sourceRecord) {
                    if (_this.__mutator.getStatus(dataID) !== EXISTENT) _this.create(dataID, RelayModernRecord.getType(sourceRecord));
                    _this.__mutator.copyFieldsFromRecord(sourceRecord, dataID);
                }
            } else if (status === NONEXISTENT) _this["delete"](dataID);
        });
        if (fieldPayloads && fieldPayloads.length) fieldPayloads.forEach(function(fieldPayload) {
            var handler = _this._handlerProvider && _this._handlerProvider(fieldPayload.handle);
            !handler && invariant(false);
            handler.update(_this, fieldPayload);
        });
    };
    _proto.create = function create(dataID, typeName) {
        this.__mutator.create(dataID, typeName);
        delete this._proxies[dataID];
        var record = this.get(dataID);
        !record && invariant(false);
        return record;
    };
    _proto["delete"] = function _delete(dataID) {
        !(dataID !== ROOT_ID) && invariant(false);
        delete this._proxies[dataID];
        this.__mutator["delete"](dataID);
    };
    _proto.get = function get(dataID) {
        if (!this._proxies.hasOwnProperty(dataID)) {
            var status = this.__mutator.getStatus(dataID);
            if (status === EXISTENT) this._proxies[dataID] = new RelayRecordProxy(this, this.__mutator, dataID);
            else this._proxies[dataID] = status === NONEXISTENT ? null : undefined;
        }
        return this._proxies[dataID];
    };
    _proto.getRoot = function getRoot() {
        var root = this.get(ROOT_ID);
        if (!root) root = this.create(ROOT_ID, ROOT_TYPE);
        !(root && root.getType() === ROOT_TYPE) && invariant(false);
        return root;
    };
    _proto.invalidateStore = function invalidateStore() {
        this._invalidatedStore = true;
    };
    _proto.isStoreMarkedForInvalidation = function isStoreMarkedForInvalidation() {
        return this._invalidatedStore;
    };
    _proto.markIDForInvalidation = function markIDForInvalidation(dataID) {
        this._idsMarkedForInvalidation.add(dataID);
    };
    _proto.getIDsMarkedForInvalidation = function getIDsMarkedForInvalidation() {
        return this._idsMarkedForInvalidation;
    };
    _proto.readUpdatableQuery = function readUpdatableQuery(query, variables) {
        return _readUpdatableQuery(query, variables, this, this._missingFieldHandlers);
    };
    _proto.readUpdatableFragment = function readUpdatableFragment(fragment, fragmentReference) {
        return _readUpdatableFragment(fragment, fragmentReference, this, this._missingFieldHandlers);
    };
    return RelayRecordSourceProxy;
}();
module.exports = RelayRecordSourceProxy;

},{"2d0374478be282f8":"daXOB","6edb7b533917499f":"7LnXj","61ac24ad43bdb688":"3QcrW","f12e4092bdced584":"oP4is","221b8709f9263d2":"hphRe","c9b916d38891ead6":"1WULY","d73775d13d747a03":"e2sci"}],"oP4is":[function(require,module,exports,__globalThis) {
'use strict';
var _require = require("8d5efcdf4dd4a551"), getFragment = _require.getFragment;
var _require2 = require("9e0c28c3cd543a5f"), getVariablesFromFragment = _require2.getVariablesFromFragment;
var _require3 = require("93299dc71edc4d7f"), ID_KEY = _require3.ID_KEY;
var _require4 = require("339cfb1f00043c83"), createUpdatableProxy = _require4.createUpdatableProxy;
var invariant = require("9186d1d33ea9d2e9");
function readUpdatableFragment(fragment, fragmentReference, proxy, missingFieldHandlers) {
    var updatableFragment = getFragment(fragment);
    var fragmentVariables = getVariablesFromFragment(updatableFragment, fragmentReference);
    var id = fragmentReference[ID_KEY];
    var fragmentRoot = proxy.get(id);
    !(fragmentRoot != null) && invariant(false);
    return {
        updatableData: createUpdatableProxy(fragmentRoot, fragmentVariables, updatableFragment.selections, proxy, missingFieldHandlers)
    };
}
module.exports = {
    readUpdatableFragment: readUpdatableFragment
};

},{"8d5efcdf4dd4a551":"8UTII","9e0c28c3cd543a5f":"9k2Dg","93299dc71edc4d7f":"3QcrW","339cfb1f00043c83":"8HjK2","9186d1d33ea9d2e9":"e2sci"}],"8HjK2":[function(require,module,exports,__globalThis) {
'use strict';
var _interopRequireDefault = require("8084d420b45658dd")["default"];
var _createForOfIteratorHelper2 = _interopRequireDefault(require("5a16f171a61f13da"));
var _require = require("68b9fda909a9dca9"), getArgumentValues = _require.getArgumentValues;
var nonUpdatableKeys = [
    'id',
    '__id',
    '__typename',
    'js'
];
function createUpdatableProxy(updatableProxyRootRecord, variables, selections, recordSourceProxy, missingFieldHandlers) {
    var mutableUpdatableProxy = {};
    updateProxyFromSelections(mutableUpdatableProxy, updatableProxyRootRecord, variables, selections, recordSourceProxy, missingFieldHandlers);
    return mutableUpdatableProxy;
}
function updateProxyFromSelections(mutableUpdatableProxy, updatableProxyRootRecord, variables, selections, recordSourceProxy, missingFieldHandlers) {
    var _selection$alias3;
    var _iterator = (0, _createForOfIteratorHelper2["default"])(selections), _step;
    try {
        var _loop = function _loop() {
            var selection = _step.value;
            switch(selection.kind){
                case 'LinkedField':
                    if (selection.plural) Object.defineProperty(mutableUpdatableProxy, (_selection$alias = selection.alias) !== null && _selection$alias !== void 0 ? _selection$alias : selection.name, {
                        get: createGetterForPluralLinkedField(selection, variables, updatableProxyRootRecord, recordSourceProxy, missingFieldHandlers),
                        set: createSetterForPluralLinkedField(selection, variables, updatableProxyRootRecord, recordSourceProxy)
                    });
                    else Object.defineProperty(mutableUpdatableProxy, (_selection$alias2 = selection.alias) !== null && _selection$alias2 !== void 0 ? _selection$alias2 : selection.name, {
                        get: createGetterForSingularLinkedField(selection, variables, updatableProxyRootRecord, recordSourceProxy, missingFieldHandlers),
                        set: createSetterForSingularLinkedField(selection, variables, updatableProxyRootRecord, recordSourceProxy)
                    });
                    break;
                case 'ScalarField':
                    var scalarFieldName = (_selection$alias3 = selection.alias) !== null && _selection$alias3 !== void 0 ? _selection$alias3 : selection.name;
                    Object.defineProperty(mutableUpdatableProxy, scalarFieldName, {
                        get: function get() {
                            var _selection$args;
                            var newVariables = getArgumentValues((_selection$args = selection.args) !== null && _selection$args !== void 0 ? _selection$args : [], variables);
                            var value = updatableProxyRootRecord.getValue(selection.name, newVariables);
                            if (value == null) value = getScalarUsingMissingFieldHandlers(selection, newVariables, updatableProxyRootRecord, recordSourceProxy, missingFieldHandlers);
                            return value;
                        },
                        set: nonUpdatableKeys.includes(selection.name) ? undefined : function(newValue) {
                            var _selection$args2;
                            var newVariables = getArgumentValues((_selection$args2 = selection.args) !== null && _selection$args2 !== void 0 ? _selection$args2 : [], variables);
                            updatableProxyRootRecord.setValue__UNSAFE(newValue, selection.name, newVariables);
                        }
                    });
                    break;
                case 'InlineFragment':
                    if (updatableProxyRootRecord.getType() === selection.type) updateProxyFromSelections(mutableUpdatableProxy, updatableProxyRootRecord, variables, selection.selections, recordSourceProxy, missingFieldHandlers);
                    break;
                case 'ClientExtension':
                    updateProxyFromSelections(mutableUpdatableProxy, updatableProxyRootRecord, variables, selection.selections, recordSourceProxy, missingFieldHandlers);
                    break;
                case 'FragmentSpread':
                    break;
                case 'Condition':
                case 'ActorChange':
                case 'InlineDataFragmentSpread':
                case 'AliasedInlineFragmentSpread':
                case 'ClientEdgeToClientObject':
                case 'ClientEdgeToServerObject':
                case 'Defer':
                case 'ModuleImport':
                case 'RequiredField':
                case 'CatchField':
                case 'Stream':
                case 'RelayResolver':
                case 'RelayLiveResolver':
                    throw new Error('Encountered an unexpected ReaderSelection variant in RelayRecordSourceProxy. This indicates a bug in Relay.');
                default:
                    selection.kind;
                    throw new Error('Encountered an unexpected ReaderSelection variant in RelayRecordSourceProxy. This indicates a bug in Relay.');
            }
        };
        for(_iterator.s(); !(_step = _iterator.n()).done;){
            var _selection$alias;
            var _selection$alias2;
            _loop();
        }
    } catch (err) {
        _iterator.e(err);
    } finally{
        _iterator.f();
    }
}
function createSetterForPluralLinkedField(selection, variables, updatableProxyRootRecord, recordSourceProxy) {
    return function set(newValue) {
        var _selection$args3;
        var newVariables = getArgumentValues((_selection$args3 = selection.args) !== null && _selection$args3 !== void 0 ? _selection$args3 : [], variables);
        if (newValue == null) throw new Error('Do not assign null to plural linked fields; assign an empty array instead.');
        else {
            var recordProxies = newValue.map(function(item) {
                if (item == null) throw new Error('When assigning an array of items, none of the items should be null or undefined.');
                var __id = item.__id;
                if (__id == null) throw new Error('The __id field must be present on each item passed to the setter. This indicates a bug in Relay.');
                var newValueRecord = recordSourceProxy.get(__id);
                if (newValueRecord == null) throw new Error("Did not find item with data id ".concat(__id, " in the store."));
                return newValueRecord;
            });
            updatableProxyRootRecord.setLinkedRecords(recordProxies, selection.name, newVariables);
        }
    };
}
function createSetterForSingularLinkedField(selection, variables, updatableProxyRootRecord, recordSourceProxy) {
    return function set(newValue) {
        var _selection$args4;
        var newVariables = getArgumentValues((_selection$args4 = selection.args) !== null && _selection$args4 !== void 0 ? _selection$args4 : [], variables);
        if (newValue == null) updatableProxyRootRecord.setValue(newValue, selection.name, newVariables);
        else {
            var __id = newValue.__id;
            if (__id == null) throw new Error('The __id field must be present on the argument. This indicates a bug in Relay.');
            var newValueRecord = recordSourceProxy.get(__id);
            if (newValueRecord == null) throw new Error("Did not find item with data id ".concat(__id, " in the store."));
            updatableProxyRootRecord.setLinkedRecord(newValueRecord, selection.name, newVariables);
        }
    };
}
function createGetterForPluralLinkedField(selection, variables, updatableProxyRootRecord, recordSourceProxy, missingFieldHandlers) {
    return function() {
        var _selection$args5;
        var newVariables = getArgumentValues((_selection$args5 = selection.args) !== null && _selection$args5 !== void 0 ? _selection$args5 : [], variables);
        var linkedRecords = updatableProxyRootRecord.getLinkedRecords(selection.name, newVariables);
        if (linkedRecords === undefined) linkedRecords = getPluralLinkedRecordUsingMissingFieldHandlers(selection, newVariables, updatableProxyRootRecord, recordSourceProxy, missingFieldHandlers);
        if (linkedRecords != null) return linkedRecords.map(function(linkedRecord) {
            if (linkedRecord != null) {
                var updatableProxy = {};
                updateProxyFromSelections(updatableProxy, linkedRecord, variables, selection.selections, recordSourceProxy, missingFieldHandlers);
                return updatableProxy;
            } else return linkedRecord;
        });
        else return linkedRecords;
    };
}
function createGetterForSingularLinkedField(selection, variables, updatableProxyRootRecord, recordSourceProxy, missingFieldHandlers) {
    return function() {
        var _selection$args6;
        var newVariables = getArgumentValues((_selection$args6 = selection.args) !== null && _selection$args6 !== void 0 ? _selection$args6 : [], variables);
        var linkedRecord = updatableProxyRootRecord.getLinkedRecord(selection.name, newVariables);
        if (linkedRecord === undefined) linkedRecord = getLinkedRecordUsingMissingFieldHandlers(selection, newVariables, updatableProxyRootRecord, recordSourceProxy, missingFieldHandlers);
        if (linkedRecord != null) {
            var updatableProxy = {};
            updateProxyFromSelections(updatableProxy, linkedRecord, variables, selection.selections, recordSourceProxy, missingFieldHandlers);
            return updatableProxy;
        } else return linkedRecord;
    };
}
function getLinkedRecordUsingMissingFieldHandlers(selection, newVariables, updatableProxyRootRecord, recordSourceProxy, missingFieldHandlers) {
    var _iterator2 = (0, _createForOfIteratorHelper2["default"])(missingFieldHandlers), _step2;
    try {
        for(_iterator2.s(); !(_step2 = _iterator2.n()).done;){
            var handler = _step2.value;
            if (handler.kind === 'linked') {
                var newId = handler.handle(selection, updatableProxyRootRecord, newVariables, recordSourceProxy);
                if (newId != null) return recordSourceProxy.get(newId);
            }
        }
    } catch (err) {
        _iterator2.e(err);
    } finally{
        _iterator2.f();
    }
}
function getPluralLinkedRecordUsingMissingFieldHandlers(selection, newVariables, updatableProxyRootRecord, recordSourceProxy, missingFieldHandlers) {
    var _iterator3 = (0, _createForOfIteratorHelper2["default"])(missingFieldHandlers), _step3;
    try {
        for(_iterator3.s(); !(_step3 = _iterator3.n()).done;){
            var handler = _step3.value;
            if (handler.kind === 'pluralLinked') {
                var newIds = handler.handle(selection, updatableProxyRootRecord, newVariables, recordSourceProxy);
                if (newIds != null) return newIds.map(function(newId) {
                    if (newId != null) return recordSourceProxy.get(newId);
                });
            }
        }
    } catch (err) {
        _iterator3.e(err);
    } finally{
        _iterator3.f();
    }
}
function getScalarUsingMissingFieldHandlers(selection, newVariables, updatableProxyRootRecord, recordSourceProxy, missingFieldHandlers) {
    var _iterator4 = (0, _createForOfIteratorHelper2["default"])(missingFieldHandlers), _step4;
    try {
        for(_iterator4.s(); !(_step4 = _iterator4.n()).done;){
            var handler = _step4.value;
            if (handler.kind === 'scalar') {
                var value = handler.handle(selection, updatableProxyRootRecord, newVariables, recordSourceProxy);
                if (value !== undefined) return value;
            }
        }
    } catch (err) {
        _iterator4.e(err);
    } finally{
        _iterator4.f();
    }
}
module.exports = {
    createUpdatableProxy: createUpdatableProxy
};

},{"8084d420b45658dd":"590td","5a16f171a61f13da":"fMaLa","68b9fda909a9dca9":"3QcrW"}],"hphRe":[function(require,module,exports,__globalThis) {
'use strict';
var _require = require("2e587e243aaedac3"), getUpdatableQuery = _require.getUpdatableQuery;
var _require2 = require("88520994ffdface7"), createUpdatableProxy = _require2.createUpdatableProxy;
function readUpdatableQuery(query, variables, proxy, missingFieldHandlers) {
    var updatableQuery = getUpdatableQuery(query);
    return {
        updatableData: createUpdatableProxy(proxy.getRoot(), variables, updatableQuery.fragment.selections, proxy, missingFieldHandlers)
    };
}
module.exports = {
    readUpdatableQuery: readUpdatableQuery
};

},{"2e587e243aaedac3":"8UTII","88520994ffdface7":"8HjK2"}],"1WULY":[function(require,module,exports,__globalThis) {
'use strict';
var _require = require("c0b8d105562c9f38"), generateClientID = _require.generateClientID;
var _require2 = require("b98f3126a52a11a6"), getStableStorageKey = _require2.getStableStorageKey;
var invariant = require("428b6ecf6b366ba0");
var RelayRecordProxy = /*#__PURE__*/ function() {
    function RelayRecordProxy(source, mutator, dataID) {
        this._dataID = dataID;
        this._mutator = mutator;
        this._source = source;
    }
    var _proto = RelayRecordProxy.prototype;
    _proto.copyFieldsFrom = function copyFieldsFrom(source) {
        this._mutator.copyFields(source.getDataID(), this._dataID);
    };
    _proto.getDataID = function getDataID() {
        return this._dataID;
    };
    _proto.getType = function getType() {
        var type = this._mutator.getType(this._dataID);
        !(type != null) && invariant(false);
        return type;
    };
    _proto.getValue = function getValue(name, args) {
        var storageKey = getStableStorageKey(name, args);
        return this._mutator.getValue(this._dataID, storageKey);
    };
    _proto.setValue = function setValue(value, name, args, errors) {
        !isValidLeafValue(value) && invariant(false);
        return this.setValue__UNSAFE(value, name, args, errors);
    };
    _proto.getErrors = function getErrors(name, args) {
        var storageKey = getStableStorageKey(name, args);
        return this._mutator.getErrors(this._dataID, storageKey);
    };
    _proto.setValue__UNSAFE = function setValue__UNSAFE(value, name, args, errors) {
        var storageKey = getStableStorageKey(name, args);
        this._mutator.setValue(this._dataID, storageKey, value);
        if (errors != null) {
            if (errors.length === 0) this._mutator.setErrors(this._dataID, storageKey);
            else this._mutator.setErrors(this._dataID, storageKey, errors);
        }
        return this;
    };
    _proto.getLinkedRecord = function getLinkedRecord(name, args) {
        var storageKey = getStableStorageKey(name, args);
        var linkedID = this._mutator.getLinkedRecordID(this._dataID, storageKey);
        return linkedID != null ? this._source.get(linkedID) : linkedID;
    };
    _proto.setLinkedRecord = function setLinkedRecord(record, name, args) {
        !(record instanceof RelayRecordProxy) && invariant(false);
        var storageKey = getStableStorageKey(name, args);
        var linkedID = record.getDataID();
        this._mutator.setLinkedRecordID(this._dataID, storageKey, linkedID);
        return this;
    };
    _proto.getOrCreateLinkedRecord = function getOrCreateLinkedRecord(name, typeName, args) {
        var linkedRecord = this.getLinkedRecord(name, args);
        if (!linkedRecord) {
            var _this$_source$get;
            var storageKey = getStableStorageKey(name, args);
            var clientID = generateClientID(this.getDataID(), storageKey);
            linkedRecord = (_this$_source$get = this._source.get(clientID)) !== null && _this$_source$get !== void 0 ? _this$_source$get : this._source.create(clientID, typeName);
            this.setLinkedRecord(linkedRecord, name, args);
        }
        return linkedRecord;
    };
    _proto.getLinkedRecords = function getLinkedRecords(name, args) {
        var _this = this;
        var storageKey = getStableStorageKey(name, args);
        var linkedIDs = this._mutator.getLinkedRecordIDs(this._dataID, storageKey);
        if (linkedIDs == null) return linkedIDs;
        return linkedIDs.map(function(linkedID) {
            return linkedID != null ? _this._source.get(linkedID) : linkedID;
        });
    };
    _proto.setLinkedRecords = function setLinkedRecords(records, name, args) {
        !Array.isArray(records) && invariant(false);
        var storageKey = getStableStorageKey(name, args);
        var linkedIDs = records.map(function(record) {
            return record && record.getDataID();
        });
        this._mutator.setLinkedRecordIDs(this._dataID, storageKey, linkedIDs);
        return this;
    };
    _proto.invalidateRecord = function invalidateRecord() {
        this._source.markIDForInvalidation(this._dataID);
    };
    return RelayRecordProxy;
}();
function isValidLeafValue(value) {
    return value == null || typeof value !== 'object' || Array.isArray(value) && value.every(isValidLeafValue);
}
module.exports = RelayRecordProxy;

},{"c0b8d105562c9f38":"gL1rB","b98f3126a52a11a6":"3QcrW","428b6ecf6b366ba0":"e2sci"}],"hUbQm":[function(require,module,exports,__globalThis) {
'use strict';
var _require = require("4f822b4d6fc10cd6"), LINKED_FIELD = _require.LINKED_FIELD;
var _require2 = require("21ceeaf6909b07d8"), getHandleStorageKey = _require2.getHandleStorageKey;
var areEqual = require("582fd0b44b6c2f8a");
var invariant = require("3c1e1ab84715f66e");
function cloneRelayHandleSourceField(handleField, selections, variables) {
    var sourceField = selections.find(function(source) {
        return source.kind === LINKED_FIELD && source.name === handleField.name && source.alias === handleField.alias && areEqual(source.args, handleField.args);
    });
    !(sourceField && sourceField.kind === LINKED_FIELD) && invariant(false);
    var handleKey = getHandleStorageKey(handleField, variables);
    return {
        kind: 'LinkedField',
        alias: sourceField.alias,
        name: handleKey,
        storageKey: handleKey,
        args: null,
        concreteType: sourceField.concreteType,
        plural: sourceField.plural,
        selections: sourceField.selections
    };
}
module.exports = cloneRelayHandleSourceField;

},{"4f822b4d6fc10cd6":"jKskk","21ceeaf6909b07d8":"3QcrW","582fd0b44b6c2f8a":"eJLuG","3c1e1ab84715f66e":"e2sci"}],"6XW3k":[function(require,module,exports,__globalThis) {
'use strict';
var _require = require("40439c33de9184e6"), SCALAR_FIELD = _require.SCALAR_FIELD;
var _require2 = require("d8849a0e1268fc6c"), getHandleStorageKey = _require2.getHandleStorageKey;
var areEqual = require("e28251715f16e299");
var invariant = require("8493e165b7d693af");
function cloneRelayScalarHandleSourceField(handleField, selections, variables) {
    var sourceField = selections.find(function(source) {
        return source.kind === SCALAR_FIELD && source.name === handleField.name && source.alias === handleField.alias && areEqual(source.args, handleField.args);
    });
    !(sourceField && sourceField.kind === SCALAR_FIELD) && invariant(false);
    var handleKey = getHandleStorageKey(handleField, variables);
    return {
        kind: 'ScalarField',
        alias: sourceField.alias,
        name: handleKey,
        storageKey: handleKey,
        args: null
    };
}
module.exports = cloneRelayScalarHandleSourceField;

},{"40439c33de9184e6":"jKskk","d8849a0e1268fc6c":"3QcrW","e28251715f16e299":"eJLuG","8493e165b7d693af":"e2sci"}],"7eTWP":[function(require,module,exports,__globalThis) {
'use strict';
var _interopRequireDefault = require("b3f6c625a17b36b")["default"];
var _createForOfIteratorHelper2 = _interopRequireDefault(require("9890d3f887d56798"));
var recycleNodesInto = require("5c4f3d0f4c5aaa26");
var _require = require("14f247449538debb"), RELAY_LIVE_RESOLVER = _require.RELAY_LIVE_RESOLVER;
var RelayFeatureFlags = require("b1ec29cdf80c4c8c");
var shallowFreeze = require("9b407baeb373bb5a");
var _require2 = require("3df09f1616af8673"), generateClientID = _require2.generateClientID, generateClientObjectClientID = _require2.generateClientObjectClientID;
var RelayModernRecord = require("5f0a315669cdf97");
var _require3 = require("9ac5b792d1296140"), createNormalizationSelector = _require3.createNormalizationSelector;
var RelayRecordSource = require("fdadf7ebc17a5e3f");
var _require4 = require("3f586416087ed086"), normalize = _require4.normalize;
var _require5 = require("ef918c7e89fcd058"), RELAY_RESOLVER_ERROR_KEY = _require5.RELAY_RESOLVER_ERROR_KEY, RELAY_RESOLVER_INVALIDATION_KEY = _require5.RELAY_RESOLVER_INVALIDATION_KEY, RELAY_RESOLVER_OUTPUT_TYPE_RECORD_IDS = _require5.RELAY_RESOLVER_OUTPUT_TYPE_RECORD_IDS, RELAY_RESOLVER_SNAPSHOT_KEY = _require5.RELAY_RESOLVER_SNAPSHOT_KEY, RELAY_RESOLVER_VALUE_KEY = _require5.RELAY_RESOLVER_VALUE_KEY, getReadTimeResolverStorageKey = _require5.getReadTimeResolverStorageKey, getStorageKey = _require5.getStorageKey;
var getOutputTypeRecordIDs = require("fa8357f4e356f096");
var isLiveStateValue = require("315bb19ab7cb79ca");
var _require6 = require("5a8572ea62eaabfb"), isSuspenseSentinel = _require6.isSuspenseSentinel;
var invariant = require("daf259438e27216");
var warning = require("41b8aa7c7b7dd158");
var RELAY_RESOLVER_LIVE_STATE_SUBSCRIPTION_KEY = '__resolverLiveStateSubscription';
var RELAY_RESOLVER_LIVE_STATE_VALUE = '__resolverLiveStateValue';
var RELAY_RESOLVER_LIVE_STATE_DIRTY = '__resolverLiveStateDirty';
var RELAY_RESOLVER_RECORD_TYPENAME = '__RELAY_RESOLVER__';
var MODEL_PROPERTY_NAME = '__relay_model_instance';
function addDependencyEdge(edges, from, to) {
    var set = edges.get(from);
    if (!set) {
        set = new Set();
        edges.set(from, set);
    }
    set.add(to);
}
var LiveResolverCache = /*#__PURE__*/ function() {
    function LiveResolverCache(getRecordSource, store) {
        this._resolverIDToRecordIDs = new Map();
        this._recordIDToResolverIDs = new Map();
        this._getRecordSource = getRecordSource;
        this._store = store;
        this._handlingBatch = false;
        this._liveResolverBatchRecordSource = null;
    }
    var _proto = LiveResolverCache.prototype;
    _proto.readFromCacheOrEvaluate = function readFromCacheOrEvaluate(recordID, field, variables, evaluate, getDataForResolverFragment) {
        var recordSource = this._getRecordSource();
        var record = expectRecord(recordSource, recordID);
        var storageKey = getReadTimeResolverStorageKey(field, variables);
        var linkedID = RelayModernRecord.getLinkedRecordID(record, storageKey);
        var linkedRecord = linkedID == null ? null : recordSource.get(linkedID);
        var updatedDataIDs;
        if (linkedRecord == null || this._isInvalid(linkedRecord, getDataForResolverFragment)) {
            var _linkedID;
            if (linkedRecord != null) maybeUnsubscribeFromLiveState(linkedRecord);
            linkedID = (_linkedID = linkedID) !== null && _linkedID !== void 0 ? _linkedID : generateClientID(recordID, storageKey);
            linkedRecord = RelayModernRecord.create(linkedID, RELAY_RESOLVER_RECORD_TYPENAME);
            var evaluationResult = evaluate();
            RelayModernRecord.setValue(linkedRecord, RELAY_RESOLVER_SNAPSHOT_KEY, evaluationResult.snapshot);
            RelayModernRecord.setValue(linkedRecord, RELAY_RESOLVER_ERROR_KEY, evaluationResult.error);
            if (field.kind === RELAY_LIVE_RESOLVER) {
                if (evaluationResult.resolverResult != null) {
                    !(evaluationResult.error == null) && invariant(false);
                    var liveState = evaluationResult.resolverResult;
                    updatedDataIDs = this._setLiveStateValue(linkedRecord, linkedID, liveState, field, variables);
                } else var _evaluationResult$sna;
            } else updatedDataIDs = this._setResolverValue(linkedRecord, evaluationResult.resolverResult, field, variables);
            recordSource.set(linkedID, linkedRecord);
            var currentRecord = expectRecord(recordSource, recordID);
            var nextRecord = RelayModernRecord.clone(currentRecord);
            RelayModernRecord.setLinkedRecordID(nextRecord, storageKey, linkedID);
            recordSource.set(recordID, nextRecord);
            if (field.fragment != null) {
                var _evaluationResult$sna2;
                var fragmentStorageKey = getStorageKey(field.fragment, variables);
                var resolverID = generateClientID(recordID, fragmentStorageKey);
                addDependencyEdge(this._resolverIDToRecordIDs, resolverID, linkedID);
                addDependencyEdge(this._recordIDToResolverIDs, recordID, resolverID);
                var seenRecordIds = (_evaluationResult$sna2 = evaluationResult.snapshot) === null || _evaluationResult$sna2 === void 0 ? void 0 : _evaluationResult$sna2.seenRecords;
                if (seenRecordIds != null) {
                    var _iterator = (0, _createForOfIteratorHelper2["default"])(seenRecordIds), _step;
                    try {
                        for(_iterator.s(); !(_step = _iterator.n()).done;){
                            var seenRecordID = _step.value;
                            addDependencyEdge(this._recordIDToResolverIDs, seenRecordID, resolverID);
                        }
                    } catch (err) {
                        _iterator.e(err);
                    } finally{
                        _iterator.f();
                    }
                }
            }
        } else if (field.kind === RELAY_LIVE_RESOLVER && RelayModernRecord.getValue(linkedRecord, RELAY_RESOLVER_LIVE_STATE_DIRTY)) {
            var _linkedID2;
            linkedID = (_linkedID2 = linkedID) !== null && _linkedID2 !== void 0 ? _linkedID2 : generateClientID(recordID, storageKey);
            linkedRecord = RelayModernRecord.clone(linkedRecord);
            var _liveState = RelayModernRecord.getValue(linkedRecord, RELAY_RESOLVER_LIVE_STATE_VALUE);
            if (!isLiveStateValue(_liveState)) invariant(false);
            updatedDataIDs = this._setLiveResolverValue(linkedRecord, _liveState, field, variables);
            RelayModernRecord.setValue(linkedRecord, RELAY_RESOLVER_LIVE_STATE_DIRTY, false);
            recordSource.set(linkedID, linkedRecord);
        }
        var answer = this._getResolverValue(linkedRecord);
        var snapshot = RelayModernRecord.getValue(linkedRecord, RELAY_RESOLVER_SNAPSHOT_KEY);
        var error = RelayModernRecord.getValue(linkedRecord, RELAY_RESOLVER_ERROR_KEY);
        var suspenseID = null;
        if (isSuspenseSentinel(answer)) {
            var _linkedID3;
            suspenseID = (_linkedID3 = linkedID) !== null && _linkedID3 !== void 0 ? _linkedID3 : generateClientID(recordID, storageKey);
        }
        return [
            answer,
            linkedID,
            error,
            snapshot,
            suspenseID,
            updatedDataIDs
        ];
    };
    _proto.getLiveResolverPromise = function getLiveResolverPromise(liveStateID) {
        var recordSource = this._getRecordSource();
        var liveStateRecord = recordSource.get(liveStateID);
        !(liveStateRecord != null) && invariant(false);
        var liveState = RelayModernRecord.getValue(liveStateRecord, RELAY_RESOLVER_LIVE_STATE_VALUE);
        return new Promise(function(resolve) {
            var unsubscribe = liveState.subscribe(function() {
                unsubscribe();
                resolve();
            });
        });
    };
    _proto._setLiveStateValue = function _setLiveStateValue(linkedRecord, linkedID, liveState, field, variables) {
        var handler = this._makeLiveStateHandler(linkedID);
        var unsubscribe = liveState.subscribe(handler);
        RelayModernRecord.setValue(linkedRecord, RELAY_RESOLVER_LIVE_STATE_VALUE, liveState);
        var updatedDataIDs = this._setLiveResolverValue(linkedRecord, liveState, field, variables);
        RelayModernRecord.setValue(linkedRecord, RELAY_RESOLVER_LIVE_STATE_DIRTY, false);
        RelayModernRecord.setValue(linkedRecord, RELAY_RESOLVER_LIVE_STATE_SUBSCRIPTION_KEY, unsubscribe);
        return updatedDataIDs;
    };
    _proto._makeLiveStateHandler = function _makeLiveStateHandler(linkedID) {
        var _this = this;
        return function() {
            var currentSource = _this._getRecordSource();
            var currentRecord = currentSource.get(linkedID);
            if (!currentRecord) return;
            if (!RelayModernRecord.hasValue(currentRecord, RELAY_RESOLVER_LIVE_STATE_VALUE)) return;
            var nextRecord = RelayModernRecord.clone(currentRecord);
            RelayModernRecord.setValue(nextRecord, RELAY_RESOLVER_LIVE_STATE_DIRTY, true);
            _this._setLiveResolverUpdate(linkedID, nextRecord);
        };
    };
    _proto._setLiveResolverUpdate = function _setLiveResolverUpdate(linkedId, record) {
        if (this._handlingBatch) {
            if (this._liveResolverBatchRecordSource == null) this._liveResolverBatchRecordSource = RelayRecordSource.create();
            this._liveResolverBatchRecordSource.set(linkedId, record);
        } else {
            var nextSource = RelayRecordSource.create();
            nextSource.set(linkedId, record);
            this._store.publish(nextSource);
            this._store.notify();
        }
    };
    _proto.batchLiveStateUpdates = function batchLiveStateUpdates(callback) {
        !!this._handlingBatch && invariant(false);
        this._handlingBatch = true;
        try {
            callback();
        } finally{
            if (this._liveResolverBatchRecordSource != null) {
                this._store.publish(this._liveResolverBatchRecordSource);
                this._store.notify();
            }
            this._liveResolverBatchRecordSource = null;
            this._handlingBatch = false;
        }
    };
    _proto._setLiveResolverValue = function _setLiveResolverValue(resolverRecord, liveValue, field, variables) {
        var value = null;
        var resolverError = null;
        try {
            value = liveValue.read();
        } catch (e) {
            resolverError = e;
        }
        RelayModernRecord.setValue(resolverRecord, RELAY_RESOLVER_ERROR_KEY, resolverError);
        return this._setResolverValue(resolverRecord, value, field, variables);
    };
    _proto._setResolverValue = function _setResolverValue(resolverRecord, value, field, variables) {
        var normalizationInfo = field.normalizationInfo;
        var updatedDataIDs = null;
        if (value != null && normalizationInfo != null && !isSuspenseSentinel(value)) {
            var resolverValue;
            var prevOutputTypeRecordIDs = getOutputTypeRecordIDs(resolverRecord);
            var nextOutputTypeRecordIDs = new Set();
            var currentSource = this._getRecordSource();
            if (normalizationInfo.plural) {
                !Array.isArray(value) && invariant(false);
                resolverValue = [];
                var nextSource = RelayRecordSource.create();
                for(var ii = 0; ii < value.length; ii++){
                    var currentValue = value[ii];
                    if (currentValue == null) continue;
                    !(typeof currentValue === 'object') && invariant(false);
                    var typename = getConcreteTypename(normalizationInfo, currentValue);
                    var outputTypeDataID = generateClientObjectClientID(typename, RelayModernRecord.getDataID(resolverRecord), ii);
                    var source = this._normalizeOutputTypeValue(outputTypeDataID, currentValue, variables, normalizationInfo, [
                        field.path,
                        String(ii)
                    ], typename);
                    var _iterator2 = (0, _createForOfIteratorHelper2["default"])(source.getRecordIDs()), _step2;
                    try {
                        for(_iterator2.s(); !(_step2 = _iterator2.n()).done;){
                            var recordID = _step2.value;
                            nextSource.set(recordID, expectRecord(source, recordID));
                            nextOutputTypeRecordIDs.add(recordID);
                        }
                    } catch (err) {
                        _iterator2.e(err);
                    } finally{
                        _iterator2.f();
                    }
                    resolverValue.push(outputTypeDataID);
                }
                updatedDataIDs = updateCurrentSource(currentSource, nextSource, prevOutputTypeRecordIDs);
            } else {
                !(typeof value === 'object') && invariant(false);
                var _typename = getConcreteTypename(normalizationInfo, value);
                var _outputTypeDataID = generateClientObjectClientID(_typename, RelayModernRecord.getDataID(resolverRecord));
                var _nextSource = this._normalizeOutputTypeValue(_outputTypeDataID, value, variables, normalizationInfo, [
                    field.path
                ], _typename);
                var _iterator3 = (0, _createForOfIteratorHelper2["default"])(_nextSource.getRecordIDs()), _step3;
                try {
                    for(_iterator3.s(); !(_step3 = _iterator3.n()).done;){
                        var _recordID = _step3.value;
                        nextOutputTypeRecordIDs.add(_recordID);
                    }
                } catch (err) {
                    _iterator3.e(err);
                } finally{
                    _iterator3.f();
                }
                resolverValue = _outputTypeDataID;
                updatedDataIDs = updateCurrentSource(currentSource, _nextSource, prevOutputTypeRecordIDs);
            }
            RelayModernRecord.setValue(resolverRecord, RELAY_RESOLVER_OUTPUT_TYPE_RECORD_IDS, nextOutputTypeRecordIDs);
            shallowFreeze(resolverValue);
            RelayModernRecord.setValue(resolverRecord, RELAY_RESOLVER_VALUE_KEY, resolverValue);
        } else {
            shallowFreeze(value);
            RelayModernRecord.setValue(resolverRecord, RELAY_RESOLVER_VALUE_KEY, value);
        }
        return updatedDataIDs;
    };
    _proto.notifyUpdatedSubscribers = function notifyUpdatedSubscribers(updatedDataIDs) {
        this._store.__notifyUpdatedSubscribers(updatedDataIDs);
    };
    _proto._getResolverValue = function _getResolverValue(resolverRecord) {
        return RelayModernRecord.getValue(resolverRecord, RELAY_RESOLVER_VALUE_KEY);
    };
    _proto.invalidateDataIDs = function invalidateDataIDs(updatedDataIDs) {
        var recordSource = this._getRecordSource();
        var visited = new Set();
        var recordsToVisit = Array.from(updatedDataIDs);
        while(recordsToVisit.length){
            var recordID = recordsToVisit.pop();
            visited.add(recordID);
            updatedDataIDs.add(recordID);
            var fragmentSet = this._recordIDToResolverIDs.get(recordID);
            if (fragmentSet == null) continue;
            var _iterator4 = (0, _createForOfIteratorHelper2["default"])(fragmentSet), _step4;
            try {
                for(_iterator4.s(); !(_step4 = _iterator4.n()).done;){
                    var fragment = _step4.value;
                    if (!visited.has(fragment)) {
                        visited.add(fragment);
                        var recordSet = this._resolverIDToRecordIDs.get(fragment);
                        if (recordSet == null) continue;
                        var _iterator5 = (0, _createForOfIteratorHelper2["default"])(recordSet), _step5;
                        try {
                            for(_iterator5.s(); !(_step5 = _iterator5.n()).done;){
                                var anotherRecordID = _step5.value;
                                markInvalidatedResolverRecord(anotherRecordID, recordSource);
                                if (!visited.has(anotherRecordID)) {
                                    visited.add(anotherRecordID);
                                    recordsToVisit.push(anotherRecordID);
                                }
                            }
                        } catch (err) {
                            _iterator5.e(err);
                        } finally{
                            _iterator5.f();
                        }
                    }
                }
            } catch (err) {
                _iterator4.e(err);
            } finally{
                _iterator4.f();
            }
        }
    };
    _proto._isInvalid = function _isInvalid(record, getDataForResolverFragment) {
        if (!RelayModernRecord.getValue(record, RELAY_RESOLVER_INVALIDATION_KEY)) return false;
        var snapshot = RelayModernRecord.getValue(record, RELAY_RESOLVER_SNAPSHOT_KEY);
        var originalInputs = snapshot === null || snapshot === void 0 ? void 0 : snapshot.data;
        var readerSelector = snapshot === null || snapshot === void 0 ? void 0 : snapshot.selector;
        if (originalInputs == null || readerSelector == null) return true;
        var _getDataForResolverFr = getDataForResolverFragment(readerSelector), latestValues = _getDataForResolverFr.data;
        var recycled = recycleNodesInto(originalInputs, latestValues);
        if (recycled !== originalInputs) return true;
        if (RelayFeatureFlags.MARK_RESOLVER_VALUES_AS_CLEAN_AFTER_FRAGMENT_REREAD) {
            var nextRecord = RelayModernRecord.clone(record);
            RelayModernRecord.setValue(nextRecord, RELAY_RESOLVER_INVALIDATION_KEY, false);
            var recordSource = this._getRecordSource();
            recordSource.set(RelayModernRecord.getDataID(record), nextRecord);
        }
        return false;
    };
    _proto._normalizeOutputTypeValue = function _normalizeOutputTypeValue(outputTypeDataID, value, variables, normalizationInfo, fieldPath, typename) {
        var source = RelayRecordSource.create();
        switch(normalizationInfo.kind){
            case 'OutputType':
                var record = RelayModernRecord.create(outputTypeDataID, typename);
                source.set(outputTypeDataID, record);
                var selector = createNormalizationSelector(normalizationInfo.normalizationNode, outputTypeDataID, variables);
                var useExecTimeResolvers = false;
                var normalizationOptions = this._store.__getNormalizationOptions(fieldPath);
                return normalize(source, selector, value, normalizationOptions, undefined, useExecTimeResolvers).source;
            case 'WeakModel':
                var _record = RelayModernRecord.create(outputTypeDataID, typename);
                RelayModernRecord.setValue(_record, MODEL_PROPERTY_NAME, value);
                source.set(outputTypeDataID, _record);
                return source;
            default:
                normalizationInfo.kind;
                invariant(false);
        }
    };
    _proto.ensureClientRecord = function ensureClientRecord(id, typeName) {
        var key = generateClientObjectClientID(typeName, id);
        var recordSource = this._getRecordSource();
        if (!recordSource.has(key)) {
            var newRecord = RelayModernRecord.create(key, typeName);
            RelayModernRecord.setValue(newRecord, 'id', id);
            recordSource.set(key, newRecord);
        }
        return key;
    };
    _proto.unsubscribeFromLiveResolverRecords = function unsubscribeFromLiveResolverRecords(invalidatedDataIDs) {
        return unsubscribeFromLiveResolverRecordsImpl(this._getRecordSource(), invalidatedDataIDs);
    };
    _proto.invalidateResolverRecords = function invalidateResolverRecords(invalidatedDataIDs) {
        if (invalidatedDataIDs.size === 0) return;
        var _iterator6 = (0, _createForOfIteratorHelper2["default"])(invalidatedDataIDs), _step6;
        try {
            for(_iterator6.s(); !(_step6 = _iterator6.n()).done;){
                var dataID = _step6.value;
                var record = this._getRecordSource().get(dataID);
                if (record != null && isResolverRecord(record)) this._getRecordSource()["delete"](dataID);
            }
        } catch (err) {
            _iterator6.e(err);
        } finally{
            _iterator6.f();
        }
    };
    return LiveResolverCache;
}();
function updateCurrentSource(currentSource, nextSource, prevOutputTypeRecordIDs) {
    var updatedDataIDs = new Set();
    if (prevOutputTypeRecordIDs != null) {
        var _iterator7 = (0, _createForOfIteratorHelper2["default"])(prevOutputTypeRecordIDs), _step7;
        try {
            for(_iterator7.s(); !(_step7 = _iterator7.n()).done;){
                var recordID = _step7.value;
                if (!nextSource.has(recordID)) {
                    updatedDataIDs.add(recordID);
                    currentSource.remove(recordID);
                }
            }
        } catch (err) {
            _iterator7.e(err);
        } finally{
            _iterator7.f();
        }
    }
    var _iterator8 = (0, _createForOfIteratorHelper2["default"])(nextSource.getRecordIDs()), _step8;
    try {
        for(_iterator8.s(); !(_step8 = _iterator8.n()).done;){
            var _recordID2 = _step8.value;
            var nextRecord = expectRecord(nextSource, _recordID2);
            if (currentSource.has(_recordID2)) {
                var currentRecord = expectRecord(currentSource, _recordID2);
                var updatedRecord = RelayModernRecord.update(currentRecord, nextRecord);
                if (updatedRecord !== currentRecord) {
                    updatedDataIDs.add(_recordID2);
                    currentSource.set(_recordID2, updatedRecord);
                    markInvalidatedLinkedResolverRecords(currentRecord, currentSource);
                }
            } else currentSource.set(_recordID2, nextRecord);
        }
    } catch (err) {
        _iterator8.e(err);
    } finally{
        _iterator8.f();
    }
    return updatedDataIDs;
}
function getAllLinkedRecordIds(record) {
    var linkedRecordIDs = new Set();
    RelayModernRecord.getFields(record).forEach(function(field) {
        if (RelayModernRecord.hasLinkedRecordID(record, field)) {
            var linkedRecordID = RelayModernRecord.getLinkedRecordID(record, field);
            if (linkedRecordID != null) linkedRecordIDs.add(linkedRecordID);
        } else if (RelayModernRecord.hasLinkedRecordIDs(record, field)) {
            var _RelayModernRecord$ge;
            (_RelayModernRecord$ge = RelayModernRecord.getLinkedRecordIDs(record, field)) === null || _RelayModernRecord$ge === void 0 || _RelayModernRecord$ge.forEach(function(linkedRecordID) {
                if (linkedRecordID != null) linkedRecordIDs.add(linkedRecordID);
            });
        }
    });
    return linkedRecordIDs;
}
function markInvalidatedResolverRecord(dataID, recordSource) {
    var record = recordSource.get(dataID);
    if (!record) return;
    var nextRecord = RelayModernRecord.clone(record);
    RelayModernRecord.setValue(nextRecord, RELAY_RESOLVER_INVALIDATION_KEY, true);
    recordSource.set(dataID, nextRecord);
}
function markInvalidatedLinkedResolverRecords(record, recordSource) {
    var currentLinkedDataIDs = getAllLinkedRecordIds(record);
    var _iterator9 = (0, _createForOfIteratorHelper2["default"])(currentLinkedDataIDs), _step9;
    try {
        for(_iterator9.s(); !(_step9 = _iterator9.n()).done;){
            var recordID = _step9.value;
            var _record2 = recordSource.get(recordID);
            if (_record2 != null && isResolverRecord(_record2)) markInvalidatedResolverRecord(recordID, recordSource);
        }
    } catch (err) {
        _iterator9.e(err);
    } finally{
        _iterator9.f();
    }
}
function unsubscribeFromLiveResolverRecordsImpl(recordSource, invalidatedDataIDs) {
    if (invalidatedDataIDs.size === 0) return;
    var _iterator10 = (0, _createForOfIteratorHelper2["default"])(invalidatedDataIDs), _step10;
    try {
        for(_iterator10.s(); !(_step10 = _iterator10.n()).done;){
            var dataID = _step10.value;
            var record = recordSource.get(dataID);
            if (record != null && isResolverRecord(record)) maybeUnsubscribeFromLiveState(record);
        }
    } catch (err) {
        _iterator10.e(err);
    } finally{
        _iterator10.f();
    }
}
function isResolverRecord(record) {
    return RelayModernRecord.getType(record) === RELAY_RESOLVER_RECORD_TYPENAME;
}
function maybeUnsubscribeFromLiveState(linkedRecord) {
    var previousUnsubscribe = RelayModernRecord.getValue(linkedRecord, RELAY_RESOLVER_LIVE_STATE_SUBSCRIPTION_KEY);
    if (previousUnsubscribe != null) previousUnsubscribe();
}
function expectRecord(source, recordID) {
    var record = source.get(recordID);
    !(record != null) && invariant(false);
    return record;
}
function getUpdatedDataIDs(updatedRecords) {
    return updatedRecords;
}
function getConcreteTypename(normalizationInfo, currentValue) {
    var _normalizationInfo$co;
    var typename = (_normalizationInfo$co = normalizationInfo.concreteType) !== null && _normalizationInfo$co !== void 0 ? _normalizationInfo$co : currentValue.__typename;
    !(typename != null) && invariant(false);
    return typename;
}
module.exports = {
    LiveResolverCache: LiveResolverCache,
    getUpdatedDataIDs: getUpdatedDataIDs,
    RELAY_RESOLVER_LIVE_STATE_SUBSCRIPTION_KEY: RELAY_RESOLVER_LIVE_STATE_SUBSCRIPTION_KEY
};

},{"b3f6c625a17b36b":"590td","9890d3f887d56798":"fMaLa","5c4f3d0f4c5aaa26":"ij1IQ","14f247449538debb":"jKskk","b1ec29cdf80c4c8c":"a0FL5","9b407baeb373bb5a":"dB2kC","3df09f1616af8673":"gL1rB","5f0a315669cdf97":"daXOB","9ac5b792d1296140":"9k2Dg","fdadf7ebc17a5e3f":"6w3KR","3f586416087ed086":"1Dhjb","ef918c7e89fcd058":"3QcrW","fa8357f4e356f096":"eGTqf","315bb19ab7cb79ca":"2d1Mx","5a8572ea62eaabfb":"9sE63","daf259438e27216":"e2sci","41b8aa7c7b7dd158":"j64TH"}],"dB2kC":[function(require,module,exports,__globalThis) {
'use strict';
module.exports = function shallowFreeze(value) {
    if (typeof value === 'object' && value != null && (Array.isArray(value) || value.constructor === Object)) Object.freeze(value);
};

},{}],"eGTqf":[function(require,module,exports,__globalThis) {
'use strict';
var RelayModernRecord = require("18d5ea6fe78de732");
var _require = require("b8234a8f3056cd6"), RELAY_RESOLVER_OUTPUT_TYPE_RECORD_IDS = _require.RELAY_RESOLVER_OUTPUT_TYPE_RECORD_IDS;
var invariant = require("f75d38df8188e994");
function getOutputTypeRecordIDs(record) {
    var maybeOutputTypeRecordIDs = RelayModernRecord.getValue(record, RELAY_RESOLVER_OUTPUT_TYPE_RECORD_IDS);
    if (maybeOutputTypeRecordIDs == null) return null;
    !(maybeOutputTypeRecordIDs instanceof Set) && invariant(false);
    return maybeOutputTypeRecordIDs;
}
module.exports = getOutputTypeRecordIDs;

},{"18d5ea6fe78de732":"daXOB","b8234a8f3056cd6":"3QcrW","f75d38df8188e994":"e2sci"}],"2d1Mx":[function(require,module,exports,__globalThis) {
'use strict';
function isLiveStateValue(v) {
    return v != null && typeof v === 'object' && typeof v.read === 'function' && typeof v.subscribe === 'function';
}
module.exports = isLiveStateValue;

},{}],"4BdDg":[function(require,module,exports,__globalThis) {
'use strict';
var _interopRequireDefault = require("f4f697e764622070")["default"];
var _objectSpread2 = _interopRequireDefault(require("7204df6f35af857f"));
var RelayModernRecord = require("ac6d3680a5c39793");
var RelayRecordSource = require("ac6fe97efdd240d7");
var invariant = require("d162a134142e3c6c");
var UNPUBLISH_RECORD_SENTINEL = RelayModernRecord.fromObject(Object.freeze({
    __UNPUBLISH_RECORD_SENTINEL: true
}));
var RelayOptimisticRecordSource = /*#__PURE__*/ function() {
    function RelayOptimisticRecordSource(base) {
        this._base = base;
        this._sink = RelayRecordSource.create();
    }
    var _proto = RelayOptimisticRecordSource.prototype;
    _proto.has = function has(dataID) {
        if (this._sink.has(dataID)) {
            var sinkRecord = this._sink.get(dataID);
            return sinkRecord !== UNPUBLISH_RECORD_SENTINEL;
        } else return this._base.has(dataID);
    };
    _proto.get = function get(dataID) {
        if (this._sink.has(dataID)) {
            var sinkRecord = this._sink.get(dataID);
            if (sinkRecord === UNPUBLISH_RECORD_SENTINEL) return undefined;
            else return sinkRecord;
        } else return this._base.get(dataID);
    };
    _proto.getStatus = function getStatus(dataID) {
        var record = this.get(dataID);
        if (record === undefined) return 'UNKNOWN';
        else if (record === null) return 'NONEXISTENT';
        else return 'EXISTENT';
    };
    _proto.clear = function clear() {
        this._base = RelayRecordSource.create();
        this._sink.clear();
    };
    _proto["delete"] = function _delete(dataID) {
        this._sink["delete"](dataID);
    };
    _proto.remove = function remove(dataID) {
        this._sink.set(dataID, UNPUBLISH_RECORD_SENTINEL);
    };
    _proto.set = function set(dataID, record) {
        this._sink.set(dataID, record);
    };
    _proto.getRecordIDs = function getRecordIDs() {
        return Object.keys(this.toJSON());
    };
    _proto.size = function size() {
        return Object.keys(this.toJSON()).length;
    };
    _proto.toJSON = function toJSON() {
        var _this = this;
        var merged = (0, _objectSpread2["default"])({}, this._base.toJSON());
        this._sink.getRecordIDs().forEach(function(dataID) {
            var record = _this.get(dataID);
            if (record === undefined) delete merged[dataID];
            else merged[dataID] = RelayModernRecord.toJSON(record);
        });
        return merged;
    };
    _proto.getOptimisticRecordIDs = function getOptimisticRecordIDs() {
        return new Set(this._sink.getRecordIDs());
    };
    return RelayOptimisticRecordSource;
}();
function create(base) {
    return new RelayOptimisticRecordSource(base);
}
function getOptimisticRecordIDs(source) {
    !(source instanceof RelayOptimisticRecordSource) && invariant(false);
    return source.getOptimisticRecordIDs();
}
module.exports = {
    create: create,
    getOptimisticRecordIDs: getOptimisticRecordIDs
};

},{"f4f697e764622070":"590td","7204df6f35af857f":"2Bj1n","ac6d3680a5c39793":"daXOB","ac6fe97efdd240d7":"6w3KR","d162a134142e3c6c":"e2sci"}],"hTh0M":[function(require,module,exports,__globalThis) {
'use strict';
var _interopRequireDefault = require("a3c1fb2c07af9d8f")["default"];
var _objectSpread2 = _interopRequireDefault(require("99f0804ffd78142a"));
var _defineProperty2 = _interopRequireDefault(require("ecd5938fdccf58d0"));
var _objectWithoutPropertiesLoose2 = _interopRequireDefault(require("99758f59b24e5d08"));
var _toConsumableArray2 = _interopRequireDefault(require("e1d5f18766f34ffd"));
var _excluded = [
    "message"
];
var RelayFeatureFlags = require("e4590f7d0743b994");
var _require = require("a4adcb3e9e93be18"), isSuspenseSentinel = _require.isSuspenseSentinel;
var RelayConcreteVariables = require("6aa3e28b2397f0f2");
var RelayModernRecord = require("1474639a77db088c");
var _require2 = require("ceb4056395d53b78"), CLIENT_EDGE_TRAVERSAL_PATH = _require2.CLIENT_EDGE_TRAVERSAL_PATH, FRAGMENT_OWNER_KEY = _require2.FRAGMENT_OWNER_KEY, FRAGMENT_PROP_NAME_KEY = _require2.FRAGMENT_PROP_NAME_KEY, FRAGMENTS_KEY = _require2.FRAGMENTS_KEY, ID_KEY = _require2.ID_KEY, MODULE_COMPONENT_KEY = _require2.MODULE_COMPONENT_KEY, ROOT_ID = _require2.ROOT_ID, getArgumentValues = _require2.getArgumentValues, getModuleComponentKey = _require2.getModuleComponentKey, getStorageKey = _require2.getStorageKey;
var _require3 = require("2ec0ed85284cf22"), NoopResolverCache = _require3.NoopResolverCache;
var _require4 = require("91eb3a4f12b0db94"), RESOLVER_FRAGMENT_ERRORED_SENTINEL = _require4.RESOLVER_FRAGMENT_ERRORED_SENTINEL, withResolverContext = _require4.withResolverContext;
var _require5 = require("c94b24a7feab2434"), generateTypeID = _require5.generateTypeID;
var invariant = require("8bf034bdcb6b97a6");
function read(recordSource, selector, resolverCache, resolverContext) {
    var reader = new RelayReader(recordSource, selector, resolverCache !== null && resolverCache !== void 0 ? resolverCache : new NoopResolverCache(), resolverContext);
    return reader.read();
}
var RelayReader = /*#__PURE__*/ function() {
    function RelayReader(recordSource, selector, resolverCache, resolverContext) {
        var _selector$clientEdgeT, _ref, _this$_owner$node$ope, _this$_owner$node$ope2;
        this._clientEdgeTraversalPath = (_selector$clientEdgeT = selector.clientEdgeTraversalPath) !== null && _selector$clientEdgeT !== void 0 && _selector$clientEdgeT.length ? (0, _toConsumableArray2["default"])(selector.clientEdgeTraversalPath) : [];
        this._missingClientEdges = [];
        this._missingLiveResolverFields = [];
        this._isMissingData = false;
        this._isWithinUnmatchedTypeRefinement = false;
        this._fieldErrors = null;
        this._owner = selector.owner;
        this._useExecTimeResolvers = (_ref = (_this$_owner$node$ope = this._owner.node.operation.use_exec_time_resolvers) !== null && _this$_owner$node$ope !== void 0 ? _this$_owner$node$ope : ((_this$_owner$node$ope2 = this._owner.node.operation.exec_time_resolvers_enabled_provider) === null || _this$_owner$node$ope2 === void 0 ? void 0 : _this$_owner$node$ope2.get()) === true) !== null && _ref !== void 0 ? _ref : false;
        this._recordSource = recordSource;
        this._seenRecords = new Set();
        this._selector = selector;
        this._variables = selector.variables;
        this._resolverCache = resolverCache;
        this._fragmentName = selector.node.name;
        this._updatedDataIDs = new Set();
        this._resolverContext = resolverContext;
    }
    var _proto = RelayReader.prototype;
    _proto.read = function read() {
        var _this$_selector$node$;
        var _this$_selector = this._selector, node = _this$_selector.node, dataID = _this$_selector.dataID, isWithinUnmatchedTypeRefinement = _this$_selector.isWithinUnmatchedTypeRefinement;
        var abstractKey = node.abstractKey;
        var record = this._recordSource.get(dataID);
        var isDataExpectedToBePresent = !isWithinUnmatchedTypeRefinement;
        if (isDataExpectedToBePresent && abstractKey == null && record != null) {
            if (!this._recordMatchesTypeCondition(record, node.type)) isDataExpectedToBePresent = false;
        }
        if (isDataExpectedToBePresent && abstractKey != null && record != null) {
            var implementsInterface = this._implementsInterface(record, abstractKey);
            if (implementsInterface === false) isDataExpectedToBePresent = false;
        }
        this._isWithinUnmatchedTypeRefinement = !isDataExpectedToBePresent;
        var data = this._traverse(node, dataID, null);
        var catchTo = (_this$_selector$node$ = this._selector.node.metadata) === null || _this$_selector$node$ === void 0 ? void 0 : _this$_selector$node$.catchTo;
        if (catchTo != null) data = this._catchErrors(data, catchTo, null);
        if (this._updatedDataIDs.size > 0) {
            this._resolverCache.notifyUpdatedSubscribers(this._updatedDataIDs);
            this._updatedDataIDs.clear();
        }
        return {
            data: data,
            isMissingData: this._isMissingData && isDataExpectedToBePresent,
            missingClientEdges: this._missingClientEdges.length ? this._missingClientEdges : null,
            missingLiveResolverFields: this._missingLiveResolverFields,
            seenRecords: this._seenRecords,
            selector: this._selector,
            fieldErrors: this._fieldErrors
        };
    };
    _proto._maybeAddFieldErrors = function _maybeAddFieldErrors(record, storageKey) {
        var errors = RelayModernRecord.getErrors(record, storageKey);
        if (errors == null) return;
        var owner = this._fragmentName;
        if (this._fieldErrors == null) this._fieldErrors = [];
        for(var i = 0; i < errors.length; i++){
            var _error$path, _this$_selector$node$2, _this$_selector$node$3;
            var error = errors[i];
            this._fieldErrors.push({
                kind: 'relay_field_payload.error',
                owner: owner,
                fieldPath: ((_error$path = error.path) !== null && _error$path !== void 0 ? _error$path : []).join('.'),
                error: error,
                shouldThrow: (_this$_selector$node$2 = (_this$_selector$node$3 = this._selector.node.metadata) === null || _this$_selector$node$3 === void 0 ? void 0 : _this$_selector$node$3.throwOnFieldError) !== null && _this$_selector$node$2 !== void 0 ? _this$_selector$node$2 : false,
                handled: false,
                uiContext: undefined
            });
        }
    };
    _proto._markDataAsMissing = function _markDataAsMissing(fieldName) {
        var _this$_selector$node$4, _this$_selector$node$5;
        if (this._isWithinUnmatchedTypeRefinement) return;
        if (this._fieldErrors == null) this._fieldErrors = [];
        var owner = this._fragmentName;
        this._fieldErrors.push(((_this$_selector$node$4 = (_this$_selector$node$5 = this._selector.node.metadata) === null || _this$_selector$node$5 === void 0 ? void 0 : _this$_selector$node$5.throwOnFieldError) !== null && _this$_selector$node$4 !== void 0 ? _this$_selector$node$4 : false) ? {
            kind: 'missing_expected_data.throw',
            owner: owner,
            fieldPath: fieldName,
            handled: false,
            uiContext: undefined
        } : {
            kind: 'missing_expected_data.log',
            owner: owner,
            fieldPath: fieldName,
            uiContext: undefined
        });
        this._isMissingData = true;
        if (this._clientEdgeTraversalPath.length) {
            var top = this._clientEdgeTraversalPath[this._clientEdgeTraversalPath.length - 1];
            if (top !== null) this._missingClientEdges.push({
                request: top.readerClientEdge.operation,
                clientEdgeDestinationID: top.clientEdgeDestinationID
            });
        }
    };
    _proto._traverse = function _traverse(node, dataID, prevData) {
        var record = this._recordSource.get(dataID);
        this._seenRecords.add(dataID);
        if (record == null) {
            if (record === undefined) this._markDataAsMissing('<record>');
            return record;
        }
        var data = prevData || {};
        var hadRequiredData = this._traverseSelections(node.selections, record, data);
        return hadRequiredData ? data : null;
    };
    _proto._getVariableValue = function _getVariableValue(name) {
        !this._variables.hasOwnProperty(name) && invariant(false);
        return this._variables[name];
    };
    _proto._maybeReportUnexpectedNull = function _maybeReportUnexpectedNull(selection) {
        if (selection.action === 'NONE') return;
        var owner = this._fragmentName;
        if (this._fieldErrors == null) this._fieldErrors = [];
        var fieldName;
        if (selection.field.linkedField != null) {
            var _selection$field$link;
            fieldName = (_selection$field$link = selection.field.linkedField.alias) !== null && _selection$field$link !== void 0 ? _selection$field$link : selection.field.linkedField.name;
        } else {
            var _selection$field$alia;
            fieldName = (_selection$field$alia = selection.field.alias) !== null && _selection$field$alia !== void 0 ? _selection$field$alia : selection.field.name;
        }
        switch(selection.action){
            case 'THROW':
                this._fieldErrors.push({
                    kind: 'missing_required_field.throw',
                    fieldPath: fieldName,
                    owner: owner,
                    handled: false,
                    uiContext: undefined
                });
                return;
            case 'LOG':
                this._fieldErrors.push({
                    kind: 'missing_required_field.log',
                    fieldPath: fieldName,
                    owner: owner,
                    uiContext: undefined
                });
                return;
            default:
                selection.action;
        }
    };
    _proto._handleRequiredFieldValue = function _handleRequiredFieldValue(selection, value) {
        if (value == null) {
            this._maybeReportUnexpectedNull(selection);
            return false;
        }
        return true;
    };
    _proto._catchErrors = function _catchErrors(_value, to, previousResponseFields) {
        var value = _value;
        switch(to){
            case 'RESULT':
                value = this._asResult(_value);
                break;
            case 'NULL':
                if (this._fieldErrors != null && this._fieldErrors.length > 0) value = null;
                break;
            default:
                to;
        }
        var childrenFieldErrors = this._fieldErrors;
        this._fieldErrors = previousResponseFields;
        if (childrenFieldErrors != null) {
            if (this._fieldErrors == null) this._fieldErrors = [];
            for(var i = 0; i < childrenFieldErrors.length; i++)this._fieldErrors.push(markFieldErrorHasHandled(childrenFieldErrors[i]));
        }
        return value;
    };
    _proto._asResult = function _asResult(value) {
        if (this._fieldErrors == null || this._fieldErrors.length === 0) return {
            ok: true,
            value: value
        };
        var errors = this._fieldErrors.map(function(error) {
            switch(error.kind){
                case 'relay_field_payload.error':
                    var _error$error = error.error, message = _error$error.message, displayError = (0, _objectWithoutPropertiesLoose2["default"])(_error$error, _excluded);
                    return displayError;
                case 'missing_expected_data.throw':
                case 'missing_expected_data.log':
                    return {
                        path: error.fieldPath.split('.')
                    };
                case 'relay_resolver.error':
                    return {
                        message: "Relay: Error in resolver for field at ".concat(error.fieldPath, " in ").concat(error.owner)
                    };
                case 'missing_required_field.throw':
                    return {
                        message: "Relay: Missing @required value at path '".concat(error.fieldPath, "' in '").concat(error.owner, "'.")
                    };
                case 'missing_required_field.log':
                    return null;
                default:
                    error.kind;
                    invariant(false);
            }
        }).filter(Boolean);
        return {
            ok: false,
            errors: errors
        };
    };
    _proto._traverseSelections = function _traverseSelections(selections, record, data) {
        for(var i = 0; i < selections.length; i++){
            var selection = selections[i];
            switch(selection.kind){
                case 'RequiredField':
                    var requiredFieldValue = this._readClientSideDirectiveField(selection, record, data);
                    if (!this._handleRequiredFieldValue(selection, requiredFieldValue)) return false;
                    break;
                case 'CatchField':
                    var _selection$field$back, _selection$field, _field$alias;
                    var previousResponseFields = this._fieldErrors;
                    this._fieldErrors = null;
                    var catchFieldValue = this._readClientSideDirectiveField(selection, record, data);
                    var field = (_selection$field$back = (_selection$field = selection.field) === null || _selection$field === void 0 ? void 0 : _selection$field.backingField) !== null && _selection$field$back !== void 0 ? _selection$field$back : selection.field;
                    var fieldName = (_field$alias = field === null || field === void 0 ? void 0 : field.alias) !== null && _field$alias !== void 0 ? _field$alias : field === null || field === void 0 ? void 0 : field.name;
                    !(fieldName != null) && invariant(false);
                    data[fieldName] = this._catchErrors(catchFieldValue, selection.to, previousResponseFields);
                    break;
                case 'ScalarField':
                    this._readScalar(selection, record, data);
                    break;
                case 'LinkedField':
                    if (selection.plural) this._readPluralLink(selection, record, data);
                    else this._readLink(selection, record, data);
                    break;
                case 'Condition':
                    var conditionValue = Boolean(this._getVariableValue(selection.condition));
                    if (conditionValue === selection.passingValue) {
                        var hasExpectedData = this._traverseSelections(selection.selections, record, data);
                        if (!hasExpectedData) return false;
                    }
                    break;
                case 'InlineFragment':
                    var _hasExpectedData = this._readInlineFragment(selection, record, data, false);
                    if (_hasExpectedData === false) return false;
                    break;
                case 'RelayLiveResolver':
                case 'RelayResolver':
                    if (this._useExecTimeResolvers) this._readScalar(selection, record, data);
                    else this._readResolverField(selection, record, data);
                    break;
                case 'FragmentSpread':
                    this._createFragmentPointer(selection, record, data);
                    break;
                case 'AliasedInlineFragmentSpread':
                    this._readAliasedInlineFragment(selection, record, data);
                    break;
                case 'ModuleImport':
                    this._readModuleImport(selection, record, data);
                    break;
                case 'InlineDataFragmentSpread':
                    this._createInlineDataOrResolverFragmentPointer(selection, record, data);
                    break;
                case 'Defer':
                case 'ClientExtension':
                    var isMissingData = this._isMissingData;
                    var alreadyMissingClientEdges = this._missingClientEdges.length;
                    this._clientEdgeTraversalPath.push(null);
                    var _hasExpectedData2 = this._traverseSelections(selection.selections, record, data);
                    this._isMissingData = isMissingData || this._missingClientEdges.length > alreadyMissingClientEdges || this._missingLiveResolverFields.length > 0;
                    this._clientEdgeTraversalPath.pop();
                    if (!_hasExpectedData2) return false;
                    break;
                case 'Stream':
                    var _hasExpectedData3 = this._traverseSelections(selection.selections, record, data);
                    if (!_hasExpectedData3) return false;
                    break;
                case 'ActorChange':
                    this._readActorChange(selection, record, data);
                    break;
                case 'ClientEdgeToClientObject':
                case 'ClientEdgeToServerObject':
                    if (this._useExecTimeResolvers && (selection.backingField.kind === 'RelayResolver' || selection.backingField.kind === 'RelayLiveResolver')) {
                        var linkedField = selection.linkedField;
                        if (linkedField.plural) this._readPluralLink(linkedField, record, data);
                        else this._readLink(linkedField, record, data);
                    } else this._readClientEdge(selection, record, data);
                    break;
                default:
                    selection;
                    invariant(false);
            }
        }
        return true;
    };
    _proto._readClientSideDirectiveField = function _readClientSideDirectiveField(selection, record, data) {
        switch(selection.field.kind){
            case 'ScalarField':
                return this._readScalar(selection.field, record, data);
            case 'LinkedField':
                if (selection.field.plural) return this._readPluralLink(selection.field, record, data);
                else return this._readLink(selection.field, record, data);
            case 'RelayResolver':
            case 'RelayLiveResolver':
                if (this._useExecTimeResolvers) return this._readScalar(selection.field, record, data);
                else return this._readResolverField(selection.field, record, data);
            case 'ClientEdgeToClientObject':
            case 'ClientEdgeToServerObject':
                if (this._useExecTimeResolvers && (selection.field.backingField.kind === 'RelayResolver' || selection.field.backingField.kind === 'RelayLiveResolver')) {
                    var field = selection.field;
                    if (field.linkedField.plural) return this._readPluralLink(field.linkedField, record, data);
                    else return this._readLink(field.linkedField, record, data);
                } else return this._readClientEdge(selection.field, record, data);
            case 'AliasedInlineFragmentSpread':
                return this._readAliasedInlineFragment(selection.field, record, data);
            default:
                selection.field.kind;
                invariant(false);
        }
    };
    _proto._readResolverField = function _readResolverField(field, record, data) {
        var _field$alias2;
        var parentRecordID = RelayModernRecord.getDataID(record);
        var prevErrors = this._fieldErrors;
        this._fieldErrors = null;
        var result = this._readResolverFieldImpl(field, parentRecordID);
        var fieldName = (_field$alias2 = field.alias) !== null && _field$alias2 !== void 0 ? _field$alias2 : field.name;
        this._prependPreviousErrors(prevErrors, fieldName);
        data[fieldName] = result;
        return result;
    };
    _proto._readResolverFieldImpl = function _readResolverFieldImpl(field, parentRecordID) {
        var _this = this;
        var fragment = field.fragment;
        var snapshot;
        var getDataForResolverFragment = function getDataForResolverFragment(singularReaderSelector) {
            if (snapshot != null) return {
                data: snapshot.data,
                isMissingData: snapshot.isMissingData,
                fieldErrors: snapshot.fieldErrors
            };
            snapshot = read(_this._recordSource, singularReaderSelector, _this._resolverCache);
            return {
                data: snapshot.data,
                isMissingData: snapshot.isMissingData,
                fieldErrors: snapshot.fieldErrors
            };
        };
        var evaluate = function evaluate() {
            if (fragment != null) {
                var key = {
                    __id: parentRecordID,
                    __fragmentOwner: _this._owner,
                    __fragments: (0, _defineProperty2["default"])({}, fragment.name, fragment.args ? getArgumentValues(fragment.args, _this._variables) : {})
                };
                if (_this._clientEdgeTraversalPath.length > 0 && _this._clientEdgeTraversalPath[_this._clientEdgeTraversalPath.length - 1] !== null) key[CLIENT_EDGE_TRAVERSAL_PATH] = (0, _toConsumableArray2["default"])(_this._clientEdgeTraversalPath);
                var resolverContext = {
                    getDataForResolverFragment: getDataForResolverFragment
                };
                return withResolverContext(resolverContext, function() {
                    var _getResolverValue = getResolverValue(field, _this._variables, key, _this._resolverContext), resolverResult = _getResolverValue[0], resolverError = _getResolverValue[1];
                    return {
                        resolverResult: resolverResult,
                        snapshot: snapshot,
                        error: resolverError
                    };
                });
            } else {
                var _getResolverValue2 = getResolverValue(field, _this._variables, null, _this._resolverContext), resolverResult = _getResolverValue2[0], _resolverError = _getResolverValue2[1];
                return {
                    resolverResult: resolverResult,
                    snapshot: undefined,
                    error: _resolverError
                };
            }
        };
        var _this$_resolverCache$ = this._resolverCache.readFromCacheOrEvaluate(parentRecordID, field, this._variables, evaluate, getDataForResolverFragment), result = _this$_resolverCache$[0], seenRecord = _this$_resolverCache$[1], resolverError = _this$_resolverCache$[2], cachedSnapshot = _this$_resolverCache$[3], suspenseID = _this$_resolverCache$[4], updatedDataIDs = _this$_resolverCache$[5];
        this._propagateResolverMetadata(field.path, cachedSnapshot, resolverError, seenRecord, suspenseID, updatedDataIDs);
        return result;
    };
    _proto._propagateResolverMetadata = function _propagateResolverMetadata(fieldPath, cachedSnapshot, resolverError, seenRecord, suspenseID, updatedDataIDs) {
        var _this2 = this;
        if (cachedSnapshot != null) {
            if (cachedSnapshot.missingClientEdges != null) for(var i = 0; i < cachedSnapshot.missingClientEdges.length; i++){
                var missing = cachedSnapshot.missingClientEdges[i];
                this._missingClientEdges.push(missing);
            }
            if (cachedSnapshot.missingLiveResolverFields != null) {
                this._isMissingData = this._isMissingData || cachedSnapshot.missingLiveResolverFields.length > 0;
                for(var _i = 0; _i < cachedSnapshot.missingLiveResolverFields.length; _i++){
                    var missingResolverField = cachedSnapshot.missingLiveResolverFields[_i];
                    this._missingLiveResolverFields.push(missingResolverField);
                }
            }
            if (cachedSnapshot.fieldErrors != null) {
                if (this._fieldErrors == null) this._fieldErrors = [];
                for(var _i2 = 0; _i2 < cachedSnapshot.fieldErrors.length; _i2++){
                    var _this$_selector$node$6;
                    var error = cachedSnapshot.fieldErrors[_i2];
                    if (((_this$_selector$node$6 = this._selector.node.metadata) === null || _this$_selector$node$6 === void 0 ? void 0 : _this$_selector$node$6.throwOnFieldError) === true) this._fieldErrors.push(error);
                    else this._fieldErrors.push(markFieldErrorHasHandled(error));
                }
            }
            this._isMissingData = this._isMissingData || cachedSnapshot.isMissingData;
        }
        if (resolverError) {
            var _this$_selector$node$7, _this$_selector$node$8;
            var errorEvent = {
                kind: 'relay_resolver.error',
                fieldPath: fieldPath,
                owner: this._fragmentName,
                error: resolverError,
                shouldThrow: (_this$_selector$node$7 = (_this$_selector$node$8 = this._selector.node.metadata) === null || _this$_selector$node$8 === void 0 ? void 0 : _this$_selector$node$8.throwOnFieldError) !== null && _this$_selector$node$7 !== void 0 ? _this$_selector$node$7 : false,
                handled: false,
                uiContext: undefined
            };
            if (this._fieldErrors == null) this._fieldErrors = [
                errorEvent
            ];
            else this._fieldErrors.push(errorEvent);
        }
        if (seenRecord != null) this._seenRecords.add(seenRecord);
        if (suspenseID != null) {
            this._isMissingData = true;
            this._missingLiveResolverFields.push(suspenseID);
        }
        if (updatedDataIDs != null) updatedDataIDs.forEach(function(recordID) {
            _this2._updatedDataIDs.add(recordID);
        });
    };
    _proto._readClientEdge = function _readClientEdge(field, record, data) {
        var _this3 = this;
        var _backingField$alias;
        var backingField = field.backingField;
        !(backingField.kind !== 'ClientExtension') && invariant(false);
        var fieldName = (_backingField$alias = backingField.alias) !== null && _backingField$alias !== void 0 ? _backingField$alias : backingField.name;
        var backingFieldData = {};
        this._traverseSelections([
            backingField
        ], record, backingFieldData);
        var clientEdgeResolverResponse = backingFieldData[fieldName];
        if (clientEdgeResolverResponse == null || isSuspenseSentinel(clientEdgeResolverResponse)) {
            data[fieldName] = clientEdgeResolverResponse;
            return clientEdgeResolverResponse;
        }
        if (field.linkedField.plural) {
            !Array.isArray(clientEdgeResolverResponse) && invariant(false);
            var storeIDs;
            !(field.kind === 'ClientEdgeToClientObject') && invariant(false);
            if (field.backingField.normalizationInfo == null) storeIDs = clientEdgeResolverResponse.map(function(itemResponse) {
                var _field$concreteType;
                var concreteType = (_field$concreteType = field.concreteType) !== null && _field$concreteType !== void 0 ? _field$concreteType : itemResponse.__typename;
                !(typeof concreteType === 'string') && invariant(false);
                var localId = extractIdFromResponse(itemResponse, backingField.path, _this3._owner.identifier);
                var id = _this3._resolverCache.ensureClientRecord(localId, concreteType);
                var modelResolvers = field.modelResolvers;
                if (modelResolvers != null) {
                    var modelResolver = modelResolvers[concreteType];
                    !(modelResolver !== undefined) && invariant(false);
                    var model = _this3._readResolverFieldImpl(modelResolver, id);
                    return model != null ? id : null;
                }
                return id;
            });
            else storeIDs = clientEdgeResolverResponse.map(function(obj) {
                return extractIdFromResponse(obj, backingField.path, _this3._owner.identifier);
            });
            this._clientEdgeTraversalPath.push(null);
            var edgeValues = this._readLinkedIds(field.linkedField, storeIDs, record, data);
            this._clientEdgeTraversalPath.pop();
            data[fieldName] = edgeValues;
            return edgeValues;
        } else {
            var _field$concreteType2;
            var id = extractIdFromResponse(clientEdgeResolverResponse, backingField.path, this._owner.identifier);
            var storeID;
            var concreteType = (_field$concreteType2 = field.concreteType) !== null && _field$concreteType2 !== void 0 ? _field$concreteType2 : clientEdgeResolverResponse.__typename;
            var traversalPathSegment;
            if (field.kind === 'ClientEdgeToClientObject') {
                if (field.backingField.normalizationInfo == null) {
                    !(typeof concreteType === 'string') && invariant(false);
                    storeID = this._resolverCache.ensureClientRecord(id, concreteType);
                    traversalPathSegment = null;
                } else {
                    storeID = id;
                    traversalPathSegment = null;
                }
            } else {
                storeID = id;
                traversalPathSegment = {
                    readerClientEdge: field,
                    clientEdgeDestinationID: id
                };
            }
            var modelResolvers = field.modelResolvers;
            if (modelResolvers != null) {
                !(typeof concreteType === 'string') && invariant(false);
                var modelResolver = modelResolvers[concreteType];
                !(modelResolver !== undefined) && invariant(false);
                var model = this._readResolverFieldImpl(modelResolver, storeID);
                if (model == null) {
                    data[fieldName] = null;
                    return null;
                }
            }
            this._clientEdgeTraversalPath.push(traversalPathSegment);
            var prevData = data[fieldName];
            !(prevData == null || typeof prevData === 'object') && invariant(false);
            var prevErrors = this._fieldErrors;
            this._fieldErrors = null;
            var edgeValue = this._traverse(field.linkedField, storeID, prevData);
            this._prependPreviousErrors(prevErrors, fieldName);
            this._clientEdgeTraversalPath.pop();
            data[fieldName] = edgeValue;
            return edgeValue;
        }
    };
    _proto._readScalar = function _readScalar(field, record, data) {
        var _field$alias3;
        var fieldName = (_field$alias3 = field.alias) !== null && _field$alias3 !== void 0 ? _field$alias3 : field.name;
        var storageKey = getStorageKey(field, this._variables);
        var value = RelayModernRecord.getValue(record, storageKey);
        if (value === null || RelayFeatureFlags.ENABLE_NONCOMPLIANT_ERROR_HANDLING_ON_LISTS && Array.isArray(value) && value.length === 0) this._maybeAddFieldErrors(record, storageKey);
        else if (value === undefined) this._markDataAsMissing(fieldName);
        data[fieldName] = value;
        return value;
    };
    _proto._readLink = function _readLink(field, record, data) {
        var _field$alias4;
        var fieldName = (_field$alias4 = field.alias) !== null && _field$alias4 !== void 0 ? _field$alias4 : field.name;
        var storageKey = getStorageKey(field, this._variables);
        var linkedID = RelayModernRecord.getLinkedRecordID(record, storageKey);
        if (linkedID == null) {
            data[fieldName] = linkedID;
            if (linkedID === null) this._maybeAddFieldErrors(record, storageKey);
            else if (linkedID === undefined) this._markDataAsMissing(fieldName);
            return linkedID;
        }
        var prevData = data[fieldName];
        !(prevData == null || typeof prevData === 'object') && invariant(false);
        var prevErrors = this._fieldErrors;
        this._fieldErrors = null;
        var value = this._traverse(field, linkedID, prevData);
        this._prependPreviousErrors(prevErrors, fieldName);
        data[fieldName] = value;
        return value;
    };
    _proto._prependPreviousErrors = function _prependPreviousErrors(prevErrors, fieldNameOrIndex) {
        if (this._fieldErrors != null) {
            for(var i = 0; i < this._fieldErrors.length; i++){
                var event = this._fieldErrors[i];
                if (event.owner === this._fragmentName && (event.kind === 'missing_expected_data.throw' || event.kind === 'missing_expected_data.log' || event.kind === 'missing_required_field.throw' || event.kind === 'missing_required_field.log')) event.fieldPath = "".concat(fieldNameOrIndex, ".").concat(event.fieldPath);
            }
            if (prevErrors != null) {
                for(var _i3 = this._fieldErrors.length - 1; _i3 >= 0; _i3--)prevErrors.push(this._fieldErrors[_i3]);
                this._fieldErrors = prevErrors;
            }
        } else this._fieldErrors = prevErrors;
    };
    _proto._readActorChange = function _readActorChange(field, record, data) {
        var _field$alias5;
        var fieldName = (_field$alias5 = field.alias) !== null && _field$alias5 !== void 0 ? _field$alias5 : field.name;
        var storageKey = getStorageKey(field, this._variables);
        var externalRef = RelayModernRecord.getActorLinkedRecordID(record, storageKey);
        if (externalRef == null) {
            data[fieldName] = externalRef;
            if (externalRef === undefined) this._markDataAsMissing(fieldName);
            else if (externalRef === null) this._maybeAddFieldErrors(record, storageKey);
            return data[fieldName];
        }
        var actorIdentifier = externalRef[0], dataID = externalRef[1];
        var fragmentRef = {};
        this._createFragmentPointer(field.fragmentSpread, RelayModernRecord.fromObject({
            __id: dataID
        }), fragmentRef);
        data[fieldName] = {
            __fragmentRef: fragmentRef,
            __viewer: actorIdentifier
        };
        return data[fieldName];
    };
    _proto._readPluralLink = function _readPluralLink(field, record, data) {
        var storageKey = getStorageKey(field, this._variables);
        var linkedIDs = RelayModernRecord.getLinkedRecordIDs(record, storageKey);
        if (linkedIDs === null || RelayFeatureFlags.ENABLE_NONCOMPLIANT_ERROR_HANDLING_ON_LISTS && Array.isArray(linkedIDs) && linkedIDs.length === 0) this._maybeAddFieldErrors(record, storageKey);
        return this._readLinkedIds(field, linkedIDs, record, data);
    };
    _proto._readLinkedIds = function _readLinkedIds(field, linkedIDs, record, data) {
        var _this4 = this;
        var _field$alias6;
        var fieldName = (_field$alias6 = field.alias) !== null && _field$alias6 !== void 0 ? _field$alias6 : field.name;
        if (linkedIDs == null) {
            data[fieldName] = linkedIDs;
            if (linkedIDs === undefined) this._markDataAsMissing(fieldName);
            return linkedIDs;
        }
        var prevData = data[fieldName];
        !(prevData == null || Array.isArray(prevData)) && invariant(false);
        var prevErrors = this._fieldErrors;
        this._fieldErrors = null;
        var linkedArray = prevData || [];
        linkedIDs.forEach(function(linkedID, nextIndex) {
            if (linkedID == null) {
                if (linkedID === undefined) _this4._markDataAsMissing(String(nextIndex));
                linkedArray[nextIndex] = linkedID;
                return;
            }
            var prevItem = linkedArray[nextIndex];
            !(prevItem == null || typeof prevItem === 'object') && invariant(false);
            var prevErrors = _this4._fieldErrors;
            _this4._fieldErrors = null;
            linkedArray[nextIndex] = _this4._traverse(field, linkedID, prevItem);
            _this4._prependPreviousErrors(prevErrors, nextIndex);
        });
        this._prependPreviousErrors(prevErrors, fieldName);
        data[fieldName] = linkedArray;
        return linkedArray;
    };
    _proto._readModuleImport = function _readModuleImport(moduleImport, record, data) {
        var componentKey = getModuleComponentKey(moduleImport.documentName);
        var relayStoreComponent = RelayModernRecord.getValue(record, componentKey);
        var component = relayStoreComponent !== undefined ? relayStoreComponent : moduleImport.componentModuleProvider;
        if (component == null) {
            if (component === undefined) this._markDataAsMissing('<module-import>');
            return;
        }
        this._createFragmentPointer({
            kind: 'FragmentSpread',
            name: moduleImport.fragmentName,
            args: moduleImport.args
        }, record, data);
        data[FRAGMENT_PROP_NAME_KEY] = moduleImport.fragmentPropName;
        data[MODULE_COMPONENT_KEY] = component;
    };
    _proto._readAliasedInlineFragment = function _readAliasedInlineFragment(aliasedInlineFragment, record, data) {
        var prevErrors = this._fieldErrors;
        this._fieldErrors = null;
        var fieldValue = this._readInlineFragment(aliasedInlineFragment.fragment, record, {}, true);
        this._prependPreviousErrors(prevErrors, aliasedInlineFragment.name);
        if (fieldValue === false) fieldValue = null;
        data[aliasedInlineFragment.name] = fieldValue;
    };
    _proto._readInlineFragment = function _readInlineFragment(inlineFragment, record, data, skipUnmatchedAbstractTypes) {
        if (inlineFragment.type == null) {
            var hasExpectedData = this._traverseSelections(inlineFragment.selections, record, data);
            if (hasExpectedData === false) return false;
            return data;
        }
        var abstractKey = inlineFragment.abstractKey;
        if (abstractKey == null) {
            if (!this._recordMatchesTypeCondition(record, inlineFragment.type)) return null;
            else {
                var hasExpectedData = this._traverseSelections(inlineFragment.selections, record, data);
                if (!hasExpectedData) return false;
            }
        } else {
            var implementsInterface = this._implementsInterface(record, abstractKey);
            if (implementsInterface === false && skipUnmatchedAbstractTypes) return null;
            var parentIsMissingData = this._isMissingData;
            var parentIsWithinUnmatchedTypeRefinement = this._isWithinUnmatchedTypeRefinement;
            this._isWithinUnmatchedTypeRefinement = parentIsWithinUnmatchedTypeRefinement || implementsInterface === false;
            var hasMissingData = this._traverseSelections(inlineFragment.selections, record, data);
            this._isWithinUnmatchedTypeRefinement = parentIsWithinUnmatchedTypeRefinement;
            if (implementsInterface === false) {
                this._isMissingData = parentIsMissingData;
                return null;
            } else if (implementsInterface == null) return undefined;
            else if (hasMissingData === false) return false;
        }
        return data;
    };
    _proto._recordMatchesTypeCondition = function _recordMatchesTypeCondition(record, type) {
        var typeName = RelayModernRecord.getType(record);
        return typeName != null && typeName === type || RelayModernRecord.getDataID(record) === ROOT_ID;
    };
    _proto._createFragmentPointer = function _createFragmentPointer(fragmentSpread, record, data) {
        var fragmentPointers = data[FRAGMENTS_KEY];
        if (fragmentPointers == null) fragmentPointers = data[FRAGMENTS_KEY] = {};
        !(typeof fragmentPointers === 'object' && fragmentPointers != null) && invariant(false);
        if (data[ID_KEY] == null) data[ID_KEY] = RelayModernRecord.getDataID(record);
        fragmentPointers[fragmentSpread.name] = getArgumentValues(fragmentSpread.args, this._variables, this._isWithinUnmatchedTypeRefinement);
        data[FRAGMENT_OWNER_KEY] = this._owner;
        if (this._clientEdgeTraversalPath.length > 0 && this._clientEdgeTraversalPath[this._clientEdgeTraversalPath.length - 1] !== null) data[CLIENT_EDGE_TRAVERSAL_PATH] = (0, _toConsumableArray2["default"])(this._clientEdgeTraversalPath);
    };
    _proto._createInlineDataOrResolverFragmentPointer = function _createInlineDataOrResolverFragmentPointer(fragmentSpreadOrFragment, record, data) {
        var fragmentPointers = data[FRAGMENTS_KEY];
        if (fragmentPointers == null) fragmentPointers = data[FRAGMENTS_KEY] = {};
        !(typeof fragmentPointers === 'object' && fragmentPointers != null) && invariant(false);
        if (data[ID_KEY] == null) data[ID_KEY] = RelayModernRecord.getDataID(record);
        var inlineData = {};
        var parentFragmentName = this._fragmentName;
        this._fragmentName = fragmentSpreadOrFragment.name;
        var parentVariables = this._variables;
        var argumentVariables = fragmentSpreadOrFragment.args ? getArgumentValues(fragmentSpreadOrFragment.args, this._variables) : {};
        this._variables = RelayConcreteVariables.getFragmentVariables(fragmentSpreadOrFragment, this._owner.variables, argumentVariables);
        this._traverseSelections(fragmentSpreadOrFragment.selections, record, inlineData);
        this._variables = parentVariables;
        this._fragmentName = parentFragmentName;
        fragmentPointers[fragmentSpreadOrFragment.name] = inlineData;
    };
    _proto._implementsInterface = function _implementsInterface(record, abstractKey) {
        var typeName = RelayModernRecord.getType(record);
        var typeRecord = this._recordSource.get(generateTypeID(typeName));
        var implementsInterface = typeRecord != null ? RelayModernRecord.getValue(typeRecord, abstractKey) : null;
        if (implementsInterface == null) this._markDataAsMissing('<abstract-type-hint>');
        return implementsInterface;
    };
    return RelayReader;
}();
function markFieldErrorHasHandled(event) {
    switch(event.kind){
        case 'missing_expected_data.throw':
        case 'missing_required_field.throw':
        case 'relay_field_payload.error':
        case 'relay_resolver.error':
            return (0, _objectSpread2["default"])((0, _objectSpread2["default"])({}, event), {}, {
                handled: true
            });
        case 'missing_expected_data.log':
        case 'missing_required_field.log':
            return event;
        default:
            event.kind;
            invariant(false);
    }
}
function getResolverValue(field, variables, fragmentKey, resolverContext) {
    var resolverFunction = typeof field.resolverModule === 'function' ? field.resolverModule : field.resolverModule["default"];
    var resolverResult = null;
    var resolverError = null;
    try {
        var resolverFunctionArgs = [];
        if (field.fragment != null) resolverFunctionArgs.push(fragmentKey);
        var args = field.args ? getArgumentValues(field.args, variables) : undefined;
        resolverFunctionArgs.push(args);
        resolverFunctionArgs.push(resolverContext);
        resolverResult = resolverFunction.apply(null, resolverFunctionArgs);
    } catch (e) {
        resolverResult = null;
        if (e !== RESOLVER_FRAGMENT_ERRORED_SENTINEL) resolverError = e;
    }
    return [
        resolverResult,
        resolverError
    ];
}
function extractIdFromResponse(individualResponse, path, owner) {
    if (typeof individualResponse === 'string') return individualResponse;
    else if (typeof individualResponse === 'object' && individualResponse != null && typeof individualResponse.id === 'string') return individualResponse.id;
    invariant(false);
}
module.exports = {
    read: read
};

},{"a3c1fb2c07af9d8f":"590td","99f0804ffd78142a":"2Bj1n","ecd5938fdccf58d0":"2paQ8","99758f59b24e5d08":"fkx57","e1d5f18766f34ffd":"7EBX0","e4590f7d0743b994":"a0FL5","a4adcb3e9e93be18":"9sE63","6aa3e28b2397f0f2":"138Hd","1474639a77db088c":"daXOB","ceb4056395d53b78":"3QcrW","2ec0ed85284cf22":"4eoTv","91eb3a4f12b0db94":"1JmVd","c94b24a7feab2434":"32ztQ","8bf034bdcb6b97a6":"e2sci"}],"4eoTv":[function(require,module,exports,__globalThis) {
'use strict';
var _require = require("1f222ceafc09f16f"), RELAY_LIVE_RESOLVER = _require.RELAY_LIVE_RESOLVER;
var invariant = require("f57ad9485ce87f04");
var NoopResolverCache = /*#__PURE__*/ function() {
    function NoopResolverCache() {}
    var _proto = NoopResolverCache.prototype;
    _proto.readFromCacheOrEvaluate = function readFromCacheOrEvaluate(recordID, field, variables, evaluate, getDataForResolverFragment) {
        !(field.kind !== RELAY_LIVE_RESOLVER) && invariant(false);
        var _evaluate = evaluate(), resolverResult = _evaluate.resolverResult, snapshot = _evaluate.snapshot, error = _evaluate.error;
        return [
            resolverResult,
            undefined,
            error,
            snapshot,
            undefined,
            undefined
        ];
    };
    _proto.invalidateDataIDs = function invalidateDataIDs(updatedDataIDs) {};
    _proto.ensureClientRecord = function ensureClientRecord(id, typeName) {
        invariant(false);
    };
    _proto.notifyUpdatedSubscribers = function notifyUpdatedSubscribers(updatedDataIDs) {};
    return NoopResolverCache;
}();
module.exports = {
    NoopResolverCache: NoopResolverCache
};

},{"1f222ceafc09f16f":"jKskk","f57ad9485ce87f04":"e2sci"}],"7FTk2":[function(require,module,exports,__globalThis) {
'use strict';
var _interopRequireDefault = require("cbadddc442b6deaf")["default"];
var _createForOfIteratorHelper2 = _interopRequireDefault(require("96443eecc4a72d7b"));
var getOperation = require("7b06dd03ba2cb4d4");
var cloneRelayHandleSourceField = require("c4ea8083a86e020d");
var getOutputTypeRecordIDs = require("5988f0eb37670567");
var _require = require("7f246af2ff0d77f5"), getLocalVariables = _require.getLocalVariables;
var RelayModernRecord = require("e00013a27e047068");
var RelayStoreUtils = require("1f42bd1ed1e95682");
var _require2 = require("d74d487411fd9911"), generateTypeID = _require2.generateTypeID;
var invariant = require("1eabded8cbcaaa04");
var getReadTimeResolverStorageKey = RelayStoreUtils.getReadTimeResolverStorageKey, getStorageKey = RelayStoreUtils.getStorageKey, getModuleOperationKey = RelayStoreUtils.getModuleOperationKey;
function mark(recordSource, selector, references, operationLoader, shouldProcessClientComponents, useExecTimeResolvers) {
    var dataID = selector.dataID, node = selector.node, variables = selector.variables;
    var marker = new RelayReferenceMarker(recordSource, variables, references, operationLoader, shouldProcessClientComponents, useExecTimeResolvers);
    marker.mark(node, dataID);
}
var RelayReferenceMarker = /*#__PURE__*/ function() {
    function RelayReferenceMarker(recordSource, variables, references, operationLoader, shouldProcessClientComponents, useExecTimeResolvers) {
        this._operationLoader = operationLoader !== null && operationLoader !== void 0 ? operationLoader : null;
        this._operationName = null;
        this._useExecTimeResolvers = useExecTimeResolvers !== null && useExecTimeResolvers !== void 0 ? useExecTimeResolvers : false;
        this._recordSource = recordSource;
        this._references = references;
        this._variables = variables;
        this._shouldProcessClientComponents = shouldProcessClientComponents;
    }
    var _proto = RelayReferenceMarker.prototype;
    _proto.mark = function mark(node, dataID) {
        if (node.kind === 'Operation' || node.kind === 'SplitOperation') this._operationName = node.name;
        this._traverse(node, dataID);
    };
    _proto._traverse = function _traverse(node, dataID) {
        this._references.add(dataID);
        var record = this._recordSource.get(dataID);
        if (record == null) return;
        this._traverseSelections(node.selections, record);
    };
    _proto._getVariableValue = function _getVariableValue(name) {
        !this._variables.hasOwnProperty(name) && invariant(false);
        return this._variables[name];
    };
    _proto._traverseSelections = function _traverseSelections(selections, record) {
        var _this = this;
        selections.forEach(function(selection) {
            switch(selection.kind){
                case 'ActorChange':
                    _this._traverseLink(selection.linkedField, record);
                    break;
                case 'LinkedField':
                    if (selection.plural) _this._traversePluralLink(selection, record);
                    else _this._traverseLink(selection, record);
                    break;
                case 'Condition':
                    var conditionValue = Boolean(_this._getVariableValue(selection.condition));
                    if (conditionValue === selection.passingValue) _this._traverseSelections(selection.selections, record);
                    break;
                case 'InlineFragment':
                    if (selection.abstractKey == null) {
                        var typeName = RelayModernRecord.getType(record);
                        if (typeName != null && typeName === selection.type || typeName === RelayStoreUtils.ROOT_TYPE) _this._traverseSelections(selection.selections, record);
                    } else {
                        var _typeName = RelayModernRecord.getType(record);
                        var typeID = generateTypeID(_typeName);
                        _this._references.add(typeID);
                        _this._traverseSelections(selection.selections, record);
                    }
                    break;
                case 'FragmentSpread':
                    var prevVariables = _this._variables;
                    _this._variables = getLocalVariables(_this._variables, selection.fragment.argumentDefinitions, selection.args);
                    _this._traverseSelections(selection.fragment.selections, record);
                    _this._variables = prevVariables;
                    break;
                case 'LinkedHandle':
                    var handleField = cloneRelayHandleSourceField(selection, selections, _this._variables);
                    if (handleField.plural) _this._traversePluralLink(handleField, record);
                    else _this._traverseLink(handleField, record);
                    break;
                case 'Defer':
                case 'Stream':
                    _this._traverseSelections(selection.selections, record);
                    break;
                case 'ScalarField':
                case 'ScalarHandle':
                    break;
                case 'TypeDiscriminator':
                    var _typeName2 = RelayModernRecord.getType(record);
                    var _typeID = generateTypeID(_typeName2);
                    _this._references.add(_typeID);
                    break;
                case 'ModuleImport':
                    _this._traverseModuleImport(selection, record);
                    break;
                case 'ClientExtension':
                    _this._traverseSelections(selection.selections, record);
                    break;
                case 'ClientComponent':
                    if (_this._shouldProcessClientComponents === false) break;
                    _this._traverseSelections(selection.fragment.selections, record);
                    break;
                case 'RelayResolver':
                case 'RelayLiveResolver':
                    _this._traverseResolverField(selection, record);
                    break;
                case 'ClientEdgeToClientObject':
                    _this._traverseClientEdgeToClientObject(selection, record);
                    break;
                default:
                    selection;
                    invariant(false);
            }
        });
    };
    _proto._traverseClientEdgeToClientObject = function _traverseClientEdgeToClientObject(field, record) {
        if (this._useExecTimeResolvers) {
            this._traverseLink(field.linkedField, record);
            return;
        }
        var dataID = this._traverseResolverField(field.backingField, record);
        if (dataID == null) return;
        var resolverRecord = this._recordSource.get(dataID);
        if (resolverRecord == null) return;
        if (field.backingField.isOutputType) {
            var outputTypeRecordIDs = getOutputTypeRecordIDs(resolverRecord);
            if (outputTypeRecordIDs != null) {
                var _iterator = (0, _createForOfIteratorHelper2["default"])(outputTypeRecordIDs), _step;
                try {
                    for(_iterator.s(); !(_step = _iterator.n()).done;){
                        var _dataID = _step.value;
                        this._references.add(_dataID);
                    }
                } catch (err) {
                    _iterator.e(err);
                } finally{
                    _iterator.f();
                }
            }
        } else {
            var linkedField = field.linkedField;
            var concreteType = linkedField.concreteType;
            if (concreteType == null) return;
            if (linkedField.plural) {
                var dataIDs = RelayModernRecord.getResolverLinkedRecordIDs(resolverRecord, concreteType);
                if (dataIDs != null) {
                    var _iterator2 = (0, _createForOfIteratorHelper2["default"])(dataIDs), _step2;
                    try {
                        for(_iterator2.s(); !(_step2 = _iterator2.n()).done;){
                            var _dataID2 = _step2.value;
                            if (_dataID2 != null) this._traverse(linkedField, _dataID2);
                        }
                    } catch (err) {
                        _iterator2.e(err);
                    } finally{
                        _iterator2.f();
                    }
                }
            } else {
                var _dataID3 = RelayModernRecord.getResolverLinkedRecordID(resolverRecord, concreteType);
                if (_dataID3 != null) this._traverse(linkedField, _dataID3);
            }
        }
    };
    _proto._traverseResolverField = function _traverseResolverField(field, record) {
        if (this._useExecTimeResolvers) return;
        var storageKey = getReadTimeResolverStorageKey(field, this._variables);
        var dataID = RelayModernRecord.getLinkedRecordID(record, storageKey);
        if (dataID != null) this._references.add(dataID);
        var fragment = field.fragment;
        if (fragment != null) this._traverseSelections([
            fragment
        ], record);
        return dataID;
    };
    _proto._traverseModuleImport = function _traverseModuleImport(moduleImport, record) {
        var _this$_operationName;
        var operationLoader = this._operationLoader;
        !(operationLoader !== null) && invariant(false);
        var operationKey = getModuleOperationKey(moduleImport.documentName);
        var operationReference = RelayModernRecord.getValue(record, operationKey);
        if (operationReference == null) return;
        var normalizationRootNode = operationLoader.get(operationReference);
        if (normalizationRootNode != null) {
            var operation = getOperation(normalizationRootNode);
            var prevVariables = this._variables;
            this._variables = getLocalVariables(this._variables, operation.argumentDefinitions, moduleImport.args);
            this._traverseSelections(operation.selections, record);
            this._variables = prevVariables;
        }
    };
    _proto._traverseLink = function _traverseLink(field, record) {
        var storageKey = getStorageKey(field, this._variables);
        var linkedID = RelayModernRecord.getLinkedRecordID(record, storageKey);
        if (linkedID == null) return;
        this._traverse(field, linkedID);
    };
    _proto._traversePluralLink = function _traversePluralLink(field, record) {
        var _this2 = this;
        var storageKey = getStorageKey(field, this._variables);
        var linkedIDs = RelayModernRecord.getLinkedRecordIDs(record, storageKey);
        if (linkedIDs == null) return;
        linkedIDs.forEach(function(linkedID) {
            if (linkedID != null) _this2._traverse(field, linkedID);
        });
    };
    return RelayReferenceMarker;
}();
module.exports = {
    mark: mark
};

},{"cbadddc442b6deaf":"590td","96443eecc4a72d7b":"fMaLa","7b06dd03ba2cb4d4":"4vplj","c4ea8083a86e020d":"hUbQm","5988f0eb37670567":"eGTqf","7f246af2ff0d77f5":"138Hd","e00013a27e047068":"daXOB","1f42bd1ed1e95682":"3QcrW","d74d487411fd9911":"32ztQ","1eabded8cbcaaa04":"e2sci"}],"idAWU":[function(require,module,exports,__globalThis) {
'use strict';
var deepFreeze = require("8a95c7fa9dc12fe9");
var recycleNodesInto = require("5e5d7bb6f8bf8b1f");
var RelayFeatureFlags = require("f33204f0bccaed58");
var hasOverlappingIDs = require("5a211ee2f9eb5afa");
var hasSignificantOverlappingIDs = require("250834abcf4a675d");
var RelayReader = require("65e9366da423c0f6");
var RelayStoreSubscriptions = /*#__PURE__*/ function() {
    function RelayStoreSubscriptions(log, resolverCache, resolverContext) {
        this._subscriptions = new Set();
        this.__log = log;
        this._resolverCache = resolverCache;
        this._resolverContext = resolverContext;
    }
    var _proto = RelayStoreSubscriptions.prototype;
    _proto.subscribe = function subscribe(snapshot, callback) {
        var _this = this;
        var subscription = {
            backup: null,
            callback: callback,
            snapshot: snapshot,
            stale: false
        };
        var dispose = function dispose() {
            _this._subscriptions["delete"](subscription);
        };
        this._subscriptions.add(subscription);
        return {
            dispose: dispose
        };
    };
    _proto.snapshotSubscriptions = function snapshotSubscriptions(source) {
        var _this2 = this;
        this._subscriptions.forEach(function(subscription) {
            if (!subscription.stale) {
                subscription.backup = subscription.snapshot;
                return;
            }
            var snapshot = subscription.snapshot;
            var backup = RelayReader.read(source, snapshot.selector, _this2._resolverCache, _this2._resolverContext);
            var nextData = recycleNodesInto(snapshot.data, backup.data);
            backup.data = nextData;
            subscription.backup = backup;
        });
    };
    _proto.restoreSubscriptions = function restoreSubscriptions() {
        this._subscriptions.forEach(function(subscription) {
            var backup = subscription.backup;
            subscription.backup = null;
            if (backup) {
                if (backup.data !== subscription.snapshot.data) subscription.stale = true;
                subscription.snapshot = {
                    data: subscription.snapshot.data,
                    isMissingData: backup.isMissingData,
                    missingClientEdges: backup.missingClientEdges,
                    missingLiveResolverFields: backup.missingLiveResolverFields,
                    seenRecords: backup.seenRecords,
                    selector: backup.selector,
                    fieldErrors: backup.fieldErrors
                };
            } else subscription.stale = true;
        });
    };
    _proto.updateSubscriptions = function updateSubscriptions(source, updatedRecordIDs, updatedOwners, sourceOperation) {
        var _this3 = this;
        var hasUpdatedRecords = updatedRecordIDs.size !== 0;
        this._subscriptions.forEach(function(subscription) {
            var owner = _this3._updateSubscription(source, subscription, updatedRecordIDs, hasUpdatedRecords, sourceOperation);
            if (owner != null) updatedOwners.push(owner);
        });
    };
    _proto._updateSubscription = function _updateSubscription(source, subscription, updatedRecordIDs, hasUpdatedRecords, sourceOperation) {
        var backup = subscription.backup, callback = subscription.callback, snapshot = subscription.snapshot, stale = subscription.stale;
        var hasOverlappingUpdates = hasUpdatedRecords && hasOverlappingIDs(snapshot.seenRecords, updatedRecordIDs);
        if (!stale && !hasOverlappingUpdates) return;
        var nextSnapshot = hasOverlappingUpdates || !backup ? RelayReader.read(source, snapshot.selector, this._resolverCache, this._resolverContext) : backup;
        var nextData = recycleNodesInto(snapshot.data, nextSnapshot.data);
        nextSnapshot = {
            data: nextData,
            isMissingData: nextSnapshot.isMissingData,
            missingClientEdges: nextSnapshot.missingClientEdges,
            missingLiveResolverFields: nextSnapshot.missingLiveResolverFields,
            seenRecords: nextSnapshot.seenRecords,
            selector: nextSnapshot.selector,
            fieldErrors: nextSnapshot.fieldErrors
        };
        subscription.snapshot = nextSnapshot;
        subscription.stale = false;
        if (nextSnapshot.data !== snapshot.data) {
            if (this.__log && RelayFeatureFlags.ENABLE_NOTIFY_SUBSCRIPTION) this.__log({
                name: 'store.notify.subscription',
                sourceOperation: sourceOperation,
                snapshot: snapshot,
                nextSnapshot: nextSnapshot
            });
            callback(nextSnapshot);
            return snapshot.selector.owner;
        }
        if (RelayFeatureFlags.ENABLE_LOOSE_SUBSCRIPTION_ATTRIBUTION && (stale || hasSignificantOverlappingIDs(snapshot.seenRecords, updatedRecordIDs))) return snapshot.selector.owner;
    };
    _proto.size = function size() {
        return this._subscriptions.size;
    };
    return RelayStoreSubscriptions;
}();
module.exports = RelayStoreSubscriptions;

},{"8a95c7fa9dc12fe9":"eLea7","5e5d7bb6f8bf8b1f":"ij1IQ","f33204f0bccaed58":"a0FL5","5a211ee2f9eb5afa":"czxXZ","250834abcf4a675d":"d1LBu","65e9366da423c0f6":"hTh0M"}],"czxXZ":[function(require,module,exports,__globalThis) {
'use strict';
var ITERATOR_KEY = Symbol.iterator;
function hasOverlappingIDs(seenRecords, updatedRecordIDs) {
    var iterator = seenRecords[ITERATOR_KEY]();
    var next = iterator.next();
    while(!next.done){
        var key = next.value;
        if (updatedRecordIDs.has(key)) return true;
        next = iterator.next();
    }
    return false;
}
module.exports = hasOverlappingIDs;

},{}],"d1LBu":[function(require,module,exports,__globalThis) {
'use strict';
var _require = require("58f1581f3785949d"), ROOT_ID = _require.ROOT_ID;
var _require2 = require("484cb66a6ef0ffa9"), VIEWER_ID = _require2.VIEWER_ID;
var ITERATOR_KEY = Symbol.iterator;
function hasSignificantOverlappingIDs(seenRecords, updatedRecordIDs) {
    var iterator = seenRecords[ITERATOR_KEY]();
    var next = iterator.next();
    while(!next.done){
        var key = next.value;
        if (updatedRecordIDs.has(key) && key !== ROOT_ID && key !== VIEWER_ID) return true;
        next = iterator.next();
    }
    return false;
}
module.exports = hasSignificantOverlappingIDs;

},{"58f1581f3785949d":"3QcrW","484cb66a6ef0ffa9":"i6PYa"}],"8vVqI":[function(require,module,exports,__globalThis) {
var global = arguments[3];
'use strict';
var _global$ErrorUtils$ap, _global$ErrorUtils;
var RelayRecordSourceMutator = require("bfd529e4a41ade2c");
var RelayRecordSourceProxy = require("d6caa5fe5bbd541f");
var RelayRecordSourceSelectorProxy = require("8a05b6ea0b9289f2");
var RelayFeatureFlags = require("282e6f2d23634148");
var RelayReader = require("9ac26e7470a958b5");
var RelayRecordSource = require("db9f9633773fc022");
var invariant = require("278061d7bbe08f7");
var warning = require("66f382df70fb6ae5");
var _global = typeof global !== 'undefined' ? global : typeof window !== 'undefined' ? window : undefined;
var applyWithGuard = (_global$ErrorUtils$ap = _global === null || _global === void 0 ? void 0 : (_global$ErrorUtils = _global.ErrorUtils) === null || _global$ErrorUtils === void 0 ? void 0 : _global$ErrorUtils.applyWithGuard) !== null && _global$ErrorUtils$ap !== void 0 ? _global$ErrorUtils$ap : function(callback, context, args, onError, name) {
    return callback.apply(context, args);
};
var RelayPublishQueue = /*#__PURE__*/ function() {
    function RelayPublishQueue(store, handlerProvider, getDataID, missingFieldHandlers, log) {
        this._hasStoreSnapshot = false;
        this._handlerProvider = handlerProvider || null;
        this._pendingBackupRebase = false;
        this._pendingData = new Set();
        this._pendingOptimisticUpdates = new Set();
        this._store = store;
        this._appliedOptimisticUpdates = new Set();
        this._gcHold = null;
        this._getDataID = getDataID;
        this._missingFieldHandlers = missingFieldHandlers;
        this._log = log;
    }
    var _proto = RelayPublishQueue.prototype;
    _proto.applyUpdate = function applyUpdate(updater) {
        !(!this._appliedOptimisticUpdates.has(updater) && !this._pendingOptimisticUpdates.has(updater)) && invariant(false);
        this._pendingOptimisticUpdates.add(updater);
    };
    _proto.revertUpdate = function revertUpdate(updater) {
        if (this._pendingOptimisticUpdates.has(updater)) this._pendingOptimisticUpdates["delete"](updater);
        else if (this._appliedOptimisticUpdates.has(updater)) {
            this._pendingBackupRebase = true;
            this._appliedOptimisticUpdates["delete"](updater);
        }
    };
    _proto.revertAll = function revertAll() {
        this._pendingBackupRebase = true;
        this._pendingOptimisticUpdates.clear();
        this._appliedOptimisticUpdates.clear();
    };
    _proto.commitPayload = function commitPayload(operation, payload, updater) {
        this._pendingBackupRebase = true;
        this._pendingData.add({
            kind: 'payload',
            operation: operation,
            payload: payload,
            updater: updater
        });
    };
    _proto.commitUpdate = function commitUpdate(updater) {
        this._pendingBackupRebase = true;
        this._pendingData.add({
            kind: 'updater',
            updater: updater
        });
    };
    _proto.commitSource = function commitSource(source) {
        this._pendingBackupRebase = true;
        this._pendingData.add({
            kind: 'source',
            source: source
        });
    };
    _proto.run = function run(sourceOperation) {
        var runWillClearGcHold = this._appliedOptimisticUpdates === 0 && !!this._gcHold;
        var runIsANoop = !this._pendingBackupRebase && this._pendingOptimisticUpdates.size === 0 && !runWillClearGcHold;
        RelayFeatureFlags.DISALLOW_NESTED_UPDATES && !(this._isRunning !== true) && invariant(false);
        this._isRunning = true;
        if (runIsANoop) {
            this._isRunning = false;
            return [];
        }
        if (this._pendingBackupRebase) {
            if (this._hasStoreSnapshot) {
                this._store.restore();
                this._hasStoreSnapshot = false;
            }
        }
        var invalidatedStore = this._commitData();
        if (this._pendingOptimisticUpdates.size || this._pendingBackupRebase && this._appliedOptimisticUpdates.size) {
            if (!this._hasStoreSnapshot) {
                this._store.snapshot();
                this._hasStoreSnapshot = true;
            }
            this._applyUpdates();
        }
        this._pendingBackupRebase = false;
        if (this._appliedOptimisticUpdates.size > 0) {
            if (!this._gcHold) this._gcHold = this._store.holdGC();
        } else if (this._gcHold) {
            this._gcHold.dispose();
            this._gcHold = null;
        }
        this._isRunning = false;
        return this._store.notify(sourceOperation, invalidatedStore);
    };
    _proto._publishSourceFromPayload = function _publishSourceFromPayload(pendingPayload) {
        var _this = this;
        var payload = pendingPayload.payload, operation = pendingPayload.operation, updater = pendingPayload.updater;
        var source = payload.source, fieldPayloads = payload.fieldPayloads;
        var mutator = new RelayRecordSourceMutator(this._store.getSource(), source);
        var recordSourceProxy = new RelayRecordSourceProxy(mutator, this._getDataID, this._handlerProvider, this._missingFieldHandlers, this._log);
        if (fieldPayloads && fieldPayloads.length) fieldPayloads.forEach(function(fieldPayload) {
            var handler = _this._handlerProvider && _this._handlerProvider(fieldPayload.handle);
            !handler && invariant(false);
            handler.update(recordSourceProxy, fieldPayload);
        });
        if (updater) {
            var selector = operation.fragment;
            !(selector != null) && invariant(false);
            var recordSourceSelectorProxy = new RelayRecordSourceSelectorProxy(mutator, recordSourceProxy, selector, this._missingFieldHandlers);
            var selectorData = lookupSelector(source, selector);
            updater(recordSourceSelectorProxy, selectorData);
        }
        var idsMarkedForInvalidation = recordSourceProxy.getIDsMarkedForInvalidation();
        this._store.publish(source, idsMarkedForInvalidation);
        return recordSourceProxy.isStoreMarkedForInvalidation();
    };
    _proto._commitData = function _commitData() {
        var _this2 = this;
        if (!this._pendingData.size) return false;
        var invalidatedStore = false;
        this._pendingData.forEach(function(data) {
            if (data.kind === 'payload') {
                var payloadInvalidatedStore = _this2._publishSourceFromPayload(data);
                invalidatedStore = invalidatedStore || payloadInvalidatedStore;
            } else if (data.kind === 'source') {
                var source = data.source;
                _this2._store.publish(source);
            } else {
                var updater = data.updater;
                var sink = RelayRecordSource.create();
                var mutator = new RelayRecordSourceMutator(_this2._store.getSource(), sink);
                var recordSourceProxy = new RelayRecordSourceProxy(mutator, _this2._getDataID, _this2._handlerProvider, _this2._missingFieldHandlers, _this2._log);
                applyWithGuard(updater, null, [
                    recordSourceProxy
                ], null, 'RelayPublishQueue:commitData');
                invalidatedStore = invalidatedStore || recordSourceProxy.isStoreMarkedForInvalidation();
                var idsMarkedForInvalidation = recordSourceProxy.getIDsMarkedForInvalidation();
                _this2._store.publish(sink, idsMarkedForInvalidation);
            }
        });
        this._pendingData.clear();
        return invalidatedStore;
    };
    _proto._applyUpdates = function _applyUpdates() {
        var _this3 = this;
        var sink = RelayRecordSource.create();
        var mutator = new RelayRecordSourceMutator(this._store.getSource(), sink);
        var recordSourceProxy = new RelayRecordSourceProxy(mutator, this._getDataID, this._handlerProvider, this._missingFieldHandlers, this._log);
        var processUpdate = function processUpdate(optimisticUpdate) {
            if (optimisticUpdate.storeUpdater) {
                var storeUpdater = optimisticUpdate.storeUpdater;
                applyWithGuard(storeUpdater, null, [
                    recordSourceProxy
                ], null, 'RelayPublishQueue:applyUpdates');
            } else {
                var operation = optimisticUpdate.operation, payload = optimisticUpdate.payload, updater = optimisticUpdate.updater;
                var source = payload.source, fieldPayloads = payload.fieldPayloads;
                if (source) recordSourceProxy.publishSource(source, fieldPayloads);
                if (updater) {
                    var selectorData;
                    if (source) selectorData = lookupSelector(source, operation.fragment);
                    var recordSourceSelectorProxy = new RelayRecordSourceSelectorProxy(mutator, recordSourceProxy, operation.fragment, _this3._missingFieldHandlers);
                    applyWithGuard(updater, null, [
                        recordSourceSelectorProxy,
                        selectorData
                    ], null, 'RelayPublishQueue:applyUpdates');
                }
            }
        };
        if (this._pendingBackupRebase && this._appliedOptimisticUpdates.size) this._appliedOptimisticUpdates.forEach(processUpdate);
        if (this._pendingOptimisticUpdates.size) {
            this._pendingOptimisticUpdates.forEach(function(optimisticUpdate) {
                processUpdate(optimisticUpdate);
                _this3._appliedOptimisticUpdates.add(optimisticUpdate);
            });
            this._pendingOptimisticUpdates.clear();
        }
        this._store.publish(sink);
    };
    return RelayPublishQueue;
}();
function lookupSelector(source, selector) {
    var selectorData = RelayReader.read(source, selector).data;
    var deepFreeze;
    return selectorData;
}
module.exports = RelayPublishQueue;

},{"bfd529e4a41ade2c":"kKEFB","d6caa5fe5bbd541f":"7OCKP","8a05b6ea0b9289f2":"aHyGd","282e6f2d23634148":"a0FL5","9ac26e7470a958b5":"hTh0M","db9f9633773fc022":"6w3KR","278061d7bbe08f7":"e2sci","66f382df70fb6ae5":"j64TH"}],"aHyGd":[function(require,module,exports,__globalThis) {
'use strict';
var _require = require("3525ecde8cb78a4"), ROOT_TYPE = _require.ROOT_TYPE, getStorageKey = _require.getStorageKey;
var _require2 = require("392cc4a3736ed13f"), _readUpdatableFragment = _require2.readUpdatableFragment;
var _require3 = require("ebf57ab694b79ffd"), _readUpdatableQuery = _require3.readUpdatableQuery;
var invariant = require("21796ae00adf6ce3");
var RelayRecordSourceSelectorProxy = /*#__PURE__*/ function() {
    function RelayRecordSourceSelectorProxy(mutator, recordSource, readSelector, missingFieldHandlers) {
        this.__mutator = mutator;
        this.__recordSource = recordSource;
        this._readSelector = readSelector;
        this._missingFieldHandlers = missingFieldHandlers;
    }
    var _proto = RelayRecordSourceSelectorProxy.prototype;
    _proto.create = function create(dataID, typeName) {
        return this.__recordSource.create(dataID, typeName);
    };
    _proto["delete"] = function _delete(dataID) {
        this.__recordSource["delete"](dataID);
    };
    _proto.get = function get(dataID) {
        return this.__recordSource.get(dataID);
    };
    _proto.getRoot = function getRoot() {
        return this.__recordSource.getRoot();
    };
    _proto.getOperationRoot = function getOperationRoot() {
        var root = this.__recordSource.get(this._readSelector.dataID);
        if (!root) root = this.__recordSource.create(this._readSelector.dataID, ROOT_TYPE);
        return root;
    };
    _proto._getRootField = function _getRootField(selector, fieldName, plural) {
        var field = selector.node.selections.find(function(selection) {
            return selection.kind === 'LinkedField' && selection.name === fieldName || selection.kind === 'RequiredField' && selection.field.name === fieldName;
        });
        if (field && field.kind === 'RequiredField') field = field.field;
        !(field && field.kind === 'LinkedField') && invariant(false);
        !(field.plural === plural) && invariant(false);
        return field;
    };
    _proto.getRootField = function getRootField(fieldName) {
        var field = this._getRootField(this._readSelector, fieldName, false);
        var storageKey = getStorageKey(field, this._readSelector.variables);
        return this.getOperationRoot().getLinkedRecord(storageKey);
    };
    _proto.getPluralRootField = function getPluralRootField(fieldName) {
        var field = this._getRootField(this._readSelector, fieldName, true);
        var storageKey = getStorageKey(field, this._readSelector.variables);
        return this.getOperationRoot().getLinkedRecords(storageKey);
    };
    _proto.invalidateStore = function invalidateStore() {
        this.__recordSource.invalidateStore();
    };
    _proto.readUpdatableQuery = function readUpdatableQuery(query, variables) {
        return _readUpdatableQuery(query, variables, this, this._missingFieldHandlers);
    };
    _proto.readUpdatableFragment = function readUpdatableFragment(fragment, fragmentReference) {
        return _readUpdatableFragment(fragment, fragmentReference, this, this._missingFieldHandlers);
    };
    return RelayRecordSourceSelectorProxy;
}();
module.exports = RelayRecordSourceSelectorProxy;

},{"3525ecde8cb78a4":"3QcrW","392cc4a3736ed13f":"oP4is","ebf57ab694b79ffd":"hphRe","21796ae00adf6ce3":"e2sci"}],"7OgOE":[function(require,module,exports,__globalThis) {
'use strict';
var RelayDeclarativeMutationConfig = require("f7be63ed7a4347a6");
var _require = require("c338a1a400b26ef4"), getRequest = _require.getRequest;
var _require2 = require("c86947abc2b5067e"), createOperationDescriptor = _require2.createOperationDescriptor;
var _require3 = require("5ee9d4b50d8dcebc"), createReaderSelector = _require3.createReaderSelector;
var warning = require("657ec1fdceb482e9");
function requestSubscription(environment, config) {
    var subscription = getRequest(config.subscription);
    if (subscription.params.operationKind !== 'subscription') throw new Error('requestSubscription: Must use Subscription operation');
    var configs = config.configs, onCompleted = config.onCompleted, onError = config.onError, onNext = config.onNext, variables = config.variables, cacheConfig = config.cacheConfig;
    var operation = createOperationDescriptor(subscription, variables, cacheConfig);
    var _ref = configs ? RelayDeclarativeMutationConfig.convert(configs, subscription, null, config.updater) : config, updater = _ref.updater;
    var sub = environment.executeSubscription({
        operation: operation,
        updater: updater
    }).subscribe({
        next: function next(responses) {
            if (onNext != null) {
                var selector = operation.fragment;
                var nextID;
                if (Array.isArray(responses)) {
                    var _responses$, _responses$$extension;
                    nextID = (_responses$ = responses[0]) === null || _responses$ === void 0 ? void 0 : (_responses$$extension = _responses$.extensions) === null || _responses$$extension === void 0 ? void 0 : _responses$$extension.__relay_subscription_root_id;
                } else {
                    var _responses$extensions;
                    nextID = (_responses$extensions = responses.extensions) === null || _responses$extensions === void 0 ? void 0 : _responses$extensions.__relay_subscription_root_id;
                }
                if (typeof nextID === 'string') selector = createReaderSelector(selector.node, nextID, selector.variables, selector.owner);
                var data = environment.lookup(selector).data;
                onNext(data);
            }
        },
        error: onError,
        complete: onCompleted
    });
    return {
        dispose: sub.unsubscribe
    };
}
module.exports = requestSubscription;

},{"f7be63ed7a4347a6":"1lmKe","c338a1a400b26ef4":"8UTII","c86947abc2b5067e":"dSeB3","5ee9d4b50d8dcebc":"9k2Dg","657ec1fdceb482e9":"j64TH"}],"7pZoN":[function(require,module,exports,__globalThis) {
'use strict';
var _interopRequireDefault = require("a92eeab200d64a8e")["default"];
var _objectSpread2 = _interopRequireDefault(require("ce63160f11945f09"));
var _require = require("ba8c3f062b9fefa3"), getModuleComponentKey = _require.getModuleComponentKey, getModuleOperationKey = _require.getModuleOperationKey;
function createPayloadFor3DField(name, operation, component, response) {
    var data = (0, _objectSpread2["default"])({}, response);
    data[getModuleComponentKey(name)] = component;
    data[getModuleOperationKey(name)] = operation;
    return data;
}
module.exports = createPayloadFor3DField;

},{"a92eeab200d64a8e":"590td","ce63160f11945f09":"2Bj1n","ba8c3f062b9fefa3":"3QcrW"}],"giGUC":[function(require,module,exports,__globalThis) {
'use strict';
var _require = require("417a7780e9c3d720"), getDataIDsFromFragment = _require.getDataIDsFromFragment, getSelector = _require.getSelector, getVariablesFromFragment = _require.getVariablesFromFragment;
var isEmptyObject = require("a07dea22d8b81663");
var RelayFeatureFlags = require("6027217066511b7");
var _require2 = require("221c854743cf59c0"), stableCopy = _require2.stableCopy;
var _require3 = require("9af55d9653e72871"), intern = _require3.intern;
function getFragmentIdentifier(fragmentNode, fragmentRef) {
    var selector = getSelector(fragmentNode, fragmentRef);
    var fragmentOwnerIdentifier = selector == null ? 'null' : selector.kind === 'SingularReaderSelector' ? selector.owner.identifier : '[' + selector.selectors.map(function(sel) {
        return sel.owner.identifier;
    }).join(',') + ']';
    var fragmentVariables = getVariablesFromFragment(fragmentNode, fragmentRef);
    var dataIDs = getDataIDsFromFragment(fragmentNode, fragmentRef);
    if (RelayFeatureFlags.ENABLE_GETFRAGMENTIDENTIFIER_OPTIMIZATION) {
        var ids = typeof dataIDs === 'undefined' ? 'missing' : dataIDs == null ? 'null' : Array.isArray(dataIDs) ? '[' + dataIDs.join(',') + ']' : dataIDs;
        ids = RelayFeatureFlags.STRING_INTERN_LEVEL <= 1 ? ids : intern(ids, RelayFeatureFlags.MAX_DATA_ID_LENGTH);
        return fragmentOwnerIdentifier + '/' + fragmentNode.name + '/' + (fragmentVariables == null || isEmptyObject(fragmentVariables) ? '{}' : JSON.stringify(stableCopy(fragmentVariables))) + '/' + ids;
    } else {
        var _JSON$stringify;
        var _ids = (_JSON$stringify = JSON.stringify(dataIDs)) !== null && _JSON$stringify !== void 0 ? _JSON$stringify : 'missing';
        _ids = RelayFeatureFlags.STRING_INTERN_LEVEL <= 1 ? _ids : intern(_ids, RelayFeatureFlags.MAX_DATA_ID_LENGTH);
        return fragmentOwnerIdentifier + '/' + fragmentNode.name + '/' + JSON.stringify(stableCopy(fragmentVariables)) + '/' + _ids;
    }
}
module.exports = getFragmentIdentifier;

},{"417a7780e9c3d720":"9k2Dg","a07dea22d8b81663":"3BR95","6027217066511b7":"a0FL5","221c854743cf59c0":"c3NLR","9af55d9653e72871":"3S1QY"}],"3BR95":[function(require,module,exports,__globalThis) {
'use strict';
var hasOwnProperty = Object.prototype.hasOwnProperty;
function isEmptyObject(obj) {
    for(var _key in obj){
        if (hasOwnProperty.call(obj, _key)) return false;
    }
    return true;
}
module.exports = isEmptyObject;

},{}],"idmUY":[function(require,module,exports,__globalThis) {
'use strict';
var getRefetchMetadata = require("27d61340cde3ecc4");
var invariant = require("7c0454ddee6ee684");
function getPaginationMetadata(fragmentNode, componentDisplayName) {
    var _fragmentNode$metadat, _fragmentNode$metadat2;
    var _getRefetchMetadata = getRefetchMetadata(fragmentNode, componentDisplayName), paginationRequest = _getRefetchMetadata.refetchableRequest, refetchMetadata = _getRefetchMetadata.refetchMetadata;
    var paginationMetadata = refetchMetadata.connection;
    !(paginationMetadata != null) && invariant(false);
    var connectionPathInFragmentData = paginationMetadata.path;
    var connectionMetadata = ((_fragmentNode$metadat = (_fragmentNode$metadat2 = fragmentNode.metadata) === null || _fragmentNode$metadat2 === void 0 ? void 0 : _fragmentNode$metadat2.connection) !== null && _fragmentNode$metadat !== void 0 ? _fragmentNode$metadat : [])[0];
    !(connectionMetadata != null) && invariant(false);
    var identifierInfo = refetchMetadata.identifierInfo;
    !((identifierInfo === null || identifierInfo === void 0 ? void 0 : identifierInfo.identifierField) == null || typeof identifierInfo.identifierField === 'string') && invariant(false);
    return {
        connectionPathInFragmentData: connectionPathInFragmentData,
        identifierField: identifierInfo === null || identifierInfo === void 0 ? void 0 : identifierInfo.identifierField,
        paginationRequest: paginationRequest,
        paginationMetadata: paginationMetadata,
        stream: connectionMetadata.stream === true
    };
}
module.exports = getPaginationMetadata;

},{"27d61340cde3ecc4":"5aHRx","7c0454ddee6ee684":"e2sci"}],"5aHRx":[function(require,module,exports,__globalThis) {
'use strict';
var invariant = require("12d1bea7081530");
function getRefetchMetadata(fragmentNode, componentDisplayName) {
    var _fragmentNode$metadat, _fragmentNode$metadat2;
    !(((_fragmentNode$metadat = fragmentNode.metadata) === null || _fragmentNode$metadat === void 0 ? void 0 : _fragmentNode$metadat.plural) !== true) && invariant(false);
    var refetchMetadata = (_fragmentNode$metadat2 = fragmentNode.metadata) === null || _fragmentNode$metadat2 === void 0 ? void 0 : _fragmentNode$metadat2.refetch;
    !(refetchMetadata != null) && invariant(false);
    var refetchableRequest = refetchMetadata.operation["default"] ? refetchMetadata.operation["default"] : refetchMetadata.operation;
    var fragmentRefPathInResponse = refetchMetadata.fragmentPathInResult;
    !(typeof refetchableRequest !== 'string') && invariant(false);
    var identifierInfo = refetchMetadata.identifierInfo;
    if (identifierInfo != null) {
        !(identifierInfo.identifierField == null || typeof identifierInfo.identifierField === 'string') && invariant(false);
        !(identifierInfo.identifierQueryVariableName == null || typeof identifierInfo.identifierQueryVariableName === 'string') && invariant(false);
    }
    return {
        fragmentRefPathInResponse: fragmentRefPathInResponse,
        identifierInfo: identifierInfo,
        refetchableRequest: refetchableRequest,
        refetchMetadata: refetchMetadata
    };
}
module.exports = getRefetchMetadata;

},{"12d1bea7081530":"e2sci"}],"f4llA":[function(require,module,exports,__globalThis) {
'use strict';
var _interopRequireDefault = require("5a32e5a1d4422f25")["default"];
var _defineProperty2 = _interopRequireDefault(require("f8d5174bc518aec8"));
var _objectSpread4 = _interopRequireDefault(require("24b7ed39a081f6d6"));
var invariant = require("e65a5dd0a68d69d8");
var warning = require("70c05a45ac29f7d0");
function getPaginationVariables(direction, count, cursor, baseVariables, extraVariables, paginationMetadata) {
    var _objectSpread3;
    var backwardMetadata = paginationMetadata.backward, forwardMetadata = paginationMetadata.forward;
    if (direction === 'backward') {
        var _objectSpread2;
        !(backwardMetadata != null && backwardMetadata.count != null && backwardMetadata.cursor != null) && invariant(false);
        var _paginationVariables = (0, _objectSpread4["default"])((0, _objectSpread4["default"])((0, _objectSpread4["default"])({}, baseVariables), extraVariables), {}, (_objectSpread2 = {}, (0, _defineProperty2["default"])(_objectSpread2, backwardMetadata.cursor, cursor), (0, _defineProperty2["default"])(_objectSpread2, backwardMetadata.count, count), _objectSpread2));
        if (forwardMetadata && forwardMetadata.cursor) _paginationVariables[forwardMetadata.cursor] = null;
        if (forwardMetadata && forwardMetadata.count) _paginationVariables[forwardMetadata.count] = null;
        return _paginationVariables;
    }
    !(forwardMetadata != null && forwardMetadata.count != null && forwardMetadata.cursor != null) && invariant(false);
    var paginationVariables = (0, _objectSpread4["default"])((0, _objectSpread4["default"])((0, _objectSpread4["default"])({}, baseVariables), extraVariables), {}, (_objectSpread3 = {}, (0, _defineProperty2["default"])(_objectSpread3, forwardMetadata.cursor, cursor), (0, _defineProperty2["default"])(_objectSpread3, forwardMetadata.count, count), _objectSpread3));
    if (backwardMetadata && backwardMetadata.cursor) paginationVariables[backwardMetadata.cursor] = null;
    if (backwardMetadata && backwardMetadata.count) paginationVariables[backwardMetadata.count] = null;
    return paginationVariables;
}
module.exports = getPaginationVariables;

},{"5a32e5a1d4422f25":"590td","f8d5174bc518aec8":"2paQ8","24b7ed39a081f6d6":"2Bj1n","e65a5dd0a68d69d8":"e2sci","70c05a45ac29f7d0":"j64TH"}],"6JAxU":[function(require,module,exports,__globalThis) {
'use strict';
var _interopRequireDefault = require("531f67bfa5115ab2")["default"];
var _createForOfIteratorHelper2 = _interopRequireDefault(require("d113ea0f914a3ecd"));
var invariant = require("f30658fe03c1247c");
function getValueAtPath(data, path) {
    var result = data;
    var _iterator = (0, _createForOfIteratorHelper2["default"])(path), _step;
    try {
        for(_iterator.s(); !(_step = _iterator.n()).done;){
            var key = _step.value;
            if (result == null) return null;
            if (typeof key === 'number') {
                !Array.isArray(result) && invariant(false);
                result = result[key];
            } else {
                !(typeof result === 'object' && !Array.isArray(result)) && invariant(false);
                result = result[key];
            }
        }
    } catch (err) {
        _iterator.e(err);
    } finally{
        _iterator.f();
    }
    return result;
}
module.exports = getValueAtPath;

},{"531f67bfa5115ab2":"590td","d113ea0f914a3ecd":"fMaLa","f30658fe03c1247c":"e2sci"}],"j0ygY":[function(require,module,exports,__globalThis) {
'use strict';
var profileHandlersByName = {};
var defaultProfiler = {
    stop: function stop() {}
};
var RelayProfiler = {
    profile: function profile(name, state) {
        var handlers = profileHandlersByName[name];
        if (handlers && handlers.length > 0) {
            var stopHandlers = [];
            for(var ii = handlers.length - 1; ii >= 0; ii--){
                var stopHandler = handlers[ii](name, state);
                stopHandlers.unshift(stopHandler);
            }
            return {
                stop: function stop(error) {
                    stopHandlers.forEach(function(stopHandler) {
                        return stopHandler(error);
                    });
                }
            };
        }
        return defaultProfiler;
    },
    attachProfileHandler: function attachProfileHandler(name, handler) {
        if (!profileHandlersByName.hasOwnProperty(name)) profileHandlersByName[name] = [];
        profileHandlersByName[name].push(handler);
    },
    detachProfileHandler: function detachProfileHandler(name, handler) {
        if (profileHandlersByName.hasOwnProperty(name)) removeFromArray(profileHandlersByName[name], handler);
    }
};
function removeFromArray(array, element) {
    var index = array.indexOf(element);
    if (index !== -1) array.splice(index, 1);
}
module.exports = RelayProfiler;

},{}],"ds2RZ":[function(require,module,exports,__globalThis) {
'use strict';
var _interopRequireDefault = require("a1754e095446dd2b")["default"];
var _extends2 = _interopRequireDefault(require("d2dbaebb2768fd4e"));
var _objectWithoutPropertiesLoose2 = _interopRequireDefault(require("cda2acd43f202955"));
var _assertThisInitialized2 = _interopRequireDefault(require("6f63235672421dfc"));
var _inheritsLoose2 = _interopRequireDefault(require("f1bdf22fe5f7cf72"));
var _defineProperty2 = _interopRequireDefault(require("7ee058b362ace828"));
var _excluded = [
    "componentRef",
    "__relayContext",
    "__rootIsQueryRenderer"
];
var buildReactRelayContainer = require("9bfe78da60564f11");
var _require = require("8439d55d54328740"), getContainerName = _require.getContainerName;
var _require2 = require("54bdad3c4dc4cd71"), assertRelayContext = _require2.assertRelayContext;
var areEqual = require("63f715741e764d2e");
var React = require("f7a484ce88430d3a");
var _require3 = require("219f2a01cc9728d6"), createFragmentSpecResolver = _require3.createFragmentSpecResolver, getDataIDsFromObject = _require3.getDataIDsFromObject, isScalarAndEqual = _require3.isScalarAndEqual;
function createContainerWithFragments(Component, fragments) {
    var _class;
    var containerName = getContainerName(Component);
    return _class = /*#__PURE__*/ function(_React$Component) {
        (0, _inheritsLoose2["default"])(_class, _React$Component);
        function _class(props) {
            var _props$__rootIsQueryR, _this;
            _this = _React$Component.call(this, props) || this;
            (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "_handleFragmentDataUpdate", function() {
                var resolverFromThisUpdate = _this.state.resolver;
                _this.setState(function(updatedState) {
                    return resolverFromThisUpdate === updatedState.resolver ? {
                        data: updatedState.resolver.resolve(),
                        relayProp: getRelayProp(updatedState.relayProp.environment)
                    } : null;
                });
            });
            var relayContext = assertRelayContext(props.__relayContext);
            var rootIsQueryRenderer = (_props$__rootIsQueryR = props.__rootIsQueryRenderer) !== null && _props$__rootIsQueryR !== void 0 ? _props$__rootIsQueryR : false;
            var resolver = createFragmentSpecResolver(relayContext, containerName, fragments, props, rootIsQueryRenderer);
            _this.state = {
                data: resolver.resolve(),
                prevProps: props,
                prevPropsContext: relayContext,
                relayProp: getRelayProp(relayContext.environment),
                resolver: resolver
            };
            return _this;
        }
        _class.getDerivedStateFromProps = function getDerivedStateFromProps(nextProps, prevState) {
            var _nextProps$__rootIsQu;
            var prevProps = prevState.prevProps;
            var relayContext = assertRelayContext(nextProps.__relayContext);
            var rootIsQueryRenderer = (_nextProps$__rootIsQu = nextProps.__rootIsQueryRenderer) !== null && _nextProps$__rootIsQu !== void 0 ? _nextProps$__rootIsQu : false;
            var prevIDs = getDataIDsFromObject(fragments, prevProps);
            var nextIDs = getDataIDsFromObject(fragments, nextProps);
            var resolver = prevState.resolver;
            if (prevState.prevPropsContext.environment !== relayContext.environment || !areEqual(prevIDs, nextIDs)) {
                resolver = createFragmentSpecResolver(relayContext, containerName, fragments, nextProps, rootIsQueryRenderer);
                return {
                    data: resolver.resolve(),
                    prevPropsContext: relayContext,
                    prevProps: nextProps,
                    relayProp: getRelayProp(relayContext.environment),
                    resolver: resolver
                };
            } else {
                resolver.setProps(nextProps);
                var data = resolver.resolve();
                if (data !== prevState.data) return {
                    data: data,
                    prevProps: nextProps,
                    prevPropsContext: relayContext,
                    relayProp: getRelayProp(relayContext.environment)
                };
            }
            return null;
        };
        var _proto = _class.prototype;
        _proto.componentDidMount = function componentDidMount() {
            this._subscribeToNewResolverAndRerenderIfStoreHasChanged();
        };
        _proto.componentDidUpdate = function componentDidUpdate(prevProps, prevState) {
            if (this.state.resolver !== prevState.resolver) {
                prevState.resolver.dispose();
                this._subscribeToNewResolverAndRerenderIfStoreHasChanged();
            } else this._rerenderIfStoreHasChanged();
        };
        _proto.componentWillUnmount = function componentWillUnmount() {
            this.state.resolver.dispose();
        };
        _proto.shouldComponentUpdate = function shouldComponentUpdate(nextProps, nextState) {
            if (nextState.data !== this.state.data) return true;
            var keys = Object.keys(nextProps);
            for(var ii = 0; ii < keys.length; ii++){
                var key = keys[ii];
                if (key === '__relayContext') {
                    if (nextState.prevPropsContext.environment !== this.state.prevPropsContext.environment) return true;
                } else {
                    if (!fragments.hasOwnProperty(key) && !isScalarAndEqual(nextProps[key], this.props[key])) return true;
                }
            }
            return false;
        };
        _proto._rerenderIfStoreHasChanged = function _rerenderIfStoreHasChanged() {
            var _this$state = this.state, data = _this$state.data, resolver = _this$state.resolver;
            var maybeNewData = resolver.resolve();
            if (data !== maybeNewData) this.setState({
                data: maybeNewData
            });
        };
        _proto._subscribeToNewResolverAndRerenderIfStoreHasChanged = function _subscribeToNewResolverAndRerenderIfStoreHasChanged() {
            var _this$state2 = this.state, data = _this$state2.data, resolver = _this$state2.resolver;
            var maybeNewData = resolver.resolve();
            resolver.setCallback(this.props, this._handleFragmentDataUpdate);
            if (data !== maybeNewData) this.setState({
                data: maybeNewData
            });
        };
        _proto.render = function render() {
            var _this$props = this.props, componentRef = _this$props.componentRef, __relayContext = _this$props.__relayContext, __rootIsQueryRenderer = _this$props.__rootIsQueryRenderer, props = (0, _objectWithoutPropertiesLoose2["default"])(_this$props, _excluded);
            return /*#__PURE__*/ React.createElement(Component, (0, _extends2["default"])({}, props, this.state.data, {
                ref: componentRef,
                relay: this.state.relayProp
            }));
        };
        return _class;
    }(React.Component), (0, _defineProperty2["default"])(_class, "displayName", containerName), _class;
}
function getRelayProp(environment) {
    return {
        environment: environment
    };
}
function createContainer(Component, fragmentSpec) {
    return buildReactRelayContainer(Component, fragmentSpec, createContainerWithFragments);
}
module.exports = {
    createContainer: createContainer
};

},{"a1754e095446dd2b":"590td","d2dbaebb2768fd4e":"ehKSH","cda2acd43f202955":"fkx57","6f63235672421dfc":"k1uP3","f1bdf22fe5f7cf72":"idPlQ","7ee058b362ace828":"2paQ8","9bfe78da60564f11":"hPnUw","8439d55d54328740":"7AyFT","54bdad3c4dc4cd71":"cZlGo","63f715741e764d2e":"eJLuG","f7a484ce88430d3a":"ltHCL","219f2a01cc9728d6":"2IxFR"}],"ehKSH":[function(require,module,exports,__globalThis) {
function _extends() {
    return module.exports = _extends = Object.assign ? Object.assign.bind() : function(n) {
        for(var e = 1; e < arguments.length; e++){
            var t = arguments[e];
            for(var r in t)({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
        }
        return n;
    }, module.exports.__esModule = true, module.exports["default"] = module.exports, _extends.apply(null, arguments);
}
module.exports = _extends, module.exports.__esModule = true, module.exports["default"] = module.exports;

},{}],"k1uP3":[function(require,module,exports,__globalThis) {
function _assertThisInitialized(e) {
    if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    return e;
}
module.exports = _assertThisInitialized, module.exports.__esModule = true, module.exports["default"] = module.exports;

},{}],"idPlQ":[function(require,module,exports,__globalThis) {
var setPrototypeOf = require("b4ce3152cb163aa8");
function _inheritsLoose(t, o) {
    t.prototype = Object.create(o.prototype), t.prototype.constructor = t, setPrototypeOf(t, o);
}
module.exports = _inheritsLoose, module.exports.__esModule = true, module.exports["default"] = module.exports;

},{"b4ce3152cb163aa8":"57E4d"}],"57E4d":[function(require,module,exports,__globalThis) {
function _setPrototypeOf(t, e) {
    return module.exports = _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function(t, e) {
        return t.__proto__ = e, t;
    }, module.exports.__esModule = true, module.exports["default"] = module.exports, _setPrototypeOf(t, e);
}
module.exports = _setPrototypeOf, module.exports.__esModule = true, module.exports["default"] = module.exports;

},{}],"hPnUw":[function(require,module,exports,__globalThis) {
'use strict';
var _interopRequireDefault = require("aef4a255ec60fb2b")["default"];
var _extends2 = _interopRequireDefault(require("b34e40963b115137"));
var assertFragmentMap = require("9e42a6a2b539f78e");
var _require = require("a4195b13ed1624dc"), getComponentName = _require.getComponentName, getContainerName = _require.getContainerName;
var ReactRelayContext = require("415c0a8bc10f8597");
var ReactRelayQueryRendererContext = require("b204f94aa50ac707");
var invariant = require("d798a86a29f44673");
var React = require("21aac5e17e156ef0");
var _require2 = require("eb347163a35ea7a3"), getFragment = _require2.getFragment;
var useContext = React.useContext;
function buildReactRelayContainer(ComponentClass, fragmentSpec, createContainerWithFragments) {
    var containerName = getContainerName(ComponentClass);
    assertFragmentMap(getComponentName(ComponentClass), fragmentSpec);
    var fragments = {};
    for(var key in fragmentSpec)fragments[key] = getFragment(fragmentSpec[key]);
    var Container = createContainerWithFragments(ComponentClass, fragments);
    Container.displayName = containerName;
    function ForwardRef(props, ref) {
        var _queryRendererContext;
        var context = useContext(ReactRelayContext);
        !(context != null) && invariant(false);
        var queryRendererContext = useContext(ReactRelayQueryRendererContext);
        return /*#__PURE__*/ React.createElement(Container, (0, _extends2["default"])({}, props, {
            __relayContext: context,
            __rootIsQueryRenderer: (_queryRendererContext = queryRendererContext === null || queryRendererContext === void 0 ? void 0 : queryRendererContext.rootIsQueryRenderer) !== null && _queryRendererContext !== void 0 ? _queryRendererContext : false,
            componentRef: props.componentRef || ref
        }));
    }
    ForwardRef.displayName = containerName;
    var ForwardContainer = React.forwardRef(ForwardRef);
    return ForwardContainer;
}
module.exports = buildReactRelayContainer;

},{"aef4a255ec60fb2b":"590td","b34e40963b115137":"ehKSH","9e42a6a2b539f78e":"cm8z5","a4195b13ed1624dc":"7AyFT","415c0a8bc10f8597":"7NW2h","b204f94aa50ac707":"8JS6r","d798a86a29f44673":"e2sci","21aac5e17e156ef0":"ltHCL","eb347163a35ea7a3":"2IxFR"}],"cm8z5":[function(require,module,exports,__globalThis) {
'use strict';
var invariant = require("c5623a04fc3ed769");
function assertFragmentMap(componentName, fragmentSpec) {
    !(fragmentSpec && typeof fragmentSpec === 'object') && invariant(false);
    for(var key in fragmentSpec)if (fragmentSpec.hasOwnProperty(key)) {
        var fragment = fragmentSpec[key];
        !(fragment && (typeof fragment === 'object' || typeof fragment === 'function')) && invariant(false);
    }
}
module.exports = assertFragmentMap;

},{"c5623a04fc3ed769":"e2sci"}],"7AyFT":[function(require,module,exports,__globalThis) {
'use strict';
function getComponentName(component) {
    return component.displayName || component.name || 'Component';
}
function getContainerName(Component) {
    return 'Relay(' + getComponentName(Component) + ')';
}
module.exports = {
    getComponentName: getComponentName,
    getContainerName: getContainerName
};

},{}],"8JS6r":[function(require,module,exports,__globalThis) {
'use strict';
var React = require("58bf434f385e0327");
module.exports = React.createContext({
    rootIsQueryRenderer: false
});

},{"58bf434f385e0327":"ltHCL"}],"cZlGo":[function(require,module,exports,__globalThis) {
'use strict';
var isRelayEnvironment = require("fe19a6b7a040a0df");
var invariant = require("980e8201bfb23cac");
function assertRelayContext(relay) {
    !isRelayContext(relay) && invariant(false);
    return relay;
}
function isRelayContext(context) {
    return typeof context === 'object' && context !== null && !Array.isArray(context) && isRelayEnvironment(context.environment);
}
module.exports = {
    assertRelayContext: assertRelayContext,
    isRelayContext: isRelayContext
};

},{"fe19a6b7a040a0df":"9w8gW","980e8201bfb23cac":"e2sci"}],"9w8gW":[function(require,module,exports,__globalThis) {
'use strict';
function isRelayEnvironment(environment) {
    return typeof environment === 'object' && environment !== null && typeof environment.check === 'function' && typeof environment.lookup === 'function' && typeof environment.retain === 'function' && typeof environment.execute === 'function' && typeof environment.subscribe === 'function';
}
module.exports = isRelayEnvironment;

},{}],"33cI7":[function(require,module,exports,__globalThis) {
'use strict';
var ReactRelayContext = require("17bdd7b8097df87e");
var ReactRelayQueryRendererContext = require("f04c8fecd16407ea");
var areEqual = require("c903ee88a7ecd95c");
var React = require("6d3a8d9b0216b4de");
var _require = require("381bc9cc2d409827"), createOperationDescriptor = _require.createOperationDescriptor, deepFreeze = _require.deepFreeze, getRequest = _require.getRequest;
var useLayoutEffect = React.useLayoutEffect, useState = React.useState, useRef = React.useRef, useMemo = React.useMemo;
var queryRendererContext = {
    rootIsQueryRenderer: true
};
function useDeepCompare(value) {
    var latestValue = React.useRef(value);
    if (!areEqual(latestValue.current, value)) latestValue.current = value;
    return latestValue.current;
}
function ReactRelayLocalQueryRenderer(props) {
    var environment = props.environment, query = props.query, variables = props.variables, render = props.render;
    var latestVariables = useDeepCompare(variables);
    var operation = useMemo(function() {
        var request = getRequest(query);
        return createOperationDescriptor(request, latestVariables);
    }, [
        query,
        latestVariables
    ]);
    var relayContext = useMemo(function() {
        return {
            environment: environment
        };
    }, [
        environment
    ]);
    var dataRef = useRef(null);
    var _useState = useState(null), forceUpdate = _useState[1];
    var cleanupFnRef = useRef(null);
    var snapshot = useMemo(function() {
        environment.check(operation);
        var res = environment.lookup(operation.fragment);
        dataRef.current = res.data;
        var retainDisposable = environment.retain(operation);
        var subscribeDisposable = environment.subscribe(res, function(newSnapshot) {
            dataRef.current = newSnapshot.data;
            forceUpdate(dataRef.current);
        });
        var disposed = false;
        function nextCleanupFn() {
            if (!disposed) {
                disposed = true;
                cleanupFnRef.current = null;
                retainDisposable.dispose();
                subscribeDisposable.dispose();
            }
        }
        if (cleanupFnRef.current) cleanupFnRef.current();
        cleanupFnRef.current = nextCleanupFn;
        return res;
    }, [
        environment,
        operation
    ]);
    useLayoutEffect(function() {
        var cleanupFn = cleanupFnRef.current;
        return function() {
            cleanupFn && cleanupFn();
        };
    }, [
        snapshot
    ]);
    return /*#__PURE__*/ React.createElement(ReactRelayContext.Provider, {
        value: relayContext
    }, /*#__PURE__*/ React.createElement(ReactRelayQueryRendererContext.Provider, {
        value: queryRendererContext
    }, render({
        props: dataRef.current
    })));
}
module.exports = ReactRelayLocalQueryRenderer;

},{"17bdd7b8097df87e":"7NW2h","f04c8fecd16407ea":"8JS6r","c903ee88a7ecd95c":"eJLuG","6d3a8d9b0216b4de":"ltHCL","381bc9cc2d409827":"2IxFR"}],"eYnmn":[function(require,module,exports,__globalThis) {
'use strict';
var _interopRequireDefault = require("6e6e7ed4afa8612d")["default"];
var _extends2 = _interopRequireDefault(require("918810cde5ad6fe0"));
var _objectWithoutPropertiesLoose2 = _interopRequireDefault(require("3cd79c67fa980491"));
var _assertThisInitialized2 = _interopRequireDefault(require("cd7a7ac1ae1e3ffd"));
var _inheritsLoose2 = _interopRequireDefault(require("4cc5ead00e406c73"));
var _defineProperty2 = _interopRequireDefault(require("a237a7825c97b226"));
var _objectSpread3 = _interopRequireDefault(require("287756abeafdedc8"));
var _excluded = [
    "componentRef"
], _excluded2 = [
    "componentRef",
    "__relayContext",
    "__rootIsQueryRenderer"
], _excluded3 = [
    "componentRef",
    "__relayContext",
    "__rootIsQueryRenderer"
];
var buildReactRelayContainer = require("a8a738316d365cfb");
var getRootVariablesForFragments = require("91c455e00e6a2238");
var _require = require("43d7443ac887d1b3"), getComponentName = _require.getComponentName, getContainerName = _require.getContainerName;
var ReactRelayContext = require("f2b31ff1102bf794");
var ReactRelayQueryFetcher = require("74dd7b526c3f03e4");
var _require2 = require("3c07bd80314624a6"), assertRelayContext = _require2.assertRelayContext;
var areEqual = require("11f996824ce1804e");
var invariant = require("f7248b901251f99d");
var React = require("b12828d89a8ae0e3");
var _require3 = require("e57e7b0f63883a80"), ConnectionInterface = _require3.ConnectionInterface, Observable = _require3.Observable, RelayFeatureFlags = _require3.RelayFeatureFlags, createFragmentSpecResolver = _require3.createFragmentSpecResolver, createOperationDescriptor = _require3.createOperationDescriptor, getDataIDsFromObject = _require3.getDataIDsFromObject, getRequest = _require3.getRequest, getVariablesFromObject = _require3.getVariablesFromObject, isScalarAndEqual = _require3.isScalarAndEqual;
var warning = require("15dd5cec7e06344");
var FORWARD = 'forward';
function createGetConnectionFromProps(metadata) {
    var path = metadata.path;
    !path && invariant(false);
    return function(props) {
        var data = props[metadata.fragmentName];
        for(var i = 0; i < path.length; i++){
            if (!data || typeof data !== 'object') return null;
            data = data[path[i]];
        }
        return data;
    };
}
function createGetFragmentVariables(metadata) {
    var countVariable = metadata.count;
    !countVariable && invariant(false);
    return function(prevVars, totalCount) {
        return (0, _objectSpread3["default"])((0, _objectSpread3["default"])({}, prevVars), {}, (0, _defineProperty2["default"])({}, countVariable, totalCount));
    };
}
function findConnectionMetadata(fragments) {
    var foundConnectionMetadata = null;
    var isRelayModern = false;
    for(var fragmentName in fragments){
        var fragment = fragments[fragmentName];
        var connectionMetadata = fragment.metadata && fragment.metadata.connection;
        if (fragment.metadata !== undefined) isRelayModern = true;
        if (connectionMetadata) {
            !(connectionMetadata.length === 1) && invariant(false);
            !!foundConnectionMetadata && invariant(false);
            foundConnectionMetadata = (0, _objectSpread3["default"])((0, _objectSpread3["default"])({}, connectionMetadata[0]), {}, {
                fragmentName: fragmentName
            });
        }
    }
    !(!isRelayModern || foundConnectionMetadata !== null) && invariant(false);
    return foundConnectionMetadata || {};
}
function toObserver(observerOrCallback) {
    return typeof observerOrCallback === 'function' ? {
        error: observerOrCallback,
        complete: observerOrCallback,
        unsubscribe: function unsubscribe(subscription) {
            typeof observerOrCallback === 'function' && observerOrCallback();
        }
    } : observerOrCallback || {};
}
function createContainerWithFragments(Component, fragments, connectionConfig) {
    var _class;
    var componentName = getComponentName(Component);
    var containerName = getContainerName(Component);
    var metadata = findConnectionMetadata(fragments);
    var getConnectionFromProps = connectionConfig.getConnectionFromProps || createGetConnectionFromProps(metadata);
    var direction = connectionConfig.direction || metadata.direction;
    !direction && invariant(false);
    var getFragmentVariables = connectionConfig.getFragmentVariables || createGetFragmentVariables(metadata);
    return _class = /*#__PURE__*/ function(_React$Component) {
        (0, _inheritsLoose2["default"])(_class, _React$Component);
        function _class(props) {
            var _props$__rootIsQueryR, _this;
            _this = _React$Component.call(this, props) || this;
            (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "_handleFragmentDataUpdate", function() {
                _this.setState({
                    data: _this._resolver.resolve()
                });
            });
            (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "_hasMore", function() {
                var connectionData = _this._getConnectionData();
                return !!(connectionData && connectionData.hasMore && connectionData.cursor);
            });
            (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "_isLoading", function() {
                return !!_this._refetchSubscription;
            });
            (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "_refetchConnection", function(totalCount, observerOrCallback, refetchVariables) {
                if (!_this._canFetchPage('refetchConnection')) return {
                    dispose: function dispose() {}
                };
                _this._refetchVariables = refetchVariables;
                var paginatingVariables = {
                    count: totalCount,
                    cursor: null,
                    totalCount: totalCount
                };
                var fetch = _this._fetchPage(paginatingVariables, toObserver(observerOrCallback), {
                    force: true
                });
                return {
                    dispose: fetch.unsubscribe
                };
            });
            (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "_loadMore", function(pageSize, observerOrCallback, options) {
                if (!_this._canFetchPage('loadMore')) return {
                    dispose: function dispose() {}
                };
                var observer = toObserver(observerOrCallback);
                var connectionData = _this._getConnectionData();
                if (!connectionData) {
                    Observable.create(function(sink) {
                        return sink.complete();
                    }).subscribe(observer);
                    return null;
                }
                var totalCount = connectionData.edgeCount + pageSize;
                if (options && options.force) return _this._refetchConnection(totalCount, observerOrCallback);
                var _ConnectionInterface$ = ConnectionInterface.get(), END_CURSOR = _ConnectionInterface$.END_CURSOR, START_CURSOR = _ConnectionInterface$.START_CURSOR;
                var cursor = connectionData.cursor;
                var paginatingVariables = {
                    count: pageSize,
                    cursor: cursor,
                    totalCount: totalCount
                };
                var fetch = _this._fetchPage(paginatingVariables, observer, options);
                return {
                    dispose: fetch.unsubscribe
                };
            });
            var relayContext = assertRelayContext(props.__relayContext);
            var rootIsQueryRenderer = (_props$__rootIsQueryR = props.__rootIsQueryRenderer) !== null && _props$__rootIsQueryR !== void 0 ? _props$__rootIsQueryR : false;
            _this._isARequestInFlight = false;
            _this._refetchSubscription = null;
            _this._refetchVariables = null;
            if (RelayFeatureFlags.ENABLE_CONTAINERS_SUBSCRIBE_ON_COMMIT === true) _this._resolver = createFragmentSpecResolver(relayContext, containerName, fragments, props, rootIsQueryRenderer);
            else _this._resolver = createFragmentSpecResolver(relayContext, containerName, fragments, props, rootIsQueryRenderer, _this._handleFragmentDataUpdate);
            _this.state = {
                data: _this._resolver.resolve(),
                prevContext: relayContext,
                contextForChildren: relayContext,
                relayProp: _this._buildRelayProp(relayContext),
                resolverGeneration: 0
            };
            _this._isUnmounted = false;
            _this._hasFetched = false;
            return _this;
        }
        var _proto = _class.prototype;
        _proto.componentDidMount = function componentDidMount() {
            this._isUnmounted = false;
            if (RelayFeatureFlags.ENABLE_CONTAINERS_SUBSCRIBE_ON_COMMIT === true) this._subscribeToNewResolverAndRerenderIfStoreHasChanged();
        };
        _proto.componentDidUpdate = function componentDidUpdate(prevProps, prevState) {
            if (RelayFeatureFlags.ENABLE_CONTAINERS_SUBSCRIBE_ON_COMMIT === true) {
                if (prevState.resolverGeneration !== this.state.resolverGeneration) this._subscribeToNewResolverAndRerenderIfStoreHasChanged();
                else this._rerenderIfStoreHasChanged();
            }
        };
        _proto.UNSAFE_componentWillReceiveProps = function UNSAFE_componentWillReceiveProps(nextProps) {
            var _this2 = this;
            var _nextProps$__rootIsQu;
            var relayContext = assertRelayContext(nextProps.__relayContext);
            var rootIsQueryRenderer = (_nextProps$__rootIsQu = nextProps.__rootIsQueryRenderer) !== null && _nextProps$__rootIsQu !== void 0 ? _nextProps$__rootIsQu : false;
            var prevIDs = getDataIDsFromObject(fragments, this.props);
            var nextIDs = getDataIDsFromObject(fragments, nextProps);
            var prevRootVariables = getRootVariablesForFragments(fragments, this.props);
            var nextRootVariables = getRootVariablesForFragments(fragments, nextProps);
            if (relayContext.environment !== this.state.prevContext.environment || !areEqual(prevRootVariables, nextRootVariables) || !areEqual(prevIDs, nextIDs)) {
                this._cleanup();
                if (RelayFeatureFlags.ENABLE_CONTAINERS_SUBSCRIBE_ON_COMMIT === true) this._resolver = createFragmentSpecResolver(relayContext, containerName, fragments, nextProps, rootIsQueryRenderer);
                else this._resolver = createFragmentSpecResolver(relayContext, containerName, fragments, nextProps, rootIsQueryRenderer, this._handleFragmentDataUpdate);
                this.setState(function(prevState) {
                    return {
                        prevContext: relayContext,
                        contextForChildren: relayContext,
                        relayProp: _this2._buildRelayProp(relayContext),
                        resolverGeneration: prevState.resolverGeneration + 1
                    };
                });
            } else if (!this._hasFetched) this._resolver.setProps(nextProps);
            var data = this._resolver.resolve();
            if (data !== this.state.data) this.setState({
                data: data
            });
        };
        _proto.componentWillUnmount = function componentWillUnmount() {
            this._isUnmounted = true;
            this._cleanup();
        };
        _proto.shouldComponentUpdate = function shouldComponentUpdate(nextProps, nextState) {
            if (nextState.data !== this.state.data || nextState.relayProp !== this.state.relayProp || nextState.resolverGeneration !== this.state.resolverGeneration) return true;
            var keys = Object.keys(nextProps);
            for(var ii = 0; ii < keys.length; ii++){
                var key = keys[ii];
                if (key === '__relayContext') {
                    if (nextState.prevContext.environment !== this.state.prevContext.environment) return true;
                } else {
                    if (!fragments.hasOwnProperty(key) && !isScalarAndEqual(nextProps[key], this.props[key])) return true;
                }
            }
            return false;
        };
        _proto._buildRelayProp = function _buildRelayProp(relayContext) {
            return {
                hasMore: this._hasMore,
                isLoading: this._isLoading,
                loadMore: this._loadMore,
                refetchConnection: this._refetchConnection,
                environment: relayContext.environment
            };
        };
        _proto._rerenderIfStoreHasChanged = function _rerenderIfStoreHasChanged() {
            var data = this.state.data;
            var maybeNewData = this._resolver.resolve();
            if (data !== maybeNewData) this.setState({
                data: maybeNewData
            });
        };
        _proto._subscribeToNewResolverAndRerenderIfStoreHasChanged = function _subscribeToNewResolverAndRerenderIfStoreHasChanged() {
            var data = this.state.data;
            var maybeNewData = this._resolver.resolve();
            this._resolver.setCallback(this.props, this._handleFragmentDataUpdate);
            if (data !== maybeNewData) this.setState({
                data: maybeNewData
            });
        };
        _proto._getConnectionData = function _getConnectionData() {
            var _this$props = this.props, _ = _this$props.componentRef, restProps = (0, _objectWithoutPropertiesLoose2["default"])(_this$props, _excluded);
            var props = (0, _objectSpread3["default"])((0, _objectSpread3["default"])({}, restProps), this.state.data);
            var connectionData = getConnectionFromProps(props);
            if (connectionData == null) return null;
            var _ConnectionInterface$2 = ConnectionInterface.get(), EDGES = _ConnectionInterface$2.EDGES, PAGE_INFO = _ConnectionInterface$2.PAGE_INFO, HAS_NEXT_PAGE = _ConnectionInterface$2.HAS_NEXT_PAGE, HAS_PREV_PAGE = _ConnectionInterface$2.HAS_PREV_PAGE, END_CURSOR = _ConnectionInterface$2.END_CURSOR, START_CURSOR = _ConnectionInterface$2.START_CURSOR;
            !(typeof connectionData === 'object') && invariant(false);
            var edges = connectionData[EDGES];
            var pageInfo = connectionData[PAGE_INFO];
            if (edges == null || pageInfo == null) return null;
            !Array.isArray(edges) && invariant(false);
            !(typeof pageInfo === 'object') && invariant(false);
            var hasMore = direction === FORWARD ? pageInfo[HAS_NEXT_PAGE] : pageInfo[HAS_PREV_PAGE];
            var cursor = direction === FORWARD ? pageInfo[END_CURSOR] : pageInfo[START_CURSOR];
            if (typeof hasMore !== 'boolean' || edges.length !== 0 && typeof cursor === 'undefined') return null;
            return {
                cursor: cursor,
                edgeCount: edges.length,
                hasMore: hasMore
            };
        };
        _proto._getQueryFetcher = function _getQueryFetcher() {
            if (!this._queryFetcher) this._queryFetcher = new ReactRelayQueryFetcher();
            return this._queryFetcher;
        };
        _proto._canFetchPage = function _canFetchPage(method) {
            if (this._isUnmounted) return false;
            return true;
        };
        _proto._fetchPage = function _fetchPage(paginatingVariables, observer, options) {
            var _this3 = this;
            var _assertRelayContext = assertRelayContext(this.props.__relayContext), environment = _assertRelayContext.environment;
            var _this$props2 = this.props, _ = _this$props2.componentRef, __relayContext = _this$props2.__relayContext, __rootIsQueryRenderer = _this$props2.__rootIsQueryRenderer, restProps = (0, _objectWithoutPropertiesLoose2["default"])(_this$props2, _excluded2);
            var props = (0, _objectSpread3["default"])((0, _objectSpread3["default"])({}, restProps), this.state.data);
            var fragmentVariables;
            var rootVariables = getRootVariablesForFragments(fragments, restProps);
            fragmentVariables = getVariablesFromObject(fragments, restProps);
            fragmentVariables = (0, _objectSpread3["default"])((0, _objectSpread3["default"])((0, _objectSpread3["default"])({}, rootVariables), fragmentVariables), this._refetchVariables);
            var fetchVariables = connectionConfig.getVariables(props, {
                count: paginatingVariables.count,
                cursor: paginatingVariables.cursor
            }, fragmentVariables);
            !(typeof fetchVariables === 'object' && fetchVariables !== null) && invariant(false);
            fetchVariables = (0, _objectSpread3["default"])((0, _objectSpread3["default"])({}, fetchVariables), this._refetchVariables);
            fragmentVariables = (0, _objectSpread3["default"])((0, _objectSpread3["default"])({}, fetchVariables), fragmentVariables);
            var cacheConfig = options ? {
                force: !!options.force
            } : undefined;
            if (cacheConfig != null && (options === null || options === void 0 ? void 0 : options.metadata) != null) cacheConfig.metadata = options === null || options === void 0 ? void 0 : options.metadata;
            var request = getRequest(connectionConfig.query);
            var operation = createOperationDescriptor(request, fetchVariables, cacheConfig);
            var refetchSubscription = null;
            if (this._refetchSubscription) this._refetchSubscription.unsubscribe();
            this._hasFetched = true;
            var onNext = function onNext(payload, complete) {
                var prevData = _this3._resolver.resolve();
                _this3._resolver.setVariables(getFragmentVariables(fragmentVariables, paginatingVariables.totalCount), operation.request.node);
                var nextData = _this3._resolver.resolve();
                if (!areEqual(prevData, nextData)) _this3.setState({
                    data: nextData,
                    contextForChildren: {
                        environment: _this3.props.__relayContext.environment
                    }
                }, complete);
                else complete();
            };
            var cleanup = function cleanup() {
                if (_this3._refetchSubscription === refetchSubscription) {
                    _this3._refetchSubscription = null;
                    _this3._isARequestInFlight = false;
                }
            };
            this._isARequestInFlight = true;
            refetchSubscription = this._getQueryFetcher().execute({
                environment: environment,
                operation: operation,
                preservePreviousReferences: true
            }).mergeMap(function(payload) {
                return Observable.create(function(sink) {
                    onNext(payload, function() {
                        sink.next();
                        sink.complete();
                    });
                });
            })["do"]({
                error: cleanup,
                complete: cleanup,
                unsubscribe: cleanup
            }).subscribe(observer || {});
            this._refetchSubscription = this._isARequestInFlight ? refetchSubscription : null;
            return refetchSubscription;
        };
        _proto._cleanup = function _cleanup() {
            this._resolver.dispose();
            this._refetchVariables = null;
            this._hasFetched = false;
            if (this._refetchSubscription) {
                this._refetchSubscription.unsubscribe();
                this._refetchSubscription = null;
                this._isARequestInFlight = false;
            }
            if (this._queryFetcher) this._queryFetcher.dispose();
        };
        _proto.render = function render() {
            var _this$props3 = this.props, componentRef = _this$props3.componentRef, __relayContext = _this$props3.__relayContext, __rootIsQueryRenderer = _this$props3.__rootIsQueryRenderer, props = (0, _objectWithoutPropertiesLoose2["default"])(_this$props3, _excluded3);
            return /*#__PURE__*/ React.createElement(ReactRelayContext.Provider, {
                value: this.state.contextForChildren
            }, /*#__PURE__*/ React.createElement(Component, (0, _extends2["default"])({}, props, this.state.data, {
                ref: componentRef,
                relay: this.state.relayProp
            })));
        };
        return _class;
    }(React.Component), (0, _defineProperty2["default"])(_class, "displayName", containerName), _class;
}
function createContainer(Component, fragmentSpec, connectionConfig) {
    return buildReactRelayContainer(Component, fragmentSpec, function(ComponentClass, fragments) {
        return createContainerWithFragments(ComponentClass, fragments, connectionConfig);
    });
}
module.exports = {
    createContainer: createContainer
};

},{"6e6e7ed4afa8612d":"590td","918810cde5ad6fe0":"ehKSH","3cd79c67fa980491":"fkx57","cd7a7ac1ae1e3ffd":"k1uP3","4cc5ead00e406c73":"idPlQ","a237a7825c97b226":"2paQ8","287756abeafdedc8":"2Bj1n","a8a738316d365cfb":"hPnUw","91c455e00e6a2238":"gDiox","43d7443ac887d1b3":"7AyFT","f2b31ff1102bf794":"7NW2h","74dd7b526c3f03e4":"fhl4l","3c07bd80314624a6":"cZlGo","11f996824ce1804e":"eJLuG","f7248b901251f99d":"e2sci","b12828d89a8ae0e3":"ltHCL","e57e7b0f63883a80":"2IxFR","15dd5cec7e06344":"j64TH"}],"gDiox":[function(require,module,exports,__globalThis) {
'use strict';
var _interopRequireDefault = require("6ce961c058406860")["default"];
var _objectSpread2 = _interopRequireDefault(require("6495af86b903b4dc"));
var _require = require("c43719be5e3ebafb"), getSelector = _require.getSelector;
function getRootVariablesForFragments(fragments, props) {
    var rootVariables = {};
    Object.keys(fragments).forEach(function(key) {
        var _selector$selectors$, _selector$selectors$2, _selector$owner$varia;
        var fragmentNode = fragments[key];
        var fragmentRef = props[key];
        var selector = getSelector(fragmentNode, fragmentRef);
        var fragmentOwnerVariables = selector != null && selector.kind === 'PluralReaderSelector' ? (_selector$selectors$ = (_selector$selectors$2 = selector.selectors[0]) === null || _selector$selectors$2 === void 0 ? void 0 : _selector$selectors$2.owner.variables) !== null && _selector$selectors$ !== void 0 ? _selector$selectors$ : {} : (_selector$owner$varia = selector === null || selector === void 0 ? void 0 : selector.owner.variables) !== null && _selector$owner$varia !== void 0 ? _selector$owner$varia : {};
        rootVariables = (0, _objectSpread2["default"])((0, _objectSpread2["default"])({}, rootVariables), fragmentOwnerVariables);
    });
    return rootVariables;
}
module.exports = getRootVariablesForFragments;

},{"6ce961c058406860":"590td","6495af86b903b4dc":"2Bj1n","c43719be5e3ebafb":"2IxFR"}],"fhl4l":[function(require,module,exports,__globalThis) {
'use strict';
var _interopRequireDefault = require("ce346cbd60d80779")["default"];
var _defineProperty2 = _interopRequireDefault(require("93ac89c2e9f81987"));
var invariant = require("c26a5bef78081a84");
var _require = require("63c9940562becb3f"), fetchQuery = _require.__internal.fetchQuery, createOperationDescriptor = _require.createOperationDescriptor, isRelayModernEnvironment = _require.isRelayModernEnvironment;
var ReactRelayQueryFetcher = /*#__PURE__*/ function() {
    function ReactRelayQueryFetcher(args) {
        (0, _defineProperty2["default"])(this, "_selectionReferences", []);
        (0, _defineProperty2["default"])(this, "_didFetchFinish", false);
        if (args != null) {
            this._cacheSelectionReference = args.cacheSelectionReference;
            this._selectionReferences = args.selectionReferences;
        }
    }
    var _proto = ReactRelayQueryFetcher.prototype;
    _proto.getSelectionReferences = function getSelectionReferences() {
        return {
            cacheSelectionReference: this._cacheSelectionReference,
            selectionReferences: this._selectionReferences
        };
    };
    _proto.lookupInStore = function lookupInStore(environment, operation, fetchPolicy) {
        if (fetchPolicy === 'store-and-network' || fetchPolicy === 'store-or-network') {
            if (environment.check(operation).status === 'available') {
                this._retainCachedOperation(environment, operation);
                return environment.lookup(operation.fragment);
            }
        }
        return null;
    };
    _proto.getFetchResult = function getFetchResult() {
        if (this._didFetchFinish) {
            if (this._error != null) return {
                error: this._error
            };
            else if (this._snapshot != null) return {
                snapshot: this._snapshot
            };
        } else return null;
    };
    _proto.execute = function execute(_ref) {
        var _this = this;
        var environment = _ref.environment, operation = _ref.operation, _ref$preservePrevious = _ref.preservePreviousReferences, preservePreviousReferences = _ref$preservePrevious === void 0 ? false : _ref$preservePrevious;
        var reference = environment.retain(operation);
        var error = function error() {
            _this._selectionReferences = _this._selectionReferences.concat(reference);
        };
        var complete = function complete() {
            if (!preservePreviousReferences) _this.disposeSelectionReferences();
            _this._selectionReferences = _this._selectionReferences.concat(reference);
        };
        var unsubscribe = function unsubscribe() {
            _this._selectionReferences = _this._selectionReferences.concat(reference);
        };
        if (!isRelayModernEnvironment(environment)) return environment.execute({
            operation: operation
        })["do"]({
            error: error,
            complete: complete,
            unsubscribe: unsubscribe
        });
        return fetchQuery(environment, operation)["do"]({
            error: error,
            complete: complete,
            unsubscribe: unsubscribe
        });
    };
    _proto.setOnDataChange = function setOnDataChange(onDataChange) {
        !this._fetchOptions && invariant(false);
        if (typeof onDataChange === 'function') {
            this._fetchOptions.onDataChangeCallbacks = this._fetchOptions.onDataChangeCallbacks || [];
            this._fetchOptions.onDataChangeCallbacks.push(onDataChange);
            if (this._didFetchFinish) {
                if (this._error != null) onDataChange({
                    error: this._error
                });
                else if (this._snapshot != null) onDataChange({
                    snapshot: this._snapshot
                });
            }
        }
    };
    _proto.fetch = function fetch(fetchOptions, cacheConfigOverride) {
        var _this2 = this;
        var environment = fetchOptions.environment, operation = fetchOptions.operation, onDataChange = fetchOptions.onDataChange;
        var fetchHasReturned = false;
        var _error;
        this.disposeRequest();
        var oldOnDataChangeCallbacks = this._fetchOptions && this._fetchOptions.onDataChangeCallbacks;
        this._fetchOptions = {
            environment: environment,
            onDataChangeCallbacks: oldOnDataChangeCallbacks || [],
            operation: operation
        };
        if (onDataChange && this._fetchOptions.onDataChangeCallbacks.indexOf(onDataChange) === -1) this._fetchOptions.onDataChangeCallbacks.push(onDataChange);
        var operationOverride = cacheConfigOverride ? createOperationDescriptor(operation.request.node, operation.request.variables, cacheConfigOverride) : operation;
        var request = this.execute({
            environment: environment,
            operation: operationOverride
        })["finally"](function() {
            _this2._pendingRequest = null;
        }).subscribe({
            next: function next() {
                _this2._didFetchFinish = true;
                _this2._error = null;
                _this2._onQueryDataAvailable({
                    notifyFirstResult: fetchHasReturned
                });
            },
            error: function error(err) {
                _this2._didFetchFinish = true;
                _this2._error = err;
                _this2._snapshot = null;
                var onDataChangeCallbacks = _this2._fetchOptions && _this2._fetchOptions.onDataChangeCallbacks;
                if (fetchHasReturned) {
                    if (onDataChangeCallbacks) onDataChangeCallbacks.forEach(function(onDataChange) {
                        onDataChange({
                            error: err
                        });
                    });
                } else _error = err;
            }
        });
        this._pendingRequest = {
            dispose: function dispose() {
                request.unsubscribe();
            }
        };
        fetchHasReturned = true;
        if (_error) throw _error;
        return this._snapshot;
    };
    _proto.retry = function retry(cacheConfigOverride) {
        !this._fetchOptions && invariant(false);
        return this.fetch({
            environment: this._fetchOptions.environment,
            operation: this._fetchOptions.operation,
            onDataChange: null
        }, cacheConfigOverride);
    };
    _proto.dispose = function dispose() {
        this.disposeRequest();
        this.disposeSelectionReferences();
    };
    _proto.disposeRequest = function disposeRequest() {
        this._error = null;
        this._snapshot = null;
        if (this._pendingRequest) this._pendingRequest.dispose();
        if (this._rootSubscription) {
            this._rootSubscription.dispose();
            this._rootSubscription = null;
        }
    };
    _proto._retainCachedOperation = function _retainCachedOperation(environment, operation) {
        this._disposeCacheSelectionReference();
        this._cacheSelectionReference = environment.retain(operation);
    };
    _proto._disposeCacheSelectionReference = function _disposeCacheSelectionReference() {
        this._cacheSelectionReference && this._cacheSelectionReference.dispose();
        this._cacheSelectionReference = null;
    };
    _proto.disposeSelectionReferences = function disposeSelectionReferences() {
        this._disposeCacheSelectionReference();
        this._selectionReferences.forEach(function(r) {
            return r.dispose();
        });
        this._selectionReferences = [];
    };
    _proto._onQueryDataAvailable = function _onQueryDataAvailable(_ref2) {
        var _this3 = this;
        var notifyFirstResult = _ref2.notifyFirstResult;
        !this._fetchOptions && invariant(false);
        var _this$_fetchOptions = this._fetchOptions, environment = _this$_fetchOptions.environment, onDataChangeCallbacks = _this$_fetchOptions.onDataChangeCallbacks, operation = _this$_fetchOptions.operation;
        if (this._snapshot) return;
        this._snapshot = environment.lookup(operation.fragment);
        this._rootSubscription = environment.subscribe(this._snapshot, function(snapshot) {
            if (_this3._fetchOptions != null) {
                var maybeNewOnDataChangeCallbacks = _this3._fetchOptions.onDataChangeCallbacks;
                if (Array.isArray(maybeNewOnDataChangeCallbacks)) maybeNewOnDataChangeCallbacks.forEach(function(onDataChange) {
                    return onDataChange({
                        snapshot: snapshot
                    });
                });
            }
        });
        if (this._snapshot && notifyFirstResult && Array.isArray(onDataChangeCallbacks)) {
            var snapshot = this._snapshot;
            onDataChangeCallbacks.forEach(function(onDataChange) {
                return onDataChange({
                    snapshot: snapshot
                });
            });
        }
    };
    return ReactRelayQueryFetcher;
}();
module.exports = ReactRelayQueryFetcher;

},{"ce346cbd60d80779":"590td","93ac89c2e9f81987":"2paQ8","c26a5bef78081a84":"e2sci","63c9940562becb3f":"2IxFR"}],"l9rE8":[function(require,module,exports,__globalThis) {
'use strict';
var _interopRequireDefault = require("b334581f34ed6b73")["default"];
var _objectSpread2 = _interopRequireDefault(require("a76878f589512f22"));
var _assertThisInitialized2 = _interopRequireDefault(require("87ef6eb737873255"));
var _inheritsLoose2 = _interopRequireDefault(require("3f89edd1050ec528"));
var _defineProperty2 = _interopRequireDefault(require("61b65da76b6d980"));
var ReactRelayContext = require("c77cf28e5778305d");
var ReactRelayQueryFetcher = require("4580c91be56cd479");
var ReactRelayQueryRendererContext = require("a20152de3a9b7ced");
var areEqual = require("45e2a2a1be611e61");
var React = require("3ef56b065f8f54ba");
var _require = require("bef4ac506cb0ba09"), createOperationDescriptor = _require.createOperationDescriptor, deepFreeze = _require.deepFreeze, getRequest = _require.getRequest;
var requestCache = {};
var queryRendererContext = {
    rootIsQueryRenderer: true
};
var ReactRelayQueryRenderer = /*#__PURE__*/ function(_React$Component) {
    (0, _inheritsLoose2["default"])(ReactRelayQueryRenderer, _React$Component);
    function ReactRelayQueryRenderer(props) {
        var _this;
        _this = _React$Component.call(this, props) || this;
        (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "_handleDataChange", function(params) {
            var error = params.error == null ? null : params.error;
            var snapshot = params.snapshot == null ? null : params.snapshot;
            _this.setState(function(prevState) {
                var prevRequestCacheKey = prevState.requestCacheKey;
                if (prevRequestCacheKey) delete requestCache[prevRequestCacheKey];
                if (snapshot === prevState.snapshot && error === prevState.error) return null;
                return {
                    renderProps: getRenderProps(error, snapshot, prevState.queryFetcher, prevState.retryCallbacks),
                    snapshot: snapshot,
                    requestCacheKey: null
                };
            });
        });
        var retryCallbacks = {
            handleDataChange: null,
            handleRetryAfterError: null
        };
        var queryFetcher;
        var requestCacheKey;
        if (props.query) {
            var query = props.query;
            var request = getRequest(query);
            requestCacheKey = getRequestCacheKey(request.params, props.variables);
            queryFetcher = requestCache[requestCacheKey] ? requestCache[requestCacheKey].queryFetcher : new ReactRelayQueryFetcher();
        } else queryFetcher = new ReactRelayQueryFetcher();
        _this._maybeHiddenOrFastRefresh = false;
        _this.state = (0, _objectSpread2["default"])({
            prevPropsEnvironment: props.environment,
            prevPropsVariables: props.variables,
            prevQuery: props.query,
            queryFetcher: queryFetcher,
            retryCallbacks: retryCallbacks
        }, fetchQueryAndComputeStateFromProps(props, queryFetcher, retryCallbacks, requestCacheKey));
        return _this;
    }
    ReactRelayQueryRenderer.getDerivedStateFromProps = function getDerivedStateFromProps(nextProps, prevState) {
        if (prevState.prevQuery !== nextProps.query || prevState.prevPropsEnvironment !== nextProps.environment || !areEqual(prevState.prevPropsVariables, nextProps.variables)) return resetQueryStateForUpdate(nextProps, prevState);
        return null;
    };
    var _proto = ReactRelayQueryRenderer.prototype;
    _proto.componentDidMount = function componentDidMount() {
        var _this2 = this;
        if (this._maybeHiddenOrFastRefresh === true) {
            this._maybeHiddenOrFastRefresh = false;
            this.setState(function(prevState) {
                var newState = resetQueryStateForUpdate(_this2.props, prevState);
                var requestCacheKey = newState.requestCacheKey, queryFetcher = newState.queryFetcher;
                if (requestCacheKey != null && requestCache[requestCacheKey] != null) queryFetcher.setOnDataChange(_this2._handleDataChange);
                return newState;
            });
            return;
        }
        var _this$state = this.state, retryCallbacks = _this$state.retryCallbacks, queryFetcher = _this$state.queryFetcher, requestCacheKey = _this$state.requestCacheKey;
        if (requestCacheKey) delete requestCache[requestCacheKey];
        retryCallbacks.handleDataChange = this._handleDataChange;
        retryCallbacks.handleRetryAfterError = function(error) {
            return _this2.setState(function(prevState) {
                var prevRequestCacheKey = prevState.requestCacheKey;
                if (prevRequestCacheKey) delete requestCache[prevRequestCacheKey];
                return {
                    renderProps: getLoadingRenderProps(),
                    requestCacheKey: null
                };
            });
        };
        if (this.props.query) queryFetcher.setOnDataChange(this._handleDataChange);
    };
    _proto.componentDidUpdate = function componentDidUpdate(_prevProps, prevState) {
        var _this$state2 = this.state, queryFetcher = _this$state2.queryFetcher, requestCacheKey = _this$state2.requestCacheKey;
        if (requestCacheKey) {
            delete requestCache[requestCacheKey];
            delete this.state.requestCacheKey;
        }
        if (this.props.query && queryFetcher !== prevState.queryFetcher) queryFetcher.setOnDataChange(this._handleDataChange);
    };
    _proto.componentWillUnmount = function componentWillUnmount() {
        this.state.queryFetcher.dispose();
        this._maybeHiddenOrFastRefresh = true;
    };
    _proto.shouldComponentUpdate = function shouldComponentUpdate(nextProps, nextState) {
        return nextProps.render !== this.props.render || nextState.renderProps !== this.state.renderProps;
    };
    _proto.render = function render() {
        var _this$state3 = this.state, renderProps = _this$state3.renderProps, relayContext = _this$state3.relayContext;
        return /*#__PURE__*/ React.createElement(ReactRelayContext.Provider, {
            value: relayContext
        }, /*#__PURE__*/ React.createElement(ReactRelayQueryRendererContext.Provider, {
            value: queryRendererContext
        }, this.props.render(renderProps)));
    };
    return ReactRelayQueryRenderer;
}(React.Component);
function getLoadingRenderProps() {
    return {
        error: null,
        props: null,
        retry: null
    };
}
function getEmptyRenderProps() {
    return {
        error: null,
        props: {},
        retry: null
    };
}
function getRenderProps(error, snapshot, queryFetcher, retryCallbacks) {
    return {
        error: error ? error : null,
        props: snapshot ? snapshot.data : null,
        retry: function retry(cacheConfigOverride) {
            var syncSnapshot = queryFetcher.retry(cacheConfigOverride);
            if (syncSnapshot && typeof retryCallbacks.handleDataChange === 'function') retryCallbacks.handleDataChange({
                snapshot: syncSnapshot
            });
            else if (error && typeof retryCallbacks.handleRetryAfterError === 'function') retryCallbacks.handleRetryAfterError(error);
        }
    };
}
function getRequestCacheKey(request, variables) {
    return JSON.stringify({
        id: request.cacheID ? request.cacheID : request.id,
        variables: variables
    });
}
function resetQueryStateForUpdate(props, prevState) {
    var query = props.query;
    var prevSelectionReferences = prevState.queryFetcher.getSelectionReferences();
    prevState.queryFetcher.disposeRequest();
    var queryFetcher;
    if (query) {
        var request = getRequest(query);
        var requestCacheKey = getRequestCacheKey(request.params, props.variables);
        queryFetcher = requestCache[requestCacheKey] ? requestCache[requestCacheKey].queryFetcher : new ReactRelayQueryFetcher(prevSelectionReferences);
    } else queryFetcher = new ReactRelayQueryFetcher(prevSelectionReferences);
    return (0, _objectSpread2["default"])({
        prevQuery: props.query,
        prevPropsEnvironment: props.environment,
        prevPropsVariables: props.variables,
        queryFetcher: queryFetcher
    }, fetchQueryAndComputeStateFromProps(props, queryFetcher, prevState.retryCallbacks));
}
function fetchQueryAndComputeStateFromProps(props, queryFetcher, retryCallbacks, requestCacheKey) {
    var environment = props.environment, query = props.query, variables = props.variables, cacheConfig = props.cacheConfig;
    var genericEnvironment = environment;
    if (query) {
        var request = getRequest(query);
        var operation = createOperationDescriptor(request, variables, cacheConfig);
        var relayContext = {
            environment: genericEnvironment
        };
        if (typeof requestCacheKey === 'string' && requestCache[requestCacheKey]) {
            var snapshot = requestCache[requestCacheKey].snapshot;
            if (snapshot) return {
                error: null,
                relayContext: relayContext,
                renderProps: getRenderProps(null, snapshot, queryFetcher, retryCallbacks),
                snapshot: snapshot,
                requestCacheKey: requestCacheKey
            };
            else return {
                error: null,
                relayContext: relayContext,
                renderProps: getLoadingRenderProps(),
                snapshot: null,
                requestCacheKey: requestCacheKey
            };
        }
        try {
            var storeSnapshot = queryFetcher.lookupInStore(genericEnvironment, operation, props.fetchPolicy);
            var querySnapshot = queryFetcher.fetch({
                environment: genericEnvironment,
                onDataChange: null,
                operation: operation
            });
            var _snapshot = querySnapshot || storeSnapshot;
            requestCacheKey = requestCacheKey || getRequestCacheKey(request.params, props.variables);
            requestCache[requestCacheKey] = {
                queryFetcher: queryFetcher,
                snapshot: _snapshot
            };
            if (!_snapshot) return {
                error: null,
                relayContext: relayContext,
                renderProps: getLoadingRenderProps(),
                snapshot: null,
                requestCacheKey: requestCacheKey
            };
            return {
                error: null,
                relayContext: relayContext,
                renderProps: getRenderProps(null, _snapshot, queryFetcher, retryCallbacks),
                snapshot: _snapshot,
                requestCacheKey: requestCacheKey
            };
        } catch (error) {
            return {
                error: error,
                relayContext: relayContext,
                renderProps: getRenderProps(error, null, queryFetcher, retryCallbacks),
                snapshot: null,
                requestCacheKey: requestCacheKey
            };
        }
    } else {
        queryFetcher.dispose();
        var _relayContext = {
            environment: genericEnvironment
        };
        return {
            error: null,
            relayContext: _relayContext,
            renderProps: getEmptyRenderProps(),
            requestCacheKey: null
        };
    }
}
module.exports = ReactRelayQueryRenderer;

},{"b334581f34ed6b73":"590td","a76878f589512f22":"2Bj1n","87ef6eb737873255":"k1uP3","3f89edd1050ec528":"idPlQ","61b65da76b6d980":"2paQ8","c77cf28e5778305d":"7NW2h","4580c91be56cd479":"fhl4l","a20152de3a9b7ced":"8JS6r","45e2a2a1be611e61":"eJLuG","3ef56b065f8f54ba":"ltHCL","bef4ac506cb0ba09":"2IxFR"}],"1nKeO":[function(require,module,exports,__globalThis) {
'use strict';
var _interopRequireDefault = require("875aaacd52671239")["default"];
var _extends2 = _interopRequireDefault(require("92541e3bf3b608dd"));
var _objectWithoutPropertiesLoose2 = _interopRequireDefault(require("4c184c233b5617e8"));
var _objectSpread2 = _interopRequireDefault(require("ea5d91145532619f"));
var _assertThisInitialized2 = _interopRequireDefault(require("ad66ac1668305503"));
var _inheritsLoose2 = _interopRequireDefault(require("ed120e4e31838a12"));
var _defineProperty2 = _interopRequireDefault(require("b910ba6d3de581bb"));
var _excluded = [
    "componentRef",
    "__relayContext",
    "__rootIsQueryRenderer"
];
var buildReactRelayContainer = require("7a9ac1d4dd3ad3fe");
var getRootVariablesForFragments = require("1150ef319ca0edf6");
var _require = require("410ee9383f755285"), getContainerName = _require.getContainerName;
var ReactRelayContext = require("a4b49dd8d95541cf");
var ReactRelayQueryFetcher = require("4cb643176406cbed");
var _require2 = require("5e074e551e87a797"), assertRelayContext = _require2.assertRelayContext;
var areEqual = require("41e9e65cf6864888");
var React = require("f4f24e93fcda9e07");
var _require3 = require("d4cd814611456f68"), Observable = _require3.Observable, createFragmentSpecResolver = _require3.createFragmentSpecResolver, createOperationDescriptor = _require3.createOperationDescriptor, getDataIDsFromObject = _require3.getDataIDsFromObject, getRequest = _require3.getRequest, getVariablesFromObject = _require3.getVariablesFromObject, isScalarAndEqual = _require3.isScalarAndEqual;
var warning = require("6225b0ef408789c3");
function createContainerWithFragments(Component, fragments, taggedNode) {
    var _class;
    var containerName = getContainerName(Component);
    return _class = /*#__PURE__*/ function(_React$Component) {
        (0, _inheritsLoose2["default"])(_class, _React$Component);
        function _class(props) {
            var _props$__rootIsQueryR, _this;
            _this = _React$Component.call(this, props) || this;
            (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "_handleFragmentDataUpdate", function() {
                var resolverFromThisUpdate = _this.state.resolver;
                _this.setState(function(updatedState) {
                    return resolverFromThisUpdate === updatedState.resolver ? {
                        data: updatedState.resolver.resolve()
                    } : null;
                });
            });
            (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "_refetch", function(refetchVariables, renderVariables, observerOrCallback, options) {
                if (_this._isUnmounted) return {
                    dispose: function dispose() {}
                };
                var _assertRelayContext = assertRelayContext(_this.props.__relayContext), environment = _assertRelayContext.environment;
                var rootVariables = getRootVariablesForFragments(fragments, _this.props);
                var fetchVariables = typeof refetchVariables === 'function' ? refetchVariables(_this._getFragmentVariables()) : refetchVariables;
                fetchVariables = (0, _objectSpread2["default"])((0, _objectSpread2["default"])({}, rootVariables), fetchVariables);
                var fragmentVariables = renderVariables ? (0, _objectSpread2["default"])((0, _objectSpread2["default"])({}, fetchVariables), renderVariables) : fetchVariables;
                var cacheConfig = options ? {
                    force: !!options.force
                } : undefined;
                if (cacheConfig != null && (options === null || options === void 0 ? void 0 : options.metadata) != null) cacheConfig.metadata = options === null || options === void 0 ? void 0 : options.metadata;
                var observer = typeof observerOrCallback === 'function' ? {
                    next: observerOrCallback,
                    error: observerOrCallback
                } : observerOrCallback || {};
                var query = getRequest(taggedNode);
                var operation = createOperationDescriptor(query, fetchVariables, cacheConfig);
                _this.state.localVariables = fetchVariables;
                _this._refetchSubscription && _this._refetchSubscription.unsubscribe();
                var refetchSubscription;
                var storeSnapshot = _this._getQueryFetcher().lookupInStore(environment, operation, options === null || options === void 0 ? void 0 : options.fetchPolicy);
                if (storeSnapshot != null) {
                    _this.state.resolver.setVariables(fragmentVariables, operation.request.node);
                    _this.setState(function(latestState) {
                        return {
                            data: latestState.resolver.resolve(),
                            contextForChildren: {
                                environment: _this.props.__relayContext.environment
                            }
                        };
                    }, function() {
                        observer.next && observer.next();
                        observer.complete && observer.complete();
                    });
                    return {
                        dispose: function dispose() {}
                    };
                }
                _this._getQueryFetcher().execute({
                    environment: environment,
                    operation: operation,
                    preservePreviousReferences: true
                }).mergeMap(function(response) {
                    _this.state.resolver.setVariables(fragmentVariables, operation.request.node);
                    return Observable.create(function(sink) {
                        return _this.setState(function(latestState) {
                            return {
                                data: latestState.resolver.resolve(),
                                contextForChildren: {
                                    environment: _this.props.__relayContext.environment
                                }
                            };
                        }, function() {
                            sink.next();
                            sink.complete();
                        });
                    });
                })["finally"](function() {
                    if (_this._refetchSubscription === refetchSubscription) _this._refetchSubscription = null;
                }).subscribe((0, _objectSpread2["default"])((0, _objectSpread2["default"])({}, observer), {}, {
                    start: function start(subscription) {
                        _this._refetchSubscription = refetchSubscription = subscription;
                        observer.start && observer.start(subscription);
                    }
                }));
                return {
                    dispose: function dispose() {
                        refetchSubscription && refetchSubscription.unsubscribe();
                    }
                };
            });
            var relayContext = assertRelayContext(props.__relayContext);
            var rootIsQueryRenderer = (_props$__rootIsQueryR = props.__rootIsQueryRenderer) !== null && _props$__rootIsQueryR !== void 0 ? _props$__rootIsQueryR : false;
            _this._refetchSubscription = null;
            var resolver = createFragmentSpecResolver(relayContext, containerName, fragments, props, rootIsQueryRenderer);
            _this.state = {
                data: resolver.resolve(),
                localVariables: null,
                prevProps: props,
                prevPropsContext: relayContext,
                contextForChildren: relayContext,
                relayProp: getRelayProp(relayContext.environment, _this._refetch),
                resolver: resolver
            };
            _this._isUnmounted = false;
            return _this;
        }
        var _proto = _class.prototype;
        _proto.componentDidMount = function componentDidMount() {
            this._isUnmounted = false;
            this._subscribeToNewResolverAndRerenderIfStoreHasChanged();
        };
        _proto.componentDidUpdate = function componentDidUpdate(prevProps, prevState) {
            if (this.state.resolver !== prevState.resolver) {
                prevState.resolver.dispose();
                this._queryFetcher && this._queryFetcher.dispose();
                this._refetchSubscription && this._refetchSubscription.unsubscribe();
                this._subscribeToNewResolverAndRerenderIfStoreHasChanged();
            } else this._rerenderIfStoreHasChanged();
        };
        _class.getDerivedStateFromProps = function getDerivedStateFromProps(nextProps, prevState) {
            var _nextProps$__rootIsQu;
            var prevProps = prevState.prevProps;
            var relayContext = assertRelayContext(nextProps.__relayContext);
            var rootIsQueryRenderer = (_nextProps$__rootIsQu = nextProps.__rootIsQueryRenderer) !== null && _nextProps$__rootIsQu !== void 0 ? _nextProps$__rootIsQu : false;
            var prevIDs = getDataIDsFromObject(fragments, prevProps);
            var nextIDs = getDataIDsFromObject(fragments, nextProps);
            var prevRootVariables = getRootVariablesForFragments(fragments, prevProps);
            var nextRootVariables = getRootVariablesForFragments(fragments, nextProps);
            var resolver = prevState.resolver;
            if (prevState.prevPropsContext.environment !== relayContext.environment || !areEqual(prevRootVariables, nextRootVariables) || !areEqual(prevIDs, nextIDs)) {
                resolver = createFragmentSpecResolver(relayContext, containerName, fragments, nextProps, rootIsQueryRenderer);
                return {
                    data: resolver.resolve(),
                    localVariables: null,
                    prevProps: nextProps,
                    prevPropsContext: relayContext,
                    contextForChildren: relayContext,
                    relayProp: getRelayProp(relayContext.environment, prevState.relayProp.refetch),
                    resolver: resolver
                };
            } else if (!prevState.localVariables) resolver.setProps(nextProps);
            var data = resolver.resolve();
            if (data !== prevState.data) return {
                data: data,
                prevProps: nextProps
            };
            return null;
        };
        _proto.componentWillUnmount = function componentWillUnmount() {
            this._isUnmounted = true;
            this.state.resolver.dispose();
            this._queryFetcher && this._queryFetcher.dispose();
            this._refetchSubscription && this._refetchSubscription.unsubscribe();
        };
        _proto.shouldComponentUpdate = function shouldComponentUpdate(nextProps, nextState) {
            if (nextState.data !== this.state.data || nextState.relayProp !== this.state.relayProp) return true;
            var keys = Object.keys(nextProps);
            for(var ii = 0; ii < keys.length; ii++){
                var key = keys[ii];
                if (key === '__relayContext') {
                    if (this.state.prevPropsContext.environment !== nextState.prevPropsContext.environment) return true;
                } else {
                    if (!fragments.hasOwnProperty(key) && !isScalarAndEqual(nextProps[key], this.props[key])) return true;
                }
            }
            return false;
        };
        _proto._rerenderIfStoreHasChanged = function _rerenderIfStoreHasChanged() {
            var _this$state = this.state, data = _this$state.data, resolver = _this$state.resolver;
            var maybeNewData = resolver.resolve();
            if (data !== maybeNewData) this.setState({
                data: maybeNewData
            });
        };
        _proto._subscribeToNewResolverAndRerenderIfStoreHasChanged = function _subscribeToNewResolverAndRerenderIfStoreHasChanged() {
            var _this$state2 = this.state, data = _this$state2.data, resolver = _this$state2.resolver;
            var maybeNewData = resolver.resolve();
            resolver.setCallback(this.props, this._handleFragmentDataUpdate);
            if (data !== maybeNewData) this.setState({
                data: maybeNewData
            });
        };
        _proto._getFragmentVariables = function _getFragmentVariables() {
            return getVariablesFromObject(fragments, this.props);
        };
        _proto._getQueryFetcher = function _getQueryFetcher() {
            if (!this._queryFetcher) this._queryFetcher = new ReactRelayQueryFetcher();
            return this._queryFetcher;
        };
        _proto.render = function render() {
            var _this$props = this.props, componentRef = _this$props.componentRef, __relayContext = _this$props.__relayContext, __rootIsQueryRenderer = _this$props.__rootIsQueryRenderer, props = (0, _objectWithoutPropertiesLoose2["default"])(_this$props, _excluded);
            var _this$state3 = this.state, relayProp = _this$state3.relayProp, contextForChildren = _this$state3.contextForChildren;
            return /*#__PURE__*/ React.createElement(ReactRelayContext.Provider, {
                value: contextForChildren
            }, /*#__PURE__*/ React.createElement(Component, (0, _extends2["default"])({}, props, this.state.data, {
                ref: componentRef,
                relay: relayProp
            })));
        };
        return _class;
    }(React.Component), (0, _defineProperty2["default"])(_class, "displayName", containerName), _class;
}
function getRelayProp(environment, refetch) {
    return {
        environment: environment,
        refetch: refetch
    };
}
function createContainer(Component, fragmentSpec, taggedNode) {
    return buildReactRelayContainer(Component, fragmentSpec, function(ComponentClass, fragments) {
        return createContainerWithFragments(ComponentClass, fragments, taggedNode);
    });
}
module.exports = {
    createContainer: createContainer
};

},{"875aaacd52671239":"590td","92541e3bf3b608dd":"ehKSH","4c184c233b5617e8":"fkx57","ea5d91145532619f":"2Bj1n","ad66ac1668305503":"k1uP3","ed120e4e31838a12":"idPlQ","b910ba6d3de581bb":"2paQ8","7a9ac1d4dd3ad3fe":"hPnUw","1150ef319ca0edf6":"gDiox","410ee9383f755285":"7AyFT","a4b49dd8d95541cf":"7NW2h","4cb643176406cbed":"fhl4l","5e074e551e87a797":"cZlGo","41e9e65cf6864888":"eJLuG","f4f24e93fcda9e07":"ltHCL","d4cd814611456f68":"2IxFR","6225b0ef408789c3":"j64TH"}],"d2ChJ":[function(require,module,exports,__globalThis) {
'use strict';
var ProfilerContext = require("cb9c9590f23f2840");
var useRelayEnvironment = require("afd31edb72068860");
var React = require("33db6349f66f6f62");
var _require = require("33db6349f66f6f62"), useContext = _require.useContext, useEffect = _require.useEffect;
var warning = require("1225c530b4ebf241");
function EntryPointContainer(_ref) {
    var entryPointReference = _ref.entryPointReference, props = _ref.props;
    var getComponent = entryPointReference.getComponent, queries = entryPointReference.queries, entryPoints = entryPointReference.entryPoints, extraProps = entryPointReference.extraProps, rootModuleID = entryPointReference.rootModuleID;
    var Component = getComponent();
    var profilerContext = useContext(ProfilerContext);
    var environment = useRelayEnvironment();
    useEffect(function() {
        environment.__log({
            name: 'entrypoint.root.consume',
            profilerContext: profilerContext,
            rootModuleID: rootModuleID
        });
    }, [
        environment,
        profilerContext,
        rootModuleID
    ]);
    return /*#__PURE__*/ React.createElement(Component, {
        entryPoints: entryPoints,
        extraProps: extraProps,
        props: props,
        queries: queries
    });
}
module.exports = EntryPointContainer;

},{"cb9c9590f23f2840":"1lEHI","afd31edb72068860":"bs9Iy","33db6349f66f6f62":"ltHCL","1225c530b4ebf241":"j64TH"}],"1lEHI":[function(require,module,exports,__globalThis) {
'use strict';
var React = require("79a90bff2d060d5e");
var ProfilerContext = React.createContext({
    wrapPrepareQueryResource: function wrapPrepareQueryResource(cb) {
        return cb();
    }
});
module.exports = ProfilerContext;

},{"79a90bff2d060d5e":"ltHCL"}],"bs9Iy":[function(require,module,exports,__globalThis) {
'use strict';
var ReactRelayContext = require("4ba0705935a2160d");
var invariant = require("2c5854cc981658fe");
var _require = require("8fe0c4d36c362e1d"), useContext = _require.useContext;
function useRelayEnvironment() {
    var context = useContext(ReactRelayContext);
    !(context != null) && invariant(false);
    return context.environment;
}
module.exports = useRelayEnvironment;

},{"4ba0705935a2160d":"7NW2h","2c5854cc981658fe":"e2sci","8fe0c4d36c362e1d":"ltHCL"}],"iKwbK":[function(require,module,exports,__globalThis) {
'use strict';
var _require = require("e32d127cb6364377"), loadQuery = _require.loadQuery;
function loadEntryPoint(environmentProvider, entryPoint, entryPointParams) {
    var loadingPromise = null;
    if (entryPoint.root.getModuleIfRequired() == null) loadingPromise = entryPoint.root.load();
    var preloadProps = entryPoint.getPreloadProps(entryPointParams);
    var queries = preloadProps.queries, entryPoints = preloadProps.entryPoints, extraProps = preloadProps.extraProps;
    var preloadedQueries = {};
    var preloadedEntryPoints = {};
    if (queries != null) {
        var queriesPropNames = Object.keys(queries);
        queriesPropNames.forEach(function(queryPropName) {
            var query = queries[queryPropName];
            if (query == null) return;
            var environmentProviderOptions = query.environmentProviderOptions, options = query.options, parameters = query.parameters, variables = query.variables;
            if ((options === null || options === void 0 ? void 0 : options.includeIf) === false) return;
            var environment = environmentProvider.getEnvironment(environmentProviderOptions);
            preloadedQueries[queryPropName] = loadQuery(environment, parameters, variables, {
                fetchPolicy: options === null || options === void 0 ? void 0 : options.fetchPolicy,
                networkCacheConfig: options === null || options === void 0 ? void 0 : options.networkCacheConfig,
                __nameForWarning: 'loadEntryPoint'
            }, environmentProviderOptions);
        });
    }
    if (entryPoints != null) {
        var entryPointPropNames = Object.keys(entryPoints);
        entryPointPropNames.forEach(function(entryPointPropName) {
            var entryPointDescription = entryPoints[entryPointPropName];
            if (entryPointDescription == null) return;
            var nestedEntryPoint = entryPointDescription.entryPoint, nestedParams = entryPointDescription.entryPointParams;
            preloadedEntryPoints[entryPointPropName] = loadEntryPoint(environmentProvider, nestedEntryPoint, nestedParams);
        });
    }
    var isDisposed = false;
    return {
        dispose: function dispose() {
            if (isDisposed) return;
            if (preloadedQueries != null) Object.values(preloadedQueries).forEach(function(_ref) {
                var innerDispose = _ref.dispose;
                innerDispose();
            });
            if (preloadedEntryPoints != null) Object.values(preloadedEntryPoints).forEach(function(_ref2) {
                var innerDispose = _ref2.dispose;
                innerDispose();
            });
            isDisposed = true;
        },
        entryPoints: preloadedEntryPoints,
        extraProps: extraProps !== null && extraProps !== void 0 ? extraProps : null,
        getComponent: function getComponent() {
            var componentModule = entryPoint.root.getModuleIfRequired();
            if (componentModule == null) {
                var _loadingPromise;
                loadingPromise = (_loadingPromise = loadingPromise) !== null && _loadingPromise !== void 0 ? _loadingPromise : entryPoint.root.load();
                throw loadingPromise;
            }
            var component = componentModule["default"] != null ? componentModule["default"] : componentModule;
            return component;
        },
        get isDisposed () {
            return isDisposed;
        },
        queries: preloadedQueries,
        rootModuleID: entryPoint.root.getModuleId()
    };
}
module.exports = loadEntryPoint;

},{"e32d127cb6364377":"4CbeJ"}],"4CbeJ":[function(require,module,exports,__globalThis) {
'use strict';
var _interopRequireDefault = require("626faaec81b8ff9d")["default"];
var _objectSpread2 = _interopRequireDefault(require("a759ea3fa6166602"));
var invariant = require("38af72ba20eb73a5");
var _require = require("a3850f77971d5b6d"), fetchQueryDeduped = _require.__internal.fetchQueryDeduped, Observable = _require.Observable, PreloadableQueryRegistry = _require.PreloadableQueryRegistry, ReplaySubject = _require.ReplaySubject, createOperationDescriptor = _require.createOperationDescriptor, getRequest = _require.getRequest, getRequestIdentifier = _require.getRequestIdentifier;
var fetchKey = 100001;
function loadQuery(environment, preloadableRequest, variables, options, environmentProviderOptions) {
    var _options$fetchPolicy;
    fetchKey++;
    var fetchPolicy = (_options$fetchPolicy = options === null || options === void 0 ? void 0 : options.fetchPolicy) !== null && _options$fetchPolicy !== void 0 ? _options$fetchPolicy : 'store-or-network';
    var networkCacheConfig = (0, _objectSpread2["default"])((0, _objectSpread2["default"])({}, options === null || options === void 0 ? void 0 : options.networkCacheConfig), {}, {
        force: true
    });
    var retainReference;
    var didExecuteNetworkSource = false;
    var executeWithNetworkSource = function executeWithNetworkSource(operation, networkObservable) {
        didExecuteNetworkSource = true;
        return environment.executeWithSource({
            operation: operation,
            source: networkObservable
        });
    };
    var executionSubject = new ReplaySubject();
    var returnedObservable = Observable.create(function(sink) {
        return executionSubject.subscribe(sink);
    });
    var unsubscribeFromNetworkRequest;
    var networkError = null;
    var didMakeNetworkRequest = false;
    var makeNetworkRequest = function makeNetworkRequest(params, checkOperation) {
        didMakeNetworkRequest = true;
        var subject = new ReplaySubject();
        var identifier = 'raw-network-request-' + getRequestIdentifier(params, variables);
        var observable = fetchQueryDeduped(environment, identifier, function() {
            var network = environment.getNetwork();
            return network.execute(params, variables, networkCacheConfig, undefined, undefined, undefined, undefined, checkOperation);
        });
        var _observable$subscribe = observable.subscribe({
            error: function error(err) {
                networkError = err;
                subject.error(err);
            },
            next: function next(data) {
                subject.next(data);
            },
            complete: function complete() {
                subject.complete();
            }
        }), unsubscribe = _observable$subscribe.unsubscribe;
        unsubscribeFromNetworkRequest = unsubscribe;
        return Observable.create(function(sink) {
            var subjectSubscription = subject.subscribe(sink);
            return function() {
                subjectSubscription.unsubscribe();
                unsubscribeFromNetworkRequest();
            };
        });
    };
    var unsubscribeFromExecution;
    var executeDeduped = function executeDeduped(operation, fetchFn) {
        didMakeNetworkRequest = true;
        var _fetchQueryDeduped$su = fetchQueryDeduped(environment, operation.request.identifier, fetchFn).subscribe({
            error: function error(err) {
                executionSubject.error(err);
            },
            next: function next(data) {
                executionSubject.next(data);
            },
            complete: function complete() {
                executionSubject.complete();
            }
        });
        unsubscribeFromExecution = _fetchQueryDeduped$su.unsubscribe;
    };
    var checkAvailabilityAndExecute = function checkAvailabilityAndExecute(concreteRequest) {
        var operation = createOperationDescriptor(concreteRequest, variables, networkCacheConfig);
        retainReference = environment.retain(operation);
        if (fetchPolicy === 'store-only') return;
        var shouldFetch = fetchPolicy !== 'store-or-network' || environment.check(operation).status !== 'available';
        if (shouldFetch) executeDeduped(operation, function() {
            var networkObservable = makeNetworkRequest(concreteRequest.params, function() {
                return environment.check(operation);
            });
            var executeObservable = executeWithNetworkSource(operation, networkObservable);
            return executeObservable;
        });
    };
    var params;
    var cancelOnLoadCallback;
    var queryId;
    if (preloadableRequest.kind === 'PreloadableConcreteRequest') {
        var preloadableConcreteRequest = preloadableRequest;
        params = preloadableConcreteRequest.params;
        var _params = params;
        queryId = _params.id;
        !(queryId !== null) && invariant(false);
        var _module = PreloadableQueryRegistry.get(queryId);
        if (_module != null) checkAvailabilityAndExecute(_module);
        else {
            var networkObservable = fetchPolicy === 'store-only' ? null : makeNetworkRequest(params);
            var _PreloadableQueryRegi = PreloadableQueryRegistry.onLoad(queryId, function(preloadedModule) {
                cancelOnLoadCallback();
                var operation = createOperationDescriptor(preloadedModule, variables, networkCacheConfig);
                retainReference = environment.retain(operation);
                if (networkObservable != null) executeDeduped(operation, function() {
                    return executeWithNetworkSource(operation, networkObservable);
                });
            });
            cancelOnLoadCallback = _PreloadableQueryRegi.dispose;
        }
    } else {
        var graphQlTaggedNode = preloadableRequest;
        var request = getRequest(graphQlTaggedNode);
        params = request.params;
        queryId = params.cacheID != null ? params.cacheID : params.id;
        checkAvailabilityAndExecute(request);
    }
    var isDisposed = false;
    var isReleased = false;
    var isNetworkRequestCancelled = false;
    var releaseQuery = function releaseQuery() {
        if (isReleased) return;
        retainReference && retainReference.dispose();
        isReleased = true;
    };
    var cancelNetworkRequest = function cancelNetworkRequest() {
        if (isNetworkRequestCancelled) return;
        if (didExecuteNetworkSource) unsubscribeFromExecution && unsubscribeFromExecution();
        else unsubscribeFromNetworkRequest && unsubscribeFromNetworkRequest();
        cancelOnLoadCallback && cancelOnLoadCallback();
        isNetworkRequestCancelled = true;
    };
    return {
        kind: 'PreloadedQuery',
        environment: environment,
        environmentProviderOptions: environmentProviderOptions,
        dispose: function dispose() {
            if (isDisposed) return;
            releaseQuery();
            cancelNetworkRequest();
            isDisposed = true;
        },
        releaseQuery: releaseQuery,
        cancelNetworkRequest: cancelNetworkRequest,
        fetchKey: fetchKey,
        id: queryId,
        get isDisposed () {
            return isDisposed || isReleased;
        },
        get networkError () {
            return networkError;
        },
        name: params.name,
        networkCacheConfig: networkCacheConfig,
        fetchPolicy: fetchPolicy,
        source: didMakeNetworkRequest ? returnedObservable : undefined,
        variables: variables
    };
}
module.exports = {
    loadQuery: loadQuery
};

},{"626faaec81b8ff9d":"590td","a759ea3fa6166602":"2Bj1n","38af72ba20eb73a5":"e2sci","a3850f77971d5b6d":"2IxFR"}],"aIt8X":[function(require,module,exports,__globalThis) {
'use strict';
var ReactRelayContext = require("3a8082aa064e367e");
var React = require("52398f158b945db7");
var useMemo = React.useMemo;
function RelayEnvironmentProvider(props) {
    var children = props.children, environment = props.environment, getEnvironmentForActor = props.getEnvironmentForActor;
    var context = useMemo(function() {
        return {
            environment: environment,
            getEnvironmentForActor: getEnvironmentForActor
        };
    }, [
        environment,
        getEnvironmentForActor
    ]);
    return /*#__PURE__*/ React.createElement(ReactRelayContext.Provider, {
        value: context
    }, children);
}
module.exports = RelayEnvironmentProvider;

},{"3a8082aa064e367e":"7NW2h","52398f158b945db7":"ltHCL"}],"c5QiX":[function(require,module,exports,__globalThis) {
'use strict';
var _interopRequireDefault = require("40c0ac0ef28fe2b3")["default"];
var _objectSpread2 = _interopRequireDefault(require("ffff63f92b982cf0"));
var useLazyLoadQuery = require("529c23f6b4cc7947");
function useClientQuery(gqlQuery, variables, options) {
    var query = gqlQuery;
    return useLazyLoadQuery(query, variables, (0, _objectSpread2["default"])((0, _objectSpread2["default"])({}, options), {}, {
        fetchPolicy: 'store-only'
    }));
}
module.exports = useClientQuery;

},{"40c0ac0ef28fe2b3":"590td","ffff63f92b982cf0":"2Bj1n","529c23f6b4cc7947":"jPRDt"}],"jPRDt":[function(require,module,exports,__globalThis) {
'use strict';
var useLazyLoadQueryNode = require("2df35e424b93be15");
var useMemoOperationDescriptor = require("bf6ba479675f72c");
var useRelayEnvironment = require("b94d6dfe73016bd9");
var _require = require("ce6dffbe96a9ef1a"), fetchQuery = _require.__internal.fetchQuery;
function useLazyLoadQuery(gqlQuery, variables, options) {
    var environment = useRelayEnvironment();
    var query = useMemoOperationDescriptor(gqlQuery, variables, options && options.networkCacheConfig ? options.networkCacheConfig : {
        force: true
    });
    var data = useLazyLoadQueryNode({
        componentDisplayName: 'useLazyLoadQuery()',
        fetchKey: options === null || options === void 0 ? void 0 : options.fetchKey,
        fetchObservable: fetchQuery(environment, query),
        fetchPolicy: options === null || options === void 0 ? void 0 : options.fetchPolicy,
        query: query,
        renderPolicy: options === null || options === void 0 ? void 0 : options.UNSTABLE_renderPolicy
    });
    return data;
}
module.exports = useLazyLoadQuery;

},{"2df35e424b93be15":"lkkQW","bf6ba479675f72c":"jnI2X","b94d6dfe73016bd9":"bs9Iy","ce6dffbe96a9ef1a":"2IxFR"}],"lkkQW":[function(require,module,exports,__globalThis) {
'use strict';
var ProfilerContext = require("963e5ae9c2f05d23");
var _require = require("8daf22736d02b4fd"), getQueryCacheIdentifier = _require.getQueryCacheIdentifier, getQueryResourceForEnvironment = _require.getQueryResourceForEnvironment;
var useFetchTrackingRef = require("adf3777d057f6b90");
var useFragmentInternal = require("71439a7e828133cf");
var useRelayEnvironment = require("acabe2ac8edf4d3f");
var React = require("35ffd4423e81259d");
var useContext = React.useContext, useEffect = React.useEffect, useState = React.useState, useRef = React.useRef;
function useLazyLoadQueryNode(_ref) {
    var query = _ref.query, componentDisplayName = _ref.componentDisplayName, fetchObservable = _ref.fetchObservable, fetchPolicy = _ref.fetchPolicy, fetchKey = _ref.fetchKey, renderPolicy = _ref.renderPolicy;
    var environment = useRelayEnvironment();
    var profilerContext = useContext(ProfilerContext);
    var QueryResource = getQueryResourceForEnvironment(environment);
    var _useState = useState(0), forceUpdateKey = _useState[0], forceUpdate = _useState[1];
    var _useFetchTrackingRef = useFetchTrackingRef(), startFetch = _useFetchTrackingRef.startFetch, completeFetch = _useFetchTrackingRef.completeFetch;
    var cacheBreaker = "".concat(forceUpdateKey, "-").concat(fetchKey !== null && fetchKey !== void 0 ? fetchKey : '');
    var cacheIdentifier = getQueryCacheIdentifier(environment, query, fetchPolicy, renderPolicy, cacheBreaker);
    var preparedQueryResult = profilerContext.wrapPrepareQueryResource(function() {
        return QueryResource.prepareWithIdentifier(cacheIdentifier, query, fetchObservable, fetchPolicy, renderPolicy, {
            start: startFetch,
            complete: completeFetch,
            error: completeFetch
        }, profilerContext);
    });
    var maybeHiddenOrFastRefresh = useRef(false);
    useEffect(function() {
        return function() {
            maybeHiddenOrFastRefresh.current = true;
        };
    }, []);
    useEffect(function() {
        if (maybeHiddenOrFastRefresh.current === true) {
            maybeHiddenOrFastRefresh.current = false;
            forceUpdate(function(n) {
                return n + 1;
            });
            return;
        }
        var disposable = QueryResource.retain(preparedQueryResult, profilerContext);
        return function() {
            disposable.dispose();
        };
    }, [
        environment,
        cacheIdentifier
    ]);
    useEffect(function() {
        QueryResource.releaseTemporaryRetain(preparedQueryResult);
    });
    var fragmentNode = preparedQueryResult.fragmentNode, fragmentRef = preparedQueryResult.fragmentRef;
    var data = useFragmentInternal(fragmentNode, fragmentRef, componentDisplayName);
    return data;
}
module.exports = useLazyLoadQueryNode;

},{"963e5ae9c2f05d23":"1lEHI","8daf22736d02b4fd":"gv1jq","adf3777d057f6b90":"inPRo","71439a7e828133cf":"eglKT","acabe2ac8edf4d3f":"bs9Iy","35ffd4423e81259d":"ltHCL"}],"gv1jq":[function(require,module,exports,__globalThis) {
'use strict';
var _interopRequireDefault = require("8c74228362cadead")["default"];
var _objectSpread2 = _interopRequireDefault(require("80166d1c304ae95c"));
var _defineProperty2 = _interopRequireDefault(require("29ed99e7fa990ae6"));
var LRUCache = require("e0cee57721c50a5f");
var SuspenseResource = require("9b021e44e4b46980");
var invariant = require("a4fad400719b5e5a");
var _require = require("4055f8e8a24a0bfd"), isPromise = _require.isPromise;
var warning = require("d0fc8ca75b8ebb01");
var CACHE_CAPACITY = 1000;
var DEFAULT_FETCH_POLICY = 'store-or-network';
var DEFAULT_LIVE_FETCH_POLICY = 'store-and-network';
var WEAKMAP_SUPPORTED = typeof WeakMap === 'function';
function operationIsLiveQuery(operation) {
    return operation.request.node.params.metadata.live !== undefined;
}
function getQueryCacheIdentifier(environment, operation, maybeFetchPolicy, maybeRenderPolicy, cacheBreaker) {
    var fetchPolicy = maybeFetchPolicy !== null && maybeFetchPolicy !== void 0 ? maybeFetchPolicy : operationIsLiveQuery(operation) ? DEFAULT_LIVE_FETCH_POLICY : DEFAULT_FETCH_POLICY;
    var renderPolicy = maybeRenderPolicy !== null && maybeRenderPolicy !== void 0 ? maybeRenderPolicy : environment.UNSTABLE_getDefaultRenderPolicy();
    var cacheIdentifier = "".concat(fetchPolicy, "-").concat(renderPolicy, "-").concat(operation.request.identifier);
    if (cacheBreaker != null) return "".concat(cacheIdentifier, "-").concat(cacheBreaker);
    return cacheIdentifier;
}
function getQueryResult(operation, cacheIdentifier) {
    var rootFragmentRef = {
        __id: operation.fragment.dataID,
        __fragments: (0, _defineProperty2["default"])({}, operation.fragment.node.name, operation.request.variables),
        __fragmentOwner: operation.request
    };
    return {
        cacheIdentifier: cacheIdentifier,
        fragmentNode: operation.request.node.fragment,
        fragmentRef: rootFragmentRef,
        operation: operation
    };
}
var nextID = 200000;
function createCacheEntry(cacheIdentifier, operation, operationAvailability, value, networkSubscription, onDispose) {
    var isLiveQuery = operationIsLiveQuery(operation);
    var currentValue = value;
    var currentNetworkSubscription = networkSubscription;
    var suspenseResource = new SuspenseResource(function(environment) {
        var retention = environment.retain(operation);
        return {
            dispose: function dispose() {
                if (isLiveQuery && currentNetworkSubscription != null) currentNetworkSubscription.unsubscribe();
                retention.dispose();
                onDispose(cacheEntry);
            }
        };
    });
    var cacheEntry = {
        cacheIdentifier: cacheIdentifier,
        id: nextID++,
        processedPayloadsCount: 0,
        operationAvailability: operationAvailability,
        getValue: function getValue() {
            return currentValue;
        },
        setValue: function setValue(val) {
            currentValue = val;
        },
        setNetworkSubscription: function setNetworkSubscription(subscription) {
            if (isLiveQuery && currentNetworkSubscription != null) currentNetworkSubscription.unsubscribe();
            currentNetworkSubscription = subscription;
        },
        temporaryRetain: function temporaryRetain(environment) {
            return suspenseResource.temporaryRetain(environment);
        },
        permanentRetain: function permanentRetain(environment) {
            return suspenseResource.permanentRetain(environment);
        },
        releaseTemporaryRetain: function releaseTemporaryRetain() {
            suspenseResource.releaseTemporaryRetain();
        }
    };
    return cacheEntry;
}
var QueryResourceImpl = /*#__PURE__*/ function() {
    function QueryResourceImpl(environment) {
        var _this = this;
        (0, _defineProperty2["default"])(this, "_clearCacheEntry", function(cacheEntry) {
            _this._cache["delete"](cacheEntry.cacheIdentifier);
        });
        this._environment = environment;
        this._cache = LRUCache.create(CACHE_CAPACITY);
    }
    var _proto = QueryResourceImpl.prototype;
    _proto.prepare = function prepare(operation, fetchObservable, maybeFetchPolicy, maybeRenderPolicy, observer, cacheBreaker, profilerContext) {
        var cacheIdentifier = getQueryCacheIdentifier(this._environment, operation, maybeFetchPolicy, maybeRenderPolicy, cacheBreaker);
        return this.prepareWithIdentifier(cacheIdentifier, operation, fetchObservable, maybeFetchPolicy, maybeRenderPolicy, observer, profilerContext);
    };
    _proto.prepareWithIdentifier = function prepareWithIdentifier(cacheIdentifier, operation, fetchObservable, maybeFetchPolicy, maybeRenderPolicy, observer, profilerContext) {
        var environment = this._environment;
        var fetchPolicy = maybeFetchPolicy !== null && maybeFetchPolicy !== void 0 ? maybeFetchPolicy : operationIsLiveQuery(operation) ? DEFAULT_LIVE_FETCH_POLICY : DEFAULT_FETCH_POLICY;
        var renderPolicy = maybeRenderPolicy !== null && maybeRenderPolicy !== void 0 ? maybeRenderPolicy : environment.UNSTABLE_getDefaultRenderPolicy();
        var cacheEntry = this._cache.get(cacheIdentifier);
        var temporaryRetainDisposable = null;
        var entryWasCached = cacheEntry != null;
        if (cacheEntry == null) cacheEntry = this._fetchAndSaveQuery(cacheIdentifier, operation, fetchObservable, fetchPolicy, renderPolicy, profilerContext, (0, _objectSpread2["default"])((0, _objectSpread2["default"])({}, observer), {}, {
            unsubscribe: function unsubscribe(subscription) {
                if (temporaryRetainDisposable != null) temporaryRetainDisposable.dispose();
                var observerUnsubscribe = observer === null || observer === void 0 ? void 0 : observer.unsubscribe;
                observerUnsubscribe && observerUnsubscribe(subscription);
            }
        }));
        temporaryRetainDisposable = cacheEntry.temporaryRetain(environment);
        var cachedValue = cacheEntry.getValue();
        if (isPromise(cachedValue)) {
            environment.__log({
                name: 'suspense.query',
                fetchPolicy: fetchPolicy,
                isPromiseCached: entryWasCached,
                operation: operation,
                queryAvailability: cacheEntry.operationAvailability,
                renderPolicy: renderPolicy
            });
            throw cachedValue;
        }
        if (cachedValue instanceof Error) throw cachedValue;
        return cachedValue;
    };
    _proto.retain = function retain(queryResult, profilerContext) {
        var environment = this._environment;
        var cacheIdentifier = queryResult.cacheIdentifier, operation = queryResult.operation;
        var cacheEntry = this._getOrCreateCacheEntry(cacheIdentifier, operation, null, queryResult, null);
        var disposable = cacheEntry.permanentRetain(environment);
        environment.__log({
            name: 'queryresource.retain',
            profilerContext: profilerContext,
            resourceID: cacheEntry.id
        });
        return {
            dispose: function dispose() {
                disposable.dispose();
            }
        };
    };
    _proto.releaseTemporaryRetain = function releaseTemporaryRetain(queryResult) {
        var cacheEntry = this._cache.get(queryResult.cacheIdentifier);
        if (cacheEntry != null) cacheEntry.releaseTemporaryRetain();
    };
    _proto.TESTS_ONLY__getCacheEntry = function TESTS_ONLY__getCacheEntry(operation, maybeFetchPolicy, maybeRenderPolicy, cacheBreaker) {
        var environment = this._environment;
        var cacheIdentifier = getQueryCacheIdentifier(environment, operation, maybeFetchPolicy, maybeRenderPolicy, cacheBreaker);
        return this._cache.get(cacheIdentifier);
    };
    _proto._getOrCreateCacheEntry = function _getOrCreateCacheEntry(cacheIdentifier, operation, operationAvailability, value, networkSubscription) {
        var cacheEntry = this._cache.get(cacheIdentifier);
        if (cacheEntry == null) {
            cacheEntry = createCacheEntry(cacheIdentifier, operation, operationAvailability, value, networkSubscription, this._clearCacheEntry);
            this._cache.set(cacheIdentifier, cacheEntry);
        }
        return cacheEntry;
    };
    _proto._fetchAndSaveQuery = function _fetchAndSaveQuery(cacheIdentifier, operation, fetchObservable, fetchPolicy, renderPolicy, profilerContext, observer) {
        var _this2 = this;
        var environment = this._environment;
        var queryAvailability = environment.check(operation);
        var queryStatus = queryAvailability.status;
        var hasFullQuery = queryStatus === 'available';
        var canPartialRender = hasFullQuery || renderPolicy === 'partial' && queryStatus !== 'stale';
        var shouldFetch;
        var shouldAllowRender;
        var resolveNetworkPromise = function resolveNetworkPromise() {};
        switch(fetchPolicy){
            case 'store-only':
                shouldFetch = false;
                shouldAllowRender = true;
                break;
            case 'store-or-network':
                shouldFetch = !hasFullQuery;
                shouldAllowRender = canPartialRender;
                break;
            case 'store-and-network':
                shouldFetch = true;
                shouldAllowRender = canPartialRender;
                break;
            case 'network-only':
            default:
                shouldFetch = true;
                shouldAllowRender = false;
                break;
        }
        if (shouldAllowRender) {
            var queryResult = getQueryResult(operation, cacheIdentifier);
            var _cacheEntry = createCacheEntry(cacheIdentifier, operation, queryAvailability, queryResult, null, this._clearCacheEntry);
            this._cache.set(cacheIdentifier, _cacheEntry);
        }
        if (shouldFetch) {
            var _queryResult = getQueryResult(operation, cacheIdentifier);
            var networkSubscription;
            fetchObservable.subscribe({
                start: function start(subscription) {
                    networkSubscription = subscription;
                    var cacheEntry = _this2._cache.get(cacheIdentifier);
                    if (cacheEntry) cacheEntry.setNetworkSubscription(networkSubscription);
                    var observerStart = observer === null || observer === void 0 ? void 0 : observer.start;
                    if (observerStart) {
                        var subscriptionWithConditionalCancelation = (0, _objectSpread2["default"])((0, _objectSpread2["default"])({}, subscription), {}, {
                            unsubscribe: function unsubscribe() {
                                if (operationIsLiveQuery(operation)) subscription.unsubscribe();
                            }
                        });
                        observerStart(subscriptionWithConditionalCancelation);
                    }
                },
                next: function next() {
                    var cacheEntry = _this2._getOrCreateCacheEntry(cacheIdentifier, operation, queryAvailability, _queryResult, networkSubscription);
                    cacheEntry.processedPayloadsCount += 1;
                    cacheEntry.setValue(_queryResult);
                    resolveNetworkPromise();
                    var observerNext = observer === null || observer === void 0 ? void 0 : observer.next;
                    if (observerNext != null) {
                        var snapshot = environment.lookup(operation.fragment);
                        observerNext(snapshot);
                    }
                },
                error: function error(_error) {
                    var cacheEntry = _this2._getOrCreateCacheEntry(cacheIdentifier, operation, queryAvailability, _error, networkSubscription);
                    if (cacheEntry.processedPayloadsCount === 0) cacheEntry.setValue(_error);
                    resolveNetworkPromise();
                    networkSubscription = null;
                    cacheEntry.setNetworkSubscription(null);
                    var observerError = observer === null || observer === void 0 ? void 0 : observer.error;
                    observerError && observerError(_error);
                },
                complete: function complete() {
                    resolveNetworkPromise();
                    networkSubscription = null;
                    var cacheEntry = _this2._cache.get(cacheIdentifier);
                    if (cacheEntry) cacheEntry.setNetworkSubscription(null);
                    var observerComplete = observer === null || observer === void 0 ? void 0 : observer.complete;
                    observerComplete && observerComplete();
                },
                unsubscribe: observer === null || observer === void 0 ? void 0 : observer.unsubscribe
            });
            var _cacheEntry2 = this._cache.get(cacheIdentifier);
            if (!_cacheEntry2) {
                var networkPromise = new Promise(function(resolve) {
                    resolveNetworkPromise = resolve;
                });
                networkPromise.displayName = 'Relay(' + operation.fragment.node.name + ')';
                _cacheEntry2 = createCacheEntry(cacheIdentifier, operation, queryAvailability, networkPromise, networkSubscription, this._clearCacheEntry);
                this._cache.set(cacheIdentifier, _cacheEntry2);
            }
        } else {
            var observerComplete = observer === null || observer === void 0 ? void 0 : observer.complete;
            observerComplete && observerComplete();
        }
        var cacheEntry = this._cache.get(cacheIdentifier);
        !(cacheEntry != null) && invariant(false);
        environment.__log({
            name: 'queryresource.fetch',
            resourceID: cacheEntry.id,
            operation: operation,
            profilerContext: profilerContext,
            fetchPolicy: fetchPolicy,
            renderPolicy: renderPolicy,
            queryAvailability: queryAvailability,
            shouldFetch: shouldFetch
        });
        return cacheEntry;
    };
    return QueryResourceImpl;
}();
function createQueryResource(environment) {
    return new QueryResourceImpl(environment);
}
var dataResources = WEAKMAP_SUPPORTED ? new WeakMap() : new Map();
function getQueryResourceForEnvironment(environment) {
    var cached = dataResources.get(environment);
    if (cached) return cached;
    var newDataResource = createQueryResource(environment);
    dataResources.set(environment, newDataResource);
    return newDataResource;
}
module.exports = {
    createQueryResource: createQueryResource,
    getQueryResourceForEnvironment: getQueryResourceForEnvironment,
    getQueryCacheIdentifier: getQueryCacheIdentifier
};

},{"8c74228362cadead":"590td","80166d1c304ae95c":"2Bj1n","29ed99e7fa990ae6":"2paQ8","e0cee57721c50a5f":"9LEGe","9b021e44e4b46980":"dPTmI","a4fad400719b5e5a":"e2sci","4055f8e8a24a0bfd":"2IxFR","d0fc8ca75b8ebb01":"j64TH"}],"9LEGe":[function(require,module,exports,__globalThis) {
'use strict';
var invariant = require("f3b6d9c0bebc71d7");
var LRUCache = /*#__PURE__*/ function() {
    function LRUCache(capacity) {
        this._capacity = capacity;
        !(this._capacity > 0) && invariant(false);
        this._map = new Map();
    }
    var _proto = LRUCache.prototype;
    _proto.set = function set(key, value) {
        this._map["delete"](key);
        this._map.set(key, value);
        if (this._map.size > this._capacity) {
            var firstKey = this._map.keys().next();
            if (!firstKey.done) this._map["delete"](firstKey.value);
        }
    };
    _proto.get = function get(key) {
        var value = this._map.get(key);
        if (value != null) {
            this._map["delete"](key);
            this._map.set(key, value);
        }
        return value;
    };
    _proto.has = function has(key) {
        return this._map.has(key);
    };
    _proto["delete"] = function _delete(key) {
        this._map["delete"](key);
    };
    _proto.size = function size() {
        return this._map.size;
    };
    _proto.capacity = function capacity() {
        return this._capacity - this._map.size;
    };
    _proto.clear = function clear() {
        this._map.clear();
    };
    return LRUCache;
}();
function create(capacity) {
    return new LRUCache(capacity);
}
module.exports = {
    create: create
};

},{"f3b6d9c0bebc71d7":"e2sci"}],"dPTmI":[function(require,module,exports,__globalThis) {
'use strict';
var _interopRequireDefault = require("a9985309bbbdff86")["default"];
var _defineProperty2 = _interopRequireDefault(require("96df57d9c4d1df35"));
var warning = require("46b029b89b2aec71");
var TEMPORARY_RETAIN_DURATION_MS = 300000;
var SuspenseResource = /*#__PURE__*/ function() {
    function SuspenseResource(retain) {
        var _this = this;
        (0, _defineProperty2["default"])(this, "_retainCount", 0);
        (0, _defineProperty2["default"])(this, "_retainDisposable", null);
        (0, _defineProperty2["default"])(this, "_releaseTemporaryRetain", null);
        this._retain = function(environment) {
            _this._retainCount++;
            if (_this._retainCount === 1) _this._retainDisposable = retain(environment);
            return {
                dispose: function dispose() {
                    _this._retainCount = Math.max(0, _this._retainCount - 1);
                    if (_this._retainCount === 0) {
                        if (_this._retainDisposable != null) {
                            _this._retainDisposable.dispose();
                            _this._retainDisposable = null;
                        }
                    }
                }
            };
        };
    }
    var _proto = SuspenseResource.prototype;
    _proto.temporaryRetain = function temporaryRetain(environment) {
        var _this2 = this;
        var _this$_releaseTempora;
        if (environment.isServer()) return {
            dispose: function dispose() {}
        };
        var retention = this._retain(environment);
        var releaseQueryTimeout = null;
        var releaseTemporaryRetain = function releaseTemporaryRetain() {
            clearTimeout(releaseQueryTimeout);
            releaseQueryTimeout = null;
            _this2._releaseTemporaryRetain = null;
            retention.dispose();
        };
        releaseQueryTimeout = setTimeout(releaseTemporaryRetain, TEMPORARY_RETAIN_DURATION_MS);
        (_this$_releaseTempora = this._releaseTemporaryRetain) === null || _this$_releaseTempora === void 0 || _this$_releaseTempora.call(this);
        this._releaseTemporaryRetain = releaseTemporaryRetain;
        return {
            dispose: function dispose() {
                var _this$_releaseTempora2;
                (_this$_releaseTempora2 = _this2._releaseTemporaryRetain) === null || _this$_releaseTempora2 === void 0 || _this$_releaseTempora2.call(_this2);
            }
        };
    };
    _proto.permanentRetain = function permanentRetain(environment) {
        var disposable = this._retain(environment);
        this.releaseTemporaryRetain();
        return disposable;
    };
    _proto.releaseTemporaryRetain = function releaseTemporaryRetain() {
        var _this$_releaseTempora3;
        (_this$_releaseTempora3 = this._releaseTemporaryRetain) === null || _this$_releaseTempora3 === void 0 || _this$_releaseTempora3.call(this);
        this._releaseTemporaryRetain = null;
    };
    _proto.getRetainCount = function getRetainCount() {
        return this._retainCount;
    };
    return SuspenseResource;
}();
module.exports = SuspenseResource;

},{"a9985309bbbdff86":"590td","96df57d9c4d1df35":"2paQ8","46b029b89b2aec71":"j64TH"}],"inPRo":[function(require,module,exports,__globalThis) {
'use strict';
var useUnsafeRef_DEPRECATED = require("cb5955a09110ebb3");
var _require = require("9a3c8538fc0f0f61"), useCallback = _require.useCallback, useEffect = _require.useEffect;
function useFetchTrackingRef() {
    var subscriptionRef = useUnsafeRef_DEPRECATED(null);
    var isFetchingRef = useUnsafeRef_DEPRECATED(false);
    var disposeFetch = useCallback(function() {
        if (subscriptionRef.current != null) {
            subscriptionRef.current.unsubscribe();
            subscriptionRef.current = null;
        }
        isFetchingRef.current = false;
    }, []);
    var startFetch = useCallback(function(subscription) {
        subscriptionRef.current = subscription;
        isFetchingRef.current = true;
    }, []);
    var completeFetch = useCallback(function() {
        subscriptionRef.current = null;
        isFetchingRef.current = false;
    }, []);
    useEffect(function() {
        return disposeFetch;
    }, [
        disposeFetch
    ]);
    return {
        isFetchingRef: isFetchingRef,
        startFetch: startFetch,
        disposeFetch: disposeFetch,
        completeFetch: completeFetch
    };
}
module.exports = useFetchTrackingRef;

},{"cb5955a09110ebb3":"eslBO","9a3c8538fc0f0f61":"ltHCL"}],"eslBO":[function(require,module,exports,__globalThis) {
'use strict';
var _require = require("e5a44dc070d2f0a"), useMemo = _require.useMemo;
function useUnsafeRef_DEPRECATED(init) {
    return useMemo(function() {
        return {
            current: init
        };
    }, []);
}
module.exports = useUnsafeRef_DEPRECATED;

},{"e5a44dc070d2f0a":"ltHCL"}],"eglKT":[function(require,module,exports,__globalThis) {
'use strict';
var _interopRequireDefault = require("62731ed9b42ef683")["default"];
var _useFragmentInternal_CURRENT = _interopRequireDefault(require("e51af9fe44111068"));
var _useFragmentInternal_EXPERIMENTAL = _interopRequireDefault(require("f1cbb6854a7ebea6"));
var _relayRuntime = require("e50215f2293434a");
function useFragmentInternal(fragmentNode, fragmentRef, hookDisplayName, queryOptions) {
    if (_relayRuntime.RelayFeatureFlags.ENABLE_ACTIVITY_COMPATIBILITY) return (0, _useFragmentInternal_EXPERIMENTAL["default"])(fragmentNode, fragmentRef, hookDisplayName, queryOptions);
    return (0, _useFragmentInternal_CURRENT["default"])(fragmentNode, fragmentRef, hookDisplayName, queryOptions);
}
module.exports = useFragmentInternal;

},{"62731ed9b42ef683":"590td","e51af9fe44111068":"hsg1N","f1cbb6854a7ebea6":"ddjmE","e50215f2293434a":"2IxFR"}],"hsg1N":[function(require,module,exports,__globalThis) {
'use strict';
var _interopRequireDefault = require("2e9fb49b2f102f90")["default"];
var _objectSpread2 = _interopRequireDefault(require("acd076e053624f1b"));
var _createForOfIteratorHelper2 = _interopRequireDefault(require("f8da592f7192ed48"));
var _toConsumableArray2 = _interopRequireDefault(require("f30fdafc7b750c"));
var _require = require("b9eddcd0aefa22a7"), getQueryResourceForEnvironment = _require.getQueryResourceForEnvironment;
var useRelayEnvironment = require("63a5893bafa46afd");
var useRelayLoggingContext = require("5899f47c78ec6794");
var invariant = require("80a93b77af055571");
var _require2 = require("baa77a1366f9b744"), useDebugValue = _require2.useDebugValue, useEffect = _require2.useEffect, useMemo = _require2.useMemo, useRef = _require2.useRef, useState = _require2.useState;
var _require3 = require("8a9a6b5bd4c2501e"), _require3$__internal = _require3.__internal, fetchQueryInternal = _require3$__internal.fetchQuery, getPromiseForActiveRequest = _require3$__internal.getPromiseForActiveRequest, RelayFeatureFlags = _require3.RelayFeatureFlags, areEqualSelectors = _require3.areEqualSelectors, createOperationDescriptor = _require3.createOperationDescriptor, getPendingOperationsForFragment = _require3.getPendingOperationsForFragment, getSelector = _require3.getSelector, getVariablesFromFragment = _require3.getVariablesFromFragment, handlePotentialSnapshotErrors = _require3.handlePotentialSnapshotErrors, recycleNodesInto = _require3.recycleNodesInto;
var warning = require("2196444b1aa0e6c4");
function isMissingData(state) {
    if (state.kind === 'bailout') return false;
    else if (state.kind === 'singular') return state.snapshot.isMissingData;
    else return state.snapshots.some(function(s) {
        return s.isMissingData;
    });
}
function getMissingClientEdges(state) {
    if (state.kind === 'bailout') return null;
    else if (state.kind === 'singular') {
        var _state$snapshot$missi;
        return (_state$snapshot$missi = state.snapshot.missingClientEdges) !== null && _state$snapshot$missi !== void 0 ? _state$snapshot$missi : null;
    } else {
        var edges = null;
        var _iterator = (0, _createForOfIteratorHelper2["default"])(state.snapshots), _step;
        try {
            for(_iterator.s(); !(_step = _iterator.n()).done;){
                var snapshot = _step.value;
                if (snapshot.missingClientEdges) {
                    var _edges;
                    edges = (_edges = edges) !== null && _edges !== void 0 ? _edges : [];
                    var _iterator2 = (0, _createForOfIteratorHelper2["default"])(snapshot.missingClientEdges), _step2;
                    try {
                        for(_iterator2.s(); !(_step2 = _iterator2.n()).done;){
                            var edge = _step2.value;
                            edges.push(edge);
                        }
                    } catch (err) {
                        _iterator2.e(err);
                    } finally{
                        _iterator2.f();
                    }
                }
            }
        } catch (err) {
            _iterator.e(err);
        } finally{
            _iterator.f();
        }
        return edges;
    }
}
function getSuspendingLiveResolver(state) {
    if (state.kind === 'bailout') return null;
    else if (state.kind === 'singular') {
        var _state$snapshot$missi2;
        return (_state$snapshot$missi2 = state.snapshot.missingLiveResolverFields) !== null && _state$snapshot$missi2 !== void 0 ? _state$snapshot$missi2 : null;
    } else {
        var missingFields = null;
        var _iterator3 = (0, _createForOfIteratorHelper2["default"])(state.snapshots), _step3;
        try {
            for(_iterator3.s(); !(_step3 = _iterator3.n()).done;){
                var snapshot = _step3.value;
                if (snapshot.missingLiveResolverFields) {
                    var _missingFields;
                    missingFields = (_missingFields = missingFields) !== null && _missingFields !== void 0 ? _missingFields : [];
                    var _iterator4 = (0, _createForOfIteratorHelper2["default"])(snapshot.missingLiveResolverFields), _step4;
                    try {
                        for(_iterator4.s(); !(_step4 = _iterator4.n()).done;){
                            var edge = _step4.value;
                            missingFields.push(edge);
                        }
                    } catch (err) {
                        _iterator4.e(err);
                    } finally{
                        _iterator4.f();
                    }
                }
            }
        } catch (err) {
            _iterator3.e(err);
        } finally{
            _iterator3.f();
        }
        return missingFields;
    }
}
function handlePotentialSnapshotErrorsForState(environment, state, loggingContext) {
    if (state.kind === 'singular') handlePotentialSnapshotErrors(environment, state.snapshot.fieldErrors, loggingContext);
    else if (state.kind === 'plural') {
        var _iterator5 = (0, _createForOfIteratorHelper2["default"])(state.snapshots), _step5;
        try {
            for(_iterator5.s(); !(_step5 = _iterator5.n()).done;){
                var snapshot = _step5.value;
                handlePotentialSnapshotErrors(environment, snapshot.fieldErrors, loggingContext);
            }
        } catch (err) {
            _iterator5.e(err);
        } finally{
            _iterator5.f();
        }
    }
}
function handleMissedUpdates(environment, state) {
    if (state.kind === 'bailout') return null;
    var currentEpoch = environment.getStore().getEpoch();
    if (currentEpoch === state.epoch) return null;
    if (state.kind === 'singular') {
        var currentSnapshot = environment.lookup(state.snapshot.selector);
        var updatedData = recycleNodesInto(state.snapshot.data, currentSnapshot.data);
        var updatedCurrentSnapshot = {
            data: updatedData,
            isMissingData: currentSnapshot.isMissingData,
            missingClientEdges: currentSnapshot.missingClientEdges,
            missingLiveResolverFields: currentSnapshot.missingLiveResolverFields,
            seenRecords: currentSnapshot.seenRecords,
            selector: currentSnapshot.selector,
            fieldErrors: currentSnapshot.fieldErrors
        };
        return [
            updatedData !== state.snapshot.data,
            {
                kind: 'singular',
                snapshot: updatedCurrentSnapshot,
                epoch: currentEpoch
            }
        ];
    } else {
        var didMissUpdates = false;
        var currentSnapshots = [];
        for(var index = 0; index < state.snapshots.length; index++){
            var snapshot = state.snapshots[index];
            var _currentSnapshot = environment.lookup(snapshot.selector);
            var _updatedData = recycleNodesInto(snapshot.data, _currentSnapshot.data);
            var _updatedCurrentSnapshot = {
                data: _updatedData,
                isMissingData: _currentSnapshot.isMissingData,
                missingClientEdges: _currentSnapshot.missingClientEdges,
                missingLiveResolverFields: _currentSnapshot.missingLiveResolverFields,
                seenRecords: _currentSnapshot.seenRecords,
                selector: _currentSnapshot.selector,
                fieldErrors: _currentSnapshot.fieldErrors
            };
            if (_updatedData !== snapshot.data) didMissUpdates = true;
            currentSnapshots.push(_updatedCurrentSnapshot);
        }
        !(currentSnapshots.length === state.snapshots.length) && invariant(false);
        return [
            didMissUpdates,
            {
                kind: 'plural',
                snapshots: currentSnapshots,
                epoch: currentEpoch
            }
        ];
    }
}
function handleMissingClientEdge(environment, parentFragmentNode, parentFragmentRef, missingClientEdgeRequestInfo, queryOptions) {
    var originalVariables = getVariablesFromFragment(parentFragmentNode, parentFragmentRef);
    var variables = (0, _objectSpread2["default"])((0, _objectSpread2["default"])({}, originalVariables), {}, {
        id: missingClientEdgeRequestInfo.clientEdgeDestinationID
    });
    var queryOperationDescriptor = createOperationDescriptor(missingClientEdgeRequestInfo.request, variables, queryOptions === null || queryOptions === void 0 ? void 0 : queryOptions.networkCacheConfig);
    var QueryResource = getQueryResourceForEnvironment(environment);
    var queryResult = QueryResource.prepare(queryOperationDescriptor, fetchQueryInternal(environment, queryOperationDescriptor), queryOptions === null || queryOptions === void 0 ? void 0 : queryOptions.fetchPolicy);
    return [
        queryResult,
        getPromiseForActiveRequest(environment, queryOperationDescriptor.request)
    ];
}
function subscribeToSnapshot(environment, state, setState, hasPendingStateChanges) {
    if (state.kind === 'bailout') return function() {};
    else if (state.kind === 'singular') {
        var disposable = environment.subscribe(state.snapshot, function(latestSnapshot) {
            setState(function(prevState) {
                if (prevState.kind !== 'singular' || prevState.snapshot.selector !== latestSnapshot.selector) {
                    var updates = handleMissedUpdates(environment, prevState);
                    if (updates != null) {
                        var dataChanged = updates[0], nextState = updates[1];
                        environment.__log({
                            name: 'useFragment.subscription.missedUpdates',
                            hasDataChanges: dataChanged
                        });
                        hasPendingStateChanges.current = dataChanged;
                        return dataChanged ? nextState : prevState;
                    } else return prevState;
                }
                hasPendingStateChanges.current = true;
                return {
                    kind: 'singular',
                    snapshot: latestSnapshot,
                    epoch: environment.getStore().getEpoch()
                };
            });
        });
        return function() {
            disposable.dispose();
        };
    } else {
        var disposables = state.snapshots.map(function(snapshot, index) {
            return environment.subscribe(snapshot, function(latestSnapshot) {
                setState(function(prevState) {
                    var _prevState$snapshots$;
                    if (prevState.kind !== 'plural' || ((_prevState$snapshots$ = prevState.snapshots[index]) === null || _prevState$snapshots$ === void 0 ? void 0 : _prevState$snapshots$.selector) !== latestSnapshot.selector) {
                        var updates = handleMissedUpdates(environment, prevState);
                        if (updates != null) {
                            var dataChanged = updates[0], nextState = updates[1];
                            environment.__log({
                                name: 'useFragment.subscription.missedUpdates',
                                hasDataChanges: dataChanged
                            });
                            hasPendingStateChanges.current = hasPendingStateChanges.current || dataChanged;
                            return dataChanged ? nextState : prevState;
                        } else return prevState;
                    }
                    var updated = (0, _toConsumableArray2["default"])(prevState.snapshots);
                    updated[index] = latestSnapshot;
                    hasPendingStateChanges.current = true;
                    return {
                        kind: 'plural',
                        snapshots: updated,
                        epoch: environment.getStore().getEpoch()
                    };
                });
            });
        });
        return function() {
            var _iterator6 = (0, _createForOfIteratorHelper2["default"])(disposables), _step6;
            try {
                for(_iterator6.s(); !(_step6 = _iterator6.n()).done;){
                    var d = _step6.value;
                    d.dispose();
                }
            } catch (err) {
                _iterator6.e(err);
            } finally{
                _iterator6.f();
            }
        };
    }
}
function getFragmentState(environment, fragmentSelector) {
    if (fragmentSelector == null) return {
        kind: 'bailout'
    };
    else if (fragmentSelector.kind === 'PluralReaderSelector') return {
        kind: 'plural',
        snapshots: fragmentSelector.selectors.map(function(s) {
            return environment.lookup(s);
        }),
        epoch: environment.getStore().getEpoch()
    };
    else return {
        kind: 'singular',
        snapshot: environment.lookup(fragmentSelector),
        epoch: environment.getStore().getEpoch()
    };
}
function useFragmentInternal(fragmentNode, fragmentRef, hookDisplayName, queryOptions) {
    var _fragmentNode$metadat, _fragmentNode$metadat2;
    var fragmentSelector = useMemo(function() {
        return getSelector(fragmentNode, fragmentRef);
    }, [
        fragmentNode,
        fragmentRef
    ]);
    var isPlural = (fragmentNode === null || fragmentNode === void 0 ? void 0 : (_fragmentNode$metadat = fragmentNode.metadata) === null || _fragmentNode$metadat === void 0 ? void 0 : _fragmentNode$metadat.plural) === true;
    if (isPlural) !(fragmentRef == null || Array.isArray(fragmentRef)) && invariant(false);
    else !!Array.isArray(fragmentRef) && invariant(false);
    !(fragmentRef == null || isPlural && Array.isArray(fragmentRef) && fragmentRef.length === 0 || fragmentSelector != null) && invariant(false);
    var environment = useRelayEnvironment();
    var loggerContext;
    if (RelayFeatureFlags.ENABLE_UI_CONTEXT_ON_RELAY_LOGGER) loggerContext = useRelayLoggingContext();
    var _useState = useState(function() {
        return getFragmentState(environment, fragmentSelector);
    }), _state = _useState[0], setState = _useState[1];
    var state = _state;
    var _useState2 = useState(state), _subscribedState = _useState2[0], setSubscribedState = _useState2[1];
    var subscribedState = _subscribedState;
    var _useState3 = useState(fragmentSelector), previousFragmentSelector = _useState3[0], setPreviousFragmentSelector = _useState3[1];
    var _useState4 = useState(environment), previousEnvironment = _useState4[0], setPreviousEnvironment = _useState4[1];
    if (!areEqualSelectors(fragmentSelector, previousFragmentSelector) || environment !== previousEnvironment) {
        setPreviousFragmentSelector(fragmentSelector);
        setPreviousEnvironment(environment);
        var newState = getFragmentState(environment, fragmentSelector);
        setState(newState);
        setSubscribedState(newState);
        state = newState;
        subscribedState = newState;
    }
    var committedFragmentSelectorRef = useRef(false);
    useEffect(function() {
        committedFragmentSelectorRef.current = fragmentSelector;
    }, [
        fragmentSelector
    ]);
    if (((_fragmentNode$metadat2 = fragmentNode.metadata) === null || _fragmentNode$metadat2 === void 0 ? void 0 : _fragmentNode$metadat2.hasClientEdges) === true || RelayFeatureFlags.CHECK_ALL_FRAGMENTS_FOR_MISSING_CLIENT_EDGES) {
        var _useMemo = useMemo(function() {
            var missingClientEdges = getMissingClientEdges(state);
            var clientEdgeQueries;
            var activeRequestPromises = [];
            if (missingClientEdges !== null && missingClientEdges !== void 0 && missingClientEdges.length) {
                clientEdgeQueries = [];
                var _iterator7 = (0, _createForOfIteratorHelper2["default"])(missingClientEdges), _step7;
                try {
                    for(_iterator7.s(); !(_step7 = _iterator7.n()).done;){
                        var edge = _step7.value;
                        var _handleMissingClientE = handleMissingClientEdge(environment, fragmentNode, fragmentRef, edge, queryOptions), queryResult = _handleMissingClientE[0], requestPromise = _handleMissingClientE[1];
                        clientEdgeQueries.push(queryResult);
                        if (requestPromise != null) activeRequestPromises.push(requestPromise);
                    }
                } catch (err) {
                    _iterator7.e(err);
                } finally{
                    _iterator7.f();
                }
            }
            return [
                clientEdgeQueries,
                activeRequestPromises
            ];
        }, [
            state,
            environment,
            fragmentNode,
            fragmentRef,
            queryOptions
        ]), clientEdgeQueries = _useMemo[0], activeRequestPromises = _useMemo[1];
        if (activeRequestPromises.length) throw Promise.all(activeRequestPromises);
        useEffect(function() {
            var QueryResource = getQueryResourceForEnvironment(environment);
            if (clientEdgeQueries !== null && clientEdgeQueries !== void 0 && clientEdgeQueries.length) {
                var disposables = [];
                var _iterator8 = (0, _createForOfIteratorHelper2["default"])(clientEdgeQueries), _step8;
                try {
                    for(_iterator8.s(); !(_step8 = _iterator8.n()).done;){
                        var query = _step8.value;
                        disposables.push(QueryResource.retain(query));
                    }
                } catch (err) {
                    _iterator8.e(err);
                } finally{
                    _iterator8.f();
                }
                return function() {
                    for(var _i = 0, _disposables = disposables; _i < _disposables.length; _i++){
                        var disposable = _disposables[_i];
                        disposable.dispose();
                    }
                };
            }
        }, [
            environment,
            clientEdgeQueries
        ]);
    }
    if (isMissingData(state)) {
        var suspendingLiveResolvers = getSuspendingLiveResolver(state);
        if (suspendingLiveResolvers != null && suspendingLiveResolvers.length > 0) throw Promise.all(suspendingLiveResolvers.map(function(liveStateID) {
            return environment.getStore().getLiveResolverPromise(liveStateID);
        }));
        if (RelayFeatureFlags.ENABLE_RELAY_OPERATION_TRACKER_SUSPENSE || environment !== previousEnvironment || !committedFragmentSelectorRef.current || !areEqualSelectors(committedFragmentSelectorRef.current, fragmentSelector)) {
            !(fragmentSelector != null) && invariant(false);
            var fragmentOwner = fragmentSelector.kind === 'PluralReaderSelector' ? fragmentSelector.selectors[0].owner : fragmentSelector.owner;
            var pendingOperationsResult = getPendingOperationsForFragment(environment, fragmentNode, fragmentOwner);
            if (pendingOperationsResult) throw pendingOperationsResult.promise;
        }
    }
    handlePotentialSnapshotErrorsForState(environment, state, loggerContext);
    var hasPendingStateChanges = useRef(false);
    useEffect(function() {
        var currentState = subscribedState;
        var updates = handleMissedUpdates(environment, subscribedState);
        if (updates !== null) {
            var didMissUpdates = updates[0], updatedState = updates[1];
            if (didMissUpdates) setState(updatedState);
            currentState = updatedState;
        }
        return subscribeToSnapshot(environment, currentState, setState, hasPendingStateChanges);
    }, [
        environment,
        subscribedState
    ]);
    if (hasPendingStateChanges.current) {
        var updates = handleMissedUpdates(environment, state);
        if (updates != null) {
            var hasStateUpdates = updates[0], updatedState = updates[1];
            if (hasStateUpdates) {
                setState(updatedState);
                state = updatedState;
            }
        }
        hasPendingStateChanges.current = false;
    }
    var data;
    if (isPlural) {
        var fragmentRefIsNullish = fragmentRef == null;
        data = useMemo(function() {
            if (state.kind === 'bailout') return fragmentRefIsNullish ? null : [];
            else {
                !(state.kind === 'plural') && invariant(false);
                return state.snapshots.map(function(s) {
                    return s.data;
                });
            }
        }, [
            state,
            fragmentRefIsNullish
        ]);
    } else if (state.kind === 'bailout') data = null;
    else {
        !(state.kind === 'singular') && invariant(false);
        data = state.snapshot.data;
    }
    if (RelayFeatureFlags.LOG_MISSING_RECORDS_IN_PROD || false) fragmentRef != null && (data === undefined || Array.isArray(data) && data.length > 0 && data.every(function(d) {
        return d === undefined;
    }));
    return data;
}
module.exports = useFragmentInternal;

},{"2e9fb49b2f102f90":"590td","acd076e053624f1b":"2Bj1n","f8da592f7192ed48":"fMaLa","f30fdafc7b750c":"7EBX0","b9eddcd0aefa22a7":"gv1jq","63a5893bafa46afd":"bs9Iy","5899f47c78ec6794":"76Dx1","80a93b77af055571":"e2sci","baa77a1366f9b744":"ltHCL","8a9a6b5bd4c2501e":"2IxFR","2196444b1aa0e6c4":"j64TH"}],"76Dx1":[function(require,module,exports,__globalThis) {
'use strict';
var ReactRelayLoggingContext = require("6ff6452d48f413e7");
var _require = require("a348a4b4b5960b48"), useContext = _require.useContext;
function useRelayLoggingContext() {
    return useContext(ReactRelayLoggingContext);
}
module.exports = useRelayLoggingContext;

},{"6ff6452d48f413e7":"iL1BZ","a348a4b4b5960b48":"ltHCL"}],"iL1BZ":[function(require,module,exports,__globalThis) {
'use strict';
var React = require("84f7042129b41bc6");
var _require = require("21d72afd4abadde1"), createRelayLoggingContext = _require.__internal.createRelayLoggingContext;
module.exports = createRelayLoggingContext(React);

},{"84f7042129b41bc6":"ltHCL","21d72afd4abadde1":"2IxFR"}],"ddjmE":[function(require,module,exports,__globalThis) {
'use strict';
var _interopRequireDefault = require("c03ede1c4a3e18e9")["default"];
var _objectSpread2 = _interopRequireDefault(require("e756deee074789b3"));
var _createForOfIteratorHelper2 = _interopRequireDefault(require("ef98f718d9c3b04"));
var _toConsumableArray2 = _interopRequireDefault(require("95204bc1a30d5865"));
var _require = require("aec7fbd8787f2ecd"), getQueryResourceForEnvironment = _require.getQueryResourceForEnvironment;
var useRelayEnvironment = require("689f9a07c60ffd57");
var useRelayLoggingContext = require("dadce75344571930");
var invariant = require("d10b52be5fc8bb2");
var _require2 = require("bfd1f51237b5c8bf"), useDebugValue = _require2.useDebugValue, useEffect = _require2.useEffect, useMemo = _require2.useMemo, useRef = _require2.useRef, useState = _require2.useState;
var _require3 = require("5bbe51391fb5b322"), _require3$__internal = _require3.__internal, fetchQueryInternal = _require3$__internal.fetchQuery, getPromiseForActiveRequest = _require3$__internal.getPromiseForActiveRequest, RelayFeatureFlags = _require3.RelayFeatureFlags, areEqualSelectors = _require3.areEqualSelectors, createOperationDescriptor = _require3.createOperationDescriptor, getPendingOperationsForFragment = _require3.getPendingOperationsForFragment, getSelector = _require3.getSelector, getVariablesFromFragment = _require3.getVariablesFromFragment, handlePotentialSnapshotErrors = _require3.handlePotentialSnapshotErrors, recycleNodesInto = _require3.recycleNodesInto;
var warning = require("667427363002b9de");
function isMissingData(state) {
    if (state.kind === 'bailout') return false;
    else if (state.kind === 'singular') return state.snapshot.isMissingData;
    else return state.snapshots.some(function(s) {
        return s.isMissingData;
    });
}
function getMissingClientEdges(state) {
    if (state.kind === 'bailout') return null;
    else if (state.kind === 'singular') {
        var _state$snapshot$missi;
        return (_state$snapshot$missi = state.snapshot.missingClientEdges) !== null && _state$snapshot$missi !== void 0 ? _state$snapshot$missi : null;
    } else {
        var edges = null;
        var _iterator = (0, _createForOfIteratorHelper2["default"])(state.snapshots), _step;
        try {
            for(_iterator.s(); !(_step = _iterator.n()).done;){
                var snapshot = _step.value;
                if (snapshot.missingClientEdges) {
                    var _edges;
                    edges = (_edges = edges) !== null && _edges !== void 0 ? _edges : [];
                    var _iterator2 = (0, _createForOfIteratorHelper2["default"])(snapshot.missingClientEdges), _step2;
                    try {
                        for(_iterator2.s(); !(_step2 = _iterator2.n()).done;){
                            var edge = _step2.value;
                            edges.push(edge);
                        }
                    } catch (err) {
                        _iterator2.e(err);
                    } finally{
                        _iterator2.f();
                    }
                }
            }
        } catch (err) {
            _iterator.e(err);
        } finally{
            _iterator.f();
        }
        return edges;
    }
}
function getSuspendingLiveResolver(state) {
    if (state.kind === 'bailout') return null;
    else if (state.kind === 'singular') {
        var _state$snapshot$missi2;
        return (_state$snapshot$missi2 = state.snapshot.missingLiveResolverFields) !== null && _state$snapshot$missi2 !== void 0 ? _state$snapshot$missi2 : null;
    } else {
        var missingFields = null;
        var _iterator3 = (0, _createForOfIteratorHelper2["default"])(state.snapshots), _step3;
        try {
            for(_iterator3.s(); !(_step3 = _iterator3.n()).done;){
                var snapshot = _step3.value;
                if (snapshot.missingLiveResolverFields) {
                    var _missingFields;
                    missingFields = (_missingFields = missingFields) !== null && _missingFields !== void 0 ? _missingFields : [];
                    var _iterator4 = (0, _createForOfIteratorHelper2["default"])(snapshot.missingLiveResolverFields), _step4;
                    try {
                        for(_iterator4.s(); !(_step4 = _iterator4.n()).done;){
                            var edge = _step4.value;
                            missingFields.push(edge);
                        }
                    } catch (err) {
                        _iterator4.e(err);
                    } finally{
                        _iterator4.f();
                    }
                }
            }
        } catch (err) {
            _iterator3.e(err);
        } finally{
            _iterator3.f();
        }
        return missingFields;
    }
}
function handlePotentialSnapshotErrorsForState(environment, state, loggingContext) {
    if (state.kind === 'singular') handlePotentialSnapshotErrors(environment, state.snapshot.fieldErrors, loggingContext);
    else if (state.kind === 'plural') {
        var _iterator5 = (0, _createForOfIteratorHelper2["default"])(state.snapshots), _step5;
        try {
            for(_iterator5.s(); !(_step5 = _iterator5.n()).done;){
                var snapshot = _step5.value;
                handlePotentialSnapshotErrors(environment, snapshot.fieldErrors, loggingContext);
            }
        } catch (err) {
            _iterator5.e(err);
        } finally{
            _iterator5.f();
        }
    }
}
function handleMissedUpdates(environment, state) {
    if (state.kind === 'bailout') return null;
    var currentEpoch = environment.getStore().getEpoch();
    if (currentEpoch === state.epoch) return null;
    if (state.kind === 'singular') {
        var currentSnapshot = environment.lookup(state.snapshot.selector);
        var updatedData = recycleNodesInto(state.snapshot.data, currentSnapshot.data);
        var updatedCurrentSnapshot = {
            data: updatedData,
            isMissingData: currentSnapshot.isMissingData,
            missingClientEdges: currentSnapshot.missingClientEdges,
            missingLiveResolverFields: currentSnapshot.missingLiveResolverFields,
            seenRecords: currentSnapshot.seenRecords,
            selector: currentSnapshot.selector,
            fieldErrors: currentSnapshot.fieldErrors
        };
        return [
            updatedData !== state.snapshot.data,
            {
                kind: 'singular',
                snapshot: updatedCurrentSnapshot,
                epoch: currentEpoch,
                selector: state.selector,
                environment: state.environment
            }
        ];
    } else {
        var didMissUpdates = false;
        var currentSnapshots = [];
        for(var index = 0; index < state.snapshots.length; index++){
            var snapshot = state.snapshots[index];
            var _currentSnapshot = environment.lookup(snapshot.selector);
            var _updatedData = recycleNodesInto(snapshot.data, _currentSnapshot.data);
            var _updatedCurrentSnapshot = {
                data: _updatedData,
                isMissingData: _currentSnapshot.isMissingData,
                missingClientEdges: _currentSnapshot.missingClientEdges,
                missingLiveResolverFields: _currentSnapshot.missingLiveResolverFields,
                seenRecords: _currentSnapshot.seenRecords,
                selector: _currentSnapshot.selector,
                fieldErrors: _currentSnapshot.fieldErrors
            };
            if (_updatedData !== snapshot.data) didMissUpdates = true;
            currentSnapshots.push(_updatedCurrentSnapshot);
        }
        !(currentSnapshots.length === state.snapshots.length) && invariant(false);
        return [
            didMissUpdates,
            {
                kind: 'plural',
                snapshots: currentSnapshots,
                epoch: currentEpoch,
                selector: state.selector,
                environment: state.environment
            }
        ];
    }
}
function handleMissingClientEdge(environment, parentFragmentNode, parentFragmentRef, missingClientEdgeRequestInfo, queryOptions) {
    var originalVariables = getVariablesFromFragment(parentFragmentNode, parentFragmentRef);
    var variables = (0, _objectSpread2["default"])((0, _objectSpread2["default"])({}, originalVariables), {}, {
        id: missingClientEdgeRequestInfo.clientEdgeDestinationID
    });
    var queryOperationDescriptor = createOperationDescriptor(missingClientEdgeRequestInfo.request, variables, queryOptions === null || queryOptions === void 0 ? void 0 : queryOptions.networkCacheConfig);
    var QueryResource = getQueryResourceForEnvironment(environment);
    var queryResult = QueryResource.prepare(queryOperationDescriptor, fetchQueryInternal(environment, queryOperationDescriptor), queryOptions === null || queryOptions === void 0 ? void 0 : queryOptions.fetchPolicy);
    var promise = getPromiseForActiveRequest(environment, queryOperationDescriptor.request);
    if (promise != null && promise.displayName == null) promise.displayName = missingClientEdgeRequestInfo.request.params.name;
    return [
        queryResult,
        promise
    ];
}
function subscribeToSnapshot(environment, state, setState) {
    if (state.kind === 'bailout') return function() {};
    else if (state.kind === 'singular') {
        var disposable = environment.subscribe(state.snapshot, function(latestSnapshot) {
            setState(function(prevState) {
                var nextState = null;
                if (prevState.kind !== 'singular' || prevState.snapshot.selector !== latestSnapshot.selector || prevState.environment !== environment) {
                    var updates = handleMissedUpdates(prevState.environment, prevState);
                    if (updates != null) {
                        var dataChanged = updates[0], updatedState = updates[1];
                        environment.__log({
                            name: 'useFragment.subscription.missedUpdates',
                            hasDataChanges: dataChanged
                        });
                        nextState = dataChanged ? updatedState : prevState;
                    } else nextState = prevState;
                } else nextState = {
                    kind: 'singular',
                    snapshot: latestSnapshot,
                    epoch: environment.getStore().getEpoch(),
                    selector: state.selector,
                    environment: state.environment
                };
                return nextState;
            });
        });
        return function() {
            disposable.dispose();
        };
    } else {
        var disposables = state.snapshots.map(function(snapshot, index) {
            return environment.subscribe(snapshot, function(latestSnapshot) {
                setState(function(prevState) {
                    var _prevState$snapshots$;
                    var nextState = null;
                    if (prevState.kind !== 'plural' || ((_prevState$snapshots$ = prevState.snapshots[index]) === null || _prevState$snapshots$ === void 0 ? void 0 : _prevState$snapshots$.selector) !== latestSnapshot.selector || prevState.environment !== environment) {
                        var updates = handleMissedUpdates(prevState.environment, prevState);
                        if (updates != null) {
                            var dataChanged = updates[0], updatedState = updates[1];
                            environment.__log({
                                name: 'useFragment.subscription.missedUpdates',
                                hasDataChanges: dataChanged
                            });
                            nextState = dataChanged ? updatedState : prevState;
                        } else nextState = prevState;
                    } else {
                        var updated = (0, _toConsumableArray2["default"])(prevState.snapshots);
                        updated[index] = latestSnapshot;
                        nextState = {
                            kind: 'plural',
                            snapshots: updated,
                            epoch: environment.getStore().getEpoch(),
                            selector: state.selector,
                            environment: state.environment
                        };
                    }
                    return nextState;
                });
            });
        });
        return function() {
            var _iterator6 = (0, _createForOfIteratorHelper2["default"])(disposables), _step6;
            try {
                for(_iterator6.s(); !(_step6 = _iterator6.n()).done;){
                    var d = _step6.value;
                    d.dispose();
                }
            } catch (err) {
                _iterator6.e(err);
            } finally{
                _iterator6.f();
            }
        };
    }
}
function getFragmentState(environment, fragmentSelector) {
    if (fragmentSelector == null) return {
        kind: 'bailout',
        environment: environment
    };
    else if (fragmentSelector.kind === 'PluralReaderSelector') return {
        kind: 'plural',
        snapshots: fragmentSelector.selectors.map(function(s) {
            return environment.lookup(s);
        }),
        epoch: environment.getStore().getEpoch(),
        selector: fragmentSelector,
        environment: environment
    };
    else return {
        kind: 'singular',
        snapshot: environment.lookup(fragmentSelector),
        epoch: environment.getStore().getEpoch(),
        selector: fragmentSelector,
        environment: environment
    };
}
function useFragmentInternal_EXPERIMENTAL(fragmentNode, fragmentRef, hookDisplayName, queryOptions) {
    var _fragmentNode$metadat, _fragmentNode$metadat2;
    var fragmentSelector = useMemo(function() {
        return getSelector(fragmentNode, fragmentRef);
    }, [
        fragmentNode,
        fragmentRef
    ]);
    var isPlural = (fragmentNode === null || fragmentNode === void 0 ? void 0 : (_fragmentNode$metadat = fragmentNode.metadata) === null || _fragmentNode$metadat === void 0 ? void 0 : _fragmentNode$metadat.plural) === true;
    if (isPlural) !(fragmentRef == null || Array.isArray(fragmentRef)) && invariant(false);
    else !!Array.isArray(fragmentRef) && invariant(false);
    !(fragmentRef == null || isPlural && Array.isArray(fragmentRef) && fragmentRef.length === 0 || fragmentSelector != null) && invariant(false);
    var environment = useRelayEnvironment();
    var loggerContext;
    if (RelayFeatureFlags.ENABLE_UI_CONTEXT_ON_RELAY_LOGGER) loggerContext = useRelayLoggingContext();
    var _useState = useState(function() {
        return getFragmentState(environment, fragmentSelector);
    }), _state = _useState[0], setState = _useState[1];
    var state = _state;
    var previousEnvironment = state.environment;
    if (!areEqualSelectors(fragmentSelector, state.selector) || environment !== state.environment) {
        var newState = getFragmentState(environment, fragmentSelector);
        setState(newState);
        state = newState;
    }
    var committedFragmentSelectorRef = useRef(false);
    useEffect(function() {
        committedFragmentSelectorRef.current = fragmentSelector;
    }, [
        fragmentSelector
    ]);
    if (((_fragmentNode$metadat2 = fragmentNode.metadata) === null || _fragmentNode$metadat2 === void 0 ? void 0 : _fragmentNode$metadat2.hasClientEdges) === true || RelayFeatureFlags.CHECK_ALL_FRAGMENTS_FOR_MISSING_CLIENT_EDGES) {
        var _useMemo = useMemo(function() {
            var missingClientEdges = getMissingClientEdges(state);
            var clientEdgeQueries;
            var activeRequestPromises = [];
            if (missingClientEdges !== null && missingClientEdges !== void 0 && missingClientEdges.length) {
                clientEdgeQueries = [];
                var _iterator7 = (0, _createForOfIteratorHelper2["default"])(missingClientEdges), _step7;
                try {
                    for(_iterator7.s(); !(_step7 = _iterator7.n()).done;){
                        var edge = _step7.value;
                        var _handleMissingClientE = handleMissingClientEdge(environment, fragmentNode, fragmentRef, edge, queryOptions), queryResult = _handleMissingClientE[0], requestPromise = _handleMissingClientE[1];
                        clientEdgeQueries.push(queryResult);
                        if (requestPromise != null) activeRequestPromises.push(requestPromise);
                    }
                } catch (err) {
                    _iterator7.e(err);
                } finally{
                    _iterator7.f();
                }
            }
            return [
                clientEdgeQueries,
                activeRequestPromises
            ];
        }, [
            state,
            environment,
            fragmentNode,
            fragmentRef,
            queryOptions
        ]), clientEdgeQueries = _useMemo[0], activeRequestPromises = _useMemo[1];
        if (activeRequestPromises.length) {
            var allPromises = Promise.all(activeRequestPromises);
            allPromises.displayName = "RelayClientEdge(".concat(activeRequestPromises.map(function(promise) {
                return promise.displayName;
            }).join(','), ")");
            throw allPromises;
        }
        useEffect(function() {
            var QueryResource = getQueryResourceForEnvironment(environment);
            if (clientEdgeQueries !== null && clientEdgeQueries !== void 0 && clientEdgeQueries.length) {
                var disposables = [];
                var _iterator8 = (0, _createForOfIteratorHelper2["default"])(clientEdgeQueries), _step8;
                try {
                    for(_iterator8.s(); !(_step8 = _iterator8.n()).done;){
                        var query = _step8.value;
                        disposables.push(QueryResource.retain(query));
                    }
                } catch (err) {
                    _iterator8.e(err);
                } finally{
                    _iterator8.f();
                }
                return function() {
                    for(var _i = 0, _disposables = disposables; _i < _disposables.length; _i++){
                        var disposable = _disposables[_i];
                        disposable.dispose();
                    }
                };
            }
        }, [
            environment,
            clientEdgeQueries
        ]);
    }
    if (isMissingData(state)) {
        var suspendingLiveResolvers = getSuspendingLiveResolver(state);
        if (suspendingLiveResolvers != null && suspendingLiveResolvers.length > 0) {
            var promise = Promise.all(suspendingLiveResolvers.map(function(liveStateID) {
                return environment.getStore().getLiveResolverPromise(liveStateID);
            }));
            promise.displayName = 'RelayLiveResolver(' + fragmentNode.name + ')';
            throw promise;
        }
        if (RelayFeatureFlags.ENABLE_RELAY_OPERATION_TRACKER_SUSPENSE || environment !== previousEnvironment || !committedFragmentSelectorRef.current || !areEqualSelectors(committedFragmentSelectorRef.current, fragmentSelector)) {
            !(fragmentSelector != null) && invariant(false);
            var fragmentOwner = fragmentSelector.kind === 'PluralReaderSelector' ? fragmentSelector.selectors[0].owner : fragmentSelector.owner;
            var pendingOperationsResult = getPendingOperationsForFragment(environment, fragmentNode, fragmentOwner);
            if (pendingOperationsResult) throw pendingOperationsResult.promise;
        }
    }
    handlePotentialSnapshotErrorsForState(environment, state, loggerContext);
    var storeSubscriptionRef = useRef(null);
    useEffect(function() {
        var storeSubscription = storeSubscriptionRef.current;
        if (storeSubscription != null) {
            if (state.environment === storeSubscription.environment && state.selector === storeSubscription.selector) return;
            else storeSubscription.dispose();
        }
        if (state.kind === 'bailout') return;
        var stateForSubscription = state;
        var updates = handleMissedUpdates(state.environment, state);
        if (updates !== null) {
            var didMissUpdates = updates[0], updatedState = updates[1];
            if (didMissUpdates) {
                setState(updatedState);
                return;
            }
            stateForSubscription = updatedState;
        }
        var dispose = subscribeToSnapshot(state.environment, stateForSubscription, setState);
        storeSubscriptionRef.current = {
            dispose: dispose,
            selector: state.selector,
            environment: state.environment
        };
    }, [
        state
    ]);
    useEffect(function() {
        if (storeSubscriptionRef.current == null && state.kind !== 'bailout') {
            var dispose = subscribeToSnapshot(state.environment, state, setState);
            storeSubscriptionRef.current = {
                dispose: dispose,
                selector: state.selector,
                environment: state.environment
            };
        }
        return function() {
            var _storeSubscriptionRef;
            (_storeSubscriptionRef = storeSubscriptionRef.current) === null || _storeSubscriptionRef === void 0 || _storeSubscriptionRef.dispose();
            storeSubscriptionRef.current = null;
        };
    }, []);
    var data;
    if (isPlural) {
        var fragmentRefIsNullish = fragmentRef == null;
        data = useMemo(function() {
            if (state.kind === 'bailout') return fragmentRefIsNullish ? null : [];
            else {
                !(state.kind === 'plural') && invariant(false);
                return state.snapshots.map(function(s) {
                    return s.data;
                });
            }
        }, [
            state,
            fragmentRefIsNullish
        ]);
    } else if (state.kind === 'bailout') data = null;
    else {
        !(state.kind === 'singular') && invariant(false);
        data = state.snapshot.data;
    }
    if (RelayFeatureFlags.LOG_MISSING_RECORDS_IN_PROD || false) fragmentRef != null && (data === undefined || Array.isArray(data) && data.length > 0 && data.every(function(d) {
        return d === undefined;
    }));
    return data;
}
module.exports = useFragmentInternal_EXPERIMENTAL;

},{"c03ede1c4a3e18e9":"590td","e756deee074789b3":"2Bj1n","ef98f718d9c3b04":"fMaLa","95204bc1a30d5865":"7EBX0","aec7fbd8787f2ecd":"gv1jq","689f9a07c60ffd57":"bs9Iy","dadce75344571930":"76Dx1","d10b52be5fc8bb2":"e2sci","bfd1f51237b5c8bf":"ltHCL","5bbe51391fb5b322":"2IxFR","667427363002b9de":"j64TH"}],"jnI2X":[function(require,module,exports,__globalThis) {
'use strict';
var useMemoVariables = require("7aa1a0283d691aaf");
var React = require("b4e529ae1e76e8b");
var _require = require("598b507a467448e1"), createOperationDescriptor = _require.createOperationDescriptor, getRequest = _require.getRequest;
var useMemo = React.useMemo;
function useMemoOperationDescriptor(gqlQuery, variables, cacheConfig) {
    var memoVariables = useMemoVariables(variables);
    var memoCacheConfig = useMemoVariables(cacheConfig || {});
    return useMemo(function() {
        return createOperationDescriptor(getRequest(gqlQuery), memoVariables, memoCacheConfig);
    }, [
        gqlQuery,
        memoVariables,
        memoCacheConfig
    ]);
}
module.exports = useMemoOperationDescriptor;

},{"7aa1a0283d691aaf":"epD46","b4e529ae1e76e8b":"ltHCL","598b507a467448e1":"2IxFR"}],"epD46":[function(require,module,exports,__globalThis) {
'use strict';
var areEqual = require("8411b20d6b142b26");
var _require = require("38edb978daf04434"), useState = _require.useState;
function useMemoVariables(variables) {
    var _useState = useState(variables), mirroredVariables = _useState[0], setMirroredVariables = _useState[1];
    if (areEqual(variables, mirroredVariables)) return mirroredVariables;
    else {
        setMirroredVariables(variables);
        return variables;
    }
}
module.exports = useMemoVariables;

},{"8411b20d6b142b26":"eJLuG","38edb978daf04434":"ltHCL"}],"lV0xn":[function(require,module,exports,__globalThis) {
'use strict';
var _interopRequireDefault = require("867495428bc05203")["default"];
var _createForOfIteratorHelper2 = _interopRequireDefault(require("e0154b009362727a"));
var loadEntryPoint = require("9c4183e84c0fb000");
var useIsMountedRef = require("c734c78036a2e216");
var _require = require("2c9267f0906d7021"), useCallback = _require.useCallback, useEffect = _require.useEffect, useRef = _require.useRef, useState = _require.useState;
var initialNullEntryPointReferenceState = {
    kind: 'NullEntryPointReference'
};
function useLoadEntryPoint(environmentProvider, entryPoint, options) {
    var _options$TEST_ONLY__i, _options$TEST_ONLY__i2, _options$TEST_ONLY__i3, _options$TEST_ONLY__i4;
    var initialEntryPointReferenceInternal = (_options$TEST_ONLY__i = options === null || options === void 0 ? void 0 : (_options$TEST_ONLY__i2 = options.TEST_ONLY__initialEntryPointData) === null || _options$TEST_ONLY__i2 === void 0 ? void 0 : _options$TEST_ONLY__i2.entryPointReference) !== null && _options$TEST_ONLY__i !== void 0 ? _options$TEST_ONLY__i : initialNullEntryPointReferenceState;
    var initialEntryPointParamsInternal = (_options$TEST_ONLY__i3 = options === null || options === void 0 ? void 0 : (_options$TEST_ONLY__i4 = options.TEST_ONLY__initialEntryPointData) === null || _options$TEST_ONLY__i4 === void 0 ? void 0 : _options$TEST_ONLY__i4.entryPointParams) !== null && _options$TEST_ONLY__i3 !== void 0 ? _options$TEST_ONLY__i3 : null;
    var isMountedRef = useIsMountedRef();
    var undisposedEntryPointReferencesRef = useRef(new Set([
        initialEntryPointReferenceInternal
    ]));
    var _useState = useState(initialEntryPointReferenceInternal), entryPointReference = _useState[0], setEntryPointReference = _useState[1];
    var _useState2 = useState(initialEntryPointParamsInternal), entryPointParams = _useState2[0], setEntryPointParams = _useState2[1];
    var disposeEntryPoint = useCallback(function() {
        if (isMountedRef.current) {
            var nullEntryPointReference = {
                kind: 'NullEntryPointReference'
            };
            undisposedEntryPointReferencesRef.current.add(nullEntryPointReference);
            setEntryPointReference(nullEntryPointReference);
        }
    }, [
        setEntryPointReference,
        isMountedRef
    ]);
    var entryPointLoaderCallback = useCallback(function(params) {
        if (isMountedRef.current) {
            var updatedEntryPointReference = loadEntryPoint(environmentProvider, entryPoint, params);
            undisposedEntryPointReferencesRef.current.add(updatedEntryPointReference);
            setEntryPointReference(updatedEntryPointReference);
            setEntryPointParams(params);
        }
    }, [
        environmentProvider,
        entryPoint,
        setEntryPointReference,
        isMountedRef
    ]);
    var maybeHiddenOrFastRefresh = useRef(false);
    useEffect(function() {
        return function() {
            maybeHiddenOrFastRefresh.current = true;
        };
    }, []);
    useEffect(function() {
        if (maybeHiddenOrFastRefresh.current === true) {
            maybeHiddenOrFastRefresh.current = false;
            if (entryPointReference.kind !== 'NullEntryPointReference' && entryPointParams != null) entryPointLoaderCallback(entryPointParams);
            return;
        }
        var undisposedEntryPointReferences = undisposedEntryPointReferencesRef.current;
        if (isMountedRef.current) {
            var _iterator = (0, _createForOfIteratorHelper2["default"])(undisposedEntryPointReferences), _step;
            try {
                for(_iterator.s(); !(_step = _iterator.n()).done;){
                    var undisposedEntryPointReference = _step.value;
                    if (undisposedEntryPointReference === entryPointReference) break;
                    undisposedEntryPointReferences["delete"](undisposedEntryPointReference);
                    if (undisposedEntryPointReference.kind !== 'NullEntryPointReference') undisposedEntryPointReference.dispose();
                }
            } catch (err) {
                _iterator.e(err);
            } finally{
                _iterator.f();
            }
        }
    }, [
        entryPointReference,
        entryPointParams,
        entryPointLoaderCallback,
        isMountedRef
    ]);
    useEffect(function() {
        return function disposeAllRemainingEntryPointReferences() {
            var _iterator2 = (0, _createForOfIteratorHelper2["default"])(undisposedEntryPointReferencesRef.current), _step2;
            try {
                for(_iterator2.s(); !(_step2 = _iterator2.n()).done;){
                    var unhandledStateChange = _step2.value;
                    if (unhandledStateChange.kind !== 'NullEntryPointReference') unhandledStateChange.dispose();
                }
            } catch (err) {
                _iterator2.e(err);
            } finally{
                _iterator2.f();
            }
        };
    }, []);
    return [
        entryPointReference.kind === 'NullEntryPointReference' ? null : entryPointReference,
        entryPointLoaderCallback,
        disposeEntryPoint
    ];
}
module.exports = useLoadEntryPoint;

},{"867495428bc05203":"590td","e0154b009362727a":"fMaLa","9c4183e84c0fb000":"iKwbK","c734c78036a2e216":"bqjPh","2c9267f0906d7021":"ltHCL"}],"bqjPh":[function(require,module,exports,__globalThis) {
'use strict';
var _require = require("fb39348231e9df8"), useEffect = _require.useEffect, useRef = _require.useRef;
function useIsMountedRef() {
    var isMountedRef = useRef(true);
    useEffect(function() {
        isMountedRef.current = true;
        return function() {
            isMountedRef.current = false;
        };
    }, []);
    return isMountedRef;
}
module.exports = useIsMountedRef;

},{"fb39348231e9df8":"ltHCL"}],"1zoWc":[function(require,module,exports,__globalThis) {
'use strict';
var useFragmentInternal = require("b1310ca474cc809");
var useStaticFragmentNodeWarning = require("1e57d8e9e4026e7b");
var _require = require("ef62af53b262de55"), useDebugValue = _require.useDebugValue;
var _require2 = require("fdbcb266aeaa1f2"), getFragment = _require2.getFragment;
function useFragment(fragment, key) {
    var fragmentNode = getFragment(fragment);
    useStaticFragmentNodeWarning(fragmentNode, 'first argument of useFragment()');
    var data = useFragmentInternal(fragmentNode, key, 'useFragment()');
    return data;
}
module.exports = useFragment;

},{"b1310ca474cc809":"eglKT","1e57d8e9e4026e7b":"8SJsi","ef62af53b262de55":"ltHCL","fdbcb266aeaa1f2":"2IxFR"}],"8SJsi":[function(require,module,exports,__globalThis) {
'use strict';
var useUnsafeRef_DEPRECATED = require("92df17c737ee1cde");
var warning = require("df1a3ea00f4bfdb1");
function useStaticFragmentNodeWarning(fragmentNode, warningContext) {
    var initialPropRef;
}
module.exports = useStaticFragmentNodeWarning;

},{"92df17c737ee1cde":"eslBO","df1a3ea00f4bfdb1":"j64TH"}],"gIJ5I":[function(require,module,exports,__globalThis) {
'use strict';
var _interopRequireDefault = require("1994f82c3167a82f")["default"];
var _objectSpread2 = _interopRequireDefault(require("936fbbf07c5590c8"));
var useIsMountedRef = require("cab1674bb914c082");
var useRelayEnvironment = require("3a2e0417487330ad");
var React = require("d873b37c20a3e87");
var _require = require("f3d3c49bcea96c38"), defaultCommitMutation = _require.commitMutation;
var useState = React.useState, useEffect = React.useEffect, useRef = React.useRef, useCallback = React.useCallback;
function useMutation(mutation) {
    var commitMutationFn = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : defaultCommitMutation;
    var environment = useRelayEnvironment();
    var isMountedRef = useIsMountedRef();
    var environmentRef = useRef(environment);
    var mutationRef = useRef(mutation);
    var inFlightMutationsRef = useRef(new Set());
    var _useState = useState(false), isMutationInFlight = _useState[0], setMutationInFlight = _useState[1];
    var cleanup = useCallback(function(disposable) {
        if (environmentRef.current === environment && mutationRef.current === mutation) {
            inFlightMutationsRef.current["delete"](disposable);
            if (isMountedRef.current) setMutationInFlight(inFlightMutationsRef.current.size > 0);
        }
    }, [
        environment,
        isMountedRef,
        mutation
    ]);
    useEffect(function() {
        if (environmentRef.current !== environment || mutationRef.current !== mutation) {
            inFlightMutationsRef.current = new Set();
            if (isMountedRef.current) setMutationInFlight(false);
            environmentRef.current = environment;
            mutationRef.current = mutation;
        }
    }, [
        environment,
        isMountedRef,
        mutation
    ]);
    var commit = useCallback(function(config) {
        if (isMountedRef.current) setMutationInFlight(true);
        var disposable = commitMutationFn(environment, (0, _objectSpread2["default"])((0, _objectSpread2["default"])({}, config), {}, {
            mutation: mutation,
            onCompleted: function onCompleted(response, errors) {
                var _config$onCompleted;
                cleanup(disposable);
                (_config$onCompleted = config.onCompleted) === null || _config$onCompleted === void 0 || _config$onCompleted.call(config, response, errors);
            },
            onError: function onError(error) {
                var _config$onError;
                cleanup(disposable);
                (_config$onError = config.onError) === null || _config$onError === void 0 || _config$onError.call(config, error);
            },
            onUnsubscribe: function onUnsubscribe() {
                var _config$onUnsubscribe;
                cleanup(disposable);
                (_config$onUnsubscribe = config.onUnsubscribe) === null || _config$onUnsubscribe === void 0 || _config$onUnsubscribe.call(config);
            },
            onNext: function onNext() {
                var _config$onNext;
                (_config$onNext = config.onNext) === null || _config$onNext === void 0 || _config$onNext.call(config);
            }
        }));
        inFlightMutationsRef.current.add(disposable);
        return disposable;
    }, [
        cleanup,
        commitMutationFn,
        environment,
        isMountedRef,
        mutation
    ]);
    return [
        commit,
        isMutationInFlight
    ];
}
module.exports = useMutation;

},{"1994f82c3167a82f":"590td","936fbbf07c5590c8":"2Bj1n","cab1674bb914c082":"bqjPh","3a2e0417487330ad":"bs9Iy","d873b37c20a3e87":"ltHCL","f3d3c49bcea96c38":"2IxFR"}],"cs6Pn":[function(require,module,exports,__globalThis) {
'use strict';
var _interopRequireDefault = require("74260e5d3240ad76")["default"];
var _objectSpread2 = _interopRequireDefault(require("772861931c397aff"));
var useLoadMoreFunction = require("f8f2f7fe49079bf");
var useRefetchableFragmentInternal = require("2e9991357388c7ab");
var useRelayEnvironment = require("862b0db33c4b8c1d");
var useStaticFragmentNodeWarning = require("e009dc1f838d8092");
var _require = require("9421470ba1e7b790"), useCallback = _require.useCallback, useDebugValue = _require.useDebugValue, useState = _require.useState;
var _require2 = require("9d207c4f45729b23"), RelayFeatureFlags = _require2.RelayFeatureFlags, getFragment = _require2.getFragment, getFragmentIdentifier = _require2.getFragmentIdentifier, getPaginationMetadata = _require2.getPaginationMetadata;
function usePaginationFragment(fragmentInput, parentFragmentRef) {
    var fragmentNode = getFragment(fragmentInput);
    useStaticFragmentNodeWarning(fragmentNode, 'first argument of usePaginationFragment()');
    var componentDisplayName = 'usePaginationFragment()';
    var _getPaginationMetadat = getPaginationMetadata(fragmentNode, componentDisplayName), connectionPathInFragmentData = _getPaginationMetadat.connectionPathInFragmentData, paginationRequest = _getPaginationMetadat.paginationRequest, paginationMetadata = _getPaginationMetadat.paginationMetadata;
    var _useRefetchableFragme = useRefetchableFragmentInternal(fragmentNode, parentFragmentRef, componentDisplayName), fragmentData = _useRefetchableFragme.fragmentData, fragmentRef = _useRefetchableFragme.fragmentRef, refetch = _useRefetchableFragme.refetch;
    var fragmentIdentifier = getFragmentIdentifier(fragmentNode, fragmentRef);
    var _useLoadMore = useLoadMore({
        componentDisplayName: componentDisplayName,
        connectionPathInFragmentData: connectionPathInFragmentData,
        direction: 'backward',
        fragmentData: fragmentData,
        fragmentIdentifier: fragmentIdentifier,
        fragmentNode: fragmentNode,
        fragmentRef: fragmentRef,
        paginationMetadata: paginationMetadata,
        paginationRequest: paginationRequest
    }), loadPrevious = _useLoadMore[0], hasPrevious = _useLoadMore[1], isLoadingPrevious = _useLoadMore[2], disposeFetchPrevious = _useLoadMore[3];
    var _useLoadMore2 = useLoadMore({
        componentDisplayName: componentDisplayName,
        connectionPathInFragmentData: connectionPathInFragmentData,
        direction: 'forward',
        fragmentData: fragmentData,
        fragmentIdentifier: fragmentIdentifier,
        fragmentNode: fragmentNode,
        fragmentRef: fragmentRef,
        paginationMetadata: paginationMetadata,
        paginationRequest: paginationRequest
    }), loadNext = _useLoadMore2[0], hasNext = _useLoadMore2[1], isLoadingNext = _useLoadMore2[2], disposeFetchNext = _useLoadMore2[3];
    var refetchPagination = useCallback(function(variables, options) {
        disposeFetchNext();
        disposeFetchPrevious();
        return refetch(variables, (0, _objectSpread2["default"])((0, _objectSpread2["default"])({}, options), {}, {
            __environment: undefined
        }));
    }, [
        disposeFetchNext,
        disposeFetchPrevious,
        refetch
    ]);
    return {
        data: fragmentData,
        loadNext: loadNext,
        loadPrevious: loadPrevious,
        hasNext: hasNext,
        hasPrevious: hasPrevious,
        isLoadingNext: isLoadingNext,
        isLoadingPrevious: isLoadingPrevious,
        refetch: refetchPagination
    };
}
function useLoadMore(args) {
    var environment = useRelayEnvironment();
    var _useState = useState(false), isLoadingMore = _useState[0], reallySetIsLoadingMore = _useState[1];
    var setIsLoadingMore = function setIsLoadingMore(value) {
        var _environment$getSched;
        var schedule = (_environment$getSched = environment.getScheduler()) === null || _environment$getSched === void 0 ? void 0 : _environment$getSched.schedule;
        if (schedule) schedule(function() {
            reallySetIsLoadingMore(value);
        });
        else reallySetIsLoadingMore(value);
    };
    var observer = {
        start: function start() {
            return setIsLoadingMore(true);
        },
        complete: function complete() {
            return setIsLoadingMore(false);
        },
        error: function error() {
            return setIsLoadingMore(false);
        },
        unsubscribe: RelayFeatureFlags.ENABLE_USE_PAGINATION_IS_LOADING_FIX ? function() {
            return setIsLoadingMore(false);
        } : undefined
    };
    var handleReset = function handleReset() {
        return setIsLoadingMore(false);
    };
    var _useLoadMoreFunction = useLoadMoreFunction((0, _objectSpread2["default"])((0, _objectSpread2["default"])({}, args), {}, {
        observer: observer,
        onReset: handleReset
    })), loadMore = _useLoadMoreFunction[0], hasMore = _useLoadMoreFunction[1], disposeFetch = _useLoadMoreFunction[2];
    return [
        loadMore,
        hasMore,
        isLoadingMore,
        disposeFetch
    ];
}
module.exports = usePaginationFragment;

},{"74260e5d3240ad76":"590td","772861931c397aff":"2Bj1n","f8f2f7fe49079bf":"12mOd","2e9991357388c7ab":"hXj4k","862b0db33c4b8c1d":"bs9Iy","e009dc1f838d8092":"8SJsi","9421470ba1e7b790":"ltHCL","9d207c4f45729b23":"2IxFR"}],"12mOd":[function(require,module,exports,__globalThis) {
'use strict';
var _interopRequireDefault = require("3ac2587f9e904957")["default"];
var _objectSpread2 = _interopRequireDefault(require("72489d7554b40490"));
var getConnectionState = require("a9ddeb0b12965a64");
var useFetchTrackingRef = require("d1b67a19bb0e9dfe");
var useIsMountedRef = require("c752c06730124926");
var useIsOperationNodeActive = require("ea77eb8e4c5dc9bc");
var useLoadMoreFunction_EXPERIMENTAL = require("7a87ec5ed97fbc68");
var useRelayEnvironment = require("30acdd32f952f70b");
var invariant = require("4a5df82bf0f64915");
var _require = require("74b8166276ceae31"), useCallback = _require.useCallback, useEffect = _require.useEffect, useState = _require.useState;
var _require2 = require("d7d30e261b59c6bd"), fetchQuery = _require2.__internal.fetchQuery, RelayFeatureFlags = _require2.RelayFeatureFlags, createOperationDescriptor = _require2.createOperationDescriptor, getPaginationVariables = _require2.getPaginationVariables, getRefetchMetadata = _require2.getRefetchMetadata, getSelector = _require2.getSelector;
var warning = require("2b34752cc6db60a3");
function useLoadMoreFunction(args) {
    if (RelayFeatureFlags.ENABLE_ACTIVITY_COMPATIBILITY) return useLoadMoreFunction_EXPERIMENTAL(args);
    return useLoadMoreFunction_CURRENT(args);
}
function useLoadMoreFunction_CURRENT(args) {
    var direction = args.direction, fragmentNode = args.fragmentNode, fragmentRef = args.fragmentRef, fragmentIdentifier = args.fragmentIdentifier, fragmentData = args.fragmentData, connectionPathInFragmentData = args.connectionPathInFragmentData, paginationRequest = args.paginationRequest, paginationMetadata = args.paginationMetadata, componentDisplayName = args.componentDisplayName, observer = args.observer, onReset = args.onReset;
    var environment = useRelayEnvironment();
    var _useFetchTrackingRef = useFetchTrackingRef(), isFetchingRef = _useFetchTrackingRef.isFetchingRef, startFetch = _useFetchTrackingRef.startFetch, disposeFetch = _useFetchTrackingRef.disposeFetch, completeFetch = _useFetchTrackingRef.completeFetch;
    var _getRefetchMetadata = getRefetchMetadata(fragmentNode, componentDisplayName), identifierInfo = _getRefetchMetadata.identifierInfo;
    var identifierValue = (identifierInfo === null || identifierInfo === void 0 ? void 0 : identifierInfo.identifierField) != null && fragmentData != null && typeof fragmentData === 'object' ? fragmentData[identifierInfo.identifierField] : null;
    var isMountedRef = useIsMountedRef();
    var _useState = useState(environment), mirroredEnvironment = _useState[0], setMirroredEnvironment = _useState[1];
    var _useState2 = useState(fragmentIdentifier), mirroredFragmentIdentifier = _useState2[0], setMirroredFragmentIdentifier = _useState2[1];
    var isParentQueryActive = useIsOperationNodeActive(fragmentNode, fragmentRef);
    var shouldReset = environment !== mirroredEnvironment || fragmentIdentifier !== mirroredFragmentIdentifier;
    if (shouldReset) {
        disposeFetch();
        onReset();
        setMirroredEnvironment(environment);
        setMirroredFragmentIdentifier(fragmentIdentifier);
    }
    var _getConnectionState = getConnectionState(direction, fragmentNode, fragmentData, connectionPathInFragmentData), cursor = _getConnectionState.cursor, hasMore = _getConnectionState.hasMore;
    useEffect(function() {
        return function() {
            disposeFetch();
        };
    }, [
        disposeFetch
    ]);
    var isRequestInvalid = fragmentData == null || isParentQueryActive;
    var loadMore = useCallback(function(count, options) {
        var onComplete = options === null || options === void 0 ? void 0 : options.onComplete;
        if (isMountedRef.current !== true) return {
            dispose: function dispose() {}
        };
        var fragmentSelector = getSelector(fragmentNode, fragmentRef);
        if (isFetchingRef.current === true || isRequestInvalid) {
            fragmentSelector;
            if (onComplete) onComplete(null);
            return {
                dispose: function dispose() {}
            };
        }
        !(fragmentSelector != null && fragmentSelector.kind !== 'PluralReaderSelector') && invariant(false);
        var parentVariables = fragmentSelector.owner.variables;
        var fragmentVariables = fragmentSelector.variables;
        var extraVariables = options === null || options === void 0 ? void 0 : options.UNSTABLE_extraVariables;
        var baseVariables = (0, _objectSpread2["default"])((0, _objectSpread2["default"])({}, parentVariables), fragmentVariables);
        var paginationVariables = getPaginationVariables(direction, count, cursor, baseVariables, (0, _objectSpread2["default"])({}, extraVariables), paginationMetadata);
        if (identifierInfo != null) {
            typeof identifierValue;
            paginationVariables[identifierInfo.identifierQueryVariableName] = identifierValue;
        }
        var paginationQuery = createOperationDescriptor(paginationRequest, paginationVariables, {
            force: true
        });
        fetchQuery(environment, paginationQuery).subscribe((0, _objectSpread2["default"])((0, _objectSpread2["default"])({}, observer), {}, {
            start: function start(subscription) {
                startFetch(subscription);
                observer.start && observer.start(subscription);
            },
            complete: function complete() {
                completeFetch();
                observer.complete && observer.complete();
                onComplete && onComplete(null);
            },
            error: function error(_error) {
                completeFetch();
                observer.error && observer.error(_error);
                onComplete && onComplete(_error);
            }
        }));
        return {
            dispose: disposeFetch
        };
    }, [
        environment,
        identifierValue,
        direction,
        cursor,
        startFetch,
        disposeFetch,
        completeFetch,
        isFetchingRef,
        isRequestInvalid,
        fragmentNode.name,
        fragmentRef,
        componentDisplayName
    ]);
    return [
        loadMore,
        hasMore,
        disposeFetch
    ];
}
module.exports = useLoadMoreFunction;

},{"3ac2587f9e904957":"590td","72489d7554b40490":"2Bj1n","a9ddeb0b12965a64":"1fPmu","d1b67a19bb0e9dfe":"inPRo","c752c06730124926":"bqjPh","ea77eb8e4c5dc9bc":"e43Xv","7a87ec5ed97fbc68":"8ihaP","30acdd32f952f70b":"bs9Iy","4a5df82bf0f64915":"e2sci","74b8166276ceae31":"ltHCL","d7d30e261b59c6bd":"2IxFR","2b34752cc6db60a3":"j64TH"}],"1fPmu":[function(require,module,exports,__globalThis) {
'use strict';
var invariant = require("dad966fd4928c363");
var _require = require("353dab5effee535d"), ConnectionInterface = _require.ConnectionInterface, getValueAtPath = _require.getValueAtPath;
function getConnectionState(direction, fragmentNode, fragmentData, connectionPathInFragmentData) {
    var _pageInfo$END_CURSOR, _pageInfo$START_CURSO;
    var _ConnectionInterface$ = ConnectionInterface.get(), EDGES = _ConnectionInterface$.EDGES, PAGE_INFO = _ConnectionInterface$.PAGE_INFO, HAS_NEXT_PAGE = _ConnectionInterface$.HAS_NEXT_PAGE, HAS_PREV_PAGE = _ConnectionInterface$.HAS_PREV_PAGE, END_CURSOR = _ConnectionInterface$.END_CURSOR, START_CURSOR = _ConnectionInterface$.START_CURSOR;
    var connection = getValueAtPath(fragmentData, connectionPathInFragmentData);
    if (connection == null) return {
        cursor: null,
        hasMore: false
    };
    !(typeof connection === 'object') && invariant(false);
    var edges = connection[EDGES];
    var pageInfo = connection[PAGE_INFO];
    if (edges == null || pageInfo == null) return {
        cursor: null,
        hasMore: false
    };
    !Array.isArray(edges) && invariant(false);
    !(typeof pageInfo === 'object') && invariant(false);
    var cursor = direction === 'forward' ? (_pageInfo$END_CURSOR = pageInfo[END_CURSOR]) !== null && _pageInfo$END_CURSOR !== void 0 ? _pageInfo$END_CURSOR : null : (_pageInfo$START_CURSO = pageInfo[START_CURSOR]) !== null && _pageInfo$START_CURSO !== void 0 ? _pageInfo$START_CURSO : null;
    !(cursor === null || typeof cursor === 'string') && invariant(false);
    var hasMore;
    if (direction === 'forward') hasMore = cursor != null && pageInfo[HAS_NEXT_PAGE] === true;
    else hasMore = cursor != null && pageInfo[HAS_PREV_PAGE] === true;
    return {
        cursor: cursor,
        hasMore: hasMore
    };
}
module.exports = getConnectionState;

},{"dad966fd4928c363":"e2sci","353dab5effee535d":"2IxFR"}],"e43Xv":[function(require,module,exports,__globalThis) {
'use strict';
var useRelayEnvironment = require("34a4af4ec66704d3");
var invariant = require("a9eeef1c36adce8d");
var React = require("7999654593a1e9d0");
var _require = require("5882e5c2a2d502a7"), getObservableForActiveRequest = _require.__internal.getObservableForActiveRequest, getSelector = _require.getSelector;
var useEffect = React.useEffect, useState = React.useState, useMemo = React.useMemo;
function useIsOperationNodeActive(fragmentNode, fragmentRef) {
    var environment = useRelayEnvironment();
    var observable = useMemo(function() {
        var selector = getSelector(fragmentNode, fragmentRef);
        if (selector == null) return null;
        !(selector.kind === 'SingularReaderSelector') && invariant(false);
        return getObservableForActiveRequest(environment, selector.owner);
    }, [
        environment,
        fragmentNode,
        fragmentRef
    ]);
    var _useState = useState(observable != null), isActive = _useState[0], setIsActive = _useState[1];
    useEffect(function() {
        var subscription;
        setIsActive(observable != null);
        if (observable != null) {
            var onCompleteOrError = function onCompleteOrError() {
                setIsActive(false);
            };
            subscription = observable.subscribe({
                complete: onCompleteOrError,
                error: onCompleteOrError
            });
        }
        return function() {
            if (subscription) subscription.unsubscribe();
        };
    }, [
        observable
    ]);
    return isActive;
}
module.exports = useIsOperationNodeActive;

},{"34a4af4ec66704d3":"bs9Iy","a9eeef1c36adce8d":"e2sci","7999654593a1e9d0":"ltHCL","5882e5c2a2d502a7":"2IxFR"}],"8ihaP":[function(require,module,exports,__globalThis) {
'use strict';
var _interopRequireDefault = require("db5602a95c2e00c6")["default"];
var _objectSpread2 = _interopRequireDefault(require("c2489f898dfc7399"));
var getConnectionState = require("564f5b274a3b41f1");
var useIsMountedRef = require("ccd599536355803e");
var useIsOperationNodeActive = require("3933746ba74821e9");
var useRelayEnvironment = require("950af906d0cd231f");
var invariant = require("d8c391218b733353");
var _require = require("3e7537eaab8fccec"), useCallback = _require.useCallback, useRef = _require.useRef, useState = _require.useState;
var _require2 = require("8232e93faa82a1e2"), fetchQuery = _require2.__internal.fetchQuery, createOperationDescriptor = _require2.createOperationDescriptor, getPaginationVariables = _require2.getPaginationVariables, getRefetchMetadata = _require2.getRefetchMetadata, getSelector = _require2.getSelector;
var warning = require("4dfc17bee0326eb1");
function useLoadMoreFunction_EXPERIMENTAL(args) {
    var direction = args.direction, fragmentNode = args.fragmentNode, fragmentRef = args.fragmentRef, fragmentIdentifier = args.fragmentIdentifier, fragmentData = args.fragmentData, connectionPathInFragmentData = args.connectionPathInFragmentData, paginationRequest = args.paginationRequest, paginationMetadata = args.paginationMetadata, componentDisplayName = args.componentDisplayName, observer = args.observer, onReset = args.onReset;
    var environment = useRelayEnvironment();
    var _getRefetchMetadata = getRefetchMetadata(fragmentNode, componentDisplayName), identifierInfo = _getRefetchMetadata.identifierInfo;
    var identifierValue = (identifierInfo === null || identifierInfo === void 0 ? void 0 : identifierInfo.identifierField) != null && fragmentData != null && typeof fragmentData === 'object' ? fragmentData[identifierInfo.identifierField] : null;
    var fetchStatusRef = useRef({
        kind: 'none'
    });
    var _useState = useState(environment), mirroredEnvironment = _useState[0], setMirroredEnvironment = _useState[1];
    var _useState2 = useState(fragmentIdentifier), mirroredFragmentIdentifier = _useState2[0], setMirroredFragmentIdentifier = _useState2[1];
    var isParentQueryActive = useIsOperationNodeActive(fragmentNode, fragmentRef);
    var forceDisposeFn = useCallback(function() {
        if (fetchStatusRef.current.kind === 'fetching') fetchStatusRef.current.subscription.unsubscribe();
        fetchStatusRef.current = {
            kind: 'none'
        };
    }, []);
    var shouldReset = environment !== mirroredEnvironment || fragmentIdentifier !== mirroredFragmentIdentifier;
    if (shouldReset) {
        forceDisposeFn();
        onReset();
        setMirroredEnvironment(environment);
        setMirroredFragmentIdentifier(fragmentIdentifier);
    }
    var _getConnectionState = getConnectionState(direction, fragmentNode, fragmentData, connectionPathInFragmentData), cursor = _getConnectionState.cursor, hasMore = _getConnectionState.hasMore;
    var isRequestInvalid = fragmentData == null || isParentQueryActive;
    var isMountedRef = useIsMountedRef();
    var loadMore = useCallback(function(count, options) {
        var onComplete = options === null || options === void 0 ? void 0 : options.onComplete;
        if (isMountedRef.current !== true) return {
            dispose: function dispose() {}
        };
        var fragmentSelector = getSelector(fragmentNode, fragmentRef);
        if (fetchStatusRef.current.kind === 'fetching' || isRequestInvalid) {
            fragmentSelector;
            if (onComplete) onComplete(null);
            return {
                dispose: function dispose() {}
            };
        }
        !(fragmentSelector != null && fragmentSelector.kind !== 'PluralReaderSelector') && invariant(false);
        var parentVariables = fragmentSelector.owner.variables;
        var fragmentVariables = fragmentSelector.variables;
        var extraVariables = options === null || options === void 0 ? void 0 : options.UNSTABLE_extraVariables;
        var baseVariables = (0, _objectSpread2["default"])((0, _objectSpread2["default"])({}, parentVariables), fragmentVariables);
        var paginationVariables = getPaginationVariables(direction, count, cursor, baseVariables, (0, _objectSpread2["default"])({}, extraVariables), paginationMetadata);
        if (identifierInfo != null) {
            typeof identifierValue;
            paginationVariables[identifierInfo.identifierQueryVariableName] = identifierValue;
        }
        var paginationQuery = createOperationDescriptor(paginationRequest, paginationVariables, {
            force: true
        });
        fetchQuery(environment, paginationQuery).subscribe((0, _objectSpread2["default"])((0, _objectSpread2["default"])({}, observer), {}, {
            start: function start(subscription) {
                fetchStatusRef.current = {
                    kind: 'fetching',
                    subscription: subscription
                };
                observer.start && observer.start(subscription);
            },
            complete: function complete() {
                fetchStatusRef.current = {
                    kind: 'none'
                };
                observer.complete && observer.complete();
                onComplete && onComplete(null);
            },
            error: function error(_error) {
                fetchStatusRef.current = {
                    kind: 'none'
                };
                observer.complete && observer.complete();
                onComplete && onComplete(_error);
            }
        }));
        return {
            dispose: function dispose() {}
        };
    }, [
        environment,
        identifierValue,
        direction,
        cursor,
        isRequestInvalid,
        fragmentNode.name,
        fragmentRef,
        componentDisplayName
    ]);
    return [
        loadMore,
        hasMore,
        forceDisposeFn
    ];
}
module.exports = useLoadMoreFunction_EXPERIMENTAL;

},{"db5602a95c2e00c6":"590td","c2489f898dfc7399":"2Bj1n","564f5b274a3b41f1":"1fPmu","ccd599536355803e":"bqjPh","3933746ba74821e9":"e43Xv","950af906d0cd231f":"bs9Iy","d8c391218b733353":"e2sci","3e7537eaab8fccec":"ltHCL","8232e93faa82a1e2":"2IxFR","4dfc17bee0326eb1":"j64TH"}],"hXj4k":[function(require,module,exports,__globalThis) {
'use strict';
var _interopRequireDefault = require("ac693a74629df594")["default"];
var _objectSpread2 = _interopRequireDefault(require("c2b913b1851b218a"));
var ProfilerContext = require("f6820d7f5df5337b");
var _require = require("9d858f0e1a8ac95c"), getQueryResourceForEnvironment = _require.getQueryResourceForEnvironment;
var readFragmentInternal = require("eb48c040dcb4cd95");
var useFragmentInternal = require("5ab498c4c84970c9");
var useIsMountedRef = require("a1154bcf0d8e0071");
var useQueryLoader = require("9df04fa0964dc0ce");
var useRelayEnvironment = require("8ee3403724de62d9");
var invariant = require("dcd3b70efb9bc004");
var _require2 = require("3bb81a8e463dc0db"), useCallback = _require2.useCallback, useContext = _require2.useContext, useReducer = _require2.useReducer;
var _require3 = require("6a2e661e8095583a"), fetchQuery = _require3.__internal.fetchQuery, createOperationDescriptor = _require3.createOperationDescriptor, getFragmentIdentifier = _require3.getFragmentIdentifier, getRefetchMetadata = _require3.getRefetchMetadata, getSelector = _require3.getSelector, getValueAtPath = _require3.getValueAtPath;
var warning = require("a9824c52910444e6");
function reducer(state, action) {
    switch(action.type){
        case 'refetch':
            var _action$refetchEnviro;
            return (0, _objectSpread2["default"])((0, _objectSpread2["default"])({}, state), {}, {
                fetchPolicy: action.fetchPolicy,
                mirroredEnvironment: (_action$refetchEnviro = action.refetchEnvironment) !== null && _action$refetchEnviro !== void 0 ? _action$refetchEnviro : state.mirroredEnvironment,
                onComplete: action.onComplete,
                refetchEnvironment: action.refetchEnvironment,
                refetchQuery: action.refetchQuery,
                renderPolicy: action.renderPolicy
            });
        case 'reset':
            return {
                fetchPolicy: undefined,
                mirroredEnvironment: action.environment,
                mirroredFragmentIdentifier: action.fragmentIdentifier,
                onComplete: undefined,
                refetchQuery: null,
                renderPolicy: undefined
            };
        default:
            action.type;
            throw new Error('useRefetchableFragmentNode: Unexpected action type');
    }
}
function useRefetchableFragmentInternal(fragmentNode, parentFragmentRef, componentDisplayName) {
    var parentEnvironment = useRelayEnvironment();
    var _getRefetchMetadata = getRefetchMetadata(fragmentNode, componentDisplayName), refetchableRequest = _getRefetchMetadata.refetchableRequest, fragmentRefPathInResponse = _getRefetchMetadata.fragmentRefPathInResponse, identifierInfo = _getRefetchMetadata.identifierInfo;
    var fragmentIdentifier = getFragmentIdentifier(fragmentNode, parentFragmentRef);
    var _useReducer = useReducer(reducer, {
        fetchPolicy: undefined,
        mirroredEnvironment: parentEnvironment,
        mirroredFragmentIdentifier: fragmentIdentifier,
        onComplete: undefined,
        refetchEnvironment: null,
        refetchQuery: null,
        renderPolicy: undefined
    }), refetchState = _useReducer[0], dispatch = _useReducer[1];
    var fetchPolicy = refetchState.fetchPolicy, mirroredEnvironment = refetchState.mirroredEnvironment, mirroredFragmentIdentifier = refetchState.mirroredFragmentIdentifier, onComplete = refetchState.onComplete, refetchEnvironment = refetchState.refetchEnvironment, refetchQuery = refetchState.refetchQuery, renderPolicy = refetchState.renderPolicy;
    var environment = refetchEnvironment !== null && refetchEnvironment !== void 0 ? refetchEnvironment : parentEnvironment;
    var QueryResource = getQueryResourceForEnvironment(environment);
    var profilerContext = useContext(ProfilerContext);
    var shouldReset = environment !== mirroredEnvironment || fragmentIdentifier !== mirroredFragmentIdentifier;
    var _useQueryLoader = useQueryLoader(refetchableRequest), queryRef = _useQueryLoader[0], loadQuery = _useQueryLoader[1], disposeQuery = _useQueryLoader[2];
    var fragmentRef = parentFragmentRef;
    if (shouldReset) {
        dispatch({
            type: 'reset',
            environment: environment,
            fragmentIdentifier: fragmentIdentifier
        });
        disposeQuery();
    } else if (refetchQuery != null && queryRef != null) {
        var debugPreviousIDAndTypename;
        var handleQueryCompleted = function handleQueryCompleted(maybeError) {
            onComplete && onComplete(maybeError !== null && maybeError !== void 0 ? maybeError : null);
        };
        var fetchObservable = queryRef.source != null ? queryRef.source : fetchQuery(environment, refetchQuery);
        var queryResult = profilerContext.wrapPrepareQueryResource(function() {
            return QueryResource.prepare(refetchQuery, fetchObservable, fetchPolicy, renderPolicy, {
                error: handleQueryCompleted,
                complete: function complete() {
                    handleQueryCompleted();
                }
            }, queryRef.fetchKey, profilerContext);
        });
        var queryData = readFragmentInternal(environment, queryResult.fragmentNode, queryResult.fragmentRef, componentDisplayName).data;
        !(queryData != null) && invariant(false);
        var refetchedFragmentRef = getValueAtPath(queryData, fragmentRefPathInResponse);
        fragmentRef = refetchedFragmentRef;
    }
    var fragmentData = useFragmentInternal(fragmentNode, fragmentRef, componentDisplayName);
    var refetch = useRefetchFunction(componentDisplayName, dispatch, disposeQuery, fragmentData, fragmentIdentifier, fragmentNode, fragmentRefPathInResponse, identifierInfo, loadQuery, parentFragmentRef, refetchableRequest);
    return {
        fragmentData: fragmentData,
        fragmentRef: fragmentRef,
        refetch: refetch
    };
}
function useRefetchFunction(componentDisplayName, dispatch, disposeQuery, fragmentData, fragmentIdentifier, fragmentNode, fragmentRefPathInResponse, identifierInfo, loadQuery, parentFragmentRef, refetchableRequest) {
    var isMountedRef = useIsMountedRef();
    var identifierValue = (identifierInfo === null || identifierInfo === void 0 ? void 0 : identifierInfo.identifierField) != null && fragmentData != null && typeof fragmentData === 'object' ? fragmentData[identifierInfo.identifierField] : null;
    return useCallback(function(providedRefetchVariables, options) {
        if (isMountedRef.current !== true) return {
            dispose: function dispose() {}
        };
        parentFragmentRef;
        var refetchEnvironment = options === null || options === void 0 ? void 0 : options.__environment;
        var fetchPolicy = options === null || options === void 0 ? void 0 : options.fetchPolicy;
        var renderPolicy = options === null || options === void 0 ? void 0 : options.UNSTABLE_renderPolicy;
        var onComplete = options === null || options === void 0 ? void 0 : options.onComplete;
        var fragmentSelector = getSelector(fragmentNode, parentFragmentRef);
        var parentVariables;
        var fragmentVariables;
        if (fragmentSelector == null) {
            parentVariables = {};
            fragmentVariables = {};
        } else if (fragmentSelector.kind === 'PluralReaderSelector') {
            var _fragmentSelector$sel, _fragmentSelector$sel2, _fragmentSelector$sel3, _fragmentSelector$sel4;
            parentVariables = (_fragmentSelector$sel = (_fragmentSelector$sel2 = fragmentSelector.selectors[0]) === null || _fragmentSelector$sel2 === void 0 ? void 0 : _fragmentSelector$sel2.owner.variables) !== null && _fragmentSelector$sel !== void 0 ? _fragmentSelector$sel : {};
            fragmentVariables = (_fragmentSelector$sel3 = (_fragmentSelector$sel4 = fragmentSelector.selectors[0]) === null || _fragmentSelector$sel4 === void 0 ? void 0 : _fragmentSelector$sel4.variables) !== null && _fragmentSelector$sel3 !== void 0 ? _fragmentSelector$sel3 : {};
        } else {
            parentVariables = fragmentSelector.owner.variables;
            fragmentVariables = fragmentSelector.variables;
        }
        var refetchVariables = (0, _objectSpread2["default"])((0, _objectSpread2["default"])((0, _objectSpread2["default"])({}, parentVariables), fragmentVariables), providedRefetchVariables);
        if (identifierInfo != null && !providedRefetchVariables.hasOwnProperty(identifierInfo.identifierQueryVariableName)) {
            typeof identifierValue;
            refetchVariables[identifierInfo.identifierQueryVariableName] = identifierValue;
        }
        var refetchQuery = createOperationDescriptor(refetchableRequest, refetchVariables, {
            force: true
        });
        loadQuery(refetchQuery.request.variables, {
            fetchPolicy: fetchPolicy,
            __environment: refetchEnvironment,
            __nameForWarning: 'refetch'
        });
        dispatch({
            type: 'refetch',
            fetchPolicy: fetchPolicy,
            onComplete: onComplete,
            refetchEnvironment: refetchEnvironment,
            refetchQuery: refetchQuery,
            renderPolicy: renderPolicy
        });
        return {
            dispose: disposeQuery
        };
    }, [
        fragmentIdentifier,
        dispatch,
        disposeQuery,
        identifierValue,
        loadQuery
    ]);
}
var debugFunctions;
module.exports = useRefetchableFragmentInternal;

},{"ac693a74629df594":"590td","c2b913b1851b218a":"2Bj1n","f6820d7f5df5337b":"1lEHI","9d858f0e1a8ac95c":"gv1jq","eb48c040dcb4cd95":"j6ktb","5ab498c4c84970c9":"eglKT","a1154bcf0d8e0071":"bqjPh","9df04fa0964dc0ce":"aiqzn","8ee3403724de62d9":"bs9Iy","dcd3b70efb9bc004":"e2sci","3bb81a8e463dc0db":"ltHCL","6a2e661e8095583a":"2IxFR","a9824c52910444e6":"j64TH"}],"j6ktb":[function(require,module,exports,__globalThis) {
'use strict';
var _interopRequireDefault = require("f9511564d4e9b960")["default"];
var _objectSpread2 = _interopRequireDefault(require("353c94e2095de9f4"));
var _createForOfIteratorHelper2 = _interopRequireDefault(require("55fb6ea8634dae59"));
var _require = require("6f3b0159c357784c"), getQueryResourceForEnvironment = _require.getQueryResourceForEnvironment;
var invariant = require("879622bbb6c4bca3");
var _require2 = require("17db8300b5c33f37"), fetchQueryInternal = _require2.__internal.fetchQuery, RelayFeatureFlags = _require2.RelayFeatureFlags, createOperationDescriptor = _require2.createOperationDescriptor, getPendingOperationsForFragment = _require2.getPendingOperationsForFragment, getSelector = _require2.getSelector, getVariablesFromFragment = _require2.getVariablesFromFragment, handlePotentialSnapshotErrors = _require2.handlePotentialSnapshotErrors;
var warning = require("646f64ee7fb37967");
function isMissingData(state) {
    if (state.kind === 'bailout') return false;
    else if (state.kind === 'singular') return state.snapshot.isMissingData;
    else return state.snapshots.some(function(s) {
        return s.isMissingData;
    });
}
function getMissingClientEdges(state) {
    if (state.kind === 'bailout') return null;
    else if (state.kind === 'singular') {
        var _state$snapshot$missi;
        return (_state$snapshot$missi = state.snapshot.missingClientEdges) !== null && _state$snapshot$missi !== void 0 ? _state$snapshot$missi : null;
    } else {
        var edges = null;
        var _iterator = (0, _createForOfIteratorHelper2["default"])(state.snapshots), _step;
        try {
            for(_iterator.s(); !(_step = _iterator.n()).done;){
                var snapshot = _step.value;
                if (snapshot.missingClientEdges) {
                    var _edges;
                    edges = (_edges = edges) !== null && _edges !== void 0 ? _edges : [];
                    var _iterator2 = (0, _createForOfIteratorHelper2["default"])(snapshot.missingClientEdges), _step2;
                    try {
                        for(_iterator2.s(); !(_step2 = _iterator2.n()).done;){
                            var edge = _step2.value;
                            edges.push(edge);
                        }
                    } catch (err) {
                        _iterator2.e(err);
                    } finally{
                        _iterator2.f();
                    }
                }
            }
        } catch (err) {
            _iterator.e(err);
        } finally{
            _iterator.f();
        }
        return edges;
    }
}
function handlePotentialSnapshotErrorsForState(environment, state) {
    if (state.kind === 'singular') handlePotentialSnapshotErrors(environment, state.snapshot.fieldErrors);
    else if (state.kind === 'plural') {
        var _iterator3 = (0, _createForOfIteratorHelper2["default"])(state.snapshots), _step3;
        try {
            for(_iterator3.s(); !(_step3 = _iterator3.n()).done;){
                var snapshot = _step3.value;
                handlePotentialSnapshotErrors(environment, snapshot.fieldErrors);
            }
        } catch (err) {
            _iterator3.e(err);
        } finally{
            _iterator3.f();
        }
    }
}
function handleMissingClientEdge(environment, parentFragmentNode, parentFragmentRef, missingClientEdgeRequestInfo, queryOptions) {
    var originalVariables = getVariablesFromFragment(parentFragmentNode, parentFragmentRef);
    var variables = (0, _objectSpread2["default"])((0, _objectSpread2["default"])({}, originalVariables), {}, {
        id: missingClientEdgeRequestInfo.clientEdgeDestinationID
    });
    var queryOperationDescriptor = createOperationDescriptor(missingClientEdgeRequestInfo.request, variables, queryOptions === null || queryOptions === void 0 ? void 0 : queryOptions.networkCacheConfig);
    var QueryResource = getQueryResourceForEnvironment(environment);
    return QueryResource.prepare(queryOperationDescriptor, fetchQueryInternal(environment, queryOperationDescriptor), queryOptions === null || queryOptions === void 0 ? void 0 : queryOptions.fetchPolicy);
}
function getFragmentState(environment, fragmentSelector) {
    if (fragmentSelector == null) return {
        kind: 'bailout'
    };
    else if (fragmentSelector.kind === 'PluralReaderSelector') {
        if (fragmentSelector.selectors.length === 0) return {
            kind: 'bailout'
        };
        else return {
            kind: 'plural',
            snapshots: fragmentSelector.selectors.map(function(s) {
                return environment.lookup(s);
            }),
            epoch: environment.getStore().getEpoch()
        };
    } else return {
        kind: 'singular',
        snapshot: environment.lookup(fragmentSelector),
        epoch: environment.getStore().getEpoch()
    };
}
function readFragmentInternal(environment, fragmentNode, fragmentRef, hookDisplayName, queryOptions, fragmentKey) {
    var _fragmentNode$metadat, _fragmentNode$metadat2;
    var fragmentSelector = getSelector(fragmentNode, fragmentRef);
    var isPlural = (fragmentNode === null || fragmentNode === void 0 ? void 0 : (_fragmentNode$metadat = fragmentNode.metadata) === null || _fragmentNode$metadat === void 0 ? void 0 : _fragmentNode$metadat.plural) === true;
    if (isPlural) !(fragmentRef == null || Array.isArray(fragmentRef)) && invariant(false);
    else !!Array.isArray(fragmentRef) && invariant(false);
    !(fragmentRef == null || isPlural && Array.isArray(fragmentRef) && fragmentRef.length === 0 || fragmentSelector != null) && invariant(false);
    var state = getFragmentState(environment, fragmentSelector);
    var clientEdgeQueries = null;
    if (((_fragmentNode$metadat2 = fragmentNode.metadata) === null || _fragmentNode$metadat2 === void 0 ? void 0 : _fragmentNode$metadat2.hasClientEdges) === true || RelayFeatureFlags.CHECK_ALL_FRAGMENTS_FOR_MISSING_CLIENT_EDGES) {
        var missingClientEdges = getMissingClientEdges(state);
        if (missingClientEdges !== null && missingClientEdges !== void 0 && missingClientEdges.length) {
            clientEdgeQueries = [];
            var _iterator4 = (0, _createForOfIteratorHelper2["default"])(missingClientEdges), _step4;
            try {
                for(_iterator4.s(); !(_step4 = _iterator4.n()).done;){
                    var edge = _step4.value;
                    clientEdgeQueries.push(handleMissingClientEdge(environment, fragmentNode, fragmentRef, edge, queryOptions));
                }
            } catch (err) {
                _iterator4.e(err);
            } finally{
                _iterator4.f();
            }
        }
    }
    if (isMissingData(state)) {
        !(fragmentSelector != null) && invariant(false);
        var fragmentOwner = fragmentSelector.kind === 'PluralReaderSelector' ? fragmentSelector.selectors[0].owner : fragmentSelector.owner;
        var pendingOperationsResult = getPendingOperationsForFragment(environment, fragmentNode, fragmentOwner);
        if (pendingOperationsResult) throw pendingOperationsResult.promise;
        handlePotentialSnapshotErrorsForState(environment, state);
    }
    var data;
    if (state.kind === 'bailout') data = isPlural ? [] : null;
    else if (state.kind === 'singular') data = state.snapshot.data;
    else data = state.snapshots.map(function(s) {
        return s.data;
    });
    if (RelayFeatureFlags.LOG_MISSING_RECORDS_IN_PROD || false) fragmentRef != null && (data === undefined || Array.isArray(data) && data.length > 0 && data.every(function(d) {
        return d === undefined;
    }));
    return {
        data: data,
        clientEdgeQueries: clientEdgeQueries
    };
}
module.exports = readFragmentInternal;

},{"f9511564d4e9b960":"590td","353c94e2095de9f4":"2Bj1n","55fb6ea8634dae59":"fMaLa","6f3b0159c357784c":"gv1jq","879622bbb6c4bca3":"e2sci","17db8300b5c33f37":"2IxFR","646f64ee7fb37967":"j64TH"}],"aiqzn":[function(require,module,exports,__globalThis) {
'use strict';
var _interopRequireDefault = require("6cb2c3ccc52d3e04")["default"];
var _createForOfIteratorHelper2 = _interopRequireDefault(require("4773fb1810474084"));
var _require = require("24bfc0805031a111"), loadQuery = _require.loadQuery;
var useIsMountedRef = require("da71897690c52194");
var useQueryLoader_EXPERIMENTAL = require("39ed6b2ced0a6701");
var useRelayEnvironment = require("e8162fbbf271eb8b");
var _require2 = require("6a5f1a721fab6555"), useCallback = _require2.useCallback, useEffect = _require2.useEffect, useRef = _require2.useRef, useState = _require2.useState;
var _require3 = require("b2e8a9e462cb557b"), RelayFeatureFlags = _require3.RelayFeatureFlags, getRequest = _require3.getRequest;
var initialNullQueryReferenceState = {
    kind: 'NullQueryReference'
};
function requestIsLiveQuery(preloadableRequest) {
    if (preloadableRequest.kind === 'PreloadableConcreteRequest') return preloadableRequest.params.metadata.live !== undefined;
    var request = getRequest(preloadableRequest);
    return request.params.metadata.live !== undefined;
}
function useQueryLoader(preloadableRequest, initialQueryReference) {
    if (RelayFeatureFlags.ENABLE_ACTIVITY_COMPATIBILITY) return useQueryLoader_EXPERIMENTAL(preloadableRequest, initialQueryReference);
    return useQueryLoader_CURRENT(preloadableRequest, initialQueryReference);
}
function useQueryLoader_CURRENT(preloadableRequest, initialQueryReference) {
    var initialQueryReferenceInternal = initialQueryReference !== null && initialQueryReference !== void 0 ? initialQueryReference : initialNullQueryReferenceState;
    var environment = useRelayEnvironment();
    var isMountedRef = useIsMountedRef();
    var undisposedQueryReferencesRef = useRef(new Set([
        initialQueryReferenceInternal
    ]));
    var _useState = useState(function() {
        return initialQueryReferenceInternal;
    }), queryReference = _useState[0], setQueryReference = _useState[1];
    var _useState2 = useState(function() {
        return initialQueryReferenceInternal;
    }), previousInitialQueryReference = _useState2[0], setPreviousInitialQueryReference = _useState2[1];
    if (initialQueryReferenceInternal !== previousInitialQueryReference) {
        undisposedQueryReferencesRef.current.add(initialQueryReferenceInternal);
        setPreviousInitialQueryReference(initialQueryReferenceInternal);
        setQueryReference(initialQueryReferenceInternal);
    }
    var disposeQuery = useCallback(function() {
        if (isMountedRef.current) {
            undisposedQueryReferencesRef.current.add(initialNullQueryReferenceState);
            setQueryReference(initialNullQueryReferenceState);
        }
    }, [
        isMountedRef
    ]);
    var queryLoaderCallback = useCallback(function(variables, options) {
        var mergedOptions = options != null && options.hasOwnProperty('__environment') ? {
            fetchPolicy: options.fetchPolicy,
            networkCacheConfig: options.networkCacheConfig,
            __nameForWarning: options.__nameForWarning
        } : options;
        if (isMountedRef.current) {
            var _options$__environmen;
            var updatedQueryReference = loadQuery((_options$__environmen = options === null || options === void 0 ? void 0 : options.__environment) !== null && _options$__environmen !== void 0 ? _options$__environmen : environment, preloadableRequest, variables, mergedOptions);
            undisposedQueryReferencesRef.current.add(updatedQueryReference);
            setQueryReference(updatedQueryReference);
        }
    }, [
        environment,
        preloadableRequest,
        setQueryReference,
        isMountedRef
    ]);
    var maybeHiddenOrFastRefresh = useRef(false);
    useEffect(function() {
        return function() {
            maybeHiddenOrFastRefresh.current = true;
        };
    }, []);
    useEffect(function() {
        if (maybeHiddenOrFastRefresh.current === true) {
            maybeHiddenOrFastRefresh.current = false;
            if (queryReference.kind !== 'NullQueryReference') queryLoaderCallback(queryReference.variables, {
                fetchPolicy: queryReference.fetchPolicy,
                networkCacheConfig: queryReference.networkCacheConfig
            });
            return;
        }
        var undisposedQueryReferences = undisposedQueryReferencesRef.current;
        if (isMountedRef.current) {
            var _iterator = (0, _createForOfIteratorHelper2["default"])(undisposedQueryReferences), _step;
            try {
                for(_iterator.s(); !(_step = _iterator.n()).done;){
                    var undisposedQueryReference = _step.value;
                    if (undisposedQueryReference === queryReference) break;
                    undisposedQueryReferences["delete"](undisposedQueryReference);
                    if (undisposedQueryReference.kind !== 'NullQueryReference') {
                        if (requestIsLiveQuery(preloadableRequest)) undisposedQueryReference.dispose && undisposedQueryReference.dispose();
                        else undisposedQueryReference.releaseQuery && undisposedQueryReference.releaseQuery();
                    }
                }
            } catch (err) {
                _iterator.e(err);
            } finally{
                _iterator.f();
            }
        }
    }, [
        queryReference,
        isMountedRef,
        queryLoaderCallback,
        preloadableRequest
    ]);
    useEffect(function() {
        return function disposeAllRemainingQueryReferences() {
            var _iterator2 = (0, _createForOfIteratorHelper2["default"])(undisposedQueryReferencesRef.current), _step2;
            try {
                for(_iterator2.s(); !(_step2 = _iterator2.n()).done;){
                    var undisposedQueryReference = _step2.value;
                    if (undisposedQueryReference.kind !== 'NullQueryReference') {
                        if (requestIsLiveQuery(preloadableRequest)) undisposedQueryReference.dispose && undisposedQueryReference.dispose();
                        else undisposedQueryReference.releaseQuery && undisposedQueryReference.releaseQuery();
                    }
                }
            } catch (err) {
                _iterator2.e(err);
            } finally{
                _iterator2.f();
            }
        };
    }, [
        preloadableRequest
    ]);
    return [
        queryReference.kind === 'NullQueryReference' ? null : queryReference,
        queryLoaderCallback,
        disposeQuery
    ];
}
module.exports = useQueryLoader;

},{"6cb2c3ccc52d3e04":"590td","4773fb1810474084":"fMaLa","24bfc0805031a111":"4CbeJ","da71897690c52194":"bqjPh","39ed6b2ced0a6701":"gMMqk","e8162fbbf271eb8b":"bs9Iy","6a5f1a721fab6555":"ltHCL","b2e8a9e462cb557b":"2IxFR"}],"gMMqk":[function(require,module,exports,__globalThis) {
'use strict';
var _interopRequireDefault = require("ac73b51b2ffbc559")["default"];
var _createForOfIteratorHelper2 = _interopRequireDefault(require("952694d0963d7d6c"));
var _require = require("ab56a06913d91ee0"), loadQuery = _require.loadQuery;
var useIsMountedRef = require("4b17cecb90bfffa");
var useRelayEnvironment = require("47cb4b499472de2c");
var _require2 = require("9e5a8f34f4e68fab"), useCallback = _require2.useCallback, useEffect = _require2.useEffect, useInsertionEffect = _require2.useInsertionEffect, useRef = _require2.useRef, useState = _require2.useState;
var _require3 = require("d70de92c66bffa96"), getRequest = _require3.getRequest;
var initialNullQueryReferenceState = {
    kind: 'NullQueryReference'
};
function requestIsLiveQuery(preloadableRequest) {
    if (preloadableRequest.kind === 'PreloadableConcreteRequest') return preloadableRequest.params.metadata.live !== undefined;
    var request = getRequest(preloadableRequest);
    return request.params.metadata.live !== undefined;
}
var CLEANUP_TIMEOUT = 300000;
function useQueryLoader_EXPERIMENTAL(preloadableRequest, initialQueryReference) {
    var initialQueryReferenceInternal = initialQueryReference !== null && initialQueryReference !== void 0 ? initialQueryReference : initialNullQueryReferenceState;
    var environment = useRelayEnvironment();
    var isMountedRef = useIsMountedRef();
    var undisposedQueryReferencesRef = useRef(null);
    if (undisposedQueryReferencesRef.current == null) undisposedQueryReferencesRef.current = new Set([
        initialQueryReferenceInternal
    ]);
    var _useState = useState(function() {
        return initialQueryReferenceInternal;
    }), queryReference = _useState[0], setQueryReference = _useState[1];
    var _useState2 = useState(function() {
        return initialQueryReferenceInternal;
    }), previousInitialQueryReference = _useState2[0], setPreviousInitialQueryReference = _useState2[1];
    if (initialQueryReferenceInternal !== previousInitialQueryReference) {
        var _undisposedQueryRefer;
        (_undisposedQueryRefer = undisposedQueryReferencesRef.current) === null || _undisposedQueryRefer === void 0 || _undisposedQueryRefer.add(initialQueryReferenceInternal);
        setPreviousInitialQueryReference(initialQueryReferenceInternal);
        setQueryReference(initialQueryReferenceInternal);
    }
    var disposeQuery = useCallback(function() {
        if (isMountedRef.current) {
            var _undisposedQueryRefer2;
            (_undisposedQueryRefer2 = undisposedQueryReferencesRef.current) === null || _undisposedQueryRefer2 === void 0 || _undisposedQueryRefer2.add(initialNullQueryReferenceState);
            setQueryReference(initialNullQueryReferenceState);
        }
    }, [
        isMountedRef
    ]);
    var queryLoaderCallback = useCallback(function(variables, options) {
        var _options$__environmen, _undisposedQueryRefer3;
        if (!isMountedRef.current) return;
        var mergedOptions = options != null && options.hasOwnProperty('__environment') ? {
            fetchPolicy: options.fetchPolicy,
            networkCacheConfig: options.networkCacheConfig,
            __nameForWarning: options.__nameForWarning
        } : options;
        var updatedQueryReference = loadQuery((_options$__environmen = options === null || options === void 0 ? void 0 : options.__environment) !== null && _options$__environmen !== void 0 ? _options$__environmen : environment, preloadableRequest, variables, mergedOptions);
        (_undisposedQueryRefer3 = undisposedQueryReferencesRef.current) === null || _undisposedQueryRefer3 === void 0 || _undisposedQueryRefer3.add(updatedQueryReference);
        setQueryReference(updatedQueryReference);
    }, [
        environment,
        preloadableRequest,
        setQueryReference,
        isMountedRef
    ]);
    var disposeAllRemainingQueryReferences = useCallback(function disposeAllRemainingQueryReferences(preloadableRequest, currentQueryReference) {
        var _undisposedQueryRefer4;
        var undisposedQueryReferences = (_undisposedQueryRefer4 = undisposedQueryReferencesRef.current) !== null && _undisposedQueryRefer4 !== void 0 ? _undisposedQueryRefer4 : new Set();
        var _iterator = (0, _createForOfIteratorHelper2["default"])(undisposedQueryReferences), _step;
        try {
            for(_iterator.s(); !(_step = _iterator.n()).done;){
                var undisposedQueryReference = _step.value;
                if (undisposedQueryReference === currentQueryReference) continue;
                if (undisposedQueryReference.kind !== 'NullQueryReference') {
                    if (requestIsLiveQuery(preloadableRequest)) undisposedQueryReference.dispose && undisposedQueryReference.dispose();
                    else undisposedQueryReference.releaseQuery && undisposedQueryReference.releaseQuery();
                }
            }
        } catch (err) {
            _iterator.e(err);
        } finally{
            _iterator.f();
        }
    }, []);
    var cleanupTimerRef = useRef(null);
    useEffect(function() {
        disposeAllRemainingQueryReferences(preloadableRequest, queryReference);
        if (cleanupTimerRef.current != null) {
            clearTimeout(cleanupTimerRef.current);
            cleanupTimerRef.current = null;
        }
        return function() {
            cleanupTimerRef.current = setTimeout(function() {
                disposeAllRemainingQueryReferences(preloadableRequest, null);
            }, CLEANUP_TIMEOUT);
        };
    }, [
        preloadableRequest,
        queryReference
    ]);
    useInsertionEffect(function() {
        return function() {
            cleanupTimerRef.current && clearTimeout(cleanupTimerRef.current);
            cleanupTimerRef.current = null;
            disposeAllRemainingQueryReferences(preloadableRequest, null);
        };
    }, [
        preloadableRequest
    ]);
    return [
        queryReference.kind === 'NullQueryReference' ? null : queryReference,
        queryLoaderCallback,
        disposeQuery
    ];
}
module.exports = useQueryLoader_EXPERIMENTAL;

},{"ac73b51b2ffbc559":"590td","952694d0963d7d6c":"fMaLa","ab56a06913d91ee0":"4CbeJ","4b17cecb90bfffa":"bqjPh","47cb4b499472de2c":"bs9Iy","9e5a8f34f4e68fab":"ltHCL","d70de92c66bffa96":"2IxFR"}],"lnoQc":[function(require,module,exports,__globalThis) {
'use strict';
var _interopRequireDefault = require("53d6685e646349fe")["default"];
var _objectSpread2 = _interopRequireDefault(require("bd34c599911d7cb9"));
var useFragment = require("ff25dbe056eb36c9");
var useLoadMoreFunction = require("f9a09bffb39a3a8c");
var useRefetchableFragmentInternal = require("86dad87b508f8735");
var useRelayEnvironment = require("3f764835c51e35f0");
var useStaticFragmentNodeWarning = require("1417730f13f4027b");
var invariant = require("992c6c53bc32b0b");
var _require = require("b7626318851550fa"), useCallback = _require.useCallback, useDebugValue = _require.useDebugValue, useEffect = _require.useEffect, useLayoutEffect = _require.useLayoutEffect, useMemo = _require.useMemo, useRef = _require.useRef, useState = _require.useState;
var _require2 = require("4256d3d79a86c713"), getFragment = _require2.getFragment, getFragmentIdentifier = _require2.getFragmentIdentifier, getPaginationMetadata = _require2.getPaginationMetadata;
var _require3 = require("4256d3d79a86c713"), ConnectionInterface = _require3.ConnectionInterface, RelayFeatureFlags = _require3.RelayFeatureFlags, getSelector = _require3.getSelector, getValueAtPath = _require3.getValueAtPath;
function usePrefetchableForwardPaginationFragment(fragmentInput, parentFragmentRef, bufferSize, initialSize, prefetchingLoadMoreOptions) {
    var _fragmentInput$metada, _fragmentInput$metada2;
    var minimalFetchSize = arguments.length > 5 && arguments[5] !== undefined ? arguments[5] : 1;
    var disablePrefetching = arguments.length > 6 && arguments[6] !== undefined ? arguments[6] : false;
    var fragmentNode = getFragment(fragmentInput);
    useStaticFragmentNodeWarning(fragmentNode, 'first argument of usePrefetchableForwardPaginationFragment()');
    var componentDisplayName = 'usePrefetchableForwardPaginationFragment()';
    var _getPaginationMetadat = getPaginationMetadata(fragmentNode, componentDisplayName), connectionPathInFragmentData = _getPaginationMetadat.connectionPathInFragmentData, paginationRequest = _getPaginationMetadat.paginationRequest, paginationMetadata = _getPaginationMetadat.paginationMetadata;
    var _useRefetchableFragme = useRefetchableFragmentInternal(fragmentNode, parentFragmentRef, componentDisplayName), fragmentData = _useRefetchableFragme.fragmentData, fragmentRef = _useRefetchableFragme.fragmentRef, refetch = _useRefetchableFragme.refetch;
    var fragmentIdentifier = getFragmentIdentifier(fragmentNode, fragmentRef);
    var edgeKeys = useMemo(function() {
        var connection = getValueAtPath(fragmentData, connectionPathInFragmentData);
        if (connection == null) return null;
        var _ConnectionInterface$ = ConnectionInterface.get(), EDGES = _ConnectionInterface$.EDGES;
        return connection[EDGES];
    }, [
        connectionPathInFragmentData,
        fragmentData
    ]);
    var sourceSize = edgeKeys == null ? -1 : edgeKeys.length;
    var _useState = useState(initialSize != null ? initialSize : sourceSize), _numInUse = _useState[0], setNumInUse = _useState[1];
    var numInUse = _numInUse;
    if (_numInUse === -1 && sourceSize !== -1) {
        numInUse = initialSize != null ? initialSize : sourceSize;
        setNumInUse(numInUse);
    }
    var environment = useRelayEnvironment();
    var _useState2 = useState(false), isLoadingMore = _useState2[0], reallySetIsLoadingMore = _useState2[1];
    var _useState3 = useState(false), isRefetching = _useState3[0], setIsRefetching = _useState3[1];
    var availableSizeRef = useRef(0);
    var setIsLoadingMore = useCallback(function(value) {
        var _environment$getSched;
        var schedule = (_environment$getSched = environment.getScheduler()) === null || _environment$getSched === void 0 ? void 0 : _environment$getSched.schedule;
        if (schedule) schedule(function() {
            reallySetIsLoadingMore(value);
        });
        else reallySetIsLoadingMore(value);
    }, [
        environment
    ]);
    var isLoadingMoreRef = useRef(false);
    var observer = useMemo(function() {
        function setIsLoadingFalse() {
            isLoadingMoreRef.current = false;
            setIsLoadingMore(false);
        }
        return {
            start: function start() {
                isLoadingMoreRef.current = true;
                reallySetIsLoadingMore(true);
            },
            complete: setIsLoadingFalse,
            error: setIsLoadingFalse,
            unsubscribe: RelayFeatureFlags.ENABLE_USE_PAGINATION_IS_LOADING_FIX ? setIsLoadingFalse : undefined
        };
    }, [
        setIsLoadingMore
    ]);
    var handleReset = useCallback(function() {
        if (!isRefetching) {
            var _environment$getSched2;
            var schedule = (_environment$getSched2 = environment.getScheduler()) === null || _environment$getSched2 === void 0 ? void 0 : _environment$getSched2.schedule;
            if (schedule) schedule(function() {
                setNumInUse(-1);
            });
            else setNumInUse(-1);
        }
        isLoadingMoreRef.current = false;
        setIsLoadingMore(false);
    }, [
        environment,
        isRefetching,
        setIsLoadingMore
    ]);
    var _useLoadMoreFunction = useLoadMoreFunction({
        componentDisplayName: componentDisplayName,
        connectionPathInFragmentData: connectionPathInFragmentData,
        direction: 'forward',
        fragmentData: fragmentData,
        fragmentIdentifier: fragmentIdentifier,
        fragmentNode: fragmentNode,
        fragmentRef: fragmentRef,
        paginationMetadata: paginationMetadata,
        paginationRequest: paginationRequest,
        observer: observer,
        onReset: handleReset
    }), loadMore = _useLoadMoreFunction[0], hasNext = _useLoadMoreFunction[1], disposeFetchNext = _useLoadMoreFunction[2];
    useLayoutEffect(function() {
        availableSizeRef.current = sourceSize - numInUse;
    }, [
        numInUse,
        sourceSize
    ]);
    var prefetchingUNSTABLE_extraVariables = prefetchingLoadMoreOptions === null || prefetchingLoadMoreOptions === void 0 ? void 0 : prefetchingLoadMoreOptions.UNSTABLE_extraVariables;
    var prefetchingOnComplete = prefetchingLoadMoreOptions === null || prefetchingLoadMoreOptions === void 0 ? void 0 : prefetchingLoadMoreOptions.onComplete;
    var showMore = useCallback(function(numToAdd, options) {
        if (!isLoadingMoreRef.current || availableSizeRef.current >= 0) {
            availableSizeRef.current -= numToAdd;
            setNumInUse(function(lastNumInUse) {
                return lastNumInUse + numToAdd;
            });
            if (!isLoadingMoreRef.current && availableSizeRef.current < 0) loadMore(Math.max(minimalFetchSize, Math.min(numToAdd, bufferSize - availableSizeRef.current)), options !== null && options !== void 0 ? options : {
                onComplete: prefetchingOnComplete,
                UNSTABLE_extraVariables: typeof prefetchingUNSTABLE_extraVariables === 'function' ? prefetchingUNSTABLE_extraVariables({
                    hasNext: hasNext,
                    data: fragmentData,
                    getServerEdges: function getServerEdges() {
                        var selector = getSelector(edgesFragment, edgeKeys);
                        if (selector == null) return [];
                        !(selector.kind === 'PluralReaderSelector') && invariant(false);
                        return selector.selectors.map(function(sel) {
                            return environment.lookup(sel).data;
                        });
                    }
                }) : prefetchingUNSTABLE_extraVariables
            });
        }
    }, [
        bufferSize,
        loadMore,
        minimalFetchSize,
        edgeKeys,
        fragmentData,
        prefetchingUNSTABLE_extraVariables,
        prefetchingOnComplete
    ]);
    var edgesFragment = (_fragmentInput$metada = fragmentInput.metadata) === null || _fragmentInput$metada === void 0 ? void 0 : (_fragmentInput$metada2 = _fragmentInput$metada.refetch) === null || _fragmentInput$metada2 === void 0 ? void 0 : _fragmentInput$metada2.edgesFragment;
    !(edgesFragment != null) && invariant(false);
    useEffect(function() {
        if (!isLoadingMoreRef.current && !isLoadingMore && !isRefetching && !disablePrefetching && hasNext && (sourceSize - numInUse < bufferSize || numInUse > sourceSize)) {
            var onComplete = prefetchingOnComplete;
            loadMore(Math.max(bufferSize - Math.max(sourceSize - numInUse, 0), numInUse - sourceSize, minimalFetchSize), {
                onComplete: onComplete,
                UNSTABLE_extraVariables: typeof prefetchingUNSTABLE_extraVariables === 'function' ? prefetchingUNSTABLE_extraVariables({
                    hasNext: hasNext,
                    data: fragmentData,
                    getServerEdges: function getServerEdges() {
                        var selector = getSelector(edgesFragment, edgeKeys);
                        if (selector == null) return [];
                        !(selector.kind === 'PluralReaderSelector') && invariant(false);
                        return selector.selectors.map(function(sel) {
                            return environment.lookup(sel).data;
                        });
                    }
                }) : prefetchingUNSTABLE_extraVariables
            });
        }
    }, [
        hasNext,
        bufferSize,
        isRefetching,
        loadMore,
        numInUse,
        prefetchingUNSTABLE_extraVariables,
        prefetchingOnComplete,
        sourceSize,
        edgeKeys,
        isLoadingMore,
        minimalFetchSize,
        environment,
        edgesFragment
    ]);
    var realNumInUse = Math.min(numInUse, sourceSize);
    var derivedEdgeKeys = useMemo(function() {
        var _edgeKeys$slice;
        return (_edgeKeys$slice = edgeKeys === null || edgeKeys === void 0 ? void 0 : edgeKeys.slice(0, realNumInUse)) !== null && _edgeKeys$slice !== void 0 ? _edgeKeys$slice : [];
    }, [
        edgeKeys,
        realNumInUse
    ]);
    var edges = useFragment(edgesFragment, derivedEdgeKeys);
    var refetchPagination = useCallback(function(variables, options) {
        disposeFetchNext();
        setIsRefetching(true);
        return refetch(variables, (0, _objectSpread2["default"])((0, _objectSpread2["default"])({}, options), {}, {
            onComplete: function onComplete(maybeError) {
                var _environment$getSched3, _options$onComplete;
                var schedule = (_environment$getSched3 = environment.getScheduler()) === null || _environment$getSched3 === void 0 ? void 0 : _environment$getSched3.schedule;
                if (schedule) schedule(function() {
                    setIsRefetching(false);
                    setNumInUse(-1);
                });
                else {
                    setIsRefetching(false);
                    setNumInUse(-1);
                }
                options === null || options === void 0 || (_options$onComplete = options.onComplete) === null || _options$onComplete === void 0 || _options$onComplete.call(options, maybeError);
            },
            __environment: undefined
        }));
    }, [
        disposeFetchNext,
        environment,
        refetch
    ]);
    return {
        edges: edges,
        data: fragmentData,
        loadNext: showMore,
        hasNext: hasNext || sourceSize > numInUse,
        isLoadingNext: isLoadingMore && numInUse > sourceSize,
        refetch: refetchPagination
    };
}
module.exports = usePrefetchableForwardPaginationFragment;

},{"53d6685e646349fe":"590td","bd34c599911d7cb9":"2Bj1n","ff25dbe056eb36c9":"1zoWc","f9a09bffb39a3a8c":"12mOd","86dad87b508f8735":"hXj4k","3f764835c51e35f0":"bs9Iy","1417730f13f4027b":"8SJsi","992c6c53bc32b0b":"e2sci","b7626318851550fa":"ltHCL","4256d3d79a86c713":"2IxFR"}],"kylpw":[function(require,module,exports,__globalThis) {
'use strict';
var useLazyLoadQueryNode = require("d8c29bce88644c1b");
var useMemoOperationDescriptor = require("7a3bee09b3b68737");
var useRelayEnvironment = require("3accb8a1eda38479");
var invariant = require("b920cef8fdc4e114");
var _require = require("f9c9cce025e39e75"), useDebugValue = _require.useDebugValue;
var _require2 = require("2d5bd0b0adc0aa47"), _require2$__internal = _require2.__internal, fetchQueryDeduped = _require2$__internal.fetchQueryDeduped, fetchQuery = _require2$__internal.fetchQuery;
var warning = require("b3dcf06d284b5853");
function usePreloadedQuery(gqlQuery, preloadedQuery, options) {
    var environment = useRelayEnvironment();
    var fetchKey = preloadedQuery.fetchKey, fetchPolicy = preloadedQuery.fetchPolicy, source = preloadedQuery.source, variables = preloadedQuery.variables, networkCacheConfig = preloadedQuery.networkCacheConfig;
    var operation = useMemoOperationDescriptor(gqlQuery, variables, networkCacheConfig);
    var useLazyLoadQueryNodeParams;
    if (preloadedQuery.kind === 'PreloadedQuery_DEPRECATED') {
        !(operation.request.node.params.name === preloadedQuery.name) && invariant(false);
        useLazyLoadQueryNodeParams = {
            componentDisplayName: 'usePreloadedQuery()',
            fetchKey: fetchKey,
            fetchObservable: fetchQueryDeduped(environment, operation.request.identifier, function() {
                if (environment === preloadedQuery.environment && source != null) return environment.executeWithSource({
                    operation: operation,
                    source: source
                });
                else return environment.execute({
                    operation: operation
                });
            }),
            fetchPolicy: fetchPolicy,
            query: operation,
            renderPolicy: options === null || options === void 0 ? void 0 : options.UNSTABLE_renderPolicy
        };
    } else {
        var fallbackFetchObservable = fetchQuery(environment, operation);
        var fetchObservable;
        if (source != null && environment === preloadedQuery.environment) fetchObservable = source.ifEmpty(fallbackFetchObservable);
        else if (environment !== preloadedQuery.environment) fetchObservable = fallbackFetchObservable;
        else fetchObservable = fallbackFetchObservable;
        useLazyLoadQueryNodeParams = {
            componentDisplayName: 'usePreloadedQuery()',
            fetchObservable: fetchObservable,
            fetchKey: fetchKey,
            fetchPolicy: fetchPolicy,
            query: operation,
            renderPolicy: options === null || options === void 0 ? void 0 : options.UNSTABLE_renderPolicy
        };
    }
    var data = useLazyLoadQueryNode(useLazyLoadQueryNodeParams);
    return data;
}
module.exports = usePreloadedQuery;

},{"d8c29bce88644c1b":"lkkQW","7a3bee09b3b68737":"jnI2X","3accb8a1eda38479":"bs9Iy","b920cef8fdc4e114":"e2sci","f9c9cce025e39e75":"ltHCL","2d5bd0b0adc0aa47":"2IxFR","b3dcf06d284b5853":"j64TH"}],"d2wqG":[function(require,module,exports,__globalThis) {
'use strict';
var useRefetchableFragmentInternal = require("1bb8827613203547");
var useStaticFragmentNodeWarning = require("699e141ab7bb354c");
var _require = require("1bbe14359652b7a7"), useDebugValue = _require.useDebugValue;
var _require2 = require("19361f6b5d849593"), getFragment = _require2.getFragment;
function useRefetchableFragment(fragmentInput, fragmentRef) {
    var fragmentNode = getFragment(fragmentInput);
    useStaticFragmentNodeWarning(fragmentNode, 'first argument of useRefetchableFragment()');
    var _useRefetchableFragme = useRefetchableFragmentInternal(fragmentNode, fragmentRef, 'useRefetchableFragment()'), fragmentData = _useRefetchableFragme.fragmentData, refetch = _useRefetchableFragme.refetch;
    return [
        fragmentData,
        refetch
    ];
}
module.exports = useRefetchableFragment;

},{"1bb8827613203547":"hXj4k","699e141ab7bb354c":"8SJsi","1bbe14359652b7a7":"ltHCL","19361f6b5d849593":"2IxFR"}],"dtX5o":[function(require,module,exports,__globalThis) {
'use strict';
var useRelayEnvironment = require("965b410d6fdf912d");
var _require = require("cf792cab208ff041"), useEffect = _require.useEffect, useRef = _require.useRef;
function useSubscribeToInvalidationState(dataIDs, callback) {
    var environment = useRelayEnvironment();
    var disposableRef = useRef(null);
    var stableDataIDs = Array.from(dataIDs).sort().join('');
    useEffect(function() {
        var store = environment.getStore();
        var invalidationState = store.lookupInvalidationState(dataIDs);
        var disposable = store.subscribeToInvalidationState(invalidationState, callback);
        disposableRef.current = disposable;
        return function() {
            return disposable.dispose();
        };
    }, [
        stableDataIDs,
        callback,
        environment
    ]);
    return {
        dispose: function dispose() {
            if (disposableRef.current != null) disposableRef.current.dispose();
        }
    };
}
module.exports = useSubscribeToInvalidationState;

},{"965b410d6fdf912d":"bs9Iy","cf792cab208ff041":"ltHCL"}],"6fzbF":[function(require,module,exports,__globalThis) {
'use strict';
var useRelayEnvironment = require("6ed4f7e3e22d401f");
var _require = require("e0162fa9badbe1e7"), useEffect = _require.useEffect;
var _require2 = require("86d88eec160104fb"), requestSubscription = _require2.requestSubscription;
function useSubscription(config, requestSubscriptionFn) {
    var actualRequestSubscription = requestSubscriptionFn !== null && requestSubscriptionFn !== void 0 ? requestSubscriptionFn : requestSubscription;
    var environment = useRelayEnvironment();
    useEffect(function() {
        var _actualRequestSubscri = actualRequestSubscription(environment, config), dispose = _actualRequestSubscri.dispose;
        return dispose;
    }, [
        environment,
        config,
        actualRequestSubscription
    ]);
}
module.exports = useSubscription;

},{"6ed4f7e3e22d401f":"bs9Iy","e0162fa9badbe1e7":"ltHCL","86d88eec160104fb":"2IxFR"}],"49JAT":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "prevPrefetchingRoute", ()=>prevPrefetchingRoute);
parcelHelpers.export(exports, "isSameRouteMatch", ()=>isSameRouteMatch);
class PrevPrefetchingRoute {
    setPrevRouteContext(route) {
        this.prevRouteContext = route;
    }
    isSameRouteMatch(route) {
        return !!this.prevRouteContext && isSameRouteMatch({
            prevContextMatch: this.prevRouteContext.match,
            nextContextMatch: route.match
        });
    }
    constructor(){
        this.prevRouteContext = null;
    }
}
const prevPrefetchingRoute = new PrevPrefetchingRoute();
const isShallowEqual = (o1, o2)=>{
    const objKeys1 = Object.keys(o1);
    const objKeys2 = Object.keys(o2);
    if (objKeys1.length !== objKeys2.length) return false;
    return objKeys1.every((key)=>o1[key] === o2[key]);
};
const isSameRouteMatch = ({ prevContextMatch, nextContextMatch })=>prevContextMatch.path === nextContextMatch.path && isShallowEqual(prevContextMatch.query, nextContextMatch.query) && isShallowEqual(prevContextMatch.params, nextContextMatch.params);

},{"@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"f9cxV":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "useCloudId", ()=>useCloudId);
var _reactResourceRouterNext = require("react-resource-router-next");
const useCloudId = ()=>{
    const [cloudId] = (0, _reactResourceRouterNext.usePathParam)('cloudId');
    if (!cloudId) throw new Error('Cloud Id must be provided in the route');
    return cloudId;
};

},{"react-resource-router-next":"6gkfP","@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"2oelf":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "isEntryPointRoute", ()=>isEntryPointRoute);
const isEntryPointRoute = (route)=>{
    return !!route.entryPoint && typeof route.entryPoint === 'function';
};

},{"@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"cZnbR":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "extractWorkspaceOrSiteIdFromPath", ()=>extractWorkspaceOrSiteIdFromPath);
const WORKSPACE_PATH_REGEX = /\/w\/([a-zA-Z0-9-_]+)/;
const SITE_PATH_REGEX = /\/s\/([^\/]+)/;
const getWorkspaceIdFromPath = ()=>{
    var _path_match;
    const path = window.location.pathname;
    const workspaceId = path === null || path === void 0 ? void 0 : (_path_match = path.match(WORKSPACE_PATH_REGEX)) === null || _path_match === void 0 ? void 0 : _path_match[1];
    return workspaceId;
};
const getSiteIdFromPath = ()=>{
    var _path_match;
    const path = window.location.pathname;
    const siteId = path === null || path === void 0 ? void 0 : (_path_match = path.match(SITE_PATH_REGEX)) === null || _path_match === void 0 ? void 0 : _path_match[1];
    return siteId;
};
const extractWorkspaceOrSiteIdFromPath = ()=>{
    const workspaceId = getWorkspaceIdFromPath();
    const siteId = getSiteIdFromPath();
    return {
        workspaceId,
        siteId
    };
};

},{"@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"d9T2z":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "useTransformStudioRoute", ()=>useTransformStudioRoute);
var _objectSpread = require("@swc/helpers/_/_object_spread");
var _objectSpreadProps = require("@swc/helpers/_/_object_spread_props");
var _react = require("react");
var _reactMagneticDi = require("react-magnetic-di");
var _reactResourceRouterNext = require("react-resource-router-next");
var _getStudioPath = require("../../utils/get-studio-path");
var _getStudioVersion = require("../../utils/get-studio-version");
const useTransformStudioRoute = ()=>{
    (0, _reactMagneticDi.di)();
    const [workspaceId] = (0, _reactResourceRouterNext.usePathParam)('workspaceId');
    const [spaceId] = (0, _reactResourceRouterNext.usePathParam)('spaceId');
    const transformRoute = (0, _react.useCallback)((route)=>({
            route: (0, _objectSpreadProps._)((0, _objectSpread._)({}, route), {
                path: (0, _getStudioPath.getStudioPath)(route.path)
            }),
            pathParams: (0, _objectSpread._)({}, (0, _getStudioVersion.isStudioV2)() ? {
                workspaceId,
                spaceId
            } : {})
        }), [
        spaceId,
        workspaceId
    ]);
    return {
        transformRoute
    };
};

},{"@swc/helpers/_/_object_spread":"9gdrV","@swc/helpers/_/_object_spread_props":"kANqQ","react":"ltHCL","react-magnetic-di":"hCzc8","react-resource-router-next":"6gkfP","../../utils/get-studio-path":"fqTIO","../../utils/get-studio-version":"fpbIA","@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"jNYYE":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "getStudioBaseUrl", ()=>getStudioBaseUrl);
var _atlassianStudioEnvUtils = require("@atlassian/atlassian-studio-env-utils");
const PROD_BASE_URL = 'https://studio.atlassian.com';
const STAGING_BASE_URL = 'https://atlassian-studio.stg-east.frontend.public.atl-paas.net';
const DEV_BASE_URL = 'http://localhost:9000';
const getStudioBaseUrl = ()=>{
    const env = (0, _atlassianStudioEnvUtils.getMappedEnv)();
    switch(env){
        case 'production':
            return PROD_BASE_URL;
        case 'staging':
            return STAGING_BASE_URL;
        case 'local':
            return DEV_BASE_URL;
        default:
            return DEV_BASE_URL;
    }
};

},{"@atlassian/atlassian-studio-env-utils":"lO9Ek","@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"cMbGI":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "StudioReliabilityTracker", ()=>StudioReliabilityTracker);
parcelHelpers.export(exports, "studioReliabilityTracker", ()=>studioReliabilityTracker);
var _objectSpread = require("@swc/helpers/_/_object_spread");
const buildKey = (task, taskId)=>taskId === undefined ? task : `${task}::${taskId}`;
class StudioReliabilityTracker {
    subscribe(subscriber) {
        this.subscribers.add(subscriber);
        return ()=>{
            this.subscribers.delete(subscriber);
        };
    }
    start({ task, taskId, touchpointId, attributes }) {
        const key = buildKey(task, taskId);
        if (this.activeTasks.has(key)) return;
        this.activeTasks.set(key, {
            task,
            taskId,
            touchpointId,
            attributes,
            startedAt: performance.now()
        });
        this.emit({
            type: 'start',
            task,
            taskId,
            touchpointId,
            attributes
        });
    }
    succeed({ task, taskId, attributes }) {
        const activeTask = this.consumeActiveTask(task, taskId);
        if (!activeTask) return;
        this.emit({
            type: 'succeed',
            task,
            taskId,
            touchpointId: activeTask.touchpointId,
            duration: performance.now() - activeTask.startedAt,
            attributes: (0, _objectSpread._)({}, activeTask.attributes, attributes)
        });
    }
    fail({ task, taskId, error, traceId, attributes }) {
        const activeTask = this.consumeActiveTask(task, taskId);
        if (!activeTask) return;
        this.emit({
            type: 'fail',
            task,
            taskId,
            touchpointId: activeTask.touchpointId,
            duration: performance.now() - activeTask.startedAt,
            error,
            traceId,
            attributes: (0, _objectSpread._)({}, activeTask.attributes, attributes)
        });
    }
    abort({ task, taskId, reason, attributes }) {
        const activeTask = this.consumeActiveTask(task, taskId);
        if (!activeTask) return;
        this.emit({
            type: 'abort',
            task,
            taskId,
            touchpointId: activeTask.touchpointId,
            duration: performance.now() - activeTask.startedAt,
            reason,
            attributes: (0, _objectSpread._)({}, activeTask.attributes, attributes)
        });
    }
    consumeActiveTask(task, taskId) {
        const key = buildKey(task, taskId);
        const activeTask = this.activeTasks.get(key);
        if (!activeTask) return undefined;
        this.activeTasks.delete(key);
        return activeTask;
    }
    emit(event) {
        this.subscribers.forEach((subscriber)=>{
            try {
                subscriber(event);
            } catch (e) {
            // no-op
            }
        });
    }
    constructor(){
        this.activeTasks = new Map();
        this.subscribers = new Set();
    }
}
const studioReliabilityTracker = new StudioReliabilityTracker();

},{"@swc/helpers/_/_object_spread":"9gdrV","@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"4YobW":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "initAnalyticsClient", ()=>initAnalyticsClient);
parcelHelpers.export(exports, "UIActionSubject", ()=>UIActionSubject);
parcelHelpers.export(exports, "Action", ()=>Action);
parcelHelpers.export(exports, "getTrackEventName", ()=>getTrackEventName);
parcelHelpers.export(exports, "getUIEventName", ()=>getUIEventName);
var _objectSpread = require("@swc/helpers/_/_object_spread");
var _analyticsWebClient = require("@atlassiansox/analytics-web-client");
var _analyticsWebClientDefault = parcelHelpers.interopDefault(_analyticsWebClient);
var _originTracing = require("@atlassiansox/origin-tracing");
var _originTracingDefault = parcelHelpers.interopDefault(_originTracing);
var _atlassianStudioEnvUtils = require("@atlassian/atlassian-studio-env-utils");
var _atlassianStudioRouting = require("@atlassian/atlassian-studio-routing");
const env = (0, _atlassianStudioEnvUtils.getMappedEnv)();
const product = 'atlassianStudio';
const getGasApiHost = ()=>{
    const currentDomain = window.location.hostname;
    switch(env){
        case 'staging':
        case 'production':
            return `${currentDomain}/gateway/api/gasv3/api/v1`;
        case 'test':
        case 'local':
            return 'atlassian-studio.stg-east.frontend.public.atl-paas.net/gateway/api/gasv3/api/v1';
        default:
            return 'atlassian-studio.stg-east.frontend.public.atl-paas.net/gateway/api/gasv3/api/v1';
    }
};
const initAnalyticsClient = ()=>{
    const client = new (0, _analyticsWebClientDefault.default)({
        env: (0, _atlassianStudioEnvUtils.getIdentityEnv)(),
        origin: (0, _analyticsWebClient.originType).WEB,
        product,
        subproduct: (0, _analyticsWebClient.originType).WEB,
        version: (0, _atlassianStudioRouting.isStudioV2)() ? 'v2' : 'v1'
    }, {
        apiHost: getGasApiHost(),
        // https://hello.atlassian.net/wiki/spaces/policy/pages/3303839825/Onboarding+a+Product+to+the+Cookies+Library+atlassian+browser-storage-controls#Upgrade-Analytics-Client-version-and-include-disableCookiePersistence-variable
        disableCookiePersistence: true
    });
    client.setOriginTracingHandlers({
        [(0, _analyticsWebClient.originTracingType).ATL_ORIGIN]: (encodedOrigin)=>{
            const origin = (0, _originTracingDefault.default).fromEncoded(encodedOrigin);
            return (0, _objectSpread._)({
                originTracingAttributes: origin.toAnalyticsAttributes()
            }, !origin.isMalformed() && {
                taskSessionId: origin.id
            });
        }
    });
    return client;
};
var UIActionSubject = /*#__PURE__*/ function(UIActionSubject) {
    UIActionSubject["PICKER"] = "picker";
    return UIActionSubject;
}({});
var Action = /*#__PURE__*/ function(Action) {
    Action["CLICKED"] = "clicked";
    Action["OPENED"] = "opened";
    Action["SEARCH"] = "searched";
    Action["PAGINATE"] = "paginated";
    Action["SELECTED"] = "selected";
    return Action;
}({});
const getTrackEventName = (actionSubject, action)=>`${actionSubject} ${action}`;
const getUIEventName = (actionSubject, action)=>`${actionSubject} ${action}`;

},{"@swc/helpers/_/_object_spread":"9gdrV","@atlassiansox/analytics-web-client":"6RHYr","@atlassiansox/origin-tracing":"7l8Iu","@atlassian/atlassian-studio-env-utils":"lO9Ek","@atlassian/atlassian-studio-routing":"aRetS","@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"6RHYr":[function(require,module,exports,__globalThis) {
/* eslint-disable @atlaskit/volt-strict-mode/no-multiple-exports */ var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>(0, _analyticsWebClientDefault.default));
parcelHelpers.export(exports, "apdexType", ()=>(0, _analyticsWebTypes.apdexType));
parcelHelpers.export(exports, "envType", ()=>(0, _analyticsWebTypes.envType));
parcelHelpers.export(exports, "eventType", ()=>(0, _analyticsWebTypes.eventType));
parcelHelpers.export(exports, "originType", ()=>(0, _analyticsWebTypes.originType));
parcelHelpers.export(exports, "platformType", ()=>(0, _analyticsWebTypes.platformType));
parcelHelpers.export(exports, "tenantType", ()=>(0, _analyticsWebTypes.tenantType));
parcelHelpers.export(exports, "userType", ()=>(0, _analyticsWebTypes.userType));
parcelHelpers.export(exports, "originTracingType", ()=>(0, _analyticsWebTypes.originTracingType));
parcelHelpers.export(exports, "TypeAheadHelper", ()=>// Helpers
    (0, _typeAheadHelperDefault.default));
parcelHelpers.export(exports, "DwellTimeHelper", ()=>(0, _dwellTimeHelperDefault.default));
parcelHelpers.export(exports, "DwellTimeHelperWithBrowserInteraction", ()=>(0, _dwellTimeHelperWithBrowserInteractionDefault.default));
parcelHelpers.export(exports, "CompressionRule", ()=>(0, _eventDelay.CompressionRule));
parcelHelpers.export(exports, "ResilienceMechanism", ()=>(0, _resilienceQueue.ResilienceMechanism));
parcelHelpers.export(exports, "StopLowPriorityEventDelayReason", ()=>(0, _eventDelay.StopLowPriorityEventDelayReason));
parcelHelpers.export(exports, "STARGATE_PROXY_PATH", ()=>(0, _selectHost.STARGATE_PROXY_PATH));
parcelHelpers.export(exports, "perimeterType", ()=>(0, _analyticsWebTypes.perimeterType));
parcelHelpers.export(exports, "aliasType", ()=>(0, _analyticsWebTypes.aliasType));
parcelHelpers.export(exports, "groupType", ()=>(0, _analyticsWebTypes.groupType));
parcelHelpers.export(exports, "productEmbedType", ()=>(0, _analyticsWebTypes.productEmbedType));
var _analyticsWebClient = require("./analyticsWebClient");
var _analyticsWebClientDefault = parcelHelpers.interopDefault(_analyticsWebClient);
var _analyticsWebTypes = require("./analyticsWebTypes");
var _dwellTimeHelper = require("./dwellTimeHelper");
var _dwellTimeHelperDefault = parcelHelpers.interopDefault(_dwellTimeHelper);
var _dwellTimeHelperWithBrowserInteraction = require("./DwellTimeHelperWithBrowserInteraction");
var _dwellTimeHelperWithBrowserInteractionDefault = parcelHelpers.interopDefault(_dwellTimeHelperWithBrowserInteraction);
var _eventDelay = require("./eventDelay");
var _resilienceQueue = require("./resilienceQueue");
var _selectHost = require("./selectHost");
var _typeAheadHelper = require("./typeAheadHelper");
var _typeAheadHelperDefault = parcelHelpers.interopDefault(_typeAheadHelper);

},{"./analyticsWebClient":"fP6oy","./analyticsWebTypes":"183Xd","./dwellTimeHelper":false,"./DwellTimeHelperWithBrowserInteraction":false,"./eventDelay":false,"./resilienceQueue":false,"./selectHost":false,"./typeAheadHelper":false,"@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"fP6oy":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "LoggingResponseCallback", ()=>LoggingResponseCallback);
// eslint-disable-next-line @atlaskit/volt-strict-mode/no-multiple-exports
parcelHelpers.export(exports, "default", ()=>AnalyticsWebClient);
var _objectSpread = require("@swc/helpers/_/_object_spread");
var _objectSpreadProps = require("@swc/helpers/_/_object_spread_props");
var _isFedrampModerate = require("@atlaskit/atlassian-context/is-fedramp-moderate");
var _isolationContextId = require("@atlaskit/atlassian-context/isolation-context-id");
var _analyticsWebTypes = require("./analyticsWebTypes");
var _apdexEvent = require("./apdexEvent");
var _apdexEventDefault = parcelHelpers.interopDefault(_apdexEvent);
var _createGetter = require("./createGetter");
var _createGetterDefault = parcelHelpers.interopDefault(_createGetter);
var _crossProductInteractionTracking = require("./crossProductInteractionTracking");
var _crossProductInteractionTrackingDefault = parcelHelpers.interopDefault(_crossProductInteractionTracking);
var _embedContext = require("./embedContext");
var _eventBuilder = require("./eventBuilder");
var _eventDelay = require("./eventDelay");
var _eventDelayDefault = parcelHelpers.interopDefault(_eventDelay);
var _eventValidation = require("./eventValidation");
var _integration = require("./integration");
var _integrationDefault = parcelHelpers.interopDefault(_integration);
var _metadataClient = require("./integration/metadataClient");
var _originTracing = require("./originTracing");
var _originTracingDefault = parcelHelpers.interopDefault(_originTracing);
var _pageVisibility = require("./pageVisibility");
var _pageVisibilityDefault = parcelHelpers.interopDefault(_pageVisibility);
var _selectHost = require("./selectHost");
var _sessionTracking = require("./sessionTracking");
var _sessionTrackingDefault = parcelHelpers.interopDefault(_sessionTracking);
var _safeSessionStorage = require("./storage/SafeSessionStorage");
var _safeSessionStorageDefault = parcelHelpers.interopDefault(_safeSessionStorage);
var _tabTracking = require("./tabTracking");
var _tabTrackingDefault = parcelHelpers.interopDefault(_tabTracking);
var _taskSessionStore = require("./taskSessionStore");
var _taskSessionStoreDefault = parcelHelpers.interopDefault(_taskSessionStore);
var _testingCache = require("./testingCache");
var _testingCacheDefault = parcelHelpers.interopDefault(_testingCache);
var _uiViewedEvent = require("./uiViewedEvent");
var _uiViewedEventDefault = parcelHelpers.interopDefault(_uiViewedEvent);
var _urlUtils = require("./urlUtils");
var _testSupport = require("./util/testSupport");
var _uuid = require("./uuid");
var _uuidDefault = parcelHelpers.interopDefault(_uuid);
var _wrapCallback = require("./wrapCallback");
var _wrapCallbackDefault = parcelHelpers.interopDefault(_wrapCallback);
var _xid = require("./xid");
const LAST_SCREEN_EVENT_STORAGE_KEY = 'last.screen.event';
class LoggingResponseCallback {
    static getCallback(logger) {
        logger = logger || console;
        return (response)=>{
            LoggingResponseCallback.callback(response, logger);
        };
    }
    static callback(response, logger) {
        const statusCode = response.getStatusCode();
        if (statusCode >= 200 && statusCode <= 299) response.getEventResponseList().forEach((eventResponse)=>{
            logger.warn('Validation report for event with message ID %s:\n', eventResponse.getMessageId(), eventResponse);
        });
        else if (statusCode === 400 || statusCode === 404) {
            logger.warn('GASv3 submission failed with HTTP Status Code %d: %s', response.getStatusCode(), response.getMessage());
            response.getEventResponseList().forEach((eventResponse)=>{
                logger.warn('Event with message ID %s:\n', eventResponse.getMessageId(), eventResponse);
            });
        } else {
            logger.log('GASv3 submission failed with HTTP Status Code %d: %s', response.getStatusCode(), response.getMessage());
            response.eventResponseList.forEach((eventResponse)=>{
                logger.debug('Event with message ID %s:\n', eventResponse.getMessageId(), eventResponse);
            });
        }
    }
}
class AnalyticsWebClient {
    metadataCallsEnabled(settings) {
        if (typeof settings.disableMetadataCalls === 'boolean') return !settings.disableMetadataCalls;
        return !(0, _testSupport.TestSupport).isGeminiVREnvironment() && !(0, _testSupport.TestSupport).areFetchCallsDisabled();
    }
    eventCallsEnabled(settings) {
        if (typeof settings.disableEventCalls === 'boolean') return !settings.disableEventCalls;
        return !(0, _testSupport.TestSupport).isGeminiVREnvironment() && !(0, _testSupport.TestSupport).areFetchCallsDisabled();
    }
    setEventValidationMode(eventValidationMode) {
        this._context.context.validationMode = eventValidationMode;
    }
    /**
	 * @private
	 * @deprecated
	 * Please avoid using internal properties. They are not part of the public
	 * API and may change without notice.
	 *
	 * This property has been exposed for backward compatibility with existing
	 * tests in external code
	 */ get task() {
        return this._task;
    }
    /**
	 * @private
	 * @deprecated
	 * Please avoid using internal properties.
	 * They are not part of the public API and may change without notice.
	 *
	 * This property has been exposed for backward compatibility with existing
	 * tests in external code
	 */ get _productInfo() {
        return this._internalProductInfo;
    }
    constructor(productInfo, settings = {}){
        this._useStargate = (useStargate)=>{
            if (useStargate == null) return true;
            return useStargate;
        };
        this._changeInternalUserId = (userId, anonymousId)=>{
            this._eventProcessor.getUser().setUserId(userId);
            if (anonymousId && anonymousId !== this._eventProcessor.getUser().getAnonymousId()) // Setting anonymous id can take a long time. Reading is a lot faster.
            // Only update if it has changed.
            this._eventProcessor.getUser().setAnonymousId(anonymousId);
        };
        this._createSubproductGetter = (subproduct)=>(0, _createGetterDefault.default)(subproduct, 'Cannot get subproduct from the callback. Proceeding without it.');
        this._createEmbeddedProductGetter = (embeddedProduct)=>(0, _createGetterDefault.default)(embeddedProduct, 'Cannot get embeddedProduct from the callback. Proceeding without it.');
        this._getLastScreenEvent = ()=>{
            try {
                return JSON.parse(this._safeSessionStorage.getItem(LAST_SCREEN_EVENT_STORAGE_KEY) || '');
            } catch (e) {
                this._safeSessionStorage.removeItem(LAST_SCREEN_EVENT_STORAGE_KEY);
                return null;
            }
        };
        this._setLastScreenEvent = (event)=>{
            this._safeSessionStorage.setItem(LAST_SCREEN_EVENT_STORAGE_KEY, JSON.stringify({
                name: event.name,
                attributes: event.attributes
            }));
        };
        this._shouldEventBeDelayed = (event)=>{
            // TODO: this is a temporary restriction for the purposes of the Track All Changes project
            // The delay mechanism has a chance of event loss, which we can only accept for our own data at this point.
            // Once the delay queue implementation has been improved and measured to confirm that it is reliable enough,
            // then we will be able to open it up for other products to use by removing this check.
            if (!event.tags || event.tags.indexOf('measurement') === -1) return false;
            const isEventHighPriority = event.highPriority !== false; // defaults to true if excluded
            return this._eventDelayQueue.isDelayingLowPriorityEvents() && !isEventHighPriority;
        };
        this._fireEvent = (identifier, builtEvent, context, callback)=>{
            switch(builtEvent.eventType){
                case (0, _analyticsWebTypes.eventType).UI:
                case (0, _analyticsWebTypes.eventType).OPERATIONAL:
                case (0, _analyticsWebTypes.eventType).TRACK:
                    return this._eventProcessor.track(identifier, builtEvent, context, callback);
                case (0, _analyticsWebTypes.eventType).SCREEN:
                    return this._eventProcessor.page(identifier, builtEvent, context, callback);
                case (0, _analyticsWebTypes.eventType).IDENTIFY:
                    return this._eventProcessor.identify(identifier, builtEvent, context, callback);
                default:
                    throw new Error(`No handler has been defined for events of type ${builtEvent.eventType}`);
            }
        };
        this._fireDelayedEvent = (identifier, builtEvent, context, userInfo)=>{
            try {
                // User information can change while the delay period is active, so we need to restore the values that
                // were active when the event was originally fired.
                this._changeInternalUserId(userInfo.userId, userInfo.anonymousId);
                builtEvent.tags = [
                    ...builtEvent.tags || [],
                    'sentWithDelay'
                ];
                // The callbacks for delayed events are fired immediately, so there is nothing to pass through for this argument.
                this._fireEvent(identifier, builtEvent, context, undefined);
            } finally{
                this._changeInternalUserId(this._userInfo.userId, this._userInfo.anonymousId);
            }
        };
        this._delayEvent = (identifier, builtEvent, context, userInfo, callback)=>{
            this._eventDelayQueue.push(identifier, builtEvent, context, userInfo);
            // Fire the callback immediately, as we can consider the event successfully processed at this point
            if (callback) callback();
        };
        this._processEvent = (identifier, builtEvent, context, callback)=>{
            this._testingCache.saveEvent(builtEvent);
            if (this._shouldEventBeDelayed(builtEvent)) {
                this._delayEvent(identifier, builtEvent, context, this._userInfo, callback);
                return Promise.resolve();
            } else return this._fireEvent(identifier, builtEvent, context, callback);
        };
        this.setEmbeddedProduct = (embeddedProduct)=>{
            this._internalProductInfo.embeddedProduct = this._createEmbeddedProductGetter(embeddedProduct);
            this.resetUIViewedTimers();
        };
        this.clearEmbeddedProduct = ()=>{
            this._internalProductInfo.embeddedProduct = this._createEmbeddedProductGetter(null);
        };
        this.setSubproduct = (subproduct)=>{
            this._internalProductInfo.subproduct = this._createSubproductGetter(subproduct);
            this.resetUIViewedTimers();
        };
        /**
   * Calling this function in the intialisation of the client in product
   * captures specified 'origin tracing' URL params and fires a single origin landed event
   * <p>
   * This function expects a mapping between the keys for any URL parameters
   *  that should be captured and removed for origin tracing
   * Multiple parameters may be captured simultaneously if multiple key: handler function pairs are provided
   * Each handler function should return an object with two items
   * a) 'originTracingAttributes' - an object that will be added to the 'origin landed' event's attributes under 'originTracing
   * b) 'taskSessionId' (optional) - an Id string that will be added to the tasksessions for any event that fires from the tab, with the key
   *    matching the URL parameter, for the purpose of attributing subsequent analytics event to the origin land.
   * </p>
   * The general use case for this feature is for allowing attributation of user behaviour to a out of product or cross product link,
   * e.g. from a share or email
   *
   * An example calling this function using an external decoding library, with taskSessionId specified to persist
   * analyticsWebClient.setOriginTracingHandlers({
        atlOrigin: encodedOrigin => {
            const { id, product } = OriginTracing.fromEncoded(encodedOrigin);
            return { originTracingAttributes: {'id': id, 'product': product}, taskSessionId: id };
        },
    });
   *
   * @param  {Object} originParamHandlerMapping a dictionary of mappings between origin url param keys and handler functions
   * @this {AnalyticsWebClient}
   */ this.setOriginTracingHandlers = (originParamHandlerMapping)=>{
            const capturedOriginTraces = this._originTracing.handleOriginParameters(originParamHandlerMapping, this._historyReplaceFn);
            const keys = Object.keys(capturedOriginTraces);
            keys.forEach((x)=>{
                if (typeof capturedOriginTraces[x].taskSessionId !== 'undefined') this._task.createTaskSessionWithProvidedId(x, capturedOriginTraces[x].taskSessionId);
            });
            const originAttributes = {};
            keys.forEach((x)=>{
                if (capturedOriginTraces[x].originTracingAttributes) originAttributes[x] = capturedOriginTraces[x].originTracingAttributes;
                else // eslint-disable-next-line no-console
                console.warn(`Handling method for origin parameter ${x} has not returned any attributes`);
            });
            if (keys.length > 0) return this.sendOperationalEvent({
                action: 'landed',
                actionSubject: 'origin',
                source: 'webClient',
                attributes: {
                    originTracesLanded: originAttributes
                }
            }, // eslint-disable-next-line @typescript-eslint/no-empty-function
            ()=>{});
            return Promise.resolve();
        };
        this.setTenantInfo = (tenantIdType, tenantId)=>{
            if (!tenantIdType) throw new Error('Missing tenantIdType');
            if (tenantIdType !== (0, _analyticsWebTypes.tenantType).NONE && !tenantId) throw new Error('Missing tenantId');
            if (!(0, _analyticsWebTypes.isType)((0, _analyticsWebTypes.tenantType), tenantIdType)) throw new Error(`Invalid tenantIdType '${tenantIdType}', ` + `must be an tenantType: [${(0, _analyticsWebTypes.objectValues)((0, _analyticsWebTypes.tenantType))}]`);
            this._tenantInfo = {
                tenantIdType,
                tenantId
            };
            this._eventProcessor.refreshMetadata(this._userInfo, this._tenantInfo);
        };
        this.clearTenantInfo = ()=>{
            this._tenantInfo = {};
            this._eventProcessor.refreshMetadata(this._userInfo, this._tenantInfo);
        };
        this.setOrgInfo = (orgId)=>{
            if (!orgId) throw new Error('Missing orgId');
            this._orgInfo = {
                orgId
            };
        };
        this.clearOrgInfo = ()=>{
            this._orgInfo = {};
        };
        this.setWorkspaceInfo = (workspaceId)=>{
            if (!workspaceId) throw new Error('Missing workspaceId');
            this._workspaceInfo = {
                workspaceId
            };
        };
        this.clearWorkspaceInfo = ()=>{
            this._workspaceInfo = {};
        };
        this.setCollaborationContextInfo = (collaborationContextAri)=>{
            if (!collaborationContextAri) throw new Error('Missing collaborationContextAri');
            this._collaborationContextInfo = {
                collaborationContextAri
            };
        };
        this.clearCollaborationContextInfo = ()=>{
            this._collaborationContextInfo = {};
        };
        this.setUserInfo = (userIdType, userId)=>{
            (0, _eventValidation.validateIdentifyEvent)(userIdType, userId);
            this._changeInternalUserId(userId);
            this._userInfo = {
                userIdType: userIdType,
                userId,
                anonymousId: this._eventProcessor.getUser().getAnonymousId()
            };
            this._eventProcessor.refreshMetadata(this._userInfo, this._tenantInfo);
        };
        this.clearUserInfo = ()=>{
            this._changeInternalUserId(undefined);
            this._userInfo = {
                anonymousId: this._eventProcessor.getUser().getAnonymousId()
            };
            this._eventProcessor.refreshMetadata(this._userInfo, this._tenantInfo);
        };
        this.setAlias = (aliasKeyType, alias)=>{
            if (!aliasKeyType) throw new Error('Missing aliasType');
            if (!(0, _analyticsWebTypes.isType)((0, _analyticsWebTypes.aliasType), aliasKeyType)) throw new Error(`Invalid aliasType '${aliasKeyType}', ` + `must be an aliasType: [${(0, _analyticsWebTypes.objectValues)((0, _analyticsWebTypes.aliasType))}]`);
            this._aliases[aliasKeyType] = alias;
        };
        this.clearAlias = ()=>{
            this._aliases = {};
        };
        this.setGroup = (groupsKeyType, group)=>{
            if (!groupsKeyType) throw new Error('Missing groupType');
            if (!(0, _analyticsWebTypes.isType)((0, _analyticsWebTypes.groupType), groupsKeyType)) throw new Error(`Invalid groupType '${groupsKeyType}', ` + `must be an groupType: [${(0, _analyticsWebTypes.objectValues)((0, _analyticsWebTypes.groupType))}]`);
            this._groups[groupsKeyType] = group;
        };
        this.clearGroup = ()=>{
            this._groups = {};
        };
        this.getAnonymousId = ()=>this._userInfo.anonymousId;
        this.getCurrentSessionId = ()=>this._sessionTracking.getCurrentSessionId();
        this.setUIViewedAttributes = (uiViewedAttributes)=>{
            if (!uiViewedAttributes) throw new Error('Missing uiViewedAttributes');
            if (typeof uiViewedAttributes !== 'object' || Array.isArray(uiViewedAttributes)) throw new Error('Invalid uiViewedAttributes type, should be a non array object');
            this._uiViewedAttributes = (0, _objectSpread._)({}, uiViewedAttributes);
        };
        this.getUIViewedAttributes = ()=>{
            return this._uiViewedAttributes;
        };
        this.clearUIViewedAttributes = ()=>{
            this._uiViewedAttributes = {};
        };
        this.appendUIViewedAttributes = (attributes)=>{
            if (!this._uiViewedAttributes) this._uiViewedAttributes = attributes;
            else this._uiViewedAttributes = (0, _objectSpread._)({}, this._uiViewedAttributes, attributes);
        };
        this.sendIdentifyEvent = (userIdType, userId, callback)=>{
            this.setUserInfo(userIdType, userId);
            const builtEvent = {
                userIdType,
                eventType: (0, _analyticsWebTypes.eventType).IDENTIFY
            };
            return this._processEvent(userId, builtEvent, this._context, callback);
        };
        /**
	 * @deprecated
	 * please use {@link sendScreenEvent instead)
	 */ this.sendPageEvent = (name, callback)=>{
            return this.sendScreenEvent(name, callback);
        };
        /**
	 * send screen event
	 * @param event The event / For retrocompatibility event name is still supported here.
	 * @param callback
	 * @param attributes. Deprecated, will get ignored if using an event object as first param.
	 */ this.sendScreenEvent = (event, callback, attributes)=>{
            let screenName;
            let screenAttributes;
            let screenContainers;
            let screenTags;
            if (typeof event === 'object') {
                /* This is for retrocompatibility */ screenName = event.name;
                screenAttributes = event.attributes;
                screenContainers = event.containers;
                screenTags = event.tags;
            } else {
                screenName = event;
                screenAttributes = attributes;
            }
            (0, _eventValidation.validateScreenEvent)(screenName);
            (0, _eventValidation.validateContainers)(screenContainers);
            const builtEvent = (0, _eventBuilder.buildScreenEvent)(this._internalProductInfo, this._tenantInfo, this._userInfo, screenAttributes, // TODO: Remove the as any and move into a place where we know event is an object
            event.nonPrivacySafeAttributes, screenTags, this._tabTracking.getCurrentTabId(), this._sessionTracking.getCurrentSessionId(), this._task.getAllTaskSessions(), this._crossProductInteractionTracking.getInteractionSession(), this._orgInfo, this._pageLoadId, this._workspaceInfo, this._collaborationContextInfo, event, screenContainers, this._aliases, this._groups);
            const builtEventWithName = (0, _objectSpread._)({
                name: screenName
            }, builtEvent);
            this._setLastScreenEvent(builtEventWithName);
            return this._processEvent(screenName, builtEventWithName, this._context, (0, _wrapCallbackDefault.default)(callback, builtEventWithName));
        };
        this.sendTrackEvent = (event, callback)=>{
            (0, _eventValidation.validateTrackEvent)(event);
            const builtEvent = (0, _eventBuilder.buildActionEvent)(this._internalProductInfo, this._tenantInfo, this._userInfo, event, (0, _analyticsWebTypes.eventType).TRACK, this._tabTracking.getCurrentTabId(), this._sessionTracking.getCurrentSessionId(), this._task.getAllTaskSessions(), this._crossProductInteractionTracking.getInteractionSession(), this._orgInfo, this._pageLoadId, this._workspaceInfo, this._collaborationContextInfo, this._aliases, this._groups);
            return this._processEvent((0, _eventBuilder.buildActionName)(event), builtEvent, this._context, (0, _wrapCallbackDefault.default)(callback, builtEvent));
        };
        this.sendUIEvent = (event, callback)=>{
            (0, _eventValidation.validateUIEvent)(event);
            const builtEvent = (0, _eventBuilder.buildActionEvent)(this._internalProductInfo, this._tenantInfo, this._userInfo, event, (0, _analyticsWebTypes.eventType).UI, this._tabTracking.getCurrentTabId(), this._sessionTracking.getCurrentSessionId(), this._task.getAllTaskSessions(), this._crossProductInteractionTracking.getInteractionSession(), this._orgInfo, this._pageLoadId, this._workspaceInfo, this._collaborationContextInfo, this._aliases, this._groups);
            return this._processEvent((0, _eventBuilder.buildActionName)(event), builtEvent, this._context, (0, _wrapCallbackDefault.default)(callback, builtEvent));
        };
        this.sendOperationalEvent = (event, callback)=>{
            (0, _eventValidation.validateOperationalEvent)(event);
            const builtEvent = (0, _eventBuilder.buildActionEvent)(this._internalProductInfo, this._tenantInfo, this._userInfo, event, (0, _analyticsWebTypes.eventType).OPERATIONAL, this._tabTracking.getCurrentTabId(), this._sessionTracking.getCurrentSessionId(), this._task.getAllTaskSessions(), this._crossProductInteractionTracking.getInteractionSession(), this._orgInfo, this._pageLoadId, this._workspaceInfo, this._collaborationContextInfo, this._aliases, this._groups);
            return this._processEvent((0, _eventBuilder.buildActionName)(event), builtEvent, this._context, (0, _wrapCallbackDefault.default)(callback, builtEvent));
        };
        this.startUIViewedEvent = (callback)=>{
            this.stopUIViewedEvent();
            this._uiViewedEvent = this.createUIViewedEvent(callback);
            this._uiViewedEvent.start();
        };
        this.stopUIViewedEvent = ()=>{
            if (this._uiViewedEvent) {
                this._uiViewedEvent.stop();
                this._uiViewedEvent = null;
            }
        };
        this.resetUIViewedTimers = ()=>{
            if (this._uiViewedEvent) this._uiViewedEvent.resetTimers();
        };
        this.signalUserActive = ()=>{
            let uiViewedEvent = this._uiViewedEvent || this.createUIViewedEvent(null);
            uiViewedEvent.signalUserActive();
        };
        this.createUIViewedEvent = (callback)=>{
            return new (0, _uiViewedEventDefault.default)(this._internalProductInfo, ()=>({
                    embeddedProduct: this._internalProductInfo.embeddedProduct(),
                    subproduct: this._internalProductInfo.subproduct(),
                    tenantIdType: this._tenantInfo.tenantIdType,
                    tenantId: this._tenantInfo.tenantId,
                    userId: this._userInfo.userId,
                    lastScreenEvent: this._getLastScreenEvent(),
                    attributes: this._uiViewedAttributes
                }), (event)=>this.sendUIEvent(event, callback));
        };
        this.startApdexEvent = (apdexEvent)=>{
            this._apdexEvent.start(apdexEvent);
        };
        this.getApdexStart = (apdexEvent)=>this._apdexEvent.getStart(apdexEvent);
        this.stopApdexEvent = (apdexEvent, callback)=>{
            this._apdexEvent.stop(apdexEvent, callback);
        };
        // TODO If we ever make another breaking change, merge these two optional args into an `options` object arg.
        this.startLowPriorityEventDelay = (timeout, callback)=>{
            this._eventDelayQueue.startLowPriorityEventDelay(timeout, callback);
        };
        this.stopLowPriorityEventDelay = ()=>{
            this._eventDelayQueue.stopLowPriorityEventDelay();
        };
        this.onEvent = (_analyticsId, analyticsData)=>{
            if (!analyticsData) throw new Error('Missing analyticsData');
            if (!analyticsData.eventType) throw new Error('Missing analyticsData.eventType');
            if (analyticsData.eventType === (0, _analyticsWebTypes.eventType).TRACK) return this.sendTrackEvent(analyticsData);
            else if (analyticsData.eventType === (0, _analyticsWebTypes.eventType).UI) return this.sendUIEvent(analyticsData);
            else if (analyticsData.eventType === (0, _analyticsWebTypes.eventType).OPERATIONAL) return this.sendOperationalEvent(analyticsData);
            else if (analyticsData.eventType === (0, _analyticsWebTypes.eventType).SCREEN) return this.sendScreenEvent(analyticsData.name, null, analyticsData.attributes);
            else if (analyticsData.eventType === (0, _analyticsWebTypes.eventType).IDENTIFY) return this.sendIdentifyEvent(analyticsData.userIdType, analyticsData.userId);
            throw new Error(`Invalid analyticsData.eventType '${analyticsData.eventType}', ` + `must be an eventType: [${(0, _analyticsWebTypes.objectValues)((0, _analyticsWebTypes.eventType))}]`);
        };
        this.setResponseCallback = (responseCallback)=>{
            this._eventProcessor.setResponseCallback(responseCallback);
        };
        if (!productInfo) throw new Error('Missing productInfo');
        if (!productInfo.env) throw new Error('Missing productInfo.env');
        if (!productInfo.product) throw new Error('Missing productInfo.product');
        if (!(0, _analyticsWebTypes.isType)((0, _analyticsWebTypes.envType), productInfo.env)) throw new Error(`Invalid productInfo.env '${productInfo.env}', ` + `must be an envType: [${(0, _analyticsWebTypes.objectValues)((0, _analyticsWebTypes.envType))}]`);
        if (!productInfo.origin) productInfo.origin = (0, _analyticsWebTypes.originType).WEB;
        else if (!(0, _analyticsWebTypes.isType)((0, _analyticsWebTypes.originType), productInfo.origin)) throw new Error(`Invalid productInfo.origin '${productInfo.origin}', ` + `must be an originType: [${(0, _analyticsWebTypes.objectValues)((0, _analyticsWebTypes.originType))}]`);
        if (!productInfo.platform) productInfo.platform = productInfo.origin === (0, _analyticsWebTypes.originType).WEB ? (0, _analyticsWebTypes.platformType).WEB : (0, _analyticsWebTypes.platformType).DESKTOP;
        else (0, _eventValidation.validatePlatform)(productInfo);
        this._logger = settings.logger || console;
        // Auto-detect Oasis perimeter (e.g. FedRAMP Moderate) when the consumer hasn't explicitly provided a perimeter.
        if (!productInfo.perimeter) try {
            if ((0, _isFedrampModerate.isFedrampModerate)()) productInfo.perimeter = (0, _analyticsWebTypes.perimeterType).FEDRAMP_MODERATE;
        } catch (e) {
            this._logger.warn('Failed to auto-detect perimeter: %s', e instanceof Error ? e.message : String(e));
        }
        // Default to commercial perimeter if not explicitly provided and not auto-detected.
        if (!productInfo.perimeter) productInfo.perimeter = (0, _analyticsWebTypes.perimeterType).COMMERCIAL;
        if (!(0, _analyticsWebTypes.isType)((0, _analyticsWebTypes.perimeterType), productInfo.perimeter)) throw new Error(`Invalid productInfo.perimeter '${productInfo.perimeter}', ` + `must be a perimeterType: [${(0, _analyticsWebTypes.objectValues)((0, _analyticsWebTypes.perimeterType))}]`);
        // Auto-detect Oasis Isolated Cloud (IC) environment when the consumer hasn't explicitly provided an `ic` value.
        if (!productInfo.ic) try {
            const icId = (0, _isolationContextId.isolationContextId)();
            if (icId && icId.length > 0) productInfo.ic = icId;
        } catch (e) {
            this._logger.warn('Failed to auto-detect isolation context: %s', e instanceof Error ? e.message : String(e));
        }
        this._internalProductInfo = (0, _objectSpreadProps._)((0, _objectSpread._)({}, productInfo), {
            subproduct: this._createSubproductGetter(productInfo.subproduct),
            embeddedProduct: this._createEmbeddedProductGetter(productInfo.embeddedProduct)
        });
        this._tenantInfo = {};
        this._orgInfo = {};
        this._uiViewedAttributes = {};
        if (productInfo === null || productInfo === void 0 ? void 0 : productInfo.embeddedContext) {
            this._embeddedContext = productInfo.embeddedContext;
            if ((0, _embedContext.isFirstParty)(this._embeddedContext)) this.setUIViewedAttributes({
                embeddedType: this._embeddedContext['embeddedType'],
                embeddedFromProduct: this._embeddedContext['embeddedFromProduct'],
                embeddedFromSubproduct: this._embeddedContext['embeddedFromSubproduct'],
                embeddedFromTopLevelDomain: this._embeddedContext['embeddedFromTopLevelDomain']
            });
            if ((0, _embedContext.isThirdParty)(this._embeddedContext)) this.setUIViewedAttributes({
                embeddedType: this._embeddedContext['embeddedType'],
                embeddedFromTopLevelDomain: this._embeddedContext['embeddedFromTopLevelDomain']
            });
        }
        this._context = (0, _eventBuilder.buildContext)(this._internalProductInfo);
        this._safeSessionStorage = new (0, _safeSessionStorageDefault.default)();
        const useStargate = this._useStargate(settings.useStargate);
        const apiHost = (0, _selectHost.selectHost)({
            useStargate,
            env: productInfo.env,
            useLegacyUrl: settings.useLegacyUrl,
            perimeter: productInfo.perimeter,
            ic: productInfo.ic,
            envOverride: productInfo.envOverride,
            apiHost: settings.apiHost
        });
        const apiHostProtocol = settings.apiHostProtocol || 'https';
        const minRetryDelay = settings.minRetryDelay || 1000;
        const maxAttempts = settings.maxRetryAttempts !== undefined && Number.isInteger(settings.maxRetryAttempts) && settings.maxRetryAttempts >= 0 ? settings.maxRetryAttempts + 1 : undefined;
        const retryQueueOptions = {
            maxRetryDelay: 60000,
            minRetryDelay,
            backoffFactor: 2,
            flushWaitMs: settings.flushWaitInterval,
            flushBeforeUnload: settings.flushBeforeUnload,
            maxAttempts: maxAttempts,
            maxQueueSize: settings.maxQueueSize
        };
        const retryQueuePrefix = `awc-${productInfo.env}`;
        const xidPromiseGetter = ()=>(0, _xid.XIDPromise)(settings.xidConsent, settings.xidPromiseFn);
        const disableCookiePersistence = settings.disableCookiePersistence || false;
        const metadataClientFactory = settings.metadataClientFactory || (0, _metadataClient.MetadataClient).Factory;
        const metadataClient = metadataClientFactory(apiHostProtocol, apiHost, productInfo.product);
        this._eventProcessor = new (0, _integrationDefault.default)({
            apiHost,
            apiHostProtocol,
            product: productInfo.product,
            retryQueuePrefix,
            retryQueueOptions,
            xidPromiseGetter,
            logger: this._logger,
            metadataClient: metadataClient,
            disableCookiePersistence,
            responseCallback: LoggingResponseCallback.getCallback(this._logger),
            env: productInfo.env,
            perimeter: productInfo.perimeter,
            enableMetadataCalls: this.metadataCallsEnabled(settings),
            enableEventCalls: this.eventCallsEnabled(settings)
        });
        this._userInfo = {
            anonymousId: this._eventProcessor.getUser().getAnonymousId(settings === null || settings === void 0 ? void 0 : settings.customAnonymousIdGenerator)
        };
        this._pageVisibility = new (0, _pageVisibilityDefault.default)();
        this._tabTracking = new (0, _tabTrackingDefault.default)();
        this._sessionTracking = new (0, _sessionTrackingDefault.default)({
            sessionExpiryTime: settings.sessionExpiryTime,
            onNewSessionStarted: settings.onNewSessionStarted
        });
        this._task = new (0, _taskSessionStoreDefault.default)();
        this._originTracing = new (0, _originTracingDefault.default)();
        this._eventProcessor.setOriginTracingClient(this._originTracing);
        // Init Apdex
        this._apdexEvent = new (0, _apdexEventDefault.default)(this.sendOperationalEvent, this._pageVisibility);
        this._historyReplaceFn = typeof settings.historyReplaceFn === 'function' ? settings.historyReplaceFn : (0, _urlUtils.defaultHistoryReplaceFn);
        this._eventDelayQueue = new (0, _eventDelayDefault.default)(this._fireDelayedEvent, settings.delayQueueCompressors || []);
        this._testingCache = new (0, _testingCacheDefault.default)(settings.isSynthetic, settings.enableTestingCache);
        this._pageLoadId = (0, _uuidDefault.default)();
        this._workspaceInfo = {};
        this._collaborationContextInfo = {};
        this._aliases = {};
        this._groups = {};
        this._crossProductInteractionTracking = new (0, _crossProductInteractionTrackingDefault.default)({
            perimeter: productInfo.perimeter,
            product: productInfo.product,
            sendEventCallback: this.sendOperationalEvent,
            historyReplaceFn: this._historyReplaceFn
        });
        this._crossProductInteractionTracking.validateInteractionSession();
    }
}

},{"@swc/helpers/_/_object_spread":"9gdrV","@swc/helpers/_/_object_spread_props":"kANqQ","@atlaskit/atlassian-context/is-fedramp-moderate":"e200g","@atlaskit/atlassian-context/isolation-context-id":"9r6Nx","./analyticsWebTypes":"183Xd","./apdexEvent":"7lB4m","./createGetter":"cswv5","./crossProductInteractionTracking":"brsj7","./embedContext":"jVtFN","./eventBuilder":"jZ9BF","./eventDelay":"03cT6","./eventValidation":"fTZkK","./integration":"7fGbV","./integration/metadataClient":"iJN14","./originTracing":"6fSdx","./pageVisibility":"5dcYq","./selectHost":"9e0Km","./sessionTracking":"edPjz","./storage/SafeSessionStorage":"aeZiF","./tabTracking":"g8l08","./taskSessionStore":"AqVua","./testingCache":"1xVFq","./uiViewedEvent":"eOUrX","./urlUtils":"gVcjs","./util/testSupport":"eJmcF","./uuid":"igO59","./wrapCallback":"9d5Wf","./xid":"13H4M","@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"e200g":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "isFedrampModerate", ()=>isFedrampModerate);
var _constants = require("../../common/constants");
var _atlCookiesLookup = require("../atl-cookies-lookup");
function isFedrampModerate() {
    var _globalThis_ssrContext;
    var _globalThis_ssrContext_isInFedramp;
    if (typeof document === 'undefined') // @ts-ignore
    return (_globalThis_ssrContext_isInFedramp = (_globalThis_ssrContext = globalThis.ssrContext) === null || _globalThis_ssrContext === void 0 ? void 0 : _globalThis_ssrContext.isInFedramp) !== null && _globalThis_ssrContext_isInFedramp !== void 0 ? _globalThis_ssrContext_isInFedramp : false;
    const atlCtxCookieValues = (0, _atlCookiesLookup.parseAtlCtxCookies)();
    if (!atlCtxCookieValues) // If the cookies are not set, the current perimeter is non-isolated commercial
    return false;
    return atlCtxCookieValues.perimeter === (0, _constants.FEDRAMP_MODERATE);
}

},{"../../common/constants":"caGXq","../atl-cookies-lookup":"5JOPy","@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"caGXq":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "FEDRAMP_MODERATE", ()=>FEDRAMP_MODERATE);
parcelHelpers.export(exports, "COMMERCIAL", ()=>COMMERCIAL);
parcelHelpers.export(exports, "ISOLATED_CLOUD", ()=>ISOLATED_CLOUD);
parcelHelpers.export(exports, "STAGING", ()=>STAGING);
parcelHelpers.export(exports, "PRODUCTION", ()=>PRODUCTION);
parcelHelpers.export(exports, "DEV", ()=>DEV);
parcelHelpers.export(exports, "ATL_CTX_PERIMETER", ()=>ATL_CTX_PERIMETER);
parcelHelpers.export(exports, "ATL_CTX_ISOLATION_CONTEXT_DOMAIN", ()=>ATL_CTX_ISOLATION_CONTEXT_DOMAIN);
parcelHelpers.export(exports, "ATL_CTX_ISOLATION_CONTEXT_ID", ()=>ATL_CTX_ISOLATION_CONTEXT_ID);
parcelHelpers.export(exports, "BIFROST_ATL_CTX_CLOUD_SERVICE_PROVIDER", ()=>BIFROST_ATL_CTX_CLOUD_SERVICE_PROVIDER);
parcelHelpers.export(exports, "CLOUD_SERVICE_PROVIDER_GCP", ()=>CLOUD_SERVICE_PROVIDER_GCP);
parcelHelpers.export(exports, "CLOUD_SERVICE_PROVIDER_AWS", ()=>CLOUD_SERVICE_PROVIDER_AWS);
const FEDRAMP_MODERATE = 'fedramp-moderate';
const COMMERCIAL = 'commercial';
const ISOLATED_CLOUD = 'isolated-cloud';
const STAGING = 'staging';
const PRODUCTION = 'prod';
const DEV = 'dev';
const ATL_CTX_PERIMETER = 'Atl-Ctx-Perimeter';
const ATL_CTX_ISOLATION_CONTEXT_DOMAIN = 'Atl-Ctx-Isolation-Context-Domain';
const ATL_CTX_ISOLATION_CONTEXT_ID = 'Atl-Ctx-Isolation-Context-Id';
const BIFROST_ATL_CTX_CLOUD_SERVICE_PROVIDER = 'Bifrost-Atl-Ctx-Cloud-Service-Provider';
const CLOUD_SERVICE_PROVIDER_GCP = 'GCP';
const CLOUD_SERVICE_PROVIDER_AWS = 'AWS';

},{"@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"5JOPy":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
/**
 * Internal helper function used to return the atl-ctx cookies for browser (which contains perimeter and ic_domain information).
 * Cookies are NOT set for regular commercial traffic.
 * @returns {AtlCtxCookieValues | undefined} - The parsed cookie contents or undefined if parsing fails (ex. if the cookies do not exist)
 */ parcelHelpers.export(exports, "parseAtlCtxCookies", ()=>parseAtlCtxCookies);
var _constants = require("../../common/constants");
var _cookies = require("../../common/utils/cookies");
function parseAtlCtxCookies() {
    const global = globalThis;
    try {
        // HOT-118791: the code below doesn't work on the server, and creates log spam in the catch block - "Cannot read properties of undefined (reading 'cookie')"
        if (typeof globalThis.document === 'undefined') return undefined;
        const cookies = global.document.cookie;
        const perimeter = (0, _cookies.getRawCookieValue)((0, _constants.ATL_CTX_PERIMETER), cookies);
        if (!perimeter) // Indicative of non-isolated commercial perimeter
        return undefined;
        const icDomain = (0, _cookies.getRawCookieValue)((0, _constants.ATL_CTX_ISOLATION_CONTEXT_DOMAIN), cookies);
        const icId = (0, _cookies.getRawCookieValue)((0, _constants.ATL_CTX_ISOLATION_CONTEXT_ID), cookies);
        // The IC Domain and IC Id cookie values are empty strings for non Isolated Cloud
        const emptyIcDomain = !icDomain || icDomain.length === 0;
        const emptyIcId = !icId || icId.length === 0;
        return {
            perimeter: perimeter,
            icDomain: emptyIcDomain ? undefined : icDomain,
            icId: emptyIcId ? undefined : icId
        };
    } catch (e) {
        console.warn('Failed to parse atl-ctx cookies:', e);
        return undefined;
    }
}

},{"../../common/constants":"caGXq","../../common/utils/cookies":"bamQY","@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"bamQY":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
/**
 * Internal helper function used to parse a cookie value by name from a cookie string.
 * @param {string} cookieName - The name of the cookie to extract
 * @param {string} cookieString - The full cookie string (e.g. document.cookie)
 * @returns {string | undefined} - The cookie value if present, undefined otherwise
 */ parcelHelpers.export(exports, "getRawCookieValue", ()=>getRawCookieValue);
function getRawCookieValue(cookieName, cookieString) {
    if (!cookieString) return undefined;
    const cookies = cookieString.split(';');
    for (const cookie of cookies){
        const [name, value] = cookie.trim().split('=');
        if (name === cookieName) return value;
    }
    return undefined;
}

},{"@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"9r6Nx":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "isolationContextId", ()=>isolationContextId);
var _atlCookiesLookup = require("../atl-cookies-lookup");
var _isIsolatedCloud = require("./isIsolatedCloud");
function isolationContextId() {
    var _globalThis_ssrContext;
    if (typeof document === 'undefined') // @ts-ignore
    return (0, _isIsolatedCloud.isIsolatedCloud)() ? (_globalThis_ssrContext = globalThis.ssrContext) === null || _globalThis_ssrContext === void 0 ? void 0 : _globalThis_ssrContext.icName : undefined;
    const atlCtxCookieValues = (0, _atlCookiesLookup.parseAtlCtxCookies)();
    return atlCtxCookieValues === null || atlCtxCookieValues === void 0 ? void 0 : atlCtxCookieValues.icId;
}

},{"../atl-cookies-lookup":"5JOPy","./isIsolatedCloud":"8yBUb","@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"8yBUb":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "isIsolatedCloud", ()=>isIsolatedCloud);
var _isolatedCloudPerimeters = require("../../common/constants/isolated-cloud-perimeters");
var _atlCookiesLookup = require("../atl-cookies-lookup");
function isIsolatedCloud() {
    var _globalThis_ssrContext;
    var _globalThis_ssrContext_isInIC;
    if (typeof document === 'undefined') // @ts-ignore
    return (_globalThis_ssrContext_isInIC = (_globalThis_ssrContext = globalThis.ssrContext) === null || _globalThis_ssrContext === void 0 ? void 0 : _globalThis_ssrContext.isInIC) !== null && _globalThis_ssrContext_isInIC !== void 0 ? _globalThis_ssrContext_isInIC : false;
    const atlCtxCookieValues = (0, _atlCookiesLookup.parseAtlCtxCookies)();
    if (!atlCtxCookieValues) // If the cookies are not set, the current perimeter is non-isolated commercial
    return false;
    // The icDomain check is needed for when federal perimeters are eventually added to Isolated Cloud as well
    return (0, _isolatedCloudPerimeters.ISOLATED_CLOUD_PERIMETERS).includes(atlCtxCookieValues.perimeter) && atlCtxCookieValues.icDomain !== undefined;
}

},{"../../common/constants/isolated-cloud-perimeters":"9PE09","../atl-cookies-lookup":"5JOPy","@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"9PE09":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "ISOLATED_CLOUD_PERIMETERS", ()=>ISOLATED_CLOUD_PERIMETERS);
var _index = require("./index");
const ISOLATED_CLOUD_PERIMETERS = [
    (0, _index.COMMERCIAL)
];

},{"./index":"caGXq","@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"183Xd":[function(require,module,exports,__globalThis) {
/* eslint-disable @atlaskit/volt-strict-mode/no-multiple-exports */ // These types have been converted from frozen objects to enums.
// We cannot change their name, or even capitalise them without breaking API.
var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "envType", ()=>envType);
parcelHelpers.export(exports, "eventType", ()=>eventType);
parcelHelpers.export(exports, "platformType", ()=>platformType);
parcelHelpers.export(exports, "originType", ()=>originType);
parcelHelpers.export(exports, "tenantType", ()=>tenantType);
parcelHelpers.export(exports, "productEmbedType", ()=>productEmbedType);
parcelHelpers.export(exports, "userType", ()=>userType);
parcelHelpers.export(exports, "apdexType", ()=>apdexType);
parcelHelpers.export(exports, "desktopPlatforms", ()=>desktopPlatforms);
parcelHelpers.export(exports, "webPlatforms", ()=>webPlatforms);
parcelHelpers.export(exports, "originTracingType", ()=>originTracingType);
parcelHelpers.export(exports, "objectValues", ()=>objectValues);
parcelHelpers.export(exports, "isType", ()=>isType);
parcelHelpers.export(exports, "perimeterType", ()=>perimeterType);
parcelHelpers.export(exports, "aliasType", ()=>aliasType);
parcelHelpers.export(exports, "groupType", ()=>groupType);
parcelHelpers.export(exports, "envOverrides", ()=>envOverrides);
var envType = /*#__PURE__*/ function(envType) {
    envType["LOCAL"] = "local";
    envType["DEV"] = "dev";
    envType["STAGING"] = "staging";
    envType["PROD"] = "prod";
    return envType;
}({});
var eventType = /*#__PURE__*/ function(eventType) {
    eventType["TRACK"] = "track";
    eventType["UI"] = "ui";
    eventType["OPERATIONAL"] = "operational";
    eventType["SCREEN"] = "screen";
    eventType["IDENTIFY"] = "identify";
    return eventType;
}({});
var platformType = /*#__PURE__*/ function(platformType) {
    platformType["MAC"] = "mac";
    platformType["LINUX"] = "linux";
    platformType["WINDOWS"] = "windows";
    /**
	 *  @deprecated desktop is here for retrocompatibility, please select one of the above OS instead.
	 */ platformType["DESKTOP"] = "desktop";
    platformType["WEB"] = "web";
    platformType["MOBILE_WEB"] = "mobileWeb";
    return platformType;
}({});
var originType = /*#__PURE__*/ function(originType) {
    originType["DESKTOP"] = "desktop";
    originType["WEB"] = "web";
    return originType;
}({});
var tenantType = /*#__PURE__*/ function(tenantType) {
    tenantType["CLOUD_ID"] = "cloudId";
    tenantType["ORG_ID"] = "orgId";
    tenantType["OPSGENIE_CUSTOMER_ID"] = "opsgenieCustomerId";
    tenantType["HALP_TEAM_ID"] = "halpTeamId";
    tenantType["LOOM_ORG_ID"] = "loomOrgId";
    tenantType["TRANSACTION_ACCOUNT_ID"] = "transactionAccountId";
    tenantType["TRELLO_WORKSPACE_ID"] = "trelloWorkspaceId";
    tenantType["JA_WORKSPACE_ID"] = "jiraAlignWorkspaceId";
    tenantType["STUDIO_WORKSPACE_ID"] = "studioWorkspaceId";
    tenantType["NONE"] = "none";
    return tenantType;
}({});
var productEmbedType = /*#__PURE__*/ function(productEmbedType) {
    productEmbedType["FIRST_PARTY"] = "FIRST_PARTY";
    productEmbedType["THIRD_PARTY"] = "THIRD_PARTY";
    return productEmbedType;
}({});
var userType = /*#__PURE__*/ function(userType) {
    userType["ATLASSIAN_ACCOUNT"] = "atlassianAccount";
    userType["HASHED_EMAIL"] = "hashedEmail";
    userType["LOOM"] = "loom";
    userType["TRELLO"] = "trello";
    userType["OPSGENIE"] = "opsgenie";
    userType["JA_USER_ID"] = "jiraAlign";
    userType["HALP"] = "halp";
    return userType;
}({});
var apdexType = /*#__PURE__*/ function(apdexType) {
    apdexType["TRANSITION"] = "transition";
    apdexType["INITIAL_LOAD"] = "initialLoad";
    return apdexType;
}({});
const desktopPlatforms = Object.freeze([
    "desktop",
    "mac",
    "linux",
    "windows"
]);
const webPlatforms = Object.freeze([
    "web",
    "mobileWeb"
]);
var originTracingType = /*#__PURE__*/ function(originTracingType) {
    originTracingType["ATL_ORIGIN"] = "atlOrigin";
    return originTracingType;
}({});
function objectValues(object) {
    return Object.values(object);
}
function isType(type, value) {
    return Object.values(type).indexOf(value) > -1;
}
var perimeterType = /*#__PURE__*/ function(perimeterType) {
    perimeterType["C5"] = "c5";
    perimeterType["COMMERCIAL"] = "commercial";
    perimeterType["FEDRAMP_MODERATE"] = "fedramp-moderate";
    perimeterType["FEDRAMP_HIGH"] = "fedramp-high";
    return perimeterType;
}({});
var aliasType = /*#__PURE__*/ function(aliasType) {
    return aliasType;
}({});
var groupType = /*#__PURE__*/ function(groupType) {
    groupType["TRANSACTION_ACCOUNT_ID"] = "transactionAccountId";
    return groupType;
}({});
var envOverrides = /*#__PURE__*/ function(envOverrides) {
    return envOverrides;
}({});

},{"@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"7lB4m":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>ApdexEvent);
var _objectSpread = require("@swc/helpers/_/_object_spread");
var _objectSpreadProps = require("@swc/helpers/_/_object_spread_props");
var _analyticsWebTypes = require("./analyticsWebTypes");
var _pageVisibility = require("./pageVisibility");
var _pageVisibilityDefault = parcelHelpers.interopDefault(_pageVisibility);
var _performance = require("./performance");
var _performanceDefault = parcelHelpers.interopDefault(_performance);
class ApdexEvent {
    start(event) {
        this._validateStartEvent(event);
        if (!this._performance.isAvailable()) return;
        const eventKey = this._getEventKey(event);
        const eventStartName = `${eventKey}-start`;
        this._startedEvents.set(eventKey, true);
        this._isActiveEvents.set(eventKey, !this._pageVisibility.getIsHidden());
        this._performance.clearMarks(eventStartName);
        this._performance.mark(eventStartName);
    }
    getStart(event) {
        this._validateStartEvent(event);
        if (!this._performance.isAvailable()) return undefined;
        const eventKey = this._getEventKey(event);
        const eventStartName = `${eventKey}-start`;
        return this._getEventTimingByName(eventStartName);
    }
    stop(event, callback) {
        this._validateStopEvent(event);
        if (!this._performance.isAvailable()) return;
        const apdexFields = this._getApdexFields(event);
        const visibilityFields = this._getVisibilityFields(event);
        this._sendEvent((0, _objectSpread._)({}, event, apdexFields, visibilityFields), callback);
    }
    onVisibilityChange(isActive) {
        if (!isActive) {
            this._wasPreviouslyHidden = true;
            Array.from(this._isActiveEvents.keys()).forEach((key)=>this._isActiveEvents.set(key, false));
        }
    }
    constructor(onEvent, pageVisibility){
        this._getEventKey = ({ task, taskId })=>taskId ? `${task}.${taskId}` : task;
        this._getEventTimingByName = (name)=>{
            const eventTimings = this._performance.getEntriesByName(name);
            const eventTiming = eventTimings[eventTimings.length - 1];
            return eventTiming;
        };
        this._getApdexFields = (event)=>{
            const apdexTimings = this._getApdexTimings(event);
            const apdexScore = this._calculateApdex({
                duration: apdexTimings.duration,
                threshold: event.threshold
            });
            return (0, _objectSpreadProps._)((0, _objectSpread._)({}, apdexTimings), {
                apdex: apdexScore
            });
        };
        this._getApdexTimings = (event)=>{
            const eventKey = this._getEventKey(event);
            const eventStartName = `${eventKey}-start`;
            const startTime = event.startTime || this._getStartTime(event, eventStartName);
            const stopTime = event.stopTime || this._getStopTime();
            // We do some clean up of the marks and started events
            this._cleanApdexState(eventKey);
            return {
                startTime,
                stopTime,
                duration: stopTime - startTime
            };
        };
        this._getStartTime = (event, eventName)=>{
            let startTime;
            const timeOrigin = this._performance.getTimeOrigin();
            if (event.type === (0, _analyticsWebTypes.apdexType).INITIAL_LOAD) startTime = timeOrigin;
            else {
                const eventTiming = this._getEventTimingByName(eventName);
                startTime = timeOrigin + eventTiming.startTime;
            }
            return startTime;
        };
        this._getStopTime = ()=>this._performance.getTimeOrigin() + this._performance.now();
        this._cleanApdexState = (eventKey)=>{
            this._performance.clearMarks(`${eventKey}-start`);
            this._performance.clearMarks(`${eventKey}-stop`);
            this._startedEvents.delete(eventKey);
        };
        this._getVisibilityFields = (event)=>{
            let isActiveTab;
            /**
		 * For initialLoad type:
		 * 1. if tab was not ever hidden (!_wasPreviouslyHidden)
		 *
		 * For transition type:
		 * 1. active status is tracked in active events map (_isActiveEvents)
		 *
		 * For any type, if startTime or stopTime is specified:
		 * 1. If currently active (!_isHidden)
		 */ if (event.type === (0, _analyticsWebTypes.apdexType).INITIAL_LOAD) isActiveTab = !this._wasPreviouslyHidden;
            else if (event.type === (0, _analyticsWebTypes.apdexType).TRANSITION) {
                const eventKey = this._getEventKey(event);
                isActiveTab = this._isActiveEvents.get(eventKey);
            }
            if (event.startTime || event.stopTime) isActiveTab = !this._pageVisibility.getIsHidden();
            return {
                isActiveTab
            };
        };
        this._calculateApdex = ({ duration, threshold = this._threshold })=>{
            let apdex;
            const satisfiedThreshold = threshold;
            const tolerableThreshold = threshold * 4;
            if (duration <= satisfiedThreshold) apdex = 1;
            else if (duration <= tolerableThreshold) apdex = 0.5;
            else apdex = 0;
            return apdex;
        };
        this._validateStartEvent = (event)=>{
            if (!event) throw new Error('Missing "event" in Apdex start event');
            if (!event.task) throw new Error('Missing "task" in Apdex start event');
            if (typeof event.task !== 'string') throw new Error('Invalid "task" in Apdex start event');
            if (event.taskId && typeof event.taskId !== 'string') throw new Error('Invalid "taskId" in Apdex start event');
        };
        this._validateStopEvent = (event)=>{
            if (!event) throw new Error('Missing "event" in Apdex stop event');
            if (!event.task) throw new Error('Missing "task" in Apdex stop event');
            if (typeof event.task !== 'string') throw new Error('Invalid "task" in Apdex stop event');
            if (event.taskId && typeof event.taskId !== 'string') throw new Error('Invalid "taskId" in Apdex stop event');
            if (!event.type) throw new Error('Missing "type" in Apdex stop event');
            if (event.type && !(0, _analyticsWebTypes.isType)((0, _analyticsWebTypes.apdexType), event.type)) throw new Error('Invalid "type" in Apdex stop event');
            if (event.threshold && typeof event.threshold !== 'number') throw new Error('Invalid "threshold" in Apdex stop event');
            /*
		 * For a transition, if the startTime was not specified,
		 * the start event should have been present.
		 */ if (!event.startTime && event.type === (0, _analyticsWebTypes.apdexType).TRANSITION) {
                const eventKey = this._getEventKey(event);
                if (!this._startedEvents.has(eventKey)) throw new Error(`Apdex event transition "${eventKey}" was not started`);
            }
            if (event.startTime && !(typeof event.startTime === 'number' && event.startTime >= 0)) throw new Error('Invalid "startTime" in Apdex stop event');
            if (event.stopTime && typeof event.stopTime !== 'number') throw new Error('Invalid "stopTime" in Apdex stop event');
            if (event.stopTime <= event.startTime) throw new Error('"stopTime" should be greater than "startTime" in Apdex stop event');
        };
        this._shouldSendEvent = (event)=>{
            if (!event) return false;
            if (typeof event.apdex !== 'number') return false;
            return true;
        };
        this._sendEvent = (event, callback)=>{
            if (this._shouldSendEvent(event)) this._onEvent({
                source: 'ui',
                action: 'readyForUser',
                actionSubject: 'ui',
                attributes: (0, _objectSpreadProps._)((0, _objectSpread._)({}, event.additionalAttributes), {
                    task: event.task,
                    taskId: event.taskId,
                    type: event.type,
                    threshold: event.threshold || this._threshold,
                    apdex: event.apdex,
                    startTime: event.startTime,
                    stopTime: event.stopTime,
                    duration: event.duration,
                    isActiveTab: event.isActiveTab
                })
            }, callback);
        };
        if (!onEvent) throw new Error('Missing onEvent callback');
        if (typeof onEvent !== 'function') throw new Error('Invalid onEvent, must be function');
        if (!(pageVisibility instanceof (0, _pageVisibilityDefault.default))) throw new Error('Invalid pageVisibility, must be PageVisibility class');
        this._startedEvents = new Map();
        this._performance = new (0, _performanceDefault.default)();
        this._onEvent = onEvent;
        this._threshold = 1000;
        this._wasPreviouslyHidden = pageVisibility.getIsHidden();
        this._isActiveEvents = new Map();
        this._pageVisibility = pageVisibility;
        this._pageVisibility.addCallback('apdexEvent', (isHidden)=>{
            this.onVisibilityChange(!isHidden);
        });
    }
}

},{"@swc/helpers/_/_object_spread":"9gdrV","@swc/helpers/_/_object_spread_props":"kANqQ","./analyticsWebTypes":"183Xd","./pageVisibility":"5dcYq","./performance":"3wG43","@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"5dcYq":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>PageVisibility);
class PageVisibility {
    addCallback(name, fn) {
        if (typeof name !== 'string') throw new Error('Invalid name, must be string');
        if (typeof fn !== 'function') throw new Error('Invalid callback, must be function');
        this._callbacks.set(name, fn);
    }
    removeCallback(name) {
        if (this._callbacks.has(name)) this._callbacks.delete(name);
    }
    getIsHidden() {
        return this._isHidden;
    }
    constructor(){
        this._bindEventListeners = ()=>{
            document.addEventListener(this._visibilityChange, this._handleVisibilityChange, false);
        };
        this._handleVisibilityChange = ()=>{
            const isHidden = document[this._hidden];
            this._isHidden = isHidden;
            this._callbacks.forEach((callbackFn)=>callbackFn(isHidden));
        };
        this._isHidden = false;
        this._callbacks = new Map();
        this._hidden = undefined;
        this._visibilityChange = undefined;
        if (typeof document !== 'undefined') {
            if (typeof document.hidden !== 'undefined') {
                // Opera 12.10 and Firefox 18 and later support
                this._isHidden = document.hidden;
                this._hidden = 'hidden';
                this._visibilityChange = 'visibilitychange';
            } else if (typeof document.msHidden !== 'undefined') {
                this._isHidden = document.msHidden;
                this._hidden = 'msHidden';
                this._visibilityChange = 'msvisibilitychange';
            } else if (typeof document.webkitHidden !== 'undefined') {
                this._isHidden = document.webkitHidden;
                this._hidden = 'webkitHidden';
                this._visibilityChange = 'webkitvisibilitychange';
            }
            if (typeof document.addEventListener !== 'undefined' && this._hidden !== undefined) this._bindEventListeners();
        }
    }
}

},{"@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"3wG43":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>Performance);
class Performance {
    clearMarks(...args) {
        if (!this._performance || !this._performance.clearMarks) return;
        this._performance.clearMarks(...args);
    }
    mark(...args) {
        if (!this._performance || !this._performance.mark) return;
        this._performance.mark(...args);
    }
    getEntriesByName(...args) {
        if (!this._performance || !this._performance.getEntriesByName) return [];
        return this._performance.getEntriesByName(...args);
    }
    getTimeOrigin() {
        if (!this._performance || !this._performance.timeOrigin && !this._performance.timing) return 0;
        return this._performance.timeOrigin || this._performance.timing.navigationStart;
    }
    now() {
        if (!this._performance || !this._performance.now) return Date.now ? Date.now() : +new Date();
        return this._performance.now();
    }
    isAvailable() {
        return !!this._performance && !!this._performance.clearMarks && !!this._performance.mark && !!this._performance.getEntriesByName && !!this._performance.timing;
    }
    constructor(){
        this._performance = window.performance;
    }
}

},{"@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"cswv5":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
/**
 * Wraps {possibleFn} into a error-safe function and handles cases where {possibleFn}
 * is a function or object
 *
 * @param possibleFn - function that returns and object or the object itself
 * @param errorMessage - error message to log if {possibleFn} is a function and
 *                        throws an error when called
 * @returns {Function}
 */ const isFunction = (possibleFn)=>typeof possibleFn === 'function';
exports.default = (possibleFn, errorMessage)=>{
    return ()=>{
        if (isFunction(possibleFn)) try {
            return possibleFn();
        } catch (e) {
            // eslint-disable-next-line no-console
            console.error(`${errorMessage} - ${e instanceof Error ? e.message : String(e)}`);
            return undefined;
        }
        return possibleFn;
    };
};

},{"@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"brsj7":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
/**
 * This class initialises the Analytics Cross Product Interaction Client, which keeps track of the
 * interactionSessionId we use to track cross-product user journeys.
 *
 * It parses URL query parameters for any previous interaction session attributes.
 * If none exist, the Analytics Cross Product Interaction Client will generate a new
 * interactionSessionId, and the class will expose a method for retrieving this from Session Storage
 *
 * @param sendEventCallback: Expects a callback function that can send an analytics event
 */ parcelHelpers.export(exports, "default", ()=>CrossProductInteractionTracking);
var _analyticsCrossProductInteractionClient = require("@atlassiansox/analytics-cross-product-interaction-client");
var _analyticsCrossProductInteractionClientDefault = parcelHelpers.interopDefault(_analyticsCrossProductInteractionClient);
var _analyticsWebTypes = require("./analyticsWebTypes");
var _urlUtils = require("./urlUtils");
var _urlUtilsDefault = parcelHelpers.interopDefault(_urlUtils);
const isCrossProductInteractionAttribute = (_, paramName)=>{
    return paramName === (0, _analyticsCrossProductInteractionClient.URL_QUERY_PARAM_INTERACTION_SESSION);
};
class CrossProductInteractionTracking {
    getInteractionSession() {
        if (this.isEnabled && this.analyticsCrossProductInteractionClient) return {
            bridge: this.analyticsCrossProductInteractionClient.getBridge(),
            id: this.analyticsCrossProductInteractionClient.getCurrentInteractionSessionId(),
            prevId: this.analyticsCrossProductInteractionClient.getPreviousInteractionSessionId(),
            source: this.analyticsCrossProductInteractionClient.getInteractionSource()
        };
        else return {
            bridge: null,
            id: null,
            prevId: null,
            source: null
        };
    }
    /**
	 * Validates the cross product interaction session parameters parsed from the URL (if present)
	 * If the Base64-encoded URL does not decode into a valid JSON object
	 *
	 * This method must be called out of the constructor, as the sendEventCallback we expect here
	 * depends on crossProductInteractionTracking.getInteractionSession() so the class must be initialised
	 */ validateInteractionSession() {
        if (!this.urlValidation.result) this.sendEventCallback({
            action: 'corrupted',
            actionSubject: 'interactionSession',
            attributes: {
                url: this.urlValidation.url
            },
            source: 'interactionComponent',
            tags: [
                'navigationExperiences'
            ]
        });
    }
    constructor(options){
        this.validProduct = false;
        this.isEnabled = options.perimeter !== (0, _analyticsWebTypes.perimeterType).FEDRAMP_MODERATE;
        this.urlValidation = {
            result: true,
            url: ''
        };
        this.sendEventCallback = options.sendEventCallback;
        if (this.isEnabled) {
            let bridge;
            let interactionSessionId;
            let interactionSource;
            let interactionSessionOptions;
            this.urlValidation.url = window.location.href;
            // Validate product
            //
            // Various UI components in the page might initialize their own AWC instances but some of those
            // instances might be associated with subordinate products that are of no interest to XPC tracking. We
            // want to avoid XPC meta analytics being fired against uninteresting products.
            //
            // Some products (e.g. Confluence) also have custom URL replace functions passed into AWC settings,
            // and we need to use those to ensure our query parameter is correctly processed.
            //
            // TODO - this is currently the best way we can try and guarantee that the most relevant product's AWC
            // is passing in the options. Down the line we ideally want the relevant products themselves to opt-in
            // to initialising cross product tracking via a flag in their AWC init options.
            this.validProduct = (0, _analyticsCrossProductInteractionClient.validProducts).includes(options.product);
            if (this.validProduct) {
                // Only parse URL parameters if we are in a valid product
                const crossProductUrlPramater = (0, _urlUtilsDefault.default)(isCrossProductInteractionAttribute, options.historyReplaceFn);
                const interactionSessionBlob = (0, _analyticsCrossProductInteractionClient.URL_QUERY_PARAM_INTERACTION_SESSION) in crossProductUrlPramater ? crossProductUrlPramater[0, _analyticsCrossProductInteractionClient.URL_QUERY_PARAM_INTERACTION_SESSION] : null;
                if (interactionSessionBlob) try {
                    const interactionSession = JSON.parse(atob(interactionSessionBlob));
                    if (interactionSession.bridge && interactionSession.id && interactionSession.source) {
                        // All 3 fields must be present from a valid query param
                        bridge = interactionSession.bridge;
                        interactionSessionId = interactionSession.id;
                        interactionSource = interactionSession.source;
                    } else this.urlValidation.result = false;
                } catch (e) {
                    // Gracefully fail through if parameter has been corrupted
                    this.urlValidation.result = false;
                }
                interactionSessionOptions = {
                    analyticsEventCallback: this.sendEventCallback,
                    persistedSessionId: interactionSessionId
                };
            }
            // Initialise interaction session client with parsed values if they exist
            this.analyticsCrossProductInteractionClient = new (0, _analyticsCrossProductInteractionClientDefault.default)(interactionSessionOptions, bridge, interactionSource);
        }
    }
}

},{"@atlassiansox/analytics-cross-product-interaction-client":"eU9hh","./analyticsWebTypes":"183Xd","./urlUtils":"gVcjs","@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"eU9hh":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>(0, _analyticsCrossProductInteractionClientDefault.default));
parcelHelpers.export(exports, "useCrossProductUrlWrapper", ()=>(0, _useCrossProductUrlWrapperDefault.default));
parcelHelpers.export(exports, "URL_QUERY_PARAM_INTERACTION_SESSION", ()=>(0, _generateUrlWithParams.URL_QUERY_PARAM_INTERACTION_SESSION));
parcelHelpers.export(exports, "validProducts", ()=>(0, _productList.validProducts));
var _analyticsCrossProductInteractionClient = require("./analyticsCrossProductInteractionClient");
var _analyticsCrossProductInteractionClientDefault = parcelHelpers.interopDefault(_analyticsCrossProductInteractionClient);
var _productList = require("./config/productList");
var _generateUrlWithParams = require("./generateUrlWithParams");
var _useCrossProductUrlWrapper = require("./useCrossProductUrlWrapper");
var _useCrossProductUrlWrapperDefault = parcelHelpers.interopDefault(_useCrossProductUrlWrapper);

},{"./analyticsCrossProductInteractionClient":"3sRlf","./config/productList":"6JtCG","./generateUrlWithParams":"uWT8A","./useCrossProductUrlWrapper":"END8o","@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"3sRlf":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "INTERACTION_SESSION_SOURCE_KEY", ()=>INTERACTION_SESSION_SOURCE_KEY);
parcelHelpers.export(exports, "INTERACTION_SESSION_BRIDGE_KEY", ()=>INTERACTION_SESSION_BRIDGE_KEY);
/**
 * AnalyticsCrossProductInteractionClient is a wrapper for the InteractionSessionTracking class.
 * It is designed to be used internally within the Atlassian Analytics Pipeline as well as useCrossProductUrlWrapper hook.
 * It is not intended to be used directly by end-users.
 *
 * This will create an instance of the interaction session tracker on the window object, which can be shared across different parts of a document.
 * If the internal client already exists, it will use the existing instance. Creating the client in a singleton manner like this enables us
 * to debounce updates to Session Storage, which is important when a large number of links using our hook are rendered on a page.
 *
 * The other interaction session parameters are written directly to session storage as they are predominantly read-only,
 * with the only update being the initialisation of the client
 */ parcelHelpers.export(exports, "default", ()=>AnalyticsCrossProductInteractionClient);
var _frontendFeatureEncoding = require("@atlassiansox/frontend-feature-encoding");
var _isFedrampModerate = require("@atlaskit/atlassian-context/is-fedramp-moderate");
var _platformFeatureFlags = require("@atlaskit/platform-feature-flags");
var _globalInteractionSessionTracking = require("./globalInteractionSessionTracking");
var _globalInteractionSessionTrackingDefault = parcelHelpers.interopDefault(_globalInteractionSessionTracking);
var _safeSessionStorage = require("./storage/SafeSessionStorage");
var _safeSessionStorageDefault = parcelHelpers.interopDefault(_safeSessionStorage);
const INTERACTION_SESSION_SOURCE_KEY = 'interactionSession.source';
const INTERACTION_SESSION_BRIDGE_KEY = 'interactionSession.bridge';
class AnalyticsCrossProductInteractionClient {
    constructor(interactionSessionOptions, bridge, interactionSource){
        this.getCurrentInteractionSessionId = ()=>this.isEnabled && this.interactionSessionTracking ? this.interactionSessionTracking.getCurrentInteractionSessionId() : null;
        this.getPreviousInteractionSessionId = ()=>this.isEnabled && this.interactionSessionTracking ? this.interactionSessionTracking.getPreviousInteractionSessionId() : null;
        this.getBridge = ()=>this.isEnabled && this.safeSessionStorage ? this.safeSessionStorage.getItem(INTERACTION_SESSION_BRIDGE_KEY) : null;
        this.getInteractionSource = ()=>this.isEnabled && this.safeSessionStorage ? this.safeSessionStorage.getItem(INTERACTION_SESSION_SOURCE_KEY) : null;
        const shouldDisable = (0, _platformFeatureFlags.fg)('use_frontend_feature_encoding_sdk_platform') ? !(0, _frontendFeatureEncoding.isFeatureEnabled)('atlassian-analytics', 'atlassian-analytics-cross-product-interaction-client') : (0, _isFedrampModerate.isFedrampModerate)();
        this.isEnabled = !shouldDisable;
        if (this.isEnabled) {
            // Get singleton interaction session tracking instance
            this.interactionSessionTracking = (0, _globalInteractionSessionTrackingDefault.default).getInstance();
            let isValidPersistedId = false;
            if (this.interactionSessionTracking) {
                if (interactionSessionOptions) {
                    this.interactionSessionTracking.setAnalyticsCallback(interactionSessionOptions.analyticsEventCallback);
                    isValidPersistedId = this.interactionSessionTracking.setInteractionSessionId(interactionSessionOptions.persistedSessionId);
                }
            }
            this.safeSessionStorage = new (0, _safeSessionStorageDefault.default)();
            // Store other interaction session parameters directly in session storage if ID has been validated
            if (isValidPersistedId) {
                bridge && this.safeSessionStorage.setItem(INTERACTION_SESSION_BRIDGE_KEY, bridge);
                interactionSource && this.safeSessionStorage.setItem(INTERACTION_SESSION_SOURCE_KEY, interactionSource);
            }
        }
    }
}

},{"@atlassiansox/frontend-feature-encoding":"diVt0","@atlaskit/atlassian-context/is-fedramp-moderate":"e200g","@atlaskit/platform-feature-flags":"8rD2i","./globalInteractionSessionTracking":"99YqN","./storage/SafeSessionStorage":"9kOxS","@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"diVt0":[function(require,module,exports,__globalThis) {
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.isFeatureEnabled = exports.isEnvironmentBlockEnabled = void 0;
var FeatureEncoding_1 = require("ad32032723832785");
Object.defineProperty(exports, "isEnvironmentBlockEnabled", {
    enumerable: true,
    get: function() {
        return FeatureEncoding_1.isEnvironmentBlockEnabled;
    }
});
Object.defineProperty(exports, "isFeatureEnabled", {
    enumerable: true,
    get: function() {
        return FeatureEncoding_1.isFeatureEnabled;
    }
});

},{"ad32032723832785":"9YIH5"}],"9YIH5":[function(require,module,exports,__globalThis) {
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.clearAuditState = exports.configureAuditState = exports.shouldEnableForAudit = exports.isFeatureEnabled = exports.isEnvironmentBlockEnabled = void 0;
const atlassian_context_1 = require("32f7ff7b62b9a35c");
const feature_encoding_core_1 = require("4968bddbafafeb34");
const FeatureOverrides_1 = require("b61437912681e209");
const EnvironmentType_1 = require("5ff3dac7e054795f");
const AEM_AUDIT_LOCAL_STORAGE_PREFIX = "aem-audit";
function isEnvironmentBlockEnabled(environmentBlockName) {
    const boundaryKey = getBoundaryKey();
    return (0, feature_encoding_core_1.isEnvironmentBlockEnabledForBoundary)(environmentBlockName, boundaryKey);
}
exports.isEnvironmentBlockEnabled = isEnvironmentBlockEnabled;
function isFeatureEnabled(environmentBlockName, featureName, offeringPredicates) {
    const override = (0, FeatureOverrides_1.getFeatureOverride)(environmentBlockName, featureName);
    if (override !== null) return override;
    const boundaryKey = getBoundaryKey();
    const aemResult = (0, feature_encoding_core_1.isFeatureEnabledForBoundary)(environmentBlockName, featureName, boundaryKey);
    if (!aemResult) {
        if ((0, EnvironmentType_1.isSSR)()) return false; // SSR: fallback to standard AEM resolution
        const metadata = (0, feature_encoding_core_1.getFeatureAvailabilityMetadataForBoundary)(environmentBlockName, featureName, boundaryKey);
        if (metadata && metadata.auditPhase) return shouldEnableForAudit(metadata.auditPhase, environmentBlockName, featureName);
        return false; // fallback to default behavior when not in audit state
    }
    const predicate = offeringPredicates ? offeringPredicates[boundaryKey] : undefined;
    return predicate ? predicate() : true;
}
exports.isFeatureEnabled = isFeatureEnabled;
/**
 * Determines whether a feature that is not enabled via standard AEM resolution
 * should be enabled due to an active audit phase.
 *
 * This function should only be called for excluded features in browser contexts that have an active
 * audit phase. It applies the following rules:
 *
 * | Phase            | Environment | localStorage key set? | Result  |
 * | ---------------- | ----------- | --------------------- | ------- |
 * | internal-audit   | non-prod    | any                   | true    |
 * | internal-audit   | prod        | any                   | false   |
 * | external-audit   | non-prod    | any                   | true    |
 * | external-audit   | prod        | yes ("true")          | true    |
 * | external-audit   | prod        | no                    | false   |
 *
 * In SSR contexts (no window/localStorage), this falls back to false
 * for any case that would require a localStorage check.
 */ function shouldEnableForAudit(auditPhase, environmentBlockName, featureName) {
    const envType = (0, EnvironmentType_1.getEnvironmentType)();
    if (envType === "non-prod") return true;
    if (auditPhase === feature_encoding_core_1.UnderAuditPhase.EXTERNAL_AUDIT && !(0, EnvironmentType_1.isSSR)() && localStorage.getItem(`${AEM_AUDIT_LOCAL_STORAGE_PREFIX}::${environmentBlockName}::${featureName}`) === "true") return true;
    return false;
}
exports.shouldEnableForAudit = shouldEnableForAudit;
function getBoundaryKey() {
    if ((0, atlassian_context_1.isFedrampModerate)()) return feature_encoding_core_1.FED_MOD_KEY;
    if ((0, atlassian_context_1.isIsolatedCloud)()) return feature_encoding_core_1.ISOLATED_CLOUD_COMMERCIAL_KEY;
    return feature_encoding_core_1.COMMERCIAL_KEY;
}
function configureAuditState(environmentBlockName, featureName, value) {
    localStorage.setItem(`${AEM_AUDIT_LOCAL_STORAGE_PREFIX}::${environmentBlockName}::${featureName}`, value);
}
exports.configureAuditState = configureAuditState;
function clearAuditState(environmentBlockName, featureName) {
    localStorage.removeItem(`${AEM_AUDIT_LOCAL_STORAGE_PREFIX}::${environmentBlockName}::${featureName}`);
}
exports.clearAuditState = clearAuditState;
// Register global API on window for browser dev tools usage
if (typeof window !== "undefined") window.__AEM_FEATURE_JS__ = {
    checkFeature: isFeatureEnabled,
    overrideFeature: FeatureOverrides_1.overrideFeature,
    clearFeatureOverride: FeatureOverrides_1.clearFeatureOverride,
    clearAllOverrides: FeatureOverrides_1.clearAllOverrides,
    configureAuditState,
    clearAuditState
};

},{"32f7ff7b62b9a35c":"7z9wj","4968bddbafafeb34":"kQyGS","b61437912681e209":"3gD30","5ff3dac7e054795f":"9o6tz"}],"7z9wj":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "isFedRamp", ()=>(0, _isFedramp.isFedRamp));
parcelHelpers.export(exports, "getATLContextDomain", ()=>(0, _getATLContextDomain.getATLContextDomain));
parcelHelpers.export(exports, "getATLContextUrl", ()=>(0, _getATLContextUrl.getATLContextUrl));
parcelHelpers.export(exports, "isFedrampModerate", ()=>(0, _isFedrampModerate.isFedrampModerate));
parcelHelpers.export(exports, "isIsolatedCloud", ()=>(0, _isIsolatedCloud.isIsolatedCloud));
parcelHelpers.export(exports, "isolatedCloudDomain", ()=>(0, _isolatedCloudDomain.isolatedCloudDomain));
parcelHelpers.export(exports, "isolationContextId", ()=>(0, _isolationContextId.isolationContextId));
parcelHelpers.export(exports, "getDomainInContext", ()=>(0, _getDomainInContext.getDomainInContext));
parcelHelpers.export(exports, "getUrlForDomainInContext", ()=>(0, _getUrlForDomainInContext.getUrlForDomainInContext));
var _isFedramp = require("./services/host-based-lookup/is-fedramp");
var _getATLContextDomain = require("./services/host-based-lookup/domain-lookup/getATLContextDomain");
var _getATLContextUrl = require("./services/host-based-lookup/domain-lookup/getATLContextUrl");
var _isFedrampModerate = require("./services/perimeter/isFedrampModerate");
var _isIsolatedCloud = require("./services/perimeter/isIsolatedCloud");
var _isolatedCloudDomain = require("./services/perimeter/isolatedCloudDomain");
var _isolationContextId = require("./services/perimeter/isolationContextId");
var _getDomainInContext = require("./services/generalized-domain-lookup/getDomainInContext");
var _getUrlForDomainInContext = require("./services/generalized-domain-lookup/getUrlForDomainInContext");

},{"./services/host-based-lookup/is-fedramp":"hsRFS","./services/host-based-lookup/domain-lookup/getATLContextDomain":"8MVi3","./services/host-based-lookup/domain-lookup/getATLContextUrl":"2GJI2","./services/perimeter/isFedrampModerate":"e200g","./services/perimeter/isIsolatedCloud":"8yBUb","./services/perimeter/isolatedCloudDomain":"cEg4g","./services/perimeter/isolationContextId":"9r6Nx","./services/generalized-domain-lookup/getDomainInContext":"fGWCb","./services/generalized-domain-lookup/getUrlForDomainInContext":"jImXA","@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"8MVi3":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "getATLContextDomain", ()=>getATLContextDomain);
var _constants = require("../../../common/constants/host-based-lookup/constants");
var _domainMap = require("../../../common/constants/host-based-lookup/constants/domainMap");
var _fullDomainOverride = require("../../../common/constants/host-based-lookup/constants/fullDomainOverride");
var _subdomainOverride = require("../../../common/constants/host-based-lookup/constants/subdomainOverride");
var _types = require("../../../common/constants/host-based-lookup/types");
var _getEnvironmentFromDomain = require("./_getEnvironmentFromDomain");
function isValidDomainKey(domainKey) {
    if (!(0, _types.AllowedDomains).includes(domainKey)) return false;
    return true;
}
function getATLContextDomain(domain, environment) {
    var // Exact match preferred
    _override_perimeter, _domainMap_perimeter;
    // Validate this is a valid domain
    if (!isValidDomainKey(domain)) throw new Error(`Domain ${domain} is not supported.
      Supported domains: ${(0, _types.AllowedDomains).join(', ')}`);
    // First priority, always return the global context if the product has onboarded
    // @ts-ignore - This is causing ts errors when this package is being enrolled into jira local consumption so temporarily ts ignoring this line for now
    const data = globalThis.ATL_CONTEXT_DOMAIN;
    if (data) return data[domain];
    const [env, perimeter] = environment !== null && environment !== void 0 ? environment : (0, _getEnvironmentFromDomain._getEnvironmentFromDomain)();
    // Second priority, return if there is a full domain override
    const override = (0, _fullDomainOverride.fullDomainOverride)[domain];
    var _override_perimeter_env;
    if (override) return (_override_perimeter_env = (_override_perimeter = override[perimeter]) === null || _override_perimeter === void 0 ? void 0 : _override_perimeter[env]) !== null && _override_perimeter_env !== void 0 ? _override_perimeter_env : override[0, _constants.COMMERCIAL][0, _constants.PRODUCTION] // Fallback to mandatory commercial production
    ;
    var _domainMap_perimeter_env;
    // Third priority, join the subdomain
    const tld = (_domainMap_perimeter_env = (_domainMap_perimeter = (0, _domainMap.domainMap)[perimeter]) === null || _domainMap_perimeter === void 0 ? void 0 : _domainMap_perimeter[env]) !== null && _domainMap_perimeter_env !== void 0 ? _domainMap_perimeter_env : (0, _domainMap.domainMap)[0, _constants.COMMERCIAL][0, _constants.PRODUCTION];
    var _subdomainOverride_domain;
    const subdomain = (_subdomainOverride_domain = (0, _subdomainOverride.subdomainOverride)[domain]) !== null && _subdomainOverride_domain !== void 0 ? _subdomainOverride_domain : domain;
    return `${subdomain}.${tld}`;
}

},{"../../../common/constants/host-based-lookup/constants":"h8Kjf","../../../common/constants/host-based-lookup/constants/domainMap":"952nw","../../../common/constants/host-based-lookup/constants/fullDomainOverride":"gsAKp","../../../common/constants/host-based-lookup/constants/subdomainOverride":"4PgaE","../../../common/constants/host-based-lookup/types":"hPfjZ","./_getEnvironmentFromDomain":"8JvI2","@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"952nw":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "domainMap", ()=>domainMap);
var _index = require("./index");
const domainMap = {
    [(0, _index.COMMERCIAL)]: {
        [(0, _index.STAGING)]: 'stg.atlassian.com',
        [(0, _index.PRODUCTION)]: 'atlassian.com'
    },
    [(0, _index.FEDRAMP_FEDEX)]: {
        [(0, _index.STAGING)]: 'atlassian-fex.com'
    },
    [(0, _index.FEDRAMP_MODERATE)]: {
        [(0, _index.STAGING)]: 'stg.atlassian-us-gov-mod.com',
        [(0, _index.PRODUCTION)]: 'atlassian-us-gov-mod.com'
    }
};

},{"./index":"h8Kjf","@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"gsAKp":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "fullDomainOverride", ()=>fullDomainOverride);
var _index = require("./index");
const fullDomainOverride = {
    analytics: {
        [(0, _index.COMMERCIAL)]: {
            [(0, _index.PRODUCTION)]: 'analytics.atlassian.com'
        }
    },
    // Marketing site
    confluence: {
        [(0, _index.COMMERCIAL)]: {
            [(0, _index.PRODUCTION)]: 'confluence.atlassian.com'
        }
    },
    // Atlassian design system documentation
    design: {
        [(0, _index.COMMERCIAL)]: {
            [(0, _index.PRODUCTION)]: 'design.atlassian.com'
        }
    },
    // Old staff intranet (now hello.atlassian.net)
    extranet: {
        [(0, _index.COMMERCIAL)]: {
            [(0, _index.PRODUCTION)]: 'extranet.atlassian.com'
        }
    },
    // Go links
    go: {
        [(0, _index.COMMERCIAL)]: {
            [(0, _index.PRODUCTION)]: 'go.atlassian.com'
        }
    },
    my: {
        [(0, _index.COMMERCIAL)]: {
            [(0, _index.PRODUCTION)]: 'my.atlassian.com'
        }
    },
    schema: {
        [(0, _index.COMMERCIAL)]: {
            [(0, _index.PRODUCTION)]: 'schema.atlassian.com'
        }
    },
    start: {
        [(0, _index.COMMERCIAL)]: {
            [(0, _index.PRODUCTION)]: 'start.atlassian.com',
            [(0, _index.STAGING)]: 'start.stg.atlassian.com'
        },
        [(0, _index.FEDRAMP_MODERATE)]: {
            [(0, _index.PRODUCTION)]: 'start.atlassian-us-gov-mod.com',
            [(0, _index.STAGING)]: 'start.stg.atlassian-us-gov-mod.com'
        }
    },
    surveys: {
        [(0, _index.COMMERCIAL)]: {
            [(0, _index.PRODUCTION)]: 'surveys.atlassian.com'
        }
    },
    'wac-cdn': {
        [(0, _index.COMMERCIAL)]: {
            [(0, _index.PRODUCTION)]: 'wac-cdn.atlassian.com'
        }
    },
    integrations: {
        [(0, _index.COMMERCIAL)]: {
            [(0, _index.PRODUCTION)]: 'integrations.atlassian.com'
        }
    },
    permalink: {
        [(0, _index.COMMERCIAL)]: {
            [(0, _index.PRODUCTION)]: 'permalink.atlassian.com'
        }
    },
    id: {
        [(0, _index.COMMERCIAL)]: {
            [(0, _index.PRODUCTION)]: 'id.atlassian.com',
            [(0, _index.STAGING)]: 'id.stg.internal.atlassian.com',
            [(0, _index.DEV)]: 'id.dev.internal.atlassian.com'
        },
        [(0, _index.FEDRAMP_MODERATE)]: {
            [(0, _index.PRODUCTION)]: 'id.atlassian-us-gov-mod.com',
            [(0, _index.STAGING)]: 'id.stg.atlassian-us-gov-mod.com'
        }
    },
    support: {
        [(0, _index.COMMERCIAL)]: {
            [(0, _index.PRODUCTION)]: 'support.atlassian.com'
        }
    }
};

},{"./index":"h8Kjf","@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"4PgaE":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "subdomainOverride", ()=>subdomainOverride);
const subdomainOverride = {};

},{"@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"hPfjZ":[function(require,module,exports,__globalThis) {
/* *NOTE*: please ensure any changes made to Perimeter and DomainKey type is copied in typings/atl-context.globals.d.ts */ var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "AllowedDomains", ()=>AllowedDomains);
const AllowedDomains = [
    'admin',
    'analytics',
    'api',
    'api.media',
    'api-private',
    'as',
    'atl-global',
    'atlaskit',
    'auth',
    'automation',
    'cassi.internal',
    'cc-import-sources.services',
    'confluence',
    'confluence-chats-integr.services',
    'confluence-cloud-bamboo.internal',
    'confluence-questions.services',
    'data-portal.internal',
    'design',
    'developer',
    'extranet',
    'go',
    'id',
    'id-mail-assets',
    'integrations',
    'ja',
    'jira',
    'jsd-widget',
    'jsd-widget-staging',
    'marketplace',
    'my',
    'my-reminders.services',
    'partners',
    'permalink',
    'permalink.stg',
    'schema',
    'start',
    'support',
    'surveys',
    'team',
    'wac-cdn',
    'xxid',
    'home'
];

},{"@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"8JvI2":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "_getEnvironmentFromDomain", ()=>_getEnvironmentFromDomain);
var _constants = require("../../../common/constants/host-based-lookup/constants");
function _getEnvironmentFromDomain() {
    var _globalThis_location;
    const hostname = (_globalThis_location = globalThis.location) === null || _globalThis_location === void 0 ? void 0 : _globalThis_location.hostname;
    if (!hostname) // default if no location available
    return [
        (0, _constants.PRODUCTION),
        (0, _constants.COMMERCIAL)
    ];
    // *.atlassian-fex.com
    if (hostname.match(/atlassian-fex\.com/)) return [
        (0, _constants.STAGING),
        (0, _constants.FEDRAMP_FEDEX)
    ];
    // *.stg.atlassian-us-gov-mod.com OR *.stg.atlassian-us-gov-mod.net
    if (hostname.match(/stg\.atlassian-us-gov-mod\.(com|net)/)) return [
        (0, _constants.STAGING),
        (0, _constants.FEDRAMP_MODERATE)
    ];
    // *.atlassian-stg-fedm.net
    if (hostname.match(/atlassian-stg-fedm\.net/)) return [
        (0, _constants.STAGING),
        (0, _constants.FEDRAMP_MODERATE)
    ];
    // *.atlassian-us-gov-mod.com OR *.atlassian-us-gov-mod.net
    if (hostname.match(/atlassian-us-gov-mod\.(com|net)/)) return [
        (0, _constants.PRODUCTION),
        (0, _constants.FEDRAMP_MODERATE)
    ];
    // *.stg.atlassian.com OR *.stg.internal.atlassian.com
    if (hostname.match(/stg(\.internal)?\.atlassian\.com/)) return [
        (0, _constants.STAGING),
        (0, _constants.COMMERCIAL)
    ];
    // *.jira-dev.com
    if (hostname.match(/jira-dev\.com/)) return [
        (0, _constants.STAGING),
        (0, _constants.COMMERCIAL)
    ];
    // default fallthrough
    return [
        (0, _constants.PRODUCTION),
        (0, _constants.COMMERCIAL)
    ];
}

},{"../../../common/constants/host-based-lookup/constants":"h8Kjf","@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"2GJI2":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "getATLContextUrl", ()=>getATLContextUrl);
var _getATLContextDomain = require("./getATLContextDomain");
function getATLContextUrl(domain) {
    var _globalThis_location;
    var _globalThis_location_protocol;
    return `${(_globalThis_location_protocol = (_globalThis_location = globalThis.location) === null || _globalThis_location === void 0 ? void 0 : _globalThis_location.protocol) !== null && _globalThis_location_protocol !== void 0 ? _globalThis_location_protocol : 'https:'}//${(0, _getATLContextDomain.getATLContextDomain)(domain)}`;
}

},{"./getATLContextDomain":"8MVi3","@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"cEg4g":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "isolatedCloudDomain", ()=>isolatedCloudDomain);
var _atlCookiesLookup = require("../atl-cookies-lookup");
function isolatedCloudDomain() {
    var _globalThis_location;
    if (typeof document === 'undefined') return (_globalThis_location = globalThis.location) === null || _globalThis_location === void 0 ? void 0 : _globalThis_location.hostname;
    const atlCtxCookieValues = (0, _atlCookiesLookup.parseAtlCtxCookies)();
    return atlCtxCookieValues === null || atlCtxCookieValues === void 0 ? void 0 : atlCtxCookieValues.icDomain;
}

},{"../atl-cookies-lookup":"5JOPy","@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"fGWCb":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "getDomainInContext", ()=>getDomainInContext);
var _constants = require("../../common/constants");
var _fullDomainOverride = require("../../common/constants/fullDomainOverride");
var _globalDomains = require("../../common/constants/globalDomains");
var _cloudEnvironment = require("../perimeter/cloudEnvironment");
var _isolatedCloudDomain = require("../perimeter/isolatedCloudDomain");
var _constants1 = require("./constants");
function getDomainForIsolatedCloud(subdomain, perimeter, isolatedCloudDomain) {
    const domainMappings = (0, _constants1.isolatedCloudFunctions)[perimeter];
    if ((0, _constants1.ReservedNameMapping)[perimeter].includes(subdomain)) return domainMappings.isolatedCloudReservedNameDomain(subdomain, isolatedCloudDomain);
    if ((0, _constants1.AtlDomainMapping)[perimeter].includes(subdomain)) return domainMappings.isolatedCloudAtlDomain(subdomain, isolatedCloudDomain);
    return domainMappings.isolatedCloudVanityDomain(subdomain, isolatedCloudDomain);
}
function getDomainForNonIsolatedCloud(subdomain, perimeter, envType) {
    var _fullDomainOverride_subdomain_perimeter, _fullDomainOverride_subdomain;
    // First, check if the subdomain is associated with a global domain
    if ((0, _globalDomains.globalDomains)[subdomain]) return (0, _globalDomains.globalDomains)[subdomain];
    // Second, check if the subdomain is associated with a full domain override (ex. a domain that uses a different pattern in other perimeters/environments)
    const override = (_fullDomainOverride_subdomain = (0, _fullDomainOverride.fullDomainOverride)[subdomain]) === null || _fullDomainOverride_subdomain === void 0 ? void 0 : (_fullDomainOverride_subdomain_perimeter = _fullDomainOverride_subdomain[perimeter]) === null || _fullDomainOverride_subdomain_perimeter === void 0 ? void 0 : _fullDomainOverride_subdomain_perimeter[envType];
    if (override) return override;
    // Use default domain ending for the given perimeter
    const domainMappings = (0, _constants1.nonIsolatedCloudFunctions)[perimeter];
    return domainMappings.defaultDomainEnding(subdomain, envType);
}
function getDomainInContext(subdomain, envType) {
    const currentCloudEnvironment = (0, _cloudEnvironment.cloudEnvironment)();
    if (currentCloudEnvironment === undefined) return undefined;
    if (currentCloudEnvironment.type === 'isolated-cloud') {
        const domain = (0, _isolatedCloudDomain.isolatedCloudDomain)();
        if (domain === undefined) return undefined;
        return getDomainForIsolatedCloud(subdomain, (0, _constants.COMMERCIAL), domain);
    }
    return getDomainForNonIsolatedCloud(subdomain, currentCloudEnvironment.perimeter, envType);
}

},{"../../common/constants":"caGXq","../../common/constants/fullDomainOverride":"7Ywif","../../common/constants/globalDomains":"6cVJO","../perimeter/cloudEnvironment":"6Zet1","../perimeter/isolatedCloudDomain":"cEg4g","./constants":"6ayz9","@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"7Ywif":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "fullDomainOverride", ()=>fullDomainOverride);
var _index = require("./index");
const fullDomainOverride = {
    id: {
        [(0, _index.COMMERCIAL)]: {
            [(0, _index.PRODUCTION)]: 'id.atlassian.com',
            [(0, _index.STAGING)]: 'id.stg.internal.atlassian.com',
            [(0, _index.DEV)]: 'id.dev.internal.atlassian.com'
        },
        [(0, _index.FEDRAMP_MODERATE)]: {
            [(0, _index.PRODUCTION)]: 'id.atlassian-us-gov-mod.com',
            [(0, _index.STAGING)]: 'id.stg.atlassian-us-gov-mod.com'
        }
    }
};

},{"./index":"caGXq","@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"6cVJO":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "globalDomains", ()=>globalDomains);
const globalDomains = {
    confluence: 'confluence.atlassian.com',
    design: 'design.atlassian.com',
    extranet: 'extranet.atlassian.com',
    go: 'go.atlassian.com',
    my: 'my.atlassian.com',
    surveys: 'surveys.atlassian.com',
    'wac-cdn': 'wac-cdn.atlassian.com',
    integrations: 'integrations.atlassian.com',
    permalink: 'permalink.atlassian.com',
    support: 'support.atlassian.com'
};

},{"@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"6Zet1":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "cloudEnvironment", ()=>cloudEnvironment);
var _constants = require("../../common/constants");
var _isolatedCloudPerimeters = require("../../common/constants/isolated-cloud-perimeters");
var _atlCookiesLookup = require("../atl-cookies-lookup");
function cloudEnvironmentSsrLookup() {
    var _globalThis_ssrContext, _globalThis_ssrContext1;
    // @ts-ignore
    if (((_globalThis_ssrContext = globalThis.ssrContext) === null || _globalThis_ssrContext === void 0 ? void 0 : _globalThis_ssrContext.isInIC) === true) return {
        type: 'isolated-cloud',
        perimeter: (0, _constants.COMMERCIAL)
    };
    // @ts-ignore
    if (((_globalThis_ssrContext1 = globalThis.ssrContext) === null || _globalThis_ssrContext1 === void 0 ? void 0 : _globalThis_ssrContext1.isInFedramp) === true) return {
        type: 'non-isolated-cloud',
        perimeter: (0, _constants.FEDRAMP_MODERATE)
    };
    return {
        type: 'non-isolated-cloud',
        perimeter: (0, _constants.COMMERCIAL)
    };
}
function cloudEnvironmentCookieLookup() {
    // Avoid calling isFedrampModerate() and isIsolatedCloud() here to avoid repeated cookie parsing
    const atlCtxCookieValues = (0, _atlCookiesLookup.parseAtlCtxCookies)();
    if (!atlCtxCookieValues) // If the cookies are not set, the current perimeter is non-isolated commercial
    return {
        type: 'non-isolated-cloud',
        perimeter: (0, _constants.COMMERCIAL)
    };
    const isIc = (0, _isolatedCloudPerimeters.ISOLATED_CLOUD_PERIMETERS).includes(atlCtxCookieValues.perimeter) && atlCtxCookieValues.icDomain !== undefined;
    if (isIc) return {
        type: 'isolated-cloud',
        perimeter: (0, _constants.COMMERCIAL)
    };
    if (atlCtxCookieValues.perimeter === (0, _constants.FEDRAMP_MODERATE)) return {
        type: 'non-isolated-cloud',
        perimeter: (0, _constants.FEDRAMP_MODERATE)
    };
    // If a new cloud environment has been created but not added to this library, return undefined
    return undefined;
}
function cloudEnvironment() {
    if (typeof document === 'undefined') return cloudEnvironmentSsrLookup();
    return cloudEnvironmentCookieLookup();
}

},{"../../common/constants":"caGXq","../../common/constants/isolated-cloud-perimeters":"9PE09","../atl-cookies-lookup":"5JOPy","@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"6ayz9":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "ReservedNameMapping", ()=>ReservedNameMapping);
parcelHelpers.export(exports, "AtlDomainMapping", ()=>AtlDomainMapping);
parcelHelpers.export(exports, "isolatedCloudFunctions", ()=>isolatedCloudFunctions);
parcelHelpers.export(exports, "nonIsolatedCloudFunctions", ()=>nonIsolatedCloudFunctions);
var _constants = require("../../common/constants");
const ReservedNameMapping = {
    [(0, _constants.COMMERCIAL)]: [
        'home',
        'team',
        'start',
        'id',
        'api',
        'admin',
        'auth',
        'bitbucket'
    ]
};
const AtlDomainMapping = {
    [(0, _constants.COMMERCIAL)]: [
        'packages'
    ]
};
const isolatedCloudFunctions = {
    [(0, _constants.COMMERCIAL)]: {
        isolatedCloudReservedNameDomain: (subdomain, isolatedCloudDomain)=>`${subdomain}.${isolatedCloudDomain}`,
        isolatedCloudAtlDomain: (subdomain, isolatedCloudDomain)=>`${subdomain}.atl.${isolatedCloudDomain}`,
        isolatedCloudVanityDomain: (subdomain, isolatedCloudDomain)=>`${subdomain}.services.${isolatedCloudDomain}`
    }
};
const nonIsolatedCloudFunctions = {
    [(0, _constants.COMMERCIAL)]: {
        defaultDomainEnding: (subdomain, envType)=>{
            switch(envType){
                case 0, _constants.PRODUCTION:
                    return `${subdomain}.atlassian.com`;
                case 0, _constants.STAGING:
                    return `${subdomain}.stg.atlassian.com`;
                case 0, _constants.DEV:
                    return `${subdomain}.dev.atlassian.com`;
                default:
                    console.warn(`Cannot get non-isolated commercial domain for provided environment, ${envType} is unsupported`);
                    return '';
            }
        }
    },
    [(0, _constants.FEDRAMP_MODERATE)]: {
        defaultDomainEnding: (subdomain, envType)=>{
            switch(envType){
                case 0, _constants.PRODUCTION:
                    return `${subdomain}.atlassian-us-gov-mod.com`;
                case 0, _constants.STAGING:
                    return `${subdomain}.stg.atlassian-us-gov-mod.com`;
                default:
                    console.warn(`Cannot get fedramp-moderate domain for provided environment, ${envType} is unsupported`);
                    return '';
            }
        }
    }
};

},{"../../common/constants":"caGXq","@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"jImXA":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "getUrlForDomainInContext", ()=>getUrlForDomainInContext);
var _getDomainInContext = require("./getDomainInContext");
function getUrlForDomainInContext(subdomain, envType) {
    var _globalThis_location;
    const domain = (0, _getDomainInContext.getDomainInContext)(subdomain, envType);
    if (!domain) {
        console.warn(`Domain could not be determined for requested subdomain: ${subdomain}`);
        return undefined;
    }
    var _globalThis_location_protocol;
    return `${(_globalThis_location_protocol = (_globalThis_location = globalThis.location) === null || _globalThis_location === void 0 ? void 0 : _globalThis_location.protocol) !== null && _globalThis_location_protocol !== void 0 ? _globalThis_location_protocol : 'https:'}//${domain}`;
}

},{"./getDomainInContext":"fGWCb","@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"kQyGS":[function(require,module,exports,__globalThis) {
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.ISOLATED_CLOUD_COMMERCIAL_KEY = exports.FED_MOD_KEY = exports.COMMERCIAL_KEY = exports.UnderAuditPhase = exports.BOUNDARY_KEYS_LIST = exports.getFeatureAvailabilityMetadataForBoundary = exports.isFeatureEnabledForBoundary = exports.isEnvironmentBlockEnabledForBoundary = void 0;
var FeatureEncoding_1 = require("4c976524b619360f");
Object.defineProperty(exports, "isEnvironmentBlockEnabledForBoundary", {
    enumerable: true,
    get: function() {
        return FeatureEncoding_1.isEnvironmentBlockEnabledForBoundary;
    }
});
var FeatureEncoding_2 = require("4c976524b619360f");
Object.defineProperty(exports, "isFeatureEnabledForBoundary", {
    enumerable: true,
    get: function() {
        return FeatureEncoding_2.isFeatureEnabledForBoundary;
    }
});
var FeatureEncoding_3 = require("4c976524b619360f");
Object.defineProperty(exports, "getFeatureAvailabilityMetadataForBoundary", {
    enumerable: true,
    get: function() {
        return FeatureEncoding_3.getFeatureAvailabilityMetadataForBoundary;
    }
});
var types_1 = require("716e3c5ac9618d44");
Object.defineProperty(exports, "BOUNDARY_KEYS_LIST", {
    enumerable: true,
    get: function() {
        return types_1.BOUNDARY_KEYS_LIST;
    }
});
Object.defineProperty(exports, "UnderAuditPhase", {
    enumerable: true,
    get: function() {
        return types_1.UnderAuditPhase;
    }
});
Object.defineProperty(exports, "COMMERCIAL_KEY", {
    enumerable: true,
    get: function() {
        return types_1.COMMERCIAL_KEY;
    }
});
Object.defineProperty(exports, "FED_MOD_KEY", {
    enumerable: true,
    get: function() {
        return types_1.FED_MOD_KEY;
    }
});
Object.defineProperty(exports, "ISOLATED_CLOUD_COMMERCIAL_KEY", {
    enumerable: true,
    get: function() {
        return types_1.ISOLATED_CLOUD_COMMERCIAL_KEY;
    }
});

},{"4c976524b619360f":"9VaAb","716e3c5ac9618d44":"f15HN"}],"9VaAb":[function(require,module,exports,__globalThis) {
"use strict";
var __importDefault = this && this.__importDefault || function(mod) {
    return mod && mod.__esModule ? mod : {
        "default": mod
    };
};
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.getFeatureAvailabilityMetadataForBoundary = exports.isFeatureEnabledForBoundary = exports.isEnvironmentBlockEnabledForBoundary = void 0;
const sdk_data_json_1 = __importDefault(require("9bea491fbe77c7ac"));
const aemEnvironmentBlockData = sdk_data_json_1.default;
// Build reverse map: offeringId -> offeringShortKeyId, derived from compositionKeyMap (offeringShortKeyId -> offeringId)
const offeringToOfferingShortKeyId = Object.fromEntries(Object.entries(aemEnvironmentBlockData.compositionKeyMap).map(([offeringShortKeyId, offeringId])=>[
        offeringId,
        offeringShortKeyId
    ]));
/**
 * Translates a full offering ID (BoundaryKey) to its short SDK key name.
 * Falls back to the original key if no mapping exists.
 */ function toofferingShortKeyId(boundaryKey) {
    const mapped = offeringToOfferingShortKeyId[boundaryKey];
    return mapped !== undefined && mapped !== null ? mapped : boundaryKey;
}
/**
 *
 * @param environmentBlockName Name of environment block as encoded in AEM
 * @param boundaryKey The boundary to evaluate for.
 *
 * @returns if the environment block is available in the current cloud environment
 */ function isEnvironmentBlockEnabledForBoundary(environmentBlockName, boundaryKey) {
    return environmentBlockInBoundary(environmentBlockName, boundaryKey);
}
exports.isEnvironmentBlockEnabledForBoundary = isEnvironmentBlockEnabledForBoundary;
/**
 *
 * @param environmentBlockName Name of environment block as encoded in AEM (the environment block that the feature belongs to)
 * @param featureName Name of feature as encoded in AEM
 * @param boundaryKey The boundary to evaluate for
 *
 * @returns if the feature is available in the current cloud environment
 */ function isFeatureEnabledForBoundary(environmentBlockName, featureName, boundaryKey) {
    if (environmentBlockInBoundary(environmentBlockName, boundaryKey)) {
        const environmentBlockData = aemEnvironmentBlockData.environmentBlocks[environmentBlockName];
        const feature = environmentBlockData.features[featureName];
        if (!feature) return false;
        return feature.compositions[toofferingShortKeyId(boundaryKey)] === true;
    }
    return false;
}
exports.isFeatureEnabledForBoundary = isFeatureEnabledForBoundary;
/**
 *
 * @param environmentBlockName Name of environment block as encoded in AEM (the environment block that the feature belongs to)
 * @param featureName Name of feature as encoded in AEM
 * @param boundaryKey The boundary to evaluate for
 *
 * @returns the availability metadata for the feature in the given boundary, or undefined if none
 */ function getFeatureAvailabilityMetadataForBoundary(environmentBlockName, featureName, boundaryKey) {
    const block = aemEnvironmentBlockData.environmentBlocks[environmentBlockName];
    if (!block) return undefined;
    const feature = block.features[featureName];
    if (!feature) return undefined;
    return feature.availabilityMetadata && feature.availabilityMetadata[toofferingShortKeyId(boundaryKey)];
}
exports.getFeatureAvailabilityMetadataForBoundary = getFeatureAvailabilityMetadataForBoundary;
function environmentBlockInBoundary(environmentBlockName, boundaryKey) {
    const block = aemEnvironmentBlockData.environmentBlocks[environmentBlockName];
    if (!block) return false;
    return block.compositions[toofferingShortKeyId(boundaryKey)] === true;
}

},{"9bea491fbe77c7ac":"by4vc"}],"by4vc":[function(require,module,exports,__globalThis) {
module.exports = JSON.parse("{\"compositionKeyMap\":{\"cc\":\"commercial-cloud\",\"ic\":\"isolated-cloud-commercial\",\"fm\":\"fedramp-moderate\"},\"environmentBlocks\":{\"adminhub\":{\"compositions\":{\"cc\":true,\"ic\":true,\"fm\":true},\"features\":{\"admin-hub-threat-detection-system-for-custom-domains\":{\"compositions\":{\"cc\":true,\"ic\":false,\"fm\":false}},\"adminhub-access-requests\":{\"compositions\":{\"cc\":true,\"ic\":false,\"fm\":false}},\"adminhub-add-app-beta-grid\":{\"compositions\":{\"cc\":true,\"ic\":false,\"fm\":false}},\"adminhub-add-app-collections-grid\":{\"compositions\":{\"cc\":true,\"ic\":false,\"fm\":false}},\"adminhub-add-app-discover-grid\":{\"compositions\":{\"cc\":true,\"ic\":false,\"fm\":false}},\"adminhub-add-app-enterprise-grid\":{\"compositions\":{\"cc\":true,\"ic\":false,\"fm\":true}},\"adminhub-add-app-standalone-apps-grid\":{\"compositions\":{\"cc\":true,\"ic\":false,\"fm\":false}},\"adminhub-add-product\":{\"compositions\":{\"cc\":true,\"ic\":false,\"fm\":true}},\"adminhub-admin-insights\":{\"compositions\":{\"cc\":true,\"ic\":false,\"fm\":false}},\"adminhub-ai-enabled-apps\":{\"compositions\":{\"cc\":true,\"ic\":false,\"fm\":false}},\"adminhub-api-token-controls\":{\"compositions\":{\"cc\":true,\"ic\":true,\"fm\":true}},\"adminhub-app-requests\":{\"compositions\":{\"cc\":true,\"ic\":true,\"fm\":false}},\"adminhub-app-updates\":{\"compositions\":{\"cc\":true,\"ic\":true,\"fm\":true}},\"adminhub-application-tunnels\":{\"compositions\":{\"cc\":true,\"ic\":true,\"fm\":false}},\"adminhub-apps-discovery\":{\"compositions\":{\"cc\":true,\"ic\":false,\"fm\":false}},\"adminhub-atlassian-intelligence\":{\"compositions\":{\"cc\":true,\"ic\":true,\"fm\":false}},\"adminhub-audit-log\":{\"compositions\":{\"cc\":true,\"ic\":true,\"fm\":true}},\"adminhub-authentication-policies\":{\"compositions\":{\"cc\":true,\"ic\":true,\"fm\":true}},\"adminhub-automations\":{\"compositions\":{\"cc\":true,\"ic\":true,\"fm\":false}},\"adminhub-backup-and-restore\":{\"compositions\":{\"cc\":true,\"ic\":true,\"fm\":true}},\"adminhub-billing-console\":{\"compositions\":{\"cc\":true,\"ic\":true,\"fm\":true}},\"adminhub-billing-preview\":{\"compositions\":{\"cc\":true,\"ic\":true,\"fm\":true}},\"adminhub-byok\":{\"compositions\":{\"cc\":true,\"ic\":false,\"fm\":false}},\"adminhub-cart\":{\"compositions\":{\"cc\":true,\"ic\":true,\"fm\":false}},\"adminhub-cmk-encryption\":{\"compositions\":{\"cc\":true,\"ic\":false,\"fm\":false}},\"adminhub-code-intelligence\":{\"compositions\":{\"cc\":true,\"ic\":true,\"fm\":false}},\"adminhub-connected-emoji\":{\"compositions\":{\"cc\":true,\"ic\":false,\"fm\":true}},\"adminhub-connected-sources\":{\"compositions\":{\"cc\":true,\"ic\":false,\"fm\":false}},\"adminhub-connector-protection\":{\"compositions\":{\"cc\":true,\"ic\":true,\"fm\":false}},\"adminhub-contacts\":{\"compositions\":{\"cc\":true,\"ic\":false,\"fm\":false}},\"adminhub-custom-domain-email-notification\":{\"compositions\":{\"cc\":true,\"ic\":false,\"fm\":true}},\"adminhub-custom-domains\":{\"compositions\":{\"cc\":true,\"ic\":false,\"fm\":false}},\"adminhub-data-classifications\":{\"compositions\":{\"cc\":true,\"ic\":true,\"fm\":false}},\"adminhub-data-management\":{\"compositions\":{\"cc\":true,\"ic\":true,\"fm\":false}},\"adminhub-data-residency\":{\"compositions\":{\"cc\":true,\"ic\":false,\"fm\":false}},\"adminhub-data-security-policies\":{\"compositions\":{\"cc\":true,\"ic\":true,\"fm\":true}},\"adminhub-data-transfer\":{\"compositions\":{\"cc\":true,\"ic\":true,\"fm\":true}},\"adminhub-delta-migrations\":{\"compositions\":{\"cc\":true,\"ic\":true,\"fm\":false}},\"adminhub-disaster-recovery\":{\"compositions\":{\"cc\":true,\"ic\":false,\"fm\":false}},\"adminhub-discover-apps-shadow-it\":{\"compositions\":{\"cc\":true,\"ic\":false,\"fm\":false}},\"adminhub-discover-new-products\":{\"compositions\":{\"cc\":true,\"ic\":false,\"fm\":false}},\"adminhub-enable-user-merge\":{\"compositions\":{\"cc\":true,\"ic\":true,\"fm\":true}},\"adminhub-encryption\":{\"compositions\":{\"cc\":true,\"ic\":false,\"fm\":false}},\"adminhub-environments\":{\"compositions\":{\"cc\":true,\"ic\":true,\"fm\":false}},\"adminhub-experiment-controls\":{\"compositions\":{\"cc\":true,\"ic\":true,\"fm\":false}},\"adminhub-external-user-security\":{\"compositions\":{\"cc\":true,\"ic\":false,\"fm\":true}},\"adminhub-footprint\":{\"compositions\":{\"cc\":true,\"ic\":true,\"fm\":false}},\"adminhub-freeze-windows\":{\"compositions\":{\"cc\":true,\"ic\":true,\"fm\":false}},\"adminhub-guard-detect-alerts\":{\"compositions\":{\"cc\":true,\"ic\":true,\"fm\":false}},\"adminhub-guard-detect-detections\":{\"compositions\":{\"cc\":true,\"ic\":true,\"fm\":false}},\"adminhub-help\":{\"compositions\":{\"cc\":true,\"ic\":false,\"fm\":true}},\"adminhub-hippa-compliance\":{\"compositions\":{\"cc\":true,\"ic\":true,\"fm\":false}},\"adminhub-jsm-scim\":{\"compositions\":{\"cc\":true,\"ic\":false,\"fm\":false}},\"adminhub-link-bitbucket\":{\"compositions\":{\"cc\":true,\"ic\":false,\"fm\":false}},\"adminhub-llm\":{\"compositions\":{\"cc\":true,\"ic\":false,\"fm\":false}},\"adminhub-login-customisation\":{\"compositions\":{\"cc\":true,\"ic\":true,\"fm\":false}},\"adminhub-managed-accounts-export\":{\"compositions\":{\"cc\":true,\"ic\":true,\"fm\":true}},\"adminhub-marketplace-apps\":{\"compositions\":{\"cc\":true,\"ic\":true,\"fm\":false}},\"adminhub-mcp-settings\":{\"compositions\":{\"cc\":true,\"ic\":true,\"fm\":false}},\"adminhub-mobile-app-policy\":{\"compositions\":{\"cc\":true,\"ic\":true,\"fm\":false}},\"adminhub-nested-side-navigation\":{\"compositions\":{\"cc\":true,\"ic\":false,\"fm\":true}},\"adminhub-org-audit-logs\":{\"compositions\":{\"cc\":true,\"ic\":true,\"fm\":true}},\"adminhub-org-create\":{\"compositions\":{\"cc\":true,\"ic\":false,\"fm\":false}},\"adminhub-org-deletion\":{\"compositions\":{\"cc\":true,\"ic\":true,\"fm\":false}},\"adminhub-org-transfer\":{\"compositions\":{\"cc\":true,\"ic\":false,\"fm\":false}},\"adminhub-performance-monitoring\":{\"compositions\":{\"cc\":true,\"ic\":false,\"fm\":false}},\"adminhub-platform-usage\":{\"compositions\":{\"cc\":true,\"ic\":false,\"fm\":false}},\"adminhub-policies\":{\"compositions\":{\"cc\":true,\"ic\":true,\"fm\":false}},\"adminhub-product-insights-workflow-discovery\":{\"compositions\":{\"cc\":true,\"ic\":true,\"fm\":false}},\"adminhub-product-insights\":{\"compositions\":{\"cc\":true,\"ic\":true,\"fm\":false}},\"adminhub-product-links\":{\"compositions\":{\"cc\":true,\"ic\":true,\"fm\":true}},\"adminhub-product-recommendation\":{\"compositions\":{\"cc\":true,\"ic\":false,\"fm\":false}},\"adminhub-product-urls\":{\"compositions\":{\"cc\":true,\"ic\":true,\"fm\":false}},\"adminhub-release-tracks\":{\"compositions\":{\"cc\":true,\"ic\":true,\"fm\":false}},\"adminhub-revamped-organization-overview\":{\"compositions\":{\"cc\":true,\"ic\":false,\"fm\":false}},\"adminhub-rovo-access\":{\"compositions\":{\"cc\":true,\"ic\":false,\"fm\":false}},\"adminhub-rovo-chat-protection\":{\"compositions\":{\"cc\":true,\"ic\":true,\"fm\":false}},\"adminhub-rovo-insights\":{\"compositions\":{\"cc\":true,\"ic\":false,\"fm\":false}},\"adminhub-rovo-mcp-server\":{\"compositions\":{\"cc\":true,\"ic\":true,\"fm\":false}},\"adminhub-rovo-settings\":{\"compositions\":{\"cc\":true,\"ic\":false,\"fm\":false}},\"adminhub-saml-sso\":{\"compositions\":{\"cc\":true,\"ic\":true,\"fm\":true}},\"adminhub-sandbox\":{\"compositions\":{\"cc\":true,\"ic\":true,\"fm\":true}},\"adminhub-security-checklist\":{\"compositions\":{\"cc\":true,\"ic\":true,\"fm\":false}},\"adminhub-sensitive-data-policies\":{\"compositions\":{\"cc\":true,\"ic\":true,\"fm\":false}},\"adminhub-signup\":{\"compositions\":{\"cc\":true,\"ic\":false,\"fm\":false}},\"adminhub-site-rename\":{\"compositions\":{\"cc\":true,\"ic\":true,\"fm\":false}},\"adminhub-site-transfer\":{\"compositions\":{\"cc\":true,\"ic\":false,\"fm\":false}},\"adminhub-system-health\":{\"compositions\":{\"cc\":true,\"ic\":true,\"fm\":false}},\"adminhub-team-site-assignment\":{\"compositions\":{\"cc\":true,\"ic\":true,\"fm\":false}},\"adminhub-teams\":{\"compositions\":{\"cc\":true,\"ic\":true,\"fm\":false}},\"adminhub-teamwork-graph-cli\":{\"compositions\":{\"cc\":true,\"ic\":true,\"fm\":false}},\"adminhub-units\":{\"compositions\":{\"cc\":true,\"ic\":true,\"fm\":false}},\"adminhub-use-available-apps\":{\"compositions\":{\"cc\":true,\"ic\":false,\"fm\":false}},\"adminhub-user-access-invites\":{\"compositions\":{\"cc\":true,\"ic\":true,\"fm\":true}},\"adminhub-user-access-settings\":{\"compositions\":{\"cc\":true,\"ic\":false,\"fm\":false}},\"adminhub-user-connected-apps\":{\"compositions\":{\"cc\":true,\"ic\":true,\"fm\":false}},\"adminhub-user-counts\":{\"compositions\":{\"cc\":true,\"ic\":true,\"fm\":false}},\"adminhub-user-last-active-timestamp\":{\"compositions\":{\"cc\":true,\"ic\":false,\"fm\":true}},\"adminhub-workspaces-table-plans\":{\"compositions\":{\"cc\":true,\"ic\":false,\"fm\":true}},\"core-adminhub\":{\"compositions\":{\"cc\":true,\"ic\":true,\"fm\":true}}}},\"assets\":{\"compositions\":{\"cc\":true,\"ic\":true,\"fm\":true},\"features\":{\"assets-data-manager\":{\"compositions\":{\"cc\":true,\"ic\":true,\"fm\":true}},\"assets-recent-items\":{\"compositions\":{\"cc\":true,\"ic\":false,\"fm\":true}},\"assets-reports\":{\"compositions\":{\"cc\":true,\"ic\":false,\"fm\":true}},\"assets-rovo-search\":{\"compositions\":{\"cc\":true,\"ic\":false,\"fm\":false}},\"core-assets\":{\"compositions\":{\"cc\":true,\"ic\":true,\"fm\":true}}}},\"atlassian-analytics\":{\"compositions\":{\"cc\":true,\"ic\":false,\"fm\":true},\"features\":{\"atlassian-analytics-3p-data-source-connections\":{\"compositions\":{\"cc\":true,\"ic\":false,\"fm\":false}},\"atlassian-analytics-chart-dashboard-pdf-png-exports\":{\"compositions\":{\"cc\":true,\"ic\":false,\"fm\":false}},\"atlassian-analytics-chart-templates\":{\"compositions\":{\"cc\":true,\"ic\":false,\"fm\":true}},\"atlassian-analytics-charts\":{\"compositions\":{\"cc\":true,\"ic\":false,\"fm\":true}},\"atlassian-analytics-comments\":{\"compositions\":{\"cc\":true,\"ic\":false,\"fm\":true}},\"atlassian-analytics-commerce-sentry\":{\"compositions\":{\"cc\":true,\"ic\":false,\"fm\":false}},\"atlassian-analytics-cross-product-interaction-client\":{\"compositions\":{\"cc\":true,\"ic\":false,\"fm\":false}},\"atlassian-analytics-dashboard-subscriptions\":{\"compositions\":{\"cc\":true,\"ic\":false,\"fm\":true}},\"atlassian-analytics-dashboard-templates\":{\"compositions\":{\"cc\":true,\"ic\":false,\"fm\":true}},\"atlassian-analytics-dashboards\":{\"compositions\":{\"cc\":true,\"ic\":false,\"fm\":true}},\"atlassian-analytics-data-lake-connections\":{\"compositions\":{\"cc\":true,\"ic\":false,\"fm\":true}},\"atlassian-analytics-data-shares\":{\"compositions\":{\"cc\":true,\"ic\":false,\"fm\":false}},\"atlassian-analytics-jira-align-enterprise-insights-connections\":{\"compositions\":{\"cc\":true,\"ic\":false,\"fm\":false}},\"core-atlassian-analytics\":{\"compositions\":{\"cc\":true,\"ic\":false,\"fm\":true}}}},\"bitbucket\":{\"compositions\":{\"cc\":true,\"ic\":false,\"fm\":false},\"features\":{\"bitbucket-development-events-and-status\":{\"compositions\":{\"cc\":true,\"ic\":false,\"fm\":false}},\"bitbucket-merge-queue\":{\"compositions\":{\"cc\":true,\"ic\":false,\"fm\":false}},\"bitbucket-slack-app\":{\"compositions\":{\"cc\":true,\"ic\":false,\"fm\":false}},\"bitbucket-ssh-key-validation\":{\"compositions\":{\"cc\":true,\"ic\":false,\"fm\":false}},\"pipelines\":{\"compositions\":{\"cc\":true,\"ic\":false,\"fm\":false}}}},\"chat\":{\"compositions\":{\"cc\":true,\"ic\":true,\"fm\":false},\"features\":{}},\"compass\":{\"compositions\":{\"cc\":true,\"ic\":false,\"fm\":false},\"features\":{}},\"confluence\":{\"compositions\":{\"cc\":true,\"ic\":true,\"fm\":true},\"features\":{\"ccma\":{\"compositions\":{\"cc\":true,\"ic\":true,\"fm\":true}},\"confluence-ai\":{\"compositions\":{\"cc\":true,\"ic\":false,\"fm\":false}},\"confluence-anonymous-access\":{\"compositions\":{\"cc\":true,\"ic\":true,\"fm\":false}},\"confluence-comment-and-header-links\":{\"compositions\":{\"cc\":true,\"ic\":true,\"fm\":true}},\"confluence-company-hub\":{\"compositions\":{\"cc\":true,\"ic\":true,\"fm\":false}},\"confluence-content-archiving\":{\"compositions\":{\"cc\":true,\"ic\":true,\"fm\":true}},\"confluence-content-manager\":{\"compositions\":{\"cc\":true,\"ic\":true,\"fm\":true}},\"confluence-databases\":{\"compositions\":{\"cc\":true,\"ic\":true,\"fm\":false},\"availabilityMetadata\":{\"fm\":{\"auditPhase\":\"internal-audit\"}}},\"confluence-editing-experience\":{\"compositions\":{\"cc\":true,\"ic\":true,\"fm\":true}},\"confluence-edition-awareness\":{\"compositions\":{\"cc\":true,\"ic\":true,\"fm\":false}},\"confluence-editor-offline-storage\":{\"compositions\":{\"cc\":true,\"ic\":true,\"fm\":false}},\"confluence-embedded-pages\":{\"compositions\":{\"cc\":true,\"ic\":false,\"fm\":false}},\"confluence-employee-directory\":{\"compositions\":{\"cc\":true,\"ic\":true,\"fm\":true}},\"confluence-forge-apps-sidebar\":{\"compositions\":{\"cc\":true,\"ic\":true,\"fm\":true}},\"confluence-inline-comments-in-edit-mode\":{\"compositions\":{\"cc\":true,\"ic\":true,\"fm\":true}},\"confluence-inspect-permissions\":{\"compositions\":{\"cc\":true,\"ic\":true,\"fm\":true}},\"confluence-invitations\":{\"compositions\":{\"cc\":true,\"ic\":false,\"fm\":true}},\"confluence-loom-integration\":{\"compositions\":{\"cc\":true,\"ic\":false,\"fm\":false}},\"confluence-mission-control\":{\"compositions\":{\"cc\":true,\"ic\":true,\"fm\":true}},\"confluence-mobile-app\":{\"compositions\":{\"cc\":true,\"ic\":true,\"fm\":false}},\"confluence-ms-teams-integration\":{\"compositions\":{\"cc\":true,\"ic\":false,\"fm\":true}},\"confluence-page-analytics\":{\"compositions\":{\"cc\":true,\"ic\":true,\"fm\":true}},\"confluence-pages-blogs-folders\":{\"compositions\":{\"cc\":true,\"ic\":true,\"fm\":true}},\"confluence-premium-onboarding\":{\"compositions\":{\"cc\":true,\"ic\":true,\"fm\":false}},\"confluence-presenter-mode\":{\"compositions\":{\"cc\":true,\"ic\":true,\"fm\":true}},\"confluence-public-links\":{\"compositions\":{\"cc\":true,\"ic\":true,\"fm\":false}},\"confluence-questions-native-experience\":{\"compositions\":{\"cc\":true,\"ic\":true,\"fm\":false}},\"confluence-questions\":{\"compositions\":{\"cc\":true,\"ic\":true,\"fm\":true}},\"confluence-recap\":{\"compositions\":{\"cc\":true,\"ic\":false,\"fm\":false}},\"confluence-search\":{\"compositions\":{\"cc\":true,\"ic\":true,\"fm\":true}},\"confluence-server\":{\"compositions\":{\"cc\":true,\"ic\":true,\"fm\":true}},\"confluence-share-to-slack-button\":{\"compositions\":{\"cc\":true,\"ic\":false,\"fm\":false}},\"confluence-single-space-guests\":{\"compositions\":{\"cc\":true,\"ic\":true,\"fm\":false}},\"confluence-slack-integration\":{\"compositions\":{\"cc\":true,\"ic\":true,\"fm\":true}},\"confluence-slides\":{\"compositions\":{\"cc\":true,\"ic\":false,\"fm\":false}},\"confluence-smart-links\":{\"compositions\":{\"cc\":true,\"ic\":true,\"fm\":true}},\"confluence-space-analytics\":{\"compositions\":{\"cc\":true,\"ic\":true,\"fm\":true}},\"confluence-team-calendars\":{\"compositions\":{\"cc\":true,\"ic\":true,\"fm\":false}},\"confluence-update-page-owners\":{\"compositions\":{\"cc\":true,\"ic\":true,\"fm\":true}},\"confluence-whiteboards\":{\"compositions\":{\"cc\":true,\"ic\":true,\"fm\":false},\"availabilityMetadata\":{\"fm\":{\"auditPhase\":\"internal-audit\"}}},\"core-confluence\":{\"compositions\":{\"cc\":true,\"ic\":true,\"fm\":true}}}},\"customer-service-management\":{\"compositions\":{\"cc\":true,\"ic\":false,\"fm\":false},\"features\":{}},\"dx\":{\"compositions\":{\"cc\":true,\"ic\":false,\"fm\":false},\"features\":{}},\"feedback\":{\"compositions\":{\"cc\":true,\"ic\":true,\"fm\":true},\"features\":{}},\"focus\":{\"compositions\":{\"cc\":true,\"ic\":false,\"fm\":false},\"features\":{\"asks-and-planning\":{\"compositions\":{\"cc\":true,\"ic\":false,\"fm\":false}}}},\"goals\":{\"compositions\":{\"cc\":true,\"ic\":true,\"fm\":false},\"features\":{}},\"guard-premium\":{\"compositions\":{\"cc\":true,\"ic\":true,\"fm\":true},\"features\":{}},\"home\":{\"compositions\":{\"cc\":true,\"ic\":true,\"fm\":false},\"features\":{\"home-org-chart-analytics-pipeline\":{\"compositions\":{\"cc\":true,\"ic\":false,\"fm\":false}},\"home-status-backend\":{\"compositions\":{\"cc\":true,\"ic\":true,\"fm\":false}}}},\"jira\":{\"compositions\":{\"cc\":true,\"ic\":true,\"fm\":true},\"features\":{\"core-jira\":{\"compositions\":{\"cc\":true,\"ic\":true,\"fm\":true}},\"issue-transition-customisation-for-srb\":{\"compositions\":{\"cc\":true,\"ic\":true,\"fm\":false}},\"jcma-x2c\":{\"compositions\":{\"cc\":true,\"ic\":false,\"fm\":true}},\"jcma\":{\"compositions\":{\"cc\":true,\"ic\":true,\"fm\":true}},\"jira-admin-oauth-credentials\":{\"compositions\":{\"cc\":true,\"ic\":true,\"fm\":false}},\"jira-ai-issue-classification\":{\"compositions\":{\"cc\":true,\"ic\":false,\"fm\":false}},\"jira-ai-snippet\":{\"compositions\":{\"cc\":true,\"ic\":true,\"fm\":false}},\"jira-ai-upsell-in-editor-free\":{\"compositions\":{\"cc\":true,\"ic\":true,\"fm\":false}},\"jira-apps-menu\":{\"compositions\":{\"cc\":true,\"ic\":false,\"fm\":true}},\"jira-atlassian-intelligence\":{\"compositions\":{\"cc\":true,\"ic\":true,\"fm\":true}},\"jira-atlassian-vs-code-extension\":{\"compositions\":{\"cc\":true,\"ic\":true,\"fm\":true}},\"jira-audit-log\":{\"compositions\":{\"cc\":true,\"ic\":true,\"fm\":true}},\"jira-backlogs\":{\"compositions\":{\"cc\":true,\"ic\":true,\"fm\":true}},\"jira-boards-and-views\":{\"compositions\":{\"cc\":true,\"ic\":true,\"fm\":true}},\"jira-calendar-view\":{\"compositions\":{\"cc\":true,\"ic\":true,\"fm\":true}},\"jira-company-managed-projects\":{\"compositions\":{\"cc\":true,\"ic\":true,\"fm\":true}},\"jira-components\":{\"compositions\":{\"cc\":true,\"ic\":false,\"fm\":false}},\"jira-dashboard-public-sharing\":{\"compositions\":{\"cc\":true,\"ic\":true,\"fm\":false}},\"jira-demux\":{\"compositions\":{\"cc\":true,\"ic\":true,\"fm\":true}},\"jira-development-hub\":{\"compositions\":{\"cc\":true,\"ic\":false,\"fm\":false}},\"jira-development-tab-druid-metric-cards\":{\"compositions\":{\"cc\":true,\"ic\":false,\"fm\":false}},\"jira-development-tab\":{\"compositions\":{\"cc\":true,\"ic\":false,\"fm\":true}},\"jira-devinfo-async-pull-request-icon\":{\"compositions\":{\"cc\":true,\"ic\":true,\"fm\":false}},\"jira-devops-toolchain\":{\"compositions\":{\"cc\":true,\"ic\":false,\"fm\":false}},\"jira-edition-awareness\":{\"compositions\":{\"cc\":true,\"ic\":true,\"fm\":false}},\"jira-figma-integration\":{\"compositions\":{\"cc\":true,\"ic\":false,\"fm\":false}},\"jira-forms\":{\"compositions\":{\"cc\":true,\"ic\":true,\"fm\":true}},\"jira-github-for-jira\":{\"compositions\":{\"cc\":true,\"ic\":false,\"fm\":true}},\"jira-github-workflows\":{\"compositions\":{\"cc\":true,\"ic\":false,\"fm\":false}},\"jira-goals-nav\":{\"compositions\":{\"cc\":true,\"ic\":true,\"fm\":false}},\"jira-import-work-sidebar\":{\"compositions\":{\"cc\":true,\"ic\":true,\"fm\":false}},\"jira-in-product-help\":{\"compositions\":{\"cc\":true,\"ic\":true,\"fm\":true}},\"jira-insights\":{\"compositions\":{\"cc\":true,\"ic\":true,\"fm\":true}},\"jira-invite-people\":{\"compositions\":{\"cc\":true,\"ic\":false,\"fm\":true}},\"jira-issue\":{\"compositions\":{\"cc\":true,\"ic\":true,\"fm\":true}},\"jira-jpd-nav-recommendations\":{\"compositions\":{\"cc\":true,\"ic\":true,\"fm\":false}},\"jira-jpd-roadmap-on-timeline-cross-sell\":{\"compositions\":{\"cc\":true,\"ic\":true,\"fm\":false}},\"jira-loom-banner\":{\"compositions\":{\"cc\":true,\"ic\":false,\"fm\":false}},\"jira-marketplace-sidebar-recommendations\":{\"compositions\":{\"cc\":true,\"ic\":true,\"fm\":false}},\"jira-mobile-app\":{\"compositions\":{\"cc\":true,\"ic\":true,\"fm\":false}},\"jira-ms-teams-integration\":{\"compositions\":{\"cc\":true,\"ic\":false,\"fm\":false}},\"jira-next-best-task\":{\"compositions\":{\"cc\":true,\"ic\":true,\"fm\":false}},\"jira-oasis-reports\":{\"compositions\":{\"cc\":true,\"ic\":false,\"fm\":true}},\"jira-opsgenie\":{\"compositions\":{\"cc\":true,\"ic\":true,\"fm\":false}},\"jira-plans\":{\"compositions\":{\"cc\":true,\"ic\":true,\"fm\":true}},\"jira-project-archiving\":{\"compositions\":{\"cc\":true,\"ic\":true,\"fm\":true}},\"jira-project-issue-navigator\":{\"compositions\":{\"cc\":true,\"ic\":true,\"fm\":true}},\"jira-project-templates\":{\"compositions\":{\"cc\":true,\"ic\":true,\"fm\":true}},\"jira-project-theme-unsplash\":{\"compositions\":{\"cc\":true,\"ic\":true,\"fm\":false}},\"jira-quickstart-pages\":{\"compositions\":{\"cc\":true,\"ic\":false,\"fm\":false}},\"jira-releases\":{\"compositions\":{\"cc\":true,\"ic\":true,\"fm\":true}},\"jira-roadmap-in-nav\":{\"compositions\":{\"cc\":true,\"ic\":true,\"fm\":false}},\"jira-share\":{\"compositions\":{\"cc\":true,\"ic\":true,\"fm\":true}},\"jira-site-optimiser\":{\"compositions\":{\"cc\":true,\"ic\":true,\"fm\":true}},\"jira-slack\":{\"compositions\":{\"cc\":true,\"ic\":true,\"fm\":false}},\"jira-smart-links\":{\"compositions\":{\"cc\":true,\"ic\":true,\"fm\":true}},\"jira-smart-related-issues\":{\"compositions\":{\"cc\":true,\"ic\":true,\"fm\":false}},\"jira-software-devops\":{\"compositions\":{\"cc\":true,\"ic\":true,\"fm\":false}},\"jira-software-reports-cycle-time\":{\"compositions\":{\"cc\":true,\"ic\":true,\"fm\":false}},\"jira-software-reports-deployment-frequency\":{\"compositions\":{\"cc\":true,\"ic\":true,\"fm\":false}},\"jira-spreadsheets-integration\":{\"compositions\":{\"cc\":true,\"ic\":false,\"fm\":false}},\"jira-synced-blocks\":{\"compositions\":{\"cc\":true,\"ic\":true,\"fm\":false}},\"jira-team-managed-projects\":{\"compositions\":{\"cc\":true,\"ic\":true,\"fm\":true}},\"jira-unsplash\":{\"compositions\":{\"cc\":true,\"ic\":true,\"fm\":false}},\"jira-whiteboards-backlog-experiment\":{\"compositions\":{\"cc\":true,\"ic\":false,\"fm\":true}},\"jira-work-item-archiving\":{\"compositions\":{\"cc\":true,\"ic\":true,\"fm\":true}},\"jira-work-suggestions\":{\"compositions\":{\"cc\":true,\"ic\":true,\"fm\":false}},\"jira-workflow-configuration\":{\"compositions\":{\"cc\":true,\"ic\":true,\"fm\":true}},\"jira-your-work-dashboard\":{\"compositions\":{\"cc\":true,\"ic\":true,\"fm\":true}},\"modern-issue-transition-connect-app-fields\":{\"compositions\":{\"cc\":true,\"ic\":true,\"fm\":false}}}},\"jira-align\":{\"compositions\":{\"cc\":true,\"ic\":false,\"fm\":false},\"features\":{}},\"jira-product-discovery\":{\"compositions\":{\"cc\":true,\"ic\":false,\"fm\":false},\"features\":{}},\"jira-service-management\":{\"compositions\":{\"cc\":true,\"ic\":true,\"fm\":true},\"features\":{\"core-jira-service-management\":{\"compositions\":{\"cc\":true,\"ic\":true,\"fm\":true}},\"jira-service-management-help-center\":{\"compositions\":{\"cc\":true,\"ic\":true,\"fm\":true}},\"jsm-ai-ops\":{\"compositions\":{\"cc\":true,\"ic\":true,\"fm\":false}},\"jsm-ai-services\":{\"compositions\":{\"cc\":true,\"ic\":false,\"fm\":false}},\"jsm-alert-notifications\":{\"compositions\":{\"cc\":true,\"ic\":true,\"fm\":true}},\"jsm-analytics-dashboards\":{\"compositions\":{\"cc\":true,\"ic\":false,\"fm\":false}},\"jsm-approvals\":{\"compositions\":{\"cc\":true,\"ic\":true,\"fm\":true}},\"jsm-assets-vertical\":{\"compositions\":{\"cc\":true,\"ic\":false,\"fm\":false}},\"jsm-automation-playbook\":{\"compositions\":{\"cc\":true,\"ic\":false,\"fm\":false}},\"jsm-boysenberry\":{\"compositions\":{\"cc\":true,\"ic\":true,\"fm\":true}},\"jsm-canned-responses\":{\"compositions\":{\"cc\":true,\"ic\":true,\"fm\":true}},\"jsm-change-ai-risk-assessment\":{\"compositions\":{\"cc\":true,\"ic\":true,\"fm\":false}},\"jsm-change-calendar\":{\"compositions\":{\"cc\":true,\"ic\":true,\"fm\":false}},\"jsm-change-management-deployment-vendors\":{\"compositions\":{\"cc\":true,\"ic\":true,\"fm\":false}},\"jsm-change-management\":{\"compositions\":{\"cc\":true,\"ic\":false,\"fm\":true}},\"jsm-change-risk-assessment\":{\"compositions\":{\"cc\":true,\"ic\":true,\"fm\":true}},\"jsm-change-risk-reporter-configuration\":{\"compositions\":{\"cc\":true,\"ic\":true,\"fm\":false}},\"jsm-chat-ops-ic-custom-apps\":{\"compositions\":{\"cc\":false,\"ic\":true,\"fm\":false}},\"jsm-chat-ops\":{\"compositions\":{\"cc\":true,\"ic\":true,\"fm\":false}},\"jsm-chat\":{\"compositions\":{\"cc\":true,\"ic\":true,\"fm\":false}},\"jsm-cloud-megatron\":{\"compositions\":{\"cc\":true,\"ic\":true,\"fm\":true}},\"jsm-csat\":{\"compositions\":{\"cc\":true,\"ic\":true,\"fm\":true}},\"jsm-csm-functionality\":{\"compositions\":{\"cc\":true,\"ic\":false,\"fm\":false}},\"jsm-customer-access-internal-account\":{\"compositions\":{\"cc\":true,\"ic\":true,\"fm\":false}},\"jsm-customer-notifications\":{\"compositions\":{\"cc\":true,\"ic\":true,\"fm\":true}},\"jsm-customer-service-management\":{\"compositions\":{\"cc\":true,\"ic\":true,\"fm\":false}},\"jsm-deployment-gating\":{\"compositions\":{\"cc\":true,\"ic\":true,\"fm\":false}},\"jsm-deployment-tracking\":{\"compositions\":{\"cc\":true,\"ic\":false,\"fm\":true}},\"jsm-developer-escalations\":{\"compositions\":{\"cc\":true,\"ic\":true,\"fm\":false}},\"jsm-email-requests\":{\"compositions\":{\"cc\":true,\"ic\":true,\"fm\":true}},\"jsm-embeddable-widget\":{\"compositions\":{\"cc\":true,\"ic\":true,\"fm\":true}},\"jsm-entity-migration\":{\"compositions\":{\"cc\":true,\"ic\":true,\"fm\":true}},\"jsm-err-governance-api\":{\"compositions\":{\"cc\":true,\"ic\":true,\"fm\":false}},\"jsm-external-customer-accounts\":{\"compositions\":{\"cc\":true,\"ic\":true,\"fm\":false}},\"jsm-external-customer-single-sign-on\":{\"compositions\":{\"cc\":true,\"ic\":true,\"fm\":false}},\"jsm-external-customer-user-provisioning\":{\"compositions\":{\"cc\":true,\"ic\":true,\"fm\":false}},\"jsm-forms\":{\"compositions\":{\"cc\":true,\"ic\":true,\"fm\":true}},\"jsm-halp-admin-panel\":{\"compositions\":{\"cc\":true,\"ic\":false,\"fm\":false}},\"jsm-help-center-change-password\":{\"compositions\":{\"cc\":true,\"ic\":true,\"fm\":false}},\"jsm-help-center-password-login\":{\"compositions\":{\"cc\":true,\"ic\":false,\"fm\":false}},\"jsm-help-center-rovo-agent\":{\"compositions\":{\"cc\":true,\"ic\":true,\"fm\":false}},\"jsm-help-center-virtual-agent\":{\"compositions\":{\"cc\":true,\"ic\":true,\"fm\":false}},\"jsm-help-center\":{\"compositions\":{\"cc\":true,\"ic\":true,\"fm\":true}},\"jsm-incident-conference-calls\":{\"compositions\":{\"cc\":true,\"ic\":true,\"fm\":false}},\"jsm-incident-management-integration\":{\"compositions\":{\"cc\":true,\"ic\":true,\"fm\":true}},\"jsm-issue\":{\"compositions\":{\"cc\":true,\"ic\":true,\"fm\":true}},\"jsm-journey-builder\":{\"compositions\":{\"cc\":true,\"ic\":false,\"fm\":false}},\"jsm-knowledge-base\":{\"compositions\":{\"cc\":true,\"ic\":true,\"fm\":true}},\"jsm-multi-language-support\":{\"compositions\":{\"cc\":true,\"ic\":true,\"fm\":true}},\"jsm-on-call-schedule\":{\"compositions\":{\"cc\":true,\"ic\":true,\"fm\":false}},\"jsm-ops-genie-reporting\":{\"compositions\":{\"cc\":true,\"ic\":true,\"fm\":false}},\"jsm-opsgenie-conference-management\":{\"compositions\":{\"cc\":true,\"ic\":false,\"fm\":false}},\"jsm-opsgenie-devops\":{\"compositions\":{\"cc\":true,\"ic\":true,\"fm\":false}},\"jsm-portal-only-account-scim\":{\"compositions\":{\"cc\":true,\"ic\":true,\"fm\":true}},\"jsm-post-incident-reviews\":{\"compositions\":{\"cc\":true,\"ic\":true,\"fm\":true}},\"jsm-queues\":{\"compositions\":{\"cc\":true,\"ic\":true,\"fm\":true}},\"jsm-related-issues\":{\"compositions\":{\"cc\":true,\"ic\":false,\"fm\":true}},\"jsm-reports-operations\":{\"compositions\":{\"cc\":true,\"ic\":true,\"fm\":false}},\"jsm-request-intake\":{\"compositions\":{\"cc\":true,\"ic\":true,\"fm\":true}},\"jsm-services\":{\"compositions\":{\"cc\":true,\"ic\":true,\"fm\":true}},\"jsm-shield\":{\"compositions\":{\"cc\":true,\"ic\":true,\"fm\":true}},\"jsm-sla-management\":{\"compositions\":{\"cc\":true,\"ic\":true,\"fm\":true}},\"jsm-status-page-integration\":{\"compositions\":{\"cc\":true,\"ic\":false,\"fm\":false}},\"jsm-surveys\":{\"compositions\":{\"cc\":true,\"ic\":false,\"fm\":false}},\"jsm-templates-and-views\":{\"compositions\":{\"cc\":true,\"ic\":true,\"fm\":true}},\"jsm-virtual-service-agent\":{\"compositions\":{\"cc\":true,\"ic\":false,\"fm\":false}},\"jsm-workforce\":{\"compositions\":{\"cc\":true,\"ic\":false,\"fm\":false}},\"opsgenie\":{\"compositions\":{\"cc\":true,\"ic\":true,\"fm\":true}}}},\"loom\":{\"compositions\":{\"cc\":true,\"ic\":false,\"fm\":false},\"features\":{\"loom-ai-evaluation\":{\"compositions\":{\"cc\":true,\"ic\":false,\"fm\":false}}}},\"projects\":{\"compositions\":{\"cc\":true,\"ic\":true,\"fm\":false},\"features\":{}},\"rovo\":{\"compositions\":{\"cc\":true,\"ic\":false,\"fm\":false},\"features\":{\"rovo-ai-app-availability\":{\"compositions\":{\"cc\":true,\"ic\":false,\"fm\":false}},\"rovo-ai-atlassian-intelligence-app-availability\":{\"compositions\":{\"cc\":true,\"ic\":false,\"fm\":false}},\"rovo-ai-generative-ai-editor\":{\"compositions\":{\"cc\":true,\"ic\":false,\"fm\":false}},\"rovo-ai-machine-learning\":{\"compositions\":{\"cc\":true,\"ic\":false,\"fm\":false}},\"rovo-ai-natural-language-in-automation-rule-creation\":{\"compositions\":{\"cc\":true,\"ic\":false,\"fm\":false}},\"rovo-ai-projects\":{\"compositions\":{\"cc\":true,\"ic\":false,\"fm\":false}},\"rovo-ai-smart-features-based-on-machine-learning-tecton-ai\":{\"compositions\":{\"cc\":true,\"ic\":false,\"fm\":false}},\"rovo-editor-ai-panels\":{\"compositions\":{\"cc\":true,\"ic\":false,\"fm\":false}}}},\"rovo-dev\":{\"compositions\":{\"cc\":true,\"ic\":false,\"fm\":false},\"features\":{\"rovo-dev-agents\":{\"compositions\":{\"cc\":true,\"ic\":false,\"fm\":false}},\"rovo-dev-code-assist\":{\"compositions\":{\"cc\":true,\"ic\":false,\"fm\":false}}}},\"statuspage\":{\"compositions\":{\"cc\":true,\"ic\":false,\"fm\":false},\"features\":{}},\"studio\":{\"compositions\":{\"cc\":true,\"ic\":false,\"fm\":false},\"features\":{}},\"talent\":{\"compositions\":{\"cc\":true,\"ic\":false,\"fm\":false},\"features\":{}},\"teams\":{\"compositions\":{\"cc\":true,\"ic\":true,\"fm\":true},\"features\":{\"teams-platform\":{\"compositions\":{\"cc\":true,\"ic\":true,\"fm\":true}},\"teams-profile-media-token-fetch\":{\"compositions\":{\"cc\":true,\"ic\":true,\"fm\":false}},\"teams-third-party-invites\":{\"compositions\":{\"cc\":true,\"ic\":false,\"fm\":false}},\"user-provided-banners-on-profile-pictures\":{\"compositions\":{\"cc\":true,\"ic\":false,\"fm\":false}}}},\"trello\":{\"compositions\":{\"cc\":true,\"ic\":false,\"fm\":false},\"features\":{\"trello-ms-teams-integration\":{\"compositions\":{\"cc\":true,\"ic\":false,\"fm\":false}}}},\"anti-abuse-platform\":{\"compositions\":{\"cc\":true,\"ic\":false,\"fm\":true},\"features\":{\"core-anti-abuse-platform\":{\"compositions\":{\"cc\":true,\"ic\":false,\"fm\":true}}}},\"application-tunnels\":{\"compositions\":{\"cc\":true,\"ic\":true,\"fm\":false},\"features\":{\"core-application-tunnels\":{\"compositions\":{\"cc\":true,\"ic\":true,\"fm\":false}}}},\"atlassian-cli\":{\"compositions\":{\"cc\":true,\"ic\":false,\"fm\":false},\"features\":{}},\"atlassian-new-platform\":{\"compositions\":{\"cc\":true,\"ic\":false,\"fm\":false},\"features\":{}},\"atlassian-visualization-platform\":{\"compositions\":{\"cc\":true,\"ic\":false,\"fm\":true},\"features\":{\"atlassian-visualization-platform-kamino\":{\"compositions\":{\"cc\":true,\"ic\":false,\"fm\":true}},\"atlassian-visualization-platform-manifold\":{\"compositions\":{\"cc\":true,\"ic\":false,\"fm\":true}},\"atlassian-visualization-platform-rovo-skills\":{\"compositions\":{\"cc\":true,\"ic\":false,\"fm\":false}}}},\"central-ai\":{\"compositions\":{\"cc\":true,\"ic\":false,\"fm\":false},\"features\":{\"ai-3p-connections\":{\"compositions\":{\"cc\":true,\"ic\":false,\"fm\":false}},\"ai-managed-objects\":{\"compositions\":{\"cc\":true,\"ic\":false,\"fm\":false}},\"ai-safety\":{\"compositions\":{\"cc\":true,\"ic\":false,\"fm\":false}},\"collaboration-graph\":{\"compositions\":{\"cc\":true,\"ic\":false,\"fm\":false}},\"gen-ai\":{\"compositions\":{\"cc\":true,\"ic\":false,\"fm\":false}},\"knowledge-ai\":{\"compositions\":{\"cc\":true,\"ic\":false,\"fm\":false}},\"knowledge-discovery\":{\"compositions\":{\"cc\":true,\"ic\":false,\"fm\":false}},\"machine-learning-platform\":{\"compositions\":{\"cc\":true,\"ic\":false,\"fm\":false}}}},\"collaboration-platform\":{\"compositions\":{\"cc\":true,\"ic\":true,\"fm\":true},\"features\":{\"core-collaboration-platform\":{\"compositions\":{\"cc\":true,\"ic\":false,\"fm\":true}}}},\"commerce-platform\":{\"compositions\":{\"cc\":true,\"ic\":true,\"fm\":true},\"features\":{\"commerce-platform-pls-changes-for-hams-cofs-in-boundary-deployment\":{\"compositions\":{\"cc\":true,\"ic\":true,\"fm\":true}},\"commerce-platform-self-serve\":{\"compositions\":{\"cc\":true,\"ic\":true,\"fm\":true}},\"core-commerce-platform\":{\"compositions\":{\"cc\":true,\"ic\":true,\"fm\":true}}}},\"customer-data-lake\":{\"compositions\":{\"cc\":true,\"ic\":true,\"fm\":true},\"features\":{\"core-customer-data-lake\":{\"compositions\":{\"cc\":true,\"ic\":true,\"fm\":true}}}},\"customer-support-platform\":{\"compositions\":{\"cc\":true,\"ic\":false,\"fm\":true},\"features\":{}},\"ecosystem-forge\":{\"compositions\":{\"cc\":true,\"ic\":true,\"fm\":true},\"features\":{\"core-ecosystem-forge\":{\"compositions\":{\"cc\":true,\"ic\":true,\"fm\":true}},\"dac-get-help-widget\":{\"compositions\":{\"cc\":true,\"ic\":false,\"fm\":false}},\"developer-atlassian-community\":{\"compositions\":{\"cc\":true,\"ic\":false,\"fm\":false}},\"docs-atlassian-com\":{\"compositions\":{\"cc\":true,\"ic\":false,\"fm\":false}},\"ecosystem-oauth\":{\"compositions\":{\"cc\":true,\"ic\":true,\"fm\":true}},\"expression-playground\":{\"compositions\":{\"cc\":true,\"ic\":false,\"fm\":false}},\"forge-cli\":{\"compositions\":{\"cc\":true,\"ic\":true,\"fm\":false}},\"forge-remote-capabilities\":{\"compositions\":{\"cc\":true,\"ic\":true,\"fm\":true}},\"forge-storage-service-rockmelon\":{\"compositions\":{\"cc\":true,\"ic\":true,\"fm\":false}},\"forge-system-apps\":{\"compositions\":{\"cc\":true,\"ic\":true,\"fm\":true}},\"forge-ui-ic-cdn-auth\":{\"compositions\":{\"cc\":false,\"ic\":true,\"fm\":false}}}},\"editor-collaboration-platform\":{\"compositions\":{\"cc\":true,\"ic\":true,\"fm\":true},\"features\":{\"block-service\":{\"compositions\":{\"cc\":true,\"ic\":true,\"fm\":true}},\"core-editor-collaboration-platform\":{\"compositions\":{\"cc\":true,\"ic\":true,\"fm\":true}},\"real-time-presence\":{\"compositions\":{\"cc\":true,\"ic\":true,\"fm\":true}}}},\"experience-platform\":{\"compositions\":{\"cc\":true,\"ic\":false,\"fm\":true},\"features\":{\"core-experience-platform\":{\"compositions\":{\"cc\":true,\"ic\":false,\"fm\":true}}}},\"gasv3\":{\"compositions\":{\"cc\":true,\"ic\":true,\"fm\":true},\"features\":{\"core-gasv3\":{\"compositions\":{\"cc\":true,\"ic\":true,\"fm\":true}}}},\"growth-platform\":{\"compositions\":{\"cc\":true,\"ic\":true,\"fm\":true},\"features\":{\"bxp-signup\":{\"compositions\":{\"cc\":true,\"ic\":true,\"fm\":true}},\"core-growth-platform\":{\"compositions\":{\"cc\":true,\"ic\":true,\"fm\":true}}}},\"identity\":{\"compositions\":{\"cc\":true,\"ic\":true,\"fm\":true},\"features\":{\"core-identity\":{\"compositions\":{\"cc\":true,\"ic\":true,\"fm\":true}},\"identity-mail-proxy\":{\"compositions\":{\"cc\":true,\"ic\":true,\"fm\":true}},\"identity-virality\":{\"compositions\":{\"cc\":true,\"ic\":true,\"fm\":true}}}},\"learning-platform\":{\"compositions\":{\"cc\":true,\"ic\":false,\"fm\":true},\"features\":{}},\"marketplace\":{\"compositions\":{\"cc\":true,\"ic\":true,\"fm\":true},\"features\":{\"marketplace-app-discovery\":{\"compositions\":{\"cc\":true,\"ic\":true,\"fm\":true}},\"marketplace-app-migrations\":{\"compositions\":{\"cc\":true,\"ic\":true,\"fm\":true}},\"marketplace-atlassian-labs\":{\"compositions\":{\"cc\":true,\"ic\":true,\"fm\":true}},\"marketplace-audit-logs\":{\"compositions\":{\"cc\":true,\"ic\":true,\"fm\":false}},\"marketplace-self-service-purchase-provision-install\":{\"compositions\":{\"cc\":true,\"ic\":true,\"fm\":true}}}},\"migrations\":{\"compositions\":{\"cc\":true,\"ic\":true,\"fm\":true},\"features\":{\"agc-migrations\":{\"compositions\":{\"cc\":true,\"ic\":true,\"fm\":true}},\"commercial-cloud-to-agc\":{\"compositions\":{\"cc\":true,\"ic\":true,\"fm\":false}},\"data-center-to-agc\":{\"compositions\":{\"cc\":true,\"ic\":true,\"fm\":false}},\"migration-link-fixing\":{\"compositions\":{\"cc\":true,\"ic\":true,\"fm\":true}}}},\"migrations-platform\":{\"compositions\":{\"cc\":true,\"ic\":true,\"fm\":true},\"features\":{\"brie\":{\"compositions\":{\"cc\":true,\"ic\":true,\"fm\":true}},\"core-migrations-platform\":{\"compositions\":{\"cc\":true,\"ic\":true,\"fm\":true}},\"data-center-to-cloud-migration\":{\"compositions\":{\"cc\":true,\"ic\":false,\"fm\":false}},\"media-migration\":{\"compositions\":{\"cc\":true,\"ic\":false,\"fm\":true}}}},\"navigation\":{\"compositions\":{\"cc\":true,\"ic\":true,\"fm\":true},\"features\":{\"core-navigation\":{\"compositions\":{\"cc\":true,\"ic\":true,\"fm\":true}},\"navigation-home-entry-mode\":{\"compositions\":{\"cc\":true,\"ic\":true,\"fm\":false}},\"navigation-identity-ic-routing\":{\"compositions\":{\"cc\":false,\"ic\":true,\"fm\":false}},\"navigation-switcher-discovery\":{\"compositions\":{\"cc\":true,\"ic\":true,\"fm\":false}},\"navigation-switcher-rovo-scas-visibility\":{\"compositions\":{\"cc\":true,\"ic\":true,\"fm\":false}}}},\"notification-platform\":{\"compositions\":{\"cc\":true,\"ic\":true,\"fm\":true},\"features\":{\"core-notification-platform\":{\"compositions\":{\"cc\":true,\"ic\":true,\"fm\":true}},\"notifications-fpn-link\":{\"compositions\":{\"cc\":true,\"ic\":false,\"fm\":true}}}},\"post-office\":{\"compositions\":{\"cc\":true,\"ic\":true,\"fm\":true},\"features\":{\"core-post-office\":{\"compositions\":{\"cc\":true,\"ic\":true,\"fm\":true}}}},\"product-integrations-platform\":{\"compositions\":{\"cc\":true,\"ic\":true,\"fm\":true},\"features\":{\"core-product-integrations-platform\":{\"compositions\":{\"cc\":true,\"ic\":false,\"fm\":true}},\"external-user-directory-integration\":{\"compositions\":{\"cc\":true,\"ic\":false,\"fm\":false}},\"google-workspace-apps-integrations\":{\"compositions\":{\"cc\":true,\"ic\":false,\"fm\":false}},\"sign-in-with-slack-usage-analytics\":{\"compositions\":{\"cc\":true,\"ic\":false,\"fm\":false}}}},\"search\":{\"compositions\":{\"cc\":true,\"ic\":true,\"fm\":true},\"features\":{\"core-search\":{\"compositions\":{\"cc\":true,\"ic\":true,\"fm\":true}},\"search-townsquare-tab\":{\"compositions\":{\"cc\":true,\"ic\":true,\"fm\":false}}}},\"smartlinks\":{\"compositions\":{\"cc\":true,\"ic\":true,\"fm\":true},\"features\":{\"core-smartlinks\":{\"compositions\":{\"cc\":true,\"ic\":true,\"fm\":true}}}},\"user-management\":{\"compositions\":{\"cc\":true,\"ic\":true,\"fm\":true},\"features\":{\"core-user-management\":{\"compositions\":{\"cc\":true,\"ic\":true,\"fm\":true}}}},\"user-recommendations\":{\"compositions\":{\"cc\":true,\"ic\":true,\"fm\":true},\"features\":{\"core-user-recommendations\":{\"compositions\":{\"cc\":true,\"ic\":true,\"fm\":true}}}},\"atlassian-graphql-gateway\":{\"compositions\":{\"cc\":true,\"ic\":true,\"fm\":true},\"features\":{\"core-atlassian-graphql-gateway\":{\"compositions\":{\"cc\":true,\"ic\":true,\"fm\":true}}}},\"atlassian-platform-deployer\":{\"compositions\":{\"cc\":true,\"ic\":true,\"fm\":true},\"features\":{}},\"automation-platform\":{\"compositions\":{\"cc\":true,\"ic\":true,\"fm\":true},\"features\":{\"automation-platform-actions\":{\"compositions\":{\"cc\":true,\"ic\":true,\"fm\":false}},\"automation-platform-automation-templates\":{\"compositions\":{\"cc\":true,\"ic\":true,\"fm\":true}},\"automation-platform-branches\":{\"compositions\":{\"cc\":true,\"ic\":true,\"fm\":false}},\"automation-platform-conditions\":{\"compositions\":{\"cc\":true,\"ic\":true,\"fm\":false}},\"automation-platform-event-processing\":{\"compositions\":{\"cc\":true,\"ic\":true,\"fm\":true}},\"automation-platform-frontend\":{\"compositions\":{\"cc\":true,\"ic\":false,\"fm\":true}},\"automation-platform-natural-language-rule-builder\":{\"compositions\":{\"cc\":true,\"ic\":true,\"fm\":true}},\"automation-platform-rule-builder\":{\"compositions\":{\"cc\":true,\"ic\":true,\"fm\":true}},\"automation-platform-templates\":{\"compositions\":{\"cc\":true,\"ic\":true,\"fm\":true}},\"automation-platform-triggers\":{\"compositions\":{\"cc\":true,\"ic\":true,\"fm\":false}},\"core-automation-platform\":{\"compositions\":{\"cc\":true,\"ic\":true,\"fm\":true}}}},\"bifrost\":{\"compositions\":{\"cc\":true,\"ic\":true,\"fm\":true},\"features\":{\"core-bifrost\":{\"compositions\":{\"cc\":true,\"ic\":true,\"fm\":true}}}},\"build-platform\":{\"compositions\":{\"cc\":true,\"ic\":true,\"fm\":true},\"features\":{}},\"cell-platform\":{\"compositions\":{\"cc\":true,\"ic\":false,\"fm\":true},\"features\":{}},\"cloud-management\":{\"compositions\":{\"cc\":true,\"ic\":true,\"fm\":true},\"features\":{}},\"cloud-security\":{\"compositions\":{\"cc\":true,\"ic\":true,\"fm\":true},\"features\":{}},\"compliance-platform\":{\"compositions\":{\"cc\":true,\"ic\":true,\"fm\":true},\"features\":{}},\"consent-platform\":{\"compositions\":{\"cc\":true,\"ic\":true,\"fm\":true},\"features\":{\"consenthub\":{\"compositions\":{\"cc\":true,\"ic\":false,\"fm\":false}}}},\"core-network-automation\":{\"compositions\":{\"cc\":true,\"ic\":true,\"fm\":true},\"features\":{\"core-core-network-automation\":{\"compositions\":{\"cc\":true,\"ic\":true,\"fm\":true}}}},\"core-network-automation-cna-theia\":{\"compositions\":{\"cc\":true,\"ic\":true,\"fm\":true},\"features\":{\"core-core-network-automation-cna-theia\":{\"compositions\":{\"cc\":true,\"ic\":true,\"fm\":true}}}},\"core-network-automation-l2\":{\"compositions\":{\"cc\":true,\"ic\":true,\"fm\":true},\"features\":{\"core-core-network-automation-l2\":{\"compositions\":{\"cc\":true,\"ic\":true,\"fm\":true}}}},\"cross-gateway\":{\"compositions\":{\"cc\":true,\"ic\":true,\"fm\":true},\"features\":{\"core-cross-gateway\":{\"compositions\":{\"cc\":true,\"ic\":true,\"fm\":true}}}},\"customer-data-lake-layer2\":{\"compositions\":{\"cc\":true,\"ic\":true,\"fm\":true},\"features\":{}},\"data-access-platform\":{\"compositions\":{\"cc\":true,\"ic\":true,\"fm\":true},\"features\":{\"core-data-access-platform\":{\"compositions\":{\"cc\":true,\"ic\":true,\"fm\":true}}}},\"data-classification-governance-platform\":{\"compositions\":{\"cc\":true,\"ic\":true,\"fm\":true},\"features\":{\"core-data-classification-governance-platform\":{\"compositions\":{\"cc\":true,\"ic\":true,\"fm\":true}}}},\"data-depot-platform\":{\"compositions\":{\"cc\":true,\"ic\":true,\"fm\":true},\"features\":{\"core-data-depot-platform\":{\"compositions\":{\"cc\":true,\"ic\":true,\"fm\":true}}}},\"data-exchange-platform\":{\"compositions\":{\"cc\":true,\"ic\":true,\"fm\":true},\"features\":{\"aqui\":{\"compositions\":{\"cc\":true,\"ic\":false,\"fm\":false}},\"eureka\":{\"compositions\":{\"cc\":true,\"ic\":true,\"fm\":true}},\"kamino\":{\"compositions\":{\"cc\":true,\"ic\":true,\"fm\":true}},\"shipyard\":{\"compositions\":{\"cc\":true,\"ic\":true,\"fm\":true}},\"topic-osb\":{\"compositions\":{\"cc\":true,\"ic\":true,\"fm\":true}}}},\"data-exchange-platform-l3\":{\"compositions\":{\"cc\":true,\"ic\":true,\"fm\":true},\"features\":{\"core-data-exchange-platform-l3\":{\"compositions\":{\"cc\":true,\"ic\":true,\"fm\":true}}}},\"data-management-platform\":{\"compositions\":{\"cc\":true,\"ic\":true,\"fm\":true},\"features\":{\"core-data-management-platform\":{\"compositions\":{\"cc\":true,\"ic\":true,\"fm\":true}},\"ers-import\":{\"compositions\":{\"cc\":true,\"ic\":true,\"fm\":true}},\"ers\":{\"compositions\":{\"cc\":true,\"ic\":true,\"fm\":true}},\"sql\":{\"compositions\":{\"cc\":true,\"ic\":true,\"fm\":true}}}},\"data-platform-services\":{\"compositions\":{\"cc\":true,\"ic\":true,\"fm\":true},\"features\":{\"core-data-platform-services\":{\"compositions\":{\"cc\":true,\"ic\":true,\"fm\":true}}}},\"data-store-gateway\":{\"compositions\":{\"cc\":true,\"ic\":true,\"fm\":true},\"features\":{\"core-data-store-gateway\":{\"compositions\":{\"cc\":true,\"ic\":true,\"fm\":true}}}},\"data-telemetry-platform\":{\"compositions\":{\"cc\":true,\"ic\":false,\"fm\":true},\"features\":{\"core-data-telemetry-platform\":{\"compositions\":{\"cc\":true,\"ic\":false,\"fm\":true}}}},\"decisions-platform\":{\"compositions\":{\"cc\":true,\"ic\":true,\"fm\":true},\"features\":{\"core-decisions-platform\":{\"compositions\":{\"cc\":true,\"ic\":true,\"fm\":true}},\"experimentation\":{\"compositions\":{\"cc\":true,\"ic\":false,\"fm\":false}}}},\"detection-and-response-platform\":{\"compositions\":{\"cc\":true,\"ic\":true,\"fm\":true},\"features\":{}},\"disaster-recovery\":{\"compositions\":{\"cc\":true,\"ic\":true,\"fm\":true},\"features\":{}},\"edge\":{\"compositions\":{\"cc\":true,\"ic\":true,\"fm\":true},\"features\":{\"core-edge\":{\"compositions\":{\"cc\":true,\"ic\":true,\"fm\":true}},\"edge-cloudfront\":{\"compositions\":{\"cc\":true,\"ic\":true,\"fm\":true}}}},\"encryption-platform\":{\"compositions\":{\"cc\":true,\"ic\":true,\"fm\":true},\"features\":{\"cryptor\":{\"compositions\":{\"cc\":true,\"ic\":true,\"fm\":true}}}},\"environment-management-platform\":{\"compositions\":{\"cc\":true,\"ic\":true,\"fm\":true},\"features\":{}},\"flight-deck-platform\":{\"compositions\":{\"cc\":true,\"ic\":true,\"fm\":true},\"features\":{}},\"golden-ami\":{\"compositions\":{\"cc\":true,\"ic\":true,\"fm\":true},\"features\":{}},\"incident-management-platform\":{\"compositions\":{\"cc\":true,\"ic\":true,\"fm\":true},\"features\":{}},\"infrastructure\":{\"compositions\":{\"cc\":true,\"ic\":true,\"fm\":true},\"features\":{\"core-infrastructure\":{\"compositions\":{\"cc\":true,\"ic\":true,\"fm\":true}}}},\"internal-data-lake\":{\"compositions\":{\"cc\":true,\"ic\":true,\"fm\":true},\"features\":{\"airlock-platform\":{\"compositions\":{\"cc\":true,\"ic\":false,\"fm\":false}}}},\"internal-edge\":{\"compositions\":{\"cc\":true,\"ic\":true,\"fm\":true},\"features\":{\"core-internal-edge\":{\"compositions\":{\"cc\":true,\"ic\":true,\"fm\":true}}}},\"internal-edge-httpbin\":{\"compositions\":{\"cc\":true,\"ic\":true,\"fm\":true},\"features\":{\"core-internal-edge-httpbin\":{\"compositions\":{\"cc\":true,\"ic\":true,\"fm\":true}}}},\"job-execution-platform\":{\"compositions\":{\"cc\":true,\"ic\":true,\"fm\":true},\"features\":{\"core-job-execution-platform\":{\"compositions\":{\"cc\":true,\"ic\":true,\"fm\":true}}}},\"kitt-platform\":{\"compositions\":{\"cc\":true,\"ic\":true,\"fm\":true},\"features\":{\"kitt-fleet\":{\"compositions\":{\"cc\":true,\"ic\":true,\"fm\":true}}}},\"media-platform\":{\"compositions\":{\"cc\":true,\"ic\":true,\"fm\":true},\"features\":{\"core-media-platform\":{\"compositions\":{\"cc\":true,\"ic\":false,\"fm\":true}},\"media-cdn-delivery\":{\"compositions\":{\"cc\":true,\"ic\":false,\"fm\":true}}}},\"messaging-platform\":{\"compositions\":{\"cc\":true,\"ic\":true,\"fm\":true},\"features\":{}},\"micros-platform\":{\"compositions\":{\"cc\":true,\"ic\":true,\"fm\":true},\"features\":{}},\"network-fabric\":{\"compositions\":{\"cc\":true,\"ic\":true,\"fm\":true},\"features\":{\"core-network-fabric\":{\"compositions\":{\"cc\":true,\"ic\":true,\"fm\":true}}}},\"observability-platform\":{\"compositions\":{\"cc\":true,\"ic\":true,\"fm\":true},\"features\":{\"sentry-opsgenie-integration\":{\"compositions\":{\"cc\":true,\"ic\":true,\"fm\":false}},\"tracing\":{\"compositions\":{\"cc\":true,\"ic\":true,\"fm\":false}}}},\"pollinator\":{\"compositions\":{\"cc\":true,\"ic\":true,\"fm\":true},\"features\":{\"core-pollinator\":{\"compositions\":{\"cc\":true,\"ic\":true,\"fm\":true}}}},\"pollinator-l2\":{\"compositions\":{\"cc\":true,\"ic\":true,\"fm\":true},\"features\":{\"core-pollinator-l2\":{\"compositions\":{\"cc\":true,\"ic\":true,\"fm\":true}}}},\"provisioning\":{\"compositions\":{\"cc\":true,\"ic\":true,\"fm\":true},\"features\":{\"core-provisioning\":{\"compositions\":{\"cc\":true,\"ic\":true,\"fm\":true}}}},\"rate-limiting-platform\":{\"compositions\":{\"cc\":true,\"ic\":true,\"fm\":true},\"features\":{\"core-rate-limiting-platform\":{\"compositions\":{\"cc\":true,\"ic\":true,\"fm\":true}}}},\"resiliency-platform\":{\"compositions\":{\"cc\":true,\"ic\":true,\"fm\":true},\"features\":{}},\"secrets\":{\"compositions\":{\"cc\":true,\"ic\":false,\"fm\":false},\"features\":{}},\"security-platform\":{\"compositions\":{\"cc\":true,\"ic\":true,\"fm\":true},\"features\":{}},\"service-to-service-fabric\":{\"compositions\":{\"cc\":true,\"ic\":true,\"fm\":true},\"features\":{}},\"slauth-auth-slack-notification-platform\":{\"compositions\":{\"cc\":true,\"ic\":false,\"fm\":false},\"features\":{}},\"sliver\":{\"compositions\":{\"cc\":true,\"ic\":true,\"fm\":false},\"features\":{}},\"staff-authentication-platform\":{\"compositions\":{\"cc\":true,\"ic\":true,\"fm\":true},\"features\":{}},\"streamhub\":{\"compositions\":{\"cc\":true,\"ic\":true,\"fm\":true},\"features\":{\"core-streamhub\":{\"compositions\":{\"cc\":true,\"ic\":true,\"fm\":true}}}},\"targeting-platform\":{\"compositions\":{\"cc\":true,\"ic\":true,\"fm\":true},\"features\":{\"core-targeting-platform\":{\"compositions\":{\"cc\":true,\"ic\":true,\"fm\":true}}}},\"teamwork-graph-platform\":{\"compositions\":{\"cc\":true,\"ic\":true,\"fm\":true},\"features\":{\"core-teamwork-graph-platform\":{\"compositions\":{\"cc\":true,\"ic\":true,\"fm\":true}},\"flock\":{\"compositions\":{\"cc\":true,\"ic\":false,\"fm\":true}}}},\"tenant-catalogue-service-record\":{\"compositions\":{\"cc\":true,\"ic\":true,\"fm\":true},\"features\":{\"core-tenant-catalogue-service-record\":{\"compositions\":{\"cc\":true,\"ic\":true,\"fm\":true}}}},\"tenant-context\":{\"compositions\":{\"cc\":true,\"ic\":true,\"fm\":true},\"features\":{\"core-tenant-context\":{\"compositions\":{\"cc\":true,\"ic\":true,\"fm\":true}}}},\"tenant-lifecycle\":{\"compositions\":{\"cc\":true,\"ic\":true,\"fm\":true},\"features\":{\"core-tenant-platform\":{\"compositions\":{\"cc\":true,\"ic\":false,\"fm\":true}},\"tenant-passivation-removal\":{\"compositions\":{\"cc\":true,\"ic\":false,\"fm\":false}}}},\"vdi\":{\"compositions\":{\"cc\":true,\"ic\":false,\"fm\":true},\"features\":{}},\"workplace-technology-solutions\":{\"compositions\":{\"cc\":true,\"ic\":true,\"fm\":true},\"features\":{}}}}");

},{}],"f15HN":[function(require,module,exports,__globalThis) {
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.UnderAuditPhase = exports.BOUNDARY_KEYS_LIST = exports.ISOLATED_CLOUD_COMMERCIAL_KEY = exports.FED_MOD_KEY = exports.COMMERCIAL_KEY = void 0;
// Each BoundaryKey is a key in the sdk data
exports.COMMERCIAL_KEY = "commercial-cloud";
exports.FED_MOD_KEY = "fedramp-moderate";
exports.ISOLATED_CLOUD_COMMERCIAL_KEY = "isolated-cloud-commercial";
exports.BOUNDARY_KEYS_LIST = [
    exports.COMMERCIAL_KEY,
    exports.FED_MOD_KEY,
    exports.ISOLATED_CLOUD_COMMERCIAL_KEY
];
var UnderAuditPhase;
(function(UnderAuditPhase) {
    UnderAuditPhase["INTERNAL_AUDIT"] = "internal-audit";
    UnderAuditPhase["EXTERNAL_AUDIT"] = "external-audit";
})(UnderAuditPhase || (exports.UnderAuditPhase = UnderAuditPhase = {}));

},{}],"3gD30":[function(require,module,exports,__globalThis) {
"use strict";
/**
 * Manages feature overrides stored in browser localStorage.
 * No-ops when not in a browser context.
 *
 * localStorage key: "AEM_FEATURE_OVERRIDES"
 * localStorage value: JSON-encoded string mapping "{environmentBlockName}::{featureName}" to boolean
 *
 * Example:
 *   "AEM_FEATURE_OVERRIDES": "{\"confluence::my_feature\":true,\"jira::other_feature\":false}"
 */ Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.clearAllOverrides = exports.clearFeatureOverride = exports.overrideFeature = exports.getFeatureOverride = exports.STORAGE_KEY = void 0;
exports.STORAGE_KEY = "AEM_FEATURE_OVERRIDES";
function buildKey(environmentBlockName, featureName) {
    return `${environmentBlockName}::${featureName}`;
}
function isBrowserEnvironment() {
    return typeof window !== "undefined" && typeof window.localStorage !== "undefined";
}
function getOverridesMap() {
    const featureOverrideValue = window.localStorage.getItem(exports.STORAGE_KEY);
    if (featureOverrideValue) try {
        return JSON.parse(featureOverrideValue);
    } catch (e) {
        console.warn("Failed to parse AEM_FEATURE_OVERRIDES from localStorage", e);
    }
    return {};
}
function setOverridesMap(map) {
    window.localStorage.setItem(exports.STORAGE_KEY, JSON.stringify(map));
}
/**
 * Returns the override value for a feature if one exists, or null if no override is set.
 * Returns null in non-browser environments.
 */ function getFeatureOverride(environmentBlockName, featureName) {
    if (!isBrowserEnvironment()) return null;
    const map = getOverridesMap();
    const key = buildKey(environmentBlockName, featureName);
    if (key in map) return map[key];
    return null;
}
exports.getFeatureOverride = getFeatureOverride;
/**
 * Sets a feature override in localStorage.
 */ function overrideFeature(environmentBlockName, featureName, value) {
    if (!isBrowserEnvironment()) return;
    const map = getOverridesMap();
    map[buildKey(environmentBlockName, featureName)] = value;
    setOverridesMap(map);
}
exports.overrideFeature = overrideFeature;
/**
 * Removes a single feature override from localStorage. Removes the key entirely if no overrides are left.
 */ function clearFeatureOverride(environmentBlockName, featureName) {
    if (!isBrowserEnvironment()) return;
    const map = getOverridesMap();
    delete map[buildKey(environmentBlockName, featureName)];
    if (Object.keys(map).length === 0) window.localStorage.removeItem(exports.STORAGE_KEY);
    else setOverridesMap(map);
}
exports.clearFeatureOverride = clearFeatureOverride;
/**
 * Clears all feature overrides from localStorage.
 */ function clearAllOverrides() {
    if (!isBrowserEnvironment()) return;
    window.localStorage.removeItem(exports.STORAGE_KEY);
}
exports.clearAllOverrides = clearAllOverrides;

},{}],"9o6tz":[function(require,module,exports,__globalThis) {
var process = require("646080dfbf7ae333");
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.getEnvironmentType = exports.isSSR = void 0;
/** Returns true when running in a server-side rendering context (no browser window). */ function isSSR() {
    return typeof window === "undefined" || typeof document === "undefined" || Boolean(typeof process !== "undefined" && process && process.env && undefined); // see https://bitbucket.org/atlassian/atlassian-frontend-monorepo/src/7377575ff0ec8a6f78257788b224e37c2bae8f66/platform/packages/editor/editor-common/src/core-utils/is-ssr.ts#lines-6
}
exports.isSSR = isSSR;
/**
 * Returns the current environment type.
 * Defaults to "prod" in unknown cases.
 *
 * In SSR contexts, reads from globalThis.ssrContext.environmentType.
 * In browser contexts, infers from window.location.hostname.
 */ function getEnvironmentType() {
    // 1. SSR: Use ssrContext if available
    if (typeof window === "undefined") {
        // @ts-expect-error — ssrContext in globalThis type
        const ssrContext = globalThis.ssrContext;
        if (ssrContext && ssrContext.environmentType) {
            const type = ssrContext.environmentType;
            if (type === "dev") return "non-prod";
            if (type === "staging") return "non-prod";
            if (type === "prod") return "prod";
        }
        return "prod";
    }
    // 2. Browser: Use hostname-based detection with all patterns
    const host = window.location.hostname.toLowerCase();
    if (!host) // default to prod if no location available
    return "prod";
    // Exact matches
    if (host === "localhost" || host === "127.0.0.1") return "non-prod";
    // Staging patterns
    if (host.endsWith(".jira-dev.com") || host.includes(".stg.") || host.includes(".staging.")) return "non-prod";
    // Development patterns
    if (host.includes(".dev.") || host.includes(".ddev.")) return "non-prod";
    if (host.endsWith(".atlassian.net") || host.endsWith(".atlassian-us-gov-mod.com") || host.endsWith(".atlassian.com")) return "prod";
    return "prod";
}
exports.getEnvironmentType = getEnvironmentType;

},{"646080dfbf7ae333":"gNLf3"}],"99YqN":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "INTERNAL_CLIENT_WINDOW_KEY", ()=>INTERNAL_CLIENT_WINDOW_KEY);
parcelHelpers.export(exports, "default", ()=>GlobalInteractionSessionTracking);
var _interactionSessionTracking = require("./interactionSessionTracking");
var _interactionSessionTrackingDefault = parcelHelpers.interopDefault(_interactionSessionTracking);
const INTERNAL_CLIENT_WINDOW_KEY = 'analyticsInteractionSesssionTrackingClient';
class GlobalInteractionSessionTracking {
    static getInstance() {
        let interactionSessionTracking;
        try {
            // Check if InteractionSessionTracking in global window object
            if (INTERNAL_CLIENT_WINDOW_KEY in window) interactionSessionTracking = window[INTERNAL_CLIENT_WINDOW_KEY];
            else {
                // Initialise InteractionSessionTracking on global window object
                window[INTERNAL_CLIENT_WINDOW_KEY] = new (0, _interactionSessionTrackingDefault.default)();
                interactionSessionTracking = window[INTERNAL_CLIENT_WINDOW_KEY];
            }
        } catch (error) {
        // Silently swallow exception
        }
        return interactionSessionTracking;
    }
}

},{"./interactionSessionTracking":"jyjs7","@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"jyjs7":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "DEFAULT_SESSION_EXPIRY_TIME_MS", ()=>DEFAULT_SESSION_EXPIRY_TIME_MS);
parcelHelpers.export(exports, "DEFAULT_PERSISTED_SESSION_TTL_MS", ()=>DEFAULT_PERSISTED_SESSION_TTL_MS);
parcelHelpers.export(exports, "DEFAULT_EXPIRY_DEBOUNCE", ()=>DEFAULT_EXPIRY_DEBOUNCE);
parcelHelpers.export(exports, "DEFAULT_DEBOUNCE_THRESHOLD_PERCENTAGE", ()=>DEFAULT_DEBOUNCE_THRESHOLD_PERCENTAGE);
parcelHelpers.export(exports, "INTERACTION_SESSION_ID_UPDATED_EVENT", ()=>INTERACTION_SESSION_ID_UPDATED_EVENT);
/**
 * This class is essentially a wrapper around SessionStorage that introduces some failsafes (such as switching to InMemoryStorage if SessionStorage is not available)
 * and providing resilient methods for accessing and updating the interaction session ID.
 * This class can be initialised anywhere within a document, and `getCurrentInteractionSessionId` will always return the latest interaction session ID.
 *
 * The `setAnalyticsCallback` method must be called with a valid analytics event callback function provided by an Analytics Web Client before any other methods are used.
 * This is to ensure that any generated or renewed session IDs can be reported via an analytics event.
 *
 * The `setInteractionSessionId` method will write the SessionStorage with the persisted session ID, and is only intended to be used by the Analytics Web Client
 */ parcelHelpers.export(exports, "default", ()=>InteractionSessionTracking);
var _safeSessionStorage = require("./storage/SafeSessionStorage");
var _safeSessionStorageDefault = parcelHelpers.interopDefault(_safeSessionStorage);
const INTERACTION_SESSION_ID_STORAGE_KEY = 'interactionSession.id';
const INTERACTION_SESSION_ID_PREV_STORAGE_KEY = 'interactionSession.id.prev';
const INTERACTION_SESSION_EXPIRY_STORAGE_KEY = 'interactionSession.expiry';
const DEFAULT_SESSION_EXPIRY_TIME_MS = 1800000; // 30 minutes
const DEFAULT_PERSISTED_SESSION_TTL_MS = 86400000; // 24 hours
const DEFAULT_EXPIRY_DEBOUNCE = 5000; // 5 seconds
const DEFAULT_DEBOUNCE_THRESHOLD_PERCENTAGE = 0.9; // 90% of expiry
const INTEGER_REGEX = /^\d+$/;
const INTERACTION_SESSION_ID_UPDATED_EVENT = 'interactionSessionIdUpdated';
class InteractionSessionTracking {
    getCurrentInteractionSessionId() {
        try {
            const { isValidSession, sessionExpiry, sessionId } = this.getCurrentSessionParams();
            // If we have an existing valid session we can return the sessionId straight away
            if (isValidSession) {
                this.debouncedUpdateSessionExpiry(sessionExpiry);
                return sessionId;
            }
            // To generate a new session ID we must ensure analytics is ready
            if (this.analyticsReady) {
                // Session expiry update must occur before generateNewSessionId. Otherwise we were running
                // into issues of calls attempting to read the session ID before a valid expiry had been set
                this.debouncedUpdateSessionExpiry(sessionExpiry);
                return this.generateNewSessionId();
            }
        } catch (err) {
        // Silently swallow exception
        }
        return null;
    }
    getPreviousInteractionSessionId() {
        return this.safeSessionStorage.getItem(INTERACTION_SESSION_ID_PREV_STORAGE_KEY);
    }
    setInteractionSessionId(persistedSessionId) {
        if (this.validateSessionId(persistedSessionId)) {
            const currentSessionId = this.safeSessionStorage.getItem(INTERACTION_SESSION_ID_STORAGE_KEY);
            // If we are already on the required session ID, just return true and make no changes
            // This can happen if the persisted session ID in options is the same as the current session ID
            // We noticed this happening in some cases where Confluence's own URL redirect logic was causing
            // race conditions with our URL stripping, resulting in the same query parameter being processed multiple times
            if (currentSessionId === persistedSessionId) return false;
            // Session expiry update must occur before we fire off the dispatchEvent. Otherwise we were running
            // into issues of the event consumer attempting to read the session ID before a valid expiry had been set
            this.debouncedUpdateSessionExpiry(0);
            this.safeSessionStorage.setItem(INTERACTION_SESSION_ID_STORAGE_KEY, persistedSessionId);
            this.safeSessionStorage.removeItem(INTERACTION_SESSION_ID_PREV_STORAGE_KEY);
            document.dispatchEvent(new Event(INTERACTION_SESSION_ID_UPDATED_EVENT));
            return true;
        }
        return false;
    }
    // Must be called with a valid sendEvent function for other methods to work
    setAnalyticsCallback(sendEventCallback) {
        if (this.analyticsReady) // If we already have a valid callback, don't over-write it
        return;
        if (sendEventCallback && typeof sendEventCallback === 'function') {
            this.sendEventCallback = sendEventCallback;
            this.analyticsReady = true;
        } else this.analyticsReady = false;
    }
    validateSessionId(sessionId) {
        // Check if persisted session ID can parse as valid Unix timestamp
        if (sessionId && INTEGER_REGEX.test(sessionId)) {
            const sessionAge = Date.now() - parseInt(sessionId, 10);
            // Validate that timestamp is not a future time, and is also within the TTL
            if (sessionAge >= 0 && sessionAge <= DEFAULT_PERSISTED_SESSION_TTL_MS) return true;
        }
        return false;
    }
    /*
	 * This function retrieves the current session ID and expiry from SessionStorage
	 * It runs the necessary checks to ensure the session ID is valid and within expiry
	 *
	 * It returns the values along with a `validSession` boolean
	 */ getCurrentSessionParams() {
        const sessionId = this.safeSessionStorage.getItem(INTERACTION_SESSION_ID_STORAGE_KEY);
        const sessionExpiry = parseInt(this.safeSessionStorage.getItem(INTERACTION_SESSION_EXPIRY_STORAGE_KEY) || '0', 10) || 0;
        if (sessionId && !Number.isNaN(sessionExpiry) && sessionExpiry > Date.now()) return {
            isValidSession: true,
            sessionExpiry: sessionExpiry,
            sessionId
        };
        return {
            isValidSession: false,
            sessionExpiry: sessionExpiry,
            sessionId: sessionId
        };
    }
    /*
	 * This function sends a GASv3 analytics event indicating the interaction session has started or renewed
	 * It requires this.sendEventCallback to be set via Analytics Web Client to a valid operational event sender function
	 *
	 * Note that Analytics Web Client's callback function will make its own call to getCurrentInteractionSessionId to retrieve the session ID
	 * to attach to the event, so a valid session ID/expiry must be retrievable from SessionStorage before this function is called to avoid infinite loops.
	 *
	 * This is not an ideal solution but it works with the current architecture of Analytics Web Client.
	 */ sendInteractionSessionEvent(action) {
        this.sendEventCallback && this.sendEventCallback({
            action: action,
            actionSubject: 'interactionSession',
            source: 'interactionComponent',
            tags: [
                'navigationExperiences'
            ]
        });
    }
    constructor(){
        this.analyticsReady = false;
        this.generateNewSessionId = ()=>{
            if (!this.analyticsReady) return null;
            const currentSessionId = this.safeSessionStorage.getItem(INTERACTION_SESSION_ID_STORAGE_KEY);
            const newSessionId = Date.now().toString();
            this.safeSessionStorage.setItem(INTERACTION_SESSION_ID_STORAGE_KEY, newSessionId);
            const { isValidSession } = this.getCurrentSessionParams();
            if (!isValidSession) // If session is not valid at this point, something has gone wrong with Session Storage access
            // Calling sendInteractionSessionEvent now would result in an infinite loop, so we terminate
            return null;
            if (currentSessionId) {
                // Store a copy of the current session ID so we can link sessions if needed
                this.safeSessionStorage.setItem(INTERACTION_SESSION_ID_PREV_STORAGE_KEY, currentSessionId);
                this.sendInteractionSessionEvent('renewed');
            } else this.sendInteractionSessionEvent('started');
            // Event listener is in useCrossProductUrl.tsx to update URL query params
            document.dispatchEvent(new Event(INTERACTION_SESSION_ID_UPDATED_EVENT));
            return newSessionId;
        };
        this.updateSessionExpiry = ()=>{
            const expiry = Date.now() + this.sessionExpiryTime;
            this.safeSessionStorage.setItem(INTERACTION_SESSION_EXPIRY_STORAGE_KEY, expiry.toString());
            return expiry;
        };
        this.debouncedUpdateSessionExpiry = (currentExpiry)=>{
            const { updateSessionExpiry } = this;
            // If the current expiry is out of date by more than 10% of the expiry, update immediately
            if (currentExpiry < Date.now() + this.sessionExpiryDebounceThresholdPercentage * this.sessionExpiryTime) updateSessionExpiry();
            else {
                if (this.sessionExpiryDebounceTimer) clearTimeout(this.sessionExpiryDebounceTimer);
                // @ts-ignore Something wrong with our types... this is legit
                this.sessionExpiryDebounceTimer = setTimeout(()=>{
                    updateSessionExpiry();
                }, this.sessionExpiryDebounce);
            }
        };
        this.sessionExpiryTime = DEFAULT_SESSION_EXPIRY_TIME_MS;
        this.sessionExpiryDebounce = DEFAULT_EXPIRY_DEBOUNCE;
        this.sessionExpiryDebounceThresholdPercentage = DEFAULT_DEBOUNCE_THRESHOLD_PERCENTAGE;
        this.safeSessionStorage = new (0, _safeSessionStorageDefault.default)();
    }
}

},{"./storage/SafeSessionStorage":"9kOxS","@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"9kOxS":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
// eslint-disable-next-line import/no-anonymous-default-export
parcelHelpers.export(exports, "default", ()=>_class);
var _inMemoryStorage = require("./InMemoryStorage");
var _inMemoryStorageDefault = parcelHelpers.interopDefault(_inMemoryStorage);
var _safeStorage = require("./SafeStorage");
var _safeStorageDefault = parcelHelpers.interopDefault(_safeStorage);
class _class extends (0, _safeStorageDefault.default) {
    constructor(options){
        let storageToUse;
        try {
            // eslint-disable-next-line @atlaskit/platform/no-direct-web-storage-usage -- existing usage
            storageToUse = window.sessionStorage || (0, _inMemoryStorageDefault.default);
        } catch (err) {
            storageToUse = (0, _inMemoryStorageDefault.default);
        }
        super(storageToUse, options);
    }
}

},{"./InMemoryStorage":"272y9","./SafeStorage":"fSs5C","@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"272y9":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _inMemoryStore = require("./InMemoryStore");
// eslint-disable-next-line import/no-anonymous-default-export
const inmemorystorage = new (0, _inMemoryStore.InMemoryStore)();
exports.default = inmemorystorage;

},{"./InMemoryStore":"el2Jl","@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"el2Jl":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "InMemoryStore", ()=>InMemoryStore);
class InMemoryStore {
    constructor(){
        this.data = {};
        this.length = 0;
        this.setItem = (key, value)=>{
            this.data[key] = value;
            this.length = Object.keys(this.data).length;
            return value;
        };
        this.getItem = (key)=>{
            if (key in this.data) return this.data[key];
            return null;
        };
        this.removeItem = (key)=>{
            if (key in this.data) delete this.data[key];
            this.length = Object.keys(this.data).length;
            return null;
        };
        this.clear = ()=>{
            this.data = {};
            this.length = 0;
        };
        this.key = (index)=>Object.keys(this.data)[index];
    }
}

},{"@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"fSs5C":[function(require,module,exports,__globalThis) {
/*
 * Code heavily influenced by Segment's Store https://github.com/segmentio/localstorage-retry/blob/master/lib/store.js
 * and Engine https://github.com/segmentio/localstorage-retry/blob/master/lib/engine.js
 * But is not used because it's not public API and is too restrictive in the way it sets keys and does JSON parsing and stringify
 */ var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "AWC_STORAGE_PREFIX", ()=>AWC_STORAGE_PREFIX);
parcelHelpers.export(exports, "GLOBAL_IN_MEMORY_NAME", ()=>GLOBAL_IN_MEMORY_NAME);
parcelHelpers.export(exports, "default", ()=>SafeStorage);
var _envType = require("./envType");
var _inMemoryStorage = require("./InMemoryStorage");
var _inMemoryStorageDefault = parcelHelpers.interopDefault(_inMemoryStorage);
var _isSupported = require("./isSupported");
const AWC_STORAGE_PREFIX = 'awc';
const GLOBAL_IN_MEMORY_NAME = 'awcInMemoryStorageFallback';
class SafeStorage {
    constructor(storageToUse, options = {}){
        this.getStore = ()=>this.store;
        this.getItem = (key)=>this.store.getItem(this.createKey(key));
        this.removeItem = (key)=>this.store.removeItem(this.createKey(key));
        this.setItem = (key, value)=>{
            try {
                this.store.setItem(this.createKey(key), value);
            } catch (err) {
                // Theoretically should only be QuotaExceededError, but keeping 'err' generic
                // https://developer.mozilla.org/en-US/docs/Web/API/Storage/setItem
                this.swapToInMemory();
                this.store.setItem(this.createKey(key), value);
            }
        };
        this.swapToInMemory = ()=>{
            if (this.store === (0, _inMemoryStorageDefault.default) || typeof window === 'undefined') return;
            const keys = Object.keys(this.store || {});
            let inMemoryStorage;
            if ((0, _isSupported.isSupported)(window[GLOBAL_IN_MEMORY_NAME])) inMemoryStorage = window[GLOBAL_IN_MEMORY_NAME];
            else {
                inMemoryStorage = (0, _inMemoryStorageDefault.default);
                if (!window[GLOBAL_IN_MEMORY_NAME]) // If not already attached to window then attach our instance of InMemoryStorage
                // We need to do this because if there are multiple instances of Analytics Client in multiple scopes,
                // there is no way to guarantee the throttling behaviour of the UI viewed event across those instances without a global singleton
                window[GLOBAL_IN_MEMORY_NAME] = (0, _inMemoryStorageDefault.default);
            }
            keys.forEach((key)=>{
                if (key.indexOf(this.getPrefix()) === 0) {
                    const value = this.store.getItem(key);
                    if (value) inMemoryStorage.setItem(key, value);
                }
            });
            this.store = inMemoryStorage;
        };
        this.clear = ()=>this.store.clear();
        this.key = (index)=>this.store.key(index);
        this.getPrefix = ()=>this.prefix;
        this.createKey = (key)=>{
            if (this.prefix) return `${this.getPrefix()}.${key}`;
            return key;
        };
        this.options = options;
        const prefixes = [];
        if (options.useStoragePrefix === undefined || options.useStoragePrefix) prefixes.push(AWC_STORAGE_PREFIX);
        if (options.envPrefix && options.envPrefix !== (0, _envType.envType).PROD) prefixes.push(options.envPrefix);
        this.prefix = prefixes.join('-');
        if ((0, _isSupported.isSupported)(storageToUse)) this.store = storageToUse;
        else this.swapToInMemory();
    }
}

},{"./envType":"9YPN1","./InMemoryStorage":"272y9","./isSupported":"4IEdp","@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"9YPN1":[function(require,module,exports,__globalThis) {
/*
 * Code heavily influenced by Segment's Store https://github.com/segmentio/localstorage-retry/blob/master/lib/store.js
 * and Engine https://github.com/segmentio/localstorage-retry/blob/master/lib/engine.js
 * But is not used because it's not public API and is too restrictive in the way it sets keys and does JSON parsing and stringify
 */ // This type has been converted from frozen objects to enums.
// We cannot change their name, or even capitalise them without breaking API.
var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "envType", ()=>envType);
var envType = /*#__PURE__*/ function(envType) {
    envType["DEV"] = "dev";
    envType["LOCAL"] = "local";
    envType["PROD"] = "prod";
    envType["STAGING"] = "staging";
    return envType;
}({});

},{"@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"4IEdp":[function(require,module,exports,__globalThis) {
/*
 * Code heavily influenced by Segment's Store https://github.com/segmentio/localstorage-retry/blob/master/lib/store.js
 * and Engine https://github.com/segmentio/localstorage-retry/blob/master/lib/engine.js
 * But is not used because it's not public API and is too restrictive in the way it sets keys and does JSON parsing and stringify
 */ var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "isSupported", ()=>isSupported);
function isSupported(store) {
    const TEST_VALUE = 'test_value';
    if (!store) return false;
    try {
        const key = 'awc.storage.support';
        store.setItem(key, TEST_VALUE);
        const value = store.getItem(key);
        store.removeItem(key);
        // handle localStorage silently failing
        return value === TEST_VALUE;
    } catch (e) {
        // Can throw if localStorage is disabled
        return false;
    }
}

},{"@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"6JtCG":[function(require,module,exports,__globalThis) {
// Add products that will participate in cross-product interaction tracking here
// TODO: Down the line this should ideally be synced with ECS product list but that
// will take significant engineering effort
var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "validProducts", ()=>validProducts);
const validProducts = [
    'jira',
    'confluence',
    'townsquare',
    'loom',
    'atlassianStudio',
    'bitbucket',
    'admin'
];

},{"@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"uWT8A":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "URL_QUERY_PARAM_INTERACTION_SESSION", ()=>URL_QUERY_PARAM_INTERACTION_SESSION);
parcelHelpers.export(exports, "generateUrlWithParams", ()=>generateUrlWithParams);
const URL_QUERY_PARAM_INTERACTION_SESSION = 'xpis';
const generateUrlWithParams = (url, bridge, interactionSessionId, product, subProduct)=>{
    const interactionSource = subProduct ? `${product}-${subProduct}` : product;
    const interactionSession = {
        bridge: bridge,
        id: interactionSessionId,
        source: interactionSource
    };
    const paramValueEncoded = btoa(JSON.stringify(interactionSession));
    let partialUrl = false;
    let urlObj;
    // If relative URL provided, add localhost as placeholder base, to be stripped later
    try {
        urlObj = new URL(url);
    } catch (e) {
        urlObj = new URL(url, 'http://localhost/');
        partialUrl = true;
    }
    urlObj.searchParams.set(URL_QUERY_PARAM_INTERACTION_SESSION, paramValueEncoded);
    if (partialUrl) return urlObj.pathname + urlObj.search;
    else return urlObj.toString();
};

},{"@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"END8o":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _react = require("react");
var _frontendFeatureEncoding = require("@atlassiansox/frontend-feature-encoding");
var _bindEventListener = require("bind-event-listener");
var _isFedrampModerate = require("@atlaskit/atlassian-context/is-fedramp-moderate");
var _platformFeatureFlags = require("@atlaskit/platform-feature-flags");
var _analyticsCrossProductInteractionClient = require("./analyticsCrossProductInteractionClient");
var _analyticsCrossProductInteractionClientDefault = parcelHelpers.interopDefault(_analyticsCrossProductInteractionClient);
var _generateUrlWithParams = require("./generateUrlWithParams");
var _interactionSessionTracking = require("./interactionSessionTracking");
// Decides whether the hook should be active for the current runtime.
function computeIsEnabled() {
    const shouldDisable = (0, _platformFeatureFlags.fg)('use_frontend_feature_encoding_sdk_platform') ? !(0, _frontendFeatureEncoding.isFeatureEnabled)('atlassian-analytics', 'atlassian-analytics-cross-product-interaction-client') : (0, _isFedrampModerate.isFedrampModerate)();
    return !shouldDisable;
}
// Module-level identity wrapper used when the hook is disabled. Stable
// identity avoids causing unnecessary re-renders / effect re-runs in
// downstream consumers.
const identityUrlWrapper = (url)=>url;
/**
 * This React hook is called with the correct bridge, product and sub-product parameters.
 * It returns a function that can be used to generate URLs with cross-product interaction parameters.
 *
 * - Lazy-initialises the session id from the client on the very first render,
 *   eliminating the post-mount re-render that re-generated the `xpis` query
 *   param.
 * - Returns a stable, memoised wrapper so consumer effects keyed on it do not
 *   re-run on unrelated re-renders.
 *
 * See PIRA-3829.
 *
 * @param options - Properties object that contains the following parameters:
 *
 * @returns A function that appends interaction session ID and other cross-product interaction parameters to a given URL.
 */ function useCrossProductUrl(options) {
    const { bridge, product, subProduct } = options;
    const isEnabled = computeIsEnabled();
    const interactionSessionClient = (0, _react.useMemo)(()=>{
        if (isEnabled) return new (0, _analyticsCrossProductInteractionClientDefault.default)();
        else return null;
    }, [
        isEnabled
    ]);
    const [interactionSessionId, setInteractionSessionId] = (0, _react.useState)(()=>{
        var _interactionSessionClient_getCurrentInteractionSessionId;
        if (isEnabled && interactionSessionClient) return (_interactionSessionClient_getCurrentInteractionSessionId = interactionSessionClient.getCurrentInteractionSessionId()) !== null && _interactionSessionClient_getCurrentInteractionSessionId !== void 0 ? _interactionSessionClient_getCurrentInteractionSessionId : '';
        return '';
    });
    (0, _react.useEffect)(()=>{
        if (interactionSessionClient && isEnabled) {
            // The lazy useState initializer above already read the session id on the
            // very first render, so we do NOT re-read here — that would cause the
            // avoidable post-mount re-render this fix is removing.
            const unbind = (0, _bindEventListener.bind)(document, {
                type: (0, _interactionSessionTracking.INTERACTION_SESSION_ID_UPDATED_EVENT),
                listener: ()=>{
                    const currentSessionId = interactionSessionClient.getCurrentInteractionSessionId();
                    if (currentSessionId) setInteractionSessionId((prev)=>prev === currentSessionId ? prev : currentSessionId);
                }
            });
            return unbind;
        }
        return ()=>{};
    }, [
        interactionSessionClient,
        isEnabled
    ]);
    const wrapUrl = (0, _react.useCallback)((url)=>(0, _generateUrlWithParams.generateUrlWithParams)(url, bridge, interactionSessionId, product, subProduct), [
        bridge,
        interactionSessionId,
        product,
        subProduct
    ]);
    if (!isEnabled) return identityUrlWrapper;
    return wrapUrl;
}
exports.default = useCrossProductUrl;

},{"react":"ltHCL","@atlassiansox/frontend-feature-encoding":"diVt0","bind-event-listener":"bjeUU","@atlaskit/atlassian-context/is-fedramp-moderate":"e200g","@atlaskit/platform-feature-flags":"8rD2i","./analyticsCrossProductInteractionClient":"3sRlf","./generateUrlWithParams":"uWT8A","./interactionSessionTracking":"jyjs7","@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"bjeUU":[function(require,module,exports,__globalThis) {
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.bindAll = exports.bind = void 0;
var bind_1 = require("1d96ed48d120f8c4");
Object.defineProperty(exports, "bind", {
    enumerable: true,
    get: function() {
        return bind_1.bind;
    }
});
var bind_all_1 = require("2ee15f5ec1b84604");
Object.defineProperty(exports, "bindAll", {
    enumerable: true,
    get: function() {
        return bind_all_1.bindAll;
    }
});

},{"1d96ed48d120f8c4":"lR6mT","2ee15f5ec1b84604":"4qXMW"}],"lR6mT":[function(require,module,exports,__globalThis) {
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.bind = void 0;
function bind(target, _a) {
    var type = _a.type, listener = _a.listener, options = _a.options;
    target.addEventListener(type, listener, options);
    return function unbind() {
        target.removeEventListener(type, listener, options);
    };
}
exports.bind = bind;

},{}],"4qXMW":[function(require,module,exports,__globalThis) {
"use strict";
var __assign = this && this.__assign || function() {
    __assign = Object.assign || function(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.bindAll = void 0;
var bind_1 = require("82e7134afc84a5c5");
function toOptions(value) {
    if (typeof value === 'undefined') return undefined;
    if (typeof value === 'boolean') return {
        capture: value
    };
    return value;
}
function getBinding(original, sharedOptions) {
    if (sharedOptions == null) return original;
    var binding = __assign(__assign({}, original), {
        options: __assign(__assign({}, toOptions(sharedOptions)), toOptions(original.options))
    });
    return binding;
}
function bindAll(target, bindings, sharedOptions) {
    var unbinds = bindings.map(function(original) {
        var binding = getBinding(original, sharedOptions);
        return (0, bind_1.bind)(target, binding);
    });
    return function unbindAll() {
        unbinds.forEach(function(unbind) {
            return unbind();
        });
    };
}
exports.bindAll = bindAll;

},{"82e7134afc84a5c5":"lR6mT"}],"gVcjs":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "defaultHistoryReplaceFn", ()=>defaultHistoryReplaceFn);
var _queryString = require("query-string");
var _objectUtils = require("./objectUtils");
const defaultHistoryReplaceFn = (newUrl)=>window.history.replaceState({}, '', newUrl);
const urlParamExtractor = (isCaptureParam, historyReplaceFn = defaultHistoryReplaceFn)=>{
    // Extract target parameters and values from URL if present
    const originalUrl = window.location.href;
    const fragmentHash = window.location.hash;
    const removedFragmentURL = fragmentHash !== '' ? originalUrl.replace(fragmentHash, '') : originalUrl;
    const { url, query } = (0, _queryString.parseUrl)(removedFragmentURL);
    const captureParams = (0, _objectUtils.pickBy)(query, isCaptureParam);
    // Do not modify URL if no matches
    if (Object.keys(captureParams).length > 0) {
        const queryWithoutCaptureParams = (0, _objectUtils.omitBy)(query, isCaptureParam);
        // Replace the URL minus captured parameters
        if (Object.keys(queryWithoutCaptureParams).length > 0) {
            const newUrl = `${url}?${(0, _queryString.stringify)(queryWithoutCaptureParams)}${fragmentHash}`;
            historyReplaceFn(newUrl);
        } else historyReplaceFn(`${url}${fragmentHash}`);
    }
    return captureParams;
};
// eslint-disable-next-line @atlaskit/volt-strict-mode/no-multiple-exports
exports.default = urlParamExtractor;

},{"query-string":"jcXMO","./objectUtils":"h1ZE7","@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"jcXMO":[function(require,module,exports,__globalThis) {
'use strict';
const strictUriEncode = require("28f2a5db4c2c5f85");
const decodeComponent = require("23b9b0bc871f5d7f");
const splitOnFirst = require("4a6bd761f28c8889");
const filterObject = require("da01a3953af7489c");
const isNullOrUndefined = (value)=>value === null || value === undefined;
const encodeFragmentIdentifier = Symbol('encodeFragmentIdentifier');
function encoderForArrayFormat(options) {
    switch(options.arrayFormat){
        case 'index':
            return (key)=>(result, value)=>{
                    const index = result.length;
                    if (value === undefined || options.skipNull && value === null || options.skipEmptyString && value === '') return result;
                    if (value === null) return [
                        ...result,
                        [
                            encode(key, options),
                            '[',
                            index,
                            ']'
                        ].join('')
                    ];
                    return [
                        ...result,
                        [
                            encode(key, options),
                            '[',
                            encode(index, options),
                            ']=',
                            encode(value, options)
                        ].join('')
                    ];
                };
        case 'bracket':
            return (key)=>(result, value)=>{
                    if (value === undefined || options.skipNull && value === null || options.skipEmptyString && value === '') return result;
                    if (value === null) return [
                        ...result,
                        [
                            encode(key, options),
                            '[]'
                        ].join('')
                    ];
                    return [
                        ...result,
                        [
                            encode(key, options),
                            '[]=',
                            encode(value, options)
                        ].join('')
                    ];
                };
        case 'colon-list-separator':
            return (key)=>(result, value)=>{
                    if (value === undefined || options.skipNull && value === null || options.skipEmptyString && value === '') return result;
                    if (value === null) return [
                        ...result,
                        [
                            encode(key, options),
                            ':list='
                        ].join('')
                    ];
                    return [
                        ...result,
                        [
                            encode(key, options),
                            ':list=',
                            encode(value, options)
                        ].join('')
                    ];
                };
        case 'comma':
        case 'separator':
        case 'bracket-separator':
            {
                const keyValueSep = options.arrayFormat === 'bracket-separator' ? '[]=' : '=';
                return (key)=>(result, value)=>{
                        if (value === undefined || options.skipNull && value === null || options.skipEmptyString && value === '') return result;
                        // Translate null to an empty string so that it doesn't serialize as 'null'
                        value = value === null ? '' : value;
                        if (result.length === 0) return [
                            [
                                encode(key, options),
                                keyValueSep,
                                encode(value, options)
                            ].join('')
                        ];
                        return [
                            [
                                result,
                                encode(value, options)
                            ].join(options.arrayFormatSeparator)
                        ];
                    };
            }
        default:
            return (key)=>(result, value)=>{
                    if (value === undefined || options.skipNull && value === null || options.skipEmptyString && value === '') return result;
                    if (value === null) return [
                        ...result,
                        encode(key, options)
                    ];
                    return [
                        ...result,
                        [
                            encode(key, options),
                            '=',
                            encode(value, options)
                        ].join('')
                    ];
                };
    }
}
function parserForArrayFormat(options) {
    let result;
    switch(options.arrayFormat){
        case 'index':
            return (key, value, accumulator)=>{
                result = /\[(\d*)\]$/.exec(key);
                key = key.replace(/\[\d*\]$/, '');
                if (!result) {
                    accumulator[key] = value;
                    return;
                }
                if (accumulator[key] === undefined) accumulator[key] = {};
                accumulator[key][result[1]] = value;
            };
        case 'bracket':
            return (key, value, accumulator)=>{
                result = /(\[\])$/.exec(key);
                key = key.replace(/\[\]$/, '');
                if (!result) {
                    accumulator[key] = value;
                    return;
                }
                if (accumulator[key] === undefined) {
                    accumulator[key] = [
                        value
                    ];
                    return;
                }
                accumulator[key] = [].concat(accumulator[key], value);
            };
        case 'colon-list-separator':
            return (key, value, accumulator)=>{
                result = /(:list)$/.exec(key);
                key = key.replace(/:list$/, '');
                if (!result) {
                    accumulator[key] = value;
                    return;
                }
                if (accumulator[key] === undefined) {
                    accumulator[key] = [
                        value
                    ];
                    return;
                }
                accumulator[key] = [].concat(accumulator[key], value);
            };
        case 'comma':
        case 'separator':
            return (key, value, accumulator)=>{
                const isArray = typeof value === 'string' && value.includes(options.arrayFormatSeparator);
                const isEncodedArray = typeof value === 'string' && !isArray && decode(value, options).includes(options.arrayFormatSeparator);
                value = isEncodedArray ? decode(value, options) : value;
                const newValue = isArray || isEncodedArray ? value.split(options.arrayFormatSeparator).map((item)=>decode(item, options)) : value === null ? value : decode(value, options);
                accumulator[key] = newValue;
            };
        case 'bracket-separator':
            return (key, value, accumulator)=>{
                const isArray = /(\[\])$/.test(key);
                key = key.replace(/\[\]$/, '');
                if (!isArray) {
                    accumulator[key] = value ? decode(value, options) : value;
                    return;
                }
                const arrayValue = value === null ? [] : value.split(options.arrayFormatSeparator).map((item)=>decode(item, options));
                if (accumulator[key] === undefined) {
                    accumulator[key] = arrayValue;
                    return;
                }
                accumulator[key] = [].concat(accumulator[key], arrayValue);
            };
        default:
            return (key, value, accumulator)=>{
                if (accumulator[key] === undefined) {
                    accumulator[key] = value;
                    return;
                }
                accumulator[key] = [].concat(accumulator[key], value);
            };
    }
}
function validateArrayFormatSeparator(value) {
    if (typeof value !== 'string' || value.length !== 1) throw new TypeError('arrayFormatSeparator must be single character string');
}
function encode(value, options) {
    if (options.encode) return options.strict ? strictUriEncode(value) : encodeURIComponent(value);
    return value;
}
function decode(value, options) {
    if (options.decode) return decodeComponent(value);
    return value;
}
function keysSorter(input) {
    if (Array.isArray(input)) return input.sort();
    if (typeof input === 'object') return keysSorter(Object.keys(input)).sort((a, b)=>Number(a) - Number(b)).map((key)=>input[key]);
    return input;
}
function removeHash(input) {
    const hashStart = input.indexOf('#');
    if (hashStart !== -1) input = input.slice(0, hashStart);
    return input;
}
function getHash(url) {
    let hash = '';
    const hashStart = url.indexOf('#');
    if (hashStart !== -1) hash = url.slice(hashStart);
    return hash;
}
function extract(input) {
    input = removeHash(input);
    const queryStart = input.indexOf('?');
    if (queryStart === -1) return '';
    return input.slice(queryStart + 1);
}
function parseValue(value, options) {
    if (options.parseNumbers && !Number.isNaN(Number(value)) && typeof value === 'string' && value.trim() !== '') value = Number(value);
    else if (options.parseBooleans && value !== null && (value.toLowerCase() === 'true' || value.toLowerCase() === 'false')) value = value.toLowerCase() === 'true';
    return value;
}
function parse(query, options) {
    options = Object.assign({
        decode: true,
        sort: true,
        arrayFormat: 'none',
        arrayFormatSeparator: ',',
        parseNumbers: false,
        parseBooleans: false
    }, options);
    validateArrayFormatSeparator(options.arrayFormatSeparator);
    const formatter = parserForArrayFormat(options);
    // Create an object with no prototype
    const ret = Object.create(null);
    if (typeof query !== 'string') return ret;
    query = query.trim().replace(/^[?#&]/, '');
    if (!query) return ret;
    for (const param of query.split('&')){
        if (param === '') continue;
        let [key, value] = splitOnFirst(options.decode ? param.replace(/\+/g, ' ') : param, '=');
        // Missing `=` should be `null`:
        // http://w3.org/TR/2012/WD-url-20120524/#collect-url-parameters
        value = value === undefined ? null : [
            'comma',
            'separator',
            'bracket-separator'
        ].includes(options.arrayFormat) ? value : decode(value, options);
        formatter(decode(key, options), value, ret);
    }
    for (const key of Object.keys(ret)){
        const value = ret[key];
        if (typeof value === 'object' && value !== null) for (const k of Object.keys(value))value[k] = parseValue(value[k], options);
        else ret[key] = parseValue(value, options);
    }
    if (options.sort === false) return ret;
    return (options.sort === true ? Object.keys(ret).sort() : Object.keys(ret).sort(options.sort)).reduce((result, key)=>{
        const value = ret[key];
        if (Boolean(value) && typeof value === 'object' && !Array.isArray(value)) // Sort object keys, not values
        result[key] = keysSorter(value);
        else result[key] = value;
        return result;
    }, Object.create(null));
}
exports.extract = extract;
exports.parse = parse;
exports.stringify = (object, options)=>{
    if (!object) return '';
    options = Object.assign({
        encode: true,
        strict: true,
        arrayFormat: 'none',
        arrayFormatSeparator: ','
    }, options);
    validateArrayFormatSeparator(options.arrayFormatSeparator);
    const shouldFilter = (key)=>options.skipNull && isNullOrUndefined(object[key]) || options.skipEmptyString && object[key] === '';
    const formatter = encoderForArrayFormat(options);
    const objectCopy = {};
    for (const key of Object.keys(object))if (!shouldFilter(key)) objectCopy[key] = object[key];
    const keys = Object.keys(objectCopy);
    if (options.sort !== false) keys.sort(options.sort);
    return keys.map((key)=>{
        const value = object[key];
        if (value === undefined) return '';
        if (value === null) return encode(key, options);
        if (Array.isArray(value)) {
            if (value.length === 0 && options.arrayFormat === 'bracket-separator') return encode(key, options) + '[]';
            return value.reduce(formatter(key), []).join('&');
        }
        return encode(key, options) + '=' + encode(value, options);
    }).filter((x)=>x.length > 0).join('&');
};
exports.parseUrl = (url, options)=>{
    options = Object.assign({
        decode: true
    }, options);
    const [url_, hash] = splitOnFirst(url, '#');
    return Object.assign({
        url: url_.split('?')[0] || '',
        query: parse(extract(url), options)
    }, options && options.parseFragmentIdentifier && hash ? {
        fragmentIdentifier: decode(hash, options)
    } : {});
};
exports.stringifyUrl = (object, options)=>{
    options = Object.assign({
        encode: true,
        strict: true,
        [encodeFragmentIdentifier]: true
    }, options);
    const url = removeHash(object.url).split('?')[0] || '';
    const queryFromUrl = exports.extract(object.url);
    const parsedQueryFromUrl = exports.parse(queryFromUrl, {
        sort: false
    });
    const query = Object.assign(parsedQueryFromUrl, object.query);
    let queryString = exports.stringify(query, options);
    if (queryString) queryString = `?${queryString}`;
    let hash = getHash(object.url);
    if (object.fragmentIdentifier) hash = `#${options[encodeFragmentIdentifier] ? encode(object.fragmentIdentifier, options) : object.fragmentIdentifier}`;
    return `${url}${queryString}${hash}`;
};
exports.pick = (input, filter, options)=>{
    options = Object.assign({
        parseFragmentIdentifier: true,
        [encodeFragmentIdentifier]: false
    }, options);
    const { url, query, fragmentIdentifier } = exports.parseUrl(input, options);
    return exports.stringifyUrl({
        url,
        query: filterObject(query, filter),
        fragmentIdentifier
    }, options);
};
exports.exclude = (input, filter, options)=>{
    const exclusionFilter = Array.isArray(filter) ? (key)=>!filter.includes(key) : (key, value)=>!filter(key, value);
    return exports.pick(input, exclusionFilter, options);
};

},{"28f2a5db4c2c5f85":"f2Q8t","23b9b0bc871f5d7f":"a7KiN","4a6bd761f28c8889":"hJbUR","da01a3953af7489c":"iYIt6"}],"f2Q8t":[function(require,module,exports,__globalThis) {
'use strict';
module.exports = (str)=>encodeURIComponent(str).replace(/[!'()*]/g, (x)=>`%${x.charCodeAt(0).toString(16).toUpperCase()}`);

},{}],"a7KiN":[function(require,module,exports,__globalThis) {
'use strict';
var token = '%[a-f0-9]{2}';
var singleMatcher = new RegExp('(' + token + ')|([^%]+?)', 'gi');
var multiMatcher = new RegExp('(' + token + ')+', 'gi');
function decodeComponents(components, split) {
    try {
        // Try to decode the entire string first
        return [
            decodeURIComponent(components.join(''))
        ];
    } catch (err) {
    // Do nothing
    }
    if (components.length === 1) return components;
    split = split || 1;
    // Split the array in 2 parts
    var left = components.slice(0, split);
    var right = components.slice(split);
    return Array.prototype.concat.call([], decodeComponents(left), decodeComponents(right));
}
function decode(input) {
    try {
        return decodeURIComponent(input);
    } catch (err) {
        var tokens = input.match(singleMatcher) || [];
        for(var i = 1; i < tokens.length; i++){
            input = decodeComponents(tokens, i).join('');
            tokens = input.match(singleMatcher) || [];
        }
        return input;
    }
}
function customDecodeURIComponent(input) {
    // Keep track of all the replacements and prefill the map with the `BOM`
    var replaceMap = {
        '%FE%FF': '\uFFFD\uFFFD',
        '%FF%FE': '\uFFFD\uFFFD'
    };
    var match = multiMatcher.exec(input);
    while(match){
        try {
            // Decode as big chunks as possible
            replaceMap[match[0]] = decodeURIComponent(match[0]);
        } catch (err) {
            var result = decode(match[0]);
            if (result !== match[0]) replaceMap[match[0]] = result;
        }
        match = multiMatcher.exec(input);
    }
    // Add `%C2` at the end of the map to make sure it does not replace the combinator before everything else
    replaceMap['%C2'] = '\uFFFD';
    var entries = Object.keys(replaceMap);
    for(var i = 0; i < entries.length; i++){
        // Replace all decoded components
        var key = entries[i];
        input = input.replace(new RegExp(key, 'g'), replaceMap[key]);
    }
    return input;
}
module.exports = function(encodedURI) {
    if (typeof encodedURI !== 'string') throw new TypeError('Expected `encodedURI` to be of type `string`, got `' + typeof encodedURI + '`');
    try {
        encodedURI = encodedURI.replace(/\+/g, ' ');
        // Try the built in decoder first
        return decodeURIComponent(encodedURI);
    } catch (err) {
        // Fallback to a more advanced decoder
        return customDecodeURIComponent(encodedURI);
    }
};

},{}],"hJbUR":[function(require,module,exports,__globalThis) {
'use strict';
module.exports = (string, separator)=>{
    if (!(typeof string === 'string' && typeof separator === 'string')) throw new TypeError('Expected the arguments to be of type `string`');
    if (separator === '') return [
        string
    ];
    const separatorIndex = string.indexOf(separator);
    if (separatorIndex === -1) return [
        string
    ];
    return [
        string.slice(0, separatorIndex),
        string.slice(separatorIndex + separator.length)
    ];
};

},{}],"iYIt6":[function(require,module,exports,__globalThis) {
'use strict';
module.exports = function(obj, predicate) {
    var ret = {};
    var keys = Object.keys(obj);
    var isArr = Array.isArray(predicate);
    for(var i = 0; i < keys.length; i++){
        var key = keys[i];
        var val = obj[key];
        if (isArr ? predicate.indexOf(key) !== -1 : predicate(key, val, obj)) ret[key] = val;
    }
    return ret;
};

},{}],"h1ZE7":[function(require,module,exports,__globalThis) {
/* eslint-disable no-return-assign, no-sequences */ var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
// eslint-disable-next-line @atlaskit/volt-strict-mode/no-multiple-exports
parcelHelpers.export(exports, "mapKeys", ()=>mapKeys);
parcelHelpers.export(exports, "pick", ()=>pick);
parcelHelpers.export(exports, "pickBy", ()=>pickBy);
parcelHelpers.export(exports, "omitBy", ()=>omitBy);
parcelHelpers.export(exports, "omit", ()=>omit);
parcelHelpers.export(exports, "equals", ()=>equals);
parcelHelpers.export(exports, "partition", ()=>partition);
// https://www.30secondsofcode.org/js/s/map-keys
const mapKeys = (obj, fn)=>Object.keys(obj).reduce((acc, k)=>{
        const key = fn(obj[k], k, obj);
        acc[key] = obj[k];
        return acc;
    }, {});
// https://www.30secondsofcode.org/js/s/pick
const pick = (obj, arr)=>arr.reduce((acc, curr)=>(curr in obj && (acc[curr] = obj[curr]), acc), {});
// https://www.30secondsofcode.org/js/s/omit-by
const omitBy = (obj, fn)=>Object.keys(obj).filter((k)=>!fn(obj[k], k)).reduce((acc, key)=>(acc[key] = obj[key], acc), {});
// https://www.30secondsofcode.org/js/s/pick-by
const pickBy = (obj, fn)=>Object.keys(obj).filter((k)=>fn(obj[k], k)).reduce((acc, key)=>(acc[key] = obj[key], acc), {});
// https://www.30secondsofcode.org/js/s/omit
const omit = (obj, arr)=>Object.keys(obj).filter((k)=>arr.indexOf(k) < 0).reduce((acc, key)=>(acc[key] = obj[key], acc), {});
// https://www.30secondsofcode.org/js/s/equals
const equals = (a, b)=>{
    if (a === b) return true;
    if (a instanceof Date && b instanceof Date) return a.getTime() === b.getTime();
    if (!a || !b || typeof a !== 'object' && typeof b !== 'object') return a === b;
    if (a.prototype !== b.prototype) return false;
    const keys = Object.keys(a);
    if (keys.length !== Object.keys(b).length) return false;
    return keys.every((k)=>equals(a[k], b[k]));
};
// https://www.30secondsofcode.org/js/s/partition
const partition = (arr, fn)=>arr.reduce(// eslint-disable-next-line no-shadow
    (acc, val, i, arr)=>{
        acc[fn(val, i, arr) ? 0 : 1].push(val);
        return acc;
    }, [
        [],
        []
    ]);

},{"@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"jVtFN":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "isFirstParty", ()=>isFirstParty);
parcelHelpers.export(exports, "isThirdParty", ()=>isThirdParty);
var _analyticsWebTypes = require("./analyticsWebTypes");
const isFirstParty = (input)=>{
    return input.embeddedType === (0, _analyticsWebTypes.productEmbedType).FIRST_PARTY && input.embeddedFromProduct !== undefined;
};
const isThirdParty = (input)=>{
    return input.embeddedType === (0, _analyticsWebTypes.productEmbedType).THIRD_PARTY && input.embeddedFromTopLevelDomain !== undefined;
};

},{"./analyticsWebTypes":"183Xd","@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"jZ9BF":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "filterAndBuildContainers", ()=>filterAndBuildContainers);
// eslint-disable-next-line @atlaskit/volt-strict-mode/no-multiple-exports
parcelHelpers.export(exports, "buildContainersWithName", ()=>buildContainersWithName);
// eslint-disable-next-line @atlaskit/volt-strict-mode/no-multiple-exports
parcelHelpers.export(exports, "buildActionFields", ()=>buildActionFields);
// eslint-disable-next-line @atlaskit/volt-strict-mode/no-multiple-exports
parcelHelpers.export(exports, "buildScreenEvent", ()=>buildScreenEvent);
// eslint-disable-next-line @atlaskit/volt-strict-mode/no-multiple-exports
parcelHelpers.export(exports, "buildActionName", ()=>buildActionName);
parcelHelpers.export(exports, "validationMode", ()=>validationMode);
// eslint-disable-next-line @atlaskit/volt-strict-mode/no-multiple-exports
parcelHelpers.export(exports, "buildContext", ()=>buildContext);
// eslint-disable-next-line @atlaskit/volt-strict-mode/no-multiple-exports
parcelHelpers.export(exports, "extractProductOverrides", ()=>extractProductOverrides);
// eslint-disable-next-line @atlaskit/volt-strict-mode/no-multiple-exports
parcelHelpers.export(exports, "buildActionEvent", ()=>buildActionEvent);
var _objectSpread = require("@swc/helpers/_/_object_spread");
var _objectSpreadProps = require("@swc/helpers/_/_object_spread_props");
var _analyticsWebTypes = require("./analyticsWebTypes");
var _objectUtils = require("./util/object-utils");
const libraryVersion = "0.16.1";
function buildTenantFields(tenantInfo) {
    return {
        tenantIdType: tenantInfo.tenantIdType,
        tenantId: tenantInfo.tenantId
    };
}
function buildUserFields(userInfo) {
    return {
        userIdType: userInfo.userIdType
    };
}
function buildOrgFields(orgInfo) {
    return {
        orgId: orgInfo.orgId
    };
}
function buildWorkspaceFields(workspaceInfo) {
    return {
        workspaceId: workspaceInfo.workspaceId
    };
}
function buildCollaborationContextFields(collaborationContextInfo) {
    return {
        collaborationContextAri: collaborationContextInfo.collaborationContextAri
    };
}
function buildAliases(aliases) {
    if (isNotEmptyObject(aliases)) return {
        aliases: aliases
    };
    return undefined;
}
function buildGroups(groups) {
    if (isNotEmptyObject(groups)) return {
        groups: groups
    };
    return undefined;
}
function buildEventOverrides(event) {
    let result = {};
    if (event.anonymousId) result.anonymousId = event.anonymousId;
    if (event.excludedProperties) result.excludedProperties = event.excludedProperties;
    if (event.userConsents) result.userConsents = event.userConsents;
    return result;
}
function getProductField(field, override) {
    return override === undefined ? field : override;
}
function buildProductFields(productInfo, productOverrides) {
    const overrides = productOverrides || {};
    const env = getProductField(productInfo.env, overrides.env);
    const product = getProductField(productInfo.product, overrides.product);
    const subproduct = getProductField(productInfo.subproduct(), overrides.subproduct);
    const version = getProductField(productInfo.version, overrides.version);
    const origin = getProductField(productInfo.origin, overrides.origin);
    const platform = getProductField(productInfo.platform, overrides.platform);
    const ic = productInfo.ic; // ic should not be overriden once set
    const cdp = productInfo.cdp;
    const csp = productInfo.csp;
    return {
        env,
        product,
        subproduct,
        version,
        origin,
        platform,
        ic,
        cdp,
        csp
    };
}
function isNotEmptyObject(obj) {
    return (0, _objectUtils.isPlainObject)(obj) && Object.keys(obj).length > 0;
}
function buildAttributesWithName(name, attrObject) {
    return isNotEmptyObject(attrObject) ? {
        [name]: attrObject
    } : undefined;
}
function buildAttributes(attributes) {
    return buildAttributesWithName('attributes', attributes);
}
function filterAndBuildContainers(containers) {
    const validContainers = {};
    Object.keys(containers).forEach((key)=>{
        const value = containers[key];
        validContainers[key] = {
            id: value.id,
            type: value.type
        };
    });
    return validContainers;
}
function buildContainersWithName(containers) {
    if (isNotEmptyObject(containers)) {
        const validContainers = filterAndBuildContainers(containers);
        return buildAttributesWithName('containers', validContainers);
    }
    return undefined;
}
function buildActionFields(event, actionEventType) {
    return (0, _objectSpread._)({
        containerType: event.containerType,
        containerId: event.containerId,
        source: event.source,
        objectType: event.objectType,
        objectId: event.objectId,
        actionSubject: event.actionSubject,
        action: event.action,
        actionSubjectId: event.actionSubjectId,
        attributes: event.attributes,
        nonPrivacySafeAttributes: event.nonPrivacySafeAttributes,
        tags: event.tags,
        highPriority: event.highPriority,
        eventType: actionEventType
    }, buildContainersWithName(event.containers));
}
function buildNonPrivacySafeAttributes(nonPrivacySafeAttributes) {
    return buildAttributesWithName('nonPrivacySafeAttributes', nonPrivacySafeAttributes);
}
function buildScreenEvent(productInfo, tenantInfo, userInfo, attributes, nonPrivacySafeAttributes, tags, tabId, sessionId, taskSessions, interactionSession, orgInfo, pageLoadId, workspaceInfo, collaborationContextInfo, event, containers, aliases, groups) {
    const productFields = buildProductFields(productInfo);
    const tenantFields = buildTenantFields(tenantInfo);
    const userFields = buildUserFields(userInfo);
    const orgFields = buildOrgFields(orgInfo);
    const workspaceFields = buildWorkspaceFields(workspaceInfo);
    const collaborationContextFields = buildCollaborationContextFields(collaborationContextInfo);
    const overrides = {
        title: '',
        path: '',
        url: '',
        referrer: '',
        search: '',
        eventType: (0, _analyticsWebTypes.eventType).SCREEN
    };
    return (0, _objectSpread._)((0, _objectSpreadProps._)((0, _objectSpread._)({}, productFields, tenantFields, userFields, orgFields, overrides, buildAttributes(attributes), buildNonPrivacySafeAttributes(nonPrivacySafeAttributes), buildContainersWithName(containers), buildEventOverrides(event)), {
        tags,
        tabId,
        sessionId,
        taskSessions,
        interactionSession,
        pageLoadId
    }), workspaceFields, collaborationContextFields, buildAliases(aliases), buildGroups(groups));
}
function buildActionName(event) {
    return `${event.actionSubject} ${event.action}`;
}
var validationMode = /*#__PURE__*/ function(validationMode) {
    validationMode["QUIET"] = "quiet";
    validationMode["STANDARD"] = "standard";
    validationMode["COMPLETE"] = "complete";
    return validationMode;
}({});
function getDefaultValidationMode(productInfo) {
    const environment = productInfo.env;
    if (environment === undefined) return "quiet";
    if (environment.includes('prod')) return "quiet";
    return "complete";
}
function buildContext(productInfo) {
    const screen = window.screen || {};
    return {
        context: {
            locale: productInfo.locale,
            screen: {
                width: screen.width,
                height: screen.height,
                density: window.devicePixelRatio
            },
            library: {
                name: 'analytics.js',
                version: libraryVersion
            },
            validationMode: getDefaultValidationMode(productInfo)
        }
    };
}
function extractProductOverrides(event) {
    const { env, product, subproduct, version, origin, platform } = event;
    return {
        env,
        product,
        subproduct,
        version,
        origin,
        platform
    };
}
function buildActionEvent(productInfo, tenantInfo, userInfo, event, actionEventType, tabId, sessionId, taskSessions, interactionSession, orgInfo, pageLoadId, workspaceInfo, collaborationContextInfo, aliases, groups) {
    const productFields = buildProductFields(productInfo, extractProductOverrides(event));
    const tenantFields = buildTenantFields(tenantInfo);
    const orgFields = buildOrgFields(orgInfo);
    const workspaceFields = buildWorkspaceFields(workspaceInfo);
    const collaborationContextFields = buildCollaborationContextFields(collaborationContextInfo);
    const userFields = buildUserFields(userInfo);
    const actionFields = buildActionFields(event, actionEventType);
    return (0, _objectSpread._)((0, _objectSpreadProps._)((0, _objectSpread._)({}, productFields, tenantFields, orgFields, userFields, actionFields, buildEventOverrides(event)), {
        tabId,
        sessionId,
        taskSessions,
        interactionSession,
        pageLoadId
    }), workspaceFields, collaborationContextFields, buildAliases(aliases), buildGroups(groups));
}

},{"@swc/helpers/_/_object_spread":"9gdrV","@swc/helpers/_/_object_spread_props":"kANqQ","./analyticsWebTypes":"183Xd","./util/object-utils":"3lQxz","@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"3lQxz":[function(require,module,exports,__globalThis) {
// Modified from https://github.com/jonschlinkert/is-plain-object/blob/master/index.js
var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "isPlainObject", ()=>// eslint-disable-next-line import/prefer-default-export
    isPlainObject);
function isObject(val) {
    return val !== null && typeof val === 'object' && Array.isArray(val) === false;
}
function isObjectObject(o) {
    return isObject(o) === true && Object.prototype.toString.call(o) === '[object Object]';
}
function isPlainObject(o) {
    if (isObjectObject(o) === false) return false;
    // If has modified constructor
    const ctor = o.constructor;
    if (typeof ctor !== 'function') return false;
    // If has modified prototype
    const prot = ctor.prototype;
    if (isObjectObject(prot) === false) return false;
    // If constructor does not have an Object-specific method
    if (!('isPrototypeOf' in prot)) return false;
    // Most likely a plain Object
    return true;
}

},{"@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"03cT6":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "CompressionRule", ()=>(0, _compressionRule.CompressionRule));
parcelHelpers.export(exports, "default", ()=>(0, _eventDelayCoordinatorDefault.default));
parcelHelpers.export(exports, "StopLowPriorityEventDelayReason", ()=>(0, _types.StopLowPriorityEventDelayReason));
var _compressionRule = require("./compressionRule");
var _eventDelayCoordinator = require("./eventDelayCoordinator");
var _eventDelayCoordinatorDefault = parcelHelpers.interopDefault(_eventDelayCoordinator);
var _types = require("./types");

},{"./compressionRule":false,"./eventDelayCoordinator":"K8neJ","./types":false,"@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"2Rs3G":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "CompressionRule", ()=>CompressionRule);
var _eventValidation = require("../eventValidation");
var _objectUtils = require("../objectUtils");
class CompressionRule {
    /**
	 * @callback EventPredicate
	 * @param {object} event An analytics event
	 * @returns {boolean} A flag indicating whether or not the event matches the conditions
	 */ /**
	 * @callback CompressionFunction
	 * @param {Array.<Object>} events A collection of analytics events that match the predicate of this compression rule
	 * @returns {Array.<Object>} compressedEvents The compressed analytics events to fire
	 */ /**
	 * This constructor defines a new rule for compressing analytics events.
	 * @param {EventPredicate} predicate
	 * @param {CompressionFunction} compressFn
	 */ constructor(predicate, compressFn){
        /**
	 * This function returns a flag indicating whether or not this instance is capable of compressing the given event.
	 * @param event
	 * @returns {boolean}
	 */ this.canCompress = (event)=>{
            try {
                return event && (0, _eventValidation.isActionEventType)(event.eventType) && this.predicate(event);
            } catch (e) {
                return false;
            }
        };
        /**
	 * This function compresses as many events in the given collection as possible.<p>
	 * Any events in the given collection that do not match the conditions of {@link canCompress} will be left uncompressed and
	 * appended to the end of the resulting array.
	 *
	 * @param events A collection of analytic events to compress
	 * @returns {Array.<Object>} The action fields for the resulting compressed events
	 */ this.compress = (events)=>{
            const [compatibleEvents, incompatibleEvents] = (0, _objectUtils.partition)(events, (event)=>this.canCompress(event));
            const compressedEvents = this.compressFn(compatibleEvents);
            if (!compressedEvents) throw new Error('No events were returned from the compression function');
            compressedEvents.forEach((event)=>{
                (0, _eventValidation.validateActionEventType)(event.eventType);
                (0, _eventValidation.validateActionEvent)(event);
            });
            return compressedEvents.concat(incompatibleEvents);
        };
        if (typeof predicate !== 'function') throw new Error('Invalid predicate, must be a function that accepts an event and returns a boolean');
        if (typeof compressFn !== 'function') throw new Error('Invalid compressFn, must be a function that both accepts and returns an array of events');
        this.predicate = predicate;
        this.compressFn = compressFn;
    }
}

},{"../eventValidation":"fTZkK","../objectUtils":"h1ZE7","@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"fTZkK":[function(require,module,exports,__globalThis) {
/* eslint-disable @atlaskit/volt-strict-mode/no-multiple-exports */ var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "validateContainersObject", ()=>validateContainersObject);
// the validation logic is documented here
// https://hello.atlassian.net/wiki/spaces/MEASURE/pages/545900273/Validating+containers+object
parcelHelpers.export(exports, "validateContainers", ()=>validateContainers);
parcelHelpers.export(exports, "isActionEventType", ()=>isActionEventType);
parcelHelpers.export(exports, "validateActionEventType", ()=>validateActionEventType);
parcelHelpers.export(exports, "validateActionEvent", ()=>validateActionEvent);
parcelHelpers.export(exports, "validateScreenEvent", ()=>validateScreenEvent);
parcelHelpers.export(exports, "validateTrackEvent", ()=>validateTrackEvent);
parcelHelpers.export(exports, "validateDwellBaseEvent", ()=>validateDwellBaseEvent);
parcelHelpers.export(exports, "validateUIEvent", ()=>validateUIEvent);
parcelHelpers.export(exports, "validateOperationalEvent", ()=>validateOperationalEvent);
parcelHelpers.export(exports, "validateIdentifyEvent", ()=>validateIdentifyEvent);
parcelHelpers.export(exports, "validatePlatform", ()=>validatePlatform);
var _analyticsWebTypes = require("./analyticsWebTypes");
var _objectUtils = require("./util/object-utils");
const actionEventTypes = Object.freeze([
    (0, _analyticsWebTypes.eventType).OPERATIONAL,
    (0, _analyticsWebTypes.eventType).TRACK,
    (0, _analyticsWebTypes.eventType).UI
]);
function validateContainersObject(container) {
    if (!(0, _objectUtils.isPlainObject)(container)) throw new Error('properties.containers must be an Object');
    if (!('id' in container)) throw new Error("properties.containers is missing field 'id'");
    if (typeof container.id !== 'string') throw new Error('properties.containers.id must be of type String');
    if ('type' in container && typeof container.type !== 'string') throw new Error('properties.containers.type must be of type String');
}
function validateContainers(containers) {
    if (!containers) return;
    if (containers && containers.constructor !== Object) throw new Error('properties.containers must be an Object');
    Object.values(containers).forEach((container)=>validateContainersObject(container));
}
function isActionEventType(type) {
    switch(type){
        case (0, _analyticsWebTypes.eventType).OPERATIONAL:
        case (0, _analyticsWebTypes.eventType).TRACK:
        case (0, _analyticsWebTypes.eventType).UI:
            return true;
        default:
            return false;
    }
}
function validateActionEventType(type) {
    if (!isActionEventType(type)) throw new Error(`Invalid action event type: ${type}, must be one of: [${actionEventTypes}]`);
    return true;
}
function validateActionEvent(event) {
    if (!event) throw new Error('Missing event');
    if (!event.source) throw new Error('Missing event.source');
    if (!event.actionSubject) throw new Error('Missing event.actionSubject');
    if (!event.action) throw new Error('Missing event.action');
    validateContainers(event.containers);
}
function validateScreenEvent(name) {
    if (!name) throw new Error('Missing name');
}
function validateTrackEvent(event) {
    validateActionEvent(event);
}
function validateDwellBaseEvent(event) {
    if (!event) throw new Error('Missing event');
    if (!event.source) throw new Error('Missing event.source');
    if (!event.actionSubject) throw new Error('Missing event.actionSubject');
}
function validateUIEvent(event) {
    validateActionEvent(event);
}
function validateOperationalEvent(event) {
    validateActionEvent(event);
}
function validateIdentifyEvent(userIdType, userId) {
    if (!userIdType) throw new Error('Missing userIdType');
    if (!userId) throw new Error('Missing userId');
    if (!(0, _analyticsWebTypes.isType)((0, _analyticsWebTypes.userType), userIdType)) throw new Error(`Invalid userIdType '${userIdType}', ` + `must be an userType: [${(0, _analyticsWebTypes.objectValues)((0, _analyticsWebTypes.userType))}]`);
}
function validatePlatform(productInfo) {
    if (!(0, _analyticsWebTypes.isType)((0, _analyticsWebTypes.platformType), productInfo.platform)) throw new Error(`Invalid productInfo.platform '${productInfo.platform}', ` + `must be a platformType: [${(0, _analyticsWebTypes.objectValues)((0, _analyticsWebTypes.platformType))}]`);
    if (productInfo.origin === (0, _analyticsWebTypes.originType).DESKTOP && !(0, _analyticsWebTypes.isType)((0, _analyticsWebTypes.desktopPlatforms), productInfo.platform)) throw new Error(`Invalid productInfo.platform '${productInfo.platform}', ` + 'must be one of [mac, linux, windows]');
    if (productInfo.origin === (0, _analyticsWebTypes.originType).WEB && !(0, _analyticsWebTypes.isType)((0, _analyticsWebTypes.webPlatforms), productInfo.platform)) throw new Error(`Invalid productInfo.platform '${productInfo.platform}', must be one of [web, mobileWeb]`);
}

},{"./analyticsWebTypes":"183Xd","./util/object-utils":"3lQxz","@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"K8neJ":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>EventDelayCoordinator);
var _defaults = require("./defaults");
var _eventDelayQueue = require("./eventDelayQueue");
var _eventDelayQueueDefault = parcelHelpers.interopDefault(_eventDelayQueue);
var _types = require("./types");
class EventDelayCoordinator {
    constructor(fireDelayedEvent, compressors){
        this.push = (identifier, builtEvent, context, userInfo)=>{
            this.delayQueue.push(identifier, builtEvent, context, userInfo);
        };
        this.startLowPriorityEventDelay = (timeout = (0, _defaults.DEFAULT_DELAY_TIMEOUT), callback)=>{
            if (Number.isNaN(timeout) || timeout <= 0) throw new Error(`Invalid timeout period: ${timeout}, must be a number greater than 0`);
            if (this.delayTimeout) clearTimeout(this.delayTimeout);
            const delayTimeoutPeriod = timeout ? Math.min(timeout, (0, _defaults.MAX_DELAY_TIMEOUT)) : (0, _defaults.MAX_DELAY_TIMEOUT);
            this.delayCallback = callback;
            this.delayTimeout = setTimeout(()=>this.stopLowPriorityEventDelay((0, _types.StopLowPriorityEventDelayReason).TIMEOUT), delayTimeoutPeriod);
            // If the queue is still flushing from a previous delay period, then we should cancel that flush
            // to stop it from negatively impacting the performance of the new critical section
            this.delayQueue.cancelFlush();
            this.isDelaying = true;
        };
        this.stopLowPriorityEventDelay = (reason = (0, _types.StopLowPriorityEventDelayReason).MANUAL)=>{
            var _this_delayCallback, _this;
            if (this.delayTimeout) {
                clearTimeout(this.delayTimeout);
                this.delayTimeout = undefined;
            }
            this.delayQueue.startFlush();
            this.isDelaying = false;
            (_this_delayCallback = (_this = this).delayCallback) === null || _this_delayCallback === void 0 ? void 0 : _this_delayCallback.call(_this, reason);
            this.delayCallback = undefined;
        };
        this.isDelayingLowPriorityEvents = ()=>this.isDelaying;
        this.isDelaying = false;
        this.delayQueue = new (0, _eventDelayQueueDefault.default)(fireDelayedEvent, compressors);
    }
}

},{"./defaults":"aVMAl","./eventDelayQueue":"8Wl08","./types":"1cGIA","@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"aVMAl":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "DEFAULT_DELAY_TIMEOUT", ()=>DEFAULT_DELAY_TIMEOUT);
parcelHelpers.export(exports, "MAX_DELAY_TIMEOUT", ()=>MAX_DELAY_TIMEOUT);
const DEFAULT_DELAY_TIMEOUT = 10000;
const MAX_DELAY_TIMEOUT = 30000;

},{"@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"8Wl08":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>EventDelayQueue);
var _eventBuilder = require("../eventBuilder");
var _objectUtils = require("../objectUtils");
var _eventCompressor = require("./eventCompressor");
var _eventCompressorDefault = parcelHelpers.interopDefault(_eventCompressor);
// We want to throttle the flush rate so that we don't have a huge upfront performance hit from starting the flush,
// and so that the underlying Segment client has some time to process some events in its queue before more are added.
const FLUSH_BATCH_SIZE = 7; // aligns with the default batch size of Segment's BatchableQueue
const FLUSH_BATCH_BACKOFF_PERIOD = 100;
class EventDelayQueue {
    constructor(processFn, compressionRules){
        this.push = (identifier, builtEvent, context, userInfo)=>{
            this.eventArgs.push({
                identifier,
                builtEvent,
                context,
                userInfo
            });
        };
        this.size = ()=>this.eventArgs.length;
        this.startFlush = ()=>{
            try {
                this.eventArgs = this.compressEventArgs(this.eventArgs);
            } catch (e) {
                // eslint-disable-next-line no-console
                console.warn('Failed to perform compression on the delayed analytics events. ' + `Error: ${e.message}. Sending ${this.eventArgs.length} uncompressed events instead`);
            }
            this.flushNextBatch();
        };
        this.cancelFlush = ()=>{
            if (this.flushBatchTimeout) {
                clearTimeout(this.flushBatchTimeout);
                this.flushBatchTimeout = null;
            }
        };
        this.flushNextBatch = ()=>{
            const batch = this.eventArgs.splice(0, FLUSH_BATCH_SIZE);
            batch.forEach((item)=>this.processFn(item.identifier, item.builtEvent, item.context, item.userInfo));
            if (this.eventArgs.length > 0) this.flushBatchTimeout = setTimeout(()=>this.flushNextBatch(), FLUSH_BATCH_BACKOFF_PERIOD);
            else this.flushBatchTimeout = null;
        };
        this.compressEventArgs = (eventArgs)=>{
            const [compressibleEventArgs, incompressibleEventArgs] = (0, _objectUtils.partition)(eventArgs, (args)=>this.compressor.canCompress(args.builtEvent));
            // Events can only be compressed together if they share the same context and user info, since these are top-level
            // fields that need to exist on the fired event and can only be set to a single value.
            // We can achieve this by grouping our events by context prior to passing them to the compressor.
            const contextGroups = compressibleEventArgs.reduce((groups, args)=>{
                const matchingGroup = groups.find((group)=>(0, _objectUtils.equals)(group.userInfo, args.userInfo) && (0, _objectUtils.equals)(group.context, args.context));
                if (matchingGroup) matchingGroup.eventArgs.push(args);
                else groups.push({
                    userInfo: args.userInfo,
                    context: args.context,
                    eventArgs: [
                        args
                    ]
                });
                return groups;
            }, []);
            // Run the compressor on each group
            const allCompressedEventArgs = contextGroups.reduce((acc, group)=>{
                try {
                    const events = group.eventArgs.map((args)=>args.builtEvent);
                    const compressedEvents = this.compressor.compress(events);
                    const compressedEventArgs = compressedEvents.map((compressedEvent)=>({
                            identifier: (0, _eventBuilder.buildActionName)(compressedEvent),
                            builtEvent: compressedEvent,
                            userInfo: group.userInfo,
                            context: group.context
                        }));
                    return acc.concat(compressedEventArgs);
                } catch (e) {
                    // If anything goes wrong while compressing this group, then just fall back on the
                    // uncompressed events instead. The event compressor already handles errors with invalid
                    // generator functions or results, but this is an extra layer of defense to prevent data
                    // loss in the event of an unexpected error.
                    // eslint-disable-next-line no-console
                    console.warn('Failed to compress some analytics events. ' + `Error: ${e.message}. Sending ${group.eventArgs.length} uncompressed events instead`);
                    return group.eventArgs;
                }
            }, []);
            incompressibleEventArgs.forEach((args)=>allCompressedEventArgs.push(args));
            return allCompressedEventArgs;
        };
        this.processFn = processFn;
        this.flushBatchTimeout = null;
        this.eventArgs = [];
        this.compressor = new (0, _eventCompressorDefault.default)(compressionRules);
    }
}

},{"../eventBuilder":"jZ9BF","../objectUtils":"h1ZE7","./eventCompressor":"i54wm","@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"i54wm":[function(require,module,exports,__globalThis) {
/* eslint-disable implicit-arrow-linebreak */ /* eslint-disable max-classes-per-file */ var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>EventCompressor);
var _objectSpread = require("@swc/helpers/_/_object_spread");
var _eventBuilder = require("../eventBuilder");
var _objectUtils = require("../objectUtils");
var _compressionRule = require("./compressionRule");
class EventCompressor {
    constructor(compressionRules = []){
        this.canCompress = (event)=>this.compressionRules.some((compressionRule)=>compressionRule.canCompress(event));
        this.compress = (events)=>{
            const groups = this.createGroups(events);
            return groups.reduce((allCompressedEvents, group)=>{
                const groupCompressedEvents = this.compressGroup(group);
                return allCompressedEvents.concat(groupCompressedEvents);
            }, []);
        };
        this.createGroups = (events)=>// Group events based on contextual fields. These fields are anything that is added by the client itself,
            // rather than passed in by the caller (eg. product, org. and tenant info)
            events.reduce((groups, event)=>{
                const matchingCompressor = this.compressionRules.find((compressor)=>compressor.canCompress(event));
                let contextFields;
                if (matchingCompressor) {
                    const actionFields = (0, _eventBuilder.buildActionFields)(event, event.eventType);
                    contextFields = (0, _objectUtils.omit)(event, Object.keys(actionFields));
                }
                const matchingGroup = groups.find((group)=>matchingCompressor === group.compressor && (0, _objectUtils.equals)(contextFields, group.contextFields));
                if (matchingGroup) matchingGroup.events.push(event);
                else groups.push({
                    contextFields,
                    compressor: matchingCompressor,
                    events: [
                        event
                    ]
                });
                return groups;
            }, []);
        this.compressGroup = (group)=>{
            // If this group doesn't have any compressor, then the event args are already in their final format
            if (!group.compressor) return group.events;
            try {
                // Run the compressor on the group to generate some new events.
                // The compression function is only expected to return the action fields for each
                // event that it generates, since all other fields are generated by the client.
                const compressedEventActionFields = group.compressor.compress(group.events);
                // Add the context fields to each of the resulting events to inflate them into a full action event
                return compressedEventActionFields.map((actionFields)=>(0, _objectSpread._)({}, actionFields, group.contextFields));
            } catch (e) {
                // If we fail to compress the events, then just fall back the uncompressed events
                // so that no data is lost. This can happen if the compression function throws an error
                // or returns some invalid event payloads.
                // eslint-disable-next-line no-console
                // console.warn(
                // 	'Failed to compress some analytics events. ' +
                // 		`Error: ${(e as Error).message}. Sending ${
                // 			group.events.length
                // 		} uncompressed events instead`,
                // );
                return group.events;
            }
        };
        if (!Array.isArray(compressionRules)) throw new Error('Event compressors must be constructed with an array of CompressionRules');
        if (!compressionRules.every((rule)=>rule instanceof (0, _compressionRule.CompressionRule))) throw new Error('Event compressors can only be constructed with instances of CompressionRule');
        this.compressionRules = compressionRules;
    }
}

},{"@swc/helpers/_/_object_spread":"9gdrV","../eventBuilder":"jZ9BF","../objectUtils":"h1ZE7","./compressionRule":"2Rs3G","@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"1cGIA":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "StopLowPriorityEventDelayReason", ()=>StopLowPriorityEventDelayReason);
var StopLowPriorityEventDelayReason = /*#__PURE__*/ function(StopLowPriorityEventDelayReason) {
    StopLowPriorityEventDelayReason["TIMEOUT"] = "timeout";
    StopLowPriorityEventDelayReason["MANUAL"] = "manual";
    return StopLowPriorityEventDelayReason;
}({});

},{"@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"7fGbV":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>(0, _eventProcessorDefault.default));
var _eventProcessor = require("./eventProcessor");
var _eventProcessorDefault = parcelHelpers.interopDefault(_eventProcessor);

},{"./eventProcessor":"hMCVY","@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"hMCVY":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "AnalyticsResponse", ()=>AnalyticsResponse);
// eslint-disable-next-line @atlaskit/volt-strict-mode/no-multiple-exports
parcelHelpers.export(exports, "default", ()=>EventProcessor);
var _objectSpread = require("@swc/helpers/_/_object_spread");
var _objectSpreadProps = require("@swc/helpers/_/_object_spread_props");
var _resilienceQueue = require("../resilienceQueue");
var _resilienceQueueDefault = parcelHelpers.interopDefault(_resilienceQueue);
var _metrics = require("../resilienceQueue/Metrics");
var _metricsDefault = parcelHelpers.interopDefault(_metrics);
var _uuid = require("../uuid");
var _uuidDefault = parcelHelpers.interopDefault(_uuid);
var _xid = require("../xid");
var _defaults = require("./defaults");
var _httpStatusCode = require("./HttpStatusCode");
var _sendEvents = require("./sendEvents");
var _types = require("./types");
var _user = require("./user");
var _userDefault = parcelHelpers.interopDefault(_user);
var _util = require("./util");
class AnalyticsAPIResponse {
    isSuccess() {
        return this.success;
    }
    getValidationErrors() {
        return this.validationErrors;
    }
    getMessage() {
        return this.message;
    }
    getCode() {
        return this.code;
    }
    getValidationReports() {
        return this.validationReports === undefined ? null : this.validationReports;
    }
    constructor(success, validationErrors, message, code, validationReports){
        this.success = success;
        this.validationErrors = validationErrors;
        this.message = message;
        this.code = code;
        this.validationReports = validationReports;
    }
}
class Message {
    constructor(error){
        this.error = error;
    }
}
class EventValidationReport {
    getMessageId() {
        return this.messageId;
    }
    getResults() {
        return this.results;
    }
    constructor(messageId, results){
        this.messageId = messageId;
        this.results = results;
    }
}
class AnalyticsResponse {
    isSuccess() {
        return this.success;
    }
    getStatusCode() {
        return this.statusCode;
    }
    getMessage() {
        return this.message;
    }
    getEventResponseList() {
        return this.eventResponseList;
    }
    constructor(success, statusCode, message, eventResponseList){
        this.success = success;
        this.statusCode = statusCode;
        this.message = message;
        this.eventResponseList = eventResponseList;
    }
}
class EventResponse {
    getMessageId() {
        return this.messageId;
    }
    getResults() {
        return this.results;
    }
    getSegmentEvent() {
        return this.segmentEvent;
    }
    constructor(messageId, results, segmentEvent){
        this.messageId = messageId;
        this.results = results;
        this.segmentEvent = segmentEvent;
    }
}
class EventValidationResult {
    getType() {
        return this.type;
    }
    getSeverity() {
        return this.severity;
    }
    getPropertyPath() {
        return this.propertyPath;
    }
    getMessage() {
        return this.message;
    }
    constructor(type, severity, propertyPath, message){
        this.type = type;
        this.severity = severity;
        this.propertyPath = propertyPath;
        this.message = message;
    }
}
class EventProcessor {
    getUser() {
        return this.user;
    }
    async track(eventName, builtEvent, context, callback) {
        const baseEvent = this.buildBaseEvent(context, (0, _types.SegmentEventTypes).TRACK, builtEvent);
        const eventWithoutMessageId = (0, _objectSpreadProps._)((0, _objectSpread._)({}, baseEvent), {
            type: (0, _types.SegmentEventTypes).TRACK,
            properties: (0, _util.prepareEventProperties)(builtEvent),
            event: eventName
        });
        const event = (0, _objectSpreadProps._)((0, _objectSpread._)({}, eventWithoutMessageId), {
            messageId: this.createMessageId()
        });
        const packagedEvent = this.packageEvent(event);
        await this.enqueueEvent(packagedEvent);
        if (callback) callback();
    }
    async page(eventName, builtEvent, context, callback) {
        const baseEvent = this.buildBaseEvent(context, (0, _types.SegmentEventTypes).PAGE, builtEvent);
        const eventWithoutMessageId = (0, _objectSpreadProps._)((0, _objectSpread._)({}, baseEvent), {
            type: (0, _types.SegmentEventTypes).PAGE,
            properties: (0, _util.prepareEventProperties)(builtEvent),
            name: eventName
        });
        const event = (0, _objectSpreadProps._)((0, _objectSpread._)({}, eventWithoutMessageId), {
            messageId: this.createMessageId()
        });
        const packagedEvent = this.packageEvent(event);
        await this.enqueueEvent(packagedEvent);
        if (callback) callback();
    }
    // Segment uses the identifier to update user id which we have already done in the analyticsWebClient.ts
    async identify(_identifier, builtEvent, context, callback) {
        const baseEvent = this.buildBaseEvent(context, (0, _types.SegmentEventTypes).IDENTIFY, builtEvent);
        const eventWithoutMessageId = (0, _objectSpreadProps._)((0, _objectSpread._)({}, baseEvent), {
            type: (0, _types.SegmentEventTypes).IDENTIFY,
            traits: (0, _util.prepareEventProperties)(builtEvent)
        });
        const event = (0, _objectSpreadProps._)((0, _objectSpread._)({}, eventWithoutMessageId), {
            messageId: this.createMessageId()
        });
        const packagedEvent = this.packageEvent(event);
        await this.enqueueEvent(packagedEvent);
        if (callback) callback();
    }
    async enqueueEvent(packagedEvent) {
        if (this.options.enableMetadataCalls) this.metadataClient.start(false); // Start the metadata client if needed
        await this.resilienceQueue.addItem(packagedEvent);
    }
    buildBaseEvent(context, type, overrides) {
        const clonedContext = (0, _util.prepareEventContext)(context);
        const segmentContext = (0, _util.buildContext)(clonedContext, overrides);
        return {
            context: segmentContext,
            timestamp: new Date().toISOString(),
            type,
            userId: this.user.getUserId(),
            anonymousId: overrides.anonymousId || this.user.getAnonymousId()
        };
    }
    createMessageId() {
        return `ajs-${(0, _uuidDefault.default)()}`;
    }
    packageEvent(event) {
        const { apiHost, apiHostProtocol } = this.options;
        return {
            headers: {
                'Content-Type': 'text/plain'
            },
            msg: event,
            url: `${apiHostProtocol}://${apiHost}/${event.type.charAt(0)}`
        };
    }
    applyExclusions(item) {
        var _msg_context;
        const msg = item.msg;
        const properties = msg.properties;
        const traits = msg.traits;
        const excluded = (_msg_context = msg.context) === null || _msg_context === void 0 ? void 0 : _msg_context.excludedProperties;
        if (!excluded) return;
        if (excluded.anonymousId === true) msg.anonymousId = undefined;
        if (excluded.interactionSession === true) {
            if (properties) properties.interactionSession = undefined;
        }
        if (excluded.sessionId === true) {
            if (properties) properties.sessionId = undefined;
        }
        if (excluded.pageLoadId === true) {
            if (properties) properties.pageLoadId = undefined;
        }
        if (excluded.tabId === true) {
            if (properties) properties.tabId = undefined;
        }
        if (excluded.taskSessions === true) {
            if (properties) properties.taskSessions = undefined;
        }
        if (excluded.userId === true) {
            msg.userId = undefined;
            if (properties) properties.userIdType = undefined;
        }
        if (excluded.xid === true) {
            if (properties) properties.xid = undefined;
            if (traits) traits.xid = undefined;
        }
    }
    getEventUrl(metadataInfo) {
        const preferredBatchUrl = (metadataInfo === null || metadataInfo === void 0 ? void 0 : metadataInfo.url) ? metadataInfo.url : this.gasv3BatchUrl;
        const finalBatchUrl = this.useUrlFromMetadata ? preferredBatchUrl : this.gasv3BatchUrl;
        const isFallbackUrl = preferredBatchUrl === this.gasv3BatchUrl ? null : finalBatchUrl !== preferredBatchUrl;
        return [
            finalBatchUrl,
            isFallbackUrl
        ];
    }
    cleanLibraryMetadata(obj) {
        // skip if the parameter is not an object
        if (obj === null || typeof obj !== 'object') return;
        for(const key in obj){
            // Skip cleaning up props object and its keys
            // to avoid having to check the existence of the fields in props object
            // and manipulate them to calculate metadata signature in analytics service
            if (key === 'props') continue;
            let value = obj[key];
            // Remove null or undefined values
            if (value === null || value === undefined) delete obj[key];
            else if (typeof value === 'number' && value === 0) delete obj[key];
            else if (Array.isArray(value)) {
                if (value.length === 0) delete obj[key];
                else value.forEach((item)=>{
                    this.cleanLibraryMetadata(item);
                });
            } else if (typeof value === 'object') this.cleanLibraryMetadata(obj[key]);
        }
    }
    async invokeLocalResponseCallbackAsync(items, response, error) {
        const localResponseCallback = this.responseCallback;
        if (localResponseCallback) {
            // If we have a response, we'll parse it and create an AnalyticsAPIResponse from it.
            let analyticsAPIResponse = null;
            if (response) {
                var _responseObject_message;
                let responseObject;
                try {
                    responseObject = await response.clone().json();
                } catch (e) {
                // Ignore errors parsing the response, we can't do anything about them
                }
                // Ensure we've got a valid object to work with, filling in any missing
                // properties as best we can.
                responseObject = responseObject || {};
                responseObject.code = Number.parseInt(responseObject.code) > 0 ? Number.parseInt(responseObject.code) : response.status;
                responseObject.success = responseObject.success || responseObject.code >= 200 && responseObject.code <= 299;
                analyticsAPIResponse = new AnalyticsAPIResponse(responseObject.success, responseObject.validationErrors || new Map(), new Message(((_responseObject_message = responseObject.message) === null || _responseObject_message === void 0 ? void 0 : _responseObject_message.error) || ''), responseObject.code, responseObject.validationReports || null);
            }
            // If we have an error, but it's not an instance of Error (e.g. it's a string), we'll convert it to an Error object.
            if (error && !(error instanceof Error)) error = new Error(String(error));
            const analyticsResponse = BatchInterceptor.toAnalyticsResponse(items || [], error || null, analyticsAPIResponse);
            localResponseCallback(analyticsResponse);
        }
    }
    async attachXIDs(items) {
        if (this.xidPromiseCallback) return (0, _xid.attachXidToMultipleEvents)(items, this.xidPromiseCallback);
        return Promise.resolve(items);
    }
    /** @internal Used by AnalyticsWebClient to wire up origin tracing cleanup. */ setOriginTracingClient(client) {
        this.originTracingClient = client;
    }
    setResponseCallback(responseCallback) {
        this.responseCallback = responseCallback;
    }
    refreshMetadata(userInfo, tenantInfo) {
        this.metadataClient.userInfo = userInfo;
        this.metadataClient.tenantInfo = tenantInfo;
    }
    constructor(options){
        var _this_options;
        this.originTracingClient = null;
        // Using anonymous function so it can have the BatchFlushCallback type associated with it
        // And to allow it to not need bind when passing through to ResilieceQueue.
        this.sendEvents = async (items, callback)=>{
            var _this_lastSendEventsError, _this_metadataClient;
            if (this.options.enableEventCalls === false) return;
            const httpRetryCount = this.resilienceQueue.getGlobalRetryCount();
            const metricsPayload = this.metrics.getMetricsPayload();
            const eventsWithXID = await this.attachXIDs(items);
            // Calculating sentAt after the XID generation as this may take some time.
            const sentAt = new Date().toISOString();
            const metadataInfo = await this.metadataClient.getMetadataAsync();
            const [eventUrl, isFallbackUrl] = this.getEventUrl(metadataInfo);
            const metadata = (0, _objectSpreadProps._)((0, _objectSpread._)({}, metricsPayload), {
                httpRetryCount,
                lastSendEventsErrorReason: ((_this_lastSendEventsError = this.lastSendEventsError) === null || _this_lastSendEventsError === void 0 ? void 0 : _this_lastSendEventsError.message) || null,
                lastSendEventsError: this.lastSendEventsError,
                lastUrlFallbackError: this.lastUrlFallbackError,
                isUsingFallbackUrl: isFallbackUrl,
                props: (metadataInfo === null || metadataInfo === void 0 ? void 0 : metadataInfo.props) || null,
                metadataClientMetrics: ((_this_metadataClient = this.metadataClient) === null || _this_metadataClient === void 0 ? void 0 : _this_metadataClient.metrics) || null
            });
            // Remove default values from metadata to save space
            this.cleanLibraryMetadata(metadata);
            const unpackagedEvents = eventsWithXID.map((item)=>{
                this.applyExclusions(item);
                item.msg.sentAt = sentAt;
                return item.msg;
            });
            const batchBody = {
                batch: unpackagedEvents,
                sentAt,
                metadata
            };
            try {
                var _this_originTracingClient;
                const response = await (0, _sendEvents.sendEvents)({
                    url: eventUrl,
                    batch: batchBody,
                    timeout: this.options.requestTimeout
                });
                this.lastSendEventsError = null;
                this.lastUrlFallbackError = null;
                this.metrics.subtractFromMetrics(metricsPayload);
                callback(null, response);
                (_this_originTracingClient = this.originTracingClient) === null || _this_originTracingClient === void 0 ? void 0 : _this_originTracingClient.cleanupOriginParameters(items);
                await this.invokeLocalResponseCallbackAsync(items, response, null);
            } catch (error) {
                // If there's an error, other than one which indicates a temporary problem with the service,
                // we'll stop using the URL from the metadata and fall back to the default URL. After a time
                // we'll fall forward again in case the problem has been resolved.
                if (error instanceof (0, _types.FetchError) && [
                    429,
                    503
                ].includes(error.statusCode)) // Ignore 429 and 503 errors since they're considered to indicate a temporary
                // issue with the service, rather than a network failure due to blocked requests.
                this.lastSendEventsError = new (0, _types.LastError)('ServerBusyError', error);
                else {
                    const errorName = error instanceof Error && (0, _types.ALLOW_LISTED_FETCH_ERROR_NAMES).includes(error.name) ? error.name : 'Unknown';
                    this.lastSendEventsError = new (0, _types.LastError)(errorName, error);
                    // Handle falling back to the default URL if we're using the metadata URL.
                    this.useUrlFromMetadata = false;
                    // If we're now using the fallback URL, and the last attempt wasn't,
                    // we'll record this as the error that triggered the fallback.
                    const [_, willUseFallbackUrl] = this.getEventUrl(metadataInfo);
                    if (willUseFallbackUrl && willUseFallbackUrl !== isFallbackUrl) this.lastUrlFallbackError = this.lastSendEventsError;
                }
                callback(error, null);
                await this.invokeLocalResponseCallbackAsync(items, null, error);
            }
        };
        this.options = (0, _objectSpreadProps._)((0, _objectSpread._)({}, options), {
            requestTimeout: options.requestTimeout || (0, _defaults.DEFAULT_REQUEST_TIMEOUT),
            retryQueueOptions: options.retryQueueOptions || {},
            logger: options.logger || console,
            disableCookiePersistence: options.disableCookiePersistence || false,
            env: options.env,
            perimeter: options.perimeter || '',
            enableMetadataCalls: typeof options.enableMetadataCalls === 'boolean' ? options.enableMetadataCalls : true,
            enableEventCalls: typeof options.enableEventCalls === 'boolean' ? options.enableEventCalls : true
        });
        this.user = new (0, _userDefault.default)((_this_options = this.options) === null || _this_options === void 0 ? void 0 : _this_options.disableCookiePersistence);
        this.xidPromiseCallback = options.xidPromiseGetter();
        this.gasv3BatchUrl = `${options.apiHostProtocol}://${options.apiHost}/batch`;
        this.metrics = (0, _metricsDefault.default)();
        this.responseCallback = options.responseCallback;
        this.resilienceQueue = (0, _resilienceQueueDefault.default)(options.retryQueuePrefix, options.product, this.options.retryQueueOptions, this.options.logger);
        this.metadataClient = options.metadataClient;
        this.useUrlFromMetadata = true;
        this.lastSendEventsError = null;
        this.lastUrlFallbackError = null;
        setInterval(()=>{
            this.useUrlFromMetadata = true;
        }, 600000);
        this.resilienceQueue.start(this.sendEvents);
    }
}
class BatchInterceptor {
    static toAnalyticsResponse(items, error, analyticsAPIResponse) {
        const eventResponseList = [];
        if (analyticsAPIResponse !== null) {
            const [statusCode, success] = [
                analyticsAPIResponse.code,
                analyticsAPIResponse.success
            ];
            if (statusCode >= 200 && statusCode <= 299) {
                var _analyticsAPIResponse_validationReports;
                (_analyticsAPIResponse_validationReports = analyticsAPIResponse.validationReports) === null || _analyticsAPIResponse_validationReports === void 0 ? void 0 : _analyticsAPIResponse_validationReports.forEach((report)=>{
                    const matchedEvent = items.find((item)=>item.msg.messageId === report.messageId);
                    if (matchedEvent) eventResponseList.push(new EventResponse(matchedEvent.msg.messageId, report.results, matchedEvent.msg));
                });
                return new AnalyticsResponse(success, statusCode, (0, _httpStatusCode.HTTP_STATUS_CODE_MAP).get(statusCode), eventResponseList);
            } else if (statusCode >= 400 && statusCode <= 499) {
                var _analyticsAPIResponse_message;
                // not exluding "HTTP 429 Too Many Requests error" as it is thrown as an error and handled below
                const errorMessage = ((_analyticsAPIResponse_message = analyticsAPIResponse.message) === null || _analyticsAPIResponse_message === void 0 ? void 0 : _analyticsAPIResponse_message.error) !== null ? analyticsAPIResponse.message.error : (0, _httpStatusCode.HTTP_STATUS_CODE_MAP).has(statusCode) ? (0, _httpStatusCode.HTTP_STATUS_CODE_MAP).get(statusCode) : (0, _httpStatusCode.HTTP_STATUS_CODE_MAP).get(-1);
                items.forEach((item)=>{
                    eventResponseList.push(new EventResponse(item.msg.messageId, [], item.msg));
                });
                return new AnalyticsResponse(success, statusCode, errorMessage, eventResponseList);
            }
        } else if (error === null || error === void 0 ? void 0 : error.message) {
            const match = error.message.match(BatchInterceptor.http_error_regex);
            if (match) {
                items.forEach((item)=>{
                    eventResponseList.push(new EventResponse(item.msg.messageId, [], item.msg));
                });
                return new AnalyticsResponse(false, Number(match[1]), match[2], eventResponseList);
            }
        }
        items.forEach((item)=>{
            eventResponseList.push(new EventResponse(item.msg.messageId, [], item.msg));
        });
        return new AnalyticsResponse(false, -1, (0, _httpStatusCode.HTTP_STATUS_CODE_MAP).get(-1), eventResponseList);
    }
}
BatchInterceptor.http_error_regex = /HTTP Error\s([0-9]{3})\s\((.+)\)/;

},{"@swc/helpers/_/_object_spread":"9gdrV","@swc/helpers/_/_object_spread_props":"kANqQ","../resilienceQueue":"gTS9R","../resilienceQueue/Metrics":"5vgpA","../uuid":"igO59","../xid":"13H4M","./defaults":"h7hwI","./HttpStatusCode":"ePgKa","./sendEvents":"fy0nR","./types":"kbxf3","./user":"7lmwV","./util":"dvv3A","@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"gTS9R":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
// Enum isnt just a type, its also an object that needs to be
// exported as an object.
parcelHelpers.export(exports, "ResilienceMechanism", ()=>(0, _types.ResilienceMechanism));
var _pullBatchableQueue = require("./PullBatchableQueue");
var _pullBatchableQueueDefault = parcelHelpers.interopDefault(_pullBatchableQueue);
var _types = require("./types");
// eslint-disable-next-line @atlaskit/volt-strict-mode/no-multiple-exports
exports.default = (retryQueuePrefix, product, options, logger)=>{
    return new (0, _pullBatchableQueueDefault.default)(retryQueuePrefix, product, options || {}, logger);
};

},{"./PullBatchableQueue":"3RHOC","./types":false,"@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"3RHOC":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "DEFAULT_POLLING_OPTIONS", ()=>DEFAULT_POLLING_OPTIONS);
// eslint-disable-next-line @atlaskit/volt-strict-mode/no-multiple-exports
parcelHelpers.export(exports, "default", ()=>PullBatchableQueue);
var _objectSpread = require("@swc/helpers/_/_object_spread");
var _objectSpreadProps = require("@swc/helpers/_/_object_spread_props");
var _localstorageRetry = require("../localstorage-retry");
var _resiliencedb = require("../resiliencedb");
var _resiliencedbDefault = parcelHelpers.interopDefault(_resiliencedb);
var _metrics = require("./Metrics");
var _metricsDefault = parcelHelpers.interopDefault(_metrics);
var _networkStatus = require("./NetworkStatus");
var _networkStatusDefault = parcelHelpers.interopDefault(_networkStatus);
var _scheduler = require("./scheduler");
var _schedulerDefault = parcelHelpers.interopDefault(_scheduler);
var _types = require("./types");
const ONE_MINUTE = 60000;
const LONG_POLLING_OPTIONS = {
    backoffFactor: 0,
    backoffJitterPercentage: 0,
    flushWaitMs: ONE_MINUTE,
    minRetryDelay: ONE_MINUTE,
    maxRetryDelay: ONE_MINUTE
};
const DEFAULT_POLLING_OPTIONS = {
    backoffFactor: 2,
    backoffJitterPercentage: 0.2,
    batchFlushSize: 7,
    flushBeforeUnload: false,
    flushWaitMs: 500,
    maxAttempts: 10,
    // The maximum number of events that can be stored in the resilience queue (IndexedDB/memory).
    // This limit is per product and is enforced by the EventCountGuard in the resilience layer.
    maxQueueSize: 8000,
    maxRetryDelay: 30000,
    minRetryDelay: 1000
};
class PullBatchableQueue {
    start(flushCallback) {
        this.batchFlushCallback = flushCallback;
        this.longPollingScheduler.schedule();
    }
    stop() {
        this.scheduler.stop();
        this.longPollingScheduler.stop();
    }
    async addItem(item) {
        // Since Jira and Confluence use `.toJSON` on objects that should be strings
        // And expect us to use `JSON.stringify` on these objects,
        // And indexeddb strips these functions from the objects when adding them to the DB,
        // We must run this silly stringify and parse before passing the event to the resilience meechanism.
        // Planning on removing this in v4
        const jsonStringifiedAndParsedItem = JSON.parse(JSON.stringify(item));
        const { numberOfEvictedItems } = await this.resilience.addItem(jsonStringifiedAndParsedItem, {}, (0, _resiliencedb.GuardPolicy).EVICT);
        this.scheduler.schedule();
        this.metricsCollector.addToEventCount();
        if (numberOfEvictedItems > 0) this.metricsCollector.addToItemsDiscardedByOverflowCounter(numberOfEvictedItems);
    }
    getGlobalRetryCount() {
        return this.scheduler.getFailureCount();
    }
    async scheduleCallback(done) {
        // Even though we stopped the scheduler, it can be restarted with a call to schedule.
        // This could be triggered by a new event or the longPollingScheduler
        if (this.networkStatus.getNetworkStatus() === (0, _types.NetworkStatusEnum).OFFLINE) {
            done((0, _scheduler.DoneState).NOOP);
            return;
        }
        try {
            const result = await this.resilience.processItems(this.flush.bind(this), this.options.batchFlushSize);
            done(result);
        } catch (error) {
            if (error.name === (0, _resiliencedb.CallbackProcessingErrorName)) {
                done((0, _scheduler.DoneState).ERROR);
                return;
            }
        // TODO we can probably log here but throwing is useless as it will just be shallowed by the Scheduler
        // In theory something else should catch all other errors from indexeddb and this should never happen.
        } finally{
            await this.checkEventCountAndReschedule();
        }
    }
    async checkEventCountAndReschedule() {
        const eventWaitingCount = await this.resilience.getItemCount();
        if (eventWaitingCount > 0) this.scheduler.schedule({
            immediate: eventWaitingCount >= this.options.batchFlushSize
        });
    }
    async scheduleLongCallBack(done) {
        // Eventually we will want to send data about how many queues were purged
        const numberOfQueuesPurged = (0, _localstorageRetry.purgeOrphanedQueues)(this.queuePrefix);
        this.metricsCollector.addToPurgedQueuesMetrics(numberOfQueuesPurged);
        // Eventually we will want to send data about how attempted reclaims and actual reclaims were made
        const reclaimMetrics = await (0, _localstorageRetry.reclaimEvents)(this.queuePrefix, async (localStorageItems)=>{
            const itemsToAdd = localStorageItems.map((localStorageItem)=>({
                    item: localStorageItem.item,
                    retryAttempts: localStorageItem.attemptNumber,
                    id: localStorageItem.id
                }));
            const { items: addedEvents } = await this.resilience.bulkAddItem(itemsToAdd, (0, _resiliencedb.GuardPolicy).IGNORE);
            if (addedEvents.length === itemsToAdd.length) return {
                status: 'successful'
            };
            else return {
                status: 'partial',
                acceptedItemIds: addedEvents.map((event)=>event.id)
            };
        });
        this.metricsCollector.addToReclaimMetrics(reclaimMetrics);
        // We dont want to flush events from here as there maybe issues with analytics-service
        // Scheduler has all the context and can schedule the next batch accordingly
        await this.checkEventCountAndReschedule();
        done((0, _scheduler.DoneState).SUCCESS);
        this.longPollingScheduler.schedule();
    }
    flush(wrappedItems, otherMetadata) {
        this.metricsCollector.setResilienceMechanism(this.resilience.storeType());
        const { batchFlushCallback } = this;
        if (!batchFlushCallback) throw new Error('batchFlushCallback has not been set. Call PullBatchableQueue#start first.');
        return new Promise((resolve, reject)=>{
            if (wrappedItems.length <= 0) {
                resolve((0, _scheduler.DoneState).NOOP);
                return;
            }
            const items = wrappedItems.map((wrappedItem)=>{
                const item = wrappedItem.item;
                if (wrappedItem.retryAttempts > 0 && item.msg) {
                    if (!item.msg._metadata) item.msg._metadata = {};
                    item.msg._metadata.failedAttempts = wrappedItem.retryAttempts;
                }
                return item;
            });
            batchFlushCallback(items, (error)=>{
                if (error) {
                    if (otherMetadata.numberOfDeletedItems > 0) this.metricsCollector.addToItemsDiscardedByRetryCounter(otherMetadata.numberOfDeletedItems);
                    reject(error);
                } else resolve((0, _scheduler.DoneState).SUCCESS);
            });
        });
    }
    buildOptions(options) {
        return {
            backoffFactor: (options === null || options === void 0 ? void 0 : options.backoffFactor) || DEFAULT_POLLING_OPTIONS.backoffFactor,
            backoffJitterPercentage: (options === null || options === void 0 ? void 0 : options.backoffJitterPercentage) !== undefined ? options.backoffJitterPercentage : DEFAULT_POLLING_OPTIONS.backoffJitterPercentage,
            batchFlushSize: (options === null || options === void 0 ? void 0 : options.batchFlushSize) || DEFAULT_POLLING_OPTIONS.batchFlushSize,
            flushBeforeUnload: (options === null || options === void 0 ? void 0 : options.flushBeforeUnload) || DEFAULT_POLLING_OPTIONS.flushBeforeUnload,
            flushWaitMs: (options === null || options === void 0 ? void 0 : options.flushWaitMs) || DEFAULT_POLLING_OPTIONS.flushWaitMs,
            maxQueueSize: (options === null || options === void 0 ? void 0 : options.maxQueueSize) || DEFAULT_POLLING_OPTIONS.maxQueueSize,
            maxAttempts: (options === null || options === void 0 ? void 0 : options.maxAttempts) || DEFAULT_POLLING_OPTIONS.maxAttempts,
            maxRetryDelay: (options === null || options === void 0 ? void 0 : options.maxRetryDelay) || DEFAULT_POLLING_OPTIONS.maxRetryDelay,
            minRetryDelay: (options === null || options === void 0 ? void 0 : options.minRetryDelay) || DEFAULT_POLLING_OPTIONS.minRetryDelay
        };
    }
    constructor(queuePrefix, product, options, logger){
        this.queuePrefix = queuePrefix;
        // Avoiding using options in ResilienceDB at this stage as
        // the options are optimised for the PushBatchableQueue
        this.resilience = new (0, _resiliencedbDefault.default)(product, {
            logger,
            maxAttempts: options === null || options === void 0 ? void 0 : options.maxAttempts,
            maxEventLimit: (options === null || options === void 0 ? void 0 : options.maxQueueSize) || DEFAULT_POLLING_OPTIONS.maxQueueSize
        });
        this.options = this.buildOptions(options);
        this.scheduler = new (0, _schedulerDefault.default)((0, _objectSpreadProps._)((0, _objectSpread._)({}, this.options), {
            waitInterval: (options === null || options === void 0 ? void 0 : options.flushBeforeUnload) ? 0 : this.options.flushWaitMs
        }), this.scheduleCallback.bind(this));
        this.longPollingScheduler = new (0, _schedulerDefault.default)((0, _objectSpreadProps._)((0, _objectSpread._)({}, LONG_POLLING_OPTIONS), {
            waitInterval: LONG_POLLING_OPTIONS.flushWaitMs
        }), this.scheduleLongCallBack.bind(this));
        this.metricsCollector = (0, _metricsDefault.default)();
        this.networkStatus = new (0, _networkStatusDefault.default)((status)=>{
            if (status === (0, _types.NetworkStatusEnum).OFFLINE) this.scheduler.stop();
            else this.checkEventCountAndReschedule();
        });
    }
}

},{"@swc/helpers/_/_object_spread":"9gdrV","@swc/helpers/_/_object_spread_props":"kANqQ","../localstorage-retry":"glL93","../resiliencedb":"3m3fo","./Metrics":"5vgpA","./NetworkStatus":"8vxyr","./scheduler":"8UdPs","./types":"lKhoc","@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"glL93":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "reclaimEvents", ()=>(0, _reclaimEventsDefault.default));
parcelHelpers.export(exports, "purgeOrphanedQueues", ()=>(0, _purgeOrphanedQueuesDefault.default));
var _reclaimEvents = require("./reclaimEvents");
var _reclaimEventsDefault = parcelHelpers.interopDefault(_reclaimEvents);
var _purgeOrphanedQueues = require("./purgeOrphanedQueues");
var _purgeOrphanedQueuesDefault = parcelHelpers.interopDefault(_purgeOrphanedQueues);

},{"./reclaimEvents":"10szA","./purgeOrphanedQueues":"31LLc","@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"10szA":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _objectSpread = require("@swc/helpers/_/_object_spread");
var _objectSpreadProps = require("@swc/helpers/_/_object_spread_props");
var _uuid = require("../uuid");
var _uuidDefault = parcelHelpers.interopDefault(_uuid);
var _types = require("./types");
var _utils = require("./utils");
const promisedSetTimeout = (msToWait)=>new Promise((resolve)=>{
        setTimeout(resolve, msToWait);
    });
const findOtherQueues = (queuePrefix)=>{
    try {
        // eslint-disable-next-line @atlaskit/platform/no-direct-web-storage-usage -- existing usage
        return Object.keys(localStorage).filter((key)=>key.startsWith(queuePrefix)).map((key)=>key.split('.')).filter((split)=>{
            if (split.length === 3 && split[0] === queuePrefix && split[2] === (0, _types.LocalStorageKeySuffix).ACK) try {
                // eslint-disable-next-line @atlaskit/platform/no-direct-web-storage-usage -- existing usage
                const ackTimestamp = localStorage.getItem(split.join('.'));
                if (ackTimestamp) {
                    const ackTimestampNumber = parseInt(ackTimestamp);
                    return (0, _types.Timers).RECLAIM_TIMEOUT + ackTimestampNumber < Date.now();
                }
            } catch (e) {
            // ignore and drop value
            }
            return false;
        }).map((split)=>split[1]);
    } catch (e) {
    // Ignore errors from accessing localStorage.
    }
    return [];
};
const tryReclaim = async (options, callback)=>{
    const { ack, reclaimStart, reclaimEnd } = options.storageKeys;
    const start = Date.now();
    // eslint-disable-next-line @atlaskit/platform/no-direct-web-storage-usage -- existing usage
    localStorage.setItem(reclaimStart, options.reclaimProcessId);
    // eslint-disable-next-line @atlaskit/platform/no-direct-web-storage-usage -- existing usage
    localStorage.setItem(ack, start.toString());
    await promisedSetTimeout((0, _types.Timers).RECLAIM_WAIT);
    if (// Prevent duplicates when extracting events from localstorage due to CPU / Memory pressure on client
    Date.now() > start + (0, _types.Timers).RECLAIM_WAIT_THRESHOLD || // Either the parent has caught up and removed our claim, or someone else started a claim instead
    // eslint-disable-next-line @atlaskit/platform/no-direct-web-storage-usage -- existing usage
    localStorage.getItem(reclaimStart) !== options.reclaimProcessId) throw new Error('Took to long to callback, reclaim abandonded. After reclaimStart.');
    // eslint-disable-next-line @atlaskit/platform/no-direct-web-storage-usage -- existing usage
    localStorage.setItem(reclaimEnd, options.reclaimProcessId);
    await promisedSetTimeout((0, _types.Timers).RECLAIM_WAIT);
    if (// Prevent duplicates when extracting events from localstorage due to CPU / Memory pressure on client
    Date.now() > start + (0, _types.Timers).RECLAIM_WAIT_THRESHOLD || // Either the parent has caught up and removed our claim, or someone else started a claim instead
    // eslint-disable-next-line @atlaskit/platform/no-direct-web-storage-usage -- existing usage
    localStorage.getItem(reclaimStart) !== options.reclaimProcessId || // eslint-disable-next-line @atlaskit/platform/no-direct-web-storage-usage -- existing usage
    localStorage.getItem(reclaimEnd) !== options.reclaimProcessId) throw new Error('Took to long to callback, reclaim abandonded. After reclaimEnd.');
    return reclaim(options, callback);
};
const reclaim = async (options, callback)=>{
    const { queue, inProgress } = options.storageKeys;
    // Queue is an array of events while inProgress is an object with a uuid for key
    // Either of these queues may legitimately be missing.
    // eslint-disable-next-line @atlaskit/platform/no-direct-web-storage-usage -- existing usage
    const eventsInQueue = JSON.parse(localStorage.getItem(queue) || '[]');
    const eventsInProgress = JSON.parse(// eslint-disable-next-line @atlaskit/platform/no-direct-web-storage-usage -- existing usage
    localStorage.getItem(inProgress) || '{}');
    const arrayOfEventsInProgress = Object.entries(eventsInProgress).map(([key, item])=>{
        const itemWithId = (0, _objectSpreadProps._)((0, _objectSpread._)({}, item), {
            // LocalStorage-retry would add the attemptCounter after failure, rather than
            // as it was being processed
            attemptNumber: item.attemptNumber + 1,
            id: key
        });
        return itemWithId;
    });
    const eventsToProcess = [
        ...eventsInQueue,
        ...arrayOfEventsInProgress
    ];
    if (eventsToProcess.length > 0) {
        const result = await callback(eventsToProcess);
        if (result.status === 'successful') clearLocalStorageKeys(options.storageKeys);
        else if (result.status === 'partial') {
            // Dont delete all events if we are only able to take some of them.
            const leftover = eventsToProcess.filter((event)=>!result.acceptedItemIds.includes(event.id));
            // This way around, we can almost ensure that we wont hit memory quota exceeded errors.
            // However, there is a very small chance that we may lose events if the process exits between these two commands.
            // eslint-disable-next-line @atlaskit/platform/no-direct-web-storage-usage -- existing usage
            localStorage.removeItem(inProgress);
            // eslint-disable-next-line @atlaskit/platform/no-direct-web-storage-usage -- existing usage
            localStorage.setItem(queue, JSON.stringify(leftover));
            return {
                fullReclaim: false
            };
        }
    } else clearLocalStorageKeys(options.storageKeys);
    return {
        fullReclaim: true
    };
};
// Exterminate
const clearLocalStorageKeys = (keys)=>{
    // Always good to do queue and inprogress first to reduce duplications
    // and to free up more space in localstorage
    // eslint-disable-next-line @atlaskit/platform/no-direct-web-storage-usage -- existing usage
    localStorage.removeItem(keys.queue);
    // eslint-disable-next-line @atlaskit/platform/no-direct-web-storage-usage -- existing usage
    localStorage.removeItem(keys.inProgress);
    // eslint-disable-next-line @atlaskit/platform/no-direct-web-storage-usage -- existing usage
    localStorage.removeItem(keys.reclaimEnd);
    // eslint-disable-next-line @atlaskit/platform/no-direct-web-storage-usage -- existing usage
    localStorage.removeItem(keys.reclaimStart);
    // This has to be last or we risk leaving things in localStorage that have to be purged
    // eslint-disable-next-line @atlaskit/platform/no-direct-web-storage-usage -- existing usage
    localStorage.removeItem(keys.ack);
};
exports.default = async (queuePrefix, callback)=>{
    if (typeof queuePrefix !== 'string' || queuePrefix.length === 0) // We do not want to start deleting everything in localstorage
    return {
        fullReclaims: 0,
        partialReclaims: 0,
        failedReclaims: 0
    };
    const reclaimProcessId = (0, _uuidDefault.default)();
    const queuesToReclaim = findOtherQueues(queuePrefix);
    const claims = queuesToReclaim.map((id)=>tryReclaim({
            queuePrefix,
            reclaimProcessId,
            storageKeys: (0, _utils.createLocalStorageKeys)(queuePrefix, id)
        }, callback));
    const settledClaims = await Promise.allSettled(claims);
    const failedReclaims = settledClaims.filter((claim)=>claim.status === 'rejected');
    const successfulClaims = settledClaims.filter((settledValue)=>settledValue.status === 'fulfilled').map((result)=>result.value);
    const fullReclaims = successfulClaims.filter((claim)=>claim.fullReclaim);
    const partialReclaims = successfulClaims.filter((claim)=>!claim.fullReclaim);
    return {
        failedReclaims: failedReclaims.length,
        partialReclaims: partialReclaims.length,
        fullReclaims: fullReclaims.length
    };
};

},{"@swc/helpers/_/_object_spread":"9gdrV","@swc/helpers/_/_object_spread_props":"kANqQ","../uuid":"igO59","./types":"9nowW","./utils":"hziwG","@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"igO59":[function(require,module,exports,__globalThis) {
// UUID v4 generator with fallback for non-secure contexts
var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>uuid);
function uuid() {
    const g = globalThis;
    try {
        if (g.crypto && typeof g.crypto.randomUUID === 'function') return g.crypto.randomUUID();
    } catch (e) {
    // ignore and fallback
    }
    // Fallback to Math.random-based v4 UUID
    return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, (c)=>{
        const r = Math.floor(Math.random() * 16);
        const v = c === 'x' ? r : r & 0x3 | 0x8; // x => random hex digit; y => set RFC 4122 variant bits (10xx), yielding 8, 9, a, or b
        return v.toString(16);
    });
}

},{"@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"9nowW":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "LocalStorageKeySuffix", ()=>LocalStorageKeySuffix);
parcelHelpers.export(exports, "Timers", ()=>Timers);
var LocalStorageKeySuffix = /*#__PURE__*/ function(LocalStorageKeySuffix) {
    LocalStorageKeySuffix["IN_PROGRESS"] = "inProgress";
    LocalStorageKeySuffix["QUEUE"] = "queue";
    LocalStorageKeySuffix["RECLAIM_START"] = "reclaimStart";
    LocalStorageKeySuffix["RECLAIM_END"] = "reclaimEnd";
    LocalStorageKeySuffix["ACK"] = "ack";
    return LocalStorageKeySuffix;
}({});
var Timers = /*#__PURE__*/ function(Timers) {
    Timers[Timers["RECLAIM_TIMEOUT"] = 10000] = "RECLAIM_TIMEOUT";
    Timers[Timers["RECLAIM_WAIT"] = 500] = "RECLAIM_WAIT";
    Timers[Timers["RECLAIM_WAIT_THRESHOLD"] = 2000] = "RECLAIM_WAIT_THRESHOLD";
    return Timers;
}({});

},{"@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"hziwG":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "createLocalStorageKeys", ()=>createLocalStorageKeys);
var _types = require("./types");
const createLocalStorageKeys = (queuePrefix, queueId)=>({
        [(0, _types.LocalStorageKeySuffix).ACK]: `${queuePrefix}.${queueId}.${(0, _types.LocalStorageKeySuffix).ACK}`,
        [(0, _types.LocalStorageKeySuffix).QUEUE]: `${queuePrefix}.${queueId}.${(0, _types.LocalStorageKeySuffix).QUEUE}`,
        [(0, _types.LocalStorageKeySuffix).IN_PROGRESS]: `${queuePrefix}.${queueId}.${(0, _types.LocalStorageKeySuffix).IN_PROGRESS}`,
        [(0, _types.LocalStorageKeySuffix).RECLAIM_START]: `${queuePrefix}.${queueId}.${(0, _types.LocalStorageKeySuffix).RECLAIM_START}`,
        [(0, _types.LocalStorageKeySuffix).RECLAIM_END]: `${queuePrefix}.${queueId}.${(0, _types.LocalStorageKeySuffix).RECLAIM_END}`
    });

},{"./types":"9nowW","@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"31LLc":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _types = require("./types");
var _utils = require("./utils");
// For more details on this funciton, see https://hello.atlassian.net/wiki/spaces/MEASURE/pages/585086028/Investigation+Local+storage+full
// TL;DR
// If a queue looses its `ack` key in localstorage, it will never get claimed.
// There is a small chance that this can happen.
// This function is to run through queues and clean any that have been orphaned.
// Keys stolen from https://github.com/segmentio/localstorage-retry/blob/master/lib/index.js#L55
const validSuffixs = Object.values((0, _types.LocalStorageKeySuffix));
exports.default = (prefix)=>{
    if (typeof prefix !== 'string' || prefix.length === 0) // We do not want to start deleting everything in localstorage
    return 0;
    try {
        // eslint-disable-next-line @atlaskit/platform/no-direct-web-storage-usage -- existing usage
        const queueStates = Object.keys(localStorage).filter((key)=>key && key.startsWith(`${prefix}.`) || false).map((key)=>key.split('.')).filter((splitKeys)=>splitKeys.length === 3 && validSuffixs.includes(splitKeys[2])).reduce((accumulator, currentKeys)=>{
            const [, id, suffix] = currentKeys;
            if (accumulator[id] === undefined) accumulator[id] = {};
            accumulator[id][suffix] = true;
            return accumulator;
        }, {});
        const queuesToPurge = Object.keys(queueStates).filter((id)=>queueStates[id][(0, _types.LocalStorageKeySuffix).ACK] !== true);
        queuesToPurge.forEach((id)=>{
            const { queue, inProgress, reclaimStart, reclaimEnd } = (0, _utils.createLocalStorageKeys)(prefix, id);
            // eslint-disable-next-line @atlaskit/platform/no-direct-web-storage-usage -- existing usage
            localStorage.removeItem(inProgress);
            // eslint-disable-next-line @atlaskit/platform/no-direct-web-storage-usage -- existing usage
            localStorage.removeItem(queue);
            // eslint-disable-next-line @atlaskit/platform/no-direct-web-storage-usage -- existing usage
            localStorage.removeItem(reclaimStart);
            // eslint-disable-next-line @atlaskit/platform/no-direct-web-storage-usage -- existing usage
            localStorage.removeItem(reclaimEnd);
        });
        return queuesToPurge.length;
    } catch (_error) {
    // Ignore errors from localStorage.
    }
    return 0;
};

},{"./types":"9nowW","./utils":"hziwG","@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"3m3fo":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "GuardPolicy", ()=>(0, _constants.GuardPolicy));
parcelHelpers.export(exports, "StoreType", ()=>(0, _constants.StoreType));
parcelHelpers.export(exports, "CallbackProcessingErrorName", ()=>(0, _errors.CallbackProcessingErrorName));
var _dbDelegator = require("./DbDelegator");
var _dbDelegatorDefault = parcelHelpers.interopDefault(_dbDelegator);
var _constants = require("./constants");
var _errors = require("./errors");
exports.default = (0, _dbDelegatorDefault.default);

},{"./DbDelegator":"hTLZe","./constants":"hsCiv","./errors":"9MWPy","@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"hTLZe":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>DbDelegator);
var _constants = require("./constants");
var _errors = require("./errors");
var _indexedDbConnector = require("./IndexedDbConnector");
var _indexedDbConnectorDefault = parcelHelpers.interopDefault(_indexedDbConnector);
var _memoryDb = require("./MemoryDb");
var _memoryDbDefault = parcelHelpers.interopDefault(_memoryDb);
var _util = require("./util");
class DbDelegator {
    getResilienceMechanism(namespace, options) {
        if (!options.useMemory) try {
            return new (0, _indexedDbConnectorDefault.default)(namespace, options);
        } catch (error) {
            var _options_logger;
            if (!(error instanceof (0, _errors.NoIndexedDbError))) (_options_logger = options.logger) === null || _options_logger === void 0 ? void 0 : _options_logger.warn('Attempted to create IndexedDbResilience but failed. Using memory instead.');
        }
        return new (0, _memoryDbDefault.default)(this.namespace, options);
    }
    addItem(item, options, policy = (0, _constants.GuardPolicy).ABANDON) {
        return this.runOrFailOver(()=>this.resilience.addItem(item, options, policy));
    }
    bulkAddItem(itemOptions, policy = (0, _constants.GuardPolicy).ABANDON) {
        return this.runOrFailOver(()=>this.resilience.bulkAddItem(itemOptions, policy));
    }
    getItems(count) {
        return this.runOrFailOver(()=>this.resilience.getItems(count));
    }
    deleteItems(itemIds) {
        return this.runOrFailOver(()=>this.resilience.deleteItems(itemIds));
    }
    getItemCount() {
        return this.runOrFailOver(()=>this.resilience.getItemCount());
    }
    processItems(processFn, count) {
        return this.runOrFailOver(()=>this.resilience.processItems(processFn, count));
    }
    storeType() {
        return this.resilience.storeType();
    }
    async runOrFailOver(runnable) {
        try {
            return await runnable();
        } catch (error) {
            if ((0, _errors.shouldIgnoreResilienceDbError)(error)) throw error;
            else if (this.resilience.storeType() === (0, _constants.StoreType).INDEXEDDB) await this.failOver();
            return runnable();
        }
    }
    async failOver() {
        // Attempt to get any events we can and put them into memory
        const oldResilience = this.resilience;
        const newResilience = new (0, _memoryDbDefault.default)(this.namespace, this.options);
        this.resilience = newResilience;
        try {
            const { items } = await oldResilience.getItems(this.options.maxEventLimit);
            if (items.length > 0) {
                const bulkAddItemsResponse = await newResilience.bulkAddItemWrapperType(items, (0, _constants.GuardPolicy).IGNORE);
                const addedItemIds = bulkAddItemsResponse.items.map((item)=>item.id);
                await oldResilience.deleteItems(addedItemIds);
            }
        } catch (error) {
            this.options.logger.warn('Unexpected error from ResilienceDb, switching to MemoryDb');
        // Dont need to catch. We are just getting events if we can
        }
    }
    constructor(namespace, options = {}){
        this.namespace = namespace;
        this.options = (0, _util.createOptionsWithDefaults)(options);
        if (!namespace || namespace.length === 0 || typeof namespace !== 'string') throw new Error('Invalid namespace provided');
        this.resilience = this.getResilienceMechanism(namespace, options);
    }
}

},{"./constants":"hsCiv","./errors":"9MWPy","./IndexedDbConnector":"g6L9t","./MemoryDb":"k9JkY","./util":"mrOvH","@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"hsCiv":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "NAMESPACE_AND_TIME_ADDED_INDEX", ()=>NAMESPACE_AND_TIME_ADDED_INDEX);
parcelHelpers.export(exports, "RESILIENCE_DB_NAME", ()=>RESILIENCE_DB_NAME);
parcelHelpers.export(exports, "RESILIENCE_STORE_NAME", ()=>RESILIENCE_STORE_NAME);
parcelHelpers.export(exports, "TIME_TO_PROCESS_AFTER_INDEX", ()=>TIME_TO_PROCESS_AFTER_INDEX);
parcelHelpers.export(exports, "TIME_ADDED_INDEX", ()=>TIME_ADDED_INDEX);
parcelHelpers.export(exports, "RETRY_INDEX", ()=>RETRY_INDEX);
parcelHelpers.export(exports, "INDEXEDDB_TIMEOUT", ()=>INDEXEDDB_TIMEOUT);
parcelHelpers.export(exports, "StoreType", ()=>StoreType);
parcelHelpers.export(exports, "GuardPolicy", ()=>GuardPolicy);
const NAMESPACE_AND_TIME_ADDED_INDEX = 'namespace-timeAdded';
const RESILIENCE_DB_NAME = 'analytics-web-client';
const RESILIENCE_STORE_NAME = 'analytics-resilience';
const TIME_TO_PROCESS_AFTER_INDEX = 'timeToBeProcessedAfter';
const TIME_ADDED_INDEX = 'timeAdded';
const RETRY_INDEX = 'retryAttempts';
const INDEXEDDB_TIMEOUT = 15000;
var StoreType = /*#__PURE__*/ function(StoreType) {
    StoreType["INDEXEDDB"] = "indexeddb";
    StoreType["MEMORY"] = "memory";
    return StoreType;
}({});
var GuardPolicy = /*#__PURE__*/ function(GuardPolicy) {
    // Adds as many items as possible and IGONRES the rest.
    // Only to be used with BulkAdd
    GuardPolicy["IGNORE"] = "ignore";
    // ABANDON the request if not all items can be added.
    GuardPolicy["ABANDON"] = "abandon";
    // EVICT old items to make room for new items if space is tight.
    GuardPolicy["EVICT"] = "evict";
    return GuardPolicy;
}({});

},{"@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"9MWPy":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "AbandonWriteError", ()=>(0, _abandonWriteErrorDefault.default));
parcelHelpers.export(exports, "AbandonWriteErrorName", ()=>(0, _abandonWriteError.AbandonWriteErrorName));
parcelHelpers.export(exports, "CallbackProcessingError", ()=>(0, _callbackProcessingErrorDefault.default));
parcelHelpers.export(exports, "CallbackProcessingErrorName", ()=>(0, _callbackProcessingError.CallbackProcessingErrorName));
parcelHelpers.export(exports, "InvalidPolicyError", ()=>(0, _invalidPolicyErrorDefault.default));
parcelHelpers.export(exports, "InvalidPolicyErrorName", ()=>(0, _invalidPolicyError.InvalidPolicyErrorName));
parcelHelpers.export(exports, "NoIndexedDbError", ()=>(0, _noIndexedDbErrorDefault.default));
parcelHelpers.export(exports, "NoIndexedDbErrorName", ()=>(0, _noIndexedDbError.NoIndexedDbErrorName));
parcelHelpers.export(exports, "shouldIgnoreResilienceDbError", ()=>(0, _util.shouldIgnoreResilienceDbError));
var _abandonWriteError = require("./AbandonWriteError");
var _abandonWriteErrorDefault = parcelHelpers.interopDefault(_abandonWriteError);
var _callbackProcessingError = require("./CallbackProcessingError");
var _callbackProcessingErrorDefault = parcelHelpers.interopDefault(_callbackProcessingError);
var _invalidPolicyError = require("./InvalidPolicyError");
var _invalidPolicyErrorDefault = parcelHelpers.interopDefault(_invalidPolicyError);
var _noIndexedDbError = require("./NoIndexedDbError");
var _noIndexedDbErrorDefault = parcelHelpers.interopDefault(_noIndexedDbError);
var _util = require("./util");

},{"./AbandonWriteError":"1Ifnp","./CallbackProcessingError":"4wrzf","./InvalidPolicyError":"d7HId","./NoIndexedDbError":"jhYaW","./util":"hPgrg","@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"1Ifnp":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "AbandonWriteErrorName", ()=>AbandonWriteErrorName);
// eslint-disable-next-line @atlaskit/volt-strict-mode/no-multiple-exports
parcelHelpers.export(exports, "default", ()=>AbandonWriteError);
const AbandonWriteErrorName = 'AbandonWriteError';
class AbandonWriteError extends Error {
    constructor(source){
        super(`Event Limit reached. Abandoning write to: ${source}`);
        // Must reset the prototypes after calling super of builtin classes
        // https://github.com/Microsoft/TypeScript/wiki/Breaking-Changes#extending-built-ins-like-error-array-and-map-may-no-longer-work
        Object.setPrototypeOf(this, AbandonWriteError.prototype);
        this.name = AbandonWriteErrorName;
    }
}

},{"@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"4wrzf":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "CallbackProcessingErrorName", ()=>CallbackProcessingErrorName);
// eslint-disable-next-line @atlaskit/volt-strict-mode/no-multiple-exports
parcelHelpers.export(exports, "default", ()=>CallbackProcessingError);
const CallbackProcessingErrorName = 'CallbackProcessingError';
class CallbackProcessingError extends Error {
    constructor(error){
        const messageFromError = error && typeof error === 'object' && 'toString' in error && typeof error.toString === 'function' && error.toString();
        const messageFromString = typeof error === 'string' && error;
        const message = messageFromError || messageFromString || 'Argument passed to CallbackProcessingError was not an Error or string.';
        super(`Error thrown while processing events in callback: ${message}`);
        // Must reset the prototypes after calling super of builtin classes
        // https://github.com/Microsoft/TypeScript/wiki/Breaking-Changes#extending-built-ins-like-error-array-and-map-may-no-longer-work
        Object.setPrototypeOf(this, CallbackProcessingError.prototype);
        this.name = CallbackProcessingErrorName;
    }
}

},{"@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"d7HId":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "InvalidPolicyErrorName", ()=>InvalidPolicyErrorName);
// eslint-disable-next-line @atlaskit/volt-strict-mode/no-multiple-exports
parcelHelpers.export(exports, "default", ()=>InvalidPolicyError);
const InvalidPolicyErrorName = 'InvalidPolicyError';
class InvalidPolicyError extends Error {
    constructor(policy, method){
        super(`Method '${method}' cannot be called with policy '${policy}'.`);
        this.name = InvalidPolicyErrorName;
    }
}

},{"@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"jhYaW":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "NoIndexedDbErrorName", ()=>NoIndexedDbErrorName);
/*
 Only to be used with window.indexeddb is undefined.
 This will prevent DbDelegator from logging errors, but will not prevent swapping to memoryDB
*/ // eslint-disable-next-line @atlaskit/volt-strict-mode/no-multiple-exports
parcelHelpers.export(exports, "default", ()=>NoIndexedDbError);
const NoIndexedDbErrorName = 'NoIndexedDbError';
class NoIndexedDbError extends Error {
    constructor(){
        super('window.indexeddb is undefined.');
        // Must reset the prototypes after calling super of builtin classes
        // https://github.com/Microsoft/TypeScript/wiki/Breaking-Changes#extending-built-ins-like-error-array-and-map-may-no-longer-work
        Object.setPrototypeOf(this, NoIndexedDbError.prototype);
        this.name = NoIndexedDbErrorName;
    }
}

},{"@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"hPgrg":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "shouldIgnoreResilienceDbError", ()=>shouldIgnoreResilienceDbError);
var _abandonWriteError = require("./AbandonWriteError");
var _callbackProcessingError = require("./CallbackProcessingError");
var _invalidPolicyError = require("./InvalidPolicyError");
const shouldIgnoreResilienceDbError = (error)=>{
    if (error && typeof error === 'object' && 'name' in error) {
        const errorWithName = error;
        return typeof errorWithName.name === 'string' && (errorWithName.name === (0, _abandonWriteError.AbandonWriteErrorName) || errorWithName.name === (0, _callbackProcessingError.CallbackProcessingErrorName) || errorWithName.name === (0, _invalidPolicyError.InvalidPolicyErrorName));
    }
    return false;
};

},{"./AbandonWriteError":"1Ifnp","./CallbackProcessingError":"4wrzf","./InvalidPolicyError":"d7HId","@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"g6L9t":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
/**
 * We have rolled our own client for IndexedDb as many Indexeddb libraries are
 * not flexible enough for our use case of:
 * 1. Adding specific indexes for time,
 * 2. Getting items on a specific index,
 * 3. Updating a field on an event while getting the event inside of a single ACID compliant transaction.
 */ parcelHelpers.export(exports, "default", ()=>IndexedDbConnector);
var _objectSpread = require("@swc/helpers/_/_object_spread");
var _objectWithoutProperties = require("@swc/helpers/_/_object_without_properties");
var _constants = require("./constants");
var _defaults = require("./defaults");
var _errors = require("./errors");
var _indexedDbEventCountGuard = require("./IndexedDbEventCountGuard");
var _indexedDbEventCountGuardDefault = parcelHelpers.interopDefault(_indexedDbEventCountGuard);
var _util = require("./util");
class IndexedDbConnector {
    storeType() {
        return (0, _constants.StoreType).INDEXEDDB;
    }
    constructor(namespace, options = {}){
        this.startDB = async ()=>{
            return new Promise(async (resolve, reject)=>{
                if (typeof window !== 'undefined') {
                    const dbTimeout = window.setTimeout(()=>{
                        this.logger.warn('IndexedDB timed out.');
                        reject(new (0, _errors.NoIndexedDbError)());
                    }, (0, _constants.INDEXEDDB_TIMEOUT));
                    /*
				 * The database version number can never change.
				 * An upgrade transaction is limited to only one connection to the database.
				 * Once this is done, we cannot open any connections with older versions of the schema.
				 * https://www.w3.org/TR/IndexedDB/#upgrade-transaction-construct
				 *
				 * Due to the nature of how AWC is used (multiple tabs that are very long lived),
				 * we will not be able to run version upgrades via indexeddb.
				 *
				 * This does not mean we cant change what is stored in the tables,
				 * this limitation just prevents us from:
				 *   - Creating new ObjectStores in this database connection, and
				 *   - Creating new indexes on our ObjectStores
				 *
				 * Any upgrades we wish to run in the future will have to create a new database,
				 * and migrate all the data from older databases.
				 *
				 * This also means any migrations we make will have to be supported until we have evidence
				 * that no events are coming from old versions of the database.
				 * This may take a long time.
				 */ const request = window.indexedDB.open((0, _constants.RESILIENCE_DB_NAME), 1);
                    request.onupgradeneeded = (event)=>{
                        if (event.oldVersion !== 0) throw new Error('We cannot upgrade the database. Do not do this.');
                        const db = request.result;
                        const store = db.createObjectStore((0, _constants.RESILIENCE_STORE_NAME), {
                            keyPath: 'id'
                        });
                        store.createIndex((0, _constants.TIME_TO_PROCESS_AFTER_INDEX), (0, _constants.TIME_TO_PROCESS_AFTER_INDEX), {
                            unique: false
                        });
                        store.createIndex((0, _constants.RETRY_INDEX), (0, _constants.RETRY_INDEX), {
                            unique: false
                        });
                        store.createIndex((0, _constants.TIME_ADDED_INDEX), (0, _constants.TIME_ADDED_INDEX), {
                            unique: false
                        });
                        // Compound key index of product - timeAdded.
                        store.createIndex((0, _constants.NAMESPACE_AND_TIME_ADDED_INDEX), [
                            'namespace',
                            'timeAdded'
                        ], {
                            unique: false
                        });
                    };
                    request.onerror = function() {
                        reject(new (0, _errors.NoIndexedDbError)());
                    };
                    try {
                        await (0, _util.requestToPromise)(request);
                        return resolve(request.result);
                    } catch (error) {
                        this.logger.warn('IndexedDB failed to initialise.', error);
                        reject(new (0, _errors.NoIndexedDbError)());
                    } finally{
                        window.clearTimeout(dbTimeout);
                    }
                } else {
                    this.logger.warn("IndexedDB failed to initialise. No 'window' object.");
                    reject(new (0, _errors.NoIndexedDbError)());
                }
            });
        };
        this.addItem = async (item, options = {}, policy = (0, _constants.GuardPolicy).ABANDON)=>{
            const { logger, namespace } = this;
            const value = (0, _util.convertToItemWrapper)(item, namespace, options);
            const { objectStore } = await this.getObjectStoreAndTransaction('readwrite');
            if (policy === (0, _constants.GuardPolicy).IGNORE) throw new (0, _errors.InvalidPolicyError)(policy, 'IndexedDbConnector#addItem');
            try {
                if (!value.namespace || value.namespace.length === 0 || typeof value.namespace !== 'string') throw new Error('Namespace not specified');
                // Making space for 1 event, if required.
                const bulkAddResult = await this.globalEventLimitGuard.insertItems(objectStore, [
                    value
                ], policy);
                if (bulkAddResult.items.length === 1) return {
                    item: bulkAddResult.items[0],
                    numberOfEvictedItems: bulkAddResult.numberOfEvictedItems
                };
                // Should never happen as the Policy and EventCountGuard should cause another pathway
                throw new Error(`Incorrect number of items added. Expected: 1, got: ${bulkAddResult.items.length}`);
            } catch (error) {
                if ((0, _errors.shouldIgnoreResilienceDbError)(error)) throw error;
                logger.log('Failed to add item to table', error);
                throw new Error('Request to add item to table failed');
            }
        };
        this.bulkAddItem = async (itemOptions, policy = (0, _constants.GuardPolicy).ABANDON)=>{
            const { logger, namespace } = this;
            const items = itemOptions.map((_param)=>{
                var { item } = _param, options = (0, _objectWithoutProperties._)(_param, [
                    "item"
                ]);
                return (0, _util.convertToItemWrapper)(item, namespace, options);
            });
            const { objectStore } = await this.getObjectStoreAndTransaction('readwrite');
            try {
                return await this.globalEventLimitGuard.insertItems(objectStore, items, policy);
            } catch (error) {
                if ((0, _errors.shouldIgnoreResilienceDbError)(error)) throw error;
                logger.log('Failed to add item to table', error);
                throw new Error('Request to add item to table failed');
            }
        };
        this.getItems = async (count = (0, _defaults.GET_ITEM_COUNT))=>{
            const fixedCount = count > 0 ? count : (0, _defaults.GET_ITEM_COUNT);
            const { logger } = this;
            const maxAttempts = this.options.maxAttempts;
            const { transaction, objectStore } = await this.getObjectStoreAndTransaction('readwrite');
            const timeIndex = objectStore.index((0, _constants.TIME_TO_PROCESS_AFTER_INDEX));
            const upperBoundOpenKeyRange = IDBKeyRange.upperBound(Date.now());
            const request = timeIndex.openCursor(upperBoundOpenKeyRange);
            const getResult = await new Promise(async (resolve, reject)=>{
                const items = [];
                let numberOfDeletedItems = 0;
                request.onerror = (error)=>{
                    logger.error('Failed to open cursor:', error);
                    reject('Failed to open cursor');
                };
                // Requests for Cursors call onsuccess multiple times and cannot be converted to promises
                request.onsuccess = (event)=>{
                    const cursor = event.target.result;
                    if (cursor) {
                        // Prevent mutation of the value we are returning
                        const value = (0, _objectSpread._)({}, cursor.value);
                        items.push(value);
                        // Mutations seem to be required for testing indexeddb library
                        const updatedValue = cursor.value;
                        updatedValue.retryAttempts += 1;
                        updatedValue.timeToBeProcessedAfter = Date.now() + (0, _defaults.VISIBILITY_TIMEOUT);
                        if (updatedValue.retryAttempts >= maxAttempts) {
                            ++numberOfDeletedItems;
                            const request = cursor.delete();
                            (0, _util.monitorErrorsOnRequest)(request, logger);
                        } else {
                            const request = cursor.update(updatedValue);
                            (0, _util.monitorErrorsOnRequest)(request, logger);
                        }
                        if (items.length < fixedCount) cursor.continue();
                        else resolve({
                            items,
                            numberOfDeletedItems
                        });
                    } else resolve({
                        items,
                        numberOfDeletedItems
                    });
                };
            });
            await (0, _util.commitTransaction)(transaction, this.logger);
            return getResult;
        };
        this.deleteItems = async (itemIds)=>{
            const { transaction, objectStore } = await this.getObjectStoreAndTransaction('readwrite');
            try {
                const deletePromises = itemIds.map((id)=>this.deleteItem(objectStore, id));
                await (0, _util.commitTransaction)(transaction, this.logger);
                await Promise.all(deletePromises);
            } catch (error) {
                this.logger.warn('Failed to delete items from indexeddb.', error);
                throw error;
            }
        };
        this.getItemCount = async ()=>{
            const { transaction, objectStore } = await this.getObjectStoreAndTransaction('readonly');
            const timeIndex = objectStore.index((0, _constants.TIME_TO_PROCESS_AFTER_INDEX));
            const upperBoundOpenKeyRange = IDBKeyRange.upperBound(Date.now());
            const request = timeIndex.count(upperBoundOpenKeyRange);
            const event = await (0, _util.requestToPromise)(request);
            await (0, _util.commitTransaction)(transaction, this.logger);
            return event.target.result;
        };
        this.processItems = async (processFn, count = (0, _defaults.GET_ITEM_COUNT))=>{
            const _ref = await this.getItems(count), { items } = _ref, partialResult = (0, _objectWithoutProperties._)(_ref, [
                "items"
            ]);
            try {
                const result = await processFn(items, partialResult);
                const itemIds = items.map((item)=>item.id);
                // We should not await this delete as a rejected promise would get caught by the catch statement
                await this.deleteItems(itemIds);
                return result;
            } catch (error) {
                // Eventually we will need a intermediate class to catch all errors but we should ignore this error
                // This allows libraries beneath to distinguish between a success or failure in processing to update schedulers or anything else
                // To provide back off or any other mechanism to allow what ever is cauing the errors to recover
                throw new (0, _errors.CallbackProcessingError)(error);
            }
        };
        this.deleteItem = async (objectStore, id)=>{
            const { logger } = this;
            try {
                await (0, _util.requestToPromise)(objectStore.delete(id));
            } catch (error) {
                logger.error('Failed to delete item:', id, error);
                throw error;
            }
        };
        this.getObjectStoreAndTransaction = async (mode)=>{
            const transaction = (await this.db).transaction((0, _constants.RESILIENCE_STORE_NAME), mode);
            const objectStore = transaction.objectStore((0, _constants.RESILIENCE_STORE_NAME));
            return {
                transaction,
                objectStore
            };
        };
        this.options = (0, _util.createOptionsWithDefaults)(options);
        this.namespace = namespace;
        this.logger = this.options.logger;
        if (!window.indexedDB) throw new (0, _errors.NoIndexedDbError)();
        this.db = this.startDB();
        // We just swallow any errors as we know that these are intermittent errors
        // when switching from indexeddb -> localStorage
        this.db.catch(()=>{});
        /**
		 *
		 * This class will enforce the number of analytics events we can store in our IndexedDB object store
		 * if asked before adding items to the object store.
		 */ this.globalEventLimitGuard = new (0, _indexedDbEventCountGuardDefault.default)(this.options.maxEventLimit, this.namespace, this.logger, this.deleteItem);
    }
}

},{"@swc/helpers/_/_object_spread":"9gdrV","@swc/helpers/_/_object_without_properties":"6HqIM","./constants":"hsCiv","./defaults":"hPUzU","./errors":"9MWPy","./IndexedDbEventCountGuard":"emraS","./util":"mrOvH","@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"hPUzU":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "GET_ITEM_COUNT", ()=>GET_ITEM_COUNT);
parcelHelpers.export(exports, "VISIBILITY_TIMEOUT", ()=>VISIBILITY_TIMEOUT);
parcelHelpers.export(exports, "MAX_ATTEMPTS", ()=>MAX_ATTEMPTS);
parcelHelpers.export(exports, "EVENT_COUNT_LIMIT", ()=>EVENT_COUNT_LIMIT);
const GET_ITEM_COUNT = 7;
const VISIBILITY_TIMEOUT = 60000;
const MAX_ATTEMPTS = 10;
const EVENT_COUNT_LIMIT = 8000;

},{"@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"emraS":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
/**
 * A class to enforce a limit on the amount of Analytics Events stored in AWC IndexedDb.
 */ parcelHelpers.export(exports, "default", ()=>IndexedDbEventCountGuard);
var _constants = require("./constants");
var _errors = require("./errors");
var _util = require("./util");
class IndexedDbEventCountGuard {
    /**
	 * This function checks the number of events currently in AWC IndexedDB object store and if necessary,
	 * will evict the oldest events in favour of the events we want to add.
	 *
	 * The indexed is treated as effectively: partitioned by product and sorted by timeAdded.
	 *
	 * This function can be re-used when the bulk add functionality is added in IndexedDbConnector.
	 *
	 * @param countOfEventsToAdd - The number of events we are proposing to add.
	 */ async insertItems(objectStore, items, policy = (0, _constants.GuardPolicy).ABANDON) {
        const itemsToAdd = [
            ...items
        ];
        let numberOfEvictedItems = 0;
        switch(policy){
            case (0, _constants.GuardPolicy).ABANDON:
                await this.throwIfNotEnoughSpace(objectStore, items.length);
                break;
            case (0, _constants.GuardPolicy).EVICT:
                numberOfEvictedItems = await this.evictIfNotEnoughSpace(objectStore, items.length);
                break;
            case (0, _constants.GuardPolicy).IGNORE:
                // Removed items from `itemsToAdd` if there is insufficient space
                await this.calculateHowManyEventsWeCanAdd(objectStore, itemsToAdd);
                break;
        }
        const promises = itemsToAdd.map((item)=>(0, _util.requestToPromise)(objectStore.add(item)));
        await Promise.all(promises);
        await (0, _util.commitTransaction)(objectStore.transaction, this.logger);
        return {
            items: itemsToAdd,
            numberOfEvictedItems
        };
    }
    async throwIfNotEnoughSpace(objectStore, requiredSpace) {
        const freeSpace = await this.calculateFreeSpace(objectStore);
        if (freeSpace < requiredSpace) throw new (0, _errors.AbandonWriteError)(`Not enough space in IndexedDb. Needed ${requiredSpace} but only had ${freeSpace}`);
    }
    async evictIfNotEnoughSpace(objectStore, requiredSpace) {
        const freeSpace = await this.calculateFreeSpace(objectStore);
        if (freeSpace < requiredSpace) {
            const extraSpace = requiredSpace - freeSpace;
            await this.deleteOldestNEvents(objectStore, extraSpace);
            return extraSpace;
        }
        return 0;
    }
    async calculateHowManyEventsWeCanAdd(objectStore, items) {
        const freeSpace = await this.calculateFreeSpace(objectStore);
        if (freeSpace < items.length) {
            const numberOfItemsToRemove = items.length - freeSpace;
            const start = items.length - numberOfItemsToRemove;
            items.splice(start, numberOfItemsToRemove);
        }
    }
    async calculateFreeSpace(objectStore) {
        const numberOfEventsInDb = await this.getCountofEventsInObjectStore(objectStore);
        return this.eventLimit - numberOfEventsInDb;
    }
    /**
	 * This query returns the count of items held in AWC IndexedDB object store per product.
	 */ async getCountofEventsInObjectStore(objectStore) {
        const productTimeAddedIndex = objectStore.index((0, _constants.NAMESPACE_AND_TIME_ADDED_INDEX));
        const keyRangeValues = IDBKeyRange.bound([
            this.namespace,
            0
        ], [
            this.namespace,
            Date.now()
        ]);
        const request = productTimeAddedIndex.count(keyRangeValues);
        const event = await (0, _util.requestToPromise)(request);
        return event.target.result;
    }
    constructor(eventLimit, namespace, logger, deleteItemHandler){
        /**
	 * This query fetches the oldest events currently stored in AWC IndexedDb object store
	 * and deletes them sequentially
	 */ this.deleteOldestNEvents = async (objectStore, count)=>{
            var _event_target;
            const productTimeAddedIndex = objectStore.index((0, _constants.NAMESPACE_AND_TIME_ADDED_INDEX));
            const keyRangeValues = IDBKeyRange.bound([
                this.namespace,
                0
            ], [
                this.namespace,
                Date.now()
            ]);
            const getAllRequest = productTimeAddedIndex.getAllKeys(keyRangeValues, count);
            const event = await (0, _util.requestToPromise)(getAllRequest);
            const result = event === null || event === void 0 ? void 0 : (_event_target = event.target) === null || _event_target === void 0 ? void 0 : _event_target.result;
            // Adding extra safety
            if (result && Array.isArray(result) && result.length > 0) try {
                const deletePromises = result.map((item)=>this.deleteItemHandler(objectStore, item));
                await Promise.all(deletePromises);
            } catch (error) {
                this.logger.warn('Failed to delete items from indexeddb.', error);
                throw error;
            }
        };
        if (eventLimit > 0) this.eventLimit = eventLimit;
        else throw Error('Event Limit has to be set higher than 1');
        this.namespace = namespace;
        this.logger = logger;
        this.deleteItemHandler = deleteItemHandler;
    }
}

},{"./constants":"hsCiv","./errors":"9MWPy","./util":"mrOvH","@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"mrOvH":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "convertToItemWrapper", ()=>convertToItemWrapper);
parcelHelpers.export(exports, "createOptionsWithDefaults", ()=>createOptionsWithDefaults);
parcelHelpers.export(exports, "requestToPromise", ()=>requestToPromise);
parcelHelpers.export(exports, "transactionToPromise", ()=>transactionToPromise);
parcelHelpers.export(exports, "commitTransaction", ()=>commitTransaction);
parcelHelpers.export(exports, "monitorErrorsOnRequest", ()=>monitorErrorsOnRequest);
var _uuid = require("../uuid");
var _uuidDefault = parcelHelpers.interopDefault(_uuid);
var _defaults = require("./defaults");
const convertToItemWrapper = (item, namespace, { id, retryAttempts, timeToProcessOffset })=>({
        item,
        id: id || (0, _uuidDefault.default)(),
        retryAttempts: retryAttempts || 0,
        timeToBeProcessedAfter: Date.now() + (timeToProcessOffset || 0),
        namespace,
        timeAdded: Date.now()
    });
const createOptionsWithDefaults = (options)=>({
        logger: options.logger || console,
        useMemory: options.useMemory || false,
        maxAttempts: options.maxAttempts || (0, _defaults.MAX_ATTEMPTS),
        // This is so that we can customise `maxEventLimit`, primarily for testing.
        maxEventLimit: options.maxEventLimit || (0, _defaults.EVENT_COUNT_LIMIT)
    });
const requestToPromise = (request)=>{
    return new Promise((resolve, reject)=>{
        request.onsuccess = (event)=>{
            resolve(event);
        };
        request.onerror = (event)=>{
            reject(event);
        };
    });
};
const transactionToPromise = (transaction)=>{
    return new Promise((resolve, reject)=>{
        // We will have to see how much cost there is to waiting for the transaction to complete in the real world.
        // In theory in some cases we could return as soon as the request is complete and
        // just monitor errors on transactions with the logger.
        // This maybe more of an issue in Safari and other older browsers where commit isnt available
        // and we would have to wait for the transaction to complete itself.
        transaction.oncomplete = ()=>{
            resolve();
        };
        transaction.onerror = (event)=>{
            reject(event);
        };
        transaction.onabort = (event)=>{
            reject(event);
        };
    });
};
const commitTransaction = (transaction, logger)=>{
    try {
        if (typeof transaction.commit === 'function') transaction.commit();
    } catch (error) {
        logger.error('Failed to force commit transaction:', error);
        throw error;
    }
    return transactionToPromise(transaction);
};
const monitorErrorsOnRequest = (request, logger)=>{
    request.onerror = (event)=>{
        logger.warn('Error thrown from request:', event);
    };
};

},{"../uuid":"igO59","./defaults":"hPUzU","@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"k9JkY":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>MemoryDb);
var _objectSpread = require("@swc/helpers/_/_object_spread");
var _objectWithoutProperties = require("@swc/helpers/_/_object_without_properties");
var _constants = require("./constants");
var _defaults = require("./defaults");
var _errors = require("./errors");
var _memoryDbEventCountGuard = require("./MemoryDbEventCountGuard");
var _memoryDbEventCountGuardDefault = parcelHelpers.interopDefault(_memoryDbEventCountGuard);
var _util = require("./util");
class MemoryDb {
    /**
	 * This method is used mainly to write new events to MemoryDB and uses the MEMORY_DB_GUARD_POLICY.EVICT_OLDEST_IF_LIMIT_EXECEEDED policy
	 * to removes oldest events when limit is reached.
	 */ async addItem(item, options = {}, policy = (0, _constants.GuardPolicy).ABANDON) {
        if (policy === (0, _constants.GuardPolicy).IGNORE) throw new (0, _errors.InvalidPolicyError)(policy, 'IndexedDbConnector#addItem');
        const storedValue = (0, _util.convertToItemWrapper)(item, this.namespace, options);
        // Delegated responsiblity to event limit guard to insert to memory stored
        const bulkAddItemsResult = await this.globalEventLimitGuard.insertItemsToMemoryStore([
            storedValue
        ], policy);
        return Promise.resolve({
            item: bulkAddItemsResult.items[0],
            numberOfEvictedItems: bulkAddItemsResult.numberOfEvictedItems
        });
    }
    bulkAddItem(itemOptions, policy = (0, _constants.GuardPolicy).ABANDON) {
        const items = itemOptions.map((_param)=>{
            var { item } = _param, addOptions = (0, _objectWithoutProperties._)(_param, [
                "item"
            ]);
            return (0, _util.convertToItemWrapper)(item, this.namespace, addOptions);
        });
        return this.bulkAddItemWrapperType(items, policy);
    }
    /**
	 * This method is used mainly to write events to MemoryDB when unknown errors are thrown from IndexedDB.
	 */ bulkAddItemWrapperType(items, policy = (0, _constants.GuardPolicy).ABANDON) {
        return Promise.resolve(this.globalEventLimitGuard.insertItemsToMemoryStore(items, policy));
    }
    getItems(count = (0, _defaults.GET_ITEM_COUNT)) {
        return Promise.resolve(this.synchronousGetItems(count));
    }
    synchronousGetItems(count = (0, _defaults.GET_ITEM_COUNT)) {
        const fixedCount = count > 0 ? count : (0, _defaults.GET_ITEM_COUNT);
        const now = Date.now();
        const wrappedItems = [];
        const itemsToRemove = [];
        for (let wrappedItem of this.memoryStore){
            if (wrappedItem.timeToBeProcessedAfter <= now) {
                wrappedItems.push((0, _objectSpread._)({}, wrappedItem));
                // Mutates the item in the memoryStore array, but not whats inside of wrappedItems
                wrappedItem.timeToBeProcessedAfter += (0, _defaults.VISIBILITY_TIMEOUT);
                wrappedItem.retryAttempts += 1;
                if (wrappedItem.retryAttempts >= this.options.maxAttempts) itemsToRemove.push(wrappedItem);
            }
            if (wrappedItems.length >= fixedCount) break;
        }
        itemsToRemove.forEach((item)=>{
            const index = this.memoryStore.indexOf(item);
            this.memoryStore.splice(index, 1);
        });
        return {
            items: wrappedItems,
            numberOfDeletedItems: itemsToRemove.length
        };
    }
    deleteItems(itemIds) {
        this.memoryStore = this.memoryStore.filter((item)=>!itemIds.includes(item.id));
        return Promise.resolve(void 0);
    }
    getItemCount() {
        const now = Date.now();
        const count = this.memoryStore.filter((item)=>item.timeToBeProcessedAfter <= now).length;
        return Promise.resolve(count);
    }
    async processItems(processFn, count) {
        const _this_synchronousGetItems = this.synchronousGetItems(count), { items } = _this_synchronousGetItems, partialGetResult = (0, _objectWithoutProperties._)(_this_synchronousGetItems, [
            "items"
        ]);
        const itemIds = items.map((i)=>i.id);
        try {
            const result = await processFn(items, partialGetResult);
            await this.deleteItems(itemIds);
            return result;
        } catch (error) {
            throw new (0, _errors.CallbackProcessingError)(error);
        }
    }
    storeType() {
        return (0, _constants.StoreType).MEMORY;
    }
    /**
	 * This function is adding items to the tail of the memoryStore and as it adds new items it keeps the
	 * memory store sorted by timeAdded property. This makes evictions easier and adding elements to
	 * memoryStore much faster.
	 *
	 * @param itemsToAdd
	 */ addItems(itemsToAdd) {
        this.memoryStore.push(...itemsToAdd);
        // Sorting everytime, intentionally.
        this.memoryStore.sort(function(a, b) {
            return a.timeAdded - b.timeAdded;
        });
    }
    /**
	 * This function checks the number of events currently in AWC MemoryDb and if necessary,
	 * will evict the oldest events in favour of the events we want to add.
	 *
	 * @param countOfEventsToAdd - The number of events we are proposing to add.
	 */ evictEventsIfNeeded(eventLimit) {
        const numberOfEventsInDb = this.memoryStore.length;
        // The number of analytics events currently in MemoryDb and
        // the Z events we are proposing to add will exceed our event count limit.
        if (numberOfEventsInDb > eventLimit) {
            const m = numberOfEventsInDb - eventLimit;
            // Removing oldest M events
            this.memoryStore.splice(0, m);
            return m;
        }
        return 0;
    }
    constructor(namespace, options = {}){
        this.namespace = namespace;
        this.memoryStore = [];
        this.options = (0, _util.createOptionsWithDefaults)(options);
        /**
		 * This class will enforce the number of analytics events we can store in our MemoryDb
		 */ this.globalEventLimitGuard = new (0, _memoryDbEventCountGuardDefault.default)(this.options.maxEventLimit, {
            addItems: this.addItems.bind(this),
            getItemCount: this.getItemCount.bind(this),
            evictEventsIfNeeded: this.evictEventsIfNeeded.bind(this)
        });
    }
}

},{"@swc/helpers/_/_object_spread":"9gdrV","@swc/helpers/_/_object_without_properties":"6HqIM","./constants":"hsCiv","./defaults":"hPUzU","./errors":"9MWPy","./MemoryDbEventCountGuard":"9d1cU","./util":"mrOvH","@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"9d1cU":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>MemoryDbEventCountGuard);
var _constants = require("./constants");
var _errors = require("./errors");
class MemoryDbEventCountGuard {
    async handleAbandonIfLimitWillExceedPolicy(itemsToAdd) {
        const itemCount = await this.memoryItemHandlers.getItemCount();
        if (itemCount + itemsToAdd.length > this.eventLimit) throw new (0, _errors.AbandonWriteError)((0, _constants.StoreType).MEMORY);
        this.memoryItemHandlers.addItems(itemsToAdd);
        return {
            items: itemsToAdd,
            numberOfEvictedItems: 0
        };
    }
    handleEvictOldestIfLimitExceededPolicy(itemsToAdd) {
        this.memoryItemHandlers.addItems(itemsToAdd);
        const numberOfEvictedItems = this.memoryItemHandlers.evictEventsIfNeeded(this.eventLimit);
        return {
            items: itemsToAdd,
            numberOfEvictedItems
        };
    }
    async handleAddAsManyAsPossible(itemsToAdd) {
        const freeSpace = this.eventLimit - await this.memoryItemHandlers.getItemCount();
        const partialEventsToAdd = freeSpace > itemsToAdd.length ? itemsToAdd : itemsToAdd.slice(0, freeSpace);
        this.memoryItemHandlers.addItems(partialEventsToAdd);
        return {
            items: partialEventsToAdd,
            numberOfEvictedItems: 0
        };
    }
    constructor(eventLimit, memoryItemHandlers){
        /**
	 * Unlike IndexedDb, we cannot take advantage of any index. So we are,
	 * treating the memory store as a sorted set when adding items.
	 */ this.insertItemsToMemoryStore = (itemsToAdd, policy)=>{
            switch(policy){
                case (0, _constants.GuardPolicy).ABANDON:
                    return this.handleAbandonIfLimitWillExceedPolicy(itemsToAdd);
                case (0, _constants.GuardPolicy).EVICT:
                    return Promise.resolve(this.handleEvictOldestIfLimitExceededPolicy(itemsToAdd));
                case (0, _constants.GuardPolicy).IGNORE:
                    return this.handleAddAsManyAsPossible(itemsToAdd);
            }
        };
        if (eventLimit > 0) this.eventLimit = eventLimit;
        else throw Error('Event Limit has to be set higher than 1');
        this.memoryItemHandlers = memoryItemHandlers;
    }
}

},{"./constants":"hsCiv","./errors":"9MWPy","@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"5vgpA":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "MetricsCollector", ()=>MetricsCollector);
var _types = require("./types");
class MetricsCollector {
    addToItemsDiscardedByRetryCounter(numberOfDeletedEvents = 1) {
        this.itemsDiscardedByRetry += numberOfDeletedEvents;
    }
    addToEventCount() {
        this.eventCount++;
    }
    addToItemsDiscardedByOverflowCounter(numberOfDeletedEvents = 1) {
        this.itemsDiscardedByOverflow += numberOfDeletedEvents;
    }
    setResilienceMechanism(mechanism) {
        this.resilienceMechanism = mechanism;
    }
    /* <Localstorage specific> */ addToReclaimMetrics(reclaimMetrics) {
        this.localstorageNumberOfFullReclaims += reclaimMetrics.fullReclaims;
        this.localstorageNumberOfPartialReclaims += reclaimMetrics.partialReclaims;
        this.localstorageNumberOfFailedReclaims += reclaimMetrics.failedReclaims;
    }
    addToPurgedQueuesMetrics(numberOfQueuesPurged) {
        this.localstorageNumberOfQueuesPurged += numberOfQueuesPurged;
    }
    /* </Localstorage specific> */ subtractFromMetrics(sentMetrics) {
        this.itemsDiscardedByRetry = this.subtractFromCount(this.itemsDiscardedByRetry, sentMetrics.itemsDiscardedByRetry);
        this.eventCount = this.subtractFromCount(this.eventCount, sentMetrics.eventCount);
        this.itemsDiscardedByOverflow = this.subtractFromCount(this.itemsDiscardedByOverflow, sentMetrics.itemsDiscardedByOverflow);
        // Localstorage specific
        this.localstorageNumberOfFullReclaims = this.subtractFromCount(this.localstorageNumberOfFullReclaims, sentMetrics.fullReclaims);
        this.localstorageNumberOfPartialReclaims = this.subtractFromCount(this.localstorageNumberOfPartialReclaims, sentMetrics.partialReclaims);
        this.localstorageNumberOfFailedReclaims = this.subtractFromCount(this.localstorageNumberOfFailedReclaims, sentMetrics.failedReclaims);
        this.localstorageNumberOfQueuesPurged = this.subtractFromCount(this.localstorageNumberOfQueuesPurged, sentMetrics.localstorageQueuesPurged);
    }
    subtractFromCount(count, subtract) {
        return Math.max(count - (subtract || 0), 0);
    }
    getMetricsPayload() {
        return {
            itemsDiscardedByRetry: this.itemsDiscardedByRetry,
            eventCount: this.eventCount,
            itemsDiscardedByOverflow: this.itemsDiscardedByOverflow,
            resilienceMechanism: this.resilienceMechanism,
            // Localstorage specific
            localstorageQueuesPurged: this.localstorageNumberOfQueuesPurged,
            fullReclaims: this.localstorageNumberOfFullReclaims,
            partialReclaims: this.localstorageNumberOfPartialReclaims,
            failedReclaims: this.localstorageNumberOfFailedReclaims
        };
    }
    constructor(){
        // Number of events discarded due to exceeding retry limits.
        this.itemsDiscardedByRetry = 0;
        // Number of events created by the product in current tab.
        this.eventCount = 0;
        // Number of events discarded due to reaching queue max size.
        this.itemsDiscardedByOverflow = 0;
        // Will be used in the future when we get more resilience mechanisms
        this.resilienceMechanism = (0, _types.ResilienceMechanism).INDEXEDDB;
        /* --- LocalStorage specific metrics --- */ // Emitted by purgeOrphanedQueues to tell us how many queues we have had to clean up due to
        // https://github.com/segmentio/localstorage-retry/pull/17
        this.localstorageNumberOfQueuesPurged = 0;
        // Emitted by reclaimEvents to tell us how many queues were seen in the process of reclaim.
        // We will only emit metrics for queues that are not currently being maintained (i.e. `ack` is not being updated).
        // Queue was found, all events removed and put into resilienceDb.
        this.localstorageNumberOfFullReclaims = 0;
        // Queue was found but not all events were able to be put into resilienceDb.
        this.localstorageNumberOfPartialReclaims = 0;
        // Reclaim failed for a queue and reclaim was abandonded.
        this.localstorageNumberOfFailedReclaims = 0;
    }
}
let cachedMetricsClient = null;
// eslint-disable-next-line @atlaskit/volt-strict-mode/no-multiple-exports
exports.default = ()=>{
    if (!cachedMetricsClient) cachedMetricsClient = new MetricsCollector();
    return cachedMetricsClient;
};

},{"./types":"lKhoc","@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"lKhoc":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "ResilienceMechanism", ()=>ResilienceMechanism);
parcelHelpers.export(exports, "NetworkStatusEnum", ()=>NetworkStatusEnum);
var ResilienceMechanism = /*#__PURE__*/ function(ResilienceMechanism) {
    ResilienceMechanism["INDEXEDDB"] = "indexeddb";
    ResilienceMechanism["MEMORY"] = "memory";
    return ResilienceMechanism;
}({});
var NetworkStatusEnum = /*#__PURE__*/ function(NetworkStatusEnum) {
    NetworkStatusEnum[NetworkStatusEnum["ONLINE"] = 0] = "ONLINE";
    NetworkStatusEnum[NetworkStatusEnum["OFFLINE"] = 1] = "OFFLINE";
    return NetworkStatusEnum;
}({});

},{"@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"8vxyr":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>NetworkStatus);
var _types = require("./types");
class NetworkStatus {
    removeListeners() {
        if (typeof window !== 'undefined') {
            window.addEventListener('offline', ()=>this._networkChangeCallback((0, _types.NetworkStatusEnum).OFFLINE));
            window.addEventListener('online', ()=>this._networkChangeCallback((0, _types.NetworkStatusEnum).ONLINE));
        }
    }
    getNetworkStatus() {
        if (window.navigator.onLine) return (0, _types.NetworkStatusEnum).ONLINE;
        return (0, _types.NetworkStatusEnum).OFFLINE;
    }
    constructor(networkChangeCallback){
        this._networkChangeCallback = networkChangeCallback;
        if (typeof window !== 'undefined') {
            window.addEventListener('offline', ()=>this._networkChangeCallback((0, _types.NetworkStatusEnum).OFFLINE));
            window.addEventListener('online', ()=>this._networkChangeCallback((0, _types.NetworkStatusEnum).ONLINE));
        }
    }
}

},{"./types":"lKhoc","@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"8UdPs":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>(0, _schedulerDefault.default));
parcelHelpers.export(exports, "DoneState", ()=>(0, _types.DoneState));
var _scheduler = require("./Scheduler");
var _schedulerDefault = parcelHelpers.interopDefault(_scheduler);
var _types = require("./types");

},{"./Scheduler":"hUAJU","./types":"cHRyY","@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"hUAJU":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "QueuedScheduleTypes", ()=>QueuedScheduleTypes);
// eslint-disable-next-line @atlaskit/volt-strict-mode/no-multiple-exports
parcelHelpers.export(exports, "default", ()=>Scheduler);
var _callbackWithTimeout = require("./CallbackWithTimeout");
var _types = require("./types");
const SCHEDULER_OPTIONS_DEFAULT = {
    minRetryDelay: 1000,
    maxRetryDelay: 30000,
    backoffFactor: 2,
    backoffJitterPercentage: 0,
    waitInterval: 500,
    callbackTimeoutPeriod: 5000
};
var QueuedScheduleTypes = /*#__PURE__*/ function(QueuedScheduleTypes) {
    QueuedScheduleTypes[QueuedScheduleTypes["NONE"] = 0] = "NONE";
    QueuedScheduleTypes[QueuedScheduleTypes["IMMEDIATE"] = 1] = "IMMEDIATE";
    QueuedScheduleTypes[QueuedScheduleTypes["WAIT"] = 2] = "WAIT";
    return QueuedScheduleTypes;
}({});
class Scheduler {
    constructor(retryOptions, callback){
        this.schedule = ({ immediate } = {})=>{
            if (typeof window === 'undefined') return;
            if (this.operationInFlight) {
                if (immediate) this.queuedSchedule = 1;
                else if (this.queuedSchedule !== 1) this.queuedSchedule = 2;
            // Only run immediately if we have no failures
            } else if ((immediate || this.options.waitInterval <= 0) && this.failureCount === 0) {
                this.clearTimeout();
                this.run();
            // Calculate backoff for normal or failure scenario
            } else if (this.scheduledTimeout === null) this.scheduledTimeout = window.setTimeout(this.run, this.calculateBackoff());
        };
        this.stop = ()=>{
            this.clearTimeout();
            this.queuedSchedule = 0;
        };
        this.getFailureCount = ()=>this.failureCount;
        this.getCallbackStatus = ()=>{
            return this.callbackTimer.getCallbackStatus();
        };
        this.clearTimeout = ()=>{
            if (typeof window !== 'undefined' && this.scheduledTimeout !== null) {
                window.clearTimeout(this.scheduledTimeout);
                this.scheduledTimeout = null;
            }
        };
        this.run = ()=>{
            this.operationInFlight = true;
            this.clearTimeout();
            try {
                this.callbackTimer.executeCallbackWithTimeout(// callback to execute
                this.callback, // when callback completes, call this function
                this.done, // on timeout, do this instead
                ()=>this.done((0, _types.DoneState).ERROR));
            } catch (err) {
                this.done(err);
            }
        };
        this.done = (state)=>{
            this.operationInFlight = false;
            if (state === (0, _types.DoneState).ERROR || this.callbackTimer.getCallbackStatus() === (0, _callbackWithTimeout.CallbackStatus).TIMED_OUT) {
                this.failureCount++;
                this.clearTimeout();
            } else if (state === (0, _types.DoneState).SUCCESS) this.failureCount = 0;
            this.processQueuedSchedule();
        };
        this.processQueuedSchedule = ()=>{
            if (this.queuedSchedule !== 0) {
                const immediate = this.queuedSchedule === 1;
                this.queuedSchedule = 0;
                this.schedule({
                    immediate
                });
            } else if (this.failureCount > 0) // This will schedule tasks when this._done was called with a truthy value
            // For example, when this.callback(this._done) was not called within
            // this.callbackTimeoutPeriod
            this.schedule();
        };
        this.calculateBackoff = ()=>{
            const { minRetryDelay, maxRetryDelay, backoffFactor, backoffJitterPercentage, waitInterval } = this.options;
            // Helper for deviation based on a single random sample
            const jitter = (base, symmetric)=>{
                if (!backoffJitterPercentage || base <= 0) return 0;
                const r = (Math.random() - 0.5) * 2;
                const frac = symmetric ? r : Math.abs(r);
                return Math.floor(frac * backoffJitterPercentage * base);
            };
            // No failures: wait interval with positive-only jitter
            if (this.failureCount === 0) return waitInterval + jitter(waitInterval, false);
            // Failures: exponential backoff with symmetric jitter
            const base = Math.min(minRetryDelay * backoffFactor ** this.failureCount, maxRetryDelay);
            const withJitter = base + jitter(base, true);
            return Math.max(minRetryDelay, Math.min(withJitter, maxRetryDelay));
        };
        this.options = {
            minRetryDelay: retryOptions.minRetryDelay || SCHEDULER_OPTIONS_DEFAULT.minRetryDelay,
            maxRetryDelay: retryOptions.maxRetryDelay || SCHEDULER_OPTIONS_DEFAULT.maxRetryDelay,
            backoffFactor: retryOptions.backoffFactor || SCHEDULER_OPTIONS_DEFAULT.backoffFactor,
            backoffJitterPercentage: retryOptions.backoffJitterPercentage || SCHEDULER_OPTIONS_DEFAULT.backoffJitterPercentage,
            waitInterval: retryOptions.waitInterval !== undefined ? retryOptions.waitInterval : SCHEDULER_OPTIONS_DEFAULT.waitInterval,
            callbackTimeoutPeriod: retryOptions.callbackTimeoutPeriod || SCHEDULER_OPTIONS_DEFAULT.callbackTimeoutPeriod
        };
        this.scheduledTimeout = null;
        this.failureCount = 0;
        this.callback = callback;
        this.operationInFlight = false;
        this.queuedSchedule = 0;
        this.callbackTimer = new (0, _callbackWithTimeout.CallbackWithTimeout)(this.options.callbackTimeoutPeriod);
    }
}

},{"./CallbackWithTimeout":"kafT8","./types":"cHRyY","@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"kafT8":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "CallbackStatus", ()=>CallbackStatus);
parcelHelpers.export(exports, "CallbackEvent", ()=>CallbackEvent);
// eslint-disable-next-line @atlaskit/volt-strict-mode/no-multiple-exports
parcelHelpers.export(exports, "CallbackWithTimeout", ()=>CallbackWithTimeout);
var CallbackStatus = /*#__PURE__*/ function(CallbackStatus) {
    CallbackStatus["IDLE"] = "idle";
    CallbackStatus["RUNNING"] = "running";
    CallbackStatus["COMPLETED"] = "completed";
    CallbackStatus["TIMED_OUT"] = "timedOut";
    return CallbackStatus;
}({});
var CallbackEvent = /*#__PURE__*/ function(CallbackEvent) {
    CallbackEvent["EXECUTE"] = "execute";
    CallbackEvent["COMPLETE"] = "complete";
    CallbackEvent["TIMEOUT"] = "timeout";
    return CallbackEvent;
}({});
class CallbackWithTimeout {
    // This is a state machine to control the flow of execution.
    // IDLE -> RUNNING -> COMPLETED
    // IDLE -> RUNNING -> TIMEDOUT
    transitionCallbackStatus(currentStatus, event) {
        switch(currentStatus){
            case "idle":
            case "timedOut":
            case "completed":
                if (event === "execute") this.callbackStatus = "running";
                break;
            case "running":
                switch(event){
                    case "complete":
                        this.callbackStatus = "completed";
                        break;
                    case "timeout":
                        this.callbackStatus = "timedOut";
                        break;
                }
                break;
            default:
                this.callbackStatus = currentStatus;
        }
    }
    // Start a timeout. If this.callback(this._done) does not finish
    // by this.options.callbackTimeoutPeriod time period,
    // we will call done with a true value.
    executeCallbackWithTimeout(callback, onDone, onTimeout) {
        if (typeof window === 'undefined') return;
        this.transitionCallbackStatus(this.callbackStatus, "execute");
        // Setting timeout
        this.timeoutHandle = window.setTimeout(()=>{
            this.transitionCallbackStatus(this.callbackStatus, "timeout");
            onTimeout();
        }, this.timeoutPeriod);
        // Executing callback
        callback((state)=>{
            this.cancelTimeout();
            if (this.getCallbackStatus() !== "timedOut") {
                this.transitionCallbackStatus(this.callbackStatus, "complete");
                onDone(state);
            }
        });
    }
    getCallbackStatus() {
        return this.callbackStatus;
    }
    // This allows us to cancel the timeout function, for example, if the callback finishes before the timeout period
    // or, if the user wants to manually cancel the timeout
    cancelTimeout() {
        if (typeof window !== 'undefined' && this.timeoutPeriod > 0 && this.timeoutHandle) {
            window.clearTimeout(this.timeoutHandle);
            this.timeoutHandle = undefined;
        }
    }
    constructor(timeoutPeriod){
        // Tracks the settimeout; so that we can clear the timeout
        this.timeoutHandle = undefined;
        this.callbackStatus = "idle";
        if (timeoutPeriod > 0) {
            this.timeoutPeriod = timeoutPeriod;
            return;
        }
        throw new Error('CallbackWithTimeout requires timeout period higher than 0');
    }
}

},{"@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"cHRyY":[function(require,module,exports,__globalThis) {
// Clients can optionally provide the callbackTimeoutPeriod parameter
var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "DoneState", ()=>DoneState);
var DoneState = /*#__PURE__*/ function(DoneState) {
    DoneState[DoneState["NOOP"] = 0] = "NOOP";
    DoneState[DoneState["SUCCESS"] = 1] = "SUCCESS";
    DoneState[DoneState["ERROR"] = 2] = "ERROR";
    return DoneState;
}({});

},{"@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"13H4M":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "createUnknownXid", ()=>(0, _constants.createUnknownXid));
parcelHelpers.export(exports, "XIDItemType", ()=>(0, _enums.XIDItemType));
parcelHelpers.export(exports, "XIDState", ()=>(0, _enums.XIDState));
parcelHelpers.export(exports, "XIDPromise", ()=>(0, _xidpromise.XIDPromise));
parcelHelpers.export(exports, "attachXidToSingleEvent", ()=>(0, _attachXID.attachXidToSingleEvent));
parcelHelpers.export(exports, "attachXidToMultipleEvents", ()=>(0, _attachXID.attachXidToMultipleEvents));
var _constants = require("./constants");
var _enums = require("./enums");
var _xidpromise = require("./XIDPromise");
var _attachXID = require("./AttachXID");

},{"./constants":false,"./enums":false,"./XIDPromise":"ejGXG","./AttachXID":"aoK3C","@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"h3nzM":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "XID_TIMEOUT", ()=>XID_TIMEOUT);
parcelHelpers.export(exports, "createTimeoutXid", ()=>createTimeoutXid);
parcelHelpers.export(exports, "createUnknownXid", ()=>createUnknownXid);
var _enums = require("./enums");
const XID_TIMEOUT = 5000;
const createTimeoutXid = ()=>[
        {
            type: (0, _enums.XIDItemType).XC,
            state: 'TIMEOUT'
        },
        {
            type: (0, _enums.XIDItemType).UID,
            state: 'TIMEOUT'
        }
    ];
const createUnknownXid = ()=>[
        {
            type: (0, _enums.XIDItemType).XC,
            state: 'UNKNOWN'
        },
        {
            type: (0, _enums.XIDItemType).UID,
            state: 'UNKNOWN'
        }
    ];

},{"./enums":"eNahQ","@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"eNahQ":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "XIDItemType", ()=>XIDItemType);
parcelHelpers.export(exports, "XIDState", ()=>XIDState);
var XIDItemType = /*#__PURE__*/ function(XIDItemType) {
    XIDItemType["XC"] = "xc";
    XIDItemType["UID"] = "uid";
    return XIDItemType;
}({});
var XIDState = /*#__PURE__*/ function(XIDState) {
    XIDState["NEW"] = "NEW";
    XIDState["CHANGED"] = "CHANGED";
    XIDState["EXISTING"] = "EXISTING";
    XIDState["TIMEOUT"] = "TIMEOUT";
    XIDState["ERROR"] = "ERROR";
    XIDState["UNAVAILABLE"] = "UNAVAILABLE";
    XIDState["MALFORMED"] = "MALFORMED";
    XIDState["UNKNOWN"] = "UNKNOWN";
    return XIDState;
}({});

},{"@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"ejGXG":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "XIDPromise", ()=>XIDPromise);
var _constants = require("./constants");
const XIDPromise = (xidConsent, xidPromiseFn)=>{
    if (xidConsent && xidPromiseFn && typeof xidPromiseFn === 'function') {
        const timeoutPromise = ()=>{
            return new Promise((resolve)=>{
                setTimeout(()=>resolve(()=>(0, _constants.createTimeoutXid)()), (0, _constants.XID_TIMEOUT));
            });
        };
        const xidPromise = ()=>{
            return xidPromiseFn().catch(()=>()=>(0, _constants.createUnknownXid)());
        };
        return Promise.race([
            xidPromise(),
            timeoutPromise()
        ]);
    }
    return undefined;
};

},{"./constants":"h3nzM","@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"aoK3C":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "attachXidToSingleEvent", ()=>attachXidToSingleEvent);
// eslint-disable-next-line @atlaskit/volt-strict-mode/no-multiple-exports
parcelHelpers.export(exports, "attachXidToMultipleEvents", ()=>attachXidToMultipleEvents);
var _objectSpread = require("@swc/helpers/_/_object_spread");
var _objectSpreadProps = require("@swc/helpers/_/_object_spread_props");
var _types = require("../integration/types");
function attachXidToSingleEvent(item, xidCallback) {
    if (!(xidCallback && xidCallback instanceof Function)) return item;
    if (item.msg.type === (0, _types.SegmentEventTypes).PAGE || item.msg.type === (0, _types.SegmentEventTypes).TRACK) {
        const xid = xidCallback();
        if (xid && Array.isArray(xid)) item.msg.properties = (0, _objectSpreadProps._)((0, _objectSpread._)({}, item.msg.properties), {
            xid
        });
    } else if (item.msg.traits && item.msg.type === (0, _types.SegmentEventTypes).IDENTIFY) {
        const xid = xidCallback();
        if (xid && Array.isArray(xid)) item.msg.traits = (0, _objectSpreadProps._)((0, _objectSpread._)({}, item.msg.traits), {
            xid
        });
    }
    return item;
}
async function attachXidToMultipleEvents(items, xidItemPromiseCallback) {
    try {
        const xidCallback = await xidItemPromiseCallback;
        return items.map((item)=>attachXidToSingleEvent(item, xidCallback));
    } catch (error) {
        return items;
    }
}

},{"@swc/helpers/_/_object_spread":"9gdrV","@swc/helpers/_/_object_spread_props":"kANqQ","../integration/types":"kbxf3","@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"kbxf3":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "LastError", ()=>LastError);
parcelHelpers.export(exports, "SegmentEventTypes", ()=>SegmentEventTypes);
parcelHelpers.export(exports, "CrossDomainIdentifierType", ()=>CrossDomainIdentifierType);
parcelHelpers.export(exports, "CrossDomainIdentifierState", ()=>CrossDomainIdentifierState);
// eslint-disable-next-line @atlaskit/volt-strict-mode/no-multiple-exports
parcelHelpers.export(exports, "MetadataResponse", ()=>MetadataResponse);
// eslint-disable-next-line @atlaskit/volt-strict-mode/no-multiple-exports
parcelHelpers.export(exports, "FetchError", ()=>FetchError);
parcelHelpers.export(exports, "ALLOW_LISTED_FETCH_ERROR_NAMES", ()=>ALLOW_LISTED_FETCH_ERROR_NAMES);
class LastError {
    constructor(reason, error){
        this.reason = reason;
        this.message = error instanceof Error ? error.message : null;
        this.statusCode = error instanceof FetchError ? error.statusCode : null;
    }
}
var SegmentEventTypes = /*#__PURE__*/ function(SegmentEventTypes) {
    SegmentEventTypes["IDENTIFY"] = "identify";
    SegmentEventTypes["PAGE"] = "page";
    // Dont need Screen as page and screen are the same and we only use page
    SegmentEventTypes["TRACK"] = "track";
    return SegmentEventTypes;
}({});
var CrossDomainIdentifierType = /*#__PURE__*/ function(CrossDomainIdentifierType) {
    CrossDomainIdentifierType["XC"] = "xc";
    CrossDomainIdentifierType["UID"] = "uid";
    return CrossDomainIdentifierType;
}({});
var CrossDomainIdentifierState = /*#__PURE__*/ function(CrossDomainIdentifierState) {
    CrossDomainIdentifierState["NEW"] = "NEW";
    CrossDomainIdentifierState["CHANGED"] = "CHANGED";
    CrossDomainIdentifierState["EXISTING"] = "EXISTING";
    CrossDomainIdentifierState["TIMEOUT"] = "TIMEOUT";
    CrossDomainIdentifierState["ERROR"] = "ERROR";
    CrossDomainIdentifierState["UNAVAILABLE"] = "UNAVAILABLE";
    CrossDomainIdentifierState["MALFORMED"] = "MALFORMED";
    CrossDomainIdentifierState["UNKNOWN"] = "UNKNOWN";
    return CrossDomainIdentifierState;
}({});
class MetadataResponse {
    static fromJson(json) {
        let isString = (value)=>typeof value === 'string' || value instanceof String;
        const url = isString(json === null || json === void 0 ? void 0 : json.url) ? json.url.trim() : '';
        return new MetadataResponse((json === null || json === void 0 ? void 0 : json.props) || null, url.startsWith('http') ? url : null);
    }
    constructor(props, url){
        this.props = props;
        this.url = url;
    }
}
class FetchError extends Error {
    constructor(message, statusCode, statusText){
        super(message);
        this.statusCode = statusCode;
        this.statusText = statusText;
    }
}
const ALLOW_LISTED_FETCH_ERROR_NAMES = [
    'FetchError',
    'AbortError',
    'TypeError'
];

},{"@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"h7hwI":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "DEFAULT_REQUEST_TIMEOUT", ()=>DEFAULT_REQUEST_TIMEOUT);
parcelHelpers.export(exports, "DEFAULT_METADATA_REQUEST_TIMEOUT", ()=>DEFAULT_METADATA_REQUEST_TIMEOUT);
parcelHelpers.export(exports, "DEFAULT_METADATA_REFRESH_INTERVAL", ()=>DEFAULT_METADATA_REFRESH_INTERVAL);
parcelHelpers.export(exports, "DEFAULT_METADATA_MIN_RETRY_DELAY", ()=>DEFAULT_METADATA_MIN_RETRY_DELAY);
parcelHelpers.export(exports, "DEFAULT_METADATA_MAX_RETRY_DELAY", ()=>DEFAULT_METADATA_MAX_RETRY_DELAY);
parcelHelpers.export(exports, "DEFAULT_METADATA_PROPERTY_CHANGE_REFRESH_INTERVAL", ()=>DEFAULT_METADATA_PROPERTY_CHANGE_REFRESH_INTERVAL);
const DEFAULT_REQUEST_TIMEOUT = 10000; // 10 seconds
const DEFAULT_METADATA_REQUEST_TIMEOUT = 60000; // 60 seconds
const DEFAULT_METADATA_REFRESH_INTERVAL = 600000; // 10 minutes
const DEFAULT_METADATA_MIN_RETRY_DELAY = 5000; // 5 seconds
const DEFAULT_METADATA_MAX_RETRY_DELAY = 3600000; // 60 minutes
const DEFAULT_METADATA_PROPERTY_CHANGE_REFRESH_INTERVAL = 10; // 10 milliseconds

},{"@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"ePgKa":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "HTTP_STATUS_CODE_MAP", ()=>HTTP_STATUS_CODE_MAP);
const HTTP_STATUS_CODE_MAP = new Map([
    [
        200,
        'OK'
    ],
    [
        400,
        'Bad Request'
    ],
    [
        401,
        'Unauthorized'
    ],
    [
        402,
        'Payment Required'
    ],
    [
        403,
        'Forbidden'
    ],
    [
        404,
        'Not Found'
    ],
    [
        405,
        'Method Not Allowed'
    ],
    [
        406,
        'Not Acceptable'
    ],
    [
        407,
        'Proxy Authentication Required'
    ],
    [
        408,
        'Request Timeout'
    ],
    [
        409,
        'Conflict'
    ],
    [
        410,
        'Gone'
    ],
    [
        411,
        'Length Required'
    ],
    [
        412,
        'Precondition Failed'
    ],
    [
        413,
        'Payload Too Large'
    ],
    [
        414,
        'URI Too Long'
    ],
    [
        415,
        'Unsupported Media Type'
    ],
    [
        416,
        'Requested range not satisfiable'
    ],
    [
        417,
        'Expectation Failed'
    ],
    [
        418,
        "I'm a teapot"
    ],
    [
        422,
        'Unprocessable Entity'
    ],
    [
        423,
        'Locked'
    ],
    [
        424,
        'Failed Dependency'
    ],
    [
        425,
        'Too Early'
    ],
    [
        426,
        'Upgrade Required'
    ],
    [
        428,
        'Precondition Required'
    ],
    [
        429,
        'Too Many Requests'
    ],
    [
        431,
        'Request Header Fields Too Large'
    ],
    [
        451,
        'Unavailable For Legal Reasons'
    ],
    [
        500,
        'Internal Server Error'
    ],
    [
        501,
        'Not Implemented'
    ],
    [
        502,
        'Bad Gateway'
    ],
    [
        503,
        'Service Unavailable'
    ],
    [
        504,
        'Gateway Timeout'
    ],
    [
        505,
        'HTTP Version not supported'
    ],
    [
        506,
        'Variant Also Negotiates'
    ],
    [
        507,
        'Insufficient Storage'
    ],
    [
        508,
        'Loop Detected'
    ],
    [
        509,
        'Bandwidth Limit Exceeded'
    ],
    [
        510,
        'Not Extended'
    ],
    [
        511,
        'Network Authentication Required'
    ],
    [
        -1,
        'Unknown Status'
    ]
]);

},{"@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"fy0nR":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "sendEvents", ()=>sendEvents);
var _objectSpread = require("@swc/helpers/_/_object_spread");
var _memoizeOne = require("memoize-one");
var _memoizeOneDefault = parcelHelpers.interopDefault(_memoizeOne);
var _types = require("./types");
const sendEvents = async (options)=>{
    var _createOrGetAbortController;
    const signal = (_createOrGetAbortController = createOrGetAbortController(options)) === null || _createOrGetAbortController === void 0 ? void 0 : _createOrGetAbortController.signal;
    const corsOptions = getCorsForUrl(options.url);
    const response = await fetch(options.url, (0, _objectSpread._)({
        method: 'POST',
        // Content-type has to be text/plain in order to prevent unnecessary `OPTIONS` requests.
        headers: {
            'Content-Type': 'text/plain'
        },
        body: JSON.stringify(options.batch),
        signal
    }, corsOptions));
    if (response.status !== 200) throw new (0, _types.FetchError)(`HTTP Error ${response.status} (${response.statusText})`, response.status, response.statusText);
    try {
        let responseBody = await response.clone().json();
        if (responseBody.success === true) return response;
    } catch (e) {}
    throw new (0, _types.FetchError)('Invalid HTTP Response (Invalid response body)', 200, 'Invalid response body');
};
const createOrGetAbortController = (options)=>{
    if (options.abortController) return options.abortController;
    else if (options.timeout) {
        const abortController = new AbortController();
        // After a fetch has completed, calling abort is ignored.
        setTimeout(()=>{
            abortController.abort();
        }, options.timeout);
        return abortController;
    }
    return undefined;
};
// To ensure we always have cookies, we should check if the origins match.
// If they dont, we need to set mode to `cors` and credentials to `include`.
const getCorsForUrl = (0, _memoizeOneDefault.default)((url)=>{
    const origin = new URL(url).origin;
    if (origin === location.origin) return {};
    else return {
        mode: 'cors',
        credentials: 'include'
    };
});

},{"@swc/helpers/_/_object_spread":"9gdrV","memoize-one":"5rJro","./types":"kbxf3","@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"5rJro":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>memoizeOne);
var safeIsNaN = Number.isNaN || function ponyfill(value) {
    return typeof value === 'number' && value !== value;
};
function isEqual(first, second) {
    if (first === second) return true;
    if (safeIsNaN(first) && safeIsNaN(second)) return true;
    return false;
}
function areInputsEqual(newInputs, lastInputs) {
    if (newInputs.length !== lastInputs.length) return false;
    for(var i = 0; i < newInputs.length; i++){
        if (!isEqual(newInputs[i], lastInputs[i])) return false;
    }
    return true;
}
function memoizeOne(resultFn, isEqual) {
    if (isEqual === void 0) isEqual = areInputsEqual;
    var cache = null;
    function memoized() {
        var newArgs = [];
        for(var _i = 0; _i < arguments.length; _i++)newArgs[_i] = arguments[_i];
        if (cache && cache.lastThis === this && isEqual(newArgs, cache.lastArgs)) return cache.lastResult;
        var lastResult = resultFn.apply(this, newArgs);
        cache = {
            lastResult: lastResult,
            lastArgs: newArgs,
            lastThis: this
        };
        return lastResult;
    }
    memoized.clear = function clear() {
        cache = null;
    };
    return memoized;
}

},{"@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"7lmwV":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>User);
var _differenceInDays = require("date-fns/differenceInDays");
var _differenceInDaysDefault = parcelHelpers.interopDefault(_differenceInDays);
var _cookie = require("../cookie");
var _cookieDefault = parcelHelpers.interopDefault(_cookie);
var _safeLocalStorage = require("../storage/SafeLocalStorage");
var _safeLocalStorageDefault = parcelHelpers.interopDefault(_safeLocalStorage);
var _uuid = require("../uuid");
var _uuidDefault = parcelHelpers.interopDefault(_uuid);
// Cookie is stale, if anonymousId was generated 7 days ago.
const ANONYMOUS_ID_COOKIE_STALE_DAYS = 7;
const SAFE = 'SAFE';
const UNSAFE = 'UNSAFE';
const NOT_FOUND = 'NOT_FOUND';
const COOKIE = 'COOKIE';
const LOCAL_STORAGE = 'LOCAL_STORAGE';
class User {
    getUserId() {
        return this.userId || null;
    }
    setUserId(userId) {
        this.userId = userId;
    }
    getAnonymousId(customAnonymousIdGenerator) {
        /**
		 * Prefer localStorage as there cant be duplicate keys, and its faster. Also update cookie, if stale.
		 * If not set in localStorage, check cookies. Also set localStorage for future attempts.
		 * If not in cookies, generate a new one. Set both cookie and localStorage keys.
		 */ return this.getAnonymousIdFromLocalStorageAndUpdateCookieIfStale() || this.getAnonymousIdFromCookieAndUpdateLocalStorage() || this.generateNewAnonymousId(customAnonymousIdGenerator);
    }
    setAnonymousId(anonymousId) {
        const stringifyAnonymosId = JSON.stringify(anonymousId);
        this.cookie.set((0, _cookie.AWCCookiesKeys).AJS_ANONYMOUS_ID, stringifyAnonymosId);
        this.lastAnonymousIdCookieUpdate = Date.now();
        return this.store.setItem((0, _cookie.AllAnalyticsCookies).AJS_ANONYMOUS_ID.getKey(), stringifyAnonymosId);
    }
    getAnonymousIdFromStorage(source) {
        const rawStorageAnonidValue = source === LOCAL_STORAGE ? this.store.getItem((0, _cookie.AllAnalyticsCookies).AJS_ANONYMOUS_ID.getKey()) : this.cookie.get((0, _cookie.AWCCookiesKeys).AJS_ANONYMOUS_ID);
        if (rawStorageAnonidValue) {
            const unsafeValue = {
                type: UNSAFE,
                anonymousId: rawStorageAnonidValue
            };
            try {
                const parsedAnonId = JSON.parse(rawStorageAnonidValue);
                if (parsedAnonId && typeof parsedAnonId === 'string') return {
                    type: SAFE,
                    anonymousId: parsedAnonId
                };
                return unsafeValue;
            } catch (e) {
                /*
				 * Segments new Analytics-next client will store strings as strings without stringifing.
				 * The legacy Segment client and AWC always stringify and parse cookies and values.
				 * If the new Segment analytics-client stores a cookie and local storage value first, it will
				 * breaking old clients.
				 *
				 * Additionally, JSON.parse can cause exceptions to be thrown in some browsers; see AAP-324.
				 *
				 * Intentionally swalling errors here and returning the original value found in storage to avoid ping-pong.
				 */ return unsafeValue;
            }
        }
        return {
            type: NOT_FOUND
        };
    }
    getAnonymousIdFromLocalStorageAndUpdateCookieIfStale() {
        const localStorageValue = this.getAnonymousIdFromStorage(LOCAL_STORAGE);
        let shouldUpdateCookie = false;
        if (!this.lastAnonymousIdCookieUpdate || (0, _differenceInDaysDefault.default)(new Date(), new Date(this.lastAnonymousIdCookieUpdate)) >= ANONYMOUS_ID_COOKIE_STALE_DAYS) shouldUpdateCookie = true;
        switch(localStorageValue.type){
            case SAFE:
                if (shouldUpdateCookie) this.setAnonymousId(localStorageValue.anonymousId);
                return localStorageValue.anonymousId;
            case UNSAFE:
                return localStorageValue.anonymousId;
            case NOT_FOUND:
            default:
                return null;
        }
    }
    getAnonymousIdFromCookieAndUpdateLocalStorage() {
        const cookieValue = this.getAnonymousIdFromStorage(COOKIE);
        switch(cookieValue.type){
            case SAFE:
            case UNSAFE:
                this.store.setItem((0, _cookie.AllAnalyticsCookies).AJS_ANONYMOUS_ID.getKey(), JSON.stringify(cookieValue.anonymousId));
                return cookieValue.anonymousId;
            case NOT_FOUND:
            default:
                return null;
        }
    }
    generateNewAnonymousId(customAnonymousIdGenerator) {
        const generator = typeof customAnonymousIdGenerator === 'function' ? customAnonymousIdGenerator : ()=>{
            return (0, _uuidDefault.default)();
        };
        const newAnonId = generator();
        this.setAnonymousId(newAnonId);
        return newAnonId;
    }
    constructor(disableCookiePersistence){
        this.store = new (0, _safeLocalStorageDefault.default)({
            useStoragePrefix: false
        });
        this.cookie = new (0, _cookieDefault.default)(disableCookiePersistence);
    }
}

},{"date-fns/differenceInDays":"ll6Hh","../cookie":"3jiLY","../storage/SafeLocalStorage":"gVEHh","../uuid":"igO59","@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"ll6Hh":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>differenceInDays);
var _indexJs = require("../toDate/index.js");
var _indexJsDefault = parcelHelpers.interopDefault(_indexJs);
var _indexJs1 = require("../differenceInCalendarDays/index.js");
var _indexJsDefault1 = parcelHelpers.interopDefault(_indexJs1);
var _indexJs2 = require // Like `compareAsc` but uses local time not UTC, which is needed
("../_lib/requiredArgs/index.js");
var _indexJsDefault2 = parcelHelpers.interopDefault(_indexJs2);
// for accurate equality comparisons of UTC timestamps that end up
// having the same representation in local time, e.g. one hour before
// DST ends vs. the instant that DST ends.
function compareLocalAsc(dateLeft, dateRight) {
    var diff = dateLeft.getFullYear() - dateRight.getFullYear() || dateLeft.getMonth() - dateRight.getMonth() || dateLeft.getDate() - dateRight.getDate() || dateLeft.getHours() - dateRight.getHours() || dateLeft.getMinutes() - dateRight.getMinutes() || dateLeft.getSeconds() - dateRight.getSeconds() || dateLeft.getMilliseconds() - dateRight.getMilliseconds();
    if (diff < 0) return -1;
    else if (diff > 0) return 1;
    else return diff;
}
function differenceInDays(dirtyDateLeft, dirtyDateRight) {
    (0, _indexJsDefault2.default)(2, arguments);
    var dateLeft = (0, _indexJsDefault.default)(dirtyDateLeft);
    var dateRight = (0, _indexJsDefault.default)(dirtyDateRight);
    var sign = compareLocalAsc(dateLeft, dateRight);
    var difference = Math.abs((0, _indexJsDefault1.default)(dateLeft, dateRight));
    dateLeft.setDate(dateLeft.getDate() - sign * difference);
    // Math.abs(diff in full days - diff in calendar days) === 1 if last calendar day is not full
    // If so, result must be decreased by 1 in absolute value
    var isLastDayNotFull = Number(compareLocalAsc(dateLeft, dateRight) === -sign);
    var result = sign * (difference - isLastDayNotFull);
    // Prevent negative zero
    return result === 0 ? 0 : result;
}

},{"../toDate/index.js":"cZAgO","../differenceInCalendarDays/index.js":"6D8SH","../_lib/requiredArgs/index.js":"hXH6a","@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"cZAgO":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>toDate);
var _typeof = require("@babel/runtime/helpers/esm/typeof");
var _typeofDefault = parcelHelpers.interopDefault(_typeof);
var _indexJs = require("../_lib/requiredArgs/index.js");
var _indexJsDefault = parcelHelpers.interopDefault(_indexJs);
function toDate(argument) {
    (0, _indexJsDefault.default)(1, arguments);
    var argStr = Object.prototype.toString.call(argument);
    // Clone the date
    if (argument instanceof Date || (0, _typeofDefault.default)(argument) === 'object' && argStr === '[object Date]') // Prevent the date to lose the milliseconds when passed to new Date() in IE10
    return new Date(argument.getTime());
    else if (typeof argument === 'number' || argStr === '[object Number]') return new Date(argument);
    else {
        if ((typeof argument === 'string' || argStr === '[object String]') && typeof console !== 'undefined') {
            // eslint-disable-next-line no-console
            console.warn("Starting with v2.0.0-beta.1 date-fns doesn't accept strings as date arguments. Please use `parseISO` to parse strings. See: https://github.com/date-fns/date-fns/blob/master/docs/upgradeGuide.md#string-arguments");
            // eslint-disable-next-line no-console
            console.warn(new Error().stack);
        }
        return new Date(NaN);
    }
}

},{"@babel/runtime/helpers/esm/typeof":"jvCfw","../_lib/requiredArgs/index.js":"hXH6a","@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"hXH6a":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>requiredArgs);
function requiredArgs(required, args) {
    if (args.length < required) throw new TypeError(required + ' argument' + (required > 1 ? 's' : '') + ' required, but only ' + args.length + ' present');
}

},{"@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"6D8SH":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>differenceInCalendarDays);
var _indexJs = require("../_lib/getTimezoneOffsetInMilliseconds/index.js");
var _indexJsDefault = parcelHelpers.interopDefault(_indexJs);
var _indexJs1 = require("../startOfDay/index.js");
var _indexJsDefault1 = parcelHelpers.interopDefault(_indexJs1);
var _indexJs2 = require("../_lib/requiredArgs/index.js");
var _indexJsDefault2 = parcelHelpers.interopDefault(_indexJs2);
var MILLISECONDS_IN_DAY = 86400000;
function differenceInCalendarDays(dirtyDateLeft, dirtyDateRight) {
    (0, _indexJsDefault2.default)(2, arguments);
    var startOfDayLeft = (0, _indexJsDefault1.default)(dirtyDateLeft);
    var startOfDayRight = (0, _indexJsDefault1.default)(dirtyDateRight);
    var timestampLeft = startOfDayLeft.getTime() - (0, _indexJsDefault.default)(startOfDayLeft);
    var timestampRight = startOfDayRight.getTime() - (0, _indexJsDefault.default)(startOfDayRight);
    // Round the number of days to the nearest integer
    // because the number of milliseconds in a day is not constant
    // (e.g. it's different in the day of the daylight saving time clock shift)
    return Math.round((timestampLeft - timestampRight) / MILLISECONDS_IN_DAY);
}

},{"../_lib/getTimezoneOffsetInMilliseconds/index.js":"5EVhm","../startOfDay/index.js":"agpXm","../_lib/requiredArgs/index.js":"hXH6a","@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"5EVhm":[function(require,module,exports,__globalThis) {
/**
 * Google Chrome as of 67.0.3396.87 introduced timezones with offset that includes seconds.
 * They usually appear for dates that denote time before the timezones were introduced
 * (e.g. for 'Europe/Prague' timezone the offset is GMT+00:57:44 before 1 October 1891
 * and GMT+01:00:00 after that date)
 *
 * Date#getTimezoneOffset returns the offset in minutes and would return 57 for the example above,
 * which would lead to incorrect calculations.
 *
 * This function returns the timezone offset in milliseconds that takes seconds in account.
 */ var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>getTimezoneOffsetInMilliseconds);
function getTimezoneOffsetInMilliseconds(date) {
    var utcDate = new Date(Date.UTC(date.getFullYear(), date.getMonth(), date.getDate(), date.getHours(), date.getMinutes(), date.getSeconds(), date.getMilliseconds()));
    utcDate.setUTCFullYear(date.getFullYear());
    return date.getTime() - utcDate.getTime();
}

},{"@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"agpXm":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>startOfDay);
var _indexJs = require("../toDate/index.js");
var _indexJsDefault = parcelHelpers.interopDefault(_indexJs);
var _indexJs1 = require("../_lib/requiredArgs/index.js");
var _indexJsDefault1 = parcelHelpers.interopDefault(_indexJs1);
function startOfDay(dirtyDate) {
    (0, _indexJsDefault1.default)(1, arguments);
    var date = (0, _indexJsDefault.default)(dirtyDate);
    date.setHours(0, 0, 0, 0);
    return date;
}

},{"../toDate/index.js":"cZAgO","../_lib/requiredArgs/index.js":"hXH6a","@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"3jiLY":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>(0, _cookieWrapperDefault.default));
parcelHelpers.export(exports, "AllAnalyticsCookies", ()=>(0, _allAnalyticsCookies.AllAnalyticsCookies));
parcelHelpers.export(exports, "AWCCookiesKeys", ()=>(0, _allAnalyticsCookies.AWCCookiesKeys));
var _cookieWrapper = require("./cookieWrapper");
var _cookieWrapperDefault = parcelHelpers.interopDefault(_cookieWrapper);
var _allAnalyticsCookies = require("./AllAnalyticsCookies");

},{"./cookieWrapper":"iZeAs","./AllAnalyticsCookies":"knWqo","@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"iZeAs":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>CookieWrapper);
var _objectSpread = require("@swc/helpers/_/_object_spread");
var _objectSpreadProps = require("@swc/helpers/_/_object_spread_props");
var _jsCookie = require("js-cookie");
var _jsCookieDefault = parcelHelpers.interopDefault(_jsCookie);
var _allAnalyticsCookies = require("./AllAnalyticsCookies");
var _localStorageAlt = require("./localStorageAlt");
var _localStorageAltDefault = parcelHelpers.interopDefault(_localStorageAlt);
var _util = require("./util");
class CookieWrapper {
    set(name, value, options) {
        // no-op
        if (!(0, _allAnalyticsCookies.AllAnalyticsCookies)[name]) {
            // eslint-disable-next-line no-console
            console.warn(`Unknown cookie key ${name} provided, not set.`);
            return;
        }
        return this.cookieLike.set((0, _allAnalyticsCookies.AllAnalyticsCookies)[name].getKey(), value, (0, _objectSpread._)((0, _objectSpreadProps._)((0, _objectSpread._)({}, (0, _allAnalyticsCookies.AllAnalyticsCookies)[name].getAttributes()), {
            // Function is memoized so we only calculate this once per page load
            domain: (0, _util.getTld)()
        }), options));
    }
    get(name) {
        if (!(0, _allAnalyticsCookies.AllAnalyticsCookies)[name]) {
            // eslint-disable-next-line no-console
            console.warn(`Unknown cookie key ${name} provided, not fetched.`);
            return;
        }
        return this.cookieLike.get((0, _allAnalyticsCookies.AllAnalyticsCookies)[name].getKey());
    }
    remove(name, options) {
        if (!(0, _allAnalyticsCookies.AllAnalyticsCookies)[name]) {
            // eslint-disable-next-line no-console
            console.warn(`Unknown cookie key ${name} provided, not removed.`);
            return;
        }
        this.cookieLike.remove((0, _allAnalyticsCookies.AllAnalyticsCookies)[name].getKey(), (0, _objectSpread._)({}, options));
    }
    constructor(disableCookiePersistence){
        this.cookieLike = (0, _util.canUseCookie)(disableCookiePersistence) ? (0, _jsCookieDefault.default) : new (0, _localStorageAltDefault.default)();
    }
}

},{"@swc/helpers/_/_object_spread":"9gdrV","@swc/helpers/_/_object_spread_props":"kANqQ","js-cookie":"brgOH","./AllAnalyticsCookies":"knWqo","./localStorageAlt":"k9Mye","./util":"23uec","@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"brgOH":[function(require,module,exports,__globalThis) {
/*! js-cookie v3.0.8 | MIT */ var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>api);
function assign(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i];
        for(var key in source){
            if (key === '__proto__') continue;
            target[key] = source[key];
        }
    }
    return target;
}
var defaultConverter = {
    read: function(value) {
        if (value[0] === '"') value = value.slice(1, -1);
        return value.replace(/(%[\dA-F]{2})+/gi, decodeURIComponent);
    },
    write: function(value) {
        return encodeURIComponent(value).replace(/%(2[346BF]|3[AC-F]|40|5[BDE]|60|7[BCD])/g, decodeURIComponent);
    }
};
function init(converter, defaultAttributes) {
    function set(name, value, attributes) {
        if (typeof document === 'undefined') return;
        attributes = assign({}, defaultAttributes, attributes);
        if (typeof attributes.expires === 'number') attributes.expires = new Date(Date.now() + attributes.expires * 864e5);
        if (attributes.expires) attributes.expires = attributes.expires.toUTCString();
        name = encodeURIComponent(name).replace(/%(2[346B]|5E|60|7C)/g, decodeURIComponent).replace(/[()]/g, escape);
        var stringifiedAttributes = '';
        for(var attributeName in attributes){
            if (!attributes[attributeName]) continue;
            stringifiedAttributes += '; ' + attributeName;
            if (attributes[attributeName] === true) continue;
            // Considers RFC 6265 section 5.2:
            // ...
            // 3.  If the remaining unparsed-attributes contains a %x3B (";")
            //     character:
            // Consume the characters of the unparsed-attributes up to,
            // not including, the first %x3B (";") character.
            // ...
            stringifiedAttributes += '=' + attributes[attributeName].split(';')[0];
        }
        return document.cookie = name + '=' + converter.write(value, name) + stringifiedAttributes;
    }
    function get(name) {
        if (typeof document === 'undefined' || arguments.length && !name) return;
        // To prevent the for loop in the first place assign an empty array
        // in case there are no cookies at all.
        var cookies = document.cookie ? document.cookie.split('; ') : [];
        var jar = {};
        for(var i = 0; i < cookies.length; i++){
            var parts = cookies[i].split('=');
            var value = parts.slice(1).join('=');
            try {
                var found = decodeURIComponent(parts[0]);
                if (!(found in jar)) jar[found] = converter.read(value, found);
                if (name === found) break;
            } catch (_e) {
            // Do nothing...
            }
        }
        return name ? jar[name] : jar;
    }
    return Object.create({
        set: set,
        get: get,
        remove: function(name, attributes) {
            set(name, '', assign({}, attributes, {
                expires: -1
            }));
        },
        withAttributes: function(attributes) {
            return init(this.converter, assign({}, this.attributes, attributes));
        },
        withConverter: function(converter) {
            return init(assign({}, this.converter, converter), this.attributes);
        }
    }, {
        attributes: {
            value: Object.freeze(defaultAttributes)
        },
        converter: {
            value: Object.freeze(converter)
        }
    });
}
var api = init(defaultConverter, {
    path: '/'
});

},{"@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"knWqo":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "AWCCookiesKeys", ()=>AWCCookiesKeys);
parcelHelpers.export(exports, "AllAnalyticsCookies", ()=>AllAnalyticsCookies);
var AWCCookiesKeys = /*#__PURE__*/ function(AWCCookiesKeys) {
    AWCCookiesKeys["AWC_TLD_TEST"] = "AWC_TLD_TEST";
    AWCCookiesKeys["AWC_ANALYTICS_DEBUG"] = "AWC_ANALYTICS_DEBUG";
    AWCCookiesKeys["AJS_ANONYMOUS_ID"] = "AJS_ANONYMOUS_ID";
    return AWCCookiesKeys;
}({});
class CookieSchema {
    getAttributes() {
        return this.options;
    }
    getKey() {
        return this.key;
    }
    constructor(key, options){
        this.key = key;
        this.options = options;
    }
}
const isSecure = ()=>{
    try {
        return globalThis && globalThis.location && globalThis.location.protocol === 'https:';
    } catch (err) {
        return false;
    }
};
const AllAnalyticsCookies = {
    ["AWC_TLD_TEST"]: new CookieSchema('__awc_tld_test__', {
        expires: 365,
        secure: isSecure(),
        path: '/'
    }),
    ["AWC_ANALYTICS_DEBUG"]: new CookieSchema('atlassian_analytics_debug', {
        expires: 365,
        secure: isSecure(),
        path: '/'
    }),
    ["AJS_ANONYMOUS_ID"]: new CookieSchema('ajs_anonymous_id', {
        expires: 365,
        secure: isSecure(),
        path: '/'
    })
};

},{"@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"k9Mye":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>LocalStorageAlt);
var _safeLocalStorage = require("../storage/SafeLocalStorage");
var _safeLocalStorageDefault = parcelHelpers.interopDefault(_safeLocalStorage);
class LocalStorageAlt {
    set(name, value) {
        this.safeStorage.setItem(name, value);
        return value;
    }
    get(name) {
        const value = this.safeStorage.getItem(name);
        return value || undefined;
    }
    remove(name) {
        this.safeStorage.removeItem(name);
    }
    constructor(){
        this.safeStorage = new (0, _safeLocalStorageDefault.default)({
            useStoragePrefix: false
        });
    }
}

},{"../storage/SafeLocalStorage":"gVEHh","@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"gVEHh":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
// eslint-disable-next-line import/no-anonymous-default-export
parcelHelpers.export(exports, "default", ()=>_class);
var _inMemoryStorage = require("./InMemoryStorage");
var _inMemoryStorageDefault = parcelHelpers.interopDefault(_inMemoryStorage);
var _safeStorage = require("./SafeStorage");
var _safeStorageDefault = parcelHelpers.interopDefault(_safeStorage);
class _class extends (0, _safeStorageDefault.default) {
    constructor(options){
        let storageToUse;
        try {
            // eslint-disable-next-line @atlaskit/platform/no-direct-web-storage-usage -- existing usage
            storageToUse = globalThis.localStorage || (0, _inMemoryStorageDefault.default);
        } catch (err) {
            storageToUse = (0, _inMemoryStorageDefault.default);
        }
        super(storageToUse, options);
    }
}

},{"./InMemoryStorage":"1BUdT","./SafeStorage":"38PtO","@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"1BUdT":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "InMemoryStore", ()=>InMemoryStore);
class InMemoryStore {
    constructor(){
        this._data = {};
        this.length = 0;
        this.setItem = (key, value)=>{
            this._data[key] = value;
            this.length = Object.keys(this._data).length;
            return value;
        };
        this.getItem = (key)=>{
            if (key in this._data) return this._data[key];
            return null;
        };
        this.removeItem = (key)=>{
            if (key in this._data) delete this._data[key];
            this.length = Object.keys(this._data).length;
            return null;
        };
        this.clear = ()=>{
            this._data = {};
            this.length = 0;
        };
        this.key = (index)=>Object.keys(this._data)[index];
    }
}
// eslint-disable-next-line import/no-anonymous-default-export
const inmemorystorage = new InMemoryStore();
// eslint-disable-next-line @atlaskit/volt-strict-mode/no-multiple-exports
exports.default = inmemorystorage;

},{"@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"38PtO":[function(require,module,exports,__globalThis) {
/*
 * Code heavily influenced by Segment's Store https://github.com/segmentio/localstorage-retry/blob/master/lib/store.js
 * and Engine https://github.com/segmentio/localstorage-retry/blob/master/lib/engine.js
 * But is not used because it's not public API and is too restrictive in the way it sets keys and does JSON parsing and stringify
 */ var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "AWC_STORAGE_PREFIX", ()=>AWC_STORAGE_PREFIX);
parcelHelpers.export(exports, "GLOBAL_IN_MEMORY_NAME", ()=>GLOBAL_IN_MEMORY_NAME);
// eslint-disable-next-line @atlaskit/volt-strict-mode/no-multiple-exports
parcelHelpers.export(exports, "isSupported", ()=>isSupported);
// eslint-disable-next-line @atlaskit/volt-strict-mode/no-multiple-exports
parcelHelpers.export(exports, "default", ()=>SafeStorage);
var _analyticsWebTypes = require("../analyticsWebTypes");
var _inMemoryStorage = require("./InMemoryStorage");
var _inMemoryStorageDefault = parcelHelpers.interopDefault(_inMemoryStorage);
const AWC_STORAGE_PREFIX = 'awc';
const GLOBAL_IN_MEMORY_NAME = 'awcInMemoryStorageFallback';
function isSupported(store) {
    const TEST_VALUE = 'test_value';
    if (!store) return false;
    try {
        const key = 'awc.storage.support';
        store.setItem(key, TEST_VALUE);
        const value = store.getItem(key);
        store.removeItem(key);
        // handle localStorage silently failing
        return value === TEST_VALUE;
    } catch (e) {
        // Can throw if localStorage is disabled
        return false;
    }
}
class SafeStorage {
    constructor(storageToUse, options = {}){
        this.getStore = ()=>this._store;
        this.getItem = (key)=>this._store.getItem(this.createKey(key));
        this.removeItem = (key)=>this._store.removeItem(this.createKey(key));
        this.setItem = (key, value)=>{
            try {
                this._store.setItem(this.createKey(key), value);
            } catch (err) {
                // Theoretically should only be QuotaExceededError, but keeping 'err' generic
                // https://developer.mozilla.org/en-US/docs/Web/API/Storage/setItem
                this.swapToInMemory();
                this._store.setItem(this.createKey(key), value);
            }
        };
        this.swapToInMemory = ()=>{
            if (this._store === (0, _inMemoryStorageDefault.default) || typeof globalThis === 'undefined') return;
            const keys = Object.keys(this._store || {});
            let inMemoryStorage;
            if (isSupported(globalThis[GLOBAL_IN_MEMORY_NAME])) inMemoryStorage = globalThis[GLOBAL_IN_MEMORY_NAME];
            else {
                inMemoryStorage = (0, _inMemoryStorageDefault.default);
                if (!globalThis[GLOBAL_IN_MEMORY_NAME]) // If not already attached to globalThis then attach our instance of InMemoryStorage
                // We need to do this because if there are multiple instances of Analytics Client in multiple scopes,
                // there is no way to guarantee the throttling behaviour of the UI viewed event across those instances without a global singleton
                globalThis[GLOBAL_IN_MEMORY_NAME] = (0, _inMemoryStorageDefault.default);
            }
            keys.forEach((key)=>{
                if (key.indexOf(this.getPrefix()) === 0) {
                    const value = this._store.getItem(key);
                    if (value) inMemoryStorage.setItem(key, value);
                }
            });
            this._store = inMemoryStorage;
        };
        this.clear = ()=>this._store.clear();
        this.key = (index)=>this._store.key(index);
        this.getPrefix = ()=>this._prefix;
        this.createKey = (key)=>{
            if (this._prefix) return `${this.getPrefix()}.${key}`;
            return key;
        };
        this.options = options;
        const prefixes = [];
        if (options.useStoragePrefix === undefined || options.useStoragePrefix) prefixes.push(AWC_STORAGE_PREFIX);
        if (options.envPrefix && options.envPrefix !== (0, _analyticsWebTypes.envType).PROD) prefixes.push(options.envPrefix);
        this._prefix = prefixes.join('-');
        if (isSupported(storageToUse)) this._store = storageToUse;
        else this.swapToInMemory();
    }
}

},{"../analyticsWebTypes":"183Xd","./InMemoryStorage":"1BUdT","@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"23uec":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "canUseCookie", ()=>canUseCookie);
parcelHelpers.export(exports, "COOKIE_NAME", ()=>COOKIE_NAME);
parcelHelpers.export(exports, "COOKIE_VALUE", ()=>COOKIE_VALUE);
parcelHelpers.export(exports, "getTld", ()=>getTld);
var _jsCookie = require("js-cookie");
var _jsCookieDefault = parcelHelpers.interopDefault(_jsCookie);
var _memoizeOne = require("memoize-one");
var _memoizeOneDefault = parcelHelpers.interopDefault(_memoizeOne);
var _allAnalyticsCookies = require("./AllAnalyticsCookies");
const canUseCookie = (disableCookiePersistence = false)=>{
    if (disableCookiePersistence) return false;
    return !(location.protocol === 'file:' || location.protocol === 'chrome-extension:');
};
const COOKIE_NAME = (0, _allAnalyticsCookies.AllAnalyticsCookies).AWC_TLD_TEST.getKey();
const COOKIE_VALUE = 'tld_test';
const getTld = (0, _memoizeOneDefault.default)(()=>{
    if (typeof location === 'undefined') return '';
    const { hostname } = location;
    const splitHostname = hostname.split('.');
    for(let i = 1; i <= splitHostname.length; i++){
        const domainParts = splitHostname.slice(i * -1);
        const domain = `.${domainParts.join('.')}`;
        (0, _jsCookieDefault.default).set(COOKIE_NAME, COOKIE_VALUE, {
            domain
        });
        if ((0, _jsCookieDefault.default).get(COOKIE_NAME) === COOKIE_VALUE) {
            (0, _jsCookieDefault.default).remove(COOKIE_NAME, {
                domain
            });
            return domain;
        }
    }
    return hostname;
});

},{"js-cookie":"brgOH","memoize-one":"5rJro","./AllAnalyticsCookies":"knWqo","@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"dvv3A":[function(require,module,exports,__globalThis) {
// @ts-ignore
var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "buildContext", ()=>buildContext);
parcelHelpers.export(exports, "prepareEventContext", ()=>prepareEventContext);
parcelHelpers.export(exports, "prepareEventProperties", ()=>prepareEventProperties);
var _objectSpread = require("@swc/helpers/_/_object_spread");
var _objectSpreadProps = require("@swc/helpers/_/_object_spread_props");
var _isodateTraverse = require("@segment/isodate-traverse");
var _isodateTraverseDefault = parcelHelpers.interopDefault(_isodateTraverse);
const buildContext = (context, overrides)=>{
    const result = (0, _objectSpreadProps._)((0, _objectSpread._)({}, context.context), {
        userAgent: navigator.userAgent
    });
    // use nestedRemoveUndefinedValues to strip undefined properties before
    // spreading the override object since we want properties that explicitly
    // set to 'undefined' to not overwrite any values, just like properties
    // that are 'undefined' because they're not set at all will.
    if (overrides === null || overrides === void 0 ? void 0 : overrides.excludedProperties) result.excludedProperties = (0, _objectSpread._)({}, result.excludedProperties, nestedRemoveUndefinedValues(overrides.excludedProperties, '$.excludedProperties'));
    if (overrides === null || overrides === void 0 ? void 0 : overrides.userConsents) result.userConsents = (0, _objectSpread._)({}, result.userConsents, nestedRemoveUndefinedValues(overrides.userConsents, '$.userConsents'));
    // Remove any falsey properties since we only want to have exclusions
    // that were explicitly declared as excluded.
    if (result.excludedProperties) result.excludedProperties = removeFalseyProperties(result.excludedProperties);
    return result;
};
const prepareEventContext = (context)=>{
    const propertiesWithoutUndefined = nestedRemoveUndefinedValues(context, '$.context');
    return (0, _isodateTraverseDefault.default)(propertiesWithoutUndefined);
};
const prepareEventProperties = (properties)=>{
    const propertiesWithoutUndefined = nestedRemoveUndefinedValues(properties, '$.properties');
    // Remove any override properties that shouldn't be included in the event body
    delete propertiesWithoutUndefined.excludedProperties;
    delete propertiesWithoutUndefined.userConsents;
    return (0, _isodateTraverseDefault.default)(propertiesWithoutUndefined);
};
// Shallow removal of all falsey properties from an object, returning a new object.
const removeFalseyProperties = (obj)=>{
    const result = {};
    for(const key in obj){
        if (Object.prototype.hasOwnProperty.call(obj, key)) // If the value is not strictly true, map it to undefined
        {
            if (obj[key]) result[key] = obj[key];
        }
    }
    return result;
};
// This function will essentially deepClone as well
const nestedRemoveUndefinedValues = (obj, path)=>{
    const recursionDepthLimit = 512;
    const nestedRemoveUndefinedValuesImpl = (source, processedReferences, path, depth)=>{
        if (source === null || typeof source !== 'object') return source;
        // If the level of nesting is egregiously excessive we'll stop processing any further to
        // avoid crashing due to stack exhaustion, instead we return a note object.
        if (depth > recursionDepthLimit) return {
            _depthLimitExceeded: true,
            message: `Object nesting depth limit exceeded at path '${path}' with depth '${depth}'`
        };
        // If this object has already been seen then processing it would create a circular reference,
        // instead we return a note object.
        if (processedReferences.has(source)) {
            const originalPath = processedReferences.get(source);
            return {
                _circularReference: true,
                message: `Circular reference to object at original path '${originalPath}' detected at path '${path}'`,
                originalPath: originalPath
            };
        }
        processedReferences.set(source, path);
        const clone = {};
        Object.keys(source).forEach((key)=>{
            const value = source[key];
            if (value !== undefined) {
                if (Array.isArray(value)) {
                    const newArray = [];
                    value.forEach((v, i)=>{
                        const newValue = nestedRemoveUndefinedValuesImpl(v, processedReferences, `${path}.${key}[${i}]`, depth + 1);
                        if (newValue !== undefined) newArray.push(newValue);
                    });
                    clone[key] = newArray;
                } else {
                    const newValue = nestedRemoveUndefinedValuesImpl(value, processedReferences, `${path}.${key}`, depth + 1);
                    if (newValue !== undefined) clone[key] = newValue;
                }
            }
        });
        processedReferences.delete(source);
        return clone;
    };
    return nestedRemoveUndefinedValuesImpl(obj, new Map(), path, 0);
};

},{"@swc/helpers/_/_object_spread":"9gdrV","@swc/helpers/_/_object_spread_props":"kANqQ","@segment/isodate-traverse":"9wK1R","@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"9wK1R":[function(require,module,exports,__globalThis) {
'use strict';
var isodate = require("b6877ceeddde8e9c");
/**
 * Expose `traverse`.
 */ module.exports = traverse;
/**
 * Recursively traverse an object or array, and convert
 * all ISO date strings parse into Date objects.
 *
 * @param {Object} input - object, array, or string to convert
 * @param {Boolean} strict - only convert strings with year, month, and date
 * @return {Object}
 */ function traverse(input, strict) {
    if (strict === undefined) strict = true;
    if (input && typeof input === 'object') return traverseObject(input, strict);
    else if (Array.isArray(input)) return traverseArray(input, strict);
    else if (isodate.is(input, strict)) return isodate.parse(input);
    return input;
}
/**
 * Object traverser helper function.
 *
 * @param {Object} obj - object to traverse
 * @param {Boolean} strict - only convert strings with year, month, and date
 * @return {Object}
 */ function traverseObject(obj, strict) {
    Object.keys(obj).forEach(function(key) {
        obj[key] = traverse(obj[key], strict);
    });
    return obj;
}
/**
 * Array traverser helper function
 *
 * @param {Array} arr - array to traverse
 * @param {Boolean} strict - only convert strings with year, month, and date
 * @return {Array}
 */ function traverseArray(arr, strict) {
    arr.forEach(function(value, index) {
        arr[index] = traverse(value, strict);
    });
    return arr;
}

},{"b6877ceeddde8e9c":"kdUmX"}],"kdUmX":[function(require,module,exports,__globalThis) {
'use strict';
/**
 * Matcher, slightly modified from:
 *
 * https://github.com/csnover/js-iso8601/blob/lax/iso8601.js
 */ var matcher = /^(\d{4})(?:-?(\d{2})(?:-?(\d{2}))?)?(?:([ T])(\d{2}):?(\d{2})(?::?(\d{2})(?:[,\.](\d{1,}))?)?(?:(Z)|([+\-])(\d{2})(?::?(\d{2}))?)?)?$/;
/**
 * Convert an ISO date string to a date. Fallback to native `Date.parse`.
 *
 * https://github.com/csnover/js-iso8601/blob/lax/iso8601.js
 *
 * @param {String} iso
 * @return {Date}
 */ exports.parse = function(iso) {
    var numericKeys = [
        1,
        5,
        6,
        7,
        11,
        12
    ];
    var arr = matcher.exec(iso);
    var offset = 0;
    // fallback to native parsing
    if (!arr) return new Date(iso);
    /* eslint-disable no-cond-assign */ // remove undefined values
    for(var i = 0, val; val = numericKeys[i]; i++)arr[val] = parseInt(arr[val], 10) || 0;
    /* eslint-enable no-cond-assign */ // allow undefined days and months
    arr[2] = parseInt(arr[2], 10) || 1;
    arr[3] = parseInt(arr[3], 10) || 1;
    // month is 0-11
    arr[2]--;
    // allow abitrary sub-second precision
    arr[8] = arr[8] ? (arr[8] + '00').substring(0, 3) : 0;
    // apply timezone if one exists
    if (arr[4] === ' ') offset = new Date().getTimezoneOffset();
    else if (arr[9] !== 'Z' && arr[10]) {
        offset = arr[11] * 60 + arr[12];
        if (arr[10] === '+') offset = 0 - offset;
    }
    var millis = Date.UTC(arr[1], arr[2], arr[3], arr[5], arr[6] + offset, arr[7], arr[8]);
    return new Date(millis);
};
/**
 * Checks whether a `string` is an ISO date string. `strict` mode requires that
 * the date string at least have a year, month and date.
 *
 * @param {String} string
 * @param {Boolean} strict
 * @return {Boolean}
 */ exports.is = function(string, strict) {
    if (typeof string !== 'string') return false;
    if (strict && /^\d{4}-\d{2}-\d{2}/.test(string) === false) return false;
    return matcher.test(string);
};

},{}],"iJN14":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "MetadataClient", ()=>MetadataClient);
var _objectSpread = require("@swc/helpers/_/_object_spread");
var _objectSpreadProps = require("@swc/helpers/_/_object_spread_props");
var _networkStatus = require("../resilienceQueue/NetworkStatus");
var _networkStatusDefault = parcelHelpers.interopDefault(_networkStatus);
var _pullBatchableQueue = require("../resilienceQueue/PullBatchableQueue");
var _scheduler = require("../resilienceQueue/scheduler");
var _schedulerDefault = parcelHelpers.interopDefault(_scheduler);
var _types = require("../resilienceQueue/types");
var _selectHost = require("../selectHost");
var _testSupport = require("../util/testSupport");
var _defaults = require("./defaults");
var _fetchMetadata = require("./fetchMetadata");
var _types1 = require("./types");
class MetadataClient {
    /**
	 * Starts the metadata client. This will start the scheduler and begin
	 * fetching metadata.
	 *
	 * @param allowRestart - If false, the client will not be restarted if it has already been stopped
	 *						 by a call to stop().
	 */ start(allowRestart) {
        if (this._isEnabled || this._hasBeenStopped && !allowRestart) return;
        this._isEnabled = true;
        this.startNetworkStatusMonitor();
        setTimeout(()=>{
            this._scheduler.schedule({
                immediate: true
            });
        }, MetadataClient.INITIAL_REFRESH_DELAY);
    }
    stop() {
        var _this__fetchAbortController;
        if (!this._isEnabled) return;
        this._hasBeenStopped = true;
        this._isEnabled = false;
        this.stopNetworkStatusMonitor();
        this._scheduler.stop();
        (_this__fetchAbortController = this._fetchAbortController) === null || _this__fetchAbortController === void 0 ? void 0 : _this__fetchAbortController.abort();
        this.resetPropertyChangeRefresh();
    }
    startNetworkStatusMonitor() {
        if (this._networkStatus) return;
        this._networkStatus = new (0, _networkStatusDefault.default)((status)=>{
            if (status === (0, _types.NetworkStatusEnum).OFFLINE) this._scheduler.stop();
            else if (this._isEnabled) this._scheduler.schedule({
                immediate: this._metadataInfo === null
            });
        });
    }
    stopNetworkStatusMonitor() {
        if (this._networkStatus) {
            this._networkStatus.removeListeners();
            this._networkStatus = null;
        }
    }
    async refreshMetadataAsync() {
        var _this__fetchAbortController;
        if ((0, _testSupport.TestSupport).areFetchCallsDisabled() || !this._isEnabled) return Promise.resolve();
        (_this__fetchAbortController = this._fetchAbortController) === null || _this__fetchAbortController === void 0 ? void 0 : _this__fetchAbortController.abort();
        this._fetchAbortController = new AbortController();
        const fetchAbortSignal = this._fetchAbortController.signal;
        this._lastFetchRequestCount = this._scheduler.getFailureCount();
        await (0, _fetchMetadata.fetchMetadata)(this._url, {
            product: this._product,
            userInfo: this._userInfo,
            tenantInfo: this._tenantInfo
        }, (0, _defaults.DEFAULT_METADATA_REQUEST_TIMEOUT), fetchAbortSignal).then(async (response)=>{
            const metadata = await response.json();
            this._metadataInfo = (0, _types1.MetadataResponse).fromJson(metadata);
            this._lastFetchRequestCount++;
            this._requestStatus = 'FETCHED';
            this._lastErrorReason = null;
        }).catch((error)=>{
            if (fetchAbortSignal.aborted) // This request was aborted, so we don't need to handle it.
            return;
            this._requestStatus = 'FAILED';
            if (error instanceof (0, _types1.FetchError) && [
                429,
                503
            ].includes(error.statusCode)) this._lastErrorReason = 'ServerBusyError';
            else this._lastErrorReason = error instanceof Error && (0, _types1.ALLOW_LISTED_FETCH_ERROR_NAMES).includes(error.name) ? error.name : 'Unknown';
            throw error;
        });
    }
    getMetadataAsync() {
        return Promise.resolve(this._metadataInfo);
    }
    get status() {
        return this._requestStatus;
    }
    get lastErrorReason() {
        return this._lastErrorReason;
    }
    get lastFetchRequestCount() {
        return this._lastFetchRequestCount;
    }
    get userInfo() {
        return this._userInfo;
    }
    set userInfo(userInfo) {
        var _this__userInfo, _this__userInfo1;
        if (((_this__userInfo = this._userInfo) === null || _this__userInfo === void 0 ? void 0 : _this__userInfo.userId) === (userInfo === null || userInfo === void 0 ? void 0 : userInfo.userId) && ((_this__userInfo1 = this._userInfo) === null || _this__userInfo1 === void 0 ? void 0 : _this__userInfo1.userIdType) === (userInfo === null || userInfo === void 0 ? void 0 : userInfo.userIdType)) return;
        this._userInfo = userInfo;
        this.schedulePropertyChangeRefresh();
    }
    get tenantInfo() {
        return this._tenantInfo;
    }
    set tenantInfo(tenantInfo) {
        var _this__tenantInfo, _this__tenantInfo1;
        if (((_this__tenantInfo = this._tenantInfo) === null || _this__tenantInfo === void 0 ? void 0 : _this__tenantInfo.tenantId) === (tenantInfo === null || tenantInfo === void 0 ? void 0 : tenantInfo.tenantId) && ((_this__tenantInfo1 = this._tenantInfo) === null || _this__tenantInfo1 === void 0 ? void 0 : _this__tenantInfo1.tenantIdType) === (tenantInfo === null || tenantInfo === void 0 ? void 0 : tenantInfo.tenantIdType)) return;
        this._tenantInfo = tenantInfo;
        this.schedulePropertyChangeRefresh();
    }
    get metrics() {
        return {
            host: this._metadataHost,
            status: this.status,
            lastErrorReason: this.lastErrorReason,
            lastRefreshRequestCount: this.lastFetchRequestCount
        };
    }
    async scheduleCallback(done) {
        var _this__networkStatus;
        if (((_this__networkStatus = this._networkStatus) === null || _this__networkStatus === void 0 ? void 0 : _this__networkStatus.getNetworkStatus()) === (0, _types.NetworkStatusEnum).OFFLINE) {
            done((0, _scheduler.DoneState).NOOP);
            return;
        }
        try {
            await this.refreshMetadataAsync();
            done((0, _scheduler.DoneState).SUCCESS);
            this._scheduler.schedule();
        } catch (e) {
            done((0, _scheduler.DoneState).ERROR);
        }
    }
    /**
	 * Schedules a refresh of the metadata when the user or tenant info changes. There is
	 * a short delay to allow for multiple changes to be batched together, such as when the
	 * callers sets the user info and tenant info in quick succession.
	 */ schedulePropertyChangeRefresh() {
        if (!this._isEnabled) return;
        this.resetPropertyChangeRefresh();
        this._propertyChangeRefreshTimeout = setTimeout(()=>{
            this.resetPropertyChangeRefresh();
            this._scheduler.schedule({
                immediate: true
            });
        }, (0, _defaults.DEFAULT_METADATA_PROPERTY_CHANGE_REFRESH_INTERVAL));
    }
    resetPropertyChangeRefresh() {
        if (this._propertyChangeRefreshTimeout) {
            clearTimeout(this._propertyChangeRefreshTimeout);
            this._propertyChangeRefreshTimeout = null;
        }
    }
    buildOptions(options) {
        return {
            backoffFactor: (options === null || options === void 0 ? void 0 : options.backoffFactor) || (0, _pullBatchableQueue.DEFAULT_POLLING_OPTIONS).backoffFactor,
            backoffJitterPercentage: (options === null || options === void 0 ? void 0 : options.backoffJitterPercentage) !== undefined ? options.backoffJitterPercentage : (0, _pullBatchableQueue.DEFAULT_POLLING_OPTIONS).backoffJitterPercentage,
            maxRetryDelay: (options === null || options === void 0 ? void 0 : options.maxRetryDelay) || (0, _pullBatchableQueue.DEFAULT_POLLING_OPTIONS).maxRetryDelay,
            minRetryDelay: (options === null || options === void 0 ? void 0 : options.minRetryDelay) || (0, _pullBatchableQueue.DEFAULT_POLLING_OPTIONS).minRetryDelay
        };
    }
    constructor(apiHostProtocol, apiHost, product){
        this._userInfo = {
            anonymousId: ''
        };
        this._tenantInfo = {};
        this._url = `${apiHostProtocol}://${apiHost}/metadata`;
        this._product = product;
        this._metadataInfo = null;
        this._requestStatus = 'PENDING';
        this._lastFetchRequestCount = 0;
        this._lastErrorReason = null;
        this._fetchAbortController = null;
        this._hasBeenStopped = false;
        this._isEnabled = false;
        this._propertyChangeRefreshTimeout = null;
        const isStargateProxy = (0, _selectHost.isStargateProxyPath)({
            apiHost: apiHost
        });
        this._metadataHost = isStargateProxy ? 'PRODUCT_HOST' : apiHost;
        this._options = this.buildOptions({
            backoffFactor: 2,
            backoffJitterPercentage: 0.8,
            flushBeforeUnload: false,
            flushWaitMs: 500,
            maxAttempts: 10,
            minRetryDelay: (0, _defaults.DEFAULT_METADATA_MIN_RETRY_DELAY),
            maxRetryDelay: (0, _defaults.DEFAULT_METADATA_MAX_RETRY_DELAY)
        });
        this._scheduler = new (0, _schedulerDefault.default)((0, _objectSpreadProps._)((0, _objectSpread._)({}, this._options), {
            waitInterval: (0, _defaults.DEFAULT_METADATA_REFRESH_INTERVAL)
        }), this.scheduleCallback.bind(this));
        this._networkStatus = null;
    }
}
MetadataClient.INITIAL_REFRESH_DELAY = 1;
MetadataClient.Factory = (apiHostProtocol, apiHost, product)=>{
    return new MetadataClient(apiHostProtocol, apiHost, product);
};

},{"@swc/helpers/_/_object_spread":"9gdrV","@swc/helpers/_/_object_spread_props":"kANqQ","../resilienceQueue/NetworkStatus":"8vxyr","../resilienceQueue/PullBatchableQueue":"3RHOC","../resilienceQueue/scheduler":"8UdPs","../resilienceQueue/types":"lKhoc","../selectHost":"9e0Km","../util/testSupport":"eJmcF","./defaults":"h7hwI","./fetchMetadata":"bLhbQ","./types":"kbxf3","@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"9e0Km":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "STARGATE_PROXY_PATH", ()=>STARGATE_PROXY_PATH);
/**
 * Resolves the GASv3 API host based on environment, perimeter and IC context.
 *
 * If an explicit `apiHost` is provided, it is always used as-is regardless of
 * other settings.
 *
 * When `ic` is present (either explicitly provided or auto-detected), the function
 * routes through the Stargate proxy path on the current host.
 *
 * For non-IC environments the function delegates to the existing perimeter-specific
 * handlers (Commercial / FedRAMP Moderate).
 */ // eslint-disable-next-line @atlaskit/volt-strict-mode/no-multiple-exports
parcelHelpers.export(exports, "selectHost", ()=>selectHost);
// eslint-disable-next-line @atlaskit/volt-strict-mode/no-multiple-exports
parcelHelpers.export(exports, "isStargateProxyPath", ()=>isStargateProxyPath);
var _analyticsWebTypes = require("./analyticsWebTypes");
const PROD_HOST = 'as.atlassian.com/api/v1';
const STARGATE_PROD_HOST = 'api-private.atlassian.com/gasv3/api/v1';
const STAGING_HOST = 'as.staging.atl-paas.net/api/v1';
const STARGATE_STAGING_HOST = 'api-private.stg.atlassian.com/gasv3/api/v1';
const FEDRAMP_STAGING_HOST = 'as.staging.atl-paas-us-gov-mod.net/api/v1';
const FEDRAMP_PROD_HOST = 'as.atlassian-us-gov-mod.com/api/v1';
const STARGATE_FEDRAMP_STAGING_HOST = 'api.stg.atlassian-us-gov-mod.com/gasv3/api/v1';
const STARGATE_FEDRAMP_PROD_HOST = 'api.atlassian-us-gov-mod.com/gasv3/api/v1';
const STARGATE_PROXY_PATH = '/gateway/api/gasv3/api/v1';
/**
 * Returns the full Stargate proxy URL (host + proxy path) for the current host.
 *
 * This is the default endpoint for Commercial, FedRAMP Moderate (with Stargate),
 * and Oasis IC environments. Using the first-party proxy works around browser
 * restrictions with third-party cookies.
 *
 * In non-browser environments (e.g. SSR) where `window` is not defined, the host
 * portion is omitted and the function returns only `STARGATE_PROXY_PATH`
 * (i.e. `/gateway/api/gasv3/api/v1`).
 */ function stargateProxyUrl() {
    return (typeof window !== 'undefined' ? window.location.host : '') + STARGATE_PROXY_PATH;
}
const handleFedRampModerate = ({ useStargate, env, useLegacyUrl, envOverride })=>{
    if (env === (0, _analyticsWebTypes.envType).LOCAL || env === (0, _analyticsWebTypes.envType).DEV) throw Error('No LOCAL or DEV environments for FedRAMP.');
    if (env === (0, _analyticsWebTypes.envType).PROD && envOverride) throw Error('Cannot override to FedRAMP Sandbox for Prod.');
    if (!useStargate) return env === (0, _analyticsWebTypes.envType).PROD ? FEDRAMP_PROD_HOST : FEDRAMP_STAGING_HOST;
    if (useLegacyUrl) return env === (0, _analyticsWebTypes.envType).PROD ? STARGATE_FEDRAMP_PROD_HOST : STARGATE_FEDRAMP_STAGING_HOST;
    return stargateProxyUrl();
};
const handleCommercial = ({ useStargate, env, useLegacyUrl })=>{
    if (!useStargate) return env === (0, _analyticsWebTypes.envType).PROD ? PROD_HOST : STAGING_HOST;
    if (useLegacyUrl) return env === (0, _analyticsWebTypes.envType).PROD ? STARGATE_PROD_HOST : STARGATE_STAGING_HOST;
    return stargateProxyUrl();
};
function selectHost({ useStargate, env, useLegacyUrl, perimeter, ic, envOverride, apiHost }) {
    // If the caller has explicitly set an apiHost, use it as the endpoint.
    if (apiHost) return apiHost;
    // When running inside an IC, events are routed through the Stargate proxy.
    if (ic) {
        if (useLegacyUrl) throw Error('IC is set but useLegacyUrl is true. Legacy URLs are not supported in IC environments.');
        return stargateProxyUrl();
    }
    if (perimeter === (0, _analyticsWebTypes.perimeterType).FEDRAMP_MODERATE) return handleFedRampModerate({
        useStargate,
        env,
        useLegacyUrl,
        envOverride
    });
    return handleCommercial({
        useStargate,
        env,
        useLegacyUrl
    });
}
function isStargateProxyPath({ apiHost }) {
    return apiHost === stargateProxyUrl();
}

},{"./analyticsWebTypes":"183Xd","@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"eJmcF":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "TestSupport", ()=>TestSupport);
class TestSupport {
    static isGeminiVREnvironment() {
        try {
            for(const k in globalThis){
                if (k.startsWith('__gemini_') && k.endsWith('__')) return true;
            }
        } catch (e) {
        // ignore
        }
        return false;
    }
    static areMetadataCallsDisabled() {
        return this.areFetchCallsDisabled() || this.getGlobalBooleanProperty(TestSupport.DISABLE_METADATA_CALLS_PROPERTY);
    }
    static areEventCallsDisabled() {
        return this.areFetchCallsDisabled() || this.getGlobalBooleanProperty(TestSupport.DISABLE_EVENT_CALLS_PROPERTY);
    }
    static areFetchCallsDisabled() {
        return this.getGlobalBooleanProperty(TestSupport.DISABLE_FETCH_CALLS_PROPERTY);
    }
    static getSyntheticFlagOverride() {
        return this.getGlobalTriStateProperty(TestSupport.SYNTHETIC_FLAG_OVERRIDE_PROPERTY);
    }
    static getGlobalBooleanProperty(propertyName) {
        if (globalThis && globalThis.hasOwnProperty(propertyName)) return globalThis[propertyName] === true;
        return false;
    }
    static getGlobalTriStateProperty(propertyName) {
        if (globalThis && globalThis.hasOwnProperty(propertyName)) {
            const value = globalThis[propertyName];
            if (typeof value === 'boolean') return value;
        }
        return undefined;
    }
}
TestSupport.DISABLE_METADATA_CALLS_PROPERTY = '__awc_disable_metadata_calls__';
TestSupport.DISABLE_EVENT_CALLS_PROPERTY = '__awc_disable_event_calls__';
TestSupport.DISABLE_FETCH_CALLS_PROPERTY = '__awc_disable_fetch_calls__';
TestSupport.SYNTHETIC_FLAG_OVERRIDE_PROPERTY = '__awc_synthetic_flag_override__';

},{"@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"bLhbQ":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "fetchMetadata", ()=>fetchMetadata);
var _objectSpread = require("@swc/helpers/_/_object_spread");
var _memoizeOne = require("memoize-one");
var _memoizeOneDefault = parcelHelpers.interopDefault(_memoizeOne);
var _types = require("./types");
const fetchMetadata = async (url, params, timeout, signal)=>{
    var _params_userInfo, _params_userInfo1, _params_tenantInfo, _params_tenantInfo1;
    const requestAbortController = createRequestAbortController(timeout, signal);
    const corsOptions = getCorsForUrl(url);
    const metadataUrl = url + '?' + new URLSearchParams({
        product: `${params.product}`,
        userId: `${((_params_userInfo = params.userInfo) === null || _params_userInfo === void 0 ? void 0 : _params_userInfo.userId) || ''}`,
        userIdType: `${((_params_userInfo1 = params.userInfo) === null || _params_userInfo1 === void 0 ? void 0 : _params_userInfo1.userIdType) || ''}`,
        tenantId: `${((_params_tenantInfo = params.tenantInfo) === null || _params_tenantInfo === void 0 ? void 0 : _params_tenantInfo.tenantId) || ''}`,
        tenantIdType: `${((_params_tenantInfo1 = params.tenantInfo) === null || _params_tenantInfo1 === void 0 ? void 0 : _params_tenantInfo1.tenantIdType) || ''}`
    }).toString();
    const response = await fetch(metadataUrl, (0, _objectSpread._)({
        method: 'GET',
        signal: requestAbortController.signal
    }, corsOptions));
    // Response must be a 200 (we expect a JSON response, so 204 is not valid for instance)
    if (response.status !== 200) throw new (0, _types.FetchError)(`Metadata: HTTP Error ${response.status} (${response.statusText})`, response.status, response.statusText);
    return response;
};
const createRequestAbortController = (timeout, signal)=>{
    const abortController = new AbortController();
    setTimeout(()=>{
        abortController.abort();
    }, timeout || 30000);
    signal === null || signal === void 0 ? void 0 : signal.addEventListener('abort', ()=>{
        abortController.abort();
    });
    return abortController;
};
// To ensure we always have cookies, we should check if the origins match.
// If they dont, we need to set mode to `cors` and credentials to `include`.
const getCorsForUrl = (0, _memoizeOneDefault.default)((url)=>{
    const origin = new URL(url).origin;
    if (origin === location.origin) return {};
    else return {
        mode: 'cors',
        credentials: 'include'
    };
});

},{"@swc/helpers/_/_object_spread":"9gdrV","memoize-one":"5rJro","./types":"kbxf3","@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"6fSdx":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>OriginTracing);
var _analyticsWebTypes = require("./analyticsWebTypes");
var _urlUtils = require("./urlUtils");
var _urlUtilsDefault = parcelHelpers.interopDefault(_urlUtils);
class OriginTracing {
    /** Executes and clears any pending origin param cleanup. No-op if nothing is pending. */ _cleanupOriginParams() {
        if (this.pendingCleanup) {
            const cleanup = this.pendingCleanup;
            this.pendingCleanup = null;
            cleanup();
        }
    }
    /**
	 * Designed to be invoked after a successful flush with the batch of flushed events.
	 */ cleanupOriginParameters(events) {
        try {
            if (this.pendingCleanup) {
                const hasOriginLanded = events.some((item)=>'event' in item.msg && item.msg.event === OriginTracing.messageEvent);
                if (hasOriginLanded) this._cleanupOriginParams();
            }
        } catch (e) {
        // Silently ignore cleanup errors to avoid disrupting the flush cycle
        }
    }
    constructor(){
        this.pendingCleanup = null;
        this.handleOriginParameters = (originParamHandlerMapping, historyReplaceFn)=>{
            // Collect all the parameter labels to be handled
            const originParamLabelList = Object.keys(originParamHandlerMapping);
            if (!(originParamLabelList.length > 0)) throw new Error('Empty parameter mapping provided');
            // Check if the parameter labels are valid. If any invalid labels are found throw an exception.
            const invalidParams = originParamLabelList.filter((x)=>Object.values((0, _analyticsWebTypes.originTracingType)).indexOf(x) < 0);
            if (invalidParams.length > 0) throw new Error(`Invalid Origin Tracing Parameter(s) supplied: ${invalidParams.join()}!`);
            const isCaptureParam = (_, key)=>originParamLabelList.indexOf(key) >= 0;
            // Capture params WITHOUT removing from URL (explicit no-op required because
            // urlParamExtractor defaults to calling history.replaceState if omitted)
            const paramExtractorReplace = ()=>{};
            const capturedURLParams = (0, _urlUtilsDefault.default)(isCaptureParam, paramExtractorReplace);
            // Apply provided handler function to extract origin trace ID from each URL parameter
            const applyHandlerFunction = (key)=>{
                const x = originParamHandlerMapping[key](capturedURLParams[key]);
                return {
                    [key]: x
                };
            };
            const capturedOriginTraces = Object.keys(capturedURLParams).map(applyHandlerFunction).reduce((accumulator, currentValue)=>Object.assign(accumulator, currentValue), {});
            if (Object.keys(capturedOriginTraces).length > 0) this.pendingCleanup = ()=>{
                (0, _urlUtilsDefault.default)(isCaptureParam, historyReplaceFn);
            };
            return capturedOriginTraces;
        };
        this._originStore = {};
    }
}
OriginTracing.messageEvent = 'origin landed';

},{"./analyticsWebTypes":"183Xd","./urlUtils":"gVcjs","@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"edPjz":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "DEFAULT_SESSION_EXPIRY_TIME_MS", ()=>DEFAULT_SESSION_EXPIRY_TIME_MS);
parcelHelpers.export(exports, "DEFAULT_EXPIRY_DEBOUNCE", ()=>DEFAULT_EXPIRY_DEBOUNCE);
parcelHelpers.export(exports, "DEFAULT_DEBOUNCE_THRESHOLD_PERCENTAGE", ()=>DEFAULT_DEBOUNCE_THRESHOLD_PERCENTAGE);
parcelHelpers.export(exports, "NOOP", ()=>NOOP);
// eslint-disable-next-line @atlaskit/volt-strict-mode/no-multiple-exports
parcelHelpers.export(exports, "default", ()=>SessionTracking);
var _safeLocalStorage = require("./storage/SafeLocalStorage");
var _safeLocalStorageDefault = parcelHelpers.interopDefault(_safeLocalStorage);
// WARNING: The value of SESSION_ID_STORAGE_KEY is relied upon by other Platform packages
// (eg. search-page, product-search-dialog). If you need to change this key, you MUST
// notify the dependant Platform teams and update all dependent packages accordingly.
const SESSION_ID_STORAGE_KEY = 'session.id';
const SESSION_EXPIRY_STORAGE_KEY = 'session.expiry';
const ONLY_NUMBERS_REGEX = /^\d+$/;
const DEFAULT_SESSION_EXPIRY_TIME_MS = 1800000; // 30 minutes
const DEFAULT_EXPIRY_DEBOUNCE = 5000; // 5 seconds
const DEFAULT_DEBOUNCE_THRESHOLD_PERCENTAGE = 0.9; // 90% of expiry
const NOOP = ()=>{};
class SessionTracking {
    getCurrentSessionId() {
        const sessionId = this._safeLocalStorage.getItem(SESSION_ID_STORAGE_KEY);
        const sessionExpiry = parseInt(this._safeLocalStorage.getItem(SESSION_EXPIRY_STORAGE_KEY) || '0', 10) || 0;
        this._debouncedUpdateSessionExpiry(sessionExpiry);
        if (!sessionId || sessionExpiry <= Date.now() || Number.isNaN(sessionExpiry)) return this._generateNewSessionId();
        // Old versions of sessionId were UUIDs which caused issues for Amplitude which only accepts
        // integers for this field. In these scenarios we want to regenerate the sessionId as an integer
        if (!ONLY_NUMBERS_REGEX.test(sessionId)) return this._generateNewSessionId();
        return sessionId;
    }
    constructor(options = {}){
        this._generateNewSessionId = ()=>{
            const newSessionId = Date.now().toString();
            this._safeLocalStorage.setItem(SESSION_ID_STORAGE_KEY, newSessionId);
            // COMMENTS-123 - When a new session starts, call the callback if it is given
            this._onNewSessionStarted && this._onNewSessionStarted();
            return newSessionId;
        };
        this._updateSessionExpiry = ()=>{
            const expiry = Date.now() + this._sessionExpiryTime;
            this._safeLocalStorage.setItem(SESSION_EXPIRY_STORAGE_KEY, expiry.toString());
            return expiry;
        };
        this._debouncedUpdateSessionExpiry = (currentExpiry)=>{
            const { _updateSessionExpiry } = this;
            // If the current expiry is out of date by more than 10% of the expiry, update immediately
            if (currentExpiry < Date.now() + this._sessionExpiryDebounceThresholdPercentage * this._sessionExpiryTime) _updateSessionExpiry();
            else {
                if (this._sessionExpiryDebounceTimer) clearTimeout(this._sessionExpiryDebounceTimer);
                // @ts-ignore Something wrong with our types... this is legit
                this._sessionExpiryDebounceTimer = setTimeout(()=>{
                    _updateSessionExpiry();
                }, this._sessionExpiryDebounce);
            }
        };
        this._sessionExpiryTime = options.sessionExpiryTime || DEFAULT_SESSION_EXPIRY_TIME_MS;
        this._sessionExpiryDebounce = options.sessionExpiryDebounce || DEFAULT_EXPIRY_DEBOUNCE;
        this._sessionExpiryDebounceThresholdPercentage = options.sessionExpiryDebounceThresholdPercentage || DEFAULT_DEBOUNCE_THRESHOLD_PERCENTAGE;
        this._onNewSessionStarted = options.onNewSessionStarted ? options.onNewSessionStarted : NOOP;
        this._safeLocalStorage = new (0, _safeLocalStorageDefault.default)();
    }
}

},{"./storage/SafeLocalStorage":"gVEHh","@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"aeZiF":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
// eslint-disable-next-line import/no-anonymous-default-export
parcelHelpers.export(exports, "default", ()=>_class);
var _inMemoryStorage = require("./InMemoryStorage");
var _inMemoryStorageDefault = parcelHelpers.interopDefault(_inMemoryStorage);
var _safeStorage = require("./SafeStorage");
var _safeStorageDefault = parcelHelpers.interopDefault(_safeStorage);
class _class extends (0, _safeStorageDefault.default) {
    constructor(options){
        let storageToUse;
        try {
            // eslint-disable-next-line @atlaskit/platform/no-direct-web-storage-usage -- existing usage
            storageToUse = globalThis.sessionStorage || (0, _inMemoryStorageDefault.default);
        } catch (err) {
            storageToUse = (0, _inMemoryStorageDefault.default);
        }
        super(storageToUse, options);
    }
}

},{"./InMemoryStorage":"1BUdT","./SafeStorage":"38PtO","@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"g8l08":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>TabTracking);
var _safeSessionStorage = require("./storage/SafeSessionStorage");
var _safeSessionStorageDefault = parcelHelpers.interopDefault(_safeSessionStorage);
var _uuid = require("./uuid");
var _uuidDefault = parcelHelpers.interopDefault(_uuid);
const STORAGE_KEY = 'tab.id';
class TabTracking {
    getCurrentTabId() {
        let tabId = this._safeSessionStorage.getItem(STORAGE_KEY);
        if (!tabId) tabId = this._generateNewTabId();
        return tabId;
    }
    constructor(){
        this._generateNewTabId = ()=>{
            const newTabId = (0, _uuidDefault.default)();
            this._safeSessionStorage.setItem(STORAGE_KEY, newTabId);
            return newTabId;
        };
        this._safeSessionStorage = new (0, _safeSessionStorageDefault.default)();
    }
}

},{"./storage/SafeSessionStorage":"aeZiF","./uuid":"igO59","@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"AqVua":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>TaskSessionStore);
var _objectSpread = require("@swc/helpers/_/_object_spread");
var _queryString = require("query-string");
var _analyticsWebTypes = require("./analyticsWebTypes");
var _objectUtils = require("./objectUtils");
var _safeSessionStorage = require("./storage/SafeSessionStorage");
var _safeSessionStorageDefault = parcelHelpers.interopDefault(_safeSessionStorage);
var _urlUtils = require("./urlUtils");
var _urlUtilsDefault = parcelHelpers.interopDefault(_urlUtils);
var _uuid = require("./uuid");
var _uuidDefault = parcelHelpers.interopDefault(_uuid);
const STORAGE_KEY = 'taskSessions';
const INIT_KEY = 'taskSessionsInit';
const AWC_PARAM_PREFIX = 'awc.';
const TASK_SESSION_RELOAD_TIME = 3000;
class TaskSessionStore {
    constructor(){
        this._taskSessionsNotRecentlyInitialised = (currentTimestamp)=>this._safeSessionStorage.getItem(STORAGE_KEY) === null || this._safeSessionStorage.getItem(INIT_KEY) === null || parseInt(this._safeSessionStorage.getItem(INIT_KEY) || '0', 10) < currentTimestamp - TASK_SESSION_RELOAD_TIME;
        this._removeTaskSessionPrefix = (_, taskSessionName)=>taskSessionName.split(AWC_PARAM_PREFIX)[1];
        this._isTaskSessionQueryParam = (_, taskSessionName)=>taskSessionName.startsWith(AWC_PARAM_PREFIX);
        this.getAllTaskSessions = ()=>{
            try {
                return JSON.parse(this._safeSessionStorage.getItem(STORAGE_KEY) || '');
            } catch (e) {
                return {};
            }
        };
        this._writeToSessionStorage = (taskSessions)=>{
            try {
                this._safeSessionStorage.setItem(STORAGE_KEY, JSON.stringify(taskSessions));
            // eslint-disable-next-line no-empty
            } catch (e) {}
        };
        this._appendTaskSessions = (newTaskSessions)=>{
            const currentState = this.getAllTaskSessions();
            const newState = currentState === null ? newTaskSessions : Object.assign(currentState, newTaskSessions);
            this._writeToSessionStorage(newState);
        };
        this._safelyRemoveKey = (currentState, taskSessionName)=>{
            if (currentState === null) return {};
            delete currentState[taskSessionName];
            return currentState;
        };
        this.createTaskSession = (taskSessionName)=>{
            const taskSessionId = (0, _uuidDefault.default)();
            const newTaskSessions = {};
            newTaskSessions[taskSessionName] = taskSessionId;
            this._appendTaskSessions(newTaskSessions);
            return taskSessionId;
        };
        this.createTaskSessionWithProvidedId = (taskSessionName, taskSessionId)=>{
            if (typeof taskSessionId !== 'string') throw new TypeError('invalid taskSessionId, must be string');
            const newTaskSessions = {};
            newTaskSessions[taskSessionName] = taskSessionId;
            this._appendTaskSessions(newTaskSessions);
        };
        this.completeTaskSession = (taskSessionName)=>{
            const currentState = this.getAllTaskSessions();
            const updatedState = this._safelyRemoveKey(currentState, taskSessionName);
            this._writeToSessionStorage(updatedState);
        };
        this.formatTaskSessionQueryString = ({ uri, includedTaskSessions })=>{
            const { url, query } = (0, _queryString.parseUrl)(uri);
            const currentState = this.getAllTaskSessions();
            // Use specified task sessions, otherwise all tasksessions excluding originTracing sessions
            const filteredTaskSessions = includedTaskSessions ? (0, _objectUtils.pick)(currentState, includedTaskSessions) : (0, _objectUtils.omit)(currentState, Object.values((0, _analyticsWebTypes.originTracingType)));
            if (Object.keys(filteredTaskSessions).length === 0) return uri;
            const queryWithTaskSessions = (0, _objectSpread._)({}, (0, _objectUtils.mapKeys)(filteredTaskSessions, (_, taskSessionName)=>AWC_PARAM_PREFIX + taskSessionName), query);
            return `${url}?${(0, _queryString.stringify)(queryWithTaskSessions)}`;
        };
        this.stripQueryParameters = ()=>{
            const extractedTaskSessions = (0, _objectUtils.mapKeys)((0, _urlUtilsDefault.default)(this._isTaskSessionQueryParam), this._removeTaskSessionPrefix);
            this._appendTaskSessions(extractedTaskSessions);
        };
        const currentTimestamp = Date.now();
        this._safeSessionStorage = new (0, _safeSessionStorageDefault.default)();
        // Wrapping all sessionStorage calls in try catch to stop any error propogation, taskSessions should gracefully fail.
        try {
            if (this._taskSessionsNotRecentlyInitialised(currentTimestamp)) {
                this._writeToSessionStorage({});
                this._safeSessionStorage.setItem(INIT_KEY, currentTimestamp.toString());
            }
        // eslint-disable-next-line no-empty
        } catch (e) {}
    }
}

},{"@swc/helpers/_/_object_spread":"9gdrV","query-string":"jcXMO","./analyticsWebTypes":"183Xd","./objectUtils":"h1ZE7","./storage/SafeSessionStorage":"aeZiF","./urlUtils":"gVcjs","./uuid":"igO59","@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"1xVFq":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _jsCookie = require("js-cookie");
var _jsCookieDefault = parcelHelpers.interopDefault(_jsCookie);
var _cookie = require("./cookie");
var _testSupport = require("./util/testSupport");
const MAX_CACHE_SIZE = 100;
const COOKIE_NAME = (0, _cookie.AllAnalyticsCookies).AWC_ANALYTICS_DEBUG.getKey();
const DEBUG_TAG = 'synthetic';
class TestingCache {
    saveEvent(event) {
        try {
            if (!event) return;
            this.bind();
            this.addSyntheticTag(event);
            this.cache(event);
        } catch (e) {
        // Ignore errors from testing cache.
        }
    }
    bind() {
        if (!this.shouldCacheEvent() || typeof window === 'undefined' || window.testAnalytics) return;
        window.testAnalytics = {
            eventCache: [],
            events: ()=>window.testAnalytics.eventCache,
            clear: ()=>{
                window.testAnalytics.eventCache = [];
                try {
                    localStorage.removeItem('awc.ui.viewed.last.sent');
                    localStorage.removeItem('awc-staging.ui.viewed.last.sent');
                    localStorage.removeItem('awc-dev.ui.viewed.last.sent');
                    localStorage.removeItem('awc-local.ui.viewed.last.sent');
                } catch (e) {
                // Ignore errors from localStorage.
                }
            }
        };
    }
    cache(event) {
        if (!this.shouldCacheEvent() || typeof window === 'undefined' || !window.testAnalytics) return;
        if (window.testAnalytics.eventCache.length >= MAX_CACHE_SIZE) window.testAnalytics.eventCache = window.testAnalytics.eventCache.slice(1, window.testAnalytics.eventCache.length);
        window.testAnalytics.eventCache.push(event);
    }
    addSyntheticTag(event) {
        if (!this.shouldSetSyntheticFlag()) return;
        if (event.tags instanceof Array) {
            if (!event.tags.includes(DEBUG_TAG)) event.tags.push(DEBUG_TAG);
        } else event.tags = [
            DEBUG_TAG
        ];
    }
    shouldCacheEvent() {
        return this._enableTestingCache ? this._enableTestingCache : this._isDebugCookieEnabled;
    }
    shouldSetSyntheticFlag() {
        if (this._syntheticFlagOverride !== undefined) return this._syntheticFlagOverride;
        const globalSyntheticOverride = (0, _testSupport.TestSupport).getSyntheticFlagOverride();
        if (globalSyntheticOverride !== undefined) return globalSyntheticOverride;
        return this.shouldCacheEvent();
    }
    static getDebugCookie() {
        try {
            return JSON.parse((0, _jsCookieDefault.default).get(COOKIE_NAME) || 'false') === true;
        } catch (e) {
            (0, _jsCookieDefault.default).remove(COOKIE_NAME);
        }
        return false;
    }
    constructor(syntheticFlagOverride, enableTestingCache){
        this._syntheticFlagOverride = typeof syntheticFlagOverride === 'boolean' ? syntheticFlagOverride : undefined;
        this._enableTestingCache = typeof enableTestingCache === 'boolean' ? enableTestingCache : undefined;
        this._isDebugCookieEnabled = TestingCache.getDebugCookie();
        this.bind();
    }
}
exports.default = TestingCache;

},{"js-cookie":"brgOH","./cookie":"3jiLY","./util/testSupport":"eJmcF","@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"eOUrX":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>UIViewedEvent);
var _objectSpread = require("@swc/helpers/_/_object_spread");
var _objectSpreadProps = require("@swc/helpers/_/_object_spread_props");
var _objectWithoutProperties = require("@swc/helpers/_/_object_without_properties");
var _analyticsWebTypes = require("./analyticsWebTypes");
var _getDocument = require("./getDocument");
var _safeLocalStorage = require("./storage/SafeLocalStorage");
var _safeLocalStorageDefault = parcelHelpers.interopDefault(_safeLocalStorage);
const DEFAULT_DELAY = 2000; // 2 seconds
const DEFAULT_THROTTLE = 3600000; // 1 hour
const DEFAULT_STORAGE_KEY = 'ui.viewed.last.sent';
const DEFAULT_MALFORMED_UIVIEWED_EVENT = 'malformed.uiviewed.last.sent';
var SendEventDecision = /*#__PURE__*/ function(SendEventDecision) {
    SendEventDecision[SendEventDecision["FocusLost"] = 0] = "FocusLost";
    SendEventDecision[SendEventDecision["UserOrTenantIncomplete"] = 1] = "UserOrTenantIncomplete";
    SendEventDecision[SendEventDecision["MalformedUiViewedRateLimited"] = 2] = "MalformedUiViewedRateLimited";
    SendEventDecision[SendEventDecision["EligibleToSend"] = 3] = "EligibleToSend";
    SendEventDecision[SendEventDecision["UiViewedRateLimited"] = 4] = "UiViewedRateLimited";
    return SendEventDecision;
}(SendEventDecision || {});
class UIViewedEvent {
    constructor(productInfo, getContext, onEvent, settings = {}){
        this.start = ()=>{
            this._startInterval();
            this._bindEventListeners();
        };
        this.stop = ()=>{
            this._stopInterval();
            this._unbindEventListeners();
        };
        this.resetTimers = ()=>{
            if (this._intervalId) {
                this.stop();
                this.start();
            }
        };
        this.signalUserActive = ()=>{
            this._sendUserActiveEvents();
        };
        this._bindEventListeners = ()=>{
            if (typeof window !== 'undefined') {
                window.addEventListener('focus', this._focusListener);
                window.addEventListener('blur', this._blurListener);
            }
        };
        this._unbindEventListeners = ()=>{
            if (typeof window !== 'undefined') {
                window.removeEventListener('focus', this._focusListener);
                window.removeEventListener('blur', this._blurListener);
            }
        };
        this._startInterval = ()=>{
            clearInterval(this._intervalId);
            this._intervalId = setInterval(this._handleDwellTimerTriggered, this._delay);
        };
        this._stopInterval = ()=>{
            if (this._intervalId) {
                clearInterval(this._intervalId);
                this._intervalId = null;
            }
        };
        this._getProductKey = (product, subproduct)=>{
            let productKey = product;
            if (subproduct) productKey += `-${subproduct}`;
            return productKey;
        };
        this._getLastSentTimestamp = (productKey, tenantId, userId)=>{
            const json = this._parseLocalStorageData(this._storageKey) || {};
            const u = json[userId] || {};
            const t = u[tenantId] || {};
            const p = t[productKey] || null;
            return p;
        };
        this._parseLocalStorageData = (key)=>{
            const data = this._safeLocalStorage.getItem(key);
            try {
                return JSON.parse(data || '');
            } catch (e) {
                this._safeLocalStorage.removeItem(key);
                return null;
            }
        };
        this._getMalformedLastSentTimestamp = (productKey, tenantId, userId)=>{
            const json = this._parseLocalStorageData(this._malformedEventStorageKey) || {};
            const finalUserId = userId || 'NOT_SET';
            const finalTenantId = tenantId || 'NOT_SET';
            const u = json[finalUserId] || {};
            const t = u[finalTenantId] || {};
            const p = t[productKey] || null;
            return p;
        };
        this._setLastSentTimestamp = (productKey, tenantId, userId)=>{
            const json = this._parseLocalStorageData(this._storageKey) || {};
            const u = json[userId] || {};
            const t = u[tenantId] || {};
            t[productKey] = Date.now();
            u[tenantId] = t;
            json[userId] = u;
            this._safeLocalStorage.setItem(this._storageKey, JSON.stringify(json));
        };
        this._setMalformedLastSentTimestamp = (productKey, tenantId, userId)=>{
            const json = this._parseLocalStorageData(this._malformedEventStorageKey) || {};
            const finalUserId = userId || 'NOT_SET';
            const finalTenantId = tenantId || 'NOT_SET';
            const u = json[finalUserId] || {};
            const t = u[finalTenantId] || {};
            t[productKey] = Date.now();
            u[finalTenantId] = t;
            json[finalUserId] = u;
            this._safeLocalStorage.setItem(this._malformedEventStorageKey, JSON.stringify(json));
        };
        this._handleDwellTimerTriggered = ()=>{
            const document = (0, _getDocument.getDocument)();
            if (document && !document.hasFocus()) return;
            this._sendUserActiveEvents();
        };
        this._sendUserActiveEvents = ()=>{
            const _this__getContext = this._getContext(), { embeddedProduct } = _this__getContext, context = (0, _objectWithoutProperties._)(_this__getContext, [
                "embeddedProduct"
            ]);
            this._sendEvent(this._product, context, false);
            if (embeddedProduct) this._sendEvent(embeddedProduct, context, true);
        };
        this._sendEvent = (product, context, isEmbeddedProduct)=>{
            const { subproduct, tenantIdType, tenantId, userId, lastScreenEvent, attributes } = context;
            const productKey = this._getProductKey(product, subproduct);
            const sendEventDecision = this._shouldSendEvent(productKey, tenantIdType, tenantId, userId);
            switch(sendEventDecision){
                case 3:
                    this._setLastSentTimestamp(productKey, tenantId, userId);
                    this._onEvent(this._createEvent(product, subproduct, isEmbeddedProduct, lastScreenEvent, attributes, 'ui', 'viewed'));
                    break;
                case 1:
                    this._setMalformedLastSentTimestamp(productKey, tenantId, userId);
                    this._onEvent(this._createEvent(product, subproduct, isEmbeddedProduct, lastScreenEvent, attributes, 'malformed', 'uiviewed'));
                    break;
                default:
                    break;
            }
        };
        this._shouldSendEvent = (productKey, tenantIdType, tenantId, userId)=>{
            // TENANT OR USER ID NOT SET
            if (tenantIdType !== (0, _analyticsWebTypes.tenantType).NONE && !tenantId || !userId) {
                const sinceLastSent = Date.now() - this._getMalformedLastSentTimestamp(productKey, tenantId, userId);
                if (sinceLastSent === null || sinceLastSent > this._throttle) return 1;
                return 2;
            }
            const sinceLastSent = Date.now() - this._getLastSentTimestamp(productKey, tenantId, userId);
            if (sinceLastSent === null || sinceLastSent > this._throttle) return 3;
            return 4;
        };
        this._createEvent = (product, subproduct, isEmbeddedProduct, lastScreenEvent, extraAttributes, actionSubject, action)=>{
            const event = {
                product,
                source: 'ui',
                action,
                actionSubject,
                attributes: extraAttributes
            };
            if (isEmbeddedProduct) {
                // Clear the subproduct and version as they don't relate to the embedded product
                event.subproduct = null;
                event.version = null;
                event.attributes = (0, _objectSpreadProps._)((0, _objectSpread._)({}, event.attributes), {
                    embeddedInEnv: this._productInfo.env,
                    embeddedInProduct: this._productInfo.product,
                    embeddedInSubproduct: subproduct,
                    embeddedInVersion: this._productInfo.version,
                    embeddedInOrigin: this._productInfo.origin,
                    embeddedInPlatform: this._productInfo.platform
                });
            }
            if (lastScreenEvent) event.attributes = (0, _objectSpreadProps._)((0, _objectSpread._)({}, event.attributes), {
                lastScreenEvent: {
                    name: lastScreenEvent.name,
                    attributes: lastScreenEvent.attributes
                }
            });
            return event;
        };
        if (!productInfo) throw new Error('Missing productInfo');
        if (!productInfo.product) throw new Error('Missing productInfo.product');
        if (!getContext) throw new Error('Missing getContext callback');
        if (typeof getContext !== 'function') throw new Error('Invalid getContext, must be function');
        if (!onEvent) throw new Error('Missing onEvent callback');
        if (typeof onEvent !== 'function') throw new Error('Invalid onEvent, must be function');
        this._productInfo = productInfo;
        this._product = productInfo.product;
        this._getContext = getContext;
        this._onEvent = onEvent;
        this._delay = settings.delay || DEFAULT_DELAY;
        this._throttle = settings.throttle || DEFAULT_THROTTLE;
        this._storageKey = settings.storageKey || DEFAULT_STORAGE_KEY;
        this._malformedEventStorageKey = settings.malformedStorageKey || DEFAULT_MALFORMED_UIVIEWED_EVENT;
        this._safeLocalStorage = new (0, _safeLocalStorageDefault.default)({
            envPrefix: this._productInfo.env
        });
        this._focusListener = ()=>{
            this._startInterval();
        };
        this._blurListener = ()=>{
            this._stopInterval();
        };
    }
}

},{"@swc/helpers/_/_object_spread":"9gdrV","@swc/helpers/_/_object_spread_props":"kANqQ","@swc/helpers/_/_object_without_properties":"6HqIM","./analyticsWebTypes":"183Xd","./getDocument":"67KNN","./storage/SafeLocalStorage":"gVEHh","@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"67KNN":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "getDocument", ()=>getDocument);
const getDocument = ()=>{
    if (typeof document !== 'undefined') return document;
    return null;
};

},{"@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"9d5Wf":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>wrapCallback);
function wrapCallback(callback, event) {
    if (!callback || typeof callback !== 'function') return null;
    return ()=>{
        callback(event);
    };
}

},{"@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"7l8Iu":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>(0, _originTracerDefault.default));
var _originTracer = require("./origin-tracer");
var _originTracerDefault = parcelHelpers.interopDefault(_originTracer);

},{"./origin-tracer":"c6z5b","@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"c6z5b":[function(require,module,exports,__globalThis) {
// import uuid from 'uuid/v4';
// eslint-disable-next-line @atlaskit/platform/prefer-crypto-random-uuid -- Use crypto.randomUUID instead
var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>OriginTracer);
var _objectSpread = require("@swc/helpers/_/_object_spread");
var _uuid = require("uuid");
var _encoder = require("./encoder");
var _env = require("./env");
const packageVersion = "0.16.1";
const originParamName = 'atlOrigin';
const originVersioningAttributes = {
    originLibrary: `origin-tracing.js@${packageVersion}`
};
class OriginTracer {
    static isValidId(value) {
        return typeof value === 'string' && /^[-_a-zA-Z0-9]{1,36}$/.test(value);
    }
    static isValidProduct(value) {
        return typeof value === 'string' && /^[-_a-zA-Z0-9]{1,20}$/.test(value);
    }
    static generateId() {
        // eslint-disable-next-line @atlaskit/platform/prefer-crypto-random-uuid -- Use crypto.randomUUID instead
        const id = (0, _uuid.v4)();
        // Dash positions are fixed so they don't add to uniqueness.
        // Remove them to save space in the encoded form.
        return id.replace(/-/g, '');
    }
    static createEmpty() {
        return new EmptyOriginTracer();
    }
    static createMalformed() {
        return new MalformedOriginTracer();
    }
    static fromUrl(url) {
        let params = new ((0, _env.getEnv)()).URLSearchParams();
        replaceQuery(url, (queryString)=>{
            params = new ((0, _env.getEnv)()).URLSearchParams(queryString);
        });
        return OriginTracer.fromEncoded(params.get(originParamName));
    }
    static fromEncoded(encoded) {
        if (!encoded) return OriginTracer.createEmpty();
        try {
            return OriginTracer.decode(encoded);
        } catch (e) {
            return OriginTracer.createMalformed();
        }
    }
    static removeFromUrl(url) {
        return replaceQuery(url, (queryString)=>{
            const params = new ((0, _env.getEnv)()).URLSearchParams(queryString);
            params.delete(originParamName);
            return params.toString();
        });
    }
    static decode(encodedOrigin) {
        const originData = (0, _encoder.decode)(encodedOrigin);
        return new OriginTracer(originData);
    }
    encode() {
        return (0, _encoder.encode)({
            id: this.id,
            product: this.product
        });
    }
    addToUrl(url) {
        return replaceQuery(url, (originalQueryString)=>{
            const params = new ((0, _env.getEnv)()).URLSearchParams(originalQueryString);
            params.set(originParamName, this.encode());
            return params.toString();
        });
    }
    containsOrigin(urlString) {
        const url = new ((0, _env.getEnv)()).URL(urlString);
        const params = new URLSearchParams(url.search);
        return params.has(originParamName);
    }
    isEmpty() {
        return false;
    }
    isMalformed() {
        return !this.isEmpty() && !this.isValid();
    }
    isValid() {
        return true;
    }
    toAnalyticsAttributes({ transformValue = (v)=>v === null ? undefined : v, hasGeneratedId = false } = {}) {
        // `originIdGenerated` should be used in analytic events that generated this originId.
        // Subsequent events should use `originId`.
        // No two events should have the same value of originIdGenerated.
        const originIdProp = hasGeneratedId ? 'originIdGenerated' : 'originId';
        return (0, _objectSpread._)({
            [originIdProp]: transformValue(this.id),
            originProduct: transformValue(this.product)
        }, originVersioningAttributes);
    }
    validate() {
        if (!OriginTracer.isValidId(this.id)) throw new TypeError('Invalid Origin id');
        if (!OriginTracer.isValidProduct(this.product)) throw new TypeError('Missing/invalid Origin product');
    }
    constructor({ id = OriginTracer.generateId(), product, dangerouslySkipValidation = false }){
        this.id = id;
        this.product = product;
        if (!dangerouslySkipValidation) this.validate();
    }
}
class EmptyOriginTracer extends OriginTracer {
    isValid() {
        return false;
    }
    isEmpty() {
        return true;
    }
    toAnalyticsAttributes() {
        return (0, _objectSpread._)({}, originVersioningAttributes);
    }
    constructor(){
        super({
            id: null,
            product: null,
            dangerouslySkipValidation: true
        });
    }
}
class MalformedOriginTracer extends OriginTracer {
    isValid() {
        return false;
    }
    isEmpty() {
        return false;
    }
    toAnalyticsAttributes() {
        return (0, _objectSpread._)({
            originMalformed: true
        }, originVersioningAttributes);
    }
    constructor(){
        super({
            id: null,
            product: null,
            dangerouslySkipValidation: true
        });
    }
}
function replaceQuery(url, replacer) {
    const urlWithQueryStringRegex = /(^[^?#]*)(?:\?)?([^#]*?)(#.*|$)$/;
    // If we get passed window.location, we don't want to call window.location.replace()
    const urlString = String(url);
    return urlString.replace(urlWithQueryStringRegex, (_wholeMatch, beforeQuery, queryString, afterQuery)=>{
        let newQueryString = replacer(queryString);
        if (newQueryString) newQueryString = `?${newQueryString}`;
        return `${beforeQuery}${newQueryString}${afterQuery}`;
    });
}

},{"@swc/helpers/_/_object_spread":"9gdrV","uuid":"5elg8","./encoder":"6NYPI","./env":"hD9Oi","@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"5elg8":[function(require,module,exports,__globalThis) {
var v1 = require("d2d48e4dfb01c5c3");
var v4 = require("f9cde9eaad80431a");
var uuid = v4;
uuid.v1 = v1;
uuid.v4 = v4;
module.exports = uuid;

},{"d2d48e4dfb01c5c3":"5HupF","f9cde9eaad80431a":"gUwCJ"}],"5HupF":[function(require,module,exports,__globalThis) {
var rng = require("a3551f36bebcd2d0");
var bytesToUuid = require("3fcd61e388bbc0a3");
// **`v1()` - Generate time-based UUID**
//
// Inspired by https://github.com/LiosK/UUID.js
// and http://docs.python.org/library/uuid.html
var _nodeId;
var _clockseq;
// Previous uuid creation time
var _lastMSecs = 0;
var _lastNSecs = 0;
// See https://github.com/uuidjs/uuid for API details
function v1(options, buf, offset) {
    var i = buf && offset || 0;
    var b = buf || [];
    options = options || {};
    var node = options.node || _nodeId;
    var clockseq = options.clockseq !== undefined ? options.clockseq : _clockseq;
    // node and clockseq need to be initialized to random values if they're not
    // specified.  We do this lazily to minimize issues related to insufficient
    // system entropy.  See #189
    if (node == null || clockseq == null) {
        var seedBytes = rng();
        if (node == null) // Per 4.5, create and 48-bit node id, (47 random bits + multicast bit = 1)
        node = _nodeId = [
            seedBytes[0] | 0x01,
            seedBytes[1],
            seedBytes[2],
            seedBytes[3],
            seedBytes[4],
            seedBytes[5]
        ];
        if (clockseq == null) // Per 4.2.2, randomize (14 bit) clockseq
        clockseq = _clockseq = (seedBytes[6] << 8 | seedBytes[7]) & 0x3fff;
    }
    // UUID timestamps are 100 nano-second units since the Gregorian epoch,
    // (1582-10-15 00:00).  JSNumbers aren't precise enough for this, so
    // time is handled internally as 'msecs' (integer milliseconds) and 'nsecs'
    // (100-nanoseconds offset from msecs) since unix epoch, 1970-01-01 00:00.
    var msecs = options.msecs !== undefined ? options.msecs : new Date().getTime();
    // Per 4.2.1.2, use count of uuid's generated during the current clock
    // cycle to simulate higher resolution clock
    var nsecs = options.nsecs !== undefined ? options.nsecs : _lastNSecs + 1;
    // Time since last uuid creation (in msecs)
    var dt = msecs - _lastMSecs + (nsecs - _lastNSecs) / 10000;
    // Per 4.2.1.2, Bump clockseq on clock regression
    if (dt < 0 && options.clockseq === undefined) clockseq = clockseq + 1 & 0x3fff;
    // Reset nsecs if clock regresses (new clockseq) or we've moved onto a new
    // time interval
    if ((dt < 0 || msecs > _lastMSecs) && options.nsecs === undefined) nsecs = 0;
    // Per 4.2.1.2 Throw error if too many uuids are requested
    if (nsecs >= 10000) throw new Error('uuid.v1(): Can\'t create more than 10M uuids/sec');
    _lastMSecs = msecs;
    _lastNSecs = nsecs;
    _clockseq = clockseq;
    // Per 4.1.4 - Convert from unix epoch to Gregorian epoch
    msecs += 12219292800000;
    // `time_low`
    var tl = ((msecs & 0xfffffff) * 10000 + nsecs) % 0x100000000;
    b[i++] = tl >>> 24 & 0xff;
    b[i++] = tl >>> 16 & 0xff;
    b[i++] = tl >>> 8 & 0xff;
    b[i++] = tl & 0xff;
    // `time_mid`
    var tmh = msecs / 0x100000000 * 10000 & 0xfffffff;
    b[i++] = tmh >>> 8 & 0xff;
    b[i++] = tmh & 0xff;
    // `time_high_and_version`
    b[i++] = tmh >>> 24 & 0xf | 0x10; // include version
    b[i++] = tmh >>> 16 & 0xff;
    // `clock_seq_hi_and_reserved` (Per 4.2.2 - include variant)
    b[i++] = clockseq >>> 8 | 0x80;
    // `clock_seq_low`
    b[i++] = clockseq & 0xff;
    // `node`
    for(var n = 0; n < 6; ++n)b[i + n] = node[n];
    return buf ? buf : bytesToUuid(b);
}
module.exports = v1;

},{"a3551f36bebcd2d0":"aM37N","3fcd61e388bbc0a3":"2dNNI"}],"aM37N":[function(require,module,exports,__globalThis) {
// Unique ID creation requires a high quality random # generator.  In the
// browser this is a little complicated due to unknown quality of Math.random()
// and inconsistent support for the `crypto` API.  We do the best we can via
// feature-detection
// getRandomValues needs to be invoked in a context where "this" is a Crypto
// implementation. Also, find the complete implementation of crypto on IE11.
var getRandomValues = typeof crypto != 'undefined' && crypto.getRandomValues && crypto.getRandomValues.bind(crypto) || typeof msCrypto != 'undefined' && typeof window.msCrypto.getRandomValues == 'function' && msCrypto.getRandomValues.bind(msCrypto);
if (getRandomValues) {
    // WHATWG crypto RNG - http://wiki.whatwg.org/wiki/Crypto
    var rnds8 = new Uint8Array(16); // eslint-disable-line no-undef
    module.exports = function whatwgRNG() {
        getRandomValues(rnds8);
        return rnds8;
    };
} else {
    // Math.random()-based (RNG)
    //
    // If all else fails, use Math.random().  It's fast, but is of unspecified
    // quality.
    var rnds = new Array(16);
    module.exports = function mathRNG() {
        for(var i = 0, r; i < 16; i++){
            if ((i & 0x03) === 0) r = Math.random() * 0x100000000;
            rnds[i] = r >>> ((i & 0x03) << 3) & 0xff;
        }
        return rnds;
    };
}

},{}],"2dNNI":[function(require,module,exports,__globalThis) {
/**
 * Convert array of 16 byte values to UUID string format of the form:
 * XXXXXXXX-XXXX-XXXX-XXXX-XXXXXXXXXXXX
 */ var byteToHex = [];
for(var i = 0; i < 256; ++i)byteToHex[i] = (i + 0x100).toString(16).substr(1);
function bytesToUuid(buf, offset) {
    var i = offset || 0;
    var bth = byteToHex;
    // join used to fix memory issue caused by concatenation: https://bugs.chromium.org/p/v8/issues/detail?id=3175#c4
    return [
        bth[buf[i++]],
        bth[buf[i++]],
        bth[buf[i++]],
        bth[buf[i++]],
        '-',
        bth[buf[i++]],
        bth[buf[i++]],
        '-',
        bth[buf[i++]],
        bth[buf[i++]],
        '-',
        bth[buf[i++]],
        bth[buf[i++]],
        '-',
        bth[buf[i++]],
        bth[buf[i++]],
        bth[buf[i++]],
        bth[buf[i++]],
        bth[buf[i++]],
        bth[buf[i++]]
    ].join('');
}
module.exports = bytesToUuid;

},{}],"gUwCJ":[function(require,module,exports,__globalThis) {
var rng = require("f08f39ba8b6d6261");
var bytesToUuid = require("9d6ef2cb3a85b612");
function v4(options, buf, offset) {
    var i = buf && offset || 0;
    if (typeof options == 'string') {
        buf = options === 'binary' ? new Array(16) : null;
        options = null;
    }
    options = options || {};
    var rnds = options.random || (options.rng || rng)();
    // Per 4.4, set bits for version and `clock_seq_hi_and_reserved`
    rnds[6] = rnds[6] & 0x0f | 0x40;
    rnds[8] = rnds[8] & 0x3f | 0x80;
    // Copy bytes to buffer, if provided
    if (buf) for(var ii = 0; ii < 16; ++ii)buf[i + ii] = rnds[ii];
    return buf || bytesToUuid(rnds);
}
module.exports = v4;

},{"f08f39ba8b6d6261":"aM37N","9d6ef2cb3a85b612":"2dNNI"}],"6NYPI":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "encode", ()=>encode);
parcelHelpers.export(exports, "decode", ()=>decode);
parcelHelpers.export(exports, "toJSONObject", ()=>toJSONObject);
parcelHelpers.export(exports, "fromJSONObject", ()=>fromJSONObject);
var _base64Url = require("./util/base64url");
var _env = require("./env");
const productShorthands = {
    confluence: 'c',
    jira: 'j',
    stride: 's',
    bitbucket: 'b',
    trello: 't'
};
function encode(originData) {
    const json = JSON.stringify(toJSONObject(originData));
    const base64 = (0, _env.getEnv)().btoa(json);
    return (0, _base64Url.base64ToBase64Url)(base64);
}
function decode(encodedOriginString) {
    const base64 = (0, _base64Url.base64UrlToBase64)(encodedOriginString);
    const json = (0, _env.getEnv)().atob(base64);
    return fromJSONObject(JSON.parse(json));
}
function toJSONObject({ id, product }) {
    return {
        i: id,
        p: product && product in productShorthands ? productShorthands[product] : product
    };
}
function fromJSONObject(originJSONObject) {
    const originData = {};
    if (originJSONObject.i) originData.id = originJSONObject.i;
    if (originJSONObject.p) originData.product = expandProductShorthand(originJSONObject.p);
    return originData;
}
function expandProductShorthand(maybeShorthand) {
    const products = Object.keys(productShorthands);
    for(let i = 0; i < products.length; i++){
        const product = products[i];
        const shorthand = productShorthands[product];
        if (maybeShorthand === shorthand) return product;
    }
    return maybeShorthand;
}

},{"./util/base64url":"lTjwW","./env":"hD9Oi","@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"lTjwW":[function(require,module,exports,__globalThis) {
/**
 * This file converts between Base64 and Base 64 Encoding with URL and Filename Safe Alphabet,
 * the latter of which has URL-safe characters only (drops =, + and /).
 *
 * Why not use a library? The popular libs use Buffer to be able to
 * encode any data to base64. We don't need this capability, and it causes
 * Webpack to include 30KB of a Buffer polyfill.
 * Webpack's/UglifyJS's Tree Shaking seems to be unable to drop it.
 *
 * See: RFC 4648 section 5 (https://tools.ietf.org/html/rfc4648#section-5)
 */ var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "base64ToBase64Url", ()=>base64ToBase64Url);
parcelHelpers.export(exports, "base64UrlToBase64", ()=>base64UrlToBase64);
function base64ToBase64Url(base64) {
    if (base64 == null) return '';
    return String(base64).replace(/\+/g, '-').replace(/\//g, '_').replace(/=/g, '');
}
function base64UrlToBase64(base64url) {
    if (base64url == null) return '';
    const base64 = String(base64url).replace(/-/g, '+').replace(/_/g, '/');
    const padLength = (4 - base64url.length % 4) % 4;
    const pad = '==='.slice(0, padLength);
    return base64 + pad;
}

},{"@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"hD9Oi":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "getEnvGlobals", ()=>getEnvGlobals);
parcelHelpers.export(exports, "getEnv", ()=>getEnv);
var _buffer = require("buffer");
const getEnvGlobals = ()=>({
        atob: // atob/btoa need to be bound because they throw an illegal invocation error when called as a method (obj.atob())
        typeof atob === 'function' && atob.bind(undefined) || typeof (0, _buffer.Buffer) !== 'undefined' && ((encoded)=>(0, _buffer.Buffer).from(encoded, 'base64').toString()),
        btoa: typeof btoa === 'function' && btoa.bind(undefined) || typeof (0, _buffer.Buffer) !== 'undefined' && ((str)=>(0, _buffer.Buffer).from(str).toString('base64')),
        URLSearchParams: typeof URLSearchParams === 'function' && URLSearchParams || require("6860264cbd5c065c").URLSearchParams,
        URL: typeof URL === 'function' && URL || require("6860264cbd5c065c").URL
    });
let env;
const getEnv = ()=>env || (env = validateEnv(getEnvGlobals()));
const validateEnv = (env)=>{
    if (!(env.atob && env.btoa && env.URLSearchParams && env.URL)) throw new TypeError(`Origin-Tracing: missing environment APIs. Required: btoa(), atob(), URLSearchParams() (or in Node: Buffer, require('url').URLSearchParams).`);
    return env;
};

},{"buffer":"xxtHx","6860264cbd5c065c":"01vhI","@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"xxtHx":[function(require,module,exports,__globalThis) {
/*!
 * The buffer module from node.js, for the browser.
 *
 * @author   Feross Aboukhadijeh <https://feross.org>
 * @license  MIT
 */ /* eslint-disable no-proto */ 'use strict';
var base64 = require("936d7d40ee51556e");
var ieee754 = require("a9454e8447bbf491");
var customInspectSymbol = typeof Symbol === 'function' && typeof Symbol['for'] === 'function' // eslint-disable-line dot-notation
 ? Symbol['for']('nodejs.util.inspect.custom') // eslint-disable-line dot-notation
 : null;
exports.Buffer = Buffer;
exports.SlowBuffer = SlowBuffer;
exports.INSPECT_MAX_BYTES = 50;
var K_MAX_LENGTH = 0x7fffffff;
exports.kMaxLength = K_MAX_LENGTH;
/**
 * If `Buffer.TYPED_ARRAY_SUPPORT`:
 *   === true    Use Uint8Array implementation (fastest)
 *   === false   Print warning and recommend using `buffer` v4.x which has an Object
 *               implementation (most compatible, even IE6)
 *
 * Browsers that support typed arrays are IE 10+, Firefox 4+, Chrome 7+, Safari 5.1+,
 * Opera 11.6+, iOS 4.2+.
 *
 * We report that the browser does not support typed arrays if the are not subclassable
 * using __proto__. Firefox 4-29 lacks support for adding new properties to `Uint8Array`
 * (See: https://bugzilla.mozilla.org/show_bug.cgi?id=695438). IE 10 lacks support
 * for __proto__ and has a buggy typed array implementation.
 */ Buffer.TYPED_ARRAY_SUPPORT = typedArraySupport();
if (!Buffer.TYPED_ARRAY_SUPPORT && typeof console !== 'undefined' && typeof console.error === 'function') console.error("This browser lacks typed array (Uint8Array) support which is required by `buffer` v5.x. Use `buffer` v4.x if you require old browser support.");
function typedArraySupport() {
    // Can typed array instances can be augmented?
    try {
        var arr = new Uint8Array(1);
        var proto = {
            foo: function() {
                return 42;
            }
        };
        Object.setPrototypeOf(proto, Uint8Array.prototype);
        Object.setPrototypeOf(arr, proto);
        return arr.foo() === 42;
    } catch (e) {
        return false;
    }
}
Object.defineProperty(Buffer.prototype, 'parent', {
    enumerable: true,
    get: function() {
        if (!Buffer.isBuffer(this)) return undefined;
        return this.buffer;
    }
});
Object.defineProperty(Buffer.prototype, 'offset', {
    enumerable: true,
    get: function() {
        if (!Buffer.isBuffer(this)) return undefined;
        return this.byteOffset;
    }
});
function createBuffer(length) {
    if (length > K_MAX_LENGTH) throw new RangeError('The value "' + length + '" is invalid for option "size"');
    // Return an augmented `Uint8Array` instance
    var buf = new Uint8Array(length);
    Object.setPrototypeOf(buf, Buffer.prototype);
    return buf;
}
/**
 * The Buffer constructor returns instances of `Uint8Array` that have their
 * prototype changed to `Buffer.prototype`. Furthermore, `Buffer` is a subclass of
 * `Uint8Array`, so the returned instances will have all the node `Buffer` methods
 * and the `Uint8Array` methods. Square bracket notation works as expected -- it
 * returns a single octet.
 *
 * The `Uint8Array` prototype remains unmodified.
 */ function Buffer(arg, encodingOrOffset, length) {
    // Common case.
    if (typeof arg === 'number') {
        if (typeof encodingOrOffset === 'string') throw new TypeError('The "string" argument must be of type string. Received type number');
        return allocUnsafe(arg);
    }
    return from(arg, encodingOrOffset, length);
}
Buffer.poolSize = 8192; // not used by this implementation
function from(value, encodingOrOffset, length) {
    if (typeof value === 'string') return fromString(value, encodingOrOffset);
    if (ArrayBuffer.isView(value)) return fromArrayView(value);
    if (value == null) throw new TypeError("The first argument must be one of type string, Buffer, ArrayBuffer, Array, or Array-like Object. Received type " + typeof value);
    if (isInstance(value, ArrayBuffer) || value && isInstance(value.buffer, ArrayBuffer)) return fromArrayBuffer(value, encodingOrOffset, length);
    if (typeof SharedArrayBuffer !== 'undefined' && (isInstance(value, SharedArrayBuffer) || value && isInstance(value.buffer, SharedArrayBuffer))) return fromArrayBuffer(value, encodingOrOffset, length);
    if (typeof value === 'number') throw new TypeError('The "value" argument must not be of type number. Received type number');
    var valueOf = value.valueOf && value.valueOf();
    if (valueOf != null && valueOf !== value) return Buffer.from(valueOf, encodingOrOffset, length);
    var b = fromObject(value);
    if (b) return b;
    if (typeof Symbol !== 'undefined' && Symbol.toPrimitive != null && typeof value[Symbol.toPrimitive] === 'function') return Buffer.from(value[Symbol.toPrimitive]('string'), encodingOrOffset, length);
    throw new TypeError("The first argument must be one of type string, Buffer, ArrayBuffer, Array, or Array-like Object. Received type " + typeof value);
}
/**
 * Functionally equivalent to Buffer(arg, encoding) but throws a TypeError
 * if value is a number.
 * Buffer.from(str[, encoding])
 * Buffer.from(array)
 * Buffer.from(buffer)
 * Buffer.from(arrayBuffer[, byteOffset[, length]])
 **/ Buffer.from = function(value, encodingOrOffset, length) {
    return from(value, encodingOrOffset, length);
};
// Note: Change prototype *after* Buffer.from is defined to workaround Chrome bug:
// https://github.com/feross/buffer/pull/148
Object.setPrototypeOf(Buffer.prototype, Uint8Array.prototype);
Object.setPrototypeOf(Buffer, Uint8Array);
function assertSize(size) {
    if (typeof size !== 'number') throw new TypeError('"size" argument must be of type number');
    else if (size < 0) throw new RangeError('The value "' + size + '" is invalid for option "size"');
}
function alloc(size, fill, encoding) {
    assertSize(size);
    if (size <= 0) return createBuffer(size);
    if (fill !== undefined) // Only pay attention to encoding if it's a string. This
    // prevents accidentally sending in a number that would
    // be interpreted as a start offset.
    return typeof encoding === 'string' ? createBuffer(size).fill(fill, encoding) : createBuffer(size).fill(fill);
    return createBuffer(size);
}
/**
 * Creates a new filled Buffer instance.
 * alloc(size[, fill[, encoding]])
 **/ Buffer.alloc = function(size, fill, encoding) {
    return alloc(size, fill, encoding);
};
function allocUnsafe(size) {
    assertSize(size);
    return createBuffer(size < 0 ? 0 : checked(size) | 0);
}
/**
 * Equivalent to Buffer(num), by default creates a non-zero-filled Buffer instance.
 * */ Buffer.allocUnsafe = function(size) {
    return allocUnsafe(size);
};
/**
 * Equivalent to SlowBuffer(num), by default creates a non-zero-filled Buffer instance.
 */ Buffer.allocUnsafeSlow = function(size) {
    return allocUnsafe(size);
};
function fromString(string, encoding) {
    if (typeof encoding !== 'string' || encoding === '') encoding = 'utf8';
    if (!Buffer.isEncoding(encoding)) throw new TypeError('Unknown encoding: ' + encoding);
    var length = byteLength(string, encoding) | 0;
    var buf = createBuffer(length);
    var actual = buf.write(string, encoding);
    if (actual !== length) // Writing a hex string, for example, that contains invalid characters will
    // cause everything after the first invalid character to be ignored. (e.g.
    // 'abxxcd' will be treated as 'ab')
    buf = buf.slice(0, actual);
    return buf;
}
function fromArrayLike(array) {
    var length = array.length < 0 ? 0 : checked(array.length) | 0;
    var buf = createBuffer(length);
    for(var i = 0; i < length; i += 1)buf[i] = array[i] & 255;
    return buf;
}
function fromArrayView(arrayView) {
    if (isInstance(arrayView, Uint8Array)) {
        var copy = new Uint8Array(arrayView);
        return fromArrayBuffer(copy.buffer, copy.byteOffset, copy.byteLength);
    }
    return fromArrayLike(arrayView);
}
function fromArrayBuffer(array, byteOffset, length) {
    if (byteOffset < 0 || array.byteLength < byteOffset) throw new RangeError('"offset" is outside of buffer bounds');
    if (array.byteLength < byteOffset + (length || 0)) throw new RangeError('"length" is outside of buffer bounds');
    var buf;
    if (byteOffset === undefined && length === undefined) buf = new Uint8Array(array);
    else if (length === undefined) buf = new Uint8Array(array, byteOffset);
    else buf = new Uint8Array(array, byteOffset, length);
    // Return an augmented `Uint8Array` instance
    Object.setPrototypeOf(buf, Buffer.prototype);
    return buf;
}
function fromObject(obj) {
    if (Buffer.isBuffer(obj)) {
        var len = checked(obj.length) | 0;
        var buf = createBuffer(len);
        if (buf.length === 0) return buf;
        obj.copy(buf, 0, 0, len);
        return buf;
    }
    if (obj.length !== undefined) {
        if (typeof obj.length !== 'number' || numberIsNaN(obj.length)) return createBuffer(0);
        return fromArrayLike(obj);
    }
    if (obj.type === 'Buffer' && Array.isArray(obj.data)) return fromArrayLike(obj.data);
}
function checked(length) {
    // Note: cannot use `length < K_MAX_LENGTH` here because that fails when
    // length is NaN (which is otherwise coerced to zero.)
    if (length >= K_MAX_LENGTH) throw new RangeError("Attempt to allocate Buffer larger than maximum size: 0x" + K_MAX_LENGTH.toString(16) + ' bytes');
    return length | 0;
}
function SlowBuffer(length) {
    if (+length != length) length = 0;
    return Buffer.alloc(+length);
}
Buffer.isBuffer = function isBuffer(b) {
    return b != null && b._isBuffer === true && b !== Buffer.prototype // so Buffer.isBuffer(Buffer.prototype) will be false
    ;
};
Buffer.compare = function compare(a, b) {
    if (isInstance(a, Uint8Array)) a = Buffer.from(a, a.offset, a.byteLength);
    if (isInstance(b, Uint8Array)) b = Buffer.from(b, b.offset, b.byteLength);
    if (!Buffer.isBuffer(a) || !Buffer.isBuffer(b)) throw new TypeError('The "buf1", "buf2" arguments must be one of type Buffer or Uint8Array');
    if (a === b) return 0;
    var x = a.length;
    var y = b.length;
    for(var i = 0, len = Math.min(x, y); i < len; ++i)if (a[i] !== b[i]) {
        x = a[i];
        y = b[i];
        break;
    }
    if (x < y) return -1;
    if (y < x) return 1;
    return 0;
};
Buffer.isEncoding = function isEncoding(encoding) {
    switch(String(encoding).toLowerCase()){
        case 'hex':
        case 'utf8':
        case 'utf-8':
        case 'ascii':
        case 'latin1':
        case 'binary':
        case 'base64':
        case 'ucs2':
        case 'ucs-2':
        case 'utf16le':
        case 'utf-16le':
            return true;
        default:
            return false;
    }
};
Buffer.concat = function concat(list, length) {
    if (!Array.isArray(list)) throw new TypeError('"list" argument must be an Array of Buffers');
    if (list.length === 0) return Buffer.alloc(0);
    var i;
    if (length === undefined) {
        length = 0;
        for(i = 0; i < list.length; ++i)length += list[i].length;
    }
    var buffer = Buffer.allocUnsafe(length);
    var pos = 0;
    for(i = 0; i < list.length; ++i){
        var buf = list[i];
        if (isInstance(buf, Uint8Array)) {
            if (pos + buf.length > buffer.length) Buffer.from(buf).copy(buffer, pos);
            else Uint8Array.prototype.set.call(buffer, buf, pos);
        } else if (!Buffer.isBuffer(buf)) throw new TypeError('"list" argument must be an Array of Buffers');
        else buf.copy(buffer, pos);
        pos += buf.length;
    }
    return buffer;
};
function byteLength(string, encoding) {
    if (Buffer.isBuffer(string)) return string.length;
    if (ArrayBuffer.isView(string) || isInstance(string, ArrayBuffer)) return string.byteLength;
    if (typeof string !== 'string') throw new TypeError('The "string" argument must be one of type string, Buffer, or ArrayBuffer. Received type ' + typeof string);
    var len = string.length;
    var mustMatch = arguments.length > 2 && arguments[2] === true;
    if (!mustMatch && len === 0) return 0;
    // Use a for loop to avoid recursion
    var loweredCase = false;
    for(;;)switch(encoding){
        case 'ascii':
        case 'latin1':
        case 'binary':
            return len;
        case 'utf8':
        case 'utf-8':
            return utf8ToBytes(string).length;
        case 'ucs2':
        case 'ucs-2':
        case 'utf16le':
        case 'utf-16le':
            return len * 2;
        case 'hex':
            return len >>> 1;
        case 'base64':
            return base64ToBytes(string).length;
        default:
            if (loweredCase) return mustMatch ? -1 : utf8ToBytes(string).length // assume utf8
            ;
            encoding = ('' + encoding).toLowerCase();
            loweredCase = true;
    }
}
Buffer.byteLength = byteLength;
function slowToString(encoding, start, end) {
    var loweredCase = false;
    // No need to verify that "this.length <= MAX_UINT32" since it's a read-only
    // property of a typed array.
    // This behaves neither like String nor Uint8Array in that we set start/end
    // to their upper/lower bounds if the value passed is out of range.
    // undefined is handled specially as per ECMA-262 6th Edition,
    // Section 13.3.3.7 Runtime Semantics: KeyedBindingInitialization.
    if (start === undefined || start < 0) start = 0;
    // Return early if start > this.length. Done here to prevent potential uint32
    // coercion fail below.
    if (start > this.length) return '';
    if (end === undefined || end > this.length) end = this.length;
    if (end <= 0) return '';
    // Force coercion to uint32. This will also coerce falsey/NaN values to 0.
    end >>>= 0;
    start >>>= 0;
    if (end <= start) return '';
    if (!encoding) encoding = 'utf8';
    while(true)switch(encoding){
        case 'hex':
            return hexSlice(this, start, end);
        case 'utf8':
        case 'utf-8':
            return utf8Slice(this, start, end);
        case 'ascii':
            return asciiSlice(this, start, end);
        case 'latin1':
        case 'binary':
            return latin1Slice(this, start, end);
        case 'base64':
            return base64Slice(this, start, end);
        case 'ucs2':
        case 'ucs-2':
        case 'utf16le':
        case 'utf-16le':
            return utf16leSlice(this, start, end);
        default:
            if (loweredCase) throw new TypeError('Unknown encoding: ' + encoding);
            encoding = (encoding + '').toLowerCase();
            loweredCase = true;
    }
}
// This property is used by `Buffer.isBuffer` (and the `is-buffer` npm package)
// to detect a Buffer instance. It's not possible to use `instanceof Buffer`
// reliably in a browserify context because there could be multiple different
// copies of the 'buffer' package in use. This method works even for Buffer
// instances that were created from another copy of the `buffer` package.
// See: https://github.com/feross/buffer/issues/154
Buffer.prototype._isBuffer = true;
function swap(b, n, m) {
    var i = b[n];
    b[n] = b[m];
    b[m] = i;
}
Buffer.prototype.swap16 = function swap16() {
    var len = this.length;
    if (len % 2 !== 0) throw new RangeError('Buffer size must be a multiple of 16-bits');
    for(var i = 0; i < len; i += 2)swap(this, i, i + 1);
    return this;
};
Buffer.prototype.swap32 = function swap32() {
    var len = this.length;
    if (len % 4 !== 0) throw new RangeError('Buffer size must be a multiple of 32-bits');
    for(var i = 0; i < len; i += 4){
        swap(this, i, i + 3);
        swap(this, i + 1, i + 2);
    }
    return this;
};
Buffer.prototype.swap64 = function swap64() {
    var len = this.length;
    if (len % 8 !== 0) throw new RangeError('Buffer size must be a multiple of 64-bits');
    for(var i = 0; i < len; i += 8){
        swap(this, i, i + 7);
        swap(this, i + 1, i + 6);
        swap(this, i + 2, i + 5);
        swap(this, i + 3, i + 4);
    }
    return this;
};
Buffer.prototype.toString = function toString() {
    var length = this.length;
    if (length === 0) return '';
    if (arguments.length === 0) return utf8Slice(this, 0, length);
    return slowToString.apply(this, arguments);
};
Buffer.prototype.toLocaleString = Buffer.prototype.toString;
Buffer.prototype.equals = function equals(b) {
    if (!Buffer.isBuffer(b)) throw new TypeError('Argument must be a Buffer');
    if (this === b) return true;
    return Buffer.compare(this, b) === 0;
};
Buffer.prototype.inspect = function inspect() {
    var str = '';
    var max = exports.INSPECT_MAX_BYTES;
    str = this.toString('hex', 0, max).replace(/(.{2})/g, '$1 ').trim();
    if (this.length > max) str += ' ... ';
    return '<Buffer ' + str + '>';
};
if (customInspectSymbol) Buffer.prototype[customInspectSymbol] = Buffer.prototype.inspect;
Buffer.prototype.compare = function compare(target, start, end, thisStart, thisEnd) {
    if (isInstance(target, Uint8Array)) target = Buffer.from(target, target.offset, target.byteLength);
    if (!Buffer.isBuffer(target)) throw new TypeError('The "target" argument must be one of type Buffer or Uint8Array. Received type ' + typeof target);
    if (start === undefined) start = 0;
    if (end === undefined) end = target ? target.length : 0;
    if (thisStart === undefined) thisStart = 0;
    if (thisEnd === undefined) thisEnd = this.length;
    if (start < 0 || end > target.length || thisStart < 0 || thisEnd > this.length) throw new RangeError('out of range index');
    if (thisStart >= thisEnd && start >= end) return 0;
    if (thisStart >= thisEnd) return -1;
    if (start >= end) return 1;
    start >>>= 0;
    end >>>= 0;
    thisStart >>>= 0;
    thisEnd >>>= 0;
    if (this === target) return 0;
    var x = thisEnd - thisStart;
    var y = end - start;
    var len = Math.min(x, y);
    var thisCopy = this.slice(thisStart, thisEnd);
    var targetCopy = target.slice(start, end);
    for(var i = 0; i < len; ++i)if (thisCopy[i] !== targetCopy[i]) {
        x = thisCopy[i];
        y = targetCopy[i];
        break;
    }
    if (x < y) return -1;
    if (y < x) return 1;
    return 0;
};
// Finds either the first index of `val` in `buffer` at offset >= `byteOffset`,
// OR the last index of `val` in `buffer` at offset <= `byteOffset`.
//
// Arguments:
// - buffer - a Buffer to search
// - val - a string, Buffer, or number
// - byteOffset - an index into `buffer`; will be clamped to an int32
// - encoding - an optional encoding, relevant is val is a string
// - dir - true for indexOf, false for lastIndexOf
function bidirectionalIndexOf(buffer, val, byteOffset, encoding, dir) {
    // Empty buffer means no match
    if (buffer.length === 0) return -1;
    // Normalize byteOffset
    if (typeof byteOffset === 'string') {
        encoding = byteOffset;
        byteOffset = 0;
    } else if (byteOffset > 0x7fffffff) byteOffset = 0x7fffffff;
    else if (byteOffset < -2147483648) byteOffset = -2147483648;
    byteOffset = +byteOffset; // Coerce to Number.
    if (numberIsNaN(byteOffset)) // byteOffset: it it's undefined, null, NaN, "foo", etc, search whole buffer
    byteOffset = dir ? 0 : buffer.length - 1;
    // Normalize byteOffset: negative offsets start from the end of the buffer
    if (byteOffset < 0) byteOffset = buffer.length + byteOffset;
    if (byteOffset >= buffer.length) {
        if (dir) return -1;
        else byteOffset = buffer.length - 1;
    } else if (byteOffset < 0) {
        if (dir) byteOffset = 0;
        else return -1;
    }
    // Normalize val
    if (typeof val === 'string') val = Buffer.from(val, encoding);
    // Finally, search either indexOf (if dir is true) or lastIndexOf
    if (Buffer.isBuffer(val)) {
        // Special case: looking for empty string/buffer always fails
        if (val.length === 0) return -1;
        return arrayIndexOf(buffer, val, byteOffset, encoding, dir);
    } else if (typeof val === 'number') {
        val = val & 0xFF; // Search for a byte value [0-255]
        if (typeof Uint8Array.prototype.indexOf === 'function') {
            if (dir) return Uint8Array.prototype.indexOf.call(buffer, val, byteOffset);
            else return Uint8Array.prototype.lastIndexOf.call(buffer, val, byteOffset);
        }
        return arrayIndexOf(buffer, [
            val
        ], byteOffset, encoding, dir);
    }
    throw new TypeError('val must be string, number or Buffer');
}
function arrayIndexOf(arr, val, byteOffset, encoding, dir) {
    var indexSize = 1;
    var arrLength = arr.length;
    var valLength = val.length;
    if (encoding !== undefined) {
        encoding = String(encoding).toLowerCase();
        if (encoding === 'ucs2' || encoding === 'ucs-2' || encoding === 'utf16le' || encoding === 'utf-16le') {
            if (arr.length < 2 || val.length < 2) return -1;
            indexSize = 2;
            arrLength /= 2;
            valLength /= 2;
            byteOffset /= 2;
        }
    }
    function read(buf, i) {
        if (indexSize === 1) return buf[i];
        else return buf.readUInt16BE(i * indexSize);
    }
    var i;
    if (dir) {
        var foundIndex = -1;
        for(i = byteOffset; i < arrLength; i++)if (read(arr, i) === read(val, foundIndex === -1 ? 0 : i - foundIndex)) {
            if (foundIndex === -1) foundIndex = i;
            if (i - foundIndex + 1 === valLength) return foundIndex * indexSize;
        } else {
            if (foundIndex !== -1) i -= i - foundIndex;
            foundIndex = -1;
        }
    } else {
        if (byteOffset + valLength > arrLength) byteOffset = arrLength - valLength;
        for(i = byteOffset; i >= 0; i--){
            var found = true;
            for(var j = 0; j < valLength; j++)if (read(arr, i + j) !== read(val, j)) {
                found = false;
                break;
            }
            if (found) return i;
        }
    }
    return -1;
}
Buffer.prototype.includes = function includes(val, byteOffset, encoding) {
    return this.indexOf(val, byteOffset, encoding) !== -1;
};
Buffer.prototype.indexOf = function indexOf(val, byteOffset, encoding) {
    return bidirectionalIndexOf(this, val, byteOffset, encoding, true);
};
Buffer.prototype.lastIndexOf = function lastIndexOf(val, byteOffset, encoding) {
    return bidirectionalIndexOf(this, val, byteOffset, encoding, false);
};
function hexWrite(buf, string, offset, length) {
    offset = Number(offset) || 0;
    var remaining = buf.length - offset;
    if (!length) length = remaining;
    else {
        length = Number(length);
        if (length > remaining) length = remaining;
    }
    var strLen = string.length;
    if (length > strLen / 2) length = strLen / 2;
    for(var i = 0; i < length; ++i){
        var parsed = parseInt(string.substr(i * 2, 2), 16);
        if (numberIsNaN(parsed)) return i;
        buf[offset + i] = parsed;
    }
    return i;
}
function utf8Write(buf, string, offset, length) {
    return blitBuffer(utf8ToBytes(string, buf.length - offset), buf, offset, length);
}
function asciiWrite(buf, string, offset, length) {
    return blitBuffer(asciiToBytes(string), buf, offset, length);
}
function base64Write(buf, string, offset, length) {
    return blitBuffer(base64ToBytes(string), buf, offset, length);
}
function ucs2Write(buf, string, offset, length) {
    return blitBuffer(utf16leToBytes(string, buf.length - offset), buf, offset, length);
}
Buffer.prototype.write = function write(string, offset, length, encoding) {
    // Buffer#write(string)
    if (offset === undefined) {
        encoding = 'utf8';
        length = this.length;
        offset = 0;
    // Buffer#write(string, encoding)
    } else if (length === undefined && typeof offset === 'string') {
        encoding = offset;
        length = this.length;
        offset = 0;
    // Buffer#write(string, offset[, length][, encoding])
    } else if (isFinite(offset)) {
        offset = offset >>> 0;
        if (isFinite(length)) {
            length = length >>> 0;
            if (encoding === undefined) encoding = 'utf8';
        } else {
            encoding = length;
            length = undefined;
        }
    } else throw new Error('Buffer.write(string, encoding, offset[, length]) is no longer supported');
    var remaining = this.length - offset;
    if (length === undefined || length > remaining) length = remaining;
    if (string.length > 0 && (length < 0 || offset < 0) || offset > this.length) throw new RangeError('Attempt to write outside buffer bounds');
    if (!encoding) encoding = 'utf8';
    var loweredCase = false;
    for(;;)switch(encoding){
        case 'hex':
            return hexWrite(this, string, offset, length);
        case 'utf8':
        case 'utf-8':
            return utf8Write(this, string, offset, length);
        case 'ascii':
        case 'latin1':
        case 'binary':
            return asciiWrite(this, string, offset, length);
        case 'base64':
            // Warning: maxLength not taken into account in base64Write
            return base64Write(this, string, offset, length);
        case 'ucs2':
        case 'ucs-2':
        case 'utf16le':
        case 'utf-16le':
            return ucs2Write(this, string, offset, length);
        default:
            if (loweredCase) throw new TypeError('Unknown encoding: ' + encoding);
            encoding = ('' + encoding).toLowerCase();
            loweredCase = true;
    }
};
Buffer.prototype.toJSON = function toJSON() {
    return {
        type: 'Buffer',
        data: Array.prototype.slice.call(this._arr || this, 0)
    };
};
function base64Slice(buf, start, end) {
    if (start === 0 && end === buf.length) return base64.fromByteArray(buf);
    else return base64.fromByteArray(buf.slice(start, end));
}
function utf8Slice(buf, start, end) {
    end = Math.min(buf.length, end);
    var res = [];
    var i = start;
    while(i < end){
        var firstByte = buf[i];
        var codePoint = null;
        var bytesPerSequence = firstByte > 0xEF ? 4 : firstByte > 0xDF ? 3 : firstByte > 0xBF ? 2 : 1;
        if (i + bytesPerSequence <= end) {
            var secondByte, thirdByte, fourthByte, tempCodePoint;
            switch(bytesPerSequence){
                case 1:
                    if (firstByte < 0x80) codePoint = firstByte;
                    break;
                case 2:
                    secondByte = buf[i + 1];
                    if ((secondByte & 0xC0) === 0x80) {
                        tempCodePoint = (firstByte & 0x1F) << 0x6 | secondByte & 0x3F;
                        if (tempCodePoint > 0x7F) codePoint = tempCodePoint;
                    }
                    break;
                case 3:
                    secondByte = buf[i + 1];
                    thirdByte = buf[i + 2];
                    if ((secondByte & 0xC0) === 0x80 && (thirdByte & 0xC0) === 0x80) {
                        tempCodePoint = (firstByte & 0xF) << 0xC | (secondByte & 0x3F) << 0x6 | thirdByte & 0x3F;
                        if (tempCodePoint > 0x7FF && (tempCodePoint < 0xD800 || tempCodePoint > 0xDFFF)) codePoint = tempCodePoint;
                    }
                    break;
                case 4:
                    secondByte = buf[i + 1];
                    thirdByte = buf[i + 2];
                    fourthByte = buf[i + 3];
                    if ((secondByte & 0xC0) === 0x80 && (thirdByte & 0xC0) === 0x80 && (fourthByte & 0xC0) === 0x80) {
                        tempCodePoint = (firstByte & 0xF) << 0x12 | (secondByte & 0x3F) << 0xC | (thirdByte & 0x3F) << 0x6 | fourthByte & 0x3F;
                        if (tempCodePoint > 0xFFFF && tempCodePoint < 0x110000) codePoint = tempCodePoint;
                    }
            }
        }
        if (codePoint === null) {
            // we did not generate a valid codePoint so insert a
            // replacement char (U+FFFD) and advance only 1 byte
            codePoint = 0xFFFD;
            bytesPerSequence = 1;
        } else if (codePoint > 0xFFFF) {
            // encode to utf16 (surrogate pair dance)
            codePoint -= 0x10000;
            res.push(codePoint >>> 10 & 0x3FF | 0xD800);
            codePoint = 0xDC00 | codePoint & 0x3FF;
        }
        res.push(codePoint);
        i += bytesPerSequence;
    }
    return decodeCodePointsArray(res);
}
// Based on http://stackoverflow.com/a/22747272/680742, the browser with
// the lowest limit is Chrome, with 0x10000 args.
// We go 1 magnitude less, for safety
var MAX_ARGUMENTS_LENGTH = 0x1000;
function decodeCodePointsArray(codePoints) {
    var len = codePoints.length;
    if (len <= MAX_ARGUMENTS_LENGTH) return String.fromCharCode.apply(String, codePoints) // avoid extra slice()
    ;
    // Decode in chunks to avoid "call stack size exceeded".
    var res = '';
    var i = 0;
    while(i < len)res += String.fromCharCode.apply(String, codePoints.slice(i, i += MAX_ARGUMENTS_LENGTH));
    return res;
}
function asciiSlice(buf, start, end) {
    var ret = '';
    end = Math.min(buf.length, end);
    for(var i = start; i < end; ++i)ret += String.fromCharCode(buf[i] & 0x7F);
    return ret;
}
function latin1Slice(buf, start, end) {
    var ret = '';
    end = Math.min(buf.length, end);
    for(var i = start; i < end; ++i)ret += String.fromCharCode(buf[i]);
    return ret;
}
function hexSlice(buf, start, end) {
    var len = buf.length;
    if (!start || start < 0) start = 0;
    if (!end || end < 0 || end > len) end = len;
    var out = '';
    for(var i = start; i < end; ++i)out += hexSliceLookupTable[buf[i]];
    return out;
}
function utf16leSlice(buf, start, end) {
    var bytes = buf.slice(start, end);
    var res = '';
    // If bytes.length is odd, the last 8 bits must be ignored (same as node.js)
    for(var i = 0; i < bytes.length - 1; i += 2)res += String.fromCharCode(bytes[i] + bytes[i + 1] * 256);
    return res;
}
Buffer.prototype.slice = function slice(start, end) {
    var len = this.length;
    start = ~~start;
    end = end === undefined ? len : ~~end;
    if (start < 0) {
        start += len;
        if (start < 0) start = 0;
    } else if (start > len) start = len;
    if (end < 0) {
        end += len;
        if (end < 0) end = 0;
    } else if (end > len) end = len;
    if (end < start) end = start;
    var newBuf = this.subarray(start, end);
    // Return an augmented `Uint8Array` instance
    Object.setPrototypeOf(newBuf, Buffer.prototype);
    return newBuf;
};
/*
 * Need to make sure that buffer isn't trying to write out of bounds.
 */ function checkOffset(offset, ext, length) {
    if (offset % 1 !== 0 || offset < 0) throw new RangeError('offset is not uint');
    if (offset + ext > length) throw new RangeError('Trying to access beyond buffer length');
}
Buffer.prototype.readUintLE = Buffer.prototype.readUIntLE = function readUIntLE(offset, byteLength, noAssert) {
    offset = offset >>> 0;
    byteLength = byteLength >>> 0;
    if (!noAssert) checkOffset(offset, byteLength, this.length);
    var val = this[offset];
    var mul = 1;
    var i = 0;
    while(++i < byteLength && (mul *= 0x100))val += this[offset + i] * mul;
    return val;
};
Buffer.prototype.readUintBE = Buffer.prototype.readUIntBE = function readUIntBE(offset, byteLength, noAssert) {
    offset = offset >>> 0;
    byteLength = byteLength >>> 0;
    if (!noAssert) checkOffset(offset, byteLength, this.length);
    var val = this[offset + --byteLength];
    var mul = 1;
    while(byteLength > 0 && (mul *= 0x100))val += this[offset + --byteLength] * mul;
    return val;
};
Buffer.prototype.readUint8 = Buffer.prototype.readUInt8 = function readUInt8(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) checkOffset(offset, 1, this.length);
    return this[offset];
};
Buffer.prototype.readUint16LE = Buffer.prototype.readUInt16LE = function readUInt16LE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) checkOffset(offset, 2, this.length);
    return this[offset] | this[offset + 1] << 8;
};
Buffer.prototype.readUint16BE = Buffer.prototype.readUInt16BE = function readUInt16BE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) checkOffset(offset, 2, this.length);
    return this[offset] << 8 | this[offset + 1];
};
Buffer.prototype.readUint32LE = Buffer.prototype.readUInt32LE = function readUInt32LE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) checkOffset(offset, 4, this.length);
    return (this[offset] | this[offset + 1] << 8 | this[offset + 2] << 16) + this[offset + 3] * 0x1000000;
};
Buffer.prototype.readUint32BE = Buffer.prototype.readUInt32BE = function readUInt32BE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) checkOffset(offset, 4, this.length);
    return this[offset] * 0x1000000 + (this[offset + 1] << 16 | this[offset + 2] << 8 | this[offset + 3]);
};
Buffer.prototype.readIntLE = function readIntLE(offset, byteLength, noAssert) {
    offset = offset >>> 0;
    byteLength = byteLength >>> 0;
    if (!noAssert) checkOffset(offset, byteLength, this.length);
    var val = this[offset];
    var mul = 1;
    var i = 0;
    while(++i < byteLength && (mul *= 0x100))val += this[offset + i] * mul;
    mul *= 0x80;
    if (val >= mul) val -= Math.pow(2, 8 * byteLength);
    return val;
};
Buffer.prototype.readIntBE = function readIntBE(offset, byteLength, noAssert) {
    offset = offset >>> 0;
    byteLength = byteLength >>> 0;
    if (!noAssert) checkOffset(offset, byteLength, this.length);
    var i = byteLength;
    var mul = 1;
    var val = this[offset + --i];
    while(i > 0 && (mul *= 0x100))val += this[offset + --i] * mul;
    mul *= 0x80;
    if (val >= mul) val -= Math.pow(2, 8 * byteLength);
    return val;
};
Buffer.prototype.readInt8 = function readInt8(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) checkOffset(offset, 1, this.length);
    if (!(this[offset] & 0x80)) return this[offset];
    return (0xff - this[offset] + 1) * -1;
};
Buffer.prototype.readInt16LE = function readInt16LE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) checkOffset(offset, 2, this.length);
    var val = this[offset] | this[offset + 1] << 8;
    return val & 0x8000 ? val | 0xFFFF0000 : val;
};
Buffer.prototype.readInt16BE = function readInt16BE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) checkOffset(offset, 2, this.length);
    var val = this[offset + 1] | this[offset] << 8;
    return val & 0x8000 ? val | 0xFFFF0000 : val;
};
Buffer.prototype.readInt32LE = function readInt32LE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) checkOffset(offset, 4, this.length);
    return this[offset] | this[offset + 1] << 8 | this[offset + 2] << 16 | this[offset + 3] << 24;
};
Buffer.prototype.readInt32BE = function readInt32BE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) checkOffset(offset, 4, this.length);
    return this[offset] << 24 | this[offset + 1] << 16 | this[offset + 2] << 8 | this[offset + 3];
};
Buffer.prototype.readFloatLE = function readFloatLE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) checkOffset(offset, 4, this.length);
    return ieee754.read(this, offset, true, 23, 4);
};
Buffer.prototype.readFloatBE = function readFloatBE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) checkOffset(offset, 4, this.length);
    return ieee754.read(this, offset, false, 23, 4);
};
Buffer.prototype.readDoubleLE = function readDoubleLE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) checkOffset(offset, 8, this.length);
    return ieee754.read(this, offset, true, 52, 8);
};
Buffer.prototype.readDoubleBE = function readDoubleBE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) checkOffset(offset, 8, this.length);
    return ieee754.read(this, offset, false, 52, 8);
};
function checkInt(buf, value, offset, ext, max, min) {
    if (!Buffer.isBuffer(buf)) throw new TypeError('"buffer" argument must be a Buffer instance');
    if (value > max || value < min) throw new RangeError('"value" argument is out of bounds');
    if (offset + ext > buf.length) throw new RangeError('Index out of range');
}
Buffer.prototype.writeUintLE = Buffer.prototype.writeUIntLE = function writeUIntLE(value, offset, byteLength, noAssert) {
    value = +value;
    offset = offset >>> 0;
    byteLength = byteLength >>> 0;
    if (!noAssert) {
        var maxBytes = Math.pow(2, 8 * byteLength) - 1;
        checkInt(this, value, offset, byteLength, maxBytes, 0);
    }
    var mul = 1;
    var i = 0;
    this[offset] = value & 0xFF;
    while(++i < byteLength && (mul *= 0x100))this[offset + i] = value / mul & 0xFF;
    return offset + byteLength;
};
Buffer.prototype.writeUintBE = Buffer.prototype.writeUIntBE = function writeUIntBE(value, offset, byteLength, noAssert) {
    value = +value;
    offset = offset >>> 0;
    byteLength = byteLength >>> 0;
    if (!noAssert) {
        var maxBytes = Math.pow(2, 8 * byteLength) - 1;
        checkInt(this, value, offset, byteLength, maxBytes, 0);
    }
    var i = byteLength - 1;
    var mul = 1;
    this[offset + i] = value & 0xFF;
    while(--i >= 0 && (mul *= 0x100))this[offset + i] = value / mul & 0xFF;
    return offset + byteLength;
};
Buffer.prototype.writeUint8 = Buffer.prototype.writeUInt8 = function writeUInt8(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) checkInt(this, value, offset, 1, 0xff, 0);
    this[offset] = value & 0xff;
    return offset + 1;
};
Buffer.prototype.writeUint16LE = Buffer.prototype.writeUInt16LE = function writeUInt16LE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) checkInt(this, value, offset, 2, 0xffff, 0);
    this[offset] = value & 0xff;
    this[offset + 1] = value >>> 8;
    return offset + 2;
};
Buffer.prototype.writeUint16BE = Buffer.prototype.writeUInt16BE = function writeUInt16BE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) checkInt(this, value, offset, 2, 0xffff, 0);
    this[offset] = value >>> 8;
    this[offset + 1] = value & 0xff;
    return offset + 2;
};
Buffer.prototype.writeUint32LE = Buffer.prototype.writeUInt32LE = function writeUInt32LE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) checkInt(this, value, offset, 4, 0xffffffff, 0);
    this[offset + 3] = value >>> 24;
    this[offset + 2] = value >>> 16;
    this[offset + 1] = value >>> 8;
    this[offset] = value & 0xff;
    return offset + 4;
};
Buffer.prototype.writeUint32BE = Buffer.prototype.writeUInt32BE = function writeUInt32BE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) checkInt(this, value, offset, 4, 0xffffffff, 0);
    this[offset] = value >>> 24;
    this[offset + 1] = value >>> 16;
    this[offset + 2] = value >>> 8;
    this[offset + 3] = value & 0xff;
    return offset + 4;
};
Buffer.prototype.writeIntLE = function writeIntLE(value, offset, byteLength, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) {
        var limit = Math.pow(2, 8 * byteLength - 1);
        checkInt(this, value, offset, byteLength, limit - 1, -limit);
    }
    var i = 0;
    var mul = 1;
    var sub = 0;
    this[offset] = value & 0xFF;
    while(++i < byteLength && (mul *= 0x100)){
        if (value < 0 && sub === 0 && this[offset + i - 1] !== 0) sub = 1;
        this[offset + i] = (value / mul >> 0) - sub & 0xFF;
    }
    return offset + byteLength;
};
Buffer.prototype.writeIntBE = function writeIntBE(value, offset, byteLength, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) {
        var limit = Math.pow(2, 8 * byteLength - 1);
        checkInt(this, value, offset, byteLength, limit - 1, -limit);
    }
    var i = byteLength - 1;
    var mul = 1;
    var sub = 0;
    this[offset + i] = value & 0xFF;
    while(--i >= 0 && (mul *= 0x100)){
        if (value < 0 && sub === 0 && this[offset + i + 1] !== 0) sub = 1;
        this[offset + i] = (value / mul >> 0) - sub & 0xFF;
    }
    return offset + byteLength;
};
Buffer.prototype.writeInt8 = function writeInt8(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) checkInt(this, value, offset, 1, 0x7f, -128);
    if (value < 0) value = 0xff + value + 1;
    this[offset] = value & 0xff;
    return offset + 1;
};
Buffer.prototype.writeInt16LE = function writeInt16LE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) checkInt(this, value, offset, 2, 0x7fff, -32768);
    this[offset] = value & 0xff;
    this[offset + 1] = value >>> 8;
    return offset + 2;
};
Buffer.prototype.writeInt16BE = function writeInt16BE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) checkInt(this, value, offset, 2, 0x7fff, -32768);
    this[offset] = value >>> 8;
    this[offset + 1] = value & 0xff;
    return offset + 2;
};
Buffer.prototype.writeInt32LE = function writeInt32LE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) checkInt(this, value, offset, 4, 0x7fffffff, -2147483648);
    this[offset] = value & 0xff;
    this[offset + 1] = value >>> 8;
    this[offset + 2] = value >>> 16;
    this[offset + 3] = value >>> 24;
    return offset + 4;
};
Buffer.prototype.writeInt32BE = function writeInt32BE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) checkInt(this, value, offset, 4, 0x7fffffff, -2147483648);
    if (value < 0) value = 0xffffffff + value + 1;
    this[offset] = value >>> 24;
    this[offset + 1] = value >>> 16;
    this[offset + 2] = value >>> 8;
    this[offset + 3] = value & 0xff;
    return offset + 4;
};
function checkIEEE754(buf, value, offset, ext, max, min) {
    if (offset + ext > buf.length) throw new RangeError('Index out of range');
    if (offset < 0) throw new RangeError('Index out of range');
}
function writeFloat(buf, value, offset, littleEndian, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) checkIEEE754(buf, value, offset, 4, 3.4028234663852886e+38, -3.4028234663852886e+38);
    ieee754.write(buf, value, offset, littleEndian, 23, 4);
    return offset + 4;
}
Buffer.prototype.writeFloatLE = function writeFloatLE(value, offset, noAssert) {
    return writeFloat(this, value, offset, true, noAssert);
};
Buffer.prototype.writeFloatBE = function writeFloatBE(value, offset, noAssert) {
    return writeFloat(this, value, offset, false, noAssert);
};
function writeDouble(buf, value, offset, littleEndian, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) checkIEEE754(buf, value, offset, 8, 1.7976931348623157E+308, -1.7976931348623157e+308);
    ieee754.write(buf, value, offset, littleEndian, 52, 8);
    return offset + 8;
}
Buffer.prototype.writeDoubleLE = function writeDoubleLE(value, offset, noAssert) {
    return writeDouble(this, value, offset, true, noAssert);
};
Buffer.prototype.writeDoubleBE = function writeDoubleBE(value, offset, noAssert) {
    return writeDouble(this, value, offset, false, noAssert);
};
// copy(targetBuffer, targetStart=0, sourceStart=0, sourceEnd=buffer.length)
Buffer.prototype.copy = function copy(target, targetStart, start, end) {
    if (!Buffer.isBuffer(target)) throw new TypeError('argument should be a Buffer');
    if (!start) start = 0;
    if (!end && end !== 0) end = this.length;
    if (targetStart >= target.length) targetStart = target.length;
    if (!targetStart) targetStart = 0;
    if (end > 0 && end < start) end = start;
    // Copy 0 bytes; we're done
    if (end === start) return 0;
    if (target.length === 0 || this.length === 0) return 0;
    // Fatal error conditions
    if (targetStart < 0) throw new RangeError('targetStart out of bounds');
    if (start < 0 || start >= this.length) throw new RangeError('Index out of range');
    if (end < 0) throw new RangeError('sourceEnd out of bounds');
    // Are we oob?
    if (end > this.length) end = this.length;
    if (target.length - targetStart < end - start) end = target.length - targetStart + start;
    var len = end - start;
    if (this === target && typeof Uint8Array.prototype.copyWithin === 'function') // Use built-in when available, missing from IE11
    this.copyWithin(targetStart, start, end);
    else Uint8Array.prototype.set.call(target, this.subarray(start, end), targetStart);
    return len;
};
// Usage:
//    buffer.fill(number[, offset[, end]])
//    buffer.fill(buffer[, offset[, end]])
//    buffer.fill(string[, offset[, end]][, encoding])
Buffer.prototype.fill = function fill(val, start, end, encoding) {
    // Handle string cases:
    if (typeof val === 'string') {
        if (typeof start === 'string') {
            encoding = start;
            start = 0;
            end = this.length;
        } else if (typeof end === 'string') {
            encoding = end;
            end = this.length;
        }
        if (encoding !== undefined && typeof encoding !== 'string') throw new TypeError('encoding must be a string');
        if (typeof encoding === 'string' && !Buffer.isEncoding(encoding)) throw new TypeError('Unknown encoding: ' + encoding);
        if (val.length === 1) {
            var code = val.charCodeAt(0);
            if (encoding === 'utf8' && code < 128 || encoding === 'latin1') // Fast path: If `val` fits into a single byte, use that numeric value.
            val = code;
        }
    } else if (typeof val === 'number') val = val & 255;
    else if (typeof val === 'boolean') val = Number(val);
    // Invalid ranges are not set to a default, so can range check early.
    if (start < 0 || this.length < start || this.length < end) throw new RangeError('Out of range index');
    if (end <= start) return this;
    start = start >>> 0;
    end = end === undefined ? this.length : end >>> 0;
    if (!val) val = 0;
    var i;
    if (typeof val === 'number') for(i = start; i < end; ++i)this[i] = val;
    else {
        var bytes = Buffer.isBuffer(val) ? val : Buffer.from(val, encoding);
        var len = bytes.length;
        if (len === 0) throw new TypeError('The value "' + val + '" is invalid for argument "value"');
        for(i = 0; i < end - start; ++i)this[i + start] = bytes[i % len];
    }
    return this;
};
// HELPER FUNCTIONS
// ================
var INVALID_BASE64_RE = /[^+/0-9A-Za-z-_]/g;
function base64clean(str) {
    // Node takes equal signs as end of the Base64 encoding
    str = str.split('=')[0];
    // Node strips out invalid characters like \n and \t from the string, base64-js does not
    str = str.trim().replace(INVALID_BASE64_RE, '');
    // Node converts strings with length < 2 to ''
    if (str.length < 2) return '';
    // Node allows for non-padded base64 strings (missing trailing ===), base64-js does not
    while(str.length % 4 !== 0)str = str + '=';
    return str;
}
function utf8ToBytes(string, units) {
    units = units || Infinity;
    var codePoint;
    var length = string.length;
    var leadSurrogate = null;
    var bytes = [];
    for(var i = 0; i < length; ++i){
        codePoint = string.charCodeAt(i);
        // is surrogate component
        if (codePoint > 0xD7FF && codePoint < 0xE000) {
            // last char was a lead
            if (!leadSurrogate) {
                // no lead yet
                if (codePoint > 0xDBFF) {
                    // unexpected trail
                    if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD);
                    continue;
                } else if (i + 1 === length) {
                    // unpaired lead
                    if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD);
                    continue;
                }
                // valid lead
                leadSurrogate = codePoint;
                continue;
            }
            // 2 leads in a row
            if (codePoint < 0xDC00) {
                if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD);
                leadSurrogate = codePoint;
                continue;
            }
            // valid surrogate pair
            codePoint = (leadSurrogate - 0xD800 << 10 | codePoint - 0xDC00) + 0x10000;
        } else if (leadSurrogate) // valid bmp char, but last char was a lead
        {
            if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD);
        }
        leadSurrogate = null;
        // encode utf8
        if (codePoint < 0x80) {
            if ((units -= 1) < 0) break;
            bytes.push(codePoint);
        } else if (codePoint < 0x800) {
            if ((units -= 2) < 0) break;
            bytes.push(codePoint >> 0x6 | 0xC0, codePoint & 0x3F | 0x80);
        } else if (codePoint < 0x10000) {
            if ((units -= 3) < 0) break;
            bytes.push(codePoint >> 0xC | 0xE0, codePoint >> 0x6 & 0x3F | 0x80, codePoint & 0x3F | 0x80);
        } else if (codePoint < 0x110000) {
            if ((units -= 4) < 0) break;
            bytes.push(codePoint >> 0x12 | 0xF0, codePoint >> 0xC & 0x3F | 0x80, codePoint >> 0x6 & 0x3F | 0x80, codePoint & 0x3F | 0x80);
        } else throw new Error('Invalid code point');
    }
    return bytes;
}
function asciiToBytes(str) {
    var byteArray = [];
    for(var i = 0; i < str.length; ++i)// Node's code seems to be doing this and not & 0x7F..
    byteArray.push(str.charCodeAt(i) & 0xFF);
    return byteArray;
}
function utf16leToBytes(str, units) {
    var c, hi, lo;
    var byteArray = [];
    for(var i = 0; i < str.length; ++i){
        if ((units -= 2) < 0) break;
        c = str.charCodeAt(i);
        hi = c >> 8;
        lo = c % 256;
        byteArray.push(lo);
        byteArray.push(hi);
    }
    return byteArray;
}
function base64ToBytes(str) {
    return base64.toByteArray(base64clean(str));
}
function blitBuffer(src, dst, offset, length) {
    for(var i = 0; i < length; ++i){
        if (i + offset >= dst.length || i >= src.length) break;
        dst[i + offset] = src[i];
    }
    return i;
}
// ArrayBuffer or Uint8Array objects from other contexts (i.e. iframes) do not pass
// the `instanceof` check but they should be treated as of that type.
// See: https://github.com/feross/buffer/issues/166
function isInstance(obj, type) {
    return obj instanceof type || obj != null && obj.constructor != null && obj.constructor.name != null && obj.constructor.name === type.name;
}
function numberIsNaN(obj) {
    // For IE11 support
    return obj !== obj // eslint-disable-line no-self-compare
    ;
}
// Create lookup table for `toString('hex')`
// See: https://github.com/feross/buffer/issues/219
var hexSliceLookupTable = function() {
    var alphabet = '0123456789abcdef';
    var table = new Array(256);
    for(var i = 0; i < 16; ++i){
        var i16 = i * 16;
        for(var j = 0; j < 16; ++j)table[i16 + j] = alphabet[i] + alphabet[j];
    }
    return table;
}();

},{"936d7d40ee51556e":"3s4Of","a9454e8447bbf491":"7UiJ8"}],"3s4Of":[function(require,module,exports,__globalThis) {
'use strict';
exports.byteLength = byteLength;
exports.toByteArray = toByteArray;
exports.fromByteArray = fromByteArray;
var lookup = [];
var revLookup = [];
var Arr = typeof Uint8Array !== 'undefined' ? Uint8Array : Array;
var code = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/';
for(var i = 0, len = code.length; i < len; ++i){
    lookup[i] = code[i];
    revLookup[code.charCodeAt(i)] = i;
}
// Support decoding URL-safe base64 strings, as Node.js does.
// See: https://en.wikipedia.org/wiki/Base64#URL_applications
revLookup['-'.charCodeAt(0)] = 62;
revLookup['_'.charCodeAt(0)] = 63;
function getLens(b64) {
    var len = b64.length;
    if (len % 4 > 0) throw new Error('Invalid string. Length must be a multiple of 4');
    // Trim off extra bytes after placeholder bytes are found
    // See: https://github.com/beatgammit/base64-js/issues/42
    var validLen = b64.indexOf('=');
    if (validLen === -1) validLen = len;
    var placeHoldersLen = validLen === len ? 0 : 4 - validLen % 4;
    return [
        validLen,
        placeHoldersLen
    ];
}
// base64 is 4/3 + up to two characters of the original data
function byteLength(b64) {
    var lens = getLens(b64);
    var validLen = lens[0];
    var placeHoldersLen = lens[1];
    return (validLen + placeHoldersLen) * 3 / 4 - placeHoldersLen;
}
function _byteLength(b64, validLen, placeHoldersLen) {
    return (validLen + placeHoldersLen) * 3 / 4 - placeHoldersLen;
}
function toByteArray(b64) {
    var tmp;
    var lens = getLens(b64);
    var validLen = lens[0];
    var placeHoldersLen = lens[1];
    var arr = new Arr(_byteLength(b64, validLen, placeHoldersLen));
    var curByte = 0;
    // if there are placeholders, only get up to the last complete 4 chars
    var len = placeHoldersLen > 0 ? validLen - 4 : validLen;
    var i;
    for(i = 0; i < len; i += 4){
        tmp = revLookup[b64.charCodeAt(i)] << 18 | revLookup[b64.charCodeAt(i + 1)] << 12 | revLookup[b64.charCodeAt(i + 2)] << 6 | revLookup[b64.charCodeAt(i + 3)];
        arr[curByte++] = tmp >> 16 & 0xFF;
        arr[curByte++] = tmp >> 8 & 0xFF;
        arr[curByte++] = tmp & 0xFF;
    }
    if (placeHoldersLen === 2) {
        tmp = revLookup[b64.charCodeAt(i)] << 2 | revLookup[b64.charCodeAt(i + 1)] >> 4;
        arr[curByte++] = tmp & 0xFF;
    }
    if (placeHoldersLen === 1) {
        tmp = revLookup[b64.charCodeAt(i)] << 10 | revLookup[b64.charCodeAt(i + 1)] << 4 | revLookup[b64.charCodeAt(i + 2)] >> 2;
        arr[curByte++] = tmp >> 8 & 0xFF;
        arr[curByte++] = tmp & 0xFF;
    }
    return arr;
}
function tripletToBase64(num) {
    return lookup[num >> 18 & 0x3F] + lookup[num >> 12 & 0x3F] + lookup[num >> 6 & 0x3F] + lookup[num & 0x3F];
}
function encodeChunk(uint8, start, end) {
    var tmp;
    var output = [];
    for(var i = start; i < end; i += 3){
        tmp = (uint8[i] << 16 & 0xFF0000) + (uint8[i + 1] << 8 & 0xFF00) + (uint8[i + 2] & 0xFF);
        output.push(tripletToBase64(tmp));
    }
    return output.join('');
}
function fromByteArray(uint8) {
    var tmp;
    var len = uint8.length;
    var extraBytes = len % 3 // if we have 1 byte left, pad 2 bytes
    ;
    var parts = [];
    var maxChunkLength = 16383 // must be multiple of 3
    ;
    // go through the array every three bytes, we'll deal with trailing stuff later
    for(var i = 0, len2 = len - extraBytes; i < len2; i += maxChunkLength)parts.push(encodeChunk(uint8, i, i + maxChunkLength > len2 ? len2 : i + maxChunkLength));
    // pad the end with zeros, but make sure to not forget the extra bytes
    if (extraBytes === 1) {
        tmp = uint8[len - 1];
        parts.push(lookup[tmp >> 2] + lookup[tmp << 4 & 0x3F] + '==');
    } else if (extraBytes === 2) {
        tmp = (uint8[len - 2] << 8) + uint8[len - 1];
        parts.push(lookup[tmp >> 10] + lookup[tmp >> 4 & 0x3F] + lookup[tmp << 2 & 0x3F] + '=');
    }
    return parts.join('');
}

},{}],"7UiJ8":[function(require,module,exports,__globalThis) {
/*! ieee754. BSD-3-Clause License. Feross Aboukhadijeh <https://feross.org/opensource> */ exports.read = function(buffer, offset, isLE, mLen, nBytes) {
    var e, m;
    var eLen = nBytes * 8 - mLen - 1;
    var eMax = (1 << eLen) - 1;
    var eBias = eMax >> 1;
    var nBits = -7;
    var i = isLE ? nBytes - 1 : 0;
    var d = isLE ? -1 : 1;
    var s = buffer[offset + i];
    i += d;
    e = s & (1 << -nBits) - 1;
    s >>= -nBits;
    nBits += eLen;
    for(; nBits > 0; e = e * 256 + buffer[offset + i], i += d, nBits -= 8);
    m = e & (1 << -nBits) - 1;
    e >>= -nBits;
    nBits += mLen;
    for(; nBits > 0; m = m * 256 + buffer[offset + i], i += d, nBits -= 8);
    if (e === 0) e = 1 - eBias;
    else if (e === eMax) return m ? NaN : (s ? -1 : 1) * Infinity;
    else {
        m = m + Math.pow(2, mLen);
        e = e - eBias;
    }
    return (s ? -1 : 1) * m * Math.pow(2, e - mLen);
};
exports.write = function(buffer, value, offset, isLE, mLen, nBytes) {
    var e, m, c;
    var eLen = nBytes * 8 - mLen - 1;
    var eMax = (1 << eLen) - 1;
    var eBias = eMax >> 1;
    var rt = mLen === 23 ? Math.pow(2, -24) - Math.pow(2, -77) : 0;
    var i = isLE ? 0 : nBytes - 1;
    var d = isLE ? 1 : -1;
    var s = value < 0 || value === 0 && 1 / value < 0 ? 1 : 0;
    value = Math.abs(value);
    if (isNaN(value) || value === Infinity) {
        m = isNaN(value) ? 1 : 0;
        e = eMax;
    } else {
        e = Math.floor(Math.log(value) / Math.LN2);
        if (value * (c = Math.pow(2, -e)) < 1) {
            e--;
            c *= 2;
        }
        if (e + eBias >= 1) value += rt / c;
        else value += rt * Math.pow(2, 1 - eBias);
        if (value * c >= 2) {
            e++;
            c /= 2;
        }
        if (e + eBias >= eMax) {
            m = 0;
            e = eMax;
        } else if (e + eBias >= 1) {
            m = (value * c - 1) * Math.pow(2, mLen);
            e = e + eBias;
        } else {
            m = value * Math.pow(2, eBias - 1) * Math.pow(2, mLen);
            e = 0;
        }
    }
    for(; mLen >= 8; buffer[offset + i] = m & 0xff, i += d, m /= 256, mLen -= 8);
    e = e << mLen | m;
    eLen += mLen;
    for(; eLen > 0; buffer[offset + i] = e & 0xff, i += d, e /= 256, eLen -= 8);
    buffer[offset + i - d] |= s * 128;
};

},{}],"01vhI":[function(require,module,exports,__globalThis) {
/*
 * Copyright Joyent, Inc. and other Node contributors.
 *
 * Permission is hereby granted, free of charge, to any person obtaining a
 * copy of this software and associated documentation files (the
 * "Software"), to deal in the Software without restriction, including
 * without limitation the rights to use, copy, modify, merge, publish,
 * distribute, sublicense, and/or sell copies of the Software, and to permit
 * persons to whom the Software is furnished to do so, subject to the
 * following conditions:
 *
 * The above copyright notice and this permission notice shall be included
 * in all copies or substantial portions of the Software.
 *
 * THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
 * OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
 * MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
 * NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
 * DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
 * OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
 * USE OR OTHER DEALINGS IN THE SOFTWARE.
 */ 'use strict';
var punycode = require("e296a666b34d5fd8");
function Url() {
    this.protocol = null;
    this.slashes = null;
    this.auth = null;
    this.host = null;
    this.port = null;
    this.hostname = null;
    this.hash = null;
    this.search = null;
    this.query = null;
    this.pathname = null;
    this.path = null;
    this.href = null;
}
// Reference: RFC 3986, RFC 1808, RFC 2396
/*
 * define these here so at least they only have to be
 * compiled once on the first module load.
 */ var protocolPattern = /^([a-z0-9.+-]+:)/i, portPattern = /:[0-9]*$/, // Special case for a simple path URL
simplePathPattern = /^(\/\/?(?!\/)[^?\s]*)(\?[^\s]*)?$/, /*
   * RFC 2396: characters reserved for delimiting URLs.
   * We actually just auto-escape these.
   */ delims = [
    '<',
    '>',
    '"',
    '`',
    ' ',
    '\r',
    '\n',
    '\t'
], // RFC 2396: characters not allowed for various reasons.
unwise = [
    '{',
    '}',
    '|',
    '\\',
    '^',
    '`'
].concat(delims), // Allowed by RFCs, but cause of XSS attacks.  Always escape these.
autoEscape = [
    '\''
].concat(unwise), /*
   * Characters that are never ever allowed in a hostname.
   * Note that any invalid chars are also handled, but these
   * are the ones that are *expected* to be seen, so we fast-path
   * them.
   */ nonHostChars = [
    '%',
    '/',
    '?',
    ';',
    '#'
].concat(autoEscape), hostEndingChars = [
    '/',
    '?',
    '#'
], hostnameMaxLen = 255, hostnamePartPattern = /^[+a-z0-9A-Z_-]{0,63}$/, hostnamePartStart = /^([+a-z0-9A-Z_-]{0,63})(.*)$/, // protocols that can allow "unsafe" and "unwise" chars.
unsafeProtocol = {
    javascript: true,
    'javascript:': true
}, // protocols that never have a hostname.
hostlessProtocol = {
    javascript: true,
    'javascript:': true
}, // protocols that always contain a // bit.
slashedProtocol = {
    http: true,
    https: true,
    ftp: true,
    gopher: true,
    file: true,
    'http:': true,
    'https:': true,
    'ftp:': true,
    'gopher:': true,
    'file:': true
}, querystring = require("79d23453adb55027");
function urlParse(url, parseQueryString, slashesDenoteHost) {
    if (url && typeof url === 'object' && url instanceof Url) return url;
    var u = new Url();
    u.parse(url, parseQueryString, slashesDenoteHost);
    return u;
}
Url.prototype.parse = function(url, parseQueryString, slashesDenoteHost) {
    if (typeof url !== 'string') throw new TypeError("Parameter 'url' must be a string, not " + typeof url);
    /*
   * Copy chrome, IE, opera backslash-handling behavior.
   * Back slashes before the query string get converted to forward slashes
   * See: https://code.google.com/p/chromium/issues/detail?id=25916
   */ var queryIndex = url.indexOf('?'), splitter = queryIndex !== -1 && queryIndex < url.indexOf('#') ? '?' : '#', uSplit = url.split(splitter), slashRegex = /\\/g;
    uSplit[0] = uSplit[0].replace(slashRegex, '/');
    url = uSplit.join(splitter);
    var rest = url;
    /*
   * trim before proceeding.
   * This is to support parse stuff like "  http://foo.com  \n"
   */ rest = rest.trim();
    if (!slashesDenoteHost && url.split('#').length === 1) {
        // Try fast path regexp
        var simplePath = simplePathPattern.exec(rest);
        if (simplePath) {
            this.path = rest;
            this.href = rest;
            this.pathname = simplePath[1];
            if (simplePath[2]) {
                this.search = simplePath[2];
                if (parseQueryString) this.query = querystring.parse(this.search.substr(1));
                else this.query = this.search.substr(1);
            } else if (parseQueryString) {
                this.search = '';
                this.query = {};
            }
            return this;
        }
    }
    var proto = protocolPattern.exec(rest);
    if (proto) {
        proto = proto[0];
        var lowerProto = proto.toLowerCase();
        this.protocol = lowerProto;
        rest = rest.substr(proto.length);
    }
    /*
   * figure out if it's got a host
   * user@server is *always* interpreted as a hostname, and url
   * resolution will treat //foo/bar as host=foo,path=bar because that's
   * how the browser resolves relative URLs.
   */ if (slashesDenoteHost || proto || rest.match(/^\/\/[^@/]+@[^@/]+/)) {
        var slashes = rest.substr(0, 2) === '//';
        if (slashes && !(proto && hostlessProtocol[proto])) {
            rest = rest.substr(2);
            this.slashes = true;
        }
    }
    if (!hostlessProtocol[proto] && (slashes || proto && !slashedProtocol[proto])) {
        /*
     * there's a hostname.
     * the first instance of /, ?, ;, or # ends the host.
     *
     * If there is an @ in the hostname, then non-host chars *are* allowed
     * to the left of the last @ sign, unless some host-ending character
     * comes *before* the @-sign.
     * URLs are obnoxious.
     *
     * ex:
     * http://a@b@c/ => user:a@b host:c
     * http://a@b?@c => user:a host:c path:/?@c
     */ /*
     * v0.12 TODO(isaacs): This is not quite how Chrome does things.
     * Review our test case against browsers more comprehensively.
     */ // find the first instance of any hostEndingChars
        var hostEnd = -1;
        for(var i = 0; i < hostEndingChars.length; i++){
            var hec = rest.indexOf(hostEndingChars[i]);
            if (hec !== -1 && (hostEnd === -1 || hec < hostEnd)) hostEnd = hec;
        }
        /*
     * at this point, either we have an explicit point where the
     * auth portion cannot go past, or the last @ char is the decider.
     */ var auth, atSign;
        if (hostEnd === -1) // atSign can be anywhere.
        atSign = rest.lastIndexOf('@');
        else /*
       * atSign must be in auth portion.
       * http://a@b/c@d => host:b auth:a path:/c@d
       */ atSign = rest.lastIndexOf('@', hostEnd);
        /*
     * Now we have a portion which is definitely the auth.
     * Pull that off.
     */ if (atSign !== -1) {
            auth = rest.slice(0, atSign);
            rest = rest.slice(atSign + 1);
            this.auth = decodeURIComponent(auth);
        }
        // the host is the remaining to the left of the first non-host char
        hostEnd = -1;
        for(var i = 0; i < nonHostChars.length; i++){
            var hec = rest.indexOf(nonHostChars[i]);
            if (hec !== -1 && (hostEnd === -1 || hec < hostEnd)) hostEnd = hec;
        }
        // if we still have not hit it, then the entire thing is a host.
        if (hostEnd === -1) hostEnd = rest.length;
        this.host = rest.slice(0, hostEnd);
        rest = rest.slice(hostEnd);
        // pull out port.
        this.parseHost();
        /*
     * we've indicated that there is a hostname,
     * so even if it's empty, it has to be present.
     */ this.hostname = this.hostname || '';
        /*
     * if hostname begins with [ and ends with ]
     * assume that it's an IPv6 address.
     */ var ipv6Hostname = this.hostname[0] === '[' && this.hostname[this.hostname.length - 1] === ']';
        // validate a little.
        if (!ipv6Hostname) {
            var hostparts = this.hostname.split(/\./);
            for(var i = 0, l = hostparts.length; i < l; i++){
                var part = hostparts[i];
                if (!part) continue;
                if (!part.match(hostnamePartPattern)) {
                    var newpart = '';
                    for(var j = 0, k = part.length; j < k; j++)if (part.charCodeAt(j) > 127) /*
               * we replace non-ASCII char with a temporary placeholder
               * we need this to make sure size of hostname is not
               * broken by replacing non-ASCII by nothing
               */ newpart += 'x';
                    else newpart += part[j];
                    // we test again with ASCII char only
                    if (!newpart.match(hostnamePartPattern)) {
                        var validParts = hostparts.slice(0, i);
                        var notHost = hostparts.slice(i + 1);
                        var bit = part.match(hostnamePartStart);
                        if (bit) {
                            validParts.push(bit[1]);
                            notHost.unshift(bit[2]);
                        }
                        if (notHost.length) rest = '/' + notHost.join('.') + rest;
                        this.hostname = validParts.join('.');
                        break;
                    }
                }
            }
        }
        if (this.hostname.length > hostnameMaxLen) this.hostname = '';
        else // hostnames are always lower case.
        this.hostname = this.hostname.toLowerCase();
        if (!ipv6Hostname) /*
       * IDNA Support: Returns a punycoded representation of "domain".
       * It only converts parts of the domain name that
       * have non-ASCII characters, i.e. it doesn't matter if
       * you call it with a domain that already is ASCII-only.
       */ this.hostname = punycode.toASCII(this.hostname);
        var p = this.port ? ':' + this.port : '';
        var h = this.hostname || '';
        this.host = h + p;
        this.href += this.host;
        /*
     * strip [ and ] from the hostname
     * the host field still retains them, though
     */ if (ipv6Hostname) {
            this.hostname = this.hostname.substr(1, this.hostname.length - 2);
            if (rest[0] !== '/') rest = '/' + rest;
        }
    }
    /*
   * now rest is set to the post-host stuff.
   * chop off any delim chars.
   */ if (!unsafeProtocol[lowerProto]) /*
     * First, make 100% sure that any "autoEscape" chars get
     * escaped, even if encodeURIComponent doesn't think they
     * need to be.
     */ for(var i = 0, l = autoEscape.length; i < l; i++){
        var ae = autoEscape[i];
        if (rest.indexOf(ae) === -1) continue;
        var esc = encodeURIComponent(ae);
        if (esc === ae) esc = escape(ae);
        rest = rest.split(ae).join(esc);
    }
    // chop off from the tail first.
    var hash = rest.indexOf('#');
    if (hash !== -1) {
        // got a fragment string.
        this.hash = rest.substr(hash);
        rest = rest.slice(0, hash);
    }
    var qm = rest.indexOf('?');
    if (qm !== -1) {
        this.search = rest.substr(qm);
        this.query = rest.substr(qm + 1);
        if (parseQueryString) this.query = querystring.parse(this.query);
        rest = rest.slice(0, qm);
    } else if (parseQueryString) {
        // no query string, but parseQueryString still requested
        this.search = '';
        this.query = {};
    }
    if (rest) this.pathname = rest;
    if (slashedProtocol[lowerProto] && this.hostname && !this.pathname) this.pathname = '/';
    // to support http.request
    if (this.pathname || this.search) {
        var p = this.pathname || '';
        var s = this.search || '';
        this.path = p + s;
    }
    // finally, reconstruct the href based on what has been validated.
    this.href = this.format();
    return this;
};
// format a parsed object into a url string
function urlFormat(obj) {
    /*
   * ensure it's an object, and not a string url.
   * If it's an obj, this is a no-op.
   * this way, you can call url_format() on strings
   * to clean up potentially wonky urls.
   */ if (typeof obj === 'string') obj = urlParse(obj);
    if (!(obj instanceof Url)) return Url.prototype.format.call(obj);
    return obj.format();
}
Url.prototype.format = function() {
    var auth = this.auth || '';
    if (auth) {
        auth = encodeURIComponent(auth);
        auth = auth.replace(/%3A/i, ':');
        auth += '@';
    }
    var protocol = this.protocol || '', pathname = this.pathname || '', hash = this.hash || '', host = false, query = '';
    if (this.host) host = auth + this.host;
    else if (this.hostname) {
        host = auth + (this.hostname.indexOf(':') === -1 ? this.hostname : '[' + this.hostname + ']');
        if (this.port) host += ':' + this.port;
    }
    if (this.query && typeof this.query === 'object' && Object.keys(this.query).length) query = querystring.stringify(this.query, {
        arrayFormat: 'repeat',
        addQueryPrefix: false
    });
    var search = this.search || query && '?' + query || '';
    if (protocol && protocol.substr(-1) !== ':') protocol += ':';
    /*
   * only the slashedProtocols get the //.  Not mailto:, xmpp:, etc.
   * unless they had them to begin with.
   */ if (this.slashes || (!protocol || slashedProtocol[protocol]) && host !== false) {
        host = '//' + (host || '');
        if (pathname && pathname.charAt(0) !== '/') pathname = '/' + pathname;
    } else if (!host) host = '';
    if (hash && hash.charAt(0) !== '#') hash = '#' + hash;
    if (search && search.charAt(0) !== '?') search = '?' + search;
    pathname = pathname.replace(/[?#]/g, function(match) {
        return encodeURIComponent(match);
    });
    search = search.replace('#', '%23');
    return protocol + host + pathname + search + hash;
};
function urlResolve(source, relative) {
    return urlParse(source, false, true).resolve(relative);
}
Url.prototype.resolve = function(relative) {
    return this.resolveObject(urlParse(relative, false, true)).format();
};
function urlResolveObject(source, relative) {
    if (!source) return relative;
    return urlParse(source, false, true).resolveObject(relative);
}
Url.prototype.resolveObject = function(relative) {
    if (typeof relative === 'string') {
        var rel = new Url();
        rel.parse(relative, false, true);
        relative = rel;
    }
    var result = new Url();
    var tkeys = Object.keys(this);
    for(var tk = 0; tk < tkeys.length; tk++){
        var tkey = tkeys[tk];
        result[tkey] = this[tkey];
    }
    /*
   * hash is always overridden, no matter what.
   * even href="" will remove it.
   */ result.hash = relative.hash;
    // if the relative url is empty, then there's nothing left to do here.
    if (relative.href === '') {
        result.href = result.format();
        return result;
    }
    // hrefs like //foo/bar always cut to the protocol.
    if (relative.slashes && !relative.protocol) {
        // take everything except the protocol from relative
        var rkeys = Object.keys(relative);
        for(var rk = 0; rk < rkeys.length; rk++){
            var rkey = rkeys[rk];
            if (rkey !== 'protocol') result[rkey] = relative[rkey];
        }
        // urlParse appends trailing / to urls like http://www.example.com
        if (slashedProtocol[result.protocol] && result.hostname && !result.pathname) {
            result.pathname = '/';
            result.path = result.pathname;
        }
        result.href = result.format();
        return result;
    }
    if (relative.protocol && relative.protocol !== result.protocol) {
        /*
     * if it's a known url protocol, then changing
     * the protocol does weird things
     * first, if it's not file:, then we MUST have a host,
     * and if there was a path
     * to begin with, then we MUST have a path.
     * if it is file:, then the host is dropped,
     * because that's known to be hostless.
     * anything else is assumed to be absolute.
     */ if (!slashedProtocol[relative.protocol]) {
            var keys = Object.keys(relative);
            for(var v = 0; v < keys.length; v++){
                var k = keys[v];
                result[k] = relative[k];
            }
            result.href = result.format();
            return result;
        }
        result.protocol = relative.protocol;
        if (!relative.host && !hostlessProtocol[relative.protocol]) {
            var relPath = (relative.pathname || '').split('/');
            while(relPath.length && !(relative.host = relPath.shift()));
            if (!relative.host) relative.host = '';
            if (!relative.hostname) relative.hostname = '';
            if (relPath[0] !== '') relPath.unshift('');
            if (relPath.length < 2) relPath.unshift('');
            result.pathname = relPath.join('/');
        } else result.pathname = relative.pathname;
        result.search = relative.search;
        result.query = relative.query;
        result.host = relative.host || '';
        result.auth = relative.auth;
        result.hostname = relative.hostname || relative.host;
        result.port = relative.port;
        // to support http.request
        if (result.pathname || result.search) {
            var p = result.pathname || '';
            var s = result.search || '';
            result.path = p + s;
        }
        result.slashes = result.slashes || relative.slashes;
        result.href = result.format();
        return result;
    }
    var isSourceAbs = result.pathname && result.pathname.charAt(0) === '/', isRelAbs = relative.host || relative.pathname && relative.pathname.charAt(0) === '/', mustEndAbs = isRelAbs || isSourceAbs || result.host && relative.pathname, removeAllDots = mustEndAbs, srcPath = result.pathname && result.pathname.split('/') || [], relPath = relative.pathname && relative.pathname.split('/') || [], psychotic = result.protocol && !slashedProtocol[result.protocol];
    /*
   * if the url is a non-slashed url, then relative
   * links like ../.. should be able
   * to crawl up to the hostname, as well.  This is strange.
   * result.protocol has already been set by now.
   * Later on, put the first path part into the host field.
   */ if (psychotic) {
        result.hostname = '';
        result.port = null;
        if (result.host) {
            if (srcPath[0] === '') srcPath[0] = result.host;
            else srcPath.unshift(result.host);
        }
        result.host = '';
        if (relative.protocol) {
            relative.hostname = null;
            relative.port = null;
            if (relative.host) {
                if (relPath[0] === '') relPath[0] = relative.host;
                else relPath.unshift(relative.host);
            }
            relative.host = null;
        }
        mustEndAbs = mustEndAbs && (relPath[0] === '' || srcPath[0] === '');
    }
    if (isRelAbs) {
        // it's absolute.
        result.host = relative.host || relative.host === '' ? relative.host : result.host;
        result.hostname = relative.hostname || relative.hostname === '' ? relative.hostname : result.hostname;
        result.search = relative.search;
        result.query = relative.query;
        srcPath = relPath;
    // fall through to the dot-handling below.
    } else if (relPath.length) {
        /*
     * it's relative
     * throw away the existing file, and take the new path instead.
     */ if (!srcPath) srcPath = [];
        srcPath.pop();
        srcPath = srcPath.concat(relPath);
        result.search = relative.search;
        result.query = relative.query;
    } else if (relative.search != null) {
        /*
     * just pull out the search.
     * like href='?foo'.
     * Put this after the other two cases because it simplifies the booleans
     */ if (psychotic) {
            result.host = srcPath.shift();
            result.hostname = result.host;
            /*
       * occationaly the auth can get stuck only in host
       * this especially happens in cases like
       * url.resolveObject('mailto:local1@domain1', 'local2@domain2')
       */ var authInHost = result.host && result.host.indexOf('@') > 0 ? result.host.split('@') : false;
            if (authInHost) {
                result.auth = authInHost.shift();
                result.hostname = authInHost.shift();
                result.host = result.hostname;
            }
        }
        result.search = relative.search;
        result.query = relative.query;
        // to support http.request
        if (result.pathname !== null || result.search !== null) result.path = (result.pathname ? result.pathname : '') + (result.search ? result.search : '');
        result.href = result.format();
        return result;
    }
    if (!srcPath.length) {
        /*
     * no path at all.  easy.
     * we've already handled the other stuff above.
     */ result.pathname = null;
        // to support http.request
        if (result.search) result.path = '/' + result.search;
        else result.path = null;
        result.href = result.format();
        return result;
    }
    /*
   * if a url ENDs in . or .., then it must get a trailing slash.
   * however, if it ends in anything else non-slashy,
   * then it must NOT get a trailing slash.
   */ var last = srcPath.slice(-1)[0];
    var hasTrailingSlash = (result.host || relative.host || srcPath.length > 1) && (last === '.' || last === '..') || last === '';
    /*
   * strip single dots, resolve double dots to parent dir
   * if the path tries to go above the root, `up` ends up > 0
   */ var up = 0;
    for(var i = srcPath.length; i >= 0; i--){
        last = srcPath[i];
        if (last === '.') srcPath.splice(i, 1);
        else if (last === '..') {
            srcPath.splice(i, 1);
            up++;
        } else if (up) {
            srcPath.splice(i, 1);
            up--;
        }
    }
    // if the path is allowed to go above the root, restore leading ..s
    if (!mustEndAbs && !removeAllDots) for(; up--; up)srcPath.unshift('..');
    if (mustEndAbs && srcPath[0] !== '' && (!srcPath[0] || srcPath[0].charAt(0) !== '/')) srcPath.unshift('');
    if (hasTrailingSlash && srcPath.join('/').substr(-1) !== '/') srcPath.push('');
    var isAbsolute = srcPath[0] === '' || srcPath[0] && srcPath[0].charAt(0) === '/';
    // put the host back
    if (psychotic) {
        result.hostname = isAbsolute ? '' : srcPath.length ? srcPath.shift() : '';
        result.host = result.hostname;
        /*
     * occationaly the auth can get stuck only in host
     * this especially happens in cases like
     * url.resolveObject('mailto:local1@domain1', 'local2@domain2')
     */ var authInHost = result.host && result.host.indexOf('@') > 0 ? result.host.split('@') : false;
        if (authInHost) {
            result.auth = authInHost.shift();
            result.hostname = authInHost.shift();
            result.host = result.hostname;
        }
    }
    mustEndAbs = mustEndAbs || result.host && srcPath.length;
    if (mustEndAbs && !isAbsolute) srcPath.unshift('');
    if (srcPath.length > 0) result.pathname = srcPath.join('/');
    else {
        result.pathname = null;
        result.path = null;
    }
    // to support request.http
    if (result.pathname !== null || result.search !== null) result.path = (result.pathname ? result.pathname : '') + (result.search ? result.search : '');
    result.auth = relative.auth || result.auth;
    result.slashes = result.slashes || relative.slashes;
    result.href = result.format();
    return result;
};
Url.prototype.parseHost = function() {
    var host = this.host;
    var port = portPattern.exec(host);
    if (port) {
        port = port[0];
        if (port !== ':') this.port = port.substr(1);
        host = host.substr(0, host.length - port.length);
    }
    if (host) this.hostname = host;
};
exports.parse = urlParse;
exports.resolve = urlResolve;
exports.resolveObject = urlResolveObject;
exports.format = urlFormat;
exports.Url = Url;

},{"e296a666b34d5fd8":"3tv2D","79d23453adb55027":"36KWj"}],"3tv2D":[function(require,module,exports,__globalThis) {
/*! https://mths.be/punycode v1.4.1 by @mathias */ var global = arguments[3];
(function(root) {
    /** Detect free variables */ var freeExports = exports && !exports.nodeType && exports;
    var freeModule = module && !module.nodeType && module;
    var freeGlobal = typeof global == 'object' && global;
    if (freeGlobal.global === freeGlobal || freeGlobal.window === freeGlobal || freeGlobal.self === freeGlobal) root = freeGlobal;
    /**
	 * The `punycode` object.
	 * @name punycode
	 * @type Object
	 */ var punycode, /** Highest positive signed 32-bit float value */ maxInt = 2147483647, /** Bootstring parameters */ base = 36, tMin = 1, tMax = 26, skew = 38, damp = 700, initialBias = 72, initialN = 128, delimiter = '-', /** Regular expressions */ regexPunycode = /^xn--/, regexNonASCII = /[^\x20-\x7E]/, regexSeparators = /[\x2E\u3002\uFF0E\uFF61]/g, /** Error messages */ errors = {
        'overflow': 'Overflow: input needs wider integers to process',
        'not-basic': 'Illegal input >= 0x80 (not a basic code point)',
        'invalid-input': 'Invalid input'
    }, /** Convenience shortcuts */ baseMinusTMin = base - tMin, floor = Math.floor, stringFromCharCode = String.fromCharCode, /** Temporary variable */ key;
    /*--------------------------------------------------------------------------*/ /**
	 * A generic error utility function.
	 * @private
	 * @param {String} type The error type.
	 * @returns {Error} Throws a `RangeError` with the applicable error message.
	 */ function error(type) {
        throw new RangeError(errors[type]);
    }
    /**
	 * A generic `Array#map` utility function.
	 * @private
	 * @param {Array} array The array to iterate over.
	 * @param {Function} callback The function that gets called for every array
	 * item.
	 * @returns {Array} A new array of values returned by the callback function.
	 */ function map(array, fn) {
        var length = array.length;
        var result = [];
        while(length--)result[length] = fn(array[length]);
        return result;
    }
    /**
	 * A simple `Array#map`-like wrapper to work with domain name strings or email
	 * addresses.
	 * @private
	 * @param {String} domain The domain name or email address.
	 * @param {Function} callback The function that gets called for every
	 * character.
	 * @returns {Array} A new string of characters returned by the callback
	 * function.
	 */ function mapDomain(string, fn) {
        var parts = string.split('@');
        var result = '';
        if (parts.length > 1) {
            // In email addresses, only the domain name should be punycoded. Leave
            // the local part (i.e. everything up to `@`) intact.
            result = parts[0] + '@';
            string = parts[1];
        }
        // Avoid `split(regex)` for IE8 compatibility. See #17.
        string = string.replace(regexSeparators, '\x2E');
        var labels = string.split('.');
        var encoded = map(labels, fn).join('.');
        return result + encoded;
    }
    /**
	 * Creates an array containing the numeric code points of each Unicode
	 * character in the string. While JavaScript uses UCS-2 internally,
	 * this function will convert a pair of surrogate halves (each of which
	 * UCS-2 exposes as separate characters) into a single code point,
	 * matching UTF-16.
	 * @see `punycode.ucs2.encode`
	 * @see <https://mathiasbynens.be/notes/javascript-encoding>
	 * @memberOf punycode.ucs2
	 * @name decode
	 * @param {String} string The Unicode input string (UCS-2).
	 * @returns {Array} The new array of code points.
	 */ function ucs2decode(string) {
        var output = [], counter = 0, length = string.length, value, extra;
        while(counter < length){
            value = string.charCodeAt(counter++);
            if (value >= 0xD800 && value <= 0xDBFF && counter < length) {
                // high surrogate, and there is a next character
                extra = string.charCodeAt(counter++);
                if ((extra & 0xFC00) == 0xDC00) output.push(((value & 0x3FF) << 10) + (extra & 0x3FF) + 0x10000);
                else {
                    // unmatched surrogate; only append this code unit, in case the next
                    // code unit is the high surrogate of a surrogate pair
                    output.push(value);
                    counter--;
                }
            } else output.push(value);
        }
        return output;
    }
    /**
	 * Creates a string based on an array of numeric code points.
	 * @see `punycode.ucs2.decode`
	 * @memberOf punycode.ucs2
	 * @name encode
	 * @param {Array} codePoints The array of numeric code points.
	 * @returns {String} The new Unicode string (UCS-2).
	 */ function ucs2encode(array) {
        return map(array, function(value) {
            var output = '';
            if (value > 0xFFFF) {
                value -= 0x10000;
                output += stringFromCharCode(value >>> 10 & 0x3FF | 0xD800);
                value = 0xDC00 | value & 0x3FF;
            }
            output += stringFromCharCode(value);
            return output;
        }).join('');
    }
    /**
	 * Converts a basic code point into a digit/integer.
	 * @see `digitToBasic()`
	 * @private
	 * @param {Number} codePoint The basic numeric code point value.
	 * @returns {Number} The numeric value of a basic code point (for use in
	 * representing integers) in the range `0` to `base - 1`, or `base` if
	 * the code point does not represent a value.
	 */ function basicToDigit(codePoint) {
        if (codePoint - 48 < 10) return codePoint - 22;
        if (codePoint - 65 < 26) return codePoint - 65;
        if (codePoint - 97 < 26) return codePoint - 97;
        return base;
    }
    /**
	 * Converts a digit/integer into a basic code point.
	 * @see `basicToDigit()`
	 * @private
	 * @param {Number} digit The numeric value of a basic code point.
	 * @returns {Number} The basic code point whose value (when used for
	 * representing integers) is `digit`, which needs to be in the range
	 * `0` to `base - 1`. If `flag` is non-zero, the uppercase form is
	 * used; else, the lowercase form is used. The behavior is undefined
	 * if `flag` is non-zero and `digit` has no uppercase form.
	 */ function digitToBasic(digit, flag) {
        //  0..25 map to ASCII a..z or A..Z
        // 26..35 map to ASCII 0..9
        return digit + 22 + 75 * (digit < 26) - ((flag != 0) << 5);
    }
    /**
	 * Bias adaptation function as per section 3.4 of RFC 3492.
	 * https://tools.ietf.org/html/rfc3492#section-3.4
	 * @private
	 */ function adapt(delta, numPoints, firstTime) {
        var k = 0;
        delta = firstTime ? floor(delta / damp) : delta >> 1;
        delta += floor(delta / numPoints);
        for(; delta > baseMinusTMin * tMax >> 1; k += base)delta = floor(delta / baseMinusTMin);
        return floor(k + (baseMinusTMin + 1) * delta / (delta + skew));
    }
    /**
	 * Converts a Punycode string of ASCII-only symbols to a string of Unicode
	 * symbols.
	 * @memberOf punycode
	 * @param {String} input The Punycode string of ASCII-only symbols.
	 * @returns {String} The resulting string of Unicode symbols.
	 */ function decode(input) {
        // Don't use UCS-2
        var output = [], inputLength = input.length, out, i = 0, n = initialN, bias = initialBias, basic, j, index, oldi, w, k, digit, t, /** Cached calculation results */ baseMinusT;
        // Handle the basic code points: let `basic` be the number of input code
        // points before the last delimiter, or `0` if there is none, then copy
        // the first basic code points to the output.
        basic = input.lastIndexOf(delimiter);
        if (basic < 0) basic = 0;
        for(j = 0; j < basic; ++j){
            // if it's not a basic code point
            if (input.charCodeAt(j) >= 0x80) error('not-basic');
            output.push(input.charCodeAt(j));
        }
        // Main decoding loop: start just after the last delimiter if any basic code
        // points were copied; start at the beginning otherwise.
        for(index = basic > 0 ? basic + 1 : 0; index < inputLength;){
            // `index` is the index of the next character to be consumed.
            // Decode a generalized variable-length integer into `delta`,
            // which gets added to `i`. The overflow checking is easier
            // if we increase `i` as we go, then subtract off its starting
            // value at the end to obtain `delta`.
            for(oldi = i, w = 1, k = base;; k += base){
                if (index >= inputLength) error('invalid-input');
                digit = basicToDigit(input.charCodeAt(index++));
                if (digit >= base || digit > floor((maxInt - i) / w)) error('overflow');
                i += digit * w;
                t = k <= bias ? tMin : k >= bias + tMax ? tMax : k - bias;
                if (digit < t) break;
                baseMinusT = base - t;
                if (w > floor(maxInt / baseMinusT)) error('overflow');
                w *= baseMinusT;
            }
            out = output.length + 1;
            bias = adapt(i - oldi, out, oldi == 0);
            // `i` was supposed to wrap around from `out` to `0`,
            // incrementing `n` each time, so we'll fix that now:
            if (floor(i / out) > maxInt - n) error('overflow');
            n += floor(i / out);
            i %= out;
            // Insert `n` at position `i` of the output
            output.splice(i++, 0, n);
        }
        return ucs2encode(output);
    }
    /**
	 * Converts a string of Unicode symbols (e.g. a domain name label) to a
	 * Punycode string of ASCII-only symbols.
	 * @memberOf punycode
	 * @param {String} input The string of Unicode symbols.
	 * @returns {String} The resulting Punycode string of ASCII-only symbols.
	 */ function encode(input) {
        var n, delta, handledCPCount, basicLength, bias, j, m, q, k, t, currentValue, output = [], /** `inputLength` will hold the number of code points in `input`. */ inputLength, /** Cached calculation results */ handledCPCountPlusOne, baseMinusT, qMinusT;
        // Convert the input in UCS-2 to Unicode
        input = ucs2decode(input);
        // Cache the length
        inputLength = input.length;
        // Initialize the state
        n = initialN;
        delta = 0;
        bias = initialBias;
        // Handle the basic code points
        for(j = 0; j < inputLength; ++j){
            currentValue = input[j];
            if (currentValue < 0x80) output.push(stringFromCharCode(currentValue));
        }
        handledCPCount = basicLength = output.length;
        // `handledCPCount` is the number of code points that have been handled;
        // `basicLength` is the number of basic code points.
        // Finish the basic string - if it is not empty - with a delimiter
        if (basicLength) output.push(delimiter);
        // Main encoding loop:
        while(handledCPCount < inputLength){
            // All non-basic code points < n have been handled already. Find the next
            // larger one:
            for(m = maxInt, j = 0; j < inputLength; ++j){
                currentValue = input[j];
                if (currentValue >= n && currentValue < m) m = currentValue;
            }
            // Increase `delta` enough to advance the decoder's <n,i> state to <m,0>,
            // but guard against overflow
            handledCPCountPlusOne = handledCPCount + 1;
            if (m - n > floor((maxInt - delta) / handledCPCountPlusOne)) error('overflow');
            delta += (m - n) * handledCPCountPlusOne;
            n = m;
            for(j = 0; j < inputLength; ++j){
                currentValue = input[j];
                if (currentValue < n && ++delta > maxInt) error('overflow');
                if (currentValue == n) {
                    // Represent delta as a generalized variable-length integer
                    for(q = delta, k = base;; k += base){
                        t = k <= bias ? tMin : k >= bias + tMax ? tMax : k - bias;
                        if (q < t) break;
                        qMinusT = q - t;
                        baseMinusT = base - t;
                        output.push(stringFromCharCode(digitToBasic(t + qMinusT % baseMinusT, 0)));
                        q = floor(qMinusT / baseMinusT);
                    }
                    output.push(stringFromCharCode(digitToBasic(q, 0)));
                    bias = adapt(delta, handledCPCountPlusOne, handledCPCount == basicLength);
                    delta = 0;
                    ++handledCPCount;
                }
            }
            ++delta;
            ++n;
        }
        return output.join('');
    }
    /**
	 * Converts a Punycode string representing a domain name or an email address
	 * to Unicode. Only the Punycoded parts of the input will be converted, i.e.
	 * it doesn't matter if you call it on a string that has already been
	 * converted to Unicode.
	 * @memberOf punycode
	 * @param {String} input The Punycoded domain name or email address to
	 * convert to Unicode.
	 * @returns {String} The Unicode representation of the given Punycode
	 * string.
	 */ function toUnicode(input) {
        return mapDomain(input, function(string) {
            return regexPunycode.test(string) ? decode(string.slice(4).toLowerCase()) : string;
        });
    }
    /**
	 * Converts a Unicode string representing a domain name or an email address to
	 * Punycode. Only the non-ASCII parts of the domain name will be converted,
	 * i.e. it doesn't matter if you call it with a domain that's already in
	 * ASCII.
	 * @memberOf punycode
	 * @param {String} input The domain name or email address to convert, as a
	 * Unicode string.
	 * @returns {String} The Punycode representation of the given domain name or
	 * email address.
	 */ function toASCII(input) {
        return mapDomain(input, function(string) {
            return regexNonASCII.test(string) ? 'xn--' + encode(string) : string;
        });
    }
    /*--------------------------------------------------------------------------*/ /** Define the public API */ punycode = {
        /**
		 * A string representing the current Punycode.js version number.
		 * @memberOf punycode
		 * @type String
		 */ 'version': '1.4.1',
        /**
		 * An object of methods to convert from JavaScript's internal character
		 * representation (UCS-2) to Unicode code points, and back.
		 * @see <https://mathiasbynens.be/notes/javascript-encoding>
		 * @memberOf punycode
		 * @type Object
		 */ 'ucs2': {
            'decode': ucs2decode,
            'encode': ucs2encode
        },
        'decode': decode,
        'encode': encode,
        'toASCII': toASCII,
        'toUnicode': toUnicode
    };
    /** Expose `punycode` */ // Some AMD build optimizers, like r.js, check for specific condition patterns
    // like the following:
    if (typeof define == 'function' && typeof define.amd == 'object' && define.amd) define('punycode', function() {
        return punycode;
    });
    else if (freeExports && freeModule) {
        if (module.exports == freeExports) // in Node.js, io.js, or RingoJS v0.8.0+
        freeModule.exports = punycode;
        else // in Narwhal or RingoJS v0.7.0-
        for(key in punycode)punycode.hasOwnProperty(key) && (freeExports[key] = punycode[key]);
    } else // in Rhino or a web browser
    root.punycode = punycode;
})(this);

},{}],"36KWj":[function(require,module,exports,__globalThis) {
'use strict';
var stringify = require("353bd08a7f6d8ac4");
var parse = require("50c665e6167f42db");
var formats = require("c714d826423952c2");
module.exports = {
    formats: formats,
    parse: parse,
    stringify: stringify
};

},{"353bd08a7f6d8ac4":"btFxQ","50c665e6167f42db":"gwG2K","c714d826423952c2":"l8I4v"}],"btFxQ":[function(require,module,exports,__globalThis) {
'use strict';
var getSideChannel = require("b4437c5816d8ce19");
var utils = require("d9c692bed0424b65");
var formats = require("7c5d3486fca2001a");
var has = Object.prototype.hasOwnProperty;
var arrayPrefixGenerators = {
    brackets: function brackets(prefix) {
        return prefix + '[]';
    },
    comma: 'comma',
    indices: function indices(prefix, key) {
        return prefix + '[' + key + ']';
    },
    repeat: function repeat(prefix) {
        return prefix;
    }
};
var isArray = Array.isArray;
var push = Array.prototype.push;
var pushToArray = function(arr, valueOrArray) {
    push.apply(arr, isArray(valueOrArray) ? valueOrArray : [
        valueOrArray
    ]);
};
var toISO = Date.prototype.toISOString;
var defaultFormat = formats['default'];
var defaults = {
    addQueryPrefix: false,
    allowDots: false,
    allowEmptyArrays: false,
    arrayFormat: 'indices',
    charset: 'utf-8',
    charsetSentinel: false,
    commaRoundTrip: false,
    delimiter: '&',
    encode: true,
    encodeDotInKeys: false,
    encoder: utils.encode,
    encodeValuesOnly: false,
    filter: void 0,
    format: defaultFormat,
    formatter: formats.formatters[defaultFormat],
    // deprecated
    indices: false,
    serializeDate: function serializeDate(date) {
        return toISO.call(date);
    },
    skipNulls: false,
    strictNullHandling: false
};
var isNonNullishPrimitive = function isNonNullishPrimitive(v) {
    return typeof v === 'string' || typeof v === 'number' || typeof v === 'boolean' || typeof v === 'symbol' || typeof v === 'bigint';
};
var sentinel = {};
var stringify = function stringify(object, prefix, generateArrayPrefix, commaRoundTrip, allowEmptyArrays, strictNullHandling, skipNulls, encodeDotInKeys, encoder, filter, sort, allowDots, serializeDate, format, formatter, encodeValuesOnly, charset, sideChannel) {
    var obj = object;
    var tmpSc = sideChannel;
    var step = 0;
    var findFlag = false;
    while((tmpSc = tmpSc.get(sentinel)) !== void 0 && !findFlag){
        // Where object last appeared in the ref tree
        var pos = tmpSc.get(object);
        step += 1;
        if (typeof pos !== 'undefined') {
            if (pos === step) throw new RangeError('Cyclic object value');
            else findFlag = true; // Break while
        }
        if (typeof tmpSc.get(sentinel) === 'undefined') step = 0;
    }
    if (typeof filter === 'function') obj = filter(prefix, obj);
    else if (obj instanceof Date) obj = serializeDate(obj);
    else if (generateArrayPrefix === 'comma' && isArray(obj)) obj = utils.maybeMap(obj, function(value) {
        if (value instanceof Date) return serializeDate(value);
        return value;
    });
    if (obj === null) {
        if (strictNullHandling) return formatter(encoder && !encodeValuesOnly ? encoder(prefix, defaults.encoder, charset, 'key', format) : prefix);
        obj = '';
    }
    if (isNonNullishPrimitive(obj) || utils.isBuffer(obj)) {
        if (encoder) {
            var keyValue = encodeValuesOnly ? prefix : encoder(prefix, defaults.encoder, charset, 'key', format);
            return [
                formatter(keyValue) + '=' + formatter(encoder(obj, defaults.encoder, charset, 'value', format))
            ];
        }
        return [
            formatter(prefix) + '=' + formatter(String(obj))
        ];
    }
    var values = [];
    if (typeof obj === 'undefined') return values;
    var objKeys;
    if (generateArrayPrefix === 'comma' && isArray(obj)) {
        // we need to join elements in
        if (encodeValuesOnly && encoder) obj = utils.maybeMap(obj, function(v) {
            return v == null ? v : encoder(v);
        });
        objKeys = [
            {
                value: obj.length > 0 ? obj.join(',') || null : void 0
            }
        ];
    } else if (isArray(filter)) objKeys = filter;
    else {
        var keys = Object.keys(obj);
        objKeys = sort ? keys.sort(sort) : keys;
    }
    var encodedPrefix = encodeDotInKeys ? String(prefix).replace(/\./g, '%2E') : String(prefix);
    var adjustedPrefix = commaRoundTrip && isArray(obj) && obj.length === 1 ? encodedPrefix + '[]' : encodedPrefix;
    if (allowEmptyArrays && isArray(obj) && obj.length === 0) return adjustedPrefix + '[]';
    for(var j = 0; j < objKeys.length; ++j){
        var key = objKeys[j];
        var value = typeof key === 'object' && key && typeof key.value !== 'undefined' ? key.value : obj[key];
        if (skipNulls && value === null) continue;
        var encodedKey = allowDots && encodeDotInKeys ? String(key).replace(/\./g, '%2E') : String(key);
        var keyPrefix = isArray(obj) ? typeof generateArrayPrefix === 'function' ? generateArrayPrefix(adjustedPrefix, encodedKey) : adjustedPrefix : adjustedPrefix + (allowDots ? '.' + encodedKey : '[' + encodedKey + ']');
        sideChannel.set(object, step);
        var valueSideChannel = getSideChannel();
        valueSideChannel.set(sentinel, sideChannel);
        pushToArray(values, stringify(value, keyPrefix, generateArrayPrefix, commaRoundTrip, allowEmptyArrays, strictNullHandling, skipNulls, encodeDotInKeys, generateArrayPrefix === 'comma' && encodeValuesOnly && isArray(obj) ? null : encoder, filter, sort, allowDots, serializeDate, format, formatter, encodeValuesOnly, charset, valueSideChannel));
    }
    return values;
};
var normalizeStringifyOptions = function normalizeStringifyOptions(opts) {
    if (!opts) return defaults;
    if (typeof opts.allowEmptyArrays !== 'undefined' && typeof opts.allowEmptyArrays !== 'boolean') throw new TypeError('`allowEmptyArrays` option can only be `true` or `false`, when provided');
    if (typeof opts.encodeDotInKeys !== 'undefined' && typeof opts.encodeDotInKeys !== 'boolean') throw new TypeError('`encodeDotInKeys` option can only be `true` or `false`, when provided');
    if (opts.encoder !== null && typeof opts.encoder !== 'undefined' && typeof opts.encoder !== 'function') throw new TypeError('Encoder has to be a function.');
    var charset = opts.charset || defaults.charset;
    if (typeof opts.charset !== 'undefined' && opts.charset !== 'utf-8' && opts.charset !== 'iso-8859-1') throw new TypeError('The charset option must be either utf-8, iso-8859-1, or undefined');
    var format = formats['default'];
    if (typeof opts.format !== 'undefined') {
        if (!has.call(formats.formatters, opts.format)) throw new TypeError('Unknown format option provided.');
        format = opts.format;
    }
    var formatter = formats.formatters[format];
    var filter = defaults.filter;
    if (typeof opts.filter === 'function' || isArray(opts.filter)) filter = opts.filter;
    var arrayFormat;
    if (opts.arrayFormat in arrayPrefixGenerators) arrayFormat = opts.arrayFormat;
    else if ('indices' in opts) arrayFormat = opts.indices ? 'indices' : 'repeat';
    else arrayFormat = defaults.arrayFormat;
    if ('commaRoundTrip' in opts && typeof opts.commaRoundTrip !== 'boolean') throw new TypeError('`commaRoundTrip` must be a boolean, or absent');
    var allowDots = typeof opts.allowDots === 'undefined' ? opts.encodeDotInKeys === true ? true : defaults.allowDots : !!opts.allowDots;
    return {
        addQueryPrefix: typeof opts.addQueryPrefix === 'boolean' ? opts.addQueryPrefix : defaults.addQueryPrefix,
        allowDots: allowDots,
        allowEmptyArrays: typeof opts.allowEmptyArrays === 'boolean' ? !!opts.allowEmptyArrays : defaults.allowEmptyArrays,
        arrayFormat: arrayFormat,
        charset: charset,
        charsetSentinel: typeof opts.charsetSentinel === 'boolean' ? opts.charsetSentinel : defaults.charsetSentinel,
        commaRoundTrip: !!opts.commaRoundTrip,
        delimiter: typeof opts.delimiter === 'undefined' ? defaults.delimiter : opts.delimiter,
        encode: typeof opts.encode === 'boolean' ? opts.encode : defaults.encode,
        encodeDotInKeys: typeof opts.encodeDotInKeys === 'boolean' ? opts.encodeDotInKeys : defaults.encodeDotInKeys,
        encoder: typeof opts.encoder === 'function' ? opts.encoder : defaults.encoder,
        encodeValuesOnly: typeof opts.encodeValuesOnly === 'boolean' ? opts.encodeValuesOnly : defaults.encodeValuesOnly,
        filter: filter,
        format: format,
        formatter: formatter,
        serializeDate: typeof opts.serializeDate === 'function' ? opts.serializeDate : defaults.serializeDate,
        skipNulls: typeof opts.skipNulls === 'boolean' ? opts.skipNulls : defaults.skipNulls,
        sort: typeof opts.sort === 'function' ? opts.sort : null,
        strictNullHandling: typeof opts.strictNullHandling === 'boolean' ? opts.strictNullHandling : defaults.strictNullHandling
    };
};
module.exports = function(object, opts) {
    var obj = object;
    var options = normalizeStringifyOptions(opts);
    var objKeys;
    var filter;
    if (typeof options.filter === 'function') {
        filter = options.filter;
        obj = filter('', obj);
    } else if (isArray(options.filter)) {
        filter = options.filter;
        objKeys = filter;
    }
    var keys = [];
    if (typeof obj !== 'object' || obj === null) return '';
    var generateArrayPrefix = arrayPrefixGenerators[options.arrayFormat];
    var commaRoundTrip = generateArrayPrefix === 'comma' && options.commaRoundTrip;
    if (!objKeys) objKeys = Object.keys(obj);
    if (options.sort) objKeys.sort(options.sort);
    var sideChannel = getSideChannel();
    for(var i = 0; i < objKeys.length; ++i){
        var key = objKeys[i];
        if (typeof key === 'undefined' || key === null) continue;
        var value = obj[key];
        if (options.skipNulls && value === null) continue;
        pushToArray(keys, stringify(value, key, generateArrayPrefix, commaRoundTrip, options.allowEmptyArrays, options.strictNullHandling, options.skipNulls, options.encodeDotInKeys, options.encode ? options.encoder : null, options.filter, options.sort, options.allowDots, options.serializeDate, options.format, options.formatter, options.encodeValuesOnly, options.charset, sideChannel));
    }
    var joined = keys.join(options.delimiter);
    var prefix = options.addQueryPrefix === true ? '?' : '';
    if (options.charsetSentinel) {
        if (options.charset === 'iso-8859-1') // encodeURIComponent('&#10003;'), the "numeric entity" representation of a checkmark
        prefix += 'utf8=%26%2310003%3B' + options.delimiter;
        else // encodeURIComponent('✓')
        prefix += 'utf8=%E2%9C%93' + options.delimiter;
    }
    return joined.length > 0 ? prefix + joined : '';
};

},{"b4437c5816d8ce19":"3ErEP","d9c692bed0424b65":"kD3m6","7c5d3486fca2001a":"l8I4v"}],"3ErEP":[function(require,module,exports,__globalThis) {
'use strict';
var $TypeError = require("6d1e665841b03744");
var inspect = require("f4e9306f5753be41");
var getSideChannelList = require("e234f10543281bc9");
var getSideChannelMap = require("b37991e510a9244a");
var getSideChannelWeakMap = require("b993f2e363e135d7");
var makeChannel = getSideChannelWeakMap || getSideChannelMap || getSideChannelList;
/** @type {import('.')} */ module.exports = function getSideChannel() {
    /** @typedef {ReturnType<typeof getSideChannel>} Channel */ /** @type {Channel | undefined} */ var $channelData;
    /** @type {Channel} */ var channel = {
        assert: function(key) {
            if (!channel.has(key)) throw new $TypeError('Side channel does not contain ' + inspect(key));
        },
        'delete': function(key) {
            return !!$channelData && $channelData['delete'](key);
        },
        get: function(key) {
            return $channelData && $channelData.get(key);
        },
        has: function(key) {
            return !!$channelData && $channelData.has(key);
        },
        set: function(key, value) {
            if (!$channelData) $channelData = makeChannel();
            $channelData.set(key, value);
        }
    };
    // @ts-expect-error TODO: figure out why this is erroring
    return channel;
};

},{"6d1e665841b03744":"b7cTX","f4e9306f5753be41":"7Q8uX","e234f10543281bc9":"fjNyp","b37991e510a9244a":"7k9aI","b993f2e363e135d7":"juGQg"}],"b7cTX":[function(require,module,exports,__globalThis) {
'use strict';
/** @type {import('./type')} */ module.exports = TypeError;

},{}],"7Q8uX":[function(require,module,exports,__globalThis) {
var global = arguments[3];
var hasMap = typeof Map === 'function' && Map.prototype;
var mapSizeDescriptor = Object.getOwnPropertyDescriptor && hasMap ? Object.getOwnPropertyDescriptor(Map.prototype, 'size') : null;
var mapSize = hasMap && mapSizeDescriptor && typeof mapSizeDescriptor.get === 'function' ? mapSizeDescriptor.get : null;
var mapForEach = hasMap && Map.prototype.forEach;
var hasSet = typeof Set === 'function' && Set.prototype;
var setSizeDescriptor = Object.getOwnPropertyDescriptor && hasSet ? Object.getOwnPropertyDescriptor(Set.prototype, 'size') : null;
var setSize = hasSet && setSizeDescriptor && typeof setSizeDescriptor.get === 'function' ? setSizeDescriptor.get : null;
var setForEach = hasSet && Set.prototype.forEach;
var hasWeakMap = typeof WeakMap === 'function' && WeakMap.prototype;
var weakMapHas = hasWeakMap ? WeakMap.prototype.has : null;
var hasWeakSet = typeof WeakSet === 'function' && WeakSet.prototype;
var weakSetHas = hasWeakSet ? WeakSet.prototype.has : null;
var hasWeakRef = typeof WeakRef === 'function' && WeakRef.prototype;
var weakRefDeref = hasWeakRef ? WeakRef.prototype.deref : null;
var booleanValueOf = Boolean.prototype.valueOf;
var objectToString = Object.prototype.toString;
var functionToString = Function.prototype.toString;
var $match = String.prototype.match;
var $slice = String.prototype.slice;
var $replace = String.prototype.replace;
var $toUpperCase = String.prototype.toUpperCase;
var $toLowerCase = String.prototype.toLowerCase;
var $test = RegExp.prototype.test;
var $concat = Array.prototype.concat;
var $join = Array.prototype.join;
var $arrSlice = Array.prototype.slice;
var $floor = Math.floor;
var bigIntValueOf = typeof BigInt === 'function' ? BigInt.prototype.valueOf : null;
var gOPS = Object.getOwnPropertySymbols;
var symToString = typeof Symbol === 'function' && typeof Symbol.iterator === 'symbol' ? Symbol.prototype.toString : null;
var hasShammedSymbols = typeof Symbol === 'function' && typeof Symbol.iterator === 'object';
// ie, `has-tostringtag/shams
var toStringTag = typeof Symbol === 'function' && Symbol.toStringTag && (typeof Symbol.toStringTag === hasShammedSymbols ? 'object' : 'symbol') ? Symbol.toStringTag : null;
var isEnumerable = Object.prototype.propertyIsEnumerable;
var gPO = (typeof Reflect === 'function' ? Reflect.getPrototypeOf : Object.getPrototypeOf) || ([].__proto__ === Array.prototype // eslint-disable-line no-proto
 ? function(O) {
    return O.__proto__; // eslint-disable-line no-proto
} : null);
function addNumericSeparator(num, str) {
    if (num === Infinity || num === -Infinity || num !== num || num && num > -1000 && num < 1000 || $test.call(/e/, str)) return str;
    var sepRegex = /[0-9](?=(?:[0-9]{3})+(?![0-9]))/g;
    if (typeof num === 'number') {
        var int = num < 0 ? -$floor(-num) : $floor(num); // trunc(num)
        if (int !== num) {
            var intStr = String(int);
            var dec = $slice.call(str, intStr.length + 1);
            return $replace.call(intStr, sepRegex, '$&_') + '.' + $replace.call($replace.call(dec, /([0-9]{3})/g, '$&_'), /_$/, '');
        }
    }
    return $replace.call(str, sepRegex, '$&_');
}
var utilInspect = require("21d2abed798fa1b1");
var inspectCustom = utilInspect.custom;
var inspectSymbol = isSymbol(inspectCustom) ? inspectCustom : null;
var quotes = {
    __proto__: null,
    'double': '"',
    single: "'"
};
var quoteREs = {
    __proto__: null,
    'double': /(["\\])/g,
    single: /(['\\])/g
};
module.exports = function inspect_(obj, options, depth, seen) {
    var opts = options || {};
    if (has(opts, 'quoteStyle') && !has(quotes, opts.quoteStyle)) throw new TypeError('option "quoteStyle" must be "single" or "double"');
    if (has(opts, 'maxStringLength') && (typeof opts.maxStringLength === 'number' ? opts.maxStringLength < 0 && opts.maxStringLength !== Infinity : opts.maxStringLength !== null)) throw new TypeError('option "maxStringLength", if provided, must be a positive integer, Infinity, or `null`');
    var customInspect = has(opts, 'customInspect') ? opts.customInspect : true;
    if (typeof customInspect !== 'boolean' && customInspect !== 'symbol') throw new TypeError('option "customInspect", if provided, must be `true`, `false`, or `\'symbol\'`');
    if (has(opts, 'indent') && opts.indent !== null && opts.indent !== '\t' && !(parseInt(opts.indent, 10) === opts.indent && opts.indent > 0)) throw new TypeError('option "indent" must be "\\t", an integer > 0, or `null`');
    if (has(opts, 'numericSeparator') && typeof opts.numericSeparator !== 'boolean') throw new TypeError('option "numericSeparator", if provided, must be `true` or `false`');
    var numericSeparator = opts.numericSeparator;
    if (typeof obj === 'undefined') return 'undefined';
    if (obj === null) return 'null';
    if (typeof obj === 'boolean') return obj ? 'true' : 'false';
    if (typeof obj === 'string') return inspectString(obj, opts);
    if (typeof obj === 'number') {
        if (obj === 0) return Infinity / obj > 0 ? '0' : '-0';
        var str = String(obj);
        return numericSeparator ? addNumericSeparator(obj, str) : str;
    }
    if (typeof obj === 'bigint') {
        var bigIntStr = String(obj) + 'n';
        return numericSeparator ? addNumericSeparator(obj, bigIntStr) : bigIntStr;
    }
    var maxDepth = typeof opts.depth === 'undefined' ? 5 : opts.depth;
    if (typeof depth === 'undefined') depth = 0;
    if (depth >= maxDepth && maxDepth > 0 && typeof obj === 'object') return isArray(obj) ? '[Array]' : '[Object]';
    var indent = getIndent(opts, depth);
    if (typeof seen === 'undefined') seen = [];
    else if (indexOf(seen, obj) >= 0) return '[Circular]';
    function inspect(value, from, noIndent) {
        if (from) {
            seen = $arrSlice.call(seen);
            seen.push(from);
        }
        if (noIndent) {
            var newOpts = {
                depth: opts.depth
            };
            if (has(opts, 'quoteStyle')) newOpts.quoteStyle = opts.quoteStyle;
            return inspect_(value, newOpts, depth + 1, seen);
        }
        return inspect_(value, opts, depth + 1, seen);
    }
    if (typeof obj === 'function' && !isRegExp(obj)) {
        var name = nameOf(obj);
        var keys = arrObjKeys(obj, inspect);
        return '[Function' + (name ? ': ' + name : ' (anonymous)') + ']' + (keys.length > 0 ? ' { ' + $join.call(keys, ', ') + ' }' : '');
    }
    if (isSymbol(obj)) {
        var symString = hasShammedSymbols ? $replace.call(String(obj), /^(Symbol\(.*\))_[^)]*$/, '$1') : symToString.call(obj);
        return typeof obj === 'object' && !hasShammedSymbols ? markBoxed(symString) : symString;
    }
    if (isElement(obj)) {
        var s = '<' + $toLowerCase.call(String(obj.nodeName));
        var attrs = obj.attributes || [];
        for(var i = 0; i < attrs.length; i++)s += ' ' + attrs[i].name + '=' + wrapQuotes(quote(attrs[i].value), 'double', opts);
        s += '>';
        if (obj.childNodes && obj.childNodes.length) s += '...';
        s += '</' + $toLowerCase.call(String(obj.nodeName)) + '>';
        return s;
    }
    if (isArray(obj)) {
        if (obj.length === 0) return '[]';
        var xs = arrObjKeys(obj, inspect);
        if (indent && !singleLineValues(xs)) return '[' + indentedJoin(xs, indent) + ']';
        return '[ ' + $join.call(xs, ', ') + ' ]';
    }
    if (isError(obj)) {
        var parts = arrObjKeys(obj, inspect);
        if (!('cause' in Error.prototype) && 'cause' in obj && !isEnumerable.call(obj, 'cause')) return '{ [' + String(obj) + '] ' + $join.call($concat.call('[cause]: ' + inspect(obj.cause), parts), ', ') + ' }';
        if (parts.length === 0) return '[' + String(obj) + ']';
        return '{ [' + String(obj) + '] ' + $join.call(parts, ', ') + ' }';
    }
    if (typeof obj === 'object' && customInspect) {
        if (inspectSymbol && typeof obj[inspectSymbol] === 'function' && utilInspect) return utilInspect(obj, {
            depth: maxDepth - depth
        });
        else if (customInspect !== 'symbol' && typeof obj.inspect === 'function') return obj.inspect();
    }
    if (isMap(obj)) {
        var mapParts = [];
        if (mapForEach) mapForEach.call(obj, function(value, key) {
            mapParts.push(inspect(key, obj, true) + ' => ' + inspect(value, obj));
        });
        return collectionOf('Map', mapSize.call(obj), mapParts, indent);
    }
    if (isSet(obj)) {
        var setParts = [];
        if (setForEach) setForEach.call(obj, function(value) {
            setParts.push(inspect(value, obj));
        });
        return collectionOf('Set', setSize.call(obj), setParts, indent);
    }
    if (isWeakMap(obj)) return weakCollectionOf('WeakMap');
    if (isWeakSet(obj)) return weakCollectionOf('WeakSet');
    if (isWeakRef(obj)) return weakCollectionOf('WeakRef');
    if (isNumber(obj)) return markBoxed(inspect(Number(obj)));
    if (isBigInt(obj)) return markBoxed(inspect(bigIntValueOf.call(obj)));
    if (isBoolean(obj)) return markBoxed(booleanValueOf.call(obj));
    if (isString(obj)) return markBoxed(inspect(String(obj)));
    // note: in IE 8, sometimes `global !== window` but both are the prototypes of each other
    /* eslint-env browser */ if (typeof window !== 'undefined' && obj === window) return '{ [object Window] }';
    if (typeof globalThis !== 'undefined' && obj === globalThis || typeof global !== 'undefined' && obj === global) return '{ [object globalThis] }';
    if (!isDate(obj) && !isRegExp(obj)) {
        var ys = arrObjKeys(obj, inspect);
        var isPlainObject = gPO ? gPO(obj) === Object.prototype : obj instanceof Object || obj.constructor === Object;
        var protoTag = obj instanceof Object ? '' : 'null prototype';
        var stringTag = !isPlainObject && toStringTag && Object(obj) === obj && toStringTag in obj ? $slice.call(toStr(obj), 8, -1) : protoTag ? 'Object' : '';
        var constructorTag = isPlainObject || typeof obj.constructor !== 'function' ? '' : obj.constructor.name ? obj.constructor.name + ' ' : '';
        var tag = constructorTag + (stringTag || protoTag ? '[' + $join.call($concat.call([], stringTag || [], protoTag || []), ': ') + '] ' : '');
        if (ys.length === 0) return tag + '{}';
        if (indent) return tag + '{' + indentedJoin(ys, indent) + '}';
        return tag + '{ ' + $join.call(ys, ', ') + ' }';
    }
    return String(obj);
};
function wrapQuotes(s, defaultStyle, opts) {
    var style = opts.quoteStyle || defaultStyle;
    var quoteChar = quotes[style];
    return quoteChar + s + quoteChar;
}
function quote(s) {
    return $replace.call(String(s), /"/g, '&quot;');
}
function canTrustToString(obj) {
    return !toStringTag || !(typeof obj === 'object' && (toStringTag in obj || typeof obj[toStringTag] !== 'undefined'));
}
function isArray(obj) {
    return toStr(obj) === '[object Array]' && canTrustToString(obj);
}
function isDate(obj) {
    return toStr(obj) === '[object Date]' && canTrustToString(obj);
}
function isRegExp(obj) {
    return toStr(obj) === '[object RegExp]' && canTrustToString(obj);
}
function isError(obj) {
    return toStr(obj) === '[object Error]' && canTrustToString(obj);
}
function isString(obj) {
    return toStr(obj) === '[object String]' && canTrustToString(obj);
}
function isNumber(obj) {
    return toStr(obj) === '[object Number]' && canTrustToString(obj);
}
function isBoolean(obj) {
    return toStr(obj) === '[object Boolean]' && canTrustToString(obj);
}
// Symbol and BigInt do have Symbol.toStringTag by spec, so that can't be used to eliminate false positives
function isSymbol(obj) {
    if (hasShammedSymbols) return obj && typeof obj === 'object' && obj instanceof Symbol;
    if (typeof obj === 'symbol') return true;
    if (!obj || typeof obj !== 'object' || !symToString) return false;
    try {
        symToString.call(obj);
        return true;
    } catch (e) {}
    return false;
}
function isBigInt(obj) {
    if (!obj || typeof obj !== 'object' || !bigIntValueOf) return false;
    try {
        bigIntValueOf.call(obj);
        return true;
    } catch (e) {}
    return false;
}
var hasOwn = Object.prototype.hasOwnProperty || function(key) {
    return key in this;
};
function has(obj, key) {
    return hasOwn.call(obj, key);
}
function toStr(obj) {
    return objectToString.call(obj);
}
function nameOf(f) {
    if (f.name) return f.name;
    var m = $match.call(functionToString.call(f), /^function\s*([\w$]+)/);
    if (m) return m[1];
    return null;
}
function indexOf(xs, x) {
    if (xs.indexOf) return xs.indexOf(x);
    for(var i = 0, l = xs.length; i < l; i++){
        if (xs[i] === x) return i;
    }
    return -1;
}
function isMap(x) {
    if (!mapSize || !x || typeof x !== 'object') return false;
    try {
        mapSize.call(x);
        try {
            setSize.call(x);
        } catch (s) {
            return true;
        }
        return x instanceof Map; // core-js workaround, pre-v2.5.0
    } catch (e) {}
    return false;
}
function isWeakMap(x) {
    if (!weakMapHas || !x || typeof x !== 'object') return false;
    try {
        weakMapHas.call(x, weakMapHas);
        try {
            weakSetHas.call(x, weakSetHas);
        } catch (s) {
            return true;
        }
        return x instanceof WeakMap; // core-js workaround, pre-v2.5.0
    } catch (e) {}
    return false;
}
function isWeakRef(x) {
    if (!weakRefDeref || !x || typeof x !== 'object') return false;
    try {
        weakRefDeref.call(x);
        return true;
    } catch (e) {}
    return false;
}
function isSet(x) {
    if (!setSize || !x || typeof x !== 'object') return false;
    try {
        setSize.call(x);
        try {
            mapSize.call(x);
        } catch (m) {
            return true;
        }
        return x instanceof Set; // core-js workaround, pre-v2.5.0
    } catch (e) {}
    return false;
}
function isWeakSet(x) {
    if (!weakSetHas || !x || typeof x !== 'object') return false;
    try {
        weakSetHas.call(x, weakSetHas);
        try {
            weakMapHas.call(x, weakMapHas);
        } catch (s) {
            return true;
        }
        return x instanceof WeakSet; // core-js workaround, pre-v2.5.0
    } catch (e) {}
    return false;
}
function isElement(x) {
    if (!x || typeof x !== 'object') return false;
    if (typeof HTMLElement !== 'undefined' && x instanceof HTMLElement) return true;
    return typeof x.nodeName === 'string' && typeof x.getAttribute === 'function';
}
function inspectString(str, opts) {
    if (str.length > opts.maxStringLength) {
        var remaining = str.length - opts.maxStringLength;
        var trailer = '... ' + remaining + ' more character' + (remaining > 1 ? 's' : '');
        return inspectString($slice.call(str, 0, opts.maxStringLength), opts) + trailer;
    }
    var quoteRE = quoteREs[opts.quoteStyle || 'single'];
    quoteRE.lastIndex = 0;
    // eslint-disable-next-line no-control-regex
    var s = $replace.call($replace.call(str, quoteRE, '\\$1'), /[\x00-\x1f]/g, lowbyte);
    return wrapQuotes(s, 'single', opts);
}
function lowbyte(c) {
    var n = c.charCodeAt(0);
    var x = {
        8: 'b',
        9: 't',
        10: 'n',
        12: 'f',
        13: 'r'
    }[n];
    if (x) return '\\' + x;
    return '\\x' + (n < 0x10 ? '0' : '') + $toUpperCase.call(n.toString(16));
}
function markBoxed(str) {
    return 'Object(' + str + ')';
}
function weakCollectionOf(type) {
    return type + ' { ? }';
}
function collectionOf(type, size, entries, indent) {
    var joinedEntries = indent ? indentedJoin(entries, indent) : $join.call(entries, ', ');
    return type + ' (' + size + ') {' + joinedEntries + '}';
}
function singleLineValues(xs) {
    for(var i = 0; i < xs.length; i++){
        if (indexOf(xs[i], '\n') >= 0) return false;
    }
    return true;
}
function getIndent(opts, depth) {
    var baseIndent;
    if (opts.indent === '\t') baseIndent = '\t';
    else if (typeof opts.indent === 'number' && opts.indent > 0) baseIndent = $join.call(Array(opts.indent + 1), ' ');
    else return null;
    return {
        base: baseIndent,
        prev: $join.call(Array(depth + 1), baseIndent)
    };
}
function indentedJoin(xs, indent) {
    if (xs.length === 0) return '';
    var lineJoiner = '\n' + indent.prev + indent.base;
    return lineJoiner + $join.call(xs, ',' + lineJoiner) + '\n' + indent.prev;
}
function arrObjKeys(obj, inspect) {
    var isArr = isArray(obj);
    var xs = [];
    if (isArr) {
        xs.length = obj.length;
        for(var i = 0; i < obj.length; i++)xs[i] = has(obj, i) ? inspect(obj[i], obj) : '';
    }
    var syms = typeof gOPS === 'function' ? gOPS(obj) : [];
    var symMap;
    if (hasShammedSymbols) {
        symMap = {};
        for(var k = 0; k < syms.length; k++)symMap['$' + syms[k]] = syms[k];
    }
    for(var key in obj){
        if (!has(obj, key)) continue;
         // eslint-disable-line no-restricted-syntax, no-continue
        if (isArr && String(Number(key)) === key && key < obj.length) continue;
         // eslint-disable-line no-restricted-syntax, no-continue
        if (hasShammedSymbols && symMap['$' + key] instanceof Symbol) continue; // eslint-disable-line no-restricted-syntax, no-continue
        else if ($test.call(/[^\w$]/, key)) xs.push(inspect(key, obj) + ': ' + inspect(obj[key], obj));
        else xs.push(key + ': ' + inspect(obj[key], obj));
    }
    if (typeof gOPS === 'function') {
        for(var j = 0; j < syms.length; j++)if (isEnumerable.call(obj, syms[j])) xs.push('[' + inspect(syms[j]) + ']: ' + inspect(obj[syms[j]], obj));
    }
    return xs;
}

},{"21d2abed798fa1b1":"ff77X"}],"ff77X":[function(require,module,exports,__globalThis) {
"use strict";

},{}],"fjNyp":[function(require,module,exports,__globalThis) {
'use strict';
var inspect = require("e8fff6efeb527f68");
var $TypeError = require("ea03598dfd525c19");
/*
* This function traverses the list returning the node corresponding to the given key.
*
* That node is also moved to the head of the list, so that if it's accessed again we don't need to traverse the whole list.
* By doing so, all the recently used nodes can be accessed relatively quickly.
*/ /** @type {import('./list.d.ts').listGetNode} */ // eslint-disable-next-line consistent-return
var listGetNode = function(list, key, isDelete) {
    /** @type {typeof list | NonNullable<(typeof list)['next']>} */ var prev = list;
    /** @type {(typeof list)['next']} */ var curr;
    // eslint-disable-next-line eqeqeq
    for(; (curr = prev.next) != null; prev = curr)if (curr.key === key) {
        prev.next = curr.next;
        if (!isDelete) {
            // eslint-disable-next-line no-extra-parens
            curr.next = /** @type {NonNullable<typeof list.next>} */ list.next;
            list.next = curr; // eslint-disable-line no-param-reassign
        }
        return curr;
    }
};
/** @type {import('./list.d.ts').listGet} */ var listGet = function(objects, key) {
    if (!objects) return void 0;
    var node = listGetNode(objects, key);
    return node && node.value;
};
/** @type {import('./list.d.ts').listSet} */ var listSet = function(objects, key, value) {
    var node = listGetNode(objects, key);
    if (node) node.value = value;
    else // Prepend the new node to the beginning of the list
    objects.next = /** @type {import('./list.d.ts').ListNode<typeof value, typeof key>} */ {
        key: key,
        next: objects.next,
        value: value
    };
};
/** @type {import('./list.d.ts').listHas} */ var listHas = function(objects, key) {
    if (!objects) return false;
    return !!listGetNode(objects, key);
};
/** @type {import('./list.d.ts').listDelete} */ // eslint-disable-next-line consistent-return
var listDelete = function(objects, key) {
    if (objects) return listGetNode(objects, key, true);
};
/** @type {import('.')} */ module.exports = function getSideChannelList() {
    /** @typedef {ReturnType<typeof getSideChannelList>} Channel */ /** @typedef {Parameters<Channel['get']>[0]} K */ /** @typedef {Parameters<Channel['set']>[1]} V */ /** @type {import('./list.d.ts').RootNode<V, K> | undefined} */ var $o;
    /** @type {Channel} */ var channel = {
        assert: function(key) {
            if (!channel.has(key)) throw new $TypeError('Side channel does not contain ' + inspect(key));
        },
        'delete': function(key) {
            var root = $o && $o.next;
            var deletedNode = listDelete($o, key);
            if (deletedNode && root && root === deletedNode) $o = void 0;
            return !!deletedNode;
        },
        get: function(key) {
            return listGet($o, key);
        },
        has: function(key) {
            return listHas($o, key);
        },
        set: function(key, value) {
            if (!$o) // Initialize the linked list as an empty node, so that we don't have to special-case handling of the first node: we can always refer to it as (previous node).next, instead of something like (list).head
            $o = {
                next: void 0
            };
            // eslint-disable-next-line no-extra-parens
            listSet(/** @type {NonNullable<typeof $o>} */ $o, key, value);
        }
    };
    // @ts-expect-error TODO: figure out why this is erroring
    return channel;
};

},{"e8fff6efeb527f68":"7Q8uX","ea03598dfd525c19":"b7cTX"}],"7k9aI":[function(require,module,exports,__globalThis) {
'use strict';
var GetIntrinsic = require("d2d0f8e9b89d5e25");
var callBound = require("c3c8fc8c93a46333");
var inspect = require("227b49577d38a398");
var $TypeError = require("14e06bea5c686b8e");
var $Map = GetIntrinsic('%Map%', true);
/** @type {<K, V>(thisArg: Map<K, V>, key: K) => V} */ var $mapGet = callBound('Map.prototype.get', true);
/** @type {<K, V>(thisArg: Map<K, V>, key: K, value: V) => void} */ var $mapSet = callBound('Map.prototype.set', true);
/** @type {<K, V>(thisArg: Map<K, V>, key: K) => boolean} */ var $mapHas = callBound('Map.prototype.has', true);
/** @type {<K, V>(thisArg: Map<K, V>, key: K) => boolean} */ var $mapDelete = callBound('Map.prototype.delete', true);
/** @type {<K, V>(thisArg: Map<K, V>) => number} */ var $mapSize = callBound('Map.prototype.size', true);
/** @type {import('.')} */ module.exports = !!$Map && /** @type {Exclude<import('.'), false>} */ function getSideChannelMap() {
    /** @typedef {ReturnType<typeof getSideChannelMap>} Channel */ /** @typedef {Parameters<Channel['get']>[0]} K */ /** @typedef {Parameters<Channel['set']>[1]} V */ /** @type {Map<K, V> | undefined} */ var $m;
    /** @type {Channel} */ var channel = {
        assert: function(key) {
            if (!channel.has(key)) throw new $TypeError('Side channel does not contain ' + inspect(key));
        },
        'delete': function(key) {
            if ($m) {
                var result = $mapDelete($m, key);
                if ($mapSize($m) === 0) $m = void 0;
                return result;
            }
            return false;
        },
        get: function(key) {
            if ($m) return $mapGet($m, key);
        },
        has: function(key) {
            if ($m) return $mapHas($m, key);
            return false;
        },
        set: function(key, value) {
            if (!$m) // @ts-expect-error TS can't handle narrowing a variable inside a closure
            $m = new $Map();
            $mapSet($m, key, value);
        }
    };
    // @ts-expect-error TODO: figure out why TS is erroring here
    return channel;
};

},{"d2d0f8e9b89d5e25":"jKgsa","c3c8fc8c93a46333":"1TuCR","227b49577d38a398":"7Q8uX","14e06bea5c686b8e":"b7cTX"}],"jKgsa":[function(require,module,exports,__globalThis) {
'use strict';
var undefined1;
var $Object = require("e41a5a3e999516b6");
var $Error = require("103f9da07d3e7f45");
var $EvalError = require("1e50d3d5f4a25b15");
var $RangeError = require("b138af87c2dff632");
var $ReferenceError = require("f7528e7ac4b4b9d9");
var $SyntaxError = require("fd0fb76a774f1532");
var $TypeError = require("a16f7fadd8e8eb4f");
var $URIError = require("d999fedf05773b17");
var abs = require("da73da030413d747");
var floor = require("c34496386617b34b");
var max = require("8d522b2bcecf3bbc");
var min = require("5eed0c547f78dce");
var pow = require("b426498c2ca2f836");
var round = require("a90d3fa4b5d97c20");
var sign = require("d335a3c747eb5afb");
var $Function = Function;
// eslint-disable-next-line consistent-return
var getEvalledConstructor = function(expressionSyntax) {
    try {
        return $Function('"use strict"; return (' + expressionSyntax + ').constructor;')();
    } catch (e) {}
};
var $gOPD = require("97a5ad18632569f5");
var $defineProperty = require("a0adc84c55230789");
var throwTypeError = function() {
    throw new $TypeError();
};
var ThrowTypeError = $gOPD ? function() {
    try {
        // eslint-disable-next-line no-unused-expressions, no-caller, no-restricted-properties
        arguments.callee; // IE 8 does not throw here
        return throwTypeError;
    } catch (calleeThrows) {
        try {
            // IE 8 throws on Object.getOwnPropertyDescriptor(arguments, '')
            return $gOPD(arguments, 'callee').get;
        } catch (gOPDthrows) {
            return throwTypeError;
        }
    }
}() : throwTypeError;
var hasSymbols = require("f5767b6172da5c14")();
var getProto = require("d8fdcf083489e29e");
var $ObjectGPO = require("5c794b30527d26a5");
var $ReflectGPO = require("72bf26be6ea904f2");
var $apply = require("215639c5976477c3");
var $call = require("be7b0d6132f990e4");
var needsEval = {};
var TypedArray = typeof Uint8Array === 'undefined' || !getProto ? undefined : getProto(Uint8Array);
var INTRINSICS = {
    __proto__: null,
    '%AggregateError%': typeof AggregateError === 'undefined' ? undefined : AggregateError,
    '%Array%': Array,
    '%ArrayBuffer%': typeof ArrayBuffer === 'undefined' ? undefined : ArrayBuffer,
    '%ArrayIteratorPrototype%': hasSymbols && getProto ? getProto([][Symbol.iterator]()) : undefined,
    '%AsyncFromSyncIteratorPrototype%': undefined,
    '%AsyncFunction%': needsEval,
    '%AsyncGenerator%': needsEval,
    '%AsyncGeneratorFunction%': needsEval,
    '%AsyncIteratorPrototype%': needsEval,
    '%Atomics%': typeof Atomics === 'undefined' ? undefined : Atomics,
    '%BigInt%': typeof BigInt === 'undefined' ? undefined : BigInt,
    '%BigInt64Array%': typeof BigInt64Array === 'undefined' ? undefined : BigInt64Array,
    '%BigUint64Array%': typeof BigUint64Array === 'undefined' ? undefined : BigUint64Array,
    '%Boolean%': Boolean,
    '%DataView%': typeof DataView === 'undefined' ? undefined : DataView,
    '%Date%': Date,
    '%decodeURI%': decodeURI,
    '%decodeURIComponent%': decodeURIComponent,
    '%encodeURI%': encodeURI,
    '%encodeURIComponent%': encodeURIComponent,
    '%Error%': $Error,
    '%eval%': eval,
    '%EvalError%': $EvalError,
    '%Float16Array%': typeof Float16Array === 'undefined' ? undefined : Float16Array,
    '%Float32Array%': typeof Float32Array === 'undefined' ? undefined : Float32Array,
    '%Float64Array%': typeof Float64Array === 'undefined' ? undefined : Float64Array,
    '%FinalizationRegistry%': typeof FinalizationRegistry === 'undefined' ? undefined : FinalizationRegistry,
    '%Function%': $Function,
    '%GeneratorFunction%': needsEval,
    '%Int8Array%': typeof Int8Array === 'undefined' ? undefined : Int8Array,
    '%Int16Array%': typeof Int16Array === 'undefined' ? undefined : Int16Array,
    '%Int32Array%': typeof Int32Array === 'undefined' ? undefined : Int32Array,
    '%isFinite%': isFinite,
    '%isNaN%': isNaN,
    '%IteratorPrototype%': hasSymbols && getProto ? getProto(getProto([][Symbol.iterator]())) : undefined,
    '%JSON%': typeof JSON === 'object' ? JSON : undefined,
    '%Map%': typeof Map === 'undefined' ? undefined : Map,
    '%MapIteratorPrototype%': typeof Map === 'undefined' || !hasSymbols || !getProto ? undefined : getProto(new Map()[Symbol.iterator]()),
    '%Math%': Math,
    '%Number%': Number,
    '%Object%': $Object,
    '%Object.getOwnPropertyDescriptor%': $gOPD,
    '%parseFloat%': parseFloat,
    '%parseInt%': parseInt,
    '%Promise%': typeof Promise === 'undefined' ? undefined : Promise,
    '%Proxy%': typeof Proxy === 'undefined' ? undefined : Proxy,
    '%RangeError%': $RangeError,
    '%ReferenceError%': $ReferenceError,
    '%Reflect%': typeof Reflect === 'undefined' ? undefined : Reflect,
    '%RegExp%': RegExp,
    '%Set%': typeof Set === 'undefined' ? undefined : Set,
    '%SetIteratorPrototype%': typeof Set === 'undefined' || !hasSymbols || !getProto ? undefined : getProto(new Set()[Symbol.iterator]()),
    '%SharedArrayBuffer%': typeof SharedArrayBuffer === 'undefined' ? undefined : SharedArrayBuffer,
    '%String%': String,
    '%StringIteratorPrototype%': hasSymbols && getProto ? getProto(''[Symbol.iterator]()) : undefined,
    '%Symbol%': hasSymbols ? Symbol : undefined,
    '%SyntaxError%': $SyntaxError,
    '%ThrowTypeError%': ThrowTypeError,
    '%TypedArray%': TypedArray,
    '%TypeError%': $TypeError,
    '%Uint8Array%': typeof Uint8Array === 'undefined' ? undefined : Uint8Array,
    '%Uint8ClampedArray%': typeof Uint8ClampedArray === 'undefined' ? undefined : Uint8ClampedArray,
    '%Uint16Array%': typeof Uint16Array === 'undefined' ? undefined : Uint16Array,
    '%Uint32Array%': typeof Uint32Array === 'undefined' ? undefined : Uint32Array,
    '%URIError%': $URIError,
    '%WeakMap%': typeof WeakMap === 'undefined' ? undefined : WeakMap,
    '%WeakRef%': typeof WeakRef === 'undefined' ? undefined : WeakRef,
    '%WeakSet%': typeof WeakSet === 'undefined' ? undefined : WeakSet,
    '%Function.prototype.call%': $call,
    '%Function.prototype.apply%': $apply,
    '%Object.defineProperty%': $defineProperty,
    '%Object.getPrototypeOf%': $ObjectGPO,
    '%Math.abs%': abs,
    '%Math.floor%': floor,
    '%Math.max%': max,
    '%Math.min%': min,
    '%Math.pow%': pow,
    '%Math.round%': round,
    '%Math.sign%': sign,
    '%Reflect.getPrototypeOf%': $ReflectGPO
};
if (getProto) try {
    null.error; // eslint-disable-line no-unused-expressions
} catch (e) {
    // https://github.com/tc39/proposal-shadowrealm/pull/384#issuecomment-1364264229
    var errorProto = getProto(getProto(e));
    INTRINSICS['%Error.prototype%'] = errorProto;
}
var doEval = function doEval(name) {
    var value;
    if (name === '%AsyncFunction%') value = getEvalledConstructor('async function () {}');
    else if (name === '%GeneratorFunction%') value = getEvalledConstructor('function* () {}');
    else if (name === '%AsyncGeneratorFunction%') value = getEvalledConstructor('async function* () {}');
    else if (name === '%AsyncGenerator%') {
        var fn = doEval('%AsyncGeneratorFunction%');
        if (fn) value = fn.prototype;
    } else if (name === '%AsyncIteratorPrototype%') {
        var gen = doEval('%AsyncGenerator%');
        if (gen && getProto) value = getProto(gen.prototype);
    }
    INTRINSICS[name] = value;
    return value;
};
var LEGACY_ALIASES = {
    __proto__: null,
    '%ArrayBufferPrototype%': [
        'ArrayBuffer',
        'prototype'
    ],
    '%ArrayPrototype%': [
        'Array',
        'prototype'
    ],
    '%ArrayProto_entries%': [
        'Array',
        'prototype',
        'entries'
    ],
    '%ArrayProto_forEach%': [
        'Array',
        'prototype',
        'forEach'
    ],
    '%ArrayProto_keys%': [
        'Array',
        'prototype',
        'keys'
    ],
    '%ArrayProto_values%': [
        'Array',
        'prototype',
        'values'
    ],
    '%AsyncFunctionPrototype%': [
        'AsyncFunction',
        'prototype'
    ],
    '%AsyncGenerator%': [
        'AsyncGeneratorFunction',
        'prototype'
    ],
    '%AsyncGeneratorPrototype%': [
        'AsyncGeneratorFunction',
        'prototype',
        'prototype'
    ],
    '%BooleanPrototype%': [
        'Boolean',
        'prototype'
    ],
    '%DataViewPrototype%': [
        'DataView',
        'prototype'
    ],
    '%DatePrototype%': [
        'Date',
        'prototype'
    ],
    '%ErrorPrototype%': [
        'Error',
        'prototype'
    ],
    '%EvalErrorPrototype%': [
        'EvalError',
        'prototype'
    ],
    '%Float32ArrayPrototype%': [
        'Float32Array',
        'prototype'
    ],
    '%Float64ArrayPrototype%': [
        'Float64Array',
        'prototype'
    ],
    '%FunctionPrototype%': [
        'Function',
        'prototype'
    ],
    '%Generator%': [
        'GeneratorFunction',
        'prototype'
    ],
    '%GeneratorPrototype%': [
        'GeneratorFunction',
        'prototype',
        'prototype'
    ],
    '%Int8ArrayPrototype%': [
        'Int8Array',
        'prototype'
    ],
    '%Int16ArrayPrototype%': [
        'Int16Array',
        'prototype'
    ],
    '%Int32ArrayPrototype%': [
        'Int32Array',
        'prototype'
    ],
    '%JSONParse%': [
        'JSON',
        'parse'
    ],
    '%JSONStringify%': [
        'JSON',
        'stringify'
    ],
    '%MapPrototype%': [
        'Map',
        'prototype'
    ],
    '%NumberPrototype%': [
        'Number',
        'prototype'
    ],
    '%ObjectPrototype%': [
        'Object',
        'prototype'
    ],
    '%ObjProto_toString%': [
        'Object',
        'prototype',
        'toString'
    ],
    '%ObjProto_valueOf%': [
        'Object',
        'prototype',
        'valueOf'
    ],
    '%PromisePrototype%': [
        'Promise',
        'prototype'
    ],
    '%PromiseProto_then%': [
        'Promise',
        'prototype',
        'then'
    ],
    '%Promise_all%': [
        'Promise',
        'all'
    ],
    '%Promise_reject%': [
        'Promise',
        'reject'
    ],
    '%Promise_resolve%': [
        'Promise',
        'resolve'
    ],
    '%RangeErrorPrototype%': [
        'RangeError',
        'prototype'
    ],
    '%ReferenceErrorPrototype%': [
        'ReferenceError',
        'prototype'
    ],
    '%RegExpPrototype%': [
        'RegExp',
        'prototype'
    ],
    '%SetPrototype%': [
        'Set',
        'prototype'
    ],
    '%SharedArrayBufferPrototype%': [
        'SharedArrayBuffer',
        'prototype'
    ],
    '%StringPrototype%': [
        'String',
        'prototype'
    ],
    '%SymbolPrototype%': [
        'Symbol',
        'prototype'
    ],
    '%SyntaxErrorPrototype%': [
        'SyntaxError',
        'prototype'
    ],
    '%TypedArrayPrototype%': [
        'TypedArray',
        'prototype'
    ],
    '%TypeErrorPrototype%': [
        'TypeError',
        'prototype'
    ],
    '%Uint8ArrayPrototype%': [
        'Uint8Array',
        'prototype'
    ],
    '%Uint8ClampedArrayPrototype%': [
        'Uint8ClampedArray',
        'prototype'
    ],
    '%Uint16ArrayPrototype%': [
        'Uint16Array',
        'prototype'
    ],
    '%Uint32ArrayPrototype%': [
        'Uint32Array',
        'prototype'
    ],
    '%URIErrorPrototype%': [
        'URIError',
        'prototype'
    ],
    '%WeakMapPrototype%': [
        'WeakMap',
        'prototype'
    ],
    '%WeakSetPrototype%': [
        'WeakSet',
        'prototype'
    ]
};
var bind = require("ed7c34829f8d2a08");
var hasOwn = require("2a037d4c46ae2d2");
var $concat = bind.call($call, Array.prototype.concat);
var $spliceApply = bind.call($apply, Array.prototype.splice);
var $replace = bind.call($call, String.prototype.replace);
var $strSlice = bind.call($call, String.prototype.slice);
var $exec = bind.call($call, RegExp.prototype.exec);
/* adapted from https://github.com/lodash/lodash/blob/4.17.15/dist/lodash.js#L6735-L6744 */ var rePropName = /[^%.[\]]+|\[(?:(-?\d+(?:\.\d+)?)|(["'])((?:(?!\2)[^\\]|\\.)*?)\2)\]|(?=(?:\.|\[\])(?:\.|\[\]|%$))/g;
var reEscapeChar = /\\(\\)?/g; /** Used to match backslashes in property paths. */ 
var stringToPath = function stringToPath(string) {
    var first = $strSlice(string, 0, 1);
    var last = $strSlice(string, -1);
    if (first === '%' && last !== '%') throw new $SyntaxError('invalid intrinsic syntax, expected closing `%`');
    else if (last === '%' && first !== '%') throw new $SyntaxError('invalid intrinsic syntax, expected opening `%`');
    var result = [];
    $replace(string, rePropName, function(match, number, quote, subString) {
        result[result.length] = quote ? $replace(subString, reEscapeChar, '$1') : number || match;
    });
    return result;
};
/* end adaptation */ var getBaseIntrinsic = function getBaseIntrinsic(name, allowMissing) {
    var intrinsicName = name;
    var alias;
    if (hasOwn(LEGACY_ALIASES, intrinsicName)) {
        alias = LEGACY_ALIASES[intrinsicName];
        intrinsicName = '%' + alias[0] + '%';
    }
    if (hasOwn(INTRINSICS, intrinsicName)) {
        var value = INTRINSICS[intrinsicName];
        if (value === needsEval) value = doEval(intrinsicName);
        if (typeof value === 'undefined' && !allowMissing) throw new $TypeError('intrinsic ' + name + ' exists, but is not available. Please file an issue!');
        return {
            alias: alias,
            name: intrinsicName,
            value: value
        };
    }
    throw new $SyntaxError('intrinsic ' + name + ' does not exist!');
};
module.exports = function GetIntrinsic(name, allowMissing) {
    if (typeof name !== 'string' || name.length === 0) throw new $TypeError('intrinsic name must be a non-empty string');
    if (arguments.length > 1 && typeof allowMissing !== 'boolean') throw new $TypeError('"allowMissing" argument must be a boolean');
    if ($exec(/^%?[^%]*%?$/, name) === null) throw new $SyntaxError('`%` may not be present anywhere but at the beginning and end of the intrinsic name');
    var parts = stringToPath(name);
    var intrinsicBaseName = parts.length > 0 ? parts[0] : '';
    var intrinsic = getBaseIntrinsic('%' + intrinsicBaseName + '%', allowMissing);
    var intrinsicRealName = intrinsic.name;
    var value = intrinsic.value;
    var skipFurtherCaching = false;
    var alias = intrinsic.alias;
    if (alias) {
        intrinsicBaseName = alias[0];
        $spliceApply(parts, $concat([
            0,
            1
        ], alias));
    }
    for(var i = 1, isOwn = true; i < parts.length; i += 1){
        var part = parts[i];
        var first = $strSlice(part, 0, 1);
        var last = $strSlice(part, -1);
        if ((first === '"' || first === "'" || first === '`' || last === '"' || last === "'" || last === '`') && first !== last) throw new $SyntaxError('property names with quotes must have matching quotes');
        if (part === 'constructor' || !isOwn) skipFurtherCaching = true;
        intrinsicBaseName += '.' + part;
        intrinsicRealName = '%' + intrinsicBaseName + '%';
        if (hasOwn(INTRINSICS, intrinsicRealName)) value = INTRINSICS[intrinsicRealName];
        else if (value != null) {
            if (!(part in value)) {
                if (!allowMissing) throw new $TypeError('base intrinsic for ' + name + ' exists, but the property is not available.');
                return void 0;
            }
            if ($gOPD && i + 1 >= parts.length) {
                var desc = $gOPD(value, part);
                isOwn = !!desc;
                // By convention, when a data property is converted to an accessor
                // property to emulate a data property that does not suffer from
                // the override mistake, that accessor's getter is marked with
                // an `originalValue` property. Here, when we detect this, we
                // uphold the illusion by pretending to see that original data
                // property, i.e., returning the value rather than the getter
                // itself.
                if (isOwn && 'get' in desc && !('originalValue' in desc.get)) value = desc.get;
                else value = value[part];
            } else {
                isOwn = hasOwn(value, part);
                value = value[part];
            }
            if (isOwn && !skipFurtherCaching) INTRINSICS[intrinsicRealName] = value;
        }
    }
    return value;
};

},{"e41a5a3e999516b6":"iEBsj","103f9da07d3e7f45":"bOabc","1e50d3d5f4a25b15":"KcLkP","b138af87c2dff632":"3E69e","f7528e7ac4b4b9d9":"1cYSH","fd0fb76a774f1532":"17gLG","a16f7fadd8e8eb4f":"b7cTX","d999fedf05773b17":"dGOCy","da73da030413d747":"gEspM","c34496386617b34b":"h4a7n","8d522b2bcecf3bbc":"1HQxY","5eed0c547f78dce":"43JFk","b426498c2ca2f836":"dZTau","a90d3fa4b5d97c20":"drTbd","d335a3c747eb5afb":"d4EMN","97a5ad18632569f5":"2guZM","a0adc84c55230789":"boEiC","f5767b6172da5c14":"h7Gzm","d8fdcf083489e29e":"aLUPd","5c794b30527d26a5":"9xAbd","72bf26be6ea904f2":"6MtNN","215639c5976477c3":"iH1pv","be7b0d6132f990e4":"fbnic","ed7c34829f8d2a08":"8Aqbj","2a037d4c46ae2d2":"iMV7B"}],"iEBsj":[function(require,module,exports,__globalThis) {
'use strict';
/** @type {import('.')} */ module.exports = Object;

},{}],"bOabc":[function(require,module,exports,__globalThis) {
'use strict';
/** @type {import('.')} */ module.exports = Error;

},{}],"KcLkP":[function(require,module,exports,__globalThis) {
'use strict';
/** @type {import('./eval')} */ module.exports = EvalError;

},{}],"3E69e":[function(require,module,exports,__globalThis) {
'use strict';
/** @type {import('./range')} */ module.exports = RangeError;

},{}],"1cYSH":[function(require,module,exports,__globalThis) {
'use strict';
/** @type {import('./ref')} */ module.exports = ReferenceError;

},{}],"17gLG":[function(require,module,exports,__globalThis) {
'use strict';
/** @type {import('./syntax')} */ module.exports = SyntaxError;

},{}],"dGOCy":[function(require,module,exports,__globalThis) {
'use strict';
/** @type {import('./uri')} */ module.exports = URIError;

},{}],"gEspM":[function(require,module,exports,__globalThis) {
'use strict';
/** @type {import('./abs')} */ module.exports = Math.abs;

},{}],"h4a7n":[function(require,module,exports,__globalThis) {
'use strict';
/** @type {import('./floor')} */ module.exports = Math.floor;

},{}],"1HQxY":[function(require,module,exports,__globalThis) {
'use strict';
/** @type {import('./max')} */ module.exports = Math.max;

},{}],"43JFk":[function(require,module,exports,__globalThis) {
'use strict';
/** @type {import('./min')} */ module.exports = Math.min;

},{}],"dZTau":[function(require,module,exports,__globalThis) {
'use strict';
/** @type {import('./pow')} */ module.exports = Math.pow;

},{}],"drTbd":[function(require,module,exports,__globalThis) {
'use strict';
/** @type {import('./round')} */ module.exports = Math.round;

},{}],"d4EMN":[function(require,module,exports,__globalThis) {
'use strict';
var $isNaN = require("4ec1fffd62fdb5f2");
/** @type {import('./sign')} */ module.exports = function sign(number) {
    if ($isNaN(number) || number === 0) return number;
    return number < 0 ? -1 : 1;
};

},{"4ec1fffd62fdb5f2":"p1VF0"}],"p1VF0":[function(require,module,exports,__globalThis) {
'use strict';
/** @type {import('./isNaN')} */ module.exports = Number.isNaN || function isNaN(a) {
    return a !== a;
};

},{}],"2guZM":[function(require,module,exports,__globalThis) {
'use strict';
/** @type {import('.')} */ var $gOPD = require("fc056afb487471c");
if ($gOPD) try {
    $gOPD([], 'length');
} catch (e) {
    // IE 8 has a broken gOPD
    $gOPD = null;
}
module.exports = $gOPD;

},{"fc056afb487471c":"kZKWT"}],"kZKWT":[function(require,module,exports,__globalThis) {
'use strict';
/** @type {import('./gOPD')} */ module.exports = Object.getOwnPropertyDescriptor;

},{}],"boEiC":[function(require,module,exports,__globalThis) {
'use strict';
/** @type {import('.')} */ var $defineProperty = Object.defineProperty || false;
if ($defineProperty) try {
    $defineProperty({}, 'a', {
        value: 1
    });
} catch (e) {
    // IE 8 has a broken defineProperty
    $defineProperty = false;
}
module.exports = $defineProperty;

},{}],"h7Gzm":[function(require,module,exports,__globalThis) {
'use strict';
var origSymbol = typeof Symbol !== 'undefined' && Symbol;
var hasSymbolSham = require("e12ff2e3aceb19c1");
/** @type {import('.')} */ module.exports = function hasNativeSymbols() {
    if (typeof origSymbol !== 'function') return false;
    if (typeof Symbol !== 'function') return false;
    if (typeof origSymbol('foo') !== 'symbol') return false;
    if (typeof Symbol('bar') !== 'symbol') return false;
    return hasSymbolSham();
};

},{"e12ff2e3aceb19c1":"jZ394"}],"jZ394":[function(require,module,exports,__globalThis) {
'use strict';
/** @type {import('./shams')} */ /* eslint complexity: [2, 18], max-statements: [2, 33] */ module.exports = function hasSymbols() {
    if (typeof Symbol !== 'function' || typeof Object.getOwnPropertySymbols !== 'function') return false;
    if (typeof Symbol.iterator === 'symbol') return true;
    /** @type {{ [k in symbol]?: unknown }} */ var obj = {};
    var sym = Symbol('test');
    var symObj = Object(sym);
    if (typeof sym === 'string') return false;
    if (Object.prototype.toString.call(sym) !== '[object Symbol]') return false;
    if (Object.prototype.toString.call(symObj) !== '[object Symbol]') return false;
    // temp disabled per https://github.com/ljharb/object.assign/issues/17
    // if (sym instanceof Symbol) { return false; }
    // temp disabled per https://github.com/WebReflection/get-own-property-symbols/issues/4
    // if (!(symObj instanceof Symbol)) { return false; }
    // if (typeof Symbol.prototype.toString !== 'function') { return false; }
    // if (String(sym) !== Symbol.prototype.toString.call(sym)) { return false; }
    var symVal = 42;
    obj[sym] = symVal;
    for(var _ in obj)return false;
     // eslint-disable-line no-restricted-syntax, no-unreachable-loop
    if (typeof Object.keys === 'function' && Object.keys(obj).length !== 0) return false;
    if (typeof Object.getOwnPropertyNames === 'function' && Object.getOwnPropertyNames(obj).length !== 0) return false;
    var syms = Object.getOwnPropertySymbols(obj);
    if (syms.length !== 1 || syms[0] !== sym) return false;
    if (!Object.prototype.propertyIsEnumerable.call(obj, sym)) return false;
    if (typeof Object.getOwnPropertyDescriptor === 'function') {
        // eslint-disable-next-line no-extra-parens
        var descriptor = /** @type {PropertyDescriptor} */ Object.getOwnPropertyDescriptor(obj, sym);
        if (descriptor.value !== symVal || descriptor.enumerable !== true) return false;
    }
    return true;
};

},{}],"aLUPd":[function(require,module,exports,__globalThis) {
'use strict';
var reflectGetProto = require("b4081b9d1172d7d9");
var originalGetProto = require("27903a86a69caa75");
var getDunderProto = require("7323a2e8b34c4403");
/** @type {import('.')} */ module.exports = reflectGetProto ? function getProto(O) {
    // @ts-expect-error TS can't narrow inside a closure, for some reason
    return reflectGetProto(O);
} : originalGetProto ? function getProto(O) {
    if (!O || typeof O !== 'object' && typeof O !== 'function') throw new TypeError('getProto: not an object');
    // @ts-expect-error TS can't narrow inside a closure, for some reason
    return originalGetProto(O);
} : getDunderProto ? function getProto(O) {
    // @ts-expect-error TS can't narrow inside a closure, for some reason
    return getDunderProto(O);
} : null;

},{"b4081b9d1172d7d9":"6MtNN","27903a86a69caa75":"9xAbd","7323a2e8b34c4403":"2ZVzu"}],"6MtNN":[function(require,module,exports,__globalThis) {
'use strict';
/** @type {import('./Reflect.getPrototypeOf')} */ module.exports = typeof Reflect !== 'undefined' && Reflect.getPrototypeOf || null;

},{}],"9xAbd":[function(require,module,exports,__globalThis) {
'use strict';
var $Object = require("8bc569d3a4b118a");
/** @type {import('./Object.getPrototypeOf')} */ module.exports = $Object.getPrototypeOf || null;

},{"8bc569d3a4b118a":"iEBsj"}],"2ZVzu":[function(require,module,exports,__globalThis) {
'use strict';
var callBind = require("92485db4f0264468");
var gOPD = require("8af404c960ac1257");
var hasProtoAccessor;
try {
    // eslint-disable-next-line no-extra-parens, no-proto
    hasProtoAccessor = /** @type {{ __proto__?: typeof Array.prototype }} */ [].__proto__ === Array.prototype;
} catch (e) {
    if (!e || typeof e !== 'object' || !('code' in e) || e.code !== 'ERR_PROTO_ACCESS') throw e;
}
// eslint-disable-next-line no-extra-parens
var desc = !!hasProtoAccessor && gOPD && gOPD(Object.prototype, /** @type {keyof typeof Object.prototype} */ '__proto__');
var $Object = Object;
var $getPrototypeOf = $Object.getPrototypeOf;
/** @type {import('./get')} */ module.exports = desc && typeof desc.get === 'function' ? callBind([
    desc.get
]) : typeof $getPrototypeOf === 'function' ? /** @type {import('./get')} */ function getDunder(value) {
    // eslint-disable-next-line eqeqeq
    return $getPrototypeOf(value == null ? value : $Object(value));
} : false;

},{"92485db4f0264468":"472ie","8af404c960ac1257":"2guZM"}],"472ie":[function(require,module,exports,__globalThis) {
'use strict';
var bind = require("da52337437fea6fc");
var $TypeError = require("88ab33fc00af6cf1");
var $call = require("3e9a2c1249f851e1");
var $actualApply = require("bd412a18560db761");
/** @type {(args: [Function, thisArg?: unknown, ...args: unknown[]]) => Function} TODO FIXME, find a way to use import('.') */ module.exports = function callBindBasic(args) {
    if (args.length < 1 || typeof args[0] !== 'function') throw new $TypeError('a function is required');
    return $actualApply(bind, $call, args);
};

},{"da52337437fea6fc":"8Aqbj","88ab33fc00af6cf1":"b7cTX","3e9a2c1249f851e1":"fbnic","bd412a18560db761":"7wOlu"}],"8Aqbj":[function(require,module,exports,__globalThis) {
'use strict';
var implementation = require("34c777c27f69cb90");
module.exports = Function.prototype.bind || implementation;

},{"34c777c27f69cb90":"guYAs"}],"guYAs":[function(require,module,exports,__globalThis) {
'use strict';
/* eslint no-invalid-this: 1 */ var ERROR_MESSAGE = 'Function.prototype.bind called on incompatible ';
var toStr = Object.prototype.toString;
var max = Math.max;
var funcType = '[object Function]';
var concatty = function concatty(a, b) {
    var arr = [];
    for(var i = 0; i < a.length; i += 1)arr[i] = a[i];
    for(var j = 0; j < b.length; j += 1)arr[j + a.length] = b[j];
    return arr;
};
var slicy = function slicy(arrLike, offset) {
    var arr = [];
    for(var i = offset || 0, j = 0; i < arrLike.length; i += 1, j += 1)arr[j] = arrLike[i];
    return arr;
};
var joiny = function(arr, joiner) {
    var str = '';
    for(var i = 0; i < arr.length; i += 1){
        str += arr[i];
        if (i + 1 < arr.length) str += joiner;
    }
    return str;
};
module.exports = function bind(that) {
    var target = this;
    if (typeof target !== 'function' || toStr.apply(target) !== funcType) throw new TypeError(ERROR_MESSAGE + target);
    var args = slicy(arguments, 1);
    var bound;
    var binder = function() {
        if (this instanceof bound) {
            var result = target.apply(this, concatty(args, arguments));
            if (Object(result) === result) return result;
            return this;
        }
        return target.apply(that, concatty(args, arguments));
    };
    var boundLength = max(0, target.length - args.length);
    var boundArgs = [];
    for(var i = 0; i < boundLength; i++)boundArgs[i] = '$' + i;
    bound = Function('binder', 'return function (' + joiny(boundArgs, ',') + '){ return binder.apply(this,arguments); }')(binder);
    if (target.prototype) {
        var Empty = function Empty() {};
        Empty.prototype = target.prototype;
        bound.prototype = new Empty();
        Empty.prototype = null;
    }
    return bound;
};

},{}],"fbnic":[function(require,module,exports,__globalThis) {
'use strict';
/** @type {import('./functionCall')} */ module.exports = Function.prototype.call;

},{}],"7wOlu":[function(require,module,exports,__globalThis) {
'use strict';
var bind = require("291ee3885df1b263");
var $apply = require("862b2bd7a1211fd6");
var $call = require("f4e342a4bc43db75");
var $reflectApply = require("572ac72825c3ee26");
/** @type {import('./actualApply')} */ module.exports = $reflectApply || bind.call($call, $apply);

},{"291ee3885df1b263":"8Aqbj","862b2bd7a1211fd6":"iH1pv","f4e342a4bc43db75":"fbnic","572ac72825c3ee26":"gSOsJ"}],"iH1pv":[function(require,module,exports,__globalThis) {
'use strict';
/** @type {import('./functionApply')} */ module.exports = Function.prototype.apply;

},{}],"gSOsJ":[function(require,module,exports,__globalThis) {
'use strict';
/** @type {import('./reflectApply')} */ module.exports = typeof Reflect !== 'undefined' && Reflect && Reflect.apply;

},{}],"iMV7B":[function(require,module,exports,__globalThis) {
'use strict';
var call = Function.prototype.call;
var $hasOwn = Object.prototype.hasOwnProperty;
var bind = require("10e7a7bbbdab97f2");
/** @type {import('.')} */ module.exports = bind.call(call, $hasOwn);

},{"10e7a7bbbdab97f2":"8Aqbj"}],"1TuCR":[function(require,module,exports,__globalThis) {
'use strict';
var GetIntrinsic = require("7c0e12f1a29e36c7");
var callBindBasic = require("dea7f5e1ca2ecea1");
/** @type {(thisArg: string, searchString: string, position?: number) => number} */ var $indexOf = callBindBasic([
    GetIntrinsic('%String.prototype.indexOf%')
]);
/** @type {import('.')} */ module.exports = function callBoundIntrinsic(name, allowMissing) {
    /* eslint no-extra-parens: 0 */ var intrinsic = /** @type {(this: unknown, ...args: unknown[]) => unknown} */ GetIntrinsic(name, !!allowMissing);
    if (typeof intrinsic === 'function' && $indexOf(name, '.prototype.') > -1) return callBindBasic(/** @type {const} */ [
        intrinsic
    ]);
    return intrinsic;
};

},{"7c0e12f1a29e36c7":"jKgsa","dea7f5e1ca2ecea1":"472ie"}],"juGQg":[function(require,module,exports,__globalThis) {
'use strict';
var GetIntrinsic = require("f23e98a9281fc459");
var callBound = require("5e01f8c52a5bb981");
var inspect = require("dbd508e1aa4752c");
var getSideChannelMap = require("faf95bf1ef012c7a");
var $TypeError = require("7bf8a94f2c2a9be4");
var $WeakMap = GetIntrinsic('%WeakMap%', true);
/** @type {<K extends object, V>(thisArg: WeakMap<K, V>, key: K) => V} */ var $weakMapGet = callBound('WeakMap.prototype.get', true);
/** @type {<K extends object, V>(thisArg: WeakMap<K, V>, key: K, value: V) => void} */ var $weakMapSet = callBound('WeakMap.prototype.set', true);
/** @type {<K extends object, V>(thisArg: WeakMap<K, V>, key: K) => boolean} */ var $weakMapHas = callBound('WeakMap.prototype.has', true);
/** @type {<K extends object, V>(thisArg: WeakMap<K, V>, key: K) => boolean} */ var $weakMapDelete = callBound('WeakMap.prototype.delete', true);
/** @type {import('.')} */ module.exports = $WeakMap ? /** @type {Exclude<import('.'), false>} */ function getSideChannelWeakMap() {
    /** @typedef {ReturnType<typeof getSideChannelWeakMap>} Channel */ /** @typedef {Parameters<Channel['get']>[0]} K */ /** @typedef {Parameters<Channel['set']>[1]} V */ /** @type {WeakMap<K & object, V> | undefined} */ var $wm;
    /** @type {Channel | undefined} */ var $m;
    /** @type {Channel} */ var channel = {
        assert: function(key) {
            if (!channel.has(key)) throw new $TypeError('Side channel does not contain ' + inspect(key));
        },
        'delete': function(key) {
            if ($WeakMap && key && (typeof key === 'object' || typeof key === 'function')) {
                if ($wm) return $weakMapDelete($wm, key);
            } else if (getSideChannelMap) {
                if ($m) return $m['delete'](key);
            }
            return false;
        },
        get: function(key) {
            if ($WeakMap && key && (typeof key === 'object' || typeof key === 'function')) {
                if ($wm) return $weakMapGet($wm, key);
            }
            return $m && $m.get(key);
        },
        has: function(key) {
            if ($WeakMap && key && (typeof key === 'object' || typeof key === 'function')) {
                if ($wm) return $weakMapHas($wm, key);
            }
            return !!$m && $m.has(key);
        },
        set: function(key, value) {
            if ($WeakMap && key && (typeof key === 'object' || typeof key === 'function')) {
                if (!$wm) $wm = new $WeakMap();
                $weakMapSet($wm, key, value);
            } else if (getSideChannelMap) {
                if (!$m) $m = getSideChannelMap();
                // eslint-disable-next-line no-extra-parens
                /** @type {NonNullable<typeof $m>} */ $m.set(key, value);
            }
        }
    };
    // @ts-expect-error TODO: figure out why this is erroring
    return channel;
} : getSideChannelMap;

},{"f23e98a9281fc459":"jKgsa","5e01f8c52a5bb981":"1TuCR","dbd508e1aa4752c":"7Q8uX","faf95bf1ef012c7a":"7k9aI","7bf8a94f2c2a9be4":"b7cTX"}],"kD3m6":[function(require,module,exports,__globalThis) {
'use strict';
var formats = require("23c942bc74556a70");
var getSideChannel = require("735bcfe446fcc695");
var has = Object.prototype.hasOwnProperty;
var isArray = Array.isArray;
// Track objects created from arrayLimit overflow using side-channel
// Stores the current max numeric index for O(1) lookup
var overflowChannel = getSideChannel();
var markOverflow = function markOverflow(obj, maxIndex) {
    overflowChannel.set(obj, maxIndex);
    return obj;
};
var isOverflow = function isOverflow(obj) {
    return overflowChannel.has(obj);
};
var getMaxIndex = function getMaxIndex(obj) {
    return overflowChannel.get(obj);
};
var setMaxIndex = function setMaxIndex(obj, maxIndex) {
    overflowChannel.set(obj, maxIndex);
};
var hexTable = function() {
    var array = [];
    for(var i = 0; i < 256; ++i)array[array.length] = '%' + ((i < 16 ? '0' : '') + i.toString(16)).toUpperCase();
    return array;
}();
var compactQueue = function compactQueue(queue) {
    while(queue.length > 1){
        var item = queue.pop();
        var obj = item.obj[item.prop];
        if (isArray(obj)) {
            var compacted = [];
            for(var j = 0; j < obj.length; ++j)if (typeof obj[j] !== 'undefined') compacted[compacted.length] = obj[j];
            item.obj[item.prop] = compacted;
        }
    }
};
var arrayToObject = function arrayToObject(source, options) {
    var obj = options && options.plainObjects ? {
        __proto__: null
    } : {};
    for(var i = 0; i < source.length; ++i)if (typeof source[i] !== 'undefined') obj[i] = source[i];
    return obj;
};
var merge = function merge(target, source, options) {
    /* eslint no-param-reassign: 0 */ if (!source) return target;
    if (typeof source !== 'object' && typeof source !== 'function') {
        if (isArray(target)) {
            var nextIndex = target.length;
            if (options && typeof options.arrayLimit === 'number' && nextIndex > options.arrayLimit) return markOverflow(arrayToObject(target.concat(source), options), nextIndex);
            target[nextIndex] = source;
        } else if (target && typeof target === 'object') {
            if (isOverflow(target)) {
                // Add at next numeric index for overflow objects
                var newIndex = getMaxIndex(target) + 1;
                target[newIndex] = source;
                setMaxIndex(target, newIndex);
            } else if (options && options.strictMerge) return [
                target,
                source
            ];
            else if (options && (options.plainObjects || options.allowPrototypes) || !has.call(Object.prototype, source)) target[source] = true;
        } else return [
            target,
            source
        ];
        return target;
    }
    if (!target || typeof target !== 'object') {
        if (isOverflow(source)) {
            // Create new object with target at 0, source values shifted by 1
            var sourceKeys = Object.keys(source);
            var result = options && options.plainObjects ? {
                __proto__: null,
                0: target
            } : {
                0: target
            };
            for(var m = 0; m < sourceKeys.length; m++){
                var oldKey = parseInt(sourceKeys[m], 10);
                result[oldKey + 1] = source[sourceKeys[m]];
            }
            return markOverflow(result, getMaxIndex(source) + 1);
        }
        var combined = [
            target
        ].concat(source);
        if (options && typeof options.arrayLimit === 'number' && combined.length > options.arrayLimit) return markOverflow(arrayToObject(combined, options), combined.length - 1);
        return combined;
    }
    var mergeTarget = target;
    if (isArray(target) && !isArray(source)) mergeTarget = arrayToObject(target, options);
    if (isArray(target) && isArray(source)) {
        source.forEach(function(item, i) {
            if (has.call(target, i)) {
                var targetItem = target[i];
                if (targetItem && typeof targetItem === 'object' && item && typeof item === 'object') target[i] = merge(targetItem, item, options);
                else target[target.length] = item;
            } else target[i] = item;
        });
        return target;
    }
    return Object.keys(source).reduce(function(acc, key) {
        var value = source[key];
        if (has.call(acc, key)) acc[key] = merge(acc[key], value, options);
        else acc[key] = value;
        if (isOverflow(source) && !isOverflow(acc)) markOverflow(acc, getMaxIndex(source));
        if (isOverflow(acc)) {
            var keyNum = parseInt(key, 10);
            if (String(keyNum) === key && keyNum >= 0 && keyNum > getMaxIndex(acc)) setMaxIndex(acc, keyNum);
        }
        return acc;
    }, mergeTarget);
};
var assign = function assignSingleSource(target, source) {
    return Object.keys(source).reduce(function(acc, key) {
        acc[key] = source[key];
        return acc;
    }, target);
};
var decode = function(str, defaultDecoder, charset) {
    var strWithoutPlus = str.replace(/\+/g, ' ');
    if (charset === 'iso-8859-1') // unescape never throws, no try...catch needed:
    return strWithoutPlus.replace(/%[0-9a-f]{2}/gi, unescape);
    // utf-8
    try {
        return decodeURIComponent(strWithoutPlus);
    } catch (e) {
        return strWithoutPlus;
    }
};
var limit = 1024;
/* eslint operator-linebreak: [2, "before"] */ var encode = function encode(str, defaultEncoder, charset, kind, format) {
    // This code was originally written by Brian White (mscdex) for the io.js core querystring library.
    // It has been adapted here for stricter adherence to RFC 3986
    if (str.length === 0) return str;
    var string = str;
    if (typeof str === 'symbol') string = Symbol.prototype.toString.call(str);
    else if (typeof str !== 'string') string = String(str);
    if (charset === 'iso-8859-1') return escape(string).replace(/%u[0-9a-f]{4}/gi, function($0) {
        return '%26%23' + parseInt($0.slice(2), 16) + '%3B';
    });
    var out = '';
    for(var j = 0; j < string.length; j += limit){
        var segment = string.length >= limit ? string.slice(j, j + limit) : string;
        var arr = [];
        for(var i = 0; i < segment.length; ++i){
            var c = segment.charCodeAt(i);
            if (c === 0x2D // -
             || c === 0x2E // .
             || c === 0x5F // _
             || c === 0x7E // ~
             || c >= 0x30 && c <= 0x39 // 0-9
             || c >= 0x41 && c <= 0x5A // a-z
             || c >= 0x61 && c <= 0x7A // A-Z
             || format === formats.RFC1738 && (c === 0x28 || c === 0x29) // ( )
            ) {
                arr[arr.length] = segment.charAt(i);
                continue;
            }
            if (c < 0x80) {
                arr[arr.length] = hexTable[c];
                continue;
            }
            if (c < 0x800) {
                arr[arr.length] = hexTable[0xC0 | c >> 6] + hexTable[0x80 | c & 0x3F];
                continue;
            }
            if (c < 0xD800 || c >= 0xE000) {
                arr[arr.length] = hexTable[0xE0 | c >> 12] + hexTable[0x80 | c >> 6 & 0x3F] + hexTable[0x80 | c & 0x3F];
                continue;
            }
            i += 1;
            c = 0x10000 + ((c & 0x3FF) << 10 | segment.charCodeAt(i) & 0x3FF);
            arr[arr.length] = hexTable[0xF0 | c >> 18] + hexTable[0x80 | c >> 12 & 0x3F] + hexTable[0x80 | c >> 6 & 0x3F] + hexTable[0x80 | c & 0x3F];
        }
        out += arr.join('');
    }
    return out;
};
var compact = function compact(value) {
    var queue = [
        {
            obj: {
                o: value
            },
            prop: 'o'
        }
    ];
    var refs = [];
    for(var i = 0; i < queue.length; ++i){
        var item = queue[i];
        var obj = item.obj[item.prop];
        var keys = Object.keys(obj);
        for(var j = 0; j < keys.length; ++j){
            var key = keys[j];
            var val = obj[key];
            if (typeof val === 'object' && val !== null && refs.indexOf(val) === -1) {
                queue[queue.length] = {
                    obj: obj,
                    prop: key
                };
                refs[refs.length] = val;
            }
        }
    }
    compactQueue(queue);
    return value;
};
var isRegExp = function isRegExp(obj) {
    return Object.prototype.toString.call(obj) === '[object RegExp]';
};
var isBuffer = function isBuffer(obj) {
    if (!obj || typeof obj !== 'object') return false;
    return !!(obj.constructor && obj.constructor.isBuffer && obj.constructor.isBuffer(obj));
};
var combine = function combine(a, b, arrayLimit, plainObjects) {
    // If 'a' is already an overflow object, add to it
    if (isOverflow(a)) {
        var newIndex = getMaxIndex(a) + 1;
        a[newIndex] = b;
        setMaxIndex(a, newIndex);
        return a;
    }
    var result = [].concat(a, b);
    if (result.length > arrayLimit) return markOverflow(arrayToObject(result, {
        plainObjects: plainObjects
    }), result.length - 1);
    return result;
};
var maybeMap = function maybeMap(val, fn) {
    if (isArray(val)) {
        var mapped = [];
        for(var i = 0; i < val.length; i += 1)mapped[mapped.length] = fn(val[i]);
        return mapped;
    }
    return fn(val);
};
module.exports = {
    arrayToObject: arrayToObject,
    assign: assign,
    combine: combine,
    compact: compact,
    decode: decode,
    encode: encode,
    isBuffer: isBuffer,
    isOverflow: isOverflow,
    isRegExp: isRegExp,
    markOverflow: markOverflow,
    maybeMap: maybeMap,
    merge: merge
};

},{"23c942bc74556a70":"l8I4v","735bcfe446fcc695":"3ErEP"}],"l8I4v":[function(require,module,exports,__globalThis) {
'use strict';
var replace = String.prototype.replace;
var percentTwenties = /%20/g;
var Format = {
    RFC1738: 'RFC1738',
    RFC3986: 'RFC3986'
};
module.exports = {
    'default': Format.RFC3986,
    formatters: {
        RFC1738: function(value) {
            return replace.call(value, percentTwenties, '+');
        },
        RFC3986: function(value) {
            return String(value);
        }
    },
    RFC1738: Format.RFC1738,
    RFC3986: Format.RFC3986
};

},{}],"gwG2K":[function(require,module,exports,__globalThis) {
'use strict';
var utils = require("7c590c0d793a7081");
var has = Object.prototype.hasOwnProperty;
var isArray = Array.isArray;
var defaults = {
    allowDots: false,
    allowEmptyArrays: false,
    allowPrototypes: false,
    allowSparse: false,
    arrayLimit: 20,
    charset: 'utf-8',
    charsetSentinel: false,
    comma: false,
    decodeDotInKeys: false,
    decoder: utils.decode,
    delimiter: '&',
    depth: 5,
    duplicates: 'combine',
    ignoreQueryPrefix: false,
    interpretNumericEntities: false,
    parameterLimit: 1000,
    parseArrays: true,
    plainObjects: false,
    strictDepth: false,
    strictMerge: true,
    strictNullHandling: false,
    throwOnLimitExceeded: false
};
var interpretNumericEntities = function(str) {
    return str.replace(/&#(\d+);/g, function($0, numberStr) {
        return String.fromCharCode(parseInt(numberStr, 10));
    });
};
var parseArrayValue = function(val, options, currentArrayLength) {
    if (val && typeof val === 'string' && options.comma && val.indexOf(',') > -1) return val.split(',');
    if (options.throwOnLimitExceeded && currentArrayLength >= options.arrayLimit) throw new RangeError('Array limit exceeded. Only ' + options.arrayLimit + ' element' + (options.arrayLimit === 1 ? '' : 's') + ' allowed in an array.');
    return val;
};
// This is what browsers will submit when the ✓ character occurs in an
// application/x-www-form-urlencoded body and the encoding of the page containing
// the form is iso-8859-1, or when the submitted form has an accept-charset
// attribute of iso-8859-1. Presumably also with other charsets that do not contain
// the ✓ character, such as us-ascii.
var isoSentinel = 'utf8=%26%2310003%3B'; // encodeURIComponent('&#10003;')
// These are the percent-encoded utf-8 octets representing a checkmark, indicating that the request actually is utf-8 encoded.
var charsetSentinel = 'utf8=%E2%9C%93'; // encodeURIComponent('✓')
var parseValues = function parseQueryStringValues(str, options) {
    var obj = {
        __proto__: null
    };
    var cleanStr = options.ignoreQueryPrefix ? str.replace(/^\?/, '') : str;
    cleanStr = cleanStr.replace(/%5B/gi, '[').replace(/%5D/gi, ']');
    var limit = options.parameterLimit === Infinity ? void 0 : options.parameterLimit;
    var parts = cleanStr.split(options.delimiter, options.throwOnLimitExceeded && typeof limit !== 'undefined' ? limit + 1 : limit);
    if (options.throwOnLimitExceeded && typeof limit !== 'undefined' && parts.length > limit) throw new RangeError('Parameter limit exceeded. Only ' + limit + ' parameter' + (limit === 1 ? '' : 's') + ' allowed.');
    var skipIndex = -1; // Keep track of where the utf8 sentinel was found
    var i;
    var charset = options.charset;
    if (options.charsetSentinel) {
        for(i = 0; i < parts.length; ++i)if (parts[i].indexOf('utf8=') === 0) {
            if (parts[i] === charsetSentinel) charset = 'utf-8';
            else if (parts[i] === isoSentinel) charset = 'iso-8859-1';
            skipIndex = i;
            i = parts.length; // The eslint settings do not allow break;
        }
    }
    for(i = 0; i < parts.length; ++i){
        if (i === skipIndex) continue;
        var part = parts[i];
        var bracketEqualsPos = part.indexOf(']=');
        var pos = bracketEqualsPos === -1 ? part.indexOf('=') : bracketEqualsPos + 1;
        var key;
        var val;
        if (pos === -1) {
            key = options.decoder(part, defaults.decoder, charset, 'key');
            val = options.strictNullHandling ? null : '';
        } else {
            key = options.decoder(part.slice(0, pos), defaults.decoder, charset, 'key');
            if (key !== null) val = utils.maybeMap(parseArrayValue(part.slice(pos + 1), options, isArray(obj[key]) ? obj[key].length : 0), function(encodedVal) {
                return options.decoder(encodedVal, defaults.decoder, charset, 'value');
            });
        }
        if (val && options.interpretNumericEntities && charset === 'iso-8859-1') val = interpretNumericEntities(String(val));
        if (part.indexOf('[]=') > -1) val = isArray(val) ? [
            val
        ] : val;
        if (options.comma && isArray(val) && val.length > options.arrayLimit) {
            if (options.throwOnLimitExceeded) throw new RangeError('Array limit exceeded. Only ' + options.arrayLimit + ' element' + (options.arrayLimit === 1 ? '' : 's') + ' allowed in an array.');
            val = utils.combine([], val, options.arrayLimit, options.plainObjects);
        }
        if (key !== null) {
            var existing = has.call(obj, key);
            if (existing && (options.duplicates === 'combine' || part.indexOf('[]=') > -1)) obj[key] = utils.combine(obj[key], val, options.arrayLimit, options.plainObjects);
            else if (!existing || options.duplicates === 'last') obj[key] = val;
        }
    }
    return obj;
};
var parseObject = function(chain, val, options, valuesParsed) {
    var currentArrayLength = 0;
    if (chain.length > 0 && chain[chain.length - 1] === '[]') {
        var parentKey = chain.slice(0, -1).join('');
        currentArrayLength = Array.isArray(val) && val[parentKey] ? val[parentKey].length : 0;
    }
    var leaf = valuesParsed ? val : parseArrayValue(val, options, currentArrayLength);
    for(var i = chain.length - 1; i >= 0; --i){
        var obj;
        var root = chain[i];
        if (root === '[]' && options.parseArrays) {
            if (utils.isOverflow(leaf)) // leaf is already an overflow object, preserve it
            obj = leaf;
            else obj = options.allowEmptyArrays && (leaf === '' || options.strictNullHandling && leaf === null) ? [] : utils.combine([], leaf, options.arrayLimit, options.plainObjects);
        } else {
            obj = options.plainObjects ? {
                __proto__: null
            } : {};
            var cleanRoot = root.charAt(0) === '[' && root.charAt(root.length - 1) === ']' ? root.slice(1, -1) : root;
            var decodedRoot = options.decodeDotInKeys ? cleanRoot.replace(/%2E/g, '.') : cleanRoot;
            var index = parseInt(decodedRoot, 10);
            var isValidArrayIndex = !isNaN(index) && root !== decodedRoot && String(index) === decodedRoot && index >= 0 && options.parseArrays;
            if (!options.parseArrays && decodedRoot === '') obj = {
                0: leaf
            };
            else if (isValidArrayIndex && index < options.arrayLimit) {
                obj = [];
                obj[index] = leaf;
            } else if (isValidArrayIndex && options.throwOnLimitExceeded) throw new RangeError('Array limit exceeded. Only ' + options.arrayLimit + ' element' + (options.arrayLimit === 1 ? '' : 's') + ' allowed in an array.');
            else if (isValidArrayIndex) {
                obj[index] = leaf;
                utils.markOverflow(obj, index);
            } else if (decodedRoot !== '__proto__') obj[decodedRoot] = leaf;
        }
        leaf = obj;
    }
    return leaf;
};
// Split a key like "a[b][c[]]" into ['a', '[b]', '[c[]]'] while preserving
// qs parse semantics for depth/prototype guards.
var splitKeyIntoSegments = function splitKeyIntoSegments(originalKey, options) {
    var key = options.allowDots ? originalKey.replace(/\.([^.[]+)/g, '[$1]') : originalKey;
    // depth <= 0 keeps the whole key as one segment
    if (options.depth <= 0) {
        if (!options.plainObjects && has.call(Object.prototype, key)) {
            if (!options.allowPrototypes) return;
        }
        return [
            key
        ];
    }
    var segments = [];
    // parent before the first '[' (may be empty if key starts with '[')
    var first = key.indexOf('[');
    var parent = first >= 0 ? key.slice(0, first) : key;
    if (parent) {
        if (!options.plainObjects && has.call(Object.prototype, parent)) {
            if (!options.allowPrototypes) return;
        }
        segments[segments.length] = parent;
    }
    var n = key.length;
    var open = first;
    var collected = 0;
    while(open >= 0 && collected < options.depth){
        var level = 1;
        var i = open + 1;
        var close = -1;
        // balance nested '[' and ']' inside this bracket group using a nesting level counter
        while(i < n && close < 0){
            var cu = key.charCodeAt(i);
            if (cu === 0x5B) level += 1;
            else if (cu === 0x5D) {
                level -= 1;
                if (level === 0) close = i; // found matching close; loop will exit by condition
            }
            i += 1;
        }
        if (close < 0) {
            // Unterminated group: wrap the raw remainder in one bracket pair so it stays
            // a single literal segment (e.g. "[[]b" -> "[[]b]"); we do not infer missing ']'.
            segments[segments.length] = '[' + key.slice(open) + ']';
            return segments;
        }
        var seg = key.slice(open, close + 1);
        // prototype guard for the content of this group
        var content = seg.slice(1, -1);
        if (!options.plainObjects && has.call(Object.prototype, content) && !options.allowPrototypes) return;
        segments[segments.length] = seg;
        collected += 1;
        // find the next '[' after this balanced group
        open = key.indexOf('[', close + 1);
    }
    if (open >= 0) {
        if (options.strictDepth === true) throw new RangeError('Input depth exceeded depth option of ' + options.depth + ' and strictDepth is true');
        segments[segments.length] = '[' + key.slice(open) + ']';
    }
    return segments;
};
var parseKeys = function parseQueryStringKeys(givenKey, val, options, valuesParsed) {
    if (!givenKey) return;
    var keys = splitKeyIntoSegments(givenKey, options);
    if (!keys) return;
    return parseObject(keys, val, options, valuesParsed);
};
var normalizeParseOptions = function normalizeParseOptions(opts) {
    if (!opts) return defaults;
    if (typeof opts.allowEmptyArrays !== 'undefined' && typeof opts.allowEmptyArrays !== 'boolean') throw new TypeError('`allowEmptyArrays` option can only be `true` or `false`, when provided');
    if (typeof opts.decodeDotInKeys !== 'undefined' && typeof opts.decodeDotInKeys !== 'boolean') throw new TypeError('`decodeDotInKeys` option can only be `true` or `false`, when provided');
    if (opts.decoder !== null && typeof opts.decoder !== 'undefined' && typeof opts.decoder !== 'function') throw new TypeError('Decoder has to be a function.');
    if (typeof opts.charset !== 'undefined' && opts.charset !== 'utf-8' && opts.charset !== 'iso-8859-1') throw new TypeError('The charset option must be either utf-8, iso-8859-1, or undefined');
    if (typeof opts.throwOnLimitExceeded !== 'undefined' && typeof opts.throwOnLimitExceeded !== 'boolean') throw new TypeError('`throwOnLimitExceeded` option must be a boolean');
    var charset = typeof opts.charset === 'undefined' ? defaults.charset : opts.charset;
    var duplicates = typeof opts.duplicates === 'undefined' ? defaults.duplicates : opts.duplicates;
    if (duplicates !== 'combine' && duplicates !== 'first' && duplicates !== 'last') throw new TypeError('The duplicates option must be either combine, first, or last');
    var allowDots = typeof opts.allowDots === 'undefined' ? opts.decodeDotInKeys === true ? true : defaults.allowDots : !!opts.allowDots;
    return {
        allowDots: allowDots,
        allowEmptyArrays: typeof opts.allowEmptyArrays === 'boolean' ? !!opts.allowEmptyArrays : defaults.allowEmptyArrays,
        allowPrototypes: typeof opts.allowPrototypes === 'boolean' ? opts.allowPrototypes : defaults.allowPrototypes,
        allowSparse: typeof opts.allowSparse === 'boolean' ? opts.allowSparse : defaults.allowSparse,
        arrayLimit: typeof opts.arrayLimit === 'number' ? opts.arrayLimit : defaults.arrayLimit,
        charset: charset,
        charsetSentinel: typeof opts.charsetSentinel === 'boolean' ? opts.charsetSentinel : defaults.charsetSentinel,
        comma: typeof opts.comma === 'boolean' ? opts.comma : defaults.comma,
        decodeDotInKeys: typeof opts.decodeDotInKeys === 'boolean' ? opts.decodeDotInKeys : defaults.decodeDotInKeys,
        decoder: typeof opts.decoder === 'function' ? opts.decoder : defaults.decoder,
        delimiter: typeof opts.delimiter === 'string' || utils.isRegExp(opts.delimiter) ? opts.delimiter : defaults.delimiter,
        // eslint-disable-next-line no-implicit-coercion, no-extra-parens
        depth: typeof opts.depth === 'number' || opts.depth === false ? +opts.depth : defaults.depth,
        duplicates: duplicates,
        ignoreQueryPrefix: opts.ignoreQueryPrefix === true,
        interpretNumericEntities: typeof opts.interpretNumericEntities === 'boolean' ? opts.interpretNumericEntities : defaults.interpretNumericEntities,
        parameterLimit: typeof opts.parameterLimit === 'number' ? opts.parameterLimit : defaults.parameterLimit,
        parseArrays: opts.parseArrays !== false,
        plainObjects: typeof opts.plainObjects === 'boolean' ? opts.plainObjects : defaults.plainObjects,
        strictDepth: typeof opts.strictDepth === 'boolean' ? !!opts.strictDepth : defaults.strictDepth,
        strictMerge: typeof opts.strictMerge === 'boolean' ? !!opts.strictMerge : defaults.strictMerge,
        strictNullHandling: typeof opts.strictNullHandling === 'boolean' ? opts.strictNullHandling : defaults.strictNullHandling,
        throwOnLimitExceeded: typeof opts.throwOnLimitExceeded === 'boolean' ? opts.throwOnLimitExceeded : false
    };
};
module.exports = function(str, opts) {
    var options = normalizeParseOptions(opts);
    if (str === '' || str === null || typeof str === 'undefined') return options.plainObjects ? {
        __proto__: null
    } : {};
    var tempObj = typeof str === 'string' ? parseValues(str, options) : str;
    var obj = options.plainObjects ? {
        __proto__: null
    } : {};
    // Iterate over the keys and setup the new object
    var keys = Object.keys(tempObj);
    for(var i = 0; i < keys.length; ++i){
        var key = keys[i];
        var newObj = parseKeys(key, tempObj[key], options, typeof str === 'string');
        obj = utils.merge(obj, newObj, options);
    }
    if (options.allowSparse === true) return obj;
    return utils.compact(obj);
};

},{"7c590c0d793a7081":"kD3m6"}],"3pYh1":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "initReactUFO", ()=>initReactUFO);
parcelHelpers.export(exports, "useReactUFORouteWatcher", ()=>useReactUFORouteWatcher);
var _react = require("react");
var _reactResourceRouterNext = require("react-resource-router-next");
var _interactionMetricsInit = require("@atlaskit/react-ufo/interaction-metrics-init");
var _tracePageload = require("@atlaskit/react-ufo/trace-pageload");
var _tracePageloadDefault = parcelHelpers.interopDefault(_tracePageload);
var _traceTransition = require("@atlaskit/react-ufo/trace-transition");
var _traceTransitionDefault = parcelHelpers.interopDefault(_traceTransition);
var _atlassianStudioEnvUtils = require("@atlassian/atlassian-studio-env-utils");
const initReactUFO = (analyticsClient)=>{
    const config = {
        vc: {
            enabled: true,
            heatmapSize: 200,
            oldDomUpdates: false,
            devToolsEnabled: true,
            // All DOM attributes currently set to false until UGC audit is completed
            // https://product-fabric.atlassian.net/browse/TC-11170
            selectorConfig: {
                id: false,
                role: false,
                className: false,
                testId: false
            }
        },
        product: 'atlassianStudio',
        region: (0, _atlassianStudioEnvUtils.getIdentityEnv)(),
        kind: {
            page_load: 1,
            transition: 1,
            press: 1,
            typing: 0,
            legacy: 0,
            hover: 0
        },
        namePrefix: 'ufo-',
        segmentPrefix: 'ufo-'
    };
    (0, _interactionMetricsInit.init)(Promise.resolve(analyticsClient), config);
};
let isInitialPageLoad = true;
const useReactUFORouteWatcher = (routesToUfoNameMap)=>{
    const [{ route, match }] = (0, _reactResourceRouterNext.useRouter)();
    const trackerName = route.trackerName || (routesToUfoNameMap === null || routesToUfoNameMap === void 0 ? void 0 : routesToUfoNameMap[route.path]);
    (0, _react.useEffect)(()=>{
        if (trackerName) {
            if (isInitialPageLoad) {
                (0, _tracePageloadDefault.default)(trackerName);
                isInitialPageLoad = false;
            } else (0, _traceTransitionDefault.default)(trackerName);
        }
    }, [
        trackerName,
        match.url
    ]);
};

},{"react":"ltHCL","react-resource-router-next":"6gkfP","@atlaskit/react-ufo/interaction-metrics-init":"9OAnj","@atlaskit/react-ufo/trace-pageload":"h746D","@atlaskit/react-ufo/trace-transition":"dqOiX","@atlassian/atlassian-studio-env-utils":"lO9Ek","@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"9OAnj":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "init", ()=>init);
var _api = require("@opentelemetry/api");
var _platformFeatureFlags = require("@atlaskit/platform-feature-flags");
var _additionalPayload = require("../additional-payload");
var _config = require("../config");
var _createExtraSearchPageInteractionPayload = require("../create-extra-search-page-interaction-payload");
var _contextManager = require("../experience-trace-id-context/context-manager");
var _hiddenTiming = require("../hidden-timing");
var _interactionMetrics = require("../interaction-metrics");
var _interactionsPerformanceObserver = require("../interactions-performance-observer");
var _machineUtilisation = require("../machine-utilisation");
var _setTerminalError = require("../set-terminal-error");
var _scheduleIdleCallback = require("./schedule-idle-callback");
var _scheduleIdleCallbackDefault = parcelHelpers.interopDefault(_scheduleIdleCallback);
let initialized = false;
function sinkInteraction(instance, payloadPackage) {
    function sinkFn(interactionId, interaction) {
        function onIdle() {
            payloadPackage.createPayloads(interactionId, interaction).then((payloads)=>{
                // NOTE: This API is used by the UFO DevTool Chrome Extension and Criterion
                const devToolObserver = globalThis.__ufo_devtool_onUfoPayload;
                payloads === null || payloads === void 0 ? void 0 : payloads.forEach((payload)=>{
                    if (typeof devToolObserver === 'function') devToolObserver === null || devToolObserver === void 0 ? void 0 : devToolObserver(payload);
                    instance.sendOperationalEvent(payload);
                });
            }).catch((error)=>{
                throw error;
            });
        }
        (0, _scheduleIdleCallbackDefault.default)(onIdle);
    }
    (0, _interactionMetrics.sinkInteractionHandler)(sinkFn);
}
function sinkPostInteractionLog(instance, createPostInteractionLogPayload) {
    (0, _interactionMetrics.sinkPostInteractionLogHandler)((logOutput)=>{
        (0, _scheduleIdleCallbackDefault.default)(()=>{
            const payload = createPostInteractionLogPayload(logOutput);
            if (payload) instance.sendOperationalEvent(payload);
        });
    });
}
function sinkTerminalErrors(instance, createTerminalErrorPayload) {
    (0, _setTerminalError.sinkTerminalErrorHandler)((errorData, context)=>{
        (0, _scheduleIdleCallbackDefault.default)(()=>{
            const payload = createTerminalErrorPayload(errorData, context);
            if (payload) instance.sendOperationalEvent(payload);
        });
    });
}
function sinkExtraSearchPageInteraction(instance, payloadPackage) {
    function sinkFn(interactionId, interaction) {
        function onIdle() {
            payloadPackage.createExtraSearchPageInteractionPayload(interactionId, interaction).then((payloads)=>{
                // NOTE: This API is used by the UFO DevTool Chrome Extension and Criterion
                const devToolObserver = globalThis.__ufo_devtool_onUfoPayload;
                payloads === null || payloads === void 0 ? void 0 : payloads.forEach((payload)=>{
                    if (typeof devToolObserver === 'function') devToolObserver === null || devToolObserver === void 0 ? void 0 : devToolObserver(payload);
                    instance.sendOperationalEvent(payload);
                });
            }).catch((error)=>{
                throw error;
            });
        }
        (0, _scheduleIdleCallbackDefault.default)(onIdle);
    }
    (0, _createExtraSearchPageInteractionPayload.sinkExtraSearchPageInteractionHandler)(sinkFn);
}
function init(analyticsWebClientAsync, config) {
    var _config_vc;
    if (initialized) return;
    // Always set config first so isUFOEnabled() can check config.enabled
    (0, _config.setUFOConfig)(config);
    // If UFO is disabled via config, skip all initialization
    if (!(0, _config.isUFOEnabled)()) {
        initialized = true;
        return;
    }
    // Initialize pressure observer for CPU usage monitoring
    (0, _machineUtilisation.initialisePressureObserver)();
    (0, _machineUtilisation.initialiseMemoryObserver)();
    if ((0, _platformFeatureFlags.fg)('platform_ufo_enable_otel_context_manager')) {
        // Configure global OTel context manager
        const contextManager = new (0, _contextManager.UFOContextManager)();
        // set the contextmanager somewhere we can reference it later
        (0, _contextManager.setContextManager)(contextManager);
        // Register the context manager with the global OTel API
        contextManager.enable();
        (0, _api.context).setGlobalContextManager(contextManager);
    }
    if ((_config_vc = config.vc) === null || _config_vc === void 0 ? void 0 : _config_vc.enabled) {
        const vcOptions = {
            heatmapSize: config.vc.heatmapSize,
            oldDomUpdates: config.vc.oldDomUpdates,
            devToolsEnabled: config.vc.devToolsEnabled,
            // Use centralised getter so the FedRAMP override (forces every
            // selector field to false) is applied consistently.
            selectorConfig: (0, _config.getSelectorConfig)(),
            ssrEnablePageLayoutPlaceholder: config.vc.ssrEnablePageLayoutPlaceholder,
            trackLayoutShiftOffenders: config.vc.trackLayoutShiftOffenders
        };
        (0, _interactionMetrics.postInteractionLog).initializeVCObserver(vcOptions);
    }
    (0, _hiddenTiming.setupHiddenTimingCapture)();
    (0, _additionalPayload.startLighthouseObserver)();
    (0, _hiddenTiming.setupThrottleDetection)();
    initialized = true;
    if (typeof PerformanceObserver !== 'undefined') {
        const observer = (0, _interactionsPerformanceObserver.getPerformanceObserver)();
        observer.observe({
            type: 'event',
            buffered: true,
            durationThreshold: 16
        });
    }
    Promise.all([
        analyticsWebClientAsync,
        require(/* webpackChunkName: "create-payloads" */ "46239c68e7f67530"),
        require(/* webpackChunkName: "create-post-interaction-log-payload" */ "442fcd49caa852b2"),
        require(/* webpackChunkName: "create-terminal-error-payload@atlaskit-internal_terminal_errors" */ "ec7f664b9d50b8c8")
    ]).then(([awc, payloadPackage, createPostInteractionLogPayloadPackage, createTerminalErrorPayloadPackage])=>{
        if (awc.getAnalyticsWebClientPromise) awc.getAnalyticsWebClientPromise().then((client)=>{
            var _config_terminalErrors, _config_postInteractionLog, _config_extraSearchPageInteraction;
            const instance = client.getInstance();
            sinkInteraction(instance, payloadPackage);
            if (config === null || config === void 0 ? void 0 : (_config_terminalErrors = config.terminalErrors) === null || _config_terminalErrors === void 0 ? void 0 : _config_terminalErrors.enabled) sinkTerminalErrors(instance, createTerminalErrorPayloadPackage.default);
            if ((_config_postInteractionLog = config.postInteractionLog) === null || _config_postInteractionLog === void 0 ? void 0 : _config_postInteractionLog.enabled) sinkPostInteractionLog(instance, createPostInteractionLogPayloadPackage.default);
            if (config === null || config === void 0 ? void 0 : (_config_extraSearchPageInteraction = config.extraSearchPageInteraction) === null || _config_extraSearchPageInteraction === void 0 ? void 0 : _config_extraSearchPageInteraction.enabled) sinkExtraSearchPageInteraction(instance, payloadPackage);
        });
        else if (awc.sendOperationalEvent) {
            var _config_terminalErrors, _config_postInteractionLog, _config_extraSearchPageInteraction;
            sinkInteraction(awc, payloadPackage);
            if (config === null || config === void 0 ? void 0 : (_config_terminalErrors = config.terminalErrors) === null || _config_terminalErrors === void 0 ? void 0 : _config_terminalErrors.enabled) sinkTerminalErrors(awc, createTerminalErrorPayloadPackage.default);
            if ((_config_postInteractionLog = config.postInteractionLog) === null || _config_postInteractionLog === void 0 ? void 0 : _config_postInteractionLog.enabled) sinkPostInteractionLog(awc, createPostInteractionLogPayloadPackage.default);
            if (config === null || config === void 0 ? void 0 : (_config_extraSearchPageInteraction = config.extraSearchPageInteraction) === null || _config_extraSearchPageInteraction === void 0 ? void 0 : _config_extraSearchPageInteraction.enabled) sinkExtraSearchPageInteraction(awc, payloadPackage);
        }
    });
}

},{"@opentelemetry/api":"9lCa7","@atlaskit/platform-feature-flags":"8rD2i","../additional-payload":"8DBX6","../config":"bx9i6","../create-extra-search-page-interaction-payload":"2hccT","../experience-trace-id-context/context-manager":"fVmSw","../hidden-timing":"c8L9i","../interaction-metrics":"j4w6h","../interactions-performance-observer":"gkHA9","../machine-utilisation":"2UWRF","../set-terminal-error":"aMOEQ","./schedule-idle-callback":"e56bN","46239c68e7f67530":"6c6HA","442fcd49caa852b2":"5SpPE","ec7f664b9d50b8c8":"j19vk","@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"9lCa7":[function(require,module,exports,__globalThis) {
/*
 * Copyright The OpenTelemetry Authors
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *      https://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "baggageEntryMetadataFromString", ()=>(0, _utils.baggageEntryMetadataFromString));
// Context APIs
parcelHelpers.export(exports, "createContextKey", ()=>(0, _context.createContextKey));
parcelHelpers.export(exports, "ROOT_CONTEXT", ()=>(0, _context.ROOT_CONTEXT));
// Diag APIs
parcelHelpers.export(exports, "DiagConsoleLogger", ()=>(0, _consoleLogger.DiagConsoleLogger));
parcelHelpers.export(exports, "DiagLogLevel", ()=>(0, _types.DiagLogLevel));
// Metrics APIs
parcelHelpers.export(exports, "createNoopMeter", ()=>(0, _noopMeter.createNoopMeter));
parcelHelpers.export(exports, "ValueType", ()=>(0, _metric.ValueType));
// Propagation APIs
parcelHelpers.export(exports, "defaultTextMapGetter", ()=>(0, _textMapPropagator.defaultTextMapGetter));
parcelHelpers.export(exports, "defaultTextMapSetter", ()=>(0, _textMapPropagator.defaultTextMapSetter));
parcelHelpers.export(exports, "ProxyTracer", ()=>(0, _proxyTracer.ProxyTracer));
parcelHelpers.export(exports, "ProxyTracerProvider", ()=>(0, _proxyTracerProvider.ProxyTracerProvider));
parcelHelpers.export(exports, "SamplingDecision", ()=>(0, _samplingResult.SamplingDecision));
parcelHelpers.export(exports, "SpanKind", ()=>(0, _spanKind.SpanKind));
parcelHelpers.export(exports, "SpanStatusCode", ()=>(0, _status.SpanStatusCode));
parcelHelpers.export(exports, "TraceFlags", ()=>(0, _traceFlags.TraceFlags));
parcelHelpers.export(exports, "createTraceState", ()=>(0, _utils1.createTraceState));
parcelHelpers.export(exports, "isSpanContextValid", ()=>(0, _spancontextUtils.isSpanContextValid));
parcelHelpers.export(exports, "isValidTraceId", ()=>(0, _spancontextUtils.isValidTraceId));
parcelHelpers.export(exports, "isValidSpanId", ()=>(0, _spancontextUtils.isValidSpanId));
parcelHelpers.export(exports, "INVALID_SPANID", ()=>(0, _invalidSpanConstants.INVALID_SPANID));
parcelHelpers.export(exports, "INVALID_TRACEID", ()=>(0, _invalidSpanConstants.INVALID_TRACEID));
parcelHelpers.export(exports, "INVALID_SPAN_CONTEXT", ()=>(0, _invalidSpanConstants.INVALID_SPAN_CONTEXT));
// Named export.
parcelHelpers.export(exports, "context", ()=>(0, _contextApi.context));
parcelHelpers.export(exports, "diag", ()=>(0, _diagApi.diag));
parcelHelpers.export(exports, "metrics", ()=>(0, _metricsApi.metrics));
parcelHelpers.export(exports, "propagation", ()=>(0, _propagationApi.propagation));
parcelHelpers.export(exports, "trace", ()=>(0, _traceApi.trace));
var _utils = require("./baggage/utils");
var _context = require("./context/context");
var _consoleLogger = require("./diag/consoleLogger");
var _types = require("./diag/types");
var _noopMeter = require("./metrics/NoopMeter");
var _metric = require("./metrics/Metric");
var _textMapPropagator = require("./propagation/TextMapPropagator");
var _proxyTracer = require("./trace/ProxyTracer");
var _proxyTracerProvider = require("./trace/ProxyTracerProvider");
var _samplingResult = require("./trace/SamplingResult");
var _spanKind = require("./trace/span_kind");
var _status = require("./trace/status");
var _traceFlags = require("./trace/trace_flags");
var _utils1 = require("./trace/internal/utils");
var _spancontextUtils = require("./trace/spancontext-utils");
var _invalidSpanConstants = require("./trace/invalid-span-constants");
// Split module-level variable definition into separate files to allow
// tree-shaking on each api instance.
var _contextApi = require("./context-api");
var _diagApi = require("./diag-api");
var _metricsApi = require("./metrics-api");
var _propagationApi = require("./propagation-api");
var _traceApi = require("./trace-api");
// Default export.
exports.default = {
    context: (0, _contextApi.context),
    diag: (0, _diagApi.diag),
    metrics: (0, _metricsApi.metrics),
    propagation: (0, _propagationApi.propagation),
    trace: (0, _traceApi.trace)
};

},{"./baggage/utils":false,"./context/context":"amn9k","./diag/consoleLogger":false,"./diag/types":false,"./metrics/NoopMeter":false,"./metrics/Metric":false,"./propagation/TextMapPropagator":false,"./trace/ProxyTracer":false,"./trace/ProxyTracerProvider":false,"./trace/SamplingResult":false,"./trace/span_kind":false,"./trace/status":false,"./trace/trace_flags":false,"./trace/internal/utils":false,"./trace/spancontext-utils":false,"./trace/invalid-span-constants":false,"./context-api":"l4IpC","./diag-api":"ca71U","./metrics-api":"flr8Y","./propagation-api":"7haOh","./trace-api":"31pDO","@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"7Z76g":[function(require,module,exports,__globalThis) {
/*
 * Copyright The OpenTelemetry Authors
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *      https://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
/**
 * Create a new Baggage with optional entries
 *
 * @param entries An array of baggage entries the new baggage should contain
 */ parcelHelpers.export(exports, "createBaggage", ()=>createBaggage);
/**
 * Create a serializable BaggageEntryMetadata object from a string.
 *
 * @param str string metadata. Format is currently not defined by the spec and has no special meaning.
 *
 */ parcelHelpers.export(exports, "baggageEntryMetadataFromString", ()=>baggageEntryMetadataFromString);
var _diag = require("../api/diag");
var _baggageImpl = require("./internal/baggage-impl");
var _symbol = require("./internal/symbol");
var diag = (0, _diag.DiagAPI).instance();
function createBaggage(entries) {
    if (entries === void 0) entries = {};
    return new (0, _baggageImpl.BaggageImpl)(new Map(Object.entries(entries)));
}
function baggageEntryMetadataFromString(str) {
    if (typeof str !== 'string') {
        diag.error("Cannot create baggage metadata from unknown type: " + typeof str);
        str = '';
    }
    return {
        __TYPE__: (0, _symbol.baggageEntryMetadataSymbol),
        toString: function() {
            return str;
        }
    };
}

},{"../api/diag":"h9doG","./internal/baggage-impl":"gkjXV","./internal/symbol":"3n72C","@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"h9doG":[function(require,module,exports,__globalThis) {
/*
 * Copyright The OpenTelemetry Authors
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *      https://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "DiagAPI", ()=>DiagAPI);
var _componentLogger = require("../diag/ComponentLogger");
var _logLevelLogger = require("../diag/internal/logLevelLogger");
var _types = require("../diag/types");
var _globalUtils = require("../internal/global-utils");
var __read = undefined && undefined.__read || function(o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while((n === void 0 || n-- > 0) && !(r = i.next()).done)ar.push(r.value);
    } catch (error) {
        e = {
            error: error
        };
    } finally{
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        } finally{
            if (e) throw e.error;
        }
    }
    return ar;
};
var __spreadArray = undefined && undefined.__spreadArray || function(to, from, pack) {
    if (pack || arguments.length === 2) {
        for(var i = 0, l = from.length, ar; i < l; i++)if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
var API_NAME = 'diag';
/**
 * Singleton object which represents the entry point to the OpenTelemetry internal
 * diagnostic API
 */ var DiagAPI = /** @class */ function() {
    /**
     * Private internal constructor
     * @private
     */ function DiagAPI() {
        function _logProxy(funcName) {
            return function() {
                var args = [];
                for(var _i = 0; _i < arguments.length; _i++)args[_i] = arguments[_i];
                var logger = (0, _globalUtils.getGlobal)('diag');
                // shortcut if logger not set
                if (!logger) return;
                return logger[funcName].apply(logger, __spreadArray([], __read(args), false));
            };
        }
        // Using self local variable for minification purposes as 'this' cannot be minified
        var self = this;
        // DiagAPI specific functions
        var setLogger = function(logger, optionsOrLogLevel) {
            var _a, _b, _c;
            if (optionsOrLogLevel === void 0) optionsOrLogLevel = {
                logLevel: (0, _types.DiagLogLevel).INFO
            };
            if (logger === self) {
                // There isn't much we can do here.
                // Logging to the console might break the user application.
                // Try to log to self. If a logger was previously registered it will receive the log.
                var err = new Error('Cannot use diag as the logger for itself. Please use a DiagLogger implementation like ConsoleDiagLogger or a custom implementation');
                self.error((_a = err.stack) !== null && _a !== void 0 ? _a : err.message);
                return false;
            }
            if (typeof optionsOrLogLevel === 'number') optionsOrLogLevel = {
                logLevel: optionsOrLogLevel
            };
            var oldLogger = (0, _globalUtils.getGlobal)('diag');
            var newLogger = (0, _logLevelLogger.createLogLevelDiagLogger)((_b = optionsOrLogLevel.logLevel) !== null && _b !== void 0 ? _b : (0, _types.DiagLogLevel).INFO, logger);
            // There already is an logger registered. We'll let it know before overwriting it.
            if (oldLogger && !optionsOrLogLevel.suppressOverrideMessage) {
                var stack = (_c = new Error().stack) !== null && _c !== void 0 ? _c : '<failed to generate stacktrace>';
                oldLogger.warn("Current logger will be overwritten from " + stack);
                newLogger.warn("Current logger will overwrite one already registered from " + stack);
            }
            return (0, _globalUtils.registerGlobal)('diag', newLogger, self, true);
        };
        self.setLogger = setLogger;
        self.disable = function() {
            (0, _globalUtils.unregisterGlobal)(API_NAME, self);
        };
        self.createComponentLogger = function(options) {
            return new (0, _componentLogger.DiagComponentLogger)(options);
        };
        self.verbose = _logProxy('verbose');
        self.debug = _logProxy('debug');
        self.info = _logProxy('info');
        self.warn = _logProxy('warn');
        self.error = _logProxy('error');
    }
    /** Get the singleton instance of the DiagAPI API */ DiagAPI.instance = function() {
        if (!this._instance) this._instance = new DiagAPI();
        return this._instance;
    };
    return DiagAPI;
}();

},{"../diag/ComponentLogger":"lEkPr","../diag/internal/logLevelLogger":"lmfou","../diag/types":"llRAn","../internal/global-utils":"4g6BY","@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"lEkPr":[function(require,module,exports,__globalThis) {
/*
 * Copyright The OpenTelemetry Authors
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *      https://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "DiagComponentLogger", ()=>DiagComponentLogger);
var _globalUtils = require("../internal/global-utils");
var __read = undefined && undefined.__read || function(o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while((n === void 0 || n-- > 0) && !(r = i.next()).done)ar.push(r.value);
    } catch (error) {
        e = {
            error: error
        };
    } finally{
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        } finally{
            if (e) throw e.error;
        }
    }
    return ar;
};
var __spreadArray = undefined && undefined.__spreadArray || function(to, from, pack) {
    if (pack || arguments.length === 2) {
        for(var i = 0, l = from.length, ar; i < l; i++)if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
/**
 * Component Logger which is meant to be used as part of any component which
 * will add automatically additional namespace in front of the log message.
 * It will then forward all message to global diag logger
 * @example
 * const cLogger = diag.createComponentLogger({ namespace: '@opentelemetry/instrumentation-http' });
 * cLogger.debug('test');
 * // @opentelemetry/instrumentation-http test
 */ var DiagComponentLogger = /** @class */ function() {
    function DiagComponentLogger(props) {
        this._namespace = props.namespace || 'DiagComponentLogger';
    }
    DiagComponentLogger.prototype.debug = function() {
        var args = [];
        for(var _i = 0; _i < arguments.length; _i++)args[_i] = arguments[_i];
        return logProxy('debug', this._namespace, args);
    };
    DiagComponentLogger.prototype.error = function() {
        var args = [];
        for(var _i = 0; _i < arguments.length; _i++)args[_i] = arguments[_i];
        return logProxy('error', this._namespace, args);
    };
    DiagComponentLogger.prototype.info = function() {
        var args = [];
        for(var _i = 0; _i < arguments.length; _i++)args[_i] = arguments[_i];
        return logProxy('info', this._namespace, args);
    };
    DiagComponentLogger.prototype.warn = function() {
        var args = [];
        for(var _i = 0; _i < arguments.length; _i++)args[_i] = arguments[_i];
        return logProxy('warn', this._namespace, args);
    };
    DiagComponentLogger.prototype.verbose = function() {
        var args = [];
        for(var _i = 0; _i < arguments.length; _i++)args[_i] = arguments[_i];
        return logProxy('verbose', this._namespace, args);
    };
    return DiagComponentLogger;
}();
function logProxy(funcName, namespace, args) {
    var logger = (0, _globalUtils.getGlobal)('diag');
    // shortcut if logger not set
    if (!logger) return;
    args.unshift(namespace);
    return logger[funcName].apply(logger, __spreadArray([], __read(args), false));
}

},{"../internal/global-utils":"4g6BY","@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"4g6BY":[function(require,module,exports,__globalThis) {
/*
 * Copyright The OpenTelemetry Authors
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *      https://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "registerGlobal", ()=>registerGlobal);
parcelHelpers.export(exports, "getGlobal", ()=>getGlobal);
parcelHelpers.export(exports, "unregisterGlobal", ()=>unregisterGlobal);
var _platform = require("../platform");
var _version = require("../version");
var _semver = require("./semver");
var major = (0, _version.VERSION).split('.')[0];
var GLOBAL_OPENTELEMETRY_API_KEY = Symbol.for("opentelemetry.js.api." + major);
var _global = (0, _platform._globalThis);
function registerGlobal(type, instance, diag, allowOverride) {
    var _a;
    if (allowOverride === void 0) allowOverride = false;
    var api = _global[GLOBAL_OPENTELEMETRY_API_KEY] = (_a = _global[GLOBAL_OPENTELEMETRY_API_KEY]) !== null && _a !== void 0 ? _a : {
        version: (0, _version.VERSION)
    };
    if (!allowOverride && api[type]) {
        // already registered an API of this type
        var err = new Error("@opentelemetry/api: Attempted duplicate registration of API: " + type);
        diag.error(err.stack || err.message);
        return false;
    }
    if (api.version !== (0, _version.VERSION)) {
        // All registered APIs must be of the same version exactly
        var err = new Error("@opentelemetry/api: Registration of version v" + api.version + " for " + type + " does not match previously registered API v" + (0, _version.VERSION));
        diag.error(err.stack || err.message);
        return false;
    }
    api[type] = instance;
    diag.debug("@opentelemetry/api: Registered a global for " + type + " v" + (0, _version.VERSION) + ".");
    return true;
}
function getGlobal(type) {
    var _a, _b;
    var globalVersion = (_a = _global[GLOBAL_OPENTELEMETRY_API_KEY]) === null || _a === void 0 ? void 0 : _a.version;
    if (!globalVersion || !(0, _semver.isCompatible)(globalVersion)) return;
    return (_b = _global[GLOBAL_OPENTELEMETRY_API_KEY]) === null || _b === void 0 ? void 0 : _b[type];
}
function unregisterGlobal(type, diag) {
    diag.debug("@opentelemetry/api: Unregistering a global for " + type + " v" + (0, _version.VERSION) + ".");
    var api = _global[GLOBAL_OPENTELEMETRY_API_KEY];
    if (api) delete api[type];
}

},{"../platform":"aOLF6","../version":"bmtug","./semver":"akR6S","@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"aOLF6":[function(require,module,exports,__globalThis) {
/*
 * Copyright The OpenTelemetry Authors
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *      https://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _globalThis = require("./globalThis");
parcelHelpers.exportAll(_globalThis, exports);

},{"./globalThis":"fxXZa","@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"fxXZa":[function(require,module,exports,__globalThis) {
/*
 * Copyright The OpenTelemetry Authors
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *      https://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ // Updates to this file should also be replicated to @opentelemetry/core too.
/**
 * - globalThis (New standard)
 * - self (Will return the current window instance for supported browsers)
 * - window (fallback for older browser implementations)
 * - global (NodeJS implementation)
 * - <object> (When all else fails)
 */ /** only globals that common to node and browsers are allowed */ // eslint-disable-next-line node/no-unsupported-features/es-builtins, no-undef
var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "_globalThis", ()=>_globalThis);
var global = arguments[3];
var _globalThis = typeof globalThis === 'object' ? globalThis : typeof self === 'object' ? self : typeof window === 'object' ? window : typeof global === 'object' ? global : {};

},{"@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"bmtug":[function(require,module,exports,__globalThis) {
/*
 * Copyright The OpenTelemetry Authors
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *      https://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ // this is autogenerated file, see scripts/version-update.js
var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "VERSION", ()=>VERSION);
var VERSION = '1.9.0';

},{"@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"akR6S":[function(require,module,exports,__globalThis) {
/*
 * Copyright The OpenTelemetry Authors
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *      https://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
/**
 * Create a function to test an API version to see if it is compatible with the provided ownVersion.
 *
 * The returned function has the following semantics:
 * - Exact match is always compatible
 * - Major versions must match exactly
 *    - 1.x package cannot use global 2.x package
 *    - 2.x package cannot use global 1.x package
 * - The minor version of the API module requesting access to the global API must be less than or equal to the minor version of this API
 *    - 1.3 package may use 1.4 global because the later global contains all functions 1.3 expects
 *    - 1.4 package may NOT use 1.3 global because it may try to call functions which don't exist on 1.3
 * - If the major version is 0, the minor version is treated as the major and the patch is treated as the minor
 * - Patch and build tag differences are not considered at this time
 *
 * @param ownVersion version which should be checked against
 */ parcelHelpers.export(exports, "_makeCompatibilityCheck", ()=>_makeCompatibilityCheck);
parcelHelpers.export(exports, "isCompatible", ()=>isCompatible);
var _version = require("../version");
var re = /^(\d+)\.(\d+)\.(\d+)(-(.+))?$/;
function _makeCompatibilityCheck(ownVersion) {
    var acceptedVersions = new Set([
        ownVersion
    ]);
    var rejectedVersions = new Set();
    var myVersionMatch = ownVersion.match(re);
    if (!myVersionMatch) // we cannot guarantee compatibility so we always return noop
    return function() {
        return false;
    };
    var ownVersionParsed = {
        major: +myVersionMatch[1],
        minor: +myVersionMatch[2],
        patch: +myVersionMatch[3],
        prerelease: myVersionMatch[4]
    };
    // if ownVersion has a prerelease tag, versions must match exactly
    if (ownVersionParsed.prerelease != null) return function isExactmatch(globalVersion) {
        return globalVersion === ownVersion;
    };
    function _reject(v) {
        rejectedVersions.add(v);
        return false;
    }
    function _accept(v) {
        acceptedVersions.add(v);
        return true;
    }
    return function isCompatible(globalVersion) {
        if (acceptedVersions.has(globalVersion)) return true;
        if (rejectedVersions.has(globalVersion)) return false;
        var globalVersionMatch = globalVersion.match(re);
        if (!globalVersionMatch) // cannot parse other version
        // we cannot guarantee compatibility so we always noop
        return _reject(globalVersion);
        var globalVersionParsed = {
            major: +globalVersionMatch[1],
            minor: +globalVersionMatch[2],
            patch: +globalVersionMatch[3],
            prerelease: globalVersionMatch[4]
        };
        // if globalVersion has a prerelease tag, versions must match exactly
        if (globalVersionParsed.prerelease != null) return _reject(globalVersion);
        // major versions must match
        if (ownVersionParsed.major !== globalVersionParsed.major) return _reject(globalVersion);
        if (ownVersionParsed.major === 0) {
            if (ownVersionParsed.minor === globalVersionParsed.minor && ownVersionParsed.patch <= globalVersionParsed.patch) return _accept(globalVersion);
            return _reject(globalVersion);
        }
        if (ownVersionParsed.minor <= globalVersionParsed.minor) return _accept(globalVersion);
        return _reject(globalVersion);
    };
}
var isCompatible = _makeCompatibilityCheck((0, _version.VERSION));

},{"../version":"bmtug","@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"lmfou":[function(require,module,exports,__globalThis) {
/*
 * Copyright The OpenTelemetry Authors
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *      https://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "createLogLevelDiagLogger", ()=>createLogLevelDiagLogger);
var _types = require("../types");
function createLogLevelDiagLogger(maxLevel, logger) {
    if (maxLevel < (0, _types.DiagLogLevel).NONE) maxLevel = (0, _types.DiagLogLevel).NONE;
    else if (maxLevel > (0, _types.DiagLogLevel).ALL) maxLevel = (0, _types.DiagLogLevel).ALL;
    // In case the logger is null or undefined
    logger = logger || {};
    function _filterFunc(funcName, theLevel) {
        var theFunc = logger[funcName];
        if (typeof theFunc === 'function' && maxLevel >= theLevel) return theFunc.bind(logger);
        return function() {};
    }
    return {
        error: _filterFunc('error', (0, _types.DiagLogLevel).ERROR),
        warn: _filterFunc('warn', (0, _types.DiagLogLevel).WARN),
        info: _filterFunc('info', (0, _types.DiagLogLevel).INFO),
        debug: _filterFunc('debug', (0, _types.DiagLogLevel).DEBUG),
        verbose: _filterFunc('verbose', (0, _types.DiagLogLevel).VERBOSE)
    };
}

},{"../types":"llRAn","@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"llRAn":[function(require,module,exports,__globalThis) {
/*
 * Copyright The OpenTelemetry Authors
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *      https://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Defines the available internal logging levels for the diagnostic logger, the numeric values
 * of the levels are defined to match the original values from the initial LogLevel to avoid
 * compatibility/migration issues for any implementation that assume the numeric ordering.
 */ var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "DiagLogLevel", ()=>DiagLogLevel);
var DiagLogLevel;
(function(DiagLogLevel) {
    /** Diagnostic Logging level setting to disable all logging (except and forced logs) */ DiagLogLevel[DiagLogLevel["NONE"] = 0] = "NONE";
    /** Identifies an error scenario */ DiagLogLevel[DiagLogLevel["ERROR"] = 30] = "ERROR";
    /** Identifies a warning scenario */ DiagLogLevel[DiagLogLevel["WARN"] = 50] = "WARN";
    /** General informational log message */ DiagLogLevel[DiagLogLevel["INFO"] = 60] = "INFO";
    /** General debug log message */ DiagLogLevel[DiagLogLevel["DEBUG"] = 70] = "DEBUG";
    /**
     * Detailed trace level logging should only be used for development, should only be set
     * in a development environment.
     */ DiagLogLevel[DiagLogLevel["VERBOSE"] = 80] = "VERBOSE";
    /** Used to set the logging level to include all logging */ DiagLogLevel[DiagLogLevel["ALL"] = 9999] = "ALL";
})(DiagLogLevel || (DiagLogLevel = {}));

},{"@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"gkjXV":[function(require,module,exports,__globalThis) {
/*
 * Copyright The OpenTelemetry Authors
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *      https://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "BaggageImpl", ()=>BaggageImpl);
var __read = undefined && undefined.__read || function(o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while((n === void 0 || n-- > 0) && !(r = i.next()).done)ar.push(r.value);
    } catch (error) {
        e = {
            error: error
        };
    } finally{
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        } finally{
            if (e) throw e.error;
        }
    }
    return ar;
};
var __values = undefined && undefined.__values || function(o) {
    var s = typeof Symbol === "function" && Symbol.iterator, m = s && o[s], i = 0;
    if (m) return m.call(o);
    if (o && typeof o.length === "number") return {
        next: function() {
            if (o && i >= o.length) o = void 0;
            return {
                value: o && o[i++],
                done: !o
            };
        }
    };
    throw new TypeError(s ? "Object is not iterable." : "Symbol.iterator is not defined.");
};
var BaggageImpl = /** @class */ function() {
    function BaggageImpl(entries) {
        this._entries = entries ? new Map(entries) : new Map();
    }
    BaggageImpl.prototype.getEntry = function(key) {
        var entry = this._entries.get(key);
        if (!entry) return undefined;
        return Object.assign({}, entry);
    };
    BaggageImpl.prototype.getAllEntries = function() {
        return Array.from(this._entries.entries()).map(function(_a) {
            var _b = __read(_a, 2), k = _b[0], v = _b[1];
            return [
                k,
                v
            ];
        });
    };
    BaggageImpl.prototype.setEntry = function(key, entry) {
        var newBaggage = new BaggageImpl(this._entries);
        newBaggage._entries.set(key, entry);
        return newBaggage;
    };
    BaggageImpl.prototype.removeEntry = function(key) {
        var newBaggage = new BaggageImpl(this._entries);
        newBaggage._entries.delete(key);
        return newBaggage;
    };
    BaggageImpl.prototype.removeEntries = function() {
        var e_1, _a;
        var keys = [];
        for(var _i = 0; _i < arguments.length; _i++)keys[_i] = arguments[_i];
        var newBaggage = new BaggageImpl(this._entries);
        try {
            for(var keys_1 = __values(keys), keys_1_1 = keys_1.next(); !keys_1_1.done; keys_1_1 = keys_1.next()){
                var key = keys_1_1.value;
                newBaggage._entries.delete(key);
            }
        } catch (e_1_1) {
            e_1 = {
                error: e_1_1
            };
        } finally{
            try {
                if (keys_1_1 && !keys_1_1.done && (_a = keys_1.return)) _a.call(keys_1);
            } finally{
                if (e_1) throw e_1.error;
            }
        }
        return newBaggage;
    };
    BaggageImpl.prototype.clear = function() {
        return new BaggageImpl();
    };
    return BaggageImpl;
}();

},{"@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"3n72C":[function(require,module,exports,__globalThis) {
/*
 * Copyright The OpenTelemetry Authors
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *      https://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Symbol used to make BaggageEntryMetadata an opaque type
 */ var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "baggageEntryMetadataSymbol", ()=>baggageEntryMetadataSymbol);
var baggageEntryMetadataSymbol = Symbol('BaggageEntryMetadata');

},{"@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"amn9k":[function(require,module,exports,__globalThis) {
/*
 * Copyright The OpenTelemetry Authors
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *      https://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /** Get a key to uniquely identify a context value */ var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "createContextKey", ()=>createContextKey);
parcelHelpers.export(exports, "ROOT_CONTEXT", ()=>ROOT_CONTEXT);
function createContextKey(description) {
    // The specification states that for the same input, multiple calls should
    // return different keys. Due to the nature of the JS dependency management
    // system, this creates problems where multiple versions of some package
    // could hold different keys for the same property.
    //
    // Therefore, we use Symbol.for which returns the same key for the same input.
    return Symbol.for(description);
}
var BaseContext = /** @class */ function() {
    /**
     * Construct a new context which inherits values from an optional parent context.
     *
     * @param parentContext a context from which to inherit values
     */ function BaseContext(parentContext) {
        // for minification
        var self = this;
        self._currentContext = parentContext ? new Map(parentContext) : new Map();
        self.getValue = function(key) {
            return self._currentContext.get(key);
        };
        self.setValue = function(key, value) {
            var context = new BaseContext(self._currentContext);
            context._currentContext.set(key, value);
            return context;
        };
        self.deleteValue = function(key) {
            var context = new BaseContext(self._currentContext);
            context._currentContext.delete(key);
            return context;
        };
    }
    return BaseContext;
}();
var ROOT_CONTEXT = new BaseContext();

},{"@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"irnKi":[function(require,module,exports,__globalThis) {
/*
 * Copyright The OpenTelemetry Authors
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *      https://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "NoopMeter", ()=>NoopMeter);
parcelHelpers.export(exports, "NoopMetric", ()=>NoopMetric);
parcelHelpers.export(exports, "NoopCounterMetric", ()=>NoopCounterMetric);
parcelHelpers.export(exports, "NoopUpDownCounterMetric", ()=>NoopUpDownCounterMetric);
parcelHelpers.export(exports, "NoopGaugeMetric", ()=>NoopGaugeMetric);
parcelHelpers.export(exports, "NoopHistogramMetric", ()=>NoopHistogramMetric);
parcelHelpers.export(exports, "NoopObservableMetric", ()=>NoopObservableMetric);
parcelHelpers.export(exports, "NoopObservableCounterMetric", ()=>NoopObservableCounterMetric);
parcelHelpers.export(exports, "NoopObservableGaugeMetric", ()=>NoopObservableGaugeMetric);
parcelHelpers.export(exports, "NoopObservableUpDownCounterMetric", ()=>NoopObservableUpDownCounterMetric);
parcelHelpers.export(exports, "NOOP_METER", ()=>NOOP_METER);
parcelHelpers.export(exports, "NOOP_COUNTER_METRIC", ()=>NOOP_COUNTER_METRIC);
parcelHelpers.export(exports, "NOOP_GAUGE_METRIC", ()=>NOOP_GAUGE_METRIC);
parcelHelpers.export(exports, "NOOP_HISTOGRAM_METRIC", ()=>NOOP_HISTOGRAM_METRIC);
parcelHelpers.export(exports, "NOOP_UP_DOWN_COUNTER_METRIC", ()=>NOOP_UP_DOWN_COUNTER_METRIC);
parcelHelpers.export(exports, "NOOP_OBSERVABLE_COUNTER_METRIC", ()=>NOOP_OBSERVABLE_COUNTER_METRIC);
parcelHelpers.export(exports, "NOOP_OBSERVABLE_GAUGE_METRIC", ()=>NOOP_OBSERVABLE_GAUGE_METRIC);
parcelHelpers.export(exports, "NOOP_OBSERVABLE_UP_DOWN_COUNTER_METRIC", ()=>NOOP_OBSERVABLE_UP_DOWN_COUNTER_METRIC);
/**
 * Create a no-op Meter
 */ parcelHelpers.export(exports, "createNoopMeter", ()=>createNoopMeter);
var __extends = undefined && undefined.__extends || function() {
    var extendStatics = function(d, b) {
        extendStatics = Object.setPrototypeOf || ({
            __proto__: []
        }) instanceof Array && function(d, b) {
            d.__proto__ = b;
        } || function(d, b) {
            for(var p in b)if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p];
        };
        return extendStatics(d, b);
    };
    return function(d, b) {
        if (typeof b !== "function" && b !== null) throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() {
            this.constructor = d;
        }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
}();
/**
 * NoopMeter is a noop implementation of the {@link Meter} interface. It reuses
 * constant NoopMetrics for all of its methods.
 */ var NoopMeter = /** @class */ function() {
    function NoopMeter() {}
    /**
     * @see {@link Meter.createGauge}
     */ NoopMeter.prototype.createGauge = function(_name, _options) {
        return NOOP_GAUGE_METRIC;
    };
    /**
     * @see {@link Meter.createHistogram}
     */ NoopMeter.prototype.createHistogram = function(_name, _options) {
        return NOOP_HISTOGRAM_METRIC;
    };
    /**
     * @see {@link Meter.createCounter}
     */ NoopMeter.prototype.createCounter = function(_name, _options) {
        return NOOP_COUNTER_METRIC;
    };
    /**
     * @see {@link Meter.createUpDownCounter}
     */ NoopMeter.prototype.createUpDownCounter = function(_name, _options) {
        return NOOP_UP_DOWN_COUNTER_METRIC;
    };
    /**
     * @see {@link Meter.createObservableGauge}
     */ NoopMeter.prototype.createObservableGauge = function(_name, _options) {
        return NOOP_OBSERVABLE_GAUGE_METRIC;
    };
    /**
     * @see {@link Meter.createObservableCounter}
     */ NoopMeter.prototype.createObservableCounter = function(_name, _options) {
        return NOOP_OBSERVABLE_COUNTER_METRIC;
    };
    /**
     * @see {@link Meter.createObservableUpDownCounter}
     */ NoopMeter.prototype.createObservableUpDownCounter = function(_name, _options) {
        return NOOP_OBSERVABLE_UP_DOWN_COUNTER_METRIC;
    };
    /**
     * @see {@link Meter.addBatchObservableCallback}
     */ NoopMeter.prototype.addBatchObservableCallback = function(_callback, _observables) {};
    /**
     * @see {@link Meter.removeBatchObservableCallback}
     */ NoopMeter.prototype.removeBatchObservableCallback = function(_callback) {};
    return NoopMeter;
}();
var NoopMetric = /** @class */ function() {
    function NoopMetric() {}
    return NoopMetric;
}();
var NoopCounterMetric = /** @class */ function(_super) {
    __extends(NoopCounterMetric, _super);
    function NoopCounterMetric() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    NoopCounterMetric.prototype.add = function(_value, _attributes) {};
    return NoopCounterMetric;
}(NoopMetric);
var NoopUpDownCounterMetric = /** @class */ function(_super) {
    __extends(NoopUpDownCounterMetric, _super);
    function NoopUpDownCounterMetric() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    NoopUpDownCounterMetric.prototype.add = function(_value, _attributes) {};
    return NoopUpDownCounterMetric;
}(NoopMetric);
var NoopGaugeMetric = /** @class */ function(_super) {
    __extends(NoopGaugeMetric, _super);
    function NoopGaugeMetric() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    NoopGaugeMetric.prototype.record = function(_value, _attributes) {};
    return NoopGaugeMetric;
}(NoopMetric);
var NoopHistogramMetric = /** @class */ function(_super) {
    __extends(NoopHistogramMetric, _super);
    function NoopHistogramMetric() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    NoopHistogramMetric.prototype.record = function(_value, _attributes) {};
    return NoopHistogramMetric;
}(NoopMetric);
var NoopObservableMetric = /** @class */ function() {
    function NoopObservableMetric() {}
    NoopObservableMetric.prototype.addCallback = function(_callback) {};
    NoopObservableMetric.prototype.removeCallback = function(_callback) {};
    return NoopObservableMetric;
}();
var NoopObservableCounterMetric = /** @class */ function(_super) {
    __extends(NoopObservableCounterMetric, _super);
    function NoopObservableCounterMetric() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    return NoopObservableCounterMetric;
}(NoopObservableMetric);
var NoopObservableGaugeMetric = /** @class */ function(_super) {
    __extends(NoopObservableGaugeMetric, _super);
    function NoopObservableGaugeMetric() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    return NoopObservableGaugeMetric;
}(NoopObservableMetric);
var NoopObservableUpDownCounterMetric = /** @class */ function(_super) {
    __extends(NoopObservableUpDownCounterMetric, _super);
    function NoopObservableUpDownCounterMetric() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    return NoopObservableUpDownCounterMetric;
}(NoopObservableMetric);
var NOOP_METER = new NoopMeter();
var NOOP_COUNTER_METRIC = new NoopCounterMetric();
var NOOP_GAUGE_METRIC = new NoopGaugeMetric();
var NOOP_HISTOGRAM_METRIC = new NoopHistogramMetric();
var NOOP_UP_DOWN_COUNTER_METRIC = new NoopUpDownCounterMetric();
var NOOP_OBSERVABLE_COUNTER_METRIC = new NoopObservableCounterMetric();
var NOOP_OBSERVABLE_GAUGE_METRIC = new NoopObservableGaugeMetric();
var NOOP_OBSERVABLE_UP_DOWN_COUNTER_METRIC = new NoopObservableUpDownCounterMetric();
function createNoopMeter() {
    return NOOP_METER;
}

},{"@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"3L3VX":[function(require,module,exports,__globalThis) {
/*
 * Copyright The OpenTelemetry Authors
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *      https://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "defaultTextMapGetter", ()=>defaultTextMapGetter);
parcelHelpers.export(exports, "defaultTextMapSetter", ()=>defaultTextMapSetter);
var defaultTextMapGetter = {
    get: function(carrier, key) {
        if (carrier == null) return undefined;
        return carrier[key];
    },
    keys: function(carrier) {
        if (carrier == null) return [];
        return Object.keys(carrier);
    }
};
var defaultTextMapSetter = {
    set: function(carrier, key, value) {
        if (carrier == null) return;
        carrier[key] = value;
    }
};

},{"@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"kQ0Z4":[function(require,module,exports,__globalThis) {
/*
 * Copyright The OpenTelemetry Authors
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *      https://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "ProxyTracer", ()=>ProxyTracer);
var _noopTracer = require("./NoopTracer");
var NOOP_TRACER = new (0, _noopTracer.NoopTracer)();
/**
 * Proxy tracer provided by the proxy tracer provider
 */ var ProxyTracer = /** @class */ function() {
    function ProxyTracer(_provider, name, version, options) {
        this._provider = _provider;
        this.name = name;
        this.version = version;
        this.options = options;
    }
    ProxyTracer.prototype.startSpan = function(name, options, context) {
        return this._getTracer().startSpan(name, options, context);
    };
    ProxyTracer.prototype.startActiveSpan = function(_name, _options, _context, _fn) {
        var tracer = this._getTracer();
        return Reflect.apply(tracer.startActiveSpan, tracer, arguments);
    };
    /**
     * Try to get a tracer from the proxy tracer provider.
     * If the proxy tracer provider has no delegate, return a noop tracer.
     */ ProxyTracer.prototype._getTracer = function() {
        if (this._delegate) return this._delegate;
        var tracer = this._provider.getDelegateTracer(this.name, this.version, this.options);
        if (!tracer) return NOOP_TRACER;
        this._delegate = tracer;
        return this._delegate;
    };
    return ProxyTracer;
}();

},{"./NoopTracer":"gCsUG","@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"gCsUG":[function(require,module,exports,__globalThis) {
/*
 * Copyright The OpenTelemetry Authors
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *      https://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "NoopTracer", ()=>NoopTracer);
var _context = require("../api/context");
var _contextUtils = require("../trace/context-utils");
var _nonRecordingSpan = require("./NonRecordingSpan");
var _spancontextUtils = require("./spancontext-utils");
var contextApi = (0, _context.ContextAPI).getInstance();
/**
 * No-op implementations of {@link Tracer}.
 */ var NoopTracer = /** @class */ function() {
    function NoopTracer() {}
    // startSpan starts a noop span.
    NoopTracer.prototype.startSpan = function(name, options, context) {
        if (context === void 0) context = contextApi.active();
        var root = Boolean(options === null || options === void 0 ? void 0 : options.root);
        if (root) return new (0, _nonRecordingSpan.NonRecordingSpan)();
        var parentFromContext = context && (0, _contextUtils.getSpanContext)(context);
        if (isSpanContext(parentFromContext) && (0, _spancontextUtils.isSpanContextValid)(parentFromContext)) return new (0, _nonRecordingSpan.NonRecordingSpan)(parentFromContext);
        else return new (0, _nonRecordingSpan.NonRecordingSpan)();
    };
    NoopTracer.prototype.startActiveSpan = function(name, arg2, arg3, arg4) {
        var opts;
        var ctx;
        var fn;
        if (arguments.length < 2) return;
        else if (arguments.length === 2) fn = arg2;
        else if (arguments.length === 3) {
            opts = arg2;
            fn = arg3;
        } else {
            opts = arg2;
            ctx = arg3;
            fn = arg4;
        }
        var parentContext = ctx !== null && ctx !== void 0 ? ctx : contextApi.active();
        var span = this.startSpan(name, opts, parentContext);
        var contextWithSpanSet = (0, _contextUtils.setSpan)(parentContext, span);
        return contextApi.with(contextWithSpanSet, fn, undefined, span);
    };
    return NoopTracer;
}();
function isSpanContext(spanContext) {
    return typeof spanContext === 'object' && typeof spanContext['spanId'] === 'string' && typeof spanContext['traceId'] === 'string' && typeof spanContext['traceFlags'] === 'number';
}

},{"../api/context":"f7atw","../trace/context-utils":"1ENWh","./NonRecordingSpan":"enlTB","./spancontext-utils":"bv17A","@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"f7atw":[function(require,module,exports,__globalThis) {
/*
 * Copyright The OpenTelemetry Authors
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *      https://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "ContextAPI", ()=>ContextAPI);
var _noopContextManager = require("../context/NoopContextManager");
var _globalUtils = require("../internal/global-utils");
var _diag = require("./diag");
var __read = undefined && undefined.__read || function(o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while((n === void 0 || n-- > 0) && !(r = i.next()).done)ar.push(r.value);
    } catch (error) {
        e = {
            error: error
        };
    } finally{
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        } finally{
            if (e) throw e.error;
        }
    }
    return ar;
};
var __spreadArray = undefined && undefined.__spreadArray || function(to, from, pack) {
    if (pack || arguments.length === 2) {
        for(var i = 0, l = from.length, ar; i < l; i++)if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
var API_NAME = 'context';
var NOOP_CONTEXT_MANAGER = new (0, _noopContextManager.NoopContextManager)();
/**
 * Singleton object which represents the entry point to the OpenTelemetry Context API
 */ var ContextAPI = /** @class */ function() {
    /** Empty private constructor prevents end users from constructing a new instance of the API */ function ContextAPI() {}
    /** Get the singleton instance of the Context API */ ContextAPI.getInstance = function() {
        if (!this._instance) this._instance = new ContextAPI();
        return this._instance;
    };
    /**
     * Set the current context manager.
     *
     * @returns true if the context manager was successfully registered, else false
     */ ContextAPI.prototype.setGlobalContextManager = function(contextManager) {
        return (0, _globalUtils.registerGlobal)(API_NAME, contextManager, (0, _diag.DiagAPI).instance());
    };
    /**
     * Get the currently active context
     */ ContextAPI.prototype.active = function() {
        return this._getContextManager().active();
    };
    /**
     * Execute a function with an active context
     *
     * @param context context to be active during function execution
     * @param fn function to execute in a context
     * @param thisArg optional receiver to be used for calling fn
     * @param args optional arguments forwarded to fn
     */ ContextAPI.prototype.with = function(context, fn, thisArg) {
        var _a;
        var args = [];
        for(var _i = 3; _i < arguments.length; _i++)args[_i - 3] = arguments[_i];
        return (_a = this._getContextManager()).with.apply(_a, __spreadArray([
            context,
            fn,
            thisArg
        ], __read(args), false));
    };
    /**
     * Bind a context to a target function or event emitter
     *
     * @param context context to bind to the event emitter or function. Defaults to the currently active context
     * @param target function or event emitter to bind
     */ ContextAPI.prototype.bind = function(context, target) {
        return this._getContextManager().bind(context, target);
    };
    ContextAPI.prototype._getContextManager = function() {
        return (0, _globalUtils.getGlobal)(API_NAME) || NOOP_CONTEXT_MANAGER;
    };
    /** Disable and remove the global context manager */ ContextAPI.prototype.disable = function() {
        this._getContextManager().disable();
        (0, _globalUtils.unregisterGlobal)(API_NAME, (0, _diag.DiagAPI).instance());
    };
    return ContextAPI;
}();

},{"../context/NoopContextManager":"5hGhU","../internal/global-utils":"4g6BY","./diag":"h9doG","@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"5hGhU":[function(require,module,exports,__globalThis) {
/*
 * Copyright The OpenTelemetry Authors
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *      https://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "NoopContextManager", ()=>NoopContextManager);
var _context = require("./context");
var __read = undefined && undefined.__read || function(o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while((n === void 0 || n-- > 0) && !(r = i.next()).done)ar.push(r.value);
    } catch (error) {
        e = {
            error: error
        };
    } finally{
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        } finally{
            if (e) throw e.error;
        }
    }
    return ar;
};
var __spreadArray = undefined && undefined.__spreadArray || function(to, from, pack) {
    if (pack || arguments.length === 2) {
        for(var i = 0, l = from.length, ar; i < l; i++)if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
var NoopContextManager = /** @class */ function() {
    function NoopContextManager() {}
    NoopContextManager.prototype.active = function() {
        return 0, _context.ROOT_CONTEXT;
    };
    NoopContextManager.prototype.with = function(_context, fn, thisArg) {
        var args = [];
        for(var _i = 3; _i < arguments.length; _i++)args[_i - 3] = arguments[_i];
        return fn.call.apply(fn, __spreadArray([
            thisArg
        ], __read(args), false));
    };
    NoopContextManager.prototype.bind = function(_context, target) {
        return target;
    };
    NoopContextManager.prototype.enable = function() {
        return this;
    };
    NoopContextManager.prototype.disable = function() {
        return this;
    };
    return NoopContextManager;
}();

},{"./context":"amn9k","@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"1ENWh":[function(require,module,exports,__globalThis) {
/*
 * Copyright The OpenTelemetry Authors
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *      https://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
/**
 * Return the span if one exists
 *
 * @param context context to get span from
 */ parcelHelpers.export(exports, "getSpan", ()=>getSpan);
/**
 * Gets the span from the current context, if one exists.
 */ parcelHelpers.export(exports, "getActiveSpan", ()=>getActiveSpan);
/**
 * Set the span on a context
 *
 * @param context context to use as parent
 * @param span span to set active
 */ parcelHelpers.export(exports, "setSpan", ()=>setSpan);
/**
 * Remove current span stored in the context
 *
 * @param context context to delete span from
 */ parcelHelpers.export(exports, "deleteSpan", ()=>deleteSpan);
/**
 * Wrap span context in a NoopSpan and set as span in a new
 * context
 *
 * @param context context to set active span on
 * @param spanContext span context to be wrapped
 */ parcelHelpers.export(exports, "setSpanContext", ()=>setSpanContext);
/**
 * Get the span context of the span if it exists.
 *
 * @param context context to get values from
 */ parcelHelpers.export(exports, "getSpanContext", ()=>getSpanContext);
var _context = require("../context/context");
var _nonRecordingSpan = require("./NonRecordingSpan");
var _context1 = require("../api/context");
/**
 * span key
 */ var SPAN_KEY = (0, _context.createContextKey)('OpenTelemetry Context Key SPAN');
function getSpan(context) {
    return context.getValue(SPAN_KEY) || undefined;
}
function getActiveSpan() {
    return getSpan((0, _context1.ContextAPI).getInstance().active());
}
function setSpan(context, span) {
    return context.setValue(SPAN_KEY, span);
}
function deleteSpan(context) {
    return context.deleteValue(SPAN_KEY);
}
function setSpanContext(context, spanContext) {
    return setSpan(context, new (0, _nonRecordingSpan.NonRecordingSpan)(spanContext));
}
function getSpanContext(context) {
    var _a;
    return (_a = getSpan(context)) === null || _a === void 0 ? void 0 : _a.spanContext();
}

},{"../context/context":"amn9k","./NonRecordingSpan":"enlTB","../api/context":"f7atw","@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"enlTB":[function(require,module,exports,__globalThis) {
/*
 * Copyright The OpenTelemetry Authors
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *      https://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "NonRecordingSpan", ()=>NonRecordingSpan);
var _invalidSpanConstants = require("./invalid-span-constants");
/**
 * The NonRecordingSpan is the default {@link Span} that is used when no Span
 * implementation is available. All operations are no-op including context
 * propagation.
 */ var NonRecordingSpan = /** @class */ function() {
    function NonRecordingSpan(_spanContext) {
        if (_spanContext === void 0) _spanContext = (0, _invalidSpanConstants.INVALID_SPAN_CONTEXT);
        this._spanContext = _spanContext;
    }
    // Returns a SpanContext.
    NonRecordingSpan.prototype.spanContext = function() {
        return this._spanContext;
    };
    // By default does nothing
    NonRecordingSpan.prototype.setAttribute = function(_key, _value) {
        return this;
    };
    // By default does nothing
    NonRecordingSpan.prototype.setAttributes = function(_attributes) {
        return this;
    };
    // By default does nothing
    NonRecordingSpan.prototype.addEvent = function(_name, _attributes) {
        return this;
    };
    NonRecordingSpan.prototype.addLink = function(_link) {
        return this;
    };
    NonRecordingSpan.prototype.addLinks = function(_links) {
        return this;
    };
    // By default does nothing
    NonRecordingSpan.prototype.setStatus = function(_status) {
        return this;
    };
    // By default does nothing
    NonRecordingSpan.prototype.updateName = function(_name) {
        return this;
    };
    // By default does nothing
    NonRecordingSpan.prototype.end = function(_endTime) {};
    // isRecording always returns false for NonRecordingSpan.
    NonRecordingSpan.prototype.isRecording = function() {
        return false;
    };
    // By default does nothing
    NonRecordingSpan.prototype.recordException = function(_exception, _time) {};
    return NonRecordingSpan;
}();

},{"./invalid-span-constants":"jdt5C","@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"jdt5C":[function(require,module,exports,__globalThis) {
/*
 * Copyright The OpenTelemetry Authors
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *      https://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "INVALID_SPANID", ()=>INVALID_SPANID);
parcelHelpers.export(exports, "INVALID_TRACEID", ()=>INVALID_TRACEID);
parcelHelpers.export(exports, "INVALID_SPAN_CONTEXT", ()=>INVALID_SPAN_CONTEXT);
var _traceFlags = require("./trace_flags");
var INVALID_SPANID = '0000000000000000';
var INVALID_TRACEID = '00000000000000000000000000000000';
var INVALID_SPAN_CONTEXT = {
    traceId: INVALID_TRACEID,
    spanId: INVALID_SPANID,
    traceFlags: (0, _traceFlags.TraceFlags).NONE
};

},{"./trace_flags":"jhO1Z","@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"jhO1Z":[function(require,module,exports,__globalThis) {
/*
 * Copyright The OpenTelemetry Authors
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *      https://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "TraceFlags", ()=>TraceFlags);
var TraceFlags;
(function(TraceFlags) {
    /** Represents no flag set. */ TraceFlags[TraceFlags["NONE"] = 0] = "NONE";
    /** Bit to represent whether trace is sampled in trace flags. */ TraceFlags[TraceFlags["SAMPLED"] = 1] = "SAMPLED";
})(TraceFlags || (TraceFlags = {}));

},{"@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"bv17A":[function(require,module,exports,__globalThis) {
/*
 * Copyright The OpenTelemetry Authors
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *      https://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "isValidTraceId", ()=>isValidTraceId);
parcelHelpers.export(exports, "isValidSpanId", ()=>isValidSpanId);
/**
 * Returns true if this {@link SpanContext} is valid.
 * @return true if this {@link SpanContext} is valid.
 */ parcelHelpers.export(exports, "isSpanContextValid", ()=>isSpanContextValid);
/**
 * Wrap the given {@link SpanContext} in a new non-recording {@link Span}
 *
 * @param spanContext span context to be wrapped
 * @returns a new non-recording {@link Span} with the provided context
 */ parcelHelpers.export(exports, "wrapSpanContext", ()=>wrapSpanContext);
var _invalidSpanConstants = require("./invalid-span-constants");
var _nonRecordingSpan = require("./NonRecordingSpan");
var VALID_TRACEID_REGEX = /^([0-9a-f]{32})$/i;
var VALID_SPANID_REGEX = /^[0-9a-f]{16}$/i;
function isValidTraceId(traceId) {
    return VALID_TRACEID_REGEX.test(traceId) && traceId !== (0, _invalidSpanConstants.INVALID_TRACEID);
}
function isValidSpanId(spanId) {
    return VALID_SPANID_REGEX.test(spanId) && spanId !== (0, _invalidSpanConstants.INVALID_SPANID);
}
function isSpanContextValid(spanContext) {
    return isValidTraceId(spanContext.traceId) && isValidSpanId(spanContext.spanId);
}
function wrapSpanContext(spanContext) {
    return new (0, _nonRecordingSpan.NonRecordingSpan)(spanContext);
}

},{"./invalid-span-constants":"jdt5C","./NonRecordingSpan":"enlTB","@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"iWUmK":[function(require,module,exports,__globalThis) {
/*
 * Copyright The OpenTelemetry Authors
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *      https://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "ProxyTracerProvider", ()=>ProxyTracerProvider);
var _proxyTracer = require("./ProxyTracer");
var _noopTracerProvider = require("./NoopTracerProvider");
var NOOP_TRACER_PROVIDER = new (0, _noopTracerProvider.NoopTracerProvider)();
/**
 * Tracer provider which provides {@link ProxyTracer}s.
 *
 * Before a delegate is set, tracers provided are NoOp.
 *   When a delegate is set, traces are provided from the delegate.
 *   When a delegate is set after tracers have already been provided,
 *   all tracers already provided will use the provided delegate implementation.
 */ var ProxyTracerProvider = /** @class */ function() {
    function ProxyTracerProvider() {}
    /**
     * Get a {@link ProxyTracer}
     */ ProxyTracerProvider.prototype.getTracer = function(name, version, options) {
        var _a;
        return (_a = this.getDelegateTracer(name, version, options)) !== null && _a !== void 0 ? _a : new (0, _proxyTracer.ProxyTracer)(this, name, version, options);
    };
    ProxyTracerProvider.prototype.getDelegate = function() {
        var _a;
        return (_a = this._delegate) !== null && _a !== void 0 ? _a : NOOP_TRACER_PROVIDER;
    };
    /**
     * Set the delegate tracer provider
     */ ProxyTracerProvider.prototype.setDelegate = function(delegate) {
        this._delegate = delegate;
    };
    ProxyTracerProvider.prototype.getDelegateTracer = function(name, version, options) {
        var _a;
        return (_a = this._delegate) === null || _a === void 0 ? void 0 : _a.getTracer(name, version, options);
    };
    return ProxyTracerProvider;
}();

},{"./ProxyTracer":"kQ0Z4","./NoopTracerProvider":"3Ht8v","@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"3Ht8v":[function(require,module,exports,__globalThis) {
/*
 * Copyright The OpenTelemetry Authors
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *      https://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "NoopTracerProvider", ()=>NoopTracerProvider);
var _noopTracer = require("./NoopTracer");
/**
 * An implementation of the {@link TracerProvider} which returns an impotent
 * Tracer for all calls to `getTracer`.
 *
 * All operations are no-op.
 */ var NoopTracerProvider = /** @class */ function() {
    function NoopTracerProvider() {}
    NoopTracerProvider.prototype.getTracer = function(_name, _version, _options) {
        return new (0, _noopTracer.NoopTracer)();
    };
    return NoopTracerProvider;
}();

},{"./NoopTracer":"gCsUG","@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"l4IpC":[function(require,module,exports,__globalThis) {
/*
 * Copyright The OpenTelemetry Authors
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *      https://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ // Split module-level variable definition into separate files to allow
// tree-shaking on each api instance.
var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "context", ()=>context);
var _context = require("./api/context");
var context = (0, _context.ContextAPI).getInstance();

},{"./api/context":"f7atw","@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"ca71U":[function(require,module,exports,__globalThis) {
/*
 * Copyright The OpenTelemetry Authors
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *      https://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ // Split module-level variable definition into separate files to allow
// tree-shaking on each api instance.
var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "diag", ()=>diag);
var _diag = require("./api/diag");
var diag = (0, _diag.DiagAPI).instance();

},{"./api/diag":"h9doG","@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"flr8Y":[function(require,module,exports,__globalThis) {
/*
 * Copyright The OpenTelemetry Authors
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *      https://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ // Split module-level variable definition into separate files to allow
// tree-shaking on each api instance.
var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "metrics", ()=>metrics);
var _metrics = require("./api/metrics");
var metrics = (0, _metrics.MetricsAPI).getInstance();

},{"./api/metrics":"b45r5","@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"b45r5":[function(require,module,exports,__globalThis) {
/*
 * Copyright The OpenTelemetry Authors
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *      https://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "MetricsAPI", ()=>MetricsAPI);
var _noopMeterProvider = require("../metrics/NoopMeterProvider");
var _globalUtils = require("../internal/global-utils");
var _diag = require("./diag");
var API_NAME = 'metrics';
/**
 * Singleton object which represents the entry point to the OpenTelemetry Metrics API
 */ var MetricsAPI = /** @class */ function() {
    /** Empty private constructor prevents end users from constructing a new instance of the API */ function MetricsAPI() {}
    /** Get the singleton instance of the Metrics API */ MetricsAPI.getInstance = function() {
        if (!this._instance) this._instance = new MetricsAPI();
        return this._instance;
    };
    /**
     * Set the current global meter provider.
     * Returns true if the meter provider was successfully registered, else false.
     */ MetricsAPI.prototype.setGlobalMeterProvider = function(provider) {
        return (0, _globalUtils.registerGlobal)(API_NAME, provider, (0, _diag.DiagAPI).instance());
    };
    /**
     * Returns the global meter provider.
     */ MetricsAPI.prototype.getMeterProvider = function() {
        return (0, _globalUtils.getGlobal)(API_NAME) || (0, _noopMeterProvider.NOOP_METER_PROVIDER);
    };
    /**
     * Returns a meter from the global meter provider.
     */ MetricsAPI.prototype.getMeter = function(name, version, options) {
        return this.getMeterProvider().getMeter(name, version, options);
    };
    /** Remove the global meter provider */ MetricsAPI.prototype.disable = function() {
        (0, _globalUtils.unregisterGlobal)(API_NAME, (0, _diag.DiagAPI).instance());
    };
    return MetricsAPI;
}();

},{"../metrics/NoopMeterProvider":"57xUb","../internal/global-utils":"4g6BY","./diag":"h9doG","@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"57xUb":[function(require,module,exports,__globalThis) {
/*
 * Copyright The OpenTelemetry Authors
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *      https://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "NoopMeterProvider", ()=>NoopMeterProvider);
parcelHelpers.export(exports, "NOOP_METER_PROVIDER", ()=>NOOP_METER_PROVIDER);
var _noopMeter = require("./NoopMeter");
/**
 * An implementation of the {@link MeterProvider} which returns an impotent Meter
 * for all calls to `getMeter`
 */ var NoopMeterProvider = /** @class */ function() {
    function NoopMeterProvider() {}
    NoopMeterProvider.prototype.getMeter = function(_name, _version, _options) {
        return 0, _noopMeter.NOOP_METER;
    };
    return NoopMeterProvider;
}();
var NOOP_METER_PROVIDER = new NoopMeterProvider();

},{"./NoopMeter":"irnKi","@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"7haOh":[function(require,module,exports,__globalThis) {
/*
 * Copyright The OpenTelemetry Authors
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *      https://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ // Split module-level variable definition into separate files to allow
// tree-shaking on each api instance.
var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "propagation", ()=>propagation);
var _propagation = require("./api/propagation");
var propagation = (0, _propagation.PropagationAPI).getInstance();

},{"./api/propagation":"kuWG7","@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"kuWG7":[function(require,module,exports,__globalThis) {
/*
 * Copyright The OpenTelemetry Authors
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *      https://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "PropagationAPI", ()=>PropagationAPI);
var _globalUtils = require("../internal/global-utils");
var _noopTextMapPropagator = require("../propagation/NoopTextMapPropagator");
var _textMapPropagator = require("../propagation/TextMapPropagator");
var _contextHelpers = require("../baggage/context-helpers");
var _utils = require("../baggage/utils");
var _diag = require("./diag");
var API_NAME = 'propagation';
var NOOP_TEXT_MAP_PROPAGATOR = new (0, _noopTextMapPropagator.NoopTextMapPropagator)();
/**
 * Singleton object which represents the entry point to the OpenTelemetry Propagation API
 */ var PropagationAPI = /** @class */ function() {
    /** Empty private constructor prevents end users from constructing a new instance of the API */ function PropagationAPI() {
        this.createBaggage = (0, _utils.createBaggage);
        this.getBaggage = (0, _contextHelpers.getBaggage);
        this.getActiveBaggage = (0, _contextHelpers.getActiveBaggage);
        this.setBaggage = (0, _contextHelpers.setBaggage);
        this.deleteBaggage = (0, _contextHelpers.deleteBaggage);
    }
    /** Get the singleton instance of the Propagator API */ PropagationAPI.getInstance = function() {
        if (!this._instance) this._instance = new PropagationAPI();
        return this._instance;
    };
    /**
     * Set the current propagator.
     *
     * @returns true if the propagator was successfully registered, else false
     */ PropagationAPI.prototype.setGlobalPropagator = function(propagator) {
        return (0, _globalUtils.registerGlobal)(API_NAME, propagator, (0, _diag.DiagAPI).instance());
    };
    /**
     * Inject context into a carrier to be propagated inter-process
     *
     * @param context Context carrying tracing data to inject
     * @param carrier carrier to inject context into
     * @param setter Function used to set values on the carrier
     */ PropagationAPI.prototype.inject = function(context, carrier, setter) {
        if (setter === void 0) setter = (0, _textMapPropagator.defaultTextMapSetter);
        return this._getGlobalPropagator().inject(context, carrier, setter);
    };
    /**
     * Extract context from a carrier
     *
     * @param context Context which the newly created context will inherit from
     * @param carrier Carrier to extract context from
     * @param getter Function used to extract keys from a carrier
     */ PropagationAPI.prototype.extract = function(context, carrier, getter) {
        if (getter === void 0) getter = (0, _textMapPropagator.defaultTextMapGetter);
        return this._getGlobalPropagator().extract(context, carrier, getter);
    };
    /**
     * Return a list of all fields which may be used by the propagator.
     */ PropagationAPI.prototype.fields = function() {
        return this._getGlobalPropagator().fields();
    };
    /** Remove the global propagator */ PropagationAPI.prototype.disable = function() {
        (0, _globalUtils.unregisterGlobal)(API_NAME, (0, _diag.DiagAPI).instance());
    };
    PropagationAPI.prototype._getGlobalPropagator = function() {
        return (0, _globalUtils.getGlobal)(API_NAME) || NOOP_TEXT_MAP_PROPAGATOR;
    };
    return PropagationAPI;
}();

},{"../internal/global-utils":"4g6BY","../propagation/NoopTextMapPropagator":"aeUcj","../propagation/TextMapPropagator":"3L3VX","../baggage/context-helpers":"l2i5x","../baggage/utils":"7Z76g","./diag":"h9doG","@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"aeUcj":[function(require,module,exports,__globalThis) {
/*
 * Copyright The OpenTelemetry Authors
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *      https://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * No-op implementations of {@link TextMapPropagator}.
 */ var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "NoopTextMapPropagator", ()=>NoopTextMapPropagator);
var NoopTextMapPropagator = /** @class */ function() {
    function NoopTextMapPropagator() {}
    /** Noop inject function does nothing */ NoopTextMapPropagator.prototype.inject = function(_context, _carrier) {};
    /** Noop extract function does nothing and returns the input context */ NoopTextMapPropagator.prototype.extract = function(context, _carrier) {
        return context;
    };
    NoopTextMapPropagator.prototype.fields = function() {
        return [];
    };
    return NoopTextMapPropagator;
}();

},{"@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"l2i5x":[function(require,module,exports,__globalThis) {
/*
 * Copyright The OpenTelemetry Authors
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *      https://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
/**
 * Retrieve the current baggage from the given context
 *
 * @param {Context} Context that manage all context values
 * @returns {Baggage} Extracted baggage from the context
 */ parcelHelpers.export(exports, "getBaggage", ()=>getBaggage);
/**
 * Retrieve the current baggage from the active/current context
 *
 * @returns {Baggage} Extracted baggage from the context
 */ parcelHelpers.export(exports, "getActiveBaggage", ()=>getActiveBaggage);
/**
 * Store a baggage in the given context
 *
 * @param {Context} Context that manage all context values
 * @param {Baggage} baggage that will be set in the actual context
 */ parcelHelpers.export(exports, "setBaggage", ()=>setBaggage);
/**
 * Delete the baggage stored in the given context
 *
 * @param {Context} Context that manage all context values
 */ parcelHelpers.export(exports, "deleteBaggage", ()=>deleteBaggage);
var _context = require("../api/context");
var _context1 = require("../context/context");
/**
 * Baggage key
 */ var BAGGAGE_KEY = (0, _context1.createContextKey)('OpenTelemetry Baggage Key');
function getBaggage(context) {
    return context.getValue(BAGGAGE_KEY) || undefined;
}
function getActiveBaggage() {
    return getBaggage((0, _context.ContextAPI).getInstance().active());
}
function setBaggage(context, baggage) {
    return context.setValue(BAGGAGE_KEY, baggage);
}
function deleteBaggage(context) {
    return context.deleteValue(BAGGAGE_KEY);
}

},{"../api/context":"f7atw","../context/context":"amn9k","@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"31pDO":[function(require,module,exports,__globalThis) {
/*
 * Copyright The OpenTelemetry Authors
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *      https://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ // Split module-level variable definition into separate files to allow
// tree-shaking on each api instance.
var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "trace", ()=>trace);
var _trace = require("./api/trace");
var trace = (0, _trace.TraceAPI).getInstance();

},{"./api/trace":"lxVxY","@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"lxVxY":[function(require,module,exports,__globalThis) {
/*
 * Copyright The OpenTelemetry Authors
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *      https://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "TraceAPI", ()=>TraceAPI);
var _globalUtils = require("../internal/global-utils");
var _proxyTracerProvider = require("../trace/ProxyTracerProvider");
var _spancontextUtils = require("../trace/spancontext-utils");
var _contextUtils = require("../trace/context-utils");
var _diag = require("./diag");
var API_NAME = 'trace';
/**
 * Singleton object which represents the entry point to the OpenTelemetry Tracing API
 */ var TraceAPI = /** @class */ function() {
    /** Empty private constructor prevents end users from constructing a new instance of the API */ function TraceAPI() {
        this._proxyTracerProvider = new (0, _proxyTracerProvider.ProxyTracerProvider)();
        this.wrapSpanContext = (0, _spancontextUtils.wrapSpanContext);
        this.isSpanContextValid = (0, _spancontextUtils.isSpanContextValid);
        this.deleteSpan = (0, _contextUtils.deleteSpan);
        this.getSpan = (0, _contextUtils.getSpan);
        this.getActiveSpan = (0, _contextUtils.getActiveSpan);
        this.getSpanContext = (0, _contextUtils.getSpanContext);
        this.setSpan = (0, _contextUtils.setSpan);
        this.setSpanContext = (0, _contextUtils.setSpanContext);
    }
    /** Get the singleton instance of the Trace API */ TraceAPI.getInstance = function() {
        if (!this._instance) this._instance = new TraceAPI();
        return this._instance;
    };
    /**
     * Set the current global tracer.
     *
     * @returns true if the tracer provider was successfully registered, else false
     */ TraceAPI.prototype.setGlobalTracerProvider = function(provider) {
        var success = (0, _globalUtils.registerGlobal)(API_NAME, this._proxyTracerProvider, (0, _diag.DiagAPI).instance());
        if (success) this._proxyTracerProvider.setDelegate(provider);
        return success;
    };
    /**
     * Returns the global tracer provider.
     */ TraceAPI.prototype.getTracerProvider = function() {
        return (0, _globalUtils.getGlobal)(API_NAME) || this._proxyTracerProvider;
    };
    /**
     * Returns a tracer from the global tracer provider.
     */ TraceAPI.prototype.getTracer = function(name, version) {
        return this.getTracerProvider().getTracer(name, version);
    };
    /** Remove the global tracer provider */ TraceAPI.prototype.disable = function() {
        (0, _globalUtils.unregisterGlobal)(API_NAME, (0, _diag.DiagAPI).instance());
        this._proxyTracerProvider = new (0, _proxyTracerProvider.ProxyTracerProvider)();
    };
    return TraceAPI;
}();

},{"../internal/global-utils":"4g6BY","../trace/ProxyTracerProvider":"iWUmK","../trace/spancontext-utils":"bv17A","../trace/context-utils":"1ENWh","./diag":"h9doG","@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"8DBX6":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "startLighthouseObserver", ()=>(0, _lighthouseMetrics.startLighthouseObserver));
parcelHelpers.export(exports, "getLighthouseMetrics", ()=>(0, _lighthouseMetrics.getLighthouseMetrics));
parcelHelpers.export(exports, "getCacheHitRatio", ()=>(0, _cacheHitRatio.getCacheHitRatio));
var _lighthouseMetrics = require("./utils/lighthouse-metrics");
var _cacheHitRatio = require("./utils/cache-hit-ratio");

},{"./utils/lighthouse-metrics":"bpvu3","./utils/cache-hit-ratio":false,"@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"bpvu3":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "startLighthouseObserver", ()=>startLighthouseObserver);
// eslint-disable-next-line @atlaskit/volt-strict-mode/no-multiple-exports
parcelHelpers.export(exports, "getLighthouseMetrics", ()=>getLighthouseMetrics);
var _cls = require("./cls");
var _const = require("./const");
var _tbt = require("./tbt");
var _buffer = require("./utils/buffer");
var _observer = require("./utils/observer");
function startLighthouseObserver() {
    (0, _observer.startLSObserver)();
    (0, _observer.startLTObserver)();
}
function getLighthouseMetrics({ start, stop }) {
    const tbt = (0, _tbt.getTBT)(start, stop, (0, _buffer.EntriesBuffer)[(0, _const.PerformanceObserverEntryTypes).LongTask]);
    // no round as CLS is usually 0-1
    const cls = (0, _cls.getCLS)(start, stop, (0, _buffer.EntriesBuffer)[(0, _const.PerformanceObserverEntryTypes).LayoutShift]);
    return {
        'metric:tbt': Math.round(tbt.total),
        'metric:tbt:observed': Math.round(tbt.observed),
        'metric:cls': cls
    };
}

},{"./cls":"4NETM","./const":"cQ1Ua","./tbt":"13Yt0","./utils/buffer":"krzpP","./utils/observer":"gRSdC","@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"4NETM":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "getCLS", ()=>getCLS);
function isSameRects(rect1, rect2) {
    return rect1.x === rect2.x && rect1.y === rect2.y && rect1.width === rect2.width && rect1.height === rect2.height && rect1.top === rect2.top && rect1.right === rect2.right && rect1.bottom === rect2.bottom && rect1.left === rect2.left;
}
function getCLS(start, stop, buffer) {
    const layoutShifts = buffer.getAll().filter((_entry)=>{
        var _entry_sources;
        const entry = _entry;
        const isWithinObservationWindow = entry.startTime >= start && entry.startTime <= stop;
        const allSourcesHaveSameRects = entry === null || entry === void 0 ? void 0 : (_entry_sources = entry.sources) === null || _entry_sources === void 0 ? void 0 : _entry_sources.every(({ previousRect, currentRect })=>isSameRects(previousRect, currentRect));
        return isWithinObservationWindow && !allSourcesHaveSameRects;
    });
    const sessionWindows = [];
    let currentWindow = null;
    // Group layout shifts into session windows
    for (const shift of layoutShifts){
        const { startTime } = shift;
        const endTime = shift.startTime + shift.duration;
        const score = shift.value;
        if (currentWindow === null || startTime - currentWindow.endTime > 1000 || endTime - currentWindow.startTime > 5000) {
            // Start a new session window
            currentWindow = {
                startTime,
                endTime,
                score
            };
            sessionWindows.push(currentWindow);
        } else {
            // Add layout shift to current session window
            currentWindow.endTime = endTime;
            currentWindow.score += score;
        }
    }
    // Find session window with highest cumulative score
    const maxScore = sessionWindows.reduce((max, sessionWindow)=>sessionWindow.score > max ? sessionWindow.score : max, 0);
    // Return score of largest burst as CLS metric
    return Math.round(maxScore * 10000) / 10000;
}

},{"@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"cQ1Ua":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "PerformanceObserverEntryTypes", ()=>PerformanceObserverEntryTypes);
const PerformanceObserverEntryTypes = {
    LayoutShift: 'layout-shift',
    LongTask: 'longtask'
};

},{"@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"13Yt0":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "getTBT", ()=>getTBT);
const MAX_ACCEPTABLE_TASK_DURATION = 50;
function getTBT(start, stop, buffer) {
    return buffer.getAll().filter((entry)=>entry.startTime <= stop && entry.duration > MAX_ACCEPTABLE_TASK_DURATION && (entry.startTime >= start || entry.startTime + entry.duration >= start || entry.startTime <= start && entry.startTime + entry.duration >= stop)).reduce((tbt, entry)=>{
        const longTaskStop = entry.startTime + entry.duration;
        const intersectStart = Math.max(entry.startTime + MAX_ACCEPTABLE_TASK_DURATION, start);
        const intersectStop = Math.min(longTaskStop, stop);
        const longTaskIncluded = Math.max(intersectStop - intersectStart, 0);
        // eslint-disable-next-line no-param-reassign
        tbt.observed += entry.duration - MAX_ACCEPTABLE_TASK_DURATION;
        // eslint-disable-next-line no-param-reassign
        tbt.total += longTaskIncluded;
        return tbt;
    }, {
        total: 0,
        observed: 0
    });
}

},{"@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"krzpP":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "BufferWithMaxLength", ()=>BufferWithMaxLength);
parcelHelpers.export(exports, "EntriesBuffer", ()=>EntriesBuffer);
var _const = require("../../const");
class BufferWithMaxLength {
    push(item) {
        if (this.full || this.maxLength === this.buffer.length) {
            this.full = true;
            this.buffer.shift();
        }
        this.buffer.push(item);
    }
    getAll() {
        return this.buffer;
    }
    constructor(maxLength = 1000){
        this.buffer = [];
        this.full = false;
        this.maxLength = maxLength;
    }
}
const EntriesBuffer = {
    [(0, _const.PerformanceObserverEntryTypes).LongTask]: new BufferWithMaxLength(),
    [(0, _const.PerformanceObserverEntryTypes).LayoutShift]: new BufferWithMaxLength()
};

},{"../../const":"cQ1Ua","@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"gRSdC":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "startLSObserver", ()=>startLSObserver);
// eslint-disable-next-line @atlaskit/volt-strict-mode/no-multiple-exports
parcelHelpers.export(exports, "startLTObserver", ()=>startLTObserver);
var _const = require("../../const");
var _buffer = require("../buffer");
let pe = null;
function getObserver() {
    if (typeof PerformanceObserver !== 'function') // Only instantiate the IntersectionObserver if it's supported
    return null;
    if (pe !== null) return pe;
    const performanceObserverCallback = (list)=>{
        list.getEntries().forEach((entry)=>{
            if (entry.entryType === (0, _const.PerformanceObserverEntryTypes).LayoutShift) (0, _buffer.EntriesBuffer)[(0, _const.PerformanceObserverEntryTypes).LayoutShift].push(entry);
            if (entry.entryType === (0, _const.PerformanceObserverEntryTypes).LongTask) (0, _buffer.EntriesBuffer)[(0, _const.PerformanceObserverEntryTypes).LongTask].push(entry);
        });
    };
    pe = new PerformanceObserver(performanceObserverCallback);
    return pe;
}
function startLSObserver() {
    var _getObserver;
    (_getObserver = getObserver()) === null || _getObserver === void 0 ? void 0 : _getObserver.observe({
        type: (0, _const.PerformanceObserverEntryTypes).LayoutShift,
        buffered: true
    });
}
function startLTObserver() {
    var _getObserver;
    (_getObserver = getObserver()) === null || _getObserver === void 0 ? void 0 : _getObserver.observe({
        type: (0, _const.PerformanceObserverEntryTypes).LongTask,
        buffered: true
    });
}

},{"../../const":"cQ1Ua","../buffer":"krzpP","@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"bx9i6":[function(require,module,exports,__globalThis) {
/* eslint-disable @atlaskit/volt-strict-mode/no-multiple-exports */ var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
/**
 * @internal Test-only helper. Do not use outside unit tests.
 */ parcelHelpers.export(exports, "__resetFedrampOverrideCacheForTests", ()=>__resetFedrampOverrideCacheForTests);
/**
 * Returns true when react-ufo should apply its FedRAMP-Moderate hardening:
 *
 *   - all `selectorConfig` fields forced to `false`
 *   - `rawData.att`, `obs[].att`, `rawData.lbl`, `rawData.lblMode` scrubbed
 *     from the `raw-handler` revision payload
 *
 * Centralising the perimeter check here ensures every FedRAMP code path in
 * react-ufo is gated by the same `isFedrampModerate()` result.
 *
 * Defensive against `isFedrampModerate()` ever throwing — falls back to
 * `false` so the metrics pipeline never breaks because of perimeter
 * detection.
 */ parcelHelpers.export(exports, "isFedrampOverrideActive", ()=>isFedrampOverrideActive);
parcelHelpers.export(exports, "DEFAULT_TTVC_REVISION", ()=>DEFAULT_TTVC_REVISION);
parcelHelpers.export(exports, "getDefaultTTVCRevision", ()=>getDefaultTTVCRevision);
parcelHelpers.export(exports, "UNKNOWN_INTERACTION_RATE", ()=>UNKNOWN_INTERACTION_RATE);
parcelHelpers.export(exports, "setUFOConfig", ()=>setUFOConfig);
parcelHelpers.export(exports, "getConfig", ()=>getConfig);
/**
 * Centralised resolver for the active `SelectorConfig` for the VC observer.
 *
 * Precedence (highest first):
 *   1. **FedRAMP override** — when `isFedrampModerate()` is true, every
 *      selector field is forced to `false` regardless of any other input.
 *      This guarantees that no `id`, `testId`, `role`, `className`, or
 *      `data-vc` selectors escape the FedRAMP perimeter via the
 *      raw-handler payload.
 *   2. **Caller-provided override** — `callerOverride` argument (e.g. an
 *      explicit `selectorConfig` passed by a per-interaction VC observer
 *      consumer).
 *   3. **Centrally configured value** — `config.vc.selectorConfig` as set
 *      via `setUFOConfig`.
 *   4. **Caller-provided default** — `defaultConfig` argument (used by call
 *      sites that have a historical hard-coded fallback they want to keep
 *      when nothing else is available).
 *   5. `undefined` — when no caller default is supplied either.
 *
 * @param callerOverride Explicit per-call-site selectorConfig override.
 * @param defaultConfig  Hard-coded fallback used only when nothing else
 *                       provided a value.
 */ parcelHelpers.export(exports, "getSelectorConfig", ()=>getSelectorConfig);
/**
 * Check if UFO is enabled based on the config.enabled field.
 *
 * @returns true if UFO is enabled, false if disabled
 */ parcelHelpers.export(exports, "isUFOEnabled", ()=>isUFOEnabled);
parcelHelpers.export(exports, "getEnabledVCRevisions", ()=>getEnabledVCRevisions);
parcelHelpers.export(exports, "isVCRevisionEnabled", ()=>isVCRevisionEnabled);
parcelHelpers.export(exports, "getMostRecentVCRevision", ()=>getMostRecentVCRevision);
parcelHelpers.export(exports, "getReactHydrationStats", ()=>getReactHydrationStats);
parcelHelpers.export(exports, "getInteractionRate", ()=>getInteractionRate);
parcelHelpers.export(exports, "getVCRawDataInteractionRate", ()=>getVCRawDataInteractionRate);
parcelHelpers.export(exports, "shouldUseRawDataThirdPartyBehavior", ()=>shouldUseRawDataThirdPartyBehavior);
parcelHelpers.export(exports, "getPostInteractionRate", ()=>getPostInteractionRate);
parcelHelpers.export(exports, "getCapabilityRate", ()=>getCapabilityRate);
parcelHelpers.export(exports, "getTypingPerformanceTracingMethod", ()=>getTypingPerformanceTracingMethod);
// Will ask UFO to wait for BM3 TTI for all events on this list
parcelHelpers.export(exports, "getAwaitBM3TTIList", ()=>getAwaitBM3TTIList);
// Will ask UFO to override ufoName => experienceKey to the apdex key
// This is to cover use cases where one rUFO route is split into multiple BM3 keys (1:N)
// This workaround should only be used as last resource,
// when we find router limitations preventing teams from splliting these routes
parcelHelpers.export(exports, "getUfoNameOverrides", ()=>getUfoNameOverrides);
parcelHelpers.export(exports, "getMinorInteractions", ()=>getMinorInteractions);
// Contains the list of interactions that do not abort existing known interactions
parcelHelpers.export(exports, "getDoNotAbortActivePressInteraction", ()=>getDoNotAbortActivePressInteraction);
// Contains the list of interactions that do not abort on transitions
parcelHelpers.export(exports, "getDoNotAbortActivePressInteractionOnTransition", ()=>getDoNotAbortActivePressInteractionOnTransition);
// Contains the list of interactions that do not abort on transitions
parcelHelpers.export(exports, "getFinishInteractionOnTransition", ()=>getFinishInteractionOnTransition);
parcelHelpers.export(exports, "CLEANUP_TIMEOUT", ()=>CLEANUP_TIMEOUT);
parcelHelpers.export(exports, "getInteractionTimeout", ()=>getInteractionTimeout);
var _objectSpread = require("@swc/helpers/_/_object_spread");
var _objectSpreadProps = require("@swc/helpers/_/_object_spread_props");
var _isFedrampModerate = require("@atlaskit/atlassian-context/is-fedramp-moderate");
var _platformFeatureFlags = require("@atlaskit/platform-feature-flags");
let config;
/**
 * Cached result of `isFedrampModerate()` so we don't re-parse cookies on
 * every selector lookup. Reset via `__resetFedrampOverrideCacheForTests` in
 * unit tests only.
 */ let cachedIsFedrampModerate;
function detectIsFedrampModerate() {
    if (cachedIsFedrampModerate !== undefined) return cachedIsFedrampModerate;
    try {
        cachedIsFedrampModerate = (0, _isFedrampModerate.isFedrampModerate)();
    } catch (e) {
        // Defensive default: if perimeter detection throws, treat as non-FedRAMP
        // so UFO behaviour is unchanged. Mirrors `analyticsWebClient` pattern.
        cachedIsFedrampModerate = false;
    }
    return cachedIsFedrampModerate;
}
function __resetFedrampOverrideCacheForTests() {
    cachedIsFedrampModerate = undefined;
}
function isFedrampOverrideActive() {
    try {
        return detectIsFedrampModerate();
    } catch (e) {
        return false;
    }
}
const FEDRAMP_DISABLED_SELECTOR_CONFIG = Object.freeze({
    id: false,
    testId: false,
    role: false,
    className: false,
    dataVC: false
});
const DEFAULT_TTVC_REVISION = 'fy26.04';
function getDefaultTTVCRevision() {
    return DEFAULT_TTVC_REVISION;
}
const UNKNOWN_INTERACTION_RATE = 1000;
function setUFOConfig(newConfig) {
    var _newConfig_vc;
    // Handle edge cases with `enabledVCRevisions`
    const { enabledVCRevisions } = (_newConfig_vc = newConfig === null || newConfig === void 0 ? void 0 : newConfig.vc) !== null && _newConfig_vc !== void 0 ? _newConfig_vc : {};
    if (enabledVCRevisions) {
        const byExperience = typeof (enabledVCRevisions === null || enabledVCRevisions === void 0 ? void 0 : enabledVCRevisions.byExperience) === 'object' ? enabledVCRevisions.byExperience : {};
        var _enabledVCRevisions_all;
        const allRevisions = [
            // Products control their own revisions.
            ...(_enabledVCRevisions_all = enabledVCRevisions === null || enabledVCRevisions === void 0 ? void 0 : enabledVCRevisions.all) !== null && _enabledVCRevisions_all !== void 0 ? _enabledVCRevisions_all : [],
            ...Object.values(byExperience).flat()
        ];
        config = (0, _objectSpreadProps._)((0, _objectSpread._)({}, newConfig), {
            vc: (0, _objectSpreadProps._)((0, _objectSpread._)({}, newConfig.vc), {
                enabledVCRevisions: {
                    all: Array.from(new Set(allRevisions)),
                    byExperience
                }
            })
        });
    } else config = newConfig;
}
function getConfig() {
    return config;
}
function getSelectorConfig(callerOverride, defaultConfig) {
    var _config_vc;
    // 1. FedRAMP override always wins.
    if (detectIsFedrampModerate()) return FEDRAMP_DISABLED_SELECTOR_CONFIG;
    var _ref;
    // 2. Then caller-provided.
    // 3. Then centrally configured.
    // 4. Then caller-provided default.
    return (_ref = callerOverride !== null && callerOverride !== void 0 ? callerOverride : config === null || config === void 0 ? void 0 : (_config_vc = config.vc) === null || _config_vc === void 0 ? void 0 : _config_vc.selectorConfig) !== null && _ref !== void 0 ? _ref : defaultConfig;
}
function isUFOEnabled() {
    // Default to enabled if config is not set or enabled is not explicitly false
    return (config === null || config === void 0 ? void 0 : config.enabled) !== false;
}
const isValidConfigArray = (array)=>{
    return Array.isArray(array) && array.length > 0;
};
function getEnabledVCRevisions(experienceKey = '') {
    try {
        var _config_vc;
        if (!config) return [];
        if ((_config_vc = config.vc) === null || _config_vc === void 0 ? void 0 : _config_vc.enabled) {
            var _enabledVCRevisions_byExperience, _enabledVCRevisions_byExperience1;
            var _config_vc1;
            const { enabledVCRevisions } = (_config_vc1 = config.vc) !== null && _config_vc1 !== void 0 ? _config_vc1 : {};
            if (isValidConfigArray(enabledVCRevisions === null || enabledVCRevisions === void 0 ? void 0 : (_enabledVCRevisions_byExperience = enabledVCRevisions.byExperience) === null || _enabledVCRevisions_byExperience === void 0 ? void 0 : _enabledVCRevisions_byExperience[experienceKey])) return (_enabledVCRevisions_byExperience1 = enabledVCRevisions.byExperience) === null || _enabledVCRevisions_byExperience1 === void 0 ? void 0 : _enabledVCRevisions_byExperience1[experienceKey];
            // When the disable flag is on, treat an explicitly-set empty array as
            // "no client-side revisions" rather than falling back to the default revision.
            const allRevisions = enabledVCRevisions === null || enabledVCRevisions === void 0 ? void 0 : enabledVCRevisions.all;
            if (Array.isArray(allRevisions) && allRevisions.length === 0 && (0, _platformFeatureFlags.fg)('ufo_disable_ttvc_v4')) return allRevisions;
            if (isValidConfigArray(allRevisions)) return allRevisions;
            return [
                getDefaultTTVCRevision()
            ];
        }
        return [];
    } catch (e) {
        return [];
    }
}
function isVCRevisionEnabled(revision, experienceKey) {
    return getEnabledVCRevisions(experienceKey).includes(revision);
}
function getMostRecentVCRevision(experienceKey = '') {
    const enabledVCRevisions = getEnabledVCRevisions(experienceKey);
    if (enabledVCRevisions.length === 0) return getDefaultTTVCRevision();
    return enabledVCRevisions[enabledVCRevisions.length - 1];
}
function getReactHydrationStats() {
    if (!config) return undefined;
    try {
        var _config_getReactHydrationStats;
        const stats = config === null || config === void 0 ? void 0 : (_config_getReactHydrationStats = config.getReactHydrationStats) === null || _config_getReactHydrationStats === void 0 ? void 0 : _config_getReactHydrationStats.call(config);
        return stats !== null && stats !== void 0 ? stats : undefined;
    } catch (e) {
        // eslint-disable-next-line no-console
        console.error('getReactHydrationStats threw an error: ', e);
        return undefined;
    }
}
function getInteractionRate(name, interactionKind) {
    try {
        if (!config) return 0;
        const { killswitch, rates, rules, kind, autoGeneratedRate } = config;
        if (killswitch != null) {
            // Specifically kill certain events
            if (killswitch.includes(name)) return 0;
        }
        const isUnknown = name === 'unknown';
        if (isUnknown) {
            if ((rates === null || rates === void 0 ? void 0 : rates[name]) != null) return rates[name];
            // Return default rate for unknown events when no explicit rate is configured
            return UNKNOWN_INTERACTION_RATE;
        }
        if (rates != null) {
            // Decide the rate explicitly
            if (rates[name] != null) return rates[name];
        }
        if (rules != null) for(let i = 0; i < rules.length; i++){
            const rule = rules[i];
            const { test, rate } = rule;
            if (test != null && rate != null) {
                const regexp = new RegExp(test, 'ig');
                if (regexp.test(name)) return rate;
            }
        }
        const isAutogenerated = name === null || name === void 0 ? void 0 : name.startsWith('auto-generated');
        if (isAutogenerated) {
            const rate = autoGeneratedRate;
            if (rate != null) return rate;
        }
        if (kind != null) {
            const rate = kind[interactionKind];
            if (rate != null) return rate;
        }
        return 0;
    } catch (e) {
        // Fallback
        return 0;
    }
}
function getVCRawDataInteractionRate(name, interactionType) {
    return getConfigRate(name, interactionType, 'enableVCRawDataRates');
}
function shouldUseRawDataThirdPartyBehavior(name, interactionType) {
    return getVCRawDataInteractionRate(name, interactionType) > 0;
}
function getPostInteractionRate(name, interactionType) {
    return getConfigRate(name, interactionType, 'postInteractionLog');
}
function getCapabilityRate(capability) {
    if ((0, _platformFeatureFlags.fg)('platform_ufo_remove_deprecated_config_fields')) return 1;
    try {
        if (!config) return 0;
        const { capability: capabilityRate } = config;
        if (capabilityRate != null) {
            const rate = capabilityRate[capability];
            if (rate != null) return rate;
        }
        return 0;
    } catch (e) {
        return 0;
    }
}
function getConfigRate(name, interactionType, configName) {
    try {
        if (!config) return 0;
        const gotConfig = config[configName];
        if (!(gotConfig === null || gotConfig === void 0 ? void 0 : gotConfig.enabled)) return 0;
        if (interactionType !== 'page_load' && interactionType !== 'transition') return 0;
        if (gotConfig.rates && typeof gotConfig.rates[name] === 'number') return gotConfig.rates[name];
        if ('kind' in gotConfig && gotConfig.kind && typeof gotConfig.kind[interactionType] === 'number') return gotConfig.kind[interactionType];
        return 0;
    } catch (e) {
        return 0;
    }
}
const validTypingMethods = [
    'timeout',
    'timeoutNoAlloc',
    'mutationObserver'
];
function getTypingPerformanceTracingMethod() {
    const defaultMethod = 'timeout';
    try {
        if (!config) return defaultMethod;
        const { typingMethod } = config;
        if (typingMethod != null && validTypingMethods.find((m)=>m === typingMethod)) return typingMethod;
        else return defaultMethod;
    } catch (e) {
        return defaultMethod;
    }
}
function getAwaitBM3TTIList() {
    try {
        if (!config) return [];
        const { awaitBM3TTI } = config;
        if (awaitBM3TTI != null) return awaitBM3TTI;
        else return [];
    } catch (e) {
        return [];
    }
}
function getUfoNameOverrides() {
    try {
        if (!config) return undefined;
        const { ufoNameOverrides } = config;
        if (ufoNameOverrides != null) return ufoNameOverrides;
        return undefined;
    } catch (e) {
        return undefined;
    }
}
function getMinorInteractions() {
    try {
        if (!config) return undefined;
        const { minorInteractions } = config;
        return minorInteractions;
    } catch (e) {
        return undefined;
    }
}
function getDoNotAbortActivePressInteraction() {
    try {
        if (!config) return undefined;
        const { doNotAbortActivePressInteraction } = config;
        return doNotAbortActivePressInteraction;
    } catch (e) {
        return undefined;
    }
}
function getDoNotAbortActivePressInteractionOnTransition() {
    try {
        if (!config) return undefined;
        const { doNotAbortActivePressInteractionOnTransition } = config;
        return doNotAbortActivePressInteractionOnTransition;
    } catch (e) {
        return undefined;
    }
}
function getFinishInteractionOnTransition() {
    try {
        if (!config) return undefined;
        const { finishInteractionOnTransition } = config;
        return finishInteractionOnTransition;
    } catch (e) {
        return undefined;
    }
}
const CLEANUP_TIMEOUT = 60000;
function getInteractionTimeout(ufoName) {
    try {
        if (!config) return CLEANUP_TIMEOUT;
        const { interactionTimeout } = config;
        if (interactionTimeout != null && interactionTimeout[ufoName] != null) return interactionTimeout[ufoName];
        if (interactionTimeout != null && interactionTimeout.__globalInteractionTimeout != null) return interactionTimeout.__globalInteractionTimeout;
        else return CLEANUP_TIMEOUT;
    } catch (e) {
        return CLEANUP_TIMEOUT;
    }
}

},{"@swc/helpers/_/_object_spread":"9gdrV","@swc/helpers/_/_object_spread_props":"kANqQ","@atlaskit/atlassian-context/is-fedramp-moderate":"e200g","@atlaskit/platform-feature-flags":"8rD2i","@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"2hccT":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "sinkExtraSearchPageInteractionHandler", ()=>sinkExtraSearchPageInteractionHandler);
// eslint-disable-next-line @atlaskit/volt-strict-mode/no-multiple-exports
parcelHelpers.export(exports, "onSearchPageInteractionComplete", ()=>onSearchPageInteractionComplete);
const interactionBuffer = [];
let bufferInteractionData = (interactionId, data)=>{
    interactionBuffer.push({
        interactionId,
        data
    });
};
function clearInteractionBuffer() {
    interactionBuffer.length = 0;
}
function appendInteractionData(interactionId, data) {
    bufferInteractionData(interactionId, data);
}
function installInteractionSink(handler) {
    for (const { interactionId, data } of interactionBuffer)handler(interactionId, data);
    clearInteractionBuffer();
    bufferInteractionData = handler;
}
function sinkExtraSearchPageInteractionHandler(sinkFn) {
    installInteractionSink(sinkFn);
}
function onSearchPageInteractionComplete(interactionId, data) {
    if (data.ufoName) {
        appendInteractionData(interactionId, data);
        clearInteractionBuffer();
    }
}

},{"@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"fVmSw":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "setContextManager", ()=>setContextManager);
// eslint-disable-next-line @atlaskit/volt-strict-mode/no-multiple-exports
parcelHelpers.export(exports, "getContextManager", ()=>getContextManager);
/**
 * The below is shamelessly borrowed from StackContextManager from @opentelemetry/sdk-trace-web
 * Using this rather than importing the entire package because this is all we need for now
 */ /**
 * UFO Context Manager for managing the state in web
 * it doesn't fully support the async calls though
 */ // eslint-disable-next-line @atlaskit/volt-strict-mode/no-multiple-exports
parcelHelpers.export(exports, "UFOContextManager", ()=>UFOContextManager);
var _api = require("@opentelemetry/api");
/**
 * We need to store a reference to the Context manager so that we can get it later.
 * This is because the OTel JS API doesn't allow us to get the registered context manager,
 * and we need to get it because we need to call a function that's not available in the OTel API:
 * `setActive`. The OTel JS API design doesn't allow us to manually set the active context
 * despite the spec allowing for the capability. Sigh.
 *
 * I imagine this situation might not be permanent if we can move to a system were we can rely
 * solely on the API, but for the purposes of the first change being React UFO API compatible,
 * we'll need to do this.
 */ let contextManager;
function setContextManager(ctxMgr) {
    contextManager = ctxMgr;
}
function getContextManager() {
    return contextManager;
}
class UFOContextManager {
    /**
	 *
	 * @param context
	 * @param target Function to be executed within the context
	 */ // eslint-disable-next-line @typescript-eslint/no-unsafe-function-type
    _bindFunction(context = (0, _api.ROOT_CONTEXT), target) {
        // eslint-disable-next-line @typescript-eslint/no-this-alias
        const manager = this;
        const contextWrapper = function(...args) {
            return manager.with(context, ()=>target.apply(this, args));
        };
        Object.defineProperty(contextWrapper, 'length', {
            enumerable: false,
            configurable: true,
            writable: false,
            value: target.length
        });
        return contextWrapper;
    }
    /**
	 * Returns the active context
	 */ active() {
        return this._currentContext;
    }
    /**
	 * Binds a the certain context or the active one to the target function and then returns the target
	 * @param context A context (span) to be bind to target
	 * @param target a function or event emitter. When target or one of its callbacks is called,
	 *  the provided context will be used as the active context for the duration of the call.
	 */ bind(context, target) {
        // if no specific context to propagate is given, we use the current one
        if (context === undefined) context = this.active();
        if (typeof target === 'function') return this._bindFunction(context, target);
        return target;
    }
    /**
	 * Disable the context manager (clears the current context)
	 */ disable() {
        this._currentContext = (0, _api.ROOT_CONTEXT);
        this._enabled = false;
        return this;
    }
    /**
	 * Enables the context manager and creates a default(root) context
	 */ enable() {
        if (this._enabled) return this;
        this._enabled = true;
        this._currentContext = (0, _api.ROOT_CONTEXT);
        return this;
    }
    /**
	 * Calls the callback function [fn] with the provided [context]. If [context] is undefined then it will use the window.
	 * The context will be set as active
	 * @param context
	 * @param fn Callback function
	 * @param thisArg optional receiver to be used for calling fn
	 * @param args optional arguments forwarded to fn
	 */ with(context, fn, thisArg, ...args) {
        const previousContext = this._currentContext;
        this._currentContext = context || (0, _api.ROOT_CONTEXT);
        try {
            return fn.call(thisArg, ...args);
        } finally{
            this._currentContext = previousContext;
        }
    }
    /**
	 * Sets the active context.
	 * This function is an extension of the OTel spec, in order to facilitate the current API of React UFO trace context handling.
	 * It doesn't keep track of any previously set active contexts, because it's assumed (for now) that only one trace context
	 * will ever exist at a time.
	 * The next step in the work to improve tracing in the FE will likely remove this function as we need to track the
	 * hierarchy of contexts (likely using the `with()` function above).
	 * @param context The context to be made the globally active one
	 */ setActive(context) {
        if (this._enabled) this._currentContext = context;
    }
    constructor(){
        /**
	 * whether the context manager is enabled or not
	 */ this._enabled = false;
        /**
	 * Keeps the reference to current context
	 */ this._currentContext = (0, _api.ROOT_CONTEXT);
    }
}

},{"@opentelemetry/api":"9lCa7","@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"c8L9i":[function(require,module,exports,__globalThis) {
/* eslint-disable @atlaskit/volt-strict-mode/no-multiple-exports */ var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "getEarliestHiddenTiming", ()=>getEarliestHiddenTiming);
parcelHelpers.export(exports, "isOpenedInBackground", ()=>isOpenedInBackground);
parcelHelpers.export(exports, "getHasHiddenTimingBeforeSetup", ()=>getHasHiddenTimingBeforeSetup);
parcelHelpers.export(exports, "setupHiddenTimingCapture", ()=>setupHiddenTimingCapture);
parcelHelpers.export(exports, "getPageVisibilityState", ()=>getPageVisibilityState);
/**
 * Sets up the throttle detection mechanism.
 * This should be called early in the page lifecycle.
 * Uses a periodic timer to detect browser throttling by measuring timer drift.
 */ parcelHelpers.export(exports, "setupThrottleDetection", ()=>setupThrottleDetection);
/**
 * Stops the throttle detection mechanism.
 * Useful for cleanup in tests or when the feature is no longer needed.
 */ parcelHelpers.export(exports, "stopThrottleDetection", ()=>stopThrottleDetection);
/**
 * Checks if the tab was throttled at any point during the specified time window.
 * Returns true if any timer measurement showed significant drift (throttling).
 *
 * @param startTime - The start timestamp of the window to check (DOMHighResTimeStamp)
 * @param endTime - The end timestamp of the window to check (DOMHighResTimeStamp)
 * @returns boolean - true if throttling was detected during the time window, false otherwise
 */ parcelHelpers.export(exports, "isTabThrottled", ()=>isTabThrottled);
/**
 * Gets detailed throttle information for debugging purposes.
 * Returns all throttle measurements within the specified time window.
 *
 * @param startTime - The start timestamp of the window to check
 * @param endTime - The end timestamp of the window to check
 * @returns Array of throttle measurements within the time window
 */ parcelHelpers.export(exports, "getThrottleMeasurements", ()=>getThrottleMeasurements);
/**
 * Injects a fake throttle measurement for testing purposes.
 * This allows integration tests to simulate throttling scenarios.
 *
 * @param measurement - The throttle measurement to inject
 */ parcelHelpers.export(exports, "__injectThrottleMeasurementForTesting", ()=>__injectThrottleMeasurementForTesting);
/**
 * Returns the page visibility timeline entries within the specified time window.
 * Each entry contains the time (relative to startTime) and whether the page was hidden.
 *
 * @param startTime - The start timestamp of the window (DOMHighResTimeStamp)
 * @param endTime - The end timestamp of the window (DOMHighResTimeStamp)
 * @returns Array of HiddenTimingItem entries within the time window, with times relative to startTime
 */ parcelHelpers.export(exports, "getPageVisibilityTimeline", ()=>getPageVisibilityTimeline);
var _bindEventListener = require("bind-event-listener");
var _platformFeatureFlags = require("@atlaskit/platform-feature-flags");
const timings = [];
let wasHiddenFlag;
let setupFlag = false;
// Threshold for determining if page was opened in background.
// If setup runs within this time and page is hidden, we assume it was opened in a background tab.
const OPENED_IN_BACKGROUND_THRESHOLD_MS = 100;
let openedInBackground = null;
function isPageHidden() {
    if ('visibilityState' in document) return document.visibilityState === 'hidden';
    else // @ts-expect-error - Property 'hidden' does not exist on type 'never'.
    return document.hidden;
}
const SIZE = 50;
let insertIndex = 0;
function getEarliestHiddenTiming(startTime, endTime) {
    var _timings_find;
    const earliestHiddenTiming = (_timings_find = timings.find(({ hidden, time })=>hidden && time > 0 && time >= startTime && time <= endTime)) === null || _timings_find === void 0 ? void 0 : _timings_find.time;
    if (typeof earliestHiddenTiming === 'number') return Math.round(earliestHiddenTiming - startTime);
}
function isOpenedInBackground(interactionType) {
    if (interactionType !== 'page_load') return false;
    // Check native visibility-state entries first (most reliable, Chromium only)
    try {
        const entries = performance.getEntriesByType('visibility-state');
        if (entries.length > 0) return entries.some((entry)=>entry.name === 'hidden' && entry.startTime <= OPENED_IN_BACKGROUND_THRESHOLD_MS);
    } catch (e) {
    // visibility-state not supported (Firefox/Safari)
    }
    // Fallback to cached value from setup (determined using time threshold)
    return openedInBackground === true;
}
function pushHidden(isPageHiddenFlag, time) {
    timings[insertIndex] = {
        time: time !== null && time !== void 0 ? time : performance.now(),
        hidden: isPageHiddenFlag
    };
    insertIndex = (insertIndex + 1) % SIZE;
    wasHiddenFlag = isPageHiddenFlag;
}
function handleChange() {
    const isPageHiddenFlag = isPageHidden();
    if (isPageHiddenFlag) {
        if (!wasHiddenFlag) pushHidden(isPageHiddenFlag);
        wasHiddenFlag = true;
    } else {
        if (wasHiddenFlag) pushHidden(isPageHiddenFlag);
        wasHiddenFlag = false;
    }
}
let hasHiddenTimingBeforeSetup = false;
function getHasHiddenTimingBeforeSetup() {
    return hasHiddenTimingBeforeSetup;
}
function setup() {
    try {
        const results = performance.getEntriesByType('visibility-state');
        results === null || results === void 0 ? void 0 : results.forEach((result)=>{
            if ((0, _platformFeatureFlags.fg)('platform_ufo_use_native_page_visibility_api')) pushHidden(result.name === 'hidden', result.startTime);
            if (result.name === 'hidden') hasHiddenTimingBeforeSetup = true;
        });
    } catch (e) {
    /* do nothing */ /* note: visibility-state entry types are not available in Firefox/Safari: https://developer.mozilla.org/en-US/docs/Web/API/VisibilityStateEntry#browser_compatibility */ }
    (0, _bindEventListener.bind)(window, {
        type: 'pageshow',
        listener: handleChange
    });
    (0, _bindEventListener.bind)(window, {
        type: 'pagehide',
        listener: handleChange
    });
    (0, _bindEventListener.bind)(document, {
        type: 'visibilitychange',
        listener: handleChange
    });
}
function setupHiddenTimingCapture() {
    if (!setupFlag) {
        const isPageHiddenFlag = isPageHidden();
        const setupTime = performance.now();
        // Determine if page was opened in background.
        // If we're early in page lifecycle (< threshold) and page is hidden,
        // it's likely the page was opened in a background tab.
        if (openedInBackground === null) openedInBackground = isPageHiddenFlag && setupTime < OPENED_IN_BACKGROUND_THRESHOLD_MS;
        pushHidden(isPageHiddenFlag, 0);
        setup();
        setupFlag = true;
    }
}
function getPageVisibilityState(start, end) {
    // Input validation - return default for invalid inputs
    if (!Number.isFinite(start) || !Number.isFinite(end)) return 'visible';
    // Desirable default value is visible
    if (timings.length === 0) return 'visible';
    const currentSize = timings.length;
    let hiddenState = 'mixed';
    let startIdx = insertIndex;
    let endIdx = insertIndex;
    // currentSize is capped at SIZE.
    for(let i = 0; i < currentSize; i++){
        const tmpIdx = (insertIndex + i) % currentSize;
        // Add bounds checking before accessing array element
        if (timings[tmpIdx] && timings[tmpIdx].time <= end) {
            endIdx = tmpIdx;
            if (timings[tmpIdx].time <= start) startIdx = tmpIdx;
        }
    }
    // Add bounds checking before accessing timings array
    if (endIdx - startIdx === 0 && timings[startIdx]) hiddenState = timings[startIdx].hidden ? 'hidden' : 'visible';
    return hiddenState;
}
// Throttle detection configuration
// Expected interval for timer checks (in milliseconds)
const THROTTLE_CHECK_INTERVAL_MS = 1000;
// Threshold for considering a timer as throttled (50% drift tolerance)
const THROTTLE_DRIFT_THRESHOLD = 1.5;
// Maximum number of throttle measurements to store (circular buffer)
const THROTTLE_BUFFER_SIZE = 120;
// Circular buffer to store throttle measurements
const throttleMeasurements = [];
let throttleInsertIndex = 0;
let throttleIntervalId = null;
let lastThrottleCheckTime = null;
let throttleSetupDone = false;
function recordThrottleMeasurement(expectedElapsed, actualElapsed) {
    const isThrottled = actualElapsed > expectedElapsed * THROTTLE_DRIFT_THRESHOLD;
    throttleMeasurements[throttleInsertIndex] = {
        time: performance.now(),
        expectedElapsed,
        actualElapsed,
        isThrottled
    };
    throttleInsertIndex = (throttleInsertIndex + 1) % THROTTLE_BUFFER_SIZE;
}
function throttleCheckCallback() {
    const currentTime = performance.now();
    if (lastThrottleCheckTime !== null) {
        const actualElapsed = currentTime - lastThrottleCheckTime;
        recordThrottleMeasurement(THROTTLE_CHECK_INTERVAL_MS, actualElapsed);
    }
    lastThrottleCheckTime = currentTime;
}
function setupThrottleDetection() {
    if (throttleSetupDone) return;
    throttleSetupDone = true;
    // Record the initial timestamp
    lastThrottleCheckTime = performance.now();
    // Start the periodic timer for throttle detection
    throttleIntervalId = setInterval(throttleCheckCallback, THROTTLE_CHECK_INTERVAL_MS);
}
function stopThrottleDetection() {
    if (throttleIntervalId !== null) {
        clearInterval(throttleIntervalId);
        throttleIntervalId = null;
    }
    lastThrottleCheckTime = null;
    throttleSetupDone = false;
    throttleMeasurements.length = 0;
    throttleInsertIndex = 0;
}
function isTabThrottled(startTime, endTime) {
    // Input validation
    if (!Number.isFinite(startTime) || !Number.isFinite(endTime) || startTime >= endTime) return false;
    // No measurements available
    if (throttleMeasurements.length === 0) return false;
    // Check if any measurement within the time window indicates throttling
    for(let i = 0; i < throttleMeasurements.length; i++){
        const measurement = throttleMeasurements[i];
        if (measurement && measurement.time >= startTime && measurement.time <= endTime && measurement.isThrottled) return true;
    }
    return false;
}
function getThrottleMeasurements(startTime, endTime) {
    // Input validation
    if (!Number.isFinite(startTime) || !Number.isFinite(endTime) || startTime >= endTime) return [];
    return throttleMeasurements.filter((measurement)=>measurement && measurement.time >= startTime && measurement.time <= endTime);
}
function __injectThrottleMeasurementForTesting(measurement) {
    throttleMeasurements[throttleInsertIndex] = measurement;
    throttleInsertIndex = (throttleInsertIndex + 1) % THROTTLE_BUFFER_SIZE;
}
function getPageVisibilityTimeline(startTime, endTime) {
    // Input validation
    if (!Number.isFinite(startTime) || !Number.isFinite(endTime) || startTime >= endTime) return [];
    if (timings.length === 0) return [];
    const result = [];
    // Find the most recent entry at or before startTime to establish initial state
    let initialEntry;
    const currentSize = timings.length;
    for(let i = 0; i < currentSize; i++){
        const idx = (insertIndex + i) % currentSize;
        const entry = timings[idx];
        if (entry && entry.time <= startTime) initialEntry = entry;
    }
    // Add the initial visibility state at the start of the window
    if (initialEntry) result.push({
        time: 0,
        hidden: initialEntry.hidden
    });
    // Add all entries within the time window
    for(let i = 0; i < currentSize; i++){
        const idx = (insertIndex + i) % currentSize;
        const entry = timings[idx];
        if (entry && entry.time > startTime && entry.time <= endTime) result.push({
            time: Math.round(entry.time - startTime),
            hidden: entry.hidden
        });
    }
    return result;
}
// Expose testing API on window for integration tests
if (typeof window !== 'undefined') window.__reactUfoHiddenTiming = {
    __injectThrottleMeasurementForTesting
};

},{"bind-event-listener":"bjeUU","@atlaskit/platform-feature-flags":"8rD2i","@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"j4w6h":[function(require,module,exports,__globalThis) {
/* eslint-disable @atlaskit/volt-strict-mode/no-multiple-exports */ // eslint-disable-next-line @atlaskit/platform/prefer-crypto-random-uuid -- Use crypto.randomUUID instead
var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "PreviousInteractionLog", ()=>PreviousInteractionLog);
parcelHelpers.export(exports, "postInteractionLog", ()=>postInteractionLog);
parcelHelpers.export(exports, "segmentUnmountCache", ()=>segmentUnmountCache);
parcelHelpers.export(exports, "getActiveInteraction", ()=>getActiveInteraction);
parcelHelpers.export(exports, "getPerformanceObserver", ()=>getPerformanceObserver);
parcelHelpers.export(exports, "setInteractionPerformanceEvent", ()=>setInteractionPerformanceEvent);
parcelHelpers.export(exports, "remove", ()=>remove);
parcelHelpers.export(exports, "updatePageLoadInteractionName", ()=>updatePageLoadInteractionName);
parcelHelpers.export(exports, "addMetadata", ()=>addMetadata);
parcelHelpers.export(exports, "addCustomData", ()=>addCustomData);
parcelHelpers.export(exports, "addSegmentExtraData", ()=>addSegmentExtraData);
parcelHelpers.export(exports, "addIframeSegmentData", ()=>addIframeSegmentData);
parcelHelpers.export(exports, "addCohortingCustomData", ()=>addCohortingCustomData);
parcelHelpers.export(exports, "addCustomTiming", ()=>addCustomTiming);
parcelHelpers.export(exports, "addMark", ()=>addMark);
parcelHelpers.export(exports, "markFirstSegmentLoad", ()=>markFirstSegmentLoad);
parcelHelpers.export(exports, "addMarkToAll", ()=>addMarkToAll);
parcelHelpers.export(exports, "addSpan", ()=>addSpan);
parcelHelpers.export(exports, "addSpanToAll", ()=>addSpanToAll);
parcelHelpers.export(exports, "addPreload", ()=>addPreload);
parcelHelpers.export(exports, "addLoad", ()=>addLoad);
parcelHelpers.export(exports, "extractModuleName", ()=>extractModuleName);
parcelHelpers.export(exports, "addHold", ()=>addHold);
parcelHelpers.export(exports, "addHoldByID", ()=>addHoldByID);
/**
 * Records a completed third-party hold with explicit start and end timestamps.
 * Use this when the hold timing is known upfront (e.g. from React Profiler's
 * actualStartTime and commitTime) rather than being captured at call time.
 */ parcelHelpers.export(exports, "addCompletedHold", ()=>addCompletedHold);
parcelHelpers.export(exports, "removeHoldByID", ()=>removeHoldByID);
parcelHelpers.export(exports, "getCurrentInteractionType", ()=>getCurrentInteractionType);
parcelHelpers.export(exports, "ModuleLoadingProfiler", ()=>ModuleLoadingProfiler);
parcelHelpers.export(exports, "addError", ()=>addError);
parcelHelpers.export(exports, "addErrorToAll", ()=>addErrorToAll);
parcelHelpers.export(exports, "addProfilerTimings", ()=>addProfilerTimings);
parcelHelpers.export(exports, "sinkInteractionHandler", ()=>sinkInteractionHandler);
parcelHelpers.export(exports, "sinkPostInteractionLogHandler", ()=>sinkPostInteractionLogHandler);
parcelHelpers.export(exports, "tryComplete", ()=>tryComplete);
parcelHelpers.export(exports, "abort", ()=>abort);
parcelHelpers.export(exports, "abortByNewInteraction", ()=>abortByNewInteraction);
parcelHelpers.export(exports, "abortAll", ()=>abortAll);
parcelHelpers.export(exports, "addOnCancelCallback", ()=>addOnCancelCallback);
parcelHelpers.export(exports, "addNewInteraction", ()=>addNewInteraction);
parcelHelpers.export(exports, "addBrowserMetricEvent", ()=>addBrowserMetricEvent);
parcelHelpers.export(exports, "addApdexToAll", ()=>addApdexToAll);
parcelHelpers.export(exports, "addApdex", ()=>addApdex);
parcelHelpers.export(exports, "addRequestInfo", ()=>addRequestInfo);
parcelHelpers.export(exports, "addSegment", ()=>addSegment);
parcelHelpers.export(exports, "removeSegment", ()=>removeSegment);
parcelHelpers.export(exports, "addRedirect", ()=>addRedirect);
parcelHelpers.export(exports, "interactionSpans", ()=>interactionSpans);
parcelHelpers.export(exports, "addCustomSpans", ()=>addCustomSpans);
var _objectSpread = require("@swc/helpers/_/_object_spread");
var _objectSpreadProps = require("@swc/helpers/_/_object_spread_props");
var _uuid = require("uuid");
var _platformFeatureFlags = require("@atlaskit/platform-feature-flags");
var _coinflip = require("../coinflip");
var _coinflipDefault = parcelHelpers.interopDefault(_coinflip);
var _timingName = require("../common/utils/timing-name");
var _config = require("../config");
var _createExtraSearchPageInteractionPayload = require("../create-extra-search-page-interaction-payload");
var _utils = require("../create-payload/common/utils");
var _experienceTraceIdContext = require("../experience-trace-id-context");
var _featureFlagsAccessed = require("../feature-flags-accessed");
var _interactionIdContext = require("../interaction-id-context");
var _resourceTimingInitiatorTypes = require("../resource-timing/common/utils/resource-timing-initiator-types");
var _ssrRenderProfiler = require("../segment/ssr-render-profiler");
var _vc = require("../vc");
var _constants = require("./common/constants");
var _postInteractionLog = require("./post-interaction-log");
var _postInteractionLogDefault = parcelHelpers.interopDefault(_postInteractionLog);
const PreviousInteractionLog = {
    id: undefined,
    name: undefined,
    type: undefined,
    isAborted: undefined,
    timestamp: undefined
};
const postInteractionLog = new (0, _postInteractionLogDefault.default)();
const interactionQueue = [];
const segmentCache = new Map();
const segmentUnmountCache = new Map(); // Temporarily store segment unmount counts
const segmentObservers = [];
function getActiveInteraction() {
    const interactionId = (0, _interactionIdContext.getInteractionId)();
    if (!interactionId.current) return;
    return (0, _constants.interactions).get(interactionId.current);
}
function isPerformanceTracingEnabled() {
    var _getConfig;
    return ((_getConfig = (0, _config.getConfig)()) === null || _getConfig === void 0 ? void 0 : _getConfig.enableAdditionalPerformanceMarks) || window.__REACT_UFO_ENABLE_PERF_TRACING || false;
}
let performanceEventObserver;
const getPerformanceObserver = ()=>{
    performanceEventObserver = performanceEventObserver || new PerformanceObserver((entries)=>{
        const list = entries.getEntries();
        for (let entry of list)if (entry.name === 'click') setInteractionPerformanceEvent(entry);
    });
    return performanceEventObserver;
};
const setInteractionPerformanceEvent = (entry)=>{
    const interaction = getActiveInteraction();
    if ((interaction === null || interaction === void 0 ? void 0 : interaction.type) === 'press') {
        const responsiveness = interaction.responsiveness || {};
        // if happens there is another event interaction that has started after
        // the initial one, we don't want to replace the values if they have already
        // been set up
        responsiveness.experimentalInputToNextPaint = responsiveness.experimentalInputToNextPaint || entry.duration;
        responsiveness.inputDelay = responsiveness.experimentalInputToNextPaint || entry.processingStart - entry.startTime;
        interaction.responsiveness = responsiveness;
        // if the entry start time is lower than the one in the interaction
        // it means the interaction start time is not accurate, we assign
        // this value which will match the timestamp in the event
        if (entry.startTime < interaction.start) interaction.start = entry.startTime;
    }
};
function labelStackToString(labelStack, name) {
    var _stack_map;
    const stack = [
        ...labelStack !== null && labelStack !== void 0 ? labelStack : []
    ];
    if (name) stack.push({
        name
    });
    return (_stack_map = stack.map((l)=>l.name)) === null || _stack_map === void 0 ? void 0 : _stack_map.join('/');
}
function labelStackToIdString(labelStack) {
    var _labelStack_map;
    return labelStack === null || labelStack === void 0 ? void 0 : (_labelStack_map = labelStack.map((l)=>'segmentId' in l ? `${l.name}:${l.segmentId}` : `${l.name}`)) === null || _labelStack_map === void 0 ? void 0 : _labelStack_map.join('/');
}
function addSegmentObserver(observer) {
    segmentObservers.push(observer);
    for (const segmentInfo of segmentCache.values())observer.onAdd(segmentInfo);
}
function removeSegmentObserver(observer) {
    const index = segmentObservers.findIndex((obs)=>obs === observer);
    if (index !== -1) segmentObservers.splice(index, 1);
}
function remove(interactionId) {
    (0, _constants.interactions).delete(interactionId);
}
function updatePageLoadInteractionName(ufoName, routeName = ufoName) {
    const interaction = getActiveInteraction();
    if (!interaction || interaction.type !== 'page_load' && interaction.type !== 'transition') return;
    interaction.ufoName = ufoName;
    interaction.routeName = routeName;
}
function addMetadata(interactionId, data) {
    const interaction = (0, _constants.interactions).get(interactionId);
    if (interaction != null) Object.keys(data).forEach((key)=>{
        interaction.metaData[key] = data[key];
    });
}
function addCustomData(interactionId, labelStack, data) {
    const interaction = (0, _constants.interactions).get(interactionId);
    if (interaction != null) Object.keys(data).forEach((i)=>{
        interaction.customData.push({
            labelStack,
            data: {
                [i]: data[i]
            }
        });
    });
}
function addSegmentExtraData(interactionId, segmentId, data) {
    const interaction = (0, _constants.interactions).get(interactionId);
    if (interaction != null) {
        if (!interaction.segmentExtraData) interaction.segmentExtraData = {};
        interaction.segmentExtraData[segmentId] = (0, _objectSpread._)({}, interaction.segmentExtraData[segmentId], data);
    }
}
/**
 * Builds a stable cross-segment dedup key for a segment3pTimings entry.
 *
 * For `resource-timing`, query-stripped backend labels + timing fields identify a request without
 * depending on query parameters. Shared CSS/JS asset timings dedupe across segments, but backend
 * fetch/XHR entries are scoped by `segmentId` because each iframe can make its own backend request
 * to the same URL.
 *
 * For all other labels the data objects are small (a handful of fields), so we use a full
 * JSON fingerprint which is cheap and collision-free.
 */ function buildCrossSegmentDedupKey(entry, segmentId) {
    if (entry.label === 'resource-timing') {
        const { label: resourceLabel, startTime, duration, requestStart, fetchStart, ttfb, type } = entry.data;
        if ((0, _resourceTimingInitiatorTypes.BACKEND_RESOURCE_TIMING_INITIATOR_TYPES).has(String(type))) // Backend calls are separate requests per segment; include extra timings and segment scope.
        return `resource-timing|${resourceLabel}|${startTime}|${duration}|${fetchStart}|${requestStart}|${ttfb}|${segmentId}`;
        // Shared CSS/JS assets keep the original B3 key so they can dedupe across segments.
        return `resource-timing|${resourceLabel}|${startTime}|${duration}`;
    }
    return `${entry.label}|${JSON.stringify(entry.data)}`;
}
function addIframeSegmentData(interactionId, segmentId, entry) {
    const interaction = (0, _constants.interactions).get(interactionId);
    if (interaction != null) {
        // B3: dedup by content — drops identical entries within and across iframes.
        // Abort markers are excluded so every segment's abort is recorded.
        if (entry.label !== 'segment-timing-abort') {
            if (!interaction.segment3pCrossSegmentSeen) interaction.segment3pCrossSegmentSeen = new Set();
            const key = buildCrossSegmentDedupKey(entry, segmentId);
            if (interaction.segment3pCrossSegmentSeen.has(key)) return;
            interaction.segment3pCrossSegmentSeen.add(key);
        }
        if (!interaction.segment3pTimings) interaction.segment3pTimings = {};
        if (!interaction.segment3pTimings[segmentId]) interaction.segment3pTimings[segmentId] = [];
        interaction.segment3pTimings[segmentId].push(entry);
    }
}
function addCohortingCustomData(interactionId, key, value) {
    const interaction = (0, _constants.interactions).get(interactionId);
    if (interaction == null) return;
    // Allow null and undefined values
    if (value === null || value === undefined) {
        interaction.cohortingCustomData.set(key, value);
        return;
    }
    // Validate that the value is a primitive (number, boolean, or string)
    if (typeof value !== 'number' && typeof value !== 'boolean' && typeof value !== 'string') return;
    // Validate string length (max 50 characters)
    if (typeof value === 'string' && value.length > 50) return;
    interaction.cohortingCustomData.set(key, value);
}
function addCustomTiming(interactionId, labelStack, data) {
    const interaction = (0, _constants.interactions).get(interactionId);
    if (interaction != null) {
        const sanitizedData = Object.fromEntries(Object.entries(data).map(([key, timingData])=>[
                (0, _timingName.sanitizeTimingName)(key),
                timingData
            ]));
        interaction.customTimings.push({
            labelStack,
            data: sanitizedData
        });
        if (isPerformanceTracingEnabled()) for (const [key, timingData] of Object.entries(sanitizedData)){
            const { startTime, endTime } = timingData;
            try {
                // for Firefox 102 and older
                performance.measure(`\u{1F6F8} ${labelStackToString(labelStack, key)} [custom_timing]`, {
                    start: startTime,
                    end: endTime,
                    detail: {
                        devtools: {
                            track: "\uD83D\uDEF8 reactUFO detailed timings",
                            color: 'tertiary-light'
                        }
                    }
                });
            } catch (e) {
            // do nothing
            }
        }
    }
}
function addMark(interactionId, type, name, labelStack, time = performance.now()) {
    const interaction = (0, _constants.interactions).get(interactionId);
    if (interaction != null) interaction.marks.push({
        type,
        name,
        labelStack,
        time
    });
    if (isPerformanceTracingEnabled()) performance.mark(`\u{1F6F8} ${labelStackToString(labelStack, name)} [${type}]`, {
        startTime: time
    });
}
function markFirstSegmentLoad(_interactionId, _labelStack, _time) {}
function addMarkToAll(type, name, labelStack, time = performance.now()) {
    (0, _constants.interactions).forEach((interaction)=>{
        interaction.marks.push({
            type,
            name,
            labelStack,
            time
        });
    });
    if (isPerformanceTracingEnabled()) performance.mark(`\u{1F6F8} ${labelStackToString(labelStack, name)} [${type}]`, {
        startTime: time
    });
}
function addSpan(interactionId, type, name, labelStack, start, end = performance.now(), size) {
    const interaction = (0, _constants.interactions).get(interactionId);
    if (interaction != null) {
        interaction.spans.push({
            type,
            name,
            labelStack,
            start,
            end,
            size
        });
        if (isPerformanceTracingEnabled()) try {
            // for Firefox 102 and older
            performance.measure(`\u{1F6F8} ${labelStackToString(labelStack, name)} [${type}]`, {
                start,
                end,
                detail: {
                    devtools: {
                        track: "\uD83D\uDEF8 reactUFO detailed timings",
                        color: 'secondary'
                    }
                }
            });
        } catch (e) {
        // do nothing
        }
    }
}
function addSpanToAll(type, name, labelStack, start, end = performance.now(), size = 0) {
    (0, _constants.interactions).forEach((interaction)=>{
        interaction.spans.push({
            type,
            name,
            labelStack,
            start,
            end,
            size
        });
    });
    if (isPerformanceTracingEnabled()) try {
        // for Firefox 102 and older
        performance.measure(`\u{1F6F8} ${labelStackToString(labelStack, name)} [${type}]`, {
            start,
            end,
            detail: {
                devtools: {
                    track: "\uD83D\uDEF8 reactUFO detailed timings",
                    color: 'secondary'
                }
            }
        });
    } catch (e) {
    // do nothing
    }
}
function addPreload(moduleId, timestamp) {
    addMarkToAll('bundle_preload', moduleId, null, timestamp);
}
function addLoad(identifier, start, end) {
    addSpanToAll('bundle_load', identifier, null, start, end - start);
}
const moduleLoadingRequests = {};
function extractModuleName(input) {
    let result = input !== null && input !== void 0 ? input : '';
    result = result.replace(/^\.\/src\/packages\//, '');
    result = result.replace(/^\.\/node_modules\//, '');
    result = result.replace(/(\/src)?\/(index|main)\.(tsx|ts|js|jsx)$/, '');
    return result;
}
function addHoldCriterion(id, labelStack, name, startTime) {
    var _window___CRITERION__;
    if (!((_window___CRITERION__ = window.__CRITERION__) === null || _window___CRITERION__ === void 0 ? void 0 : _window___CRITERION__.addUFOHold)) return;
    window.__CRITERION__.addUFOHold(id, labelStackToString(labelStack), name, startTime);
}
function removeHoldCriterion(id) {
    var _window___CRITERION__;
    if (!((_window___CRITERION__ = window.__CRITERION__) === null || _window___CRITERION__ === void 0 ? void 0 : _window___CRITERION__.removeUFOHold)) return;
    window.__CRITERION__.removeUFOHold(id);
}
function addHold(interactionId, labelStack, name, _experimental) {
    const interaction = (0, _constants.interactions).get(interactionId);
    // eslint-disable-next-line @atlaskit/platform/prefer-crypto-random-uuid -- Use crypto.randomUUID instead
    const id = (0, _uuid.v4)();
    if (!interaction) // add hold timestamp to post interaction log if interaction is complete
    postInteractionLog.addHoldInfo(labelStack, name, performance.now());
    if (interaction != null) {
        const start = performance.now();
        const holdActive = {
            labelStack,
            name,
            start
        };
        if (shouldMoveHoldToExtendedBucket(interaction, holdActive)) ensureExtendedHoldActive(interaction).set(id, (0, _objectSpreadProps._)((0, _objectSpread._)({}, holdActive), {
            start
        }));
        else {
            interaction.holdActive.set(id, (0, _objectSpreadProps._)((0, _objectSpread._)({}, holdActive), {
                start
            }));
            addHoldCriterion(id, labelStack, name, start);
        }
        return ()=>{
            const end = performance.now();
            if (isPerformanceTracingEnabled()) try {
                // for Firefox 102 and older
                performance.measure(`\u{1F6F8} ${labelStackToString(labelStack, name)} [hold]`, {
                    start,
                    end,
                    detail: {
                        devtools: {
                            track: "\uD83D\uDEF8 reactUFO detailed timings",
                            color: 'secondary-light'
                        }
                    }
                });
            } catch (e) {
            // do nothing
            }
            removeHoldCriterion(id);
            const currentInteraction = (0, _constants.interactions).get(interactionId);
            const currentHold = interaction.holdActive.get(id);
            if (currentInteraction != null) {
                if (currentHold != null) {
                    currentInteraction.holdInfo.push((0, _objectSpreadProps._)((0, _objectSpread._)({}, currentHold), {
                        end
                    }));
                    interaction.holdActive.delete(id);
                }
                if (interaction.hold3pActive) {
                    const current3pHold = interaction.hold3pActive.get(id);
                    if (current3pHold != null) {
                        recordMetricVariantCategoryEnd(currentInteraction, current3pHold.labelStack, end);
                        if (!currentInteraction.hold3pInfo) currentInteraction.hold3pInfo = [];
                        currentInteraction.hold3pInfo.push((0, _objectSpreadProps._)((0, _objectSpread._)({}, current3pHold), {
                            end
                        }));
                        interaction.hold3pActive.delete(id);
                    }
                }
            }
        };
    }
    return ()=>{};
}
function addHoldByID(interactionId, labelStack, name, id, ignoreOnSubmit) {
    const interaction = (0, _constants.interactions).get(interactionId);
    if (interaction != null) {
        const start = performance.now();
        const holdActive = {
            labelStack,
            name,
            start,
            ignoreOnSubmit
        };
        if (shouldMoveHoldToExtendedBucket(interaction, holdActive)) ensureExtendedHoldActive(interaction).set(id, holdActive);
        else {
            interaction.holdActive.set(id, holdActive);
            addHoldCriterion(id, labelStack, name, start);
        }
    }
    return ()=>{};
}
function addCompletedHold(interactionId, labelStack, name, start, end) {
    const interaction = (0, _constants.interactions).get(interactionId);
    if (interaction != null) {
        recordMetricVariantCategoryEnd(interaction, labelStack, end);
        ensureExtendedHoldInfo(interaction).push({
            labelStack,
            name,
            start,
            end
        });
    }
}
function removeHoldByID(interactionId, id) {
    const interaction = (0, _constants.interactions).get(interactionId);
    if (interaction != null) {
        const end = performance.now();
        const currentInteraction = (0, _constants.interactions).get(interactionId);
        const currentHold = interaction.holdActive.get(id);
        if (currentInteraction != null && currentHold != null) {
            if (shouldMoveHoldToExtendedBucket(currentInteraction, currentHold)) ensureExtendedHoldInfo(currentInteraction).push((0, _objectSpreadProps._)((0, _objectSpread._)({}, currentHold), {
                end
            }));
            else currentInteraction.holdInfo.push((0, _objectSpreadProps._)((0, _objectSpread._)({}, currentHold), {
                end
            }));
            interaction.holdActive.delete(id);
            removeHoldCriterion(id);
        }
        if (interaction.hold3pActive) {
            const current3pHold = interaction.hold3pActive.get(id);
            if (currentInteraction != null && current3pHold != null) {
                recordMetricVariantCategoryEnd(currentInteraction, current3pHold.labelStack, end);
                if (!currentInteraction.hold3pInfo) currentInteraction.hold3pInfo = [];
                currentInteraction.hold3pInfo.push((0, _objectSpreadProps._)((0, _objectSpread._)({}, current3pHold), {
                    end
                }));
                interaction.hold3pActive.delete(id);
            }
        }
    }
}
function getCurrentInteractionType(interactionId) {
    const interaction = (0, _constants.interactions).get(interactionId);
    if (interaction) return interaction.type;
    return null;
}
const ModuleLoadingProfiler = {
    onPreload (moduleId, _priority) {
        addPreload(extractModuleName(moduleId), performance.now());
    },
    onLoadStart (info) {
        const timeoutId = setTimeout(()=>{
            delete moduleLoadingRequests[info.identifier];
        }, 30000);
        const request = {
            start: performance.now(),
            timeoutId
        };
        moduleLoadingRequests[info.identifier] = request;
    },
    onLoadComplete (info) {
        const request = moduleLoadingRequests[info.identifier];
        if (request) {
            clearTimeout(request.timeoutId);
            delete moduleLoadingRequests[info.identifier];
            addLoad(extractModuleName(info.identifier), request.start, performance.now());
        }
    },
    placeholderFallBackMounted (id, moduleId) {
        const interactionId = (0, _interactionIdContext.getInteractionId)();
        const currentInteractionId = interactionId.current;
        // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
        addHoldByID(currentInteractionId, [], moduleId, id);
    },
    placeholderFallBackUnmounted (id) {
        const interactionId = (0, _interactionIdContext.getInteractionId)();
        const currentInteractionId = interactionId.current;
        // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
        removeHoldByID(currentInteractionId, id);
    }
};
function addError(interactionId, name, labelStack, errorType, errorMessage, errorStack, forcedError, errorHash, errorStatusCode) {
    const interaction = (0, _constants.interactions).get(interactionId);
    if (interaction != null) interaction.errors.push({
        name,
        labelStack,
        errorType,
        errorMessage,
        errorStack,
        forcedError,
        errorHash,
        errorStatusCode
    });
}
function addErrorToAll(name, labelStack, errorType, errorMessage, errorStack, errorHash, errorStatusCode) {
    (0, _constants.interactions).forEach((interaction)=>{
        interaction.errors.push({
            name,
            labelStack,
            errorType,
            errorMessage,
            errorStack,
            errorHash,
            errorStatusCode
        });
    });
}
function addProfilerTimings(interactionId, labelStack, type, actualDuration, baseDuration, startTime, commitTime) {
    var _getConfig_postInteractionLog, _getConfig;
    if (isPerformanceTracingEnabled()) try {
        // for Firefox 102 and older
        performance.measure(`\u{1F6F8} ${labelStackToString(labelStack)} [react-profiler] ${type}`, {
            start: startTime,
            duration: actualDuration,
            detail: {
                devtools: {
                    track: "\uD83D\uDEF8 reactUFO detailed timings",
                    color: 'secondary-dark'
                }
            }
        });
    } catch (e) {
    // do nothing
    }
    const interaction = (0, _constants.interactions).get(interactionId);
    if (interaction != null) interaction.reactProfilerTimings.push({
        labelStack,
        type,
        actualDuration,
        baseDuration,
        startTime,
        commitTime
    });
    else if ((_getConfig = (0, _config.getConfig)()) === null || _getConfig === void 0 ? void 0 : (_getConfig_postInteractionLog = _getConfig.postInteractionLog) === null || _getConfig_postInteractionLog === void 0 ? void 0 : _getConfig_postInteractionLog.enabled) postInteractionLog.addProfilerTimings(labelStack, type, actualDuration, baseDuration, startTime, commitTime);
}
function pushToQueue(id, data) {
    interactionQueue.push({
        id,
        data
    });
}
let handleInteraction = pushToQueue;
const isKnownMetricVariantCategory = (type)=>type === 'third-party' || type === 'gen-ai';
const hasMetricVariantCategory = (labelStack, category)=>{
    var _labelStack_some;
    return (_labelStack_some = labelStack === null || labelStack === void 0 ? void 0 : labelStack.some((label)=>'type' in label && label.type === category)) !== null && _labelStack_some !== void 0 ? _labelStack_some : false;
};
const hasAnyMetricVariantCategory = (labelStack)=>{
    var _labelStack_some;
    return (_labelStack_some = labelStack === null || labelStack === void 0 ? void 0 : labelStack.some((label)=>'type' in label && isKnownMetricVariantCategory(label.type))) !== null && _labelStack_some !== void 0 ? _labelStack_some : false;
};
const getMetricVariantCategories = (labelStack)=>{
    const categories = new Set();
    labelStack === null || labelStack === void 0 ? void 0 : labelStack.forEach((label)=>{
        if ('type' in label && isKnownMetricVariantCategory(label.type)) categories.add(label.type);
    });
    return [
        ...categories
    ];
};
const hasMetricVariantCategoryInHoldData = (interaction, category)=>{
    var _interaction_hold3pActive;
    var _interaction_holdActive_values, _interaction_hold3pInfo, _interaction_hold3pActive_values;
    return interaction.holdInfo.some((hold)=>hasMetricVariantCategory(hold.labelStack, category)) || [
        ...(_interaction_holdActive_values = interaction.holdActive.values()) !== null && _interaction_holdActive_values !== void 0 ? _interaction_holdActive_values : []
    ].some((hold)=>hasMetricVariantCategory(hold.labelStack, category)) || [
        ...(_interaction_hold3pInfo = interaction.hold3pInfo) !== null && _interaction_hold3pInfo !== void 0 ? _interaction_hold3pInfo : []
    ].some((hold)=>hasMetricVariantCategory(hold.labelStack, category)) || [
        ...(_interaction_hold3pActive_values = (_interaction_hold3pActive = interaction.hold3pActive) === null || _interaction_hold3pActive === void 0 ? void 0 : _interaction_hold3pActive.values()) !== null && _interaction_hold3pActive_values !== void 0 ? _interaction_hold3pActive_values : []
    ].some((hold)=>hasMetricVariantCategory(hold.labelStack, category));
};
const recordMetricVariantCategoryEnd = (interaction, labelStack, end)=>{
    const categories = getMetricVariantCategories(labelStack);
    if (categories.length === 0) return;
    var _interaction_metricCategoryEnds;
    interaction.metricCategoryEnds = (_interaction_metricCategoryEnds = interaction.metricCategoryEnds) !== null && _interaction_metricCategoryEnds !== void 0 ? _interaction_metricCategoryEnds : {};
    categories.forEach((category)=>{
        var _interaction_metricCategoryEnds_category;
        interaction.metricCategoryEnds[category] = Math.max((_interaction_metricCategoryEnds_category = interaction.metricCategoryEnds[category]) !== null && _interaction_metricCategoryEnds_category !== void 0 ? _interaction_metricCategoryEnds_category : 0, end);
    });
};
const recordActiveMetricVariantCategoryEnds = (interaction, end)=>{
    var _interaction_hold3pActive;
    (_interaction_hold3pActive = interaction.hold3pActive) === null || _interaction_hold3pActive === void 0 ? void 0 : _interaction_hold3pActive.forEach((hold)=>{
        recordMetricVariantCategoryEnd(interaction, hold.labelStack, end);
    });
};
const hasActiveMetricVariantCategory = (interaction, category)=>{
    var _interaction_hold3pActive;
    var _interaction_hold3pActive_values;
    return [
        ...(_interaction_hold3pActive_values = (_interaction_hold3pActive = interaction.hold3pActive) === null || _interaction_hold3pActive === void 0 ? void 0 : _interaction_hold3pActive.values()) !== null && _interaction_hold3pActive_values !== void 0 ? _interaction_hold3pActive_values : []
    ].some((hold)=>hasMetricVariantCategory(hold.labelStack, category));
};
function shouldMoveHoldToExtendedBucket(interaction, hold) {
    return hasAnyMetricVariantCategory(hold.labelStack) || interaction.end !== 0 && hold.start > interaction.end;
}
function ensureExtendedHoldActive(interaction) {
    var _interaction_hold3pActive;
    interaction.hold3pActive = (_interaction_hold3pActive = interaction.hold3pActive) !== null && _interaction_hold3pActive !== void 0 ? _interaction_hold3pActive : new Map();
    return interaction.hold3pActive;
}
function ensureExtendedHoldInfo(interaction) {
    var _interaction_hold3pInfo;
    interaction.hold3pInfo = (_interaction_hold3pInfo = interaction.hold3pInfo) !== null && _interaction_hold3pInfo !== void 0 ? _interaction_hold3pInfo : [];
    return interaction.hold3pInfo;
}
function moveLateActiveHoldsToExtendedBucket(interaction) {
    if (interaction.end === 0) return;
    const holdsToMove = [
        ...interaction.holdActive.entries()
    ].filter(([, hold])=>shouldMoveHoldToExtendedBucket(interaction, hold));
    holdsToMove.forEach(([id, hold])=>{
        ensureExtendedHoldActive(interaction).set(id, hold);
        interaction.holdActive.delete(id);
    });
}
function ensureMetricWindows(interaction) {
    var _interaction_metricCategoryEnds, _interaction_metricCategoryEnds1;
    if (interaction.end === 0) return;
    const hasGenAI = hasMetricVariantCategoryInHoldData(interaction, 'gen-ai');
    const hasThirdParty = hasMetricVariantCategoryInHoldData(interaction, 'third-party');
    const includeThirdPartyEnd = ((_interaction_metricCategoryEnds = interaction.metricCategoryEnds) === null || _interaction_metricCategoryEnds === void 0 ? void 0 : _interaction_metricCategoryEnds['third-party']) !== undefined ? Math.max(interaction.metricCategoryEnds['third-party'], interaction.end) : interaction.end3p;
    const includeGenAIEnd = ((_interaction_metricCategoryEnds1 = interaction.metricCategoryEnds) === null || _interaction_metricCategoryEnds1 === void 0 ? void 0 : _interaction_metricCategoryEnds1['gen-ai']) !== undefined ? Math.max(interaction.metricCategoryEnds['gen-ai'], interaction.end) : undefined;
    interaction.metricWindows = (0, _objectSpreadProps._)((0, _objectSpread._)({}, interaction.metricWindows), {
        standard: {
            start: interaction.start,
            end: interaction.end,
            includeCategories: [],
            excludeCategories: [
                'third-party',
                'gen-ai'
            ]
        }
    });
    if (includeThirdPartyEnd !== undefined && (hasThirdParty || !hasGenAI)) interaction.metricWindows['include-third-party'] = {
        start: interaction.start,
        end: includeThirdPartyEnd,
        includeCategories: [
            'third-party'
        ],
        excludeCategories: []
    };
    if (hasGenAI && includeGenAIEnd !== undefined) interaction.metricWindows['include-gen-ai'] = {
        start: interaction.start,
        end: includeGenAIEnd,
        includeCategories: [
            'gen-ai'
        ],
        excludeCategories: []
    };
}
function addLifecycleObservation(interaction, observation) {
    var _interaction_lifecycleObservations;
    interaction.lifecycleObservations = (_interaction_lifecycleObservations = interaction.lifecycleObservations) !== null && _interaction_lifecycleObservations !== void 0 ? _interaction_lifecycleObservations : [];
    interaction.lifecycleObservations.push(observation);
}
function callCleanUpCallbacks(interaction) {
    interaction.cleanupCallbacks.reverse().forEach((cleanUpCallback)=>{
        cleanUpCallback();
    });
}
function finishInteraction(id, data, endTime = performance.now()) {
    data.end = endTime;
    ensureMetricWindows(data);
    try {
        // for Firefox 102 and older
        performance.measure(`\u{1F6F8} [${data.type}] ${data.ufoName} [ttai]`, {
            start: data.start,
            end: data.end,
            detail: {
                devtools: {
                    track: 'main metrics',
                    trackGroup: "\uD83D\uDEF8 reactUFO metrics",
                    color: 'tertiary'
                }
            }
        });
        performance.mark(`TTAI`, {
            startTime: data.end,
            detail: {
                devtools: {
                    dataType: 'marker'
                }
            }
        });
    } catch (e) {
    // do nothing
    }
    if (data.featureFlags) data.featureFlags.during = Object.fromEntries((0, _featureFlagsAccessed.currentFeatureFlagsAccessed));
    (0, _experienceTraceIdContext.clearActiveTrace)();
    callCleanUpCallbacks(data);
    (0, _ssrRenderProfiler.flushSsrRenderProfilerTraces)();
    if (data.type === 'page_load') data.hydration = (0, _config.getReactHydrationStats)();
    // By this time, stop the post interaction log observer if coinflip rate is 0
    if (!(0, _coinflipDefault.default)((0, _config.getPostInteractionRate)((0, _utils.sanitizeUfoName)(data.ufoName), data.type))) postInteractionLog.stopVCObserver();
    remove(id);
    PreviousInteractionLog.id = data.id;
    PreviousInteractionLog.type = data.type;
    PreviousInteractionLog.timestamp = data.end;
    PreviousInteractionLog.name = data.ufoName || 'unknown';
    PreviousInteractionLog.isAborted = data.abortReason != null;
    if (data.ufoName) handleInteraction(id, data);
    if (isPerformanceTracingEnabled()) {
        const profilerTimingMap = new Map();
        data.reactProfilerTimings.forEach((profilerTiming)=>{
            const labelStackId = labelStackToIdString(profilerTiming.labelStack);
            if (labelStackId) {
                var _profilerTimingMap_get;
                const timing = (_profilerTimingMap_get = profilerTimingMap.get(labelStackId)) !== null && _profilerTimingMap_get !== void 0 ? _profilerTimingMap_get : {
                    labelStack: profilerTiming.labelStack
                };
                var _timing_start;
                timing.start = profilerTiming.startTime < ((_timing_start = timing.start) !== null && _timing_start !== void 0 ? _timing_start : Number.MAX_SAFE_INTEGER) ? profilerTiming.startTime : timing.start;
                var _timing_end;
                timing.end = profilerTiming.commitTime > ((_timing_end = timing.end) !== null && _timing_end !== void 0 ? _timing_end : Number.MIN_SAFE_INTEGER) ? profilerTiming.commitTime : timing.end;
                profilerTimingMap.set(labelStackId, timing);
            }
        });
        try {
            // for Firefox 102 and older
            for (const [, { labelStack, start, end }] of profilerTimingMap.entries())performance.measure(`\u{1F6F8} ${labelStackToString(labelStack)} [segment_ttai]`, {
                start,
                end,
                detail: {
                    devtools: {
                        track: "\uD83D\uDEF8 reactUFO detailed timings",
                        color: 'secondary-dark'
                    }
                }
            });
        } catch (e) {
        // do nothing
        }
    }
    try {
        // dispatch a global window event to notify the measure is completed
        window.dispatchEvent(new CustomEvent('UFO_FINISH_INTERACTION', {
            detail: data
        }));
    } catch (e) {
    // do nothing
    }
}
function sinkInteractionHandler(sinkFn) {
    if (handleInteraction === pushToQueue) {
        handleInteraction = sinkFn;
        interactionQueue.forEach((interaction)=>{
            sinkFn(interaction.id, interaction.data);
        });
        interactionQueue.length = 0;
    }
}
function sinkPostInteractionLogHandler(sinkFn) {
    postInteractionLog.sinkHandler(sinkFn);
}
// a flag to prevent multiple submitting
let activeSubmitted = false;
function tryComplete(interactionId, endTime) {
    const interaction = (0, _constants.interactions).get(interactionId);
    if (interaction != null) {
        var _interaction_hold3pActive;
        const noMoreActiveHolds = interaction.holdActive.size === 0;
        const shouldUseRawDataThirdParty = (0, _config.shouldUseRawDataThirdPartyBehavior)(interaction.ufoName, interaction.type);
        const postInteraction = async ()=>{
            var _getConfig_postInteractionLog, _getConfig;
            if ((_getConfig = (0, _config.getConfig)()) === null || _getConfig === void 0 ? void 0 : (_getConfig_postInteractionLog = _getConfig.postInteractionLog) === null || _getConfig_postInteractionLog === void 0 ? void 0 : _getConfig_postInteractionLog.enabled) postInteractionLog.onInteractionComplete(interaction);
            activeSubmitted = false;
        };
        const noMoreActiveMetricVariantHolds = ((_interaction_hold3pActive = interaction.hold3pActive) === null || _interaction_hold3pActive === void 0 ? void 0 : _interaction_hold3pActive.size) === 0 || interaction.hold3pActive === undefined;
        const shouldUseSeparatedMetricVariantBehavior = shouldUseRawDataThirdParty || hasActiveMetricVariantCategory(interaction, 'gen-ai');
        // If using separated metric variant behavior, wait for extended category holds to clear.
        // The backing fields still use their legacy 3P names because they are part of the existing
        // third-party payload contract, but this bucket now also drives client metric windows.
        if (shouldUseSeparatedMetricVariantBehavior) {
            // If there are no standard holds active, mark the interaction as successful
            // but don't finish until extended metric variant holds are cleared.
            if (noMoreActiveHolds && !noMoreActiveMetricVariantHolds) {
                // Mark interaction as successful by setting endTime, but don't finish yet
                if (endTime !== undefined && interaction.end === 0) interaction.end = endTime;
                moveLateActiveHoldsToExtendedBucket(interaction);
                ensureMetricWindows(interaction);
                // Wait for extended metric variant holds to clear before finishing.
                return;
            }
            // If all holds, including extended metric variant holds, are cleared, finish the interaction.
            if (noMoreActiveHolds && noMoreActiveMetricVariantHolds) {
                if (!activeSubmitted) {
                    var _getConfig_extraSearchPageInteraction, _getConfig, _getConfig_extraSearchPageInteraction1, _getConfig1;
                    // Set the legacy third-party end marker when extended metric variant holds clear,
                    // preserving existing 3P payload behavior while category-specific end times are
                    // recorded separately in metricCategoryEnds.
                    const currentTime = endTime !== null && endTime !== void 0 ? endTime : performance.now();
                    interaction.end3p = interaction.end !== 0 && currentTime < interaction.end ? interaction.end : currentTime;
                    ensureMetricWindows(interaction);
                    finishInteraction(interactionId, interaction, interaction.end !== 0 ? interaction.end : endTime);
                    if (((_getConfig = (0, _config.getConfig)()) === null || _getConfig === void 0 ? void 0 : (_getConfig_extraSearchPageInteraction = _getConfig.extraSearchPageInteraction) === null || _getConfig_extraSearchPageInteraction === void 0 ? void 0 : _getConfig_extraSearchPageInteraction.enabled) && interaction.ufoName === ((_getConfig1 = (0, _config.getConfig)()) === null || _getConfig1 === void 0 ? void 0 : (_getConfig_extraSearchPageInteraction1 = _getConfig1.extraSearchPageInteraction) === null || _getConfig_extraSearchPageInteraction1 === void 0 ? void 0 : _getConfig_extraSearchPageInteraction1.searchPageMetricName)) (0, _createExtraSearchPageInteractionPayload.onSearchPageInteractionComplete)(interactionId, interaction);
                    activeSubmitted = true;
                }
                postInteraction();
            }
        } else if (noMoreActiveHolds) {
            if (!activeSubmitted) {
                var _getConfig_extraSearchPageInteraction2, _getConfig2, _getConfig_extraSearchPageInteraction3, _getConfig3;
                finishInteraction(interactionId, interaction, endTime);
                if (((_getConfig2 = (0, _config.getConfig)()) === null || _getConfig2 === void 0 ? void 0 : (_getConfig_extraSearchPageInteraction2 = _getConfig2.extraSearchPageInteraction) === null || _getConfig_extraSearchPageInteraction2 === void 0 ? void 0 : _getConfig_extraSearchPageInteraction2.enabled) && interaction.ufoName === ((_getConfig3 = (0, _config.getConfig)()) === null || _getConfig3 === void 0 ? void 0 : (_getConfig_extraSearchPageInteraction3 = _getConfig3.extraSearchPageInteraction) === null || _getConfig_extraSearchPageInteraction3 === void 0 ? void 0 : _getConfig_extraSearchPageInteraction3.searchPageMetricName)) (0, _createExtraSearchPageInteractionPayload.onSearchPageInteractionComplete)(interactionId, interaction);
                activeSubmitted = true;
            }
            postInteraction();
        }
    }
}
function callCancelCallbacks(interaction) {
    interaction.cancelCallbacks.reverse().forEach((cancelCallback)=>{
        cancelCallback();
    });
}
function abort(interactionId, abortReason) {
    const interaction = (0, _constants.interactions).get(interactionId);
    if (interaction != null) {
        var _interaction_hold3pActive;
        const shouldUseRawDataThirdParty = (0, _config.shouldUseRawDataThirdPartyBehavior)(interaction.ufoName, interaction.type);
        const noMoreActiveHolds = interaction.holdActive.size === 0;
        const has3pHoldsActive = interaction.hold3pActive && interaction.hold3pActive.size > 0;
        const shouldUseSeparatedMetricVariantBehavior = shouldUseRawDataThirdParty || hasActiveMetricVariantCategory(interaction, 'gen-ai');
        // If only extended metric variant holds are active, finish as successful instead of aborting
        if (shouldUseSeparatedMetricVariantBehavior && noMoreActiveHolds && has3pHoldsActive) {
            var _interaction_hold3pActive1;
            const endTime = interaction.end !== 0 ? interaction.end : performance.now();
            interaction.end3p = performance.now();
            recordActiveMetricVariantCategoryEnds(interaction, interaction.end3p);
            var _interaction_hold3pActive_size;
            addLifecycleObservation(interaction, {
                type: abortReason === 'timeout' ? 'timeout_expired' : 'page_unloaded',
                timestamp: interaction.end3p,
                activeHoldCount: (_interaction_hold3pActive_size = (_interaction_hold3pActive1 = interaction.hold3pActive) === null || _interaction_hold3pActive1 === void 0 ? void 0 : _interaction_hold3pActive1.size) !== null && _interaction_hold3pActive_size !== void 0 ? _interaction_hold3pActive_size : 0
            });
            ensureMetricWindows(interaction);
            finishInteraction(interactionId, interaction, endTime);
            postInteractionLog.reset();
            postInteractionLog.stopVCObserver();
            return;
        }
        callCancelCallbacks(interaction);
        interaction.abortReason = abortReason;
        var _interaction_hold3pActive_size1;
        addLifecycleObservation(interaction, {
            type: abortReason === 'timeout' ? 'timeout_expired' : 'page_unloaded',
            timestamp: performance.now(),
            activeHoldCount: interaction.holdActive.size + ((_interaction_hold3pActive_size1 = (_interaction_hold3pActive = interaction.hold3pActive) === null || _interaction_hold3pActive === void 0 ? void 0 : _interaction_hold3pActive.size) !== null && _interaction_hold3pActive_size1 !== void 0 ? _interaction_hold3pActive_size1 : 0)
        });
        finishInteraction(interactionId, interaction);
        postInteractionLog.reset();
        postInteractionLog.stopVCObserver();
    }
}
function abortByNewInteraction(interactionId, interactionName) {
    const interaction = (0, _constants.interactions).get(interactionId);
    if (interaction != null) {
        const shouldUseRawDataThirdParty = (0, _config.shouldUseRawDataThirdPartyBehavior)(interaction.ufoName, interaction.type);
        const noMoreActiveHolds = interaction.holdActive.size === 0;
        const has3pHoldsActive = interaction.hold3pActive && interaction.hold3pActive.size > 0;
        const shouldUseSeparatedMetricVariantBehavior = shouldUseRawDataThirdParty || hasActiveMetricVariantCategory(interaction, 'gen-ai');
        // If only extended metric variant holds are active, finish as successful instead of aborting
        if (shouldUseSeparatedMetricVariantBehavior && noMoreActiveHolds && has3pHoldsActive) {
            const endTime = interaction.end !== 0 ? interaction.end : performance.now();
            // Set end3p to current time, but ensure it's at least interaction.end
            interaction.end3p = performance.now();
            recordActiveMetricVariantCategoryEnds(interaction, interaction.end3p);
            addLifecycleObservation(interaction, {
                type: 'new_interaction_started',
                timestamp: interaction.end3p,
                triggerName: interactionName
            });
            ensureMetricWindows(interaction);
            finishInteraction(interactionId, interaction, endTime);
            postInteractionLog.reset();
            postInteractionLog.stopVCObserver();
            return;
        }
        callCancelCallbacks(interaction);
        interaction.abortReason = 'new_interaction';
        interaction.abortedByInteractionName = interactionName;
        addLifecycleObservation(interaction, {
            type: 'new_interaction_started',
            timestamp: performance.now(),
            triggerName: interactionName
        });
        finishInteraction(interactionId, interaction);
        postInteractionLog.reset();
        postInteractionLog.stopVCObserver();
    } else if ((0, _platformFeatureFlags.fg)('platform_reset_post_interaction_on_new_interaction')) {
        // post-interaction log is active after interaction is aborted by new one
        postInteractionLog.reset();
        postInteractionLog.stopVCObserver();
    }
}
function abortAll(abortReason, abortedByInteractionName) {
    const activeInteraction = getActiveInteraction();
    const finishInteractions = (0, _config.getFinishInteractionOnTransition)();
    (0, _constants.interactions).forEach((interaction, interactionId)=>{
        const isActiveInteraction = activeInteraction === interaction;
        let hasFinished = interaction.holdActive.size === 0;
        if (isActiveInteraction && abortReason === 'transition' && interaction.type === 'press' && (finishInteractions === null || finishInteractions === void 0 ? void 0 : finishInteractions.includes(interaction.ufoName))) hasFinished = true;
        const shouldUseRawDataThirdParty = (0, _config.shouldUseRawDataThirdPartyBehavior)(interaction.ufoName, interaction.type);
        const noMoreActiveHolds = interaction.holdActive.size === 0;
        const has3pHoldsActive = interaction.hold3pActive && interaction.hold3pActive.size > 0;
        const shouldUseSeparatedMetricVariantBehavior = shouldUseRawDataThirdParty || hasActiveMetricVariantCategory(interaction, 'gen-ai');
        // If only extended metric variant holds are active, finish as successful instead of aborting
        if (shouldUseSeparatedMetricVariantBehavior && noMoreActiveHolds && has3pHoldsActive) {
            const endTime = interaction.end !== 0 ? interaction.end : performance.now();
            interaction.end3p = performance.now();
            recordActiveMetricVariantCategoryEnds(interaction, interaction.end3p);
            addLifecycleObservation(interaction, {
                type: abortReason === 'transition' ? 'transition_started' : 'new_interaction_started',
                timestamp: interaction.end3p,
                triggerName: abortedByInteractionName
            });
            ensureMetricWindows(interaction);
            finishInteraction(interactionId, interaction, endTime);
            postInteractionLog.reset();
            postInteractionLog.stopVCObserver();
            return;
        }
        if (!hasFinished) {
            callCancelCallbacks(interaction);
            interaction.abortReason = abortReason;
            if (abortedByInteractionName != null) interaction.abortedByInteractionName = abortedByInteractionName;
            addLifecycleObservation(interaction, {
                type: abortReason === 'transition' ? 'transition_started' : 'new_interaction_started',
                timestamp: performance.now(),
                triggerName: abortedByInteractionName
            });
        }
        finishInteraction(interactionId, interaction);
        postInteractionLog.reset();
        postInteractionLog.stopVCObserver();
    });
}
function addOnCancelCallback(id, cancelCallback) {
    const interaction = (0, _constants.interactions).get(id);
    interaction === null || interaction === void 0 ? void 0 : interaction.cancelCallbacks.push(cancelCallback);
}
function addNewInteraction(interactionId, ufoName, type, startTime, rate, labelStack, routeName, trace = null) {
    var _config_extraSearchPageInteraction, _config_extraSearchPageInteraction1;
    postInteractionLog.reset();
    let vcObserver;
    let previousTime = startTime;
    let timeoutTime = (0, _config.getInteractionTimeout)(ufoName);
    const timerID = setTimeout(()=>{
        abort(interactionId, 'timeout');
    }, timeoutTime);
    function changeTimeout(newTime) {
        // we compare if the time left is lower than the new time to no
        // extend the timeout beyond the initial waiting time
        const currentTime = performance.now();
        const timeLeft = timeoutTime - (currentTime - previousTime);
        if (timeLeft < newTime) return;
        clearTimeout(this.timerID);
        const newTimerID = setTimeout(()=>{
            abort(interactionId, 'timeout');
        }, newTime);
        timeoutTime = newTime;
        previousTime = currentTime;
        this.timerID = newTimerID;
    }
    const addFeatureFlagsToInteraction = (0, _coinflipDefault.default)((0, _config.getCapabilityRate)('feature_flag_access'));
    const config = (0, _config.getConfig)();
    const searchPageConfig = {
        enableSmartAnswersMutations: config === null || config === void 0 ? void 0 : (_config_extraSearchPageInteraction = config.extraSearchPageInteraction) === null || _config_extraSearchPageInteraction === void 0 ? void 0 : _config_extraSearchPageInteraction.enabled,
        searchPageRoute: config === null || config === void 0 ? void 0 : (_config_extraSearchPageInteraction1 = config.extraSearchPageInteraction) === null || _config_extraSearchPageInteraction1 === void 0 ? void 0 : _config_extraSearchPageInteraction1.searchPageRoute
    };
    if (config && config.vc) {
        const vcOptions = {
            heatmapSize: config.vc.heatmapSize,
            oldDomUpdates: config.vc.oldDomUpdates,
            devToolsEnabled: config.vc.devToolsEnabled,
            // Use centralised getter so the FedRAMP override (forces every
            // selector field to false) is applied consistently.
            selectorConfig: (0, _config.getSelectorConfig)(),
            ssrEnablePageLayoutPlaceholder: config.vc.ssrEnablePageLayoutPlaceholder,
            trackLayoutShiftOffenders: config.vc.trackLayoutShiftOffenders,
            searchPageConfig
        };
        vcObserver = (0, _vc.newVCObserver)(vcOptions);
    }
    const priorAccessedFg = type === 'press' ? {} : Object.fromEntries((0, _featureFlagsAccessed.allFeatureFlagsAccessed));
    const metrics = {
        id: interactionId,
        start: startTime,
        end: 0,
        ufoName,
        type,
        previousInteractionName: PreviousInteractionLog.name,
        isPreviousInteractionAborted: PreviousInteractionLog.isAborted === true,
        marks: [],
        customData: [],
        cohortingCustomData: new Map(),
        customTimings: [],
        spans: [],
        requestInfo: [],
        reactProfilerTimings: [],
        holdInfo: [],
        holdActive: new Map(),
        // measure when we execute this code
        // from this, we can measure the input delay -
        // how long the browser took to hand execution back to JS)
        measureStart: performance.now(),
        rate,
        cancelCallbacks: [],
        metaData: {},
        errors: [],
        apdex: [],
        labelStack,
        routeName: routeName !== null && routeName !== void 0 ? routeName : ufoName,
        featureFlags: addFeatureFlagsToInteraction ? {
            prior: priorAccessedFg,
            during: {}
        } : undefined,
        knownSegments: [],
        cleanupCallbacks: [],
        awaitReactProfilerCount: 0,
        redirects: [],
        timerID,
        changeTimeout,
        trace,
        vcObserver,
        hold3pActive: new Map(),
        hold3pInfo: [],
        minorInteractions: []
    };
    if (addFeatureFlagsToInteraction) (0, _featureFlagsAccessed.currentFeatureFlagsAccessed).clear();
    (0, _constants.interactions).set(interactionId, metrics);
    const segmentObserver = {
        onAdd (segment) {
            metrics.knownSegments.push(segment);
        },
        onRemove () {}
    };
    addSegmentObserver(segmentObserver);
    metrics.cleanupCallbacks.push(()=>{
        removeSegmentObserver(segmentObserver);
    });
    metrics.cleanupCallbacks.push(()=>{
        clearTimeout(metrics.timerID);
    });
    // Add cleanup for per-interaction VC observer
    if (vcObserver) metrics.cleanupCallbacks.push(()=>{
        vcObserver.stop(ufoName);
    });
    const awaitBM3TTIList = (0, _config.getAwaitBM3TTIList)();
    if (awaitBM3TTIList.includes(ufoName)) addHoldByID(interactionId, [], ufoName, ufoName, true);
    if (type === 'transition' || type === 'page_load') {
        var _getConfig_postInteractionLog, _getConfig;
        // Use per-interaction VC observer if available, otherwise fall back to global
        const observer = vcObserver;
        if (observer) observer.start({
            startTime,
            experienceKey: ufoName
        });
        // Start post interaction observer for all if config is enabled
        // in case ufoName is updated at later time
        if ((_getConfig = (0, _config.getConfig)()) === null || _getConfig === void 0 ? void 0 : (_getConfig_postInteractionLog = _getConfig.postInteractionLog) === null || _getConfig_postInteractionLog === void 0 ? void 0 : _getConfig_postInteractionLog.enabled) postInteractionLog.startVCObserver({
            startTime
        });
    }
    if (type === 'press') {
        // Use per-interaction VC observer if available, otherwise fall back to global
        const observer = vcObserver;
        if (observer) observer.start({
            startTime,
            experienceKey: ufoName
        });
    }
}
function addBrowserMetricEvent(event) {
    const interaction = getActiveInteraction();
    if (interaction) {
        var _event_config;
        interaction.legacyMetrics = interaction.legacyMetrics || [];
        interaction.legacyMetrics.push(event);
        if ((interaction.type === 'page_load' || interaction.type === 'transition') && ((_event_config = event.config) === null || _event_config === void 0 ? void 0 : _event_config.type) === 'PAGE_LOAD') removeHoldByID(interaction.id, interaction.ufoName);
    }
}
function addApdexToAll(apdex) {
    (0, _constants.interactions).forEach((interaction, key)=>{
        interaction.apdex.push(apdex);
        try {
            var _apdex_startTime;
            // for Firefox 102 and older
            performance.measure(`\u{1F6F8} ${apdex.key} [bm3_tti]`, {
                start: (_apdex_startTime = apdex.startTime) !== null && _apdex_startTime !== void 0 ? _apdex_startTime : interaction.start,
                end: apdex.stopTime,
                detail: {
                    devtools: {
                        track: 'main metrics',
                        trackGroup: "\uD83D\uDEF8 reactUFO metrics",
                        color: 'primary-dark'
                    }
                }
            });
            performance.mark(`[bm3] TTI`, {
                startTime: apdex.stopTime,
                detail: {
                    devtools: {
                        dataType: 'marker'
                    }
                }
            });
        } catch (e) {
        // do nothing
        }
        if (interaction.type === 'page_load' || interaction.type === 'transition') removeHoldByID(key, interaction.ufoName);
    });
}
function addApdex(interactionId, apdexInfo) {
    const interaction = (0, _constants.interactions).get(interactionId);
    if (interaction != null) {
        interaction.apdex.push(apdexInfo);
        try {
            var _apdexInfo_startTime;
            // for Firefox 102 and older
            performance.measure(`\u{1F6F8} ${apdexInfo.key} [bm3_tti]`, {
                start: (_apdexInfo_startTime = apdexInfo.startTime) !== null && _apdexInfo_startTime !== void 0 ? _apdexInfo_startTime : interaction.start,
                end: apdexInfo.stopTime,
                detail: {
                    devtools: {
                        track: 'main metrics',
                        trackGroup: "\uD83D\uDEF8 reactUFO metrics",
                        color: 'primary-dark'
                    }
                }
            });
            performance.mark(`[bm3] TTI`, {
                startTime: apdexInfo.stopTime,
                detail: {
                    devtools: {
                        dataType: 'marker'
                    }
                }
            });
        } catch (e) {
        // do nothing
        }
        if (interaction.type === 'page_load' || interaction.type === 'transition') removeHoldByID(interactionId, interaction.ufoName);
    }
}
function addRequestInfo(interactionId, labelStack, requestInfo) {
    const interaction = (0, _constants.interactions).get(interactionId);
    if (interaction != null) interaction.requestInfo.push((0, _objectSpread._)({
        labelStack
    }, requestInfo));
}
function isSegmentLabel(obj) {
    return obj && typeof obj.name === 'string' && typeof obj.segmentId === 'string';
}
function getSegmentCacheKey(labelStack) {
    return labelStack.map((l)=>{
        if (isSegmentLabel(l)) return `${l.name}_${l.segmentId}`;
        return l.name;
    }).join('|');
}
function addSegment(labelStack) {
    const key = getSegmentCacheKey(labelStack);
    const existingSegment = segmentCache.get(key);
    if (!existingSegment) {
        const segmentInfo = {
            labelStack
        };
        segmentCache.set(key, segmentInfo);
        segmentObservers.forEach((observer)=>{
            observer.onAdd(segmentInfo);
        });
    }
}
function removeSegment(labelStack) {
    const key = getSegmentCacheKey(labelStack);
    const segmentInfo = segmentCache.get(key);
    if (segmentInfo) {
        segmentCache.delete(JSON.stringify(labelStack));
        const cacheKey = (0, _utils.stringifyLabelStackFully)(labelStack);
        segmentUnmountCache.set(cacheKey, (segmentUnmountCache.get(cacheKey) || 0) + 1);
        segmentObservers.forEach((observer)=>{
            observer.onRemove(segmentInfo);
        });
    }
}
function addRedirect(interactionId, fromUfoName, nextUfoName, nextRouteName, time) {
    const interaction = (0, _constants.interactions).get(interactionId);
    if (interaction != null) {
        interaction.ufoName = nextUfoName;
        interaction.routeName = nextRouteName;
        interaction.redirects.push({
            fromInteractionName: fromUfoName,
            time
        });
        if (isPerformanceTracingEnabled()) {
            const prevRedirect = interaction.redirects.at(-2);
            try {
                var _prevRedirect_time;
                // for Firefox 102 and older
                performance.measure(`\u{1F6F8} ${nextUfoName} [redirect]`, {
                    start: (_prevRedirect_time = prevRedirect === null || prevRedirect === void 0 ? void 0 : prevRedirect.time) !== null && _prevRedirect_time !== void 0 ? _prevRedirect_time : interaction.start,
                    end: time,
                    detail: {
                        devtools: {
                            track: "\uD83D\uDEF8 reactUFO detailed timings",
                            color: 'tertiary'
                        }
                    }
                });
            } catch (e) {
            // do nothing
            }
        }
    }
}
const interactionSpans = [];
const defaultLabelStack = [
    {
        name: 'custom'
    }
];
function addCustomSpans(name, start, end = performance.now(), size = 0, labelStack = defaultLabelStack) {
    const customSpan = {
        type: 'custom',
        name,
        start,
        end,
        labelStack,
        size
    };
    interactionSpans.push(customSpan);
}

},{"@swc/helpers/_/_object_spread":"9gdrV","@swc/helpers/_/_object_spread_props":"kANqQ","uuid":"5elg8","@atlaskit/platform-feature-flags":"8rD2i","../coinflip":"e6eL5","../common/utils/timing-name":"03eCI","../config":"bx9i6","../create-extra-search-page-interaction-payload":"2hccT","../create-payload/common/utils":"bqJei","../experience-trace-id-context":"aWDQC","../feature-flags-accessed":"cXQ8g","../interaction-id-context":"eBW7s","../resource-timing/common/utils/resource-timing-initiator-types":"lKGMp","../segment/ssr-render-profiler":"b0GDU","../vc":"l4p8T","./common/constants":"j1a3t","./post-interaction-log":"6CSgU","@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"e6eL5":[function(require,module,exports,__globalThis) {
/**
 * A random function that passes one in rate times.
 * E.g. coinflip(2) is the same as if you flipped a coin.
 * It will pass 50% of the time
 * @param rate The change that it will pass (1 in <rate> times)
 * @returns bool, if it passes or not
 */ var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
function coinflip(rate) {
    if (rate === 0) return false;
    else if (rate === 1) return true;
    else return Math.random() * rate <= 1;
}
exports.default = coinflip;

},{"@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"03eCI":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "MAX_TIMING_NAME_LENGTH", ()=>MAX_TIMING_NAME_LENGTH);
// eslint-disable-next-line @atlaskit/volt-strict-mode/no-multiple-exports
parcelHelpers.export(exports, "sanitizeTimingName", ()=>sanitizeTimingName);
const MAX_TIMING_NAME_LENGTH = 255;
const GQL_OPERATION_PARAMS = [
    'operation',
    'operationName',
    'q'
];
function isGqlUrl(name) {
    try {
        const url = new URL(name);
        const searchParams = url.search ? new URLSearchParams(url.search) : null;
        return GQL_OPERATION_PARAMS.some((param)=>Boolean(searchParams === null || searchParams === void 0 ? void 0 : searchParams.get(param)));
    } catch (e) {
        return false;
    }
}
function sanitizeTimingName(name) {
    if (name.length <= MAX_TIMING_NAME_LENGTH) return name;
    if (isGqlUrl(name)) return name;
    return name.slice(0, MAX_TIMING_NAME_LENGTH);
}

},{"@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"bqJei":[function(require,module,exports,__globalThis) {
/* eslint-disable @atlaskit/volt-strict-mode/no-multiple-exports */ var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "sanitizeUfoName", ()=>sanitizeUfoName);
parcelHelpers.export(exports, "sanitizeLabelStackName", ()=>sanitizeLabelStackName);
parcelHelpers.export(exports, "isSegmentLabel", ()=>isSegmentLabel);
parcelHelpers.export(exports, "buildSegmentTree", ()=>buildSegmentTree);
parcelHelpers.export(exports, "stringifyLabelStackFully", ()=>stringifyLabelStackFully);
parcelHelpers.export(exports, "stringifyLabelStackWithoutId", ()=>stringifyLabelStackWithoutId);
parcelHelpers.export(exports, "labelStackStartWith", ()=>labelStackStartWith);
parcelHelpers.export(exports, "optimizeLabelStack", ()=>optimizeLabelStack);
/**
 * Optimizes a labelStack with registry-based deduplication.
 * When a registry is provided and the version is '2.0.0', the labelStack string
 * is registered in the lookup table and a numeric index is returned instead of the full string.
 * Falls back to regular optimizeLabelStack when no registry is provided.
 */ parcelHelpers.export(exports, "optimizeLabelStackWithRegistry", ()=>optimizeLabelStackWithRegistry);
parcelHelpers.export(exports, "getOldSegmentsLabelStack", ()=>getOldSegmentsLabelStack);
var _objectSpread = require("@swc/helpers/_/_object_spread");
var _objectSpreadProps = require("@swc/helpers/_/_object_spread_props");
var _objectWithoutProperties = require("@swc/helpers/_/_object_without_properties");
var _config = require("../../../config");
function sanitizeUfoName(name) {
    return name.replace(/_/g, '-');
}
function sanitizeLabelStackName(name) {
    if (name.startsWith('/')) name = name.replace(/^\/+/, '');
    if (name.endsWith('/')) name = name.replace(/\/+$/, '');
    return name;
}
function isSegmentLabel(obj) {
    return obj && typeof obj.name === 'string' && typeof obj.segmentId === 'string';
}
function buildSegmentTree(labelStacks) {
    const r = {
        n: 'segment-tree-root',
        c: {}
    };
    const config = (0, _config.getConfig)();
    const segmentThreshold = config === null || config === void 0 ? void 0 : config.segmentsThreshold;
    const addSegmentsMap = new Map();
    labelStacks.forEach((labelStack)=>{
        const stringifiedLabelStack = stringifyLabelStackWithoutId(labelStack);
        let currentNode = r;
        for (const label of labelStack){
            const isSegment = isSegmentLabel(label);
            const name = sanitizeLabelStackName(label.name);
            if (isSegment && segmentThreshold && segmentThreshold[name]) {
                const threshold = segmentThreshold[name];
                const count = addSegmentsMap.get(stringifiedLabelStack) || 0;
                if (count < threshold) addSegmentsMap.set(stringifiedLabelStack, count + 1);
                else break;
            }
            const id = isSegment ? label.segmentId : undefined;
            const key = id !== undefined ? id : name;
            const type = isSegment ? label.type : undefined;
            if (!currentNode.c) currentNode.c = {};
            if (!currentNode.c[key]) currentNode.c[key] = (0, _objectSpread._)({
                n: name
            }, type ? {
                t: type
            } : {});
            currentNode = currentNode.c[key];
        }
    });
    return {
        r
    };
}
function stringifyLabelStackFully(labelStack) {
    return labelStack.map((l)=>{
        const name = sanitizeLabelStackName(l.name);
        if (isSegmentLabel(l)) return `${name}:${l.segmentId}`;
        return name;
    }).join('/');
}
function stringifyLabelStackWithoutId(labelStack) {
    return labelStack.map((l)=>{
        const name = sanitizeLabelStackName(l.name);
        if (isSegmentLabel(l)) return `${name}:segment`;
        return name;
    }).join('/');
}
function getLabelStackReference(labelStack) {
    return labelStack.map((l)=>isSegmentLabel(l) ? l.segmentId : sanitizeLabelStackName(l.name)).join('/');
}
function labelStackStartWith(labelStack, startWith) {
    return stringifyLabelStackFully(labelStack).startsWith(stringifyLabelStackFully(startWith));
}
function optimizeLabelStack(labelStack, reactUFOVersion) {
    return reactUFOVersion === '2.0.0' ? getLabelStackReference(labelStack) : labelStack.map((ls)=>(0, _objectSpread._)({
            n: sanitizeLabelStackName(ls.name)
        }, ls.segmentId ? {
            s: ls.segmentId
        } : {}, ls.type ? {
            t: ls.type
        } : {}));
}
function optimizeLabelStackWithRegistry(labelStack, reactUFOVersion, registry) {
    if (registry && reactUFOVersion === '2.0.0') {
        const ref = getLabelStackReference(labelStack);
        return registry.register(ref);
    }
    return optimizeLabelStack(labelStack, reactUFOVersion);
}
function getOldSegmentsLabelStack(segments, _interactionType) {
    const config = (0, _config.getConfig)();
    const addSegmentsMap = new Map();
    const segmentThreshold = config === null || config === void 0 ? void 0 : config.segmentsThreshold;
    return segments.map((_param)=>{
        var { labelStack } = _param, others = (0, _objectWithoutProperties._)(_param, [
            "labelStack"
        ]);
        const stringifiedLabelStack = stringifyLabelStackWithoutId(labelStack);
        const segmentsInfo = [];
        for (const ls of labelStack){
            const isSegment = isSegmentLabel(ls);
            const name = sanitizeLabelStackName(ls.name);
            if (isSegment && segmentThreshold && segmentThreshold[name]) {
                const threshold = segmentThreshold[name];
                const count = addSegmentsMap.get(stringifiedLabelStack) || 0;
                if (count < threshold) addSegmentsMap.set(stringifiedLabelStack, count + 1);
                else break;
            }
            segmentsInfo.push((0, _objectSpread._)({
                n: name
            }, ls.segmentId ? {
                s: ls.segmentId
            } : {}, ls.type ? {
                t: ls.type
            } : {}));
        }
        return (0, _objectSpreadProps._)((0, _objectSpread._)({}, others), {
            labelStack: segmentsInfo
        });
    });
}

},{"@swc/helpers/_/_object_spread":"9gdrV","@swc/helpers/_/_object_spread_props":"kANqQ","@swc/helpers/_/_object_without_properties":"6HqIM","../../../config":"bx9i6","@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"aWDQC":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
// DO NOT CALL THIS FUNCTION DIRECTLY!!!!
// It is only to be called by React UFO libraries for the automatic handling of trace context for experiences.
// Calling this may cause trace context to be broken
parcelHelpers.export(exports, "generateSpanId", ()=>generateSpanId);
// DO NOT CALL THIS FUNCTION DIRECTLY!!!!
// It is only to be called by React UFO libraries for the automatic handling of trace context for experiences.
// Calling this may cause trace context to be broken
// eslint-disable-next-line @atlaskit/volt-strict-mode/no-multiple-exports
parcelHelpers.export(exports, "setInteractionActiveTrace", ()=>setInteractionActiveTrace);
// DO NOT CALL THIS FUNCTION DIRECTLY!!!!
// It is only to be called by React UFO libraries for the automatic handling of trace context for experiences.
// Calling this may cause trace context to be broken
// eslint-disable-next-line @atlaskit/volt-strict-mode/no-multiple-exports
parcelHelpers.export(exports, "setActiveTrace", ()=>setActiveTrace);
// eslint-disable-next-line @atlaskit/volt-strict-mode/no-multiple-exports
parcelHelpers.export(exports, "getActiveTrace", ()=>getActiveTrace);
// DO NOT CALL THIS FUNCTION DIRECTLY!!!!
// It is only to be called by React UFO libraries for the automatic handling of trace context for experiences.
// Calling this may cause trace context to be broken
// eslint-disable-next-line @atlaskit/volt-strict-mode/no-multiple-exports
parcelHelpers.export(exports, "clearActiveTrace", ()=>clearActiveTrace);
// eslint-disable-next-line @atlaskit/volt-strict-mode/no-multiple-exports
parcelHelpers.export(exports, "getActiveTraceHttpRequestHeaders", ()=>getActiveTraceHttpRequestHeaders);
// eslint-disable-next-line @atlaskit/volt-strict-mode/no-multiple-exports
parcelHelpers.export(exports, "getActiveTraceAsQueryParams", ()=>getActiveTraceAsQueryParams);
var _api = require("@opentelemetry/api");
var _platformFeatureFlags = require("@atlaskit/platform-feature-flags");
var _contextManager = require("./context-manager");
var _makeTraceHttpRequestHeaders = require("./utils/make-trace-http-request-headers");
const state = {
    context: null
};
const traceIdKey = (0, _api.createContextKey)('traceId');
const spanIdKey = (0, _api.createContextKey)('spanId');
const experienceTypeKey = (0, _api.createContextKey)('type');
function generateSpanId() {
    return Array.from(new Array(16), ()=>Math.floor(Math.random() * 16).toString(16)).join('');
}
function setInteractionActiveTrace(interactionId, experienceType) {
    setActiveTrace(interactionId.replace(/-/g, ''), generateSpanId(), experienceType);
}
function setActiveTrace(traceId, spanId, type) {
    if ((0, _platformFeatureFlags.fg)('platform_ufo_enable_otel_context_manager')) {
        const activeTraceContext = (0, _api.ROOT_CONTEXT).setValue(traceIdKey, traceId).setValue(spanIdKey, spanId).setValue(experienceTypeKey, type);
        // Now we need to get the global Context Manager and set the active context
        // Using type assertion because we've "extended" the ContextManager type
        if ((0, _contextManager.getContextManager)() instanceof (0, _contextManager.UFOContextManager)) {
            let contextManager = (0, _contextManager.getContextManager)();
            contextManager.setActive(activeTraceContext);
        }
    } else state.context = {
        traceId,
        spanId,
        type
    };
}
function getActiveTrace() {
    if ((0, _platformFeatureFlags.fg)('platform_ufo_enable_otel_context_manager')) {
        // Get trace context from active context
        const activeTraceContext = {
            traceId: String((0, _api.context).active().getValue(traceIdKey)),
            spanId: String((0, _api.context).active().getValue(spanIdKey)),
            type: String((0, _api.context).active().getValue(experienceTypeKey))
        };
        // Return activeTraceContext if traceId and spanId are not "undefined"
        return activeTraceContext.traceId !== 'undefined' && activeTraceContext.spanId !== 'undefined' ? activeTraceContext : undefined;
    } else return state.context || undefined;
}
function clearActiveTrace() {
    if ((0, _platformFeatureFlags.fg)('platform_ufo_enable_otel_context_manager')) // Now we need to get the global Context Manager and set the active context
    // Using type assertion because we've "extended" the ContextManager type
    {
        if ((0, _contextManager.getContextManager)() instanceof (0, _contextManager.UFOContextManager)) {
            let contextManager = (0, _contextManager.getContextManager)();
            // ROOT_CONTEXT is an empty context used to initialise ContextManagers
            contextManager.setActive((0, _api.ROOT_CONTEXT));
        }
    } else state.context = null;
}
function getActiveTraceHttpRequestHeaders(_url) {
    if (getActiveTrace() === undefined) return null;
    const { traceId, spanId } = getActiveTrace();
    return (0, _makeTraceHttpRequestHeaders.makeTraceHttpRequestHeaders)(traceId, spanId);
}
function getActiveTraceAsQueryParams(_url) {
    const traceHeaders = getActiveTraceHttpRequestHeaders();
    return traceHeaders ? new URLSearchParams(traceHeaders).toString().toLowerCase() : null;
}

},{"@opentelemetry/api":"9lCa7","@atlaskit/platform-feature-flags":"8rD2i","./context-manager":"fVmSw","./utils/make-trace-http-request-headers":"12lmj","@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"12lmj":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "makeTraceHttpRequestHeaders", ()=>makeTraceHttpRequestHeaders);
function makeTraceHttpRequestHeaders(traceId, spanId) {
    return {
        'X-B3-TraceId': traceId,
        'X-B3-SpanId': spanId
    };
}

},{"@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"cXQ8g":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "redactValue", ()=>(0, _utils.redactValue));
parcelHelpers.export(exports, "allFeatureFlagsAccessed", ()=>allFeatureFlagsAccessed);
parcelHelpers.export(exports, "currentFeatureFlagsAccessed", ()=>currentFeatureFlagsAccessed);
/**
 * Used for tracking accessed feature flags in "@atlassian/jira-feature-flagging".
 * */ // eslint-disable-next-line @atlaskit/volt-strict-mode/no-multiple-exports
parcelHelpers.export(exports, "addFeatureFlagAccessed", ()=>addFeatureFlagAccessed);
var _utils = require("./common/utils");
const allFeatureFlagsAccessed = new Map();
const currentFeatureFlagsAccessed = new Map();
function addFeatureFlagAccessed(featureFlagName, featureFlagValue) {
    try {
        // Inform Criterion about FF being accessed
        if (globalThis.__CRITERION__ && typeof globalThis.__CRITERION__.addFeatureFlagAccessed === 'function') globalThis.__CRITERION__.addFeatureFlagAccessed(featureFlagName, featureFlagValue);
    } catch (_e) {
    // ignore the criterion error
    }
    const value = (0, _utils.redactValue)(featureFlagValue);
    allFeatureFlagsAccessed.set(featureFlagName, value);
    currentFeatureFlagsAccessed.set(featureFlagName, value);
}

},{"./common/utils":"6Csju","@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"6Csju":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "shouldRedactValue", ()=>shouldRedactValue);
// eslint-disable-next-line @atlaskit/volt-strict-mode/no-multiple-exports
parcelHelpers.export(exports, "redactValue", ()=>redactValue);
var _constants = require("../constants");
function startsAsObject(value) {
    try {
        if (value.charAt(0) === '{') return true;
    } catch (e) {
        return false;
    }
    return false;
}
function isObject(value) {
    return value && typeof value === 'object' && value.constructor === Object;
}
function isString(input) {
    let result;
    try {
        result = typeof input === 'string' || input instanceof String;
    } catch (e) {
        // swallow any errors
        result = false;
    }
    return result;
}
function shouldRedactValue(value) {
    return isString(value) && startsAsObject(value) || isObject(value);
}
function redactValue(featureFlagValue) {
    return shouldRedactValue(featureFlagValue) ? (0, _constants.NON_BOOLEAN_VALUE) : featureFlagValue;
}

},{"../constants":"bn66v","@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"bn66v":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "NON_BOOLEAN_VALUE", ()=>NON_BOOLEAN_VALUE);
const NON_BOOLEAN_VALUE = 'non_boolean';

},{"@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"eBW7s":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "DefaultInteractionID", ()=>DefaultInteractionID);
parcelHelpers.export(exports, "subscribeToInteractionIdChanges", ()=>subscribeToInteractionIdChanges);
parcelHelpers.export(exports, "getInteractionId", ()=>getInteractionId);
parcelHelpers.export(exports, "useInteractionId", ()=>useInteractionId);
var _react = require("react");
const listeners = new Set();
// Observable interaction ID implementation
class ObservableInteractionID {
    get current() {
        return this._current;
    }
    set current(newId) {
        const oldId = this._current;
        this._current = newId;
        // Notify all listeners if the ID actually changed
        if (oldId !== newId) listeners.forEach((listener)=>listener(newId));
    }
    constructor(){
        this._current = null;
    }
}
// Ensures a single DefaultInteractionID instance exists across the entire application,
// even when the module is loaded multiple times in different contexts
const initializeGlobalDefaultInteractionID = ()=>{
    // Return existing instance if already initialized
    if (globalThis.__UFO_DEFAULT_INTERACTION_ID__) return globalThis.__UFO_DEFAULT_INTERACTION_ID__;
    // Create and store new instance globally
    const instance = new ObservableInteractionID();
    globalThis.__UFO_DEFAULT_INTERACTION_ID__ = instance;
    return instance;
};
const DefaultInteractionID = initializeGlobalDefaultInteractionID();
const subscribeToInteractionIdChanges = (listener)=>{
    listeners.add(listener);
    return ()=>{
        listeners.delete(listener);
    };
};
// We use a context to allow modals to have their own lifecycle
const interactionContext = (0, _react.createContext)(DefaultInteractionID);
// eslint-disable-next-line @atlaskit/volt-strict-mode/no-multiple-exports
exports.default = interactionContext;
const getInteractionId = ()=>DefaultInteractionID;
const useInteractionId = ()=>DefaultInteractionID;

},{"react":"ltHCL","@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"lKGMp":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "BACKEND_RESOURCE_TIMING_INITIATOR_TYPES", ()=>BACKEND_RESOURCE_TIMING_INITIATOR_TYPES);
const BACKEND_RESOURCE_TIMING_INITIATOR_TYPES = new Set([
    'fetch',
    'xmlhttprequest'
]);

},{"@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"b0GDU":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "clearState", ()=>clearState);
parcelHelpers.export(exports, "flushSsrRenderProfilerTraces", ()=>flushSsrRenderProfilerTraces);
parcelHelpers.export(exports, "SsrRenderProfilerInner", ()=>SsrRenderProfilerInner);
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _config = require("../config");
var _utils = require("../create-payload/common/utils");
var _interactionMetrics = require("../interaction-metrics");
var _process_env;
var process = require("6a7d2a1de2db0be1");
// These are stored outside react context to be resilient to concurrent mode
// restarting the start marker from a suspense and losing the initial render
const startTimes = new Map();
const spanStates = new Map();
const clearState = ()=>{
    startTimes.clear();
    spanStates.clear();
};
// Keep track of the last interaction id and reset the start timers if it ever changes.
// This is to allow multi-step ssr to track the render timers from different "interaction"s seperately
let lastActiveInteraction;
function checkActiveInteractionAndResetStartMarksIfSet() {
    var _getActiveInteraction;
    const activeInteractionId = (_getActiveInteraction = (0, _interactionMetrics.getActiveInteraction)()) === null || _getActiveInteraction === void 0 ? void 0 : _getActiveInteraction.id;
    if (!!lastActiveInteraction && lastActiveInteraction !== activeInteractionId) clearState();
    lastActiveInteraction = activeInteractionId;
}
const getIsNativeTracingEnabled = ()=>{
    var _getConfig_ssr, _getConfig;
    var _getConfig_ssr_enableNativeTracing;
    return (_getConfig_ssr_enableNativeTracing = (_getConfig = (0, _config.getConfig)()) === null || _getConfig === void 0 ? void 0 : (_getConfig_ssr = _getConfig.ssr) === null || _getConfig_ssr === void 0 ? void 0 : _getConfig_ssr.enableNativeTracing) !== null && _getConfig_ssr_enableNativeTracing !== void 0 ? _getConfig_ssr_enableNativeTracing : false;
};
const onStartRender = (id, currentSegmentName, parentContext)=>{
    var _startTimes_get, _globalThis___vm_internals___telemetry, _globalThis___vm_internals__;
    if (!startTimes.has(id)) startTimes.set(id, []);
    (_startTimes_get = startTimes.get(id)) === null || _startTimes_get === void 0 ? void 0 : _startTimes_get.push(performance.now());
    if (!getIsNativeTracingEnabled()) return null;
    const startSpan = (_globalThis___vm_internals__ = globalThis.__vm_internals__) === null || _globalThis___vm_internals__ === void 0 ? void 0 : (_globalThis___vm_internals___telemetry = _globalThis___vm_internals__.telemetry) === null || _globalThis___vm_internals___telemetry === void 0 ? void 0 : _globalThis___vm_internals___telemetry.startSpan;
    var _spanStates_get;
    let spanState = (_spanStates_get = spanStates.get(id)) !== null && _spanStates_get !== void 0 ? _spanStates_get : null;
    if (!spanState && startSpan) {
        const span = startSpan(currentSegmentName, {
            parentSpanId: parentContext === null || parentContext === void 0 ? void 0 : parentContext.spanId
        });
        spanState = {
            span
        };
        spanStates.set(id, spanState);
    }
    return spanState;
};
const isInSSR = typeof __SERVER__ !== 'undefined' && __SERVER__ || typeof process !== 'undefined' && Boolean((process === null || process === void 0 ? void 0 : (_process_env = process.env) === null || _process_env === void 0 ? void 0 : _process_env.REACT_SSR) || false);
const ProfilerMarker = ({ onRender })=>{
    onRender === null || onRender === void 0 ? void 0 : onRender();
    return null;
};
const ParentSpanContext = /*#__PURE__*/ (0, _react.createContext)(null);
const flushSsrRenderProfilerTraces = ()=>{
    spanStates.forEach((spanState)=>{
        if (spanState.latestEndTime != null) spanState.span.end(spanState.latestEndTime);
    });
    spanStates.clear();
};
const SsrRenderProfilerInner = ({ children, labelStack, onRender })=>{
    const reactProfilerId = (0, _react.useMemo)(()=>labelStack.map((l)=>(0, _utils.sanitizeLabelStackName)(l.name)).join('/'), [
        labelStack
    ]);
    checkActiveInteractionAndResetStartMarksIfSet();
    const parentSpan = (0, _react.useContext)(ParentSpanContext);
    const currentSpanState = onStartRender(reactProfilerId, (0, _utils.sanitizeLabelStackName)(labelStack[labelStack.length - 1].name), parentSpan);
    var _currentSpanState_span_getSpanContext;
    return /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _reactDefault.default).Fragment, null, /*#__PURE__*/ (0, _reactDefault.default).createElement(ParentSpanContext.Provider, {
        value: (_currentSpanState_span_getSpanContext = currentSpanState === null || currentSpanState === void 0 ? void 0 : currentSpanState.span.getSpanContext()) !== null && _currentSpanState_span_getSpanContext !== void 0 ? _currentSpanState_span_getSpanContext : null
    }, children, /*#__PURE__*/ (0, _reactDefault.default).createElement(ProfilerMarker, {
        onRender: ()=>{
            const startTimesForId = startTimes.get(reactProfilerId);
            if (startTimesForId === null || startTimesForId === void 0 ? void 0 : startTimesForId.length) {
                const endTime = performance.now();
                const firstStartTime = startTimesForId[0];
                const lastStartTime = startTimesForId[startTimesForId.length - 1];
                const baseDuration = endTime - lastStartTime;
                const actualDuration = endTime - firstStartTime;
                onRender('mount', actualDuration, baseDuration, firstStartTime, endTime);
            }
            const spanState = spanStates.get(reactProfilerId);
            if (spanState) spanState.latestEndTime = performance.now();
        }
    })));
};
const SsrRenderProfiler = (props)=>{
    if (isInSSR) return /*#__PURE__*/ (0, _reactDefault.default).createElement(SsrRenderProfilerInner, props);
    // ensure structure similar to SSR implementation
    return /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _reactDefault.default).Fragment, null, /*#__PURE__*/ (0, _reactDefault.default).createElement(ProfilerMarker, null), props.children);
};
// eslint-disable-next-line @atlaskit/volt-strict-mode/no-multiple-exports
exports.default = SsrRenderProfiler;

},{"6a7d2a1de2db0be1":"gNLf3","react":"ltHCL","../config":"bx9i6","../create-payload/common/utils":"bqJei","../interaction-metrics":"j4w6h","@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"l4p8T":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "VCObserverWrapper", ()=>VCObserverWrapper);
// eslint-disable-next-line @atlaskit/volt-strict-mode/no-multiple-exports
parcelHelpers.export(exports, "isEnvironmentSupported", ()=>isEnvironmentSupported);
// eslint-disable-next-line @atlaskit/volt-strict-mode/no-multiple-exports
parcelHelpers.export(exports, "getVCObserver", ()=>getVCObserver);
// eslint-disable-next-line @atlaskit/volt-strict-mode/no-multiple-exports
parcelHelpers.export(exports, "newVCObserver", ()=>newVCObserver);
var _objectSpread = require("@swc/helpers/_/_object_spread");
var _objectSpreadProps = require("@swc/helpers/_/_object_spread_props");
var _config = require("../config");
var _noOpVcObserver = require("./no-op-vc-observer");
var _vcObserver = require("./vc-observer");
var _vcObserverNew = require("./vc-observer-new");
var _vcObserverNewDefault = parcelHelpers.interopDefault(_vcObserverNew);
var _rllPlaceholders = require("./vc-observer/observers/rll-placeholders");
var _ssrPlaceholders = require("./vc-observer/observers/ssr-placeholders");
var _globalThis, _process_env;
var process = require("ff89f1101a2fdf32");
class VCObserverWrapper {
    // Helper method to process SSR abort listeners
    processSsrAbortListeners() {
        var _window;
        // Process any SSR abort listeners that remain
        if ((_window = window) === null || _window === void 0 ? void 0 : _window.__SSR_ABORT_LISTENERS__) {
            // Clean up any event listeners that may have been registered during SSR
            // This is centralized here so only the wrapper handles unbinding, not individual observers
            if (window.__SSR_ABORT_LISTENERS__.unbinds && Array.isArray(window.__SSR_ABORT_LISTENERS__.unbinds)) window.__SSR_ABORT_LISTENERS__.unbinds.forEach((unbind)=>{
                if (typeof unbind === 'function') unbind();
            });
            // After all observers had a chance to process abort events,
            // we can safely delete the SSR_ABORT_LISTENERS object
            delete window.__SSR_ABORT_LISTENERS__;
        }
    }
    start({ startTime, experienceKey }) {
        var _this_oldVCObserver, _this_newVCObserver;
        if ((0, _config.isVCRevisionEnabled)('fy25.01', experienceKey) || (0, _config.isVCRevisionEnabled)('fy25.02', experienceKey)) (_this_oldVCObserver = this.oldVCObserver) === null || _this_oldVCObserver === void 0 ? void 0 : _this_oldVCObserver.start({
            startTime
        });
        (_this_newVCObserver = this.newVCObserver) === null || _this_newVCObserver === void 0 ? void 0 : _this_newVCObserver.start({
            startTime
        });
        // Clean up any remaining SSR abort listeners after all observers have been started
        this.processSsrAbortListeners();
    }
    stop(experienceKey) {
        var _this_oldVCObserver, _this_newVCObserver;
        if ((0, _config.isVCRevisionEnabled)('fy25.01', experienceKey) || (0, _config.isVCRevisionEnabled)('fy25.02', experienceKey)) (_this_oldVCObserver = this.oldVCObserver) === null || _this_oldVCObserver === void 0 ? void 0 : _this_oldVCObserver.stop();
        (_this_newVCObserver = this.newVCObserver) === null || _this_newVCObserver === void 0 ? void 0 : _this_newVCObserver.stop();
        (0, _rllPlaceholders.RLLPlaceholderHandlers).getInstance().reset();
        // Clear shared SSR placeholder handler
        this.ssrPlaceholderHandler.clear();
    }
    getVCRawData() {
        var _this_oldVCObserver;
        var _this_oldVCObserver_getVCRawData;
        return (_this_oldVCObserver_getVCRawData = (_this_oldVCObserver = this.oldVCObserver) === null || _this_oldVCObserver === void 0 ? void 0 : _this_oldVCObserver.getVCRawData()) !== null && _this_oldVCObserver_getVCRawData !== void 0 ? _this_oldVCObserver_getVCRawData : null;
    }
    async getVCResult(param) {
        var _this_oldVCObserver, _this_newVCObserver, _v3v4Result_;
        const { experienceKey, include3p, excludeSmartAnswersInSearch, includeSSRRatio, includeRawData } = param;
        const v1v2Result = (0, _config.isVCRevisionEnabled)('fy25.01', experienceKey) || (0, _config.isVCRevisionEnabled)('fy25.02', experienceKey) ? await ((_this_oldVCObserver = this.oldVCObserver) === null || _this_oldVCObserver === void 0 ? void 0 : _this_oldVCObserver.getVCResult(param)) : {};
        const v3v4Result = await ((_this_newVCObserver = this.newVCObserver) === null || _this_newVCObserver === void 0 ? void 0 : _this_newVCObserver.getVCResult({
            start: param.start,
            stop: param.stop,
            interactionId: param.interactionId,
            ssr: param.ssr,
            include3p,
            excludeSmartAnswersInSearch,
            includeSSRRatio,
            interactionType: param.interactionType,
            isPageVisible: param.isPageVisible,
            interactionAbortReason: param.interactionAbortReason,
            includeRawData,
            includeSSRInV3: param.includeSSRInV3,
            rawDataStopTime: param.rawDataStopTime,
            reportLayoutShiftOffenders: param.reportLayoutShiftOffenders
        }));
        if (!v3v4Result || v3v4Result.length === 0) return v1v2Result !== null && v1v2Result !== void 0 ? v1v2Result : {};
        const ssrRatio = v3v4Result === null || v3v4Result === void 0 ? void 0 : (_v3v4Result_ = v3v4Result[0]) === null || _v3v4Result_ === void 0 ? void 0 : _v3v4Result_.ssrRatio;
        var _v1v2Result_ufovcrev;
        return (0, _objectSpreadProps._)((0, _objectSpread._)({}, includeSSRRatio && ssrRatio !== undefined ? {
            'ufo:vc:ssrRatio': ssrRatio
        } : {}, v1v2Result), {
            'ufo:vc:rev': [
                ...(_v1v2Result_ufovcrev = v1v2Result === null || v1v2Result === void 0 ? void 0 : v1v2Result['ufo:vc:rev']) !== null && _v1v2Result_ufovcrev !== void 0 ? _v1v2Result_ufovcrev : [],
                ...v3v4Result !== null && v3v4Result !== void 0 ? v3v4Result : []
            ]
        });
    }
    setSSRElement(element) {
        var _this_oldVCObserver, _this_newVCObserver;
        (_this_oldVCObserver = this.oldVCObserver) === null || _this_oldVCObserver === void 0 ? void 0 : _this_oldVCObserver.setSSRElement(element);
        (_this_newVCObserver = this.newVCObserver) === null || _this_newVCObserver === void 0 ? void 0 : _this_newVCObserver.setReactRootElement(element);
    }
    setReactRootRenderStart(startTime) {
        var _this_oldVCObserver, _this_newVCObserver;
        (_this_oldVCObserver = this.oldVCObserver) === null || _this_oldVCObserver === void 0 ? void 0 : _this_oldVCObserver.setReactRootRenderStart(startTime || performance.now());
        (_this_newVCObserver = this.newVCObserver) === null || _this_newVCObserver === void 0 ? void 0 : _this_newVCObserver.setReactRootRenderStart(startTime || performance.now());
    }
    setReactRootRenderStop(stopTime) {
        var _this_oldVCObserver, _this_newVCObserver;
        (_this_oldVCObserver = this.oldVCObserver) === null || _this_oldVCObserver === void 0 ? void 0 : _this_oldVCObserver.setReactRootRenderStop(stopTime || performance.now());
        (_this_newVCObserver = this.newVCObserver) === null || _this_newVCObserver === void 0 ? void 0 : _this_newVCObserver.setReactRootRenderStop(stopTime || performance.now());
    }
    collectSSRPlaceholders() {
        this.ssrPlaceholderHandler.collectExistingPlaceholders();
    }
    constructor(opts = {}){
        this.newVCObserver = null;
        this.oldVCObserver = null;
        var _opts_ssrEnablePageLayoutPlaceholder;
        // Initialize SSR placeholder handler once
        this.ssrPlaceholderHandler = new (0, _ssrPlaceholders.SSRPlaceholderHandlers)({
            enablePageLayoutPlaceholder: (_opts_ssrEnablePageLayoutPlaceholder = opts.ssrEnablePageLayoutPlaceholder) !== null && _opts_ssrEnablePageLayoutPlaceholder !== void 0 ? _opts_ssrEnablePageLayoutPlaceholder : false
        });
        var _opts_ssrEnablePageLayoutPlaceholder1, _opts_trackLayoutShiftOffenders;
        this.newVCObserver = new (0, _vcObserverNewDefault.default)({
            selectorConfig: opts.selectorConfig,
            isPostInteraction: opts.isPostInteraction,
            SSRConfig: {
                enablePageLayoutPlaceholder: (_opts_ssrEnablePageLayoutPlaceholder1 = opts.ssrEnablePageLayoutPlaceholder) !== null && _opts_ssrEnablePageLayoutPlaceholder1 !== void 0 ? _opts_ssrEnablePageLayoutPlaceholder1 : false
            },
            ssrPlaceholderHandler: this.ssrPlaceholderHandler,
            trackLayoutShiftOffenders: (_opts_trackLayoutShiftOffenders = opts.trackLayoutShiftOffenders) !== null && _opts_trackLayoutShiftOffenders !== void 0 ? _opts_trackLayoutShiftOffenders : false,
            searchPageConfig: opts.searchPageConfig
        });
        if ((0, _config.isVCRevisionEnabled)('fy25.01') || (0, _config.isVCRevisionEnabled)('fy25.02')) this.oldVCObserver = new (0, _vcObserver.VCObserver)((0, _objectSpreadProps._)((0, _objectSpread._)({}, opts), {
            ssrPlaceholderHandler: this.ssrPlaceholderHandler
        }));
    }
}
// Some products set this variable to indicate it is running in SSR
let isServer = Boolean((_globalThis = globalThis) === null || _globalThis === void 0 ? void 0 : _globalThis.__SERVER__);
// Other products set this other variable to indicate it is running in SSR
let isReactSSR = typeof process !== 'undefined' && Boolean((process === null || process === void 0 ? void 0 : (_process_env = process.env) === null || _process_env === void 0 ? void 0 : _process_env.REACT_SSR) || false);
function isEnvironmentSupported() {
    var _globalThis, _globalThis1, _globalThis2, _globalThis3;
    // SSR environment aren't supported
    if (isReactSSR || isServer) return false;
    // Legacy browsers that doesn't support WeakRef
    // aren't valid
    if (typeof ((_globalThis = globalThis) === null || _globalThis === void 0 ? void 0 : _globalThis.WeakRef) !== 'function') return false;
    if (typeof ((_globalThis1 = globalThis) === null || _globalThis1 === void 0 ? void 0 : _globalThis1.MutationObserver) !== 'function' || typeof ((_globalThis2 = globalThis) === null || _globalThis2 === void 0 ? void 0 : _globalThis2.IntersectionObserver) !== 'function' || typeof ((_globalThis3 = globalThis) === null || _globalThis3 === void 0 ? void 0 : _globalThis3.PerformanceObserver) !== 'function') return false;
    return true;
}
function getVCObserver(opts = {}) {
    if (!globalThis.__vcObserver) {
        const shouldMockVCObserver = !isEnvironmentSupported();
        globalThis.__vcObserver = shouldMockVCObserver ? new (0, _noOpVcObserver.VCObserverNOOP)() : new VCObserverWrapper(opts);
    }
    return globalThis.__vcObserver;
}
function newVCObserver(opts = {}) {
    const shouldMockVCObserver = !isEnvironmentSupported();
    const observer = shouldMockVCObserver ? new (0, _noOpVcObserver.VCObserverNOOP)() : new VCObserverWrapper(opts);
    return observer;
}

},{"@swc/helpers/_/_object_spread":"9gdrV","@swc/helpers/_/_object_spread_props":"kANqQ","ff89f1101a2fdf32":"gNLf3","../config":"bx9i6","./no-op-vc-observer":"d2feV","./vc-observer":"2iwGy","./vc-observer-new":"75IUn","./vc-observer/observers/rll-placeholders":"calqI","./vc-observer/observers/ssr-placeholders":"5zEx5","@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"d2feV":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
// This class should be used on scenarios where VC can not be calculate
// such as: SSR environment and legacy browsers
parcelHelpers.export(exports, "VCObserverNOOP", ()=>VCObserverNOOP);
class VCObserverNOOP {
    start(_) {}
    stop() {}
    getVCRawData() {
        return null;
    }
    getVCResult(_) {
        return Promise.resolve({
            'ufo:vc:noop': true
        });
    }
    setSSRElement(_) {}
    setReactRootRenderStart(_) {}
    setReactRootRenderStop(_) {}
}

},{"@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"2iwGy":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "VCObserver", ()=>VCObserver);
var _objectSpread = require("@swc/helpers/_/_object_spread");
var _objectSpreadProps = require("@swc/helpers/_/_object_spread_props");
var _objectWithoutProperties = require("@swc/helpers/_/_object_without_properties");
var _platformFeatureFlags = require("@atlaskit/platform-feature-flags");
var _config = require("../../config");
var _interactionMetrics = require("../../interaction-metrics");
var _attachAbortListeners = require("./attachAbortListeners");
var _getVCRevisionDebugDetails = require("./getVCRevisionDebugDetails");
var _getVCRevisionsData = require("./getVCRevisionsData");
var _getViewport = require("./getViewport");
var _observers = require("./observers");
const abortReason = {
    scroll: 'scroll',
    keypress: 'keypress',
    resize: 'resize',
    error: 'error'
};
const UNUSED_SECTOR = 0;
function filterComponentsLog(log) {
    return Object.fromEntries(Object.entries(log).map(([timestamp, entries])=>[
            Number(timestamp),
            entries.map((entry)=>{
                const { __debug__element } = entry, rest = (0, _objectWithoutProperties._)(entry, [
                    "__debug__element"
                ]);
                return rest;
            })
        ]));
}
class VCObserver {
    start({ startTime }) {
        this.active = true;
        if (this.observers.isBrowserSupported()) {
            this.setViewportSize();
            this.resetState();
            this.startTime = startTime;
            this.attachAbortListeners();
            this.observers.subscribeResults(this.handleUpdate);
            this.observers.observe();
        } else this.setAbortReason('not-supported', startTime);
    }
    stop() {
        this.observers.disconnect();
        this.detachAbortListeners();
    }
    getIgnoredElements(componentsLog) {
        return Object.values(componentsLog).flat().filter(({ ignoreReason })=>Boolean(ignoreReason)).map(({ targetName, ignoreReason })=>({
                targetName,
                ignoreReason
            }));
    }
    static getSSRRatio(entries, ssr) {
        if (ssr === undefined || entries.length === 0) return undefined;
        const maybeSSR = entries[0];
        if (maybeSSR.elements[0] === 'SSR') return maybeSSR.vc;
        return 0;
    }
    static calculateVC({ heatmap, ssr = UNUSED_SECTOR, componentsLog, viewport, fixSSRAttribution }) {
        const lastUpdate = {};
        let totalPainted = 0;
        const ssrTime = fixSSRAttribution ? Math.floor(ssr) : ssr;
        if (ssrTime !== UNUSED_SECTOR) {
            var _window_document;
            const element = {
                __debug__element: new WeakRef((_window_document = window.document) === null || _window_document === void 0 ? void 0 : _window_document.body),
                intersectionRect: {
                    top: 0,
                    left: 0,
                    right: 0,
                    bottom: 0,
                    x: 0,
                    y: 0,
                    width: viewport.w,
                    height: viewport.h,
                    toJSON () {
                        return {};
                    }
                },
                targetName: 'SSR'
            };
            if (!componentsLog[ssrTime]) componentsLog[ssrTime] = [];
            componentsLog[ssrTime].push(element);
        }
        heatmap.forEach((line)=>{
            line.forEach((entry)=>{
                const rounded = Math.floor(entry === UNUSED_SECTOR && ssrTime !== UNUSED_SECTOR ? ssrTime : entry);
                totalPainted += rounded !== UNUSED_SECTOR ? 1 : 0;
                if (rounded !== UNUSED_SECTOR) lastUpdate[rounded] = lastUpdate[rounded] ? lastUpdate[rounded] + 1 : 1;
            });
        });
        const entries = Object.entries(lastUpdate).map((a)=>[
                parseInt(a[0], 10),
                a[1]
            ]).sort((a, b)=>a[0] > b[0] ? 1 : -1);
        const VC = VCObserver.makeVCReturnObj();
        const VCBox = VCObserver.makeVCReturnObj();
        entries.reduce((acc = 0, v)=>{
            const currRatio = v[1] / totalPainted;
            let VCRatio = currRatio + acc;
            const preciseCurrRatio = Math.round(100 * (v[1] / totalPainted));
            const preciseAccRatio = Math.round(acc * 100);
            VCRatio = (preciseCurrRatio + preciseAccRatio) / 100;
            const time = v[0];
            VCObserver.VCParts.forEach((key)=>{
                const value = parseInt(key, 10);
                if ((VC[key] === null || VC[key] === undefined) && VCRatio >= value / 100) {
                    var _componentsLog_time;
                    VC[key] = time;
                    VCBox[key] = [
                        ...new Set((_componentsLog_time = componentsLog[time]) === null || _componentsLog_time === void 0 ? void 0 : _componentsLog_time.filter((v)=>!v.ignoreReason).map((v)=>v.targetName))
                    ];
                }
            });
            return VCRatio;
        }, 0);
        const VCEntries = entries.reduce((acc, [timestamp, entryPainted], i)=>{
            var _acc_abs_, _componentsLog_timestamp, _acc_rel_;
            const currentlyPainted = entryPainted + (((_acc_abs_ = acc.abs[i - 1]) === null || _acc_abs_ === void 0 ? void 0 : _acc_abs_[1]) || 0);
            const currentlyPaintedRatio = Math.round(currentlyPainted / totalPainted * 1000) / 10;
            const logEntry = [
                ...new Set((_componentsLog_timestamp = componentsLog[timestamp]) === null || _componentsLog_timestamp === void 0 ? void 0 : _componentsLog_timestamp.filter((v)=>!v.ignoreReason).map((v)=>v.targetName))
            ];
            var _acc_rel__vc;
            const ratioDelta = (currentlyPaintedRatio - ((_acc_rel__vc = (_acc_rel_ = acc.rel[i - 1]) === null || _acc_rel_ === void 0 ? void 0 : _acc_rel_.vc) !== null && _acc_rel__vc !== void 0 ? _acc_rel__vc : 0)) / 100;
            const speedIndex = timestamp * ratioDelta;
            acc.speedIndex += speedIndex;
            acc.abs.push([
                timestamp,
                currentlyPainted
            ]);
            acc.rel.push({
                time: timestamp,
                vc: currentlyPaintedRatio,
                elements: logEntry
            });
            return acc;
        }, {
            abs: [],
            rel: [],
            speedIndex: 0
        });
        VCEntries.speedIndex = Math.round(VCEntries.speedIndex);
        return {
            VC,
            VCBox,
            VCEntries,
            totalPainted
        };
    }
    setSSRElement(element) {
        this.observers.setReactRootElement(element);
    }
    setReactRootRenderStart(startTime = performance.now()) {
        this.observers.setReactRootRenderStart(startTime);
    }
    setReactRootRenderStop(stopTime = performance.now()) {
        this.observers.setReactRootRenderStop(stopTime);
    }
    collectSSRPlaceholders() {
    // This is handled by the shared SSRPlaceholderHandlers in VCObserverWrapper
    // Individual observers don't need to implement this
    }
    setAbortReason(abort, timestamp, info = '') {
        if (this.abortReason.reason === null || this.abortReason.blocking === false) {
            this.abortReason.reason = abort;
            this.abortReason.info = info;
            this.abortReason.timestamp = timestamp;
            this.abortReason.blocking = abort !== abortReason.scroll;
            if (this.abortReason.blocking) this.detachAbortListeners();
        }
    }
    resetState() {
        this.abortReason = {
            reason: null,
            info: '',
            timestamp: -1,
            blocking: false
        };
        this.detachAbortListeners();
        this.heatmap = !(0, _config.isVCRevisionEnabled)('fy25.01') ? [] : this.getCleanHeatmap();
        this.heatmapNext = this.getCleanHeatmap();
        this.totalTime = 0;
        this.componentsLog = {};
        this.vcRatios = {};
    }
    getCleanHeatmap() {
        return Array(this.arraySize).fill('').map(()=>Array(this.arraySize).fill(UNUSED_SECTOR));
    }
    setViewportSize() {
        this.viewport.w = (0, _getViewport.getViewportWidth)();
        this.viewport.h = (0, _getViewport.getViewportHeight)();
    }
    applyChangesToHeatMap(a, time, heatmap) {
        const { l, t, r, b } = a;
        const localHeatmap = heatmap;
        for(let row = t; row < b; row++){
            for(let col = l; col < r; col++)if (localHeatmap[row] === undefined) {
                try {
                    this.setAbortReason(abortReason.error, time, `index - ${row}`);
                } catch (e) {
                    this.setAbortReason(abortReason.error, time, 'row error');
                }
                return;
            } else localHeatmap[row][col] = time;
        }
    }
    static makeVCReturnObj() {
        const vc = {};
        VCObserver.VCParts.forEach((v)=>{
            vc[v] = null;
        });
        return vc;
    }
    detachAbortListeners() {
        if (this.unbind) {
            const { unbind } = this;
            for(let i = 0; i < unbind.length; i++)unbind[i]();
            this.unbind.length = 0;
        }
    }
    measureStart() {
        this._startMeasureTimestamp = performance.now();
    }
    measureStop() {
        if (this._startMeasureTimestamp === -1) return;
        this.totalTime += performance.now() - this._startMeasureTimestamp;
        this._startMeasureTimestamp = -1;
    }
    constructor(options){
        /* abort logic */ this.abortReason = {
            reason: null,
            info: '',
            timestamp: -1,
            blocking: false
        };
        this.outOfBoundaryInfo = '';
        this.viewport = {
            w: 0,
            h: 0
        };
        /* heatmap */ this.arraySize = 0;
        this.componentsLog = {};
        this.vcRatios = {};
        this.active = false;
        this.totalTime = 0;
        this.startTime = 0;
        this._startMeasureTimestamp = -1;
        this.ssr = {
            reactRendered: -1
        };
        this.unbind = [];
        this.getAbortReasonInfo = ()=>{
            if (this.abortReason.reason === null) return null;
            const info = this.abortReason.info !== '' ? ` ${this.abortReason.info}` : '';
            return `${this.abortReason.reason}${info}`;
        };
        this.getVCRawData = ()=>{
            this.measureStart();
            if (!this.active) {
                this.measureStop();
                return null;
            }
            this.stop();
            const abortReasonInfo = this.getAbortReasonInfo();
            this.measureStop();
            return {
                abortReasonInfo,
                abortReason: (0, _objectSpread._)({}, this.abortReason),
                heatmap: this.heatmap,
                heatmapNext: this.heatmapNext,
                outOfBoundaryInfo: this.outOfBoundaryInfo,
                totalTime: Math.round(this.totalTime + this.observers.getTotalTime()),
                componentsLog: (0, _objectSpread._)({}, this.componentsLog),
                viewport: (0, _objectSpread._)({}, this.viewport),
                oldDomUpdatesEnabled: this.oldDomUpdatesEnabled,
                devToolsEnabled: this.devToolsEnabled,
                ratios: this.vcRatios
            };
        };
        this.getVCResult = async ({ start, stop, tti, prefix, ssr, vc, isEventAborted, experienceKey, interactionId, includeSSRRatio })=>{
            const startTime = performance.now();
            // add local measurement
            const fullPrefix = prefix !== undefined && prefix !== '' ? `${prefix}:` : '';
            const rawData = vc !== undefined ? vc : this.getVCRawData();
            if (rawData === null) return {};
            const { abortReason, abortReasonInfo, heatmap, heatmapNext, outOfBoundaryInfo, totalTime, componentsLog, viewport, devToolsEnabled, ratios } = rawData;
            const isTTVCv1Disabled = !(0, _config.isVCRevisionEnabled)('fy25.01', experienceKey);
            if (abortReasonInfo !== null) {
                // exposing data to devtools
                try {
                    if (devToolsEnabled && !this.isPostInteraction) window.__vcNotAvailableReason = abortReasonInfo;
                } catch (e) {}
                const vcAbortedResultWithRevisions = {
                    [`${fullPrefix}vc:rev`]: [
                        {
                            revision: 'fy25.02',
                            clean: false,
                            'metric:vc90': null,
                            abortReason: abortReason.reason,
                            abortTimestamp: Math.round(abortReason.timestamp)
                        }
                    ]
                };
                if (!isTTVCv1Disabled) vcAbortedResultWithRevisions[`${fullPrefix}vc:rev`].push({
                    revision: 'fy25.01',
                    clean: false,
                    'metric:vc90': null,
                    abortReason: abortReason.reason,
                    abortTimestamp: Math.round(abortReason.timestamp)
                });
                return vcAbortedResultWithRevisions;
            }
            const ttvcV1Result = isTTVCv1Disabled ? {
                VC: {},
                VCBox: {},
                VCEntries: {
                    abs: [],
                    rel: [],
                    speedIndex: -1
                },
                totalPainted: -1
            } : VCObserver.calculateVC({
                heatmap,
                ssr,
                componentsLog: (0, _objectSpread._)({}, componentsLog),
                viewport,
                fixSSRAttribution: includeSSRRatio
            });
            const { VC, VCBox, VCEntries, totalPainted } = ttvcV1Result;
            const _componentsLog = {};
            Object.entries(this.componentsLog).forEach(([_timestamp, value])=>{
                const timestamp = Number(_timestamp);
                if (stop > timestamp) _componentsLog[timestamp] = value;
            });
            const vcNext = VCObserver.calculateVC({
                heatmap: heatmapNext,
                ssr,
                componentsLog: _componentsLog,
                viewport,
                fixSSRAttribution: includeSSRRatio
            });
            const outOfBoundary = outOfBoundaryInfo ? {
                [`${fullPrefix}vc:oob`]: outOfBoundaryInfo
            } : {};
            //const oldDomUpdates = oldDomUpdatesEnabled ? { [`${fullPrefix}vc:old:dom`]: vcNext.VCBox } : {};
            const stopTime = performance.now();
            // exposing data to devtools
            try {
                if (!this.isPostInteraction && devToolsEnabled) {
                    const ttvcV1DevToolInfo = isTTVCv1Disabled ? undefined : {
                        entries: VCEntries.rel,
                        log: componentsLog,
                        metrics: {
                            '75': VC['75'],
                            '80': VC['80'],
                            '85': VC['85'],
                            '90': VC['90'],
                            '95': VC['95'],
                            '98': VC['98'],
                            '99': VC['99'],
                            tti,
                            ttai: stop - start
                        },
                        start,
                        stop,
                        heatmap,
                        ratios
                    };
                    const ttvcV2DevToolInfo = {
                        entries: vcNext.VCEntries.rel,
                        log: componentsLog,
                        metrics: {
                            '75': vcNext.VC['75'],
                            '80': vcNext.VC['80'],
                            '85': vcNext.VC['85'],
                            '90': vcNext.VC['90'],
                            '95': vcNext.VC['95'],
                            '98': vcNext.VC['98'],
                            '99': vcNext.VC['99'],
                            tti,
                            ttai: stop - start
                        },
                        start,
                        stop,
                        heatmap: heatmapNext,
                        ratios
                    };
                    if (isTTVCv1Disabled) {
                        window.__vc = ttvcV2DevToolInfo;
                        window.__vcNext = ttvcV2DevToolInfo;
                    } else {
                        window.__vc = ttvcV1DevToolInfo;
                        window.__vcNext = ttvcV2DevToolInfo;
                    }
                    // Emitting a custom event to make it available in the Chrome extension
                    window.dispatchEvent(new CustomEvent('vcReady', {
                        detail: {
                            log: filterComponentsLog(componentsLog),
                            entries: isTTVCv1Disabled ? vcNext.VCEntries.rel : VCEntries.rel
                        }
                    }));
                }
                if (!this.isPostInteraction) {
                    // Only create revision debug details if callbacks exist
                    const shouldCreateDebugDetails = typeof window.__ufo_devtool_onVCRevisionReady__ === 'function' || typeof window.__on_ufo_vc_debug_data_ready === 'function';
                    if (shouldCreateDebugDetails) {
                        const v1RevisionDebugDetails = (0, _getVCRevisionDebugDetails.getVCRevisionDebugDetails)({
                            revision: 'fy25.01',
                            isClean: !abortReasonInfo,
                            abortReason: abortReason.reason,
                            VCEntries: VCEntries.rel,
                            componentsLog,
                            interactionId
                        });
                        const v2RevisionDebugDetails = (0, _getVCRevisionDebugDetails.getVCRevisionDebugDetails)({
                            revision: 'fy25.02',
                            isClean: !abortReasonInfo,
                            abortReason: abortReason.reason,
                            VCEntries: vcNext.VCEntries.rel,
                            componentsLog,
                            interactionId
                        });
                        // Add devtool callback for both v1 and v2
                        if (typeof window.__ufo_devtool_onVCRevisionReady__ === 'function') {
                            var _window___ufo_devtool_onVCRevisionReady__, _window, // Handle v2
                            _window___ufo_devtool_onVCRevisionReady__1, _window1;
                            // Handle v1 if not disabled
                            if (!isTTVCv1Disabled) (_window___ufo_devtool_onVCRevisionReady__ = (_window = window).__ufo_devtool_onVCRevisionReady__) === null || _window___ufo_devtool_onVCRevisionReady__ === void 0 ? void 0 : _window___ufo_devtool_onVCRevisionReady__.call(_window, v1RevisionDebugDetails);
                            (_window___ufo_devtool_onVCRevisionReady__1 = (_window1 = window).__ufo_devtool_onVCRevisionReady__) === null || _window___ufo_devtool_onVCRevisionReady__1 === void 0 ? void 0 : _window___ufo_devtool_onVCRevisionReady__1.call(_window1, v2RevisionDebugDetails);
                        }
                        if (typeof window.__on_ufo_vc_debug_data_ready === 'function') {
                            var _window___on_ufo_vc_debug_data_ready, _window2, _window___on_ufo_vc_debug_data_ready1, _window3;
                            if (!isTTVCv1Disabled) (_window___on_ufo_vc_debug_data_ready = (_window2 = window).__on_ufo_vc_debug_data_ready) === null || _window___on_ufo_vc_debug_data_ready === void 0 ? void 0 : _window___on_ufo_vc_debug_data_ready.call(_window2, v1RevisionDebugDetails);
                            (_window___on_ufo_vc_debug_data_ready1 = (_window3 = window).__on_ufo_vc_debug_data_ready) === null || _window___on_ufo_vc_debug_data_ready1 === void 0 ? void 0 : _window___on_ufo_vc_debug_data_ready1.call(_window3, v2RevisionDebugDetails);
                        }
                    }
                }
            } catch (e) {
            /*  do nothing */ }
            const isVCClean = !abortReasonInfo;
            const revisionsData = (0, _getVCRevisionsData.getVCRevisionsData)({
                fullPrefix,
                interaction: {
                    start,
                    end: stop
                },
                isVCClean,
                calculatedVC: {
                    VC,
                    VCBox
                },
                calculatedVCNext: {
                    VC: vcNext.VC,
                    VCBox: vcNext.VCBox
                },
                isEventAborted,
                experienceKey,
                ratios
            });
            const speedIndex = {
                [`ufo:speedIndex`]: isTTVCv1Disabled ? vcNext.VCEntries.speedIndex : VCEntries.speedIndex,
                [`ufo:next:speedIndex`]: vcNext.VCEntries.speedIndex
            };
            const SSRRatio = VCObserver.getSSRRatio(VCEntries.rel, ssr);
            const SSRRatioNext = VCObserver.getSSRRatio(vcNext.VCEntries.rel, ssr);
            const SSRRatioPayload = includeSSRRatio ? {
                [`${fullPrefix}vc:ssrRatio`]: isTTVCv1Disabled ? SSRRatioNext : SSRRatio,
                [`${fullPrefix}vc:next:ssrRatio`]: SSRRatioNext
            } : {};
            if (isTTVCv1Disabled) return (0, _objectSpread._)((0, _objectSpreadProps._)((0, _objectSpread._)((0, _objectSpreadProps._)((0, _objectSpread._)({
                [`${fullPrefix}vc:size`]: viewport,
                [`${fullPrefix}vc:time`]: Math.round(totalTime + (stopTime - startTime)),
                [`${fullPrefix}vc:ratios`]: ratios
            }, outOfBoundary), {
                [`${fullPrefix}vc:ignored`]: this.getIgnoredElements(componentsLog)
            }), SSRRatioPayload), {
                [`${fullPrefix}vc:ssrRatio`]: SSRRatioNext
            }), revisionsData, speedIndex);
            const isTTVCv3Enabled = (0, _config.isVCRevisionEnabled)('fy25.03', experienceKey);
            return (0, _objectSpread._)((0, _objectSpreadProps._)((0, _objectSpread._)((0, _objectSpreadProps._)((0, _objectSpread._)({
                'metrics:vc': VC,
                [`${fullPrefix}vc:state`]: true,
                [`${fullPrefix}vc:clean`]: isVCClean,
                [`${fullPrefix}vc:dom`]: VCBox,
                [`${fullPrefix}vc:updates`]: isTTVCv3Enabled ? undefined : VCEntries.rel.slice(0, 50),
                [`${fullPrefix}vc:size`]: viewport,
                [`${fullPrefix}vc:time`]: Math.round(totalTime + (stopTime - startTime)),
                [`${fullPrefix}vc:total`]: totalPainted,
                [`${fullPrefix}vc:ratios`]: ratios,
                [`${fullPrefix}vc:ssrRatio`]: SSRRatio
            }, outOfBoundary), {
                [`${fullPrefix}vc:next`]: vcNext.VC,
                [`${fullPrefix}vc:next:updates`]: isTTVCv3Enabled ? undefined : vcNext.VCEntries.rel.slice(0, 50),
                [`${fullPrefix}vc:next:dom`]: vcNext.VCBox
            }), SSRRatioPayload), {
                [`${fullPrefix}vc:ignored`]: this.getIgnoredElements(componentsLog)
            }), revisionsData, speedIndex);
        };
        this.handleUpdate = (rawTime, intersectionRect, targetName, element, type, ignoreReason, attributeName, oldValue, newValue)=>{
            if (this.abortReason.reason === null || this.abortReason.blocking === false) {
                const time = Math.round(rawTime - this.startTime);
                const mappedValues = this.mapPixelsToHeatmap(intersectionRect.left, intersectionRect.top, intersectionRect.width, intersectionRect.height);
                this.vcRatios[targetName] = this.getElementRatio(mappedValues);
                if (!ignoreReason) this.applyChangesToHeatMap(mappedValues, time, this.heatmapNext);
                const interaction = (0, _interactionMetrics.getActiveInteraction)();
                const isTTVCv1Disabled = !(0, _config.isVCRevisionEnabled)('fy25.01', interaction === null || interaction === void 0 ? void 0 : interaction.ufoName);
                if (!isTTVCv1Disabled && (!ignoreReason || ignoreReason === 'not-visible') && type !== 'attr') this.applyChangesToHeatMap(mappedValues, time, this.heatmap);
                if (!this.componentsLog[time]) this.componentsLog[time] = [];
                this.componentsLog[time].push({
                    __debug__element: this.devToolsEnabled ? new WeakRef(element) : null,
                    type,
                    intersectionRect,
                    targetName,
                    ignoreReason,
                    attributeName,
                    oldValue,
                    newValue
                });
            }
        };
        this.mapPixelsToHeatmap = (left, top, width, height)=>{
            const { w, h } = this.viewport;
            const l = Math.floor(left / w * this.arraySize);
            const t = Math.floor(top / h * this.arraySize);
            const r = Math.ceil((left + width) / w * this.arraySize);
            const b = Math.ceil((top + height) / h * this.arraySize);
            // that info is temporary to get info why it goes over boundary
            if (this.outOfBoundaryInfo === '') {
                let outOfBoundaryInfo = '';
                if (r > this.arraySize) outOfBoundaryInfo += ` r ${r} ! ${left} ${width}`;
                if (b > this.arraySize) outOfBoundaryInfo += ` r ${r} ! ${top} ${height}`;
                this.outOfBoundaryInfo = outOfBoundaryInfo;
            }
            // correct values to min - 0, max - arraySize
            const result = {
                l: Math.max(0, l),
                t: Math.max(0, t),
                r: Math.min(this.arraySize, r),
                b: Math.min(this.arraySize, b)
            };
            return result;
        };
        this.getElementRatio = (mappedValues)=>{
            const { r, l, b, t } = mappedValues;
            return (r - l) * (b - t) / (this.arraySize * this.arraySize);
        };
        this.abortReasonCallback = (key, time)=>{
            switch(key){
                case 'wheel':
                    this.setAbortReason(abortReason.scroll, time);
                    break;
                case 'keydown':
                    // Don't abort press interactions on keydown events, as keydown is expected
                    // when users press Enter/Space to activate buttons or other interactive elements
                    if ((0, _platformFeatureFlags.fg)('platform_ufo_keypress_interaction_abort')) {
                        const interaction = (0, _interactionMetrics.getActiveInteraction)();
                        if ((interaction === null || interaction === void 0 ? void 0 : interaction.type) === 'press') break;
                    }
                    this.setAbortReason(abortReason.keypress, time);
                    break;
                case 'resize':
                    this.setAbortReason(abortReason.resize, time);
                    break;
            }
        };
        this.attachAbortListeners = ()=>{
            var _window;
            this.detachAbortListeners();
            let unbinds = (0, _attachAbortListeners.attachAbortListeners)(window, this.viewport, this.abortReasonCallback);
            if ((_window = window) === null || _window === void 0 ? void 0 : _window.__SSR_ABORT_LISTENERS__) Object.entries(window.__SSR_ABORT_LISTENERS__.aborts).forEach(([key, time])=>{
                if (time) this.abortReasonCallback(key, time);
            });
            this.unbind = unbinds;
        };
        this.arraySize = options.heatmapSize || 200;
        this.devToolsEnabled = options.devToolsEnabled || false;
        this.oldDomUpdatesEnabled = options.oldDomUpdates || false;
        const { ssrEnablePageLayoutPlaceholder, ssrPlaceholderHandler } = options;
        // Selector-config resolution is centralised in `getSelectorConfig()`
        // (`../../config`). It enforces FedRAMP-override > caller-override >
        // centrally configured > caller default. When `getSelectorConfig()`
        // returns `undefined` we fall back to the legacy hard-coded default
        // to preserve pre-existing behaviour for callers that don't pass an
        // explicit `selectorConfig`.
        const LEGACY_DEFAULT_SELECTOR_CONFIG = {
            id: false,
            testId: false,
            role: false,
            className: true,
            dataVC: true
        };
        this.observers = new (0, _observers.Observers)({
            selectorConfig: (0, _config.getSelectorConfig)(options.selectorConfig, LEGACY_DEFAULT_SELECTOR_CONFIG) || options.selectorConfig || LEGACY_DEFAULT_SELECTOR_CONFIG,
            SSRConfig: {
                enablePageLayoutPlaceholder: ssrEnablePageLayoutPlaceholder || false
            },
            ssrPlaceholderHandler: ssrPlaceholderHandler
        });
        this.heatmap = !(0, _config.isVCRevisionEnabled)('fy25.01') ? [] : this.getCleanHeatmap();
        this.heatmapNext = this.getCleanHeatmap();
        this.isPostInteraction = options.isPostInteraction || false;
    }
}
/** config * */ VCObserver.VCParts = [
    '25',
    '50',
    '75',
    '80',
    '85',
    '90',
    '95',
    '98',
    '99'
];

},{"@swc/helpers/_/_object_spread":"9gdrV","@swc/helpers/_/_object_spread_props":"kANqQ","@swc/helpers/_/_object_without_properties":"6HqIM","@atlaskit/platform-feature-flags":"8rD2i","../../config":"bx9i6","../../interaction-metrics":"j4w6h","./attachAbortListeners":"9Uw1h","./getVCRevisionDebugDetails":"9JbTn","./getVCRevisionsData":"8F1CE","./getViewport":"1l9Fb","./observers":"6End3","@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"9Uw1h":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "attachAbortListeners", ()=>attachAbortListeners);
var _bindEventListener = require("bind-event-listener");
var _types = require("../../common/vc/types");
var _getViewport = require("./getViewport");
function attachAbortListeners(window, initialViewPort, callback) {
    const unbindWheel = (0, _bindEventListener.bind)(window, {
        type: (0, _types.AbortEvent).wheel,
        listener: (e)=>{
            callback((0, _types.AbortEvent).wheel, e.timeStamp);
        },
        options: {
            passive: true,
            once: true
        }
    });
    const unbindKeydown = (0, _bindEventListener.bind)(window, {
        type: (0, _types.AbortEvent).keydown,
        listener: (e)=>{
            callback((0, _types.AbortEvent).keydown, e.timeStamp);
        },
        options: {
            once: true
        }
    });
    const unbindResize = (0, _bindEventListener.bind)(window, {
        type: (0, _types.AbortEvent).resize,
        listener: (e)=>{
            if ((0, _getViewport.getViewportWidth)() !== initialViewPort.w || (0, _getViewport.getViewportHeight)() !== initialViewPort.h) {
                callback((0, _types.AbortEvent).resize, e.timeStamp);
                unbindResize();
            }
        }
    });
    return [
        unbindWheel,
        unbindKeydown,
        unbindResize
    ];
}

},{"bind-event-listener":"bjeUU","../../common/vc/types":"lJKOI","./getViewport":"1l9Fb","@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"lJKOI":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "AbortEvent", ()=>AbortEvent);
const AbortEvent = {
    wheel: 'wheel',
    keydown: 'keydown',
    resize: 'resize'
};

},{"@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"1l9Fb":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "getViewportWidth", ()=>getViewportWidth);
// eslint-disable-next-line @atlaskit/volt-strict-mode/no-multiple-exports
parcelHelpers.export(exports, "getViewportHeight", ()=>getViewportHeight);
function getViewportWidth(document = window.document) {
    let documentWidth;
    try {
        documentWidth = document.documentElement.clientWidth || 0;
    } catch (e) {
        documentWidth = 0;
    }
    return Math.max(documentWidth, window.innerWidth || 0);
}
function getViewportHeight(document = window.document) {
    let documentHeight;
    try {
        documentHeight = document.documentElement.clientHeight || 0;
    } catch (e) {
        documentHeight = 0;
    }
    return Math.max(documentHeight, window.innerHeight || 0);
}

},{"@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"9JbTn":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "getVCRevisionDebugDetails", ()=>getVCRevisionDebugDetails);
function getVCRevisionDebugDetails({ revision, isClean, abortReason, VCEntries, componentsLog, interactionId }) {
    // Pre-sort VCEntries by time for efficient lookups
    const sortedVCEntries = [
        ...VCEntries
    ].sort((a, b)=>a.time - b.time);
    // Pre-calculate max viewport percentage up to each time for efficient lookups
    const maxViewportPercentageAtTime = new Map();
    let maxSoFar = 0;
    for (const entry of sortedVCEntries){
        maxSoFar = Math.max(maxSoFar, entry.vc);
        maxViewportPercentageAtTime.set(entry.time, maxSoFar);
    }
    // Helper function to find the biggest previous viewport percentage
    const getBiggestPreviousViewportPercentage = (targetTime)=>{
        // Binary search for the largest time <= targetTime
        let left = 0;
        let right = sortedVCEntries.length - 1;
        let result = -1;
        while(left <= right){
            const mid = Math.floor((left + right) / 2);
            if (sortedVCEntries[mid].time <= targetTime) {
                result = mid;
                left = mid + 1;
            } else right = mid - 1;
        }
        return result >= 0 ? maxViewportPercentageAtTime.get(sortedVCEntries[result].time) || null : null;
    };
    const allVcLogs = [];
    // Add regular VC entries
    for (const entry of VCEntries){
        const timeLogEntries = componentsLog[entry.time];
        allVcLogs.push({
            time: entry.time,
            viewportPercentage: entry.vc,
            entries: entry.elements.map((element)=>{
                const logEntry = timeLogEntries === null || timeLogEntries === void 0 ? void 0 : timeLogEntries.find((log)=>log.targetName === element);
                return {
                    elementName: element,
                    type: logEntry === null || logEntry === void 0 ? void 0 : logEntry.type,
                    rect: logEntry === null || logEntry === void 0 ? void 0 : logEntry.intersectionRect,
                    visible: true,
                    attributeName: logEntry === null || logEntry === void 0 ? void 0 : logEntry.attributeName,
                    oldValue: logEntry === null || logEntry === void 0 ? void 0 : logEntry.oldValue,
                    newValue: logEntry === null || logEntry === void 0 ? void 0 : logEntry.newValue,
                    ignoreReason: logEntry === null || logEntry === void 0 ? void 0 : logEntry.ignoreReason
                };
            })
        });
    }
    // Add ignored elements - only process timestamps that have ignored elements
    for (const [timestamp, timeLogEntries] of Object.entries(componentsLog)){
        const ignoredElements = timeLogEntries.filter((log)=>log.ignoreReason);
        if (ignoredElements.length === 0) continue;
        const time = Number(timestamp);
        const viewportPercentage = getBiggestPreviousViewportPercentage(time);
        allVcLogs.push({
            time,
            viewportPercentage,
            entries: ignoredElements.map((logEntry)=>({
                    elementName: logEntry.targetName,
                    type: logEntry.type,
                    rect: logEntry.intersectionRect,
                    visible: false,
                    attributeName: logEntry.attributeName,
                    oldValue: logEntry.oldValue,
                    newValue: logEntry.newValue,
                    ignoreReason: logEntry.ignoreReason
                }))
        });
    }
    // Sort once at the end
    allVcLogs.sort((a, b)=>a.time - b.time);
    return {
        revision,
        isClean,
        abortReason,
        vcLogs: allVcLogs,
        interactionId
    };
}

},{"@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"8F1CE":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
// Optimized implementation (current one)
parcelHelpers.export(exports, "getVCRevisionsData", ()=>getVCRevisionsData);
var _config = require("../../config");
var _hiddenTiming = require("../../hidden-timing");
const VCParts = [
    '25',
    '50',
    '75',
    '80',
    '85',
    '90',
    '95',
    '98',
    '99'
];
const READONLY_EMPTY_ARRAY = Array.from({
    length: 0
});
// Helper function to create vcDetails object to avoid code duplication
function createVCDetails(calculatedVC, shouldHaveVCmetric) {
    if (!shouldHaveVCmetric || !calculatedVC || !calculatedVC.VC || !calculatedVC.VCBox) return {};
    const details = {};
    const { VC, VCBox } = calculatedVC; // Destructure once to avoid repeated property access
    for (const key of VCParts)details[key] = {
        t: VC[key] || -1,
        e: VCBox[key] || READONLY_EMPTY_ARRAY
    };
    return details;
}
function getVCRevisionsData({ fullPrefix, interaction, isVCClean, isEventAborted, calculatedVC, calculatedVCNext, experienceKey, ratios }) {
    const pageVisibilityUpToTTAI = (0, _hiddenTiming.getPageVisibilityState)(interaction.start, interaction.end);
    const isVisiblePageVisibleUpToTTAI = pageVisibilityUpToTTAI === 'visible';
    const shouldHaveVCmetric = isVCClean && !isEventAborted && isVisiblePageVisibleUpToTTAI;
    const availableVCRevisionPayloads = [];
    if ((0, _config.isVCRevisionEnabled)('fy25.01', experienceKey)) {
        const revision = {
            revision: 'fy25.01',
            clean: isVCClean,
            'metric:vc90': shouldHaveVCmetric ? calculatedVC.VC['90'] : null,
            vcDetails: createVCDetails(calculatedVC, shouldHaveVCmetric)
        };
        if (shouldHaveVCmetric) revision.ratios = ratios;
        availableVCRevisionPayloads.push(revision);
    }
    if ((0, _config.isVCRevisionEnabled)('fy25.02', experienceKey)) {
        const revision = {
            revision: 'fy25.02',
            clean: isVCClean,
            'metric:vc90': shouldHaveVCmetric ? calculatedVCNext.VC['90'] : null,
            vcDetails: createVCDetails(calculatedVCNext, shouldHaveVCmetric)
        };
        if (shouldHaveVCmetric) revision.ratios = ratios;
        availableVCRevisionPayloads.push(revision);
    }
    return {
        [`${fullPrefix}vc:rev`]: availableVCRevisionPayloads
    };
}

},{"../../config":"bx9i6","../../hidden-timing":"c8L9i","@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"6End3":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "Observers", ()=>Observers);
var _objectSpread = require("@swc/helpers/_/_object_spread");
var _config = require("../../../config");
var _vcUtils = require("../media-wrapper/vc-utils");
var _isNonVisualStyleMutation = require("./non-visual-styles/is-non-visual-style-mutation");
var _isNonVisualStyleMutationDefault = parcelHelpers.interopDefault(_isNonVisualStyleMutation);
var _rllPlaceholders = require("./rll-placeholders");
var _ssrPlaceholders = require("./ssr-placeholders");
const state = {
    normal: 1,
    waitingForFirstRender: 2,
    ignoring: 3
};
function isElementVisible(target) {
    if (!target || typeof target.checkVisibility !== 'function') return true;
    const isVisible = target.checkVisibility({
        contentVisibilityAuto: true,
        opacityProperty: true,
        visibilityProperty: true
    });
    return isVisible;
}
class Observers {
    isBrowserSupported() {
        return typeof window.IntersectionObserver === 'function' && typeof window.MutationObserver === 'function';
    }
    observe() {
        var _this_mutationObserver;
        this.totalTime = 0;
        this.ssr = {
            state: state.normal,
            reactRootElement: null,
            renderStart: -1,
            renderStop: -1
        };
        (_this_mutationObserver = this.mutationObserver) === null || _this_mutationObserver === void 0 ? void 0 : _this_mutationObserver.observe(document.body, {
            attributeFilter: [
                'hidden',
                'style',
                'src',
                'class'
            ],
            attributeOldValue: true,
            attributes: true,
            childList: true,
            subtree: true
        });
    }
    disconnect() {
        var _this_mutationObserver, _this_intersectionObserver;
        (_this_mutationObserver = this.mutationObserver) === null || _this_mutationObserver === void 0 ? void 0 : _this_mutationObserver.disconnect();
        (_this_intersectionObserver = this.intersectionObserver) === null || _this_intersectionObserver === void 0 ? void 0 : _this_intersectionObserver.disconnect();
        this.observedMutations = new WeakMap();
        this.elementsInView.clear();
        this.callbacks.clear();
        this.ssr.reactRootElement = null;
        this.ssrPlaceholderHandler.clear();
    }
    getTotalTime() {
        return this.totalTime;
    }
    setReactRootElement(element) {
        this.ssr.reactRootElement = element;
    }
    setReactRootRenderStart(startTime = performance.now()) {
        this.ssr.renderStart = startTime;
        this.ssr.state = state.waitingForFirstRender;
    }
    setReactRootRenderStop(stopTime = performance.now()) {
        this.ssr.renderStop = stopTime;
    }
    getMutationObserver() {
        if (!this.isBrowserSupported()) return null;
        return new MutationObserver((mutations)=>{
            this.measureStart();
            mutations.forEach((mutation)=>{
                // patching element if timestamp not automatically added
                // eslint-disable-next-line no-param-reassign
                mutation.timestamp = mutation.timestamp === undefined ? performance.now() : mutation.timestamp;
                let ignoreReason = '';
                if (this.ssr.state === state.waitingForFirstRender && mutation.timestamp > this.ssr.renderStart && mutation.target === this.ssr.reactRootElement) {
                    this.ssr.state = state.ignoring;
                    if (this.ssr.renderStop === -1) // arbitrary 500ms DOM update window
                    this.ssr.renderStop = mutation.timestamp + 500;
                    ignoreReason = 'ssr-hydration';
                }
                if (this.ssr.state === state.ignoring && mutation.timestamp > this.ssr.renderStart && mutation.target === this.ssr.reactRootElement) {
                    if (mutation.timestamp <= this.ssr.renderStop) ignoreReason = 'ssr-hydration';
                    else this.ssr.state = state.normal;
                }
                if (mutation.type === 'childList') {
                    mutation.addedNodes.forEach((node)=>{
                        if ((0, _vcUtils.isContainedWithinMediaWrapper)(node)) ignoreReason = 'image';
                        if (node instanceof HTMLElement) {
                            if (this.ssrPlaceholderHandler.isPlaceholder(node) || this.ssrPlaceholderHandler.isPlaceholderIgnored(node)) {
                                this.ssrPlaceholderHandler.checkIfExistedAndSizeMatching(node).then((result)=>{
                                    if (result === false) this.observeElement(node, mutation, 'html', ignoreReason);
                                });
                                return;
                            }
                            if (this.ssrPlaceholderHandler.isPlaceholderReplacement(node) || this.ssrPlaceholderHandler.isPlaceholderIgnored(node)) {
                                this.ssrPlaceholderHandler.validateReactComponentMatchToPlaceholder(node).then((result)=>{
                                    if (result === false) this.observeElement(node, mutation, 'html', ignoreReason);
                                });
                                return;
                            }
                            this.observeElement(node, mutation, 'html', ignoreReason);
                        }
                        if (node instanceof Text && node.parentElement != null) this.observeElement(node.parentElement, mutation, 'text', ignoreReason);
                    });
                    mutation.removedNodes.forEach((node)=>{
                        if (node instanceof Element) {
                            var _this_intersectionObserver;
                            this.elementsInView.delete(node);
                            (_this_intersectionObserver = this.intersectionObserver) === null || _this_intersectionObserver === void 0 ? void 0 : _this_intersectionObserver.unobserve(node);
                        }
                    });
                } else if (mutation.type === 'attributes') {
                    if (mutation.target instanceof HTMLElement) {
                        const attributeName = mutation.attributeName;
                        var _mutation_oldValue;
                        /*
							"MutationObserver was explicitly designed to work that way, but I can't now recall the reasoning.
							I think it might have been something along the lines that for consistency every setAttribute call should create a record.
							Conceptually there is after all a mutation: there is an old value replaced with a new one,
							and whether or not they are the same doesn't really matter.
							And Custom elements should work the same way as MutationObserver."
							https://github.com/whatwg/dom/issues/520#issuecomment-336574796
						*/ const oldValue = (_mutation_oldValue = mutation.oldValue) !== null && _mutation_oldValue !== void 0 ? _mutation_oldValue : undefined;
                        const newValue = attributeName ? mutation.target.getAttribute(attributeName) : undefined;
                        if (oldValue !== newValue) {
                            if ((0, _isNonVisualStyleMutationDefault.default)(mutation)) ignoreReason = 'non-visual-style';
                            if ((0, _vcUtils.isContainedWithinMediaWrapper)(mutation.target)) ignoreReason = 'image';
                            this.observeElement(mutation.target, mutation, 'attr', ignoreReason, attributeName, oldValue, newValue);
                        }
                    }
                }
            });
        });
    }
    getElementName(element) {
        try {
            const tagName = element.localName;
            const dataVCAttr = element.getAttribute('data-vc');
            const dataVC = this.selectorConfig.dataVC && dataVCAttr ? `[data-vc="${dataVCAttr}"]` : '';
            const id = this.selectorConfig.id && element.id ? `#${element.id}` : '';
            let testId = this.selectorConfig.testId ? element.getAttribute('data-testid') || element.getAttribute('data-test-id') : '';
            testId = testId ? `[testid=${testId}]` : '';
            let role = this.selectorConfig.role ? element.getAttribute('role') : '';
            role = role ? `[role=${role}]` : '';
            let classList = this.selectorConfig.className ? Array.from(element.classList).join('.') : '';
            classList = classList === '' ? '' : `.${classList}`;
            const attrs = dataVC ? dataVC : [
                id,
                testId,
                role
            ].join('');
            let idString = '';
            if (attrs === '' && classList === '') {
                const parent = element.parentElement ? this.getElementName(element.parentElement) : 'unknown';
                idString = `${parent} > ${tagName}`;
            } else idString = [
                tagName,
                attrs || classList
            ].join('');
            return idString;
        } catch (e) {
            return 'error';
        }
    }
    getIntersectionObserver() {
        if (!this.isBrowserSupported()) return null;
        return new IntersectionObserver((entries)=>{
            this.measureStart();
            entries.forEach(({ isIntersecting, intersectionRect: ir, target })=>{
                const data = this.observedMutations.get(target);
                this.observedMutations.delete(target);
                if (isIntersecting && ir.width > 0 && ir.height > 0) {
                    if (!(target instanceof HTMLElement)) return;
                    if (!(data === null || data === void 0 ? void 0 : data.mutation)) // ignore intersection report without recent mutation
                    return;
                    if (!isElementVisible(target)) data.ignoreReason = 'not-visible';
                    if ((0, _rllPlaceholders.RLLPlaceholderHandlers).getInstance().isRLLPlaceholderHydration(ir)) data.ignoreReason = 'rll-placeholder';
                    this.callbacks.forEach((callback)=>{
                        let elementName;
                        try {
                            elementName = this.getElementName(target);
                        } catch (e) {
                            elementName = 'error';
                        }
                        callback(data.mutation.timestamp || performance.now(), ir, elementName, target, data.type, data.ignoreReason, data.attributeName, data.oldValue, data.newValue);
                    });
                    this.elementsInView.add(target);
                } else this.elementsInView.delete(target);
            });
            this.measureStop();
        });
    }
    measureStart() {
        this._startMeasureTimestamp = performance.now();
    }
    measureStop() {
        if (this._startMeasureTimestamp === -1) return;
        this.totalTime += performance.now() - this._startMeasureTimestamp;
        this._startMeasureTimestamp = -1;
    }
    constructor(opts){
        var _opts_SSRConfig;
        this.observedMutations = new WeakMap();
        this.elementsInView = new Set();
        this.callbacks = new Set();
        this.totalTime = 0;
        this._startMeasureTimestamp = -1;
        this.ssr = {
            state: state.normal,
            reactRootElement: null,
            renderStart: -1,
            renderStop: -1
        };
        this.selectorConfig = {
            id: false,
            testId: false,
            role: false,
            className: true,
            dataVC: true
        };
        this.subscribeResults = (cb)=>{
            this.callbacks.add(cb);
        };
        this.observeElement = (node, mutation, type, ignoreReason, attributeName, oldValue = null, newValue = null)=>{
            var _this_intersectionObserver;
            (_this_intersectionObserver = this.intersectionObserver) === null || _this_intersectionObserver === void 0 ? void 0 : _this_intersectionObserver.observe(node);
            this.observedMutations.set(node, {
                mutation,
                ignoreReason,
                type,
                attributeName,
                oldValue,
                newValue
            });
        };
        // Selector-config resolution is centralised in `getSelectorConfig()`.
        // It enforces FedRAMP-override > caller-override > centrally
        // configured > caller default.
        const resolved = (0, _config.getSelectorConfig)(opts.selectorConfig, this.selectorConfig);
        this.selectorConfig = resolved !== null && resolved !== void 0 ? resolved : (0, _objectSpread._)({}, this.selectorConfig, opts.selectorConfig);
        this.intersectionObserver = this.getIntersectionObserver();
        this.mutationObserver = this.getMutationObserver();
        // Use shared SSR placeholder handler if provided, otherwise create new one
        if (opts.ssrPlaceholderHandler) this.ssrPlaceholderHandler = opts.ssrPlaceholderHandler;
        else this.ssrPlaceholderHandler = new (0, _ssrPlaceholders.SSRPlaceholderHandlers)({
            enablePageLayoutPlaceholder: (_opts_SSRConfig = opts.SSRConfig) === null || _opts_SSRConfig === void 0 ? void 0 : _opts_SSRConfig.enablePageLayoutPlaceholder
        });
    }
}

},{"@swc/helpers/_/_object_spread":"9gdrV","../../../config":"bx9i6","../media-wrapper/vc-utils":"kpsp6","./non-visual-styles/is-non-visual-style-mutation":"g5J6e","./rll-placeholders":"calqI","./ssr-placeholders":"5zEx5","@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"kpsp6":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "isContainedWithinMediaWrapper", ()=>isContainedWithinMediaWrapper);
var _index = require("./index");
function isContainedWithinMediaWrapper(node) {
    while(node){
        if (node instanceof Element && node.hasAttribute((0, _index.MEDIA_WRAPPER_TAG))) return true;
        node = node.parentNode;
    }
    return false;
}

},{"./index":"fdEMr","@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"fdEMr":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>(0, _mediaWrapperDefault.default));
parcelHelpers.export(exports, "MEDIA_WRAPPER_TAG", ()=>(0, _mediaWrapper.MEDIA_WRAPPER_TAG));
parcelHelpers.export(exports, "VcMediaWrapperProps", ()=>(0, _mediaWrapper.VcMediaWrapperProps));
var _mediaWrapper = require("./MediaWrapper");
var _mediaWrapperDefault = parcelHelpers.interopDefault(_mediaWrapper);

},{"./MediaWrapper":"2LCyU","@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"2LCyU":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "MEDIA_WRAPPER_TAG", ()=>MEDIA_WRAPPER_TAG);
parcelHelpers.export(exports, "VcMediaWrapperProps", ()=>VcMediaWrapperProps);
parcelHelpers.export(exports, "default", ()=>MediaWrapper);
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
const MEDIA_WRAPPER_TAG = 'data-media-vc-wrapper';
const VcMediaWrapperProps = {
    [MEDIA_WRAPPER_TAG]: true
};
function MediaWrapper({ children }) {
    return /*#__PURE__*/ (0, _reactDefault.default).createElement("div", VcMediaWrapperProps, children);
}

},{"react":"ltHCL","@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"g5J6e":[function(require,module,exports,__globalThis) {
/**
 * Checks if a mutation record represents a non-visual style change
 * @param mutation - The mutation record to check
 * @returns boolean indicating if this is a non-visual style mutation
 *
 * A mutation is considered non-visual if:
 * - The target has data-	vc-nvs="true" attribute
 * - The changed attribute is either 'class' or 'style'
 */ var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
function isNonVisualStyleMutation({ target, attributeName }) {
    if (!(target instanceof Element)) return false;
    if (attributeName !== 'class' && attributeName !== 'style') return false;
    if (target.getAttribute('data-vc-nvs') !== 'true') return false;
    return true;
}
exports.default = isNonVisualStyleMutation;

},{"@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"calqI":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "RLLPlaceholderHandlers", ()=>RLLPlaceholderHandlers);
const GLOBAL_RLL_HANDLERS_KEY = '__REACT_UFO_RLL_PLACEHOLDER_HANDLERS__';
class RLLPlaceholderHandlers {
    /**
   * Gets the global singleton instance of RLLPlaceholderHandlers.
   * Creates the instance if it doesn't exist and stores it in globalThis.
   * @returns The singleton instance of RLLPlaceholderHandlers
   */ static getInstance() {
        if (typeof globalThis !== 'undefined') {
            if (!globalThis[GLOBAL_RLL_HANDLERS_KEY]) globalThis[GLOBAL_RLL_HANDLERS_KEY] = new RLLPlaceholderHandlers();
            return globalThis[GLOBAL_RLL_HANDLERS_KEY];
        }
        // Fallback for environments without globalThis (should be rare)
        return new RLLPlaceholderHandlers();
    }
    reset() {
        this.placeholders = [];
    }
    /**
   * Collects all React Loosely Lazy (RLL) placeholders from the DOM and caches their viewport intersecting rectangles.
   * RLL placeholders are marked with data-lazy-begin and data-lazy-end attributes on hidden input elements.
   * Performance optimized to batch getBoundingClientRect calls and minimize layout thrashing.
   * Only stores the intersecting portions of rectangles that are currently visible in the viewport.
   */ collectRLLPlaceholders() {
        if (typeof window === 'undefined' || typeof document === 'undefined' || typeof window.document === 'undefined') return;
        const beginElements = document.querySelectorAll('input[data-lazy-begin]');
        const beginCount = beginElements.length;
        if (beginCount === 0) return;
        // Performance optimization: pre-allocate array with estimated size
        const allElements = [];
        // Performance optimization: use traditional for loop instead of forEach
        for(let i = 0; i < beginCount; i++){
            const beginEl = beginElements[i];
            const id = beginEl.getAttribute('data-lazy-begin');
            if (!id) continue;
            const elements = this.refElements(beginEl, id);
            if (elements.length > 0) allElements.push(...elements);
        }
        // Second pass: batch all getBoundingClientRect calls to minimize reflow cycles
        const allElementsLength = allElements.length;
        if (allElementsLength > 0) {
            // Performance optimization: pre-allocate array with exact size
            const intersectingRects = [];
            const windowWidth = window.innerWidth;
            const windowHeight = window.innerHeight;
            for(let i = 0; i < allElementsLength; i++){
                const rect = allElements[i].getBoundingClientRect();
                // Performance optimization: inline intersection calculation to avoid function call overhead
                const left = Math.max(rect.left, 0);
                const top = Math.max(rect.top, 0);
                const right = Math.min(rect.right, windowWidth);
                const bottom = Math.min(rect.bottom, windowHeight);
                // Check if there's a valid intersection with non-zero width and height
                if (left < right && top < bottom) intersectingRects.push(new DOMRect(left, top, right - left, bottom - top));
            }
            this.placeholders = intersectingRects;
        }
    }
    /**
   * Traverses DOM siblings to find all elements between RLL begin and end markers.
   * Based on the refElements pattern from react-loosely-lazy's platform/packages/async/react-loosely-lazy/src/collect/hydrate.ts
   * Performance optimized to minimize iterations and early exit conditions.
   *
   * @param fromEl - The input element with data-lazy-begin attribute
   * @param id - The placeholder ID to match against data-lazy-end
   * @returns Array of DOM elements between the begin/end markers
   */ refElements(fromEl, id) {
        const result = [];
        let el = fromEl.nextSibling;
        // Performance optimization: use while loop instead of recursive calls
        while(el){
            var _el_dataset;
            if (((_el_dataset = el.dataset) === null || _el_dataset === void 0 ? void 0 : _el_dataset.lazyEnd) === id) break;
            if (el.nodeType === Node.ELEMENT_NODE) result.push(el);
            el = el.nextSibling;
        }
        return result;
    }
    /**
   * Returns the cached intersecting viewport rectangles for all RLL placeholder elements.
   * @returns Array of DOMRect objects representing the intersecting portions of placeholders within the viewport
   */ getPlaceholders() {
        return this.placeholders;
    }
    /**
   * Checks if the given intersecting rectangle matches any of the cached RLL placeholder intersecting rectangles.
   * This is designed to be called from IntersectionObserver with the intersectionRect.
   * Performance optimized with early exits and minimal calculations.
   * @param intersectingRect - The intersecting rectangle from IntersectionObserver
   * @returns true if the intersecting rectangle matches a cached placeholder rectangle and hasn't exceeded match limit, false otherwise
   */ isRLLPlaceholderHydration(intersectingRect) {
        const placeholdersLength = this.placeholders.length;
        if (placeholdersLength === 0) return false;
        // Performance optimization: cache array length and use traditional for loop
        for(let i = 0; i < placeholdersLength; i++){
            const placeholderRect = this.placeholders[i];
            if (this.areRectsEqual(intersectingRect, placeholderRect)) return true;
        }
        return false;
    }
    /**
   * Compares two DOMRect objects for equality with ±1 pixel tolerance.
   * Performance optimized to minimize calculations and early exit on major differences.
   * @param rect1 - First rectangle to compare
   * @param rect2 - Second rectangle to compare
   * @returns true if rectangles are within 1 pixel tolerance for all properties
   */ areRectsEqual(rect1, rect2) {
        // Early exit for exact matches (most common case)
        if (rect1.left === rect2.left && rect1.top === rect2.top && rect1.right === rect2.right && rect1.bottom === rect2.bottom) return true;
        // Performance optimization: check largest differences first for early exit
        const leftDiff = rect1.left - rect2.left;
        if (leftDiff > 1 || leftDiff < -1) return false;
        const rightDiff = rect1.right - rect2.right;
        if (rightDiff > 1 || rightDiff < -1) return false;
        const topDiff = rect1.top - rect2.top;
        if (topDiff > 1 || topDiff < -1) return false;
        const bottomDiff = rect1.bottom - rect2.bottom;
        if (bottomDiff > 1 || bottomDiff < -1) return false;
        return true;
    }
    constructor(){
        this.placeholders = [];
        if (typeof window !== 'undefined' && typeof document !== 'undefined' && typeof window.document !== 'undefined') this.collectRLLPlaceholders();
    }
}

},{"@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"5zEx5":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "SSRPlaceholderHandlers", ()=>SSRPlaceholderHandlers);
const ANCESTOR_LOOKUP_LIMIT = 10;
const PAGE_LAYOUT_ID = 'page-layout.root';
class SSRPlaceholderHandlers {
    clear() {
        this.staticPlaceholders = new Map();
        this.callbacks = new Map();
        this.getSizeCallbacks = new Map();
        this.reactValidateCallbacks = new Map();
    }
    collectPlaceholdersInternal() {
        const selector = this.enablePageLayoutPlaceholder ? '[data-ssr-placeholder],[data-testid="page-layout.root"]' : '[data-ssr-placeholder]';
        const existingElements = document.querySelectorAll(selector);
        existingElements.forEach((el)=>{
            const placeholderId = el instanceof HTMLElement && this.getPlaceholderId(el);
            if (placeholderId && !this.staticPlaceholders.has(placeholderId)) {
                var _window___SSR_PLACEHOLDERS_DIMENSIONS__, _this_intersectionObserver;
                let width = -1;
                let height = -1;
                let x = -1;
                let y = -1;
                // Use SSR dimensions from window global if available
                const boundingClientRect = (_window___SSR_PLACEHOLDERS_DIMENSIONS__ = window.__SSR_PLACEHOLDERS_DIMENSIONS__) === null || _window___SSR_PLACEHOLDERS_DIMENSIONS__ === void 0 ? void 0 : _window___SSR_PLACEHOLDERS_DIMENSIONS__[placeholderId];
                if (boundingClientRect) {
                    width = boundingClientRect.width;
                    height = boundingClientRect.height;
                    x = boundingClientRect.x;
                    y = boundingClientRect.y;
                } else {
                    // Fallback to current bounding rect if SSR dimensions not available
                    const rect = el.getBoundingClientRect();
                    width = rect.width;
                    height = rect.height;
                    x = rect.x;
                    y = rect.y;
                }
                this.staticPlaceholders.set(placeholderId, {
                    width,
                    height,
                    x,
                    y
                });
                (_this_intersectionObserver = this.intersectionObserver) === null || _this_intersectionObserver === void 0 ? void 0 : _this_intersectionObserver.observe(el);
            }
        });
    }
    /**
	 * Added this method to be utilised for testing purposes.
	 * In production it collection placeholder should only happens on constructor
	 */ collectExistingPlaceholders() {
        if (!window.document) return;
        try {
            // Collect placeholders using SSR dimensions or fallback to live dimensions
            this.collectPlaceholdersInternal();
        } catch (e) {
        // Silently fail if there are any issues
        } finally{
            delete window.__SSR_PLACEHOLDERS_DIMENSIONS__;
        }
    }
    isPlaceholder(element) {
        return Boolean(this.getPlaceholderId(element));
    }
    isPlaceholderReplacement(element) {
        return Boolean(this.getPlaceholderReplacementId(element));
    }
    isPlaceholderIgnored(element) {
        // data-ssr-placeholder-ignored doesn't have a value.
        return 'ssrPlaceholderIgnored' in element.dataset;
    }
    isPlaceholderV4(element) {
        let currentElement = element;
        let i = 0;
        while(currentElement && i < ANCESTOR_LOOKUP_LIMIT){
            if (Boolean(this.getPlaceholderId(currentElement))) return true;
            currentElement = currentElement.parentElement;
            i++;
        }
        return false;
    }
    isPlaceholderReplacementV4(element) {
        let currentElement = element;
        let i = 0;
        while(currentElement && i < ANCESTOR_LOOKUP_LIMIT){
            if (Boolean(this.getPlaceholderReplacementId(currentElement))) return true;
            currentElement = currentElement.parentElement;
            i++;
        }
        return false;
    }
    findNearestPlaceholderContainerIfIgnored(element) {
        if (!this.isPlaceholderIgnored(element)) return element;
        let ancestor = element.parentElement;
        let i = 0;
        while(ancestor && i < ANCESTOR_LOOKUP_LIMIT){
            if (this.isPlaceholder(ancestor) || this.isPlaceholderReplacement(ancestor)) return ancestor;
            ancestor = ancestor.parentElement;
            i++;
        }
        return element;
    }
    findNearestPlaceholderOrContainer(element, limit = ANCESTOR_LOOKUP_LIMIT) {
        let ancestor = element;
        if (this.isPlaceholderIgnored(element) && element.parentElement) ancestor = element.parentElement;
        let i = 0;
        while(ancestor && i < limit){
            if (this.isPlaceholder(ancestor) || this.isPlaceholderReplacement(ancestor)) return ancestor;
            if (ancestor.parentElement) {
                ancestor = ancestor.parentElement;
                i++;
            } else break;
        }
        return element;
    }
    // Validates placeholder match using asynchronous observation and resolves with the result
    checkIfExistedAndSizeMatching(el) {
        el = this.findNearestPlaceholderContainerIfIgnored(el);
        const id = this.getPlaceholderId(el);
        return new Promise((resolve)=>{
            if (!this.staticPlaceholders.has(id)) {
                resolve(false);
                return;
            } else {
                var _this_intersectionObserver;
                this.callbacks.set(id, resolve);
                (_this_intersectionObserver = this.intersectionObserver) === null || _this_intersectionObserver === void 0 ? void 0 : _this_intersectionObserver.observe(el);
            }
        });
    }
    // Validates placeholder match synchronously using stored SSR dimensions and current bounds
    checkIfExistedAndSizeMatchingV3(el) {
        el = this.findNearestPlaceholderContainerIfIgnored(el);
        const id = this.getPlaceholderId(el);
        const placeholderRects = this.staticPlaceholders.get(id);
        if (!placeholderRects) return false;
        return this.hasSameSizePosition(placeholderRects, this.getEffectiveBoundingRect(el));
    }
    getSize(el) {
        return new Promise((resolve)=>{
            var _this_intersectionObserver;
            this.getSizeCallbacks.set(this.getPlaceholderId(el), resolve);
            (_this_intersectionObserver = this.intersectionObserver) === null || _this_intersectionObserver === void 0 ? void 0 : _this_intersectionObserver.observe(el);
        });
    }
    validateReactComponentMatchToPlaceholder(el) {
        el = this.findNearestPlaceholderContainerIfIgnored(el);
        const id = this.getPlaceholderReplacementId(el);
        return new Promise((resolve)=>{
            if (!this.staticPlaceholders.has(id)) {
                resolve(false);
                return;
            } else {
                var _this_intersectionObserver;
                this.reactValidateCallbacks.set(id, resolve);
                (_this_intersectionObserver = this.intersectionObserver) === null || _this_intersectionObserver === void 0 ? void 0 : _this_intersectionObserver.observe(el);
            }
        });
    }
    validateReactComponentMatchToPlaceholderV4(el) {
        el = this.findNearestPlaceholderOrContainer(el, 2); // We are using 2 due to over-eagerness of the default, only check itself and 1 ancestor
        const id = this.getPlaceholderReplacementId(el);
        return this.staticPlaceholders.has(id);
    }
    hasSameSizePosition(rect, boundingClientRect) {
        if (!rect) return false;
        const horizontalCheck = Math.abs(rect.x - boundingClientRect.x) < this.EQUALITY_THRESHOLD && Math.abs(rect.width - boundingClientRect.width) < this.EQUALITY_THRESHOLD;
        const verticalCheck = Math.abs(rect.y - boundingClientRect.y) < this.EQUALITY_THRESHOLD && Math.abs(rect.height - boundingClientRect.height) < this.EQUALITY_THRESHOLD;
        return horizontalCheck && verticalCheck || false;
    }
    /**
	 * Gets the effective bounding rectangle for an element, handling display: contents elements
	 * by collecting dimensions from their children instead
	 */ getEffectiveBoundingRect(el) {
        const computedStyle = window.getComputedStyle(el);
        // If element has display: contents, collect bounding rect from children
        if (computedStyle.display === 'contents') {
            const children = Array.from(el.children);
            if (children.length === 0) // No children, return zero rect
            return new DOMRect(0, 0, 0, 0);
            // Calculate union of all children's bounding rects
            let minX = Infinity;
            let minY = Infinity;
            let maxX = -Infinity;
            let maxY = -Infinity;
            children.forEach((child)=>{
                const childRect = child.getBoundingClientRect();
                // Skip children with zero dimensions (likely also display: contents)
                if (childRect.width > 0 || childRect.height > 0) {
                    minX = Math.min(minX, childRect.left);
                    minY = Math.min(minY, childRect.top);
                    maxX = Math.max(maxX, childRect.right);
                    maxY = Math.max(maxY, childRect.bottom);
                }
            });
            // If no children with dimensions found, return zero rect
            if (minX === Infinity) return new DOMRect(0, 0, 0, 0);
            return new DOMRect(minX, minY, maxX - minX, maxY - minY);
        }
        // Normal element, return its bounding rect
        return el.getBoundingClientRect();
    }
    isDummyRect(rect) {
        return rect && rect.width < 0 && rect.height < 0 || false;
    }
    constructor({ enablePageLayoutPlaceholder = false }){
        this.staticPlaceholders = new Map();
        this.callbacks = new Map();
        this.getSizeCallbacks = new Map();
        this.reactValidateCallbacks = new Map();
        this.EQUALITY_THRESHOLD = 1;
        this.getPlaceholderId = (el)=>{
            var _el_dataset;
            const ssrPlaceholderId = el === null || el === void 0 ? void 0 : (_el_dataset = el.dataset) === null || _el_dataset === void 0 ? void 0 : _el_dataset.ssrPlaceholder;
            if (!!ssrPlaceholderId) return ssrPlaceholderId;
            if (this.enablePageLayoutPlaceholder && (el === null || el === void 0 ? void 0 : el.dataset.testid) === PAGE_LAYOUT_ID) return PAGE_LAYOUT_ID;
            return '';
        };
        this.getPlaceholderReplacementId = (el)=>{
            var _el_dataset;
            const ssrPlaceholderReplaceId = el === null || el === void 0 ? void 0 : (_el_dataset = el.dataset) === null || _el_dataset === void 0 ? void 0 : _el_dataset.ssrPlaceholderReplace;
            if (!!ssrPlaceholderReplaceId) return ssrPlaceholderReplaceId;
            if (this.enablePageLayoutPlaceholder && (el === null || el === void 0 ? void 0 : el.dataset.testid) === PAGE_LAYOUT_ID) return PAGE_LAYOUT_ID;
            return '';
        };
        this.intersectionObserverCallback = ({ target, boundingClientRect })=>{
            var _this_intersectionObserver;
            (_this_intersectionObserver = this.intersectionObserver) === null || _this_intersectionObserver === void 0 ? void 0 : _this_intersectionObserver.unobserve(target);
            if (!(target instanceof HTMLElement)) // impossible case - keep typescript healthy
            return;
            const staticKey = this.getPlaceholderId(target);
            if (staticKey) {
                if (this.staticPlaceholders.has(staticKey) && this.callbacks.has(staticKey)) {
                    // validation
                    const resolve = this.callbacks.get(staticKey);
                    if (!resolve) return;
                    const rect = this.staticPlaceholders.get(staticKey);
                    const hasSameSizePosition = this.hasSameSizePosition(rect, boundingClientRect);
                    if (hasSameSizePosition || this.isDummyRect(rect)) resolve(hasSameSizePosition);
                    else requestAnimationFrame(()=>{
                        const targetRect = this.getEffectiveBoundingRect(target);
                        const hasSameSizePosition = this.hasSameSizePosition(rect, targetRect);
                        resolve(hasSameSizePosition);
                    });
                    this.callbacks.delete(staticKey);
                }
            } else {
                const key = this.getPlaceholderReplacementId(target);
                const resolve = this.reactValidateCallbacks.get(key);
                if (!resolve) return;
                const rect = this.staticPlaceholders.get(key);
                const hasSameSizePosition = this.hasSameSizePosition(rect, boundingClientRect);
                if (hasSameSizePosition || this.isDummyRect(rect)) resolve(hasSameSizePosition);
                else requestAnimationFrame(()=>{
                    const targetRect = this.getEffectiveBoundingRect(target);
                    const hasSameSizePosition = this.hasSameSizePosition(rect, targetRect);
                    resolve(hasSameSizePosition);
                });
                this.staticPlaceholders.delete(staticKey);
                this.reactValidateCallbacks.delete(staticKey);
            }
        };
        if (typeof IntersectionObserver === 'function') // Only instantiate the IntersectionObserver if it's supported
        this.intersectionObserver = new IntersectionObserver((entries)=>entries.filter((entry)=>entry.intersectionRatio > 0).forEach(this.intersectionObserverCallback));
        this.enablePageLayoutPlaceholder = enablePageLayoutPlaceholder;
        if (window.document) try {
            // Collect initial placeholders using SSR dimensions
            this.collectPlaceholdersInternal();
        } catch (e) {} finally{
            delete window.__SSR_PLACEHOLDERS_DIMENSIONS__;
        }
    }
}

},{"@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"75IUn":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "getHasAbortingEventDuringSSR", ()=>getHasAbortingEventDuringSSR);
// eslint-disable-next-line @atlaskit/volt-strict-mode/no-multiple-exports
parcelHelpers.export(exports, "default", ()=>VCObserverNew);
var _objectSpread = require("@swc/helpers/_/_object_spread");
var _platformFeatureFlags = require("@atlaskit/platform-feature-flags");
var _config = require("../../config");
var _utils = require("../../create-payload/common/utils");
var _interactionMetrics = require("../../interaction-metrics");
var _ssrPlaceholders = require("../vc-observer/observers/ssr-placeholders");
var _entriesTimeline = require("./entries-timeline");
var _entriesTimelineDefault = parcelHelpers.interopDefault(_entriesTimeline);
var _getElementName = require("./get-element-name");
var _getElementNameDefault = parcelHelpers.interopDefault(_getElementName);
var _fy2503 = require("./metric-calculator/fy25_03");
var _fy2503Default = parcelHelpers.interopDefault(_fy2503);
var _fy2604 = require("./metric-calculator/fy26_04");
var _fy2604Default = parcelHelpers.interopDefault(_fy2604);
var _getViewportHeight = require("./metric-calculator/utils/get-viewport-height");
var _getViewportHeightDefault = parcelHelpers.interopDefault(_getViewportHeight);
var _getViewportWidth = require("./metric-calculator/utils/get-viewport-width");
var _getViewportWidthDefault = parcelHelpers.interopDefault(_getViewportWidth);
var _vcNext = require("./metric-calculator/vc-next");
var _vcNextDefault = parcelHelpers.interopDefault(_vcNext);
var _rawDataHandler = require("./raw-data-handler");
var _rawDataHandlerDefault = parcelHelpers.interopDefault(_rawDataHandler);
var _viewportObserver = require("./viewport-observer");
var _viewportObserverDefault = parcelHelpers.interopDefault(_viewportObserver);
var _windowEventObserver = require("./window-event-observer");
var _windowEventObserverDefault = parcelHelpers.interopDefault(_windowEventObserver);
const SSRState = {
    normal: 1,
    waitingForFirstRender: 2,
    ignoring: 3
};
const DEFAULT_SELECTOR_CONFIG = {
    id: false,
    testId: true,
    role: false,
    className: false,
    dataVC: true
};
function getHasAbortingEventDuringSSR() {
    return false;
}
class VCObserverNew {
    start(_) {
        var _this_viewportObserver, _window, _this_windowEventObserver;
        // Reset SSR state on start (matches old VCObserver behavior)
        this.ssr = {
            state: SSRState.normal,
            reactRootElement: null,
            renderStart: -1,
            renderStop: -1
        };
        (_this_viewportObserver = this.viewportObserver) === null || _this_viewportObserver === void 0 ? void 0 : _this_viewportObserver.start();
        this.entriesTimeline.clear();
        if ((_window = window) === null || _window === void 0 ? void 0 : _window.__SSR_ABORT_LISTENERS__) {
            const abortListeners = window.__SSR_ABORT_LISTENERS__;
            const aborts = abortListeners.aborts;
            if (aborts && typeof aborts === 'object') Object.entries(aborts).forEach(([key, time])=>{
                if (typeof time === 'number') this.entriesTimeline.push({
                    time,
                    data: {
                        type: 'window:event',
                        eventType: key
                    }
                });
            });
        }
        (_this_windowEventObserver = this.windowEventObserver) === null || _this_windowEventObserver === void 0 ? void 0 : _this_windowEventObserver.start();
    }
    stop() {
        var _this_viewportObserver, _this_windowEventObserver;
        (_this_viewportObserver = this.viewportObserver) === null || _this_viewportObserver === void 0 ? void 0 : _this_viewportObserver.stop();
        (_this_windowEventObserver = this.windowEventObserver) === null || _this_windowEventObserver === void 0 ? void 0 : _this_windowEventObserver.stop();
        // Clear SSR state on stop (matches old VCObserver behavior)
        this.ssr.reactRootElement = null;
    }
    // SSR related methods
    setReactRootElement(element) {
        this.ssr.reactRootElement = element;
    }
    setReactRootRenderStart(startTime = performance.now()) {
        this.ssr.renderStart = startTime;
        this.ssr.state = SSRState.waitingForFirstRender;
    }
    setReactRootRenderStop(stopTime = performance.now()) {
        this.ssr.renderStop = stopTime;
    }
    collectSSRPlaceholders() {
    // This is handled by the shared SSRPlaceholderHandlers in VCObserverWrapper
    // Individual observers don't need to implement this
    }
    // Internal methods for ViewportObserver to access SSR state
    getSSRState() {
        return this.ssr;
    }
    getSSRPlaceholderHandler() {
        return this.ssrPlaceholderHandler;
    }
    addSSR(ssr) {
        this.entriesTimeline.push({
            time: ssr,
            data: {
                elementName: 'SSR',
                type: 'mutation:element',
                rect: {
                    height: (0, _getViewportHeightDefault.default)(),
                    width: (0, _getViewportWidthDefault.default)(),
                    left: 0,
                    top: 0,
                    x: 0,
                    y: 0,
                    bottom: (0, _getViewportHeightDefault.default)(),
                    right: (0, _getViewportWidthDefault.default)(),
                    toJSON () {
                        return null;
                    }
                },
                visible: true
            }
        });
    }
    async getVCResult(param) {
        const { start, stop, interactionId, interactionType, interactionAbortReason, isPageVisible, include3p, includeSSRRatio, excludeSmartAnswersInSearch, rawDataStopTime } = param;
        const results = [];
        this.addStartEntry(start);
        const feVCCalculationStartTime = performance.now();
        const calculator_fy25_03 = new (0, _fy2503Default.default)();
        if (param.includeSSRInV3 && param.ssr) this.addSSR(param.ssr);
        const orderedEntries = this.entriesTimeline.getOrderedEntries({
            start,
            stop
        });
        const fy25_03 = (0, _config.isVCRevisionEnabled)('fy25.03') ? await calculator_fy25_03.calculate({
            orderedEntries,
            startTime: start,
            stopTime: stop,
            interactionId,
            interactionType,
            isPostInteraction: this.isPostInteraction,
            include3p,
            excludeSmartAnswersInSearch,
            includeSSRRatio,
            isPageVisible,
            interactionAbortReason,
            reportLayoutShiftOffenders: this.trackLayoutShiftOffenders
        }) : null;
        if (fy25_03) results.push(fy25_03);
        // From TTVC v4 onwards, ensuring that SSR entry is always auto-added, whenever it is configured.
        if (param.ssr) this.addSSR(param.ssr);
        const calculator_fy26_04 = new (0, _fy2604Default.default)();
        const calculator_next = new (0, _vcNextDefault.default)();
        const calculatorParams = {
            orderedEntries,
            startTime: start,
            stopTime: stop,
            interactionId,
            interactionType,
            isPostInteraction: this.isPostInteraction,
            include3p,
            excludeSmartAnswersInSearch,
            includeSSRRatio,
            isPageVisible,
            interactionAbortReason,
            reportLayoutShiftOffenders: this.trackLayoutShiftOffenders
        };
        const isFy2604Enabled = (0, _config.isVCRevisionEnabled)('fy26.04');
        const [fy26_04, vcNext] = await Promise.all([
            isFy2604Enabled ? calculator_fy26_04.calculate(calculatorParams) : null,
            (0, _config.isVCRevisionEnabled)('next') ? calculator_next.calculate(calculatorParams) : null
        ]);
        if (fy26_04) results.push(fy26_04);
        if (vcNext) results.push(vcNext);
        const feVCCalculationEndTime = performance.now();
        // Always include raw data so the server can recalculate metrics
        // (ssrRatio, labelStacks, speedIndex) from raw observations.
        const rawVCCalculationStartTime = performance.now();
        const rawHandler = new (0, _rawDataHandlerDefault.default)();
        // Use rawDataStopTime (end3p) when available to capture observations during 3p holds
        const rawStopTime = rawDataStopTime !== null && rawDataStopTime !== void 0 ? rawDataStopTime : stop;
        const rawOrderedEntries = rawDataStopTime ? this.entriesTimeline.getOrderedEntries({
            start,
            stop: rawStopTime
        }) : orderedEntries;
        const raw = await rawHandler.getRawData({
            entries: rawOrderedEntries,
            startTime: start,
            stopTime: rawStopTime,
            isPageVisible
        });
        results.forEach((result)=>{
            delete result.vcDetails;
            delete result.ratios;
        });
        if (raw) {
            raw.rawVCTime = Number((performance.now() - rawVCCalculationStartTime).toFixed(2));
            raw.feVCTime = Number((feVCCalculationEndTime - feVCCalculationStartTime).toFixed(2));
            results.push(raw);
        }
        return results;
    }
    addStartEntry(startTime) {
        this.entriesTimeline.push({
            time: startTime,
            data: {
                type: 'mutation:element',
                elementName: 'START',
                visible: true,
                rect: {
                    x: 0,
                    y: 0,
                    width: window.innerWidth,
                    height: window.innerHeight,
                    top: 0,
                    left: 0,
                    bottom: window.innerHeight,
                    right: window.innerWidth,
                    toJSON: function() {
                        return {
                            x: this.x,
                            y: this.y,
                            width: this.width,
                            height: this.height,
                            top: this.top,
                            left: this.left,
                            bottom: this.bottom,
                            right: this.right
                        };
                    }
                }
            }
        });
    }
    getElementName(element) {
        return (0, _getElementNameDefault.default)(this.selectorConfig, element);
    }
    constructor(config){
        var _config_SSRConfig;
        this.viewportObserver = null;
        this.windowEventObserver = null;
        // SSR related properties
        this.ssrPlaceholderHandler = null;
        this.ssr = {
            state: SSRState.normal,
            reactRootElement: null,
            renderStart: -1,
            renderStop: -1
        };
        this.entriesTimeline = new (0, _entriesTimelineDefault.default)();
        var _config_isPostInteraction;
        this.isPostInteraction = (_config_isPostInteraction = config.isPostInteraction) !== null && _config_isPostInteraction !== void 0 ? _config_isPostInteraction : false;
        var _getSelectorConfig, _ref;
        // Selector-config resolution is centralised in `getSelectorConfig()`
        // (`../../config`). It applies the FedRAMP all-`false` override when
        // `isFedrampModerate()` is true; otherwise it returns `caller-override
        // → setUFOConfig value → historical default`.
        this.selectorConfig = (_ref = (_getSelectorConfig = (0, _config.getSelectorConfig)(config.selectorConfig, DEFAULT_SELECTOR_CONFIG)) !== null && _getSelectorConfig !== void 0 ? _getSelectorConfig : config.selectorConfig) !== null && _ref !== void 0 ? _ref : DEFAULT_SELECTOR_CONFIG;
        var _config_SSRConfig_enablePageLayoutPlaceholder;
        // Use shared SSR placeholder handler if provided, otherwise create new one if feature flag is enabled
        if (config.ssrPlaceholderHandler) this.ssrPlaceholderHandler = config.ssrPlaceholderHandler;
        else this.ssrPlaceholderHandler = new (0, _ssrPlaceholders.SSRPlaceholderHandlers)({
            enablePageLayoutPlaceholder: (_config_SSRConfig_enablePageLayoutPlaceholder = (_config_SSRConfig = config.SSRConfig) === null || _config_SSRConfig === void 0 ? void 0 : _config_SSRConfig.enablePageLayoutPlaceholder) !== null && _config_SSRConfig_enablePageLayoutPlaceholder !== void 0 ? _config_SSRConfig_enablePageLayoutPlaceholder : false
        });
        var _config_trackLayoutShiftOffenders;
        this.trackLayoutShiftOffenders = (_config_trackLayoutShiftOffenders = config.trackLayoutShiftOffenders) !== null && _config_trackLayoutShiftOffenders !== void 0 ? _config_trackLayoutShiftOffenders : false;
        this.viewportObserver = new (0, _viewportObserverDefault.default)({
            onChange: (onChangeArg)=>{
                const { time, type, elementRef, visible, rect, previousRect, mutationData } = onChangeArg;
                let elementName = 'unknown';
                const element = elementRef.deref();
                if (element) elementName = this.getElementName(element);
                const data = {
                    type,
                    elementName,
                    rect,
                    previousRect,
                    visible,
                    attributeName: mutationData === null || mutationData === void 0 ? void 0 : mutationData.attributeName,
                    oldValue: mutationData === null || mutationData === void 0 ? void 0 : mutationData.oldValue,
                    newValue: mutationData === null || mutationData === void 0 ? void 0 : mutationData.newValue,
                    originalMutationTimestamp: mutationData === null || mutationData === void 0 ? void 0 : mutationData.timestamp
                };
                if (element) {
                    const labelStacks = getLabelStacks(element);
                    if (labelStacks) Object.assign(data, {
                        labelStacks
                    });
                }
                this.entriesTimeline.push({
                    time,
                    data
                });
            },
            // Pass SSR context to ViewportObserver
            getSSRState: ()=>this.getSSRState(),
            getSSRPlaceholderHandler: ()=>this.getSSRPlaceholderHandler(),
            searchPageConfig: config.searchPageConfig,
            trackLayoutShiftOffenders: this.trackLayoutShiftOffenders
        });
        this.windowEventObserver = new (0, _windowEventObserverDefault.default)({
            onEvent: ({ time, type, event })=>{
                // Don't abort press interactions on keydown events, as keydown is expected
                // when users press Enter/Space to activate buttons or other interactive elements
                if (type === 'keydown' && (0, _platformFeatureFlags.fg)('platform_ufo_keypress_interaction_abort')) {
                    const interaction = (0, _interactionMetrics.getActiveInteraction)();
                    if ((interaction === null || interaction === void 0 ? void 0 : interaction.type) === 'press') return;
                }
                const abortEventTargetElement = isAbortEventTargetSupported(type) && event ? getAbortEventTargetElement(event.target) : null;
                const elementName = abortEventTargetElement ? this.getElementName(abortEventTargetElement) : undefined;
                this.entriesTimeline.push({
                    time,
                    data: (0, _objectSpread._)({
                        type: 'window:event',
                        eventType: type
                    }, elementName ? {
                        elementName
                    } : {})
                });
            }
        });
    }
}
function labelStackFromFiber(fiber) {
    var _fiber_child_memoizedProps, _fiber_child;
    const value = fiber === null || fiber === void 0 ? void 0 : (_fiber_child = fiber.child) === null || _fiber_child === void 0 ? void 0 : (_fiber_child_memoizedProps = _fiber_child.memoizedProps) === null || _fiber_child_memoizedProps === void 0 ? void 0 : _fiber_child_memoizedProps.value;
    return Array.isArray(value === null || value === void 0 ? void 0 : value.labelStack) ? value.labelStack : [];
}
function labelStackToString(labelStack) {
    return labelStack.map((label)=>(0, _utils.sanitizeLabelStackName)(label.name)).join('/');
}
function labelStackToSegment(labelStack) {
    let segmentIndex = -1;
    for(let i = labelStack.length - 1; i >= 0; i--)if (labelStack[i].segmentId) {
        segmentIndex = i;
        break;
    }
    return labelStack.slice(0, segmentIndex + 1).map((label)=>(0, _utils.sanitizeLabelStackName)(label.name)).join('/');
}
function traverseFiber(fiber) {
    let segment = 'unknown';
    let labelStackString = 'unknown';
    let currentFiber = fiber;
    while(currentFiber){
        if (currentFiber.type) {
            const componentName = currentFiber.type.displayName || currentFiber.type.name;
            if (componentName === 'UFOSegment' || componentName === 'UFOLabel') {
                const labelStack = labelStackFromFiber(currentFiber);
                labelStackString = labelStackToString(labelStack) || 'unknown';
                segment = labelStackToSegment(labelStack) || 'unknown';
                break;
            }
        }
        currentFiber = currentFiber.return;
    }
    return {
        segment,
        labelStack: labelStackString
    };
}
function getLabelStacks(element) {
    const reactFiberKey = Object.keys(element).find((key)=>key.startsWith('__reactFiber$'));
    if (!reactFiberKey) return null;
    const fiber = element[reactFiberKey];
    return fiber ? traverseFiber(fiber) : null;
}
const SUPPORTED_ABORT_EVENT_TARGET_TYPES = new Set([
    'scroll-container',
    'scroll',
    'wheel'
]);
function isAbortEventTargetSupported(type) {
    return SUPPORTED_ABORT_EVENT_TARGET_TYPES.has(type);
}
function getAbortEventTargetElement(target) {
    if (target instanceof HTMLElement) return target;
    if (target instanceof Document) {
        const scrollingElement = target.scrollingElement;
        if (scrollingElement instanceof HTMLElement) return scrollingElement;
        var _target_documentElement;
        return (_target_documentElement = target.documentElement) !== null && _target_documentElement !== void 0 ? _target_documentElement : null;
    }
    if (target instanceof Window) {
        const scrollingElement = target.document.scrollingElement;
        if (scrollingElement instanceof HTMLElement) return scrollingElement;
        var _target_document_documentElement;
        return (_target_document_documentElement = target.document.documentElement) !== null && _target_document_documentElement !== void 0 ? _target_document_documentElement : null;
    }
    if (target instanceof Node) return target.parentElement;
    return null;
}

},{"@swc/helpers/_/_object_spread":"9gdrV","@atlaskit/platform-feature-flags":"8rD2i","../../config":"bx9i6","../../create-payload/common/utils":"bqJei","../../interaction-metrics":"j4w6h","../vc-observer/observers/ssr-placeholders":"5zEx5","./entries-timeline":"lHMnc","./get-element-name":"Vvvbg","./metric-calculator/fy25_03":"8M5az","./metric-calculator/fy26_04":"gVzYn","./metric-calculator/utils/get-viewport-height":"5uR3m","./metric-calculator/utils/get-viewport-width":"dh0qc","./metric-calculator/vc-next":"lNIk3","./raw-data-handler":"kT5FO","./viewport-observer":"0ziSR","./window-event-observer":"kVl4j","@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"lHMnc":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>EntriesTimeline);
class EntriesTimeline {
    push(entry) {
        this.unorderedEntries.push(entry);
        this.sortedEntriesCache.clear();
    }
    getCacheKey(start, stop) {
        return `${start !== null && start !== void 0 ? start : 'null'}_${stop !== null && stop !== void 0 ? stop : 'null'}`;
    }
    getOrderedEntries({ start, stop }) {
        var _this_sortedEntriesCache_get;
        const cacheKey = this.getCacheKey(start, stop);
        const cachedSortedEntries = (_this_sortedEntriesCache_get = this.sortedEntriesCache.get(cacheKey)) === null || _this_sortedEntriesCache_get === void 0 ? void 0 : _this_sortedEntriesCache_get.deref();
        if (cachedSortedEntries) return cachedSortedEntries;
        const filteredEntries = this.unorderedEntries.filter((e)=>e.time >= (start !== null && start !== void 0 ? start : 0) && e.time <= (stop !== null && stop !== void 0 ? stop : performance.now()));
        const sortedEntries = filteredEntries.sort((a, b)=>a.time - b.time);
        this.sortedEntriesCache.set(cacheKey, new WeakRef(sortedEntries));
        return sortedEntries;
    }
    clear() {
        this.unorderedEntries = [];
        this.sortedEntriesCache.clear();
    }
    constructor(){
        this.unorderedEntries = [];
        this.sortedEntriesCache = new Map();
    }
}

},{"@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"Vvvbg":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
const nameCache = new WeakMap();
function getElementName(selectorConfig, element) {
    if (!(element instanceof HTMLElement)) {
        let elementInstance = 'Unknown';
        // Types of elements according to LLM
        if (element instanceof Text) elementInstance = 'Text';
        else if (element instanceof DocumentFragment) elementInstance = 'DocumentFragment';
        else if (element instanceof Document) elementInstance = 'Document';
        else if (element instanceof Comment) elementInstance = 'Comment';
        else if (element instanceof ProcessingInstruction) elementInstance = 'ProcessingInstruction';
        else if (element instanceof Attr) elementInstance = 'Attr';
        else if (element instanceof CDATASection) elementInstance = 'CDATASection';
        if (element.parentElement && element.parentElement instanceof HTMLElement) {
            const parentElementSelector = getElementName(selectorConfig, element.parentElement);
            return `${parentElementSelector} > ${elementInstance}`;
        } else return elementInstance;
    }
    const cachedName = nameCache.get(element);
    if (cachedName) return cachedName;
    // Get the tag name of the element.
    const tagName = element.localName;
    const encodeValue = (s)=>{
        if (typeof encodeURIComponent !== 'function') return '';
        try {
            return encodeURIComponent(s);
        } catch (e) {
            return 'malformed_value';
        }
    };
    // Helper function to construct attribute selectors.
    const getAttributeSelector = (attributeName, prefix = '')=>{
        if (element && typeof element.getAttribute !== 'function') return '';
        const attrValue = element.getAttribute(attributeName);
        if (!attrValue) return '';
        const encondedAttrValue = encodeValue(attrValue);
        return `${prefix}[${attributeName}="${encondedAttrValue}"]`;
    };
    // Construct the data-vc attribute selector if specified in the config.
    const dataVC = selectorConfig.dataVC !== false ? getAttributeSelector('data-vc') : '';
    // Construct the ID selector if specified in the config and the element has an ID.
    const id = selectorConfig.id && element.id ? `#${encodeValue(element.id)}` : '';
    // Construct the test ID selector if specified in the config.
    const testId = selectorConfig.testId ? getAttributeSelector('data-testid') || getAttributeSelector('data-test-id') : '';
    // Construct the role selector if specified in the config.
    const role = selectorConfig.role ? getAttributeSelector('role') : '';
    const classNames = Array.from(element.classList).map(encodeValue).join('.');
    // Construct the class list selector if specified in the config.
    const classList = selectorConfig.className && classNames ? `.${classNames}` : '';
    // Combine primary attribute selectors (id, testId, role) into a single string.
    const primaryAttributes = [
        id,
        testId,
        role
    ].filter(Boolean).join('');
    // Use dataVC if available, otherwise use the primary attributes.
    const attributes = dataVC || primaryAttributes;
    // If no attributes or class list, recursively get the parent's name.
    if (!attributes && !classList) {
        const parentName = element.parentElement ? getElementName(selectorConfig, element.parentElement) : 'unknown';
        return `${parentName} > ${tagName}`;
    }
    // Return the final constructed name: tagName + attributes or classList.
    const name = `${tagName}${attributes || classList}`;
    nameCache.set(element, name);
    return name;
}
exports.default = getElementName;

},{"@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"8M5az":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>VCCalculator_FY25_03);
var _platformFeatureFlags = require("@atlaskit/platform-feature-flags");
var _expVal = require("../../../expVal");
var _isDndStyleMutation = require("../../../vc-observer/observers/non-visual-styles/is-dnd-style-mutation");
var _abstractBaseVcCalculator = require("../abstract-base-vc-calculator");
var _abstractBaseVcCalculatorDefault = parcelHelpers.interopDefault(_abstractBaseVcCalculator);
var _constants = require("../utils/constants");
var _isViewportEntryData = require("../utils/is-viewport-entry-data");
var _isViewportEntryDataDefault = parcelHelpers.interopDefault(_isViewportEntryData);
const ABORTING_WINDOW_EVENT = [
    'wheel',
    'scroll',
    'keydown',
    'resize'
];
const REVISION_NO = 'fy25.03';
const getConsideredEntryTypes = (include3p, excludeSmartAnswersInSearch)=>{
    const entryTypes = [
        'mutation:child-element',
        'mutation:element',
        'mutation:attribute',
        'layout-shift',
        'layout-shift:same-rect',
        'window:event'
    ];
    // Only include third-party elements in TTVC calculation when explicitly requested.
    // GenAI elements intentionally remain excluded from core TTVC; a server-side metric variant
    // can derive "including GenAI" from the emitted metricWindows payload.
    if (include3p) {
        entryTypes.push('mutation:third-party-element');
        entryTypes.push('mutation:third-party-attribute');
    }
    if (!excludeSmartAnswersInSearch) {
        entryTypes.push('mutation:smart-answers-element');
        entryTypes.push('mutation:smart-answers-attribute');
    }
    entryTypes.push('mutation:media');
    // Still included as part of TTVC v3
    entryTypes.push('mutation:attribute:non-visual-input-name');
    return entryTypes;
};
class VCCalculator_FY25_03 extends (0, _abstractBaseVcCalculatorDefault.default) {
    isEntryIncluded(entry, include3p, excludeSmartAnswersInSearch) {
        if (!getConsideredEntryTypes(include3p, excludeSmartAnswersInSearch).includes(entry.data.type)) return false;
        if (entry.data.type === 'mutation:attribute:framework-routing') return false;
        if (entry.data.type === 'mutation:media' && (0, _platformFeatureFlags.fg)('media-perf-uplift-mutation-fix')) {
            const entryData = entry.data;
            const attributeName = entryData.attributeName;
            if (attributeName && (/data-(test|file|context)-\S+/g.test(attributeName) || attributeName === 'data-cursor' || attributeName === 'alt' || (attributeName === 'localid' || attributeName === 'contenteditable' || attributeName === 'anchor-name') && (0, _expVal.expVal)('platform_editor_media_vc_fixes', 'isEnabled', false))) return false;
            // special case for style attribute to ignore only anchor-name changes
            if ((0, _expVal.expVal)('platform_editor_media_vc_fixes', 'isEnabled', false)) {
                if ((0, _isDndStyleMutation.containsDnDMutationInStyle)({
                    attributeName: entryData.attributeName,
                    oldValue: entryData.oldValue,
                    newValue: entryData.newValue
                })) return false;
            }
        }
        if (entry.data.type === 'mutation:attribute') {
            const entryData = entry.data;
            const attributeName = entryData.attributeName;
            if (!attributeName || (0, _constants.KNOWN_ATTRIBUTES_THAT_DOES_NOT_CAUSE_LAYOUT_SHIFTS).includes(attributeName)) return false;
            if (attributeName.startsWith('data-test') || (0, _constants.NON_VISUAL_ARIA_ATTRIBUTES).includes(attributeName) || (0, _constants.THIRD_PARTY_BROWSER_EXTENSION_ATTRIBUTES).includes(attributeName) && (0, _platformFeatureFlags.fg)('platform_ufo_exclude_3p_extensions_from_ttvc') || (0, _constants.DARK_READER_BROWSER_EXTENSION_ATTRIBUTES).includes(attributeName) && (0, _platformFeatureFlags.fg)('platform_ufo_exclude_dark_reader_extension') || (0, _constants.MORE_THIRD_PARTY_EXTENSION_ATTRIBUTES).includes(attributeName) && (0, _platformFeatureFlags.fg)('platform_ufo_exclude_fdprocessedid_attribute')) return false;
            return true;
        }
        if ((0, _isViewportEntryDataDefault.default)(entry.data) && !entry.data.visible) return false;
        return true;
    }
    getVCCleanStatus(filteredEntries) {
        let dirtyReason = '';
        let abortTimestamp = -1;
        const hasAbortEvent = filteredEntries.some((entry)=>{
            if (entry.data.type === 'window:event') {
                const data = entry.data;
                const eventType = data.eventType;
                if (ABORTING_WINDOW_EVENT.includes(eventType)) {
                    dirtyReason = eventType === 'keydown' ? 'keypress' : eventType;
                    abortTimestamp = Math.round(entry.time);
                    return true;
                }
            }
            return false;
        });
        if (hasAbortEvent && dirtyReason) return {
            isVCClean: false,
            dirtyReason,
            abortTimestamp
        };
        return {
            isVCClean: true
        };
    }
    constructor(revisionNo){
        super(revisionNo !== null && revisionNo !== void 0 ? revisionNo : REVISION_NO);
    }
}

},{"@atlaskit/platform-feature-flags":"8rD2i","../../../expVal":"gVXAt","../../../vc-observer/observers/non-visual-styles/is-dnd-style-mutation":"1QpRK","../abstract-base-vc-calculator":"bh5ZZ","../utils/constants":"9D0J0","../utils/is-viewport-entry-data":"4EC3r","@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"gVXAt":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "expVal", ()=>expVal);
var _featureGateJsClient = require("@atlaskit/feature-gate-js-client");
var _featureGateJsClientDefault = parcelHelpers.interopDefault(_featureGateJsClient);
var _featureFlagsAccessed = require("../feature-flags-accessed");
const expVal = (experimentName, experimentParam, defaultValue)=>{
    // If client is not initialized, we return the default value
    if (!(0, _featureGateJsClientDefault.default).initializeCompleted()) return defaultValue;
    // eslint-disable-next-line @atlaskit/platform/use-recommended-utils
    const experimentValue = (0, _featureGateJsClientDefault.default).getExperimentValue(experimentName, experimentParam, defaultValue);
    (0, _featureFlagsAccessed.addFeatureFlagAccessed)(`${experimentName}:${experimentParam}`, experimentValue);
    return experimentValue;
};

},{"@atlaskit/feature-gate-js-client":"27dQF","../feature-flags-accessed":"cXQ8g","@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"1QpRK":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
// eslint-disable-next-line @atlaskit/volt-strict-mode/no-multiple-exports
parcelHelpers.export(exports, "isDnDStyleMutation", ()=>isDnDStyleMutation);
parcelHelpers.export(exports, "containsDnDMutationInStyle", ()=>containsDnDMutationInStyle);
const isDnDStyleChange = (style)=>{
    return style.startsWith('anchor-name: --node-anchor');
};
const parseStyleSet = (style)=>{
    if (!style) return null;
    const set = new Set();
    for (const part of style.split(';')){
        const t = part.trim();
        if (t) set.add(t);
    }
    return set;
};
/**
 * Checks if a mutation record represents a style change from Editor's
 * drag and drop feature, which don't cause visual shifts.
 * This should be removed once DnD has been fixed.
 * @param mutation - The mutation record to check
 * @returns boolean indicating if this is a DnD style mutation
 */ function isDnDStyleMutation({ target, attributeName, oldValue, newValue }) {
    if (!(target instanceof Element)) return false;
    return containsDnDMutationInStyle({
        attributeName,
        oldValue,
        newValue
    });
}
function containsDnDMutationInStyle({ attributeName, oldValue, newValue }) {
    if (attributeName !== 'style') return false;
    const oldStyles = parseStyleSet(oldValue);
    const newStyles = parseStyleSet(newValue);
    let isDnDMutation = false;
    for (const s of oldStyles !== null && oldStyles !== void 0 ? oldStyles : [])if (!(newStyles === null || newStyles === void 0 ? void 0 : newStyles.has(s))) {
        if (!isDnDStyleChange(s)) return false;
        isDnDMutation = true;
    }
    for (const s of newStyles !== null && newStyles !== void 0 ? newStyles : [])if (!(oldStyles === null || oldStyles === void 0 ? void 0 : oldStyles.has(s))) {
        if (!isDnDStyleChange(s)) return false;
        isDnDMutation = true;
    }
    return isDnDMutation;
}
exports.default = isDnDStyleMutation;

},{"@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"bh5ZZ":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>AbstractVCCalculatorBase);
var _objectSpread = require("@swc/helpers/_/_object_spread");
var _objectSpreadProps = require("@swc/helpers/_/_object_spread_props");
var _percentileCalc = require("./percentile-calc");
var _detectLayoutShiftCause = require("./utils/detect-layout-shift-cause");
var _getViewportHeight = require("./utils/get-viewport-height");
var _getViewportHeightDefault = parcelHelpers.interopDefault(_getViewportHeight);
var _getViewportWidth = require("./utils/get-viewport-width");
var _getViewportWidthDefault = parcelHelpers.interopDefault(_getViewportWidth);
var _isViewportEntryData = require("./utils/is-viewport-entry-data");
var _isViewportEntryDataDefault = parcelHelpers.interopDefault(_isViewportEntryData);
// Helper function for reporting ratios
function roundDecimal(value, decimals = 3) {
    const factor = Math.pow(10, decimals);
    return Math.round(value * factor) / factor;
}
class AbstractVCCalculatorBase {
    filterViewportEntries(entries) {
        return entries.filter((entry)=>{
            return 'rect' in entry.data;
        });
    }
    /**
	 * Calculate ratios for each element based on their viewport coverage.
	 */ calculateRatios(filteredEntries) {
        const ratios = {};
        const viewportWidth = (0, _getViewportWidthDefault.default)();
        const viewportHeight = (0, _getViewportHeightDefault.default)();
        const totalViewportArea = viewportWidth * viewportHeight;
        if (totalViewportArea === 0) return ratios;
        const elementRects = new Map();
        for (const entry of filteredEntries)if ('rect' in entry.data) {
            const viewportEntry = entry.data;
            elementRects.set(viewportEntry.elementName, viewportEntry.rect);
        }
        for (const [elementName, rect] of elementRects){
            const elementArea = rect.width * rect.height;
            ratios[elementName] = roundDecimal(elementArea / totalViewportArea);
        }
        return ratios;
    }
    getLabelStacks(filteredEntries, isPostInteraction) {
        const labelStacks = {};
        for (const entry of filteredEntries)if ((0, _isViewportEntryDataDefault.default)(entry.data) && entry.data.labelStacks) {
            if (isPostInteraction) labelStacks[entry.data.elementName] = {
                segment: entry.data.labelStacks.segment,
                labelStack: entry.data.labelStacks.labelStack
            };
            else labelStacks[entry.data.elementName] = entry.data.labelStacks.labelStack;
        }
        return labelStacks;
    }
    async calculateWithDebugInfo(filteredEntries, startTime, stopTime, isPostInteraction, isVCClean, interactionType, isPageVisible, interactionId, dirtyReason, allEntries, include3p, excludeSmartAnswersInSearch, interactionAbortReason, includeSSRRatio, reportLayoutShiftOffenders) {
        var _window, _window1, _window2, _window3, _window4;
        const percentiles = [
            25,
            50,
            75,
            80,
            85,
            90,
            95,
            98,
            99,
            100
        ];
        const viewportEntries = this.filterViewportEntries(filteredEntries);
        const { entries: vcLogs, speedIndex } = await (0, _percentileCalc.calculateTTVCPercentilesWithDebugInfo)({
            viewport: {
                width: (0, _getViewportWidthDefault.default)(),
                height: (0, _getViewportHeightDefault.default)()
            },
            startTime,
            stopTime,
            orderedEntries: viewportEntries
        });
        const vcDetails = {};
        let percentileIndex = 0;
        const entryDataBuffer = new Set();
        let ssrRatio = -1;
        let layoutShiftInsights = null;
        let previousViewportPercentage = 0;
        if (vcLogs) for (const entry of vcLogs){
            const { time, viewportPercentage, entries } = entry;
            if (includeSSRRatio && ssrRatio === -1 && entries.some((e)=>e.elementName === 'SSR')) ssrRatio = viewportPercentage;
            // Only process entries if we haven't reached all percentiles
            if (percentileIndex >= percentiles.length) break;
            // Check if this entry matches any checkpoint percentiles
            if (viewportPercentage >= percentiles[percentileIndex]) {
                const elementNames = [
                    ...new Set(entries.map((e)=>e.elementName))
                ];
                // Process all matching percentiles in one go
                while(percentileIndex < percentiles.length && viewportPercentage >= percentiles[percentileIndex]){
                    vcDetails[`${percentiles[percentileIndex]}`] = {
                        t: Math.round(time),
                        e: elementNames
                    };
                    if (reportLayoutShiftOffenders && percentiles[percentileIndex] === 90 && entries.some((e)=>e.type === 'layout-shift')) {
                        const layoutShiftEntries = entries.filter((e)=>e.type === 'layout-shift');
                        layoutShiftInsights = {
                            layoutShiftOffendersResult: (0, _detectLayoutShiftCause.detectLayoutShiftCause)({
                                viewportEntries: viewportEntries,
                                layoutShiftEntries,
                                time,
                                startTime
                            }),
                            layoutShiftEntriesCount: layoutShiftEntries.length,
                            layoutShiftImpact: viewportPercentage - previousViewportPercentage
                        };
                    }
                    percentileIndex++;
                }
                // Clear buffer after processing all matching percentiles
                entryDataBuffer.clear();
            } else // Only add to buffer if we haven't reached all percentiles
            entries.forEach((e)=>entryDataBuffer.add(e));
            previousViewportPercentage = viewportPercentage;
        }
        // Fill in any missing percentiles with the last known values
        let previousResult = {
            t: 0,
            e: []
        };
        for(let i = 0; i < percentiles.length; i++){
            const percentile = percentiles[i];
            if (!(percentile in vcDetails)) vcDetails[`${percentile}`] = previousResult;
            else previousResult = vcDetails[`${percentile}`];
        }
        let enhancedVcLogs = vcLogs ? vcLogs.map((log)=>(0, _objectSpreadProps._)((0, _objectSpread._)({}, log), {
                entries: log.entries.map((entry)=>{
                    var _entry_rect, _entry_previousRect;
                    return (0, _objectSpreadProps._)((0, _objectSpread._)({}, entry), {
                        rect: (_entry_rect = entry.rect) === null || _entry_rect === void 0 ? void 0 : _entry_rect.toJSON(),
                        previousRect: (_entry_previousRect = entry.previousRect) === null || _entry_previousRect === void 0 ? void 0 : _entry_previousRect.toJSON()
                    });
                }),
                viewportPercentage: log.viewportPercentage
            })) : [];
        // If 3p metric enabled - calculate the debug details
        const shouldCalculate3p = include3p;
        // Only calculate enhanced debug details if devtool callbacks exist
        const shouldCalculateDebugDetails = !isPostInteraction && (typeof ((_window = window) === null || _window === void 0 ? void 0 : _window.__ufo_devtool_onVCRevisionReady__) === 'function' || typeof ((_window1 = window) === null || _window1 === void 0 ? void 0 : _window1.__on_ufo_vc_debug_data_ready) === 'function' || typeof ((_window2 = window) === null || _window2 === void 0 ? void 0 : _window2.__ufo_devtool_vc_3p_debug_data) === 'function');
        if (shouldCalculateDebugDetails && allEntries && vcLogs) {
            // Pre-sort vcLogs by time for efficient lookups
            const sortedVcLogs = [
                ...vcLogs
            ].sort((a, b)=>a.time - b.time);
            // Pre-calculate max viewport percentage up to each time for efficient lookups
            const maxViewportPercentageAtTime = new Map();
            let maxSoFar = 0;
            for (const log of sortedVcLogs)if (log.viewportPercentage !== null) {
                maxSoFar = Math.max(maxSoFar, log.viewportPercentage);
                maxViewportPercentageAtTime.set(log.time, maxSoFar);
            }
            // Helper function to find the biggest previous viewport percentage
            const getBiggestPreviousViewportPercentage = (targetTime)=>{
                // Binary search for the largest time <= targetTime
                let left = 0;
                let right = sortedVcLogs.length - 1;
                let result = -1;
                while(left <= right){
                    const mid = Math.floor((left + right) / 2);
                    if (sortedVcLogs[mid].time <= targetTime) {
                        result = mid;
                        left = mid + 1;
                    } else right = mid - 1;
                }
                return result >= 0 ? maxViewportPercentageAtTime.get(sortedVcLogs[result].time) || null : null;
            };
            // Group ignored entries by timestamp
            const ignoredEntriesByTime = new Map();
            for (const entry of allEntries)if ('rect' in entry.data && !this.isEntryIncluded(entry, include3p, excludeSmartAnswersInSearch)) {
                var _viewportData_rect, _viewportData_previousRect, _ignoredEntriesByTime_get;
                const viewportData = entry.data;
                const timestamp = Math.round(entry.time);
                if (!ignoredEntriesByTime.has(timestamp)) ignoredEntriesByTime.set(timestamp, []);
                (_ignoredEntriesByTime_get = ignoredEntriesByTime.get(timestamp)) === null || _ignoredEntriesByTime_get === void 0 ? void 0 : _ignoredEntriesByTime_get.push((0, _objectSpreadProps._)((0, _objectSpread._)({}, viewportData), {
                    rect: (_viewportData_rect = viewportData.rect) === null || _viewportData_rect === void 0 ? void 0 : _viewportData_rect.toJSON(),
                    previousRect: (_viewportData_previousRect = viewportData.previousRect) === null || _viewportData_previousRect === void 0 ? void 0 : _viewportData_previousRect.toJSON(),
                    ignoreReason: viewportData.visible ? viewportData.type : 'not-visible'
                }));
            }
            // Add ignored entries to vcLogs
            const additionalVcLogs = [];
            for (const [timestamp, ignoredEntries] of ignoredEntriesByTime)if (ignoredEntries.length > 0) {
                const viewportPercentage = getBiggestPreviousViewportPercentage(timestamp);
                additionalVcLogs.push({
                    time: timestamp,
                    viewportPercentage,
                    entries: ignoredEntries
                });
            }
            // Combine and sort all vcLogs
            enhancedVcLogs = [
                ...enhancedVcLogs,
                ...additionalVcLogs
            ].sort((a, b)=>a.time - b.time);
        }
        // Only create debug details if callbacks exist
        let v3RevisionDebugDetails = null;
        if (shouldCalculateDebugDetails) v3RevisionDebugDetails = {
            revision: this.revisionNo,
            isClean: isVCClean && !interactionAbortReason && isPageVisible,
            abortReason: !isPageVisible ? 'browser_backgrounded' : dirtyReason !== null && dirtyReason !== void 0 ? dirtyReason : interactionAbortReason,
            vcLogs: enhancedVcLogs,
            interactionId,
            interactionType
        };
        // Handle devtool callback
        if (v3RevisionDebugDetails && typeof ((_window3 = window) === null || _window3 === void 0 ? void 0 : _window3.__ufo_devtool_onVCRevisionReady__) === 'function' && !include3p) try {
            var _window___ufo_devtool_onVCRevisionReady__, _window5;
            (_window5 = window) === null || _window5 === void 0 ? void 0 : (_window___ufo_devtool_onVCRevisionReady__ = _window5.__ufo_devtool_onVCRevisionReady__) === null || _window___ufo_devtool_onVCRevisionReady__ === void 0 ? void 0 : _window___ufo_devtool_onVCRevisionReady__.call(_window5, v3RevisionDebugDetails);
        } catch (e) {
            // if any error communicating with devtool, we don't want to break the app
            // eslint-disable-next-line no-console
            console.error('Error in onVCRevisionReady', e);
        }
        if (v3RevisionDebugDetails && typeof ((_window4 = window) === null || _window4 === void 0 ? void 0 : _window4.__on_ufo_vc_debug_data_ready) === 'function' && !include3p) try {
            var _window___on_ufo_vc_debug_data_ready, _window6;
            (_window6 = window) === null || _window6 === void 0 ? void 0 : (_window___on_ufo_vc_debug_data_ready = _window6.__on_ufo_vc_debug_data_ready) === null || _window___on_ufo_vc_debug_data_ready === void 0 ? void 0 : _window___on_ufo_vc_debug_data_ready.call(_window6, v3RevisionDebugDetails);
        } catch (e) {
            // eslint-disable-next-line no-console
            console.error('Error in onVCRevisionReady', e);
        }
        if (v3RevisionDebugDetails && shouldCalculate3p) try {
            // Log vc details with 3p for debugging
            window.__ufo_devtool_vc_3p_debug_data = v3RevisionDebugDetails;
        } catch (e) {
            // eslint-disable-next-line no-console
            console.error('Error in 3pDebugData', e);
        }
        return {
            vcDetails,
            ssrRatio,
            speedIndex,
            VC90layoutShiftInsights: layoutShiftInsights
        };
    }
    async calculate({ startTime, stopTime, orderedEntries, interactionId, isPostInteraction, include3p, excludeSmartAnswersInSearch, includeSSRRatio, interactionType, isPageVisible, interactionAbortReason, reportLayoutShiftOffenders }) {
        var _vcDetails_90;
        const filteredEntries = orderedEntries.filter((entry)=>{
            return this.isEntryIncluded(entry, include3p, excludeSmartAnswersInSearch);
        });
        let isVCClean;
        let dirtyReason;
        const getVCCleanStatusResult = this.getVCCleanStatus(filteredEntries);
        isVCClean = getVCCleanStatusResult.isVCClean;
        dirtyReason = getVCCleanStatusResult.dirtyReason;
        if (!isVCClean) return {
            revision: this.revisionNo,
            'metric:vc90': null,
            clean: false,
            abortReason: dirtyReason,
            abortTimestamp: getVCCleanStatusResult.abortTimestamp
        };
        const { vcDetails, ssrRatio, speedIndex, VC90layoutShiftInsights } = await this.calculateWithDebugInfo(filteredEntries, startTime, stopTime, isPostInteraction, isVCClean, interactionType, isPageVisible, interactionId, dirtyReason, orderedEntries, include3p, excludeSmartAnswersInSearch, interactionAbortReason, includeSSRRatio, reportLayoutShiftOffenders);
        let layoutShiftInsightsPayload;
        if (VC90layoutShiftInsights !== null && reportLayoutShiftOffenders) {
            const { layoutShiftOffendersResult, layoutShiftEntriesCount, layoutShiftImpact } = VC90layoutShiftInsights;
            var _layoutShiftOffendersResult_layoutShiftVariables_allMovedSameWay, _layoutShiftOffendersResult_layoutShiftVariables_allMovedSameAmount, _layoutShiftOffendersResult_layoutShiftOffenders_length;
            layoutShiftInsightsPayload = {
                impact: layoutShiftImpact,
                sources: layoutShiftEntriesCount !== null && layoutShiftEntriesCount !== void 0 ? layoutShiftEntriesCount : 0,
                same: {
                    dir: (_layoutShiftOffendersResult_layoutShiftVariables_allMovedSameWay = layoutShiftOffendersResult === null || layoutShiftOffendersResult === void 0 ? void 0 : layoutShiftOffendersResult.layoutShiftVariables.allMovedSameWay) !== null && _layoutShiftOffendersResult_layoutShiftVariables_allMovedSameWay !== void 0 ? _layoutShiftOffendersResult_layoutShiftVariables_allMovedSameWay : false,
                    dist: (_layoutShiftOffendersResult_layoutShiftVariables_allMovedSameAmount = layoutShiftOffendersResult === null || layoutShiftOffendersResult === void 0 ? void 0 : layoutShiftOffendersResult.layoutShiftVariables.allMovedSameAmount) !== null && _layoutShiftOffendersResult_layoutShiftVariables_allMovedSameAmount !== void 0 ? _layoutShiftOffendersResult_layoutShiftVariables_allMovedSameAmount : false
                },
                total_mut: (_layoutShiftOffendersResult_layoutShiftOffenders_length = layoutShiftOffendersResult === null || layoutShiftOffendersResult === void 0 ? void 0 : layoutShiftOffendersResult.layoutShiftOffenders.length) !== null && _layoutShiftOffendersResult_layoutShiftOffenders_length !== void 0 ? _layoutShiftOffendersResult_layoutShiftOffenders_length : 0,
                mut: layoutShiftOffendersResult === null || layoutShiftOffendersResult === void 0 ? void 0 : layoutShiftOffendersResult.layoutShiftOffenders.sort((a, b)=>Math.abs(a.distanceToLS) - Math.abs(b.distanceToLS)).slice(0, 5).map((offender)=>({
                        e: offender.offender,
                        size: -1,
                        attr: {
                            t_before: offender.happenedBefore,
                            t_distance: offender.distanceToLS,
                            p_above: offender.isAbove,
                            p_left: offender.isLeft,
                            p_right: offender.isRight,
                            p_h_overlap: offender.hasHorizontalOverlap,
                            p_v_overlap: offender.hasVerticalOverlap,
                            p_same_offset: offender.matchesLayoutShiftDelta ? 'all' : 'none'
                        }
                    }))
            };
        }
        var _vcDetails_90_t;
        const result = {
            revision: this.revisionNo,
            clean: true,
            'metric:vc90': (_vcDetails_90_t = vcDetails === null || vcDetails === void 0 ? void 0 : (_vcDetails_90 = vcDetails['90']) === null || _vcDetails_90 === void 0 ? void 0 : _vcDetails_90.t) !== null && _vcDetails_90_t !== void 0 ? _vcDetails_90_t : null,
            vcDetails: vcDetails !== null && vcDetails !== void 0 ? vcDetails : undefined,
            'vc90:ls': layoutShiftInsightsPayload !== null && layoutShiftInsightsPayload !== void 0 ? layoutShiftInsightsPayload : undefined
        };
        result.ratios = this.calculateRatios(filteredEntries);
        if (ssrRatio !== -1) result.ssrRatio = ssrRatio;
        // speedIndex is only included in the result when it has a meaningful value (> 0)
        if (speedIndex > 0) result.speedIndex = speedIndex;
        result.labelStacks = this.getLabelStacks(filteredEntries, isPostInteraction);
        return result;
    }
    constructor(revisionNo){
        this.revisionNo = revisionNo;
    }
}

},{"@swc/helpers/_/_object_spread":"9gdrV","@swc/helpers/_/_object_spread_props":"kANqQ","./percentile-calc":"40BvS","./utils/detect-layout-shift-cause":"fkNHj","./utils/get-viewport-height":"5uR3m","./utils/get-viewport-width":"dh0qc","./utils/is-viewport-entry-data":"4EC3r","@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"40BvS":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "calculateTTVCPercentiles", ()=>(0, _canvasHeatmapDefault.default));
parcelHelpers.export(exports, "calculateTTVCPercentilesWithDebugInfo", ()=>(0, _canvasHeatmap.calculateTTVCPercentilesWithDebugInfo));
var _canvasHeatmap = require("./canvas-heatmap");
var _canvasHeatmapDefault = parcelHelpers.interopDefault(_canvasHeatmap);

},{"./canvas-heatmap":"hH3va","@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"hH3va":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
// eslint-disable-next-line @atlaskit/volt-strict-mode/no-multiple-exports
parcelHelpers.export(exports, "calculatePercentiles", ()=>calculatePercentiles);
// eslint-disable-next-line @atlaskit/volt-strict-mode/no-multiple-exports
parcelHelpers.export(exports, "calculatePercentilesWithDebugInfo", ()=>calculatePercentilesWithDebugInfo);
// eslint-disable-next-line @atlaskit/volt-strict-mode/no-multiple-exports
parcelHelpers.export(exports, "calculateTTVCPercentilesWithDebugInfo", ()=>calculateTTVCPercentilesWithDebugInfo);
var _platformFeatureFlags = require("@atlaskit/platform-feature-flags");
var _canvasPixel = require("./canvas-pixel");
async function calculateTTVCPercentiles({ viewport, orderedEntries, percentiles, startTime }) {
    const canvas = new (0, _canvasPixel.ViewportCanvas)(viewport, (0, _platformFeatureFlags.fg)('platform_ufo_canvas_heatmap_full_precision') ? 1 : 0.25);
    const elementMap = new Map();
    for (const entry of orderedEntries){
        if (!('rect' in entry.data)) continue;
        const rect = entry.data.rect;
        const elementName = entry.data.elementName;
        canvas.drawRect(rect, entry.time);
        if (!elementMap.has(entry.time)) elementMap.set(entry.time, new Set());
        elementMap.get(entry.time).add(elementName);
    }
    // Get pixel counts
    const timePixelCounts = await canvas.getPixelCounts();
    const canvasDimenstions = canvas.getScaledDimensions();
    const totalPixels = canvasDimenstions.width * canvasDimenstions.height;
    return calculatePercentiles(timePixelCounts, elementMap, percentiles, totalPixels, startTime);
}
async function calculateTTVCPercentilesWithDebugInfo({ viewport, orderedEntries, startTime }) {
    const canvas = new (0, _canvasPixel.ViewportCanvas)(viewport, (0, _platformFeatureFlags.fg)('platform_ufo_canvas_heatmap_full_precision') ? 1 : 0.25);
    const elementMap = new Map();
    for (const entry of orderedEntries){
        if (!('rect' in entry.data)) continue;
        const rect = entry.data.rect;
        canvas.drawRect(rect, entry.time);
        if (!elementMap.has(entry.time)) elementMap.set(entry.time, []);
        elementMap.get(entry.time).push(entry.data);
    }
    // Get pixel counts
    const timePixelCounts = await canvas.getPixelCounts();
    const canvasDimensions = canvas.getScaledDimensions();
    const totalPixels = canvasDimensions.width * canvasDimensions.height;
    return calculatePercentilesWithDebugInfo(timePixelCounts, elementMap, totalPixels, startTime);
}
exports.default = calculateTTVCPercentiles;
function calculatePercentiles(timePixelCounts, elementMap, unorderedPercentiles, totalPixels, startTime) {
    const results = {};
    let cumulativePixels = 0;
    const percentiles = unorderedPercentiles.sort((a, b)=>a - b);
    // Sort entries by timestamp for consistent processing
    const sortedEntries = Array.from(timePixelCounts.entries()).sort(([timeA], [timeB])=>Number(timeA) - Number(timeB));
    let percentileIndex = 0;
    let domElementsBuffer = new Set();
    for (const [time, pixelCount] of sortedEntries){
        cumulativePixels += pixelCount;
        const percentCovered = cumulativePixels / totalPixels * 100;
        const elementNames = elementMap.get(time) || new Set();
        elementNames.forEach((elName)=>domElementsBuffer.add(elName));
        let matchesAnyCheckpoints = false;
        while(percentileIndex < percentiles.length && percentCovered >= percentiles[percentileIndex]){
            results[`${percentiles[percentileIndex]}`] = {
                t: Math.round(Number(time - startTime)),
                e: Array.from(domElementsBuffer)
            };
            percentileIndex++;
            matchesAnyCheckpoints = true;
        }
        if (matchesAnyCheckpoints) domElementsBuffer.clear();
        if (percentileIndex >= percentiles.length) break;
    }
    let previousResult = {
        t: 0,
        e: []
    };
    for(let i = 0; i < percentiles.length; i++){
        const percentile = percentiles[i];
        if (!(percentile in results)) results[`${percentile}`] = previousResult;
        previousResult = results[`${percentile}`];
    }
    return results;
}
function calculatePercentilesWithDebugInfo(timePixelCounts, elementMap, totalPixels, startTime) {
    const entries = new Array(elementMap.size);
    let cumulativePixels = 0;
    let speedIndex = 0;
    let previousPercentCovered = 0;
    const sortedEntries = Array.from(timePixelCounts.entries()).sort(([timeA], [timeB])=>Number(timeA) - Number(timeB));
    for(let i = 0; i < sortedEntries.length; i++){
        const [time, pixelCount] = sortedEntries[i];
        cumulativePixels += pixelCount;
        const percentCovered = cumulativePixels / totalPixels * 100;
        const entryDatas = elementMap.get(time) || [];
        const relativeTime = Math.round(Number(time - startTime));
        entries[i] = {
            time: relativeTime,
            viewportPercentage: percentCovered,
            entries: Array.from(entryDatas)
        };
        // Speed index calculation: sum of (time × incremental viewport percentage)
        const ratioDelta = (percentCovered - previousPercentCovered) / 100;
        speedIndex += relativeTime * ratioDelta;
        previousPercentCovered = percentCovered;
    }
    return {
        entries,
        speedIndex: Math.round(speedIndex)
    };
}

},{"@atlaskit/platform-feature-flags":"8rD2i","./canvas-pixel":"46d38","@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"46d38":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
/**
 * Class responsible for managing a scaled canvas and tracking pixel drawing operations.
 * It uses either an OffscreenCanvas (if available) or a regular HTML Canvas for better performance
 * and maintains a mapping between colors and timestamps for pixel counting purposes.
 */ parcelHelpers.export(exports, "ViewportCanvas", ()=>ViewportCanvas);
/**
 * Converts a number into RGB components in such a way that they can be recombined
 * to form the original number using bitwise operations.
 * @param number - The input number to be split into RGB components.
 * @returns The RGB color string in the format "rgb(r, g, b)".
 */ // eslint-disable-next-line @atlaskit/volt-strict-mode/no-multiple-exports
parcelHelpers.export(exports, "getRGBComponents", ()=>getRGBComponents);
/**
 * Calculates the number of pixels drawn for each color in the image data.
 * @param imageData - The image data to analyze.
 * @param scaleFactor - The scale factor applied to the canvas.
 * @param arraySize - The amount of timestamps that were drawn in the viewport
 * @returns A Map containing color to pixel count mappings.
 */ // eslint-disable-next-line @atlaskit/volt-strict-mode/no-multiple-exports
parcelHelpers.export(exports, "calculateDrawnPixelsRaw", ()=>calculateDrawnPixelsRaw);
var _taskYield = require("../../utils/task-yield");
var _taskYieldDefault = parcelHelpers.interopDefault(_taskYield);
class ViewportCanvas {
    /**
	 * Creates a canvas instance, falling back to HTMLCanvasElement if OffscreenCanvas is not available
	 */ createCanvas(width, height) {
        if (typeof OffscreenCanvas !== 'undefined') return new OffscreenCanvas(width, height);
        const canvas = document.createElement('canvas');
        canvas.width = width;
        canvas.height = height;
        return canvas;
    }
    getScaledDimensions() {
        return {
            width: this.scaledWidth,
            height: this.scaledHeight
        };
    }
    /**
	 * Clears the entire canvas by removing all drawn content.
	 * @private
	 */ clear() {
        this.ctx.clearRect(0, 0, this.canvas.width, this.canvas.height);
    }
    /**
	 * Generates a unique RGB color from an incrementing counter.
	 * Uses a 24-bit color space (16,777,216 possible colors).
	 *
	 * @private
	 * @returns A unique RGB color string
	 *
	 * @example
	 * // Example bit operations for color 0x00FF8040:
	 * // Red:   (0x00FF8040 >> 16) & 0xFF = 0xFF = 255
	 * // Green: (0x00FF8040 >> 8) & 0xFF  = 0x80 = 128
	 * // Blue:   0x00FF8040 & 0xFF        = 0x40 = 64
	 */ generateColor() {
        // Wrap around at 16,777,215 (0x00FFFFFF) to stay within 24-bit color space
        const rgbColor = this.colorCounter++ % 0x00ffffff;
        return getRGBComponents(rgbColor);
    }
    /**
	 * Draws a rectangle on the canvas with a unique color and associates it with a timestamp.
	 * Each drawn rectangle gets a unique color which is mapped to the provided timestamp.
	 *
	 * @param rect - The rectangle dimensions to draw
	 * @param timestamp - The timestamp to associate with this drawing operation
	 */ drawRect(rect, timestamp) {
        const color = this.generateColor();
        this.colorTimeMap.set(color, timestamp);
        this.ctx.fillStyle = color;
        if (this.scaleFactor === 1) return this.ctx.fillRect(rect.x, rect.y, rect.width, rect.height);
        const scaledX = rect.x * this.scaleX;
        const scaledY = rect.y * this.scaleY;
        const scaledWidth = rect.width * this.scaleX;
        const scaledHeight = rect.height * this.scaleY;
        this.ctx.fillRect(Math.floor(scaledX), Math.ceil(scaledY), Math.max(scaledWidth, 1), Math.max(scaledHeight, 1));
    }
    /**
	 * Calculates the number of pixels drawn for each timestamp.
	 * This method:
	 * 1. Reads the pixel data from the canvas
	 * 2. Counts pixels of each unique color
	 * 3. Maps colors back to their timestamps
	 * 4. Adjusts counts based on the scale factor
	 *
	 * @returns A Map containing timestamp to pixel count mappings
	 */ async getPixelCounts() {
        const imageData = this.ctx.getImageData(0, 0, this.canvas.width, this.canvas.height);
        const timestampsAmount = this.colorTimeMap.size;
        const pixelCounts = await calculateDrawnPixelsRaw(imageData, this.scaleFactor, timestampsAmount);
        // Convert color counts to timestamp counts
        const timePixelCounts = new Map();
        for(let i = 0; i < pixelCounts.length; i++){
            const count = pixelCounts[i];
            if (typeof count !== 'number') continue;
            const color = i + 1;
            const rgbColor = getRGBComponents(color);
            const timestamp = this.colorTimeMap.get(rgbColor);
            if (timestamp !== undefined) timePixelCounts.set(timestamp, (timePixelCounts.get(timestamp) || 0) + count);
        }
        return timePixelCounts;
    }
    /**
	 * Creates a new ViewportCanvas instance.
	 * @param viewport - The dimensions of the viewport
	 * @param scaleFactor - Scale factor to apply to the canvas (default: 0.5)
	 * @throws {Error} If canvas context cannot be obtained
	 */ constructor(viewport, scaleFactor = 1){
        this.scaleFactor = scaleFactor;
        this.colorCounter = 1;
        this.colorTimeMap = new Map();
        const safeViewportWidth = Math.max(viewport.width, 1);
        const safeViewportHeight = Math.max(viewport.height, 1);
        // Calculate scaled dimensions
        this.scaledWidth = Math.max(Math.ceil(safeViewportWidth * scaleFactor), 1);
        this.scaledHeight = Math.max(Math.ceil(safeViewportHeight * scaleFactor), 1);
        this.scaleX = this.scaledWidth / safeViewportWidth;
        this.scaleY = this.scaledHeight / safeViewportHeight;
        // Initialize canvas with scaled dimensions
        this.canvas = this.createCanvas(this.scaledWidth, this.scaledHeight);
        const ctx = this.canvas.getContext('2d', {
            alpha: false,
            willReadFrequently: true,
            colorSpace: 'srgb'
        });
        if (!ctx) throw new Error('Could not get canvas context');
        this.ctx = ctx;
        this.ctx.globalCompositeOperation = 'source-over';
        this.ctx.imageSmoothingEnabled = false; // Disable image smoothing for better performance
        this.clear();
    }
}
function getRGBComponents(n) {
    // Ensure the input is within the valid range for a 24-bit color
    if (n < 0 || n > 0xffffff) throw new Error('Input number must be between 0 and 16777215 (inclusive).');
    // Extract blue component (bits 0-7)
    const blue = n & 0xff;
    // Extract green component (bits 8-15)
    const green = n >> 8 & 0xff;
    // Extract red component (bits 16-23)
    const red = n >> 16 & 0xff;
    return `rgb(${red}, ${green}, ${blue})`;
}
async function calculateDrawnPixelsRaw(imageData, _, arraySize) {
    const data = imageData.data;
    const arr = new Uint32Array(arraySize);
    for(let i = 0; i < data.length; i += 4){
        // Check alpha
        if (data[i + 3] !== 0) {
            // Combine RGB components into a single 24-bit color value:
            // (data[i] << 16)   - Shift red component left 16 bits   (bits 16-23)
            // (data[i + 1] << 8) - Shift green component left 8 bits (bits 8-15)
            // data[i + 2]       - Blue component stays as is         (bits 0-7)
            // The | operator combines all bits together
            const color = data[i] << 16 | data[i + 1] << 8 | data[i + 2];
            const colorIndex = color - 1;
            arr[colorIndex] = (arr[colorIndex] || 0) + 1;
        }
        if (i % 10000 === 0) await (0, _taskYieldDefault.default)();
    }
    return arr;
}

},{"../../utils/task-yield":"gLjYx","@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"gLjYx":[function(require,module,exports,__globalThis) {
// See https://developer.mozilla.org/en-US/docs/Web/API/Prioritized_Task_Scheduling_API
var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
async function taskYield() {
    // This is using globalThis to allow the yield task to be used outside of a browser env
    if ('scheduler' in globalThis && // @ts-ignore
    'yield' in globalThis.scheduler) {
        // @ts-ignore
        await scheduler.yield();
        return;
    }
    let resolve = ()=>{};
    const p = new Promise((a)=>{
        resolve = a;
    });
    setTimeout(resolve, 0);
    await p;
}
exports.default = taskYield;

},{"@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"fkNHj":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "detectLayoutShiftCause", ()=>detectLayoutShiftCause);
const calculateOffenderState = (current, matchesCurrentEntry)=>{
    // Once we know it's mixed across entries, we can short-circuit.
    if (current === 'some') return 'some';
    const entryState = matchesCurrentEntry ? 'all' : 'none';
    if (current == null) return entryState;
    // If the state flips between entries (all <-> none), it's "some".
    if (current !== entryState) return 'some';
    return current;
};
const calculateLayoutShiftMovement = (layoutShiftEntries)=>{
    const movements = layoutShiftEntries.map((lsEntry)=>{
        const rect = lsEntry.rect;
        const previousRect = lsEntry.previousRect;
        if (!rect || !previousRect) return null;
        const dx = rect.x - previousRect.x;
        const dy = rect.y - previousRect.y;
        return {
            dx,
            dy,
            movedX: dx !== 0,
            movedY: dy !== 0,
            dirX: Math.sign(dx),
            dirY: Math.sign(dy),
            absDx: Math.abs(dx),
            absDy: Math.abs(dy)
        };
    });
    const hasMovement = (m)=>m !== null;
    const validMovements = movements.filter(hasMovement);
    const allHaveRects = layoutShiftEntries.length > 0 && validMovements.length === layoutShiftEntries.length;
    if (!allHaveRects) return {
        allHaveRects,
        allMovedSameWay: false,
        allMovedSameAmount: false
    };
    const first = validMovements[0];
    const allMovedSameWay = validMovements.every((m)=>m.movedX === first.movedX && m.movedY === first.movedY && m.dirX === first.dirX && m.dirY === first.dirY);
    const allMovedSameAmount = allMovedSameWay && validMovements.every((m)=>m.absDx === first.absDx && m.absDy === first.absDy);
    return {
        allHaveRects,
        allMovedSameWay,
        allMovedSameAmount,
        deltaX: first.dx,
        deltaY: first.dy
    };
};
const detectLayoutShiftCause = ({ viewportEntries, layoutShiftEntries, time, startTime, offenderWindowMs = 250 })=>{
    const checkpointTimestamp = startTime + time;
    const filteredLSPotentialOffenders = viewportEntries.filter((viewportEntry)=>(viewportEntry.time < checkpointTimestamp && viewportEntry.time > checkpointTimestamp - offenderWindowMs || viewportEntry.time > checkpointTimestamp && viewportEntry.time < checkpointTimestamp + offenderWindowMs) && viewportEntry.data.type !== 'layout-shift');
    // Summarize whether all layout-shift entries moved in a consistent direction and by the same amount.
    const layoutShiftVariables = calculateLayoutShiftMovement(layoutShiftEntries);
    // Classify each offender against *all* layout-shift entries when the layout shift is consistently moving in a
    // single axis (pure X or pure Y) so we can reason about whether an offender could have caused the movement.
    const layoutShiftOffenders = filteredLSPotentialOffenders.reduce((acc, offender)=>{
        const offenderData = offender.data;
        const offenderRect = offenderData.rect;
        if (!offenderRect) return acc;
        var _offenderData_originalMutationTimestamp;
        const offenderTimestamp = (_offenderData_originalMutationTimestamp = offenderData.originalMutationTimestamp) !== null && _offenderData_originalMutationTimestamp !== void 0 ? _offenderData_originalMutationTimestamp : offender.time;
        const happenedBefore = offenderTimestamp <= checkpointTimestamp;
        const offenderLeft = offenderRect.x;
        const offenderRight = offenderRect.x + offenderRect.width;
        const offenderTop = offenderRect.y;
        const offenderBottom = offenderRect.y + offenderRect.height;
        const shouldClassifyAgainstAllEntries = layoutShiftVariables.allMovedSameWay && 'deltaX' in layoutShiftVariables && 'deltaY' in layoutShiftVariables && layoutShiftVariables.deltaX === 0 !== (layoutShiftVariables.deltaY === 0);
        let isAbove = null;
        let isLeft = null;
        let isRight = null;
        let hasHorizontalOverlap = null;
        let hasVerticalOverlap = null;
        if (shouldClassifyAgainstAllEntries) for (const lsEntry of layoutShiftEntries){
            const lsRect = lsEntry.rect;
            if (!lsRect) continue;
            const lsLeft = lsRect.x;
            const lsRight = lsRect.x + lsRect.width;
            const lsTop = lsRect.y;
            const lsBottom = lsRect.y + lsRect.height;
            isAbove = calculateOffenderState(isAbove, offenderBottom <= lsTop);
            isLeft = calculateOffenderState(isLeft, offenderRight <= lsLeft);
            isRight = calculateOffenderState(isRight, offenderLeft >= lsRight);
            hasHorizontalOverlap = calculateOffenderState(hasHorizontalOverlap, offenderLeft < lsRight && offenderRight > lsLeft);
            hasVerticalOverlap = calculateOffenderState(hasVerticalOverlap, offenderTop < lsBottom && offenderBottom > lsTop);
        }
        let matchesLayoutShiftDelta = false;
        if (shouldClassifyAgainstAllEntries && layoutShiftVariables.allMovedSameAmount && offenderData.previousRect) {
            const dx = offenderRect.x - offenderData.previousRect.x;
            const dy = offenderRect.y - offenderData.previousRect.y;
            const isPureX = layoutShiftVariables.deltaX !== 0 && layoutShiftVariables.deltaY === 0;
            const isPureY = layoutShiftVariables.deltaY !== 0 && layoutShiftVariables.deltaX === 0;
            if (isPureX) matchesLayoutShiftDelta = dx === layoutShiftVariables.deltaX && dy === 0;
            else if (isPureY) matchesLayoutShiftDelta = dy === layoutShiftVariables.deltaY && dx === 0;
        }
        acc.push({
            offender: offenderData.elementName,
            happenedBefore,
            distanceToLS: Math.round(offenderTimestamp - checkpointTimestamp),
            isAbove: isAbove !== null && isAbove !== void 0 ? isAbove : 'none',
            isLeft: isLeft !== null && isLeft !== void 0 ? isLeft : 'none',
            isRight: isRight !== null && isRight !== void 0 ? isRight : 'none',
            hasHorizontalOverlap: hasHorizontalOverlap !== null && hasHorizontalOverlap !== void 0 ? hasHorizontalOverlap : 'none',
            hasVerticalOverlap: hasVerticalOverlap !== null && hasVerticalOverlap !== void 0 ? hasVerticalOverlap : 'none',
            matchesLayoutShiftDelta
        });
        return acc;
    }, []);
    return {
        layoutShiftVariables,
        layoutShiftOffenders
    };
};

},{"@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"5uR3m":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
function getViewportHeight(document = window.document) {
    let documentHeight;
    try {
        documentHeight = document.documentElement.clientHeight || 0;
    } catch (e) {
        documentHeight = 0;
    }
    return Math.max(documentHeight, window.innerHeight || 0);
}
exports.default = getViewportHeight;

},{"@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"dh0qc":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
function getViewportWidth(document = window.document) {
    let documentWidth;
    try {
        documentWidth = document.documentElement.clientWidth || 0;
    } catch (e) {
        documentWidth = 0;
    }
    return Math.max(documentWidth, window.innerWidth || 0);
}
exports.default = getViewportWidth;

},{"@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"4EC3r":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
function isViewportEntryData(data) {
    if (data) {
        const hasElementName = typeof data.elementName === 'string';
        const hasRect = typeof data.rect !== 'undefined';
        if (hasRect && hasElementName) return true;
    }
    return false;
}
exports.default = isViewportEntryData;

},{"@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"9D0J0":[function(require,module,exports,__globalThis) {
// TODO: AFO-3523
// Those are the attributes we have found when testing the 'fy25.03' manually.
// We still need to replace this hardcoded list with a proper automation
var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "KNOWN_ATTRIBUTES_THAT_DOES_NOT_CAUSE_LAYOUT_SHIFTS", ()=>KNOWN_ATTRIBUTES_THAT_DOES_NOT_CAUSE_LAYOUT_SHIFTS);
parcelHelpers.export(exports, "NON_VISUAL_ARIA_ATTRIBUTES", ()=>NON_VISUAL_ARIA_ATTRIBUTES);
parcelHelpers.export(exports, "THIRD_PARTY_BROWSER_EXTENSION_ATTRIBUTES", ()=>THIRD_PARTY_BROWSER_EXTENSION_ATTRIBUTES);
parcelHelpers.export(exports, "MORE_THIRD_PARTY_EXTENSION_ATTRIBUTES", ()=>MORE_THIRD_PARTY_EXTENSION_ATTRIBUTES);
parcelHelpers.export(exports, "DARK_READER_BROWSER_EXTENSION_ATTRIBUTES", ()=>DARK_READER_BROWSER_EXTENSION_ATTRIBUTES);
const KNOWN_ATTRIBUTES_THAT_DOES_NOT_CAUSE_LAYOUT_SHIFTS = [
    'data-drop-target-for-element',
    'data-drop-target-for-external',
    'draggable',
    'data-is-observed',
    'data-aui-version',
    'data-testid',
    'data-vc',
    'data-ssr-placeholder',
    'data-ssr-placeholder-replace',
    'data-vc-nvs',
    'data-media-vc-wrapper',
    'data-renderer-start-pos',
    'data-table-local-id',
    'spellcheck',
    'data-auto-scrollable',
    'id',
    'tabindex',
    'data-is-ttvc-ready',
    'contenteditable',
    'data-has-collab-initialised',
    'translate',
    'data-comment-id',
    'data-access-level'
];
const NON_VISUAL_ARIA_ATTRIBUTES = [
    'aria-label',
    'aria-labelledby',
    'aria-describedby',
    'aria-hidden',
    'aria-expanded',
    'aria-controls',
    'aria-selected',
    'aria-checked',
    'aria-disabled',
    'aria-required',
    'aria-current',
    'aria-haspopup',
    'aria-pressed',
    'aria-atomic',
    'aria-live'
];
const THIRD_PARTY_BROWSER_EXTENSION_ATTRIBUTES = [
    'bis_skin_checked',
    'cz-shortcut-listen',
    'monica-version',
    'data-gr-ext-installed',
    'data-dashlane-rid',
    'sapling-installed',
    'data-gptw',
    // grammarly extensions
    'data-new-gr-c-s-loaded',
    'data-gr-aaa-notch-connection-id',
    'data-gr-aaa-loaded'
];
const MORE_THIRD_PARTY_EXTENSION_ATTRIBUTES = [
    'fdprocessedid',
    'data-dashlane-classification'
];
const DARK_READER_BROWSER_EXTENSION_ATTRIBUTES = [
    // dark reader extension
    'data-darkreader-inline-bgcolor',
    'data-darkreader-inline-bgimage',
    'data-darkreader-inline-border',
    'data-darkreader-inline-border-bottom',
    'data-darkreader-inline-border-left',
    'data-darkreader-inline-border-right',
    'data-darkreader-inline-border-top',
    'data-darkreader-inline-boxshadow',
    'data-darkreader-inline-color',
    'data-darkreader-inline-fill',
    'data-darkreader-inline-stroke',
    'data-darkreader-inline-outline',
    'data-darkreader-inline-stopcolor',
    'data-darkreader-inline-bg',
    'data-darkreader-inline-border-short',
    'data-darkreader-inline-border-bottom-short',
    'data-darkreader-inline-border-left-short',
    'data-darkreader-inline-border-right-short',
    'data-darkreader-inline-border-top-short'
];

},{"@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"gVzYn":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>VCCalculator_FY26_04);
var _platformFeatureFlags = require("@atlaskit/platform-feature-flags");
var _fy2503 = require("../fy25_03");
var _fy2503Default = parcelHelpers.interopDefault(_fy2503);
var _constants = require("../utils/constants");
const getConsideredEntryTypes = ()=>{
    const consideredEntryTypes = [
        'mutation:display-contents-children-element'
    ];
    consideredEntryTypes.push('mutation:display-contents-children-attribute');
    return consideredEntryTypes;
};
const getExcludedEntryTypes = ()=>{
    const excludedEntryTypes = [
        'layout-shift:same-rect',
        'mutation:attribute:non-visual-input-name'
    ];
    return excludedEntryTypes;
};
const fy26_04_excluded_attributes = [
    'data-is-hovered'
];
class VCCalculator_FY26_04 extends (0, _fy2503Default.default) {
    isEntryIncluded(entry, include3p, excludeSmartAnswersInSearch) {
        const extra_fy26_04_excluded_attributes = [
            'data-fabric-mode'
        ];
        const entryData = entry.data;
        const { attributeName } = entryData;
        if (entry.data.type === 'mutation:attribute' && attributeName && extra_fy26_04_excluded_attributes.includes(attributeName)) return false;
        const isEntryIncludedInV3 = super.isEntryIncluded(entry, include3p, excludeSmartAnswersInSearch);
        if (isEntryIncludedInV3 && !getExcludedEntryTypes().includes(entry.data.type)) return true;
        if (entry.data.type === 'mutation:attribute' && (!attributeName || fy26_04_excluded_attributes.includes(attributeName) && (0, _platformFeatureFlags.fg)('platform_ufo_data-is-hovered-v4-exclusion'))) return false;
        const thirdPartyAttributes = [
            ...(0, _constants.THIRD_PARTY_BROWSER_EXTENSION_ATTRIBUTES),
            ...(0, _platformFeatureFlags.fg)('platform_ufo_exclude_dark_reader_extension') ? (0, _constants.DARK_READER_BROWSER_EXTENSION_ATTRIBUTES) : [],
            ...(0, _platformFeatureFlags.fg)('platform_ufo_exclude_fdprocessedid_attribute') ? (0, _constants.MORE_THIRD_PARTY_EXTENSION_ATTRIBUTES) : []
        ];
        if (entryData.type === 'mutation:display-contents-children-attribute') {
            if (!attributeName || attributeName.startsWith('data-test') || (0, _constants.KNOWN_ATTRIBUTES_THAT_DOES_NOT_CAUSE_LAYOUT_SHIFTS).includes(attributeName) || (0, _constants.NON_VISUAL_ARIA_ATTRIBUTES).includes(attributeName) || thirdPartyAttributes.includes(attributeName)) return false;
            return true;
        }
        return getConsideredEntryTypes().includes(entry.data.type);
    }
    constructor(revisionNo = 'fy26.04'){
        super(revisionNo);
    }
}

},{"@atlaskit/platform-feature-flags":"8rD2i","../fy25_03":"8M5az","../utils/constants":"9D0J0","@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"lNIk3":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>VCCalculator_Next);
var _fy2604 = require("../fy26_04");
var _fy2604Default = parcelHelpers.interopDefault(_fy2604);
const ABORTING_WINDOW_EVENT = [
    'wheel',
    'scroll',
    'keydown',
    'resize',
    'scroll-container'
];
const getConsideredEntryTypes = ()=>{
    const consideredEntryTypes = [];
    return consideredEntryTypes;
};
const getExcludedEntryTypes = ()=>{
    const excludedEntryTypes = [];
    return excludedEntryTypes;
};
class VCCalculator_Next extends (0, _fy2604Default.default) {
    isEntryIncluded(entry, include3p, excludeSmartAnswersInSearch) {
        const isEntryIncludedInV4 = super.isEntryIncluded(entry, include3p, excludeSmartAnswersInSearch);
        if (isEntryIncludedInV4 && !getExcludedEntryTypes().includes(entry.data.type)) return true;
        return getConsideredEntryTypes().includes(entry.data.type);
    }
    getVCCleanStatus(filteredEntries) {
        let dirtyReason = '';
        let abortTimestamp = -1;
        const hasAbortEvent = filteredEntries.some((entry)=>{
            if (entry.data.type === 'window:event') {
                const data = entry.data;
                const eventType = data.eventType;
                if (ABORTING_WINDOW_EVENT.includes(eventType)) {
                    if (eventType === 'keydown') dirtyReason = 'keypress';
                    else if (eventType === 'scroll-container') dirtyReason = 'scroll';
                    else dirtyReason = eventType;
                    abortTimestamp = Math.round(entry.time);
                    return true;
                }
            }
            return false;
        });
        if (hasAbortEvent && dirtyReason) return {
            isVCClean: false,
            dirtyReason,
            abortTimestamp
        };
        return {
            isVCClean: true
        };
    }
    constructor(){
        super('next');
    }
}

},{"../fy26_04":"gVzYn","@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"kT5FO":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>RawDataHandler);
var _objectSpread = require("@swc/helpers/_/_object_spread");
var _objectSpreadProps = require("@swc/helpers/_/_object_spread_props");
var _objectWithoutProperties = require("@swc/helpers/_/_object_without_properties");
var _config = require("../../../config");
var _hiddenTiming = require("../../../hidden-timing");
var _getViewportHeight = require("../metric-calculator/utils/get-viewport-height");
var _getViewportHeightDefault = parcelHelpers.interopDefault(_getViewportHeight);
var _getViewportWidth = require("../metric-calculator/utils/get-viewport-width");
var _getViewportWidthDefault = parcelHelpers.interopDefault(_getViewportWidth);
const ABORTING_WINDOW_EVENT = [
    'wheel',
    'scroll',
    'keydown',
    'resize'
];
const MAX_OBSERVATIONS = 200;
const encodeRect = (rect)=>[
        Math.round(rect.left * 10) / 10,
        Math.round(rect.top * 10) / 10,
        Math.round(rect.right * 10) / 10,
        Math.round(rect.bottom * 10) / 10
    ];
const areRectsEqual = (left, right)=>left.every((value, index)=>value === right[index]);
function isWindowEventEntryData(data) {
    return data.type === 'window:event' && 'eventType' in data;
}
class RawDataHandler {
    getVCCleanStatus(filteredEntries) {
        let dirtyReason = '';
        let abortTimestamp = -1;
        const hasAbortEvent = filteredEntries.some((entry)=>{
            if (entry.data.type === 'window:event') {
                const data = entry.data;
                const eventType = data.eventType;
                if (ABORTING_WINDOW_EVENT.includes(eventType)) {
                    dirtyReason = eventType === 'keydown' ? 'keypress' : eventType;
                    abortTimestamp = Math.round(entry.time);
                    return true;
                }
            }
            return false;
        });
        if (hasAbortEvent && dirtyReason) return {
            isVCClean: false,
            dirtyReason,
            abortTimestamp
        };
        return {
            isVCClean: true
        };
    }
    async getRawData({ entries, startTime, stopTime, isPageVisible }) {
        let isVCClean;
        let dirtyReason;
        const getVCCleanStatusResult = this.getVCCleanStatus(entries);
        isVCClean = getVCCleanStatusResult.isVCClean;
        dirtyReason = getVCCleanStatusResult.dirtyReason;
        var _getEarliestHiddenTiming;
        if (!isPageVisible) return {
            revision: this.revisionNo,
            clean: false,
            'metric:vc90': null,
            abortReason: 'browser_backgrounded',
            abortTimestamp: (_getEarliestHiddenTiming = (0, _hiddenTiming.getEarliestHiddenTiming)(startTime, stopTime)) !== null && _getEarliestHiddenTiming !== void 0 ? _getEarliestHiddenTiming : -1,
            viewport: {
                w: (0, _getViewportWidthDefault.default)(),
                h: (0, _getViewportHeightDefault.default)()
            }
        };
        const viewportEntries = entries.filter((entry)=>{
            return entry.time >= startTime && entry.time <= stopTime && entry.data && entry.data.visible;
        });
        const windowEventEntries = entries.filter((entry)=>{
            return entry.time >= startTime && entry.time <= stopTime && entry.data && isWindowEventEntryData(entry.data);
        });
        const targetNameToIdMap = new Map();
        const elementMapEntriesMap = {};
        let nextElementId = 1;
        const typeMap = new Map();
        const typeMapEntriesMap = {};
        let nextTypeId = 1;
        const attributeMap = new Map();
        const attributeEntriesMap = {};
        let nextAttributeId = 1;
        const eventTypeMap = new Map();
        const eventTypeMapEntriesMap = {};
        let nextEventTypeId = 1;
        const labelStacksMap = {};
        let rawObservations = viewportEntries.map((entry)=>{
            const viewportEntry = entry.data;
            const targetName = viewportEntry.elementName || '';
            const type = viewportEntry.type || '';
            const rect = viewportEntry.rect;
            const attributeName = viewportEntry.attributeName || '';
            let eid = targetNameToIdMap.get(viewportEntry.elementName || '') || 0;
            if (eid === 0) {
                eid = nextElementId;
                nextElementId += 1;
                targetNameToIdMap.set(targetName, eid);
                elementMapEntriesMap[eid] = targetName;
            }
            // Capture labelStacks per element (only stored once per unique element)
            if (viewportEntry.labelStacks && !(eid in labelStacksMap)) {
                const labelInfo = {
                    s: viewportEntry.labelStacks.segment,
                    l: viewportEntry.labelStacks.labelStack
                };
                const shouldCompactImplicitUnknown = labelInfo.s === 'unknown' && labelInfo.l === 'unknown';
                labelStacksMap[eid] = shouldCompactImplicitUnknown ? 'u' : labelInfo;
            }
            let chg = typeMap.get(type || '') || 0;
            if (chg === 0) {
                chg = nextTypeId;
                nextTypeId += 1;
                typeMap.set(type, chg);
                typeMapEntriesMap[chg] = type;
            }
            let att = 0;
            if (attributeName) {
                att = attributeMap.get(attributeName) || 0;
                if (att === 0) {
                    att = nextAttributeId;
                    nextAttributeId += 1;
                    attributeMap.set(attributeName, att);
                    attributeEntriesMap[att] = attributeName;
                }
            }
            const encodedRect = encodeRect(rect);
            const encodedPreviousRect = viewportEntry.previousRect ? encodeRect(viewportEntry.previousRect) : null;
            const shouldIncludePreviousRect = encodedPreviousRect === null || !areRectsEqual(encodedRect, encodedPreviousRect);
            const observation = (0, _objectSpread._)((0, _objectSpreadProps._)((0, _objectSpread._)({
                t: Math.round(entry.time - startTime),
                r: encodedRect
            }, shouldIncludePreviousRect ? {
                pr: encodedPreviousRect
            } : {}), {
                chg,
                eid: eid || 0
            }), att > 0 ? {
                att
            } : {});
            return observation;
        });
        let rawEventObservations = windowEventEntries.map((entry)=>{
            const windowEventEntry = entry.data;
            const eventType = windowEventEntry.eventType;
            let evtId = eventTypeMap.get(eventType) || 0;
            if (evtId === 0) {
                evtId = nextEventTypeId;
                nextEventTypeId += 1;
                eventTypeMap.set(eventType, evtId);
                eventTypeMapEntriesMap[evtId] = eventType;
            }
            let eventTargetId = 0;
            const eventTargetName = windowEventEntry.elementName || '';
            if (eventTargetName) {
                eventTargetId = targetNameToIdMap.get(eventTargetName) || 0;
                if (eventTargetId === 0) {
                    eventTargetId = nextElementId;
                    nextElementId += 1;
                    targetNameToIdMap.set(eventTargetName, eventTargetId);
                    elementMapEntriesMap[eventTargetId] = eventTargetName;
                }
            }
            const eventObservation = (0, _objectSpread._)({
                t: Math.round(entry.time - startTime),
                evt: evtId
            }, eventTargetId > 0 ? {
                eid: eventTargetId
            } : {});
            return eventObservation;
        });
        const shouldTrimEventObservations = rawEventObservations.length > MAX_OBSERVATIONS;
        const shouldTrimViewportObservations = rawObservations.length > MAX_OBSERVATIONS;
        // If the number of event observations is greater than the maximum allowed, we need to trim the event observations to the maximum allowed.
        // We do this by keeping the first observation and the last MAX_OBSERVATIONS observations.
        if (shouldTrimEventObservations) {
            const firstEventObservation = rawEventObservations[0];
            const lastEventObservations = rawEventObservations.slice(-MAX_OBSERVATIONS);
            rawEventObservations = [
                firstEventObservation,
                ...lastEventObservations
            ];
        }
        // If the number of observations is greater than the maximum allowed, we need to trim the observations to the maximum allowed.
        // We do this by keeping the first observation, the SSR observation (if present), and the last MAX_OBSERVATIONS observations.
        if (shouldTrimViewportObservations) {
            const firstObservation = rawObservations[0];
            const lastObservations = rawObservations.slice(-MAX_OBSERVATIONS);
            // Find the SSR observation by looking up the eid that corresponds to 'SSR' element name
            const ssrEid = targetNameToIdMap.get('SSR');
            const ssrObservation = ssrEid ? rawObservations.find((obs)=>obs.eid === ssrEid && obs !== firstObservation) : undefined;
            // Include SSR observation if it exists and is not already in the kept observations
            const ssrAlreadyIncluded = ssrObservation && lastObservations.some((obs)=>obs === ssrObservation);
            rawObservations = [
                firstObservation,
                ...ssrObservation && !ssrAlreadyIncluded ? [
                    ssrObservation
                ] : [],
                ...lastObservations
            ];
        }
        if (shouldTrimViewportObservations || shouldTrimEventObservations) {
            // Collect referenced IDs from final retained observations. Keep this inside the trim
            // guard so the common untrimmed path avoids extra Set allocations and scans.
            const referencedEids = new Set();
            const referencedChgs = new Set();
            const referencedAtts = new Set();
            const referencedEvts = new Set();
            const referencedEventTargetEids = new Set();
            for (const observation of rawObservations){
                if (observation.eid > 0) referencedEids.add(observation.eid);
                if (typeof observation.chg === 'number' && observation.chg > 0) referencedChgs.add(observation.chg);
                if (observation.att !== undefined && observation.att > 0) referencedAtts.add(observation.att);
            }
            for (const observation of rawEventObservations){
                if (observation.evt > 0) referencedEvts.add(observation.evt);
                if (observation.eid !== undefined && observation.eid > 0) referencedEventTargetEids.add(observation.eid);
            }
            for (const eid of Object.keys(elementMapEntriesMap).map(Number))if (!referencedEids.has(eid) && !referencedEventTargetEids.has(eid)) {
                delete elementMapEntriesMap[eid];
                delete labelStacksMap[eid];
            }
            if (shouldTrimViewportObservations) {
                for (const chg of Object.keys(typeMapEntriesMap).map(Number))if (!referencedChgs.has(chg)) delete typeMapEntriesMap[chg];
                for (const att of Object.keys(attributeEntriesMap).map(Number))if (!referencedAtts.has(att)) delete attributeEntriesMap[att];
            }
            if (shouldTrimEventObservations) {
                // Event type map cleanup is only needed when event observations were trimmed.
                // If only viewport observations were trimmed, all event observations remain and
                // therefore every event type ID in the map is still referenced.
                for (const evt of Object.keys(eventTypeMapEntriesMap).map(Number))if (!referencedEvts.has(evt)) delete eventTypeMapEntriesMap[evt];
            }
        }
        // FedRAMP-Moderate scrubbing.
        //
        // In commercial environments the raw-handler payload includes:
        //   - `rawData.att` / `obs[].att`  → DOM attribute names from
        //     `MutationRecord.attributeName`. These are *names* (not values),
        //     but custom product attributes can in principle embed
        //     identifiers (e.g. `data-user-{id}-state`).
        //   - `rawData.lbl`                → UFO labelStacks. Generally
        //     curated product paths but in poorly-instrumented call sites
        //     could embed dynamic identifiers.
        //
        // Server-side TTVC reconstruction does not require these fields
        // (it is driven by timestamps, rectangles, and mutation kind),
        // so dropping them in FedRAMP is safe and removes residual PII risk.
        const isFedrampScrubbed = (0, _config.isFedrampOverrideActive)();
        const scrubbedObservations = isFedrampScrubbed ? rawObservations.map((_param)=>{
            var { att: _att } = _param, rest = (0, _objectWithoutProperties._)(_param, [
                "att"
            ]);
            return rest;
        }) : rawObservations;
        const result = {
            revision: this.revisionNo,
            clean: isVCClean,
            'metric:vc90': null,
            rawData: {
                obs: scrubbedObservations !== null && scrubbedObservations !== void 0 ? scrubbedObservations : undefined,
                eid: elementMapEntriesMap !== null && elementMapEntriesMap !== void 0 ? elementMapEntriesMap : undefined,
                chg: typeMapEntriesMap !== null && typeMapEntriesMap !== void 0 ? typeMapEntriesMap : undefined,
                att: isFedrampScrubbed ? undefined : attributeEntriesMap !== null && attributeEntriesMap !== void 0 ? attributeEntriesMap : undefined,
                evts: rawEventObservations.length > 0 ? rawEventObservations : undefined,
                evt: Object.keys(eventTypeMapEntriesMap).length > 0 ? eventTypeMapEntriesMap : undefined,
                lbl: isFedrampScrubbed ? undefined : Object.keys(labelStacksMap).length > 0 ? labelStacksMap : undefined,
                lblMode: isFedrampScrubbed ? undefined : Object.keys(labelStacksMap).length > 0 ? 'sentinel-v1' : undefined
            },
            abortReason: dirtyReason,
            abortTimestamp: getVCCleanStatusResult.abortTimestamp,
            viewport: {
                w: (0, _getViewportWidthDefault.default)(),
                h: (0, _getViewportHeightDefault.default)()
            }
        };
        return result;
    }
    constructor(){
        this.revisionNo = 'raw-handler';
    }
}

},{"@swc/helpers/_/_object_spread":"9gdrV","@swc/helpers/_/_object_spread_props":"kANqQ","@swc/helpers/_/_object_without_properties":"6HqIM","../../../config":"bx9i6","../../../hidden-timing":"c8L9i","../metric-calculator/utils/get-viewport-height":"5uR3m","../metric-calculator/utils/get-viewport-width":"dh0qc","@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"0ziSR":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>ViewportObserver);
var _platformFeatureFlags = require("@atlaskit/platform-feature-flags");
var _vcUtils = require("../../vc-observer/media-wrapper/vc-utils");
var _isDndStyleMutation = require("../../vc-observer/observers/non-visual-styles/is-dnd-style-mutation");
var _isDndStyleMutationDefault = parcelHelpers.interopDefault(_isDndStyleMutation);
var _isNonVisualStyleMutation = require("../../vc-observer/observers/non-visual-styles/is-non-visual-style-mutation");
var _isNonVisualStyleMutationDefault = parcelHelpers.interopDefault(_isNonVisualStyleMutation);
var _isPdndAttribute = require("../../vc-observer/observers/non-visual-styles/is-pdnd-attribute");
var _isPdndAttributeDefault = parcelHelpers.interopDefault(_isPdndAttribute);
var _rllPlaceholders = require("../../vc-observer/observers/rll-placeholders");
var _intersectionObserver = require("./intersection-observer");
var _mutationObserver = require("./mutation-observer");
var _mutationObserverDefault = parcelHelpers.interopDefault(_mutationObserver);
var _performanceObserver = require("./performance-observer");
var _performanceObserverDefault = parcelHelpers.interopDefault(_performanceObserver);
var _checkWithinComponent = require("./utils/check-within-component");
var _checkWithinComponentDefault = parcelHelpers.interopDefault(_checkWithinComponent);
var _isContainedWithinSmartAnswers = require("./utils/is-contained-within-smart-answers");
var _isElementVisible = require("./utils/is-element-visible");
var _isInVcIgnoreIfNoLayoutShiftMarker = require("./utils/is-in-vc-ignore-if-no-layout-shift-marker");
var _isInVcIgnoreIfNoLayoutShiftMarkerDefault = parcelHelpers.interopDefault(_isInVcIgnoreIfNoLayoutShiftMarker);
var _isInputNameMutation = require("./utils/is-input-name-mutation");
var _isSameRectDimensions = require("./utils/is-same-rect-dimensions");
var _isSameRectSize = require("./utils/is-same-rect-size");
const createElementMutationsWatcher = (removedNodeRects, isWithinThirdPartySegment, isWithinGenAISegment, isWithinSmartAnswersSegment, hasSameDeletedNode, timestamp, isTargetReactRoot, getSSRState, getSSRPlaceholderHandler)=>({ target, rect })=>{
        if (getSSRState) {
            const ssrState = getSSRState();
            const SSRStateEnum = {
                normal: 1,
                waitingForFirstRender: 2,
                ignoring: 3
            };
            if (ssrState.state === SSRStateEnum.waitingForFirstRender && timestamp > ssrState.renderStart && isTargetReactRoot) {
                ssrState.state = SSRStateEnum.ignoring;
                if (ssrState.renderStop === -1) // arbitrary 500ms DOM update window
                ssrState.renderStop = timestamp + 500;
                return 'ssr-hydration';
            }
            if (ssrState.state === SSRStateEnum.ignoring && timestamp > ssrState.renderStart && isTargetReactRoot) {
                if (timestamp <= ssrState.renderStop) return 'ssr-hydration';
                else ssrState.state = SSRStateEnum.normal;
            }
        }
        if (getSSRPlaceholderHandler) {
            const ssrPlaceholderHandler = getSSRPlaceholderHandler();
            if (ssrPlaceholderHandler) {
                if ((ssrPlaceholderHandler.isPlaceholderV4(target) || ssrPlaceholderHandler.isPlaceholderIgnored(target)) && ssrPlaceholderHandler.checkIfExistedAndSizeMatchingV3(target)) return 'mutation:ssr-placeholder';
                if ((ssrPlaceholderHandler.isPlaceholderReplacementV4(target) || ssrPlaceholderHandler.isPlaceholderIgnored(target)) && ssrPlaceholderHandler.validateReactComponentMatchToPlaceholderV4(target)) return 'mutation:ssr-placeholder';
            }
        }
        if (hasSameDeletedNode && (0, _isInVcIgnoreIfNoLayoutShiftMarkerDefault.default)(target)) return 'mutation:remount';
        if ((0, _vcUtils.isContainedWithinMediaWrapper)(target)) return 'mutation:media';
        if (isWithinThirdPartySegment) return 'mutation:third-party-element';
        if (isWithinGenAISegment) return 'mutation:gen-ai-element';
        if (isWithinSmartAnswersSegment) return 'mutation:smart-answers-element';
        const isInIgnoreLsMarker = (0, _isInVcIgnoreIfNoLayoutShiftMarkerDefault.default)(target);
        if (!isInIgnoreLsMarker) return 'mutation:element';
        const isRLLPlaceholder = (0, _rllPlaceholders.RLLPlaceholderHandlers).getInstance().isRLLPlaceholderHydration(rect);
        if (isRLLPlaceholder && isInIgnoreLsMarker) return 'mutation:rll-placeholder';
        const wasDeleted = removedNodeRects.some((nr)=>(0, _isSameRectDimensions.isSameRectDimensions)(nr, rect));
        if (wasDeleted && isInIgnoreLsMarker) return 'mutation:element-replacement';
        return 'mutation:element';
    };
const createElementMutationsWatcherNew = (removedNodeRects, isWithinThirdPartySegment, isWithinGenAISegment, isWithinSmartAnswersSegment, hasSameDeletedNode, timestamp, isTargetReactRoot, getSSRState, getSSRPlaceholderHandler)=>({ target, rect })=>{
        if (getSSRState) {
            const ssrState = getSSRState();
            const SSRStateEnum = {
                normal: 1,
                waitingForFirstRender: 2,
                ignoring: 3
            };
            if (ssrState.state === SSRStateEnum.waitingForFirstRender && timestamp > ssrState.renderStart && isTargetReactRoot) {
                ssrState.state = SSRStateEnum.ignoring;
                if (ssrState.renderStop === -1) // arbitrary 500ms DOM update window
                ssrState.renderStop = timestamp + 500;
                return {
                    type: 'ssr-hydration',
                    mutationData: {
                        timestamp
                    }
                };
            }
            if (ssrState.state === SSRStateEnum.ignoring && timestamp > ssrState.renderStart && isTargetReactRoot) {
                if (timestamp <= ssrState.renderStop) return {
                    type: 'ssr-hydration',
                    mutationData: {
                        timestamp
                    }
                };
                else ssrState.state = SSRStateEnum.normal;
            }
        }
        if (getSSRPlaceholderHandler) {
            const ssrPlaceholderHandler = getSSRPlaceholderHandler();
            if (ssrPlaceholderHandler) {
                if ((ssrPlaceholderHandler.isPlaceholderV4(target) || ssrPlaceholderHandler.isPlaceholderIgnored(target)) && ssrPlaceholderHandler.checkIfExistedAndSizeMatchingV3(target)) return {
                    type: 'mutation:ssr-placeholder',
                    mutationData: {
                        timestamp
                    }
                };
                if ((ssrPlaceholderHandler.isPlaceholderReplacementV4(target) || ssrPlaceholderHandler.isPlaceholderIgnored(target)) && ssrPlaceholderHandler.validateReactComponentMatchToPlaceholderV4(target)) return {
                    type: 'mutation:ssr-placeholder',
                    mutationData: {
                        timestamp
                    }
                };
            }
        }
        if (hasSameDeletedNode && (0, _isInVcIgnoreIfNoLayoutShiftMarkerDefault.default)(target)) return {
            type: 'mutation:remount',
            mutationData: {
                timestamp
            }
        };
        if ((0, _vcUtils.isContainedWithinMediaWrapper)(target)) return {
            type: 'mutation:media',
            mutationData: {
                timestamp
            }
        };
        if (isWithinThirdPartySegment) return {
            type: 'mutation:third-party-element',
            mutationData: {
                timestamp
            }
        };
        if (isWithinGenAISegment) return {
            type: 'mutation:gen-ai-element',
            mutationData: {
                timestamp
            }
        };
        if (isWithinSmartAnswersSegment) return {
            type: 'mutation:smart-answers-element',
            mutationData: {
                timestamp
            }
        };
        const isInIgnoreLsMarker = (0, _isInVcIgnoreIfNoLayoutShiftMarkerDefault.default)(target);
        if (!isInIgnoreLsMarker) return {
            type: 'mutation:element',
            mutationData: {
                timestamp
            }
        };
        const isRLLPlaceholder = (0, _rllPlaceholders.RLLPlaceholderHandlers).getInstance().isRLLPlaceholderHydration(rect);
        if (isRLLPlaceholder && isInIgnoreLsMarker) return {
            type: 'mutation:rll-placeholder',
            mutationData: {
                timestamp
            }
        };
        const wasDeleted = removedNodeRects.some((nr)=>(0, _isSameRectDimensions.isSameRectDimensions)(nr, rect));
        if (wasDeleted && isInIgnoreLsMarker) return {
            type: 'mutation:element-replacement',
            mutationData: {
                timestamp
            }
        };
        return {
            type: 'mutation:element',
            mutationData: {
                timestamp
            }
        };
    };
class ViewportObserver {
    initializeObservers() {
        if (this.isStarted) return;
        this.intersectionObserver = (0, _intersectionObserver.createIntersectionObserver)({
            onEntry: this.handleIntersectionEntry
        });
        this.mutationObserver = (0, _mutationObserverDefault.default)({
            onChildListMutation: this.handleChildListMutation,
            onAttributeMutation: this.handleAttributeMutation
        });
        this.performanceObserver = (0, _performanceObserverDefault.default)({
            onLayoutShift: this.handleLayoutShift
        });
    }
    start() {
        var _this_mutationObserver, _this_performanceObserver;
        if (this.isStarted) return;
        this.initializeObservers();
        (_this_mutationObserver = this.mutationObserver) === null || _this_mutationObserver === void 0 ? void 0 : _this_mutationObserver.observe(document.body, {
            attributeOldValue: true,
            attributes: true,
            childList: true,
            subtree: true
        });
        (_this_performanceObserver = this.performanceObserver) === null || _this_performanceObserver === void 0 ? void 0 : _this_performanceObserver.observe({
            type: 'layout-shift',
            buffered: true,
            // @ts-ignore -error
            durationThreshold: 30
        });
        this.isStarted = true;
    }
    stop() {
        var _this_mutationObserver, _this_intersectionObserver, _this_performanceObserver;
        if (!this.isStarted) return;
        (_this_mutationObserver = this.mutationObserver) === null || _this_mutationObserver === void 0 ? void 0 : _this_mutationObserver.disconnect();
        (_this_intersectionObserver = this.intersectionObserver) === null || _this_intersectionObserver === void 0 ? void 0 : _this_intersectionObserver.disconnect();
        (_this_performanceObserver = this.performanceObserver) === null || _this_performanceObserver === void 0 ? void 0 : _this_performanceObserver.disconnect();
        this.isStarted = false;
        // Clean up caches when stopping
        (0, _checkWithinComponent.cleanupCaches)(this.mapIs3pResult);
    }
    constructor({ onChange, getSSRState, getSSRPlaceholderHandler, trackLayoutShiftOffenders = false, searchPageConfig }){
        this.handleIntersectionEntry = ({ target, rect, time, type, mutationData })=>{
            if (!target) return;
            const visible = (0, _isElementVisible.isElementVisible)(target);
            const lastElementRect = this.mapVisibleNodeRects.get(target);
            this.mapVisibleNodeRects.set(target, rect);
            this.onChange({
                time,
                type,
                elementRef: new WeakRef(target),
                visible,
                rect,
                previousRect: lastElementRect,
                mutationData
            });
        };
        this.handleChildListMutation = async ({ target, addedNodes, removedNodes, timestamp })=>{
            const removedNodeRects = removedNodes.map((ref)=>{
                const n = ref.deref();
                if (!n) return;
                return this.mapVisibleNodeRects.get(n);
            });
            const targetNode = target.deref();
            for (const addedNodeRef of addedNodes){
                var _this_getSSRState, _this_getSSRState1, _this, _this_intersectionObserver;
                const addedNode = addedNodeRef.deref();
                if (!addedNode) continue;
                const hasSameDeletedNode = removedNodes.find((ref)=>{
                    const n = ref.deref();
                    if (!n || !addedNode) return false;
                    return n.isEqualNode(addedNode);
                });
                const { isWithin: isWithinThirdPartySegment } = (0, _checkWithinComponentDefault.default)(addedNode, 'UFOThirdPartySegment', this.mapIs3pResult);
                const { isWithin: isWithinGenAISegment } = (0, _checkWithinComponentDefault.default)(addedNode, 'UFOGenAISegment', this.mapIsGenAIResult);
                const isWithinSmartAnswersSegment = Boolean(this.shouldCheckSmartAnswersMutations() && (0, _isContainedWithinSmartAnswers.isContainedWithinSmartAnswers)(addedNode));
                const isTargetReactRoot = targetNode === ((_this_getSSRState1 = (_this = this).getSSRState) === null || _this_getSSRState1 === void 0 ? void 0 : (_this_getSSRState = _this_getSSRState1.call(_this)) === null || _this_getSSRState === void 0 ? void 0 : _this_getSSRState.reactRootElement);
                (_this_intersectionObserver = this.intersectionObserver) === null || _this_intersectionObserver === void 0 ? void 0 : _this_intersectionObserver.watchAndTag(addedNode, (this.trackLayoutShiftOffenders ? createElementMutationsWatcherNew : createElementMutationsWatcher)(removedNodeRects, isWithinThirdPartySegment, isWithinGenAISegment, isWithinSmartAnswersSegment, !!hasSameDeletedNode, timestamp, isTargetReactRoot, this.getSSRState, this.getSSRPlaceholderHandler));
            }
        };
        this.handleAttributeMutation = ({ target, attributeName, oldValue, newValue, timestamp })=>{
            var _this_intersectionObserver;
            (_this_intersectionObserver = this.intersectionObserver) === null || _this_intersectionObserver === void 0 ? void 0 : _this_intersectionObserver.watchAndTag(target, ({ target, rect })=>{
                if ((0, _vcUtils.isContainedWithinMediaWrapper)(target)) return {
                    type: 'mutation:media',
                    mutationData: {
                        attributeName,
                        oldValue,
                        newValue,
                        timestamp
                    }
                };
                const { isWithin: isWithinThirdPartySegment } = (0, _checkWithinComponentDefault.default)(target, 'UFOThirdPartySegment', this.mapIs3pResult);
                const { isWithin: isWithinGenAISegment } = (0, _checkWithinComponentDefault.default)(target, 'UFOGenAISegment', this.mapIsGenAIResult);
                if (isWithinThirdPartySegment) return {
                    type: 'mutation:third-party-attribute',
                    mutationData: {
                        attributeName,
                        oldValue,
                        newValue,
                        timestamp
                    }
                };
                if (isWithinGenAISegment) return {
                    type: 'mutation:gen-ai-attribute',
                    mutationData: {
                        attributeName,
                        oldValue,
                        newValue,
                        timestamp
                    }
                };
                if (this.shouldCheckSmartAnswersMutations() && (0, _isContainedWithinSmartAnswers.isContainedWithinSmartAnswers)(target)) return {
                    type: 'mutation:smart-answers-attribute',
                    mutationData: {
                        attributeName,
                        oldValue,
                        newValue
                    }
                };
                if ((0, _isDndStyleMutationDefault.default)({
                    target,
                    attributeName,
                    oldValue,
                    newValue
                })) return {
                    type: 'mutation:attribute:non-visual-style',
                    mutationData: {
                        attributeName,
                        oldValue,
                        newValue,
                        timestamp
                    }
                };
                if ((0, _isNonVisualStyleMutationDefault.default)({
                    target,
                    attributeName,
                    type: 'attributes'
                })) return {
                    type: 'mutation:attribute:non-visual-style',
                    mutationData: {
                        attributeName,
                        oldValue,
                        newValue,
                        timestamp
                    }
                };
                // Pragmatic Drag and Drop attributes added during post-paint
                // registration; do not affect layout or paint.
                if ((0, _isPdndAttributeDefault.default)({
                    target,
                    attributeName
                }) && (0, _platformFeatureFlags.fg)('platform_ufo_exclude_pdnd_attributes_from_vc')) return {
                    type: 'mutation:attribute:non-visual-style',
                    mutationData: {
                        attributeName,
                        oldValue,
                        newValue,
                        timestamp
                    }
                };
                if ((0, _isInputNameMutation.isInputNameMutation)({
                    target,
                    attributeName,
                    oldValue,
                    newValue
                })) return {
                    type: 'mutation:attribute:non-visual-input-name',
                    mutationData: {
                        attributeName,
                        oldValue,
                        newValue,
                        timestamp
                    }
                };
                const isRLLPlaceholder = (0, _rllPlaceholders.RLLPlaceholderHandlers).getInstance().isRLLPlaceholderHydration(rect);
                if (isRLLPlaceholder) return {
                    type: 'mutation:rll-placeholder',
                    mutationData: {
                        attributeName,
                        oldValue,
                        newValue,
                        timestamp
                    }
                };
                const lastElementRect = this.mapVisibleNodeRects.get(target);
                if (lastElementRect && (0, _isSameRectSize.isSameRectSize)(rect, lastElementRect)) return {
                    type: 'mutation:attribute:no-layout-shift',
                    mutationData: {
                        attributeName,
                        oldValue,
                        newValue,
                        timestamp
                    }
                };
                return {
                    type: 'mutation:attribute',
                    mutationData: {
                        attributeName,
                        oldValue,
                        newValue,
                        timestamp
                    }
                };
            });
        };
        this.handleLayoutShift = ({ time, changedRects })=>{
            for (const changedRect of changedRects){
                const target = changedRect.node;
                if (target) {
                    const isSameCurrentAndPreviousRects = (0, _isSameRectDimensions.isSameRectDimensions)(changedRect.rect, changedRect.previousRect);
                    this.onChange({
                        time,
                        elementRef: new WeakRef(target),
                        visible: true,
                        rect: changedRect.rect,
                        previousRect: changedRect.previousRect,
                        type: isSameCurrentAndPreviousRects ? 'layout-shift:same-rect' : 'layout-shift'
                    });
                }
            }
        };
        this.shouldCheckSmartAnswersMutations = ()=>{
            var _this_searchPageConfig, _this_searchPageConfig1, _window_location, _window;
            return ((_this_searchPageConfig = this.searchPageConfig) === null || _this_searchPageConfig === void 0 ? void 0 : _this_searchPageConfig.enableSmartAnswersMutations) && ((_this_searchPageConfig1 = this.searchPageConfig) === null || _this_searchPageConfig1 === void 0 ? void 0 : _this_searchPageConfig1.searchPageRoute) && ((_window = window) === null || _window === void 0 ? void 0 : (_window_location = _window.location) === null || _window_location === void 0 ? void 0 : _window_location.pathname) && window.location.pathname === this.searchPageConfig.searchPageRoute;
        };
        this.mapVisibleNodeRects = new WeakMap();
        this.mapIs3pResult = new WeakMap();
        this.mapIsGenAIResult = new WeakMap();
        this.onChange = onChange;
        this.isStarted = false;
        this.intersectionObserver = null;
        this.mutationObserver = null;
        this.performanceObserver = null;
        this.trackLayoutShiftOffenders = trackLayoutShiftOffenders;
        // Initialize SSR context functions
        this.getSSRState = getSSRState;
        this.getSSRPlaceholderHandler = getSSRPlaceholderHandler;
        this.searchPageConfig = searchPageConfig;
    }
}

},{"@atlaskit/platform-feature-flags":"8rD2i","../../vc-observer/media-wrapper/vc-utils":"kpsp6","../../vc-observer/observers/non-visual-styles/is-dnd-style-mutation":"1QpRK","../../vc-observer/observers/non-visual-styles/is-non-visual-style-mutation":"g5J6e","../../vc-observer/observers/non-visual-styles/is-pdnd-attribute":"acVHP","../../vc-observer/observers/rll-placeholders":"calqI","./intersection-observer":"8tTYz","./mutation-observer":"dk30I","./performance-observer":"4DpzO","./utils/check-within-component":"jj7iD","./utils/is-contained-within-smart-answers":"3X1L9","./utils/is-element-visible":"bXa7m","./utils/is-in-vc-ignore-if-no-layout-shift-marker":"2dy6J","./utils/is-input-name-mutation":"k5wPU","./utils/is-same-rect-dimensions":"1AJKN","./utils/is-same-rect-size":"7r0cm","@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"acVHP":[function(require,module,exports,__globalThis) {
/**
 * Attributes that Pragmatic Drag and Drop adds via `setAttribute` during its
 * post-paint registration step. They are used purely for hit testing and
 * registration bookkeeping, and do not affect layout, paint, or visible
 * styling, so they are safe to ignore for VC measurement.
 *
 * Drop target attributes follow `data-drop-target-for-<typeKey>` and are
 * handled by the prefix below (covers shipped and custom adapters).
 */ var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "PDND_REGISTRATION_ATTRIBUTES", ()=>PDND_REGISTRATION_ATTRIBUTES);
parcelHelpers.export(exports, "DROP_TARGET_ATTRIBUTE_PREFIX", ()=>DROP_TARGET_ATTRIBUTE_PREFIX);
parcelHelpers.export(exports, "default", ()=>isPdndAttribute);
const PDND_REGISTRATION_ATTRIBUTES = new Set([
    // @atlaskit/pragmatic-drag-and-drop (core)
    'draggable',
    // Honey pot lives on a transient element; included for completeness.
    'data-pdnd-honey-pot',
    // @atlaskit/pragmatic-drag-and-drop-auto-scroll
    'data-auto-scrollable',
    // @atlaskit/pragmatic-drag-and-drop/react-beautiful-dnd-migration
    'data-rbd-draggable-droppable-id',
    'data-rbd-draggable-index',
    'data-rbd-droppable-type',
    'data-rbd-droppable-direction',
    'data-rbd-droppable-id',
    'data-rbd-droppable-context-id',
    'data-rbd-style-context-id'
]);
const DROP_TARGET_ATTRIBUTE_PREFIX = 'data-drop-target-for-';
function isPdndAttribute({ target, attributeName }) {
    if (!(target instanceof Element)) return false;
    if (!attributeName) return false;
    if (PDND_REGISTRATION_ATTRIBUTES.has(attributeName)) return true;
    if (attributeName.startsWith(DROP_TARGET_ATTRIBUTE_PREFIX)) return true;
    return false;
}

},{"@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"8tTYz":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "createIntersectionObserver", ()=>createIntersectionObserver);
var _isZeroDimensionRectangle = require("../utils/is-zero-dimension-rectangle");
function isValidEntry(entry) {
    return entry.isIntersecting && entry.intersectionRect.width > 0 && entry.intersectionRect.height > 0;
}
function createIntersectionObserver({ onEntry, onObserved }) {
    if (!window || typeof window.IntersectionObserver !== 'function') return null;
    const callbacksPerElement = new WeakMap();
    const intersectionObserverCallback = (entries)=>{
        const validEntries = [];
        const startTime = performance.now();
        entries.forEach((entry)=>{
            if (!(entry.target instanceof HTMLElement)) return;
            const tagOrCallback = callbacksPerElement.get(entry.target);
            if ((0, _isZeroDimensionRectangle.isZeroDimensionRectangle)(entry.intersectionRect)) {
                const zeroDimensionRectangleTagCallback = (props)=>{
                    const tagOrCallbackResult = typeof tagOrCallback === 'function' ? tagOrCallback(props) : tagOrCallback;
                    // override as display-contents mutation
                    if (tagOrCallbackResult === 'mutation:element') return 'mutation:display-contents-children-element';
                    // override as display-contents mutation
                    if (tagOrCallbackResult && typeof tagOrCallbackResult !== 'string' && tagOrCallbackResult.type === 'mutation:attribute' && 'oldValue' in tagOrCallbackResult.mutationData) {
                        const { attributeName, oldValue, newValue } = tagOrCallbackResult.mutationData;
                        const isRoutingMutation = attributeName === 'style' && (!oldValue && newValue === 'display: none !important;' || oldValue === 'display: none !important;' && !newValue);
                        if (isRoutingMutation) return {
                            type: 'mutation:attribute:framework-routing',
                            mutationData: tagOrCallbackResult.mutationData
                        };
                        return {
                            type: 'mutation:display-contents-children-attribute',
                            mutationData: tagOrCallbackResult.mutationData
                        };
                    }
                    return tagOrCallbackResult;
                };
                for (const child of Array.from(entry.target.children)){
                    observer.observe(child);
                    callbacksPerElement.set(child, zeroDimensionRectangleTagCallback);
                }
                return;
            }
            if (!isValidEntry(entry)) return;
            let mutationTag = null;
            let mutationData = null;
            if (typeof tagOrCallback === 'function') {
                const tagOrCallbackResult = tagOrCallback({
                    target: entry.target,
                    rect: entry.intersectionRect
                });
                if (!tagOrCallbackResult) mutationTag = 'unknown';
                else if (typeof tagOrCallbackResult === 'string') mutationTag = tagOrCallbackResult;
                else {
                    mutationTag = tagOrCallbackResult.type;
                    mutationData = tagOrCallbackResult.mutationData;
                }
            } else if (typeof tagOrCallback === 'string') mutationTag = tagOrCallback;
            onEntry({
                target: entry.target,
                rect: entry.intersectionRect,
                time: entry.time,
                type: mutationTag !== null && mutationTag !== void 0 ? mutationTag : 'unknown',
                mutationData
            });
            validEntries.push(new WeakRef(entry.target));
            callbacksPerElement.delete(entry.target);
            observer.unobserve(entry.target);
        });
        onObserved === null || onObserved === void 0 ? void 0 : onObserved({
            time: startTime,
            elements: validEntries
        });
    };
    const observer = new IntersectionObserver(intersectionObserverCallback);
    return {
        disconnect: ()=>{
            observer.disconnect();
        },
        unobserve: (target)=>{
            observer.unobserve(target);
        },
        watchAndTag: (target, tagOrCallback)=>{
            callbacksPerElement.set(target, tagOrCallback);
            observer.observe(target);
        }
    };
}

},{"../utils/is-zero-dimension-rectangle":"fdtqF","@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"fdtqF":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "isZeroDimensionRectangle", ()=>isZeroDimensionRectangle);
function isZeroDimensionRectangle(rect) {
    return rect.bottom === 0 && rect.top === 0 && rect.left === 0 && rect.right === 0 && rect.x === 0 && rect.y === 0 && rect.width === 0 && rect.height === 0;
}

},{"@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"dk30I":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _expVal = require("../../../expVal");
function createMutationObserver({ onAttributeMutation, onChildListMutation, onMutationFinished }) {
    if (!window || typeof window.IntersectionObserver !== 'function') return null;
    const mutationObserverCallback = (mutations)=>{
        const targets = [];
        // Use nested Maps for O(1) batching performance
        // Short-lived Maps are safe since they're discarded after each callback
        const batchedMutations = new Map();
        for (const mut of mutations){
            if (!(mut.target instanceof HTMLElement)) continue;
            if ((0, _expVal.expVal)('cc_editor_vc_exclude_flags', 'isEnabled', false)) {
                // Intended for excluding out of band mutations such as tooltips on hover, and page flags
                // Currently being tested in Confluence
                // Skip elements with data-vc-oob attribute
                if (mut.target.dataset.vcOob) return;
            }
            if (mut.type === 'attributes') {
                var _mut_oldValue;
                /*
					"MutationObserver was explicitly designed to work that way, but I can't now recall the reasoning.
					I think it might have been something along the lines that for consistency every setAttribute call should create a record.
					Conceptually there is after all a mutation: there is an old value replaced with a new one,
					and whether or not they are the same doesn't really matter.
					And Custom elements should work the same way as MutationObserver."
					https://github.com/whatwg/dom/issues/520#issuecomment-336574796
				*/ const oldValue = (_mut_oldValue = mut.oldValue) !== null && _mut_oldValue !== void 0 ? _mut_oldValue : undefined;
                const newValue = mut.attributeName ? mut.target.getAttribute(mut.attributeName) : undefined;
                var _mut_attributeName;
                if (oldValue !== newValue) onAttributeMutation({
                    target: mut.target,
                    attributeName: (_mut_attributeName = mut.attributeName) !== null && _mut_attributeName !== void 0 ? _mut_attributeName : 'unknown',
                    oldValue,
                    newValue,
                    timestamp: mut.timestamp || performance.now()
                });
                continue;
            } else if (mut.type === 'childList') {
                // In chromium browser MutationRecord has timestamp field, which we should use.
                const timestamp = Math.round(mut.timestamp || performance.now());
                // Get or create timestamp bucket
                let timestampBucket = batchedMutations.get(timestamp);
                if (!timestampBucket) {
                    timestampBucket = new Map();
                    batchedMutations.set(timestamp, timestampBucket);
                }
                // Get or create target batch within timestamp bucket
                let batch = timestampBucket.get(mut.target);
                if (!batch) {
                    batch = {
                        target: new WeakRef(mut.target),
                        addedNodes: [],
                        removedNodes: [],
                        timestamp
                    };
                    timestampBucket.set(mut.target, batch);
                }
                var // Accumulate added nodes
                _mut_addedNodes;
                ((_mut_addedNodes = mut.addedNodes) !== null && _mut_addedNodes !== void 0 ? _mut_addedNodes : []).forEach((node)=>{
                    if (node instanceof HTMLElement) batch.addedNodes.push(new WeakRef(node));
                });
                var // Accumulate removed nodes
                _mut_removedNodes;
                ((_mut_removedNodes = mut.removedNodes) !== null && _mut_removedNodes !== void 0 ? _mut_removedNodes : []).forEach((node)=>{
                    if (node instanceof HTMLElement) batch.removedNodes.push(new WeakRef(node));
                });
            }
            targets.push(mut.target);
        }
        // Process all batched childList mutations
        for (const timestampBucket of batchedMutations.values())for (const batch of timestampBucket.values())onChildListMutation({
            target: batch.target,
            addedNodes: batch.addedNodes,
            removedNodes: batch.removedNodes,
            timestamp: batch.timestamp
        });
        onMutationFinished === null || onMutationFinished === void 0 ? void 0 : onMutationFinished({
            targets
        });
    };
    const observer = new MutationObserver(mutationObserverCallback);
    return observer;
}
exports.default = createMutationObserver;

},{"../../../expVal":"gVXAt","@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"4DpzO":[function(require,module,exports,__globalThis) {
// The LayoutShiftAttribution API is returning the numbers on physical dimension
var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "convertPhysicalToLogicalResolution", ()=>convertPhysicalToLogicalResolution);
function convertPhysicalToLogicalResolution(rect) {
    if (typeof window.devicePixelRatio !== 'number') return rect;
    if (window.devicePixelRatio === 1) return rect;
    // eslint-disable-next-line compat/compat
    return new DOMRect(rect.x / window.devicePixelRatio, rect.y / window.devicePixelRatio, rect.width / window.devicePixelRatio, rect.height / window.devicePixelRatio);
}
function createPerformanceObserver({ onLayoutShift }) {
    if (!window || typeof window.PerformanceObserver !== 'function') return null;
    const performanceObserverCallback = (entries)=>{
        for (const entry of entries.getEntries())if (entry.entryType === 'layout-shift' && 'sources' in entry) {
            // see https://developer.mozilla.org/en-US/docs/Web/API/LayoutShiftAttribution for more info
            const changedRects = entry.sources.reduceRight((acc, attr)=>{
                acc.push({
                    rect: convertPhysicalToLogicalResolution(attr.currentRect),
                    previousRect: convertPhysicalToLogicalResolution(attr.previousRect),
                    node: attr.node
                });
                return acc;
            }, []);
            onLayoutShift({
                time: entry.startTime,
                changedRects
            });
        }
    };
    const observer = new PerformanceObserver(performanceObserverCallback);
    return observer;
}
// eslint-disable-next-line @atlaskit/volt-strict-mode/no-multiple-exports
exports.default = createPerformanceObserver;

},{"@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"jj7iD":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "cleanupCaches", ()=>cleanupCaches);
parcelHelpers.export(exports, "default", ()=>checkWithinComponent);
var _platformFeatureFlags = require("@atlaskit/platform-feature-flags");
var _coinflip = require("../../../../coinflip");
var _coinflipDefault = parcelHelpers.interopDefault(_coinflip);
var _checkFiberWithinComponent = require("./check-fiber-within-component");
var _checkFiberWithinComponentDefault = parcelHelpers.interopDefault(_checkFiberWithinComponent);
var _findFiberWithCache = require("./find-fiber-with-cache");
var _findFiberWithCacheDefault = parcelHelpers.interopDefault(_findFiberWithCache);
const OLD_DOM_WALK_MAX_LEVEL = 40;
const OLD_FIBER_WALK_MAX_LEVEL = 40;
const NEW_DOM_WALK_MAX_LEVEL = 400;
const NEW_FIBER_WALK_MAX_LEVEL = 400;
// Cache cleanup
let callCount = 0;
const CLEANUP_THRESHOLD = 50;
function maybeCleanup(resultCache) {
    callCount++;
    if (callCount >= CLEANUP_THRESHOLD && (0, _coinflipDefault.default)(0.3)) cleanupCaches(resultCache);
}
function cleanupCaches(resultCache) {
    resultCache = new WeakMap();
    callCount = 0;
    return resultCache;
}
function checkWithinComponent(node, targetComponentName, resultCache) {
    maybeCleanup(resultCache);
    var _resultCache_get;
    if (resultCache.has(node)) return {
        isWithin: (_resultCache_get = resultCache.get(node)) !== null && _resultCache_get !== void 0 ? _resultCache_get : false
    };
    const checkedNodes = [];
    const shouldUseBumpedWalkLevels = (0, _platformFeatureFlags.fg)('ufo-bump-walk-levels');
    const DOM_WALK_MAX_LEVEL = shouldUseBumpedWalkLevels ? NEW_DOM_WALK_MAX_LEVEL : OLD_DOM_WALK_MAX_LEVEL;
    const FIBER_WALK_MAX_LEVEL = shouldUseBumpedWalkLevels ? NEW_FIBER_WALK_MAX_LEVEL : OLD_FIBER_WALK_MAX_LEVEL;
    // Always use cached fiber strategy to handle non-React elements reliably
    const { fiber, cachedResult } = (0, _findFiberWithCacheDefault.default)(node, DOM_WALK_MAX_LEVEL, checkedNodes, shouldUseBumpedWalkLevels ? resultCache : undefined);
    if (cachedResult !== undefined) {
        checkedNodes.forEach((checkedNode)=>{
            resultCache.set(checkedNode, cachedResult);
        });
        return {
            isWithin: cachedResult
        };
    }
    if (!fiber) {
        checkedNodes.forEach((checkedNode)=>{
            resultCache.set(checkedNode, false);
        });
        return {
            isWithin: false
        };
    }
    const isWithin = (0, _checkFiberWithinComponentDefault.default)(fiber, targetComponentName, FIBER_WALK_MAX_LEVEL);
    checkedNodes.forEach((checkedNode)=>{
        resultCache.set(checkedNode, isWithin);
    });
    return {
        isWithin
    };
}

},{"@atlaskit/platform-feature-flags":"8rD2i","../../../../coinflip":"e6eL5","./check-fiber-within-component":"4Qa1b","./find-fiber-with-cache":"ajMU6","@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"4Qa1b":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>checkFiberWithinComponent);
var _getComponentName = require("./get-component-name");
var _getComponentNameDefault = parcelHelpers.interopDefault(_getComponentName);
function checkFiberWithinComponent(fiber, targetComponentName, maxLevel) {
    // Stop when no more levels to traverse
    if (maxLevel <= 0) return false;
    if (!fiber) return false;
    const componentName = (0, _getComponentNameDefault.default)(fiber);
    if (componentName === targetComponentName) return true;
    // Recursively traverse up the fiber tree
    return checkFiberWithinComponent(fiber.return, targetComponentName, maxLevel - 1);
}

},{"./get-component-name":"1AMRe","@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"1AMRe":[function(require,module,exports,__globalThis) {
// Helper function to extract component name from fiber
var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>getComponentName);
function getComponentName(fiber) {
    const type = fiber === null || fiber === void 0 ? void 0 : fiber.type;
    if (!type) return undefined;
    if (typeof type === 'function' || typeof type === 'object') return type.displayName || type.name;
    return undefined;
}

},{"@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"ajMU6":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>findFiberWithCache);
var _findReactFiber = require("./find-react-fiber");
var _findReactFiberDefault = parcelHelpers.interopDefault(_findReactFiber);
function findFiberWithCache(element, maxLevel, checkedNodes, resultCache) {
    let currentElement = element;
    let remainingLevels = maxLevel;
    while(currentElement && remainingLevels > 0){
        const cachedResult = resultCache === null || resultCache === void 0 ? void 0 : resultCache.get(currentElement);
        if (cachedResult !== undefined) return {
            fiber: null,
            cachedResult
        };
        checkedNodes.push(currentElement);
        const fiber = (0, _findReactFiberDefault.default)(currentElement);
        if (fiber) return {
            fiber
        };
        currentElement = currentElement.parentElement;
        remainingLevels--;
    }
    return {
        fiber: null
    };
}

},{"./find-react-fiber":"7fbSN","@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"7fbSN":[function(require,module,exports,__globalThis) {
// Helper function to find React fiber on an element
var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>findReactFiber);
function findReactFiber(element) {
    // Use for...in loop instead of Object.keys().find() to avoid creating an array
    for(const key in element){
        if (key.startsWith('__reactFiber$') || key.startsWith('__reactInternalInstance$')) return element[key];
    }
    return null;
}

},{"@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"3X1L9":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "isContainedWithinSmartAnswers", ()=>isContainedWithinSmartAnswers);
var _browserApis = require("@atlaskit/browser-apis");
function isContainedWithinSmartAnswers(node) {
    const doc = (0, _browserApis.getDocument)();
    if (!doc) return false;
    const smartAnswersElement = doc.getElementById('search-page-smart-answers');
    if (!smartAnswersElement) return false;
    // When the node is the smart answer element, .contains() still returns true
    return smartAnswersElement.contains(node);
}

},{"@atlaskit/browser-apis":"1bRFZ","@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"1bRFZ":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "getDocument", ()=>getDocument);
const getDocument = ()=>{
    if (typeof document !== 'undefined') return document;
    return null;
};

},{"@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"bXa7m":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "isElementVisible", ()=>isElementVisible);
function isElementVisible(element) {
    if (!(element instanceof HTMLElement)) return true;
    try {
        const visible = element.checkVisibility({
            // @ts-ignore - visibilityProperty may not exist in all TS environments
            visibilityProperty: true,
            contentVisibilityAuto: true,
            opacityProperty: true
        });
        return visible;
    } catch (e) {
        // there is no support for checkVisibility
        return true;
    }
}

},{"@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"2dy6J":[function(require,module,exports,__globalThis) {
/**
 * Check if the element is in the VC ignore if no layout shift marker.
 * @param element - The element to check.
 * @returns True if the element has the data-vc-ignore-if-no-layout-shift attribute == 'true or its parent has it, false otherwise.
 */ var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>isInVCIgnoreIfNoLayoutShiftMarker);
function isInVCIgnoreIfNoLayoutShiftMarker(element) {
    if (!element) return false;
    return element.getAttribute('data-vc-ignore-if-no-layout-shift') === 'true' || isInVCIgnoreIfNoLayoutShiftMarker(element.parentElement);
}

},{"@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"k5wPU":[function(require,module,exports,__globalThis) {
// Detecting this is required due to a React/Chromium bug, where React itself triggers an attribute mutation for input elements
// Reference: https://atlassian.slack.com/archives/C08EK6TCUP6/p1764129900970719
var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "isInputNameMutation", ()=>isInputNameMutation);
function isInputNameMutation({ target, attributeName, oldValue, newValue }) {
    return target instanceof HTMLInputElement && attributeName === 'name' && (oldValue === '' || newValue === '');
}

},{"@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"1AJKN":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "isSameRectDimensions", ()=>isSameRectDimensions);
const DIMENSIONS_CHECK_TOLERANCE_MARGIN_IN_PX = 1;
function isSameRectDimensions(a, b) {
    if (!a || !b) return false;
    return Math.abs(a.width - b.width) <= DIMENSIONS_CHECK_TOLERANCE_MARGIN_IN_PX && Math.abs(a.height - b.height) <= DIMENSIONS_CHECK_TOLERANCE_MARGIN_IN_PX && Math.abs(a.x - b.x) <= DIMENSIONS_CHECK_TOLERANCE_MARGIN_IN_PX && Math.abs(a.y - b.y) <= DIMENSIONS_CHECK_TOLERANCE_MARGIN_IN_PX;
}

},{"@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"7r0cm":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "isSameRectSize", ()=>isSameRectSize);
const SIZE_CHECK_TOLERANCE_MARGIN_IN_PX = 1;
function isSameRectSize(a, b) {
    if (!a || !b) return false;
    return Math.abs(a.width - b.width) <= SIZE_CHECK_TOLERANCE_MARGIN_IN_PX && Math.abs(a.height - b.height) <= SIZE_CHECK_TOLERANCE_MARGIN_IN_PX;
}

},{"@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"kVl4j":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>WindowEventObserver);
var _bindEventListener = require("bind-event-listener");
class WindowEventObserver {
    bindEvent(type) {
        const unbindCallback = (0, _bindEventListener.bind)(window, {
            type,
            listener: (event)=>{
                if (!event.isTrusted) return;
                this.onEvent({
                    time: event.timeStamp,
                    type,
                    event
                });
            },
            options: {
                passive: true,
                once: true
            }
        });
        this.unbindFns.push(unbindCallback);
    }
    /**
	 * Binds a scroll listener on `document` using the capture phase.
	 * The `scroll` event does not bubble, so listening on `window` only catches
	 * document-level scrolls. By using `{ capture: true }` on `document`, we can
	 * detect scroll events from any element in the DOM tree, including inner
	 * scrollable containers (e.g. when the user drags a scrollbar).
	 */ bindCaptureScrollEvent() {
        const unbindCallback = (0, _bindEventListener.bind)(document, {
            type: 'scroll',
            listener: (event)=>{
                if (!event.isTrusted) return;
                this.onEvent({
                    time: event.timeStamp,
                    type: 'scroll-container',
                    event
                });
            },
            options: {
                capture: true,
                passive: true,
                once: true
            }
        });
        this.unbindFns.push(unbindCallback);
    }
    start() {
        this.bindEvent('wheel');
        this.bindEvent('scroll');
        this.bindEvent('keydown');
        this.bindEvent('resize');
        this.bindCaptureScrollEvent();
    }
    stop() {
        this.unbindFns.forEach((cb)=>{
            cb();
        });
        this.unbindFns = [];
    }
    constructor(opts){
        this.unbindFns = [];
        this.onEvent = opts.onEvent;
    }
}

},{"bind-event-listener":"bjeUU","@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"j1a3t":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "interactions", ()=>interactions);
const interactions = new Map();

},{"@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"6CSgU":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>PostInteractionLog);
var _objectSpread = require("@swc/helpers/_/_object_spread");
var _objectSpreadProps = require("@swc/helpers/_/_object_spread_props");
var _config = require("../config");
var _hiddenTiming = require("../hidden-timing");
var _vc = require("../vc");
const POST_INTERACTION_LOG_SEND_DEFAULT_TIMEOUT = 3000;
class PostInteractionLog {
    initializeVCObserver(options) {
        this.vcObserver = new (0, _vc.VCObserverWrapper)((0, _objectSpreadProps._)((0, _objectSpread._)({}, options), {
            isPostInteraction: true
        }));
    }
    startVCObserver({ startTime }) {
        var _this_vcObserver;
        (_this_vcObserver = this.vcObserver) === null || _this_vcObserver === void 0 ? void 0 : _this_vcObserver.start({
            startTime
        });
    }
    stopVCObserver() {
        var _this_vcObserver;
        (_this_vcObserver = this.vcObserver) === null || _this_vcObserver === void 0 ? void 0 : _this_vcObserver.stop();
    }
    setVCObserverSSRConfig(vcObserverSSRConfig) {
        this.vcObserverSSRConfig = vcObserverSSRConfig;
    }
    /**
	 * Set the VC result as per the last interaction
	 * Used to compare diffs of VC updates vs post interaction VC observer
	 * @param result - VC result as calculated by UFO create payload
	 */ setLastInteractionFinishVCResult(result) {
        this.lastInteractionFinishVCResult = result;
    }
    /**
	 * Set the fn that would be invoked to process / send the observation data
	 */ sinkHandler(sinkHandlerFn) {
        this.sinkHandlerFn = sinkHandlerFn;
    }
    /**
	 * Reset state of the log
	 */ reset() {
        this.lastInteractionFinish = null;
        this.reactProfilerTimings = [];
        this.holdInfo = [];
        if (this.sinkTimeoutId != null) {
            clearTimeout(this.sinkTimeoutId);
            this.sinkTimeoutId = null;
        }
        this.setVCObserverSSRConfig(null);
    }
    /**
	 * Check if there is data in the log
	 */ hasData() {
        var _this_reactProfilerTimings;
        return ((_this_reactProfilerTimings = this.reactProfilerTimings) === null || _this_reactProfilerTimings === void 0 ? void 0 : _this_reactProfilerTimings.length) > 0;
    }
    /**
	 * Send the log if there is data
	 */ async sendPostInteractionLog() {
        var _config_vc, _config_vc1, _this_vcObserver, _this_vcObserver1;
        if (!this.lastInteractionFinish || !this.sinkHandlerFn) {
            var _this_vcObserver2;
            this.reset();
            (_this_vcObserver2 = this.vcObserver) === null || _this_vcObserver2 === void 0 ? void 0 : _this_vcObserver2.stop();
            return;
        }
        const pageVisibilityState = (0, _hiddenTiming.getPageVisibilityState)(this.lastInteractionFinish.start, this.lastInteractionFinish.end);
        const isPageVisible = pageVisibilityState === 'visible';
        const config = (0, _config.getConfig)();
        const postInteractionFinishVCResult = await ((_this_vcObserver = this.vcObserver) === null || _this_vcObserver === void 0 ? void 0 : _this_vcObserver.getVCResult((0, _objectSpreadProps._)((0, _objectSpread._)({
            start: this.lastInteractionFinish.start,
            stop: performance.now(),
            tti: -1,
            isEventAborted: !!this.lastInteractionFinish.abortReason,
            prefix: 'ufo',
            experienceKey: this.lastInteractionFinish.ufoName,
            interactionId: this.lastInteractionFinish.id,
            includeSSRInV3: config === null || config === void 0 ? void 0 : (_config_vc = config.vc) === null || _config_vc === void 0 ? void 0 : _config_vc.includeSSRInV3,
            includeSSRRatio: config === null || config === void 0 ? void 0 : (_config_vc1 = config.vc) === null || _config_vc1 === void 0 ? void 0 : _config_vc1.includeSSRRatio
        }, this.vcObserverSSRConfig), {
            interactionType: this.lastInteractionFinish.type,
            isPageVisible,
            interactionAbortReason: this.lastInteractionFinish.abortReason
        })));
        (_this_vcObserver1 = this.vcObserver) === null || _this_vcObserver1 === void 0 ? void 0 : _this_vcObserver1.stop();
        this.sinkHandlerFn({
            lastInteractionFinish: this.lastInteractionFinish,
            reactProfilerTimings: this.reactProfilerTimings,
            postInteractionFinishVCResult,
            lastInteractionFinishVCResult: this.lastInteractionFinishVCResult,
            postInteractionHoldInfo: this.holdInfo
        });
        this.reset();
    }
    /**
	 * This fn should be invoked when an interaction has finished
	 * Basic details about the finished interaction will be recorded
	 * A timeout will be setup to send the post interaction observation after some time.
	 */ onInteractionComplete({ ufoName, start, end, id, abortReason, abortedByInteractionName, routeName, type, errors }) {
        var _getConfig;
        this.lastInteractionFinish = {
            ufoName,
            start,
            end,
            id,
            abortReason,
            abortedByInteractionName,
            routeName,
            type,
            errors
        };
        const timeout = ((_getConfig = (0, _config.getConfig)()) === null || _getConfig === void 0 ? void 0 : _getConfig.timeWindowForLateMutationsInMilliseconds) || POST_INTERACTION_LOG_SEND_DEFAULT_TIMEOUT;
        this.sinkTimeoutId = window.setTimeout(async ()=>{
            await this.sendPostInteractionLog();
        }, timeout);
    }
    /**
	 * This fn should be invoked when a React render happens after interaction has finished
	 */ addProfilerTimings(labelStack, type, actualDuration, baseDuration, startTime, commitTime) {
        if (this.lastInteractionFinish != null) this.reactProfilerTimings.push({
            type,
            actualDuration,
            baseDuration,
            startTime,
            commitTime,
            labelStack
        });
    }
    addHoldInfo(labelStack, name, start) {
        this.holdInfo.push({
            name,
            labelStack,
            start
        });
    }
    constructor(){
        /**
	 * Basic info about interaction that has just finished
	 */ this.lastInteractionFinish = null;
        /**
	 * Array of observed react render timings
	 */ this.reactProfilerTimings = [];
        /**
	 * Store the scheduled sink timeout Id so that it can be cancelled when needed
	 */ this.sinkTimeoutId = null;
        this.holdInfo = [];
        /**
	 * independent VC observer, that observes until `custom.post-interaction-logs` event is sent
	 */ this.vcObserver = null;
        this.vcObserverSSRConfig = null;
        /**
	 * Handler function to process / send the observation data
	 */ this.sinkHandlerFn = ()=>{};
    }
}

},{"@swc/helpers/_/_object_spread":"9gdrV","@swc/helpers/_/_object_spread_props":"kANqQ","../config":"bx9i6","../hidden-timing":"c8L9i","../vc":"l4p8T","@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"gkHA9":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "getPerformanceObserver", ()=>getPerformanceObserver);
parcelHelpers.export(exports, "setInteractionPerformanceEvent", ()=>setInteractionPerformanceEvent);
var _objectSpread = require("@swc/helpers/_/_object_spread");
var _objectSpreadProps = require("@swc/helpers/_/_object_spread_props");
var _config = require("../config");
var _interactionMetrics = require("../interaction-metrics");
var _getUniqueElementName = require("../vc/vc-observer-new/get-unique-element-name");
var _getUniqueElementNameDefault = parcelHelpers.interopDefault(_getUniqueElementName);
let performanceEventObserver;
const DEFAULT_SELECTOR_CONFIG = {
    id: true,
    testId: true,
    role: true,
    className: true
};
/**
 * Resolve the SelectorConfig for the performance-observer code path.
 *
 * In FedRAMP Moderate environments (when `getSelectorConfig()` returns the
 * forced all-`false` config) we honour that override; otherwise we fall back
 * to the historical default that enables every selector.
 */ function resolveSelectorConfig() {
    var _getSelectorConfig;
    return (_getSelectorConfig = (0, _config.getSelectorConfig)()) !== null && _getSelectorConfig !== void 0 ? _getSelectorConfig : DEFAULT_SELECTOR_CONFIG;
}
function getTestIdName(memoizedProps) {
    if (memoizedProps['data-testid']) return `[data-testid=${memoizedProps['data-testid']}]`;
    else if (memoizedProps['data-test-id']) return `[data-test-id=${memoizedProps['data-testid']}]`;
    else if (memoizedProps['data-vc']) return `[data-vc=${memoizedProps['data-vc']}]`;
    return null;
}
function getUFOSegmentName(componentName, memoizedProps) {
    if (memoizedProps && memoizedProps['name']) return `UFOSegment[name=${memoizedProps['name']}]`;
    return componentName;
}
function getReactComponentHierarchy(element) {
    const componentHierarchy = [];
    // Function to traverse up the fiber tree
    function traverseFiber(fiber) {
        let currentFiber = fiber;
        while(currentFiber){
            if (currentFiber.type) {
                // Check if there's a display name or a function name
                const componentName = currentFiber.type.displayName || currentFiber.type.name;
                // checking when component name is bigger than the minimized name produced by react
                if (componentName && componentName.length > 2 && !componentName.includes('Listener') && !componentName.includes('Provider')) {
                    if (componentName === 'UFOSegment') {
                        componentHierarchy.push(getUFOSegmentName(componentName, currentFiber.memoizedProps));
                        break;
                    }
                    componentHierarchy.push(componentName);
                }
            }
            if (currentFiber.memoizedProps) {
                const dataIdInfo = getTestIdName(currentFiber.memoizedProps);
                if (dataIdInfo) {
                    componentHierarchy.push(dataIdInfo);
                    currentFiber = null;
                    continue;
                }
            }
            currentFiber = currentFiber.return;
        }
    }
    // Access the reactFiber node from the HTML element
    const reactFiberKey = Object.keys(element).find((key)=>key.startsWith('__reactFiber$'));
    if (reactFiberKey) {
        const fiber = element[reactFiberKey];
        traverseFiber(fiber);
    }
    return componentHierarchy.reverse().join(' > ');
}
const getPerformanceObserver = ()=>{
    performanceEventObserver = performanceEventObserver || new PerformanceObserver((entries)=>{
        const list = entries.getEntries();
        for (let entry of list)if (entry.name === 'click') setInteractionPerformanceEvent(entry);
    });
    return performanceEventObserver;
};
const setInteractionPerformanceEvent = (entry)=>{
    var _interaction_responsiveness;
    const interaction = (0, _interactionMetrics.getActiveInteraction)();
    if ((interaction === null || interaction === void 0 ? void 0 : interaction.type) === 'press') {
        if (!((_interaction_responsiveness = interaction.responsiveness) === null || _interaction_responsiveness === void 0 ? void 0 : _interaction_responsiveness.experimentalInputToNextPaint)) {
            var _interaction_responsiveness1, _interaction_responsiveness2;
            interaction.responsiveness = (0, _objectSpreadProps._)((0, _objectSpread._)({}, interaction.responsiveness), {
                experimentalInputToNextPaint: ((_interaction_responsiveness1 = interaction.responsiveness) === null || _interaction_responsiveness1 === void 0 ? void 0 : _interaction_responsiveness1.experimentalInputToNextPaint) || entry.duration,
                inputDelay: ((_interaction_responsiveness2 = interaction.responsiveness) === null || _interaction_responsiveness2 === void 0 ? void 0 : _interaction_responsiveness2.inputDelay) || entry.processingStart - entry.startTime
            });
            if (interaction.ufoName === 'unknown') {
                if (entry.target) {
                    const componentHierarchy = getReactComponentHierarchy(entry.target);
                    interaction.unknownElementHierarchy = componentHierarchy;
                }
                interaction.unknownElementName = (0, _getUniqueElementNameDefault.default)(resolveSelectorConfig(), entry.target);
            }
        }
    }
};

},{"@swc/helpers/_/_object_spread":"9gdrV","@swc/helpers/_/_object_spread_props":"kANqQ","../config":"bx9i6","../interaction-metrics":"j4w6h","../vc/vc-observer-new/get-unique-element-name":"k42OM","@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"k42OM":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
const nameCache = new WeakMap();
function getAttributeSelector(element, attributeName) {
    const attrValue = element.getAttribute(attributeName);
    if (!attrValue) return '';
    return `[${attributeName}="${attrValue}"]`;
}
function isValidSelector(selector) {
    try {
        document.querySelector(selector);
        return true;
    } catch (e) {
        return false;
    }
}
function isSelectorUnique(selector) {
    return document.querySelectorAll(selector).length === 1;
}
function getUniqueSelector(selectorConfig, element) {
    let currentElement = element;
    const parts = [];
    const MAX_DEPTH = 3;
    let currentDepth = 0;
    while(currentElement && currentElement.localName !== 'body' && currentDepth <= MAX_DEPTH){
        const tagName = currentElement.localName;
        let selectorPart = tagName;
        if (selectorConfig.id && currentElement.id && isValidSelector(`#${currentElement.id}`)) selectorPart += `#${currentElement.id}`;
        else if (selectorConfig.dataVC) selectorPart += getAttributeSelector(currentElement, 'data-vc');
        else if (selectorConfig.testId) selectorPart += getAttributeSelector(currentElement, 'data-testid') || getAttributeSelector(currentElement, 'data-test-id');
        else if (selectorConfig.role) selectorPart += getAttributeSelector(currentElement, 'role');
        else if (selectorConfig.className && currentElement.className) {
            const classNames = Array.from(currentElement.classList).join('.');
            if (classNames) {
                if (isValidSelector(`.${classNames}`)) selectorPart += `.${classNames}`;
            }
        }
        parts.unshift(selectorPart);
        const potentialSelector = parts.join(' > ').trim();
        if (potentialSelector && isSelectorUnique(potentialSelector)) return potentialSelector;
        currentElement = currentElement.parentElement;
        currentDepth++;
    }
    const potentialSelector = parts.join(' > ').trim();
    if (!potentialSelector) return 'unknown';
    else if (!isSelectorUnique(potentialSelector)) {
        const parentElement = element.parentElement;
        if (parentElement) return `${potentialSelector}:nth-child`; // NOTE: invalid DOM selector, but enough information for VC
    }
    return potentialSelector;
}
function getElementName(selectorConfig, element) {
    if (!(element instanceof HTMLElement)) return 'error';
    const cachedName = nameCache.get(element);
    if (cachedName) return cachedName;
    const uniqueSelector = getUniqueSelector(selectorConfig, element);
    nameCache.set(element, uniqueSelector);
    return uniqueSelector;
}
exports.default = getElementName;

},{"@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"2UWRF":[function(require,module,exports,__globalThis) {
/* eslint-disable @atlaskit/volt-strict-mode/no-multiple-exports */ var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "resetPressureRecordBuffer", ()=>resetPressureRecordBuffer);
parcelHelpers.export(exports, "resetMemoryRecordBuffer", ()=>resetMemoryRecordBuffer);
parcelHelpers.export(exports, "removeOldPressureBufferRecords", ()=>removeOldPressureBufferRecords);
parcelHelpers.export(exports, "removeOldMemoryBufferRecords", ()=>removeOldMemoryBufferRecords);
parcelHelpers.export(exports, "createPressureStateReport", ()=>createPressureStateReport);
parcelHelpers.export(exports, "createMemoryStateReport", ()=>createMemoryStateReport);
parcelHelpers.export(exports, "initialisePressureObserver", ()=>initialisePressureObserver);
parcelHelpers.export(exports, "initialiseMemoryObserver", ()=>initialiseMemoryObserver);
parcelHelpers.export(exports, "disconnectMemoryObserver", ()=>disconnectMemoryObserver);
parcelHelpers.export(exports, "disconnectPressureObserver", ()=>disconnectPressureObserver);
const BUFFER_MAX_LENGTH = 1000; // ensure we don't blow up this buffer
let pressureRecordBuffer = [];
let pressureObserver = null;
let memoryRecordBuffer = [];
let memoryInterval;
function resetPressureRecordBuffer() {
    pressureRecordBuffer.length = 0;
}
function resetMemoryRecordBuffer() {
    memoryRecordBuffer.length = 0;
}
function removeOldPressureBufferRecords(filter) {
    pressureRecordBuffer = pressureRecordBuffer.filter(({ time })=>time > filter);
}
function removeOldMemoryBufferRecords(filter) {
    memoryRecordBuffer = memoryRecordBuffer.filter(({ time })=>time > filter);
}
function createPressureStateReport(start, end) {
    try {
        // To differentiate between the API not available, vs no PressureRecords added
        if (!('PressureObserver' in globalThis)) return null;
        const pressureStateCount = pressureRecordBuffer.reduce((pressureReport, { time, state })=>{
            if (time >= start && time <= end) pressureReport[state] += 1;
            return pressureReport;
        }, {
            nominal: 0,
            fair: 0,
            serious: 0,
            critical: 0
        });
        const pressureStateTotal = Object.values(pressureStateCount).reduce((total, count)=>total + count) || 1;
        removeOldPressureBufferRecords(end);
        return {
            count: pressureStateCount,
            percentage: {
                nominal: Math.round(pressureStateCount.nominal / pressureStateTotal * 100),
                fair: Math.round(pressureStateCount.fair / pressureStateTotal * 100),
                serious: Math.round(pressureStateCount.serious / pressureStateTotal * 100),
                critical: Math.round(pressureStateCount.critical / pressureStateTotal * 100)
            }
        };
    } catch (e) {
        return null;
    }
}
function convertBytesToMegabytes(bytes) {
    return Math.round(Math.round(bytes / 1048576 * 100) / 100);
}
function createMemoryStateReport(start, end) {
    try {
        if (!('memory' in performance)) return null;
        const accumulatedMemoryUsage = memoryRecordBuffer.reduce((acc, snapshot)=>{
            if (snapshot.time >= start && snapshot.time <= end) {
                acc.totalJSHeapSize += snapshot.totalJSHeapSize;
                acc.usedJSHeapSize += snapshot.usedJSHeapSize;
                acc.snapshotCount += 1;
            }
            return acc;
        }, {
            totalJSHeapSize: 0,
            usedJSHeapSize: 0,
            snapshotCount: 0
        });
        const memoryStateReport = {
            jsHeapSizeLimitInMB: convertBytesToMegabytes(memoryRecordBuffer[0].jsHeapSizeLimit),
            avgTotalJSHeapSizeInMB: convertBytesToMegabytes(accumulatedMemoryUsage.totalJSHeapSize / accumulatedMemoryUsage.snapshotCount),
            avgUsedJSHeapSizeInMB: convertBytesToMegabytes(accumulatedMemoryUsage.usedJSHeapSize / accumulatedMemoryUsage.snapshotCount)
        };
        removeOldMemoryBufferRecords(end);
        return memoryStateReport;
    } catch (e) {
        return null;
    }
}
function initialisePressureObserver() {
    try {
        if ('PressureObserver' in globalThis) {
            pressureObserver = new PressureObserver((records)=>{
                if (pressureRecordBuffer.length + records.length <= BUFFER_MAX_LENGTH) pressureRecordBuffer.push(...records);
            });
            pressureObserver.observe('cpu', {
                sampleInterval: 100
            }).catch(()=>{
            // Silently handle permission policy restrictions or other observe failures
            // This prevents unhandled promise rejections from being reported to Sentry
            });
        }
    } catch (e) {
    /* do nothing, this is a best efforts metric */ }
}
function initialiseMemoryObserver() {
    try {
        // only set up the interval if `performance.memory` is available in the browser
        if ('memory' in performance) memoryInterval = setInterval(()=>{
            // another check of `performance.memory` availability to satisfy typescript
            if ('memory' in performance) {
                const memory = performance.memory;
                if (memoryRecordBuffer.length <= BUFFER_MAX_LENGTH) memoryRecordBuffer.push({
                    time: performance.now(),
                    jsHeapSizeLimit: memory.jsHeapSizeLimit,
                    totalJSHeapSize: memory.totalJSHeapSize,
                    usedJSHeapSize: memory.usedJSHeapSize
                });
            }
        }, 100);
    } catch (e) {
    /* do nothing, this is a best efforts metric */ }
}
function disconnectMemoryObserver() {
    clearInterval(memoryInterval);
}
function disconnectPressureObserver() {
    pressureObserver === null || pressureObserver === void 0 ? void 0 : pressureObserver.disconnect();
}

},{"@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"aMOEQ":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "sinkTerminalErrorHandler", ()=>sinkTerminalErrorHandler);
parcelHelpers.export(exports, "isRelayNetworkError", ()=>isRelayNetworkError);
// eslint-disable-next-line @atlaskit/volt-strict-mode/no-multiple-exports
parcelHelpers.export(exports, "setTerminalError", ()=>setTerminalError);
// eslint-disable-next-line @atlaskit/volt-strict-mode/no-multiple-exports
parcelHelpers.export(exports, "useReportTerminalError", ()=>useReportTerminalError);
var _objectSpread = require("@swc/helpers/_/_object_spread");
var _objectSpreadProps = require("@swc/helpers/_/_object_spread_props");
var _react = require("react");
var _experienceTraceIdContext = require("../experience-trace-id-context");
var _interactionContext = require("../interaction-context");
var _interactionMetrics = require("../interaction-metrics");
var _routeNameContext = require("../route-name-context");
var _routeNameContextDefault = parcelHelpers.interopDefault(_routeNameContext);
var _classifyTerminalError = require("./classify-terminal-error");
let sinkHandlerFn = ()=>{};
function sinkTerminalErrorHandler(fn) {
    sinkHandlerFn = fn;
}
const RELAY_NETWORK_ERRORS_NAME = 'RelayNetwork';
const isRelayNetworkError = (error)=>error.name === RELAY_NETWORK_ERRORS_NAME;
const isErrorObject = (error)=>typeof error === 'object' && error !== null;
const getErrorStatusCode = (error)=>{
    var _error_source_errors__extensions, _error_source_errors_, _error_source_errors, _error_source;
    if (!isErrorObject(error)) return undefined;
    if (isRelayNetworkError(error)) return (_error_source = error.source) === null || _error_source === void 0 ? void 0 : (_error_source_errors = _error_source.errors) === null || _error_source_errors === void 0 ? void 0 : (_error_source_errors_ = _error_source_errors[0]) === null || _error_source_errors_ === void 0 ? void 0 : (_error_source_errors__extensions = _error_source_errors_.extensions) === null || _error_source_errors__extensions === void 0 ? void 0 : _error_source_errors__extensions.statusCode;
    if ('statusCode' in error && typeof error.statusCode === 'number') return error.statusCode;
    return undefined;
};
const getErrorTraceId = (error)=>isErrorObject(error) && 'traceId' in error && typeof error.traceId === 'string' ? error.traceId : undefined;
function setTerminalError(error, additionalAttributes, labelStack) {
    var _error_message, _getActiveTrace;
    const activeInteraction = (0, _interactionMetrics.getActiveInteraction)();
    const currentTime = performance.now();
    const baseErrorData = {
        errorType: error.name || 'Error',
        errorMessage: ((_error_message = error.message) === null || _error_message === void 0 ? void 0 : _error_message.slice(0, 100)) || 'Unknown error',
        timestamp: currentTime,
        errorCategory: (0, _classifyTerminalError.classifyTerminalError)(error)
    };
    var _additionalAttributes_statusCode, _getActiveTrace_traceId;
    const errorData = (0, _objectSpreadProps._)((0, _objectSpread._)({}, baseErrorData), {
        statusCode: (_additionalAttributes_statusCode = additionalAttributes === null || additionalAttributes === void 0 ? void 0 : additionalAttributes.statusCode) !== null && _additionalAttributes_statusCode !== void 0 ? _additionalAttributes_statusCode : getErrorStatusCode(error),
        // Fallback to traceId from error object if it exists (e.g. FetchError)
        traceId: (_getActiveTrace_traceId = (_getActiveTrace = (0, _experienceTraceIdContext.getActiveTrace)()) === null || _getActiveTrace === void 0 ? void 0 : _getActiveTrace.traceId) !== null && _getActiveTrace_traceId !== void 0 ? _getActiveTrace_traceId : getErrorTraceId(error),
        teamName: additionalAttributes === null || additionalAttributes === void 0 ? void 0 : additionalAttributes.teamName,
        packageName: additionalAttributes === null || additionalAttributes === void 0 ? void 0 : additionalAttributes.packageName,
        errorBoundaryId: additionalAttributes === null || additionalAttributes === void 0 ? void 0 : additionalAttributes.errorBoundaryId,
        errorHash: additionalAttributes === null || additionalAttributes === void 0 ? void 0 : additionalAttributes.errorHash,
        fallbackType: additionalAttributes === null || additionalAttributes === void 0 ? void 0 : additionalAttributes.fallbackType
    });
    // Calculate time since previous interaction
    const timeSincePreviousInteraction = (0, _interactionMetrics.PreviousInteractionLog).timestamp != null ? currentTime - (0, _interactionMetrics.PreviousInteractionLog).timestamp : null;
    var _activeInteraction_ufoName, _activeInteraction_id, _activeInteraction_type, _PreviousInteractionLog_id, _PreviousInteractionLog_name, _PreviousInteractionLog_type, _UFORouteName_current;
    const context = {
        labelStack: labelStack !== null && labelStack !== void 0 ? labelStack : null,
        activeInteractionName: (_activeInteraction_ufoName = activeInteraction === null || activeInteraction === void 0 ? void 0 : activeInteraction.ufoName) !== null && _activeInteraction_ufoName !== void 0 ? _activeInteraction_ufoName : null,
        activeInteractionId: (_activeInteraction_id = activeInteraction === null || activeInteraction === void 0 ? void 0 : activeInteraction.id) !== null && _activeInteraction_id !== void 0 ? _activeInteraction_id : null,
        activeInteractionType: (_activeInteraction_type = activeInteraction === null || activeInteraction === void 0 ? void 0 : activeInteraction.type) !== null && _activeInteraction_type !== void 0 ? _activeInteraction_type : null,
        previousInteractionId: (_PreviousInteractionLog_id = (0, _interactionMetrics.PreviousInteractionLog).id) !== null && _PreviousInteractionLog_id !== void 0 ? _PreviousInteractionLog_id : null,
        previousInteractionName: (_PreviousInteractionLog_name = (0, _interactionMetrics.PreviousInteractionLog).name) !== null && _PreviousInteractionLog_name !== void 0 ? _PreviousInteractionLog_name : null,
        previousInteractionType: (_PreviousInteractionLog_type = (0, _interactionMetrics.PreviousInteractionLog).type) !== null && _PreviousInteractionLog_type !== void 0 ? _PreviousInteractionLog_type : null,
        timeSincePreviousInteraction,
        routeName: (_UFORouteName_current = (0, _routeNameContextDefault.default).current) !== null && _UFORouteName_current !== void 0 ? _UFORouteName_current : null
    };
    sinkHandlerFn(errorData, context);
}
function useReportTerminalError(error, additionalAttributes) {
    const interactionContext = (0, _interactionContext.useInteractionContext)();
    const hasReportedRef = (0, _react.useRef)(false);
    (0, _react.useEffect)(()=>{
        if (error && !hasReportedRef.current) {
            hasReportedRef.current = true;
            setTerminalError(error, additionalAttributes, interactionContext === null || interactionContext === void 0 ? void 0 : interactionContext.labelStack);
        }
    }, [
        error,
        additionalAttributes,
        interactionContext === null || interactionContext === void 0 ? void 0 : interactionContext.labelStack
    ]);
}

},{"@swc/helpers/_/_object_spread":"9gdrV","@swc/helpers/_/_object_spread_props":"kANqQ","react":"ltHCL","../experience-trace-id-context":"aWDQC","../interaction-context":"cJnHa","../interaction-metrics":"j4w6h","../route-name-context":"bPLck","./classify-terminal-error":"lG1HF","@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"cJnHa":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
// eslint-disable-next-line @atlaskit/volt-strict-mode/no-multiple-exports
parcelHelpers.export(exports, "useInteractionContext", ()=>useInteractionContext);
var _react = require("react");
var _interactionContext = require("@atlaskit/interaction-context");
var _interactionContextDefault = parcelHelpers.interopDefault(_interactionContext);
exports.default = (0, _interactionContextDefault.default);
function useInteractionContext() {
    return (0, _react.useContext)((0, _interactionContextDefault.default));
}

},{"react":"ltHCL","@atlaskit/interaction-context":"18HT9","@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"18HT9":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _react = require("react");
const interactionContext = (0, _react.createContext)(null);
exports.default = interactionContext;

},{"react":"ltHCL","@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"bPLck":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
// The UFORouteName object is a global singleton
const UFORouteName = {
    current: null
};
exports.default = UFORouteName;

},{"@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"lG1HF":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
/**
 * Classifies an error into a TerminalErrorCategory for UFO terminal error
 * reporting. The category is included in the event payload so that Databricks
 * and SignalFx dashboards can filter/alert by category without silently
 * dropping events.
 *
 * Checks both the error itself and error.cause (one level deep), matching the
 * behaviour of isClientFetchError in jira-fetch. Checks are ordered from
 * most-specific to least-specific to ensure the first matching category wins.
 */ parcelHelpers.export(exports, "classifyTerminalError", ()=>classifyTerminalError);
const ABORT_ERROR_NAMES = new Set([
    'AbortError'
]);
const ABORT_ERROR_MESSAGES = [
    'The operation was aborted',
    'auth_window_closed'
];
// Only treated as abort when combined with AuthError name — the same string
// can appear in other error messages (e.g. 403 response bodies) where it
// should not be classified as abort.
const AUTH_ERROR_ABORT_MESSAGES = [
    'access_denied'
];
// AuthError is thrown by @atlaskit/outbound-auth-flow-client during OAuth flows
// (e.g. connecting third-party apps like GitHub or Bitbucket to Jira).
// User-initiated outcomes (closing the popup, denying consent) are classified
// as abort; server/config failures are classified as auth.
const AUTH_ERROR_NAMES = new Set([
    'AuthError'
]);
const CHUNK_LOAD_ERROR_NAMES = new Set([
    'ChunkLoadError'
]);
const CHUNK_LOAD_ERROR_MESSAGES = [
    'Unable to fetch manifest',
    'dynamically imported module',
    'Importing a module script failed'
];
const NETWORK_CLIENT_ERROR_NAMES = new Set([
    'NetworkError',
    'Network error'
]);
const NETWORK_CLIENT_ERROR_MESSAGES = [
    'Failed to fetch',
    'Load failed',
    'Network request failed',
    'NetworkError',
    'server with the specified hostname could not be found',
    'The network connection was lost',
    'The request timed out',
    'connection failure',
    'CloseEvent: Ping timeout',
    'Curl Error: Failure when receiving data from the peer'
];
const NETWORK_SERVER_ERROR_MESSAGES = [
    '... is not valid JSON',
    'in JSON at position 0',
    'JSON.parse: unexpected character',
    'JSON.parse: unexpected end of data',
    'Unexpected end of input',
    'Unexpected end of JSON input',
    'cannot parse response',
    'Syntax or http error'
];
function matchesCategory(error) {
    var _error_name;
    const name = (_error_name = error.name) !== null && _error_name !== void 0 ? _error_name : '';
    var _error_message;
    const message = (_error_message = error.message) !== null && _error_message !== void 0 ? _error_message : '';
    if (ABORT_ERROR_NAMES.has(name) || ABORT_ERROR_MESSAGES.some((pattern)=>message.includes(pattern)) || // OAuth Abort errors
    AUTH_ERROR_NAMES.has(name) && AUTH_ERROR_ABORT_MESSAGES.some((pattern)=>message.includes(pattern))) return 'abort';
    if (AUTH_ERROR_NAMES.has(name)) return 'auth';
    if (CHUNK_LOAD_ERROR_NAMES.has(name) || CHUNK_LOAD_ERROR_MESSAGES.some((pattern)=>message.includes(pattern))) return 'chunk-load';
    if (NETWORK_CLIENT_ERROR_NAMES.has(name) || NETWORK_CLIENT_ERROR_MESSAGES.some((pattern)=>message.includes(pattern))) return 'network-client';
    if (NETWORK_SERVER_ERROR_MESSAGES.some((pattern)=>message.includes(pattern))) return 'network-server';
    return null;
}
function classifyTerminalError(error) {
    const directMatch = matchesCategory(error);
    if (directMatch) return directMatch;
    if (typeof error === 'object' && error !== null && 'cause' in error && error.cause instanceof Error) {
        const cause = error.cause;
        const causeMatch = matchesCategory(cause);
        if (causeMatch) return causeMatch;
    }
    return 'product';
}

},{"@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"e56bN":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _scheduler = require("scheduler");
var _platformFeatureFlags = require("@atlaskit/platform-feature-flags");
function scheduleIdleCallback(work) {
    if (typeof window !== 'undefined' && typeof window.requestIdleCallback === 'function' && (0, _platformFeatureFlags.fg)('ufo_payload_use_idle_callback')) window.requestIdleCallback(work);
    else (0, _scheduler.unstable_scheduleCallback)((0, _scheduler.unstable_IdlePriority), work);
}
exports.default = scheduleIdleCallback;

},{"scheduler":"NHulo","@atlaskit/platform-feature-flags":"8rD2i","@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"6c6HA":[function(require,module,exports,__globalThis) {
module.exports = require("49d7f3322a80008d")(require("14c3e0eb5ec81114").resolve("diPfx")).then(()=>module.bundle.root('hBT71'));

},{"49d7f3322a80008d":"hkfCW","14c3e0eb5ec81114":"l4T2r"}],"hkfCW":[function(require,module,exports,__globalThis) {
"use strict";
const cacheLoader = require("e82306cc835a39a8");
module.exports = cacheLoader(function loadJSBundle(bundle) {
    return new Promise(function(resolve, reject) {
        // Don't insert the same script twice (e.g. if it was already in the HTML)
        let existingScripts = document.getElementsByTagName('script');
        let isCurrentBundle = function(script) {
            return script.src === bundle;
        };
        if ([].concat(existingScripts).some(isCurrentBundle)) {
            resolve();
            return;
        }
        var preloadLink = document.createElement('link');
        preloadLink.href = bundle;
        preloadLink.rel = 'preload';
        preloadLink.as = 'script';
        document.head.appendChild(preloadLink);
        var script = document.createElement('script');
        script.async = true;
        script.type = 'text/javascript';
        script.src = bundle;
        script.onerror = function(e) {
            var error = new TypeError(`Failed to fetch dynamically imported module: ${bundle}. Error: ${e.message}`);
            script.onerror = script.onload = null;
            script.remove();
            reject(error);
        };
        script.onload = function() {
            script.onerror = script.onload = null;
            resolve();
        };
        document.getElementsByTagName('head')[0].appendChild(script);
    });
});

},{"e82306cc835a39a8":"62BBR"}],"62BBR":[function(require,module,exports,__globalThis) {
"use strict";
let cachedBundles = {};
let cachedPreloads = {};
let cachedPrefetches = {};
function getCache(type) {
    switch(type){
        case 'preload':
            return cachedPreloads;
        case 'prefetch':
            return cachedPrefetches;
        default:
            return cachedBundles;
    }
}
module.exports = function cacheLoader(loader, type) {
    return function(bundle) {
        let cache = getCache(type);
        if (cache[bundle]) return cache[bundle];
        return cache[bundle] = loader.apply(null, arguments).catch(function(e) {
            delete cache[bundle];
            throw e;
        });
    };
};

},{}],"l4T2r":[function(require,module,exports,__globalThis) {
"use strict";
var mapping = new Map();
function register(/** @type {string} */ baseUrl, /** @type {Array<string>} */ manifest // ['id', 'path', 'id2', 'path2']
) {
    for(var i = 0; i < manifest.length - 1; i += 2)mapping.set(manifest[i], {
        baseUrl: baseUrl,
        path: manifest[i + 1]
    });
}
function resolve(id) {
    var resolved = mapping.get(id);
    if (resolved == null) throw new Error('Could not resolve bundle with id ' + id);
    return new URL(resolved.path, resolved.baseUrl).toString();
}
module.exports.register = register;
module.exports.resolve = resolve;

},{}],"5SpPE":[function(require,module,exports,__globalThis) {
module.exports = require("49adc678e1d364a")(require("44c26db66f1520f1").resolve("dmqlX")).then(()=>module.bundle.root('cH3Rx'));

},{"49adc678e1d364a":"hkfCW","44c26db66f1520f1":"l4T2r"}],"j19vk":[function(require,module,exports,__globalThis) {
module.exports = require("e918385fd28e919b")(require("70eb0df146f0e4c3").resolve("gSIum")).then(()=>module.bundle.root('5ngyX'));

},{"e918385fd28e919b":"hkfCW","70eb0df146f0e4c3":"l4T2r"}],"h746D":[function(require,module,exports,__globalThis) {
// eslint-disable-next-line @atlaskit/platform/prefer-crypto-random-uuid -- Use crypto.randomUUID instead
var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
// eslint-disable-next-line @atlaskit/volt-strict-mode/no-multiple-exports
parcelHelpers.export(exports, "updatePageloadName", ()=>updatePageloadName);
var _uuid = require("uuid");
var _coinflip = require("../coinflip");
var _coinflipDefault = parcelHelpers.interopDefault(_coinflip);
var _config = require("../config");
var _experienceTraceIdContext = require("../experience-trace-id-context");
var _interactionIdContext = require("../interaction-id-context");
var _interactionMetrics = require("../interaction-metrics");
var _routeNameContext = require("../route-name-context");
var _routeNameContextDefault = parcelHelpers.interopDefault(_routeNameContext);
const AWAITING_PAGELOAD_NAME = 'awaiting_pageload_name';
function traceUFOPageLoad(ufoName, routeName = ufoName) {
    if (!(0, _config.isUFOEnabled)()) return;
    const activeInteraction = (0, _interactionMetrics.getActiveInteraction)();
    if (activeInteraction && !ufoName) return;
    (0, _routeNameContextDefault.default).current = routeName || null;
    const rate = ufoName ? (0, _config.getInteractionRate)(ufoName, 'page_load') : 1;
    const enabledBySamplingRate = (0, _coinflipDefault.default)(rate);
    if (enabledBySamplingRate && !activeInteraction) {
        // eslint-disable-next-line @atlaskit/platform/prefer-crypto-random-uuid -- Use crypto.randomUUID instead
        const newId = (0, _uuid.v4)();
        (0, _interactionIdContext.DefaultInteractionID).current = newId;
        (0, _interactionMetrics.addNewInteraction)(newId, ufoName || '', 'page_load', 0, rate, null, routeName, (0, _experienceTraceIdContext.getActiveTrace)());
        if (!ufoName) // if no name is provided we add a hold to the interaction, it is removed if the name is provided while the interaction is holding
        (0, _interactionMetrics.addHoldByID)(newId, [], AWAITING_PAGELOAD_NAME, AWAITING_PAGELOAD_NAME, true);
    } else if (!enabledBySamplingRate && activeInteraction && activeInteraction.type === 'page_load') // if there is an active interaction it will be aborted without initialising a new one because the coinflip returned false
    (0, _interactionMetrics.abort)(activeInteraction.id, 'excluded_by_sampling');
    else if (ufoName && activeInteraction && !activeInteraction.ufoName && activeInteraction.type === 'page_load') {
        (0, _interactionMetrics.updatePageLoadInteractionName)(ufoName, routeName);
        (0, _interactionMetrics.removeHoldByID)(activeInteraction.id, AWAITING_PAGELOAD_NAME);
    }
}
exports.default = traceUFOPageLoad;
function updatePageloadName(ufoName, routeName = ufoName) {
    if (!(0, _config.isUFOEnabled)()) return;
    const interaction = (0, _interactionMetrics.getActiveInteraction)();
    if (!interaction || interaction.type !== 'page_load' && interaction.type !== 'transition') return;
    if (ufoName) {
        const rate = (0, _config.getInteractionRate)(ufoName, 'page_load');
        (0, _interactionMetrics.updatePageLoadInteractionName)(ufoName, routeName);
        if ((0, _coinflipDefault.default)(rate)) (0, _routeNameContextDefault.default).current = ufoName;
        else (0, _interactionMetrics.abort)(interaction.id, 'excluded_by_sampling');
    }
    (0, _interactionMetrics.removeHoldByID)(interaction.id, AWAITING_PAGELOAD_NAME);
}

},{"uuid":"5elg8","../coinflip":"e6eL5","../config":"bx9i6","../experience-trace-id-context":"aWDQC","../interaction-id-context":"eBW7s","../interaction-metrics":"j4w6h","../route-name-context":"bPLck","@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"dqOiX":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "useUFOTransitionCompleter", ()=>useUFOTransitionCompleter);
var _react = require("react");
// eslint-disable-next-line @atlaskit/platform/prefer-crypto-random-uuid -- Use crypto.randomUUID instead
var _uuid = require("uuid");
var _coinflip = require("../coinflip");
var _coinflipDefault = parcelHelpers.interopDefault(_coinflip);
var _config = require("../config");
var _experienceTraceIdContext = require("../experience-trace-id-context");
var _interactionIdContext = require("../interaction-id-context");
var _interactionIdContextDefault = parcelHelpers.interopDefault(_interactionIdContext);
var _interactionMetrics = require("../interaction-metrics");
var _routeNameContext = require("../route-name-context");
var _routeNameContextDefault = parcelHelpers.interopDefault(_routeNameContext);
var _setInteractionActiveTrace = require("./utils/set-interaction-active-trace");
function traceUFOTransition(ufoName, routeName = ufoName) {
    if (!(0, _config.isUFOEnabled)()) return;
    const pressInteractionsList = (0, _config.getDoNotAbortActivePressInteractionOnTransition)();
    const interaction = (0, _interactionMetrics.getActiveInteraction)();
    if (pressInteractionsList && interaction) {
        if (pressInteractionsList.includes(interaction.ufoName)) return;
    }
    (0, _interactionMetrics.abortAll)('transition', ufoName !== null && ufoName !== void 0 ? ufoName : undefined);
    if (ufoName) {
        (0, _routeNameContextDefault.default).current = ufoName;
        const rate = (0, _config.getInteractionRate)(ufoName, 'transition');
        if ((0, _coinflipDefault.default)(rate)) {
            // eslint-disable-next-line @atlaskit/platform/prefer-crypto-random-uuid -- Use crypto.randomUUID instead
            const newId = (0, _uuid.v4)();
            (0, _setInteractionActiveTrace.setInteractionActiveTrace)(newId);
            (0, _interactionIdContext.DefaultInteractionID).current = newId;
            (0, _interactionMetrics.addNewInteraction)(newId, ufoName, 'transition', performance.now(), rate, null, routeName, (0, _experienceTraceIdContext.getActiveTrace)());
        }
    }
}
function useUFOTransitionCompleter() {
    const interactionId = (0, _react.useContext)((0, _interactionIdContextDefault.default));
    const capturedInteractionId = interactionId.current;
    (0, _react.useEffect)(()=>{
        // If we have a current interaction set...
        if (capturedInteractionId != null) {
            let cancel = requestAnimationFrame(()=>{
                cancel = requestAnimationFrame(()=>{
                    if (capturedInteractionId === interactionId.current) (0, _interactionMetrics.tryComplete)(capturedInteractionId);
                });
            });
            (0, _interactionMetrics.addOnCancelCallback)(capturedInteractionId, ()=>{
                cancelAnimationFrame(cancel);
            });
        }
    }, [
        capturedInteractionId,
        interactionId
    ]);
}
// eslint-disable-next-line @atlaskit/volt-strict-mode/no-multiple-exports
exports.default = traceUFOTransition;

},{"react":"ltHCL","uuid":"5elg8","../coinflip":"e6eL5","../config":"bx9i6","../experience-trace-id-context":"aWDQC","../interaction-id-context":"eBW7s","../interaction-metrics":"j4w6h","../route-name-context":"bPLck","./utils/set-interaction-active-trace":"lAV10","@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"lAV10":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "setInteractionActiveTrace", ()=>setInteractionActiveTrace);
var _experienceTraceIdContext = require("../../../experience-trace-id-context");
var _generateSpanId = require("../generate-span-id");
function setInteractionActiveTrace(newId) {
    (0, _experienceTraceIdContext.setActiveTrace)(newId.replace(/-/g, ''), (0, _generateSpanId.generateSpanId)(), 'transition');
}

},{"../../../experience-trace-id-context":"aWDQC","../generate-span-id":"jeO3s","@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"jeO3s":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "generateSpanId", ()=>generateSpanId);
function generateSpanId() {
    return Array.from(new Array(16), ()=>Math.floor(Math.random() * 16).toString(16)).join('');
}

},{"@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"hi1dr":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "PageSegment", ()=>PageSegment);
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _reactMagneticDi = require("react-magnetic-di");
var _platformFeatureFlags = require("@atlaskit/platform-feature-flags");
var _reportError = require("@atlaskit/react-ufo/report-error");
var _segment = require("@atlaskit/react-ufo/segment");
var _segmentDefault = parcelHelpers.interopDefault(_segment);
var _components = require("../reliability-tracker/components");
var _studioReliabilityTracker = require("../reliability-tracker/studio-reliability-tracker");
var _sentry = require("../sentry");
const DefaultFallbackComponent = ()=>null;
const defaultShouldReportError = ()=>true;
const PageSegmentInternal = ({ name: segmentName, children, fallbackComponent = DefaultFallbackComponent, suspenseFallback, shouldReportError = defaultShouldReportError, task, taskId, teamName, touchpointId })=>{
    (0, _reactMagneticDi.di)((0, _reportError.useUFOReportError));
    const reportError = (0, _reportError.useUFOReportError)();
    const errorName = `PageSegmentError:${segmentName}`;
    const reliabilityTask = task !== null && task !== void 0 ? task : segmentName;
    const MaybeSuspense = suspenseFallback !== undefined ? (0, _react.Suspense) : (0, _react.Fragment);
    const maybeSuspenseProps = suspenseFallback !== undefined ? {
        fallback: suspenseFallback
    } : {};
    return /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _sentry.SentryErrorBoundary), {
        loggerName: errorName,
        fallbackComponent: fallbackComponent,
        teamName: teamName,
        touchpointId: touchpointId,
        onError: (error)=>{
            if ((0, _platformFeatureFlags.fg)('studio_reliability_tracker_page_segment')) {
                if (shouldReportError(error)) (0, _studioReliabilityTracker.studioReliabilityTracker).fail({
                    task: reliabilityTask,
                    taskId,
                    error
                });
                else (0, _studioReliabilityTracker.studioReliabilityTracker).abort({
                    task: reliabilityTask,
                    taskId,
                    reason: error.message
                });
            }
            if (!shouldReportError(error)) return;
            // TODO(RAGE-3798): remove UFO interaction-error reporting once TOME dashboards migrate.
            // using `useUFOReportError` instead of `setInteractionError`
            // because `setInteractionError` will not work due to mismatching activeInteraction
            // https://atlassian.slack.com/archives/C095EAEKV63/p1756710099202429?thread_ts=1756193218.083929&cid=C095EAEKV63
            reportError({
                name: errorName,
                errorMessage: error.message,
                errorStack: error.stack
            });
        }
    }, (0, _platformFeatureFlags.fg)('studio_reliability_tracker_page_segment') && /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _components.ReliabilityStart), {
        task: reliabilityTask,
        taskId: taskId,
        touchpointId: touchpointId
    }), /*#__PURE__*/ (0, _reactDefault.default).createElement(MaybeSuspense, maybeSuspenseProps, children, (0, _platformFeatureFlags.fg)('studio_reliability_tracker_page_segment') && // Order is important, this should be fired last after suspense
    /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _components.ReliabilitySucceed), {
        task: reliabilityTask,
        taskId: taskId
    })));
};
const PageSegment = (props)=>// TODO(RAGE-3798): remove <UFOSegment> wrapper once TOME dashboards migrate.
    /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _segmentDefault.default), {
        name: props.name
    }, /*#__PURE__*/ (0, _reactDefault.default).createElement(PageSegmentInternal, props));

},{"react":"ltHCL","react-magnetic-di":"hCzc8","@atlaskit/platform-feature-flags":"8rD2i","@atlaskit/react-ufo/report-error":"fGFvW","@atlaskit/react-ufo/segment":"amS4N","../reliability-tracker/components":"jewgo","../reliability-tracker/studio-reliability-tracker":"cMbGI","../sentry":"22o7a","@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"fGFvW":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
/**
 * Usage:
 * ```
 * import { useUFOReportError } from '@atlaskit/react-ufo/use-error-handler';
 *
 * const reportError = useUFOReportError();
 *
 * try {
 *   // something that can throw an error
 * } catch (error) {
 *   reportError(error)
 * }
 * ```
 * @returns `reportError` function
 */ parcelHelpers.export(exports, "useUFOReportError", ()=>useUFOReportError);
var _interactionContext = require("../interaction-context");
var _interactionMetrics = require("../interaction-metrics");
function useUFOReportError() {
    const ufoContext = (0, _interactionContext.useInteractionContext)();
    const reportError = (error)=>{
        const interaction = (0, _interactionMetrics.getActiveInteraction)();
        if (interaction === null || interaction === void 0 ? void 0 : interaction.id) (0, _interactionMetrics.addError)(interaction.id, error.name, (ufoContext === null || ufoContext === void 0 ? void 0 : ufoContext.labelStack) || null, error.name, error.errorMessage, error.errorStack, error.forcedError);
        else (0, _interactionMetrics.addErrorToAll)(error.name, (ufoContext === null || ufoContext === void 0 ? void 0 : ufoContext.labelStack) || null, error.name, error.errorMessage, error.errorStack);
    };
    return reportError;
}

},{"../interaction-context":"cJnHa","../interaction-metrics":"j4w6h","@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"amS4N":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "UFOThirdPartySegment", ()=>(0, _thirdPartySegment.UFOThirdPartySegment));
parcelHelpers.export(exports, "UFOGenAISegment", ()=>(0, _genAiSegment.UFOGenAISegment));
parcelHelpers.export(exports, "flushSsrRenderProfilerTraces", ()=>(0, _ssrRenderProfiler.flushSsrRenderProfilerTraces));
var _segment = require("./segment");
var _segmentDefault = parcelHelpers.interopDefault(_segment);
var _thirdPartySegment = require("./third-party-segment");
var _genAiSegment = require("./gen-ai-segment");
var _ssrRenderProfiler = require("./ssr-render-profiler");
exports.default = (0, _segmentDefault.default);

},{"./segment":"6wPnN","./third-party-segment":"h87G9","./gen-ai-segment":false,"./ssr-render-profiler":false,"@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"6wPnN":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _objectSpread = require("@swc/helpers/_/_object_spread");
var _objectSpreadProps = require("@swc/helpers/_/_object_spread_props");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _scheduler = require("scheduler");
// eslint-disable-next-line @atlaskit/platform/prefer-crypto-random-uuid -- Use crypto.randomUUID instead
var _uuid = require("uuid");
var _coinflip = require("../coinflip");
var _coinflipDefault = parcelHelpers.interopDefault(_coinflip);
var _config = require("../config");
var _utils = require("../create-payload/common/utils");
var _experienceTraceIdContext = require("../experience-trace-id-context");
var _interactionContext = require("../interaction-context");
var _interactionContextDefault = parcelHelpers.interopDefault(_interactionContext);
var _interactionIdContext = require("../interaction-id-context");
var _interactionIdContextDefault = parcelHelpers.interopDefault(_interactionIdContext);
var _interactionMetrics = require("../interaction-metrics");
var _routeNameContext = require("../route-name-context");
var _routeNameContextDefault = parcelHelpers.interopDefault(_routeNameContext);
var _shortId = require("../short-id");
var _shortIdDefault = parcelHelpers.interopDefault(_shortId);
var _scheduleOnPaint = require("./schedule-on-paint");
var _scheduleOnPaintDefault = parcelHelpers.interopDefault(_scheduleOnPaint);
var _ssrRenderProfiler = require("./ssr-render-profiler");
var _ssrRenderProfilerDefault = parcelHelpers.interopDefault(_ssrRenderProfiler);
let tryCompleteHandle;
/** A portion of the page we apply measurement to */ const UFOSegment = ({ name: segmentName, children, mode = 'single', type = 'first-party' })=>{
    // If UFO is disabled, render children without any tracking overhead
    // Note: isUFOEnabled() returns a stable value based on config, so it's safe to call before hooks
    const ufoEnabled = (0, _config.isUFOEnabled)();
    const parentContext = (0, _react.useContext)((0, _interactionContextDefault.default));
    const segmentIdMap = (0, _react.useMemo)(()=>{
        if (!(parentContext === null || parentContext === void 0 ? void 0 : parentContext.segmentIdMap)) return new Map();
        return parentContext.segmentIdMap;
    }, [
        parentContext
    ]);
    const segmentId = (0, _react.useMemo)(()=>{
        if (mode === 'single') return (0, _shortIdDefault.default)();
        if (segmentIdMap.has(segmentName)) return segmentIdMap.get(segmentName);
        const newSegmentId = (0, _shortIdDefault.default)();
        segmentIdMap.set(segmentName, newSegmentId);
        return newSegmentId;
    }, [
        mode,
        segmentName,
        segmentIdMap
    ]);
    const labelStack = (0, _react.useMemo)(()=>(parentContext === null || parentContext === void 0 ? void 0 : parentContext.labelStack) ? [
            ...parentContext.labelStack,
            (0, _objectSpread._)({
                name: segmentName,
                segmentId
            }, type !== 'first-party' ? {
                type
            } : {})
        ] : [
            (0, _objectSpread._)({
                name: segmentName,
                segmentId
            }, type !== 'first-party' ? {
                type
            } : {})
        ], [
        parentContext,
        segmentName,
        segmentId,
        type
    ]);
    const interactionId = (0, _react.useContext)((0, _interactionIdContextDefault.default));
    const interactionContext = (0, _react.useMemo)(()=>{
        let lastCompleteEndTime = 0;
        function complete(endTime = performance.now()) {
            if (interactionId.current) {
                if (parentContext) parentContext.complete();
                else {
                    var _cancelAnimationFrame;
                    const capturedInteractionId = interactionId.current;
                    if (endTime > lastCompleteEndTime) lastCompleteEndTime = endTime;
                    if (tryCompleteHandle) (_cancelAnimationFrame = cancelAnimationFrame) === null || _cancelAnimationFrame === void 0 ? void 0 : _cancelAnimationFrame(tryCompleteHandle);
                    const onComplete = ()=>{
                        if (capturedInteractionId === interactionId.current) {
                            var _globalThis_document, _globalThis;
                            const isPageVisible = ((_globalThis = globalThis) === null || _globalThis === void 0 ? void 0 : (_globalThis_document = _globalThis.document) === null || _globalThis_document === void 0 ? void 0 : _globalThis_document.visibilityState) === 'visible';
                            const canDoRAF = typeof requestAnimationFrame !== 'undefined';
                            if (isPageVisible && canDoRAF) tryCompleteHandle = requestAnimationFrame(()=>{
                                tryCompleteHandle = requestAnimationFrame(()=>{
                                    if (capturedInteractionId === interactionId.current) (0, _interactionMetrics.tryComplete)(interactionId.current, lastCompleteEndTime);
                                });
                            });
                            else (0, _interactionMetrics.tryComplete)(interactionId.current, lastCompleteEndTime);
                        }
                    };
                    (0, _scheduler.unstable_scheduleCallback)((0, _scheduler.unstable_NormalPriority), onComplete);
                }
            }
        }
        function _internalHold(labelStack, name) {
            if (interactionId.current != null) {
                if (parentContext) return parentContext._internalHold(labelStack, name);
                else {
                    const capturedInteractionId = interactionId.current;
                    const disposeHold = (0, _interactionMetrics.addHold)(interactionId.current, labelStack, name, false);
                    return ()=>{
                        if (capturedInteractionId === interactionId.current) disposeHold();
                    };
                }
            }
        }
        function _internalHoldByID(labelStack, id, name, remove) {
            if (interactionId.current != null) {
                if (parentContext) {
                    parentContext._internalHoldByID(labelStack, name, id, remove);
                    return;
                }
                if (!remove) (0, _interactionMetrics.addHoldByID)(interactionId.current, labelStack, name, id);
                else (0, _interactionMetrics.removeHoldByID)(interactionId.current, id);
            }
        }
        if (parentContext) return (0, _objectSpreadProps._)((0, _objectSpread._)({}, parentContext), {
            labelStack,
            complete
        });
        return {
            labelStack,
            segmentIdMap: segmentIdMap,
            hold (name = 'unknown') {
                return this._internalHold(this.labelStack, name);
            },
            addHoldByID (labelStack, id, name = 'unknown') {
                this._internalHoldByID(labelStack, id, name, false);
            },
            removeHoldByID (labelStack, id, name = 'unknown') {
                this._internalHoldByID(labelStack, id, name, true);
            },
            tracePress (name = 'unknown', timestamp) {
                var _getDoNotAbortActivePressInteraction, _getMinorInteractions;
                const minorInteractions = [
                    ...(_getDoNotAbortActivePressInteraction = (0, _config.getDoNotAbortActivePressInteraction)()) !== null && _getDoNotAbortActivePressInteraction !== void 0 ? _getDoNotAbortActivePressInteraction : [],
                    ...(_getMinorInteractions = (0, _config.getMinorInteractions)()) !== null && _getMinorInteractions !== void 0 ? _getMinorInteractions : []
                ];
                if (minorInteractions.includes(name)) {
                    var _activeInteraction_minorInteractions;
                    const activeInteraction = (0, _interactionMetrics.getActiveInteraction)();
                    activeInteraction === null || activeInteraction === void 0 ? void 0 : (_activeInteraction_minorInteractions = activeInteraction.minorInteractions) === null || _activeInteraction_minorInteractions === void 0 ? void 0 : _activeInteraction_minorInteractions.push({
                        name,
                        startTime: timestamp !== null && timestamp !== void 0 ? timestamp : performance.now()
                    });
                    return;
                } else if (interactionId.current != null) (0, _interactionMetrics.abortByNewInteraction)(interactionId.current, name);
                const rate = (0, _config.getInteractionRate)(name, 'press');
                if ((0, _coinflipDefault.default)(rate)) {
                    const startTimestamp = timestamp !== null && timestamp !== void 0 ? timestamp : performance.now();
                    // eslint-disable-next-line @atlaskit/platform/prefer-crypto-random-uuid -- Use crypto.randomUUID instead
                    const newId = (0, _uuid.v4)();
                    interactionId.current = newId;
                    // covered experiences with tracing instrumentation:
                    // inline-result.global-issue.create-modal.submit
                    // inline-result.global-issue.create-modal-subsequent
                    (0, _experienceTraceIdContext.setInteractionActiveTrace)(newId, 'press');
                    (0, _interactionMetrics.addNewInteraction)(newId, name, 'press', startTimestamp, rate, this.labelStack, (0, _routeNameContextDefault.default).current, (0, _experienceTraceIdContext.getActiveTrace)());
                }
            },
            retainQuery (info) {
                if (interactionId.current != null) (0, _interactionMetrics.addRequestInfo)(interactionId.current, this.labelStack, info);
            },
            addPreload (moduleId, timestamp) {
                if (interactionId.current != null) (0, _interactionMetrics.addMark)(interactionId.current, 'bundle_preload', moduleId, this.labelStack, timestamp);
            },
            addLoad (identifier, start, end) {
                if (interactionId.current != null) {
                    const { labelStack = [] } = this;
                    (0, _interactionMetrics.addSpan)(interactionId.current, 'bundle_load', identifier, labelStack, start, end);
                }
            },
            addMark (name, timestamp) {
                if (interactionId.current != null) {
                    const time = timestamp !== null && timestamp !== void 0 ? timestamp : performance.now();
                    (0, _interactionMetrics.addMark)(interactionId.current, 'custom', name, this.labelStack, time);
                }
            },
            addCustomData (customData) {
                if (interactionId.current != null) (0, _interactionMetrics.addCustomData)(interactionId.current, this.labelStack, customData);
            },
            addCustomTimings (customTimings) {
                if (interactionId.current != null) (0, _interactionMetrics.addCustomTiming)(interactionId.current, this.labelStack, customTimings);
            },
            addApdex (apdexInfo) {
                if (interactionId.current != null) {
                    const { key, stopTime, startTime } = apdexInfo;
                    (0, _interactionMetrics.addApdex)(interactionId.current, {
                        key,
                        stopTime,
                        startTime,
                        labelStack: this.labelStack
                    });
                }
            },
            onRender (phase, actualDuration, baseDuration, startTime, commitTime) {
                if (interactionId.current !== null) {
                    (0, _interactionMetrics.addProfilerTimings)(interactionId.current, this.labelStack, phase, actualDuration, baseDuration, startTime, commitTime);
                    (0, _scheduleOnPaintDefault.default)(()=>{
                        const paintedTime = performance.now();
                        this.complete(paintedTime);
                    });
                }
            },
            _internalHold,
            _internalHoldByID,
            complete
        };
    }, [
        parentContext,
        labelStack,
        segmentIdMap,
        interactionId
    ]);
    const hasMounted = (0, _react.useRef)(false);
    const onRender = (0, _react.useCallback)((_id, phase, actualDuration, baseDuration, startTime, commitTime)=>{
        var _getConfig;
        // Manually keep track of mount-phase, and ensure that every segment is always mounted at least once
        if (((_getConfig = (0, _config.getConfig)()) === null || _getConfig === void 0 ? void 0 : _getConfig.manuallyTrackReactProfilerMounts) && !hasMounted.current) {
            interactionContext.onRender('mount', actualDuration, baseDuration, startTime, commitTime);
            hasMounted.current = true;
        } else interactionContext.onRender(phase, actualDuration, baseDuration, startTime, commitTime);
    }, [
        interactionContext
    ]);
    (0, _react.useEffect)(()=>{
        (0, _interactionMetrics.addSegment)(labelStack);
        return ()=>{
            (0, _interactionMetrics.removeSegment)(labelStack);
        };
    }, [
        interactionId,
        parentContext,
        interactionContext,
        labelStack
    ]);
    const reactProfilerId = (0, _react.useMemo)(()=>labelStack.map((l)=>(0, _utils.sanitizeLabelStackName)(l.name)).join('/'), [
        labelStack
    ]);
    // If UFO is disabled, just render children without tracking overhead
    if (!ufoEnabled) return /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _reactDefault.default).Fragment, null, children);
    const ufoSegment = /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _interactionContextDefault.default).Provider, {
        value: interactionContext
    }, /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _react.Profiler), {
        id: reactProfilerId,
        onRender: onRender
    }, children));
    return /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _ssrRenderProfilerDefault.default), {
        labelStack: labelStack,
        onRender: (...args)=>interactionContext.onRender.apply(interactionContext, args)
    }, ufoSegment);
};
UFOSegment.displayName = 'UFOSegment';
exports.default = UFOSegment;

},{"@swc/helpers/_/_object_spread":"9gdrV","@swc/helpers/_/_object_spread_props":"kANqQ","react":"ltHCL","scheduler":"NHulo","uuid":"5elg8","../coinflip":"e6eL5","../config":"bx9i6","../create-payload/common/utils":"bqJei","../experience-trace-id-context":"aWDQC","../interaction-context":"cJnHa","../interaction-id-context":"eBW7s","../interaction-metrics":"j4w6h","../route-name-context":"bPLck","../short-id":"aUDYg","./schedule-on-paint":"8g9o5","./ssr-render-profiler":"b0GDU","@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"aUDYg":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
function generateId(length = 7) {
    const characters = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789';
    let result = '';
    for(let i = 0; i < length; i++)result += characters.charAt(Math.floor(Math.random() * characters.length));
    return result;
}
exports.default = generateId;

},{"@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"8g9o5":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var process = require("9deca7cd8c934c7e");
function scheduleOnPaint(callback) {
    var _globalThis, _process_env, _globalThis_document;
    const isSSR = typeof window === 'undefined' || Boolean((_globalThis = globalThis) === null || _globalThis === void 0 ? void 0 : _globalThis.__SERVER__) || typeof process !== 'undefined' && Boolean(process === null || process === void 0 ? void 0 : (_process_env = process.env) === null || _process_env === void 0 ? void 0 : _process_env.REACT_SSR);
    if (isSSR) {
        // In SSR, execute callback immediately (no paint event exists)
        callback();
        return;
    }
    if (((_globalThis_document = globalThis.document) === null || _globalThis_document === void 0 ? void 0 : _globalThis_document.visibilityState) !== 'visible') {
        // last resort fallback
        setTimeout(callback, 100);
        return;
    }
    // Check if the Scheduler API is available
    if (typeof window.scheduler !== 'undefined' && typeof window.scheduler.postTask === 'function') // Use scheduler.postTask if available
    // https://developer.mozilla.org/en-US/docs/Web/API/Prioritized_Task_Scheduling_API
    // Make sure we are scheduling this task before the browser paint the next frame
    requestAnimationFrame(()=>{
        window.scheduler.postTask(callback, {
            priority: 'user-visible'
        });
    });
    else if (typeof requestAnimationFrame !== 'undefined') // Fallback to using double requestAnimationFrame
    requestAnimationFrame(()=>{
        requestAnimationFrame(()=>{
            callback();
        });
    });
}
exports.default = scheduleOnPaint;

},{"9deca7cd8c934c7e":"gNLf3","@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"h87G9":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "UFOThirdPartySegment", ()=>UFOThirdPartySegment);
var _objectSpread = require("@swc/helpers/_/_object_spread");
var _objectWithoutProperties = require("@swc/helpers/_/_object_without_properties");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _interactionContext = require("../interaction-context");
var _interactionContextDefault = parcelHelpers.interopDefault(_interactionContext);
var _interactionIdContext = require("../interaction-id-context");
var _interactionIdContextDefault = parcelHelpers.interopDefault(_interactionIdContext);
var _interactionMetrics = require("../interaction-metrics");
var _ufoloadHold = require("../load-hold/UFOLoadHold");
var _ufoloadHoldDefault = parcelHelpers.interopDefault(_ufoloadHold);
var _shapeResourceTiming = require("../resource-timing/common/utils/shape-resource-timing");
var _segment = require("./segment");
var _segmentDefault = parcelHelpers.interopDefault(_segment);
var _shapeIframeDomEvents = require("./shape-iframe-dom-events");
const FORGE_TTAI_EVENT_PREFIX = 'ufo-forge';
// Early-signal event emitted by the iframe bridge as soon as it wires up its
// UFO observers. Receiving this within ABORT_TIMEOUT_INITIAL_MS tells us the
// iframe is on the new rollout cohort and will send data events.
const FORGE_INIT_EVENT = 'ufo-forge-init';
// Grace period (ms) after the navigation hold releases before finalising.
const GRACE_PERIOD_MS = 2000;
// Initial abort timeout (ms from mount). If no recognised iframe event arrives within
// this window, the hold is force-released and an abort marker is logged. This protects
// metric quality during progressive rollouts where old-cohort iframes never emit events.
const ABORT_TIMEOUT_INITIAL_MS = 6000;
// Per-segment cap on the number of `resized` entries forwarded to addIframeSegmentData.
// useResizeAnalytics already limits emissions to a 10s tracking window, but a chatty
// app could still produce dozens of resizes; combined with many Forge apps on one
// page this could push segment3pData toward the 60 KB soft limit. The cap provides
// defence-in-depth without affecting realistic apps (typical <20 resizes per segment).
const MAX_RESIZED_ENTRIES_PER_SEGMENT = 50;
// Extended abort timeout (ms from mount). Once any recognised iframe event is received
// we know the iframe is on the new rollout cohort and actively sending data, so we extend
// the window to accommodate legitimately slow-loading Forge apps.
const ABORT_TIMEOUT_EXTENDED_MS = 30000;
// Events logged via addIframeSegmentData as they arrive.
const IFRAME_SEGMENT_DATA_SUFFIXES = [
    'resource-timing',
    'paint-timing',
    'largest-contentful-paint',
    'layout-shift',
    'dom-mutations',
    'navigation-timing'
];
// Events that extend the forge-ui-requests corrected end-time during grace.
const NAV_HOLD_GRACE_SUFFIXES = new Set([
    'navigation-timing',
    'resource-timing'
]);
/** Reads segmentId from UFOInteractionContext and stores it in a ref. */ function IframeSegmentIdReader({ segmentIdRef }) {
    const context = (0, _react.useContext)((0, _interactionContextDefault.default));
    const labelStack = context === null || context === void 0 ? void 0 : context.labelStack;
    const segmentId = labelStack && labelStack.length > 0 ? labelStack[labelStack.length - 1].segmentId : undefined;
    if (segmentId && segmentIdRef.current !== segmentId) segmentIdRef.current = segmentId;
    return null;
}
/** Subscribes to iframe performance events and records them as segment3pTimings. */ function IframeSegment({ onRegisterIframeEventListener, appType }) {
    const interactionId = (0, _react.useContext)((0, _interactionIdContextDefault.default));
    const interactionContext = (0, _react.useContext)((0, _interactionContextDefault.default));
    const segmentIdRef = (0, _react.useRef)(undefined);
    // Per-segment counter for `resized` entries (defence-in-depth payload cap).
    // Tracks both the count AND the segmentId it was last incremented under, so
    // SPA navigations that swap segmentId reset the budget for the new segment.
    const resizedCountRef = (0, _react.useRef)(0);
    const resizedCounterSegmentIdRef = (0, _react.useRef)(undefined);
    const isUiKit = appType === 'UIKit';
    // Released on the first navigation-timing event from the iframe.
    const [navigationHold, setNavigationHold] = (0, _react.useState)('holding');
    // UIKit: wrap onRender to account for React Profiler timings
    // Accumulates profiler timing bounds so we emit one aggregated entry at cleanup.
    const profilerAccRef = (0, _react.useRef)(null);
    (0, _react.useLayoutEffect)(()=>{
        if (!isUiKit || !interactionContext || !interactionContext.onRender) return;
        const originalOnRender = interactionContext.onRender.bind(interactionContext);
        interactionContext.onRender = function(phase, actualDuration, baseDuration, startTime, commitTime) {
            originalOnRender(phase, actualDuration, baseDuration, startTime, commitTime);
            // Accumulate timing bounds into a single entry.
            const start = Math.round(startTime);
            const end = Math.round(commitTime);
            if (profilerAccRef.current === null) profilerAccRef.current = {
                startTime: start,
                endTime: end
            };
            else {
                if (start < profilerAccRef.current.startTime) profilerAccRef.current.startTime = start;
                if (end > profilerAccRef.current.endTime) profilerAccRef.current.endTime = end;
            }
        };
        return ()=>{
            interactionContext.onRender = originalOnRender;
        };
    }, [
        isUiKit,
        interactionContext,
        interactionId
    ]);
    (0, _react.useEffect)(()=>{
        let navigationHoldReleased = false;
        let lastNavEventTime = null;
        let gracePeriodTimer = null;
        // Tracks whether any recognised iframe event has been received, which tells us
        // the iframe is on the new rollout cohort and actively sending data.
        let iframeEventsReceived = false;
        let abortTimer;
        const mountTime = performance.now();
        const fireAbort = (abortAfterMs)=>{
            // Cancel any pending grace period so it doesn't also fire.
            if (gracePeriodTimer !== null) {
                clearTimeout(gracePeriodTimer);
                gracePeriodTimer = null;
            }
            // Force-release the hold if still active at abort time.
            if (!navigationHoldReleased) {
                navigationHoldReleased = true;
                setNavigationHold('released');
            }
            // Record the abort marker so downstream analytics can detect it.
            if (interactionId.current && segmentIdRef.current) (0, _interactionMetrics.addIframeSegmentData)(interactionId.current, segmentIdRef.current, {
                label: 'segment-timing-abort',
                data: {
                    reason: 'timeout',
                    abortAfterMs
                }
            });
        };
        // Start with the short initial timeout. If no ufo-forge-init signal arrives
        // within this window, the iframe is likely an old-cohort app that will never
        // send events — abort early to avoid blocking the interaction indefinitely.
        abortTimer = setTimeout(()=>{
            if (!iframeEventsReceived) fireAbort(ABORT_TIMEOUT_INITIAL_MS);
        }, ABORT_TIMEOUT_INITIAL_MS);
        const finaliseHolds = ()=>{
            const iid = interactionId.current;
            const lStack = interactionContext === null || interactionContext === void 0 ? void 0 : interactionContext.labelStack;
            if (iid && lStack) {
                if (lastNavEventTime !== null) (0, _interactionMetrics.addCompletedHold)(iid, lStack, 'forge-ui-requests', mountTime, lastNavEventTime);
            }
        };
        const scheduleGracePeriodExpiry = ()=>{
            // Reset the 2s countdown each time a new event arrives during the grace period.
            if (gracePeriodTimer !== null) clearTimeout(gracePeriodTimer);
            gracePeriodTimer = setTimeout(()=>{
                clearTimeout(abortTimer);
                finaliseHolds();
            }, GRACE_PERIOD_MS);
        };
        const maybeStartGracePeriod = ()=>{
            if (navigationHoldReleased && gracePeriodTimer === null) scheduleGracePeriodExpiry();
        };
        const handleEvent = (event)=>{
            // Host-side `resized` events come from useResizeAnalytics (forge-ui).
            // They are emitted whenever the iframe container height changes during
            // the 10s tracking window after mount. We forward only the reliable
            // fields (height, elapsed). The `measuredHeight` and `viewportHeight`
            // fields are intentionally excluded because they require a vendor
            // config that is rarely populated in practice (almost always null).
            if (event.type === 'resized') {
                // Guard against malformed payloads (height is required and must be
                // a non-negative number; useResizeAnalytics emits Math.trunc'd ints).
                // `IframeSegmentEvent` already declares `[key: string]: unknown`, so
                // no `as` cast is needed — the typeof guards handle runtime safety.
                const { height, elapsed } = event;
                // Reset the per-segment counter when the active segmentId changes
                // (SPA navigations swap segments; each gets a fresh budget).
                if (segmentIdRef.current && segmentIdRef.current !== resizedCounterSegmentIdRef.current) {
                    resizedCountRef.current = 0;
                    resizedCounterSegmentIdRef.current = segmentIdRef.current;
                }
                if (typeof height === 'number' && Number.isFinite(height) && height >= 0 && typeof elapsed === 'number' && Number.isFinite(elapsed) && elapsed >= 0 && resizedCountRef.current < MAX_RESIZED_ENTRIES_PER_SEGMENT && interactionId.current && segmentIdRef.current) {
                    resizedCountRef.current += 1;
                    (0, _interactionMetrics.addIframeSegmentData)(interactionId.current, segmentIdRef.current, {
                        label: 'resized',
                        data: {
                            height,
                            elapsed
                        }
                    });
                }
                // NOTE: we deliberately do NOT set iframeEventsReceived = true here.
                // The 6s abort timer exists to detect old-cohort iframes that won't
                // emit bridge events. `resized` is a host-side signal (forge-ui's
                // ResizeObserver) and fires regardless of which bridge version the
                // iframe is serving, so it cannot confirm new-cohort membership.
                // Only bridge-emitted `ufo-forge-*` events (esp. `ufo-forge-init`)
                // are valid proof, and they extend the abort timeout below.
                return;
            }
            if (event.type !== 'ufo-event' || typeof event.name !== 'string' || !event.name.startsWith(FORGE_TTAI_EVENT_PREFIX)) return;
            const eventName = event.name;
            const suffix = IFRAME_SEGMENT_DATA_SUFFIXES.find((s)=>eventName.endsWith(`-${s}`));
            if (suffix && interactionId.current && segmentIdRef.current) {
                const { type } = event, rest = (0, _objectWithoutProperties._)(event, [
                    "type"
                ]);
                const restData = rest;
                let data;
                if (suffix === 'resource-timing') data = (0, _shapeResourceTiming.shapeResourceTimingData)(restData);
                else if (suffix === 'navigation-timing') data = (0, _shapeResourceTiming.shapeNavigationTimingData)(restData);
                else if (suffix === 'paint-timing') data = (0, _shapeIframeDomEvents.shapePaintTimingData)(restData);
                else if (suffix === 'largest-contentful-paint') data = (0, _shapeIframeDomEvents.shapeLargestContentfulPaintData)(restData);
                else if (suffix === 'layout-shift') data = (0, _shapeIframeDomEvents.shapeLayoutShiftData)(restData);
                else if (suffix === 'dom-mutations') {
                    // Skip intermediate batches — only record the final summary batch.
                    if (!(0, _shapeIframeDomEvents.isDomMutationsFinalBatch)(restData)) return;
                    data = (0, _shapeIframeDomEvents.shapeDomMutationsData)(restData);
                } else data = restData;
                if (data !== undefined) (0, _interactionMetrics.addIframeSegmentData)(interactionId.current, segmentIdRef.current, {
                    label: suffix,
                    data
                });
            }
            // ufo-forge-init confirms the iframe is on the new rollout cohort — extend the abort window.
            if (eventName === FORGE_INIT_EVENT && !iframeEventsReceived) {
                iframeEventsReceived = true;
                clearTimeout(abortTimer);
                const remainingMs = Math.max(ABORT_TIMEOUT_EXTENDED_MS - (performance.now() - mountTime), 0);
                abortTimer = setTimeout(()=>{
                    fireAbort(ABORT_TIMEOUT_EXTENDED_MS);
                }, remainingMs);
            }
            if (eventName.endsWith('-navigation-timing') && !navigationHoldReleased) {
                navigationHoldReleased = true;
                setNavigationHold('released');
                maybeStartGracePeriod();
            }
            if (navigationHoldReleased) {
                const now = performance.now();
                if (suffix && NAV_HOLD_GRACE_SUFFIXES.has(suffix)) {
                    lastNavEventTime = now;
                    scheduleGracePeriodExpiry();
                }
            }
        };
        const unregister = onRegisterIframeEventListener(handleEvent);
        // Emit react-profiler-timing for UI kit
        const activeInteraction = (0, _interactionMetrics.getActiveInteraction)();
        let isUnmounted = false;
        if (activeInteraction) activeInteraction.cleanupCallbacks.push(()=>{
            if (isUnmounted) return;
            const iid = interactionId.current;
            const sid = segmentIdRef.current;
            if (iid && sid && profilerAccRef.current !== null) {
                (0, _interactionMetrics.addIframeSegmentData)(iid, sid, {
                    label: 'react-profiler-timing',
                    data: (0, _objectSpread._)({}, profilerAccRef.current)
                });
                profilerAccRef.current = null;
            }
        });
        return ()=>{
            isUnmounted = true;
            unregister();
            clearTimeout(abortTimer);
            if (gracePeriodTimer !== null) clearTimeout(gracePeriodTimer);
        };
    }, [
        onRegisterIframeEventListener,
        interactionId,
        interactionContext
    ]);
    return /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _reactDefault.default).Fragment, null, /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _ufoloadHoldDefault.default), {
        name: "forge-ui-requests",
        hold: navigationHold === 'holding'
    }), /*#__PURE__*/ (0, _reactDefault.default).createElement(IframeSegmentIdReader, {
        segmentIdRef: segmentIdRef
    }));
}
/** Writes per-segment extraData via addSegmentExtraData. */ function SegmentExtraDataWriter({ extraData }) {
    const interactionContext = (0, _react.useContext)((0, _interactionContextDefault.default));
    const interactionId = (0, _react.useContext)((0, _interactionIdContextDefault.default));
    const labelStack = interactionContext === null || interactionContext === void 0 ? void 0 : interactionContext.labelStack;
    const segmentId = labelStack && labelStack.length > 0 ? labelStack[labelStack.length - 1].segmentId : undefined;
    (0, _react.useEffect)(()=>{
        const currentInteractionId = interactionId.current;
        if (segmentId && currentInteractionId) (0, _interactionMetrics.addSegmentExtraData)(currentInteractionId, segmentId, extraData);
    }, [
        extraData,
        segmentId,
        interactionId
    ]);
    return null;
}
const UFOThirdPartySegment = (props)=>{
    const { children, onRegisterIframeEventListener, extraData } = props, otherProps = (0, _objectWithoutProperties._)(props, [
        "children",
        "onRegisterIframeEventListener",
        "extraData"
    ]);
    return /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _segmentDefault.default), (0, _objectSpread._)({
        type: "third-party"
    }, otherProps), onRegisterIframeEventListener && extraData && /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _reactDefault.default).Fragment, null, /*#__PURE__*/ (0, _reactDefault.default).createElement(IframeSegment, {
        onRegisterIframeEventListener: onRegisterIframeEventListener,
        appType: extraData.appType
    }), /*#__PURE__*/ (0, _reactDefault.default).createElement(SegmentExtraDataWriter, {
        extraData: extraData
    })), children);
};
UFOThirdPartySegment.displayName = 'UFOThirdPartySegment';

},{"@swc/helpers/_/_object_spread":"9gdrV","@swc/helpers/_/_object_without_properties":"6HqIM","react":"ltHCL","../interaction-context":"cJnHa","../interaction-id-context":"eBW7s","../interaction-metrics":"j4w6h","../load-hold/UFOLoadHold":"l7xK8","../resource-timing/common/utils/shape-resource-timing":"4u4v1","./segment":"6wPnN","./shape-iframe-dom-events":"hKmGZ","@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"l7xK8":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>UFOLoadHold);
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _config = require("../config");
var _interactionContext = require("../interaction-context");
var _interactionContextDefault = parcelHelpers.interopDefault(_interactionContext);
var _interactionIdContext = require("../interaction-id-context");
var _interactionIdContextDefault = parcelHelpers.interopDefault(_interactionIdContext);
const useLayoutEffectSAFE = typeof window === 'undefined' ? (0, _react.useEffect) : (0, _react.useLayoutEffect);
/**
 * Custom hook to track changes to the interaction ID.
 * Uses a subscription system to automatically update when the interaction ID changes.
 */ function useInteractionIdValue() {
    const interactionId = (0, _react.useContext)((0, _interactionIdContextDefault.default));
    const [currentId, setCurrentId] = (0, _react.useState)((interactionId === null || interactionId === void 0 ? void 0 : interactionId.current) || null);
    useLayoutEffectSAFE(()=>{
        setCurrentId((interactionId === null || interactionId === void 0 ? void 0 : interactionId.current) || null);
        const unsubscribe = (0, _interactionIdContext.subscribeToInteractionIdChanges)((newId)=>{
            setCurrentId(newId);
        });
        return unsubscribe;
    }, [
        interactionId
    ]);
    return currentId;
}
function UFOLoadHold({ children, name, hold = true }) {
    // Check if UFO is enabled
    // Note: isUFOEnabled() returns a stable value based on config, so it's safe to call before hooks
    const ufoEnabled = (0, _config.isUFOEnabled)();
    const currentInteractionId = useInteractionIdValue();
    // react-18: useId instead
    const context = (0, _react.useContext)((0, _interactionContextDefault.default));
    useLayoutEffectSAFE(()=>{
        // Skip hold registration if UFO is disabled
        if (!ufoEnabled) return;
        if (hold && context != null) return context.hold(name);
    }, [
        hold,
        context,
        name,
        currentInteractionId,
        ufoEnabled
    ]);
    // react-18: can return children directly
    return children != null ? /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _reactDefault.default).Fragment, null, children) : null;
}

},{"react":"ltHCL","../config":"bx9i6","../interaction-context":"cJnHa","../interaction-id-context":"eBW7s","@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"4u4v1":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
/**
 * Shapes a raw iframe navigation-timing event data object into the same field set
 * produced by getNavigationMetrics() in create-payload/utils/get-navigation-metrics.ts,
 * so that iframe navigation timings are consistent with host-page navigation timings.
 *
 * Deliberately omitted fields (same rationale as host-page):
 *   domComplete, domContentLoadedEventStart/End, domInteractive, loadEventStart/End
 * Also dropped: iframe-specific pre-computed `metrics` object, top-level `startTime`/`duration`
 *
 * The iframe event structure is: { name, elapsed, payload: { name, startTime, duration, type,
 *   redirectCount, timing: { ... }, metrics: { ... } } }
 */ parcelHelpers.export(exports, "shapeNavigationTimingData", ()=>shapeNavigationTimingData);
/**
 * Shapes a raw iframe resource-timing event data object into the same field set
 * produced by getResourceTimings() / getNetworkData() in resource-timing/main.ts,
 * so that iframe resource timings are consistent with host-page resource timings.
 *
 * The iframe event structure is: { name, elapsed, payload: { name, startTime, ... timing: { ... } } }
 * All timing fields live inside `payload`, with sub-timing fields inside `payload.timing`.
 */ // eslint-disable-next-line @atlaskit/volt-strict-mode/no-multiple-exports
parcelHelpers.export(exports, "shapeResourceTimingData", ()=>shapeResourceTimingData);
var _objectSpread = require("@swc/helpers/_/_object_spread");
var _resourceTimingInitiatorTypes = require("./resource-timing-initiator-types");
var _transferType = require("./transfer-type");
const num = (v)=>typeof v === 'number' ? Math.round(v) : 0;
// Accepted source values from forge-cdn bridge:
//   - 'forge-framework' (PR #775+) — Forge runtime assets (bridge.js, iframeResizer*, etc.)
//   - 'forge-app'       (PR #775+) — app-author assets on installation-scoped subdomain
//   - 'external'        (both schemes) — anything outside Atlassian-controlled domains
//   - 'internal'        (PR #769 only, LEGACY) — bridges still emit this until PR #775
//                       rolls out everywhere; safe to remove from this allowlist after
//                       the rollout has been stable for a release cycle. Do NOT remove
//                       'external' during that cleanup — it's a first-class value in
//                       both the old and new schemes.
const ACCEPTED_SOURCES = [
    'forge-framework',
    'forge-app',
    'external',
    'internal'
];
const ASSET_RESOURCE_TYPES = new Set([
    'script',
    'link',
    'css'
]);
const OTHER_JS_RESOURCE_TYPE = 'other';
const SCRIPT_EXTENSIONS = [
    '.js',
    '.mjs',
    '.cjs'
];
const STYLESHEET_EXTENSIONS = [
    '.css'
];
const ASSET_EXTENSIONS = [
    ...SCRIPT_EXTENSIONS,
    ...STYLESHEET_EXTENSIONS
];
const FILE_OR_MEDIA_EXTENSIONS = [
    '.pdf',
    '.doc',
    '.docx',
    '.xls',
    '.xlsx',
    '.ppt',
    '.pptx',
    '.csv',
    '.zip',
    '.heic',
    '.mov',
    '.mp4',
    '.mp3',
    '.wav',
    '.woff',
    '.woff2',
    '.ttf',
    '.otf'
];
const IMAGE_EXTENSIONS = [
    '.png',
    '.jpg',
    '.jpeg',
    '.gif',
    '.webp',
    '.svg',
    '.ico'
];
const IMAGE_RESOURCE_LABEL = '<image-resource>';
const FILE_RESOURCE_LABEL = '<file-resource>';
const AVATAR_RESOURCE_LABEL = '<avatar-resource>';
const ATTACHMENT_OR_DOWNLOAD_PATH_PATTERNS = [
    /(?:^|\/)secure\/attachment(?:\/|$)/,
    /(?:^|\/)download\/attachments(?:\/|$)/,
    /(?:^|\/)wiki\/download(?:\/|$)/,
    /(?:^|\/)child\/attachment(?:\/|$)/,
    /(?:^|\/)attachment(?:\/|$)/
];
function stripQueryAndHash(value) {
    var _value_split_;
    return (_value_split_ = value.split(/[?#]/, 1)[0]) !== null && _value_split_ !== void 0 ? _value_split_ : '';
}
function getSanitizedLastPathSegment(value) {
    const trimmedValue = stripQueryAndHash(value).replace(/\/+$/, '');
    if (!trimmedValue.includes('/')) return trimmedValue;
    var _trimmedValue_split_filter_pop;
    return (_trimmedValue_split_filter_pop = trimmedValue.split('/').filter(Boolean).pop()) !== null && _trimmedValue_split_filter_pop !== void 0 ? _trimmedValue_split_filter_pop : trimmedValue;
}
function hasExtension(value, extensions) {
    const path = stripQueryAndHash(value).toLowerCase();
    return extensions.some((extension)=>path.endsWith(extension));
}
function hasAttachmentOrDownloadPath(value) {
    return ATTACHMENT_OR_DOWNLOAD_PATH_PATTERNS.some((pattern)=>pattern.test(value));
}
function isAvatarResource(value) {
    return value.includes('avatar-management') || value.includes('/initials/') || value.includes('%2finitials%2f') || value.includes('viewavatar');
}
function getSanitizedBackendResourceLabel(rawName) {
    const querylessName = stripQueryAndHash(rawName);
    const normalizedRawName = rawName.toLowerCase();
    const normalizedQuerylessName = querylessName.toLowerCase();
    if (isAvatarResource(normalizedRawName)) return AVATAR_RESOURCE_LABEL;
    if (hasExtension(normalizedQuerylessName, IMAGE_EXTENSIONS)) return IMAGE_RESOURCE_LABEL;
    if (hasAttachmentOrDownloadPath(normalizedQuerylessName) || hasExtension(normalizedQuerylessName, FILE_OR_MEDIA_EXTENSIONS)) return FILE_RESOURCE_LABEL;
    return querylessName;
}
function isBackendResourceTiming(initiatorType) {
    return (0, _resourceTimingInitiatorTypes.BACKEND_RESOURCE_TIMING_INITIATOR_TYPES).has(initiatorType);
}
function isScriptOrStylesheetResource(rawName, initiatorType) {
    if (initiatorType === OTHER_JS_RESOURCE_TYPE) return hasExtension(rawName, ASSET_EXTENSIONS);
    if (!ASSET_RESOURCE_TYPES.has(initiatorType)) return false;
    return hasExtension(rawName, ASSET_EXTENSIONS);
}
function shapeNavigationTimingData(data) {
    const payload = (data === null || data === void 0 ? void 0 : data.payload) || {};
    // payload.timing.* to payload.* directly. Support both shapes during rollout.
    const timing = (payload === null || payload === void 0 ? void 0 : payload.timing) || payload;
    // Trim long URLs to just the last path segment to keep payload size manageable.
    const rawName = typeof payload.name === 'string' ? payload.name : '';
    var _rawName_split_filter_pop;
    const label = rawName.includes('/') ? (_rawName_split_filter_pop = rawName.split('/').filter(Boolean).pop()) !== null && _rawName_split_filter_pop !== void 0 ? _rawName_split_filter_pop : rawName : rawName;
    return {
        label,
        // From Resource Timing spec
        redirectStart: num(timing.redirectStart),
        redirectEnd: num(timing.redirectEnd),
        fetchStart: num(timing.fetchStart),
        domainLookupStart: num(timing.domainLookupStart),
        domainLookupEnd: num(timing.domainLookupEnd),
        connectStart: num(timing.connectStart),
        connectEnd: num(timing.connectEnd),
        secureConnectionStart: num(timing.secureConnectionStart),
        requestStart: num(timing.requestStart),
        responseStart: num(timing.responseStart),
        responseEnd: num(timing.responseEnd),
        // Added in PR #769 — present in new flat shape, absent in old nested shape (defaults to 0)
        encodedBodySize: num(timing.encodedBodySize),
        decodedBodySize: num(timing.decodedBodySize),
        transferSize: num(timing.transferSize),
        // From Navigation Timing 2 spec
        redirectCount: num(payload.redirectCount),
        type: typeof payload.type === 'string' ? payload.type : undefined,
        unloadEventStart: num(timing.unloadEventStart),
        unloadEventEnd: num(timing.unloadEventEnd),
        workerStart: num(timing.workerStart),
        nextHopProtocol: typeof timing.nextHopProtocol === 'string' ? timing.nextHopProtocol : undefined
    };
}
function shapeResourceTimingData(data) {
    const payload = (data === null || data === void 0 ? void 0 : data.payload) || {};
    // payload.timing.* to payload.* directly. Support both shapes during rollout.
    const timing = (payload === null || payload === void 0 ? void 0 : payload.timing) || payload;
    const rawName = typeof payload.name === 'string' ? payload.name : '';
    const initiatorType = typeof payload.initiatorType === 'string' ? payload.initiatorType : 'other';
    const isBackendTiming = isBackendResourceTiming(initiatorType);
    if (!isBackendTiming && !isScriptOrStylesheetResource(rawName, initiatorType)) return undefined;
    const name = isBackendTiming ? getSanitizedBackendResourceLabel(rawName) : getSanitizedLastPathSegment(rawName);
    const startTime = num(payload.startTime);
    const duration = num(payload.duration);
    const fetchStart = num(timing.fetchStart);
    const workerStart = num(timing.workerStart);
    const responseStart = num(timing.responseStart);
    const requestStart = num(timing.requestStart);
    const transferSize = typeof payload.transferSize === 'number' ? payload.transferSize : undefined;
    const encodedSize = typeof payload.encodedBodySize === 'number' ? payload.encodedBodySize : undefined;
    const decodedSize = typeof payload.decodedBodySize === 'number' ? payload.decodedBodySize : undefined;
    // serverTime / networkTime are not in the current iframe payload but kept for forward-compat
    const serverTime = typeof payload.serverTime === 'number' ? payload.serverTime : undefined;
    const networkTime = typeof payload.networkTime === 'number' ? payload.networkTime : undefined;
    const source = ACCEPTED_SOURCES.includes(payload.source) ? payload.source : undefined;
    // Base fields — always present (times are relative to interaction start from the iframe)
    const shaped = (0, _objectSpread._)({
        label: name,
        startTime,
        duration,
        workerStart: Math.max(workerStart, 0),
        fetchStart: Math.max(fetchStart, 0),
        type: initiatorType
    }, source !== undefined ? {
        source
    } : {});
    const cacheable = (0, _transferType.isCacheableType)(rawName, initiatorType);
    shaped.ttfb = responseStart;
    if (serverTime !== undefined) shaped.serverTime = serverTime;
    if (networkTime !== undefined) shaped.networkTime = networkTime;
    if (transferSize !== undefined) shaped.size = transferSize;
    // Flag entries where timing-allow-origin headers are missing:
    // duration > 0 but all size fields are 0 means the browser withheld size data.
    if (duration > 0 && transferSize === 0 && encodedSize === 0) shaped.noTA = true;
    if (cacheable) {
        // CacheableResourceTiming — calculateTransferType is only meaningful for cacheable resources
        const transferType = (0, _transferType.calculateTransferType)(rawName, initiatorType, duration, transferSize);
        if (transferType !== null) shaped.transferType = transferType;
        if (encodedSize !== undefined) shaped.encodedSize = encodedSize;
        if (decodedSize !== undefined) shaped.decodedSize = decodedSize;
    } else // NonCacheableResourceTiming (fetch, xmlhttprequest, etc.)
    shaped.requestStart = requestStart;
    return shaped;
}

},{"@swc/helpers/_/_object_spread":"9gdrV","./resource-timing-initiator-types":"lKGMp","./transfer-type":"lOigk","@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"lOigk":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "isCacheableType", ()=>isCacheableType);
// eslint-disable-next-line @typescript-eslint/no-invalid-void-type, @atlaskit/volt-strict-mode/no-multiple-exports
parcelHelpers.export(exports, "calculateTransferType", ()=>calculateTransferType);
const alwaysCacheableTypes = [
    'script',
    'link'
];
const CACHE_NETWORK = 'network';
const CACHE_MEMORY = 'memory';
const CACHE_DISK = 'disk';
function isCacheableType(url, type) {
    if (alwaysCacheableTypes.includes(type)) return true;
    if (type === 'other' && url.includes('.js')) return true;
    return false;
}
function calculateTransferType(name, type, duration, size) {
    if (!isCacheableType(name, type)) return CACHE_NETWORK;
    if ((size === undefined || size === 0) && duration === 0) return CACHE_MEMORY;
    if (size === 0 && duration > 0) return CACHE_DISK;
    if (size === undefined) return null;
    return CACHE_NETWORK;
}

},{"@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"hKmGZ":[function(require,module,exports,__globalThis) {
/**
 * Iframe event shaping helpers
 *
 * These functions normalise raw Forge bridge event data into compact, consistent
 * shapes before storing in segment3pTimings, reducing payload size and aligning
 * with the equivalent host-page metrics where applicable.
 *
 * Each function receives the full raw event object (minus `type`) and returns
 * only the fields worth retaining in the analytics payload.
 */ var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
/**
 * paint-timing: keep only name + startTime (mirrors host-side getPaintMetricsToLegacyFormat).
 * Drops: elapsed, envelope name, duration (always 0), entryType (always 'paint').
 */ parcelHelpers.export(exports, "shapePaintTimingData", ()=>shapePaintTimingData);
/**
 * largest-contentful-paint: keep only startTime + size.
 * Mirrors the bridge's own emission shape: { startTime, size }.
 * Drops: elapsed, envelope name — no other fields are sent by the bridge.
 */ // eslint-disable-next-line @atlaskit/volt-strict-mode/no-multiple-exports
parcelHelpers.export(exports, "shapeLargestContentfulPaintData", ()=>shapeLargestContentfulPaintData);
/**
 * layout-shift: keep value, startTime, cumulativeScore, sessionValue, and source node names.
 * Drops: elapsed, envelope name, duration (always 0), hadRecentInput (always false — entries
 * with hadRecentInput:true are filtered out before emit), lastInputTime (low analytical value),
 * and currentRect/previousRect from sources (8 floats per source — high cost, low value).
 */ // eslint-disable-next-line @atlaskit/volt-strict-mode/no-multiple-exports
parcelHelpers.export(exports, "shapeLayoutShiftData", ()=>shapeLayoutShiftData);
/**
 * Returns true only for the final dom-mutations batch, which is the one worth recording.
 * Intermediate batches (isFinalBatch === false/undefined) are skipped by the caller.
 */ // eslint-disable-next-line @atlaskit/volt-strict-mode/no-multiple-exports
parcelHelpers.export(exports, "isDomMutationsFinalBatch", ()=>isDomMutationsFinalBatch);
/**
 * dom-mutations (final batch only): keep summary counters + stopReason.
 * Intermediate batches are skipped entirely in the caller (third-party-segment.tsx).
 * Drops: elapsed, envelope name, per-mutation details (addedNodeDetails / removedNodeDetails),
 * isTimedOut (redundant with stopReason), isFinalBatch (always true at this point),
 * and individual mutation objects (too verbose; totalMutations covers the count).
 */ // eslint-disable-next-line @atlaskit/volt-strict-mode/no-multiple-exports
parcelHelpers.export(exports, "shapeDomMutationsData", ()=>shapeDomMutationsData);
const num = (v)=>typeof v === 'number' ? Math.round(v) : 0;
function extractPayload(data) {
    return data.payload !== null && typeof data.payload === 'object' ? data.payload : {};
}
function shapePaintTimingData(data) {
    const payload = extractPayload(data);
    return {
        name: typeof payload.name === 'string' ? payload.name : '',
        startTime: num(payload.startTime)
    };
}
function shapeLargestContentfulPaintData(data) {
    const payload = extractPayload(data);
    return {
        startTime: num(payload.startTime),
        size: num(payload.size)
    };
}
function shapeLayoutShiftData(data) {
    const payload = extractPayload(data);
    const rawSources = Array.isArray(payload.sources) ? payload.sources : [];
    const sources = rawSources.map((source)=>{
        const s = source !== null && typeof source === 'object' ? source : {};
        return {
            node: typeof s.node === 'string' ? s.node : 'unknown'
        };
    });
    return {
        value: typeof payload.value === 'number' ? payload.value : 0,
        startTime: num(payload.startTime),
        cumulativeScore: typeof payload.cumulativeScore === 'number' ? payload.cumulativeScore : 0,
        sessionValue: typeof payload.sessionValue === 'number' ? payload.sessionValue : 0,
        sources
    };
}
function isDomMutationsFinalBatch(data) {
    const payload = extractPayload(data);
    return payload.isFinalBatch === true;
}
function shapeDomMutationsData(data) {
    const payload = extractPayload(data);
    return {
        totalMutations: typeof payload.totalMutations === 'number' ? payload.totalMutations : 0,
        observationDurationMs: num(payload.observationDurationMs),
        stopReason: typeof payload.stopReason === 'string' ? payload.stopReason : null
    };
}

},{"@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"jewgo":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "ReliabilityStart", ()=>ReliabilityStart);
parcelHelpers.export(exports, "ReliabilitySucceed", ()=>ReliabilitySucceed);
parcelHelpers.export(exports, "ReliabilityFailure", ()=>ReliabilityFailure);
parcelHelpers.export(exports, "ReliabilityErrorBoundary", ()=>ReliabilityErrorBoundary);
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _reactErrorBoundary = require("react-error-boundary");
var _studioReliabilityTracker = require("./studio-reliability-tracker");
const ReliabilityStart = ({ task, taskId, touchpointId, attributes })=>{
    (0, _react.useMemo)(()=>{
        (0, _studioReliabilityTracker.studioReliabilityTracker).start({
            task,
            taskId,
            touchpointId,
            attributes
        });
    }, // eslint-disable-next-line react-hooks/exhaustive-deps
    [
        task,
        taskId,
        touchpointId
    ]);
    return null;
};
const ReliabilitySucceed = ({ task, taskId, attributes })=>{
    (0, _react.useEffect)(()=>{
        (0, _studioReliabilityTracker.studioReliabilityTracker).succeed({
            task,
            taskId,
            attributes
        });
    }, // eslint-disable-next-line react-hooks/exhaustive-deps
    [
        task,
        taskId
    ]);
    return null;
};
const ReliabilityFailure = ({ task, taskId, error, traceId, attributes })=>{
    (0, _react.useEffect)(()=>{
        (0, _studioReliabilityTracker.studioReliabilityTracker).fail({
            task,
            taskId,
            error,
            traceId,
            attributes
        });
    }, // eslint-disable-next-line react-hooks/exhaustive-deps
    [
        task,
        taskId,
        error
    ]);
    return null;
};
const ReliabilityErrorBoundary = ({ task, taskId, fallback, children })=>/*#__PURE__*/ (0, _reactDefault.default).createElement((0, _reactErrorBoundary.ErrorBoundary), {
        FallbackComponent: fallback,
        onError: (error)=>{
            (0, _studioReliabilityTracker.studioReliabilityTracker).fail({
                task,
                taskId,
                error
            });
        }
    }, children);

},{"react":"ltHCL","react-error-boundary":"cC53c","./studio-reliability-tracker":"cMbGI","@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"k3dox":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "BulkActionToolbar", ()=>(0, _bulkToolbar.BulkActionToolbar));
parcelHelpers.export(exports, "BulkActionToolbarButton", ()=>(0, _bulkToolbar.BulkActionToolbarButton));
parcelHelpers.export(exports, "RadioGroup", ()=>(0, _radioGroup.RadioGroup));
parcelHelpers.export(exports, "RadioButton", ()=>(0, _radioGroup.RadioButton));
parcelHelpers.export(exports, "Table", ()=>(0, _table.Table));
parcelHelpers.export(exports, "Card", ()=>(0, _card.Card));
parcelHelpers.export(exports, "PaginatedCharlieTable", ()=>(0, _paginatedCharlieTable.PaginatedCharlieTable));
parcelHelpers.export(exports, "PageMainContentLoadingLogo", ()=>(0, _pageMainContentLoadingLogo.PageMainContentLoadingLogo));
var _bulkToolbar = require("./ui/bulk-toolbar");
var _radioGroup = require("./ui/radio-group");
var _table = require("./common/ui/table");
var _card = require("./ui/card");
var _paginatedCharlieTable = require("./ui/paginated-charlie-table");
var _pageMainContentLoadingLogo = require("./ui/page-main-content-loading-logo");

},{"./ui/bulk-toolbar":"echCs","./ui/radio-group":"21kRr","./common/ui/table":"4Gv67","./ui/card":"adpjC","./ui/paginated-charlie-table":"e2MdE","./ui/page-main-content-loading-logo":"lwwQ1","@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"echCs":[function(require,module,exports,__globalThis) {
/* index.tsx generated by @compiled/babel-plugin v0.39.1 */ var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "BulkActionToolbar", ()=>BulkActionToolbar);
parcelHelpers.export(exports, "BulkActionToolbarButton", ()=>BulkActionToolbarButton);
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _reactIntl = require("react-intl");
var _badge = require("@atlaskit/badge");
var _badgeDefault = parcelHelpers.interopDefault(_badge);
var _cross = require("@atlaskit/icon/core/cross");
var _crossDefault = parcelHelpers.interopDefault(_cross);
var _compiled = require("@atlaskit/primitives/compiled");
// eslint-disable-next-line @atlaskit/design-system/no-emotion-primitives -- TODO: migrate to @atlaskit/primitives/compiled
var _pressable = require("@atlaskit/primitives/pressable");
var _pressableDefault = parcelHelpers.interopDefault(_pressable);
var _tooltip = require("@atlaskit/tooltip");
var _tooltipDefault = parcelHelpers.interopDefault(_tooltip);
var _messages = require("./messages");
var _messagesDefault = parcelHelpers.interopDefault(_messages);
const styles = {
    bulkToolbarContainer: "_kqsw1n9t _1ltvidpf _1xi2idpf _94n5u2gc _1e0c1txw _1bah1h6o",
    bulkToolBar: "_2rko12b0 _zulputpp _4cvr1h6o _bfhk1aqn _16qs1nax _1e0c116y _ca0qu2gc _u5f3u2gc _n3tdu2gc _19bvu2gc",
    bulkToolBarItem: "_19bv12x7 _u5f312x7",
    button: "_2rko12b0 _bfhk1aqn _syaz15cr _4t3izwfg _irr3mpja",
    divider: "_1wpz1fhb _14vnveue _ngwonqa1 _gx38e4h9 _4t3i1wug"
};
const BulkActionToolbar = ({ children, numSelected, onClearAll })=>{
    const { formatMessage } = (0, _reactIntl.useIntl)();
    return /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _compiled.Box), {
        xcss: styles.bulkToolbarContainer
    }, /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _compiled.Box), {
        xcss: styles.bulkToolBar
    }, /*#__PURE__*/ (0, _reactDefault.default).createElement(ClearAllButton, {
        onClick: onClearAll
    }), /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _compiled.Inline), {
        alignBlock: "center",
        space: "space.100",
        xcss: styles.bulkToolBarItem
    }, /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _badgeDefault.default), {
        testId: "bulk-action-toolbar-count-badge"
    }, numSelected), /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _compiled.Text), {
        color: "color.text.inverse"
    }, formatMessage((0, _messagesDefault.default).selectedText))), /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _compiled.Box), {
        xcss: styles.divider
    }), children));
};
const BulkActionToolbarButton = ({ icon, onClick, text })=>{
    return /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _pressableDefault.default), {
        onClick: onClick,
        xcss: styles.button
    }, /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _compiled.Inline), {
        space: "space.100",
        xcss: styles.bulkToolBarItem
    }, icon, text));
};
const ClearAllButton = ({ onClick })=>{
    const { formatMessage } = (0, _reactIntl.useIntl)();
    const label = formatMessage((0, _messagesDefault.default).clearAllButtonTooltip);
    return /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _tooltipDefault.default), {
        content: label,
        position: "top"
    }, /*#__PURE__*/ (0, _reactDefault.default).createElement(BulkActionToolbarButton, {
        icon: /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _crossDefault.default), {
            label: label
        }),
        onClick: onClick
    }));
};

},{"react":"ltHCL","react-intl":"f41fF","@atlaskit/badge":"iVzoy","@atlaskit/icon/core/cross":"7mJX1","@atlaskit/primitives/compiled":"hDay7","@atlaskit/primitives/pressable":"hb6DX","@atlaskit/tooltip":"7RyYv","./messages":"4HNAS","@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"f41fF":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "createIntlCache", ()=>(0, _intl.createIntlCache));
parcelHelpers.export(exports, "InvalidConfigError", ()=>(0, _intl.InvalidConfigError));
parcelHelpers.export(exports, "MessageFormatError", ()=>(0, _intl.MessageFormatError));
parcelHelpers.export(exports, "MissingDataError", ()=>(0, _intl.MissingDataError));
parcelHelpers.export(exports, "MissingTranslationError", ()=>(0, _intl.MissingTranslationError));
parcelHelpers.export(exports, "ReactIntlError", ()=>(0, _intl.IntlError));
parcelHelpers.export(exports, "ReactIntlErrorCode", ()=>(0, _intl.IntlErrorCode));
parcelHelpers.export(exports, "UnsupportedFormatterError", ()=>(0, _intl.UnsupportedFormatterError));
parcelHelpers.export(exports, "FormattedListParts", ()=>(0, _createFormattedComponent.FormattedListParts));
parcelHelpers.export(exports, "FormattedNumberParts", ()=>(0, _createFormattedComponent.FormattedNumberParts));
parcelHelpers.export(exports, "createIntl", ()=>(0, _createIntl.createIntl));
parcelHelpers.export(exports, "FormattedDateTimeRange", ()=>(0, _dateTimeRangeDefault.default));
parcelHelpers.export(exports, "FormattedMessage", ()=>(0, _messageDefault.default));
parcelHelpers.export(exports, "FormattedPlural", ()=>(0, _pluralDefault.default));
parcelHelpers.export(exports, "FormattedRelativeTime", ()=>(0, _relativeDefault.default));
parcelHelpers.export(exports, "injectIntl", ()=>(0, _injectIntlDefault.default));
parcelHelpers.export(exports, "IntlContext", ()=>(0, _injectIntl.Context));
parcelHelpers.export(exports, "IntlProvider", ()=>(0, _providerDefault.default));
parcelHelpers.export(exports, "RawIntlProvider", ()=>(0, _injectIntl.Provider));
parcelHelpers.export(exports, "useIntl", ()=>(0, _useIntlDefault.default));
parcelHelpers.export(exports, "defineMessages", ()=>defineMessages);
parcelHelpers.export(exports, "defineMessage", ()=>defineMessage);
parcelHelpers.export(exports, "FormattedDate", ()=>FormattedDate);
parcelHelpers.export(exports, "FormattedTime", ()=>FormattedTime);
parcelHelpers.export(exports, "FormattedNumber", ()=>FormattedNumber);
parcelHelpers.export(exports, "FormattedList", ()=>FormattedList);
parcelHelpers.export(exports, "FormattedDisplayName", ()=>FormattedDisplayName);
parcelHelpers.export(exports, "FormattedDateParts", ()=>FormattedDateParts);
parcelHelpers.export(exports, "FormattedTimeParts", ()=>FormattedTimeParts);
var _createFormattedComponent = require("./src/components/createFormattedComponent");
var _createIntl = require("./src/components/createIntl");
var _dateTimeRange = require("./src/components/dateTimeRange");
var _dateTimeRangeDefault = parcelHelpers.interopDefault(_dateTimeRange);
var _injectIntl = require("./src/components/injectIntl");
var _injectIntlDefault = parcelHelpers.interopDefault(_injectIntl);
var _message = require("./src/components/message");
var _messageDefault = parcelHelpers.interopDefault(_message);
var _plural = require("./src/components/plural");
var _pluralDefault = parcelHelpers.interopDefault(_plural);
var _provider = require("./src/components/provider");
var _providerDefault = parcelHelpers.interopDefault(_provider);
var _relative = require("./src/components/relative");
var _relativeDefault = parcelHelpers.interopDefault(_relative);
var _useIntl = require("./src/components/useIntl");
var _useIntlDefault = parcelHelpers.interopDefault(_useIntl);
var _intl = require("@formatjs/intl");
function defineMessages(msgs) {
    return msgs;
}
function defineMessage(msg) {
    return msg;
}
var FormattedDate = (0, _createFormattedComponent.createFormattedComponent)('formatDate');
var FormattedTime = (0, _createFormattedComponent.createFormattedComponent)('formatTime');
var FormattedNumber = (0, _createFormattedComponent.createFormattedComponent)('formatNumber');
var FormattedList = (0, _createFormattedComponent.createFormattedComponent)('formatList');
var FormattedDisplayName = (0, _createFormattedComponent.createFormattedComponent)('formatDisplayName');
var FormattedDateParts = (0, _createFormattedComponent.createFormattedDateTimePartsComponent)('formatDate');
var FormattedTimeParts = (0, _createFormattedComponent.createFormattedDateTimePartsComponent)('formatTime');

},{"./src/components/createFormattedComponent":"bS5Zp","./src/components/createIntl":"4Xxzz","./src/components/dateTimeRange":"fQpLs","./src/components/injectIntl":"jwY9c","./src/components/message":"gfNgD","./src/components/plural":"d3HMU","./src/components/provider":"b7DFj","./src/components/relative":"4dstO","./src/components/useIntl":"jQUM3","@formatjs/intl":"ljzXP","@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"bS5Zp":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "FormattedNumberParts", ()=>FormattedNumberParts);
parcelHelpers.export(exports, "FormattedListParts", ()=>FormattedListParts);
parcelHelpers.export(exports, "createFormattedDateTimePartsComponent", ()=>createFormattedDateTimePartsComponent);
parcelHelpers.export(exports, "createFormattedComponent", ()=>createFormattedComponent);
var _tslib = require("tslib");
var _react = require("react");
var _useIntl = require("./useIntl");
var _useIntlDefault = parcelHelpers.interopDefault(_useIntl);
var DisplayName;
(function(DisplayName) {
    DisplayName["formatDate"] = "FormattedDate";
    DisplayName["formatTime"] = "FormattedTime";
    DisplayName["formatNumber"] = "FormattedNumber";
    DisplayName["formatList"] = "FormattedList";
    // Note that this DisplayName is the locale display name, not to be confused with
    // the name of the enum, which is for React component display name in dev tools.
    DisplayName["formatDisplayName"] = "FormattedDisplayName";
})(DisplayName || (DisplayName = {}));
var DisplayNameParts;
(function(DisplayNameParts) {
    DisplayNameParts["formatDate"] = "FormattedDateParts";
    DisplayNameParts["formatTime"] = "FormattedTimeParts";
    DisplayNameParts["formatNumber"] = "FormattedNumberParts";
    DisplayNameParts["formatList"] = "FormattedListParts";
})(DisplayNameParts || (DisplayNameParts = {}));
var FormattedNumberParts = function(props) {
    var intl = (0, _useIntlDefault.default)();
    var value = props.value, children = props.children, formatProps = (0, _tslib.__rest)(props, [
        "value",
        "children"
    ]);
    return children(intl.formatNumberToParts(value, formatProps));
};
FormattedNumberParts.displayName = 'FormattedNumberParts';
var FormattedListParts = function(props) {
    var intl = (0, _useIntlDefault.default)();
    var value = props.value, children = props.children, formatProps = (0, _tslib.__rest)(props, [
        "value",
        "children"
    ]);
    return children(intl.formatListToParts(value, formatProps));
};
FormattedNumberParts.displayName = 'FormattedNumberParts';
function createFormattedDateTimePartsComponent(name) {
    var ComponentParts = function(props) {
        var intl = (0, _useIntlDefault.default)();
        var value = props.value, children = props.children, formatProps = (0, _tslib.__rest)(props, [
            "value",
            "children"
        ]);
        var date = typeof value === 'string' ? new Date(value || 0) : value;
        var formattedParts = name === 'formatDate' ? intl.formatDateToParts(date, formatProps) : intl.formatTimeToParts(date, formatProps);
        return children(formattedParts);
    };
    ComponentParts.displayName = DisplayNameParts[name];
    return ComponentParts;
}
function createFormattedComponent(name) {
    var Component = function(props) {
        var intl = (0, _useIntlDefault.default)();
        var value = props.value, children = props.children, formatProps = (0, _tslib.__rest)(props, [
            "value",
            "children"
        ]);
        // TODO: fix TS type definition for localeMatcher upstream
        var formattedValue = intl[name](value, formatProps);
        if (typeof children === 'function') return children(formattedValue);
        var Text = intl.textComponent || _react.Fragment;
        return _react.createElement(Text, null, formattedValue);
    };
    Component.displayName = DisplayName[name];
    return Component;
}

},{"tslib":"6MhhU","react":"ltHCL","./useIntl":"jQUM3","@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"jQUM3":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>useIntl);
var _react = require("react");
var _utils = require("../utils");
var _injectIntl = require("./injectIntl");
function useIntl() {
    var intl = _react.useContext((0, _injectIntl.Context));
    (0, _utils.invariantIntlContext)(intl);
    return intl;
}

},{"react":"ltHCL","../utils":"88Xfc","./injectIntl":"jwY9c","@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"88Xfc":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "invariant", ()=>invariant);
parcelHelpers.export(exports, "invariantIntlContext", ()=>invariantIntlContext);
parcelHelpers.export(exports, "DEFAULT_INTL_CONFIG", ()=>DEFAULT_INTL_CONFIG);
parcelHelpers.export(exports, "toKeyedReactNodeArray", ()=>toKeyedReactNodeArray);
/**
 * Takes a `formatXMLElementFn`, and composes it in function, which passes
 * argument `parts` through, assigning unique key to each part, to prevent
 * "Each child in a list should have a unique "key"" React error.
 * @param formatXMLElementFn
 */ parcelHelpers.export(exports, "assignUniqueKeysToParts", ()=>assignUniqueKeysToParts);
parcelHelpers.export(exports, "shallowEqual", ()=>shallowEqual);
var _tslib = require("tslib");
var _react = require("react");
var _intl = require("@formatjs/intl");
function invariant(condition, message, Err) {
    if (Err === void 0) Err = Error;
    if (!condition) throw new Err(message);
}
function invariantIntlContext(intl) {
    invariant(intl, "[React Intl] Could not find required `intl` object. <IntlProvider> needs to exist in the component ancestry.");
}
var DEFAULT_INTL_CONFIG = (0, _tslib.__assign)((0, _tslib.__assign)({}, (0, _intl.DEFAULT_INTL_CONFIG)), {
    textComponent: _react.Fragment
});
var toKeyedReactNode = function(reactNode, key) {
    return _react.isValidElement(reactNode) ? _react.cloneElement(reactNode, {
        key: key
    }) : reactNode;
};
var toKeyedReactNodeArray = function(children) {
    var _a;
    /**
 * Note: {@link React.Children.map} will add its own index-based prefix to
 * every key anyway, so the auto-injected one doesn't even have to be unique.
 * This basically just tells React that it's explicit/intentional.
 */ return (_a = _react.Children.map(children, toKeyedReactNode)) !== null && _a !== void 0 ? _a : [];
};
function assignUniqueKeysToParts(formatXMLElementFn) {
    return function(parts) {
        // eslint-disable-next-line prefer-rest-params
        return formatXMLElementFn(toKeyedReactNodeArray(parts));
    };
}
function shallowEqual(objA, objB) {
    if (objA === objB) return true;
    if (!objA || !objB) return false;
    var aKeys = Object.keys(objA);
    var bKeys = Object.keys(objB);
    var len = aKeys.length;
    if (bKeys.length !== len) return false;
    for(var i = 0; i < len; i++){
        var key = aKeys[i];
        if (objA[key] !== objB[key] || !Object.prototype.hasOwnProperty.call(objB, key)) return false;
    }
    return true;
}

},{"tslib":"6MhhU","react":"ltHCL","@formatjs/intl":"ljzXP","@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"ljzXP":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "createIntlCache", ()=>(0, _utils.createIntlCache));
parcelHelpers.export(exports, "filterProps", ()=>(0, _utils.filterProps));
parcelHelpers.export(exports, "DEFAULT_INTL_CONFIG", ()=>(0, _utils.DEFAULT_INTL_CONFIG));
parcelHelpers.export(exports, "createFormatters", ()=>(0, _utils.createFormatters));
parcelHelpers.export(exports, "getNamedFormat", ()=>(0, _utils.getNamedFormat));
parcelHelpers.export(exports, "formatMessage", ()=>(0, _message.formatMessage));
parcelHelpers.export(exports, "formatDate", ()=>(0, _dateTime.formatDate));
parcelHelpers.export(exports, "formatDateToParts", ()=>(0, _dateTime.formatDateToParts));
parcelHelpers.export(exports, "formatTime", ()=>(0, _dateTime.formatTime));
parcelHelpers.export(exports, "formatTimeToParts", ()=>(0, _dateTime.formatTimeToParts));
parcelHelpers.export(exports, "formatDisplayName", ()=>(0, _displayName.formatDisplayName));
parcelHelpers.export(exports, "formatList", ()=>(0, _list.formatList));
parcelHelpers.export(exports, "formatPlural", ()=>(0, _plural.formatPlural));
parcelHelpers.export(exports, "formatRelativeTime", ()=>(0, _relativeTime.formatRelativeTime));
parcelHelpers.export(exports, "formatNumber", ()=>(0, _number.formatNumber));
parcelHelpers.export(exports, "formatNumberToParts", ()=>(0, _number.formatNumberToParts));
parcelHelpers.export(exports, "createIntl", ()=>(0, _createIntl.createIntl));
parcelHelpers.export(exports, "defineMessages", ()=>defineMessages);
parcelHelpers.export(exports, "defineMessage", ()=>defineMessage);
var _types = require("./src/types");
parcelHelpers.exportAll(_types, exports);
var _utils = require("./src/utils");
var _error = require("./src/error");
parcelHelpers.exportAll(_error, exports);
var _message = require("./src/message");
var _dateTime = require("./src/dateTime");
var _displayName = require("./src/displayName");
var _list = require("./src/list");
var _plural = require("./src/plural");
var _relativeTime = require("./src/relativeTime");
var _number = require("./src/number");
var _createIntl = require("./src/create-intl");
function defineMessages(msgs) {
    return msgs;
}
function defineMessage(msg) {
    return msg;
}

},{"./src/types":false,"./src/utils":"1huCS","./src/error":"j1qwF","./src/message":"9tWAc","./src/dateTime":false,"./src/displayName":false,"./src/list":false,"./src/plural":false,"./src/relativeTime":false,"./src/number":false,"./src/create-intl":"gdAHl","@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"1huCS":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "invariant", ()=>invariant);
parcelHelpers.export(exports, "filterProps", ()=>filterProps);
parcelHelpers.export(exports, "DEFAULT_INTL_CONFIG", ()=>DEFAULT_INTL_CONFIG);
parcelHelpers.export(exports, "createIntlCache", ()=>createIntlCache);
/**
 * Create intl formatters and populate cache
 * @param cache explicit cache to prevent leaking memory
 */ parcelHelpers.export(exports, "createFormatters", ()=>createFormatters);
parcelHelpers.export(exports, "getNamedFormat", ()=>getNamedFormat);
var _tslib = require("tslib");
var _fastMemoize = require("@formatjs/fast-memoize");
var _intlMessageformat = require("intl-messageformat");
var _error = require("./error");
function invariant(condition, message, Err) {
    if (Err === void 0) Err = Error;
    if (!condition) throw new Err(message);
}
function filterProps(props, allowlist, defaults) {
    if (defaults === void 0) defaults = {};
    return allowlist.reduce(function(filtered, name) {
        if (name in props) filtered[name] = props[name];
        else if (name in defaults) filtered[name] = defaults[name];
        return filtered;
    }, {});
}
var defaultErrorHandler = function(error) {};
var defaultWarnHandler = function(warning) {};
var DEFAULT_INTL_CONFIG = {
    formats: {},
    messages: {},
    timeZone: undefined,
    defaultLocale: 'en',
    defaultFormats: {},
    fallbackOnEmptyString: true,
    onError: defaultErrorHandler,
    onWarn: defaultWarnHandler
};
function createIntlCache() {
    return {
        dateTime: {},
        number: {},
        message: {},
        relativeTime: {},
        pluralRules: {},
        list: {},
        displayNames: {}
    };
}
function createFastMemoizeCache(store) {
    return {
        create: function() {
            return {
                get: function(key) {
                    return store[key];
                },
                set: function(key, value) {
                    store[key] = value;
                }
            };
        }
    };
}
function createFormatters(cache) {
    if (cache === void 0) cache = createIntlCache();
    var RelativeTimeFormat = Intl.RelativeTimeFormat;
    var ListFormat = Intl.ListFormat;
    var DisplayNames = Intl.DisplayNames;
    var getDateTimeFormat = (0, _fastMemoize.memoize)(function() {
        var _a;
        var args = [];
        for(var _i = 0; _i < arguments.length; _i++)args[_i] = arguments[_i];
        return new ((_a = Intl.DateTimeFormat).bind.apply(_a, (0, _tslib.__spreadArray)([
            void 0
        ], args, false)))();
    }, {
        cache: createFastMemoizeCache(cache.dateTime),
        strategy: (0, _fastMemoize.strategies).variadic
    });
    var getNumberFormat = (0, _fastMemoize.memoize)(function() {
        var _a;
        var args = [];
        for(var _i = 0; _i < arguments.length; _i++)args[_i] = arguments[_i];
        return new ((_a = Intl.NumberFormat).bind.apply(_a, (0, _tslib.__spreadArray)([
            void 0
        ], args, false)))();
    }, {
        cache: createFastMemoizeCache(cache.number),
        strategy: (0, _fastMemoize.strategies).variadic
    });
    var getPluralRules = (0, _fastMemoize.memoize)(function() {
        var _a;
        var args = [];
        for(var _i = 0; _i < arguments.length; _i++)args[_i] = arguments[_i];
        return new ((_a = Intl.PluralRules).bind.apply(_a, (0, _tslib.__spreadArray)([
            void 0
        ], args, false)))();
    }, {
        cache: createFastMemoizeCache(cache.pluralRules),
        strategy: (0, _fastMemoize.strategies).variadic
    });
    return {
        getDateTimeFormat: getDateTimeFormat,
        getNumberFormat: getNumberFormat,
        getMessageFormat: (0, _fastMemoize.memoize)(function(message, locales, overrideFormats, opts) {
            return new (0, _intlMessageformat.IntlMessageFormat)(message, locales, overrideFormats, (0, _tslib.__assign)({
                formatters: {
                    getNumberFormat: getNumberFormat,
                    getDateTimeFormat: getDateTimeFormat,
                    getPluralRules: getPluralRules
                }
            }, opts || {}));
        }, {
            cache: createFastMemoizeCache(cache.message),
            strategy: (0, _fastMemoize.strategies).variadic
        }),
        getRelativeTimeFormat: (0, _fastMemoize.memoize)(function() {
            var args = [];
            for(var _i = 0; _i < arguments.length; _i++)args[_i] = arguments[_i];
            return new (RelativeTimeFormat.bind.apply(RelativeTimeFormat, (0, _tslib.__spreadArray)([
                void 0
            ], args, false)))();
        }, {
            cache: createFastMemoizeCache(cache.relativeTime),
            strategy: (0, _fastMemoize.strategies).variadic
        }),
        getPluralRules: getPluralRules,
        getListFormat: (0, _fastMemoize.memoize)(function() {
            var args = [];
            for(var _i = 0; _i < arguments.length; _i++)args[_i] = arguments[_i];
            return new (ListFormat.bind.apply(ListFormat, (0, _tslib.__spreadArray)([
                void 0
            ], args, false)))();
        }, {
            cache: createFastMemoizeCache(cache.list),
            strategy: (0, _fastMemoize.strategies).variadic
        }),
        getDisplayNames: (0, _fastMemoize.memoize)(function() {
            var args = [];
            for(var _i = 0; _i < arguments.length; _i++)args[_i] = arguments[_i];
            return new (DisplayNames.bind.apply(DisplayNames, (0, _tslib.__spreadArray)([
                void 0
            ], args, false)))();
        }, {
            cache: createFastMemoizeCache(cache.displayNames),
            strategy: (0, _fastMemoize.strategies).variadic
        })
    };
}
function getNamedFormat(formats, type, name, onError) {
    var formatType = formats && formats[type];
    var format;
    if (formatType) format = formatType[name];
    if (format) return format;
    onError(new (0, _error.UnsupportedFormatterError)("No ".concat(type, " format named: ").concat(name)));
}

},{"tslib":"6MhhU","@formatjs/fast-memoize":"abkD2","intl-messageformat":"3QRuN","./error":"j1qwF","@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"abkD2":[function(require,module,exports,__globalThis) {
//
// Main
//
var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "memoize", ()=>memoize);
parcelHelpers.export(exports, "strategies", ()=>strategies);
function memoize(fn, options) {
    var cache = options && options.cache ? options.cache : cacheDefault;
    var serializer = options && options.serializer ? options.serializer : serializerDefault;
    var strategy = options && options.strategy ? options.strategy : strategyDefault;
    return strategy(fn, {
        cache: cache,
        serializer: serializer
    });
}
//
// Strategy
//
function isPrimitive(value) {
    return value == null || typeof value === 'number' || typeof value === 'boolean'; // || typeof value === "string" 'unsafe' primitive for our needs
}
function monadic(fn, cache, serializer, arg) {
    var cacheKey = isPrimitive(arg) ? arg : serializer(arg);
    var computedValue = cache.get(cacheKey);
    if (typeof computedValue === 'undefined') {
        computedValue = fn.call(this, arg);
        cache.set(cacheKey, computedValue);
    }
    return computedValue;
}
function variadic(fn, cache, serializer) {
    var args = Array.prototype.slice.call(arguments, 3);
    var cacheKey = serializer(args);
    var computedValue = cache.get(cacheKey);
    if (typeof computedValue === 'undefined') {
        computedValue = fn.apply(this, args);
        cache.set(cacheKey, computedValue);
    }
    return computedValue;
}
function assemble(fn, context, strategy, cache, serialize) {
    return strategy.bind(context, fn, cache, serialize);
}
function strategyDefault(fn, options) {
    var strategy = fn.length === 1 ? monadic : variadic;
    return assemble(fn, this, strategy, options.cache.create(), options.serializer);
}
function strategyVariadic(fn, options) {
    return assemble(fn, this, variadic, options.cache.create(), options.serializer);
}
function strategyMonadic(fn, options) {
    return assemble(fn, this, monadic, options.cache.create(), options.serializer);
}
//
// Serializer
//
var serializerDefault = function() {
    return JSON.stringify(arguments);
};
//
// Cache
//
var ObjectWithoutPrototypeCache = /** @class */ function() {
    function ObjectWithoutPrototypeCache() {
        this.cache = Object.create(null);
    }
    ObjectWithoutPrototypeCache.prototype.get = function(key) {
        return this.cache[key];
    };
    ObjectWithoutPrototypeCache.prototype.set = function(key, value) {
        this.cache[key] = value;
    };
    return ObjectWithoutPrototypeCache;
}();
var cacheDefault = {
    create: function create() {
        return new ObjectWithoutPrototypeCache();
    }
};
var strategies = {
    variadic: strategyVariadic,
    monadic: strategyMonadic
};

},{"@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"3QRuN":[function(require,module,exports,__globalThis) {
/*
Copyright (c) 2014, Yahoo! Inc. All rights reserved.
Copyrights licensed under the New BSD License.
See the accompanying LICENSE file for terms.
*/ var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "IntlMessageFormat", ()=>(0, _core.IntlMessageFormat));
var _core = require("./src/core");
parcelHelpers.exportAll(_core, exports);
var _error = require("./src/error");
parcelHelpers.exportAll(_error, exports);
var _formatters = require("./src/formatters");
parcelHelpers.exportAll(_formatters, exports);
exports.default = (0, _core.IntlMessageFormat);

},{"./src/core":"5d6nK","./src/error":"hodAk","./src/formatters":"l38Sx","@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"5d6nK":[function(require,module,exports,__globalThis) {
/*
Copyright (c) 2014, Yahoo! Inc. All rights reserved.
Copyrights licensed under the New BSD License.
See the accompanying LICENSE file for terms.
*/ var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "IntlMessageFormat", ()=>IntlMessageFormat);
var _tslib = require("tslib");
var _fastMemoize = require("@formatjs/fast-memoize");
var _icuMessageformatParser = require("@formatjs/icu-messageformat-parser");
var _formatters = require("./formatters");
// -- MessageFormat --------------------------------------------------------
function mergeConfig(c1, c2) {
    if (!c2) return c1;
    return (0, _tslib.__assign)((0, _tslib.__assign)((0, _tslib.__assign)({}, c1 || {}), c2 || {}), Object.keys(c1).reduce(function(all, k) {
        all[k] = (0, _tslib.__assign)((0, _tslib.__assign)({}, c1[k]), c2[k] || {});
        return all;
    }, {}));
}
function mergeConfigs(defaultConfig, configs) {
    if (!configs) return defaultConfig;
    return Object.keys(defaultConfig).reduce(function(all, k) {
        all[k] = mergeConfig(defaultConfig[k], configs[k]);
        return all;
    }, (0, _tslib.__assign)({}, defaultConfig));
}
function createFastMemoizeCache(store) {
    return {
        create: function() {
            return {
                get: function(key) {
                    return store[key];
                },
                set: function(key, value) {
                    store[key] = value;
                }
            };
        }
    };
}
function createDefaultFormatters(cache) {
    if (cache === void 0) cache = {
        number: {},
        dateTime: {},
        pluralRules: {}
    };
    return {
        getNumberFormat: (0, _fastMemoize.memoize)(function() {
            var _a;
            var args = [];
            for(var _i = 0; _i < arguments.length; _i++)args[_i] = arguments[_i];
            return new ((_a = Intl.NumberFormat).bind.apply(_a, (0, _tslib.__spreadArray)([
                void 0
            ], args, false)))();
        }, {
            cache: createFastMemoizeCache(cache.number),
            strategy: (0, _fastMemoize.strategies).variadic
        }),
        getDateTimeFormat: (0, _fastMemoize.memoize)(function() {
            var _a;
            var args = [];
            for(var _i = 0; _i < arguments.length; _i++)args[_i] = arguments[_i];
            return new ((_a = Intl.DateTimeFormat).bind.apply(_a, (0, _tslib.__spreadArray)([
                void 0
            ], args, false)))();
        }, {
            cache: createFastMemoizeCache(cache.dateTime),
            strategy: (0, _fastMemoize.strategies).variadic
        }),
        getPluralRules: (0, _fastMemoize.memoize)(function() {
            var _a;
            var args = [];
            for(var _i = 0; _i < arguments.length; _i++)args[_i] = arguments[_i];
            return new ((_a = Intl.PluralRules).bind.apply(_a, (0, _tslib.__spreadArray)([
                void 0
            ], args, false)))();
        }, {
            cache: createFastMemoizeCache(cache.pluralRules),
            strategy: (0, _fastMemoize.strategies).variadic
        })
    };
}
var IntlMessageFormat = /** @class */ function() {
    function IntlMessageFormat(message, locales, overrideFormats, opts) {
        if (locales === void 0) locales = IntlMessageFormat.defaultLocale;
        var _this = this;
        this.formatterCache = {
            number: {},
            dateTime: {},
            pluralRules: {}
        };
        this.format = function(values) {
            var parts = _this.formatToParts(values);
            // Hot path for straight simple msg translations
            if (parts.length === 1) return parts[0].value;
            var result = parts.reduce(function(all, part) {
                if (!all.length || part.type !== (0, _formatters.PART_TYPE).literal || typeof all[all.length - 1] !== 'string') all.push(part.value);
                else all[all.length - 1] += part.value;
                return all;
            }, []);
            if (result.length <= 1) return result[0] || '';
            return result;
        };
        this.formatToParts = function(values) {
            return (0, _formatters.formatToParts)(_this.ast, _this.locales, _this.formatters, _this.formats, values, undefined, _this.message);
        };
        this.resolvedOptions = function() {
            var _a;
            return {
                locale: ((_a = _this.resolvedLocale) === null || _a === void 0 ? void 0 : _a.toString()) || Intl.NumberFormat.supportedLocalesOf(_this.locales)[0]
            };
        };
        this.getAst = function() {
            return _this.ast;
        };
        // Defined first because it's used to build the format pattern.
        this.locales = locales;
        this.resolvedLocale = IntlMessageFormat.resolveLocale(locales);
        if (typeof message === 'string') {
            this.message = message;
            if (!IntlMessageFormat.__parse) throw new TypeError('IntlMessageFormat.__parse must be set to process `message` of type `string`');
            var _a = opts || {}, formatters = _a.formatters, parseOpts = (0, _tslib.__rest)(_a, [
                "formatters"
            ]);
            // Parse string messages into an AST.
            this.ast = IntlMessageFormat.__parse(message, (0, _tslib.__assign)((0, _tslib.__assign)({}, parseOpts), {
                locale: this.resolvedLocale
            }));
        } else this.ast = message;
        if (!Array.isArray(this.ast)) throw new TypeError('A message must be provided as a String or AST.');
        // Creates a new object with the specified `formats` merged with the default
        // formats.
        this.formats = mergeConfigs(IntlMessageFormat.formats, overrideFormats);
        this.formatters = opts && opts.formatters || createDefaultFormatters(this.formatterCache);
    }
    Object.defineProperty(IntlMessageFormat, "defaultLocale", {
        get: function() {
            if (!IntlMessageFormat.memoizedDefaultLocale) IntlMessageFormat.memoizedDefaultLocale = new Intl.NumberFormat().resolvedOptions().locale;
            return IntlMessageFormat.memoizedDefaultLocale;
        },
        enumerable: false,
        configurable: true
    });
    IntlMessageFormat.memoizedDefaultLocale = null;
    IntlMessageFormat.resolveLocale = function(locales) {
        if (typeof Intl.Locale === 'undefined') return;
        var supportedLocales = Intl.NumberFormat.supportedLocalesOf(locales);
        if (supportedLocales.length > 0) return new Intl.Locale(supportedLocales[0]);
        return new Intl.Locale(typeof locales === 'string' ? locales : locales[0]);
    };
    IntlMessageFormat.__parse = (0, _icuMessageformatParser.parse);
    // Default format options used as the prototype of the `formats` provided to the
    // constructor. These are used when constructing the internal Intl.NumberFormat
    // and Intl.DateTimeFormat instances.
    IntlMessageFormat.formats = {
        number: {
            integer: {
                maximumFractionDigits: 0
            },
            currency: {
                style: 'currency'
            },
            percent: {
                style: 'percent'
            }
        },
        date: {
            short: {
                month: 'numeric',
                day: 'numeric',
                year: '2-digit'
            },
            medium: {
                month: 'short',
                day: 'numeric',
                year: 'numeric'
            },
            long: {
                month: 'long',
                day: 'numeric',
                year: 'numeric'
            },
            full: {
                weekday: 'long',
                month: 'long',
                day: 'numeric',
                year: 'numeric'
            }
        },
        time: {
            short: {
                hour: 'numeric',
                minute: 'numeric'
            },
            medium: {
                hour: 'numeric',
                minute: 'numeric',
                second: 'numeric'
            },
            long: {
                hour: 'numeric',
                minute: 'numeric',
                second: 'numeric',
                timeZoneName: 'short'
            },
            full: {
                hour: 'numeric',
                minute: 'numeric',
                second: 'numeric',
                timeZoneName: 'short'
            }
        }
    };
    return IntlMessageFormat;
}();

},{"tslib":"6MhhU","@formatjs/fast-memoize":"abkD2","@formatjs/icu-messageformat-parser":"gNrtO","./formatters":"l38Sx","@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"gNrtO":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "isStructurallySame", ()=>(0, _manipulator.isStructurallySame));
parcelHelpers.export(exports, "parse", ()=>parse);
parcelHelpers.export(exports, "_Parser", ()=>_Parser);
var _tslib = require("tslib");
var _error = require("./error");
var _parser = require("./parser");
var _types = require("./types");
parcelHelpers.exportAll(_types, exports);
var _manipulator = require("./manipulator");
function pruneLocation(els) {
    els.forEach(function(el) {
        delete el.location;
        if ((0, _types.isSelectElement)(el) || (0, _types.isPluralElement)(el)) for(var k in el.options){
            delete el.options[k].location;
            pruneLocation(el.options[k].value);
        }
        else if ((0, _types.isNumberElement)(el) && (0, _types.isNumberSkeleton)(el.style)) delete el.style.location;
        else if (((0, _types.isDateElement)(el) || (0, _types.isTimeElement)(el)) && (0, _types.isDateTimeSkeleton)(el.style)) delete el.style.location;
        else if ((0, _types.isTagElement)(el)) pruneLocation(el.children);
    });
}
function parse(message, opts) {
    if (opts === void 0) opts = {};
    opts = (0, _tslib.__assign)({
        shouldParseSkeletons: true,
        requiresOtherClause: true
    }, opts);
    var result = new (0, _parser.Parser)(message, opts).parse();
    if (result.err) {
        var error = SyntaxError((0, _error.ErrorKind)[result.err.kind]);
        // @ts-expect-error Assign to error object
        error.location = result.err.location;
        // @ts-expect-error Assign to error object
        error.originalMessage = result.err.message;
        throw error;
    }
    if (!(opts === null || opts === void 0 ? void 0 : opts.captureLocation)) pruneLocation(result.val);
    return result.val;
}
var _Parser = (0, _parser.Parser);

},{"tslib":"6MhhU","./error":"ccJXP","./parser":"8y0yt","./types":"2FWjX","./manipulator":"bzfOU","@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"ccJXP":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "ErrorKind", ()=>ErrorKind);
var ErrorKind;
(function(ErrorKind) {
    /** Argument is unclosed (e.g. `{0`) */ ErrorKind[ErrorKind["EXPECT_ARGUMENT_CLOSING_BRACE"] = 1] = "EXPECT_ARGUMENT_CLOSING_BRACE";
    /** Argument is empty (e.g. `{}`). */ ErrorKind[ErrorKind["EMPTY_ARGUMENT"] = 2] = "EMPTY_ARGUMENT";
    /** Argument is malformed (e.g. `{foo!}``) */ ErrorKind[ErrorKind["MALFORMED_ARGUMENT"] = 3] = "MALFORMED_ARGUMENT";
    /** Expect an argument type (e.g. `{foo,}`) */ ErrorKind[ErrorKind["EXPECT_ARGUMENT_TYPE"] = 4] = "EXPECT_ARGUMENT_TYPE";
    /** Unsupported argument type (e.g. `{foo,foo}`) */ ErrorKind[ErrorKind["INVALID_ARGUMENT_TYPE"] = 5] = "INVALID_ARGUMENT_TYPE";
    /** Expect an argument style (e.g. `{foo, number, }`) */ ErrorKind[ErrorKind["EXPECT_ARGUMENT_STYLE"] = 6] = "EXPECT_ARGUMENT_STYLE";
    /** The number skeleton is invalid. */ ErrorKind[ErrorKind["INVALID_NUMBER_SKELETON"] = 7] = "INVALID_NUMBER_SKELETON";
    /** The date time skeleton is invalid. */ ErrorKind[ErrorKind["INVALID_DATE_TIME_SKELETON"] = 8] = "INVALID_DATE_TIME_SKELETON";
    /** Exepct a number skeleton following the `::` (e.g. `{foo, number, ::}`) */ ErrorKind[ErrorKind["EXPECT_NUMBER_SKELETON"] = 9] = "EXPECT_NUMBER_SKELETON";
    /** Exepct a date time skeleton following the `::` (e.g. `{foo, date, ::}`) */ ErrorKind[ErrorKind["EXPECT_DATE_TIME_SKELETON"] = 10] = "EXPECT_DATE_TIME_SKELETON";
    /** Unmatched apostrophes in the argument style (e.g. `{foo, number, 'test`) */ ErrorKind[ErrorKind["UNCLOSED_QUOTE_IN_ARGUMENT_STYLE"] = 11] = "UNCLOSED_QUOTE_IN_ARGUMENT_STYLE";
    /** Missing select argument options (e.g. `{foo, select}`) */ ErrorKind[ErrorKind["EXPECT_SELECT_ARGUMENT_OPTIONS"] = 12] = "EXPECT_SELECT_ARGUMENT_OPTIONS";
    /** Expecting an offset value in `plural` or `selectordinal` argument (e.g `{foo, plural, offset}`) */ ErrorKind[ErrorKind["EXPECT_PLURAL_ARGUMENT_OFFSET_VALUE"] = 13] = "EXPECT_PLURAL_ARGUMENT_OFFSET_VALUE";
    /** Offset value in `plural` or `selectordinal` is invalid (e.g. `{foo, plural, offset: x}`) */ ErrorKind[ErrorKind["INVALID_PLURAL_ARGUMENT_OFFSET_VALUE"] = 14] = "INVALID_PLURAL_ARGUMENT_OFFSET_VALUE";
    /** Expecting a selector in `select` argument (e.g `{foo, select}`) */ ErrorKind[ErrorKind["EXPECT_SELECT_ARGUMENT_SELECTOR"] = 15] = "EXPECT_SELECT_ARGUMENT_SELECTOR";
    /** Expecting a selector in `plural` or `selectordinal` argument (e.g `{foo, plural}`) */ ErrorKind[ErrorKind["EXPECT_PLURAL_ARGUMENT_SELECTOR"] = 16] = "EXPECT_PLURAL_ARGUMENT_SELECTOR";
    /** Expecting a message fragment after the `select` selector (e.g. `{foo, select, apple}`) */ ErrorKind[ErrorKind["EXPECT_SELECT_ARGUMENT_SELECTOR_FRAGMENT"] = 17] = "EXPECT_SELECT_ARGUMENT_SELECTOR_FRAGMENT";
    /**
     * Expecting a message fragment after the `plural` or `selectordinal` selector
     * (e.g. `{foo, plural, one}`)
     */ ErrorKind[ErrorKind["EXPECT_PLURAL_ARGUMENT_SELECTOR_FRAGMENT"] = 18] = "EXPECT_PLURAL_ARGUMENT_SELECTOR_FRAGMENT";
    /** Selector in `plural` or `selectordinal` is malformed (e.g. `{foo, plural, =x {#}}`) */ ErrorKind[ErrorKind["INVALID_PLURAL_ARGUMENT_SELECTOR"] = 19] = "INVALID_PLURAL_ARGUMENT_SELECTOR";
    /**
     * Duplicate selectors in `plural` or `selectordinal` argument.
     * (e.g. {foo, plural, one {#} one {#}})
     */ ErrorKind[ErrorKind["DUPLICATE_PLURAL_ARGUMENT_SELECTOR"] = 20] = "DUPLICATE_PLURAL_ARGUMENT_SELECTOR";
    /** Duplicate selectors in `select` argument.
     * (e.g. {foo, select, apple {apple} apple {apple}})
     */ ErrorKind[ErrorKind["DUPLICATE_SELECT_ARGUMENT_SELECTOR"] = 21] = "DUPLICATE_SELECT_ARGUMENT_SELECTOR";
    /** Plural or select argument option must have `other` clause. */ ErrorKind[ErrorKind["MISSING_OTHER_CLAUSE"] = 22] = "MISSING_OTHER_CLAUSE";
    /** The tag is malformed. (e.g. `<bold!>foo</bold!>) */ ErrorKind[ErrorKind["INVALID_TAG"] = 23] = "INVALID_TAG";
    /** The tag name is invalid. (e.g. `<123>foo</123>`) */ ErrorKind[ErrorKind["INVALID_TAG_NAME"] = 25] = "INVALID_TAG_NAME";
    /** The closing tag does not match the opening tag. (e.g. `<bold>foo</italic>`) */ ErrorKind[ErrorKind["UNMATCHED_CLOSING_TAG"] = 26] = "UNMATCHED_CLOSING_TAG";
    /** The opening tag has unmatched closing tag. (e.g. `<bold>foo`) */ ErrorKind[ErrorKind["UNCLOSED_TAG"] = 27] = "UNCLOSED_TAG";
})(ErrorKind || (ErrorKind = {}));

},{"@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"8y0yt":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "Parser", ()=>Parser);
var _tslib = require("tslib");
var _error = require("./error");
var _types = require("./types");
var _regexGenerated = require("./regex.generated");
var _icuSkeletonParser = require("@formatjs/icu-skeleton-parser");
var _dateTimePatternGenerator = require("./date-time-pattern-generator");
var _a;
var SPACE_SEPARATOR_START_REGEX = new RegExp("^".concat((0, _regexGenerated.SPACE_SEPARATOR_REGEX).source, "*"));
var SPACE_SEPARATOR_END_REGEX = new RegExp("".concat((0, _regexGenerated.SPACE_SEPARATOR_REGEX).source, "*$"));
function createLocation(start, end) {
    return {
        start: start,
        end: end
    };
}
// #region Ponyfills
// Consolidate these variables up top for easier toggling during debugging
var hasNativeStartsWith = !!String.prototype.startsWith && '_a'.startsWith('a', 1);
var hasNativeFromCodePoint = !!String.fromCodePoint;
var hasNativeFromEntries = !!Object.fromEntries;
var hasNativeCodePointAt = !!String.prototype.codePointAt;
var hasTrimStart = !!String.prototype.trimStart;
var hasTrimEnd = !!String.prototype.trimEnd;
var hasNativeIsSafeInteger = !!Number.isSafeInteger;
var isSafeInteger = hasNativeIsSafeInteger ? Number.isSafeInteger : function(n) {
    return typeof n === 'number' && isFinite(n) && Math.floor(n) === n && Math.abs(n) <= 0x1fffffffffffff;
};
// IE11 does not support y and u.
var REGEX_SUPPORTS_U_AND_Y = true;
try {
    var re = RE('([^\\p{White_Space}\\p{Pattern_Syntax}]*)', 'yu');
    /**
     * legacy Edge or Xbox One browser
     * Unicode flag support: supported
     * Pattern_Syntax support: not supported
     * See https://github.com/formatjs/formatjs/issues/2822
     */ REGEX_SUPPORTS_U_AND_Y = ((_a = re.exec('a')) === null || _a === void 0 ? void 0 : _a[0]) === 'a';
} catch (_) {
    REGEX_SUPPORTS_U_AND_Y = false;
}
var startsWith = hasNativeStartsWith ? function startsWith(s, search, position) {
    return s.startsWith(search, position);
} : function startsWith(s, search, position) {
    return s.slice(position, position + search.length) === search;
};
var fromCodePoint = hasNativeFromCodePoint ? String.fromCodePoint : function fromCodePoint() {
    var codePoints = [];
    for(var _i = 0; _i < arguments.length; _i++)codePoints[_i] = arguments[_i];
    var elements = '';
    var length = codePoints.length;
    var i = 0;
    var code;
    while(length > i){
        code = codePoints[i++];
        if (code > 0x10ffff) throw RangeError(code + ' is not a valid code point');
        elements += code < 0x10000 ? String.fromCharCode(code) : String.fromCharCode(((code -= 0x10000) >> 10) + 0xd800, code % 0x400 + 0xdc00);
    }
    return elements;
};
var fromEntries = // native
hasNativeFromEntries ? Object.fromEntries : function fromEntries(entries) {
    var obj = {};
    for(var _i = 0, entries_1 = entries; _i < entries_1.length; _i++){
        var _a = entries_1[_i], k = _a[0], v = _a[1];
        obj[k] = v;
    }
    return obj;
};
var codePointAt = hasNativeCodePointAt ? function codePointAt(s, index) {
    return s.codePointAt(index);
} : function codePointAt(s, index) {
    var size = s.length;
    if (index < 0 || index >= size) return undefined;
    var first = s.charCodeAt(index);
    var second;
    return first < 0xd800 || first > 0xdbff || index + 1 === size || (second = s.charCodeAt(index + 1)) < 0xdc00 || second > 0xdfff ? first : (first - 0xd800 << 10) + (second - 0xdc00) + 0x10000;
};
var trimStart = hasTrimStart ? function trimStart(s) {
    return s.trimStart();
} : function trimStart(s) {
    return s.replace(SPACE_SEPARATOR_START_REGEX, '');
};
var trimEnd = hasTrimEnd ? function trimEnd(s) {
    return s.trimEnd();
} : function trimEnd(s) {
    return s.replace(SPACE_SEPARATOR_END_REGEX, '');
};
// Prevent minifier to translate new RegExp to literal form that might cause syntax error on IE11.
function RE(s, flag) {
    return new RegExp(s, flag);
}
// #endregion
var matchIdentifierAtIndex;
if (REGEX_SUPPORTS_U_AND_Y) {
    // Native
    var IDENTIFIER_PREFIX_RE_1 = RE('([^\\p{White_Space}\\p{Pattern_Syntax}]*)', 'yu');
    matchIdentifierAtIndex = function matchIdentifierAtIndex(s, index) {
        var _a;
        IDENTIFIER_PREFIX_RE_1.lastIndex = index;
        var match = IDENTIFIER_PREFIX_RE_1.exec(s);
        return (_a = match[1]) !== null && _a !== void 0 ? _a : '';
    };
} else // IE11
matchIdentifierAtIndex = function matchIdentifierAtIndex(s, index) {
    var match = [];
    while(true){
        var c = codePointAt(s, index);
        if (c === undefined || _isWhiteSpace(c) || _isPatternSyntax(c)) break;
        match.push(c);
        index += c >= 0x10000 ? 2 : 1;
    }
    return fromCodePoint.apply(void 0, match);
};
var Parser = /** @class */ function() {
    function Parser(message, options) {
        if (options === void 0) options = {};
        this.message = message;
        this.position = {
            offset: 0,
            line: 1,
            column: 1
        };
        this.ignoreTag = !!options.ignoreTag;
        this.locale = options.locale;
        this.requiresOtherClause = !!options.requiresOtherClause;
        this.shouldParseSkeletons = !!options.shouldParseSkeletons;
    }
    Parser.prototype.parse = function() {
        if (this.offset() !== 0) throw Error('parser can only be used once');
        return this.parseMessage(0, '', false);
    };
    Parser.prototype.parseMessage = function(nestingLevel, parentArgType, expectingCloseTag) {
        var elements = [];
        while(!this.isEOF()){
            var char = this.char();
            if (char === 123 /* `{` */ ) {
                var result = this.parseArgument(nestingLevel, expectingCloseTag);
                if (result.err) return result;
                elements.push(result.val);
            } else if (char === 125 /* `}` */  && nestingLevel > 0) break;
            else if (char === 35 /* `#` */  && (parentArgType === 'plural' || parentArgType === 'selectordinal')) {
                var position = this.clonePosition();
                this.bump();
                elements.push({
                    type: (0, _types.TYPE).pound,
                    location: createLocation(position, this.clonePosition())
                });
            } else if (char === 60 /* `<` */  && !this.ignoreTag && this.peek() === 47 // char code for '/'
            ) {
                if (expectingCloseTag) break;
                else return this.error((0, _error.ErrorKind).UNMATCHED_CLOSING_TAG, createLocation(this.clonePosition(), this.clonePosition()));
            } else if (char === 60 /* `<` */  && !this.ignoreTag && _isAlpha(this.peek() || 0)) {
                var result = this.parseTag(nestingLevel, parentArgType);
                if (result.err) return result;
                elements.push(result.val);
            } else {
                var result = this.parseLiteral(nestingLevel, parentArgType);
                if (result.err) return result;
                elements.push(result.val);
            }
        }
        return {
            val: elements,
            err: null
        };
    };
    /**
     * A tag name must start with an ASCII lower/upper case letter. The grammar is based on the
     * [custom element name][] except that a dash is NOT always mandatory and uppercase letters
     * are accepted:
     *
     * ```
     * tag ::= "<" tagName (whitespace)* "/>" | "<" tagName (whitespace)* ">" message "</" tagName (whitespace)* ">"
     * tagName ::= [a-z] (PENChar)*
     * PENChar ::=
     *     "-" | "." | [0-9] | "_" | [a-z] | [A-Z] | #xB7 | [#xC0-#xD6] | [#xD8-#xF6] | [#xF8-#x37D] |
     *     [#x37F-#x1FFF] | [#x200C-#x200D] | [#x203F-#x2040] | [#x2070-#x218F] | [#x2C00-#x2FEF] |
     *     [#x3001-#xD7FF] | [#xF900-#xFDCF] | [#xFDF0-#xFFFD] | [#x10000-#xEFFFF]
     * ```
     *
     * [custom element name]: https://html.spec.whatwg.org/multipage/custom-elements.html#valid-custom-element-name
     * NOTE: We're a bit more lax here since HTML technically does not allow uppercase HTML element but we do
     * since other tag-based engines like React allow it
     */ Parser.prototype.parseTag = function(nestingLevel, parentArgType) {
        var startPosition = this.clonePosition();
        this.bump(); // `<`
        var tagName = this.parseTagName();
        this.bumpSpace();
        if (this.bumpIf('/>')) // Self closing tag
        return {
            val: {
                type: (0, _types.TYPE).literal,
                value: "<".concat(tagName, "/>"),
                location: createLocation(startPosition, this.clonePosition())
            },
            err: null
        };
        else if (this.bumpIf('>')) {
            var childrenResult = this.parseMessage(nestingLevel + 1, parentArgType, true);
            if (childrenResult.err) return childrenResult;
            var children = childrenResult.val;
            // Expecting a close tag
            var endTagStartPosition = this.clonePosition();
            if (this.bumpIf('</')) {
                if (this.isEOF() || !_isAlpha(this.char())) return this.error((0, _error.ErrorKind).INVALID_TAG, createLocation(endTagStartPosition, this.clonePosition()));
                var closingTagNameStartPosition = this.clonePosition();
                var closingTagName = this.parseTagName();
                if (tagName !== closingTagName) return this.error((0, _error.ErrorKind).UNMATCHED_CLOSING_TAG, createLocation(closingTagNameStartPosition, this.clonePosition()));
                this.bumpSpace();
                if (!this.bumpIf('>')) return this.error((0, _error.ErrorKind).INVALID_TAG, createLocation(endTagStartPosition, this.clonePosition()));
                return {
                    val: {
                        type: (0, _types.TYPE).tag,
                        value: tagName,
                        children: children,
                        location: createLocation(startPosition, this.clonePosition())
                    },
                    err: null
                };
            } else return this.error((0, _error.ErrorKind).UNCLOSED_TAG, createLocation(startPosition, this.clonePosition()));
        } else return this.error((0, _error.ErrorKind).INVALID_TAG, createLocation(startPosition, this.clonePosition()));
    };
    /**
     * This method assumes that the caller has peeked ahead for the first tag character.
     */ Parser.prototype.parseTagName = function() {
        var startOffset = this.offset();
        this.bump(); // the first tag name character
        while(!this.isEOF() && _isPotentialElementNameChar(this.char()))this.bump();
        return this.message.slice(startOffset, this.offset());
    };
    Parser.prototype.parseLiteral = function(nestingLevel, parentArgType) {
        var start = this.clonePosition();
        var value = '';
        while(true){
            var parseQuoteResult = this.tryParseQuote(parentArgType);
            if (parseQuoteResult) {
                value += parseQuoteResult;
                continue;
            }
            var parseUnquotedResult = this.tryParseUnquoted(nestingLevel, parentArgType);
            if (parseUnquotedResult) {
                value += parseUnquotedResult;
                continue;
            }
            var parseLeftAngleResult = this.tryParseLeftAngleBracket();
            if (parseLeftAngleResult) {
                value += parseLeftAngleResult;
                continue;
            }
            break;
        }
        var location = createLocation(start, this.clonePosition());
        return {
            val: {
                type: (0, _types.TYPE).literal,
                value: value,
                location: location
            },
            err: null
        };
    };
    Parser.prototype.tryParseLeftAngleBracket = function() {
        if (!this.isEOF() && this.char() === 60 /* `<` */  && (this.ignoreTag || // If at the opening tag or closing tag position, bail.
        !_isAlphaOrSlash(this.peek() || 0))) {
            this.bump(); // `<`
            return '<';
        }
        return null;
    };
    /**
     * Starting with ICU 4.8, an ASCII apostrophe only starts quoted text if it immediately precedes
     * a character that requires quoting (that is, "only where needed"), and works the same in
     * nested messages as on the top level of the pattern. The new behavior is otherwise compatible.
     */ Parser.prototype.tryParseQuote = function(parentArgType) {
        if (this.isEOF() || this.char() !== 39 /* `'` */ ) return null;
        // Parse escaped char following the apostrophe, or early return if there is no escaped char.
        // Check if is valid escaped character
        switch(this.peek()){
            case 39 /* `'` */ :
                // double quote, should return as a single quote.
                this.bump();
                this.bump();
                return "'";
            // '{', '<', '>', '}'
            case 123:
            case 60:
            case 62:
            case 125:
                break;
            case 35:
                if (parentArgType === 'plural' || parentArgType === 'selectordinal') break;
                return null;
            default:
                return null;
        }
        this.bump(); // apostrophe
        var codePoints = [
            this.char()
        ]; // escaped char
        this.bump();
        // read chars until the optional closing apostrophe is found
        while(!this.isEOF()){
            var ch = this.char();
            if (ch === 39 /* `'` */ ) {
                if (this.peek() === 39 /* `'` */ ) {
                    codePoints.push(39);
                    // Bump one more time because we need to skip 2 characters.
                    this.bump();
                } else {
                    // Optional closing apostrophe.
                    this.bump();
                    break;
                }
            } else codePoints.push(ch);
            this.bump();
        }
        return fromCodePoint.apply(void 0, codePoints);
    };
    Parser.prototype.tryParseUnquoted = function(nestingLevel, parentArgType) {
        if (this.isEOF()) return null;
        var ch = this.char();
        if (ch === 60 /* `<` */  || ch === 123 /* `{` */  || ch === 35 /* `#` */  && (parentArgType === 'plural' || parentArgType === 'selectordinal') || ch === 125 /* `}` */  && nestingLevel > 0) return null;
        else {
            this.bump();
            return fromCodePoint(ch);
        }
    };
    Parser.prototype.parseArgument = function(nestingLevel, expectingCloseTag) {
        var openingBracePosition = this.clonePosition();
        this.bump(); // `{`
        this.bumpSpace();
        if (this.isEOF()) return this.error((0, _error.ErrorKind).EXPECT_ARGUMENT_CLOSING_BRACE, createLocation(openingBracePosition, this.clonePosition()));
        if (this.char() === 125 /* `}` */ ) {
            this.bump();
            return this.error((0, _error.ErrorKind).EMPTY_ARGUMENT, createLocation(openingBracePosition, this.clonePosition()));
        }
        // argument name
        var value = this.parseIdentifierIfPossible().value;
        if (!value) return this.error((0, _error.ErrorKind).MALFORMED_ARGUMENT, createLocation(openingBracePosition, this.clonePosition()));
        this.bumpSpace();
        if (this.isEOF()) return this.error((0, _error.ErrorKind).EXPECT_ARGUMENT_CLOSING_BRACE, createLocation(openingBracePosition, this.clonePosition()));
        switch(this.char()){
            // Simple argument: `{name}`
            case 125 /* `}` */ :
                this.bump(); // `}`
                return {
                    val: {
                        type: (0, _types.TYPE).argument,
                        // value does not include the opening and closing braces.
                        value: value,
                        location: createLocation(openingBracePosition, this.clonePosition())
                    },
                    err: null
                };
            // Argument with options: `{name, format, ...}`
            case 44 /* `,` */ :
                this.bump(); // `,`
                this.bumpSpace();
                if (this.isEOF()) return this.error((0, _error.ErrorKind).EXPECT_ARGUMENT_CLOSING_BRACE, createLocation(openingBracePosition, this.clonePosition()));
                return this.parseArgumentOptions(nestingLevel, expectingCloseTag, value, openingBracePosition);
            default:
                return this.error((0, _error.ErrorKind).MALFORMED_ARGUMENT, createLocation(openingBracePosition, this.clonePosition()));
        }
    };
    /**
     * Advance the parser until the end of the identifier, if it is currently on
     * an identifier character. Return an empty string otherwise.
     */ Parser.prototype.parseIdentifierIfPossible = function() {
        var startingPosition = this.clonePosition();
        var startOffset = this.offset();
        var value = matchIdentifierAtIndex(this.message, startOffset);
        var endOffset = startOffset + value.length;
        this.bumpTo(endOffset);
        var endPosition = this.clonePosition();
        var location = createLocation(startingPosition, endPosition);
        return {
            value: value,
            location: location
        };
    };
    Parser.prototype.parseArgumentOptions = function(nestingLevel, expectingCloseTag, value, openingBracePosition) {
        var _a;
        // Parse this range:
        // {name, type, style}
        //        ^---^
        var typeStartPosition = this.clonePosition();
        var argType = this.parseIdentifierIfPossible().value;
        var typeEndPosition = this.clonePosition();
        switch(argType){
            case '':
                // Expecting a style string number, date, time, plural, selectordinal, or select.
                return this.error((0, _error.ErrorKind).EXPECT_ARGUMENT_TYPE, createLocation(typeStartPosition, typeEndPosition));
            case 'number':
            case 'date':
            case 'time':
                // Parse this range:
                // {name, number, style}
                //              ^-------^
                this.bumpSpace();
                var styleAndLocation = null;
                if (this.bumpIf(',')) {
                    this.bumpSpace();
                    var styleStartPosition = this.clonePosition();
                    var result = this.parseSimpleArgStyleIfPossible();
                    if (result.err) return result;
                    var style = trimEnd(result.val);
                    if (style.length === 0) return this.error((0, _error.ErrorKind).EXPECT_ARGUMENT_STYLE, createLocation(this.clonePosition(), this.clonePosition()));
                    var styleLocation = createLocation(styleStartPosition, this.clonePosition());
                    styleAndLocation = {
                        style: style,
                        styleLocation: styleLocation
                    };
                }
                var argCloseResult = this.tryParseArgumentClose(openingBracePosition);
                if (argCloseResult.err) return argCloseResult;
                var location_1 = createLocation(openingBracePosition, this.clonePosition());
                // Extract style or skeleton
                if (styleAndLocation && startsWith(styleAndLocation === null || styleAndLocation === void 0 ? void 0 : styleAndLocation.style, '::', 0)) {
                    // Skeleton starts with `::`.
                    var skeleton = trimStart(styleAndLocation.style.slice(2));
                    if (argType === 'number') {
                        var result = this.parseNumberSkeletonFromString(skeleton, styleAndLocation.styleLocation);
                        if (result.err) return result;
                        return {
                            val: {
                                type: (0, _types.TYPE).number,
                                value: value,
                                location: location_1,
                                style: result.val
                            },
                            err: null
                        };
                    } else {
                        if (skeleton.length === 0) return this.error((0, _error.ErrorKind).EXPECT_DATE_TIME_SKELETON, location_1);
                        var dateTimePattern = skeleton;
                        // Get "best match" pattern only if locale is passed, if not, let it
                        // pass as-is where `parseDateTimeSkeleton()` will throw an error
                        // for unsupported patterns.
                        if (this.locale) dateTimePattern = (0, _dateTimePatternGenerator.getBestPattern)(skeleton, this.locale);
                        var style = {
                            type: (0, _types.SKELETON_TYPE).dateTime,
                            pattern: dateTimePattern,
                            location: styleAndLocation.styleLocation,
                            parsedOptions: this.shouldParseSkeletons ? (0, _icuSkeletonParser.parseDateTimeSkeleton)(dateTimePattern) : {}
                        };
                        var type = argType === 'date' ? (0, _types.TYPE).date : (0, _types.TYPE).time;
                        return {
                            val: {
                                type: type,
                                value: value,
                                location: location_1,
                                style: style
                            },
                            err: null
                        };
                    }
                }
                // Regular style or no style.
                return {
                    val: {
                        type: argType === 'number' ? (0, _types.TYPE).number : argType === 'date' ? (0, _types.TYPE).date : (0, _types.TYPE).time,
                        value: value,
                        location: location_1,
                        style: (_a = styleAndLocation === null || styleAndLocation === void 0 ? void 0 : styleAndLocation.style) !== null && _a !== void 0 ? _a : null
                    },
                    err: null
                };
            case 'plural':
            case 'selectordinal':
            case 'select':
                // Parse this range:
                // {name, plural, options}
                //              ^---------^
                var typeEndPosition_1 = this.clonePosition();
                this.bumpSpace();
                if (!this.bumpIf(',')) return this.error((0, _error.ErrorKind).EXPECT_SELECT_ARGUMENT_OPTIONS, createLocation(typeEndPosition_1, (0, _tslib.__assign)({}, typeEndPosition_1)));
                this.bumpSpace();
                // Parse offset:
                // {name, plural, offset:1, options}
                //                ^-----^
                //
                // or the first option:
                //
                // {name, plural, one {...} other {...}}
                //                ^--^
                var identifierAndLocation = this.parseIdentifierIfPossible();
                var pluralOffset = 0;
                if (argType !== 'select' && identifierAndLocation.value === 'offset') {
                    if (!this.bumpIf(':')) return this.error((0, _error.ErrorKind).EXPECT_PLURAL_ARGUMENT_OFFSET_VALUE, createLocation(this.clonePosition(), this.clonePosition()));
                    this.bumpSpace();
                    var result = this.tryParseDecimalInteger((0, _error.ErrorKind).EXPECT_PLURAL_ARGUMENT_OFFSET_VALUE, (0, _error.ErrorKind).INVALID_PLURAL_ARGUMENT_OFFSET_VALUE);
                    if (result.err) return result;
                    // Parse another identifier for option parsing
                    this.bumpSpace();
                    identifierAndLocation = this.parseIdentifierIfPossible();
                    pluralOffset = result.val;
                }
                var optionsResult = this.tryParsePluralOrSelectOptions(nestingLevel, argType, expectingCloseTag, identifierAndLocation);
                if (optionsResult.err) return optionsResult;
                var argCloseResult = this.tryParseArgumentClose(openingBracePosition);
                if (argCloseResult.err) return argCloseResult;
                var location_2 = createLocation(openingBracePosition, this.clonePosition());
                if (argType === 'select') return {
                    val: {
                        type: (0, _types.TYPE).select,
                        value: value,
                        options: fromEntries(optionsResult.val),
                        location: location_2
                    },
                    err: null
                };
                else return {
                    val: {
                        type: (0, _types.TYPE).plural,
                        value: value,
                        options: fromEntries(optionsResult.val),
                        offset: pluralOffset,
                        pluralType: argType === 'plural' ? 'cardinal' : 'ordinal',
                        location: location_2
                    },
                    err: null
                };
            default:
                return this.error((0, _error.ErrorKind).INVALID_ARGUMENT_TYPE, createLocation(typeStartPosition, typeEndPosition));
        }
    };
    Parser.prototype.tryParseArgumentClose = function(openingBracePosition) {
        // Parse: {value, number, ::currency/GBP }
        //
        if (this.isEOF() || this.char() !== 125 /* `}` */ ) return this.error((0, _error.ErrorKind).EXPECT_ARGUMENT_CLOSING_BRACE, createLocation(openingBracePosition, this.clonePosition()));
        this.bump(); // `}`
        return {
            val: true,
            err: null
        };
    };
    /**
     * See: https://github.com/unicode-org/icu/blob/af7ed1f6d2298013dc303628438ec4abe1f16479/icu4c/source/common/messagepattern.cpp#L659
     */ Parser.prototype.parseSimpleArgStyleIfPossible = function() {
        var nestedBraces = 0;
        var startPosition = this.clonePosition();
        while(!this.isEOF()){
            var ch = this.char();
            switch(ch){
                case 39 /* `'` */ :
                    // Treat apostrophe as quoting but include it in the style part.
                    // Find the end of the quoted literal text.
                    this.bump();
                    var apostrophePosition = this.clonePosition();
                    if (!this.bumpUntil("'")) return this.error((0, _error.ErrorKind).UNCLOSED_QUOTE_IN_ARGUMENT_STYLE, createLocation(apostrophePosition, this.clonePosition()));
                    this.bump();
                    break;
                case 123 /* `{` */ :
                    nestedBraces += 1;
                    this.bump();
                    break;
                case 125 /* `}` */ :
                    if (nestedBraces > 0) nestedBraces -= 1;
                    else return {
                        val: this.message.slice(startPosition.offset, this.offset()),
                        err: null
                    };
                    break;
                default:
                    this.bump();
                    break;
            }
        }
        return {
            val: this.message.slice(startPosition.offset, this.offset()),
            err: null
        };
    };
    Parser.prototype.parseNumberSkeletonFromString = function(skeleton, location) {
        var tokens = [];
        try {
            tokens = (0, _icuSkeletonParser.parseNumberSkeletonFromString)(skeleton);
        } catch (e) {
            return this.error((0, _error.ErrorKind).INVALID_NUMBER_SKELETON, location);
        }
        return {
            val: {
                type: (0, _types.SKELETON_TYPE).number,
                tokens: tokens,
                location: location,
                parsedOptions: this.shouldParseSkeletons ? (0, _icuSkeletonParser.parseNumberSkeleton)(tokens) : {}
            },
            err: null
        };
    };
    /**
     * @param nesting_level The current nesting level of messages.
     *     This can be positive when parsing message fragment in select or plural argument options.
     * @param parent_arg_type The parent argument's type.
     * @param parsed_first_identifier If provided, this is the first identifier-like selector of
     *     the argument. It is a by-product of a previous parsing attempt.
     * @param expecting_close_tag If true, this message is directly or indirectly nested inside
     *     between a pair of opening and closing tags. The nested message will not parse beyond
     *     the closing tag boundary.
     */ Parser.prototype.tryParsePluralOrSelectOptions = function(nestingLevel, parentArgType, expectCloseTag, parsedFirstIdentifier) {
        var _a;
        var hasOtherClause = false;
        var options = [];
        var parsedSelectors = new Set();
        var selector = parsedFirstIdentifier.value, selectorLocation = parsedFirstIdentifier.location;
        // Parse:
        // one {one apple}
        // ^--^
        while(true){
            if (selector.length === 0) {
                var startPosition = this.clonePosition();
                if (parentArgType !== 'select' && this.bumpIf('=')) {
                    // Try parse `={number}` selector
                    var result = this.tryParseDecimalInteger((0, _error.ErrorKind).EXPECT_PLURAL_ARGUMENT_SELECTOR, (0, _error.ErrorKind).INVALID_PLURAL_ARGUMENT_SELECTOR);
                    if (result.err) return result;
                    selectorLocation = createLocation(startPosition, this.clonePosition());
                    selector = this.message.slice(startPosition.offset, this.offset());
                } else break;
            }
            // Duplicate selector clauses
            if (parsedSelectors.has(selector)) return this.error(parentArgType === 'select' ? (0, _error.ErrorKind).DUPLICATE_SELECT_ARGUMENT_SELECTOR : (0, _error.ErrorKind).DUPLICATE_PLURAL_ARGUMENT_SELECTOR, selectorLocation);
            if (selector === 'other') hasOtherClause = true;
            // Parse:
            // one {one apple}
            //     ^----------^
            this.bumpSpace();
            var openingBracePosition = this.clonePosition();
            if (!this.bumpIf('{')) return this.error(parentArgType === 'select' ? (0, _error.ErrorKind).EXPECT_SELECT_ARGUMENT_SELECTOR_FRAGMENT : (0, _error.ErrorKind).EXPECT_PLURAL_ARGUMENT_SELECTOR_FRAGMENT, createLocation(this.clonePosition(), this.clonePosition()));
            var fragmentResult = this.parseMessage(nestingLevel + 1, parentArgType, expectCloseTag);
            if (fragmentResult.err) return fragmentResult;
            var argCloseResult = this.tryParseArgumentClose(openingBracePosition);
            if (argCloseResult.err) return argCloseResult;
            options.push([
                selector,
                {
                    value: fragmentResult.val,
                    location: createLocation(openingBracePosition, this.clonePosition())
                }
            ]);
            // Keep track of the existing selectors
            parsedSelectors.add(selector);
            // Prep next selector clause.
            this.bumpSpace();
            _a = this.parseIdentifierIfPossible(), selector = _a.value, selectorLocation = _a.location;
        }
        if (options.length === 0) return this.error(parentArgType === 'select' ? (0, _error.ErrorKind).EXPECT_SELECT_ARGUMENT_SELECTOR : (0, _error.ErrorKind).EXPECT_PLURAL_ARGUMENT_SELECTOR, createLocation(this.clonePosition(), this.clonePosition()));
        if (this.requiresOtherClause && !hasOtherClause) return this.error((0, _error.ErrorKind).MISSING_OTHER_CLAUSE, createLocation(this.clonePosition(), this.clonePosition()));
        return {
            val: options,
            err: null
        };
    };
    Parser.prototype.tryParseDecimalInteger = function(expectNumberError, invalidNumberError) {
        var sign = 1;
        var startingPosition = this.clonePosition();
        if (this.bumpIf('+')) ;
        else if (this.bumpIf('-')) sign = -1;
        var hasDigits = false;
        var decimal = 0;
        while(!this.isEOF()){
            var ch = this.char();
            if (ch >= 48 /* `0` */  && ch <= 57 /* `9` */ ) {
                hasDigits = true;
                decimal = decimal * 10 + (ch - 48);
                this.bump();
            } else break;
        }
        var location = createLocation(startingPosition, this.clonePosition());
        if (!hasDigits) return this.error(expectNumberError, location);
        decimal *= sign;
        if (!isSafeInteger(decimal)) return this.error(invalidNumberError, location);
        return {
            val: decimal,
            err: null
        };
    };
    Parser.prototype.offset = function() {
        return this.position.offset;
    };
    Parser.prototype.isEOF = function() {
        return this.offset() === this.message.length;
    };
    Parser.prototype.clonePosition = function() {
        // This is much faster than `Object.assign` or spread.
        return {
            offset: this.position.offset,
            line: this.position.line,
            column: this.position.column
        };
    };
    /**
     * Return the code point at the current position of the parser.
     * Throws if the index is out of bound.
     */ Parser.prototype.char = function() {
        var offset = this.position.offset;
        if (offset >= this.message.length) throw Error('out of bound');
        var code = codePointAt(this.message, offset);
        if (code === undefined) throw Error("Offset ".concat(offset, " is at invalid UTF-16 code unit boundary"));
        return code;
    };
    Parser.prototype.error = function(kind, location) {
        return {
            val: null,
            err: {
                kind: kind,
                message: this.message,
                location: location
            }
        };
    };
    /** Bump the parser to the next UTF-16 code unit. */ Parser.prototype.bump = function() {
        if (this.isEOF()) return;
        var code = this.char();
        if (code === 10 /* '\n' */ ) {
            this.position.line += 1;
            this.position.column = 1;
            this.position.offset += 1;
        } else {
            this.position.column += 1;
            // 0 ~ 0x10000 -> unicode BMP, otherwise skip the surrogate pair.
            this.position.offset += code < 0x10000 ? 1 : 2;
        }
    };
    /**
     * If the substring starting at the current position of the parser has
     * the given prefix, then bump the parser to the character immediately
     * following the prefix and return true. Otherwise, don't bump the parser
     * and return false.
     */ Parser.prototype.bumpIf = function(prefix) {
        if (startsWith(this.message, prefix, this.offset())) {
            for(var i = 0; i < prefix.length; i++)this.bump();
            return true;
        }
        return false;
    };
    /**
     * Bump the parser until the pattern character is found and return `true`.
     * Otherwise bump to the end of the file and return `false`.
     */ Parser.prototype.bumpUntil = function(pattern) {
        var currentOffset = this.offset();
        var index = this.message.indexOf(pattern, currentOffset);
        if (index >= 0) {
            this.bumpTo(index);
            return true;
        } else {
            this.bumpTo(this.message.length);
            return false;
        }
    };
    /**
     * Bump the parser to the target offset.
     * If target offset is beyond the end of the input, bump the parser to the end of the input.
     */ Parser.prototype.bumpTo = function(targetOffset) {
        if (this.offset() > targetOffset) throw Error("targetOffset ".concat(targetOffset, " must be greater than or equal to the current offset ").concat(this.offset()));
        targetOffset = Math.min(targetOffset, this.message.length);
        while(true){
            var offset = this.offset();
            if (offset === targetOffset) break;
            if (offset > targetOffset) throw Error("targetOffset ".concat(targetOffset, " is at invalid UTF-16 code unit boundary"));
            this.bump();
            if (this.isEOF()) break;
        }
    };
    /** advance the parser through all whitespace to the next non-whitespace code unit. */ Parser.prototype.bumpSpace = function() {
        while(!this.isEOF() && _isWhiteSpace(this.char()))this.bump();
    };
    /**
     * Peek at the *next* Unicode codepoint in the input without advancing the parser.
     * If the input has been exhausted, then this returns null.
     */ Parser.prototype.peek = function() {
        if (this.isEOF()) return null;
        var code = this.char();
        var offset = this.offset();
        var nextCode = this.message.charCodeAt(offset + (code >= 0x10000 ? 2 : 1));
        return nextCode !== null && nextCode !== void 0 ? nextCode : null;
    };
    return Parser;
}();
/**
 * This check if codepoint is alphabet (lower & uppercase)
 * @param codepoint
 * @returns
 */ function _isAlpha(codepoint) {
    return codepoint >= 97 && codepoint <= 122 || codepoint >= 65 && codepoint <= 90;
}
function _isAlphaOrSlash(codepoint) {
    return _isAlpha(codepoint) || codepoint === 47; /* '/' */ 
}
/** See `parseTag` function docs. */ function _isPotentialElementNameChar(c) {
    return c === 45 /* '-' */  || c === 46 /* '.' */  || c >= 48 && c <= 57 || c === 95 /* '_' */  || c >= 97 && c <= 122 || c >= 65 && c <= 90 || c == 0xb7 || c >= 0xc0 && c <= 0xd6 || c >= 0xd8 && c <= 0xf6 || c >= 0xf8 && c <= 0x37d || c >= 0x37f && c <= 0x1fff || c >= 0x200c && c <= 0x200d || c >= 0x203f && c <= 0x2040 || c >= 0x2070 && c <= 0x218f || c >= 0x2c00 && c <= 0x2fef || c >= 0x3001 && c <= 0xd7ff || c >= 0xf900 && c <= 0xfdcf || c >= 0xfdf0 && c <= 0xfffd || c >= 0x10000 && c <= 0xeffff;
}
/**
 * Code point equivalent of regex `\p{White_Space}`.
 * From: https://www.unicode.org/Public/UCD/latest/ucd/PropList.txt
 */ function _isWhiteSpace(c) {
    return c >= 0x0009 && c <= 0x000d || c === 0x0020 || c === 0x0085 || c >= 0x200e && c <= 0x200f || c === 0x2028 || c === 0x2029;
}
/**
 * Code point equivalent of regex `\p{Pattern_Syntax}`.
 * See https://www.unicode.org/Public/UCD/latest/ucd/PropList.txt
 */ function _isPatternSyntax(c) {
    return c >= 0x0021 && c <= 0x0023 || c === 0x0024 || c >= 0x0025 && c <= 0x0027 || c === 0x0028 || c === 0x0029 || c === 0x002a || c === 0x002b || c === 0x002c || c === 0x002d || c >= 0x002e && c <= 0x002f || c >= 0x003a && c <= 0x003b || c >= 0x003c && c <= 0x003e || c >= 0x003f && c <= 0x0040 || c === 0x005b || c === 0x005c || c === 0x005d || c === 0x005e || c === 0x0060 || c === 0x007b || c === 0x007c || c === 0x007d || c === 0x007e || c === 0x00a1 || c >= 0x00a2 && c <= 0x00a5 || c === 0x00a6 || c === 0x00a7 || c === 0x00a9 || c === 0x00ab || c === 0x00ac || c === 0x00ae || c === 0x00b0 || c === 0x00b1 || c === 0x00b6 || c === 0x00bb || c === 0x00bf || c === 0x00d7 || c === 0x00f7 || c >= 0x2010 && c <= 0x2015 || c >= 0x2016 && c <= 0x2017 || c === 0x2018 || c === 0x2019 || c === 0x201a || c >= 0x201b && c <= 0x201c || c === 0x201d || c === 0x201e || c === 0x201f || c >= 0x2020 && c <= 0x2027 || c >= 0x2030 && c <= 0x2038 || c === 0x2039 || c === 0x203a || c >= 0x203b && c <= 0x203e || c >= 0x2041 && c <= 0x2043 || c === 0x2044 || c === 0x2045 || c === 0x2046 || c >= 0x2047 && c <= 0x2051 || c === 0x2052 || c === 0x2053 || c >= 0x2055 && c <= 0x205e || c >= 0x2190 && c <= 0x2194 || c >= 0x2195 && c <= 0x2199 || c >= 0x219a && c <= 0x219b || c >= 0x219c && c <= 0x219f || c === 0x21a0 || c >= 0x21a1 && c <= 0x21a2 || c === 0x21a3 || c >= 0x21a4 && c <= 0x21a5 || c === 0x21a6 || c >= 0x21a7 && c <= 0x21ad || c === 0x21ae || c >= 0x21af && c <= 0x21cd || c >= 0x21ce && c <= 0x21cf || c >= 0x21d0 && c <= 0x21d1 || c === 0x21d2 || c === 0x21d3 || c === 0x21d4 || c >= 0x21d5 && c <= 0x21f3 || c >= 0x21f4 && c <= 0x22ff || c >= 0x2300 && c <= 0x2307 || c === 0x2308 || c === 0x2309 || c === 0x230a || c === 0x230b || c >= 0x230c && c <= 0x231f || c >= 0x2320 && c <= 0x2321 || c >= 0x2322 && c <= 0x2328 || c === 0x2329 || c === 0x232a || c >= 0x232b && c <= 0x237b || c === 0x237c || c >= 0x237d && c <= 0x239a || c >= 0x239b && c <= 0x23b3 || c >= 0x23b4 && c <= 0x23db || c >= 0x23dc && c <= 0x23e1 || c >= 0x23e2 && c <= 0x2426 || c >= 0x2427 && c <= 0x243f || c >= 0x2440 && c <= 0x244a || c >= 0x244b && c <= 0x245f || c >= 0x2500 && c <= 0x25b6 || c === 0x25b7 || c >= 0x25b8 && c <= 0x25c0 || c === 0x25c1 || c >= 0x25c2 && c <= 0x25f7 || c >= 0x25f8 && c <= 0x25ff || c >= 0x2600 && c <= 0x266e || c === 0x266f || c >= 0x2670 && c <= 0x2767 || c === 0x2768 || c === 0x2769 || c === 0x276a || c === 0x276b || c === 0x276c || c === 0x276d || c === 0x276e || c === 0x276f || c === 0x2770 || c === 0x2771 || c === 0x2772 || c === 0x2773 || c === 0x2774 || c === 0x2775 || c >= 0x2794 && c <= 0x27bf || c >= 0x27c0 && c <= 0x27c4 || c === 0x27c5 || c === 0x27c6 || c >= 0x27c7 && c <= 0x27e5 || c === 0x27e6 || c === 0x27e7 || c === 0x27e8 || c === 0x27e9 || c === 0x27ea || c === 0x27eb || c === 0x27ec || c === 0x27ed || c === 0x27ee || c === 0x27ef || c >= 0x27f0 && c <= 0x27ff || c >= 0x2800 && c <= 0x28ff || c >= 0x2900 && c <= 0x2982 || c === 0x2983 || c === 0x2984 || c === 0x2985 || c === 0x2986 || c === 0x2987 || c === 0x2988 || c === 0x2989 || c === 0x298a || c === 0x298b || c === 0x298c || c === 0x298d || c === 0x298e || c === 0x298f || c === 0x2990 || c === 0x2991 || c === 0x2992 || c === 0x2993 || c === 0x2994 || c === 0x2995 || c === 0x2996 || c === 0x2997 || c === 0x2998 || c >= 0x2999 && c <= 0x29d7 || c === 0x29d8 || c === 0x29d9 || c === 0x29da || c === 0x29db || c >= 0x29dc && c <= 0x29fb || c === 0x29fc || c === 0x29fd || c >= 0x29fe && c <= 0x2aff || c >= 0x2b00 && c <= 0x2b2f || c >= 0x2b30 && c <= 0x2b44 || c >= 0x2b45 && c <= 0x2b46 || c >= 0x2b47 && c <= 0x2b4c || c >= 0x2b4d && c <= 0x2b73 || c >= 0x2b74 && c <= 0x2b75 || c >= 0x2b76 && c <= 0x2b95 || c === 0x2b96 || c >= 0x2b97 && c <= 0x2bff || c >= 0x2e00 && c <= 0x2e01 || c === 0x2e02 || c === 0x2e03 || c === 0x2e04 || c === 0x2e05 || c >= 0x2e06 && c <= 0x2e08 || c === 0x2e09 || c === 0x2e0a || c === 0x2e0b || c === 0x2e0c || c === 0x2e0d || c >= 0x2e0e && c <= 0x2e16 || c === 0x2e17 || c >= 0x2e18 && c <= 0x2e19 || c === 0x2e1a || c === 0x2e1b || c === 0x2e1c || c === 0x2e1d || c >= 0x2e1e && c <= 0x2e1f || c === 0x2e20 || c === 0x2e21 || c === 0x2e22 || c === 0x2e23 || c === 0x2e24 || c === 0x2e25 || c === 0x2e26 || c === 0x2e27 || c === 0x2e28 || c === 0x2e29 || c >= 0x2e2a && c <= 0x2e2e || c === 0x2e2f || c >= 0x2e30 && c <= 0x2e39 || c >= 0x2e3a && c <= 0x2e3b || c >= 0x2e3c && c <= 0x2e3f || c === 0x2e40 || c === 0x2e41 || c === 0x2e42 || c >= 0x2e43 && c <= 0x2e4f || c >= 0x2e50 && c <= 0x2e51 || c === 0x2e52 || c >= 0x2e53 && c <= 0x2e7f || c >= 0x3001 && c <= 0x3003 || c === 0x3008 || c === 0x3009 || c === 0x300a || c === 0x300b || c === 0x300c || c === 0x300d || c === 0x300e || c === 0x300f || c === 0x3010 || c === 0x3011 || c >= 0x3012 && c <= 0x3013 || c === 0x3014 || c === 0x3015 || c === 0x3016 || c === 0x3017 || c === 0x3018 || c === 0x3019 || c === 0x301a || c === 0x301b || c === 0x301c || c === 0x301d || c >= 0x301e && c <= 0x301f || c === 0x3020 || c === 0x3030 || c === 0xfd3e || c === 0xfd3f || c >= 0xfe45 && c <= 0xfe46;
}

},{"tslib":"6MhhU","./error":"ccJXP","./types":"2FWjX","./regex.generated":"54MVg","@formatjs/icu-skeleton-parser":"grXgR","./date-time-pattern-generator":"cdVKe","@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"2FWjX":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "TYPE", ()=>TYPE);
parcelHelpers.export(exports, "SKELETON_TYPE", ()=>SKELETON_TYPE);
/**
 * Type Guards
 */ parcelHelpers.export(exports, "isLiteralElement", ()=>isLiteralElement);
parcelHelpers.export(exports, "isArgumentElement", ()=>isArgumentElement);
parcelHelpers.export(exports, "isNumberElement", ()=>isNumberElement);
parcelHelpers.export(exports, "isDateElement", ()=>isDateElement);
parcelHelpers.export(exports, "isTimeElement", ()=>isTimeElement);
parcelHelpers.export(exports, "isSelectElement", ()=>isSelectElement);
parcelHelpers.export(exports, "isPluralElement", ()=>isPluralElement);
parcelHelpers.export(exports, "isPoundElement", ()=>isPoundElement);
parcelHelpers.export(exports, "isTagElement", ()=>isTagElement);
parcelHelpers.export(exports, "isNumberSkeleton", ()=>isNumberSkeleton);
parcelHelpers.export(exports, "isDateTimeSkeleton", ()=>isDateTimeSkeleton);
parcelHelpers.export(exports, "createLiteralElement", ()=>createLiteralElement);
parcelHelpers.export(exports, "createNumberElement", ()=>createNumberElement);
var TYPE;
(function(TYPE) {
    /**
     * Raw text
     */ TYPE[TYPE["literal"] = 0] = "literal";
    /**
     * Variable w/o any format, e.g `var` in `this is a {var}`
     */ TYPE[TYPE["argument"] = 1] = "argument";
    /**
     * Variable w/ number format
     */ TYPE[TYPE["number"] = 2] = "number";
    /**
     * Variable w/ date format
     */ TYPE[TYPE["date"] = 3] = "date";
    /**
     * Variable w/ time format
     */ TYPE[TYPE["time"] = 4] = "time";
    /**
     * Variable w/ select format
     */ TYPE[TYPE["select"] = 5] = "select";
    /**
     * Variable w/ plural format
     */ TYPE[TYPE["plural"] = 6] = "plural";
    /**
     * Only possible within plural argument.
     * This is the `#` symbol that will be substituted with the count.
     */ TYPE[TYPE["pound"] = 7] = "pound";
    /**
     * XML-like tag
     */ TYPE[TYPE["tag"] = 8] = "tag";
})(TYPE || (TYPE = {}));
var SKELETON_TYPE;
(function(SKELETON_TYPE) {
    SKELETON_TYPE[SKELETON_TYPE["number"] = 0] = "number";
    SKELETON_TYPE[SKELETON_TYPE["dateTime"] = 1] = "dateTime";
})(SKELETON_TYPE || (SKELETON_TYPE = {}));
function isLiteralElement(el) {
    return el.type === TYPE.literal;
}
function isArgumentElement(el) {
    return el.type === TYPE.argument;
}
function isNumberElement(el) {
    return el.type === TYPE.number;
}
function isDateElement(el) {
    return el.type === TYPE.date;
}
function isTimeElement(el) {
    return el.type === TYPE.time;
}
function isSelectElement(el) {
    return el.type === TYPE.select;
}
function isPluralElement(el) {
    return el.type === TYPE.plural;
}
function isPoundElement(el) {
    return el.type === TYPE.pound;
}
function isTagElement(el) {
    return el.type === TYPE.tag;
}
function isNumberSkeleton(el) {
    return !!(el && typeof el === 'object' && el.type === SKELETON_TYPE.number);
}
function isDateTimeSkeleton(el) {
    return !!(el && typeof el === 'object' && el.type === SKELETON_TYPE.dateTime);
}
function createLiteralElement(value) {
    return {
        type: TYPE.literal,
        value: value
    };
}
function createNumberElement(value, style) {
    return {
        type: TYPE.number,
        value: value,
        style: style
    };
}

},{"@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"54MVg":[function(require,module,exports,__globalThis) {
// @generated from regex-gen.ts
var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "SPACE_SEPARATOR_REGEX", ()=>SPACE_SEPARATOR_REGEX);
parcelHelpers.export(exports, "WHITE_SPACE_REGEX", ()=>WHITE_SPACE_REGEX);
var SPACE_SEPARATOR_REGEX = /[ \xA0\u1680\u2000-\u200A\u202F\u205F\u3000]/;
var WHITE_SPACE_REGEX = /[\t-\r \x85\u200E\u200F\u2028\u2029]/;

},{"@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"grXgR":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _dateTime = require("./date-time");
parcelHelpers.exportAll(_dateTime, exports);
var _number = require("./number");
parcelHelpers.exportAll(_number, exports);

},{"./date-time":"9mD7Z","./number":"hdU52","@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"9mD7Z":[function(require,module,exports,__globalThis) {
/**
 * https://unicode.org/reports/tr35/tr35-dates.html#Date_Field_Symbol_Table
 * Credit: https://github.com/caridy/intl-datetimeformat-pattern/blob/master/index.js
 * with some tweaks
 */ var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
/**
 * Parse Date time skeleton into Intl.DateTimeFormatOptions
 * Ref: https://unicode.org/reports/tr35/tr35-dates.html#Date_Field_Symbol_Table
 * @public
 * @param skeleton skeleton string
 */ parcelHelpers.export(exports, "parseDateTimeSkeleton", ()=>parseDateTimeSkeleton);
var DATE_TIME_REGEX = /(?:[Eec]{1,6}|G{1,5}|[Qq]{1,5}|(?:[yYur]+|U{1,5})|[ML]{1,5}|d{1,2}|D{1,3}|F{1}|[abB]{1,5}|[hkHK]{1,2}|w{1,2}|W{1}|m{1,2}|s{1,2}|[zZOvVxX]{1,4})(?=([^']*'[^']*')*[^']*$)/g;
function parseDateTimeSkeleton(skeleton) {
    var result = {};
    skeleton.replace(DATE_TIME_REGEX, function(match) {
        var len = match.length;
        switch(match[0]){
            // Era
            case 'G':
                result.era = len === 4 ? 'long' : len === 5 ? 'narrow' : 'short';
                break;
            // Year
            case 'y':
                result.year = len === 2 ? '2-digit' : 'numeric';
                break;
            case 'Y':
            case 'u':
            case 'U':
            case 'r':
                throw new RangeError('`Y/u/U/r` (year) patterns are not supported, use `y` instead');
            // Quarter
            case 'q':
            case 'Q':
                throw new RangeError('`q/Q` (quarter) patterns are not supported');
            // Month
            case 'M':
            case 'L':
                result.month = [
                    'numeric',
                    '2-digit',
                    'short',
                    'long',
                    'narrow'
                ][len - 1];
                break;
            // Week
            case 'w':
            case 'W':
                throw new RangeError('`w/W` (week) patterns are not supported');
            case 'd':
                result.day = [
                    'numeric',
                    '2-digit'
                ][len - 1];
                break;
            case 'D':
            case 'F':
            case 'g':
                throw new RangeError('`D/F/g` (day) patterns are not supported, use `d` instead');
            // Weekday
            case 'E':
                result.weekday = len === 4 ? 'long' : len === 5 ? 'narrow' : 'short';
                break;
            case 'e':
                if (len < 4) throw new RangeError('`e..eee` (weekday) patterns are not supported');
                result.weekday = [
                    'short',
                    'long',
                    'narrow',
                    'short'
                ][len - 4];
                break;
            case 'c':
                if (len < 4) throw new RangeError('`c..ccc` (weekday) patterns are not supported');
                result.weekday = [
                    'short',
                    'long',
                    'narrow',
                    'short'
                ][len - 4];
                break;
            // Period
            case 'a':
                result.hour12 = true;
                break;
            case 'b':
            case 'B':
                throw new RangeError('`b/B` (period) patterns are not supported, use `a` instead');
            // Hour
            case 'h':
                result.hourCycle = 'h12';
                result.hour = [
                    'numeric',
                    '2-digit'
                ][len - 1];
                break;
            case 'H':
                result.hourCycle = 'h23';
                result.hour = [
                    'numeric',
                    '2-digit'
                ][len - 1];
                break;
            case 'K':
                result.hourCycle = 'h11';
                result.hour = [
                    'numeric',
                    '2-digit'
                ][len - 1];
                break;
            case 'k':
                result.hourCycle = 'h24';
                result.hour = [
                    'numeric',
                    '2-digit'
                ][len - 1];
                break;
            case 'j':
            case 'J':
            case 'C':
                throw new RangeError('`j/J/C` (hour) patterns are not supported, use `h/H/K/k` instead');
            // Minute
            case 'm':
                result.minute = [
                    'numeric',
                    '2-digit'
                ][len - 1];
                break;
            // Second
            case 's':
                result.second = [
                    'numeric',
                    '2-digit'
                ][len - 1];
                break;
            case 'S':
            case 'A':
                throw new RangeError('`S/A` (second) patterns are not supported, use `s` instead');
            // Zone
            case 'z':
                result.timeZoneName = len < 4 ? 'short' : 'long';
                break;
            case 'Z':
            case 'O':
            case 'v':
            case 'V':
            case 'X':
            case 'x':
                throw new RangeError('`Z/O/v/V/X/x` (timeZone) patterns are not supported, use `z` instead');
        }
        return '';
    });
    return result;
}

},{"@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"hdU52":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "parseNumberSkeletonFromString", ()=>parseNumberSkeletonFromString);
/**
 * https://github.com/unicode-org/icu/blob/master/docs/userguide/format_parse/numbers/skeletons.md#skeleton-stems-and-options
 */ parcelHelpers.export(exports, "parseNumberSkeleton", ()=>parseNumberSkeleton);
var _tslib = require("tslib");
var _regexGenerated = require("./regex.generated");
function parseNumberSkeletonFromString(skeleton) {
    if (skeleton.length === 0) throw new Error('Number skeleton cannot be empty');
    // Parse the skeleton
    var stringTokens = skeleton.split((0, _regexGenerated.WHITE_SPACE_REGEX)).filter(function(x) {
        return x.length > 0;
    });
    var tokens = [];
    for(var _i = 0, stringTokens_1 = stringTokens; _i < stringTokens_1.length; _i++){
        var stringToken = stringTokens_1[_i];
        var stemAndOptions = stringToken.split('/');
        if (stemAndOptions.length === 0) throw new Error('Invalid number skeleton');
        var stem = stemAndOptions[0], options = stemAndOptions.slice(1);
        for(var _a = 0, options_1 = options; _a < options_1.length; _a++){
            var option = options_1[_a];
            if (option.length === 0) throw new Error('Invalid number skeleton');
        }
        tokens.push({
            stem: stem,
            options: options
        });
    }
    return tokens;
}
function icuUnitToEcma(unit) {
    return unit.replace(/^(.*?)-/, '');
}
var FRACTION_PRECISION_REGEX = /^\.(?:(0+)(\*)?|(#+)|(0+)(#+))$/g;
var SIGNIFICANT_PRECISION_REGEX = /^(@+)?(\+|#+)?[rs]?$/g;
var INTEGER_WIDTH_REGEX = /(\*)(0+)|(#+)(0+)|(0+)/g;
var CONCISE_INTEGER_WIDTH_REGEX = /^(0+)$/;
function parseSignificantPrecision(str) {
    var result = {};
    if (str[str.length - 1] === 'r') result.roundingPriority = 'morePrecision';
    else if (str[str.length - 1] === 's') result.roundingPriority = 'lessPrecision';
    str.replace(SIGNIFICANT_PRECISION_REGEX, function(_, g1, g2) {
        // @@@ case
        if (typeof g2 !== 'string') {
            result.minimumSignificantDigits = g1.length;
            result.maximumSignificantDigits = g1.length;
        } else if (g2 === '+') result.minimumSignificantDigits = g1.length;
        else if (g1[0] === '#') result.maximumSignificantDigits = g1.length;
        else {
            result.minimumSignificantDigits = g1.length;
            result.maximumSignificantDigits = g1.length + (typeof g2 === 'string' ? g2.length : 0);
        }
        return '';
    });
    return result;
}
function parseSign(str) {
    switch(str){
        case 'sign-auto':
            return {
                signDisplay: 'auto'
            };
        case 'sign-accounting':
        case '()':
            return {
                currencySign: 'accounting'
            };
        case 'sign-always':
        case '+!':
            return {
                signDisplay: 'always'
            };
        case 'sign-accounting-always':
        case '()!':
            return {
                signDisplay: 'always',
                currencySign: 'accounting'
            };
        case 'sign-except-zero':
        case '+?':
            return {
                signDisplay: 'exceptZero'
            };
        case 'sign-accounting-except-zero':
        case '()?':
            return {
                signDisplay: 'exceptZero',
                currencySign: 'accounting'
            };
        case 'sign-never':
        case '+_':
            return {
                signDisplay: 'never'
            };
    }
}
function parseConciseScientificAndEngineeringStem(stem) {
    // Engineering
    var result;
    if (stem[0] === 'E' && stem[1] === 'E') {
        result = {
            notation: 'engineering'
        };
        stem = stem.slice(2);
    } else if (stem[0] === 'E') {
        result = {
            notation: 'scientific'
        };
        stem = stem.slice(1);
    }
    if (result) {
        var signDisplay = stem.slice(0, 2);
        if (signDisplay === '+!') {
            result.signDisplay = 'always';
            stem = stem.slice(2);
        } else if (signDisplay === '+?') {
            result.signDisplay = 'exceptZero';
            stem = stem.slice(2);
        }
        if (!CONCISE_INTEGER_WIDTH_REGEX.test(stem)) throw new Error('Malformed concise eng/scientific notation');
        result.minimumIntegerDigits = stem.length;
    }
    return result;
}
function parseNotationOptions(opt) {
    var result = {};
    var signOpts = parseSign(opt);
    if (signOpts) return signOpts;
    return result;
}
function parseNumberSkeleton(tokens) {
    var result = {};
    for(var _i = 0, tokens_1 = tokens; _i < tokens_1.length; _i++){
        var token = tokens_1[_i];
        switch(token.stem){
            case 'percent':
            case '%':
                result.style = 'percent';
                continue;
            case '%x100':
                result.style = 'percent';
                result.scale = 100;
                continue;
            case 'currency':
                result.style = 'currency';
                result.currency = token.options[0];
                continue;
            case 'group-off':
            case ',_':
                result.useGrouping = false;
                continue;
            case 'precision-integer':
            case '.':
                result.maximumFractionDigits = 0;
                continue;
            case 'measure-unit':
            case 'unit':
                result.style = 'unit';
                result.unit = icuUnitToEcma(token.options[0]);
                continue;
            case 'compact-short':
            case 'K':
                result.notation = 'compact';
                result.compactDisplay = 'short';
                continue;
            case 'compact-long':
            case 'KK':
                result.notation = 'compact';
                result.compactDisplay = 'long';
                continue;
            case 'scientific':
                result = (0, _tslib.__assign)((0, _tslib.__assign)((0, _tslib.__assign)({}, result), {
                    notation: 'scientific'
                }), token.options.reduce(function(all, opt) {
                    return (0, _tslib.__assign)((0, _tslib.__assign)({}, all), parseNotationOptions(opt));
                }, {}));
                continue;
            case 'engineering':
                result = (0, _tslib.__assign)((0, _tslib.__assign)((0, _tslib.__assign)({}, result), {
                    notation: 'engineering'
                }), token.options.reduce(function(all, opt) {
                    return (0, _tslib.__assign)((0, _tslib.__assign)({}, all), parseNotationOptions(opt));
                }, {}));
                continue;
            case 'notation-simple':
                result.notation = 'standard';
                continue;
            // https://github.com/unicode-org/icu/blob/master/icu4c/source/i18n/unicode/unumberformatter.h
            case 'unit-width-narrow':
                result.currencyDisplay = 'narrowSymbol';
                result.unitDisplay = 'narrow';
                continue;
            case 'unit-width-short':
                result.currencyDisplay = 'code';
                result.unitDisplay = 'short';
                continue;
            case 'unit-width-full-name':
                result.currencyDisplay = 'name';
                result.unitDisplay = 'long';
                continue;
            case 'unit-width-iso-code':
                result.currencyDisplay = 'symbol';
                continue;
            case 'scale':
                result.scale = parseFloat(token.options[0]);
                continue;
            case 'rounding-mode-floor':
                result.roundingMode = 'floor';
                continue;
            case 'rounding-mode-ceiling':
                result.roundingMode = 'ceil';
                continue;
            case 'rounding-mode-down':
                result.roundingMode = 'trunc';
                continue;
            case 'rounding-mode-up':
                result.roundingMode = 'expand';
                continue;
            case 'rounding-mode-half-even':
                result.roundingMode = 'halfEven';
                continue;
            case 'rounding-mode-half-down':
                result.roundingMode = 'halfTrunc';
                continue;
            case 'rounding-mode-half-up':
                result.roundingMode = 'halfExpand';
                continue;
            // https://unicode-org.github.io/icu/userguide/format_parse/numbers/skeletons.html#integer-width
            case 'integer-width':
                if (token.options.length > 1) throw new RangeError('integer-width stems only accept a single optional option');
                token.options[0].replace(INTEGER_WIDTH_REGEX, function(_, g1, g2, g3, g4, g5) {
                    if (g1) result.minimumIntegerDigits = g2.length;
                    else if (g3 && g4) throw new Error('We currently do not support maximum integer digits');
                    else if (g5) throw new Error('We currently do not support exact integer digits');
                    return '';
                });
                continue;
        }
        // https://unicode-org.github.io/icu/userguide/format_parse/numbers/skeletons.html#integer-width
        if (CONCISE_INTEGER_WIDTH_REGEX.test(token.stem)) {
            result.minimumIntegerDigits = token.stem.length;
            continue;
        }
        if (FRACTION_PRECISION_REGEX.test(token.stem)) {
            // Precision
            // https://unicode-org.github.io/icu/userguide/format_parse/numbers/skeletons.html#fraction-precision
            // precision-integer case
            if (token.options.length > 1) throw new RangeError('Fraction-precision stems only accept a single optional option');
            token.stem.replace(FRACTION_PRECISION_REGEX, function(_, g1, g2, g3, g4, g5) {
                // .000* case (before ICU67 it was .000+)
                if (g2 === '*') result.minimumFractionDigits = g1.length;
                else if (g3 && g3[0] === '#') result.maximumFractionDigits = g3.length;
                else if (g4 && g5) {
                    result.minimumFractionDigits = g4.length;
                    result.maximumFractionDigits = g4.length + g5.length;
                } else {
                    result.minimumFractionDigits = g1.length;
                    result.maximumFractionDigits = g1.length;
                }
                return '';
            });
            var opt = token.options[0];
            // https://unicode-org.github.io/icu/userguide/format_parse/numbers/skeletons.html#trailing-zero-display
            if (opt === 'w') result = (0, _tslib.__assign)((0, _tslib.__assign)({}, result), {
                trailingZeroDisplay: 'stripIfInteger'
            });
            else if (opt) result = (0, _tslib.__assign)((0, _tslib.__assign)({}, result), parseSignificantPrecision(opt));
            continue;
        }
        // https://unicode-org.github.io/icu/userguide/format_parse/numbers/skeletons.html#significant-digits-precision
        if (SIGNIFICANT_PRECISION_REGEX.test(token.stem)) {
            result = (0, _tslib.__assign)((0, _tslib.__assign)({}, result), parseSignificantPrecision(token.stem));
            continue;
        }
        var signOpts = parseSign(token.stem);
        if (signOpts) result = (0, _tslib.__assign)((0, _tslib.__assign)({}, result), signOpts);
        var conciseScientificAndEngineeringOpts = parseConciseScientificAndEngineeringStem(token.stem);
        if (conciseScientificAndEngineeringOpts) result = (0, _tslib.__assign)((0, _tslib.__assign)({}, result), conciseScientificAndEngineeringOpts);
    }
    return result;
}

},{"tslib":"6MhhU","./regex.generated":"abpOr","@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"abpOr":[function(require,module,exports,__globalThis) {
// @generated from regex-gen.ts
var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "WHITE_SPACE_REGEX", ()=>WHITE_SPACE_REGEX);
var WHITE_SPACE_REGEX = /[\t-\r \x85\u200E\u200F\u2028\u2029]/i;

},{"@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"cdVKe":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
/**
 * Returns the best matching date time pattern if a date time skeleton
 * pattern is provided with a locale. Follows the Unicode specification:
 * https://www.unicode.org/reports/tr35/tr35-dates.html#table-mapping-requested-time-skeletons-to-patterns
 * @param skeleton date time skeleton pattern that possibly includes j, J or C
 * @param locale
 */ parcelHelpers.export(exports, "getBestPattern", ()=>getBestPattern);
var _timeDataGenerated = require("./time-data.generated");
function getBestPattern(skeleton, locale) {
    var skeletonCopy = '';
    for(var patternPos = 0; patternPos < skeleton.length; patternPos++){
        var patternChar = skeleton.charAt(patternPos);
        if (patternChar === 'j') {
            var extraLength = 0;
            while(patternPos + 1 < skeleton.length && skeleton.charAt(patternPos + 1) === patternChar){
                extraLength++;
                patternPos++;
            }
            var hourLen = 1 + (extraLength & 1);
            var dayPeriodLen = extraLength < 2 ? 1 : 3 + (extraLength >> 1);
            var dayPeriodChar = 'a';
            var hourChar = getDefaultHourSymbolFromLocale(locale);
            if (hourChar == 'H' || hourChar == 'k') dayPeriodLen = 0;
            while(dayPeriodLen-- > 0)skeletonCopy += dayPeriodChar;
            while(hourLen-- > 0)skeletonCopy = hourChar + skeletonCopy;
        } else if (patternChar === 'J') skeletonCopy += 'H';
        else skeletonCopy += patternChar;
    }
    return skeletonCopy;
}
/**
 * Maps the [hour cycle type](https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Intl/Locale/hourCycle)
 * of the given `locale` to the corresponding time pattern.
 * @param locale
 */ function getDefaultHourSymbolFromLocale(locale) {
    var hourCycle = locale.hourCycle;
    if (hourCycle === undefined && // @ts-ignore hourCycle(s) is not identified yet
    locale.hourCycles && // @ts-ignore
    locale.hourCycles.length) // @ts-ignore
    hourCycle = locale.hourCycles[0];
    if (hourCycle) switch(hourCycle){
        case 'h24':
            return 'k';
        case 'h23':
            return 'H';
        case 'h12':
            return 'h';
        case 'h11':
            return 'K';
        default:
            throw new Error('Invalid hourCycle');
    }
    // TODO: Once hourCycle is fully supported remove the following with data generation
    var languageTag = locale.language;
    var regionTag;
    if (languageTag !== 'root') regionTag = locale.maximize().region;
    var hourCycles = (0, _timeDataGenerated.timeData)[regionTag || ''] || (0, _timeDataGenerated.timeData)[languageTag || ''] || (0, _timeDataGenerated.timeData)["".concat(languageTag, "-001")] || (0, _timeDataGenerated.timeData)['001'];
    return hourCycles[0];
}

},{"./time-data.generated":"kDXFs","@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"kDXFs":[function(require,module,exports,__globalThis) {
// @generated from time-data-gen.ts
// prettier-ignore  
var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "timeData", ()=>timeData);
var timeData = {
    "001": [
        "H",
        "h"
    ],
    "419": [
        "h",
        "H",
        "hB",
        "hb"
    ],
    "AC": [
        "H",
        "h",
        "hb",
        "hB"
    ],
    "AD": [
        "H",
        "hB"
    ],
    "AE": [
        "h",
        "hB",
        "hb",
        "H"
    ],
    "AF": [
        "H",
        "hb",
        "hB",
        "h"
    ],
    "AG": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "AI": [
        "H",
        "h",
        "hb",
        "hB"
    ],
    "AL": [
        "h",
        "H",
        "hB"
    ],
    "AM": [
        "H",
        "hB"
    ],
    "AO": [
        "H",
        "hB"
    ],
    "AR": [
        "h",
        "H",
        "hB",
        "hb"
    ],
    "AS": [
        "h",
        "H"
    ],
    "AT": [
        "H",
        "hB"
    ],
    "AU": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "AW": [
        "H",
        "hB"
    ],
    "AX": [
        "H"
    ],
    "AZ": [
        "H",
        "hB",
        "h"
    ],
    "BA": [
        "H",
        "hB",
        "h"
    ],
    "BB": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "BD": [
        "h",
        "hB",
        "H"
    ],
    "BE": [
        "H",
        "hB"
    ],
    "BF": [
        "H",
        "hB"
    ],
    "BG": [
        "H",
        "hB",
        "h"
    ],
    "BH": [
        "h",
        "hB",
        "hb",
        "H"
    ],
    "BI": [
        "H",
        "h"
    ],
    "BJ": [
        "H",
        "hB"
    ],
    "BL": [
        "H",
        "hB"
    ],
    "BM": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "BN": [
        "hb",
        "hB",
        "h",
        "H"
    ],
    "BO": [
        "h",
        "H",
        "hB",
        "hb"
    ],
    "BQ": [
        "H"
    ],
    "BR": [
        "H",
        "hB"
    ],
    "BS": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "BT": [
        "h",
        "H"
    ],
    "BW": [
        "H",
        "h",
        "hb",
        "hB"
    ],
    "BY": [
        "H",
        "h"
    ],
    "BZ": [
        "H",
        "h",
        "hb",
        "hB"
    ],
    "CA": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "CC": [
        "H",
        "h",
        "hb",
        "hB"
    ],
    "CD": [
        "hB",
        "H"
    ],
    "CF": [
        "H",
        "h",
        "hB"
    ],
    "CG": [
        "H",
        "hB"
    ],
    "CH": [
        "H",
        "hB",
        "h"
    ],
    "CI": [
        "H",
        "hB"
    ],
    "CK": [
        "H",
        "h",
        "hb",
        "hB"
    ],
    "CL": [
        "h",
        "H",
        "hB",
        "hb"
    ],
    "CM": [
        "H",
        "h",
        "hB"
    ],
    "CN": [
        "H",
        "hB",
        "hb",
        "h"
    ],
    "CO": [
        "h",
        "H",
        "hB",
        "hb"
    ],
    "CP": [
        "H"
    ],
    "CR": [
        "h",
        "H",
        "hB",
        "hb"
    ],
    "CU": [
        "h",
        "H",
        "hB",
        "hb"
    ],
    "CV": [
        "H",
        "hB"
    ],
    "CW": [
        "H",
        "hB"
    ],
    "CX": [
        "H",
        "h",
        "hb",
        "hB"
    ],
    "CY": [
        "h",
        "H",
        "hb",
        "hB"
    ],
    "CZ": [
        "H"
    ],
    "DE": [
        "H",
        "hB"
    ],
    "DG": [
        "H",
        "h",
        "hb",
        "hB"
    ],
    "DJ": [
        "h",
        "H"
    ],
    "DK": [
        "H"
    ],
    "DM": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "DO": [
        "h",
        "H",
        "hB",
        "hb"
    ],
    "DZ": [
        "h",
        "hB",
        "hb",
        "H"
    ],
    "EA": [
        "H",
        "h",
        "hB",
        "hb"
    ],
    "EC": [
        "h",
        "H",
        "hB",
        "hb"
    ],
    "EE": [
        "H",
        "hB"
    ],
    "EG": [
        "h",
        "hB",
        "hb",
        "H"
    ],
    "EH": [
        "h",
        "hB",
        "hb",
        "H"
    ],
    "ER": [
        "h",
        "H"
    ],
    "ES": [
        "H",
        "hB",
        "h",
        "hb"
    ],
    "ET": [
        "hB",
        "hb",
        "h",
        "H"
    ],
    "FI": [
        "H"
    ],
    "FJ": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "FK": [
        "H",
        "h",
        "hb",
        "hB"
    ],
    "FM": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "FO": [
        "H",
        "h"
    ],
    "FR": [
        "H",
        "hB"
    ],
    "GA": [
        "H",
        "hB"
    ],
    "GB": [
        "H",
        "h",
        "hb",
        "hB"
    ],
    "GD": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "GE": [
        "H",
        "hB",
        "h"
    ],
    "GF": [
        "H",
        "hB"
    ],
    "GG": [
        "H",
        "h",
        "hb",
        "hB"
    ],
    "GH": [
        "h",
        "H"
    ],
    "GI": [
        "H",
        "h",
        "hb",
        "hB"
    ],
    "GL": [
        "H",
        "h"
    ],
    "GM": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "GN": [
        "H",
        "hB"
    ],
    "GP": [
        "H",
        "hB"
    ],
    "GQ": [
        "H",
        "hB",
        "h",
        "hb"
    ],
    "GR": [
        "h",
        "H",
        "hb",
        "hB"
    ],
    "GT": [
        "h",
        "H",
        "hB",
        "hb"
    ],
    "GU": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "GW": [
        "H",
        "hB"
    ],
    "GY": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "HK": [
        "h",
        "hB",
        "hb",
        "H"
    ],
    "HN": [
        "h",
        "H",
        "hB",
        "hb"
    ],
    "HR": [
        "H",
        "hB"
    ],
    "HU": [
        "H",
        "h"
    ],
    "IC": [
        "H",
        "h",
        "hB",
        "hb"
    ],
    "ID": [
        "H"
    ],
    "IE": [
        "H",
        "h",
        "hb",
        "hB"
    ],
    "IL": [
        "H",
        "hB"
    ],
    "IM": [
        "H",
        "h",
        "hb",
        "hB"
    ],
    "IN": [
        "h",
        "H"
    ],
    "IO": [
        "H",
        "h",
        "hb",
        "hB"
    ],
    "IQ": [
        "h",
        "hB",
        "hb",
        "H"
    ],
    "IR": [
        "hB",
        "H"
    ],
    "IS": [
        "H"
    ],
    "IT": [
        "H",
        "hB"
    ],
    "JE": [
        "H",
        "h",
        "hb",
        "hB"
    ],
    "JM": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "JO": [
        "h",
        "hB",
        "hb",
        "H"
    ],
    "JP": [
        "H",
        "K",
        "h"
    ],
    "KE": [
        "hB",
        "hb",
        "H",
        "h"
    ],
    "KG": [
        "H",
        "h",
        "hB",
        "hb"
    ],
    "KH": [
        "hB",
        "h",
        "H",
        "hb"
    ],
    "KI": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "KM": [
        "H",
        "h",
        "hB",
        "hb"
    ],
    "KN": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "KP": [
        "h",
        "H",
        "hB",
        "hb"
    ],
    "KR": [
        "h",
        "H",
        "hB",
        "hb"
    ],
    "KW": [
        "h",
        "hB",
        "hb",
        "H"
    ],
    "KY": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "KZ": [
        "H",
        "hB"
    ],
    "LA": [
        "H",
        "hb",
        "hB",
        "h"
    ],
    "LB": [
        "h",
        "hB",
        "hb",
        "H"
    ],
    "LC": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "LI": [
        "H",
        "hB",
        "h"
    ],
    "LK": [
        "H",
        "h",
        "hB",
        "hb"
    ],
    "LR": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "LS": [
        "h",
        "H"
    ],
    "LT": [
        "H",
        "h",
        "hb",
        "hB"
    ],
    "LU": [
        "H",
        "h",
        "hB"
    ],
    "LV": [
        "H",
        "hB",
        "hb",
        "h"
    ],
    "LY": [
        "h",
        "hB",
        "hb",
        "H"
    ],
    "MA": [
        "H",
        "h",
        "hB",
        "hb"
    ],
    "MC": [
        "H",
        "hB"
    ],
    "MD": [
        "H",
        "hB"
    ],
    "ME": [
        "H",
        "hB",
        "h"
    ],
    "MF": [
        "H",
        "hB"
    ],
    "MG": [
        "H",
        "h"
    ],
    "MH": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "MK": [
        "H",
        "h",
        "hb",
        "hB"
    ],
    "ML": [
        "H"
    ],
    "MM": [
        "hB",
        "hb",
        "H",
        "h"
    ],
    "MN": [
        "H",
        "h",
        "hb",
        "hB"
    ],
    "MO": [
        "h",
        "hB",
        "hb",
        "H"
    ],
    "MP": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "MQ": [
        "H",
        "hB"
    ],
    "MR": [
        "h",
        "hB",
        "hb",
        "H"
    ],
    "MS": [
        "H",
        "h",
        "hb",
        "hB"
    ],
    "MT": [
        "H",
        "h"
    ],
    "MU": [
        "H",
        "h"
    ],
    "MV": [
        "H",
        "h"
    ],
    "MW": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "MX": [
        "h",
        "H",
        "hB",
        "hb"
    ],
    "MY": [
        "hb",
        "hB",
        "h",
        "H"
    ],
    "MZ": [
        "H",
        "hB"
    ],
    "NA": [
        "h",
        "H",
        "hB",
        "hb"
    ],
    "NC": [
        "H",
        "hB"
    ],
    "NE": [
        "H"
    ],
    "NF": [
        "H",
        "h",
        "hb",
        "hB"
    ],
    "NG": [
        "H",
        "h",
        "hb",
        "hB"
    ],
    "NI": [
        "h",
        "H",
        "hB",
        "hb"
    ],
    "NL": [
        "H",
        "hB"
    ],
    "NO": [
        "H",
        "h"
    ],
    "NP": [
        "H",
        "h",
        "hB"
    ],
    "NR": [
        "H",
        "h",
        "hb",
        "hB"
    ],
    "NU": [
        "H",
        "h",
        "hb",
        "hB"
    ],
    "NZ": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "OM": [
        "h",
        "hB",
        "hb",
        "H"
    ],
    "PA": [
        "h",
        "H",
        "hB",
        "hb"
    ],
    "PE": [
        "h",
        "H",
        "hB",
        "hb"
    ],
    "PF": [
        "H",
        "h",
        "hB"
    ],
    "PG": [
        "h",
        "H"
    ],
    "PH": [
        "h",
        "hB",
        "hb",
        "H"
    ],
    "PK": [
        "h",
        "hB",
        "H"
    ],
    "PL": [
        "H",
        "h"
    ],
    "PM": [
        "H",
        "hB"
    ],
    "PN": [
        "H",
        "h",
        "hb",
        "hB"
    ],
    "PR": [
        "h",
        "H",
        "hB",
        "hb"
    ],
    "PS": [
        "h",
        "hB",
        "hb",
        "H"
    ],
    "PT": [
        "H",
        "hB"
    ],
    "PW": [
        "h",
        "H"
    ],
    "PY": [
        "h",
        "H",
        "hB",
        "hb"
    ],
    "QA": [
        "h",
        "hB",
        "hb",
        "H"
    ],
    "RE": [
        "H",
        "hB"
    ],
    "RO": [
        "H",
        "hB"
    ],
    "RS": [
        "H",
        "hB",
        "h"
    ],
    "RU": [
        "H"
    ],
    "RW": [
        "H",
        "h"
    ],
    "SA": [
        "h",
        "hB",
        "hb",
        "H"
    ],
    "SB": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "SC": [
        "H",
        "h",
        "hB"
    ],
    "SD": [
        "h",
        "hB",
        "hb",
        "H"
    ],
    "SE": [
        "H"
    ],
    "SG": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "SH": [
        "H",
        "h",
        "hb",
        "hB"
    ],
    "SI": [
        "H",
        "hB"
    ],
    "SJ": [
        "H"
    ],
    "SK": [
        "H"
    ],
    "SL": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "SM": [
        "H",
        "h",
        "hB"
    ],
    "SN": [
        "H",
        "h",
        "hB"
    ],
    "SO": [
        "h",
        "H"
    ],
    "SR": [
        "H",
        "hB"
    ],
    "SS": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "ST": [
        "H",
        "hB"
    ],
    "SV": [
        "h",
        "H",
        "hB",
        "hb"
    ],
    "SX": [
        "H",
        "h",
        "hb",
        "hB"
    ],
    "SY": [
        "h",
        "hB",
        "hb",
        "H"
    ],
    "SZ": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "TA": [
        "H",
        "h",
        "hb",
        "hB"
    ],
    "TC": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "TD": [
        "h",
        "H",
        "hB"
    ],
    "TF": [
        "H",
        "h",
        "hB"
    ],
    "TG": [
        "H",
        "hB"
    ],
    "TH": [
        "H",
        "h"
    ],
    "TJ": [
        "H",
        "h"
    ],
    "TL": [
        "H",
        "hB",
        "hb",
        "h"
    ],
    "TM": [
        "H",
        "h"
    ],
    "TN": [
        "h",
        "hB",
        "hb",
        "H"
    ],
    "TO": [
        "h",
        "H"
    ],
    "TR": [
        "H",
        "hB"
    ],
    "TT": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "TW": [
        "hB",
        "hb",
        "h",
        "H"
    ],
    "TZ": [
        "hB",
        "hb",
        "H",
        "h"
    ],
    "UA": [
        "H",
        "hB",
        "h"
    ],
    "UG": [
        "hB",
        "hb",
        "H",
        "h"
    ],
    "UM": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "US": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "UY": [
        "h",
        "H",
        "hB",
        "hb"
    ],
    "UZ": [
        "H",
        "hB",
        "h"
    ],
    "VA": [
        "H",
        "h",
        "hB"
    ],
    "VC": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "VE": [
        "h",
        "H",
        "hB",
        "hb"
    ],
    "VG": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "VI": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "VN": [
        "H",
        "h"
    ],
    "VU": [
        "h",
        "H"
    ],
    "WF": [
        "H",
        "hB"
    ],
    "WS": [
        "h",
        "H"
    ],
    "XK": [
        "H",
        "hB",
        "h"
    ],
    "YE": [
        "h",
        "hB",
        "hb",
        "H"
    ],
    "YT": [
        "H",
        "hB"
    ],
    "ZA": [
        "H",
        "h",
        "hb",
        "hB"
    ],
    "ZM": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "ZW": [
        "H",
        "h"
    ],
    "af-ZA": [
        "H",
        "h",
        "hB",
        "hb"
    ],
    "ar-001": [
        "h",
        "hB",
        "hb",
        "H"
    ],
    "ca-ES": [
        "H",
        "h",
        "hB"
    ],
    "en-001": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "en-HK": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "en-IL": [
        "H",
        "h",
        "hb",
        "hB"
    ],
    "en-MY": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "es-BR": [
        "H",
        "h",
        "hB",
        "hb"
    ],
    "es-ES": [
        "H",
        "h",
        "hB",
        "hb"
    ],
    "es-GQ": [
        "H",
        "h",
        "hB",
        "hb"
    ],
    "fr-CA": [
        "H",
        "h",
        "hB"
    ],
    "gl-ES": [
        "H",
        "h",
        "hB"
    ],
    "gu-IN": [
        "hB",
        "hb",
        "h",
        "H"
    ],
    "hi-IN": [
        "hB",
        "h",
        "H"
    ],
    "it-CH": [
        "H",
        "h",
        "hB"
    ],
    "it-IT": [
        "H",
        "h",
        "hB"
    ],
    "kn-IN": [
        "hB",
        "h",
        "H"
    ],
    "ml-IN": [
        "hB",
        "h",
        "H"
    ],
    "mr-IN": [
        "hB",
        "hb",
        "h",
        "H"
    ],
    "pa-IN": [
        "hB",
        "hb",
        "h",
        "H"
    ],
    "ta-IN": [
        "hB",
        "h",
        "hb",
        "H"
    ],
    "te-IN": [
        "hB",
        "h",
        "H"
    ],
    "zu-ZA": [
        "H",
        "hB",
        "hb",
        "h"
    ]
};

},{"@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"bzfOU":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
/**
 * Hoist all selectors to the beginning of the AST & flatten the
 * resulting options. E.g:
 * "I have {count, plural, one{a dog} other{many dogs}}"
 * becomes "{count, plural, one{I have a dog} other{I have many dogs}}".
 * If there are multiple selectors, the order of which one is hoisted 1st
 * is non-deterministic.
 * The goal is to provide as many full sentences as possible since fragmented
 * sentences are not translator-friendly
 * @param ast AST
 */ parcelHelpers.export(exports, "hoistSelectors", ()=>hoistSelectors);
/**
 * Check if 2 ASTs are structurally the same. This primarily means that
 * they have the same variables with the same type
 * @param a
 * @param b
 * @returns
 */ parcelHelpers.export(exports, "isStructurallySame", ()=>isStructurallySame);
var _tslib = require("tslib");
var _types = require("./types");
function cloneDeep(obj) {
    if (Array.isArray(obj)) // @ts-expect-error meh
    return (0, _tslib.__spreadArray)([], obj.map(cloneDeep), true);
    if (obj !== null && typeof obj === 'object') // @ts-expect-error meh
    return Object.keys(obj).reduce(function(cloned, k) {
        // @ts-expect-error meh
        cloned[k] = cloneDeep(obj[k]);
        return cloned;
    }, {});
    return obj;
}
function hoistPluralOrSelectElement(ast, el, positionToInject) {
    // pull this out of the ast and move it to the top
    var cloned = cloneDeep(el);
    var options = cloned.options;
    cloned.options = Object.keys(options).reduce(function(all, k) {
        var newValue = hoistSelectors((0, _tslib.__spreadArray)((0, _tslib.__spreadArray)((0, _tslib.__spreadArray)([], ast.slice(0, positionToInject), true), options[k].value, true), ast.slice(positionToInject + 1), true));
        all[k] = {
            value: newValue
        };
        return all;
    }, {});
    return cloned;
}
function isPluralOrSelectElement(el) {
    return (0, _types.isPluralElement)(el) || (0, _types.isSelectElement)(el);
}
function findPluralOrSelectElement(ast) {
    return !!ast.find(function(el) {
        if (isPluralOrSelectElement(el)) return true;
        if ((0, _types.isTagElement)(el)) return findPluralOrSelectElement(el.children);
        return false;
    });
}
function hoistSelectors(ast) {
    for(var i = 0; i < ast.length; i++){
        var el = ast[i];
        if (isPluralOrSelectElement(el)) return [
            hoistPluralOrSelectElement(ast, el, i)
        ];
        if ((0, _types.isTagElement)(el) && findPluralOrSelectElement([
            el
        ])) throw new Error('Cannot hoist plural/select within a tag element. Please put the tag element inside each plural/select option');
    }
    return ast;
}
/**
 * Collect all variables in an AST to Record<string, TYPE>
 * @param ast AST to collect variables from
 * @param vars Record of variable name to variable type
 */ function collectVariables(ast, vars) {
    if (vars === void 0) vars = new Map();
    ast.forEach(function(el) {
        if ((0, _types.isArgumentElement)(el) || (0, _types.isDateElement)(el) || (0, _types.isTimeElement)(el) || (0, _types.isNumberElement)(el)) {
            if (el.value in vars && vars.get(el.value) !== el.type) throw new Error("Variable ".concat(el.value, " has conflicting types"));
            vars.set(el.value, el.type);
        }
        if ((0, _types.isPluralElement)(el) || (0, _types.isSelectElement)(el)) {
            vars.set(el.value, el.type);
            Object.keys(el.options).forEach(function(k) {
                collectVariables(el.options[k].value, vars);
            });
        }
        if ((0, _types.isTagElement)(el)) {
            vars.set(el.value, el.type);
            collectVariables(el.children, vars);
        }
    });
}
function isStructurallySame(a, b) {
    var aVars = new Map();
    var bVars = new Map();
    collectVariables(a, aVars);
    collectVariables(b, bVars);
    if (aVars.size !== bVars.size) return {
        success: false,
        error: new Error("Different number of variables: [".concat(Array.from(aVars.keys()).join(', '), "] vs [").concat(Array.from(bVars.keys()).join(', '), "]"))
    };
    return Array.from(aVars.entries()).reduce(function(result, _a) {
        var key = _a[0], type = _a[1];
        if (!result.success) return result;
        var bType = bVars.get(key);
        if (bType == null) return {
            success: false,
            error: new Error("Missing variable ".concat(key, " in message"))
        };
        if (bType !== type) return {
            success: false,
            error: new Error("Variable ".concat(key, " has conflicting types: ").concat((0, _types.TYPE)[type], " vs ").concat((0, _types.TYPE)[bType]))
        };
        return result;
    }, {
        success: true
    });
}

},{"tslib":"6MhhU","./types":"2FWjX","@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"l38Sx":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "PART_TYPE", ()=>PART_TYPE);
parcelHelpers.export(exports, "isFormatXMLElementFn", ()=>isFormatXMLElementFn);
// TODO(skeleton): add skeleton support
parcelHelpers.export(exports, "formatToParts", ()=>formatToParts);
var _icuMessageformatParser = require("@formatjs/icu-messageformat-parser");
var _error = require("./error");
var PART_TYPE;
(function(PART_TYPE) {
    PART_TYPE[PART_TYPE["literal"] = 0] = "literal";
    PART_TYPE[PART_TYPE["object"] = 1] = "object";
})(PART_TYPE || (PART_TYPE = {}));
function mergeLiteral(parts) {
    if (parts.length < 2) return parts;
    return parts.reduce(function(all, part) {
        var lastPart = all[all.length - 1];
        if (!lastPart || lastPart.type !== PART_TYPE.literal || part.type !== PART_TYPE.literal) all.push(part);
        else lastPart.value += part.value;
        return all;
    }, []);
}
function isFormatXMLElementFn(el) {
    return typeof el === 'function';
}
function formatToParts(els, locales, formatters, formats, values, currentPluralValue, // For debugging
originalMessage) {
    // Hot path for straight simple msg translations
    if (els.length === 1 && (0, _icuMessageformatParser.isLiteralElement)(els[0])) return [
        {
            type: PART_TYPE.literal,
            value: els[0].value
        }
    ];
    var result = [];
    for(var _i = 0, els_1 = els; _i < els_1.length; _i++){
        var el = els_1[_i];
        // Exit early for string parts.
        if ((0, _icuMessageformatParser.isLiteralElement)(el)) {
            result.push({
                type: PART_TYPE.literal,
                value: el.value
            });
            continue;
        }
        // TODO: should this part be literal type?
        // Replace `#` in plural rules with the actual numeric value.
        if ((0, _icuMessageformatParser.isPoundElement)(el)) {
            if (typeof currentPluralValue === 'number') result.push({
                type: PART_TYPE.literal,
                value: formatters.getNumberFormat(locales).format(currentPluralValue)
            });
            continue;
        }
        var varName = el.value;
        // Enforce that all required values are provided by the caller.
        if (!(values && varName in values)) throw new (0, _error.MissingValueError)(varName, originalMessage);
        var value = values[varName];
        if ((0, _icuMessageformatParser.isArgumentElement)(el)) {
            if (!value || typeof value === 'string' || typeof value === 'number') value = typeof value === 'string' || typeof value === 'number' ? String(value) : '';
            result.push({
                type: typeof value === 'string' ? PART_TYPE.literal : PART_TYPE.object,
                value: value
            });
            continue;
        }
        // Recursively format plural and select parts' option — which can be a
        // nested pattern structure. The choosing of the option to use is
        // abstracted-by and delegated-to the part helper object.
        if ((0, _icuMessageformatParser.isDateElement)(el)) {
            var style = typeof el.style === 'string' ? formats.date[el.style] : (0, _icuMessageformatParser.isDateTimeSkeleton)(el.style) ? el.style.parsedOptions : undefined;
            result.push({
                type: PART_TYPE.literal,
                value: formatters.getDateTimeFormat(locales, style).format(value)
            });
            continue;
        }
        if ((0, _icuMessageformatParser.isTimeElement)(el)) {
            var style = typeof el.style === 'string' ? formats.time[el.style] : (0, _icuMessageformatParser.isDateTimeSkeleton)(el.style) ? el.style.parsedOptions : formats.time.medium;
            result.push({
                type: PART_TYPE.literal,
                value: formatters.getDateTimeFormat(locales, style).format(value)
            });
            continue;
        }
        if ((0, _icuMessageformatParser.isNumberElement)(el)) {
            var style = typeof el.style === 'string' ? formats.number[el.style] : (0, _icuMessageformatParser.isNumberSkeleton)(el.style) ? el.style.parsedOptions : undefined;
            if (style && style.scale) value = value * (style.scale || 1);
            result.push({
                type: PART_TYPE.literal,
                value: formatters.getNumberFormat(locales, style).format(value)
            });
            continue;
        }
        if ((0, _icuMessageformatParser.isTagElement)(el)) {
            var children = el.children, value_1 = el.value;
            var formatFn = values[value_1];
            if (!isFormatXMLElementFn(formatFn)) throw new (0, _error.InvalidValueTypeError)(value_1, 'function', originalMessage);
            var parts = formatToParts(children, locales, formatters, formats, values, currentPluralValue);
            var chunks = formatFn(parts.map(function(p) {
                return p.value;
            }));
            if (!Array.isArray(chunks)) chunks = [
                chunks
            ];
            result.push.apply(result, chunks.map(function(c) {
                return {
                    type: typeof c === 'string' ? PART_TYPE.literal : PART_TYPE.object,
                    value: c
                };
            }));
        }
        if ((0, _icuMessageformatParser.isSelectElement)(el)) {
            var opt = el.options[value] || el.options.other;
            if (!opt) throw new (0, _error.InvalidValueError)(el.value, value, Object.keys(el.options), originalMessage);
            result.push.apply(result, formatToParts(opt.value, locales, formatters, formats, values));
            continue;
        }
        if ((0, _icuMessageformatParser.isPluralElement)(el)) {
            var opt = el.options["=".concat(value)];
            if (!opt) {
                if (!Intl.PluralRules) throw new (0, _error.FormatError)("Intl.PluralRules is not available in this environment.\nTry polyfilling it using \"@formatjs/intl-pluralrules\"\n", (0, _error.ErrorCode).MISSING_INTL_API, originalMessage);
                var rule = formatters.getPluralRules(locales, {
                    type: el.pluralType
                }).select(value - (el.offset || 0));
                opt = el.options[rule] || el.options.other;
            }
            if (!opt) throw new (0, _error.InvalidValueError)(el.value, value, Object.keys(el.options), originalMessage);
            result.push.apply(result, formatToParts(opt.value, locales, formatters, formats, values, value - (el.offset || 0)));
            continue;
        }
    }
    return mergeLiteral(result);
}

},{"@formatjs/icu-messageformat-parser":"gNrtO","./error":"hodAk","@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"hodAk":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "ErrorCode", ()=>ErrorCode);
parcelHelpers.export(exports, "FormatError", ()=>FormatError);
parcelHelpers.export(exports, "InvalidValueError", ()=>InvalidValueError);
parcelHelpers.export(exports, "InvalidValueTypeError", ()=>InvalidValueTypeError);
parcelHelpers.export(exports, "MissingValueError", ()=>MissingValueError);
var _tslib = require("tslib");
var ErrorCode;
(function(ErrorCode) {
    // When we have a placeholder but no value to format
    ErrorCode["MISSING_VALUE"] = "MISSING_VALUE";
    // When value supplied is invalid
    ErrorCode["INVALID_VALUE"] = "INVALID_VALUE";
    // When we need specific Intl API but it's not available
    ErrorCode["MISSING_INTL_API"] = "MISSING_INTL_API";
})(ErrorCode || (ErrorCode = {}));
var FormatError = /** @class */ function(_super) {
    (0, _tslib.__extends)(FormatError, _super);
    function FormatError(msg, code, originalMessage) {
        var _this = _super.call(this, msg) || this;
        _this.code = code;
        _this.originalMessage = originalMessage;
        return _this;
    }
    FormatError.prototype.toString = function() {
        return "[formatjs Error: ".concat(this.code, "] ").concat(this.message);
    };
    return FormatError;
}(Error);
var InvalidValueError = /** @class */ function(_super) {
    (0, _tslib.__extends)(InvalidValueError, _super);
    function InvalidValueError(variableId, value, options, originalMessage) {
        return _super.call(this, "Invalid values for \"".concat(variableId, "\": \"").concat(value, "\". Options are \"").concat(Object.keys(options).join('", "'), "\""), ErrorCode.INVALID_VALUE, originalMessage) || this;
    }
    return InvalidValueError;
}(FormatError);
var InvalidValueTypeError = /** @class */ function(_super) {
    (0, _tslib.__extends)(InvalidValueTypeError, _super);
    function InvalidValueTypeError(value, type, originalMessage) {
        return _super.call(this, "Value for \"".concat(value, "\" must be of type ").concat(type), ErrorCode.INVALID_VALUE, originalMessage) || this;
    }
    return InvalidValueTypeError;
}(FormatError);
var MissingValueError = /** @class */ function(_super) {
    (0, _tslib.__extends)(MissingValueError, _super);
    function MissingValueError(variableId, originalMessage) {
        return _super.call(this, "The intl string context variable \"".concat(variableId, "\" was not provided to the string \"").concat(originalMessage, "\""), ErrorCode.MISSING_VALUE, originalMessage) || this;
    }
    return MissingValueError;
}(FormatError);

},{"tslib":"6MhhU","@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"j1qwF":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "IntlErrorCode", ()=>IntlErrorCode);
parcelHelpers.export(exports, "IntlError", ()=>IntlError);
parcelHelpers.export(exports, "UnsupportedFormatterError", ()=>UnsupportedFormatterError);
parcelHelpers.export(exports, "InvalidConfigError", ()=>InvalidConfigError);
parcelHelpers.export(exports, "MissingDataError", ()=>MissingDataError);
parcelHelpers.export(exports, "IntlFormatError", ()=>IntlFormatError);
parcelHelpers.export(exports, "MessageFormatError", ()=>MessageFormatError);
parcelHelpers.export(exports, "MissingTranslationError", ()=>MissingTranslationError);
var _tslib = require("tslib");
var IntlErrorCode;
(function(IntlErrorCode) {
    IntlErrorCode["FORMAT_ERROR"] = "FORMAT_ERROR";
    IntlErrorCode["UNSUPPORTED_FORMATTER"] = "UNSUPPORTED_FORMATTER";
    IntlErrorCode["INVALID_CONFIG"] = "INVALID_CONFIG";
    IntlErrorCode["MISSING_DATA"] = "MISSING_DATA";
    IntlErrorCode["MISSING_TRANSLATION"] = "MISSING_TRANSLATION";
})(IntlErrorCode || (IntlErrorCode = {}));
var IntlError = /** @class */ function(_super) {
    (0, _tslib.__extends)(IntlError, _super);
    function IntlError(code, message, exception) {
        var _this = this;
        var err = exception ? exception instanceof Error ? exception : new Error(String(exception)) : undefined;
        _this = _super.call(this, "[@formatjs/intl Error ".concat(code, "] ").concat(message, "\n").concat(err ? "\n".concat(err.message, "\n").concat(err.stack) : '')) || this;
        _this.code = code;
        // @ts-ignore just so we don't need to declare dep on @types/node
        if (typeof Error.captureStackTrace === 'function') // @ts-ignore just so we don't need to declare dep on @types/node
        Error.captureStackTrace(_this, IntlError);
        return _this;
    }
    return IntlError;
}(Error);
var UnsupportedFormatterError = /** @class */ function(_super) {
    (0, _tslib.__extends)(UnsupportedFormatterError, _super);
    function UnsupportedFormatterError(message, exception) {
        return _super.call(this, IntlErrorCode.UNSUPPORTED_FORMATTER, message, exception) || this;
    }
    return UnsupportedFormatterError;
}(IntlError);
var InvalidConfigError = /** @class */ function(_super) {
    (0, _tslib.__extends)(InvalidConfigError, _super);
    function InvalidConfigError(message, exception) {
        return _super.call(this, IntlErrorCode.INVALID_CONFIG, message, exception) || this;
    }
    return InvalidConfigError;
}(IntlError);
var MissingDataError = /** @class */ function(_super) {
    (0, _tslib.__extends)(MissingDataError, _super);
    function MissingDataError(message, exception) {
        return _super.call(this, IntlErrorCode.MISSING_DATA, message, exception) || this;
    }
    return MissingDataError;
}(IntlError);
var IntlFormatError = /** @class */ function(_super) {
    (0, _tslib.__extends)(IntlFormatError, _super);
    function IntlFormatError(message, locale, exception) {
        var _this = _super.call(this, IntlErrorCode.FORMAT_ERROR, "".concat(message, "\nLocale: ").concat(locale, "\n"), exception) || this;
        _this.locale = locale;
        return _this;
    }
    return IntlFormatError;
}(IntlError);
var MessageFormatError = /** @class */ function(_super) {
    (0, _tslib.__extends)(MessageFormatError, _super);
    function MessageFormatError(message, locale, descriptor, exception) {
        var _this = _super.call(this, "".concat(message, "\nMessageID: ").concat(descriptor === null || descriptor === void 0 ? void 0 : descriptor.id, "\nDefault Message: ").concat(descriptor === null || descriptor === void 0 ? void 0 : descriptor.defaultMessage, "\nDescription: ").concat(descriptor === null || descriptor === void 0 ? void 0 : descriptor.description, "\n"), locale, exception) || this;
        _this.descriptor = descriptor;
        _this.locale = locale;
        return _this;
    }
    return MessageFormatError;
}(IntlFormatError);
var MissingTranslationError = /** @class */ function(_super) {
    (0, _tslib.__extends)(MissingTranslationError, _super);
    function MissingTranslationError(descriptor, locale) {
        var _this = _super.call(this, IntlErrorCode.MISSING_TRANSLATION, "Missing message: \"".concat(descriptor.id, "\" for locale \"").concat(locale, "\", using ").concat(descriptor.defaultMessage ? "default message (".concat(typeof descriptor.defaultMessage === 'string' ? descriptor.defaultMessage : descriptor.defaultMessage.map(function(e) {
            var _a;
            return (_a = e.value) !== null && _a !== void 0 ? _a : JSON.stringify(e);
        }).join(), ")") : 'id', " as fallback.")) || this;
        _this.descriptor = descriptor;
        return _this;
    }
    return MissingTranslationError;
}(IntlError);

},{"tslib":"6MhhU","@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"9tWAc":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "formatMessage", ()=>formatMessage);
var _tslib = require("tslib");
var _icuMessageformatParser = require("@formatjs/icu-messageformat-parser");
var _intlMessageformat = require("intl-messageformat");
var _error = require("./error");
var _utils = require("./utils");
function setTimeZoneInOptions(opts, timeZone) {
    return Object.keys(opts).reduce(function(all, k) {
        all[k] = (0, _tslib.__assign)({
            timeZone: timeZone
        }, opts[k]);
        return all;
    }, {});
}
function deepMergeOptions(opts1, opts2) {
    var keys = Object.keys((0, _tslib.__assign)((0, _tslib.__assign)({}, opts1), opts2));
    return keys.reduce(function(all, k) {
        all[k] = (0, _tslib.__assign)((0, _tslib.__assign)({}, opts1[k] || {}), opts2[k] || {});
        return all;
    }, {});
}
function deepMergeFormatsAndSetTimeZone(f1, timeZone) {
    if (!timeZone) return f1;
    var mfFormats = (0, _intlMessageformat.IntlMessageFormat).formats;
    return (0, _tslib.__assign)((0, _tslib.__assign)((0, _tslib.__assign)({}, mfFormats), f1), {
        date: deepMergeOptions(setTimeZoneInOptions(mfFormats.date, timeZone), setTimeZoneInOptions(f1.date || {}, timeZone)),
        time: deepMergeOptions(setTimeZoneInOptions(mfFormats.time, timeZone), setTimeZoneInOptions(f1.time || {}, timeZone))
    });
}
var formatMessage = function(_a, state, messageDescriptor, values, opts) {
    var locale = _a.locale, formats = _a.formats, messages = _a.messages, defaultLocale = _a.defaultLocale, defaultFormats = _a.defaultFormats, fallbackOnEmptyString = _a.fallbackOnEmptyString, onError = _a.onError, timeZone = _a.timeZone, defaultRichTextElements = _a.defaultRichTextElements;
    if (messageDescriptor === void 0) messageDescriptor = {
        id: ''
    };
    var msgId = messageDescriptor.id, defaultMessage = messageDescriptor.defaultMessage;
    // `id` is a required field of a Message Descriptor.
    (0, _utils.invariant)(!!msgId, "[@formatjs/intl] An `id` must be provided to format a message. You can either:\n1. Configure your build toolchain with [babel-plugin-formatjs](https://formatjs.github.io/docs/tooling/babel-plugin)\nor [@formatjs/ts-transformer](https://formatjs.github.io/docs/tooling/ts-transformer) OR\n2. Configure your `eslint` config to include [eslint-plugin-formatjs](https://formatjs.github.io/docs/tooling/linter#enforce-id)\nto autofix this issue");
    var id = String(msgId);
    var message = // In case messages is Object.create(null)
    // e.g import('foo.json') from webpack)
    // See https://github.com/formatjs/formatjs/issues/1914
    messages && Object.prototype.hasOwnProperty.call(messages, id) && messages[id];
    // IMPORTANT: Hot path if `message` is AST with a single literal node
    if (Array.isArray(message) && message.length === 1 && message[0].type === (0, _icuMessageformatParser.TYPE).literal) return message[0].value;
    // IMPORTANT: Hot path straight lookup for performance
    if (!values && message && typeof message === 'string' && !defaultRichTextElements) return message.replace(/'\{(.*?)\}'/gi, "{$1}");
    values = (0, _tslib.__assign)((0, _tslib.__assign)({}, defaultRichTextElements), values || {});
    formats = deepMergeFormatsAndSetTimeZone(formats, timeZone);
    defaultFormats = deepMergeFormatsAndSetTimeZone(defaultFormats, timeZone);
    if (!message) {
        if (fallbackOnEmptyString === false && message === '') return message;
        if (!defaultMessage || locale && locale.toLowerCase() !== defaultLocale.toLowerCase()) // This prevents warnings from littering the console in development
        // when no `messages` are passed into the <IntlProvider> for the
        // default locale.
        onError(new (0, _error.MissingTranslationError)(messageDescriptor, locale));
        if (defaultMessage) try {
            var formatter = state.getMessageFormat(defaultMessage, defaultLocale, defaultFormats, opts);
            return formatter.format(values);
        } catch (e) {
            onError(new (0, _error.MessageFormatError)("Error formatting default message for: \"".concat(id, "\", rendering default message verbatim"), locale, messageDescriptor, e));
            return typeof defaultMessage === 'string' ? defaultMessage : id;
        }
        return id;
    }
    // We have the translated message
    try {
        var formatter = state.getMessageFormat(message, locale, formats, (0, _tslib.__assign)({
            formatters: state
        }, opts || {}));
        return formatter.format(values);
    } catch (e) {
        onError(new (0, _error.MessageFormatError)("Error formatting message: \"".concat(id, "\", using ").concat(defaultMessage ? 'default message' : 'id', " as fallback."), locale, messageDescriptor, e));
    }
    if (defaultMessage) try {
        var formatter = state.getMessageFormat(defaultMessage, defaultLocale, defaultFormats, opts);
        return formatter.format(values);
    } catch (e) {
        onError(new (0, _error.MessageFormatError)("Error formatting the default message for: \"".concat(id, "\", rendering message verbatim"), locale, messageDescriptor, e));
    }
    if (typeof message === 'string') return message;
    if (typeof defaultMessage === 'string') return defaultMessage;
    return id;
};

},{"tslib":"6MhhU","@formatjs/icu-messageformat-parser":"gNrtO","intl-messageformat":"3QRuN","./error":"j1qwF","./utils":"1huCS","@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"ev41Q":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "getFormatter", ()=>getFormatter);
parcelHelpers.export(exports, "formatDate", ()=>formatDate);
parcelHelpers.export(exports, "formatTime", ()=>formatTime);
parcelHelpers.export(exports, "formatDateTimeRange", ()=>formatDateTimeRange);
parcelHelpers.export(exports, "formatDateToParts", ()=>formatDateToParts);
parcelHelpers.export(exports, "formatTimeToParts", ()=>formatTimeToParts);
var _tslib = require("tslib");
var _error = require("./error");
var _utils = require("./utils");
var DATE_TIME_FORMAT_OPTIONS = [
    'formatMatcher',
    'timeZone',
    'hour12',
    'weekday',
    'era',
    'year',
    'month',
    'day',
    'hour',
    'minute',
    'second',
    'timeZoneName',
    'hourCycle',
    'dateStyle',
    'timeStyle',
    'calendar',
    // 'dayPeriod',
    'numberingSystem',
    'fractionalSecondDigits'
];
function getFormatter(_a, type, getDateTimeFormat, options) {
    var locale = _a.locale, formats = _a.formats, onError = _a.onError, timeZone = _a.timeZone;
    if (options === void 0) options = {};
    var format = options.format;
    var defaults = (0, _tslib.__assign)((0, _tslib.__assign)({}, timeZone && {
        timeZone: timeZone
    }), format && (0, _utils.getNamedFormat)(formats, type, format, onError));
    var filteredOptions = (0, _utils.filterProps)(options, DATE_TIME_FORMAT_OPTIONS, defaults);
    if (type === 'time' && !filteredOptions.hour && !filteredOptions.minute && !filteredOptions.second && !filteredOptions.timeStyle && !filteredOptions.dateStyle) // Add default formatting options if hour, minute, or second isn't defined.
    filteredOptions = (0, _tslib.__assign)((0, _tslib.__assign)({}, filteredOptions), {
        hour: 'numeric',
        minute: 'numeric'
    });
    return getDateTimeFormat(locale, filteredOptions);
}
function formatDate(config, getDateTimeFormat) {
    var _a = [];
    for(var _i = 2; _i < arguments.length; _i++)_a[_i - 2] = arguments[_i];
    var value = _a[0], _b = _a[1], options = _b === void 0 ? {} : _b;
    var date = typeof value === 'string' ? new Date(value || 0) : value;
    try {
        return getFormatter(config, 'date', getDateTimeFormat, options).format(date);
    } catch (e) {
        config.onError(new (0, _error.IntlFormatError)('Error formatting date.', config.locale, e));
    }
    return String(date);
}
function formatTime(config, getDateTimeFormat) {
    var _a = [];
    for(var _i = 2; _i < arguments.length; _i++)_a[_i - 2] = arguments[_i];
    var value = _a[0], _b = _a[1], options = _b === void 0 ? {} : _b;
    var date = typeof value === 'string' ? new Date(value || 0) : value;
    try {
        return getFormatter(config, 'time', getDateTimeFormat, options).format(date);
    } catch (e) {
        config.onError(new (0, _error.IntlFormatError)('Error formatting time.', config.locale, e));
    }
    return String(date);
}
function formatDateTimeRange(config, getDateTimeFormat) {
    var _a = [];
    for(var _i = 2; _i < arguments.length; _i++)_a[_i - 2] = arguments[_i];
    var from = _a[0], to = _a[1], _b = _a[2], options = _b === void 0 ? {} : _b;
    var fromDate = typeof from === 'string' ? new Date(from || 0) : from;
    var toDate = typeof to === 'string' ? new Date(to || 0) : to;
    try {
        return getFormatter(config, 'dateTimeRange', getDateTimeFormat, options).formatRange(fromDate, toDate);
    } catch (e) {
        config.onError(new (0, _error.IntlFormatError)('Error formatting date time range.', config.locale, e));
    }
    return String(fromDate);
}
function formatDateToParts(config, getDateTimeFormat) {
    var _a = [];
    for(var _i = 2; _i < arguments.length; _i++)_a[_i - 2] = arguments[_i];
    var value = _a[0], _b = _a[1], options = _b === void 0 ? {} : _b;
    var date = typeof value === 'string' ? new Date(value || 0) : value;
    try {
        return getFormatter(config, 'date', getDateTimeFormat, options).formatToParts(date); // TODO: remove this when https://github.com/microsoft/TypeScript/pull/50402 is merged
    } catch (e) {
        config.onError(new (0, _error.IntlFormatError)('Error formatting date.', config.locale, e));
    }
    return [];
}
function formatTimeToParts(config, getDateTimeFormat) {
    var _a = [];
    for(var _i = 2; _i < arguments.length; _i++)_a[_i - 2] = arguments[_i];
    var value = _a[0], _b = _a[1], options = _b === void 0 ? {} : _b;
    var date = typeof value === 'string' ? new Date(value || 0) : value;
    try {
        return getFormatter(config, 'time', getDateTimeFormat, options).formatToParts(date); // TODO: remove this when https://github.com/microsoft/TypeScript/pull/50402 is merged
    } catch (e) {
        config.onError(new (0, _error.IntlFormatError)('Error formatting time.', config.locale, e));
    }
    return [];
}

},{"tslib":"6MhhU","./error":"j1qwF","./utils":"1huCS","@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"PLBBG":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "formatDisplayName", ()=>formatDisplayName);
var _utils = require("./utils");
var _intlMessageformat = require("intl-messageformat");
var _error = require("./error");
var DISPLAY_NAMES_OPTONS = [
    'style',
    'type',
    'fallback',
    'languageDisplay'
];
function formatDisplayName(_a, getDisplayNames, value, options) {
    var locale = _a.locale, onError = _a.onError;
    var DisplayNames = Intl.DisplayNames;
    if (!DisplayNames) onError(new (0, _intlMessageformat.FormatError)("Intl.DisplayNames is not available in this environment.\nTry polyfilling it using \"@formatjs/intl-displaynames\"\n", (0, _intlMessageformat.ErrorCode).MISSING_INTL_API));
    var filteredOptions = (0, _utils.filterProps)(options, DISPLAY_NAMES_OPTONS);
    try {
        return getDisplayNames(locale, filteredOptions).of(value);
    } catch (e) {
        onError(new (0, _error.IntlFormatError)('Error formatting display name.', locale, e));
    }
}

},{"./utils":"1huCS","intl-messageformat":"3QRuN","./error":"j1qwF","@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"djquk":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "formatList", ()=>formatList);
parcelHelpers.export(exports, "formatListToParts", ()=>formatListToParts);
var _tslib = require("tslib");
var _intlMessageformat = require("intl-messageformat");
var _error = require("./error");
var _utils = require("./utils");
var LIST_FORMAT_OPTIONS = [
    'type',
    'style'
];
var now = Date.now();
function generateToken(i) {
    return "".concat(now, "_").concat(i, "_").concat(now);
}
function formatList(opts, getListFormat, values, options) {
    if (options === void 0) options = {};
    var results = formatListToParts(opts, getListFormat, values, options).reduce(function(all, el) {
        var val = el.value;
        if (typeof val !== 'string') all.push(val);
        else if (typeof all[all.length - 1] === 'string') all[all.length - 1] += val;
        else all.push(val);
        return all;
    }, []);
    return results.length === 1 ? results[0] : results.length === 0 ? '' : results;
}
function formatListToParts(_a, getListFormat, values, options) {
    var locale = _a.locale, onError = _a.onError;
    if (options === void 0) options = {};
    var ListFormat = Intl.ListFormat;
    if (!ListFormat) onError(new (0, _intlMessageformat.FormatError)("Intl.ListFormat is not available in this environment.\nTry polyfilling it using \"@formatjs/intl-listformat\"\n", (0, _intlMessageformat.ErrorCode).MISSING_INTL_API));
    var filteredOptions = (0, _utils.filterProps)(options, LIST_FORMAT_OPTIONS);
    try {
        var richValues_1 = {};
        var serializedValues = Array.from(values).map(function(v, i) {
            if (typeof v === 'object' && v !== null) {
                var id = generateToken(i);
                richValues_1[id] = v;
                return id;
            }
            return String(v);
        });
        return getListFormat(locale, filteredOptions).formatToParts(serializedValues).map(function(part) {
            return part.type === 'literal' ? part : (0, _tslib.__assign)((0, _tslib.__assign)({}, part), {
                value: richValues_1[part.value] || part.value
            });
        });
    } catch (e) {
        onError(new (0, _error.IntlFormatError)('Error formatting list.', locale, e));
    }
    // @ts-ignore
    return values;
}

},{"tslib":"6MhhU","intl-messageformat":"3QRuN","./error":"j1qwF","./utils":"1huCS","@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"f82CG":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "formatPlural", ()=>formatPlural);
var _intlMessageformat = require("intl-messageformat");
var _error = require("./error");
var _utils = require("./utils");
var PLURAL_FORMAT_OPTIONS = [
    'type'
];
function formatPlural(_a, getPluralRules, value, options) {
    var locale = _a.locale, onError = _a.onError;
    if (options === void 0) options = {};
    if (!Intl.PluralRules) onError(new (0, _intlMessageformat.FormatError)("Intl.PluralRules is not available in this environment.\nTry polyfilling it using \"@formatjs/intl-pluralrules\"\n", (0, _intlMessageformat.ErrorCode).MISSING_INTL_API));
    var filteredOptions = (0, _utils.filterProps)(options, PLURAL_FORMAT_OPTIONS);
    try {
        return getPluralRules(locale, filteredOptions).select(value);
    } catch (e) {
        onError(new (0, _error.IntlFormatError)('Error formatting plural.', locale, e));
    }
    return 'other';
}

},{"intl-messageformat":"3QRuN","./error":"j1qwF","./utils":"1huCS","@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"azliI":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "formatRelativeTime", ()=>formatRelativeTime);
var _utils = require("./utils");
var _intlMessageformat = require("intl-messageformat");
var _error = require("./error");
var RELATIVE_TIME_FORMAT_OPTIONS = [
    'numeric',
    'style'
];
function getFormatter(_a, getRelativeTimeFormat, options) {
    var locale = _a.locale, formats = _a.formats, onError = _a.onError;
    if (options === void 0) options = {};
    var format = options.format;
    var defaults = !!format && (0, _utils.getNamedFormat)(formats, 'relative', format, onError) || {};
    var filteredOptions = (0, _utils.filterProps)(options, RELATIVE_TIME_FORMAT_OPTIONS, defaults);
    return getRelativeTimeFormat(locale, filteredOptions);
}
function formatRelativeTime(config, getRelativeTimeFormat, value, unit, options) {
    if (options === void 0) options = {};
    if (!unit) unit = 'second';
    var RelativeTimeFormat = Intl.RelativeTimeFormat;
    if (!RelativeTimeFormat) config.onError(new (0, _intlMessageformat.FormatError)("Intl.RelativeTimeFormat is not available in this environment.\nTry polyfilling it using \"@formatjs/intl-relativetimeformat\"\n", (0, _intlMessageformat.ErrorCode).MISSING_INTL_API));
    try {
        return getFormatter(config, getRelativeTimeFormat, options).format(value, unit);
    } catch (e) {
        config.onError(new (0, _error.IntlFormatError)('Error formatting relative time.', config.locale, e));
    }
    return String(value);
}

},{"./utils":"1huCS","intl-messageformat":"3QRuN","./error":"j1qwF","@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"jakNl":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "getFormatter", ()=>getFormatter);
parcelHelpers.export(exports, "formatNumber", ()=>formatNumber);
parcelHelpers.export(exports, "formatNumberToParts", ()=>formatNumberToParts);
var _error = require("./error");
var _utils = require("./utils");
var NUMBER_FORMAT_OPTIONS = [
    'style',
    'currency',
    'unit',
    'unitDisplay',
    'useGrouping',
    'minimumIntegerDigits',
    'minimumFractionDigits',
    'maximumFractionDigits',
    'minimumSignificantDigits',
    'maximumSignificantDigits',
    // ES2020 NumberFormat
    'compactDisplay',
    'currencyDisplay',
    'currencySign',
    'notation',
    'signDisplay',
    'unit',
    'unitDisplay',
    'numberingSystem',
    // ES2023 NumberFormat
    'trailingZeroDisplay',
    'roundingPriority',
    'roundingIncrement',
    'roundingMode'
];
function getFormatter(_a, getNumberFormat, options) {
    var locale = _a.locale, formats = _a.formats, onError = _a.onError;
    if (options === void 0) options = {};
    var format = options.format;
    var defaults = format && (0, _utils.getNamedFormat)(formats, 'number', format, onError) || {};
    var filteredOptions = (0, _utils.filterProps)(options, NUMBER_FORMAT_OPTIONS, defaults);
    return getNumberFormat(locale, filteredOptions);
}
function formatNumber(config, getNumberFormat, value, options) {
    if (options === void 0) options = {};
    try {
        return getFormatter(config, getNumberFormat, options).format(value);
    } catch (e) {
        config.onError(new (0, _error.IntlFormatError)('Error formatting number.', config.locale, e));
    }
    return String(value);
}
function formatNumberToParts(config, getNumberFormat, value, options) {
    if (options === void 0) options = {};
    try {
        return getFormatter(config, getNumberFormat, options).formatToParts(value);
    } catch (e) {
        config.onError(new (0, _error.IntlFormatError)('Error formatting number.', config.locale, e));
    }
    return [];
}

},{"./error":"j1qwF","./utils":"1huCS","@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"gdAHl":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
/**
 * Create intl object
 * @param config intl config
 * @param cache cache for formatter instances to prevent memory leak
 */ parcelHelpers.export(exports, "createIntl", ()=>createIntl);
var _tslib = require("tslib");
var _dateTime = require("./dateTime");
var _displayName = require("./displayName");
var _error = require("./error");
var _list = require("./list");
var _message = require("./message");
var _number = require("./number");
var _plural = require("./plural");
var _relativeTime = require("./relativeTime");
var _utils = require("./utils");
function messagesContainString(messages) {
    var firstMessage = messages ? messages[Object.keys(messages)[0]] : undefined;
    return typeof firstMessage === 'string';
}
function verifyConfigMessages(config) {
    if (config.onWarn && config.defaultRichTextElements && messagesContainString(config.messages || {})) config.onWarn("[@formatjs/intl] \"defaultRichTextElements\" was specified but \"message\" was not pre-compiled. \nPlease consider using \"@formatjs/cli\" to pre-compile your messages for performance.\nFor more details see https://formatjs.github.io/docs/getting-started/message-distribution");
}
function createIntl(config, cache) {
    var formatters = (0, _utils.createFormatters)(cache);
    var resolvedConfig = (0, _tslib.__assign)((0, _tslib.__assign)({}, (0, _utils.DEFAULT_INTL_CONFIG)), config);
    var locale = resolvedConfig.locale, defaultLocale = resolvedConfig.defaultLocale, onError = resolvedConfig.onError;
    if (!locale) {
        if (onError) onError(new (0, _error.InvalidConfigError)("\"locale\" was not configured, using \"".concat(defaultLocale, "\" as fallback. See https://formatjs.github.io/docs/react-intl/api#intlshape for more details")));
        // Since there's no registered locale data for `locale`, this will
        // fallback to the `defaultLocale` to make sure things can render.
        // The `messages` are overridden to the `defaultProps` empty object
        // to maintain referential equality across re-renders. It's assumed
        // each <FormattedMessage> contains a `defaultMessage` prop.
        resolvedConfig.locale = resolvedConfig.defaultLocale || 'en';
    } else if (!Intl.NumberFormat.supportedLocalesOf(locale).length && onError) onError(new (0, _error.MissingDataError)("Missing locale data for locale: \"".concat(locale, "\" in Intl.NumberFormat. Using default locale: \"").concat(defaultLocale, "\" as fallback. See https://formatjs.github.io/docs/react-intl#runtime-requirements for more details")));
    else if (!Intl.DateTimeFormat.supportedLocalesOf(locale).length && onError) onError(new (0, _error.MissingDataError)("Missing locale data for locale: \"".concat(locale, "\" in Intl.DateTimeFormat. Using default locale: \"").concat(defaultLocale, "\" as fallback. See https://formatjs.github.io/docs/react-intl#runtime-requirements for more details")));
    verifyConfigMessages(resolvedConfig);
    return (0, _tslib.__assign)((0, _tslib.__assign)({}, resolvedConfig), {
        formatters: formatters,
        formatNumber: (0, _number.formatNumber).bind(null, resolvedConfig, formatters.getNumberFormat),
        formatNumberToParts: (0, _number.formatNumberToParts).bind(null, resolvedConfig, formatters.getNumberFormat),
        formatRelativeTime: (0, _relativeTime.formatRelativeTime).bind(null, resolvedConfig, formatters.getRelativeTimeFormat),
        formatDate: (0, _dateTime.formatDate).bind(null, resolvedConfig, formatters.getDateTimeFormat),
        formatDateToParts: (0, _dateTime.formatDateToParts).bind(null, resolvedConfig, formatters.getDateTimeFormat),
        formatTime: (0, _dateTime.formatTime).bind(null, resolvedConfig, formatters.getDateTimeFormat),
        formatDateTimeRange: (0, _dateTime.formatDateTimeRange).bind(null, resolvedConfig, formatters.getDateTimeFormat),
        formatTimeToParts: (0, _dateTime.formatTimeToParts).bind(null, resolvedConfig, formatters.getDateTimeFormat),
        formatPlural: (0, _plural.formatPlural).bind(null, resolvedConfig, formatters.getPluralRules),
        formatMessage: (0, _message.formatMessage).bind(null, resolvedConfig, formatters),
        $t: (0, _message.formatMessage).bind(null, resolvedConfig, formatters),
        formatList: (0, _list.formatList).bind(null, resolvedConfig, formatters.getListFormat),
        formatListToParts: (0, _list.formatListToParts).bind(null, resolvedConfig, formatters.getListFormat),
        formatDisplayName: (0, _displayName.formatDisplayName).bind(null, resolvedConfig, formatters.getDisplayNames)
    });
}

},{"tslib":"6MhhU","./dateTime":"ev41Q","./displayName":"PLBBG","./error":"j1qwF","./list":"djquk","./message":"9tWAc","./number":"jakNl","./plural":"f82CG","./relativeTime":"azliI","./utils":"1huCS","@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"jwY9c":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "Provider", ()=>Provider);
parcelHelpers.export(exports, "Context", ()=>Context);
parcelHelpers.export(exports, "default", ()=>injectIntl);
var _tslib = require("tslib");
var _hoistNonReactStatics = require("hoist-non-react-statics");
var _hoistNonReactStaticsDefault = parcelHelpers.interopDefault(_hoistNonReactStatics);
var _react = require("react");
var _utils = require("../utils");
function getDisplayName(Component) {
    return Component.displayName || Component.name || 'Component';
}
// This is primarily dealing with packaging systems where multiple copies of react-intl
// might exist
var IntlContext = typeof window !== 'undefined' && !window.__REACT_INTL_BYPASS_GLOBAL_CONTEXT__ ? window.__REACT_INTL_CONTEXT__ || (window.__REACT_INTL_CONTEXT__ = _react.createContext(null)) : _react.createContext(null);
var IntlConsumer = IntlContext.Consumer, IntlProvider = IntlContext.Provider;
var Provider = IntlProvider;
var Context = IntlContext;
function injectIntl(WrappedComponent, options) {
    var _a = options || {}, _b = _a.intlPropName, intlPropName = _b === void 0 ? 'intl' : _b, _c = _a.forwardRef, forwardRef = _c === void 0 ? false : _c, _d = _a.enforceContext, enforceContext = _d === void 0 ? true : _d;
    var WithIntl = function(props) {
        return _react.createElement(IntlConsumer, null, function(intl) {
            var _a;
            if (enforceContext) (0, _utils.invariantIntlContext)(intl);
            var intlProp = (_a = {}, _a[intlPropName] = intl, _a);
            return _react.createElement(WrappedComponent, (0, _tslib.__assign)({}, props, intlProp, {
                ref: forwardRef ? props.forwardedRef : null
            }));
        });
    };
    WithIntl.displayName = "injectIntl(".concat(getDisplayName(WrappedComponent), ")");
    WithIntl.WrappedComponent = WrappedComponent;
    if (forwardRef) return (0, _hoistNonReactStaticsDefault.default)(// @ts-expect-error
    _react.forwardRef(function(props, ref) {
        return _react.createElement(WithIntl, (0, _tslib.__assign)({}, props, {
            forwardedRef: ref
        }));
    }), WrappedComponent);
    return (0, _hoistNonReactStaticsDefault.default)(WithIntl, WrappedComponent);
}

},{"tslib":"6MhhU","hoist-non-react-statics":"nZLnq","react":"ltHCL","../utils":"88Xfc","@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"nZLnq":[function(require,module,exports,__globalThis) {
'use strict';
var reactIs = require("5214e2ea36cfd2c8");
/**
 * Copyright 2015, Yahoo! Inc.
 * Copyrights licensed under the New BSD License. See the accompanying LICENSE file for terms.
 */ var REACT_STATICS = {
    childContextTypes: true,
    contextType: true,
    contextTypes: true,
    defaultProps: true,
    displayName: true,
    getDefaultProps: true,
    getDerivedStateFromError: true,
    getDerivedStateFromProps: true,
    mixins: true,
    propTypes: true,
    type: true
};
var KNOWN_STATICS = {
    name: true,
    length: true,
    prototype: true,
    caller: true,
    callee: true,
    arguments: true,
    arity: true
};
var FORWARD_REF_STATICS = {
    '$$typeof': true,
    render: true,
    defaultProps: true,
    displayName: true,
    propTypes: true
};
var MEMO_STATICS = {
    '$$typeof': true,
    compare: true,
    defaultProps: true,
    displayName: true,
    propTypes: true,
    type: true
};
var TYPE_STATICS = {};
TYPE_STATICS[reactIs.ForwardRef] = FORWARD_REF_STATICS;
TYPE_STATICS[reactIs.Memo] = MEMO_STATICS;
function getStatics(component) {
    // React v16.11 and below
    if (reactIs.isMemo(component)) return MEMO_STATICS;
     // React v16.12 and above
    return TYPE_STATICS[component['$$typeof']] || REACT_STATICS;
}
var defineProperty = Object.defineProperty;
var getOwnPropertyNames = Object.getOwnPropertyNames;
var getOwnPropertySymbols = Object.getOwnPropertySymbols;
var getOwnPropertyDescriptor = Object.getOwnPropertyDescriptor;
var getPrototypeOf = Object.getPrototypeOf;
var objectPrototype = Object.prototype;
function hoistNonReactStatics(targetComponent, sourceComponent, blacklist) {
    if (typeof sourceComponent !== 'string') {
        // don't hoist over string (html) components
        if (objectPrototype) {
            var inheritedComponent = getPrototypeOf(sourceComponent);
            if (inheritedComponent && inheritedComponent !== objectPrototype) hoistNonReactStatics(targetComponent, inheritedComponent, blacklist);
        }
        var keys = getOwnPropertyNames(sourceComponent);
        if (getOwnPropertySymbols) keys = keys.concat(getOwnPropertySymbols(sourceComponent));
        var targetStatics = getStatics(targetComponent);
        var sourceStatics = getStatics(sourceComponent);
        for(var i = 0; i < keys.length; ++i){
            var key = keys[i];
            if (!KNOWN_STATICS[key] && !(blacklist && blacklist[key]) && !(sourceStatics && sourceStatics[key]) && !(targetStatics && targetStatics[key])) {
                var descriptor = getOwnPropertyDescriptor(sourceComponent, key);
                try {
                    // Avoid failures from read-only properties
                    defineProperty(targetComponent, key, descriptor);
                } catch (e) {}
            }
        }
    }
    return targetComponent;
}
module.exports = hoistNonReactStatics;

},{"5214e2ea36cfd2c8":"aBLra"}],"aBLra":[function(require,module,exports,__globalThis) {
'use strict';
module.exports = require("3216a58d2c9ca429");

},{"3216a58d2c9ca429":"kr4g9"}],"kr4g9":[function(require,module,exports,__globalThis) {
/** @license React v16.13.1
 * react-is.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ 'use strict';
var b = "function" === typeof Symbol && Symbol.for, c = b ? Symbol.for("react.element") : 60103, d = b ? Symbol.for("react.portal") : 60106, e = b ? Symbol.for("react.fragment") : 60107, f = b ? Symbol.for("react.strict_mode") : 60108, g = b ? Symbol.for("react.profiler") : 60114, h = b ? Symbol.for("react.provider") : 60109, k = b ? Symbol.for("react.context") : 60110, l = b ? Symbol.for("react.async_mode") : 60111, m = b ? Symbol.for("react.concurrent_mode") : 60111, n = b ? Symbol.for("react.forward_ref") : 60112, p = b ? Symbol.for("react.suspense") : 60113, q = b ? Symbol.for("react.suspense_list") : 60120, r = b ? Symbol.for("react.memo") : 60115, t = b ? Symbol.for("react.lazy") : 60116, v = b ? Symbol.for("react.block") : 60121, w = b ? Symbol.for("react.fundamental") : 60117, x = b ? Symbol.for("react.responder") : 60118, y = b ? Symbol.for("react.scope") : 60119;
function z(a) {
    if ("object" === typeof a && null !== a) {
        var u = a.$$typeof;
        switch(u){
            case c:
                switch(a = a.type, a){
                    case l:
                    case m:
                    case e:
                    case g:
                    case f:
                    case p:
                        return a;
                    default:
                        switch(a = a && a.$$typeof, a){
                            case k:
                            case n:
                            case t:
                            case r:
                            case h:
                                return a;
                            default:
                                return u;
                        }
                }
            case d:
                return u;
        }
    }
}
function A(a) {
    return z(a) === m;
}
exports.AsyncMode = l;
exports.ConcurrentMode = m;
exports.ContextConsumer = k;
exports.ContextProvider = h;
exports.Element = c;
exports.ForwardRef = n;
exports.Fragment = e;
exports.Lazy = t;
exports.Memo = r;
exports.Portal = d;
exports.Profiler = g;
exports.StrictMode = f;
exports.Suspense = p;
exports.isAsyncMode = function(a) {
    return A(a) || z(a) === l;
};
exports.isConcurrentMode = A;
exports.isContextConsumer = function(a) {
    return z(a) === k;
};
exports.isContextProvider = function(a) {
    return z(a) === h;
};
exports.isElement = function(a) {
    return "object" === typeof a && null !== a && a.$$typeof === c;
};
exports.isForwardRef = function(a) {
    return z(a) === n;
};
exports.isFragment = function(a) {
    return z(a) === e;
};
exports.isLazy = function(a) {
    return z(a) === t;
};
exports.isMemo = function(a) {
    return z(a) === r;
};
exports.isPortal = function(a) {
    return z(a) === d;
};
exports.isProfiler = function(a) {
    return z(a) === g;
};
exports.isStrictMode = function(a) {
    return z(a) === f;
};
exports.isSuspense = function(a) {
    return z(a) === p;
};
exports.isValidElementType = function(a) {
    return "string" === typeof a || "function" === typeof a || a === e || a === m || a === g || a === f || a === p || a === q || "object" === typeof a && null !== a && (a.$$typeof === t || a.$$typeof === r || a.$$typeof === h || a.$$typeof === k || a.$$typeof === n || a.$$typeof === w || a.$$typeof === x || a.$$typeof === y || a.$$typeof === v);
};
exports.typeOf = z;

},{}],"4Xxzz":[function(require,module,exports,__globalThis) {
/*
 * Copyright 2015, Yahoo Inc.
 * Copyrights licensed under the New BSD License.
 * See the accompanying LICENSE file for terms.
 */ var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "createIntl", ()=>createIntl);
var _tslib = require("tslib");
var _intl = require("@formatjs/intl");
var _intlMessageformat = require("intl-messageformat");
var _utils = require("../utils");
function assignUniqueKeysToFormatXMLElementFnArgument(values) {
    if (!values) return values;
    return Object.keys(values).reduce(function(acc, k) {
        var v = values[k];
        acc[k] = (0, _intlMessageformat.isFormatXMLElementFn)(v) ? (0, _utils.assignUniqueKeysToParts)(v) : v;
        return acc;
    }, {});
}
var formatMessage = function(config, formatters, descriptor, rawValues) {
    var rest = [];
    for(var _i = 4; _i < arguments.length; _i++)rest[_i - 4] = arguments[_i];
    var values = assignUniqueKeysToFormatXMLElementFnArgument(rawValues);
    var chunks = (0, _intl.formatMessage).apply(void 0, (0, _tslib.__spreadArray)([
        config,
        formatters,
        descriptor,
        values
    ], rest, false));
    if (Array.isArray(chunks)) return (0, _utils.toKeyedReactNodeArray)(chunks);
    return chunks;
};
var createIntl = function(_a, cache) {
    var rawDefaultRichTextElements = _a.defaultRichTextElements, config = (0, _tslib.__rest)(_a, [
        "defaultRichTextElements"
    ]);
    var defaultRichTextElements = assignUniqueKeysToFormatXMLElementFnArgument(rawDefaultRichTextElements);
    var coreIntl = (0, _intl.createIntl)((0, _tslib.__assign)((0, _tslib.__assign)((0, _tslib.__assign)({}, (0, _utils.DEFAULT_INTL_CONFIG)), config), {
        defaultRichTextElements: defaultRichTextElements
    }), cache);
    var resolvedConfig = {
        locale: coreIntl.locale,
        timeZone: coreIntl.timeZone,
        fallbackOnEmptyString: coreIntl.fallbackOnEmptyString,
        formats: coreIntl.formats,
        defaultLocale: coreIntl.defaultLocale,
        defaultFormats: coreIntl.defaultFormats,
        messages: coreIntl.messages,
        onError: coreIntl.onError,
        defaultRichTextElements: defaultRichTextElements
    };
    return (0, _tslib.__assign)((0, _tslib.__assign)({}, coreIntl), {
        formatMessage: formatMessage.bind(null, resolvedConfig, coreIntl.formatters),
        $t: formatMessage.bind(null, resolvedConfig, coreIntl.formatters)
    });
};

},{"tslib":"6MhhU","@formatjs/intl":"ljzXP","intl-messageformat":"3QRuN","../utils":"88Xfc","@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"fQpLs":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _tslib = require("tslib");
var _react = require("react");
var _useIntl = require("./useIntl");
var _useIntlDefault = parcelHelpers.interopDefault(_useIntl);
var FormattedDateTimeRange = function(props) {
    var intl = (0, _useIntlDefault.default)();
    var from = props.from, to = props.to, children = props.children, formatProps = (0, _tslib.__rest)(props, [
        "from",
        "to",
        "children"
    ]);
    var formattedValue = intl.formatDateTimeRange(from, to, formatProps);
    if (typeof children === 'function') return children(formattedValue);
    var Text = intl.textComponent || _react.Fragment;
    return _react.createElement(Text, null, formattedValue);
};
FormattedDateTimeRange.displayName = 'FormattedDateTimeRange';
exports.default = FormattedDateTimeRange;

},{"tslib":"6MhhU","react":"ltHCL","./useIntl":"jQUM3","@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"gfNgD":[function(require,module,exports,__globalThis) {
/*
 * Copyright 2015, Yahoo Inc.
 * Copyrights licensed under the New BSD License.
 * See the accompanying LICENSE file for terms.
 */ var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _tslib = require("tslib");
var _react = require("react");
var _utils = require("../utils");
var _useIntl = require("./useIntl");
var _useIntlDefault = parcelHelpers.interopDefault(_useIntl);
function areEqual(prevProps, nextProps) {
    var values = prevProps.values, otherProps = (0, _tslib.__rest)(prevProps, [
        "values"
    ]);
    var nextValues = nextProps.values, nextOtherProps = (0, _tslib.__rest)(nextProps, [
        "values"
    ]);
    return (0, _utils.shallowEqual)(nextValues, values) && (0, _utils.shallowEqual)(otherProps, nextOtherProps);
}
function FormattedMessage(props) {
    var intl = (0, _useIntlDefault.default)();
    var formatMessage = intl.formatMessage, _a = intl.textComponent, Text = _a === void 0 ? _react.Fragment : _a;
    var id = props.id, description = props.description, defaultMessage = props.defaultMessage, values = props.values, children = props.children, _b = props.tagName, Component = _b === void 0 ? Text : _b, ignoreTag = props.ignoreTag;
    var descriptor = {
        id: id,
        description: description,
        defaultMessage: defaultMessage
    };
    var nodes = formatMessage(descriptor, values, {
        ignoreTag: ignoreTag
    });
    if (typeof children === 'function') return children(Array.isArray(nodes) ? nodes : [
        nodes
    ]);
    if (Component) return _react.createElement(Component, null, nodes);
    return _react.createElement(_react.Fragment, null, nodes);
}
FormattedMessage.displayName = 'FormattedMessage';
var MemoizedFormattedMessage = _react.memo(FormattedMessage, areEqual);
MemoizedFormattedMessage.displayName = 'MemoizedFormattedMessage';
exports.default = MemoizedFormattedMessage;

},{"tslib":"6MhhU","react":"ltHCL","../utils":"88Xfc","./useIntl":"jQUM3","@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"d3HMU":[function(require,module,exports,__globalThis) {
/*
 * Copyright 2015, Yahoo Inc.
 * Copyrights licensed under the New BSD License.
 * See the accompanying LICENSE file for terms.
 */ var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _react = require("react");
var _useIntl = require("./useIntl");
var _useIntlDefault = parcelHelpers.interopDefault(_useIntl);
var FormattedPlural = function(props) {
    var _a = (0, _useIntlDefault.default)(), formatPlural = _a.formatPlural, Text = _a.textComponent;
    var value = props.value, other = props.other, children = props.children;
    var pluralCategory = formatPlural(value, props);
    var formattedPlural = props[pluralCategory] || other;
    if (typeof children === 'function') return children(formattedPlural);
    if (Text) return _react.createElement(Text, null, formattedPlural);
    // Work around @types/react where React.FC cannot return string
    return formattedPlural;
};
FormattedPlural.displayName = 'FormattedPlural';
exports.default = FormattedPlural;

},{"react":"ltHCL","./useIntl":"jQUM3","@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"b7DFj":[function(require,module,exports,__globalThis) {
/*
 * Copyright 2015, Yahoo Inc.
 * Copyrights licensed under the New BSD License.
 * See the accompanying LICENSE file for terms.
 */ var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _tslib = require("tslib");
var _intl = require("@formatjs/intl");
var _react = require("react");
var _utils = require("../utils");
var _createIntl = require("./createIntl");
var _injectIntl = require("./injectIntl");
function processIntlConfig(config) {
    return {
        locale: config.locale,
        timeZone: config.timeZone,
        fallbackOnEmptyString: config.fallbackOnEmptyString,
        formats: config.formats,
        textComponent: config.textComponent,
        messages: config.messages,
        defaultLocale: config.defaultLocale,
        defaultFormats: config.defaultFormats,
        onError: config.onError,
        onWarn: config.onWarn,
        wrapRichTextChunksInFragment: config.wrapRichTextChunksInFragment,
        defaultRichTextElements: config.defaultRichTextElements
    };
}
var IntlProvider = /** @class */ function(_super) {
    (0, _tslib.__extends)(IntlProvider, _super);
    function IntlProvider() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.cache = (0, _intl.createIntlCache)();
        _this.state = {
            cache: _this.cache,
            intl: (0, _createIntl.createIntl)(processIntlConfig(_this.props), _this.cache),
            prevConfig: processIntlConfig(_this.props)
        };
        return _this;
    }
    IntlProvider.getDerivedStateFromProps = function(props, _a) {
        var prevConfig = _a.prevConfig, cache = _a.cache;
        var config = processIntlConfig(props);
        if (!(0, _utils.shallowEqual)(prevConfig, config)) return {
            intl: (0, _createIntl.createIntl)(config, cache),
            prevConfig: config
        };
        return null;
    };
    IntlProvider.prototype.render = function() {
        (0, _utils.invariantIntlContext)(this.state.intl);
        return _react.createElement((0, _injectIntl.Provider), {
            value: this.state.intl
        }, this.props.children);
    };
    IntlProvider.displayName = 'IntlProvider';
    IntlProvider.defaultProps = (0, _utils.DEFAULT_INTL_CONFIG);
    return IntlProvider;
}(_react.PureComponent);
exports.default = IntlProvider;

},{"tslib":"6MhhU","@formatjs/intl":"ljzXP","react":"ltHCL","../utils":"88Xfc","./createIntl":"4Xxzz","./injectIntl":"jwY9c","@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"4dstO":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _tslib = require("tslib");
/*
 * Copyright 2015, Yahoo Inc.
 * Copyrights licensed under the New BSD License.
 * See the accompanying LICENSE file for terms.
 */ var _react = require("react");
var _utils = require("../utils");
var _useIntl = require("./useIntl");
var _useIntlDefault = parcelHelpers.interopDefault(_useIntl);
var MINUTE = 60;
var HOUR = 3600;
var DAY = 86400;
function selectUnit(seconds) {
    var absValue = Math.abs(seconds);
    if (absValue < MINUTE) return 'second';
    if (absValue < HOUR) return 'minute';
    if (absValue < DAY) return 'hour';
    return 'day';
}
function getDurationInSeconds(unit) {
    switch(unit){
        case 'second':
            return 1;
        case 'minute':
            return MINUTE;
        case 'hour':
            return HOUR;
        default:
            return DAY;
    }
}
function valueToSeconds(value, unit) {
    if (!value) return 0;
    switch(unit){
        case 'second':
            return value;
        case 'minute':
            return value * MINUTE;
        default:
            return value * HOUR;
    }
}
var INCREMENTABLE_UNITS = [
    'second',
    'minute',
    'hour'
];
function canIncrement(unit) {
    if (unit === void 0) unit = 'second';
    return INCREMENTABLE_UNITS.indexOf(unit) > -1;
}
var SimpleFormattedRelativeTime = function(props) {
    var _a = (0, _useIntlDefault.default)(), formatRelativeTime = _a.formatRelativeTime, Text = _a.textComponent;
    var children = props.children, value = props.value, unit = props.unit, otherProps = (0, _tslib.__rest)(props, [
        "children",
        "value",
        "unit"
    ]);
    var formattedRelativeTime = formatRelativeTime(value || 0, unit, otherProps);
    if (typeof children === 'function') return children(formattedRelativeTime);
    if (Text) return _react.createElement(Text, null, formattedRelativeTime);
    return _react.createElement(_react.Fragment, null, formattedRelativeTime);
};
var FormattedRelativeTime = function(_a) {
    var _b = _a.value, value = _b === void 0 ? 0 : _b, _c = _a.unit, unit = _c === void 0 ? 'second' : _c, updateIntervalInSeconds = _a.updateIntervalInSeconds, otherProps = (0, _tslib.__rest)(_a, [
        "value",
        "unit",
        "updateIntervalInSeconds"
    ]);
    (0, _utils.invariant)(!updateIntervalInSeconds || !!(updateIntervalInSeconds && canIncrement(unit)), 'Cannot schedule update with unit longer than hour');
    var _d = _react.useState(), prevUnit = _d[0], setPrevUnit = _d[1];
    var _e = _react.useState(0), prevValue = _e[0], setPrevValue = _e[1];
    var _f = _react.useState(0), currentValueInSeconds = _f[0], setCurrentValueInSeconds = _f[1];
    var updateTimer;
    if (unit !== prevUnit || value !== prevValue) {
        setPrevValue(value || 0);
        setPrevUnit(unit);
        setCurrentValueInSeconds(canIncrement(unit) ? valueToSeconds(value, unit) : 0);
    }
    _react.useEffect(function() {
        function clearUpdateTimer() {
            clearTimeout(updateTimer);
        }
        clearUpdateTimer();
        // If there's no interval and we cannot increment this unit, do nothing
        if (!updateIntervalInSeconds || !canIncrement(unit)) return clearUpdateTimer;
        // Figure out the next interesting time
        var nextValueInSeconds = currentValueInSeconds - updateIntervalInSeconds;
        var nextUnit = selectUnit(nextValueInSeconds);
        // We've reached the max auto incrementable unit, don't schedule another update
        if (nextUnit === 'day') return clearUpdateTimer;
        var unitDuration = getDurationInSeconds(nextUnit);
        var remainder = nextValueInSeconds % unitDuration;
        var prevInterestingValueInSeconds = nextValueInSeconds - remainder;
        var nextInterestingValueInSeconds = prevInterestingValueInSeconds >= currentValueInSeconds ? prevInterestingValueInSeconds - unitDuration : prevInterestingValueInSeconds;
        var delayInSeconds = Math.abs(nextInterestingValueInSeconds - currentValueInSeconds);
        if (currentValueInSeconds !== nextInterestingValueInSeconds) updateTimer = setTimeout(function() {
            return setCurrentValueInSeconds(nextInterestingValueInSeconds);
        }, delayInSeconds * 1e3);
        return clearUpdateTimer;
    }, [
        currentValueInSeconds,
        updateIntervalInSeconds,
        unit
    ]);
    var currentValue = value || 0;
    var currentUnit = unit;
    if (canIncrement(unit) && typeof currentValueInSeconds === 'number' && updateIntervalInSeconds) {
        currentUnit = selectUnit(currentValueInSeconds);
        var unitDuration = getDurationInSeconds(currentUnit);
        currentValue = Math.round(currentValueInSeconds / unitDuration);
    }
    return _react.createElement(SimpleFormattedRelativeTime, (0, _tslib.__assign)({
        value: currentValue,
        unit: currentUnit
    }, otherProps));
};
FormattedRelativeTime.displayName = 'FormattedRelativeTime';
exports.default = FormattedRelativeTime;

},{"tslib":"6MhhU","react":"ltHCL","../utils":"88Xfc","./useIntl":"jQUM3","@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"iVzoy":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>(0, _badgeDefault.default));
var _badge = require("./badge");
var _badgeDefault = parcelHelpers.interopDefault(_badge);

},{"./badge":"l1cU2","@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"l1cU2":[function(require,module,exports,__globalThis) {
/* badge.tsx generated by @compiled/babel-plugin v0.39.1 */ var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _react = require("react");
var _runtime = require("@compiled/react/runtime");
var _platformFeatureFlags = require("@atlaskit/platform-feature-flags");
var _compiled = require("@atlaskit/primitives/compiled");
var _appearanceMapping = require("./appearance-mapping");
var _appearanceMappingToOld = require("./appearance-mapping-to-old");
var _badgeNew = require("./badge-new");
var _badgeNewDefault = parcelHelpers.interopDefault(_badgeNew);
var _formatValueWithNegativeSupport = require("./internal/format-value-with-negative-support");
/**
 * Visual refresh colors.
 * Hardcoded hex colors are used as the they will be updated in the labelling system work and we want to avoid frequent UI changes.\
 *
 * Using separate variables as opposed to an object, to comply with UI styling standard
 * https://atlassian.design/components/eslint-plugin-ui-styling-standard/no-unsafe-values/usage#object-access
 */ const neutral300 = '#DDDEE1';
const red300 = '#FD9891';
const blue300 = '#8FB8F6';
const neutral1000 = '#292A2E';
const styles = {
    root: "_2rkolb4i _18zr1b66 _1e0c116y _vchhusvi _1ul91ejb _1bah1h6o _1o9zidpf _1kz6184x",
    added: "_bfhk1y9u _syazi7uo",
    default: "_bfhk1fkg _syazwwip",
    important: "_bfhk1366 _syazwwip",
    primary: "_bfhk1ymo _syazwwip",
    primaryInverted: "_bfhkvuon _syaz1oa5",
    removed: "_bfhk1gly _syazi7uo"
};
const badgeValueWithNegativeNumberSupported = (children, max)=>{
    return typeof children === 'number' && typeof max === 'number' ? (0, _formatValueWithNegativeSupport.formatValueWithNegativeSupport)(children, max) : children;
};
/**
 * __Badge__
 *
 * This component gives you the full badge functionality and automatically formats the number you provide in \`children\`.
 *
 * - [Examples](https://atlassian.design/components/badge/examples)
 * - [Code](https://atlassian.design/components/badge/code)
 * - [Usage](https://atlassian.design/components/badge/usage)
 */ const Badge = /*#__PURE__*/ (0, _react.memo)(function Badge({ appearance = 'default', children = 0, max = 99, style, testId }) {
    if ((0, _platformFeatureFlags.fg)('platform-dst-lozenge-tag-badge-visual-uplifts')) {
        // Map old appearance names to new ones
        const newAppearance = (0, _appearanceMapping.appearanceMapping)[appearance];
        return /*#__PURE__*/ _react.createElement((0, _badgeNewDefault.default), {
            appearance: newAppearance,
            max: max,
            style: style,
            testId: testId
        }, children);
    }
    const oldAppearance = (0, _appearanceMappingToOld.appearanceMappingToOld)[appearance];
    return /*#__PURE__*/ _react.createElement("span", {
        "data-testid": testId,
        style: {
            background: style === null || style === void 0 ? void 0 : style.backgroundColor,
            color: style === null || style === void 0 ? void 0 : style.color
        },
        className: (0, _runtime.ax)([
            styles.root,
            styles[oldAppearance]
        ])
    }, /*#__PURE__*/ _react.createElement((0, _compiled.Text), {
        size: "small",
        align: "center",
        color: "inherit"
    }, badgeValueWithNegativeNumberSupported(children, max)));
});
exports.default = Badge;

},{"react":"ltHCL","@compiled/react/runtime":"d27Vo","@atlaskit/platform-feature-flags":"8rD2i","@atlaskit/primitives/compiled":"hDay7","./appearance-mapping":"7H8Wc","./appearance-mapping-to-old":"7dgCj","./badge-new":"3ineL","./internal/format-value-with-negative-support":"a8h4P","@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"d27Vo":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "CC", ()=>(0, _indexJs.CC));
parcelHelpers.export(exports, "CS", ()=>(0, _indexJs.CS));
parcelHelpers.export(exports, "ax", ()=>(0, _indexJs.ax));
parcelHelpers.export(exports, "ac", ()=>(0, _indexJs.ac));
parcelHelpers.export(exports, "clearAcCache", ()=>(0, _indexJs.clearAcCache));
parcelHelpers.export(exports, "ix", ()=>(0, _indexJs.ix));
var _indexJs = require("./runtime/index.js");

},{"./runtime/index.js":"joOrm","@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"joOrm":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "CS", ()=>(0, _styleJsDefault.default));
parcelHelpers.export(exports, "CC", ()=>(0, _styleCacheJsDefault.default));
parcelHelpers.export(exports, "ax", ()=>(0, _axJsDefault.default));
parcelHelpers.export(exports, "ac", ()=>(0, _acJsDefault.default));
parcelHelpers.export(exports, "clearAcCache", ()=>(0, _acJs.clearCache));
parcelHelpers.export(exports, "ix", ()=>(0, _cssCustomPropertyJsDefault.default));
var _styleJs = require("./style.js");
var _styleJsDefault = parcelHelpers.interopDefault(_styleJs);
var _styleCacheJs = require("./style-cache.js");
var _styleCacheJsDefault = parcelHelpers.interopDefault(_styleCacheJs);
var _axJs = require("./ax.js");
var _axJsDefault = parcelHelpers.interopDefault(_axJs);
var _acJs = require("./ac.js");
var _acJsDefault = parcelHelpers.interopDefault(_acJs);
var _cssCustomPropertyJs = require("./css-custom-property.js");
var _cssCustomPropertyJsDefault = parcelHelpers.interopDefault(_cssCustomPropertyJs);

},{"./style.js":"51knx","./style-cache.js":"HvhWu","./ax.js":"2JZ8z","./ac.js":"YpLZX","./css-custom-property.js":"f8xiQ","@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"51knx":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>Style);
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _devWarningsJs = require("./dev-warnings.js");
var _isServerEnvironmentJs = require("./is-server-environment.js");
var _sheetJs = require("./sheet.js");
var _sheetJsDefault = parcelHelpers.interopDefault(_sheetJs);
var _styleCacheJs = require("./style-cache.js");
function Style(props) {
    const inserted = (0, _styleCacheJs.useCache)();
    if (props.children.length) {
        if ((0, _isServerEnvironmentJs.isServerEnvironment)()) {
            const bucketedSheets = {};
            let hasSheets = false;
            for(let i = 0; i < props.children.length; i++){
                const sheet = props.children[i];
                if (inserted[sheet]) continue;
                else {
                    inserted[sheet] = true;
                    hasSheets = true;
                }
                const bucketName = (0, _sheetJs.getStyleBucketName)(sheet);
                bucketedSheets[bucketName] = (bucketedSheets[bucketName] || '') + sheet;
            }
            if (!hasSheets) return null;
            return (0, _reactDefault.default).createElement("style", {
                "data-cmpld": true,
                nonce: props.nonce,
                dangerouslySetInnerHTML: {
                    __html: (0, _sheetJs.styleBucketOrdering).map((bucket)=>bucketedSheets[bucket]).join('')
                }
            });
        } else for(let i = 0; i < props.children.length; i++){
            const sheet = props.children[i];
            if (inserted[sheet]) continue;
            inserted[sheet] = true;
            (0, _sheetJsDefault.default)(sheet, props);
        }
    }
    return null;
}

},{"react":"ltHCL","./dev-warnings.js":"ffqlV","./is-server-environment.js":"6kHEw","./sheet.js":"ivkwd","./style-cache.js":"HvhWu","@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"ffqlV":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "analyzeCssInDev", ()=>analyzeCssInDev);
const selectorsToWarn = [
    ':first-child',
    ':nth-child'
];
const hasWarned = {};
const warn = (str, ...args)=>console.error(`
 \u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2557} \u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2557} \u{2588}\u{2588}\u{2588}\u{2557}   \u{2588}\u{2588}\u{2588}\u{2557}\u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2557} \u{2588}\u{2588}\u{2557}\u{2588}\u{2588}\u{2557}     \u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2557}\u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2557}
\u{2588}\u{2588}\u{2554}\u{2550}\u{2550}\u{2550}\u{2550}\u{255D}\u{2588}\u{2588}\u{2554}\u{2550}\u{2550}\u{2550}\u{2588}\u{2588}\u{2557}\u{2588}\u{2588}\u{2588}\u{2588}\u{2557} \u{2588}\u{2588}\u{2588}\u{2588}\u{2551}\u{2588}\u{2588}\u{2554}\u{2550}\u{2550}\u{2588}\u{2588}\u{2557}\u{2588}\u{2588}\u{2551}\u{2588}\u{2588}\u{2551}     \u{2588}\u{2588}\u{2554}\u{2550}\u{2550}\u{2550}\u{2550}\u{255D}\u{2588}\u{2588}\u{2554}\u{2550}\u{2550}\u{2588}\u{2588}\u{2557}
\u{2588}\u{2588}\u{2551}     \u{2588}\u{2588}\u{2551}   \u{2588}\u{2588}\u{2551}\u{2588}\u{2588}\u{2554}\u{2588}\u{2588}\u{2588}\u{2588}\u{2554}\u{2588}\u{2588}\u{2551}\u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2554}\u{255D}\u{2588}\u{2588}\u{2551}\u{2588}\u{2588}\u{2551}     \u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2557}  \u{2588}\u{2588}\u{2551}  \u{2588}\u{2588}\u{2551}
\u{2588}\u{2588}\u{2551}     \u{2588}\u{2588}\u{2551}   \u{2588}\u{2588}\u{2551}\u{2588}\u{2588}\u{2551}\u{255A}\u{2588}\u{2588}\u{2554}\u{255D}\u{2588}\u{2588}\u{2551}\u{2588}\u{2588}\u{2554}\u{2550}\u{2550}\u{2550}\u{255D} \u{2588}\u{2588}\u{2551}\u{2588}\u{2588}\u{2551}     \u{2588}\u{2588}\u{2554}\u{2550}\u{2550}\u{255D}  \u{2588}\u{2588}\u{2551}  \u{2588}\u{2588}\u{2551}
\u{255A}\u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2557}\u{255A}\u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2554}\u{255D}\u{2588}\u{2588}\u{2551} \u{255A}\u{2550}\u{255D} \u{2588}\u{2588}\u{2551}\u{2588}\u{2588}\u{2551}     \u{2588}\u{2588}\u{2551}\u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2557}\u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2557}\u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2554}\u{255D}
 \u{255A}\u{2550}\u{2550}\u{2550}\u{2550}\u{2550}\u{255D} \u{255A}\u{2550}\u{2550}\u{2550}\u{2550}\u{2550}\u{255D} \u{255A}\u{2550}\u{255D}     \u{255A}\u{2550}\u{255D}\u{255A}\u{2550}\u{255D}     \u{255A}\u{2550}\u{255D}\u{255A}\u{2550}\u{2550}\u{2550}\u{2550}\u{2550}\u{2550}\u{255D}\u{255A}\u{2550}\u{2550}\u{2550}\u{2550}\u{2550}\u{2550}\u{255D}\u{255A}\u{2550}\u{2550}\u{2550}\u{2550}\u{2550}\u{255D}

  @compiled/react/runtime - DEV WARNING

  ${str}
`, ...args);
const analyzeCssInDev = (sheet)=>{
    if (hasWarned[sheet]) return;
    const shouldWarnAboutSelectors = selectorsToWarn.map((selector)=>sheet.includes(selector)).filter(Boolean).length > 0;
    if (shouldWarnAboutSelectors) warn(`Selectors "${selectorsToWarn.join(', ')}" are dangerous to use when server side rendering.
  Alternatively try and use ":nth-of-type", or placing data attributes and targetting those instead.
  Read https://compiledcssinjs.com/docs/server-side-rendering for more advice.`);
    hasWarned[sheet] = true;
};

},{"@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"6kHEw":[function(require,module,exports,__globalThis) {
/**
 * @see https://github.com/jsdom/jsdom/releases/tag/12.0.0
 * @see https://github.com/jsdom/jsdom/issues/1537
 */ var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "isServerEnvironment", ()=>isServerEnvironment);
var process = require("ab54d5390b80662b");
const isJsDomEnvironment = ()=>window.name === 'nodejs' || (navigator === null || navigator === void 0 ? void 0 : navigator.userAgent.includes('Node.js')) || (navigator === null || navigator === void 0 ? void 0 : navigator.userAgent.includes('jsdom'));
const isServerEnvironment = ()=>{
    if (typeof window === 'undefined' || typeof process !== 'undefined' && process.versions != null && process.versions.node != null) return true;
    if (isJsDomEnvironment()) return true;
    return false;
};

},{"ab54d5390b80662b":"gNLf3","@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"ivkwd":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "styleBucketOrdering", ()=>styleBucketOrdering);
parcelHelpers.export(exports, "getStyleBucketName", ()=>getStyleBucketName);
parcelHelpers.export(exports, "default", ()=>insertRule);
var _cacheJs = require("./cache.js");
var _shorthandJs = require("./shorthand.js");
const styleBucketOrdering = [
    // shorthand properties
    's-0',
    's-1',
    's-2',
    's-3',
    's-4',
    's-5',
    // catch-all
    '',
    // link
    'l',
    // visited
    'v',
    // focus-within
    'w',
    // focus
    'f',
    // focus-visible
    'i',
    // hover
    'h',
    // active
    'a',
    // at-rules
    'm'
];
/**
 * Holds all style buckets in memory that have been added to the head.
 */ const styleBucketsInHead = {};
/**
 * Maps the long pseudo name to the short pseudo name.
 * Pseudos that match here will be ordered,
 * everything else will make their way to the catch all style bucket.
 * We reduce the pseudo name to save bundlesize.
 * Thankfully there aren't any overlaps, see: https://developer.mozilla.org/en-US/docs/Web/CSS/Pseudo-classes.
 */ const pseudosMap = {
    // link
    k: 'l',
    // visited
    ited: 'v',
    // focus-within
    'us-within': 'w',
    // focus
    us: 'f',
    // focus-visible
    'us-visible': 'i',
    // hover
    er: 'h',
    // active
    ive: 'a'
};
/**
 * Lazily adds a `<style>` bucket to the `<head>`.
 * This will ensure that the style buckets are ordered.
 *
 * @param bucket Bucket to insert in the head.
 */ function lazyAddStyleBucketToHead(bucketName, opts) {
    if (!styleBucketsInHead[bucketName]) {
        let currentBucketIndex = styleBucketOrdering.indexOf(bucketName) + 1;
        let nextBucketFromCache = null;
        // Find the next bucket which we will add our new style bucket before.
        for(; currentBucketIndex < styleBucketOrdering.length; currentBucketIndex++){
            const nextBucket = styleBucketsInHead[styleBucketOrdering[currentBucketIndex]];
            if (nextBucket) {
                nextBucketFromCache = nextBucket;
                break;
            }
        }
        const tag = document.createElement('style');
        opts.nonce && tag.setAttribute('nonce', opts.nonce);
        tag.appendChild(document.createTextNode(''));
        document.head.insertBefore(tag, nextBucketFromCache);
        styleBucketsInHead[bucketName] = tag;
    }
    return styleBucketsInHead[bucketName];
}
const getStyleBucketName = (sheet)=>{
    // We are grouping all the at-rules like @media, @supports etc under `m` bucket.
    if (sheet.charCodeAt(0) === 64 /* "@" */ ) return 'm';
    const firstBracket = sheet.indexOf('{');
    /**
     * We assume that classname will always be 9 character long,
     * using this the 10th characters could be a pseudo declaration.
     */ if (sheet.charCodeAt(10) === 58 /* ":" */ ) {
        // We send through a subset of the string instead of the full pseudo name.
        // For example `"focus-visible"` name would instead of `"us-visible"`.
        // Return a mapped pseudo else the default catch all bucket.
        const mapped = pseudosMap[sheet.slice(14, firstBracket)];
        if (mapped) return mapped;
    }
    const property = sheet.slice(firstBracket + 1, sheet.indexOf(':', firstBracket)).trim();
    const shorthandDepth = (0, _shorthandJs.getShorthandDepth)(property);
    if (typeof shorthandDepth === 'number') return `s-${shorthandDepth}`;
    // Return default catch all bucket
    return '';
};
function insertRule(css, opts) {
    const bucketName = getStyleBucketName(css);
    const style = lazyAddStyleBucketToHead(bucketName, opts);
    {
        const sheet = style.sheet;
        // Used to avoid unhandled exceptions across browsers with prefixed selectors such as -moz-placeholder.
        try {
            sheet.insertRule(css, sheet.cssRules.length);
        } catch (_a) {}
    }
}

},{"./cache.js":"5b7Jw","./shorthand.js":"8qqhk","@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"5b7Jw":[function(require,module,exports,__globalThis) {
/**
 * Returns `true` when caching should be disabled, else `false`.
 *
 * Any code within this check will be removed in the output bundles:
 *
 * ```js
 * if (isCacheDisabled()) {
 *   // This code will be removed from the output bundles
 * }
 * ```
 */ var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "isCacheDisabled", ()=>isCacheDisabled);
const isCacheDisabled = ()=>{
    return false;
};

},{"@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"8qqhk":[function(require,module,exports,__globalThis) {
// Copied from packages/utils/src/shorthand.ts so that we avoid
// inflating the bundle size of @compiled/react/runtime with the contents
// of @compiled/utils
//
// Keep this `shorthandBuckets` in sync with the `shorthandBuckets` defined in
// packages/utils/src/shorthand.ts
var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "getShorthandDepth", ()=>getShorthandDepth);
const shorthandBuckets = {
    all: 0,
    animation: 1,
    'animation-range': 1,
    background: 1,
    border: 1,
    'border-color': 2,
    'border-style': 2,
    'border-width': 2,
    'border-block': 3,
    'border-inline': 3,
    'border-top': 4,
    'border-right': 4,
    'border-bottom': 4,
    'border-left': 4,
    'border-block-start': 5,
    'border-block-end': 5,
    'border-inline-start': 5,
    'border-inline-end': 5,
    'border-image': 1,
    'border-radius': 1,
    'column-rule': 1,
    columns: 1,
    'contain-intrinsic-size': 1,
    container: 1,
    flex: 1,
    'flex-flow': 1,
    font: 1,
    'font-synthesis': 1,
    'font-variant': 2,
    gap: 1,
    grid: 1,
    'grid-area': 1,
    'grid-column': 2,
    'grid-row': 2,
    'grid-template': 2,
    inset: 1,
    'inset-block': 2,
    'inset-inline': 2,
    'list-style': 1,
    margin: 1,
    'margin-block': 2,
    'margin-inline': 2,
    mask: 1,
    'mask-border': 1,
    offset: 1,
    outline: 1,
    overflow: 1,
    'overscroll-behavior': 1,
    padding: 1,
    'padding-block': 2,
    'padding-inline': 2,
    'place-content': 1,
    'place-items': 1,
    'place-self': 1,
    'position-try': 1,
    'scroll-margin': 1,
    'scroll-margin-block': 2,
    'scroll-margin-inline': 2,
    'scroll-padding': 1,
    'scroll-padding-block': 2,
    'scroll-padding-inline': 2,
    'scroll-timeline': 1,
    'text-decoration': 1,
    'text-emphasis': 1,
    'text-wrap': 1,
    transition: 1,
    'view-timeline': 1
};
const getShorthandDepth = (shorthand)=>{
    var _a;
    return (_a = shorthandBuckets[shorthand]) !== null && _a !== void 0 ? _a : null;
};

},{"@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"HvhWu":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "useCache", ()=>useCache);
var _react = require("react");
var _cacheJs = require("./cache.js");
var _isServerEnvironmentJs = require("./is-server-environment.js");
/**
 * Cache to hold already used styles.
 * React Context on the server - singleton object on the client.
 */ const Cache = (0, _isServerEnvironmentJs.isServerEnvironment)() ? (0, _react.createContext)(null) : {};
if (!(0, _isServerEnvironmentJs.isServerEnvironment)() && typeof document !== 'undefined') {
    /**
     * Iterates through all found style elements generated when server side rendering.
     *
     * @param cb
     */ const ssrStyles = document.querySelectorAll('style[data-cmpld]');
    for(let i = 0; i < ssrStyles.length; i++)// Move all found server-side rendered style elements to the head before React hydration happens.
    document.head.appendChild(ssrStyles[i]);
}
const useCache = ()=>{
    if ((0, _isServerEnvironmentJs.isServerEnvironment)()) // On the server we use React Context to we don't leak the cache between SSR calls.
    // During runtime this hook isn't conditionally called - it is at build time that the flow gets decided.
    // eslint-disable-next-line react-hooks/rules-of-hooks
    return (0, _react.useContext)(Cache) || {};
    // On the client we use the object singleton.
    return Cache;
};
/**
 * On the server this ensures the minimal amount of styles will be rendered
 * safely using React Context.
 *
 * On the browser this turns into a fragment with no React Context.
 */ const StyleCacheProvider = (props)=>{
    if ((0, _isServerEnvironmentJs.isServerEnvironment)()) {
        // This code path isn't conditionally called at build time - safe to ignore.
        // eslint-disable-next-line react-hooks/rules-of-hooks
        const inserted = useCache();
        return _react.createElement(Cache.Provider, {
            value: inserted
        }, props.children);
    }
    return props.children;
};
exports.default = StyleCacheProvider;

},{"react":"ltHCL","./cache.js":"5b7Jw","./is-server-environment.js":"6kHEw","@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"2JZ8z":[function(require,module,exports,__globalThis) {
/**
 * This length includes the underscore,
 * e.g. `"_1s4A"` would be a valid atomic group hash.
 */ var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>ax);
const ATOMIC_GROUP_LENGTH = 5;
function ax(classNames) {
    // Shortcut: nothing to do
    if (!classNames.length) return;
    // Shortcut: don't need to do anything if we only have a single classname
    if (classNames.length === 1 && classNames[0] && // checking to see if `classNames[0]` is a string that contains other classnames
    !classNames[0].includes(' ')) return classNames[0];
    // Using an object rather than a `Map` as it performed better in our benchmarks.
    // Would be happy to move to `Map` if it proved to be better under real conditions.
    const map = {};
    // Note: using loops to minimize iterations over the collection
    for (const value of classNames){
        // Exclude all falsy values, which leaves us with populated strings
        if (!value) continue;
        // a `value` can contain multiple classnames
        const list = value.split(' ');
        for (const className of list){
            /**
             * For atomic style classnames: the `key` is the `group`
             *
             * - Later atomic classnames with the same `group` will override earlier ones
             *   (which is what we want).
             * - Assumes atomic classnames are the only things that start with `_`
             * - Could use a regex to ensure that atomic classnames are structured how we expect,
             *   but did not add that for now as it did slow things down a bit.
             *
             * For other classnames: the `key` is the whole classname
             * - Okay to remove duplicates as doing so does not impact specificity
             *
             * */ const key = className.startsWith('_') ? className.slice(0, ATOMIC_GROUP_LENGTH) : className;
            map[key] = className;
        }
    }
    /**
     * We are converting the `map` into a string.
     *
     * The simple way to do this would be `Object.values(map).join(' ')`.
     * However, the approach below performs 10%-20% better in benchmarks.
     *
     * For `ax()` it feels right to squeeze as much runtime performance out as we can.
     */ let result = '';
    for(const key in map)result += map[key] + ' ';
    // If we have an empty string, then our `map` was empty.
    if (!result) return;
    // remove last " " from the result (we added " " at the end of every value)
    return result.trimEnd();
}

},{"@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"YpLZX":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
/**
 * Joins classes together and ensures atomic declarations of a single group exist.
 * Atomic declarations take the form of `_{group}{value}` (always prefixed with an underscore),
 * where both `group` and `value` are hashes **four characters long**.
 * Class names can be of any length,
 * this function can take both atomic declarations and class names.
 *
 * Input:
 *
 * ```
 * ax(['_aaaabbbb', '_aaaacccc'])
 * ```
 *
 * Output:
 *
 * ```
 * '_aaaacccc'
 * ```
 *
 * @param classes
 */ parcelHelpers.export(exports, "ac", ()=>ac);
parcelHelpers.export(exports, "memoizedAc", ()=>memoizedAc);
/**
 * Provide an opportunity to clear the cache to prevent memory leak.
 */ parcelHelpers.export(exports, "clearCache", ()=>clearCache);
/**
 * Expose cache
 */ parcelHelpers.export(exports, "getCache", ()=>getCache);
var _isServerEnvironmentJs = require("./is-server-environment.js");
const UNDERSCORE_UNICODE = 95;
/**
 * This length includes the underscore,
 * e.g. `"_1s4A"` would be a valid atomic group hash.
 */ const ATOMIC_GROUP_LENGTH = 5;
/**
 * Memoize the result of ac so if it is called with the same args, it returns immediately.
 * Also, to prevent useless React rerenders
 */ const cache = new Map();
/**
 * `ac` returns an instance of AtomicGroups. The instance holds the knowledge of Atomic Group so we can chain `ac`.
 * e.g. <div className={ax([ax(['_aaaa_b']), '_aaaa_c'])} />
 */ class AtomicGroups {
    toString() {
        let str = '';
        for (const [, value] of this.values)str += value + ' ';
        return str.slice(0, -1);
    }
    constructor(values){
        // An object stores the relation between Atomic group and actual class name
        // e.g. { "aaaa": "a" } `aaaa` is the Atomic group and `a` is the actual class name
        this.values = values;
    }
}
function ac(classNames) {
    // short circuit if there's no class names.
    if (classNames.length <= 1 && !classNames[0]) return undefined;
    const atomicGroups = new Map();
    for(let i = 0; i < classNames.length; i++){
        const cls = classNames[i];
        if (!cls) continue;
        if (typeof cls === 'string') {
            const groups = cls.split(' ');
            for(let x = 0; x < groups.length; x++){
                const atomic = groups[x];
                const isAtomic = atomic.charCodeAt(0) === UNDERSCORE_UNICODE;
                const isCompressed = isAtomic && atomic.charCodeAt(5) === UNDERSCORE_UNICODE;
                const atomicGroupName = isAtomic ? atomic.slice(0, ATOMIC_GROUP_LENGTH) : atomic;
                atomicGroups.set(atomicGroupName, isCompressed ? atomic.slice(ATOMIC_GROUP_LENGTH + 1) : atomic);
            }
        } else // if cls is an instance of AtomicGroups, transfer its values to `atomicGroups`
        for (const [key, value] of cls.values)atomicGroups.set(key, value);
    }
    return new AtomicGroups(atomicGroups);
}
function memoizedAc(classNames) {
    // short circuit if there's no class names.
    if (classNames.length <= 1 && !classNames[0]) return undefined;
    // build the cacheKey based on the function argument
    // e.g. if the argument is ["_aaaabbbb", "_aaaa_a", "some-class-name"],
    // then the cacheKey is "_aaaabbbb _aaaa_a some-class-name"
    let cacheKey = '';
    for(let i = 0; i < classNames.length; i += 1){
        const current = classNames[i];
        // continue if current is undefined, false, or ""
        if (!current) continue;
        cacheKey += current + ' ';
    }
    cacheKey = cacheKey.slice(0, -1);
    if (cache.has(cacheKey)) return cache.get(cacheKey);
    const result = ac(classNames);
    cache.set(cacheKey, result);
    return result;
}
// Memoization is primarily used to prevent React from unncessary re-rendering.
// Use unmemoizedAc on server-side because We don't need to worry about re-rendering on server-side.
exports.default = (0, _isServerEnvironmentJs.isServerEnvironment)() ? ac : memoizedAc;
function clearCache() {
    cache.clear();
}
function getCache() {
    return cache;
}

},{"./is-server-environment.js":"6kHEw","@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"f8xiQ":[function(require,module,exports,__globalThis) {
/**
 * Returns a CSS custom property value with an optional suffix & prefix.
 * Prefix will only be added if there is a suffix.
 * If the value is undefined a fallback value will be returned to prevent children inheriting parent values.
 *
 * @param value
 * @param suffix
 * @param prefix
 */ var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>cssCustomPropertyValue);
function cssCustomPropertyValue(value, suffix, prefix) {
    if (value != undefined) {
        if (suffix) {
            if (prefix) return prefix + value + suffix;
            return value + suffix;
        }
        return value;
    }
    // Currently React trims these values so we can't use a space " " to block the value.
    // Instead we use a CSS variable that doesn't exist which falls back to " ".
    // Bug raised here: https://github.com/facebook/react/issues/20497
    return 'var(--c-, )';
}

},{"@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"hDay7":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "Box", ()=>(0, _boxDefault.default));
parcelHelpers.export(exports, "Inline", ()=>(0, _inlineDefault.default));
parcelHelpers.export(exports, "Stack", ()=>(0, _stackDefault.default));
parcelHelpers.export(exports, "Flex", ()=>(0, _flexDefault.default));
parcelHelpers.export(exports, "Grid", ()=>(0, _gridDefault.default));
parcelHelpers.export(exports, "Bleed", ()=>(0, _bleedDefault.default));
parcelHelpers.export(exports, "Text", ()=>(0, _textDefault.default));
parcelHelpers.export(exports, "MetricText", ()=>(0, _metricTextDefault.default));
parcelHelpers.export(exports, "Pressable", ()=>(0, _pressableDefault.default));
parcelHelpers.export(exports, "Anchor", ()=>(0, _anchorDefault.default));
parcelHelpers.export(exports, "media", ()=>(0, _responsive.media));
parcelHelpers.export(exports, "UNSAFE_useMediaQuery", ()=>(0, _responsive.UNSAFE_useMediaQuery));
parcelHelpers.export(exports, "Show", ()=>(0, _responsive.Show));
parcelHelpers.export(exports, "Hide", ()=>(0, _responsive.Hide));
parcelHelpers.export(exports, "Focusable", ()=>(0, _focusableDefault.default));
// TODO: This is still not figured out from before…
parcelHelpers.export(exports, "UNSAFE_useSurface", ()=>(0, _surfaceProvider.useSurface));
parcelHelpers.export(exports, "UNSAFE_SurfaceContext", ()=>(0, _surfaceProvider.SurfaceContext));
var _box = require("./components/box");
var _boxDefault = parcelHelpers.interopDefault(_box);
var _inline = require("./components/inline");
var _inlineDefault = parcelHelpers.interopDefault(_inline);
var _stack = require("./components/stack");
var _stackDefault = parcelHelpers.interopDefault(_stack);
var _flex = require("./components/flex");
var _flexDefault = parcelHelpers.interopDefault(_flex);
var _grid = require("./components/grid");
var _gridDefault = parcelHelpers.interopDefault(_grid);
var _bleed = require("./components/bleed");
var _bleedDefault = parcelHelpers.interopDefault(_bleed);
var _text = require("./components/text");
var _textDefault = parcelHelpers.interopDefault(_text);
var _metricText = require("./components/metric-text");
var _metricTextDefault = parcelHelpers.interopDefault(_metricText);
var _pressable = require("./components/pressable");
var _pressableDefault = parcelHelpers.interopDefault(_pressable);
var _anchor = require("./components/anchor");
var _anchorDefault = parcelHelpers.interopDefault(_anchor);
var _responsive = require("./responsive");
var _focusable = require("./components/focusable");
var _focusableDefault = parcelHelpers.interopDefault(_focusable);
var _surfaceProvider = require("../utils/surface-provider");

},{"./components/box":"djz3s","./components/inline":"e7Psa","./components/stack":"3D5Ti","./components/flex":"9doqK","./components/grid":"vXS5Z","./components/bleed":"fZFvp","./components/text":"iDpYp","./components/metric-text":false,"./components/pressable":"iTONZ","./components/anchor":"lL0r0","./responsive":"6twZN","./components/focusable":"h97Ae","../utils/surface-provider":"1kmKD","@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"djz3s":[function(require,module,exports,__globalThis) {
/* box.tsx generated by @compiled/babel-plugin v0.39.1 */ var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _objectSpread = require("@swc/helpers/_/_object_spread");
var _objectSpreadProps = require("@swc/helpers/_/_object_spread_props");
var _objectWithoutProperties = require("@swc/helpers/_/_object_without_properties");
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _runtime = require("@compiled/react/runtime");
var _surfaceContext = require("../../utils/surface-context");
const baseStyles = null;
const backgroundColorMap = {
    'color.background.accent.lime.subtlest': "_bfhkm890",
    'color.background.accent.lime.subtlest.hovered': "_bfhkd4y8",
    'color.background.accent.lime.subtlest.pressed': "_bfhkkuup",
    'color.background.accent.lime.subtler': "_bfhkz2ec",
    'color.background.accent.lime.subtler.hovered': "_bfhk1gf0",
    'color.background.accent.lime.subtler.pressed': "_bfhk2kxc",
    'color.background.accent.lime.subtle': "_bfhkbq5w",
    'color.background.accent.lime.subtle.hovered': "_bfhkfoww",
    'color.background.accent.lime.subtle.pressed': "_bfhk1jbd",
    'color.background.accent.lime.bolder': "_bfhktde4",
    'color.background.accent.lime.bolder.hovered': "_bfhknzpa",
    'color.background.accent.lime.bolder.pressed': "_bfhkh0j0",
    'color.background.accent.red.subtlest': "_bfhk1vk5",
    'color.background.accent.red.subtlest.hovered': "_bfhk1i6i",
    'color.background.accent.red.subtlest.pressed': "_bfhknbir",
    'color.background.accent.red.subtler': "_bfhk1rtt",
    'color.background.accent.red.subtler.hovered': "_bfhkaffd",
    'color.background.accent.red.subtler.pressed': "_bfhk1j5a",
    'color.background.accent.red.subtle': "_bfhkkrt9",
    'color.background.accent.red.subtle.hovered': "_bfhk1sou",
    'color.background.accent.red.subtle.pressed': "_bfhk1fnn",
    'color.background.accent.red.bolder': "_bfhkuibq",
    'color.background.accent.red.bolder.hovered': "_bfhk100f",
    'color.background.accent.red.bolder.pressed': "_bfhk1cl6",
    'color.background.accent.orange.subtlest': "_bfhkf5uh",
    'color.background.accent.orange.subtlest.hovered': "_bfhk19yr",
    'color.background.accent.orange.subtlest.pressed': "_bfhkf90x",
    'color.background.accent.orange.subtler': "_bfhk165s",
    'color.background.accent.orange.subtler.hovered': "_bfhk1ei0",
    'color.background.accent.orange.subtler.pressed': "_bfhkdpo3",
    'color.background.accent.orange.subtle': "_bfhk1kkj",
    'color.background.accent.orange.subtle.hovered': "_bfhk9mfs",
    'color.background.accent.orange.subtle.pressed': "_bfhkaxpp",
    'color.background.accent.orange.bolder': "_bfhk1qg1",
    'color.background.accent.orange.bolder.hovered': "_bfhk12qo",
    'color.background.accent.orange.bolder.pressed': "_bfhk1fyq",
    'color.background.accent.yellow.subtlest': "_bfhkibhp",
    'color.background.accent.yellow.subtlest.hovered': "_bfhkaetg",
    'color.background.accent.yellow.subtlest.pressed': "_bfhk1o1l",
    'color.background.accent.yellow.subtler': "_bfhk1773",
    'color.background.accent.yellow.subtler.hovered': "_bfhk1uw7",
    'color.background.accent.yellow.subtler.pressed': "_bfhk1r9w",
    'color.background.accent.yellow.subtle': "_bfhk8y3s",
    'color.background.accent.yellow.subtle.hovered': "_bfhk819w",
    'color.background.accent.yellow.subtle.pressed': "_bfhk1jx0",
    'color.background.accent.yellow.bolder': "_bfhk1vop",
    'color.background.accent.yellow.bolder.hovered': "_bfhkkjqf",
    'color.background.accent.yellow.bolder.pressed': "_bfhk1okt",
    'color.background.accent.green.subtlest': "_bfhkn729",
    'color.background.accent.green.subtlest.hovered': "_bfhk3utz",
    'color.background.accent.green.subtlest.pressed': "_bfhkyfny",
    'color.background.accent.green.subtler': "_bfhk1wnw",
    'color.background.accent.green.subtler.hovered': "_bfhk1e2h",
    'color.background.accent.green.subtler.pressed': "_bfhkybhx",
    'color.background.accent.green.subtle': "_bfhk1rsu",
    'color.background.accent.green.subtle.hovered': "_bfhk12e3",
    'color.background.accent.green.subtle.pressed': "_bfhk1g86",
    'color.background.accent.green.bolder': "_bfhk1e5c",
    'color.background.accent.green.bolder.hovered': "_bfhka5yi",
    'color.background.accent.green.bolder.pressed': "_bfhk1j68",
    'color.background.accent.teal.subtlest': "_bfhk7xuz",
    'color.background.accent.teal.subtlest.hovered': "_bfhk108c",
    'color.background.accent.teal.subtlest.pressed': "_bfhk1cxp",
    'color.background.accent.teal.subtler': "_bfhk1a17",
    'color.background.accent.teal.subtler.hovered': "_bfhkkwwr",
    'color.background.accent.teal.subtler.pressed': "_bfhk1jb0",
    'color.background.accent.teal.subtle': "_bfhktdv8",
    'color.background.accent.teal.subtle.hovered': "_bfhkzh8h",
    'color.background.accent.teal.subtle.pressed': "_bfhk16zl",
    'color.background.accent.teal.bolder': "_bfhk2c8p",
    'color.background.accent.teal.bolder.hovered': "_bfhkl3ve",
    'color.background.accent.teal.bolder.pressed': "_bfhktor0",
    'color.background.accent.blue.subtlest': "_bfhk1s93",
    'color.background.accent.blue.subtlest.hovered': "_bfhkdaj9",
    'color.background.accent.blue.subtlest.pressed': "_bfhkxm0g",
    'color.background.accent.blue.subtler': "_bfhk1dy8",
    'color.background.accent.blue.subtler.hovered': "_bfhk815t",
    'color.background.accent.blue.subtler.pressed': "_bfhkrwxf",
    'color.background.accent.blue.subtle': "_bfhk115i",
    'color.background.accent.blue.subtle.hovered': "_bfhk9pr4",
    'color.background.accent.blue.subtle.pressed': "_bfhknpx7",
    'color.background.accent.blue.bolder': "_bfhk16e3",
    'color.background.accent.blue.bolder.hovered': "_bfhk1vbm",
    'color.background.accent.blue.bolder.pressed': "_bfhk1xwi",
    'color.background.accent.purple.subtlest': "_bfhkp2ly",
    'color.background.accent.purple.subtlest.hovered': "_bfhkkca2",
    'color.background.accent.purple.subtlest.pressed': "_bfhk1jbm",
    'color.background.accent.purple.subtler': "_bfhk1nm4",
    'color.background.accent.purple.subtler.hovered': "_bfhkattl",
    'color.background.accent.purple.subtler.pressed': "_bfhk3nfk",
    'color.background.accent.purple.subtle': "_bfhk18ah",
    'color.background.accent.purple.subtle.hovered': "_bfhk8bp1",
    'color.background.accent.purple.subtle.pressed': "_bfhk1cd2",
    'color.background.accent.purple.bolder': "_bfhkya33",
    'color.background.accent.purple.bolder.hovered': "_bfhk1af5",
    'color.background.accent.purple.bolder.pressed': "_bfhk6cze",
    'color.background.accent.magenta.subtlest': "_bfhk8tvm",
    'color.background.accent.magenta.subtlest.hovered': "_bfhkr3zd",
    'color.background.accent.magenta.subtlest.pressed': "_bfhk1ckf",
    'color.background.accent.magenta.subtler': "_bfhkv9ra",
    'color.background.accent.magenta.subtler.hovered': "_bfhk1axx",
    'color.background.accent.magenta.subtler.pressed': "_bfhk42ri",
    'color.background.accent.magenta.subtle': "_bfhk1mi6",
    'color.background.accent.magenta.subtle.hovered': "_bfhkrwyz",
    'color.background.accent.magenta.subtle.pressed': "_bfhk6c15",
    'color.background.accent.magenta.bolder': "_bfhkc3uk",
    'color.background.accent.magenta.bolder.hovered': "_bfhk1ok8",
    'color.background.accent.magenta.bolder.pressed': "_bfhkeawv",
    'color.background.accent.gray.subtlest': "_bfhkysee",
    'color.background.accent.gray.subtlest.hovered': "_bfhkwejn",
    'color.background.accent.gray.subtlest.pressed': "_bfhk18ut",
    'color.background.accent.gray.subtler': "_bfhk7qp0",
    'color.background.accent.gray.subtler.hovered': "_bfhk10ef",
    'color.background.accent.gray.subtler.pressed': "_bfhk1rk9",
    'color.background.accent.gray.subtle': "_bfhk18j9",
    'color.background.accent.gray.subtle.hovered': "_bfhk1nv3",
    'color.background.accent.gray.subtle.pressed': "_bfhkq9tj",
    'color.background.accent.gray.bolder': "_bfhk1i45",
    'color.background.accent.gray.bolder.hovered': "_bfhkbyip",
    'color.background.accent.gray.bolder.pressed': "_bfhk1van",
    'color.background.disabled': "_bfhk187o",
    'color.background.input': "_bfhk1j9a",
    'color.background.input.hovered': "_bfhkl4ek",
    'color.background.input.pressed': "_bfhkr01l",
    'color.background.inverse.subtle': "_bfhk1vck",
    'color.background.inverse.subtle.hovered': "_bfhkmpja",
    'color.background.inverse.subtle.pressed': "_bfhk1gii",
    'color.background.neutral': "_bfhki8nm",
    'color.background.neutral.hovered': "_bfhkplhp",
    'color.background.neutral.pressed': "_bfhk1gdz",
    'color.background.neutral.subtle': "_bfhksm61",
    'color.background.neutral.subtle.hovered': "_bfhk1dpa",
    'color.background.neutral.subtle.pressed': "_bfhkfcek",
    'color.background.neutral.bold': "_bfhk1aqn",
    'color.background.neutral.bold.hovered': "_bfhk1ibz",
    'color.background.neutral.bold.pressed': "_bfhkof27",
    'color.background.selected': "_bfhk15s3",
    'color.background.selected.hovered': "_bfhkufnl",
    'color.background.selected.pressed': "_bfhknozp",
    'color.background.selected.bold': "_bfhkjmqp",
    'color.background.selected.bold.hovered': "_bfhk1q28",
    'color.background.selected.bold.pressed': "_bfhk12kk",
    'color.background.brand.subtlest': "_bfhk1gmr",
    'color.background.brand.subtlest.hovered': "_bfhk3v15",
    'color.background.brand.subtlest.pressed': "_bfhku02c",
    'color.background.brand.bold': "_bfhk1856",
    'color.background.brand.bold.hovered': "_bfhkhf2y",
    'color.background.brand.bold.pressed': "_bfhkg6ey",
    'color.background.brand.boldest': "_bfhk1o4i",
    'color.background.brand.boldest.hovered': "_bfhklefx",
    'color.background.brand.boldest.pressed': "_bfhk16k6",
    'color.background.danger': "_bfhk1gly",
    'color.background.danger.hovered': "_bfhk1yvi",
    'color.background.danger.pressed': "_bfhk1r4b",
    'color.background.danger.bold': "_bfhkybec",
    'color.background.danger.bold.hovered': "_bfhks9hg",
    'color.background.danger.bold.pressed': "_bfhk13a9",
    'color.background.warning': "_bfhk1917",
    'color.background.warning.hovered': "_bfhk19zu",
    'color.background.warning.pressed': "_bfhkzr32",
    'color.background.warning.bold': "_bfhk1kmu",
    'color.background.warning.bold.hovered': "_bfhk1spp",
    'color.background.warning.bold.pressed': "_bfhk4m4m",
    'color.background.success': "_bfhk1y9u",
    'color.background.success.hovered': "_bfhk1vfx",
    'color.background.success.pressed': "_bfhk1wl5",
    'color.background.success.bold': "_bfhkkcmj",
    'color.background.success.bold.hovered': "_bfhky7x8",
    'color.background.success.bold.pressed': "_bfhkwcbh",
    'color.background.discovery': "_bfhk6vm6",
    'color.background.discovery.hovered': "_bfhk12eq",
    'color.background.discovery.pressed': "_bfhk18vq",
    'color.background.discovery.bold': "_bfhku5tj",
    'color.background.discovery.bold.hovered': "_bfhkfqeg",
    'color.background.discovery.bold.pressed': "_bfhk1f1m",
    'color.background.information': "_bfhk19ip",
    'color.background.information.hovered': "_bfhk86z5",
    'color.background.information.pressed': "_bfhk1c1j",
    'color.background.information.bold': "_bfhkx4w0",
    'color.background.information.bold.hovered': "_bfhkq2ii",
    'color.background.information.bold.pressed': "_bfhkf89v",
    'color.blanket': "_bfhk1i5c",
    'color.blanket.selected': "_bfhk7wq0",
    'color.blanket.danger': "_bfhkrprw",
    'color.skeleton': "_bfhkizff",
    'color.skeleton.subtle': "_bfhkvkf5",
    'elevation.surface': "_bfhkvuon",
    'elevation.surface.hovered': "_bfhk19i6",
    'elevation.surface.pressed': "_bfhk13ro",
    'elevation.surface.overlay': "_bfhk1bhr",
    'elevation.surface.overlay.hovered': "_bfhk6o2t",
    'elevation.surface.overlay.pressed': "_bfhkm8nx",
    'elevation.surface.raised': "_bfhkhp5a",
    'elevation.surface.raised.hovered': "_bfhk116u",
    'elevation.surface.raised.pressed': "_bfhk14aj",
    'elevation.surface.sunken': "_bfhkhfxm",
    'utility.elevation.surface.current': "_bfhkchd4"
};
const CURRENT_SURFACE_CSS_VAR = `--ds-elevation-surface-current`;
const setSurfaceTokenMap = {
    'elevation.surface': "_1q1lvuon",
    'elevation.surface.hovered': "_1q1l19i6",
    'elevation.surface.pressed': "_1q1l13ro",
    'elevation.surface.overlay': "_1q1l1bhr",
    'elevation.surface.overlay.hovered': "_1q1l6o2t",
    'elevation.surface.overlay.pressed': "_1q1lm8nx",
    'elevation.surface.raised': "_1q1lhp5a",
    'elevation.surface.raised.hovered': "_1q1l116u",
    'elevation.surface.raised.pressed': "_1q1l14aj",
    'elevation.surface.sunken': "_1q1lhfxm"
};
const paddingBlockStartMap = {
    'space.0': "_1q51ze3t",
    'space.025': "_1q51v77o",
    'space.050': "_1q511b66",
    'space.075': "_1q5112x7",
    'space.100': "_1q51u2gc",
    'space.150': "_1q51utpp",
    'space.200': "_1q51pxbi",
    'space.250': "_1q51v47k",
    'space.300': "_1q511ejb",
    'space.400': "_1q51xy5q",
    'space.500': "_1q511jfw",
    'space.600': "_1q51oahv",
    'space.800': "_1q51xncg",
    'space.1000': "_1q511epz"
};
const paddingBlockEndMap = {
    'space.0': "_85i5ze3t",
    'space.025': "_85i5v77o",
    'space.050': "_85i51b66",
    'space.075': "_85i512x7",
    'space.100': "_85i5u2gc",
    'space.150': "_85i5utpp",
    'space.200': "_85i5pxbi",
    'space.250': "_85i5v47k",
    'space.300': "_85i51ejb",
    'space.400': "_85i5xy5q",
    'space.500': "_85i51jfw",
    'space.600': "_85i5oahv",
    'space.800': "_85i5xncg",
    'space.1000': "_85i51epz"
};
const paddingInlineStartMap = {
    'space.0': "_bozgze3t",
    'space.025': "_bozgv77o",
    'space.050': "_bozg1b66",
    'space.075': "_bozg12x7",
    'space.100': "_bozgu2gc",
    'space.150': "_bozgutpp",
    'space.200': "_bozgpxbi",
    'space.250': "_bozgv47k",
    'space.300': "_bozg1ejb",
    'space.400': "_bozgxy5q",
    'space.500': "_bozg1jfw",
    'space.600': "_bozgoahv",
    'space.800': "_bozgxncg",
    'space.1000': "_bozg1epz"
};
const paddingInlineEndMap = {
    'space.0': "_y4tize3t",
    'space.025': "_y4tiv77o",
    'space.050': "_y4ti1b66",
    'space.075': "_y4ti12x7",
    'space.100': "_y4tiu2gc",
    'space.150': "_y4tiutpp",
    'space.200': "_y4tipxbi",
    'space.250': "_y4tiv47k",
    'space.300': "_y4ti1ejb",
    'space.400': "_y4tixy5q",
    'space.500': "_y4ti1jfw",
    'space.600': "_y4tioahv",
    'space.800': "_y4tixncg",
    'space.1000': "_y4ti1epz"
};
/**
 * __Box__
 *
 * A Box is a primitive component that has the design decisions of the Atlassian Design System baked in.
 * Renders a `div` by default.
 *
 * - [Examples](https://atlassian.design/components/primitives/box/examples)
 * - [Code](https://atlassian.design/components/primitives/box/code)
 * - [Usage](https://atlassian.design/components/primitives/box/usage)
 */ const Box = /*#__PURE__*/ (0, _react.forwardRef)((_param, ref)=>{
    var { as: Component = 'div', children, backgroundColor, padding, paddingBlock = padding, paddingBlockStart = paddingBlock, paddingBlockEnd = paddingBlock, paddingInline = padding, paddingInlineStart = paddingInline, paddingInlineEnd = paddingInline, style, testId, xcss } = _param, htmlAttributes = (0, _objectWithoutProperties._)(_param, [
        "as",
        "children",
        "backgroundColor",
        "padding",
        "paddingBlock",
        "paddingBlockStart",
        "paddingBlockEnd",
        "paddingInline",
        "paddingInlineStart",
        "paddingInlineEnd",
        "style",
        "testId",
        "xcss"
    ]);
    // This is to remove className from safeHtmlAttributes
    // @ts-ignore -- not using expect since it causes issues with help-center local consumption - className doesn't exist in the prop definition but we want to ensure it cannot be applied even if types are bypassed
    const { className: _spreadClass } = htmlAttributes, safeHtmlAttributes = (0, _objectWithoutProperties._)(htmlAttributes, [
        "className"
    ]);
    const node = /*#__PURE__*/ (0, _jsxRuntime.jsx)(Component, (0, _objectSpreadProps._)((0, _objectSpread._)({
        style: style,
        // @ts-ignore -- Expression produces a union type that is too complex to represent. We may be able to narrow the type here but unsure.
        ref: ref,
        className: (0, _runtime.ax)([
            "_19itglyw _vchhusvi _r06hglyw",
            backgroundColor && backgroundColorMap[backgroundColor],
            backgroundColor && isSurfaceToken(backgroundColor) && setSurfaceTokenMap[backgroundColor],
            paddingBlockStart && paddingBlockStartMap[paddingBlockStart],
            paddingBlockEnd && paddingBlockEndMap[paddingBlockEnd],
            paddingInlineStart && paddingInlineStartMap[paddingInlineStart],
            paddingInlineEnd && paddingInlineEndMap[paddingInlineEnd],
            xcss
        ])
    }, safeHtmlAttributes), {
        "data-testid": testId,
        children: children
    }));
    if (backgroundColor) return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _surfaceContext.SurfaceContext).Provider, {
        value: backgroundColor,
        children: node
    });
    return node;
});
exports.default = Box;
function isSurfaceToken(backgroundColor) {
    return backgroundColor in setSurfaceTokenMap;
}

},{"@swc/helpers/_/_object_spread":"9gdrV","@swc/helpers/_/_object_spread_props":"kANqQ","@swc/helpers/_/_object_without_properties":"6HqIM","react/jsx-runtime":"bGvcw","react":"ltHCL","@compiled/react/runtime":"d27Vo","../../utils/surface-context":"a2y1l","@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"a2y1l":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "SurfaceContext", ()=>SurfaceContext);
var _react = require("react");
const SurfaceContext = /*#__PURE__*/ (0, _react.createContext)('elevation.surface');

},{"react":"ltHCL","@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"e7Psa":[function(require,module,exports,__globalThis) {
/* inline.tsx generated by @compiled/babel-plugin v0.39.1 */ var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _objectSpread = require("@swc/helpers/_/_object_spread");
var _objectSpreadProps = require("@swc/helpers/_/_object_spread_props");
var _objectWithoutProperties = require("@swc/helpers/_/_object_without_properties");
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _runtime = require("@compiled/react/runtime");
var _css = require("@atlaskit/css");
var _flex = require("./flex");
var _flexDefault = parcelHelpers.interopDefault(_flex);
const styles = {
    separator: "_1mouze3t _195g1i6y _syazjjyb _lcxvglyw _uiztglyw",
    hug: "_16jlidpf",
    fill: "_1bsb1osq _16jlkb7n"
};
const Separator = ({ children })=>/*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
        className: (0, _runtime.ax)([
            styles.separator
        ]),
        children: children
    });
/**
 * __Inline__
 *
 * Inline is a primitive component based on CSS Flexbox that manages the horizontal layout of direct children.
 *
 * @example
 * ```tsx
 *  <Inline>
 *    <Box padding="space.100" backgroundColor="neutral"></Box>
 *    <Box padding="space.100" backgroundColor="neutral"></Box>
 *  </Inline>
 * ```
 *
 */ const Inline = /*#__PURE__*/ (0, _react.memo)(/*#__PURE__*/ (0, _react.forwardRef)((_param, ref)=>{
    var { as, alignInline, alignBlock: alignItems = 'start', shouldWrap = false, spread, grow, space, rowSpace, separator, xcss, testId, role, children: rawChildren } = _param, ariaAttributes = (0, _objectWithoutProperties._)(_param, [
        "as",
        "alignInline",
        "alignBlock",
        "shouldWrap",
        "spread",
        "grow",
        "space",
        "rowSpace",
        "separator",
        "xcss",
        "testId",
        "role",
        "children"
    ]);
    const separatorComponent = typeof separator === 'string' ? /*#__PURE__*/ (0, _jsxRuntime.jsx)(Separator, {
        children: separator
    }) : separator;
    const children = separatorComponent ? (0, _react.Children).toArray(rawChildren).filter(Boolean).map((child, index)=>{
        return /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _react.Fragment), {
            children: [
                separator && index > 0 ? separatorComponent : null,
                child
            ]
        }, index);
    }) : rawChildren;
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _flexDefault.default), (0, _objectSpreadProps._)((0, _objectSpread._)({}, ariaAttributes), {
        as: as,
        role: role,
        alignItems: alignItems,
        justifyContent: spread || alignInline,
        direction: "row",
        gap: space,
        rowGap: rowSpace,
        wrap: shouldWrap ? 'wrap' : undefined,
        xcss: (0, _css.cx)(grow === 'hug' && styles.hug, grow === 'fill' && styles.fill, xcss),
        testId: testId,
        ref: ref,
        children: children
    }));
}));
Inline.displayName = 'Inline';
exports.default = Inline;

},{"@swc/helpers/_/_object_spread":"9gdrV","@swc/helpers/_/_object_spread_props":"kANqQ","@swc/helpers/_/_object_without_properties":"6HqIM","react/jsx-runtime":"bGvcw","react":"ltHCL","@compiled/react/runtime":"d27Vo","@atlaskit/css":"kMGms","./flex":"9doqK","@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"kMGms":[function(require,module,exports,__globalThis) {
/* index.tsx generated by @compiled/babel-plugin v0.39.1 */ var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "jsx", ()=>(0, _react1.jsx));
parcelHelpers.export(exports, "css", ()=>css);
parcelHelpers.export(exports, "cssMap", ()=>cssMap);
parcelHelpers.export(exports, "cx", ()=>cx);
var _react = require("react");
var _react1 = require("@compiled/react");
const strictApi = (0, _react1.createStrictAPI)();
const css = strictApi.css;
const cssMap = strictApi.cssMap;
strictApi.cssMap;
const cx = strictApi.cx;
const XCSSProp = strictApi.XCSSProp;

},{"react":"ltHCL","@compiled/react":"MfI9Z","@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"MfI9Z":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "ClassNames", ()=>(0, _indexJs.ClassNames));
parcelHelpers.export(exports, "createStrictAPI", ()=>(0, _indexJs1.createStrictAPI));
parcelHelpers.export(exports, "css", ()=>(0, _indexJsDefault.default));
parcelHelpers.export(exports, "cssMap", ()=>(0, _indexJsDefault1.default));
parcelHelpers.export(exports, "keyframes", ()=>(0, _indexJs4.keyframes));
parcelHelpers.export(exports, "styled", ()=>(0, _indexJs5.styled));
parcelHelpers.export(exports, "cx", ()=>(0, _indexJs6.cx));
parcelHelpers.export(exports, "jsx", ()=>jsx);
var _react = require("react");
var _indexJs = require("./class-names/index.js");
var _indexJs1 = require("./create-strict-api/index.js");
var _indexJs2 = require("./css/index.js");
var _indexJsDefault = parcelHelpers.interopDefault(_indexJs2);
var _indexJs3 = require("./css-map/index.js");
var _indexJsDefault1 = parcelHelpers.interopDefault(_indexJs3);
var _indexJs4 = require("./keyframes/index.js");
var _indexJs5 = require("./styled/index.js");
var _indexJs6 = require("./xcss-prop/index.js");
const jsx = (0, _react.createElement);

},{"react":"ltHCL","./class-names/index.js":false,"./create-strict-api/index.js":"asN8e","./css/index.js":false,"./css-map/index.js":false,"./keyframes/index.js":false,"./styled/index.js":false,"./xcss-prop/index.js":"1GqFw","@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"asN8e":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
/**
 * ## Create Strict API
 *
 * Returns a strict subset of Compiled APIs augmented by a type definition.
 * This API does not change Compileds build time behavior — merely augmenting
 * the returned API types which enforce:
 *
 * - all APIs use object types
 * - property values declared in the type definition must be used (else fallback to defaults)
 * - a strict subset of pseudo states/selectors
 * - unknown properties to be a type violation
 *
 * To set up:
 *
 * 1. Declare the API in a module (either local or in a package), optionally declaring accepted media queries.
 *
 * @example
 * ```tsx
 * // ./foo.ts
 * interface Schema {
 *   color: 'var(--ds-text)',
 *   '&:hover': { color: 'var(--ds-text-hover)' }
 * }
 *
 * const { css, cssMap, XCSSProp, cx } = createStrictAPI<Schema, { media: '(min-width: 30rem)' }>();
 *
 * export { css, cssMap, XCSSProp, cx };
 * ```
 *
 * 2. Configure Compiled to pick up this module:
 *
 * @example
 * ```diff
 * // .compiledcssrc
 * {
 * +  "importSources": ["./foo.ts"]
 * }
 * ```
 *
 * 3. Use the module in your application code:
 *
 * @example
 * ```tsx
 * import { css } from './foo';
 *
 * const styles = css({ color: 'var(--ds-text)' });
 *
 * <div css={styles} />
 * ```
 */ parcelHelpers.export(exports, "createStrictAPI", ()=>createStrictAPI);
var _errorJs = require("../utils/error.js");
var _indexJs = require("../xcss-prop/index.js");
function createStrictAPI() {
    return {
        css () {
            throw (0, _errorJs.createStrictSetupError)();
        },
        cssMap () {
            throw (0, _errorJs.createStrictSetupError)();
        },
        cx: (0, _indexJs.cx),
        XCSSProp () {
            throw (0, _errorJs.createStrictSetupError)();
        }
    };
}

},{"../utils/error.js":"oNbvf","../xcss-prop/index.js":"1GqFw","@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"oNbvf":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "createSetupError", ()=>createSetupError);
parcelHelpers.export(exports, "createStrictSetupError", ()=>createStrictSetupError);
const createSetupError = ()=>{
    return new Error(`
 \u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2557} \u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2557} \u{2588}\u{2588}\u{2588}\u{2557}   \u{2588}\u{2588}\u{2588}\u{2557}\u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2557} \u{2588}\u{2588}\u{2557}\u{2588}\u{2588}\u{2557}     \u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2557}\u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2557}
\u{2588}\u{2588}\u{2554}\u{2550}\u{2550}\u{2550}\u{2550}\u{255D}\u{2588}\u{2588}\u{2554}\u{2550}\u{2550}\u{2550}\u{2588}\u{2588}\u{2557}\u{2588}\u{2588}\u{2588}\u{2588}\u{2557} \u{2588}\u{2588}\u{2588}\u{2588}\u{2551}\u{2588}\u{2588}\u{2554}\u{2550}\u{2550}\u{2588}\u{2588}\u{2557}\u{2588}\u{2588}\u{2551}\u{2588}\u{2588}\u{2551}     \u{2588}\u{2588}\u{2554}\u{2550}\u{2550}\u{2550}\u{2550}\u{255D}\u{2588}\u{2588}\u{2554}\u{2550}\u{2550}\u{2588}\u{2588}\u{2557}
\u{2588}\u{2588}\u{2551}     \u{2588}\u{2588}\u{2551}   \u{2588}\u{2588}\u{2551}\u{2588}\u{2588}\u{2554}\u{2588}\u{2588}\u{2588}\u{2588}\u{2554}\u{2588}\u{2588}\u{2551}\u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2554}\u{255D}\u{2588}\u{2588}\u{2551}\u{2588}\u{2588}\u{2551}     \u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2557}  \u{2588}\u{2588}\u{2551}  \u{2588}\u{2588}\u{2551}
\u{2588}\u{2588}\u{2551}     \u{2588}\u{2588}\u{2551}   \u{2588}\u{2588}\u{2551}\u{2588}\u{2588}\u{2551}\u{255A}\u{2588}\u{2588}\u{2554}\u{255D}\u{2588}\u{2588}\u{2551}\u{2588}\u{2588}\u{2554}\u{2550}\u{2550}\u{2550}\u{255D} \u{2588}\u{2588}\u{2551}\u{2588}\u{2588}\u{2551}     \u{2588}\u{2588}\u{2554}\u{2550}\u{2550}\u{255D}  \u{2588}\u{2588}\u{2551}  \u{2588}\u{2588}\u{2551}
\u{255A}\u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2557}\u{255A}\u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2554}\u{255D}\u{2588}\u{2588}\u{2551} \u{255A}\u{2550}\u{255D} \u{2588}\u{2588}\u{2551}\u{2588}\u{2588}\u{2551}     \u{2588}\u{2588}\u{2551}\u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2557}\u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2557}\u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2554}\u{255D}
 \u{255A}\u{2550}\u{2550}\u{2550}\u{2550}\u{2550}\u{255D} \u{255A}\u{2550}\u{2550}\u{2550}\u{2550}\u{2550}\u{255D} \u{255A}\u{2550}\u{255D}     \u{255A}\u{2550}\u{255D}\u{255A}\u{2550}\u{255D}     \u{255A}\u{2550}\u{255D}\u{255A}\u{2550}\u{2550}\u{2550}\u{2550}\u{2550}\u{2550}\u{255D}\u{255A}\u{2550}\u{2550}\u{2550}\u{2550}\u{2550}\u{2550}\u{255D}\u{255A}\u{2550}\u{2550}\u{2550}\u{2550}\u{2550}\u{255D}

  @compiled/react

  Code was executed when it shouldn't have. This could have happened because:

  1. You haven't configured a transformer yet. Visit https://compiledcssinjs.com/docs/installation and follow the instructions.
  2. You have duplicate versions of React and hooks are blowing up. You need to de-duplicate your dependencies.

  Good luck!
`);
};
const createStrictSetupError = ()=>{
    return new Error(`
 \u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2557} \u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2557} \u{2588}\u{2588}\u{2588}\u{2557}   \u{2588}\u{2588}\u{2588}\u{2557}\u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2557} \u{2588}\u{2588}\u{2557}\u{2588}\u{2588}\u{2557}     \u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2557}\u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2557}
\u{2588}\u{2588}\u{2554}\u{2550}\u{2550}\u{2550}\u{2550}\u{255D}\u{2588}\u{2588}\u{2554}\u{2550}\u{2550}\u{2550}\u{2588}\u{2588}\u{2557}\u{2588}\u{2588}\u{2588}\u{2588}\u{2557} \u{2588}\u{2588}\u{2588}\u{2588}\u{2551}\u{2588}\u{2588}\u{2554}\u{2550}\u{2550}\u{2588}\u{2588}\u{2557}\u{2588}\u{2588}\u{2551}\u{2588}\u{2588}\u{2551}     \u{2588}\u{2588}\u{2554}\u{2550}\u{2550}\u{2550}\u{2550}\u{255D}\u{2588}\u{2588}\u{2554}\u{2550}\u{2550}\u{2588}\u{2588}\u{2557}
\u{2588}\u{2588}\u{2551}     \u{2588}\u{2588}\u{2551}   \u{2588}\u{2588}\u{2551}\u{2588}\u{2588}\u{2554}\u{2588}\u{2588}\u{2588}\u{2588}\u{2554}\u{2588}\u{2588}\u{2551}\u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2554}\u{255D}\u{2588}\u{2588}\u{2551}\u{2588}\u{2588}\u{2551}     \u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2557}  \u{2588}\u{2588}\u{2551}  \u{2588}\u{2588}\u{2551}
\u{2588}\u{2588}\u{2551}     \u{2588}\u{2588}\u{2551}   \u{2588}\u{2588}\u{2551}\u{2588}\u{2588}\u{2551}\u{255A}\u{2588}\u{2588}\u{2554}\u{255D}\u{2588}\u{2588}\u{2551}\u{2588}\u{2588}\u{2554}\u{2550}\u{2550}\u{2550}\u{255D} \u{2588}\u{2588}\u{2551}\u{2588}\u{2588}\u{2551}     \u{2588}\u{2588}\u{2554}\u{2550}\u{2550}\u{255D}  \u{2588}\u{2588}\u{2551}  \u{2588}\u{2588}\u{2551}
\u{255A}\u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2557}\u{255A}\u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2554}\u{255D}\u{2588}\u{2588}\u{2551} \u{255A}\u{2550}\u{255D} \u{2588}\u{2588}\u{2551}\u{2588}\u{2588}\u{2551}     \u{2588}\u{2588}\u{2551}\u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2557}\u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2557}\u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2554}\u{255D}
 \u{255A}\u{2550}\u{2550}\u{2550}\u{2550}\u{2550}\u{255D} \u{255A}\u{2550}\u{2550}\u{2550}\u{2550}\u{2550}\u{255D} \u{255A}\u{2550}\u{255D}     \u{255A}\u{2550}\u{255D}\u{255A}\u{2550}\u{255D}     \u{255A}\u{2550}\u{255D}\u{255A}\u{2550}\u{2550}\u{2550}\u{2550}\u{2550}\u{2550}\u{255D}\u{255A}\u{2550}\u{2550}\u{2550}\u{2550}\u{2550}\u{2550}\u{255D}\u{255A}\u{2550}\u{2550}\u{2550}\u{2550}\u{2550}\u{255D}

  @compiled/react

  Code was executed when it shouldn't have. To resolve make sure to:

  1. Set up Compiled.
  2. Configure importSources in your Compiled config to point to the module that exports the output of createStrictAPI().

  For more information visit https://compiledcssinjs.com/docs/installation and follow the instructions.
`);
};

},{"@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"1GqFw":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "cx", ()=>cx);
var _runtimeJs = require("../runtime.js");
const cx = (...styles)=>{
    // At runtime TStyles is resolved down to strings, but not at compile time.
    // We circumvent the type system here because of that.
    const actualStyles = styles;
    // The output should be a union type of passed in styles. This ensures the call
    // site of xcss prop can raise violations when disallowed styles have been passed.
    return (0, _runtimeJs.ax)(actualStyles);
};

},{"../runtime.js":"d27Vo","@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"9doqK":[function(require,module,exports,__globalThis) {
/* flex.tsx generated by @compiled/babel-plugin v0.39.1 */ var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _objectSpread = require("@swc/helpers/_/_object_spread");
var _objectSpreadProps = require("@swc/helpers/_/_object_spread_props");
var _objectWithoutProperties = require("@swc/helpers/_/_object_without_properties");
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _runtime = require("@compiled/react/runtime");
const rowGapMap = {
    'space.0': "_1p57ze3t",
    'space.025': "_1p57v77o",
    'space.050': "_1p571b66",
    'space.075': "_1p5712x7",
    'space.100': "_1p57u2gc",
    'space.150': "_1p57utpp",
    'space.200': "_1p57pxbi",
    'space.250': "_1p57v47k",
    'space.300': "_1p571ejb",
    'space.400': "_1p57xy5q",
    'space.500': "_1p571jfw",
    'space.600': "_1p57oahv",
    'space.800': "_1p57xncg",
    'space.1000': "_1p571epz"
};
const columnGapMap = {
    'space.0': "_gy1pze3t",
    'space.025': "_gy1pv77o",
    'space.050': "_gy1p1b66",
    'space.075': "_gy1p12x7",
    'space.100': "_gy1pu2gc",
    'space.150': "_gy1putpp",
    'space.200': "_gy1ppxbi",
    'space.250': "_gy1pv47k",
    'space.300': "_gy1p1ejb",
    'space.400': "_gy1pxy5q",
    'space.500': "_gy1p1jfw",
    'space.600': "_gy1poahv",
    'space.800': "_gy1pxncg",
    'space.1000': "_gy1p1epz"
};
const justifyContentMap = {
    start: "_1bahv2br",
    center: "_1bah1h6o",
    end: "_1bahh9n0",
    'space-between': "_1bah1yb4",
    'space-around': "_1bah1b1v",
    'space-evenly': "_1bahitcz",
    stretch: "_1bah1fhb"
};
const flexDirectionMap = {
    column: "_2lx21bp4",
    row: "_2lx2vrvc"
};
const flexWrapMap = {
    wrap: "_1n261g80",
    nowrap: "_1n261q9c"
};
const alignItemsMap = {
    start: "_4cvrv2br",
    center: "_4cvr1h6o",
    baseline: "_4cvr1q9y",
    end: "_4cvrh9n0",
    stretch: "_4cvr1fhb"
};
const styles = {
    root: "_1e0c1txw _vchhusvi"
};
/**
 * __Flex__
 *
 * `Flex` is a primitive component that implements the CSS Flexbox API.
 *
 * - [Examples](https://atlassian.design/components/primitives/flex/examples)
 * - [Code](https://atlassian.design/components/primitives/flex/code)
 *
 * @example
 * ```tsx
 * import { Box } from '@atlaskit/primitives/compiled'
 * import { Flex } from '@atlaskit/primitives/compiled/flex'
 *
 * const Component = () => (
 *   <Flex direction="column">
 *     <Box padding="space.100" backgroundColor="neutral"></Box>
 *     <Box padding="space.100" backgroundColor="neutral"></Box>
 *   </Flex>
 * )
 * ```
 */ const Flex = /*#__PURE__*/ (0, _react.memo)(/*#__PURE__*/ (0, _react.forwardRef)((_param, ref)=>{
    var { as: Component = 'div', role, alignItems, justifyContent, gap, columnGap, rowGap, children, testId, direction, wrap, xcss } = _param, ariaAttributes = (0, _objectWithoutProperties._)(_param, [
        "as",
        "role",
        "alignItems",
        "justifyContent",
        "gap",
        "columnGap",
        "rowGap",
        "children",
        "testId",
        "direction",
        "wrap",
        "xcss"
    ]);
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)(Component, (0, _objectSpreadProps._)((0, _objectSpread._)({}, ariaAttributes), {
        role: role,
        className: (0, _runtime.ax)([
            styles.root,
            gap && columnGapMap[gap],
            columnGap && columnGapMap[columnGap],
            gap && rowGapMap[gap],
            rowGap && rowGapMap[rowGap],
            alignItems && alignItemsMap[alignItems],
            direction && flexDirectionMap[direction],
            justifyContent && justifyContentMap[justifyContent],
            wrap && flexWrapMap[wrap],
            xcss
        ]),
        "data-testid": testId,
        ref: ref,
        children: children
    }));
}));
Flex.displayName = 'Flex';
exports.default = Flex;

},{"@swc/helpers/_/_object_spread":"9gdrV","@swc/helpers/_/_object_spread_props":"kANqQ","@swc/helpers/_/_object_without_properties":"6HqIM","react/jsx-runtime":"bGvcw","react":"ltHCL","@compiled/react/runtime":"d27Vo","@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"3D5Ti":[function(require,module,exports,__globalThis) {
/* stack.tsx generated by @compiled/babel-plugin v0.39.1 */ var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _objectSpread = require("@swc/helpers/_/_object_spread");
var _objectSpreadProps = require("@swc/helpers/_/_object_spread_props");
var _objectWithoutProperties = require("@swc/helpers/_/_object_without_properties");
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _css = require("@atlaskit/css");
var _flex = require("./flex");
var _flexDefault = parcelHelpers.interopDefault(_flex);
const styles = {
    hug: "_16jlidpf",
    fill: "_1bsb1osq _16jlkb7n"
};
/**
 * __Stack__
 *
 * Stack is a primitive component based on flexbox that manages the block layout of direct children.
 *
 * @example
 * ```tsx
 *  <Stack>
 *    <Box padding="space.100" backgroundColor="neutral"></Box>
 *    <Box padding="space.100" backgroundColor="neutral"></Box>
 *  </Stack>
 * ```
 *
 */ const Stack = /*#__PURE__*/ (0, _react.memo)(/*#__PURE__*/ (0, _react.forwardRef)((_param, ref)=>{
    var { as, alignInline: alignItems, alignBlock = 'stretch', spread, grow, space, children, testId, xcss, role } = _param, ariaAttributes = (0, _objectWithoutProperties._)(_param, [
        "as",
        "alignInline",
        "alignBlock",
        "spread",
        "grow",
        "space",
        "children",
        "testId",
        "xcss",
        "role"
    ]);
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _flexDefault.default), (0, _objectSpreadProps._)((0, _objectSpread._)({}, ariaAttributes), {
        as: as,
        role: role,
        gap: space,
        direction: "column",
        alignItems: alignItems,
        justifyContent: spread || alignBlock,
        xcss: (0, _css.cx)(grow === 'hug' && styles.hug, grow === 'fill' && styles.fill, xcss),
        testId: testId,
        ref: ref,
        children: children
    }));
}));
Stack.displayName = 'Stack';
exports.default = Stack;

},{"@swc/helpers/_/_object_spread":"9gdrV","@swc/helpers/_/_object_spread_props":"kANqQ","@swc/helpers/_/_object_without_properties":"6HqIM","react/jsx-runtime":"bGvcw","react":"ltHCL","@atlaskit/css":"kMGms","./flex":"9doqK","@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"vXS5Z":[function(require,module,exports,__globalThis) {
/* grid.tsx generated by @compiled/babel-plugin v0.39.1 */ var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _runtime = require("@compiled/react/runtime");
const rowGapMap = {
    'space.0': "_1p57ze3t",
    'space.025': "_1p57v77o",
    'space.050': "_1p571b66",
    'space.075': "_1p5712x7",
    'space.100': "_1p57u2gc",
    'space.150': "_1p57utpp",
    'space.200': "_1p57pxbi",
    'space.250': "_1p57v47k",
    'space.300': "_1p571ejb",
    'space.400': "_1p57xy5q",
    'space.500': "_1p571jfw",
    'space.600': "_1p57oahv",
    'space.800': "_1p57xncg",
    'space.1000': "_1p571epz"
};
const columnGapMap = {
    'space.0': "_gy1pze3t",
    'space.025': "_gy1pv77o",
    'space.050': "_gy1p1b66",
    'space.075': "_gy1p12x7",
    'space.100': "_gy1pu2gc",
    'space.150': "_gy1putpp",
    'space.200': "_gy1ppxbi",
    'space.250': "_gy1pv47k",
    'space.300': "_gy1p1ejb",
    'space.400': "_gy1pxy5q",
    'space.500': "_gy1p1jfw",
    'space.600': "_gy1poahv",
    'space.800': "_gy1pxncg",
    'space.1000': "_gy1p1epz"
};
const justifyContentMap = {
    start: "_1bahv2br",
    center: "_1bah1h6o",
    end: "_1bahh9n0",
    'space-between': "_1bah1yb4",
    'space-around': "_1bah1b1v",
    'space-evenly': "_1bahitcz",
    stretch: "_1bah1fhb"
};
const alignContentMap = {
    start: "_ae4vv2br",
    center: "_ae4v1h6o",
    end: "_ae4vh9n0",
    'space-between': "_ae4v1yb4",
    'space-around': "_ae4v1b1v",
    'space-evenly': "_ae4vitcz",
    stretch: "_ae4v1fhb"
};
const alignItemsMap = {
    start: "_4cvrv2br",
    center: "_4cvr1h6o",
    baseline: "_4cvr1q9y",
    end: "_4cvrh9n0",
    stretch: "_4cvr1fhb"
};
const baseStyles = {
    root: "_1e0c11p5 _vchhusvi"
};
const gridAutoFlowMap = {
    row: "_wij2vrvc",
    column: "_wij21bp4",
    dense: "_wij218l3",
    'row dense': "_wij2j5tq",
    'column dense': "_wij2adhi"
};
/**
 * __Grid__
 *
 * `Grid` is a primitive component that implements the CSS Grid API.
 *
 * - [Examples](https://atlassian.design/components/primitives/grid/examples)
 * - [Code](https://atlassian.design/components/primitives/grid/code)
 *
 * @example
 * ```tsx
 * import { Box } from '@atlaskit/primitives/compiled'
 * import { Grid } from '@atlaskit/primitives/compiled/grid'
 *
 * const Component = () => (
 *   <Grid gap="space.100" gridColumns="1fr 1fr">
 *     <Box padding="space.100" backgroundColor="neutral"></Box>
 *     <Box padding="space.100" backgroundColor="neutral"></Box>
 *   </Grid>
 * )
 * ```
 */ const Grid = /*#__PURE__*/ (0, _react.memo)(/*#__PURE__*/ (0, _react.forwardRef)(({ as, alignItems, alignContent, justifyContent, gap, columnGap, rowGap, children, id, role, testId, autoFlow, xcss }, ref)=>{
    const Component = as || 'div';
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)(Component, {
        id: id,
        role: role,
        className: (0, _runtime.ax)([
            baseStyles.root,
            gap && columnGapMap[gap],
            columnGap && columnGapMap[columnGap],
            gap && rowGapMap[gap],
            rowGap && rowGapMap[rowGap],
            alignItems && alignItemsMap[alignItems],
            alignContent && alignContentMap[alignContent],
            justifyContent && justifyContentMap[justifyContent],
            autoFlow && gridAutoFlowMap[autoFlow],
            xcss
        ]),
        "data-testid": testId,
        ref: ref,
        children: children
    });
}));
Grid.displayName = 'Grid';
exports.default = Grid;

},{"react/jsx-runtime":"bGvcw","react":"ltHCL","@compiled/react/runtime":"d27Vo","@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"fZFvp":[function(require,module,exports,__globalThis) {
/* bleed.tsx generated by @compiled/babel-plugin v0.39.1 */ var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _jsxRuntime = require("react/jsx-runtime");
var _runtime = require("@compiled/react/runtime");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
// NOTE: This maintains a full map of 10 styles as Bleed is a bit of a semantic outlier
const styles = {
    root: "_vchhusvi",
    'inline.space.025': "_195g4pxn",
    'inline.space.050': "_195ggp71",
    'inline.space.100': "_195gtdkl",
    'inline.space.150': "_195gkqjj",
    'inline.space.200': "_195g1e8l",
    'block.space.025': "_1mou4pxn",
    'block.space.050': "_1mougp71",
    'block.space.100': "_1moutdkl",
    'block.space.150': "_1moukqjj",
    'block.space.200': "_1mou1e8l"
};
/**
 * __Bleed__
 *
 * `Bleed` is a primitive layout component that controls negative whitespace.
 *
 * - [Examples](https://atlassian.design/components/primitives/bleed/examples)
 * - [Code](https://atlassian.design/components/primitives/bleed/code)
 */ const Bleed = /*#__PURE__*/ (0, _reactDefault.default).memo(({ children, testId, inline, block, all, xcss })=>{
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
        className: (0, _runtime.ax)([
            styles.root,
            all && styles[`inline.${all}`],
            inline && styles[`inline.${inline}`],
            all && styles[`block.${all}`],
            block && styles[`block.${block}`],
            xcss
        ]),
        "data-testid": testId,
        children: children
    });
});
Bleed.displayName = 'Bleed';
exports.default = Bleed;

},{"react/jsx-runtime":"bGvcw","@compiled/react/runtime":"d27Vo","react":"ltHCL","@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"iDpYp":[function(require,module,exports,__globalThis) {
/* text.tsx generated by @compiled/babel-plugin v0.39.1 */ var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "inverseColorMap", ()=>inverseColorMap);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _runtime = require("@compiled/react/runtime");
var _tinyInvariant = require("tiny-invariant");
var _tinyInvariantDefault = parcelHelpers.interopDefault(_tinyInvariant);
var _hasTextAncestorContext = require("../../utils/has-text-ancestor-context");
var _surfaceProvider = require("../../utils/surface-provider");
const asAllowlist = [
    'span',
    'p',
    'strong',
    'em'
];
/**
 * Custom hook designed to abstract the parsing of the color props and make it clearer in the future how color is reconciled between themes and tokens.
 */ const useColor = (colorProp, hasTextAncestor)=>{
    const surface = (0, _surfaceProvider.useSurface)();
    if (colorProp === 'inherit') return undefined;
    if (colorProp) return colorProp;
    if (hasTextAncestor) return undefined;
    if (inverseColorMap.hasOwnProperty(surface)) return inverseColorMap[surface];
    return 'color.text';
};
const styles = {
    root: "_19pkidpf _2hwxidpf _otyridpf _18u0idpf _1i4qfg65",
    'as.strong': "_k48pwu06",
    'as.em': "_zg8l1m30",
    'textAlign.center': "_y3gn1h6o",
    'textAlign.end': "_y3gnh9n0",
    'textAlign.start': "_y3gnv2br",
    truncation: "_1reo15vq _18m915vq _1e0ccj1k _sudp1e54",
    breakAll: "_1nmz9jpi"
};
const fontSizeMap = {
    medium: "_11c8fhey",
    large: "_11c81d4k",
    small: "_11c8wadc"
};
const fontWeightMap = {
    bold: "_k48pwu06",
    medium: "_k48p1wq8",
    regular: "_k48pi7a9",
    semibold: "_k48p1pd9"
};
const textColorMap = {
    'color.text': "_syazi7uo",
    'color.text.accent.lime': "_syaz1tco",
    'color.text.accent.lime.bolder': "_syaz1ik3",
    'color.text.accent.red': "_syaz9lu1",
    'color.text.accent.red.bolder': "_syazhwvp",
    'color.text.accent.orange': "_syazp1lv",
    'color.text.accent.orange.bolder': "_syaz7i1p",
    'color.text.accent.yellow': "_syazfb2s",
    'color.text.accent.yellow.bolder': "_syazekll",
    'color.text.accent.green': "_syazh55r",
    'color.text.accent.green.bolder': "_syaz1y78",
    'color.text.accent.teal': "_syaz17qg",
    'color.text.accent.teal.bolder': "_syaz12v7",
    'color.text.accent.blue': "_syaz16jw",
    'color.text.accent.blue.bolder': "_syaz1kyx",
    'color.text.accent.purple': "_syazqmo9",
    'color.text.accent.purple.bolder': "_syaz1mn1",
    'color.text.accent.magenta': "_syaz1s8m",
    'color.text.accent.magenta.bolder': "_syaz1qur",
    'color.text.accent.gray': "_syaz1sqi",
    'color.text.accent.gray.bolder': "_syaz1tmo",
    'color.text.disabled': "_syaz1gmx",
    'color.text.inverse': "_syaz15cr",
    'color.text.selected': "_syaz6x5g",
    'color.text.brand': "_syaz1oa5",
    'color.text.danger': "_syaz1tmw",
    'color.text.warning': "_syaz1xn9",
    'color.text.warning.inverse': "_syaz1yd3",
    'color.text.success': "_syazgsak",
    'color.text.discovery': "_syazdv2p",
    'color.text.information': "_syazu3tg",
    'color.text.subtlest': "_syaz1rpy",
    'color.text.subtle': "_syazazsu",
    'color.link': "_syaz13af",
    'color.link.pressed': "_syaz12zz",
    'color.link.visited': "_syaz1ra0",
    'color.link.visited.pressed': "_syaz17z1"
};
const inverseColorMap = {
    'color.background.neutral.bold': 'color.text.inverse',
    'color.background.neutral.bold.hovered': 'color.text.inverse',
    'color.background.neutral.bold.pressed': 'color.text.inverse',
    'color.background.selected.bold': 'color.text.inverse',
    'color.background.selected.bold.hovered': 'color.text.inverse',
    'color.background.selected.bold.pressed': 'color.text.inverse',
    'color.background.brand.bold': 'color.text.inverse',
    'color.background.brand.bold.hovered': 'color.text.inverse',
    'color.background.brand.bold.pressed': 'color.text.inverse',
    'color.background.brand.boldest': 'color.text.inverse',
    'color.background.brand.boldest.hovered': 'color.text.inverse',
    'color.background.brand.boldest.pressed': 'color.text.inverse',
    'color.background.danger.bold': 'color.text.inverse',
    'color.background.danger.bold.hovered': 'color.text.inverse',
    'color.background.danger.bold.pressed': 'color.text.inverse',
    'color.background.warning.bold': 'color.text.warning.inverse',
    'color.background.warning.bold.hovered': 'color.text.warning.inverse',
    'color.background.warning.bold.pressed': 'color.text.warning.inverse',
    'color.background.success.bold': 'color.text.inverse',
    'color.background.success.bold.hovered': 'color.text.inverse',
    'color.background.success.bold.pressed': 'color.text.inverse',
    'color.background.discovery.bold': 'color.text.inverse',
    'color.background.discovery.bold.hovered': 'color.text.inverse',
    'color.background.discovery.bold.pressed': 'color.text.inverse',
    'color.background.information.bold': 'color.text.inverse',
    'color.background.information.bold.hovered': 'color.text.inverse',
    'color.background.information.bold.pressed': 'color.text.inverse'
};
/**
 * __Text__
 *
 * Text is a primitive component that has the Atlassian Design System's design guidelines baked in.
 * This includes considerations for text attributes such as color, font size, font weight, and line height.
 * It renders a `span` by default.
 *
 * @internal
 */ const Text = /*#__PURE__*/ (0, _react.forwardRef)(({ as: Component = 'span', color: colorProp, align, testId, id, size, weight, maxLines, xcss, children }, ref)=>{
    (0, _tinyInvariantDefault.default)(asAllowlist.includes(Component), `@atlaskit/primitives: Text received an invalid "as" value of "${Component}"`);
    const hasTextAncestor = (0, _hasTextAncestorContext.useHasTextAncestor)();
    const color = useColor(colorProp, hasTextAncestor);
    if (!size && !hasTextAncestor) size = 'medium';
    const component = /*#__PURE__*/ (0, _jsxRuntime.jsx)(Component, {
        id: id,
        className: (0, _runtime.ax)([
            styles.root,
            size && fontSizeMap[size],
            color && textColorMap[color],
            maxLines && styles.truncation,
            maxLines === 1 && styles.breakAll,
            align && styles[`textAlign.${align}`],
            weight && fontWeightMap[weight],
            Component === 'em' && styles['as.em'],
            Component === 'strong' && styles['as.strong'],
            xcss
        ]),
        style: {
            WebkitLineClamp: maxLines
        },
        "data-testid": testId,
        ref: ref,
        children: children
    });
    if (hasTextAncestor) // no need to re-apply context if the text is already wrapped
    return component;
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _hasTextAncestorContext.HasTextAncestorProvider), {
        value: true,
        children: component
    });
});
// eslint-disable-next-line @atlaskit/volt-strict-mode/no-multiple-exports
exports.default = Text;

},{"react/jsx-runtime":"bGvcw","react":"ltHCL","@compiled/react/runtime":"d27Vo","tiny-invariant":"9VWeJ","../../utils/has-text-ancestor-context":"9Iq5i","../../utils/surface-provider":"1kmKD","@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"9Iq5i":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "useHasTextAncestor", ()=>useHasTextAncestor);
parcelHelpers.export(exports, "HasTextAncestorProvider", ()=>HasTextAncestorProvider);
var _react = require("react");
const HasTextAncestorContext = /*#__PURE__*/ (0, _react.createContext)(false);
const useHasTextAncestor = ()=>(0, _react.useContext)(HasTextAncestorContext);
const HasTextAncestorProvider = HasTextAncestorContext.Provider;

},{"react":"ltHCL","@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"1kmKD":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "SurfaceContext", ()=>(0, _surfaceContext.SurfaceContext));
parcelHelpers.export(exports, "useSurface", ()=>useSurface);
var _react = require("react");
var _surfaceContext = require("./surface-context");
const useSurface = ()=>{
    return (0, _react.useContext)((0, _surfaceContext.SurfaceContext));
};
(0, _surfaceContext.SurfaceContext).displayName = 'SurfaceProvider';

},{"react":"ltHCL","./surface-context":"a2y1l","@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"iTONZ":[function(require,module,exports,__globalThis) {
/* pressable.tsx generated by @compiled/babel-plugin v0.39.1 */ var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _objectSpread = require("@swc/helpers/_/_object_spread");
var _objectSpreadProps = require("@swc/helpers/_/_object_spread_props");
var _objectWithoutProperties = require("@swc/helpers/_/_object_without_properties");
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _react1 = require("@compiled/react");
var _analyticsNext = require("@atlaskit/analytics-next");
var _isSafari = require("@atlaskit/ds-lib/is-safari");
var _noop = require("@atlaskit/ds-lib/noop");
var _noopDefault = parcelHelpers.interopDefault(_noop);
var _interactionContext = require("@atlaskit/interaction-context");
var _interactionContextDefault = parcelHelpers.interopDefault(_interactionContext);
var _focusable = require("./focusable");
var _focusableDefault = parcelHelpers.interopDefault(_focusable);
const styles = {
    root: "_19itglyw _vchhusvi _r06hglyw _80omtlke",
    disabled: "_80om13gf"
};
/**
 * __Pressable__
 *
 * A primitive for building custom buttons.
 *
 * - [Examples](https://atlassian.design/components/primitives/pressable/examples)
 * - [Code](https://atlassian.design/components/primitives/pressable/code)
 * - [Usage](https://atlassian.design/components/primitives/pressable/usage)
 */ const Pressable = /*#__PURE__*/ (0, _react.forwardRef)((_param, ref)=>{
    var { children, isDisabled, type = 'button', onClick: providedOnClick = (0, _noopDefault.default), interactionName, componentName, analyticsContext, style, testId, xcss, tabIndex } = _param, htmlAttributes = (0, _objectWithoutProperties._)(_param, [
        "children",
        "isDisabled",
        "type",
        "onClick",
        "interactionName",
        "componentName",
        "analyticsContext",
        "style",
        "testId",
        "xcss",
        "tabIndex"
    ]);
    const interactionContext = (0, _react.useContext)((0, _interactionContextDefault.default));
    const handleClick = (0, _react.useCallback)((e, analyticsEvent)=>{
        interactionContext && interactionContext.tracePress(interactionName, e.timeStamp);
        providedOnClick(e, analyticsEvent);
    }, [
        providedOnClick,
        interactionContext,
        interactionName
    ]);
    const onClick = (0, _analyticsNext.usePlatformLeafEventHandler)({
        fn: handleClick,
        action: 'clicked',
        componentName: componentName || 'Pressable',
        packageName: "@af/atlassian-studio",
        packageVersion: "0.16.1",
        analyticsData: analyticsContext,
        actionSubject: 'button'
    });
    // This is to remove className from safeHtmlAttributes
    // @ts-expect-error className doesn't exist in the prop definition but we want to ensure it cannot be applied even if types are bypassed
    const { className: _spreadClass } = htmlAttributes, safeHtmlAttributes = (0, _objectWithoutProperties._)(htmlAttributes, [
        "className"
    ]);
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _focusableDefault.default), (0, _objectSpreadProps._)((0, _objectSpread._)({
        // @ts-ignore -- not using expect since it causes issues with help-center local consumption - we don't allow `button` on Focusable for makers as they should use Pressable instead
        as: "button",
        // Safari does not apply focus to buttons on click like other browsers, which means click events will not be fired.
        // Adding a tabIndex of 0 to the button will allow it to be focused on click.
        // This is a known issue in Safari that is meant to be "intended", see https://bugs.webkit.org/show_bug.cgi?id=22261
        tabIndex: tabIndex !== null && tabIndex !== void 0 ? tabIndex : (0, _isSafari.isSafari)() && !isDisabled ? 0 : undefined,
        style: style
    }, safeHtmlAttributes), {
        type: type,
        onClick: onClick,
        disabled: isDisabled,
        xcss: (0, _react1.cx)(styles.root, isDisabled && styles.disabled, xcss),
        testId: testId,
        ref: ref,
        children: children
    }));
});
exports.default = Pressable;

},{"@swc/helpers/_/_object_spread":"9gdrV","@swc/helpers/_/_object_spread_props":"kANqQ","@swc/helpers/_/_object_without_properties":"6HqIM","react/jsx-runtime":"bGvcw","react":"ltHCL","@compiled/react":"MfI9Z","@atlaskit/analytics-next":"6PLie","@atlaskit/ds-lib/is-safari":"kZLd6","@atlaskit/ds-lib/noop":"faKzG","@atlaskit/interaction-context":"18HT9","./focusable":"h97Ae","@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"kZLd6":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "isSafari", ()=>isSafari);
function isSafari() {
    if (typeof window !== 'undefined' && window.navigator != null) {
        var _window_navigator_userAgent;
        const ua = (_window_navigator_userAgent = window.navigator.userAgent) === null || _window_navigator_userAgent === void 0 ? void 0 : _window_navigator_userAgent.toLowerCase();
        return ua ? ua.includes('safari') && !ua.includes('chrome') : false;
    }
    return false;
}

},{"@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"faKzG":[function(require,module,exports,__globalThis) {
/**
 * An empty function which does nothing.
 */ var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>noop);
function noop() {}

},{"@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"h97Ae":[function(require,module,exports,__globalThis) {
/* focusable.tsx generated by @compiled/babel-plugin v0.39.1 */ var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _objectSpread = require("@swc/helpers/_/_object_spread");
var _objectSpreadProps = require("@swc/helpers/_/_object_spread_props");
var _objectWithoutProperties = require("@swc/helpers/_/_object_without_properties");
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _runtime = require("@compiled/react/runtime");
const focusRingStyles = null;
const insetFocusRingStyles = null;
/**
 * __Focus ring__
 *
 * A focus ring visually indicates the currently focused item.
 *
 */ const Focusable = /*#__PURE__*/ (0, _react.forwardRef)((_param, ref)=>{
    var { as: Component = 'button', children, isInset, testId, style, xcss } = _param, htmlAttributes = (0, _objectWithoutProperties._)(_param, [
        "as",
        "children",
        "isInset",
        "testId",
        "style",
        "xcss"
    ]);
    // This is to remove className from safeHtmlAttributes
    // @ts-ignore -- not using expect since it causes issues with help-center local consumption - className doesn't exist in the prop definition but we want to ensure it cannot be applied even if types are bypassed
    const { className: _spreadClass } = htmlAttributes, safeHtmlAttributes = (0, _objectWithoutProperties._)(htmlAttributes, [
        "className"
    ]);
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)(Component, (0, _objectSpreadProps._)((0, _objectSpread._)({}, safeHtmlAttributes), {
        // @ts-ignore Expression produces a union type that is too complex to represent. We may be able to narrow the type here but unsure.
        ref: ref,
        className: (0, _runtime.ax)([
            "_ymio1r31 _ypr0glyw _zcxs1o36 _mizu194a _1ah3dkaa _ra3xnqa1 _128mdkaa _1cvmnqa1 _4davt94y",
            isInset && "_1ah31gjf _2mwq1gjf",
            xcss
        ]),
        style: style,
        "data-testid": testId,
        children: children
    }));
});
exports.default = Focusable;

},{"@swc/helpers/_/_object_spread":"9gdrV","@swc/helpers/_/_object_spread_props":"kANqQ","@swc/helpers/_/_object_without_properties":"6HqIM","react/jsx-runtime":"bGvcw","react":"ltHCL","@compiled/react/runtime":"d27Vo","@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"lL0r0":[function(require,module,exports,__globalThis) {
/* anchor.tsx generated by @compiled/babel-plugin v0.39.1 */ var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _objectSpread = require("@swc/helpers/_/_object_spread");
var _objectSpreadProps = require("@swc/helpers/_/_object_spread_props");
var _objectWithoutProperties = require("@swc/helpers/_/_object_without_properties");
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _react1 = require("@compiled/react");
var _tinyInvariant = require("tiny-invariant");
var _tinyInvariantDefault = parcelHelpers.interopDefault(_tinyInvariant);
var _analyticsNext = require("@atlaskit/analytics-next");
var _appProvider = require("@atlaskit/app-provider");
var _noop = require("@atlaskit/ds-lib/noop");
var _noopDefault = parcelHelpers.interopDefault(_noop);
var _useId = require("@atlaskit/ds-lib/use-id");
var _interactionContext = require("@atlaskit/interaction-context");
var _interactionContextDefault = parcelHelpers.interopDefault(_interactionContext);
var _visuallyHidden = require("@atlaskit/visually-hidden");
var _visuallyHiddenDefault = parcelHelpers.interopDefault(_visuallyHidden);
var _focusable = require("./focusable");
var _focusableDefault = parcelHelpers.interopDefault(_focusable);
const styles = {
    root: "_4bfu1r31 _1hms8stv _ajmmnqa1 _vchhusvi",
    position: "_kqswh2mm"
};
const IS_EXTERNAL_LINK_REGEX = /^(?:(http|https):\/\/)/;
const IS_NON_HTTP_BASED = /^(((mailto|tel|sms|blob):)|(#))/;
/**
 * __Anchor__
 *
 * A primitive for building custom anchor links.
 *
 * - [Examples](https://atlassian.design/components/primitives/anchor/examples)
 * - [Code](https://atlassian.design/components/primitives/anchor/code)
 * - [Usage](https://atlassian.design/components/primitives/anchor/usage)
 */ const AnchorNoRef = (_param, ref)=>{
    var { href, children, onClick: providedOnClick = (0, _noopDefault.default), interactionName, componentName, analyticsContext, 'aria-label': ariaLabel, 'aria-labelledby': ariaLabelledBy, style, target, testId, xcss, newWindowLabel = '(opens new window)' } = _param, htmlAttributes = (0, _objectWithoutProperties._)(_param, [
        "href",
        "children",
        "onClick",
        "interactionName",
        "componentName",
        "analyticsContext",
        'aria-label',
        'aria-labelledby',
        "style",
        "target",
        "testId",
        "xcss",
        "newWindowLabel"
    ]);
    const interactionContext = (0, _react.useContext)((0, _interactionContextDefault.default));
    const handleClick = (0, _react.useCallback)((e, analyticsEvent)=>{
        interactionContext && interactionContext.tracePress(interactionName, e.timeStamp);
        providedOnClick(e, analyticsEvent);
    }, [
        providedOnClick,
        interactionContext,
        interactionName
    ]);
    const opensNewWindowLabelId = (0, _useId.useId)();
    const onClick = (0, _analyticsNext.usePlatformLeafEventHandler)({
        fn: handleClick,
        action: 'clicked',
        componentName: componentName || 'Anchor',
        packageName: "@af/atlassian-studio",
        packageVersion: "0.16.1",
        analyticsData: analyticsContext,
        actionSubject: 'link'
    });
    // This is to remove className from safeHtmlAttributes
    // @ts-expect-error className doesn't exist in the prop definition but we want to ensure it cannot be applied even if types are bypassed
    const { className: _spreadClass } = htmlAttributes, safeHtmlAttributes = (0, _objectWithoutProperties._)(htmlAttributes, [
        "className"
    ]);
    const RouterLink = (0, _appProvider.useRouterLink)();
    const isExternal = typeof href === 'string' && IS_EXTERNAL_LINK_REGEX.test(href);
    const isNonHttpBased = typeof href === 'string' && IS_NON_HTTP_BASED.test(href);
    /**
   * Renders a router link if:
   *
   * - a link component is set in the app provider
   * - it's not an external link (starting with `http://` or `https://`)
   * - it's not a non-HTTP-based link (e.g. emails, phone numbers, hash links etc.).
   */ const isRouterLink = RouterLink && !isExternal && !isNonHttpBased;
    const hrefObjectUsedWithoutRouterLink = RouterLink === undefined && typeof href === 'object';
    (0, _tinyInvariantDefault.default)(!hrefObjectUsedWithoutRouterLink, `@atlaskit/primitives: Anchor primitive cannot pass an object to 'href' unless a router link is configured in the AppProvider`);
    const Component = isRouterLink ? RouterLink : 'a';
    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _focusableDefault.default), (0, _objectSpreadProps._)((0, _objectSpread._)({
        // @ts-expect-error we don't allow `a` on Focusable for makers as they should use Anchor instead
        as: Component,
        className: xcss,
        style: style,
        ref: ref
    }, safeHtmlAttributes), {
        href: !isRouterLink && typeof href !== 'string' ? undefined : href,
        target: target,
        onClick: onClick,
        "aria-label": ariaLabel && target === '_blank' && !ariaLabelledBy ? `${ariaLabel} , ${newWindowLabel}` : ariaLabel,
        "aria-labelledby": ariaLabelledBy && target === '_blank' ? `${ariaLabelledBy} ${opensNewWindowLabelId}` : ariaLabelledBy,
        xcss: (0, _react1.cx)(styles.root, styles.position, xcss),
        testId: testId,
        "data-is-router-link": testId ? isRouterLink ? 'true' : 'false' : undefined,
        children: [
            children,
            target === '_blank' && (children && !ariaLabel && !ariaLabelledBy || ariaLabelledBy) && /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _visuallyHiddenDefault.default), {
                id: opensNewWindowLabelId,
                children: `, ${newWindowLabel}`
            })
        ]
    }));
};
// Workarounds to support generic types with forwardRef
/**
 * __Anchor__
 *
 * Anchor is a primitive for building custom anchor links. It's a wrapper around the HTML `<a>` element that provides a consistent API for handling client-side routing and Atlassian Design System styling.
 *
 * - [Examples](https://atlassian.design/components/primitives/anchor/examples)
 * - [Code](https://atlassian.design/components/primitives/anchor/code)
 * - [Usage](https://atlassian.design/components/primitives/anchor/usage)
 */ const Anchor = /*#__PURE__*/ (0, _react.forwardRef)(AnchorNoRef);
exports.default = Anchor;

},{"@swc/helpers/_/_object_spread":"9gdrV","@swc/helpers/_/_object_spread_props":"kANqQ","@swc/helpers/_/_object_without_properties":"6HqIM","react/jsx-runtime":"bGvcw","react":"ltHCL","@compiled/react":"MfI9Z","tiny-invariant":"9VWeJ","@atlaskit/analytics-next":"6PLie","@atlaskit/app-provider":"hIy26","@atlaskit/ds-lib/noop":"faKzG","@atlaskit/ds-lib/use-id":"9jWCD","@atlaskit/interaction-context":"18HT9","@atlaskit/visually-hidden":"gKDx1","./focusable":"h97Ae","@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"hIy26":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>(0, _appProviderDefault.default));
// Theme provider
parcelHelpers.export(exports, "UNSAFE_useColorModeForMigration", ()=>(0, _useColorModeForMigration.UNSAFE_useColorModeForMigration));
parcelHelpers.export(exports, "useColorMode", ()=>(0, _useColorMode.useColorMode));
parcelHelpers.export(exports, "useSetColorMode", ()=>(0, _useSetColorMode.useSetColorMode));
parcelHelpers.export(exports, "useSetTheme", ()=>(0, _useSetTheme.useSetTheme));
parcelHelpers.export(exports, "useTheme", ()=>(0, _useTheme.useTheme));
parcelHelpers.export(exports, "ThemeProvider", ()=>(0, _themeProviderDefault.default));
parcelHelpers.export(exports, "useRouterLink", ()=>(0, _useRouterLinkDefault.default));
var _appProvider = require("./app-provider");
var _appProviderDefault = parcelHelpers.interopDefault(_appProvider);
var _useColorModeForMigration = require("./theme-provider/hooks/use-color-mode-for-migration");
var _useColorMode = require("./theme-provider/hooks/use-color-mode");
var _useSetColorMode = require("./theme-provider/hooks/use-set-color-mode");
var _useSetTheme = require("./theme-provider/hooks/use-set-theme");
var _useTheme = require("./theme-provider/hooks/use-theme");
var _themeProvider = require("./theme-provider");
var _themeProviderDefault = parcelHelpers.interopDefault(_themeProvider);
var _useRouterLink = require("./router-link-provider/hooks/use-router-link");
var _useRouterLinkDefault = parcelHelpers.interopDefault(_useRouterLink);

},{"./app-provider":"iFYI4","./theme-provider/hooks/use-color-mode-for-migration":"jTBV4","./theme-provider/hooks/use-color-mode":"76o1k","./theme-provider/hooks/use-set-color-mode":"k527J","./theme-provider/hooks/use-set-theme":"4Hh5R","./theme-provider/hooks/use-theme":"lRPls","./theme-provider":"eM09k","./router-link-provider/hooks/use-router-link":"eEyBk","@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"iFYI4":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _appProviderThemingEnabledContext = require("./app-provider-theming-enabled-context");
var _insideAppProviderContext = require("./inside-app-provider-context");
var _routerLinkProvider = require("./router-link-provider");
var _routerLinkProviderDefault = parcelHelpers.interopDefault(_routerLinkProvider);
var _themeProvider = require("./theme-provider");
var _themeProviderDefault = parcelHelpers.interopDefault(_themeProvider);
var _useIsInsideAppProvider = require("./use-is-inside-app-provider");
/**
 * __App provider__
 *
 * An app provider provides app level configuration such as global theming.
 *
 * Place it at the root of your application.
 */ function AppProvider({ children, defaultColorMode = 'light', defaultTheme, routerLinkComponent, UNSAFE_isThemingDisabled }) {
    const isInsideAppProvider = (0, _useIsInsideAppProvider.useIsInsideAppProvider)();
    if (isInsideAppProvider) throw new Error('App provider should not be nested within another app provider.');
    const routerLinkProvider = /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _routerLinkProviderDefault.default), {
        routerLinkComponent: routerLinkComponent
    }, children);
    return /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _insideAppProviderContext.InsideAppProviderContext).Provider, {
        value: true
    }, UNSAFE_isThemingDisabled ? routerLinkProvider : /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _appProviderThemingEnabledContext.AppProviderThemingEnabledContext).Provider, {
        value: true
    }, /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _themeProviderDefault.default), {
        defaultColorMode: defaultColorMode,
        defaultTheme: defaultTheme
    }, routerLinkProvider)));
}
exports.default = AppProvider;

},{"react":"ltHCL","./app-provider-theming-enabled-context":"4VWbj","./inside-app-provider-context":"gKEtH","./router-link-provider":"4xhXT","./theme-provider":"eM09k","./use-is-inside-app-provider":"fCw6q","@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"4VWbj":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "AppProviderThemingEnabledContext", ()=>AppProviderThemingEnabledContext);
var _react = require("react");
const AppProviderThemingEnabledContext = /*#__PURE__*/ (0, _react.createContext)(false);

},{"react":"ltHCL","@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"gKEtH":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "InsideAppProviderContext", ()=>InsideAppProviderContext);
var _react = require("react");
const InsideAppProviderContext = /*#__PURE__*/ (0, _react.createContext)(false);

},{"react":"ltHCL","@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"4xhXT":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "RouterLinkProviderContext", ()=>RouterLinkProviderContext);
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
const RouterLinkProviderContext = /*#__PURE__*/ (0, _react.createContext)({});
/**
 * __RouterLinkProvider__
 *
 * Provides a configured router link component for use
 * within Design System components.
 */ const RouterLinkProvider = ({ routerLinkComponent, children })=>{
    return /*#__PURE__*/ (0, _reactDefault.default).createElement(RouterLinkProviderContext.Provider, {
        value: {
            routerLinkComponent
        }
    }, children);
};
// eslint-disable-next-line @atlaskit/volt-strict-mode/no-multiple-exports
exports.default = RouterLinkProvider;

},{"react":"ltHCL","@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"eM09k":[function(require,module,exports,__globalThis) {
/* index.tsx generated by @compiled/babel-plugin v0.39.1 */ var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _objectSpread = require("@swc/helpers/_/_object_spread");
var _objectSpreadProps = require("@swc/helpers/_/_object_spread_props");
var _runtime = require("@compiled/react/runtime");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _bindEventListener = require("bind-event-listener");
var _constants = require("@atlaskit/tokens/constants");
var _getThemeHtmlAttrs = require("@atlaskit/tokens/get-theme-html-attrs");
var _setGlobalTheme = require("@atlaskit/tokens/set-global-theme");
var _useIsAppProviderThemingEnabled = require("../use-is-app-provider-theming-enabled");
var _useIsInsideAppProvider = require("../use-is-inside-app-provider");
var _colorMode = require("./context/color-mode");
var _insideThemeProvider = require("./context/inside-theme-provider");
var _setColorModeContext = require("./context/set-color-mode-context");
var _theme = require("./context/theme");
var _useIsInsideThemeProvider = require("./hooks/use-is-inside-theme-provider");
var _loadAndMountThemes = require("./utils/load-and-mount-themes");
const defaultThemeSettings = {
    dark: 'dark',
    light: 'light',
    spacing: 'spacing',
    typography: 'typography'
};
const isMatchMediaAvailable = typeof window !== 'undefined' && 'matchMedia' in window;
const prefersDarkModeMql = isMatchMediaAvailable ? window.matchMedia('(prefers-color-scheme: dark)') : undefined; // TODO: currently 'auto' color mode will always return 'light' in SSR.
// Additional work required: https://product-fabric.atlassian.net/browse/DSP-9781
function getReconciledColorMode(colorMode) {
    if (colorMode === 'auto') return (prefersDarkModeMql === null || prefersDarkModeMql === void 0 ? void 0 : prefersDarkModeMql.matches) ? 'dark' : 'light';
    return colorMode;
}
const contentStyles = {
    body: "_1e0c1bgi"
};
function ThemeProvider({ children, defaultColorMode = 'auto', defaultTheme }) {
    const [chosenColorMode, setChosenColorMode] = (0, _react.useState)(defaultColorMode);
    const [reconciledColorMode, setReconciledColorMode] = (0, _react.useState)(getReconciledColorMode(defaultColorMode));
    const [theme, setTheme] = (0, _react.useState)(()=>(0, _objectSpread._)({}, defaultThemeSettings, defaultTheme));
    const setColorMode = (0, _react.useCallback)((colorMode)=>{
        setChosenColorMode(colorMode);
        setReconciledColorMode(getReconciledColorMode(colorMode));
    }, []);
    const setPartialTheme = (0, _react.useCallback)((nextTheme)=>{
        setTheme((theme)=>(0, _objectSpread._)({}, theme, nextTheme));
    }, []);
    const lastSetGlobalThemePromiseRef = (0, _react.useRef)(null);
    const isInsideAppProvider = (0, _useIsInsideAppProvider.useIsInsideAppProvider)();
    const isAppProviderThemingEnabled = (0, _useIsAppProviderThemingEnabled.useIsAppProviderThemingEnabled)();
    const isInsideThemeProvider = (0, _useIsInsideThemeProvider.useIsInsideThemeProvider)(); /**
                                                             * A top-level ThemeProvider is detected by being the first ThemeProvider inside an AppProvider.
                                                             *
                                                             * This will not use sub-tree theming but instead set the global theme state using the
                                                             * `@atlaskit/tokens` APIs, as it's required for styling root `html` and `body` elements
                                                             * for compatibility with `@atlaskit/css-reset`.
                                                             *
                                                             * In the future we could consider moving away from DOM mutations and require AppProvider to wrap
                                                             * `html` in order to apply global theme state, which would allow a more consistent approach to
                                                             * theme loading.
                                                             */ 
    const isRootThemeProvider = isInsideAppProvider && !isInsideThemeProvider && isAppProviderThemingEnabled;
    (0, _react.useEffect)(()=>{
        if (isRootThemeProvider) {
            /**
       * We need to wait for any previous `setGlobalTheme` calls to finish before calling it again.
       * This is to prevent race conditions as `setGlobalTheme` is async and mutates the DOM (e.g. sets the
       * `data-color-mode` attribute on the root element).
       *
       * Since we can't safely abort the `setGlobalTheme` execution, we need to wait for it to properly finish before
       * applying the new theme.
       *
       * Without this, we can end up in the following scenario:
       * 1. app loads with the default 'light' theme, kicking off `setGlobalTheme`
       * 2. app switches to 'dark' theme after retrieving value persisted in local storage, calling `setGlobalTheme` again
       * 3. `setGlobalTheme` function execution for `dark` finishes before the initial `light` execution
       * 4. `setGlobalTheme` function execution for `light` then finishes, resulting in the 'light' theme being applied.
       */ const cleanupLastFnCall = async ()=>{
                if (lastSetGlobalThemePromiseRef.current) {
                    const unbindFn = await lastSetGlobalThemePromiseRef.current;
                    unbindFn();
                    lastSetGlobalThemePromiseRef.current = null;
                }
            };
            const safelySetGlobalTheme = async ()=>{
                await cleanupLastFnCall();
                const promise = (0, _setGlobalTheme.setGlobalTheme)((0, _objectSpreadProps._)((0, _objectSpread._)({}, theme), {
                    colorMode: reconciledColorMode
                }));
                lastSetGlobalThemePromiseRef.current = promise;
            };
            safelySetGlobalTheme();
            return function cleanup() {
                cleanupLastFnCall();
            };
        } else // For other theme providers (whether outside AppProvider or nested inside a ThemeProvider),
        // we treat them as sub-tree themes that do not load global theme state.
        (0, _loadAndMountThemes.loadAndMountThemes)(theme);
    }, [
        isInsideAppProvider,
        isInsideThemeProvider,
        isRootThemeProvider,
        reconciledColorMode,
        theme
    ]);
    (0, _react.useEffect)(()=>{
        if (!prefersDarkModeMql) return;
        const unbindListener = (0, _bindEventListener.bind)(prefersDarkModeMql, {
            type: 'change',
            listener: (event)=>{
                if (chosenColorMode === 'auto') setReconciledColorMode(event.matches ? 'dark' : 'light');
            }
        });
        return unbindListener;
    }, [
        chosenColorMode
    ]);
    const attrs = (0, _objectSpreadProps._)((0, _objectSpread._)({}, (0, _getThemeHtmlAttrs.getThemeHtmlAttrs)((0, _objectSpreadProps._)((0, _objectSpread._)({}, theme), {
        colorMode: reconciledColorMode
    }))), {
        [(0, _constants.SUBTREE_THEME_ATTRIBUTE)]: true
    });
    return /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _insideThemeProvider.InsideThemeProviderContext).Provider, {
        value: true
    }, /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _colorMode.ColorModeContext).Provider, {
        value: reconciledColorMode
    }, /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _setColorModeContext.SetColorModeContext).Provider, {
        value: setColorMode
    }, /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _theme.ThemeContext).Provider, {
        value: theme
    }, /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _theme.SetThemeContext).Provider, {
        value: setPartialTheme
    }, !isRootThemeProvider ? /*#__PURE__*/ (0, _reactDefault.default).createElement("div", (0, _objectSpreadProps._)((0, _objectSpread._)({}, attrs), {
        className: (0, _runtime.ax)([
            contentStyles.body
        ])
    }), children) : children)))));
}
exports.default = ThemeProvider;

},{"@swc/helpers/_/_object_spread":"9gdrV","@swc/helpers/_/_object_spread_props":"kANqQ","@compiled/react/runtime":"d27Vo","react":"ltHCL","bind-event-listener":"bjeUU","@atlaskit/tokens/constants":"5fDwY","@atlaskit/tokens/get-theme-html-attrs":"3LVlc","@atlaskit/tokens/set-global-theme":"5oVM0","../use-is-app-provider-theming-enabled":"dHLLA","../use-is-inside-app-provider":"fCw6q","./context/color-mode":"i7ixV","./context/inside-theme-provider":"6hncJ","./context/set-color-mode-context":"cxMiV","./context/theme":"kzIYk","./hooks/use-is-inside-theme-provider":"7fB2c","./utils/load-and-mount-themes":"9qDrg","@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"5fDwY":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "COLOR_MODE_ATTRIBUTE", ()=>(0, _constants.COLOR_MODE_ATTRIBUTE));
parcelHelpers.export(exports, "CURRENT_SURFACE_CSS_VAR", ()=>(0, _constants.CURRENT_SURFACE_CSS_VAR));
parcelHelpers.export(exports, "SUBTREE_THEME_ATTRIBUTE", ()=>(0, _constants.SUBTREE_THEME_ATTRIBUTE));
parcelHelpers.export(exports, "THEME_DATA_ATTRIBUTE", ()=>(0, _constants.THEME_DATA_ATTRIBUTE));
var _constants = require("../constants");

},{"../constants":"g8h9H","@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"g8h9H":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "THEME_DATA_ATTRIBUTE", ()=>THEME_DATA_ATTRIBUTE);
parcelHelpers.export(exports, "SUBTREE_THEME_ATTRIBUTE", ()=>SUBTREE_THEME_ATTRIBUTE);
parcelHelpers.export(exports, "COLOR_MODE_ATTRIBUTE", ()=>COLOR_MODE_ATTRIBUTE);
parcelHelpers.export(exports, "CONTRAST_MODE_ATTRIBUTE", ()=>CONTRAST_MODE_ATTRIBUTE);
parcelHelpers.export(exports, "CUSTOM_THEME_ATTRIBUTE", ()=>CUSTOM_THEME_ATTRIBUTE);
parcelHelpers.export(exports, "CSS_PREFIX", ()=>CSS_PREFIX);
parcelHelpers.export(exports, "CSS_VAR_FULL", ()=>CSS_VAR_FULL);
parcelHelpers.export(exports, "TOKEN_NOT_FOUND_CSS_VAR", ()=>TOKEN_NOT_FOUND_CSS_VAR);
parcelHelpers.export(exports, "CURRENT_SURFACE_CSS_VAR", ()=>CURRENT_SURFACE_CSS_VAR);
const THEME_DATA_ATTRIBUTE = 'data-theme';
const SUBTREE_THEME_ATTRIBUTE = 'data-subtree-theme';
const COLOR_MODE_ATTRIBUTE = 'data-color-mode';
const CONTRAST_MODE_ATTRIBUTE = 'data-contrast-mode';
const CUSTOM_THEME_ATTRIBUTE = 'data-custom-theme';
const CSS_PREFIX = 'ds';
const CSS_VAR_FULL = [
    'opacity',
    'font',
    'space',
    'border',
    'radius'
];
const TOKEN_NOT_FOUND_CSS_VAR = `--${CSS_PREFIX}-token-not-found`;
const CURRENT_SURFACE_CSS_VAR = `--${CSS_PREFIX}-elevation-surface-current`;

},{"@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"3LVlc":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "getThemeHtmlAttrs", ()=>(0, _getThemeHtmlAttrsDefault.default));
var _getThemeHtmlAttrs = require("../get-theme-html-attrs");
var _getThemeHtmlAttrsDefault = parcelHelpers.interopDefault(_getThemeHtmlAttrs);

},{"../get-theme-html-attrs":"fS4QK","@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"fS4QK":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _objectSpread = require("@swc/helpers/_/_object_spread");
var _objectSpreadProps = require("@swc/helpers/_/_object_spread_props");
var _platformFeatureFlags = require("@atlaskit/platform-feature-flags");
var _constants = require("./constants");
var _themeConfig = require("./theme-config");
var _themeObjectToString = require("./theme-object-to-string");
var _hash = require("./utils/hash");
var _isValidBrandHex = require("./utils/is-valid-brand-hex");
const defaultColorMode = 'light';
const defaultContrastMode = 'no-preference';
/**
 * Server-side rendering utility. Generates the valid HTML attributes for a given theme.
 * Note: this utility does not handle automatic theme switching.
 *
 * @param {Object<string, string>} themeOptions - Theme options object
 * @param {string} themeState.colorMode Determines which color theme is applied. If set to `auto`, the theme applied will be determined by the OS setting.
 * @param {string} themeState.dark The color theme to be applied when the color mode resolves to 'dark'.
 * @param {string} themeState.light The color theme to be applied when the color mode resolves to 'light'.
 * @param {string} themeState.motion The motion theme to be applied.
 * @param {string} themeState.spacing The spacing theme to be applied.
 * @param {string} themeState.typography The typography theme to be applied.
 * @param {Object} themeState.UNSAFE_themeOptions The custom branding options to be used for custom theme generation
 *
 * @returns {Object} Object of HTML attributes to be applied to the document root
 */ const getThemeHtmlAttrs = ({ colorMode = (0, _themeConfig.themeStateDefaults)['colorMode'], dark = (0, _themeConfig.themeStateDefaults)['dark'], light = (0, _themeConfig.themeStateDefaults)['light'], contrastMode = (0, _themeConfig.themeStateDefaults)['contrastMode'], motion = (0, _themeConfig.themeStateDefaults)['motion'](), shape = (0, _themeConfig.themeStateDefaults)['shape'](), spacing = (0, _themeConfig.themeStateDefaults)['spacing'], typography = (0, _themeConfig.themeStateDefaults)['typography'], UNSAFE_themeOptions = (0, _themeConfig.themeStateDefaults)['UNSAFE_themeOptions'] } = {})=>{
    const themeAttribute = (0, _themeObjectToString.themeObjectToString)({
        dark,
        light,
        motion,
        shape,
        spacing,
        typography
    });
    let result = {
        [(0, _constants.THEME_DATA_ATTRIBUTE)]: themeAttribute,
        [(0, _constants.COLOR_MODE_ATTRIBUTE)]: colorMode === 'auto' ? defaultColorMode : colorMode
    };
    if ((0, _platformFeatureFlags.fg)('platform_increased-contrast-themes')) result = (0, _objectSpreadProps._)((0, _objectSpread._)({}, result), {
        // CLEANUP: Move this to the initial `result` assignment above
        [(0, _constants.CONTRAST_MODE_ATTRIBUTE)]: contrastMode === 'auto' ? defaultContrastMode : contrastMode
    });
    if (UNSAFE_themeOptions && (0, _isValidBrandHex.isValidBrandHex)(UNSAFE_themeOptions.brandColor)) {
        const optionString = JSON.stringify(UNSAFE_themeOptions);
        const uniqueId = (0, _hash.hash)(optionString);
        result[0, _constants.CUSTOM_THEME_ATTRIBUTE] = uniqueId;
    }
    return result;
};
exports.default = getThemeHtmlAttrs;

},{"@swc/helpers/_/_object_spread":"9gdrV","@swc/helpers/_/_object_spread_props":"kANqQ","@atlaskit/platform-feature-flags":"8rD2i","./constants":"g8h9H","./theme-config":"6N1dQ","./theme-object-to-string":"1hTMy","./utils/hash":"1MfsS","./utils/is-valid-brand-hex":"6JaUW","@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"6N1dQ":[function(require,module,exports,__globalThis) {
/**
 * This file contains the source of truth for themes and all associated meta data.
 */ var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "themeColorModes", ()=>(0, _themeColorModes.themeColorModes));
parcelHelpers.export(exports, "themeIds", ()=>(0, _themeIds.themeIds));
parcelHelpers.export(exports, "themeStateDefaults", ()=>(0, _themeStateDefaults.themeStateDefaults));
parcelHelpers.export(exports, "themeIdsWithOverrides", ()=>themeIdsWithOverrides);
var _themeIds = require("./theme-ids");
var _themeColorModes = require("./theme-color-modes");
var _themeStateDefaults = require("./theme-state-defaults");
/**
 * Contrast preferences: The system contrast preference
 */ const themeContrastModes = [
    'more',
    'no-preference',
    'auto'
];
/**
 * Theme override ids: the equivalent of themeIds for theme overrides.
 * Theme overrides are temporary and there may not be any defined at times.
 */ const themeOverrideIds = [];
const themeIdsWithOverrides = [
    ...(0, _themeIds.themeIds),
    ...themeOverrideIds
];
const themeConfig = {
    'atlassian-light': {
        id: 'light',
        displayName: 'Light Theme',
        palette: 'defaultPalette',
        attributes: {
            type: 'color',
            mode: 'light'
        }
    },
    'atlassian-light-future': {
        id: 'light-future',
        displayName: 'Future Light Theme',
        palette: 'defaultPalette',
        attributes: {
            type: 'color',
            mode: 'light'
        },
        override: 'light'
    },
    'atlassian-light-increased-contrast': {
        id: 'light-increased-contrast',
        displayName: 'Light Theme (increased contrast)',
        palette: 'defaultPalette',
        attributes: {
            type: 'color',
            mode: 'light'
        },
        extends: 'light',
        increasesContrastFor: 'light'
    },
    'atlassian-dark': {
        id: 'dark',
        displayName: 'Dark Theme',
        palette: 'defaultPalette',
        attributes: {
            type: 'color',
            mode: 'dark'
        }
    },
    'atlassian-dark-future': {
        id: 'dark-future',
        displayName: 'Future Dark Theme',
        palette: 'defaultPalette',
        attributes: {
            type: 'color',
            mode: 'dark'
        },
        override: 'light'
    },
    'atlassian-dark-increased-contrast': {
        id: 'dark-increased-contrast',
        displayName: 'Dark Theme (increased contrast)',
        palette: 'defaultPalette',
        attributes: {
            type: 'color',
            mode: 'dark'
        },
        extends: 'dark',
        increasesContrastFor: 'dark'
    },
    'atlassian-spacing': {
        id: 'spacing',
        displayName: 'Atlassian Spacing',
        palette: 'spacingScale',
        attributes: {
            type: 'spacing'
        }
    },
    'atlassian-typography': {
        id: 'typography',
        displayName: 'Atlassian Typography',
        palette: 'typographyPalette',
        attributes: {
            type: 'typography'
        }
    },
    'atlassian-shape': {
        id: 'shape',
        displayName: 'Shape',
        palette: 'shapePalette',
        attributes: {
            type: 'shape'
        }
    },
    'atlassian-motion': {
        id: 'motion',
        displayName: 'Motion',
        palette: 'motionPalette',
        attributes: {
            type: 'motion'
        }
    }
};
// eslint-disable-next-line @atlaskit/volt-strict-mode/no-multiple-exports
exports.default = themeConfig;

},{"./theme-ids":"dwqoZ","./theme-color-modes":false,"./theme-state-defaults":"7Je8f","@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"dwqoZ":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "themeIds", ()=>themeIds);
const themeIds = [
    'light-increased-contrast',
    'light',
    'light-future',
    'dark',
    'dark-future',
    'dark-increased-contrast',
    'spacing',
    'shape',
    'typography',
    'motion'
];

},{"@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"awztt":[function(require,module,exports,__globalThis) {
/**
 * Theme modes: The general purpose of a theme.
 * This attr is used to apply the appropriate system-preference option
 * It may also be used as a selector for mode-specific overrides such as light/dark images.
 * The idea is there may exist many color themes, but every theme must either fit into light or dark.
 */ var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "themeColorModes", ()=>themeColorModes);
const themeColorModes = [
    'light',
    'dark',
    'auto'
];

},{"@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"7Je8f":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "themeStateDefaults", ()=>themeStateDefaults);
var _platformFeatureFlags = require("@atlaskit/platform-feature-flags");
function getShapeDefault() {
    if ((0, _platformFeatureFlags.fg)('platform-dst-shape-theme-default')) return 'shape';
    return undefined;
}
function getMotionDefault() {
    return 'motion';
}
const themeStateDefaults = {
    colorMode: 'auto',
    contrastMode: 'auto',
    dark: 'dark',
    light: 'light',
    shape: getShapeDefault,
    spacing: 'spacing',
    typography: 'typography',
    motion: getMotionDefault,
    UNSAFE_themeOptions: undefined
};

},{"@atlaskit/platform-feature-flags":"8rD2i","@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"1hTMy":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "themeObjectToString", ()=>themeObjectToString);
var _isColorMode = require("./is-color-mode");
var _isThemeIds = require("./is-theme-ids");
var _isThemeKind = require("./is-theme-kind");
const customThemeOptions = 'UNSAFE_themeOptions';
const themeObjectToString = (themeState)=>Object.entries(themeState).reduce((themeString, [kind, id])=>{
        if (// colorMode theme state
        kind === 'colorMode' && typeof id === 'string' && (0, _isColorMode.isColorMode)(id) || // custom theme state
        kind === customThemeOptions && typeof id === 'object' || // other theme states
        (0, _isThemeKind.isThemeKind)(kind) && typeof id === 'string' && (0, _isThemeIds.isThemeIds)(id)) return themeString + `${themeString ? ' ' : ''}` + `${kind}:${typeof id === 'object' ? JSON.stringify(id) : id}`;
        return themeString;
    }, '');

},{"./is-color-mode":"hT4ia","./is-theme-ids":"6U2yF","./is-theme-kind":"3JrnN","@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"hT4ia":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "isColorMode", ()=>isColorMode);
const isColorMode = (modeId)=>{
    return [
        'light',
        'dark',
        'auto'
    ].includes(modeId);
};

},{"@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"6U2yF":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "isThemeIds", ()=>isThemeIds);
var _themeIds = require("./theme-ids");
const isThemeIds = (themeId)=>{
    return (0, _themeIds.themeIds).find((id)=>id === themeId) !== undefined;
};

},{"./theme-ids":"dwqoZ","@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"3JrnN":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "isThemeKind", ()=>isThemeKind);
const themeKinds = [
    'light',
    'dark',
    'spacing',
    'typography',
    'shape',
    'motion'
];
const isThemeKind = (themeKind)=>{
    return themeKinds.find((kind)=>kind === themeKind) !== undefined;
};

},{"@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"1MfsS":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "hash", ()=>hash);
const hash = (str)=>{
    let hash = 0;
    for(let i = 0; i < str.length; i++){
        const char = str.charCodeAt(i);
        hash = (hash << 5) - hash + char;
        hash &= hash; // Convert to 32bit integer
    }
    return new Uint32Array([
        hash
    ])[0].toString(36);
};

},{"@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"6JaUW":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "isValidBrandHex", ()=>isValidBrandHex);
const isValidBrandHex = (hex)=>/^#[0-9A-F]{6}$/i.test(hex);

},{"@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"5oVM0":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "setGlobalTheme", ()=>(0, _setGlobalThemeDefault.default));
var _setGlobalTheme = require("../set-global-theme");
var _setGlobalThemeDefault = parcelHelpers.interopDefault(_setGlobalTheme);

},{"../set-global-theme":"kJr7U","@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"kJr7U":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _objectSpread = require("@swc/helpers/_/_object_spread");
var _objectSpreadProps = require("@swc/helpers/_/_object_spread_props");
var _platformFeatureFlags = require("@atlaskit/platform-feature-flags");
var _getGlobalTheme = require("./get-global-theme");
var _getGlobalThemeDefault = parcelHelpers.interopDefault(_getGlobalTheme);
var _themeConfig = require("./theme-config");
var _configurePage = require("./utils/configure-page");
var _configurePageDefault = parcelHelpers.interopDefault(_configurePage);
var _customThemeLoadingUtils = require("./utils/custom-theme-loading-utils");
var _getThemeOverridePreferences = require("./utils/get-theme-override-preferences");
var _getThemePreferences = require("./utils/get-theme-preferences");
var _isValidBrandHex = require("./utils/is-valid-brand-hex");
var _themeLoading = require("./utils/theme-loading");
/**
 * Sets the theme globally at runtime. This updates the `data-theme` and `data-color-mode` attributes on your page's <html> tag.
 *
 * @param {Object<string, string>} themeState The themes and color mode that should be applied.
 * @param {string} themeState.colorMode Determines which color theme is applied. If set to `auto`, the theme applied will be determined by the OS setting.
 * @param {string} themeState.contrastMode The contrast mode theme to be applied. If set to `auto`, the theme applied will be determined by the OS setting.set to `auto`, the theme applied will be determined by the OS setting.
 * @param {string} themeState.dark The color theme to be applied when the color mode resolves to 'dark'.
 * @param {string} themeState.light The color theme to be applied when the color mode resolves to 'light'.
 * @param {string} themeState.motion The motion theme to be applied.
 * @param {string} themeState.shape The shape theme to be applied.
 * @param {string} themeState.spacing The spacing theme to be applied.
 * @param {string} themeState.typography The typography theme to be applied.
 * @param {Object} themeState.UNSAFE_themeOptions The custom branding options to be used for custom theme generation
 * @param {function} themeLoader Callback function used to override the default theme loading functionality.
 *
 * @returns A Promise of an unbind function, that can be used to stop listening for changes to system theme.
 *
 * @example
 * ```
 * setGlobalTheme({colorMode: 'auto', light: 'light', dark: 'dark', spacing: 'spacing'});
 * ```
 */ const setGlobalTheme = async (nextThemeState = {}, themeLoader)=>{
    let { colorMode = (0, _themeConfig.themeStateDefaults)['colorMode'], contrastMode = (0, _themeConfig.themeStateDefaults)['contrastMode'], dark = (0, _themeConfig.themeStateDefaults)['dark'], light = (0, _themeConfig.themeStateDefaults)['light'], shape = (0, _themeConfig.themeStateDefaults)['shape'](), spacing = (0, _themeConfig.themeStateDefaults)['spacing'], typography = (0, _themeConfig.themeStateDefaults)['typography'], motion = (0, _themeConfig.themeStateDefaults)['motion'](), UNSAFE_themeOptions = (0, _themeConfig.themeStateDefaults)['UNSAFE_themeOptions'] } = typeof nextThemeState === 'function' ? nextThemeState((0, _objectSpread._)((0, _objectSpreadProps._)((0, _objectSpread._)({}, (0, _themeConfig.themeStateDefaults)), {
        typography: (0, _themeConfig.themeStateDefaults)['typography'],
        shape: (0, _themeConfig.themeStateDefaults)['shape'](),
        motion: (0, _themeConfig.themeStateDefaults)['motion']()
    }), (0, _getGlobalThemeDefault.default)())) : nextThemeState;
    // CLEANUP: Remove. This blocks application of increased contrast themes
    // without the feature flag enabled.
    if (!(0, _platformFeatureFlags.fg)('platform_increased-contrast-themes')) {
        if (light === 'light-increased-contrast') light = 'light';
        if (dark === 'dark-increased-contrast') dark = 'dark';
    }
    const themeState = {
        colorMode,
        contrastMode,
        dark,
        light,
        shape,
        spacing,
        typography,
        motion,
        UNSAFE_themeOptions: themeLoader ? undefined : UNSAFE_themeOptions
    };
    // Determine what to load and loading strategy
    let themePreferences = (0, _getThemePreferences.getThemePreferences)(themeState);
    const loadingStrategy = themeLoader ? themeLoader : (0, _themeLoading.loadAndAppendThemeCss);
    // Load standard themes
    const loadingTasks = themePreferences.map(async (themeId)=>await loadingStrategy(themeId));
    // Load custom themes if needed
    if (!themeLoader && UNSAFE_themeOptions && (0, _isValidBrandHex.isValidBrandHex)(UNSAFE_themeOptions === null || UNSAFE_themeOptions === void 0 ? void 0 : UNSAFE_themeOptions.brandColor)) {
        const mode = colorMode || (0, _themeConfig.themeStateDefaults)['colorMode'];
        const attrOfMissingCustomStyles = (0, _customThemeLoadingUtils.findMissingCustomStyleElements)(UNSAFE_themeOptions, mode);
        if (attrOfMissingCustomStyles.length > 0) // Load custom theme styles
        loadingTasks.push((async ()=>{
            const { loadAndAppendCustomThemeCss } = await require(/* webpackChunkName: "@atlaskit-internal_atlassian-custom-theme" */ "1ac56c424e4a476a");
            loadAndAppendCustomThemeCss({
                colorMode: attrOfMissingCustomStyles.length === 2 ? 'auto' : attrOfMissingCustomStyles[0],
                UNSAFE_themeOptions
            });
        })());
    }
    await Promise.all(loadingTasks);
    // Load override themes after standard themes
    const themeOverridePreferences = (0, _getThemeOverridePreferences.getThemeOverridePreferences)(themeState);
    for (const themeId of themeOverridePreferences)await loadingStrategy(themeId);
    const autoUnbind = (0, _configurePageDefault.default)(themeState);
    return autoUnbind;
};
exports.default = setGlobalTheme;

},{"@swc/helpers/_/_object_spread":"9gdrV","@swc/helpers/_/_object_spread_props":"kANqQ","@atlaskit/platform-feature-flags":"8rD2i","./get-global-theme":"acd8k","./theme-config":"6N1dQ","./utils/configure-page":"7HZLA","./utils/custom-theme-loading-utils":"kBuj0","./utils/get-theme-override-preferences":"a2tUi","./utils/get-theme-preferences":"kJDqV","./utils/is-valid-brand-hex":"6JaUW","./utils/theme-loading":"hUGIQ","1ac56c424e4a476a":"bOfaz","@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"acd8k":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _objectSpread = require("@swc/helpers/_/_object_spread");
var _constants = require("./constants");
var _themeColorModes = require("./theme-color-modes");
var _themeStringToObject = require("./theme-string-to-object");
const isThemeColorMode = (colorMode)=>{
    return (0, _themeColorModes.themeColorModes).find((mode)=>mode === colorMode) !== undefined;
};
const getGlobalTheme = ()=>{
    if (typeof document === 'undefined') return {};
    const element = document.documentElement;
    const colorMode = element.getAttribute((0, _constants.COLOR_MODE_ATTRIBUTE)) || '';
    const theme = element.getAttribute((0, _constants.THEME_DATA_ATTRIBUTE)) || '';
    return (0, _objectSpread._)({}, (0, _themeStringToObject.themeStringToObject)(theme), isThemeColorMode(colorMode) && {
        colorMode
    });
};
exports.default = getGlobalTheme;

},{"@swc/helpers/_/_object_spread":"9gdrV","./constants":"g8h9H","./theme-color-modes":"awztt","./theme-string-to-object":"hhJWT","@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"hhJWT":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "themeStringToObject", ()=>themeStringToObject);
var _isColorMode = require("./is-color-mode");
var _isThemeIds = require("./is-theme-ids");
var _isThemeKind = require("./is-theme-kind");
const customThemeOptions = 'UNSAFE_themeOptions';
const themeStringToObject = (themeState)=>{
    return themeState.split(' ')// @ts-ignore - TS1501 TypeScript 5.9.2 upgrade
    .map((theme)=>theme.split(RegExp(":(.*)", "s"))).reduce((themeObject, [kind, id])=>{
        if (kind === 'colorMode' && (0, _isColorMode.isColorMode)(id)) themeObject[kind] = id;
        if ((0, _isThemeKind.isThemeKind)(kind) && (0, _isThemeIds.isThemeIds)(id)) // @ts-expect-error FIXME - this is a valid ts error
        themeObject[kind] = id;
        if (kind === customThemeOptions) try {
            themeObject[customThemeOptions] = JSON.parse(id);
        } catch (e) {
            new Error('Invalid custom theme string');
        }
        return themeObject;
    }, {});
};

},{"./is-color-mode":"hT4ia","./is-theme-ids":"6U2yF","./is-theme-kind":"3JrnN","@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"7HZLA":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>configurePage);
var _platformFeatureFlags = require("@atlaskit/platform-feature-flags");
var _getThemeHtmlAttrs = require("../get-theme-html-attrs");
var _getThemeHtmlAttrsDefault = parcelHelpers.interopDefault(_getThemeHtmlAttrs);
var _colorModeListeners = require("./color-mode-listeners");
var _colorModeListenersDefault = parcelHelpers.interopDefault(_colorModeListeners);
var _contrastModeListeners = require("./contrast-mode-listeners");
var _contrastModeListenersDefault = parcelHelpers.interopDefault(_contrastModeListeners);
function configurePage(themeState) {
    if (themeState.colorMode === 'auto') {
        // Set colorMode based on the user preference
        themeState.colorMode = (0, _colorModeListenersDefault.default).getColorMode();
        // Bind a listener (if one doesn't already exist) to keep colorMode updated
        (0, _colorModeListenersDefault.default).bind();
    } else (0, _colorModeListenersDefault.default).unbind();
    if ((0, _platformFeatureFlags.fg)('platform_increased-contrast-themes')) {
        if (themeState.contrastMode === 'auto') {
            // Set contrastMode based on the user preference
            themeState.contrastMode = (0, _contrastModeListenersDefault.default).getContrastMode();
            // Bind a listener (if one doesn't already exist) to keep contrastMode updated
            (0, _contrastModeListenersDefault.default).bind();
        } else (0, _contrastModeListenersDefault.default).unbind();
    }
    const themeAttributes = (0, _getThemeHtmlAttrsDefault.default)(themeState);
    Object.entries(themeAttributes).forEach(([key, value])=>{
        document.documentElement.setAttribute(key, value);
    });
    return ()=>{
        (0, _colorModeListenersDefault.default).unbind();
        if ((0, _platformFeatureFlags.fg)('platform_increased-contrast-themes')) (0, _contrastModeListenersDefault.default).unbind();
    };
}

},{"@atlaskit/platform-feature-flags":"8rD2i","../get-theme-html-attrs":"fS4QK","./color-mode-listeners":"alKx5","./contrast-mode-listeners":"6kDN3","@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"alKx5":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _bindEventListener = require("bind-event-listener");
var _constants = require("../constants");
var _themeLoading = require("./theme-loading");
const isMatchMediaAvailable = typeof window !== 'undefined' && 'matchMedia' in window;
/**
 * Updates the current theme when the system theme changes. Should be bound
 * to an event listener listening on the '(prefers-color-scheme: dark)' query
 * @param e The event representing a change in system theme.
 */ function checkNativeListener(e) {
    const element = document.documentElement;
    element.setAttribute((0, _constants.COLOR_MODE_ATTRIBUTE), e.matches ? 'dark' : 'light');
}
const darkModeMql = isMatchMediaAvailable && window.matchMedia((0, _themeLoading.darkModeMediaQuery));
class ColorModeObserver {
    getColorMode() {
        if (!darkModeMql) return 'light';
        return (darkModeMql === null || darkModeMql === void 0 ? void 0 : darkModeMql.matches) ? 'dark' : 'light';
    }
    bind() {
        if (darkModeMql && this.unbindThemeChangeListener === null) this.unbindThemeChangeListener = (0, _bindEventListener.bind)(darkModeMql, {
            type: 'change',
            listener: checkNativeListener
        });
    }
    unbind() {
        if (this.unbindThemeChangeListener) {
            this.unbindThemeChangeListener();
            this.unbindThemeChangeListener = null;
        }
    }
    constructor(){
        this.unbindThemeChangeListener = null;
    }
}
/**
 * A singleton color mode observer - binds "auto" switching logic to a single `mediaQueryList` listener
 * that can be unbound by any consumer when no longer needed.
 */ const SingletonColorModeObserver = new ColorModeObserver();
exports.default = SingletonColorModeObserver;

},{"bind-event-listener":"bjeUU","../constants":"g8h9H","./theme-loading":"hUGIQ","@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"hUGIQ":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "loadThemeCss", ()=>(0, _loadThemeCss.loadThemeCss));
parcelHelpers.export(exports, "loadAndAppendThemeCss", ()=>loadAndAppendThemeCss);
parcelHelpers.export(exports, "darkModeMediaQuery", ()=>darkModeMediaQuery);
parcelHelpers.export(exports, "moreContrastMediaQuery", ()=>moreContrastMediaQuery);
var _constants = require("../constants");
var _loadThemeCss = require("./load-theme-css");
const loadAndAppendThemeCss = async (themeId)=>{
    if (document.head.querySelector(`style[${(0, _constants.THEME_DATA_ATTRIBUTE)}="${themeId}"]:not([${(0, _constants.CUSTOM_THEME_ATTRIBUTE)}])`)) return;
    // Gracefully handles falsy values like `null` and `undefined` when maker ignore TS
    // to avoid loading default themes.
    if (!themeId) return;
    const themeCss = await (0, _loadThemeCss.loadThemeCss)(themeId);
    const style = document.createElement('style');
    style.textContent = themeCss;
    style.dataset.theme = themeId;
    document.head.appendChild(style);
};
const darkModeMediaQuery = '(prefers-color-scheme: dark)';
const moreContrastMediaQuery = '(prefers-contrast: more)';

},{"../constants":"g8h9H","./load-theme-css":"b9wci","@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"b9wci":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "loadThemeCss", ()=>loadThemeCss);
var _themeImportMap = require("../artifacts/theme-import-map");
var _themeImportMapDefault = parcelHelpers.interopDefault(_themeImportMap);
const loadThemeCss = async (themeId)=>{
    const { default: themeCss } = await (0, _themeImportMapDefault.default)[themeId]();
    return themeCss;
};

},{"../artifacts/theme-import-map":"2Oz0Y","@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"2Oz0Y":[function(require,module,exports,__globalThis) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 *
 * This file contains a dynamic import for each theme this package exports.
 * Themes are loaded asynchronously at runtime to minimise the amount of CSS we send to the client.
 * This allows users to compose their themes and only use the tokens that are requested.
 * When a new theme is created, the import should automatically be added to the map
 *
 * @codegen <<SignedSource::a20c72d683b08b594c5be4160eec5f78>>
 * @codegenCommand yarn build tokens
 */ var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
const themeImportsMap = {
    'light': ()=>require(/* webpackChunkName: "@atlaskit-internal_atlassian-light" */ "61b2e2bda3b33ffd"),
    'light-future': ()=>require(/* webpackChunkName: "@atlaskit-internal_atlassian-light-future" */ "1108dfcf4270cf2c"),
    'light-increased-contrast': ()=>require(/* webpackChunkName: "@atlaskit-internal_atlassian-light-increased-contrast" */ "5ec8946da09a2f03"),
    'dark': ()=>require(/* webpackChunkName: "@atlaskit-internal_atlassian-dark" */ "3ebaad453b19dba7"),
    'dark-future': ()=>require(/* webpackChunkName: "@atlaskit-internal_atlassian-dark-future" */ "f9de0190f17213b2"),
    'dark-increased-contrast': ()=>require(/* webpackChunkName: "@atlaskit-internal_atlassian-dark-increased-contrast" */ "40ce4699b32cc8cb"),
    'spacing': ()=>require(/* webpackChunkName: "@atlaskit-internal_atlassian-spacing" */ "538c68d17e75ec60"),
    'typography': ()=>require(/* webpackChunkName: "@atlaskit-internal_atlassian-typography" */ "e85bfdada23a99e8"),
    'shape': ()=>require(/* webpackChunkName: "@atlaskit-internal_atlassian-shape" */ "ee0aa988ae39672d"),
    'motion': ()=>require(/* webpackChunkName: "@atlaskit-internal_atlassian-motion" */ "d533d09592ff1d3a")
};
exports.default = themeImportsMap;

},{"61b2e2bda3b33ffd":"dptD5","1108dfcf4270cf2c":"e4gpa","5ec8946da09a2f03":"cCDfQ","3ebaad453b19dba7":"ckwqP","f9de0190f17213b2":"eGnL8","40ce4699b32cc8cb":"1F1QR","538c68d17e75ec60":"dc2aj","e85bfdada23a99e8":"d9iMN","ee0aa988ae39672d":"k1zQD","d533d09592ff1d3a":"5GOtN","@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"dptD5":[function(require,module,exports,__globalThis) {
module.exports = require("4a36cca604e100dc")(require("fcd681d4332c3bfe").resolve("561E1")).then(()=>module.bundle.root('1LSDA'));

},{"4a36cca604e100dc":"hkfCW","fcd681d4332c3bfe":"l4T2r"}],"e4gpa":[function(require,module,exports,__globalThis) {
module.exports = require("2f9b283e7a775e2a")(require("56adfd68ae8683ab").resolve("jZDU5")).then(()=>module.bundle.root('conF3'));

},{"2f9b283e7a775e2a":"hkfCW","56adfd68ae8683ab":"l4T2r"}],"cCDfQ":[function(require,module,exports,__globalThis) {
module.exports = require("473d3b7f1198bdce")(require("18a1f52e5419f296").resolve("79yNH")).then(()=>module.bundle.root('kOXeT'));

},{"473d3b7f1198bdce":"hkfCW","18a1f52e5419f296":"l4T2r"}],"ckwqP":[function(require,module,exports,__globalThis) {
module.exports = require("bd61bc086e1d29a4")(require("a59de4050eaaf38a").resolve("2vkNG")).then(()=>module.bundle.root('hyH1f'));

},{"bd61bc086e1d29a4":"hkfCW","a59de4050eaaf38a":"l4T2r"}],"eGnL8":[function(require,module,exports,__globalThis) {
module.exports = require("d58d174178b8030f")(require("8318c9d2bb9867ce").resolve("goFnJ")).then(()=>module.bundle.root('3ReX2'));

},{"d58d174178b8030f":"hkfCW","8318c9d2bb9867ce":"l4T2r"}],"1F1QR":[function(require,module,exports,__globalThis) {
module.exports = require("e694abb86a17dc12")(require("3cd5057660b493e7").resolve("3VVjz")).then(()=>module.bundle.root('bneZm'));

},{"e694abb86a17dc12":"hkfCW","3cd5057660b493e7":"l4T2r"}],"dc2aj":[function(require,module,exports,__globalThis) {
module.exports = require("f2356ae759f9bd4f")(require("e9acffb70015be36").resolve("65M74")).then(()=>module.bundle.root('lsGGD'));

},{"f2356ae759f9bd4f":"hkfCW","e9acffb70015be36":"l4T2r"}],"d9iMN":[function(require,module,exports,__globalThis) {
module.exports = require("835da06b575f2328")(require("35ac5ffdf37dbec4").resolve("4dofA")).then(()=>module.bundle.root('c6XdD'));

},{"835da06b575f2328":"hkfCW","35ac5ffdf37dbec4":"l4T2r"}],"k1zQD":[function(require,module,exports,__globalThis) {
module.exports = require("430e9d9735f42cc1")(require("8263ccc94b0dbcc1").resolve("1PQHU")).then(()=>module.bundle.root('eVO4f'));

},{"430e9d9735f42cc1":"hkfCW","8263ccc94b0dbcc1":"l4T2r"}],"5GOtN":[function(require,module,exports,__globalThis) {
module.exports = require("9d75a824ddf4658e")(require("3bc774022d9ebbf2").resolve("6Esfa")).then(()=>module.bundle.root('eXP9T'));

},{"9d75a824ddf4658e":"hkfCW","3bc774022d9ebbf2":"l4T2r"}],"6kDN3":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _bindEventListener = require("bind-event-listener");
var _constants = require("../constants");
var _themeLoading = require("./theme-loading");
const isMatchMediaAvailable = typeof window !== 'undefined' && 'matchMedia' in window;
/**
 * Updates the current theme when the system contrast preference changes. Should be bound
 * to an event listener listening on the '(prefers-contrast: more)' query
 * @param e The event representing a change in system theme.
 */ function checkNativeListener(e) {
    const element = document.documentElement;
    element.setAttribute((0, _constants.CONTRAST_MODE_ATTRIBUTE), e.matches ? 'more' : 'no-preference');
}
const contrastModeMql = isMatchMediaAvailable && window.matchMedia((0, _themeLoading.moreContrastMediaQuery));
class ContrastModeObserver {
    getContrastMode() {
        if (!contrastModeMql) return 'no-preference';
        return (contrastModeMql === null || contrastModeMql === void 0 ? void 0 : contrastModeMql.matches) ? 'more' : 'no-preference';
    }
    bind() {
        if (contrastModeMql && this.unbindContrastChangeListener === null) this.unbindContrastChangeListener = (0, _bindEventListener.bind)(contrastModeMql, {
            type: 'change',
            listener: checkNativeListener
        });
    }
    unbind() {
        if (this.unbindContrastChangeListener) {
            this.unbindContrastChangeListener();
            this.unbindContrastChangeListener = null;
        }
    }
    constructor(){
        this.unbindContrastChangeListener = null;
    }
}
/**
 * A singleton contrast mode observer - binds "auto" switching logic to a single `mediaQueryList` listener
 * that can be unbound by any consumer when no longer needed.
 */ const SingletonContrastModeObserver = new ContrastModeObserver();
exports.default = SingletonContrastModeObserver;

},{"bind-event-listener":"bjeUU","../constants":"g8h9H","./theme-loading":"hUGIQ","@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"kBuj0":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "findMissingCustomStyleElements", ()=>findMissingCustomStyleElements);
var _constants = require("../constants");
var _hash = require("./hash");
function findMissingCustomStyleElements(UNSAFE_themeOptions, mode) {
    const optionString = JSON.stringify(UNSAFE_themeOptions);
    const uniqueId = (0, _hash.hash)(optionString);
    const attrOfMissingCustomStyles = [];
    (mode === 'auto' ? [
        'light',
        'dark'
    ] : [
        mode
    ]).forEach((themeId)=>{
        const element = document.head.querySelector(`style[${(0, _constants.CUSTOM_THEME_ATTRIBUTE)}="${uniqueId}"][${(0, _constants.THEME_DATA_ATTRIBUTE)}="${themeId}"]`);
        if (element) // Append the existing custom styles to take precedence over others
        document.head.appendChild(element);
        else attrOfMissingCustomStyles.push(themeId);
    });
    return attrOfMissingCustomStyles;
}

},{"../constants":"g8h9H","./hash":"1MfsS","@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"a2tUi":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "getThemeOverridePreferences", ()=>getThemeOverridePreferences);
const getThemeOverridePreferences = (_themeState)=>{
    const themeOverridePreferences = [];
    return [
        ...new Set(themeOverridePreferences)
    ];
};

},{"@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"kJDqV":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "getThemeOverridePreferences", ()=>(0, _getThemeOverridePreferences.getThemeOverridePreferences));
parcelHelpers.export(exports, "getThemePreferences", ()=>getThemePreferences);
var _platformFeatureFlags = require("@atlaskit/platform-feature-flags");
var _getIncreasedContrastTheme = require("./get-increased-contrast-theme");
var _getIncreasedContrastThemeDefault = parcelHelpers.interopDefault(_getIncreasedContrastTheme);
var _getThemeOverridePreferences = require("./get-theme-override-preferences");
const getThemePreferences = (themeState)=>{
    const { colorMode, contrastMode, dark, light, shape, spacing, typography, motion } = themeState;
    const autoColorModeThemes = [
        light,
        dark
    ];
    const themePreferences = [];
    if (colorMode === 'auto') {
        if (contrastMode !== 'no-preference' && (0, _platformFeatureFlags.fg)('platform_increased-contrast-themes')) autoColorModeThemes.forEach((normalTheme)=>{
            const increasedContrastTheme = (0, _getIncreasedContrastThemeDefault.default)(normalTheme);
            if (increasedContrastTheme) autoColorModeThemes.push(increasedContrastTheme);
        });
        themePreferences.push(...autoColorModeThemes);
    } else {
        themePreferences.push(themeState[colorMode]);
        if (contrastMode !== 'no-preference' && (0, _platformFeatureFlags.fg)('platform_increased-contrast-themes')) {
            const increasedContrastTheme = (0, _getIncreasedContrastThemeDefault.default)(themeState[colorMode]);
            if (increasedContrastTheme) themePreferences.push(increasedContrastTheme);
        }
    }
    [
        shape,
        spacing,
        typography,
        motion
    ].forEach((themeId)=>{
        if (themeId) themePreferences.push(themeId);
    });
    return [
        ...new Set(themePreferences)
    ];
};

},{"@atlaskit/platform-feature-flags":"8rD2i","./get-increased-contrast-theme":"kDfjo","./get-theme-override-preferences":false,"@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"kDfjo":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>getIncreasedContrastTheme);
var _themeConfig = require("../theme-config");
var _themeConfigDefault = parcelHelpers.interopDefault(_themeConfig);
function getIncreasedContrastTheme(themeId) {
    var _Object_entries_find;
    return (_Object_entries_find = Object.entries((0, _themeConfigDefault.default)).find(([, { increasesContrastFor }])=>{
        return increasesContrastFor === themeId;
    })) === null || _Object_entries_find === void 0 ? void 0 : _Object_entries_find[1].id;
}

},{"../theme-config":"6N1dQ","@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"bOfaz":[function(require,module,exports,__globalThis) {
module.exports = Promise.all([
    require("10ef074381a9609e")(require("4f19f5f72d6c0239").resolve("6YAjW")),
    require("10ef074381a9609e")(require("4f19f5f72d6c0239").resolve("2E0BP"))
]).then(()=>module.bundle.root('6n9kA'));

},{"10ef074381a9609e":"hkfCW","4f19f5f72d6c0239":"l4T2r"}],"dHLLA":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "useIsAppProviderThemingEnabled", ()=>useIsAppProviderThemingEnabled);
var _react = require("react");
var _appProviderThemingEnabledContext = require("./app-provider-theming-enabled-context");
const useIsAppProviderThemingEnabled = ()=>{
    return (0, _react.useContext)((0, _appProviderThemingEnabledContext.AppProviderThemingEnabledContext));
};

},{"react":"ltHCL","./app-provider-theming-enabled-context":"4VWbj","@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"fCw6q":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "useIsInsideAppProvider", ()=>useIsInsideAppProvider);
var _react = require("react");
var _insideAppProviderContext = require("./inside-app-provider-context");
const useIsInsideAppProvider = ()=>{
    return (0, _react.useContext)((0, _insideAppProviderContext.InsideAppProviderContext));
};

},{"react":"ltHCL","./inside-app-provider-context":"gKEtH","@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"i7ixV":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "ColorModeContext", ()=>ColorModeContext);
var _react = require("react");
const ColorModeContext = /*#__PURE__*/ (0, _react.createContext)(undefined);

},{"react":"ltHCL","@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"6hncJ":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "InsideThemeProviderContext", ()=>InsideThemeProviderContext);
var _react = require("react");
const InsideThemeProviderContext = /*#__PURE__*/ (0, _react.createContext)(false);

},{"react":"ltHCL","@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"cxMiV":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "SetColorModeContext", ()=>SetColorModeContext);
var _react = require("react");
const SetColorModeContext = /*#__PURE__*/ (0, _react.createContext)(undefined);

},{"react":"ltHCL","@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"kzIYk":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "ThemeContext", ()=>ThemeContext);
parcelHelpers.export(exports, "SetThemeContext", ()=>SetThemeContext);
var _react = require("react");
const ThemeContext = /*#__PURE__*/ (0, _react.createContext)(undefined);
const SetThemeContext = /*#__PURE__*/ (0, _react.createContext)(undefined);

},{"react":"ltHCL","@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"7fB2c":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "useIsInsideThemeProvider", ()=>useIsInsideThemeProvider);
var _react = require("react");
var _insideThemeProvider = require("../context/inside-theme-provider");
const useIsInsideThemeProvider = ()=>{
    var _useContext;
    return (_useContext = (0, _react.useContext)((0, _insideThemeProvider.InsideThemeProviderContext))) !== null && _useContext !== void 0 ? _useContext : false;
};

},{"react":"ltHCL","../context/inside-theme-provider":"6hncJ","@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"9qDrg":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "loadAndMountThemes", ()=>loadAndMountThemes);
var _browserApis = require("@atlaskit/browser-apis");
var _themeImportMap = require("@atlaskit/tokens/artifacts/theme-import-map");
var _isThemeMounted = require("./is-theme-mounted");
const loadThemeCss = async (themeId)=>{
    // Prevent duplicate loading of themes
    if ((0, _isThemeMounted.isThemeMounted)(themeId)) return;
    // Gracefully handles falsy values like `null` and `undefined` when makers ignore
    // TS to avoid loading default themes.
    if (!themeId) return;
    const { default: themeCss } = await (0, _themeImportMap.themeImportMap)[themeId]();
    return themeCss;
};
const mountThemeCss = async (css, themeId)=>{
    // SSR-safe: Only mount on client side
    const doc = (0, _browserApis.getDocument)();
    if (!doc) return;
    const style = doc.createElement('style');
    style.textContent = css;
    style.dataset.theme = themeId;
    // Prevent duplicate mounting of themes.
    // It's possible the theme was already being loaded elsewhere.
    if ((0, _isThemeMounted.isThemeMounted)(themeId)) return;
    doc.head.appendChild(style);
};
const loadAndMountThemeCss = async (themeId)=>{
    const themeCss = await loadThemeCss(themeId);
    if (!themeCss) return;
    mountThemeCss(themeCss, themeId);
};
const loadAndMountThemes = async (theme)=>{
    const themesToLoad = Object.values(theme).filter((themeId)=>!!themeId);
    themesToLoad.forEach(loadAndMountThemeCss);
};

},{"@atlaskit/browser-apis":"1bRFZ","@atlaskit/tokens/artifacts/theme-import-map":"6ZXJy","./is-theme-mounted":"76bF3","@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"6ZXJy":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "themeImportMap", ()=>(0, _themeImportMapDefault.default));
var _themeImportMap = require("../artifacts/theme-import-map");
var _themeImportMapDefault = parcelHelpers.interopDefault(_themeImportMap);

},{"../artifacts/theme-import-map":"2Oz0Y","@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"76bF3":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
/**
 * Checks if a theme is mounted in the document head.
 *
 * Eventually this won't be necessary as we'll utilise AppProvider context
 * to track theme loading.
 */ parcelHelpers.export(exports, "isThemeMounted", ()=>isThemeMounted);
var _browserApis = require("@atlaskit/browser-apis");
var _constants = require("@atlaskit/tokens/constants");
function isThemeMounted(themeId) {
    const doc = (0, _browserApis.getDocument)();
    if (!doc) return false;
    return doc.head.querySelector(`style[${(0, _constants.THEME_DATA_ATTRIBUTE)}="${themeId}"]`);
}

},{"@atlaskit/browser-apis":"1bRFZ","@atlaskit/tokens/constants":"5fDwY","@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"jTBV4":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
/**
 * __UNSAFE_useColorModeForMigration()__
 *
 * Returns the current color mode when inside the app provider.
 * Unlike useColorMode, this utility returns undefined, instead of throwing an error, when the app provider is missing.
 * This allows it to be used by components that need to operate with and without an app provider.
 */ parcelHelpers.export(exports, "UNSAFE_useColorModeForMigration", ()=>UNSAFE_useColorModeForMigration);
var _react = require("react");
var _colorMode = require("../context/color-mode");
function UNSAFE_useColorModeForMigration() {
    const value = (0, _react.useContext)((0, _colorMode.ColorModeContext));
    return value;
}

},{"react":"ltHCL","../context/color-mode":"i7ixV","@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"76o1k":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
/**
 * __useColorMode()__
 *
 * Returns the active (reconciled) color mode for the current theme context.
 *
 * When the color mode is set to `'auto'`, this hook returns the resolved value
 * (`'light'` or `'dark'`) based on the system color scheme preference.
 * it will never return `'auto'`. Use `useSetColorMode` to change the color mode.
 *
 * This hook can be used both inside and outside `AppProvider`. When used inside
 * a nested `ThemeProvider`, it reflects the color mode of that sub-tree.
 *
 * @returns The current reconciled color mode: `'light'` or `'dark'`.
 *
 * @example
 * ```tsx
 * function MyComponent() {
 *   const colorMode = useColorMode();
 *
 *   return <p>Current color mode: {colorMode}</p>;
 * }
 * ```
 */ parcelHelpers.export(exports, "useColorMode", ()=>useColorMode);
var _react = require("react");
var _getGlobalTheme = require("@atlaskit/tokens/get-global-theme");
var _themeMutationObserver = require("@atlaskit/tokens/theme-mutation-observer");
var _colorMode = require("../context/color-mode");
function useColorMode() {
    const value = (0, _react.useContext)((0, _colorMode.ColorModeContext));
    // TODO: This will only return 'light' or 'dark' but never 'auto', which in some cases
    // may be desirable. We should consider returning both the reconciled color mode (e.g. 'light' or 'dark') and the selected color mode ("auto").
    const theme = (0, _getGlobalTheme.getGlobalTheme)();
    const [resolvedColorMode, setResolvedColorMode] = (0, _react.useState)((theme === null || theme === void 0 ? void 0 : theme.colorMode) || 'light');
    (0, _react.useEffect)(()=>{
        // We are using theme from context so no need to reference the DOM
        if (value) return;
        const observer = new (0, _themeMutationObserver.ThemeMutationObserver)((theme)=>{
            setResolvedColorMode((theme === null || theme === void 0 ? void 0 : theme.colorMode) || 'light');
        });
        observer.observe();
        return ()=>observer.disconnect();
    }, [
        value
    ]);
    return value ? value : resolvedColorMode;
}

},{"react":"ltHCL","@atlaskit/tokens/get-global-theme":"8lhfU","@atlaskit/tokens/theme-mutation-observer":"bWFey","../context/color-mode":"i7ixV","@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"8lhfU":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "getGlobalTheme", ()=>(0, _getGlobalThemeDefault.default));
var _getGlobalTheme = require("../get-global-theme");
var _getGlobalThemeDefault = parcelHelpers.interopDefault(_getGlobalTheme);

},{"../get-global-theme":"acd8k","@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"bWFey":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "ThemeMutationObserver", ()=>(0, _themeMutationObserverDefault.default));
var _themeMutationObserver = require("../theme-mutation-observer");
var _themeMutationObserverDefault = parcelHelpers.interopDefault(_themeMutationObserver);

},{"../theme-mutation-observer":"4qKqG","@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"4qKqG":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
/**
 * A MutationObserver which watches the `<html>` element for changes to the theme.
 *
 * In React, use the {@link useThemeObserver `useThemeObserver`} hook instead.
 *
 * @param {function} callback - A callback function which fires when the theme changes.
 *
 * @example
 * ```
 * const observer = new ThemeMutationObserver((theme) => {});
 * observer.observe();
 * ```
 */ parcelHelpers.export(exports, "default", ()=>ThemeMutationObserver);
var _constants = require("./constants");
var _getGlobalTheme = require("./get-global-theme");
var _getGlobalThemeDefault = parcelHelpers.interopDefault(_getGlobalTheme);
class ThemeMutationObserver {
    observe() {
        if (!ThemeMutationObserver.observer) {
            ThemeMutationObserver.observer = new MutationObserver(()=>{
                const theme = (0, _getGlobalThemeDefault.default)();
                ThemeMutationObserver.callbacks.forEach((callback)=>callback(theme));
            });
            // Observer only needs to be configured once
            ThemeMutationObserver.observer.observe(document.documentElement, {
                attributeFilter: [
                    (0, _constants.THEME_DATA_ATTRIBUTE),
                    (0, _constants.COLOR_MODE_ATTRIBUTE)
                ]
            });
        }
    }
    disconnect() {
        if (this.callback) ThemeMutationObserver.callbacks.delete(this.callback);
        if (ThemeMutationObserver.callbacks.size === 0 && ThemeMutationObserver.observer) {
            ThemeMutationObserver.observer.disconnect();
            ThemeMutationObserver.observer = null;
        }
    }
    constructor(callback){
        this.legacyObserver = null;
        this.callback = callback;
        ThemeMutationObserver.callbacks.add(callback);
    }
}
ThemeMutationObserver.observer = null;
ThemeMutationObserver.callbacks = new Set();

},{"./constants":"g8h9H","./get-global-theme":"acd8k","@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"k527J":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
/**
 * __useSetColorMode()__
 *
 * Returns a function that updates the color mode for the nearest `ThemeProvider`
 * in the React tree.
 *
 * Call the returned setter with `'light'`, `'dark'`, or `'auto'` to change the
 * active color mode. When set to `'auto'`, the color mode follows the system
 * color scheme preference and `useColorMode()` returns the resolved value.
 *
 * This hook must be called from within a `ThemeProvider` (or `AppProvider`).
 * It throws if no `ThemeProvider` is found in the tree.
 *
 * @returns A setter function that accepts a `ThemeColorModes` value.
 *
 * @example
 * ```tsx
 * function ColorModeToggle() {
 *   const colorMode = useColorMode();
 *   const setColorMode = useSetColorMode();
 *
 *   return (
 *     <button onClick={() => setColorMode(colorMode === 'light' ? 'dark' : 'light')}>
 *       Toggle color mode
 *     </button>
 *   );
 * }
 * ```
 *
 * @example
 * ```tsx
 * // Invert the color mode relative to a parent ThemeProvider
 * function InvertedPanel({ parentColorMode }: { parentColorMode: ThemeColorModes }) {
 *   const setColorMode = useSetColorMode();
 *
 *   useEffect(() => {
 *     setColorMode(parentColorMode === 'light' ? 'dark' : 'light');
 *   }, [parentColorMode, setColorMode]);
 *
 *   return <Box backgroundColor="elevation.surface">...</Box>;
 * }
 * ```
 */ parcelHelpers.export(exports, "useSetColorMode", ()=>useSetColorMode);
var _react = require("react");
var _setColorModeContext = require("../context/set-color-mode-context");
function useSetColorMode() {
    const value = (0, _react.useContext)((0, _setColorModeContext.SetColorModeContext));
    if (!value) throw new Error('useSetColorMode must be used within ThemeProvider.');
    return value;
}

},{"react":"ltHCL","../context/set-color-mode-context":"cxMiV","@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"4Hh5R":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
/**
 * __useSetTheme()__
 *
 * Returns a function that partially updates the theme settings for the nearest
 * `ThemeProvider` in the React tree.
 *
 * Pass a partial `Theme` object to update one or more theme slots (`light`,
 * `dark`, `spacing`, `typography`). Unspecified slots will retain their current
 * values. The updated theme is merged with the existing theme state.
 *
 * This hook must be called from within a `ThemeProvider` (or `AppProvider`).
 * It throws if no `ThemeProvider` is found in the tree.
 *
 * @returns A setter function that accepts a partial `Theme` object.
 *
 * @example
 * ```tsx
 * function ThemeSwitcher() {
 *   const setTheme = useSetTheme();
 *
 *   return (
 *     <button onClick={() => setTheme({ light: 'light', dark: 'dark' })}>
 *       Reset to default theme
 *     </button>
 *   );
 * }
 * ```
 */ parcelHelpers.export(exports, "useSetTheme", ()=>useSetTheme);
var _react = require("react");
var _theme = require("../context/theme");
function useSetTheme() {
    const value = (0, _react.useContext)((0, _theme.SetThemeContext));
    if (!value) throw new Error('useSetTheme must be used within ThemeProvider.');
    return value;
}

},{"react":"ltHCL","../context/theme":"kzIYk","@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"lRPls":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
/**
 * __useTheme()__
 *
 * Returns the current theme settings for the nearest `ThemeProvider` in the
 * React tree.
 *
 * The returned object contains the named theme IDs for each slot: `light`,
 * `dark`, `spacing`, and `typography`. Use `useSetTheme` to change these
 * values at runtime.
 *
 * This hook can be used both inside and outside `AppProvider`. When used
 * inside a nested `ThemeProvider`, it reflects the theme of that sub-tree.
 *
 * @returns The current theme settings object.
 *
 * @example
 * ```tsx
 * function ThemeDisplay() {
 *   const theme = useTheme();
 *
 *   return (
 *     <p>
 *       Light theme: {theme.light}, Dark theme: {theme.dark}
 *     </p>
 *   );
 * }
 * ```
 */ parcelHelpers.export(exports, "useTheme", ()=>useTheme);
var _react = require("react");
var _getGlobalTheme = require("@atlaskit/tokens/get-global-theme");
var _themeMutationObserver = require("@atlaskit/tokens/theme-mutation-observer");
var _theme = require("../context/theme");
function useTheme() {
    const theme = (0, _react.useContext)((0, _theme.ThemeContext));
    const [resolvedTheme, setResolvedTheme] = (0, _react.useState)(theme || (0, _getGlobalTheme.getGlobalTheme)());
    (0, _react.useEffect)(()=>{
        // We are using theme from context so no need to reference the DOM
        if (theme) return;
        const observer = new (0, _themeMutationObserver.ThemeMutationObserver)(setResolvedTheme);
        observer.observe();
        return ()=>observer.disconnect();
    }, [
        theme
    ]);
    return theme ? theme : resolvedTheme;
}

},{"react":"ltHCL","@atlaskit/tokens/get-global-theme":"8lhfU","@atlaskit/tokens/theme-mutation-observer":"bWFey","../context/theme":"kzIYk","@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"eEyBk":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _react = require("react");
var _index = require("../index");
/**
 * __useRouterLink()__
 *
 * Hook: Returns app-configured router link component.
 *
 * A generic can be passed to define advanced link configuration:
 * ```
 * type MyRouterLinkConfig = {
 *  to: string;
 *  replace?: boolean;
 * }
 *
 * const RouterLink = useRouterLink<MyRouterLinkConfig>();
 * ```
 */ const useRouterLink = ()=>{
    const { routerLinkComponent } = (0, _react.useContext)((0, _index.RouterLinkProviderContext));
    if (routerLinkComponent) return routerLinkComponent;
    return;
};
exports.default = useRouterLink;

},{"react":"ltHCL","../index":"4xhXT","@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"9jWCD":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "useId", ()=>useId);
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
function useId() {
    // React uses `:` or `«»` in selectors which breaks `document.querySelector(…)`.
    // Replace with `_` to match future React 19 functionality.
    return (0, _reactDefault.default).useId().replace(/[:«»]/g, '_');
}

},{"react":"ltHCL","@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"gKDx1":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>(0, _visuallyHiddenDefault.default));
var _visuallyHidden = require("./visually-hidden");
var _visuallyHiddenDefault = parcelHelpers.interopDefault(_visuallyHidden);

},{"./visually-hidden":"kBHcE","@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"kBHcE":[function(require,module,exports,__globalThis) {
/* visually-hidden.tsx generated by @compiled/babel-plugin v0.39.1 */ var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _react = require("react");
var _runtime = require("@compiled/react/runtime");
const visuallyHiddenStyles = null;
/**
 * __Visually hidden__
 *
 * A composable element to apply a visually hidden effect to children.
 * Useful for accessibility compliance.
 *
 * @example
 * ```jsx
 * import VisuallyHidden from '@atlaskit/visually-hidden';
 *
 * export default () => (
 *   <div style={{ border: '1px solid black' }}>
 *      There is text hidden between the brackets [
 *      <VisuallyHidden>Can't see me!</VisuallyHidden>]
 *   </div>
 * );
 * ```
 */ const VisuallyHidden = ({ children, testId, role, id })=>{
    return /*#__PURE__*/ _react.createElement("span", {
        id: id,
        "data-testid": testId,
        role: role,
        className: (0, _runtime.ax)([
            "_ca0qidpf _u5f3idpf _n3tdidpf _19bvidpf _19itidpf _1reo15vq _18m915vq _1bsbt94y _4t3it94y _kqswstnw _ogto7mnp _uiztglyw _o5721q9c"
        ])
    }, children);
};
VisuallyHidden.displayName = 'VisuallyHidden';
exports.default = VisuallyHidden;

},{"react":"ltHCL","@compiled/react/runtime":"d27Vo","@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"6twZN":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "media", ()=>(0, _mediaHelper.media));
parcelHelpers.export(exports, "UNSAFE_useMediaQuery", ()=>(0, _useMediaQuery.UNSAFE_useMediaQuery));
parcelHelpers.export(exports, "Show", ()=>(0, _show.Show));
parcelHelpers.export(exports, "Hide", ()=>(0, _hide.Hide));
var _mediaHelper = require("./media-helper");
var _useMediaQuery = require("./use-media-query");
var _show = require("./show");
var _hide = require("./hide");

},{"./media-helper":false,"./use-media-query":"kBVYh","./show":false,"./hide":false,"@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"03afQ":[function(require,module,exports,__globalThis) {
/**
 * This is an object of usable media query helpers using our internal breakpoints configuration.
 *
 * When using Compiled CSS-in-JS, please ensure that only a single declaration can take effect at a time.
 * This means that you should avoid multiple breakpoints taking effect at the same time,
 * eg. ```{ [media.above.xs]: { color: 'red' }, [media.above.sm]: { color: 'green' }}```.
 * Instead, make sure that only one breakpoint can take effect at a time,
 * e.g, ```{ [media.only.xs]: { color: 'red' }, [media.above.sm]: { color: 'green' }}```.
 * For more details, please see <https://compiledcssinjs.com/docs/atomic-css#selector-specificity>.
 */ var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "media", ()=>media);
const media = {
    above: {
        // TODO: Should this even exist, we don't want `css({ [media.above.xxs]: { … } })` because that just adds duplicates styles!
        xxs: '@media all',
        xs: '@media (min-width: 30rem)',
        sm: '@media (min-width: 48rem)',
        md: '@media (min-width: 64rem)',
        lg: '@media (min-width: 90rem)',
        xl: '@media (min-width: 110.5rem)'
    },
    only: {
        xxs: '@media (min-width: 0rem) and (max-width: 29.99rem)',
        xs: '@media (min-width: 30rem) and (max-width: 47.99rem)',
        sm: '@media (min-width: 48rem) and (max-width: 63.99rem)',
        md: '@media (min-width: 64rem) and (max-width: 89.99rem)',
        lg: '@media (min-width: 90rem) and (max-width: 110.49rem)',
        xl: '@media (min-width: 110.5rem)'
    },
    below: {
        xs: '@media not all and (min-width: 30rem)',
        sm: '@media not all and (min-width: 48rem)',
        md: '@media not all and (min-width: 64rem)',
        lg: '@media not all and (min-width: 90rem)',
        xl: '@media not all and (min-width: 110.5rem)'
    }
};

},{"@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"kBVYh":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "UNSAFE_useMediaQuery", ()=>UNSAFE_useMediaQuery);
var _react = require("react");
var _bindEventListener = require("bind-event-listener");
var _mediaHelper = require("./media-helper");
var _window_matchMedia, _window, _window_matchMedia1, _window1, _window_matchMedia2, _window2, _window_matchMedia3, _window3, _window_matchMedia4, _window4, _window_matchMedia5, _window5, _window_matchMedia6, _window6, _window_matchMedia7, _window7, _window_matchMedia8, _window8, _window_matchMedia9, _window9, _window_matchMedia10, _window10;
const queries = {
    'above.xxs': typeof window === 'undefined' ? undefined : (_window = window) === null || _window === void 0 ? void 0 : (_window_matchMedia = _window.matchMedia) === null || _window_matchMedia === void 0 ? void 0 : _window_matchMedia.call(_window, (0, _mediaHelper.media).above.xxs.replace('@media ', '').trim()),
    'above.xs': typeof window === 'undefined' ? undefined : (_window1 = window) === null || _window1 === void 0 ? void 0 : (_window_matchMedia1 = _window1.matchMedia) === null || _window_matchMedia1 === void 0 ? void 0 : _window_matchMedia1.call(_window1, (0, _mediaHelper.media).above.xs.replace('@media ', '').trim()),
    'above.sm': typeof window === 'undefined' ? undefined : (_window2 = window) === null || _window2 === void 0 ? void 0 : (_window_matchMedia2 = _window2.matchMedia) === null || _window_matchMedia2 === void 0 ? void 0 : _window_matchMedia2.call(_window2, (0, _mediaHelper.media).above.sm.replace('@media ', '').trim()),
    'above.md': typeof window === 'undefined' ? undefined : (_window3 = window) === null || _window3 === void 0 ? void 0 : (_window_matchMedia3 = _window3.matchMedia) === null || _window_matchMedia3 === void 0 ? void 0 : _window_matchMedia3.call(_window3, (0, _mediaHelper.media).above.md.replace('@media ', '').trim()),
    'above.lg': typeof window === 'undefined' ? undefined : (_window4 = window) === null || _window4 === void 0 ? void 0 : (_window_matchMedia4 = _window4.matchMedia) === null || _window_matchMedia4 === void 0 ? void 0 : _window_matchMedia4.call(_window4, (0, _mediaHelper.media).above.lg.replace('@media ', '').trim()),
    'above.xl': typeof window === 'undefined' ? undefined : (_window5 = window) === null || _window5 === void 0 ? void 0 : (_window_matchMedia5 = _window5.matchMedia) === null || _window_matchMedia5 === void 0 ? void 0 : _window_matchMedia5.call(_window5, (0, _mediaHelper.media).above.xl.replace('@media ', '').trim()),
    'below.xs': typeof window === 'undefined' ? undefined : (_window6 = window) === null || _window6 === void 0 ? void 0 : (_window_matchMedia6 = _window6.matchMedia) === null || _window_matchMedia6 === void 0 ? void 0 : _window_matchMedia6.call(_window6, (0, _mediaHelper.media).below.xs.replace('@media ', '').trim()),
    'below.sm': typeof window === 'undefined' ? undefined : (_window7 = window) === null || _window7 === void 0 ? void 0 : (_window_matchMedia7 = _window7.matchMedia) === null || _window_matchMedia7 === void 0 ? void 0 : _window_matchMedia7.call(_window7, (0, _mediaHelper.media).below.sm.replace('@media ', '').trim()),
    'below.md': typeof window === 'undefined' ? undefined : (_window8 = window) === null || _window8 === void 0 ? void 0 : (_window_matchMedia8 = _window8.matchMedia) === null || _window_matchMedia8 === void 0 ? void 0 : _window_matchMedia8.call(_window8, (0, _mediaHelper.media).below.md.replace('@media ', '').trim()),
    'below.lg': typeof window === 'undefined' ? undefined : (_window9 = window) === null || _window9 === void 0 ? void 0 : (_window_matchMedia9 = _window9.matchMedia) === null || _window_matchMedia9 === void 0 ? void 0 : _window_matchMedia9.call(_window9, (0, _mediaHelper.media).below.lg.replace('@media ', '').trim()),
    'below.xl': typeof window === 'undefined' ? undefined : (_window10 = window) === null || _window10 === void 0 ? void 0 : (_window_matchMedia10 = _window10.matchMedia) === null || _window_matchMedia10 === void 0 ? void 0 : _window_matchMedia10.call(_window10, (0, _mediaHelper.media).below.xl.replace('@media ', '').trim())
};
const UNSAFE_useMediaQuery = (queryString, listener)=>{
    const listenerRef = (0, _react.useRef)(listener);
    (0, _react.useEffect)(()=>{
        // Bind the listener if changed so it's called on the next change event; no guarantee on timing.
        listenerRef.current = listener;
    }, [
        listener
    ]);
    /**
	 * We explicitly only react to boolean changes for binding our listener
	 * Changes to the functional reference are ignored.
	 */ const hasListener = !!listener;
    /**
	 * The `matchMedia(…)` return value for our breakpoint query.
	 */ const mq = queries[queryString];
    (0, _react.useLayoutEffect)(()=>{
        listenerRef.current = listener; // Bind the listener now in case the `useEffect` hasn't fired above yet
        if (!mq || !hasListener || !listenerRef.current) return;
        return (0, _bindEventListener.bind)(mq, {
            type: 'change',
            listener: (event)=>{
                // We explicitly call the current version of the function
                return listenerRef.current(event);
            }
        });
    }, // eslint-disable-next-line react-hooks/exhaustive-deps -- explicitly do not trigger the effect on `listener` reference change, only on a boolean representation of it.
    [
        mq,
        hasListener
    ]);
    return mq || null;
};

},{"react":"ltHCL","bind-event-listener":"bjeUU","./media-helper":"03afQ","@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"7H8Wc":[function(require,module,exports,__globalThis) {
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "appearanceMapping", ()=>appearanceMapping);
const appearanceMapping = {
    added: 'success',
    removed: 'danger',
    default: 'neutral',
    primary: 'information',
    primaryInverted: 'inverse',
    important: 'danger',
    warning: 'warning',
    discovery: 'discovery',
    danger: 'danger',
    success: 'success',
    information: 'information',
    inverse: 'inverse',
    neutral: 'neutral',
    informationBold: 'informationBold',
    successBold: 'successBold',
    dangerBold: 'dangerBold',
    warningBold: 'warningBold',
    discoveryBold: 'discoveryBold'
};

},{"@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"7dgCj":[function(require,module,exports,__globalThis) {
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "appearanceMappingToOld", ()=>appearanceMappingToOld);
const appearanceMappingToOld = {
    added: 'added',
    removed: 'removed',
    default: 'default',
    primary: 'primary',
    primaryInverted: 'primaryInverted',
    important: 'important',
    danger: 'removed',
    success: 'added',
    information: 'primary',
    inverse: 'primaryInverted',
    neutral: 'default',
    warning: 'default',
    discovery: 'default',
    informationBold: 'primary',
    successBold: 'added',
    dangerBold: 'important',
    warningBold: 'default',
    discoveryBold: 'default'
};

},{"@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"3ineL":[function(require,module,exports,__globalThis) {
/* badge-new.tsx generated by @compiled/babel-plugin v0.39.1 */ var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _react = require("react");
var _runtime = require("@compiled/react/runtime");
var _compiled = require("@atlaskit/primitives/compiled");
var _useThemeObserver = require("@atlaskit/tokens/use-theme-observer");
var _formatValue = require("./internal/format-value");
// Nested selectors with data attributes are required for theme switching
const stylesNew = {
    root: "_2rkolb4i _18zr1b66 _1rjcidpf _1e0c116y _vchhusvi _1ul91ejb _1bah1h6o _1o9zidpf _1kz6184x",
    success: "_syaz1p1e _bfhk14j0",
    danger: "_syaz1blx _bfhk18wg",
    warning: "_syazmgs1 _bfhk10f4",
    information: "_syaz1qd9 _bfhk8lbg",
    discovery: "_syaz1g72 _bfhke670",
    neutral: "_syazi7uo _bfhk7qp0",
    inverse: "_bfhkvuon _syazi7uo",
    informationBold: "_syaz1qd9 _bfhk9pm7",
    successBold: "_syaz1p1e _bfhk16ib",
    dangerBold: "_syaz1blx _bfhkud63",
    warningBold: "_syazmgs1 _bfhk1kmu",
    warningBoldDark: "_syazmgs1 _bfhkgj02",
    discoveryBold: "_syaz1g72 _bfhk5ly7"
};
/* eslint-enable @atlaskit/ui-styling-standard/no-nested-selectors, @atlaskit/ui-styling-standard/no-unsafe-selectors */ const badgeValueWithNegativeNumberSupported = (children, max)=>{
    return typeof children === 'number' && max ? (0, _formatValue.formatValue)(children, max) : children;
}; /**
    * __BadgeNew__
    *
    * New visual refresh implementation of Badge component for the labelling system.
    * This component is used when the 'platform-dst-lozenge-tag-badge-visual-uplifts' feature flag is enabled.
    *
    * Uses new appearance naming convention:
    * - success (green)
    * - danger (red)
    * - neutral (gray)
    * - information (blue)
    * - inverse (inverted colors)
    * - warning (orange/yellow)
    * - discovery (purple)
    * - informationBold (bold blue, color.background.information.subtle)
    * - successBold (bold green, color.background.success.subtle)
    * - dangerBold (bold red, color.background.danger.subtle)
    * - warningBold (bold warning, color.background.warning.bold)
    * - discoveryBold (bold purple, color.background.discovery.subtle)
    */ 
const BadgeNew = /*#__PURE__*/ (0, _react.memo)(function BadgeNew({ appearance = 'neutral', children = 0, max = 99, style, testId }) {
    const { colorMode } = (0, _useThemeObserver.useThemeObserver)(); // In dark theme, warningBold needs to swap to a lighter background
    // (color.background.warning.subtle / Orange800) for better contrast against
    // the typical dark surface colors.
    const resolvedAppearance = appearance === 'warningBold' && colorMode === 'dark' ? 'warningBoldDark' : appearance;
    return /*#__PURE__*/ _react.createElement("span", {
        "data-testid": testId,
        style: {
            background: style === null || style === void 0 ? void 0 : style.backgroundColor,
            color: style === null || style === void 0 ? void 0 : style.color
        },
        className: (0, _runtime.ax)([
            stylesNew.root,
            stylesNew[resolvedAppearance]
        ])
    }, /*#__PURE__*/ _react.createElement((0, _compiled.Text), {
        size: "small",
        align: "center",
        color: "inherit"
    }, badgeValueWithNegativeNumberSupported(children, max)));
});
exports.default = BadgeNew;

},{"react":"ltHCL","@compiled/react/runtime":"d27Vo","@atlaskit/primitives/compiled":"hDay7","@atlaskit/tokens/use-theme-observer":"4S775","./internal/format-value":"higHn","@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"4S775":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "useThemeObserver", ()=>(0, _useThemeObserverDefault.default));
var _useThemeObserver = require("../use-theme-observer");
var _useThemeObserverDefault = parcelHelpers.interopDefault(_useThemeObserver);

},{"../use-theme-observer":"lcFmk","@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"lcFmk":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _react = require("react");
var _getGlobalTheme = require("./get-global-theme");
var _getGlobalThemeDefault = parcelHelpers.interopDefault(_getGlobalTheme);
var _themeMutationObserver = require("./theme-mutation-observer");
var _themeMutationObserverDefault = parcelHelpers.interopDefault(_themeMutationObserver);
/**
 * A React hook which returns the current themes and color-mode set on `<html>`.
 *
 * @example
 * ```
 * const { colorMode, dark, light, spacing, typography } = useThemeObserver();
 *
 * // Performing side effects when it changes
 * useEffect(() => {
 *   console.log(`The color mode has changed to ${theme.colorMode}`);
 * }, [theme.colorMode]);
 * ```
 */ const useThemeObserver = ()=>{
    const [theme, setTheme] = (0, _react.useState)((0, _getGlobalThemeDefault.default)());
    (0, _react.useEffect)(()=>{
        const observer = new (0, _themeMutationObserverDefault.default)((theme)=>setTheme(theme));
        observer.observe();
        return ()=>observer.disconnect();
    }, []);
    return theme;
};
exports.default = useThemeObserver;

},{"react":"ltHCL","./get-global-theme":"acd8k","./theme-mutation-observer":"4qKqG","@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"higHn":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "formatValue", ()=>formatValue);
function getSafeValue(value = 0) {
    const numericValue = +value;
    if (numericValue < 0) return 0;
    return value;
}
function formatValue(value, max) {
    const safeValue = getSafeValue(value);
    const safeMax = getSafeValue(max);
    if (safeMax && safeMax < safeValue) return `${safeMax}+`;
    if (safeValue === Infinity) return "\u221E";
    return safeValue.toString();
}

},{"@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"a8h4P":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "formatValueWithNegativeSupport", ()=>formatValueWithNegativeSupport);
function getSafeValueWithNegativeSupport(value = 0) {
    const numericValue = +value;
    // NOTE: Changing below code as this causes custom fields -ve number to show up as zero in activity timeline.
    // This will ensure it renders correctly if it is a number otherwise renders 0
    // If the value is NaN, return it as is (assuming it's a non-numeric string)
    if (isNaN(numericValue)) return value;
    // Return the numeric value, allowing negative numbers
    return numericValue;
}
function formatValueWithNegativeSupport(value, max) {
    const safeValue = getSafeValueWithNegativeSupport(value);
    const safeMax = getSafeValueWithNegativeSupport(max);
    let hasSafeMaxValue = false;
    if (max !== undefined) hasSafeMaxValue = true;
    if (safeMax === Infinity && safeValue === Infinity) return "\u221E";
    if (hasSafeMaxValue && safeMax < safeValue) return `${safeMax}+`;
    if (safeValue === Infinity) return "\u221E";
    return safeValue.toString();
}

},{"@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"7mJX1":[function(require,module,exports,__globalThis) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::a6e34d167858ba514f74d5881b8440fc>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = void 0;
var _react = _interopRequireDefault(require("2327fd062c78ba1e"));
var _baseNew = _interopRequireDefault(require("ad4fb8911f01a770"));
function _interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "Cross".
 * Category: multi-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Known uses: closing modals, panels, and transient views; removing tags
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const CrossIcon = (props)=>/*#__PURE__*/ _react.default.createElement(_baseNew.default, Object.assign({
        name: "CrossIcon",
        dangerouslySetGlyph: `<path fill="currentcolor" d="M13.53 3.53 9.06 8l4.47 4.47-1.06 1.06L8 9.06l-4.47 4.47-1.06-1.06L6.94 8 2.47 3.53l1.06-1.06L8 6.94l4.47-4.47z"/>`
    }, props));
CrossIcon.displayName = 'CrossIcon';
var _default = exports.default = CrossIcon;

},{"2327fd062c78ba1e":"ltHCL","ad4fb8911f01a770":"5XL7D"}],"5XL7D":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>(0, _iconNewDefault.default));
parcelHelpers.export(exports, "Icon", ()=>(0, _iconNew.Icon));
var _iconNew = require("../components/icon-new");
var _iconNewDefault = parcelHelpers.interopDefault(_iconNew);

},{"../components/icon-new":"hXbmM","@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"hXbmM":[function(require,module,exports,__globalThis) {
/* icon-new.tsx generated by @compiled/babel-plugin v0.39.1 */ var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "Icon", ()=>Icon);
var _react = require("react");
var _runtime = require("@compiled/react/runtime");
const svgStyles = null;
const iconStyles = null;
const smallIconStyles = null;
const scaleStyles = null;
/**
 * For windows high contrast mode
 */ const baseHcmStyles = null;
const scaleSize = null;
const coreSizeMedium = {
    none: "_1bsbpxbi _4t3ipxbi",
    compact: "_1bsb1ejb _4t3i1ejb",
    spacious: "_1bsb1ejb _4t3i1ejb"
};
const coreSizeSmall = {
    none: "_1bsbutpp _4t3iutpp",
    compact: "_1bsbpxbi _4t3ipxbi",
    spacious: "_1bsb1ejb _4t3i1ejb"
};
const paddingMap = {
    medium: {
        none: 0,
        compact: 4,
        spacious: 4
    },
    small: {
        none: 0,
        compact: 2.66,
        spacious: 8
    }
};
const Icon = /*#__PURE__*/ (0, _react.memo)(function Icon(props) {
    const { color = 'currentColor', testId, label, // Used to set icon dimensions/behaviour in codegen
    // Used to set icon glyphs in codegen
    dangerouslySetGlyph, // Used with iconTile to scale icon up and down
    shouldScale, spacing = 'none', name } = props;
    const dangerouslySetInnerHTML = dangerouslySetGlyph ? {
        __html: dangerouslySetGlyph
    } : undefined;
    let size = 'medium';
    if ('size' in props && props.size !== undefined) {
        if (typeof props.size === 'string') size = props.size === 'small' || props.size === 'medium' ? props.size : size;
        else if (name) {
            const newSize = props.size(name);
            size = newSize === 'small' || newSize === 'medium' ? newSize : size;
        }
    }
    const baseSize = 16;
    const viewBoxPadding = paddingMap[size][spacing];
    const viewBoxSize = baseSize + 2 * viewBoxPadding;
    return /*#__PURE__*/ _react.createElement("span", {
        "data-testid": testId,
        role: label ? 'img' : undefined,
        "aria-label": label ? label : undefined,
        "aria-hidden": label ? undefined : true,
        style: {
            color
        },
        className: (0, _runtime.ax)([
            "_1e0c1o8l _vchhusvi _1o9zidpf _vwz4kb7n _y4ti1igz _bozg1mb9",
            "_12va1onz _jcxd1r8n",
            shouldScale && "_1bsb1kw7 _4t3i1kw7",
            size === 'small' && "_vwz4utpp"
        ])
    }, /*#__PURE__*/ _react.createElement("svg", {
        fill: "none",
        // Adjusting the viewBox allows the icon padding to scale with the contents of the SVG, which
        // we want for Icon Tile
        viewBox: `${0 - viewBoxPadding} ${0 - viewBoxPadding} ${viewBoxSize} ${viewBoxSize}`,
        role: "presentation",
        dangerouslySetInnerHTML: dangerouslySetInnerHTML,
        className: (0, _runtime.ax)([
            "_1reo15vq _18m915vq _syaz1r31 _lcxvglyw _s7n4yfq0 _vc881r31",
            shouldScale ? "_1bsb1kw7 _4t3i1kw7" : size === 'small' ? coreSizeSmall[spacing] : coreSizeMedium[spacing]
        ])
    }));
});
// eslint-disable-next-line @atlaskit/volt-strict-mode/no-multiple-exports
exports.default = Icon;

},{"react":"ltHCL","@compiled/react/runtime":"d27Vo","@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"hb6DX":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>(0, _pressableDefault.default));
var _pressable = require("../components/pressable");
var _pressableDefault = parcelHelpers.interopDefault(_pressable);

},{"../components/pressable":"kTwbY","@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"kTwbY":[function(require,module,exports,__globalThis) {
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _objectSpread = require("@swc/helpers/_/_object_spread");
var _objectSpreadProps = require("@swc/helpers/_/_object_spread_props");
var _objectWithoutProperties = require("@swc/helpers/_/_object_without_properties");
var _react = require("react");
// eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled -- Ignored via go/DSP-18766
var _react1 = require("@emotion/react");
var _analyticsNext = require("@atlaskit/analytics-next");
var _noop = require("@atlaskit/ds-lib/noop");
var _noopDefault = parcelHelpers.interopDefault(_noop);
var _interactionContext = require("@atlaskit/interaction-context");
var _interactionContextDefault = parcelHelpers.interopDefault(_interactionContext);
var _styleMapsPartial = require("../xcss/style-maps.partial");
var _xcss = require("../xcss/xcss");
// This duplicates FocusRing styles from `@atlaskit/focus-ring`.
const focusRingStyles = (0, _react1.css)({
    '&:focus, &:focus-visible': {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values
        outlineColor: (0, _styleMapsPartial.borderColorMap)['color.border.focused'],
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values
        outlineOffset: (0, _styleMapsPartial.positiveSpaceMap)['space.025'],
        outlineStyle: 'solid',
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values
        outlineWidth: (0, _styleMapsPartial.borderWidthMap)['border.width.focused']
    },
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-selectors
    '&:focus:not(:focus-visible)': {
        outline: 'none'
    },
    '@media screen and (forced-colors: active), screen and (-ms-high-contrast: active)': {
        '&:focus-visible': {
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values
            outline: `${(0, _styleMapsPartial.borderWidthMap)['border.width']} solid`
        }
    }
});
const baseStyles = (0, _react1.css)({
    boxSizing: 'border-box',
    appearance: 'none',
    border: 'none'
});
const enabledStyles = (0, _react1.css)({
    cursor: 'pointer'
});
const disabledStyles = (0, _react1.css)({
    cursor: 'not-allowed'
});
/**
 * __Pressable__
 *
 * A primitive for building custom buttons.
 *
 * - [Examples](https://atlassian.design/components/primitives/pressable/examples)
 * - [Code](https://atlassian.design/components/primitives/pressable/code)
 * - [Usage](https://atlassian.design/components/primitives/pressable/usage)
 */ const Pressable = /*#__PURE__*/ (0, _react.forwardRef)((_param, ref)=>{
    var { children, backgroundColor, padding, paddingBlock, paddingBlockStart, paddingBlockEnd, paddingInline, paddingInlineStart, paddingInlineEnd, isDisabled, type = 'button', onClick: providedOnClick = (0, _noopDefault.default), interactionName, componentName, analyticsContext, style, testId, xcss } = _param, htmlAttributes = (0, _objectWithoutProperties._)(_param, [
        "children",
        "backgroundColor",
        "padding",
        "paddingBlock",
        "paddingBlockStart",
        "paddingBlockEnd",
        "paddingInline",
        "paddingInlineStart",
        "paddingInlineEnd",
        "isDisabled",
        "type",
        "onClick",
        "interactionName",
        "componentName",
        "analyticsContext",
        "style",
        "testId",
        "xcss"
    ]);
    const interactionContext = (0, _react.useContext)((0, _interactionContextDefault.default));
    const handleClick = (0, _react.useCallback)((e, analyticsEvent)=>{
        interactionContext && interactionContext.tracePress(interactionName, e.timeStamp);
        providedOnClick(e, analyticsEvent);
    }, [
        providedOnClick,
        interactionContext,
        interactionName
    ]);
    const onClick = (0, _analyticsNext.usePlatformLeafEventHandler)({
        fn: handleClick,
        action: 'clicked',
        componentName: componentName || 'Pressable',
        packageName: "@af/atlassian-studio",
        packageVersion: "0.16.1",
        analyticsData: analyticsContext,
        actionSubject: 'button'
    });
    // This is to remove className from safeHtmlAttributes
    // @ts-expect-error className doesn't exist in the prop definition but we want to ensure it cannot be applied even if types are bypassed
    const { className: _spreadClass } = htmlAttributes, safeHtmlAttributes = (0, _objectWithoutProperties._)(htmlAttributes, [
        "className"
    ]);
    const resolvedStyles = (0, _xcss.parseXcss)(xcss);
    return /*#__PURE__*/ (0, _react1.jsx)("button", (0, _objectSpreadProps._)((0, _objectSpread._)({
        style: style,
        ref: ref,
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
        className: resolvedStyles.static
    }, safeHtmlAttributes), {
        // eslint-disable-next-line react/button-has-type
        type: type,
        onClick: onClick,
        disabled: isDisabled,
        css: [
            baseStyles,
            focusRingStyles,
            isDisabled ? disabledStyles : enabledStyles,
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
            backgroundColor && (0, _styleMapsPartial.backgroundColorStylesMap)[backgroundColor],
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
            padding && (0, _styleMapsPartial.paddingStylesMap).padding[padding],
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
            paddingBlock && (0, _styleMapsPartial.paddingStylesMap).paddingBlock[paddingBlock],
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
            paddingBlockStart && (0, _styleMapsPartial.paddingStylesMap).paddingBlockStart[paddingBlockStart],
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
            paddingBlockEnd && (0, _styleMapsPartial.paddingStylesMap).paddingBlockEnd[paddingBlockEnd],
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
            paddingInline && (0, _styleMapsPartial.paddingStylesMap).paddingInline[paddingInline],
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
            paddingInlineStart && (0, _styleMapsPartial.paddingStylesMap).paddingInlineStart[paddingInlineStart],
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
            paddingInlineEnd && (0, _styleMapsPartial.paddingStylesMap).paddingInlineEnd[paddingInlineEnd],
            ...resolvedStyles.emotion || []
        ],
        "data-testid": testId
    }), children);
});
exports.default = Pressable;

},{"@swc/helpers/_/_object_spread":"9gdrV","@swc/helpers/_/_object_spread_props":"kANqQ","@swc/helpers/_/_object_without_properties":"6HqIM","react":"ltHCL","@emotion/react":"cCAhJ","@atlaskit/analytics-next":"6PLie","@atlaskit/ds-lib/noop":"faKzG","@atlaskit/interaction-context":"18HT9","../xcss/style-maps.partial":"a7SYG","../xcss/xcss":"fMzqB","@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"cCAhJ":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "CacheProvider", ()=>(0, _emotionElement43C6Fea0BrowserEsmJs.C));
parcelHelpers.export(exports, "ThemeContext", ()=>(0, _emotionElement43C6Fea0BrowserEsmJs.T));
parcelHelpers.export(exports, "ThemeProvider", ()=>(0, _emotionElement43C6Fea0BrowserEsmJs.a));
parcelHelpers.export(exports, "__unsafe_useEmotionCache", ()=>(0, _emotionElement43C6Fea0BrowserEsmJs._));
parcelHelpers.export(exports, "useTheme", ()=>(0, _emotionElement43C6Fea0BrowserEsmJs.u));
parcelHelpers.export(exports, "withEmotionCache", ()=>(0, _emotionElement43C6Fea0BrowserEsmJs.w));
parcelHelpers.export(exports, "withTheme", ()=>(0, _emotionElement43C6Fea0BrowserEsmJs.b));
parcelHelpers.export(exports, "ClassNames", ()=>ClassNames);
parcelHelpers.export(exports, "Global", ()=>Global);
parcelHelpers.export(exports, "createElement", ()=>jsx);
parcelHelpers.export(exports, "css", ()=>css);
parcelHelpers.export(exports, "jsx", ()=>jsx);
parcelHelpers.export(exports, "keyframes", ()=>keyframes);
var _emotionElement43C6Fea0BrowserEsmJs = require("./emotion-element-43c6fea0.browser.esm.js");
var _react = require("react");
var _utils = require("@emotion/utils");
var _useInsertionEffectWithFallbacks = require("@emotion/use-insertion-effect-with-fallbacks");
var _serialize = require("@emotion/serialize");
var _cache = require("@emotion/cache");
var _extends = require("@babel/runtime/helpers/extends");
var _weakMemoize = require("@emotion/weak-memoize");
var _emotionReactIsolatedHnrsBrowserEsmJs = require("../_isolated-hnrs/dist/emotion-react-_isolated-hnrs.browser.esm.js");
var _hoistNonReactStatics = require("hoist-non-react-statics");
var pkg = {
    name: "@emotion/react",
    version: "11.11.4",
    main: "dist/emotion-react.cjs.js",
    module: "dist/emotion-react.esm.js",
    browser: {
        "./dist/emotion-react.esm.js": "./dist/emotion-react.browser.esm.js"
    },
    exports: {
        ".": {
            module: {
                worker: "./dist/emotion-react.worker.esm.js",
                browser: "./dist/emotion-react.browser.esm.js",
                "default": "./dist/emotion-react.esm.js"
            },
            "import": "./dist/emotion-react.cjs.mjs",
            "default": "./dist/emotion-react.cjs.js"
        },
        "./jsx-runtime": {
            module: {
                worker: "./jsx-runtime/dist/emotion-react-jsx-runtime.worker.esm.js",
                browser: "./jsx-runtime/dist/emotion-react-jsx-runtime.browser.esm.js",
                "default": "./jsx-runtime/dist/emotion-react-jsx-runtime.esm.js"
            },
            "import": "./jsx-runtime/dist/emotion-react-jsx-runtime.cjs.mjs",
            "default": "./jsx-runtime/dist/emotion-react-jsx-runtime.cjs.js"
        },
        "./_isolated-hnrs": {
            module: {
                worker: "./_isolated-hnrs/dist/emotion-react-_isolated-hnrs.worker.esm.js",
                browser: "./_isolated-hnrs/dist/emotion-react-_isolated-hnrs.browser.esm.js",
                "default": "./_isolated-hnrs/dist/emotion-react-_isolated-hnrs.esm.js"
            },
            "import": "./_isolated-hnrs/dist/emotion-react-_isolated-hnrs.cjs.mjs",
            "default": "./_isolated-hnrs/dist/emotion-react-_isolated-hnrs.cjs.js"
        },
        "./jsx-dev-runtime": {
            module: {
                worker: "./jsx-dev-runtime/dist/emotion-react-jsx-dev-runtime.worker.esm.js",
                browser: "./jsx-dev-runtime/dist/emotion-react-jsx-dev-runtime.browser.esm.js",
                "default": "./jsx-dev-runtime/dist/emotion-react-jsx-dev-runtime.esm.js"
            },
            "import": "./jsx-dev-runtime/dist/emotion-react-jsx-dev-runtime.cjs.mjs",
            "default": "./jsx-dev-runtime/dist/emotion-react-jsx-dev-runtime.cjs.js"
        },
        "./package.json": "./package.json",
        "./types/css-prop": "./types/css-prop.d.ts",
        "./macro": {
            types: {
                "import": "./macro.d.mts",
                "default": "./macro.d.ts"
            },
            "default": "./macro.js"
        }
    },
    types: "types/index.d.ts",
    files: [
        "src",
        "dist",
        "jsx-runtime",
        "jsx-dev-runtime",
        "_isolated-hnrs",
        "types/*.d.ts",
        "macro.*"
    ],
    sideEffects: false,
    author: "Emotion Contributors",
    license: "MIT",
    scripts: {
        "test:typescript": "dtslint types"
    },
    dependencies: {
        "@babel/runtime": "^7.18.3",
        "@emotion/babel-plugin": "^11.11.0",
        "@emotion/cache": "^11.11.0",
        "@emotion/serialize": "^1.1.3",
        "@emotion/use-insertion-effect-with-fallbacks": "^1.0.1",
        "@emotion/utils": "^1.2.1",
        "@emotion/weak-memoize": "^0.3.1",
        "hoist-non-react-statics": "^3.3.1"
    },
    peerDependencies: {
        react: ">=16.8.0"
    },
    peerDependenciesMeta: {
        "@types/react": {
            optional: true
        }
    },
    devDependencies: {
        "@definitelytyped/dtslint": "0.0.112",
        "@emotion/css": "11.11.2",
        "@emotion/css-prettifier": "1.1.3",
        "@emotion/server": "11.11.0",
        "@emotion/styled": "11.11.0",
        "html-tag-names": "^1.1.2",
        react: "16.14.0",
        "svg-tag-names": "^1.1.1",
        typescript: "^4.5.5"
    },
    repository: "https://github.com/emotion-js/emotion/tree/main/packages/react",
    publishConfig: {
        access: "public"
    },
    "umd:main": "dist/emotion-react.umd.min.js",
    preconstruct: {
        entrypoints: [
            "./index.js",
            "./jsx-runtime.js",
            "./jsx-dev-runtime.js",
            "./_isolated-hnrs.js"
        ],
        umdName: "emotionReact",
        exports: {
            envConditions: [
                "browser",
                "worker"
            ],
            extra: {
                "./types/css-prop": "./types/css-prop.d.ts",
                "./macro": {
                    types: {
                        "import": "./macro.d.mts",
                        "default": "./macro.d.ts"
                    },
                    "default": "./macro.js"
                }
            }
        }
    }
};
var jsx = function jsx(type, props) {
    var args = arguments;
    if (props == null || !(0, _emotionElement43C6Fea0BrowserEsmJs.h).call(props, 'css')) // $FlowFixMe
    return _react.createElement.apply(undefined, args);
    var argsLength = args.length;
    var createElementArgArray = new Array(argsLength);
    createElementArgArray[0] = (0, _emotionElement43C6Fea0BrowserEsmJs.E);
    createElementArgArray[1] = (0, _emotionElement43C6Fea0BrowserEsmJs.c)(type, props);
    for(var i = 2; i < argsLength; i++)createElementArgArray[i] = args[i];
     // $FlowFixMe
    return _react.createElement.apply(null, createElementArgArray);
};
var warnedAboutCssPropForGlobal = false; // maintain place over rerenders.
// initial render from browser, insertBefore context.sheet.tags[0] or if a style hasn't been inserted there yet, appendChild
// initial client-side render from SSR, use place of hydrating tag
var Global = /* #__PURE__ */ (0, _emotionElement43C6Fea0BrowserEsmJs.w)(function(props, cache) {
    var styles = props.styles;
    var serialized = (0, _serialize.serializeStyles)([
        styles
    ], undefined, _react.useContext((0, _emotionElement43C6Fea0BrowserEsmJs.T)));
    if (!(0, _emotionElement43C6Fea0BrowserEsmJs.i)) {
        var _ref;
        var serializedNames = serialized.name;
        var serializedStyles = serialized.styles;
        var next = serialized.next;
        while(next !== undefined){
            serializedNames += ' ' + next.name;
            serializedStyles += next.styles;
            next = next.next;
        }
        var shouldCache = cache.compat === true;
        var rules = cache.insert("", {
            name: serializedNames,
            styles: serializedStyles
        }, cache.sheet, shouldCache);
        if (shouldCache) return null;
        return /*#__PURE__*/ _react.createElement("style", (_ref = {}, _ref["data-emotion"] = cache.key + "-global " + serializedNames, _ref.dangerouslySetInnerHTML = {
            __html: rules
        }, _ref.nonce = cache.sheet.nonce, _ref));
    } // yes, i know these hooks are used conditionally
    // but it is based on a constant that will never change at runtime
    // it's effectively like having two implementations and switching them out
    // so it's not actually breaking anything
    var sheetRef = _react.useRef();
    (0, _useInsertionEffectWithFallbacks.useInsertionEffectWithLayoutFallback)(function() {
        var key = cache.key + "-global"; // use case of https://github.com/emotion-js/emotion/issues/2675
        var sheet = new cache.sheet.constructor({
            key: key,
            nonce: cache.sheet.nonce,
            container: cache.sheet.container,
            speedy: cache.sheet.isSpeedy
        });
        var rehydrating = false; // $FlowFixMe
        var node = document.querySelector("style[data-emotion=\"" + key + " " + serialized.name + "\"]");
        if (cache.sheet.tags.length) sheet.before = cache.sheet.tags[0];
        if (node !== null) {
            rehydrating = true; // clear the hash so this node won't be recognizable as rehydratable by other <Global/>s
            node.setAttribute('data-emotion', key);
            sheet.hydrate([
                node
            ]);
        }
        sheetRef.current = [
            sheet,
            rehydrating
        ];
        return function() {
            sheet.flush();
        };
    }, [
        cache
    ]);
    (0, _useInsertionEffectWithFallbacks.useInsertionEffectWithLayoutFallback)(function() {
        var sheetRefCurrent = sheetRef.current;
        var sheet = sheetRefCurrent[0], rehydrating = sheetRefCurrent[1];
        if (rehydrating) {
            sheetRefCurrent[1] = false;
            return;
        }
        if (serialized.next !== undefined) // insert keyframes
        (0, _utils.insertStyles)(cache, serialized.next, true);
        if (sheet.tags.length) {
            // if this doesn't exist then it will be null so the style element will be appended
            var element = sheet.tags[sheet.tags.length - 1].nextElementSibling;
            sheet.before = element;
            sheet.flush();
        }
        cache.insert("", serialized, sheet, false);
    }, [
        cache,
        serialized.name
    ]);
    return null;
});
function css() {
    for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
    return (0, _serialize.serializeStyles)(args);
}
var keyframes = function keyframes() {
    var insertable = css.apply(void 0, arguments);
    var name = "animation-" + insertable.name; // $FlowFixMe
    return {
        name: name,
        styles: "@keyframes " + name + "{" + insertable.styles + "}",
        anim: 1,
        toString: function toString() {
            return "_EMO_" + this.name + "_" + this.styles + "_EMO_";
        }
    };
};
var classnames = function classnames(args) {
    var len = args.length;
    var i = 0;
    var cls = '';
    for(; i < len; i++){
        var arg = args[i];
        if (arg == null) continue;
        var toAdd = void 0;
        switch(typeof arg){
            case 'boolean':
                break;
            case 'object':
                if (Array.isArray(arg)) toAdd = classnames(arg);
                else {
                    toAdd = '';
                    for(var k in arg)if (arg[k] && k) {
                        toAdd && (toAdd += ' ');
                        toAdd += k;
                    }
                }
                break;
            default:
                toAdd = arg;
        }
        if (toAdd) {
            cls && (cls += ' ');
            cls += toAdd;
        }
    }
    return cls;
};
function merge(registered, css, className) {
    var registeredStyles = [];
    var rawClassName = (0, _utils.getRegisteredStyles)(registered, registeredStyles, className);
    if (registeredStyles.length < 2) return className;
    return rawClassName + css(registeredStyles);
}
var Insertion = function Insertion(_ref) {
    var cache = _ref.cache, serializedArr = _ref.serializedArr;
    (0, _useInsertionEffectWithFallbacks.useInsertionEffectAlwaysWithSyncFallback)(function() {
        for(var i = 0; i < serializedArr.length; i++)(0, _utils.insertStyles)(cache, serializedArr[i], false);
    });
    return null;
};
var ClassNames = /* #__PURE__ */ (0, _emotionElement43C6Fea0BrowserEsmJs.w)(function(props, cache) {
    var hasRendered = false;
    var serializedArr = [];
    var css = function css() {
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        var serialized = (0, _serialize.serializeStyles)(args, cache.registered);
        serializedArr.push(serialized); // registration has to happen here as the result of this might get consumed by `cx`
        (0, _utils.registerStyles)(cache, serialized, false);
        return cache.key + "-" + serialized.name;
    };
    var cx = function cx() {
        for(var _len2 = arguments.length, args = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++)args[_key2] = arguments[_key2];
        return merge(cache.registered, css, classnames(args));
    };
    var content = {
        css: css,
        cx: cx,
        theme: _react.useContext((0, _emotionElement43C6Fea0BrowserEsmJs.T))
    };
    var ele = props.children(content);
    hasRendered = true;
    return /*#__PURE__*/ _react.createElement(_react.Fragment, null, /*#__PURE__*/ _react.createElement(Insertion, {
        cache: cache,
        serializedArr: serializedArr
    }), ele);
});
var isBrowser, isTestEnv, globalContext, globalKey;

},{"./emotion-element-43c6fea0.browser.esm.js":"hN1rQ","react":"ltHCL","@emotion/utils":"9m6eO","@emotion/use-insertion-effect-with-fallbacks":"6a6BT","@emotion/serialize":"7NJwA","@emotion/cache":"6fGRf","@babel/runtime/helpers/extends":"3LZYG","@emotion/weak-memoize":"aJNMy","../_isolated-hnrs/dist/emotion-react-_isolated-hnrs.browser.esm.js":"gUQuF","hoist-non-react-statics":"nZLnq","@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"hN1rQ":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "C", ()=>CacheProvider);
parcelHelpers.export(exports, "E", ()=>Emotion$1);
parcelHelpers.export(exports, "T", ()=>ThemeContext);
parcelHelpers.export(exports, "_", ()=>__unsafe_useEmotionCache);
parcelHelpers.export(exports, "a", ()=>ThemeProvider);
parcelHelpers.export(exports, "b", ()=>withTheme);
parcelHelpers.export(exports, "c", ()=>createEmotionProps);
parcelHelpers.export(exports, "h", ()=>hasOwn);
parcelHelpers.export(exports, "i", ()=>isBrowser);
parcelHelpers.export(exports, "u", ()=>useTheme);
parcelHelpers.export(exports, "w", ()=>withEmotionCache);
var _react = require("react");
var _cache = require("@emotion/cache");
var _cacheDefault = parcelHelpers.interopDefault(_cache);
var _extends = require("@babel/runtime/helpers/esm/extends");
var _extendsDefault = parcelHelpers.interopDefault(_extends);
var _weakMemoize = require("@emotion/weak-memoize");
var _weakMemoizeDefault = parcelHelpers.interopDefault(_weakMemoize);
var _emotionReactIsolatedHnrsBrowserEsmJs = require("../_isolated-hnrs/dist/emotion-react-_isolated-hnrs.browser.esm.js");
var _emotionReactIsolatedHnrsBrowserEsmJsDefault = parcelHelpers.interopDefault(_emotionReactIsolatedHnrsBrowserEsmJs);
var _utils = require("@emotion/utils");
var _serialize = require("@emotion/serialize");
var _useInsertionEffectWithFallbacks = require("@emotion/use-insertion-effect-with-fallbacks");
var isBrowser = true;
var hasOwn = {}.hasOwnProperty;
var EmotionCacheContext = /* #__PURE__ */ _react.createContext(// because this module is primarily intended for the browser and node
// but it's also required in react native and similar environments sometimes
// and we could have a special build just for that
// but this is much easier and the native packages
// might use a different theme context in the future anyway
typeof HTMLElement !== 'undefined' ? /* #__PURE__ */ (0, _cacheDefault.default)({
    key: 'css'
}) : null);
var CacheProvider = EmotionCacheContext.Provider;
var __unsafe_useEmotionCache = function useEmotionCache() {
    return (0, _react.useContext)(EmotionCacheContext);
};
var withEmotionCache = function withEmotionCache(func) {
    // $FlowFixMe
    return /*#__PURE__*/ (0, _react.forwardRef)(function(props, ref) {
        // the cache will never be null in the browser
        var cache = (0, _react.useContext)(EmotionCacheContext);
        return func(props, cache, ref);
    });
};
if (!isBrowser) withEmotionCache = function withEmotionCache(func) {
    return function(props) {
        var cache = (0, _react.useContext)(EmotionCacheContext);
        if (cache === null) {
            // yes, we're potentially creating this on every render
            // it doesn't actually matter though since it's only on the server
            // so there will only every be a single render
            // that could change in the future because of suspense and etc. but for now,
            // this works and i don't want to optimise for a future thing that we aren't sure about
            cache = (0, _cacheDefault.default)({
                key: 'css'
            });
            return /*#__PURE__*/ _react.createElement(EmotionCacheContext.Provider, {
                value: cache
            }, func(props, cache));
        } else return func(props, cache);
    };
};
var ThemeContext = /* #__PURE__ */ _react.createContext({});
var useTheme = function useTheme() {
    return _react.useContext(ThemeContext);
};
var getTheme = function getTheme(outerTheme, theme) {
    if (typeof theme === 'function') {
        var mergedTheme = theme(outerTheme);
        return mergedTheme;
    }
    return (0, _extendsDefault.default)({}, outerTheme, theme);
};
var createCacheWithTheme = /* #__PURE__ */ (0, _weakMemoizeDefault.default)(function(outerTheme) {
    return (0, _weakMemoizeDefault.default)(function(theme) {
        return getTheme(outerTheme, theme);
    });
});
var ThemeProvider = function ThemeProvider(props) {
    var theme = _react.useContext(ThemeContext);
    if (props.theme !== theme) theme = createCacheWithTheme(theme)(props.theme);
    return /*#__PURE__*/ _react.createElement(ThemeContext.Provider, {
        value: theme
    }, props.children);
};
function withTheme(Component) {
    var componentName = Component.displayName || Component.name || 'Component';
    var render = function render(props, ref) {
        var theme = _react.useContext(ThemeContext);
        return /*#__PURE__*/ _react.createElement(Component, (0, _extendsDefault.default)({
            theme: theme,
            ref: ref
        }, props));
    }; // $FlowFixMe
    var WithTheme = /*#__PURE__*/ _react.forwardRef(render);
    WithTheme.displayName = "WithTheme(" + componentName + ")";
    return (0, _emotionReactIsolatedHnrsBrowserEsmJsDefault.default)(WithTheme, Component);
}
var getLastPart = function getLastPart(functionName) {
    // The match may be something like 'Object.createEmotionProps' or
    // 'Loader.prototype.render'
    var parts = functionName.split('.');
    return parts[parts.length - 1];
};
var getFunctionNameFromStackTraceLine = function getFunctionNameFromStackTraceLine(line) {
    // V8
    var match = /^\s+at\s+([A-Za-z0-9$.]+)\s/.exec(line);
    if (match) return getLastPart(match[1]); // Safari / Firefox
    match = /^([A-Za-z0-9$.]+)@/.exec(line);
    if (match) return getLastPart(match[1]);
    return undefined;
};
var internalReactFunctionNames = /* #__PURE__ */ new Set([
    'renderWithHooks',
    'processChild',
    'finishClassComponent',
    'renderToString'
]); // These identifiers come from error stacks, so they have to be valid JS
// identifiers, thus we only need to replace what is a valid character for JS,
// but not for CSS.
var sanitizeIdentifier = function sanitizeIdentifier(identifier) {
    return identifier.replace(/\$/g, '-');
};
var getLabelFromStackTrace = function getLabelFromStackTrace(stackTrace) {
    if (!stackTrace) return undefined;
    var lines = stackTrace.split('\n');
    for(var i = 0; i < lines.length; i++){
        var functionName = getFunctionNameFromStackTraceLine(lines[i]); // The first line of V8 stack traces is just "Error"
        if (!functionName) continue; // If we reach one of these, we have gone too far and should quit
        if (internalReactFunctionNames.has(functionName)) break; // The component name is the first function in the stack that starts with an
        // uppercase letter
        if (/^[A-Z]/.test(functionName)) return sanitizeIdentifier(functionName);
    }
    return undefined;
};
var typePropName = '__EMOTION_TYPE_PLEASE_DO_NOT_USE__';
var labelPropName = '__EMOTION_LABEL_PLEASE_DO_NOT_USE__';
var createEmotionProps = function createEmotionProps(type, props) {
    var newProps = {};
    for(var key in props)if (hasOwn.call(props, key)) newProps[key] = props[key];
    newProps[typePropName] = type; // For performance, only call getLabelFromStackTrace in development and when
    var label;
    return newProps;
};
var Insertion = function Insertion(_ref) {
    var cache = _ref.cache, serialized = _ref.serialized, isStringTag = _ref.isStringTag;
    (0, _utils.registerStyles)(cache, serialized, isStringTag);
    (0, _useInsertionEffectWithFallbacks.useInsertionEffectAlwaysWithSyncFallback)(function() {
        return (0, _utils.insertStyles)(cache, serialized, isStringTag);
    });
    return null;
};
var Emotion = /* #__PURE__ */ withEmotionCache(function(props, cache, ref) {
    var cssProp = props.css; // so that using `css` from `emotion` and passing the result to the css prop works
    // not passing the registered cache to serializeStyles because it would
    // make certain babel optimisations not possible
    if (typeof cssProp === 'string' && cache.registered[cssProp] !== undefined) cssProp = cache.registered[cssProp];
    var WrappedComponent = props[typePropName];
    var registeredStyles = [
        cssProp
    ];
    var className = '';
    if (typeof props.className === 'string') className = (0, _utils.getRegisteredStyles)(cache.registered, registeredStyles, props.className);
    else if (props.className != null) className = props.className + " ";
    var serialized = (0, _serialize.serializeStyles)(registeredStyles, undefined, _react.useContext(ThemeContext));
    var labelFromStack;
    className += cache.key + "-" + serialized.name;
    var newProps = {};
    for(var key in props)if (hasOwn.call(props, key) && key !== 'css' && key !== typePropName && true) newProps[key] = props[key];
    newProps.ref = ref;
    newProps.className = className;
    return /*#__PURE__*/ _react.createElement(_react.Fragment, null, /*#__PURE__*/ _react.createElement(Insertion, {
        cache: cache,
        serialized: serialized,
        isStringTag: typeof WrappedComponent === 'string'
    }), /*#__PURE__*/ _react.createElement(WrappedComponent, newProps));
});
var Emotion$1 = Emotion;

},{"react":"ltHCL","@emotion/cache":"6fGRf","@babel/runtime/helpers/esm/extends":"3LZYG","@emotion/weak-memoize":"aJNMy","../_isolated-hnrs/dist/emotion-react-_isolated-hnrs.browser.esm.js":"gUQuF","@emotion/utils":"9m6eO","@emotion/serialize":"7NJwA","@emotion/use-insertion-effect-with-fallbacks":"6a6BT","@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"6fGRf":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>createCache);
var _sheet = require("@emotion/sheet");
var _stylis = require("stylis");
var _weakMemoize = require("@emotion/weak-memoize");
var _memoize = require("@emotion/memoize");
var identifierWithPointTracking = function identifierWithPointTracking(begin, points, index) {
    var previous = 0;
    var character = 0;
    while(true){
        previous = character;
        character = (0, _stylis.peek)(); // &\f
        if (previous === 38 && character === 12) points[index] = 1;
        if ((0, _stylis.token)(character)) break;
        (0, _stylis.next)();
    }
    return (0, _stylis.slice)(begin, (0, _stylis.position));
};
var toRules = function toRules(parsed, points) {
    // pretend we've started with a comma
    var index = -1;
    var character = 44;
    do switch((0, _stylis.token)(character)){
        case 0:
            // &\f
            if (character === 38 && (0, _stylis.peek)() === 12) // this is not 100% correct, we don't account for literal sequences here - like for example quoted strings
            // stylis inserts \f after & to know when & where it should replace this sequence with the context selector
            // and when it should just concatenate the outer and inner selectors
            // it's very unlikely for this sequence to actually appear in a different context, so we just leverage this fact here
            points[index] = 1;
            parsed[index] += identifierWithPointTracking((0, _stylis.position) - 1, points, index);
            break;
        case 2:
            parsed[index] += (0, _stylis.delimit)(character);
            break;
        case 4:
            // comma
            if (character === 44) {
                // colon
                parsed[++index] = (0, _stylis.peek)() === 58 ? '&\f' : '';
                points[index] = parsed[index].length;
                break;
            }
        // fallthrough
        default:
            parsed[index] += (0, _stylis.from)(character);
    }
    while (character = (0, _stylis.next)());
    return parsed;
};
var getRules = function getRules(value, points) {
    return (0, _stylis.dealloc)(toRules((0, _stylis.alloc)(value), points));
}; // WeakSet would be more appropriate, but only WeakMap is supported in IE11
var fixedElements = /* #__PURE__ */ new WeakMap();
var compat = function compat(element) {
    if (element.type !== 'rule' || !element.parent || // positive .length indicates that this rule contains pseudo
    // negative .length indicates that this rule has been already prefixed
    element.length < 1) return;
    var value = element.value, parent = element.parent;
    var isImplicitRule = element.column === parent.column && element.line === parent.line;
    while(parent.type !== 'rule'){
        parent = parent.parent;
        if (!parent) return;
    } // short-circuit for the simplest case
    if (element.props.length === 1 && value.charCodeAt(0) !== 58 && !fixedElements.get(parent)) return;
     // if this is an implicitly inserted rule (the one eagerly inserted at the each new nested level)
    // then the props has already been manipulated beforehand as they that array is shared between it and its "rule parent"
    if (isImplicitRule) return;
    fixedElements.set(element, true);
    var points = [];
    var rules = getRules(value, points);
    var parentRules = parent.props;
    for(var i = 0, k = 0; i < rules.length; i++)for(var j = 0; j < parentRules.length; j++, k++)element.props[k] = points[i] ? rules[i].replace(/&\f/g, parentRules[j]) : parentRules[j] + " " + rules[i];
};
var removeLabel = function removeLabel(element) {
    if (element.type === 'decl') {
        var value = element.value;
        if (value.charCodeAt(0) === 108 && // charcode for b
        value.charCodeAt(2) === 98) {
            // this ignores label
            element["return"] = '';
            element.value = '';
        }
    }
};
var ignoreFlag = 'emotion-disable-server-rendering-unsafe-selector-warning-please-do-not-use-this-the-warning-exists-for-a-reason';
var isIgnoringComment = function isIgnoringComment(element) {
    return element.type === 'comm' && element.children.indexOf(ignoreFlag) > -1;
};
var createUnsafeSelectorsAlarm = function createUnsafeSelectorsAlarm(cache) {
    return function(element, index, children) {
        if (element.type !== 'rule' || cache.compat) return;
        var unsafePseudoClasses = element.value.match(/(:first|:nth|:nth-last)-child/g);
        if (unsafePseudoClasses) {
            var isNested = !!element.parent; // in nested rules comments become children of the "auto-inserted" rule and that's always the `element.parent`
            //
            // considering this input:
            // .a {
            //   .b /* comm */ {}
            //   color: hotpink;
            // }
            // we get output corresponding to this:
            // .a {
            //   & {
            //     /* comm */
            //     color: hotpink;
            //   }
            //   .b {}
            // }
            var commentContainer = isNested ? element.parent.children : children;
            for(var i = commentContainer.length - 1; i >= 0; i--){
                var node = commentContainer[i];
                if (node.line < element.line) break;
                 // it is quite weird but comments are *usually* put at `column: element.column - 1`
                // so we seek *from the end* for the node that is earlier than the rule's `element` and check that
                // this will also match inputs like this:
                // .a {
                //   /* comm */
                //   .b {}
                // }
                //
                // but that is fine
                //
                // it would be the easiest to change the placement of the comment to be the first child of the rule:
                // .a {
                //   .b { /* comm */ }
                // }
                // with such inputs we wouldn't have to search for the comment at all
                // TODO: consider changing this comment placement in the next major version
                if (node.column < element.column) {
                    if (isIgnoringComment(node)) return;
                    break;
                }
            }
        }
    };
};
var isImportRule = function isImportRule(element) {
    return element.type.charCodeAt(1) === 105 && element.type.charCodeAt(0) === 64;
};
var isPrependedWithRegularRules = function isPrependedWithRegularRules(index, children) {
    for(var i = index - 1; i >= 0; i--){
        if (!isImportRule(children[i])) return true;
    }
    return false;
}; // use this to remove incorrect elements from further processing
// so they don't get handed to the `sheet` (or anything else)
// as that could potentially lead to additional logs which in turn could be overhelming to the user
var nullifyElement = function nullifyElement(element) {
    element.type = '';
    element.value = '';
    element["return"] = '';
    element.children = '';
    element.props = '';
};
var incorrectImportAlarm = function incorrectImportAlarm(element, index, children) {
    if (!isImportRule(element)) return;
    if (element.parent) {
        console.error("`@import` rules can't be nested inside other rules. Please move it to the top level and put it before regular rules. Keep in mind that they can only be used within global styles.");
        nullifyElement(element);
    } else if (isPrependedWithRegularRules(index, children)) {
        console.error("`@import` rules can't be after other rules. Please put your `@import` rules before your other rules.");
        nullifyElement(element);
    }
};
/* eslint-disable no-fallthrough */ function prefix(value, length) {
    switch((0, _stylis.hash)(value, length)){
        // color-adjust
        case 5103:
            return (0, _stylis.WEBKIT) + 'print-' + value + value;
        // animation, animation-(delay|direction|duration|fill-mode|iteration-count|name|play-state|timing-function)
        case 5737:
        case 4201:
        case 3177:
        case 3433:
        case 1641:
        case 4457:
        case 2921:
        case 5572:
        case 6356:
        case 5844:
        case 3191:
        case 6645:
        case 3005:
        case 6391:
        case 5879:
        case 5623:
        case 6135:
        case 4599:
        case 4855:
        case 4215:
        case 6389:
        case 5109:
        case 5365:
        case 5621:
        case 3829:
            return (0, _stylis.WEBKIT) + value + value;
        // appearance, user-select, transform, hyphens, text-size-adjust
        case 5349:
        case 4246:
        case 4810:
        case 6968:
        case 2756:
            return (0, _stylis.WEBKIT) + value + (0, _stylis.MOZ) + value + (0, _stylis.MS) + value + value;
        // flex, flex-direction
        case 6828:
        case 4268:
            return (0, _stylis.WEBKIT) + value + (0, _stylis.MS) + value + value;
        // order
        case 6165:
            return (0, _stylis.WEBKIT) + value + (0, _stylis.MS) + 'flex-' + value + value;
        // align-items
        case 5187:
            return (0, _stylis.WEBKIT) + value + (0, _stylis.replace)(value, /(\w+).+(:[^]+)/, (0, _stylis.WEBKIT) + 'box-$1$2' + (0, _stylis.MS) + 'flex-$1$2') + value;
        // align-self
        case 5443:
            return (0, _stylis.WEBKIT) + value + (0, _stylis.MS) + 'flex-item-' + (0, _stylis.replace)(value, /flex-|-self/, '') + value;
        // align-content
        case 4675:
            return (0, _stylis.WEBKIT) + value + (0, _stylis.MS) + 'flex-line-pack' + (0, _stylis.replace)(value, /align-content|flex-|-self/, '') + value;
        // flex-shrink
        case 5548:
            return (0, _stylis.WEBKIT) + value + (0, _stylis.MS) + (0, _stylis.replace)(value, 'shrink', 'negative') + value;
        // flex-basis
        case 5292:
            return (0, _stylis.WEBKIT) + value + (0, _stylis.MS) + (0, _stylis.replace)(value, 'basis', 'preferred-size') + value;
        // flex-grow
        case 6060:
            return (0, _stylis.WEBKIT) + 'box-' + (0, _stylis.replace)(value, '-grow', '') + (0, _stylis.WEBKIT) + value + (0, _stylis.MS) + (0, _stylis.replace)(value, 'grow', 'positive') + value;
        // transition
        case 4554:
            return (0, _stylis.WEBKIT) + (0, _stylis.replace)(value, /([^-])(transform)/g, '$1' + (0, _stylis.WEBKIT) + '$2') + value;
        // cursor
        case 6187:
            return (0, _stylis.replace)((0, _stylis.replace)((0, _stylis.replace)(value, /(zoom-|grab)/, (0, _stylis.WEBKIT) + '$1'), /(image-set)/, (0, _stylis.WEBKIT) + '$1'), value, '') + value;
        // background, background-image
        case 5495:
        case 3959:
            return (0, _stylis.replace)(value, /(image-set\([^]*)/, (0, _stylis.WEBKIT) + '$1' + '$`$1');
        // justify-content
        case 4968:
            return (0, _stylis.replace)((0, _stylis.replace)(value, /(.+:)(flex-)?(.*)/, (0, _stylis.WEBKIT) + 'box-pack:$3' + (0, _stylis.MS) + 'flex-pack:$3'), /s.+-b[^;]+/, 'justify') + (0, _stylis.WEBKIT) + value + value;
        // (margin|padding)-inline-(start|end)
        case 4095:
        case 3583:
        case 4068:
        case 2532:
            return (0, _stylis.replace)(value, /(.+)-inline(.+)/, (0, _stylis.WEBKIT) + '$1$2') + value;
        // (min|max)?(width|height|inline-size|block-size)
        case 8116:
        case 7059:
        case 5753:
        case 5535:
        case 5445:
        case 5701:
        case 4933:
        case 4677:
        case 5533:
        case 5789:
        case 5021:
        case 4765:
            // stretch, max-content, min-content, fill-available
            if ((0, _stylis.strlen)(value) - 1 - length > 6) switch((0, _stylis.charat)(value, length + 1)){
                // (m)ax-content, (m)in-content
                case 109:
                    // -
                    if ((0, _stylis.charat)(value, length + 4) !== 45) break;
                // (f)ill-available, (f)it-content
                case 102:
                    return (0, _stylis.replace)(value, /(.+:)(.+)-([^]+)/, '$1' + (0, _stylis.WEBKIT) + '$2-$3' + '$1' + (0, _stylis.MOZ) + ((0, _stylis.charat)(value, length + 3) == 108 ? '$3' : '$2-$3')) + value;
                // (s)tretch
                case 115:
                    return ~(0, _stylis.indexof)(value, 'stretch') ? prefix((0, _stylis.replace)(value, 'stretch', 'fill-available'), length) + value : value;
            }
            break;
        // position: sticky
        case 4949:
            // (s)ticky?
            if ((0, _stylis.charat)(value, length + 1) !== 115) break;
        // display: (flex|inline-flex)
        case 6444:
            switch((0, _stylis.charat)(value, (0, _stylis.strlen)(value) - 3 - (~(0, _stylis.indexof)(value, '!important') && 10))){
                // stic(k)y
                case 107:
                    return (0, _stylis.replace)(value, ':', ':' + (0, _stylis.WEBKIT)) + value;
                // (inline-)?fl(e)x
                case 101:
                    return (0, _stylis.replace)(value, /(.+:)([^;!]+)(;|!.+)?/, '$1' + (0, _stylis.WEBKIT) + ((0, _stylis.charat)(value, 14) === 45 ? 'inline-' : '') + 'box$3' + '$1' + (0, _stylis.WEBKIT) + '$2$3' + '$1' + (0, _stylis.MS) + '$2box$3') + value;
            }
            break;
        // writing-mode
        case 5936:
            switch((0, _stylis.charat)(value, length + 11)){
                // vertical-l(r)
                case 114:
                    return (0, _stylis.WEBKIT) + value + (0, _stylis.MS) + (0, _stylis.replace)(value, /[svh]\w+-[tblr]{2}/, 'tb') + value;
                // vertical-r(l)
                case 108:
                    return (0, _stylis.WEBKIT) + value + (0, _stylis.MS) + (0, _stylis.replace)(value, /[svh]\w+-[tblr]{2}/, 'tb-rl') + value;
                // horizontal(-)tb
                case 45:
                    return (0, _stylis.WEBKIT) + value + (0, _stylis.MS) + (0, _stylis.replace)(value, /[svh]\w+-[tblr]{2}/, 'lr') + value;
            }
            return (0, _stylis.WEBKIT) + value + (0, _stylis.MS) + value + value;
    }
    return value;
}
var prefixer = function prefixer(element, index, children, callback) {
    if (element.length > -1) {
        if (!element["return"]) switch(element.type){
            case 0, _stylis.DECLARATION:
                element["return"] = prefix(element.value, element.length);
                break;
            case 0, _stylis.KEYFRAMES:
                return (0, _stylis.serialize)([
                    (0, _stylis.copy)(element, {
                        value: (0, _stylis.replace)(element.value, '@', '@' + (0, _stylis.WEBKIT))
                    })
                ], callback);
            case 0, _stylis.RULESET:
                if (element.length) return (0, _stylis.combine)(element.props, function(value) {
                    switch((0, _stylis.match)(value, /(::plac\w+|:read-\w+)/)){
                        // :read-(only|write)
                        case ':read-only':
                        case ':read-write':
                            return (0, _stylis.serialize)([
                                (0, _stylis.copy)(element, {
                                    props: [
                                        (0, _stylis.replace)(value, /:(read-\w+)/, ':' + (0, _stylis.MOZ) + '$1')
                                    ]
                                })
                            ], callback);
                        // :placeholder
                        case '::placeholder':
                            return (0, _stylis.serialize)([
                                (0, _stylis.copy)(element, {
                                    props: [
                                        (0, _stylis.replace)(value, /:(plac\w+)/, ':' + (0, _stylis.WEBKIT) + 'input-$1')
                                    ]
                                }),
                                (0, _stylis.copy)(element, {
                                    props: [
                                        (0, _stylis.replace)(value, /:(plac\w+)/, ':' + (0, _stylis.MOZ) + '$1')
                                    ]
                                }),
                                (0, _stylis.copy)(element, {
                                    props: [
                                        (0, _stylis.replace)(value, /:(plac\w+)/, (0, _stylis.MS) + 'input-$1')
                                    ]
                                })
                            ], callback);
                    }
                    return '';
                });
        }
    }
};
var defaultStylisPlugins = [
    prefixer
];
var createCache = function createCache(options) {
    var key = options.key;
    if (key === 'css') {
        var ssrStyles = document.querySelectorAll("style[data-emotion]:not([data-s])"); // get SSRed styles out of the way of React's hydration
        // document.head is a safe place to move them to(though note document.head is not necessarily the last place they will be)
        // note this very very intentionally targets all style elements regardless of the key to ensure
        // that creating a cache works inside of render of a React component
        Array.prototype.forEach.call(ssrStyles, function(node) {
            // we want to only move elements which have a space in the data-emotion attribute value
            // because that indicates that it is an Emotion 11 server-side rendered style elements
            // while we will already ignore Emotion 11 client-side inserted styles because of the :not([data-s]) part in the selector
            // Emotion 10 client-side inserted styles did not have data-s (but importantly did not have a space in their data-emotion attributes)
            // so checking for the space ensures that loading Emotion 11 after Emotion 10 has inserted some styles
            // will not result in the Emotion 10 styles being destroyed
            var dataEmotionAttribute = node.getAttribute('data-emotion');
            if (dataEmotionAttribute.indexOf(' ') === -1) return;
            document.head.appendChild(node);
            node.setAttribute('data-s', '');
        });
    }
    var stylisPlugins = options.stylisPlugins || defaultStylisPlugins;
    var inserted = {};
    var container;
    var nodesToHydrate = [];
    container = options.container || document.head;
    Array.prototype.forEach.call(// means that the style elements we're looking at are only Emotion 11 server-rendered style elements
    document.querySelectorAll("style[data-emotion^=\"" + key + " \"]"), function(node) {
        var attrib = node.getAttribute("data-emotion").split(' '); // $FlowFixMe
        for(var i = 1; i < attrib.length; i++)inserted[attrib[i]] = true;
        nodesToHydrate.push(node);
    });
    var _insert;
    var omnipresentPlugins = [
        compat,
        removeLabel
    ];
    var currentSheet;
    var finalizingPlugins = [
        (0, _stylis.stringify),
        (0, _stylis.rulesheet)(function(rule) {
            currentSheet.insert(rule);
        })
    ];
    var serializer = (0, _stylis.middleware)(omnipresentPlugins.concat(stylisPlugins, finalizingPlugins));
    var stylis = function stylis(styles) {
        return (0, _stylis.serialize)((0, _stylis.compile)(styles), serializer);
    };
    _insert = function insert(selector, serialized, sheet, shouldCache) {
        currentSheet = sheet;
        stylis(selector ? selector + "{" + serialized.styles + "}" : serialized.styles);
        if (shouldCache) cache.inserted[serialized.name] = true;
    };
    var cache = {
        key: key,
        sheet: new (0, _sheet.StyleSheet)({
            key: key,
            container: container,
            nonce: options.nonce,
            speedy: options.speedy,
            prepend: options.prepend,
            insertionPoint: options.insertionPoint
        }),
        nonce: options.nonce,
        inserted: inserted,
        registered: {},
        insert: _insert
    };
    cache.sheet.hydrate(nodesToHydrate);
    return cache;
};

},{"@emotion/sheet":"chO3L","stylis":"lMHey","@emotion/weak-memoize":"aJNMy","@emotion/memoize":"4Sq1M","@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"chO3L":[function(require,module,exports,__globalThis) {
/*

Based off glamor's StyleSheet, thanks Sunil ❤️

high performance StyleSheet for css-in-js systems

- uses multiple style tags behind the scenes for millions of rules
- uses `insertRule` for appending in production for *much* faster performance

// usage

import { StyleSheet } from '@emotion/sheet'

let styleSheet = new StyleSheet({ key: '', container: document.head })

styleSheet.insert('#box { border: 1px solid red; }')
- appends a css rule into the stylesheet

styleSheet.flush()
- empties the stylesheet of all its contents

*/ // $FlowFixMe
var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "StyleSheet", ()=>StyleSheet);
function sheetForTag(tag) {
    if (tag.sheet) // $FlowFixMe
    return tag.sheet;
     // this weirdness brought to you by firefox
    /* istanbul ignore next */ for(var i = 0; i < document.styleSheets.length; i++){
        if (document.styleSheets[i].ownerNode === tag) // $FlowFixMe
        return document.styleSheets[i];
    }
}
function createStyleElement(options) {
    var tag = document.createElement('style');
    tag.setAttribute('data-emotion', options.key);
    if (options.nonce !== undefined) tag.setAttribute('nonce', options.nonce);
    tag.appendChild(document.createTextNode(''));
    tag.setAttribute('data-s', '');
    return tag;
}
var StyleSheet = /*#__PURE__*/ function() {
    // Using Node instead of HTMLElement since container may be a ShadowRoot
    function StyleSheet(options) {
        var _this = this;
        this._insertTag = function(tag) {
            var before;
            if (_this.tags.length === 0) {
                if (_this.insertionPoint) before = _this.insertionPoint.nextSibling;
                else if (_this.prepend) before = _this.container.firstChild;
                else before = _this.before;
            } else before = _this.tags[_this.tags.length - 1].nextSibling;
            _this.container.insertBefore(tag, before);
            _this.tags.push(tag);
        };
        this.isSpeedy = options.speedy === undefined ? true : options.speedy;
        this.tags = [];
        this.ctr = 0;
        this.nonce = options.nonce; // key is the value of the data-emotion attribute, it's used to identify different sheets
        this.key = options.key;
        this.container = options.container;
        this.prepend = options.prepend;
        this.insertionPoint = options.insertionPoint;
        this.before = null;
    }
    var _proto = StyleSheet.prototype;
    _proto.hydrate = function hydrate(nodes) {
        nodes.forEach(this._insertTag);
    };
    _proto.insert = function insert(rule) {
        // the max length is how many rules we have per style tag, it's 65000 in speedy mode
        // it's 1 in dev because we insert source maps that map a single rule to a location
        // and you can only have one source map per style tag
        if (this.ctr % (this.isSpeedy ? 65000 : 1) === 0) this._insertTag(createStyleElement(this));
        var tag = this.tags[this.tags.length - 1];
        var isImportRule;
        if (this.isSpeedy) {
            var sheet = sheetForTag(tag);
            try {
                // this is the ultrafast version, works across browsers
                // the big drawback is that the css won't be editable in devtools
                sheet.insertRule(rule, sheet.cssRules.length);
            } catch (e) {}
        } else tag.appendChild(document.createTextNode(rule));
        this.ctr++;
    };
    _proto.flush = function flush() {
        // $FlowFixMe
        this.tags.forEach(function(tag) {
            return tag.parentNode && tag.parentNode.removeChild(tag);
        });
        this.tags = [];
        this.ctr = 0;
    };
    return StyleSheet;
}();

},{"@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"lMHey":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _enumJs = require("./src/Enum.js");
parcelHelpers.exportAll(_enumJs, exports);
var _utilityJs = require("./src/Utility.js");
parcelHelpers.exportAll(_utilityJs, exports);
var _parserJs = require("./src/Parser.js");
parcelHelpers.exportAll(_parserJs, exports);
var _prefixerJs = require("./src/Prefixer.js");
parcelHelpers.exportAll(_prefixerJs, exports);
var _tokenizerJs = require("./src/Tokenizer.js");
parcelHelpers.exportAll(_tokenizerJs, exports);
var _serializerJs = require("./src/Serializer.js");
parcelHelpers.exportAll(_serializerJs, exports);
var _middlewareJs = require("./src/Middleware.js");
parcelHelpers.exportAll(_middlewareJs, exports);

},{"./src/Enum.js":"hzPck","./src/Utility.js":"gIM69","./src/Parser.js":"lJO3j","./src/Prefixer.js":false,"./src/Tokenizer.js":"hrdBx","./src/Serializer.js":"4JWcU","./src/Middleware.js":"lrOJv","@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"hzPck":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "MS", ()=>MS);
parcelHelpers.export(exports, "MOZ", ()=>MOZ);
parcelHelpers.export(exports, "WEBKIT", ()=>WEBKIT);
parcelHelpers.export(exports, "COMMENT", ()=>COMMENT);
parcelHelpers.export(exports, "RULESET", ()=>RULESET);
parcelHelpers.export(exports, "DECLARATION", ()=>DECLARATION);
parcelHelpers.export(exports, "PAGE", ()=>PAGE);
parcelHelpers.export(exports, "MEDIA", ()=>MEDIA);
parcelHelpers.export(exports, "IMPORT", ()=>IMPORT);
parcelHelpers.export(exports, "CHARSET", ()=>CHARSET);
parcelHelpers.export(exports, "VIEWPORT", ()=>VIEWPORT);
parcelHelpers.export(exports, "SUPPORTS", ()=>SUPPORTS);
parcelHelpers.export(exports, "DOCUMENT", ()=>DOCUMENT);
parcelHelpers.export(exports, "NAMESPACE", ()=>NAMESPACE);
parcelHelpers.export(exports, "KEYFRAMES", ()=>KEYFRAMES);
parcelHelpers.export(exports, "FONT_FACE", ()=>FONT_FACE);
parcelHelpers.export(exports, "COUNTER_STYLE", ()=>COUNTER_STYLE);
parcelHelpers.export(exports, "FONT_FEATURE_VALUES", ()=>FONT_FEATURE_VALUES);
parcelHelpers.export(exports, "LAYER", ()=>LAYER);
var MS = '-ms-';
var MOZ = '-moz-';
var WEBKIT = '-webkit-';
var COMMENT = 'comm';
var RULESET = 'rule';
var DECLARATION = 'decl';
var PAGE = '@page';
var MEDIA = '@media';
var IMPORT = '@import';
var CHARSET = '@charset';
var VIEWPORT = '@viewport';
var SUPPORTS = '@supports';
var DOCUMENT = '@document';
var NAMESPACE = '@namespace';
var KEYFRAMES = '@keyframes';
var FONT_FACE = '@font-face';
var COUNTER_STYLE = '@counter-style';
var FONT_FEATURE_VALUES = '@font-feature-values';
var LAYER = '@layer';

},{"@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"gIM69":[function(require,module,exports,__globalThis) {
/**
 * @param {number}
 * @return {number}
 */ var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "abs", ()=>abs);
parcelHelpers.export(exports, "from", ()=>from);
parcelHelpers.export(exports, "assign", ()=>assign);
/**
 * @param {string} value
 * @param {number} length
 * @return {number}
 */ parcelHelpers.export(exports, "hash", ()=>hash);
/**
 * @param {string} value
 * @return {string}
 */ parcelHelpers.export(exports, "trim", ()=>trim);
/**
 * @param {string} value
 * @param {RegExp} pattern
 * @return {string?}
 */ parcelHelpers.export(exports, "match", ()=>match);
/**
 * @param {string} value
 * @param {(string|RegExp)} pattern
 * @param {string} replacement
 * @return {string}
 */ parcelHelpers.export(exports, "replace", ()=>replace);
/**
 * @param {string} value
 * @param {string} search
 * @return {number}
 */ parcelHelpers.export(exports, "indexof", ()=>indexof);
/**
 * @param {string} value
 * @param {number} index
 * @return {number}
 */ parcelHelpers.export(exports, "charat", ()=>charat);
/**
 * @param {string} value
 * @param {number} begin
 * @param {number} end
 * @return {string}
 */ parcelHelpers.export(exports, "substr", ()=>substr);
/**
 * @param {string} value
 * @return {number}
 */ parcelHelpers.export(exports, "strlen", ()=>strlen);
/**
 * @param {any[]} value
 * @return {number}
 */ parcelHelpers.export(exports, "sizeof", ()=>sizeof);
/**
 * @param {any} value
 * @param {any[]} array
 * @return {any}
 */ parcelHelpers.export(exports, "append", ()=>append);
/**
 * @param {string[]} array
 * @param {function} callback
 * @return {string}
 */ parcelHelpers.export(exports, "combine", ()=>combine);
var abs = Math.abs;
var from = String.fromCharCode;
var assign = Object.assign;
function hash(value, length) {
    return charat(value, 0) ^ 45 ? (((length << 2 ^ charat(value, 0)) << 2 ^ charat(value, 1)) << 2 ^ charat(value, 2)) << 2 ^ charat(value, 3) : 0;
}
function trim(value) {
    return value.trim();
}
function match(value, pattern) {
    return (value = pattern.exec(value)) ? value[0] : value;
}
function replace(value, pattern, replacement) {
    return value.replace(pattern, replacement);
}
function indexof(value, search) {
    return value.indexOf(search);
}
function charat(value, index) {
    return value.charCodeAt(index) | 0;
}
function substr(value, begin, end) {
    return value.slice(begin, end);
}
function strlen(value) {
    return value.length;
}
function sizeof(value) {
    return value.length;
}
function append(value, array) {
    return array.push(value), value;
}
function combine(array, callback) {
    return array.map(callback).join('');
}

},{"@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"lJO3j":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
/**
 * @param {string} value
 * @return {object[]}
 */ parcelHelpers.export(exports, "compile", ()=>compile);
/**
 * @param {string} value
 * @param {object} root
 * @param {object?} parent
 * @param {string[]} rule
 * @param {string[]} rules
 * @param {string[]} rulesets
 * @param {number[]} pseudo
 * @param {number[]} points
 * @param {string[]} declarations
 * @return {object}
 */ parcelHelpers.export(exports, "parse", ()=>parse);
/**
 * @param {string} value
 * @param {object} root
 * @param {object?} parent
 * @param {number} index
 * @param {number} offset
 * @param {string[]} rules
 * @param {number[]} points
 * @param {string} type
 * @param {string[]} props
 * @param {string[]} children
 * @param {number} length
 * @return {object}
 */ parcelHelpers.export(exports, "ruleset", ()=>ruleset);
/**
 * @param {number} value
 * @param {object} root
 * @param {object?} parent
 * @return {object}
 */ parcelHelpers.export(exports, "comment", ()=>comment);
/**
 * @param {string} value
 * @param {object} root
 * @param {object?} parent
 * @param {number} length
 * @return {object}
 */ parcelHelpers.export(exports, "declaration", ()=>declaration);
var _enumJs = require("./Enum.js");
var _utilityJs = require("./Utility.js");
var _tokenizerJs = require("./Tokenizer.js");
function compile(value) {
    return (0, _tokenizerJs.dealloc)(parse('', null, null, null, [
        ''
    ], value = (0, _tokenizerJs.alloc)(value), 0, [
        0
    ], value));
}
function parse(value, root, parent, rule, rules, rulesets, pseudo, points, declarations) {
    var index = 0;
    var offset = 0;
    var length = pseudo;
    var atrule = 0;
    var property = 0;
    var previous = 0;
    var variable = 1;
    var scanning = 1;
    var ampersand = 1;
    var character = 0;
    var type = '';
    var props = rules;
    var children = rulesets;
    var reference = rule;
    var characters = type;
    while(scanning)switch(previous = character, character = (0, _tokenizerJs.next)()){
        // (
        case 40:
            if (previous != 108 && (0, _utilityJs.charat)(characters, length - 1) == 58) {
                if ((0, _utilityJs.indexof)(characters += (0, _utilityJs.replace)((0, _tokenizerJs.delimit)(character), '&', '&\f'), '&\f') != -1) ampersand = -1;
                break;
            }
        // " ' [
        case 34:
        case 39:
        case 91:
            characters += (0, _tokenizerJs.delimit)(character);
            break;
        // \t \n \r \s
        case 9:
        case 10:
        case 13:
        case 32:
            characters += (0, _tokenizerJs.whitespace)(previous);
            break;
        // \
        case 92:
            characters += (0, _tokenizerJs.escaping)((0, _tokenizerJs.caret)() - 1, 7);
            continue;
        // /
        case 47:
            switch((0, _tokenizerJs.peek)()){
                case 42:
                case 47:
                    (0, _utilityJs.append)(comment((0, _tokenizerJs.commenter)((0, _tokenizerJs.next)(), (0, _tokenizerJs.caret)()), root, parent), declarations);
                    break;
                default:
                    characters += '/';
            }
            break;
        // {
        case 123 * variable:
            points[index++] = (0, _utilityJs.strlen)(characters) * ampersand;
        // } ; \0
        case 125 * variable:
        case 59:
        case 0:
            switch(character){
                // \0 }
                case 0:
                case 125:
                    scanning = 0;
                // ;
                case 59 + offset:
                    if (ampersand == -1) characters = (0, _utilityJs.replace)(characters, /\f/g, '');
                    if (property > 0 && (0, _utilityJs.strlen)(characters) - length) (0, _utilityJs.append)(property > 32 ? declaration(characters + ';', rule, parent, length - 1) : declaration((0, _utilityJs.replace)(characters, ' ', '') + ';', rule, parent, length - 2), declarations);
                    break;
                // @ ;
                case 59:
                    characters += ';';
                // { rule/at-rule
                default:
                    (0, _utilityJs.append)(reference = ruleset(characters, root, parent, index, offset, rules, points, type, props = [], children = [], length), rulesets);
                    if (character === 123) {
                        if (offset === 0) parse(characters, root, reference, reference, props, rulesets, length, points, children);
                        else switch(atrule === 99 && (0, _utilityJs.charat)(characters, 3) === 110 ? 100 : atrule){
                            // d l m s
                            case 100:
                            case 108:
                            case 109:
                            case 115:
                                parse(value, reference, reference, rule && (0, _utilityJs.append)(ruleset(value, reference, reference, 0, 0, rules, points, type, rules, props = [], length), children), rules, children, length, points, rule ? props : children);
                                break;
                            default:
                                parse(characters, reference, reference, reference, [
                                    ''
                                ], children, 0, points, children);
                        }
                    }
            }
            index = offset = property = 0, variable = ampersand = 1, type = characters = '', length = pseudo;
            break;
        // :
        case 58:
            length = 1 + (0, _utilityJs.strlen)(characters), property = previous;
        default:
            if (variable < 1) {
                if (character == 123) --variable;
                else if (character == 125 && variable++ == 0 && (0, _tokenizerJs.prev)() == 125) continue;
            }
            switch(characters += (0, _utilityJs.from)(character), character * variable){
                // &
                case 38:
                    ampersand = offset > 0 ? 1 : (characters += '\f', -1);
                    break;
                // ,
                case 44:
                    points[index++] = ((0, _utilityJs.strlen)(characters) - 1) * ampersand, ampersand = 1;
                    break;
                // @
                case 64:
                    // -
                    if ((0, _tokenizerJs.peek)() === 45) characters += (0, _tokenizerJs.delimit)((0, _tokenizerJs.next)());
                    atrule = (0, _tokenizerJs.peek)(), offset = length = (0, _utilityJs.strlen)(type = characters += (0, _tokenizerJs.identifier)((0, _tokenizerJs.caret)())), character++;
                    break;
                // -
                case 45:
                    if (previous === 45 && (0, _utilityJs.strlen)(characters) == 2) variable = 0;
            }
    }
    return rulesets;
}
function ruleset(value, root, parent, index, offset, rules, points, type, props, children, length) {
    var post = offset - 1;
    var rule = offset === 0 ? rules : [
        ''
    ];
    var size = (0, _utilityJs.sizeof)(rule);
    for(var i = 0, j = 0, k = 0; i < index; ++i)for(var x = 0, y = (0, _utilityJs.substr)(value, post + 1, post = (0, _utilityJs.abs)(j = points[i])), z = value; x < size; ++x)if (z = (0, _utilityJs.trim)(j > 0 ? rule[x] + ' ' + y : (0, _utilityJs.replace)(y, /&\f/g, rule[x]))) props[k++] = z;
    return (0, _tokenizerJs.node)(value, root, parent, offset === 0 ? (0, _enumJs.RULESET) : type, props, children, length);
}
function comment(value, root, parent) {
    return (0, _tokenizerJs.node)(value, root, parent, (0, _enumJs.COMMENT), (0, _utilityJs.from)((0, _tokenizerJs.char)()), (0, _utilityJs.substr)(value, 2, -2), 0);
}
function declaration(value, root, parent, length) {
    return (0, _tokenizerJs.node)(value, root, parent, (0, _enumJs.DECLARATION), (0, _utilityJs.substr)(value, 0, length), (0, _utilityJs.substr)(value, length + 1, -1), length);
}

},{"./Enum.js":"hzPck","./Utility.js":"gIM69","./Tokenizer.js":"hrdBx","@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"hrdBx":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "line", ()=>line);
parcelHelpers.export(exports, "column", ()=>column);
parcelHelpers.export(exports, "length", ()=>length);
parcelHelpers.export(exports, "position", ()=>position);
parcelHelpers.export(exports, "character", ()=>character);
parcelHelpers.export(exports, "characters", ()=>characters);
/**
 * @param {string} value
 * @param {object | null} root
 * @param {object | null} parent
 * @param {string} type
 * @param {string[] | string} props
 * @param {object[] | string} children
 * @param {number} length
 */ parcelHelpers.export(exports, "node", ()=>node);
/**
 * @param {object} root
 * @param {object} props
 * @return {object}
 */ parcelHelpers.export(exports, "copy", ()=>copy);
/**
 * @return {number}
 */ parcelHelpers.export(exports, "char", ()=>char);
/**
 * @return {number}
 */ parcelHelpers.export(exports, "prev", ()=>prev);
/**
 * @return {number}
 */ parcelHelpers.export(exports, "next", ()=>next);
/**
 * @return {number}
 */ parcelHelpers.export(exports, "peek", ()=>peek);
/**
 * @return {number}
 */ parcelHelpers.export(exports, "caret", ()=>caret);
/**
 * @param {number} begin
 * @param {number} end
 * @return {string}
 */ parcelHelpers.export(exports, "slice", ()=>slice);
/**
 * @param {number} type
 * @return {number}
 */ parcelHelpers.export(exports, "token", ()=>token);
/**
 * @param {string} value
 * @return {any[]}
 */ parcelHelpers.export(exports, "alloc", ()=>alloc);
/**
 * @param {any} value
 * @return {any}
 */ parcelHelpers.export(exports, "dealloc", ()=>dealloc);
/**
 * @param {number} type
 * @return {string}
 */ parcelHelpers.export(exports, "delimit", ()=>delimit);
/**
 * @param {string} value
 * @return {string[]}
 */ parcelHelpers.export(exports, "tokenize", ()=>tokenize);
/**
 * @param {number} type
 * @return {string}
 */ parcelHelpers.export(exports, "whitespace", ()=>whitespace);
/**
 * @param {string[]} children
 * @return {string[]}
 */ parcelHelpers.export(exports, "tokenizer", ()=>tokenizer);
/**
 * @param {number} index
 * @param {number} count
 * @return {string}
 */ parcelHelpers.export(exports, "escaping", ()=>escaping);
/**
 * @param {number} type
 * @return {number}
 */ parcelHelpers.export(exports, "delimiter", ()=>delimiter);
/**
 * @param {number} type
 * @param {number} index
 * @return {number}
 */ parcelHelpers.export(exports, "commenter", ()=>commenter);
/**
 * @param {number} index
 * @return {string}
 */ parcelHelpers.export(exports, "identifier", ()=>identifier);
var _utilityJs = require("./Utility.js");
var line = 1;
var column = 1;
var length = 0;
var position = 0;
var character = 0;
var characters = '';
function node(value, root, parent, type, props, children, length) {
    return {
        value: value,
        root: root,
        parent: parent,
        type: type,
        props: props,
        children: children,
        line: line,
        column: column,
        length: length,
        return: ''
    };
}
function copy(root, props) {
    return (0, _utilityJs.assign)(node('', null, null, '', null, null, 0), root, {
        length: -root.length
    }, props);
}
function char() {
    return character;
}
function prev() {
    character = position > 0 ? (0, _utilityJs.charat)(characters, --position) : 0;
    if (column--, character === 10) column = 1, line--;
    return character;
}
function next() {
    character = position < length ? (0, _utilityJs.charat)(characters, position++) : 0;
    if (column++, character === 10) column = 1, line++;
    return character;
}
function peek() {
    return (0, _utilityJs.charat)(characters, position);
}
function caret() {
    return position;
}
function slice(begin, end) {
    return (0, _utilityJs.substr)(characters, begin, end);
}
function token(type) {
    switch(type){
        // \0 \t \n \r \s whitespace token
        case 0:
        case 9:
        case 10:
        case 13:
        case 32:
            return 5;
        // ! + , / > @ ~ isolate token
        case 33:
        case 43:
        case 44:
        case 47:
        case 62:
        case 64:
        case 126:
        // ; { } breakpoint token
        case 59:
        case 123:
        case 125:
            return 4;
        // : accompanied token
        case 58:
            return 3;
        // " ' ( [ opening delimit token
        case 34:
        case 39:
        case 40:
        case 91:
            return 2;
        // ) ] closing delimit token
        case 41:
        case 93:
            return 1;
    }
    return 0;
}
function alloc(value) {
    return line = column = 1, length = (0, _utilityJs.strlen)(characters = value), position = 0, [];
}
function dealloc(value) {
    return characters = '', value;
}
function delimit(type) {
    return (0, _utilityJs.trim)(slice(position - 1, delimiter(type === 91 ? type + 2 : type === 40 ? type + 1 : type)));
}
function tokenize(value) {
    return dealloc(tokenizer(alloc(value)));
}
function whitespace(type) {
    while(character = peek())if (character < 33) next();
    else break;
    return token(type) > 2 || token(character) > 3 ? '' : ' ';
}
function tokenizer(children) {
    while(next())switch(token(character)){
        case 0:
            (0, _utilityJs.append)(identifier(position - 1), children);
            break;
        case 2:
            (0, _utilityJs.append)(delimit(character), children);
            break;
        default:
            (0, _utilityJs.append)((0, _utilityJs.from)(character), children);
    }
    return children;
}
function escaping(index, count) {
    while(--count && next())// not 0-9 A-F a-f
    if (character < 48 || character > 102 || character > 57 && character < 65 || character > 70 && character < 97) break;
    return slice(index, caret() + (count < 6 && peek() == 32 && next() == 32));
}
function delimiter(type) {
    while(next())switch(character){
        // ] ) " '
        case type:
            return position;
        // " '
        case 34:
        case 39:
            if (type !== 34 && type !== 39) delimiter(character);
            break;
        // (
        case 40:
            if (type === 41) delimiter(type);
            break;
        // \
        case 92:
            next();
            break;
    }
    return position;
}
function commenter(type, index) {
    while(next())// //
    if (type + character === 57) break;
    else if (type + character === 84 && peek() === 47) break;
    return '/*' + slice(index, position - 1) + '*' + (0, _utilityJs.from)(type === 47 ? type : next());
}
function identifier(index) {
    while(!token(peek()))next();
    return slice(index, position);
}

},{"./Utility.js":"gIM69","@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"M3Jge":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
/**
 * @param {string} value
 * @param {number} length
 * @param {object[]} children
 * @return {string}
 */ parcelHelpers.export(exports, "prefix", ()=>prefix);
var _enumJs = require("./Enum.js");
var _utilityJs = require("./Utility.js");
function prefix(value, length, children) {
    switch((0, _utilityJs.hash)(value, length)){
        // color-adjust
        case 5103:
            return (0, _enumJs.WEBKIT) + 'print-' + value + value;
        // animation, animation-(delay|direction|duration|fill-mode|iteration-count|name|play-state|timing-function)
        case 5737:
        case 4201:
        case 3177:
        case 3433:
        case 1641:
        case 4457:
        case 2921:
        // text-decoration, filter, clip-path, backface-visibility, column, box-decoration-break
        case 5572:
        case 6356:
        case 5844:
        case 3191:
        case 6645:
        case 3005:
        // mask, mask-image, mask-(mode|clip|size), mask-(repeat|origin), mask-position, mask-composite,
        case 6391:
        case 5879:
        case 5623:
        case 6135:
        case 4599:
        case 4855:
        // background-clip, columns, column-(count|fill|gap|rule|rule-color|rule-style|rule-width|span|width)
        case 4215:
        case 6389:
        case 5109:
        case 5365:
        case 5621:
        case 3829:
            return (0, _enumJs.WEBKIT) + value + value;
        // tab-size
        case 4789:
            return (0, _enumJs.MOZ) + value + value;
        // appearance, user-select, transform, hyphens, text-size-adjust
        case 5349:
        case 4246:
        case 4810:
        case 6968:
        case 2756:
            return (0, _enumJs.WEBKIT) + value + (0, _enumJs.MOZ) + value + (0, _enumJs.MS) + value + value;
        // writing-mode
        case 5936:
            switch((0, _utilityJs.charat)(value, length + 11)){
                // vertical-l(r)
                case 114:
                    return (0, _enumJs.WEBKIT) + value + (0, _enumJs.MS) + (0, _utilityJs.replace)(value, /[svh]\w+-[tblr]{2}/, 'tb') + value;
                // vertical-r(l)
                case 108:
                    return (0, _enumJs.WEBKIT) + value + (0, _enumJs.MS) + (0, _utilityJs.replace)(value, /[svh]\w+-[tblr]{2}/, 'tb-rl') + value;
                // horizontal(-)tb
                case 45:
                    return (0, _enumJs.WEBKIT) + value + (0, _enumJs.MS) + (0, _utilityJs.replace)(value, /[svh]\w+-[tblr]{2}/, 'lr') + value;
            }
        // flex, flex-direction, scroll-snap-type, writing-mode
        case 6828:
        case 4268:
        case 2903:
            return (0, _enumJs.WEBKIT) + value + (0, _enumJs.MS) + value + value;
        // order
        case 6165:
            return (0, _enumJs.WEBKIT) + value + (0, _enumJs.MS) + 'flex-' + value + value;
        // align-items
        case 5187:
            return (0, _enumJs.WEBKIT) + value + (0, _utilityJs.replace)(value, /(\w+).+(:[^]+)/, (0, _enumJs.WEBKIT) + 'box-$1$2' + (0, _enumJs.MS) + 'flex-$1$2') + value;
        // align-self
        case 5443:
            return (0, _enumJs.WEBKIT) + value + (0, _enumJs.MS) + 'flex-item-' + (0, _utilityJs.replace)(value, /flex-|-self/g, '') + (!(0, _utilityJs.match)(value, /flex-|baseline/) ? (0, _enumJs.MS) + 'grid-row-' + (0, _utilityJs.replace)(value, /flex-|-self/g, '') : '') + value;
        // align-content
        case 4675:
            return (0, _enumJs.WEBKIT) + value + (0, _enumJs.MS) + 'flex-line-pack' + (0, _utilityJs.replace)(value, /align-content|flex-|-self/g, '') + value;
        // flex-shrink
        case 5548:
            return (0, _enumJs.WEBKIT) + value + (0, _enumJs.MS) + (0, _utilityJs.replace)(value, 'shrink', 'negative') + value;
        // flex-basis
        case 5292:
            return (0, _enumJs.WEBKIT) + value + (0, _enumJs.MS) + (0, _utilityJs.replace)(value, 'basis', 'preferred-size') + value;
        // flex-grow
        case 6060:
            return (0, _enumJs.WEBKIT) + 'box-' + (0, _utilityJs.replace)(value, '-grow', '') + (0, _enumJs.WEBKIT) + value + (0, _enumJs.MS) + (0, _utilityJs.replace)(value, 'grow', 'positive') + value;
        // transition
        case 4554:
            return (0, _enumJs.WEBKIT) + (0, _utilityJs.replace)(value, /([^-])(transform)/g, '$1' + (0, _enumJs.WEBKIT) + '$2') + value;
        // cursor
        case 6187:
            return (0, _utilityJs.replace)((0, _utilityJs.replace)((0, _utilityJs.replace)(value, /(zoom-|grab)/, (0, _enumJs.WEBKIT) + '$1'), /(image-set)/, (0, _enumJs.WEBKIT) + '$1'), value, '') + value;
        // background, background-image
        case 5495:
        case 3959:
            return (0, _utilityJs.replace)(value, /(image-set\([^]*)/, (0, _enumJs.WEBKIT) + '$1' + '$`$1');
        // justify-content
        case 4968:
            return (0, _utilityJs.replace)((0, _utilityJs.replace)(value, /(.+:)(flex-)?(.*)/, (0, _enumJs.WEBKIT) + 'box-pack:$3' + (0, _enumJs.MS) + 'flex-pack:$3'), /s.+-b[^;]+/, 'justify') + (0, _enumJs.WEBKIT) + value + value;
        // justify-self
        case 4200:
            if (!(0, _utilityJs.match)(value, /flex-|baseline/)) return (0, _enumJs.MS) + 'grid-column-align' + (0, _utilityJs.substr)(value, length) + value;
            break;
        // grid-template-(columns|rows)
        case 2592:
        case 3360:
            return (0, _enumJs.MS) + (0, _utilityJs.replace)(value, 'template-', '') + value;
        // grid-(row|column)-start
        case 4384:
        case 3616:
            if (children && children.some(function(element, index) {
                return length = index, (0, _utilityJs.match)(element.props, /grid-\w+-end/);
            })) return ~(0, _utilityJs.indexof)(value + (children = children[length].value), 'span') ? value : (0, _enumJs.MS) + (0, _utilityJs.replace)(value, '-start', '') + value + (0, _enumJs.MS) + 'grid-row-span:' + (~(0, _utilityJs.indexof)(children, 'span') ? (0, _utilityJs.match)(children, /\d+/) : +(0, _utilityJs.match)(children, /\d+/) - +(0, _utilityJs.match)(value, /\d+/)) + ';';
            return (0, _enumJs.MS) + (0, _utilityJs.replace)(value, '-start', '') + value;
        // grid-(row|column)-end
        case 4896:
        case 4128:
            return children && children.some(function(element) {
                return (0, _utilityJs.match)(element.props, /grid-\w+-start/);
            }) ? value : (0, _enumJs.MS) + (0, _utilityJs.replace)((0, _utilityJs.replace)(value, '-end', '-span'), 'span ', '') + value;
        // (margin|padding)-inline-(start|end)
        case 4095:
        case 3583:
        case 4068:
        case 2532:
            return (0, _utilityJs.replace)(value, /(.+)-inline(.+)/, (0, _enumJs.WEBKIT) + '$1$2') + value;
        // (min|max)?(width|height|inline-size|block-size)
        case 8116:
        case 7059:
        case 5753:
        case 5535:
        case 5445:
        case 5701:
        case 4933:
        case 4677:
        case 5533:
        case 5789:
        case 5021:
        case 4765:
            // stretch, max-content, min-content, fill-available
            if ((0, _utilityJs.strlen)(value) - 1 - length > 6) switch((0, _utilityJs.charat)(value, length + 1)){
                // (m)ax-content, (m)in-content
                case 109:
                    // -
                    if ((0, _utilityJs.charat)(value, length + 4) !== 45) break;
                // (f)ill-available, (f)it-content
                case 102:
                    return (0, _utilityJs.replace)(value, /(.+:)(.+)-([^]+)/, '$1' + (0, _enumJs.WEBKIT) + '$2-$3' + '$1' + (0, _enumJs.MOZ) + ((0, _utilityJs.charat)(value, length + 3) == 108 ? '$3' : '$2-$3')) + value;
                // (s)tretch
                case 115:
                    return ~(0, _utilityJs.indexof)(value, 'stretch') ? prefix((0, _utilityJs.replace)(value, 'stretch', 'fill-available'), length, children) + value : value;
            }
            break;
        // grid-(column|row)
        case 5152:
        case 5920:
            return (0, _utilityJs.replace)(value, /(.+?):(\d+)(\s*\/\s*(span)?\s*(\d+))?(.*)/, function(_, a, b, c, d, e, f) {
                return (0, _enumJs.MS) + a + ':' + b + f + (c ? (0, _enumJs.MS) + a + '-span:' + (d ? e : +e - +b) + f : '') + value;
            });
        // position: sticky
        case 4949:
            // stick(y)?
            if ((0, _utilityJs.charat)(value, length + 6) === 121) return (0, _utilityJs.replace)(value, ':', ':' + (0, _enumJs.WEBKIT)) + value;
            break;
        // display: (flex|inline-flex|grid|inline-grid)
        case 6444:
            switch((0, _utilityJs.charat)(value, (0, _utilityJs.charat)(value, 14) === 45 ? 18 : 11)){
                // (inline-)?fle(x)
                case 120:
                    return (0, _utilityJs.replace)(value, /(.+:)([^;\s!]+)(;|(\s+)?!.+)?/, '$1' + (0, _enumJs.WEBKIT) + ((0, _utilityJs.charat)(value, 14) === 45 ? 'inline-' : '') + 'box$3' + '$1' + (0, _enumJs.WEBKIT) + '$2$3' + '$1' + (0, _enumJs.MS) + '$2box$3') + value;
                // (inline-)?gri(d)
                case 100:
                    return (0, _utilityJs.replace)(value, ':', ':' + (0, _enumJs.MS)) + value;
            }
            break;
        // scroll-margin, scroll-margin-(top|right|bottom|left)
        case 5719:
        case 2647:
        case 2135:
        case 3927:
        case 2391:
            return (0, _utilityJs.replace)(value, 'scroll-', 'scroll-snap-') + value;
    }
    return value;
}

},{"./Enum.js":"hzPck","./Utility.js":"gIM69","@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"4JWcU":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
/**
 * @param {object[]} children
 * @param {function} callback
 * @return {string}
 */ parcelHelpers.export(exports, "serialize", ()=>serialize);
/**
 * @param {object} element
 * @param {number} index
 * @param {object[]} children
 * @param {function} callback
 * @return {string}
 */ parcelHelpers.export(exports, "stringify", ()=>stringify);
var _enumJs = require("./Enum.js");
var _utilityJs = require("./Utility.js");
function serialize(children, callback) {
    var output = '';
    var length = (0, _utilityJs.sizeof)(children);
    for(var i = 0; i < length; i++)output += callback(children[i], i, children, callback) || '';
    return output;
}
function stringify(element, index, children, callback) {
    switch(element.type){
        case 0, _enumJs.LAYER:
            if (element.children.length) break;
        case 0, _enumJs.IMPORT:
        case 0, _enumJs.DECLARATION:
            return element.return = element.return || element.value;
        case 0, _enumJs.COMMENT:
            return '';
        case 0, _enumJs.KEYFRAMES:
            return element.return = element.value + '{' + serialize(element.children, callback) + '}';
        case 0, _enumJs.RULESET:
            element.value = element.props.join(',');
    }
    return (0, _utilityJs.strlen)(children = serialize(element.children, callback)) ? element.return = element.value + '{' + children + '}' : '';
}

},{"./Enum.js":"hzPck","./Utility.js":"gIM69","@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"lrOJv":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
/**
 * @param {function[]} collection
 * @return {function}
 */ parcelHelpers.export(exports, "middleware", ()=>middleware);
/**
 * @param {function} callback
 * @return {function}
 */ parcelHelpers.export(exports, "rulesheet", ()=>rulesheet);
/**
 * @param {object} element
 * @param {number} index
 * @param {object[]} children
 * @param {function} callback
 */ parcelHelpers.export(exports, "prefixer", ()=>prefixer);
/**
 * @param {object} element
 * @param {number} index
 * @param {object[]} children
 */ parcelHelpers.export(exports, "namespace", ()=>namespace);
var _enumJs = require("./Enum.js");
var _utilityJs = require("./Utility.js");
var _tokenizerJs = require("./Tokenizer.js");
var _serializerJs = require("./Serializer.js");
var _prefixerJs = require("./Prefixer.js");
function middleware(collection) {
    var length = (0, _utilityJs.sizeof)(collection);
    return function(element, index, children, callback) {
        var output = '';
        for(var i = 0; i < length; i++)output += collection[i](element, index, children, callback) || '';
        return output;
    };
}
function rulesheet(callback) {
    return function(element) {
        if (!element.root) {
            if (element = element.return) callback(element);
        }
    };
}
function prefixer(element, index, children, callback) {
    if (element.length > -1) {
        if (!element.return) switch(element.type){
            case 0, _enumJs.DECLARATION:
                element.return = (0, _prefixerJs.prefix)(element.value, element.length, children);
                return;
            case 0, _enumJs.KEYFRAMES:
                return (0, _serializerJs.serialize)([
                    (0, _tokenizerJs.copy)(element, {
                        value: (0, _utilityJs.replace)(element.value, '@', '@' + (0, _enumJs.WEBKIT))
                    })
                ], callback);
            case 0, _enumJs.RULESET:
                if (element.length) return (0, _utilityJs.combine)(element.props, function(value) {
                    switch((0, _utilityJs.match)(value, /(::plac\w+|:read-\w+)/)){
                        // :read-(only|write)
                        case ':read-only':
                        case ':read-write':
                            return (0, _serializerJs.serialize)([
                                (0, _tokenizerJs.copy)(element, {
                                    props: [
                                        (0, _utilityJs.replace)(value, /:(read-\w+)/, ':' + (0, _enumJs.MOZ) + '$1')
                                    ]
                                })
                            ], callback);
                        // :placeholder
                        case '::placeholder':
                            return (0, _serializerJs.serialize)([
                                (0, _tokenizerJs.copy)(element, {
                                    props: [
                                        (0, _utilityJs.replace)(value, /:(plac\w+)/, ':' + (0, _enumJs.WEBKIT) + 'input-$1')
                                    ]
                                }),
                                (0, _tokenizerJs.copy)(element, {
                                    props: [
                                        (0, _utilityJs.replace)(value, /:(plac\w+)/, ':' + (0, _enumJs.MOZ) + '$1')
                                    ]
                                }),
                                (0, _tokenizerJs.copy)(element, {
                                    props: [
                                        (0, _utilityJs.replace)(value, /:(plac\w+)/, (0, _enumJs.MS) + 'input-$1')
                                    ]
                                })
                            ], callback);
                    }
                    return '';
                });
        }
    }
}
function namespace(element) {
    switch(element.type){
        case 0, _enumJs.RULESET:
            element.props = element.props.map(function(value) {
                return (0, _utilityJs.combine)((0, _tokenizerJs.tokenize)(value), function(value, index, children) {
                    switch((0, _utilityJs.charat)(value, 0)){
                        // \f
                        case 12:
                            return (0, _utilityJs.substr)(value, 1, (0, _utilityJs.strlen)(value));
                        // \0 ( + > ~
                        case 0:
                        case 40:
                        case 43:
                        case 62:
                        case 126:
                            return value;
                        // :
                        case 58:
                            if (children[++index] === 'global') children[index] = '', children[++index] = '\f' + (0, _utilityJs.substr)(children[index], index = 1, -1);
                        // \s
                        case 32:
                            return index === 1 ? '' : value;
                        default:
                            switch(index){
                                case 0:
                                    element = value;
                                    return (0, _utilityJs.sizeof)(children) > 1 ? '' : value;
                                case index = (0, _utilityJs.sizeof)(children) - 1:
                                case 2:
                                    return index === 2 ? value + element + element : value + element;
                                default:
                                    return value;
                            }
                    }
                });
            });
    }
}

},{"./Enum.js":"hzPck","./Utility.js":"gIM69","./Tokenizer.js":"hrdBx","./Serializer.js":"4JWcU","./Prefixer.js":"M3Jge","@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"aJNMy":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>weakMemoize);
var weakMemoize = function weakMemoize(func) {
    // $FlowFixMe flow doesn't include all non-primitive types as allowed for weakmaps
    var cache = new WeakMap();
    return function(arg) {
        if (cache.has(arg)) // $FlowFixMe
        return cache.get(arg);
        var ret = func(arg);
        cache.set(arg, ret);
        return ret;
    };
};

},{"@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"4Sq1M":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>memoize);
function memoize(fn) {
    var cache = Object.create(null);
    return function(arg) {
        if (cache[arg] === undefined) cache[arg] = fn(arg);
        return cache[arg];
    };
}

},{"@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"gUQuF":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>hoistNonReactStatics);
var _hoistNonReactStatics = require("hoist-non-react-statics");
var _hoistNonReactStaticsDefault = parcelHelpers.interopDefault(_hoistNonReactStatics);
// this file isolates this package that is not tree-shakeable
// and if this module doesn't actually contain any logic of its own
// then Rollup just use 'hoist-non-react-statics' directly in other chunks
var hoistNonReactStatics = function(targetComponent, sourceComponent) {
    return (0, _hoistNonReactStaticsDefault.default)(targetComponent, sourceComponent);
};

},{"hoist-non-react-statics":"nZLnq","@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"9m6eO":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "getRegisteredStyles", ()=>getRegisteredStyles);
parcelHelpers.export(exports, "insertStyles", ()=>insertStyles);
parcelHelpers.export(exports, "registerStyles", ()=>registerStyles);
var isBrowser = true;
function getRegisteredStyles(registered, registeredStyles, classNames) {
    var rawClassName = '';
    classNames.split(' ').forEach(function(className) {
        if (registered[className] !== undefined) registeredStyles.push(registered[className] + ";");
        else if (className) rawClassName += className + " ";
    });
    return rawClassName;
}
var registerStyles = function registerStyles(cache, serialized, isStringTag) {
    var className = cache.key + "-" + serialized.name;
    if (// class name could be used further down
    // the tree but if it's a string tag, we know it won't
    // so we don't have to add it to registered cache.
    // this improves memory usage since we can avoid storing the whole style string
    (isStringTag === false || // we need to always store it if we're in compat mode and
    // in node since emotion-server relies on whether a style is in
    // the registered cache to know whether a style is global or not
    // also, note that this check will be dead code eliminated in the browser
    isBrowser === false) && cache.registered[className] === undefined) cache.registered[className] = serialized.styles;
};
var insertStyles = function insertStyles(cache, serialized, isStringTag) {
    registerStyles(cache, serialized, isStringTag);
    var className = cache.key + "-" + serialized.name;
    if (cache.inserted[serialized.name] === undefined) {
        var current = serialized;
        do {
            cache.insert(serialized === current ? "." + className : '', current, cache.sheet, true);
            current = current.next;
        }while (current !== undefined);
    }
};

},{"@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"7NJwA":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "serializeStyles", ()=>serializeStyles);
var _hash = require("@emotion/hash");
var _hashDefault = parcelHelpers.interopDefault(_hash);
var _unitless = require("@emotion/unitless");
var _unitlessDefault = parcelHelpers.interopDefault(_unitless);
var _memoize = require("@emotion/memoize");
var _memoizeDefault = parcelHelpers.interopDefault(_memoize);
var isDevelopment = false;
var hyphenateRegex = /[A-Z]|^ms/g;
var animationRegex = /_EMO_([^_]+?)_([^]*?)_EMO_/g;
var isCustomProperty = function isCustomProperty(property) {
    return property.charCodeAt(1) === 45;
};
var isProcessableValue = function isProcessableValue(value) {
    return value != null && typeof value !== 'boolean';
};
var processStyleName = /* #__PURE__ */ (0, _memoizeDefault.default)(function(styleName) {
    return isCustomProperty(styleName) ? styleName : styleName.replace(hyphenateRegex, '-$&').toLowerCase();
});
var processStyleValue = function processStyleValue(key, value) {
    switch(key){
        case 'animation':
        case 'animationName':
            if (typeof value === 'string') return value.replace(animationRegex, function(match, p1, p2) {
                cursor = {
                    name: p1,
                    styles: p2,
                    next: cursor
                };
                return p1;
            });
    }
    if ((0, _unitlessDefault.default)[key] !== 1 && !isCustomProperty(key) && typeof value === 'number' && value !== 0) return value + 'px';
    return value;
};
var noComponentSelectorMessage = "Component selectors can only be used in conjunction with @emotion/babel-plugin, the swc Emotion plugin, or another Emotion-aware compiler transform.";
function handleInterpolation(mergedProps, registered, interpolation) {
    if (interpolation == null) return '';
    var componentSelector = interpolation;
    if (componentSelector.__emotion_styles !== undefined) return componentSelector;
    switch(typeof interpolation){
        case 'boolean':
            return '';
        case 'object':
            var keyframes = interpolation;
            if (keyframes.anim === 1) {
                cursor = {
                    name: keyframes.name,
                    styles: keyframes.styles,
                    next: cursor
                };
                return keyframes.name;
            }
            var serializedStyles = interpolation;
            if (serializedStyles.styles !== undefined) {
                var next = serializedStyles.next;
                if (next !== undefined) // not the most efficient thing ever but this is a pretty rare case
                // and there will be very few iterations of this generally
                while(next !== undefined){
                    cursor = {
                        name: next.name,
                        styles: next.styles,
                        next: cursor
                    };
                    next = next.next;
                }
                var styles = serializedStyles.styles + ";";
                return styles;
            }
            return createStringFromObject(mergedProps, registered, interpolation);
        case 'function':
            if (mergedProps !== undefined) {
                var previousCursor = cursor;
                var result = interpolation(mergedProps);
                cursor = previousCursor;
                return handleInterpolation(mergedProps, registered, result);
            }
            break;
    } // finalize string values (regular strings and functions interpolated into css calls)
    var asString = interpolation;
    if (registered == null) return asString;
    var cached = registered[asString];
    return cached !== undefined ? cached : asString;
}
function createStringFromObject(mergedProps, registered, obj) {
    var string = '';
    if (Array.isArray(obj)) for(var i = 0; i < obj.length; i++)string += handleInterpolation(mergedProps, registered, obj[i]) + ";";
    else for(var key in obj){
        var value = obj[key];
        if (typeof value !== 'object') {
            var asString = value;
            if (registered != null && registered[asString] !== undefined) string += key + "{" + registered[asString] + "}";
            else if (isProcessableValue(asString)) string += processStyleName(key) + ":" + processStyleValue(key, asString) + ";";
        } else {
            if (key === 'NO_COMPONENT_SELECTOR' && isDevelopment) throw new Error(noComponentSelectorMessage);
            if (Array.isArray(value) && typeof value[0] === 'string' && (registered == null || registered[value[0]] === undefined)) {
                for(var _i = 0; _i < value.length; _i++)if (isProcessableValue(value[_i])) string += processStyleName(key) + ":" + processStyleValue(key, value[_i]) + ";";
            } else {
                var interpolated = handleInterpolation(mergedProps, registered, value);
                switch(key){
                    case 'animation':
                    case 'animationName':
                        string += processStyleName(key) + ":" + interpolated + ";";
                        break;
                    default:
                        string += key + "{" + interpolated + "}";
                }
            }
        }
    }
    return string;
}
var labelPattern = /label:\s*([^\s;{]+)\s*(;|$)/g; // this is the cursor for keyframes
// keyframes are stored on the SerializedStyles object as a linked list
var cursor;
function serializeStyles(args, registered, mergedProps) {
    if (args.length === 1 && typeof args[0] === 'object' && args[0] !== null && args[0].styles !== undefined) return args[0];
    var stringMode = true;
    var styles = '';
    cursor = undefined;
    var strings = args[0];
    if (strings == null || strings.raw === undefined) {
        stringMode = false;
        styles += handleInterpolation(mergedProps, registered, strings);
    } else {
        var asTemplateStringsArr = strings;
        styles += asTemplateStringsArr[0];
    } // we start at 1 since we've already handled the first arg
    for(var i = 1; i < args.length; i++){
        styles += handleInterpolation(mergedProps, registered, args[i]);
        if (stringMode) {
            var templateStringsArr = strings;
            styles += templateStringsArr[i];
        }
    } // using a global regex with .exec is stateful so lastIndex has to be reset each time
    labelPattern.lastIndex = 0;
    var identifierName = '';
    var match; // https://esbench.com/bench/5b809c2cf2949800a0f61fb5
    while((match = labelPattern.exec(styles)) !== null)identifierName += '-' + match[1];
    var name = (0, _hashDefault.default)(styles) + identifierName;
    return {
        name: name,
        styles: styles,
        next: cursor
    };
}

},{"@emotion/hash":"aWxID","@emotion/unitless":"eiJ2O","@emotion/memoize":"7iowJ","@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"aWxID":[function(require,module,exports,__globalThis) {
/* eslint-disable */ // Inspired by https://github.com/garycourt/murmurhash-js
// Ported from https://github.com/aappleby/smhasher/blob/61a0530f28277f2e850bfc39600ce61d02b518de/src/MurmurHash2.cpp#L37-L86
var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>murmur2);
function murmur2(str) {
    // 'm' and 'r' are mixing constants generated offline.
    // They're not really 'magic', they just happen to work well.
    // const m = 0x5bd1e995;
    // const r = 24;
    // Initialize the hash
    var h = 0; // Mix 4 bytes at a time into the hash
    var k, i = 0, len = str.length;
    for(; len >= 4; ++i, len -= 4){
        k = str.charCodeAt(i) & 0xff | (str.charCodeAt(++i) & 0xff) << 8 | (str.charCodeAt(++i) & 0xff) << 16 | (str.charCodeAt(++i) & 0xff) << 24;
        k = /* Math.imul(k, m): */ (k & 0xffff) * 0x5bd1e995 + ((k >>> 16) * 0xe995 << 16);
        k ^= /* k >>> r: */ k >>> 24;
        h = /* Math.imul(k, m): */ (k & 0xffff) * 0x5bd1e995 + ((k >>> 16) * 0xe995 << 16) ^ /* Math.imul(h, m): */ (h & 0xffff) * 0x5bd1e995 + ((h >>> 16) * 0xe995 << 16);
    } // Handle the last few bytes of the input array
    switch(len){
        case 3:
            h ^= (str.charCodeAt(i + 2) & 0xff) << 16;
        case 2:
            h ^= (str.charCodeAt(i + 1) & 0xff) << 8;
        case 1:
            h ^= str.charCodeAt(i) & 0xff;
            h = /* Math.imul(h, m): */ (h & 0xffff) * 0x5bd1e995 + ((h >>> 16) * 0xe995 << 16);
    } // Do a few final mixes of the hash to ensure the last few
    // bytes are well-incorporated.
    h ^= h >>> 13;
    h = /* Math.imul(h, m): */ (h & 0xffff) * 0x5bd1e995 + ((h >>> 16) * 0xe995 << 16);
    return ((h ^ h >>> 15) >>> 0).toString(36);
}

},{"@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"eiJ2O":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>unitlessKeys);
var unitlessKeys = {
    animationIterationCount: 1,
    aspectRatio: 1,
    borderImageOutset: 1,
    borderImageSlice: 1,
    borderImageWidth: 1,
    boxFlex: 1,
    boxFlexGroup: 1,
    boxOrdinalGroup: 1,
    columnCount: 1,
    columns: 1,
    flex: 1,
    flexGrow: 1,
    flexPositive: 1,
    flexShrink: 1,
    flexNegative: 1,
    flexOrder: 1,
    gridRow: 1,
    gridRowEnd: 1,
    gridRowSpan: 1,
    gridRowStart: 1,
    gridColumn: 1,
    gridColumnEnd: 1,
    gridColumnSpan: 1,
    gridColumnStart: 1,
    msGridRow: 1,
    msGridRowSpan: 1,
    msGridColumn: 1,
    msGridColumnSpan: 1,
    fontWeight: 1,
    lineHeight: 1,
    opacity: 1,
    order: 1,
    orphans: 1,
    scale: 1,
    tabSize: 1,
    widows: 1,
    zIndex: 1,
    zoom: 1,
    WebkitLineClamp: 1,
    // SVG-related properties
    fillOpacity: 1,
    floodOpacity: 1,
    stopOpacity: 1,
    strokeDasharray: 1,
    strokeDashoffset: 1,
    strokeMiterlimit: 1,
    strokeOpacity: 1,
    strokeWidth: 1
};

},{"@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"7iowJ":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>memoize);
function memoize(fn) {
    var cache = Object.create(null);
    return function(arg) {
        if (cache[arg] === undefined) cache[arg] = fn(arg);
        return cache[arg];
    };
}

},{"@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"6a6BT":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "useInsertionEffectAlwaysWithSyncFallback", ()=>useInsertionEffectAlwaysWithSyncFallback);
parcelHelpers.export(exports, "useInsertionEffectWithLayoutFallback", ()=>useInsertionEffectWithLayoutFallback);
var _react = require("react");
var syncFallback = function syncFallback(create) {
    return create();
};
var useInsertionEffect = false;
var useInsertionEffectAlwaysWithSyncFallback = useInsertionEffect || syncFallback;
var useInsertionEffectWithLayoutFallback = useInsertionEffect || _react.useLayoutEffect;

},{"react":"ltHCL","@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"a7SYG":[function(require,module,exports,__globalThis) {
// eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled -- Ignored via go/DSP-18766
var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "dimensionMap", ()=>dimensionMap);
parcelHelpers.export(exports, "positiveSpaceMap", ()=>positiveSpaceMap);
parcelHelpers.export(exports, "negativeSpaceMap", ()=>negativeSpaceMap);
parcelHelpers.export(exports, "allSpaceMap", ()=>allSpaceMap);
parcelHelpers.export(exports, "inverseColorMap", ()=>inverseColorMap);
parcelHelpers.export(exports, "opacityMap", ()=>opacityMap);
parcelHelpers.export(exports, "shadowMap", ()=>shadowMap);
parcelHelpers.export(exports, "surfaceColorMap", ()=>surfaceColorMap);
parcelHelpers.export(exports, "borderColorMap", ()=>borderColorMap);
parcelHelpers.export(exports, "backgroundColorMap", ()=>backgroundColorMap);
parcelHelpers.export(exports, "textColorMap", ()=>textColorMap);
parcelHelpers.export(exports, "fillMap", ()=>fillMap);
parcelHelpers.export(exports, "layerMap", ()=>layerMap);
parcelHelpers.export(exports, "borderWidthMap", ()=>borderWidthMap);
parcelHelpers.export(exports, "borderRadiusMap", ()=>borderRadiusMap);
parcelHelpers.export(exports, "fontMap", ()=>fontMap);
parcelHelpers.export(exports, "fontWeightMap", ()=>fontWeightMap);
parcelHelpers.export(exports, "fontFamilyMap", ()=>fontFamilyMap);
parcelHelpers.export(exports, "textSizeMap", ()=>textSizeMap);
parcelHelpers.export(exports, "textWeightMap", ()=>textWeightMap);
parcelHelpers.export(exports, "metricTextSizeMap", ()=>metricTextSizeMap);
parcelHelpers.export(exports, "getSerializedStylesMap", ()=>getSerializedStylesMap);
parcelHelpers.export(exports, "paddingStylesMap", ()=>paddingStylesMap);
parcelHelpers.export(exports, "spaceStylesMap", ()=>spaceStylesMap);
parcelHelpers.export(exports, "backgroundColorStylesMap", ()=>backgroundColorStylesMap);
parcelHelpers.export(exports, "textColorStylesMap", ()=>textColorStylesMap);
parcelHelpers.export(exports, "fontWeightStylesMap", ()=>fontWeightStylesMap);
parcelHelpers.export(exports, "fontFamilyStylesMap", ()=>fontFamilyStylesMap);
parcelHelpers.export(exports, "fontStylesMap", ()=>fontStylesMap);
parcelHelpers.export(exports, "textSizeStylesMap", ()=>textSizeStylesMap);
parcelHelpers.export(exports, "textWeightStylesMap", ()=>textWeightStylesMap);
parcelHelpers.export(exports, "surfaceColorStylesMap", ()=>surfaceColorStylesMap);
parcelHelpers.export(exports, "isSurfaceColorToken", ()=>isSurfaceColorToken);
parcelHelpers.export(exports, "metricTextSizeStylesMap", ()=>metricTextSizeStylesMap);
var _objectSpread = require("@swc/helpers/_/_object_spread");
var _react = require("@emotion/react");
var _constants = require("@atlaskit/tokens/constants");
const dimensionMap = {
    '100%': '100%',
    'size.100': '1rem',
    'size.200': '1.5rem',
    'size.300': '2rem',
    'size.400': '2.5rem',
    'size.500': '3rem',
    'size.600': '6rem',
    'size.1000': '12rem'
};
const positiveSpaceMap = {
    'space.0': "var(--ds-space-0, 0px)",
    'space.025': "var(--ds-space-025, 2px)",
    'space.050': "var(--ds-space-050, 4px)",
    'space.075': "var(--ds-space-075, 6px)",
    'space.100': "var(--ds-space-100, 8px)",
    'space.150': "var(--ds-space-150, 12px)",
    'space.200': "var(--ds-space-200, 16px)",
    'space.250': "var(--ds-space-250, 20px)",
    'space.300': "var(--ds-space-300, 24px)",
    'space.400': "var(--ds-space-400, 32px)",
    'space.500': "var(--ds-space-500, 40px)",
    'space.600': "var(--ds-space-600, 48px)",
    'space.800': "var(--ds-space-800, 64px)",
    'space.1000': "var(--ds-space-1000, 80px)"
};
const negativeSpaceMap = {
    'space.negative.025': "var(--ds-space-negative-025, -2px)",
    'space.negative.050': "var(--ds-space-negative-050, -4px)",
    'space.negative.075': "var(--ds-space-negative-075, -6px)",
    'space.negative.100': "var(--ds-space-negative-100, -8px)",
    'space.negative.150': "var(--ds-space-negative-150, -12px)",
    'space.negative.200': "var(--ds-space-negative-200, -16px)",
    'space.negative.250': "var(--ds-space-negative-250, -20px)",
    'space.negative.300': "var(--ds-space-negative-300, -24px)",
    'space.negative.400': "var(--ds-space-negative-400, -32px)"
};
const allSpaceMap = (0, _objectSpread._)({}, positiveSpaceMap, negativeSpaceMap);
const inverseColorMap = {
    'color.background.neutral.bold': 'color.text.inverse',
    'color.background.neutral.bold.hovered': 'color.text.inverse',
    'color.background.neutral.bold.pressed': 'color.text.inverse',
    'color.background.selected.bold': 'color.text.inverse',
    'color.background.selected.bold.hovered': 'color.text.inverse',
    'color.background.selected.bold.pressed': 'color.text.inverse',
    'color.background.brand.bold': 'color.text.inverse',
    'color.background.brand.bold.hovered': 'color.text.inverse',
    'color.background.brand.bold.pressed': 'color.text.inverse',
    'color.background.brand.boldest': 'color.text.inverse',
    'color.background.brand.boldest.hovered': 'color.text.inverse',
    'color.background.brand.boldest.pressed': 'color.text.inverse',
    'color.background.danger.bold': 'color.text.inverse',
    'color.background.danger.bold.hovered': 'color.text.inverse',
    'color.background.danger.bold.pressed': 'color.text.inverse',
    'color.background.warning.bold': 'color.text.warning.inverse',
    'color.background.warning.bold.hovered': 'color.text.warning.inverse',
    'color.background.warning.bold.pressed': 'color.text.warning.inverse',
    'color.background.success.bold': 'color.text.inverse',
    'color.background.success.bold.hovered': 'color.text.inverse',
    'color.background.success.bold.pressed': 'color.text.inverse',
    'color.background.discovery.bold': 'color.text.inverse',
    'color.background.discovery.bold.hovered': 'color.text.inverse',
    'color.background.discovery.bold.pressed': 'color.text.inverse',
    'color.background.information.bold': 'color.text.inverse',
    'color.background.information.bold.hovered': 'color.text.inverse',
    'color.background.information.bold.pressed': 'color.text.inverse',
    'color.rovo.background.brand.bold': 'color.text.inverse',
    'color.rovo.background.brand.bold.hovered': 'color.text.inverse',
    'color.rovo.background.brand.bold.pressed': 'color.text.inverse'
};
const opacityMap = {
    'opacity.disabled': "var(--ds-opacity-disabled, 0.4)",
    'opacity.loading': "var(--ds-opacity-loading, 0.2)"
};
const shadowMap = {
    'elevation.shadow.overflow': "var(--ds-shadow-overflow, 0px 0px 8px #1E1F21, 0px 0px 1px #1E1F21)",
    'elevation.shadow.overflow.perimeter': "var(--ds-shadow-overflow-perimeter, #1E1F211f)",
    'elevation.shadow.overflow.spread': "var(--ds-shadow-overflow-spread, #1E1F2129)",
    'elevation.shadow.overlay': "var(--ds-shadow-overlay, 0px 8px 12px #1E1F21, 0px 0px 1px #1E1F21)",
    'elevation.shadow.raised': "var(--ds-shadow-raised, 0px 1px 1px #1E1F21, 0px 0px 1px #1E1F21)"
};
const surfaceColorMap = {
    'elevation.surface': "var(--ds-surface, #FFFFFF)",
    'elevation.surface.hovered': "var(--ds-surface-hovered, #F0F1F2)",
    'elevation.surface.pressed': "var(--ds-surface-pressed, #DDDEE1)",
    'elevation.surface.container': "var(--ds-surface-container, #17171708)",
    'elevation.surface.container.hovered': "var(--ds-surface-container-hovered, #0515240F)",
    'elevation.surface.container.pressed': "var(--ds-surface-container-pressed, #0B120E24)",
    'elevation.surface.overlay': "var(--ds-surface-overlay, #FFFFFF)",
    'elevation.surface.overlay.hovered': "var(--ds-surface-overlay-hovered, #F0F1F2)",
    'elevation.surface.overlay.pressed': "var(--ds-surface-overlay-pressed, #DDDEE1)",
    'elevation.surface.raised': "var(--ds-surface-raised, #FFFFFF)",
    'elevation.surface.raised.hovered': "var(--ds-surface-raised-hovered, #F0F1F2)",
    'elevation.surface.raised.pressed': "var(--ds-surface-raised-pressed, #DDDEE1)",
    'elevation.surface.sunken': "var(--ds-surface-sunken, #F8F8F8)"
};
const borderColorMap = {
    'color.border': "var(--ds-border, #0B120E24)",
    'color.border.accent.lime': "var(--ds-border-accent-lime, #6A9A23)",
    'color.border.accent.lime.subtle': "var(--ds-border-accent-lime-subtle, #B3DF72)",
    'color.border.accent.red': "var(--ds-border-accent-red, #E2483D)",
    'color.border.accent.red.subtle': "var(--ds-border-accent-red-subtle, #FD9891)",
    'color.border.accent.orange': "var(--ds-border-accent-orange, #E06C00)",
    'color.border.accent.orange.subtle': "var(--ds-border-accent-orange-subtle, #FBC828)",
    'color.border.accent.yellow': "var(--ds-border-accent-yellow, #B38600)",
    'color.border.accent.yellow.subtle': "var(--ds-border-accent-yellow-subtle, #EED12B)",
    'color.border.accent.green': "var(--ds-border-accent-green, #22A06B)",
    'color.border.accent.green.subtle': "var(--ds-border-accent-green-subtle, #7EE2B8)",
    'color.border.accent.teal': "var(--ds-border-accent-teal, #2898BD)",
    'color.border.accent.teal.subtle': "var(--ds-border-accent-teal-subtle, #9DD9EE)",
    'color.border.accent.blue': "var(--ds-border-accent-blue, #357DE8)",
    'color.border.accent.blue.subtle': "var(--ds-border-accent-blue-subtle, #8FB8F6)",
    'color.border.accent.purple': "var(--ds-border-accent-purple, #AF59E1)",
    'color.border.accent.purple.subtle': "var(--ds-border-accent-purple-subtle, #D8A0F7)",
    'color.border.accent.magenta': "var(--ds-border-accent-magenta, #CD519D)",
    'color.border.accent.magenta.subtle': "var(--ds-border-accent-magenta-subtle, #F797D2)",
    'color.border.accent.gray': "var(--ds-border-accent-gray, #7D818A)",
    'color.border.accent.gray.subtle': "var(--ds-border-accent-gray-subtle, #B7B9BE)",
    'color.border.disabled': "var(--ds-border-disabled, #0515240F)",
    'color.border.focused': "var(--ds-border-focused, #4688EC)",
    'color.border.input': "var(--ds-border-input, #8C8F97)",
    'color.border.inverse': "var(--ds-border-inverse, #FFFFFF)",
    'color.border.selected': "var(--ds-border-selected, #1868DB)",
    'color.border.brand': "var(--ds-border-brand, #1868DB)",
    'color.border.danger': "var(--ds-border-danger, #E2483D)",
    'color.border.danger.subtle': "var(--ds-border-danger-subtle, #FD9891)",
    'color.border.warning': "var(--ds-border-warning, #E06C00)",
    'color.border.warning.subtle': "var(--ds-border-warning-subtle, #FBC828)",
    'color.border.success': "var(--ds-border-success, #6A9A23)",
    'color.border.success.subtle': "var(--ds-border-success-subtle, #B3DF72)",
    'color.border.discovery': "var(--ds-border-discovery, #AF59E1)",
    'color.border.discovery.subtle': "var(--ds-border-discovery-subtle, #D8A0F7)",
    'color.border.information': "var(--ds-border-information, #357DE8)",
    'color.border.information.subtle': "var(--ds-border-information-subtle, #8FB8F6)",
    'color.border.bold': "var(--ds-border-bold, #7D818A)"
};
const backgroundColorMap = {
    'color.background.accent.lime.subtlest': "var(--ds-background-accent-lime-subtlest, #EFFFD6)",
    'color.background.accent.lime.subtlest.hovered': "var(--ds-background-accent-lime-subtlest-hovered, #D3F1A7)",
    'color.background.accent.lime.subtlest.pressed': "var(--ds-background-accent-lime-subtlest-pressed, #BDE97C)",
    'color.background.accent.lime.subtler': "var(--ds-background-accent-lime-subtler, #D3F1A7)",
    'color.background.accent.lime.subtler.hovered': "var(--ds-background-accent-lime-subtler-hovered, #BDE97C)",
    'color.background.accent.lime.subtler.pressed': "var(--ds-background-accent-lime-subtler-pressed, #B3DF72)",
    'color.background.accent.lime.subtle': "var(--ds-background-accent-lime-subtle, #94C748)",
    'color.background.accent.lime.subtle.hovered': "var(--ds-background-accent-lime-subtle-hovered, #B3DF72)",
    'color.background.accent.lime.subtle.pressed': "var(--ds-background-accent-lime-subtle-pressed, #BDE97C)",
    'color.background.accent.lime.bolder': "var(--ds-background-accent-lime-bolder, #5B7F24)",
    'color.background.accent.lime.bolder.hovered': "var(--ds-background-accent-lime-bolder-hovered, #4C6B1F)",
    'color.background.accent.lime.bolder.pressed': "var(--ds-background-accent-lime-bolder-pressed, #3F5224)",
    'color.background.accent.red.subtlest': "var(--ds-background-accent-red-subtlest, #FFECEB)",
    'color.background.accent.red.subtlest.hovered': "var(--ds-background-accent-red-subtlest-hovered, #FFD5D2)",
    'color.background.accent.red.subtlest.pressed': "var(--ds-background-accent-red-subtlest-pressed, #FFB8B2)",
    'color.background.accent.red.subtler': "var(--ds-background-accent-red-subtler, #FFD5D2)",
    'color.background.accent.red.subtler.hovered': "var(--ds-background-accent-red-subtler-hovered, #FFB8B2)",
    'color.background.accent.red.subtler.pressed': "var(--ds-background-accent-red-subtler-pressed, #FD9891)",
    'color.background.accent.red.subtle': "var(--ds-background-accent-red-subtle, #F87168)",
    'color.background.accent.red.subtle.hovered': "var(--ds-background-accent-red-subtle-hovered, #FD9891)",
    'color.background.accent.red.subtle.pressed': "var(--ds-background-accent-red-subtle-pressed, #FFB8B2)",
    'color.background.accent.red.bolder': "var(--ds-background-accent-red-bolder, #C9372C)",
    'color.background.accent.red.bolder.hovered': "var(--ds-background-accent-red-bolder-hovered, #AE2E24)",
    'color.background.accent.red.bolder.pressed': "var(--ds-background-accent-red-bolder-pressed, #872821)",
    'color.background.accent.orange.subtlest': "var(--ds-background-accent-orange-subtlest, #FFF5DB)",
    'color.background.accent.orange.subtlest.hovered': "var(--ds-background-accent-orange-subtlest-hovered, #FCE4A6)",
    'color.background.accent.orange.subtlest.pressed': "var(--ds-background-accent-orange-subtlest-pressed, #FBD779)",
    'color.background.accent.orange.subtler': "var(--ds-background-accent-orange-subtler, #FCE4A6)",
    'color.background.accent.orange.subtler.hovered': "var(--ds-background-accent-orange-subtler-hovered, #FBD779)",
    'color.background.accent.orange.subtler.pressed': "var(--ds-background-accent-orange-subtler-pressed, #FBC828)",
    'color.background.accent.orange.subtle': "var(--ds-background-accent-orange-subtle, #FCA700)",
    'color.background.accent.orange.subtle.hovered': "var(--ds-background-accent-orange-subtle-hovered, #FBC828)",
    'color.background.accent.orange.subtle.pressed': "var(--ds-background-accent-orange-subtle-pressed, #FBD779)",
    'color.background.accent.orange.bolder': "var(--ds-background-accent-orange-bolder, #BD5B00)",
    'color.background.accent.orange.bolder.hovered': "var(--ds-background-accent-orange-bolder-hovered, #9E4C00)",
    'color.background.accent.orange.bolder.pressed': "var(--ds-background-accent-orange-bolder-pressed, #7A3B00)",
    'color.background.accent.yellow.subtlest': "var(--ds-background-accent-yellow-subtlest, #FEF7C8)",
    'color.background.accent.yellow.subtlest.hovered': "var(--ds-background-accent-yellow-subtlest-hovered, #F5E989)",
    'color.background.accent.yellow.subtlest.pressed': "var(--ds-background-accent-yellow-subtlest-pressed, #EFDD4E)",
    'color.background.accent.yellow.subtler': "var(--ds-background-accent-yellow-subtler, #F5E989)",
    'color.background.accent.yellow.subtler.hovered': "var(--ds-background-accent-yellow-subtler-hovered, #EFDD4E)",
    'color.background.accent.yellow.subtler.pressed': "var(--ds-background-accent-yellow-subtler-pressed, #EED12B)",
    'color.background.accent.yellow.subtle': "var(--ds-background-accent-yellow-subtle, #EED12B)",
    'color.background.accent.yellow.subtle.hovered': "var(--ds-background-accent-yellow-subtle-hovered, #DDB30E)",
    'color.background.accent.yellow.subtle.pressed': "var(--ds-background-accent-yellow-subtle-pressed, #EFDD4E)",
    'color.background.accent.yellow.bolder': "var(--ds-background-accent-yellow-bolder, #946F00)",
    'color.background.accent.yellow.bolder.hovered': "var(--ds-background-accent-yellow-bolder-hovered, #7F5F01)",
    'color.background.accent.yellow.bolder.pressed': "var(--ds-background-accent-yellow-bolder-pressed, #614A05)",
    'color.background.accent.green.subtlest': "var(--ds-background-accent-green-subtlest, #DCFFF1)",
    'color.background.accent.green.subtlest.hovered': "var(--ds-background-accent-green-subtlest-hovered, #BAF3DB)",
    'color.background.accent.green.subtlest.pressed': "var(--ds-background-accent-green-subtlest-pressed, #97EDC9)",
    'color.background.accent.green.subtler': "var(--ds-background-accent-green-subtler, #BAF3DB)",
    'color.background.accent.green.subtler.hovered': "var(--ds-background-accent-green-subtler-hovered, #97EDC9)",
    'color.background.accent.green.subtler.pressed': "var(--ds-background-accent-green-subtler-pressed, #7EE2B8)",
    'color.background.accent.green.subtle': "var(--ds-background-accent-green-subtle, #4BCE97)",
    'color.background.accent.green.subtle.hovered': "var(--ds-background-accent-green-subtle-hovered, #7EE2B8)",
    'color.background.accent.green.subtle.pressed': "var(--ds-background-accent-green-subtle-pressed, #97EDC9)",
    'color.background.accent.green.bolder': "var(--ds-background-accent-green-bolder, #1F845A)",
    'color.background.accent.green.bolder.hovered': "var(--ds-background-accent-green-bolder-hovered, #216E4E)",
    'color.background.accent.green.bolder.pressed': "var(--ds-background-accent-green-bolder-pressed, #19573D)",
    'color.background.accent.teal.subtlest': "var(--ds-background-accent-teal-subtlest, #E7F9FF)",
    'color.background.accent.teal.subtlest.hovered': "var(--ds-background-accent-teal-subtlest-hovered, #C6EDFB)",
    'color.background.accent.teal.subtlest.pressed': "var(--ds-background-accent-teal-subtlest-pressed, #B1E4F7)",
    'color.background.accent.teal.subtler': "var(--ds-background-accent-teal-subtler, #C6EDFB)",
    'color.background.accent.teal.subtler.hovered': "var(--ds-background-accent-teal-subtler-hovered, #B1E4F7)",
    'color.background.accent.teal.subtler.pressed': "var(--ds-background-accent-teal-subtler-pressed, #9DD9EE)",
    'color.background.accent.teal.subtle': "var(--ds-background-accent-teal-subtle, #6CC3E0)",
    'color.background.accent.teal.subtle.hovered': "var(--ds-background-accent-teal-subtle-hovered, #9DD9EE)",
    'color.background.accent.teal.subtle.pressed': "var(--ds-background-accent-teal-subtle-pressed, #B1E4F7)",
    'color.background.accent.teal.bolder': "var(--ds-background-accent-teal-bolder, #227D9B)",
    'color.background.accent.teal.bolder.hovered': "var(--ds-background-accent-teal-bolder-hovered, #206A83)",
    'color.background.accent.teal.bolder.pressed': "var(--ds-background-accent-teal-bolder-pressed, #1A5265)",
    'color.background.accent.blue.subtlest': "var(--ds-background-accent-blue-subtlest, #E9F2FE)",
    'color.background.accent.blue.subtlest.hovered': "var(--ds-background-accent-blue-subtlest-hovered, #CFE1FD)",
    'color.background.accent.blue.subtlest.pressed': "var(--ds-background-accent-blue-subtlest-pressed, #ADCBFB)",
    'color.background.accent.blue.subtler': "var(--ds-background-accent-blue-subtler, #CFE1FD)",
    'color.background.accent.blue.subtler.hovered': "var(--ds-background-accent-blue-subtler-hovered, #ADCBFB)",
    'color.background.accent.blue.subtler.pressed': "var(--ds-background-accent-blue-subtler-pressed, #8FB8F6)",
    'color.background.accent.blue.subtle': "var(--ds-background-accent-blue-subtle, #669DF1)",
    'color.background.accent.blue.subtle.hovered': "var(--ds-background-accent-blue-subtle-hovered, #8FB8F6)",
    'color.background.accent.blue.subtle.pressed': "var(--ds-background-accent-blue-subtle-pressed, #ADCBFB)",
    'color.background.accent.blue.bolder': "var(--ds-background-accent-blue-bolder, #1868DB)",
    'color.background.accent.blue.bolder.hovered': "var(--ds-background-accent-blue-bolder-hovered, #1558BC)",
    'color.background.accent.blue.bolder.pressed': "var(--ds-background-accent-blue-bolder-pressed, #144794)",
    'color.background.accent.purple.subtlest': "var(--ds-background-accent-purple-subtlest, #F8EEFE)",
    'color.background.accent.purple.subtlest.hovered': "var(--ds-background-accent-purple-subtlest-hovered, #EED7FC)",
    'color.background.accent.purple.subtlest.pressed': "var(--ds-background-accent-purple-subtlest-pressed, #E3BDFA)",
    'color.background.accent.purple.subtler': "var(--ds-background-accent-purple-subtler, #EED7FC)",
    'color.background.accent.purple.subtler.hovered': "var(--ds-background-accent-purple-subtler-hovered, #E3BDFA)",
    'color.background.accent.purple.subtler.pressed': "var(--ds-background-accent-purple-subtler-pressed, #D8A0F7)",
    'color.background.accent.purple.subtle': "var(--ds-background-accent-purple-subtle, #C97CF4)",
    'color.background.accent.purple.subtle.hovered': "var(--ds-background-accent-purple-subtle-hovered, #D8A0F7)",
    'color.background.accent.purple.subtle.pressed': "var(--ds-background-accent-purple-subtle-pressed, #E3BDFA)",
    'color.background.accent.purple.bolder': "var(--ds-background-accent-purple-bolder, #964AC0)",
    'color.background.accent.purple.bolder.hovered': "var(--ds-background-accent-purple-bolder-hovered, #803FA5)",
    'color.background.accent.purple.bolder.pressed': "var(--ds-background-accent-purple-bolder-pressed, #673286)",
    'color.background.accent.magenta.subtlest': "var(--ds-background-accent-magenta-subtlest, #FFECF8)",
    'color.background.accent.magenta.subtlest.hovered': "var(--ds-background-accent-magenta-subtlest-hovered, #FDD0EC)",
    'color.background.accent.magenta.subtlest.pressed': "var(--ds-background-accent-magenta-subtlest-pressed, #FCB6E1)",
    'color.background.accent.magenta.subtler': "var(--ds-background-accent-magenta-subtler, #FDD0EC)",
    'color.background.accent.magenta.subtler.hovered': "var(--ds-background-accent-magenta-subtler-hovered, #FCB6E1)",
    'color.background.accent.magenta.subtler.pressed': "var(--ds-background-accent-magenta-subtler-pressed, #F797D2)",
    'color.background.accent.magenta.subtle': "var(--ds-background-accent-magenta-subtle, #E774BB)",
    'color.background.accent.magenta.subtle.hovered': "var(--ds-background-accent-magenta-subtle-hovered, #F797D2)",
    'color.background.accent.magenta.subtle.pressed': "var(--ds-background-accent-magenta-subtle-pressed, #FCB6E1)",
    'color.background.accent.magenta.bolder': "var(--ds-background-accent-magenta-bolder, #AE4787)",
    'color.background.accent.magenta.bolder.hovered': "var(--ds-background-accent-magenta-bolder-hovered, #943D73)",
    'color.background.accent.magenta.bolder.pressed': "var(--ds-background-accent-magenta-bolder-pressed, #77325B)",
    'color.background.accent.gray.subtlest': "var(--ds-background-accent-gray-subtlest, #F0F1F2)",
    'color.background.accent.gray.subtlest.hovered': "var(--ds-background-accent-gray-subtlest-hovered, #DDDEE1)",
    'color.background.accent.gray.subtlest.pressed': "var(--ds-background-accent-gray-subtlest-pressed, #B7B9BE)",
    'color.background.accent.gray.subtler': "var(--ds-background-accent-gray-subtler, #DDDEE1)",
    'color.background.accent.gray.subtler.hovered': "var(--ds-background-accent-gray-subtler-hovered, #B7B9BE)",
    'color.background.accent.gray.subtler.pressed': "var(--ds-background-accent-gray-subtler-pressed, #8C8F97)",
    'color.background.accent.gray.subtle': "var(--ds-background-accent-gray-subtle, #8C8F97)",
    'color.background.accent.gray.subtle.hovered': "var(--ds-background-accent-gray-subtle-hovered, #B7B9BE)",
    'color.background.accent.gray.subtle.pressed': "var(--ds-background-accent-gray-subtle-pressed, #DDDEE1)",
    'color.background.accent.gray.bolder': "var(--ds-background-accent-gray-bolder, #6B6E76)",
    'color.background.accent.gray.bolder.hovered': "var(--ds-background-accent-gray-bolder-hovered, #505258)",
    'color.background.accent.gray.bolder.pressed': "var(--ds-background-accent-gray-bolder-pressed, #3B3D42)",
    'color.background.disabled': "var(--ds-background-disabled, #0515240F)",
    'color.background.input': "var(--ds-background-input, #FFFFFF)",
    'color.background.input.hovered': "var(--ds-background-input-hovered, #F8F8F8)",
    'color.background.input.pressed': "var(--ds-background-input-pressed, #FFFFFF)",
    'color.background.inverse.subtle': "var(--ds-background-inverse-subtle, #00000029)",
    'color.background.inverse.subtle.hovered': "var(--ds-background-inverse-subtle-hovered, #0000003D)",
    'color.background.inverse.subtle.pressed': "var(--ds-background-inverse-subtle-pressed, #00000052)",
    'color.background.neutral': "var(--ds-background-neutral, #0515240F)",
    'color.background.neutral.hovered': "var(--ds-background-neutral-hovered, #0B120E24)",
    'color.background.neutral.pressed': "var(--ds-background-neutral-pressed, #080F214A)",
    'color.background.neutral.subtle': "var(--ds-background-neutral-subtle, #00000000)",
    'color.background.neutral.subtle.hovered': "var(--ds-background-neutral-subtle-hovered, #0515240F)",
    'color.background.neutral.subtle.pressed': "var(--ds-background-neutral-subtle-pressed, #0B120E24)",
    'color.background.neutral.bold': "var(--ds-background-neutral-bold, #292A2E)",
    'color.background.neutral.bold.hovered': "var(--ds-background-neutral-bold-hovered, #3B3D42)",
    'color.background.neutral.bold.pressed': "var(--ds-background-neutral-bold-pressed, #505258)",
    'color.background.selected': "var(--ds-background-selected, #E9F2FE)",
    'color.background.selected.hovered': "var(--ds-background-selected-hovered, #CFE1FD)",
    'color.background.selected.pressed': "var(--ds-background-selected-pressed, #8FB8F6)",
    'color.background.selected.bold': "var(--ds-background-selected-bold, #1868DB)",
    'color.background.selected.bold.hovered': "var(--ds-background-selected-bold-hovered, #1558BC)",
    'color.background.selected.bold.pressed': "var(--ds-background-selected-bold-pressed, #123263)",
    'color.background.brand.subtlest': "var(--ds-background-brand-subtlest, #E9F2FE)",
    'color.background.brand.subtlest.hovered': "var(--ds-background-brand-subtlest-hovered, #CFE1FD)",
    'color.background.brand.subtlest.pressed': "var(--ds-background-brand-subtlest-pressed, #ADCBFB)",
    'color.background.brand.bold': "var(--ds-background-brand-bold, #1868DB)",
    'color.background.brand.bold.hovered': "var(--ds-background-brand-bold-hovered, #1558BC)",
    'color.background.brand.bold.pressed': "var(--ds-background-brand-bold-pressed, #144794)",
    'color.background.brand.boldest': "var(--ds-background-brand-boldest, #1C2B42)",
    'color.background.brand.boldest.hovered': "var(--ds-background-brand-boldest-hovered, #123263)",
    'color.background.brand.boldest.pressed': "var(--ds-background-brand-boldest-pressed, #144794)",
    'color.background.danger': "var(--ds-background-danger, #FFECEB)",
    'color.background.danger.hovered': "var(--ds-background-danger-hovered, #FFD5D2)",
    'color.background.danger.pressed': "var(--ds-background-danger-pressed, #FFB8B2)",
    'color.background.danger.subtler': "var(--ds-background-danger-subtler, #FFD5D2)",
    'color.background.danger.subtler.hovered': "var(--ds-background-danger-subtler-hovered, #FFB8B2)",
    'color.background.danger.subtler.pressed': "var(--ds-background-danger-subtler-pressed, #FD9891)",
    'color.background.danger.subtle': "var(--ds-background-danger-subtle, #FD9891)",
    'color.background.danger.bold': "var(--ds-background-danger-bold, #C9372C)",
    'color.background.danger.bold.hovered': "var(--ds-background-danger-bold-hovered, #AE2E24)",
    'color.background.danger.bold.pressed': "var(--ds-background-danger-bold-pressed, #872821)",
    'color.background.warning': "var(--ds-background-warning, #FFF5DB)",
    'color.background.warning.hovered': "var(--ds-background-warning-hovered, #FCE4A6)",
    'color.background.warning.pressed': "var(--ds-background-warning-pressed, #FBD779)",
    'color.background.warning.subtler': "var(--ds-background-warning-subtler, #FCE4A6)",
    'color.background.warning.subtler.hovered': "var(--ds-background-warning-subtler-hovered, #FBD779)",
    'color.background.warning.subtler.pressed': "var(--ds-background-warning-subtler-pressed, #FBC828)",
    'color.background.warning.subtle': "var(--ds-background-warning-subtle, #FBD779)",
    'color.background.warning.bold': "var(--ds-background-warning-bold, #FBC828)",
    'color.background.warning.bold.hovered': "var(--ds-background-warning-bold-hovered, #FCA700)",
    'color.background.warning.bold.pressed': "var(--ds-background-warning-bold-pressed, #F68909)",
    'color.background.success': "var(--ds-background-success, #EFFFD6)",
    'color.background.success.hovered': "var(--ds-background-success-hovered, #D3F1A7)",
    'color.background.success.pressed': "var(--ds-background-success-pressed, #BDE97C)",
    'color.background.success.subtler': "var(--ds-background-success-subtler, #D3F1A7)",
    'color.background.success.subtler.hovered': "var(--ds-background-success-subtler-hovered, #BDE97C)",
    'color.background.success.subtler.pressed': "var(--ds-background-success-subtler-pressed, #B3DF72)",
    'color.background.success.subtle': "var(--ds-background-success-subtle, #B3DF72)",
    'color.background.success.bold': "var(--ds-background-success-bold, #5B7F24)",
    'color.background.success.bold.hovered': "var(--ds-background-success-bold-hovered, #4C6B1F)",
    'color.background.success.bold.pressed': "var(--ds-background-success-bold-pressed, #3F5224)",
    'color.background.discovery': "var(--ds-background-discovery, #F8EEFE)",
    'color.background.discovery.hovered': "var(--ds-background-discovery-hovered, #EED7FC)",
    'color.background.discovery.pressed': "var(--ds-background-discovery-pressed, #E3BDFA)",
    'color.background.discovery.subtler': "var(--ds-background-discovery-subtler, #EED7FC)",
    'color.background.discovery.subtler.hovered': "var(--ds-background-discovery-subtler-hovered, #E3BDFA)",
    'color.background.discovery.subtler.pressed': "var(--ds-background-discovery-subtler-pressed, #D8A0F7)",
    'color.background.discovery.subtle': "var(--ds-background-discovery-subtle, #D8A0F7)",
    'color.background.discovery.bold': "var(--ds-background-discovery-bold, #964AC0)",
    'color.background.discovery.bold.hovered': "var(--ds-background-discovery-bold-hovered, #803FA5)",
    'color.background.discovery.bold.pressed': "var(--ds-background-discovery-bold-pressed, #673286)",
    'color.background.information': "var(--ds-background-information, #E9F2FE)",
    'color.background.information.hovered': "var(--ds-background-information-hovered, #CFE1FD)",
    'color.background.information.pressed': "var(--ds-background-information-pressed, #ADCBFB)",
    'color.background.information.subtler': "var(--ds-background-information-subtler, #CFE1FD)",
    'color.background.information.subtler.hovered': "var(--ds-background-information-subtler-hovered, #ADCBFB)",
    'color.background.information.subtler.pressed': "var(--ds-background-information-subtler-pressed, #8FB8F6)",
    'color.background.information.subtle': "var(--ds-background-information-subtle, #8FB8F6)",
    'color.background.information.bold': "var(--ds-background-information-bold, #1868DB)",
    'color.background.information.bold.hovered': "var(--ds-background-information-bold-hovered, #1558BC)",
    'color.background.information.bold.pressed': "var(--ds-background-information-bold-pressed, #144794)",
    'color.skeleton': "var(--ds-skeleton, #0515240F)",
    'color.skeleton.subtle': "var(--ds-skeleton-subtle, #17171708)",
    'color.blanket': "var(--ds-blanket, #050C1F75)",
    'color.blanket.selected': "var(--ds-blanket-selected, #388BFF14)",
    'color.blanket.danger': "var(--ds-blanket-danger, #EF5C4814)",
    'color.rovo.background.brand.bold': "var(--ds-rovo-background-brand-bold, #000000)",
    'color.rovo.background.brand.bold.hovered': "var(--ds-rovo-background-brand-bold-hovered, #1E1F21)",
    'color.rovo.background.brand.bold.pressed': "var(--ds-rovo-background-brand-bold-pressed, #292A2E)",
    'elevation.surface': "var(--ds-surface, #FFFFFF)",
    'elevation.surface.hovered': "var(--ds-surface-hovered, #F0F1F2)",
    'elevation.surface.pressed': "var(--ds-surface-pressed, #DDDEE1)",
    'elevation.surface.container': "var(--ds-surface-container, #17171708)",
    'elevation.surface.container.hovered': "var(--ds-surface-container-hovered, #0515240F)",
    'elevation.surface.container.pressed': "var(--ds-surface-container-pressed, #0B120E24)",
    'elevation.surface.overlay': "var(--ds-surface-overlay, #FFFFFF)",
    'elevation.surface.overlay.hovered': "var(--ds-surface-overlay-hovered, #F0F1F2)",
    'elevation.surface.overlay.pressed': "var(--ds-surface-overlay-pressed, #DDDEE1)",
    'elevation.surface.raised': "var(--ds-surface-raised, #FFFFFF)",
    'elevation.surface.raised.hovered': "var(--ds-surface-raised-hovered, #F0F1F2)",
    'elevation.surface.raised.pressed': "var(--ds-surface-raised-pressed, #DDDEE1)",
    'elevation.surface.sunken': "var(--ds-surface-sunken, #F8F8F8)",
    'utility.elevation.surface.current': "var(--ds-elevation-surface-current, #FFFFFF)"
};
const textColorMap = {
    'color.text': "var(--ds-text, #292A2E)",
    'color.text.accent.lime': "var(--ds-text-accent-lime, #4C6B1F)",
    'color.text.accent.lime.bolder': "var(--ds-text-accent-lime-bolder, #37471F)",
    'color.text.accent.red': "var(--ds-text-accent-red, #AE2E24)",
    'color.text.accent.red.bolder': "var(--ds-text-accent-red-bolder, #5D1F1A)",
    'color.text.accent.orange': "var(--ds-text-accent-orange, #9E4C00)",
    'color.text.accent.orange.bolder': "var(--ds-text-accent-orange-bolder, #693200)",
    'color.text.accent.yellow': "var(--ds-text-accent-yellow, #7F5F01)",
    'color.text.accent.yellow.bolder': "var(--ds-text-accent-yellow-bolder, #533F04)",
    'color.text.accent.green': "var(--ds-text-accent-green, #216E4E)",
    'color.text.accent.green.bolder': "var(--ds-text-accent-green-bolder, #164B35)",
    'color.text.accent.teal': "var(--ds-text-accent-teal, #206A83)",
    'color.text.accent.teal.bolder': "var(--ds-text-accent-teal-bolder, #164555)",
    'color.text.accent.blue': "var(--ds-text-accent-blue, #1558BC)",
    'color.text.accent.blue.bolder': "var(--ds-text-accent-blue-bolder, #123263)",
    'color.text.accent.purple': "var(--ds-text-accent-purple, #803FA5)",
    'color.text.accent.purple.bolder': "var(--ds-text-accent-purple-bolder, #48245D)",
    'color.text.accent.magenta': "var(--ds-text-accent-magenta, #943D73)",
    'color.text.accent.magenta.bolder': "var(--ds-text-accent-magenta-bolder, #50253F)",
    'color.text.accent.gray': "var(--ds-text-accent-gray, #505258)",
    'color.text.accent.gray.bolder': "var(--ds-text-accent-gray-bolder, #1E1F21)",
    'color.text.disabled': "var(--ds-text-disabled, #080F214A)",
    'color.text.inverse': "var(--ds-text-inverse, #FFFFFF)",
    'color.text.selected': "var(--ds-text-selected, #1868DB)",
    'color.text.brand': "var(--ds-text-brand, #1868DB)",
    'color.text.danger': "var(--ds-text-danger, #AE2E24)",
    'color.text.danger.bolder': "var(--ds-text-danger-bolder, #5D1F1A)",
    'color.text.warning': "var(--ds-text-warning, #9E4C00)",
    'color.text.warning.inverse': "var(--ds-text-warning-inverse, #292A2E)",
    'color.text.warning.bolder': "var(--ds-text-warning-bolder, #693200)",
    'color.text.success': "var(--ds-text-success, #4C6B1F)",
    'color.text.success.bolder': "var(--ds-text-success-bolder, #37471F)",
    'color.text.discovery': "var(--ds-text-discovery, #803FA5)",
    'color.text.discovery.bolder': "var(--ds-text-discovery-bolder, #48245D)",
    'color.text.information': "var(--ds-text-information, #1558BC)",
    'color.text.information.bolder': "var(--ds-text-information-bolder, #123263)",
    'color.text.subtlest': "var(--ds-text-subtlest, #6B6E76)",
    'color.text.subtle': "var(--ds-text-subtle, #505258)",
    'color.link': "var(--ds-link, #1868DB)",
    'color.link.pressed': "var(--ds-link-pressed, #1558BC)",
    'color.link.visited': "var(--ds-link-visited, #803FA5)",
    'color.link.visited.pressed': "var(--ds-link-visited-pressed, #48245D)"
};
const fillMap = {
    'color.icon': "var(--ds-icon, #292A2E)",
    'color.icon.accent.lime': "var(--ds-icon-accent-lime, #6A9A23)",
    'color.icon.accent.red': "var(--ds-icon-accent-red, #C9372C)",
    'color.icon.accent.orange': "var(--ds-icon-accent-orange, #E06C00)",
    'color.icon.accent.yellow': "var(--ds-icon-accent-yellow, #B38600)",
    'color.icon.accent.green': "var(--ds-icon-accent-green, #22A06B)",
    'color.icon.accent.teal': "var(--ds-icon-accent-teal, #2898BD)",
    'color.icon.accent.blue': "var(--ds-icon-accent-blue, #357DE8)",
    'color.icon.accent.purple': "var(--ds-icon-accent-purple, #AF59E1)",
    'color.icon.accent.magenta': "var(--ds-icon-accent-magenta, #CD519D)",
    'color.icon.accent.gray': "var(--ds-icon-accent-gray, #7D818A)",
    'color.icon.disabled': "var(--ds-icon-disabled, #080F214A)",
    'color.icon.inverse': "var(--ds-icon-inverse, #FFFFFF)",
    'color.icon.selected': "var(--ds-icon-selected, #1868DB)",
    'color.icon.brand': "var(--ds-icon-brand, #1868DB)",
    'color.icon.danger': "var(--ds-icon-danger, #C9372C)",
    'color.icon.warning': "var(--ds-icon-warning, #E06C00)",
    'color.icon.warning.inverse': "var(--ds-icon-warning-inverse, #292A2E)",
    'color.icon.success': "var(--ds-icon-success, #6A9A23)",
    'color.icon.discovery': "var(--ds-icon-discovery, #AF59E1)",
    'color.icon.information': "var(--ds-icon-information, #357DE8)",
    'color.icon.subtlest': "var(--ds-icon-subtlest, #6B6E76)",
    'color.icon.subtle': "var(--ds-icon-subtle, #505258)"
};
const layerMap = {
    '1': 1,
    card: 100,
    navigation: 200,
    dialog: 300,
    layer: 400,
    blanket: 500,
    modal: 510,
    flag: 600,
    spotlight: 700,
    tooltip: 800
};
const borderWidthMap = {
    'border.width': "var(--ds-border-width, 1px)",
    'border.width.selected': "var(--ds-border-width-selected, 2px)",
    'border.width.focused': "var(--ds-border-width-focused, 2px)"
};
const borderRadiusMap = {
    'radius.xsmall': "var(--ds-radius-xsmall, 2px)",
    'radius.small': "var(--ds-radius-small, 3px)",
    'radius.medium': "var(--ds-radius-medium, 6px)",
    'radius.large': "var(--ds-radius-large, 8px)",
    'radius.xlarge': "var(--ds-radius-xlarge, 12px)",
    'radius.xxlarge': "var(--ds-radius-xxlarge, 16px)",
    'radius.full': "var(--ds-radius-full, 9999px)",
    'radius.tile': "var(--ds-radius-tile, 25%)"
};
const fontMap = {
    'font.body': "var(--ds-font-body, normal 400 14px/20px \"Atlassian Sans\", ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, \"Helvetica Neue\", sans-serif)",
    'font.body.large': "var(--ds-font-body-large, normal 400 16px/24px \"Atlassian Sans\", ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, \"Helvetica Neue\", sans-serif)",
    'font.body.small': "var(--ds-font-body-small, normal 400 12px/16px \"Atlassian Sans\", ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, \"Helvetica Neue\", sans-serif)",
    'font.code': "var(--ds-font-code, normal 400 0.875em/1 \"Atlassian Mono\", ui-monospace, Menlo, \"Segoe UI Mono\", \"Ubuntu Mono\", monospace)",
    'font.heading.large': "var(--ds-font-heading-large, normal 653 24px/28px \"Atlassian Sans\", ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, \"Helvetica Neue\", sans-serif)",
    'font.heading.medium': "var(--ds-font-heading-medium, normal 653 20px/24px \"Atlassian Sans\", ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, \"Helvetica Neue\", sans-serif)",
    'font.heading.small': "var(--ds-font-heading-small, normal 653 16px/20px \"Atlassian Sans\", ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, \"Helvetica Neue\", sans-serif)",
    'font.heading.xlarge': "var(--ds-font-heading-xlarge, normal 653 28px/32px \"Atlassian Sans\", ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, \"Helvetica Neue\", sans-serif)",
    'font.heading.xsmall': "var(--ds-font-heading-xsmall, normal 653 14px/20px \"Atlassian Sans\", ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, \"Helvetica Neue\", sans-serif)",
    'font.heading.xxlarge': "var(--ds-font-heading-xxlarge, normal 653 32px/36px \"Atlassian Sans\", ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, \"Helvetica Neue\", sans-serif)",
    'font.heading.xxsmall': "var(--ds-font-heading-xxsmall, normal 653 12px/16px \"Atlassian Sans\", ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, \"Helvetica Neue\", sans-serif)",
    'font.metric.large': "var(--ds-font-metric-large, normal 653 28px/32px \"Atlassian Sans\", ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, \"Helvetica Neue\", sans-serif)",
    'font.metric.medium': "var(--ds-font-metric-medium, normal 653 24px/28px \"Atlassian Sans\", ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, \"Helvetica Neue\", sans-serif)",
    'font.metric.small': "var(--ds-font-metric-small, normal 653 16px/20px \"Atlassian Sans\", ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, \"Helvetica Neue\", sans-serif)"
};
const fontWeightMap = {
    'font.weight.bold': "var(--ds-font-weight-bold, 653)",
    'font.weight.medium': "var(--ds-font-weight-medium, 500)",
    'font.weight.regular': "var(--ds-font-weight-regular, 400)",
    'font.weight.semibold': "var(--ds-font-weight-semibold, 600)"
};
const fontFamilyMap = {
    'font.family.body': "var(--ds-font-family-body, \"Atlassian Sans\", ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, \"Helvetica Neue\", sans-serif)",
    'font.family.brand.body': "var(--ds-font-family-brand-body, \"Charlie Text\", ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, \"Helvetica Neue\", sans-serif)",
    'font.family.brand.heading': "var(--ds-font-family-brand-heading, \"Charlie Display\", ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, \"Helvetica Neue\", sans-serif)",
    'font.family.code': "var(--ds-font-family-code, \"Atlassian Mono\", ui-monospace, Menlo, \"Segoe UI Mono\", \"Ubuntu Mono\", monospace)",
    'font.family.heading': "var(--ds-font-family-heading, \"Atlassian Sans\", ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, \"Helvetica Neue\", sans-serif)"
};
const textSizeMap = {
    medium: "var(--ds-font-body, normal 400 14px/20px \"Atlassian Sans\", ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, \"Helvetica Neue\", sans-serif)",
    large: "var(--ds-font-body-large, normal 400 16px/24px \"Atlassian Sans\", ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, \"Helvetica Neue\", sans-serif)",
    small: "var(--ds-font-body-small, normal 400 12px/16px \"Atlassian Sans\", ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, \"Helvetica Neue\", sans-serif)"
};
const textWeightMap = {
    bold: "var(--ds-font-weight-bold, 653)",
    medium: "var(--ds-font-weight-medium, 500)",
    regular: "var(--ds-font-weight-regular, 400)",
    semibold: "var(--ds-font-weight-semibold, 600)"
};
const metricTextSizeMap = {
    large: "var(--ds-font-metric-large, normal 653 28px/32px \"Atlassian Sans\", ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, \"Helvetica Neue\", sans-serif)",
    medium: "var(--ds-font-metric-medium, normal 653 24px/28px \"Atlassian Sans\", ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, \"Helvetica Neue\", sans-serif)",
    small: "var(--ds-font-metric-small, normal 653 16px/20px \"Atlassian Sans\", ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, \"Helvetica Neue\", sans-serif)"
};
// Generate maps for Box props. backgroundColor, padding, etc
const spacingProperties = [
    // Used by Box
    'padding',
    'paddingBlock',
    'paddingBlockStart',
    'paddingBlockEnd',
    'paddingInline',
    'paddingInlineStart',
    'paddingInlineEnd',
    // Used by Inline and Stack
    'gap',
    'rowGap',
    'columnGap'
];
const getSerializedStylesMap = (cssProperty, tokenMap)=>{
    return Object.keys(tokenMap).reduce((emotionSpacingMap, token)=>{
        // eslint-disable-next-line @repo/internal/styles/no-exported-styles
        emotionSpacingMap[token] = (0, _react.css)({
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
            [cssProperty]: tokenMap[token]
        });
        return emotionSpacingMap;
    }, {});
};
const paddingStylesMap = spacingProperties.reduce((styleMap, spacingProperty)=>{
    styleMap[spacingProperty] = getSerializedStylesMap(spacingProperty, positiveSpaceMap);
    return styleMap;
}, {});
const spaceStylesMap = spacingProperties.reduce((styleMap, spacingProperty)=>{
    styleMap[spacingProperty] = getSerializedStylesMap(spacingProperty, positiveSpaceMap);
    return styleMap;
}, {});
const backgroundColorStylesMap = getSerializedStylesMap('backgroundColor', backgroundColorMap);
const textColorStylesMap = getSerializedStylesMap('color', textColorMap);
const fontWeightStylesMap = getSerializedStylesMap('fontWeight', fontWeightMap);
const fontFamilyStylesMap = getSerializedStylesMap('fontFamily', fontFamilyMap);
const fontStylesMap = getSerializedStylesMap('font', fontMap);
const textSizeStylesMap = getSerializedStylesMap('font', textSizeMap);
const textWeightStylesMap = getSerializedStylesMap('fontWeight', textWeightMap);
const surfaceColorStylesMap = getSerializedStylesMap((0, _constants.CURRENT_SURFACE_CSS_VAR), surfaceColorMap);
const isSurfaceColorToken = (color)=>surfaceColorMap[color] !== undefined;
const metricTextSizeStylesMap = getSerializedStylesMap('font', metricTextSizeMap);

},{"@swc/helpers/_/_object_spread":"9gdrV","@emotion/react":"cCAhJ","@atlaskit/tokens/constants":"5fDwY","@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"fMzqB":[function(require,module,exports,__globalThis) {
/* xcss.tsx generated by @compiled/babel-plugin v0.39.1 */ // eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled -- Ignored via go/DSP-18766
var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "tokensMap", ()=>tokensMap);
parcelHelpers.export(exports, "parseXcss", ()=>parseXcss);
/**
 * ### xcss
 *
 * `xcss` is a safer, tokens-first approach to CSS-in-JS. It allows token-backed values for
 * CSS application.
 *
 * ```tsx
 * const styles = xcss({
 *   padding: 'space.100'
 * })
 * ```
 *
 * @deprecated Use `@atlaskit/css` with `@atlaskit/primitives/compiled` instead.
 * {@link https://hello.atlassian.net/wiki/spaces/DST/pages/4992259434/Guidance+Migrating+to+atlaskit+css+from+xcss Internal documentation for migration; no external access}
 */ // eslint-disable-next-line @atlaskit/volt-strict-mode/no-multiple-exports
parcelHelpers.export(exports, "xcss", ()=>xcss);
var _react = require("react");
var _react1 = require("@emotion/react");
var _styleMapsPartial = require("./style-maps.partial");
var process = require("690434904e26513b");
const tokensMap = {
    backgroundColor: (0, _styleMapsPartial.backgroundColorMap),
    blockSize: (0, _styleMapsPartial.dimensionMap),
    borderBlockColor: (0, _styleMapsPartial.borderColorMap),
    borderBlockEndColor: (0, _styleMapsPartial.borderColorMap),
    borderBlockEndWidth: (0, _styleMapsPartial.borderWidthMap),
    borderBlockStartColor: (0, _styleMapsPartial.borderColorMap),
    borderBlockStartWidth: (0, _styleMapsPartial.borderWidthMap),
    borderBlockWidth: (0, _styleMapsPartial.borderWidthMap),
    borderBottomColor: (0, _styleMapsPartial.borderColorMap),
    borderBottomLeftRadius: (0, _styleMapsPartial.borderRadiusMap),
    borderBottomRightRadius: (0, _styleMapsPartial.borderRadiusMap),
    borderBottomWidth: (0, _styleMapsPartial.borderWidthMap),
    borderColor: (0, _styleMapsPartial.borderColorMap),
    borderEndEndRadius: (0, _styleMapsPartial.borderRadiusMap),
    borderEndStartRadius: (0, _styleMapsPartial.borderRadiusMap),
    borderInlineColor: (0, _styleMapsPartial.borderColorMap),
    borderInlineEndColor: (0, _styleMapsPartial.borderColorMap),
    borderInlineEndWidth: (0, _styleMapsPartial.borderWidthMap),
    borderInlineStartColor: (0, _styleMapsPartial.borderColorMap),
    borderInlineStartWidth: (0, _styleMapsPartial.borderWidthMap),
    borderInlineWidth: (0, _styleMapsPartial.borderWidthMap),
    borderLeftColor: (0, _styleMapsPartial.borderColorMap),
    borderLeftWidth: (0, _styleMapsPartial.borderWidthMap),
    borderRadius: (0, _styleMapsPartial.borderRadiusMap),
    borderRightColor: (0, _styleMapsPartial.borderColorMap),
    borderRightWidth: (0, _styleMapsPartial.borderWidthMap),
    borderStartEndRadius: (0, _styleMapsPartial.borderRadiusMap),
    borderStartStartRadius: (0, _styleMapsPartial.borderRadiusMap),
    borderTopColor: (0, _styleMapsPartial.borderColorMap),
    borderTopLeftRadius: (0, _styleMapsPartial.borderRadiusMap),
    borderTopRightRadius: (0, _styleMapsPartial.borderRadiusMap),
    borderTopWidth: (0, _styleMapsPartial.borderWidthMap),
    borderWidth: (0, _styleMapsPartial.borderWidthMap),
    bottom: (0, _styleMapsPartial.allSpaceMap),
    boxShadow: (0, _styleMapsPartial.shadowMap),
    color: (0, _styleMapsPartial.textColorMap),
    columnGap: (0, _styleMapsPartial.positiveSpaceMap),
    font: (0, _styleMapsPartial.fontMap),
    fontFamily: (0, _styleMapsPartial.fontFamilyMap),
    fontWeight: (0, _styleMapsPartial.fontWeightMap),
    gap: (0, _styleMapsPartial.positiveSpaceMap),
    height: (0, _styleMapsPartial.dimensionMap),
    inlineSize: (0, _styleMapsPartial.dimensionMap),
    inset: (0, _styleMapsPartial.allSpaceMap),
    insetBlock: (0, _styleMapsPartial.allSpaceMap),
    insetBlockEnd: (0, _styleMapsPartial.allSpaceMap),
    insetBlockStart: (0, _styleMapsPartial.allSpaceMap),
    insetInline: (0, _styleMapsPartial.allSpaceMap),
    insetInlineEnd: (0, _styleMapsPartial.allSpaceMap),
    insetInlineStart: (0, _styleMapsPartial.allSpaceMap),
    left: (0, _styleMapsPartial.allSpaceMap),
    margin: (0, _styleMapsPartial.allSpaceMap),
    marginBlock: (0, _styleMapsPartial.allSpaceMap),
    marginBlockEnd: (0, _styleMapsPartial.allSpaceMap),
    marginBlockStart: (0, _styleMapsPartial.allSpaceMap),
    marginBottom: (0, _styleMapsPartial.allSpaceMap),
    marginInline: (0, _styleMapsPartial.allSpaceMap),
    marginInlineEnd: (0, _styleMapsPartial.allSpaceMap),
    marginInlineStart: (0, _styleMapsPartial.allSpaceMap),
    marginLeft: (0, _styleMapsPartial.allSpaceMap),
    marginRight: (0, _styleMapsPartial.allSpaceMap),
    marginTop: (0, _styleMapsPartial.allSpaceMap),
    maxBlockSize: (0, _styleMapsPartial.dimensionMap),
    maxHeight: (0, _styleMapsPartial.dimensionMap),
    maxInlineSize: (0, _styleMapsPartial.dimensionMap),
    maxWidth: (0, _styleMapsPartial.dimensionMap),
    minBlockSize: (0, _styleMapsPartial.dimensionMap),
    minHeight: (0, _styleMapsPartial.dimensionMap),
    minInlineSize: (0, _styleMapsPartial.dimensionMap),
    minWidth: (0, _styleMapsPartial.dimensionMap),
    opacity: (0, _styleMapsPartial.opacityMap),
    outlineColor: (0, _styleMapsPartial.borderColorMap),
    outlineOffset: (0, _styleMapsPartial.allSpaceMap),
    outlineWidth: (0, _styleMapsPartial.borderWidthMap),
    padding: (0, _styleMapsPartial.positiveSpaceMap),
    paddingBlock: (0, _styleMapsPartial.positiveSpaceMap),
    paddingBlockEnd: (0, _styleMapsPartial.positiveSpaceMap),
    paddingBlockStart: (0, _styleMapsPartial.positiveSpaceMap),
    paddingBottom: (0, _styleMapsPartial.positiveSpaceMap),
    paddingInline: (0, _styleMapsPartial.positiveSpaceMap),
    paddingInlineEnd: (0, _styleMapsPartial.positiveSpaceMap),
    paddingInlineStart: (0, _styleMapsPartial.positiveSpaceMap),
    paddingLeft: (0, _styleMapsPartial.positiveSpaceMap),
    paddingRight: (0, _styleMapsPartial.positiveSpaceMap),
    paddingTop: (0, _styleMapsPartial.positiveSpaceMap),
    right: (0, _styleMapsPartial.allSpaceMap),
    rowGap: (0, _styleMapsPartial.positiveSpaceMap),
    top: (0, _styleMapsPartial.allSpaceMap),
    width: (0, _styleMapsPartial.dimensionMap),
    zIndex: (0, _styleMapsPartial.layerMap)
};
const uniqueSymbol = Symbol('UNSAFE_INTERNAL_styles');
const isSafeEnvToThrow = ()=>typeof process === 'object' && typeof process.env === 'object' && false;
const reNestedSelectors = /(\.|\s|&+|\*\>|#|\[.*\])/;
const safeSelectors = /^@media .*$|^::?.*$|^@supports .*$/;
const transformStyles = (styleObj)=>{
    if (!styleObj || typeof styleObj !== 'object') return styleObj;
    // If styles are defined as a CSSObject[], recursively call on each element until we reach CSSObject
    if (Array.isArray(styleObj)) return styleObj.map(transformStyles);
    // Modifies styleObj in place. Be careful.
    Object.entries(styleObj).forEach(([key, value])=>{
        // If key is a pseudo class or a pseudo element, then value should be an object.
        // So, call transformStyles on the value
        if (typeof value === 'object' && safeSelectors.test(key)) {
            styleObj[key] = transformStyles(value);
            return;
        }
        if (isSafeEnvToThrow()) {
            // We don't support `.class`, `[data-testid]`, `> *`, `#some-id`
            if (reNestedSelectors.test(key)) throw new Error(`Styles not supported for key '${key}'.`);
        }
        // We have now dealt with all the special cases, so,
        // check whether what remains is a style property
        // that can be transformed.
        if (!(key in tokensMap)) return;
        const tokenValue = tokensMap[key][value];
        styleObj[key] = tokenValue !== null && tokenValue !== void 0 ? tokenValue : value;
    });
    return styleObj;
};
const baseXcss = (style)=>{
    const transformedStyles = transformStyles(style);
    return {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values, @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
        [uniqueSymbol]: (0, _react1.css)(transformedStyles)
    };
};
const parseXcss = (args)=>{
    if (Array.isArray(args)) {
        const emotion = [];
        const staticArr = [];
        for (const arg of args){
            const result = parseXcss(arg);
            if (result.emotion) emotion.push(...result.emotion);
            if (result.static) staticArr.push(result.static);
        }
        return {
            emotion,
            static: staticArr.join(' ')
        };
    }
    const objArgs = args;
    const { [uniqueSymbol]: styles } = objArgs || {};
    if (styles) return {
        emotion: [
            styles
        ]
    };
    if (args) {
        // We use string interpolation here instead of .toString() just
        // in case the resulting object doesn't have the method available.
        const stringifiedArgs = `${args}`;
        if (stringifiedArgs) return {
            static: stringifiedArgs
        };
    }
    return {};
};
function xcss(style) {
    return baseXcss(style);
}

},{"690434904e26513b":"gNLf3","react":"ltHCL","@emotion/react":"cCAhJ","./style-maps.partial":"a7SYG","@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"7RyYv":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>(0, _tooltipDefault.default));
parcelHelpers.export(exports, "TooltipPrimitive", ()=>(0, _tooltipPrimitiveDefault.default));
var _tooltip = require("./tooltip");
var _tooltipDefault = parcelHelpers.interopDefault(_tooltip);
var _tooltipPrimitive = require("./tooltip-primitive");
var _tooltipPrimitiveDefault = parcelHelpers.interopDefault(_tooltipPrimitive);

},{"./tooltip":"b06ye","./tooltip-primitive":"gIFNN","@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"b06ye":[function(require,module,exports,__globalThis) {
/* tooltip.tsx generated by @compiled/babel-plugin v0.39.1 */ var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _objectSpread = require("@swc/helpers/_/_object_spread");
var _objectSpreadProps = require("@swc/helpers/_/_object_spread_props");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _bindEventListener = require("bind-event-listener");
var _analyticsNext = require("@atlaskit/analytics-next");
var _noop = require("@atlaskit/ds-lib/noop");
var _noopDefault = parcelHelpers.interopDefault(_noop);
var _useCloseOnEscapePress = require("@atlaskit/ds-lib/use-close-on-escape-press");
var _useCloseOnEscapePressDefault = parcelHelpers.interopDefault(_useCloseOnEscapePress);
var _useStableRef = require("@atlaskit/ds-lib/use-stable-ref");
var _useStableRefDefault = parcelHelpers.interopDefault(_useStableRef);
var _openLayerObserver = require("@atlaskit/layering/experimental/open-layer-observer");
var _motion = require("@atlaskit/motion");
var _platformFeatureFlags = require("@atlaskit/platform-feature-flags");
var _popper = require("@atlaskit/popper");
var _portal = require("@atlaskit/portal");
var _portalDefault = parcelHelpers.interopDefault(_portal);
var _constants = require("@atlaskit/theme/constants");
var _placementMap = require("@atlaskit/top-layer/placement-map");
var _popover = require("@atlaskit/top-layer/popover");
var _useAnchorPosition = require("@atlaskit/top-layer/use-anchor-position");
var _useAnchorPositionAtPoint = require("@atlaskit/top-layer/use-anchor-position-at-point");
var _dragManager = require("./internal/drag-manager");
var _getAnchorPoint = require("./internal/get-anchor-point");
var _getVirtualElementFromMousePos = require("./internal/get-virtual-element-from-mouse-pos");
var _tooltipManager = require("./internal/tooltip-manager");
var _useUniqueId = require("./internal/use-unique-id");
var _useUniqueIdDefault = parcelHelpers.interopDefault(_useUniqueId);
var _tooltipContainer = require("./tooltip-container");
var _tooltipContainerDefault = parcelHelpers.interopDefault(_tooltipContainer);
const tooltipZIndex = (0, _constants.layers).tooltip();
const analyticsAttributes = {
    componentName: 'tooltip',
    packageName: "@af/atlassian-studio",
    packageVersion: "0.16.1"
};
// Inverts motion direction
const invertedDirection = {
    top: 'bottom',
    bottom: 'top',
    left: 'right',
    right: 'left'
};
/**
 * Converts a Popper placement to it's general direction.
 *
 * @param placement - Popper Placement value, e.g. 'top-start'
 * @returns Popper Direction, e.g. 'top'
 */ const getDirectionFromPlacement = (placement)=>placement.split('-')[0];
/**
 * __Tooltip__
 *
 * A tooltip is a floating, non-actionable label used to explain a user interface element or feature.
 */ function Tooltip({ children, position = 'bottom', mousePosition = 'bottom', content, truncate = false, // @ts-ignore: [PIT-1685] Fails in post-office due to backwards incompatibility issue with React 18
component: Container = (0, _tooltipContainerDefault.default), tag: TargetContainer = 'div', testId, delay = 300, onShow = (0, _noopDefault.default), onHide = (0, _noopDefault.default), canAppear, hideTooltipOnClick = false, hideTooltipOnMouseDown = false, analyticsContext, strategy = 'fixed', ignoreTooltipPointerEvents = false, isScreenReaderAnnouncementDisabled = false, shortcut, shouldAlwaysFadeIn = false, shouldRenderToParent = false }) {
    var _apiRef_current;
    // Not using a gate for this check. When the gate is disabled `mouse-y` and `mouse-x` are treated as `mouse`.
    const isMousePosition = position === 'mouse' || position === 'mouse-y' || position === 'mouse-x';
    const tooltipPosition = isMousePosition ? mousePosition : position;
    const onShowHandler = (0, _analyticsNext.usePlatformLeafSyntheticEventHandler)((0, _objectSpread._)({
        fn: onShow,
        action: 'displayed',
        analyticsData: analyticsContext
    }, analyticsAttributes));
    const onHideHandler = (0, _analyticsNext.usePlatformLeafSyntheticEventHandler)((0, _objectSpread._)({
        fn: onHide,
        action: 'hidden',
        analyticsData: analyticsContext
    }, analyticsAttributes));
    const apiRef = (0, _react.useRef)(null);
    const [state, setState] = (0, _react.useState)('hide');
    const targetRef = (0, _react.useRef)(null);
    const containerRef = (0, _react.useRef)(null);
    // This function is deliberately _not_ memoized as it needs to re-run every render
    // to pick up any child ref changes. If you use render props you don't have this issue.
    const setImplicitRefFromChildren = (node)=>{
        containerRef.current = node;
        targetRef.current = node ? node.firstElementChild : null;
    };
    // This is memoized and passed into the render props callback.
    const setDirectRef = (0, _react.useCallback)((node)=>{
        targetRef.current = node;
    }, []);
    // Putting a few things into refs so that we don't have to break memoization
    const stableState = (0, _useStableRefDefault.default)(state);
    // These props are placed in separate refs instead of a single object to reduce memory usage.
    // Placing them in the same object previously caused an increase in the number of JavaScript event listeners
    // before garbage collection.
    const onShowHandlerStable = (0, _useStableRefDefault.default)(onShowHandler);
    const onHideHandlerStable = (0, _useStableRefDefault.default)(onHideHandler);
    const delayStable = (0, _useStableRefDefault.default)(delay);
    const canAppearStable = (0, _useStableRefDefault.default)(canAppear);
    const hasCalledShowHandler = (0, _react.useRef)(false);
    const shouldAlwaysFadeInStable = (0, _useStableRefDefault.default)(shouldAlwaysFadeIn);
    const start = (0, _react.useCallback)((api)=>{
        apiRef.current = api;
        hasCalledShowHandler.current = false;
    }, []);
    const done = (0, _react.useCallback)(()=>{
        if (!apiRef.current) return;
        // Only call onHideHandler if we have called onShowHandler
        if (hasCalledShowHandler.current) onHideHandlerStable.current();
        apiRef.current = null;
        hasCalledShowHandler.current = false;
        // just in case
        setState('hide');
    }, [
        onHideHandlerStable
    ]);
    const abort = (0, _react.useCallback)(()=>{
        if (!apiRef.current) return;
        apiRef.current.abort();
        // Only call onHideHandler if we have called onShowHandler
        if (hasCalledShowHandler.current) onHideHandlerStable.current();
        apiRef.current = null;
    }, [
        onHideHandlerStable
    ]);
    (0, _react.useEffect)(function mount() {
        return function unmount() {
            if (apiRef.current) abort();
        };
    }, [
        abort
    ]);
    const isDraggingRef = (0, _react.useRef)(false);
    (0, _react.useEffect)(()=>{
        return (0, _dragManager.register)({
            onRegister ({ isDragging }) {
                isDraggingRef.current = isDragging;
            },
            onDragStart () {
                var /**
         * Hiding any visible tooltips when a drag starts because otherwise it
         * looks janky (disappears and reappears), and is not required.
         */ _apiRef_current;
                (_apiRef_current = apiRef.current) === null || _apiRef_current === void 0 ? void 0 : _apiRef_current.requestHide({
                    isImmediate: true
                });
                isDraggingRef.current = true;
            },
            onDragEnd () {
                isDraggingRef.current = false;
            }
        });
    }, []);
    const tryShowTooltip = (0, _react.useCallback)((source)=>{
        var _canAppearStable_current;
        /**
     * Prevent tooltips from being shown during a drag. This can occur with
     * the native drag and drop API, where some pointer events can fire
     * when they should not and lead to jank with tooltips.
     */ if (isDraggingRef.current) return;
        // Another tooltip is has been active but we still have the old `api`
        // around. We need to finish up the last usage.
        // Note: just being safe - this should not happen
        if (apiRef.current && !apiRef.current.isActive()) abort();
        // This tooltip is already active, we can exit
        if (apiRef.current && apiRef.current.isActive()) {
            apiRef.current.keep();
            return;
        }
        /**
     * Check if tooltip is allowed to show.
     *
     * Once a tooltip has started, or has scheduled to start
     * we won't be checking `canAppear` again.
     *
     * - We don't want tooltips to disappear once they are shown
     * - For consistency, we start after a single positive `canAppear`.
     *   Otherwise the amount of times we ask consumers would depend on
     *   how many times we get a "mousemove", which _could_ lead to situations
     *   where moving the mouse could result in a different outcome to if
     *   the mouse was not moved.
     */ if (canAppearStable.current && !((_canAppearStable_current = canAppearStable.current) === null || _canAppearStable_current === void 0 ? void 0 : _canAppearStable_current.call(canAppearStable))) return;
        const entry = {
            source,
            delay: delayStable.current,
            show: ({ isImmediate })=>{
                // Call the onShow handler if it hasn't been called yet
                if (!hasCalledShowHandler.current) {
                    hasCalledShowHandler.current = true;
                    onShowHandlerStable.current();
                }
                setState(!isImmediate ? 'fade-in' : 'show-immediate');
            },
            hide: ({ isImmediate })=>{
                if (isImmediate) setState('hide');
                else if ((0, _platformFeatureFlags.fg)('platform-dst-top-layer-tooltip')) // Top-layer path: set state to 'top-layer-exit'. The component
                // stays mounted and Popover's isOpen prop transitions to
                // false, triggering the CSS exit animation internally.
                // finishHideAnimation is called after a brief delay matching
                // the CSS exit animation duration.
                setState('top-layer-exit');
                else setState('before-fade-out');
            },
            done,
            shouldAlwaysFadeIn: shouldAlwaysFadeInStable.current
        };
        const api = (0, _tooltipManager.show)(entry);
        start(api);
    }, [
        canAppearStable,
        delayStable,
        done,
        start,
        abort,
        onShowHandlerStable,
        shouldAlwaysFadeInStable
    ]);
    const hideTooltipOnEsc = (0, _react.useCallback)(()=>{
        var _apiRef_current;
        (_apiRef_current = apiRef.current) === null || _apiRef_current === void 0 ? void 0 : _apiRef_current.requestHide({
            isImmediate: true
        });
    }, [
        apiRef
    ]);
    // When using top-layer, popover="auto" handles Escape natively
    (0, _useCloseOnEscapePressDefault.default)({
        onClose: hideTooltipOnEsc,
        isDisabled: state === 'hide' || state === 'fade-out' || state === 'top-layer-exit' || (0, _platformFeatureFlags.fg)('platform-dst-top-layer-tooltip')
    });
    // ── Top-layer exit animation lifecycle ──
    // When state is 'top-layer-exit', Popover's isOpen transitions to false and
    // the CSS exit animation plays. The Popover's built-in `transitionend`
    // detection (with timeout fallback) calls `onExitFinish` when the exit
    // animation completes, which triggers the tooltip-manager lifecycle
    // (finishHideAnimation → done → onHide, setState('hide'), cleanup).
    const handleExitFinish = (0, _react.useCallback)(()=>{
        var _apiRef_current;
        (_apiRef_current = apiRef.current) === null || _apiRef_current === void 0 ? void 0 : _apiRef_current.finishHideAnimation();
    }, []);
    (0, _react.useEffect)(()=>{
        if (state === 'hide') return 0, _noopDefault.default;
        if (state === 'before-fade-out') setState('fade-out');
        const unbind = (0, _bindEventListener.bind)(window, {
            type: 'scroll',
            listener: ()=>{
                if (apiRef.current) apiRef.current.requestHide({
                    isImmediate: true
                });
            },
            options: {
                capture: true,
                passive: true,
                once: true
            }
        });
        return unbind;
    }, [
        state
    ]);
    const onMouseDown = (0, _react.useCallback)(()=>{
        if (hideTooltipOnMouseDown && apiRef.current) apiRef.current.requestHide({
            isImmediate: true
        });
    }, [
        hideTooltipOnMouseDown
    ]);
    const onClick = (0, _react.useCallback)(()=>{
        if (hideTooltipOnClick && apiRef.current) apiRef.current.requestHide({
            isImmediate: true
        });
    }, [
        hideTooltipOnClick
    ]);
    // Ideally we would be using onMouseEnter here, but
    // because we are binding the event to the target parent
    // we need to listen for the mouseover of all sub elements
    // This means when moving along a tooltip we are quickly toggling
    // between api.requestHide and api.keep. This it not ideal
    const onMouseOver = (0, _react.useCallback)((event)=>{
        // Ignoring events from the container ref
        if (containerRef.current && event.target === containerRef.current) return;
        // Using prevent default as a signal that parent tooltips
        if (event.defaultPrevented) return;
        event.preventDefault();
        const source = isMousePosition ? {
            type: 'mouse',
            clientX: event.clientX,
            clientY: event.clientY
        } : {
            type: 'keyboard'
        };
        tryShowTooltip(source);
    }, [
        isMousePosition,
        tryShowTooltip
    ]);
    // Ideally we would be using onMouseEnter here, but
    // because we are binding the event to the target parent
    // we need to listen for the mouseout of all sub elements
    // This means when moving along a tooltip we are quickly toggling
    // between api.requestHide and api.keep. This it not ideal
    const onMouseOut = (0, _react.useCallback)((event)=>{
        // Ignoring events from the container ref
        if (containerRef.current && event.target === containerRef.current) return;
        // Using prevent default as a signal that parent tooltips
        if (event.defaultPrevented) return;
        event.preventDefault();
        if (apiRef.current) apiRef.current.requestHide({
            isImmediate: false
        });
    }, []);
    const onMouseMove = isMousePosition ? (event)=>{
        var _apiRef_current;
        if ((_apiRef_current = apiRef.current) === null || _apiRef_current === void 0 ? void 0 : _apiRef_current.isActive()) apiRef.current.mousePos = {
            clientX: event.clientX,
            clientY: event.clientY
        };
    } : undefined;
    const onMouseOverTooltip = (0, _react.useCallback)(()=>{
        if (apiRef.current && apiRef.current.isActive()) {
            apiRef.current.keep();
            return;
        }
    }, []);
    const onFocus = (0, _react.useCallback)((e)=>{
        // Check if focus-visible
        // Prevents tooltips from showing when focus is not visible,
        // i.e., when focus is moved onto tooltip trigger inside a popup on open
        try {
            if (!e.target.matches(':focus-visible')) return;
        } catch (e) {
        // Ignore errors from environments that don't support :focus-visible
        }
        // TODO: this does not play well with `hideTooltipOnMouseDown`
        // as "focus" will occur after the "mousedown".
        tryShowTooltip({
            type: 'keyboard'
        });
    }, [
        tryShowTooltip
    ]);
    const onBlur = (0, _react.useCallback)(()=>{
        if (apiRef.current) apiRef.current.requestHide({
            isImmediate: false
        });
    }, []);
    const onAnimationFinished = (0, _react.useCallback)((transition)=>{
        // Using lastState here because motion is not picking up the latest value
        if (transition === 'exiting' && stableState.current === 'fade-out' && apiRef.current) apiRef.current.finishHideAnimation();
    }, [
        stableState
    ]);
    // Doing a cast because typescript is struggling to narrow the type
    const CastTargetContainer = TargetContainer;
    const shouldRenderTooltipPopup = state !== 'hide' && Boolean(content);
    const shouldRenderHiddenContent = !isScreenReaderAnnouncementDisabled && shouldRenderTooltipPopup;
    const shouldRenderTooltipChildren = state !== 'hide' && state !== 'fade-out' && state !== 'top-layer-exit';
    const handleOpenLayerObserverCloseSignal = (0, _react.useCallback)(()=>{
        var _apiRef_current;
        (_apiRef_current = apiRef.current) === null || _apiRef_current === void 0 ? void 0 : _apiRef_current.requestHide({
            isImmediate: true
        });
    }, []);
    // On the top-layer path, the Popover primitive (used by TopLayerTooltipPopup)
    // registers with the observer directly, so we skip registration here to
    // avoid double-counting.
    // Safe conditional hook: feature flags are resolved once at startup.
    if (!(0, _platformFeatureFlags.fg)('platform-dst-top-layer-tooltip')) // eslint-disable-next-line react-hooks/rules-of-hooks
    (0, _openLayerObserver.useNotifyOpenLayerObserver)({
        // Layer is only visually open if both the tooltip popup (container) and children are rendered.
        isOpen: shouldRenderTooltipPopup && shouldRenderTooltipChildren,
        /**
       * We don't strictly need to provide an onClose callback at this time, as there is
       * already code that handles hiding the tooltip when a drag is started (and the only
       * usage right now is closing all layers when the user resizes the side nav).
       *
       * However, for future-proofing and semantic reasons, it makes sense to close the tooltip
       * whenever the open layer observer requests a close.
       */ onClose: handleOpenLayerObserverCloseSignal
    });
    const getReferenceElement = ()=>{
        var _apiRef_current;
        if (isMousePosition && ((_apiRef_current = apiRef.current) === null || _apiRef_current === void 0 ? void 0 : _apiRef_current.mousePos) && targetRef.current) return (0, _getVirtualElementFromMousePos.getVirtualElementFromMousePos)(apiRef.current.mousePos, {
            targetElement: targetRef.current,
            tooltipPosition: position
        });
        return targetRef.current || undefined;
    };
    const tooltipIdForHiddenContent = (0, _useUniqueIdDefault.default)('tooltip', shouldRenderHiddenContent);
    const tooltipTriggerProps = {
        onMouseOver,
        onMouseOut,
        onMouseMove,
        onMouseDown,
        onClick,
        onFocus,
        onBlur
    };
    // This useEffect is purely for managing the aria attribute when using the
    // wrapped children approach.
    const isChildrenAFunction = typeof children === 'function';
    (0, _react.useEffect)(()=>{
        if (isChildrenAFunction) return;
        // If `children` is _not_ a function, we are stepping outside of the public
        // API to add a `aria-describedby` attribute.
        const target = targetRef.current;
        if (!target || !tooltipIdForHiddenContent) return;
        target.setAttribute('aria-describedby', tooltipIdForHiddenContent);
        return ()=>target.removeAttribute('aria-describedby');
    }, [
        isChildrenAFunction,
        tooltipIdForHiddenContent
    ]);
    const hiddenContent = shouldRenderHiddenContent ? /*#__PURE__*/ (0, _reactDefault.default).createElement("span", {
        "data-testid": testId ? `${testId}-hidden` : undefined,
        hidden: true,
        id: tooltipIdForHiddenContent
    }, typeof content === 'function' ? content({}) : content) : null;
    const PopperWrapper = shouldRenderToParent ? (0, _react.Fragment) : TooltipPortal;
    const trigger = typeof children === 'function' ? // once we deprecate the wrapped approach, we can put the aria
    // attribute back into the tooltipTriggerProps and make it required
    // instead of optional in `types`
    /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _react.Fragment), null, children((0, _objectSpreadProps._)((0, _objectSpread._)({}, tooltipTriggerProps, testId ? {
        testId: `${testId}--container`
    } : {}), {
        'aria-describedby': tooltipIdForHiddenContent,
        ref: setDirectRef
    })), hiddenContent) : // @ts-ignore
    /*#__PURE__*/ (0, _reactDefault.default).createElement(CastTargetContainer, (0, _objectSpreadProps._)((0, _objectSpread._)({}, tooltipTriggerProps, testId ? {
        'data-testid': `${testId}--container`
    } : undefined), {
        ref: setImplicitRefFromChildren,
        /**
   * TODO: Why is role="presentation" added?
   * - Is it only to "remove" the `Container` from screen readers?
   * - Why is it added only to the `Container` but not to `tooltipTriggerProps`?
   * - Should `role="presentation"` only be used if `shouldRenderHiddenContent == false`?
   */ role: "presentation"
    }), children, hiddenContent);
    var _apiRef_current_mousePos;
    if ((0, _platformFeatureFlags.fg)('platform-dst-top-layer-tooltip')) return /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _react.Fragment), null, trigger, shouldRenderTooltipPopup ? /*#__PURE__*/ (0, _reactDefault.default).createElement(TopLayerTooltipPopup, {
        targetRef: targetRef,
        tooltipPosition: tooltipPosition,
        mousePos: (_apiRef_current_mousePos = (_apiRef_current = apiRef.current) === null || _apiRef_current === void 0 ? void 0 : _apiRef_current.mousePos) !== null && _apiRef_current_mousePos !== void 0 ? _apiRef_current_mousePos : undefined,
        position: position,
        onMouseOut: onMouseOut,
        onMouseOverTooltip: onMouseOverTooltip,
        ignoreTooltipPointerEvents: ignoreTooltipPointerEvents,
        truncate: truncate,
        testId: testId,
        shortcut: shortcut,
        content: content,
        Container: Container,
        onClose: ()=>{
            var _apiRef_current;
            return (_apiRef_current = apiRef.current) === null || _apiRef_current === void 0 ? void 0 : _apiRef_current.requestHide({
                isImmediate: true
            });
        },
        onExitFinish: handleExitFinish,
        isOpen: state !== 'hide' && state !== 'top-layer-exit'
    }) : null);
    return /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _react.Fragment), null, trigger, shouldRenderTooltipPopup ? /*#__PURE__*/ (0, _reactDefault.default).createElement(PopperWrapper, null, /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _popper.Popper), {
        placement: tooltipPosition,
        referenceElement: getReferenceElement(),
        strategy: strategy
    }, ({ ref, style, update, placement })=>{
        const direction = isMousePosition ? undefined : invertedDirection[getDirectionFromPlacement(placement)];
        return /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _motion.ExitingPersistence), {
            appear: true
        }, shouldRenderTooltipChildren && /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _motion.FadeIn), {
            distance: "constant",
            entranceDirection: direction,
            exitDirection: direction,
            onFinish: onAnimationFinished,
            duration: state !== 'show-immediate' ? 'medium' : 'none'
        }, ({ className })=>/*#__PURE__*/ (0, _reactDefault.default).createElement(Container, {
                ref: ref,
                /**
               * "Tooltip" classname is a hook used by tests to manipulate
               * and hide tooltips, including in VR snapshots
               */ // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
                className: `Tooltip ${className}`,
                style: (0, _objectSpread._)({}, style, ignoreTooltipPointerEvents && {
                    pointerEvents: 'none'
                }),
                truncate: truncate,
                placement: tooltipPosition,
                testId: getReferenceElement() ? testId : testId && `${testId}--unresolved`,
                onMouseOut: onMouseOut,
                onMouseOver: onMouseOverTooltip,
                shortcut: shortcut
            }, typeof content === 'function' ? content({
                update
            }) : content)));
    })) : null);
}
exports.default = Tooltip;
const TooltipPortal = ({ children })=>{
    return /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _portalDefault.default), {
        zIndex: tooltipZIndex
    }, children);
};
const tooltipMouseAnimationStyles = {
    root: "_j7hq1a5s _71re1bym"
};
/**
 * Top-layer tooltip popup component.
 *
 * Composes `Popover` (top-layer visibility + animation) with one of two
 * positioning hooks:
 *
 *   - `useAnchorPositionAtPoint` — for cursor-tracking positions
 *     (`mouse`, `mouse-x`, `mouse-y`) when a cursor position is
 *     available (i.e. the popup was activated by a pointer). Positions
 *     the popover relative to a hidden synthetic anchor that follows
 *     the cursor according to the `position` / `mousePosition`
 *     semantics. The synthetic anchor element is rendered as a sibling
 *     of the popover.
 *   - `useAnchorPosition` directly — for non-cursor positions, AND
 *     for cursor positions activated via keyboard focus (where there
 *     is no cursor to track). Anchoring directly to the trigger keeps
 *     keyboard-activated tooltips correctly placed next to the target
 *     instead of rendering in the top-left of the viewport.
 *
 * Exactly one positioning strategy is active at a time: `useAnchorPosition`
 * is wired to the trigger only when the mouse strategy is inactive, and
 * `useAnchorPositionAtPoint` is told `isActive: false` when the direct
 * anchor strategy is active. The other hook is still called (Rules of
 * Hooks) but does no work.
 *
 * Exit animation is handled by `Popover`'s `isOpen` prop. When `isOpen`
 * transitions to `false`, the primitive calls `hidePopover()` internally and
 * the CSS exit animation plays via `allow-discrete`. No glue code needed.
 */ function TopLayerTooltipPopup({ targetRef, tooltipPosition, mousePos, position, onMouseOut, onMouseOverTooltip, ignoreTooltipPointerEvents, truncate, testId, shortcut, content, Container, onClose, onExitFinish, isOpen }) {
    const popoverRef = (0, _react.useRef)(null);
    // Translate the legacy Popper-style placement string ("right",
    // "bottom-start", etc.) once and pass the same object to both hooks.
    const placement = (0, _placementMap.fromLegacyPlacement)({
        legacy: tooltipPosition
    });
    const isMousePosition = position === 'mouse' || position === 'mouse-x' || position === 'mouse-y';
    const isMouseStrategyActive = isMousePosition && Boolean(mousePos);
    // Direct anchor strategy: anchors to the trigger element.
    // Disabled when the mouse strategy is active — both hooks writing
    // to the same popover would fight for positioning ownership.
    (0, _useAnchorPosition.useAnchorPosition)({
        anchorRef: targetRef,
        popoverRef,
        placement,
        isEnabled: !isMouseStrategyActive,
        isOpen
    });
    // Mouse anchor strategy: the hook calls `getPoint()` exactly once
    // per activation and latches the resulting coordinate. The latch is
    // per-show because `TopLayerTooltipPopup` mounts fresh on every
    // show.
    //
    // `getPoint()` returns `null` for keyboard-activated shows (where
    // `mousePos` is undefined) or before the trigger has mounted —
    // leaving the direct strategy above to own positioning.
    //
    // SSR note: `getBoundingClientRect()` is only called here because
    // `TopLayerTooltipPopup` is gated behind client-only state
    // transitions.
    (0, _useAnchorPositionAtPoint.useAnchorPositionAtPoint)({
        popoverRef,
        placement,
        isEnabled: isMouseStrategyActive,
        isOpen,
        getPoint: ()=>{
            if (!mousePos || !targetRef.current || !isMousePosition) return null;
            return (0, _getAnchorPoint.getAnchorPoint)({
                cursor: mousePos,
                triggerRect: targetRef.current.getBoundingClientRect(),
                tooltipPosition: position,
                placement
            });
        }
    });
    return /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _popover.Popover), {
        ref: popoverRef,
        role: "tooltip",
        mode: "hint",
        isOpen: isOpen,
        onClose: onClose,
        onExitFinish: onExitFinish,
        testId: testId ? `${testId}--popover` : undefined,
        animate: true,
        xcss: isMouseStrategyActive && tooltipMouseAnimationStyles.root,
        placement: placement
    }, /*#__PURE__*/ (0, _reactDefault.default).createElement(Container, {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- top-layer spike
        className: "Tooltip",
        // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- top-layer spike
        style: ignoreTooltipPointerEvents ? {
            pointerEvents: 'none'
        } : undefined,
        truncate: truncate,
        placement: tooltipPosition,
        testId: testId,
        onMouseOut: onMouseOut,
        onMouseOver: onMouseOverTooltip,
        shortcut: shortcut,
        role: "presentation"
    }, typeof content === 'function' ? content({
        update: (0, _noopDefault.default)
    }) : content));
}

},{"@swc/helpers/_/_object_spread":"9gdrV","@swc/helpers/_/_object_spread_props":"kANqQ","react":"ltHCL","bind-event-listener":"bjeUU","@atlaskit/analytics-next":"6PLie","@atlaskit/ds-lib/noop":"faKzG","@atlaskit/ds-lib/use-close-on-escape-press":"d65nx","@atlaskit/ds-lib/use-stable-ref":"gfVAA","@atlaskit/layering/experimental/open-layer-observer":"2Dqp9","@atlaskit/motion":"eg70v","@atlaskit/platform-feature-flags":"8rD2i","@atlaskit/popper":"4PB1z","@atlaskit/portal":"jvgcC","@atlaskit/theme/constants":"gxXsN","@atlaskit/top-layer/placement-map":"fBy31","@atlaskit/top-layer/popover":"hLw5z","@atlaskit/top-layer/use-anchor-position":"6ghLj","@atlaskit/top-layer/use-anchor-position-at-point":"1BeoO","./internal/drag-manager":"bL5lY","./internal/get-anchor-point":"g3PYT","./internal/get-virtual-element-from-mouse-pos":"g1OSU","./internal/tooltip-manager":"Yg7Cj","./internal/use-unique-id":"1YoKj","./tooltip-container":"jyGbU","@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"d65nx":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>useCloseOnEscapePress);
var _react = require("react");
var _bindEventListener = require("bind-event-listener");
var _keycodes = require("../utils/keycodes");
function useCloseOnEscapePress({ onClose, isDisabled }) {
    const escapePressed = (0, _react.useRef)(false);
    const onKeyDown = (0, _react.useCallback)((e)=>{
        if (isDisabled || escapePressed.current || e.key !== (0, _keycodes.ESCAPE)) // We're either already handling the key down event or it's not escape.
        // Bail early!
        return;
        escapePressed.current = true;
        onClose(e);
    }, [
        onClose,
        isDisabled
    ]);
    const onKeyUp = (0, _react.useCallback)(()=>{
        escapePressed.current = false;
    }, []);
    (0, _react.useEffect)(()=>{
        // Don't attach document event listeners if the hook is disabled
        if (isDisabled) return;
        return (0, _bindEventListener.bindAll)(document, [
            {
                type: 'keydown',
                listener: onKeyDown
            },
            {
                type: 'keyup',
                listener: onKeyUp
            }
        ], {
            capture: false
        });
    }, [
        onKeyDown,
        onKeyUp,
        isDisabled
    ]);
}

},{"react":"ltHCL","bind-event-listener":"bjeUU","../utils/keycodes":"5zA5X","@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"5zA5X":[function(require,module,exports,__globalThis) {
/**
 * Character key codes which can be used in keyboard events.
 */ var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "KEY_UP", ()=>KEY_UP);
parcelHelpers.export(exports, "KEY_DOWN", ()=>KEY_DOWN);
parcelHelpers.export(exports, "KEY_LEFT", ()=>KEY_LEFT);
parcelHelpers.export(exports, "KEY_RIGHT", ()=>KEY_RIGHT);
parcelHelpers.export(exports, "KEY_HOME", ()=>KEY_HOME);
parcelHelpers.export(exports, "KEY_END", ()=>KEY_END);
parcelHelpers.export(exports, "KEY_TAB", ()=>KEY_TAB);
parcelHelpers.export(exports, "KEY_ENTER", ()=>KEY_ENTER);
parcelHelpers.export(exports, "KEY_SPACE", ()=>KEY_SPACE);
parcelHelpers.export(exports, "ESCAPE", ()=>ESCAPE);
const KEY_UP = 'ArrowUp';
const KEY_DOWN = 'ArrowDown';
const KEY_LEFT = 'ArrowLeft';
const KEY_RIGHT = 'ArrowRight';
const KEY_HOME = 'Home';
const KEY_END = 'End';
const KEY_TAB = 'Tab';
const KEY_ENTER = 'Enter';
const KEY_SPACE = 'Space';
const ESCAPE = 'Escape';

},{"@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"gfVAA":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>useStableRef);
var _react = require("react");
function useStableRef(value) {
    const ref = (0, _react.useRef)(value);
    (0, _react.useEffect)(()=>{
        ref.current = value;
    }, [
        value
    ]);
    return ref;
}

},{"react":"ltHCL","@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"2Dqp9":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "OpenLayerObserver", ()=>(0, _openLayerObserver.OpenLayerObserver));
parcelHelpers.export(exports, "useNotifyOpenLayerObserver", ()=>(0, _useNotifyOpenLayerObserver.useNotifyOpenLayerObserver));
parcelHelpers.export(exports, "useOpenLayerObserver", ()=>(0, _useOpenLayerObserver.useOpenLayerObserver));
parcelHelpers.export(exports, "OpenLayerObserverNamespaceProvider", ()=>(0, _openLayerObserverNamespaceProvider.OpenLayerObserverNamespaceProvider));
var _openLayerObserver = require("../../components/open-layer-observer/open-layer-observer");
var _useNotifyOpenLayerObserver = require("../../components/open-layer-observer/use-notify-open-layer-observer");
var _useOpenLayerObserver = require("../../components/open-layer-observer/use-open-layer-observer");
var _openLayerObserverNamespaceProvider = require("../../components/open-layer-observer/open-layer-observer-namespace-provider");

},{"../../components/open-layer-observer/open-layer-observer":"jpZur","../../components/open-layer-observer/use-notify-open-layer-observer":"htnpn","../../components/open-layer-observer/use-open-layer-observer":"akMWA","../../components/open-layer-observer/open-layer-observer-namespace-provider":"3ZEhF","@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"jpZur":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
/**
 * Context provider for observing the number of __open__ layering components (e.g. popups, dropdown menus) under the observer.
 * It uses a stable object to keep track of the number of open layered components - which means the observer will not re-render
 * when the number of layers changes.
 *
 * There should only be one `OpenLayerObserver` in the application. If there are more, the component will throw an error.
 * To track the number of layers in a section of the application, use the `OpenLayerObserverNamespaceProvider` to create a new
 * namespace to group layers.
 *
 * It is intended for use with the `useOpenLayerObserver` hook.
 */ parcelHelpers.export(exports, "OpenLayerObserver", ()=>OpenLayerObserver);
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _tinyInvariant = require("tiny-invariant");
var _tinyInvariantDefault = parcelHelpers.interopDefault(_tinyInvariant);
var _openLayerObserverContext = require("./open-layer-observer-context");
/**
 * Layers that are registered without a namespace are grouped under this fallback namespace.
 */ const noNamespaceSymbol = Symbol('no-namespace');
/**
 * Returns the number of open layers across all namespaces.
 * It calculates the sum of the set sizes in the map, which corresponds to the number of open layers.
 */ function getTotalOpenLayerCount(registry) {
    return Array.from(registry.values()).reduce((acc, listeners)=>acc + listeners.size, 0);
}
/**
 * Returns the number of layers in the set that match the type filter.
 */ function getLayerCountWithFilter({ layers, type }) {
    return Array.from(layers.values()).filter((layer)=>layer.type === type).length;
}
/**
 * Returns the layer count change listeners set for the namespace.
 * If there are no listeners registered for the namespace yet, it creates a new set
 * and adds it to the registry, then returns the new set.
 */ function getListeners({ registry, namespace }) {
    // 1. If there are existing listeners for this namespace, return the existing set.
    const existingListeners = registry.get(namespace);
    if (existingListeners) return existingListeners;
    // 2. If there are no existing listeners for this namespace, create a new set for this namespace
    // and add it to the registry, then return the new set.
    const newSet = new Set();
    registry.set(namespace, newSet);
    return newSet;
}
/**
 * Returns an instance of the open layer observer API. It internally keeps track of the number of open layers and
 * exposes methods to get the current count, increment/decrement the count, and subscribe to changes.
 */ function createInternalAPI() {
    /**
	 * The layer count change listeners for each namespace.
	 */ const namespaceToChangeListenerRegistry = new Map();
    /**
	 * The registered layers for each namespace.
	 * Each layer registers with an `onClose` callback, and optionally with a layer type (`type`).
	 * **When the layer is open**, its `onClose`
	 * callback is registered in this set along with its type.
	 *
	 * This data structure is also used determine the number of open layers.
	 */ const namespaceToLayerRegistry = new Map();
    /**
	 * Calls the appropriate layer count change listeners after the number of open layers has changed.
	 */ function callChangeListeners({ namespace, newCount }) {
        // 1. Call listeners registered to the specific namespace
        if (namespace) {
            const listenersForNamespace = namespaceToChangeListenerRegistry.get(namespace);
            // Using `Array.from` to ensure we iterate over a stable list - e.g. in case a listener adds to the registry while we are
            // iterating over it.
            Array.from(listenersForNamespace !== null && listenersForNamespace !== void 0 ? listenersForNamespace : []).forEach((listener)=>listener({
                    count: newCount
                }));
        }
        // 2. Call listeners registered without a specific namespace
        const noNamespaceListeners = namespaceToChangeListenerRegistry.get(noNamespaceSymbol);
        // Return early if no listeners
        if (!noNamespaceListeners) return;
        // For the listeners without a specific namespace, we need to provide the sum of all namespace counts
        // as the callback `count` arg.
        const totalCount = getTotalOpenLayerCount(namespaceToLayerRegistry);
        Array.from(noNamespaceListeners).forEach((listener)=>listener({
                count: totalCount
            }));
    }
    /**
	 * Returns the current count of open layers.
	 *
	 * - If a namespace is provided, the count for that namespace is returned.
	 * - If a type is provided, only layers of that type are counted.
	 * - If both are provided, only layers matching both criteria are counted.
	 * - Otherwise, the sum of all namespace counts is returned.
	 */ function getCount({ namespace, type } = {}) {
        if (namespace) {
            // 1. A namespace was requested, so we count only layers in that namespace
            const layersForNamespace = namespaceToLayerRegistry.get(namespace);
            if (!layersForNamespace) return 0;
            if (type) // Count layers in the namespace that match the type filter
            return getLayerCountWithFilter({
                layers: layersForNamespace,
                type
            });
            // No type filter - just return the size of the set
            return layersForNamespace.size;
        }
        // 2. A specific namespace was not requested, so we count across all namespaces
        if (type) // Count layers in each namespace that match the type filter
        return Array.from(namespaceToLayerRegistry.values()).reduce((acc, layers)=>acc + getLayerCountWithFilter({
                layers,
                type
            }), 0);
        // No type filter - count all layers across all namespaces
        return getTotalOpenLayerCount(namespaceToLayerRegistry);
    }
    /**
	 * Adds a listener that will be called when the number of open layers changes.
	 *
	 * @returns a cleanup function to unsubscribe, which should be called when the component unmounts.
	 */ function onChange(listener, { namespace: providedNamespace } = {}) {
        /**
		 * We are wrapping the passed listener in a function to ensure that each call to `onChange` creates a unique
		 * function reference. This is to handle scenarios where the same function is provided to several different `onChange`
		 * calls - we want to ensure that each call to `unsubscribe` only removes the specific listener registration that was added.
		 */ function wrapped(...args) {
            listener(...args);
        }
        const namespace = providedNamespace !== null && providedNamespace !== void 0 ? providedNamespace : noNamespaceSymbol;
        const listenersForNamespace = getListeners({
            namespace,
            registry: namespaceToChangeListenerRegistry
        });
        listenersForNamespace.add(wrapped);
        return function unsubscribe() {
            listenersForNamespace.delete(wrapped);
            // If there are no listeners for this namespace, remove the registry entry.
            if (listenersForNamespace.size === 0) namespaceToChangeListenerRegistry.delete(namespace);
        };
    }
    /**
	 * Adds a listener to the registry that tells the observer how to close the layer component.
	 * The listener should only be added if the layer is open. This is handled by `useNotifyOpenLayerObserver`.
	 *
	 * All close listeners will be called by the observer when `closeLayers` is called.
	 *
	 * @returns a cleanup function to unsubscribe, which should be called when the component unmounts.
	 */ function onClose(listener, { namespace: providedNamespace, type }) {
        const wrapped = {
            listener,
            type
        };
        const namespace = providedNamespace !== null && providedNamespace !== void 0 ? providedNamespace : noNamespaceSymbol;
        const listenersForNamespace = getListeners({
            namespace,
            registry: namespaceToLayerRegistry
        });
        listenersForNamespace.add(wrapped);
        callChangeListeners({
            namespace: providedNamespace,
            newCount: listenersForNamespace.size
        });
        return function unsubscribe() {
            listenersForNamespace.delete(wrapped);
            callChangeListeners({
                namespace: providedNamespace,
                newCount: listenersForNamespace.size
            });
            // If there are no listeners for this namespace, remove the registry entry.
            if (listenersForNamespace.size === 0) namespaceToLayerRegistry.delete(namespace);
        };
    }
    /**
	 * Closes all open layers registered across all namespaces.
	 */ function closeLayers() {
        // Using `Array.from` to ensure we iterate over a stable list - e.g. in case a listener adds to the registry while we are
        // iterating over it.
        Array.from(namespaceToLayerRegistry.values()).forEach((listeners)=>{
            Array.from(listeners).forEach(({ listener })=>listener());
        });
    }
    const internalAPI = {
        getCount,
        onChange,
        onClose,
        closeLayers
    };
    return internalAPI;
}
function OpenLayerObserver({ children }) {
    // Using state to ensure a stable reference to a single instance.
    const [internalAPI] = (0, _react.useState)(()=>createInternalAPI());
    const parentContext = (0, _react.useContext)((0, _openLayerObserverContext.OpenLayerObserverContext));
    // We don't expect a parent context. If there is one, that means this component is nested within another `OpenLayerObserver`
    // - which we don't support.
    (0, _tinyInvariantDefault.default)(parentContext === null, '`OpenLayerObserver` cannot be nested within another `OpenLayerObserver`.');
    return /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _openLayerObserverContext.OpenLayerObserverContext).Provider, {
        value: internalAPI
    }, children);
}

},{"react":"ltHCL","tiny-invariant":"9VWeJ","./open-layer-observer-context":"5uCPW","@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"5uCPW":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "OpenLayerObserverContext", ()=>OpenLayerObserverContext);
var _react = require("react");
const OpenLayerObserverContext = /*#__PURE__*/ (0, _react.createContext)(null);

},{"react":"ltHCL","@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"htnpn":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
/**
 * Hook that increments/decrements the open layer count when the component mounts/unmounts or becomes visible/hidden.
 * It is used to "notify" the layer observer(s) that a new layer has been added/opened.
 *
 * It takes an object with two arguments:
 * - `isOpen` - used to conditionally update the layer count based on the visibility of the layered component.
 * - `onClose` - callback used to close this layer when the OpenLayerObserver has called `closeLayers`.
 *
 * Example usage:
 * ```tsx
 * const [isOpen, setIsOpen] = useState(false); // State for controlling layer visibility
 * useNotifyLayerObserver({
 *   isOpen,
 *   onClose: () => setIsOpen(false) // Optional callback to close this layer
 * });
 * ```
 */ parcelHelpers.export(exports, "useNotifyOpenLayerObserver", ()=>useNotifyOpenLayerObserver);
var _react = require("react");
var _openLayerObserverContext = require("./open-layer-observer-context");
var _useOpenLayerObserverNamespace = require("./use-open-layer-observer-namespace");
function useNotifyOpenLayerObserver({ isOpen, type, onClose }) {
    const context = (0, _react.useContext)((0, _openLayerObserverContext.OpenLayerObserverContext));
    const namespace = (0, _useOpenLayerObserverNamespace.useOpenLayerObserverNamespace)();
    (0, _react.useEffect)(()=>{
        /**
		 * Registers the `onClose` callback with the OpenLayerObserver.
		 */ if (context === null) return;
        if (!isOpen) /**
			 * If the layer is not open, we are not registering the `onClose` callback.
			 * This is important to prevent the `onClose` from being called for layers that
			 * are not open.
			 *
			 * Some consumers mistakenly pass "toggle" functions to `onClose` callbacks for
			 * layer components, as Popup, e.g. `onClose={() => setIsOpen(!isOpen)}`.
			 */ return;
        return context.onClose(onClose, {
            namespace,
            type
        });
    }, [
        context,
        isOpen,
        namespace,
        onClose,
        type
    ]);
}

},{"react":"ltHCL","./open-layer-observer-context":"5uCPW","./use-open-layer-observer-namespace":"GYK28","@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"GYK28":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
/**
 * A hook for use within an `OpenLayerObserver` component. It provides access to the namespace of the
 * `OpenLayerObserver`.
 *
 * This is useful for determining the number of layers open within a section of the page, e.g. the SideNav.
 */ parcelHelpers.export(exports, "useOpenLayerObserverNamespace", ()=>useOpenLayerObserverNamespace);
var _react = require("react");
var _openLayerObserverNamespaceContext = require("./open-layer-observer-namespace-context");
function useOpenLayerObserverNamespace() {
    const namespace = (0, _react.useContext)((0, _openLayerObserverNamespaceContext.OpenLayerObserverNamespaceContext));
    return namespace;
}

},{"react":"ltHCL","./open-layer-observer-namespace-context":"1jpVg","@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"1jpVg":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "OpenLayerObserverNamespaceContext", ()=>OpenLayerObserverNamespaceContext);
var _react = require("react");
const OpenLayerObserverNamespaceContext = /*#__PURE__*/ (0, _react.createContext)(null);

},{"react":"ltHCL","@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"akMWA":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
/**
 * A hook for use within an `OpenLayerObserver` component.  It will return `null` if there is no
 * `OpenLayerObserver` in the component tree.
 *
 * It provides access to:
 *
 * - `getCount`: a function that returns the current count of open layers under the observer.
 * - `onChange`: a function that allows you to subscribe to changes in the layer count. It returns a
 * cleanup function to unsubscribe, which you should call when the component unmounts.
 * - `closeLayers`: a function that closes all open layers.
 *
 * Example usage:
 * ```tsx
 * const openLayerObserver = useOpenLayerObserver();
 * useEffect(() => {
 *   return openLayerObserver?.onChange(function onChange({ count }) {
 *     // react to changes in the layer count
 *   });
 * }, [openLayerObserver]);
 * ```
 */ parcelHelpers.export(exports, "useOpenLayerObserver", ()=>useOpenLayerObserver);
var _react = require("react");
var _openLayerObserverContext = require("./open-layer-observer-context");
function useOpenLayerObserver() {
    const context = (0, _react.useContext)((0, _openLayerObserverContext.OpenLayerObserverContext));
    const publicAPI = (0, _react.useMemo)(()=>{
        if (context === null) return null;
        return {
            getCount: context.getCount,
            onChange: context.onChange,
            closeLayers: context.closeLayers
        };
    }, [
        context
    ]);
    return publicAPI;
}

},{"react":"ltHCL","./open-layer-observer-context":"5uCPW","@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"3ZEhF":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
/**
 * Creates a layer namespace for grouping layers together.
 */ parcelHelpers.export(exports, "OpenLayerObserverNamespaceProvider", ()=>OpenLayerObserverNamespaceProvider);
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _tinyInvariant = require("tiny-invariant");
var _tinyInvariantDefault = parcelHelpers.interopDefault(_tinyInvariant);
var _openLayerObserverNamespaceContext = require("./open-layer-observer-namespace-context");
var _useOpenLayerObserverNamespace = require("./use-open-layer-observer-namespace");
function OpenLayerObserverNamespaceProvider({ children, namespace }) {
    // If there is an existing namespace context being provided, throw an invariant.
    // This use case is not supported at this time.
    const parentContext = (0, _useOpenLayerObserverNamespace.useOpenLayerObserverNamespace)();
    (0, _react.useEffect)(()=>{
        (0, _tinyInvariantDefault.default)(parentContext === null, `An OpenLayerObserver namespace already exists in this component tree: ${parentContext}. Nesting OpenLayerObserverNamespaceProvider is not supported.`);
    }, [
        parentContext
    ]);
    return /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _openLayerObserverNamespaceContext.OpenLayerObserverNamespaceContext).Provider, {
        value: namespace
    }, children);
}

},{"react":"ltHCL","tiny-invariant":"9VWeJ","./open-layer-observer-namespace-context":"1jpVg","./use-open-layer-observer-namespace":"GYK28","@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"eg70v":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "durations", ()=>(0, _durations.durations));
parcelHelpers.export(exports, "durationStep", ()=>(0, _durations.durationStep));
parcelHelpers.export(exports, "exitingDurations", ()=>(0, _exitingDurations.exitingDurations));
parcelHelpers.export(exports, "easeIn", ()=>(0, _curves.easeIn));
parcelHelpers.export(exports, "easeInOut", ()=>(0, _curves.easeInOut));
parcelHelpers.export(exports, "easeOut", ()=>(0, _curves.easeOut));
parcelHelpers.export(exports, "linear", ()=>(0, _curves.linear));
parcelHelpers.export(exports, "isReducedMotion", ()=>(0, _isReducedMotion.isReducedMotion));
parcelHelpers.export(exports, "useIsReducedMotion", ()=>(0, _useIsReducedMotion.useIsReducedMotion));
parcelHelpers.export(exports, "prefersReducedMotion", ()=>(0, _accessibility.prefersReducedMotion));
parcelHelpers.export(exports, "reduceMotionAsPerUserPreference", ()=>(0, _reduceMotionAsPerUserPreference.reduceMotionAsPerUserPreference));
parcelHelpers.export(exports, "FadeIn", ()=>(0, _fadeInDefault.default));
parcelHelpers.export(exports, "AnimateIn", ()=>(0, _animateInDefault.default));
parcelHelpers.export(exports, "StaggeredEntrance", ()=>(0, _staggeredEntranceDefault.default));
parcelHelpers.export(exports, "ResizingHeight", ()=>(0, _height.ResizingHeight));
parcelHelpers.export(exports, "useResizingHeight", ()=>(0, _useResizingHeight.useResizingHeight));
parcelHelpers.export(exports, "ExitingPersistence", ()=>(0, _exitingPersistenceDefault.default));
parcelHelpers.export(exports, "useExitingPersistence", ()=>(0, _exitingPersistence.useExitingPersistence));
parcelHelpers.export(exports, "ZoomIn", ()=>(0, _zoomInDefault.default));
parcelHelpers.export(exports, "SlideIn", ()=>(0, _slideInDefault.default));
parcelHelpers.export(exports, "ShrinkOut", ()=>(0, _shrinkOutDefault.default));
parcelHelpers.export(exports, "Motion", ()=>(0, _motionDefault.default));
parcelHelpers.export(exports, "Reanimate", ()=>(0, _reanimate.Reanimate));
var _durations = require("./utils/durations");
var _exitingDurations = require("./utils/exiting-durations");
var _curves = require("./utils/curves");
var _isReducedMotion = require("./utils/is-reduced-motion");
var _useIsReducedMotion = require("./utils/use-is-reduced-motion");
var _accessibility = require("./utils/accessibility");
var _reduceMotionAsPerUserPreference = require("./utils/reduce-motion-as-per-user-preference");
var _fadeIn = require("./entering/fade-in");
var _fadeInDefault = parcelHelpers.interopDefault(_fadeIn);
var _animateIn = require("./entering/animate-in");
var _animateInDefault = parcelHelpers.interopDefault(_animateIn);
var _staggeredEntrance = require("./entering/staggered-entrance");
var _staggeredEntranceDefault = parcelHelpers.interopDefault(_staggeredEntrance);
var _height = require("./resizing/height");
var _useResizingHeight = require("./resizing/use-resizing-height");
var _exitingPersistence = require("./entering/exiting-persistence");
var _exitingPersistenceDefault = parcelHelpers.interopDefault(_exitingPersistence);
var _zoomIn = require("./entering/zoom-in");
var _zoomInDefault = parcelHelpers.interopDefault(_zoomIn);
var _slideIn = require("./entering/slide-in");
var _slideInDefault = parcelHelpers.interopDefault(_slideIn);
var _shrinkOut = require("./entering/shrink-out");
var _shrinkOutDefault = parcelHelpers.interopDefault(_shrinkOut);
var _motion = require("./entering/motion");
var _motionDefault = parcelHelpers.interopDefault(_motion);
var _reanimate = require("./entering/reanimate");

},{"./utils/durations":false,"./utils/exiting-durations":false,"./utils/curves":false,"./utils/is-reduced-motion":false,"./utils/use-is-reduced-motion":"cqcXz","./utils/accessibility":false,"./utils/reduce-motion-as-per-user-preference":"1ixxb","./entering/fade-in":"bW9cF","./entering/animate-in":false,"./entering/staggered-entrance":"eiSc7","./resizing/height":false,"./resizing/use-resizing-height":"tXfEe","./entering/exiting-persistence":"9OFRq","./entering/zoom-in":"nzH1k","./entering/slide-in":"j0S25","./entering/shrink-out":"1ZLLp","./entering/motion":"3d35X","./entering/reanimate":false,"@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"3tpdK":[function(require,module,exports,__globalThis) {
/**
 * Think of this as the motion equivalent of the @atlaskit/theme `grid()`.
 */ var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "durationStep", ()=>durationStep);
parcelHelpers.export(exports, "durations", ()=>durations);
const durationStep = 25;
const durations = {
    none: 0,
    small: 100,
    medium: 350,
    large: 700
};

},{"@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"fGCJG":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "exitingDurations", ()=>exitingDurations);
var _durations = require("./durations");
/**
 * Used to multiply the initial duration for exiting motions.
 */ const EXITING_MOTION_MULTIPLIER = 0.5;
const exitingDurations = {
    none: (0, _durations.durations).none,
    small: (0, _durations.durations).small * EXITING_MOTION_MULTIPLIER,
    medium: (0, _durations.durations).medium * EXITING_MOTION_MULTIPLIER,
    large: (0, _durations.durations).large * EXITING_MOTION_MULTIPLIER
};

},{"./durations":"3tpdK","@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"7J7Ar":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "easeInOut", ()=>easeInOut);
parcelHelpers.export(exports, "easeOut", ()=>easeOut);
parcelHelpers.export(exports, "easeIn", ()=>easeIn);
parcelHelpers.export(exports, "easeIn40Out", ()=>easeIn40Out);
parcelHelpers.export(exports, "easeIn60Out", ()=>easeIn60Out);
parcelHelpers.export(exports, "easeIn80Out", ()=>easeIn80Out);
parcelHelpers.export(exports, "linear", ()=>linear);
const easeInOut = 'cubic-bezier(0.15,1,0.3,1)';
const easeOut = 'cubic-bezier(0.2,0,0,1)';
const easeIn = 'cubic-bezier(0.8,0,0,0.8)';
const easeIn40Out = 'cubic-bezier(0.4,0,0,1)';
const easeIn60Out = 'cubic-bezier(0.6,0,0,1)';
const easeIn80Out = 'cubic-bezier(0.8,0,0,1)';
const linear = 'cubic-bezier(0,0,1,1)';

},{"@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"XfCCa":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "isReducedMotion", ()=>isReducedMotion);
var _isMatchMediaAvailable = require("./is-match-media-available");
const isReducedMotion = ()=>{
    if (!(0, _isMatchMediaAvailable.isMatchMediaAvailable)()) return false;
    const { matches } = window.matchMedia('(prefers-reduced-motion: reduce)');
    return matches;
};

},{"./is-match-media-available":"7Sti2","@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"7Sti2":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "isMatchMediaAvailable", ()=>isMatchMediaAvailable);
const isMatchMediaAvailable = ()=>typeof window !== 'undefined' && 'matchMedia' in window;

},{"@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"cqcXz":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "useIsReducedMotion", ()=>useIsReducedMotion);
var _react = require("react");
var _bindEventListener = require("bind-event-listener");
var _isMatchMediaAvailable = require("./is-match-media-available");
var _isReducedMotion = require("./is-reduced-motion");
const useIsReducedMotion = ()=>{
    const [prefersReducedMotion, setPrefersReducedMotion] = (0, _react.useState)((0, _isReducedMotion.isReducedMotion));
    (0, _react.useEffect)(()=>{
        if (!(0, _isMatchMediaAvailable.isMatchMediaAvailable)()) return;
        const mediaQueryList = window.matchMedia('(prefers-reduced-motion: reduce)');
        const onChange = (event)=>setPrefersReducedMotion(event.matches);
        return (0, _bindEventListener.bind)(mediaQueryList, {
            type: 'change',
            listener: onChange
        });
    }, []);
    return prefersReducedMotion;
};

},{"react":"ltHCL","bind-event-listener":"bjeUU","./is-match-media-available":"7Sti2","./is-reduced-motion":"XfCCa","@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"1ixxb":[function(require,module,exports,__globalThis) {
/**
 * Use for any CSS based motion (animation or transition).
 * Always put at the end of your declaration for correct use of the cascade.
 * Reduced motion preference is generally set through OS preferences/settings.
 *
 * @deprecated This is not fully compatible with Compiled CSS and will be removed in the future.
 * You should hardcode the `prefers-reduced-motion` media query in your file instead.
 */ var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "reduceMotionAsPerUserPreference", ()=>reduceMotionAsPerUserPreference);
const reduceMotionAsPerUserPreference = {
    '@media (prefers-reduced-motion: reduce)': {
        animation: 'none',
        transition: 'none'
    }
};

},{"@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"bW9cF":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _keyframesMotion = require("./keyframes-motion");
var _keyframesMotionDefault = parcelHelpers.interopDefault(_keyframesMotion);
const invertedDirection = {
    top: 'bottom',
    bottom: 'top',
    left: 'right',
    right: 'left'
};
/**
 * __FadeIn__
 *
 * Useful for fading in one or more elements.
 *
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/motion/docs/entering-motion)
 */ const FadeIn = ({ children, duration = 'large', entranceDirection, exitDirection, distance = 'proportional', onFinish, isPaused })=>{
    const invertedEntranceDirection = entranceDirection !== undefined ? invertedDirection[entranceDirection] : undefined;
    const isExitDirect = Boolean(exitDirection || invertedEntranceDirection) ? `fade-out-from-${exitDirection || invertedEntranceDirection}${distance === 'proportional' ? '' : '-constant'}` : 'fade-out';
    return /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _keyframesMotionDefault.default), {
        duration: duration,
        enteringAnimation: entranceDirection ? `fade-in-from-${entranceDirection}${distance === 'proportional' ? '' : '-constant'}` : 'fade-in',
        exitingAnimation: isExitDirect,
        animationTimingFunction: "ease-in-out",
        onFinish: onFinish,
        isPaused: isPaused
    }, children);
};
exports.default = FadeIn;

},{"react":"ltHCL","./keyframes-motion":"2Tz9i","@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"2Tz9i":[function(require,module,exports,__globalThis) {
/* keyframes-motion.tsx generated by @compiled/babel-plugin v0.39.1 */ var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _runtime = require("@compiled/react/runtime");
var _durations = require("../utils/durations");
var _exitingDurations = require("../utils/exiting-durations");
var _isReducedMotion = require("../utils/is-reduced-motion");
var _useSetTimeout = require("../utils/use-set-timeout");
var _exitingPersistence = require("./exiting-persistence");
var _staggeredEntrance = require("./staggered-entrance");
const zoomIn = null;
const zoomOut = null;
const fadeIn = null;
const fadeOut = null;
const fadeInFromTop = null;
const fadeOutFromTop = null;
const fadeInFromLeft = null;
const fadeOutFromLeft = null;
const fadeInFromBottom = null;
const fadeOutFromBottom = null;
const fadeInFromRight = null;
const fadeOutFromRight = null;
const fadeInFromTopConstant = null;
const fadeOutFromTopConstant = null;
const fadeInFromLeftConstant = null;
const fadeOutFromLeftConstant = null;
const fadeInFromBottomConstant = null;
const fadeOutFromBottomConstant = null;
const fadeInFromRightConstant = null;
const fadeOutFromRightConstant = null;
const slideInFromTop = null;
const slideOutFromTop = null;
const slideInFromRight = null;
const slideOutFromRight = null;
const slideInFromBottom = null;
const slideOutFromBottom = null;
const slideInFromLeft = null;
const slideOutFromLeft = null;
/**
 * This is the base INTERNAL component used for all other entering motions.
 * This does not need Javascript to execute on the client so it will run immediately
 * for any SSR rendered React apps before the JS has executed.
 */ const EnteringMotion = ({ children, animationTimingFunction, animationTimingFunctionExiting = animationTimingFunction, enteringAnimation, exitingAnimation = enteringAnimation, isPaused, onFinish: onFinishMotion, duration = 'large' })=>{
    const staggered = (0, _staggeredEntrance.useStaggeredEntrance)();
    const { isExiting, onFinish: onExitFinished, appear } = (0, _exitingPersistence.useExitingPersistence)();
    const setTimeout = (0, _useSetTimeout.useSetTimeout)();
    const paused = isPaused || !staggered.isReady;
    const delay = isExiting ? 0 : staggered.delay;
    const state = isExiting ? 'exiting' : 'entering';
    const [hasAnimationStyles, setHasAnimationStyles] = (0, _react.useState)(appear);
    (0, _react.useEffect)(()=>{
        // Tracking this to prevent changing state on an unmounted component
        let isCancelled = false;
        if (paused) return;
        // On initial mount if elements aren't set to animate on appear, we return early and callback
        if (!appear) {
            onFinishMotion && onFinishMotion(state);
            return;
        }
        /**
     * Updates relevant state.
     * Called when the animation is finished, or immediately with reduced motion.
     */ const onAnimationEnd = ()=>{
            if (state === 'exiting') // Updates the `ExitingPersistence` to remove this child
            onExitFinished === null || onExitFinished === void 0 ? void 0 : onExitFinished();
            if (!isCancelled) setHasAnimationStyles(false);
            onFinishMotion === null || onFinishMotion === void 0 ? void 0 : onFinishMotion(state);
        };
        if ((0, _isReducedMotion.isReducedMotion)()) {
            // If there is reduced motion there is no exit animation, so call this immediately
            onAnimationEnd();
            return;
        }
        // Elements may need animation styles back after initial mount (they could animate out)
        setHasAnimationStyles(true);
        // Queue `onAnimationEnd` for after the animation has finished
        setTimeout(onAnimationEnd, isExiting ? (0, _exitingDurations.exitingDurations)[duration] : (0, _durations.durations)[duration] + delay);
        return ()=>{
            isCancelled = true;
        };
    // We ignore this for onFinishMotion as consumers could potentially inline the function
    // which would then trigger this effect every re-render.
    // We want to make it easier for consumers so we go down this path unfortunately.
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        onExitFinished,
        state,
        isExiting,
        duration,
        delay,
        paused,
        setTimeout
    ]);
    return children({
        ref: staggered.ref,
        // @ts-expect-error: `ax` is not typed correctly
        className: hasAnimationStyles ? (0, _runtime.ax)([
            (0, _runtime.ax)([
                "_1o51eoah _1y0co91m _1bumglyw _sedtglyw"
            ]),
            paused && (0, _runtime.ax)([
                "_1y0ctrqk"
            ]),
            duration === 'small' && (0, _runtime.ax)([
                "_5sag1yx9"
            ]),
            duration === 'medium' && (0, _runtime.ax)([
                "_5sag1ttt"
            ]),
            duration === 'large' && (0, _runtime.ax)([
                "_5sagpwmj"
            ]),
            isExiting && duration === 'small' && (0, _runtime.ax)([
                "_5sag14ed"
            ]),
            isExiting && duration === 'medium' && (0, _runtime.ax)([
                "_5sagluct"
            ]),
            isExiting && duration === 'large' && (0, _runtime.ax)([
                "_5sag1ttt"
            ]),
            isExiting && (0, _runtime.ax)([
                "_ju255cps _1o51q7pw"
            ]),
            !isExiting && animationTimingFunction === 'linear' && (0, _runtime.ax)([
                "_1pglp3kn"
            ]),
            !isExiting && animationTimingFunction === 'ease-out' && (0, _runtime.ax)([
                "_1pgldkwg"
            ]),
            !isExiting && animationTimingFunction === 'ease-in' && (0, _runtime.ax)([
                "_1pgl1nzg"
            ]),
            !isExiting && animationTimingFunction === 'ease-in-40-out' && (0, _runtime.ax)([
                "_1pgl5y64"
            ]),
            !isExiting && animationTimingFunction === 'ease-in-60-out' && (0, _runtime.ax)([
                "_1pgl1ddy"
            ]),
            !isExiting && animationTimingFunction === 'ease-in-80-out' && (0, _runtime.ax)([
                "_1pglannl"
            ]),
            !isExiting && animationTimingFunction === 'ease-in-out' && (0, _runtime.ax)([
                "_1pgl1fu8"
            ]),
            isExiting && animationTimingFunction === 'linear' && (0, _runtime.ax)([
                "_1pglp3kn"
            ]),
            isExiting && animationTimingFunctionExiting === 'ease-out' && (0, _runtime.ax)([
                "_1pgldkwg"
            ]),
            isExiting && animationTimingFunctionExiting === 'ease-in' && (0, _runtime.ax)([
                "_1pgl1nzg"
            ]),
            isExiting && animationTimingFunctionExiting === 'ease-in-40-out' && (0, _runtime.ax)([
                "_1pgl5y64"
            ]),
            isExiting && animationTimingFunctionExiting === 'ease-in-60-out' && (0, _runtime.ax)([
                "_1pgl1ddy"
            ]),
            isExiting && animationTimingFunctionExiting === 'ease-in-80-out' && (0, _runtime.ax)([
                "_1pglannl"
            ]),
            isExiting && animationTimingFunctionExiting === 'ease-in-out' && (0, _runtime.ax)([
                "_1pgl1fu8"
            ]),
            (!isExiting && enteringAnimation === 'fade-in' || isExiting && exitingAnimation === 'fade-in') && (0, _runtime.ax)([
                "_j7hq1cgr"
            ]),
            (!isExiting && enteringAnimation === 'fade-out' || isExiting && exitingAnimation === 'fade-out') && (0, _runtime.ax)([
                "_j7hq1lln"
            ]),
            (!isExiting && enteringAnimation === 'zoom-in' || isExiting && exitingAnimation === 'zoom-in') && (0, _runtime.ax)([
                "_j7hqe8p0"
            ]),
            (!isExiting && enteringAnimation === 'zoom-out' || isExiting && exitingAnimation === 'zoom-out') && (0, _runtime.ax)([
                "_j7hqy6ql"
            ]),
            (!isExiting && enteringAnimation === 'slide-in-from-top' || isExiting && exitingAnimation === 'slide-in-from-top') && (0, _runtime.ax)([
                "_j7hqqshu"
            ]),
            (!isExiting && enteringAnimation === 'slide-out-from-top' || isExiting && exitingAnimation === 'slide-out-from-top') && (0, _runtime.ax)([
                "_j7hq7ri4"
            ]),
            (!isExiting && enteringAnimation === 'slide-in-from-right' || isExiting && exitingAnimation === 'slide-in-from-right') && (0, _runtime.ax)([
                "_j7hqdfjr"
            ]),
            (!isExiting && enteringAnimation === 'slide-out-from-right' || isExiting && exitingAnimation === 'slide-out-from-right') && (0, _runtime.ax)([
                "_j7hqonfj"
            ]),
            (!isExiting && enteringAnimation === 'slide-in-from-bottom' || isExiting && exitingAnimation === 'slide-in-from-bottom') && (0, _runtime.ax)([
                "_j7hq1liq"
            ]),
            (!isExiting && enteringAnimation === 'slide-out-from-bottom' || isExiting && exitingAnimation === 'slide-out-from-bottom') && (0, _runtime.ax)([
                "_j7hqhnf1"
            ]),
            (!isExiting && enteringAnimation === 'slide-in-from-left' || isExiting && exitingAnimation === 'slide-in-from-left') && (0, _runtime.ax)([
                "_j7hq1bh1"
            ]),
            (!isExiting && enteringAnimation === 'slide-out-from-left' || isExiting && exitingAnimation === 'slide-out-from-left') && (0, _runtime.ax)([
                "_j7hqj08w"
            ]),
            (!isExiting && enteringAnimation === 'fade-in-from-top' || isExiting && exitingAnimation === 'fade-in-from-top') && (0, _runtime.ax)([
                "_j7hq2iua"
            ]),
            (!isExiting && enteringAnimation === 'fade-out-from-top' || isExiting && exitingAnimation === 'fade-out-from-top') && (0, _runtime.ax)([
                "_j7hq39va"
            ]),
            (!isExiting && enteringAnimation === 'fade-in-from-left' || isExiting && exitingAnimation === 'fade-in-from-left') && (0, _runtime.ax)([
                "_j7hq15m2"
            ]),
            (!isExiting && enteringAnimation === 'fade-out-from-left' || isExiting && exitingAnimation === 'fade-out-from-left') && (0, _runtime.ax)([
                "_j7hq1yiv"
            ]),
            (!isExiting && enteringAnimation === 'fade-in-from-bottom' || isExiting && exitingAnimation === 'fade-in-from-bottom') && (0, _runtime.ax)([
                "_j7hq1w00"
            ]),
            (!isExiting && enteringAnimation === 'fade-out-from-bottom' || isExiting && exitingAnimation === 'fade-out-from-bottom') && (0, _runtime.ax)([
                "_j7hqzy3z"
            ]),
            (!isExiting && enteringAnimation === 'fade-in-from-right' || isExiting && exitingAnimation === 'fade-in-from-right') && (0, _runtime.ax)([
                "_j7hqpqak"
            ]),
            (!isExiting && enteringAnimation === 'fade-out-from-right' || isExiting && exitingAnimation === 'fade-out-from-right') && (0, _runtime.ax)([
                "_j7hq1ebg"
            ]),
            (!isExiting && enteringAnimation === 'fade-in-from-top-constant' || isExiting && exitingAnimation === 'fade-in-from-top-constant') && (0, _runtime.ax)([
                "_j7hqm2e2"
            ]),
            (!isExiting && enteringAnimation === 'fade-out-from-top-constant' || isExiting && exitingAnimation === 'fade-out-from-top-constant') && (0, _runtime.ax)([
                "_j7hq97jn"
            ]),
            (!isExiting && enteringAnimation === 'fade-in-from-left-constant' || isExiting && exitingAnimation === 'fade-in-from-left-constant') && (0, _runtime.ax)([
                "_j7hqovgq"
            ]),
            (!isExiting && enteringAnimation === 'fade-out-from-left-constant' || isExiting && exitingAnimation === 'fade-out-from-left-constant') && (0, _runtime.ax)([
                "_j7hq15do"
            ]),
            (!isExiting && enteringAnimation === 'fade-in-from-bottom-constant' || isExiting && exitingAnimation === 'fade-in-from-bottom-constant') && (0, _runtime.ax)([
                "_j7hq797a"
            ]),
            (!isExiting && enteringAnimation === 'fade-out-from-bottom-constant' || isExiting && exitingAnimation === 'fade-out-from-bottom-constant') && (0, _runtime.ax)([
                "_j7hqwo7r"
            ]),
            (!isExiting && enteringAnimation === 'fade-in-from-right-constant' || isExiting && exitingAnimation === 'fade-in-from-right-constant') && (0, _runtime.ax)([
                "_j7hqt8u5"
            ]),
            (!isExiting && enteringAnimation === 'fade-out-from-right-constant' || isExiting && exitingAnimation === 'fade-out-from-right-constant') && (0, _runtime.ax)([
                "_j7hq1pgp"
            ])
        ]) : '',
        style: {
            animationDelay: `${delay}ms`
        }
    }, state);
};
exports.default = EnteringMotion;

},{"react":"ltHCL","@compiled/react/runtime":"d27Vo","../utils/durations":"3tpdK","../utils/exiting-durations":"fGCJG","../utils/is-reduced-motion":"XfCCa","../utils/use-set-timeout":"hOeL0","./exiting-persistence":"9OFRq","./staggered-entrance":"eiSc7","@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"hOeL0":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "useSetTimeout", ()=>useSetTimeout);
var _react = require("react");
const getHookDeps = (opts)=>{
    switch(opts.cleanup){
        case 'next-effect':
            return undefined;
        case 'unmount':
        default:
            return [];
    }
};
const useSetTimeout = (opts = {
    cleanup: 'unmount'
})=>{
    const timeouts = (0, _react.useRef)([]);
    (0, _react.useEffect)(()=>{
        return ()=>{
            if (timeouts.current.length) {
                timeouts.current.forEach((id)=>clearTimeout(id));
                timeouts.current = [];
            }
        };
    // We dynamically set this so we either clean up on the next effect - or on unmount.
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, getHookDeps(opts));
    return (0, _react.useCallback)((handler, timeout, ...args)=>{
        const id = setTimeout(()=>{
            timeouts.current = timeouts.current.filter((timeoutId)=>timeoutId !== id);
            handler();
        }, timeout, ...args);
        timeouts.current.push(id);
    }, []);
};

},{"react":"ltHCL","@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"9OFRq":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "useExitingPersistence", ()=>useExitingPersistence);
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _platformFeatureFlags = require("@atlaskit/platform-feature-flags");
// We define empty context here so the object doesn't change.
const emptyContext = {
    // Motions will always appear if not inside a exiting persistence component.
    appear: true,
    isExiting: false
};
/**
 * __Exiting context__
 *
 * An exiting context.
 */ const ExitingContext = /*#__PURE__*/ (0, _react.createContext)(emptyContext);
/**
 * This method will wrap any React element with a context provider. We're using context (instead of
 * cloneElement) so we can communicate between multiple elements without the need of prop drilling
 * (results in a better API for consumers).
 */ const wrapChildWithContextProvider = (child, value = emptyContext)=>{
    return /*#__PURE__*/ (0, _reactDefault.default).createElement(ExitingContext.Provider, {
        key: `${child.key}-provider`,
        value: value
    }, child);
};
/**
 * This function will convert all children types to an array while also filtering out non-valid React elements.
 */ const childrenToArray = (children)=>{
    const childrenAsArray = [];
    // We convert children to an array using this helper method as it will add keys to children that do not
    // have them, such as when we have hardcoded children that are conditionally rendered.
    (0, _react.Children).toArray(children).forEach((child)=>{
        // We ignore any boolean children to make our code a little more simple later on,
        // and also filter out any falsies (empty strings, nulls, and undefined).
        if (typeof child !== 'boolean' && Boolean(child)) // Children WILL have a key after being forced into an array using the React.Children helper.
        childrenAsArray.push(child);
    });
    return childrenAsArray;
};
const spliceNewElementsIntoPrevious = (current, previous)=>{
    const splicedChildren = previous.concat([]);
    const previousMap = childrenToObj(previous);
    for(let i = 0; i < current.length; i++){
        const child = current[i];
        const childIsNew = !previousMap[child.key];
        if (childIsNew) // This will insert the new element after the previous element.
        splicedChildren.splice(i + 1, 0, child);
    }
    return splicedChildren;
};
const childrenToObj = (children)=>{
    return children.reduce((acc, child)=>{
        acc[child.key] = child;
        return acc;
    }, {});
};
const getMissingKeys = (current, previous)=>{
    const currentMapKeys = new Set(current.map((child)=>child.key));
    const missing = new Set();
    for(let i = 0; i < previous.length; i++){
        const element = previous[i];
        const key = element.key;
        if (!currentMapKeys.has(key)) missing.add(key);
    }
    return missing;
};
/**
 * How does this component work?
 *
 * It looks at changes in its children to see what is removed.
 *
 * If a child is removed it clones it and wraps it with context providing an `onFinish` callback.
 *
 * The cloned child will call the `onFinish` when it finishes its exit animation,
 * which lets `ExitingPersistence` know to stop rendering it.
 */ /**
 * __ExitingPersistence__
 *
 * Useful for enabling elements to persist and animate away when they are removed from the DOM.
 *
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/motion/docs/entering-motion)
 */ const ExitingPersistence = /*#__PURE__*/ (0, _react.memo)(({ appear = false, children, exitThenEnter })=>{
    const [stateChildren, setChildren] = (0, _react.useState)([
        null,
        children
    ]);
    const [exitingChildren, setExitingChildren] = (0, _react.useState)([]);
    const [defaultContext, setDefaultContext] = (0, _react.useState)(()=>({
            appear,
            isExiting: false
        }));
    (0, _react.useEffect)(()=>{
        if (!defaultContext.appear) setDefaultContext({
            appear: true,
            isExiting: false
        });
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
    /**
	 * NOTE: This is a workaround for the test case written in Jira where the stateChildren is a boolean value because
	 * useState is mocked to return a boolean value.
	 */ if (typeof stateChildren === 'boolean') return children;
    const [previousChildren, currentChildren] = stateChildren;
    const previous = childrenToArray(previousChildren);
    const current = childrenToArray(currentChildren);
    if (currentChildren !== children) setChildren([
        currentChildren,
        children
    ]);
    const nextChildren = currentChildren !== children ? childrenToArray(children) : current;
    const missingKeys = getMissingKeys(nextChildren, previous);
    const isSomeChildRemoved = !!missingKeys.size;
    let visibleChildren = !isSomeChildRemoved && currentChildren !== children ? nextChildren : current;
    if (isSomeChildRemoved) visibleChildren = spliceNewElementsIntoPrevious(current, previous);
    if (exitThenEnter) {
        if (exitingChildren.length) visibleChildren = (0, _platformFeatureFlags.fg)('platform-dst-motion-uplift') ? previous : exitingChildren;
        else {
            const nextExitingChildren = visibleChildren.filter((child)=>missingKeys.has(child.key));
            if (nextExitingChildren.length) setExitingChildren(nextExitingChildren);
        }
    }
    if (missingKeys.size) visibleChildren = visibleChildren.map((child)=>{
        const isExiting = missingKeys.has(child.key);
        return wrapChildWithContextProvider(child, {
            appear: true,
            isExiting,
            onFinish: isExiting ? ()=>{
                missingKeys.delete(child.key);
                if (missingKeys.size === 0) {
                    setChildren([
                        null,
                        children
                    ]);
                    setExitingChildren([]);
                }
            } : undefined
        });
    });
    else visibleChildren = visibleChildren.map((child)=>wrapChildWithContextProvider(child, defaultContext));
    return visibleChildren;
});
const useExitingPersistence = ()=>{
    return (0, _react.useContext)(ExitingContext);
};
ExitingPersistence.displayName = 'ExitingPersistence';
// eslint-disable-next-line @atlaskit/volt-strict-mode/no-multiple-exports
exports.default = ExitingPersistence;

},{"react":"ltHCL","@atlaskit/platform-feature-flags":"8rD2i","@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"eiSc7":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "useStaggeredEntrance", ()=>useStaggeredEntrance);
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _noop = require("@atlaskit/ds-lib/noop");
var _noopDefault = parcelHelpers.interopDefault(_noop);
var _useLayoutEffect = require("../utils/use-layout-effect");
var _useUniqueId = require("../utils/use-unique-id");
const StaggeredEntranceContext = /*#__PURE__*/ (0, _react.createContext)(()=>({
        isReady: true,
        delay: 0,
        ref: (0, _noopDefault.default)
    }));
const useStaggeredEntrance = ()=>{
    const indentifier = (0, _useUniqueId.useUniqueId)();
    const context = (0, _react.useContext)(StaggeredEntranceContext);
    return context(indentifier);
};
/**
 * For a list of elements that need to animate in,
 * this should be used in conjunction with entering components.
 * This does not need Javascript to execute so it will run immediately for any SSR rendered React apps before the JS has executed.
 *
 * Will dynamically add delay to each child entering component.
 * Unfortunately all entering components _NEED_ to be a direct descendant.
 */ const StaggeredEntrance = ({ children, column, columns = 'responsive', delayStep = 50 })=>{
    const elementRefs = (0, _react.useRef)([]);
    const indexes = [];
    const [actualColumns, setActualColumns] = (0, _react.useState)(()=>{
        if (typeof columns === 'number') // A hardcoded columns is set so bail out and set it to that!
        return columns;
        if (typeof column === 'number') // A hardcoded column is set so we will set actualColumns to be 1.
        return 1;
        // We are in "responsive" mode.
        // So we will be calculating when the Javascript executes on the client how many columns there will be.
        return 0;
    });
    (0, _useLayoutEffect.useLayoutEffect)(()=>{
        // We want to only run this code when we are in "responsive" mode.
        // It is assumed we are in responsive mode if `columns` is "responsive",
        // we have children element refs ready to be read (i.e. if there are no children this won't run as well)
        // and finally that `actualColumns` is `0` - this is because for the first render cycle `actualColumns` will be `0` (set above)
        // and then after this layout effect runs the value for `actualColumns` will then be calculated and set.
        if (columns === 'responsive' && elementRefs.current.length && actualColumns === 0) {
            let currentTop = 0;
            let numberColumns = 0;
            if (elementRefs.current.length <= 1) {
                setActualColumns(1);
                return;
            }
            // We set the current top to the first elements.
            // We will be comparing this and incrementing the column count
            // until we hit an element that has a different offset top (or we run out of elements).
            currentTop = elementRefs.current[0] ? elementRefs.current[0].offsetTop : 0;
            for(let i = 0; i < elementRefs.current.length; i++){
                const child = elementRefs.current[i];
                if (!child) break;
                if (currentTop === child.offsetTop) {
                    numberColumns += 1;
                    if (elementRefs.current.length - 1 === i) setActualColumns(numberColumns);
                    continue;
                }
                setActualColumns(numberColumns);
                break;
            }
        }
    // We only want this effect to run once - on initial mount.
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
    return /*#__PURE__*/ (0, _reactDefault.default).createElement(StaggeredEntranceContext.Provider, {
        value: (id)=>{
            if (!indexes.includes(id)) indexes.push(id);
            const isReady = actualColumns > 0;
            const index = indexes.indexOf(id);
            const currentColumn = column || index % actualColumns;
            const currentRow = Math.floor(index / actualColumns);
            const distanceFromTopLeftElement = currentRow + currentColumn;
            // We don't want loads of elements to have the same staggered delay as it ends up looking slow for users.
            // To get around that we calculate the logarithm using `distanceFromTopLeftElement` which ends making
            // elements appear faster the further away from the top left element.
            const delay = Math.ceil(Math.log(distanceFromTopLeftElement + 1) * delayStep * 1.5) || 0;
            return {
                delay,
                isReady,
                ref: (element)=>elementRefs.current[index] = element
            };
        }
    }, children);
};
// eslint-disable-next-line @atlaskit/volt-strict-mode/no-multiple-exports
exports.default = StaggeredEntrance;

},{"react":"ltHCL","@atlaskit/ds-lib/noop":"faKzG","../utils/use-layout-effect":"emFaL","../utils/use-unique-id":"1ZCFJ","@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"emFaL":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "useLayoutEffect", ()=>useLayoutEffect);
var _react = require("react");
const useLayoutEffect = typeof window === 'undefined' ? (0, _react.useEffect) : (0, _react.useLayoutEffect);

},{"react":"ltHCL","@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"1ZCFJ":[function(require,module,exports,__globalThis) {
/* eslint-disable @repo/internal/react/disallow-unstable-values */ var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
/**
 * Will return a unique id that does not change between renders.
 * Try not use this to render DOM markup (attributes or otherwise)
 * as you will probably not get the same result on the Server vs. Client.
 */ parcelHelpers.export(exports, "useUniqueId", ()=>useUniqueId);
var _react = require("react");
function useUniqueId() {
    const identifier = (0, _react.useRef)('');
    if (!identifier.current) identifier.current = '_' + (Number(String(Math.random()).slice(2)) + Date.now() + Math.round(performance.now())).toString(36);
    return identifier.current;
}

},{"react":"ltHCL","@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"tXfEe":[function(require,module,exports,__globalThis) {
/* eslint-disable @repo/internal/deprecations/deprecation-ticket-required */ var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "useResizingHeight", ()=>useResizingHeight);
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _curves = require("../utils/curves");
var _durations = require("../utils/durations");
var _isReducedMotion = require("../utils/is-reduced-motion");
var _useElementRef = require("../utils/use-element-ref");
var _useLayoutEffect = require("../utils/use-layout-effect");
var _useRequestAnimationFrame = require("../utils/use-request-animation-frame");
var _useSetTimeout = require("../utils/use-set-timeout");
var _useSnapshotBeforeUpdate = require("../utils/use-snapshot-before-update");
const useResizingHeight = ({ duration: calcDuration = ()=>(0, _durations.durations).medium, timingFunction: calcTimingFunction = ()=>(0, _curves.easeInOut) } = {})=>{
    const prevDimensions = (0, _react.useRef)();
    const [element, setElementRef] = (0, _useElementRef.useElementRef)();
    // We cleanup on the next effect to prevent the previous timeout being called during
    // the next motion - as now the timeout has essentially been extended!
    const setTimeout = (0, _useSetTimeout.useSetTimeout)({
        cleanup: 'next-effect'
    });
    const requestAnimationFrame = (0, _useRequestAnimationFrame.useRequestAnimationFrame)();
    (0, _useSnapshotBeforeUpdate.useSnapshotBeforeUpdate)(()=>{
        if ((0, _isReducedMotion.isReducedMotion)() || !element) return;
        prevDimensions.current = element.getBoundingClientRect();
    });
    (0, _useLayoutEffect.useLayoutEffect)(()=>{
        if ((0, _isReducedMotion.isReducedMotion)() || !element || !prevDimensions.current) return;
        // We might already be animating.
        // Because of that we need to expand to the destination height first.
        element.setAttribute('style', '');
        const nextDimensions = element.getBoundingClientRect();
        if (nextDimensions.height === prevDimensions.current.height) return;
        const duration = calcDuration(prevDimensions.current.height, nextDimensions.height);
        const newStyles = {
            height: `${prevDimensions.current.height}px`,
            willChange: 'height',
            transitionProperty: 'height',
            transitionDuration: `${duration}ms`,
            boxSizing: 'border-box',
            transitionTimingFunction: calcTimingFunction(prevDimensions.current.height, nextDimensions.height, duration)
        };
        Object.assign(element.style, newStyles);
        // We split this over two animation frames so the DOM has enough time to flush the changes.
        // We are deliberately not skipping this frame if another render happens - if we do the motion doesn't finish properly.
        requestAnimationFrame(()=>{
            requestAnimationFrame(()=>{
                if (!element) return;
                element.style.height = `${nextDimensions.height}px`;
                setTimeout(()=>{
                    if (!element) return;
                    element.setAttribute('style', '');
                }, duration);
            });
        });
    });
    return {
        ref: setElementRef
    };
};

},{"react":"ltHCL","../utils/curves":"7J7Ar","../utils/durations":"3tpdK","../utils/is-reduced-motion":"XfCCa","../utils/use-element-ref":"3UxZJ","../utils/use-layout-effect":"emFaL","../utils/use-request-animation-frame":"jYsxU","../utils/use-set-timeout":"hOeL0","../utils/use-snapshot-before-update":"im97U","@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"3UxZJ":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "useElementRef", ()=>useElementRef);
var _react = require("react");
const useElementRef = ()=>{
    const elementRef = (0, _react.useRef)(null);
    const setRef = (0, _react.useCallback)((ref)=>{
        elementRef.current = ref;
    }, []);
    return [
        elementRef.current,
        setRef
    ];
};

},{"react":"ltHCL","@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"jYsxU":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "useRequestAnimationFrame", ()=>useRequestAnimationFrame);
var _react = require("react");
const getHookDeps = (opts)=>{
    switch(opts.cleanup){
        case 'next-effect':
            return undefined;
        case 'unmount':
        default:
            return [];
    }
};
const useRequestAnimationFrame = (opts = {
    cleanup: 'unmount'
})=>{
    const frames = (0, _react.useRef)([]);
    (0, _react.useEffect)(()=>{
        return ()=>{
            if (frames.current.length) {
                frames.current.forEach((id)=>cancelAnimationFrame(id));
                frames.current = [];
            }
        };
    // We dynamically set this so we either clean up on the next effect - or on unmount.
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, getHookDeps(opts));
    return (0, _react.useCallback)((handler)=>{
        const id = requestAnimationFrame((time)=>{
            frames.current = frames.current.filter((frameId)=>frameId !== id);
            handler(time);
        });
        frames.current.push(id);
    }, []);
};

},{"react":"ltHCL","@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"im97U":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "useSnapshotBeforeUpdate", ()=>useSnapshotBeforeUpdate);
var _react = require("react");
var _useLayoutEffect = require("../utils/use-layout-effect");
const useSnapshotBeforeUpdate = (cb)=>{
    const isFirstRender = (0, _react.useRef)(true);
    if (!isFirstRender.current) cb();
    (0, _useLayoutEffect.useLayoutEffect)(()=>{
        isFirstRender.current = false;
    }, []);
};

},{"react":"ltHCL","../utils/use-layout-effect":"emFaL","@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"nzH1k":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _keyframesMotion = require("./keyframes-motion");
var _keyframesMotionDefault = parcelHelpers.interopDefault(_keyframesMotion);
/**
 * __ZoomIn__
 *
 * Will over zoom an element into position.
 *
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/motion/docs/entering-motion)
 */ const ZoomIn = ({ children, duration = 'small', isPaused, onFinish })=>{
    return /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _keyframesMotionDefault.default), {
        duration: duration,
        enteringAnimation: "zoom-in",
        exitingAnimation: "zoom-out",
        animationTimingFunction: "ease-in-out",
        isPaused: isPaused,
        onFinish: onFinish
    }, children);
};
exports.default = ZoomIn;

},{"react":"ltHCL","./keyframes-motion":"2Tz9i","@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"j0S25":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _keyframesMotion = require("./keyframes-motion");
var _keyframesMotionDefault = parcelHelpers.interopDefault(_keyframesMotion);
/**
 * __SlideIn__
 *
 * Will slide an element into position, generally used for things that appear from outside of the viewport into view.
 *
 * See [examples](https://atlaskit.atlassian.com/packages/design-system/motion/docs/entering-motion).
 */ const SlideIn = ({ children, enterFrom, exitTo, duration = 'medium', isPaused, onFinish, animationTimingFunction = 'ease-out', animationTimingFunctionExiting = 'ease-in' })=>{
    return /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _keyframesMotionDefault.default), {
        duration: duration,
        enteringAnimation: `slide-in-from-${enterFrom}`,
        exitingAnimation: `slide-out-from-${exitTo || enterFrom}`,
        animationTimingFunction: animationTimingFunction,
        animationTimingFunctionExiting: animationTimingFunctionExiting,
        isPaused: isPaused,
        onFinish: onFinish
    }, children);
};
exports.default = SlideIn;

},{"react":"ltHCL","./keyframes-motion":"2Tz9i","@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"1ZLLp":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _durations = require("../utils/durations");
var _isReducedMotion = require("../utils/is-reduced-motion");
var _useElementRef = require("../utils/use-element-ref");
var _useLayoutEffect = require("../utils/use-layout-effect");
var _useRequestAnimationFrame = require("../utils/use-request-animation-frame");
var _useSetTimeout = require("../utils/use-set-timeout");
var _exitingPersistence = require("./exiting-persistence");
/**
 * __ShrinkOut__
 *
 * Will shrink an element down to nothing when exiting.
 * Works best with flex children as collapsing margins can come with undesired behaviour.
 *
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/motion/docs/entering-motion)
 */ const ShrinkOut = ({ children, duration = 'small', onFinish })=>{
    const [element, setElementRef] = (0, _useElementRef.useElementRef)();
    const exiting = (0, _exitingPersistence.useExitingPersistence)();
    const requestAnimationFrame = (0, _useRequestAnimationFrame.useRequestAnimationFrame)();
    const setTimeout = (0, _useSetTimeout.useSetTimeout)();
    const direction = exiting.isExiting ? 'exiting' : 'entering';
    (0, _useLayoutEffect.useLayoutEffect)(()=>{
        if (exiting.isExiting && element) {
            if ((0, _isReducedMotion.isReducedMotion)()) {
                exiting.onFinish && exiting.onFinish();
                onFinish && onFinish('exiting');
                return;
            }
            const newStyles = {
                // We fix both width and height because when changing box sizing to border-box.
                width: `${element.offsetWidth}px`,
                height: `${element.offsetHeight}px`,
                boxSizing: 'border-box',
                willChange: 'width,margin'
            };
            Object.assign(element.style, newStyles);
            requestAnimationFrame(()=>{
                requestAnimationFrame(()=>{
                    const newStyles = {
                        width: '0px',
                        margin: '0px',
                        transitionTimingFunction: 'cubic-bezier(0.8,0,0,0.8)',
                        transitionDuration: (0, _durations.durations)[duration] + 'ms',
                        transitionProperty: 'width,margin'
                    };
                    Object.assign(element.style, newStyles);
                    setTimeout(()=>{
                        exiting.onFinish && exiting.onFinish();
                        onFinish && onFinish('exiting');
                    }, (0, _durations.durations)[duration]);
                });
            });
        }
    });
    return children({
        ref: setElementRef
    }, direction);
};
exports.default = ShrinkOut;

},{"../utils/durations":"3tpdK","../utils/is-reduced-motion":"XfCCa","../utils/use-element-ref":"3UxZJ","../utils/use-layout-effect":"emFaL","../utils/use-request-animation-frame":"jYsxU","../utils/use-set-timeout":"hOeL0","./exiting-persistence":"9OFRq","@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"3d35X":[function(require,module,exports,__globalThis) {
/* motion.tsx generated by @compiled/babel-plugin v0.39.1 */ var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "Reanimate", ()=>(0, _reanimate.Reanimate));
var _objectSpread = require("@swc/helpers/_/_object_spread");
var _objectSpreadProps = require("@swc/helpers/_/_object_spread_props");
var _runtime = require("@compiled/react/runtime");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _css = require("@atlaskit/css");
var _mergeRefs = require("@atlaskit/ds-lib/merge-refs");
var _mergeRefsDefault = parcelHelpers.interopDefault(_mergeRefs);
var _platformFeatureFlags = require("@atlaskit/platform-feature-flags");
var _convertToMs = require("../utils/convert-to-ms");
var _getDurationMs = require("../utils/get-duration-ms");
var _isReducedMotion = require("../utils/is-reduced-motion");
var _resolveMotionToken = require("../utils/resolve-motion-token");
var _exitingPersistence = require("./exiting-persistence");
var _reanimate = require("./reanimate");
var _staggeredEntrance = require("./staggered-entrance");
var _useMotion = require("./use-motion");
const styles = {
    base: "_1y0co91m _1bumglyw _sedtglyw",
    hidden: "_3um015vq",
    entering: "_1o51eoah",
    exiting: "_1o51q7pw"
};
/**
 * Legacy implementation of `Motion` that inlines the animation lifecycle.
 * Used when the `platform-dst-use-motion` feature gate is off.
 */ const MotionLegacy = /*#__PURE__*/ (0, _react.forwardRef)(({ children, enteringAnimation, enteringAnimationXcss, exitingAnimation, exitingAnimationXcss, onFinish: onFinishMotion, xcss, style: styleProp, testId }, ref)=>{
    const staggered = (0, _staggeredEntrance.useStaggeredEntrance)();
    const { isExiting, onFinish: onExitFinished, appear } = (0, _exitingPersistence.useExitingPersistence)();
    const staggeredDelay = isExiting ? 0 : staggered.delay;
    const staggedIsReady = staggered.isReady;
    const [state, setState] = (0, _react.useState)(appear ? staggedIsReady && !staggeredDelay ? 'entering' : 'init' : 'idle');
    const elementRef = (0, _react.useRef)(null);
    const reanimateRef = (0, _react.useRef)();
    const animationRef = (0, _react.useRef)();
    const staggeredEntryRef = (0, _react.useRef)();
    (0, _react.useEffect)(()=>{
        if (isExiting) setState('exiting');
    }, [
        isExiting
    ]); // Handles staggered entry
    (0, _react.useEffect)(()=>{
        if (state !== 'init') return; // We delay the entry animation by the stagger delay
        staggeredEntryRef.current = setTimeout(()=>{
            setState('entering');
        }, staggeredDelay);
        return ()=>{
            if (staggeredEntryRef.current) clearTimeout(staggeredEntryRef.current);
        };
    }, [
        state,
        staggedIsReady,
        staggeredDelay
    ]); /**
                                                * Updates relevant state.
                                                * Called when the animation is finished, or immediately with reduced motion.
                                                */ 
    const onAnimationEnd = (0, _react.useCallback)((state, cancelled)=>{
        // We are done animating, so we set the state to idle
        let newState = 'idle';
        if (state === 'exiting') {
            if (!reanimateRef.current) // Updates the `ExitingPersistence` to remove this child
            onExitFinished === null || onExitFinished === void 0 ? void 0 : onExitFinished();
            onFinishMotion === null || onFinishMotion === void 0 ? void 0 : onFinishMotion('exiting');
        }
        if (state === 'entering') onFinishMotion === null || onFinishMotion === void 0 ? void 0 : onFinishMotion('entering');
        if (reanimateRef.current === (0, _reanimate.Reanimate).exit_then_enter) {
            // We are done exiting, so we set the state to entering
            reanimateRef.current = (0, _reanimate.Reanimate).enter;
            newState = 'entering';
        } else if (reanimateRef.current) // We are done reanimating, so we clear the reanimate state
        reanimateRef.current = undefined;
        if (!cancelled) setState(newState);
         // We ignore this for onFinishMotion as consumers could potentially inline the function
    // which would then trigger this effect every re-render.
    // We want to make it easier for consumers so we go down this path unfortunately.
    }, // eslint-disable-next-line react-hooks/exhaustive-deps
    [
        onExitFinished
    ]);
    (0, _react.useEffect)(()=>{
        // Tracking this to prevent changing state on an unmounted component
        let isCancelled = false;
        if (!staggedIsReady) return;
         // On initial mount if elements aren't set to animate on appear, we return early and callback
        // This only occurs on initial mount, as appear will be true once the component is mounted
        if (!appear) {
            onFinishMotion && onFinishMotion('entering');
            return;
        } // If the state is idle or init, we don't need to do anything
        if (state === 'idle' || state === 'init') return;
         // If there is reduced motion or no exit animation, we call the onAnimationEnd function immediately
        if ((0, _isReducedMotion.isReducedMotion)() || !exitingAnimation && !exitingAnimationXcss) {
            onAnimationEnd(state, isCancelled);
            return;
        }
        let animationDuration = 0;
        let animationDelay = 0;
        if (state === 'entering' || state === 'exiting') {
            if (elementRef.current) {
                if (elementRef.current.style.animation) {
                    // Motion token
                    const animationTimings = (0, _getDurationMs.getDurationMs)((0, _resolveMotionToken.resolveMotionToken)(elementRef.current.style.animation));
                    animationDuration = animationTimings.duration;
                    animationDelay = animationTimings.delay;
                } else {
                    // Custom motion
                    const styles = window.getComputedStyle(elementRef.current);
                    if (styles.animationDuration) animationDuration = (0, _convertToMs.convertToMs)(styles.animationDuration);
                    if (styles.animationDelay) animationDelay = (0, _convertToMs.convertToMs)(styles.animationDelay);
                }
            }
        } // Queue `onAnimationEnd` for after the animation has finished
        if (state === 'exiting' && (exitingAnimation || exitingAnimationXcss)) animationRef.current = setTimeout(()=>onAnimationEnd(state, isCancelled), animationDuration + animationDelay);
        else if (state === 'entering' && (enteringAnimation || enteringAnimationXcss)) animationRef.current = setTimeout(()=>onAnimationEnd(state, isCancelled), animationDuration + animationDelay);
        return ()=>{
            isCancelled = true;
            if (animationRef.current) clearTimeout(animationRef.current);
        }; // We ignore this for onFinishMotion as consumers could potentially inline the function
    // which would then trigger this effect every re-render.
    // We want to make it easier for consumers so we go down this path unfortunately.
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        onAnimationEnd,
        state,
        exitingAnimation,
        enteringAnimation,
        exitingAnimationXcss,
        enteringAnimationXcss,
        staggeredDelay,
        staggedIsReady
    ]);
    (0, _react.useImperativeHandle)(ref, ()=>({
            reanimate: (value)=>{
                animationRef.current && clearTimeout(animationRef.current);
                reanimateRef.current = value;
                if (value === (0, _reanimate.Reanimate).exit_then_enter) setState('exiting');
                else if (value === (0, _reanimate.Reanimate).enter) setState('entering');
            }
        }));
    let style = {};
    let customAnimation;
    if (state === 'entering') {
        if (enteringAnimation) style.animation = `${enteringAnimation} backwards`;
        else if (enteringAnimationXcss) customAnimation = enteringAnimationXcss;
    } else if (state === 'exiting') {
        if (exitingAnimation) style.animation = `${exitingAnimation} forwards`;
        else if (exitingAnimationXcss) customAnimation = exitingAnimationXcss;
    }
    const hasAnimationStyles = state !== 'idle' && state !== 'init';
    return /*#__PURE__*/ (0, _reactDefault.default).createElement("div" // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop, @atlaskit/ui-styling-standard/local-cx-xcss, @compiled/local-cx-xcss
    , {
        className: (0, _runtime.ax)([
            hasAnimationStyles && styles.base,
            state === 'init' && styles.hidden,
            state === 'entering' && styles.entering,
            state === 'exiting' && styles.exiting,
            (0, _css.cx)(xcss, customAnimation)
        ]),
        ref: (0, _mergeRefsDefault.default)([
            staggered.ref,
            elementRef
        ]),
        style: styleProp || hasAnimationStyles ? (0, _objectSpread._)({}, styleProp, style) : undefined,
        "data-testid": testId
    }, children);
});
/**
 * Implementation of `Motion` built on top of the `useMotion` hook.
 * Used when the `platform-dst-use-motion` feature gate is on.
 */ const MotionNext = /*#__PURE__*/ (0, _react.forwardRef)(({ children, enteringAnimation, enteringAnimationXcss, exitingAnimation, exitingAnimationXcss, onFinish: onFinishMotion, xcss, style: styleProp, testId }, ref)=>{
    const { state, ref: motionRef, reanimate } = (0, _useMotion.useMotion)({
        onFinish: onFinishMotion
    });
    (0, _react.useImperativeHandle)(ref, ()=>({
            reanimate
        }), [
        reanimate
    ]); // `xcss` and `style` apply to the wrapper `<div>` the `Motion` component renders,
    // so they are merged here (not in the hook) alongside the hook's animation output.
    return /*#__PURE__*/ (0, _reactDefault.default).createElement("div" // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop, @atlaskit/ui-styling-standard/local-cx-xcss, @compiled/local-cx-xcss
    , {
        className: (0, _runtime.ax)([
            state === 'init' && styles.hidden,
            state === 'entering' && styles.entering,
            state === 'exiting' && styles.exiting,
            (0, _css.cx)(xcss, state === 'entering' && enteringAnimationXcss, state === 'exiting' && exitingAnimationXcss)
        ]),
        ref: motionRef,
        style: (0, _objectSpreadProps._)((0, _objectSpread._)({}, styleProp), {
            animation: state === 'entering' ? enteringAnimation : state === 'exiting' ? exitingAnimation : undefined
        }),
        "data-testid": testId
    }, children);
}); /**
     * __Motion__
     *
     * A motion primitive that can be used to animate the entry and exit of components.
     */ 
const Motion = /*#__PURE__*/ (0, _react.forwardRef)((props, ref)=>{
    if ((0, _platformFeatureFlags.fg)('platform-dst-use-motion')) return /*#__PURE__*/ (0, _reactDefault.default).createElement(MotionNext, (0, _objectSpreadProps._)((0, _objectSpread._)({}, props), {
        ref: ref
    }));
    return /*#__PURE__*/ (0, _reactDefault.default).createElement(MotionLegacy, (0, _objectSpreadProps._)((0, _objectSpread._)({}, props), {
        ref: ref
    }));
}); // eslint-disable-next-line @atlaskit/volt-strict-mode/no-multiple-exports
exports.default = Motion;

},{"@swc/helpers/_/_object_spread":"9gdrV","@swc/helpers/_/_object_spread_props":"kANqQ","@compiled/react/runtime":"d27Vo","react":"ltHCL","@atlaskit/css":"kMGms","@atlaskit/ds-lib/merge-refs":"doPwA","@atlaskit/platform-feature-flags":"8rD2i","../utils/convert-to-ms":"2tXPt","../utils/get-duration-ms":"Qtxzs","../utils/is-reduced-motion":"XfCCa","../utils/resolve-motion-token":"e1EjN","./exiting-persistence":"9OFRq","./reanimate":"cW3ZQ","./staggered-entrance":"eiSc7","./use-motion":"bn905","@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"doPwA":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>mergeRefs);
function mergeRefs(refs) {
    return (value)=>{
        refs.forEach((ref)=>{
            if (typeof ref === 'function') ref(value);
            else if (ref !== null && typeof ref === 'object') ref.current = value;
        });
    };
}

},{"@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"2tXPt":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "convertToMs", ()=>convertToMs);
const convertToMs = (duration)=>{
    // Use regex to separate the number and the unit
    const matches = duration.match(/^(\d+\.?\d*)(s|ms)$/);
    if (!matches) return 0; // Or return for invalid format
    const value = parseFloat(matches[1]);
    const unit = matches[2];
    if (unit === 's') return value * 1000; // Convert seconds to milliseconds
    else return value; // Already in milliseconds
};

},{"@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"Qtxzs":[function(require,module,exports,__globalThis) {
/**
 * Gets the duration in milliseconds for an animation property.
 * @param animation - The animation property to get the duration for.
 * @returns The duration in milliseconds.
 */ var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "getDurationMs", ()=>getDurationMs);
const getDurationMs = (animation)=>{
    const match = [
        ...animation.trim().matchAll(/(-?\d*\.?\d+)(ms|s)\b/g)
    ];
    if (match.length === 0) return {
        duration: 0,
        delay: 0
    };
    const durationValue = parseFloat(match[0][1]);
    const durationUnit = match[0][2];
    const duration = durationUnit === 's' ? durationValue * 1000 : durationValue;
    let delay = 0;
    if (match[1]) {
        const delayValue = parseFloat(match[1][1]);
        const delayUnit = match[1][2];
        delay = delayUnit === 's' ? delayValue * 1000 : delayValue;
    }
    return {
        duration,
        delay
    };
};

},{"@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"e1EjN":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "resolveMotionToken", ()=>resolveMotionToken);
var _browserApis = require("@atlaskit/browser-apis");
const resolveMotionToken = (token)=>{
    const cssVarMatch = token.match(/var\(\s*(--[^,\s)]+)/);
    const cssVar = cssVarMatch ? cssVarMatch[1] : null;
    if (cssVar) {
        var _getDocument;
        const documentElement = (_getDocument = (0, _browserApis.getDocument)()) === null || _getDocument === void 0 ? void 0 : _getDocument.documentElement;
        if (documentElement) return getComputedStyle(documentElement).getPropertyValue(cssVar);
    }
    return '';
};

},{"@atlaskit/browser-apis":"1bRFZ","@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"cW3ZQ":[function(require,module,exports,__globalThis) {
/**
 * Supported reanimate values.
 * 'enter' will re-enter the animation.
 * 'exit-then-enter' will exit the animation and then enter it again.
 */ var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "Reanimate", ()=>Reanimate);
var Reanimate = /*#__PURE__*/ function(Reanimate) {
    Reanimate["enter"] = "enter";
    Reanimate["exit_then_enter"] = "exit_then_enter";
    Reanimate["exit"] = "exit";
    return Reanimate;
}({});

},{"@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"bn905":[function(require,module,exports,__globalThis) {
/* use-motion.tsx generated by @compiled/babel-plugin v0.39.1 */ var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
/**
 * __useMotion__
 *
 * A hook form of the `Motion` primitive. It manages the entering/exiting animation
 * lifecycle and returns `{ ref, reanimate, state }` so that motion can be applied to
 * an existing element __without__ introducing an extra wrapper element. The consumer
 * drives the animation styling from `state` (e.g. via a `cssMap`) and applies the
 * animation to their own element.
 *
 * The returned `ref` __must__ be attached to the animated element, otherwise exit
 * timing, `onFinish`, and `ExitingPersistence` removal will not work.
 */ parcelHelpers.export(exports, "useMotion", ()=>useMotion);
var _react = require("react");
var _mergeRefs = require("@atlaskit/ds-lib/merge-refs");
var _mergeRefsDefault = parcelHelpers.interopDefault(_mergeRefs);
var _convertToMs = require("../utils/convert-to-ms");
var _getDurationMs = require("../utils/get-duration-ms");
var _isReducedMotion = require("../utils/is-reduced-motion");
var _resolveMotionToken = require("../utils/resolve-motion-token");
var _exitingPersistence = require("./exiting-persistence");
var _reanimate = require("./reanimate");
var _staggeredEntrance = require("./staggered-entrance");
function useMotion({ onFinish: onFinishMotion } = {}) {
    const reducedMotion = (0, _isReducedMotion.isReducedMotion)();
    const staggered = (0, _staggeredEntrance.useStaggeredEntrance)();
    const { isExiting, onFinish: onExitFinished, appear } = (0, _exitingPersistence.useExitingPersistence)();
    const staggeredDelay = isExiting ? 0 : staggered.delay;
    const staggeredIsReady = staggered.isReady;
    const [state, setState] = (0, _react.useState)(appear ? staggeredIsReady && !staggeredDelay ? 'entering' : 'init' : 'idle');
    const elementRef = (0, _react.useRef)(null);
    const reanimateRef = (0, _react.useRef)();
    const animationRef = (0, _react.useRef)();
    const staggeredEntryRef = (0, _react.useRef)();
    (0, _react.useEffect)(()=>{
        if (isExiting) setState('exiting');
    }, [
        isExiting
    ]);
    /**
   * Updates relevant state.
   * Called when the animation is finished, or immediately with reduced motion.
   */ const onAnimationEnd = (0, _react.useCallback)((currentState, cancelled)=>{
        // We are done animating, so we set the state to idle
        let newState = 'idle';
        if (currentState === 'exiting') {
            if (!reanimateRef.current) // Updates the `ExitingPersistence` to remove this child
            onExitFinished === null || onExitFinished === void 0 ? void 0 : onExitFinished();
            onFinishMotion === null || onFinishMotion === void 0 ? void 0 : onFinishMotion('exiting');
        }
        if (currentState === 'entering') onFinishMotion === null || onFinishMotion === void 0 ? void 0 : onFinishMotion('entering');
        if (reanimateRef.current === (0, _reanimate.Reanimate).exit_then_enter) {
            // We are done exiting, so we set the state to entering
            reanimateRef.current = (0, _reanimate.Reanimate).enter;
            newState = 'entering';
        } else if (reanimateRef.current === (0, _reanimate.Reanimate).enter) // We are done reanimating, so we clear the reanimate state
        reanimateRef.current = undefined;
        else if (reanimateRef.current === (0, _reanimate.Reanimate).exit) {
            // We are done exiting, so we set the state to idle
            reanimateRef.current = undefined;
            // No need to set the state to idle, as we have exited
            return;
        }
        if (!cancelled) setState(newState);
    // We ignore this for onFinishMotion as consumers could potentially inline the function
    // which would then trigger this effect every re-render.
    // We want to make it easier for consumers so we go down this path unfortunately.
    }, // eslint-disable-next-line react-hooks/exhaustive-deps
    [
        onExitFinished
    ]);
    // Handles staggered entry
    (0, _react.useEffect)(()=>{
        if (state !== 'init') return;
        if (reducedMotion) {
            onAnimationEnd('entering', false);
            return;
        }
        // We delay the entry animation by the stagger delay
        staggeredEntryRef.current = setTimeout(()=>{
            setState('entering');
        }, staggeredDelay);
        return ()=>{
            if (staggeredEntryRef.current) clearTimeout(staggeredEntryRef.current);
        };
    }, [
        onAnimationEnd,
        state,
        staggeredIsReady,
        staggeredDelay,
        reducedMotion
    ]);
    (0, _react.useEffect)(()=>{
        // Tracking this to prevent changing state on an unmounted component
        let isCancelled = false;
        if (!staggeredIsReady) return;
        // On initial mount if elements aren't set to animate on appear, we return early and callback
        // This only occurs on initial mount, as appear will be true once the component is mounted
        if (!appear) {
            onFinishMotion && onFinishMotion('entering');
            return;
        }
        // If the state is idle or init, we don't need to do anything
        if (state === 'idle' || state === 'init') return;
        // If there is reduced motion or no exit animation, we call the onAnimationEnd function immediately
        if (reducedMotion) {
            onAnimationEnd(state, isCancelled);
            return;
        }
        let animationDuration = 0;
        let animationDelay = 0;
        if (state === 'entering' || state === 'exiting') {
            if (elementRef.current) {
                if (elementRef.current.style.animation) {
                    // Motion token
                    const animationTimings = (0, _getDurationMs.getDurationMs)((0, _resolveMotionToken.resolveMotionToken)(elementRef.current.style.animation));
                    animationDuration = animationTimings.duration;
                    animationDelay = animationTimings.delay;
                } else {
                    // Custom motion
                    const computedStyles = window.getComputedStyle(elementRef.current);
                    if (computedStyles.animationDuration) animationDuration = (0, _convertToMs.convertToMs)(computedStyles.animationDuration);
                    if (computedStyles.animationDelay) animationDelay = (0, _convertToMs.convertToMs)(computedStyles.animationDelay);
                }
            }
        }
        // Queue `onAnimationEnd` for after the animation has finished
        if (state === 'exiting') animationRef.current = setTimeout(()=>onAnimationEnd(state, isCancelled), animationDuration + animationDelay);
        else if (state === 'entering') animationRef.current = setTimeout(()=>onAnimationEnd(state, isCancelled), animationDuration + animationDelay);
        return ()=>{
            isCancelled = true;
            if (animationRef.current) clearTimeout(animationRef.current);
        };
    // We ignore this for onFinishMotion as consumers could potentially inline the function
    // which would then trigger this effect every re-render.
    // We want to make it easier for consumers so we go down this path unfortunately.
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        onAnimationEnd,
        state,
        appear,
        staggeredDelay,
        staggeredIsReady,
        reducedMotion
    ]);
    const reanimate = (0, _react.useCallback)((value)=>{
        animationRef.current && clearTimeout(animationRef.current);
        reanimateRef.current = value;
        if (value === (0, _reanimate.Reanimate).exit_then_enter) setState('exiting');
        else if (value === (0, _reanimate.Reanimate).enter) setState('entering');
        else if (value === (0, _reanimate.Reanimate).exit) setState('exiting');
    }, []);
    const ref = (0, _mergeRefsDefault.default)([
        staggered.ref,
        elementRef
    ]);
    return {
        ref,
        reanimate,
        state
    };
}

},{"react":"ltHCL","@atlaskit/ds-lib/merge-refs":"doPwA","../utils/convert-to-ms":"2tXPt","../utils/get-duration-ms":"Qtxzs","../utils/is-reduced-motion":"XfCCa","../utils/resolve-motion-token":"e1EjN","./exiting-persistence":"9OFRq","./reanimate":"cW3ZQ","./staggered-entrance":"eiSc7","@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"4PB1z":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "Popper", ()=>(0, _popper.Popper));
parcelHelpers.export(exports, "placements", ()=>(0, _popper.placements));
// `Manager` and `Reference` are re-exported through our own wrappers so
// the anchor element captured by `<Reference>` reaches `<Popper>` via a
// single shared context instance, sidestepping the dual CJS/ESM context
// duplication shipped by `react-popper`.
parcelHelpers.export(exports, "Manager", ()=>(0, _manager.Manager));
parcelHelpers.export(exports, "Reference", ()=>(0, _reference.Reference));
var _popper = require("./popper");
var _manager = require("./manager");
var _reference = require("./reference");

},{"./popper":"l9JBa","./manager":"jO3Co","./reference":"aMror","@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"l9JBa":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "placements", ()=>(0, _core.placements));
parcelHelpers.export(exports, "Popper", ()=>Popper);
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _reactPopper = require("react-popper");
var _platformFeatureFlags = require("@atlaskit/platform-feature-flags");
var _maxSize = require("./max-size");
var _popperTopLayer = require("./popper-top-layer");
var _core = require("@popperjs/core");
const viewportPadding = 5;
const constantModifiers = [
    {
        name: 'flip',
        options: {
            flipVariations: false,
            padding: viewportPadding,
            boundary: 'clippingParents',
            rootBoundary: 'viewport'
        }
    }
];
function defaultChildrenFn() {
    return null;
}
const defaultOffset = [
    0,
    8
];
function Popper({ children, offset, placement, referenceElement, modifiers, strategy, shouldFitViewport }) {
    // The FF check sits at the very top of the public Popper so the
    // rest of the function (which has its own hooks) does not violate
    // the rules of hooks. Each branch is its own component with its
    // own complete hook order. Props are forwarded explicitly to
    // satisfy `no-unsafe-spread-props`.
    if ((0, _platformFeatureFlags.fg)('platform-dst-top-layer')) return /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _popperTopLayer.PopperTopLayer), {
        children: children,
        offset: offset,
        placement: placement,
        referenceElement: referenceElement,
        modifiers: modifiers,
        strategy: strategy,
        shouldFitViewport: shouldFitViewport
    });
    return /*#__PURE__*/ (0, _reactDefault.default).createElement(LegacyPopper, {
        children: children,
        offset: offset,
        placement: placement,
        referenceElement: referenceElement,
        modifiers: modifiers,
        strategy: strategy,
        shouldFitViewport: shouldFitViewport
    });
}
function LegacyPopper({ children = defaultChildrenFn, offset = defaultOffset, placement = 'bottom-start', referenceElement, modifiers, strategy = 'fixed', shouldFitViewport = false }) {
    const [offsetX, offsetY] = offset;
    const internalModifiers = (0, _react.useMemo)(()=>{
        const preventOverflowModifier = {
            name: 'preventOverflow',
            options: {
                padding: viewportPadding,
                rootBoundary: shouldFitViewport ? 'viewport' : 'document'
            }
        };
        const offsetModifier = {
            name: 'offset',
            options: {
                offset: [
                    offsetX,
                    offsetY
                ]
            }
        };
        const maxSizeModifiers = shouldFitViewport ? (0, _maxSize.getMaxSizeModifiers)({
            viewportPadding
        }) : [];
        // @ts-ignore Type errors from incompatible @popperjs/core versions between Jira and AFM Platform... we are using ts-ignore here because ts-expect-error will cause an "Unused '@ts-expect-error' directive." error
        return [
            ...constantModifiers,
            preventOverflowModifier,
            offsetModifier,
            ...maxSizeModifiers
        ];
    }, [
        offsetX,
        offsetY,
        shouldFitViewport
    ]);
    // Merge custom props and memoize
    const mergedModifiers = (0, _react.useMemo)(()=>{
        if (modifiers == null) return internalModifiers;
        return [
            ...internalModifiers,
            ...modifiers
        ];
    }, [
        internalModifiers,
        modifiers
    ]);
    return /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _reactPopper.Popper), {
        // @ts-expect-error - No overload matches this call
        // This error was introduced after upgrading to TypeScript 5
        modifiers: mergedModifiers,
        placement: placement,
        strategy: strategy,
        referenceElement: referenceElement
    }, children);
}

},{"react":"ltHCL","react-popper":"bGSxp","@atlaskit/platform-feature-flags":"8rD2i","./max-size":"dDoYp","./popper-top-layer":"dtZjg","@popperjs/core":false,"@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"bGSxp":[function(require,module,exports,__globalThis) {
// Public components
var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "Popper", ()=>(0, _popper.Popper)); // Public types
parcelHelpers.export(exports, "Manager", ()=>(0, _manager.Manager));
parcelHelpers.export(exports, "Reference", ()=>(0, _reference.Reference));
parcelHelpers.export(exports, "usePopper", ()=>(0, _usePopper.usePopper));
var _popper = require("./Popper");
var _manager = require("./Manager");
var _reference = require("./Reference");
var _usePopper = require("./usePopper");

},{"./Popper":"g9n8m","./Manager":"ltEqg","./Reference":"c68RF","./usePopper":false,"@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"g9n8m":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "Popper", ()=>Popper);
var _react = require("react");
var _manager = require("./Manager");
var _utils = require("./utils");
var _usePopper = require("./usePopper");
var NOOP = function NOOP() {
    return void 0;
};
var NOOP_PROMISE = function NOOP_PROMISE() {
    return Promise.resolve(null);
};
var EMPTY_MODIFIERS = [];
function Popper(_ref) {
    var _ref$placement = _ref.placement, placement = _ref$placement === void 0 ? 'bottom' : _ref$placement, _ref$strategy = _ref.strategy, strategy = _ref$strategy === void 0 ? 'absolute' : _ref$strategy, _ref$modifiers = _ref.modifiers, modifiers = _ref$modifiers === void 0 ? EMPTY_MODIFIERS : _ref$modifiers, referenceElement = _ref.referenceElement, onFirstUpdate = _ref.onFirstUpdate, innerRef = _ref.innerRef, children = _ref.children;
    var referenceNode = _react.useContext((0, _manager.ManagerReferenceNodeContext));
    var _React$useState = _react.useState(null), popperElement = _React$useState[0], setPopperElement = _React$useState[1];
    var _React$useState2 = _react.useState(null), arrowElement = _React$useState2[0], setArrowElement = _React$useState2[1];
    _react.useEffect(function() {
        (0, _utils.setRef)(innerRef, popperElement);
    }, [
        innerRef,
        popperElement
    ]);
    var options = _react.useMemo(function() {
        return {
            placement: placement,
            strategy: strategy,
            onFirstUpdate: onFirstUpdate,
            modifiers: [].concat(modifiers, [
                {
                    name: 'arrow',
                    enabled: arrowElement != null,
                    options: {
                        element: arrowElement
                    }
                }
            ])
        };
    }, [
        placement,
        strategy,
        onFirstUpdate,
        modifiers,
        arrowElement
    ]);
    var _usePopper1 = (0, _usePopper.usePopper)(referenceElement || referenceNode, popperElement, options), state = _usePopper1.state, styles = _usePopper1.styles, forceUpdate = _usePopper1.forceUpdate, update = _usePopper1.update;
    var childrenProps = _react.useMemo(function() {
        return {
            ref: setPopperElement,
            style: styles.popper,
            placement: state ? state.placement : placement,
            hasPopperEscaped: state && state.modifiersData.hide ? state.modifiersData.hide.hasPopperEscaped : null,
            isReferenceHidden: state && state.modifiersData.hide ? state.modifiersData.hide.isReferenceHidden : null,
            arrowProps: {
                style: styles.arrow,
                ref: setArrowElement
            },
            forceUpdate: forceUpdate || NOOP,
            update: update || NOOP_PROMISE
        };
    }, [
        setPopperElement,
        setArrowElement,
        placement,
        state,
        styles,
        update,
        forceUpdate
    ]);
    return (0, _utils.unwrapArray)(children)(childrenProps);
}

},{"react":"ltHCL","./Manager":"ltEqg","./utils":"9X8cu","./usePopper":"eTy54","@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"ltEqg":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "ManagerReferenceNodeContext", ()=>ManagerReferenceNodeContext);
parcelHelpers.export(exports, "ManagerReferenceNodeSetterContext", ()=>ManagerReferenceNodeSetterContext);
parcelHelpers.export(exports, "Manager", ()=>Manager);
var _react = require("react");
var ManagerReferenceNodeContext = _react.createContext();
var ManagerReferenceNodeSetterContext = _react.createContext();
function Manager(_ref) {
    var children = _ref.children;
    var _React$useState = _react.useState(null), referenceNode = _React$useState[0], setReferenceNode = _React$useState[1];
    var hasUnmounted = _react.useRef(false);
    _react.useEffect(function() {
        return function() {
            hasUnmounted.current = true;
        };
    }, []);
    var handleSetReferenceNode = _react.useCallback(function(node) {
        if (!hasUnmounted.current) setReferenceNode(node);
    }, []);
    return /*#__PURE__*/ _react.createElement(ManagerReferenceNodeContext.Provider, {
        value: referenceNode
    }, /*#__PURE__*/ _react.createElement(ManagerReferenceNodeSetterContext.Provider, {
        value: handleSetReferenceNode
    }, children));
}

},{"react":"ltHCL","@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"9X8cu":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "unwrapArray", ()=>unwrapArray);
parcelHelpers.export(exports, "safeInvoke", ()=>safeInvoke);
parcelHelpers.export(exports, "setRef", ()=>setRef);
parcelHelpers.export(exports, "fromEntries", ()=>fromEntries);
parcelHelpers.export(exports, "useIsomorphicLayoutEffect", ()=>useIsomorphicLayoutEffect);
var _react = require("react");
var unwrapArray = function unwrapArray(arg) {
    return Array.isArray(arg) ? arg[0] : arg;
};
var safeInvoke = function safeInvoke(fn) {
    if (typeof fn === 'function') {
        for(var _len = arguments.length, args = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++)args[_key - 1] = arguments[_key];
        return fn.apply(void 0, args);
    }
};
var setRef = function setRef(ref, node) {
    // if its a function call it
    if (typeof ref === 'function') return safeInvoke(ref, node);
    else if (ref != null) ref.current = node;
};
var fromEntries = function fromEntries(entries) {
    return entries.reduce(function(acc, _ref) {
        var key = _ref[0], value = _ref[1];
        acc[key] = value;
        return acc;
    }, {});
};
var useIsomorphicLayoutEffect = typeof window !== 'undefined' && window.document && window.document.createElement ? _react.useLayoutEffect : _react.useEffect;

},{"react":"ltHCL","@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"eTy54":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "usePopper", ()=>usePopper);
var _react = require("react");
var _reactDom = require("react-dom");
var _core = require("@popperjs/core");
var _reactFastCompare = require("react-fast-compare");
var _reactFastCompareDefault = parcelHelpers.interopDefault(_reactFastCompare);
var _utils = require("./utils");
var EMPTY_MODIFIERS = [];
var usePopper = function usePopper(referenceElement, popperElement, options) {
    if (options === void 0) options = {};
    var prevOptions = _react.useRef(null);
    var optionsWithDefaults = {
        onFirstUpdate: options.onFirstUpdate,
        placement: options.placement || 'bottom',
        strategy: options.strategy || 'absolute',
        modifiers: options.modifiers || EMPTY_MODIFIERS
    };
    var _React$useState = _react.useState({
        styles: {
            popper: {
                position: optionsWithDefaults.strategy,
                left: '0',
                top: '0'
            },
            arrow: {
                position: 'absolute'
            }
        },
        attributes: {}
    }), state = _React$useState[0], setState = _React$useState[1];
    var updateStateModifier = _react.useMemo(function() {
        return {
            name: 'updateState',
            enabled: true,
            phase: 'write',
            fn: function fn(_ref) {
                var state = _ref.state;
                var elements = Object.keys(state.elements);
                _reactDom.flushSync(function() {
                    setState({
                        styles: (0, _utils.fromEntries)(elements.map(function(element) {
                            return [
                                element,
                                state.styles[element] || {}
                            ];
                        })),
                        attributes: (0, _utils.fromEntries)(elements.map(function(element) {
                            return [
                                element,
                                state.attributes[element]
                            ];
                        }))
                    });
                });
            },
            requires: [
                'computeStyles'
            ]
        };
    }, []);
    var popperOptions = _react.useMemo(function() {
        var newOptions = {
            onFirstUpdate: optionsWithDefaults.onFirstUpdate,
            placement: optionsWithDefaults.placement,
            strategy: optionsWithDefaults.strategy,
            modifiers: [].concat(optionsWithDefaults.modifiers, [
                updateStateModifier,
                {
                    name: 'applyStyles',
                    enabled: false
                }
            ])
        };
        if ((0, _reactFastCompareDefault.default)(prevOptions.current, newOptions)) return prevOptions.current || newOptions;
        else {
            prevOptions.current = newOptions;
            return newOptions;
        }
    }, [
        optionsWithDefaults.onFirstUpdate,
        optionsWithDefaults.placement,
        optionsWithDefaults.strategy,
        optionsWithDefaults.modifiers,
        updateStateModifier
    ]);
    var popperInstanceRef = _react.useRef();
    (0, _utils.useIsomorphicLayoutEffect)(function() {
        if (popperInstanceRef.current) popperInstanceRef.current.setOptions(popperOptions);
    }, [
        popperOptions
    ]);
    (0, _utils.useIsomorphicLayoutEffect)(function() {
        if (referenceElement == null || popperElement == null) return;
        var createPopper = options.createPopper || (0, _core.createPopper);
        var popperInstance = createPopper(referenceElement, popperElement, popperOptions);
        popperInstanceRef.current = popperInstance;
        return function() {
            popperInstance.destroy();
            popperInstanceRef.current = null;
        };
    }, [
        referenceElement,
        popperElement,
        options.createPopper
    ]);
    return {
        state: popperInstanceRef.current ? popperInstanceRef.current.state : null,
        styles: state.styles,
        attributes: state.attributes,
        update: popperInstanceRef.current ? popperInstanceRef.current.update : null,
        forceUpdate: popperInstanceRef.current ? popperInstanceRef.current.forceUpdate : null
    };
};

},{"react":"ltHCL","react-dom":"7Lblg","@popperjs/core":"lQ6Il","react-fast-compare":"8GPFg","./utils":"9X8cu","@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"lQ6Il":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "popperGenerator", ()=>(0, _createPopperJs.popperGenerator)); // eslint-disable-next-line import/no-unused-modules
parcelHelpers.export(exports, "detectOverflow", ()=>(0, _createPopperJs.detectOverflow));
parcelHelpers.export(exports, "createPopperBase", ()=>(0, _createPopperJs.createPopper));
parcelHelpers.export(exports, "createPopper", ()=>(0, _popperJs.createPopper)); // eslint-disable-next-line import/no-unused-modules
parcelHelpers.export(exports, "createPopperLite", ()=>(0, _popperLiteJs.createPopper));
var _enumsJs = require("./enums.js");
parcelHelpers.exportAll(_enumsJs, exports);
var _indexJs = require // eslint-disable-next-line import/no-unused-modules
("./modifiers/index.js");
parcelHelpers.exportAll(_indexJs, exports);
var _createPopperJs = require("./createPopper.js");
var _popperJs = require("./popper.js");
var _popperLiteJs = require("./popper-lite.js");

},{"./enums.js":false,"./modifiers/index.js":false,"./createPopper.js":false,"./popper.js":"dOvVs","./popper-lite.js":false,"@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"1lwWm":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "top", ()=>top);
parcelHelpers.export(exports, "bottom", ()=>bottom);
parcelHelpers.export(exports, "right", ()=>right);
parcelHelpers.export(exports, "left", ()=>left);
parcelHelpers.export(exports, "auto", ()=>auto);
parcelHelpers.export(exports, "basePlacements", ()=>basePlacements);
parcelHelpers.export(exports, "start", ()=>start);
parcelHelpers.export(exports, "end", ()=>end);
parcelHelpers.export(exports, "clippingParents", ()=>clippingParents);
parcelHelpers.export(exports, "viewport", ()=>viewport);
parcelHelpers.export(exports, "popper", ()=>popper);
parcelHelpers.export(exports, "reference", ()=>reference);
parcelHelpers.export(exports, "variationPlacements", ()=>variationPlacements);
parcelHelpers.export(exports, "placements", ()=>placements);
parcelHelpers.export(exports, "beforeRead", ()=>beforeRead);
parcelHelpers.export(exports, "read", ()=>read);
parcelHelpers.export(exports, "afterRead", ()=>afterRead);
parcelHelpers.export(exports, "beforeMain", ()=>beforeMain);
parcelHelpers.export(exports, "main", ()=>main);
parcelHelpers.export(exports, "afterMain", ()=>afterMain);
parcelHelpers.export(exports, "beforeWrite", ()=>beforeWrite);
parcelHelpers.export(exports, "write", ()=>write);
parcelHelpers.export(exports, "afterWrite", ()=>afterWrite);
parcelHelpers.export(exports, "modifierPhases", ()=>modifierPhases);
var top = 'top';
var bottom = 'bottom';
var right = 'right';
var left = 'left';
var auto = 'auto';
var basePlacements = [
    top,
    bottom,
    right,
    left
];
var start = 'start';
var end = 'end';
var clippingParents = 'clippingParents';
var viewport = 'viewport';
var popper = 'popper';
var reference = 'reference';
var variationPlacements = /*#__PURE__*/ basePlacements.reduce(function(acc, placement) {
    return acc.concat([
        placement + "-" + start,
        placement + "-" + end
    ]);
}, []);
var placements = /*#__PURE__*/ [].concat(basePlacements, [
    auto
]).reduce(function(acc, placement) {
    return acc.concat([
        placement,
        placement + "-" + start,
        placement + "-" + end
    ]);
}, []); // modifiers that need to read the DOM
var beforeRead = 'beforeRead';
var read = 'read';
var afterRead = 'afterRead'; // pure-logic modifiers
var beforeMain = 'beforeMain';
var main = 'main';
var afterMain = 'afterMain'; // modifier with the purpose to write to the DOM (or write into a framework state)
var beforeWrite = 'beforeWrite';
var write = 'write';
var afterWrite = 'afterWrite';
var modifierPhases = [
    beforeRead,
    read,
    afterRead,
    beforeMain,
    main,
    afterMain,
    beforeWrite,
    write,
    afterWrite
];

},{"@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"fg8fT":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "popperGenerator", ()=>popperGenerator);
parcelHelpers.export(exports, "createPopper", ()=>createPopper);
parcelHelpers.export(exports, "detectOverflow", ()=>(0, _detectOverflowJsDefault.default));
var _getCompositeRectJs = require("./dom-utils/getCompositeRect.js");
var _getCompositeRectJsDefault = parcelHelpers.interopDefault(_getCompositeRectJs);
var _getLayoutRectJs = require("./dom-utils/getLayoutRect.js");
var _getLayoutRectJsDefault = parcelHelpers.interopDefault(_getLayoutRectJs);
var _listScrollParentsJs = require("./dom-utils/listScrollParents.js");
var _listScrollParentsJsDefault = parcelHelpers.interopDefault(_listScrollParentsJs);
var _getOffsetParentJs = require("./dom-utils/getOffsetParent.js");
var _getOffsetParentJsDefault = parcelHelpers.interopDefault(_getOffsetParentJs);
var _orderModifiersJs = require("./utils/orderModifiers.js");
var _orderModifiersJsDefault = parcelHelpers.interopDefault(_orderModifiersJs);
var _debounceJs = require("./utils/debounce.js");
var _debounceJsDefault = parcelHelpers.interopDefault(_debounceJs);
var _mergeByNameJs = require("./utils/mergeByName.js");
var _mergeByNameJsDefault = parcelHelpers.interopDefault(_mergeByNameJs);
var _detectOverflowJs = require("./utils/detectOverflow.js");
var _detectOverflowJsDefault = parcelHelpers.interopDefault(_detectOverflowJs);
var _instanceOfJs = require("./dom-utils/instanceOf.js");
var DEFAULT_OPTIONS = {
    placement: 'bottom',
    modifiers: [],
    strategy: 'absolute'
};
function areValidElements() {
    for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
    return !args.some(function(element) {
        return !(element && typeof element.getBoundingClientRect === 'function');
    });
}
function popperGenerator(generatorOptions) {
    if (generatorOptions === void 0) generatorOptions = {};
    var _generatorOptions = generatorOptions, _generatorOptions$def = _generatorOptions.defaultModifiers, defaultModifiers = _generatorOptions$def === void 0 ? [] : _generatorOptions$def, _generatorOptions$def2 = _generatorOptions.defaultOptions, defaultOptions = _generatorOptions$def2 === void 0 ? DEFAULT_OPTIONS : _generatorOptions$def2;
    return function createPopper(reference, popper, options) {
        if (options === void 0) options = defaultOptions;
        var state = {
            placement: 'bottom',
            orderedModifiers: [],
            options: Object.assign({}, DEFAULT_OPTIONS, defaultOptions),
            modifiersData: {},
            elements: {
                reference: reference,
                popper: popper
            },
            attributes: {},
            styles: {}
        };
        var effectCleanupFns = [];
        var isDestroyed = false;
        var instance = {
            state: state,
            setOptions: function setOptions(setOptionsAction) {
                var options = typeof setOptionsAction === 'function' ? setOptionsAction(state.options) : setOptionsAction;
                cleanupModifierEffects();
                state.options = Object.assign({}, defaultOptions, state.options, options);
                state.scrollParents = {
                    reference: (0, _instanceOfJs.isElement)(reference) ? (0, _listScrollParentsJsDefault.default)(reference) : reference.contextElement ? (0, _listScrollParentsJsDefault.default)(reference.contextElement) : [],
                    popper: (0, _listScrollParentsJsDefault.default)(popper)
                }; // Orders the modifiers based on their dependencies and `phase`
                // properties
                var orderedModifiers = (0, _orderModifiersJsDefault.default)((0, _mergeByNameJsDefault.default)([].concat(defaultModifiers, state.options.modifiers))); // Strip out disabled modifiers
                state.orderedModifiers = orderedModifiers.filter(function(m) {
                    return m.enabled;
                });
                runModifierEffects();
                return instance.update();
            },
            // Sync update – it will always be executed, even if not necessary. This
            // is useful for low frequency updates where sync behavior simplifies the
            // logic.
            // For high frequency updates (e.g. `resize` and `scroll` events), always
            // prefer the async Popper#update method
            forceUpdate: function forceUpdate() {
                if (isDestroyed) return;
                var _state$elements = state.elements, reference = _state$elements.reference, popper = _state$elements.popper; // Don't proceed if `reference` or `popper` are not valid elements
                // anymore
                if (!areValidElements(reference, popper)) return;
                 // Store the reference and popper rects to be read by modifiers
                state.rects = {
                    reference: (0, _getCompositeRectJsDefault.default)(reference, (0, _getOffsetParentJsDefault.default)(popper), state.options.strategy === 'fixed'),
                    popper: (0, _getLayoutRectJsDefault.default)(popper)
                }; // Modifiers have the ability to reset the current update cycle. The
                // most common use case for this is the `flip` modifier changing the
                // placement, which then needs to re-run all the modifiers, because the
                // logic was previously ran for the previous placement and is therefore
                // stale/incorrect
                state.reset = false;
                state.placement = state.options.placement; // On each update cycle, the `modifiersData` property for each modifier
                // is filled with the initial data specified by the modifier. This means
                // it doesn't persist and is fresh on each update.
                // To ensure persistent data, use `${name}#persistent`
                state.orderedModifiers.forEach(function(modifier) {
                    return state.modifiersData[modifier.name] = Object.assign({}, modifier.data);
                });
                for(var index = 0; index < state.orderedModifiers.length; index++){
                    if (state.reset === true) {
                        state.reset = false;
                        index = -1;
                        continue;
                    }
                    var _state$orderedModifie = state.orderedModifiers[index], fn = _state$orderedModifie.fn, _state$orderedModifie2 = _state$orderedModifie.options, _options = _state$orderedModifie2 === void 0 ? {} : _state$orderedModifie2, name = _state$orderedModifie.name;
                    if (typeof fn === 'function') state = fn({
                        state: state,
                        options: _options,
                        name: name,
                        instance: instance
                    }) || state;
                }
            },
            // Async and optimistically optimized update – it will not be executed if
            // not necessary (debounced to run at most once-per-tick)
            update: (0, _debounceJsDefault.default)(function() {
                return new Promise(function(resolve) {
                    instance.forceUpdate();
                    resolve(state);
                });
            }),
            destroy: function destroy() {
                cleanupModifierEffects();
                isDestroyed = true;
            }
        };
        if (!areValidElements(reference, popper)) return instance;
        instance.setOptions(options).then(function(state) {
            if (!isDestroyed && options.onFirstUpdate) options.onFirstUpdate(state);
        }); // Modifiers have the ability to execute arbitrary code before the first
        // update cycle runs. They will be executed in the same order as the update
        // cycle. This is useful when a modifier adds some persistent data that
        // other modifiers need to use, but the modifier is run after the dependent
        // one.
        function runModifierEffects() {
            state.orderedModifiers.forEach(function(_ref) {
                var name = _ref.name, _ref$options = _ref.options, options = _ref$options === void 0 ? {} : _ref$options, effect = _ref.effect;
                if (typeof effect === 'function') {
                    var cleanupFn = effect({
                        state: state,
                        name: name,
                        instance: instance,
                        options: options
                    });
                    var noopFn = function noopFn() {};
                    effectCleanupFns.push(cleanupFn || noopFn);
                }
            });
        }
        function cleanupModifierEffects() {
            effectCleanupFns.forEach(function(fn) {
                return fn();
            });
            effectCleanupFns = [];
        }
        return instance;
    };
}
var createPopper = /*#__PURE__*/ popperGenerator(); // eslint-disable-next-line import/no-unused-modules

},{"./dom-utils/getCompositeRect.js":"Enf03","./dom-utils/getLayoutRect.js":"8pwV1","./dom-utils/listScrollParents.js":"8lPAs","./dom-utils/getOffsetParent.js":"eIa18","./utils/orderModifiers.js":"5CPmb","./utils/debounce.js":"e8ZGY","./utils/mergeByName.js":"arn2H","./utils/detectOverflow.js":false,"./dom-utils/instanceOf.js":"qMR4O","@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"Enf03":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>getCompositeRect);
var _getBoundingClientRectJs = require("./getBoundingClientRect.js");
var _getBoundingClientRectJsDefault = parcelHelpers.interopDefault(_getBoundingClientRectJs);
var _getNodeScrollJs = require("./getNodeScroll.js");
var _getNodeScrollJsDefault = parcelHelpers.interopDefault(_getNodeScrollJs);
var _getNodeNameJs = require("./getNodeName.js");
var _getNodeNameJsDefault = parcelHelpers.interopDefault(_getNodeNameJs);
var _instanceOfJs = require("./instanceOf.js");
var _getWindowScrollBarXJs = require("./getWindowScrollBarX.js");
var _getWindowScrollBarXJsDefault = parcelHelpers.interopDefault(_getWindowScrollBarXJs);
var _getDocumentElementJs = require("./getDocumentElement.js");
var _getDocumentElementJsDefault = parcelHelpers.interopDefault(_getDocumentElementJs);
var _isScrollParentJs = require("./isScrollParent.js");
var _isScrollParentJsDefault = parcelHelpers.interopDefault(_isScrollParentJs);
var _mathJs = require("../utils/math.js");
function isElementScaled(element) {
    var rect = element.getBoundingClientRect();
    var scaleX = (0, _mathJs.round)(rect.width) / element.offsetWidth || 1;
    var scaleY = (0, _mathJs.round)(rect.height) / element.offsetHeight || 1;
    return scaleX !== 1 || scaleY !== 1;
} // Returns the composite rect of an element relative to its offsetParent.
function getCompositeRect(elementOrVirtualElement, offsetParent, isFixed) {
    if (isFixed === void 0) isFixed = false;
    var isOffsetParentAnElement = (0, _instanceOfJs.isHTMLElement)(offsetParent);
    var offsetParentIsScaled = (0, _instanceOfJs.isHTMLElement)(offsetParent) && isElementScaled(offsetParent);
    var documentElement = (0, _getDocumentElementJsDefault.default)(offsetParent);
    var rect = (0, _getBoundingClientRectJsDefault.default)(elementOrVirtualElement, offsetParentIsScaled, isFixed);
    var scroll = {
        scrollLeft: 0,
        scrollTop: 0
    };
    var offsets = {
        x: 0,
        y: 0
    };
    if (isOffsetParentAnElement || !isOffsetParentAnElement && !isFixed) {
        if ((0, _getNodeNameJsDefault.default)(offsetParent) !== 'body' || // https://github.com/popperjs/popper-core/issues/1078
        (0, _isScrollParentJsDefault.default)(documentElement)) scroll = (0, _getNodeScrollJsDefault.default)(offsetParent);
        if ((0, _instanceOfJs.isHTMLElement)(offsetParent)) {
            offsets = (0, _getBoundingClientRectJsDefault.default)(offsetParent, true);
            offsets.x += offsetParent.clientLeft;
            offsets.y += offsetParent.clientTop;
        } else if (documentElement) offsets.x = (0, _getWindowScrollBarXJsDefault.default)(documentElement);
    }
    return {
        x: rect.left + scroll.scrollLeft - offsets.x,
        y: rect.top + scroll.scrollTop - offsets.y,
        width: rect.width,
        height: rect.height
    };
}

},{"./getBoundingClientRect.js":"iNomO","./getNodeScroll.js":"jZhQ2","./getNodeName.js":"iwIho","./instanceOf.js":"qMR4O","./getWindowScrollBarX.js":"6tSvX","./getDocumentElement.js":"5KI4G","./isScrollParent.js":"3Easg","../utils/math.js":"9Qz9r","@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"iNomO":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>getBoundingClientRect);
var _instanceOfJs = require("./instanceOf.js");
var _mathJs = require("../utils/math.js");
var _getWindowJs = require("./getWindow.js");
var _getWindowJsDefault = parcelHelpers.interopDefault(_getWindowJs);
var _isLayoutViewportJs = require("./isLayoutViewport.js");
var _isLayoutViewportJsDefault = parcelHelpers.interopDefault(_isLayoutViewportJs);
function getBoundingClientRect(element, includeScale, isFixedStrategy) {
    if (includeScale === void 0) includeScale = false;
    if (isFixedStrategy === void 0) isFixedStrategy = false;
    var clientRect = element.getBoundingClientRect();
    var scaleX = 1;
    var scaleY = 1;
    if (includeScale && (0, _instanceOfJs.isHTMLElement)(element)) {
        scaleX = element.offsetWidth > 0 ? (0, _mathJs.round)(clientRect.width) / element.offsetWidth || 1 : 1;
        scaleY = element.offsetHeight > 0 ? (0, _mathJs.round)(clientRect.height) / element.offsetHeight || 1 : 1;
    }
    var _ref = (0, _instanceOfJs.isElement)(element) ? (0, _getWindowJsDefault.default)(element) : window, visualViewport = _ref.visualViewport;
    var addVisualOffsets = !(0, _isLayoutViewportJsDefault.default)() && isFixedStrategy;
    var x = (clientRect.left + (addVisualOffsets && visualViewport ? visualViewport.offsetLeft : 0)) / scaleX;
    var y = (clientRect.top + (addVisualOffsets && visualViewport ? visualViewport.offsetTop : 0)) / scaleY;
    var width = clientRect.width / scaleX;
    var height = clientRect.height / scaleY;
    return {
        width: width,
        height: height,
        top: y,
        right: x + width,
        bottom: y + height,
        left: x,
        x: x,
        y: y
    };
}

},{"./instanceOf.js":"qMR4O","../utils/math.js":"9Qz9r","./getWindow.js":"iIOiw","./isLayoutViewport.js":"2i0W9","@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"qMR4O":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "isElement", ()=>isElement);
parcelHelpers.export(exports, "isHTMLElement", ()=>isHTMLElement);
parcelHelpers.export(exports, "isShadowRoot", ()=>isShadowRoot);
var _getWindowJs = require("./getWindow.js");
var _getWindowJsDefault = parcelHelpers.interopDefault(_getWindowJs);
function isElement(node) {
    var OwnElement = (0, _getWindowJsDefault.default)(node).Element;
    return node instanceof OwnElement || node instanceof Element;
}
function isHTMLElement(node) {
    var OwnElement = (0, _getWindowJsDefault.default)(node).HTMLElement;
    return node instanceof OwnElement || node instanceof HTMLElement;
}
function isShadowRoot(node) {
    // IE 11 has no ShadowRoot
    if (typeof ShadowRoot === 'undefined') return false;
    var OwnElement = (0, _getWindowJsDefault.default)(node).ShadowRoot;
    return node instanceof OwnElement || node instanceof ShadowRoot;
}

},{"./getWindow.js":"iIOiw","@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"iIOiw":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>getWindow);
function getWindow(node) {
    if (node == null) return window;
    if (node.toString() !== '[object Window]') {
        var ownerDocument = node.ownerDocument;
        return ownerDocument ? ownerDocument.defaultView || window : window;
    }
    return node;
}

},{"@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"9Qz9r":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "max", ()=>max);
parcelHelpers.export(exports, "min", ()=>min);
parcelHelpers.export(exports, "round", ()=>round);
var max = Math.max;
var min = Math.min;
var round = Math.round;

},{"@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"2i0W9":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>isLayoutViewport);
var _userAgentJs = require("../utils/userAgent.js");
var _userAgentJsDefault = parcelHelpers.interopDefault(_userAgentJs);
function isLayoutViewport() {
    return !/^((?!chrome|android).)*safari/i.test((0, _userAgentJsDefault.default)());
}

},{"../utils/userAgent.js":"6VLDh","@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"6VLDh":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>getUAString);
function getUAString() {
    var uaData = navigator.userAgentData;
    if (uaData != null && uaData.brands && Array.isArray(uaData.brands)) return uaData.brands.map(function(item) {
        return item.brand + "/" + item.version;
    }).join(' ');
    return navigator.userAgent;
}

},{"@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"jZhQ2":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>getNodeScroll);
var _getWindowScrollJs = require("./getWindowScroll.js");
var _getWindowScrollJsDefault = parcelHelpers.interopDefault(_getWindowScrollJs);
var _getWindowJs = require("./getWindow.js");
var _getWindowJsDefault = parcelHelpers.interopDefault(_getWindowJs);
var _instanceOfJs = require("./instanceOf.js");
var _getHTMLElementScrollJs = require("./getHTMLElementScroll.js");
var _getHTMLElementScrollJsDefault = parcelHelpers.interopDefault(_getHTMLElementScrollJs);
function getNodeScroll(node) {
    if (node === (0, _getWindowJsDefault.default)(node) || !(0, _instanceOfJs.isHTMLElement)(node)) return (0, _getWindowScrollJsDefault.default)(node);
    else return (0, _getHTMLElementScrollJsDefault.default)(node);
}

},{"./getWindowScroll.js":"7FUFj","./getWindow.js":"iIOiw","./instanceOf.js":"qMR4O","./getHTMLElementScroll.js":"gcXl1","@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"7FUFj":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>getWindowScroll);
var _getWindowJs = require("./getWindow.js");
var _getWindowJsDefault = parcelHelpers.interopDefault(_getWindowJs);
function getWindowScroll(node) {
    var win = (0, _getWindowJsDefault.default)(node);
    var scrollLeft = win.pageXOffset;
    var scrollTop = win.pageYOffset;
    return {
        scrollLeft: scrollLeft,
        scrollTop: scrollTop
    };
}

},{"./getWindow.js":"iIOiw","@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"gcXl1":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>getHTMLElementScroll);
function getHTMLElementScroll(element) {
    return {
        scrollLeft: element.scrollLeft,
        scrollTop: element.scrollTop
    };
}

},{"@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"iwIho":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>getNodeName);
function getNodeName(element) {
    return element ? (element.nodeName || '').toLowerCase() : null;
}

},{"@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"6tSvX":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>getWindowScrollBarX);
var _getBoundingClientRectJs = require("./getBoundingClientRect.js");
var _getBoundingClientRectJsDefault = parcelHelpers.interopDefault(_getBoundingClientRectJs);
var _getDocumentElementJs = require("./getDocumentElement.js");
var _getDocumentElementJsDefault = parcelHelpers.interopDefault(_getDocumentElementJs);
var _getWindowScrollJs = require("./getWindowScroll.js");
var _getWindowScrollJsDefault = parcelHelpers.interopDefault(_getWindowScrollJs);
function getWindowScrollBarX(element) {
    // If <html> has a CSS width greater than the viewport, then this will be
    // incorrect for RTL.
    // Popper 1 is broken in this case and never had a bug report so let's assume
    // it's not an issue. I don't think anyone ever specifies width on <html>
    // anyway.
    // Browsers where the left scrollbar doesn't cause an issue report `0` for
    // this (e.g. Edge 2019, IE11, Safari)
    return (0, _getBoundingClientRectJsDefault.default)((0, _getDocumentElementJsDefault.default)(element)).left + (0, _getWindowScrollJsDefault.default)(element).scrollLeft;
}

},{"./getBoundingClientRect.js":"iNomO","./getDocumentElement.js":"5KI4G","./getWindowScroll.js":"7FUFj","@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"5KI4G":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>getDocumentElement);
var _instanceOfJs = require("./instanceOf.js");
function getDocumentElement(element) {
    // $FlowFixMe[incompatible-return]: assume body is always available
    return (((0, _instanceOfJs.isElement)(element) ? element.ownerDocument : element.document) || window.document).documentElement;
}

},{"./instanceOf.js":"qMR4O","@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"3Easg":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>isScrollParent);
var _getComputedStyleJs = require("./getComputedStyle.js");
var _getComputedStyleJsDefault = parcelHelpers.interopDefault(_getComputedStyleJs);
function isScrollParent(element) {
    // Firefox wants us to check `-x` and `-y` variations as well
    var _getComputedStyle = (0, _getComputedStyleJsDefault.default)(element), overflow = _getComputedStyle.overflow, overflowX = _getComputedStyle.overflowX, overflowY = _getComputedStyle.overflowY;
    return /auto|scroll|overlay|hidden/.test(overflow + overflowY + overflowX);
}

},{"./getComputedStyle.js":"eoRQF","@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"eoRQF":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>getComputedStyle);
var _getWindowJs = require("./getWindow.js");
var _getWindowJsDefault = parcelHelpers.interopDefault(_getWindowJs);
function getComputedStyle(element) {
    return (0, _getWindowJsDefault.default)(element).getComputedStyle(element);
}

},{"./getWindow.js":"iIOiw","@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"8pwV1":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>getLayoutRect);
var _getBoundingClientRectJs = require // Returns the layout rect of an element relative to its offsetParent. Layout
("./getBoundingClientRect.js");
var _getBoundingClientRectJsDefault = parcelHelpers.interopDefault(_getBoundingClientRectJs);
function getLayoutRect(element) {
    var clientRect = (0, _getBoundingClientRectJsDefault.default)(element); // Use the clientRect sizes if it's not been transformed.
    // Fixes https://github.com/popperjs/popper-core/issues/1223
    var width = element.offsetWidth;
    var height = element.offsetHeight;
    if (Math.abs(clientRect.width - width) <= 1) width = clientRect.width;
    if (Math.abs(clientRect.height - height) <= 1) height = clientRect.height;
    return {
        x: element.offsetLeft,
        y: element.offsetTop,
        width: width,
        height: height
    };
}

},{"./getBoundingClientRect.js":"iNomO","@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"8lPAs":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>listScrollParents);
var _getScrollParentJs = require("./getScrollParent.js");
var _getScrollParentJsDefault = parcelHelpers.interopDefault(_getScrollParentJs);
var _getParentNodeJs = require("./getParentNode.js");
var _getParentNodeJsDefault = parcelHelpers.interopDefault(_getParentNodeJs);
var _getWindowJs = require("./getWindow.js");
var _getWindowJsDefault = parcelHelpers.interopDefault(_getWindowJs);
var _isScrollParentJs = require("./isScrollParent.js");
var _isScrollParentJsDefault = parcelHelpers.interopDefault(_isScrollParentJs);
function listScrollParents(element, list) {
    var _element$ownerDocumen;
    if (list === void 0) list = [];
    var scrollParent = (0, _getScrollParentJsDefault.default)(element);
    var isBody = scrollParent === ((_element$ownerDocumen = element.ownerDocument) == null ? void 0 : _element$ownerDocumen.body);
    var win = (0, _getWindowJsDefault.default)(scrollParent);
    var target = isBody ? [
        win
    ].concat(win.visualViewport || [], (0, _isScrollParentJsDefault.default)(scrollParent) ? scrollParent : []) : scrollParent;
    var updatedList = list.concat(target);
    return isBody ? updatedList : updatedList.concat(listScrollParents((0, _getParentNodeJsDefault.default)(target)));
}

},{"./getScrollParent.js":"jAvRf","./getParentNode.js":"1WvAu","./getWindow.js":"iIOiw","./isScrollParent.js":"3Easg","@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"jAvRf":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>getScrollParent);
var _getParentNodeJs = require("./getParentNode.js");
var _getParentNodeJsDefault = parcelHelpers.interopDefault(_getParentNodeJs);
var _isScrollParentJs = require("./isScrollParent.js");
var _isScrollParentJsDefault = parcelHelpers.interopDefault(_isScrollParentJs);
var _getNodeNameJs = require("./getNodeName.js");
var _getNodeNameJsDefault = parcelHelpers.interopDefault(_getNodeNameJs);
var _instanceOfJs = require("./instanceOf.js");
function getScrollParent(node) {
    if ([
        'html',
        'body',
        '#document'
    ].indexOf((0, _getNodeNameJsDefault.default)(node)) >= 0) // $FlowFixMe[incompatible-return]: assume body is always available
    return node.ownerDocument.body;
    if ((0, _instanceOfJs.isHTMLElement)(node) && (0, _isScrollParentJsDefault.default)(node)) return node;
    return getScrollParent((0, _getParentNodeJsDefault.default)(node));
}

},{"./getParentNode.js":"1WvAu","./isScrollParent.js":"3Easg","./getNodeName.js":"iwIho","./instanceOf.js":"qMR4O","@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"1WvAu":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>getParentNode);
var _getNodeNameJs = require("./getNodeName.js");
var _getNodeNameJsDefault = parcelHelpers.interopDefault(_getNodeNameJs);
var _getDocumentElementJs = require("./getDocumentElement.js");
var _getDocumentElementJsDefault = parcelHelpers.interopDefault(_getDocumentElementJs);
var _instanceOfJs = require("./instanceOf.js");
function getParentNode(element) {
    if ((0, _getNodeNameJsDefault.default)(element) === 'html') return element;
    return(// $FlowFixMe[incompatible-return]
    // $FlowFixMe[prop-missing]
    element.assignedSlot || // step into the shadow DOM of the parent of a slotted node
    element.parentNode || ((0, _instanceOfJs.isShadowRoot)(element) ? element.host : null) || // ShadowRoot detected
    // $FlowFixMe[incompatible-call]: HTMLElement is a Node
    (0, _getDocumentElementJsDefault.default)(element) // fallback
    );
}

},{"./getNodeName.js":"iwIho","./getDocumentElement.js":"5KI4G","./instanceOf.js":"qMR4O","@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"eIa18":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>getOffsetParent);
var _getWindowJs = require("./getWindow.js");
var _getWindowJsDefault = parcelHelpers.interopDefault(_getWindowJs);
var _getNodeNameJs = require("./getNodeName.js");
var _getNodeNameJsDefault = parcelHelpers.interopDefault(_getNodeNameJs);
var _getComputedStyleJs = require("./getComputedStyle.js");
var _getComputedStyleJsDefault = parcelHelpers.interopDefault(_getComputedStyleJs);
var _instanceOfJs = require("./instanceOf.js");
var _isTableElementJs = require("./isTableElement.js");
var _isTableElementJsDefault = parcelHelpers.interopDefault(_isTableElementJs);
var _getParentNodeJs = require("./getParentNode.js");
var _getParentNodeJsDefault = parcelHelpers.interopDefault(_getParentNodeJs);
var _userAgentJs = require("../utils/userAgent.js");
var _userAgentJsDefault = parcelHelpers.interopDefault(_userAgentJs);
function getTrueOffsetParent(element) {
    if (!(0, _instanceOfJs.isHTMLElement)(element) || // https://github.com/popperjs/popper-core/issues/837
    (0, _getComputedStyleJsDefault.default)(element).position === 'fixed') return null;
    return element.offsetParent;
} // `.offsetParent` reports `null` for fixed elements, while absolute elements
// return the containing block
function getContainingBlock(element) {
    var isFirefox = /firefox/i.test((0, _userAgentJsDefault.default)());
    var isIE = /Trident/i.test((0, _userAgentJsDefault.default)());
    if (isIE && (0, _instanceOfJs.isHTMLElement)(element)) {
        // In IE 9, 10 and 11 fixed elements containing block is always established by the viewport
        var elementCss = (0, _getComputedStyleJsDefault.default)(element);
        if (elementCss.position === 'fixed') return null;
    }
    var currentNode = (0, _getParentNodeJsDefault.default)(element);
    if ((0, _instanceOfJs.isShadowRoot)(currentNode)) currentNode = currentNode.host;
    while((0, _instanceOfJs.isHTMLElement)(currentNode) && [
        'html',
        'body'
    ].indexOf((0, _getNodeNameJsDefault.default)(currentNode)) < 0){
        var css = (0, _getComputedStyleJsDefault.default)(currentNode); // This is non-exhaustive but covers the most common CSS properties that
        // create a containing block.
        // https://developer.mozilla.org/en-US/docs/Web/CSS/Containing_block#identifying_the_containing_block
        if (css.transform !== 'none' || css.perspective !== 'none' || css.contain === 'paint' || [
            'transform',
            'perspective'
        ].indexOf(css.willChange) !== -1 || isFirefox && css.willChange === 'filter' || isFirefox && css.filter && css.filter !== 'none') return currentNode;
        else currentNode = currentNode.parentNode;
    }
    return null;
} // Gets the closest ancestor positioned element. Handles some edge cases,
function getOffsetParent(element) {
    var window = (0, _getWindowJsDefault.default)(element);
    var offsetParent = getTrueOffsetParent(element);
    while(offsetParent && (0, _isTableElementJsDefault.default)(offsetParent) && (0, _getComputedStyleJsDefault.default)(offsetParent).position === 'static')offsetParent = getTrueOffsetParent(offsetParent);
    if (offsetParent && ((0, _getNodeNameJsDefault.default)(offsetParent) === 'html' || (0, _getNodeNameJsDefault.default)(offsetParent) === 'body' && (0, _getComputedStyleJsDefault.default)(offsetParent).position === 'static')) return window;
    return offsetParent || getContainingBlock(element) || window;
}

},{"./getWindow.js":"iIOiw","./getNodeName.js":"iwIho","./getComputedStyle.js":"eoRQF","./instanceOf.js":"qMR4O","./isTableElement.js":"4TvaP","./getParentNode.js":"1WvAu","../utils/userAgent.js":"6VLDh","@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"4TvaP":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>isTableElement);
var _getNodeNameJs = require("./getNodeName.js");
var _getNodeNameJsDefault = parcelHelpers.interopDefault(_getNodeNameJs);
function isTableElement(element) {
    return [
        'table',
        'td',
        'th'
    ].indexOf((0, _getNodeNameJsDefault.default)(element)) >= 0;
}

},{"./getNodeName.js":"iwIho","@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"5CPmb":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>orderModifiers);
var _enumsJs = require // source: https://stackoverflow.com/questions/49875255
("../enums.js");
function order(modifiers) {
    var map = new Map();
    var visited = new Set();
    var result = [];
    modifiers.forEach(function(modifier) {
        map.set(modifier.name, modifier);
    }); // On visiting object, check for its dependencies and visit them recursively
    function sort(modifier) {
        visited.add(modifier.name);
        var requires = [].concat(modifier.requires || [], modifier.requiresIfExists || []);
        requires.forEach(function(dep) {
            if (!visited.has(dep)) {
                var depModifier = map.get(dep);
                if (depModifier) sort(depModifier);
            }
        });
        result.push(modifier);
    }
    modifiers.forEach(function(modifier) {
        if (!visited.has(modifier.name)) // check for visited object
        sort(modifier);
    });
    return result;
}
function orderModifiers(modifiers) {
    // order based on dependencies
    var orderedModifiers = order(modifiers); // order based on phase
    return (0, _enumsJs.modifierPhases).reduce(function(acc, phase) {
        return acc.concat(orderedModifiers.filter(function(modifier) {
            return modifier.phase === phase;
        }));
    }, []);
}

},{"../enums.js":"1lwWm","@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"e8ZGY":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>debounce);
function debounce(fn) {
    var pending;
    return function() {
        if (!pending) pending = new Promise(function(resolve) {
            Promise.resolve().then(function() {
                pending = undefined;
                resolve(fn());
            });
        });
        return pending;
    };
}

},{"@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"arn2H":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>mergeByName);
function mergeByName(modifiers) {
    var merged = modifiers.reduce(function(merged, current) {
        var existing = merged[current.name];
        merged[current.name] = existing ? Object.assign({}, existing, current, {
            options: Object.assign({}, existing.options, current.options),
            data: Object.assign({}, existing.data, current.data)
        }) : current;
        return merged;
    }, {}); // IE11 does not support Object.values
    return Object.keys(merged).map(function(key) {
        return merged[key];
    });
}

},{"@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"a7bOO":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>detectOverflow);
var _getClippingRectJs = require("../dom-utils/getClippingRect.js");
var _getClippingRectJsDefault = parcelHelpers.interopDefault(_getClippingRectJs);
var _getDocumentElementJs = require("../dom-utils/getDocumentElement.js");
var _getDocumentElementJsDefault = parcelHelpers.interopDefault(_getDocumentElementJs);
var _getBoundingClientRectJs = require("../dom-utils/getBoundingClientRect.js");
var _getBoundingClientRectJsDefault = parcelHelpers.interopDefault(_getBoundingClientRectJs);
var _computeOffsetsJs = require("./computeOffsets.js");
var _computeOffsetsJsDefault = parcelHelpers.interopDefault(_computeOffsetsJs);
var _rectToClientRectJs = require("./rectToClientRect.js");
var _rectToClientRectJsDefault = parcelHelpers.interopDefault(_rectToClientRectJs);
var _enumsJs = require("../enums.js");
var _instanceOfJs = require("../dom-utils/instanceOf.js");
var _mergePaddingObjectJs = require("./mergePaddingObject.js");
var _mergePaddingObjectJsDefault = parcelHelpers.interopDefault(_mergePaddingObjectJs);
var _expandToHashMapJs = require // eslint-disable-next-line import/no-unused-modules
("./expandToHashMap.js");
var _expandToHashMapJsDefault = parcelHelpers.interopDefault(_expandToHashMapJs);
function detectOverflow(state, options) {
    if (options === void 0) options = {};
    var _options = options, _options$placement = _options.placement, placement = _options$placement === void 0 ? state.placement : _options$placement, _options$strategy = _options.strategy, strategy = _options$strategy === void 0 ? state.strategy : _options$strategy, _options$boundary = _options.boundary, boundary = _options$boundary === void 0 ? (0, _enumsJs.clippingParents) : _options$boundary, _options$rootBoundary = _options.rootBoundary, rootBoundary = _options$rootBoundary === void 0 ? (0, _enumsJs.viewport) : _options$rootBoundary, _options$elementConte = _options.elementContext, elementContext = _options$elementConte === void 0 ? (0, _enumsJs.popper) : _options$elementConte, _options$altBoundary = _options.altBoundary, altBoundary = _options$altBoundary === void 0 ? false : _options$altBoundary, _options$padding = _options.padding, padding = _options$padding === void 0 ? 0 : _options$padding;
    var paddingObject = (0, _mergePaddingObjectJsDefault.default)(typeof padding !== 'number' ? padding : (0, _expandToHashMapJsDefault.default)(padding, (0, _enumsJs.basePlacements)));
    var altContext = elementContext === (0, _enumsJs.popper) ? (0, _enumsJs.reference) : (0, _enumsJs.popper);
    var popperRect = state.rects.popper;
    var element = state.elements[altBoundary ? altContext : elementContext];
    var clippingClientRect = (0, _getClippingRectJsDefault.default)((0, _instanceOfJs.isElement)(element) ? element : element.contextElement || (0, _getDocumentElementJsDefault.default)(state.elements.popper), boundary, rootBoundary, strategy);
    var referenceClientRect = (0, _getBoundingClientRectJsDefault.default)(state.elements.reference);
    var popperOffsets = (0, _computeOffsetsJsDefault.default)({
        reference: referenceClientRect,
        element: popperRect,
        strategy: 'absolute',
        placement: placement
    });
    var popperClientRect = (0, _rectToClientRectJsDefault.default)(Object.assign({}, popperRect, popperOffsets));
    var elementClientRect = elementContext === (0, _enumsJs.popper) ? popperClientRect : referenceClientRect; // positive = overflowing the clipping rect
    // 0 or negative = within the clipping rect
    var overflowOffsets = {
        top: clippingClientRect.top - elementClientRect.top + paddingObject.top,
        bottom: elementClientRect.bottom - clippingClientRect.bottom + paddingObject.bottom,
        left: clippingClientRect.left - elementClientRect.left + paddingObject.left,
        right: elementClientRect.right - clippingClientRect.right + paddingObject.right
    };
    var offsetData = state.modifiersData.offset; // Offsets can be applied only to the popper element
    if (elementContext === (0, _enumsJs.popper) && offsetData) {
        var offset = offsetData[placement];
        Object.keys(overflowOffsets).forEach(function(key) {
            var multiply = [
                (0, _enumsJs.right),
                (0, _enumsJs.bottom)
            ].indexOf(key) >= 0 ? 1 : -1;
            var axis = [
                (0, _enumsJs.top),
                (0, _enumsJs.bottom)
            ].indexOf(key) >= 0 ? 'y' : 'x';
            overflowOffsets[key] += offset[axis] * multiply;
        });
    }
    return overflowOffsets;
}

},{"../dom-utils/getClippingRect.js":"jg7fG","../dom-utils/getDocumentElement.js":"5KI4G","../dom-utils/getBoundingClientRect.js":"iNomO","./computeOffsets.js":"1VqQs","./rectToClientRect.js":"decNn","../enums.js":"1lwWm","../dom-utils/instanceOf.js":"qMR4O","./mergePaddingObject.js":"7STG4","./expandToHashMap.js":"4p7fS","@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"jg7fG":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>getClippingRect);
var _enumsJs = require("../enums.js");
var _getViewportRectJs = require("./getViewportRect.js");
var _getViewportRectJsDefault = parcelHelpers.interopDefault(_getViewportRectJs);
var _getDocumentRectJs = require("./getDocumentRect.js");
var _getDocumentRectJsDefault = parcelHelpers.interopDefault(_getDocumentRectJs);
var _listScrollParentsJs = require("./listScrollParents.js");
var _listScrollParentsJsDefault = parcelHelpers.interopDefault(_listScrollParentsJs);
var _getOffsetParentJs = require("./getOffsetParent.js");
var _getOffsetParentJsDefault = parcelHelpers.interopDefault(_getOffsetParentJs);
var _getDocumentElementJs = require("./getDocumentElement.js");
var _getDocumentElementJsDefault = parcelHelpers.interopDefault(_getDocumentElementJs);
var _getComputedStyleJs = require("./getComputedStyle.js");
var _getComputedStyleJsDefault = parcelHelpers.interopDefault(_getComputedStyleJs);
var _instanceOfJs = require("./instanceOf.js");
var _getBoundingClientRectJs = require("./getBoundingClientRect.js");
var _getBoundingClientRectJsDefault = parcelHelpers.interopDefault(_getBoundingClientRectJs);
var _getParentNodeJs = require("./getParentNode.js");
var _getParentNodeJsDefault = parcelHelpers.interopDefault(_getParentNodeJs);
var _containsJs = require("./contains.js");
var _containsJsDefault = parcelHelpers.interopDefault(_containsJs);
var _getNodeNameJs = require("./getNodeName.js");
var _getNodeNameJsDefault = parcelHelpers.interopDefault(_getNodeNameJs);
var _rectToClientRectJs = require("../utils/rectToClientRect.js");
var _rectToClientRectJsDefault = parcelHelpers.interopDefault(_rectToClientRectJs);
var _mathJs = require("../utils/math.js");
function getInnerBoundingClientRect(element, strategy) {
    var rect = (0, _getBoundingClientRectJsDefault.default)(element, false, strategy === 'fixed');
    rect.top = rect.top + element.clientTop;
    rect.left = rect.left + element.clientLeft;
    rect.bottom = rect.top + element.clientHeight;
    rect.right = rect.left + element.clientWidth;
    rect.width = element.clientWidth;
    rect.height = element.clientHeight;
    rect.x = rect.left;
    rect.y = rect.top;
    return rect;
}
function getClientRectFromMixedType(element, clippingParent, strategy) {
    return clippingParent === (0, _enumsJs.viewport) ? (0, _rectToClientRectJsDefault.default)((0, _getViewportRectJsDefault.default)(element, strategy)) : (0, _instanceOfJs.isElement)(clippingParent) ? getInnerBoundingClientRect(clippingParent, strategy) : (0, _rectToClientRectJsDefault.default)((0, _getDocumentRectJsDefault.default)((0, _getDocumentElementJsDefault.default)(element)));
} // A "clipping parent" is an overflowable container with the characteristic of
// clipping (or hiding) overflowing elements with a position different from
// `initial`
function getClippingParents(element) {
    var clippingParents = (0, _listScrollParentsJsDefault.default)((0, _getParentNodeJsDefault.default)(element));
    var canEscapeClipping = [
        'absolute',
        'fixed'
    ].indexOf((0, _getComputedStyleJsDefault.default)(element).position) >= 0;
    var clipperElement = canEscapeClipping && (0, _instanceOfJs.isHTMLElement)(element) ? (0, _getOffsetParentJsDefault.default)(element) : element;
    if (!(0, _instanceOfJs.isElement)(clipperElement)) return [];
     // $FlowFixMe[incompatible-return]: https://github.com/facebook/flow/issues/1414
    return clippingParents.filter(function(clippingParent) {
        return (0, _instanceOfJs.isElement)(clippingParent) && (0, _containsJsDefault.default)(clippingParent, clipperElement) && (0, _getNodeNameJsDefault.default)(clippingParent) !== 'body';
    });
} // Gets the maximum area that the element is visible in due to any number of
function getClippingRect(element, boundary, rootBoundary, strategy) {
    var mainClippingParents = boundary === 'clippingParents' ? getClippingParents(element) : [].concat(boundary);
    var clippingParents = [].concat(mainClippingParents, [
        rootBoundary
    ]);
    var firstClippingParent = clippingParents[0];
    var clippingRect = clippingParents.reduce(function(accRect, clippingParent) {
        var rect = getClientRectFromMixedType(element, clippingParent, strategy);
        accRect.top = (0, _mathJs.max)(rect.top, accRect.top);
        accRect.right = (0, _mathJs.min)(rect.right, accRect.right);
        accRect.bottom = (0, _mathJs.min)(rect.bottom, accRect.bottom);
        accRect.left = (0, _mathJs.max)(rect.left, accRect.left);
        return accRect;
    }, getClientRectFromMixedType(element, firstClippingParent, strategy));
    clippingRect.width = clippingRect.right - clippingRect.left;
    clippingRect.height = clippingRect.bottom - clippingRect.top;
    clippingRect.x = clippingRect.left;
    clippingRect.y = clippingRect.top;
    return clippingRect;
}

},{"../enums.js":"1lwWm","./getViewportRect.js":"5GMYq","./getDocumentRect.js":"6N1Xe","./listScrollParents.js":"8lPAs","./getOffsetParent.js":"eIa18","./getDocumentElement.js":"5KI4G","./getComputedStyle.js":"eoRQF","./instanceOf.js":"qMR4O","./getBoundingClientRect.js":"iNomO","./getParentNode.js":"1WvAu","./contains.js":"fTuMy","./getNodeName.js":"iwIho","../utils/rectToClientRect.js":"decNn","../utils/math.js":"9Qz9r","@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"5GMYq":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>getViewportRect);
var _getWindowJs = require("./getWindow.js");
var _getWindowJsDefault = parcelHelpers.interopDefault(_getWindowJs);
var _getDocumentElementJs = require("./getDocumentElement.js");
var _getDocumentElementJsDefault = parcelHelpers.interopDefault(_getDocumentElementJs);
var _getWindowScrollBarXJs = require("./getWindowScrollBarX.js");
var _getWindowScrollBarXJsDefault = parcelHelpers.interopDefault(_getWindowScrollBarXJs);
var _isLayoutViewportJs = require("./isLayoutViewport.js");
var _isLayoutViewportJsDefault = parcelHelpers.interopDefault(_isLayoutViewportJs);
function getViewportRect(element, strategy) {
    var win = (0, _getWindowJsDefault.default)(element);
    var html = (0, _getDocumentElementJsDefault.default)(element);
    var visualViewport = win.visualViewport;
    var width = html.clientWidth;
    var height = html.clientHeight;
    var x = 0;
    var y = 0;
    if (visualViewport) {
        width = visualViewport.width;
        height = visualViewport.height;
        var layoutViewport = (0, _isLayoutViewportJsDefault.default)();
        if (layoutViewport || !layoutViewport && strategy === 'fixed') {
            x = visualViewport.offsetLeft;
            y = visualViewport.offsetTop;
        }
    }
    return {
        width: width,
        height: height,
        x: x + (0, _getWindowScrollBarXJsDefault.default)(element),
        y: y
    };
}

},{"./getWindow.js":"iIOiw","./getDocumentElement.js":"5KI4G","./getWindowScrollBarX.js":"6tSvX","./isLayoutViewport.js":"2i0W9","@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"6N1Xe":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>getDocumentRect);
var _getDocumentElementJs = require("./getDocumentElement.js");
var _getDocumentElementJsDefault = parcelHelpers.interopDefault(_getDocumentElementJs);
var _getComputedStyleJs = require("./getComputedStyle.js");
var _getComputedStyleJsDefault = parcelHelpers.interopDefault(_getComputedStyleJs);
var _getWindowScrollBarXJs = require("./getWindowScrollBarX.js");
var _getWindowScrollBarXJsDefault = parcelHelpers.interopDefault(_getWindowScrollBarXJs);
var _getWindowScrollJs = require("./getWindowScroll.js");
var _getWindowScrollJsDefault = parcelHelpers.interopDefault(_getWindowScrollJs);
var _mathJs = require // Gets the entire size of the scrollable document area, even extending outside
("../utils/math.js");
function getDocumentRect(element) {
    var _element$ownerDocumen;
    var html = (0, _getDocumentElementJsDefault.default)(element);
    var winScroll = (0, _getWindowScrollJsDefault.default)(element);
    var body = (_element$ownerDocumen = element.ownerDocument) == null ? void 0 : _element$ownerDocumen.body;
    var width = (0, _mathJs.max)(html.scrollWidth, html.clientWidth, body ? body.scrollWidth : 0, body ? body.clientWidth : 0);
    var height = (0, _mathJs.max)(html.scrollHeight, html.clientHeight, body ? body.scrollHeight : 0, body ? body.clientHeight : 0);
    var x = -winScroll.scrollLeft + (0, _getWindowScrollBarXJsDefault.default)(element);
    var y = -winScroll.scrollTop;
    if ((0, _getComputedStyleJsDefault.default)(body || html).direction === 'rtl') x += (0, _mathJs.max)(html.clientWidth, body ? body.clientWidth : 0) - width;
    return {
        width: width,
        height: height,
        x: x,
        y: y
    };
}

},{"./getDocumentElement.js":"5KI4G","./getComputedStyle.js":"eoRQF","./getWindowScrollBarX.js":"6tSvX","./getWindowScroll.js":"7FUFj","../utils/math.js":"9Qz9r","@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"fTuMy":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>contains);
var _instanceOfJs = require("./instanceOf.js");
function contains(parent, child) {
    var rootNode = child.getRootNode && child.getRootNode(); // First, attempt with faster native method
    if (parent.contains(child)) return true;
    else if (rootNode && (0, _instanceOfJs.isShadowRoot)(rootNode)) {
        var next = child;
        do {
            if (next && parent.isSameNode(next)) return true;
             // $FlowFixMe[prop-missing]: need a better way to handle this...
            next = next.parentNode || next.host;
        }while (next);
    } // Give up, the result is false
    return false;
}

},{"./instanceOf.js":"qMR4O","@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"decNn":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>rectToClientRect);
function rectToClientRect(rect) {
    return Object.assign({}, rect, {
        left: rect.x,
        top: rect.y,
        right: rect.x + rect.width,
        bottom: rect.y + rect.height
    });
}

},{"@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"1VqQs":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>computeOffsets);
var _getBasePlacementJs = require("./getBasePlacement.js");
var _getBasePlacementJsDefault = parcelHelpers.interopDefault(_getBasePlacementJs);
var _getVariationJs = require("./getVariation.js");
var _getVariationJsDefault = parcelHelpers.interopDefault(_getVariationJs);
var _getMainAxisFromPlacementJs = require("./getMainAxisFromPlacement.js");
var _getMainAxisFromPlacementJsDefault = parcelHelpers.interopDefault(_getMainAxisFromPlacementJs);
var _enumsJs = require("../enums.js");
function computeOffsets(_ref) {
    var reference = _ref.reference, element = _ref.element, placement = _ref.placement;
    var basePlacement = placement ? (0, _getBasePlacementJsDefault.default)(placement) : null;
    var variation = placement ? (0, _getVariationJsDefault.default)(placement) : null;
    var commonX = reference.x + reference.width / 2 - element.width / 2;
    var commonY = reference.y + reference.height / 2 - element.height / 2;
    var offsets;
    switch(basePlacement){
        case 0, _enumsJs.top:
            offsets = {
                x: commonX,
                y: reference.y - element.height
            };
            break;
        case 0, _enumsJs.bottom:
            offsets = {
                x: commonX,
                y: reference.y + reference.height
            };
            break;
        case 0, _enumsJs.right:
            offsets = {
                x: reference.x + reference.width,
                y: commonY
            };
            break;
        case 0, _enumsJs.left:
            offsets = {
                x: reference.x - element.width,
                y: commonY
            };
            break;
        default:
            offsets = {
                x: reference.x,
                y: reference.y
            };
    }
    var mainAxis = basePlacement ? (0, _getMainAxisFromPlacementJsDefault.default)(basePlacement) : null;
    if (mainAxis != null) {
        var len = mainAxis === 'y' ? 'height' : 'width';
        switch(variation){
            case 0, _enumsJs.start:
                offsets[mainAxis] = offsets[mainAxis] - (reference[len] / 2 - element[len] / 2);
                break;
            case 0, _enumsJs.end:
                offsets[mainAxis] = offsets[mainAxis] + (reference[len] / 2 - element[len] / 2);
                break;
            default:
        }
    }
    return offsets;
}

},{"./getBasePlacement.js":"etRI4","./getVariation.js":"bnPY8","./getMainAxisFromPlacement.js":"baABc","../enums.js":"1lwWm","@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"etRI4":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>getBasePlacement);
var _enumsJs = require("../enums.js");
function getBasePlacement(placement) {
    return placement.split('-')[0];
}

},{"../enums.js":"1lwWm","@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"bnPY8":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>getVariation);
function getVariation(placement) {
    return placement.split('-')[1];
}

},{"@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"baABc":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>getMainAxisFromPlacement);
function getMainAxisFromPlacement(placement) {
    return [
        'top',
        'bottom'
    ].indexOf(placement) >= 0 ? 'x' : 'y';
}

},{"@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"7STG4":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>mergePaddingObject);
var _getFreshSideObjectJs = require("./getFreshSideObject.js");
var _getFreshSideObjectJsDefault = parcelHelpers.interopDefault(_getFreshSideObjectJs);
function mergePaddingObject(paddingObject) {
    return Object.assign({}, (0, _getFreshSideObjectJsDefault.default)(), paddingObject);
}

},{"./getFreshSideObject.js":"eT6Tx","@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"eT6Tx":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>getFreshSideObject);
function getFreshSideObject() {
    return {
        top: 0,
        right: 0,
        bottom: 0,
        left: 0
    };
}

},{"@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"4p7fS":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>expandToHashMap);
function expandToHashMap(value, keys) {
    return keys.reduce(function(hashMap, key) {
        hashMap[key] = value;
        return hashMap;
    }, {});
}

},{"@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"dOvVs":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "createPopperLite", ()=>(0, _popperLiteJs.createPopper)); // eslint-disable-next-line import/no-unused-modules
parcelHelpers.export(exports, "createPopper", ()=>createPopper); // eslint-disable-next-line import/no-unused-modules
parcelHelpers.export(exports, "popperGenerator", ()=>(0, _createPopperJs.popperGenerator));
parcelHelpers.export(exports, "defaultModifiers", ()=>defaultModifiers);
parcelHelpers.export(exports, "detectOverflow", ()=>(0, _createPopperJs.detectOverflow));
var _createPopperJs = require("./createPopper.js");
var _eventListenersJs = require("./modifiers/eventListeners.js");
var _eventListenersJsDefault = parcelHelpers.interopDefault(_eventListenersJs);
var _popperOffsetsJs = require("./modifiers/popperOffsets.js");
var _popperOffsetsJsDefault = parcelHelpers.interopDefault(_popperOffsetsJs);
var _computeStylesJs = require("./modifiers/computeStyles.js");
var _computeStylesJsDefault = parcelHelpers.interopDefault(_computeStylesJs);
var _applyStylesJs = require("./modifiers/applyStyles.js");
var _applyStylesJsDefault = parcelHelpers.interopDefault(_applyStylesJs);
var _offsetJs = require("./modifiers/offset.js");
var _offsetJsDefault = parcelHelpers.interopDefault(_offsetJs);
var _flipJs = require("./modifiers/flip.js");
var _flipJsDefault = parcelHelpers.interopDefault(_flipJs);
var _preventOverflowJs = require("./modifiers/preventOverflow.js");
var _preventOverflowJsDefault = parcelHelpers.interopDefault(_preventOverflowJs);
var _arrowJs = require("./modifiers/arrow.js");
var _arrowJsDefault = parcelHelpers.interopDefault(_arrowJs);
var _hideJs = require("./modifiers/hide.js");
var _hideJsDefault = parcelHelpers.interopDefault(_hideJs);
var _popperLiteJs = require("./popper-lite.js");
var _indexJs = require("./modifiers/index.js");
parcelHelpers.exportAll(_indexJs, exports);
var defaultModifiers = [
    (0, _eventListenersJsDefault.default),
    (0, _popperOffsetsJsDefault.default),
    (0, _computeStylesJsDefault.default),
    (0, _applyStylesJsDefault.default),
    (0, _offsetJsDefault.default),
    (0, _flipJsDefault.default),
    (0, _preventOverflowJsDefault.default),
    (0, _arrowJsDefault.default),
    (0, _hideJsDefault.default)
];
var createPopper = /*#__PURE__*/ (0, _createPopperJs.popperGenerator)({
    defaultModifiers: defaultModifiers
}); // eslint-disable-next-line import/no-unused-modules

},{"./createPopper.js":"fg8fT","./modifiers/eventListeners.js":"lSylz","./modifiers/popperOffsets.js":"7I9U7","./modifiers/computeStyles.js":"Fio91","./modifiers/applyStyles.js":"fODnH","./modifiers/offset.js":"lkdHi","./modifiers/flip.js":"k4dec","./modifiers/preventOverflow.js":"iGv9c","./modifiers/arrow.js":"2mT2H","./modifiers/hide.js":"ewdTW","./popper-lite.js":false,"./modifiers/index.js":false,"@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"lSylz":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _getWindowJs = require // eslint-disable-next-line import/no-unused-modules
("../dom-utils/getWindow.js");
var _getWindowJsDefault = parcelHelpers.interopDefault(_getWindowJs);
var passive = {
    passive: true
};
function effect(_ref) {
    var state = _ref.state, instance = _ref.instance, options = _ref.options;
    var _options$scroll = options.scroll, scroll = _options$scroll === void 0 ? true : _options$scroll, _options$resize = options.resize, resize = _options$resize === void 0 ? true : _options$resize;
    var window = (0, _getWindowJsDefault.default)(state.elements.popper);
    var scrollParents = [].concat(state.scrollParents.reference, state.scrollParents.popper);
    if (scroll) scrollParents.forEach(function(scrollParent) {
        scrollParent.addEventListener('scroll', instance.update, passive);
    });
    if (resize) window.addEventListener('resize', instance.update, passive);
    return function() {
        if (scroll) scrollParents.forEach(function(scrollParent) {
            scrollParent.removeEventListener('scroll', instance.update, passive);
        });
        if (resize) window.removeEventListener('resize', instance.update, passive);
    };
} // eslint-disable-next-line import/no-unused-modules
exports.default = {
    name: 'eventListeners',
    enabled: true,
    phase: 'write',
    fn: function fn() {},
    effect: effect,
    data: {}
};

},{"../dom-utils/getWindow.js":"iIOiw","@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"7I9U7":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _computeOffsetsJs = require("../utils/computeOffsets.js");
var _computeOffsetsJsDefault = parcelHelpers.interopDefault(_computeOffsetsJs);
function popperOffsets(_ref) {
    var state = _ref.state, name = _ref.name;
    // Offsets are the actual position the popper needs to have to be
    // properly positioned near its reference element
    // This is the most basic placement, and will be adjusted by
    // the modifiers in the next step
    state.modifiersData[name] = (0, _computeOffsetsJsDefault.default)({
        reference: state.rects.reference,
        element: state.rects.popper,
        strategy: 'absolute',
        placement: state.placement
    });
} // eslint-disable-next-line import/no-unused-modules
exports.default = {
    name: 'popperOffsets',
    enabled: true,
    phase: 'read',
    fn: popperOffsets,
    data: {}
};

},{"../utils/computeOffsets.js":"1VqQs","@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"Fio91":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "mapToStyles", ()=>mapToStyles);
var _enumsJs = require("../enums.js");
var _getOffsetParentJs = require("../dom-utils/getOffsetParent.js");
var _getOffsetParentJsDefault = parcelHelpers.interopDefault(_getOffsetParentJs);
var _getWindowJs = require("../dom-utils/getWindow.js");
var _getWindowJsDefault = parcelHelpers.interopDefault(_getWindowJs);
var _getDocumentElementJs = require("../dom-utils/getDocumentElement.js");
var _getDocumentElementJsDefault = parcelHelpers.interopDefault(_getDocumentElementJs);
var _getComputedStyleJs = require("../dom-utils/getComputedStyle.js");
var _getComputedStyleJsDefault = parcelHelpers.interopDefault(_getComputedStyleJs);
var _getBasePlacementJs = require("../utils/getBasePlacement.js");
var _getBasePlacementJsDefault = parcelHelpers.interopDefault(_getBasePlacementJs);
var _getVariationJs = require("../utils/getVariation.js");
var _getVariationJsDefault = parcelHelpers.interopDefault(_getVariationJs);
var _mathJs = require // eslint-disable-next-line import/no-unused-modules
("../utils/math.js");
var unsetSides = {
    top: 'auto',
    right: 'auto',
    bottom: 'auto',
    left: 'auto'
}; // Round the offsets to the nearest suitable subpixel based on the DPR.
// Zooming can change the DPR, but it seems to report a value that will
// cleanly divide the values into the appropriate subpixels.
function roundOffsetsByDPR(_ref, win) {
    var x = _ref.x, y = _ref.y;
    var dpr = win.devicePixelRatio || 1;
    return {
        x: (0, _mathJs.round)(x * dpr) / dpr || 0,
        y: (0, _mathJs.round)(y * dpr) / dpr || 0
    };
}
function mapToStyles(_ref2) {
    var _Object$assign2;
    var popper = _ref2.popper, popperRect = _ref2.popperRect, placement = _ref2.placement, variation = _ref2.variation, offsets = _ref2.offsets, position = _ref2.position, gpuAcceleration = _ref2.gpuAcceleration, adaptive = _ref2.adaptive, roundOffsets = _ref2.roundOffsets, isFixed = _ref2.isFixed;
    var _offsets$x = offsets.x, x = _offsets$x === void 0 ? 0 : _offsets$x, _offsets$y = offsets.y, y = _offsets$y === void 0 ? 0 : _offsets$y;
    var _ref3 = typeof roundOffsets === 'function' ? roundOffsets({
        x: x,
        y: y
    }) : {
        x: x,
        y: y
    };
    x = _ref3.x;
    y = _ref3.y;
    var hasX = offsets.hasOwnProperty('x');
    var hasY = offsets.hasOwnProperty('y');
    var sideX = (0, _enumsJs.left);
    var sideY = (0, _enumsJs.top);
    var win = window;
    if (adaptive) {
        var offsetParent = (0, _getOffsetParentJsDefault.default)(popper);
        var heightProp = 'clientHeight';
        var widthProp = 'clientWidth';
        if (offsetParent === (0, _getWindowJsDefault.default)(popper)) {
            offsetParent = (0, _getDocumentElementJsDefault.default)(popper);
            if ((0, _getComputedStyleJsDefault.default)(offsetParent).position !== 'static' && position === 'absolute') {
                heightProp = 'scrollHeight';
                widthProp = 'scrollWidth';
            }
        } // $FlowFixMe[incompatible-cast]: force type refinement, we compare offsetParent with window above, but Flow doesn't detect it
        offsetParent;
        if (placement === (0, _enumsJs.top) || (placement === (0, _enumsJs.left) || placement === (0, _enumsJs.right)) && variation === (0, _enumsJs.end)) {
            sideY = (0, _enumsJs.bottom);
            var offsetY = isFixed && offsetParent === win && win.visualViewport ? win.visualViewport.height : offsetParent[heightProp];
            y -= offsetY - popperRect.height;
            y *= gpuAcceleration ? 1 : -1;
        }
        if (placement === (0, _enumsJs.left) || (placement === (0, _enumsJs.top) || placement === (0, _enumsJs.bottom)) && variation === (0, _enumsJs.end)) {
            sideX = (0, _enumsJs.right);
            var offsetX = isFixed && offsetParent === win && win.visualViewport ? win.visualViewport.width : offsetParent[widthProp];
            x -= offsetX - popperRect.width;
            x *= gpuAcceleration ? 1 : -1;
        }
    }
    var commonStyles = Object.assign({
        position: position
    }, adaptive && unsetSides);
    var _ref4 = roundOffsets === true ? roundOffsetsByDPR({
        x: x,
        y: y
    }, (0, _getWindowJsDefault.default)(popper)) : {
        x: x,
        y: y
    };
    x = _ref4.x;
    y = _ref4.y;
    if (gpuAcceleration) {
        var _Object$assign;
        return Object.assign({}, commonStyles, (_Object$assign = {}, _Object$assign[sideY] = hasY ? '0' : '', _Object$assign[sideX] = hasX ? '0' : '', _Object$assign.transform = (win.devicePixelRatio || 1) <= 1 ? "translate(" + x + "px, " + y + "px)" : "translate3d(" + x + "px, " + y + "px, 0)", _Object$assign));
    }
    return Object.assign({}, commonStyles, (_Object$assign2 = {}, _Object$assign2[sideY] = hasY ? y + "px" : '', _Object$assign2[sideX] = hasX ? x + "px" : '', _Object$assign2.transform = '', _Object$assign2));
}
function computeStyles(_ref5) {
    var state = _ref5.state, options = _ref5.options;
    var _options$gpuAccelerat = options.gpuAcceleration, gpuAcceleration = _options$gpuAccelerat === void 0 ? true : _options$gpuAccelerat, _options$adaptive = options.adaptive, adaptive = _options$adaptive === void 0 ? true : _options$adaptive, _options$roundOffsets = options.roundOffsets, roundOffsets = _options$roundOffsets === void 0 ? true : _options$roundOffsets;
    var commonStyles = {
        placement: (0, _getBasePlacementJsDefault.default)(state.placement),
        variation: (0, _getVariationJsDefault.default)(state.placement),
        popper: state.elements.popper,
        popperRect: state.rects.popper,
        gpuAcceleration: gpuAcceleration,
        isFixed: state.options.strategy === 'fixed'
    };
    if (state.modifiersData.popperOffsets != null) state.styles.popper = Object.assign({}, state.styles.popper, mapToStyles(Object.assign({}, commonStyles, {
        offsets: state.modifiersData.popperOffsets,
        position: state.options.strategy,
        adaptive: adaptive,
        roundOffsets: roundOffsets
    })));
    if (state.modifiersData.arrow != null) state.styles.arrow = Object.assign({}, state.styles.arrow, mapToStyles(Object.assign({}, commonStyles, {
        offsets: state.modifiersData.arrow,
        position: 'absolute',
        adaptive: false,
        roundOffsets: roundOffsets
    })));
    state.attributes.popper = Object.assign({}, state.attributes.popper, {
        'data-popper-placement': state.placement
    });
} // eslint-disable-next-line import/no-unused-modules
exports.default = {
    name: 'computeStyles',
    enabled: true,
    phase: 'beforeWrite',
    fn: computeStyles,
    data: {}
};

},{"../enums.js":"1lwWm","../dom-utils/getOffsetParent.js":"eIa18","../dom-utils/getWindow.js":"iIOiw","../dom-utils/getDocumentElement.js":"5KI4G","../dom-utils/getComputedStyle.js":"eoRQF","../utils/getBasePlacement.js":"etRI4","../utils/getVariation.js":"bnPY8","../utils/math.js":"9Qz9r","@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"fODnH":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _getNodeNameJs = require("../dom-utils/getNodeName.js");
var _getNodeNameJsDefault = parcelHelpers.interopDefault(_getNodeNameJs);
var _instanceOfJs = require // This modifier takes the styles prepared by the `computeStyles` modifier
("../dom-utils/instanceOf.js");
// and applies them to the HTMLElements such as popper and arrow
function applyStyles(_ref) {
    var state = _ref.state;
    Object.keys(state.elements).forEach(function(name) {
        var style = state.styles[name] || {};
        var attributes = state.attributes[name] || {};
        var element = state.elements[name]; // arrow is optional + virtual elements
        if (!(0, _instanceOfJs.isHTMLElement)(element) || !(0, _getNodeNameJsDefault.default)(element)) return;
         // Flow doesn't support to extend this property, but it's the most
        // effective way to apply styles to an HTMLElement
        // $FlowFixMe[cannot-write]
        Object.assign(element.style, style);
        Object.keys(attributes).forEach(function(name) {
            var value = attributes[name];
            if (value === false) element.removeAttribute(name);
            else element.setAttribute(name, value === true ? '' : value);
        });
    });
}
function effect(_ref2) {
    var state = _ref2.state;
    var initialStyles = {
        popper: {
            position: state.options.strategy,
            left: '0',
            top: '0',
            margin: '0'
        },
        arrow: {
            position: 'absolute'
        },
        reference: {}
    };
    Object.assign(state.elements.popper.style, initialStyles.popper);
    state.styles = initialStyles;
    if (state.elements.arrow) Object.assign(state.elements.arrow.style, initialStyles.arrow);
    return function() {
        Object.keys(state.elements).forEach(function(name) {
            var element = state.elements[name];
            var attributes = state.attributes[name] || {};
            var styleProperties = Object.keys(state.styles.hasOwnProperty(name) ? state.styles[name] : initialStyles[name]); // Set all values to an empty string to unset them
            var style = styleProperties.reduce(function(style, property) {
                style[property] = '';
                return style;
            }, {}); // arrow is optional + virtual elements
            if (!(0, _instanceOfJs.isHTMLElement)(element) || !(0, _getNodeNameJsDefault.default)(element)) return;
            Object.assign(element.style, style);
            Object.keys(attributes).forEach(function(attribute) {
                element.removeAttribute(attribute);
            });
        });
    };
} // eslint-disable-next-line import/no-unused-modules
exports.default = {
    name: 'applyStyles',
    enabled: true,
    phase: 'write',
    fn: applyStyles,
    effect: effect,
    requires: [
        'computeStyles'
    ]
};

},{"../dom-utils/getNodeName.js":"iwIho","../dom-utils/instanceOf.js":"qMR4O","@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"lkdHi":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "distanceAndSkiddingToXY", ()=>distanceAndSkiddingToXY);
var _getBasePlacementJs = require("../utils/getBasePlacement.js");
var _getBasePlacementJsDefault = parcelHelpers.interopDefault(_getBasePlacementJs);
var _enumsJs = require // eslint-disable-next-line import/no-unused-modules
("../enums.js");
function distanceAndSkiddingToXY(placement, rects, offset) {
    var basePlacement = (0, _getBasePlacementJsDefault.default)(placement);
    var invertDistance = [
        (0, _enumsJs.left),
        (0, _enumsJs.top)
    ].indexOf(basePlacement) >= 0 ? -1 : 1;
    var _ref = typeof offset === 'function' ? offset(Object.assign({}, rects, {
        placement: placement
    })) : offset, skidding = _ref[0], distance = _ref[1];
    skidding = skidding || 0;
    distance = (distance || 0) * invertDistance;
    return [
        (0, _enumsJs.left),
        (0, _enumsJs.right)
    ].indexOf(basePlacement) >= 0 ? {
        x: distance,
        y: skidding
    } : {
        x: skidding,
        y: distance
    };
}
function offset(_ref2) {
    var state = _ref2.state, options = _ref2.options, name = _ref2.name;
    var _options$offset = options.offset, offset = _options$offset === void 0 ? [
        0,
        0
    ] : _options$offset;
    var data = (0, _enumsJs.placements).reduce(function(acc, placement) {
        acc[placement] = distanceAndSkiddingToXY(placement, state.rects, offset);
        return acc;
    }, {});
    var _data$state$placement = data[state.placement], x = _data$state$placement.x, y = _data$state$placement.y;
    if (state.modifiersData.popperOffsets != null) {
        state.modifiersData.popperOffsets.x += x;
        state.modifiersData.popperOffsets.y += y;
    }
    state.modifiersData[name] = data;
} // eslint-disable-next-line import/no-unused-modules
exports.default = {
    name: 'offset',
    enabled: true,
    phase: 'main',
    requires: [
        'popperOffsets'
    ],
    fn: offset
};

},{"../utils/getBasePlacement.js":"etRI4","../enums.js":"1lwWm","@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"k4dec":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _getOppositePlacementJs = require("../utils/getOppositePlacement.js");
var _getOppositePlacementJsDefault = parcelHelpers.interopDefault(_getOppositePlacementJs);
var _getBasePlacementJs = require("../utils/getBasePlacement.js");
var _getBasePlacementJsDefault = parcelHelpers.interopDefault(_getBasePlacementJs);
var _getOppositeVariationPlacementJs = require("../utils/getOppositeVariationPlacement.js");
var _getOppositeVariationPlacementJsDefault = parcelHelpers.interopDefault(_getOppositeVariationPlacementJs);
var _detectOverflowJs = require("../utils/detectOverflow.js");
var _detectOverflowJsDefault = parcelHelpers.interopDefault(_detectOverflowJs);
var _computeAutoPlacementJs = require("../utils/computeAutoPlacement.js");
var _computeAutoPlacementJsDefault = parcelHelpers.interopDefault(_computeAutoPlacementJs);
var _enumsJs = require("../enums.js");
var _getVariationJs = require // eslint-disable-next-line import/no-unused-modules
("../utils/getVariation.js");
var _getVariationJsDefault = parcelHelpers.interopDefault(_getVariationJs);
function getExpandedFallbackPlacements(placement) {
    if ((0, _getBasePlacementJsDefault.default)(placement) === (0, _enumsJs.auto)) return [];
    var oppositePlacement = (0, _getOppositePlacementJsDefault.default)(placement);
    return [
        (0, _getOppositeVariationPlacementJsDefault.default)(placement),
        oppositePlacement,
        (0, _getOppositeVariationPlacementJsDefault.default)(oppositePlacement)
    ];
}
function flip(_ref) {
    var state = _ref.state, options = _ref.options, name = _ref.name;
    if (state.modifiersData[name]._skip) return;
    var _options$mainAxis = options.mainAxis, checkMainAxis = _options$mainAxis === void 0 ? true : _options$mainAxis, _options$altAxis = options.altAxis, checkAltAxis = _options$altAxis === void 0 ? true : _options$altAxis, specifiedFallbackPlacements = options.fallbackPlacements, padding = options.padding, boundary = options.boundary, rootBoundary = options.rootBoundary, altBoundary = options.altBoundary, _options$flipVariatio = options.flipVariations, flipVariations = _options$flipVariatio === void 0 ? true : _options$flipVariatio, allowedAutoPlacements = options.allowedAutoPlacements;
    var preferredPlacement = state.options.placement;
    var basePlacement = (0, _getBasePlacementJsDefault.default)(preferredPlacement);
    var isBasePlacement = basePlacement === preferredPlacement;
    var fallbackPlacements = specifiedFallbackPlacements || (isBasePlacement || !flipVariations ? [
        (0, _getOppositePlacementJsDefault.default)(preferredPlacement)
    ] : getExpandedFallbackPlacements(preferredPlacement));
    var placements = [
        preferredPlacement
    ].concat(fallbackPlacements).reduce(function(acc, placement) {
        return acc.concat((0, _getBasePlacementJsDefault.default)(placement) === (0, _enumsJs.auto) ? (0, _computeAutoPlacementJsDefault.default)(state, {
            placement: placement,
            boundary: boundary,
            rootBoundary: rootBoundary,
            padding: padding,
            flipVariations: flipVariations,
            allowedAutoPlacements: allowedAutoPlacements
        }) : placement);
    }, []);
    var referenceRect = state.rects.reference;
    var popperRect = state.rects.popper;
    var checksMap = new Map();
    var makeFallbackChecks = true;
    var firstFittingPlacement = placements[0];
    for(var i = 0; i < placements.length; i++){
        var placement = placements[i];
        var _basePlacement = (0, _getBasePlacementJsDefault.default)(placement);
        var isStartVariation = (0, _getVariationJsDefault.default)(placement) === (0, _enumsJs.start);
        var isVertical = [
            (0, _enumsJs.top),
            (0, _enumsJs.bottom)
        ].indexOf(_basePlacement) >= 0;
        var len = isVertical ? 'width' : 'height';
        var overflow = (0, _detectOverflowJsDefault.default)(state, {
            placement: placement,
            boundary: boundary,
            rootBoundary: rootBoundary,
            altBoundary: altBoundary,
            padding: padding
        });
        var mainVariationSide = isVertical ? isStartVariation ? (0, _enumsJs.right) : (0, _enumsJs.left) : isStartVariation ? (0, _enumsJs.bottom) : (0, _enumsJs.top);
        if (referenceRect[len] > popperRect[len]) mainVariationSide = (0, _getOppositePlacementJsDefault.default)(mainVariationSide);
        var altVariationSide = (0, _getOppositePlacementJsDefault.default)(mainVariationSide);
        var checks = [];
        if (checkMainAxis) checks.push(overflow[_basePlacement] <= 0);
        if (checkAltAxis) checks.push(overflow[mainVariationSide] <= 0, overflow[altVariationSide] <= 0);
        if (checks.every(function(check) {
            return check;
        })) {
            firstFittingPlacement = placement;
            makeFallbackChecks = false;
            break;
        }
        checksMap.set(placement, checks);
    }
    if (makeFallbackChecks) {
        // `2` may be desired in some cases – research later
        var numberOfChecks = flipVariations ? 3 : 1;
        var _loop = function _loop(_i) {
            var fittingPlacement = placements.find(function(placement) {
                var checks = checksMap.get(placement);
                if (checks) return checks.slice(0, _i).every(function(check) {
                    return check;
                });
            });
            if (fittingPlacement) {
                firstFittingPlacement = fittingPlacement;
                return "break";
            }
        };
        for(var _i = numberOfChecks; _i > 0; _i--){
            var _ret = _loop(_i);
            if (_ret === "break") break;
        }
    }
    if (state.placement !== firstFittingPlacement) {
        state.modifiersData[name]._skip = true;
        state.placement = firstFittingPlacement;
        state.reset = true;
    }
} // eslint-disable-next-line import/no-unused-modules
exports.default = {
    name: 'flip',
    enabled: true,
    phase: 'main',
    fn: flip,
    requiresIfExists: [
        'offset'
    ],
    data: {
        _skip: false
    }
};

},{"../utils/getOppositePlacement.js":"8eVxc","../utils/getBasePlacement.js":"etRI4","../utils/getOppositeVariationPlacement.js":"cH7ZM","../utils/detectOverflow.js":"a7bOO","../utils/computeAutoPlacement.js":"ja6QN","../enums.js":"1lwWm","../utils/getVariation.js":"bnPY8","@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"8eVxc":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>getOppositePlacement);
var hash = {
    left: 'right',
    right: 'left',
    bottom: 'top',
    top: 'bottom'
};
function getOppositePlacement(placement) {
    return placement.replace(/left|right|bottom|top/g, function(matched) {
        return hash[matched];
    });
}

},{"@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"cH7ZM":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>getOppositeVariationPlacement);
var hash = {
    start: 'end',
    end: 'start'
};
function getOppositeVariationPlacement(placement) {
    return placement.replace(/start|end/g, function(matched) {
        return hash[matched];
    });
}

},{"@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"ja6QN":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>computeAutoPlacement);
var _getVariationJs = require("./getVariation.js");
var _getVariationJsDefault = parcelHelpers.interopDefault(_getVariationJs);
var _enumsJs = require("../enums.js");
var _detectOverflowJs = require("./detectOverflow.js");
var _detectOverflowJsDefault = parcelHelpers.interopDefault(_detectOverflowJs);
var _getBasePlacementJs = require("./getBasePlacement.js");
var _getBasePlacementJsDefault = parcelHelpers.interopDefault(_getBasePlacementJs);
function computeAutoPlacement(state, options) {
    if (options === void 0) options = {};
    var _options = options, placement = _options.placement, boundary = _options.boundary, rootBoundary = _options.rootBoundary, padding = _options.padding, flipVariations = _options.flipVariations, _options$allowedAutoP = _options.allowedAutoPlacements, allowedAutoPlacements = _options$allowedAutoP === void 0 ? (0, _enumsJs.placements) : _options$allowedAutoP;
    var variation = (0, _getVariationJsDefault.default)(placement);
    var placements = variation ? flipVariations ? (0, _enumsJs.variationPlacements) : (0, _enumsJs.variationPlacements).filter(function(placement) {
        return (0, _getVariationJsDefault.default)(placement) === variation;
    }) : (0, _enumsJs.basePlacements);
    var allowedPlacements = placements.filter(function(placement) {
        return allowedAutoPlacements.indexOf(placement) >= 0;
    });
    if (allowedPlacements.length === 0) allowedPlacements = placements;
     // $FlowFixMe[incompatible-type]: Flow seems to have problems with two array unions...
    var overflows = allowedPlacements.reduce(function(acc, placement) {
        acc[placement] = (0, _detectOverflowJsDefault.default)(state, {
            placement: placement,
            boundary: boundary,
            rootBoundary: rootBoundary,
            padding: padding
        })[(0, _getBasePlacementJsDefault.default)(placement)];
        return acc;
    }, {});
    return Object.keys(overflows).sort(function(a, b) {
        return overflows[a] - overflows[b];
    });
}

},{"./getVariation.js":"bnPY8","../enums.js":"1lwWm","./detectOverflow.js":"a7bOO","./getBasePlacement.js":"etRI4","@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"iGv9c":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _enumsJs = require("../enums.js");
var _getBasePlacementJs = require("../utils/getBasePlacement.js");
var _getBasePlacementJsDefault = parcelHelpers.interopDefault(_getBasePlacementJs);
var _getMainAxisFromPlacementJs = require("../utils/getMainAxisFromPlacement.js");
var _getMainAxisFromPlacementJsDefault = parcelHelpers.interopDefault(_getMainAxisFromPlacementJs);
var _getAltAxisJs = require("../utils/getAltAxis.js");
var _getAltAxisJsDefault = parcelHelpers.interopDefault(_getAltAxisJs);
var _withinJs = require("../utils/within.js");
var _getLayoutRectJs = require("../dom-utils/getLayoutRect.js");
var _getLayoutRectJsDefault = parcelHelpers.interopDefault(_getLayoutRectJs);
var _getOffsetParentJs = require("../dom-utils/getOffsetParent.js");
var _getOffsetParentJsDefault = parcelHelpers.interopDefault(_getOffsetParentJs);
var _detectOverflowJs = require("../utils/detectOverflow.js");
var _detectOverflowJsDefault = parcelHelpers.interopDefault(_detectOverflowJs);
var _getVariationJs = require("../utils/getVariation.js");
var _getVariationJsDefault = parcelHelpers.interopDefault(_getVariationJs);
var _getFreshSideObjectJs = require("../utils/getFreshSideObject.js");
var _getFreshSideObjectJsDefault = parcelHelpers.interopDefault(_getFreshSideObjectJs);
var _mathJs = require("../utils/math.js");
function preventOverflow(_ref) {
    var state = _ref.state, options = _ref.options, name = _ref.name;
    var _options$mainAxis = options.mainAxis, checkMainAxis = _options$mainAxis === void 0 ? true : _options$mainAxis, _options$altAxis = options.altAxis, checkAltAxis = _options$altAxis === void 0 ? false : _options$altAxis, boundary = options.boundary, rootBoundary = options.rootBoundary, altBoundary = options.altBoundary, padding = options.padding, _options$tether = options.tether, tether = _options$tether === void 0 ? true : _options$tether, _options$tetherOffset = options.tetherOffset, tetherOffset = _options$tetherOffset === void 0 ? 0 : _options$tetherOffset;
    var overflow = (0, _detectOverflowJsDefault.default)(state, {
        boundary: boundary,
        rootBoundary: rootBoundary,
        padding: padding,
        altBoundary: altBoundary
    });
    var basePlacement = (0, _getBasePlacementJsDefault.default)(state.placement);
    var variation = (0, _getVariationJsDefault.default)(state.placement);
    var isBasePlacement = !variation;
    var mainAxis = (0, _getMainAxisFromPlacementJsDefault.default)(basePlacement);
    var altAxis = (0, _getAltAxisJsDefault.default)(mainAxis);
    var popperOffsets = state.modifiersData.popperOffsets;
    var referenceRect = state.rects.reference;
    var popperRect = state.rects.popper;
    var tetherOffsetValue = typeof tetherOffset === 'function' ? tetherOffset(Object.assign({}, state.rects, {
        placement: state.placement
    })) : tetherOffset;
    var normalizedTetherOffsetValue = typeof tetherOffsetValue === 'number' ? {
        mainAxis: tetherOffsetValue,
        altAxis: tetherOffsetValue
    } : Object.assign({
        mainAxis: 0,
        altAxis: 0
    }, tetherOffsetValue);
    var offsetModifierState = state.modifiersData.offset ? state.modifiersData.offset[state.placement] : null;
    var data = {
        x: 0,
        y: 0
    };
    if (!popperOffsets) return;
    if (checkMainAxis) {
        var _offsetModifierState$;
        var mainSide = mainAxis === 'y' ? (0, _enumsJs.top) : (0, _enumsJs.left);
        var altSide = mainAxis === 'y' ? (0, _enumsJs.bottom) : (0, _enumsJs.right);
        var len = mainAxis === 'y' ? 'height' : 'width';
        var offset = popperOffsets[mainAxis];
        var min = offset + overflow[mainSide];
        var max = offset - overflow[altSide];
        var additive = tether ? -popperRect[len] / 2 : 0;
        var minLen = variation === (0, _enumsJs.start) ? referenceRect[len] : popperRect[len];
        var maxLen = variation === (0, _enumsJs.start) ? -popperRect[len] : -referenceRect[len]; // We need to include the arrow in the calculation so the arrow doesn't go
        // outside the reference bounds
        var arrowElement = state.elements.arrow;
        var arrowRect = tether && arrowElement ? (0, _getLayoutRectJsDefault.default)(arrowElement) : {
            width: 0,
            height: 0
        };
        var arrowPaddingObject = state.modifiersData['arrow#persistent'] ? state.modifiersData['arrow#persistent'].padding : (0, _getFreshSideObjectJsDefault.default)();
        var arrowPaddingMin = arrowPaddingObject[mainSide];
        var arrowPaddingMax = arrowPaddingObject[altSide]; // If the reference length is smaller than the arrow length, we don't want
        // to include its full size in the calculation. If the reference is small
        // and near the edge of a boundary, the popper can overflow even if the
        // reference is not overflowing as well (e.g. virtual elements with no
        // width or height)
        var arrowLen = (0, _withinJs.within)(0, referenceRect[len], arrowRect[len]);
        var minOffset = isBasePlacement ? referenceRect[len] / 2 - additive - arrowLen - arrowPaddingMin - normalizedTetherOffsetValue.mainAxis : minLen - arrowLen - arrowPaddingMin - normalizedTetherOffsetValue.mainAxis;
        var maxOffset = isBasePlacement ? -referenceRect[len] / 2 + additive + arrowLen + arrowPaddingMax + normalizedTetherOffsetValue.mainAxis : maxLen + arrowLen + arrowPaddingMax + normalizedTetherOffsetValue.mainAxis;
        var arrowOffsetParent = state.elements.arrow && (0, _getOffsetParentJsDefault.default)(state.elements.arrow);
        var clientOffset = arrowOffsetParent ? mainAxis === 'y' ? arrowOffsetParent.clientTop || 0 : arrowOffsetParent.clientLeft || 0 : 0;
        var offsetModifierValue = (_offsetModifierState$ = offsetModifierState == null ? void 0 : offsetModifierState[mainAxis]) != null ? _offsetModifierState$ : 0;
        var tetherMin = offset + minOffset - offsetModifierValue - clientOffset;
        var tetherMax = offset + maxOffset - offsetModifierValue;
        var preventedOffset = (0, _withinJs.within)(tether ? (0, _mathJs.min)(min, tetherMin) : min, offset, tether ? (0, _mathJs.max)(max, tetherMax) : max);
        popperOffsets[mainAxis] = preventedOffset;
        data[mainAxis] = preventedOffset - offset;
    }
    if (checkAltAxis) {
        var _offsetModifierState$2;
        var _mainSide = mainAxis === 'x' ? (0, _enumsJs.top) : (0, _enumsJs.left);
        var _altSide = mainAxis === 'x' ? (0, _enumsJs.bottom) : (0, _enumsJs.right);
        var _offset = popperOffsets[altAxis];
        var _len = altAxis === 'y' ? 'height' : 'width';
        var _min = _offset + overflow[_mainSide];
        var _max = _offset - overflow[_altSide];
        var isOriginSide = [
            (0, _enumsJs.top),
            (0, _enumsJs.left)
        ].indexOf(basePlacement) !== -1;
        var _offsetModifierValue = (_offsetModifierState$2 = offsetModifierState == null ? void 0 : offsetModifierState[altAxis]) != null ? _offsetModifierState$2 : 0;
        var _tetherMin = isOriginSide ? _min : _offset - referenceRect[_len] - popperRect[_len] - _offsetModifierValue + normalizedTetherOffsetValue.altAxis;
        var _tetherMax = isOriginSide ? _offset + referenceRect[_len] + popperRect[_len] - _offsetModifierValue - normalizedTetherOffsetValue.altAxis : _max;
        var _preventedOffset = tether && isOriginSide ? (0, _withinJs.withinMaxClamp)(_tetherMin, _offset, _tetherMax) : (0, _withinJs.within)(tether ? _tetherMin : _min, _offset, tether ? _tetherMax : _max);
        popperOffsets[altAxis] = _preventedOffset;
        data[altAxis] = _preventedOffset - _offset;
    }
    state.modifiersData[name] = data;
} // eslint-disable-next-line import/no-unused-modules
exports.default = {
    name: 'preventOverflow',
    enabled: true,
    phase: 'main',
    fn: preventOverflow,
    requiresIfExists: [
        'offset'
    ]
};

},{"../enums.js":"1lwWm","../utils/getBasePlacement.js":"etRI4","../utils/getMainAxisFromPlacement.js":"baABc","../utils/getAltAxis.js":"hc9jw","../utils/within.js":"h1Nzj","../dom-utils/getLayoutRect.js":"8pwV1","../dom-utils/getOffsetParent.js":"eIa18","../utils/detectOverflow.js":"a7bOO","../utils/getVariation.js":"bnPY8","../utils/getFreshSideObject.js":"eT6Tx","../utils/math.js":"9Qz9r","@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"hc9jw":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>getAltAxis);
function getAltAxis(axis) {
    return axis === 'x' ? 'y' : 'x';
}

},{"@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"h1Nzj":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "within", ()=>within);
parcelHelpers.export(exports, "withinMaxClamp", ()=>withinMaxClamp);
var _mathJs = require("./math.js");
function within(min, value, max) {
    return (0, _mathJs.max)(min, (0, _mathJs.min)(value, max));
}
function withinMaxClamp(min, value, max) {
    var v = within(min, value, max);
    return v > max ? max : v;
}

},{"./math.js":"9Qz9r","@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"2mT2H":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _getBasePlacementJs = require("../utils/getBasePlacement.js");
var _getBasePlacementJsDefault = parcelHelpers.interopDefault(_getBasePlacementJs);
var _getLayoutRectJs = require("../dom-utils/getLayoutRect.js");
var _getLayoutRectJsDefault = parcelHelpers.interopDefault(_getLayoutRectJs);
var _containsJs = require("../dom-utils/contains.js");
var _containsJsDefault = parcelHelpers.interopDefault(_containsJs);
var _getOffsetParentJs = require("../dom-utils/getOffsetParent.js");
var _getOffsetParentJsDefault = parcelHelpers.interopDefault(_getOffsetParentJs);
var _getMainAxisFromPlacementJs = require("../utils/getMainAxisFromPlacement.js");
var _getMainAxisFromPlacementJsDefault = parcelHelpers.interopDefault(_getMainAxisFromPlacementJs);
var _withinJs = require("../utils/within.js");
var _mergePaddingObjectJs = require("../utils/mergePaddingObject.js");
var _mergePaddingObjectJsDefault = parcelHelpers.interopDefault(_mergePaddingObjectJs);
var _expandToHashMapJs = require("../utils/expandToHashMap.js");
var _expandToHashMapJsDefault = parcelHelpers.interopDefault(_expandToHashMapJs);
var _enumsJs = require // eslint-disable-next-line import/no-unused-modules
("../enums.js");
var toPaddingObject = function toPaddingObject(padding, state) {
    padding = typeof padding === 'function' ? padding(Object.assign({}, state.rects, {
        placement: state.placement
    })) : padding;
    return (0, _mergePaddingObjectJsDefault.default)(typeof padding !== 'number' ? padding : (0, _expandToHashMapJsDefault.default)(padding, (0, _enumsJs.basePlacements)));
};
function arrow(_ref) {
    var _state$modifiersData$;
    var state = _ref.state, name = _ref.name, options = _ref.options;
    var arrowElement = state.elements.arrow;
    var popperOffsets = state.modifiersData.popperOffsets;
    var basePlacement = (0, _getBasePlacementJsDefault.default)(state.placement);
    var axis = (0, _getMainAxisFromPlacementJsDefault.default)(basePlacement);
    var isVertical = [
        (0, _enumsJs.left),
        (0, _enumsJs.right)
    ].indexOf(basePlacement) >= 0;
    var len = isVertical ? 'height' : 'width';
    if (!arrowElement || !popperOffsets) return;
    var paddingObject = toPaddingObject(options.padding, state);
    var arrowRect = (0, _getLayoutRectJsDefault.default)(arrowElement);
    var minProp = axis === 'y' ? (0, _enumsJs.top) : (0, _enumsJs.left);
    var maxProp = axis === 'y' ? (0, _enumsJs.bottom) : (0, _enumsJs.right);
    var endDiff = state.rects.reference[len] + state.rects.reference[axis] - popperOffsets[axis] - state.rects.popper[len];
    var startDiff = popperOffsets[axis] - state.rects.reference[axis];
    var arrowOffsetParent = (0, _getOffsetParentJsDefault.default)(arrowElement);
    var clientSize = arrowOffsetParent ? axis === 'y' ? arrowOffsetParent.clientHeight || 0 : arrowOffsetParent.clientWidth || 0 : 0;
    var centerToReference = endDiff / 2 - startDiff / 2; // Make sure the arrow doesn't overflow the popper if the center point is
    // outside of the popper bounds
    var min = paddingObject[minProp];
    var max = clientSize - arrowRect[len] - paddingObject[maxProp];
    var center = clientSize / 2 - arrowRect[len] / 2 + centerToReference;
    var offset = (0, _withinJs.within)(min, center, max); // Prevents breaking syntax highlighting...
    var axisProp = axis;
    state.modifiersData[name] = (_state$modifiersData$ = {}, _state$modifiersData$[axisProp] = offset, _state$modifiersData$.centerOffset = offset - center, _state$modifiersData$);
}
function effect(_ref2) {
    var state = _ref2.state, options = _ref2.options;
    var _options$element = options.element, arrowElement = _options$element === void 0 ? '[data-popper-arrow]' : _options$element;
    if (arrowElement == null) return;
     // CSS selector
    if (typeof arrowElement === 'string') {
        arrowElement = state.elements.popper.querySelector(arrowElement);
        if (!arrowElement) return;
    }
    if (!(0, _containsJsDefault.default)(state.elements.popper, arrowElement)) return;
    state.elements.arrow = arrowElement;
} // eslint-disable-next-line import/no-unused-modules
exports.default = {
    name: 'arrow',
    enabled: true,
    phase: 'main',
    fn: arrow,
    effect: effect,
    requires: [
        'popperOffsets'
    ],
    requiresIfExists: [
        'preventOverflow'
    ]
};

},{"../utils/getBasePlacement.js":"etRI4","../dom-utils/getLayoutRect.js":"8pwV1","../dom-utils/contains.js":"fTuMy","../dom-utils/getOffsetParent.js":"eIa18","../utils/getMainAxisFromPlacement.js":"baABc","../utils/within.js":"h1Nzj","../utils/mergePaddingObject.js":"7STG4","../utils/expandToHashMap.js":"4p7fS","../enums.js":"1lwWm","@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"ewdTW":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _enumsJs = require("../enums.js");
var _detectOverflowJs = require("../utils/detectOverflow.js");
var _detectOverflowJsDefault = parcelHelpers.interopDefault(_detectOverflowJs);
function getSideOffsets(overflow, rect, preventedOffsets) {
    if (preventedOffsets === void 0) preventedOffsets = {
        x: 0,
        y: 0
    };
    return {
        top: overflow.top - rect.height - preventedOffsets.y,
        right: overflow.right - rect.width + preventedOffsets.x,
        bottom: overflow.bottom - rect.height + preventedOffsets.y,
        left: overflow.left - rect.width - preventedOffsets.x
    };
}
function isAnySideFullyClipped(overflow) {
    return [
        (0, _enumsJs.top),
        (0, _enumsJs.right),
        (0, _enumsJs.bottom),
        (0, _enumsJs.left)
    ].some(function(side) {
        return overflow[side] >= 0;
    });
}
function hide(_ref) {
    var state = _ref.state, name = _ref.name;
    var referenceRect = state.rects.reference;
    var popperRect = state.rects.popper;
    var preventedOffsets = state.modifiersData.preventOverflow;
    var referenceOverflow = (0, _detectOverflowJsDefault.default)(state, {
        elementContext: 'reference'
    });
    var popperAltOverflow = (0, _detectOverflowJsDefault.default)(state, {
        altBoundary: true
    });
    var referenceClippingOffsets = getSideOffsets(referenceOverflow, referenceRect);
    var popperEscapeOffsets = getSideOffsets(popperAltOverflow, popperRect, preventedOffsets);
    var isReferenceHidden = isAnySideFullyClipped(referenceClippingOffsets);
    var hasPopperEscaped = isAnySideFullyClipped(popperEscapeOffsets);
    state.modifiersData[name] = {
        referenceClippingOffsets: referenceClippingOffsets,
        popperEscapeOffsets: popperEscapeOffsets,
        isReferenceHidden: isReferenceHidden,
        hasPopperEscaped: hasPopperEscaped
    };
    state.attributes.popper = Object.assign({}, state.attributes.popper, {
        'data-popper-reference-hidden': isReferenceHidden,
        'data-popper-escaped': hasPopperEscaped
    });
} // eslint-disable-next-line import/no-unused-modules
exports.default = {
    name: 'hide',
    enabled: true,
    phase: 'main',
    requiresIfExists: [
        'preventOverflow'
    ],
    fn: hide
};

},{"../enums.js":"1lwWm","../utils/detectOverflow.js":"a7bOO","@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"8GPFg":[function(require,module,exports,__globalThis) {
/* global Map:readonly, Set:readonly, ArrayBuffer:readonly */ var hasElementType = typeof Element !== 'undefined';
var hasMap = typeof Map === 'function';
var hasSet = typeof Set === 'function';
var hasArrayBuffer = typeof ArrayBuffer === 'function' && !!ArrayBuffer.isView;
// Note: We **don't** need `envHasBigInt64Array` in fde es6/index.js
function equal(a, b) {
    // START: fast-deep-equal es6/index.js 3.1.3
    if (a === b) return true;
    if (a && b && typeof a == 'object' && typeof b == 'object') {
        if (a.constructor !== b.constructor) return false;
        var length, i, keys;
        if (Array.isArray(a)) {
            length = a.length;
            if (length != b.length) return false;
            for(i = length; i-- !== 0;)if (!equal(a[i], b[i])) return false;
            return true;
        }
        // START: Modifications:
        // 1. Extra `has<Type> &&` helpers in initial condition allow es6 code
        //    to co-exist with es5.
        // 2. Replace `for of` with es5 compliant iteration using `for`.
        //    Basically, take:
        //
        //    ```js
        //    for (i of a.entries())
        //      if (!b.has(i[0])) return false;
        //    ```
        //
        //    ... and convert to:
        //
        //    ```js
        //    it = a.entries();
        //    while (!(i = it.next()).done)
        //      if (!b.has(i.value[0])) return false;
        //    ```
        //
        //    **Note**: `i` access switches to `i.value`.
        var it;
        if (hasMap && a instanceof Map && b instanceof Map) {
            if (a.size !== b.size) return false;
            it = a.entries();
            while(!(i = it.next()).done)if (!b.has(i.value[0])) return false;
            it = a.entries();
            while(!(i = it.next()).done)if (!equal(i.value[1], b.get(i.value[0]))) return false;
            return true;
        }
        if (hasSet && a instanceof Set && b instanceof Set) {
            if (a.size !== b.size) return false;
            it = a.entries();
            while(!(i = it.next()).done)if (!b.has(i.value[0])) return false;
            return true;
        }
        // END: Modifications
        if (hasArrayBuffer && ArrayBuffer.isView(a) && ArrayBuffer.isView(b)) {
            length = a.length;
            if (length != b.length) return false;
            for(i = length; i-- !== 0;)if (a[i] !== b[i]) return false;
            return true;
        }
        if (a.constructor === RegExp) return a.source === b.source && a.flags === b.flags;
        // START: Modifications:
        // Apply guards for `Object.create(null)` handling. See:
        // - https://github.com/FormidableLabs/react-fast-compare/issues/64
        // - https://github.com/epoberezkin/fast-deep-equal/issues/49
        if (a.valueOf !== Object.prototype.valueOf && typeof a.valueOf === 'function' && typeof b.valueOf === 'function') return a.valueOf() === b.valueOf();
        if (a.toString !== Object.prototype.toString && typeof a.toString === 'function' && typeof b.toString === 'function') return a.toString() === b.toString();
        // END: Modifications
        keys = Object.keys(a);
        length = keys.length;
        if (length !== Object.keys(b).length) return false;
        for(i = length; i-- !== 0;)if (!Object.prototype.hasOwnProperty.call(b, keys[i])) return false;
        // END: fast-deep-equal
        // START: react-fast-compare
        // custom handling for DOM elements
        if (hasElementType && a instanceof Element) return false;
        // custom handling for React/Preact
        for(i = length; i-- !== 0;){
            if ((keys[i] === '_owner' || keys[i] === '__v' || keys[i] === '__o') && a.$$typeof) continue;
            // all other properties should be traversed as usual
            if (!equal(a[keys[i]], b[keys[i]])) return false;
        }
        // END: react-fast-compare
        // START: fast-deep-equal
        return true;
    }
    return a !== a && b !== b;
}
// end fast-deep-equal
module.exports = function isEqual(a, b) {
    try {
        return equal(a, b);
    } catch (error) {
        if ((error.message || '').match(/stack|recursion/i)) {
            // warn on circular references, don't crash
            // browsers give this different errors name and messages:
            // chrome/safari: "RangeError", "Maximum call stack size exceeded"
            // firefox: "InternalError", too much recursion"
            // edge: "Error", "Out of stack space"
            console.warn('react-fast-compare cannot handle circular refs');
            return false;
        }
        // some other error. we should definitely know about these
        throw error;
    }
};

},{}],"c68RF":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "Reference", ()=>Reference);
var _react = require("react");
var _warning = require("warning");
var _warningDefault = parcelHelpers.interopDefault(_warning);
var _manager = require("./Manager");
var _utils = require("./utils");
function Reference(_ref) {
    var children = _ref.children, innerRef = _ref.innerRef;
    var setReferenceNode = _react.useContext((0, _manager.ManagerReferenceNodeSetterContext));
    var refHandler = _react.useCallback(function(node) {
        (0, _utils.setRef)(innerRef, node);
        (0, _utils.safeInvoke)(setReferenceNode, node);
    }, [
        innerRef,
        setReferenceNode
    ]); // ran on unmount
    // eslint-disable-next-line react-hooks/exhaustive-deps
    _react.useEffect(function() {
        return function() {
            return (0, _utils.setRef)(innerRef, null);
        };
    }, []);
    _react.useEffect(function() {
        (0, _warningDefault.default)(Boolean(setReferenceNode), '`Reference` should not be used outside of a `Manager` component.');
    }, [
        setReferenceNode
    ]);
    return (0, _utils.unwrapArray)(children)({
        ref: refHandler
    });
}

},{"react":"ltHCL","warning":"5WfJp","./Manager":"ltEqg","./utils":"9X8cu","@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"5WfJp":[function(require,module,exports,__globalThis) {
/**
 * Copyright (c) 2014-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ 'use strict';
/**
 * Similar to invariant but only logs a warning if the condition is not met.
 * This can be used to log issues in development environments in critical
 * paths. Removing the logging code for production environments will keep the
 * same logic and follow the same code paths.
 */ var __DEV__ = false;
var warning = function() {};
if (__DEV__) {
    var printWarning = function printWarning(format, args) {
        var len = arguments.length;
        args = new Array(len > 1 ? len - 1 : 0);
        for(var key = 1; key < len; key++)args[key - 1] = arguments[key];
        var argIndex = 0;
        var message = 'Warning: ' + format.replace(/%s/g, function() {
            return args[argIndex++];
        });
        if (typeof console !== 'undefined') console.error(message);
        try {
            // --- Welcome to debugging React ---
            // This error was thrown as a convenience so that you can use this stack
            // to find the callsite that caused this warning to fire.
            throw new Error(message);
        } catch (x) {}
    };
    warning = function(condition, format, args) {
        var len = arguments.length;
        args = new Array(len > 2 ? len - 2 : 0);
        for(var key = 2; key < len; key++)args[key - 2] = arguments[key];
        if (format === undefined) throw new Error("`warning(condition, format, ...args)` requires a warning message argument");
        if (!condition) printWarning.apply(null, [
            format
        ].concat(args));
    };
}
module.exports = warning;

},{}],"dDoYp":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "getMaxSizeModifiers", ()=>getMaxSizeModifiers);
function getMaxSizeModifiers({ viewportPadding }) {
    return [
        {
            /**
			 * Performing DOM measurements in the 'read' phase,
			 * which is the convention for popper modifiers
			 */ name: 'maxSizeData',
            enabled: true,
            phase: 'read',
            fn ({ state, name }) {
                if (!window.visualViewport) return;
                state.modifiersData[name] = {
                    viewport: {
                        width: window.visualViewport.width,
                        height: window.visualViewport.height
                    }
                };
            }
        },
        {
            /**
			 * Applying max size CSS
			 */ name: 'maxSize',
            enabled: true,
            phase: 'beforeWrite',
            requiresIfExists: [
                'offset',
                'preventOverflow',
                'flip'
            ],
            fn ({ state }) {
                var _data_viewport, _data_viewport1, _state_modifiersData_offset, _state_modifiersData;
                const data = state.modifiersData.maxSizeData;
                if (typeof (data === null || data === void 0 ? void 0 : (_data_viewport = data.viewport) === null || _data_viewport === void 0 ? void 0 : _data_viewport.width) !== 'number' || typeof (data === null || data === void 0 ? void 0 : (_data_viewport1 = data.viewport) === null || _data_viewport1 === void 0 ? void 0 : _data_viewport1.height) !== 'number') // This shouldn't occur in a real browser but might in non-browser test environments
                return;
                const { viewport } = data;
                const { popperOffsets = {
                    x: 0,
                    y: 0
                } } = state.modifiersData;
                const [basePlacement] = state.placement.split('-');
                var _state_modifiersData_offset_state_placement;
                const placementOffset = (_state_modifiersData_offset_state_placement = (_state_modifiersData = state.modifiersData) === null || _state_modifiersData === void 0 ? void 0 : (_state_modifiersData_offset = _state_modifiersData.offset) === null || _state_modifiersData_offset === void 0 ? void 0 : _state_modifiersData_offset[state.placement]) !== null && _state_modifiersData_offset_state_placement !== void 0 ? _state_modifiersData_offset_state_placement : {
                    x: 0,
                    y: 0
                };
                // By default we set these to the entire viewport (minus padding)
                // Each placement direction will overwrite one of these
                let maxWidth = viewport.width - 2 * viewportPadding;
                let maxHeight = viewport.height - 2 * viewportPadding;
                if (basePlacement === 'top') maxHeight = state.rects.reference.y + // Viewport-relative position of reference element
                placementOffset.y - // Space between popper and reference
                viewportPadding;
                if (basePlacement === 'bottom') maxHeight = viewport.height - popperOffsets.y - // Viewport-relative position of popper
                viewportPadding;
                if (basePlacement === 'left') maxWidth = state.rects.reference.x + // Viewport-relative position of reference element
                placementOffset.x - // Space between popper and reference
                viewportPadding;
                if (basePlacement === 'right') maxWidth = viewport.width - popperOffsets.x - // Viewport-relative position of popper
                viewportPadding;
                state.styles.popper.maxWidth = `${maxWidth}px`;
                state.styles.popper.maxHeight = `${maxHeight}px`;
            }
        }
    ];
}

},{"@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"dtZjg":[function(require,module,exports,__globalThis) {
/* popper-top-layer.tsx generated by @compiled/babel-plugin v0.39.1 */ var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
/**
 * FF-on implementation of `@atlaskit/popper`'s `<Popper>` primitive.
 *
 * Renders the consumer's render-prop output into a `<Popover>` from
 * `@atlaskit/top-layer`, which lifts the element into the browser top
 * layer and positions it via CSS Anchor Positioning. The render-prop
 * contract (`PopperChildrenProps`) is preserved at the type level;
 * `style` and `arrowProps.style` are inert at runtime because the
 * browser owns positioning.
 *
 * Gated behind the `platform-dst-top-layer` feature flag from
 * `popper.tsx`.
 */ parcelHelpers.export(exports, "PopperTopLayer", ()=>PopperTopLayer);
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _browserApis = require("@atlaskit/browser-apis");
var _noop = require("@atlaskit/ds-lib/noop");
var _noopDefault = parcelHelpers.interopDefault(_noop);
var _placementMap = require("@atlaskit/top-layer/placement-map");
var _popover = require("@atlaskit/top-layer/popover");
var _useAnchorPosition = require("@atlaskit/top-layer/use-anchor-position");
var _useAnchorPositionAtPoint = require("@atlaskit/top-layer/use-anchor-position-at-point");
var _usePopoverId = require("@atlaskit/top-layer/use-popover-id");
var _useWidthFromAnchor = require("@atlaskit/top-layer/use-width-from-anchor");
var _rectPointForPlacement = require("./internal/rect-point-for-placement");
var _useFitViewportMaxSize = require("./internal/use-fit-viewport-max-size");
var _useManagerAnchor = require("./internal/use-manager-anchor");
var _useReferenceVisibility = require("./internal/use-reference-visibility");
/**
 * Inert render-prop values. The browser owns positioning under CSS Anchor
 * Positioning, so `style` / `ref` / `arrowProps` / `update` / `forceUpdate`
 * are no-ops that consumers can safely spread. Module scope keeps identities
 * stable for effect dep arrays.
 */ const noopStyle = {};
const noopSetRef = (0, _noopDefault.default);
const noopUpdate = ()=>Promise.resolve(null);
const noopForceUpdate = ()=>({});
const noopArrowProps = {
    ref: noopSetRef,
    style: noopStyle,
    'data-popper-arrow': true
};
/**
 * Returns whether the current page is laid out right-to-left.
 */ function isPageRtl() {
    const document = (0, _browserApis.getDocument)();
    if (!document) return false;
    return document.dir === 'rtl' || document.body.dir === 'rtl' || document.documentElement.dir === 'rtl';
}
/**
 * `@popperjs/core`'s `Placement` union is a strict subset of
 * `TLegacyPlacement` (the placement-map adds `top-center` /
 * `bottom-center` on top of popper's enum), so every value popper hands
 * us is a valid legacy placement. The cast keeps the runtime path free
 * of an extra module-level lookup that bundlers can occasionally fail
 * to wire up (observed as `Cannot read properties of undefined (reading
 * 'includes')` in component-test bundles).
 */ function toLegacyPlacement(placement) {
    return placement;
}
/**
 * Returns the primary axis (`top` / `bottom` / `left` / `right`) of a popper
 * placement, used to pick which axis `useFitViewportMaxSize` caps to the
 * anchor edge.
 */ function getPlacementAxis(placement) {
    if (placement.startsWith('top')) return 'top';
    if (placement.startsWith('bottom')) return 'bottom';
    if (placement.startsWith('left')) return 'left';
    if (placement.startsWith('right')) return 'right';
    // `auto*` placements have no fixed axis. Default to `bottom` to match the
    // `auto -> block-end` mapping in `fromLegacyPlacement`.
    return 'bottom';
}
/**
 * Normalises popper's `[along, away]` offset (which may include `null` or
 * `undefined` entries) into the `[along, away]` number tuple
 * `fromLegacyPlacement` expects.
 */ function popperToTopLayerOffset(offset) {
    if (!offset) return undefined;
    const [along, away] = offset;
    if (along == null && away == null) return undefined;
    return [
        along !== null && along !== void 0 ? along : 0,
        away !== null && away !== void 0 ? away : 0
    ];
}
function PopperTopLayer({ children, offset, placement = 'bottom-start', referenceElement, shouldFitViewport = false }) {
    // `modifiers` and `strategy` are accepted for source compatibility but have
    // no runtime effect; CSS Anchor Positioning + top-layer rendering replaces
    // them. See `top-layer/notes/migrations/popper-migration.md`.
    // Anchor resolution: `referenceElement` prop, then `<Manager>` context.
    const managerAnchor = (0, _useManagerAnchor.useManagerAnchor)();
    var _ref;
    const effectiveReference = (_ref = referenceElement !== null && referenceElement !== void 0 ? referenceElement : managerAnchor) !== null && _ref !== void 0 ? _ref : undefined;
    // Real DOM nodes go to `useAnchorPosition`; popper `VirtualElement`s are
    // bridged through `useAnchorPositionAtPoint`, which owns its own synthetic
    // anchor.
    const htmlAnchor = effectiveReference instanceof HTMLElement ? effectiveReference : null;
    const virtualReference = effectiveReference != null && !(effectiveReference instanceof HTMLElement) ? effectiveReference : null;
    const htmlAnchorRef = (0, _react.useRef)(htmlAnchor);
    htmlAnchorRef.current = htmlAnchor;
    const popoverRef = (0, _react.useRef)(null);
    const popoverId = (0, _usePopoverId.usePopoverId)();
    // Track the resolved DOM anchor in state so visibility / max-size hooks
    // re-run when its identity changes. Virtual anchors do not feed these
    // hooks because their probe is outside the consumer's DOM.
    //
    // Adjust state during render by comparing against the state itself: the
    // conditional guard means `setResolvedAnchor` is skipped once they match,
    // so it converges in one extra render. This is the React-documented pattern
    // and is side-effect-free — no ref mutation during render.
    const [resolvedAnchor, setResolvedAnchor] = (0, _react.useState)(htmlAnchor);
    if (resolvedAnchor !== htmlAnchor) setResolvedAnchor(htmlAnchor);
    const topLayerPlacement = (0, _react.useMemo)(()=>{
        return (0, _placementMap.fromLegacyPlacement)({
            legacy: toLegacyPlacement(placement),
            offset: popperToTopLayerOffset(offset)
        });
    }, [
        placement,
        offset
    ]);
    const isOpen = effectiveReference != null;
    // HTML-element path. No-op when the reference is virtual or absent.
    (0, _useAnchorPosition.useAnchorPosition)({
        anchorRef: htmlAnchorRef,
        popoverRef,
        placement: topLayerPlacement,
        isEnabled: htmlAnchor != null,
        isOpen
    });
    // Virtual-element path. `useAnchorPositionAtPoint` owns a synthetic
    // anchor in `document.body` and latches `getPoint` once per
    // `isEnabled` activation. Reading the latest `virtualReference` and
    // `topLayerPlacement` via refs ensures the latched closure always
    // sees the current values rather than the ones captured at first
    // activation, which would otherwise go stale if either prop changes
    // while the popper stays open.
    const virtualReferenceRef = (0, _react.useRef)(virtualReference);
    virtualReferenceRef.current = virtualReference;
    const topLayerPlacementRef = (0, _react.useRef)(topLayerPlacement);
    topLayerPlacementRef.current = topLayerPlacement;
    const isVirtualEnabled = virtualReference != null;
    (0, _useAnchorPositionAtPoint.useAnchorPositionAtPoint)({
        popoverRef,
        placement: topLayerPlacement,
        isEnabled: isVirtualEnabled,
        isOpen,
        getPoint: ()=>{
            const current = virtualReferenceRef.current;
            if (!current) return null;
            return (0, _rectPointForPlacement.rectPointForPlacement)({
                rect: current.getBoundingClientRect(),
                placement: topLayerPlacementRef.current,
                isRtl: isPageRtl()
            });
        }
    });
    const { isReferenceHidden, hasPopperEscaped } = (0, _useReferenceVisibility.useReferenceVisibility)({
        anchor: resolvedAnchor,
        popoverRef
    });
    // Restore legacy `react-popper`'s natural-width behaviour. Under CSS
    // Anchor Positioning the `position-area` grid cell becomes the popover
    // host's containing block, so an auto-width host shrinks to that cell.
    // When the anchor sits near a viewport edge the cell is narrow, so the
    // content wraps far more than it did under `react-popper` (which kept the
    // content's natural width and shifted/flipped to stay on screen).
    // `min-inline-size: max-content` (mode `'none'`) floors the host at its
    // content's intrinsic width, so a too-narrow span overflows the viewport
    // (driving `position-try-fallbacks`) instead of wrapping. This is safe
    // alongside `shouldFitViewport`: the fit caps clamp the host on both axes,
    // so the host never exceeds the viewport / anchor-edge cap.
    (0, _useWidthFromAnchor.useWidthFromAnchor)({
        mode: 'none',
        popoverRef,
        anchorRef: htmlAnchorRef,
        isOpen
    });
    // `shouldFitViewport` caps are applied directly to the `position-area`
    // host, whose containing block is the cell between the anchor edge and the
    // viewport edge — so a pure-CSS `calc(100% - 5px - gap)` reproduces the
    // legacy per-placement anchor-edge cap with no measurement. The gap mirrors
    // `getPlacement`: an omitted offset resolves to `space.100`, otherwise the
    // consumer's `away` value.
    const resolvedOffset = popperToTopLayerOffset(offset);
    const fitGap = resolvedOffset ? `${resolvedOffset[1]}px` : "var(--ds-space-100, 8px)";
    const placementAxis = getPlacementAxis(placement);
    (0, _useFitViewportMaxSize.useFitViewportMaxSize)({
        target: popoverRef,
        placementAxis,
        gap: fitGap,
        isEnabled: shouldFitViewport,
        isOpen
    });
    const renderChildren = children;
    if (typeof renderChildren !== 'function') return null;
    const renderPropArg = {
        ref: noopSetRef,
        style: noopStyle,
        placement,
        isReferenceHidden,
        hasPopperEscaped,
        update: noopUpdate,
        forceUpdate: noopForceUpdate,
        arrowProps: noopArrowProps
    };
    const content = renderChildren(renderPropArg);
    // The `shouldFitViewport` size caps live on the `<Popover>` host itself
    // (applied by `useFitViewportMaxSize` above), so the consumer's content is
    // rendered directly with no intermediate wrapper.
    return /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _popover.Popover), {
        ref: popoverRef,
        id: popoverId,
        isOpen: isOpen,
        mode: "manual",
        animate: false
    }, content);
}

},{"react":"ltHCL","@atlaskit/browser-apis":"1bRFZ","@atlaskit/ds-lib/noop":"faKzG","@atlaskit/top-layer/placement-map":"fBy31","@atlaskit/top-layer/popover":"hLw5z","@atlaskit/top-layer/use-anchor-position":"6ghLj","@atlaskit/top-layer/use-anchor-position-at-point":"1BeoO","@atlaskit/top-layer/use-popover-id":"6C7Zl","@atlaskit/top-layer/use-width-from-anchor":"geRT5","./internal/rect-point-for-placement":"41wjV","./internal/use-fit-viewport-max-size":"8n82B","./internal/use-manager-anchor":"9H3bP","./internal/use-reference-visibility":"746ze","@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"fBy31":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "fromLegacyPlacement", ()=>(0, _placementMap.fromLegacyPlacement));
parcelHelpers.export(exports, "LEGACY_PLACEMENTS", ()=>(0, _legacyPlacements.LEGACY_PLACEMENTS));
var _placementMap = require("../placement-map");
var _legacyPlacements = require("../placement-map/legacy-placements");

},{"../placement-map":"hw3tZ","../placement-map/legacy-placements":false,"@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"hw3tZ":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
/**
 * Maps legacy Popper.js placement values to the new object-based
 * `Placement` values used by `@atlaskit/top-layer/popover`.
 *
 * **Mapping logic:**
 *
 * | Legacy (Popper.js)  | New (Placement object)                              |
 * | ------------------- | --------------------------------------------------- |
 * | `top`               | `{ axis: 'block', edge: 'start', align: 'center' }`  |
 * | `top-start`         | `{ axis: 'block', edge: 'start', align: 'start' }`   |
 * | `top-center`        | `{ axis: 'block', edge: 'start', align: 'center' }`  |
 * | `top-end`           | `{ axis: 'block', edge: 'start', align: 'end' }`     |
 * | `bottom`            | `{ axis: 'block', edge: 'end', align: 'center' }`    |
 * | `bottom-start`      | `{ axis: 'block', edge: 'end', align: 'start' }`     |
 * | `bottom-center`     | `{ axis: 'block', edge: 'end', align: 'center' }`    |
 * | `bottom-end`        | `{ axis: 'block', edge: 'end', align: 'end' }`       |
 * | `right`             | `{ axis: 'inline', edge: 'end', align: 'center' }`   |
 * | `right-start`       | `{ axis: 'inline', edge: 'end', align: 'start' }`    |
 * | `right-end`         | `{ axis: 'inline', edge: 'end', align: 'end' }`      |
 * | `left`              | `{ axis: 'inline', edge: 'start', align: 'center' }` |
 * | `left-start`        | `{ axis: 'inline', edge: 'start', align: 'start' }`  |
 * | `left-end`          | `{ axis: 'inline', edge: 'start', align: 'end' }`    |
 * | `auto`              | `{ axis: 'block', edge: 'end', align: 'center' }`    |
 * | `auto-start`        | `{ axis: 'block', edge: 'end', align: 'start' }`     |
 * | `auto-end`          | `{ axis: 'block', edge: 'end', align: 'end' }`       |
 *
 * `auto*` is mapped to `block-end` (a reduction in expressiveness vs Popper's
 * runtime auto-flip). CSS `position-try-fallbacks` provides flipping at the
 * edge - but the initial placement is fixed. If migrating away from Popper's
 * dynamic auto, prefer an explicit placement.
 *
 * @example
 * ```ts
 * import { fromLegacyPlacement } from '@atlaskit/top-layer/placement-map';
 *
 * // In a migration from @atlaskit/popup:
 * const oldPlacement: TLegacyPlacement = 'bottom-start';
 * const newPlacement: TPlacementOptions = fromLegacyPlacement({ legacy: oldPlacement });
 * // newPlacement === { axis: 'block', edge: 'end', align: 'start' }
 * ```
 */ parcelHelpers.export(exports, "fromLegacyPlacement", ()=>fromLegacyPlacement);
var _objectSpread = require("@swc/helpers/_/_object_spread");
var _objectSpreadProps = require("@swc/helpers/_/_object_spread_props");
var _placementMapping = require("./placement-mapping");
function fromLegacyPlacement({ legacy, offset }) {
    const basePlacement = (0, _placementMapping.placementMapping)[legacy];
    if (!offset) return basePlacement;
    const [along, away] = offset;
    return (0, _objectSpreadProps._)((0, _objectSpread._)({}, basePlacement), {
        offset: {
            gap: away,
            crossAxisShift: {
                // Sign is captured in `direction`; `value` is the magnitude.
                value: Math.abs(along),
                direction: along >= 0 ? 'forwards' : 'backwards'
            }
        }
    });
}

},{"@swc/helpers/_/_object_spread":"9gdrV","@swc/helpers/_/_object_spread_props":"kANqQ","./placement-mapping":"g9QEJ","@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"g9QEJ":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "placementMapping", ()=>placementMapping);
const placementMapping = {
    top: {
        axis: 'block',
        edge: 'start',
        align: 'center'
    },
    'top-start': {
        axis: 'block',
        edge: 'start',
        align: 'start'
    },
    'top-center': {
        axis: 'block',
        edge: 'start',
        align: 'center'
    },
    'top-end': {
        axis: 'block',
        edge: 'start',
        align: 'end'
    },
    bottom: {
        axis: 'block',
        edge: 'end',
        align: 'center'
    },
    'bottom-start': {
        axis: 'block',
        edge: 'end',
        align: 'start'
    },
    'bottom-center': {
        axis: 'block',
        edge: 'end',
        align: 'center'
    },
    'bottom-end': {
        axis: 'block',
        edge: 'end',
        align: 'end'
    },
    right: {
        axis: 'inline',
        edge: 'end',
        align: 'center'
    },
    'right-start': {
        axis: 'inline',
        edge: 'end',
        align: 'start'
    },
    'right-end': {
        axis: 'inline',
        edge: 'end',
        align: 'end'
    },
    left: {
        axis: 'inline',
        edge: 'start',
        align: 'center'
    },
    'left-start': {
        axis: 'inline',
        edge: 'start',
        align: 'start'
    },
    'left-end': {
        axis: 'inline',
        edge: 'start',
        align: 'end'
    },
    auto: {
        axis: 'block',
        edge: 'end',
        align: 'center'
    },
    'auto-start': {
        axis: 'block',
        edge: 'end',
        align: 'start'
    },
    'auto-end': {
        axis: 'block',
        edge: 'end',
        align: 'end'
    }
};

},{"@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"hLw5z":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "createPopoverCloseEvent", ()=>(0, _popover.createPopoverCloseEvent));
parcelHelpers.export(exports, "Popover", ()=>(0, _popover.Popover));
var _popover = require("../popover");

},{"../popover":"9aNvj","@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"9aNvj":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "Popover", ()=>(0, _popover.Popover));
parcelHelpers.export(exports, "createPopoverCloseEvent", ()=>(0, _createCloseEvent.createPopoverCloseEvent));
var _popover = require("./popover");
var _createCloseEvent = require("./create-close-event");

},{"./popover":"8E0fj","./create-close-event":"1aZvn","@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"8E0fj":[function(require,module,exports,__globalThis) {
/* popover.tsx generated by @compiled/babel-plugin v0.39.1 */ var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "Popover", ()=>Popover);
var _jsxRuntime = require("react/jsx-runtime");
var _runtime = require("@compiled/react/runtime");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _bindEventListener = require("bind-event-listener");
var _mergeRefs = require("@atlaskit/ds-lib/merge-refs");
var _mergeRefsDefault = parcelHelpers.interopDefault(_mergeRefs);
var _once = require("@atlaskit/ds-lib/once");
var _onceDefault = parcelHelpers.interopDefault(_once);
var _openLayerObserver = require("@atlaskit/layering/experimental/open-layer-observer");
var _roleTypes = require("../internal/role-types");
var _setStyle = require("../internal/set-style");
var _useAnimatedVisibility = require("../internal/use-animated-visibility");
var _useFocusWrap = require("../internal/use-focus-wrap");
var _useInitialFocus = require("../internal/use-initial-focus");
var _animations = require("./animations");
/**
 * Detects `popover="hint"` support via DOM reflection. SSR-safe, cached.
 */ const supportsPopoverHint = (0, _onceDefault.default)(()=>{
    if (typeof document === 'undefined') return false;
    // eslint-disable-next-line @atlaskit/platform/no-direct-document-usage -- feature detection
    const element = document.createElement('div');
    element.setAttribute('popover', 'hint');
    return element.popover === 'hint';
});
// These animation styles use the non-strict Compiled cssMap because they rely
// on `@starting-style`, `:popover-open`, `[dir='rtl']`, and `allow-discrete`.
// Keep them in this component so the Compiled transform can statically extract
// every referenced style.
const popoverAnimationStyles = {
    root: "_y44vof1f _k8m011k7 _1oecdn4k _1s9z1a5r _1o51q7pw _5sagdn4k _1pgl1lbj _15ns179n _12t71ign _n70peoah _1psg1ign _o8i7indk _bl8aglyw _156yru3m _8rmvglyw _2qm2ru3m"
};
const styles = {
    root: "_19itglyw _ca0qidpf _u5f3idpf _n3tdidpf _19bvidpf _19pkidpf _2hwxidpf _otyridpf _18u0idpf _1r041wug _1reoewfl _18m9ewfl _bfhk1j28 _4t3i1wug"
};
/**
 * Roles registered with the open layer observer as `popup`, so `closeLayers()`
 * dismisses them. `modal` comes from Dialog only; other layer types are unused.
 */ const POPUP_ROLES = new Set([
    'menu',
    'listbox',
    'dialog',
    'alertdialog',
    'tree',
    'grid'
]);
const Popover = /*#__PURE__*/ (0, _react.forwardRef)(function Popover({ children, mode: modeProp = 'auto', onClose, onOpenChange, onEnterFinish, onExitFinish, animate = false, placement, testId, isOpen, xcss: consumerXcss, // ARIA
role, label, labelledBy, id: idProp }, ref) {
    const autoId = (0, _react.useId)();
    const ownRef = (0, _react.useRef)(null);
    const combinedRef = (0, _mergeRefsDefault.default)([
        ownRef,
        ref
    ].filter(Boolean));
    // `useId()` colons are invalid in CSS selectors and popover target attributes.
    const popoverId = idProp !== null && idProp !== void 0 ? idProp : `popover-${autoId.replace(/:/g, '')}`;
    const { phase, preset } = (0, _useAnimatedVisibility.useAnimatedVisibility)({
        isOpen,
        animationKind: 'popover',
        animate,
        elementRef: ownRef,
        onEnterFinish,
        onExitFinish
    });
    // True while the host element is mounted (any phase except `closed`).
    // Used as a dep so listener-rebind effects re-attach after a remount.
    const isVisible = phase !== 'closed';
    // Focus management: initial focus on entry (role-dependent), Tab cycling
    // for dialog roles. Restoration is native for outermost popovers; nested
    // focus-capturing roles are handled below via the `beforetoggle` snapshot.
    // Passing `phase` keeps `useFocusWrap` attached through the animated-exit
    // window (WCAG 2.4.3 guard). See notes/architecture/focus-restoration.md.
    (0, _useFocusWrap.useFocusWrap)({
        elementRef: ownRef,
        role,
        phase
    });
    (0, _useInitialFocus.useInitialFocus)({
        elementRef: ownRef,
        phase,
        role
    });
    // Register with open layer observer so `closeLayers()` and open-count
    // subscriptions work. Only popup-like roles register as `popup`; passive
    // roles (tooltip, status, etc.) leave `type` undefined.
    const handleObserverClose = (0, _react.useCallback)(()=>{
        onClose === null || onClose === void 0 ? void 0 : onClose({
            reason: 'programmatic'
        });
    }, [
        onClose
    ]);
    (0, _openLayerObserver.useNotifyOpenLayerObserver)({
        type: role && POPUP_ROLES.has(role) ? 'popup' : undefined,
        isOpen,
        onClose: handleObserverClose
    });
    // `hint` falls back to `auto` when unsupported: closest behavior (light
    // dismiss works), but `auto` participates in the auto-dismiss stack so it
    // will close other `auto` popovers when opened. Acceptable trade-off given
    // shrinking browser set without `hint` support.
    const mode = modeProp === 'hint' && !supportsPopoverHint() ? 'auto' : modeProp;
    // Prevents toggle handler from calling onClose for our own hidePopover() calls.
    const programmaticCloseRef = (0, _react.useRef)(false);
    // Set in capture-phase keydown so the toggle handler knows close reason.
    const closeReasonRef = (0, _react.useRef)('light-dismiss');
    // Snapshot of pre-open focus, used to restore focus for nested popovers
    // with focus-capturing roles (browser only restores the outermost).
    const previouslyFocusedElementRef = (0, _react.useRef)(null);
    const handleBeforeToggle = (0, _react.useCallback)((event)=>{
        if (event.newState !== 'open') return;
        // eslint-disable-next-line @atlaskit/platform/no-direct-document-usage -- need active element snapshot
        const active = document.activeElement;
        previouslyFocusedElementRef.current = active instanceof HTMLElement ? active : null;
    }, []);
    const handleToggle = (0, _react.useCallback)((event)=>{
        const element = ownRef.current;
        if (event.newState === 'open') {
            if (element) onOpenChange === null || onOpenChange === void 0 ? void 0 : onOpenChange({
                isOpen: true,
                element: element
            });
            return;
        }
        if (event.newState === 'closed') {
            if (element) {
                onOpenChange === null || onOpenChange === void 0 ? void 0 : onOpenChange({
                    isOpen: false,
                    element: element
                });
                // Nested-popover focus restoration fallback (browser only
                // restores outermost; Firefox skips nested entirely).
                // Restore only when the role moved focus in on open AND the
                // close was Escape/programmatic. For light dismiss, the
                // click target keeps focus per HTML spec
                // (`focusPreviousElement=false`).
                const previouslyFocused = previouslyFocusedElementRef.current;
                const reason = closeReasonRef.current;
                const isProgrammatic = programmaticCloseRef.current;
                const shouldRestore = previouslyFocused !== null && previouslyFocused.isConnected && (0, _roleTypes.shouldFocusIntoPopover)({
                    role
                }) && (reason === 'escape' || isProgrammatic);
                if (shouldRestore && previouslyFocused) previouslyFocused.focus({
                    preventScroll: true
                });
                previouslyFocusedElementRef.current = null;
            }
            // Programmatic close: consumer already knows.
            if (programmaticCloseRef.current) {
                // Reset reason so a stale 'escape' from a race with Escape keydown
                // does not corrupt the next browser-dismiss cycle.
                closeReasonRef.current = 'light-dismiss';
                return;
            }
            // Browser dismiss (Escape/click-outside).
            const reason = closeReasonRef.current;
            closeReasonRef.current = 'light-dismiss';
            // Optional: `manual` mode has no `onClose` in the forwarded type.
            onClose === null || onClose === void 0 ? void 0 : onClose({
                reason
            });
        }
    }, [
        onClose,
        onOpenChange,
        role
    ]);
    // Bind via `useLayoutEffect`, and BEFORE the show/hide layout effect
    // below, so listeners are attached when `showPopover()` synchronously
    // dispatches `beforetoggle`. A regular `useEffect` would miss that
    // first dispatch, dropping the `previouslyFocusedElementRef` snapshot
    // and breaking nested-popover focus restoration on close. React runs
    // layout effects in source order on the same commit.
    (0, _react.useLayoutEffect)(()=>{
        const element = ownRef.current;
        if (!element) return;
        // Tag Escape before the browser processes light dismiss.
        const unbindEscape = (0, _bindEventListener.bind)(element, {
            type: 'keydown',
            listener: (event)=>{
                if (event.key === 'Escape') closeReasonRef.current = 'escape';
            },
            options: {
                capture: true
            }
        });
        const unbindToggle = (0, _bindEventListener.bind)(element, {
            type: 'toggle',
            listener: handleToggle
        });
        // Snapshot `document.activeElement` before `useInitialFocus` moves it.
        const unbindBeforeToggle = (0, _bindEventListener.bind)(element, {
            type: 'beforetoggle',
            listener: handleBeforeToggle
        });
        return ()=>{
            unbindEscape();
            unbindToggle();
            unbindBeforeToggle();
        };
    }, [
        handleToggle,
        handleBeforeToggle,
        isVisible
    ]);
    // Placement-dependent animation CSS vars. Kept separate from show/hide
    // so preset reference changes do not re-trigger visibility. The cleanup
    // restores the previous inline values so a preset change does not leave
    // stale custom properties on the element.
    (0, _react.useLayoutEffect)(()=>{
        const element = ownRef.current;
        if (!element || !placement) return;
        return (0, _setStyle.setStyle)({
            element,
            styles: (0, _animations.getPopupMotionStyles)({
                placement
            })
        });
    }, [
        preset,
        placement,
        isVisible
    ]);
    // Show/hide based on isOpen. `showPopover`/`hidePopover` are no-ops when
    // already in the target state. Try/catch guards `InvalidStateError` on
    // disconnected elements (StrictMode/concurrent/unmount edge cases).
    (0, _react.useLayoutEffect)(()=>{
        const element = ownRef.current;
        if (!element) return;
        if (isOpen) {
            programmaticCloseRef.current = false;
            // Clear stale 'escape' from a prior cycle: the ref outlives
            // the host element, and the no-animation path unmounts before
            // `handleToggle` can reset it.
            closeReasonRef.current = 'light-dismiss';
            try {
                element.showPopover();
            } catch (e) {}
            return ()=>{
                programmaticCloseRef.current = true;
                try {
                    element.hidePopover();
                } catch (e) {}
            };
        }
        programmaticCloseRef.current = true;
        try {
            element.hidePopover();
        } catch (e) {}
    }, [
        isOpen
    ]);
    // Unmount the host once exit completes so it does not leave an empty
    // `role`/`popover` element in the accessibility tree. The element
    // remounts on the next open; the `popoverId` is stable across opens.
    if (!isVisible) return null;
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
        ref: combinedRef,
        id: popoverId,
        // @ts-expect-error -- popover attribute not yet in React types
        // eslint-disable-next-line react/no-unknown-property -- popover attribute not yet in React types
        popover: mode,
        role: role,
        "aria-label": label,
        "aria-labelledby": labelledBy,
        "data-testid": testId,
        className: (0, _runtime.ax)([
            styles.root,
            preset && popoverAnimationStyles.root,
            consumerXcss
        ]),
        children: children
    });
});

},{"react/jsx-runtime":"bGvcw","@compiled/react/runtime":"d27Vo","react":"ltHCL","bind-event-listener":"bjeUU","@atlaskit/ds-lib/merge-refs":"doPwA","@atlaskit/ds-lib/once":"3Kj1N","@atlaskit/layering/experimental/open-layer-observer":"2Dqp9","../internal/role-types":"anEJG","../internal/set-style":"ae3H5","../internal/use-animated-visibility":"akb4B","../internal/use-focus-wrap":"7XjZG","../internal/use-initial-focus":"hNWjg","./animations":"fLvQb","@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"3Kj1N":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>once);
function once(fn) {
    let cache = null;
    return function result(...args) {
        if (!cache) cache = {
            value: fn.call(this, ...args)
        };
        /**
		 * Intentionally not adding `.clear()` function property
		 *
		 * - We currently have no need for it
		 * - We don't want to add a `.clear()` to functions that should never be called twice,
		 *   for example: `cleanup` functions.
		 * - We can add a `onceWithCleanup` variant as a separate export from ds-lib if the
		 *   need arises 🧘
		 */ return cache.value;
    };
}

},{"@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"anEJG":[function(require,module,exports,__globalThis) {
/**
 * Valid values for the `aria-haspopup` attribute.
 *
 * Derived from the HTML spec - maps popover roles to what the trigger
 * announces. `undefined` means the attribute is omitted entirely (used for
 * non-popup roles like `tooltip`/`status`/`alert`/`note`/`log` where
 * `aria-haspopup` would be misleading).
 *
 * `true` is intentionally NOT in the union - the runtime only ever produces
 * the explicit string forms, so widening the type would invite consumers to
 * pass `true` and get an `aria-haspopup="true"` serialisation that the
 * runtime no longer emits.
 */ var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
/**
 * Returns `true` when the given popover role moves focus into the popover
 * on open, and `false` otherwise (including when `role` is `undefined`).
 */ // eslint-disable-next-line @atlaskit/volt-strict-mode/no-multiple-exports
parcelHelpers.export(exports, "shouldFocusIntoPopover", ()=>shouldFocusIntoPopover);
const rolesThatMoveFocus = new Set([
    'dialog',
    'alertdialog',
    'menu',
    'listbox',
    'tree',
    'grid'
]);
function shouldFocusIntoPopover({ role }) {
    if (!role) return false;
    return rolesThatMoveFocus.has(role);
}

},{"@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"ae3H5":[function(require,module,exports,__globalThis) {
/**
 * Sets inline styles on an element and returns a cleanup function that
 * restores the prior inline values (so we do not stomp consumer styles).
 */ var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "setStyle", ()=>setStyle);
function setStyle({ element, styles }) {
    // Snapshot the prior inline value (NOT the computed style - we only want
    // to restore values that the consumer/our previous run inlined). An empty
    // string means "no inline value", in which case cleanup uses removeProperty.
    const priorValues = styles.map(({ property })=>({
            property,
            value: element.style.getPropertyValue(property)
        }));
    styles.forEach(({ property, value })=>{
        element.style.setProperty(property, value);
    });
    return function cleanup() {
        priorValues.forEach(({ property, value })=>{
            if (value === '') {
                element.style.removeProperty(property);
                return;
            }
            element.style.setProperty(property, value);
        });
    };
}

},{"@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"akb4B":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
/**
 * Manages the children mount/unmount lifecycle around CSS exit transitions.
 *
 * Used by both `Popover` and `Dialog` to share the same animation lifecycle
 * logic. Those components own their own show/hide mechanisms (showPopover /
 * hidePopover vs showModal / close) and event handling - this hook only
 * manages the relationship between `isOpen` and when children are rendered.
 *
 * ## Problem
 *
 * We want to delay the unmount of children until a CSS exit transition has
 * finished playing. If we unmount children the moment `isOpen` becomes
 * `false`, the exit animation is never visible - the content just disappears.
 *
 * ## How it works
 *
 * The lifecycle is modeled as a `phase` discriminated union (`closed`,
 * `entering`, `open`, `exiting`). The host element is rendered while
 * `phase !== 'closed'`, so the `exiting` phase keeps the host mounted
 * while the CSS exit transition plays (or, with animation disabled,
 * while we wait for the browser `toggle` / `close` event to fire on the
 * still-attached element):
 *
 * ```
 * isOpen:  true ──────────────── false
 * phase:   open ──────────────── exiting ─── (exit settle) ─── closed
 * ```
 *
 * Every effect dispatches on the single `phase` value instead of a
 * cross-product of booleans.
 */ parcelHelpers.export(exports, "useAnimatedVisibility", ()=>useAnimatedVisibility);
var _react = require("react");
var _bindEventListener = require("bind-event-listener");
var _reducedMotion = require("./reduced-motion");
/**
 * Using the recommended motion timings for safety net.
 *
 * Not setting these timings on the preset config because they're defined in the CSS,
 * so configuring it in the preset doesn't achieve anything except introduce a potential
 * source of drift.
 *
 * TODO: figure out a way to not need to redeclare these in the future,
 * and keep CSS and JS timings in sync always.
 */ const safetyNetMsMap = {
    dialog: {
        enter: 250,
        exit: 200
    },
    popover: {
        enter: 150,
        exit: 100
    }
};
/**
 * Fires `onSettled` once when `transitionend` fires on `element`, or after
 * `safetyNetMs` if the event is swallowed (mid-transition unmount, CSS
 * mismatch, browser quirks). Returns a cleanup that cancels both paths.
 */ function runOnTransitionEndOrTimeout({ element, safetyNetMs, onSettled }) {
    const state = {
        isSettled: false
    };
    function teardown() {
        state.isSettled = true;
        clearTimeout(safetyNetId);
        unbind();
    }
    function settle() {
        if (state.isSettled) return;
        teardown();
        onSettled();
    }
    const unbind = (0, _bindEventListener.bind)(element, {
        type: 'transitionend',
        listener: settle,
        options: {
            once: true
        }
    });
    const safetyNetId = setTimeout(settle, safetyNetMs);
    return teardown;
}
function useAnimatedVisibility({ isOpen, animationKind, animate, elementRef, onEnterFinish, onExitFinish }) {
    // Styles are applied via the `css` prop on the host element (see `Popover`
    // and `Dialog`), so there is no longer any CSS injection step. Normalize a
    // falsy `animate` to `null`.
    const preset = animate || null;
    // False when there is no preset or `prefers-reduced-motion` is set.
    const willAnimate = Boolean(animate) && !(0, _reducedMotion.prefersReducedMotion)();
    // Promote `closed → entering`/`closed → open` synchronously during
    // render so the host element mounts in the same commit as the open
    // intent. All other transitions are driven by phase-specific effects.
    const [phase, setPhase] = (0, _react.useState)(()=>{
        if (!isOpen) return 'closed';
        return willAnimate ? 'entering' : 'open';
    });
    if (isOpen && phase === 'closed') setPhase(willAnimate ? 'entering' : 'open');
    if (!isOpen && (phase === 'open' || phase === 'entering')) // Close intent. Move to `exiting` to gate the unmount on either
    // the exit transition (animated) or the toggle/close event
    // (non-animated). Includes interrupted entry (`entering → exiting`).
    setPhase('exiting');
    if (isOpen && phase === 'exiting') // Reopen mid-exit. With animation, jump back to `entering` and let
    // the entry transition restart from current visual state. Without
    // animation, jump straight to `open` (the handshake we were waiting
    // for is no longer relevant; the consumer wants the host visible
    // again synchronously).
    setPhase(willAnimate ? 'entering' : 'open');
    // Keep stable refs to the latest callbacks so effects and timeout closures
    // always call the current callback without needing them in dependency arrays.
    const onEnterFinishRef = (0, _react.useRef)(onEnterFinish);
    onEnterFinishRef.current = onEnterFinish;
    const onExitFinishRef = (0, _react.useRef)(onExitFinish);
    onExitFinishRef.current = onExitFinish;
    // Animated entry: wait for `transitionend` (or a safety-net timeout) and
    // move to `open`. The fallback guarantees settle on swallowed events
    // (zero-duration, browser quirk, mid-transition unmount).
    (0, _react.useEffect)(()=>{
        if (phase !== 'entering') return;
        const element = elementRef.current;
        if (!element) return;
        return runOnTransitionEndOrTimeout({
            element,
            safetyNetMs: safetyNetMsMap[animationKind].enter + 50,
            onSettled: ()=>{
                var // Fire the consumer callback before transitioning phase so any
                // state the consumer reads (refs, DOM nodes) is still attached
                // in the same synchronous tick, regardless of React batching
                // semantics.
                _onEnterFinishRef_current;
                (_onEnterFinishRef_current = onEnterFinishRef.current) === null || _onEnterFinishRef_current === void 0 ? void 0 : _onEnterFinishRef_current.call(onEnterFinishRef);
                setPhase((current)=>current === 'entering' ? 'open' : current);
            }
        });
    }, [
        phase,
        animationKind,
        elementRef
    ]);
    // Non-animated entry callback. The lifecycle goes `closed → open`
    // directly with no `entering` phase; fire `onEnterFinish` on that jump.
    // A previous-phase ref avoids double-firing on the animated path.
    const prevPhaseForEntryRef = (0, _react.useRef)('closed');
    (0, _react.useEffect)(()=>{
        var _onEnterFinishRef_current;
        const prevPhase = prevPhaseForEntryRef.current;
        prevPhaseForEntryRef.current = phase;
        // Animated entry settle goes through `entering` and already fired
        // onEnterFinish above; only handle the non-animated direct jumps.
        if (prevPhase !== 'open' && phase === 'open' && prevPhase !== 'entering') (_onEnterFinishRef_current = onEnterFinishRef.current) === null || _onEnterFinishRef_current === void 0 ? void 0 : _onEnterFinishRef_current.call(onEnterFinishRef);
    }, [
        phase
    ]);
    // Animated exit: wait for `transitionend` (or a safety-net timeout),
    // fire `onExitFinish`, then move to `closed` to unmount the host.
    (0, _react.useEffect)(()=>{
        if (phase !== 'exiting' || !willAnimate) return;
        const element = elementRef.current;
        if (!element) return;
        return runOnTransitionEndOrTimeout({
            element,
            safetyNetMs: safetyNetMsMap[animationKind].exit + 50,
            onSettled: ()=>{
                var // Fire the consumer callback before transitioning phase to
                // `closed`. The phase change drives the host element unmount,
                // and consumers expect to be able to read the element (or a
                // forwarded ref to it) inside `onExitFinish`. Doing this in
                // the safe order avoids relying on React's automatic batching
                // to keep the element attached across the callback.
                _onExitFinishRef_current;
                (_onExitFinishRef_current = onExitFinishRef.current) === null || _onExitFinishRef_current === void 0 ? void 0 : _onExitFinishRef_current.call(onExitFinishRef);
                setPhase((current)=>current === 'exiting' ? 'closed' : current);
            }
        });
    }, [
        phase,
        willAnimate,
        animationKind,
        elementRef
    ]);
    // Non-animated exit: wait for the browser's `toggle` (closed) or
    // `close` event before unmounting, so the consumer's listener (close
    // reason, nested focus restoration, `onClose`) and the browser's
    // native focus restoration both run against the still-attached
    // element. A naive `setTimeout(0)` occasionally beats the `toggle`
    // task in Chromium and drops focus restoration.
    //
    // `useLayoutEffect` so the listener binds in the same commit as the
    // show/hide layout effect that calls `hidePopover()` / `dialog.close()`.
    // The toggle/close event is queued as a task and cannot run until the
    // frame completes. SSR-safe: `phase` starts at `'closed'`.
    //
    // `onExitFinish` is fired separately (see effect below) so consumers
    // observe it the moment `isOpen` flips to `false`.
    (0, _react.useLayoutEffect)(()=>{
        if (phase !== 'exiting' || willAnimate) return;
        const element = elementRef.current;
        if (!element) return;
        function unmount() {
            setPhase((current)=>current === 'exiting' ? 'closed' : current);
        }
        return (0, _bindEventListener.bindAll)(element, [
            {
                type: 'toggle',
                listener: (event)=>{
                    if (event.newState === 'closed') unmount();
                }
            },
            {
                type: 'close',
                listener: unmount
            }
        ]);
    }, [
        phase,
        willAnimate,
        elementRef
    ]);
    // Non-animated exit callback. No `transitionend` to wait for, so fire
    // `onExitFinish` on the transition into `exiting` (the unmount itself
    // is gated by the toggle/close handshake above).
    const prevPhaseForExitRef = (0, _react.useRef)('closed');
    (0, _react.useEffect)(()=>{
        var _onExitFinishRef_current;
        const prevPhase = prevPhaseForExitRef.current;
        prevPhaseForExitRef.current = phase;
        // Only fire on the non-animated transition into `exiting`. The
        // animated path's `exiting → closed` settle already fires
        // `onExitFinish` from `runOnTransitionEndOrTimeout`.
        if (prevPhase !== 'exiting' && phase === 'exiting' && !willAnimate) (_onExitFinishRef_current = onExitFinishRef.current) === null || _onExitFinishRef_current === void 0 ? void 0 : _onExitFinishRef_current.call(onExitFinishRef);
    }, [
        phase,
        willAnimate
    ]);
    return {
        phase,
        preset
    };
}

},{"react":"ltHCL","bind-event-listener":"bjeUU","./reduced-motion":"8tCXN","@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"8tCXN":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "prefersReducedMotion", ()=>prefersReducedMotion);
var _once = require("@atlaskit/ds-lib/once");
var _onceDefault = parcelHelpers.interopDefault(_once);
const prefersReducedMotion = (0, _onceDefault.default)(()=>{
    if (typeof window === 'undefined' || !('matchMedia' in window)) return false;
    return window.matchMedia('(prefers-reduced-motion: reduce)').matches;
});

},{"@atlaskit/ds-lib/once":"3Kj1N","@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"7XjZG":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
/**
 * Wraps Tab/Shift+Tab focus within a popover element when its role
 * semantically requires it (dialog, alertdialog).
 *
 * While the popover is open, Tab and Shift+Tab are intercepted
 * (via `preventDefault`) and remapped to cycle through focusable
 * elements within the container using wrapping navigation.
 *
 * Light dismiss (Escape, click outside) continues to work natively
 * via `popover="auto"` - this hook only intercepts Tab.
 *
 * Always call this hook unconditionally. The listener is only
 * attached when the role requires focus wrapping, and is cleaned
 * up and re-evaluated when the role changes.
 */ parcelHelpers.export(exports, "useFocusWrap", ()=>useFocusWrap);
var _react = require("react");
var _bindEventListener = require("bind-event-listener");
var _getFirstFocusable = require("../focus/get-first-focusable");
var _getLastFocusable = require("../focus/get-last-focusable");
var _getNextFocusable = require("../focus/get-next-focusable");
var _isNestedLayerFocused = require("../focus/is-nested-layer-focused");
/**
 * Roles that require focus wrapping per WAI-ARIA APG.
 *
 * - `dialog`: https://www.w3.org/WAI/ARIA/apg/patterns/dialog-modal/
 * - `alertdialog`: same keyboard pattern as dialog
 *
 * `menu` is intentionally excluded. Menus are composite widgets
 * (https://www.w3.org/WAI/ARIA/apg/practices/keyboard-interface/#kbd_general_within)
 * that manage their own internal keyboard navigation via arrow keys,
 * not Tab. Tab/Shift+Tab should move focus OUT of a menu entirely.
 *
 * Menu keyboard behavior (arrow keys, Home/End, type-ahead, Enter/Space)
 * is context-dependent. It varies by orientation, nesting depth, item
 * type, and control pattern (menu button vs menubar). This makes it
 * impossible to implement generically here. The consumer component
 * (e.g. `dropdown-menu`) owns all menu keyboard navigation.
 *
 * See: notes/outputs/menu-keyboard-decision.md
 */ function roleRequiresFocusWrap(role) {
    return role === 'dialog' || role === 'alertdialog';
}
function useFocusWrap({ elementRef, role, phase }) {
    const isVisible = phase !== 'closed';
    (0, _react.useEffect)(()=>{
        const element = elementRef.current;
        if (!element || !roleRequiresFocusWrap(role) || !isVisible) return;
        const unbind = (0, _bindEventListener.bind)(element, {
            type: 'keydown',
            listener: (event)=>{
                if (event.key !== 'Tab') return;
                // If focus is already in a nested layer, then
                // we continue to let that nested layer own focus
                if ((0, _isNestedLayerFocused.isNestedLayerFocused)({
                    container: element
                })) return;
                // Prevent the browser giving focus to where it wants to
                // (we will be handling it, including with wrapping)
                event.preventDefault();
                const direction = event.shiftKey ? 'backwards' : 'forwards';
                // Try to move to the next/previous focusable element relative
                // to the currently focused element within the container.
                const next = (0, _getNextFocusable.getNextFocusable)({
                    container: element,
                    direction
                });
                if (next) {
                    next.focus();
                    return;
                }
                // Nothing is currently focused inside the container (or the
                // focused element is not in the focusable list). Fall back to
                // the first or last focusable element depending on direction.
                const fallback = direction === 'forwards' ? (0, _getFirstFocusable.getFirstFocusable)({
                    container: element
                }) : (0, _getLastFocusable.getLastFocusable)({
                    container: element
                });
                if (fallback) fallback.focus();
            },
            options: {
                capture: true
            }
        });
        return unbind;
    }, [
        elementRef,
        role,
        isVisible
    ]);
}

},{"react":"ltHCL","bind-event-listener":"bjeUU","../focus/get-first-focusable":"jj1om","../focus/get-last-focusable":"2mG9F","../focus/get-next-focusable":"a3aLC","../focus/is-nested-layer-focused":"cNB0B","@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"jj1om":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
/**
 * Returns the first focusable element within the container.
 */ parcelHelpers.export(exports, "getFirstFocusable", ()=>getFirstFocusable);
var _getFocusables = require("./get-focusables");
function getFirstFocusable({ container, filter }) {
    const items = (0, _getFocusables.getFocusables)({
        container,
        filter
    });
    return items.length > 0 ? items[0] : null;
}

},{"./get-focusables":"j1YVb","@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"j1YVb":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
/**
 * Returns all focusable HTMLElements within the container, optionally filtered.
 *
 * Focusables that belong to a nested top-layer scope (a `[popover]` or
 * `<dialog>` descendant of the container) are excluded - those elements
 * are owned by the inner layer's focus management. The container itself
 * is allowed to be a popover/dialog; only nested ones are filtered.
 */ parcelHelpers.export(exports, "getFocusables", ()=>getFocusables);
var _isInSameLayer = require("./is-in-same-layer");
var _selectors = require("./selectors");
function getFocusables({ container, filter }) {
    return Array.from(container.querySelectorAll((0, _selectors.selectors).focusable)).filter((element)=>element instanceof HTMLElement).filter((element)=>(0, _isInSameLayer.isInSameLayer)({
            element,
            container
        })).filter((element)=>!filter || filter(element, container));
}

},{"./is-in-same-layer":"j4wDW","./selectors":"RSRls","@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"j4wDW":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
/**
 * Returns true when `element` and `container` resolve to the same nearest
 * top-layer host (or both resolve to `null`, meaning the document layer).
 */ parcelHelpers.export(exports, "isInSameLayer", ()=>isInSameLayer);
const topLayerSelector = '[popover], dialog, [role="dialog"], [role="alertdialog"]';
function isInSameLayer({ element, container }) {
    const elementLayer = element.closest(topLayerSelector);
    const containerLayer = container.closest(topLayerSelector);
    // Both elements are in the "document" layer
    if (!elementLayer && !containerLayer) return true;
    return elementLayer === containerLayer;
}

},{"@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"RSRls":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "selectors", ()=>selectors);
const selectors = (()=>{
    // Common exclusion filter applied to every selector.
    const not = ':not([tabindex="-1"]):not([aria-disabled="true"]):not([aria-hidden="true"])';
    const notDisabled = `:not([disabled])${not}`;
    const focusable = [
        `a[href]${not}`,
        `area[href]${not}`,
        `input${notDisabled}:not([type="hidden"])`,
        `select${notDisabled}`,
        `textarea${notDisabled}`,
        `button${notDisabled}`,
        `iframe${not}`,
        `audio[controls]${not}`,
        `video[controls]${not}`,
        `[contenteditable]:not([contenteditable="false"])${not}`,
        `[tabindex]${notDisabled}${not}`
    ];
    return {
        focusable: focusable.join(','),
        // Build the `:focus` selector
        focused: focusable.map((selector)=>`${selector}:focus`).join(',')
    };
})();

},{"@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"2mG9F":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
/**
 * Returns the last focusable element within the container.
 */ parcelHelpers.export(exports, "getLastFocusable", ()=>getLastFocusable);
var _getFocusables = require("./get-focusables");
function getLastFocusable({ container, filter }) {
    const items = (0, _getFocusables.getFocusables)({
        container,
        filter
    });
    return items.length > 0 ? items[items.length - 1] : null;
}

},{"./get-focusables":"j1YVb","@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"a3aLC":[function(require,module,exports,__globalThis) {
/**
 * Returns the next focusable element in the given direction relative to the
 * currently focused element within the container. Wraps around at both ends.
 *
 * Returns `null` if there is no focused element within the container or if
 * the focused element is not in the list of focusable elements.
 */ var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "getNextFocusable", ()=>getNextFocusable);
var _getFocusables = require("./get-focusables");
var _selectors = require("./selectors");
function getNextFocusable({ container, direction, filter }) {
    const all = (0, _getFocusables.getFocusables)({
        container,
        filter
    });
    const current = container.querySelector((0, _selectors.selectors).focused);
    if (!(current instanceof HTMLElement)) return null;
    const index = all.indexOf(current);
    if (index === -1) return null;
    const nextIndex = (()=>{
        if (direction === 'forwards') return (index + 1) % all.length;
        const proposed = index - 1;
        // if going into negative numbers, loop back to the last item
        return proposed < 0 ? all.length - 1 : proposed;
    })();
    var _all_nextIndex;
    return (_all_nextIndex = all[nextIndex]) !== null && _all_nextIndex !== void 0 ? _all_nextIndex : null;
}

},{"./get-focusables":"j1YVb","./selectors":"RSRls","@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"cNB0B":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
/**
 * Returns `true` when `document.activeElement` is inside a nested top-layer
 * descendant of `container` (a `[popover]`, `<dialog>`, `[role="dialog"]` or
 * `[role="alertdialog"]` that is itself a descendant of `container`).
 */ parcelHelpers.export(exports, "isNestedLayerFocused", ()=>isNestedLayerFocused);
var _browserApis = require("@atlaskit/browser-apis");
var _isInSameLayer = require("./is-in-same-layer");
function isNestedLayerFocused({ container }) {
    var _getDocument;
    const focused = (_getDocument = (0, _browserApis.getDocument)()) === null || _getDocument === void 0 ? void 0 : _getDocument.activeElement;
    if (!(focused instanceof HTMLElement)) return false;
    // Cannot be in a nested layer if it is not in the container
    if (!container.contains(focused)) return false;
    // If not in the same layer, must be in a nested layer
    return !(0, _isInSameLayer.isInSameLayer)({
        element: focused,
        container
    });
}

},{"@atlaskit/browser-apis":"1bRFZ","./is-in-same-layer":"j4wDW","@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"hNWjg":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
/**
 * Moves focus into a popover element when it opens, based on its ARIA role.
 *
 * Follows the WAI-ARIA APG initial-focus patterns for each role:
 * - `dialog` / `alertdialog` → focus first focusable (or `[autofocus]`)
 * - `menu` → focus first menu item
 * - `listbox` → focus selected or first option
 * - `tooltip` / no role → no focus movement (focus must remain on trigger;
 *   moving focus into the tooltip would dismiss it)
 *
 * Role is taken from the typed `role` prop - this is the consumer's contract
 * and is not subject to drift from a directly-mutated DOM attribute.
 *
 * Always call this hook unconditionally. Focus is moved on each transition
 * into a visible phase, the moment the host element first becomes visible
 * for that open intent:
 *
 * - Animated path: on `closed → entering`. The host has just been mounted
 *   and the layout effect that calls `showPopover()` / `showModal()` has
 *   already run, so the element is in the top layer. We focus before the
 *   entry transition settles to match the WAI-ARIA APG expectation that
 *   focus lands on the new menu / dialog the instant it opens, not after
 *   the CSS finishes animating.
 * - Non-animated path: on `closed → open` (the entering phase is skipped).
 * - Reopen mid-exit: on `exiting → entering`. When a user dismisses the
 *   popup (Escape, close button, light dismiss) the browser natively
 *   restores focus to the trigger as part of `hidePopover()` /
 *   `<dialog>.close()`. If the consumer reopens before the exit transition
 *   has settled, the phase machine jumps `exiting → entering` without
 *   passing through `closed`, so without this branch the popup would be
 *   visible again with focus stranded on the trigger - a keyboard usability
 *   gap for menu/dialog/listbox roles.
 *
 * Note: there is a rare programmatic path where a consumer flips `isOpen`
 * false → true without any user-initiated close gesture and had moved focus
 * to a non-default target inside the popup. In that scenario this hook
 * re-focuses the role-appropriate default (e.g. first menu item) rather
 * than preserving the consumer-chosen target. This matches the documented
 * `closed → entering` behavior and is considered acceptable given how
 * abstract the scenario is. See `notes/architecture/focus.md`.
 *
 * Pure `entering → exiting → entering` stutters where the popup never
 * reaches `closed` and the consumer toggles in the same frame are still
 * collapsed: the `prevPhase` ref guard rejects any transition whose
 * previous phase was not `closed` or `exiting`.
 *
 * Tradeoff vs the previous `requestAnimationFrame` based approach: we no
 * longer wait one paint before focusing. The element is already attached
 * and in the top layer when this effect runs (the show / hide layout
 * effect runs first), so screen-reader announcement and visible focus
 * land together. If a regression appears that needs the extra paint
 * (e.g. browsers that require a layout pass before `focus()` works on a
 * freshly promoted top-layer element), wrap the `focus()` call in a
 * single `requestAnimationFrame` here and re-add a same-element ref
 * check inside the RAF callback.
 */ parcelHelpers.export(exports, "useInitialFocus", ()=>useInitialFocus);
var _react = require("react");
var _getFirstFocusable = require("../focus/get-first-focusable");
/**
 * Determines the correct element to receive initial focus within a popover,
 * based on its ARIA role.
 *
 * Focus rules by role (per WAI-ARIA APG):
 * - `dialog` / `alertdialog`: first element with `[autofocus]`, or first focusable element
 * - `menu`: first menu item (`[role="menuitem|menuitemcheckbox|menuitemradio"]`)
 * - `listbox`: first selected option (`[aria-selected="true"]`), or first option (`[role="option"]`)
 * - `tooltip`: no focus movement (tooltips are informational)
 * - no role / other roles: no focus movement
 *
 * Note: React 18's `autoFocus` JSX prop does NOT set the HTML `autofocus`
 * attribute - it only calls `.focus()` imperatively during commit, which
 * has no effect on hidden popover content. Consumers must set the native
 * attribute via a ref callback (e.g. `node.setAttribute('autofocus', '')`).
 * React 19+ reflects the JSX prop as the HTML attribute automatically.
 *
 * Combobox pattern exception: if the popup is controlled by a focused
 * combobox-like trigger (its `aria-controls` references this popup),
 * focus stays on the textbox regardless of role. See
 * `isComboboxControllingPopup`.
 */ /**
 * WAI-ARIA APG Combobox Pattern: when a combobox controls a popup (listbox,
 * grid, tree, or menu), DOM focus must remain on the textbox. Subsequent
 * navigation through popup items uses `aria-activedescendant` (or proxied
 * keyboard events), never DOM focus movement.
 *
 * Detects both variants in a single pass:
 * - In-popup combobox: the textbox lives inside the popup `container`
 *   (the popup is rendered as a child of the combobox wrapper).
 * - External combobox: the textbox is rendered OUTSIDE the popup
 *   (`react-select` pattern, where the listbox is portalled separately
 *   from the textbox).
 *
 * Acceptance criteria for the active element:
 * - Role / element-type filter: `role="combobox"`, `role="textbox"`,
 *   `TEXTAREA`, `contentEditable`, or `INPUT` of text-like type
 *   (`text`, `search`, `email`, `url`, `tel`, `password`, or
 *   unspecified). Non-text input types (`button`, `checkbox`, etc.)
 *   are rejected.
 * - Reference filter: `aria-controls` (or legacy `aria-owns`) IDREFS
 *   must resolve to an element that IS or CONTAINS the popup container.
 *
 * See: https://www.w3.org/WAI/ARIA/apg/patterns/combobox/
 */ // `<input>` types treated as text-like for combobox detection.
// Non-text input types (`button`, `checkbox`, `submit`, etc.) are rejected.
// A missing `type` attribute defaults to `text` per the HTML spec, so we
// normalize that case before lookup rather than including an empty string here.
const TEXT_LIKE_INPUT_TYPES = new Set([
    'text',
    'search',
    'email',
    'url',
    'tel',
    'password'
]);
function isTextboxLikeElement(element) {
    const role = element.getAttribute('role');
    if (role === 'combobox' || role === 'textbox') return true;
    // `tagName` is uppercase for HTML elements but can be mixed-case for
    // XML/SVG. Normalize once so downstream comparisons stay lowercase.
    const tag = element.tagName.toLowerCase();
    if (tag === 'textarea') return true;
    if (element.isContentEditable) return true;
    if (tag === 'input') {
        var _element_getAttribute;
        const type = ((_element_getAttribute = element.getAttribute('type')) !== null && _element_getAttribute !== void 0 ? _element_getAttribute : 'text').toLowerCase();
        return TEXT_LIKE_INPUT_TYPES.has(type);
    }
    return false;
}
function isComboboxControllingPopup({ container }) {
    const ownerDocument = container.ownerDocument;
    const active = ownerDocument.activeElement;
    if (!(active instanceof HTMLElement)) return false;
    if (!isTextboxLikeElement(active)) return false;
    var _active_getAttribute;
    // Accept legacy `aria-owns` in addition to `aria-controls`.
    // `aria-controls` / `aria-owns` are IDREFS (space-separated list of IDs)
    // per the WAI-ARIA spec, so we must split and check membership rather
    // than comparing with strict equality. A combobox that controls both
    // this popup and another element (e.g. a results status region) must
    // still be recognised as controlling this popup.
    const idRefs = (_active_getAttribute = active.getAttribute('aria-controls')) !== null && _active_getAttribute !== void 0 ? _active_getAttribute : active.getAttribute('aria-owns');
    if (!idRefs) return false;
    // Match if any referenced element IS, CONTAINS, or IS CONTAINED BY the
    // popup container. The "contained by" case covers wrapper-style adopters
    // like react-select, where the combobox input's `aria-controls` points at
    // a listbox element that is a descendant of the Popover host (the
    // listbox role lives on a child the wrapped library owns, not on the
    // host we render).
    const referencedIds = idRefs.split(/\s+/).filter((id)=>id !== '');
    return referencedIds.some((id)=>{
        const referenced = ownerDocument.getElementById(id);
        if (!referenced) return false;
        return referenced === container || referenced.contains(container) || container.contains(referenced);
    });
}
function getInitialFocusTarget({ container, role }) {
    if (role === 'dialog' || role === 'alertdialog') {
        // Prefer element with the native HTML autofocus attribute.
        const autofocusEl = container.querySelector('[autofocus]');
        if (autofocusEl) return autofocusEl;
        // Fall back to first focusable element
        return (0, _getFirstFocusable.getFirstFocusable)({
            container
        });
    }
    // The combobox carve-out is kept role-specific (menu / listbox) rather
    // than hoisted. Hoisting it over-matched on dialog popups that contain
    // a nested combobox (e.g. datetime-picker's dialog hosts a react-select),
    // where the active combobox's `aria-controls` falsely matched the
    // container and suppressed the dialog's own focus contract.
    if (role === 'menu') {
        if (isComboboxControllingPopup({
            container
        })) return null;
        // Initial focus placement is the extent of what top-layer provides
        // for menus. All subsequent keyboard navigation (arrow keys, Home/End,
        // type-ahead, Enter/Space, submenu coordination) is the responsibility
        // of the consumer component (e.g. dropdown-menu), because menu keyboard
        // behavior varies by context (orientation, nesting, item type, control
        // pattern). See: notes/outputs/menu-keyboard-decision.md
        return (0, _getFirstFocusable.getFirstFocusable)({
            container
        });
    }
    if (role === 'listbox') {
        // ARIA Combobox Pattern: if a combobox-like textbox owns the popup
        // (in-popup or external e.g. react-select), leave focus on the
        // textbox - navigation is proxied through it.
        if (isComboboxControllingPopup({
            container
        })) return null;
        // Prefer the selected option, then fall back to the first option.
        // We intentionally match by `[role="option"]` rather than by
        // `getFirstFocusable`. The standard WAI-ARIA APG listbox pattern
        // renders options with `tabindex="-1"` (managed via roving
        // tabindex); `getFirstFocusable` excludes `tabindex="-1"` elements
        // and would silently lose initial focus for spec-conformant
        // listboxes. Options remain programmatically focusable.
        const selectedOption = container.querySelector('[role="option"][aria-selected="true"]');
        if (selectedOption) return selectedOption;
        const firstOption = container.querySelector('[role="option"]');
        if (firstOption) return firstOption;
        // Last resort for non-standard listboxes that render no options
        // but do contain a focusable element (e.g. an empty-state action).
        return (0, _getFirstFocusable.getFirstFocusable)({
            container
        });
    }
    // tooltip, no role, or other roles: no focus movement
    return null;
}
function useInitialFocus({ elementRef, phase, role }) {
    // Track the previous phase so we only focus on transitions into a
    // visible phase from either `'closed'` (fresh mount) or `'exiting'`
    // (mid-exit reopen where the browser has already restored focus to
    // the trigger). Pure `entering → exiting → entering` stutters where
    // the consumer toggles in the same frame are still collapsed.
    const prevPhaseRef = (0, _react.useRef)('closed');
    (0, _react.useEffect)(()=>{
        var _getInitialFocusTarget;
        const prevPhase = prevPhaseRef.current;
        prevPhaseRef.current = phase;
        // Only focus on transitions into a visible phase from `'closed'`
        // (fresh open) or `'exiting'` (mid-exit reopen).
        if (phase === 'closed') return;
        if (prevPhase !== 'closed' && prevPhase !== 'exiting') return;
        const element = elementRef.current;
        if (!element) return;
        (_getInitialFocusTarget = getInitialFocusTarget({
            container: element,
            role
        })) === null || _getInitialFocusTarget === void 0 ? void 0 : _getInitialFocusTarget.focus();
    }, [
        elementRef,
        phase,
        role
    ]);
}

},{"react":"ltHCL","../focus/get-first-focusable":"jj1om","@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"fLvQb":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "getPopupMotionStyles", ()=>getPopupMotionStyles);
var _resolvePlacement = require("../internal/resolve-placement");
function getPopupMotionStyles({ placement }) {
    const { axis, edge } = (0, _resolvePlacement.getPlacement)({
        placement
    });
    if (axis === 'block' && edge === 'start') return [
        {
            property: '--ds-popover-motion-enter',
            value: "var(--ds-popup-enter-top, 150ms cubic-bezier(0.4, 1, 0.6, 1) SlideInTop8px, 150ms cubic-bezier(0.4, 1, 0.6, 1) FadeIn0to100)"
        },
        {
            property: '--ds-popover-motion-exit',
            value: "var(--ds-popup-exit-top, 100ms cubic-bezier(0.6, 0, 0.8, 0.6) SlideOutTop8px, 100ms cubic-bezier(0.6, 0, 0.8, 0.6) FadeOut100to0)"
        }
    ];
    if (axis === 'inline' && edge === 'start') return [
        {
            property: '--ds-popover-motion-enter',
            value: "var(--ds-popup-enter-left, 150ms cubic-bezier(0.4, 1, 0.6, 1) SlideInLeft8px, 150ms cubic-bezier(0.4, 1, 0.6, 1) FadeIn0to100)"
        },
        {
            property: '--ds-popover-motion-exit',
            value: "var(--ds-popup-exit-left, 100ms cubic-bezier(0.6, 0, 0.8, 0.6) SlideOutLeft8px, 100ms cubic-bezier(0.6, 0, 0.8, 0.6) FadeOut100to0)"
        }
    ];
    if (axis === 'inline' && edge === 'end') return [
        {
            property: '--ds-popover-motion-enter',
            value: "var(--ds-popup-enter-right, 150ms cubic-bezier(0.4, 1, 0.6, 1) SlideInRight8px, 150ms cubic-bezier(0.4, 1, 0.6, 1) FadeIn0to100)"
        },
        {
            property: '--ds-popover-motion-exit',
            value: "var(--ds-popup-exit-right, 100ms cubic-bezier(0.6, 0, 0.8, 0.6) SlideOutRight8px, 100ms cubic-bezier(0.6, 0, 0.8, 0.6) FadeOut100to0)"
        }
    ];
    // Default: block/end (popover below trigger)
    return [
        {
            property: '--ds-popover-motion-enter',
            value: "var(--ds-popup-enter-bottom, 150ms cubic-bezier(0.4, 1, 0.6, 1) SlideInBottom8px, 150ms cubic-bezier(0.4, 1, 0.6, 1) FadeIn0to100)"
        },
        {
            property: '--ds-popover-motion-exit',
            value: "var(--ds-popup-exit-bottom, 100ms cubic-bezier(0.6, 0, 0.8, 0.6) SlideOutBottom8px, 100ms cubic-bezier(0.6, 0, 0.8, 0.6) FadeOut100to0)"
        }
    ];
}

},{"../internal/resolve-placement":"iv3Jy","@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"iv3Jy":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
/**
 * Resolves a partial placement to its fully-specified form. Number offsets
 * are normalized to `${n}px` strings.
 *
 * Defaults: `axis: 'block'`, `edge: 'end'`, `align: 'center'`,
 * `offset.gap: token('space.100', '8px')`,
 * `offset.crossAxisShift: { value: '0px', direction: 'forwards' }`.
 */ parcelHelpers.export(exports, "getPlacement", ()=>getPlacement);
var _resolveCssLength = require("./resolve-css-length");
/**
 * Default gap between trigger and popover. Resolves to a design
 * token (`space.100`) so the value follows the design system's spacing
 * scale. Used when `placement.offset.gap` is not provided.
 */ const DEFAULT_GAP = "var(--ds-space-100, 8px)";
function getPlacement({ placement }) {
    var _placement_offset, _placement_offset_crossAxisShift, _placement_offset1, _placement_offset_crossAxisShift1, _placement_offset2;
    const consumerGap = (_placement_offset = placement.offset) === null || _placement_offset === void 0 ? void 0 : _placement_offset.gap;
    var _placement_axis, _placement_edge, _placement_align, _placement_offset_crossAxisShift_value, _placement_offset_crossAxisShift_direction;
    return {
        axis: (_placement_axis = placement.axis) !== null && _placement_axis !== void 0 ? _placement_axis : 'block',
        edge: (_placement_edge = placement.edge) !== null && _placement_edge !== void 0 ? _placement_edge : 'end',
        align: (_placement_align = placement.align) !== null && _placement_align !== void 0 ? _placement_align : 'center',
        offset: {
            gap: consumerGap === undefined ? DEFAULT_GAP : (0, _resolveCssLength.toCssLengthString)({
                value: consumerGap
            }),
            crossAxisShift: {
                value: (0, _resolveCssLength.toCssLengthString)({
                    value: (_placement_offset_crossAxisShift_value = (_placement_offset1 = placement.offset) === null || _placement_offset1 === void 0 ? void 0 : (_placement_offset_crossAxisShift = _placement_offset1.crossAxisShift) === null || _placement_offset_crossAxisShift === void 0 ? void 0 : _placement_offset_crossAxisShift.value) !== null && _placement_offset_crossAxisShift_value !== void 0 ? _placement_offset_crossAxisShift_value : 0
                }),
                direction: (_placement_offset_crossAxisShift_direction = (_placement_offset2 = placement.offset) === null || _placement_offset2 === void 0 ? void 0 : (_placement_offset_crossAxisShift1 = _placement_offset2.crossAxisShift) === null || _placement_offset_crossAxisShift1 === void 0 ? void 0 : _placement_offset_crossAxisShift1.direction) !== null && _placement_offset_crossAxisShift_direction !== void 0 ? _placement_offset_crossAxisShift_direction : 'forwards'
            }
        }
    };
}

},{"./resolve-css-length":"TxOe7","@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"TxOe7":[function(require,module,exports,__globalThis) {
/**
 * Normalizes an offset to a CSS length string. Numbers become `${n}px`;
 * strings pass through. Apply at the API boundary so internal code only
 * deals with strings.
 */ var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "toCssLengthString", ()=>toCssLengthString);
function toCssLengthString({ value }) {
    if (typeof value === 'number') return `${value}px`;
    return value;
}

},{"@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"1aZvn":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
/**
 * Creates a synthetic DOM event from a `TPopoverCloseReason`.
 *
 * Useful when bridging the Popover primitive's `onClose({ reason })` callback
 * to a legacy API that expects a native DOM event - for example,
 * `@atlaskit/inline-dialog`'s `onClose(event)` contract.
 *
 * - `'escape'` → `KeyboardEvent('keydown', { key: 'Escape' })`
 * - `'light-dismiss'` → `MouseEvent('click')`
 *
 * For any other reason, a generic `Event('close')` is returned as a fallback.
 *
 * @example
 * ```tsx
 * import { createPopoverCloseEvent, type TPopoverCloseReason } from '@atlaskit/top-layer/popover';
 *
 * function onPopoverClose({ reason }: { reason: TPopoverCloseReason }) {
 *   legacyOnClose(createPopoverCloseEvent({ reason }));
 * }
 * ```
 */ parcelHelpers.export(exports, "createPopoverCloseEvent", ()=>createPopoverCloseEvent);
function createPopoverCloseEvent({ reason }) {
    if (reason === 'escape') return new KeyboardEvent('keydown', {
        key: 'Escape',
        bubbles: true
    });
    if (reason === 'light-dismiss') return new MouseEvent('click', {
        bubbles: true,
        cancelable: true
    });
    return new Event('close');
}

},{"@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"6ghLj":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "useAnchorPosition", ()=>(0, _useAnchorPosition.useAnchorPosition));
var _useAnchorPosition = require("../internal/use-anchor-position");

},{"../internal/use-anchor-position":"bcfEr","@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"bcfEr":[function(require,module,exports,__globalThis) {
/**
 * Anchor positioning for top-layer popovers. See
 * `notes/architecture/positioning.md` for the full model.
 *
 * Two runtime paths: CSS Anchor Positioning (modern browsers) and a JS
 * fallback that measures the trigger and writes `top`/`left`.
 *
 * Both paths honour `offset.gap` and `offset.crossAxisShift`. The
 * CSS path passes the values through as strings; the JS fallback resolves
 * them to pixels via a hidden DOM probe (see `resolveCssLengthToPixels`)
 * so tokens, `calc()`, `var()`, etc all work. The JS fallback hides the
 * popover with `opacity: 0` until the first measurement completes, so it
 * is never painted at the wrong location.
 */ var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
/**
 * Hook that positions an element relative to an anchor element using
 * CSS Anchor Positioning (with a JS fallback for older browsers).
 *
 * This hook is the positioning primitive. It has no knowledge of popovers,
 * visibility, or animation. Compose it with `Popover` for anchor-positioned
 * top-layer content.
 *
 * When CSS Anchor Positioning is supported, it sets CSS properties
 * (`anchor-name`, `position-anchor`, `position-area`, `position-try-fallbacks`)
 * directly on the elements via `el.style.setProperty()`.
 *
 * When not supported, it falls back to JavaScript-based positioning using
 * `position: fixed` with measured coordinates, re-running on scroll (capture)
 * and resize events.
 */ // eslint-disable-next-line @atlaskit/volt-strict-mode/no-multiple-exports
parcelHelpers.export(exports, "useAnchorPosition", ()=>useAnchorPosition);
var _react = require("react");
var _bindEventListener = require("bind-event-listener");
var _rafSchd = require("raf-schd");
var _rafSchdDefault = parcelHelpers.interopDefault(_rafSchd);
var _once = require("@atlaskit/ds-lib/once");
var _onceDefault = parcelHelpers.interopDefault(_once);
var _anchorPositioningFallback = require("./anchor-positioning-fallback");
var _combine = require("./combine");
var _placementToPositionArea = require("./placement-to-position-area");
var _placementToTryFallbacks = require("./placement-to-try-fallbacks");
var _resolveCssLengthToPixels = require("./resolve-css-length-to-pixels");
var _resolvePlacement = require("./resolve-placement");
var _setStyle = require("./set-style");
// `getPlacement` is intentionally NOT re-exported here - import it directly
// from `./resolve-placement` so search-and-jump lands at the source of truth.
/**
 * Module-scope no-op `ResizeObserver` used in non-DOM jest environments where
 * `ResizeObserver` is `undefined`. Hoisted out of the effect to avoid
 * allocating a new class declaration on every run.
 */ const NoopResizeObserver = class {
    observe() {}
    unobserve() {}
    disconnect() {}
};
/**
 * Returns true when the popover is currently open. Wrapped because the
 * `:popover-open` pseudo-class is not implemented in some test environments
 * (e.g. jsdom), where `matches` throws on unknown selectors.
 */ function isPopoverOpen(popover) {
    try {
        return popover.matches(':popover-open');
    } catch (e) {
        return false;
    }
}
/**
 * Detects whether the browser supports CSS Anchor Positioning.
 * Uses `once()` for lazy evaluation: safe for SSR and avoids hydration mismatches.
 */ const supportsAnchorPositioning = (0, _onceDefault.default)(()=>{
    if (typeof window === 'undefined' || typeof CSS === 'undefined' || typeof CSS.supports !== 'function') return false;
    return CSS.supports('anchor-name', '--a');
});
/**
 * Returns the CSS margin declaration that creates a gap between the
 * popover and its trigger on the side facing the anchor.
 *
 * For example, a `block-end` placement (popover below) gets
 * `margin-block-start: 8px` to push it away from the trigger's bottom edge.
 */ function edgeMargin({ placement, offset }) {
    const { axis, edge } = placement;
    const value = offset;
    if (axis === 'block' && edge === 'end') return {
        property: 'margin-block-start',
        value
    };
    if (axis === 'block' && edge === 'start') return {
        property: 'margin-block-end',
        value
    };
    if (axis === 'inline' && edge === 'end') return {
        property: 'margin-inline-start',
        value
    };
    if (axis === 'inline' && edge === 'start') return {
        property: 'margin-inline-end',
        value
    };
    return {
        property: 'margin-block-start',
        value
    };
}
/**
 * Cross-axis shift margin. Margin side matches the popover's anchored
 * cross-axis edge: `align: 'start'` uses the START margin, `align: 'end'`
 * uses the END margin with the sign inverted (so `forwards` is always
 * positive), `align: 'center'` uses START. Margin on the un-anchored side
 * has no effect under CSS Anchor Positioning.
 */ function crossAxisShiftMargin({ placement, crossAxisShiftCssValue, direction }) {
    const { axis, align } = placement;
    const directionSign = direction === 'forwards' ? 1 : -1;
    const crossAxis = axis === 'block' ? 'inline' : 'block';
    const useEndSide = align === 'end';
    const side = useEndSide ? 'end' : 'start';
    const sideSign = useEndSide ? -1 : 1;
    const finalSign = directionSign * sideSign;
    // Wrap any string in calc() with the sign factor. CSS handles the math.
    const value = finalSign === 1 ? crossAxisShiftCssValue : `calc(-1 * ${crossAxisShiftCssValue})`;
    return {
        property: `margin-${crossAxis}-${side}`,
        value
    };
}
/**
 * Returns a referentially-stable, fully-resolved `TPlacement`. The memo is
 * keyed on the resolved primitive fields so a fresh inline `placement` object
 * (or undefined fields vs explicit defaults) does not produce a fresh result.
 */ function useStablePlacement(placement) {
    const resolved = (0, _resolvePlacement.getPlacement)({
        placement
    });
    const axis = resolved.axis;
    const edge = resolved.edge;
    const align = resolved.align;
    const gap = resolved.offset.gap;
    const shiftValue = resolved.offset.crossAxisShift.value;
    const shiftDirection = resolved.offset.crossAxisShift.direction;
    // Rebuild inside the memo from primitive deps so the factory does not
    // close over the outer `resolved` reference and exhaustive-deps can verify.
    return (0, _react.useMemo)(()=>({
            axis,
            edge,
            align,
            offset: {
                gap,
                crossAxisShift: {
                    value: shiftValue,
                    direction: shiftDirection
                }
            }
        }), [
        axis,
        edge,
        align,
        gap,
        shiftValue,
        shiftDirection
    ]);
}
function useAnchorPosition({ anchorRef, popoverRef, placement = {}, forceFallbackPositioning = false, isEnabled = true, isOpen }) {
    const id = (0, _react.useId)();
    const stablePlacement = useStablePlacement(placement);
    (0, _react.useLayoutEffect)(()=>{
        if (!isEnabled) return;
        const trigger = anchorRef.current;
        const popover = popoverRef.current;
        if (!trigger || !popover) return;
        const gapCssValue = stablePlacement.offset.gap;
        const crossAxisShiftCssValue = stablePlacement.offset.crossAxisShift.value;
        const shouldForceFallback = Boolean(forceFallbackPositioning);
        if (supportsAnchorPositioning() && !shouldForceFallback) {
            // Reuse an existing `anchor-name` if the element already has one.
            // Another popover might already be anchored to the old name.
            const anchorName = trigger.style.getPropertyValue('anchor-name') || `--anchor-${id.replace(/:/g, '')}`;
            const gap = edgeMargin({
                placement: stablePlacement,
                offset: gapCssValue
            });
            // Computed once; reused below to populate the active
            // `--ds-cross-axis-shift-margin-*` custom property for the
            // named arrow @position-try rules.
            const crossAxisShift = crossAxisShiftMargin({
                placement: stablePlacement,
                crossAxisShiftCssValue,
                direction: stablePlacement.offset.crossAxisShift.direction
            });
            const popoverStyles = [
                {
                    property: 'position-anchor',
                    value: anchorName
                },
                {
                    property: 'position-area',
                    value: (0, _placementToPositionArea.placementToPositionArea)({
                        placement: stablePlacement
                    })
                },
                {
                    property: 'position-try-fallbacks',
                    value: (0, _placementToTryFallbacks.placementToTryFallbacks)({
                        placement: stablePlacement
                    })
                },
                // Reset browser default popover positioning that conflicts
                // with anchor positioning (UA: `inset: 0; margin: auto;`)
                {
                    property: 'margin',
                    value: '0'
                },
                {
                    property: 'inset',
                    value: 'auto'
                },
                {
                    property: gap.property,
                    value: gap.value
                },
                {
                    property: crossAxisShift.property,
                    value: crossAxisShift.value
                }
            ];
            // Expose the active cross-axis shift via custom properties so each
            // named arrow @position-try rule can re-apply it after a flip.
            // One of the four (cross-axis, side) properties is non-zero at a time.
            popoverStyles.push({
                property: '--ds-cross-axis-shift-margin-start',
                value: '0px'
            });
            popoverStyles.push({
                property: '--ds-cross-axis-shift-margin-end',
                value: '0px'
            });
            popoverStyles.push({
                property: '--ds-cross-axis-shift-margin-block-start',
                value: '0px'
            });
            popoverStyles.push({
                property: '--ds-cross-axis-shift-margin-block-end',
                value: '0px'
            });
            // `crossAxisShift` IS the active margin; reuse instead of recomputing.
            const crossAxisShiftActive = crossAxisShift;
            const customPropertyByMarginProperty = {
                'margin-inline-start': '--ds-cross-axis-shift-margin-start',
                'margin-inline-end': '--ds-cross-axis-shift-margin-end',
                'margin-block-start': '--ds-cross-axis-shift-margin-block-start',
                'margin-block-end': '--ds-cross-axis-shift-margin-block-end'
            };
            const crossAxisShiftCustomProperty = customPropertyByMarginProperty[crossAxisShiftActive.property];
            if (crossAxisShiftCustomProperty) popoverStyles.push({
                property: crossAxisShiftCustomProperty,
                value: crossAxisShiftActive.value
            });
            /**
			 * **We are never cleaning up anchor names**
			 *
			 * _Rationale_
			 *
			 * - Multiple popovers can share the same anchor element.
			 * - Sometimes the `useAnchorPosition` hook and `Popover`
			 *   are not in the same component.
			 * - There can be times when, even with reference counting, we
			 *   could remove the anchor-name while it is still being used
			 *   by something else - especially with async react updates
			 *   which can cause tearing
			 *
			 * _More_
			 *
			 * See `notes/decisions/anchor-name-lifetime.md`
			 */ trigger.style.setProperty('anchor-name', anchorName);
            const undoPositioning = (0, _combine.combine)((0, _setStyle.setStyle)({
                element: popover,
                styles: popoverStyles
            }));
            return undoPositioning;
        }
        // JS fallback. The popover is already in the top layer via
        // popover="auto", so we only reset UA defaults and set top/left
        // based on measurements.
        const cleanupBaseStyles = (0, _setStyle.setStyle)({
            element: popover,
            styles: [
                {
                    property: 'margin',
                    value: '0'
                },
                {
                    property: 'inset',
                    value: 'auto'
                }
            ]
        });
        function update() {
            if (!trigger || !popover) return;
            const triggerRect = trigger.getBoundingClientRect();
            const viewport = {
                width: window.innerWidth,
                height: window.innerHeight
            };
            // Resolve consumer-supplied CSS length strings (tokens, calc, var,
            // px, rem, etc) to pixels. The probe is mounted INSIDE the popover
            // itself so the resolved length matches the scope a token would
            // resolve against from inside the popover content. (The popover
            // lives in the top layer, not the trigger's DOM tree, so probing
            // at `popover.parentElement` would resolve in a different scope
            // than the consumer's token authoring expects.)
            const gapPx = (0, _resolveCssLengthToPixels.resolveCssLengthToPixels)({
                value: gapCssValue,
                container: popover
            });
            const crossAxisShiftPx = (0, _resolveCssLengthToPixels.resolveCssLengthToPixels)({
                value: crossAxisShiftCssValue,
                container: popover
            });
            const { top, left } = (0, _anchorPositioningFallback.computeFallbackPosition)({
                triggerRect,
                popoverEl: popover,
                placement: stablePlacement,
                viewport,
                gap: gapPx,
                crossAxisShift: {
                    value: crossAxisShiftPx,
                    direction: stablePlacement.offset.crossAxisShift.direction
                }
            });
            popover.style.setProperty('top', `${top}px`);
            popover.style.setProperty('left', `${left}px`);
            // Reveal the popover only after it has been positioned.
            // See the toggle listener below for why we hide on open.
            popover.style.removeProperty('opacity');
        }
        // Throttle scroll/resize updates to one per animation frame
        const scheduledUpdate = (0, _rafSchdDefault.default)(update);
        // Wait for the FIRST valid layout before measuring: the popover
        // is `display: none` until `showPopover()`, and some browsers
        // fire `toggle` before layout, so RAF-after-toggle is unreliable.
        // ResizeObserver fires once the browser has real dimensions.
        // Self-disconnects after one valid measurement; ongoing
        // scroll/resize is handled by the window listeners below.
        // `ResizeObserver` is missing in some non-DOM jest environments
        // (e.g. post-office's `node` environment). Fall back to a no-op
        // observer there. The scroll/resize listeners below still keep
        // the popover positioned in the rare case the consumer also
        // polyfilled `showPopover` but not `ResizeObserver`. Real
        // browsers always have it. The `NoopResizeObserver` class is
        // hoisted to module scope (see top of file) so we do not allocate
        // a new constructor on every effect run.
        const ResizeObserverImpl = typeof ResizeObserver !== 'undefined' ? ResizeObserver : NoopResizeObserver;
        const resizeObserver = new ResizeObserverImpl(()=>{
            if (popover.offsetWidth > 0 && popover.offsetHeight > 0) {
                update();
                resizeObserver.disconnect();
            }
        });
        // If the popover is already open by the time this effect runs (for
        // example, the parent `useAnchorPosition` effect runs after the child
        // `Popover` effect that called `showPopover()`), the initial `toggle`
        // event has already fired and our listener below would miss it. Start
        // observing immediately so the first measurement still happens.
        if (isPopoverOpen(popover)) {
            popover.style.setProperty('opacity', '0');
            resizeObserver.observe(popover);
        }
        const undoPositioning = (0, _combine.combine)(cleanupBaseStyles, // On every open: hide synchronously so the user never sees
        // the UA-default position, then re-observe for a fresh
        // measurement. We use `opacity: 0` rather than
        // `visibility: hidden` because Firefox skips visibility-hidden
        // elements during `<dialog>` initial-focus traversal. See
        // `form-in-popup.spec.tsx` on `desktop-firefox`.
        (0, _bindEventListener.bind)(popover, {
            type: 'toggle',
            listener: (event)=>{
                const toggleEvent = event;
                if (toggleEvent.newState === 'open') {
                    popover.style.setProperty('opacity', '0');
                    resizeObserver.observe(popover);
                }
            }
        }), ()=>resizeObserver.disconnect(), (0, _bindEventListener.bind)(window, {
            type: 'scroll',
            listener: scheduledUpdate,
            options: {
                capture: true,
                passive: true
            }
        }), (0, _bindEventListener.bind)(window, {
            type: 'resize',
            listener: scheduledUpdate,
            options: {
                passive: true
            }
        }), ()=>{
            scheduledUpdate.cancel();
            popover.style.removeProperty('top');
            popover.style.removeProperty('left');
            popover.style.removeProperty('opacity');
        });
        return undoPositioning;
    }, [
        anchorRef,
        popoverRef,
        stablePlacement,
        forceFallbackPositioning,
        isEnabled,
        id,
        isOpen
    ]);
}

},{"react":"ltHCL","bind-event-listener":"bjeUU","raf-schd":"oiTmD","@atlaskit/ds-lib/once":"3Kj1N","./anchor-positioning-fallback":"gb7ai","./combine":"jwffs","./placement-to-position-area":"9n5i9","./placement-to-try-fallbacks":"jYoZv","./resolve-css-length-to-pixels":"gIyFt","./resolve-placement":"iv3Jy","./set-style":"ae3H5","@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"oiTmD":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var rafSchd = function rafSchd(fn) {
    var lastArgs = [];
    var frameId = null;
    var wrapperFn = function wrapperFn() {
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        lastArgs = args;
        if (frameId) return;
        frameId = requestAnimationFrame(function() {
            frameId = null;
            fn.apply(void 0, lastArgs);
        });
    };
    wrapperFn.cancel = function() {
        if (!frameId) return;
        cancelAnimationFrame(frameId);
        frameId = null;
    };
    return wrapperFn;
};
exports.default = rafSchd;

},{"@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"gb7ai":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
/**
 * Computes popover position from trigger rect and viewport, flipping to
 * the side with more space when needed. Re-runs on scroll/resize.
 *
 * `gap` and `crossAxisShift` are pre-resolved to pixels by the
 * caller (see `resolveCssLengthToPixels`), so this function stays purely
 * numeric.
 */ parcelHelpers.export(exports, "computeFallbackPosition", ()=>computeFallbackPosition);
var _objectSpread = require("@swc/helpers/_/_object_spread");
var _objectSpreadProps = require("@swc/helpers/_/_object_spread_props");
/**
 * JS fallback positioning math. Used only when the browser does not
 * support CSS Anchor Positioning (less than 6% of users).
 *
 * Consumer-supplied `offset.gap` and `offset.crossAxisShift` are
 * honored: the caller (`useAnchorPosition`) resolves CSS length strings
 * (tokens, calc, var, etc) to pixels via a DOM probe before passing them
 * in. The caller also keeps the popover hidden (`opacity: 0`) until the
 * first measurement completes, so the popover never paints at the wrong
 * position.
 */ /**
 * Computes the base {top, left} position based on the primary edge,
 * flipping to the opposite side when there is not enough space.
 *
 * `gap` is applied along the main axis between trigger and popover.
 */ function computeEdgePosition({ axis, edge, triggerRect, popoverWidth, popoverHeight, viewport, gap }) {
    if (axis === 'block' && edge === 'end') {
        // Below trigger
        const spaceBelow = viewport.height - triggerRect.bottom;
        const spaceAbove = triggerRect.top;
        const fitsBelow = spaceBelow >= popoverHeight + gap;
        const useBelow = fitsBelow || spaceBelow >= spaceAbove;
        return {
            top: useBelow ? triggerRect.bottom + gap : triggerRect.top - popoverHeight - gap,
            left: triggerRect.left + triggerRect.width / 2 - popoverWidth / 2
        };
    }
    if (axis === 'block' && edge === 'start') {
        // Above trigger
        const spaceAbove = triggerRect.top;
        const spaceBelow = viewport.height - triggerRect.bottom;
        const fitsAbove = spaceAbove >= popoverHeight + gap;
        const useAbove = fitsAbove || spaceAbove >= spaceBelow;
        return {
            top: useAbove ? triggerRect.top - popoverHeight - gap : triggerRect.bottom + gap,
            left: triggerRect.left + triggerRect.width / 2 - popoverWidth / 2
        };
    }
    if (axis === 'inline' && edge === 'end') {
        // Right of trigger
        const spaceRight = viewport.width - triggerRect.right;
        const spaceLeft = triggerRect.left;
        const fitsRight = spaceRight >= popoverWidth + gap;
        const useRight = fitsRight || spaceRight >= spaceLeft;
        return {
            top: triggerRect.top + triggerRect.height / 2 - popoverHeight / 2,
            left: useRight ? triggerRect.right + gap : triggerRect.left - popoverWidth - gap
        };
    }
    if (axis === 'inline' && edge === 'start') {
        // Left of trigger
        const spaceLeft = triggerRect.left;
        const spaceRight = viewport.width - triggerRect.right;
        const fitsLeft = spaceLeft >= popoverWidth + gap;
        const useLeft = fitsLeft || spaceLeft >= spaceRight;
        return {
            top: triggerRect.top + triggerRect.height / 2 - popoverHeight / 2,
            left: useLeft ? triggerRect.left - popoverWidth - gap : triggerRect.right + gap
        };
    }
    // Unreachable for valid placements; defaults to below trigger
    return {
        top: triggerRect.bottom + gap,
        left: triggerRect.left + triggerRect.width / 2 - popoverWidth / 2
    };
}
/**
 * Adjusts the base (centered) position for non-center alignments.
 *
 * `align: 'start'` → popover start edge at trigger start edge
 * `align: 'end'`   → popover end edge at trigger end edge
 */ function applyAlignment({ position, axis, align, triggerRect, popoverWidth, popoverHeight }) {
    if (align === 'center') return position;
    if (axis === 'block') {
        // Block-axis placement → cross-axis is inline (left/right)
        if (align === 'start') return (0, _objectSpreadProps._)((0, _objectSpread._)({}, position), {
            left: triggerRect.left
        });
        // align === 'end'
        return (0, _objectSpreadProps._)((0, _objectSpread._)({}, position), {
            left: triggerRect.right - popoverWidth
        });
    }
    // Inline-axis placement → cross-axis is block (top/bottom)
    if (align === 'start') return (0, _objectSpreadProps._)((0, _objectSpread._)({}, position), {
        top: triggerRect.top
    });
    // align === 'end'
    return (0, _objectSpreadProps._)((0, _objectSpread._)({}, position), {
        top: triggerRect.bottom - popoverHeight
    });
}
/**
 * Applies the cross-axis shift offset.
 *
 * The sign mirrors the CSS path (see `crossAxisShiftMargin` in
 * `use-anchor-position.tsx`):
 *   - `align: 'start' | 'center'` + `forwards`  → push toward end (positive)
 *   - `align: 'end'`              + `forwards`  → push toward start (negative)
 *   - `backwards` flips the sign in both cases.
 */ function applyCrossAxisShift({ position, axis, align, crossAxisShift }) {
    if (crossAxisShift.value === 0) return position;
    const directionSign = crossAxisShift.direction === 'forwards' ? 1 : -1;
    const sideSign = align === 'end' ? -1 : 1;
    const delta = crossAxisShift.value * directionSign * sideSign;
    // Cross-axis is the OPPOSITE of the placement axis.
    if (axis === 'block') return (0, _objectSpreadProps._)((0, _objectSpread._)({}, position), {
        left: position.left + delta
    });
    return (0, _objectSpreadProps._)((0, _objectSpread._)({}, position), {
        top: position.top + delta
    });
}
function computeFallbackPosition({ triggerRect, popoverEl, placement, viewport, gap, crossAxisShift }) {
    const { axis, edge, align } = placement;
    // Measure popover dimensions. Callers must ensure the popover has
    // laid out before calling this (it should not be `display: none`).
    const popoverWidth = popoverEl.offsetWidth;
    const popoverHeight = popoverEl.offsetHeight;
    const basePosition = computeEdgePosition({
        axis,
        edge,
        triggerRect,
        popoverWidth,
        popoverHeight,
        viewport,
        gap
    });
    const alignedPosition = applyAlignment({
        position: basePosition,
        axis,
        align,
        triggerRect,
        popoverWidth,
        popoverHeight
    });
    const shiftedPosition = applyCrossAxisShift({
        position: alignedPosition,
        axis,
        align,
        crossAxisShift
    });
    // Clamp to viewport so the popover is never offscreen
    return {
        top: Math.max(0, Math.min(shiftedPosition.top, viewport.height - popoverHeight)),
        left: Math.max(0, Math.min(shiftedPosition.left, viewport.width - popoverWidth))
    };
}

},{"@swc/helpers/_/_object_spread":"9gdrV","@swc/helpers/_/_object_spread_props":"kANqQ","@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"jwffs":[function(require,module,exports,__globalThis) {
/**
 * Combine multiple cleanup functions into a single cleanup function.
 *
 * @example
 * ```ts
 * useEffect(() => {
 *   return combine(
 *     bind(window, { type: 'resize', listener: onResize }),
 *     bind(window, { type: 'scroll', listener: onScroll, options: { capture: true } }),
 *   );
 * }, []);
 * ```
 */ var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "combine", ()=>combine);
function combine(...cleanupFns) {
    return function cleanup() {
        cleanupFns.forEach((callback)=>callback === null || callback === void 0 ? void 0 : callback());
    };
}

},{"@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"9n5i9":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
/**
 * Resolves placement options to CSS `position-area` syntax.
 *
 * The `align` field represents the *visual* alignment:
 * - `align: 'start'` means "aligned to the trigger's start edge" (left in LTR for block axis)
 * - `align: 'end'` means "aligned to the trigger's end edge"
 * - `align: 'center'` means centered (single-axis position-area)
 *
 * CSS `position-area` uses `span-*` keywords which indicate the *expansion direction*.
 * Visual start-alignment requires `span-{cross-axis}-end` (expand toward end = start-aligned).
 * This function handles the inversion internally.
 *
 * @example
 * placementToPositionArea({ placement: { axis: 'block', edge: 'end', align: 'center' } }) // → 'block-end'
 * placementToPositionArea({ placement: { axis: 'block', edge: 'end', align: 'start' } }) // → 'block-end span-inline-end'
 * placementToPositionArea({ placement: { axis: 'block', edge: 'end', align: 'end' } })   // → 'block-end span-inline-start'
 */ parcelHelpers.export(exports, "placementToPositionArea", ()=>placementToPositionArea);
var _resolvePlacement = require("./resolve-placement");
function placementToPositionArea({ placement }) {
    const { axis, edge, align } = (0, _resolvePlacement.getPlacement)({
        placement
    });
    const edgeValue = `${axis}-${edge}`;
    if (align === 'center') return edgeValue;
    // Cross-axis name: block ↔ inline
    const crossAxis = axis === 'block' ? 'inline' : 'block';
    // Invert align → CSS span direction: visual 'start' → span toward 'end'
    const spanDir = align === 'start' ? 'end' : 'start';
    return `${edgeValue} span-${crossAxis}-${spanDir}`;
}

},{"./resolve-placement":"iv3Jy","@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"jYoZv":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
/**
 * Returns the `position-try-fallbacks` value for a placement.
 *
 * @example
 * // Centered on the block-end edge (the default placement):
 * placementToTryFallbacks({ placement: { axis: 'block', edge: 'end', align: 'center' } });
 * // => 'block-end span-inline-end, block-end span-inline-start, flip-block,
 * //     block-start span-inline-end, block-start span-inline-start'
 */ parcelHelpers.export(exports, "placementToTryFallbacks", ()=>placementToTryFallbacks);
var _resolvePlacement = require("./resolve-placement");
function slideOnEdge({ align, edgeKey, crossAxis }) {
    if (align === 'center') return [
        `${edgeKey} span-${crossAxis}-end`,
        `${edgeKey} span-${crossAxis}-start`
    ];
    // For `align: 'start'` the popover expands toward `end`, so the "near"
    // span is `end` and the "far" span is `start`; `align: 'end'` mirrors
    // this. The bare `edgeKey` (re-centered) sits between them.
    const near = align === 'start' ? 'end' : 'start';
    const far = align === 'start' ? 'start' : 'end';
    return [
        `${edgeKey} span-${crossAxis}-${near}`,
        edgeKey,
        `${edgeKey} span-${crossAxis}-${far}`
    ];
}
function flipDiagonally({ axis }) {
    const flipOnMainAxis = axis === 'block' ? 'flip-block' : 'flip-inline';
    const flipToCrossAxis = axis === 'block' ? 'flip-inline' : 'flip-block';
    return `${flipOnMainAxis} ${flipToCrossAxis}`;
}
function placementToTryFallbacks({ placement }) {
    /**
	 * **Build the fallback list**
	 *
	 * Each entry is a complete alternative position.
	 * The browser tries them _in order_ and uses the _first_ one that fits.
	 */ const resolved = (0, _resolvePlacement.getPlacement)({
        placement
    });
    const { axis, edge, align } = resolved;
    const crossAxis = axis === 'block' ? 'inline' : 'block';
    const flippedEdge = edge === 'start' ? 'end' : 'start';
    const sameEdgeArea = `${axis}-${edge}`;
    const oppositeEdgeArea = `${axis}-${flippedEdge}`;
    const flipOnMainAxis = axis === 'block' ? 'flip-block' : 'flip-inline';
    /**
	 * **Fallback algorithm**
	 *
	 * We have two things we can do to keep something visible:
	 *
	 * 1. _Slide_ along edges
	 * 2. _Flip_ to another edge
	 *
	 * _Centered popover_
	 *
	 * Desired: Sits in middle of main edge
	 *
	 * Fallbacks:
	 *  1: _Slide_ along main edge on the cross axis
	 *  2: _Flip_ on main axis to opposite edge (centered)
	 *  3: _Slide_ along opposite edge on the cross axis
	 *
	 * _Start or end aligned popover_
	 *
	 * Desired: Sits at start / end of main edge
	 *
	 * Fallbacks:
	 *  1: _Slide_ along main edge on the cross axis
	 *  2: _Flip_ on main axis to opposite edge
	 *  3: _Flip_ on the diagonal (flip main axis + flip cross axis) into the
	 *     opposite corner. For start / end alignment, this is the clean escape
	 *     when the popover would otherwise land offscreen on both axes (ie in a
	 *     corner). Rule 4 gets the job done, but a slide drops the gap
	 *     as named position-area values don't carry margins).
	 *     The diagonal flip keeps the gap and the alignment.
	 *  4: _Slide_ along opposite edge on the cross axis
	 */ return [
        slideOnEdge({
            align,
            edgeKey: sameEdgeArea,
            crossAxis
        }),
        flipOnMainAxis,
        align !== 'center' ? flipDiagonally({
            axis
        }) : null,
        slideOnEdge({
            align,
            edgeKey: oppositeEdgeArea,
            crossAxis
        })
    ].filter(Boolean).flat().join(', ');
}

},{"./resolve-placement":"iv3Jy","@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"gIyFt":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
/**
 * Resolves a CSS length value to a pixel number using a hidden DOM probe.
 *
 * Used by the JS positioning fallback: consumer offsets can be numbers,
 * `${n}px` strings, tokenised `var(--ds-space-100, 8px)` strings, `calc()`
 * expressions, viewport units, etc. Parsing arbitrary CSS in JS is fragile
 * (and impossible for `calc(var(...))` without a layout context), so we let
 * the browser do the math.
 *
 * The probe is appended to `container` so it inherits the same containing
 * block, font size, and custom-property scope as the popover.
 *
 * Cost: one synchronous reflow on first cacheable resolution per
 * (container, value) pair, then a `WeakMap` lookup. Resolutions involving
 * `var(` are intentionally not cached.
 */ parcelHelpers.export(exports, "resolveCssLengthToPixels", ()=>resolveCssLengthToPixels);
const elementCaches = new WeakMap();
function canCacheResolvedLength(value) {
    // Custom-property values can be retargeted by inline overrides on the
    // consumer's wrapper, so we cannot prove a cached pixel value is still valid.
    return !value.includes('var(');
}
function getCachedResolvedLength({ element, value }) {
    if (!canCacheResolvedLength(value)) return null;
    const cacheForElement = elementCaches.get(element);
    var _cacheForElement_get;
    return (_cacheForElement_get = cacheForElement === null || cacheForElement === void 0 ? void 0 : cacheForElement.get(value)) !== null && _cacheForElement_get !== void 0 ? _cacheForElement_get : null;
}
function cacheResolvedLength({ element, value, result }) {
    if (!canCacheResolvedLength(value)) return;
    var _elementCaches_get;
    const cacheForElement = (_elementCaches_get = elementCaches.get(element)) !== null && _elementCaches_get !== void 0 ? _elementCaches_get : new Map();
    cacheForElement.set(value, result);
    elementCaches.set(element, cacheForElement);
}
function resolveCssLengthToPixels({ value, container }) {
    if (typeof value === 'number') return value;
    // Fast path: unitless zero is universally zero pixels - accept `'0'` and
    // `'-0'` without a probe. (Consumers occasionally pass `'0'` instead of
    // the number `0`.)
    if (value === '0' || value === '-0') return 0;
    // Fast path: bare `${n}px` strings come from the consumer normalisation
    // in `getPlacement`. Avoid a reflow when we can.
    const pxMatch = value.match(/^(-?\d+(?:\.\d+)?)px$/);
    if (pxMatch) return Number(pxMatch[1]);
    const cached = getCachedResolvedLength({
        element: container,
        value
    });
    if (cached !== null) return cached;
    const probe = container.ownerDocument.createElement('div');
    probe.style.position = 'absolute';
    probe.style.visibility = 'hidden';
    probe.style.pointerEvents = 'none';
    probe.style.height = '0';
    probe.style.padding = '0';
    probe.style.border = '0';
    // `width` clamps negatives to 0; use `margin-left` instead so signs are
    // preserved. `getComputedStyle` returns the resolved pixel value for
    // margin-* properties even when the source was a token / calc / var.
    probe.style.marginLeft = value;
    // Hide the probe from assistive tech and event targeting; defensive
    // against `getElementsByTagName('div')` walks in consumer code.
    probe.setAttribute('aria-hidden', 'true');
    probe.setAttribute('inert', '');
    container.appendChild(probe);
    const resolved = parseFloat(getComputedStyle(probe).marginLeft);
    container.removeChild(probe);
    const result = Number.isFinite(resolved) ? resolved : 0;
    cacheResolvedLength({
        element: container,
        value,
        result
    });
    return result;
}

},{"@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"1BeoO":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "useAnchorPositionAtPoint", ()=>(0, _useAnchorPositionAtPoint.useAnchorPositionAtPoint));
var _useAnchorPositionAtPoint = require("../internal/use-anchor-position-at-point");

},{"../internal/use-anchor-position-at-point":"15zy3","@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"15zy3":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
// `useAnchorPosition` requires a real DOM element. When the caller only
// has a viewport coordinate (e.g. cursor at hover time), this hook
// manages a hidden `<div>` at that point and delegates the rest.
//
// The `<div>` is appended directly to `document.body` to escape any
// transformed ancestor, which would otherwise break `position: fixed`
// viewport-relative resolution.
/**
 * Positions a popover at a consumer-supplied viewport coordinate using a
 * hidden synthetic anchor.
 *
 * @example
 * ```tsx
 * function PointPositionedPopover({ popoverRef, placement, mousePos }) {
 *   useAnchorPositionAtPoint({
 *     popoverRef,
 *     placement,
 *     isEnabled: Boolean(mousePos),
 *     getPoint: () => {
 *       if (!mousePos) return null;
 *       return { x: mousePos.clientX, y: mousePos.clientY };
 *     },
 *   });
 *   return <Popover ref={popoverRef}>...</Popover>;
 * }
 * ```
 */ parcelHelpers.export(exports, "useAnchorPositionAtPoint", ()=>useAnchorPositionAtPoint);
var _react = require("react");
var _useAnchorPosition = require("./use-anchor-position");
/**
 * Styles the synthetic anchor as an invisible, zero-size point.
 * Dynamic `inset-*` overrides are written by the positioning effect.
 *
 * Uses `Object.assign` rather than Compiled CSS (element is outside the React tree)
 * or the internal `setStyle` helper (we own this element entirely - it is created
 * and removed by this hook - so the snapshot/restore semantics `setStyle`
 * provides for caller-owned elements would be dead work here).
 */ function applyStaticAnchorStyles(element) {
    Object.assign(element.style, {
        position: 'fixed',
        // `top`/`left` rather than `inset-block-start`/`inset-inline-start`
        // for consistency with the dynamic positioning effect below, which
        // uses physical properties (see comment there for the rationale).
        top: '0',
        left: '0',
        // Zero size - placement decides which side the popover sits on.
        width: '0',
        height: '0',
        // Prevent the overlay from intercepting pointer events.
        pointerEvents: 'none'
    });
}
function useAnchorPositionAtPoint({ popoverRef, placement, getPoint, isEnabled = true, isOpen }) {
    const syntheticAnchorRef = (0, _react.useRef)(null);
    // `getPoint` is kept in a ref so the layout effect can call the
    // latest version without listing it as a dep - that would re-fire
    // on every render and re-latch the point.
    const getPointRef = (0, _react.useRef)(getPoint);
    getPointRef.current = getPoint;
    // Lazy element creation: the `<div>` is only created when both
    // `isEnabled` is true AND `getPoint()` returns a non-null point.
    // `useLayoutEffect` ensures the element exists before the inner
    // `useAnchorPosition` (also a layout effect) reads the ref.
    (0, _react.useLayoutEffect)(()=>{
        if (!isEnabled) return;
        const point = getPointRef.current();
        if (!point) return;
        const anchor = document.createElement('div');
        anchor.setAttribute('aria-hidden', 'true');
        applyStaticAnchorStyles(anchor);
        // `point.x`/`y` are physical viewport coordinates (from
        // `MouseEvent.clientX/Y`), so map directly onto physical
        // `left`/`top`. This is RTL-safe: `position: fixed` + physical
        // insets is direction-independent. Using logical
        // `inset-inline-start` would need `viewportWidth - point.x` in
        // RTL to land at the same physical pixel.
        anchor.style.top = `${point.y}px`;
        anchor.style.left = `${point.x}px`;
        document.body.appendChild(anchor);
        syntheticAnchorRef.current = anchor;
        return function cleanup() {
            anchor.remove();
            syntheticAnchorRef.current = null;
        };
    }, [
        isEnabled
    ]);
    // Mirror `isEnabled` so both hooks stay in sync - when disabled,
    // neither this hook nor the inner one touches the popover, leaving
    // any other positioning the consumer has set up free to take effect.
    (0, _useAnchorPosition.useAnchorPosition)({
        anchorRef: syntheticAnchorRef,
        popoverRef,
        placement,
        isEnabled,
        isOpen
    });
}

},{"react":"ltHCL","./use-anchor-position":"bcfEr","@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"6C7Zl":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
/**
 * Returns a stable HTML `id` used to wire a trigger element to its popover
 * via ARIA (`aria-controls`) and the Popover API (`popovertarget`).
 *
 * The returned value is intended for the `id` attribute on the popover and
 * for the matching `aria-controls` / `popovertarget` references on the
 * trigger. It is NOT a CSS `anchor-name` value: CSS anchor positioning is
 * handled internally by `useAnchorPosition`, which mints and applies its
 * own `anchor-name` on the trigger element.
 */ parcelHelpers.export(exports, "usePopoverId", ()=>usePopoverId);
var _useId = require("@atlaskit/ds-lib/use-id");
function usePopoverId() {
    // `@atlaskit/ds-lib/use-id` already strips characters that React's
    // `useId` produces (`:`, `«`, `»`) which are invalid in HTML ID
    // tokens. The `popover-` prefix is purely for DOM debug clarity.
    return `popover-${(0, _useId.useId)()}`;
}

},{"@atlaskit/ds-lib/use-id":"9jWCD","@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"geRT5":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "useWidthFromAnchor", ()=>(0, _useWidthFromAnchor.useWidthFromAnchor));
var _useWidthFromAnchor = require("../internal/use-width-from-anchor");

},{"../internal/use-width-from-anchor":"jypqq","@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"jypqq":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
/**
 * Sets the width of a popover element relative to its anchor element.
 *
 * - `'match-anchor'` → `width: anchor-size(width)` - popover matches anchor width exactly.
 * - `'min-anchor'`   → `min-width: anchor-size(width)` - popover is at least as wide as anchor,
 *   but can grow wider.
 * - `'none'`         → no explicit width is set (default behaviour)
 *
 * Uses CSS `anchor-size(width)` when the browser supports it, falling back to a
 * one-off measurement of `anchor.offsetWidth`.
 *
 * Designed to be composed alongside `useAnchorPosition` for top-layer popovers.
 */ parcelHelpers.export(exports, "useWidthFromAnchor", ()=>useWidthFromAnchor);
var _react = require("react");
var _setStyle = require("./set-style");
function useWidthFromAnchor({ mode, popoverRef, anchorRef, isOpen }) {
    (0, _react.useLayoutEffect)(()=>{
        const node = popoverRef.current;
        if (!node) return;
        // Feature-detect `anchor-size()` specifically (not just `anchor-name`)
        // so the JS fallback fires correctly in browsers that support anchor
        // positioning but not anchor sizing.
        const supportsAnchorSize = typeof CSS !== 'undefined' && typeof CSS.supports === 'function' && CSS.supports('width', 'anchor-size(width)');
        if (mode === 'match-anchor') {
            // Set an exact width matching the anchor.
            // `min-inline-size` is intentionally NOT set here - it would override the
            // explicit width constraint, allowing the popover to grow past the anchor's width.
            if (supportsAnchorSize) return (0, _setStyle.setStyle)({
                element: node,
                styles: [
                    {
                        property: 'width',
                        value: 'anchor-size(width)'
                    }
                ]
            });
            // JS fallback: one-off read of the anchor's width.
            const anchor = anchorRef.current;
            if (anchor) return (0, _setStyle.setStyle)({
                element: node,
                styles: [
                    {
                        property: 'width',
                        value: `${anchor.offsetWidth}px`
                    }
                ]
            });
            return;
        }
        // For 'min-anchor' and 'none', apply `min-inline-size: max-content` to ensure
        // correct position-try-fallbacks behaviour (popover margin box overflows the
        // viewport when its span region is too narrow, rather than wrapping content).
        const minInlineSizeStyle = {
            property: 'min-inline-size',
            value: 'max-content'
        };
        if (mode === 'min-anchor') {
            // Set a minimum width matching the anchor. The popover can grow wider
            // if its content requires it.
            if (supportsAnchorSize) return (0, _setStyle.setStyle)({
                element: node,
                styles: [
                    minInlineSizeStyle,
                    {
                        property: 'min-width',
                        value: 'anchor-size(width)'
                    }
                ]
            });
            const anchor = anchorRef.current;
            if (anchor) return (0, _setStyle.setStyle)({
                element: node,
                styles: [
                    minInlineSizeStyle,
                    {
                        property: 'min-width',
                        value: `${anchor.offsetWidth}px`
                    }
                ]
            });
            // No anchor available in JS fallback - still apply min-inline-size.
            return (0, _setStyle.setStyle)({
                element: node,
                styles: [
                    minInlineSizeStyle
                ]
            });
        }
        // 'none' mode: no explicit width, but still apply `min-inline-size: max-content`.
        return (0, _setStyle.setStyle)({
            element: node,
            styles: [
                minInlineSizeStyle
            ]
        });
    }, [
        mode,
        popoverRef,
        anchorRef,
        isOpen
    ]);
}

},{"react":"ltHCL","./set-style":"ae3H5","@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"41wjV":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
/**
 * Reduces an anchor rect to the single viewport point that, wrapped in a
 * zero-size synthetic anchor, produces the same popover position
 * `useAnchorPosition` would for the given placement. This works because
 * `useAnchorPosition` only reads the edge / alignment corner of the rect,
 * so a coincident zero-size point is geometrically equivalent.
 *
 * RTL is resolved here so the downstream synthetic anchor only sees physical
 * coordinates. Defaults mirror `getPlacement` in
 * `@atlaskit/top-layer/placement-map` (`axis: 'block'`, `edge: 'end'`,
 * `align: 'center'`).
 */ parcelHelpers.export(exports, "rectPointForPlacement", ()=>rectPointForPlacement);
function rectPointForPlacement({ rect, placement, isRtl }) {
    var _placement_axis;
    const axis = (_placement_axis = placement.axis) !== null && _placement_axis !== void 0 ? _placement_axis : 'block';
    var _placement_edge;
    const edge = (_placement_edge = placement.edge) !== null && _placement_edge !== void 0 ? _placement_edge : 'end';
    var _placement_align;
    const align = (_placement_align = placement.align) !== null && _placement_align !== void 0 ? _placement_align : 'center';
    if (axis === 'block') {
        // Popover sits above (`edge: 'start'`) or below (`edge: 'end'`)
        // the anchor. Hug the matching horizontal edge; align along x.
        const y = edge === 'start' ? rect.top : rect.bottom;
        const x = horizontalForAlign({
            rect,
            align,
            isRtl
        });
        return {
            x,
            y
        };
    }
    // `axis: 'inline'`: popover sits inline-start or inline-end of the
    // anchor. Hug the matching vertical edge; align along y.
    const x = inlineEdgeX({
        rect,
        edge,
        isRtl
    });
    const y = verticalForAlign({
        rect,
        align
    });
    return {
        x,
        y
    };
}
function horizontalForAlign({ rect, align, isRtl }) {
    if (align === 'center') return rect.left + rect.width / 2;
    // `start` / `end` are logical. In LTR, `start` is the left edge.
    // In RTL, `start` is the right edge.
    const isStartLeft = !isRtl;
    if (align === 'start') return isStartLeft ? rect.left : rect.right;
    return isStartLeft ? rect.right : rect.left;
}
function verticalForAlign({ rect, align }) {
    if (align === 'center') return rect.top + rect.height / 2;
    if (align === 'start') return rect.top;
    return rect.bottom;
}
function inlineEdgeX({ rect, edge, isRtl }) {
    const isStartLeft = !isRtl;
    if (edge === 'start') return isStartLeft ? rect.left : rect.right;
    return isStartLeft ? rect.right : rect.left;
}

},{"@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"8n82B":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
/**
 * @param target        the `position-area`-anchored popover host
 * @param placementAxis the primary axis derived from the popper placement
 * @param gap           the offset distance the popover is pushed from the
 *                      anchor (CSS length), subtracted from the primary cap
 * @param isEnabled     mirrors the consumer's `shouldFitViewport` prop
 * @param isOpen        re-applies the caps after the host unmounts/remounts
 *                      across open cycles (the host is torn down on exit)
 */ parcelHelpers.export(exports, "useFitViewportMaxSize", ()=>useFitViewportMaxSize);
var _react = require("react");
var _setStyle = require("./set-style");
const CROSS_INLINE_CAP = 'calc(100dvw - 10px)';
const CROSS_BLOCK_CAP = 'calc(100dvh - 10px)';
/**
 * Legacy `viewportPadding` (`preventOverflow` padding) the popover kept from
 * every viewport edge under `react-popper`. The caps above already *reserve*
 * this space (`- 5px` on the primary far edge, `- 10px` = `2 * 5px` on the
 * cross axis), but nothing makes the reservation land on the viewport side:
 * the anchor-side gap is a real margin (`useAnchorPosition`'s `edgeMargin`),
 * the viewport side has none, so a capped popover packs flush against the
 * viewport edge it slid/flipped to. Re-applying the padding as a margin on the
 * three non-anchor sides puts the reserved space back on the viewport side.
 * `position-try` flips mirror margins and slides keep them per-side, so the
 * gap tracks whichever edge the browser settles on.
 */ const VIEWPORT_PADDING = '5px';
/**
 * The popover's three non-anchor margin sides for a given placement axis — the
 * primary *far* side plus both cross sides. The remaining (anchor-facing) side
 * already carries the offset gap from `useAnchorPosition` and is left alone.
 */ const NON_ANCHOR_MARGIN_SIDES = {
    top: [
        'margin-block-start',
        'margin-inline-start',
        'margin-inline-end'
    ],
    bottom: [
        'margin-block-end',
        'margin-inline-start',
        'margin-inline-end'
    ],
    left: [
        'margin-inline-start',
        'margin-block-start',
        'margin-block-end'
    ],
    right: [
        'margin-inline-end',
        'margin-block-start',
        'margin-block-end'
    ]
};
function useFitViewportMaxSize({ target, placementAxis, gap, isEnabled, isOpen }) {
    (0, _react.useLayoutEffect)(()=>{
        const element = target.current;
        if (!element || !isEnabled) return;
        const isBlockAxis = placementAxis === 'top' || placementAxis === 'bottom';
        const primaryAxisCap = `calc(100% - 5px - ${gap})`;
        const cleanupHost = (0, _setStyle.setStyle)({
            element,
            styles: [
                {
                    property: 'display',
                    value: 'flex'
                },
                // Neutralise `useWidthFromAnchor`'s `min-inline-size: max-content`
                // floor so the caps below win and content reflows. `setStyle`
                // restores the floor on cleanup.
                {
                    property: 'min-inline-size',
                    value: '0'
                },
                isBlockAxis ? {
                    property: 'max-block-size',
                    value: primaryAxisCap
                } : {
                    property: 'max-inline-size',
                    value: primaryAxisCap
                },
                isBlockAxis ? {
                    property: 'max-inline-size',
                    value: CROSS_INLINE_CAP
                } : {
                    property: 'max-block-size',
                    value: CROSS_BLOCK_CAP
                },
                // Park the reserved viewport padding on the non-anchor sides so a
                // capped popover keeps the legacy `viewportPadding` gap from the
                // viewport edge instead of sitting flush against it.
                ...NON_ANCHOR_MARGIN_SIDES[placementAxis].map((property)=>({
                        property,
                        value: VIEWPORT_PADDING
                    }))
            ]
        });
        // The host deliberately stays `overflow: visible`. An ancestor with
        // `overflow: auto` clips a descendant's `box-shadow`, so capping and
        // scrolling on the host would strip the elevation shadow from the
        // consumer surface. Instead the host only constrains size; scrolling
        // oversized content is the consumer surface's own responsibility,
        // matching the contract `@atlaskit/top-layer`'s `PopoverSurface` follows
        // (shadow and `overflow` on one element). For that surface (the host's
        // flex child) to be clamped to the cap and scroll its own content, it
        // must be allowed to shrink below its intrinsic size, so reset its
        // min-size floor.
        const child = element.firstElementChild;
        const cleanupChild = child instanceof HTMLElement ? (0, _setStyle.setStyle)({
            element: child,
            styles: [
                {
                    property: 'min-block-size',
                    value: '0'
                },
                {
                    property: 'min-inline-size',
                    value: '0'
                }
            ]
        }) : undefined;
        return ()=>{
            cleanupHost();
            cleanupChild === null || cleanupChild === void 0 ? void 0 : cleanupChild();
        };
    }, [
        target,
        placementAxis,
        gap,
        isEnabled,
        isOpen
    ]);
}

},{"react":"ltHCL","./set-style":"k2rVX","@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"k2rVX":[function(require,module,exports,__globalThis) {
/**
 * Sets inline styles on an element and returns a cleanup function that
 * restores the prior inline values (so we do not stomp consumer styles).
 *
 * Copied from `@atlaskit/top-layer`'s internal `setStyle` (not exported there
 * yet); inline here until top-layer exposes it via a subpath export.
 */ var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "setStyle", ()=>setStyle);
function setStyle({ element, styles }) {
    // Snapshot the prior inline value (NOT the computed style - we only want
    // to restore values that the consumer/our previous run inlined). An empty
    // string means "no inline value", in which case cleanup uses removeProperty.
    const priorValues = styles.map(({ property })=>({
            property,
            value: element.style.getPropertyValue(property)
        }));
    styles.forEach(({ property, value })=>{
        element.style.setProperty(property, value);
    });
    return function cleanup() {
        priorValues.forEach(({ property, value })=>{
            if (value === '') {
                element.style.removeProperty(property);
                return;
            }
            element.style.setProperty(property, value);
        });
    };
}

},{"@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"9H3bP":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
/**
 * Returns the current anchor element published by an ancestor
 * `<Reference>` via the shared `<Manager>` provider. Returns `null`
 * when there is no surrounding `<Manager>` / `<Reference>` pair.
 */ parcelHelpers.export(exports, "useManagerAnchor", ()=>useManagerAnchor);
var _react = require("react");
var _anchorContext = require("./anchor-context");
function useManagerAnchor() {
    return (0, _react.useContext)((0, _anchorContext.AnchorContext));
}

},{"react":"ltHCL","./anchor-context":"lOVMG","@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"lOVMG":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "AnchorContext", ()=>AnchorContext);
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
const AnchorContext = /*#__PURE__*/ (0, _react.createContext)(null);

},{"react":"ltHCL","@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"746ze":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
/**
 * Exists **only** to preserve API parity with the legacy popper.js
 * implementation. The top-layer popper does not natively expose
 * popper.js's `isReferenceHidden` / `hasPopperEscaped` render-prop
 * modifiers, but existing consumers still branch on those values, so
 * this hook reconstructs them from live DOM measurement.
 *
 * Do not reach for this hook in new code. If you find yourself wanting
 * these signals for a new feature, prefer a first-class top-layer or
 * anchor-positioning primitive instead.
 *
 * - `isReferenceHidden`: the anchor's bounding rect is fully outside the
 *   visual viewport OR is clipped to zero area by any scrollable
 *   ancestor.
 * - `hasPopperEscaped`: the popover surface's rect is fully outside the
 *   visual viewport.
 *
 * Measurement runs in a `useLayoutEffect` so the first paint already
 * reflects the correct values, preventing consumers from animating
 * from `opacity: 1` to `opacity: 0` on mount.
 */ parcelHelpers.export(exports, "useReferenceVisibility", ()=>useReferenceVisibility);
var _react = require("react");
var _bindEventListener = require("bind-event-listener");
var _readViewport = require("./read-viewport");
const INITIAL = {
    isReferenceHidden: false,
    hasPopperEscaped: false
};
function isFullyOutsideViewport(rect, viewport) {
    if (rect.width === 0 && rect.height === 0) return true;
    if (rect.bottom <= 0) return true;
    if (rect.right <= 0) return true;
    if (rect.top >= viewport.height) return true;
    if (rect.left >= viewport.width) return true;
    return false;
}
function isClippingOverflow(value) {
    return value === 'auto' || value === 'scroll' || value === 'hidden' || value === 'clip';
}
function isClippedByAncestors(element) {
    const rect = element.getBoundingClientRect();
    let parent = element.parentElement;
    while(parent){
        // Read the longhand axis properties directly. The `overflow` shorthand
        // is only populated when both axes share the same value, so reading it
        // alone misses ancestors that set only `overflow-x` or `overflow-y`.
        const style = window.getComputedStyle(parent);
        const clipsHorizontally = isClippingOverflow(style.overflowX);
        const clipsVertically = isClippingOverflow(style.overflowY);
        if (clipsHorizontally || clipsVertically) {
            const parentRect = parent.getBoundingClientRect();
            const horizontallyOutside = rect.right <= parentRect.left || rect.left >= parentRect.right;
            const verticallyOutside = rect.bottom <= parentRect.top || rect.top >= parentRect.bottom;
            if (clipsHorizontally && horizontallyOutside) return true;
            if (clipsVertically && verticallyOutside) return true;
        }
        parent = parent.parentElement;
    }
    return false;
}
function useReferenceVisibility({ anchor, popoverRef }) {
    const [visibility, setVisibility] = (0, _react.useState)(INITIAL);
    const measure = (0, _react.useCallback)(()=>{
        if (!anchor) {
            setVisibility((previous)=>previous.isReferenceHidden === false && previous.hasPopperEscaped === false ? previous : INITIAL);
            return;
        }
        const viewport = (0, _readViewport.readViewport)();
        const anchorRect = anchor.getBoundingClientRect();
        const isReferenceHidden = isFullyOutsideViewport(anchorRect, viewport) || isClippedByAncestors(anchor);
        const popoverElement = popoverRef.current;
        const hasPopperEscaped = popoverElement ? isFullyOutsideViewport(popoverElement.getBoundingClientRect(), viewport) : false;
        setVisibility((previous)=>{
            if (previous.isReferenceHidden === isReferenceHidden && previous.hasPopperEscaped === hasPopperEscaped) return previous;
            return {
                isReferenceHidden,
                hasPopperEscaped
            };
        });
    }, [
        anchor,
        popoverRef
    ]);
    (0, _react.useLayoutEffect)(()=>{
        measure();
        if (typeof window === 'undefined') return undefined;
        const cleanups = [];
        // Resize observer on the anchor so layout changes update visibility.
        if (anchor && typeof ResizeObserver !== 'undefined') {
            const observer = new ResizeObserver(()=>measure());
            observer.observe(anchor);
            cleanups.push(()=>observer.disconnect());
        }
        // Scroll + resize: any scroll event in the document can move the
        // anchor in/out of any scrollable ancestor's viewport.
        cleanups.push((0, _bindEventListener.bindAll)(window, [
            {
                type: 'scroll',
                listener: measure,
                options: {
                    capture: true,
                    passive: true
                }
            },
            {
                type: 'resize',
                listener: measure,
                options: {
                    passive: true
                }
            }
        ]));
        const visual = window.visualViewport;
        if (visual) cleanups.push((0, _bindEventListener.bind)(visual, {
            type: 'resize',
            listener: measure,
            options: {
                passive: true
            }
        }));
        return ()=>{
            cleanups.forEach((cleanup)=>cleanup());
        };
    }, [
        anchor,
        measure
    ]);
    return visibility;
}

},{"react":"ltHCL","bind-event-listener":"bjeUU","./read-viewport":"88Soh","@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"88Soh":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
/**
 * Returns the current viewport size in CSS pixels, preferring the visual
 * viewport (which accounts for pinch-zoom on touch devices) over the
 * layout viewport. Returns `{ width: 0, height: 0 }` in non-DOM
 * environments so callers can use the result unconditionally.
 */ parcelHelpers.export(exports, "readViewport", ()=>readViewport);
function readViewport() {
    if (typeof window === 'undefined') return {
        width: 0,
        height: 0
    };
    const visual = window.visualViewport;
    if (visual) return {
        width: visual.width,
        height: visual.height
    };
    return {
        width: window.innerWidth,
        height: window.innerHeight
    };
}

},{"@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"jO3Co":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
/**
 * Wraps `react-popper`'s `<Manager>` so the anchor that `<Reference>`
 * captures is published through `@atlaskit/popper`'s own bridge context.
 * Doing so insulates `<Popper>` consumers from `react-popper`'s dual
 * CJS / ESM builds, which otherwise create two unrelated context
 * instances that prevent the FF-on top-layer adapter from discovering
 * the anchor.
 */ parcelHelpers.export(exports, "Manager", ()=>Manager);
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _reactPopper = require("react-popper");
var _anchorContext = require("./internal/anchor-context");
var _anchorSetterContext = require("./internal/anchor-setter-context");
var _useAnchorState = require("./internal/use-anchor-state");
function Manager({ children }) {
    // `setAnchor` is the `useState` setter, which React guarantees is stable
    // across renders, so it can be passed straight to the context provider.
    const { anchor, setAnchor } = (0, _useAnchorState.useAnchorState)();
    return /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _reactPopper.Manager), null, /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _anchorSetterContext.AnchorSetterContext).Provider, {
        value: setAnchor
    }, /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _anchorContext.AnchorContext).Provider, {
        value: anchor
    }, children)));
}

},{"react":"ltHCL","react-popper":"bGSxp","./internal/anchor-context":"lOVMG","./internal/anchor-setter-context":"1wWkn","./internal/use-anchor-state":"2QFom","@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"1wWkn":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "AnchorSetterContext", ()=>AnchorSetterContext);
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
const AnchorSetterContext = /*#__PURE__*/ (0, _react.createContext)(()=>undefined);

},{"react":"ltHCL","@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"2QFom":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
/**
 * Returns the local state used by `<Manager>` to publish the anchor
 * captured by `<Reference>` to descendant `<Popper>` instances.
 */ parcelHelpers.export(exports, "useAnchorState", ()=>useAnchorState);
var _react = require("react");
function useAnchorState() {
    const [anchor, setAnchor] = (0, _react.useState)(null);
    return {
        anchor,
        setAnchor
    };
}

},{"react":"ltHCL","@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"aMror":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
/**
 * Wraps `react-popper`'s `<Reference>` so the anchor element it captures
 * is also published through `@atlaskit/popper`'s own bridge context.
 * The bridge lets the FF-on top-layer adapter discover the anchor even
 * when `react-popper`'s CJS and ESM builds resolve to different context
 * instances (Jest vs production bundlers).
 *
 * The bridge + consumer refs are composed into a single stable callback and
 * passed to `react-popper` as `innerRef`, so the (stable) ref `react-popper`
 * hands to `children` never changes identity. Composing inline instead would
 * produce a new ref callback every render, making React detach/reattach the
 * anchor each commit — firing `publishAnchor(null)` then `publishAnchor(el)`
 * and churning the `Manager`.
 */ parcelHelpers.export(exports, "Reference", ()=>Reference);
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _reactPopper = require("react-popper");
var _mergeRefs = require("@atlaskit/ds-lib/merge-refs");
var _mergeRefsDefault = parcelHelpers.interopDefault(_mergeRefs);
var _useManagerAnchorSetter = require("./internal/use-manager-anchor-setter");
function Reference({ children, innerRef }) {
    const publishAnchor = (0, _useManagerAnchorSetter.useManagerAnchorSetter)();
    const composedRef = (0, _react.useMemo)(()=>(0, _mergeRefsDefault.default)([
            publishAnchor,
            innerRef
        ]), [
        publishAnchor,
        innerRef
    ]);
    return /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _reactPopper.Reference), {
        innerRef: composedRef
    }, children);
}

},{"react":"ltHCL","react-popper":"bGSxp","@atlaskit/ds-lib/merge-refs":"doPwA","./internal/use-manager-anchor-setter":"b81VA","@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"b81VA":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
/**
 * Returns the setter that an ancestor `<Manager>` exposes to publish
 * the anchor element from `<Reference>`. Returns a no-op when there is
 * no surrounding `<Manager>`.
 */ parcelHelpers.export(exports, "useManagerAnchorSetter", ()=>useManagerAnchorSetter);
var _react = require("react");
var _anchorSetterContext = require("./anchor-setter-context");
function useManagerAnchorSetter() {
    return (0, _react.useContext)((0, _anchorSetterContext.AnchorSetterContext));
}

},{"react":"ltHCL","./anchor-setter-context":"1wWkn","@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"jvgcC":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>(0, _portalDefault.default));
parcelHelpers.export(exports, "PORTAL_MOUNT_EVENT", ()=>(0, _constants.PORTAL_MOUNT_EVENT));
parcelHelpers.export(exports, "PORTAL_UNMOUNT_EVENT", ()=>(0, _constants.PORTAL_UNMOUNT_EVENT));
var _portal = require("./portal");
var _portalDefault = parcelHelpers.interopDefault(_portal);
var _constants = require("./constants");

},{"./portal":"3jKar","./constants":false,"@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"3jKar":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>Portal);
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _platformFeatureFlags = require("@atlaskit/platform-feature-flags");
var _internalPortal = require("./internal/components/internal-portal");
var _internalPortalDefault = parcelHelpers.interopDefault(_internalPortal);
var _internalPortalNew = require("./internal/components/internal-portal-new");
var _internalPortalNewDefault = parcelHelpers.interopDefault(_internalPortalNew);
var _useIsSubsequentRender = require("./internal/hooks/use-is-subsequent-render");
var _useIsSubsequentRenderDefault = parcelHelpers.interopDefault(_useIsSubsequentRender);
var _usePortalEvent = require("./internal/hooks/use-portal-event");
var _usePortalEventDefault = parcelHelpers.interopDefault(_usePortalEvent);
function Portal({ zIndex = 0, children, mountStrategy = 'effect', isClosed = false }) {
    const isSubsequentRender = (0, _useIsSubsequentRenderDefault.default)(mountStrategy);
    (0, _usePortalEventDefault.default)(zIndex);
    return !(0, _platformFeatureFlags.fg)('platform_design_system_team_portal_logic_r18_fix') ? isSubsequentRender ? /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _internalPortalDefault.default), {
        zIndex: zIndex,
        isClosed: isClosed
    }, children) : null : /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _internalPortalNewDefault.default), {
        zIndex: zIndex,
        isClosed: isClosed
    }, children);
}

},{"react":"ltHCL","@atlaskit/platform-feature-flags":"8rD2i","./internal/components/internal-portal":"6kfsc","./internal/components/internal-portal-new":"80avR","./internal/hooks/use-is-subsequent-render":"hVbmq","./internal/hooks/use-portal-event":"a0qub","@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"6kfsc":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>InternalPortal);
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _reactDom = require("react-dom");
var _appProvider = require("@atlaskit/app-provider");
var _useIsInsideThemeProvider = require("@atlaskit/app-provider/use-is-inside-theme-provider");
var _platformFeatureFlags = require("@atlaskit/platform-feature-flags");
var _appendPortalContainerIfNotAppended = require("../utils/append-portal-container-if-not-appended");
var _createContainer = require("../utils/create-container");
var _removePortalContainer = require("../utils/remove-portal-container");
function InternalPortal(props) {
    const { zIndex, children, isClosed = false } = props;
    const container = (0, _react.useMemo)(()=>(0, _createContainer.createContainer)(zIndex), [
        zIndex
    ]);
    const colorMode = (0, _appProvider.useColorMode)();
    const isInsideThemeProvider = (0, _useIsInsideThemeProvider.useIsInsideThemeProvider)();
    // This is in the render method instead of useEffect so that
    // the portal will be added to the DOM before the children render.
    // For any further changes, ensure that the container does not have a
    // parent besides the portal parent.
    (0, _appendPortalContainerIfNotAppended.appendPortalContainerIfNotAppended)(container);
    (0, _react.useEffect)(()=>{
        if ((0, _platformFeatureFlags.fg)('import_into_jsm_in_template_gallery_killswitch')) {
            if (isClosed) (0, _removePortalContainer.removePortalContainer)(container);
        }
    }, [
        isClosed,
        container
    ]);
    (0, _react.useEffect)(()=>{
        return ()=>{
            (0, _removePortalContainer.removePortalContainer)(container);
        };
    }, [
        container
    ]);
    return /*#__PURE__*/ (0, _reactDom.createPortal)(isInsideThemeProvider ? /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _appProvider.ThemeProvider), {
        defaultColorMode: colorMode
    }, children) : children, container);
}

},{"react":"ltHCL","react-dom":"7Lblg","@atlaskit/app-provider":"hIy26","@atlaskit/app-provider/use-is-inside-theme-provider":"bhpUB","@atlaskit/platform-feature-flags":"8rD2i","../utils/append-portal-container-if-not-appended":"iFjWy","../utils/create-container":"fh2gi","../utils/remove-portal-container":"7zZlq","@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"bhpUB":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "useIsInsideThemeProvider", ()=>(0, _useIsInsideThemeProvider.useIsInsideThemeProvider));
var _useIsInsideThemeProvider = require("../theme-provider/hooks/use-is-inside-theme-provider");

},{"../theme-provider/hooks/use-is-inside-theme-provider":"7fB2c","@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"iFjWy":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "appendPortalContainerIfNotAppended", ()=>appendPortalContainerIfNotAppended);
var _constants = require("../constants");
var _getBody = require("./get-body");
const getPortalParent = ()=>{
    const parentElement = document.querySelector((0, _constants.portalParentSelector));
    if (!parentElement) {
        var _getBody1;
        const parent = document.createElement('div');
        parent.className = (0, _constants.portalParentClassName);
        // we are setting display to flex because we want each portal to create a new stacking context
        // See https://developer.mozilla.org/en-US/docs/Web/CSS/CSS_Positioning/Understanding_z_index/The_stacking_context
        parent.style.display = 'flex';
        (_getBody1 = (0, _getBody.getBody)()) === null || _getBody1 === void 0 ? void 0 : _getBody1.appendChild(parent);
        return parent;
    }
    return parentElement;
};
const appendPortalContainerIfNotAppended = (container)=>{
    if (!container.parentElement) getPortalParent().appendChild(container);
};

},{"../constants":"2yFRr","./get-body":"2SwEg","@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"2yFRr":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "portalParentClassName", ()=>portalParentClassName);
parcelHelpers.export(exports, "portalParentSelector", ()=>portalParentSelector);
parcelHelpers.export(exports, "portalClassName", ()=>portalClassName);
const portalParentClassName = 'atlaskit-portal-container';
const portalParentSelector = 'body > .atlaskit-portal-container';
const portalClassName = 'atlaskit-portal';

},{"@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"2SwEg":[function(require,module,exports,__globalThis) {
/**
 * Returns document body element
 * @return {number} - The document body element
 */ var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "getBody", ()=>getBody);
const getBody = ()=>{
    return document.body;
};

},{"@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"fh2gi":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "createContainer", ()=>createContainer);
var _constants = require("../constants");
const createContainer = (zIndex)=>{
    const container = document.createElement('div');
    container.className = (0, _constants.portalClassName);
    container.style.zIndex = `${zIndex}`;
    return container;
};

},{"../constants":"2yFRr","@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"7zZlq":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "removePortalContainer", ()=>removePortalContainer);
var _constants = require("../constants");
var _getBody = require("./get-body");
const getPortalParent = ()=>{
    const parentElement = document.querySelector((0, _constants.portalParentSelector));
    if (!parentElement) {
        var _getBody1;
        const parent = document.createElement('div');
        parent.className = (0, _constants.portalParentClassName);
        // we are setting display to flex because we want each portal to create a new stacking context
        // See https://developer.mozilla.org/en-US/docs/Web/CSS/CSS_Positioning/Understanding_z_index/The_stacking_context
        parent.style.display = 'flex';
        (_getBody1 = (0, _getBody.getBody)()) === null || _getBody1 === void 0 ? void 0 : _getBody1.appendChild(parent);
        return parent;
    }
    return parentElement;
};
const removePortalContainer = (container)=>{
    const parent = getPortalParent();
    if (parent.contains(container)) parent.removeChild(container);
};

},{"../constants":"2yFRr","./get-body":"2SwEg","@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"80avR":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>InternalPortalNew);
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _reactDom = require("react-dom");
var _appProvider = require("@atlaskit/app-provider");
var _useIsInsideThemeProvider = require("@atlaskit/app-provider/use-is-inside-theme-provider");
var _platformFeatureFlags = require("@atlaskit/platform-feature-flags");
var _useIsomorphicLayoutEffect = require("../hooks/use-isomorphic-layout-effect");
var _createAtlaskitPortal = require("../utils/create-atlaskit-portal");
var _createPortalParent = require("../utils/create-portal-parent");
var _removePortalParent = require("../utils/remove-portal-parent");
function InternalPortalNew(props) {
    const { zIndex, children, isClosed } = props;
    const [atlaskitPortal, setAtlaskitPortal] = (0, _react.useState)(null);
    const colorMode = (0, _appProvider.useColorMode)();
    const isInsideThemeProvider = (0, _useIsInsideThemeProvider.useIsInsideThemeProvider)();
    (0, _useIsomorphicLayoutEffect.useIsomorphicLayoutEffect)(()=>{
        if ((0, _platformFeatureFlags.fg)('import_into_jsm_in_template_gallery_killswitch')) {
            if (!isClosed) {
                let tempPortalContainer = (0, _createAtlaskitPortal.createAtlaskitPortal)(zIndex);
                setAtlaskitPortal(tempPortalContainer);
                const portalParent = (0, _createPortalParent.createPortalParent)();
                if (!tempPortalContainer || !portalParent) return;
                portalParent.appendChild(tempPortalContainer);
                return ()=>{
                    if (portalParent) {
                        portalParent.removeChild(tempPortalContainer);
                        !portalParent.hasChildNodes() && (0, _removePortalParent.removePortalParent)(portalParent);
                    }
                    setAtlaskitPortal(null);
                };
            }
        } else {
            const tempPortalContainer = (0, _createAtlaskitPortal.createAtlaskitPortal)(zIndex);
            setAtlaskitPortal(tempPortalContainer);
            const portalParent = (0, _createPortalParent.createPortalParent)();
            if (!tempPortalContainer || !portalParent) return;
            portalParent.appendChild(tempPortalContainer);
            return ()=>{
                if (tempPortalContainer) portalParent.removeChild(tempPortalContainer);
                setAtlaskitPortal(null);
            };
        }
    }, [
        zIndex,
        isClosed,
        (0, _platformFeatureFlags.fg)
    ]);
    /**
	 * We wrap portal children with a Suspense boundary because in React 18 concurrent,
	 * if you suspend from _within_ a portal to a Suspense boundary _outside_ the portal,
	 * our portal gets in an infinite loop of rendering.
	 */ const suspendedChildren = /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _react.Suspense), {
        fallback: null
    }, isInsideThemeProvider ? /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _appProvider.ThemeProvider), {
        defaultColorMode: colorMode
    }, children) : children);
    return atlaskitPortal ? /*#__PURE__*/ (0, _reactDom.createPortal)(suspendedChildren, atlaskitPortal) : null;
}

},{"react":"ltHCL","react-dom":"7Lblg","@atlaskit/app-provider":"hIy26","@atlaskit/app-provider/use-is-inside-theme-provider":"bhpUB","@atlaskit/platform-feature-flags":"8rD2i","../hooks/use-isomorphic-layout-effect":"3DRIz","../utils/create-atlaskit-portal":"5fWDq","../utils/create-portal-parent":"8hmNU","../utils/remove-portal-parent":"66l8W","@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"3DRIz":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "useIsomorphicLayoutEffect", ()=>useIsomorphicLayoutEffect);
var _react = require("react");
const useIsomorphicLayoutEffect = typeof window !== 'undefined' ? (0, _react.useLayoutEffect) : (0, _react.useEffect);

},{"react":"ltHCL","@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"5fWDq":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "createAtlaskitPortal", ()=>createAtlaskitPortal);
var _constants = require("../constants");
const isDocumentDefined = ()=>{
    return document !== undefined;
};
const createAtlaskitPortal = (zIndex)=>{
    //atlaskit-portal div
    if (isDocumentDefined()) {
        const atlaskitportal = document.createElement('div');
        atlaskitportal.className = (0, _constants.portalClassName);
        atlaskitportal.style.zIndex = `${zIndex}`;
        return atlaskitportal;
    }
    return;
};

},{"../constants":"2yFRr","@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"8hmNU":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "createPortalParent", ()=>createPortalParent);
var _constants = require("../constants");
var _getBody = require("./get-body");
const isDocumentDefined = ()=>{
    return document !== undefined;
};
const createPortalParent = ()=>{
    //atlaskit-portal-container div
    if (isDocumentDefined()) {
        const parentElement = document.querySelector((0, _constants.portalParentSelector));
        if (!parentElement) {
            var _getBody1;
            const parent = document.createElement('div');
            parent.className = (0, _constants.portalParentClassName);
            parent.style.display = 'flex';
            (_getBody1 = (0, _getBody.getBody)()) === null || _getBody1 === void 0 ? void 0 : _getBody1.appendChild(parent);
            return parent;
        }
        return parentElement;
    }
    return;
};

},{"../constants":"2yFRr","./get-body":"2SwEg","@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"66l8W":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "removePortalParent", ()=>removePortalParent);
var _getBody = require("./get-body");
const isDocumentDefined = ()=>{
    return document !== undefined;
};
const removePortalParent = (parentElement)=>{
    var _getBody1;
    if (isDocumentDefined()) {
        if (parentElement) (_getBody1 = (0, _getBody.getBody)()) === null || _getBody1 === void 0 ? void 0 : _getBody1.removeChild(parentElement);
    }
};

},{"./get-body":"2SwEg","@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"hVbmq":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _react = require("react");
var _useIsomorphicLayoutEffect = require("./use-isomorphic-layout-effect");
const useIsSubsequentRender = (mountStrategy)=>{
    const [isSubsequentRender, setIsSubsequentRender] = (0, _react.useState)(false);
    const [useMountEffect] = (0, _react.useState)(()=>mountStrategy === 'layoutEffect' ? (0, _useIsomorphicLayoutEffect.useIsomorphicLayoutEffect) : (0, _react.useEffect));
    useMountEffect(()=>{
        setIsSubsequentRender(true);
    }, []);
    return isSubsequentRender;
};
exports.default = useIsSubsequentRender;

},{"react":"ltHCL","./use-isomorphic-layout-effect":"3DRIz","@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"a0qub":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _react = require("react");
var _constants = require("../../constants");
var _portalCustomEvent = require("../utils/portal-custom-event");
var _portalCustomEventDefault = parcelHelpers.interopDefault(_portalCustomEvent);
const useFirePortalEvent = (zIndex)=>{
    const zIndexNumber = Number(zIndex);
    (0, _react.useEffect)(()=>{
        (0, _portalCustomEventDefault.default)((0, _constants.PORTAL_MOUNT_EVENT), zIndexNumber);
        return ()=>{
            (0, _portalCustomEventDefault.default)((0, _constants.PORTAL_UNMOUNT_EVENT), zIndexNumber);
        };
    }, [
        zIndexNumber
    ]);
};
exports.default = useFirePortalEvent;

},{"react":"ltHCL","../../constants":"5QFsI","../utils/portal-custom-event":"hmz6R","@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"5QFsI":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "PORTAL_MOUNT_EVENT", ()=>PORTAL_MOUNT_EVENT);
parcelHelpers.export(exports, "PORTAL_UNMOUNT_EVENT", ()=>PORTAL_UNMOUNT_EVENT);
const PORTAL_MOUNT_EVENT = 'akPortalMount';
const PORTAL_UNMOUNT_EVENT = 'akPortalUnmount';

},{"@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"hmz6R":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>firePortalEvent);
const zIndexToName = {
    100: 'card',
    200: 'navigation',
    300: 'dialog',
    400: 'layer',
    500: 'blanket',
    510: 'modal',
    600: 'flag',
    700: 'spotlight',
    9999: 'tooltip'
};
/**
 * return layer name in Atlassian design system corresponding to given z-index
 * @param {number} zIndex - z-index value for which layer name is needed
 * @returns {LayerName | null} - The layer name for given z-index. If layer name is not found then null is returned
 */ const getLayerName = (zIndex)=>{
    return zIndexToName.hasOwnProperty(zIndex) ? zIndexToName[zIndex] : null;
};
/**
 * Creates a PortalEvent object with given eventName, given zIndex and corresponding layer
 * @param {string} eventName - either of Mount or Unmount event name
 * @param {number} zIndex - z-index value which will be included in the event to be dispatched
 * @returns {PortalEvent} - The newly created PortalEvent object
 */ const getEvent = (eventName, zIndex)=>{
    const detail = {
        layer: getLayerName(Number(zIndex)),
        zIndex
    };
    return new CustomEvent(eventName, {
        detail
    });
};
function firePortalEvent(eventName, zIndex) {
    const event = getEvent(eventName, zIndex);
    window.dispatchEvent(event);
}

},{"@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"gxXsN":[function(require,module,exports,__globalThis) {
/* eslint-disable @atlaskit/volt-strict-mode/no-multiple-exports */ var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "CHANNEL", ()=>CHANNEL);
parcelHelpers.export(exports, "DEFAULT_THEME_MODE", ()=>DEFAULT_THEME_MODE);
parcelHelpers.export(exports, "THEME_MODES", ()=>THEME_MODES);
parcelHelpers.export(exports, "focusRing", ()=>focusRing);
parcelHelpers.export(exports, "noFocusRing", ()=>noFocusRing);
parcelHelpers.export(exports, "layers", ()=>layers);
parcelHelpers.export(exports, "visuallyHidden", ()=>visuallyHidden);
parcelHelpers.export(exports, "assistive", ()=>assistive);
var _deprecationWarning = require("@atlaskit/ds-lib/deprecation-warning");
var _deprecationWarningDefault = parcelHelpers.interopDefault(_deprecationWarning);
const CHANNEL = '__ATLASKIT_THEME__';
const DEFAULT_THEME_MODE = 'light';
const THEME_MODES = [
    'light',
    'dark'
];
const focusRing = (color = "var(--ds-border-focused, #4688EC)", outlineWidth = 2)=>{
    (0, _deprecationWarningDefault.default)('@atlaskit/theme', 'focus ring mixin', 'Please use `@atlaskit/focus-ring` instead.');
    return `
  &:focus {
    outline: none;
    box-shadow: 0px 0px 0px ${outlineWidth}px ${color};
  }
`;
};
const noFocusRing = ()=>`
  box-shadow: none;
`;
const layers = {
    card: ()=>100,
    navigation: ()=>200,
    dialog: ()=>300,
    layer: ()=>400,
    blanket: ()=>500,
    modal: ()=>510,
    flag: ()=>600,
    spotlight: ()=>700,
    tooltip: ()=>9999
};
const visuallyHidden = ()=>{
    (0, _deprecationWarningDefault.default)('@atlaskit/theme', 'visually hidden mixin', 'Please use `@atlaskit/visually-hidden` instead.');
    return {
        border: '0 !important',
        clip: 'rect(1px, 1px, 1px, 1px) !important',
        height: '1px !important',
        overflow: 'hidden !important',
        padding: '0 !important',
        position: 'absolute !important',
        width: '1px !important',
        whiteSpace: 'nowrap !important'
    };
};
const assistive = visuallyHidden;

},{"@atlaskit/ds-lib/deprecation-warning":"97GNa","@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"97GNa":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>deprecationWarning);
var _warnOnce = require("./warn-once");
var _warnOnceDefault = parcelHelpers.interopDefault(_warnOnce);
function deprecationWarning(packageName, api, additionalMessage) {
    (0, _warnOnceDefault.default)(`[${packageName}]: The ${api} is deprecated.${additionalMessage && ` ${additionalMessage}`}`);
}

},{"./warn-once":"9o8xE","@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"9o8xE":[function(require,module,exports,__globalThis) {
/* eslint-disable no-console */ var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>warnOnce);
const printed = {};
function warnOnce(message) {
    if (printed[message]) return;
    printed[message] = true;
    if (typeof window !== 'undefined') console.warn(message);
}

},{"@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"bL5lY":[function(require,module,exports,__globalThis) {
/* eslint-disable @atlaskit/design-system/no-direct-use-of-web-platform-drag-and-drop */ /**
 * We are listening directly to drag events instead of using a monitor from
 * `@atlaskit/pragmatic-drag-and-drop` to avoid the bundle size cost, as it
 * would affect almost every view in every app.
 *
 * We can reconsider this choice in the future.
 */ var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "register", ()=>register);
var _bindEventListener = require("bind-event-listener");
const registrations = new Set();
let cleanupEndEventListeners = null;
function onDragStart() {
    if (cleanupEndEventListeners) // If the cleanup function exists then we've already run this
    return;
    cleanupEndEventListeners = (0, _bindEventListener.bindAll)(window, [
        {
            type: 'dragend',
            listener: onDragEnd
        },
        {
            type: 'pointerdown',
            listener: onDragEnd
        },
        {
            type: 'pointermove',
            listener: (()=>{
                let callCount = 0;
                return function listener() {
                    // Using 20 as it is far bigger than the most observed (3)
                    if (callCount < 20) {
                        callCount++;
                        return;
                    }
                    onDragEnd();
                };
            })()
        }
    ]);
    const clone = Array.from(registrations);
    clone.forEach((subscriber)=>{
        subscriber.onDragStart();
    });
}
function onDragEnd() {
    cleanupEndEventListeners === null || cleanupEndEventListeners === void 0 ? void 0 : cleanupEndEventListeners();
    cleanupEndEventListeners = null;
    const clone = Array.from(registrations);
    clone.forEach((subscriber)=>{
        subscriber.onDragEnd();
    });
}
function bindStartEvents() {
    return (0, _bindEventListener.bindAll)(window, [
        {
            type: 'dragstart',
            listener: onDragStart
        },
        {
            type: 'dragenter',
            listener: onDragStart
        }
    ]);
}
let cleanupStartEventListeners = null;
function register(registration) {
    // if first registration, bind event listeners
    if (!cleanupStartEventListeners) // note: currently never unbinding these event listeners
    cleanupStartEventListeners = bindStartEvents();
    registrations.add(registration);
    /**
	 * The reasoning for this behavior is so that if a tooltip mounts during
	 * a drag it can still be suppressed.
	 *
	 * We use a separate callback instead of onDragStart to avoid infinite loops.
	 */ registration.onRegister({
        isDragging: cleanupEndEventListeners !== null
    });
    return function unregister() {
        registrations.delete(registration);
        if (registrations.size === 0) {
            cleanupStartEventListeners === null || cleanupStartEventListeners === void 0 ? void 0 : cleanupStartEventListeners();
            cleanupStartEventListeners = null;
        }
    };
}

},{"bind-event-listener":"bjeUU","@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"g3PYT":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
/**
 * Computes the viewport point at which to anchor a cursor-positioned
 * tooltip, given the cursor's coordinates and the trigger's bounding rect.
 *
 * - `mouse`:   both axes follow the cursor.
 * - `mouse-x`: X follows the cursor; Y locks to the trigger edge selected
 *   by `placement` (falls back to trigger center if the placement axis
 *   doesn't have a Y edge).
 * - `mouse-y`: Y follows the cursor; X locks to the trigger edge (falls
 *   back to trigger center similarly).
 */ parcelHelpers.export(exports, "getAnchorPoint", ()=>getAnchorPoint);
/**
 * Returns the trigger's X edge for inline-axis placements, or the
 * trigger's horizontal center for block-axis placements.
 *
 * Note: does not account for RTL writing modes.
 */ function getTriggerEdgeX({ triggerRect, placement }) {
    if (placement.axis === 'inline') return placement.edge === 'start' ? triggerRect.left : triggerRect.right;
    return triggerRect.left + triggerRect.width / 2;
}
/**
 * Returns the trigger's Y edge for block-axis placements, or the
 * trigger's vertical center for inline-axis placements.
 */ function getTriggerEdgeY({ triggerRect, placement }) {
    if (placement.axis === 'block') return placement.edge === 'start' ? triggerRect.top : triggerRect.bottom;
    return triggerRect.top + triggerRect.height / 2;
}
function getAnchorPoint({ cursor, triggerRect, tooltipPosition, placement }) {
    if (tooltipPosition === 'mouse-y') return {
        x: getTriggerEdgeX({
            triggerRect,
            placement
        }),
        y: cursor.clientY
    };
    if (tooltipPosition === 'mouse-x') return {
        x: cursor.clientX,
        y: getTriggerEdgeY({
            triggerRect,
            placement
        })
    };
    // tooltipPosition === 'mouse'
    return {
        x: cursor.clientX,
        y: cursor.clientY
    };
}

},{"@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"g1OSU":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "getVirtualElementFromMousePos", ()=>getVirtualElementFromMousePos);
function getVirtualElementFromMousePos(mousePos, { targetElement, tooltipPosition }) {
    if (tooltipPosition === 'mouse') return {
        getBoundingClientRect: ()=>DOMRect.fromRect({
                x: mousePos.clientX,
                y: mousePos.clientY,
                width: 0,
                height: 0
            })
    };
    const targetRect = targetElement.getBoundingClientRect();
    if (tooltipPosition === 'mouse-x') return {
        getBoundingClientRect: ()=>DOMRect.fromRect({
                x: mousePos.clientX,
                y: targetRect.top,
                width: 0,
                height: targetRect.height
            })
    };
    if (tooltipPosition === 'mouse-y') return {
        getBoundingClientRect: ()=>DOMRect.fromRect({
                x: targetRect.left,
                y: mousePos.clientY,
                width: targetRect.width,
                height: 0
            })
    };
    throw new Error(`Invalid tooltip position for virtual element: ${tooltipPosition}`);
}

},{"@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"Yg7Cj":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "show", ()=>show);
var _platformFeatureFlags = require("@atlaskit/platform-feature-flags");
let delayId = null;
function clearScheduled() {
    if (delayId != null) {
        window.clearTimeout(delayId);
        delayId = null;
    }
}
function scheduleTimeout(fn, delay) {
    clearScheduled();
    delayId = window.setTimeout(()=>{
        delayId = null;
        fn();
    }, delay);
}
let active = null;
function show(entry) {
    let phase = 'waiting-to-show';
    function isActive() {
        return Boolean(active && active.entry === entry);
    }
    function cleanup() {
        if (isActive()) {
            clearScheduled();
            active = null;
        }
    }
    function done() {
        if (isActive()) entry.done();
        phase = 'done';
        cleanup();
    }
    function immediatelyHideAndDone() {
        if (isActive()) entry.hide({
            isImmediate: true
        });
        done();
    }
    function keep() {
        if (!isActive()) return;
        // aborting a wait to hide
        if (phase === 'waiting-to-hide') {
            phase = 'shown';
            clearScheduled();
            return;
        }
        // aborting hide animation
        if (phase === 'hide-animating') {
            phase = 'shown';
            clearScheduled();
            entry.show({
                isImmediate: false
            });
            return;
        }
    }
    function requestHide({ isImmediate }) {
        if (!isActive()) return;
        // If we were not showing yet anyway; finish straight away
        if (phase === 'waiting-to-show') {
            immediatelyHideAndDone();
            return;
        }
        // already waiting to hide
        // Bug in legacy path: isImmediate hide requests are ignored during waiting-to-hide,
        // meaning Escape/scroll won't instantly dismiss a tooltip that's already fading out.
        // Gated fix: only apply the immediate-hide behavior under the top-layer flag for now.
        if (phase === 'waiting-to-hide') {
            if (isImmediate && (0, _platformFeatureFlags.fg)('platform-dst-top-layer-tooltip')) immediatelyHideAndDone();
            return;
        }
        if (isImmediate) {
            immediatelyHideAndDone();
            return;
        }
        phase = 'waiting-to-hide';
        scheduleTimeout(()=>{
            phase = 'hide-animating';
            entry.hide({
                isImmediate: false
            });
        }, entry.delay);
    }
    function finishHideAnimation() {
        if (isActive() && phase === 'hide-animating') done();
    }
    function isVisible() {
        return phase === 'shown' || phase === 'waiting-to-hide' || phase === 'hide-animating';
    }
    function start() {
        const shouldAlwaysFadeIn = entry.shouldAlwaysFadeIn;
        const showImmediately = Boolean(active && active.isVisible()) && !shouldAlwaysFadeIn;
        // If there was an active tooltip; we tell it to remove itself at once!
        if (active) {
            clearScheduled();
            active.entry.hide({
                isImmediate: true
            });
            active.entry.done();
            active = null;
        }
        // this tooltip is now the active tooltip
        active = {
            entry,
            isVisible
        };
        function show() {
            phase = 'shown';
            entry.show({
                isImmediate: showImmediately
            });
        }
        if (showImmediately) {
            show();
            return;
        }
        phase = 'waiting-to-show';
        scheduleTimeout(show, entry.delay);
    }
    // let's get started!
    start();
    const result = {
        keep,
        abort: cleanup,
        isActive,
        requestHide,
        finishHideAnimation,
        mousePos: entry.source.type === 'mouse' ? {
            clientX: entry.source.clientX,
            clientY: entry.source.clientY
        } : null
    };
    return result;
}

},{"@atlaskit/platform-feature-flags":"8rD2i","@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"1YoKj":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>useUniqueId);
var _useIdSeed = require("@atlaskit/ds-lib/use-id-seed");
function useUniqueId(prefix, shouldRenderId) {
    const seed = (0, _useIdSeed.useIdSeed)();
    return shouldRenderId ? `${seed(prefix)}` : undefined;
}

},{"@atlaskit/ds-lib/use-id-seed":"7zgfh","@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"7zgfh":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
/**
 * Generates a seed for the useId hook.
 */ parcelHelpers.export(exports, "useIdSeed", ()=>useIdSeed);
var _useId = require("./use-id");
function useIdSeed() {
    const uid = (0, _useId.useId)();
    return (id)=>`${uid}-${id.toString()}`;
}

},{"./use-id":"9jWCD","@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"jyGbU":[function(require,module,exports,__globalThis) {
/* tooltip-container.tsx generated by @compiled/babel-plugin v0.39.1 */ var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _react = require("react");
var _runtime = require("@compiled/react/runtime");
var _tooltipPrimitive = require("./tooltip-primitive");
var _tooltipPrimitiveDefault = parcelHelpers.interopDefault(_tooltipPrimitive);
const styles = {
    base: "_2rkofajl _11c8wadc _vchhusvi _p12fp3fh _bfhk1aqn _syaz15cr _152tze3t _1e02ze3t _1i4q1hna _1q511b66 _85i51b66 _y4ti12x7 _bozg12x7 _slp31hna",
    truncate: "_1reo15vq _18m915vq _p12f1pna _1bto1l2s _o5721q9c"
};
/**
 * Used as the default tooltip container component for the exported `Tooltip` component.
 * Adds some styles to the tooltip primitive.
 */ const TooltipContainer = /*#__PURE__*/ (0, _react.forwardRef)(function TooltipContainer({ style, className, children, truncate, placement, testId, onMouseOut, onMouseOver, id, shortcut, role }, ref) {
    return /*#__PURE__*/ _react.createElement((0, _tooltipPrimitiveDefault.default), {
        ref: ref,
        style: style,
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
        className: (0, _runtime.ax)([
            styles.base,
            truncate && styles.truncate,
            className
        ]),
        placement: placement,
        testId: testId,
        id: id,
        onMouseOut: onMouseOut,
        onMouseOver: onMouseOver,
        shortcut: shortcut,
        role: role
    }, children);
});
TooltipContainer.displayName = 'TooltipContainer';
exports.default = TooltipContainer;

},{"react":"ltHCL","@compiled/react/runtime":"d27Vo","./tooltip-primitive":"gIFNN","@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"gIFNN":[function(require,module,exports,__globalThis) {
/* tooltip-primitive.tsx generated by @compiled/babel-plugin v0.39.1 */ var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _react = require("react");
var _runtime = require("@compiled/react/runtime");
var _tooltipShortcut = require("./tooltip-shortcut");
const primitiveStyles = null;
/**
 * The lower level component for rendering a tooltip.
 */ const TooltipPrimitive = /*#__PURE__*/ (0, _react.forwardRef)(function TooltipPrimitive({ style, className, children, placement, testId, onMouseOut, onMouseOver, id, shortcut, role = 'tooltip' }, ref) {
    return /*#__PURE__*/ _react.createElement("div", {
        ref: ref,
        style: style,
        "data-testid": testId ? `${testId}--wrapper` : undefined
    }, /*#__PURE__*/ _react.createElement("div", {
        role: role,
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
        className: (0, _runtime.ax)([
            "_80om73ad",
            className
        ]),
        // Because the tooltip should not be focusable, there is no reason to have key events.
        /* eslint-disable-next-line @atlassian/a11y/mouse-events-have-key-events */ onMouseOut: onMouseOut,
        /* eslint-disable-next-line @atlassian/a11y/mouse-events-have-key-events */ onMouseOver: onMouseOver,
        "data-placement": placement,
        "data-testid": testId,
        id: id
    }, children, shortcut && /*#__PURE__*/ _react.createElement((0, _tooltipShortcut.TooltipShortcut), {
        shortcut: shortcut
    })));
});
TooltipPrimitive.displayName = 'TooltipPrimitive';
exports.default = TooltipPrimitive;

},{"react":"ltHCL","@compiled/react/runtime":"d27Vo","./tooltip-shortcut":"4AAc0","@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"4AAc0":[function(require,module,exports,__globalThis) {
/* tooltip-shortcut.tsx generated by @compiled/babel-plugin v0.39.1 */ var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "TooltipShortcut", ()=>TooltipShortcut);
var _react = require("react");
var _runtime = require("@compiled/react/runtime");
const styles = {
    shortcutSegmentsContainer: "_zulpv77o _1e0c1txw _1q511b66 _85i5v77o",
    shortcutSegment: "_11c8wadc _2rkolb4i _1dqonqa1 _189ee4h9 _1h6d1ihb _1e0c1txw _4cvr1h6o _4t3i1k92 _vchhusvi _1q51v77o _85i5v77o _bozg12x7 _y4ti12x7 _16qsn7od _1254n7od _cgnln7od _syazn7od _ahbqn7od _12l2n7od _1pfhn7od _6rthn7od _1ul9n7od _w19jn7od _bfhk261p"
};
const TooltipShortcut = ({ shortcut })=>{
    return /*#__PURE__*/ _react.createElement("div", {
        className: (0, _runtime.ax)([
            styles.shortcutSegmentsContainer
        ])
    }, shortcut.map((segment, index)=>/*#__PURE__*/ _react.createElement("kbd", {
            key: `${segment}-${index}`,
            className: (0, _runtime.ax)([
                styles.shortcutSegment
            ])
        }, segment)));
};

},{"react":"ltHCL","@compiled/react/runtime":"d27Vo","@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"4HNAS":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _reactIntl = require("react-intl");
const _default_1 = (0, _reactIntl.defineMessages)({
    clearAllButtonTooltip: {
        id: 'atlassian-studio-ui-components.bulk-toolbar.clearAllButtonTooltip',
        defaultMessage: 'Clear all',
        description: 'Tool tip for the button that clears all the selections'
    },
    selectedText: {
        id: 'atlassian-studio-ui-components.bulk-toolbar.selectedText',
        defaultMessage: 'selected',
        description: 'Text that comes after a number to show how many items are selected for bulk edititing'
    }
});
exports.default = _default_1;

},{"react-intl":"f41fF","@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"21kRr":[function(require,module,exports,__globalThis) {
/* index.tsx generated by @compiled/babel-plugin v0.39.1 */ var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "RadioGroup", ()=>RadioGroup);
parcelHelpers.export(exports, "RadioButton", ()=>RadioButton);
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _css = require("@atlaskit/css");
var _compiled = require("@atlaskit/primitives/compiled");
var _radio = require("@atlaskit/radio");
const radioGroupStyles = {
    container: "_19itia51 _2rko1mok"
};
const RadioGroup = ({ children, onChange, value, name })=>{
    const [selectedValue, setSelectedValue] = (0, _react.useState)(value);
    const isControlled = onChange !== undefined;
    const props = (0, _react.useMemo)(()=>({
            name,
            selectedValue: isControlled ? value : selectedValue,
            onChange: (value)=>{
                isControlled ? onChange(value) : setSelectedValue(value);
            }
        }), [
        name,
        value,
        selectedValue,
        isControlled,
        onChange
    ]);
    return /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _compiled.Stack), {
        xcss: radioGroupStyles.container
    }, children(props));
};
const radioButtonStyles = {
    container: "_n7zlia51 _ca0qze3t _n3tdze3t _19bvze3t _u5f3ze3t _irr31dpa",
    outerWrapper: "_19bvpxbi _u5f3pxbi",
    innerWrapper: "_ca0qutpp _n3tdutpp",
    lastChild: "_n7zlglyw"
};
const RadioButton = ({ label, description, actions, labelAfter, name, value, children, isDisabled, selectedValue, lastChild, onChange, testId })=>{
    return /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _compiled.Box), {
        xcss: (0, _css.cx)(radioButtonStyles.container, lastChild && radioButtonStyles.lastChild)
    }, /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _compiled.Inline), {
        spread: "space-between",
        alignBlock: "center",
        xcss: radioButtonStyles.outerWrapper
    }, /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _compiled.Inline), {
        xcss: radioButtonStyles.innerWrapper,
        space: "space.100",
        alignBlock: "center"
    }, /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _radio.Radio), {
        value: value,
        onChange: ()=>onChange(value),
        isChecked: value === selectedValue,
        isDisabled: isDisabled,
        name: name,
        testId: testId,
        ariaLabel: label
    }), /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _compiled.Stack), null, /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _compiled.Inline), {
        space: "space.050",
        alignBlock: "center"
    }, /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _compiled.Text), null, label), labelAfter), description && /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _compiled.Text), {
        color: "color.text.subtlest"
    }, description))), actions && /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _compiled.Box), null, actions)), children);
};

},{"react":"ltHCL","@atlaskit/css":"kMGms","@atlaskit/primitives/compiled":"hDay7","@atlaskit/radio":"3XXDZ","@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"3XXDZ":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "RadioGroup", ()=>(0, _radioGroupDefault.default));
parcelHelpers.export(exports, "Radio", ()=>(0, _radioDefault.default));
var _radioGroup = require("./radio-group");
var _radioGroupDefault = parcelHelpers.interopDefault(_radioGroup);
var _radio = require("./radio");
var _radioDefault = parcelHelpers.interopDefault(_radio);

},{"./radio-group":"9u2hP","./radio":"lXTe3","@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"9u2hP":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>RadioGroup);
var _extends = require("@swc/helpers/_/_extends");
var _objectDestructuringEmpty = require("@swc/helpers/_/_object_destructuring_empty");
var _objectSpread = require("@swc/helpers/_/_object_spread");
var _objectSpreadProps = require("@swc/helpers/_/_object_spread_props");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _noop = require("@atlaskit/ds-lib/noop");
var _noopDefault = parcelHelpers.interopDefault(_noop);
var _useId = require("@atlaskit/ds-lib/use-id");
var _radio = require("./radio");
var _radioDefault = parcelHelpers.interopDefault(_radio);
const noOptions = [];
function RadioGroup(props) {
    const { onChange, options = noOptions, value: propValue, defaultValue, id, isDisabled, isRequired, isInvalid, labelId, onInvalid = (0, _noopDefault.default), name, analyticsContext, ['aria-labelledby']: ariaLabelledBy, testId } = props;
    const uid = (0, _useId.useId)();
    const [selectedValue, setSelectedValue] = (0, _react.useState)(propValue !== undefined ? propValue : defaultValue);
    const onRadioChange = (0, _react.useCallback)((e, analyticsEvent)=>{
        setSelectedValue(e.currentTarget.value);
        if (onChange) onChange(e, analyticsEvent);
    }, [
        onChange
    ]);
    // If propValue is provided than act as a controlled component
    // If not then act as an uncontrolled component using the value from state
    const value = typeof propValue !== 'undefined' ? propValue : selectedValue;
    return /*#__PURE__*/ (0, _reactDefault.default).createElement("div", {
        role: "radiogroup",
        // TODO: Make `aria-labelledby` a `never` in TS. See https://product-fabric.atlassian.net/browse/DSP-23009
        "aria-labelledby": labelId || ariaLabelledBy,
        "data-testid": testId,
        "aria-describedby": isInvalid ? `${id || uid}-error` : undefined,
        id: id || uid
    }, options.map((_param, index)=>{
        var optionProps = (0, _extends._)({}, (0, _objectDestructuringEmpty._)(_param));
        if (typeof isDisabled !== 'undefined') optionProps.isDisabled = isDisabled;
        const isChecked = value !== null && optionProps.value === value;
        return /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _radioDefault.default), (0, _objectSpreadProps._)((0, _objectSpread._)({}, optionProps), {
            name: name || optionProps.name,
            key: index,
            onChange: onRadioChange,
            onInvalid: onInvalid,
            isInvalid: isChecked && isInvalid,
            isChecked: isChecked,
            testId: optionProps.testId || testId,
            isRequired: isRequired,
            analyticsContext: analyticsContext
        }));
    }));
}

},{"@swc/helpers/_/_extends":"bXNuS","@swc/helpers/_/_object_destructuring_empty":"18aa3","@swc/helpers/_/_object_spread":"9gdrV","@swc/helpers/_/_object_spread_props":"kANqQ","react":"ltHCL","@atlaskit/ds-lib/noop":"faKzG","@atlaskit/ds-lib/use-id":"9jWCD","./radio":"lXTe3","@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"lXTe3":[function(require,module,exports,__globalThis) {
/* radio.tsx generated by @compiled/babel-plugin v0.39.1 */ /// <reference types="node" />
// for typing `process`
var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _objectSpread = require("@swc/helpers/_/_object_spread");
var _objectSpreadProps = require("@swc/helpers/_/_object_spread_props");
var _objectWithoutProperties = require("@swc/helpers/_/_object_without_properties");
var _react = require("react");
var _runtime = require("@compiled/react/runtime");
var _usePlatformLeafEventHandler = require("@atlaskit/analytics-next/usePlatformLeafEventHandler");
var _noop = require("@atlaskit/ds-lib/noop");
var _noopDefault = parcelHelpers.interopDefault(_noop);
const packageName = "@af/atlassian-studio";
const packageVersion = "0.16.1";
const noop = (0, _noopDefault.default);
const labelPaddingStyles = null;
const labelStyles = null;
const labelDisabledStyles = null;
const radioBaseStyles = null;
const radioInteractiveStyles = null;
const radioDisabledStyles = null;
const radioDisabledCheckedStyles = null;
const radioInvalidStyles = null;
const InnerRadio = /*#__PURE__*/ (0, _react.forwardRef)(function Radio(props, ref) {
    const { ariaLabel, 'aria-labelledby': ariaLabelledBy, isDisabled = false, isRequired, isInvalid = false, isChecked = false, label, labelId, name, onChange = noop, value, testId, analyticsContext } = props, rest = (0, _objectWithoutProperties._)(props, [
        "ariaLabel",
        'aria-labelledby',
        "isDisabled",
        "isRequired",
        "isInvalid",
        "isChecked",
        "label",
        "labelId",
        "name",
        "onChange",
        "value",
        "testId",
        "analyticsContext"
    ]);
    const onChangeAnalytics = (0, _usePlatformLeafEventHandler.usePlatformLeafEventHandler)({
        fn: onChange,
        action: 'changed',
        analyticsData: analyticsContext,
        componentName: 'radio',
        packageName,
        packageVersion
    });
    return /*#__PURE__*/ _react.createElement("label", {
        "data-testid": testId && `${testId}--radio-label`,
        "data-disabled": isDisabled ? 'true' : undefined,
        className: (0, _runtime.ax)([
            "_11c8fhey _1e0c1txw _vchhusvi _kqswh2mm _4cvr1y6m _syazi7uo",
            isDisabled && "_syaz1gmx _80om13gf"
        ])
    }, /*#__PURE__*/ _react.createElement("input", (0, _objectSpreadProps._)((0, _objectSpread._)({}, rest), {
        // It is necessary only for Safari. It allows to render focus styles.
        tabIndex: 0,
        "aria-label": ariaLabel,
        // TODO: Make `aria-labelledby` a `never` in TS. See https://product-fabric.atlassian.net/browse/DSP-23009
        "aria-labelledby": labelId || ariaLabelledBy,
        checked: isChecked,
        disabled: isDisabled,
        name: name,
        onChange: onChangeAnalytics,
        required: isRequired,
        type: "radio",
        value: value,
        "data-testid": testId && `${testId}--radio-input`,
        // isInvalid is used in a nonstandard way so cannot
        // use :invalid selector
        "data-invalid": isInvalid ? 'true' : undefined,
        ref: ref,
        className: (0, _runtime.ax)([
            "_18s8ze3t _19it3vzd _2rko1qll _12ji1r31 _1qu2glyw _12y31o36 _v56415j1 _1e0c1txw _1bsb1tcg _4t3i1tcg _kqswh2mm _4cvr1h6o _1bah1h6o _1o9zidpf _bfhk4t47 _13diglyw _1q6q1j9a _1151rsbi _1s6w5w2r _tqbwidpf _t9ec1soj _s7n4jp4b _wstuglyw _16r2ucr4 _14mj1qll _qc5orqeg _z0ai120g _1qdg120g _18postnw _aetrb3bt _1peq1xmd",
            !isDisabled && "_iosijmqp _11jyjmqp _f3ett94y _y2mvdfik _1bg41l7b _6tjkdfik _awqn1l7b _1rvql4ek _1p9jrsbi _x2tz1q28 _1iwz1q28 _sj8yr01l _jcko12kk _1dvdrsbi _60ak5w2r",
            isDisabled && "_80om13gf _1q6q187o _1151bk0g _1s6w2sac",
            isDisabled && isChecked && "_tqbwt94y",
            isInvalid && !isDisabled && "_1151s4qr _11jys4qr"
        ])
    })), label ? /*#__PURE__*/ _react.createElement("span", {
        className: (0, _runtime.ax)([
            "_85i5v77o _1q51v77o _y4ti1b66 _bozg1b66"
        ])
    }, label) : null);
});
/**
 * __Radio__
 *
 * A radio input allows users to select only one option from a number of choices. Radio is generally displayed in a radio group.
 *
 * - [Examples](https://atlassian.design/components/radio/examples)
 * - [Code](https://atlassian.design/components/radio/code)
 * - [Usage](https://atlassian.design/components/radio/usage)
 */ const Radio = /*#__PURE__*/ (0, _react.memo)(/*#__PURE__*/ (0, _react.forwardRef)(function Radio(props, ref) {
    return /*#__PURE__*/ _react.createElement(InnerRadio, (0, _objectSpreadProps._)((0, _objectSpread._)({}, props), {
        ref: ref
    }));
}));
exports.default = Radio;

},{"@swc/helpers/_/_object_spread":"9gdrV","@swc/helpers/_/_object_spread_props":"kANqQ","@swc/helpers/_/_object_without_properties":"6HqIM","react":"ltHCL","@compiled/react/runtime":"d27Vo","@atlaskit/analytics-next/usePlatformLeafEventHandler":"dRWFk","@atlaskit/ds-lib/noop":"faKzG","@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"4Gv67":[function(require,module,exports,__globalThis) {
/* index.tsx generated by @compiled/babel-plugin v0.39.1 */ var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "Table", ()=>Table);
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _compiled = require("@atlaskit/primitives/compiled");
const styles = {
    tableContainer: "_2rko1mok _1reo15vq _18m915vq _1dqonqa1 _189ee4h9 _1h6d1l7x _1bsb1osq _1kqm1n9t _19pkze3t _2hwxze3t _otyr1ejb _18u0ze3t _yq5hus1c _btyzidpf",
    tableHeader: "_1r04ze3t _1dqonqa1 _189ee4h9 _1h6d1l7x _s7n4nkob _kqswh2mm _13li1mok",
    tableHeaderCell: "_11c8i4vh _1dqoglyw _1e0cdav6 _kqswh2mm _r06hglyw _s7n4nkob _vchhusvi _1il9nqa1 _1doce4h9 _1o3i1l7x _syazazsu _ca0qu2gc _u5f3u2gc _n3tdu2gc _19bvu2gc _1lhcu2gc",
    cell: "_5pio18uv _11c8fhey _1dqoglyw _1e0cdav6 _kqswh2mm _r06hglyw _s7n4nkob _vchhusvi _1il9nqa1 _1doce4h9 _1o3i1l7x _syazi7uo _ca0qu2gc _u5f3u2gc _n3tdu2gc _19bvu2gc _1lhcu2gc"
};
const Table = ({ head, rows, emptyState })=>/*#__PURE__*/ (0, _reactDefault.default).createElement((0, _compiled.Box), {
        as: "table",
        xcss: styles.tableContainer
    }, /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _compiled.Box), {
        as: "thead",
        xcss: styles.tableHeader
    }, /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _compiled.Box), {
        as: "tr"
    }, head.cells.map((cell)=>/*#__PURE__*/ (0, _reactDefault.default).createElement((0, _compiled.Box), {
            as: "th",
            xcss: styles.tableHeaderCell,
            // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop
            style: cell.width ? {
                width: cell.width
            } : undefined,
            key: cell.key,
            scope: "col"
        }, cell.content)))), /*#__PURE__*/ (0, _reactDefault.default).createElement("tbody", null, rows.length > 0 ? rows.map((row)=>/*#__PURE__*/ (0, _reactDefault.default).createElement((0, _compiled.Box), {
            as: "tr",
            key: row.key
        }, row.cells.map((cell, index)=>/*#__PURE__*/ (0, _reactDefault.default).createElement((0, _compiled.Box), {
                as: "td",
                xcss: styles.cell,
                key: `${row.key}-${index}`
            }, cell.content)))) : /*#__PURE__*/ (0, _reactDefault.default).createElement("tr", null, /*#__PURE__*/ (0, _reactDefault.default).createElement("td", {
        colSpan: head.cells.length
    }, emptyState))));

},{"react":"ltHCL","@atlaskit/primitives/compiled":"hDay7","@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"adpjC":[function(require,module,exports,__globalThis) {
/* index.tsx generated by @compiled/babel-plugin v0.39.1 */ var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "Card", ()=>Card);
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _reactIntl = require("react-intl");
var _chevronDown = require("@atlaskit/icon/core/chevron-down");
var _chevronDownDefault = parcelHelpers.interopDefault(_chevronDown);
var _chevronUp = require("@atlaskit/icon/core/chevron-up");
var _chevronUpDefault = parcelHelpers.interopDefault(_chevronUp);
var _compiled = require("@atlaskit/primitives/compiled");
var _messages = require("./messages");
var _messagesDefault = parcelHelpers.interopDefault(_messages);
const styles = {
    cardContainer: "_2rko1mok _1bsb1osq _16qst7xp _19pkpxbi _otyrpxbi",
    header: "_ca0qpxbi _u5f3pxbi _n3tdpxbi _19bvpxbi",
    content: "_ca0qpxbi _u5f3pxbi _n3tdpxbi _19bvpxbi _1bsb1osq",
    iconWrapper: "_2rko12b0 _18u0pxbi _1bsb1tcg _4t3i1tcg _ca0qze3t _u5f3ze3t _n3tdze3t _19bvze3t _bfhksm61 _irr31dpa",
    subSection: "_16jlkb7n _1o9zkb7n _i0dlf1ug _18u0pxbi _1e0c1txw _1bsb1mjv"
};
const Card = ({ header, children, subSection, isExpandable, expandableSectionName, defaultExpanded })=>{
    const { formatMessage } = (0, _reactIntl.useIntl)();
    const [isExpanded, setIsExpanded] = (0, _react.useState)(!!defaultExpanded);
    const handleToggle = (0, _react.useCallback)(()=>{
        setIsExpanded((prev)=>!prev);
    }, []);
    const Icon = isExpanded ? (0, _chevronUpDefault.default) : (0, _chevronDownDefault.default);
    const expandButtonLabel = formatMessage(isExpanded ? (0, _messagesDefault.default).collapseButtonWithLabel : (0, _messagesDefault.default).expandButtonWithLabel, {
        label: expandableSectionName
    });
    return /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _compiled.Box), {
        xcss: styles.cardContainer
    }, /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _compiled.Inline), {
        xcss: styles.header,
        alignBlock: "center",
        spread: "space-between"
    }, /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _compiled.Box), null, header), /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _compiled.Inline), {
        alignBlock: "center",
        alignInline: "center",
        spread: "space-between"
    }, subSection && !isExpanded && /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _compiled.Box), {
        xcss: styles.subSection
    }, subSection), isExpandable && /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _compiled.Pressable), {
        xcss: styles.iconWrapper,
        onClick: handleToggle
    }, /*#__PURE__*/ (0, _reactDefault.default).createElement(Icon, {
        spacing: "spacious",
        color: "var(--ds-text, #292A2E)",
        size: "small",
        label: expandButtonLabel
    })))), isExpanded ? /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _compiled.Box), {
        xcss: styles.content
    }, children) : null);
};

},{"react":"ltHCL","react-intl":"f41fF","@atlaskit/icon/core/chevron-down":"ieg9F","@atlaskit/icon/core/chevron-up":"i5Pp9","@atlaskit/primitives/compiled":"hDay7","./messages":"f3Yiz","@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"ieg9F":[function(require,module,exports,__globalThis) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::d56e8662eb8a8d2462ec3a39ff3aa40b>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = void 0;
var _react = _interopRequireDefault(require("6474b2bc1aa81236"));
var _baseNew = _interopRequireDefault(require("cb0d279c347efd19"));
function _interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "ChevronDown".
 * Category: multi-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Do not use 16px chevrons within buttons, icon buttons, or dropdowns to maintain visual cohesion with ADS which uses 12px chevrons.
Known uses: Open dropdown menu, expanded tree item, collapse tree item
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const ChevronDownIcon = (props)=>/*#__PURE__*/ _react.default.createElement(_baseNew.default, Object.assign({
        name: "ChevronDownIcon",
        dangerouslySetGlyph: `<path fill="currentcolor" d="m14.53 6.03-6 6a.75.75 0 0 1-1.004.052l-.056-.052-6-6 1.06-1.06L8 10.44l5.47-5.47z"/>`
    }, props));
ChevronDownIcon.displayName = 'ChevronDownIcon';
var _default = exports.default = ChevronDownIcon;

},{"6474b2bc1aa81236":"ltHCL","cb0d279c347efd19":"5XL7D"}],"i5Pp9":[function(require,module,exports,__globalThis) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::b6f832dcdc2d7a1f91afd5e9b90e10b9>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = void 0;
var _react = _interopRequireDefault(require("736e768e496ffeb"));
var _baseNew = _interopRequireDefault(require("685d5c65ac64a85d"));
function _interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "ChevronUp".
 * Category: multi-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Do not use 16px chevrons within buttons, icon buttons, or dropdowns to maintain visual cohesion with ADS which uses 12px chevrons.
Known uses: Close dropdown menu
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const ChevronUpIcon = (props)=>/*#__PURE__*/ _react.default.createElement(_baseNew.default, Object.assign({
        name: "ChevronUpIcon",
        dangerouslySetGlyph: `<path fill="currentcolor" d="m14.53 9.97-6-6a.75.75 0 0 0-1.004-.052l-.056.052-6 6 1.06 1.06L8 5.56l5.47 5.47z"/>`
    }, props));
ChevronUpIcon.displayName = 'ChevronUpIcon';
var _default = exports.default = ChevronUpIcon;

},{"736e768e496ffeb":"ltHCL","685d5c65ac64a85d":"5XL7D"}],"f3Yiz":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _reactIntl = require("react-intl");
const messages = (0, _reactIntl.defineMessages)({
    expandButtonWithLabel: {
        id: 'atlassian-studio-ui-components.card.expandButtonWithLabel',
        defaultMessage: 'Expand {label}',
        description: 'Accessible label for a button on an expandable card that includes the section name. When clicked, this button expands the card to show additional details or content that is currently hidden.'
    },
    collapseButtonWithLabel: {
        id: 'atlassian-studio-ui-components.card.collapseButtonWithLabel',
        defaultMessage: 'Collapse {label}',
        description: 'Accessible label for a button on an expanded card that includes the section name. When clicked, this button collapses the card to hide the additional details or content.'
    }
});
exports.default = messages;

},{"react-intl":"f41fF","@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"e2MdE":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "PaginatedCharlieTable", ()=>PaginatedCharlieTable);
var _objectSpread = require("@swc/helpers/_/_object_spread");
var _objectSpreadProps = require("@swc/helpers/_/_object_spread_props");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _reactIntl = require("react-intl");
var _new = require("@atlaskit/button/new");
var _arrowDown = require("@atlaskit/icon/core/arrow-down");
var _arrowDownDefault = parcelHelpers.interopDefault(_arrowDown);
var _arrowUp = require("@atlaskit/icon/core/arrow-up");
var _arrowUpDefault = parcelHelpers.interopDefault(_arrowUp);
var _pagination = require("@atlaskit/pagination");
var _paginationDefault = parcelHelpers.interopDefault(_pagination);
var _compiled = require("@atlaskit/primitives/compiled");
var _charlieTable = require("@atlassian/charlie-table");
var _table = require("../../common/ui/table");
var _messages = require("./messages");
var _messagesDefault = parcelHelpers.interopDefault(_messages);
const DEFAULT_PAGE_SIZE = 10;
const UpButton = ({ onClick })=>{
    const { formatMessage } = (0, _reactIntl.useIntl)();
    return /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _new.IconButton), {
        icon: (props)=>/*#__PURE__*/ (0, _reactDefault.default).createElement((0, _arrowUpDefault.default), (0, _objectSpreadProps._)((0, _objectSpread._)({}, props), {
                color: "var(--ds-icon-subtle, #505258)",
                size: "small"
            })),
        onClick: onClick,
        label: formatMessage((0, _messagesDefault.default).sortAscending),
        appearance: "subtle",
        spacing: "compact"
    });
};
const DownButton = ({ onClick })=>{
    const { formatMessage } = (0, _reactIntl.useIntl)();
    return /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _new.IconButton), {
        icon: (props)=>/*#__PURE__*/ (0, _reactDefault.default).createElement((0, _arrowDownDefault.default), (0, _objectSpreadProps._)((0, _objectSpread._)({}, props), {
                color: "var(--ds-icon-subtle, #505258)",
                size: "small"
            })),
        onClick: onClick,
        label: formatMessage((0, _messagesDefault.default).sortDescending),
        appearance: "subtle",
        spacing: "compact"
    });
};
const ColumnHeaderCell = ({ column, table })=>{
    var _table_getSorting;
    return /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _compiled.Inline), {
        space: "space.050",
        alignBlock: "center"
    }, column.content, column.isSortable && /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _reactDefault.default).Fragment, null, table.getIsCurrentSort(column) ? ((_table_getSorting = table.getSorting()) === null || _table_getSorting === void 0 ? void 0 : _table_getSorting.direction) === 'asc' ? /*#__PURE__*/ (0, _reactDefault.default).createElement(UpButton, {
        onClick: ()=>table.setSorting({
                field: column.key,
                direction: 'desc'
            })
    }) : /*#__PURE__*/ (0, _reactDefault.default).createElement(DownButton, {
        onClick: ()=>table.setSorting({
                field: column.key,
                direction: 'asc'
            })
    }) : /*#__PURE__*/ (0, _reactDefault.default).createElement(UpButton, {
        onClick: ()=>table.setSorting({
                field: column.key,
                direction: 'desc'
            })
    })));
};
const PaginatedCharlieTable = ({ data, columns, emptyState, pageSize, isLoading, loadingState, onPageChange, hasNext })=>{
    const [page, setPage] = (0, _react.useState)(1);
    const table = (0, _charlieTable.useCharlieTable)({
        columns,
        rows: data
    });
    const currentPageRows = (0, _react.useMemo)(()=>table.rows.slice((page - 1) * (pageSize !== null && pageSize !== void 0 ? pageSize : DEFAULT_PAGE_SIZE), page * (pageSize !== null && pageSize !== void 0 ? pageSize : DEFAULT_PAGE_SIZE)), [
        page,
        pageSize,
        table.rows
    ]);
    const sortedRows = (0, _react.useMemo)(()=>{
        const currentSorting = table.getSorting();
        if (!currentSorting) return currentPageRows;
        return currentPageRows.sort((a, b)=>{
            var _columns_find;
            const sortFunction = (_columns_find = columns.find((col)=>col.key === currentSorting.field)) === null || _columns_find === void 0 ? void 0 : _columns_find.sortFunction;
            if (sortFunction) return sortFunction(a.data, b.data, currentSorting.direction);
            if (currentSorting.direction === 'asc') // @ts-ignore: data has generic type
            return a.data[currentSorting.field] - b.data[currentSorting.field];
            // @ts-ignore: data has generic type
            return b.data[currentSorting.field] - a.data[currentSorting.field];
        });
    }, [
        columns,
        currentPageRows,
        table
    ]);
    const pages = (0, _react.useMemo)(()=>{
        if (data.length === 0) return [
            1
        ];
        // If there is no overflowing items into next page
        if (data.length % (pageSize !== null && pageSize !== void 0 ? pageSize : DEFAULT_PAGE_SIZE) === 0) {
            // Add an extra page at the end if there is a next page
            if (hasNext) return Array.from(Array(Math.floor(data.length / (pageSize !== null && pageSize !== void 0 ? pageSize : DEFAULT_PAGE_SIZE)) + 1).keys(), (_, i)=>i + 1);
            else return Array.from(Array(Math.floor(data.length / (pageSize !== null && pageSize !== void 0 ? pageSize : DEFAULT_PAGE_SIZE))).keys(), (_, i)=>i + 1);
        } else return Array.from(Array(Math.floor(data.length / (pageSize !== null && pageSize !== void 0 ? pageSize : DEFAULT_PAGE_SIZE)) + 1).keys(), (_, i)=>i + 1);
    }, [
        data.length,
        hasNext,
        pageSize
    ]);
    return /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _compiled.Stack), {
        alignInline: "center"
    }, /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _table.Table), {
        head: {
            cells: table.getColumnsInOrder().map((col)=>({
                    key: col.key,
                    content: /*#__PURE__*/ (0, _reactDefault.default).createElement(ColumnHeaderCell, {
                        column: col,
                        table: table
                    }),
                    width: col.width ? `${col.width}px` : undefined
                }))
        },
        rows: isLoading ? [] : sortedRows.map((row, index)=>{
            var _row_groupKey;
            return {
                key: (_row_groupKey = row.groupKey) !== null && _row_groupKey !== void 0 ? _row_groupKey : index.toString(),
                cells: table.getColumnsInOrder().map((col)=>({
                        content: col.cell.render(row.data)
                    }))
            };
        }),
        emptyState: isLoading ? loadingState : emptyState
    }), pageSize && data.length > pageSize && /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _paginationDefault.default), {
        pages: pages,
        onChange: (_, page)=>{
            onPageChange === null || onPageChange === void 0 ? void 0 : onPageChange(page);
            setPage(page);
        },
        selectedIndex: page - 1
    }));
};

},{"@swc/helpers/_/_object_spread":"9gdrV","@swc/helpers/_/_object_spread_props":"kANqQ","react":"ltHCL","react-intl":"f41fF","@atlaskit/button/new":"aXnNi","@atlaskit/icon/core/arrow-down":"1ItQx","@atlaskit/icon/core/arrow-up":"kK2kA","@atlaskit/pagination":"jL7K3","@atlaskit/primitives/compiled":"hDay7","@atlassian/charlie-table":"cnfS7","../../common/ui/table":"4Gv67","./messages":"930s9","@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"aXnNi":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>(0, _buttonDefault.default));
parcelHelpers.export(exports, "LinkButton", ()=>(0, _linkDefault.default));
parcelHelpers.export(exports, "IconButton", ()=>(0, _buttonDefault1.default));
parcelHelpers.export(exports, "LinkIconButton", ()=>(0, _linkDefault1.default));
parcelHelpers.export(exports, "SplitButton", ()=>(0, _splitButton.SplitButton));
var _button = require("../new-button/variants/default/button");
var _buttonDefault = parcelHelpers.interopDefault(_button);
var _link = require("../new-button/variants/default/link");
var _linkDefault = parcelHelpers.interopDefault(_link);
var _button1 = require("../new-button/variants/icon/button");
var _buttonDefault1 = parcelHelpers.interopDefault(_button1);
var _link1 = require("../new-button/variants/icon/link");
var _linkDefault1 = parcelHelpers.interopDefault(_link1);
var _splitButton = require("../new-button/containers/split-button/split-button");

},{"../new-button/variants/default/button":"4u7fH","../new-button/variants/default/link":"bQlWh","../new-button/variants/icon/button":"43ide","../new-button/variants/icon/link":"g8Pan","../new-button/containers/split-button/split-button":"7v8tH","@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"4u7fH":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _objectSpread = require("@swc/helpers/_/_object_spread");
var _objectWithoutProperties = require("@swc/helpers/_/_object_without_properties");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _buttonBase = require("../shared/button-base");
var _buttonBaseDefault = parcelHelpers.interopDefault(_buttonBase);
var _content = require("../shared/content");
var _contentDefault = parcelHelpers.interopDefault(_content);
var _iconRenderer = require("../shared/icon-renderer");
var _iconRendererDefault = parcelHelpers.interopDefault(_iconRenderer);
/**
 * __Button__
 *
 * A button triggers an event or action.
 *
 * - [Examples](https://atlassian.design/components/button/examples)
 * - [Code](https://atlassian.design/components/button/code)
 * - [Usage](https://atlassian.design/components/button/usage)
 */ const Button = /*#__PURE__*/ (0, _reactDefault.default).memo(/*#__PURE__*/ (0, _reactDefault.default).forwardRef(function Button(_param, ref) {
    var { analyticsContext, appearance, 'aria-label': ariaLabel, 'aria-labelledby': ariaLabelledBy, autoFocus, children, iconAfter, iconBefore, interactionName, isDisabled, isLoading = false, isSelected, onClick, onClickCapture, onKeyDownCapture, onKeyUpCapture, onMouseDownCapture, onMouseUpCapture, onPointerDownCapture, onPointerUpCapture, onTouchEndCapture, onTouchStartCapture, shouldFitContainer, spacing, testId, type = 'button' } = _param, unsafeRest = (0, _objectWithoutProperties._)(_param, [
        "analyticsContext",
        "appearance",
        'aria-label',
        'aria-labelledby',
        "autoFocus",
        "children",
        "iconAfter",
        "iconBefore",
        "interactionName",
        "isDisabled",
        "isLoading",
        "isSelected",
        "onClick",
        "onClickCapture",
        "onKeyDownCapture",
        "onKeyUpCapture",
        "onMouseDownCapture",
        "onMouseUpCapture",
        "onPointerDownCapture",
        "onPointerUpCapture",
        "onTouchEndCapture",
        "onTouchStartCapture",
        "shouldFitContainer",
        "spacing",
        "testId",
        "type"
    ]);
    // @ts-expect-error
    const { className: _className, css: _css, as: _as, style: _style } = unsafeRest, saferRest = (0, _objectWithoutProperties._)(unsafeRest, [
        "className",
        "css",
        "as",
        "style"
    ]);
    return /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _buttonBaseDefault.default), (0, _objectSpread._)({
        analyticsContext: analyticsContext,
        ref: ref,
        appearance: appearance,
        autoFocus: autoFocus,
        isDisabled: isDisabled,
        isLoading: isLoading,
        isSelected: isSelected,
        hasIconBefore: Boolean(iconBefore),
        hasIconAfter: Boolean(iconAfter),
        shouldFitContainer: shouldFitContainer,
        spacing: spacing,
        ariaLabel: ariaLabel,
        ariaLabelledBy: ariaLabelledBy,
        onClick: onClick,
        onClickCapture: onClickCapture,
        onKeyDownCapture: onKeyDownCapture,
        onKeyUpCapture: onKeyUpCapture,
        onMouseDownCapture: onMouseDownCapture,
        onMouseUpCapture: onMouseUpCapture,
        onPointerDownCapture: onPointerDownCapture,
        onPointerUpCapture: onPointerUpCapture,
        onTouchStartCapture: onTouchStartCapture,
        onTouchEndCapture: onTouchEndCapture,
        testId: testId,
        componentName: "Button",
        type: type,
        interactionName: interactionName
    }, saferRest), iconBefore && /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _contentDefault.default), {
        type: "icon",
        position: "before",
        isLoading: isLoading
    }, /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _iconRendererDefault.default), {
        icon: iconBefore
    })), children && /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _contentDefault.default), {
        isLoading: isLoading
    }, children), iconAfter && /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _contentDefault.default), {
        type: "icon",
        position: "after",
        isLoading: isLoading
    }, /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _iconRendererDefault.default), {
        icon: iconAfter
    })));
}));
Button.displayName = 'Button';
exports.default = Button;

},{"@swc/helpers/_/_object_spread":"9gdrV","@swc/helpers/_/_object_without_properties":"6HqIM","react":"ltHCL","../shared/button-base":"d0P50","../shared/content":"jty5c","../shared/icon-renderer":"dQF4B","@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"d0P50":[function(require,module,exports,__globalThis) {
/* button-base.tsx generated by @compiled/babel-plugin v0.39.1 */ var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _objectSpread = require("@swc/helpers/_/_object_spread");
var _objectSpreadProps = require("@swc/helpers/_/_object_spread_props");
var _objectWithoutProperties = require("@swc/helpers/_/_object_without_properties");
var _runtime = require("@compiled/react/runtime");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _css = require("@atlaskit/css");
var _mergeRefs = require("@atlaskit/ds-lib/merge-refs");
var _mergeRefsDefault = parcelHelpers.interopDefault(_mergeRefs);
var _useAutoFocus = require("@atlaskit/ds-lib/use-auto-focus");
var _useAutoFocusDefault = parcelHelpers.interopDefault(_useAutoFocus);
var _useId = require("@atlaskit/ds-lib/use-id");
var _platformFeatureFlags = require("@atlaskit/platform-feature-flags");
var _compiled = require("@atlaskit/primitives/compiled");
var _visuallyHidden = require("@atlaskit/visually-hidden");
var _visuallyHiddenDefault = parcelHelpers.interopDefault(_visuallyHidden);
var _splitButtonContext = require("../../containers/split-button/split-button-context");
var _useSplitButtonContext = require("../../containers/split-button/use-split-button-context");
var _blockEvents = require("./block-events");
var _blockEventsDefault = parcelHelpers.interopDefault(_blockEvents);
var _loadingOverlay = require("./loading-overlay");
var _loadingOverlayDefault = parcelHelpers.interopDefault(_loadingOverlay);
const LOADING_LABEL = ', Loading';
const styles = {
    base: "_2rkofajl _11c8fhey _v5649dqc _189eidpf _1rjc12x7 _1e0c116y _vchhusvi _1bsb1wug _p12f1osq _kqswh2mm _4cvr1q9y _1bah1h6o _gy1p1b66 _1o9zidpf _4t3iviql _k48p1wq8 _y4tiutpp _bozgutpp _y3gn1h6o _s7n4nkob _14mj1kw7 _9v7aze3t _1tv3nqa1 _39yqe4h9 _11fnglyw _18postnw",
    baseT26Shape: "_2rko1qi0",
    interactiveMotion: "_v564o1g2 _1gglat8s",
    linkDecorationUnset: "_4bfu1r31 _1hmsglyw _ajmmnqa1 _1a3b1r31 _4fprglyw _5goinqa1 _9oik1r31 _1bnxglyw _jf4cnqa1 _1nrm1r31 _c2waglyw _1iohnqa1",
    disabled: "_80om13gf _syaz1gmx _30l31gmx _9h8h1gmx",
    sharedDisabled: "_bfhk187o _irr3187o _1di6187o",
    spacingCompact: "_1rjcv77o _gy1p1b66 _4t3i1k8s _y4tiutpp _bozgutpp _s7n4nkob",
    spacingCompactT26Shape: "_2rko12b0",
    circle: "_2rko1rr0",
    fullWidth: "_1bsb1osq",
    loading: "_80om15jw",
    iconButton: "_4t3iviql _1bsbviql _y4tize3t _bozgze3t",
    iconButtonCompact: "_4t3i1k8s _1bsb1k8s",
    buttonIconBefore: "_bozgutpp _gy1p12x7",
    buttonIconAfter: "_y4tiutpp _gy1p12x7",
    splitButton: "_g0pbb4wl",
    loadingOverlay: "_1reo15vq _18m915vq _1e0c1txw _kqswstnw _4cvr1h6o _1bah1h6o _u7coze3t _152tze3t _rjxpze3t _1e02ze3t",
    navigationSplitButton: "_1bsb1tcg _bfhksm61 _y4ti12x7 _bozg12x7"
};
const defaultStyles = {
    root: "_bfhksm61 _syazazsu _8l3m1l7x _aetrb3bt _1053azsu _f8pjazsu _30l3azsu _9h8hazsu",
    interactive: "_irr31dpa _30l3azsu _1di6fcek _9h8hazsu",
    disabled: "_bfhk1j28 _8l3mbk0g _irr31j28 _1di61j28"
};
const primaryStyles = {
    root: "_bfhk1856 _syaz15cr _105315cr _f8pj15cr _30l315cr _9h8h15cr",
    interactive: "_30l315cr _irr3hf2y _9h8h15cr _1di6g6ey"
};
const rovoStyles = {
    root: "_bfhklqh9 _syaz15cr _105315cr _f8pj15cr _30l315cr _9h8h15cr",
    interactive: "_30l315cr _irr31afz _9h8h15cr _1di61kru"
};
const warningStyles = {
    root: "_bfhk1kmu _syaz1yd3 _10531yd3 _f8pj1yd3 _30l31yd3 _9h8h1yd3",
    interactive: "_30l31yd3 _irr31spp _9h8h1yd3 _1di64m4m"
};
const dangerStyles = {
    root: "_bfhkybec _syaz15cr _105315cr _f8pj15cr _30l315cr _9h8h15cr",
    interactive: "_30l315cr _irr3s9hg _9h8h15cr _1di613a9"
};
const discoveryStyles = {
    root: "_bfhku5tj _syaz15cr _105315cr _f8pj15cr _30l315cr _9h8h15cr",
    interactive: "_30l315cr _irr3fqeg _9h8h15cr _1di61f1m"
};
const subtleStyles = {
    root: "_bfhksm61 _syazazsu _1053azsu _f8pjazsu _30l3azsu _9h8hazsu",
    interactive: "_irr31dpa _30l3azsu _1di6fcek _9h8hazsu",
    disabled: "_bfhk1j28 _8l3mbk0g _irr31j28 _1di61j28"
};
const selectedStyles = {
    root: "_bfhk15s3 _syaz6x5g _8l3mq98m _aetrb3bt _10536x5g _f8pj6x5g _30l36x5g _9h8h6x5g",
    insideSplitButton: "_1pbycs5v",
    interactive: "_irr3ufnl _30l36x5g _1di6nozp _9h8h6x5g",
    warning: "_bfhk15s3 _syaz6x5g _30l36x5g _irr315s3 _9h8h6x5g _1di615s3",
    danger: "_bfhk15s3 _syaz6x5g _30l36x5g _irr315s3 _9h8h6x5g _1di615s3",
    discovery: "_bfhk15s3 _syaz6x5g _30l36x5g _irr315s3 _9h8h6x5g _1di615s3"
};
/**
 * __button base__
 *
 * - Implements auto focus when enabled.
 * - Appends the `onClick` event with UFO analytics tracking.
 *
 * @private
 */ const ButtonBase = /*#__PURE__*/ (0, _reactDefault.default).forwardRef(// eslint-disable-next-line @typescript-eslint/ban-ts-comment
// @ts-ignore: to unblock React 18.2.0 -> 18.3.1 version bump in Jira
(_param, ref)=>{
    var { appearance: propAppearance, autoFocus = false, isDisabled: propIsDisabled = false, isLoading = false, isSelected: propIsSelected = false, isIconButton = false, isCircle = false, hasIconBefore = false, hasIconAfter = false, shouldFitContainer = false, spacing: propSpacing = 'default', ariaLabel, ariaLabelledBy, children, interactionName, onClick, onMouseDown, onMouseDownCapture, onMouseUp, onMouseUpCapture, onKeyDown, onKeyDownCapture, onKeyUp, onKeyUpCapture, onTouchStart, onTouchStartCapture, onTouchEnd, onTouchEndCapture, onPointerDown, onPointerDownCapture, onPointerUp, onPointerUpCapture, onClickCapture, testId, analyticsContext, componentName, role, onMouseOver, onMouseOut, onFocus, onBlur, onMouseMove, type } = _param, unsafeRest = (0, _objectWithoutProperties._)(_param, [
        "appearance",
        "autoFocus",
        "isDisabled",
        "isLoading",
        "isSelected",
        "isIconButton",
        "isCircle",
        "hasIconBefore",
        "hasIconAfter",
        "shouldFitContainer",
        "spacing",
        "ariaLabel",
        "ariaLabelledBy",
        "children",
        "interactionName",
        "onClick",
        "onMouseDown",
        "onMouseDownCapture",
        "onMouseUp",
        "onMouseUpCapture",
        "onKeyDown",
        "onKeyDownCapture",
        "onKeyUp",
        "onKeyUpCapture",
        "onTouchStart",
        "onTouchStartCapture",
        "onTouchEnd",
        "onTouchEndCapture",
        "onPointerDown",
        "onPointerDownCapture",
        "onPointerUp",
        "onPointerUpCapture",
        "onClickCapture",
        "testId",
        "analyticsContext",
        "componentName",
        "role",
        "onMouseOver",
        "onMouseOut",
        "onFocus",
        "onBlur",
        "onMouseMove",
        "type"
    ]);
    // React Compiler opt-out: RC-incompatible (memoization breaks runtime behaviour).
    'use no memo';
    const localRef = (0, _react.useRef)(null);
    const splitButtonContext = (0, _useSplitButtonContext.useSplitButtonContext)();
    const loadingLabelId = (0, _useId.useId)();
    const isSplitButton = Boolean(splitButtonContext);
    const isNavigationSplitButton = (splitButtonContext === null || splitButtonContext === void 0 ? void 0 : splitButtonContext.isNavigationSplitButton) || false;
    const isDefaultAppearanceSplitButton = (splitButtonContext === null || splitButtonContext === void 0 ? void 0 : splitButtonContext.appearance) === 'default';
    const appearance = isDefaultAppearanceSplitButton ? 'subtle' : propAppearance || (splitButtonContext === null || splitButtonContext === void 0 ? void 0 : splitButtonContext.appearance) || 'default';
    const spacing = (splitButtonContext === null || splitButtonContext === void 0 ? void 0 : splitButtonContext.spacing) || propSpacing;
    const isDisabled = (splitButtonContext === null || splitButtonContext === void 0 ? void 0 : splitButtonContext.isDisabled) || propIsDisabled;
    const isInteractive = !isDisabled && !isLoading;
    // Also treat loading buttons as disabled
    const isEffectivelyDisabled = isDisabled || isLoading;
    const isSelected = propIsSelected && !isDisabled;
    (0, _useAutoFocusDefault.default)(localRef, autoFocus);
    // @ts-expect-error
    const { className: _className, css: _css1, as: _as, style: _style } = unsafeRest, saferRest = (0, _objectWithoutProperties._)(unsafeRest, [
        "className",
        "css",
        "as",
        "style"
    ]);
    return /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _compiled.Pressable), (0, _objectSpreadProps._)((0, _objectSpread._)((0, _objectSpreadProps._)((0, _objectSpread._)((0, _objectSpreadProps._)((0, _objectSpread._)({}, saferRest), {
        componentName: componentName || 'button',
        analyticsContext: analyticsContext,
        role: role,
        ref: (0, _mergeRefsDefault.default)([
            localRef,
            ref
        ]),
        xcss: (0, _css.cx)(styles.base, (0, _platformFeatureFlags.fg)('platform-dst-shape-theme-default') && styles.baseT26Shape, isInteractive && (0, _platformFeatureFlags.fg)('platform-dst-motion-uplift-button') && styles.interactiveMotion, appearance === 'default' && defaultStyles.root, appearance === 'default' && isInteractive && defaultStyles.interactive, appearance === 'primary' && primaryStyles.root, appearance === 'primary' && isInteractive && primaryStyles.interactive, appearance === 'rovo' && rovoStyles.root, appearance === 'rovo' && isInteractive && rovoStyles.interactive, appearance === 'warning' && warningStyles.root, appearance === 'warning' && isInteractive && warningStyles.interactive, appearance === 'danger' && dangerStyles.root, appearance === 'danger' && isInteractive && dangerStyles.interactive, appearance === 'discovery' && discoveryStyles.root, appearance === 'discovery' && isInteractive && discoveryStyles.interactive, appearance === 'subtle' && subtleStyles.root, appearance === 'subtle' && isInteractive && subtleStyles.interactive, styles.linkDecorationUnset, isSelected && selectedStyles.root, isSelected && isSplitButton && selectedStyles.insideSplitButton, isSelected && isInteractive && selectedStyles.interactive, // TODO: remove me once we kill color fallbacks
        isSelected && appearance === 'danger' && selectedStyles.danger, // TODO: remove me once we kill color fallbacks
        isSelected && appearance === 'warning' && selectedStyles.warning, // TODO: remove me once we kill color fallbacks
        isSelected && appearance === 'discovery' && selectedStyles.discovery, isDisabled && styles.disabled, isDisabled && appearance !== 'default' && appearance !== 'subtle' && styles.sharedDisabled, isDisabled && appearance === 'default' && defaultStyles.disabled, spacing === 'compact' && styles.spacingCompact, spacing === 'compact' && (0, _platformFeatureFlags.fg)('platform-dst-shape-theme-default') && styles.spacingCompactT26Shape, // This must come after spacing compact styling as it overrides the border radius
        isCircle && !isSplitButton && styles.circle, shouldFitContainer && styles.fullWidth, hasIconBefore && styles.buttonIconBefore, hasIconAfter && styles.buttonIconAfter, isIconButton && styles.iconButton, isIconButton && spacing === 'compact' && styles.iconButtonCompact, isLoading && styles.loading, isSplitButton && styles.splitButton, isNavigationSplitButton && styles.navigationSplitButton),
        isDisabled: (0, _platformFeatureFlags.fg)('platform-dst_fix_not_focusable_loading_button') ? isDisabled : isEffectivelyDisabled
    }), (0, _platformFeatureFlags.fg)('platform-dst_fix_not_focusable_loading_button') && {
        'aria-live': 'polite'
    }, isLoading && (0, _platformFeatureFlags.fg)('platform-dst_fix_not_focusable_loading_button') && {
        'aria-disabled': true
    }), {
        "aria-label": isLoading && ariaLabel && !ariaLabelledBy ? `${ariaLabel} ${LOADING_LABEL}` : ariaLabel,
        "aria-labelledby": isLoading && ariaLabelledBy ? `${ariaLabelledBy} ${loadingLabelId}` : ariaLabelledBy,
        onClick: onClick
    }), (0, _blockEventsDefault.default)(isEffectivelyDisabled, {
        onMouseDownCapture,
        onMouseUpCapture,
        onKeyDownCapture,
        onKeyUpCapture,
        onTouchStartCapture,
        onTouchEndCapture,
        onPointerDownCapture,
        onPointerUpCapture,
        onClickCapture
    })), {
        testId: testId,
        onMouseOver: onMouseOver,
        onFocus: onFocus,
        onMouseMove: onMouseMove,
        onBlur: onBlur,
        type: type,
        interactionName: interactionName,
        onMouseDown: onMouseDown,
        onMouseUp: onMouseUp,
        onKeyDown: onKeyDown,
        onMouseOut: onMouseOut,
        onKeyUp: onKeyUp,
        onTouchStart: onTouchStart,
        onTouchEnd: onTouchEnd,
        onPointerDown: onPointerDown,
        onPointerUp: onPointerUp
    }), /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _splitButtonContext.SplitButtonContext).Provider, {
        value: undefined
    }, children, isLoading && /*#__PURE__*/ (0, _reactDefault.default).createElement("span", {
        className: (0, _runtime.ax)([
            styles.loadingOverlay
        ])
    }, (0, _loadingOverlayDefault.default)({
        spacing: spacing,
        appearance: appearance,
        isDisabled: isDisabled,
        isSelected: isSelected,
        testId
    })), isLoading && (ariaLabelledBy || !ariaLabel) && /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _visuallyHiddenDefault.default), {
        id: loadingLabelId
    }, LOADING_LABEL)));
});
exports.default = ButtonBase;

},{"@swc/helpers/_/_object_spread":"9gdrV","@swc/helpers/_/_object_spread_props":"kANqQ","@swc/helpers/_/_object_without_properties":"6HqIM","@compiled/react/runtime":"d27Vo","react":"ltHCL","@atlaskit/css":"kMGms","@atlaskit/ds-lib/merge-refs":"doPwA","@atlaskit/ds-lib/use-auto-focus":"cDep4","@atlaskit/ds-lib/use-id":"9jWCD","@atlaskit/platform-feature-flags":"8rD2i","@atlaskit/primitives/compiled":"hDay7","@atlaskit/visually-hidden":"gKDx1","../../containers/split-button/split-button-context":"D7RWu","../../containers/split-button/use-split-button-context":"eQP3I","./block-events":"eE345","./loading-overlay":"i2TAm","@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"cDep4":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>useAutoFocus);
var _react = require("react");
function useAutoFocus(ref, autoFocus) {
    const initialMount = (0, _react.useRef)(true);
    (0, _react.useEffect)(()=>{
        if (ref && initialMount.current && autoFocus && ref.current) ref.current.focus();
        initialMount.current = false;
    }, [
        autoFocus,
        ref
    ]);
}

},{"react":"ltHCL","@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"D7RWu":[function(require,module,exports,__globalThis) {
/* eslint-disable @repo/internal/react/require-jsdoc */ var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "SplitButtonContext", ()=>SplitButtonContext);
var _react = require("react");
const SplitButtonContext = /*#__PURE__*/ (0, _react.createContext)(undefined);

},{"react":"ltHCL","@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"eQP3I":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "useSplitButtonContext", ()=>useSplitButtonContext);
var _react = require("react");
var _splitButtonContext = require("./split-button-context");
const useSplitButtonContext = ()=>{
    const context = (0, _react.useContext)((0, _splitButtonContext.SplitButtonContext));
    if (!context) return undefined;
    if (context.appearance === 'navigation') {
        const newContext = {
            spacing: 'default',
            appearance: 'subtle',
            isDisabled: false,
            isActiveOverSelected: false,
            isNavigationSplitButton: true,
            isHighlighted: context.isHighlighted
        };
        return newContext;
    }
    const splitButtonContext = {
        spacing: context.spacing,
        appearance: context.appearance,
        isDisabled: context.isDisabled,
        isActiveOverSelected: true,
        isNavigationSplitButton: false,
        isHighlighted: false
    };
    return splitButtonContext;
};

},{"react":"ltHCL","./split-button-context":"D7RWu","@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"eE345":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>blockEvents);
function abort(event) {
    event.preventDefault();
    event.stopPropagation();
}
const tabKeyCode = 9;
function onKey(event) {
    // Allowing tab so that a user can move focus away
    if (event.keyCode === tabKeyCode) return;
    abort(event);
}
function blockEvents(shouldBlockEvents, events) {
    return shouldBlockEvents ? {
        onMouseDownCapture: abort,
        onMouseUpCapture: abort,
        onKeyDownCapture: onKey,
        onKeyUpCapture: onKey,
        onTouchStartCapture: abort,
        onTouchEndCapture: abort,
        onPointerDownCapture: abort,
        onPointerUpCapture: abort,
        onClickCapture: abort,
        // Just smashing the existing onClick for good measure
        onClick: abort
    } : events;
}

},{"@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"i2TAm":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>renderLoadingOverlay);
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _spinner = require("@atlaskit/spinner");
var _spinnerDefault = parcelHelpers.interopDefault(_spinner);
function getIconSpacing(spacing) {
    switch(spacing){
        case 'compact':
            return 'small';
        default:
            return 'medium';
    }
}
function getSpinnerAppearance({ appearance, isDisabled, isSelected }) {
    if (isDisabled || isSelected) return 'inherit';
    if (appearance === 'primary' || appearance === 'rovo' || appearance === 'danger' || appearance === 'discovery') return 'invert';
    return 'inherit';
}
function renderLoadingOverlay({ appearance, spacing, isDisabled, isSelected, testId }) {
    return /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _spinnerDefault.default), {
        size: getIconSpacing(spacing),
        appearance: getSpinnerAppearance({
            appearance,
            isDisabled,
            isSelected
        }),
        testId: testId ? `${testId}--loading-spinner` : undefined
    });
}

},{"react":"ltHCL","@atlaskit/spinner":"l22fT","@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"l22fT":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>(0, _spinnerDefault.default));
var _spinner = require("./spinner");
var _spinnerDefault = parcelHelpers.interopDefault(_spinner);

},{"./spinner":"7eBhY","@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"7eBhY":[function(require,module,exports,__globalThis) {
/* spinner.tsx generated by @compiled/babel-plugin v0.39.1 */ var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _runtime = require("@compiled/react/runtime");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _interactionContext = require("@atlaskit/interaction-context");
var _interactionContextDefault = parcelHelpers.interopDefault(_interactionContext);
var _constants = require("./constants");
/**
 * Returns the appropriate circle stroke color.
 */ function getStrokeColor(appearance) {
    return appearance === 'inherit' ? "var(--ds-icon-subtle, #505258)" : "var(--ds-icon-inverse, #FFFFFF)";
}
const rotate = null;
/**
 * There are three parts to the load in animation:
 * 1. Accelerated spin
 * 2. Stretch the spinner line
 */ const loadIn = null;
const styles = {
    rotateStyles: "_j7hqsf8s _5sag12kz _tip812c5 _1pgl2qsq _8hrz1h6o",
    loadInStyles: "_j7hq1ky6 _5sag9cwz _1pgl1ytf _1o51q7pw",
    wrapperStyles: "_1e0c116y _s7n4nkob",
    circleStyles: "_lswuglyw _7ljx1dhp _1snbbs82 _jcxd7g3v _1tjm1onz"
};
/**
 * `useLayoutEffect` is being used in SSR safe form. On the server, this work doesn’t need to run.
 * `useEffect` is used in-place, because `useEffect` is not run on the server and it matches types
 * which makes things simpler than doing an `isServer` check or a `null` check.
 *
 * @see https://hello.atlassian.net/wiki/spaces/DST/pages/2081696628/DSTDACI-010+-+Interaction+Tracing+hooks+in+DS+components
 */ const useLayoutEffect = typeof window === 'undefined' ? (0, _react.useEffect) : (0, _react.useLayoutEffect);
/**
 * __Spinner__
 *
 * A spinner is an animated spinning icon that lets users know content is being loaded.
 *
 * - [Examples](https://atlassian.design/components/spinner/examples)
 * - [Code](https://atlassian.design/components/spinner/code)
 * - [Usage](https://atlassian.design/components/spinner/usage)
 */ const Spinner = /*#__PURE__*/ (0, _reactDefault.default).memo(/*#__PURE__*/ (0, _reactDefault.default).forwardRef(function Spinner({ appearance = 'inherit', delay = 0, interactionName, label, size: providedSize = 'medium', testId }, ref) {
    const size = typeof providedSize === 'number' ? providedSize : (0, _constants.presetSizes)[providedSize];
    const animationDelay = `${delay}ms`;
    const stroke = getStrokeColor(appearance);
    const context = (0, _react.useContext)((0, _interactionContextDefault.default));
    useLayoutEffect(()=>{
        if (context != null) return context.hold(interactionName);
    }, [
        context,
        interactionName
    ]);
    /**
   * The Spinner animation uses a combination of two
   * css animations on two separate elements.
   */ return /*#__PURE__*/ (0, _reactDefault.default).createElement("span", {
        /**
   * This span exists to off-load animations from the circle element,
   * which were causing performance issues (style recalculations)
   * on Safari and older versions of Chrome.
   *
   * This can be removed and styles placed back on the circle element once
   * Safari fixes this bug and off-loads rendering to the GPU from the CPU.
   */ "data-testid": testId ? `${testId}-wrapper` : 'spinner-wrapper',
        // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
        style: {
            animationDelay,
            width: size,
            height: size
        },
        className: (0, _runtime.ax)([
            styles.wrapperStyles,
            styles.rotateStyles
        ])
    }, /*#__PURE__*/ (0, _reactDefault.default).createElement("svg", {
        height: size,
        width: size,
        viewBox: "0 0 16 16",
        xmlns: "http://www.w3.org/2000/svg",
        "data-testid": testId,
        ref: ref,
        "aria-label": label || undefined,
        // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
        style: {
            animationDelay
        },
        role: label ? 'img' : 'none',
        className: (0, _runtime.ax)([
            styles.loadInStyles
        ])
    }, /*#__PURE__*/ (0, _reactDefault.default).createElement("circle", {
        cx: "8",
        cy: "8",
        r: "7",
        style: {
            stroke
        },
        className: (0, _runtime.ax)([
            styles.circleStyles
        ])
    })));
}));
exports.default = Spinner;

},{"@compiled/react/runtime":"d27Vo","react":"ltHCL","@atlaskit/interaction-context":"18HT9","./constants":"7sNU4","@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"7sNU4":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "presetSizes", ()=>presetSizes);
const presetSizes = {
    xsmall: 12,
    small: 16,
    medium: 24,
    large: 48,
    xlarge: 96
};

},{"@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"jty5c":[function(require,module,exports,__globalThis) {
/* content.tsx generated by @compiled/babel-plugin v0.39.1 */ var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _runtime = require("@compiled/react/runtime");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
const styles = {
    text: "_1reo15vq _18m915vq _16jlkb7n _1o9zkb7n _1bto1l2s _o5721q9c",
    icon: "_1e0c1txw _16jlidpf _1o9zidpf _1wpz1h6o _1wybidpf _vwz4idpf _uiztglyw",
    common: "_v564g17y",
    fade: "_tzy4idpf"
};
/**
 * __Content__
 *
 * Used for slots within a Button, including icons and text content.
 */ const Content = ({ children, type = 'text', isLoading })=>{
    return /*#__PURE__*/ (0, _reactDefault.default).createElement("span", {
        className: (0, _runtime.ax)([
            styles.common,
            type === 'text' && styles.text,
            type === 'icon' && styles.icon,
            isLoading && styles.fade
        ])
    }, children);
};
exports.default = Content;

},{"@compiled/react/runtime":"d27Vo","react":"ltHCL","@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"dQF4B":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _platformFeatureFlags = require("@atlaskit/platform-feature-flags");
function isIconRenderProp(func) {
    return !func.displayName && // most function components and class components have a displayName, negate them
    !func.render && // forwardRef doesn't require a display name, however it does include a render function, negate them
    typeof func === 'function' // at the very least we need to be a function
    ;
}
/**
 * __Icon renderer__
 *
 * Used to support render props with icons.
 *
 */ const IconRenderer = ({ icon: Icon })=>{
    // React Compiler opt-out: RC-incompatible (memoization breaks runtime behaviour).
    'use no memo';
    const isRenderProp = isIconRenderProp(Icon);
    let iconProps = {
        label: '',
        color: 'currentColor',
        size: (0, _platformFeatureFlags.fg)('platform_dst_button_chevron_sizing') ? (iconName)=>iconName.startsWith('Chevron') ? 'small' : 'medium' : undefined
    };
    // @ts-ignore - TS2322 TypeScript 5.9.2 upgrade
    return /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _reactDefault.default).Fragment, null, isRenderProp ? Icon(iconProps) : /*#__PURE__*/ (0, _reactDefault.default).createElement(Icon, iconProps));
};
exports.default = IconRenderer;

},{"react":"ltHCL","@atlaskit/platform-feature-flags":"8rD2i","@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"bQlWh":[function(require,module,exports,__globalThis) {
/* link.tsx generated by @compiled/babel-plugin v0.39.1 */ var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _objectSpread = require("@swc/helpers/_/_object_spread");
var _objectSpreadProps = require("@swc/helpers/_/_object_spread_props");
var _objectWithoutProperties = require("@swc/helpers/_/_object_without_properties");
var _react = require("react");
var _css = require("@atlaskit/css");
var _mergeRefs = require("@atlaskit/ds-lib/merge-refs");
var _mergeRefsDefault = parcelHelpers.interopDefault(_mergeRefs);
var _useAutoFocus = require("@atlaskit/ds-lib/use-auto-focus");
var _useAutoFocusDefault = parcelHelpers.interopDefault(_useAutoFocus);
var _platformFeatureFlags = require("@atlaskit/platform-feature-flags");
var _compiled = require("@atlaskit/primitives/compiled");
var _content = require("../shared/content");
var _contentDefault = parcelHelpers.interopDefault(_content);
var _iconRenderer = require("../shared/icon-renderer");
var _iconRendererDefault = parcelHelpers.interopDefault(_iconRenderer);
const styles = {
    base: "_2rkofajl _11c8fhey _v5649dqc _189eidpf _1rjc12x7 _1e0c116y _vchhusvi _1bsb1wug _p12f1osq _kqswh2mm _4cvr1q9y _1bah1h6o _gy1p1b66 _1o9zidpf _4t3iviql _k48p1wq8 _y4tiutpp _bozgutpp _y3gn1h6o _s7n4nkob _14mj1kw7 _9v7aze3t _1tv3nqa1 _39yqe4h9 _11fnglyw _18postnw",
    baseT26Shape: "_2rko1qi0",
    interactiveMotion: "_v564o1g2 _1gglat8s",
    linkDecorationUnset: "_4bfu1snc _1hmsagmp _ajmmvv82 _1a3b1r31 _4fprglyw _5goinqa1 _9oik1r31 _1bnxglyw _jf4cnqa1 _1nrm1r31 _c2waglyw _1iohnqa1",
    disabled: "_80om13gf _bfhk187o _syaz1gmx _aetrglyw _irr3187o _30l31gmx _1di6187o _9h8h1gmx",
    spacingCompact: "_1rjcv77o _gy1p1b66 _4t3i1k8s _y4tiutpp _bozgutpp _s7n4nkob",
    buttonIconBefore: "_bozgutpp _gy1p12x7",
    buttonIconAfter: "_y4tiutpp _gy1p12x7",
    fullWidth: "_1bsb1osq"
};
const defaultStyles = {
    root: "_bfhksm61 _syazazsu _8l3m1l7x _aetrb3bt _1053azsu _f8pjazsu _irr31dpa _30l3azsu _1di6fcek _9h8hazsu"
};
const primaryStyles = {
    root: "_bfhk1856 _syaz15cr _105315cr _f8pj15cr _30l315cr _irr3hf2y _9h8h15cr _1di6g6ey"
};
const rovoStyles = {
    root: "_bfhklqh9 _syaz15cr _105315cr _f8pj15cr _irr31afz _1di61kru"
};
const warningStyles = {
    root: "_bfhk1kmu _syaz1yd3 _10531yd3 _f8pj1yd3 _30l31yd3 _irr31spp _9h8h1yd3 _1di64m4m"
};
const dangerStyles = {
    root: "_bfhkybec _syaz15cr _105315cr _f8pj15cr _30l315cr _irr3s9hg _9h8h15cr _1di613a9"
};
const discoveryStyles = {
    root: "_bfhku5tj _syaz15cr _105315cr _f8pj15cr _30l315cr _irr3fqeg _9h8h15cr _1di61f1m"
};
const subtleStyles = {
    root: "_bfhksm61 _syazazsu _1053azsu _f8pj1mjl _irr31dpa _30l3azsu _1di6fcek _9h8hazsu"
};
const selectedStyles = {
    root: "_bfhk15s3 _syaz6x5g _8l3mq98m _aetrb3bt _10536x5g _f8pj6x5g _30l36x5g _9h8h6x5g",
    warning: "_bfhk15s3 _syaz6x5g _30l36x5g _irr315s3 _9h8h6x5g _1di615s3",
    danger: "_bfhk15s3 _syaz6x5g _30l36x5g _irr315s3 _9h8h6x5g _1di615s3",
    discovery: "_bfhk15s3 _syaz6x5g _30l36x5g _irr315s3 _9h8h6x5g _1di615s3"
};
/**
 * __Link Button__
 *
 * Renders a link in the style of a button.
 *
 * - [Examples](https://atlassian.design/components/link-button/examples)
 * - [Code](https://atlassian.design/components/link-button/code)
 * - [Usage](https://atlassian.design/components/link-button/usage)
 */ const LinkButtonBase = (_param, ref)=>{
    var { analyticsContext, appearance = 'default', 'aria-label': ariaLabel, 'aria-labelledby': ariaLabelledBy, autoFocus = false, children, href, iconAfter, iconBefore, interactionName, isDisabled, isSelected, onClick, onClickCapture, onKeyDownCapture, onKeyUpCapture, onMouseDownCapture, onMouseUpCapture, onPointerDownCapture, onPointerUpCapture, onTouchEndCapture, onTouchStartCapture, shouldFitContainer, spacing, testId } = _param, unsafeRest = (0, _objectWithoutProperties._)(_param, [
        "analyticsContext",
        "appearance",
        'aria-label',
        'aria-labelledby',
        "autoFocus",
        "children",
        "href",
        "iconAfter",
        "iconBefore",
        "interactionName",
        "isDisabled",
        "isSelected",
        "onClick",
        "onClickCapture",
        "onKeyDownCapture",
        "onKeyUpCapture",
        "onMouseDownCapture",
        "onMouseUpCapture",
        "onPointerDownCapture",
        "onPointerUpCapture",
        "onTouchEndCapture",
        "onTouchStartCapture",
        "shouldFitContainer",
        "spacing",
        "testId"
    ]);
    // @ts-expect-error
    const { className: _className, css: _css1, as: _as, style: _style } = unsafeRest, saferRest = (0, _objectWithoutProperties._)(unsafeRest, [
        "className",
        "css",
        "as",
        "style"
    ]);
    const hasIconAfter = Boolean(iconAfter);
    const hasIconBefore = Boolean(iconBefore);
    const localRef = (0, _react.useRef)(null);
    (0, _useAutoFocusDefault.default)(localRef, autoFocus);
    const combinedRef = (0, _mergeRefsDefault.default)([
        localRef,
        ref
    ]);
    return /*#__PURE__*/ _react.createElement((0, _compiled.Anchor), (0, _objectSpreadProps._)((0, _objectSpread._)({
        analyticsContext: analyticsContext,
        ref: combinedRef,
        /**
   * Disable link in an accessible way using `href`, `role`, and `aria-disabled`.
   * @see https://a11y-guidelines.orange.com/en/articles/disable-elements/#disable-a-link
   */ // @ts-expect-error (`href` is required, we could make it optional but don't want to encourage this pattern elsewhere)
        href: isDisabled ? undefined : href,
        role: isDisabled ? 'link' : undefined,
        "aria-disabled": isDisabled === true ? true : undefined,
        "aria-label": ariaLabel,
        "aria-labelledby": ariaLabelledBy,
        onClick: onClick,
        onClickCapture: onClickCapture,
        onKeyDownCapture: onKeyDownCapture,
        onKeyUpCapture: onKeyUpCapture,
        onMouseDownCapture: onMouseDownCapture,
        onMouseUpCapture: onMouseUpCapture,
        onPointerDownCapture: onPointerDownCapture,
        onPointerUpCapture: onPointerUpCapture,
        onTouchEndCapture: onTouchEndCapture,
        onTouchStartCapture: onTouchStartCapture,
        testId: testId,
        componentName: "LinkButton",
        interactionName: interactionName
    }, saferRest), {
        xcss: (0, _css.cx)(styles.base, (0, _platformFeatureFlags.fg)('platform-dst-shape-theme-default') && styles.baseT26Shape, !isDisabled && (0, _platformFeatureFlags.fg)('platform-dst-motion-uplift-button') && styles.interactiveMotion, appearance === 'default' && defaultStyles.root, appearance === 'primary' && primaryStyles.root, appearance === 'rovo' && rovoStyles.root, appearance === 'warning' && warningStyles.root, appearance === 'danger' && dangerStyles.root, appearance === 'discovery' && discoveryStyles.root, appearance === 'subtle' && subtleStyles.root, styles.linkDecorationUnset, isSelected && selectedStyles.root, isSelected && appearance === 'danger' && selectedStyles.danger, isSelected && appearance === 'warning' && selectedStyles.warning, isSelected && appearance === 'discovery' && selectedStyles.discovery, isDisabled && styles.disabled, spacing === 'compact' && styles.spacingCompact, hasIconBefore && styles.buttonIconBefore, hasIconAfter && styles.buttonIconAfter, shouldFitContainer && styles.fullWidth)
    }), iconBefore && /*#__PURE__*/ _react.createElement((0, _contentDefault.default), {
        type: "icon",
        position: "before",
        isLoading: false
    }, /*#__PURE__*/ _react.createElement((0, _iconRendererDefault.default), {
        icon: iconBefore
    })), children && /*#__PURE__*/ _react.createElement((0, _contentDefault.default), {
        isLoading: false
    }, children), iconAfter && /*#__PURE__*/ _react.createElement((0, _contentDefault.default), {
        type: "icon",
        position: "after",
        isLoading: false
    }, /*#__PURE__*/ _react.createElement((0, _iconRendererDefault.default), {
        icon: iconAfter
    })));
};
// Workarounds to support generic types with forwardRef
/**
 * __Link Button__
 *
 * Renders a link in the style of a button.
 *
 * - [Examples](https://atlassian.design/components/link-button/examples)
 * - [Code](https://atlassian.design/components/link-button/code)
 * - [Usage](https://atlassian.design/components/link-button/usage)
 */ const LinkButton = /*#__PURE__*/ (0, _react.forwardRef)(LinkButtonBase);
LinkButton.displayName = 'LinkButton';
exports.default = LinkButton;

},{"@swc/helpers/_/_object_spread":"9gdrV","@swc/helpers/_/_object_spread_props":"kANqQ","@swc/helpers/_/_object_without_properties":"6HqIM","react":"ltHCL","@atlaskit/css":"kMGms","@atlaskit/ds-lib/merge-refs":"doPwA","@atlaskit/ds-lib/use-auto-focus":"cDep4","@atlaskit/platform-feature-flags":"8rD2i","@atlaskit/primitives/compiled":"hDay7","../shared/content":"jty5c","../shared/icon-renderer":"dQF4B","@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"43ide":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _objectSpread = require("@swc/helpers/_/_object_spread");
var _objectSpreadProps = require("@swc/helpers/_/_object_spread_props");
var _objectWithoutProperties = require("@swc/helpers/_/_object_without_properties");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _mergeRefs = require("@atlaskit/ds-lib/merge-refs");
var _mergeRefsDefault = parcelHelpers.interopDefault(_mergeRefs);
var _tooltip = require("@atlaskit/tooltip");
var _tooltipDefault = parcelHelpers.interopDefault(_tooltip);
var _visuallyHidden = require("@atlaskit/visually-hidden");
var _visuallyHiddenDefault = parcelHelpers.interopDefault(_visuallyHidden);
var _buttonBase = require("../shared/button-base");
var _buttonBaseDefault = parcelHelpers.interopDefault(_buttonBase);
var _content = require("../shared/content");
var _contentDefault = parcelHelpers.interopDefault(_content);
var _iconRenderer = require("../shared/icon-renderer");
var _iconRendererDefault = parcelHelpers.interopDefault(_iconRenderer);
/**
 * __Icon Button__
 *
 * Renders an icon-only button lets people take a common and recognizable action where space is limited.
 *
 * - [Examples](https://atlassian.design/components/button/icon-button/examples)
 * - [Code](https://atlassian.design/components/button/icon-button/code)
 * - [Usage](https://atlassian.design/components/button/icon-button/usage)
 */ const IconButton = /*#__PURE__*/ (0, _reactDefault.default).memo(/*#__PURE__*/ (0, _reactDefault.default).forwardRef(function Button(_param, ref) {
    var { // Prevent duplicate labels being added.
    'aria-label': preventedAriaLabel, 'aria-labelledby': ariaLabelledBy, analyticsContext, appearance, autoFocus, icon, interactionName, isDisabled, isLoading = false, isSelected, isTooltipDisabled = true, label, onClick, onClickCapture, onKeyDownCapture, onKeyUpCapture, onMouseDownCapture, onMouseUpCapture, onPointerDownCapture, onPointerUpCapture, onTouchEndCapture, onTouchStartCapture, shape, spacing, testId, tooltip, type = 'button' } = _param, unsafeRest = (0, _objectWithoutProperties._)(_param, [
        'aria-label',
        'aria-labelledby',
        "analyticsContext",
        "appearance",
        "autoFocus",
        "icon",
        "interactionName",
        "isDisabled",
        "isLoading",
        "isSelected",
        "isTooltipDisabled",
        "label",
        "onClick",
        "onClickCapture",
        "onKeyDownCapture",
        "onKeyUpCapture",
        "onMouseDownCapture",
        "onMouseUpCapture",
        "onPointerDownCapture",
        "onPointerUpCapture",
        "onTouchEndCapture",
        "onTouchStartCapture",
        "shape",
        "spacing",
        "testId",
        "tooltip",
        "type"
    ]);
    // @ts-expect-error
    const { className: _className, css: _css, as: _as, style: _style } = unsafeRest, saferRest = (0, _objectWithoutProperties._)(unsafeRest, [
        "className",
        "css",
        "as",
        "style"
    ]);
    if (isTooltipDisabled) return /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _buttonBaseDefault.default), (0, _objectSpreadProps._)((0, _objectSpread._)({}, saferRest), {
        ref: ref,
        appearance: appearance,
        autoFocus: autoFocus,
        isDisabled: isDisabled,
        isLoading: isLoading,
        isSelected: isSelected,
        isIconButton: true,
        isCircle: shape === 'circle',
        hasIconBefore: !!icon,
        spacing: spacing,
        ariaLabelledBy: ariaLabelledBy,
        onClick: onClick,
        onClickCapture: onClickCapture,
        onKeyDownCapture: onKeyDownCapture,
        onKeyUpCapture: onKeyUpCapture,
        onMouseDownCapture: onMouseDownCapture,
        onMouseUpCapture: onMouseUpCapture,
        onPointerDownCapture: onPointerDownCapture,
        onPointerUpCapture: onPointerUpCapture,
        onTouchStartCapture: onTouchStartCapture,
        onTouchEndCapture: onTouchEndCapture,
        testId: testId,
        componentName: "IconButton",
        analyticsContext: analyticsContext,
        type: type,
        interactionName: interactionName
    }), /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _contentDefault.default), {
        type: "icon",
        isLoading: isLoading
    }, /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _iconRendererDefault.default), {
        icon: icon
    }), /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _visuallyHiddenDefault.default), null, label)));
    var _tooltip_content;
    return /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _tooltipDefault.default), {
        content: (_tooltip_content = tooltip === null || tooltip === void 0 ? void 0 : tooltip.content) !== null && _tooltip_content !== void 0 ? _tooltip_content : label,
        testId: tooltip === null || tooltip === void 0 ? void 0 : tooltip.testId,
        position: tooltip === null || tooltip === void 0 ? void 0 : tooltip.position,
        delay: tooltip === null || tooltip === void 0 ? void 0 : tooltip.delay,
        onShow: tooltip === null || tooltip === void 0 ? void 0 : tooltip.onShow,
        onHide: tooltip === null || tooltip === void 0 ? void 0 : tooltip.onHide,
        mousePosition: tooltip === null || tooltip === void 0 ? void 0 : tooltip.mousePosition,
        analyticsContext: tooltip === null || tooltip === void 0 ? void 0 : tooltip.analyticsContext,
        strategy: tooltip === null || tooltip === void 0 ? void 0 : tooltip.strategy,
        tag: tooltip === null || tooltip === void 0 ? void 0 : tooltip.tag,
        truncate: tooltip === null || tooltip === void 0 ? void 0 : tooltip.truncate,
        component: tooltip === null || tooltip === void 0 ? void 0 : tooltip.component,
        hideTooltipOnClick: tooltip === null || tooltip === void 0 ? void 0 : tooltip.hideTooltipOnClick,
        hideTooltipOnMouseDown: tooltip === null || tooltip === void 0 ? void 0 : tooltip.hideTooltipOnMouseDown,
        ignoreTooltipPointerEvents: tooltip === null || tooltip === void 0 ? void 0 : tooltip.ignoreTooltipPointerEvents,
        shortcut: tooltip === null || tooltip === void 0 ? void 0 : tooltip.shortcut
    }, (triggerProps)=>/*#__PURE__*/ (0, _reactDefault.default).createElement((0, _buttonBaseDefault.default), (0, _objectSpreadProps._)((0, _objectSpread._)({}, saferRest), {
            appearance: appearance,
            autoFocus: autoFocus,
            isDisabled: isDisabled,
            isLoading: isLoading,
            isSelected: isSelected,
            isIconButton: true,
            isCircle: shape === 'circle',
            hasIconBefore: false,
            spacing: spacing,
            ariaLabelledBy: ariaLabelledBy,
            onClick: (e, analyticsEvent)=>{
                var _triggerProps_onClick;
                onClick === null || onClick === void 0 ? void 0 : onClick(e, analyticsEvent);
                (_triggerProps_onClick = triggerProps.onClick) === null || _triggerProps_onClick === void 0 ? void 0 : _triggerProps_onClick.call(triggerProps, e);
            },
            onMouseOver: (e)=>{
                var _triggerProps_onMouseOver, _saferRest_onMouseOver;
                (_triggerProps_onMouseOver = triggerProps.onMouseOver) === null || _triggerProps_onMouseOver === void 0 ? void 0 : _triggerProps_onMouseOver.call(triggerProps, e);
                (_saferRest_onMouseOver = saferRest.onMouseOver) === null || _saferRest_onMouseOver === void 0 ? void 0 : _saferRest_onMouseOver.call(saferRest, e);
            },
            onMouseOut: (e)=>{
                var _triggerProps_onMouseOut, _saferRest_onMouseOut;
                (_triggerProps_onMouseOut = triggerProps.onMouseOut) === null || _triggerProps_onMouseOut === void 0 ? void 0 : _triggerProps_onMouseOut.call(triggerProps, e);
                (_saferRest_onMouseOut = saferRest.onMouseOut) === null || _saferRest_onMouseOut === void 0 ? void 0 : _saferRest_onMouseOut.call(saferRest, e);
            },
            onMouseMove: (e)=>{
                var _triggerProps_onMouseMove, _saferRest_onMouseMove;
                (_triggerProps_onMouseMove = triggerProps.onMouseMove) === null || _triggerProps_onMouseMove === void 0 ? void 0 : _triggerProps_onMouseMove.call(triggerProps, e);
                (_saferRest_onMouseMove = saferRest.onMouseMove) === null || _saferRest_onMouseMove === void 0 ? void 0 : _saferRest_onMouseMove.call(saferRest, e);
            },
            onMouseDown: (e)=>{
                var _triggerProps_onMouseDown, _saferRest_onMouseDown;
                (_triggerProps_onMouseDown = triggerProps.onMouseDown) === null || _triggerProps_onMouseDown === void 0 ? void 0 : _triggerProps_onMouseDown.call(triggerProps, e);
                (_saferRest_onMouseDown = saferRest.onMouseDown) === null || _saferRest_onMouseDown === void 0 ? void 0 : _saferRest_onMouseDown.call(saferRest, e);
            },
            onFocus: (e)=>{
                var _triggerProps_onFocus, _saferRest_onFocus;
                (_triggerProps_onFocus = triggerProps.onFocus) === null || _triggerProps_onFocus === void 0 ? void 0 : _triggerProps_onFocus.call(triggerProps, e);
                (_saferRest_onFocus = saferRest.onFocus) === null || _saferRest_onFocus === void 0 ? void 0 : _saferRest_onFocus.call(saferRest, e);
            },
            onBlur: (e)=>{
                var _triggerProps_onBlur, _saferRest_onBlur;
                (_triggerProps_onBlur = triggerProps.onBlur) === null || _triggerProps_onBlur === void 0 ? void 0 : _triggerProps_onBlur.call(triggerProps, e);
                (_saferRest_onBlur = saferRest.onBlur) === null || _saferRest_onBlur === void 0 ? void 0 : _saferRest_onBlur.call(saferRest, e);
            },
            ref: (0, _mergeRefsDefault.default)([
                ref,
                triggerProps === null || triggerProps === void 0 ? void 0 : triggerProps.ref
            ].filter(Boolean)),
            onMouseDownCapture: onMouseDownCapture,
            onMouseUpCapture: onMouseUpCapture,
            onKeyDownCapture: onKeyDownCapture,
            onKeyUpCapture: onKeyUpCapture,
            onTouchStartCapture: onTouchStartCapture,
            onTouchEndCapture: onTouchEndCapture,
            onPointerDownCapture: onPointerDownCapture,
            onPointerUpCapture: onPointerUpCapture,
            onClickCapture: onClickCapture,
            type: type,
            testId: testId,
            analyticsContext: analyticsContext,
            interactionName: interactionName,
            componentName: "IconButton"
        }), /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _contentDefault.default), {
            type: "icon",
            isLoading: isLoading
        }, /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _iconRendererDefault.default), {
            icon: icon
        }), /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _visuallyHiddenDefault.default), null, label))));
}));
IconButton.displayName = 'IconButton';
exports.default = IconButton;

},{"@swc/helpers/_/_object_spread":"9gdrV","@swc/helpers/_/_object_spread_props":"kANqQ","@swc/helpers/_/_object_without_properties":"6HqIM","react":"ltHCL","@atlaskit/ds-lib/merge-refs":"doPwA","@atlaskit/tooltip":"7RyYv","@atlaskit/visually-hidden":"gKDx1","../shared/button-base":"d0P50","../shared/content":"jty5c","../shared/icon-renderer":"dQF4B","@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"g8Pan":[function(require,module,exports,__globalThis) {
/* link.tsx generated by @compiled/babel-plugin v0.39.1 */ var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _objectSpread = require("@swc/helpers/_/_object_spread");
var _objectSpreadProps = require("@swc/helpers/_/_object_spread_props");
var _objectWithoutProperties = require("@swc/helpers/_/_object_without_properties");
var _react = require("react");
var _css = require("@atlaskit/css");
var _mergeRefs = require("@atlaskit/ds-lib/merge-refs");
var _mergeRefsDefault = parcelHelpers.interopDefault(_mergeRefs);
var _useAutoFocus = require("@atlaskit/ds-lib/use-auto-focus");
var _useAutoFocusDefault = parcelHelpers.interopDefault(_useAutoFocus);
var _platformFeatureFlags = require("@atlaskit/platform-feature-flags");
var _compiled = require("@atlaskit/primitives/compiled");
var _tooltip = require("@atlaskit/tooltip");
var _tooltipDefault = parcelHelpers.interopDefault(_tooltip);
var _visuallyHidden = require("@atlaskit/visually-hidden");
var _visuallyHiddenDefault = parcelHelpers.interopDefault(_visuallyHidden);
var _content = require("../shared/content");
var _contentDefault = parcelHelpers.interopDefault(_content);
var _iconRenderer = require("../shared/icon-renderer");
var _iconRendererDefault = parcelHelpers.interopDefault(_iconRenderer);
const styles = {
    base: "_2rkofajl _11c8fhey _v5649dqc _189eidpf _1rjc12x7 _1e0c116y _vchhusvi _1bsb1wug _p12f1osq _kqswh2mm _4cvr1q9y _1bah1h6o _gy1p1b66 _1o9zidpf _4t3iviql _k48p1wq8 _y4tiutpp _bozgutpp _y3gn1h6o _s7n4nkob _14mj1kw7 _9v7aze3t _1tv3nqa1 _39yqe4h9 _11fnglyw _18postnw",
    baseT26Shape: "_2rko1qi0",
    interactiveMotion: "_v564o1g2 _1gglat8s",
    linkDecorationUnset: "_4bfu1snc _1hmsagmp _ajmmvv82 _1a3b1r31 _4fprglyw _5goinqa1 _9oik1r31 _1bnxglyw _jf4cnqa1 _1nrm1r31 _c2waglyw _1iohnqa1",
    disabled: "_80om13gf _bfhk187o _syaz1gmx _aetrglyw _irr3187o _30l31gmx _1di6187o _9h8h1gmx",
    spacingCompact: "_1rjcv77o _gy1p1b66 _y4tiutpp _bozgutpp _s7n4nkob _4t3i1k8s _1bsb1k8s",
    iconButton: "_4t3iviql _1bsbviql _y4tize3t _bozgze3t",
    circle: "_2rko1rr0"
};
const defaultStyles = {
    root: "_bfhksm61 _syazazsu _8l3m1l7x _aetrb3bt _1053azsu _f8pjazsu _irr31dpa _30l3azsu _1di6fcek _9h8hazsu"
};
const primaryStyles = {
    root: "_bfhk1856 _syaz15cr _105315cr _30l315cr _irr3hf2y _9h8h15cr _1di6g6ey"
};
const rovoStyles = {
    root: "_bfhklqh9 _syaz15cr _105315cr _irr31afz _1di61kru"
};
const discoveryStyles = {
    root: "_bfhku5tj _syaz15cr _105315cr _30l315cr _irr3fqeg _9h8h15cr _1di61f1m"
};
const subtleStyles = {
    root: "_bfhksm61 _syazazsu _1053azsu _f8pj1mjl _irr31dpa _30l3azsu _1di6fcek _9h8hazsu"
};
const selectedStyles = {
    root: "_bfhk15s3 _syaz6x5g _8l3mq98m _aetrb3bt _10536x5g _f8pj6x5g _30l36x5g _9h8h6x5g",
    discovery: "_bfhk15s3 _syaz6x5g _30l36x5g _irr315s3 _9h8h6x5g _1di615s3"
};
const LinkIconButtonBase = (_param, ref)=>{
    var { // Prevent duplicate labels being added.
    'aria-label': preventedAriaLabel, 'aria-labelledby': ariaLabelledBy, analyticsContext, appearance = 'default', autoFocus = false, href, icon, interactionName, isDisabled, isSelected, isTooltipDisabled = true, label, onClick, onClickCapture, onKeyDownCapture, onKeyUpCapture, onMouseDownCapture, onMouseUpCapture, onPointerDownCapture, onPointerUpCapture, onTouchEndCapture, onTouchStartCapture, shape, spacing, testId, tooltip } = _param, unsafeRest = (0, _objectWithoutProperties._)(_param, [
        'aria-label',
        'aria-labelledby',
        "analyticsContext",
        "appearance",
        "autoFocus",
        "href",
        "icon",
        "interactionName",
        "isDisabled",
        "isSelected",
        "isTooltipDisabled",
        "label",
        "onClick",
        "onClickCapture",
        "onKeyDownCapture",
        "onKeyUpCapture",
        "onMouseDownCapture",
        "onMouseUpCapture",
        "onPointerDownCapture",
        "onPointerUpCapture",
        "onTouchEndCapture",
        "onTouchStartCapture",
        "shape",
        "spacing",
        "testId",
        "tooltip"
    ]);
    // @ts-expect-error
    const { className: _className, css: _css1, as: _as, style: _style } = unsafeRest, saferRest = (0, _objectWithoutProperties._)(unsafeRest, [
        "className",
        "css",
        "as",
        "style"
    ]);
    const localRef = (0, _react.useRef)(null);
    (0, _useAutoFocusDefault.default)(localRef, autoFocus);
    var _tooltip_content;
    if (!isTooltipDisabled) return /*#__PURE__*/ _react.createElement((0, _tooltipDefault.default), {
        content: (_tooltip_content = tooltip === null || tooltip === void 0 ? void 0 : tooltip.content) !== null && _tooltip_content !== void 0 ? _tooltip_content : label,
        testId: tooltip === null || tooltip === void 0 ? void 0 : tooltip.testId,
        position: tooltip === null || tooltip === void 0 ? void 0 : tooltip.position,
        delay: tooltip === null || tooltip === void 0 ? void 0 : tooltip.delay,
        onShow: tooltip === null || tooltip === void 0 ? void 0 : tooltip.onShow,
        onHide: tooltip === null || tooltip === void 0 ? void 0 : tooltip.onHide,
        mousePosition: tooltip === null || tooltip === void 0 ? void 0 : tooltip.mousePosition,
        analyticsContext: tooltip === null || tooltip === void 0 ? void 0 : tooltip.analyticsContext,
        strategy: tooltip === null || tooltip === void 0 ? void 0 : tooltip.strategy,
        tag: tooltip === null || tooltip === void 0 ? void 0 : tooltip.tag,
        truncate: tooltip === null || tooltip === void 0 ? void 0 : tooltip.truncate,
        component: tooltip === null || tooltip === void 0 ? void 0 : tooltip.component,
        hideTooltipOnClick: tooltip === null || tooltip === void 0 ? void 0 : tooltip.hideTooltipOnClick,
        hideTooltipOnMouseDown: tooltip === null || tooltip === void 0 ? void 0 : tooltip.hideTooltipOnMouseDown,
        ignoreTooltipPointerEvents: tooltip === null || tooltip === void 0 ? void 0 : tooltip.ignoreTooltipPointerEvents
    }, (triggerProps)=>/*#__PURE__*/ _react.createElement((0, _compiled.Anchor), (0, _objectSpreadProps._)((0, _objectSpread._)({}, saferRest), {
            "aria-labelledby": ariaLabelledBy,
            testId: testId,
            componentName: "LinkIconButton",
            analyticsContext: analyticsContext,
            interactionName: interactionName,
            // Shared between tooltip and native props
            onMouseOver: (e)=>{
                var _triggerProps_onMouseOver, _saferRest_onMouseOver;
                (_triggerProps_onMouseOver = triggerProps.onMouseOver) === null || _triggerProps_onMouseOver === void 0 ? void 0 : _triggerProps_onMouseOver.call(triggerProps, e);
                (_saferRest_onMouseOver = saferRest.onMouseOver) === null || _saferRest_onMouseOver === void 0 ? void 0 : _saferRest_onMouseOver.call(saferRest, e);
            },
            onMouseOut: (e)=>{
                var _triggerProps_onMouseOut, _saferRest_onMouseOut;
                (_triggerProps_onMouseOut = triggerProps.onMouseOut) === null || _triggerProps_onMouseOut === void 0 ? void 0 : _triggerProps_onMouseOut.call(triggerProps, e);
                (_saferRest_onMouseOut = saferRest.onMouseOut) === null || _saferRest_onMouseOut === void 0 ? void 0 : _saferRest_onMouseOut.call(saferRest, e);
            },
            onMouseMove: (e)=>{
                var _triggerProps_onMouseMove, _saferRest_onMouseMove;
                (_triggerProps_onMouseMove = triggerProps.onMouseMove) === null || _triggerProps_onMouseMove === void 0 ? void 0 : _triggerProps_onMouseMove.call(triggerProps, e);
                (_saferRest_onMouseMove = saferRest.onMouseMove) === null || _saferRest_onMouseMove === void 0 ? void 0 : _saferRest_onMouseMove.call(saferRest, e);
            },
            onMouseDown: (e)=>{
                var _triggerProps_onMouseDown, _saferRest_onMouseDown;
                (_triggerProps_onMouseDown = triggerProps.onMouseDown) === null || _triggerProps_onMouseDown === void 0 ? void 0 : _triggerProps_onMouseDown.call(triggerProps, e);
                (_saferRest_onMouseDown = saferRest.onMouseDown) === null || _saferRest_onMouseDown === void 0 ? void 0 : _saferRest_onMouseDown.call(saferRest, e);
            },
            onFocus: (e)=>{
                var _triggerProps_onFocus, _saferRest_onFocus;
                (_triggerProps_onFocus = triggerProps.onFocus) === null || _triggerProps_onFocus === void 0 ? void 0 : _triggerProps_onFocus.call(triggerProps, e);
                (_saferRest_onFocus = saferRest.onFocus) === null || _saferRest_onFocus === void 0 ? void 0 : _saferRest_onFocus.call(saferRest, e);
            },
            onBlur: (e)=>{
                var _triggerProps_onBlur, _saferRest_onBlur;
                (_triggerProps_onBlur = triggerProps.onBlur) === null || _triggerProps_onBlur === void 0 ? void 0 : _triggerProps_onBlur.call(triggerProps, e);
                (_saferRest_onBlur = saferRest.onBlur) === null || _saferRest_onBlur === void 0 ? void 0 : _saferRest_onBlur.call(saferRest, e);
            },
            // Shared between tooltip and base props
            onClick: (event, analyticsEvent)=>{
                var _triggerProps_onClick;
                onClick === null || onClick === void 0 ? void 0 : onClick(event, analyticsEvent);
                triggerProps === null || triggerProps === void 0 ? void 0 : (_triggerProps_onClick = triggerProps.onClick) === null || _triggerProps_onClick === void 0 ? void 0 : _triggerProps_onClick.call(triggerProps, event);
            },
            ref: (0, _mergeRefsDefault.default)([
                localRef,
                ref,
                triggerProps.ref
            ].filter(Boolean)),
            // Base props only
            xcss: (0, _css.cx)(styles.base, (0, _platformFeatureFlags.fg)('platform-dst-shape-theme-default') && styles.baseT26Shape, !isDisabled && (0, _platformFeatureFlags.fg)('platform-dst-motion-uplift-button') && styles.interactiveMotion, appearance === 'default' && defaultStyles.root, appearance === 'primary' && primaryStyles.root, appearance === 'rovo' && rovoStyles.root, appearance === 'discovery' && discoveryStyles.root, appearance === 'subtle' && subtleStyles.root, styles.linkDecorationUnset, isSelected && selectedStyles.root, isSelected && appearance === 'discovery' && selectedStyles.discovery, isDisabled && styles.disabled, styles.iconButton, spacing === 'compact' && styles.spacingCompact, shape === 'circle' && styles.circle),
            onMouseDownCapture: onMouseDownCapture,
            onMouseUpCapture: onMouseUpCapture,
            onKeyDownCapture: onKeyDownCapture,
            onKeyUpCapture: onKeyUpCapture,
            onTouchStartCapture: onTouchStartCapture,
            onTouchEndCapture: onTouchEndCapture,
            onPointerDownCapture: onPointerDownCapture,
            onPointerUpCapture: onPointerUpCapture,
            onClickCapture: onClickCapture,
            /**
       * Disable link in an accessible way using `href`, `role`, and `aria-disabled`.
       * @see https://a11y-guidelines.orange.com/en/articles/disable-elements/#disable-a-link
       */ // @ts-expect-error (`href` is required, we could make it optional but don't want to encourage this pattern elsewhere)
            href: isDisabled ? undefined : href,
            role: isDisabled ? 'link' : undefined,
            "aria-disabled": isDisabled === true ? true : undefined
        }), /*#__PURE__*/ _react.createElement((0, _contentDefault.default), {
            type: "icon",
            isLoading: false
        }, /*#__PURE__*/ _react.createElement((0, _iconRendererDefault.default), {
            icon: icon
        }), /*#__PURE__*/ _react.createElement((0, _visuallyHiddenDefault.default), null, label))));
    return /*#__PURE__*/ _react.createElement((0, _compiled.Anchor), (0, _objectSpreadProps._)((0, _objectSpread._)({}, saferRest), {
        // aria-label={preventedAriaLabel}
        "aria-labelledby": ariaLabelledBy,
        ref: (0, _mergeRefsDefault.default)([
            localRef,
            ref
        ]),
        xcss: (0, _css.cx)(styles.base, (0, _platformFeatureFlags.fg)('platform-dst-shape-theme-default') && styles.baseT26Shape, !isDisabled && (0, _platformFeatureFlags.fg)('platform-dst-motion-uplift-button') && styles.interactiveMotion, appearance === 'default' && defaultStyles.root, appearance === 'primary' && primaryStyles.root, appearance === 'rovo' && rovoStyles.root, appearance === 'discovery' && discoveryStyles.root, appearance === 'subtle' && subtleStyles.root, styles.linkDecorationUnset, isSelected && selectedStyles.root, isSelected && appearance === 'discovery' && selectedStyles.discovery, isDisabled && styles.disabled, styles.iconButton, spacing === 'compact' && styles.spacingCompact, shape === 'circle' && styles.circle),
        onClick: onClick,
        onMouseDownCapture: onMouseDownCapture,
        onMouseUpCapture: onMouseUpCapture,
        onKeyDownCapture: onKeyDownCapture,
        onKeyUpCapture: onKeyUpCapture,
        onTouchStartCapture: onTouchStartCapture,
        onTouchEndCapture: onTouchEndCapture,
        onPointerDownCapture: onPointerDownCapture,
        onPointerUpCapture: onPointerUpCapture,
        onClickCapture: onClickCapture,
        testId: testId,
        /**
   * Disable link in an accessible way using `href`, `role`, and `aria-disabled`.
   * @see https://a11y-guidelines.orange.com/en/articles/disable-elements/#disable-a-link
   */ // @ts-expect-error (`href` is required, we could make it optional but don't want to encourage this pattern elsewhere)
        href: isDisabled ? undefined : href,
        role: isDisabled ? 'link' : undefined,
        "aria-disabled": isDisabled === true ? true : undefined,
        componentName: "LinkIconButton",
        analyticsContext: analyticsContext,
        interactionName: interactionName
    }), /*#__PURE__*/ _react.createElement((0, _contentDefault.default), {
        type: "icon",
        isLoading: false
    }, /*#__PURE__*/ _react.createElement((0, _iconRendererDefault.default), {
        icon: icon
    }), /*#__PURE__*/ _react.createElement((0, _visuallyHiddenDefault.default), null, label)));
};
// Workarounds to support generic types with forwardRef + memo
const WithRef = /*#__PURE__*/ (0, _react.forwardRef)(LinkIconButtonBase);
/**
 * __Link Icon Button__
 *
 * Renders a link in the style of an icon button.
 *
 * - [Examples](https://atlassian.design/components/button/link-icon-button/examples)
 * - [Code](https://atlassian.design/components/button/link-icon-button/code)
 * - [Usage](https://atlassian.design/components/button/link-icon-button/usage)
 */ const LinkIconButton = /*#__PURE__*/ (0, _react.memo)(WithRef);
exports.default = LinkIconButton;

},{"@swc/helpers/_/_object_spread":"9gdrV","@swc/helpers/_/_object_spread_props":"kANqQ","@swc/helpers/_/_object_without_properties":"6HqIM","react":"ltHCL","@atlaskit/css":"kMGms","@atlaskit/ds-lib/merge-refs":"doPwA","@atlaskit/ds-lib/use-auto-focus":"cDep4","@atlaskit/platform-feature-flags":"8rD2i","@atlaskit/primitives/compiled":"hDay7","@atlaskit/tooltip":"7RyYv","@atlaskit/visually-hidden":"gKDx1","../shared/content":"jty5c","../shared/icon-renderer":"dQF4B","@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"7v8tH":[function(require,module,exports,__globalThis) {
/* split-button.tsx generated by @compiled/babel-plugin v0.39.1 */ var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "SplitButton", ()=>SplitButton);
var _react = require("react");
var _runtime = require("@compiled/react/runtime");
var _divider = require("./divider");
var _splitButtonContainer = require("./split-button-container");
var _splitButtonContext = require("./split-button-context");
var _utils = require("./utils");
const buttonStyles = {
    primaryButton: "_traeidpf _anlpidpf _p9ykidpf _bepvidpf",
    secondaryButton: "_1j4hidpf _1553idpf _1qgbidpf _y1n3idpf"
};
const SplitButton = ({ children, appearance = 'default', spacing = 'default', isDisabled = false })=>{
    const { PrimaryAction, SecondaryAction } = (0, _utils.getActions)(children);
    return /*#__PURE__*/ _react.createElement((0, _splitButtonContainer.SplitButtonContainer), {
        appearance: appearance,
        isDisabled: isDisabled
    }, /*#__PURE__*/ _react.createElement((0, _splitButtonContext.SplitButtonContext).Provider, {
        value: {
            appearance,
            spacing,
            isDisabled
        }
    }, /*#__PURE__*/ _react.createElement("div", {
        className: (0, _runtime.ax)([
            buttonStyles.primaryButton
        ])
    }, PrimaryAction), /*#__PURE__*/ _react.createElement((0, _divider.Divider), {
        appearance: appearance,
        spacing: spacing,
        isDisabled: isDisabled
    }), /*#__PURE__*/ _react.createElement("div", {
        className: (0, _runtime.ax)([
            buttonStyles.secondaryButton
        ])
    }, SecondaryAction)));
};

},{"react":"ltHCL","@compiled/react/runtime":"d27Vo","./divider":"91rUN","./split-button-container":"8mW2s","./split-button-context":"D7RWu","./utils":"gaJsy","@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"91rUN":[function(require,module,exports,__globalThis) {
/* divider.tsx generated by @compiled/babel-plugin v0.39.1 */ var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "Divider", ()=>Divider);
var _react = require("react");
var _runtime = require("@compiled/react/runtime");
const dividerStyles = {
    baseDivider: "_1bsbe4h9 _kqswh2mm _1pbykb7n",
    dividerDisabled: "_bfhkbk0g _80om13gf",
    dividerOffset: "_195g1n1a"
};
const dividerAppearanceStyles = {
    default: "_bfhk1l7x",
    primary: "_bfhkveue _tzy41wzo",
    navigation: "_1mouu2gc _195g1h5n _4t3i7vkz _bfhkazsu _tzy419lr"
};
const dividerHeightStyles = {
    default: "_4t3iviql",
    compact: "_4t3i1k8s"
};
const defaultDividerHeightStyles = {
    default: "_4t3im1ee",
    compact: "_4t3i1hvu"
};
const Divider = ({ appearance, spacing, isDisabled = false })=>{
    const isDefaultDivider = appearance === 'default' && !isDisabled;
    return /*#__PURE__*/ _react.createElement("div", {
        className: (0, _runtime.ax)([
            dividerStyles.baseDivider,
            isDefaultDivider && defaultDividerHeightStyles[spacing],
            !isDefaultDivider && dividerHeightStyles[spacing],
            isDisabled && dividerStyles.dividerDisabled,
            !isDisabled && dividerAppearanceStyles[appearance],
            dividerStyles.dividerOffset
        ])
    });
};

},{"react":"ltHCL","@compiled/react/runtime":"d27Vo","@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"8mW2s":[function(require,module,exports,__globalThis) {
/* split-button-container.tsx generated by @compiled/babel-plugin v0.39.1 */ var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "SplitButtonContainer", ()=>SplitButtonContainer);
var _react = require("react");
var _runtime = require("@compiled/react/runtime");
var _platformFeatureFlags = require("@atlaskit/platform-feature-flags");
const buttonStyles = {
    splitButton: "_1e0c116y _kqswh2mm _4cvr1h6o _o5721q9c",
    defaultAppearanceContainer: "_2rkofajl _12ji1l7x _1cwg1n1a _1qu2nqa1 _12y3t94y",
    defaultAppearanceContainerT26Shape: "_2rko1qi0",
    defaultAppearanceDisabledContainer: "_12jibk0g"
};
const SplitButtonContainer = ({ appearance, children, isDisabled = false })=>{
    return /*#__PURE__*/ _react.createElement("div", {
        className: (0, _runtime.ax)([
            appearance === 'default' && buttonStyles.defaultAppearanceContainer,
            appearance === 'default' && (0, _platformFeatureFlags.fg)('platform-dst-shape-theme-default') && buttonStyles.defaultAppearanceContainerT26Shape,
            appearance === 'default' && isDisabled && buttonStyles.defaultAppearanceDisabledContainer,
            buttonStyles.splitButton
        ])
    }, children);
};

},{"react":"ltHCL","@compiled/react/runtime":"d27Vo","@atlaskit/platform-feature-flags":"8rD2i","@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"gaJsy":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "getActions", ()=>getActions);
var _react = require("react");
var process = require("8c5fc82a5153bfe9");
const getActions = (children)=>{
    const [PrimaryAction, SecondaryAction] = (0, _react.Children).toArray(children);
    typeof process;
    return {
        PrimaryAction,
        SecondaryAction
    };
};

},{"8c5fc82a5153bfe9":"gNLf3","react":"ltHCL","@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"1ItQx":[function(require,module,exports,__globalThis) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::fcfd9fc2877ad309c8a5d6e5d6ea9482>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = void 0;
var _react = _interopRequireDefault(require("9e0ff8fbb634564f"));
var _baseNew = _interopRequireDefault(require("e25cf409583dbb4d"));
function _interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "ArrowDown".
 * Category: multi-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Multi purpose - Know uses: sorting table headers or Bitbucket code difference.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const ArrowDownIcon = (props)=>/*#__PURE__*/ _react.default.createElement(_baseNew.default, Object.assign({
        name: "ArrowDownIcon",
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M8.75 1v11.44l3.72-3.72 1.06 1.06-5 5a.75.75 0 0 1-1.06 0l-5-5 1.06-1.06 3.72 3.72V1z" clip-rule="evenodd"/>`
    }, props));
ArrowDownIcon.displayName = 'ArrowDownIcon';
var _default = exports.default = ArrowDownIcon;

},{"9e0ff8fbb634564f":"ltHCL","e25cf409583dbb4d":"5XL7D"}],"kK2kA":[function(require,module,exports,__globalThis) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::be13ec6c7b346b13ffda97746cc85c67>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = void 0;
var _react = _interopRequireDefault(require("516085539982d3d7"));
var _baseNew = _interopRequireDefault(require("71fb1d44673425dd"));
function _interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "ArrowUp".
 * Category: multi-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Multi purpose - Known uses: back to top.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const ArrowUpIcon = (props)=>/*#__PURE__*/ _react.default.createElement(_baseNew.default, Object.assign({
        name: "ArrowUpIcon",
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M8.75 15V3.56l3.72 3.72 1.06-1.06-5-5a.75.75 0 0 0-1.06 0l-5 5 1.06 1.06 3.72-3.72V15z" clip-rule="evenodd"/>`
    }, props));
ArrowUpIcon.displayName = 'ArrowUpIcon';
var _default = exports.default = ArrowUpIcon;

},{"516085539982d3d7":"ltHCL","71fb1d44673425dd":"5XL7D"}],"jL7K3":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>(0, _paginationDefault.default));
var _pagination = require("./pagination");
var _paginationDefault = parcelHelpers.interopDefault(_pagination);

},{"./pagination":"9WKdY","@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"9WKdY":[function(require,module,exports,__globalThis) {
/* pagination.tsx generated by @compiled/babel-plugin v0.39.1 */ var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _objectSpread = require("@swc/helpers/_/_object_spread");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _analyticsNext = require("@atlaskit/analytics-next");
var _noop = require("@atlaskit/ds-lib/noop");
var _noopDefault = parcelHelpers.interopDefault(_noop);
var _useControlled = require("@atlaskit/ds-lib/use-controlled");
var _useControlledDefault = parcelHelpers.interopDefault(_useControlled);
var _chevronLeft = require("@atlaskit/icon/core/chevron-left");
var _chevronLeftDefault = parcelHelpers.interopDefault(_chevronLeft);
var _chevronRight = require("@atlaskit/icon/core/chevron-right");
var _chevronRightDefault = parcelHelpers.interopDefault(_chevronRight);
var _compiled = require("@atlaskit/primitives/compiled");
var _navigator = require("./internal/components/navigator");
var _navigatorDefault = parcelHelpers.interopDefault(_navigator);
var _page = require("./internal/components/page");
var _pageDefault = parcelHelpers.interopDefault(_page);
var _renderEllipsis = require("./internal/components/render-ellipsis");
var _renderEllipsisDefault = parcelHelpers.interopDefault(_renderEllipsis);
var _constants = require("./internal/constants");
var _collapseRange = require("./internal/utils/collapse-range");
var _collapseRangeDefault = parcelHelpers.interopDefault(_collapseRange);
const styles = {
    paginationMenu: "_1q51ze3t _y4tize3t _85i5ze3t _bozgze3t _1pfhze3t _12l2ze3t _6rthze3t _ahbqze3t",
    paginationMenuItem: "_1pfhze3t _ect4ttxp",
    navigatorIconWrapper: "_18zr12x7"
};
const analyticsAttributes = {
    componentName: 'pagination',
    packageName: "@af/atlassian-studio",
    packageVersion: "0.16.1"
};
function NavigatorIcon({ chevronDirection }) {
    const Chevron = chevronDirection === 'left' ? (0, _chevronLeftDefault.default) : (0, _chevronRightDefault.default);
    return /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _compiled.Box), {
        as: "span",
        xcss: styles.navigatorIconWrapper
    }, /*#__PURE__*/ (0, _reactDefault.default).createElement(Chevron, {
        label: "",
        color: "currentColor",
        size: "small"
    }));
}
function InnerPagination({ components = (0, _constants.emptyObject), defaultSelectedIndex = 0, selectedIndex, label = 'pagination', pageLabel = 'page', previousLabel = 'previous', nextLabel = 'next', style = (0, _constants.emptyObject), max = 7, onChange = (0, _noopDefault.default), pages, getPageLabel, renderEllipsis = (0, _renderEllipsisDefault.default), analyticsContext, testId, isDisabled }, ref) {
    const [selectedIndexValue, setSelectedIndexValue] = (0, _useControlledDefault.default)(selectedIndex, ()=>defaultSelectedIndex || 0);
    const onChangeWithAnalytics = (0, _analyticsNext.usePlatformLeafEventHandler)((0, _objectSpread._)({
        fn: (value, analyticsEvent)=>{
            const { event, selectedPageIndex } = value;
            if (selectedIndex === undefined) setSelectedIndexValue(selectedPageIndex);
            if (onChange) onChange(event, pages[selectedPageIndex], analyticsEvent);
        },
        action: 'changed',
        actionSubject: 'pageNumber',
        analyticsData: analyticsContext
    }, analyticsAttributes));
    const transform = (page, currPageIndex, testId)=>{
        const selectedPage = pages[selectedIndexValue];
        const pageIndexLabel = `${pageLabel} ${getPageLabel ? getPageLabel(page, currPageIndex) : page}`;
        const isCurrentPage = page === selectedPage;
        return /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _compiled.Inline), {
            as: "li",
            xcss: styles.paginationMenuItem,
            key: `page-${getPageLabel ? getPageLabel(page, currPageIndex) : currPageIndex}`
        }, /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _pageDefault.default), {
            component: components.Page,
            onClick: (event)=>onChangeWithAnalytics({
                    event,
                    selectedPageIndex: currPageIndex
                }),
            "aria-current": isCurrentPage ? 'page' : undefined,
            "aria-label": pageIndexLabel,
            isSelected: isCurrentPage,
            isDisabled: isDisabled,
            page: page,
            testId: testId && `${testId}--${isCurrentPage ? 'current-' : ''}page-${currPageIndex}`
        }, getPageLabel ? getPageLabel(page, currPageIndex) : page));
    };
    return(// eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
    /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _compiled.Box), {
        testId: testId,
        style: style,
        ref: ref,
        "aria-label": label,
        as: "nav"
    }, /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _compiled.Inline), {
        space: "space.0",
        alignBlock: "center"
    }, /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _navigatorDefault.default), {
        key: "left-navigator",
        component: components.Previous,
        onClick: (event)=>onChangeWithAnalytics({
                event,
                selectedPageIndex: selectedIndexValue - 1
            }),
        isDisabled: isDisabled || selectedIndexValue === 0,
        iconBefore: /*#__PURE__*/ (0, _reactDefault.default).createElement(NavigatorIcon, {
            chevronDirection: "left"
        }),
        "aria-label": previousLabel,
        testId: testId && `${testId}--left-navigator`
    }), /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _compiled.Inline), {
        space: "space.0",
        alignBlock: "baseline",
        as: "ul",
        xcss: styles.paginationMenu
    }, (0, _collapseRangeDefault.default)(pages, selectedIndexValue, {
        max: max,
        ellipsis: renderEllipsis,
        transform
    }, testId)), /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _navigatorDefault.default), {
        key: "right-navigator",
        component: components.Next,
        onClick: (event)=>onChangeWithAnalytics({
                event,
                selectedPageIndex: selectedIndexValue + 1
            }),
        isDisabled: isDisabled || selectedIndexValue === pages.length - 1,
        iconBefore: /*#__PURE__*/ (0, _reactDefault.default).createElement(NavigatorIcon, {
            chevronDirection: "right"
        }),
        "aria-label": nextLabel,
        testId: testId && `${testId}--right-navigator`
    }))));
}
/**
 * __Pagination__
 *
 * Pagination allows you to divide large amounts of content into smaller chunks across multiple pages.
 *
 * - [Examples](https://atlassian.design/components/pagination/examples)
 * - [Code](https://atlassian.design/components/pagination/code)
 * - [Usage](https://atlassian.design/components/pagination/usage)
 */ const Pagination = /*#__PURE__*/ (0, _react.memo)(/*#__PURE__*/ (0, _react.forwardRef)(InnerPagination));
exports.default = Pagination;

},{"@swc/helpers/_/_object_spread":"9gdrV","react":"ltHCL","@atlaskit/analytics-next":"6PLie","@atlaskit/ds-lib/noop":"faKzG","@atlaskit/ds-lib/use-controlled":"d9tMx","@atlaskit/icon/core/chevron-left":"3gMxN","@atlaskit/icon/core/chevron-right":"8s3ae","@atlaskit/primitives/compiled":"hDay7","./internal/components/navigator":"66sNN","./internal/components/page":"7pzcv","./internal/components/render-ellipsis":"9ERXZ","./internal/constants":"3ihWx","./internal/utils/collapse-range":"kWQJ1","@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"d9tMx":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>useControlled);
var _react = require("react");
function useControlled(propValue, getDefaultPropValue = ()=>propValue) {
    const isControlled = propValue !== undefined;
    const [valueState, setValue] = (0, _react.useState)(getDefaultPropValue);
    const isControlledRef = (0, _react.useRef)(isControlled);
    (0, _react.useEffect)(()=>{
        isControlledRef.current = isControlled;
    }, [
        isControlled
    ]);
    const value = isControlled ? propValue : valueState;
    const setValueIfUncontrolled = (0, _react.useCallback)((newValue)=>{
        if (!isControlledRef.current) setValue(newValue);
    }, []);
    return [
        value,
        setValueIfUncontrolled
    ];
}

},{"react":"ltHCL","@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"3gMxN":[function(require,module,exports,__globalThis) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::8ee9ad5072a30451ff7ca2ddc0961d03>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = void 0;
var _react = _interopRequireDefault(require("b3971e92e2235838"));
var _baseNew = _interopRequireDefault(require("461ef2c2176f140a"));
function _interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "ChevronLeft".
 * Category: multi-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Do not use 16px chevrons within buttons, icon buttons, or dropdowns to maintain visual cohesion with ADS which uses 12px chevrons.
Known uses: Navigate back, show previous page of pagination results
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const ChevronLeftIcon = (props)=>/*#__PURE__*/ _react.default.createElement(_baseNew.default, Object.assign({
        name: "ChevronLeftIcon",
        dangerouslySetGlyph: `<path fill="currentcolor" d="m9.97 1.47-6 6a.75.75 0 0 0-.052 1.004l.052.056 6 6 1.06-1.06L5.56 8l5.47-5.47z"/>`
    }, props));
ChevronLeftIcon.displayName = 'ChevronLeftIcon';
var _default = exports.default = ChevronLeftIcon;

},{"b3971e92e2235838":"ltHCL","461ef2c2176f140a":"5XL7D"}],"8s3ae":[function(require,module,exports,__globalThis) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::fbc9eb298cfdac722b50cf5246108693>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = void 0;
var _react = _interopRequireDefault(require("794fe1439a23741f"));
var _baseNew = _interopRequireDefault(require("903f8cb09c0c9c33"));
function _interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "ChevronRight".
 * Category: multi-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Do not use 16px chevrons within buttons, icon buttons, or dropdowns to maintain visual cohesion with ADS which uses 12px chevrons.
Known uses: Next page of pagination results, collapsed tree item, expand tree item
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const ChevronRightIcon = (props)=>/*#__PURE__*/ _react.default.createElement(_baseNew.default, Object.assign({
        name: "ChevronRightIcon",
        dangerouslySetGlyph: `<path fill="currentcolor" d="m6.03 1.47 6 6a.75.75 0 0 1 .052 1.004l-.052.056-6 6-1.06-1.06L10.44 8 4.97 2.53z"/>`
    }, props));
ChevronRightIcon.displayName = 'ChevronRightIcon';
var _default = exports.default = ChevronRightIcon;

},{"794fe1439a23741f":"ltHCL","903f8cb09c0c9c33":"5XL7D"}],"66sNN":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>Navigator);
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _standardButton = require("@atlaskit/button/standard-button");
var _standardButtonDefault = parcelHelpers.interopDefault(_standardButton);
function Navigator(props) {
    return /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _standardButtonDefault.default), {
        "aria-label": props['aria-label'],
        isDisabled: props.isDisabled,
        iconBefore: props.iconBefore,
        testId: props.testId,
        onClick: props.onClick,
        component: props.component,
        appearance: "subtle"
    });
}

},{"react":"ltHCL","@atlaskit/button/standard-button":"l4NwS","@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"l4NwS":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>(0, _buttonDefault.default));
var _button = require("../old-button/button");
var _buttonDefault = parcelHelpers.interopDefault(_button);

},{"../old-button/button":"6FFoe","@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"6FFoe":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _objectSpread = require("@swc/helpers/_/_object_spread");
var _objectSpreadProps = require("@swc/helpers/_/_object_spread_props");
var _objectWithoutProperties = require("@swc/helpers/_/_object_without_properties");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _noop = require("@atlaskit/ds-lib/noop");
var _noopDefault = parcelHelpers.interopDefault(_noop);
var _buttonBase = require("./shared/button-base");
var _buttonBaseDefault = parcelHelpers.interopDefault(_buttonBase);
var _getCss = require("./shared/get-css");
var _getIsOnlySingleIcon = require("./shared/get-is-only-single-icon");
var _getIsOnlySingleIconDefault = parcelHelpers.interopDefault(_getIsOnlySingleIcon);
const isFirefox = typeof navigator !== 'undefined' && navigator.userAgent.toLowerCase().indexOf('firefox') > -1;
/**
 * __Button__
 *
 * @deprecated Legacy buttons are deprecated and will be removed from `atlaskit/button` in an upcoming major release. Please use the new Button components from `@atlaskit/button/new`
 *
 * Please refer to the [migration guide](https://atlassian.design/components/button/button-legacy/migration-guide) for further details.
 *
 * A button triggers an event or action. They let users know what will happen next.
 *
 * - [Examples](https://atlassian.design/components/button/button-legacy/examples)
 * - [Code](https://atlassian.design/components/button/button-legacy/code)
 * - [Usage](https://atlassian.design/components/button/button-legacy/usage)
 */ const Button = /*#__PURE__*/ (0, _reactDefault.default).memo(/*#__PURE__*/ (0, _reactDefault.default).forwardRef(function Button(_param, ref) {
    var { appearance = 'default', children, iconBefore, iconAfter, isSelected = false, onMouseDown: providedOnMouseDown = (0, _noopDefault.default), onMouseUp: providedOnMouseUp = (0, _noopDefault.default), shouldFitContainer = false, spacing = 'default' } = _param, rest = (0, _objectWithoutProperties._)(_param, [
        "appearance",
        "children",
        "iconBefore",
        "iconAfter",
        "isSelected",
        "onMouseDown",
        "onMouseUp",
        "shouldFitContainer",
        "spacing"
    ]);
    const isOnlySingleIcon = (0, _getIsOnlySingleIconDefault.default)({
        children,
        iconBefore,
        iconAfter
    });
    const [isActive, setIsActive] = (0, _react.useState)(false);
    // Wrap onMouseDown / onMouseUp to manually trigger active state
    // in Firefox
    const onMouseDown = (0, _react.useCallback)((event)=>{
        providedOnMouseDown(event);
        if (isFirefox) setIsActive(true);
    }, [
        providedOnMouseDown,
        setIsActive
    ]);
    const onMouseUp = (0, _react.useCallback)((event)=>{
        providedOnMouseUp(event);
        if (isFirefox) setIsActive(false);
    }, [
        providedOnMouseUp,
        setIsActive
    ]);
    const buttonCss = (0, _react.useMemo)(()=>(0, _getCss.getCss)({
            appearance,
            spacing,
            isSelected,
            shouldFitContainer,
            isOnlySingleIcon
        }), [
        appearance,
        spacing,
        isSelected,
        shouldFitContainer,
        isOnlySingleIcon
    ]);
    return /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _buttonBaseDefault.default), (0, _objectSpreadProps._)((0, _objectSpread._)({}, rest), {
        ref: ref,
        appearance: appearance,
        buttonCss: buttonCss,
        children: children,
        // Due to how click events are set, we need to set active styles
        // manually in Firefox and wrap onMouseDown/onMouseUp
        "data-firefox-is-active": isActive ? true : undefined,
        iconAfter: iconAfter,
        iconBefore: iconBefore,
        isSelected: isSelected,
        onMouseDown: onMouseDown,
        onMouseUp: onMouseUp,
        spacing: spacing
    }));
}));
// Tools including enzyme rely on components having a display name
Button.displayName = 'Button';
exports.default = Button;

},{"@swc/helpers/_/_object_spread":"9gdrV","@swc/helpers/_/_object_spread_props":"kANqQ","@swc/helpers/_/_object_without_properties":"6HqIM","react":"ltHCL","@atlaskit/ds-lib/noop":"faKzG","./shared/button-base":"dsrZX","./shared/get-css":"dYJ2c","./shared/get-is-only-single-icon":"8YxN4","@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"dsrZX":[function(require,module,exports,__globalThis) {
/* eslint-disable @atlaskit/design-system/consistent-css-prop-usage, @atlaskit/design-system/no-deprecated-imports, @atlaskit/platform/no-direct-document-usage -- Preserve old-button behavior while focus-ring usage is reviewed separately. */ /**
 * @jsxRuntime classic
 * @jsx jsx
 */ var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _objectSpread = require("@swc/helpers/_/_object_spread");
var _objectSpreadProps = require("@swc/helpers/_/_object_spread_props");
var _objectWithoutProperties = require("@swc/helpers/_/_object_without_properties");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
// eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled -- Ignored via go/DSP-18766
var _react1 = require("@emotion/react");
var _analyticsNext = require("@atlaskit/analytics-next");
var _noop = require("@atlaskit/ds-lib/noop");
var _noopDefault = parcelHelpers.interopDefault(_noop);
var _useAutoFocus = require("@atlaskit/ds-lib/use-auto-focus");
var _useAutoFocusDefault = parcelHelpers.interopDefault(_useAutoFocus);
var _focusRing = require("@atlaskit/focus-ring");
var _focusRingDefault = parcelHelpers.interopDefault(_focusRing);
// eslint-disable-next-line no-duplicate-imports
var _interactionContext = require("@atlaskit/interaction-context");
var _interactionContextDefault = parcelHelpers.interopDefault(_interactionContext);
var _blockEvents = require("./block-events");
var _blockEventsDefault = parcelHelpers.interopDefault(_blockEvents);
var _getContentStyle = require("./get-content-style");
var _getFadingCss = require("./get-fading-css");
var _getIconStyle = require("./get-icon-style");
var _getIfVisuallyHiddenChildren = require("./get-if-visually-hidden-children");
var _overlayCss = require("./overlay-css");
// Disabled buttons will still publish events for nested elements in webkit.
// We are disabling pointer events on child elements so that
// the button will always be the target of events
// Note: firefox does not have this behaviour for child elements
const noPointerEventsOnChildrenCss = {
    '> *': {
        pointerEvents: 'none'
    }
};
/**
 * These CSS variables consumed by the new icons, to allow them to have appropriate
 * padding inside Button while also maintaining spacing for the existing icons.
 *
 * These styles can be removed once the new icons are fully rolled out, feature flag
 * platform-visual-refresh-icons is cleaned up,
 * and we bump Button to set padding based on the new icons.
 */ const iconBeforeSpacingFixStyle = (0, _react1.css)({
    '--ds--button--new-icon-padding-end': "var(--ds-space-025, 2px)",
    '--ds--button--new-icon-padding-start': "var(--ds-space-050, 4px)",
    marginInlineStart: "var(--ds-space-negative-025, -2px)"
});
const iconAfterSpacingFixStyle = (0, _react1.css)({
    '--ds--button--new-icon-padding-end': "var(--ds-space-050, 4px)",
    '--ds--button--new-icon-padding-start': "var(--ds-space-025, 2px)",
    marginInlineEnd: "var(--ds-space-negative-025, -2px)"
});
const getSpacingFix = (children, spacingStyles)=>{
    if (!children || (0, _getIfVisuallyHiddenChildren.getIfVisuallyHiddenChildren)(children)) return null;
    return spacingStyles;
};
const getChildren = (children, childrenStyles)=>{
    if ((0, _getIfVisuallyHiddenChildren.getIfVisuallyHiddenChildren)(children)) return children;
    return children ? /*#__PURE__*/ (0, _react1.jsx)("span", {
        css: childrenStyles
    }, children) : null;
};
const ButtonBase = /*#__PURE__*/ (0, _reactDefault.default).forwardRef(function ButtonBase(props, ref) {
    const { // I don't think analytics should be in button, but for now it is
    analyticsContext, appearance = 'default', autoFocus = false, buttonCss, children, className, href, // use the provided component prop,
    // else default to anchor if there is a href, and button if there is no href
    component: Component = href ? 'a' : 'button', iconAfter, iconBefore, interactionName, isDisabled = false, isSelected = false, onBlur, onClick: providedOnClick = (0, _noopDefault.default), onFocus, onMouseDown: providedOnMouseDown = (0, _noopDefault.default), overlay, // Pulling out so it doesn't spread on rendered component
    shouldFitContainer, spacing = 'default', tabIndex = 0, type = !href ? 'button' : undefined, testId } = props, rest = (0, _objectWithoutProperties._)(props, [
        "analyticsContext",
        "appearance",
        "autoFocus",
        "buttonCss",
        "children",
        "className",
        "href",
        "component",
        "iconAfter",
        "iconBefore",
        "interactionName",
        "isDisabled",
        "isSelected",
        "onBlur",
        "onClick",
        "onFocus",
        "onMouseDown",
        "overlay",
        "shouldFitContainer",
        "spacing",
        "tabIndex",
        "type",
        "testId"
    ]);
    const ourRef = (0, _react.useRef)();
    const setRef = (0, _react.useCallback)((node)=>{
        ourRef.current = node;
        if (ref == null) return;
        if (typeof ref === 'function') {
            ref(node);
            return;
        }
        // We can write to ref's `current` property, but Typescript does not like it.
        // @ts-ignore
        ref.current = node;
    }, [
        ourRef,
        ref
    ]);
    // Cross browser auto focusing is pretty broken, so we are doing it ourselves
    (0, _useAutoFocusDefault.default)(ourRef, autoFocus);
    const interactionContext = (0, _react.useContext)((0, _interactionContextDefault.default));
    const handleClick = (0, _react.useCallback)((e, analyticsEvent)=>{
        interactionContext && interactionContext.tracePress(interactionName, e.timeStamp);
        providedOnClick(e, analyticsEvent);
    }, [
        providedOnClick,
        interactionContext,
        interactionName
    ]);
    const onClick = (0, _analyticsNext.usePlatformLeafEventHandler)({
        fn: handleClick,
        action: 'clicked',
        componentName: 'button',
        packageName: "@af/atlassian-studio",
        packageVersion: "0.16.1",
        analyticsData: analyticsContext
    });
    // Button currently calls preventDefault, which is not standard button behaviour
    const onMouseDown = (0, _react.useCallback)((event)=>{
        event.preventDefault();
        providedOnMouseDown(event);
    }, [
        providedOnMouseDown
    ]);
    // Lose focus when becoming disabled (standard button behaviour)
    (0, _react.useEffect)(()=>{
        const el = ourRef.current;
        if (isDisabled && el && el === document.activeElement) el.blur();
    }, [
        isDisabled
    ]);
    // we are 'disabling' input with a button when there is an overlay
    const hasOverlay = Boolean(overlay);
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    const fadeStyles = (0, _react1.css)((0, _getFadingCss.getFadingCss)({
        hasOverlay
    }));
    const isInteractive = !isDisabled && !hasOverlay;
    /**
   * HACK: Spinner needs to have different colours in the "new" tokens design compared to the old design.
   * For now, while we support both, these styles reach into Spinner when a theme is set, applies the right color.
   * Ticket to remove: https://product-fabric.atlassian.net/browse/DSP-2067.
   */ var spinnerHackCss = {};
    if (isSelected || isDisabled || appearance === 'warning') spinnerHackCss = {
        '[data-theme] & circle': {
            stroke: `${isSelected || isDisabled ? "var(--ds-icon-subtle, #505258)" : "var(--ds-icon-warning-inverse, #292A2E)"} !important`
        }
    };
    return /*#__PURE__*/ (0, _react1.jsx)((0, _focusRingDefault.default), null, /*#__PURE__*/ (0, _react1.jsx)(Component, (0, _objectSpread._)((0, _objectSpreadProps._)((0, _objectSpread._)({}, rest), {
        ref: setRef,
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
        className: className,
        css: [
            buttonCss,
            isInteractive ? null : noPointerEventsOnChildrenCss
        ],
        // using undefined so that the property doesn't exist when false
        "data-has-overlay": hasOverlay ? true : undefined,
        "data-testid": testId,
        disabled: isDisabled,
        href: isInteractive ? href : undefined,
        onBlur: onBlur,
        onClick: onClick,
        onFocus: onFocus,
        onMouseDown: onMouseDown,
        // Adding a tab index so element is always focusable, even when not a <button> or <a>
        // Disabling focus via keyboard navigation when disabled
        // as this is standard button behaviour
        tabIndex: isDisabled ? -1 : tabIndex,
        type: type
    }), (0, _blockEventsDefault.default)({
        isInteractive
    })), iconBefore ? /*#__PURE__*/ (0, _react1.jsx)("span", {
        css: [
            fadeStyles,
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
            (0, _getIconStyle.getIconStyle)({
                spacing
            }),
            getSpacingFix(children, iconBeforeSpacingFixStyle)
        ]
    }, iconBefore) : null, getChildren(children, [
        fadeStyles,
        (0, _getContentStyle.getContentStyle)({
            spacing
        })
    ]), iconAfter ? /*#__PURE__*/ (0, _react1.jsx)("span", {
        css: [
            fadeStyles,
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
            (0, _getIconStyle.getIconStyle)({
                spacing
            }),
            getSpacingFix(children, iconAfterSpacingFixStyle)
        ]
    }, iconAfter) : null, overlay ? /*#__PURE__*/ (0, _react1.jsx)("span", {
        css: [
            (0, _overlayCss.overlayCss),
            spinnerHackCss
        ]
    }, overlay) : null));
});
// eslint-disable-next-line @repo/internal/react/require-jsdoc
exports.default = ButtonBase;

},{"@swc/helpers/_/_object_spread":"9gdrV","@swc/helpers/_/_object_spread_props":"kANqQ","@swc/helpers/_/_object_without_properties":"6HqIM","react":"ltHCL","@emotion/react":"cCAhJ","@atlaskit/analytics-next":"6PLie","@atlaskit/ds-lib/noop":"faKzG","@atlaskit/ds-lib/use-auto-focus":"cDep4","@atlaskit/focus-ring":"5PDo1","@atlaskit/interaction-context":"18HT9","./block-events":"8BpC0","./get-content-style":"37Y1v","./get-fading-css":"3WJDs","./get-icon-style":"9sMg2","./get-if-visually-hidden-children":"iNcJF","./overlay-css":"lRCFI","@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"5PDo1":[function(require,module,exports,__globalThis) {
/* eslint-disable @repo/internal/deprecations/deprecation-ticket-required -- LENS1-245 tracks @atlaskit/focus-ring deprecation. */ /**
 * @deprecated FocusRing is deprecated. Use Focusable from @atlaskit/primitives/compiled/focusable instead.
 */ var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>(0, _focusRingDefault.default));
/**
 * @deprecated useFocusRing is deprecated with FocusRing. Use Focusable from @atlaskit/primitives/compiled/focusable instead.
 */ parcelHelpers.export(exports, "useFocusRing", ()=>(0, _useFocusRingDefault.default));
var _focusRing = require("./focus-ring");
var _focusRingDefault = parcelHelpers.interopDefault(_focusRing);
var _useFocusRing = require("./use-focus-ring");
var _useFocusRingDefault = parcelHelpers.interopDefault(_useFocusRing);

},{"./focus-ring":"ity54","./use-focus-ring":false,"@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"ity54":[function(require,module,exports,__globalThis) {
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ /* eslint-disable @repo/internal/deprecations/deprecation-ticket-required -- LENS1-245 tracks @atlaskit/focus-ring deprecation. */ var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _react = require("react");
// eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled -- Ignored via go/DSP-18766
var _react1 = require("@emotion/react");
const BORDER_WIDTH = 2;
const baseFocusOutsideStyles = (0, _react1.css)({
    outline: `${"var(--ds-border-width-focused, 2px)"} solid ${"var(--ds-border-focused, #4688EC)"}`,
    outlineOffset: BORDER_WIDTH
});
const baseInsetStyles = (0, _react1.css)({
    outlineColor: "var(--ds-border-focused, #4688EC)",
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    outlineOffset: -BORDER_WIDTH,
    outlineStyle: 'solid',
    outlineWidth: "var(--ds-border-width-focused, 2px)"
});
const focusRingStyles = (0, _react1.css)({
    // Focus styles used when :focus-visible isn't supported
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values
    '&:focus': baseFocusOutsideStyles,
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values
    '&:focus-visible': baseFocusOutsideStyles,
    // Remove default focus styles for mouse interactions if :focus-visible is supported
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-selectors
    '&:focus:not(:focus-visible)': {
        outline: 'none'
    },
    '@media screen and (forced-colors: active), screen and (-ms-high-contrast: active)': {
        '&:focus-visible': {
            outline: `${"var(--ds-border-width, 1px)"} solid`
        }
    }
});
const insetFocusRingStyles = (0, _react1.css)({
    // Focus styles used when :focus-visible isn't supported
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values
    '&:focus': baseInsetStyles,
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values
    '&:focus-visible': baseInsetStyles,
    // Remove default focus styles for mouse interactions if :focus-visible is supported
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-selectors
    '&:focus:not(:focus-visible)': {
        outline: 'none'
    },
    '@media screen and (forced-colors: active), screen and (-ms-high-contrast: active)': {
        '&:focus-visible': {
            outline: `${"var(--ds-border-width, 1px)"} solid`,
            // eslint-disable-next-line @atlaskit/design-system/use-tokens-space
            outlineOffset: '-1px'
        }
    }
});
/**
 * __Focus ring__
 *
 * A focus ring visually indicates the currently focused item.
 *
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/focus-ring)
 *
 * @example
 * ```jsx
 * import FocusRing from '@atlaskit/focus-ring';
 *
 * const InteractiveComponent = () => (
 *   <FocusRing>
 *     <button type="button">Hello</button>
 *   </FocusRing>
 * )
 * ```
 *
 * @deprecated FocusRing is deprecated. Use Focusable from @atlaskit/primitives/compiled/focusable instead.
 */ const FocusRing = /*#__PURE__*/ (0, _react.memo)(({ children, isInset, focus })=>{
    const controlledStyles = isInset ? baseInsetStyles : baseFocusOutsideStyles;
    const uncontrolledStyles = isInset ? insetFocusRingStyles : focusRingStyles;
    const focusCls = typeof focus === 'undefined' ? uncontrolledStyles : focus === 'on' && controlledStyles;
    return /*#__PURE__*/ (0, _react1.jsx)((0, _react1.ClassNames), null, ({ css, cx })=>(0, _react.Children).only(// This may look unwieldy but means we skip applying styles / cloning if no className is applicable
        focusCls ? // eslint-disable-next-line @repo/internal/react/no-clone-element
        /*#__PURE__*/ (0, _react.cloneElement)(children, {
            className: cx([
                css(focusCls),
                children.props.className
            ])
        }) : children));
});
FocusRing.displayName = 'FocusRing';
exports.default = FocusRing;

},{"react":"ltHCL","@emotion/react":"cCAhJ","@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"8BpC0":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>blockEvents);
function abort(event) {
    event.preventDefault();
    event.stopPropagation();
}
const tabKeyCode = 9;
function onKey(event) {
    // Allowing tab so that a user can move focus away
    if (event.keyCode === tabKeyCode) return;
    abort(event);
}
const block = {
    onMouseDownCapture: abort,
    onMouseUpCapture: abort,
    // because we have tabIndex = -1 when disabled,
    // keyboard events can only occur when there is an overlay
    onKeyDownCapture: onKey,
    onKeyUpCapture: onKey,
    onTouchStartCapture: abort,
    onTouchEndCapture: abort,
    onPointerDownCapture: abort,
    onPointerUpCapture: abort,
    onClickCapture: abort,
    // Just smashing the existing onClick for good measure
    onClick: abort
};
const doNotBlock = {};
function blockEvents({ isInteractive }) {
    return isInteractive ? doNotBlock : block;
}

},{"@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"37Y1v":[function(require,module,exports,__globalThis) {
// eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled -- Ignored via go/DSP-18766
var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "getContentStyle", ()=>getContentStyle);
var _react = require("@emotion/react");
function getContentStyle({ spacing }) {
    return (0, _react.css)({
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
        margin: spacing === 'none' ? 0 : '0 2px',
        // content can grow and shrink
        flexGrow: 1,
        flexShrink: 1,
        // ellipsis for overflow text
        overflow: 'hidden',
        textOverflow: 'ellipsis',
        whiteSpace: 'nowrap'
    });
}

},{"@emotion/react":"cCAhJ","@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"3WJDs":[function(require,module,exports,__globalThis) {
// eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled -- Ignored via go/DSP-18766
var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "getFadingCss", ()=>getFadingCss);
var _react = require("@emotion/react");
function getFadingCss({ hasOverlay }) {
    return (0, _react.css)({
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
        opacity: hasOverlay ? 0 : 1,
        transition: 'opacity 0.3s'
    });
}

},{"@emotion/react":"cCAhJ","@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"9sMg2":[function(require,module,exports,__globalThis) {
// eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled -- Ignored via go/DSP-18766
var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "getIconStyle", ()=>getIconStyle);
var _react = require("@emotion/react");
function getIconStyle({ spacing }) {
    return (0, _react.css)({
        display: 'flex',
        // icon size cannot grow and shrink
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
        margin: spacing === 'none' ? 0 : `0 2px`,
        flexGrow: 0,
        flexShrink: 0,
        alignSelf: 'center',
        // eslint-disable-next-line @atlaskit/design-system/use-tokens-typography
        fontSize: 0,
        // eslint-disable-next-line @atlaskit/design-system/use-tokens-typography
        lineHeight: 0,
        userSelect: 'none'
    });
}

},{"@emotion/react":"cCAhJ","@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"iNcJF":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "getIfVisuallyHiddenChildren", ()=>getIfVisuallyHiddenChildren);
var _react = require("react");
var _visuallyHidden = require("@atlaskit/visually-hidden");
var _visuallyHiddenDefault = parcelHelpers.interopDefault(_visuallyHidden);
const getIfVisuallyHiddenChildren = (children)=>{
    return children && /*#__PURE__*/ (0, _react.isValidElement)(children) && children.type === (0, _visuallyHiddenDefault.default);
};

},{"react":"ltHCL","@atlaskit/visually-hidden":"gKDx1","@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"lRCFI":[function(require,module,exports,__globalThis) {
// eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled -- Ignored via go/DSP-18766
var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "overlayCss", ()=>overlayCss);
const overlayCss = {
    // stretching to full width / height of button
    // this is important as we need it to still block
    // event if clicking in the button's own padding
    position: 'absolute',
    left: 0,
    top: 0,
    right: 0,
    bottom: 0,
    // Putting all children in the center
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center'
};

},{"@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"dYJ2c":[function(require,module,exports,__globalThis) {
// eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled -- Ignored via go/DSP-18766
var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "getCss", ()=>getCss);
var _objectSpread = require("@swc/helpers/_/_object_spread");
var _objectSpreadProps = require("@swc/helpers/_/_object_spread_props");
var _platformFeatureFlags = require("@atlaskit/platform-feature-flags");
const gridSize = 8;
const HAS_DISABLED_BACKGROUND = [
    'default',
    'primary',
    'danger',
    'warning'
];
const heights = {
    default: `${32 / 14}em`,
    // 32px
    compact: `${24 / 14}em`,
    none: 'auto'
};
const lineHeights = {
    default: heights.default,
    compact: heights.compact,
    none: 'inherit'
};
const padding = {
    // 10px gutter
    default: `0 ${gridSize + gridSize / 4}px`,
    compact: `0 ${gridSize + gridSize / 4}px`,
    none: '0'
};
const singleIconPadding = {
    // 2px gutter
    compact: `0 ${gridSize / 4}px`,
    default: `0 ${gridSize / 4}px`,
    none: '0'
};
const verticalAlign = {
    default: 'middle',
    compact: 'middle',
    none: 'baseline'
};
const defaultAfterStyles = {
    borderRadius: 'inherit',
    inset: "var(--ds-space-0, 0px)",
    borderStyle: 'solid',
    borderWidth: "var(--ds-border-width, 1px)",
    pointerEvents: 'none',
    position: 'absolute'
};
const defaultStyles = {
    background: "var(--ds-background-neutral-subtle, #00000000)",
    color: "var(--ds-text, #292A2E)",
    '&::after': (0, _objectSpreadProps._)((0, _objectSpread._)({}, defaultAfterStyles), {
        content: '""',
        borderColor: "var(--ds-border, #0B120E24)"
    }),
    '&:hover': {
        background: "var(--ds-background-neutral-hovered, #0B120E24)"
    },
    '&:active': {
        background: "var(--ds-background-neutral-pressed, #080F214A)"
    },
    '&[data-has-overlay="true"]:not([disabled]):hover': {
        background: "var(--ds-background-neutral-subtle, #00000000)"
    },
    '&:disabled[disabled]': {
        background: "var(--ds-background-neutral-subtle, #00000000)"
    },
    '&:disabled[disabled]:hover': {
        background: "var(--ds-background-neutral-subtle, #00000000)"
    },
    '&:disabled[disabled]:active': {
        background: "var(--ds-background-neutral-subtle, #00000000)"
    }
};
const primaryStyles = {
    background: "var(--ds-background-brand-bold, #1868DB)",
    color: "var(--ds-text-inverse, #FFFFFF)",
    '&:hover': {
        background: "var(--ds-background-brand-bold-hovered, #1558BC)"
    },
    '&:active': {
        background: "var(--ds-background-brand-bold-pressed, #144794)"
    },
    '&[data-has-overlay="true"]:not([disabled]):hover': {
        background: "var(--ds-background-brand-bold, #1868DB)"
    }
};
const linkStyles = {
    background: 'transparent',
    color: "var(--ds-link, #1868DB)",
    '&:hover': {
        color: "var(--ds-link, #1868DB)",
        textDecoration: 'underline'
    },
    '&:active': {
        color: "var(--ds-link-pressed, #1558BC)",
        textDecoration: 'underline'
    }
};
const subtleStyles = {
    background: 'transparent',
    color: "var(--ds-text-subtle, #505258)",
    '&:hover': {
        background: "var(--ds-background-neutral-subtle-hovered, #0515240F)"
    },
    '&:active': {
        background: "var(--ds-background-neutral-subtle-pressed, #0B120E24)"
    },
    '&[data-has-overlay="true"]:not([disabled]):hover': {
        background: 'transparent'
    }
};
const subtleLinkStyles = {
    background: 'transparent',
    color: "var(--ds-text-subtle, #505258)",
    '&:hover': {
        background: 'transparent',
        color: "var(--ds-text-subtle, #505258)",
        textDecoration: 'underline'
    },
    '&:active': {
        background: 'transparent',
        color: "var(--ds-text, #292A2E)",
        textDecoration: 'underline'
    }
};
const warningStyles = {
    background: "var(--ds-background-warning-bold, #FBC828)",
    color: "var(--ds-text-warning-inverse, #292A2E)",
    '&:hover': {
        background: "var(--ds-background-warning-bold-hovered, #FCA700)"
    },
    '&:active': {
        background: "var(--ds-background-warning-bold-pressed, #F68909)"
    },
    '&[data-has-overlay="true"]:not([disabled]):hover': {
        background: "var(--ds-background-warning-bold, #FBC828)"
    }
};
const dangerStyles = {
    background: "var(--ds-background-danger-bold, #C9372C)",
    color: "var(--ds-text-inverse, #FFFFFF)",
    '&:hover': {
        background: "var(--ds-background-danger-bold-hovered, #AE2E24)"
    },
    '&:active': {
        background: "var(--ds-background-danger-bold-pressed, #872821)"
    },
    '&[data-has-overlay="true"]:not([disabled]):hover': {
        background: "var(--ds-background-danger-bold, #C9372C)"
    }
};
const selectedStyles = {
    background: "var(--ds-background-selected, #E9F2FE)",
    color: "var(--ds-text-selected, #1868DB)",
    '&:not([disabled])::after': (0, _objectSpreadProps._)((0, _objectSpread._)({}, defaultAfterStyles), {
        content: '""',
        borderColor: "var(--ds-border-selected, #1868DB)"
    })
};
/**
 * Anchor-text-color variants applied when the legacy `Button` is rendered as
 * an `<a>` (via `href`). Each `<variant>WithAnchorTextColorStyles` is a
 * self-contained appearance object that adds explicit `color` /
 * `text-decoration` on the base, `:hover`, and `:active` states, preventing
 * browser default or ambient anchor styles from overriding the button's
 * intended text color or adding an unwanted underline.
 *
 * Gated by `platform-dst-legacy-button-anchor-text-color` and used *instead*
 * of the base `<variant>Styles`. When cleaning up the gate: delete the base
 * `<variant>Styles` and rename the `WithAnchorTextColor` variant to replace
 * it.
 *
 * Link-like variants (`link`, `subtle-link`) keep their intentional underline
 * on `:hover` / `:active`.
 */ const defaultWithAnchorTextColorStyles = (0, _objectSpreadProps._)((0, _objectSpread._)({}, defaultStyles), {
    textDecoration: 'none',
    '&:hover': (0, _objectSpreadProps._)((0, _objectSpread._)({}, defaultStyles['&:hover']), {
        color: "var(--ds-text, #292A2E)",
        textDecoration: 'none'
    }),
    '&:active': (0, _objectSpreadProps._)((0, _objectSpread._)({}, defaultStyles['&:active']), {
        color: "var(--ds-text, #292A2E)",
        textDecoration: 'none'
    })
});
const primaryWithAnchorTextColorStyles = (0, _objectSpreadProps._)((0, _objectSpread._)({}, primaryStyles), {
    textDecoration: 'none',
    '&:hover': (0, _objectSpreadProps._)((0, _objectSpread._)({}, primaryStyles['&:hover']), {
        color: "var(--ds-text-inverse, #FFFFFF)",
        textDecoration: 'none'
    }),
    '&:active': (0, _objectSpreadProps._)((0, _objectSpread._)({}, primaryStyles['&:active']), {
        color: "var(--ds-text-inverse, #FFFFFF)",
        textDecoration: 'none'
    })
});
const linkWithAnchorTextColorStyles = (0, _objectSpreadProps._)((0, _objectSpread._)({}, linkStyles), {
    textDecoration: 'none'
});
const subtleWithAnchorTextColorStyles = (0, _objectSpreadProps._)((0, _objectSpread._)({}, subtleStyles), {
    textDecoration: 'none',
    '&:hover': (0, _objectSpreadProps._)((0, _objectSpread._)({}, subtleStyles['&:hover']), {
        color: "var(--ds-text-subtle, #505258)",
        textDecoration: 'none'
    }),
    '&:active': (0, _objectSpreadProps._)((0, _objectSpread._)({}, subtleStyles['&:active']), {
        color: "var(--ds-text-subtle, #505258)",
        textDecoration: 'none'
    })
});
const subtleLinkWithAnchorTextColorStyles = (0, _objectSpreadProps._)((0, _objectSpread._)({}, subtleLinkStyles), {
    textDecoration: 'none'
});
const warningWithAnchorTextColorStyles = (0, _objectSpreadProps._)((0, _objectSpread._)({}, warningStyles), {
    textDecoration: 'none',
    '&:hover': (0, _objectSpreadProps._)((0, _objectSpread._)({}, warningStyles['&:hover']), {
        color: "var(--ds-text-warning-inverse, #292A2E)",
        textDecoration: 'none'
    }),
    '&:active': (0, _objectSpreadProps._)((0, _objectSpread._)({}, warningStyles['&:active']), {
        color: "var(--ds-text-warning-inverse, #292A2E)",
        textDecoration: 'none'
    })
});
const dangerWithAnchorTextColorStyles = (0, _objectSpreadProps._)((0, _objectSpread._)({}, dangerStyles), {
    textDecoration: 'none',
    '&:hover': (0, _objectSpreadProps._)((0, _objectSpread._)({}, dangerStyles['&:hover']), {
        color: "var(--ds-text-inverse, #FFFFFF)",
        textDecoration: 'none'
    }),
    '&:active': (0, _objectSpreadProps._)((0, _objectSpread._)({}, dangerStyles['&:active']), {
        color: "var(--ds-text-inverse, #FFFFFF)",
        textDecoration: 'none'
    })
});
const hasOverlayStyles = {
    '&[data-has-overlay="true"]': {
        cursor: 'default',
        textDecoration: 'none'
    }
};
function getCss({ appearance, spacing, isSelected, shouldFitContainer, isOnlySingleIcon }) {
    return (0, _objectSpreadProps._)((0, _objectSpread._)({
        // 0px margin added to css-reset
        alignItems: 'baseline',
        borderWidth: 0,
        borderRadius: (0, _platformFeatureFlags.fg)('platform-dst-shape-theme-default') ? "var(--ds-radius-medium, 6px)" : "var(--ds-radius-small, 3px)",
        boxSizing: 'border-box',
        display: 'inline-flex',
        fontSize: 'inherit',
        fontStyle: 'normal',
        // Chrome recently changed button so that they use 'arial' as the font family
        fontFamily: 'inherit',
        fontWeight: "var(--ds-font-weight-medium, 500)",
        // margin for button has been applied to css reset
        maxWidth: '100%',
        // Needed to position overlay
        position: 'relative',
        textAlign: 'center',
        textDecoration: 'none',
        transition: (0, _platformFeatureFlags.fg)('platform-dst-motion-uplift-button') ? `${"var(--ds-button-hovered, background-color 150ms cubic-bezier(0.4, 1, 0.6, 1))"}, box-shadow 0.15s cubic-bezier(0.47, 0.03, 0.49, 1.38)` : 'background 0.1s ease-out, box-shadow 0.15s cubic-bezier(0.47, 0.03, 0.49, 1.38)',
        whiteSpace: 'nowrap',
        cursor: 'pointer',
        height: heights[spacing],
        lineHeight: lineHeights[spacing],
        padding: isOnlySingleIcon ? singleIconPadding[spacing] : padding[spacing],
        verticalAlign: verticalAlign[spacing],
        width: shouldFitContainer ? '100%' : 'auto',
        // justifyContent required for shouldFitContainer buttons with an icon inside
        justifyContent: 'center'
    }, isSelected ? selectedStyles : (0, _objectSpread._)((0, _objectSpreadProps._)((0, _objectSpread._)({}, (0, _platformFeatureFlags.fg)('platform-dst-legacy-button-anchor-text-color') ? (0, _objectSpread._)({}, appearance === 'default' && defaultWithAnchorTextColorStyles, appearance === 'primary' && primaryWithAnchorTextColorStyles, appearance === 'link' && linkWithAnchorTextColorStyles, appearance === 'subtle' && subtleWithAnchorTextColorStyles, appearance === 'subtle-link' && subtleLinkWithAnchorTextColorStyles, appearance === 'warning' && warningWithAnchorTextColorStyles, appearance === 'danger' && dangerWithAnchorTextColorStyles) : (0, _objectSpread._)({}, appearance === 'default' && defaultStyles, appearance === 'primary' && primaryStyles, appearance === 'link' && linkStyles, appearance === 'subtle' && subtleStyles, appearance === 'subtle-link' && subtleLinkStyles, appearance === 'warning' && warningStyles, appearance === 'danger' && dangerStyles)), {
        '&[disabled]': {
            color: "var(--ds-text-disabled, #080F214A)",
            backgroundColor: HAS_DISABLED_BACKGROUND.includes(appearance) ? "var(--ds-background-disabled, #0515240F)" : 'transparent',
            cursor: 'not-allowed',
            textDecoration: 'none',
            '&:hovered': {
                backgroundColor: HAS_DISABLED_BACKGROUND.includes(appearance) ? "var(--ds-background-disabled, #0515240F)" : 'transparent'
            },
            '&:active': {
                backgroundColor: HAS_DISABLED_BACKGROUND.includes(appearance) ? "var(--ds-background-disabled, #0515240F)" : 'transparent'
            }
        }
    }), hasOverlayStyles)), {
        '&::-moz-focus-inner': {
            border: 0,
            margin: 0,
            padding: 0
        }
    });
}

},{"@swc/helpers/_/_object_spread":"9gdrV","@swc/helpers/_/_object_spread_props":"kANqQ","@atlaskit/platform-feature-flags":"8rD2i","@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"8YxN4":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>getIsOnlySingleIcon);
var _getIfVisuallyHiddenChildren = require("./get-if-visually-hidden-children");
function getIsOnlySingleIcon({ children, iconBefore, iconAfter }) {
    if ((0, _getIfVisuallyHiddenChildren.getIfVisuallyHiddenChildren)(children)) return true;
    if (children) return false;
    if (iconBefore && !iconAfter) return true;
    if (!iconBefore && iconAfter) return true;
    return false;
}

},{"./get-if-visually-hidden-children":"iNcJF","@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"7pzcv":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>Page);
var _objectSpread = require("@swc/helpers/_/_object_spread");
var _objectSpreadProps = require("@swc/helpers/_/_object_spread_props");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _standardButton = require("@atlaskit/button/standard-button");
var _standardButtonDefault = parcelHelpers.interopDefault(_standardButton);
function Page(props) {
    // eslint-disable-next-line @repo/internal/react/no-unsafe-spread-props
    return /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _standardButtonDefault.default), (0, _objectSpreadProps._)((0, _objectSpread._)({}, props), {
        appearance: "subtle"
    }));
}

},{"@swc/helpers/_/_object_spread":"9gdrV","@swc/helpers/_/_object_spread_props":"kANqQ","react":"ltHCL","@atlaskit/button/standard-button":"l4NwS","@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"9ERXZ":[function(require,module,exports,__globalThis) {
/* render-ellipsis.tsx generated by @compiled/babel-plugin v0.39.1 */ var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>renderEllipsis);
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _compiled = require("@atlaskit/primitives/compiled");
var _visuallyHidden = require("@atlaskit/visually-hidden");
var _visuallyHiddenDefault = parcelHelpers.interopDefault(_visuallyHidden);
const styles = {
    container: "_1e0c1txw _kqswh2mm"
};
function renderEllipsis({ key, testId, from, to }) {
    return /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _compiled.Box), {
        as: "li",
        testId: testId,
        key: key,
        xcss: styles.container,
        paddingInline: "space.100"
    }, /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _compiled.Text), {
        testId: testId && `${testId}-text`
    }, /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _visuallyHiddenDefault.default), null, "Skipped pages from ", from, " to ", to), "\u2026"));
}

},{"react":"ltHCL","@atlaskit/primitives/compiled":"hDay7","@atlaskit/visually-hidden":"gKDx1","@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"3ihWx":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "emptyObject", ()=>emptyObject);
const emptyObject = {};

},{"@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"kWQJ1":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _memoizeOne = require("memoize-one");
var _memoizeOneDefault = parcelHelpers.interopDefault(_memoizeOne);
// TODO: comma needed after generic declaration below, or the .tsx file thinks
// it is a JSX element. Tidy up in a future refactor.
const collapseRange = (pages, current, { max, ellipsis, transform }, testId)=>{
    const total = pages.length;
    // only need ellipsis if we have more pages than we can display
    const needEllipsis = total > max;
    // show start ellipsis if the current page is further away than max - 4 from the first page
    const hasStartEllipsis = needEllipsis && max - 4 < current;
    // show end ellipsis if the current page is further than total - max + 3 from the last page
    const hasEndEllipsis = needEllipsis && current < total - max + 3;
    const getPageComponents = (0, _memoizeOneDefault.default)((startIndex = 0, lastIndex = total)=>{
        return pages.slice(startIndex, lastIndex).map((page, index)=>transform(page, startIndex + index, testId));
    });
    if (!needEllipsis) return getPageComponents(0, total);
    if (hasStartEllipsis && !hasEndEllipsis) {
        const pageCount = max - 2;
        return [
            ...getPageComponents(0, 1),
            ellipsis({
                key: 'ellipsis-1',
                testId: testId && `${testId}-ellipsis`,
                from: 2,
                to: total - pageCount
            }),
            ...getPageComponents(total - pageCount)
        ];
    }
    if (!hasStartEllipsis && hasEndEllipsis) {
        const pageCount = max - 2;
        return [
            ...getPageComponents(0, pageCount),
            ellipsis({
                key: 'ellipsis-1',
                testId: testId && `${testId}-ellipsis`,
                from: pageCount + 1,
                to: total - 1
            }),
            ...getPageComponents(total - 1)
        ];
    }
    // we have both start and end ellipsis
    const pageCount = max - 4;
    return [
        ...getPageComponents(0, 1),
        ellipsis({
            key: 'ellipsis-1',
            testId: testId && `${testId}-ellipsis`,
            from: 2,
            to: current - Math.floor(pageCount / 2)
        }),
        ...getPageComponents(current - Math.floor(pageCount / 2), current + pageCount - 1),
        ellipsis({
            key: 'ellipsis-2',
            testId: testId && `${testId}-ellipsis`,
            from: current + 3,
            to: total - 1
        }),
        ...getPageComponents(total - 1)
    ];
};
exports.default = collapseRange;

},{"memoize-one":"5rJro","@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"cnfS7":[function(require,module,exports,__globalThis) {
/**
 * notes to other devs, we are starting to move toward a 1.0.0
 * which will include making `/compiled` the default entry point
 * to the package.
 *
 * the previous version will be under `/depecated` until
 * we can clean up usage in the monorepo.
 */ var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "ExpandIcon", ()=>(0, _expandIcon.ExpandIcon));
parcelHelpers.export(exports, "TBody", ()=>(0, _body.TBody));
parcelHelpers.export(exports, "DraggableCell", ()=>(0, _cellDnd.DraggableCell));
parcelHelpers.export(exports, "HeadCell", ()=>(0, _headCell.HeadCell));
parcelHelpers.export(exports, "HeaderDescription", ()=>(0, _headerDescription.HeaderDescription));
parcelHelpers.export(exports, "Row", ()=>(0, _row.Row));
parcelHelpers.export(exports, "RowCell", ()=>(0, _rowCell.RowCell));
parcelHelpers.export(exports, "SortIcon", ()=>(0, _sortIcon.SortIcon));
parcelHelpers.export(exports, "Table", ()=>(0, _table1.Table));
parcelHelpers.export(exports, "THead", ()=>(0, _thead1.THead));
parcelHelpers.export(exports, "CharlieTable", ()=>(0, _charlieTable.CharlieTable));
parcelHelpers.export(exports, "TableState", ()=>(0, _charlieTable.TableState));
parcelHelpers.export(exports, "useCharlieTable", ()=>(0, _useCharlieTable.useCharlieTable));
parcelHelpers.export(exports, "useInfiniteScroll", ()=>(0, _useInfiniteScroll.useInfiniteScroll));
parcelHelpers.export(exports, "Primitives", ()=>Primitives);
var _table = require("./ui/primitives/table");
var _tbody = require("./ui/primitives/tbody");
var _td = require("./ui/primitives/td");
var _th = require("./ui/primitives/th");
var _thead = require("./ui/primitives/thead");
var _tr = require("./ui/primitives/tr");
var _expandIcon = require("./ui/primitives/expand-icon");
var _body = require("./deprecated/components/body");
var _cellDnd = require("./deprecated/components/cell-dnd");
var _headCell = require("./deprecated/components/head-cell");
var _headerDescription = require("./deprecated/components/header-description");
var _row = require("./deprecated/components/row");
var _rowCell = require("./deprecated/components/row-cell");
var _sortIcon = require("./deprecated/components/sort-icon");
var _table1 = require("./deprecated/components/table");
var _thead1 = require("./deprecated/components/thead");
var _charlieTable = require("./deprecated/charlie-table");
var _useCharlieTable = require("./hooks/use-charlie-table");
var _useInfiniteScroll = require("./shared-hooks/use-infinite-scroll");
const Primitives = {
    TBody: (0, _tbody.TBody),
    THead: (0, _thead.THead),
    TR: (0, _tr.TR),
    Table: (0, _table.Table),
    TD: (0, _td.TD),
    TH: (0, _th.TH)
};

},{"./ui/primitives/table":"iU7Dg","./ui/primitives/tbody":"ckVuK","./ui/primitives/td":"c8E9x","./ui/primitives/th":"58kIs","./ui/primitives/thead":"jhq5N","./ui/primitives/tr":"5MlIx","./ui/primitives/expand-icon":false,"./deprecated/components/body":false,"./deprecated/components/cell-dnd":false,"./deprecated/components/head-cell":false,"./deprecated/components/header-description":false,"./deprecated/components/row":false,"./deprecated/components/row-cell":false,"./deprecated/components/sort-icon":false,"./deprecated/components/table":false,"./deprecated/components/thead":false,"./deprecated/charlie-table":false,"./hooks/use-charlie-table":"4yZqG","./shared-hooks/use-infinite-scroll":false,"@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"iU7Dg":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "Table", ()=>Table);
var _objectSpread = require("@swc/helpers/_/_object_spread");
var _objectWithoutProperties = require("@swc/helpers/_/_object_without_properties");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
// eslint-disable-next-line @atlaskit/design-system/no-emotion-primitives -- to be migrated to @atlaskit/primitives/compiled – go/akcss
var _primitives = require("@atlaskit/primitives");
const Table = /*#__PURE__*/ (0, _react.forwardRef)((_param, ref)=>{
    var { children, testId } = _param, props = (0, _objectWithoutProperties._)(_param, [
        "children",
        "testId"
    ]);
    return /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _primitives.Box), (0, _objectSpread._)({
        as: "table",
        testId: testId,
        ref: ref
    }, props), children);
});

},{"@swc/helpers/_/_object_spread":"9gdrV","@swc/helpers/_/_object_without_properties":"6HqIM","react":"ltHCL","@atlaskit/primitives":"3S6Im","@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"3S6Im":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "Box", ()=>(0, _boxDefault.default));
parcelHelpers.export(exports, "Inline", ()=>(0, _inlineDefault.default));
parcelHelpers.export(exports, "xcss", ()=>(0, _xcss.xcss));
parcelHelpers.export(exports, "tokensMap", ()=>(0, _xcss.tokensMap));
parcelHelpers.export(exports, "Stack", ()=>(0, _stackDefault.default));
parcelHelpers.export(exports, "Flex", ()=>(0, _flexDefault.default));
parcelHelpers.export(exports, "Grid", ()=>(0, _gridDefault.default));
parcelHelpers.export(exports, "Bleed", ()=>(0, _bleedDefault.default));
parcelHelpers.export(exports, "Text", ()=>(0, _textDefault.default));
parcelHelpers.export(exports, "MetricText", ()=>(0, _metricTextDefault.default));
parcelHelpers.export(exports, "Pressable", ()=>(0, _pressableDefault.default));
parcelHelpers.export(exports, "Anchor", ()=>(0, _anchorDefault.default));
parcelHelpers.export(exports, "media", ()=>(0, _responsive.media));
parcelHelpers.export(exports, "UNSAFE_media", ()=>(0, _responsive.UNSAFE_media));
parcelHelpers.export(exports, "UNSAFE_BREAKPOINTS_CONFIG", ()=>(0, _responsive.UNSAFE_BREAKPOINTS_CONFIG));
parcelHelpers.export(exports, "UNSAFE_useSurface", ()=>(0, _surfaceProvider.useSurface));
parcelHelpers.export(exports, "UNSAFE_inverseColorMap", ()=>(0, _styleMapsPartial.inverseColorMap));
var _box = require("./components/box");
var _boxDefault = parcelHelpers.interopDefault(_box);
var _inline = require("./components/inline");
var _inlineDefault = parcelHelpers.interopDefault(_inline);
var _xcss = require("./xcss/xcss");
var _stack = require("./components/stack");
var _stackDefault = parcelHelpers.interopDefault(_stack);
var _flex = require("./components/flex");
var _flexDefault = parcelHelpers.interopDefault(_flex);
var _grid = require("./components/grid");
var _gridDefault = parcelHelpers.interopDefault(_grid);
var _bleed = require("./components/bleed");
var _bleedDefault = parcelHelpers.interopDefault(_bleed);
var _text = require("./components/text");
var _textDefault = parcelHelpers.interopDefault(_text);
var _metricText = require("./components/metric-text");
var _metricTextDefault = parcelHelpers.interopDefault(_metricText);
var _pressable = require("./components/pressable");
var _pressableDefault = parcelHelpers.interopDefault(_pressable);
var _anchor = require("./components/anchor");
var _anchorDefault = parcelHelpers.interopDefault(_anchor);
var _responsive = require("./responsive");
var _surfaceProvider = require("./utils/surface-provider");
var _styleMapsPartial = require("./xcss/style-maps.partial");

},{"./components/box":"bU4xr","./components/inline":"5pDfG","./xcss/xcss":"fMzqB","./components/stack":"1mttX","./components/flex":"iXW1t","./components/grid":"6Xtvi","./components/bleed":false,"./components/text":"aWZMm","./components/metric-text":false,"./components/pressable":"kTwbY","./components/anchor":"ac3oA","./responsive":false,"./utils/surface-provider":false,"./xcss/style-maps.partial":"a7SYG","@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"bU4xr":[function(require,module,exports,__globalThis) {
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "Box", ()=>Box);
var _objectSpread = require("@swc/helpers/_/_object_spread");
var _objectSpreadProps = require("@swc/helpers/_/_object_spread_props");
var _objectWithoutProperties = require("@swc/helpers/_/_object_without_properties");
var _react = require("react");
// eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled -- Ignored via go/DSP-18766
var _react1 = require("@emotion/react");
var _surfaceContext = require("../utils/surface-context");
var _styleMapsPartial = require("../xcss/style-maps.partial");
var _xcss = require("../xcss/xcss");
const Box = /*#__PURE__*/ (0, _react.forwardRef)((_param, ref)=>{
    var { as: Component = 'div', children, backgroundColor, padding, paddingBlock, paddingBlockStart, paddingBlockEnd, paddingInline, paddingInlineStart, paddingInlineEnd, style, testId, xcss } = _param, htmlAttributes = (0, _objectWithoutProperties._)(_param, [
        "as",
        "children",
        "backgroundColor",
        "padding",
        "paddingBlock",
        "paddingBlockStart",
        "paddingBlockEnd",
        "paddingInline",
        "paddingInlineStart",
        "paddingInlineEnd",
        "style",
        "testId",
        "xcss"
    ]);
    // This is to remove className from safeHtmlAttributes
    // @ts-ignore -- not using expect since it causes issues with help-center local consumption - className doesn't exist in the prop definition but we want to ensure it cannot be applied even if types are bypassed
    const { className: _spreadClass } = htmlAttributes, safeHtmlAttributes = (0, _objectWithoutProperties._)(htmlAttributes, [
        "className"
    ]);
    const resolvedStyles = (0, _xcss.parseXcss)(xcss);
    const node = // @ts-expect-error Expression produces a union type that is too complex to represent. I think this is unavoidable
    /*#__PURE__*/ (0, _react1.jsx)(Component, (0, _objectSpreadProps._)((0, _objectSpread._)({
        style: style,
        // @ts-ignore Expression produces a union type that is too complex to represent. We may be able to narrow the type here but unsure.
        ref: ref,
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
        className: resolvedStyles.static
    }, safeHtmlAttributes), {
        css: [
            baseStyles,
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
            backgroundColor && (0, _styleMapsPartial.backgroundColorStylesMap)[backgroundColor],
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
            (0, _styleMapsPartial.isSurfaceColorToken)(backgroundColor) && (0, _styleMapsPartial.surfaceColorStylesMap)[backgroundColor],
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
            padding && (0, _styleMapsPartial.paddingStylesMap).padding[padding],
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
            paddingBlock && (0, _styleMapsPartial.paddingStylesMap).paddingBlock[paddingBlock],
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
            paddingBlockStart && (0, _styleMapsPartial.paddingStylesMap).paddingBlockStart[paddingBlockStart],
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
            paddingBlockEnd && (0, _styleMapsPartial.paddingStylesMap).paddingBlockEnd[paddingBlockEnd],
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
            paddingInline && (0, _styleMapsPartial.paddingStylesMap).paddingInline[paddingInline],
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
            paddingInlineStart && (0, _styleMapsPartial.paddingStylesMap).paddingInlineStart[paddingInlineStart],
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
            paddingInlineEnd && (0, _styleMapsPartial.paddingStylesMap).paddingInlineEnd[paddingInlineEnd],
            resolvedStyles.emotion
        ],
        "data-testid": testId
    }), children);
    return backgroundColor ? /*#__PURE__*/ (0, _react1.jsx)((0, _surfaceContext.SurfaceContext).Provider, {
        value: backgroundColor
    }, node) : node;
});
// eslint-disable-next-line @atlaskit/volt-strict-mode/no-multiple-exports
exports.default = Box;
const baseStyles = (0, _react1.css)({
    boxSizing: 'border-box',
    appearance: 'none',
    border: 'none'
});

},{"@swc/helpers/_/_object_spread":"9gdrV","@swc/helpers/_/_object_spread_props":"kANqQ","@swc/helpers/_/_object_without_properties":"6HqIM","react":"ltHCL","@emotion/react":"cCAhJ","../utils/surface-context":"a2y1l","../xcss/style-maps.partial":"a7SYG","../xcss/xcss":"fMzqB","@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"5pDfG":[function(require,module,exports,__globalThis) {
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
// eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled -- Ignored via go/DSP-18766
var _react1 = require("@emotion/react");
var _xcss = require("../xcss/xcss");
var _flex = require("./flex");
var _flexDefault = parcelHelpers.interopDefault(_flex);
const flexGrowMap = {
    hug: (0, _xcss.xcss)({
        flexGrow: 0
    }),
    fill: (0, _xcss.xcss)({
        width: '100%',
        flexGrow: 1
    })
};
const separatorStyles = (0, _react1.css)({
    color: "var(--ds-text-subtle, #42526E)",
    marginBlock: "var(--ds-space-0, 0px)",
    marginInline: `${"var(--ds-space-negative-025, -2px)"}`,
    pointerEvents: 'none',
    userSelect: 'none'
});
const Separator = ({ children })=>/*#__PURE__*/ (0, _react1.jsx)("span", {
        css: separatorStyles
    }, children);
/**
 * __Inline__
 *
 * Inline is a primitive component based on CSS Flexbox that manages the horizontal layout of direct children.
 *
 * @example
 * ```tsx
 *  <Inline>
 *    <Box padding="space.100" backgroundColor="neutral"></Box>
 *    <Box padding="space.100" backgroundColor="neutral"></Box>
 *  </Inline>
 * ```
 *
 */ const Inline = /*#__PURE__*/ (0, _react.memo)(/*#__PURE__*/ (0, _react.forwardRef)(({ as, alignInline, alignBlock: alignItems = 'start', shouldWrap = false, spread, grow, space, rowSpace, separator, xcss, testId, role, id, children: rawChildren }, ref)=>{
    const separatorComponent = typeof separator === 'string' ? /*#__PURE__*/ (0, _react1.jsx)(Separator, null, separator) : separator;
    const children = separatorComponent ? (0, _react.Children).toArray(rawChildren).filter(Boolean).map((child, index)=>{
        return /*#__PURE__*/ (0, _react1.jsx)((0, _react.Fragment), {
            key: index
        }, separator && index > 0 ? separatorComponent : null, child);
    }) : rawChildren;
    const justifyContent = spread || alignInline;
    // We're type coercing this as Compiled styles in an array isn't supported by the types
    // But the runtime accepts it none-the-wiser. We can remove this entire block and replace
    // it with cx(defaultStyles, focusRingStyles, xcssStyles) when we've moved away from Emotion.
    const styles = grow ? [
        flexGrowMap[grow],
        ...Array.isArray(xcss) ? xcss : [
            xcss
        ]
    ] : xcss;
    return /*#__PURE__*/ (0, _react1.jsx)((0, _flexDefault.default), {
        id: id,
        as: as,
        role: role,
        alignItems: alignItems,
        justifyContent: justifyContent,
        direction: "row",
        gap: space,
        rowGap: rowSpace,
        wrap: shouldWrap ? 'wrap' : undefined,
        // eslint-disable-next-line @atlaskit/design-system/consistent-css-prop-usage
        xcss: styles,
        testId: testId,
        ref: ref
    }, children);
}));
Inline.displayName = 'Inline';
exports.default = Inline;

},{"react":"ltHCL","@emotion/react":"cCAhJ","../xcss/xcss":"fMzqB","./flex":"iXW1t","@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"iXW1t":[function(require,module,exports,__globalThis) {
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _react = require("react");
// eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled -- Ignored via go/DSP-18766
var _react1 = require("@emotion/react");
var _styleMapsPartial = require("../xcss/style-maps.partial");
var _xcss = require("../xcss/xcss");
const justifyContentMap = {
    start: (0, _react1.css)({
        justifyContent: 'start'
    }),
    center: (0, _react1.css)({
        justifyContent: 'center'
    }),
    end: (0, _react1.css)({
        justifyContent: 'end'
    }),
    'space-between': (0, _react1.css)({
        justifyContent: 'space-between'
    }),
    'space-around': (0, _react1.css)({
        justifyContent: 'space-around'
    }),
    'space-evenly': (0, _react1.css)({
        justifyContent: 'space-evenly'
    }),
    stretch: (0, _react1.css)({
        justifyContent: 'stretch'
    })
};
const flexDirectionMap = {
    column: (0, _react1.css)({
        flexDirection: 'column'
    }),
    row: (0, _react1.css)({
        flexDirection: 'row'
    })
};
const flexWrapMap = {
    wrap: (0, _react1.css)({
        flexWrap: 'wrap'
    }),
    nowrap: (0, _react1.css)({
        flexWrap: 'nowrap'
    })
};
const alignItemsMap = {
    start: (0, _react1.css)({
        alignItems: 'start'
    }),
    center: (0, _react1.css)({
        alignItems: 'center'
    }),
    baseline: (0, _react1.css)({
        alignItems: 'baseline'
    }),
    end: (0, _react1.css)({
        alignItems: 'end'
    }),
    stretch: (0, _react1.css)({
        alignItems: 'stretch'
    })
};
const baseStyles = (0, _react1.css)({
    display: 'flex',
    boxSizing: 'border-box'
});
/**
 * __Flex__
 *
 * `Flex` is a primitive component that implements the CSS Flexbox API.
 *
 * - [Examples](https://atlassian.design/components/primitives/flex/examples)
 * - [Code](https://atlassian.design/components/primitives/flex/code)
 *
 * @example
 * ```tsx
 * // eslint-disable-next-line @atlaskit/design-system/no-emotion-primitives -- to be migrated to @atlaskit/primitives/compiled – go/akcss
 * import { Flex, Box } from '@atlaskit/primitives'
 *
 * const Component = () => (
 *   <Flex direction="column">
 *     <Box padding="space.100" backgroundColor="neutral"></Box>
 *     <Box padding="space.100" backgroundColor="neutral"></Box>
 *   </Flex>
 * )
 * ```
 */ const Flex = /*#__PURE__*/ (0, _react.memo)(/*#__PURE__*/ (0, _react.forwardRef)(({ as: Component = 'div', role, alignItems, justifyContent, gap, columnGap, rowGap, children, testId, direction, wrap, xcss, id }, ref)=>{
    const resolvedStyles = (0, _xcss.parseXcss)(xcss);
    return /*#__PURE__*/ (0, _react1.jsx)(Component, {
        id: id,
        role: role,
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
        className: resolvedStyles.static,
        css: [
            baseStyles,
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
            gap && (0, _styleMapsPartial.spaceStylesMap).gap[gap],
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
            columnGap && (0, _styleMapsPartial.spaceStylesMap).columnGap[columnGap],
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
            rowGap && (0, _styleMapsPartial.spaceStylesMap).rowGap[rowGap],
            alignItems && alignItemsMap[alignItems],
            direction && flexDirectionMap[direction],
            justifyContent && justifyContentMap[justifyContent],
            wrap && flexWrapMap[wrap],
            ...resolvedStyles.emotion || []
        ],
        "data-testid": testId,
        ref: ref
    }, children);
}));
Flex.displayName = 'Flex';
exports.default = Flex;

},{"react":"ltHCL","@emotion/react":"cCAhJ","../xcss/style-maps.partial":"a7SYG","../xcss/xcss":"fMzqB","@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"1mttX":[function(require,module,exports,__globalThis) {
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _react = require("react");
// eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled -- Ignored via go/DSP-18766
var _react1 = require("@emotion/react");
var _xcss = require("../xcss/xcss");
var _flex = require("./flex");
var _flexDefault = parcelHelpers.interopDefault(_flex);
const flexGrowMap = {
    hug: (0, _xcss.xcss)({
        flexGrow: 0
    }),
    fill: (0, _xcss.xcss)({
        width: '100%',
        flexGrow: 1
    })
};
/**
 * __Stack__
 *
 * Stack is a primitive component based on flexbox that manages the block layout of direct children.
 *
 * @example
 * ```tsx
 *  <Stack>
 *    <Box padding="space.100" backgroundColor="neutral"></Box>
 *    <Box padding="space.100" backgroundColor="neutral"></Box>
 *  </Stack>
 * ```
 *
 */ const Stack = /*#__PURE__*/ (0, _react.memo)(/*#__PURE__*/ (0, _react.forwardRef)(({ as, alignInline: alignItems, alignBlock = 'stretch', spread, grow, space, children, testId, xcss, role, id }, ref)=>{
    const justifyContent = spread || alignBlock;
    // We're type coercing this as Compiled styles in an array isn't supported by the types
    // But the runtime accepts it none-the-wiser. We can remove this entire block and replace
    // it with cx(defaultStyles, focusRingStyles, xcssStyles) when we've moved away from Emotion.
    const styles = grow ? [
        flexGrowMap[grow],
        ...Array.isArray(xcss) ? xcss : [
            xcss
        ]
    ] : xcss;
    return /*#__PURE__*/ (0, _react1.jsx)((0, _flexDefault.default), {
        id: id,
        as: as,
        role: role,
        gap: space,
        direction: "column",
        alignItems: alignItems,
        justifyContent: justifyContent,
        // eslint-disable-next-line @atlaskit/design-system/consistent-css-prop-usage
        xcss: styles,
        testId: testId,
        ref: ref
    }, children);
}));
Stack.displayName = 'Stack';
exports.default = Stack;

},{"react":"ltHCL","@emotion/react":"cCAhJ","../xcss/xcss":"fMzqB","./flex":"iXW1t","@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"6Xtvi":[function(require,module,exports,__globalThis) {
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _react = require("react");
// eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled -- Ignored via go/DSP-18766
var _react1 = require("@emotion/react");
var _styleMapsPartial = require("../xcss/style-maps.partial");
var _xcss = require("../xcss/xcss");
const gridTemplateAreasVar = '--ds-grid--grid-template-areas';
const gridTemplateColumnsVar = '--ds-grid--grid-template-columns';
const gridTemplateRowsVar = '--ds-grid--grid-template-rows';
const justifyContentMap = {
    start: (0, _react1.css)({
        justifyContent: 'start'
    }),
    center: (0, _react1.css)({
        justifyContent: 'center'
    }),
    end: (0, _react1.css)({
        justifyContent: 'end'
    }),
    'space-between': (0, _react1.css)({
        justifyContent: 'space-between'
    }),
    'space-around': (0, _react1.css)({
        justifyContent: 'space-around'
    }),
    'space-evenly': (0, _react1.css)({
        justifyContent: 'space-evenly'
    }),
    stretch: (0, _react1.css)({
        justifyContent: 'stretch'
    })
};
const justifyItemsMap = {
    start: (0, _react1.css)({
        justifyItems: 'start'
    }),
    center: (0, _react1.css)({
        justifyItems: 'center'
    }),
    end: (0, _react1.css)({
        justifyItems: 'end'
    }),
    stretch: (0, _react1.css)({
        justifyItems: 'stretch'
    })
};
const alignContentMap = {
    start: (0, _react1.css)({
        alignContent: 'start'
    }),
    center: (0, _react1.css)({
        alignContent: 'center'
    }),
    end: (0, _react1.css)({
        alignContent: 'end'
    }),
    'space-between': (0, _react1.css)({
        alignContent: 'space-between'
    }),
    'space-around': (0, _react1.css)({
        alignContent: 'space-around'
    }),
    'space-evenly': (0, _react1.css)({
        alignContent: 'space-evenly'
    }),
    stretch: (0, _react1.css)({
        alignContent: 'stretch'
    })
};
const alignItemsMap = {
    start: (0, _react1.css)({
        alignItems: 'start'
    }),
    center: (0, _react1.css)({
        alignItems: 'center'
    }),
    baseline: (0, _react1.css)({
        alignItems: 'baseline'
    }),
    end: (0, _react1.css)({
        alignItems: 'end'
    })
};
const baseStyles = (0, _react1.css)({
    display: 'grid',
    boxSizing: 'border-box',
    gridTemplateAreas: `var(${gridTemplateAreasVar})`,
    gridTemplateColumns: `var(${gridTemplateColumnsVar})`,
    gridTemplateRows: `var(${gridTemplateRowsVar})`
});
const gridAutoFlowMap = {
    row: (0, _react1.css)({
        gridAutoFlow: 'row'
    }),
    column: (0, _react1.css)({
        gridAutoFlow: 'column'
    }),
    dense: (0, _react1.css)({
        gridAutoFlow: 'dense'
    }),
    'row dense': (0, _react1.css)({
        gridAutoFlow: 'row dense'
    }),
    'column dense': (0, _react1.css)({
        gridAutoFlow: 'column dense'
    })
};
/**
 * __Grid__
 *
 * `Grid` is a primitive component that implements the CSS Grid API.
 *
 * - [Examples](https://atlassian.design/components/primitives/grid/examples)
 * - [Code](https://atlassian.design/components/primitives/grid/code)
 *
 * @example
 * ```tsx
 * // eslint-disable-next-line @atlaskit/design-system/no-emotion-primitives -- to be migrated to @atlaskit/primitives/compiled – go/akcss
 * import { Grid, Box } from '@atlaskit/primitives'
 *
 * const Component = () => (
 *   <Grid gap="space.100" gridColumns="1fr 1fr">
 *     <Box padding="space.100" backgroundColor="neutral"></Box>
 *     <Box padding="space.100" backgroundColor="neutral"></Box>
 *   </Grid>
 * )
 * ```
 */ const Grid = /*#__PURE__*/ (0, _react.memo)(/*#__PURE__*/ (0, _react.forwardRef)(({ as, alignItems, alignContent, justifyContent, gap, columnGap, rowGap, children, id, role, testId, autoFlow, templateAreas: gridTemplateAreas, templateRows: gridTemplateRows, templateColumns: gridTemplateColumns, xcss }, ref)=>{
    const Component = as || 'div';
    const resolvedStyles = (0, _xcss.parseXcss)(xcss);
    /**
			 * We use CSS variables to allow for dynamic grid templates instead of dynamically setting to `props.style`
			 * This allows `props.xcss` to override them as `style={{ gridTemplateAreas }}` would have higher specificity.
			 *
			 * This must be reset to `initial` if `gridTemplateAreas` is not set, otherwise nested grids will break!
			 *
			 * NOTE: If we disallow `grid-template-areas` (etc) to be set via `props.xcss`, we can remove this.
			 */ const style = (0, _react.useMemo)(()=>({
            [gridTemplateAreasVar]: gridTemplateAreas ? gridTemplateAreas.map((str)=>`"${str}"`).join('\n') || 'initial' : 'initial',
            [gridTemplateColumnsVar]: gridTemplateColumns || 'initial',
            [gridTemplateRowsVar]: gridTemplateRows || 'initial'
        }), [
        gridTemplateAreas,
        gridTemplateColumns,
        gridTemplateRows
    ]);
    return /*#__PURE__*/ (0, _react1.jsx)(Component, {
        id: id,
        role: role,
        // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
        style: style,
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
        className: resolvedStyles.static,
        css: [
            baseStyles,
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
            gap && (0, _styleMapsPartial.spaceStylesMap).gap[gap],
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
            columnGap && (0, _styleMapsPartial.spaceStylesMap).columnGap[columnGap],
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
            rowGap && (0, _styleMapsPartial.spaceStylesMap).rowGap[rowGap],
            alignItems && alignItemsMap[alignItems],
            alignContent && alignContentMap[alignContent],
            justifyContent && justifyContentMap[justifyContent],
            autoFlow && gridAutoFlowMap[autoFlow],
            ...resolvedStyles.emotion || []
        ],
        "data-testid": testId,
        ref: ref
    }, children);
}));
Grid.displayName = 'Grid';
exports.default = Grid;

},{"react":"ltHCL","@emotion/react":"cCAhJ","../xcss/style-maps.partial":"a7SYG","../xcss/xcss":"fMzqB","@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"aWZMm":[function(require,module,exports,__globalThis) {
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _react = require("react");
// eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled -- Ignored via go/DSP-18766
var _react1 = require("@emotion/react");
var _tinyInvariant = require("tiny-invariant");
var _tinyInvariantDefault = parcelHelpers.interopDefault(_tinyInvariant);
var _hasTextAncestorContext = require("../utils/has-text-ancestor-context");
var _surfaceProvider = require("../utils/surface-provider");
var _styleMapsPartial = require("../xcss/style-maps.partial");
const asAllowlist = [
    'span',
    'p',
    'strong',
    'em'
];
// We're doing this because our CSS reset can add top margins to elements such as `p` which is totally insane.
// Long term we should remove those instances from the reset - it should be a reset to 0.
// For now, at least we know <Text> will be unaffected by this.
const resetStyles = (0, _react1.css)({
    margin: 0,
    overflowWrap: 'anywhere'
});
const strongStyles = (0, _react1.css)({
    fontWeight: "var(--ds-font-weight-bold, 653)"
});
const emStyles = (0, _react1.css)({
    fontStyle: 'italic'
});
const textAlignMap = {
    center: (0, _react1.css)({
        textAlign: 'center'
    }),
    end: (0, _react1.css)({
        textAlign: 'end'
    }),
    start: (0, _react1.css)({
        textAlign: 'start'
    })
};
const truncationStyles = (0, _react1.css)({
    display: '-webkit-box',
    overflow: 'hidden',
    WebkitBoxOrient: 'vertical'
});
const wordBreakMap = {
    breakAll: (0, _react1.css)({
        wordBreak: 'break-all'
    })
};
/**
 * Custom hook designed to abstract the parsing of the color props and make it clearer in the future how color is reconciled between themes and tokens.
 */ const useColor = (colorProp, hasTextAncestor)=>{
    const surface = (0, _surfaceProvider.useSurface)();
    if (colorProp === 'inherit') return undefined;
    if (colorProp) return colorProp;
    if (hasTextAncestor) return undefined;
    if ((0, _styleMapsPartial.inverseColorMap).hasOwnProperty(surface)) return (0, _styleMapsPartial.inverseColorMap)[surface];
    return 'color.text';
};
/**
 * __Text__
 *
 * Text is a primitive component that has the Atlassian Design System's design guidelines baked in.
 * This includes considerations for text attributes such as color, font size, font weight, and line height.
 * It renders a `span` by default.
 *
 * @internal
 */ const Text = /*#__PURE__*/ (0, _react.forwardRef)(({ as: Component = 'span', color: colorProp, align, testId, id, size, weight, maxLines, children }, ref)=>{
    (0, _tinyInvariantDefault.default)(asAllowlist.includes(Component), `@atlaskit/primitives: Text received an invalid "as" value of "${Component}"`);
    const hasTextAncestor = (0, _hasTextAncestorContext.useHasTextAncestor)();
    const color = useColor(colorProp, hasTextAncestor);
    if (!size && !hasTextAncestor) size = 'medium';
    const component = /*#__PURE__*/ (0, _react1.jsx)(Component, {
        ref: ref,
        css: [
            resetStyles,
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values
            size && (0, _styleMapsPartial.textSizeStylesMap)[size],
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values
            color && (0, _styleMapsPartial.textColorStylesMap)[color],
            maxLines && truncationStyles,
            maxLines === 1 && wordBreakMap.breakAll,
            align && textAlignMap[align],
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values
            weight && (0, _styleMapsPartial.textWeightStylesMap)[weight],
            Component === 'em' && emStyles,
            Component === 'strong' && strongStyles
        ],
        style: {
            WebkitLineClamp: maxLines
        },
        "data-testid": testId,
        id: id
    }, children);
    return hasTextAncestor ? // no need to re-apply context if the text is already wrapped
    component : /*#__PURE__*/ (0, _react1.jsx)((0, _hasTextAncestorContext.HasTextAncestorProvider), {
        value: true
    }, component);
});
exports.default = Text;

},{"react":"ltHCL","@emotion/react":"cCAhJ","tiny-invariant":"9VWeJ","../utils/has-text-ancestor-context":"9Iq5i","../utils/surface-provider":"1kmKD","../xcss/style-maps.partial":"a7SYG","@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"ac3oA":[function(require,module,exports,__globalThis) {
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _objectSpread = require("@swc/helpers/_/_object_spread");
var _objectSpreadProps = require("@swc/helpers/_/_object_spread_props");
var _objectWithoutProperties = require("@swc/helpers/_/_object_without_properties");
var _react = require("react");
// eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled, @typescript-eslint/consistent-type-imports
var _react1 = require("@emotion/react");
var _tinyInvariant = require("tiny-invariant");
var _tinyInvariantDefault = parcelHelpers.interopDefault(_tinyInvariant);
var _analyticsNext = require("@atlaskit/analytics-next");
var _appProvider = require("@atlaskit/app-provider");
var _noop = require("@atlaskit/ds-lib/noop");
var _noopDefault = parcelHelpers.interopDefault(_noop);
var _useId = require("@atlaskit/ds-lib/use-id");
var _interactionContext = require("@atlaskit/interaction-context");
var _interactionContextDefault = parcelHelpers.interopDefault(_interactionContext);
var _visuallyHidden = require("@atlaskit/visually-hidden");
var _visuallyHiddenDefault = parcelHelpers.interopDefault(_visuallyHidden);
var _styleMapsPartial = require("../xcss/style-maps.partial");
var _xcss = require("../xcss/xcss");
// TODO: duplicates FocusRing styles from `@atlaskit/focus-ring`.
const focusRingStyles = (0, _react1.css)({
    '&:focus, &:focus-visible': {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values
        outlineColor: (0, _styleMapsPartial.borderColorMap)['color.border.focused'],
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values
        outlineOffset: (0, _styleMapsPartial.positiveSpaceMap)['space.025'],
        outlineStyle: 'solid',
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values
        outlineWidth: (0, _styleMapsPartial.borderWidthMap)['border.width.focused']
    },
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-selectors
    '&:focus:not(:focus-visible)': {
        outline: 'none'
    },
    '@media screen and (forced-colors: active), screen and (-ms-high-contrast: active)': {
        '&:focus-visible': {
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values
            outline: `${(0, _styleMapsPartial.borderWidthMap)['border.width']} solid`
        }
    }
});
const baseStyles = (0, _react1.css)({
    boxSizing: 'border-box',
    textDecoration: 'underline'
});
const positionStyles = (0, _react1.css)({
    position: 'relative'
});
const IS_EXTERNAL_LINK_REGEX = /^(?:(http|https):\/\/)/;
const IS_NON_HTTP_BASED = /^(((mailto|tel|sms|blob):)|(#))/;
// Comma is added here to add a slight pause between announcing the anchor label and "opens in new window"
const OPENS_NEW_WINDOW_LABEL = '(opens new window)';
/**
 * __Anchor__
 *
 * A primitive for building custom anchor links.
 *
 * - [Examples](https://atlassian.design/components/primitives/anchor/examples)
 * - [Code](https://atlassian.design/components/primitives/anchor/code)
 * - [Usage](https://atlassian.design/components/primitives/anchor/usage)
 */ const AnchorNoRef = (_param, ref)=>{
    var { href, children, backgroundColor, newWindowLabel, padding, paddingBlock, paddingBlockStart, paddingBlockEnd, paddingInline, paddingInlineStart, paddingInlineEnd, onClick: providedOnClick = (0, _noopDefault.default), interactionName, componentName, analyticsContext, 'aria-label': ariaLabel, 'aria-labelledby': ariaLabelledBy, style, target, testId, xcss } = _param, htmlAttributes = (0, _objectWithoutProperties._)(_param, [
        "href",
        "children",
        "backgroundColor",
        "newWindowLabel",
        "padding",
        "paddingBlock",
        "paddingBlockStart",
        "paddingBlockEnd",
        "paddingInline",
        "paddingInlineStart",
        "paddingInlineEnd",
        "onClick",
        "interactionName",
        "componentName",
        "analyticsContext",
        'aria-label',
        'aria-labelledby',
        "style",
        "target",
        "testId",
        "xcss"
    ]);
    const interactionContext = (0, _react.useContext)((0, _interactionContextDefault.default));
    const handleClick = (0, _react.useCallback)((e, analyticsEvent)=>{
        interactionContext && interactionContext.tracePress(interactionName, e.timeStamp);
        providedOnClick(e, analyticsEvent);
    }, [
        providedOnClick,
        interactionContext,
        interactionName
    ]);
    const opensNewWindowLabelId = (0, _useId.useId)();
    const onClick = (0, _analyticsNext.usePlatformLeafEventHandler)({
        fn: handleClick,
        action: 'clicked',
        componentName: componentName || 'Anchor',
        packageName: "@af/atlassian-studio",
        packageVersion: "0.16.1",
        analyticsData: analyticsContext,
        actionSubject: 'link'
    });
    // This is to remove className from safeHtmlAttributes
    // @ts-expect-error className doesn't exist in the prop definition but we want to ensure it cannot be applied even if types are bypassed
    const { className: _spreadClass } = htmlAttributes, safeHtmlAttributes = (0, _objectWithoutProperties._)(htmlAttributes, [
        "className"
    ]);
    const resolvedStyles = (0, _xcss.parseXcss)(xcss);
    const RouterLink = (0, _appProvider.useRouterLink)();
    const isExternal = typeof href === 'string' && IS_EXTERNAL_LINK_REGEX.test(href);
    const isNonHttpBased = typeof href === 'string' && IS_NON_HTTP_BASED.test(href);
    /**
	 * Renders a router link if:
	 *
	 * - a link component is set in the app provider
	 * - it's not an external link (starting with `http://` or `https://`)
	 * - it's not a non-HTTP-based link (e.g. emails, phone numbers, hash links etc.).
	 */ const isRouterLink = RouterLink && !isExternal && !isNonHttpBased;
    const hrefObjectUsedWithoutRouterLink = RouterLink === undefined && typeof href === 'object';
    (0, _tinyInvariantDefault.default)(!hrefObjectUsedWithoutRouterLink, `@atlaskit/primitives: Anchor primitive cannot pass an object to 'href' unless a router link is configured in the AppProvider`);
    const Component = isRouterLink ? RouterLink : 'a';
    return /*#__PURE__*/ (0, _react1.jsx)(Component, (0, _objectSpreadProps._)((0, _objectSpread._)({
        style: style,
        ref: ref,
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
        className: resolvedStyles.static
    }, safeHtmlAttributes), {
        // @ts-expect-error
        href: !isRouterLink && typeof href !== 'string' ? undefined : href,
        target: target,
        onClick: onClick,
        "aria-label": ariaLabel && target === '_blank' && !ariaLabelledBy ? `${ariaLabel} , ${newWindowLabel ? newWindowLabel : OPENS_NEW_WINDOW_LABEL}` : ariaLabel,
        "aria-labelledby": ariaLabelledBy && target === '_blank' ? `${ariaLabelledBy} ${opensNewWindowLabelId}` : ariaLabelledBy,
        css: [
            baseStyles,
            positionStyles,
            focusRingStyles,
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
            backgroundColor && (0, _styleMapsPartial.backgroundColorStylesMap)[backgroundColor],
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
            padding && (0, _styleMapsPartial.paddingStylesMap).padding[padding],
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
            paddingBlock && (0, _styleMapsPartial.paddingStylesMap).paddingBlock[paddingBlock],
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
            paddingBlockStart && (0, _styleMapsPartial.paddingStylesMap).paddingBlockStart[paddingBlockStart],
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
            paddingBlockEnd && (0, _styleMapsPartial.paddingStylesMap).paddingBlockEnd[paddingBlockEnd],
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
            paddingInline && (0, _styleMapsPartial.paddingStylesMap).paddingInline[paddingInline],
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
            paddingInlineStart && (0, _styleMapsPartial.paddingStylesMap).paddingInlineStart[paddingInlineStart],
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
            paddingInlineEnd && (0, _styleMapsPartial.paddingStylesMap).paddingInlineEnd[paddingInlineEnd],
            ...resolvedStyles.emotion || []
        ],
        "data-testid": testId,
        "data-is-router-link": testId ? isRouterLink ? 'true' : 'false' : undefined
    }), children, target === '_blank' && (children && !ariaLabel && !ariaLabelledBy || ariaLabelledBy) && /*#__PURE__*/ (0, _react1.jsx)((0, _visuallyHiddenDefault.default), {
        id: opensNewWindowLabelId
    }, `, ${newWindowLabel ? newWindowLabel : OPENS_NEW_WINDOW_LABEL}`));
};
// Workarounds to support generic types with forwardRef
/**
 * __Anchor__
 *
 * Anchor is a primitive for building custom anchor links. It's a wrapper around the HTML `<a>` element that provides a consistent API for handling client-side routing and Atlassian Design System styling.
 *
 * - [Examples](https://atlassian.design/components/primitives/anchor/examples)
 * - [Code](https://atlassian.design/components/primitives/anchor/code)
 * - [Usage](https://atlassian.design/components/primitives/anchor/usage)
 */ const Anchor = /*#__PURE__*/ (0, _react.forwardRef)(AnchorNoRef);
exports.default = Anchor;

},{"@swc/helpers/_/_object_spread":"9gdrV","@swc/helpers/_/_object_spread_props":"kANqQ","@swc/helpers/_/_object_without_properties":"6HqIM","react":"ltHCL","@emotion/react":"cCAhJ","tiny-invariant":"9VWeJ","@atlaskit/analytics-next":"6PLie","@atlaskit/app-provider":"hIy26","@atlaskit/ds-lib/noop":"faKzG","@atlaskit/ds-lib/use-id":"9jWCD","@atlaskit/interaction-context":"18HT9","@atlaskit/visually-hidden":"gKDx1","../xcss/style-maps.partial":"a7SYG","../xcss/xcss":"fMzqB","@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"9Ve4N":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "media", ()=>(0, _mediaHelper.media));
parcelHelpers.export(exports, "UNSAFE_media", ()=>(0, _mediaHelper.UNSAFE_media));
parcelHelpers.export(exports, "UNSAFE_buildAboveMediaQueryCSS", ()=>(0, _buildMediaQueryCss.UNSAFE_buildAboveMediaQueryCSS));
parcelHelpers.export(exports, "UNSAFE_BREAKPOINTS_ORDERED_LIST", ()=>(0, _constants.UNSAFE_BREAKPOINTS_ORDERED_LIST));
parcelHelpers.export(exports, "UNSAFE_BREAKPOINTS_CONFIG", ()=>(0, _constants.UNSAFE_BREAKPOINTS_CONFIG));
parcelHelpers.export(exports, "UNSAFE_useMediaQuery", ()=>(0, _useMediaQuery.UNSAFE_useMediaQuery));
parcelHelpers.export(exports, "Show", ()=>(0, _show.Show));
parcelHelpers.export(exports, "Hide", ()=>(0, _hide.Hide));
var _mediaHelper = require("./media-helper");
var _buildMediaQueryCss = require("./build-media-query-css");
var _constants = require("./constants");
var _useMediaQuery = require("./use-media-query");
var _show = require("./show");
var _hide = require("./hide");

},{"./media-helper":"2rVT9","./build-media-query-css":false,"./constants":false,"./use-media-query":"kbnUq","./show":"kRH3l","./hide":"4Wy9i","@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"2rVT9":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "media", ()=>(0, _media.media));
parcelHelpers.export(exports, "UNSAFE_media", ()=>UNSAFE_media);
var _media = require("./media");
const UNSAFE_media = (0, _media.media);

},{"./media":"e0QSz","@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"e0QSz":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "media", ()=>media);
const media = {
    above: {
        xxs: '@media all',
        xs: '@media (min-width: 30rem)',
        sm: '@media (min-width: 48rem)',
        md: '@media (min-width: 64rem)',
        lg: '@media (min-width: 90rem)',
        xl: '@media (min-width: 110.5rem)'
    },
    only: {
        xxs: '@media (min-width: 0rem) and (max-width: 29.99rem)',
        xs: '@media (min-width: 30rem) and (max-width: 47.99rem)',
        sm: '@media (min-width: 48rem) and (max-width: 63.99rem)',
        md: '@media (min-width: 64rem) and (max-width: 89.99rem)',
        lg: '@media (min-width: 90rem) and (max-width: 110.49rem)',
        xl: '@media (min-width: 110.5rem)'
    },
    below: {
        xs: '@media not all and (min-width: 30rem)',
        sm: '@media not all and (min-width: 48rem)',
        md: '@media not all and (min-width: 64rem)',
        lg: '@media not all and (min-width: 90rem)',
        xl: '@media not all and (min-width: 110.5rem)'
    }
};

},{"@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"2I2yN":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "UNSAFE_BREAKPOINTS_CONFIG", ()=>UNSAFE_BREAKPOINTS_CONFIG);
parcelHelpers.export(exports, "UNSAFE_BREAKPOINTS_ORDERED_LIST", ()=>UNSAFE_BREAKPOINTS_ORDERED_LIST);
parcelHelpers.export(exports, "SMALLEST_BREAKPOINT", ()=>SMALLEST_BREAKPOINT);
const UNSAFE_BREAKPOINTS_CONFIG = {
    // mobile
    xxs: {
        gridItemGutter: "var(--ds-space-200, 16px)",
        gridMargin: "var(--ds-space-200, 16px)",
        min: '0rem',
        max: '29.99rem'
    },
    // phablet
    xs: {
        gridItemGutter: "var(--ds-space-200, 16px)",
        gridMargin: "var(--ds-space-200, 16px)",
        min: '30rem',
        max: '47.99rem'
    },
    // tablet
    sm: {
        gridItemGutter: "var(--ds-space-200, 16px)",
        gridMargin: "var(--ds-space-300, 24px)",
        min: '48rem',
        max: '63.99rem'
    },
    // laptop desktop
    md: {
        gridItemGutter: "var(--ds-space-300, 24px)",
        gridMargin: "var(--ds-space-400, 32px)",
        min: '64rem',
        max: '89.99rem'
    },
    // monitor
    lg: {
        gridItemGutter: "var(--ds-space-400, 32px)",
        gridMargin: "var(--ds-space-400, 32px)",
        min: '90rem',
        max: '110.49rem'
    },
    // large high res
    xl: {
        gridItemGutter: "var(--ds-space-400, 32px)",
        gridMargin: "var(--ds-space-500, 40px)",
        min: '110.5rem',
        max: null
    }
}; //TODO: This `as const` should really be `satisfies Record<Breakpoint, BreakpointConfig>`, but that's not possible in our shipped TypeScript version yet.
const UNSAFE_BREAKPOINTS_ORDERED_LIST = Object.keys(UNSAFE_BREAKPOINTS_CONFIG);
const SMALLEST_BREAKPOINT = UNSAFE_BREAKPOINTS_ORDERED_LIST[0];

},{"@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"kbnUq":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "UNSAFE_useMediaQuery", ()=>UNSAFE_useMediaQuery);
var _react = require("react");
var _bindEventListener = require("bind-event-listener");
var _useLayoutEffect = require("@atlaskit/ds-lib/use-layout-effect");
var _mediaHelper = require("./media-helper");
var _window_matchMedia, _window, _window_matchMedia1, _window1, _window_matchMedia2, _window2, _window_matchMedia3, _window3, _window_matchMedia4, _window4, _window_matchMedia5, _window5, _window_matchMedia6, _window6, _window_matchMedia7, _window7, _window_matchMedia8, _window8, _window_matchMedia9, _window9, _window_matchMedia10, _window10;
const queries = {
    'above.xxs': typeof window === 'undefined' ? undefined : (_window = window) === null || _window === void 0 ? void 0 : (_window_matchMedia = _window.matchMedia) === null || _window_matchMedia === void 0 ? void 0 : _window_matchMedia.call(_window, (0, _mediaHelper.UNSAFE_media).above.xxs.replace('@media ', '').trim()),
    'above.xs': typeof window === 'undefined' ? undefined : (_window1 = window) === null || _window1 === void 0 ? void 0 : (_window_matchMedia1 = _window1.matchMedia) === null || _window_matchMedia1 === void 0 ? void 0 : _window_matchMedia1.call(_window1, (0, _mediaHelper.UNSAFE_media).above.xs.replace('@media ', '').trim()),
    'above.sm': typeof window === 'undefined' ? undefined : (_window2 = window) === null || _window2 === void 0 ? void 0 : (_window_matchMedia2 = _window2.matchMedia) === null || _window_matchMedia2 === void 0 ? void 0 : _window_matchMedia2.call(_window2, (0, _mediaHelper.UNSAFE_media).above.sm.replace('@media ', '').trim()),
    'above.md': typeof window === 'undefined' ? undefined : (_window3 = window) === null || _window3 === void 0 ? void 0 : (_window_matchMedia3 = _window3.matchMedia) === null || _window_matchMedia3 === void 0 ? void 0 : _window_matchMedia3.call(_window3, (0, _mediaHelper.UNSAFE_media).above.md.replace('@media ', '').trim()),
    'above.lg': typeof window === 'undefined' ? undefined : (_window4 = window) === null || _window4 === void 0 ? void 0 : (_window_matchMedia4 = _window4.matchMedia) === null || _window_matchMedia4 === void 0 ? void 0 : _window_matchMedia4.call(_window4, (0, _mediaHelper.UNSAFE_media).above.lg.replace('@media ', '').trim()),
    'above.xl': typeof window === 'undefined' ? undefined : (_window5 = window) === null || _window5 === void 0 ? void 0 : (_window_matchMedia5 = _window5.matchMedia) === null || _window_matchMedia5 === void 0 ? void 0 : _window_matchMedia5.call(_window5, (0, _mediaHelper.UNSAFE_media).above.xl.replace('@media ', '').trim()),
    'below.xs': typeof window === 'undefined' ? undefined : (_window6 = window) === null || _window6 === void 0 ? void 0 : (_window_matchMedia6 = _window6.matchMedia) === null || _window_matchMedia6 === void 0 ? void 0 : _window_matchMedia6.call(_window6, (0, _mediaHelper.UNSAFE_media).below.xs.replace('@media ', '').trim()),
    'below.sm': typeof window === 'undefined' ? undefined : (_window7 = window) === null || _window7 === void 0 ? void 0 : (_window_matchMedia7 = _window7.matchMedia) === null || _window_matchMedia7 === void 0 ? void 0 : _window_matchMedia7.call(_window7, (0, _mediaHelper.UNSAFE_media).below.sm.replace('@media ', '').trim()),
    'below.md': typeof window === 'undefined' ? undefined : (_window8 = window) === null || _window8 === void 0 ? void 0 : (_window_matchMedia8 = _window8.matchMedia) === null || _window_matchMedia8 === void 0 ? void 0 : _window_matchMedia8.call(_window8, (0, _mediaHelper.UNSAFE_media).below.md.replace('@media ', '').trim()),
    'below.lg': typeof window === 'undefined' ? undefined : (_window9 = window) === null || _window9 === void 0 ? void 0 : (_window_matchMedia9 = _window9.matchMedia) === null || _window_matchMedia9 === void 0 ? void 0 : _window_matchMedia9.call(_window9, (0, _mediaHelper.UNSAFE_media).below.lg.replace('@media ', '').trim()),
    'below.xl': typeof window === 'undefined' ? undefined : (_window10 = window) === null || _window10 === void 0 ? void 0 : (_window_matchMedia10 = _window10.matchMedia) === null || _window_matchMedia10 === void 0 ? void 0 : _window_matchMedia10.call(_window10, (0, _mediaHelper.UNSAFE_media).below.xl.replace('@media ', '').trim())
};
const UNSAFE_useMediaQuery = (queryString, listener)=>{
    const listenerRef = (0, _react.useRef)(listener);
    (0, _react.useEffect)(()=>{
        // Bind the listener if changed so it's called on the next change event; no guarantee on timing.
        listenerRef.current = listener;
    }, [
        listener
    ]);
    /**
	 * We explicitly only react to boolean changes for binding our listener
	 * Changes to the functional reference are ignored.
	 */ const hasListener = !!listener;
    /**
	 * The `matchMedia(…)` return value for our breakpoint query.
	 */ const mq = queries[queryString];
    (0, _useLayoutEffect.useLayoutEffect)(()=>{
        listenerRef.current = listener; // Bind the listener now in case the `useEffect` hasn't fired above yet
        if (!mq || !hasListener || !listenerRef.current) return;
        return (0, _bindEventListener.bind)(mq, {
            type: 'change',
            listener: (event)=>{
                // We explicitly call the current version of the function
                return listenerRef.current(event);
            }
        });
    }, // eslint-disable-next-line react-hooks/exhaustive-deps -- explicitly do not trigger the effect on `listener` reference change, only on a boolean representation of it.
    [
        mq,
        hasListener
    ]);
    return mq || null;
};

},{"react":"ltHCL","bind-event-listener":"bjeUU","@atlaskit/ds-lib/use-layout-effect":"8gCVt","./media-helper":"2rVT9","@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"8gCVt":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "useLayoutEffect", ()=>useLayoutEffect);
var _react = require("react");
const useLayoutEffect = typeof window === 'undefined' ? (0, _react.useEffect) : (0, _react.useLayoutEffect);

},{"react":"ltHCL","@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"kRH3l":[function(require,module,exports,__globalThis) {
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "Show", ()=>Show);
// eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled -- Ignored via go/DSP-18766
var _react = require("@emotion/react");
var _xcss = require("../xcss/xcss");
var _unsafeBuildAboveMediaQueryCss = require("./unsafe-build-above-media-query-css");
var _unsafeBuildBelowMediaQueryCss = require("./unsafe-build-below-media-query-css");
const showAboveQueries = (0, _unsafeBuildAboveMediaQueryCss.UNSAFE_buildAboveMediaQueryCSS)({
    display: 'revert'
});
const showBelowQueries = (0, _unsafeBuildBelowMediaQueryCss.UNSAFE_buildBelowMediaQueryCSS)({
    display: 'revert'
});
const defaultHiddenStyles = (0, _react.css)({
    display: 'none'
});
const Show = ({ above, below, children, as: AsElement = 'div', xcss })=>{
    const resolvedStyles = (0, _xcss.parseXcss)(xcss);
    return /*#__PURE__*/ (0, _react.jsx)(AsElement, {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
        className: resolvedStyles.static,
        css: [
            defaultHiddenStyles,
            above && showAboveQueries[above],
            below && showBelowQueries[below],
            ...resolvedStyles.emotion || []
        ]
    }, children);
};

},{"@emotion/react":"cCAhJ","../xcss/xcss":"fMzqB","./unsafe-build-above-media-query-css":"66LgX","./unsafe-build-below-media-query-css":"bVLOK","@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"66LgX":[function(require,module,exports,__globalThis) {
// eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled
var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "UNSAFE_buildAboveMediaQueryCSS", ()=>UNSAFE_buildAboveMediaQueryCSS);
var _objectSpread = require("@swc/helpers/_/_object_spread");
var _objectSpreadProps = require("@swc/helpers/_/_object_spread_props");
var _react = require("@emotion/react");
var _constants = require("./constants");
var _media = require("./media");
const UNSAFE_buildAboveMediaQueryCSS = (/**
	 * The desired CSS to place inside of the media query.
	 * This can either be a css object directly or functional with `breakpoint` as the arg to return a css object.
	 */ input)=>{
    return (0, _constants.UNSAFE_BREAKPOINTS_ORDERED_LIST).reduce((acc, breakpoint)=>(0, _objectSpreadProps._)((0, _objectSpread._)({}, acc), {
            [breakpoint]: (0, _react.css)({
                // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
                [(0, _media.media).above[breakpoint]]: typeof input === 'function' ? input(breakpoint) : input
            })
        }), {});
};

},{"@swc/helpers/_/_object_spread":"9gdrV","@swc/helpers/_/_object_spread_props":"kANqQ","@emotion/react":"cCAhJ","./constants":"2I2yN","./media":"e0QSz","@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"bVLOK":[function(require,module,exports,__globalThis) {
// eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled
var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "UNSAFE_buildBelowMediaQueryCSS", ()=>UNSAFE_buildBelowMediaQueryCSS);
var _objectSpread = require("@swc/helpers/_/_object_spread");
var _objectSpreadProps = require("@swc/helpers/_/_object_spread_props");
var _react = require("@emotion/react");
var _constants = require("./constants");
var _mediaHelper = require("./media-helper");
const UNSAFE_buildBelowMediaQueryCSS = (/**
	 * The desired CSS to place inside of the media query.
	 * This can either be a css object directly or functional with `breakpoint` as the arg to return a css object.
	 */ input)=>{
    return (0, _constants.UNSAFE_BREAKPOINTS_ORDERED_LIST).reduce((acc, breakpoint)=>{
        if (breakpoint === 'xxs') return acc;
        return (0, _objectSpreadProps._)((0, _objectSpread._)({}, acc), {
            [breakpoint]: (0, _react.css)({
                // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
                [(0, _mediaHelper.UNSAFE_media).below[breakpoint]]: typeof input === 'function' ? input(breakpoint) : input
            })
        });
    }, {});
};

},{"@swc/helpers/_/_object_spread":"9gdrV","@swc/helpers/_/_object_spread_props":"kANqQ","@emotion/react":"cCAhJ","./constants":"2I2yN","./media-helper":"2rVT9","@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"4Wy9i":[function(require,module,exports,__globalThis) {
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "Hide", ()=>Hide);
// eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled, @typescript-eslint/consistent-type-imports
var _react = require("@emotion/react");
var _xcss = require("../xcss/xcss");
var _unsafeBuildAboveMediaQueryCss = require("./unsafe-build-above-media-query-css");
var _unsafeBuildBelowMediaQueryCss = require("./unsafe-build-below-media-query-css");
const hideAboveQueries = (0, _unsafeBuildAboveMediaQueryCss.UNSAFE_buildAboveMediaQueryCSS)({
    display: 'none'
});
const hideBelowQueries = (0, _unsafeBuildBelowMediaQueryCss.UNSAFE_buildBelowMediaQueryCSS)({
    display: 'none'
});
const Hide = ({ above, below, children, as: AsElement = 'div', xcss })=>{
    const resolvedStyles = (0, _xcss.parseXcss)(xcss);
    return /*#__PURE__*/ (0, _react.jsx)(AsElement, {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
        className: resolvedStyles.static,
        css: [
            above && hideAboveQueries[above],
            below && hideBelowQueries[below],
            ...resolvedStyles.emotion || []
        ]
    }, children);
};

},{"@emotion/react":"cCAhJ","../xcss/xcss":"fMzqB","./unsafe-build-above-media-query-css":"66LgX","./unsafe-build-below-media-query-css":"bVLOK","@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"ckVuK":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "TBody", ()=>TBody);
var _objectSpread = require("@swc/helpers/_/_object_spread");
var _objectSpreadProps = require("@swc/helpers/_/_object_spread_props");
var _objectWithoutProperties = require("@swc/helpers/_/_object_without_properties");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _compiled = require("@atlaskit/primitives/compiled");
const TBody = /*#__PURE__*/ (0, _react.forwardRef)((_param, ref)=>{
    var { children } = _param, props = (0, _objectWithoutProperties._)(_param, [
        "children"
    ]);
    return /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _compiled.Box), (0, _objectSpreadProps._)((0, _objectSpread._)({
        as: "tbody"
    }, props), {
        ref: ref
    }), children);
});

},{"@swc/helpers/_/_object_spread":"9gdrV","@swc/helpers/_/_object_spread_props":"kANqQ","@swc/helpers/_/_object_without_properties":"6HqIM","react":"ltHCL","@atlaskit/primitives/compiled":"hDay7","@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"c8E9x":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "TD", ()=>TD);
var _objectSpread = require("@swc/helpers/_/_object_spread");
var _objectSpreadProps = require("@swc/helpers/_/_object_spread_props");
var _objectWithoutProperties = require("@swc/helpers/_/_object_without_properties");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _baseCell = require("./base-cell");
const TD = /*#__PURE__*/ (0, _react.forwardRef)((_param, ref)=>{
    var { testId } = _param, props = (0, _objectWithoutProperties._)(_param, [
        "testId"
    ]);
    return /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _baseCell.BaseCell), (0, _objectSpreadProps._)((0, _objectSpread._)({
        as: "td",
        testId: testId
    }, props), {
        ref: ref
    }));
});

},{"@swc/helpers/_/_object_spread":"9gdrV","@swc/helpers/_/_object_spread_props":"kANqQ","@swc/helpers/_/_object_without_properties":"6HqIM","react":"ltHCL","./base-cell":"j78BC","@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"j78BC":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "BaseCell", ()=>BaseCell);
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
// eslint-disable-next-line @atlaskit/design-system/no-emotion-primitives -- to be migrated to @atlaskit/primitives/compiled – go/akcss
var _primitives = require("@atlaskit/primitives");
const alignLeftStyles = (0, _primitives.xcss)({
    textAlign: 'left'
});
const alignCenterStyles = (0, _primitives.xcss)({
    textAlign: 'center'
});
const alignRightStyles = (0, _primitives.xcss)({
    textAlign: 'right'
});
const focusOutline = (0, _primitives.xcss)({
    ':focus-visible': {
        //@ts-expect-error This is a hack to get better focus styles
        boxShadow: `0 0 0 2px ${"var(--ds-border-focused, #4688EC)"} inset`,
        outline: 'none'
    },
    ':focus': {
        //@ts-expect-error This is a hack to get better focus styles
        boxShadow: `0 0 0 2px ${"var(--ds-border-focused, #4688EC)"} inset`
    }
});
const alignMap = {
    text: alignLeftStyles,
    number: alignRightStyles,
    icon: alignCenterStyles
};
const BaseCell = /*#__PURE__*/ (0, _react.forwardRef)(({ testId, as, xcss: customXcss, children, align = 'text', display, paddingBlock = 'space.100', paddingInline = 'space.100', backgroundColor, scope, width, sortDirection, colSpan, onMouseEnter, onMouseLeave, tabIndex, onKeyDown }, ref)=>{
    return /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _primitives.Box), {
        ref: ref,
        scope: scope,
        xcss: [
            alignMap[align],
            // eslint-disable-next-line @atlaskit/design-system/consistent-css-prop-usage, @atlaskit/ui-styling-standard/no-unsafe-values, @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
            (0, _primitives.xcss)({
                width
            }),
            tabIndex === 0 && focusOutline,
            customXcss
        ],
        backgroundColor: backgroundColor,
        paddingBlock: paddingBlock,
        paddingInline: paddingInline,
        as: as,
        //@ts-expect-error This is a hack to get around Box's typing not allowing 'unset' or 'table-cell'
        display: display !== null && display !== void 0 ? display : 'unset',
        testId: testId,
        "aria-sort": sortDirection,
        colSpan: colSpan,
        onMouseEnter: onMouseEnter,
        onMouseLeave: onMouseLeave,
        tabIndex: tabIndex,
        onKeyDown: onKeyDown
    }, children);
});

},{"react":"ltHCL","@atlaskit/primitives":"3S6Im","@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"58kIs":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "TH", ()=>TH);
var _objectSpread = require("@swc/helpers/_/_object_spread");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _baseCell = require("./base-cell");
const TH = /*#__PURE__*/ (0, _react.forwardRef)((props, ref)=>{
    return /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _baseCell.BaseCell), (0, _objectSpread._)({
        as: "th",
        ref: ref
    }, props));
});

},{"@swc/helpers/_/_object_spread":"9gdrV","react":"ltHCL","./base-cell":"j78BC","@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"jhq5N":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "THead", ()=>THead);
var _objectSpread = require("@swc/helpers/_/_object_spread");
var _objectSpreadProps = require("@swc/helpers/_/_object_spread_props");
var _objectWithoutProperties = require("@swc/helpers/_/_object_without_properties");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
// eslint-disable-next-line @atlaskit/design-system/no-emotion-primitives -- to be migrated to @atlaskit/primitives/compiled – go/akcss
var _primitives = require("@atlaskit/primitives");
const THead = /*#__PURE__*/ (0, _react.forwardRef)((_param, ref)=>{
    var { children } = _param, props = (0, _objectWithoutProperties._)(_param, [
        "children"
    ]);
    return /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _primitives.Box), (0, _objectSpreadProps._)((0, _objectSpread._)({
        as: "thead"
    }, props), {
        ref: ref
    }), children);
});

},{"@swc/helpers/_/_object_spread":"9gdrV","@swc/helpers/_/_object_spread_props":"kANqQ","@swc/helpers/_/_object_without_properties":"6HqIM","react":"ltHCL","@atlaskit/primitives":"3S6Im","@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"5MlIx":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "TR", ()=>TR);
var _objectSpread = require("@swc/helpers/_/_object_spread");
var _objectWithoutProperties = require("@swc/helpers/_/_object_without_properties");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
// eslint-disable-next-line @atlaskit/design-system/no-emotion-primitives -- to be migrated to @atlaskit/primitives/compiled – go/akcss
var _primitives = require("@atlaskit/primitives");
const TR = /*#__PURE__*/ (0, _react.forwardRef)((_param, ref)=>{
    var { isSelected } = _param, props = (0, _objectWithoutProperties._)(_param, [
        "isSelected"
    ]);
    return /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _primitives.Box), (0, _objectSpread._)({
        as: "tr",
        tabIndex: -1,
        "aria-selected": isSelected,
        ref: ref
    }, props));
});

},{"@swc/helpers/_/_object_spread":"9gdrV","@swc/helpers/_/_object_without_properties":"6HqIM","react":"ltHCL","@atlaskit/primitives":"3S6Im","@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"4yZqG":[function(require,module,exports,__globalThis) {
/**
 * useCharlieTable is a custom hook that returns the table state and the table actions
 * similar to the tanstack table hook. The idea here is to provide similar functionality
 * while allowing the functionality to be upstreams back into the @atlaskit/table
 * if they find it acceptable.
 */ var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "defaultColumnWidth", ()=>defaultColumnWidth);
parcelHelpers.export(exports, "SORT_ASC", ()=>SORT_ASC);
parcelHelpers.export(exports, "SORT_DESC", ()=>SORT_DESC);
parcelHelpers.export(exports, "useCharlieTable", ()=>useCharlieTable);
var _objectSpread = require("@swc/helpers/_/_object_spread");
var _objectSpreadProps = require("@swc/helpers/_/_object_spread_props");
var _react = require("react");
var _getRow = require("./table-features/get-row");
var _rowExpanding = require("./table-features/row-expanding");
const defaultColumnWidth = {
    width: 150,
    minWidth: 40,
    maxWidth: Number.MAX_SAFE_INTEGER
};
const SORT_ASC = 'asc';
const SORT_DESC = 'desc';
const useStateManagement = (options)=>{
    var _options_initialState, _options_columns;
    var _options_initialState_columnOrder;
    const initialState = (0, _objectSpreadProps._)((0, _objectSpread._)({}, options.initialState), {
        columnOrder: (_options_initialState_columnOrder = (_options_initialState = options.initialState) === null || _options_initialState === void 0 ? void 0 : _options_initialState.columnOrder) !== null && _options_initialState_columnOrder !== void 0 ? _options_initialState_columnOrder : (_options_columns = options.columns) === null || _options_columns === void 0 ? void 0 : _options_columns.map((column)=>column.key)
    });
    const [internalState, setInternalState] = (0, _react.useState)(initialState);
    const updateTableState = (key, updater, externalCallback)=>{
        setInternalState((prevState)=>{
            const currentValue = prevState[key];
            const updatedValue = typeof updater === 'function' ? updater(currentValue) : updater;
            // Optionally, call the external callback with the new value
            if (externalCallback) externalCallback(updatedValue);
            return (0, _objectSpreadProps._)((0, _objectSpread._)({}, prevState), {
                [key]: updatedValue
            });
        });
    };
    // This allows the component to either use the internal state or a provided state
    const getState = ()=>(0, _objectSpread._)({}, internalState, options.state);
    return {
        getState,
        updateTableState
    };
};
// Column handling utilities
const useColumnUtils = ({ options, getState, updateTableState })=>{
    // Sorting utilities
    const setSorting = (newSorting)=>{
        updateTableState('sorting', newSorting, options.onSortChange);
    };
    const getSorting = ()=>getState().sorting;
    const toggleSorting = (column)=>{
        const currentSorting = getSorting();
        var _column_sortField;
        if (!currentSorting || getIsCurrentSort(column) === false) setSorting({
            field: (_column_sortField = column.sortField) !== null && _column_sortField !== void 0 ? _column_sortField : column.key,
            direction: SORT_ASC
        });
        else setSorting((0, _objectSpreadProps._)((0, _objectSpread._)({}, currentSorting), {
            direction: currentSorting.direction === SORT_ASC ? SORT_DESC : SORT_ASC
        }));
    };
    const getIsCurrentSort = (column)=>{
        var _getSorting;
        var _column_sortField;
        return ((_getSorting = getSorting()) === null || _getSorting === void 0 ? void 0 : _getSorting.field) === ((_column_sortField = column.sortField) !== null && _column_sortField !== void 0 ? _column_sortField : column.key);
    };
    // Column order utilities
    const setColumnOrder = (newColumnOrder)=>{
        updateTableState('columnOrder', newColumnOrder, options.onColumnOrderChange);
    };
    const getColumnsInOrder = (0, _react.useCallback)(()=>{
        return getState().columnOrder.flatMap((columnId)=>{
            const column = options.columns.find((column)=>column.key === columnId);
            return column ? [
                column
            ] : [];
        });
    }, [
        getState,
        options.columns
    ]);
    /**
	 * Gets the index of a column in the columnOrder array.
	 * @param columnKey -- the key of the column to find the index of
	 * @returns number -- the index of the column in the columnOrder array
	 */ const getColumnIndex = (0, _react.useCallback)((column)=>{
        return getColumnsInOrder().findIndex((columnInOrder)=>column.key === columnInOrder.key);
    }, [
        getColumnsInOrder
    ]);
    const getVisibleColumns = (0, _react.useCallback)(()=>getColumnsInOrder().filter((column)=>!(column === null || column === void 0 ? void 0 : column.isHidden)), [
        getColumnsInOrder
    ]);
    const getColumnOrder = ()=>getState().columnOrder;
    // Column width utilities
    /**
	 * Sets the columnWidths state for the table.
	 * Intended for internal use or overriding the state, setColumnWidth (singular) preferred for column width changes.
	 * @param newColumnWidths -- the new columnWidths state
	 */ const setColumnWidths = (newColumnWidths)=>{
        updateTableState('columnWidths', newColumnWidths, options.onColumnWidthsChange);
    };
    /**
	 * Preferred method of changing the column width for a column.
	 * @param column -- the column to set the width for
	 * @param width -- the new width for the column
	 */ const setColumnWidth = ({ column, width })=>{
        setColumnWidths((prevColumnWidths)=>{
            return (0, _objectSpreadProps._)((0, _objectSpread._)({}, prevColumnWidths), {
                [column.key]: width
            });
        });
    };
    /**
	 * @returns the columnWidths state for the table
	 */ const getColumnWidths = ()=>getState().columnWidths;
    /**
	 * Gets the width of a column, clamped between the min and max width.
	 * @param column -- the column to get the width for
	 * @returns number -- the width of the column
	 */ const getColumnWidth = (0, _react.useCallback)((column)=>{
        var _getState_columnWidths;
        var _options_defaultColumnWidths;
        const defaultColWidth = (_options_defaultColumnWidths = options.defaultColumnWidths) !== null && _options_defaultColumnWidths !== void 0 ? _options_defaultColumnWidths : defaultColumnWidth;
        var _column_minWidth, _getState_columnWidths_column_key, _ref, _column_maxWidth;
        return Math.max((_column_minWidth = column.minWidth) !== null && _column_minWidth !== void 0 ? _column_minWidth : defaultColWidth.minWidth, Math.min((_ref = (_getState_columnWidths_column_key = (_getState_columnWidths = getState().columnWidths) === null || _getState_columnWidths === void 0 ? void 0 : _getState_columnWidths[column.key]) !== null && _getState_columnWidths_column_key !== void 0 ? _getState_columnWidths_column_key : column.width) !== null && _ref !== void 0 ? _ref : defaultColWidth.width, (_column_maxWidth = column.maxWidth) !== null && _column_maxWidth !== void 0 ? _column_maxWidth : defaultColWidth.maxWidth));
    }, [
        getState,
        options.defaultColumnWidths
    ]);
    /**
	 * Gets the total width of all columns visible in the table.
	 * Useful for setting the width of the table container when tableLayout is fixed.
	 * @returns number -- the total width of all columns visible in the table
	 */ const getTotalTableWidth = (0, _react.useCallback)(()=>{
        var _getColumnsInOrder_reduce;
        return (_getColumnsInOrder_reduce = getColumnsInOrder().reduce((sum, column)=>{
            if (column == null) return sum;
            return sum + getColumnWidth(column);
        }, 0)) !== null && _getColumnsInOrder_reduce !== void 0 ? _getColumnsInOrder_reduce : 0;
    }, [
        getColumnWidth,
        getColumnsInOrder
    ]);
    // Column pinning utilities
    /**
	 * Sets the columnPinning state for the table.
	 * @param newColumnWidths -- the new columnPinning state
	 */ const setColumnPinning = (newColumnPinning)=>{
        updateTableState('columnPinning', newColumnPinning, options.onColumnPinningChange);
    };
    /**
	 * @returns the columnPinning state for the table
	 */ const getColumnPinning = ()=>getState().columnPinning;
    /**
	 * Gets the keys of all columns before the given column.
	 */ const getStartColumnKeys = (0, _react.useCallback)((column)=>getColumnsInOrder().slice(0, getColumnIndex(column)).map((column)=>column.key), [
        getColumnIndex,
        getColumnsInOrder
    ]);
    /**
	 * Gets the keys of all columns after the given column.
	 */ const getEndColumnKeys = (0, _react.useCallback)((column)=>getColumnsInOrder().slice(getColumnIndex(column) + 1).map((column)=>column.key), [
        getColumnIndex,
        getColumnsInOrder
    ]);
    /**
	 * Sets the columnPinning state for the table where columns to the start or end of the given column are pinned.
	 * @param column the column to pin columns to the start or end of
	 * @param position the position to pin the columns to
	 */ const setBulkColumnPinning = (column, position)=>{
        setColumnPinning((prevColumnPinning)=>{
            var _prevColumnPinning_start, _prevColumnPinning_end;
            const startColumnKeys = getStartColumnKeys(column);
            const endColumnKeys = getEndColumnKeys(column);
            var _prevColumnPinning_start_filter, _prevColumnPinning_end_filter;
            const newColumnPinning = {
                start: position === 'start' ? [
                    ...startColumnKeys,
                    column.key
                ] : (_prevColumnPinning_start_filter = prevColumnPinning === null || prevColumnPinning === void 0 ? void 0 : (_prevColumnPinning_start = prevColumnPinning.start) === null || _prevColumnPinning_start === void 0 ? void 0 : _prevColumnPinning_start.filter((colkey)=>colkey !== column.key)) !== null && _prevColumnPinning_start_filter !== void 0 ? _prevColumnPinning_start_filter : [],
                end: position === 'end' ? [
                    ...endColumnKeys,
                    column.key
                ] : (_prevColumnPinning_end_filter = prevColumnPinning === null || prevColumnPinning === void 0 ? void 0 : (_prevColumnPinning_end = prevColumnPinning.end) === null || _prevColumnPinning_end === void 0 ? void 0 : _prevColumnPinning_end.filter((colkey)=>colkey !== column.key)) !== null && _prevColumnPinning_end_filter !== void 0 ? _prevColumnPinning_end_filter : []
            };
            return newColumnPinning;
        });
    };
    /**
	 * Gets the isPinned value for a column.
	 * @param column  the column to check if it is pinned
	 * @returns the isPinned value for the column
	 */ const getIsPinned = (column)=>{
        var _getColumnPinning_start, _getColumnPinning, _getColumnPinning_end, _getColumnPinning1;
        const isStartPinned = (_getColumnPinning = getColumnPinning()) === null || _getColumnPinning === void 0 ? void 0 : (_getColumnPinning_start = _getColumnPinning.start) === null || _getColumnPinning_start === void 0 ? void 0 : _getColumnPinning_start.includes(column.key);
        const isEndPinned = (_getColumnPinning1 = getColumnPinning()) === null || _getColumnPinning1 === void 0 ? void 0 : (_getColumnPinning_end = _getColumnPinning1.end) === null || _getColumnPinning_end === void 0 ? void 0 : _getColumnPinning_end.includes(column.key);
        return isStartPinned ? 'start' : isEndPinned ? 'end' : false;
    };
    /**
	 * Gets the total width of all columns before the given column.
	 */ const getStartColumnWidths = (0, _react.useCallback)((column)=>getColumnsInOrder().slice(0, getColumnIndex(column)).reduce((sum, column)=>{
            if (column == null) return sum;
            return sum + getColumnWidth(column);
        }, 0), [
        getColumnIndex,
        getColumnWidth,
        getColumnsInOrder
    ]);
    /**
	 * Gets the total width of all columns after the given column.
	 */ const getEndColumnWidths = (0, _react.useCallback)((column)=>getColumnsInOrder().slice(getColumnIndex(column) + 1).reduce((sum, column)=>{
            if (column == null) return sum;
            return sum + getColumnWidth(column);
        }, 0), [
        getColumnIndex,
        getColumnWidth,
        getColumnsInOrder
    ]);
    /**
	 * Resets the columnPinning state for the table.
	 * @param column Optional column to reset pinning for. If not provided, all columns are reset.
	 */ const resetColumnPinning = (column)=>{
        setColumnPinning((prevColumnPinning)=>{
            var _prevColumnPinning_start, _prevColumnPinning_end;
            if (!column) return {
                start: [],
                end: []
            };
            const newColumnPinning = {
                start: (prevColumnPinning === null || prevColumnPinning === void 0 ? void 0 : (_prevColumnPinning_start = prevColumnPinning.start) === null || _prevColumnPinning_start === void 0 ? void 0 : _prevColumnPinning_start.includes(column.key)) ? [] : prevColumnPinning === null || prevColumnPinning === void 0 ? void 0 : prevColumnPinning.start,
                end: (prevColumnPinning === null || prevColumnPinning === void 0 ? void 0 : (_prevColumnPinning_end = prevColumnPinning.end) === null || _prevColumnPinning_end === void 0 ? void 0 : _prevColumnPinning_end.includes(column.key)) ? [] : prevColumnPinning === null || prevColumnPinning === void 0 ? void 0 : prevColumnPinning.end
            };
            return newColumnPinning;
        });
    };
    return {
        getIsCurrentSort,
        toggleSorting,
        getSorting,
        setSorting,
        setColumnOrder,
        getColumnsInOrder,
        getVisibleColumns,
        getColumnOrder,
        getColumnWidths,
        getColumnWidth,
        setColumnWidth,
        setColumnWidths,
        getTotalTableWidth,
        getStartColumnWidths,
        getEndColumnWidths,
        getColumnIndex,
        getColumnPinning,
        getIsPinned,
        setColumnPinning,
        getStartColumnKeys,
        getEndColumnKeys,
        setBulkColumnPinning,
        resetColumnPinning
    };
};
// Row handling utilities
const useRows = ({ options, rowStruct, getState, updateTableState })=>{
    const setRowSelection = (0, _react.useCallback)((newRowSelection)=>{
        updateTableState('rowSelection', newRowSelection, options === null || options === void 0 ? void 0 : options.onSelectionChange);
    }, [
        options === null || options === void 0 ? void 0 : options.onSelectionChange,
        updateTableState
    ]);
    const getCanSelect = (0, _react.useCallback)((_row)=>{
        return options.enableRowSelection;
    }, [
        options
    ]);
    const getIsRowSelected = (0, _react.useCallback)((row)=>{
        var _getState_rowSelection;
        var _getState_rowSelection_row_id;
        return (_getState_rowSelection_row_id = (_getState_rowSelection = getState().rowSelection) === null || _getState_rowSelection === void 0 ? void 0 : _getState_rowSelection[row.id]) !== null && _getState_rowSelection_row_id !== void 0 ? _getState_rowSelection_row_id : false;
    }, [
        getState
    ]);
    const toggleRowSelected = (0, _react.useCallback)((row)=>{
        var _getState_rowSelection;
        const rowSelection = (_getState_rowSelection = getState().rowSelection) !== null && _getState_rowSelection !== void 0 ? _getState_rowSelection : {};
        const toggleSelect = (innerRow, parentSelection)=>{
            if (getCanSelect(innerRow)) {
                rowSelection[innerRow.id] = (parentSelection !== null && parentSelection !== void 0 ? parentSelection : (rowSelection === null || rowSelection === void 0 ? void 0 : rowSelection[innerRow.id]) == null) ? true : !(rowSelection === null || rowSelection === void 0 ? void 0 : rowSelection[innerRow.id]);
                if (innerRow.subRows) innerRow.subRows.forEach((subRow)=>toggleSelect(subRow, rowSelection[innerRow.id]));
            }
        };
        toggleSelect(row);
        setRowSelection(()=>{
            var _getState_rowSelection;
            return (0, _objectSpread._)({}, (_getState_rowSelection = getState().rowSelection) !== null && _getState_rowSelection !== void 0 ? _getState_rowSelection : {}, rowSelection);
        });
    }, [
        getCanSelect,
        getState,
        setRowSelection
    ]);
    //TODO: implement this
    // const getIsSomeChildrenSelected = useCallback(
    //   (row: FinalCharlieTableRow<TableDataModel>) => {
    //     const checkIfSelected = (innerRow: FinalCharlieTableRow<TableDataModel>) => {
    //       if (row.subRows) {
    //         return row.subRows.some((subRow) => getIsRowSelected(subRow));
    //       }
    //     }
    //     return false;
    //   },
    //   [getIsRowSelected],
    // );
    const getIsSomeRowsSelected = (0, _react.useCallback)(()=>{
        var _getState_rowSelection;
        return Object.values((_getState_rowSelection = getState().rowSelection) !== null && _getState_rowSelection !== void 0 ? _getState_rowSelection : {}).some(Boolean);
    }, [
        getState
    ]);
    const getIsAllRowsSelected = (0, _react.useCallback)(()=>{
        var _rowStruct_rows, _rowStruct_rows1;
        var _rowStruct_rows_length;
        const rowsExist = (_rowStruct_rows_length = rowStruct === null || rowStruct === void 0 ? void 0 : (_rowStruct_rows = rowStruct.rows) === null || _rowStruct_rows === void 0 ? void 0 : _rowStruct_rows.length) !== null && _rowStruct_rows_length !== void 0 ? _rowStruct_rows_length : false;
        var _getState_rowSelection;
        const anySelectionsExist = Object.keys((_getState_rowSelection = getState().rowSelection) !== null && _getState_rowSelection !== void 0 ? _getState_rowSelection : {}).length > 0;
        const hasLength = rowsExist && anySelectionsExist;
        if (hasLength && (rowStruct === null || rowStruct === void 0 ? void 0 : (_rowStruct_rows1 = rowStruct.rows) === null || _rowStruct_rows1 === void 0 ? void 0 : _rowStruct_rows1.some((row)=>getCanSelect(row) && !getIsRowSelected(row)))) return false;
        return hasLength;
    }, [
        getCanSelect,
        getIsRowSelected,
        getState,
        rowStruct === null || rowStruct === void 0 ? void 0 : rowStruct.rows
    ]);
    const toggleAllRowsSelected = (0, _react.useCallback)(()=>{
        setRowSelection(()=>{
            var _rowStruct_flatRows;
            if (getIsAllRowsSelected()) return {};
            const newSelection = {};
            rowStruct === null || rowStruct === void 0 ? void 0 : (_rowStruct_flatRows = rowStruct.flatRows) === null || _rowStruct_flatRows === void 0 ? void 0 : _rowStruct_flatRows.forEach((row)=>{
                newSelection[row.id] = getCanSelect(row) ? true : false;
            });
            return newSelection;
        });
    }, [
        getCanSelect,
        getIsAllRowsSelected,
        rowStruct === null || rowStruct === void 0 ? void 0 : rowStruct.flatRows,
        setRowSelection
    ]);
    return {
        toggleRowSelected,
        getIsRowSelected,
        getIsSomeRowsSelected,
        getIsAllRowsSelected,
        toggleAllRowsSelected,
        getCanSelect
    };
};
// Main hook
const useCharlieTable = (options)=>{
    const { getState, updateTableState } = useStateManagement(options);
    const state = getState();
    //these need to have a stable reference to avoid re-renders
    const rowStruct = (0, _react.useMemo)(()=>{
        return (0, _getRow.getRowStructs)({
            rows: options.rows,
            getChildRows: options.getChildRows,
            getRowId: options.getRowId,
            state: {
                expanded: state.expanded
            }
        });
    }, [
        options.rows,
        options.getChildRows,
        options.getRowId,
        state.expanded
    ]);
    const rows = (0, _react.useMemo)(()=>{
        return rowStruct.rows;
    }, [
        rowStruct
    ]);
    const columnHandlers = useColumnUtils({
        options,
        getState,
        updateTableState
    });
    const rowHandlers = useRows({
        options,
        rowStruct,
        getState,
        updateTableState
    });
    const rowExpansion = (0, _rowExpanding.useRowExpansion)({
        options,
        getState,
        updateTableState
    });
    // Expose table state management functions and helper functions
    return (0, _objectSpread._)({
        rows: rows,
        columns: options.columns,
        /**
		 * @private
		 * @deprecated getSubRows will be refactored in future versions.
		 * Use renderChildComponent instead for the existing behavior.
		 */ getSubRows: options.getSubRows,
        rowStruct: rowStruct,
        getChildRows: options.getChildRows,
        state: getState()
    }, columnHandlers, rowHandlers, rowExpansion);
};

},{"@swc/helpers/_/_object_spread":"9gdrV","@swc/helpers/_/_object_spread_props":"kANqQ","react":"ltHCL","./table-features/get-row":"b8usR","./table-features/row-expanding":"9fJQy","@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"b8usR":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "getRowStructs", ()=>getRowStructs);
var _objectSpread = require("@swc/helpers/_/_object_spread");
var _objectSpreadProps = require("@swc/helpers/_/_object_spread_props");
const getRowStructs = (options)=>{
    const rowStruct = {
        rows: [],
        flatRows: [],
        rowsById: {}
    };
    const recurseRows = ({ originalRows, depth = 0, parent })=>{
        const rows = [];
        originalRows.forEach((row, index)=>{
            var _options_getRowId;
            var _options_getRowId1;
            const finalRow = (0, _objectSpreadProps._)((0, _objectSpread._)({}, row), {
                depth,
                index,
                parent,
                id: (_options_getRowId1 = (_options_getRowId = options.getRowId) === null || _options_getRowId === void 0 ? void 0 : _options_getRowId.call(options, {
                    row,
                    index,
                    parent
                })) !== null && _options_getRowId1 !== void 0 ? _options_getRowId1 : `${parent ? [
                    parent.id,
                    index
                ].join('.') : index}`,
                subRows: undefined
            });
            rowStruct.flatRows.push(finalRow);
            rowStruct.rowsById[finalRow.id] = finalRow;
            rows.push(finalRow);
            if (options.getChildRows) {
                const originalSubRows = options.getChildRows(row);
                if (originalSubRows === null || originalSubRows === void 0 ? void 0 : originalSubRows.length) finalRow.subRows = recurseRows({
                    originalRows: originalSubRows,
                    depth: depth + 1,
                    parent: finalRow
                });
            }
        });
        return rows;
    };
    if (options.rows == null) return rowStruct;
    rowStruct.rows = recurseRows({
        originalRows: options.rows
    });
    const expanded = [];
    const recurseExpanded = (rows)=>{
        rows.forEach((row)=>{
            var _row_subRows, _options_state_expanded, _options_state;
            expanded.push(row);
            if (((_row_subRows = row.subRows) === null || _row_subRows === void 0 ? void 0 : _row_subRows.length) && ((_options_state = options.state) === null || _options_state === void 0 ? void 0 : (_options_state_expanded = _options_state.expanded) === null || _options_state_expanded === void 0 ? void 0 : _options_state_expanded[row.id]) === true) recurseExpanded(row.subRows);
        });
    };
    if (options.getChildRows) {
        recurseExpanded(rowStruct.rows);
        rowStruct.rows = expanded;
    }
    return rowStruct;
};

},{"@swc/helpers/_/_object_spread":"9gdrV","@swc/helpers/_/_object_spread_props":"kANqQ","@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"9fJQy":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "useRowExpansion", ()=>useRowExpansion);
var _objectSpread = require("@swc/helpers/_/_object_spread");
var _objectSpreadProps = require("@swc/helpers/_/_object_spread_props");
var _react = require("react");
const useRowExpansion = ({ options, getState, updateTableState })=>{
    const setExpand = (0, _react.useCallback)((newExpand)=>{
        updateTableState('expanded', newExpand, options === null || options === void 0 ? void 0 : options.onExpandChange);
    }, [
        options === null || options === void 0 ? void 0 : options.onExpandChange,
        updateTableState
    ]);
    const toggleExpandedRow = (0, _react.useCallback)((row)=>{
        setExpand((prevExpanded)=>{
            if ((prevExpanded === null || prevExpanded === void 0 ? void 0 : prevExpanded[row.id]) === undefined && row.isDefaultExpanded) return (0, _objectSpreadProps._)((0, _objectSpread._)({}, prevExpanded), {
                [row.id]: false
            });
            if ((prevExpanded === null || prevExpanded === void 0 ? void 0 : prevExpanded[row.id]) === undefined) return (0, _objectSpreadProps._)((0, _objectSpread._)({}, prevExpanded), {
                [row.id]: true
            });
            return (0, _objectSpreadProps._)((0, _objectSpread._)({}, prevExpanded), {
                [row.id]: !prevExpanded[row.id]
            });
        });
    }, [
        setExpand
    ]);
    const getIsRowExpanded = (0, _react.useCallback)((row)=>{
        var _getState_expanded;
        var _getState_expanded_row_id, _ref;
        return (_ref = (_getState_expanded_row_id = (_getState_expanded = getState().expanded) === null || _getState_expanded === void 0 ? void 0 : _getState_expanded[row.id]) !== null && _getState_expanded_row_id !== void 0 ? _getState_expanded_row_id : row.isDefaultExpanded) !== null && _ref !== void 0 ? _ref : false;
    }, [
        getState
    ]);
    //TODO: add callback for getIsRowExpandable to table hook to decide if row is expandable
    return {
        toggleExpandedRow,
        getIsRowExpanded,
        setExpand
    };
};

},{"@swc/helpers/_/_object_spread":"9gdrV","@swc/helpers/_/_object_spread_props":"kANqQ","react":"ltHCL","@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"930s9":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _reactIntl = require("react-intl");
const message = (0, _reactIntl.defineMessages)({
    sortAscending: {
        id: 'atlassian-studio-ui-components.paginated-charlie-table.sortAscending',
        defaultMessage: 'Sort ascending',
        description: 'Label for ascending sort button'
    },
    sortDescending: {
        id: 'atlassian-studio-ui-components.paginated-charlie-table.sortDescending',
        defaultMessage: 'Sort descending',
        description: 'Label for descending sort button'
    }
});
exports.default = message;

},{"react-intl":"f41fF","@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"lwwQ1":[function(require,module,exports,__globalThis) {
/* index.tsx generated by @compiled/babel-plugin v0.39.1 */ var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "PageMainContentLoadingLogo", ()=>PageMainContentLoadingLogo);
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _logo = require("@atlaskit/logo");
var _compiled = require("@atlaskit/primitives/compiled");
var _loadHold = require("@atlaskit/react-ufo/load-hold");
var _loadHoldDefault = parcelHelpers.interopDefault(_loadHold);
const loading = null;
const styles = {
    containerStyles: "_4t3i1osq",
    logoStyles: "_y44vx1hm"
};
const PageMainContentLoadingLogo = ({ interactionName, testId = 'loading-logo' })=>/*#__PURE__*/ (0, _reactDefault.default).createElement((0, _loadHoldDefault.default), {
        name: interactionName !== null && interactionName !== void 0 ? interactionName : 'studio-loading-atlassian-logo'
    }, /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _compiled.Stack), {
        grow: "fill",
        alignBlock: "center",
        alignInline: "center",
        xcss: styles.containerStyles,
        testId: testId
    }, /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _compiled.Box), {
        xcss: styles.logoStyles
    }, /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _logo.AtlassianIcon), {
        appearance: "brand",
        size: "xlarge"
    }))));

},{"react":"ltHCL","@atlaskit/logo":"hH5Id","@atlaskit/primitives/compiled":"hDay7","@atlaskit/react-ufo/load-hold":"iGGpO","@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"hH5Id":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "AtlasIcon", ()=>(0, _atlas.AtlasIcon));
parcelHelpers.export(exports, "AtlasLogo", ()=>(0, _atlas.AtlasLogo));
parcelHelpers.export(exports, "AtlassianMarketplaceIcon", ()=>(0, _atlassianMarketplace.AtlassianMarketplaceIcon));
parcelHelpers.export(exports, "AtlassianMarketplaceLogo", ()=>(0, _atlassianMarketplace.AtlassianMarketplaceLogo));
parcelHelpers.export(exports, "AtlassianAccessIcon", ()=>(0, _atlassianAccess.AtlassianAccessIcon));
parcelHelpers.export(exports, "AtlassianAccessLogo", ()=>(0, _atlassianAccess.AtlassianAccessLogo));
parcelHelpers.export(exports, "JiraWorkManagementLogo", ()=>(0, _jiraWorkManagement.JiraWorkManagementLogo));
parcelHelpers.export(exports, "JiraWorkManagementIcon", ()=>(0, _jiraWorkManagement.JiraWorkManagementIcon));
parcelHelpers.export(exports, "AtlassianIcon", ()=>(0, _atlassian.AtlassianIcon));
parcelHelpers.export(exports, "AtlassianLogo", ()=>(0, _atlassian.AtlassianLogo));
parcelHelpers.export(exports, "JiraSoftwareIcon", ()=>(0, _jiraSoftware.JiraSoftwareIcon));
parcelHelpers.export(exports, "JiraSoftwareLogo", ()=>(0, _jiraSoftware.JiraSoftwareLogo));
parcelHelpers.export(exports, "AdminIcon", ()=>AdminIcon);
parcelHelpers.export(exports, "AdminLogo", ()=>AdminLogo);
parcelHelpers.export(exports, "AnalyticsIcon", ()=>AnalyticsIcon);
parcelHelpers.export(exports, "AnalyticsLogo", ()=>AnalyticsLogo);
parcelHelpers.export(exports, "AssetsIcon", ()=>AssetsIcon);
parcelHelpers.export(exports, "AssetsLogo", ()=>AssetsLogo);
parcelHelpers.export(exports, "ChatIcon", ()=>ChatIcon);
parcelHelpers.export(exports, "ChatLogo", ()=>ChatLogo);
parcelHelpers.export(exports, "CustomerServiceManagementIcon", ()=>CustomerServiceManagementIcon);
parcelHelpers.export(exports, "CustomerServiceManagementLogo", ()=>CustomerServiceManagementLogo);
parcelHelpers.export(exports, "FeedbackIcon", ()=>FeedbackIcon);
parcelHelpers.export(exports, "FeedbackLogo", ()=>FeedbackLogo);
parcelHelpers.export(exports, "GoalsIcon", ()=>GoalsIcon);
parcelHelpers.export(exports, "GoalsLogo", ()=>GoalsLogo);
parcelHelpers.export(exports, "HomeIcon", ()=>HomeIcon);
parcelHelpers.export(exports, "HomeLogo", ()=>HomeLogo);
parcelHelpers.export(exports, "HubIcon", ()=>HubIcon);
parcelHelpers.export(exports, "HubLogo", ()=>HubLogo);
parcelHelpers.export(exports, "ProjectsIcon", ()=>ProjectsIcon);
parcelHelpers.export(exports, "ProjectsLogo", ()=>ProjectsLogo);
parcelHelpers.export(exports, "RovoDevIcon", ()=>RovoDevIcon);
parcelHelpers.export(exports, "RovoDevLogo", ()=>RovoDevLogo);
parcelHelpers.export(exports, "RovoDevAgentIcon", ()=>RovoDevAgentIcon);
parcelHelpers.export(exports, "RovoDevAgentLogo", ()=>RovoDevAgentLogo);
parcelHelpers.export(exports, "JiraCodingAgentIcon", ()=>JiraCodingAgentIcon);
parcelHelpers.export(exports, "SearchIcon", ()=>SearchIcon);
parcelHelpers.export(exports, "SearchLogo", ()=>SearchLogo);
parcelHelpers.export(exports, "StudioIcon", ()=>StudioIcon);
parcelHelpers.export(exports, "StudioLogo", ()=>StudioLogo);
parcelHelpers.export(exports, "TalentIcon", ()=>TalentIcon);
parcelHelpers.export(exports, "TalentLogo", ()=>TalentLogo);
parcelHelpers.export(exports, "TeamsIcon", ()=>TeamsIcon);
parcelHelpers.export(exports, "TeamsLogo", ()=>TeamsLogo);
parcelHelpers.export(exports, "BambooIcon", ()=>BambooIcon);
parcelHelpers.export(exports, "BambooLogo", ()=>BambooLogo);
parcelHelpers.export(exports, "BitbucketDataCenterIcon", ()=>BitbucketDataCenterIcon);
parcelHelpers.export(exports, "BitbucketDataCenterLogo", ()=>BitbucketDataCenterLogo);
parcelHelpers.export(exports, "ConfluenceDataCenterIcon", ()=>ConfluenceDataCenterIcon);
parcelHelpers.export(exports, "ConfluenceDataCenterLogo", ()=>ConfluenceDataCenterLogo);
parcelHelpers.export(exports, "CrowdIcon", ()=>CrowdIcon);
parcelHelpers.export(exports, "CrowdLogo", ()=>CrowdLogo);
parcelHelpers.export(exports, "JiraDataCenterIcon", ()=>JiraDataCenterIcon);
parcelHelpers.export(exports, "JiraDataCenterLogo", ()=>JiraDataCenterLogo);
parcelHelpers.export(exports, "JiraServiceManagementDataCenterIcon", ()=>JiraServiceManagementDataCenterIcon);
parcelHelpers.export(exports, "JiraServiceManagementDataCenterLogo", ()=>JiraServiceManagementDataCenterLogo);
parcelHelpers.export(exports, "AtlassianAdministrationIcon", ()=>AtlassianAdministrationIcon);
parcelHelpers.export(exports, "AtlassianAdministrationLogo", ()=>AtlassianAdministrationLogo);
parcelHelpers.export(exports, "AtlassianAdminIcon", ()=>AtlassianAdminIcon);
parcelHelpers.export(exports, "AtlassianAdminLogo", ()=>AtlassianAdminLogo);
parcelHelpers.export(exports, "AtlassianAnalyticsIcon", ()=>AtlassianAnalyticsIcon);
parcelHelpers.export(exports, "AtlassianAnalyticsLogo", ()=>AtlassianAnalyticsLogo);
parcelHelpers.export(exports, "BitbucketIcon", ()=>BitbucketIcon);
parcelHelpers.export(exports, "BitbucketLogo", ()=>BitbucketLogo);
parcelHelpers.export(exports, "CompassIcon", ()=>CompassIcon);
parcelHelpers.export(exports, "CompassLogo", ()=>CompassLogo);
parcelHelpers.export(exports, "DxIcon", ()=>DxIcon);
parcelHelpers.export(exports, "ConfluenceIcon", ()=>ConfluenceIcon);
parcelHelpers.export(exports, "ConfluenceLogo", ()=>ConfluenceLogo);
parcelHelpers.export(exports, "AlignIcon", ()=>AlignIcon);
parcelHelpers.export(exports, "AlignLogo", ()=>AlignLogo);
parcelHelpers.export(exports, "JiraAlignIcon", ()=>JiraAlignIcon);
parcelHelpers.export(exports, "JiraAlignLogo", ()=>JiraAlignLogo);
parcelHelpers.export(exports, "JiraIcon", ()=>JiraIcon);
parcelHelpers.export(exports, "JiraLogo", ()=>JiraLogo);
parcelHelpers.export(exports, "JiraProductDiscoveryIcon", ()=>JiraProductDiscoveryIcon);
parcelHelpers.export(exports, "JiraProductDiscoveryLogo", ()=>JiraProductDiscoveryLogo);
parcelHelpers.export(exports, "JiraServiceManagementIcon", ()=>JiraServiceManagementIcon);
parcelHelpers.export(exports, "JiraServiceManagementLogo", ()=>JiraServiceManagementLogo);
parcelHelpers.export(exports, "LoomIcon", ()=>LoomIcon);
parcelHelpers.export(exports, "LoomLogo", ()=>LoomLogo);
parcelHelpers.export(exports, "LoomAttributionIcon", ()=>LoomAttributionIcon);
parcelHelpers.export(exports, "LoomAttributionLogo", ()=>LoomAttributionLogo);
parcelHelpers.export(exports, "LoomBlurpleLogo", ()=>LoomBlurpleLogo);
parcelHelpers.export(exports, "LoomBlurpleIcon", ()=>LoomBlurpleIcon);
parcelHelpers.export(exports, "OpsgenieIcon", ()=>OpsgenieIcon);
parcelHelpers.export(exports, "OpsgenieLogo", ()=>OpsgenieLogo);
parcelHelpers.export(exports, "StatuspageIcon", ()=>StatuspageIcon);
parcelHelpers.export(exports, "StatuspageLogo", ()=>StatuspageLogo);
parcelHelpers.export(exports, "TrelloIcon", ()=>TrelloIcon);
parcelHelpers.export(exports, "TrelloLogo", ()=>TrelloLogo);
parcelHelpers.export(exports, "RovoIcon", ()=>RovoIcon);
parcelHelpers.export(exports, "RovoLogo", ()=>RovoLogo);
parcelHelpers.export(exports, "GuardIcon", ()=>GuardIcon);
parcelHelpers.export(exports, "GuardLogo", ()=>GuardLogo);
parcelHelpers.export(exports, "FocusIcon", ()=>FocusIcon);
parcelHelpers.export(exports, "FocusLogo", ()=>FocusLogo);
parcelHelpers.export(exports, "CompanyHubIcon", ()=>CompanyHubIcon);
parcelHelpers.export(exports, "CompanyHubLogo", ()=>CompanyHubLogo);
parcelHelpers.export(exports, "CustomLinkIcon", ()=>CustomLinkIcon);
parcelHelpers.export(exports, "GuardDetectIcon", ()=>GuardDetectIcon);
parcelHelpers.export(exports, "GuardDetectLogo", ()=>GuardDetectLogo);
parcelHelpers.export(exports, "MoreAtlassianAppsIcon", ()=>MoreAtlassianAppsIcon);
var _icon = require("./artifacts/logo-components/admin/icon");
var _logoCs = require("./artifacts/logo-components/admin/logo-cs");
var _icon1 = require("./artifacts/logo-components/align/icon");
var _logoCs1 = require("./artifacts/logo-components/align/logo-cs");
var _icon2 = require("./artifacts/logo-components/analytics/icon");
var _logoCs2 = require("./artifacts/logo-components/analytics/logo-cs");
var _icon3 = require("./artifacts/logo-components/assets/icon");
var _logoCs3 = require("./artifacts/logo-components/assets/logo-cs");
var _icon4 = require("./artifacts/logo-components/bamboo/icon");
var _logoCs4 = require("./artifacts/logo-components/bamboo/logo-cs");
var _icon5 = require("./artifacts/logo-components/bitbucket-data-center/icon");
var _logoCs5 = require("./artifacts/logo-components/bitbucket-data-center/logo-cs");
var _icon6 = require("./artifacts/logo-components/bitbucket/icon");
var _logoCs6 = require("./artifacts/logo-components/bitbucket/logo-cs");
var _icon7 = require("./artifacts/logo-components/chat/icon");
var _logoCs7 = require("./artifacts/logo-components/chat/logo-cs");
var _icon8 = require("./artifacts/logo-components/company-hub/icon");
var _logo = require("./artifacts/logo-components/company-hub/logo");
var _icon9 = require("./artifacts/logo-components/compass/icon");
var _logoCs8 = require("./artifacts/logo-components/compass/logo-cs");
var _icon10 = require("./artifacts/logo-components/confluence-data-center/icon");
var _logoCs9 = require("./artifacts/logo-components/confluence-data-center/logo-cs");
var _icon11 = require("./artifacts/logo-components/confluence/icon");
var _logoCs10 = require("./artifacts/logo-components/confluence/logo-cs");
var _icon12 = require("./artifacts/logo-components/crowd/icon");
var _logoCs11 = require("./artifacts/logo-components/crowd/logo-cs");
var _icon13 = require("./artifacts/logo-components/custom-link/icon");
var _icon14 = require("./artifacts/logo-components/customer-service-management/icon");
var _logoCs12 = require("./artifacts/logo-components/customer-service-management/logo-cs");
var _icon15 = require("./artifacts/logo-components/dx/icon");
var _icon16 = require("./artifacts/logo-components/feedback/icon");
var _logoCs13 = require("./artifacts/logo-components/feedback/logo-cs");
var _icon17 = require("./artifacts/logo-components/focus/icon");
var _logoCs14 = require("./artifacts/logo-components/focus/logo-cs");
var _icon18 = require("./artifacts/logo-components/goals/icon");
var _logoCs15 = require("./artifacts/logo-components/goals/logo-cs");
var _icon19 = require("./artifacts/logo-components/guard-detect/icon");
var _logo1 = require("./artifacts/logo-components/guard-detect/logo");
var _icon20 = require("./artifacts/logo-components/guard/icon");
var _logoCs16 = require("./artifacts/logo-components/guard/logo-cs");
var _icon21 = require("./artifacts/logo-components/home/icon");
var _logoCs17 = require("./artifacts/logo-components/home/logo-cs");
var _icon22 = require("./artifacts/logo-components/hub/icon");
var _logoCs18 = require("./artifacts/logo-components/hub/logo-cs");
var _icon23 = require("./artifacts/logo-components/jira-coding-agent/icon");
var _icon24 = require("./artifacts/logo-components/jira-data-center/icon");
var _logoCs19 = require("./artifacts/logo-components/jira-data-center/logo-cs");
var _icon25 = require("./artifacts/logo-components/jira-product-discovery/icon");
var _logoCs20 = require("./artifacts/logo-components/jira-product-discovery/logo-cs");
var _icon26 = require("./artifacts/logo-components/jira-service-management-data-center/icon");
var _logoCs21 = require("./artifacts/logo-components/jira-service-management-data-center/logo-cs");
var _icon27 = require("./artifacts/logo-components/jira-service-management/icon");
var _logoCs22 = require("./artifacts/logo-components/jira-service-management/logo-cs");
var _icon28 = require("./artifacts/logo-components/jira/icon");
var _logoCs23 = require("./artifacts/logo-components/jira/logo-cs");
var _logoCs24 = require("./artifacts/logo-components/loom-attribution/logo-cs");
var _icon29 = require("./artifacts/logo-components/loom-internal/icon");
var _logoCs25 = require("./artifacts/logo-components/loom-internal/logo-cs");
var _icon30 = require("./artifacts/logo-components/loom/icon");
var _logoCs26 = require("./artifacts/logo-components/loom/logo-cs");
var _icon31 = require("./artifacts/logo-components/more-atlassian-apps/icon");
var _icon32 = require("./artifacts/logo-components/opsgenie/icon");
var _logoCs27 = require("./artifacts/logo-components/opsgenie/logo-cs");
var _icon33 = require("./artifacts/logo-components/projects/icon");
var _logoCs28 = require("./artifacts/logo-components/projects/logo-cs");
var _icon34 = require("./artifacts/logo-components/rovo-dev-agent/icon");
var _logoCs29 = require("./artifacts/logo-components/rovo-dev-agent/logo-cs");
var _icon35 = require("./artifacts/logo-components/rovo-dev/icon");
var _logoCs30 = require("./artifacts/logo-components/rovo-dev/logo-cs");
var _icon36 = require("./artifacts/logo-components/rovo-hex/icon");
var _logoCs31 = require("./artifacts/logo-components/rovo-hex/logo-cs");
var _icon37 = require("./artifacts/logo-components/rovo/icon");
var _logoCs32 = require("./artifacts/logo-components/rovo/logo-cs");
var _icon38 = require("./artifacts/logo-components/search/icon");
var _logoCs33 = require("./artifacts/logo-components/search/logo-cs");
var _icon39 = require("./artifacts/logo-components/statuspage/icon");
var _logoCs34 = require("./artifacts/logo-components/statuspage/logo-cs");
var _icon40 = require("./artifacts/logo-components/studio/icon");
var _logoCs35 = require("./artifacts/logo-components/studio/logo-cs");
var _icon41 = require("./artifacts/logo-components/talent/icon");
var _logoCs36 = require("./artifacts/logo-components/talent/logo-cs");
var _icon42 = require("./artifacts/logo-components/teams/icon");
var _logoCs37 = require("./artifacts/logo-components/teams/logo-cs");
var _icon43 = require("./artifacts/logo-components/trello/icon");
var _logoCs38 = require("./artifacts/logo-components/trello/logo-cs");
var _createFeatureFlaggedComponent = require("./create-feature-flagged-component");
var _createFeatureFlaggedServiceCollectionComponent = require("./create-feature-flagged-service-collection-component");
var _atlassianAdmin = require("./legacy-logos/atlassian-admin");
var _atlassianAdministration = require("./legacy-logos/atlassian-administration");
var _atlassianAnalytics = require("./legacy-logos/atlassian-analytics");
var _bitbucket = require("./legacy-logos/bitbucket");
var _compass = require("./legacy-logos/compass");
var _confluence = require("./legacy-logos/confluence");
var _focus = require("./legacy-logos/focus");
var _guard = require("./legacy-logos/guard");
var _jira = require("./legacy-logos/jira");
var _jiraAlign = require("./legacy-logos/jira-align");
var _jiraProductDiscovery = require("./legacy-logos/jira-product-discovery");
var _jiraServiceManagement = require("./legacy-logos/jira-service-management");
var _loom = require("./legacy-logos/loom");
var _loomAttribution = require("./legacy-logos/loom-attribution");
var _opsgenie = require("./legacy-logos/opsgenie");
var _rovo = require("./legacy-logos/rovo");
var _statuspage = require("./legacy-logos/statuspage");
var _trello = require("./legacy-logos/trello");
var _atlas = require("./legacy-logos/atlas");
var _atlassianMarketplace = require("./legacy-logos/atlassian-marketplace");
var _atlassianAccess = require("./legacy-logos/atlassian-access");
var _jiraWorkManagement = require("./legacy-logos/jira-work-management");
var _atlassian = require("./legacy-logos/atlassian");
var _jiraSoftware = require("./legacy-logos/jira-software");
var _logoConfig = require("./logo-config");
var _tempSizeWrapper = require("./temp-size-wrapper");
const AdminIcon = (0, _tempSizeWrapper.tempSizeWrapper)((0, _icon.AdminIcon));
const AdminLogo = (0, _tempSizeWrapper.tempSizeWrapper)((0, _logoCs.AdminLogoCS));
const AnalyticsIcon = (0, _tempSizeWrapper.tempSizeWrapper)((0, _icon2.AnalyticsIcon));
const AnalyticsLogo = (0, _tempSizeWrapper.tempSizeWrapper)((0, _logoCs2.AnalyticsLogoCS));
const AssetsIcon = (0, _tempSizeWrapper.tempSizeWrapper)((0, _icon3.AssetsIcon));
const AssetsLogo = (0, _tempSizeWrapper.tempSizeWrapper)((0, _logoCs3.AssetsLogoCS));
const ChatIcon = (0, _tempSizeWrapper.tempSizeWrapper)((0, _icon7.ChatIcon));
const ChatLogo = (0, _tempSizeWrapper.tempSizeWrapper)((0, _logoCs7.ChatLogoCS));
const CustomerServiceManagementIcon = (0, _tempSizeWrapper.tempSizeWrapper)((0, _icon14.CustomerServiceManagementIcon));
const CustomerServiceManagementLogo = (0, _tempSizeWrapper.tempSizeWrapper)((0, _logoCs12.CustomerServiceManagementLogoCS));
const FeedbackIcon = (0, _tempSizeWrapper.tempSizeWrapper)((0, _icon16.FeedbackIcon));
const FeedbackLogo = (0, _tempSizeWrapper.tempSizeWrapper)((0, _logoCs13.FeedbackLogoCS));
const GoalsIcon = (0, _tempSizeWrapper.tempSizeWrapper)((0, _icon18.GoalsIcon));
const GoalsLogo = (0, _tempSizeWrapper.tempSizeWrapper)((0, _logoCs15.GoalsLogoCS));
const HomeIcon = (0, _tempSizeWrapper.tempSizeWrapper)((0, _icon21.HomeIcon));
const HomeLogo = (0, _tempSizeWrapper.tempSizeWrapper)((0, _logoCs17.HomeLogoCS));
const HubIcon = (0, _tempSizeWrapper.tempSizeWrapper)((0, _icon22.HubIcon));
const HubLogo = (0, _tempSizeWrapper.tempSizeWrapper)((0, _logoCs18.HubLogoCS));
const ProjectsIcon = (0, _tempSizeWrapper.tempSizeWrapper)((0, _icon33.ProjectsIcon));
const ProjectsLogo = (0, _tempSizeWrapper.tempSizeWrapper)((0, _logoCs28.ProjectsLogoCS));
const RovoDevIcon = (0, _tempSizeWrapper.tempSizeWrapper)((0, _icon35.RovoDevIcon));
const RovoDevLogo = (0, _tempSizeWrapper.tempSizeWrapper)((0, _logoCs30.RovoDevLogoCS));
const RovoDevAgentIcon = (0, _tempSizeWrapper.tempSizeWrapper)((0, _icon34.RovoDevAgentIcon));
const RovoDevAgentLogo = (0, _tempSizeWrapper.tempSizeWrapper)((0, _logoCs29.RovoDevAgentLogoCS));
const JiraCodingAgentIcon = (0, _tempSizeWrapper.tempSizeWrapper)((0, _icon23.JiraCodingAgentIcon));
const SearchIcon = (0, _tempSizeWrapper.tempSizeWrapper)((0, _icon38.SearchIcon));
const SearchLogo = (0, _tempSizeWrapper.tempSizeWrapper)((0, _logoCs33.SearchLogoCS));
const StudioIcon = (0, _tempSizeWrapper.tempSizeWrapper)((0, _icon40.StudioIcon));
const StudioLogo = (0, _tempSizeWrapper.tempSizeWrapper)((0, _logoCs35.StudioLogoCS));
const TalentIcon = (0, _tempSizeWrapper.tempSizeWrapper)((0, _icon41.TalentIcon));
const TalentLogo = (0, _tempSizeWrapper.tempSizeWrapper)((0, _logoCs36.TalentLogoCS));
const TeamsIcon = (0, _tempSizeWrapper.tempSizeWrapper)((0, _icon42.TeamsIcon));
const TeamsLogo = (0, _tempSizeWrapper.tempSizeWrapper)((0, _logoCs37.TeamsLogoCS));
const BambooIcon = (0, _tempSizeWrapper.tempSizeWrapper)((0, _icon4.BambooIcon));
const BambooLogo = (0, _tempSizeWrapper.tempSizeWrapper)((0, _logoCs4.BambooLogoCS));
const BitbucketDataCenterIcon = (0, _tempSizeWrapper.tempSizeWrapper)((0, _icon5.BitbucketDataCenterIcon));
const BitbucketDataCenterLogo = (0, _tempSizeWrapper.tempSizeWrapper)((0, _logoCs5.BitbucketDataCenterLogoCS));
const ConfluenceDataCenterIcon = (0, _tempSizeWrapper.tempSizeWrapper)((0, _icon10.ConfluenceDataCenterIcon));
const ConfluenceDataCenterLogo = (0, _tempSizeWrapper.tempSizeWrapper)((0, _logoCs9.ConfluenceDataCenterLogoCS));
const CrowdIcon = (0, _tempSizeWrapper.tempSizeWrapper)((0, _icon12.CrowdIcon));
const CrowdLogo = (0, _tempSizeWrapper.tempSizeWrapper)((0, _logoCs11.CrowdLogoCS));
const JiraDataCenterIcon = (0, _tempSizeWrapper.tempSizeWrapper)((0, _icon24.JiraDataCenterIcon));
const JiraDataCenterLogo = (0, _tempSizeWrapper.tempSizeWrapper)((0, _logoCs19.JiraDataCenterLogoCS));
const JiraServiceManagementDataCenterIcon = (0, _tempSizeWrapper.tempSizeWrapper)((0, _icon26.JiraServiceManagementDataCenterIcon));
const JiraServiceManagementDataCenterLogo = (0, _tempSizeWrapper.tempSizeWrapper)((0, _logoCs21.JiraServiceManagementDataCenterLogoCS));
const AtlassianAdministrationIcon = (0, _createFeatureFlaggedComponent.createFeatureFlaggedComponent)((0, _atlassianAdministration.AtlassianAdministrationIcon), (0, _icon.AdminIcon));
const AtlassianAdministrationLogo = (0, _createFeatureFlaggedComponent.createFeatureFlaggedComponent)((0, _atlassianAdministration.AtlassianAdministrationLogo), (0, _logoCs.AdminLogoCS));
const AtlassianAdminIcon = (0, _createFeatureFlaggedComponent.createFeatureFlaggedComponent)((0, _atlassianAdmin.AtlassianAdminIcon), (0, _icon.AdminIcon));
const AtlassianAdminLogo = (0, _createFeatureFlaggedComponent.createFeatureFlaggedComponent)((0, _atlassianAdmin.AtlassianAdminLogo), (0, _logoCs.AdminLogoCS));
const AtlassianAnalyticsIcon = (0, _createFeatureFlaggedComponent.createFeatureFlaggedComponent)((0, _atlassianAnalytics.AtlassianAnalyticsIcon), (0, _icon2.AnalyticsIcon));
const AtlassianAnalyticsLogo = (0, _createFeatureFlaggedComponent.createFeatureFlaggedComponent)((0, _atlassianAnalytics.AtlassianAnalyticsLogo), (0, _logoCs2.AnalyticsLogoCS));
const BitbucketIcon = (0, _createFeatureFlaggedComponent.createFeatureFlaggedComponent)((0, _bitbucket.BitbucketIcon), (0, _icon6.BitbucketIcon));
const BitbucketLogo = (0, _createFeatureFlaggedComponent.createFeatureFlaggedComponent)((0, _bitbucket.BitbucketLogo), (0, _logoCs6.BitbucketLogoCS));
const CompassIcon = (0, _createFeatureFlaggedComponent.createFeatureFlaggedComponent)((0, _compass.CompassIcon), (0, _icon9.CompassIcon));
const CompassLogo = (0, _createFeatureFlaggedComponent.createFeatureFlaggedComponent)((0, _compass.CompassLogo), (0, _logoCs8.CompassLogoCS));
const DxIcon = (0, _tempSizeWrapper.tempSizeWrapper)((0, _icon15.DxIcon));
const ConfluenceIcon = (0, _createFeatureFlaggedComponent.createFeatureFlaggedComponent)((0, _confluence.ConfluenceIcon), (0, _icon11.ConfluenceIcon));
const ConfluenceLogo = (0, _createFeatureFlaggedComponent.createFeatureFlaggedComponent)((0, _confluence.ConfluenceLogo), (0, _logoCs10.ConfluenceLogoCS));
const AlignIcon = (0, _tempSizeWrapper.tempSizeWrapper)((0, _icon1.AlignIcon));
const AlignLogo = (0, _tempSizeWrapper.tempSizeWrapper)((0, _logoCs1.AlignLogoCS));
const JiraAlignIcon = (0, _createFeatureFlaggedComponent.createFeatureFlaggedComponent)((0, _jiraAlign.JiraAlignIcon), (0, _icon1.AlignIcon));
const JiraAlignLogo = (0, _createFeatureFlaggedComponent.createFeatureFlaggedComponent)((0, _jiraAlign.JiraAlignLogo), (0, _logoCs1.AlignLogoCS));
const JiraIcon = (0, _createFeatureFlaggedComponent.createFeatureFlaggedComponent)((0, _jira.JiraIcon), (0, _icon28.JiraIcon));
const JiraLogo = (0, _createFeatureFlaggedComponent.createFeatureFlaggedComponent)((0, _jira.JiraLogo), (0, _logoCs23.JiraLogoCS));
const JiraProductDiscoveryIcon = (0, _createFeatureFlaggedComponent.createFeatureFlaggedComponent)((0, _jiraProductDiscovery.JiraProductDiscoveryIcon), (0, _icon25.JiraProductDiscoveryIcon));
const JiraProductDiscoveryLogo = (0, _createFeatureFlaggedComponent.createFeatureFlaggedComponent)((0, _jiraProductDiscovery.JiraProductDiscoveryLogo), (0, _logoCs20.JiraProductDiscoveryLogoCS));
const JiraServiceManagementIcon = (0, _createFeatureFlaggedServiceCollectionComponent.createFeatureFlaggedServiceCollectionComponent)((0, _jiraServiceManagement.JiraServiceManagementIcon), (0, _icon27.JiraServiceManagementIcon));
const JiraServiceManagementLogo = (0, _createFeatureFlaggedServiceCollectionComponent.createFeatureFlaggedServiceCollectionComponent)((0, _jiraServiceManagement.JiraServiceManagementLogo), (0, _logoCs22.JiraServiceManagementLogoCS));
const LoomIcon = (0, _createFeatureFlaggedComponent.createFeatureFlaggedComponent)((0, _loom.LoomIcon), (0, _icon30.LoomIcon));
const LoomLogo = (0, _createFeatureFlaggedComponent.createFeatureFlaggedComponent)((0, _loom.LoomLogo), (0, _logoCs26.LoomLogoCS));
const LoomAttributionIcon = (0, _createFeatureFlaggedComponent.createFeatureFlaggedComponent)((0, _loomAttribution.LoomAttributionIcon), (0, _icon30.LoomIcon));
const LoomAttributionLogo = (0, _createFeatureFlaggedComponent.createFeatureFlaggedComponent)((0, _loomAttribution.LoomAttributionLogo), (0, _logoCs24.LoomAttributionLogoCS));
const LoomBlurpleLogo = (0, _tempSizeWrapper.tempSizeWrapper)((0, _logoCs25.LoomInternalLogoCS));
const LoomBlurpleIcon = (0, _tempSizeWrapper.tempSizeWrapper)((0, _icon29.LoomInternalIcon));
const OpsgenieIcon = (0, _createFeatureFlaggedServiceCollectionComponent.createFeatureFlaggedServiceCollectionComponent)((0, _opsgenie.OpsgenieIcon), (0, _icon32.OpsgenieIcon));
const OpsgenieLogo = (0, _createFeatureFlaggedServiceCollectionComponent.createFeatureFlaggedServiceCollectionComponent)((0, _opsgenie.OpsgenieLogo), (0, _logoCs27.OpsgenieLogoCS));
const StatuspageIcon = (0, _createFeatureFlaggedServiceCollectionComponent.createFeatureFlaggedServiceCollectionComponent)((0, _statuspage.StatuspageIcon), (0, _icon39.StatuspageIcon));
const StatuspageLogo = (0, _createFeatureFlaggedServiceCollectionComponent.createFeatureFlaggedServiceCollectionComponent)((0, _statuspage.StatuspageLogo), (0, _logoCs34.StatuspageLogoCS));
const TrelloIcon = (0, _createFeatureFlaggedComponent.createFeatureFlaggedComponent)((0, _trello.TrelloIcon), (0, _icon43.TrelloIcon));
const TrelloLogo = (0, _createFeatureFlaggedComponent.createFeatureFlaggedComponent)((0, _trello.TrelloLogo), (0, _logoCs38.TrelloLogoCS));
const RovoIcon = (0, _logoConfig.createFeatureFlaggedRovoComponent)((0, _rovo.RovoIcon), (0, _icon37.RovoIcon), (0, _icon36.RovoHexIcon));
const RovoLogo = (0, _logoConfig.createFeatureFlaggedRovoComponent)((0, _rovo.RovoLogo), (0, _logoCs32.RovoLogoCS), (0, _logoCs31.RovoHexLogoCS));
const GuardIcon = (0, _createFeatureFlaggedComponent.createFeatureFlaggedComponent)((0, _guard.GuardIcon), (0, _icon20.GuardIcon));
const GuardLogo = (0, _createFeatureFlaggedComponent.createFeatureFlaggedComponent)((0, _guard.GuardLogo), (0, _logoCs16.GuardLogoCS));
const FocusIcon = (0, _createFeatureFlaggedComponent.createFeatureFlaggedComponent)((0, _focus.FocusIcon), (0, _icon17.FocusIcon));
const FocusLogo = (0, _createFeatureFlaggedComponent.createFeatureFlaggedComponent)((0, _focus.FocusLogo), (0, _logoCs14.FocusLogoCS));
const CompanyHubIcon = (0, _tempSizeWrapper.tempSizeWrapper)((0, _icon8.CompanyHubIcon));
const CompanyHubLogo = (0, _tempSizeWrapper.tempSizeWrapper)((0, _logo.CompanyHubLogo));
const CustomLinkIcon = (0, _tempSizeWrapper.tempSizeWrapper)((0, _icon13.CustomLinkIcon));
const GuardDetectIcon = (0, _tempSizeWrapper.tempSizeWrapper)((0, _icon19.GuardDetectIcon));
const GuardDetectLogo = (0, _tempSizeWrapper.tempSizeWrapper)((0, _logo1.GuardDetectLogo));
const MoreAtlassianAppsIcon = (0, _tempSizeWrapper.tempSizeWrapper)((0, _icon31.MoreAtlassianAppsIcon));

},{"./artifacts/logo-components/admin/icon":"46jz9","./artifacts/logo-components/admin/logo-cs":"9SnyQ","./artifacts/logo-components/align/icon":"fgU9J","./artifacts/logo-components/align/logo-cs":"6hCZ1","./artifacts/logo-components/analytics/icon":"5XmVS","./artifacts/logo-components/analytics/logo-cs":"88sB4","./artifacts/logo-components/assets/icon":"NIrnl","./artifacts/logo-components/assets/logo-cs":"2Xfd6","./artifacts/logo-components/bamboo/icon":"8aZ5i","./artifacts/logo-components/bamboo/logo-cs":"gFP9D","./artifacts/logo-components/bitbucket-data-center/icon":"fs59x","./artifacts/logo-components/bitbucket-data-center/logo-cs":"kqkOn","./artifacts/logo-components/bitbucket/icon":"2xL4i","./artifacts/logo-components/bitbucket/logo-cs":"3b4jn","./artifacts/logo-components/chat/icon":"6n5cI","./artifacts/logo-components/chat/logo-cs":"k9xiQ","./artifacts/logo-components/company-hub/icon":"bBAww","./artifacts/logo-components/company-hub/logo":"1RFts","./artifacts/logo-components/compass/icon":"7Meg0","./artifacts/logo-components/compass/logo-cs":"4XrHp","./artifacts/logo-components/confluence-data-center/icon":"jkj2x","./artifacts/logo-components/confluence-data-center/logo-cs":"fTOiY","./artifacts/logo-components/confluence/icon":"7HfeB","./artifacts/logo-components/confluence/logo-cs":"b07tV","./artifacts/logo-components/crowd/icon":"cbavW","./artifacts/logo-components/crowd/logo-cs":"7j0JG","./artifacts/logo-components/custom-link/icon":"5LXqv","./artifacts/logo-components/customer-service-management/icon":"2dUak","./artifacts/logo-components/customer-service-management/logo-cs":"1F709","./artifacts/logo-components/dx/icon":"cZ76K","./artifacts/logo-components/feedback/icon":"CKDBX","./artifacts/logo-components/feedback/logo-cs":"dO0ug","./artifacts/logo-components/focus/icon":"huGIX","./artifacts/logo-components/focus/logo-cs":"fnqFA","./artifacts/logo-components/goals/icon":"bOzby","./artifacts/logo-components/goals/logo-cs":"5qXAm","./artifacts/logo-components/guard-detect/icon":"a5CkP","./artifacts/logo-components/guard-detect/logo":"3As3C","./artifacts/logo-components/guard/icon":"fWC0u","./artifacts/logo-components/guard/logo-cs":"74m4J","./artifacts/logo-components/home/icon":"11q6O","./artifacts/logo-components/home/logo-cs":"605fe","./artifacts/logo-components/hub/icon":"eKhnE","./artifacts/logo-components/hub/logo-cs":"3oK4G","./artifacts/logo-components/jira-coding-agent/icon":"hDPcG","./artifacts/logo-components/jira-data-center/icon":"aFxdE","./artifacts/logo-components/jira-data-center/logo-cs":"fteNs","./artifacts/logo-components/jira-product-discovery/icon":"9nYF6","./artifacts/logo-components/jira-product-discovery/logo-cs":"69nzR","./artifacts/logo-components/jira-service-management-data-center/icon":"bYJlc","./artifacts/logo-components/jira-service-management-data-center/logo-cs":"b1EDv","./artifacts/logo-components/jira-service-management/icon":"aMcsj","./artifacts/logo-components/jira-service-management/logo-cs":"g5xzB","./artifacts/logo-components/jira/icon":"6CqCR","./artifacts/logo-components/jira/logo-cs":"k6PVE","./artifacts/logo-components/loom-attribution/logo-cs":"hZYb0","./artifacts/logo-components/loom-internal/icon":"6LAgU","./artifacts/logo-components/loom-internal/logo-cs":"eduIg","./artifacts/logo-components/loom/icon":"7lL9f","./artifacts/logo-components/loom/logo-cs":"73uid","./artifacts/logo-components/more-atlassian-apps/icon":"lOMs6","./artifacts/logo-components/opsgenie/icon":"35Kec","./artifacts/logo-components/opsgenie/logo-cs":"31DOx","./artifacts/logo-components/projects/icon":"8sscb","./artifacts/logo-components/projects/logo-cs":"aTNRi","./artifacts/logo-components/rovo-dev-agent/icon":"ffHTg","./artifacts/logo-components/rovo-dev-agent/logo-cs":"cPrXs","./artifacts/logo-components/rovo-dev/icon":"2pBYw","./artifacts/logo-components/rovo-dev/logo-cs":"GOXcQ","./artifacts/logo-components/rovo-hex/icon":"2h3XF","./artifacts/logo-components/rovo-hex/logo-cs":"fMSN8","./artifacts/logo-components/rovo/icon":"erI0H","./artifacts/logo-components/rovo/logo-cs":"bBgAF","./artifacts/logo-components/search/icon":"5zLu7","./artifacts/logo-components/search/logo-cs":"3e4fh","./artifacts/logo-components/statuspage/icon":"aRJot","./artifacts/logo-components/statuspage/logo-cs":"dsmSW","./artifacts/logo-components/studio/icon":"9OhW3","./artifacts/logo-components/studio/logo-cs":"4joV2","./artifacts/logo-components/talent/icon":"bKuIO","./artifacts/logo-components/talent/logo-cs":"kaDYR","./artifacts/logo-components/teams/icon":"fVGE3","./artifacts/logo-components/teams/logo-cs":"lsBUC","./artifacts/logo-components/trello/icon":"iGsWT","./artifacts/logo-components/trello/logo-cs":"ahpsb","./create-feature-flagged-component":"6IptU","./create-feature-flagged-service-collection-component":"3NrZZ","./legacy-logos/atlassian-admin":"lzwNy","./legacy-logos/atlassian-administration":"3OvbM","./legacy-logos/atlassian-analytics":"1XjmU","./legacy-logos/bitbucket":"4lMQq","./legacy-logos/compass":"c0M48","./legacy-logos/confluence":"b0iVX","./legacy-logos/focus":"1rGcg","./legacy-logos/guard":"hxXQG","./legacy-logos/jira":"cJ4sZ","./legacy-logos/jira-align":"aQQzV","./legacy-logos/jira-product-discovery":"dwHPV","./legacy-logos/jira-service-management":"g5Er5","./legacy-logos/loom":"7eP0p","./legacy-logos/loom-attribution":"gnuyM","./legacy-logos/opsgenie":"bD3Mi","./legacy-logos/rovo":"3LzuM","./legacy-logos/statuspage":"fqqOI","./legacy-logos/trello":"hQloK","./legacy-logos/atlas":false,"./legacy-logos/atlassian-marketplace":false,"./legacy-logos/atlassian-access":false,"./legacy-logos/jira-work-management":"iz94O","./legacy-logos/atlassian":"fc0zD","./legacy-logos/jira-software":"hPZJ7","./logo-config":"e3QCB","./temp-size-wrapper":"gwyCQ","@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"46jz9":[function(require,module,exports,__globalThis) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::3ee8292a79b161f2b692708d346bda7d>>
 * @codegenCommand yarn workspace @atlaskit/logo generate:components
 */ var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
/**
 * __AdminIcon__
 *
 * An internal component to represent the icon for Admin.
 * Do not use this internal component directly — use `AdminIcon` from `@atlaskit/logo` instead.
 *
 */ parcelHelpers.export(exports, "AdminIcon", ()=>AdminIcon);
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _iconWrapper = require("../../../utils/icon-wrapper");
// `height` is set to 100% to allow the SVG to scale with the parent element
const svg = `<svg height="100%" viewBox="0 0 24 24">
    <path fill="var(--tile-color,#dddee1)" d="M0 6a6 6 0 0 1 6-6h12a6 6 0 0 1 6 6v12a6 6 0 0 1-6 6H6a6 6 0 0 1-6-6z"/>
    <path fill="var(--icon-color, #101214)" fill-rule="evenodd" d="M10.444 5h3.111l.98 2.61 2.75-.457 1.555 2.694L17.07 12l1.77 2.153-1.555 2.694-2.75-.457-.979 2.61h-3.11l-.98-2.61-2.75.457-1.555-2.694L6.931 12 5.16 9.847l1.555-2.694 2.75.457zM12 14.625a2.625 2.625 0 1 0 0-5.25 2.625 2.625 0 0 0 0 5.25" clip-rule="evenodd"/>
</svg>
`;
function AdminIcon({ size, appearance = 'brand', label = 'Admin', testId }) {
    return /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _iconWrapper.IconWrapper), {
        svg: svg,
        label: label,
        appearance: appearance,
        size: size,
        testId: testId
    });
}

},{"react":"ltHCL","../../../utils/icon-wrapper":"4NqBa","@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"4NqBa":[function(require,module,exports,__globalThis) {
/* icon-wrapper.tsx generated by @compiled/babel-plugin v0.39.1 */ var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "IconWrapper", ()=>IconWrapper);
var _react = require("react");
var _runtime = require("@compiled/react/runtime");
var _platformFeatureFlags = require("@atlaskit/platform-feature-flags");
var _useThemeObserver = require("@atlaskit/tokens/use-theme-observer");
const styles = {
    root: "_1e0c1o8l",
    TEMP_assets: "_9aea1fkg"
}; /* eslint-disable @atlaskit/ui-styling-standard/no-imported-style-values */ 
/* eslint-disable @atlaskit/ui-styling-standard/no-unsafe-values */ const cloudLightAppearanceMap = {
    brand: "_1b3i18uv _9aea18uv",
    neutral: "_1b3i1e01 _9aea1fkg",
    inverse: "_1b3i5a6q _9aeau67f",
    legacy: "_1b3iu67f _9aeadoyu"
}; /* eslint-disable @atlaskit/ui-styling-standard/no-imported-style-values */ 
/* eslint-disable @atlaskit/ui-styling-standard/no-unsafe-values */ const cloudDarkAppearanceMap = {
    brand: "_1b3i18uv _9aea18uv",
    neutral: "_1b3i1gvk _9aea8hz0",
    inverse: "_1b3iu67f _9aea5a6q",
    legacy: "_1b3iu67f _9aeadoyu"
}; /* eslint-disable @atlaskit/ui-styling-standard/no-imported-style-values */ 
/* eslint-disable @atlaskit/ui-styling-standard/no-unsafe-values */ const dataCenterLightAppearanceMap = {
    brand: "_1b3idoyu _9aeau67f _3wu01fkg",
    neutral: "_1b3i1e01 _9aea1fkg _3wu01e01",
    inverse: "_1b3iu67f _9aeaqlpt _3wu0u67f",
    legacy: "_1b3idoyu _9aeau67f _3wu01fkg"
}; /* eslint-disable @atlaskit/ui-styling-standard/no-imported-style-values */ 
/* eslint-disable @atlaskit/ui-styling-standard/no-unsafe-values */ const dataCenterDarkAppearanceMap = {
    brand: "_1b3idoyu _9aeaqlpt _3wu08hz0",
    neutral: "_1b3i1gvk _9aea8hz0 _3wu01gvk",
    inverse: "_1b3i1501 _9aeau67f _3wu01501",
    legacy: "_1b3idoyu _9aeaqlpt _3wu08hz0"
};
const rovoDarkAppearanceMap = {
    brand: "_170318uv _1evo18uv _epb518uv _1osd18uv",
    neutral: "_17031gvk _1evo1gvk _epb51gvk _1osd1gvk",
    inverse: "_1703qlpt _1evoqlpt _epb5qlpt _1osdqlpt",
    legacy: "_1703doyu _1evodoyu _epb5doyu _1osddoyu"
};
const rovoLightAppearanceMap = {
    brand: "_170318uv _1evo18uv _epb518uv _1osd18uv",
    neutral: "_17031e01 _1evo1e01 _epb51e01 _1osd1e01",
    inverse: "_1703u67f _1evou67f _epb5u67f _1osdu67f",
    legacy: "_1703doyu _1evodoyu _epb5doyu _1osddoyu"
}; /* eslint-enable @atlaskit/ui-styling-standard/no-imported-style-values */ 
/* eslint-enable @atlaskit/ui-styling-standard/no-unsafe-values */ const sizeMap = {
    xxsmall: "_4t3i7vkz",
    xsmall: "_4t3igktf",
    small: "_4t3i1tcg",
    medium: "_4t3izwfg",
    large: "_4t3i1ylp",
    xlarge: "_4t3ickbl",
    '12': "_4t3i1crf",
    '16': "_4t3i7vkz",
    '20': "_4t3igktf",
    '24': "_4t3i1tcg",
    '32': "_4t3izwfg"
};
function IconWrapper({ size = '20', label, svg, customThemeSvg, testId: userDefinedTestId, appearance = 'brand', iconColor: customIconColor, isAssets = false, type = 'tile' }) {
    const testId = userDefinedTestId && `${userDefinedTestId}--wrapper`;
    const isCustomThemed = customThemeSvg && customIconColor;
    const { colorMode } = (0, _useThemeObserver.useThemeObserver)();
    return /*#__PURE__*/ _react.createElement("span", {
        "data-testid": testId,
        style: {
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values
            '--themed-icon-color': customIconColor || 'initial'
        },
        "aria-label": label ? label : undefined,
        role: label ? 'img' : undefined,
        "aria-hidden": label === '' ? true : undefined,
        // This is because the SVG elements are static and will not change, so we get a little performance benefit by
        // bypassing React.
        dangerouslySetInnerHTML: {
            __html: isCustomThemed ? customThemeSvg : svg
        },
        className: (0, _runtime.ax)([
            styles.root,
            sizeMap[size],
            colorMode === 'dark' ? dataCenterDarkAppearanceMap[appearance] : dataCenterLightAppearanceMap[appearance],
            type === 'rovo' ? colorMode === 'dark' ? rovoDarkAppearanceMap[appearance] : rovoLightAppearanceMap[appearance] : colorMode === 'dark' ? cloudDarkAppearanceMap[appearance] : cloudLightAppearanceMap[appearance],
            isAssets && appearance === 'brand' && ((0, _platformFeatureFlags.fg)('assets-platform-branding') || (0, _platformFeatureFlags.fg)('assets-platform-branding-with-confluence')) && styles.TEMP_assets
        ])
    });
}

},{"react":"ltHCL","@compiled/react/runtime":"d27Vo","@atlaskit/platform-feature-flags":"8rD2i","@atlaskit/tokens/use-theme-observer":"4S775","@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"9SnyQ":[function(require,module,exports,__globalThis) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::cb1b5c1084ec5af5d6446030d431f52c>>
 * @codegenCommand yarn workspace @atlaskit/logo generate:components
 */ var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
/**
 * __AdminLogoCS__
 *
 * An internal component to represent the logo for Admin.
 *
 */ parcelHelpers.export(exports, "AdminLogoCS", ()=>AdminLogoCS);
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _logoWrapper = require("../../../utils/logo-wrapper");
// `height` is set to 100% to allow the SVG to scale with the parent element
// The text color is set to "currentColor" to allow the SVG to inherit the color set by the parent based on the theme.
const svg = `<svg height="100%" viewBox="0 0 126 32">
    <path fill="var(--text-color, #1e1f21)" d="M124.84 16.35v8.99h-2.64v-9.26c0-2.76-1.1-3.99-3.62-3.99-2.45 0-4.14 1.63-4.14 4.72v8.53h-2.64V10h2.64v2.51c.98-1.81 2.79-2.82 4.85-2.82 3.53 0 5.55 2.42 5.55 6.66m-20.15-10.4c0-1.17.77-1.84 1.84-1.84s1.84.67 1.84 1.84-.77 1.84-1.84 1.84-1.84-.67-1.84-1.84m.49 19.38V10h2.64v15.33zm-14.07-8.52v8.53h-2.64v-9.26c0-2.76-1.1-3.99-3.62-3.99-2.45 0-4.14 1.63-4.14 4.72v8.53h-2.64V10h2.64v2.51c.98-1.81 2.79-2.82 4.85-2.82 2.61 0 4.39 1.32 5.15 3.74.86-2.36 2.91-3.74 5.46-3.74 3.44 0 5.34 2.33 5.34 6.66v8.99h-2.64v-8.52c0-3.16-1.1-4.72-3.62-4.72-2.45 0-4.14 1.63-4.14 4.72m-28.32.85c0 3.68 1.47 5.52 4.2 5.52 2.36 0 4.48-1.5 4.48-4.91v-1.23c0-3.4-1.93-4.91-4.17-4.91-2.97 0-4.51 1.96-4.51 5.52m8.68 7.67v-2.76c-.98 2.02-2.82 3.07-5.18 3.07-4.08 0-6.13-3.46-6.13-7.97 0-4.32 2.15-7.97 6.44-7.97 2.24 0 3.96 1.01 4.88 3.01V3.59h2.64v21.74zm-22.02-4.01c-1.53 0-3.1-.18-4.81-.52l-1.69 4.54h-3.1l7.94-20.15h3.5l7.94 20.15h-3.1l-1.69-4.57c-1.81.37-3.37.55-5 .55m0-2.45c1.29 0 2.61-.15 4.17-.4L49.53 7.43 45.45 18.5c1.5.25 2.76.37 3.99.37"/>
    <path fill="var(--tile-color,#dddee1)" d="M0 8a8 8 0 0 1 8-8h16a8 8 0 0 1 8 8v16a8 8 0 0 1-8 8H8a8 8 0 0 1-8-8z"/>
    <path fill="var(--icon-color, #101214)" fill-rule="evenodd" d="M13.826 6.4h4.255l1.338 3.569 3.76-.626 2.128 3.684-2.422 2.945 2.421 2.943L23.18 22.6l-3.76-.626-1.338 3.57h-4.255l-1.338-3.57-3.76.625L6.6 18.915l2.421-2.943L6.6 13.028l2.127-3.685 3.76.626zm2.128 13.16a3.59 3.59 0 1 0 0-7.178 3.59 3.59 0 0 0 0 7.179" clip-rule="evenodd"/>
</svg>
`;
function AdminLogoCS({ size, appearance = 'brand', label = 'Admin', testId }) {
    return /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _logoWrapper.LogoWrapper), {
        svg: svg,
        label: label,
        appearance: appearance,
        size: size,
        testId: testId
    });
}

},{"react":"ltHCL","../../../utils/logo-wrapper":"aSXlT","@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"aSXlT":[function(require,module,exports,__globalThis) {
/* logo-wrapper.tsx generated by @compiled/babel-plugin v0.39.1 */ /* eslint-disable @atlaskit/ui-styling-standard/no-imported-style-values */ var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "LogoWrapper", ()=>LogoWrapper);
var _react = require("react");
var _runtime = require("@compiled/react/runtime");
var _platformFeatureFlags = require("@atlaskit/platform-feature-flags");
var _useThemeObserver = require("@atlaskit/tokens/use-theme-observer");
const styles = {
    root: "_1e0c1o8l _vwz4idpf",
    TEMP_assets: "_9aea1fkg"
}; // These styles set the `color` property so that the child SVG can inherit the correct text color using "currentColor"
const logoTextColorMap = {
    light: "_syazqlpt",
    dark: "_syazz6c6"
};
const sizeMap = {
    xxsmall: "_4t3i7vkz",
    xsmall: "_4t3igktf",
    small: "_4t3i1tcg",
    medium: "_4t3izwfg",
    large: "_4t3i1ylp",
    xlarge: "_4t3ickbl"
}; /* eslint-disable @atlaskit/ui-styling-standard/no-imported-style-values */ 
/* eslint-disable @atlaskit/ui-styling-standard/no-unsafe-values */ const textLightAppearanceMap = {
    brand: "_1wyci7uo",
    neutral: "_1wyc1e01",
    inverse: "_1wycu67f",
    legacy: "_1wycu67f"
}; /* eslint-disable @atlaskit/ui-styling-standard/no-imported-style-values */ 
/* eslint-disable @atlaskit/ui-styling-standard/no-unsafe-values */ const textDarkAppearanceMap = {
    brand: "_1wyci7uo",
    neutral: "_1wyc1gvk",
    inverse: "_1wyc5a6q",
    legacy: "_1wycu67f"
}; /* eslint-disable @atlaskit/ui-styling-standard/no-imported-style-values */ 
/* eslint-disable @atlaskit/ui-styling-standard/no-unsafe-values */ const cloudLightAppearanceMap = {
    brand: "_1b3i18uv _9aea18uv",
    neutral: "_1b3i1e01 _9aea1fkg",
    inverse: "_1b3i5a6q _9aeau67f",
    legacy: "_1b3iu67f _9aeadoyu"
}; /* eslint-disable @atlaskit/ui-styling-standard/no-imported-style-values */ 
/* eslint-disable @atlaskit/ui-styling-standard/no-unsafe-values */ const cloudDarkAppearanceMap = {
    brand: "_1b3i18uv _9aea18uv",
    neutral: "_1b3i1gvk _9aea8hz0",
    inverse: "_1b3iu67f _9aea5a6q",
    legacy: "_1b3iu67f _9aeadoyu"
}; /* eslint-disable @atlaskit/ui-styling-standard/no-imported-style-values */ 
/* eslint-disable @atlaskit/ui-styling-standard/no-unsafe-values */ const dataCenterLightAppearanceMap = {
    brand: "_1b3idoyu _9aeau67f _3wu01fkg",
    neutral: "_1b3i1e01 _9aea1fkg _3wu01e01",
    inverse: "_1b3iu67f _9aeaqlpt _3wu0u67f",
    legacy: "_1b3idoyu _9aeau67f _3wu01fkg"
}; /* eslint-disable @atlaskit/ui-styling-standard/no-imported-style-values */ 
/* eslint-disable @atlaskit/ui-styling-standard/no-unsafe-values */ const dataCenterDarkAppearanceMap = {
    brand: "_1b3idoyu _9aeaqlpt _3wu08hz0",
    neutral: "_1b3i1gvk _9aea8hz0 _3wu01gvk",
    inverse: "_1b3i1501 _9aeau67f _3wu01501",
    legacy: "_1b3idoyu _9aeaqlpt _3wu08hz0"
};
const rovoDarkAppearanceMap = {
    brand: "_1703lrxy _1evoh727 _epb51yy8 _1osdxeun",
    neutral: "_17031gvk _1evo1gvk _epb51gvk _1osd1gvk",
    inverse: "_1703qlpt _1evoqlpt _epb5qlpt _1osdqlpt",
    legacy: "_1703doyu _1evodoyu _epb5doyu _1osddoyu"
};
const rovoLightAppearanceMap = {
    brand: "_170318uv _1evo18uv _epb518uv _1osd18uv",
    neutral: "_17031e01 _1evo1e01 _epb51e01 _1osd1e01",
    inverse: "_1703u67f _1evou67f _epb5u67f _1osdu67f",
    legacy: "_1703doyu _1evodoyu _epb5doyu _1osddoyu"
}; /* eslint-enable @atlaskit/ui-styling-standard/no-imported-style-values */ 
function LogoWrapper({ appearance = 'brand', size = 'small', svg, customThemeSvg, label, testId: userDefinedTestId, iconColor: customIconColor, textColor: customTextColor, isAssets = false, type = 'tile' }) {
    const { colorMode } = (0, _useThemeObserver.useThemeObserver)();
    const testId = userDefinedTestId && `${userDefinedTestId}--wrapper`;
    const isCustomThemed = customThemeSvg && (customIconColor || customTextColor);
    return /*#__PURE__*/ _react.createElement("span", {
        style: {
            // Nav v3 passes in "inherit" incorrectly for iconColor, so we fall back to textColor when this happens.
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values
            '--themed-icon-color': customIconColor === 'inherit' ? customTextColor : customIconColor,
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values
            '--themed-text-color': customTextColor || 'inherit'
        },
        "data-testid": testId,
        "aria-label": label ? label : undefined,
        role: label ? 'img' : undefined,
        "aria-hidden": label === '' ? true : undefined,
        // This is because the SVG elements are static and will not change, so we get a little performance benefit by
        // bypassing React.
        dangerouslySetInnerHTML: {
            __html: isCustomThemed ? customThemeSvg : svg
        },
        className: (0, _runtime.ax)([
            styles.root,
            // Setting the color so that the SVG can inherit the correct text color using "currentColor"
            logoTextColorMap[colorMode !== null && colorMode !== void 0 ? colorMode : 'light'],
            sizeMap[size],
            colorMode === 'dark' ? textDarkAppearanceMap[appearance] : textLightAppearanceMap[appearance],
            colorMode === 'dark' ? dataCenterDarkAppearanceMap[appearance] : dataCenterLightAppearanceMap[appearance],
            type === 'rovo' ? colorMode === 'dark' ? rovoDarkAppearanceMap[appearance] : rovoLightAppearanceMap[appearance] : colorMode === 'dark' ? cloudDarkAppearanceMap[appearance] : cloudLightAppearanceMap[appearance],
            isAssets && appearance === 'brand' && ((0, _platformFeatureFlags.fg)('assets-platform-branding') || (0, _platformFeatureFlags.fg)('assets-platform-branding-with-confluence')) && styles.TEMP_assets
        ])
    });
}

},{"react":"ltHCL","@compiled/react/runtime":"d27Vo","@atlaskit/platform-feature-flags":"8rD2i","@atlaskit/tokens/use-theme-observer":"4S775","@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"fgU9J":[function(require,module,exports,__globalThis) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::d8dc880eda57906914bb7837c5a5c673>>
 * @codegenCommand yarn workspace @atlaskit/logo generate:components
 */ var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
/**
 * __AlignIcon__
 *
 * An internal component to represent the icon for Align.
 * Do not use this internal component directly — use `AlignIcon` from `@atlaskit/logo` instead.
 *
 */ parcelHelpers.export(exports, "AlignIcon", ()=>AlignIcon);
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _iconWrapper = require("../../../utils/icon-wrapper");
// `height` is set to 100% to allow the SVG to scale with the parent element
const svg = `<svg height="100%" viewBox="0 0 24 24">
    <path fill="var(--tile-color,#fb9700)" d="M0 6a6 6 0 0 1 6-6h12a6 6 0 0 1 6 6v12a6 6 0 0 1-6 6H6a6 6 0 0 1-6-6z"/>
    <path fill="var(--icon-color, #101214)" d="M18.545 18.545a4.49 4.49 0 0 0-4.48-4.48h-4.13v-3.78h-4.48v7.434c0 .576.25.826.826.826zM5.455 5.455a4.454 4.454 0 0 0 4.455 4.48h4.155v3.78h4.48V6.28q0-.825-.826-.826z"/>
</svg>
`;
function AlignIcon({ size, appearance = 'brand', label = 'Align', testId }) {
    return /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _iconWrapper.IconWrapper), {
        svg: svg,
        label: label,
        appearance: appearance,
        size: size,
        testId: testId
    });
}

},{"react":"ltHCL","../../../utils/icon-wrapper":"4NqBa","@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"6hCZ1":[function(require,module,exports,__globalThis) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::b50cb2ad76b4dba28f22d4bb555219f7>>
 * @codegenCommand yarn workspace @atlaskit/logo generate:components
 */ var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
/**
 * __AlignLogoCS__
 *
 * An internal component to represent the logo for Align.
 *
 */ parcelHelpers.export(exports, "AlignLogoCS", ()=>AlignLogoCS);
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _logoWrapper = require("../../../utils/logo-wrapper");
// `height` is set to 100% to allow the SVG to scale with the parent element
// The text color is set to "currentColor" to allow the SVG to inherit the color set by the parent based on the theme.
const svg = `<svg height="100%" viewBox="0 0 106 32">
    <path fill="var(--text-color, #1e1f21)" d="M105.76 16.35v8.99h-2.64v-9.26c0-2.76-1.1-3.99-3.62-3.99-2.45 0-4.14 1.63-4.14 4.72v8.53h-2.63V10h2.64v2.52c.98-1.81 2.79-2.82 4.85-2.82 3.53 0 5.55 2.42 5.55 6.66m-19.6 7.75v-1.53c-.98 2.02-2.82 3.07-5.18 3.07-4.05 0-6.07-3.46-6.07-7.97 0-4.32 2.12-7.97 6.38-7.97 2.24 0 3.96 1.01 4.88 3.01V10h2.58v13.95c0 4.51-2.12 7.54-7.61 7.54-2.58 0-3.99-.34-5.46-.83v-2.58c1.69.55 3.43.92 5.34.92 3.83 0 5.15-2.05 5.15-4.91m-8.68-6.44c0 3.68 1.47 5.52 4.2 5.52 2.36 0 4.48-1.5 4.48-4.91v-1.23c0-3.4-1.93-4.91-4.17-4.91-2.97 0-4.51 1.96-4.51 5.52M68.73 5.95c0-1.17.77-1.84 1.84-1.84s1.84.67 1.84 1.84-.77 1.84-1.84 1.84-1.84-.67-1.84-1.84m.49 19.38V10h2.64v15.33zm-2.54-.03c-.21.06-.67.12-1.35.12-2.51 0-4.11-1.19-4.11-4.02V3.59h2.64V21.1c0 1.38.92 1.87 2.06 1.87.28 0 .46 0 .77-.03zM49.6 21.32c-1.53 0-3.1-.18-4.82-.52l-1.69 4.54H40l7.94-20.15h3.5l7.94 20.15h-3.1l-1.69-4.57c-1.81.37-3.37.55-5 .55m0-2.45c1.29 0 2.61-.15 4.17-.4L49.68 7.43 45.6 18.5c1.5.25 2.76.37 3.99.37"/>
    <path fill="var(--tile-color,#fb9700)" d="M0 8a8 8 0 0 1 8-8h16a8 8 0 0 1 8 8v16a8 8 0 0 1-8 8H8a8 8 0 0 1-8-8z"/>
    <path fill="var(--icon-color, #101214)" d="M23.735 23.735c0-2.928-2.396-5.295-5.295-5.295h-4.88v-4.466H8.265v8.785c0 .68.296.976.976.976zM8.265 8.265c0 2.928 2.337 5.295 5.265 5.295h4.91v4.466h5.295V9.241q0-.976-.976-.976z"/>
</svg>
`;
function AlignLogoCS({ size, appearance = 'brand', label = 'Align', testId }) {
    return /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _logoWrapper.LogoWrapper), {
        svg: svg,
        label: label,
        appearance: appearance,
        size: size,
        testId: testId
    });
}

},{"react":"ltHCL","../../../utils/logo-wrapper":"aSXlT","@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"5XmVS":[function(require,module,exports,__globalThis) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::93b4dea5ca940a35aa6da4a3e32efaba>>
 * @codegenCommand yarn workspace @atlaskit/logo generate:components
 */ var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
/**
 * __AnalyticsIcon__
 *
 * An internal component to represent the icon for Analytics.
 * Do not use this internal component directly — use `AnalyticsIcon` from `@atlaskit/logo` instead.
 *
 */ parcelHelpers.export(exports, "AnalyticsIcon", ()=>AnalyticsIcon);
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _iconWrapper = require("../../../utils/icon-wrapper");
// `height` is set to 100% to allow the SVG to scale with the parent element
const svg = `<svg height="100%" viewBox="0 0 24 24">
    <path fill="var(--tile-color,#dddee1)" d="M0 6a6 6 0 0 1 6-6h12a6 6 0 0 1 6 6v12a6 6 0 0 1-6 6H6a6 6 0 0 1-6-6z"/>
    <path fill="var(--icon-color, #101214)" d="M14.63 5.88v9.19h3.06v-9.2zM5.88 18.13h11.81v-1.75H5.87zm0-3.07v-4.81h3.06v4.81zm4.37-6.56v6.56h3.06V8.5z"/>
</svg>
`;
function AnalyticsIcon({ size, appearance = 'brand', label = 'Analytics', testId }) {
    return /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _iconWrapper.IconWrapper), {
        svg: svg,
        label: label,
        appearance: appearance,
        size: size,
        testId: testId
    });
}

},{"react":"ltHCL","../../../utils/icon-wrapper":"4NqBa","@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"88sB4":[function(require,module,exports,__globalThis) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::19cf5335c393da35608b01fe889f5c46>>
 * @codegenCommand yarn workspace @atlaskit/logo generate:components
 */ var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
/**
 * __AnalyticsLogoCS__
 *
 * An internal component to represent the logo for Analytics.
 *
 */ parcelHelpers.export(exports, "AnalyticsLogoCS", ()=>AnalyticsLogoCS);
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _logoWrapper = require("../../../utils/logo-wrapper");
// `height` is set to 100% to allow the SVG to scale with the parent element
// The text color is set to "currentColor" to allow the SVG to inherit the color set by the parent based on the theme.
const svg = `<svg height="100%" viewBox="0 0 161 32">
    <path fill="var(--text-color, #1e1f21)" d="M160.66 21.16c0 2.55-1.66 4.48-5.76 4.48-2.3 0-4.17-.52-5.34-1.13v-2.79c1.32.77 3.53 1.5 5.46 1.5 2.02 0 3.07-.83 3.07-2.02 0-1.17-.89-1.84-3.8-2.55-3.4-.83-4.85-2.15-4.85-4.66 0-2.67 2.06-4.29 5.55-4.29 1.99 0 3.8.49 4.94 1.1v2.73c-1.84-.92-3.34-1.41-4.97-1.41-1.93 0-2.97.67-2.97 1.87 0 1.07.74 1.75 3.56 2.42 3.4.83 5.12 2.09 5.12 4.75m-13.6 1.41v2.36c-.92.49-2.33.71-3.74.71-5.46 0-8-3.31-8-8 0-4.63 2.55-7.94 8-7.94 1.38 0 2.45.18 3.65.74v2.45c-.98-.46-2.02-.74-3.47-.74-3.99 0-5.61 2.52-5.61 5.49s1.66 5.49 5.67 5.49c1.56 0 2.55-.21 3.5-.55M129.13 5.95c0-1.16.77-1.84 1.84-1.84s1.84.68 1.84 1.84-.77 1.84-1.84 1.84-1.84-.67-1.84-1.84m.49 19.38V10h2.64v15.33zm-7.46-4.75c0 1.35.8 2.27 2.42 2.27.61 0 1.2-.12 1.66-.21v2.55c-.46.12-.98.25-1.78.25-3.28 0-4.88-1.93-4.88-4.78v-8.19h-2.48V10h2.48V6.75h2.58V10h4.08v2.45h-4.08zm-14.12 3.77h-1.72L100.77 10h2.82l4.91 13.13L113.41 10h2.82l-5.8 14.84c-1.72 4.39-2.7 6.66-6.59 6.66-1.32 0-2.05-.12-2.82-.43V28.8c.89.28 1.9.37 2.67.37 2.15 0 3.1-1.47 4.36-4.81m-7.8.94c-.21.06-.67.12-1.35.12-2.51 0-4.11-1.19-4.11-4.02V3.59h2.64V21.1c0 1.38.92 1.87 2.06 1.87.28 0 .46 0 .77-.03zM79.5 17.67c0 3.68 1.47 5.52 4.2 5.52 2.36 0 4.48-1.5 4.48-4.91v-1.23c0-3.4-1.93-4.91-4.17-4.91-2.97 0-4.51 1.96-4.51 5.52m8.68 7.67v-2.76c-.98 2.02-2.82 3.07-5.18 3.07-4.08 0-6.13-3.47-6.13-7.97 0-4.32 2.15-7.97 6.44-7.97 2.24 0 3.96 1.01 4.88 3.01V10h2.64v15.33zM74.1 16.35v8.99h-2.64v-9.26c0-2.76-1.1-3.99-3.62-3.99-2.45 0-4.14 1.63-4.14 4.72v8.53h-2.63V10h2.64v2.51c.98-1.81 2.79-2.82 4.85-2.82 3.53 0 5.55 2.42 5.55 6.66m-24.66 4.97c-1.53 0-3.1-.18-4.81-.52l-1.69 4.54h-3.1l7.94-20.15h3.5l7.94 20.15h-3.1l-1.69-4.57c-1.81.37-3.37.55-5 .55m0-2.45c1.29 0 2.61-.15 4.17-.4L49.53 7.43 45.45 18.5c1.5.25 2.76.37 3.99.37"/>
    <path fill="var(--tile-color,#dddee1)" d="M0 8a8 8 0 0 1 8-8h16a8 8 0 0 1 8 8v16a8 8 0 0 1-8 8H8a8 8 0 0 1-8-8z"/>
    <path fill="var(--icon-color, #101214)" d="M19.5 7.83v12.25h4.08V7.83zM7.83 24.17h15.75v-2.33H7.83zm0-4.09v-6.42h4.08v6.42zm5.84-8.75v8.75h4.08v-8.75z"/>
</svg>
`;
function AnalyticsLogoCS({ size, appearance = 'brand', label = 'Analytics', testId }) {
    return /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _logoWrapper.LogoWrapper), {
        svg: svg,
        label: label,
        appearance: appearance,
        size: size,
        testId: testId
    });
}

},{"react":"ltHCL","../../../utils/logo-wrapper":"aSXlT","@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"NIrnl":[function(require,module,exports,__globalThis) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::70585722d0ca9257d878eccc1885f195>>
 * @codegenCommand yarn workspace @atlaskit/logo generate:components
 */ var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
/**
 * __AssetsIcon__
 *
 * An internal component to represent the icon for Assets.
 * Do not use this internal component directly — use `AssetsIcon` from `@atlaskit/logo` instead.
 *
 */ parcelHelpers.export(exports, "AssetsIcon", ()=>AssetsIcon);
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _iconWrapper = require("../../../utils/icon-wrapper");
// `height` is set to 100% to allow the SVG to scale with the parent element
const svg = `<svg height="100%" viewBox="0 0 24 24">
    <path fill="var(--tile-color,#ffc716)" d="M0 6a6 6 0 0 1 6-6h12a6 6 0 0 1 6 6v12a6 6 0 0 1-6 6H6a6 6 0 0 1-6-6z"/>
    <path fill="var(--icon-color, #101214)" fill-rule="evenodd" d="M8.34 11.495a3.64 3.64 0 0 0 3.155-3.154h2.3V6.523h-2.537a3.638 3.638 0 1 0-4.735 4.735v2.538H8.34zM7.887 9.25a1.364 1.364 0 1 0 0-2.727 1.364 1.364 0 0 0 0 2.727" clip-rule="evenodd"/>
    <path fill="var(--icon-color, #101214)" d="M19.25 7.43a2.27 2.27 0 1 1-4.54 0 2.27 2.27 0 0 1 4.55 0M7.43 19.25a2.27 2.27 0 1 0 0-4.54 2.27 2.27 0 0 0 0 4.55m9.55-.01a2.27 2.27 0 1 0 0-4.54 2.27 2.27 0 0 0 0 4.55m-3.18-3.19h-3.18v1.82h3.18zm2.27-5.46v3.18h1.82v-3.18z"/>
</svg>
`;
const customThemeSvg = `<svg height="100%" viewBox="0 0 24 24">
    <path fill="var(--themed-icon-color, currentcolor)" d="M18 0a6 6 0 0 1 6 6v12a6 6 0 0 1-6 6H6a6 6 0 0 1-6-6V6a6 6 0 0 1 6-6zM7.432 14.704a2.273 2.273 0 1 0 .001 4.547 2.273 2.273 0 0 0-.001-4.547m9.545 0a2.274 2.274 0 1 0 .001 4.548 2.274 2.274 0 0 0 0-4.548m-6.364 1.364v1.819h3.183v-1.819zM7.887 4.25a3.637 3.637 0 0 0-1.365 7.009v2.537h1.819v-2.302a3.64 3.64 0 0 0 3.153-3.153h2.302V6.522h-2.537A3.64 3.64 0 0 0 7.887 4.25m8.181 6.363v3.183h1.819v-3.183zm.91-5.454a2.273 2.273 0 1 0 0 4.547 2.273 2.273 0 0 0 0-4.547M7.887 6.522a1.364 1.364 0 1 1-.002 2.729 1.364 1.364 0 0 1 .002-2.729"/>
</svg>
`;
function AssetsIcon({ iconColor, size, appearance = 'brand', label = 'Assets', testId }) {
    return /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _iconWrapper.IconWrapper), {
        svg: svg,
        customThemeSvg: customThemeSvg,
        iconColor: iconColor,
        label: label,
        isAssets: true,
        appearance: appearance,
        size: size,
        testId: testId
    });
}

},{"react":"ltHCL","../../../utils/icon-wrapper":"4NqBa","@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"2Xfd6":[function(require,module,exports,__globalThis) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::e69fa4e6ed45c9755193e19593b57593>>
 * @codegenCommand yarn workspace @atlaskit/logo generate:components
 */ var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
/**
 * __AssetsLogoCS__
 *
 * An internal component to represent the logo for Assets.
 *
 */ parcelHelpers.export(exports, "AssetsLogoCS", ()=>AssetsLogoCS);
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _logoWrapper = require("../../../utils/logo-wrapper");
// `height` is set to 100% to allow the SVG to scale with the parent element
// The text color is set to "currentColor" to allow the SVG to inherit the color set by the parent based on the theme.
const svg = `<svg height="100%" viewBox="0 0 126 32">
    <path fill="var(--text-color, #1e1f21)" d="M125.8 21.16c0 2.55-1.66 4.48-5.76 4.48-2.3 0-4.17-.52-5.34-1.13v-2.79c1.32.77 3.53 1.5 5.46 1.5 2.02 0 3.07-.83 3.07-2.02 0-1.16-.89-1.84-3.8-2.54-3.4-.83-4.84-2.15-4.84-4.66 0-2.67 2.06-4.29 5.55-4.29 1.99 0 3.8.49 4.94 1.1v2.73c-1.84-.92-3.34-1.41-4.97-1.41-1.93 0-2.97.67-2.97 1.87 0 1.07.74 1.75 3.56 2.42 3.4.83 5.12 2.09 5.12 4.75m-17.77-.59c0 1.35.8 2.27 2.42 2.27.61 0 1.2-.12 1.66-.21v2.55c-.46.12-.98.25-1.78.25-3.28 0-4.88-1.93-4.88-4.78v-8.19h-2.48V10h2.48V6.75h2.58V10h4.08v2.45h-4.08zm-13.53-8.5c-2.79 0-4.2 1.81-4.48 4.48h8.56c-.15-2.85-1.44-4.48-4.08-4.48m5.89 12.64c-1.26.68-3.19.92-4.75.92-5.73 0-8.25-3.31-8.25-8 0-4.63 2.58-7.94 7.24-7.94 4.72 0 6.62 3.28 6.62 7.94v1.2h-11.2c.37 2.61 2.05 4.29 5.67 4.29 1.78 0 3.28-.34 4.66-.83zm-15.13-3.56c0 2.55-1.66 4.48-5.77 4.48-2.3 0-4.17-.52-5.34-1.13v-2.79c1.32.77 3.53 1.5 5.46 1.5 2.02 0 3.07-.83 3.07-2.02 0-1.16-.89-1.84-3.8-2.54-3.4-.83-4.85-2.15-4.85-4.66 0-2.67 2.06-4.29 5.55-4.29 1.99 0 3.8.49 4.94 1.1v2.73c-1.84-.92-3.34-1.41-4.97-1.41-1.93 0-2.97.67-2.97 1.87 0 1.07.74 1.75 3.56 2.42 3.4.83 5.12 2.09 5.12 4.75m-13.63-.01c0 2.55-1.66 4.48-5.76 4.48-2.3 0-4.17-.52-5.34-1.13v-2.79c1.32.77 3.53 1.5 5.46 1.5 2.02 0 3.07-.83 3.07-2.02 0-1.16-.89-1.84-3.8-2.54-3.4-.83-4.84-2.15-4.84-4.66 0-2.67 2.06-4.29 5.55-4.29 1.99 0 3.8.49 4.94 1.1v2.73c-1.84-.92-3.34-1.41-4.97-1.41-1.93 0-2.97.67-2.97 1.87 0 1.07.74 1.75 3.56 2.42 3.4.83 5.12 2.09 5.12 4.75m-22.22.15c-1.53 0-3.1-.18-4.81-.52l-1.69 4.54h-3.1l7.94-20.15h3.5l7.94 20.15h-3.1l-1.69-4.57c-1.81.37-3.37.55-5 .55m0-2.45c1.29 0 2.61-.15 4.17-.4L49.53 7.43 45.45 18.5c1.5.25 2.76.37 3.99.37"/>
    <path fill="var(--tile-color,#ffc716)" d="M0 8a8 8 0 0 1 8-8h16a8 8 0 0 1 8 8v16a8 8 0 0 1-8 8H8a8 8 0 0 1-8-8z"/>
    <path fill="var(--icon-color, #101214)" fill-rule="evenodd" d="M11.667 15.425a4.335 4.335 0 0 0 3.758-3.758h2.742V9.5h-3.023A4.335 4.335 0 1 0 9.5 15.144v3.023h2.167zm-.542-2.675a1.625 1.625 0 1 0 0-3.25 1.625 1.625 0 0 0 0 3.25" clip-rule="evenodd"/>
    <path fill="var(--icon-color, #101214)" d="M24.67 10.58a2.71 2.71 0 1 1-5.42 0 2.71 2.71 0 0 1 5.42 0M10.58 24.67a2.71 2.71 0 1 0 0-5.42 2.71 2.71 0 0 0 0 5.42m11.38 0a2.71 2.71 0 1 0 0-5.42 2.71 2.71 0 0 0 0 5.42m-3.79-3.79h-3.79v2.17h3.79zm2.71-6.5v3.79h2.17v-3.79z"/>
</svg>
`;
function AssetsLogoCS({ size, appearance = 'brand', label = 'Assets', testId }) {
    return /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _logoWrapper.LogoWrapper), {
        svg: svg,
        label: label,
        isAssets: true,
        appearance: appearance,
        size: size,
        testId: testId
    });
}

},{"react":"ltHCL","../../../utils/logo-wrapper":"aSXlT","@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"8aZ5i":[function(require,module,exports,__globalThis) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::4355cde32d77e58b21f0c95828a80152>>
 * @codegenCommand yarn workspace @atlaskit/logo generate:components
 */ var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
/**
 * __BambooIcon__
 *
 * An internal component to represent the icon for Bamboo.
 * Do not use this internal component directly — use `BambooIcon` from `@atlaskit/logo` instead.
 *
 */ parcelHelpers.export(exports, "BambooIcon", ()=>BambooIcon);
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _iconWrapper = require("../../../utils/icon-wrapper");
// `height` is set to 100% to allow the SVG to scale with the parent element
const svg = `<svg height="100%" viewBox="0 0 24 24">
    <path fill="var(--tile-color, white)" d="M6 .5h12A5.5 5.5 0 0 1 23.5 6v12a5.5 5.5 0 0 1-5.5 5.5H6A5.5 5.5 0 0 1 .5 18V6A5.5 5.5 0 0 1 6 .5"/>
    <path fill="none" stroke="var(--border-color, #dddee1)" d="M6 .5h12A5.5 5.5 0 0 1 23.5 6v12a5.5 5.5 0 0 1-5.5 5.5H6A5.5 5.5 0 0 1 .5 18V6A5.5 5.5 0 0 1 6 .5Z"/>
    <path fill="var(--icon-color, #1868db)" d="M9.215 12.652a2.75 2.75 0 0 0 2.749 2.742v4.205a6.964 6.964 0 0 1-6.849-5.727l-.049-.317zm9.26 0a.44.44 0 0 1 .436.468c-.222 3.311-2.783 5.989-6.043 6.414l-.904-4.14a2.75 2.75 0 0 0 2.723-2.37.44.44 0 0 1 .44-.372zM11.963 9.91a2.75 2.75 0 0 0-2.748 2.742H5v-.065c.033-3.495 2.668-6.374 6.059-6.816zm0-5.972a.436.436 0 0 1 .72-.33l4.824 4.138a.436.436 0 0 1 0 .662l-4.823 4.139a.436.436 0 0 1-.72-.331z"/>
</svg>
`;
function BambooIcon({ size, appearance = 'brand', label = 'Bamboo', testId }) {
    return /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _iconWrapper.IconWrapper), {
        svg: svg,
        label: label,
        type: "data-center",
        appearance: appearance,
        size: size,
        testId: testId
    });
}

},{"react":"ltHCL","../../../utils/icon-wrapper":"4NqBa","@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"gFP9D":[function(require,module,exports,__globalThis) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::a8b53caccfaf8935cadc28439cd96493>>
 * @codegenCommand yarn workspace @atlaskit/logo generate:components
 */ var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
/**
 * __BambooLogoCS__
 *
 * An internal component to represent the logo for Bamboo.
 *
 */ parcelHelpers.export(exports, "BambooLogoCS", ()=>BambooLogoCS);
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _logoWrapper = require("../../../utils/logo-wrapper");
// `height` is set to 100% to allow the SVG to scale with the parent element
// The text color is set to "currentColor" to allow the SVG to inherit the color set by the parent based on the theme.
const svg = `<svg height="100%" viewBox="0 0 154 32">
    <path fill="var(--text-color, #1e1f21)" d="M146 25.64c-4.6 0-7.3-3.4-7.3-8s2.7-7.94 7.3-7.94c4.57 0 7.24 3.34 7.24 7.94s-2.67 8-7.24 8m0-13.49c-3.28 0-4.72 2.58-4.72 5.49s1.44 5.55 4.72 5.55c3.25 0 4.66-2.64 4.66-5.55s-1.41-5.49-4.66-5.49m-16.68 13.49c-4.6 0-7.3-3.4-7.3-8s2.7-7.94 7.3-7.94c4.57 0 7.24 3.34 7.24 7.94s-2.67 8-7.24 8m0-13.49c-3.28 0-4.72 2.58-4.72 5.49s1.44 5.55 4.72 5.55c3.25 0 4.66-2.64 4.66-5.55s-1.41-5.49-4.66-5.49m-12.07 5.52c0-3.68-1.47-5.52-4.2-5.52-2.36 0-4.48 1.5-4.48 4.91v1.23c0 3.4 1.93 4.91 4.17 4.91 2.98 0 4.51-1.96 4.51-5.52m-3.8 7.97c-2.24 0-3.96-1.01-4.88-3v2.7h-2.64V3.59h2.64v9.17c.98-2.02 2.82-3.07 5.18-3.07 4.08 0 6.13 3.47 6.13 7.97 0 4.32-2.15 7.97-6.44 7.97m-21.58-8.82v8.53h-2.64v-9.26c0-2.76-1.1-3.99-3.62-3.99-2.45 0-4.14 1.63-4.14 4.72v8.53h-2.64V10h2.64v2.52c.98-1.81 2.79-2.82 4.85-2.82 2.61 0 4.39 1.32 5.15 3.74.86-2.36 2.91-3.74 5.46-3.74 3.43 0 5.34 2.33 5.34 6.66v8.99h-2.64v-8.52c0-3.16-1.1-4.72-3.62-4.72-2.45 0-4.14 1.63-4.14 4.72m-28.32.84c0 3.68 1.47 5.52 4.2 5.52 2.36 0 4.48-1.5 4.48-4.91v-1.23c0-3.4-1.93-4.91-4.17-4.91-2.97 0-4.51 1.96-4.51 5.52m8.68 7.67v-2.76c-.98 2.02-2.82 3.07-5.18 3.07-4.08 0-6.13-3.46-6.13-7.97 0-4.32 2.15-7.97 6.44-7.97 2.24 0 3.96 1.01 4.88 3.01V10h2.64v15.33zm-20.23-9.04H45.8v6.29h6.26c2.64 0 3.83-.95 3.83-2.97 0-2.15-1.13-3.31-3.89-3.31m-.89-8.46h-5.3v6.01h5.31c2.61 0 3.68-1.2 3.68-3.13 0-1.96-1.16-2.88-3.68-2.88m-8.06 17.51V5.19h8.43c4.11 0 6.1 2.02 6.1 5.28 0 2.42-1.1 3.93-3.37 4.48 2.97.49 4.45 2.12 4.45 4.97 0 3.22-2.18 5.43-6.68 5.43z"/>
    <path fill="var(--tile-color, white)" d="M8 .667h16A7.333 7.333 0 0 1 31.333 8v16A7.333 7.333 0 0 1 24 31.333H8A7.333 7.333 0 0 1 .667 24V8A7.333 7.333 0 0 1 8 .667"/>
    <path fill="none" stroke="var(--border-color, #dddee1)" stroke-width="1.333" d="M8 .667h16A7.333 7.333 0 0 1 31.333 8v16A7.333 7.333 0 0 1 24 31.333H8A7.333 7.333 0 0 1 .667 24V8A7.333 7.333 0 0 1 8 .667Z"/>
    <path fill="var(--icon-color, #1868db)" d="M12.287 16.869a3.665 3.665 0 0 0 3.665 3.656v5.607c-4.71 0-8.602-3.52-9.196-8.06zm12.347 0a.584.584 0 0 1 .581.624c-.295 4.415-3.71 7.986-8.057 8.554l-1.206-5.521a3.67 3.67 0 0 0 3.63-3.161.59.59 0 0 1 .589-.496zm-8.683-3.656a3.664 3.664 0 0 0-3.665 3.656h-5.62v-.088c.044-4.66 3.557-8.498 8.078-9.088zm0-7.964a.58.58 0 0 1 .96-.44l6.432 5.518c.27.232.27.65 0 .883l-6.431 5.517a.581.581 0 0 1-.96-.44z"/>
</svg>
`;
function BambooLogoCS({ size, appearance = 'brand', label = 'Bamboo', testId }) {
    return /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _logoWrapper.LogoWrapper), {
        svg: svg,
        label: label,
        type: "data-center",
        appearance: appearance,
        size: size,
        testId: testId
    });
}

},{"react":"ltHCL","../../../utils/logo-wrapper":"aSXlT","@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"fs59x":[function(require,module,exports,__globalThis) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::0a55e042f17bf853ed858530ff13b240>>
 * @codegenCommand yarn workspace @atlaskit/logo generate:components
 */ var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
/**
 * __BitbucketDataCenterIcon__
 *
 * An internal component to represent the icon for Bitbucket Data Center.
 * Do not use this internal component directly — use `BitbucketDataCenterIcon` from `@atlaskit/logo` instead.
 *
 */ parcelHelpers.export(exports, "BitbucketDataCenterIcon", ()=>BitbucketDataCenterIcon);
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _iconWrapper = require("../../../utils/icon-wrapper");
// `height` is set to 100% to allow the SVG to scale with the parent element
const svg = `<svg height="100%" viewBox="0 0 24 24">
    <path fill="var(--tile-color, white)" d="M6 .5h12A5.5 5.5 0 0 1 23.5 6v12a5.5 5.5 0 0 1-5.5 5.5H6A5.5 5.5 0 0 1 .5 18V6A5.5 5.5 0 0 1 6 .5"/>
    <path fill="none" stroke="var(--border-color, #dddee1)" d="M6 .5h12A5.5 5.5 0 0 1 23.5 6v12a5.5 5.5 0 0 1-5.5 5.5H6A5.5 5.5 0 0 1 .5 18V6A5.5 5.5 0 0 1 6 .5Z"/>
    <path fill="var(--icon-color, #1868db)" d="m17.843 11.763-.986 6.024c-.065.365-.322.58-.686.58H7.81c-.365 0-.622-.215-.686-.58L5.387 7.047c-.064-.364.129-.6.472-.6h12.262c.343 0 .536.236.472.6l-.472 2.83c-.064.407-.3.579-.686.579h-7.374c-.107 0-.172.064-.15.193l.579 3.558c.021.086.085.15.171.15h2.658c.086 0 .15-.064.172-.15l.407-2.572c.043-.322.257-.45.558-.45h2.894c.428 0 .557.214.493.578"/>
</svg>
`;
function BitbucketDataCenterIcon({ size, appearance = 'brand', label = 'Bitbucket Data Center', testId }) {
    return /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _iconWrapper.IconWrapper), {
        svg: svg,
        label: label,
        type: "data-center",
        appearance: appearance,
        size: size,
        testId: testId
    });
}

},{"react":"ltHCL","../../../utils/icon-wrapper":"4NqBa","@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"kqkOn":[function(require,module,exports,__globalThis) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::a6cf1e00141abbc39f2d3b5098a9d63a>>
 * @codegenCommand yarn workspace @atlaskit/logo generate:components
 */ var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
/**
 * __BitbucketDataCenterLogoCS__
 *
 * An internal component to represent the logo for Bitbucket Data Center.
 *
 */ parcelHelpers.export(exports, "BitbucketDataCenterLogoCS", ()=>BitbucketDataCenterLogoCS);
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _logoWrapper = require("../../../utils/logo-wrapper");
// `height` is set to 100% to allow the SVG to scale with the parent element
// The text color is set to "currentColor" to allow the SVG to inherit the color set by the parent based on the theme.
const svg = `<svg height="100%" viewBox="0 0 166 32">
    <path fill="var(--text-color, #1e1f21)" d="M161.21 20.58c0 1.35.8 2.27 2.42 2.27.61 0 1.2-.12 1.66-.21v2.55c-.46.12-.98.25-1.78.25-3.28 0-4.88-1.93-4.88-4.78v-8.19h-2.48V10h2.48V6.75h2.58V10h4.08v2.45h-4.08zm-13.53-8.49c-2.79 0-4.2 1.81-4.48 4.48h8.56c-.15-2.85-1.44-4.48-4.08-4.48m5.89 12.64c-1.26.68-3.19.92-4.75.92-5.73 0-8.25-3.31-8.25-8 0-4.63 2.58-7.94 7.24-7.94 4.72 0 6.62 3.28 6.62 7.94v1.2h-11.19c.37 2.61 2.06 4.29 5.67 4.29 1.78 0 3.28-.34 4.66-.83zm-23.83.6h-2.64V3.59h2.64v13.59l6.6-7.18h3.44l-7.21 7.54 7.51 7.79h-3.59l-6.75-7.18zm-5.64-2.76v2.36c-.92.49-2.33.71-3.74.71-5.46 0-8-3.31-8-8 0-4.63 2.55-7.94 8-7.94 1.38 0 2.45.18 3.65.74v2.45c-.98-.46-2.02-.74-3.47-.74-3.99 0-5.61 2.51-5.61 5.49s1.66 5.49 5.67 5.49c1.56 0 2.55-.21 3.5-.55m-27.85-3.59V10h2.64v9.26c0 2.76 1.1 3.99 3.62 3.99 2.45 0 4.14-1.62 4.14-4.72V10h2.64v15.33h-2.64v-2.51c-.98 1.81-2.79 2.82-4.85 2.82-3.53 0-5.55-2.42-5.55-6.65m-5.39-1.32c0-3.68-1.47-5.52-4.2-5.52-2.36 0-4.48 1.5-4.48 4.91v1.23c0 3.4 1.93 4.91 4.17 4.91 2.98 0 4.51-1.96 4.51-5.52m-3.8 7.97c-2.24 0-3.96-1.01-4.88-3v2.7h-2.64V3.59h2.64v9.17c.98-2.02 2.82-3.07 5.18-3.07 4.08 0 6.13 3.47 6.13 7.97 0 4.32-2.15 7.97-6.44 7.97m-14.96-5.05c0 1.35.8 2.27 2.42 2.27.61 0 1.2-.12 1.66-.21v2.55a6.3 6.3 0 0 1-1.78.25c-3.28 0-4.88-1.93-4.88-4.78v-8.19h-2.48V10h2.48V6.75h2.58V10h4.08v2.45h-4.08zM61.33 5.95c0-1.16.77-1.84 1.84-1.84s1.84.68 1.84 1.84-.77 1.84-1.84 1.84-1.84-.67-1.84-1.84m.49 19.38V10h2.64v15.33zm-9.83-9.04H45.8v6.29h6.26c2.64 0 3.83-.95 3.83-2.97 0-2.15-1.13-3.31-3.89-3.31m-.89-8.46h-5.3v6.01h5.31c2.61 0 3.68-1.2 3.68-3.13 0-1.96-1.16-2.88-3.68-2.88m-8.06 17.51V5.19h8.43c4.11 0 6.1 2.02 6.1 5.28 0 2.42-1.1 3.93-3.37 4.48 2.97.49 4.45 2.12 4.45 4.97 0 3.22-2.18 5.43-6.68 5.43z"/>
    <path fill="var(--tile-color, white)" d="M8 .667h16A7.333 7.333 0 0 1 31.333 8v16A7.333 7.333 0 0 1 24 31.333H8A7.333 7.333 0 0 1 .667 24V8A7.333 7.333 0 0 1 8 .667"/>
    <path fill="none" stroke="var(--border-color, #dddee1)" stroke-width="1.333" d="M8 .667h16A7.333 7.333 0 0 1 31.333 8v16A7.333 7.333 0 0 1 24 31.333H8A7.333 7.333 0 0 1 .667 24V8A7.333 7.333 0 0 1 8 .667Z"/>
    <path fill="var(--icon-color, #1868db)" d="m23.79 15.684-1.315 8.032c-.085.486-.428.772-.914.772H10.413c-.486 0-.829-.286-.915-.772L7.183 9.396c-.086-.486.172-.8.629-.8h16.35c.457 0 .714.314.629.8l-.63 3.773c-.085.543-.4.772-.914.772h-9.833c-.143 0-.228.086-.2.257l.772 4.745c.028.114.114.2.229.2h3.544c.114 0 .2-.086.229-.2l.543-3.43c.057-.429.343-.6.743-.6h3.859c.571 0 .743.285.657.771"/>
</svg>
`;
function BitbucketDataCenterLogoCS({ size, appearance = 'brand', label = 'Bitbucket Data Center', testId }) {
    return /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _logoWrapper.LogoWrapper), {
        svg: svg,
        label: label,
        type: "data-center",
        appearance: appearance,
        size: size,
        testId: testId
    });
}

},{"react":"ltHCL","../../../utils/logo-wrapper":"aSXlT","@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"2xL4i":[function(require,module,exports,__globalThis) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::83bd991a11895fc697ec86ba4d2d82c2>>
 * @codegenCommand yarn workspace @atlaskit/logo generate:components
 */ var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
/**
 * __BitbucketIcon__
 *
 * A temporary component to represent the icon for Bitbucket.
 * @deprecated This component has been replaced by the component `BitbucketIcon` in `@atlaskit/logo`.
 * Please migrate any usages of this temporary component, using the prop `shouldUseNewLogoDesign` where necessary
 * to enable the new design by default.
 *
 */ parcelHelpers.export(exports, "BitbucketIcon", ()=>BitbucketIcon);
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _iconWrapper = require("../../../utils/icon-wrapper");
// `height` is set to 100% to allow the SVG to scale with the parent element
const svg = `<svg height="100%" viewBox="0 0 24 24">
    <path fill="var(--tile-color,#94c748)" d="M0 6a6 6 0 0 1 6-6h12a6 6 0 0 1 6 6v12a6 6 0 0 1-6 6H6a6 6 0 0 1-6-6z"/>
    <path fill="var(--icon-color, #101214)" d="m17.898 11.353-.994 6.064c-.065.367-.324.583-.691.583H7.787c-.367 0-.627-.216-.691-.583L5.346 6.604C5.28 6.237 5.476 6 5.82 6h12.358c.346 0 .54.237.475.604l-.475 2.85c-.065.41-.303.582-.691.582h-7.432c-.109 0-.173.065-.152.194l.584 3.583c.021.086.086.151.172.151h2.68c.086 0 .15-.065.172-.151l.41-2.59c.044-.324.26-.453.563-.453H17.4c.432 0 .562.216.497.582"/>
</svg>
`;
const customThemeSvg = `<svg height="100%" viewBox="0 0 24 24">
    <path fill="var(--themed-icon-color, currentcolor)" d="M18 0a6 6 0 0 1 6 6v12a6 6 0 0 1-6 6H6a6 6 0 0 1-6-6V6a6 6 0 0 1 6-6zM5.821 6c-.345 0-.54.238-.475.604l1.75 10.813c.065.367.324.583.691.583h8.426c.367 0 .627-.216.691-.583l.994-6.065c.065-.366-.065-.582-.497-.582h-2.917c-.302 0-.518.13-.561.453l-.41 2.59c-.022.086-.087.15-.173.15h-2.68c-.086 0-.151-.064-.173-.15l-.583-3.583c-.021-.129.044-.194.152-.194h7.431c.39 0 .627-.173.692-.583l.475-2.849c.065-.366-.13-.604-.475-.604z"/>
</svg>
`;
function BitbucketIcon({ iconColor, size, appearance = 'brand', label = 'Bitbucket', testId }) {
    return /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _iconWrapper.IconWrapper), {
        svg: svg,
        customThemeSvg: customThemeSvg,
        iconColor: iconColor,
        label: label,
        appearance: appearance,
        size: size,
        testId: testId
    });
}

},{"react":"ltHCL","../../../utils/icon-wrapper":"4NqBa","@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"3b4jn":[function(require,module,exports,__globalThis) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::7131ffd6f745f530e9a82fe4842b6a8c>>
 * @codegenCommand yarn workspace @atlaskit/logo generate:components
 */ var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
/**
 * __BitbucketLogoCS__
 *
 * A temporary component to represent the logo for Bitbucket.
 *
 */ parcelHelpers.export(exports, "BitbucketLogoCS", ()=>BitbucketLogoCS);
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _logoWrapper = require("../../../utils/logo-wrapper");
// `height` is set to 100% to allow the SVG to scale with the parent element
// The text color is set to "currentColor" to allow the SVG to inherit the color set by the parent based on the theme.
const svg = `<svg height="100%" viewBox="0 0 166 32">
    <path fill="var(--text-color, #1e1f21)" d="M161.21 20.58c0 1.35.8 2.27 2.42 2.27.61 0 1.2-.12 1.66-.21v2.55a6.3 6.3 0 0 1-1.78.25c-3.28 0-4.88-1.93-4.88-4.78v-8.19h-2.48V10h2.48V6.75h2.58V10h4.08v2.45h-4.08zm-13.53-8.49c-2.79 0-4.2 1.81-4.48 4.48h8.56c-.15-2.85-1.44-4.48-4.08-4.48m5.89 12.64c-1.26.67-3.19.92-4.75.92-5.73 0-8.25-3.31-8.25-8 0-4.63 2.58-7.94 7.24-7.94 4.72 0 6.62 3.28 6.62 7.94v1.2h-11.19c.37 2.61 2.05 4.29 5.67 4.29 1.78 0 3.28-.34 4.66-.83zm-23.83.6h-2.64V3.59h2.64v13.59l6.6-7.18h3.44l-7.21 7.54 7.51 7.79h-3.59l-6.75-7.18zm-5.64-2.76v2.36c-.92.49-2.33.71-3.74.71-5.46 0-8-3.31-8-8 0-4.63 2.55-7.94 8-7.94 1.38 0 2.45.18 3.65.74v2.45c-.98-.46-2.02-.74-3.46-.74-3.99 0-5.61 2.52-5.61 5.49s1.66 5.49 5.67 5.49c1.56 0 2.55-.21 3.5-.55m-27.86-3.59V10h2.64v9.26c0 2.76 1.1 3.99 3.62 3.99 2.45 0 4.14-1.63 4.14-4.72V10h2.64v15.33h-2.64v-2.51c-.98 1.81-2.79 2.82-4.84 2.82-3.53 0-5.55-2.42-5.55-6.65m-5.4-1.32c0-3.68-1.47-5.52-4.2-5.52-2.36 0-4.48 1.5-4.48 4.91v1.23c0 3.4 1.93 4.91 4.17 4.91 2.98 0 4.51-1.96 4.51-5.52m-3.8 7.97c-2.24 0-3.96-1.01-4.88-3v2.7h-2.64V3.59h2.64v9.17c.98-2.02 2.82-3.07 5.18-3.07 4.08 0 6.13 3.47 6.13 7.97 0 4.32-2.15 7.97-6.44 7.97m-14.96-5.05c0 1.35.8 2.27 2.42 2.27.61 0 1.2-.12 1.66-.21v2.55c-.46.12-.98.25-1.78.25-3.28 0-4.88-1.93-4.88-4.78v-8.19h-2.48V10h2.48V6.75h2.58V10h4.08v2.45h-4.08zM61.33 5.95c0-1.16.77-1.84 1.84-1.84s1.84.68 1.84 1.84-.77 1.84-1.84 1.84-1.84-.67-1.84-1.84m.49 19.38V10h2.64v15.33zm-9.83-9.04H45.8v6.29h6.26c2.64 0 3.83-.95 3.83-2.97 0-2.15-1.13-3.31-3.89-3.31m-.89-8.46h-5.3v6.01h5.31c2.61 0 3.68-1.2 3.68-3.13 0-1.96-1.17-2.88-3.68-2.88m-8.06 17.51V5.19h8.43c4.11 0 6.1 2.02 6.1 5.27 0 2.42-1.1 3.93-3.37 4.48 2.97.49 4.45 2.12 4.45 4.97 0 3.22-2.18 5.43-6.69 5.43z"/>
    <path fill="var(--tile-color,#94c748)" d="M0 8a8 8 0 0 1 8-8h16a8 8 0 0 1 8 8v16a8 8 0 0 1-8 8H8a8 8 0 0 1-8-8z"/>
    <path fill="var(--icon-color, #101214)" d="m23.79 15.684-1.315 8.032c-.085.486-.428.772-.914.772H10.413c-.486 0-.829-.286-.915-.772L7.183 9.396c-.086-.486.172-.8.629-.8h16.35c.457 0 .714.314.629.8l-.63 3.773c-.085.543-.4.772-.914.772h-9.833c-.143 0-.228.086-.2.257l.772 4.745c.029.114.114.2.229.2h3.544c.114 0 .2-.086.229-.2l.543-3.43c.057-.429.343-.6.743-.6h3.859c.572 0 .743.285.657.771"/>
</svg>
`;
function BitbucketLogoCS({ size, appearance = 'brand', label = 'Bitbucket', testId }) {
    return /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _logoWrapper.LogoWrapper), {
        svg: svg,
        label: label,
        appearance: appearance,
        size: size,
        testId: testId
    });
}

},{"react":"ltHCL","../../../utils/logo-wrapper":"aSXlT","@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"6n5cI":[function(require,module,exports,__globalThis) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::a54a6a33fcca799b58ea8f543b85188b>>
 * @codegenCommand yarn workspace @atlaskit/logo generate:components
 */ var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
/**
 * __ChatIcon__
 *
 * An internal component to represent the icon for Chat.
 * Do not use this internal component directly — use `ChatIcon` from `@atlaskit/logo` instead.
 *
 */ parcelHelpers.export(exports, "ChatIcon", ()=>ChatIcon);
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _iconWrapper = require("../../../utils/icon-wrapper");
// `height` is set to 100% to allow the SVG to scale with the parent element
const svg = `<svg height="100%" viewBox="0 0 24 24">
    <path fill="var(--tile-color,#dddee1)" d="M0 6a6 6 0 0 1 6-6h12a6 6 0 0 1 6 6v12a6 6 0 0 1-6 6H6a6 6 0 0 1-6-6z"/>
    <path fill="var(--icon-color, #101214)" fill-rule="evenodd" d="M18.563 16.688h-8.438L5.438 19.5V5.438h13.125zm-6.83-9.375-.255.647c-.362.92-.543 1.38-.878 1.727-.334.346-.787.543-1.694.938l-.388.17v.535l.388.17c.907.394 1.36.592 1.694.938.335.346.516.807.878 1.727l.255.648h.535l.255-.648c.362-.92.543-1.38.877-1.727.335-.346.788-.544 1.694-.939l.388-.169v-.535l-.388-.17c-.906-.395-1.36-.592-1.694-.938-.334-.347-.515-.807-.877-1.727l-.255-.647z" clip-rule="evenodd"/>
</svg>
`;
function ChatIcon({ size, appearance = 'brand', label = 'Chat', testId }) {
    return /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _iconWrapper.IconWrapper), {
        svg: svg,
        label: label,
        appearance: appearance,
        size: size,
        testId: testId
    });
}

},{"react":"ltHCL","../../../utils/icon-wrapper":"4NqBa","@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"k9xiQ":[function(require,module,exports,__globalThis) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::e9242b17d268ccb8686f65219c6ac465>>
 * @codegenCommand yarn workspace @atlaskit/logo generate:components
 */ var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
/**
 * __ChatLogoCS__
 *
 * An internal component to represent the logo for Chat.
 *
 */ parcelHelpers.export(exports, "ChatLogoCS", ()=>ChatLogoCS);
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _logoWrapper = require("../../../utils/logo-wrapper");
// `height` is set to 100% to allow the SVG to scale with the parent element
// The text color is set to "currentColor" to allow the SVG to inherit the color set by the parent based on the theme.
const svg = `<svg height="100%" viewBox="0 0 102 32">
    <path fill="var(--text-color, #1e1f21)" d="M97.51 20.58c0 1.35.8 2.27 2.42 2.27.61 0 1.2-.12 1.66-.21v2.55c-.46.12-.98.25-1.78.25-3.28 0-4.88-1.93-4.88-4.78v-8.19h-2.48V10h2.48V6.75h2.58V10h4.08v2.45h-4.08zm-18.94-2.91c0 3.68 1.47 5.52 4.2 5.52 2.36 0 4.48-1.5 4.48-4.91v-1.23c0-3.4-1.93-4.91-4.17-4.91-2.97 0-4.51 1.96-4.51 5.52m8.68 7.67v-2.76c-.98 2.02-2.82 3.07-5.18 3.07-4.08 0-6.13-3.46-6.13-7.97 0-4.32 2.15-7.97 6.44-7.97 2.24 0 3.96 1.01 4.88 3.01V10h2.64v15.33zm-14.1-8.98v8.99h-2.64v-8.52c0-3.16-1.1-4.72-3.62-4.72-2.45 0-4.14 1.63-4.14 4.72v8.53h-2.64V3.59h2.64v8.95c1.01-1.81 2.85-2.85 5.06-2.85 3.44 0 5.34 2.33 5.34 6.66m-16.22 5.43v2.67c-1.26.83-3.25 1.2-5.34 1.2-6.62 0-10.36-3.99-10.36-10.33 0-6.13 3.74-10.43 10.3-10.43 1.96 0 3.93.37 5.37 1.41v2.67c-1.44-.92-3.04-1.41-5.37-1.41-4.72 0-7.54 3.13-7.54 7.76s2.91 7.7 7.7 7.7c2.12 0 3.77-.49 5.24-1.23"/>
    <path fill="var(--tile-color,#dddee1)" d="M0 8a8 8 0 0 1 8-8h16a8 8 0 0 1 8 8v16a8 8 0 0 1-8 8H8a8 8 0 0 1-8-8z"/>
    <path fill="var(--icon-color, #101214)" fill-rule="evenodd" d="M24.75 22.25H13.5L7.25 26V7.25h17.5zm-9.107-12.5-.34.864c-.482 1.226-.724 1.84-1.17 2.302s-1.05.725-2.258 1.251l-.518.226v.714l.518.226c1.209.526 1.813.79 2.259 1.251.445.462.687 1.076 1.17 2.303l.34.863h.714l.34-.864c.482-1.227.724-1.84 1.17-2.302s1.049-.725 2.258-1.251l.517-.226v-.714l-.517-.226c-1.21-.526-1.813-.79-2.259-1.251-.445-.462-.687-1.075-1.17-2.302l-.34-.864z" clip-rule="evenodd"/>
</svg>
`;
function ChatLogoCS({ size, appearance = 'brand', label = 'Chat', testId }) {
    return /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _logoWrapper.LogoWrapper), {
        svg: svg,
        label: label,
        appearance: appearance,
        size: size,
        testId: testId
    });
}

},{"react":"ltHCL","../../../utils/logo-wrapper":"aSXlT","@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"bBAww":[function(require,module,exports,__globalThis) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::3ac62e14826e8b3e1f38977284672c29>>
 * @codegenCommand yarn workspace @atlaskit/logo generate:components
 */ var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
/**
 * __CompanyHubIcon__
 *
 * An internal component to represent the icon for Company Hub.
 * Do not use this internal component directly — use `CompanyHubIcon` from `@atlaskit/logo` instead.
 *
 */ parcelHelpers.export(exports, "CompanyHubIcon", ()=>CompanyHubIcon);
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _iconWrapper = require("../../../utils/icon-wrapper");
// `height` is set to 100% to allow the SVG to scale with the parent element
const svg = `<svg height="100%" viewBox="0 0 24 24">
    <path fill="var(--tile-color,#dddee1)" d="M0 6a6 6 0 0 1 6-6h12a6 6 0 0 1 6 6v12a6 6 0 0 1-6 6H6a6 6 0 0 1-6-6z"/>
    <path fill="var(--icon-color, #101214)" fill-rule="evenodd" d="M6.75 19V5h10.5v14h-3.937v-3.062h-2.625V19zM9.375 8.063h1.75V6.75h-1.75zm3.5 0h1.75V6.75h-1.75zm-1.75 3.062h-1.75V9.813h1.75zm-1.75 3.063h1.75v-1.313h-1.75zm5.25-3.063h-1.75V9.813h1.75zm-1.75 3.063h1.75v-1.313h-1.75z" clip-rule="evenodd"/>
</svg>
`;
function CompanyHubIcon({ size, appearance = 'brand', label = 'Company Hub', testId }) {
    return /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _iconWrapper.IconWrapper), {
        svg: svg,
        label: label,
        appearance: appearance,
        size: size,
        testId: testId
    });
}

},{"react":"ltHCL","../../../utils/icon-wrapper":"4NqBa","@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"1RFts":[function(require,module,exports,__globalThis) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::bcf3d9eaf1759437b869f9901adcacb2>>
 * @codegenCommand yarn workspace @atlaskit/logo generate:components
 */ var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
/**
 * __CompanyHubLogo__
 *
 * An internal component to represent the logo for Company Hub.
 *
 */ parcelHelpers.export(exports, "CompanyHubLogo", ()=>CompanyHubLogo);
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _logoWrapper = require("../../../utils/logo-wrapper");
// `height` is set to 100% to allow the SVG to scale with the parent element
// The text color is set to "currentColor" to allow the SVG to inherit the color set by the parent based on the theme.
const svg = `<svg height="100%" viewBox="0 0 129 24">
    <path fill="var(--tile-color,#dddee1)" d="M0 6a6 6 0 0 1 6-6h12a6 6 0 0 1 6 6v12a6 6 0 0 1-6 6H6a6 6 0 0 1-6-6z"/>
    <path fill="var(--icon-color, #101214)" fill-rule="evenodd" d="M6.75 19V5h10.5v14h-3.937v-3.062h-2.625V19zM9.375 8.063h1.75V6.75h-1.75zm3.5 0h1.75V6.75h-1.75zm-1.75 3.062h-1.75V9.813h1.75zm-1.75 3.063h1.75v-1.313h-1.75zm5.25-3.063h-1.75V9.813h1.75zm-1.75 3.063h1.75v-1.313h-1.75z" clip-rule="evenodd"/>
    <path fill="var(--text-color, #292a2e)" d="M124.53 17.13q-.64 0-1.07-.21a2.3 2.3 0 0 1-.7-.53 3 3 0 0 1-.4-.61h-.1V17h-1.89V6.81h1.93v3.82h.07a3 3 0 0 1 .4-.61q.26-.32.69-.54t1.09-.22q.87 0 1.57.44.71.44 1.13 1.32.42.87.42 2.17 0 1.26-.41 2.15-.41.87-1.12 1.33a2.87 2.87 0 0 1-1.6.46m-.56-1.55q.57 0 .95-.31a1.9 1.9 0 0 0 .57-.85q.2-.54.2-1.23t-.2-1.22a1.8 1.8 0 0 0-.57-.83q-.38-.31-.95-.31-.55 0-.94.29-.38.29-.58.83-.2.53-.2 1.24t.2 1.25q.21.54.59.84.39.3.94.3m-9.65 1.52q-.79 0-1.39-.34a2.34 2.34 0 0 1-.92-.98q-.33-.65-.33-1.55V9.37h1.93v4.54q0 .75.38 1.16t1.05.42q.46 0 .81-.19a1.4 1.4 0 0 0 .55-.57q.2-.38.2-.9V9.38h1.93V17h-1.82l-.02-1.9h.12q-.31.98-.93 1.49t-1.56.51m-13.01-.1V6.81h1.96v4.16h4.58V6.81h1.97V17h-1.97v-4.39h-4.58V17zm-11.89 2.71.45-1.47.23.06q.41.11.73.06a.83.83 0 0 0 .52-.27q.2-.22.27-.62l.08-.44-2.88-7.67h2.04l1.34 4.05q.24.75.39 1.49.16.75.34 1.54h-.47l.37-1.54q.18-.75.43-1.49l1.4-4.05h2.02l-3.26 8.58q-.23.62-.59 1.06-.35.44-.88.68-.52.24-1.25.24-.4 0-.74-.06a2.5 2.5 0 0 1-.53-.14m-6.44-7.17V17h-1.93V9.36h1.82l.04 1.9h-.13q.31-.97.92-1.48.62-.51 1.57-.51.79 0 1.37.34.59.34.92.98t.33 1.55V17H86v-4.54q0-.74-.38-1.16t-1.05-.42q-.45 0-.81.2a1.34 1.34 0 0 0-.55.57q-.2.37-.2.9m-7.92 4.58a2.9 2.9 0 0 1-1.59-.46q-.7-.46-1.12-1.33-.41-.88-.41-2.15 0-1.29.42-2.17.42-.87 1.13-1.32a2.9 2.9 0 0 1 1.58-.44q.66 0 1.09.23.43.22.69.54t.4.61h.08V9.36h1.91V17h-1.9v-1.22h-.08a2.6 2.6 0 0 1-.41.61q-.27.32-.7.53t-1.08.21m.57-1.55q.55 0 .94-.3.38-.3.58-.84.21-.54.21-1.25 0-.72-.2-1.25t-.58-.83q-.38-.29-.94-.29-.57 0-.96.3a1.85 1.85 0 0 0-.58.83 3.6 3.6 0 0 0-.19 1.23q0 .69.2 1.23t.58.85q.39.31.95.31M63.5 19.86V9.36h1.89v1.28h.1q.14-.29.4-.61t.69-.54 1.09-.22q.87 0 1.57.44.71.44 1.13 1.32.42.87.42 2.17 0 1.26-.41 2.15-.41.87-1.12 1.33a2.87 2.87 0 0 1-1.6.46q-.64 0-1.07-.21a2.3 2.3 0 0 1-.7-.53 3 3 0 0 1-.4-.61h-.07v4.07zm3.61-4.28q.57 0 .95-.31t.57-.85q.2-.54.2-1.23t-.2-1.22a1.8 1.8 0 0 0-.57-.83q-.38-.31-.95-.31-.56 0-.94.29t-.58.83q-.2.53-.2 1.24t.2 1.25q.21.54.59.84.39.3.94.3M50.8 17V9.36h1.8l.08 1.87h-.14q.17-.7.51-1.13.35-.44.81-.64.47-.21.97-.21.83 0 1.33.52.51.52.73 1.57h-.22q.16-.71.55-1.18.39-.46.91-.69.53-.23 1.12-.23.69 0 1.24.3.56.3.87.88.32.58.32 1.42V17h-1.92v-4.82q0-.67-.37-1a1.32 1.32 0 0 0-.89-.32q-.4 0-.7.18a1.2 1.2 0 0 0-.46.49q-.16.32-.16.73V17h-1.87v-4.89q0-.57-.35-.91-.34-.34-.89-.34-.37 0-.68.17a1.2 1.2 0 0 0-.49.51q-.18.33-.18.81V17zm-5.18.15q-1.13 0-1.97-.49a3.3 3.3 0 0 1-1.28-1.38q-.45-.89-.45-2.06 0-1.18.45-2.07.45-.9 1.28-1.39t1.97-.49 1.96.49q.83.49 1.29 1.39.45.89.45 2.07t-.45 2.07-1.29 1.38q-.83.49-1.96.49m0-1.53q.58 0 .97-.31.39-.32.58-.87a3.7 3.7 0 0 0 .19-1.23 3.7 3.7 0 0 0-.19-1.23 1.87 1.87 0 0 0-.58-.86q-.39-.32-.97-.32t-.97.32q-.38.32-.58.86-.19.54-.19 1.23 0 .68.19 1.23.2.55.58.87.39.31.97.31m-9.25 1.51q-1.35 0-2.41-.62t-1.67-1.79-.61-2.82.62-2.82q.62-1.18 1.68-1.79 1.07-.62 2.4-.62.85 0 1.59.24.75.24 1.32.7t.94 1.12.49 1.51h-1.98a2.2 2.2 0 0 0-.28-.77 2 2 0 0 0-.51-.57q-.3-.24-.69-.36a2.8 2.8 0 0 0-.83-.12q-.81 0-1.43.41-.62.4-.97 1.18-.34.78-.34 1.89 0 1.13.35 1.91.35.77.96 1.17a2.6 2.6 0 0 0 1.43.4q.45 0 .83-.12.39-.12.7-.36.32-.24.52-.57.21-.34.29-.77h1.98q-.09.72-.43 1.36a4.2 4.2 0 0 1-.9 1.15 4.2 4.2 0 0 1-1.32.79q-.76.28-1.69.28"/>
</svg>
`;
function CompanyHubLogo({ size, appearance = 'brand', label = 'Company Hub', testId }) {
    return /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _logoWrapper.LogoWrapper), {
        svg: svg,
        label: label,
        appearance: appearance,
        size: size,
        testId: testId
    });
}

},{"react":"ltHCL","../../../utils/logo-wrapper":"aSXlT","@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"7Meg0":[function(require,module,exports,__globalThis) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::e5ce5248a23a237688e2341559569305>>
 * @codegenCommand yarn workspace @atlaskit/logo generate:components
 */ var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
/**
 * __CompassIcon__
 *
 * A temporary component to represent the icon for Compass.
 * @deprecated This component has been replaced by the component `CompassIcon` in `@atlaskit/logo`.
 * Please migrate any usages of this temporary component, using the prop `shouldUseNewLogoDesign` where necessary
 * to enable the new design by default.
 *
 */ parcelHelpers.export(exports, "CompassIcon", ()=>CompassIcon);
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _iconWrapper = require("../../../utils/icon-wrapper");
// `height` is set to 100% to allow the SVG to scale with the parent element
const svg = `<svg height="100%" viewBox="0 0 24 24">
    <path fill="var(--tile-color,#94c748)" d="M0 6a6 6 0 0 1 6-6h12a6 6 0 0 1 6 6v12a6 6 0 0 1-6 6H6a6 6 0 0 1-6-6z"/>
    <path fill="var(--icon-color, #101214)" d="M12.75 7.877v-3.37l6.16-.007h.007a.59.59 0 0 1 .583.598v6.147h-3.366V7.877z"/>
    <path fill="var(--icon-color, #101214)" d="M12.75 14.615v-3.37h3.368v6.165a.59.59 0 0 1-.591.59H6.583A.59.59 0 0 1 6 17.402V8.467a.59.59 0 0 1 .591-.59h6.16v3.368H9.373v3.37z"/>
</svg>
`;
function CompassIcon({ size, appearance = 'brand', label = 'Compass', testId }) {
    return /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _iconWrapper.IconWrapper), {
        svg: svg,
        label: label,
        appearance: appearance,
        size: size,
        testId: testId
    });
}

},{"react":"ltHCL","../../../utils/icon-wrapper":"4NqBa","@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"4XrHp":[function(require,module,exports,__globalThis) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::bbcc7f43e0a51fb6caa253b27359fb22>>
 * @codegenCommand yarn workspace @atlaskit/logo generate:components
 */ var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
/**
 * __CompassLogoCS__
 *
 * A temporary component to represent the logo for Compass.
 *
 */ parcelHelpers.export(exports, "CompassLogoCS", ()=>CompassLogoCS);
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _logoWrapper = require("../../../utils/logo-wrapper");
// `height` is set to 100% to allow the SVG to scale with the parent element
// The text color is set to "currentColor" to allow the SVG to inherit the color set by the parent based on the theme.
const svg = `<svg height="100%" viewBox="0 0 162 32">
    <path fill="var(--text-color, #1e1f21)" d="M161.79 21.16c0 2.55-1.66 4.48-5.76 4.48-2.3 0-4.17-.52-5.34-1.13v-2.79c1.32.77 3.53 1.5 5.46 1.5 2.02 0 3.07-.83 3.07-2.02 0-1.16-.89-1.84-3.8-2.55-3.4-.83-4.85-2.15-4.85-4.66 0-2.67 2.06-4.29 5.55-4.29 1.99 0 3.8.49 4.94 1.1v2.73c-1.84-.92-3.34-1.41-4.97-1.41-1.93 0-2.97.68-2.97 1.87 0 1.07.74 1.75 3.56 2.42 3.4.83 5.12 2.09 5.12 4.75m-13.63 0c0 2.55-1.66 4.48-5.76 4.48-2.3 0-4.17-.52-5.34-1.13v-2.79c1.32.77 3.53 1.5 5.46 1.5 2.02 0 3.07-.83 3.07-2.02 0-1.16-.89-1.84-3.8-2.55-3.4-.83-4.84-2.15-4.84-4.66 0-2.67 2.06-4.29 5.55-4.29 1.99 0 3.8.49 4.94 1.1v2.73c-1.84-.92-3.34-1.41-4.97-1.41-1.93 0-2.97.68-2.97 1.87 0 1.07.74 1.75 3.56 2.42 3.4.83 5.12 2.09 5.12 4.75m-25.9-3.49c0 3.68 1.47 5.52 4.2 5.52 2.36 0 4.48-1.5 4.48-4.91v-1.23c0-3.4-1.93-4.91-4.17-4.91-2.97 0-4.51 1.96-4.51 5.52m8.68 7.67v-2.76c-.98 2.02-2.82 3.07-5.18 3.07-4.08 0-6.13-3.46-6.13-7.97 0-4.32 2.15-7.97 6.44-7.97 2.24 0 3.96 1.01 4.88 3.01v-2.7h2.64v15.33zm-16.09-7.66c0-3.68-1.47-5.52-4.2-5.52-2.36 0-4.48 1.5-4.48 4.91v1.23c0 3.4 1.93 4.91 4.17 4.91 2.98 0 4.51-1.96 4.51-5.52m-3.8 7.97c-2.24 0-3.96-1.01-4.88-3v8.68h-2.64V10h2.64v2.76c.98-2.02 2.82-3.07 5.18-3.07 4.08 0 6.13 3.47 6.13 7.97 0 4.32-2.15 7.97-6.44 7.97M89.5 16.81v8.53h-2.64v-9.26c0-2.76-1.1-3.99-3.62-3.99-2.45 0-4.14 1.63-4.14 4.72v8.53h-2.64V10h2.64v2.51c.98-1.81 2.79-2.82 4.85-2.82 2.61 0 4.39 1.32 5.15 3.74.86-2.36 2.91-3.74 5.46-3.74 3.43 0 5.34 2.33 5.34 6.66v8.99h-2.64v-8.53c0-3.16-1.1-4.72-3.62-4.72-2.45 0-4.14 1.63-4.14 4.72m-23.34 8.83c-4.6 0-7.3-3.4-7.3-8s2.7-7.94 7.3-7.94c4.57 0 7.24 3.34 7.24 7.94s-2.67 8-7.24 8m0-13.49c-3.28 0-4.72 2.58-4.72 5.49s1.44 5.55 4.72 5.55c3.25 0 4.66-2.64 4.66-5.55s-1.41-5.49-4.66-5.49m-9.23 9.63v2.67c-1.26.83-3.25 1.2-5.34 1.2-6.62 0-10.36-3.99-10.36-10.33 0-6.13 3.74-10.43 10.3-10.43 1.96 0 3.93.37 5.37 1.41v2.67c-1.44-.92-3.04-1.41-5.37-1.41-4.72 0-7.54 3.13-7.54 7.76s2.91 7.7 7.7 7.7c2.12 0 3.77-.49 5.24-1.23"/>
    <path fill="var(--tile-color,#94c748)" d="M0 8a8 8 0 0 1 8-8h16a8 8 0 0 1 8 8v16a8 8 0 0 1-8 8H8a8 8 0 0 1-8-8z"/>
    <path fill="var(--icon-color, #101214)" d="M16.69 15.16v4.24h-4.25v-4.24zv-4.24H8.93a.74.74 0 0 0-.74.74v11.25a.74.74 0 0 0 .74.75h11.26a.74.74 0 0 0 .75-.74v-7.76zm0-8.48v4.24h4.26v4.24h4.24V7.42a.74.74 0 0 0-.73-.75h-.01z"/>
</svg>
`;
function CompassLogoCS({ size, appearance = 'brand', label = 'Compass', testId }) {
    return /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _logoWrapper.LogoWrapper), {
        svg: svg,
        label: label,
        appearance: appearance,
        size: size,
        testId: testId
    });
}

},{"react":"ltHCL","../../../utils/logo-wrapper":"aSXlT","@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"jkj2x":[function(require,module,exports,__globalThis) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::79151986eefb0d79ff7389ad5707c136>>
 * @codegenCommand yarn workspace @atlaskit/logo generate:components
 */ var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
/**
 * __ConfluenceDataCenterIcon__
 *
 * An internal component to represent the icon for Confluence Data Center.
 * Do not use this internal component directly — use `ConfluenceDataCenterIcon` from `@atlaskit/logo` instead.
 *
 */ parcelHelpers.export(exports, "ConfluenceDataCenterIcon", ()=>ConfluenceDataCenterIcon);
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _iconWrapper = require("../../../utils/icon-wrapper");
// `height` is set to 100% to allow the SVG to scale with the parent element
const svg = `<svg height="100%" viewBox="0 0 24 24">
    <path fill="var(--tile-color, white)" d="M6 .5h12A5.5 5.5 0 0 1 23.5 6v12a5.5 5.5 0 0 1-5.5 5.5H6A5.5 5.5 0 0 1 .5 18V6A5.5 5.5 0 0 1 6 .5"/>
    <path fill="none" stroke="var(--border-color, #dddee1)" d="M6 .5h12A5.5 5.5 0 0 1 23.5 6v12a5.5 5.5 0 0 1-5.5 5.5H6A5.5 5.5 0 0 1 .5 18V6A5.5 5.5 0 0 1 6 .5Z"/>
    <path fill="var(--icon-color, #1868db)" d="M17.37 14.265c-3.704-1.79-4.785-2.058-6.346-2.058-1.83 0-3.391.761-4.785 2.902l-.229.35c-.187.288-.229.39-.229.514s.063.227.292.37l2.35 1.462c.125.083.23.124.333.124.125 0 .208-.062.333-.247l.375-.577c.582-.885 1.102-1.173 1.768-1.173.583 0 1.27.165 2.122.577l2.455 1.152c.25.124.52.062.645-.226l1.165-2.552c.125-.289.042-.474-.25-.618M6.572 9.757c3.703 1.791 4.785 2.059 6.346 2.059 1.83 0 3.39-.762 4.785-2.902l.229-.35c.187-.288.228-.391.228-.515 0-.123-.062-.226-.29-.37l-2.352-1.462c-.125-.082-.229-.123-.333-.123-.125 0-.208.061-.333.247l-.374.576c-.583.885-1.103 1.173-1.769 1.173-.582 0-1.269-.164-2.122-.576L8.132 6.361c-.25-.123-.52-.061-.645.227L6.322 9.14c-.125.288-.041.473.25.617"/>
</svg>
`;
function ConfluenceDataCenterIcon({ size, appearance = 'brand', label = 'Confluence Data Center', testId }) {
    return /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _iconWrapper.IconWrapper), {
        svg: svg,
        label: label,
        type: "data-center",
        appearance: appearance,
        size: size,
        testId: testId
    });
}

},{"react":"ltHCL","../../../utils/icon-wrapper":"4NqBa","@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"fTOiY":[function(require,module,exports,__globalThis) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::b0ac4de94f42b3a4050a935e411c6789>>
 * @codegenCommand yarn workspace @atlaskit/logo generate:components
 */ var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
/**
 * __ConfluenceDataCenterLogoCS__
 *
 * An internal component to represent the logo for Confluence Data Center.
 *
 */ parcelHelpers.export(exports, "ConfluenceDataCenterLogoCS", ()=>ConfluenceDataCenterLogoCS);
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _logoWrapper = require("../../../utils/logo-wrapper");
// `height` is set to 100% to allow the SVG to scale with the parent element
// The text color is set to "currentColor" to allow the SVG to inherit the color set by the parent based on the theme.
const svg = `<svg height="100%" viewBox="0 0 188 32">
    <path fill="var(--text-color, #1e1f21)" d="M181.16 12.09c-2.79 0-4.2 1.81-4.48 4.48h8.56c-.15-2.85-1.44-4.48-4.08-4.48m5.89 12.64c-1.26.68-3.19.92-4.75.92-5.73 0-8.25-3.31-8.25-8 0-4.63 2.58-7.94 7.24-7.94 4.72 0 6.62 3.28 6.62 7.94v1.2h-11.2c.37 2.61 2.06 4.29 5.67 4.29 1.78 0 3.28-.34 4.66-.83zm-15.1-2.16v2.36c-.92.49-2.33.71-3.74.71-5.46 0-8-3.31-8-8 0-4.63 2.55-7.94 8-7.94 1.38 0 2.45.18 3.65.74v2.45c-.98-.46-2.02-.74-3.47-.74-3.99 0-5.61 2.51-5.61 5.49s1.66 5.49 5.67 5.49c1.56 0 2.55-.21 3.5-.55m-14.5-6.23v8.99h-2.64v-9.26c0-2.76-1.1-3.99-3.62-3.99-2.45 0-4.14 1.63-4.14 4.72v8.53h-2.64V10h2.64v2.52c.98-1.81 2.79-2.82 4.85-2.82 3.53 0 5.55 2.42 5.55 6.66m-22.92-4.27c-2.79 0-4.2 1.81-4.48 4.48h8.56c-.15-2.85-1.44-4.48-4.08-4.48m5.89 12.64c-1.26.68-3.19.92-4.75.92-5.73 0-8.25-3.31-8.25-8 0-4.63 2.58-7.94 7.24-7.94 4.72 0 6.62 3.28 6.62 7.94v1.2h-11.19c.37 2.61 2.06 4.29 5.67 4.29 1.78 0 3.28-.34 4.66-.83zm-29.1-5.74V10h2.64v9.26c0 2.76 1.1 3.99 3.62 3.99 2.45 0 4.14-1.62 4.14-4.72V10h2.64v15.33h-2.64v-2.51c-.98 1.81-2.79 2.82-4.85 2.82-3.53 0-5.55-2.42-5.55-6.65m-2.23 6.31c-.21.06-.67.12-1.35.12-2.51 0-4.11-1.2-4.11-4.02V3.59h2.64V21.1c0 1.38.92 1.87 2.06 1.87.28 0 .46 0 .77-.03zM96.82 8.38V10h3.96v2.45h-3.96v12.88h-2.58V12.45h-2.48V10h2.48V8.31c0-2.85 1.59-4.78 4.88-4.78.8 0 1.32.12 1.78.25V6.2a8.7 8.7 0 0 0-1.66-.15c-1.62 0-2.42.95-2.42 2.33m-7.32 7.97v8.99h-2.64v-9.26c0-2.76-1.1-3.99-3.62-3.99-2.45 0-4.14 1.63-4.14 4.72v8.53h-2.64V10h2.64v2.52c.98-1.81 2.79-2.82 4.85-2.82 3.53 0 5.55 2.42 5.55 6.66m-23.34 9.28c-4.6 0-7.3-3.4-7.3-8s2.7-7.94 7.3-7.94c4.57 0 7.24 3.34 7.24 7.94s-2.67 8-7.24 8m0-13.49c-3.28 0-4.72 2.58-4.72 5.49s1.44 5.55 4.72 5.55c3.25 0 4.66-2.64 4.66-5.55s-1.41-5.49-4.66-5.49m-9.23 9.63v2.67c-1.26.83-3.25 1.2-5.34 1.2-6.62 0-10.36-3.99-10.36-10.33 0-6.13 3.74-10.43 10.3-10.43 1.96 0 3.93.37 5.37 1.41v2.67c-1.44-.92-3.04-1.41-5.37-1.41-4.72 0-7.54 3.13-7.54 7.76s2.91 7.7 7.7 7.7c2.12 0 3.77-.49 5.24-1.23"/>
    <path fill="var(--tile-color, white)" d="M8 .667h16A7.333 7.333 0 0 1 31.333 8v16A7.333 7.333 0 0 1 24 31.333H8A7.333 7.333 0 0 1 .667 24V8A7.333 7.333 0 0 1 8 .667"/>
    <path fill="none" stroke="var(--border-color, #dddee1)" stroke-width="1.333" d="M8 .667h16A7.333 7.333 0 0 1 31.333 8v16A7.333 7.333 0 0 1 24 31.333H8A7.333 7.333 0 0 1 .667 24V8A7.333 7.333 0 0 1 8 .667Z"/>
    <path fill="var(--icon-color, #1868db)" d="M23.16 19.02c-4.938-2.387-6.38-2.744-8.461-2.744-2.441 0-4.522 1.015-6.38 3.87l-.306.466c-.25.384-.305.521-.305.686s.084.302.389.494l3.134 1.948c.167.11.306.165.444.165.167 0 .278-.082.444-.33l.5-.768c.776-1.18 1.47-1.564 2.357-1.564.777 0 1.693.22 2.83.768l3.273 1.537c.333.165.694.083.86-.302l1.554-3.403c.166-.384.055-.63-.333-.823M8.762 13.01c4.938 2.388 6.38 2.744 8.461 2.744 2.441 0 4.522-1.015 6.38-3.87l.306-.466c.25-.384.305-.521.305-.686 0-.164-.083-.302-.388-.494L20.69 8.29c-.167-.11-.305-.165-.444-.165-.166 0-.277.082-.444.33l-.5.768c-.776 1.18-1.47 1.564-2.357 1.564-.777 0-1.692-.22-2.83-.768l-3.273-1.537c-.333-.165-.694-.083-.86.302L8.43 12.187c-.167.384-.056.63.332.823"/>
</svg>
`;
function ConfluenceDataCenterLogoCS({ size, appearance = 'brand', label = 'Confluence Data Center', testId }) {
    return /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _logoWrapper.LogoWrapper), {
        svg: svg,
        label: label,
        type: "data-center",
        appearance: appearance,
        size: size,
        testId: testId
    });
}

},{"react":"ltHCL","../../../utils/logo-wrapper":"aSXlT","@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"7HfeB":[function(require,module,exports,__globalThis) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::2264fa822c5f74cedf4229a8911c73b4>>
 * @codegenCommand yarn workspace @atlaskit/logo generate:components
 */ var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
/**
 * __ConfluenceIcon__
 *
 * A temporary component to represent the icon for Confluence.
 * @deprecated This component has been replaced by the component `ConfluenceIcon` in `@atlaskit/logo`.
 * Please migrate any usages of this temporary component, using the prop `shouldUseNewLogoDesign` where necessary
 * to enable the new design by default.
 *
 */ parcelHelpers.export(exports, "ConfluenceIcon", ()=>ConfluenceIcon);
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _iconWrapper = require("../../../utils/icon-wrapper");
// `height` is set to 100% to allow the SVG to scale with the parent element
const svg = `<svg height="100%" viewBox="0 0 24 24">
    <path fill="var(--tile-color,#1868db)" d="M0 6a6 6 0 0 1 6-6h12a6 6 0 0 1 6 6v12a6 6 0 0 1-6 6H6a6 6 0 0 1-6-6z"/>
    <path fill="var(--icon-color, white)" d="M17.888 14.461c-4.039-1.953-5.219-2.245-6.92-2.245-1.997 0-3.699.831-5.219 3.165l-.25.382c-.204.314-.249.426-.249.561s.068.247.318.404l2.564 1.594c.136.09.25.135.363.135.136 0 .226-.068.363-.27l.408-.628c.635-.966 1.203-1.28 1.928-1.28.636 0 1.385.18 2.315.629l2.677 1.257c.272.134.567.067.704-.247l1.27-2.783c.136-.315.046-.517-.272-.674M6.112 9.545c4.039 1.953 5.219 2.245 6.92 2.245 1.997 0 3.699-.83 5.219-3.165l.25-.381c.204-.315.249-.427.249-.562 0-.134-.068-.247-.318-.404L15.87 5.685c-.137-.09-.25-.135-.364-.135-.136 0-.226.067-.363.27l-.408.628c-.635.965-1.203 1.28-1.928 1.28-.636 0-1.385-.18-2.315-.63L7.814 5.843c-.272-.135-.567-.068-.703.247L5.84 8.872c-.136.314-.045.516.272.673"/>
</svg>
`;
const customThemeSvg = `<svg height="100%" viewBox="0 0 24 24">
    <path fill="var(--themed-icon-color, currentcolor)" d="M18 0a6 6 0 0 1 6 6v12a6 6 0 0 1-6 6H6a6 6 0 0 1-6-6V6a6 6 0 0 1 6-6zm-7.032 12.217c-1.997 0-3.699.83-5.219 3.165l-.249.38c-.204.315-.25.427-.25.562s.068.247.317.404l2.565 1.594c.136.09.249.135.362.135.136 0 .227-.068.363-.27l.409-.628c.635-.966 1.202-1.28 1.928-1.28.636 0 1.384.18 2.315.63l2.677 1.256c.273.134.568.067.704-.247l1.27-2.783c.136-.315.045-.517-.272-.674-4.039-1.953-5.219-2.244-6.92-2.244m4.538-6.667c-.136 0-.227.067-.363.27l-.409.628c-.635.965-1.202 1.28-1.928 1.28-.636 0-1.384-.18-2.315-.63L7.813 5.843c-.272-.135-.567-.067-.703.247L5.84 8.872c-.136.314-.045.517.272.674 4.039 1.953 5.219 2.244 6.92 2.244 1.997 0 3.699-.83 5.219-3.165l.249-.382c.204-.314.25-.426.25-.56s-.068-.248-.317-.405l-2.565-1.593c-.136-.09-.249-.135-.362-.135"/>
</svg>
`;
function ConfluenceIcon({ iconColor, size, appearance = 'brand', label = 'Confluence', testId }) {
    return /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _iconWrapper.IconWrapper), {
        svg: svg,
        customThemeSvg: customThemeSvg,
        iconColor: iconColor,
        label: label,
        appearance: appearance,
        size: size,
        testId: testId
    });
}

},{"react":"ltHCL","../../../utils/icon-wrapper":"4NqBa","@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"b07tV":[function(require,module,exports,__globalThis) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::90f8012e577da50adfff14718da1e4b3>>
 * @codegenCommand yarn workspace @atlaskit/logo generate:components
 */ var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
/**
 * __ConfluenceLogoCS__
 *
 * A temporary component to represent the logo for Confluence.
 *
 */ parcelHelpers.export(exports, "ConfluenceLogoCS", ()=>ConfluenceLogoCS);
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _logoWrapper = require("../../../utils/logo-wrapper");
// `height` is set to 100% to allow the SVG to scale with the parent element
// The text color is set to "currentColor" to allow the SVG to inherit the color set by the parent based on the theme.
const svg = `<svg height="100%" viewBox="0 0 188 32">
    <path fill="var(--text-color, #1e1f21)" d="M181.16 12.09c-2.79 0-4.2 1.81-4.48 4.48h8.56c-.15-2.85-1.44-4.48-4.08-4.48m5.89 12.64c-1.26.68-3.19.92-4.75.92-5.73 0-8.25-3.31-8.25-8 0-4.63 2.58-7.94 7.24-7.94 4.72 0 6.62 3.28 6.62 7.94v1.2h-11.2c.37 2.61 2.06 4.29 5.67 4.29 1.78 0 3.28-.34 4.66-.83zm-15.1-2.16v2.36c-.92.49-2.33.71-3.74.71-5.46 0-8-3.31-8-8 0-4.63 2.55-7.94 8-7.94 1.38 0 2.45.18 3.65.74v2.45c-.98-.46-2.02-.74-3.46-.74-3.99 0-5.61 2.51-5.61 5.49s1.66 5.49 5.67 5.49c1.56 0 2.55-.21 3.5-.55m-14.51-6.23v8.99h-2.64v-9.26c0-2.76-1.1-3.99-3.62-3.99-2.45 0-4.14 1.63-4.14 4.72v8.53h-2.64V10h2.64v2.52c.98-1.81 2.79-2.82 4.85-2.82 3.53 0 5.55 2.42 5.55 6.66m-22.92-4.27c-2.79 0-4.2 1.81-4.48 4.48h8.56c-.15-2.85-1.44-4.48-4.08-4.48m5.89 12.64c-1.26.68-3.19.92-4.75.92-5.73 0-8.25-3.31-8.25-8 0-4.63 2.58-7.94 7.24-7.94 4.72 0 6.62 3.28 6.62 7.94v1.2h-11.19c.37 2.61 2.06 4.29 5.67 4.29 1.78 0 3.28-.34 4.66-.83zm-29.1-5.74V10h2.64v9.26c0 2.76 1.1 3.99 3.62 3.99 2.45 0 4.14-1.62 4.14-4.72V10h2.64v15.33h-2.64v-2.51c-.98 1.81-2.79 2.82-4.84 2.82-3.53 0-5.55-2.42-5.55-6.65m-2.24 6.31c-.21.06-.67.12-1.35.12-2.51 0-4.11-1.19-4.11-4.02V3.59h2.64V21.1c0 1.38.92 1.87 2.06 1.87.28 0 .46 0 .77-.03zM96.82 8.38V10h3.96v2.45h-3.96v12.88h-2.58V12.45h-2.48V10h2.48V8.31c0-2.85 1.59-4.78 4.88-4.78.8 0 1.32.12 1.78.25V6.2a8.7 8.7 0 0 0-1.66-.15c-1.62 0-2.42.95-2.42 2.33m-7.32 7.97v8.99h-2.64v-9.26c0-2.76-1.1-3.99-3.62-3.99-2.45 0-4.14 1.63-4.14 4.72v8.53h-2.64V10h2.64v2.52c.98-1.81 2.79-2.82 4.85-2.82 3.53 0 5.55 2.42 5.55 6.66m-23.34 9.28c-4.6 0-7.3-3.4-7.3-8s2.7-7.94 7.3-7.94c4.57 0 7.24 3.34 7.24 7.94s-2.67 8-7.24 8m0-13.49c-3.28 0-4.72 2.58-4.72 5.49s1.44 5.55 4.72 5.55c3.25 0 4.66-2.64 4.66-5.55s-1.41-5.49-4.66-5.49m-9.23 9.63v2.67c-1.26.83-3.25 1.2-5.34 1.2-6.62 0-10.36-3.99-10.36-10.33 0-6.13 3.74-10.43 10.3-10.43 1.96 0 3.93.37 5.37 1.41v2.67c-1.44-.92-3.04-1.41-5.37-1.41-4.72 0-7.54 3.13-7.54 7.76s2.91 7.7 7.7 7.7c2.12 0 3.77-.49 5.24-1.23"/>
    <path fill="var(--tile-color,#1868db)" d="M0 8a8 8 0 0 1 8-8h16a8 8 0 0 1 8 8v16a8 8 0 0 1-8 8H8a8 8 0 0 1-8-8z"/>
    <path fill="var(--icon-color, white)" d="M23.16 19.02c-4.938-2.387-6.38-2.744-8.461-2.744-2.442 0-4.522 1.015-6.38 3.87l-.306.466c-.25.384-.305.521-.305.686s.083.302.388.494l3.135 1.948c.167.11.305.165.444.165.166 0 .277-.082.444-.33l.5-.768c.776-1.18 1.47-1.564 2.357-1.564.777 0 1.692.22 2.83.768l3.273 1.537c.333.165.693.083.86-.302l1.553-3.403c.167-.384.056-.63-.333-.823M8.761 13.01c4.938 2.388 6.38 2.744 8.461 2.744 2.441 0 4.522-1.015 6.38-3.87l.305-.466c.25-.384.305-.521.305-.686 0-.164-.083-.302-.388-.494L20.691 8.29c-.167-.11-.306-.165-.444-.165-.167 0-.278.082-.444.33l-.5.768c-.776 1.18-1.47 1.564-2.357 1.564-.777 0-1.693-.22-2.83-.768l-3.273-1.537c-.333-.165-.694-.083-.86.302l-1.554 3.403c-.166.384-.055.63.333.823"/>
</svg>
`;
function ConfluenceLogoCS({ size, appearance = 'brand', label = 'Confluence', testId }) {
    return /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _logoWrapper.LogoWrapper), {
        svg: svg,
        label: label,
        appearance: appearance,
        size: size,
        testId: testId
    });
}

},{"react":"ltHCL","../../../utils/logo-wrapper":"aSXlT","@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"cbavW":[function(require,module,exports,__globalThis) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::d471014cf3c5b11585548418a230239b>>
 * @codegenCommand yarn workspace @atlaskit/logo generate:components
 */ var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
/**
 * __CrowdIcon__
 *
 * An internal component to represent the icon for Crowd.
 * Do not use this internal component directly — use `CrowdIcon` from `@atlaskit/logo` instead.
 *
 */ parcelHelpers.export(exports, "CrowdIcon", ()=>CrowdIcon);
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _iconWrapper = require("../../../utils/icon-wrapper");
// `height` is set to 100% to allow the SVG to scale with the parent element
const svg = `<svg height="100%" viewBox="0 0 24 24">
    <path fill="var(--tile-color, white)" d="M6 .5h12A5.5 5.5 0 0 1 23.5 6v12a5.5 5.5 0 0 1-5.5 5.5H6A5.5 5.5 0 0 1 .5 18V6A5.5 5.5 0 0 1 6 .5"/>
    <path fill="none" stroke="var(--border-color, #dddee1)" d="M6 .5h12A5.5 5.5 0 0 1 23.5 6v12a5.5 5.5 0 0 1-5.5 5.5H6A5.5 5.5 0 0 1 .5 18V6A5.5 5.5 0 0 1 6 .5Z"/>
    <path fill="var(--icon-color, #1868db)" d="M18.71 7.463 12 4.993l-6.71 2.47a.44.44 0 0 0-.29.433l.14 3.807c.103 3.148 1.684 5.489 4.163 7.018a.446.446 0 0 0 .646-.204l1.445-3.412a.22.22 0 0 0-.14-.298 2.585 2.585 0 1 1 1.492 0 .22.22 0 0 0-.14.298l1.446 3.412a.446.446 0 0 0 .645.204c2.48-1.529 4.06-3.87 4.163-7.018L19 7.896a.44.44 0 0 0-.29-.433"/>
</svg>
`;
function CrowdIcon({ size, appearance = 'brand', label = 'Crowd', testId }) {
    return /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _iconWrapper.IconWrapper), {
        svg: svg,
        label: label,
        type: "data-center",
        appearance: appearance,
        size: size,
        testId: testId
    });
}

},{"react":"ltHCL","../../../utils/icon-wrapper":"4NqBa","@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"7j0JG":[function(require,module,exports,__globalThis) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::13d7df881302adff1c5de7157bb4b9bb>>
 * @codegenCommand yarn workspace @atlaskit/logo generate:components
 */ var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
/**
 * __CrowdLogoCS__
 *
 * An internal component to represent the logo for Crowd.
 *
 */ parcelHelpers.export(exports, "CrowdLogoCS", ()=>CrowdLogoCS);
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _logoWrapper = require("../../../utils/logo-wrapper");
// `height` is set to 100% to allow the SVG to scale with the parent element
// The text color is set to "currentColor" to allow the SVG to inherit the color set by the parent based on the theme.
const svg = `<svg height="100%" viewBox="0 0 126 32">
    <path fill="var(--text-color, #1e1f21)" d="M113.97 17.67c0 3.68 1.47 5.52 4.2 5.52 2.36 0 4.48-1.5 4.48-4.91v-1.23c0-3.4-1.93-4.91-4.17-4.91-2.97 0-4.51 1.96-4.51 5.52m8.68 7.67v-2.76c-.98 2.02-2.82 3.07-5.18 3.07-4.08 0-6.13-3.46-6.13-7.97 0-4.32 2.15-7.97 6.44-7.97 2.24 0 3.96 1.01 4.88 3.01V3.59h2.64v21.74zm-17.72 0h-3.37l-2.64-7.42-1.41-4.72-1.41 4.72-2.64 7.42h-3.37L84.45 10h2.91l4.42 13 4.48-13h2.51l4.48 13 4.41-13h2.91zm-28.47.31c-4.6 0-7.3-3.4-7.3-8s2.7-7.94 7.3-7.94c4.57 0 7.24 3.34 7.24 7.94s-2.67 8-7.24 8m0-13.49c-3.28 0-4.72 2.58-4.72 5.49s1.44 5.55 4.72 5.55c3.25 0 4.66-2.64 4.66-5.55s-1.41-5.49-4.66-5.49m-13.77 4.14v9.05h-2.58V10h2.58v2.7c.89-1.81 2.42-3.1 5.43-2.91v2.58c-3.37-.34-5.43.68-5.43 3.93m-5.76 5.48v2.67c-1.26.83-3.25 1.2-5.34 1.2-6.62 0-10.36-3.99-10.36-10.33 0-6.13 3.74-10.43 10.3-10.43 1.96 0 3.93.37 5.37 1.41v2.67c-1.44-.92-3.04-1.41-5.37-1.41-4.72 0-7.54 3.13-7.54 7.76s2.91 7.7 7.7 7.7c2.12 0 3.77-.49 5.24-1.23"/>
    <path fill="var(--tile-color, white)" d="M8 .667h16A7.333 7.333 0 0 1 31.333 8v16A7.333 7.333 0 0 1 24 31.333H8A7.333 7.333 0 0 1 .667 24V8A7.333 7.333 0 0 1 8 .667"/>
    <path fill="none" stroke="var(--border-color, #dddee1)" stroke-width="1.333" d="M8 .667h16A7.333 7.333 0 0 1 31.333 8v16A7.333 7.333 0 0 1 24 31.333H8A7.333 7.333 0 0 1 .667 24V8A7.333 7.333 0 0 1 8 .667Z"/>
    <path fill="var(--icon-color, #1868db)" d="M24.946 9.951 16 6.657 7.054 9.95a.59.59 0 0 0-.387.577l.187 5.076c.137 4.197 2.245 7.319 5.55 9.357.31.19.719.063.86-.272l1.928-4.55a.294.294 0 0 0-.185-.396 3.447 3.447 0 1 1 1.987 0 .294.294 0 0 0-.185.397l1.927 4.549c.142.335.55.463.86.272 3.305-2.038 5.413-5.16 5.55-9.357l.187-5.076a.59.59 0 0 0-.387-.577"/>
</svg>
`;
function CrowdLogoCS({ size, appearance = 'brand', label = 'Crowd', testId }) {
    return /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _logoWrapper.LogoWrapper), {
        svg: svg,
        label: label,
        type: "data-center",
        appearance: appearance,
        size: size,
        testId: testId
    });
}

},{"react":"ltHCL","../../../utils/logo-wrapper":"aSXlT","@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"5LXqv":[function(require,module,exports,__globalThis) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::6a1acdf5e3aacf1ac91c03f0f8d3dcf4>>
 * @codegenCommand yarn workspace @atlaskit/logo generate:components
 */ var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
/**
 * __CustomLinkIcon__
 *
 * An internal component to represent the icon for Custom Link.
 * Do not use this internal component directly — use `CustomLinkIcon` from `@atlaskit/logo` instead.
 *
 */ parcelHelpers.export(exports, "CustomLinkIcon", ()=>CustomLinkIcon);
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _iconWrapper = require("../../../utils/icon-wrapper");
// `height` is set to 100% to allow the SVG to scale with the parent element
const svg = `<svg height="100%" viewBox="0 0 24 24">
    <path fill="var(--tile-color,#dddee1)" d="M0 6a6 6 0 0 1 6-6h12a6 6 0 0 1 6 6v12a6 6 0 0 1-6 6H6a6 6 0 0 1-6-6z"/>
    <path fill="var(--icon-color, #101214)" fill-rule="evenodd" d="M19 12a7 7 0 1 0-14 0 7 7 0 0 0 14 0m-9.37 4.625.026.074a5.26 5.26 0 0 1-2.833-3.824h2.136c.069 1.426.306 2.73.67 3.75m1.08-3.75c.068 1.255.278 2.353.567 3.162.179.5.37.841.54 1.042a.6.6 0 0 0 .183.165.7.7 0 0 0 .183-.165c.17-.2.361-.543.54-1.042.288-.809.498-1.907.566-3.162zm2.58-1.75h-2.58c.068-1.255.278-2.353.567-3.162.179-.5.37-.841.54-1.042A.7.7 0 0 1 12 6.756a.6.6 0 0 1 .183.165c.17.2.361.543.54 1.042.288.809.498 1.907.566 3.162m1.751 1.75c-.069 1.426-.306 2.73-.67 3.75l-.027.074a5.26 5.26 0 0 0 2.833-3.824zm2.136-1.75H15.04c-.069-1.426-.306-2.73-.67-3.75l-.027-.074a5.26 5.26 0 0 1 2.833 3.824m-8.218 0H6.823a5.26 5.26 0 0 1 2.833-3.824l-.027.074c-.364 1.02-.601 2.324-.67 3.75" clip-rule="evenodd"/>
</svg>
`;
function CustomLinkIcon({ size, appearance = 'brand', label = 'Custom Link', testId }) {
    return /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _iconWrapper.IconWrapper), {
        svg: svg,
        label: label,
        appearance: appearance,
        size: size,
        testId: testId
    });
}

},{"react":"ltHCL","../../../utils/icon-wrapper":"4NqBa","@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"2dUak":[function(require,module,exports,__globalThis) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::adde776e49635255fd9de5c803442f95>>
 * @codegenCommand yarn workspace @atlaskit/logo generate:components
 */ var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
/**
 * __CustomerServiceManagementIcon__
 *
 * An internal component to represent the icon for Customer Service Management.
 * Do not use this internal component directly — use `CustomerServiceManagementIcon` from `@atlaskit/logo` instead.
 *
 */ parcelHelpers.export(exports, "CustomerServiceManagementIcon", ()=>CustomerServiceManagementIcon);
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _iconWrapper = require("../../../utils/icon-wrapper");
// `height` is set to 100% to allow the SVG to scale with the parent element
const svg = `<svg height="100%" viewBox="0 0 24 24">
    <path fill="var(--tile-color,#ffc716)" d="M0 6a6 6 0 0 1 6-6h12a6 6 0 0 1 6 6v12a6 6 0 0 1-6 6H6a6 6 0 0 1-6-6z"/>
    <path fill="var(--icon-color, #101214)" d="M16.43 17.42A6.97 6.97 0 0 1 12 19H6.4v-.47l3.84-3.78a3.25 3.25 0 0 0 1.76.52c.65 0 1.25-.19 1.76-.51zm.99-.99A6.97 6.97 0 0 0 19 12a6.97 6.97 0 0 0-1.58-4.43l-2.67 2.67c.33.51.52 1.11.52 1.76s-.19 1.25-.51 1.76zm-.99-9.85-2.67 2.67A3.25 3.25 0 0 0 12 8.73c-.65 0-1.25.19-1.76.52L7.57 6.58A6.97 6.97 0 0 1 12 5c1.68 0 3.22.59 4.43 1.58m-9.85.99A6.97 6.97 0 0 0 5 12c0 1.68.59 3.22 1.58 4.43l2.67-2.67A3.25 3.25 0 0 1 8.73 12c0-.65.19-1.25.52-1.76z"/>
</svg>
`;
const customThemeSvg = `<svg height="100%" viewBox="0 0 24 24">
    <path fill="var(--themed-icon-color, currentcolor)" d="M18 0a6 6 0 0 1 6 6v12a6 6 0 0 1-6 6H6a6 6 0 0 1-6-6V6a6 6 0 0 1 6-6zm-4.238 14.751a3.25 3.25 0 0 1-1.762.516 3.25 3.25 0 0 1-1.762-.515L6.4 18.533V19H12a6.97 6.97 0 0 0 4.43-1.58zM6.58 7.571A6.97 6.97 0 0 0 5 12a6.97 6.97 0 0 0 1.58 4.43l2.669-2.668A3.25 3.25 0 0 1 8.733 12c0-.649.19-1.253.516-1.762zm8.172 2.667c.326.508.515 1.113.515 1.762s-.189 1.254-.515 1.762l2.668 2.668A6.97 6.97 0 0 0 19 12a6.97 6.97 0 0 0-1.58-4.43zM12 5a6.97 6.97 0 0 0-4.43 1.58l2.668 2.668A3.25 3.25 0 0 1 12 8.733c.649 0 1.253.19 1.762.516L16.43 6.58A6.97 6.97 0 0 0 12 5"/>
</svg>
`;
function CustomerServiceManagementIcon({ iconColor, size, appearance = 'brand', label = 'Customer Service Management', testId }) {
    return /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _iconWrapper.IconWrapper), {
        svg: svg,
        customThemeSvg: customThemeSvg,
        iconColor: iconColor,
        label: label,
        appearance: appearance,
        size: size,
        testId: testId
    });
}

},{"react":"ltHCL","../../../utils/icon-wrapper":"4NqBa","@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"1F709":[function(require,module,exports,__globalThis) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::e95354b27dc93f4ad2578de274aa63f2>>
 * @codegenCommand yarn workspace @atlaskit/logo generate:components
 */ var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
/**
 * __CustomerServiceManagementLogoCS__
 *
 * An internal component to represent the logo for Customer Service Management.
 *
 */ parcelHelpers.export(exports, "CustomerServiceManagementLogoCS", ()=>CustomerServiceManagementLogoCS);
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _logoWrapper = require("../../../utils/logo-wrapper");
// `height` is set to 100% to allow the SVG to scale with the parent element
// The text color is set to "currentColor" to allow the SVG to inherit the color set by the parent based on the theme.
const svg = `<svg height="100%" viewBox="0 0 456 32">
    <path fill="var(--text-color, #1e1f21)" d="M451.86 20.58c0 1.35.8 2.27 2.42 2.27.61 0 1.2-.12 1.66-.21v2.55c-.46.12-.98.25-1.78.25-3.28 0-4.88-1.93-4.88-4.78v-8.19h-2.48V10h2.48V6.75h2.58V10h4.08v2.45h-4.08zm-7.33-4.23v8.99h-2.64v-9.26c0-2.76-1.1-3.99-3.62-3.99-2.45 0-4.14 1.63-4.14 4.72v8.53h-2.64V10h2.64v2.52c.98-1.81 2.79-2.82 4.85-2.82 3.53 0 5.55 2.42 5.55 6.66m-22.92-4.27c-2.79 0-4.2 1.81-4.48 4.48h8.56c-.15-2.85-1.44-4.48-4.08-4.48m5.89 12.64c-1.26.68-3.19.92-4.75.92-5.73 0-8.25-3.31-8.25-8 0-4.63 2.58-7.94 7.24-7.94 4.72 0 6.62 3.28 6.62 7.94v1.2h-11.19c.37 2.61 2.06 4.29 5.67 4.29 1.78 0 3.28-.34 4.66-.83zm-26.16-7.92v8.53h-2.64v-9.26c0-2.76-1.1-3.99-3.62-3.99-2.45 0-4.14 1.63-4.14 4.72v8.53h-2.64V10h2.64v2.52c.98-1.81 2.79-2.82 4.85-2.82 2.61 0 4.39 1.32 5.15 3.74.86-2.36 2.91-3.74 5.46-3.74 3.44 0 5.34 2.33 5.34 6.66v8.99h-2.64v-8.52c0-3.16-1.1-4.72-3.62-4.72-2.45 0-4.14 1.63-4.14 4.72m-22.92-4.74c-2.79 0-4.2 1.81-4.48 4.48h8.56c-.15-2.85-1.44-4.48-4.08-4.48m5.89 12.64c-1.26.68-3.19.92-4.75.92-5.73 0-8.25-3.31-8.25-8 0-4.63 2.58-7.94 7.24-7.94 4.72 0 6.62 3.28 6.62 7.94v1.2h-11.19c.37 2.61 2.06 4.29 5.67 4.29 1.78 0 3.28-.34 4.66-.83zm-18.64-.62v-1.53c-.98 2.02-2.82 3.07-5.18 3.07-4.05 0-6.07-3.46-6.07-7.97 0-4.32 2.12-7.97 6.38-7.97 2.24 0 3.96 1.01 4.88 3.01V10h2.58v13.95c0 4.51-2.12 7.54-7.6 7.54-2.58 0-3.99-.34-5.46-.83v-2.58c1.69.55 3.44.92 5.34.92 3.83 0 5.15-2.05 5.15-4.91m-8.68-6.44c0 3.68 1.47 5.52 4.2 5.52 2.36 0 4.48-1.5 4.48-4.91v-1.23c0-3.4-1.93-4.91-4.17-4.91-2.97 0-4.51 1.96-4.51 5.52m-16.96.03c0 3.68 1.47 5.52 4.2 5.52 2.36 0 4.48-1.5 4.48-4.91v-1.23c0-3.4-1.93-4.91-4.17-4.91-2.97 0-4.51 1.96-4.51 5.52m8.68 7.67v-2.76c-.98 2.02-2.82 3.07-5.18 3.07-4.08 0-6.13-3.46-6.13-7.97 0-4.32 2.15-7.97 6.44-7.97 2.24 0 3.96 1.01 4.88 3.01V10h2.64v15.33zm-14.08-8.98v8.99h-2.64v-9.26c0-2.76-1.1-3.99-3.62-3.99-2.45 0-4.14 1.63-4.14 4.72v8.53h-2.64V10h2.64v2.52c.98-1.81 2.79-2.82 4.85-2.82 3.53 0 5.55 2.42 5.55 6.66m-28.33 1.31c0 3.68 1.47 5.52 4.2 5.52 2.36 0 4.48-1.5 4.48-4.91v-1.23c0-3.4-1.93-4.91-4.17-4.91-2.97 0-4.51 1.96-4.51 5.52m8.68 7.67v-2.76c-.98 2.02-2.82 3.07-5.18 3.07-4.08 0-6.13-3.46-6.13-7.97 0-4.32 2.15-7.97 6.44-7.97 2.24 0 3.96 1.01 4.88 3.01V10h2.64v15.33zm-31.44-11.01-2.76-7.48v18.49h-2.76V5.19h4.78l4.57 11.56 1.87 5.55 1.87-5.55 4.6-11.56h4.45v20.15h-2.76V7.06l-2.36 7.27-4.45 11.01h-2.67zm-21.51-2.23c-2.79 0-4.2 1.81-4.48 4.48h8.56c-.15-2.85-1.44-4.48-4.08-4.48m5.89 12.64c-1.26.68-3.19.92-4.75.92-5.73 0-8.25-3.31-8.25-8 0-4.63 2.58-7.94 7.24-7.94 4.72 0 6.62 3.28 6.62 7.94v1.2h-11.19c.37 2.61 2.06 4.29 5.67 4.29 1.78 0 3.28-.34 4.66-.83zm-15.1-2.16v2.36c-.92.49-2.33.71-3.74.71-5.46 0-8-3.31-8-8 0-4.63 2.55-7.94 8-7.94 1.38 0 2.45.18 3.65.74v2.45c-.98-.46-2.02-.74-3.47-.74-3.99 0-5.61 2.51-5.61 5.49s1.66 5.49 5.67 5.49c1.56 0 2.55-.21 3.5-.55M234.91 5.95c0-1.16.77-1.84 1.84-1.84s1.84.68 1.84 1.84-.77 1.84-1.84 1.84-1.84-.67-1.84-1.84m.49 19.38V10h2.64v15.33zm-8.24 0h-3.53L217.69 10h2.76l4.97 13.09L230.36 10h2.76zm-15.45-9.04v9.05h-2.58V10h2.58v2.7c.89-1.81 2.42-3.1 5.43-2.91v2.58c-3.37-.34-5.43.68-5.43 3.93m-12.46-4.21c-2.79 0-4.2 1.81-4.48 4.48h8.56c-.15-2.85-1.44-4.48-4.08-4.48m5.89 12.64c-1.26.68-3.19.92-4.75.92-5.73 0-8.25-3.31-8.25-8 0-4.63 2.58-7.94 7.24-7.94 4.72 0 6.62 3.28 6.62 7.94v1.2h-11.19c.37 2.61 2.05 4.29 5.67 4.29 1.78 0 3.28-.34 4.66-.83zm-15.33-4.95c0 3.5-2.08 5.86-7.08 5.86-3.89 0-5.7-.77-7.27-1.56v-2.82c1.87.98 4.75 1.69 7.42 1.69 3.04 0 4.17-1.2 4.17-2.97 0-1.78-1.1-2.73-4.94-3.65-4.54-1.1-6.56-2.67-6.56-5.98 0-3.13 2.39-5.46 7.08-5.46 2.91 0 4.78.71 6.16 1.47v2.76c-2.02-1.16-4.2-1.53-6.29-1.53-2.64 0-4.2.92-4.2 2.76 0 1.66 1.29 2.48 4.85 3.37 4.26 1.07 6.65 2.45 6.65 6.07m-26.4-3.5v9.05h-2.58V10h2.58v2.7c.89-1.81 2.42-3.1 5.43-2.91v2.58c-3.37-.34-5.43.68-5.43 3.93m-12.46-4.21c-2.79 0-4.2 1.81-4.48 4.48h8.56c-.15-2.85-1.44-4.48-4.08-4.48m5.89 12.64c-1.26.68-3.19.92-4.75.92-5.73 0-8.25-3.31-8.25-8 0-4.63 2.58-7.94 7.24-7.94 4.72 0 6.62 3.28 6.62 7.94v1.2H146.5c.37 2.61 2.06 4.29 5.67 4.29 1.78 0 3.28-.34 4.66-.83zm-26.15-7.92v8.53h-2.64v-9.26c0-2.76-1.1-3.99-3.62-3.99-2.45 0-4.14 1.63-4.14 4.72v8.53h-2.64V10h2.64v2.52c.98-1.81 2.79-2.82 4.85-2.82 2.61 0 4.39 1.32 5.15 3.74.86-2.36 2.91-3.74 5.46-3.74 3.44 0 5.34 2.33 5.34 6.66v8.99h-2.64v-8.52c0-3.16-1.1-4.72-3.62-4.72-2.45 0-4.14 1.63-4.14 4.72m-23.34 8.81c-4.6 0-7.3-3.4-7.3-8s2.7-7.94 7.3-7.94c4.57 0 7.24 3.34 7.24 7.94s-2.67 8-7.24 8m0-13.49c-3.28 0-4.72 2.58-4.72 5.49s1.44 5.55 4.72 5.55c3.25 0 4.66-2.64 4.66-5.55s-1.41-5.49-4.66-5.49M94.1 20.58c0 1.35.8 2.27 2.42 2.27.61 0 1.2-.12 1.66-.21v2.55a6.3 6.3 0 0 1-1.78.25c-3.28 0-4.88-1.93-4.88-4.78v-8.19h-2.48V10h2.48V6.75h2.58V10h4.08v2.45H94.1zm-6.7.58c0 2.55-1.66 4.48-5.77 4.48-2.3 0-4.17-.52-5.34-1.13v-2.79c1.32.77 3.53 1.5 5.46 1.5 2.02 0 3.07-.83 3.07-2.02 0-1.16-.89-1.84-3.8-2.54-3.4-.83-4.84-2.15-4.84-4.66 0-2.67 2.05-4.29 5.55-4.29 1.99 0 3.8.49 4.94 1.1v2.73c-1.84-.92-3.34-1.41-4.97-1.41-1.93 0-2.97.68-2.97 1.87 0 1.07.74 1.75 3.56 2.42 3.4.83 5.12 2.09 5.12 4.75m-27.6-2.18V10h2.64v9.26c0 2.76 1.1 3.99 3.62 3.99 2.45 0 4.14-1.63 4.14-4.72V10h2.64v15.33h-2.64v-2.51c-.98 1.81-2.79 2.82-4.84 2.82-3.53 0-5.55-2.42-5.55-6.65m-2.89 2.79v2.67c-1.26.83-3.25 1.2-5.34 1.2-6.62 0-10.36-3.99-10.36-10.33 0-6.13 3.74-10.43 10.3-10.43 1.96 0 3.93.37 5.37 1.41v2.67c-1.44-.92-3.04-1.41-5.37-1.41-4.72 0-7.54 3.13-7.54 7.76s2.91 7.7 7.7 7.7c2.12 0 3.77-.49 5.24-1.23"/>
    <path fill="var(--tile-color,#ffc716)" d="M0 8a8 8 0 0 1 8-8h16a8 8 0 0 1 8 8v16a8 8 0 0 1-8 8H8a8 8 0 0 1-8-8z"/>
    <path fill="var(--icon-color, #101214)" d="M21.91 23.23a9.3 9.3 0 0 1-5.91 2.1H8.53v-.62l5.12-5.04a4.34 4.34 0 0 0 2.35.69c.86 0 1.67-.25 2.35-.69zm1.32-1.32a9.3 9.3 0 0 0 2.1-5.91c0-2.24-.79-4.3-2.11-5.91l-3.56 3.56c.43.68.69 1.48.69 2.35s-.25 1.67-.69 2.35zM21.91 8.77l-3.56 3.56a4.34 4.34 0 0 0-2.35-.69c-.86 0-1.67.25-2.35.69l-3.56-3.56A9.3 9.3 0 0 1 16 6.67c2.24 0 4.3.79 5.91 2.11M8.77 10.09A9.3 9.3 0 0 0 6.67 16c0 2.24.79 4.3 2.11 5.91l3.56-3.56a4.34 4.34 0 0 1-.69-2.35c0-.86.25-1.67.69-2.35z"/>
</svg>
`;
function CustomerServiceManagementLogoCS({ size, appearance = 'brand', label = 'Customer Service Management', testId }) {
    return /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _logoWrapper.LogoWrapper), {
        svg: svg,
        label: label,
        appearance: appearance,
        size: size,
        testId: testId
    });
}

},{"react":"ltHCL","../../../utils/logo-wrapper":"aSXlT","@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"cZ76K":[function(require,module,exports,__globalThis) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::772abda1b80977ea1535de7e3f60e0fa>>
 * @codegenCommand yarn workspace @atlaskit/logo generate:components
 */ var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
/**
 * __DxIcon__
 *
 * An internal component to represent the icon for Dx.
 * Do not use this internal component directly — use `DxIcon` from `@atlaskit/logo` instead.
 *
 */ parcelHelpers.export(exports, "DxIcon", ()=>DxIcon);
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _iconWrapper = require("../../../utils/icon-wrapper");
// `height` is set to 100% to allow the SVG to scale with the parent element
const svg = `<svg height="100%" viewBox="0 0 48 48">
    <path fill="var(--tile-color,#94c748)" d="M0 12C0 5.373 5.373 0 12 0h24c6.627 0 12 5.373 12 12v24c0 6.627-5.373 12-12 12H12C5.373 48 0 42.627 0 36z"/>
    <path fill="var(--icon-color, #101214)" d="m36.22 26.75 4.9 7.25h-4.78c-.52-.6-1.02-1.31-1.47-1.98-.68-1.02-.68-2.41.03-3.41zm-7.3-5.5L24.02 14h4.78c.52.6 1.02 1.31 1.47 1.98.68 1.02.68 2.41-.02 3.41zm6.98-6.02c.5-.84 1.07-1.16 1.95-1.16l3.9-.07-12.68 19.27a1.46 1.46 0 0 1-1.22.67H23.6c4.07-6.25 8.37-12.37 12.31-18.7M8 33.94h6.89c6.16 0 9.92-3.88 9.92-9.94s-3.76-9.94-9.92-9.94H8l4.28 3.9h-1.76C9.13 17.96 8 19.12 8 20.55v13.38m4.41-3.9V17.96h2.46c3.52 0 5.49 2.38 5.49 6.04 0 3.65-1.97 6.04-5.46 6.04z"/>
</svg>
`;
function DxIcon({ size, appearance = 'brand', label = 'Dx', testId }) {
    return /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _iconWrapper.IconWrapper), {
        svg: svg,
        label: label,
        appearance: appearance,
        size: size,
        testId: testId
    });
}

},{"react":"ltHCL","../../../utils/icon-wrapper":"4NqBa","@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"CKDBX":[function(require,module,exports,__globalThis) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::2b7db25f7017f6ec5d21f0ae31065359>>
 * @codegenCommand yarn workspace @atlaskit/logo generate:components
 */ var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
/**
 * __FeedbackIcon__
 *
 * An internal component to represent the icon for Feedback.
 * Do not use this internal component directly — use `FeedbackIcon` from `@atlaskit/logo` instead.
 *
 */ parcelHelpers.export(exports, "FeedbackIcon", ()=>FeedbackIcon);
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _iconWrapper = require("../../../utils/icon-wrapper");
// `height` is set to 100% to allow the SVG to scale with the parent element
const svg = `<svg height="100%" viewBox="0 0 48 48">
    <rect width="48" height="48" fill="var(--tile-color,#c97cf4)" rx="12"/>
    <path fill="var(--icon-color, #101214)" d="M20 19h5v11h-5zm7-9h5v28h-5zm7 6h5v16h-5zm-21 0h5v16h-5zm-7 5h5v7H6z"/>
</svg>
`;
function FeedbackIcon({ size, appearance = 'brand', label = 'Feedback', testId }) {
    return /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _iconWrapper.IconWrapper), {
        svg: svg,
        label: label,
        appearance: appearance,
        size: size,
        testId: testId
    });
}

},{"react":"ltHCL","../../../utils/icon-wrapper":"4NqBa","@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"dO0ug":[function(require,module,exports,__globalThis) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::fe7d010e7776c61d1ffb49fef9c7dd61>>
 * @codegenCommand yarn workspace @atlaskit/logo generate:components
 */ var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
/**
 * __FeedbackLogoCS__
 *
 * An internal component to represent the logo for Feedback.
 *
 */ parcelHelpers.export(exports, "FeedbackLogoCS", ()=>FeedbackLogoCS);
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _logoWrapper = require("../../../utils/logo-wrapper");
// `height` is set to 100% to allow the SVG to scale with the parent element
// The text color is set to "currentColor" to allow the SVG to inherit the color set by the parent based on the theme.
const svg = `<svg height="100%" viewBox="0 0 169 32">
    <path fill="var(--text-color, #1e1f21)" d="M157.894 25.334h-2.638V3.59h2.638v13.585L164.487 10h3.435l-7.207 7.544 7.513 7.79h-3.588l-6.746-7.177zm-5.648-2.761v2.362c-.92.49-2.331.705-3.742.705-5.458 0-8.004-3.312-8.004-8.004 0-4.63 2.546-7.943 8.004-7.943 1.38 0 2.454.184 3.65.736v2.454c-.982-.46-2.024-.736-3.466-.736-3.986 0-5.612 2.514-5.612 5.489s1.656 5.49 5.674 5.49c1.564 0 2.545-.215 3.496-.553m-26.118-4.906c0 3.68 1.472 5.52 4.201 5.52 2.361 0 4.477-1.503 4.477-4.907v-1.227c0-3.404-1.932-4.906-4.17-4.906-2.975 0-4.508 1.962-4.508 5.52m8.678 7.666v-2.76c-.981 2.024-2.821 3.067-5.182 3.067-4.079 0-6.134-3.465-6.134-7.973 0-4.324 2.147-7.974 6.44-7.974 2.239 0 3.956 1.012 4.876 3.006V10h2.638v15.333zm-16.09-7.666c0-3.68-1.472-5.52-4.201-5.52-2.362 0-4.478 1.502-4.478 4.906v1.227c0 3.404 1.932 4.907 4.171 4.907 2.975 0 4.508-1.963 4.508-5.52m-3.803 7.973c-2.238 0-3.956-1.012-4.876-3.005v2.698H107.4V3.592h2.637v9.17c.982-2.025 2.822-3.068 5.183-3.068 4.079 0 6.133 3.466 6.133 7.974 0 4.324-2.146 7.973-6.44 7.973m-22.806-7.974c0 3.68 1.472 5.52 4.2 5.52 2.362 0 4.478-1.503 4.478-4.907v-1.227c0-3.404-1.932-4.906-4.17-4.906-2.975 0-4.508 1.963-4.508 5.52m8.678 7.666v-2.76c-.981 2.024-2.821 3.067-5.182 3.067-4.08 0-6.134-3.465-6.134-7.973 0-4.324 2.147-7.974 6.44-7.974 2.239 0 3.956 1.013 4.876 3.006V3.59h2.638v21.743zM80.502 12.085c-2.79 0-4.201 1.81-4.477 4.478h8.555c-.153-2.852-1.44-4.478-4.078-4.478M86.39 24.72c-1.258.675-3.19.92-4.754.92-5.734 0-8.249-3.312-8.249-8.004 0-4.63 2.576-7.943 7.237-7.943 4.723 0 6.625 3.282 6.625 7.943v1.196H76.055c.368 2.607 2.055 4.293 5.673 4.293 1.78 0 3.282-.337 4.662-.828zM64.42 12.085c-2.79 0-4.202 1.81-4.477 4.478h8.556c-.154-2.852-1.442-4.478-4.08-4.478m5.888 12.635c-1.258.675-3.19.92-4.754.92-5.734 0-8.249-3.312-8.249-8.004 0-4.63 2.576-7.943 7.238-7.943 4.722 0 6.623 3.282 6.623 7.943v1.196H59.974c.368 2.607 2.055 4.293 5.674 4.293 1.778 0 3.28-.337 4.66-.828zm-15.679-6.9H45.49v7.514h-2.76V5.186h12.94v2.637H45.49v7.36h9.138z"/>
    <rect width="32" height="32" fill="var(--tile-color,#c97cf4)" rx="8"/>
    <path fill="var(--icon-color, #101214)" d="M13.333 12.667h3.334V20h-3.334zm4.667-6h3.333v18.666H18zm4.667 4H26v10.666h-3.333zm-14 0H12v10.666H8.667zM4 14h3.333v4.666H4z"/>
</svg>
`;
function FeedbackLogoCS({ size, appearance = 'brand', label = 'Feedback', testId }) {
    return /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _logoWrapper.LogoWrapper), {
        svg: svg,
        label: label,
        appearance: appearance,
        size: size,
        testId: testId
    });
}

},{"react":"ltHCL","../../../utils/logo-wrapper":"aSXlT","@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"huGIX":[function(require,module,exports,__globalThis) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::c86bc4a90f7eb35fd36ae7c99f20011b>>
 * @codegenCommand yarn workspace @atlaskit/logo generate:components
 */ var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
/**
 * __FocusIcon__
 *
 * A temporary component to represent the icon for Focus.
 * @deprecated This component has been replaced by the component `FocusIcon` in `@atlaskit/logo`.
 * Please migrate any usages of this temporary component, using the prop `shouldUseNewLogoDesign` where necessary
 * to enable the new design by default.
 *
 */ parcelHelpers.export(exports, "FocusIcon", ()=>FocusIcon);
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _iconWrapper = require("../../../utils/icon-wrapper");
// `height` is set to 100% to allow the SVG to scale with the parent element
const svg = `<svg height="100%" viewBox="0 0 24 24">
    <path fill="var(--tile-color,#fb9700)" d="M0 6a6 6 0 0 1 6-6h12a6 6 0 0 1 6 6v12a6 6 0 0 1-6 6H6a6 6 0 0 1-6-6z"/>
    <path fill="var(--icon-color, #101214)" d="M20.84 12.21a4.29 4.29 0 0 0-6.05 0l-1.394 1.393c-.77.769-2.02.769-2.789 0L9.45 12.445 6.424 15.47l1.158 1.158a6.25 6.25 0 0 0 8.838 0zm-17.68-.418a4.253 4.253 0 0 0 6.034.017l1.412-1.412a1.973 1.973 0 0 1 2.788 0l1.158 1.158 3.026-3.025-1.158-1.158a6.25 6.25 0 0 0-8.838 0l-4.42 4.419z"/>
</svg>
`;
function FocusIcon({ size, appearance = 'brand', label = 'Focus', testId }) {
    return /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _iconWrapper.IconWrapper), {
        svg: svg,
        label: label,
        appearance: appearance,
        size: size,
        testId: testId
    });
}

},{"react":"ltHCL","../../../utils/icon-wrapper":"4NqBa","@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"fnqFA":[function(require,module,exports,__globalThis) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::7aca4717e5f7edbaa74141430c7d1f8d>>
 * @codegenCommand yarn workspace @atlaskit/logo generate:components
 */ var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
/**
 * __FocusLogoCS__
 *
 * A temporary component to represent the logo for Focus.
 *
 */ parcelHelpers.export(exports, "FocusLogoCS", ()=>FocusLogoCS);
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _logoWrapper = require("../../../utils/logo-wrapper");
// `height` is set to 100% to allow the SVG to scale with the parent element
// The text color is set to "currentColor" to allow the SVG to inherit the color set by the parent based on the theme.
const svg = `<svg height="100%" viewBox="0 0 117 32">
    <path fill="var(--text-color, #1e1f21)" d="M116.03 21.16c0 2.55-1.66 4.48-5.76 4.48-2.3 0-4.17-.52-5.34-1.13v-2.79c1.32.77 3.53 1.5 5.46 1.5 2.02 0 3.07-.83 3.07-2.02 0-1.16-.89-1.84-3.8-2.54-3.4-.83-4.85-2.15-4.85-4.66 0-2.67 2.06-4.29 5.55-4.29 1.99 0 3.8.49 4.94 1.1v2.73c-1.84-.92-3.34-1.41-4.97-1.41-1.93 0-2.97.68-2.97 1.87 0 1.07.74 1.75 3.56 2.42 3.4.83 5.12 2.09 5.12 4.75m-27.6-2.18V10h2.64v9.26c0 2.76 1.1 3.99 3.62 3.99 2.45 0 4.14-1.62 4.14-4.72V10h2.64v15.33h-2.64v-2.51c-.98 1.81-2.79 2.82-4.85 2.82-3.53 0-5.55-2.42-5.55-6.65m-2.71 3.58v2.36c-.92.49-2.33.71-3.74.71-5.46 0-8-3.31-8-8 0-4.63 2.55-7.94 8-7.94 1.38 0 2.45.18 3.65.74v2.45c-.98-.46-2.02-.74-3.47-.74-3.99 0-5.61 2.51-5.61 5.49s1.66 5.49 5.67 5.49c1.56 0 2.55-.21 3.5-.55M64.6 25.64c-4.6 0-7.3-3.4-7.3-8S60 9.7 64.6 9.7c4.57 0 7.24 3.34 7.24 7.94s-2.67 8-7.24 8m0-13.49c-3.28 0-4.72 2.58-4.72 5.49s1.44 5.55 4.72 5.55c3.25 0 4.66-2.64 4.66-5.55s-1.41-5.49-4.66-5.49m-9.97 5.67h-9.14v7.51h-2.76V5.19h12.94v2.64H45.49v7.36h9.14z"/>
    <path fill="var(--tile-color,#fb9700)" d="M0 8a8 8 0 0 1 8-8h16a8 8 0 0 1 8 8v16a8 8 0 0 1-8 8H8a8 8 0 0 1-8-8z"/>
    <path fill="var(--icon-color, #101214)" d="M27.607 16.272c-2.176-2.176-5.712-2.152-7.865 0l-1.812 1.812c-1 1-2.625 1-3.625 0L12.8 16.578l-3.933 3.934 1.505 1.505a8.126 8.126 0 0 0 11.49 0zm-22.982-.541c2.176 2.175 5.668 2.196 7.844.02l1.834-1.834c1-1 2.625-1 3.625 0l1.505 1.505 3.934-3.933-1.505-1.505a8.126 8.126 0 0 0-11.49 0l-5.745 5.745z"/>
</svg>
`;
function FocusLogoCS({ size, appearance = 'brand', label = 'Focus', testId }) {
    return /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _logoWrapper.LogoWrapper), {
        svg: svg,
        label: label,
        appearance: appearance,
        size: size,
        testId: testId
    });
}

},{"react":"ltHCL","../../../utils/logo-wrapper":"aSXlT","@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"bOzby":[function(require,module,exports,__globalThis) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::02833d9738a6774113f222b59b2a94ce>>
 * @codegenCommand yarn workspace @atlaskit/logo generate:components
 */ var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
/**
 * __GoalsIcon__
 *
 * An internal component to represent the icon for Goals.
 * Do not use this internal component directly — use `GoalsIcon` from `@atlaskit/logo` instead.
 *
 */ parcelHelpers.export(exports, "GoalsIcon", ()=>GoalsIcon);
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _iconWrapper = require("../../../utils/icon-wrapper");
// `height` is set to 100% to allow the SVG to scale with the parent element
const svg = `<svg height="100%" viewBox="0 0 24 24">
    <path fill="var(--tile-color,#dddee1)" d="M0 6a6 6 0 0 1 6-6h12a6 6 0 0 1 6 6v12a6 6 0 0 1-6 6H6a6 6 0 0 1-6-6z"/>
    <path fill="var(--icon-color, #101214)" d="M14.352 12a2.352 2.352 0 1 1-4.704 0 2.352 2.352 0 0 1 4.704 0"/>
    <path fill="var(--icon-color, #101214)" fill-rule="evenodd" d="M12 18.563a6.562 6.562 0 1 0 0-13.125 6.562 6.562 0 0 0 0 13.125M16.102 12a4.102 4.102 0 1 1-8.204 0 4.102 4.102 0 0 1 8.204 0" clip-rule="evenodd"/>
</svg>
`;
function GoalsIcon({ size, appearance = 'brand', label = 'Goals', testId }) {
    return /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _iconWrapper.IconWrapper), {
        svg: svg,
        label: label,
        appearance: appearance,
        size: size,
        testId: testId
    });
}

},{"react":"ltHCL","../../../utils/icon-wrapper":"4NqBa","@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"5qXAm":[function(require,module,exports,__globalThis) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::56bcd62ca7ac54601202de0d95c6f0a6>>
 * @codegenCommand yarn workspace @atlaskit/logo generate:components
 */ var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
/**
 * __GoalsLogoCS__
 *
 * An internal component to represent the logo for Goals.
 *
 */ parcelHelpers.export(exports, "GoalsLogoCS", ()=>GoalsLogoCS);
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _logoWrapper = require("../../../utils/logo-wrapper");
// `height` is set to 100% to allow the SVG to scale with the parent element
// The text color is set to "currentColor" to allow the SVG to inherit the color set by the parent based on the theme.
const svg = `<svg height="100%" viewBox="0 0 116 32">
    <path fill="var(--text-color, #1e1f21)" d="M115.55 21.16c0 2.55-1.66 4.48-5.77 4.48-2.3 0-4.17-.52-5.34-1.13v-2.79c1.32.77 3.53 1.5 5.46 1.5 2.02 0 3.07-.83 3.07-2.02 0-1.16-.89-1.84-3.8-2.54-3.4-.83-4.84-2.15-4.84-4.66 0-2.67 2.05-4.29 5.55-4.29 1.99 0 3.8.49 4.94 1.1v2.73c-1.84-.92-3.34-1.41-4.97-1.41-1.93 0-2.97.68-2.97 1.87 0 1.07.74 1.75 3.56 2.42 3.4.83 5.12 2.09 5.12 4.75m-13.12 4.13c-.21.06-.67.12-1.35.12-2.51 0-4.11-1.19-4.11-4.02V3.59h2.64V21.1c0 1.38.92 1.87 2.06 1.87.28 0 .46 0 .77-.03zm-20.75-7.63c0 3.68 1.47 5.52 4.2 5.52 2.36 0 4.48-1.5 4.48-4.91v-1.23c0-3.4-1.93-4.91-4.17-4.91-2.97 0-4.51 1.96-4.51 5.52m8.68 7.67v-2.76c-.98 2.02-2.82 3.07-5.18 3.07-4.08 0-6.13-3.46-6.13-7.97 0-4.32 2.15-7.97 6.44-7.97 2.24 0 3.96 1.01 4.88 3.01V10h2.64v15.33zm-20.7.31c-4.6 0-7.3-3.4-7.3-8s2.7-7.94 7.3-7.94c4.57 0 7.24 3.34 7.24 7.94s-2.67 8-7.24 8m0-13.49c-3.28 0-4.72 2.58-4.72 5.49s1.44 5.55 4.72 5.55c3.25 0 4.66-2.64 4.66-5.55s-1.41-5.49-4.66-5.49M58.71 24.2c-1.59.95-4.54 1.44-6.81 1.44-6.93 0-10.67-4.23-10.67-10.33 0-6.56 4.26-10.46 11.44-10.46 1.6 0 3.47.18 5.24.8v2.76c-1.53-.61-3.34-.89-5.21-.89-5.98 0-8.71 2.98-8.71 7.73 0 4.66 2.76 7.76 8.56 7.76.95 0 2.27-.09 3.4-.43v-5.61H50.8v-2.64h7.91z"/>
    <path fill="var(--tile-color,#dddee1)" d="M0 8a8 8 0 0 1 8-8h16a8 8 0 0 1 8 8v16a8 8 0 0 1-8 8H8a8 8 0 0 1-8-8z"/>
    <path fill="var(--icon-color, #101214)" d="M19.36 16a3.36 3.36 0 1 1-6.72 0 3.36 3.36 0 0 1 6.72 0"/>
    <path fill="var(--icon-color, #101214)" fill-rule="evenodd" d="M16 25.375a9.375 9.375 0 1 0 0-18.75 9.375 9.375 0 1 0 0 18.75M21.86 16a5.86 5.86 0 1 1-11.72 0 5.86 5.86 0 0 1 11.72 0" clip-rule="evenodd"/>
</svg>
`;
function GoalsLogoCS({ size, appearance = 'brand', label = 'Goals', testId }) {
    return /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _logoWrapper.LogoWrapper), {
        svg: svg,
        label: label,
        appearance: appearance,
        size: size,
        testId: testId
    });
}

},{"react":"ltHCL","../../../utils/logo-wrapper":"aSXlT","@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"a5CkP":[function(require,module,exports,__globalThis) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::0276df52cce3ff4af21c51ddcfcd1999>>
 * @codegenCommand yarn workspace @atlaskit/logo generate:components
 */ var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
/**
 * __GuardDetectIcon__
 *
 * An internal component to represent the icon for Guard Detect.
 * Do not use this internal component directly — use `GuardDetectIcon` from `@atlaskit/logo` instead.
 *
 */ parcelHelpers.export(exports, "GuardDetectIcon", ()=>GuardDetectIcon);
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _iconWrapper = require("../../../utils/icon-wrapper");
// `height` is set to 100% to allow the SVG to scale with the parent element
const svg = `<svg height="100%" viewBox="0 0 24 24">
    <path fill="var(--tile-color,#dddee1)" d="M0 6a6 6 0 0 1 6-6h12a6 6 0 0 1 6 6v12a6 6 0 0 1-6 6H6a6 6 0 0 1-6-6z"/>
    <path fill="var(--icon-color, #101214)" d="M5.49 10.87h13.02c.374 0 .574-.2.574-.574V5.907c0-.374-.2-.574-.574-.574h-2.744c-.374 0-.573.2-.573.574v2.22h-1.247v-2.22c0-.374-.2-.574-.574-.574h-2.743c-.374 0-.574.2-.574.574v2.22H8.807v-2.22c0-.374-.2-.574-.573-.574H5.49c-.374 0-.573.2-.573.574v4.39c0 .373.2.573.573.573m.225 3.84a8.7 8.7 0 0 1-.5-2.493c-.024-.324.126-.499.475-.499h12.62c.349 0 .498.15.498.449a8.2 8.2 0 0 1-.523 2.544c-.15.399-.375.573-.799.573H6.513c-.424 0-.649-.174-.798-.573m11.547 2.07C16.065 18.253 14.095 19.2 12 19.2s-4.116-.948-5.288-2.42c-.299-.398-.15-.648.15-.648h10.275c.3 0 .45.25.125.649"/>
</svg>
`;
function GuardDetectIcon({ size, appearance = 'brand', label = 'Guard Detect', testId }) {
    return /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _iconWrapper.IconWrapper), {
        svg: svg,
        label: label,
        appearance: appearance,
        size: size,
        testId: testId
    });
}

},{"react":"ltHCL","../../../utils/icon-wrapper":"4NqBa","@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"3As3C":[function(require,module,exports,__globalThis) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::ffc02f6eb51ba8d719155b3e3ac4a088>>
 * @codegenCommand yarn workspace @atlaskit/logo generate:components
 */ var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
/**
 * __GuardDetectLogo__
 *
 * An internal component to represent the logo for Guard Detect.
 *
 */ parcelHelpers.export(exports, "GuardDetectLogo", ()=>GuardDetectLogo);
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _logoWrapper = require("../../../utils/logo-wrapper");
// `height` is set to 100% to allow the SVG to scale with the parent element
// The text color is set to "currentColor" to allow the SVG to inherit the color set by the parent based on the theme.
const svg = `<svg height="100%" viewBox="0 0 121 24">
    <path fill="var(--tile-color,#dddee1)" d="M0 6a6 6 0 0 1 6-6h12a6 6 0 0 1 6 6v12a6 6 0 0 1-6 6H6a6 6 0 0 1-6-6z"/>
    <path fill="var(--icon-color, #101214)" d="M5.49 10.87h13.02c.374 0 .574-.2.574-.574V5.907c0-.374-.2-.574-.574-.574h-2.744c-.374 0-.573.2-.573.574v2.22h-1.247v-2.22c0-.374-.2-.574-.574-.574h-2.743c-.374 0-.574.2-.574.574v2.22H8.807v-2.22c0-.374-.2-.574-.573-.574H5.49c-.374 0-.573.2-.573.574v4.39c0 .373.2.573.573.573m.225 3.84a8.7 8.7 0 0 1-.5-2.493c-.024-.324.126-.499.475-.499h12.62c.349 0 .498.15.498.449a8.2 8.2 0 0 1-.523 2.544c-.15.399-.375.573-.799.573H6.513c-.424 0-.649-.174-.798-.573m11.547 2.07C16.065 18.253 14.095 19.2 12 19.2s-4.116-.948-5.288-2.42c-.299-.398-.15-.648.15-.648h10.275c.3 0 .45.25.125.649"/>
    <path fill="var(--text-color, #292a2e)" d="M120.03 9.36v1.48h-4.44V9.36zm-3.38-1.82h1.92v7.27q0 .38.17.57t.56.19a3 3 0 0 0 .32-.03 5 5 0 0 0 .32-.06l.29 1.46a3.4 3.4 0 0 1-.63.13 5 5 0 0 1-.62.04q-1.13 0-1.73-.55-.59-.56-.59-1.59zm-5.13 9.61q-1.13 0-1.96-.49a3.3 3.3 0 0 1-1.28-1.38q-.45-.89-.45-2.06 0-1.18.45-2.07a3.3 3.3 0 0 1 1.28-1.39q.83-.49 1.96-.49.66 0 1.22.17t1 .49.73.78.41 1.03l-1.8.36q-.06-.3-.2-.54a1.5 1.5 0 0 0-.33-.4 1.3 1.3 0 0 0-.44-.26 1.6 1.6 0 0 0-.56-.09q-.58 0-.97.31t-.59.86q-.2.54-.2 1.24t.2 1.24.59.86q.39.31.97.31.32 0 .57-.09.26-.09.46-.27a1.6 1.6 0 0 0 .34-.42q.14-.25.2-.56l1.79.35q-.12.6-.4 1.06t-.73.79a3.3 3.3 0 0 1-1 .51q-.56.17-1.23.17m-8.29-.02q-1.16 0-2-.48a3.26 3.26 0 0 1-1.29-1.37q-.45-.88-.45-2.08 0-1.18.44-2.06a3.4 3.4 0 0 1 1.26-1.39q.82-.5 1.93-.5.73 0 1.36.23.64.23 1.13.71.49.47.77 1.2t.28 1.72v.57h-6.34v-1.25h5.39l-.9.35q0-.62-.19-1.08a1.54 1.54 0 0 0-.57-.72q-.37-.26-.93-.26-.55 0-.94.26t-.59.7-.2.99v.88q0 .69.23 1.17.24.47.66.71t.98.24q.37 0 .68-.11t.53-.31q.22-.21.34-.52l1.75.34q-.18.62-.64 1.09-.45.46-1.13.73-.68.25-1.54.25m-4.67-7.8v1.48h-4.44V9.36zm-3.38-1.82h1.92v7.27q0 .38.17.57t.56.19q.12 0 .32-.03.21-.03.32-.06l.29 1.46q-.31.1-.64.13a5 5 0 0 1-.62.04q-1.13 0-1.73-.55-.59-.56-.59-1.59zm-5.19 9.61q-1.16 0-2-.48a3.26 3.26 0 0 1-1.29-1.37q-.45-.88-.45-2.08 0-1.18.44-2.06A3.4 3.4 0 0 1 88 9.77q.82-.5 1.93-.5.72 0 1.36.23t1.14.71q.49.47.77 1.2t.28 1.72v.57h-6.34v-1.25h5.39l-.9.35a2.8 2.8 0 0 0-.19-1.08 1.55 1.55 0 0 0-.57-.72q-.37-.26-.93-.26-.55 0-.94.26t-.59.7-.2.99v.88q0 .69.23 1.17.24.47.66.71t.98.24q.37 0 .68-.11t.53-.31a1.4 1.4 0 0 0 .34-.52l1.75.34q-.18.62-.64 1.09-.45.46-1.13.73-.68.25-1.54.25M80.08 17h-2.6v-1.69H80q1.02 0 1.71-.37t1.03-1.12q.35-.76.35-1.91t-.35-1.9a2.32 2.32 0 0 0-1.02-1.12q-.68-.37-1.69-.37h-2.61v-1.7h2.71q1.52 0 2.62.61a4.1 4.1 0 0 1 1.69 1.75q.6 1.14.6 2.73t-.59 2.74a4.1 4.1 0 0 1-1.7 1.76q-1.12.59-2.67.59M78.53 6.81V17h-1.96V6.81zM67.1 17.13a2.9 2.9 0 0 1-1.6-.46q-.71-.46-1.12-1.33-.41-.88-.41-2.15 0-1.29.42-2.17.42-.87 1.13-1.32a2.9 2.9 0 0 1 1.57-.44q.66 0 1.09.23.43.22.69.54.27.32.4.61h.07V6.81h1.92V17h-1.89v-1.22h-.1a2.8 2.8 0 0 1-.4.61q-.27.31-.7.53-.43.21-1.07.21m.56-1.55q.55 0 .94-.3.38-.3.58-.84.21-.54.21-1.25 0-.72-.2-1.25t-.59-.83q-.38-.29-.94-.29-.57 0-.95.31a1.85 1.85 0 0 0-.58.83 3.6 3.6 0 0 0-.19 1.22q0 .69.19 1.23.2.54.58.85.39.31.95.31M58.98 17V9.36h1.87v1.31h.08q.2-.68.71-1.05a1.93 1.93 0 0 1 1.16-.36q.15 0 .34.02.18.01.32.04v1.74a2 2 0 0 0-.38-.07 5 5 0 0 0-.48-.03q-.48 0-.86.21a1.5 1.5 0 0 0-.6.57 1.65 1.65 0 0 0-.21.85V17zm-5.98.13a2.9 2.9 0 0 1-1.59-.46q-.7-.46-1.12-1.33-.41-.88-.41-2.15 0-1.29.42-2.17.42-.87 1.14-1.32a2.9 2.9 0 0 1 1.58-.44q.66 0 1.09.23.43.22.69.54t.4.61h.08V9.36h1.91V17h-1.9v-1.22h-.08a2.6 2.6 0 0 1-.41.61q-.27.32-.7.53t-1.08.21m.57-1.55q.56 0 .94-.3t.58-.84q.21-.54.21-1.25 0-.72-.2-1.25t-.58-.83-.94-.29q-.57 0-.96.3a1.85 1.85 0 0 0-.58.83 3.6 3.6 0 0 0-.19 1.23q0 .69.2 1.23t.58.85q.39.31.95.31m-9.43 1.53q-.79 0-1.39-.34a2.34 2.34 0 0 1-.92-.98q-.33-.65-.33-1.55V9.37h1.93v4.54q0 .75.38 1.16t1.05.42q.46 0 .81-.19.35-.2.55-.57t.2-.9V9.38h1.93V17h-1.82l-.02-1.9h.12q-.31.98-.93 1.49t-1.56.51m-8.95.04q-1.29 0-2.32-.64-1.02-.63-1.63-1.8-.6-1.17-.6-2.77 0-1.65.62-2.82t1.68-1.8q1.07-.63 2.41-.63.85 0 1.58.25.74.25 1.31.7.57.46.94 1.09a3.8 3.8 0 0 1 .49 1.37h-2.01a2.3 2.3 0 0 0-.32-.69 2 2 0 0 0-.5-.52 2 2 0 0 0-.66-.33 2.6 2.6 0 0 0-.81-.12q-.81 0-1.43.4T33 10.01q-.35.77-.35 1.89 0 1.11.35 1.89t.98 1.19q.64.4 1.48.4.76 0 1.3-.29a2 2 0 0 0 .83-.83q.29-.55.29-1.29h.42v.85q0 .66-.16 1.26t-.53 1.06q-.35.47-.95.73-.59.27-1.45.27m3.24-.14-.26-2.43v-1.43H35.6v-1.52h4.19V17z"/>
</svg>
`;
function GuardDetectLogo({ size, appearance = 'brand', label = 'Guard Detect', testId }) {
    return /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _logoWrapper.LogoWrapper), {
        svg: svg,
        label: label,
        appearance: appearance,
        size: size,
        testId: testId
    });
}

},{"react":"ltHCL","../../../utils/logo-wrapper":"aSXlT","@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"fWC0u":[function(require,module,exports,__globalThis) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::9271fe2e99ed03180fc112676167f42e>>
 * @codegenCommand yarn workspace @atlaskit/logo generate:components
 */ var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
/**
 * __GuardIcon__
 *
 * A temporary component to represent the icon for Guard.
 * @deprecated This component has been replaced by the component `GuardIcon` in `@atlaskit/logo`.
 * Please migrate any usages of this temporary component, using the prop `shouldUseNewLogoDesign` where necessary
 * to enable the new design by default.
 *
 */ parcelHelpers.export(exports, "GuardIcon", ()=>GuardIcon);
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _iconWrapper = require("../../../utils/icon-wrapper");
// `height` is set to 100% to allow the SVG to scale with the parent element
const svg = `<svg height="100%" viewBox="0 0 24 24">
    <path fill="var(--tile-color,#dddee1)" d="M0 6a6 6 0 0 1 6-6h12a6 6 0 0 1 6 6v12a6 6 0 0 1-6 6H6a6 6 0 0 1-6-6z"/>
    <path fill="var(--icon-color, #101214)" d="M5.49 10.87h13.02c.374 0 .574-.2.574-.574V5.907c0-.374-.2-.574-.574-.574h-2.744c-.374 0-.573.2-.573.574v2.22h-1.247v-2.22c0-.374-.2-.574-.574-.574h-2.743c-.374 0-.574.2-.574.574v2.22H8.807v-2.22c0-.374-.2-.574-.573-.574H5.49c-.374 0-.573.2-.573.574v4.39c0 .373.2.573.573.573m.225 3.84a8.7 8.7 0 0 1-.5-2.493c-.024-.324.126-.499.475-.499h12.62c.349 0 .498.15.498.449a8.2 8.2 0 0 1-.523 2.544c-.15.399-.375.573-.799.573H6.513c-.424 0-.649-.174-.798-.573m11.547 2.07C16.065 18.253 14.095 19.2 12 19.2s-4.116-.948-5.288-2.42c-.299-.398-.15-.648.15-.648h10.275c.3 0 .45.25.125.649"/>
</svg>
`;
function GuardIcon({ size, appearance = 'brand', label = 'Guard', testId }) {
    return /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _iconWrapper.IconWrapper), {
        svg: svg,
        label: label,
        appearance: appearance,
        size: size,
        testId: testId
    });
}

},{"react":"ltHCL","../../../utils/icon-wrapper":"4NqBa","@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"74m4J":[function(require,module,exports,__globalThis) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::db6984f13fa8a1f65e3a27814935822a>>
 * @codegenCommand yarn workspace @atlaskit/logo generate:components
 */ var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
/**
 * __GuardLogoCS__
 *
 * A temporary component to represent the logo for Guard.
 *
 */ parcelHelpers.export(exports, "GuardLogoCS", ()=>GuardLogoCS);
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _logoWrapper = require("../../../utils/logo-wrapper");
// `height` is set to 100% to allow the SVG to scale with the parent element
// The text color is set to "currentColor" to allow the SVG to inherit the color set by the parent based on the theme.
const svg = `<svg height="100%" viewBox="0 0 120 32">
    <path fill="var(--text-color, #1e1f21)" d="M108.4 17.67c0 3.68 1.47 5.52 4.2 5.52 2.36 0 4.48-1.5 4.48-4.91v-1.23c0-3.4-1.93-4.91-4.17-4.91-2.97 0-4.51 1.96-4.51 5.52m8.68 7.67v-2.76c-.98 2.02-2.82 3.07-5.18 3.07-4.08 0-6.13-3.46-6.13-7.97 0-4.32 2.15-7.97 6.44-7.97 2.24 0 3.96 1.01 4.88 3.01V3.59h2.64v21.74zm-17.8-9.04v9.05H96.7V10h2.58v2.7c.89-1.81 2.42-3.1 5.43-2.91v2.58c-3.37-.34-5.43.67-5.43 3.93m-17.86 1.37c0 3.68 1.47 5.52 4.2 5.52 2.36 0 4.48-1.5 4.48-4.91v-1.23c0-3.4-1.93-4.91-4.17-4.91-2.97 0-4.51 1.96-4.51 5.52m8.68 7.67v-2.76c-.98 2.02-2.82 3.07-5.18 3.07-4.08 0-6.13-3.46-6.13-7.97 0-4.32 2.15-7.97 6.44-7.97 2.24 0 3.96 1.01 4.88 3.01V10h2.64v15.33zm-27.42-6.34V10h2.64v9.26c0 2.76 1.1 3.99 3.62 3.99 2.45 0 4.14-1.62 4.14-4.72V10h2.64v15.33h-2.64v-2.51c-.98 1.81-2.79 2.82-4.84 2.82-3.53 0-5.55-2.42-5.55-6.65m-3.98 5.21c-1.59.95-4.54 1.44-6.81 1.44-6.93 0-10.67-4.23-10.67-10.33 0-6.56 4.26-10.46 11.44-10.46 1.6 0 3.47.18 5.24.8v2.76c-1.53-.61-3.34-.89-5.21-.89-5.98 0-8.71 2.98-8.71 7.73 0 4.66 2.76 7.76 8.56 7.76.95 0 2.27-.09 3.4-.43v-5.61H50.8v-2.64h7.91z"/>
    <path fill="var(--tile-color,#dddee1)" d="M0 8a8 8 0 0 1 8-8h16a8 8 0 0 1 8 8v16a8 8 0 0 1-8 8H8a8 8 0 0 1-8-8z"/>
    <path fill="var(--icon-color, #101214)" d="M8.188 14.644h15.623c.449 0 .688-.24.688-.688V8.688c0-.449-.24-.688-.688-.688h-3.292c-.45 0-.689.24-.689.688v2.664h-1.496V8.688c0-.449-.24-.688-.688-.688h-3.293c-.448 0-.688.24-.688.688v2.664H12.17V8.688c0-.449-.24-.688-.689-.688H8.188c-.449 0-.688.24-.688.688v5.268c0 .449.24.688.688.688m.27 4.609a10.4 10.4 0 0 1-.599-2.993c-.03-.389.15-.598.569-.598H23.57c.42 0 .599.18.599.538q-.09 1.662-.629 3.053c-.18.479-.448.688-.957.688H9.415c-.508 0-.778-.21-.957-.688m13.856 2.484c-1.436 1.766-3.8 2.903-6.314 2.903s-4.939-1.137-6.345-2.903c-.36-.479-.18-.778.18-.778h12.33c.359 0 .538.3.15.778"/>
</svg>
`;
function GuardLogoCS({ size, appearance = 'brand', label = 'Guard', testId }) {
    return /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _logoWrapper.LogoWrapper), {
        svg: svg,
        label: label,
        appearance: appearance,
        size: size,
        testId: testId
    });
}

},{"react":"ltHCL","../../../utils/logo-wrapper":"aSXlT","@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"11q6O":[function(require,module,exports,__globalThis) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::978838b36f6aa3744f039bfb1c56d79c>>
 * @codegenCommand yarn workspace @atlaskit/logo generate:components
 */ var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
/**
 * __HomeIcon__
 *
 * An internal component to represent the icon for Home.
 * Do not use this internal component directly — use `HomeIcon` from `@atlaskit/logo` instead.
 *
 */ parcelHelpers.export(exports, "HomeIcon", ()=>HomeIcon);
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _iconWrapper = require("../../../utils/icon-wrapper");
// `height` is set to 100% to allow the SVG to scale with the parent element
const svg = `<svg height="100%" viewBox="0 0 24 24">
    <path fill="var(--tile-color,#dddee1)" d="M0 6a6 6 0 0 1 6-6h12a6 6 0 0 1 6 6v12a6 6 0 0 1-6 6H6a6 6 0 0 1-6-6z"/>
    <path fill="var(--icon-color, #101214)" d="M5.875 10.688v7.437h4.375V13.75h3.5v4.375h4.375v-7.437L12 5z"/>
</svg>
`;
function HomeIcon({ size, appearance = 'brand', label = 'Home', testId }) {
    return /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _iconWrapper.IconWrapper), {
        svg: svg,
        label: label,
        appearance: appearance,
        size: size,
        testId: testId
    });
}

},{"react":"ltHCL","../../../utils/icon-wrapper":"4NqBa","@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"605fe":[function(require,module,exports,__globalThis) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::5bd026d27282a90cddcd834d02167bda>>
 * @codegenCommand yarn workspace @atlaskit/logo generate:components
 */ var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
/**
 * __HomeLogoCS__
 *
 * An internal component to represent the logo for Home.
 *
 */ parcelHelpers.export(exports, "HomeLogoCS", ()=>HomeLogoCS);
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _logoWrapper = require("../../../utils/logo-wrapper");
// `height` is set to 100% to allow the SVG to scale with the parent element
// The text color is set to "currentColor" to allow the SVG to inherit the color set by the parent based on the theme.
const svg = `<svg height="100%" viewBox="0 0 121 32">
    <path fill="var(--text-color, #1e1f21)" d="M113.57 12.09c-2.79 0-4.2 1.81-4.48 4.48h8.56c-.15-2.85-1.44-4.48-4.08-4.48m5.89 12.64c-1.26.68-3.19.92-4.75.92-5.73 0-8.25-3.31-8.25-8 0-4.63 2.58-7.94 7.24-7.94 4.72 0 6.62 3.28 6.62 7.94v1.2h-11.19c.37 2.61 2.06 4.29 5.67 4.29 1.78 0 3.28-.34 4.66-.83zM93.3 16.81v8.53h-2.64v-9.26c0-2.76-1.1-3.99-3.62-3.99-2.45 0-4.14 1.63-4.14 4.72v8.53h-2.64V10h2.64v2.52c.98-1.81 2.79-2.82 4.85-2.82 2.61 0 4.39 1.32 5.15 3.74.86-2.36 2.91-3.74 5.46-3.74 3.43 0 5.34 2.33 5.34 6.66v8.99h-2.64v-8.52c0-3.16-1.1-4.72-3.62-4.72-2.45 0-4.14 1.63-4.14 4.72m-23.33 8.81c-4.6 0-7.3-3.4-7.3-8s2.7-7.94 7.3-7.94c4.57 0 7.24 3.34 7.24 7.94s-2.67 8-7.24 8m0-13.49c-3.28 0-4.72 2.58-4.72 5.49s1.44 5.55 4.72 5.55c3.25 0 4.66-2.64 4.66-5.55s-1.41-5.49-4.66-5.49M56.41 5.19h2.76v20.15h-2.76v-8.71H45.8v8.71h-2.76V5.19h2.76v8.8h10.61z"/>
    <path fill="var(--tile-color,#dddee1)" d="M0 8a8 8 0 0 1 8-8h16a8 8 0 0 1 8 8v16a8 8 0 0 1-8 8H8a8 8 0 0 1-8-8z"/>
    <path fill="var(--icon-color, #101214)" d="M7.25 14.125V24.75h6.25V18.5h5v6.25h6.25V14.125L16 6z"/>
</svg>
`;
function HomeLogoCS({ size, appearance = 'brand', label = 'Home', testId }) {
    return /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _logoWrapper.LogoWrapper), {
        svg: svg,
        label: label,
        appearance: appearance,
        size: size,
        testId: testId
    });
}

},{"react":"ltHCL","../../../utils/logo-wrapper":"aSXlT","@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"eKhnE":[function(require,module,exports,__globalThis) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::983ad8fa518509adc011dda491e7edb4>>
 * @codegenCommand yarn workspace @atlaskit/logo generate:components
 */ var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
/**
 * __HubIcon__
 *
 * An internal component to represent the icon for Hub.
 * Do not use this internal component directly — use `HubIcon` from `@atlaskit/logo` instead.
 *
 */ parcelHelpers.export(exports, "HubIcon", ()=>HubIcon);
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _iconWrapper = require("../../../utils/icon-wrapper");
// `height` is set to 100% to allow the SVG to scale with the parent element
const svg = `<svg height="100%" viewBox="0 0 32 32">
    <g clip-path="url(#clip0_95164_16219)">
        <path fill="var(--tile-color,#dddee1)" d="M0 8a8 8 0 0 1 8-8h16a8 8 0 0 1 8 8v16a8 8 0 0 1-8 8H8a8 8 0 0 1-8-8z"/>
        <g clip-path="url(#clip1_95164_16219)">
            <path fill="var(--icon-color, #101214)" fill-rule="evenodd" d="M9 25.333V6.667h14v18.666h-5.25V21.25h-3.5v4.083zm3.5-14.583h2.333V9H12.5zm4.667 0H19.5V9h-2.333zm-2.334 4.083H12.5v-1.75h2.333zM12.5 18.916h2.333v-1.75H12.5zm7-4.083h-2.333v-1.75H19.5zm-2.333 4.083H19.5v-1.75h-2.333z" clip-rule="evenodd"/>
        </g>
    </g>
    <defs>
        <clipPath id="clip0_95164_16219">
            <path fill="var(--icon-color, white)" d="M0 0h32v32H0z"/>
        </clipPath>
        <clipPath id="clip1_95164_16219">
            <path fill="var(--icon-color, white)" d="M2 2h28v28H2z"/>
        </clipPath>
    </defs>
</svg>
`;
function HubIcon({ size, appearance = 'brand', label = 'Hub', testId }) {
    return /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _iconWrapper.IconWrapper), {
        svg: svg,
        label: label,
        appearance: appearance,
        size: size,
        testId: testId
    });
}

},{"react":"ltHCL","../../../utils/icon-wrapper":"4NqBa","@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"3oK4G":[function(require,module,exports,__globalThis) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::525e888921a2eb67ac3477c558f06bd0>>
 * @codegenCommand yarn workspace @atlaskit/logo generate:components
 */ var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
/**
 * __HubLogoCS__
 *
 * An internal component to represent the logo for Hub.
 *
 */ parcelHelpers.export(exports, "HubLogoCS", ()=>HubLogoCS);
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _logoWrapper = require("../../../utils/logo-wrapper");
// `height` is set to 100% to allow the SVG to scale with the parent element
// The text color is set to "currentColor" to allow the SVG to inherit the color set by the parent based on the theme.
const svg = `<svg height="100%" viewBox="0 0 95 32">
    <path fill="var(--text-color, #1e1f21)" d="M91.61 17.67c0-3.68-1.47-5.52-4.2-5.52-2.36 0-4.48 1.5-4.48 4.91v1.23c0 3.4 1.93 4.91 4.17 4.91 2.98 0 4.51-1.96 4.51-5.52m-3.8 7.97c-2.24 0-3.96-1.01-4.88-3v2.7h-2.64V3.59h2.64v9.17c.98-2.02 2.82-3.07 5.18-3.07 4.08 0 6.13 3.47 6.13 7.97 0 4.32-2.15 7.97-6.44 7.97m-24.52-6.64V10h2.64v9.26c0 2.76 1.1 3.99 3.62 3.99 2.45 0 4.14-1.62 4.14-4.72V10h2.64v15.33h-2.64v-2.51c-.98 1.81-2.79 2.82-4.84 2.82-3.53 0-5.55-2.42-5.55-6.65M56.4 5.19h2.76v20.15H56.4v-8.71H45.79v8.71h-2.76V5.19h2.76v8.8H56.4z"/>
    <path fill="var(--tile-color,#dddee1)" d="M0 8a8 8 0 0 1 8-8h16a8 8 0 0 1 8 8v16a8 8 0 0 1-8 8H8a8 8 0 0 1-8-8z"/>
    <path fill="var(--icon-color, #101214)" fill-rule="evenodd" d="M9 25.333V6.667h14v18.666h-5.25V21.25h-3.5v4.083zm3.5-14.583h2.333V9H12.5zm4.667 0H19.5V9h-2.333zm-2.334 4.083H12.5v-1.75h2.333zM12.5 18.916h2.333v-1.75H12.5zm7-4.083h-2.333v-1.75H19.5zm-2.333 4.083H19.5v-1.75h-2.333z" clip-rule="evenodd"/>
</svg>
`;
function HubLogoCS({ size, appearance = 'brand', label = 'Hub', testId }) {
    return /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _logoWrapper.LogoWrapper), {
        svg: svg,
        label: label,
        appearance: appearance,
        size: size,
        testId: testId
    });
}

},{"react":"ltHCL","../../../utils/logo-wrapper":"aSXlT","@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"hDPcG":[function(require,module,exports,__globalThis) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::f238f469c20433ab8ed5a1e4abeae5fe>>
 * @codegenCommand yarn workspace @atlaskit/logo generate:components
 */ var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
/**
 * __JiraCodingAgentIcon__
 *
 * An internal component to represent the icon for Jira Coding Agent.
 * Do not use this internal component directly — use `JiraCodingAgentIcon` from `@atlaskit/logo` instead.
 *
 */ parcelHelpers.export(exports, "JiraCodingAgentIcon", ()=>JiraCodingAgentIcon);
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _iconWrapper = require("../../../utils/icon-wrapper");
// `height` is set to 100% to allow the SVG to scale with the parent element
const svg = `<svg height="100%" viewBox="0 0 55 55">
    <path fill="var(--tile-color,#1868db)" d="M24.519.844a6.3 6.3 0 0 1 6.3 0l18.37 10.601a6.3 6.3 0 0 1 3.15 5.454V38.1c0 2.25-1.2 4.33-3.15 5.454l-18.37 10.601a6.3 6.3 0 0 1-6.3 0l-18.37-10.6a6.3 6.3 0 0 1-3.15-5.454V16.9c0-2.25 1.2-4.33 3.15-5.454z"/>
    <path fill="var(--icon-color, white)" d="M20.71 34.657h-2.705C13.926 34.657 11 32.16 11 28.5h14.543c.754 0 1.241.536 1.241 1.294v14.634c-3.635 0-6.074-2.944-6.074-7.05zm7.183-7.272h-2.705c-4.079 0-7.005-2.454-7.005-6.113h14.542c.754 0 1.286.491 1.286 1.25v14.634c-3.635 0-6.118-2.945-6.118-7.05zm7.227-7.228h-2.705c-4.079 0-7.005-2.498-7.005-6.157h14.543c.753 0 1.241.535 1.241 1.25v14.633c-3.636 0-6.074-2.944-6.074-7.049z"/>
</svg>
`;
function JiraCodingAgentIcon({ size, appearance = 'brand', label = 'Jira Coding Agent', testId }) {
    return /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _iconWrapper.IconWrapper), {
        svg: svg,
        label: label,
        appearance: appearance,
        size: size,
        testId: testId
    });
}

},{"react":"ltHCL","../../../utils/icon-wrapper":"4NqBa","@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"aFxdE":[function(require,module,exports,__globalThis) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::491a8713d140a4025bae404f0574bce7>>
 * @codegenCommand yarn workspace @atlaskit/logo generate:components
 */ var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
/**
 * __JiraDataCenterIcon__
 *
 * An internal component to represent the icon for Jira Data Center.
 * Do not use this internal component directly — use `JiraDataCenterIcon` from `@atlaskit/logo` instead.
 *
 */ parcelHelpers.export(exports, "JiraDataCenterIcon", ()=>JiraDataCenterIcon);
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _iconWrapper = require("../../../utils/icon-wrapper");
// `height` is set to 100% to allow the SVG to scale with the parent element
const svg = `<svg height="100%" viewBox="0 0 24 24">
    <path fill="var(--tile-color, white)" d="M6 .5h12A5.5 5.5 0 0 1 23.5 6v12a5.5 5.5 0 0 1-5.5 5.5H6A5.5 5.5 0 0 1 .5 18V6A5.5 5.5 0 0 1 6 .5"/>
    <path fill="none" stroke="var(--border-color, #dddee1)" d="M6 .5h12A5.5 5.5 0 0 1 23.5 6v12a5.5 5.5 0 0 1-5.5 5.5H6A5.5 5.5 0 0 1 .5 18V6A5.5 5.5 0 0 1 6 .5Z"/>
    <path fill="var(--icon-color, #1868db)" d="M8.974 15.523H7.62c-2.04 0-3.502-1.249-3.502-3.078h7.271c.377 0 .62.268.62.647v7.317c-1.817 0-3.036-1.472-3.036-3.525zm3.591-3.636h-1.352c-2.04 0-3.503-1.227-3.503-3.056h7.272c.376 0 .642.245.642.625v7.317c-1.817 0-3.059-1.473-3.059-3.525zm3.614-3.614h-1.353c-2.04 0-3.502-1.249-3.502-3.078h7.271c.377 0 .62.268.62.624v7.318c-1.817 0-3.036-1.473-3.036-3.525z"/>
</svg>
`;
function JiraDataCenterIcon({ size, appearance = 'brand', label = 'Jira Data Center', testId }) {
    return /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _iconWrapper.IconWrapper), {
        svg: svg,
        label: label,
        type: "data-center",
        appearance: appearance,
        size: size,
        testId: testId
    });
}

},{"react":"ltHCL","../../../utils/icon-wrapper":"4NqBa","@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"fteNs":[function(require,module,exports,__globalThis) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::97902fae9a5e66613a7ad8ae8ea2e75d>>
 * @codegenCommand yarn workspace @atlaskit/logo generate:components
 */ var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
/**
 * __JiraDataCenterLogoCS__
 *
 * An internal component to represent the logo for Jira Data Center.
 *
 */ parcelHelpers.export(exports, "JiraDataCenterLogoCS", ()=>JiraDataCenterLogoCS);
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _logoWrapper = require("../../../utils/logo-wrapper");
// `height` is set to 100% to allow the SVG to scale with the parent element
// The text color is set to "currentColor" to allow the SVG to inherit the color set by the parent based on the theme.
const svg = `<svg height="100%" viewBox="0 0 83 32">
    <path fill="var(--text-color, #1e1f21)" d="M71.02 17.67c0 3.68 1.47 5.52 4.2 5.52 2.36 0 4.48-1.5 4.48-4.91v-1.23c0-3.4-1.93-4.91-4.17-4.91-2.98 0-4.51 1.96-4.51 5.52m8.68 7.67v-2.76c-.98 2.02-2.82 3.07-5.18 3.07-4.08 0-6.13-3.47-6.13-7.97 0-4.32 2.15-7.97 6.44-7.97 2.24 0 3.96 1.01 4.88 3.01V10h2.64v15.33zm-17.79-9.04v9.05h-2.58V10h2.58v2.7c.89-1.81 2.42-3.1 5.43-2.91v2.58c-3.37-.34-5.43.67-5.43 3.93M52.22 5.95c0-1.17.77-1.84 1.84-1.84s1.84.67 1.84 1.84-.77 1.84-1.84 1.84-1.84-.67-1.84-1.84m.49 19.38V10h2.64v15.33zm-6.42-5.95V5.19h2.76V19.2c0 3.71-1.63 6.26-5.43 6.26-1.44 0-2.55-.24-3.31-.52v-2.67c.83.34 1.84.52 2.85.52 2.33 0 3.13-1.41 3.13-3.4"/>
    <path fill="var(--tile-color, white)" d="M8 .667h16A7.333 7.333 0 0 1 31.333 8v16A7.333 7.333 0 0 1 24 31.333H8A7.333 7.333 0 0 1 .667 24V8A7.333 7.333 0 0 1 8 .667"/>
    <path fill="none" stroke="var(--border-color, #dddee1)" stroke-width="1.333" d="M8 .667h16A7.333 7.333 0 0 1 31.333 8v16A7.333 7.333 0 0 1 24 31.333H8A7.333 7.333 0 0 1 .667 24V8A7.333 7.333 0 0 1 8 .667Z"/>
    <path fill="var(--icon-color, #1868db)" d="M11.965 20.699h-1.803c-2.72 0-4.67-1.666-4.67-4.105h9.695c.502 0 .827.357.827.863v9.756c-2.424 0-4.05-1.963-4.05-4.7zm4.788-4.848H14.95c-2.72 0-4.67-1.636-4.67-4.075h9.695c.502 0 .857.327.857.832v9.756c-2.424 0-4.079-1.963-4.079-4.699zm4.818-4.819h-1.803c-2.72 0-4.67-1.666-4.67-4.105h9.695c.503 0 .828.357.828.833v9.756c-2.424 0-4.05-1.963-4.05-4.7z"/>
</svg>
`;
function JiraDataCenterLogoCS({ size, appearance = 'brand', label = 'Jira Data Center', testId }) {
    return /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _logoWrapper.LogoWrapper), {
        svg: svg,
        label: label,
        type: "data-center",
        appearance: appearance,
        size: size,
        testId: testId
    });
}

},{"react":"ltHCL","../../../utils/logo-wrapper":"aSXlT","@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"9nYF6":[function(require,module,exports,__globalThis) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::3b3ec3c590ed89c431e0f979daa3e25e>>
 * @codegenCommand yarn workspace @atlaskit/logo generate:components
 */ var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
/**
 * __JiraProductDiscoveryIcon__
 *
 * A temporary component to represent the icon for Jira Product Discovery.
 * @deprecated This component has been replaced by the component `JiraProductDiscoveryIcon` in `@atlaskit/logo`.
 * Please migrate any usages of this temporary component, using the prop `shouldUseNewLogoDesign` where necessary
 * to enable the new design by default.
 *
 */ parcelHelpers.export(exports, "JiraProductDiscoveryIcon", ()=>JiraProductDiscoveryIcon);
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _iconWrapper = require("../../../utils/icon-wrapper");
// `height` is set to 100% to allow the SVG to scale with the parent element
const svg = `<svg height="100%" viewBox="0 0 24 24">
    <path fill="var(--tile-color,#c97cf4)" d="M0 6a6 6 0 0 1 6-6h12a6 6 0 0 1 6 6v12a6 6 0 0 1-6 6H6a6 6 0 0 1-6-6z"/>
    <path fill="var(--icon-color, #101214)" d="M13.467 4.882a9.47 9.47 0 0 0 5.422 0c.159-.035.265.07.23.229-.513 1.85-.513 3.558 0 5.408.035.14-.072.264-.23.211a10.1 10.1 0 0 0-5.422 0c-.142.053-.265-.07-.212-.211.476-1.85.476-3.559 0-5.408-.053-.159.07-.264.212-.23m.724 6.553v.3c0 1.39-.972 2.412-2.173 2.412a2.153 2.153 0 0 1-2.154-2.166c0-1.198.971-2.15 2.331-2.15h.353V5.62c-.176-.017-.353-.017-.53-.017a6.387 6.387 0 0 0-6.393 6.394 6.37 6.37 0 0 0 6.393 6.377c3.533 0 6.411-2.854 6.411-6.377v-.563z"/>
</svg>
`;
const customThemeSvg = `<svg height="100%" viewBox="0 0 24 24">
    <path fill="var(--themed-icon-color, currentcolor)" d="M18 0a6 6 0 0 1 6 6v12a6 6 0 0 1-6 6H6a6 6 0 0 1-6-6V6a6 6 0 0 1 6-6zm-5.981 5.604a6.387 6.387 0 0 0-6.394 6.394 6.373 6.373 0 0 0 6.394 6.377c3.532 0 6.41-2.854 6.41-6.377v-.563H14.19v.3c0 1.39-.97 2.412-2.171 2.413a2.154 2.154 0 0 1-2.156-2.168c0-1.197.973-2.148 2.332-2.148h.353v-4.21c-.177-.018-.353-.018-.53-.018m6.87-.722a9.47 9.47 0 0 1-5.422 0c-.141-.035-.265.07-.212.228.477 1.85.477 3.559 0 5.409-.053.14.07.264.212.211a10.1 10.1 0 0 1 5.422 0c.159.053.265-.07.23-.211-.513-1.85-.513-3.56 0-5.409.034-.158-.072-.263-.23-.228"/>
</svg>
`;
function JiraProductDiscoveryIcon({ iconColor, size, appearance = 'brand', label = 'Jira Product Discovery', testId }) {
    return /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _iconWrapper.IconWrapper), {
        svg: svg,
        customThemeSvg: customThemeSvg,
        iconColor: iconColor,
        label: label,
        appearance: appearance,
        size: size,
        testId: testId
    });
}

},{"react":"ltHCL","../../../utils/icon-wrapper":"4NqBa","@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"69nzR":[function(require,module,exports,__globalThis) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::c8e2d27dec964efc37c6ed5782c3fe57>>
 * @codegenCommand yarn workspace @atlaskit/logo generate:components
 */ var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
/**
 * __JiraProductDiscoveryLogoCS__
 *
 * A temporary component to represent the logo for Jira Product Discovery.
 *
 */ parcelHelpers.export(exports, "JiraProductDiscoveryLogoCS", ()=>JiraProductDiscoveryLogoCS);
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _logoWrapper = require("../../../utils/logo-wrapper");
// `height` is set to 100% to allow the SVG to scale with the parent element
// The text color is set to "currentColor" to allow the SVG to inherit the color set by the parent based on the theme.
const svg = `<svg height="100%" viewBox="0 0 327 32">
    <path fill="var(--text-color, #1e1f21)" d="M317.88 24.35h-1.72L310.62 10h2.82l4.91 13.13 4.9-13.13h2.82l-5.8 14.84c-1.72 4.39-2.7 6.65-6.59 6.65-1.32 0-2.06-.12-2.82-.43v-2.27c.89.28 1.9.37 2.67.37 2.15 0 3.1-1.47 4.36-4.82m-13.25-8.05v9.05h-2.58V10h2.58v2.7c.89-1.81 2.42-3.1 5.43-2.91v2.58c-3.37-.34-5.43.67-5.43 3.93m-12.47-4.21c-2.79 0-4.2 1.81-4.48 4.48h8.56c-.15-2.85-1.44-4.48-4.08-4.48m5.89 12.64c-1.26.68-3.19.92-4.75.92-5.73 0-8.25-3.31-8.25-8 0-4.63 2.58-7.94 7.24-7.94 4.72 0 6.62 3.28 6.62 7.94v1.2h-11.19c.37 2.61 2.06 4.29 5.67 4.29 1.78 0 3.28-.34 4.66-.83zm-19.72.6h-3.53L268.87 10h2.76l4.97 13.1 4.93-13.1h2.76zm-17.46.31c-4.6 0-7.3-3.4-7.3-8s2.7-7.94 7.3-7.94c4.57 0 7.24 3.34 7.24 7.94s-2.67 8-7.24 8m0-13.49c-3.28 0-4.72 2.58-4.72 5.49s1.44 5.55 4.72 5.55c3.25 0 4.66-2.64 4.66-5.55s-1.41-5.49-4.66-5.49m-9.39 10.42v2.36c-.92.49-2.33.71-3.74.71-5.46 0-8-3.31-8-8 0-4.63 2.55-7.94 8-7.94 1.38 0 2.45.18 3.65.74v2.45c-.98-.46-2.02-.74-3.46-.74-3.99 0-5.61 2.51-5.61 5.49s1.66 5.49 5.67 5.49c1.56 0 2.55-.21 3.5-.55m-13.88-1.42c0 2.55-1.66 4.48-5.76 4.48-2.3 0-4.17-.52-5.34-1.13v-2.79c1.32.77 3.53 1.5 5.46 1.5 2.02 0 3.07-.83 3.07-2.02 0-1.16-.89-1.84-3.8-2.54-3.4-.83-4.85-2.15-4.85-4.66 0-2.67 2.06-4.29 5.55-4.29 1.99 0 3.8.49 4.94 1.1v2.73c-1.84-.92-3.34-1.41-4.97-1.41-1.93 0-2.97.68-2.97 1.87 0 1.07.74 1.75 3.56 2.42 3.4.83 5.12 2.09 5.12 4.75m-17.7-15.22c0-1.16.77-1.84 1.84-1.84s1.84.68 1.84 1.84-.77 1.84-1.84 1.84-1.84-.67-1.84-1.84m.49 19.38V10h2.64v15.33zM207.68 7.82h-4.54v14.87h4.69c4.6 0 6.9-2.42 6.9-7.3 0-4.91-2.18-7.57-7.05-7.57m-7.3 17.51V5.19h7.42c6.53 0 9.69 4.08 9.69 10.12 0 6.1-3.19 10.03-9.69 10.03zm-13.41-4.75c0 1.35.8 2.27 2.42 2.27.61 0 1.2-.12 1.66-.21v2.55c-.46.12-.98.25-1.78.25-3.28 0-4.88-1.93-4.88-4.78v-8.19h-2.48V10h2.48V6.75h2.58V10h4.08v2.45h-4.08zm-6.66 1.99v2.36c-.92.49-2.33.71-3.74.71-5.46 0-8-3.31-8-8 0-4.63 2.55-7.94 8-7.94 1.38 0 2.45.18 3.65.74v2.45c-.98-.46-2.02-.74-3.46-.74-3.99 0-5.61 2.51-5.61 5.49s1.66 5.49 5.67 5.49c1.56 0 2.55-.21 3.5-.55m-27.86-3.59V10h2.64v9.26c0 2.76 1.1 3.99 3.62 3.99 2.45 0 4.14-1.62 4.14-4.72V10h2.64v15.33h-2.64v-2.51c-.98 1.81-2.79 2.82-4.84 2.82-3.53 0-5.55-2.42-5.55-6.65m-14.99-1.32c0 3.68 1.47 5.52 4.2 5.52 2.36 0 4.48-1.5 4.48-4.91v-1.23c0-3.4-1.93-4.91-4.17-4.91-2.97 0-4.51 1.96-4.51 5.52m8.68 7.67v-2.76c-.98 2.02-2.82 3.07-5.18 3.07-4.08 0-6.13-3.46-6.13-7.97 0-4.32 2.15-7.97 6.44-7.97 2.24 0 3.96 1.01 4.88 3.01V3.59h2.64v21.74zm-20.7.31c-4.6 0-7.3-3.4-7.3-8s2.7-7.94 7.3-7.94c4.57 0 7.24 3.34 7.24 7.94s-2.67 8-7.24 8m0-13.49c-3.28 0-4.72 2.58-4.72 5.49s1.44 5.55 4.72 5.55c3.25 0 4.66-2.64 4.66-5.55s-1.41-5.49-4.66-5.49m-13.78 4.14v9.05h-2.58V10h2.58v2.7c.89-1.81 2.42-3.1 5.43-2.91v2.58c-3.37-.34-5.43.67-5.43 3.93m-5-4.4c0 4.39-2.45 6.84-7.48 6.84h-4.02v6.59h-2.76V5.19h6.78c5.03 0 7.48 2.58 7.48 6.72m-7.79 4.2c3.56.12 4.94-1.56 4.94-4.14 0-2.45-1.38-4.14-4.94-4.14h-3.71v8.28zm-27.87 1.56c0 3.68 1.47 5.52 4.2 5.52 2.36 0 4.48-1.5 4.48-4.91v-1.23c0-3.4-1.93-4.91-4.17-4.91-2.98 0-4.51 1.96-4.51 5.52m8.68 7.67v-2.76c-.98 2.02-2.82 3.07-5.18 3.07-4.08 0-6.13-3.46-6.13-7.97 0-4.32 2.15-7.97 6.44-7.97 2.24 0 3.96 1.01 4.88 3.01V10h2.64v15.33zm-17.79-9.04v9.05h-2.58V10h2.58v2.7c.89-1.81 2.42-3.1 5.43-2.91v2.58c-3.37-.34-5.43.67-5.43 3.93M52.22 5.95c0-1.16.77-1.84 1.84-1.84s1.84.68 1.84 1.84-.77 1.84-1.84 1.84-1.84-.67-1.84-1.84m.49 19.38V10h2.64v15.33zm-6.42-5.95V5.19h2.76V19.2c0 3.71-1.63 6.26-5.43 6.26-1.44 0-2.55-.24-3.31-.52v-2.67c.83.34 1.84.52 2.85.52 2.33 0 3.13-1.41 3.13-3.4"/>
    <path fill="var(--tile-color,#c97cf4)" d="M0 8a8 8 0 0 1 8-8h16a8 8 0 0 1 8 8v16a8 8 0 0 1-8 8H8a8 8 0 0 1-8-8z"/>
    <path fill="var(--icon-color, #101214)" d="M17.448 6.967c2.544.746 5.113.746 7.656 0 .225-.05.375.1.325.323-.724 2.612-.724 5.025 0 7.637.05.199-.1.373-.325.298a14.3 14.3 0 0 0-7.656 0c-.2.075-.374-.1-.3-.298.674-2.612.674-5.025 0-7.637-.074-.223.1-.373.3-.323m1.023 9.253v.423c0 1.965-1.372 3.408-3.068 3.408a3.04 3.04 0 0 1-3.043-3.06c0-1.691 1.372-3.034 3.292-3.034h.5V8.012c-.25-.025-.5-.025-.749-.025a9.02 9.02 0 0 0-9.028 9.03c0 4.999 4.04 9.004 9.028 9.004s9.053-4.03 9.053-9.005v-.796z"/>
</svg>
`;
function JiraProductDiscoveryLogoCS({ size, appearance = 'brand', label = 'Jira Product Discovery', testId }) {
    return /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _logoWrapper.LogoWrapper), {
        svg: svg,
        label: label,
        appearance: appearance,
        size: size,
        testId: testId
    });
}

},{"react":"ltHCL","../../../utils/logo-wrapper":"aSXlT","@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"bYJlc":[function(require,module,exports,__globalThis) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::e66626867983712448eb161ec2993046>>
 * @codegenCommand yarn workspace @atlaskit/logo generate:components
 */ var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
/**
 * __JiraServiceManagementDataCenterIcon__
 *
 * An internal component to represent the icon for Jira Service Management Data Center.
 * Do not use this internal component directly — use `JiraServiceManagementDataCenterIcon` from `@atlaskit/logo` instead.
 *
 */ parcelHelpers.export(exports, "JiraServiceManagementDataCenterIcon", ()=>JiraServiceManagementDataCenterIcon);
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _iconWrapper = require("../../../utils/icon-wrapper");
// `height` is set to 100% to allow the SVG to scale with the parent element
const svg = `<svg height="100%" viewBox="0 0 25 24">
    <path fill="var(--tile-color, white)" d="M6.417.5h12a5.5 5.5 0 0 1 5.5 5.5v12a5.5 5.5 0 0 1-5.5 5.5h-12a5.5 5.5 0 0 1-5.5-5.5V6a5.5 5.5 0 0 1 5.5-5.5"/>
    <path fill="none" stroke="var(--border-color, #dddee1)" d="M6.417.5h12a5.5 5.5 0 0 1 5.5 5.5v12a5.5 5.5 0 0 1-5.5 5.5h-12a5.5 5.5 0 0 1-5.5-5.5V6a5.5 5.5 0 0 1 5.5-5.5Z"/>
    <path fill="var(--icon-color, #1868db)" d="M14.117 10.203h4.464c.67 0 .899.637.49 1.144l-6.98 8.616c-2.257-1.798-2.044-4.643-.393-6.72zm-3.45 3.433H6.205c-.67 0-.899-.638-.49-1.144l6.981-8.617c2.256 1.799 2.011 4.61.376 6.704z"/>
</svg>
`;
function JiraServiceManagementDataCenterIcon({ size, appearance = 'brand', label = 'Jira Service Management Data Center', testId }) {
    return /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _iconWrapper.IconWrapper), {
        svg: svg,
        label: label,
        type: "data-center",
        appearance: appearance,
        size: size,
        testId: testId
    });
}

},{"react":"ltHCL","../../../utils/icon-wrapper":"4NqBa","@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"b1EDv":[function(require,module,exports,__globalThis) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::90317e51e9a9185b7a39157502e3ebed>>
 * @codegenCommand yarn workspace @atlaskit/logo generate:components
 */ var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
/**
 * __JiraServiceManagementDataCenterLogoCS__
 *
 * An internal component to represent the logo for Jira Service Management Data Center.
 *
 */ parcelHelpers.export(exports, "JiraServiceManagementDataCenterLogoCS", ()=>JiraServiceManagementDataCenterLogoCS);
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _logoWrapper = require("../../../utils/logo-wrapper");
// `height` is set to 100% to allow the SVG to scale with the parent element
// The text color is set to "currentColor" to allow the SVG to inherit the color set by the parent based on the theme.
const svg = `<svg height="100%" viewBox="0 0 372 32">
    <path fill="var(--text-color, #1e1f21)" d="M367.07 20.58c0 1.35.8 2.27 2.42 2.27.61 0 1.2-.12 1.66-.21v2.55c-.46.12-.98.25-1.78.25-3.28 0-4.88-1.93-4.88-4.78v-8.19h-2.48V10h2.48V6.75h2.58V10h4.08v2.45h-4.08zm-7.32-4.23v8.99h-2.64v-9.26c0-2.76-1.1-3.99-3.62-3.99-2.45 0-4.14 1.63-4.14 4.72v8.53h-2.64V10h2.64v2.52c.98-1.81 2.79-2.82 4.85-2.82 3.53 0 5.55 2.42 5.55 6.66m-22.92-4.27c-2.79 0-4.2 1.81-4.48 4.48h8.56c-.15-2.85-1.44-4.48-4.08-4.48m5.89 12.64c-1.26.68-3.19.92-4.75.92-5.73 0-8.25-3.31-8.25-8 0-4.63 2.58-7.94 7.24-7.94 4.72 0 6.62 3.28 6.62 7.94v1.2h-11.19c.37 2.61 2.06 4.29 5.67 4.29 1.78 0 3.28-.34 4.66-.83zm-26.16-7.92v8.53h-2.64v-9.26c0-2.76-1.1-3.99-3.62-3.99-2.45 0-4.14 1.63-4.14 4.72v8.53h-2.64V10h2.64v2.52c.98-1.81 2.79-2.82 4.85-2.82 2.61 0 4.39 1.32 5.15 3.74.86-2.36 2.91-3.74 5.46-3.74 3.43 0 5.34 2.33 5.34 6.66v8.99h-2.64v-8.52c0-3.16-1.1-4.72-3.62-4.72-2.45 0-4.14 1.63-4.14 4.72m-22.92-4.74c-2.79 0-4.2 1.81-4.48 4.48h8.56c-.15-2.85-1.44-4.48-4.08-4.48m5.89 12.64c-1.26.68-3.19.92-4.75.92-5.73 0-8.25-3.31-8.25-8 0-4.63 2.58-7.94 7.24-7.94 4.72 0 6.62 3.28 6.62 7.94v1.2H289.2c.37 2.61 2.06 4.29 5.67 4.29 1.78 0 3.28-.34 4.66-.83zm-18.64-.62v-1.53c-.98 2.02-2.82 3.07-5.18 3.07-4.05 0-6.07-3.46-6.07-7.97 0-4.32 2.12-7.97 6.38-7.97 2.24 0 3.96 1.01 4.88 3.01V10h2.58v13.95c0 4.51-2.12 7.54-7.6 7.54-2.58 0-3.99-.34-5.46-.83v-2.58c1.69.55 3.44.92 5.34.92 3.83 0 5.15-2.05 5.15-4.91m-8.68-6.44c0 3.68 1.47 5.52 4.2 5.52 2.36 0 4.48-1.5 4.48-4.91v-1.23c0-3.4-1.93-4.91-4.17-4.91-2.97 0-4.51 1.96-4.51 5.52m-16.97.03c0 3.68 1.47 5.52 4.2 5.52 2.36 0 4.48-1.5 4.48-4.91v-1.23c0-3.4-1.93-4.91-4.17-4.91-2.97 0-4.51 1.96-4.51 5.52m8.68 7.67v-2.76c-.98 2.02-2.82 3.07-5.18 3.07-4.08 0-6.13-3.46-6.13-7.97 0-4.32 2.15-7.97 6.44-7.97 2.24 0 3.96 1.01 4.88 3.01V10h2.64v15.33zm-14.07-8.98v8.99h-2.64v-9.26c0-2.76-1.1-3.99-3.62-3.99-2.45 0-4.14 1.63-4.14 4.72v8.53h-2.64V10h2.64v2.52c.98-1.81 2.79-2.82 4.85-2.82 3.53 0 5.55 2.42 5.55 6.66m-28.33 1.31c0 3.68 1.47 5.52 4.2 5.52 2.36 0 4.48-1.5 4.48-4.91v-1.23c0-3.4-1.93-4.91-4.17-4.91-2.97 0-4.51 1.96-4.51 5.52m8.68 7.67v-2.76c-.98 2.02-2.82 3.07-5.18 3.07-4.08 0-6.13-3.46-6.13-7.97 0-4.32 2.15-7.97 6.44-7.97 2.24 0 3.96 1.01 4.88 3.01V10h2.64v15.33zm-31.44-11.01-2.76-7.48v18.49h-2.76V5.19h4.78l4.57 11.56 1.87 5.55 1.87-5.55 4.6-11.56h4.45v20.15h-2.76V7.06l-2.36 7.27-4.45 11.01h-2.67zm-21.52-2.23c-2.79 0-4.2 1.81-4.48 4.48h8.56c-.15-2.85-1.44-4.48-4.08-4.48m5.89 12.64c-1.26.68-3.19.92-4.75.92-5.73 0-8.25-3.31-8.25-8 0-4.63 2.58-7.94 7.24-7.94 4.72 0 6.62 3.28 6.62 7.94v1.2h-11.19c.37 2.61 2.05 4.29 5.67 4.29 1.78 0 3.28-.34 4.66-.83zm-15.09-2.16v2.36c-.92.49-2.33.71-3.74.71-5.46 0-8-3.31-8-8 0-4.63 2.55-7.94 8-7.94 1.38 0 2.45.18 3.65.74v2.45c-.98-.46-2.02-.74-3.46-.74-3.99 0-5.61 2.51-5.61 5.49s1.66 5.49 5.67 5.49c1.56 0 2.55-.21 3.5-.55M150.12 5.95c0-1.16.77-1.84 1.84-1.84s1.84.68 1.84 1.84-.77 1.84-1.84 1.84-1.84-.67-1.84-1.84m.49 19.38V10h2.64v15.33zm-8.23 0h-3.53L132.91 10h2.76l4.97 13.1 4.93-13.1h2.76zm-15.45-9.04v9.05h-2.58V10h2.58v2.7c.89-1.81 2.42-3.1 5.43-2.91v2.58c-3.37-.34-5.43.68-5.43 3.93m-12.47-4.21c-2.79 0-4.2 1.81-4.48 4.48h8.56c-.15-2.85-1.44-4.48-4.08-4.48m5.89 12.64c-1.26.68-3.19.92-4.75.92-5.73 0-8.25-3.31-8.25-8 0-4.63 2.58-7.94 7.24-7.94 4.72 0 6.62 3.28 6.62 7.94v1.2h-11.19c.37 2.61 2.06 4.29 5.67 4.29 1.78 0 3.28-.34 4.66-.83zm-15.33-4.95c0 3.5-2.08 5.86-7.08 5.86-3.89 0-5.7-.77-7.27-1.56v-2.82c1.87.98 4.75 1.69 7.42 1.69 3.04 0 4.17-1.2 4.17-2.97s-1.1-2.73-4.94-3.65c-4.54-1.1-6.56-2.67-6.56-5.98 0-3.13 2.39-5.46 7.08-5.46 2.91 0 4.78.71 6.16 1.47v2.76c-2.02-1.17-4.2-1.53-6.29-1.53-2.64 0-4.2.92-4.2 2.76 0 1.66 1.29 2.48 4.84 3.37 4.26 1.07 6.66 2.45 6.66 6.07m-33.99-2.12c0 3.68 1.47 5.52 4.2 5.52 2.36 0 4.48-1.5 4.48-4.91v-1.23c0-3.4-1.93-4.91-4.17-4.91-2.97 0-4.51 1.96-4.51 5.52m8.68 7.67v-2.76c-.98 2.02-2.82 3.07-5.18 3.07-4.08 0-6.13-3.46-6.13-7.97 0-4.32 2.15-7.97 6.44-7.97 2.24 0 3.96 1.01 4.88 3.01V10h2.64v15.33zm-17.79-9.04v9.05h-2.58V10h2.58v2.7c.89-1.81 2.42-3.1 5.43-2.91v2.58c-3.37-.34-5.43.68-5.43 3.93M52.22 5.95c0-1.16.77-1.84 1.84-1.84s1.84.68 1.84 1.84-.77 1.84-1.84 1.84-1.84-.67-1.84-1.84m.49 19.38V10h2.64v15.33zm-6.42-5.95V5.19h2.76V19.2c0 3.71-1.63 6.26-5.43 6.26-1.44 0-2.55-.24-3.31-.52v-2.67c.83.34 1.84.52 2.85.52 2.33 0 3.13-1.41 3.13-3.4"/>
    <path fill="var(--tile-color, white)" d="M8 .667h16A7.333 7.333 0 0 1 31.333 8v16A7.333 7.333 0 0 1 24 31.333H8A7.333 7.333 0 0 1 .667 24V8A7.333 7.333 0 0 1 8 .667"/>
    <path fill="none" stroke="var(--border-color, #dddee1)" stroke-width="1.333" d="M8 .667h16A7.333 7.333 0 0 1 31.333 8v16A7.333 7.333 0 0 1 24 31.333H8A7.333 7.333 0 0 1 .667 24V8A7.333 7.333 0 0 1 8 .667Z"/>
    <path fill="var(--icon-color, #1868db)" d="M18.268 13.604h5.95c.895 0 1.2.85.655 1.526l-9.308 11.487c-3.008-2.397-2.725-6.19-.524-8.959zm-4.6 4.577h-5.95c-.895 0-1.2-.85-.655-1.526l9.308-11.488c3.009 2.398 2.682 6.148.502 8.938z"/>
</svg>
`;
function JiraServiceManagementDataCenterLogoCS({ size, appearance = 'brand', label = 'Jira Service Management Data Center', testId }) {
    return /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _logoWrapper.LogoWrapper), {
        svg: svg,
        label: label,
        type: "data-center",
        appearance: appearance,
        size: size,
        testId: testId
    });
}

},{"react":"ltHCL","../../../utils/logo-wrapper":"aSXlT","@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"aMcsj":[function(require,module,exports,__globalThis) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::cedb5d68059644a06a093aa74d8e3cc5>>
 * @codegenCommand yarn workspace @atlaskit/logo generate:components
 */ var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
/**
 * __JiraServiceManagementIcon__
 *
 * A temporary component to represent the icon for Jira Service Management.
 * @deprecated This component has been replaced by the component `JiraServiceManagementIcon` in `@atlaskit/logo`.
 * Please migrate any usages of this temporary component, using the prop `shouldUseNewLogoDesign` where necessary
 * to enable the new design by default.
 *
 */ parcelHelpers.export(exports, "JiraServiceManagementIcon", ()=>JiraServiceManagementIcon);
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _iconWrapper = require("../../../utils/icon-wrapper");
// `height` is set to 100% to allow the SVG to scale with the parent element
const svg = `<svg height="100%" viewBox="0 0 24 24">
    <path fill="var(--tile-color,#ffc716)" d="M0 6a6 6 0 0 1 6-6h12a6 6 0 0 1 6 6v12a6 6 0 0 1-6 6H6a6 6 0 0 1-6-6z"/>
    <path fill="var(--icon-color, #101214)" d="M13.744 10.156h4.578c.688 0 .922.654.503 1.174l-7.16 8.837c-2.314-1.845-2.096-4.763-.402-6.892zm-3.538 3.521H5.63c-.688 0-.923-.654-.504-1.173l7.16-8.837c2.315 1.844 2.063 4.728.386 6.875z"/>
</svg>
`;
const customThemeSvg = `<svg height="100%" viewBox="0 0 24 24">
    <path fill="var(--themed-icon-color, currentcolor)" d="M18 0a6 6 0 0 1 6 6v12a6 6 0 0 1-6 6H6a6 6 0 0 1-6-6V6a6 6 0 0 1 6-6zm-4.256 10.156-2.481 3.12c-1.694 2.129-1.912 5.047.402 6.891l7.16-8.837c.42-.52.185-1.174-.503-1.174zm-8.619 2.348c-.419.52-.183 1.174.504 1.174h4.577l2.465-3.136c1.677-2.146 1.928-5.03-.386-6.875z"/>
</svg>
`;
function JiraServiceManagementIcon({ iconColor, size, appearance = 'brand', label = 'Jira Service Management', testId }) {
    return /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _iconWrapper.IconWrapper), {
        svg: svg,
        customThemeSvg: customThemeSvg,
        iconColor: iconColor,
        label: label,
        appearance: appearance,
        size: size,
        testId: testId
    });
}

},{"react":"ltHCL","../../../utils/icon-wrapper":"4NqBa","@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"g5xzB":[function(require,module,exports,__globalThis) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::bcf1b6bc0c0712320d6fbdb868500ebb>>
 * @codegenCommand yarn workspace @atlaskit/logo generate:components
 */ var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
/**
 * __JiraServiceManagementLogoCS__
 *
 * A temporary component to represent the logo for Jira Service Management.
 *
 */ parcelHelpers.export(exports, "JiraServiceManagementLogoCS", ()=>JiraServiceManagementLogoCS);
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _logoWrapper = require("../../../utils/logo-wrapper");
// `height` is set to 100% to allow the SVG to scale with the parent element
// The text color is set to "currentColor" to allow the SVG to inherit the color set by the parent based on the theme.
const svg = `<svg height="100%" viewBox="0 0 372 32">
    <path fill="var(--text-color, #1e1f21)" d="M367.07 20.58c0 1.35.8 2.27 2.42 2.27.61 0 1.2-.12 1.66-.21v2.55a6.3 6.3 0 0 1-1.78.25c-3.28 0-4.88-1.93-4.88-4.78v-8.19h-2.48V10h2.48V6.75h2.58V10h4.08v2.45h-4.08zm-7.32-4.23v8.99h-2.64v-9.26c0-2.76-1.1-3.99-3.62-3.99-2.45 0-4.14 1.63-4.14 4.72v8.53h-2.64V10h2.64v2.52c.98-1.81 2.79-2.82 4.85-2.82 3.53 0 5.55 2.42 5.55 6.66m-22.92-4.27c-2.79 0-4.2 1.81-4.48 4.48h8.56c-.15-2.85-1.44-4.48-4.08-4.48m5.89 12.64c-1.26.68-3.19.92-4.75.92-5.73 0-8.25-3.31-8.25-8 0-4.63 2.58-7.94 7.24-7.94 4.72 0 6.62 3.28 6.62 7.94v1.2h-11.19c.37 2.61 2.06 4.29 5.67 4.29 1.78 0 3.28-.34 4.66-.83zm-26.16-7.92v8.53h-2.64v-9.26c0-2.76-1.1-3.99-3.62-3.99-2.45 0-4.14 1.63-4.14 4.72v8.53h-2.64V10h2.64v2.52c.98-1.81 2.79-2.82 4.85-2.82 2.61 0 4.39 1.32 5.15 3.74.86-2.36 2.91-3.74 5.46-3.74 3.43 0 5.34 2.33 5.34 6.66v8.99h-2.64v-8.52c0-3.16-1.1-4.72-3.62-4.72-2.45 0-4.14 1.63-4.14 4.72m-22.92-4.74c-2.79 0-4.2 1.81-4.48 4.48h8.56c-.15-2.85-1.44-4.48-4.08-4.48m5.89 12.64c-1.26.68-3.19.92-4.75.92-5.73 0-8.25-3.31-8.25-8 0-4.63 2.58-7.94 7.24-7.94 4.72 0 6.62 3.28 6.62 7.94v1.2H289.2c.37 2.61 2.06 4.29 5.67 4.29 1.78 0 3.28-.34 4.66-.83zm-18.64-.62v-1.53c-.98 2.02-2.82 3.07-5.18 3.07-4.05 0-6.07-3.46-6.07-7.97 0-4.32 2.12-7.97 6.38-7.97 2.24 0 3.96 1.01 4.88 3.01V10h2.58v13.95c0 4.51-2.12 7.54-7.6 7.54-2.58 0-3.99-.34-5.46-.83v-2.58c1.69.55 3.44.92 5.34.92 3.83 0 5.15-2.05 5.15-4.91m-8.68-6.44c0 3.68 1.47 5.52 4.2 5.52 2.36 0 4.48-1.5 4.48-4.91v-1.23c0-3.4-1.93-4.91-4.17-4.91-2.97 0-4.51 1.96-4.51 5.52m-16.97.03c0 3.68 1.47 5.52 4.2 5.52 2.36 0 4.48-1.5 4.48-4.91v-1.23c0-3.4-1.93-4.91-4.17-4.91-2.97 0-4.51 1.96-4.51 5.52m8.68 7.67v-2.76c-.98 2.02-2.82 3.07-5.18 3.07-4.08 0-6.13-3.46-6.13-7.97 0-4.32 2.15-7.97 6.44-7.97 2.24 0 3.96 1.01 4.88 3.01V10h2.64v15.33zm-14.07-8.98v8.99h-2.64v-9.26c0-2.76-1.1-3.99-3.62-3.99-2.45 0-4.14 1.63-4.14 4.72v8.53h-2.64V10h2.64v2.52c.98-1.81 2.79-2.82 4.85-2.82 3.53 0 5.55 2.42 5.55 6.66m-28.33 1.31c0 3.68 1.47 5.52 4.2 5.52 2.36 0 4.48-1.5 4.48-4.91v-1.23c0-3.4-1.93-4.91-4.17-4.91-2.97 0-4.51 1.96-4.51 5.52m8.68 7.67v-2.76c-.98 2.02-2.82 3.07-5.18 3.07-4.08 0-6.13-3.46-6.13-7.97 0-4.32 2.15-7.97 6.44-7.97 2.24 0 3.96 1.01 4.88 3.01V10h2.64v15.33zm-31.44-11.01-2.76-7.48v18.49h-2.76V5.19h4.78l4.57 11.56 1.87 5.55 1.87-5.55 4.6-11.56h4.45v20.15h-2.76V7.06l-2.36 7.27-4.45 11.01h-2.67zm-21.52-2.23c-2.79 0-4.2 1.81-4.48 4.48h8.56c-.15-2.85-1.44-4.48-4.08-4.48m5.89 12.64c-1.26.68-3.19.92-4.75.92-5.73 0-8.25-3.31-8.25-8 0-4.63 2.58-7.94 7.24-7.94 4.72 0 6.62 3.28 6.62 7.94v1.2h-11.19c.37 2.61 2.05 4.29 5.67 4.29 1.78 0 3.28-.34 4.66-.83zm-15.09-2.16v2.36c-.92.49-2.33.71-3.74.71-5.46 0-8-3.31-8-8 0-4.63 2.55-7.94 8-7.94 1.38 0 2.45.18 3.65.74v2.45c-.98-.46-2.02-.74-3.46-.74-3.99 0-5.61 2.51-5.61 5.49s1.66 5.49 5.67 5.49c1.56 0 2.55-.21 3.5-.55M150.12 5.95c0-1.17.77-1.84 1.84-1.84s1.84.67 1.84 1.84-.77 1.84-1.84 1.84-1.84-.67-1.84-1.84m.49 19.38V10h2.64v15.33zm-8.23 0h-3.53L132.91 10h2.76l4.97 13.1 4.93-13.1h2.76zm-15.45-9.04v9.05h-2.58V10h2.58v2.7c.89-1.81 2.42-3.1 5.43-2.91v2.58c-3.37-.34-5.43.67-5.43 3.93m-12.47-4.21c-2.79 0-4.2 1.81-4.48 4.48h8.56c-.15-2.85-1.44-4.48-4.08-4.48m5.89 12.64c-1.26.68-3.19.92-4.75.92-5.73 0-8.25-3.31-8.25-8 0-4.63 2.58-7.94 7.24-7.94 4.72 0 6.62 3.28 6.62 7.94v1.2h-11.19c.37 2.61 2.06 4.29 5.67 4.29 1.78 0 3.28-.34 4.66-.83zm-15.33-4.95c0 3.5-2.08 5.86-7.08 5.86-3.89 0-5.7-.77-7.27-1.56v-2.82c1.87.98 4.75 1.69 7.42 1.69 3.04 0 4.17-1.2 4.17-2.97 0-1.78-1.1-2.73-4.94-3.65-4.54-1.1-6.56-2.67-6.56-5.98 0-3.13 2.39-5.46 7.08-5.46 2.91 0 4.78.71 6.16 1.47v2.76c-2.02-1.16-4.2-1.53-6.29-1.53-2.64 0-4.2.92-4.2 2.76 0 1.66 1.29 2.48 4.84 3.37 4.26 1.07 6.66 2.45 6.66 6.07m-33.99-2.12c0 3.68 1.47 5.52 4.2 5.52 2.36 0 4.48-1.5 4.48-4.91v-1.23c0-3.4-1.93-4.91-4.17-4.91-2.98 0-4.51 1.96-4.51 5.52m8.68 7.67v-2.76c-.98 2.02-2.82 3.07-5.18 3.07-4.08 0-6.13-3.46-6.13-7.97 0-4.32 2.15-7.97 6.44-7.97 2.24 0 3.96 1.01 4.88 3.01V10h2.64v15.33zm-17.79-9.04v9.05h-2.58V10h2.58v2.7c.89-1.81 2.42-3.1 5.43-2.91v2.58c-3.37-.34-5.43.67-5.43 3.93M52.22 5.95c0-1.17.77-1.84 1.84-1.84s1.84.67 1.84 1.84-.77 1.84-1.84 1.84-1.84-.67-1.84-1.84m.49 19.38V10h2.64v15.33zm-6.42-5.95V5.19h2.76V19.2c0 3.71-1.63 6.26-5.43 6.26-1.44 0-2.55-.25-3.31-.52v-2.67c.83.34 1.84.52 2.85.52 2.33 0 3.13-1.41 3.13-3.4"/>
    <path fill="var(--tile-color,#ffc716)" d="M0 8a8 8 0 0 1 8-8h16a8 8 0 0 1 8 8v16a8 8 0 0 1-8 8H8a8 8 0 0 1-8-8z"/>
    <path fill="var(--icon-color, #101214)" d="M18.268 13.604h5.951c.894 0 1.199.85.654 1.526l-9.308 11.487c-3.008-2.397-2.725-6.19-.523-8.959zm-4.6 4.577h-5.95c-.894 0-1.2-.85-.655-1.526l9.308-11.488c3.009 2.398 2.682 6.148.502 8.938z"/>
</svg>
`;
function JiraServiceManagementLogoCS({ size, appearance = 'brand', label = 'Jira Service Management', testId }) {
    return /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _logoWrapper.LogoWrapper), {
        svg: svg,
        label: label,
        appearance: appearance,
        size: size,
        testId: testId
    });
}

},{"react":"ltHCL","../../../utils/logo-wrapper":"aSXlT","@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"6CqCR":[function(require,module,exports,__globalThis) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::b225283860ba91a6c228b8f4fa0e1d39>>
 * @codegenCommand yarn workspace @atlaskit/logo generate:components
 */ var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
/**
 * __JiraIcon__
 *
 * A temporary component to represent the icon for Jira.
 * @deprecated This component has been replaced by the component `JiraIcon` in `@atlaskit/logo`.
 * Please migrate any usages of this temporary component, using the prop `shouldUseNewLogoDesign` where necessary
 * to enable the new design by default.
 *
 */ parcelHelpers.export(exports, "JiraIcon", ()=>JiraIcon);
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _iconWrapper = require("../../../utils/icon-wrapper");
// `height` is set to 100% to allow the SVG to scale with the parent element
const svg = `<svg height="100%" viewBox="0 0 24 24">
    <path fill="var(--tile-color,#1868db)" d="M0 6a6 6 0 0 1 6-6h12a6 6 0 0 1 6 6v12a6 6 0 0 1-6 6H6a6 6 0 0 1-6-6z"/>
    <path fill="var(--icon-color, white)" d="M9.051 15.434H7.734c-1.988 0-3.413-1.218-3.413-3h7.085c.367 0 .605.26.605.63v7.13c-1.772 0-2.96-1.435-2.96-3.434zm3.5-3.543h-1.318c-1.987 0-3.413-1.196-3.413-2.978h7.085c.367 0 .627.239.627.608v7.13c-1.772 0-2.981-1.435-2.981-3.434zm3.52-3.522h-1.317c-1.987 0-3.413-1.217-3.413-3h7.085c.367 0 .605.262.605.61v7.129c-1.771 0-2.96-1.435-2.96-3.434z"/>
</svg>
`;
const customThemeSvg = `<svg height="100%" viewBox="0 0 24 24">
    <path fill="var(--themed-icon-color, currentcolor)" d="M18 0a6 6 0 0 1 6 6v12a6 6 0 0 1-6 6H6a6 6 0 0 1-6-6V6a6 6 0 0 1 6-6zM4.321 12.434c0 1.782 1.425 3 3.412 3h1.319v1.326c0 2 1.188 3.433 2.959 3.433v-7.129c0-.369-.238-.63-.605-.63zm3.5-3.52c0 1.781 1.425 2.977 3.412 2.977h1.318v1.326c0 2 1.21 3.433 2.98 3.433V9.521c0-.369-.259-.608-.626-.608zm3.52-3.544c0 1.782 1.426 3 3.413 3h1.317v1.304c0 2 1.188 3.433 2.96 3.433V5.98c0-.348-.238-.609-.605-.609z"/>
</svg>
`;
function JiraIcon({ iconColor, size, appearance = 'brand', label = 'Jira', testId }) {
    return /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _iconWrapper.IconWrapper), {
        svg: svg,
        customThemeSvg: customThemeSvg,
        iconColor: iconColor,
        label: label,
        appearance: appearance,
        size: size,
        testId: testId
    });
}

},{"react":"ltHCL","../../../utils/icon-wrapper":"4NqBa","@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"k6PVE":[function(require,module,exports,__globalThis) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::3ed7d2f84cfdfe8bfef2a295bafed6da>>
 * @codegenCommand yarn workspace @atlaskit/logo generate:components
 */ var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
/**
 * __JiraLogoCS__
 *
 * A temporary component to represent the logo for Jira.
 *
 */ parcelHelpers.export(exports, "JiraLogoCS", ()=>JiraLogoCS);
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _logoWrapper = require("../../../utils/logo-wrapper");
// `height` is set to 100% to allow the SVG to scale with the parent element
// The text color is set to "currentColor" to allow the SVG to inherit the color set by the parent based on the theme.
const svg = `<svg height="100%" viewBox="0 0 83 32">
    <path fill="var(--text-color, #1e1f21)" d="M71.02 17.67c0 3.68 1.47 5.52 4.2 5.52 2.36 0 4.48-1.5 4.48-4.91v-1.23c0-3.4-1.93-4.91-4.17-4.91-2.98 0-4.51 1.96-4.51 5.52m8.68 7.67v-2.76c-.98 2.02-2.82 3.07-5.18 3.07-4.08 0-6.13-3.46-6.13-7.97 0-4.32 2.15-7.97 6.44-7.97 2.24 0 3.96 1.01 4.88 3.01V10h2.64v15.33zm-17.79-9.04v9.05h-2.58V10h2.58v2.7c.89-1.81 2.42-3.1 5.43-2.91v2.58c-3.37-.34-5.43.67-5.43 3.93M52.22 5.95c0-1.17.77-1.84 1.84-1.84s1.84.67 1.84 1.84-.77 1.84-1.84 1.84-1.84-.67-1.84-1.84m.49 19.38V10h2.64v15.33zm-6.42-5.95V5.19h2.76V19.2c0 3.71-1.63 6.26-5.43 6.26-1.44 0-2.55-.25-3.31-.52v-2.67c.83.34 1.84.52 2.85.52 2.33 0 3.13-1.41 3.13-3.4"/>
    <path fill="var(--tile-color,#1868db)" d="M0 8a8 8 0 0 1 8-8h16a8 8 0 0 1 8 8v16a8 8 0 0 1-8 8H8a8 8 0 0 1-8-8z"/>
    <path fill="var(--icon-color, white)" d="M11.965 20.698h-1.803c-2.72 0-4.67-1.666-4.67-4.105h9.695c.502 0 .827.357.827.863v9.756c-2.423 0-4.05-1.963-4.05-4.7zm4.788-4.848H14.95c-2.72 0-4.67-1.636-4.67-4.075h9.695c.503 0 .857.327.857.832v9.756c-2.424 0-4.079-1.963-4.079-4.7zm4.818-4.82h-1.803c-2.72 0-4.67-1.665-4.67-4.104h9.695c.503 0 .828.357.828.833v9.756c-2.424 0-4.05-1.963-4.05-4.7z"/>
</svg>
`;
function JiraLogoCS({ size, appearance = 'brand', label = 'Jira', testId }) {
    return /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _logoWrapper.LogoWrapper), {
        svg: svg,
        label: label,
        appearance: appearance,
        size: size,
        testId: testId
    });
}

},{"react":"ltHCL","../../../utils/logo-wrapper":"aSXlT","@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"hZYb0":[function(require,module,exports,__globalThis) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::9f5d94b0d7bf822b6ab4c2ad26c21970>>
 * @codegenCommand yarn workspace @atlaskit/logo generate:components
 */ var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
/**
 * __LoomAttributionLogoCS__
 *
 * A temporary component to represent the logo for Loom Attribution.
 *
 */ parcelHelpers.export(exports, "LoomAttributionLogoCS", ()=>LoomAttributionLogoCS);
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _logoWrapper = require("../../../utils/logo-wrapper");
// `height` is set to 100% to allow the SVG to scale with the parent element
// The text color is set to "currentColor" to allow the SVG to inherit the color set by the parent based on the theme.
const svg = `<svg height="100%" viewBox="0 0 100 32">
    <path fill="var(--icon-color, #101214)" d="M66.71 5.11c0 1.08.49 1.93 2.47 2.31 1.16.26 1.41.44 1.41.82 0 .39-.26.62-1.08.62-.95 0-2.08-.33-2.83-.77v1.75c.59.28 1.36.62 2.83.62 2.06 0 2.85-.92 2.85-2.26m0 .03c0-1.28-.67-1.88-2.59-2.29-1.05-.23-1.31-.46-1.31-.8 0-.41.39-.59 1.08-.59.85 0 1.67.26 2.47.62V3.5c-.56-.28-1.41-.49-2.41-.49-1.9 0-2.88.82-2.88 2.16m26.29-2.11v7.32h1.57V4.81l.64 1.46 2.21 4.11h1.95V3.06h-1.54v4.73l-.59-1.39-1.77-3.34zm-9.91 0h-1.7v7.32h1.7zM79.45 8.2c0-1.28-.67-1.88-2.59-2.29-1.05-.23-1.31-.46-1.31-.8 0-.41.39-.59 1.08-.59.85 0 1.67.26 2.47.62V3.47c-.56-.28-1.41-.49-2.41-.49-1.9 0-2.88.82-2.88 2.16 0 1.08.49 1.93 2.47 2.31 1.16.26 1.41.44 1.41.82s-.26.62-1.08.62c-.95 0-2.08-.33-2.83-.77v1.75c.59.28 1.36.62 2.83.62 2.03 0 2.85-.92 2.85-2.29M53.5 3.06v7.32h3.49l.54-1.59h-2.34V3.06zm-6.91 0v1.57h1.88v5.75h1.72V4.63h2.03V3.06zm-2.49 0h-2.24l-2.54 7.32h1.95l.36-1.23c.44.13.9.21 1.36.21s.93-.08 1.36-.21l.36 1.23h1.95c-.03 0-2.57-7.32-2.57-7.32m-1.13 4.75c-.33 0-.64-.05-.93-.13l.93-3.19.93 3.19c-.28.08-.59.13-.92.13m20.06-4.75H60.8l-2.57 7.32h1.95l.36-1.23c.44.13.9.21 1.36.21s.93-.08 1.36-.21l.36 1.23h1.95zM61.9 7.81c-.33 0-.64-.05-.92-.13l.93-3.19.93 3.19c-.28.08-.59.13-.92.13m27.32-4.75h-2.23l-2.54 7.32h1.95l.36-1.23c.44.13.9.21 1.36.21s.93-.08 1.36-.21l.36 1.23h1.95zm-1.11 4.75c-.33 0-.64-.05-.92-.13l.93-3.19.93 3.19a3.7 3.7 0 0 1-.92.13"/>
    <path fill="var(--tile-color,#1868db)" d="M0 8a8 8 0 0 1 8-8h16a8 8 0 0 1 8 8v16a8 8 0 0 1-8 8H8a8 8 0 0 1-8-8z"/>
    <path fill="var(--icon-color, white)" d="M25.375 15.31H19.99l4.664-2.693-1.024-1.775-4.664 2.693 2.692-4.664-1.775-1.025-2.692 4.664V7.125h-2.048v5.385l-2.694-4.664-1.774 1.025 2.693 4.663-4.664-2.692-1.024 1.774 4.664 2.693H6.958v2.048h5.385L7.68 20.05l1.024 1.775 4.663-2.693-2.692 4.664 1.774 1.024 2.693-4.664v5.386h2.049v-5.385l2.692 4.663 1.774-1.024-2.692-4.664 4.663 2.693 1.025-1.775-4.664-2.692h5.385zm-9.208 3.81a2.797 2.797 0 1 1 0-5.594 2.797 2.797 0 0 1 0 5.593"/>
    <path fill="var(--text-color, #1e1f21)" d="M39.32 27.74v-13.7h2.52v13.7zm24.13-9.31h2.4v1.14c.51-.91 1.7-1.4 2.72-1.4 1.27 0 2.29.55 2.76 1.55.74-1.14 1.72-1.55 2.95-1.55 1.72 0 3.37 1.04 3.37 3.54v6.04h-2.44v-5.53c0-1-.49-1.76-1.65-1.76-1.08 0-1.72.83-1.72 1.84v5.45h-2.49v-5.53c0-1-.51-1.76-1.65-1.76-1.1 0-1.74.81-1.74 1.84v5.45h-2.52zm-15.93 9.58c-2.83 0-4.89-2.1-4.89-4.93 0-2.78 2.05-4.93 4.89-4.93 2.85 0 4.89 2.17 4.89 4.93 0 2.8-2.05 4.93-4.89 4.93m0-7.58a2.65 2.65 0 0 0-2.65 2.65 2.65 2.65 0 0 0 2.65 2.65c1.46 0 2.65-1.19 2.65-2.65a2.65 2.65 0 0 0-2.65-2.65m10.26 7.58c-2.83 0-4.89-2.1-4.89-4.93 0-2.78 2.05-4.93 4.89-4.93 2.85 0 4.89 2.17 4.89 4.93 0 2.8-2.06 4.93-4.89 4.93m0-7.61a2.69 2.69 0 0 0-2.68 2.68 2.69 2.69 0 0 0 2.68 2.68 2.69 2.69 0 0 0 2.68-2.68 2.69 2.69 0 0 0-2.68-2.68"/>
</svg>
`;
function LoomAttributionLogoCS({ size, appearance = 'brand', label = 'Loom Attribution', testId }) {
    return /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _logoWrapper.LogoWrapper), {
        svg: svg,
        label: label,
        appearance: appearance,
        size: size,
        testId: testId
    });
}

},{"react":"ltHCL","../../../utils/logo-wrapper":"aSXlT","@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"6LAgU":[function(require,module,exports,__globalThis) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::26f3036375895bf30dc2c16f910588fe>>
 * @codegenCommand yarn workspace @atlaskit/logo generate:components
 */ var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
/**
 * __LoomInternalIcon__
 *
 * An internal component to represent the icon for Loom.
 * Do not use this internal component directly — use `LoomInternalIcon` from `@atlaskit/logo` instead.
 *
 */ parcelHelpers.export(exports, "LoomInternalIcon", ()=>LoomInternalIcon);
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _iconWrapper = require("../../../utils/icon-wrapper");
// `height` is set to 100% to allow the SVG to scale with the parent element
const svg = `<svg height="100%" viewBox="0 0 24 24">
    <path fill="var(--tile-color,#625df5)" d="M0 6a6 6 0 0 1 6-6h12a6 6 0 0 1 6 6v12a6 6 0 0 1-6 6H6a6 6 0 0 1-6-6z"/>
    <path fill="var(--icon-color, white)" d="M19.083 11.212h-4.142l3.588-2.071-.788-1.365-3.588 2.071 2.07-3.587-1.364-.788-2.071 3.587V4.917h-1.576v4.142L9.141 5.472l-1.365.787 2.071 3.588L6.26 7.776 5.472 9.14l3.587 2.07H4.917v1.577h4.142l-3.587 2.071.788 1.365 3.587-2.07-2.071 3.587 1.365.787 2.07-3.587v4.142h1.577V14.94l2.07 3.587 1.365-.787-2.07-3.588 3.587 2.071.788-1.365-3.587-2.07h4.142zM12 14.143a2.151 2.151 0 1 1 0-4.302 2.151 2.151 0 0 1 0 4.302"/>
</svg>
`;
function LoomInternalIcon({ size, appearance = 'brand', label = 'Loom', testId }) {
    return /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _iconWrapper.IconWrapper), {
        svg: svg,
        label: label,
        appearance: appearance,
        size: size,
        testId: testId
    });
}

},{"react":"ltHCL","../../../utils/icon-wrapper":"4NqBa","@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"eduIg":[function(require,module,exports,__globalThis) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::bf5c00a6af1a30f7d2914e27e51f1aff>>
 * @codegenCommand yarn workspace @atlaskit/logo generate:components
 */ var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
/**
 * __LoomInternalLogoCS__
 *
 * An internal component to represent the logo for Loom.
 *
 */ parcelHelpers.export(exports, "LoomInternalLogoCS", ()=>LoomInternalLogoCS);
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _logoWrapper = require("../../../utils/logo-wrapper");
// `height` is set to 100% to allow the SVG to scale with the parent element
// The text color is set to "currentColor" to allow the SVG to inherit the color set by the parent based on the theme.
const svg = `<svg height="100%" viewBox="0 0 103 32">
    <path fill="var(--tile-color,#625df5)" d="M0 8a8 8 0 0 1 8-8h16a8 8 0 0 1 8 8v16a8 8 0 0 1-8 8H8a8 8 0 0 1-8-8z"/>
    <path fill="var(--icon-color, white)" d="M25.375 15.31H19.99l4.664-2.693-1.024-1.775-4.664 2.693 2.692-4.663-1.775-1.025-2.692 4.663V7.125h-2.048v5.386l-2.694-4.664-1.774 1.024 2.693 4.664-4.664-2.693-1.024 1.774 4.664 2.693H6.959v2.049h5.384L7.68 20.05l1.024 1.774 4.663-2.692-2.692 4.664 1.774 1.024 2.693-4.664v5.385h2.049v-5.385l2.692 4.664 1.774-1.024-2.692-4.665 4.663 2.693 1.025-1.774-4.664-2.693h5.385zm-9.208 3.81a2.797 2.797 0 1 1 0-5.593 2.797 2.797 0 0 1 0 5.593"/>
    <path fill="var(--text-color, #1e1f21)" d="M42.67 25.34V3.93h3.93v21.41zm37.7-14.55h3.75v1.78c.8-1.42 2.66-2.19 4.26-2.19 1.98 0 3.58.86 4.32 2.43 1.15-1.77 2.69-2.42 4.61-2.42 2.69 0 5.26 1.63 5.26 5.53v9.43h-3.81v-8.63c0-1.57-.77-2.75-2.57-2.75-1.68 0-2.69 1.3-2.69 2.87v8.52h-3.9v-8.63c0-1.57-.8-2.75-2.57-2.75-1.71 0-2.72 1.27-2.72 2.87v8.52h-3.93zM55.48 25.77c-4.43 0-7.63-3.28-7.63-7.7 0-4.34 3.2-7.7 7.64-7.7 4.46 0 7.63 3.39 7.63 7.7 0 4.38-3.21 7.7-7.63 7.7m0-11.84a4.15 4.15 0 0 0-4.14 4.14 4.15 4.15 0 0 0 4.14 4.14 4.15 4.15 0 0 0 4.14-4.14 4.15 4.15 0 0 0-4.14-4.14m16.02 11.84c-4.43 0-7.63-3.28-7.63-7.7 0-4.34 3.2-7.7 7.63-7.7 4.46 0 7.64 3.39 7.64 7.7 0 4.38-3.21 7.7-7.63 7.7m0-11.89c-2.31 0-4.19 1.88-4.19 4.19s1.88 4.19 4.19 4.19 4.19-1.88 4.19-4.19-1.88-4.19-4.19-4.19"/>
</svg>
`;
function LoomInternalLogoCS({ size, appearance = 'brand', label = 'Loom', testId }) {
    return /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _logoWrapper.LogoWrapper), {
        svg: svg,
        label: label,
        appearance: appearance,
        size: size,
        testId: testId
    });
}

},{"react":"ltHCL","../../../utils/logo-wrapper":"aSXlT","@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"7lL9f":[function(require,module,exports,__globalThis) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::568f663154fd35333110385dd0c22e41>>
 * @codegenCommand yarn workspace @atlaskit/logo generate:components
 */ var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
/**
 * __LoomIcon__
 *
 * A temporary component to represent the icon for Loom.
 * @deprecated This component has been replaced by the component `LoomIcon` in `@atlaskit/logo`.
 * Please migrate any usages of this temporary component, using the prop `shouldUseNewLogoDesign` where necessary
 * to enable the new design by default.
 *
 */ parcelHelpers.export(exports, "LoomIcon", ()=>LoomIcon);
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _iconWrapper = require("../../../utils/icon-wrapper");
// `height` is set to 100% to allow the SVG to scale with the parent element
const svg = `<svg height="100%" viewBox="0 0 24 24">
    <path fill="var(--tile-color,#1868db)" d="M0 6a6 6 0 0 1 6-6h12a6 6 0 0 1 6 6v12a6 6 0 0 1-6 6H6a6 6 0 0 1-6-6z"/>
    <path fill="var(--icon-color, white)" d="M19.083 11.212h-4.142l3.588-2.071-.788-1.365-3.588 2.071 2.07-3.587-1.364-.788-2.071 3.587V4.917h-1.576v4.142L9.141 5.472l-1.365.787 2.071 3.588L6.26 7.776 5.472 9.14l3.587 2.07H4.917v1.577h4.142l-3.587 2.071.788 1.365 3.587-2.07-2.071 3.587 1.365.787 2.07-3.587v4.142h1.577V14.94l2.07 3.587 1.365-.787-2.07-3.588 3.587 2.071.788-1.365-3.587-2.07h4.142zM12 14.143a2.151 2.151 0 1 1 0-4.302 2.151 2.151 0 0 1 0 4.302"/>
</svg>
`;
function LoomIcon({ size, appearance = 'brand', label = 'Loom', testId }) {
    return /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _iconWrapper.IconWrapper), {
        svg: svg,
        label: label,
        appearance: appearance,
        size: size,
        testId: testId
    });
}

},{"react":"ltHCL","../../../utils/icon-wrapper":"4NqBa","@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"73uid":[function(require,module,exports,__globalThis) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::2d69248f39a87c063a78e83a58b63bd7>>
 * @codegenCommand yarn workspace @atlaskit/logo generate:components
 */ var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
/**
 * __LoomLogoCS__
 *
 * A temporary component to represent the logo for Loom.
 *
 */ parcelHelpers.export(exports, "LoomLogoCS", ()=>LoomLogoCS);
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _logoWrapper = require("../../../utils/logo-wrapper");
// `height` is set to 100% to allow the SVG to scale with the parent element
// The text color is set to "currentColor" to allow the SVG to inherit the color set by the parent based on the theme.
const svg = `<svg height="100%" viewBox="0 0 103 32">
    <path fill="var(--tile-color,#1868db)" d="M0 8a8 8 0 0 1 8-8h16a8 8 0 0 1 8 8v16a8 8 0 0 1-8 8H8a8 8 0 0 1-8-8z"/>
    <path fill="var(--icon-color, white)" d="M25.375 15.31H19.99l4.664-2.693-1.024-1.775-4.664 2.693 2.692-4.663-1.775-1.025-2.692 4.663V7.125h-2.048v5.386l-2.694-4.664-1.774 1.024 2.693 4.664-4.664-2.693-1.024 1.774 4.664 2.693H6.959v2.049h5.384L7.68 20.05l1.024 1.774 4.663-2.692-2.692 4.664 1.774 1.024 2.693-4.664v5.385h2.049v-5.385l2.692 4.664 1.774-1.024-2.692-4.665 4.663 2.693 1.025-1.774-4.664-2.693h5.385zm-9.208 3.81a2.797 2.797 0 1 1 0-5.593 2.797 2.797 0 0 1 0 5.593"/>
    <path fill="var(--text-color, #1e1f21)" d="M42.67 25.34V3.93h3.93v21.41zm37.7-14.55h3.75v1.78c.8-1.42 2.66-2.19 4.26-2.19 1.98 0 3.58.86 4.32 2.43 1.15-1.77 2.69-2.42 4.61-2.42 2.69 0 5.26 1.63 5.26 5.53v9.43h-3.81v-8.63c0-1.57-.77-2.75-2.57-2.75-1.68 0-2.69 1.3-2.69 2.87v8.52h-3.9v-8.63c0-1.57-.8-2.75-2.57-2.75-1.71 0-2.72 1.27-2.72 2.87v8.52h-3.93zM55.48 25.77c-4.43 0-7.63-3.28-7.63-7.7 0-4.34 3.2-7.7 7.64-7.7 4.46 0 7.63 3.39 7.63 7.7 0 4.38-3.21 7.7-7.63 7.7m0-11.84a4.15 4.15 0 0 0-4.14 4.14 4.15 4.15 0 0 0 4.14 4.14 4.15 4.15 0 0 0 4.14-4.14 4.15 4.15 0 0 0-4.14-4.14m16.02 11.84c-4.43 0-7.63-3.28-7.63-7.7 0-4.34 3.2-7.7 7.63-7.7 4.46 0 7.64 3.39 7.64 7.7 0 4.38-3.21 7.7-7.63 7.7m0-11.89c-2.31 0-4.19 1.88-4.19 4.19s1.88 4.19 4.19 4.19 4.19-1.88 4.19-4.19-1.88-4.19-4.19-4.19"/>
</svg>
`;
function LoomLogoCS({ size, appearance = 'brand', label = 'Loom', testId }) {
    return /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _logoWrapper.LogoWrapper), {
        svg: svg,
        label: label,
        appearance: appearance,
        size: size,
        testId: testId
    });
}

},{"react":"ltHCL","../../../utils/logo-wrapper":"aSXlT","@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"lOMs6":[function(require,module,exports,__globalThis) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::c11df6f0c8182479108e0649acaca190>>
 * @codegenCommand yarn workspace @atlaskit/logo generate:components
 */ var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
/**
 * __MoreAtlassianAppsIcon__
 *
 * An internal component to represent the icon for More Atlassian Apps.
 * Do not use this internal component directly — use `MoreAtlassianAppsIcon` from `@atlaskit/logo` instead.
 *
 */ parcelHelpers.export(exports, "MoreAtlassianAppsIcon", ()=>MoreAtlassianAppsIcon);
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _iconWrapper = require("../../../utils/icon-wrapper");
// `height` is set to 100% to allow the SVG to scale with the parent element
const svg = `<svg height="100%" viewBox="0 0 24 24">
    <path fill="var(--tile-color,#dddee1)" d="M0 6a6 6 0 0 1 6-6h12a6 6 0 0 1 6 6v12a6 6 0 0 1-6 6H6a6 6 0 0 1-6-6z"/>
    <path fill="var(--icon-color, #101214)" d="M11.13 5.88H5.88v5.25h5.25zm0 7H5.88v5.25h5.25zm1.75-7h5.25v5.25h-5.25zm5.25 7h-5.25v5.25h5.25z"/>
</svg>
`;
function MoreAtlassianAppsIcon({ size, appearance = 'brand', label = 'More Atlassian Apps', testId }) {
    return /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _iconWrapper.IconWrapper), {
        svg: svg,
        label: label,
        appearance: appearance,
        size: size,
        testId: testId
    });
}

},{"react":"ltHCL","../../../utils/icon-wrapper":"4NqBa","@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"35Kec":[function(require,module,exports,__globalThis) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::2bf4732a418598faff0fcffc57f4a7b7>>
 * @codegenCommand yarn workspace @atlaskit/logo generate:components
 */ var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
/**
 * __OpsgenieIcon__
 *
 * A temporary component to represent the icon for Opsgenie.
 * @deprecated This component has been replaced by the component `OpsgenieIcon` in `@atlaskit/logo`.
 * Please migrate any usages of this temporary component, using the prop `shouldUseNewLogoDesign` where necessary
 * to enable the new design by default.
 *
 */ parcelHelpers.export(exports, "OpsgenieIcon", ()=>OpsgenieIcon);
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _iconWrapper = require("../../../utils/icon-wrapper");
// `height` is set to 100% to allow the SVG to scale with the parent element
const svg = `<svg height="100%" viewBox="0 0 24 24">
    <path fill="var(--tile-color,#ffc716)" d="M0 6a6 6 0 0 1 6-6h12a6 6 0 0 1 6 6v12a6 6 0 0 1-6 6H6a6 6 0 0 1-6-6z"/>
    <path fill="var(--icon-color, #101214)" d="M12.696 19.45c-.49.361-.749.336-1.24-.026-2.375-1.704-4.57-3.641-6.042-5.655-.155-.207-.078-.49.155-.62l2.685-1.678q.35-.233.62.077c1.033 1.188 2.04 2.35 3.202 3.176 1.162-.826 2.17-1.988 3.202-3.176q.272-.31.62-.078l2.686 1.679c.232.13.31.413.155.62-1.472 2.014-3.667 3.95-6.043 5.68m-.62-7.411c2.118 0 3.874-1.73 3.874-3.848s-1.756-3.9-3.874-3.9c-2.117 0-3.873 1.757-3.873 3.9s1.704 3.848 3.873 3.848"/>
</svg>
`;
function OpsgenieIcon({ size, appearance = 'brand', label = 'Opsgenie', testId }) {
    return /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _iconWrapper.IconWrapper), {
        svg: svg,
        label: label,
        appearance: appearance,
        size: size,
        testId: testId
    });
}

},{"react":"ltHCL","../../../utils/icon-wrapper":"4NqBa","@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"31DOx":[function(require,module,exports,__globalThis) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::032f8fa95ed51413adb506dd076fd343>>
 * @codegenCommand yarn workspace @atlaskit/logo generate:components
 */ var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
/**
 * __OpsgenieLogoCS__
 *
 * A temporary component to represent the logo for Opsgenie.
 *
 */ parcelHelpers.export(exports, "OpsgenieLogoCS", ()=>OpsgenieLogoCS);
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _logoWrapper = require("../../../utils/logo-wrapper");
// `height` is set to 100% to allow the SVG to scale with the parent element
// The text color is set to "currentColor" to allow the SVG to inherit the color set by the parent based on the theme.
const svg = `<svg height="100%" viewBox="0 0 164 32">
    <path fill="var(--text-color, #1e1f21)" d="M156.69 12.09c-2.79 0-4.2 1.81-4.48 4.48h8.56c-.15-2.85-1.44-4.48-4.08-4.48m5.89 12.64c-1.26.67-3.19.92-4.75.92-5.73 0-8.25-3.31-8.25-8 0-4.63 2.58-7.94 7.24-7.94 4.72 0 6.62 3.28 6.62 7.94v1.2h-11.19c.37 2.61 2.06 4.29 5.67 4.29 1.78 0 3.28-.34 4.66-.83zM143.39 5.95c0-1.16.77-1.84 1.84-1.84s1.84.68 1.84 1.84-.77 1.84-1.84 1.84-1.84-.67-1.84-1.84m.49 19.38V10h2.64v15.33zm-3.68-8.98v8.99h-2.64v-9.26c0-2.76-1.1-3.99-3.62-3.99-2.45 0-4.14 1.63-4.14 4.72v8.53h-2.64V10h2.64v2.51c.98-1.81 2.79-2.82 4.85-2.82 3.53 0 5.55 2.42 5.55 6.66m-22.92-4.26c-2.79 0-4.2 1.81-4.48 4.48h8.56c-.15-2.85-1.44-4.48-4.08-4.48m5.89 12.64c-1.26.67-3.19.92-4.75.92-5.73 0-8.25-3.31-8.25-8 0-4.63 2.58-7.94 7.24-7.94 4.72 0 6.62 3.28 6.62 7.94v1.2h-11.19c.37 2.61 2.06 4.29 5.67 4.29 1.78 0 3.28-.34 4.66-.83zm-18.64-.62v-1.53c-.98 2.02-2.82 3.07-5.18 3.07-4.05 0-6.07-3.47-6.07-7.97 0-4.32 2.12-7.97 6.38-7.97 2.24 0 3.96 1.01 4.88 3.01V10h2.58v13.95c0 4.51-2.12 7.54-7.6 7.54-2.58 0-3.99-.34-5.46-.83v-2.58c1.69.55 3.44.92 5.34.92 3.83 0 5.15-2.06 5.15-4.91m-8.68-6.44c0 3.68 1.47 5.52 4.2 5.52 2.36 0 4.48-1.5 4.48-4.91v-1.23c0-3.4-1.93-4.91-4.17-4.91-2.97 0-4.51 1.96-4.51 5.52m-4.72 3.52c0 2.55-1.66 4.48-5.76 4.48-2.3 0-4.17-.52-5.34-1.13v-2.79c1.32.77 3.53 1.5 5.46 1.5 2.02 0 3.07-.83 3.07-2.02 0-1.17-.89-1.84-3.8-2.55-3.4-.83-4.85-2.15-4.85-4.66 0-2.67 2.06-4.29 5.55-4.29 1.99 0 3.8.49 4.94 1.1v2.73c-1.84-.92-3.34-1.41-4.97-1.41-1.93 0-2.97.67-2.97 1.87 0 1.07.74 1.75 3.56 2.42 3.4.83 5.12 2.09 5.12 4.75m-16.29-3.49c0-3.68-1.47-5.52-4.2-5.52-2.36 0-4.48 1.5-4.48 4.91v1.23c0 3.4 1.93 4.91 4.17 4.91 2.98 0 4.51-1.96 4.51-5.52m-3.8 7.97c-2.24 0-3.96-1.01-4.88-3.01v8.68h-2.64V10h2.64v2.76c.98-2.02 2.82-3.07 5.18-3.07 4.08 0 6.13 3.47 6.13 7.97 0 4.32-2.15 7.97-6.44 7.97m-20.11.01c-6.22 0-9.72-4.29-9.72-10.43 0-6.07 3.5-10.33 9.72-10.33 6.2 0 9.69 4.26 9.69 10.34 0 6.13-3.5 10.43-9.69 10.43m0-18.12c-4.97 0-6.96 3.53-6.96 7.7 0 4.26 1.99 7.79 6.96 7.79 4.94 0 6.93-3.53 6.93-7.79 0-4.17-1.99-7.7-6.93-7.7"/>
    <path fill="var(--tile-color,#ffc716)" d="M0 8a8 8 0 0 1 8-8h16a8 8 0 0 1 8 8v16a8 8 0 0 1-8 8H8a8 8 0 0 1-8-8z"/>
    <path fill="var(--icon-color, #101214)" d="M16.905 25.684c-.638.47-.974.437-1.612-.033-3.088-2.216-5.942-4.734-7.855-7.352-.202-.269-.1-.638.201-.806l3.491-2.182q.454-.302.806.1c1.343 1.545 2.652 3.056 4.163 4.13 1.51-1.074 2.82-2.585 4.163-4.13q.352-.402.805-.1l3.491 2.182c.303.168.403.537.202.806-1.914 2.618-4.767 5.136-7.855 7.385m-.806-9.635c2.753 0 5.035-2.249 5.035-5.001s-2.282-5.07-5.035-5.07-5.036 2.283-5.036 5.07c0 2.786 2.216 5.001 5.036 5.001"/>
</svg>
`;
function OpsgenieLogoCS({ size, appearance = 'brand', label = 'Opsgenie', testId }) {
    return /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _logoWrapper.LogoWrapper), {
        svg: svg,
        label: label,
        appearance: appearance,
        size: size,
        testId: testId
    });
}

},{"react":"ltHCL","../../../utils/logo-wrapper":"aSXlT","@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"8sscb":[function(require,module,exports,__globalThis) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::1c3a56195279b145c83aee2d39dd6918>>
 * @codegenCommand yarn workspace @atlaskit/logo generate:components
 */ var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
/**
 * __ProjectsIcon__
 *
 * An internal component to represent the icon for Projects.
 * Do not use this internal component directly — use `ProjectsIcon` from `@atlaskit/logo` instead.
 *
 */ parcelHelpers.export(exports, "ProjectsIcon", ()=>ProjectsIcon);
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _iconWrapper = require("../../../utils/icon-wrapper");
// `height` is set to 100% to allow the SVG to scale with the parent element
const svg = `<svg height="100%" viewBox="0 0 24 24">
    <path fill="var(--tile-color,#dddee1)" d="M0 6a6 6 0 0 1 6-6h12a6 6 0 0 1 6 6v12a6 6 0 0 1-6 6H6a6 6 0 0 1-6-6z"/>
    <path fill="var(--icon-color, #101214)" fill-rule="evenodd" d="m5.106 14.44 1.856-1.856-1.856-1.856L6.653 9.18h3.712l2.784-2.784h4.332v4.33l-2.785 2.785v3.712L13.15 18.77l-1.857-1.856-1.856 1.856-1.7-1.7 2.784-2.784-.928-.928-2.784 2.784zm10.209-4.331a1.094 1.094 0 1 1-1.547-1.546 1.094 1.094 0 0 1 1.547 1.546" clip-rule="evenodd"/>
</svg>
`;
function ProjectsIcon({ size, appearance = 'brand', label = 'Projects', testId }) {
    return /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _iconWrapper.IconWrapper), {
        svg: svg,
        label: label,
        appearance: appearance,
        size: size,
        testId: testId
    });
}

},{"react":"ltHCL","../../../utils/icon-wrapper":"4NqBa","@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"aTNRi":[function(require,module,exports,__globalThis) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::2700d019c02f76a45bbbdb7e71fedfcb>>
 * @codegenCommand yarn workspace @atlaskit/logo generate:components
 */ var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
/**
 * __ProjectsLogoCS__
 *
 * An internal component to represent the logo for Projects.
 *
 */ parcelHelpers.export(exports, "ProjectsLogoCS", ()=>ProjectsLogoCS);
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _logoWrapper = require("../../../utils/logo-wrapper");
// `height` is set to 100% to allow the SVG to scale with the parent element
// The text color is set to "currentColor" to allow the SVG to inherit the color set by the parent based on the theme.
const svg = `<svg height="100%" viewBox="0 0 145 32">
    <path fill="var(--text-color, #1e1f21)" d="M144.54 21.16c0 2.55-1.66 4.48-5.77 4.48-2.3 0-4.17-.52-5.34-1.13v-2.79c1.32.77 3.53 1.5 5.46 1.5 2.02 0 3.07-.83 3.07-2.02 0-1.17-.89-1.84-3.8-2.55-3.4-.83-4.84-2.15-4.84-4.66 0-2.67 2.05-4.29 5.55-4.29 1.99 0 3.8.49 4.94 1.1v2.73c-1.84-.92-3.34-1.41-4.97-1.41-1.93 0-2.97.67-2.97 1.87 0 1.07.74 1.75 3.56 2.42 3.4.83 5.12 2.09 5.12 4.75m-17.75-.58c0 1.35.8 2.27 2.42 2.27.61 0 1.2-.12 1.66-.21v2.55c-.46.12-.98.25-1.78.25-3.28 0-4.88-1.93-4.88-4.78v-8.19h-2.48V10h2.48V6.75h2.58V10h4.08v2.45h-4.08zm-6.66 1.99v2.36c-.92.49-2.33.71-3.74.71-5.46 0-8-3.31-8-8 0-4.63 2.55-7.94 8-7.94 1.38 0 2.45.18 3.65.74v2.45c-.98-.46-2.02-.74-3.47-.74-3.99 0-5.61 2.52-5.61 5.49s1.66 5.49 5.67 5.49c1.56 0 2.55-.21 3.5-.55M99.43 12.09c-2.79 0-4.2 1.81-4.48 4.48h8.56c-.15-2.85-1.44-4.48-4.08-4.48m5.89 12.64c-1.26.67-3.19.92-4.75.92-5.73 0-8.25-3.31-8.25-8 0-4.63 2.58-7.94 7.24-7.94 4.72 0 6.62 3.28 6.62 7.94v1.2h-11.2c.37 2.61 2.05 4.29 5.67 4.29 1.78 0 3.28-.34 4.66-.83zM83.8 31.25v-2.36c.31.03.49.03.77.03 1.13 0 2.05-.49 2.05-1.87V10h2.64v17.36c0 2.82-1.59 4.02-4.11 4.02-.67 0-1.13-.06-1.35-.12m2.3-25.3c0-1.16.77-1.84 1.84-1.84s1.84.68 1.84 1.84-.77 1.84-1.84 1.84-1.84-.67-1.84-1.84M76.07 25.64c-4.6 0-7.3-3.4-7.3-8s2.7-7.94 7.3-7.94c4.57 0 7.24 3.34 7.24 7.94s-2.67 8-7.24 8m0-13.49c-3.28 0-4.72 2.58-4.72 5.49s1.44 5.55 4.72 5.55c3.25 0 4.66-2.64 4.66-5.55s-1.41-5.49-4.66-5.49M62.3 16.29v9.05h-2.58V10h2.58v2.7c.89-1.81 2.42-3.1 5.43-2.91v2.58c-3.37-.34-5.43.67-5.43 3.93m-5-4.4c0 4.39-2.45 6.84-7.48 6.84H45.8v6.59h-2.76V5.19h6.78c5.03 0 7.48 2.58 7.48 6.72m-7.79 4.2c3.56.12 4.94-1.56 4.94-4.14 0-2.45-1.38-4.14-4.94-4.14H45.8v8.28z"/>
    <path fill="var(--tile-color,#dddee1)" d="M0 8a8 8 0 0 1 8-8h16a8 8 0 0 1 8 8v16a8 8 0 0 1-8 8H8a8 8 0 0 1-8-8z"/>
    <path fill="var(--icon-color, #101214)" fill-rule="evenodd" d="m6.152 19.486 2.651-2.652-2.651-2.651 2.21-2.21h5.303l3.977-3.977h6.187v6.187l-3.977 3.977v5.304l-2.21 2.21-2.652-2.652-2.651 2.651-2.429-2.428 3.978-3.978-1.326-1.325-3.978 3.977zM20.736 13.3a1.562 1.562 0 1 1-2.21-2.21 1.562 1.562 0 0 1 2.21 2.21" clip-rule="evenodd"/>
</svg>
`;
function ProjectsLogoCS({ size, appearance = 'brand', label = 'Projects', testId }) {
    return /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _logoWrapper.LogoWrapper), {
        svg: svg,
        label: label,
        appearance: appearance,
        size: size,
        testId: testId
    });
}

},{"react":"ltHCL","../../../utils/logo-wrapper":"aSXlT","@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"ffHTg":[function(require,module,exports,__globalThis) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::694cf9c8d8336e73333c711f4777239b>>
 * @codegenCommand yarn workspace @atlaskit/logo generate:components
 */ var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
/**
 * __RovoDevAgentIcon__
 *
 * An internal component to represent the icon for Rovo Dev Agent.
 * Do not use this internal component directly — use `RovoDevAgentIcon` from `@atlaskit/logo` instead.
 *
 */ parcelHelpers.export(exports, "RovoDevAgentIcon", ()=>RovoDevAgentIcon);
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _iconWrapper = require("../../../utils/icon-wrapper");
// `height` is set to 100% to allow the SVG to scale with the parent element
const svg = `<svg height="100%" viewBox="0 0 24 24">
    <path fill="var(--tile-color,#94c748)" d="M10.7.368a2.75 2.75 0 0 1 2.748 0l8.016 4.626a2.75 2.75 0 0 1 1.375 2.38v9.252c0 .982-.524 1.889-1.375 2.38l-8.016 4.626a2.75 2.75 0 0 1-2.749 0l-8.016-4.626a2.75 2.75 0 0 1-1.374-2.38V7.374c0-.982.524-1.889 1.374-2.38z"/>
    <path fill="var(--icon-color, #101214)" fill-rule="evenodd" d="M10.181 6.096 6.777 8.06a1.53 1.53 0 0 0-.768 1.327v5.229c0 .547.294 1.054.768 1.327l.807.466 3.722 2.149a1.54 1.54 0 0 0 1.508.014l.027-.018a1.54 1.54 0 0 0 .766-1.323v-2.026l-1.97-1.137-.568-.327a2 2 0 0 1-1.006-1.74V6.775a2 2 0 0 1 .118-.678" clip-rule="evenodd"/>
    <path fill="var(--icon-color, #101214)" fill-rule="evenodd" d="M12.842 5.441a1.54 1.54 0 0 0-1.508-.014l-.028.019a1.54 1.54 0 0 0-.765 1.323v2.025l1.91 1.102.628.362a2 2 0 0 1 1.006 1.74v5.228a2 2 0 0 1-.118.678l3.404-1.965c.476-.273.767-.778.767-1.327V9.383c0-.546-.293-1.054-.767-1.327l-.868-.501z" clip-rule="evenodd"/>
</svg>
`;
function RovoDevAgentIcon({ size, appearance = 'brand', label = 'Rovo Dev Agent', testId }) {
    return /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _iconWrapper.IconWrapper), {
        svg: svg,
        label: label,
        appearance: appearance,
        size: size,
        testId: testId
    });
}

},{"react":"ltHCL","../../../utils/icon-wrapper":"4NqBa","@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"cPrXs":[function(require,module,exports,__globalThis) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::3e07b5682123be769fa70cfe7a8367bf>>
 * @codegenCommand yarn workspace @atlaskit/logo generate:components
 */ var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
/**
 * __RovoDevAgentLogoCS__
 *
 * An internal component to represent the logo for Rovo Dev Agent.
 *
 */ parcelHelpers.export(exports, "RovoDevAgentLogoCS", ()=>RovoDevAgentLogoCS);
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _logoWrapper = require("../../../utils/logo-wrapper");
// `height` is set to 100% to allow the SVG to scale with the parent element
// The text color is set to "currentColor" to allow the SVG to inherit the color set by the parent based on the theme.
const svg = `<svg height="100%" viewBox="0 0 160 32">
    <path fill="var(--text-color, #1e1f21)" d="M153.94 25.67h-3.53l-5.95-15.33h2.76l4.97 13.1 4.94-13.09h2.76zM136.3 12.42c-2.79 0-4.2 1.81-4.48 4.48h8.56c-.15-2.85-1.44-4.48-4.08-4.48m5.89 12.64c-1.26.67-3.19.92-4.75.92-5.73 0-8.25-3.31-8.25-8 0-4.63 2.58-7.94 7.24-7.94 4.72 0 6.62 3.28 6.62 7.94v1.2h-11.2c.37 2.61 2.05 4.29 5.67 4.29 1.78 0 3.28-.34 4.66-.83zm-25.13-16.9h-4.54v14.87h4.69c4.6 0 6.9-2.42 6.9-7.3 0-4.91-2.18-7.57-7.05-7.57m-7.3 17.51V5.52h7.42c6.53 0 9.69 4.08 9.69 10.12 0 6.1-3.19 10.03-9.69 10.03zm-16.25.31c-4.6 0-7.3-3.4-7.3-8s2.7-7.94 7.3-7.94c4.57 0 7.24 3.34 7.24 7.94s-2.67 8-7.24 8m0-13.49c-3.28 0-4.72 2.58-4.72 5.49s1.44 5.55 4.72 5.55c3.25 0 4.66-2.64 4.66-5.55s-1.41-5.49-4.66-5.49M79.49 25.67h-3.53l-5.95-15.33h2.76l4.97 13.1 4.94-13.09h2.76zm-17.46.31c-4.6 0-7.3-3.4-7.3-8s2.7-7.94 7.3-7.94c4.57 0 7.24 3.34 7.24 7.94s-2.67 8-7.24 8m0-13.49c-3.28 0-4.72 2.58-4.72 5.49s1.44 5.55 4.72 5.55c3.25 0 4.66-2.64 4.66-5.55s-1.41-5.49-4.66-5.49M45 8.16h-4.05v7.36H45c3.59 0 4.69-1.38 4.69-3.68 0-2.18-1.13-3.68-4.69-3.68m7.45 3.62c0 3.04-1.29 5.09-3.96 5.95l4.94 7.94h-3.25l-4.45-7.51h-4.78v7.51h-2.76V5.52h7.11c4.82 0 7.15 2.39 7.15 6.26"/>
    <path fill="var(--tile-color,#94c748)" d="M12.52.49a3.67 3.67 0 0 1 3.666 0l10.688 6.17a3.66 3.66 0 0 1 1.833 3.173v12.336a3.66 3.66 0 0 1-1.833 3.173L16.186 31.51a3.67 3.67 0 0 1-3.665 0L1.833 25.341A3.66 3.66 0 0 1 0 22.168V9.832c0-1.309.7-2.519 1.833-3.173z"/>
    <path fill="var(--icon-color, #101214)" fill-rule="evenodd" d="m11.83 8.128-4.54 2.62a2.04 2.04 0 0 0-1.022 1.77v6.972c0 .728.39 1.405 1.023 1.77l1.076.62 4.963 2.865a2.05 2.05 0 0 0 2.01.02l.037-.025c.445-.257.771-.67.925-1.146q.094-.297.095-.619v-2.7l-2.627-1.516-.757-.436a2.67 2.67 0 0 1-1.34-2.32v-6.97a2.7 2.7 0 0 1 .157-.904" clip-rule="evenodd"/>
    <path fill="var(--icon-color, #101214)" fill-rule="evenodd" d="M15.377 7.255a2.05 2.05 0 0 0-2.01-.019l-.038.026c-.445.257-.77.67-.924 1.145a2 2 0 0 0-.095.618v2.7l2.545 1.47.839.483a2.67 2.67 0 0 1 1.34 2.319v6.972a2.7 2.7 0 0 1-.157.903l4.54-2.62a2.04 2.04 0 0 0 1.022-1.77v-6.971c0-.729-.39-1.405-1.023-1.77l-1.157-.668z" clip-rule="evenodd"/>
</svg>
`;
function RovoDevAgentLogoCS({ size, appearance = 'brand', label = 'Rovo Dev Agent', testId }) {
    return /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _logoWrapper.LogoWrapper), {
        svg: svg,
        label: label,
        appearance: appearance,
        size: size,
        testId: testId
    });
}

},{"react":"ltHCL","../../../utils/logo-wrapper":"aSXlT","@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"2pBYw":[function(require,module,exports,__globalThis) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::a1131b9b9b6248ab2f320c07042466bf>>
 * @codegenCommand yarn workspace @atlaskit/logo generate:components
 */ var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
/**
 * __RovoDevIcon__
 *
 * An internal component to represent the icon for Rovo Dev.
 * Do not use this internal component directly — use `RovoDevIcon` from `@atlaskit/logo` instead.
 *
 */ parcelHelpers.export(exports, "RovoDevIcon", ()=>RovoDevIcon);
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _iconWrapper = require("../../../utils/icon-wrapper");
// `height` is set to 100% to allow the SVG to scale with the parent element
const svg = `<svg height="100%" viewBox="0 0 24 24">
    <path fill="var(--tile-color,#94c748)" d="M0 6a6 6 0 0 1 6-6h12a6 6 0 0 1 6 6v12a6 6 0 0 1-6 6H6a6 6 0 0 1-6-6z"/>
    <path fill="var(--icon-color, #101214)" d="M11.26 4.71a1.7 1.7 0 0 1 1.666.017l5.006 2.89c.524.302.848.863.848 1.467v5.78a1.69 1.69 0 0 1-.848 1.467l-3.763 2.172.024-.07c.07-.216.107-.445.107-.679v-5.78c0-.794-.423-1.526-1.112-1.922l-2.805-1.62V6.195q.001-.267.08-.512c.126-.395.396-.737.765-.95l.002-.001z"/>
    <path fill="var(--icon-color, #101214)" d="M9.986 5.45 6.223 7.623a1.69 1.69 0 0 0-.848 1.466v5.78c0 .605.324 1.166.848 1.468l5.006 2.89a1.7 1.7 0 0 0 1.666.016l.03-.02c.37-.214.64-.556.768-.95q.078-.247.079-.513v-2.24l-2.805-1.618a2.22 2.22 0 0 1-1.112-1.922V6.2a2.2 2.2 0 0 1 .13-.75"/>
</svg>
`;
function RovoDevIcon({ size, appearance = 'brand', label = 'Rovo Dev', testId }) {
    return /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _iconWrapper.IconWrapper), {
        svg: svg,
        label: label,
        appearance: appearance,
        size: size,
        testId: testId
    });
}

},{"react":"ltHCL","../../../utils/icon-wrapper":"4NqBa","@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"GOXcQ":[function(require,module,exports,__globalThis) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::8e3612ac67ced6c8ac8b271a1aa6aa8b>>
 * @codegenCommand yarn workspace @atlaskit/logo generate:components
 */ var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
/**
 * __RovoDevLogoCS__
 *
 * An internal component to represent the logo for Rovo Dev.
 *
 */ parcelHelpers.export(exports, "RovoDevLogoCS", ()=>RovoDevLogoCS);
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _logoWrapper = require("../../../utils/logo-wrapper");
// `height` is set to 100% to allow the SVG to scale with the parent element
// The text color is set to "currentColor" to allow the SVG to inherit the color set by the parent based on the theme.
const svg = `<svg height="100%" viewBox="0 0 165 32">
    <path fill="var(--text-color, #1e1f21)" d="M158.79 25.33h-3.53L149.32 10h2.76l4.97 13.1 4.93-13.1h2.76zm-17.64-13.24c-2.79 0-4.2 1.81-4.48 4.48h8.56c-.15-2.85-1.44-4.48-4.08-4.48m5.89 12.64c-1.26.68-3.19.92-4.75.92-5.73 0-8.25-3.31-8.25-8 0-4.63 2.58-7.94 7.24-7.94 4.72 0 6.62 3.28 6.62 7.94v1.2h-11.19c.37 2.61 2.05 4.29 5.67 4.29 1.78 0 3.28-.34 4.66-.83zM121.91 7.82h-4.54v14.87h4.69c4.6 0 6.9-2.42 6.9-7.3 0-4.91-2.18-7.57-7.05-7.57m-7.3 17.51V5.19h7.42c6.53 0 9.69 4.08 9.69 10.12 0 6.1-3.19 10.03-9.69 10.03zm-16.26.31c-4.6 0-7.3-3.4-7.3-8s2.7-7.94 7.3-7.94c4.57 0 7.24 3.34 7.24 7.94s-2.67 8-7.24 8m0-13.49c-3.28 0-4.72 2.58-4.72 5.49s1.44 5.55 4.72 5.55c3.25 0 4.66-2.64 4.66-5.55s-1.41-5.49-4.66-5.49M84.34 25.33h-3.53L74.86 10h2.76l4.97 13.1L87.53 10h2.76zm-17.46.31c-4.6 0-7.3-3.4-7.3-8s2.7-7.94 7.3-7.94c4.57 0 7.24 3.34 7.24 7.94s-2.67 8-7.24 8m0-13.49c-3.28 0-4.72 2.58-4.72 5.49s1.44 5.55 4.72 5.55c3.25 0 4.66-2.64 4.66-5.55s-1.41-5.49-4.66-5.49M49.84 7.82h-4.05v7.36h4.05c3.59 0 4.69-1.38 4.69-3.68 0-2.18-1.13-3.68-4.69-3.68m7.45 3.62c0 3.04-1.29 5.09-3.96 5.95l4.94 7.94h-3.25l-4.44-7.51H45.8v7.51h-2.76V5.19h7.12c4.81 0 7.15 2.39 7.15 6.26"/>
    <path fill="var(--tile-color,#94c748)" d="M0 8a8 8 0 0 1 8-8h16a8 8 0 0 1 8 8v16a8 8 0 0 1-8 8H8a8 8 0 0 1-8-8z"/>
    <path fill="var(--icon-color, #101214)" d="M15.013 6.281a2.26 2.26 0 0 1 2.222.021l6.674 3.854a2.26 2.26 0 0 1 1.131 1.956v7.707c0 .809-.43 1.553-1.13 1.956l-5.018 2.896.032-.093c.093-.289.142-.594.142-.906v-7.707a2.95 2.95 0 0 0-1.481-2.563l-3.74-2.158V8.258c0-.235.036-.465.105-.682a2.26 2.26 0 0 1 1.021-1.267h.002z"/>
    <path fill="var(--icon-color, #101214)" d="m13.314 7.267-5.017 2.896a2.25 2.25 0 0 0-1.13 1.956v7.707c0 .806.432 1.553 1.13 1.956l6.675 3.854c.686.396 1.53.403 2.222.02l.04-.026c.493-.284.853-.74 1.023-1.267a2.3 2.3 0 0 0 .105-.683v-2.986l-3.74-2.158a2.96 2.96 0 0 1-1.482-2.563V8.266a3 3 0 0 1 .174-1"/>
</svg>
`;
function RovoDevLogoCS({ size, appearance = 'brand', label = 'Rovo Dev', testId }) {
    return /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _logoWrapper.LogoWrapper), {
        svg: svg,
        label: label,
        appearance: appearance,
        size: size,
        testId: testId
    });
}

},{"react":"ltHCL","../../../utils/logo-wrapper":"aSXlT","@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"2h3XF":[function(require,module,exports,__globalThis) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::a7bd8774a1a483ce4ec625e53d5f111c>>
 * @codegenCommand yarn workspace @atlaskit/logo generate:components
 */ var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
/**
 * __RovoHexIcon__
 *
 * An internal component to represent the icon for Rovo.
 * Do not use this internal component directly — use `RovoHexIcon` from `@atlaskit/logo` instead.
 *
 */ parcelHelpers.export(exports, "RovoHexIcon", ()=>RovoHexIcon);
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _iconWrapper = require("../../../utils/icon-wrapper");
// `height` is set to 100% to allow the SVG to scale with the parent element
const svg = `<svg height="100%" viewBox="0 0 24 24">
    <path fill="var(--rovo-blue-color, #1868db)" fill-rule="evenodd" d="m13.227 16.789-7.154 4.169-3.403-1.96a2.72 2.72 0 0 1-1.362-2.355V7.366c0-.973.518-1.87 1.361-2.354l6.044-3.487-.038.114a3.6 3.6 0 0 0-.172 1.088v9.278c0 1.274.68 2.45 1.786 3.085z" clip-rule="evenodd"/>
    <path fill="var(--rovo-green-color, #6a9a23)" fill-rule="evenodd" d="m11.296 15.671-7.193 4.153 6.607 3.812a2.73 2.73 0 0 0 2.676.026l.048-.033a2.73 2.73 0 0 0 1.232-1.525 2.7 2.7 0 0 0 .127-.822v-3.594z" clip-rule="evenodd"/>
    <path fill="var(--rovo-purple-color, #af59e1)" fill-rule="evenodd" d="m21.477 5.003-4.404-2.539-5.904 4.89 2.69 1.556a3.56 3.56 0 0 1 1.785 3.086v9.277a3.6 3.6 0 0 1-.21 1.202l6.044-3.486a2.71 2.71 0 0 0 1.362-2.355V7.357c0-.97-.521-1.87-1.363-2.354" clip-rule="evenodd"/>
    <path fill="var(--rovo-yellow-color, #fca700)" fill-rule="evenodd" d="M12.74 8.266 9.353 6.312V2.718c0-.283.044-.56.127-.821A2.73 2.73 0 0 1 10.71.372V.37a.4.4 0 0 0 .048-.033 2.73 2.73 0 0 1 2.676.026l6.499 3.75z" clip-rule="evenodd"/>
</svg>
`;
function RovoHexIcon({ size, appearance = 'brand', label = 'Rovo', testId }) {
    return /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _iconWrapper.IconWrapper), {
        svg: svg,
        label: label,
        type: "rovo",
        appearance: appearance,
        size: size,
        testId: testId
    });
}

},{"react":"ltHCL","../../../utils/icon-wrapper":"4NqBa","@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"fMSN8":[function(require,module,exports,__globalThis) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::81d74fa5dbe2e1ea12f9e61d6b58e6d8>>
 * @codegenCommand yarn workspace @atlaskit/logo generate:components
 */ var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
/**
 * __RovoHexLogoCS__
 *
 * An internal component to represent the logo for Rovo.
 *
 */ parcelHelpers.export(exports, "RovoHexLogoCS", ()=>RovoHexLogoCS);
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _logoWrapper = require("../../../utils/logo-wrapper");
// `height` is set to 100% to allow the SVG to scale with the parent element
// The text color is set to "currentColor" to allow the SVG to inherit the color set by the parent based on the theme.
const svg = `<svg height="100%" viewBox="0 0 102 32">
    <path fill="var(--text-color, #1e1f21)" d="M93.5 25.97c-4.6 0-7.3-3.4-7.3-8s2.7-7.94 7.3-7.94c4.57 0 7.24 3.34 7.24 7.94s-2.67 8-7.24 8m0-13.49c-3.28 0-4.72 2.58-4.72 5.49s1.44 5.55 4.72 5.55c3.25 0 4.66-2.64 4.66-5.55s-1.41-5.49-4.66-5.49M79.49 25.67h-3.53l-5.95-15.33h2.76l4.97 13.1 4.94-13.09h2.76zm-17.46.3c-4.6 0-7.3-3.4-7.3-8s2.7-7.94 7.3-7.94c4.57 0 7.24 3.34 7.24 7.94s-2.67 8-7.24 8m0-13.49c-3.28 0-4.72 2.58-4.72 5.49s1.44 5.55 4.72 5.55c3.25 0 4.66-2.64 4.66-5.55s-1.41-5.49-4.66-5.49M44.99 8.16h-4.05v7.36h4.05c3.59 0 4.69-1.38 4.69-3.68 0-2.18-1.13-3.68-4.69-3.68m7.45 3.62c0 3.04-1.29 5.09-3.96 5.95l4.94 7.94h-3.25l-4.45-7.51h-4.78v7.51h-2.76V5.52h7.11c4.82 0 7.15 2.39 7.15 6.26"/>
    <path fill="var(--rovo-blue-color, #1868db)" fill-rule="evenodd" d="m15.892 22.385-9.538 5.559-4.538-2.613A3.63 3.63 0 0 1 0 22.19V9.821C0 8.524.69 7.33 1.816 6.682l8.058-4.649-.052.152a4.7 4.7 0 0 0-.228 1.452v12.37a4.74 4.74 0 0 0 2.38 4.113z" clip-rule="evenodd"/>
    <path fill="var(--rovo-green-color, #6a9a23)" fill-rule="evenodd" d="m13.318 20.895-9.591 5.538 8.809 5.082a3.64 3.64 0 0 0 3.568.034l.065-.043a3.63 3.63 0 0 0 1.642-2.034c.11-.35.17-.718.17-1.096v-4.792z" clip-rule="evenodd"/>
    <path fill="var(--rovo-purple-color, #af59e1)" fill-rule="evenodd" d="M26.893 6.67 21.02 3.285l-7.873 6.52 3.587 2.075a4.74 4.74 0 0 1 2.38 4.115v12.369a4.7 4.7 0 0 1-.28 1.603l8.058-4.649a3.62 3.62 0 0 0 1.816-3.139V9.81a3.63 3.63 0 0 0-1.816-3.139" clip-rule="evenodd"/>
    <path fill="var(--rovo-yellow-color, #fca700)" fill-rule="evenodd" d="m15.244 11.022-4.519-2.606V3.625c0-.378.059-.747.17-1.096a3.63 3.63 0 0 1 1.64-2.033l.002-.001.064-.044a3.64 3.64 0 0 1 3.569.034l8.665 5z" clip-rule="evenodd"/>
</svg>
`;
function RovoHexLogoCS({ size, appearance = 'brand', label = 'Rovo', testId }) {
    return /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _logoWrapper.LogoWrapper), {
        svg: svg,
        label: label,
        type: "rovo",
        appearance: appearance,
        size: size,
        testId: testId
    });
}

},{"react":"ltHCL","../../../utils/logo-wrapper":"aSXlT","@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"erI0H":[function(require,module,exports,__globalThis) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::4fdd9cdb3dfb222b9beb33bde63bcd67>>
 * @codegenCommand yarn workspace @atlaskit/logo generate:components
 */ var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
/**
 * __RovoIcon__
 *
 * An internal component to represent the icon for Rovo.
 * Do not use this internal component directly — use `RovoIcon` from `@atlaskit/logo` instead.
 *
 */ parcelHelpers.export(exports, "RovoIcon", ()=>RovoIcon);
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _iconWrapper = require("../../../utils/icon-wrapper");
// `height` is set to 100% to allow the SVG to scale with the parent element
const svg = `<svg height="100%" viewBox="0 0 24 24">
    <path fill="var(--tile-color,#1868db)" d="M0 6a6 6 0 0 1 6-6h12a6 6 0 0 1 6 6v12a6 6 0 0 1-6 6H6a6 6 0 0 1-6-6z"/>
    <path fill="var(--icon-color, white)" d="M11.057 5.257a1.57 1.57 0 0 1 1.539.015l4.621 2.668c.484.279.783.797.783 1.354v5.336a1.56 1.56 0 0 1-.782 1.355l-3.474 2.005a2 2 0 0 0 .12-.691v-5.337c0-.733-.39-1.409-1.026-1.774l-2.59-1.495V6.626q.001-.246.074-.473c.117-.364.366-.68.707-.877z"/>
    <path fill="var(--icon-color, white)" d="M9.881 5.94 6.408 7.945A1.56 1.56 0 0 0 5.625 9.3v5.337c0 .557.3 1.075.783 1.354l4.621 2.668c.475.274 1.06.279 1.539.015l.027-.019a1.57 1.57 0 0 0 .781-1.35v-2.067l-2.589-1.495a2.05 2.05 0 0 1-1.026-1.775V6.631a2 2 0 0 1 .12-.691"/>
</svg>
`;
function RovoIcon({ size, appearance = 'brand', label = 'Rovo', testId }) {
    return /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _iconWrapper.IconWrapper), {
        svg: svg,
        label: label,
        appearance: appearance,
        size: size,
        testId: testId
    });
}

},{"react":"ltHCL","../../../utils/icon-wrapper":"4NqBa","@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"bBgAF":[function(require,module,exports,__globalThis) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::078cc586ef0207819d6635adebbccf14>>
 * @codegenCommand yarn workspace @atlaskit/logo generate:components
 */ var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
/**
 * __RovoLogoCS__
 *
 * An internal component to represent the logo for Rovo.
 *
 */ parcelHelpers.export(exports, "RovoLogoCS", ()=>RovoLogoCS);
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _logoWrapper = require("../../../utils/logo-wrapper");
// `height` is set to 100% to allow the SVG to scale with the parent element
// The text color is set to "currentColor" to allow the SVG to inherit the color set by the parent based on the theme.
const svg = `<svg height="100%" viewBox="0 0 106 32">
    <path fill="var(--text-color, #1e1f21)" d="M98.36 25.64c-4.6 0-7.3-3.4-7.3-8s2.7-7.94 7.3-7.94c4.57 0 7.24 3.34 7.24 7.94s-2.67 8-7.24 8m0-13.49c-3.28 0-4.72 2.58-4.72 5.49s1.44 5.55 4.72 5.55c3.25 0 4.66-2.64 4.66-5.55s-1.41-5.49-4.66-5.49M84.34 25.33h-3.53L74.87 10h2.76l4.97 13.1L87.53 10h2.76zm-17.46.31c-4.6 0-7.3-3.4-7.3-8s2.7-7.94 7.3-7.94c4.57 0 7.24 3.34 7.24 7.94s-2.67 8-7.24 8m0-13.49c-3.28 0-4.72 2.58-4.72 5.49s1.44 5.55 4.72 5.55c3.25 0 4.66-2.64 4.66-5.55s-1.41-5.49-4.66-5.49M49.84 7.82h-4.05v7.36h4.05c3.59 0 4.69-1.38 4.69-3.68 0-2.18-1.13-3.68-4.69-3.68m7.45 3.62c0 3.04-1.29 5.09-3.96 5.95l4.94 7.94h-3.25l-4.44-7.51H45.8v7.51h-2.76V5.19h7.12c4.81 0 7.15 2.39 7.15 6.26"/>
    <path fill="var(--tile-color,#1868db)" d="M0 8a8 8 0 0 1 8-8h16a8 8 0 0 1 8 8v16a8 8 0 0 1-8 8H8a8 8 0 0 1-8-8z"/>
    <path fill="var(--icon-color, white)" d="M15.013 6.281a2.26 2.26 0 0 1 2.222.021l6.674 3.854a2.26 2.26 0 0 1 1.131 1.956v7.707c0 .809-.43 1.553-1.13 1.956l-5.018 2.896q.017-.046.032-.093c.093-.289.142-.594.142-.906v-7.707a2.95 2.95 0 0 0-1.481-2.563l-3.74-2.158V8.258c0-.235.036-.465.105-.682.17-.527.529-.983 1.021-1.267h.002z"/>
    <path fill="var(--icon-color, white)" d="m13.314 7.267-5.017 2.896a2.25 2.25 0 0 0-1.13 1.956v7.707c0 .806.432 1.553 1.13 1.956l6.675 3.854c.686.396 1.53.403 2.222.02l.04-.026c.493-.284.853-.74 1.023-1.267a2.3 2.3 0 0 0 .105-.683v-2.986l-3.74-2.158a2.96 2.96 0 0 1-1.482-2.563V8.266a3 3 0 0 1 .174-1"/>
</svg>
`;
function RovoLogoCS({ size, appearance = 'brand', label = 'Rovo', testId }) {
    return /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _logoWrapper.LogoWrapper), {
        svg: svg,
        label: label,
        appearance: appearance,
        size: size,
        testId: testId
    });
}

},{"react":"ltHCL","../../../utils/logo-wrapper":"aSXlT","@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"5zLu7":[function(require,module,exports,__globalThis) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::e8449a5cf6c2f473179dfe4bd9893163>>
 * @codegenCommand yarn workspace @atlaskit/logo generate:components
 */ var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
/**
 * __SearchIcon__
 *
 * An internal component to represent the icon for Search.
 * Do not use this internal component directly — use `SearchIcon` from `@atlaskit/logo` instead.
 *
 */ parcelHelpers.export(exports, "SearchIcon", ()=>SearchIcon);
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _iconWrapper = require("../../../utils/icon-wrapper");
// `height` is set to 100% to allow the SVG to scale with the parent element
const svg = `<svg height="100%" viewBox="0 0 24 24">
    <path fill="var(--tile-color,#dddee1)" d="M0 6.625a6 6 0 0 1 6-6h12a6 6 0 0 1 6 6v12a6 6 0 0 1-6 6H6a6 6 0 0 1-6-6z"/>
    <path fill="var(--icon-color, #101214)" fill-rule="evenodd" d="M10.76 17.176a5.791 5.791 0 1 1 5.038-2.935l3.403 3.403-2.205 2.204-3.409-3.408a5.77 5.77 0 0 1-2.827.736m-.274-9.37-.242.615c-.344.874-.516 1.312-.833 1.64-.318.33-.749.518-1.61.893l-.37.16v.51l.37.16c.861.376 1.292.563 1.61.893.317.329.49.766.833 1.64l.242.616h.51l.242-.616c.344-.874.516-1.311.834-1.64.317-.33.748-.517 1.61-.893l.368-.16v-.51l-.369-.16c-.861-.375-1.292-.563-1.61-.892-.317-.33-.489-.766-.833-1.64l-.242-.616z" clip-rule="evenodd"/>
</svg>
`;
function SearchIcon({ size, appearance = 'brand', label = 'Search', testId }) {
    return /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _iconWrapper.IconWrapper), {
        svg: svg,
        label: label,
        appearance: appearance,
        size: size,
        testId: testId
    });
}

},{"react":"ltHCL","../../../utils/icon-wrapper":"4NqBa","@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"3e4fh":[function(require,module,exports,__globalThis) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::17e42f012731a68dbb72bc00bc08f838>>
 * @codegenCommand yarn workspace @atlaskit/logo generate:components
 */ var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
/**
 * __SearchLogoCS__
 *
 * An internal component to represent the logo for Search.
 *
 */ parcelHelpers.export(exports, "SearchLogoCS", ()=>SearchLogoCS);
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _logoWrapper = require("../../../utils/logo-wrapper");
// `height` is set to 100% to allow the SVG to scale with the parent element
// The text color is set to "currentColor" to allow the SVG to inherit the color set by the parent based on the theme.
const svg = `<svg height="100%" viewBox="0 0 130 32">
    <path fill="var(--text-color, #1e1f21)" d="M128.82 16.35v8.99h-2.64v-8.52c0-3.16-1.1-4.72-3.62-4.72-2.45 0-4.14 1.63-4.14 4.72v8.53h-2.64V3.59h2.64v8.96c1.01-1.81 2.85-2.85 5.06-2.85 3.44 0 5.34 2.33 5.34 6.66m-16.05 6.21v2.36c-.92.49-2.33.71-3.74.71-5.46 0-8-3.31-8-8 0-4.63 2.55-7.94 8-7.94 1.38 0 2.45.18 3.65.74v2.45c-.98-.46-2.02-.74-3.46-.74-3.99 0-5.61 2.52-5.61 5.49s1.66 5.49 5.67 5.49c1.56 0 2.55-.21 3.5-.55m-18.23-6.29v9.05h-2.58V10h2.58v2.7c.89-1.81 2.42-3.1 5.43-2.91v2.58c-3.37-.34-5.43.67-5.43 3.93m-17.87 1.37c0 3.68 1.47 5.52 4.2 5.52 2.36 0 4.48-1.5 4.48-4.91v-1.23c0-3.4-1.93-4.91-4.17-4.91-2.97 0-4.51 1.96-4.51 5.52m8.68 7.67v-2.76c-.98 2.02-2.82 3.07-5.18 3.07-4.08 0-6.13-3.47-6.13-7.97 0-4.32 2.15-7.97 6.44-7.97 2.24 0 3.96 1.01 4.88 3.01V10h2.64v15.33zM65.08 12.09c-2.79 0-4.2 1.81-4.48 4.48h8.56c-.15-2.85-1.44-4.48-4.08-4.48m5.89 12.64c-1.26.67-3.19.92-4.75.92-5.73 0-8.25-3.31-8.25-8 0-4.63 2.58-7.94 7.24-7.94 4.72 0 6.62 3.28 6.62 7.94v1.2h-11.2c.37 2.61 2.06 4.29 5.67 4.29 1.78 0 3.28-.34 4.66-.83zm-15.33-4.95c0 3.5-2.08 5.86-7.08 5.86-3.89 0-5.7-.77-7.27-1.56v-2.82c1.87.98 4.75 1.69 7.42 1.69 3.04 0 4.17-1.2 4.17-2.97s-1.1-2.73-4.94-3.65c-4.54-1.1-6.56-2.67-6.56-5.98 0-3.13 2.39-5.46 7.08-5.46 2.91 0 4.78.71 6.16 1.47v2.76c-2.02-1.16-4.2-1.53-6.29-1.53-2.64 0-4.2.92-4.2 2.76 0 1.66 1.29 2.48 4.85 3.37 4.26 1.07 6.66 2.45 6.66 6.07"/>
    <path fill="var(--tile-color,#dddee1)" d="M0 8a8 8 0 0 1 8-8h16a8 8 0 0 1 8 8v16a8 8 0 0 1-8 8H8a8 8 0 0 1-8-8z"/>
    <path fill="var(--icon-color, #101214)" fill-rule="evenodd" d="M14.346 22.068a7.721 7.721 0 1 1 6.718-3.913l4.537 4.536-2.94 2.94-4.545-4.545a7.7 7.7 0 0 1-3.77.982m-.364-12.494-.323.82c-.459 1.167-.688 1.75-1.112 2.188-.423.44-.997.69-2.146 1.19l-.492.214v.68l.492.213c1.149.5 1.723.75 2.146 1.19.424.439.653 1.022 1.112 2.188l.323.82h.679l.323-.82c.459-1.166.688-1.75 1.111-2.188.424-.44.998-.69 2.147-1.19l.491-.214v-.679l-.491-.214c-1.149-.5-1.723-.75-2.147-1.19-.423-.438-.652-1.021-1.111-2.187l-.323-.82z" clip-rule="evenodd"/>
</svg>
`;
function SearchLogoCS({ size, appearance = 'brand', label = 'Search', testId }) {
    return /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _logoWrapper.LogoWrapper), {
        svg: svg,
        label: label,
        appearance: appearance,
        size: size,
        testId: testId
    });
}

},{"react":"ltHCL","../../../utils/logo-wrapper":"aSXlT","@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"aRJot":[function(require,module,exports,__globalThis) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::37c59c3ee979ff8acaf7525e576da094>>
 * @codegenCommand yarn workspace @atlaskit/logo generate:components
 */ var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
/**
 * __StatuspageIcon__
 *
 * A temporary component to represent the icon for Statuspage.
 * @deprecated This component has been replaced by the component `StatuspageIcon` in `@atlaskit/logo`.
 * Please migrate any usages of this temporary component, using the prop `shouldUseNewLogoDesign` where necessary
 * to enable the new design by default.
 *
 */ parcelHelpers.export(exports, "StatuspageIcon", ()=>StatuspageIcon);
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _iconWrapper = require("../../../utils/icon-wrapper");
// `height` is set to 100% to allow the SVG to scale with the parent element
const svg = `<svg height="100%" viewBox="0 0 24 24">
    <path fill="var(--tile-color,#ffc716)" d="M0 6a6 6 0 0 1 6-6h12a6 6 0 0 1 6 6v12a6 6 0 0 1-6 6H6a6 6 0 0 1-6-6z"/>
    <path fill="var(--icon-color, #101214)" d="M12 9.796c-1.924 0-3.796.832-5.324 2.118q-.238.227-.475.227c-.132 0-.263-.076-.369-.202L3.908 9.771c-.105-.126-.158-.252-.158-.353 0-.151.08-.277.237-.429C6.307 7.023 9.127 5.914 12 5.914s5.693 1.109 8.013 3.075c.158.152.237.278.237.429 0 .1-.053.227-.158.353l-1.924 2.168c-.106.126-.238.202-.37.202q-.236 0-.474-.227c-1.529-1.286-3.4-2.118-5.324-2.118m0 8.118c-2.135 0-3.875-1.664-3.875-3.68 0-2.018 1.74-3.682 3.875-3.682s3.875 1.64 3.875 3.681-1.74 3.68-3.875 3.68"/>
</svg>
`;
function StatuspageIcon({ size, appearance = 'brand', label = 'Statuspage', testId }) {
    return /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _iconWrapper.IconWrapper), {
        svg: svg,
        label: label,
        appearance: appearance,
        size: size,
        testId: testId
    });
}

},{"react":"ltHCL","../../../utils/icon-wrapper":"4NqBa","@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"dsmSW":[function(require,module,exports,__globalThis) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::4e31a509778b74933bf91345a74560c5>>
 * @codegenCommand yarn workspace @atlaskit/logo generate:components
 */ var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
/**
 * __StatuspageLogoCS__
 *
 * A temporary component to represent the logo for Statuspage.
 *
 */ parcelHelpers.export(exports, "StatuspageLogoCS", ()=>StatuspageLogoCS);
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _logoWrapper = require("../../../utils/logo-wrapper");
// `height` is set to 100% to allow the SVG to scale with the parent element
// The text color is set to "currentColor" to allow the SVG to inherit the color set by the parent based on the theme.
const svg = `<svg height="100%" viewBox="0 0 192 32">
    <path fill="var(--text-color, #1e1f21)" d="M184.96 12.09c-2.79 0-4.2 1.81-4.48 4.48h8.56c-.15-2.85-1.44-4.48-4.08-4.48m5.89 12.64c-1.26.68-3.19.92-4.75.92-5.73 0-8.25-3.31-8.25-8 0-4.63 2.58-7.94 7.24-7.94 4.72 0 6.62 3.28 6.62 7.94v1.2h-11.19c.37 2.61 2.05 4.29 5.67 4.29 1.78 0 3.28-.34 4.66-.83zm-18.64-.62v-1.53c-.98 2.02-2.82 3.07-5.18 3.07-4.05 0-6.07-3.46-6.07-7.97 0-4.32 2.12-7.97 6.38-7.97 2.24 0 3.96 1.01 4.88 3.01V10h2.58v13.95c0 4.51-2.12 7.54-7.61 7.54-2.58 0-3.99-.34-5.46-.83v-2.58c1.69.55 3.43.92 5.34.92 3.83 0 5.15-2.05 5.15-4.91m-8.68-6.44c0 3.68 1.47 5.52 4.2 5.52 2.36 0 4.48-1.5 4.48-4.91v-1.23c0-3.4-1.93-4.91-4.17-4.91-2.97 0-4.51 1.96-4.51 5.52m-16.96.03c0 3.68 1.47 5.52 4.2 5.52 2.36 0 4.48-1.5 4.48-4.91v-1.23c0-3.4-1.93-4.91-4.17-4.91-2.97 0-4.51 1.96-4.51 5.52m8.68 7.67v-2.76c-.98 2.02-2.82 3.07-5.18 3.07-4.08 0-6.13-3.46-6.13-7.97 0-4.32 2.15-7.97 6.44-7.97 2.24 0 3.96 1.01 4.88 3.01V10h2.64v15.33zm-16.09-7.66c0-3.68-1.47-5.52-4.2-5.52-2.36 0-4.48 1.5-4.48 4.91v1.23c0 3.4 1.93 4.91 4.17 4.91 2.98 0 4.51-1.96 4.51-5.52m-3.8 7.97c-2.24 0-3.96-1.01-4.88-3v8.68h-2.64V10h2.64v2.76c.98-2.02 2.82-3.07 5.18-3.07 4.08 0 6.13 3.47 6.13 7.97 0 4.32-2.15 7.97-6.44 7.97m-10.55-4.47c0 2.55-1.66 4.48-5.77 4.48-2.3 0-4.17-.52-5.34-1.13v-2.79c1.32.77 3.53 1.5 5.46 1.5 2.02 0 3.07-.83 3.07-2.02 0-1.16-.89-1.84-3.8-2.54-3.4-.83-4.84-2.15-4.84-4.66 0-2.67 2.05-4.29 5.55-4.29 1.99 0 3.8.49 4.94 1.1v2.73c-1.84-.92-3.34-1.41-4.97-1.41-1.93 0-2.97.68-2.97 1.87 0 1.07.74 1.75 3.56 2.42 3.4.83 5.12 2.09 5.12 4.75m-27.61-2.18V10h2.64v9.26c0 2.76 1.1 3.99 3.62 3.99 2.45 0 4.14-1.62 4.14-4.72V10h2.64v15.33h-2.64v-2.51c-.98 1.81-2.79 2.82-4.84 2.82-3.53 0-5.55-2.42-5.55-6.65m-7.16 1.59c0 1.35.8 2.27 2.42 2.27.61 0 1.2-.12 1.66-.21v2.55c-.46.12-.98.25-1.78.25-3.28 0-4.88-1.93-4.88-4.78v-8.19H85V10h2.48V6.75h2.58V10h4.08v2.45h-4.08zm-18.95-2.91c0 3.68 1.47 5.52 4.2 5.52 2.36 0 4.48-1.5 4.48-4.91v-1.23c0-3.4-1.93-4.91-4.17-4.91-2.97 0-4.51 1.96-4.51 5.52m8.68 7.67v-2.76c-.98 2.02-2.82 3.07-5.18 3.07-4.08 0-6.13-3.46-6.13-7.97 0-4.32 2.15-7.97 6.44-7.97 2.24 0 3.96 1.01 4.88 3.01V10h2.64v15.33zm-17.26-4.75c0 1.35.8 2.27 2.42 2.27.61 0 1.2-.12 1.66-.21v2.55c-.46.12-.98.25-1.78.25-3.28 0-4.88-1.93-4.88-4.78v-8.19h-2.48V10h2.48V6.75h2.58V10h4.08v2.45h-4.08zm-6.89-.8c0 3.5-2.08 5.86-7.08 5.86-3.89 0-5.7-.77-7.27-1.56v-2.82c1.87.98 4.75 1.69 7.42 1.69 3.04 0 4.17-1.2 4.17-2.97s-1.1-2.73-4.94-3.65c-4.54-1.1-6.56-2.67-6.56-5.98 0-3.13 2.39-5.46 7.08-5.46 2.91 0 4.78.71 6.16 1.47v2.76c-2.02-1.16-4.2-1.53-6.29-1.53-2.64 0-4.2.92-4.2 2.76 0 1.66 1.29 2.48 4.84 3.37 4.26 1.07 6.66 2.45 6.66 6.07"/>
    <path fill="var(--tile-color,#ffc716)" d="M0 8a8 8 0 0 1 8-8h16a8 8 0 0 1 8 8v16a8 8 0 0 1-8 8H8a8 8 0 0 1-8-8z"/>
    <path fill="var(--icon-color, #101214)" d="M15.896 13.196c-2.464 0-4.86 1.114-6.817 2.835q-.303.304-.607.304c-.169 0-.338-.102-.473-.27l-2.463-2.902c-.135-.17-.202-.338-.202-.473 0-.202.1-.371.303-.573C8.607 9.484 12.217 8 15.896 8c3.678 0 7.29 1.484 10.259 4.117.202.202.303.37.303.573 0 .135-.067.304-.202.473l-2.463 2.902c-.135.168-.304.27-.473.27q-.303 0-.607-.304c-1.958-1.721-4.353-2.835-6.817-2.835m0 10.867c-2.733 0-4.96-2.228-4.96-4.927 0-2.7 2.227-4.927 4.96-4.927s4.96 2.193 4.96 4.927-2.227 4.927-4.96 4.927"/>
</svg>
`;
function StatuspageLogoCS({ size, appearance = 'brand', label = 'Statuspage', testId }) {
    return /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _logoWrapper.LogoWrapper), {
        svg: svg,
        label: label,
        appearance: appearance,
        size: size,
        testId: testId
    });
}

},{"react":"ltHCL","../../../utils/logo-wrapper":"aSXlT","@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"9OhW3":[function(require,module,exports,__globalThis) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::547909cc6b5dd84f765ef41fd848647b>>
 * @codegenCommand yarn workspace @atlaskit/logo generate:components
 */ var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
/**
 * __StudioIcon__
 *
 * An internal component to represent the icon for Studio.
 * Do not use this internal component directly — use `StudioIcon` from `@atlaskit/logo` instead.
 *
 */ parcelHelpers.export(exports, "StudioIcon", ()=>StudioIcon);
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _iconWrapper = require("../../../utils/icon-wrapper");
// `height` is set to 100% to allow the SVG to scale with the parent element
const svg = `<svg height="100%" viewBox="0 0 24 24">
    <path fill="var(--tile-color,#dddee1)" d="M0 6a6 6 0 0 1 6-6h12a6 6 0 0 1 6 6v12a6 6 0 0 1-6 6H6a6 6 0 0 1-6-6z"/>
    <path fill="var(--icon-color, #101214)" fill-rule="evenodd" d="M10.594 18.563v-7.97h7.969v7.97zm3.808-6.488-.163.429c-.235.615-.352.922-.572 1.155s-.52.368-1.12.638l-.222.1v.357l.222.099c.6.27.9.405 1.12.638s.337.54.572 1.156l.163.428h.347l.163-.429c.235-.615.352-.922.572-1.155s.52-.368 1.12-.638l.221-.1v-.357l-.22-.1c-.601-.269-.901-.404-1.121-.637s-.337-.54-.572-1.155l-.164-.429z" clip-rule="evenodd"/>
    <path fill="var(--icon-color, #101214)" d="M14.813 7.195 10.125 4.5 5.438 7.195v5.39l3.75 2.157V9.187h5.625z"/>
</svg>
`;
function StudioIcon({ size, appearance = 'brand', label = 'Studio', testId }) {
    return /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _iconWrapper.IconWrapper), {
        svg: svg,
        label: label,
        appearance: appearance,
        size: size,
        testId: testId
    });
}

},{"react":"ltHCL","../../../utils/icon-wrapper":"4NqBa","@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"4joV2":[function(require,module,exports,__globalThis) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::9f55f424cde2b5fe1f1eee28320c6ad8>>
 * @codegenCommand yarn workspace @atlaskit/logo generate:components
 */ var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
/**
 * __StudioLogoCS__
 *
 * An internal component to represent the logo for Studio.
 *
 */ parcelHelpers.export(exports, "StudioLogoCS", ()=>StudioLogoCS);
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _logoWrapper = require("../../../utils/logo-wrapper");
// `height` is set to 100% to allow the SVG to scale with the parent element
// The text color is set to "currentColor" to allow the SVG to inherit the color set by the parent based on the theme.
const svg = `<svg height="100%" viewBox="0 0 124 32">
    <path fill="var(--text-color, #1e1f21)" d="M116.71 25.64c-4.6 0-7.3-3.4-7.3-8s2.7-7.94 7.3-7.94c4.57 0 7.24 3.34 7.24 7.94s-2.67 8-7.24 8m0-13.49c-3.28 0-4.72 2.58-4.72 5.49s1.44 5.55 4.72 5.55c3.25 0 4.66-2.64 4.66-5.55s-1.41-5.49-4.66-5.49m-13.48-6.2c0-1.17.77-1.84 1.84-1.84s1.84.67 1.84 1.84-.77 1.84-1.84 1.84-1.84-.67-1.84-1.84m.49 19.38V10h2.64v15.33zm-15.3-7.66c0 3.68 1.47 5.52 4.2 5.52 2.36 0 4.48-1.5 4.48-4.91v-1.23c0-3.4-1.93-4.91-4.17-4.91-2.97 0-4.51 1.96-4.51 5.52m8.68 7.67v-2.76c-.98 2.02-2.82 3.07-5.18 3.07-4.08 0-6.13-3.47-6.13-7.97 0-4.32 2.15-7.97 6.44-7.97 2.24 0 3.96 1.01 4.88 3.01V3.59h2.64v21.74zm-27.41-6.34V10h2.64v9.26c0 2.76 1.1 3.99 3.62 3.99 2.45 0 4.14-1.63 4.14-4.72V10h2.64v15.33h-2.64v-2.51c-.98 1.81-2.79 2.82-4.85 2.82-3.53 0-5.55-2.42-5.55-6.65m-7.16 1.59c0 1.35.8 2.27 2.42 2.27.61 0 1.2-.12 1.66-.21v2.55a6.3 6.3 0 0 1-1.78.25c-3.28 0-4.88-1.93-4.88-4.78v-8.19h-2.48V10h2.48V6.75h2.58V10h4.08v2.45h-4.08zm-6.89-.8c0 3.5-2.08 5.86-7.08 5.86-3.89 0-5.7-.77-7.27-1.56v-2.82c1.87.98 4.75 1.69 7.42 1.69 3.04 0 4.17-1.2 4.17-2.97s-1.1-2.73-4.94-3.65c-4.54-1.1-6.56-2.67-6.56-5.98 0-3.13 2.39-5.46 7.08-5.46 2.91 0 4.78.71 6.16 1.47v2.76c-2.02-1.16-4.2-1.53-6.29-1.53-2.64 0-4.2.92-4.2 2.76 0 1.66 1.29 2.48 4.85 3.37 4.26 1.07 6.66 2.45 6.66 6.07"/>
    <path fill="var(--tile-color,#dddee1)" d="M0 8a8 8 0 0 1 8-8h16a8 8 0 0 1 8 8v16a8 8 0 0 1-8 8H8a8 8 0 0 1-8-8z"/>
    <path fill="var(--icon-color, #101214)" fill-rule="evenodd" d="M14.125 24.75V14.125H24.75V24.75zm5.078-8.65-.218.571c-.312.82-.469 1.23-.762 1.541s-.694.49-1.494.85l-.295.133v.476l.295.133c.8.36 1.2.54 1.494.85.293.311.45.721.762 1.541l.218.572h.462l.218-.572c.313-.82.469-1.23.762-1.54s.694-.491 1.494-.851l.295-.133v-.476l-.295-.132c-.8-.36-1.2-.54-1.494-.85-.293-.312-.45-.722-.762-1.542l-.218-.571z" clip-rule="evenodd"/>
    <path fill="var(--icon-color, #101214)" d="M19.75 9.594 13.5 6 7.25 9.594v7.187l5 2.875V12.25h7.5z"/>
</svg>
`;
function StudioLogoCS({ size, appearance = 'brand', label = 'Studio', testId }) {
    return /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _logoWrapper.LogoWrapper), {
        svg: svg,
        label: label,
        appearance: appearance,
        size: size,
        testId: testId
    });
}

},{"react":"ltHCL","../../../utils/logo-wrapper":"aSXlT","@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"bKuIO":[function(require,module,exports,__globalThis) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::548aca21494c6e3d39de8ad380612aed>>
 * @codegenCommand yarn workspace @atlaskit/logo generate:components
 */ var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
/**
 * __TalentIcon__
 *
 * An internal component to represent the icon for Talent.
 * Do not use this internal component directly — use `TalentIcon` from `@atlaskit/logo` instead.
 *
 */ parcelHelpers.export(exports, "TalentIcon", ()=>TalentIcon);
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _iconWrapper = require("../../../utils/icon-wrapper");
// `height` is set to 100% to allow the SVG to scale with the parent element
const svg = `<svg height="100%" viewBox="0 0 24 24">
    <path fill="var(--tile-color,#fb9700)" d="M0 6a6 6 0 0 1 6-6h12a6 6 0 0 1 6 6v12a6 6 0 0 1-6 6H6a6 6 0 0 1-6-6z"/>
    <path fill="var(--icon-color, #101214)" fill-rule="evenodd" d="m9.297 8.753 2.277-5.073h.858l2.277 5.073 5.529.598.265.816-4.121 3.734 1.14 5.442-.695.505-4.824-2.766-4.824 2.766-.695-.505 1.14-5.442-4.121-3.733.265-.817zm.777 6.415v-.678a1.857 1.857 0 0 1 3.715 0v.613a3.6 3.6 0 0 1-1.886.548h-.053a3.6 3.6 0 0 1-1.776-.483m1.858-3.134a1.393 1.393 0 1 0 0-2.786 1.393 1.393 0 0 0 0 2.786" clip-rule="evenodd"/>
</svg>
`;
function TalentIcon({ size, appearance = 'brand', label = 'Talent', testId }) {
    return /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _iconWrapper.IconWrapper), {
        svg: svg,
        label: label,
        appearance: appearance,
        size: size,
        testId: testId
    });
}

},{"react":"ltHCL","../../../utils/icon-wrapper":"4NqBa","@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"kaDYR":[function(require,module,exports,__globalThis) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::5789a2ba9d9ad5ee943d0005b148e594>>
 * @codegenCommand yarn workspace @atlaskit/logo generate:components
 */ var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
/**
 * __TalentLogoCS__
 *
 * An internal component to represent the logo for Talent.
 *
 */ parcelHelpers.export(exports, "TalentLogoCS", ()=>TalentLogoCS);
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _logoWrapper = require("../../../utils/logo-wrapper");
// `height` is set to 100% to allow the SVG to scale with the parent element
// The text color is set to "currentColor" to allow the SVG to inherit the color set by the parent based on the theme.
const svg = `<svg height="100%" viewBox="0 0 122 32">
    <path fill="var(--text-color, #1e1f21)" d="M117.1 20.58c0 1.35.8 2.27 2.42 2.27.61 0 1.2-.12 1.66-.21v2.55c-.46.12-.98.25-1.78.25-3.28 0-4.88-1.93-4.88-4.78v-8.19h-2.48V10h2.48V6.75h2.58V10h4.08v2.45h-4.08zm-7.33-4.23v8.99h-2.64v-9.26c0-2.76-1.1-3.99-3.62-3.99-2.45 0-4.14 1.63-4.14 4.72v8.53h-2.64V10h2.64v2.51c.98-1.81 2.79-2.82 4.85-2.82 3.53 0 5.55 2.42 5.55 6.66m-22.92-4.26c-2.79 0-4.2 1.81-4.48 4.48h8.56c-.15-2.85-1.44-4.48-4.08-4.48m5.89 12.64c-1.26.67-3.19.92-4.75.92-5.73 0-8.25-3.31-8.25-8 0-4.63 2.58-7.94 7.24-7.94 4.72 0 6.62 3.28 6.62 7.94v1.2H82.4c.37 2.61 2.06 4.29 5.67 4.29 1.78 0 3.28-.34 4.66-.83zm-14.47.57c-.21.06-.67.12-1.35.12-2.51 0-4.11-1.19-4.11-4.02V3.59h2.64V21.1c0 1.38.92 1.87 2.06 1.87.28 0 .46 0 .77-.03zm-20.75-7.63c0 3.68 1.47 5.52 4.2 5.52 2.36 0 4.48-1.5 4.48-4.91v-1.23c0-3.4-1.93-4.91-4.17-4.91-2.97 0-4.51 1.96-4.51 5.52m8.68 7.67v-2.76c-.98 2.02-2.82 3.07-5.18 3.07-4.08 0-6.13-3.47-6.13-7.97 0-4.32 2.15-7.97 6.44-7.97 2.24 0 3.96 1.01 4.88 3.01V10h2.64v15.33zM40.28 5.19h15.09v2.64H49.2v17.51h-2.76V7.82h-6.16z"/>
    <path fill="var(--tile-color,#fb9700)" d="M0 8a8 8 0 0 1 8-8h16a8 8 0 0 1 8 8v16a8 8 0 0 1-8 8H8a8 8 0 0 1-8-8z"/>
    <path fill="var(--icon-color, #101214)" d="m16.577 4.907 3.035 6.763 7.372.797.354 1.09-5.495 4.977 1.52 7.257-.927.672-6.431-3.687-6.433 3.687-.926-.672 1.52-7.257-5.495-4.978.353-1.089 7.372-.797 3.035-6.763zm-.668 11.936a2.476 2.476 0 0 0-2.476 2.477v.904a4.8 4.8 0 0 0 2.369.644h.07a4.8 4.8 0 0 0 2.514-.73v-.818a2.477 2.477 0 0 0-2.477-2.477m0-4.511a1.857 1.857 0 1 0 0 3.714 1.857 1.857 0 0 0 0-3.714"/>
</svg>
`;
function TalentLogoCS({ size, appearance = 'brand', label = 'Talent', testId }) {
    return /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _logoWrapper.LogoWrapper), {
        svg: svg,
        label: label,
        appearance: appearance,
        size: size,
        testId: testId
    });
}

},{"react":"ltHCL","../../../utils/logo-wrapper":"aSXlT","@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"fVGE3":[function(require,module,exports,__globalThis) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::2a7617bb15f45b06b307ddb34a89ff24>>
 * @codegenCommand yarn workspace @atlaskit/logo generate:components
 */ var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
/**
 * __TeamsIcon__
 *
 * An internal component to represent the icon for Teams.
 * Do not use this internal component directly — use `TeamsIcon` from `@atlaskit/logo` instead.
 *
 */ parcelHelpers.export(exports, "TeamsIcon", ()=>TeamsIcon);
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _iconWrapper = require("../../../utils/icon-wrapper");
// `height` is set to 100% to allow the SVG to scale with the parent element
const svg = `<svg height="100%" viewBox="0 0 24 24">
    <path fill="var(--tile-color,#dddee1)" d="M0 6a6 6 0 0 1 6-6h12a6 6 0 0 1 6 6v12a6 6 0 0 1-6 6H6a6 6 0 0 1-6-6z"/>
    <path fill="var(--icon-color, #101214)" d="M8.06 11.25a2.63 2.63 0 1 0 0-5.25 2.63 2.63 0 0 0 0 5.25m7.88 0a2.63 2.63 0 1 0 0-5.25 2.63 2.63 0 0 0 0 5.25m.17 1.31a2.89 2.89 0 0 1 2.89 2.9V18h-7.22l1.66-3.67a2.89 2.89 0 0 1 2.67-1.77M5 15.63V18h4.81l1.31-2.81a2.63 2.63 0 0 0-2.62-2.63h-.44A3.06 3.06 0 0 0 5 15.63"/>
</svg>
`;
function TeamsIcon({ size, appearance = 'brand', label = 'Teams', testId }) {
    return /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _iconWrapper.IconWrapper), {
        svg: svg,
        label: label,
        appearance: appearance,
        size: size,
        testId: testId
    });
}

},{"react":"ltHCL","../../../utils/icon-wrapper":"4NqBa","@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"lsBUC":[function(require,module,exports,__globalThis) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::767fa2606cdc14e785d5959f2e07c247>>
 * @codegenCommand yarn workspace @atlaskit/logo generate:components
 */ var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
/**
 * __TeamsLogoCS__
 *
 * An internal component to represent the logo for Teams.
 *
 */ parcelHelpers.export(exports, "TeamsLogoCS", ()=>TeamsLogoCS);
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _logoWrapper = require("../../../utils/logo-wrapper");
// `height` is set to 100% to allow the SVG to scale with the parent element
// The text color is set to "currentColor" to allow the SVG to inherit the color set by the parent based on the theme.
const svg = `<svg height="100%" viewBox="0 0 127 32">
    <path fill="var(--text-color, #1e1f21)" d="M126.58 21.16c0 2.55-1.66 4.48-5.77 4.48-2.3 0-4.17-.52-5.34-1.13v-2.79c1.32.77 3.53 1.5 5.46 1.5 2.02 0 3.07-.83 3.07-2.02 0-1.16-.89-1.84-3.8-2.54-3.4-.83-4.84-2.15-4.84-4.66 0-2.67 2.05-4.29 5.55-4.29 1.99 0 3.8.49 4.94 1.1v2.73c-1.84-.92-3.34-1.41-4.97-1.41-1.93 0-2.97.67-2.97 1.87 0 1.07.74 1.75 3.56 2.42 3.4.83 5.12 2.09 5.12 4.75m-24.66-4.36v8.53h-2.64v-9.26c0-2.76-1.1-3.99-3.62-3.99-2.45 0-4.14 1.63-4.14 4.72v8.53h-2.64V10h2.64v2.52c.98-1.81 2.79-2.82 4.85-2.82 2.61 0 4.39 1.32 5.15 3.74.86-2.36 2.91-3.74 5.46-3.74 3.44 0 5.34 2.33 5.34 6.66v8.99h-2.64v-8.52c0-3.16-1.1-4.72-3.62-4.72-2.45 0-4.14 1.63-4.14 4.72m-28.33.84c0 3.68 1.47 5.52 4.2 5.52 2.36 0 4.48-1.5 4.48-4.91v-1.23c0-3.4-1.93-4.91-4.17-4.91-2.97 0-4.51 1.96-4.51 5.52m8.68 7.67v-2.76c-.98 2.02-2.82 3.07-5.18 3.07-4.08 0-6.13-3.46-6.13-7.97 0-4.32 2.15-7.97 6.44-7.97 2.24 0 3.96 1.01 4.88 3.01V10h2.64v15.33zM61.99 12.08c-2.79 0-4.2 1.81-4.48 4.48h8.56c-.15-2.85-1.44-4.48-4.08-4.48m5.89 12.64c-1.26.68-3.19.92-4.75.92-5.73 0-8.25-3.31-8.25-8 0-4.63 2.58-7.94 7.24-7.94 4.72 0 6.62 3.28 6.62 7.94v1.2H57.55c.37 2.61 2.06 4.29 5.67 4.29 1.78 0 3.28-.34 4.66-.83zM40.28 5.19h15.09v2.64H49.2v17.51h-2.76V7.82h-6.16z"/>
    <path fill="var(--tile-color,#dddee1)" d="M0 8a8 8 0 0 1 8-8h16a8 8 0 0 1 8 8v16a8 8 0 0 1-8 8H8a8 8 0 0 1-8-8z"/>
    <path fill="var(--icon-color, #101214)" d="M10.75 14.83a3.5 3.5 0 1 0 0-7 3.5 3.5 0 0 0 0 7m10.5 0a3.5 3.5 0 1 0 0-7 3.5 3.5 0 0 0 0 7m.23 1.75a3.86 3.86 0 0 1 3.86 3.86v3.72h-9.62l2.21-5.23a3.86 3.86 0 0 1 3.55-2.35M6.67 20.67v3.5h6.42l1.75-4.08a3.5 3.5 0 0 0-3.5-3.5h-.58a4.08 4.08 0 0 0-4.08 4.08"/>
</svg>
`;
function TeamsLogoCS({ size, appearance = 'brand', label = 'Teams', testId }) {
    return /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _logoWrapper.LogoWrapper), {
        svg: svg,
        label: label,
        appearance: appearance,
        size: size,
        testId: testId
    });
}

},{"react":"ltHCL","../../../utils/logo-wrapper":"aSXlT","@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"iGsWT":[function(require,module,exports,__globalThis) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::2fc7b25031952cd94704eefaa85d7de4>>
 * @codegenCommand yarn workspace @atlaskit/logo generate:components
 */ var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
/**
 * __TrelloIcon__
 *
 * A temporary component to represent the icon for Trello.
 * @deprecated This component has been replaced by the component `TrelloIcon` in `@atlaskit/logo`.
 * Please migrate any usages of this temporary component, using the prop `shouldUseNewLogoDesign` where necessary
 * to enable the new design by default.
 *
 */ parcelHelpers.export(exports, "TrelloIcon", ()=>TrelloIcon);
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _iconWrapper = require("../../../utils/icon-wrapper");
// `height` is set to 100% to allow the SVG to scale with the parent element
const svg = `<svg height="100%" viewBox="0 0 24 24">
    <path fill="var(--tile-color,#1558bc)" d="M0 6a6 6 0 0 1 6-6h12a6 6 0 0 1 6 6v12a6 6 0 0 1-6 6H6a6 6 0 0 1-6-6z"/>
    <path fill="var(--icon-color, white)" d="M9.39 18.23a.95.95 0 0 0 .95-.95V5.38a.95.95 0 0 0-.95-.95H5.38a.95.95 0 0 0-.95.95v11.91c0 .52.42.95.95.95zm9.23-5.46a.95.95 0 0 0 .95-.95V5.38a.95.95 0 0 0-.95-.95h-4.01a.95.95 0 0 0-.95.95v6.44c0 .52.42.95.95.95z"/>
</svg>
`;
const customThemeSvg = `<svg height="100%" viewBox="0 0 24 24">
    <path fill="var(--themed-icon-color, currentcolor)" d="M18 0a6 6 0 0 1 6 6v12a6 6 0 0 1-6 6H6a6 6 0 0 1-6-6V6a6 6 0 0 1 6-6zM5.379 4.43a.95.95 0 0 0-.948.949v11.907c0 .523.424.948.948.948H9.39a.95.95 0 0 0 .947-.948V5.38a.95.95 0 0 0-.947-.948zm9.23 0a.95.95 0 0 0-.947.949v6.44c0 .523.423.948.947.949h4.012a.95.95 0 0 0 .948-.949V5.38a.95.95 0 0 0-.948-.948z"/>
</svg>
`;
function TrelloIcon({ iconColor, size, appearance = 'brand', label = 'Trello', testId }) {
    return /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _iconWrapper.IconWrapper), {
        svg: svg,
        customThemeSvg: customThemeSvg,
        iconColor: iconColor,
        label: label,
        appearance: appearance,
        size: size,
        testId: testId
    });
}

},{"react":"ltHCL","../../../utils/icon-wrapper":"4NqBa","@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"ahpsb":[function(require,module,exports,__globalThis) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::b73a20da143650f747e32cb182c99798>>
 * @codegenCommand yarn workspace @atlaskit/logo generate:components
 */ var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
/**
 * __TrelloLogoCS__
 *
 * A temporary component to represent the logo for Trello.
 *
 */ parcelHelpers.export(exports, "TrelloLogoCS", ()=>TrelloLogoCS);
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _logoWrapper = require("../../../utils/logo-wrapper");
// `height` is set to 100% to allow the SVG to scale with the parent element
// The text color is set to "currentColor" to allow the SVG to inherit the color set by the parent based on the theme.
const svg = `<svg height="100%" viewBox="0 0 113 32">
    <path fill="var(--text-color, #1e1f21)" d="M104.97 25.64c-4.6 0-7.3-3.4-7.3-8s2.7-7.94 7.3-7.94c4.57 0 7.24 3.34 7.24 7.94s-2.67 8-7.24 8m0-13.49c-3.28 0-4.72 2.58-4.72 5.49s1.44 5.55 4.72 5.55c3.25 0 4.66-2.64 4.66-5.55s-1.41-5.49-4.66-5.49M96.21 25.3c-.21.06-.67.12-1.35.12-2.51 0-4.11-1.19-4.11-4.02V3.59h2.64V21.1c0 1.38.92 1.87 2.06 1.87.28 0 .46 0 .77-.03zm-8 0c-.21.06-.67.12-1.35.12-2.51 0-4.11-1.19-4.11-4.02V3.59h2.64V21.1c0 1.38.92 1.87 2.06 1.87.28 0 .46 0 .77-.03zM72.86 12.09c-2.79 0-4.2 1.81-4.48 4.48h8.56c-.15-2.85-1.44-4.48-4.08-4.48m5.89 12.64c-1.26.67-3.19.92-4.75.92-5.73 0-8.25-3.31-8.25-8 0-4.63 2.58-7.94 7.24-7.94 4.72 0 6.62 3.28 6.62 7.94v1.2H68.42c.37 2.61 2.05 4.29 5.67 4.29 1.78 0 3.28-.34 4.66-.83zm-19.48-8.44v9.05h-2.58V10h2.58v2.7c.89-1.81 2.42-3.1 5.43-2.91v2.58c-3.37-.34-5.43.67-5.43 3.93M40.28 5.19h15.09v2.64H49.2v17.51h-2.76V7.82h-6.16z"/>
    <path fill="var(--tile-color,#1558bc)" d="M0 8a8 8 0 0 1 8-8h16a8 8 0 0 1 8 8v16a8 8 0 0 1-8 8H8a8 8 0 0 1-8-8z"/>
    <path fill="var(--icon-color, white)" d="M12.9 24c.62 0 1.13-.49 1.13-1.1V9.1c0-.61-.5-1.1-1.13-1.1H8.13C7.51 8 7 8.49 7 9.1v13.8c0 .61.5 1.1 1.13 1.1zm10.97-6.34c.62 0 1.13-.49 1.13-1.1V9.1c0-.61-.5-1.1-1.13-1.1H19.1c-.62 0-1.13.49-1.13 1.1v7.47c0 .61.5 1.1 1.13 1.1z"/>
</svg>
`;
function TrelloLogoCS({ size, appearance = 'brand', label = 'Trello', testId }) {
    return /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _logoWrapper.LogoWrapper), {
        svg: svg,
        label: label,
        appearance: appearance,
        size: size,
        testId: testId
    });
}

},{"react":"ltHCL","../../../utils/logo-wrapper":"aSXlT","@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"6IptU":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "createFeatureFlaggedComponent", ()=>createFeatureFlaggedComponent);
var _objectSpread = require("@swc/helpers/_/_object_spread");
var _objectWithoutProperties = require("@swc/helpers/_/_object_without_properties");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
const createFeatureFlaggedComponent = (_LegacyComponent, NewComponent)=>{
    // Note: textColor and iconColor aren't supported on all new logos
    // These props will be deprecated in the future
    return (_param)=>{
        var { size, shouldUseNewLogoDesign: _shouldUseNewLogoDesign } = _param, props = (0, _objectWithoutProperties._)(_param, [
            "size",
            "shouldUseNewLogoDesign"
        ]);
        // Size defaults need to be set, as the temp library had different defaults
        return /*#__PURE__*/ (0, _reactDefault.default).createElement(NewComponent, (0, _objectSpread._)({
            size: size || 'medium'
        }, props));
    };
};

},{"@swc/helpers/_/_object_spread":"9gdrV","@swc/helpers/_/_object_without_properties":"6HqIM","react":"ltHCL","@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"3NrZZ":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "createFeatureFlaggedServiceCollectionComponent", ()=>createFeatureFlaggedServiceCollectionComponent);
var _objectSpread = require("@swc/helpers/_/_object_spread");
var _objectWithoutProperties = require("@swc/helpers/_/_object_without_properties");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
const createFeatureFlaggedServiceCollectionComponent = (_LegacyComponent, NewComponent)=>{
    // Note: textColor and iconColor aren't supported on all new logos
    // These props will be deprecated in the future
    return (_param)=>{
        var { size, shouldUseNewLogoDesign: _shouldUseNewLogoDesign } = _param, props = (0, _objectWithoutProperties._)(_param, [
            "size",
            "shouldUseNewLogoDesign"
        ]);
        // Size defaults need to be set, as the temp library had different defaults
        return /*#__PURE__*/ (0, _reactDefault.default).createElement(NewComponent, (0, _objectSpread._)({
            size: size || 'medium'
        }, props));
    };
};

},{"@swc/helpers/_/_object_spread":"9gdrV","@swc/helpers/_/_object_without_properties":"6HqIM","react":"ltHCL","@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"lzwNy":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "AtlassianAdminIcon", ()=>(0, _icon.AtlassianAdminIcon));
parcelHelpers.export(exports, "AtlassianAdminLogo", ()=>(0, _logo.AtlassianAdminLogo));
var _icon = require("./icon");
var _logo = require("./logo");

},{"./icon":"cfxTf","./logo":"4oPTz","@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"cfxTf":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "AtlassianAdminIcon", ()=>AtlassianAdminIcon);
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _useThemeObserver = require("@atlaskit/tokens/use-theme-observer");
var _constants = require("../../constants");
var _wrapper = require("../../wrapper");
var _wrapperDefault = parcelHelpers.interopDefault(_wrapper);
var _getColorsFromAppearance = require("../get-colors-from-appearance");
const svg = ({ appearance, iconColor }, colorMode)=>{
    let colors = {
        iconColor
    };
    if (appearance) colors = (0, _getColorsFromAppearance.getColorsFromAppearance)(appearance, colorMode);
    return `<svg fill="none" height="32" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 32 32" focusable="false" aria-hidden="true">
      <path
        d="M27.545 24.378 16.96 3.208c-.208-.458-.417-.541-.667-.541-.208 0-.458.083-.708.5-1.5 2.375-2.167 5.125-2.167 8 0 4.001 2.042 7.752 5.042 13.794.334.667.584.792 1.167.792h7.335c.541 0 .833-.208.833-.625 0-.208-.042-.333-.25-.75M12.168 14.377c-.834-1.25-1.084-1.334-1.292-1.334s-.333.083-.708.834L4.875 24.46c-.167.334-.208.459-.208.625 0 .334.291.667.916.667h7.46c.5 0 .875-.416 1.083-1.208.25-1 .334-1.876.334-2.917 0-2.917-1.292-5.751-2.292-7.251z"
        fill="${colors.iconColor}"
      />
    </svg>`;
};
const AtlassianAdminIcon = ({ appearance, label = 'Atlassian Admin', size = (0, _constants.defaultLogoParams).size, testId, textColor = (0, _constants.defaultLogoParams).textColor, iconColor = (0, _constants.defaultLogoParams).iconColor })=>{
    const { colorMode } = (0, _useThemeObserver.useThemeObserver)();
    return /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _wrapperDefault.default), {
        appearance: appearance,
        svg: svg({
            appearance,
            iconColor
        }, colorMode),
        iconColor: iconColor,
        label: label,
        size: size,
        testId: testId,
        textColor: textColor
    });
};

},{"react":"ltHCL","@atlaskit/tokens/use-theme-observer":"4S775","../../constants":"kYpRl","../../wrapper":"9ojnE","../get-colors-from-appearance":"jcOxk","@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"kYpRl":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "defaultLogoParams", ()=>defaultLogoParams);
parcelHelpers.export(exports, "legacyDefaultLogoParams", ()=>legacyDefaultLogoParams);
const defaultLogoParams = {
    iconColor: 'inherit',
    label: '',
    size: 'medium',
    textColor: 'currentColor'
};
const legacyDefaultLogoParams = {
    iconGradientStart: 'inherit',
    iconGradientStop: 'inherit'
};

},{"@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"9ojnE":[function(require,module,exports,__globalThis) {
/* wrapper.tsx generated by @compiled/babel-plugin v0.39.1 */ var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _objectSpread = require("@swc/helpers/_/_object_spread");
var _objectSpreadProps = require("@swc/helpers/_/_object_spread_props");
var _objectWithoutProperties = require("@swc/helpers/_/_object_without_properties");
var _react = require("react");
var _runtime = require("@compiled/react/runtime");
const CSS_VAR_COLOR = '--logo-color';
const CSS_VAR_FILL = '--logo-fill';
const styles = {
    root: "_1e0c1o8l _kqswh2mm _syaz1vry _lswu1xf6 _vwz4kb7n _uiztglyw _o5724jg8 _zbji1osq _3se11kw7",
    stop: "_vc881r31",
    xxsmall: "_4t3i7vkz",
    xsmall: "_4t3igktf",
    small: "_4t3i1tcg",
    medium: "_4t3izwfg",
    large: "_4t3i1ylp",
    xlarge: "_4t3ickbl"
};
/**
 * __Wrapper__
 *
 * An internal component used by `@atlaskit/logo` to render logo SVGs with correct styles.
 */ const Wrapper = (_param)=>{
    var { label, svg, size, appearance, iconColor, textColor, testId: userDefinedTestId } = _param, rest = (0, _objectWithoutProperties._)(_param, [
        "label",
        "svg",
        "size",
        "appearance",
        "iconColor",
        "textColor",
        "testId"
    ]);
    // Only required for old logos with gradients, which set gradient values to `inherit` when no appearance is provided
    const shouldApplyStopColor = appearance === undefined;
    const testId = userDefinedTestId && `${userDefinedTestId}--wrapper`;
    return /*#__PURE__*/ _react.createElement("span", (0, _objectSpreadProps._)((0, _objectSpread._)({
        "data-testid": testId,
        style: {
            [CSS_VAR_COLOR]: iconColor,
            [CSS_VAR_FILL]: textColor
        },
        "aria-label": label ? label : undefined,
        role: label ? 'img' : undefined,
        dangerouslySetInnerHTML: {
            __html: svg
        }
    }, rest), {
        className: (0, _runtime.ax)([
            styles.root,
            shouldApplyStopColor && styles.stop,
            size && styles[size]
        ])
    }));
};
exports.default = Wrapper;

},{"@swc/helpers/_/_object_spread":"9gdrV","@swc/helpers/_/_object_spread_props":"kANqQ","@swc/helpers/_/_object_without_properties":"6HqIM","react":"ltHCL","@compiled/react/runtime":"d27Vo","@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"jcOxk":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "getColorsFromAppearance", ()=>getColorsFromAppearance);
const getColorsFromAppearance = (appearance, colorMode)=>{
    let iconColor, textColor, atlassianLogoTextColor;
    if (colorMode === 'dark') switch(appearance){
        case 'brand':
            iconColor = '#357DE8';
            textColor = '#E2E3E4';
            atlassianLogoTextColor = '#357DE8';
            break;
        case 'neutral':
            iconColor = '#96999E';
            textColor = '#BFC1C4';
            atlassianLogoTextColor = '#96999E';
            break;
        case 'inverse':
            iconColor = '#101214';
            textColor = '#101214';
            atlassianLogoTextColor = '#101214';
            break;
    }
    else switch(appearance){
        case 'brand':
            iconColor = '#1868DB';
            textColor = '#101214';
            atlassianLogoTextColor = '#1868DB';
            break;
        case 'neutral':
            iconColor = '#6C6F77';
            textColor = '#3B3D42';
            atlassianLogoTextColor = '#6C6F77';
            break;
        case 'inverse':
            iconColor = '#FFFFFF';
            textColor = '#FFFFFF';
            atlassianLogoTextColor = '#FFFFFF';
            break;
    }
    return {
        iconColor,
        textColor,
        atlassianLogoTextColor
    };
};

},{"@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"4oPTz":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "AtlassianAdminLogo", ()=>AtlassianAdminLogo);
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _useThemeObserver = require("@atlaskit/tokens/use-theme-observer");
var _constants = require("../../constants");
var _wrapper = require("../../wrapper");
var _wrapperDefault = parcelHelpers.interopDefault(_wrapper);
var _getColorsFromAppearance = require("../get-colors-from-appearance");
const svg = ({ appearance, iconColor, textColor }, colorMode)=>{
    let colors = {
        iconColor,
        textColor
    };
    if (appearance) colors = (0, _getColorsFromAppearance.getColorsFromAppearance)(appearance, colorMode);
    return `<svg
      fill="none"
      height="32"
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 295 32"
      focusable="false"
      aria-hidden="true"
    >
      <path
        d="M294.31 16.348v8.985h-2.637v-9.261c0-2.76-1.104-3.987-3.619-3.987-2.453 0-4.14 1.626-4.14 4.723v8.525h-2.637V10h2.637v2.515c.982-1.81 2.791-2.822 4.846-2.822 3.526 0 5.55 2.423 5.55 6.655M274.168 5.952c0-1.165.766-1.84 1.84-1.84 1.073 0 1.84.675 1.84 1.84s-.767 1.84-1.84 1.84c-1.074 0-1.84-.675-1.84-1.84m.49 19.381V10h2.638v15.333zm-14.069-8.525v8.525h-2.637v-9.261c0-2.76-1.104-3.987-3.619-3.987-2.453 0-4.14 1.626-4.14 4.723v8.525h-2.637V10h2.637v2.515c.981-1.81 2.791-2.822 4.845-2.822 2.607 0 4.386 1.319 5.152 3.742.859-2.362 2.914-3.742 5.459-3.742 3.435 0 5.336 2.331 5.336 6.655v8.985h-2.637v-8.525c0-3.159-1.104-4.723-3.619-4.723-2.453 0-4.14 1.626-4.14 4.723m-28.327.859c0 3.68 1.472 5.52 4.202 5.52 2.361 0 4.477-1.503 4.477-4.907v-1.227c0-3.404-1.932-4.906-4.171-4.906-2.974 0-4.508 1.962-4.508 5.52m8.679 7.666v-2.76c-.981 2.024-2.821 3.067-5.183 3.067-4.078 0-6.133-3.465-6.133-7.973 0-4.324 2.147-7.974 6.44-7.974 2.239 0 3.956 1.012 4.876 3.006V3.59h2.637v21.742zm-22.021-4.017c-1.533 0-3.097-.184-4.814-.521l-1.687 4.538h-3.097l7.942-20.148h3.496l7.943 20.148h-3.097l-1.687-4.569c-1.809.368-3.373.552-4.999.552m0-2.453c1.288 0 2.607-.154 4.171-.399l-4.079-11.04-4.078 11.07c1.502.246 2.76.369 3.986.369"
        fill="${colors.textColor}"
      />
      <path
        d="M107.447 10.828c0 2.972 1.345 5.308 6.795 6.37 3.185.707 3.893 1.203 3.893 2.264 0 1.062-.708 1.699-2.973 1.699-2.619 0-5.733-.92-7.785-2.123v4.812c1.627.779 3.751 1.699 7.785 1.699 5.662 0 7.856-2.548 7.856-6.228m0 .07c0-3.538-1.84-5.166-7.148-6.299-2.902-.637-3.61-1.274-3.61-2.194 0-1.132 1.062-1.628 2.973-1.628 2.335 0 4.6.708 6.794 1.7V6.368c-1.557-.779-3.892-1.345-6.653-1.345-5.237 0-7.927 2.265-7.927 5.945m72.475-5.803v20.172h4.318V9.978l1.769 4.034 6.087 11.325h5.379V5.165h-4.247v13.023l-1.628-3.822-4.883-9.2zm-27.319 0h-4.671v20.172h4.671zm-10.05 14.155c0-3.538-1.841-5.166-7.149-6.298-2.902-.637-3.609-1.274-3.609-2.194 0-1.133 1.061-1.628 2.972-1.628 2.336 0 4.601.707 6.795 1.698v-4.6c-1.557-.779-3.893-1.345-6.653-1.345-5.238 0-7.927 2.265-7.927 5.945 0 2.973 1.345 5.309 6.794 6.37 3.185.708 3.893 1.203 3.893 2.265s-.708 1.699-2.973 1.699c-2.618 0-5.733-.92-7.785-2.124v4.813c1.628.779 3.751 1.699 7.785 1.699 5.592 0 7.857-2.548 7.857-6.3M71.069 5.165v20.172h9.625l1.486-4.389h-6.44V5.165zm-19.039 0v4.318h5.167v15.854h4.741V9.483h5.592V5.165zm-6.866 0h-6.157L32 25.336h5.379l.99-3.397c1.204.354 2.478.566 3.752.566s2.548-.212 3.751-.566l.991 3.397h5.379c-.07 0-7.078-20.17-7.078-20.17zM42.05 18.26c-.92 0-1.77-.142-2.548-.354L42.05 9.13l2.548 8.776a9.6 9.6 0 0 1-2.548.354M97.326 5.165H91.17l-7.08 20.171h5.38l.99-3.397c1.203.354 2.477.566 3.751.566s2.548-.212 3.751-.566l.991 3.397h5.379zM94.212 18.26c-.92 0-1.77-.142-2.548-.354l2.548-8.776 2.548 8.776a9.6 9.6 0 0 1-2.548.354m75.306-13.095h-6.157l-7.007 20.171h5.379l.991-3.397c1.203.354 2.477.566 3.751.566s2.548-.212 3.751-.566l.991 3.397h5.379zm-3.043 13.094c-.92 0-1.77-.142-2.548-.354l2.548-8.776 2.548 8.776a10 10 0 0 1-2.548.354M22.878 24.378 12.293 3.208c-.208-.458-.416-.541-.666-.541-.209 0-.459.083-.709.5-1.5 2.375-2.167 5.125-2.167 8 0 4.001 2.042 7.752 5.043 13.794.333.667.583.792 1.166.792h7.335c.542 0 .833-.208.833-.625 0-.208-.041-.333-.25-.75M7.501 14.377c-.833-1.25-1.083-1.334-1.292-1.334s-.333.083-.708.834L.208 24.46c-.166.334-.208.459-.208.625 0 .334.292.667.917.667h7.46c.5 0 .874-.416 1.083-1.208.25-1 .333-1.876.333-2.917 0-2.917-1.292-5.751-2.292-7.251z"
        fill="${colors.iconColor}"
      />
    </svg>`;
};
const AtlassianAdminLogo = ({ appearance, label = 'Atlassian Admin', size = (0, _constants.defaultLogoParams).size, testId, textColor = (0, _constants.defaultLogoParams).textColor, iconColor = (0, _constants.defaultLogoParams).iconColor })=>{
    const { colorMode } = (0, _useThemeObserver.useThemeObserver)();
    return /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _wrapperDefault.default), {
        appearance: appearance,
        iconColor: iconColor,
        label: label,
        size: size,
        svg: svg({
            appearance,
            iconColor,
            textColor
        }, colorMode),
        testId: testId,
        textColor: textColor
    });
};

},{"react":"ltHCL","@atlaskit/tokens/use-theme-observer":"4S775","../../constants":"kYpRl","../../wrapper":"9ojnE","../get-colors-from-appearance":"jcOxk","@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"3OvbM":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "AtlassianAdministrationIcon", ()=>(0, _icon.AtlassianAdministrationIcon));
parcelHelpers.export(exports, "AtlassianAdministrationLogo", ()=>(0, _logo.AtlassianAdministrationLogo));
var _icon = require("./icon");
var _logo = require("./logo");

},{"./icon":"9jkbJ","./logo":"eSbun","@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"9jkbJ":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "AtlassianAdministrationIcon", ()=>AtlassianAdministrationIcon);
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _useThemeObserver = require("@atlaskit/tokens/use-theme-observer");
var _constants = require("../../constants");
var _wrapper = require("../../wrapper");
var _wrapperDefault = parcelHelpers.interopDefault(_wrapper);
var _getColorsFromAppearance = require("../get-colors-from-appearance");
const svg = ({ appearance, iconColor }, colorMode)=>{
    let colors = {
        iconColor
    };
    if (appearance) colors = (0, _getColorsFromAppearance.getColorsFromAppearance)(appearance, colorMode);
    return `<svg fill="none" height="32" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 32 32" focusable="false" aria-hidden="true">
      <path
        d="M27.545 24.378 16.96 3.208c-.208-.458-.417-.541-.667-.541-.208 0-.458.083-.708.5-1.5 2.375-2.167 5.125-2.167 8 0 4.001 2.042 7.752 5.042 13.794.334.667.584.792 1.167.792h7.335c.541 0 .833-.208.833-.625 0-.208-.042-.333-.25-.75M12.168 14.377c-.834-1.25-1.084-1.334-1.292-1.334s-.333.083-.708.834L4.875 24.46c-.167.334-.208.459-.208.625 0 .334.291.667.916.667h7.46c.5 0 .875-.416 1.083-1.208.25-1 .334-1.876.334-2.917 0-2.917-1.292-5.751-2.292-7.251z"
        fill="${colors.iconColor}"
      />
    </svg>`;
};
const AtlassianAdministrationIcon = ({ appearance, label = 'Atlassian Administration', size = (0, _constants.defaultLogoParams).size, testId, textColor = (0, _constants.defaultLogoParams).textColor, iconColor = (0, _constants.defaultLogoParams).iconColor })=>{
    const { colorMode } = (0, _useThemeObserver.useThemeObserver)();
    return /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _wrapperDefault.default), {
        appearance: appearance,
        svg: svg({
            appearance,
            iconColor
        }, colorMode),
        iconColor: iconColor,
        label: label,
        size: size,
        testId: testId,
        textColor: textColor
    });
};

},{"react":"ltHCL","@atlaskit/tokens/use-theme-observer":"4S775","../../constants":"kYpRl","../../wrapper":"9ojnE","../get-colors-from-appearance":"jcOxk","@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"eSbun":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "AtlassianAdministrationLogo", ()=>AtlassianAdministrationLogo);
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _useThemeObserver = require("@atlaskit/tokens/use-theme-observer");
var _constants = require("../../constants");
var _wrapper = require("../../wrapper");
var _wrapperDefault = parcelHelpers.interopDefault(_wrapper);
var _getColorsFromAppearance = require("../get-colors-from-appearance");
const svg = ({ appearance, iconColor, textColor }, colorMode)=>{
    let colors = {
        iconColor,
        textColor
    };
    if (appearance) colors = (0, _getColorsFromAppearance.getColorsFromAppearance)(appearance, colorMode);
    return `<svg
      fill="none"
      height="32"
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 404 32"
      focusable="false"
      aria-hidden="true"
    >
      <path
        d="M403.77 16.348v8.985h-2.637v-9.261c0-2.76-1.104-3.987-3.619-3.987-2.453 0-4.14 1.626-4.14 4.723v8.525h-2.637V10h2.637v2.515c.981-1.81 2.791-2.822 4.845-2.822 3.527 0 5.551 2.423 5.551 6.655m-23.336 9.292c-4.6 0-7.299-3.404-7.299-8.004s2.699-7.943 7.299-7.943c4.57 0 7.237 3.343 7.237 7.943s-2.667 8.004-7.237 8.004m0-13.493c-3.281 0-4.723 2.576-4.723 5.489s1.442 5.55 4.723 5.55c3.251 0 4.661-2.637 4.661-5.55s-1.41-5.49-4.661-5.49zm-13.488-6.195c0-1.165.767-1.84 1.84-1.84 1.074 0 1.84.675 1.84 1.84s-.766 1.84-1.84 1.84c-1.073 0-1.84-.675-1.84-1.84m.491 19.381V10h2.637v15.333zm-7.461-4.753c0 1.35.797 2.27 2.422 2.27.614 0 1.196-.123 1.656-.215v2.545a6.3 6.3 0 0 1-1.778.245c-3.282 0-4.876-1.932-4.876-4.784v-8.188h-2.484V10h2.484V6.75h2.576V10h4.078v2.453h-4.078zm-18.943-2.913c0 3.68 1.472 5.52 4.202 5.52 2.361 0 4.477-1.503 4.477-4.907v-1.227c0-3.404-1.932-4.906-4.171-4.906-2.974 0-4.508 1.962-4.508 5.52m8.679 7.666v-2.76c-.981 2.024-2.821 3.067-5.183 3.067-4.078 0-6.133-3.465-6.133-7.973 0-4.324 2.147-7.974 6.44-7.974 2.239 0 3.956 1.012 4.876 3.006V10h2.637v15.333zm-17.793-9.046v9.046h-2.576V10h2.576v2.699c.89-1.81 2.423-3.098 5.428-2.914v2.576c-3.373-.337-5.428.675-5.428 3.926m-10.037 4.293c0 1.35.797 2.27 2.423 2.27.613 0 1.196-.123 1.656-.215v2.545c-.46.123-.982.245-1.779.245-3.281 0-4.876-1.932-4.876-4.784v-8.188h-2.484V10h2.484V6.75h2.576V10h4.079v2.453h-4.079zm-6.696.583c0 2.545-1.656 4.477-5.765 4.477-2.3 0-4.171-.521-5.336-1.135v-2.79c1.319.766 3.527 1.502 5.459 1.502 2.024 0 3.066-.828 3.066-2.024 0-1.165-.889-1.84-3.802-2.545-3.404-.828-4.846-2.147-4.846-4.661 0-2.668 2.055-4.294 5.551-4.294 1.993 0 3.803.491 4.937 1.104v2.73c-1.84-.92-3.342-1.411-4.968-1.411-1.932 0-2.974.675-2.974 1.87 0 1.074.736 1.749 3.557 2.423 3.404.828 5.121 2.086 5.121 4.754M297.497 5.952c0-1.165.767-1.84 1.84-1.84 1.074 0 1.84.675 1.84 1.84s-.766 1.84-1.84 1.84c-1.073 0-1.84-.675-1.84-1.84m.491 19.381V10h2.637v15.333zm-3.678-8.985v8.985h-2.637v-9.261c0-2.76-1.104-3.987-3.619-3.987-2.453 0-4.14 1.626-4.14 4.723v8.525h-2.637V10h2.637v2.515c.982-1.81 2.791-2.822 4.846-2.822 3.526 0 5.55 2.423 5.55 6.655M274.168 5.952c0-1.165.766-1.84 1.84-1.84 1.073 0 1.84.675 1.84 1.84s-.767 1.84-1.84 1.84c-1.074 0-1.84-.675-1.84-1.84m.49 19.381V10h2.638v15.333zm-14.069-8.525v8.525h-2.637v-9.261c0-2.76-1.104-3.987-3.619-3.987-2.453 0-4.14 1.626-4.14 4.723v8.525h-2.637V10h2.637v2.515c.981-1.81 2.791-2.822 4.845-2.822 2.607 0 4.386 1.319 5.152 3.742.859-2.362 2.914-3.742 5.459-3.742 3.435 0 5.336 2.331 5.336 6.655v8.985h-2.637v-8.525c0-3.159-1.104-4.723-3.619-4.723-2.453 0-4.14 1.626-4.14 4.723m-28.327.859c0 3.68 1.472 5.52 4.202 5.52 2.361 0 4.477-1.503 4.477-4.907v-1.227c0-3.404-1.932-4.906-4.171-4.906-2.974 0-4.508 1.962-4.508 5.52m8.679 7.666v-2.76c-.981 2.024-2.821 3.067-5.183 3.067-4.078 0-6.133-3.465-6.133-7.973 0-4.324 2.147-7.974 6.44-7.974 2.239 0 3.956 1.012 4.876 3.006V3.59h2.637v21.742zm-22.021-4.017c-1.533 0-3.097-.184-4.814-.521l-1.687 4.538h-3.097l7.942-20.148h3.496l7.943 20.148h-3.097l-1.687-4.569c-1.809.368-3.373.552-4.999.552m0-2.453c1.288 0 2.607-.154 4.171-.399l-4.079-11.04-4.078 11.07c1.502.246 2.76.369 3.986.369"
        fill="${colors.textColor}"
      />
      <path
        d="M107.447 10.828c0 2.972 1.345 5.308 6.795 6.37 3.185.707 3.893 1.203 3.893 2.264 0 1.062-.708 1.699-2.973 1.699-2.619 0-5.733-.92-7.785-2.123v4.812c1.627.779 3.751 1.699 7.785 1.699 5.662 0 7.856-2.548 7.856-6.228m0 .07c0-3.538-1.84-5.166-7.148-6.299-2.902-.637-3.61-1.274-3.61-2.194 0-1.132 1.062-1.628 2.973-1.628 2.335 0 4.6.708 6.794 1.7V6.368c-1.557-.779-3.892-1.345-6.653-1.345-5.237 0-7.927 2.265-7.927 5.945m72.475-5.803v20.172h4.318V9.978l1.769 4.034 6.087 11.325h5.379V5.165h-4.247v13.023l-1.628-3.822-4.883-9.2zm-27.319 0h-4.671v20.172h4.671zm-10.05 14.155c0-3.538-1.841-5.166-7.149-6.298-2.902-.637-3.609-1.274-3.609-2.194 0-1.133 1.061-1.628 2.972-1.628 2.336 0 4.601.707 6.795 1.698v-4.6c-1.557-.779-3.893-1.345-6.653-1.345-5.238 0-7.927 2.265-7.927 5.945 0 2.973 1.345 5.309 6.794 6.37 3.185.708 3.893 1.203 3.893 2.265s-.708 1.699-2.973 1.699c-2.618 0-5.733-.92-7.785-2.124v4.813c1.628.779 3.751 1.699 7.785 1.699 5.592 0 7.857-2.548 7.857-6.3M71.069 5.165v20.172h9.625l1.486-4.389h-6.44V5.165zm-19.039 0v4.318h5.167v15.854h4.741V9.483h5.592V5.165zm-6.866 0h-6.157L32 25.336h5.379l.99-3.397c1.204.354 2.478.566 3.752.566s2.548-.212 3.751-.566l.991 3.397h5.379c-.07 0-7.078-20.17-7.078-20.17zM42.05 18.26c-.92 0-1.77-.142-2.548-.354L42.05 9.13l2.548 8.776a9.6 9.6 0 0 1-2.548.354M97.326 5.165H91.17l-7.08 20.171h5.38l.99-3.397c1.203.354 2.477.566 3.751.566s2.548-.212 3.751-.566l.991 3.397h5.379zM94.212 18.26c-.92 0-1.77-.142-2.548-.354l2.548-8.776 2.548 8.776a9.6 9.6 0 0 1-2.548.354m75.306-13.095h-6.157l-7.007 20.171h5.379l.991-3.397c1.203.354 2.477.566 3.751.566s2.548-.212 3.751-.566l.991 3.397h5.379zm-3.043 13.094c-.92 0-1.77-.142-2.548-.354l2.548-8.776 2.548 8.776a10 10 0 0 1-2.548.354M22.878 24.378 12.293 3.208c-.208-.458-.416-.541-.666-.541-.209 0-.459.083-.709.5-1.5 2.375-2.167 5.125-2.167 8 0 4.001 2.042 7.752 5.043 13.794.333.667.583.792 1.166.792h7.335c.542 0 .833-.208.833-.625 0-.208-.041-.333-.25-.75M7.501 14.377c-.833-1.25-1.083-1.334-1.292-1.334s-.333.083-.708.834L.208 24.46c-.166.334-.208.459-.208.625 0 .334.292.667.917.667h7.46c.5 0 .874-.416 1.083-1.208.25-1 .333-1.876.333-2.917 0-2.917-1.292-5.751-2.292-7.251z"
        fill="${colors.iconColor}"
      />
    </svg>`;
};
const AtlassianAdministrationLogo = ({ appearance, label = 'Atlassian Administration', size = (0, _constants.defaultLogoParams).size, testId, textColor = (0, _constants.defaultLogoParams).textColor, iconColor = (0, _constants.defaultLogoParams).iconColor })=>{
    const { colorMode } = (0, _useThemeObserver.useThemeObserver)();
    return /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _wrapperDefault.default), {
        appearance: appearance,
        iconColor: iconColor,
        label: label,
        size: size,
        svg: svg({
            appearance,
            iconColor,
            textColor
        }, colorMode),
        testId: testId,
        textColor: textColor
    });
};

},{"react":"ltHCL","@atlaskit/tokens/use-theme-observer":"4S775","../../constants":"kYpRl","../../wrapper":"9ojnE","../get-colors-from-appearance":"jcOxk","@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"1XjmU":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "AtlassianAnalyticsIcon", ()=>(0, _icon.AtlassianAnalyticsIcon));
parcelHelpers.export(exports, "AtlassianAnalyticsLogo", ()=>(0, _logo.AtlassianAnalyticsLogo));
var _icon = require("./icon");
var _logo = require("./logo");

},{"./icon":"8Siil","./logo":"aqvWS","@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"8Siil":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "AtlassianAnalyticsIcon", ()=>AtlassianAnalyticsIcon);
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _useId = require("@atlaskit/ds-lib/use-id");
var _useThemeObserver = require("@atlaskit/tokens/use-theme-observer");
var _constants = require("../../constants");
var _wrapper = require("../../wrapper");
var _wrapperDefault = parcelHelpers.interopDefault(_wrapper);
var _getColorsFromAppearanceOldLogos = require("../get-colors-from-appearance-old-logos");
const svg = ({ appearance, iconColor }, colorMode, id)=>{
    let colors = {
        iconGradientStart: iconColor,
        iconGradientStop: iconColor,
        iconColor
    };
    if (appearance) colors = (0, _getColorsFromAppearanceOldLogos.getColorsFromAppearanceOldLogos)(appearance, colorMode);
    return `<svg height="32" viewBox="0 0 48 48" xmlns="http://www.w3.org/2000/svg">
  <defs>
    <linearGradient id="${id}-a" x1="12.595" x2="12.595" y1="40" y2="30" gradientUnits="userSpaceOnUse">
      <stop offset="0" stop-color="${colors.iconGradientStart}"/>
      <stop offset="1" stop-color="${colors.iconGradientStop}"/>
    </linearGradient>
    <linearGradient id="${id}-b" x1="28.595" x2="28.595" y1="40" y2="27" gradientUnits="userSpaceOnUse">
      <stop offset="0" stop-color="${colors.iconGradientStart}"/>
      <stop offset="1" stop-color="${colors.iconGradientStop}"/>
    </linearGradient>
    <linearGradient xlink:href="#${id}-b" id="${id}-c" x1="20.595" x2="20.595" y2="22"/>
    <linearGradient xlink:href="#${id}-b" id="${id}-d" x1="36.595" x2="36.595" y2="20"/>
  </defs>
  <path d="M10.595 30h4v10h-4z" fill="url(#${id}-a)"/>
  <path d="M26.595 27h4v13h-4z" fill="url(#${id}-b)"/>
  <path d="M18.595 22h4v18h-4z" fill="url(#${id}-c)"/>
  <path d="M34.595 20h4v20h-4z" fill="url(#${id}-d)"/>
  <path fill="${colors.iconColor}" d="m9.009 25.414-2.828-2.828 10.127-10.128a5 5 0 0 1 6.605-.411l4.471 3.477a1.5 1.5 0 0 0 1.982-.123l9.815-9.815 2.828 2.828-10.127 10.128a5 5 0 0 1-6.605.411l-4.471-3.477a1.5 1.5 0 0 0-1.982.123l-9.815 9.815Z" />
</svg>`;
};
const AtlassianAnalyticsIcon = ({ appearance, label = 'Atlassian Analytics', size = (0, _constants.defaultLogoParams).size, iconColor = (0, _constants.defaultLogoParams).iconColor, textColor = (0, _constants.defaultLogoParams).textColor, testId })=>{
    const { colorMode } = (0, _useThemeObserver.useThemeObserver)();
    const id = (0, _useId.useId)();
    return /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _wrapperDefault.default), {
        appearance: appearance,
        label: label,
        svg: svg({
            appearance,
            iconColor
        }, colorMode, id),
        iconColor: iconColor,
        textColor: textColor,
        size: size,
        testId: testId
    });
};

},{"react":"ltHCL","@atlaskit/ds-lib/use-id":"9jWCD","@atlaskit/tokens/use-theme-observer":"4S775","../../constants":"kYpRl","../../wrapper":"9ojnE","../get-colors-from-appearance-old-logos":"10zPy","@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"10zPy":[function(require,module,exports,__globalThis) {
// TODO: This is where we need to add tokens for all appearance color values
var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "getColorsFromAppearanceOldLogos", ()=>getColorsFromAppearanceOldLogos);
const getColorsFromAppearanceOldLogos = (appearance, colorMode)=>{
    let iconGradientStart, iconGradientStop, iconColor, textColor, atlassianLogoTextColor;
    switch(appearance){
        case 'brand':
            iconGradientStart = '#0052CC';
            iconGradientStop = '#2684FF';
            iconColor = '#2684FF';
            textColor = "var(--ds-text, #292A2E)";
            // This is only used for the top level Atlassian wordmark (see AtlassianLogo
            // or AtlassianStartLogo for example), and is only different for the Brand
            // appearance - a bold brand color. For other appearances,
            // atlassianLogoTextColor is the same as textColor.
            atlassianLogoTextColor = '#0052CC';
            break;
        case 'neutral':
            iconGradientStart = '#344563';
            iconGradientStop = '#7A869A';
            iconColor = '#7A869A';
            textColor = '#505F79';
            atlassianLogoTextColor = '#505F79';
            break;
        case 'inverse':
            iconGradientStart = '#FFFFFF66';
            iconGradientStop = '#FFFFFF';
            iconColor = '#FFFFFF';
            textColor = '#FFFFFF';
            atlassianLogoTextColor = '#FFFFFF';
            break;
    }
    if (colorMode === 'dark' && appearance === 'inverse') {
        iconGradientStart = '#161A1D66';
        iconGradientStop = '#161A1D';
        iconColor = '#161A1D';
        textColor = '#161A1D';
        atlassianLogoTextColor = '#161A1D';
    }
    return {
        iconGradientStart,
        iconGradientStop,
        iconColor,
        textColor,
        atlassianLogoTextColor
    };
};

},{"@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"aqvWS":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "AtlassianAnalyticsLogo", ()=>AtlassianAnalyticsLogo);
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _useId = require("@atlaskit/ds-lib/use-id");
var _useThemeObserver = require("@atlaskit/tokens/use-theme-observer");
var _constants = require("../../constants");
var _wrapper = require("../../wrapper");
var _wrapperDefault = parcelHelpers.interopDefault(_wrapper);
var _getColorsFromAppearanceOldLogos = require("../get-colors-from-appearance-old-logos");
const svg = ({ appearance, iconColor, textColor }, colorMode, id)=>{
    let colors = {
        iconGradientStart: iconColor,
        iconGradientStop: iconColor,
        textColor,
        iconColor,
        // We treat the word "Atlassian" differently to normal app logos, it has a bold brand look
        atlassianLogoTextColor: textColor
    };
    if (appearance) colors = (0, _getColorsFromAppearanceOldLogos.getColorsFromAppearanceOldLogos)(appearance, colorMode);
    return `
  <svg height="32" viewBox="0 0 477 48" xmlns="http://www.w3.org/2000/svg">
  <defs>
    <linearGradient id="${id}-a" x1="447.285" x2="447.285" y1="40" y2="30" gradientUnits="userSpaceOnUse">
      <stop offset="0" stop-color="${colors.iconGradientStart}"/>
      <stop offset="1" stop-color="${colors.iconGradientStop}"/>
    </linearGradient>
    <linearGradient xlink:href="#${id}-a" id="${id}-b" x1="463.285" x2="463.285" y2="27"/>
    <linearGradient xlink:href="#${id}-a" id="${id}-c" x1="455.285" x2="455.285" y2="22"/>
    <linearGradient xlink:href="#${id}-a" id="${id}-d" x1="471.285" x2="471.285" y2="20"/>
  </defs>
  <g fill="${colors.atlassianLogoTextColor}">
    <path d="M106.72 18.359c0 4.201 1.949 7.536 9.572 9.008 4.548.953 5.5 1.689 5.5 3.205 0 1.473-.953 2.425-4.158 2.425-3.725 0-8.142-1.256-11.044-2.988v6.843c2.295 1.126 5.327 2.382 10.957 2.382 7.969 0 11.131-3.551 11.131-8.835m0 0c0-4.981-2.642-7.319-10.091-8.922-4.114-.91-5.111-1.819-5.111-3.118 0-1.646 1.473-2.339 4.201-2.339 3.292 0 6.54.996 9.615 2.382v-6.54c-2.166-1.083-5.5-1.949-9.398-1.949-7.363 0-11.174 3.205-11.174 8.445M209.1 10.346v28.455h6.063V17.103l2.556 5.76 8.575 15.938h7.623V10.346h-6.064V28.71l-2.295-5.327-6.886-13.037H209.1zM163.909 10.346h6.626v28.455h-6.626zM156.263 30.399c0-4.981-2.642-7.319-10.091-8.922-4.114-.91-5.111-1.819-5.111-3.118 0-1.646 1.473-2.339 4.201-2.339 3.292 0 6.54.996 9.615 2.382v-6.54c-2.166-1.083-5.5-1.949-9.398-1.949-7.363 0-11.174 3.205-11.174 8.445 0 4.201 1.949 7.536 9.572 9.008 4.548.953 5.5 1.689 5.5 3.205 0 1.473-.953 2.425-4.158 2.425-3.725 0-8.142-1.256-11.044-2.988v6.843c2.295 1.126 5.327 2.382 10.957 2.382 7.969 0 11.131-3.551 11.131-8.835M55.243 10.346v28.455h13.62l2.145-6.15h-9.095V10.346h-6.67zM28.334 10.346v6.15h7.363v22.305h6.67V16.496h7.882v-6.15H28.334zM18.663 10.346h-8.74L0 38.801h7.579l1.407-4.792a18.852 18.852 0 0 0 10.612 0l1.407 4.792h7.579l-9.922-28.455Zm-4.37 18.533c-1.267 0-2.49-.185-3.647-.524l3.647-12.422 3.647 12.422c-1.157.339-2.38.524-3.647.524ZM92.344 10.346h-8.74l-9.922 28.455h7.579l1.407-4.792a18.852 18.852 0 0 0 10.612 0l1.407 4.792h7.579l-9.922-28.455Zm-4.37 18.533c-1.267 0-2.49-.185-3.647-.524l3.647-12.422 3.647 12.422c-1.157.339-2.38.524-3.647.524ZM194.414 10.346h-8.74l-9.922 28.455h7.579l1.407-4.792a18.852 18.852 0 0 0 10.612 0l1.407 4.792h7.579l-9.922-28.455Zm-4.37 18.533c-1.267 0-2.49-.185-3.647-.524l3.647-12.422 3.647 12.422c-1.157.339-2.38.524-3.647.524Z"/>
  </g>
  <g fill="${colors.textColor}">
    <path d="m254.776 31.987-2.53 6.809H247.6l11.916-30.225h5.244l11.916 30.225h-4.646l-2.53-6.855c-2.714.552-5.061.828-7.499.828-2.3 0-4.646-.276-7.223-.782Zm13.479-3.496-6.119-16.562-6.119 16.608c2.254.368 4.141.552 5.98.552 1.933 0 3.911-.23 6.257-.598ZM298.984 38.796h-3.957V24.902c0-4.141-1.656-5.981-5.428-5.981-3.681 0-6.211 2.438-6.211 7.085v12.79h-3.957V15.794h3.957v3.772c1.472-2.715 4.187-4.232 7.269-4.232 5.291 0 8.327 3.634 8.327 9.983v13.479ZM320.097 34.656c-1.472 3.036-4.232 4.6-7.775 4.6-6.119 0-9.201-5.199-9.201-11.961 0-6.486 3.22-11.961 9.661-11.961 3.358 0 5.935 1.518 7.314 4.508v-4.048h3.957v23.002h-3.957v-4.14Zm-6.717.92c3.542 0 6.717-2.254 6.717-7.361v-1.84c0-5.106-2.898-7.361-6.256-7.361-4.463 0-6.763 2.944-6.763 8.281 0 5.521 2.208 8.281 6.303 8.281ZM336.196 38.935c-3.772 0-6.165-1.794-6.165-6.027V6.179h3.957v26.269c0 2.07 1.38 2.806 3.083 2.806.414 0 .69 0 1.15-.046v3.542c-.322.092-1.012.184-2.024.184ZM347.328 37.324l-8.327-21.53h4.232l7.361 19.69 7.361-19.69h4.232l-8.695 22.267c-2.576 6.579-4.048 9.983-9.891 9.983-1.979 0-3.083-.184-4.232-.644v-3.404c1.334.414 2.852.552 4.002.552 3.22 0 4.646-2.208 6.533-7.223h-2.576ZM374.698 35.07c.92 0 1.794-.185 2.484-.322v3.818c-.69.184-1.472.368-2.668.368-4.923 0-7.315-2.898-7.315-7.177V19.473h-3.727v-3.68h3.727v-4.877h3.864v4.877h6.119v3.68h-6.119v12.191c0 2.024 1.196 3.405 3.635 3.405ZM384.265 6.961c1.61 0 2.76 1.012 2.76 2.76s-1.15 2.76-2.76 2.76-2.76-1.012-2.76-2.76 1.15-2.76 2.76-2.76Zm-2.024 8.833h3.957v23.002h-3.957V15.794ZM408.416 38.198c-1.38.736-3.496 1.058-5.612 1.058-8.189 0-12.007-4.968-12.007-12.007 0-6.947 3.818-11.915 12.007-11.915 2.07 0 3.68.276 5.475 1.104v3.681c-1.472-.69-3.037-1.104-5.199-1.104-5.98 0-8.419 3.772-8.419 8.235s2.484 8.235 8.511 8.235c2.346 0 3.818-.322 5.244-.828v3.542ZM420.144 39.256c-3.451 0-6.257-.782-8.005-1.702v-4.187c1.978 1.15 5.291 2.254 8.188 2.254 3.037 0 4.601-1.242 4.601-3.036 0-1.749-1.334-2.761-5.705-3.818-5.106-1.242-7.269-3.221-7.269-6.993 0-4.002 3.082-6.44 8.327-6.44 2.99 0 5.705.736 7.407 1.656v4.094c-2.76-1.38-5.014-2.117-7.453-2.117-2.898 0-4.462 1.013-4.462 2.807 0 1.61 1.104 2.622 5.336 3.635 5.106 1.242 7.683 3.128 7.683 7.13 0 3.819-2.484 6.717-8.649 6.717Z"/>
  </g>
  <path fill="url(#${id}-a)" d="M445.285 30h4v10h-4z"/>
  <path fill="url(#${id}-b)" d="M461.285 27h4v13h-4z"/>
  <path fill="url(#${id}-c)" d="M453.285 22h4v18h-4z"/>
  <path fill="url(#${id}-d)" d="M469.285 20h4v20h-4z"/>
  <path fill="${colors.iconColor}" d="m443.699 25.414-2.828-2.828 10.127-10.128a5 5 0 0 1 6.605-.411l4.471 3.477a1.5 1.5 0 0 0 1.982-.123l9.815-9.815 2.828 2.828-10.127 10.128a5 5 0 0 1-6.605.411l-4.471-3.477a1.5 1.5 0 0 0-1.982.123l-9.815 9.815Z"/>
</svg>`;
};
const AtlassianAnalyticsLogo = ({ appearance, label = 'Atlassian Analytics', size = (0, _constants.defaultLogoParams).size, testId, iconColor = (0, _constants.defaultLogoParams).iconColor, textColor = (0, _constants.defaultLogoParams).textColor })=>{
    const { colorMode } = (0, _useThemeObserver.useThemeObserver)();
    const id = (0, _useId.useId)();
    return /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _wrapperDefault.default), {
        appearance: appearance,
        label: label,
        size: size,
        iconColor: iconColor,
        svg: svg({
            appearance,
            iconColor,
            textColor
        }, colorMode, id),
        testId: testId,
        textColor: textColor
    });
};

},{"react":"ltHCL","@atlaskit/ds-lib/use-id":"9jWCD","@atlaskit/tokens/use-theme-observer":"4S775","../../constants":"kYpRl","../../wrapper":"9ojnE","../get-colors-from-appearance-old-logos":"10zPy","@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"4lMQq":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "BitbucketIcon", ()=>(0, _icon.BitbucketIcon));
parcelHelpers.export(exports, "BitbucketLogo", ()=>(0, _logo.BitbucketLogo));
var _icon = require("./icon");
var _logo = require("./logo");

},{"./icon":"dZADS","./logo":"2GJHy","@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"dZADS":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "BitbucketIcon", ()=>BitbucketIcon);
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _useThemeObserver = require("@atlaskit/tokens/use-theme-observer");
var _constants = require("../../constants");
var _wrapper = require("../../wrapper");
var _wrapperDefault = parcelHelpers.interopDefault(_wrapper);
var _getColorsFromAppearance = require("../get-colors-from-appearance");
const svg = ({ appearance, iconColor }, colorMode)=>{
    let colors = {
        iconColor
    };
    if (appearance) colors = (0, _getColorsFromAppearance.getColorsFromAppearance)(appearance, colorMode);
    return `<svg fill="none" height="32" viewBox="0 0 32 32" focusable="false" aria-hidden="true" xmlns="http://www.w3.org/2000/svg">
      <path fill=${colors.iconColor} d="m25.586 15.819-1.618 9.885c-.106.598-.528.95-1.126.95H9.122c-.598 0-1.02-.352-1.126-.95L5.146 8.08c-.105-.598.212-.985.775-.985h20.123c.562 0 .88.387.773.985l-.773 4.644c-.106.668-.493.95-1.126.95H12.816c-.176 0-.282.105-.246.316l.95 5.84c.035.14.14.246.281.246h4.362c.141 0 .246-.105.282-.246l.668-4.222c.07-.527.422-.738.915-.738h4.75c.703 0 .914.351.808.95"/>
    </svg>`;
};
const BitbucketIcon = ({ appearance, label = 'Bitbucket', size = (0, _constants.defaultLogoParams).size, testId, iconColor = (0, _constants.defaultLogoParams).iconColor, textColor = (0, _constants.defaultLogoParams).textColor })=>{
    const { colorMode } = (0, _useThemeObserver.useThemeObserver)();
    return /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _wrapperDefault.default), {
        appearance: appearance,
        label: label,
        svg: svg({
            appearance,
            iconColor
        }, colorMode),
        iconColor: iconColor,
        size: size,
        testId: testId,
        textColor: textColor
    });
};

},{"react":"ltHCL","@atlaskit/tokens/use-theme-observer":"4S775","../../constants":"kYpRl","../../wrapper":"9ojnE","../get-colors-from-appearance":"jcOxk","@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"2GJHy":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "BitbucketLogo", ()=>BitbucketLogo);
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _useThemeObserver = require("@atlaskit/tokens/use-theme-observer");
var _constants = require("../../constants");
var _wrapper = require("../../wrapper");
var _wrapperDefault = parcelHelpers.interopDefault(_wrapper);
var _getColorsFromAppearance = require("../get-colors-from-appearance");
const svg = ({ appearance, iconColor, textColor }, colorMode)=>{
    let colors = {
        iconColor,
        textColor
    };
    if (appearance) colors = (0, _getColorsFromAppearance.getColorsFromAppearance)(appearance, colorMode);
    return `<svg fill="none" height="32" viewBox="0 0 158 32" focusable="false" aria-hidden="true" xmlns="http://www.w3.org/2000/svg">
        <path fill=${colors.iconColor} d="m20.46 15.152-1.619 9.885c-.105.598-.527.95-1.125.95H3.996c-.599 0-1.02-.352-1.126-.95L.02 7.412c-.105-.598.211-.985.774-.985h20.123c.563 0 .88.387.774.985l-.774 4.644c-.106.668-.493.95-1.126.95H7.69c-.176 0-.281.105-.246.316l.95 5.84c.035.141.14.247.281.247h4.363c.14 0 .246-.106.281-.247l.668-4.221c.07-.528.423-.739.915-.739h4.75c.703 0 .914.352.809.95"/>
        <path fill=${colors.textColor} d="M153.212 20.787c0 1.35.797 2.27 2.422 2.27.614 0 1.196-.123 1.656-.215v2.545c-.46.123-.981.245-1.778.245-3.282 0-4.876-1.932-4.876-4.784v-8.187h-2.484v-2.454h2.484v-3.25h2.576v3.25h4.078v2.453h-4.078zm-13.537-8.494c-2.791 0-4.201 1.809-4.477 4.477h8.556c-.154-2.852-1.442-4.477-4.079-4.477m5.888 12.634c-1.257.675-3.189.92-4.753.92-5.735 0-8.25-3.312-8.25-8.004 0-4.63 2.576-7.942 7.238-7.942 4.722 0 6.624 3.281 6.624 7.942v1.196h-11.194c.368 2.607 2.055 4.294 5.674 4.294 1.778 0 3.281-.338 4.661-.828zm-23.82.613h-2.638V3.799h2.638v13.585l6.593-7.176h3.435l-7.207 7.544 7.513 7.79h-3.588l-6.746-7.176zm-5.648-2.76v2.362c-.92.49-2.331.705-3.742.705-5.458 0-8.004-3.312-8.004-8.004 0-4.63 2.546-7.942 8.004-7.942 1.38 0 2.454.184 3.65.736v2.453c-.982-.46-2.024-.736-3.466-.736-3.986 0-5.612 2.515-5.612 5.49s1.656 5.489 5.674 5.489c1.564 0 2.545-.215 3.496-.552m-27.843-3.588v-8.986h2.637v9.262c0 2.76 1.104 3.986 3.619 3.986 2.453 0 4.14-1.625 4.14-4.722v-8.526h2.637v15.334h-2.637v-2.515c-.982 1.81-2.79 2.821-4.846 2.821-3.526 0-5.55-2.422-5.55-6.654m-5.388-1.319c0-3.68-1.472-5.52-4.201-5.52-2.362 0-4.478 1.503-4.478 4.907v1.226c0 3.404 1.932 4.907 4.171 4.907 2.975 0 4.508-1.963 4.508-5.52m-3.803 7.973c-2.238 0-3.956-1.012-4.876-3.005v2.699h-2.637V3.798h2.637v9.17c.982-2.025 2.822-3.067 5.183-3.067 4.079 0 6.133 3.465 6.133 7.973 0 4.324-2.146 7.973-6.44 7.973m-14.974-5.06c0 1.35.797 2.27 2.422 2.27.614 0 1.196-.123 1.656-.215v2.545a6.3 6.3 0 0 1-1.778.245c-3.282 0-4.876-1.932-4.876-4.784v-8.187h-2.484v-2.454h2.484v-3.25h2.576v3.25h4.078v2.453h-4.078zM53.328 6.16c0-1.166.767-1.84 1.84-1.84s1.84.674 1.84 1.84S56.242 8 55.168 8s-1.84-.676-1.84-1.84m.49 19.38V10.207h2.638V25.54zm-9.828-9.046h-6.194v6.287h6.256c2.637 0 3.833-.951 3.833-2.975 0-2.147-1.134-3.312-3.894-3.312m-.889-8.464h-5.305v6.01h5.305c2.607 0 3.68-1.195 3.68-3.127 0-1.963-1.165-2.883-3.68-2.883m-8.065 17.51V5.394h8.433c4.11 0 6.103 2.024 6.103 5.274 0 2.423-1.104 3.926-3.373 4.478 2.974.49 4.446 2.116 4.446 4.968 0 3.22-2.177 5.428-6.685 5.428z"/>
      </svg>`;
};
const BitbucketLogo = ({ appearance, label = 'Bitbucket', size = (0, _constants.defaultLogoParams).size, testId, iconColor = (0, _constants.defaultLogoParams).iconColor, textColor = (0, _constants.defaultLogoParams).textColor })=>{
    const { colorMode } = (0, _useThemeObserver.useThemeObserver)();
    return /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _wrapperDefault.default), {
        appearance: appearance,
        label: label,
        iconColor: iconColor,
        size: size,
        svg: svg({
            appearance,
            iconColor,
            textColor
        }, colorMode),
        testId: testId,
        textColor: textColor
    });
};

},{"react":"ltHCL","@atlaskit/tokens/use-theme-observer":"4S775","../../constants":"kYpRl","../../wrapper":"9ojnE","../get-colors-from-appearance":"jcOxk","@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"c0M48":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "CompassIcon", ()=>(0, _icon.CompassIcon));
parcelHelpers.export(exports, "CompassLogo", ()=>(0, _logo.CompassLogo));
var _icon = require("./icon");
var _logo = require("./logo");

},{"./icon":"181bl","./logo":"6iHP4","@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"181bl":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "CompassIcon", ()=>CompassIcon);
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _useThemeObserver = require("@atlaskit/tokens/use-theme-observer");
var _constants = require("../../constants");
var _wrapper = require("../../wrapper");
var _wrapperDefault = parcelHelpers.interopDefault(_wrapper);
var _getColorsFromAppearance = require("../get-colors-from-appearance");
const svg = ({ appearance, iconColor }, colorMode)=>{
    let colors = {
        iconColor
    };
    if (appearance) colors = (0, _getColorsFromAppearance.getColorsFromAppearance)(appearance, colorMode);
    return `<svg fill="none" height="32" viewBox="0 0 32 32" focusable="false" aria-hidden="true" xmlns="http://www.w3.org/2000/svg">
      <path fill="${colors.iconColor}" d="M15.667 15.66v5.942H9.713V15.66zV9.722H4.807c-.58.004-1.047.47-1.043 1.04v15.755a1.04 1.04 0 0 0 1.028 1.054h15.771a1.04 1.04 0 0 0 1.042-1.04V15.66zm0-11.88v5.942h5.967v5.938h5.935V4.82a1.04 1.04 0 0 0-1.028-1.053h-.014z"/>
      </svg>
    `;
};
const CompassIcon = ({ appearance, label = 'Compass', size = (0, _constants.defaultLogoParams).size, testId, iconColor = (0, _constants.defaultLogoParams).iconColor, textColor = (0, _constants.defaultLogoParams).textColor })=>{
    const { colorMode } = (0, _useThemeObserver.useThemeObserver)();
    return /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _wrapperDefault.default), {
        appearance: appearance,
        label: label,
        svg: svg({
            appearance,
            iconColor
        }, colorMode),
        iconColor: iconColor,
        size: size,
        testId: testId,
        textColor: textColor
    });
};

},{"react":"ltHCL","@atlaskit/tokens/use-theme-observer":"4S775","../../constants":"kYpRl","../../wrapper":"9ojnE","../get-colors-from-appearance":"jcOxk","@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"6iHP4":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "CompassLogo", ()=>CompassLogo);
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _useThemeObserver = require("@atlaskit/tokens/use-theme-observer");
var _constants = require("../../constants");
var _wrapper = require("../../wrapper");
var _wrapperDefault = parcelHelpers.interopDefault(_wrapper);
var _getColorsFromAppearance = require("../get-colors-from-appearance");
const svg = ({ appearance, iconColor, textColor }, colorMode)=>{
    let colors = {
        iconColor,
        textColor
    };
    if (appearance) colors = (0, _getColorsFromAppearance.getColorsFromAppearance)(appearance, colorMode);
    return `<svg fill="none" height="32" viewBox="0 0 155 32" focusable="false" aria-hidden="true" xmlns="http://www.w3.org/2000/svg">
    <path fill=${colors.iconColor} d="M11.903 14.993v5.942H5.95v-5.942zV9.055H1.043c-.58.004-1.047.47-1.043 1.04v15.756a1.04 1.04 0 0 0 1.028 1.054H16.8a1.04 1.04 0 0 0 1.043-1.04V14.993zm0-11.879v5.941h5.967v5.938h5.936V4.153A1.04 1.04 0 0 0 22.778 3.1h-.015z"/>
    <path fill="${colors.textColor}" d="M154.46 21.37c0 2.545-1.656 4.477-5.765 4.477-2.3 0-4.171-.521-5.336-1.134v-2.791c1.318.767 3.526 1.503 5.458 1.503 2.024 0 3.067-.828 3.067-2.024 0-1.166-.889-1.84-3.803-2.546-3.404-.828-4.845-2.146-4.845-4.661 0-2.668 2.055-4.293 5.551-4.293 1.993 0 3.802.49 4.937 1.104v2.729c-1.84-.92-3.343-1.41-4.968-1.41-1.932 0-2.975.674-2.975 1.87 0 1.073.736 1.748 3.558 2.423 3.404.828 5.121 2.085 5.121 4.753m-13.626 0c0 2.545-1.656 4.477-5.766 4.477-2.3 0-4.17-.521-5.336-1.134v-2.791c1.319.767 3.527 1.503 5.459 1.503 2.024 0 3.067-.828 3.067-2.024 0-1.166-.89-1.84-3.803-2.546-3.404-.828-4.845-2.146-4.845-4.661 0-2.668 2.054-4.293 5.55-4.293 1.994 0 3.803.49 4.938 1.104v2.729c-1.84-.92-3.343-1.41-4.968-1.41-1.932 0-2.975.674-2.975 1.87 0 1.073.736 1.748 3.557 2.423 3.404.828 5.122 2.085 5.122 4.753m-25.873-3.496c0 3.68 1.472 5.52 4.201 5.52 2.361 0 4.477-1.503 4.477-4.907v-1.226c0-3.404-1.932-4.907-4.17-4.907-2.975 0-4.508 1.963-4.508 5.52m8.678 7.667v-2.76c-.981 2.024-2.821 3.066-5.182 3.066-4.079 0-6.134-3.465-6.134-7.973 0-4.324 2.147-7.973 6.44-7.973 2.239 0 3.956 1.012 4.876 3.005v-2.699h2.638v15.334zm-16.09-7.667c0-3.68-1.472-5.52-4.201-5.52-2.362 0-4.478 1.503-4.478 4.907v1.226c0 3.404 1.932 4.907 4.171 4.907 2.975 0 4.508-1.963 4.508-5.52m-3.803 7.973c-2.238 0-3.956-1.012-4.876-3.005v8.679h-2.637V10.207h2.637v2.76c.982-2.024 2.822-3.066 5.183-3.066 4.079 0 6.133 3.465 6.133 7.973 0 4.324-2.146 7.973-6.44 7.973m-21.583-8.832v8.526h-2.637v-9.262c0-2.76-1.104-3.986-3.619-3.986-2.453 0-4.14 1.625-4.14 4.722v8.526H69.13V10.207h2.637v2.515c.982-1.81 2.791-2.821 4.846-2.821 2.606 0 4.385 1.318 5.152 3.741.858-2.361 2.913-3.741 5.458-3.741 3.435 0 5.336 2.33 5.336 6.654v8.986h-2.637v-8.526c0-3.158-1.104-4.722-3.619-4.722-2.453 0-4.14 1.625-4.14 4.722m-23.335 8.832c-4.6 0-7.299-3.404-7.299-8.004s2.699-7.942 7.299-7.942c4.57 0 7.237 3.342 7.237 7.942s-2.668 8.004-7.237 8.004m0-13.493c-3.282 0-4.723 2.576-4.723 5.49s1.441 5.55 4.723 5.55c3.25 0 4.661-2.637 4.661-5.55s-1.41-5.49-4.661-5.49m-9.233 9.629v2.668c-1.258.828-3.251 1.196-5.336 1.196-6.624 0-10.366-3.986-10.366-10.334 0-6.134 3.742-10.427 10.304-10.427 1.963 0 3.926.368 5.367 1.41v2.669c-1.441-.92-3.036-1.411-5.367-1.411-4.722 0-7.544 3.128-7.544 7.759s2.914 7.697 7.698 7.697c2.116 0 3.772-.49 5.244-1.227"/>
  </svg>`;
};
const CompassLogo = ({ appearance, label = 'Compass', size = (0, _constants.defaultLogoParams).size, testId, iconColor = (0, _constants.defaultLogoParams).iconColor, textColor = (0, _constants.defaultLogoParams).textColor })=>{
    const { colorMode } = (0, _useThemeObserver.useThemeObserver)();
    return /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _wrapperDefault.default), {
        appearance: appearance,
        label: label,
        iconColor: iconColor,
        size: size,
        svg: svg({
            appearance,
            iconColor,
            textColor
        }, colorMode),
        testId: testId,
        textColor: textColor
    });
};

},{"react":"ltHCL","@atlaskit/tokens/use-theme-observer":"4S775","../../constants":"kYpRl","../../wrapper":"9ojnE","../get-colors-from-appearance":"jcOxk","@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"b0iVX":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "ConfluenceIcon", ()=>(0, _icon.ConfluenceIcon));
parcelHelpers.export(exports, "ConfluenceLogo", ()=>(0, _logo.ConfluenceLogo));
var _icon = require("./icon");
var _logo = require("./logo");

},{"./icon":"5vAQA","./logo":"fIu6i","@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"5vAQA":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "ConfluenceIcon", ()=>ConfluenceIcon);
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _useThemeObserver = require("@atlaskit/tokens/use-theme-observer");
var _constants = require("../../constants");
var _wrapper = require("../../wrapper");
var _wrapperDefault = parcelHelpers.interopDefault(_wrapper);
var _getColorsFromAppearance = require("../get-colors-from-appearance");
const svg = ({ appearance, iconColor }, colorMode)=>{
    let colors = {
        iconColor
    };
    if (appearance) colors = (0, _getColorsFromAppearance.getColorsFromAppearance)(appearance, colorMode);
    return `<svg fill="none" height="32" viewBox="0 0 32 32" focusable="false" aria-hidden="true" xmlns="http://www.w3.org/2000/svg">
      <path fill="${colors.iconColor}" d="M25.769 20.234c-6.584-3.183-8.507-3.66-11.282-3.66-3.254 0-6.028 1.355-8.507 5.16l-.406.622c-.333.513-.407.696-.407.915s.11.403.517.659l4.18 2.598c.222.146.407.22.592.22.222 0 .37-.11.592-.44l.665-1.024c1.036-1.574 1.96-2.086 3.144-2.086 1.036 0 2.257.293 3.773 1.025l4.365 2.049c.443.22.924.11 1.146-.403l2.071-4.537c.222-.512.074-.842-.444-1.098M6.572 12.22c6.584 3.184 8.507 3.66 11.281 3.66 3.255 0 6.03-1.354 8.507-5.16l.407-.622c.333-.512.407-.695.407-.915s-.11-.402-.518-.658l-4.18-2.598c-.221-.147-.406-.22-.591-.22-.222 0-.37.11-.592.44l-.666 1.024c-1.035 1.573-1.96 2.086-3.144 2.086-1.035 0-2.256-.293-3.772-1.025L9.346 6.183c-.444-.22-.924-.11-1.146.402l-2.072 4.538c-.222.512-.074.841.444 1.098"/>
    </svg>`;
};
const ConfluenceIcon = ({ appearance, label = 'Confluence', size = (0, _constants.defaultLogoParams).size, testId, iconColor = (0, _constants.defaultLogoParams).iconColor, textColor = (0, _constants.defaultLogoParams).textColor })=>{
    const { colorMode } = (0, _useThemeObserver.useThemeObserver)();
    return /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _wrapperDefault.default), {
        appearance: appearance,
        label: label,
        svg: svg({
            appearance,
            iconColor
        }, colorMode),
        iconColor: iconColor,
        size: size,
        testId: testId,
        textColor: textColor
    });
};

},{"react":"ltHCL","@atlaskit/tokens/use-theme-observer":"4S775","../../constants":"kYpRl","../../wrapper":"9ojnE","../get-colors-from-appearance":"jcOxk","@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"fIu6i":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "ConfluenceLogo", ()=>ConfluenceLogo);
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _useThemeObserver = require("@atlaskit/tokens/use-theme-observer");
var _constants = require("../../constants");
var _wrapper = require("../../wrapper");
var _wrapperDefault = parcelHelpers.interopDefault(_wrapper);
var _getColorsFromAppearance = require("../get-colors-from-appearance");
const svg = ({ appearance, iconColor, textColor }, colorMode)=>{
    let colors = {
        iconColor,
        textColor
    };
    if (appearance) colors = (0, _getColorsFromAppearance.getColorsFromAppearance)(appearance, colorMode);
    return `<svg fill="none" height="32" viewBox="0 0 180 32" focusable="false" aria-hidden="true" xmlns="http://www.w3.org/2000/svg">
      <path fill="${colors.iconColor}" d="M20.602 20.234c-6.584-3.183-8.507-3.66-11.281-3.66-3.255 0-6.03 1.355-8.507 5.16l-.407.622c-.333.513-.407.696-.407.915s.111.403.518.659l4.18 2.598c.221.146.406.22.591.22.222 0 .37-.11.592-.44l.666-1.024c1.035-1.574 1.96-2.086 3.144-2.086 1.035 0 2.256.293 3.772 1.025l4.365 2.049c.444.22.925.11 1.146-.403l2.072-4.537c.222-.512.074-.842-.444-1.098M1.406 12.22c6.583 3.184 8.507 3.66 11.28 3.66 3.256 0 6.03-1.354 8.508-5.16l.407-.622c.332-.512.406-.695.406-.915s-.11-.402-.518-.658L17.31 5.927c-.222-.147-.407-.22-.592-.22-.222 0-.37.11-.592.44l-.665 1.024c-1.036 1.573-1.96 2.086-3.144 2.086-1.036 0-2.257-.293-3.773-1.025L4.18 6.183c-.444-.22-.925-.11-1.147.402L.962 11.123c-.222.512-.074.841.444 1.098"/>
      <path fill="${colors.textColor}" d="M172.49 12.293c-2.791 0-4.201 1.809-4.477 4.477h8.556c-.154-2.852-1.442-4.477-4.079-4.477m5.888 12.634c-1.257.675-3.189.92-4.753.92-5.735 0-8.25-3.312-8.25-8.004 0-4.63 2.576-7.942 7.238-7.942 4.722 0 6.624 3.281 6.624 7.942v1.196h-11.194c.368 2.607 2.055 4.294 5.674 4.294 1.778 0 3.281-.338 4.661-.828zm-15.093-2.147v2.362c-.92.49-2.331.705-3.742.705-5.458 0-8.004-3.312-8.004-8.004 0-4.63 2.546-7.942 8.004-7.942 1.38 0 2.454.184 3.65.736v2.453c-.982-.46-2.024-.736-3.466-.736-3.986 0-5.612 2.515-5.612 5.49s1.656 5.489 5.674 5.489c1.564 0 2.545-.215 3.496-.552m-14.503-6.226v8.986h-2.637v-9.262c0-2.76-1.104-3.986-3.619-3.986-2.453 0-4.14 1.625-4.14 4.722v8.526h-2.637V10.207h2.637v2.515c.981-1.81 2.791-2.821 4.845-2.821 3.527 0 5.551 2.422 5.551 6.654m-22.921-4.262c-2.79 0-4.201 1.809-4.477 4.477h8.556c-.154-2.852-1.441-4.477-4.079-4.477m5.888 12.634c-1.257.675-3.189.92-4.753.92-5.735 0-8.249-3.312-8.249-8.004 0-4.63 2.576-7.942 7.237-7.942 4.723 0 6.624 3.281 6.624 7.942v1.196h-11.193c.368 2.607 2.054 4.294 5.673 4.294 1.778 0 3.281-.338 4.661-.828zm-29.1-5.734v-8.986h2.637v9.262c0 2.76 1.104 3.986 3.619 3.986 2.453 0 4.14-1.625 4.14-4.722v-8.526h2.637v15.334h-2.637v-2.515c-.981 1.81-2.791 2.821-4.845 2.821-3.527 0-5.551-2.422-5.551-6.654m-2.231 6.317c-.215.061-.674.122-1.35.122-2.514 0-4.108-1.196-4.108-4.017V3.798h2.637v17.51c0 1.38.92 1.871 2.055 1.871.275 0 .459 0 .766-.03zM88.157 8.582v1.625h3.956v2.454h-3.956v12.88h-2.576V12.66h-2.484v-2.454h2.484V8.521c0-2.852 1.595-4.784 4.876-4.784a6.3 6.3 0 0 1 1.779.245v2.423a8.7 8.7 0 0 0-1.656-.154c-1.626 0-2.423.95-2.423 2.33m-7.327 7.974v8.986h-2.637v-9.262c0-2.76-1.104-3.986-3.619-3.986-2.453 0-4.14 1.625-4.14 4.722v8.526h-2.637V10.207h2.637v2.515c.981-1.81 2.79-2.821 4.845-2.821 3.527 0 5.551 2.422 5.551 6.654m-23.336 9.292c-4.6 0-7.298-3.404-7.298-8.004s2.698-7.942 7.298-7.942c4.57 0 7.238 3.342 7.238 7.942s-2.668 8.004-7.238 8.004m0-13.493c-3.28 0-4.722 2.576-4.722 5.49s1.441 5.55 4.722 5.55c3.251 0 4.662-2.637 4.662-5.55s-1.41-5.49-4.662-5.49m-9.233 9.629v2.668c-1.257.828-3.25 1.196-5.336 1.196-6.624 0-10.365-3.986-10.365-10.334 0-6.134 3.741-10.427 10.304-10.427 1.963 0 3.925.368 5.367 1.41v2.669c-1.442-.92-3.036-1.411-5.367-1.411-4.723 0-7.544 3.128-7.544 7.759s2.913 7.697 7.697 7.697c2.116 0 3.772-.49 5.244-1.227"/>
    </svg>
    `;
};
const ConfluenceLogo = ({ appearance, label = 'Confluence', size = (0, _constants.defaultLogoParams).size, testId, iconColor = (0, _constants.defaultLogoParams).iconColor, textColor = (0, _constants.defaultLogoParams).textColor })=>{
    const { colorMode } = (0, _useThemeObserver.useThemeObserver)();
    return /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _wrapperDefault.default), {
        appearance: appearance,
        label: label,
        iconColor: iconColor,
        size: size,
        svg: svg({
            appearance,
            iconColor,
            textColor
        }, colorMode),
        testId: testId,
        textColor: textColor
    });
};

},{"react":"ltHCL","@atlaskit/tokens/use-theme-observer":"4S775","../../constants":"kYpRl","../../wrapper":"9ojnE","../get-colors-from-appearance":"jcOxk","@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"1rGcg":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "FocusIcon", ()=>(0, _icon.FocusIcon));
parcelHelpers.export(exports, "FocusLogo", ()=>(0, _logo.FocusLogo));
var _icon = require("./icon");
var _logo = require("./logo");

},{"./icon":"bNYKw","./logo":"6nmzo","@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"bNYKw":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "FocusIcon", ()=>FocusIcon);
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _useThemeObserver = require("@atlaskit/tokens/use-theme-observer");
var _constants = require("../../constants");
var _wrapper = require("../../wrapper");
var _wrapperDefault = parcelHelpers.interopDefault(_wrapper);
var _getColorsFromAppearance = require("../get-colors-from-appearance");
const svg = ({ appearance, iconColor }, colorMode)=>{
    let colors = {
        iconColor
    };
    if (appearance) colors = (0, _getColorsFromAppearance.getColorsFromAppearance)(appearance, colorMode);
    return `<svg fill="none" height="32" viewBox="0 0 48 48" focusable="false" aria-hidden="true" xmlns="http://www.w3.org/2000/svg">
		<path fill="${colors.iconColor}" d="M45.4277 24.5018C41.4108 20.4849 34.8821 20.5276 30.908 24.5018L27.5636 27.8462C25.717 29.6927 22.7177 29.6927 20.8712 27.8462L18.0925 25.0675L10.8309 32.3291L13.6096 35.1078C19.4658 40.9641 28.9654 40.9641 34.8216 35.1078L45.4277 24.5018ZM3 23.5018C7.01684 27.5186 13.4637 27.5578 17.4805 23.5409L20.8676 20.1538C22.7142 18.3073 25.7135 18.3073 27.56 20.1538L30.3387 22.9325L37.6003 15.6709L34.8216 12.8922C28.9654 7.03593 19.4658 7.03593 13.6096 12.8922L3.00356 23.4982L3 23.5018Z"/>
		</svg>
		`;
};
const FocusIcon = ({ appearance, label = 'Focus', size = (0, _constants.defaultLogoParams).size, testId, iconColor = (0, _constants.defaultLogoParams).iconColor, textColor = (0, _constants.defaultLogoParams).textColor })=>{
    const { colorMode } = (0, _useThemeObserver.useThemeObserver)();
    return /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _wrapperDefault.default), {
        appearance: appearance,
        label: label,
        svg: svg({
            appearance,
            iconColor
        }, colorMode),
        iconColor: iconColor,
        size: size,
        testId: testId,
        textColor: textColor
    });
};

},{"react":"ltHCL","@atlaskit/tokens/use-theme-observer":"4S775","../../constants":"kYpRl","../../wrapper":"9ojnE","../get-colors-from-appearance":"jcOxk","@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"6nmzo":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "FocusLogo", ()=>FocusLogo);
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _useThemeObserver = require("@atlaskit/tokens/use-theme-observer");
var _constants = require("../../constants");
var _wrapper = require("../../wrapper");
var _wrapperDefault = parcelHelpers.interopDefault(_wrapper);
var _getColorsFromAppearance = require("../get-colors-from-appearance");
const svg = ({ appearance, iconColor, textColor }, colorMode)=>{
    let colors = {
        iconColor,
        textColor
    };
    if (appearance) colors = (0, _getColorsFromAppearance.getColorsFromAppearance)(appearance, colorMode);
    return `<svg fill="none" height="32" viewBox="0 0 168 48" focusable="false" aria-hidden="true" xmlns="http://www.w3.org/2000/svg">
		<path fill="${colors.iconColor}" d="M42.4277 24.5018C38.4108 20.4849 31.8821 20.5276 27.908 24.5018L24.5636 27.8462C22.717 29.6927 19.7177 29.6927 17.8712 27.8462L15.0925 25.0675L7.83088 32.3291L10.6096 35.1078C16.4658 40.9641 25.9654 40.9641 31.8216 35.1078L42.4277 24.5018ZM0 23.5018C4.01684 27.5186 10.4637 27.5578 14.4805 23.5409L17.8676 20.1538C19.7142 18.3073 22.7135 18.3073 24.56 20.1538L27.3387 22.9325L34.6003 15.6709L31.8216 12.8922C25.9654 7.03593 16.4658 7.03593 10.6096 12.8922L0.00355592 23.4982L0 23.5018Z"/>
		<path fill="${colors.textColor}" d="M167.405 31.746C167.405 35.564 164.921 38.462 158.757 38.462C155.307 38.462 152.501 37.68 150.753 36.76V32.574C152.731 33.724 156.043 34.828 158.941 34.828C161.977 34.828 163.541 33.586 163.541 31.792C163.541 30.044 162.207 29.032 157.837 27.974C152.731 26.732 150.569 24.754 150.569 20.982C150.569 16.98 153.651 14.542 158.895 14.542C161.885 14.542 164.599 15.278 166.301 16.198V20.292C163.541 18.912 161.287 18.176 158.849 18.176C155.951 18.176 154.387 19.188 154.387 20.982C154.387 22.592 155.491 23.604 159.723 24.616C164.829 25.858 167.405 27.744 167.405 31.746Z"/>
		<path fill="${colors.textColor}" d="M126.009 28.48V15.002H129.965V28.894C129.965 33.034 131.621 34.874 135.393 34.874C139.073 34.874 141.603 32.436 141.603 27.79V15.002H145.559V38.002H141.603V34.23C140.131 36.944 137.417 38.462 134.335 38.462C129.045 38.462 126.009 34.828 126.009 28.48Z"/>
		<path fill="${colors.textColor}" d="M121.953 33.862V37.404C120.573 38.14 118.457 38.462 116.341 38.462C108.153 38.462 104.335 33.494 104.335 26.456C104.335 19.51 108.153 14.542 116.341 14.542C118.411 14.542 120.021 14.818 121.815 15.646V19.326C120.343 18.636 118.779 18.222 116.617 18.222C110.637 18.222 108.199 21.994 108.199 26.456C108.199 30.918 110.683 34.69 116.709 34.69C119.055 34.69 120.527 34.368 121.953 33.862Z"/>
		<path fill="${colors.textColor}" d="M90.2616 38.462C83.3616 38.462 79.3136 33.356 79.3136 26.456C79.3136 19.556 83.3616 14.542 90.2616 14.542C97.1156 14.542 101.118 19.556 101.118 26.456C101.118 33.356 97.1156 38.462 90.2616 38.462ZM90.2616 18.222C85.3396 18.222 83.1776 22.086 83.1776 26.456C83.1776 30.826 85.3396 34.782 90.2616 34.782C95.1376 34.782 97.2536 30.826 97.2536 26.456C97.2536 22.086 95.1376 18.222 90.2616 18.222Z"/>
		<path fill="${colors.textColor}" d="M75.298 26.732H61.59V38.002H57.45V7.78003H76.862V11.736H61.59V22.776H75.298V26.732Z"/>
		</svg>
		`;
};
const FocusLogo = ({ appearance, label = 'Focus', size = (0, _constants.defaultLogoParams).size, testId, iconColor = (0, _constants.defaultLogoParams).iconColor, textColor = (0, _constants.defaultLogoParams).textColor })=>{
    const { colorMode } = (0, _useThemeObserver.useThemeObserver)();
    return /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _wrapperDefault.default), {
        appearance: appearance,
        label: label,
        iconColor: iconColor,
        size: size,
        svg: svg({
            appearance,
            iconColor,
            textColor
        }, colorMode),
        testId: testId,
        textColor: textColor
    });
};

},{"react":"ltHCL","@atlaskit/tokens/use-theme-observer":"4S775","../../constants":"kYpRl","../../wrapper":"9ojnE","../get-colors-from-appearance":"jcOxk","@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"hxXQG":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "GuardIcon", ()=>(0, _icon.GuardIcon));
parcelHelpers.export(exports, "GuardLogo", ()=>(0, _logo.GuardLogo));
var _icon = require("./icon");
var _logo = require("./logo");

},{"./icon":"dcbrj","./logo":"cQZ7t","@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"dcbrj":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "GuardIcon", ()=>GuardIcon);
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _useThemeObserver = require("@atlaskit/tokens/use-theme-observer");
var _constants = require("../../constants");
var _wrapper = require("../../wrapper");
var _wrapperDefault = parcelHelpers.interopDefault(_wrapper);
var _getColorsFromAppearance = require("../get-colors-from-appearance");
const svg = ({ appearance, iconColor }, colorMode)=>{
    let colors = {
        iconColor
    };
    if (appearance) colors = (0, _getColorsFromAppearance.getColorsFromAppearance)(appearance, colorMode);
    return `<svg fill="none" height="32" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 32 32" focusable="false" aria-hidden="true">
      <path
        d="M5.584 14.4h20.83c.599 0 .918-.32.918-.918V6.459c0-.599-.319-.918-.918-.918h-4.39c-.598 0-.917.32-.917.918v3.551h-1.995V6.46c0-.599-.32-.918-.918-.918h-4.39c-.598 0-.917.32-.917.918v3.551h-1.995V6.46c0-.599-.32-.918-.918-.918h-4.39c-.598 0-.917.32-.917.918v7.023c0 .599.319.918.917.918zm.36 6.145a13.9 13.9 0 0 1-.798-3.99c-.04-.52.199-.799.758-.799h20.191c.559 0 .798.24.798.719q-.12 2.214-.838 4.07c-.24.638-.598.918-1.277.918H7.221c-.679 0-1.038-.28-1.277-.918m18.475 3.312c-1.915 2.354-5.068 3.87-8.42 3.87s-6.584-1.516-8.46-3.87c-.478-.638-.239-1.038.24-1.038h16.44c.48 0 .719.4.2 1.038"
        fill="${colors.iconColor}"
      />
    </svg>`;
};
const GuardIcon = ({ appearance, label = 'Guard', size = (0, _constants.defaultLogoParams).size, testId, textColor = (0, _constants.defaultLogoParams).textColor, iconColor = (0, _constants.defaultLogoParams).iconColor })=>{
    const { colorMode } = (0, _useThemeObserver.useThemeObserver)();
    return /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _wrapperDefault.default), {
        appearance: appearance,
        svg: svg({
            appearance,
            iconColor
        }, colorMode),
        iconColor: iconColor,
        label: label,
        size: size,
        testId: testId,
        textColor: textColor
    });
};

},{"react":"ltHCL","@atlaskit/tokens/use-theme-observer":"4S775","../../constants":"kYpRl","../../wrapper":"9ojnE","../get-colors-from-appearance":"jcOxk","@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"cQZ7t":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "GuardLogo", ()=>GuardLogo);
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _useThemeObserver = require("@atlaskit/tokens/use-theme-observer");
var _constants = require("../../constants");
var _wrapper = require("../../wrapper");
var _wrapperDefault = parcelHelpers.interopDefault(_wrapper);
var _getColorsFromAppearance = require("../get-colors-from-appearance");
const svg = ({ appearance, iconColor, textColor }, colorMode)=>{
    let colors = {
        iconColor,
        textColor
    };
    if (appearance) colors = (0, _getColorsFromAppearance.getColorsFromAppearance)(appearance, colorMode);
    return `<svg fill="none" height="32" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 114 32" focusable="false" aria-hidden="true">
      <path
        d="M.918 13.733h20.83c.598 0 .918-.32.918-.918V5.792c0-.599-.32-.918-.918-.918h-4.39c-.598 0-.918.32-.918.918v3.551h-1.995V5.792c0-.599-.319-.918-.918-.918H9.139c-.599 0-.918.32-.918.918v3.551H6.225V5.792c0-.599-.32-.918-.918-.918H.917c-.598 0-.917.32-.917.918v7.023c0 .599.32.918.918.918m.359 6.145a13.9 13.9 0 0 1-.798-3.99c-.04-.52.2-.799.758-.799h20.191c.56 0 .799.24.799.719q-.12 2.214-.838 4.07c-.24.638-.599.918-1.277.918H2.554c-.679 0-1.038-.28-1.277-.918m18.476 3.312c-1.916 2.354-5.068 3.87-8.42 3.87s-6.584-1.516-8.46-3.87c-.479-.638-.24-1.038.24-1.038h16.44c.479 0 .718.4.2 1.038"
        fill="${colors.iconColor}"
      />
      <path
        d="M102.398 17.874c0 3.68 1.472 5.52 4.202 5.52 2.361 0 4.477-1.502 4.477-4.906V17.26c0-3.404-1.932-4.907-4.171-4.907-2.974 0-4.508 1.963-4.508 5.52zm8.679 7.667v-2.76c-.982 2.024-2.822 3.067-5.183 3.067-4.079 0-6.133-3.466-6.133-7.974 0-4.324 2.146-7.973 6.44-7.973 2.238 0 3.956 1.012 4.876 3.005V3.798h2.637v21.743zm-17.793-9.047v9.047h-2.576V10.208h2.576v2.698c.89-1.809 2.423-3.097 5.428-2.913v2.576c-3.373-.337-5.428.675-5.428 3.925m-17.869 1.381c0 3.68 1.472 5.52 4.201 5.52 2.362 0 4.478-1.503 4.478-4.907v-1.227c0-3.404-1.932-4.906-4.17-4.906-2.976 0-4.509 1.962-4.509 5.52m8.679 7.666v-2.76c-.982 2.024-2.822 3.067-5.183 3.067-4.079 0-6.133-3.465-6.133-7.973 0-4.324 2.146-7.974 6.44-7.974 2.238 0 3.956 1.012 4.876 3.006v-2.699h2.637v15.333zM56.68 19.193v-8.985h2.637v9.261c0 2.76 1.105 3.987 3.62 3.987 2.453 0 4.14-1.625 4.14-4.723v-8.525h2.637v15.333h-2.638v-2.514c-.981 1.809-2.79 2.821-4.845 2.821-3.527 0-5.55-2.423-5.55-6.655zm-3.973 5.213c-1.595.951-4.539 1.442-6.808 1.442-6.931 0-10.672-4.232-10.672-10.335 0-6.563 4.262-10.457 11.438-10.457 1.595 0 3.466.184 5.244.797v2.76c-1.533-.613-3.342-.89-5.213-.89-5.98 0-8.71 2.975-8.71 7.729 0 4.661 2.76 7.758 8.557 7.758.95 0 2.269-.092 3.404-.429v-5.612h-5.152v-2.637h7.912z"
        fill="${colors.textColor}"
      />
    </svg>`;
};
const GuardLogo = ({ appearance, label = 'Guard', size = (0, _constants.defaultLogoParams).size, testId, textColor = (0, _constants.defaultLogoParams).textColor, iconColor = (0, _constants.defaultLogoParams).iconColor })=>{
    const { colorMode } = (0, _useThemeObserver.useThemeObserver)();
    return /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _wrapperDefault.default), {
        appearance: appearance,
        iconColor: iconColor,
        label: label,
        size: size,
        svg: svg({
            appearance,
            iconColor,
            textColor
        }, colorMode),
        testId: testId,
        textColor: textColor
    });
};

},{"react":"ltHCL","@atlaskit/tokens/use-theme-observer":"4S775","../../constants":"kYpRl","../../wrapper":"9ojnE","../get-colors-from-appearance":"jcOxk","@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"cJ4sZ":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "JiraIcon", ()=>(0, _icon.JiraIcon));
parcelHelpers.export(exports, "JiraLogo", ()=>(0, _logo.JiraLogo));
var _icon = require("./icon");
var _logo = require("./logo");

},{"./icon":"bGAdl","./logo":"5HTEB","@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"bGAdl":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "JiraIcon", ()=>JiraIcon);
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _useThemeObserver = require("@atlaskit/tokens/use-theme-observer");
var _constants = require("../../constants");
var _wrapper = require("../../wrapper");
var _wrapperDefault = parcelHelpers.interopDefault(_wrapper);
var _getColorsFromAppearance = require("../get-colors-from-appearance");
const svg = ({ appearance, iconColor }, colorMode)=>{
    let colors = {
        iconColor
    };
    if (appearance) colors = (0, _getColorsFromAppearance.getColorsFromAppearance)(appearance, colorMode);
    return `<svg fill="none" height="32" viewBox="0 0 32 32" focusable="false" aria-hidden="true" xmlns="http://www.w3.org/2000/svg">
      <path fill="${colors.iconColor}" d="M11.034 21.99h-2.22c-3.346 0-5.747-2.05-5.747-5.052h11.932c.619 0 1.019.44 1.019 1.062v12.007c-2.983 0-4.984-2.416-4.984-5.784zm5.893-5.967h-2.219c-3.347 0-5.748-2.013-5.748-5.015h11.933c.618 0 1.055.402 1.055 1.025V24.04c-2.983 0-5.02-2.416-5.02-5.784zm5.93-5.93h-2.219c-3.347 0-5.748-2.05-5.748-5.052h11.933c.618 0 1.018.439 1.018 1.025v12.007c-2.983 0-4.984-2.416-4.984-5.784z"/>
    </svg>`;
};
const JiraIcon = ({ appearance, label = 'Jira', size = (0, _constants.defaultLogoParams).size, testId, textColor = (0, _constants.defaultLogoParams).textColor, iconColor = (0, _constants.defaultLogoParams).iconColor })=>{
    const { colorMode } = (0, _useThemeObserver.useThemeObserver)();
    return /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _wrapperDefault.default), {
        appearance: appearance,
        label: label,
        svg: svg({
            appearance,
            iconColor
        }, colorMode),
        iconColor: iconColor,
        size: size,
        testId: testId,
        textColor: textColor
    });
};

},{"react":"ltHCL","@atlaskit/tokens/use-theme-observer":"4S775","../../constants":"kYpRl","../../wrapper":"9ojnE","../get-colors-from-appearance":"jcOxk","@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"5HTEB":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "JiraLogo", ()=>JiraLogo);
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _useThemeObserver = require("@atlaskit/tokens/use-theme-observer");
var _constants = require("../../constants");
var _wrapper = require("../../wrapper");
var _wrapperDefault = parcelHelpers.interopDefault(_wrapper);
var _getColorsFromAppearance = require("../get-colors-from-appearance");
const svg = ({ appearance, iconColor, textColor }, colorMode)=>{
    let colors = {
        iconColor,
        textColor
    };
    if (appearance) colors = (0, _getColorsFromAppearance.getColorsFromAppearance)(appearance, colorMode);
    return `<svg fill="none" height="32" viewBox="0 0 77 32" focusable="false" aria-hidden="true" xmlns="http://www.w3.org/2000/svg">
      <path fill="${colors.iconColor}" d="M7.967 21.323H5.748C2.401 21.323 0 19.273 0 16.271h11.933c.618 0 1.018.44 1.018 1.062V29.34c-2.983 0-4.984-2.416-4.984-5.784zm5.894-5.967h-2.22c-3.346 0-5.747-2.013-5.747-5.015h11.932c.618 0 1.055.402 1.055 1.025v12.007c-2.983 0-5.02-2.416-5.02-5.784zm5.93-5.93h-2.22c-3.347 0-5.748-2.05-5.748-5.052h11.933c.618 0 1.019.439 1.019 1.025v12.007c-2.983 0-4.984-2.416-4.984-5.784z"/>
      <path fill="${colors.textColor}" d="M65.023 17.874c0 3.68 1.472 5.52 4.202 5.52 2.36 0 4.477-1.503 4.477-4.907V17.26c0-3.404-1.932-4.906-4.17-4.906-2.975 0-4.509 1.962-4.509 5.52m8.679 7.666v-2.76c-.981 2.024-2.821 3.067-5.183 3.067-4.078 0-6.133-3.465-6.133-7.973 0-4.324 2.147-7.974 6.44-7.974 2.239 0 3.956 1.012 4.876 3.006v-2.699h2.637V25.54zM55.91 16.493v9.047h-2.577V10.207h2.576v2.698c.89-1.809 2.423-3.097 5.428-2.913v2.576c-3.373-.337-5.428.675-5.428 3.925M46.224 6.159c0-1.165.767-1.84 1.84-1.84s1.84.675 1.84 1.84-.767 1.84-1.84 1.84-1.84-.675-1.84-1.84m.49 19.381V10.207h2.638V25.54zm-6.427-5.95V5.393h2.76v14.015c0 3.71-1.626 6.256-5.428 6.256-1.442 0-2.546-.246-3.312-.522v-2.668c.828.338 1.84.522 2.852.522 2.33 0 3.128-1.41 3.128-3.404"/>
    </svg>`;
};
const JiraLogo = ({ appearance, label = 'Jira', size = (0, _constants.defaultLogoParams).size, testId, iconColor = (0, _constants.defaultLogoParams).iconColor, textColor = (0, _constants.defaultLogoParams).textColor })=>{
    const { colorMode } = (0, _useThemeObserver.useThemeObserver)();
    return /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _wrapperDefault.default), {
        appearance: appearance,
        label: label,
        iconColor: iconColor,
        size: size,
        svg: svg({
            appearance,
            iconColor,
            textColor
        }, colorMode),
        testId: testId,
        textColor: textColor
    });
};

},{"react":"ltHCL","@atlaskit/tokens/use-theme-observer":"4S775","../../constants":"kYpRl","../../wrapper":"9ojnE","../get-colors-from-appearance":"jcOxk","@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"aQQzV":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "JiraAlignIcon", ()=>(0, _icon.JiraAlignIcon));
parcelHelpers.export(exports, "JiraAlignLogo", ()=>(0, _logo.JiraAlignLogo));
var _icon = require("./icon");
var _logo = require("./logo");

},{"./icon":"2lsgS","./logo":"hANqH","@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"2lsgS":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "JiraAlignIcon", ()=>JiraAlignIcon);
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _useThemeObserver = require("@atlaskit/tokens/use-theme-observer");
var _constants = require("../../constants");
var _wrapper = require("../../wrapper");
var _wrapperDefault = parcelHelpers.interopDefault(_wrapper);
var _getColorsFromAppearance = require("../get-colors-from-appearance");
const svg = ({ appearance, iconColor }, colorMode)=>{
    let colors = {
        iconColor
    };
    if (appearance) colors = (0, _getColorsFromAppearance.getColorsFromAppearance)(appearance, colorMode);
    return `<svg viewBox="0 0 32 32" focusable="false" aria-hidden="true" height="32" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      fill="${colors.iconColor}"
      d="M25.52 25.727c0-3.604-2.949-6.517-6.517-6.517h-6.007v-5.497H6.48v10.813c0 .837.364 1.201 1.201 1.201zM6.48 6.687c0 3.604 2.876 6.517 6.48 6.517h6.043V18.7h6.517V7.888q0-1.2-1.201-1.201z"
    />
  </svg>`;
};
const JiraAlignIcon = ({ appearance, label = 'Jira Align', size = (0, _constants.defaultLogoParams).size, testId, textColor = (0, _constants.defaultLogoParams).textColor, iconColor = (0, _constants.defaultLogoParams).iconColor })=>{
    const { colorMode } = (0, _useThemeObserver.useThemeObserver)();
    return /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _wrapperDefault.default), {
        appearance: appearance,
        label: label,
        svg: svg({
            appearance,
            iconColor
        }, colorMode),
        iconColor: iconColor,
        size: size,
        testId: testId,
        textColor: textColor
    });
};

},{"react":"ltHCL","@atlaskit/tokens/use-theme-observer":"4S775","../../constants":"kYpRl","../../wrapper":"9ojnE","../get-colors-from-appearance":"jcOxk","@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"hANqH":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "JiraAlignLogo", ()=>JiraAlignLogo);
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _useThemeObserver = require("@atlaskit/tokens/use-theme-observer");
var _constants = require("../../constants");
var _wrapper = require("../../wrapper");
var _wrapperDefault = parcelHelpers.interopDefault(_wrapper);
var _getColorsFromAppearance = require("../get-colors-from-appearance");
const svg = ({ appearance, iconColor, textColor }, colorMode)=>{
    let colors = {
        iconColor,
        textColor
    };
    if (appearance) colors = (0, _getColorsFromAppearance.getColorsFromAppearance)(appearance, colorMode);
    return `<svg viewBox="0 0 146 32" focusable="false" aria-hidden="true" height="32" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path d="M19.04 25.727c0-3.604-2.949-6.517-6.517-6.517H6.517v-5.497H0v10.813c0 .837.364 1.201 1.201 1.201zM0 6.687c0 3.604 2.876 6.517 6.48 6.517h6.043V18.7h6.517V7.888q0-1.2-1.201-1.201z" fill="${colors.iconColor}"/>
      <path d="M144.993 16.555v8.985h-2.638v-9.26c0-2.76-1.104-3.988-3.618-3.988-2.454 0-4.14 1.626-4.14 4.723v8.525h-2.638V10.207h2.638v2.515c.981-1.81 2.79-2.822 4.845-2.822 3.527 0 5.551 2.423 5.551 6.655m-19.589 7.759V22.78c-.982 2.024-2.822 3.067-5.183 3.067-4.048 0-6.072-3.465-6.072-7.973 0-4.324 2.116-7.974 6.379-7.974 2.238 0 3.956 1.012 4.876 3.006v-2.699h2.576V24.16c0 4.508-2.116 7.544-7.606 7.544-2.576 0-3.986-.337-5.458-.828V28.3c1.686.552 3.434.92 5.336.92 3.833 0 5.152-2.054 5.152-4.906m-8.679-6.44c0 3.68 1.472 5.52 4.201 5.52 2.362 0 4.478-1.503 4.478-4.907V17.26c0-3.404-1.932-4.906-4.171-4.906-2.975 0-4.508 1.962-4.508 5.52M107.96 6.16c0-1.166.766-1.84 1.84-1.84 1.073 0 1.84.674 1.84 1.84S110.873 8 109.8 8c-1.074 0-1.84-.675-1.84-1.84m.49 19.38V10.208h2.638v15.334h-2.638Zm-2.537-.03c-.215.061-.675.122-1.349.122-2.515 0-4.11-1.196-4.11-4.017V3.798h2.638v17.51c0 1.38.92 1.871 2.054 1.871.276 0 .46 0 .767-.03v2.36ZM88.83 21.523c-1.534 0-3.098-.184-4.815-.521l-1.687 4.539h-3.097l7.942-20.148h3.496l7.943 20.148h-3.097l-1.687-4.57c-1.81.368-3.373.552-4.999.552Zm0-2.453c1.287 0 2.606-.153 4.17-.399l-4.079-11.04-4.078 11.07c1.502.246 2.76.369 3.986.369Zm-27.807-1.196c0 3.68 1.472 5.52 4.202 5.52 2.36 0 4.477-1.503 4.477-4.907V17.26c0-3.404-1.932-4.906-4.17-4.906-2.975 0-4.509 1.962-4.509 5.52m8.679 7.666v-2.76c-.981 2.024-2.822 3.067-5.183 3.067-4.079 0-6.133-3.465-6.133-7.973 0-4.324 2.146-7.974 6.44-7.974 2.239 0 3.956 1.012 4.876 3.006v-2.699h2.637V25.54zM51.91 16.494v9.047h-2.577V10.207h2.576v2.699c.89-1.81 2.423-3.097 5.428-2.913v2.576c-3.373-.338-5.428.674-5.428 3.925ZM42.224 6.16c0-1.166.767-1.84 1.84-1.84s1.84.674 1.84 1.84S45.137 8 44.064 8s-1.84-.675-1.84-1.84m.49 19.38V10.208h2.638v15.334h-2.637Zm-6.427-5.949V5.393h2.76v14.014c0 3.71-1.626 6.256-5.428 6.256-1.442 0-2.546-.245-3.312-.521v-2.668c.828.337 1.84.521 2.852.521 2.33 0 3.128-1.41 3.128-3.404" fill="${colors.textColor}"/>
    </svg>
  `;
};
const JiraAlignLogo = ({ appearance, label = 'Jira Align', size = (0, _constants.defaultLogoParams).size, testId, iconColor = (0, _constants.defaultLogoParams).iconColor, textColor = (0, _constants.defaultLogoParams).textColor })=>{
    const { colorMode } = (0, _useThemeObserver.useThemeObserver)();
    return /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _wrapperDefault.default), {
        appearance: appearance,
        label: label,
        iconColor: iconColor,
        size: size,
        svg: svg({
            appearance,
            iconColor,
            textColor
        }, colorMode),
        testId: testId,
        textColor: textColor
    });
};

},{"react":"ltHCL","@atlaskit/tokens/use-theme-observer":"4S775","../../constants":"kYpRl","../../wrapper":"9ojnE","../get-colors-from-appearance":"jcOxk","@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"dwHPV":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "JiraProductDiscoveryIcon", ()=>(0, _icon.JiraProductDiscoveryIcon));
parcelHelpers.export(exports, "JiraProductDiscoveryLogo", ()=>(0, _logo.JiraProductDiscoveryLogo));
var _icon = require("./icon");
var _logo = require("./logo");

},{"./icon":"iZzUC","./logo":"hYj5a","@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"iZzUC":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "JiraProductDiscoveryIcon", ()=>JiraProductDiscoveryIcon);
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _useThemeObserver = require("@atlaskit/tokens/use-theme-observer");
var _constants = require("../../constants");
var _wrapper = require("../../wrapper");
var _wrapperDefault = parcelHelpers.interopDefault(_wrapper);
var _getColorsFromAppearance = require("../get-colors-from-appearance");
const svg = ({ appearance, iconColor }, colorMode)=>{
    let colors = {
        iconColor
    };
    if (appearance) colors = (0, _getColorsFromAppearance.getColorsFromAppearance)(appearance, colorMode);
    return `<svg fill="none" height="32" viewBox="0 0 32 32" focusable="false" aria-hidden="true" xmlns="http://www.w3.org/2000/svg">
      <path fill="${colors.iconColor}" d="M17.655 5.884a15.3 15.3 0 0 0 8.75 0c.257-.056.428.114.37.37-.826 2.985-.826 5.742 0 8.727.058.228-.113.427-.37.342a16.33 16.33 0 0 0-8.75 0c-.228.085-.428-.114-.342-.342.77-2.985.77-5.742 0-8.727-.086-.256.114-.426.342-.37m1.169 10.576v.483c0 2.246-1.568 3.894-3.506 3.894a3.474 3.474 0 0 1-3.477-3.496c0-1.933 1.567-3.468 3.762-3.468h.57V7.078c-.285-.028-.57-.028-.855-.028C9.618 7.05 5 11.655 5 17.37c0 5.713 4.617 10.29 10.318 10.29s10.346-4.605 10.346-10.29v-.91z"/>
    </svg>`;
};
const JiraProductDiscoveryIcon = ({ appearance, label = 'Jira Product Discovery', size = (0, _constants.defaultLogoParams).size, testId, iconColor = (0, _constants.defaultLogoParams).iconColor, textColor = (0, _constants.defaultLogoParams).textColor })=>{
    const { colorMode } = (0, _useThemeObserver.useThemeObserver)();
    return /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _wrapperDefault.default), {
        appearance: appearance,
        label: label,
        svg: svg({
            appearance,
            iconColor
        }, colorMode),
        iconColor: iconColor,
        size: size,
        testId: testId,
        textColor: textColor
    });
};

},{"react":"ltHCL","@atlaskit/tokens/use-theme-observer":"4S775","../../constants":"kYpRl","../../wrapper":"9ojnE","../get-colors-from-appearance":"jcOxk","@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"hYj5a":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "JiraProductDiscoveryLogo", ()=>JiraProductDiscoveryLogo);
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _useThemeObserver = require("@atlaskit/tokens/use-theme-observer");
var _constants = require("../../constants");
var _wrapper = require("../../wrapper");
var _wrapperDefault = parcelHelpers.interopDefault(_wrapper);
var _getColorsFromAppearance = require("../get-colors-from-appearance");
const svg = ({ appearance, iconColor, textColor }, colorMode)=>{
    let colors = {
        iconColor,
        textColor
    };
    if (appearance) colors = (0, _getColorsFromAppearance.getColorsFromAppearance)(appearance, colorMode);
    return `<svg fill="none" height="32" viewBox="0 0 318 32" focusable="false" aria-hidden="true" xmlns="http://www.w3.org/2000/svg">
      <path fill="${colors.iconColor}" d="M12.655 5.218a15.3 15.3 0 0 0 8.75 0c.257-.057.428.114.37.37-.826 2.984-.826 5.742 0 8.727.058.227-.113.426-.37.341a16.33 16.33 0 0 0-8.75 0c-.228.085-.428-.114-.342-.341.77-2.985.77-5.743 0-8.727-.086-.256.114-.427.342-.37m1.169 10.575v.483c0 2.246-1.568 3.895-3.506 3.895a3.474 3.474 0 0 1-3.478-3.497c0-1.933 1.568-3.468 3.763-3.468h.57V6.412c-.285-.028-.57-.028-.855-.028C4.618 6.384 0 10.989 0 16.703s4.617 10.29 10.318 10.29 10.346-4.605 10.346-10.29v-.91z" />
      <path fill="${colors.textColor}" d="M308.551 24.559h-1.718l-5.55-14.352h2.821l4.907 13.125 4.906-13.125h2.822l-5.796 14.843c-1.718 4.385-2.699 6.654-6.594 6.654-1.318 0-2.054-.122-2.821-.429v-2.27c.889.277 1.901.369 2.668.369 2.147 0 3.097-1.472 4.355-4.815m-13.247-8.065v9.047h-2.576V10.207h2.576v2.699c.889-1.81 2.422-3.097 5.428-2.913v2.576c-3.374-.338-5.428.674-5.428 3.925m-12.464-4.202c-2.79 0-4.201 1.81-4.477 4.478h8.556c-.153-2.852-1.441-4.478-4.079-4.478m5.888 12.635c-1.257.675-3.189.92-4.753.92-5.735 0-8.249-3.312-8.249-8.004 0-4.63 2.576-7.943 7.237-7.943 4.723 0 6.624 3.282 6.624 7.943v1.196h-11.193c.368 2.607 2.054 4.293 5.673 4.293 1.779 0 3.281-.337 4.661-.828zm-19.717.613h-3.527l-5.949-15.333h2.76l4.968 13.095 4.937-13.095h2.76zm-17.462.307c-4.6 0-7.299-3.404-7.299-8.004s2.699-7.943 7.299-7.943c4.569 0 7.237 3.343 7.237 7.943s-2.668 8.004-7.237 8.004m0-13.493c-3.281 0-4.723 2.576-4.723 5.49 0 2.912 1.442 5.55 4.723 5.55 3.251 0 4.661-2.638 4.661-5.55 0-2.914-1.41-5.49-4.661-5.49M242.16 22.78v2.362c-.92.49-2.331.705-3.742.705-5.458 0-8.004-3.312-8.004-8.004 0-4.63 2.546-7.943 8.004-7.943 1.38 0 2.454.184 3.65.736v2.454c-.982-.46-2.024-.736-3.466-.736-3.986 0-5.612 2.514-5.612 5.49 0 2.974 1.656 5.488 5.674 5.488 1.564 0 2.545-.214 3.496-.552m-13.872-1.41c0 2.545-1.656 4.477-5.765 4.477-2.3 0-4.171-.521-5.336-1.135v-2.79c1.319.766 3.527 1.502 5.459 1.502 2.024 0 3.066-.828 3.066-2.024 0-1.165-.889-1.84-3.802-2.545-3.404-.828-4.846-2.147-4.846-4.661 0-2.668 2.055-4.294 5.551-4.294 1.993 0 3.803.491 4.937 1.104v2.73c-1.84-.92-3.342-1.41-4.968-1.41-1.932 0-2.974.674-2.974 1.87 0 1.073.736 1.748 3.557 2.422 3.404.828 5.121 2.086 5.121 4.754M210.599 6.16c0-1.166.767-1.84 1.84-1.84s1.84.674 1.84 1.84-.767 1.84-1.84 1.84-1.84-.675-1.84-1.84m.491 19.38V10.208h2.637v15.334zM198.344 8.03h-4.539v14.873h4.692c4.6 0 6.9-2.422 6.9-7.298 0-4.907-2.177-7.575-7.053-7.575m-7.299 17.51V5.394h7.422c6.532 0 9.69 4.078 9.69 10.12 0 6.102-3.189 10.028-9.69 10.028zm-13.411-4.753c0 1.35.797 2.27 2.422 2.27.614 0 1.196-.123 1.656-.215v2.545c-.46.123-.981.245-1.778.245-3.282 0-4.876-1.932-4.876-4.784v-8.187h-2.484v-2.454h2.484v-3.25h2.576v3.25h4.078v2.453h-4.078zm-6.66 1.993v2.362c-.92.49-2.331.705-3.742.705-5.458 0-8.004-3.312-8.004-8.004 0-4.63 2.546-7.943 8.004-7.943 1.38 0 2.454.184 3.65.736v2.454c-.982-.46-2.024-.736-3.466-.736-3.986 0-5.612 2.514-5.612 5.49 0 2.974 1.656 5.488 5.674 5.488 1.564 0 2.545-.214 3.496-.552m-27.843-3.588v-8.985h2.637v9.261c0 2.76 1.104 3.987 3.619 3.987 2.453 0 4.14-1.625 4.14-4.723v-8.525h2.637V25.54h-2.637v-2.514c-.982 1.809-2.791 2.821-4.846 2.821-3.526 0-5.55-2.423-5.55-6.655m-14.987-1.318c0 3.68 1.472 5.52 4.202 5.52 2.361 0 4.477-1.503 4.477-4.907V17.26c0-3.404-1.932-4.906-4.171-4.906-2.974 0-4.508 1.962-4.508 5.52m8.679 7.667v-2.76c-.981 2.023-2.821 3.066-5.183 3.066-4.078 0-6.133-3.465-6.133-7.973 0-4.324 2.147-7.973 6.44-7.973 2.239 0 3.956 1.012 4.876 3.005V3.798h2.637V25.54zm-20.698.306c-4.6 0-7.299-3.404-7.299-8.004s2.699-7.943 7.299-7.943c4.569 0 7.237 3.343 7.237 7.943s-2.668 8.004-7.237 8.004m0-13.493c-3.282 0-4.723 2.576-4.723 5.49 0 2.912 1.441 5.55 4.723 5.55 3.25 0 4.661-2.638 4.661-5.55 0-2.914-1.411-5.49-4.661-5.49m-13.776 4.14v9.047h-2.576V10.207h2.576v2.699c.89-1.81 2.423-3.097 5.428-2.913v2.576c-3.373-.338-5.428.674-5.428 3.925m-5.002-4.385c0 4.385-2.454 6.838-7.483 6.838h-4.017v6.594h-2.76V5.393h6.777c5.03 0 7.483 2.576 7.483 6.716m-7.79 4.2c3.558.124 4.938-1.563 4.938-4.14 0-2.452-1.38-4.14-4.938-4.14h-3.71v8.28zM61.69 17.874c0 3.68 1.472 5.52 4.201 5.52 2.361 0 4.477-1.503 4.477-4.907V17.26c0-3.404-1.931-4.906-4.17-4.906-2.975 0-4.508 1.962-4.508 5.52m8.679 7.666v-2.76c-.982 2.024-2.822 3.067-5.183 3.067-4.079 0-6.134-3.465-6.134-7.973 0-4.324 2.147-7.974 6.44-7.974 2.24 0 3.957 1.012 4.877 3.006v-2.699h2.637V25.54zm-17.793-9.046v9.047H50V10.207h2.576v2.699c.89-1.81 2.423-3.097 5.428-2.913v2.576c-3.373-.338-5.428.674-5.428 3.925M42.89 6.16c0-1.166.767-1.84 1.84-1.84s1.84.674 1.84 1.84S45.805 8 44.73 8s-1.84-.675-1.84-1.84m.491 19.38V10.208h2.638v15.334zm-6.428-5.949V5.393h2.76v14.014c0 3.71-1.625 6.256-5.428 6.256-1.441 0-2.545-.245-3.312-.521v-2.668c.828.337 1.84.521 2.852.521 2.331 0 3.128-1.41 3.128-3.404" />
    </svg>`;
};
const JiraProductDiscoveryLogo = ({ appearance, label = 'Jira Product Discovery', size = (0, _constants.defaultLogoParams).size, testId, iconColor = (0, _constants.defaultLogoParams).iconColor, textColor = (0, _constants.defaultLogoParams).textColor })=>{
    const { colorMode } = (0, _useThemeObserver.useThemeObserver)();
    return /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _wrapperDefault.default), {
        appearance: appearance,
        label: label,
        iconColor: iconColor,
        size: size,
        svg: svg({
            appearance,
            iconColor,
            textColor
        }, colorMode),
        testId: testId,
        textColor: textColor
    });
};

},{"react":"ltHCL","@atlaskit/tokens/use-theme-observer":"4S775","../../constants":"kYpRl","../../wrapper":"9ojnE","../get-colors-from-appearance":"jcOxk","@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"g5Er5":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "JiraServiceManagementIcon", ()=>(0, _icon.JiraServiceManagementIcon));
parcelHelpers.export(exports, "JiraServiceManagementLogo", ()=>(0, _logo.JiraServiceManagementLogo));
var _icon = require("./icon");
var _logo = require("./logo");

},{"./icon":"9xuL9","./logo":"2gbRb","@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"9xuL9":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "JiraServiceManagementIcon", ()=>JiraServiceManagementIcon);
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _useThemeObserver = require("@atlaskit/tokens/use-theme-observer");
var _constants = require("../../constants");
var _wrapper = require("../../wrapper");
var _wrapperDefault = parcelHelpers.interopDefault(_wrapper);
var _getColorsFromAppearance = require("../get-colors-from-appearance");
const svg = ({ appearance, iconColor }, colorMode)=>{
    let colors = {
        iconColor
    };
    if (appearance) colors = (0, _getColorsFromAppearance.getColorsFromAppearance)(appearance, colorMode);
    return `<svg fill="none" height="32" viewBox="0 0 32 32" focusable="false" aria-hidden="true" xmlns="http://www.w3.org/2000/svg">
      <path fill=${colors.iconColor} d="M18.79 13.257h7.325c1.1 0 1.476 1.046.805 1.878L15.464 29.274c-3.702-2.951-3.353-7.62-.644-11.027zm-5.66 5.634H5.806c-1.1 0-1.476-1.046-.805-1.878L16.457 2.874c3.702 2.951 3.3 7.566.617 11z"/>
    </svg>`;
};
const JiraServiceManagementIcon = ({ appearance, label = 'Jira Service Management', size = (0, _constants.defaultLogoParams).size, testId, iconColor = (0, _constants.defaultLogoParams).iconColor, textColor = (0, _constants.defaultLogoParams).textColor })=>{
    const { colorMode } = (0, _useThemeObserver.useThemeObserver)();
    return /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _wrapperDefault.default), {
        appearance: appearance,
        label: label,
        svg: svg({
            appearance,
            iconColor
        }, colorMode),
        iconColor: iconColor,
        size: size,
        testId: testId,
        textColor: textColor
    });
};

},{"react":"ltHCL","@atlaskit/tokens/use-theme-observer":"4S775","../../constants":"kYpRl","../../wrapper":"9ojnE","../get-colors-from-appearance":"jcOxk","@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"2gbRb":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "JiraServiceManagementLogo", ()=>JiraServiceManagementLogo);
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _useThemeObserver = require("@atlaskit/tokens/use-theme-observer");
var _constants = require("../../constants");
var _wrapper = require("../../wrapper");
var _wrapperDefault = parcelHelpers.interopDefault(_wrapper);
var _getColorsFromAppearance = require("../get-colors-from-appearance");
const svg = ({ appearance, iconColor, textColor }, colorMode)=>{
    let colors = {
        iconColor,
        textColor
    };
    if (appearance) colors = (0, _getColorsFromAppearance.getColorsFromAppearance)(appearance, colorMode);
    return `<svg fill="none" height="32" viewBox="0 0 362 32" focusable="false" aria-hidden="true" xmlns="http://www.w3.org/2000/svg">
      <path fill=${colors.iconColor} d="M14.124 13.257h7.325c1.1 0 1.475 1.046.804 1.878L10.798 29.274c-3.702-2.951-3.353-7.62-.644-11.027zm-5.66 5.634H1.138c-1.1 0-1.476-1.046-.805-1.878L11.79 2.874c3.703 2.951 3.3 7.566.617 11z" />
      <path fill=${colors.textColor} d="M357.074 20.787c0 1.35.797 2.27 2.422 2.27.614 0 1.196-.123 1.656-.215v2.545c-.46.123-.981.245-1.778.245-3.282 0-4.876-1.932-4.876-4.784v-8.187h-2.484v-2.454h2.484v-3.25h2.576v3.25h4.078v2.453h-4.078zm-7.327-4.231v8.985h-2.638V16.28c0-2.76-1.104-3.987-3.618-3.987-2.454 0-4.14 1.625-4.14 4.723v8.525h-2.638V10.208h2.638v2.514c.981-1.81 2.79-2.821 4.845-2.821 3.527 0 5.551 2.423 5.551 6.655m-22.921-4.263c-2.791 0-4.201 1.81-4.477 4.477h8.556c-.154-2.852-1.442-4.477-4.079-4.477m5.888 12.635c-1.257.674-3.189.92-4.753.92-5.735 0-8.25-3.312-8.25-8.004 0-4.631 2.576-7.943 7.238-7.943 4.722 0 6.624 3.281 6.624 7.943v1.196h-11.194c.368 2.606 2.055 4.293 5.674 4.293 1.778 0 3.281-.337 4.661-.828zm-26.152-7.912v8.525h-2.637V16.28c0-2.76-1.104-3.987-3.619-3.987-2.453 0-4.14 1.625-4.14 4.723v8.525h-2.637V10.208h2.637v2.514c.981-1.81 2.79-2.821 4.845-2.821 2.607 0 4.385 1.319 5.152 3.741.859-2.361 2.913-3.741 5.459-3.741 3.434 0 5.336 2.33 5.336 6.655v8.985h-2.638v-8.525c0-3.16-1.104-4.723-3.618-4.723-2.454 0-4.14 1.625-4.14 4.723m-22.921-4.723c-2.79 0-4.201 1.81-4.477 4.477h8.556c-.153-2.852-1.441-4.477-4.079-4.477m5.888 12.635c-1.257.674-3.189.92-4.753.92-5.735 0-8.25-3.312-8.25-8.004 0-4.631 2.577-7.943 7.238-7.943 4.723 0 6.624 3.281 6.624 7.943v1.196h-11.193c.368 2.606 2.054 4.293 5.673 4.293 1.779 0 3.281-.337 4.661-.828zm-18.638-.614v-1.533c-.982 2.024-2.822 3.067-5.183 3.067-4.048 0-6.072-3.466-6.072-7.974 0-4.324 2.116-7.973 6.379-7.973 2.238 0 3.956 1.012 4.876 3.005v-2.698h2.576V24.16c0 4.508-2.116 7.544-7.606 7.544-2.576 0-3.986-.337-5.458-.828V28.3c1.686.552 3.434.92 5.336.92 3.833 0 5.152-2.055 5.152-4.907m-8.679-6.44c0 3.68 1.472 5.52 4.201 5.52 2.362 0 4.478-1.503 4.478-4.906V17.26c0-3.404-1.932-4.907-4.171-4.907-2.975 0-4.508 1.963-4.508 5.52m-16.949.001c0 3.68 1.472 5.52 4.201 5.52 2.361 0 4.477-1.503 4.477-4.906V17.26c0-3.404-1.932-4.907-4.17-4.907-2.975 0-4.508 1.963-4.508 5.52m8.678 7.667v-2.76c-.981 2.024-2.821 3.066-5.182 3.066-4.079 0-6.134-3.465-6.134-7.973 0-4.324 2.147-7.973 6.44-7.973 2.239 0 3.956 1.012 4.876 3.005v-2.699h2.638V25.54zm-14.073-8.984v8.985h-2.638V16.28c0-2.76-1.104-3.987-3.618-3.987-2.454 0-4.14 1.625-4.14 4.723v8.525h-2.638V10.208h2.638v2.514c.981-1.81 2.79-2.821 4.845-2.821 3.527 0 5.551 2.423 5.551 6.655m-28.327 1.318c0 3.68 1.472 5.52 4.202 5.52 2.361 0 4.477-1.503 4.477-4.906V17.26c0-3.404-1.932-4.907-4.171-4.907-2.974 0-4.508 1.963-4.508 5.52m8.679 7.667v-2.76c-.981 2.024-2.821 3.066-5.183 3.066-4.078 0-6.133-3.465-6.133-7.973 0-4.324 2.147-7.973 6.44-7.973 2.239 0 3.956 1.012 4.876 3.005v-2.699h2.637V25.54zm-31.445-11.009-2.76-7.482V25.54h-2.76V5.393h4.784l4.569 11.56 1.871 5.552 1.87-5.551 4.6-11.561h4.447V25.54h-2.76V7.263l-2.361 7.268-4.447 11.01h-2.668zm-21.511-2.238c-2.791 0-4.202 1.81-4.478 4.477h8.556c-.153-2.852-1.441-4.477-4.078-4.477m5.888 12.635c-1.258.674-3.19.92-4.754.92-5.734 0-8.249-3.312-8.249-8.004 0-4.631 2.576-7.943 7.237-7.943 4.723 0 6.624 3.281 6.624 7.943v1.196h-11.193c.368 2.606 2.055 4.293 5.673 4.293 1.779 0 3.282-.337 4.662-.828zm-15.094-2.148v2.362c-.92.49-2.33.705-3.741.705-5.459 0-8.004-3.312-8.004-8.004 0-4.63 2.545-7.942 8.004-7.942 1.38 0 2.453.184 3.649.736v2.453c-.981-.46-2.024-.736-3.465-.736-3.987 0-5.612 2.515-5.612 5.49s1.656 5.489 5.673 5.489c1.564 0 2.546-.215 3.496-.552M140.124 6.16c0-1.166.766-1.84 1.84-1.84 1.073 0 1.84.674 1.84 1.84S143.037 8 141.964 8c-1.074 0-1.84-.675-1.84-1.84m.49 19.38V10.208h2.638v15.334zm-8.233 0h-3.527l-5.949-15.332h2.76l4.968 13.094 4.937-13.094h2.76zm-15.455-9.046v9.047h-2.576V10.207h2.576v2.699c.889-1.81 2.423-3.097 5.428-2.913v2.576c-3.373-.338-5.428.674-5.428 3.925m-12.463-4.201c-2.791 0-4.202 1.81-4.478 4.477h8.556c-.153-2.852-1.441-4.477-4.078-4.477m5.888 12.635c-1.258.674-3.19.92-4.754.92-5.734 0-8.249-3.312-8.249-8.004 0-4.631 2.576-7.943 7.237-7.943 4.723 0 6.624 3.281 6.624 7.943v1.196h-11.193c.368 2.606 2.055 4.293 5.673 4.293 1.779 0 3.282-.337 4.662-.828zM95.024 19.99c0 3.496-2.085 5.857-7.084 5.857-3.894 0-5.704-.766-7.268-1.564v-2.821c1.87.981 4.754 1.687 7.422 1.687 3.036 0 4.17-1.196 4.17-2.975s-1.104-2.73-4.937-3.65c-4.539-1.103-6.563-2.667-6.563-5.98 0-3.127 2.392-5.458 7.084-5.458 2.914 0 4.784.705 6.164 1.472v2.76c-2.024-1.165-4.201-1.533-6.286-1.533-2.638 0-4.202.92-4.202 2.76 0 1.656 1.288 2.484 4.845 3.373 4.263 1.073 6.655 2.453 6.655 6.072m-34.001-2.116c0 3.68 1.472 5.52 4.201 5.52 2.362 0 4.478-1.503 4.478-4.906V17.26c0-3.404-1.932-4.907-4.17-4.907-2.975 0-4.509 1.963-4.509 5.52m8.679 7.667v-2.76c-.981 2.024-2.821 3.066-5.183 3.066-4.078 0-6.133-3.465-6.133-7.973 0-4.324 2.147-7.973 6.44-7.973 2.239 0 3.956 1.012 4.876 3.005v-2.699h2.637V25.54zM51.91 16.494v9.047h-2.577V10.207h2.576v2.699c.89-1.81 2.423-3.097 5.428-2.913v2.576c-3.373-.338-5.428.674-5.428 3.925M42.224 6.16c0-1.166.767-1.84 1.84-1.84s1.84.674 1.84 1.84S45.137 8 44.064 8s-1.84-.675-1.84-1.84m.49 19.38V10.208h2.638v15.334zm-6.427-5.949V5.393h2.76v14.014c0 3.71-1.626 6.256-5.428 6.256-1.442 0-2.546-.245-3.312-.521v-2.668c.828.337 1.84.521 2.852.521 2.33 0 3.128-1.41 3.128-3.404" />
    </svg>`;
};
const JiraServiceManagementLogo = ({ appearance, label = 'Jira Service Management', size = (0, _constants.defaultLogoParams).size, testId, iconColor = (0, _constants.defaultLogoParams).iconColor, textColor = (0, _constants.defaultLogoParams).textColor })=>{
    const { colorMode } = (0, _useThemeObserver.useThemeObserver)();
    return /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _wrapperDefault.default), {
        appearance: appearance,
        label: label,
        iconColor: iconColor,
        size: size,
        svg: svg({
            appearance,
            iconColor,
            textColor
        }, colorMode),
        testId: testId,
        textColor: textColor
    });
};

},{"react":"ltHCL","@atlaskit/tokens/use-theme-observer":"4S775","../../constants":"kYpRl","../../wrapper":"9ojnE","../get-colors-from-appearance":"jcOxk","@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"7eP0p":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "LoomIcon", ()=>(0, _icon.LoomIcon));
parcelHelpers.export(exports, "LoomLogo", ()=>(0, _logo.LoomLogo));
var _icon = require("./icon");
var _logo = require("./logo");

},{"./icon":"2HLDv","./logo":"eK6nj","@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"2HLDv":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "LoomIcon", ()=>LoomIcon);
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _useThemeObserver = require("@atlaskit/tokens/use-theme-observer");
var _constants = require("../../constants");
var _wrapper = require("../../wrapper");
var _wrapperDefault = parcelHelpers.interopDefault(_wrapper);
var _utils = require("../utils");
const svg = ({ appearance, iconColor }, colorMode)=>{
    let colors = {
        iconColor
    };
    if (appearance) colors = (0, _utils.getColorsForLoom)(appearance, colorMode);
    return `<svg
    fill="none"
    height="32"
    viewBox="0 0 32 32"
    xmlns="http://www.w3.org/2000/svg"
    focusable="false"
    aria-hidden="true"
  >
    <path
      d="M27.333 15.508h-6.628l5.74-3.315-1.26-2.184-5.74 3.314 3.313-5.74-2.184-1.26-3.313 5.74V5.434h-2.522v6.628l-3.314-5.74-2.184 1.26 3.314 5.74-5.74-3.314-1.26 2.184 5.74 3.314H4.667v2.521h6.627l-5.74 3.314 1.261 2.184 5.74-3.313-3.314 5.74 2.184 1.26 3.314-5.74V28.1h2.521v-6.627l3.313 5.74 2.184-1.261-3.314-5.74 5.74 3.313 1.261-2.184-5.74-3.313h6.628zM16 20.198a3.442 3.442 0 1 1 0-6.885 3.442 3.442 0 0 1 0 6.884"
      fill="${colors.iconColor}"
    />
  </svg>`;
};
const LoomIcon = ({ appearance, label = 'Loom', size = (0, _constants.defaultLogoParams).size, testId, iconColor = (0, _constants.defaultLogoParams).iconColor, textColor = (0, _constants.defaultLogoParams).textColor })=>{
    const { colorMode } = (0, _useThemeObserver.useThemeObserver)();
    return /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _wrapperDefault.default), {
        appearance: appearance,
        label: label,
        svg: svg({
            appearance,
            iconColor
        }, colorMode),
        iconColor: iconColor,
        size: size,
        testId: testId,
        textColor: textColor
    });
};

},{"react":"ltHCL","@atlaskit/tokens/use-theme-observer":"4S775","../../constants":"kYpRl","../../wrapper":"9ojnE","../utils":"4okCB","@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"4okCB":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "getColorsFromAppearanceOldLogos", ()=>(0, _getColorsFromAppearanceOldLogos.getColorsFromAppearanceOldLogos));
parcelHelpers.export(exports, "getColorsFromAppearance", ()=>(0, _getColorsFromAppearance.getColorsFromAppearance));
parcelHelpers.export(exports, "getColorsForLoom", ()=>getColorsForLoom);
var _getColorsFromAppearance = require("./get-colors-from-appearance");
var _getColorsFromAppearanceOldLogos = require("./get-colors-from-appearance-old-logos");
const getColorsForLoom = (appearance, colorMode)=>{
    let iconColor = (0, _getColorsFromAppearance.getColorsFromAppearance)(appearance, colorMode).iconColor;
    let textColor = (0, _getColorsFromAppearance.getColorsFromAppearance)(appearance, colorMode).textColor;
    if (colorMode === 'dark') switch(appearance){
        case 'brand':
            iconColor = '#625DF5';
            textColor = '#EFF0FF';
            break;
    }
    else switch(appearance){
        case 'brand':
            iconColor = '#625DF5';
            textColor = '#252434';
            break;
    }
    return {
        iconColor,
        textColor
    };
};

},{"./get-colors-from-appearance":"jcOxk","./get-colors-from-appearance-old-logos":false,"@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"eK6nj":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "LoomLogo", ()=>LoomLogo);
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _useThemeObserver = require("@atlaskit/tokens/use-theme-observer");
var _constants = require("../../constants");
var _wrapper = require("../../wrapper");
var _wrapperDefault = parcelHelpers.interopDefault(_wrapper);
var _utils = require("../utils");
const svg = ({ appearance, iconColor, textColor }, colorMode)=>{
    let colors = {
        iconColor,
        textColor
    };
    if (appearance) colors = (0, _utils.getColorsForLoom)(appearance, colorMode);
    return `<svg
      fill="none"
      height="32"
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 98 32"
      focusable="false"
      aria-hidden="true"
    >
      <path
        d="M29.657 13.659h-8.672l7.51-4.337-1.649-2.857-7.51 4.336 4.335-7.51-2.857-1.65-4.336 7.51V.479H13.18v8.672l-4.337-7.51-2.856 1.65 4.336 7.51-7.51-4.336-1.65 2.857 7.51 4.336H0v3.299h8.671l-7.51 4.336 1.65 2.858 7.51-4.336-4.336 7.51 2.857 1.65 4.336-7.511v8.672h3.3v-8.671l4.335 7.51 2.857-1.65-4.336-7.51 7.51 4.336 1.65-2.858-7.51-4.335h8.672v-3.3zM14.83 19.794a4.503 4.503 0 1 1 0-9.006 4.503 4.503 0 0 1 0 9.006"
        fill="${colors.iconColor}"
      />
      <path
        d="M37.303 26.155V4.459h3.983v21.696zm38.204-14.743h3.803v1.798c.808-1.438 2.696-2.218 4.313-2.218 2.007 0 3.624.87 4.373 2.457 1.167-1.798 2.726-2.457 4.673-2.457 2.725 0 5.33 1.648 5.33 5.604v9.559h-3.862v-8.75c0-1.588-.78-2.786-2.607-2.786-1.707 0-2.726 1.318-2.726 2.907v8.63H84.85v-8.75c0-1.59-.808-2.787-2.606-2.787-1.738 0-2.757 1.288-2.757 2.907v8.63h-3.981zm-25.219 15.17c-4.487 0-7.737-3.328-7.737-7.798 0-4.4 3.24-7.806 7.737-7.806 4.52 0 7.737 3.439 7.737 7.806 0 4.438-3.251 7.798-7.737 7.798m0-11.996a4.2 4.2 0 0 0-4.197 4.199c0 2.315 1.883 4.199 4.197 4.199s4.196-1.884 4.196-4.2a4.2 4.2 0 0 0-4.196-4.198m16.245 11.996c-4.487 0-7.737-3.328-7.737-7.798 0-4.4 3.24-7.806 7.737-7.806 4.52 0 7.737 3.439 7.737 7.806 0 4.438-3.253 7.798-7.737 7.798m0-12.046c-2.34 0-4.245 1.906-4.245 4.247s1.904 4.247 4.245 4.247a4.25 4.25 0 0 0 4.245-4.247 4.25 4.25 0 0 0-4.245-4.247"
        fill="${colors.textColor}"
      />
    </svg>`;
};
const LoomLogo = ({ appearance, label = 'Loom', size = (0, _constants.defaultLogoParams).size, testId, iconColor = (0, _constants.defaultLogoParams).iconColor, textColor = (0, _constants.defaultLogoParams).textColor })=>{
    const { colorMode } = (0, _useThemeObserver.useThemeObserver)();
    return /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _wrapperDefault.default), {
        appearance: appearance,
        label: label,
        iconColor: iconColor,
        size: size,
        svg: svg({
            appearance,
            iconColor,
            textColor
        }, colorMode),
        testId: testId,
        textColor: textColor
    });
};

},{"react":"ltHCL","@atlaskit/tokens/use-theme-observer":"4S775","../../constants":"kYpRl","../../wrapper":"9ojnE","../utils":"4okCB","@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"gnuyM":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "LoomAttributionIcon", ()=>(0, _icon.LoomAttributionIcon));
parcelHelpers.export(exports, "LoomAttributionLogo", ()=>(0, _logo.LoomAttributionLogo));
var _icon = require("./icon");
var _logo = require("./logo");

},{"./icon":"gfHFO","./logo":"cGsZn","@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"gfHFO":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "LoomAttributionIcon", ()=>LoomAttributionIcon);
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _constants = require("../../constants");
var _loom = require("../loom");
const LoomAttributionIcon = ({ appearance, label = 'Loom Attribution', size = (0, _constants.defaultLogoParams).size, testId, iconColor = (0, _constants.defaultLogoParams).iconColor, textColor = (0, _constants.defaultLogoParams).textColor })=>{
    return /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _loom.LoomIcon), {
        appearance: appearance,
        label: label,
        size: size,
        testId: testId,
        iconColor: iconColor,
        textColor: textColor
    });
};

},{"react":"ltHCL","../../constants":"kYpRl","../loom":"7eP0p","@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"cGsZn":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "LoomAttributionLogo", ()=>LoomAttributionLogo);
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _useThemeObserver = require("@atlaskit/tokens/use-theme-observer");
var _constants = require("../../constants");
var _wrapper = require("../../wrapper");
var _wrapperDefault = parcelHelpers.interopDefault(_wrapper);
var _utils = require("../utils");
const svg = ({ appearance, iconColor, textColor }, colorMode)=>{
    let colors = {
        iconColor,
        textColor
    };
    if (appearance) colors = (0, _utils.getColorsForLoom)(appearance, colorMode);
    return `<svg
		fill="none"
		height="32"
		xmlns="http://www.w3.org/2000/svg"
		focusable="false"
		aria-hidden="true"
		viewBox="0 0 88 32"
	>
		<path
			d="M29.488 12.765h-8.983l7.78-4.344-1.544-2.585-7.78 4.344 4.492-7.523-2.674-1.493-4.491 7.522V0H13.2v8.687L8.71 1.164 6.035 2.657l4.49 7.522-7.778-4.343L1.204 8.42l7.779 4.344H0v2.986h8.982l-7.778 4.343 1.543 2.585 7.78-4.342-4.492 7.522 2.674 1.493L13.2 19.83v8.687h3.087v-8.873l4.574 7.663 2.507-1.4-4.575-7.663 7.946 4.437 1.544-2.586-7.779-4.343h8.982v-2.986h.001Zm-14.744 5.552c-2.318 0-4.197-1.817-4.197-4.059s1.88-4.059 4.197-4.059 4.198 1.817 4.198 4.06c0 2.24-1.88 4.058-4.198 4.058"
			fill="${colors.iconColor}"
		/>
		<path
			d="M38.379 26.847V10.094h3.18v16.753zm30.503-11.79h3.036v1.438c.646-1.15 2.153-1.773 3.444-1.773 1.602 0 2.893.695 3.49 1.964.932-1.438 2.177-1.964 3.731-1.964 2.175 0 4.256 1.318 4.256 4.48v7.642h-3.084V19.85c0-1.27-.623-2.228-2.081-2.228-1.363 0-2.177 1.054-2.177 2.324v6.9h-3.155V19.85c0-1.27-.646-2.228-2.081-2.228-1.387 0-2.2 1.03-2.2 2.324v6.9h-3.18V15.057Zm-20.134 12.13c-3.582 0-6.176-2.66-6.176-6.234 0-3.517 2.585-6.242 6.176-6.242 3.609 0 6.177 2.75 6.177 6.242 0 3.547-2.596 6.234-6.177 6.234m0-9.59a3.357 3.357 0 0 0 0 6.713 3.357 3.357 0 0 0 0-6.713m12.966 9.59c-3.583 0-6.177-2.66-6.177-6.234 0-3.517 2.586-6.242 6.177-6.242 3.608 0 6.176 2.75 6.176 6.242 0 3.547-2.597 6.234-6.176 6.234m0-9.63a3.397 3.397 0 0 0-3.39 3.395 3.397 3.397 0 0 0 3.39 3.395 3.396 3.396 0 0 0 0-6.79M64.933 5.63c0-1.102-.697-1.522-1.983-1.837-.803-.21-1.018-.368-1.018-.63q0-.473.804-.473c.643 0 1.286.21 1.93.473V1.798a4.5 4.5 0 0 0-1.876-.42c-1.447 0-2.25.682-2.25 1.785 0 1.05.696 1.575 1.928 1.838.804.157 1.072.315 1.072.682 0 .263-.215.473-.804.473a4.46 4.46 0 0 1-2.197-.63v1.417c.483.263 1.233.473 2.197.473 1.5.052 2.197-.683 2.197-1.785Zm16.662-4.067v5.988h1.3V3.007l.542 1.23 1.841 3.368h1.626V1.563h-1.3v3.85l-.488-1.123-1.463-2.727zm-8.056 0h-1.465v6.042h1.465zm-23.981 0v6.042h2.863l.432-1.295h-1.945V1.563zm-5.671 0v1.295h1.604v4.747h1.44V2.858h1.715V1.563zm-2.177 0h-1.802l-2.066 6.042h1.59l.317-1.025a4 4 0 0 0 1.113.162q.556 0 1.113-.162l.318 1.025h1.59zm-.9 3.938a3 3 0 0 1-.743-.108l.742-2.643.742 2.643c-.265.054-.477.108-.742.108Zm16.577-3.938H55.53L53.4 7.605h1.638l.328-1.025q.573.162 1.146.162.574 0 1.147-.162l.328 1.025h1.638l-2.24-6.042Zm-.928 3.938c-.273 0-.546-.054-.765-.108l.765-2.643.764 2.643a3.3 3.3 0 0 1-.764.108m21.98-3.938h-1.857l-2.13 6.042h1.638l.328-1.025q.574.162 1.147.162c.573 0 .764-.054 1.146-.162l.328 1.025h1.638zm-.93 3.938c-.272 0-.545-.054-.763-.108l.764-2.643.765 2.643a3.3 3.3 0 0 1-.765.108Zm-6.894.129c0-1.102-.697-1.522-1.983-1.837-.803-.21-1.018-.368-1.018-.63q0-.473.804-.473c.643 0 1.286.21 1.93.473V1.798a4.5 4.5 0 0 0-1.876-.42c-1.447 0-2.25.682-2.25 1.785 0 1.05.696 1.575 1.928 1.838.804.157 1.072.315 1.072.682 0 .263-.215.473-.804.473-.75 0-1.608-.263-2.197-.63v1.417c.482.263 1.233.473 2.197.473 1.447.052 2.197-.683 2.197-1.785Z"
			fill="${colors.textColor}"
		/>
	</svg>`;
};
const LoomAttributionLogo = ({ appearance, label = 'Loom Attribution', size = (0, _constants.defaultLogoParams).size, testId, iconColor = (0, _constants.defaultLogoParams).iconColor, textColor = (0, _constants.defaultLogoParams).textColor })=>{
    const { colorMode } = (0, _useThemeObserver.useThemeObserver)();
    return /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _wrapperDefault.default), {
        appearance: appearance,
        label: label,
        iconColor: iconColor,
        size: size,
        svg: svg({
            appearance,
            iconColor,
            textColor
        }, colorMode),
        testId: testId,
        textColor: textColor
    });
};

},{"react":"ltHCL","@atlaskit/tokens/use-theme-observer":"4S775","../../constants":"kYpRl","../../wrapper":"9ojnE","../utils":"4okCB","@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"bD3Mi":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "OpsgenieIcon", ()=>(0, _icon.OpsgenieIcon));
parcelHelpers.export(exports, "OpsgenieLogo", ()=>(0, _logo.OpsgenieLogo));
var _icon = require("./icon");
var _logo = require("./logo");

},{"./icon":"bjzqH","./logo":"j2VXU","@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"bjzqH":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "OpsgenieIcon", ()=>OpsgenieIcon);
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _useThemeObserver = require("@atlaskit/tokens/use-theme-observer");
var _constants = require("../../constants");
var _wrapper = require("../../wrapper");
var _wrapperDefault = parcelHelpers.interopDefault(_wrapper);
var _getColorsFromAppearance = require("../get-colors-from-appearance");
const svg = ({ appearance, iconColor }, colorMode)=>{
    let colors = {
        iconColor
    };
    if (appearance) colors = (0, _getColorsFromAppearance.getColorsFromAppearance)(appearance, colorMode);
    return `<svg fill="none" height="32" viewBox="0 0 32 32" focusable="false" aria-hidden="true" xmlns="http://www.w3.org/2000/svg">
      <path fill="${colors.iconColor}" d="M17.114 28.127c-.785.578-1.199.537-1.984-.041-3.8-2.727-7.313-5.826-9.668-9.049-.248-.33-.124-.785.248-.991l4.297-2.686q.558-.372.992.124c1.652 1.9 3.264 3.76 5.123 5.082 1.86-1.322 3.47-3.181 5.123-5.082q.434-.495.992-.124l4.297 2.686c.372.206.496.66.248.991-2.355 3.223-5.867 6.322-9.668 9.09m-.992-11.858c3.388 0 6.198-2.768 6.198-6.156s-2.81-6.239-6.198-6.239-6.198 2.81-6.198 6.239c0 3.43 2.727 6.156 6.198 6.156"/>
    </svg>`;
};
const OpsgenieIcon = ({ appearance, label = 'Opsgenie', size = (0, _constants.defaultLogoParams).size, testId, textColor = (0, _constants.defaultLogoParams).textColor, iconColor = (0, _constants.defaultLogoParams).iconColor })=>{
    const { colorMode } = (0, _useThemeObserver.useThemeObserver)();
    return /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _wrapperDefault.default), {
        appearance: appearance,
        svg: svg({
            appearance,
            iconColor
        }, colorMode),
        iconColor: iconColor,
        label: label,
        size: size,
        testId: testId,
        textColor: textColor
    });
};

},{"react":"ltHCL","@atlaskit/tokens/use-theme-observer":"4S775","../../constants":"kYpRl","../../wrapper":"9ojnE","../get-colors-from-appearance":"jcOxk","@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"j2VXU":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "OpsgenieLogo", ()=>OpsgenieLogo);
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _useThemeObserver = require("@atlaskit/tokens/use-theme-observer");
var _constants = require("../../constants");
var _wrapper = require("../../wrapper");
var _wrapperDefault = parcelHelpers.interopDefault(_wrapper);
var _getColorsFromAppearance = require("../get-colors-from-appearance");
const svg = ({ appearance, iconColor, textColor }, colorMode)=>{
    let colors = {
        iconColor,
        textColor
    };
    if (appearance) colors = (0, _getColorsFromAppearance.getColorsFromAppearance)(appearance, colorMode);
    return `<svg fill="none" height="32" viewBox="0 0 154 32" focusable="false" aria-hidden="true" xmlns="http://www.w3.org/2000/svg">
      <path fill="${colors.iconColor}" d="M11.78 28.127c-.785.578-1.198.537-1.983-.041-3.801-2.727-7.313-5.826-9.668-9.049-.248-.33-.124-.785.248-.991l4.297-2.686q.558-.372.991.124c1.653 1.9 3.264 3.76 5.124 5.082 1.859-1.322 3.47-3.181 5.123-5.082q.435-.495.992-.124l4.297 2.686c.371.206.495.66.247.991-2.355 3.223-5.867 6.322-9.668 9.09m-.99-11.857c3.388 0 6.197-2.768 6.197-6.156s-2.81-6.239-6.197-6.239-6.198 2.81-6.198 6.239c0 3.43 2.727 6.156 6.198 6.156"/>
      <path fill="${colors.textColor}" d="M146.689 12.293c-2.79 0-4.201 1.81-4.477 4.477h8.556c-.153-2.852-1.441-4.477-4.079-4.477m5.888 12.635c-1.257.674-3.189.92-4.753.92-5.735 0-8.249-3.312-8.249-8.004 0-4.631 2.576-7.943 7.237-7.943 4.723 0 6.624 3.281 6.624 7.943v1.196h-11.193c.368 2.606 2.054 4.293 5.673 4.293 1.779 0 3.281-.337 4.661-.828zM133.385 6.16c0-1.166.767-1.84 1.841-1.84s1.84.674 1.84 1.84-.767 1.84-1.84 1.84c-1.074 0-1.841-.675-1.841-1.84m.491 19.38V10.208h2.638v15.334zm-3.677-8.984v8.985h-2.638V16.28c0-2.76-1.104-3.987-3.618-3.987-2.454 0-4.14 1.625-4.14 4.723v8.525h-2.638V10.208h2.638v2.514c.981-1.81 2.79-2.821 4.845-2.821 3.527 0 5.551 2.423 5.551 6.655m-22.921-4.263c-2.791 0-4.201 1.81-4.477 4.477h8.556c-.154-2.852-1.442-4.477-4.079-4.477m5.888 12.635c-1.257.674-3.189.92-4.753.92-5.735 0-8.25-3.312-8.25-8.004 0-4.631 2.576-7.943 7.238-7.943 4.722 0 6.624 3.281 6.624 7.943v1.196h-11.194c.368 2.606 2.055 4.293 5.674 4.293 1.778 0 3.281-.337 4.661-.828zm-18.639-.614v-1.533c-.981 2.024-2.821 3.067-5.182 3.067-4.048 0-6.072-3.466-6.072-7.974 0-4.324 2.116-7.973 6.378-7.973 2.239 0 3.956 1.012 4.876 3.005v-2.698h2.576V24.16c0 4.508-2.116 7.544-7.605 7.544-2.576 0-3.987-.337-5.459-.828V28.3c1.687.552 3.435.92 5.336.92 3.834 0 5.152-2.055 5.152-4.907m-8.678-6.44c0 3.68 1.472 5.52 4.2 5.52 2.362 0 4.478-1.503 4.478-4.906V17.26c0-3.404-1.932-4.907-4.17-4.907-2.975 0-4.508 1.963-4.508 5.52m-4.703 3.497c0 2.545-1.656 4.477-5.765 4.477-2.3 0-4.17-.52-5.336-1.134v-2.79c1.319.766 3.527 1.502 5.459 1.502 2.024 0 3.066-.828 3.066-2.024 0-1.165-.89-1.84-3.802-2.545-3.404-.829-4.846-2.147-4.846-4.662 0-2.668 2.055-4.293 5.55-4.293 1.994 0 3.804.49 4.938 1.104v2.73c-1.84-.92-3.342-1.411-4.968-1.411-1.932 0-2.974.674-2.974 1.87 0 1.073.736 1.748 3.557 2.423 3.404.828 5.121 2.085 5.121 4.753m-16.274-3.496c0-3.68-1.472-5.52-4.202-5.52-2.36 0-4.477 1.503-4.477 4.907v1.227c0 3.404 1.932 4.906 4.17 4.906 2.975 0 4.509-1.962 4.509-5.52m-3.803 7.974c-2.239 0-3.956-1.013-4.876-3.006v8.679h-2.637V10.207h2.637v2.76c.981-2.024 2.821-3.066 5.183-3.066 4.079 0 6.133 3.465 6.133 7.973 0 4.324-2.147 7.973-6.44 7.973m-20.121 0c-6.225 0-9.721-4.293-9.721-10.426 0-6.072 3.496-10.335 9.721-10.335 6.195 0 9.69 4.263 9.69 10.335 0 6.133-3.495 10.426-9.69 10.426m0-18.124c-4.968 0-6.961 3.527-6.961 7.698 0 4.262 1.993 7.789 6.961 7.789 4.937 0 6.93-3.527 6.93-7.79 0-4.17-1.993-7.697-6.93-7.697" />
    </svg>`;
};
const OpsgenieLogo = ({ appearance, label = 'Opsgenie', size = (0, _constants.defaultLogoParams).size, testId, textColor = (0, _constants.defaultLogoParams).textColor, iconColor = (0, _constants.defaultLogoParams).iconColor })=>{
    const { colorMode } = (0, _useThemeObserver.useThemeObserver)();
    return /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _wrapperDefault.default), {
        appearance: appearance,
        iconColor: iconColor,
        label: label,
        size: size,
        svg: svg({
            appearance,
            iconColor,
            textColor
        }, colorMode),
        testId: testId,
        textColor: textColor
    });
};

},{"react":"ltHCL","@atlaskit/tokens/use-theme-observer":"4S775","../../constants":"kYpRl","../../wrapper":"9ojnE","../get-colors-from-appearance":"jcOxk","@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"3LzuM":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "RovoIcon", ()=>(0, _icon.RovoIcon));
parcelHelpers.export(exports, "RovoLogo", ()=>(0, _logo.RovoLogo));
var _icon = require("./icon");
var _logo = require("./logo");

},{"./icon":"fqawd","./logo":"hI8ks","@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"fqawd":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "RovoIcon", ()=>RovoIcon);
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _useThemeObserver = require("@atlaskit/tokens/use-theme-observer");
var _constants = require("../../constants");
var _wrapper = require("../../wrapper");
var _wrapperDefault = parcelHelpers.interopDefault(_wrapper);
var _getColorsFromAppearance = require("../get-colors-from-appearance");
const svg = ({ appearance, iconColor }, colorMode)=>{
    let colors = {
        iconColor
    };
    if (appearance) colors = (0, _getColorsFromAppearance.getColorsFromAppearance)(appearance, colorMode);
    return `<svg fill="none" height="32" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 32 32" focusable="false" aria-hidden="true">
    <g fill="${colors.iconColor}" fill-rule="evenodd">
      <path d="M17.06 4.246a2.79 2.79 0 0 0-2.736-.026l-.049.033-.002.001c-.605.35-1.048.91-1.256 1.558-.085.268-.13.552-.13.842v3.675l4.603 2.656a3.64 3.64 0 0 1 1.824 3.155v9.487a3.6 3.6 0 0 1-.214 1.23l6.175-3.566a2.77 2.77 0 0 0 1.392-2.407v-9.487c0-.991-.532-1.912-1.392-2.408z"/>
      <path d="m6.058 9 6.176-3.566a3.7 3.7 0 0 0-.214 1.23v9.486c0 1.303.693 2.505 1.823 3.155l4.604 2.657v3.674c0 .29-.045.575-.13.843a2.8 2.8 0 0 1-1.258 1.558.4.4 0 0 0-.05.033c-.851.47-1.89.461-2.735-.026L6.06 23.301a2.78 2.78 0 0 1-1.392-2.408v-9.486c0-.996.529-1.912 1.391-2.408z"/>
    </g>
  </svg>`;
};
const RovoIcon = ({ appearance, label = 'Rovo', size = (0, _constants.defaultLogoParams).size, testId, textColor = (0, _constants.defaultLogoParams).textColor, iconColor = (0, _constants.defaultLogoParams).iconColor })=>{
    const { colorMode } = (0, _useThemeObserver.useThemeObserver)();
    return /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _wrapperDefault.default), {
        appearance: appearance,
        svg: svg({
            appearance,
            iconColor
        }, colorMode),
        iconColor: iconColor,
        label: label,
        size: size,
        testId: testId,
        textColor: textColor
    });
};

},{"react":"ltHCL","@atlaskit/tokens/use-theme-observer":"4S775","../../constants":"kYpRl","../../wrapper":"9ojnE","../get-colors-from-appearance":"jcOxk","@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"hI8ks":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "RovoLogo", ()=>RovoLogo);
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _useThemeObserver = require("@atlaskit/tokens/use-theme-observer");
var _constants = require("../../constants");
var _wrapper = require("../../wrapper");
var _wrapperDefault = parcelHelpers.interopDefault(_wrapper);
var _getColorsFromAppearance = require("../get-colors-from-appearance");
const svg = ({ appearance, iconColor, textColor }, colorMode)=>{
    let colors = {
        iconColor,
        textColor
    };
    if (appearance) colors = (0, _getColorsFromAppearance.getColorsFromAppearance)(appearance, colorMode);
    return `<svg fill="none" height="32" viewBox="0 0 100 32" focusable="false" aria-hidden="true" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M12.393 4.246a2.79 2.79 0 0 0-2.735-.026.4.4 0 0 1-.05.033l-.001.001c-.606.35-1.048.91-1.257 1.558q-.129.404-.13.842v3.675l4.603 2.656a3.64 3.64 0 0 1 1.824 3.155v9.487a3.6 3.6 0 0 1-.214 1.23l6.175-3.566A2.77 2.77 0 0 0 22 20.884v-9.487c0-.991-.532-1.912-1.392-2.408z"
        fill="${colors.iconColor}"
        fillRule="evenodd"
      />
      <path
        d="m1.391 9 6.176-3.566a3.6 3.6 0 0 0-.214 1.23v9.486c0 1.303.693 2.505 1.823 3.155h.001l4.603 2.657v3.674c0 .29-.045.575-.13.843a2.8 2.8 0 0 1-1.258 1.558.4.4 0 0 0-.05.033c-.85.47-1.89.461-2.734-.026l-8.216-4.743A2.78 2.78 0 0 1 0 20.893v-9.486c0-.996.529-1.912 1.391-2.408z"
        fill="${colors.iconColor}"
        fillRule="evenodd"
      />
      <path
        d="M91.688 25.848c-4.6 0-7.298-3.404-7.298-8.004S87.088 9.9 91.688 9.9c4.57 0 7.238 3.342 7.238 7.942s-2.668 8.004-7.238 8.004zm0-13.494c-3.28 0-4.722 2.576-4.722 5.49 0 2.913 1.441 5.55 4.722 5.55 3.251 0 4.662-2.637 4.662-5.55 0-2.914-1.41-5.49-4.662-5.49M77.675 25.54H74.15L68.2 10.208h2.76l4.968 13.094 4.938-13.095h2.76zm-17.462.308c-4.6 0-7.299-3.404-7.299-8.004s2.7-7.943 7.3-7.943c4.568 0 7.236 3.342 7.236 7.942s-2.668 8.004-7.237 8.004zm0-13.494c-3.281 0-4.723 2.576-4.723 5.49 0 2.913 1.442 5.55 4.723 5.55 3.25 0 4.661-2.637 4.661-5.55 0-2.914-1.41-5.49-4.66-5.49zM43.177 8.03H39.13v7.36h4.048c3.588 0 4.692-1.38 4.692-3.68 0-2.177-1.134-3.68-4.692-3.68zm7.452 3.619c0 3.036-1.288 5.09-3.956 5.949l4.938 7.943H48.36l-4.447-7.514H39.13v7.514h-2.76V5.393h7.115c4.815 0 7.145 2.392 7.145 6.256z"
        fill="${colors.textColor}"
      />
    </svg>`;
};
const RovoLogo = ({ appearance, label = 'Rovo', size = (0, _constants.defaultLogoParams).size, testId, textColor = (0, _constants.defaultLogoParams).textColor, iconColor = (0, _constants.defaultLogoParams).iconColor })=>{
    const { colorMode } = (0, _useThemeObserver.useThemeObserver)();
    return /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _wrapperDefault.default), {
        appearance: appearance,
        iconColor: iconColor,
        label: label,
        size: size,
        svg: svg({
            appearance,
            iconColor,
            textColor
        }, colorMode),
        testId: testId,
        textColor: textColor
    });
};

},{"react":"ltHCL","@atlaskit/tokens/use-theme-observer":"4S775","../../constants":"kYpRl","../../wrapper":"9ojnE","../get-colors-from-appearance":"jcOxk","@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"fqqOI":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "StatuspageIcon", ()=>(0, _icon.StatuspageIcon));
parcelHelpers.export(exports, "StatuspageLogo", ()=>(0, _logo.StatuspageLogo));
var _icon = require("./icon");
var _logo = require("./logo");

},{"./icon":"3PEL1","./logo":"aBuND","@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"3PEL1":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "StatuspageIcon", ()=>StatuspageIcon);
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _useThemeObserver = require("@atlaskit/tokens/use-theme-observer");
var _constants = require("../../constants");
var _wrapper = require("../../wrapper");
var _wrapperDefault = parcelHelpers.interopDefault(_wrapper);
var _getColorsFromAppearance = require("../get-colors-from-appearance");
const svg = ({ appearance, iconColor }, colorMode)=>{
    let colors = {
        iconColor
    };
    if (appearance) colors = (0, _getColorsFromAppearance.getColorsFromAppearance)(appearance, colorMode);
    return `<svg fill="none" height="32" viewBox="0 0 32 32" focusable="false" aria-hidden="true" xmlns="http://www.w3.org/2000/svg">
      <path fill="${colors.iconColor}" d="M16 12.604c-3.033 0-5.981 1.37-8.39 3.489q-.375.373-.748.373c-.208 0-.415-.124-.581-.332l-3.032-3.572c-.166-.207-.25-.415-.25-.581 0-.25.125-.457.374-.706 3.655-3.24 8.1-5.067 12.627-5.067s8.97 1.827 12.626 5.067c.249.249.374.457.374.706 0 .166-.084.374-.25.581l-3.032 3.572c-.166.208-.373.332-.581.332q-.374 0-.748-.374c-2.409-2.118-5.358-3.488-8.39-3.488m0 13.374c-3.365 0-6.106-2.742-6.106-6.064S12.635 13.85 16 13.85s6.106 2.7 6.106 6.064-2.741 6.063-6.105 6.063"/>
    </svg>`;
};
const StatuspageIcon = ({ appearance, label = 'Statuspage', size = (0, _constants.defaultLogoParams).size, testId, iconColor = (0, _constants.defaultLogoParams).iconColor, textColor = (0, _constants.defaultLogoParams).textColor })=>{
    const { colorMode } = (0, _useThemeObserver.useThemeObserver)();
    return /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _wrapperDefault.default), {
        appearance: appearance,
        label: label,
        svg: svg({
            appearance,
            iconColor
        }, colorMode),
        iconColor: iconColor,
        size: size,
        testId: testId,
        textColor: textColor
    });
};

},{"react":"ltHCL","@atlaskit/tokens/use-theme-observer":"4S775","../../constants":"kYpRl","../../wrapper":"9ojnE","../get-colors-from-appearance":"jcOxk","@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"aBuND":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "StatuspageLogo", ()=>StatuspageLogo);
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _useThemeObserver = require("@atlaskit/tokens/use-theme-observer");
var _constants = require("../../constants");
var _wrapper = require("../../wrapper");
var _wrapperDefault = parcelHelpers.interopDefault(_wrapper);
var _getColorsFromAppearance = require("../get-colors-from-appearance");
const svg = ({ appearance, iconColor, textColor }, colorMode)=>{
    let colors = {
        iconColor,
        textColor
    };
    if (appearance) colors = (0, _getColorsFromAppearance.getColorsFromAppearance)(appearance, colorMode);
    return `<svg fill="none" height="32" viewBox="0 0 188 32" focusable="false" aria-hidden="true" xmlns="http://www.w3.org/2000/svg">
      <path fill="${colors.iconColor}" d="M13 12.604c-3.032 0-5.98 1.37-8.39 3.489q-.373.373-.747.373c-.208 0-.416-.124-.582-.332L.25 12.562c-.167-.207-.25-.415-.25-.581 0-.25.125-.457.374-.706C4.029 8.035 8.473 6.208 13 6.208s8.971 1.827 12.626 5.067c.25.249.374.457.374.706 0 .166-.083.374-.25.581l-3.031 3.572c-.166.208-.374.332-.582.332q-.373 0-.747-.374c-2.41-2.118-5.358-3.488-8.39-3.488m0 13.374c-3.364 0-6.105-2.742-6.105-6.064S9.635 13.85 13 13.85c3.364 0 6.105 2.7 6.105 6.064s-2.74 6.063-6.105 6.063" />
      <path fill="${colors.textColor}" d="M180.293 12.293c-2.79 0-4.201 1.81-4.477 4.477h8.556c-.153-2.852-1.441-4.477-4.079-4.477m5.888 12.635c-1.257.674-3.189.92-4.753.92-5.735 0-8.249-3.312-8.249-8.004 0-4.631 2.576-7.943 7.237-7.943 4.723 0 6.624 3.281 6.624 7.943v1.196h-11.193c.368 2.606 2.054 4.293 5.673 4.293 1.779 0 3.281-.337 4.661-.828zm-18.638-.614v-1.533c-.981 2.024-2.821 3.067-5.183 3.067-4.048 0-6.072-3.466-6.072-7.974 0-4.324 2.116-7.973 6.379-7.973 2.239 0 3.956 1.012 4.876 3.005v-2.698h2.576V24.16c0 4.508-2.116 7.544-7.605 7.544-2.576 0-3.987-.337-5.459-.828V28.3c1.687.552 3.435.92 5.336.92 3.833 0 5.152-2.055 5.152-4.907m-8.679-6.44c0 3.68 1.472 5.52 4.202 5.52 2.361 0 4.477-1.503 4.477-4.906V17.26c0-3.404-1.932-4.907-4.171-4.907-2.974 0-4.508 1.963-4.508 5.52m-16.949.001c0 3.68 1.472 5.52 4.201 5.52 2.362 0 4.478-1.503 4.478-4.906V17.26c0-3.404-1.932-4.907-4.171-4.907-2.975 0-4.508 1.963-4.508 5.52m8.679 7.667v-2.76c-.982 2.024-2.822 3.066-5.183 3.066-4.079 0-6.133-3.465-6.133-7.973 0-4.324 2.146-7.973 6.44-7.973 2.238 0 3.956 1.012 4.876 3.005v-2.699h2.637V25.54zm-16.091-7.666c0-3.68-1.472-5.52-4.201-5.52-2.361 0-4.477 1.503-4.477 4.907v1.227c0 3.404 1.932 4.906 4.17 4.906 2.975 0 4.508-1.962 4.508-5.52m-3.802 7.974c-2.239 0-3.956-1.013-4.876-3.006v8.679h-2.638V10.207h2.638v2.76c.981-2.024 2.821-3.066 5.182-3.066 4.079 0 6.134 3.465 6.134 7.973 0 4.324-2.147 7.973-6.44 7.973m-10.56-4.477c0 2.545-1.656 4.477-5.765 4.477-2.3 0-4.171-.52-5.336-1.134v-2.79c1.318.766 3.526 1.502 5.458 1.502 2.024 0 3.067-.828 3.067-2.024 0-1.165-.889-1.84-3.803-2.545-3.404-.829-4.845-2.147-4.845-4.662 0-2.668 2.055-4.293 5.551-4.293 1.993 0 3.802.49 4.937 1.104v2.73c-1.84-.92-3.343-1.411-4.968-1.411-1.932 0-2.975.674-2.975 1.87 0 1.073.736 1.748 3.558 2.423 3.404.828 5.121 2.085 5.121 4.753m-27.598-2.177v-8.985h2.638v9.26c0 2.76 1.104 3.988 3.618 3.988 2.454 0 4.14-1.626 4.14-4.723v-8.525h2.638V25.54h-2.638v-2.515c-.981 1.81-2.79 2.821-4.845 2.821-3.527 0-5.55-2.422-5.55-6.654m-7.155 1.596c0 1.349.797 2.269 2.422 2.269.614 0 1.196-.123 1.656-.215v2.546a6.3 6.3 0 0 1-1.778.245c-3.282 0-4.876-1.932-4.876-4.784v-8.188h-2.484v-2.453h2.484V6.957h2.576v3.25h4.078v2.454H85.39zm-18.943-2.914c0 3.68 1.472 5.52 4.202 5.52 2.361 0 4.477-1.503 4.477-4.906V17.26c0-3.404-1.932-4.907-4.17-4.907-2.975 0-4.509 1.963-4.509 5.52m8.679 7.667v-2.76c-.981 2.024-2.821 3.066-5.183 3.066-4.078 0-6.133-3.465-6.133-7.973 0-4.324 2.147-7.973 6.44-7.973 2.239 0 3.956 1.012 4.876 3.005v-2.699h2.637V25.54zm-17.258-4.752c0 1.349.797 2.269 2.422 2.269.614 0 1.196-.123 1.656-.215v2.546a6.3 6.3 0 0 1-1.778.245c-3.282 0-4.876-1.932-4.876-4.784v-8.188h-2.484v-2.453h2.484V6.957h2.576v3.25h4.078v2.454h-4.078zm-6.894-.798c0 3.496-2.085 5.858-7.084 5.858-3.894 0-5.704-.767-7.268-1.564v-2.822c1.871.982 4.754 1.687 7.422 1.687 3.036 0 4.17-1.196 4.17-2.975 0-1.778-1.104-2.729-4.937-3.649-4.539-1.104-6.563-2.668-6.563-5.98 0-3.128 2.392-5.459 7.084-5.459 2.914 0 4.784.706 6.164 1.472v2.76c-2.024-1.165-4.201-1.533-6.286-1.533-2.638 0-4.202.92-4.202 2.76 0 1.656 1.288 2.484 4.846 3.373 4.262 1.074 6.654 2.454 6.654 6.072" />
    </svg>`;
};
const StatuspageLogo = ({ appearance, label = 'Statuspage', size = (0, _constants.defaultLogoParams).size, testId, iconColor = (0, _constants.defaultLogoParams).iconColor, textColor = (0, _constants.defaultLogoParams).textColor })=>{
    const { colorMode } = (0, _useThemeObserver.useThemeObserver)();
    return /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _wrapperDefault.default), {
        appearance: appearance,
        label: label,
        iconColor: iconColor,
        size: size,
        svg: svg({
            appearance,
            iconColor,
            textColor
        }, colorMode),
        testId: testId,
        textColor: textColor
    });
};

},{"react":"ltHCL","@atlaskit/tokens/use-theme-observer":"4S775","../../constants":"kYpRl","../../wrapper":"9ojnE","../get-colors-from-appearance":"jcOxk","@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"hQloK":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "TrelloIcon", ()=>(0, _icon.TrelloIcon));
parcelHelpers.export(exports, "TrelloLogo", ()=>(0, _logo.TrelloLogo));
var _icon = require("./icon");
var _logo = require("./logo");

},{"./icon":"3HLgC","./logo":"js4Ez","@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"3HLgC":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "TrelloIcon", ()=>TrelloIcon);
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _useThemeObserver = require("@atlaskit/tokens/use-theme-observer");
var _constants = require("../../constants");
var _wrapper = require("../../wrapper");
var _wrapperDefault = parcelHelpers.interopDefault(_wrapper);
var _getColorsFromAppearance = require("../get-colors-from-appearance");
const svg = ({ appearance, iconColor }, colorMode)=>{
    let colors = {
        iconColor
    };
    if (appearance) colors = (0, _getColorsFromAppearance.getColorsFromAppearance)(appearance, colorMode);
    return `<svg fill="none" height="32" viewBox="0 0 32 32" focusable="false" aria-hidden="true" xmlns="http://www.w3.org/2000/svg">
      <path fill=${colors.iconColor} clip-rule="evenodd" d="M24.286 5.337H7.714a2.585 2.585 0 0 0-2.585 2.585v16.572a2.585 2.585 0 0 0 2.585 2.584h16.572a2.585 2.585 0 0 0 2.585-2.584V7.922a2.585 2.585 0 0 0-2.585-2.585m-9.791 15.66a.86.86 0 0 1-.859.858h-3.634a.86.86 0 0 1-.859-.859V10.21a.86.86 0 0 1 .859-.86h3.634a.86.86 0 0 1 .859.86zm8.362-4.953a.86.86 0 0 1-.859.859h-3.634a.86.86 0 0 1-.859-.859V10.21a.86.86 0 0 1 .859-.86h3.634a.86.86 0 0 1 .859.86z" fill-rule="evenodd"/>
    </svg>`;
};
const TrelloIcon = ({ appearance, label = 'Trello', size = (0, _constants.defaultLogoParams).size, testId, iconColor = (0, _constants.defaultLogoParams).iconColor, textColor = (0, _constants.defaultLogoParams).textColor })=>{
    const { colorMode } = (0, _useThemeObserver.useThemeObserver)();
    return /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _wrapperDefault.default), {
        appearance: appearance,
        label: label,
        svg: svg({
            appearance,
            iconColor
        }, colorMode),
        iconColor: iconColor,
        size: size,
        testId: testId,
        textColor: textColor
    });
};

},{"react":"ltHCL","@atlaskit/tokens/use-theme-observer":"4S775","../../constants":"kYpRl","../../wrapper":"9ojnE","../get-colors-from-appearance":"jcOxk","@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"js4Ez":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "TrelloLogo", ()=>TrelloLogo);
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _useThemeObserver = require("@atlaskit/tokens/use-theme-observer");
var _constants = require("../../constants");
var _wrapper = require("../../wrapper");
var _wrapperDefault = parcelHelpers.interopDefault(_wrapper);
var _getColorsFromAppearance = require("../get-colors-from-appearance");
const svg = ({ appearance, iconColor, textColor }, colorMode)=>{
    let colors = {
        iconColor,
        textColor
    };
    if (appearance) colors = (0, _getColorsFromAppearance.getColorsFromAppearance)(appearance, colorMode);
    return `<svg fill="none" height="32" viewBox="0 0 106 32" focusable="false" aria-hidden="true" xmlns="http://www.w3.org/2000/svg">
      <path fill="${colors.iconColor}" clip-rule="evenodd" d="M19.157 4.67H2.585A2.585 2.585 0 0 0 0 7.255v16.572a2.585 2.585 0 0 0 2.585 2.585h16.572a2.585 2.585 0 0 0 2.584-2.585V7.255a2.585 2.585 0 0 0-2.584-2.585M9.365 20.33a.86.86 0 0 1-.858.858H4.873a.86.86 0 0 1-.859-.858V9.543c0-.475.385-.859.859-.859h3.634c.474 0 .858.385.858.86zm8.362-4.952a.86.86 0 0 1-.858.858h-3.634a.86.86 0 0 1-.859-.858V9.543c0-.475.385-.859.859-.859h3.634c.474 0 .858.385.858.86z" fill-rule="evenodd"/>
      <path fill="${colors.textColor}" d="M97.64 25.848c-4.6 0-7.298-3.404-7.298-8.004S93.04 9.9 97.64 9.9c4.57 0 7.238 3.342 7.238 7.942s-2.668 8.004-7.238 8.004m0-13.494c-3.281 0-4.722 2.576-4.722 5.49 0 2.913 1.44 5.55 4.722 5.55 3.251 0 4.662-2.637 4.662-5.55 0-2.914-1.411-5.49-4.662-5.49M88.874 25.51c-.215.062-.675.123-1.35.123-2.514 0-4.109-1.196-4.109-4.017V3.798h2.637V21.31c0 1.38.92 1.87 2.055 1.87.276 0 .46 0 .767-.03zm-7.996 0c-.215.062-.675.123-1.35.123-2.514 0-4.109-1.196-4.109-4.017V3.798h2.637V21.31c0 1.38.92 1.87 2.055 1.87.276 0 .46 0 .767-.03zM65.532 12.293c-2.79 0-4.202 1.81-4.478 4.477h8.556c-.153-2.852-1.44-4.477-4.078-4.477m5.888 12.635c-1.258.674-3.19.92-4.754.92-5.734 0-8.249-3.312-8.249-8.004 0-4.631 2.576-7.943 7.237-7.943 4.723 0 6.624 3.281 6.624 7.943v1.196H61.085c.368 2.606 2.055 4.293 5.673 4.293 1.78 0 3.282-.337 4.662-.828zm-19.48-8.434v9.047h-2.576V10.208h2.576v2.698c.89-1.809 2.423-3.097 5.428-2.913v2.576c-3.373-.337-5.428.675-5.428 3.925M32.943 5.393H48.03V8.03h-6.164v17.511h-2.76V8.031h-6.164z"/>
    </svg>`;
};
const TrelloLogo = ({ appearance, label = 'Trello', size = (0, _constants.defaultLogoParams).size, testId, iconColor = (0, _constants.defaultLogoParams).iconColor, textColor = (0, _constants.defaultLogoParams).textColor })=>{
    const { colorMode } = (0, _useThemeObserver.useThemeObserver)();
    return /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _wrapperDefault.default), {
        appearance: appearance,
        label: label,
        iconColor: iconColor,
        size: size,
        svg: svg({
            appearance,
            textColor
        }, colorMode),
        testId: testId,
        textColor: textColor
    });
};

},{"react":"ltHCL","@atlaskit/tokens/use-theme-observer":"4S775","../../constants":"kYpRl","../../wrapper":"9ojnE","../get-colors-from-appearance":"jcOxk","@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"iz94O":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "JiraWorkManagementIcon", ()=>(0, _icon.JiraWorkManagementIcon));
parcelHelpers.export(exports, "JiraWorkManagementLogo", ()=>(0, _logo.JiraWorkManagementLogo));
var _icon = require("./icon");
var _logo = require("./logo");

},{"./icon":"7c2HA","./logo":false,"@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"7c2HA":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "JiraWorkManagementIcon", ()=>JiraWorkManagementIcon);
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _useId = require("@atlaskit/ds-lib/use-id");
var _useThemeObserver = require("@atlaskit/tokens/use-theme-observer");
var _constants = require("../../constants");
var _wrapper = require("../../wrapper");
var _wrapperDefault = parcelHelpers.interopDefault(_wrapper);
var _getColorsFromAppearanceOldLogos = require("../get-colors-from-appearance-old-logos");
const svg = ({ appearance, iconColor }, colorMode, id)=>{
    let colors = {
        iconGradientStart: (0, _constants.legacyDefaultLogoParams).iconGradientStart,
        iconGradientStop: (0, _constants.legacyDefaultLogoParams).iconGradientStart,
        iconColor
    };
    if (appearance) colors = (0, _getColorsFromAppearanceOldLogos.getColorsFromAppearanceOldLogos)(appearance, colorMode);
    return `
    <svg
      fill="none"
      height="32"
      viewBox="0 0 32 32"
      xmlns="http://www.w3.org/2000/svg"
    >
      <linearGradient
        id="${id}"
        gradientUnits="userSpaceOnUse"
        x1="13.9485"
        x2="20.7792"
        y1="20.2388"
        y2="11.8277"
      >
        <stop offset="0" stop-color="${colors.iconGradientStart}" ${colors.iconGradientStart === 'inherit' ? 'stop-opacity="0.4"' : ''} />
        <stop offset="100%" stop-color="${colors.iconGradientStop}" />
      </linearGradient>
      <path
        d="m18.3893 7-3.4257 13.1867c4.3592 1.2052 7.8383-.3558 9.1709-5.4802l1.9988-7.6973z"
        fill="url(#${id})"
      />
      <path
      fill="${colors.iconColor}"
      d="m13.7566 24.8265 3.4257-13.1866c-4.3623-1.196-7.8383.3649-9.17087 5.4985l-2.01143 7.6881z"
      />
    </svg>`;
};
const JiraWorkManagementIcon = ({ appearance, label = 'Jira Work Management', size = (0, _constants.defaultLogoParams).size, testId, iconColor = (0, _constants.defaultLogoParams).iconColor, textColor = (0, _constants.defaultLogoParams).textColor })=>{
    const { colorMode } = (0, _useThemeObserver.useThemeObserver)();
    const id = (0, _useId.useId)();
    return /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _wrapperDefault.default), {
        appearance: appearance,
        label: label,
        svg: svg({
            appearance,
            iconColor
        }, colorMode, id),
        iconColor: iconColor,
        size: size,
        testId: testId,
        textColor: textColor
    });
};

},{"react":"ltHCL","@atlaskit/ds-lib/use-id":"9jWCD","@atlaskit/tokens/use-theme-observer":"4S775","../../constants":"kYpRl","../../wrapper":"9ojnE","../get-colors-from-appearance-old-logos":"10zPy","@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"fc0zD":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "AtlassianIcon", ()=>(0, _icon.AtlassianIcon));
parcelHelpers.export(exports, "AtlassianLogo", ()=>(0, _logo.AtlassianLogo));
var _icon = require("./icon");
var _logo = require("./logo");

},{"./icon":"hrJe0","./logo":"l2a2p","@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"hrJe0":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "AtlassianIcon", ()=>AtlassianIcon);
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _useThemeObserver = require("@atlaskit/tokens/use-theme-observer");
var _constants = require("../../constants");
var _wrapper = require("../../wrapper");
var _wrapperDefault = parcelHelpers.interopDefault(_wrapper);
var _getColorsFromAppearance = require("../get-colors-from-appearance");
const svg = ({ appearance, iconColor }, colorMode)=>{
    let colors = {
        iconColor
    };
    if (appearance) colors = (0, _getColorsFromAppearance.getColorsFromAppearance)(appearance, colorMode);
    return `<svg fill="none" height="32" viewBox="0 0 32 32" focusable="false" aria-hidden="true" xmlns="http://www.w3.org/2000/svg">
      <path fill="${colors.iconColor}" d="M27.545 24.378 16.96 3.208c-.208-.458-.417-.541-.667-.541-.208 0-.458.083-.708.5-1.5 2.375-2.167 5.125-2.167 8 0 4.001 2.042 7.752 5.042 13.795.334.666.584.791 1.167.791h7.335c.541 0 .833-.208.833-.625 0-.208-.042-.333-.25-.75M12.168 14.377c-.834-1.25-1.084-1.334-1.292-1.334s-.333.083-.708.834L4.875 24.46c-.167.334-.208.459-.208.625 0 .334.291.667.916.667h7.46c.5 0 .875-.416 1.083-1.208.25-1 .334-1.876.334-2.917 0-2.917-1.292-5.751-2.292-7.251"/>
    </svg>`;
};
const AtlassianIcon = ({ appearance, label = 'Atlassian', size = (0, _constants.defaultLogoParams).size, iconColor = (0, _constants.defaultLogoParams).iconColor, textColor = (0, _constants.defaultLogoParams).textColor, testId })=>{
    const { colorMode } = (0, _useThemeObserver.useThemeObserver)();
    return /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _wrapperDefault.default), {
        appearance: appearance,
        label: label,
        svg: svg({
            appearance,
            iconColor
        }, colorMode),
        iconColor: iconColor,
        textColor: textColor,
        size: size,
        testId: testId
    });
};

},{"react":"ltHCL","@atlaskit/tokens/use-theme-observer":"4S775","../../constants":"kYpRl","../../wrapper":"9ojnE","../get-colors-from-appearance":"jcOxk","@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"l2a2p":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "AtlassianLogo", ()=>AtlassianLogo);
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _useThemeObserver = require("@atlaskit/tokens/use-theme-observer");
var _constants = require("../../constants");
var _wrapper = require("../../wrapper");
var _wrapperDefault = parcelHelpers.interopDefault(_wrapper);
var _getColorsFromAppearance = require("../get-colors-from-appearance");
const svg = ({ appearance, iconColor, textColor }, colorMode)=>{
    let colors = {
        iconColor,
        textColor,
        // We treat the word "Atlassian" differently to normal app logos, it has a bold brand look
        atlassianLogoTextColor: textColor
    };
    if (appearance) colors = (0, _getColorsFromAppearance.getColorsFromAppearance)(appearance, colorMode);
    return `<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 198 32" focusable="false" aria-hidden="true" height="32" fill="none">
      <path fill=${colors.iconColor} d="M22.878 24.378 12.293 3.208c-.208-.458-.416-.541-.666-.541-.209 0-.459.083-.709.5-1.5 2.375-2.167 5.125-2.167 8 0 4.001 2.042 7.752 5.043 13.794.333.667.583.792 1.166.792h7.335c.542 0 .833-.208.833-.625 0-.208-.041-.333-.25-.75M7.501 14.377c-.833-1.25-1.083-1.334-1.292-1.334s-.333.083-.708.834L.208 24.46c-.166.334-.208.459-.208.625 0 .334.292.667.917.667h7.46c.5 0 .874-.416 1.083-1.208.25-1 .333-1.876.333-2.917 0-2.917-1.292-5.751-2.292-7.251z"/>
      <path fill=${colors.atlassianLogoTextColor} d="M107.447 10.828c0 2.972 1.345 5.308 6.795 6.37 3.185.707 3.893 1.203 3.893 2.265 0 1.061-.708 1.698-2.973 1.698-2.619 0-5.733-.92-7.785-2.123v4.813c1.627.778 3.751 1.698 7.785 1.698 5.662 0 7.856-2.548 7.856-6.228m0 .07c0-3.538-1.84-5.166-7.148-6.298-2.902-.637-3.61-1.274-3.61-2.194 0-1.133 1.062-1.628 2.973-1.628 2.335 0 4.6.708 6.794 1.698v-4.6c-1.557-.779-3.892-1.345-6.653-1.345-5.237 0-7.927 2.265-7.927 5.945m72.475-5.803v20.17h4.318V9.979l1.769 4.035 6.087 11.324h5.379V5.166h-4.247v13.022l-1.628-3.821-4.883-9.201zm-27.319 0h-4.671v20.17h4.671zm-10.05 14.154c0-3.538-1.841-5.166-7.149-6.298-2.902-.637-3.609-1.274-3.609-2.194 0-1.133 1.061-1.628 2.972-1.628 2.336 0 4.601.708 6.795 1.699v-4.6c-1.557-.78-3.893-1.346-6.653-1.346-5.238 0-7.927 2.265-7.927 5.946 0 2.972 1.344 5.308 6.794 6.37 3.185.707 3.893 1.203 3.893 2.264 0 1.062-.708 1.699-2.973 1.699-2.618 0-5.733-.92-7.785-2.123v4.812c1.628.779 3.751 1.699 7.785 1.699 5.592 0 7.857-2.548 7.857-6.3M71.069 5.166v20.17h9.625l1.486-4.387h-6.44V5.166zm-19.039 0v4.317h5.167v15.854h4.741V9.483h5.592V5.166zm-6.866 0h-6.157L32 25.336h5.379l.99-3.396c1.204.353 2.478.566 3.752.566s2.548-.213 3.751-.567l.991 3.398h5.379c-.07 0-7.078-20.171-7.078-20.171M42.05 18.259c-.92 0-1.77-.141-2.548-.354L42.05 9.13l2.548 8.776a9.6 9.6 0 0 1-2.548.354zM97.326 5.166H91.17l-7.078 20.17h5.38l.99-3.396c1.203.353 2.477.566 3.751.566s2.548-.213 3.751-.567l.991 3.398h5.379zm-3.114 13.093c-.92 0-1.77-.141-2.548-.354l2.548-8.776 2.548 8.776a9.6 9.6 0 0 1-2.548.354m75.306-13.093h-6.157l-7.007 20.17h5.379l.991-3.396c1.203.353 2.477.566 3.751.566s2.548-.213 3.751-.567l.991 3.398h5.379zm-3.043 13.093c-.92 0-1.77-.141-2.548-.354l2.548-8.776 2.548 8.776a10 10 0 0 1-2.548.354"/>
    </svg>`;
};
const AtlassianLogo = ({ appearance, label = 'Atlassian', size = (0, _constants.defaultLogoParams).size, testId, iconColor = (0, _constants.defaultLogoParams).iconColor, textColor = (0, _constants.defaultLogoParams).textColor })=>{
    const { colorMode } = (0, _useThemeObserver.useThemeObserver)();
    return /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _wrapperDefault.default), {
        appearance: appearance,
        label: label,
        svg: svg({
            appearance,
            iconColor,
            textColor
        }, colorMode),
        iconColor: iconColor,
        size: size,
        testId: testId,
        textColor: textColor
    });
};

},{"react":"ltHCL","@atlaskit/tokens/use-theme-observer":"4S775","../../constants":"kYpRl","../../wrapper":"9ojnE","../get-colors-from-appearance":"jcOxk","@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"hPZJ7":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "JiraSoftwareIcon", ()=>(0, _icon.JiraSoftwareIcon));
parcelHelpers.export(exports, "JiraSoftwareLogo", ()=>(0, _logo.JiraSoftwareLogo));
var _icon = require("./icon");
var _logo = require("./logo");

},{"./icon":"lhuea","./logo":false,"@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"lhuea":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "JiraSoftwareIcon", ()=>JiraSoftwareIcon);
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _useId = require("@atlaskit/ds-lib/use-id");
var _useThemeObserver = require("@atlaskit/tokens/use-theme-observer");
var _constants = require("../../constants");
var _wrapper = require("../../wrapper");
var _wrapperDefault = parcelHelpers.interopDefault(_wrapper);
var _getColorsFromAppearanceOldLogos = require("../get-colors-from-appearance-old-logos");
const svg = ({ appearance, iconColor }, colorMode, id)=>{
    let colors = {
        iconGradientStart: (0, _constants.legacyDefaultLogoParams).iconGradientStart,
        iconGradientStop: (0, _constants.legacyDefaultLogoParams).iconGradientStart,
        iconColor
    };
    if (appearance) colors = (0, _getColorsFromAppearanceOldLogos.getColorsFromAppearanceOldLogos)(appearance, colorMode);
    return `
  <svg viewBox="0 0 32 32" height="32" xmlns="http://www.w3.org/2000/svg" focusable="false" aria-hidden="true">
    <defs>
      <linearGradient x1="108.695%" x2="12.439%" y1="-14.936%" y2="45.215%" id="${id}-1">
        <stop stop-color="${colors.iconGradientStart}" ${colors.iconGradientStart === 'inherit' ? 'stop-opacity="0.4"' : ''} offset="0%"></stop>
        <stop stop-color="${colors.iconGradientStop}" offset="100%"></stop>
      </linearGradient>
      <linearGradient x1="0%" x2="91.029%" y1="118.55%" y2="63.971%" id="${id}-2">
        <stop stop-color="${colors.iconGradientStart}" ${colors.iconGradientStart === 'inherit' ? 'stop-opacity="0.4"' : ''} offset="0%"></stop>
        <stop stop-color="${colors.iconGradientStop}" offset="100%"></stop>
      </linearGradient>
    </defs>
    <g stroke="none" stroke-width="1" fill-rule="nonzero">
      <path fill="${colors.iconColor}" d="M15.9669691 29.3616152C17.2195568 28.1097726 17.9233158 26.4114623 17.9233158 24.6405626 17.9233158 22.8696629 17.2195568 21.1713527 15.9669691 19.91951L7.26805808 11.2489111 3.31143376 15.2055354C2.89743442 15.6200502 2.89743442 16.291565 3.31143376 16.7060799L15.9669691 29.3616152zM28.6225045 15.2055354L15.9669691 2.55 15.9280399 2.58892922C13.3485687 5.19994003 13.3612164 9.40374108 15.9563521 11.9991833L24.6623412 20.6662432 28.6225045 16.7060799C29.0365039 16.291565 29.0365039 15.6200502 28.6225045 15.2055354z" />
      <path fill="url(#${id}-1" d="M15.9669691,11.9921053 C13.3718335,9.39666304 13.3591857,5.19286199 15.938657,2.58185118 L6.91061706,11.6063521 L11.6316697,16.3274047 L15.9669691,11.9921053 Z" />
      <path fill="url(#${id}-2" d="M20.2951906,15.5912886 L15.9669691,19.91951 C17.2195568,21.1713527 17.9233158,22.8696629 17.9233158,24.6405626 C17.9233158,26.4114623 17.2195568,28.1097726 15.9669691,29.3616152 L25.0162432,20.3123412 L20.2951906,15.5912886 Z" />
    </g>
  </svg>`;
};
const JiraSoftwareIcon = ({ appearance, label = 'Jira Software', size = (0, _constants.defaultLogoParams).size, testId, iconColor = (0, _constants.defaultLogoParams).iconColor, textColor = (0, _constants.defaultLogoParams).textColor })=>{
    const { colorMode } = (0, _useThemeObserver.useThemeObserver)();
    const id = (0, _useId.useId)();
    return /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _wrapperDefault.default), {
        appearance: appearance,
        label: label,
        svg: svg({
            appearance,
            iconColor
        }, colorMode, id),
        iconColor: iconColor,
        size: size,
        testId: testId,
        textColor: textColor
    });
};

},{"react":"ltHCL","@atlaskit/ds-lib/use-id":"9jWCD","@atlaskit/tokens/use-theme-observer":"4S775","../../constants":"kYpRl","../../wrapper":"9ojnE","../get-colors-from-appearance-old-logos":"10zPy","@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"e3QCB":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "logoDocsSchema", ()=>(0, _logoDocsSchema.logoDocsSchema));
parcelHelpers.export(exports, "PROGRAM_LOGO_DOCS_ORDER", ()=>(0, _logoDocsSchema.PROGRAM_LOGO_DOCS_ORDER));
parcelHelpers.export(exports, "APP_LOGO_DOCS_ORDER", ()=>(0, _logoDocsSchema.APP_LOGO_DOCS_ORDER));
parcelHelpers.export(exports, "AGENT_LOGO_DOCS_ORDER", ()=>(0, _logoDocsSchema.AGENT_LOGO_DOCS_ORDER));
parcelHelpers.export(exports, "LEGACY_ONLY_LOGOS", ()=>(0, _logoDocsSchema.LEGACY_ONLY_LOGOS));
parcelHelpers.export(exports, "SHARED_LOGOS", ()=>(0, _logoDocsSchema.SHARED_LOGOS));
parcelHelpers.export(exports, "NEW_ONLY_LOGOS", ()=>(0, _logoDocsSchema.NEW_ONLY_LOGOS));
parcelHelpers.export(exports, "createFeatureFlaggedComponent", ()=>(0, _createFeatureFlaggedComponent.createFeatureFlaggedComponent));
parcelHelpers.export(exports, "createFeatureFlaggedServiceCollectionComponent", ()=>(0, _createFeatureFlaggedServiceCollectionComponent.createFeatureFlaggedServiceCollectionComponent));
parcelHelpers.export(exports, "tempSizeWrapper", ()=>(0, _tempSizeWrapper.tempSizeWrapper));
parcelHelpers.export(exports, "createFeatureFlaggedRovoComponent", ()=>createFeatureFlaggedRovoComponent);
var _objectWithoutProperties = require("@swc/helpers/_/_object_without_properties");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _tempSizeWrapper = require("./temp-size-wrapper");
var _logoDocsSchema = require("./logo-docs-schema");
var _createFeatureFlaggedComponent = require("./create-feature-flagged-component");
var _createFeatureFlaggedServiceCollectionComponent = require("./create-feature-flagged-service-collection-component");
const createFeatureFlaggedRovoComponent = (_LegacyComponent, _NewComponent, NewHexComponent)=>{
    const RovoHexWrapped = (0, _tempSizeWrapper.tempSizeWrapper)(NewHexComponent);
    return (_param)=>{
        var { shouldUseHexLogo: _shouldUseHexLogo } = _param, props = (0, _objectWithoutProperties._)(_param, [
            "shouldUseHexLogo"
        ]);
        // Hex logo is now always used (platform-logo-rebrand-rovo-hex fully launched)
        return /*#__PURE__*/ (0, _reactDefault.default).createElement(RovoHexWrapped, props);
    };
};

},{"@swc/helpers/_/_object_without_properties":"6HqIM","react":"ltHCL","./temp-size-wrapper":"gwyCQ","./logo-docs-schema":false,"./create-feature-flagged-component":false,"./create-feature-flagged-service-collection-component":false,"@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"gwyCQ":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "tempSizeWrapper", ()=>tempSizeWrapper);
var _objectSpread = require("@swc/helpers/_/_object_spread");
var _objectWithoutProperties = require("@swc/helpers/_/_object_without_properties");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
const tempSizeWrapper = (NewComponent)=>{
    return (_param)=>{
        var { size } = _param, props = (0, _objectWithoutProperties._)(_param, [
            "size"
        ]);
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        const Component = NewComponent;
        return /*#__PURE__*/ (0, _reactDefault.default).createElement(Component, (0, _objectSpread._)({
            size: size || 'medium'
        }, props));
    };
};

},{"@swc/helpers/_/_object_spread":"9gdrV","@swc/helpers/_/_object_without_properties":"6HqIM","react":"ltHCL","@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"iGGpO":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _ufoloadHold = require("./UFOLoadHold");
var _ufoloadHoldDefault = parcelHelpers.interopDefault(_ufoloadHold);
exports.default = (0, _ufoloadHoldDefault.default);

},{"./UFOLoadHold":"l7xK8","@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"5UJMi":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "AtlassianRelayEnvironmentProvider", ()=>AtlassianRelayEnvironmentProvider);
parcelHelpers.export(exports, "RelayEnvironmentProvider", ()=>RelayEnvironmentProvider);
parcelHelpers.export(exports, "ConditionalRelayEnvironmentProvider", ()=>ConditionalRelayEnvironmentProvider);
parcelHelpers.export(exports, "useRelayEnvironmentProvider", ()=>useRelayEnvironmentProvider);
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _reactRelay = require("react-relay");
var _environment = require("./environment");
function AtlassianRelayEnvironmentProvider({ children }) {
    return /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _reactRelay.RelayEnvironmentProvider), {
        environment: (0, _environment.__INTERNAL_RELAY_ENVIRONMENT__DO_NOT_USE_THIS_DIRECTLY__)
    }, children);
}
const RelayEnvironmentProvider = AtlassianRelayEnvironmentProvider;
const ConditionalRelayEnvironmentProvider = ({ children })=>{
    const isRelayPresent = (0, _react.useContext)((0, _reactRelay.ReactRelayContext));
    if (isRelayPresent) return children;
    return /*#__PURE__*/ (0, _reactDefault.default).createElement(AtlassianRelayEnvironmentProvider, null, children);
};
function useRelayEnvironmentProvider() {
    const environment = (0, _reactRelay.useRelayEnvironment)();
    return (0, _react.useMemo)(()=>({
            getEnvironment () {
                return environment;
            }
        }), [
        environment
    ]);
}

},{"react":"ltHCL","react-relay":"9HAyN","./environment":"30bzq","@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"30bzq":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "ssrCache", ()=>ssrCache);
parcelHelpers.export(exports, "__INTERNAL_RELAY_ENVIRONMENT__DO_NOT_USE_THIS_DIRECTLY__", ()=>__INTERNAL_RELAY_ENVIRONMENT__DO_NOT_USE_THIS_DIRECTLY__);
var _platformFeatureFlags = require("@atlaskit/platform-feature-flags");
var _createRelayEnvironment = require("@atlassian/relay-environment/createRelayEnvironment");
var _relayErrors = require("@atlassian/relay-errors");
var _relayQueryResponses = require("@atlassian/relay-query-responses");
const getLoggingAndMetricsHelper = ()=>{
    return {
        logNonBreakingErrors: ()=>{},
        logError: ()=>{},
        logErrorRetry: ()=>{},
        logQueryFallbackToPost: ()=>{}
    };
};
const ssrCache = new (0, _relayQueryResponses.SSRQueryResponseCache)({
    cacheName: 'relay-cache/v2/AGG',
    size: Infinity,
    ttl: Infinity
});
const __INTERNAL_RELAY_ENVIRONMENT__DO_NOT_USE_THIS_DIRECTLY__ = (0, _createRelayEnvironment.createRelayEnvironment)({
    networkOptions: {
        getLoggingAndMetricsHelper,
        withErrorHandling: (source)=>source,
        validateResponse: (request, response)=>{
            const errors = 'errors' in response ? response.errors : undefined;
            if (errors != null) {
                var _response_extensions_gateway, _response_extensions;
                const requestId = response === null || response === void 0 ? void 0 : (_response_extensions = response.extensions) === null || _response_extensions === void 0 ? void 0 : (_response_extensions_gateway = _response_extensions.gateway) === null || _response_extensions_gateway === void 0 ? void 0 : _response_extensions_gateway.request_id;
                (0, _relayErrors.captureErrors)(errors, {
                    operationName: request.name,
                    requestId
                });
                if ((0, _platformFeatureFlags.fg)('platform_relay_redirect_on_step_up_auth_studio')) {
                    const { hasStepUpAuthError, stepUpUrl } = (0, _relayErrors.isStepUpAuthError)(errors);
                    // Guard against SSR: window is not defined in server-side rendering environments.
                    // RelayEnvironmentProvider is used by platform components (e.g. GlobalSideNavigation)
                    // during SSR — validateResponse may be called during renderToString where window
                    // does not exist. Without this guard, a step-up auth error would throw
                    // ReferenceError and crash the entire SSR render.
                    if (hasStepUpAuthError && stepUpUrl && typeof window !== 'undefined') window.location.href = stepUpUrl;
                }
            }
            return true;
        },
        onInvalidResponse: ()=>{},
        queryResponseCache: ssrCache,
        // Use typeof window === 'undefined' for SSR detection rather than globalThis.__SERVER__.
        // __SERVER__ is set in tests but not in Bifrost's actual SSR environment (it's set in
        // init() which runs after module evaluation). typeof window === 'undefined' is the
        // standard pattern and correctly identifies both Bifrost SSR and test environments.
        isServer: typeof window === 'undefined'
    }
});

},{"@atlaskit/platform-feature-flags":"8rD2i","@atlassian/relay-environment/createRelayEnvironment":"eiXUF","@atlassian/relay-errors":"dafjR","@atlassian/relay-query-responses":"7ZNPA","@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"eiXUF":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "createRelayEnvironment", ()=>createRelayEnvironment);
var _relayRuntime = require("relay-runtime");
var _liveResolverStore = require("relay-runtime/lib/store/live-resolvers/LiveResolverStore");
var _liveResolverStoreDefault = parcelHelpers.interopDefault(_liveResolverStore);
var _tinyInvariant = require("tiny-invariant");
var _tinyInvariantDefault = parcelHelpers.interopDefault(_tinyInvariant);
var _tinyWarning = require("tiny-warning");
var _tinyWarningDefault = parcelHelpers.interopDefault(_tinyWarning);
var _relayDataId = require("@atlassian/relay-data-id");
var _relayDataIdDefault = parcelHelpers.interopDefault(_relayDataId);
var _multiFetch = require("@atlassian/relay-fetch/multi-fetch");
var _relayMissingFieldHandlers = require("@atlassian/relay-missing-field-handlers");
var _relayMissingFieldHandlersDefault = parcelHelpers.interopDefault(_relayMissingFieldHandlers);
var _relayScheduler = require("@atlassian/relay-scheduler");
var _relaySchedulerDefault = parcelHelpers.interopDefault(_relayScheduler);
var _relaySubscription = require("@atlassian/relay-subscription");
// Enable Relay Resolvers globally for this module
(0, _relayRuntime.RelayFeatureFlags).ENABLE_RELAY_RESOLVERS = true;
function createNetwork(networkOptions) {
    return (0, _relayRuntime.Network).create((request, variables, cacheConfig)=>(0, _multiFetch.fetch)(request, variables, cacheConfig, networkOptions), networkOptions.isServer === false ? (0, _relaySubscription.createSubscribeFn)(networkOptions) : undefined);
}
const createStore = (source, options)=>{
    return new (0, _liveResolverStoreDefault.default)(source, options);
};
// Copied from ConnectionHandler.deleteNode implementation with a single change in behaviour:
// nodeID is compared to the `id` field of the node, rather than node.getDataID().
// This is a sane thing to do within the scope of a single connection even in the light of
// id collisions present in AGG for the entities of different types.
// Such change makes @deleteEdge directive usable again.
function deleteNode(record, nodeID) {
    const { EDGES, NODE } = (0, _relayRuntime.ConnectionInterface).get();
    const edges = record.getLinkedRecords(EDGES);
    if (!edges) return;
    let nextEdges;
    for(let ii = 0; ii < edges.length; ii++){
        const edge = edges[ii];
        const node = edge && edge.getLinkedRecord(NODE);
        // N.B. node.getValue('id') instead of node.getDataID()
        if (node != null && node.getValue('id') === nodeID) {
            if (nextEdges === undefined) nextEdges = edges.slice(0, ii);
        } else if (nextEdges !== undefined) nextEdges.push(edge);
    }
    if (nextEdges !== undefined) record.setLinkedRecords(nextEdges, EDGES);
}
// Copied from DeleteEdgeHandler implementation in Relay with a single change in behaviour:
// it calls deleteNode above instead of ConnectionHandler.deleteNode.
const DeleteEdgeHandler = {
    update: (store, payload)=>{
        const record = store.get(payload.dataID);
        if (record == null) return;
        // @types/relay-runtime is broken, handleArgs is present in the original Flow types.
        const { connections } = payload.handleArgs;
        (0, _tinyInvariantDefault.default)(connections != null, 'MutationHandlers: Expected connection IDs to be specified.');
        const idOrIds = record.getValue(payload.fieldKey);
        const idList = Array.isArray(idOrIds) ? idOrIds : [
            idOrIds
        ];
        idList.forEach((id)=>{
            if (typeof id === 'string') for (const connectionID of connections){
                const connection = store.get(connectionID);
                if (connection == null) {
                    (0, _tinyWarningDefault.default)(false, `[Relay] The connection with id ${connectionID} doesn't exist.`);
                    continue;
                }
                deleteNode(connection, id);
            }
        });
    }
};
function HandlerProvider(handle) {
    switch(handle){
        case 'deleteEdge':
            return DeleteEdgeHandler;
        default:
            return (0, _relayRuntime.DefaultHandlerProvider)(handle);
    }
}
function createRelayEnvironment({ log, requiredFieldLogger, networkOptions, getDataID }) {
    return new (0, _relayRuntime.Environment)({
        configName: 'Atlassian Shared Graphql Gateway',
        network: createNetwork(networkOptions || {
            isServer: false
        }),
        store: createStore(new (0, _relayRuntime.RecordSource)(), {
            log: log !== null && log !== void 0 ? log : undefined,
            getDataID: 'getDataID' in arguments[0] ? getDataID : (0, _relayDataIdDefault.default)
        }),
        log,
        relayFieldLogger: requiredFieldLogger,
        getDataID: 'getDataID' in arguments[0] ? getDataID : (0, _relayDataIdDefault.default),
        scheduler: (0, _relaySchedulerDefault.default),
        missingFieldHandlers: (0, _relayMissingFieldHandlersDefault.default),
        handlerProvider: HandlerProvider
    });
}

},{"relay-runtime":"2IxFR","relay-runtime/lib/store/live-resolvers/LiveResolverStore":"d2wOk","tiny-invariant":"9VWeJ","tiny-warning":"6MVuu","@atlassian/relay-data-id":"cYlpB","@atlassian/relay-fetch/multi-fetch":"4cnen","@atlassian/relay-missing-field-handlers":"2WsDZ","@atlassian/relay-scheduler":"lDCic","@atlassian/relay-subscription":"lTv1N","@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"d2wOk":[function(require,module,exports,__globalThis) {
'use strict';
var RelayModernStore = require("857d745813772ec9");
module.exports = RelayModernStore;

},{"857d745813772ec9":"UtVKb"}],"cYlpB":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>RelayDataID);
function RelayDataID(fieldValue, typeName) {
    const { id } = fieldValue;
    if (id == null) return undefined;
    return `${String(id)}:::::${typeName}`;
}

},{"@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"4cnen":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "fetch", ()=>fetch);
parcelHelpers.export(exports, "enforceProductNonNullability", ()=>enforceProductNonNullability);
var _objectSpread = require("@swc/helpers/_/_object_spread");
var _objectSpreadProps = require("@swc/helpers/_/_object_spread_props");
var _isNil = require("lodash/isNil");
var _isNilDefault = parcelHelpers.interopDefault(_isNil);
var _relayRuntime = require("relay-runtime");
var _platformFeatureFlags = require("@atlaskit/platform-feature-flags");
var _relayCaptureExtensions = require("@atlassian/relay-capture-extensions");
var _relayEndpoint = require("@atlassian/relay-endpoint");
var _relayQueryPromises = require("@atlassian/relay-query-promises");
var _relayTraceid = require("@atlassian/relay-traceid");
var _clientDispatcher = require("@atlassian/server-to-client-comms/client-dispatcher");
var _serverReceiver = require("@atlassian/server-to-client-comms/server-receiver");
var _multipartFetch = require("./multipart-fetch");
var _retries = require("./utils/retries");
var _trace = require("./utils/trace");
const isSsrHandoverIncrementsEnabled = ()=>Boolean(globalThis.__SSR_HANDOVER_INCREMENTS);
const moduleID = 'relay-fetch';
const fetch = (request, variables, cacheConfig, dependencies)=>{
    var _dependencies_getLoggingAndMetricsHelper;
    if ((0, _platformFeatureFlags.fg)('nike_redirect-logic-jira')) {
        var _dependencies_didPreflightAuthenticationCheckTriggerRedirect;
        if ((dependencies === null || dependencies === void 0 ? void 0 : (_dependencies_didPreflightAuthenticationCheckTriggerRedirect = dependencies.didPreflightAuthenticationCheckTriggerRedirect) === null || _dependencies_didPreflightAuthenticationCheckTriggerRedirect === void 0 ? void 0 : _dependencies_didPreflightAuthenticationCheckTriggerRedirect.call(dependencies, request, variables, cacheConfig)) === true) // Jira's preflight check starts login navigation as a side effect. Keep Relay pending
        // while the redirect takes over instead of starting a fetch with a stale auth state.
        return (0, _relayRuntime.Observable).from(new Promise(()=>{}));
    }
    const { name: queryName, operationKind } = request;
    const loggingMetadata = {
        queryName,
        operationKind
    };
    const loggingAndMetrics = dependencies === null || dependencies === void 0 ? void 0 : (_dependencies_getLoggingAndMetricsHelper = dependencies.getLoggingAndMetricsHelper) === null || _dependencies_getLoggingAndMetricsHelper === void 0 ? void 0 : _dependencies_getLoggingAndMetricsHelper.call(dependencies, loggingMetadata);
    function augmentResponse(response) {
        (0, _relayTraceid.addTraceId)(queryName, (0, _trace.getTraceIdFromExtensions)(response));
        (0, _relayCaptureExtensions.putExtensions)(queryName, response.extensions);
    }
    // TODO: This needs to be changed by removing each Product, and only if all keys are empty final output is null
    function enforceNonNullability(response) {
        if (response.data && // DO NOT ADD TO THIS CONDITION.
        // Doing so can make service timeouts in non-critical dependencies result in a complete breakage of experiences.
        // If requesting a namespaced field, flatten it - e.g. "query { foo { bar {" should become "query { foo_bar {".
        // See https://atlassian.slack.com/archives/C01E2MPPLE4/p1780367270438419.
        (response.data.jira === null || response.data.customerService === null || response.data.graphStore === null)) // Enforce non-nullability of the jira and customerService namespaces. This is an intermediary solution to
        // prevent server errors/gateway timeouts from wiping the Relay store. Eventually we'd like this
        // to be enforced at a schema level, see further discussion https://hello.atlassian.net/wiki/spaces/~236031707/pages/2034382845/Top+level+errors+for+namespaces+in+AGG+Relay
        // @ts-expect-error - TS2322 - Relay types do not allow null data for a response with errors, however this is valid according to the spec http://spec.graphql.org/June2018/#sec-Data
        response.data = null;
    }
    return (0, _relayRuntime.Observable).create((sink)=>{
        try {
            const requestID = 'cacheID' in request && request.cacheID != null ? request.cacheID : request.id;
            // Unique identifier for the server-to-client channel.
            const sinkID = `${moduleID}-${requestID}`;
            let resolveCompletedResponse;
            const completedResponse = new Promise((resolve)=>{
                resolveCompletedResponse = resolve;
            });
            const finalise = ()=>{
                resolveCompletedResponse();
                sink.complete();
            };
            const handleResponse = (response)=>{
                let payload = null;
                if ('incremental' in response && response.incremental) {
                    if (response.incremental.length) // Relay is expecting the contents of this array rather than the entire array itself. Also, Relay doesn't really care about tracking
                    // the pending versus completed values, so we can just return the array without the extra account keeping.
                    // @ts-expect-error It's hard to type this correctly because the payload sometimes has errors, sometimes not. Relay accounts for it,
                    // TypeScript can't handle the polymorphism.
                    payload = response.incremental;
                    else if (response.hasNext === false) // It's possible for the server to send back an empty final increment.
                    // Attempt to make Relay happy.
                    payload = {
                        data: null,
                        extensions: {
                            is_final: true
                        }
                    };
                } else // @ts-expect-error Typescript isn't happy that sometimes errors is undefined, but relay will manage just fine.
                payload = response;
                // Notify observers that we have more data!
                if (payload) sink.next(payload);
                // Close the stream if there are no more responses.
                if ('hasNext' in response && response.hasNext === false) finalise();
            };
            // handles getting multipart response
            const getData = ()=>{
                var _dependencies_earlyScriptPromise;
                const endpoint = (0, _relayEndpoint.getAggEndpoint)(request, cacheConfig);
                const body = (0, _relayEndpoint.getRequestBody)(request, variables);
                let options = {
                    body
                };
                if (dependencies === null || dependencies === void 0 ? void 0 : dependencies.getHeaders) {
                    const headers = dependencies.getHeaders({
                        endpoint,
                        options,
                        request,
                        variables
                    });
                    options = (0, _objectSpreadProps._)((0, _objectSpread._)({}, options), {
                        headers: (0, _objectSpread._)({}, options.headers, headers)
                    });
                }
                if (dependencies === null || dependencies === void 0 ? void 0 : dependencies.getAbortSignal) options.signal = dependencies === null || dependencies === void 0 ? void 0 : dependencies.getAbortSignal();
                const fetchOverNetwork = (0, _multipartFetch.buildGraphqlSmartFetch)({
                    url: (dependencies === null || dependencies === void 0 ? void 0 : dependencies.setEndpoint) ? dependencies === null || dependencies === void 0 ? void 0 : dependencies.setEndpoint(endpoint) : endpoint,
                    options,
                    variables,
                    request,
                    isServer: (dependencies === null || dependencies === void 0 ? void 0 : dependencies.isServer) || false,
                    cacheConfig
                });
                const earlyScriptPromise = dependencies === null || dependencies === void 0 ? void 0 : (_dependencies_earlyScriptPromise = dependencies.earlyScriptPromise) === null || _dependencies_earlyScriptPromise === void 0 ? void 0 : _dependencies_earlyScriptPromise.call(dependencies, request, variables);
                let fetchFn = fetchOverNetwork;
                let initialSource = fetchFn;
                if (dependencies === null || dependencies === void 0 ? void 0 : dependencies.withErrorHandling) {
                    const withErrorHandling = dependencies.withErrorHandling;
                    initialSource = ()=>!(dependencies === null || dependencies === void 0 ? void 0 : dependencies.isServer) && earlyScriptPromise ? withErrorHandling(earlyScriptPromise) : withErrorHandling(fetchFn());
                }
                const responses = (0, _multipartFetch.processMultipartPromise)(()=>(0, _retries.retryOnError)(initialSource, {
                        retryFunc: fetchFn,
                        retryPredicate: (0, _retries.shouldRetry),
                        retryAttempts: (0, _retries.getRetryAttemptsForQuery)(request),
                        onRetry: loggingAndMetrics === null || loggingAndMetrics === void 0 ? void 0 : loggingAndMetrics.logErrorRetry
                    }), dependencies === null || dependencies === void 0 ? void 0 : dependencies.onFetchError);
                // Recreate a bizarre behaviour that will cause the observable to hang indefinitely when the user is not authenticated, presumably because we redirect the user to log in...
                // This should be revised; see https://jplat.atlassian.net/browse/MAGMA-3087
                let responseShouldHang = false;
                let firstResponseUsed = false;
                let resolveFirstResponse;
                const firstResponse = new Promise((resolve)=>{
                    resolveFirstResponse = resolve;
                });
                responses.subscribe({
                    start: ()=>{
                        if (requestID != null) {
                            if (dependencies === null || dependencies === void 0 ? void 0 : dependencies.isServer) {
                                // so that SSR SPA knows it is safe to render
                                const renderAfterThisResponse = isSsrHandoverIncrementsEnabled() ? firstResponse : completedResponse;
                                (0, _relayQueryPromises.QueryPromisesMap).set(requestID, renderAfterThisResponse);
                            } else (0, _relayQueryPromises.QueryPromisesMap).set(requestID, firstResponse);
                            (0, _relayQueryPromises.CompletedQueryPromisesMap).set(requestID, completedResponse);
                        }
                    },
                    next: (r)=>{
                        let payload = r;
                        let response = payload || {};
                        if ((dependencies === null || dependencies === void 0 ? void 0 : dependencies.isServer) && isSsrHandoverIncrementsEnabled() && firstResponseUsed) {
                            // Send the response payload to a side-channel.
                            // TODO MAGMA-3204: improve robustness. Should be sending ID of module to communicate with, sinkID should be an argument.
                            (0, _serverReceiver.registerEvent)({
                                id: sinkID,
                                name: 'default',
                                args: [
                                    response
                                ]
                            });
                            if ('hasNext' in response && response.hasNext === false) finalise();
                            // Don't send any further responses to the fetch subscriber, since we'll be sending them through a side-channel.
                            return;
                        }
                        if (!firstResponseUsed) {
                            firstResponseUsed = true;
                            // according to spec, we can assume the first response is a GraphQLSingularResponse.
                            // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
                            const singularResponse = response;
                            augmentResponse(singularResponse);
                            if ((dependencies === null || dependencies === void 0 ? void 0 : dependencies.validateResponse) && !dependencies.validateResponse(request, singularResponse)) {
                                var _dependencies_onInvalidResponse;
                                dependencies === null || dependencies === void 0 ? void 0 : (_dependencies_onInvalidResponse = dependencies.onInvalidResponse) === null || _dependencies_onInvalidResponse === void 0 ? void 0 : _dependencies_onInvalidResponse.call(dependencies, request, singularResponse);
                                responseShouldHang = true;
                                return;
                            }
                            if ((0, _platformFeatureFlags.fg)('platform_relay_use_new_non_nullability')) response = enforceProductNonNullability(singularResponse);
                            else enforceNonNullability(singularResponse);
                            // write cache query response on SSR
                            // only write cache query response once or else this will break the assumption of graphql response being singular response
                            if ((dependencies === null || dependencies === void 0 ? void 0 : dependencies.isServer) && requestID != null && typeof (dependencies === null || dependencies === void 0 ? void 0 : dependencies.queryResponseCache) !== 'undefined') {
                                if ('appendWithMetadata' in dependencies.queryResponseCache) dependencies.queryResponseCache.appendWithMetadata(requestID, variables, singularResponse, loggingMetadata);
                                else dependencies.queryResponseCache.setWithMetadata(requestID, variables, singularResponse, loggingMetadata);
                            }
                        }
                        handleResponse(response);
                        // signal that the initial response has been received
                        resolveFirstResponse();
                        // After the initial response, further responses are sent through a side-channel.
                        if ((dependencies === null || dependencies === void 0 ? void 0 : dependencies.isServer) && isSsrHandoverIncrementsEnabled()) sink.complete();
                    },
                    error: (error)=>{
                        if (!firstResponseUsed) firstResponseUsed = true;
                        loggingAndMetrics === null || loggingAndMetrics === void 0 ? void 0 : loggingAndMetrics.logError(error);
                        sink.error(error);
                    },
                    complete: ()=>{
                        if (responseShouldHang) return;
                        finalise();
                    }
                });
            };
            // On client...
            if (!(dependencies === null || dependencies === void 0 ? void 0 : dependencies.isServer) && requestID != null) {
                var _dependencies_queryResponseCache;
                // read cache from window.SPA_STATE if available
                const ssrCache = dependencies === null || dependencies === void 0 ? void 0 : (_dependencies_queryResponseCache = dependencies.queryResponseCache) === null || _dependencies_queryResponseCache === void 0 ? void 0 : _dependencies_queryResponseCache.get(requestID, variables);
                if (!(0, _isNilDefault.default)(ssrCache)) {
                    var _dependencies_queryResponseCache1;
                    dependencies === null || dependencies === void 0 ? void 0 : (_dependencies_queryResponseCache1 = dependencies.queryResponseCache) === null || _dependencies_queryResponseCache1 === void 0 ? void 0 : _dependencies_queryResponseCache1.delete(requestID, variables);
                    sink.next(ssrCache);
                    if (isSsrHandoverIncrementsEnabled() && 'hasNext' in ssrCache && ssrCache.hasNext) {
                        // TODO MAGMA-3017: what about SSR fallback mode, or scenarios where SSR has partially failed?
                        // TODO MAGMA-3204: improve robustness. Should be using a middle-man module rather than client dispatcher directly.
                        // Receive response events as they are streamed from the server.
                        (0, _clientDispatcher.getClientDispatcher)().register(sinkID, handleResponse);
                        (0, _clientDispatcher.getClientDispatcher)().onAbort(sinkID, ({ reason })=>{
                            if (!sink.closed) {
                                var _dependencies_handleAbort;
                                dependencies === null || dependencies === void 0 ? void 0 : (_dependencies_handleAbort = dependencies.handleAbort) === null || _dependencies_handleAbort === void 0 ? void 0 : _dependencies_handleAbort.call(dependencies, request, reason);
                                // if server throws an exception (such as SSR hanging up due to deadline exceeded)
                                // refetch multipart data again via network
                                getData();
                            }
                        });
                    } else finalise();
                    return;
                }
            }
            getData();
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        } catch (error) {
            loggingAndMetrics === null || loggingAndMetrics === void 0 ? void 0 : loggingAndMetrics.logError(error);
            sink.error(error);
        }
    });
};
function enforceProductNonNullability(response) {
    if (response.data) {
        // Enforce non-nullability of the product namespaces. This is an intermediary solution to
        // prevent server errors/gateway timeouts from wiping the Relay store. Eventually we'd like this
        // to be enforced at a schema level, see further discussion https://hello.atlassian.net/wiki/spaces/~236031707/pages/2034382845/Top+level+errors+for+namespaces+in+AGG+Relay
        let sanitisedData = Object.assign({}, response.data);
        const productKeys = [
            'jira',
            'customerService',
            'graphStore'
        ];
        for (const product of productKeys)if (sanitisedData[product] === null) delete sanitisedData[product];
        if (Object.keys(sanitisedData).length === 0) // @ts-expect-error - TS2322 - Relay types do not allow null data for a response with errors, however this is valid according to the spec http://spec.graphql.org/June2018/#sec-Dataa
        sanitisedData = null;
        response.data = sanitisedData;
    }
    return response;
}

},{"@swc/helpers/_/_object_spread":"9gdrV","@swc/helpers/_/_object_spread_props":"kANqQ","lodash/isNil":"o6Rs9","relay-runtime":"2IxFR","@atlaskit/platform-feature-flags":"8rD2i","@atlassian/relay-capture-extensions":"dRRxb","@atlassian/relay-endpoint":"kpbj9","@atlassian/relay-query-promises":"9axfh","@atlassian/relay-traceid":"NgtKk","@atlassian/server-to-client-comms/client-dispatcher":"fweXr","@atlassian/server-to-client-comms/server-receiver":"3Tgrn","./multipart-fetch":"cX4jI","./utils/retries":"dc5U4","./utils/trace":"3d3DX","@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"o6Rs9":[function(require,module,exports,__globalThis) {
/**
 * Checks if `value` is `null` or `undefined`.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is nullish, else `false`.
 * @example
 *
 * _.isNil(null);
 * // => true
 *
 * _.isNil(void 0);
 * // => true
 *
 * _.isNil(NaN);
 * // => false
 */ function isNil(value) {
    return value == null;
}
module.exports = isNil;

},{}],"dRRxb":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "startCapturingExtensions", ()=>startCapturingExtensions);
parcelHelpers.export(exports, "stopCapturingExtensions", ()=>stopCapturingExtensions);
parcelHelpers.export(exports, "putExtensions", ()=>putExtensions);
parcelHelpers.export(exports, "getExtensions", ()=>getExtensions);
const OperationExtensionsMap = {};
const startCapturingExtensions = (operationName)=>{
    OperationExtensionsMap[operationName] = OperationExtensionsMap[operationName] || [];
};
const stopCapturingExtensions = (operationName)=>{
    OperationExtensionsMap[operationName] = undefined;
};
const putExtensions = (operationName, extension)=>{
    if (extension !== undefined) {
        const extensionsForOperation = OperationExtensionsMap[operationName];
        if (extensionsForOperation !== undefined) extensionsForOperation.push(extension);
    }
};
const getExtensions = (operationName)=>OperationExtensionsMap[operationName] || [];

},{"@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"kpbj9":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "aggPathname", ()=>aggPathname);
parcelHelpers.export(exports, "getAggEndpoint", ()=>getAggEndpoint);
parcelHelpers.export(exports, "getRequestBody", ()=>getRequestBody);
var process = require("3726143e1c99c293");
const branchSlug = typeof process !== 'undefined' && process.env ? undefined : undefined;
// Pre-encoded value passed through verbatim as the `serviceOverride` query param.
const serviceOverrides = typeof process !== 'undefined' && process.env ? undefined : undefined;
const aggPathname = `/gateway/api/graphql${branchSlug ? `/${branchSlug}/graphql` : ''}`;
const getAggEndpoint = (request, cacheConfig = {})=>{
    var _cacheConfig_metadata;
    let endpoint = aggPathname;
    if ((_cacheConfig_metadata = cacheConfig.metadata) === null || _cacheConfig_metadata === void 0 ? void 0 : _cacheConfig_metadata.META_SLOW_ENDPOINT) endpoint = `${endpoint}/slow`;
    if (request.id != null) endpoint = `${endpoint}/pq/${request.id}`;
    let url = `${endpoint}?operation=${request.name}`;
    if (serviceOverrides) url = `${url}&serviceOverride=${serviceOverrides}`;
    return url;
};
const getRequestBody = (request, variables)=>{
    const requestBody = {
        operationName: request.name,
        variables
    };
    return JSON.stringify(requestBody);
};

},{"3726143e1c99c293":"gNLf3","@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"9axfh":[function(require,module,exports,__globalThis) {
/**
 * A map of signals that the initial response from the network has been received for a given relay query.
 *
 * This signal is used on the server-side during SSR to prevent React from running a render pass
 * until we can guarantee the data has arrived and is cached in the relay-client.
 *
 * This allows us to make a meaningful an initial render pass, avoiding needless suspense boundaries
 * and avoiding adding noncritical work to the JS call stack.
 */ var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "QueryPromisesMap", ()=>QueryPromisesMap);
parcelHelpers.export(exports, "CompletedQueryPromisesMap", ()=>CompletedQueryPromisesMap);
const QueryPromisesMap = new Map();
const CompletedQueryPromisesMap = new Map();

},{"@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"NgtKk":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "startCapturingTraceIds", ()=>startCapturingTraceIds);
parcelHelpers.export(exports, "stopCapturingTraceIds", ()=>stopCapturingTraceIds);
parcelHelpers.export(exports, "addTraceId", ()=>addTraceId);
parcelHelpers.export(exports, "getTraceIds", ()=>getTraceIds);
const OperationTraceIdMap = {};
const startCapturingTraceIds = (operationName)=>{
    OperationTraceIdMap[operationName] = OperationTraceIdMap[operationName] || [];
};
const stopCapturingTraceIds = (operationName)=>{
    OperationTraceIdMap[operationName] = undefined;
};
const addTraceId = (operationName, traceId)=>{
    if (traceId !== undefined) {
        const traceIdsForOperation = OperationTraceIdMap[operationName];
        if (traceIdsForOperation !== undefined) traceIdsForOperation.push(traceId);
    }
};
const getTraceIds = (operationName)=>OperationTraceIdMap[operationName] || [];

},{"@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"fweXr":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "CLIENT_DISPATCHER_MODULE", ()=>CLIENT_DISPATCHER_MODULE);
parcelHelpers.export(exports, "getClientDispatcher", ()=>getClientDispatcher);
var _clientDispatcher = require("./client-dispatcher");
const CLIENT_DISPATCHER_MODULE = 'ClientDispatcher';
let dispatcher;
const getClientDispatcher = ()=>{
    if (!dispatcher) {
        dispatcher = new (0, _clientDispatcher.ClientDispatcher)();
        // Handle the server hangup scenarios
        dispatcher.register(CLIENT_DISPATCHER_MODULE, dispatcher._abort.bind(dispatcher));
    }
    return dispatcher;
};

},{"./client-dispatcher":"8JGdj","@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"8JGdj":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
/**
 * The glue between a {@link ServerToClientEvent} and a client-side component.
 *
 * This class is responsible for ingesting events from the server and dispatching them to the correct component.
 *
 * Components hoping to be called from the server must be registered. Today, that's a manual call a developer
 * needs to make. Tomorrow, that may be automatically generated by the compiler reading a code annotation.
 */ parcelHelpers.export(exports, "ClientDispatcher", ()=>ClientDispatcher);
class ClientDispatcher {
    /**
	 * Ingest a payload from the server.
	 * This will trigger a callback to the component that registered for this event, otherwise the payload will be queued to do so later.
	 * @param payload - The payload to ingest.
	 */ ingest(payload) {
        const handler = this.handlers.get(payload.id);
        if (handler) this.exec(handler, payload);
        else {
            const queue = this.queuedPayloads.get(payload.id) || [];
            queue.push(payload);
            this.queuedPayloads.set(payload.id, queue);
        }
    }
    /**
	 * Register a callback for a given event. If any payloads were queued for this event, they will be processed immediately.
	 * @param id - The event ID to register for.
	 * @param callback - The callback to trigger when the event is ingested.
	 */ register(id, callback) {
        this.handlers.set(id, callback);
        // Process any queued payloads for this handler
        const queuedPayloads = this.queuedPayloads.get(id) || [];
        if (queuedPayloads.length > 0) {
            queuedPayloads.forEach((payload)=>this.exec(callback, payload));
            this.queuedPayloads.delete(id);
        }
    }
    /**
	 * Unregister a callback for a given event.
	 * @param id
	 */ unregister(id) {
        this.handlers.delete(id);
        this.queuedPayloads.delete(id);
    }
    /**
	 * Register an abort handler that will get called if exceptional circmstances arise (such as SSR hanging up due to deadline exceeded)
	 * @param id - The event ID to register for.
	 * @param callback - The callback to trigger when abort detected.
	 */ onAbort(id, callback) {
        if (this.abortReason) this.exec(callback, {
            args: [
                this.abortReason
            ]
        });
        else this.abortHandlers.set(id, callback);
    }
    /**
	 * Notify any registered abort handlers that the server exceeded its deadline before finishing, so we may not have received all events.
	 * @private
	 * @param props
	 */ _abort(props) {
        this.abortReason = props;
        this.abortHandlers.forEach((handler)=>{
            this.exec(handler, {
                args: [
                    props
                ]
            });
        });
        // We can delete these now that we've handled the case and remainder will be dealt with immediately.
        this.abortHandlers = new Map();
    }
    /**
	 * Execute a callback with the given payload.
	 * @param callback - The callback to execute.
	 * @param payload - The payload to execute the callback with.
	 */ exec(callback, payload) {
        const { args, error } = payload;
        try {
            if (error) throw error;
            // @ts-expect-error
            callback(...args);
        } catch (err) {
        // TODO: log error
        // console.error(err);
        }
    }
    constructor(){
        this.handlers = new Map();
        this.abortHandlers = new Map();
        this.queuedPayloads = new Map();
    }
}

},{"@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"3Tgrn":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "registerEvent", ()=>registerEvent);
parcelHelpers.export(exports, "drainEvents", ()=>drainEvents);
const events = [];
const registerEvent = (event)=>{
    events.push(event);
};
const drainEvents = ()=>{
    return events.splice(0, events.length);
};

},{"@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"cX4jI":[function(require,module,exports,__globalThis) {
/**
 * @fileOverview Implements a fetch function that can handle multipart/mixed responses.
 * The multipart response is expected to follow the GraphQL multipart request spec.
 *
 * See https://github.com/graphql/graphql-over-http/blob/main/rfcs/IncrementalDelivery.md#content-type-multipartmixed
 * See https://github.com/graphql/graphql-over-http/blob/main/spec/GraphQLOverHTTP.md#multipart-request-format
 */ var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "processStream", ()=>processStream);
parcelHelpers.export(exports, "buildGraphqlSmartFetch", ()=>buildGraphqlSmartFetch);
parcelHelpers.export(exports, "processChunk", ()=>processChunk);
parcelHelpers.export(exports, "processMultipartPromise", ()=>// These are only exported for testing purposes.
    processMultipartPromise);
parcelHelpers.export(exports, "calculateHeadersSize", ()=>calculateHeadersSize);
parcelHelpers.export(exports, "shouldUseGetMethod", ()=>shouldUseGetMethod);
parcelHelpers.export(exports, "buildGetUrl", ()=>buildGetUrl);
var _objectSpread = require("@swc/helpers/_/_object_spread");
var _merge = require("lodash/merge");
var _mergeDefault = parcelHelpers.interopDefault(_merge);
var _relayRuntime = require("relay-runtime");
var _platformFeatureFlags = require("@atlaskit/platform-feature-flags");
var _relayExperimentalApis = require("@atlassian/relay-experimental-apis");
const NO_CONTENT = 204;
function getBoundary(contentType) {
    const parts = contentType.split('boundary=');
    if (parts.length < 2) return null;
    return parts[1].trim();
}
function processChunk(chunk, boundaryString, observer) {
    const parts = chunk.split(boundaryString);
    let incompleteChunk = '';
    // Process all complete parts (except the last one which might be incomplete)
    for(let i = 0; i < parts.length - 1; i++){
        const part = parts[i].trim();
        // Skip empty parts and encapsulation boundaries
        if (part && !part.startsWith('--')) {
            // Split content-type header and body
            const [part1, part2] = part.split(/\r?\n\r?\n/);
            // when response content has boundary string, part1 is the actual response
            // when response content does not have boundary string, part2 is the actual response
            const body = part2 !== null && part2 !== void 0 ? part2 : part1;
            if (body) try {
                const jsonData = JSON.parse(incompleteChunk + body);
                observer.next(jsonData);
                incompleteChunk = '';
            } catch (e) {
                // add boundary string back to response for cases when response content has boundary string
                // no error is thrown because next part might be a valid JSON object
                incompleteChunk += body + boundaryString;
            }
        }
    }
    // Return the last part which might be incomplete
    return incompleteChunk + parts[parts.length - 1];
}
async function processStream(reader, boundary, observer) {
    const boundaryString = `--${boundary}`;
    let incompleteChunk = '';
    // Process chunks until the stream is done
    for await (const newText of reader){
        const combinedChunk = incompleteChunk + newText;
        // Process the combined chunk and get any incomplete part
        incompleteChunk = processChunk(combinedChunk, boundaryString, observer);
    }
    // Process any remaining data
    if (incompleteChunk.length > 0) processChunk(incompleteChunk, boundaryString, observer);
    observer.complete();
}
/**
 * Forward `error` to `observer.error`, giving the product-provided
 * `onFetchError` (if any) a chance to transform it first.
 */ function emitError(observer, error, response, onFetchError) {
    const transformed = onFetchError ? onFetchError(error, response) : error;
    // `Sink.error` accepts `Error` per its type, but in practice relay
    // forwards whatever it receives to consumers. Cast to keep the existing
    // signature while allowing products to return any error-like value.
    observer.error(transformed);
}
function handleMultipartResponse(response, observer, onFetchError) {
    const contentType = response.headers.get('content-type');
    const boundary = getBoundary(contentType || '');
    if (!boundary) {
        emitError(observer, new Error('Invalid multipart boundary'), response, onFetchError);
        return;
    }
    const decoder = new TextDecoder('utf-8');
    async function* streamReader() {
        // @ts-expect-error a Response object in Node is streamable
        for await (const chunk of response.body){
            const newText = decoder.decode(chunk, {
                stream: true
            });
            yield newText;
        }
    }
    try {
        // Depending on the version of Node we're running in, the Response object may not implement ReadableStream.
        // Here, we treat the response as an async iterator, since both node-fetch and browser implement the response body as a stream.
        // We wrap that iteration in an async generator, which lets us
        processStream(streamReader(), boundary, observer).catch((error)=>emitError(observer, error, response, onFetchError));
    } catch (e) {
        const error = new Error('Failed to read from response body');
        // @ts-ignore: cause property may not be available in all environments
        error.cause = e;
        emitError(observer, error, response, onFetchError);
    }
}
function handleJsonResponse(response, observer, onFetchError) {
    response.json().then((data)=>{
        return observer.next(data);
    }).catch((error)=>emitError(observer, error, response, onFetchError)).finally(()=>observer.complete());
}
function handleTextResponse(response, observer, onFetchError) {
    response.text().then((data)=>{
        const maybeJson = data ? JSON.parse(data) : null;
        observer.next(maybeJson);
        observer.complete();
    }).catch((responseError)=>{
        var _response_headers;
        let traceId = '';
        if ((0, _platformFeatureFlags.fg)('platform_relay_use_shared_relay_env_help_center')) traceId = `(trace-id: ${response.headers.get('atl-traceid')}) `;
        const error = new Error(`Error while parsing text response ${traceId}(Content-Type: ${response === null || response === void 0 ? void 0 : (_response_headers = response.headers) === null || _response_headers === void 0 ? void 0 : _response_headers.get('content-type')}): ${responseError instanceof Error ? responseError.message : String(responseError)}`);
        emitError(observer, error, response, onFetchError);
    });
}
function processMultipartPromise(source, onFetchError) {
    // Cache the result of the source promise to avoid calling it multiple times.
    const result = source();
    // Wrap an observer around the result to handle the response.
    return (0, _relayRuntime.Observable).create((observer)=>{
        result.then((response)=>{
            if (response.status === NO_CONTENT) {
                observer.complete();
                return;
            }
            const contentType = response.headers.get('content-type') || '';
            if (contentType.includes('application/json') || contentType.includes('application/graphql-response+json')) handleJsonResponse(response, observer, onFetchError);
            else if (contentType.includes('text/plain')) handleTextResponse(response, observer, onFetchError);
            else if (contentType.includes('multipart/mixed')) handleMultipartResponse(response, observer, onFetchError);
            else handleTextResponse(response, observer, onFetchError);
        })// Pre-response failure (network error, AbortController, etc.) — no
        // Response object is in scope, so pass `undefined`.
        .catch((error)=>emitError(observer, error, undefined, onFetchError));
    });
}
const relayDeferAcceptableFormats = [
    'application/graphql-response+json',
    'application/json',
    // there must not be spacing between `multipart/mixed` and `deferSpec=20220824` since the backend assumes no spacing
    'multipart/mixed;deferSpec=20220824'
];
const MAX_QUERY_LENGTH = 2000; // Maximum allowed query length
const MAX_HEADERS_SIZE = 20480; // Maximum header size in bytes (20 KB)
// Calculate the size of the headers
function calculateHeadersSize(headers) {
    let totalBytes = 0;
    const textEncoder = new TextEncoder();
    // Iterate over each header entry (name and value)
    for (const [name, value] of Object.entries(headers)){
        const headerSize = textEncoder.encode(`${name}: ${value}\r\n`).length; // Include CRLF
        totalBytes += headerSize;
    }
    return totalBytes;
}
function buildGetUrl(baseUrl, variables) {
    const params = new URLSearchParams();
    params.append('variables', JSON.stringify(variables));
    return baseUrl + `${baseUrl.includes('?') ? '&' : '?'}${params.toString()}`;
}
function shouldUseGetMethod({ url: baseUrl, variables, request, headers, isServer }) {
    if (isServer) return {
        isGetRequest: false,
        reason: 'SSR'
    };
    if ((0, _platformFeatureFlags.fg)('hot-302159-relay-get-killswitch')) return {
        isGetRequest: false,
        reason: 'Killswitch is on'
    };
    if (request.operationKind !== 'query') return {
        isGetRequest: false,
        reason: request.operationKind
    };
    const queryLength = buildGetUrl(baseUrl, variables).length;
    const headersSize = calculateHeadersSize(headers || {});
    return queryLength <= MAX_QUERY_LENGTH && headersSize <= MAX_HEADERS_SIZE ? {
        isGetRequest: true
    } : {
        isGetRequest: false,
        reason: 'URL length or headers size too large'
    };
}
function buildGraphqlSmartFetch({ url, options, variables, request, isServer, cacheConfig }) {
    var _cacheConfig_metadata;
    const headers = (0, _objectSpread._)({
        'atl-client-name': 'atlassian-frontend-monorepo',
        Accept: relayDeferAcceptableFormats.join(', '),
        'X-ExperimentalApi': (0, _relayExperimentalApis.getRelayExperimentalApis)().join(',')
    }, (cacheConfig === null || cacheConfig === void 0 ? void 0 : (_cacheConfig_metadata = cacheConfig.metadata) === null || _cacheConfig_metadata === void 0 ? void 0 : _cacheConfig_metadata.headers) || {});
    const requestOptions = (0, _mergeDefault.default)(options, {
        credentials: 'same-origin',
        headers
    });
    requestOptions.headers['Content-Type'] = 'application/json';
    // Default `atl-attribution` header value for AGG requests
    // https://hello.atlassian.net/wiki/spaces/AGG/pages/5954141702/Metrics+Attribution+Onboarding+Doc+for+AGG+Clients
    if (!requestOptions.headers['atl-attribution']) requestOptions.headers['atl-attribution'] = JSON.stringify({
        service: 'afm-frontend'
    });
    const { isGetRequest, reason } = shouldUseGetMethod({
        url,
        variables,
        request,
        headers: requestOptions.headers,
        isServer
    });
    // Nav4ProjectsContentQuery is forced to go POST route to avoid the stale cache issues when transition between issues in Issue-view
    // that's not a permanent fix, but rather an attampt to unblock the team
    // Context: #jiv-navigation-issue channel
    if (isGetRequest && request.name !== 'Nav4ProjectsContentQuery') {
        requestOptions.method = 'GET';
        url = buildGetUrl(url, variables);
        delete requestOptions.body; // Not needed for GET
    } else {
        requestOptions.method = 'POST';
        if (reason) requestOptions.headers['X-Request-Fallback-To-Post-Reason'] = reason;
    }
    return ()=>fetch(url, requestOptions);
}

},{"@swc/helpers/_/_object_spread":"9gdrV","lodash/merge":"yJjRX","relay-runtime":"2IxFR","@atlaskit/platform-feature-flags":"8rD2i","@atlassian/relay-experimental-apis":"bfMHE","@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"bfMHE":[function(require,module,exports,__globalThis) {
// Please add your Experimental API name below
// You do not need to wait for approval to add to this list
var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "RelayExperimentalApis", ()=>RelayExperimentalApis);
parcelHelpers.export(exports, "getRelayExperimentalApis", ()=>getRelayExperimentalApis);
const RelayExperimentalApis = [
    'ariGraph',
    'boardCardMove',
    'deleteCard',
    'JiraJqlBuilder',
    'SoftwareCardTypeTransitions',
    'jira-releases-v0',
    'JiraDevOps',
    'JiraDevOpsProviders',
    'createCustomFilter',
    'updateCustomFilter',
    'deleteCustomFilter',
    'customFilters',
    'PermissionScheme',
    'JiraIssue',
    'projectStyle',
    'startSprintPrototype',
    'AddIssuesToFixVersion',
    'JiraVersionResult',
    'JiraIssueConnectionJql',
    'JiraFieldOptionSearching',
    'JiraIssueFieldMutations',
    'JiraIssueDevInfoDetails',
    'JiraIssueDevSummaryCache',
    'JiraVersionWarningConfig',
    'JiraReleaseNotesConfiguration',
    'JiraUpdateReleaseNotesConfiguration',
    'ReleaseNotes',
    'ReleaseNotesOptions',
    'DeploymentsFeaturePrecondition',
    'UpdateVersionWarningConfig',
    'UpdateVersionName',
    'UpdateVersionDescription',
    'UpdateVersionStartDate',
    'UpdateVersionReleaseDate',
    'VersionsForProject',
    'RelatedWork',
    'SuggestedRelatedWorkCategories',
    'setIssueMediaVisibility',
    'toggleBoardFeature',
    'DevOpsProvider',
    'DevOpsSummarisedDeployments',
    'JiraProject',
    'DevOpsSummarisedEntities',
    'RoadmapsMutation',
    'RoadmapsQuery',
    'JiraApplicationProperties',
    'JiraIssueSearch',
    'JiraFilter',
    'featureGroups',
    'setBoardEstimationType',
    'devOps',
    'softwareBoards',
    'name',
    'AddRelatedWorkToVersion',
    'RemoveRelatedWorkFromVersion',
    'admins',
    'canAdministerBoard',
    'jql',
    'globalCardCreateAdditionalFields',
    'GlobalTimeTrackingSettings',
    'ReleaseNotesOptions',
    'search-experience',
    'MoveOrRemoveIssuesToFixVersion',
    'compass-beta',
    'JiraIssueSearchStatus',
    'Townsquare',
    'JiraNavigationItems',
    'JiraVersionsForProjects',
    'columnConfigs',
    'help-object-store-agg-beta',
    'HelpCenterReorderTopics',
    'polaris-v0'
];
const getRelayExperimentalApis = ()=>RelayExperimentalApis;

},{"@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"dc5U4":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "RETRY_ATTEMPTS_LIMIT", ()=>RETRY_ATTEMPTS_LIMIT);
parcelHelpers.export(exports, "retryOnError", ()=>retryOnError);
parcelHelpers.export(exports, "shouldRetry", ()=>shouldRetry);
parcelHelpers.export(exports, "getRetryAttemptsForQuery", ()=>getRetryAttemptsForQuery);
const RETRY_ATTEMPTS_LIMIT = 1;
const retryOnError = (initialPromiseGetter, { retryFunc, retryPredicate, retryAttempts = RETRY_ATTEMPTS_LIMIT, onRetry })=>{
    // Eventually we might like to make max attempts configurable.
    // To do so, we'll need to support jitter & exponential back-off
    const maxAttempts = retryAttempts > RETRY_ATTEMPTS_LIMIT ? RETRY_ATTEMPTS_LIMIT : retryAttempts;
    const execute = async (getPromise, retryAttempt = 0)=>{
        try {
            return await getPromise();
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        } catch (error) {
            // If no retry predicate is passed, retry on every error
            const shouldAttemptRetry = retryPredicate ? retryPredicate(error) : true;
            if (retryAttempt < maxAttempts && shouldAttemptRetry) {
                onRetry && onRetry(error, retryAttempt + 1);
                return execute(retryFunc, retryAttempt + 1);
            }
            throw error;
        }
    };
    return execute(initialPromiseGetter);
};
const shouldRetry = (error)=>{
    if ('statusCode' in error && typeof error.statusCode === 'number') return [
        502,
        503,
        504
    ].includes(error.statusCode);
    return false;
};
const getRetryAttemptsForQuery = (request)=>{
    if (request.operationKind === 'query') return RETRY_ATTEMPTS_LIMIT;
    return 0;
};

},{"@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"3d3DX":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "getTraceIdFromExtensions", ()=>getTraceIdFromExtensions);
var _platformFeatureFlags = require("@atlaskit/platform-feature-flags");
const getTraceIdFromExtensions = ({ extensions })=>{
    if (extensions === undefined || extensions.gateway === undefined || extensions.gateway === null) return undefined;
    if ((0, _platformFeatureFlags.fg)('platform_relay_fetch_use_tid_property')) {
        if (typeof extensions.gateway.tId === 'string') // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
        return extensions.gateway.tId;
    } else {
        if (typeof extensions.gateway.trace_id === 'string') // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
        return extensions.gateway.trace_id;
    }
    return undefined;
};

},{"@atlaskit/platform-feature-flags":"8rD2i","@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"2WsDZ":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "JiraQueryFilterMissingFieldHandler", ()=>JiraQueryFilterMissingFieldHandler);
var _filter = require("@atlassian/ari/jira/filter");
var _relayDataId = require("@atlassian/relay-data-id");
var _relayDataIdDefault = parcelHelpers.interopDefault(_relayDataId);
const isCustomFilter = (filterId)=>/^\d+$/.test(filterId);
const isSystemFilter = (filterId)=>/^-\d+$/.test(filterId);
const JiraQueryFilterMissingFieldHandler = {
    handle: (field, record, argValues)=>{
        // https://relay.dev/docs/guided-tour/reusing-cached-data/filling-in-missing-data/
        // This lets relay know that a query of
        // JiraQuery.filter(id: ID!)
        // can return:
        //   - a JiraCustomFilter object
        //   - a JiraSystemFilter object
        // determined by the type encoded within the id field (which is an ARI type).
        // By providing the id that relay would refer to those objects by, it is able to check it's
        // store to see if they are already fetched, and avoid refetching them if it is unnecessary
        if (record != null && record.getType() === 'JiraQuery' && field.name === 'filter' && argValues.id != null) {
            const { id } = argValues;
            const filterId = (0, _filter.JiraFilterAri).parse(id).filterId;
            if (isCustomFilter(filterId)) return (0, _relayDataIdDefault.default)({
                id
            }, 'JiraCustomFilter');
            if (isSystemFilter(filterId)) return (0, _relayDataIdDefault.default)({
                id
            }, 'JiraSystemFilter');
            return undefined;
        }
        return undefined;
    },
    kind: 'linked'
};
const MissingFieldHandlers = [
    JiraQueryFilterMissingFieldHandler
];
exports.default = MissingFieldHandlers;

},{"@atlassian/ari/jira/filter":"hdGN8","@atlassian/relay-data-id":"cYlpB","@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"hdGN8":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "JiraFilterAri", ()=>(0, _chunkXXJMI7KOMjs.JiraFilterAri));
parcelHelpers.export(exports, "JiraFilterAriResourceOwner", ()=>(0, _chunkNQBZEVCSMjs.JiraFilterAriResourceOwner));
parcelHelpers.export(exports, "JiraFilterAriResourceType", ()=>(0, _chunkNQBZEVCSMjs.JiraFilterAriResourceType));
var _chunkXXJMI7KOMjs = require("../../chunk-XXJMI7KO.mjs");
var _chunkNQBZEVCSMjs = require("../../chunk-NQBZEVCS.mjs");
var _chunkAB4PPISIMjs = require("../../chunk-AB4PPISI.mjs");
var _chunkYFR5EBRKMjs = require("../../chunk-YFR5EBRK.mjs");
var _chunkS7RIZVFIMjs = require("../../chunk-S7RIZVFI.mjs");
var _chunkGAA5ADPBMjs = require("../../chunk-GAA5ADPB.mjs");
var _chunkFAZYALZ2Mjs = require("../../chunk-FAZYALZ2.mjs");

},{"../../chunk-XXJMI7KO.mjs":"4sBq2","../../chunk-NQBZEVCS.mjs":false,"../../chunk-AB4PPISI.mjs":false,"../../chunk-YFR5EBRK.mjs":false,"../../chunk-S7RIZVFI.mjs":false,"../../chunk-GAA5ADPB.mjs":false,"../../chunk-FAZYALZ2.mjs":false,"@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"4sBq2":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "JiraFilterAri", ()=>JiraFilterAri);
var _chunkNQBZEVCSMjs = require("./chunk-NQBZEVCS.mjs");
var _chunkAB4PPISIMjs = require("./chunk-AB4PPISI.mjs");
var _chunkS7RIZVFIMjs = require("./chunk-S7RIZVFI.mjs");
// src/jira/filter/manifest.ts
var jiraFilterAriStaticOpts = {
    qualifier: "ari",
    platformQualifier: "cloud",
    cloudId: new RegExp("^[a-zA-Z0-9_\\-.]{1,255}$"),
    resourceOwner: (0, _chunkNQBZEVCSMjs.JiraFilterAriResourceOwner),
    resourceType: (0, _chunkNQBZEVCSMjs.JiraFilterAriResourceType),
    resourceIdSlug: "activation/{activationId}/{filterId}",
    resourceIdSegmentFormats: {
        activationId: /[a-zA-Z0-9\-]+/,
        // eslint-disable-line no-useless-escape
        filterId: /[!a-zA-Z0-9\-_.~@:;{}=]+(\/[!a-zA-Z0-9\-_.~@:;{}=]+)*/
    }
};
// src/jira/filter/index.ts
var JiraFilterAri = class _JiraFilterAri extends (0, _chunkAB4PPISIMjs.RegisteredAri) {
    get siteId() {
        return this._siteId;
    }
    get activationId() {
        return this._activationId;
    }
    get filterId() {
        return this._filterId;
    }
    static create(opts) {
        let derivedOpts = {
            qualifier: jiraFilterAriStaticOpts.qualifier,
            platformQualifier: jiraFilterAriStaticOpts.platformQualifier,
            cloudId: opts.siteId,
            resourceOwner: jiraFilterAriStaticOpts.resourceOwner,
            resourceType: jiraFilterAriStaticOpts.resourceType,
            resourceId: `activation/${opts.activationId}/${opts.filterId}`,
            resourceIdSegmentValues: {
                activationId: opts.activationId,
                filterId: opts.filterId
            }
        }, ariOpts = (0, _chunkS7RIZVFIMjs.AriParser).fromOpts(derivedOpts, jiraFilterAriStaticOpts);
        return new _JiraFilterAri(ariOpts);
    }
    static parse(maybeAri) {
        let opts = (0, _chunkS7RIZVFIMjs.AriParser).fromString(maybeAri, jiraFilterAriStaticOpts);
        return new _JiraFilterAri(opts);
    }
    getVariables() {
        return {
            siteId: this.siteId,
            activationId: this.activationId,
            filterId: this.filterId
        };
    }
    constructor(opts){
        super(opts), this._siteId = opts.cloudId || "", this._activationId = opts.resourceIdSegmentValues.activationId, this._filterId = opts.resourceIdSegmentValues.filterId;
    }
};

},{"./chunk-NQBZEVCS.mjs":"eNlkT","./chunk-AB4PPISI.mjs":"19mDr","./chunk-S7RIZVFI.mjs":"h8qPM","@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"eNlkT":[function(require,module,exports,__globalThis) {
// src/jira/filter/types.ts
var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "JiraFilterAriResourceOwner", ()=>JiraFilterAriResourceOwner);
parcelHelpers.export(exports, "JiraFilterAriResourceType", ()=>JiraFilterAriResourceType);
var JiraFilterAriResourceOwner = "jira", JiraFilterAriResourceType = "filter";

},{"@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"19mDr":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "RegisteredAri", ()=>RegisteredAri);
var _chunkYFR5EBRKMjs = require("./chunk-YFR5EBRK.mjs");
// src/core/registered-ari.ts
var RegisteredAri = class extends (0, _chunkYFR5EBRKMjs.Ari) {
    static check(maybeAri) {
        try {
            return this.parse(maybeAri.toString()), !0;
        } catch (err) {
            return !1;
        }
    }
    asAnyAri() {
        return (0, _chunkYFR5EBRKMjs.AnyAri).parse(this.toString());
    }
};

},{"./chunk-YFR5EBRK.mjs":"jzCcT","@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"jzCcT":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "Ari", ()=>Ari);
parcelHelpers.export(exports, "AnyAri", ()=>AnyAri);
var _objectSpread = require("@swc/helpers/_/_object_spread");
var _objectSpreadProps = require("@swc/helpers/_/_object_spread_props");
var _chunkS7RIZVFIMjs = require("./chunk-S7RIZVFI.mjs");
// src/core/ari.ts
var Ari = class {
    get platformQualifier() {
        return this._ati.platformQualifier;
    }
    get cloudId() {
        return this._cloudId;
    }
    get resourceOwner() {
        return this._ati.resourceOwner;
    }
    get resourceType() {
        return this._ati.resourceType;
    }
    get resourceId() {
        return this._resourceId;
    }
    get ati() {
        return this._ati;
    }
    equals(other) {
        return this.toString() === other.toString();
    }
    toString() {
        return `ari:${this.platformQualifier}:${this.resourceOwner}:${this.cloudId || ""}:${this.resourceType}/${this.resourceId}`;
    }
    toJSON() {
        return this.toString();
    }
    toOpts() {
        return {
            platformQualifier: this.platformQualifier,
            resourceOwner: this.resourceOwner,
            cloudId: this.cloudId,
            resourceType: this.resourceType,
            resourceId: this.resourceId
        };
    }
    constructor(opts){
        this._ati = (0, _chunkS7RIZVFIMjs.Ati).create({
            platformQualifier: opts.platformQualifier || "cloud",
            resourceOwner: opts.resourceOwner,
            resourceType: opts.resourceType
        }), this._cloudId = opts.cloudId !== "" ? opts.cloudId : void 0, this._resourceId = opts.resourceId;
    }
};
// src/any-ari.ts
var AnyAri = class _AnyAri extends Ari {
    static create(ariOpts, ariStaticOpts) {
        let ariOptsWithDefaults = (0, _objectSpreadProps._)((0, _objectSpread._)({}, ariOpts), {
            resourceIdSegmentValues: {}
        }), validatedOpts = (0, _chunkS7RIZVFIMjs.AriParser).fromOpts(ariOptsWithDefaults, ariStaticOpts);
        return new _AnyAri(validatedOpts);
    }
    static parse(maybeAri, ariStaticOpts) {
        let validatedOpts = (0, _chunkS7RIZVFIMjs.AriParser).fromString(maybeAri, ariStaticOpts);
        return new _AnyAri(validatedOpts);
    }
    static check(maybeAri) {
        try {
            return _AnyAri.parse(maybeAri.toString()), !0;
        } catch (err) {
            return !1;
        }
    }
    asAnyAri() {
        return this;
    }
    constructor(opts){
        super(opts);
    }
};

},{"@swc/helpers/_/_object_spread":"9gdrV","@swc/helpers/_/_object_spread_props":"kANqQ","./chunk-S7RIZVFI.mjs":"h8qPM","@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"h8qPM":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "AriParser", ()=>AriParser);
parcelHelpers.export(exports, "Ati", ()=>Ati);
var _chunkGAA5ADPBMjs = require("./chunk-GAA5ADPB.mjs");
var _chunkFAZYALZ2Mjs = require("./chunk-FAZYALZ2.mjs");
// src/core/rules/cloud-id.ts
function validateCloudId(cloudId, format = new RegExp("^[a-zA-Z0-9_\\-.]{0,255}$")) {
    if (!cloudId.match(format)) throw new (0, _chunkFAZYALZ2Mjs.ValidationError)(`Invalid cloud ID, expected ID of format ${format}.`);
}
// src/core/rules/resource-id.ts
function validateResourceId(id, format = new RegExp("[!a-zA-Z0-9\\-_.~@:;{}=]+(/[!a-zA-Z0-9\\-_.~@:;{}=]+)*" /* ANY_RESOURCE_ID */ ), key = "resourceId") {
    let formatWithCarets = new RegExp(`^${format.source}$`);
    if (!id.match(formatWithCarets)) throw new (0, _chunkFAZYALZ2Mjs.ValidationError)(`Invalid ${key} - ${id}, expected ID of format ${formatWithCarets}.`);
}
// src/core/rules/resource-id-segments.ts
function validateResourceIdSegments(resourceIdSegmentValues, resourceIdSegmentFormats) {
    Object.entries(resourceIdSegmentValues).forEach(([resourceIdKey, resourceIdValue])=>{
        validateResourceId(resourceIdValue, resourceIdSegmentFormats == null ? void 0 : resourceIdSegmentFormats[resourceIdKey], resourceIdKey);
    });
}
// src/core/rules/resource-owner.ts
function validateResourceOwner(owner, expectedResourceOwner) {
    if (expectedResourceOwner && owner !== expectedResourceOwner) throw new (0, _chunkFAZYALZ2Mjs.ValidationError)(`Invalid resource owner - ${owner}, expected ${expectedResourceOwner}.`);
}
// src/core/rules/resource-type.ts
function validateResourceType(type, expectedResourceType) {
    if (expectedResourceType && type !== expectedResourceType) throw new (0, _chunkFAZYALZ2Mjs.ValidationError)(`Invalid resource type - ${type}, expected ${expectedResourceType}.`);
}
// src/core/parser/ari.ts
var NUMBER_OF_ARI_SEGMENTS = 5, AriParser = class extends (0, _chunkGAA5ADPBMjs.BaseParser) {
    static fromString(maybeAri, ariProperties) {
        let segments = this.getIdentifierSegments(maybeAri, NUMBER_OF_ARI_SEGMENTS), [qualifier, platformQualifier, resourceOwner, cloudId, resourceTypeAndId] = segments, [resourceType, ...resourceIdSegments] = resourceTypeAndId.split("/"), maybeAriDerivedProperties = {
            qualifier,
            platformQualifier,
            cloudId,
            resourceOwner,
            resourceType,
            resourceId: resourceIdSegments.join("/"),
            resourceIdSegmentValues: ariProperties != null && ariProperties.resourceIdSlug ? this.ariSegmentValuesFromSlug(ariProperties.resourceIdSlug, resourceIdSegments.join("/"), Object.keys(ariProperties.resourceIdSegmentFormats)) : {}
        };
        return this.fromOpts(maybeAriDerivedProperties, ariProperties);
    }
    static fromOpts(maybeAriOpts, ariProperties) {
        let { qualifier = "ari", platformQualifier = "cloud", resourceOwner, cloudId, resourceId, resourceIdSegmentValues, resourceType } = maybeAriOpts;
        return (0, _chunkGAA5ADPBMjs.validateAriQualifier)(qualifier), (0, _chunkGAA5ADPBMjs.validatePlatformQualifier)(platformQualifier), validateCloudId(maybeAriOpts.cloudId || "", ariProperties == null ? void 0 : ariProperties.cloudId), validateResourceOwner(resourceOwner, ariProperties == null ? void 0 : ariProperties.resourceOwner), validateResourceType(resourceType, ariProperties == null ? void 0 : ariProperties.resourceType), validateResourceIdSegments(resourceIdSegmentValues, ariProperties == null ? void 0 : ariProperties.resourceIdSegmentFormats), {
            qualifier,
            resourceOwner,
            resourceType,
            platformQualifier,
            cloudId,
            resourceId,
            resourceIdSegmentValues
        };
    }
    static ariSegmentValuesFromSlug(slug, incomingSegments, expectedKeys) {
        let regexpResult = new RegExp("^" + slug.replace(/\{(.*?)\}/g, "(?<$1>.*?)") + "$").exec(incomingSegments);
        if (!regexpResult) throw new (0, _chunkFAZYALZ2Mjs.ValidationError)(`Segment '${incomingSegments}' don't match expected slug: ${slug}`);
        return expectedKeys.forEach((expectedKey)=>{
            var _a;
            if (!((_a = regexpResult.groups) != null && _a[expectedKey])) throw new (0, _chunkFAZYALZ2Mjs.ValidationError)(`No value supplied for '${expectedKey}' based on slug ${slug}`);
        }), regexpResult.groups || {};
    }
};
// src/core/parser/ati.ts
var NUMBER_OF_ATI_SEGMENTS = 4, AtiParser = class extends (0, _chunkGAA5ADPBMjs.BaseParser) {
    static fromString(inputStr, atiOpts) {
        let segments = this.getIdentifierSegments(inputStr, NUMBER_OF_ATI_SEGMENTS), [qualifier = "ati", platformQualifier = "cloud", resourceOwner, resourceType] = segments;
        return (0, _chunkGAA5ADPBMjs.validateAtiQualifier)(qualifier), (0, _chunkGAA5ADPBMjs.validatePlatformQualifier)(platformQualifier), validateResourceOwner(resourceOwner, atiOpts == null ? void 0 : atiOpts.resourceOwner), validateResourceType(resourceType, atiOpts == null ? void 0 : atiOpts.resourceType), {
            platformQualifier,
            resourceOwner,
            resourceType
        };
    }
    static fromOpts(maybeAtiOpts, atiOpts) {
        let { qualifier, platformQualifier, resourceOwner, resourceType } = maybeAtiOpts;
        return (0, _chunkGAA5ADPBMjs.validateAtiQualifier)(qualifier), (0, _chunkGAA5ADPBMjs.validatePlatformQualifier)(platformQualifier), validateResourceOwner(resourceOwner, atiOpts == null ? void 0 : atiOpts.resourceOwner), validateResourceType(resourceType, atiOpts == null ? void 0 : atiOpts.resourceType), {
            platformQualifier,
            resourceOwner,
            resourceType
        };
    }
};
// src/ati.ts
var Ati = class _Ati {
    get platformQualifier() {
        return this._platformQualifier;
    }
    get resourceOwner() {
        return this._resourceOwner;
    }
    get resourceType() {
        return this._resourceType;
    }
    static create(opts) {
        return new _Ati(opts.platformQualifier || "cloud", opts.resourceOwner, opts.resourceType);
    }
    static parse(maybeAti, atiOpts) {
        let opts = AtiParser.fromString(maybeAti, atiOpts);
        return new _Ati(opts.platformQualifier, opts.resourceOwner, opts.resourceType);
    }
    toString() {
        return `ati:${this.platformQualifier}:${this.resourceOwner}:${this.resourceType}`;
    }
    toJSON() {
        return this.toString();
    }
    toOpts() {
        return {
            platformQualifier: this._platformQualifier,
            resourceOwner: this._resourceOwner,
            resourceType: this._resourceType
        };
    }
    constructor(platformQualifier, resourceOwner, resourceType){
        this._platformQualifier = platformQualifier, this._resourceOwner = resourceOwner, this._resourceType = resourceType;
    }
};

},{"./chunk-GAA5ADPB.mjs":"cvdgR","./chunk-FAZYALZ2.mjs":"7nviT","@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"cvdgR":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "validatePlatformQualifier", ()=>validatePlatformQualifier);
parcelHelpers.export(exports, "validateAtiQualifier", ()=>validateAtiQualifier);
parcelHelpers.export(exports, "validateAriQualifier", ()=>validateAriQualifier);
parcelHelpers.export(exports, "validateArmQualifier", ()=>validateArmQualifier);
parcelHelpers.export(exports, "BaseParser", ()=>BaseParser);
var _chunkFAZYALZ2Mjs = require("./chunk-FAZYALZ2.mjs");
// src/core/rules/platform-qualifier.ts
function validatePlatformQualifier(qualifier) {
    if (qualifier !== "cloud" && qualifier !== "third-party") throw new (0, _chunkFAZYALZ2Mjs.ValidationError)(`Identifier must have a qualifier of 'cloud' or 'third-party'. Received: ${qualifier}`);
}
// src/core/rules/qualifier.ts
function validateAtiQualifier(qualifier) {
    if (qualifier !== "ati") throw new (0, _chunkFAZYALZ2Mjs.ValidationError)(`ATI must have a qualifier of 'ati'. Received: ${qualifier}`);
}
function validateAriQualifier(qualifier) {
    if (qualifier !== "ari") throw new (0, _chunkFAZYALZ2Mjs.ValidationError)(`ARI must have a qualifier of 'ari'. Received: ${qualifier}`);
}
function validateArmQualifier(qualifier) {
    if (qualifier !== "arm") throw new (0, _chunkFAZYALZ2Mjs.ValidationError)(`ARM must have a qualifier of 'arm'. Received: ${qualifier}`);
}
// src/core/parser/base.ts
var NUMBER_OF_BASE_SEGMENTS = 5, SEGMENT_SEPARATOR = ":", BaseParser = class {
    static getIdentifierSegments(inputStr, numberOfSegmentsRequired) {
        let allSegments = inputStr.split(SEGMENT_SEPARATOR);
        if (allSegments.length < numberOfSegmentsRequired) throw new (0, _chunkFAZYALZ2Mjs.ValidationError)(`Input string must have ${numberOfSegmentsRequired} segments.`);
        if (allSegments.length > numberOfSegmentsRequired) {
            let segments = allSegments.slice(0, NUMBER_OF_BASE_SEGMENTS - 1), segmentsForResourceId = allSegments.slice(NUMBER_OF_BASE_SEGMENTS - 1, allSegments.length);
            return [
                ...segments,
                segmentsForResourceId.join(SEGMENT_SEPARATOR)
            ];
        }
        return allSegments;
    }
};

},{"./chunk-FAZYALZ2.mjs":"7nviT","@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"7nviT":[function(require,module,exports,__globalThis) {
// src/errors.ts
var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "ValidationError", ()=>ValidationError);
var ValidationError = class extends Error {
};

},{"@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"lDCic":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _reactDom = require("react-dom");
var _reactDomDefault = parcelHelpers.interopDefault(_reactDom);
// eslint-disable-next-line @typescript-eslint/consistent-type-assertions
exports.default = {
    cancel: ()=>{},
    schedule: (fn)=>{
        // react 16.x
        if (// `unstable_batchedUpdates` is defined in all currently supported versions
        // but could be removed in the future.
        // This check is defensive and not currently necessary.
        typeof (0, _reactDomDefault.default).unstable_batchedUpdates === 'function' && // The version export was only introduced in `react-dom@16.13.0`
        // but we need to support `react-dom@^16.8.0`
        // so we need to handle when the version is `undefined`
        (typeof (0, _reactDom.version) === 'undefined' || (0, _reactDom.version).startsWith('16'))) (0, _reactDomDefault.default).unstable_batchedUpdates(()=>{
            fn();
        });
        else if (typeof (0, _reactDefault.default).startTransition === 'function') // @ts-ignore -error React.startTransition does not exist in react-16
        (0, _reactDefault.default).startTransition(()=>{
            fn();
        });
        else fn();
        return '';
    }
};

},{"react":"ltHCL","react-dom":"7Lblg","@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"lTv1N":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "createSubscribeFn", ()=>createSubscribeFn);
parcelHelpers.export(exports, "subscribe", ()=>subscribe);
var _objectSpread = require("@swc/helpers/_/_object_spread");
var _objectSpreadProps = require("@swc/helpers/_/_object_spread_props");
var _relayRuntime = require("relay-runtime");
var _platformFeatureFlags = require("@atlaskit/platform-feature-flags");
var _graphqlSubscription = require("@atlassian/graphql-subscription");
let cachedDefaultSubscribe;
function createSubscribeFn(subscribeOptions) {
    if (typeof subscribeOptions === 'undefined' && typeof cachedDefaultSubscribe !== 'undefined') return cachedDefaultSubscribe;
    const fn = ({ id, name: operationName }, variables, cacheConfig)=>(0, _relayRuntime.Observable).create((sink)=>{
            var _cacheConfig_metadata, _subscribeOptions_onSubscribeTrigger;
            const client = (0, _graphqlSubscription.getClient)();
            if (!client) return sink.error(new Error('Unable to create subscription client'));
            const replayConfig = (cacheConfig === null || cacheConfig === void 0 ? void 0 : (_cacheConfig_metadata = cacheConfig.metadata) === null || _cacheConfig_metadata === void 0 ? void 0 : _cacheConfig_metadata.replay) || undefined;
            // When the fix gate is ON and the caller supplies a `command` key inside
            // replayConfig, hoist it to extensions.command (flat) to match AGG's
            // expected wire shape. AGG reads extensions["command"] directly; the
            // previous extensions.replay.command nesting was silently dropped and no
            // Replay ChannelCommand was ever issued. See CRCS-3291.
            // When the gate is OFF the old extensions.replay: {...} shape is preserved,
            // which is the broken-but-stable status-quo for consumers not using replay.
            const replayCommand = replayConfig !== null && typeof replayConfig === 'object' && 'command' in replayConfig ? replayConfig.command : undefined;
            const replayExtensions = replayCommand && (0, _platformFeatureFlags.fg)('platform_relay_subscription_fix_replay_command') ? {
                command: replayCommand
            } : replayConfig ? {
                replay: replayConfig
            } : {};
            const payload = {
                query: '',
                operationName,
                variables,
                extensions: (0, _objectSpread._)({
                    pq: id
                }, (subscribeOptions === null || subscribeOptions === void 0 ? void 0 : subscribeOptions.subscribeExtensions) || {}, replayExtensions)
            };
            let requestId = null;
            subscribeOptions === null || subscribeOptions === void 0 ? void 0 : (_subscribeOptions_onSubscribeTrigger = subscribeOptions.onSubscribeTrigger) === null || _subscribeOptions_onSubscribeTrigger === void 0 ? void 0 : _subscribeOptions_onSubscribeTrigger.call(subscribeOptions, payload);
            return client.subscribe(payload, (0, _objectSpreadProps._)((0, _objectSpread._)({}, sink), {
                next: (value)=>{
                    var _value_extensions_gateway, _value_extensions;
                    // @ts-expect-error agg prop is missing on generic "extensions" type
                    const aggRequestId = value === null || value === void 0 ? void 0 : (_value_extensions = value.extensions) === null || _value_extensions === void 0 ? void 0 : (_value_extensions_gateway = _value_extensions.gateway) === null || _value_extensions_gateway === void 0 ? void 0 : _value_extensions_gateway.request_id;
                    requestId = aggRequestId !== null && aggRequestId !== void 0 ? aggRequestId : requestId;
                    // @ts-expect-error incompatible types between two libraries
                    sink.next(value);
                },
                error: (sinkError)=>{
                    var _subscribeOptions_onSubscribeError;
                    const errorInfo = (0, _graphqlSubscription.getSinkError)(sinkError);
                    sink.error(errorInfo);
                    subscribeOptions === null || subscribeOptions === void 0 ? void 0 : (_subscribeOptions_onSubscribeError = subscribeOptions.onSubscribeError) === null || _subscribeOptions_onSubscribeError === void 0 ? void 0 : _subscribeOptions_onSubscribeError.call(subscribeOptions, (0, _objectSpreadProps._)((0, _objectSpread._)({}, payload), {
                        requestId
                    }));
                }
            }));
        });
    if (typeof subscribeOptions === 'undefined') cachedDefaultSubscribe = fn;
    return fn;
}
const subscribe = createSubscribeFn();

},{"@swc/helpers/_/_object_spread":"9gdrV","@swc/helpers/_/_object_spread_props":"kANqQ","relay-runtime":"2IxFR","@atlaskit/platform-feature-flags":"8rD2i","@atlassian/graphql-subscription":"2EoGp","@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"2EoGp":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "useSubscribe", ()=>(0, _subscribe.useSubscribe));
parcelHelpers.export(exports, "getClient", ()=>(0, _client.getClient));
parcelHelpers.export(exports, "getSinkError", ()=>(0, _sink.getSinkError));
var _subscribe = require("./services/subscribe");
var _client = require("./utils/client");
var _sink = require("./utils/sink");

},{"./services/subscribe":false,"./utils/client":"jm3zB","./utils/sink":"iK0JS","@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"jm3zB":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "getClient", ()=>getClient);
parcelHelpers.export(exports, "cleanUpClient", ()=>cleanUpClient);
var _graphqlWs = require("graphql-ws");
var _relayExperimentalApis = require("@atlassian/relay-experimental-apis");
var _constants = require("../../constants");
var _index = require("../index");
let client;
const getClient = ()=>{
    var _window, _window1;
    if ((0, _index.isSSR)()) return null;
    var _window_BUILD_KEY, _window_SSR_BUILD_KEY;
    if (!client) client = (0, _graphqlWs.createClient)({
        url: (0, _index.getAggSubscriptionEndpoint)(),
        lazy: true,
        keepAlive: (0, _constants.WS_CLIENT_KEEP_ALIVE),
        retryAttempts: (0, _constants.WS_CLIENT_RETRIES),
        connectionParams: {
            'atl-client-name': 'jira-frontend',
            'atl-client-version': `${(_window_BUILD_KEY = (_window = window) === null || _window === void 0 ? void 0 : _window.BUILD_KEY) !== null && _window_BUILD_KEY !== void 0 ? _window_BUILD_KEY : ''}::${(_window_SSR_BUILD_KEY = (_window1 = window) === null || _window1 === void 0 ? void 0 : _window1.SSR_BUILD_KEY) !== null && _window_SSR_BUILD_KEY !== void 0 ? _window_SSR_BUILD_KEY : ''}`,
            'X-ExperimentalApi': (0, _relayExperimentalApis.getRelayExperimentalApis)().join(',')
        }
    });
    return client;
};
const cleanUpClient = ()=>{
    client = null;
};

},{"graphql-ws":"eDBVp","@atlassian/relay-experimental-apis":"bfMHE","../../constants":"aK7ic","../index":"eAgxD","@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"eDBVp":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _clientMjs = require("./client.mjs");
parcelHelpers.exportAll(_clientMjs, exports);
var _serverMjs = require("./server.mjs");
parcelHelpers.exportAll(_serverMjs, exports);
var _commonMjs = require("./common.mjs");
parcelHelpers.exportAll(_commonMjs, exports);

},{"./client.mjs":"ebcMP","./server.mjs":false,"./common.mjs":false,"@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"ebcMP":[function(require,module,exports,__globalThis) {
/**
 *
 * client
 *
 */ var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
/**
 * Creates a disposable GraphQL over WebSocket client.
 *
 * @category Client
 */ parcelHelpers.export(exports, "createClient", ()=>createClient);
/**
 * A synthetic close event `4499: Terminated` is issued to the current to immediately
 * close the connection without waiting for the one coming from `WebSocket.onclose`.
 *
 * Terminating is not considered fatal and a connection retry will occur as expected.
 *
 * Useful in cases where the WebSocket is stuck and not emitting any events;
 * can happen on iOS Safari, see: https://github.com/enisdenjo/graphql-ws/discussions/290.
 */ parcelHelpers.export(exports, "TerminatedCloseEvent", ()=>TerminatedCloseEvent);
var _commonMjs = require("./common.mjs");
var _utilsMjs = require("./utils.mjs");
/** This file is the entry point for browsers, re-export common elements. */ parcelHelpers.exportAll(_commonMjs, exports);
var global = arguments[3];
var __await = undefined && undefined.__await || function(v) {
    return this instanceof __await ? (this.v = v, this) : new __await(v);
};
var __asyncGenerator = undefined && undefined.__asyncGenerator || function(thisArg, _arguments, generator) {
    if (!Symbol.asyncIterator) throw new TypeError("Symbol.asyncIterator is not defined.");
    var g = generator.apply(thisArg, _arguments || []), i, q = [];
    return i = Object.create((typeof AsyncIterator === "function" ? AsyncIterator : Object).prototype), verb("next"), verb("throw"), verb("return", awaitReturn), i[Symbol.asyncIterator] = function() {
        return this;
    }, i;
    function awaitReturn(f) {
        return function(v) {
            return Promise.resolve(v).then(f, reject);
        };
    }
    function verb(n, f) {
        if (g[n]) {
            i[n] = function(v) {
                return new Promise(function(a, b) {
                    q.push([
                        n,
                        v,
                        a,
                        b
                    ]) > 1 || resume(n, v);
                });
            };
            if (f) i[n] = f(i[n]);
        }
    }
    function resume(n, v) {
        try {
            step(g[n](v));
        } catch (e) {
            settle(q[0][3], e);
        }
    }
    function step(r) {
        r.value instanceof __await ? Promise.resolve(r.value.v).then(fulfill, reject) : settle(q[0][2], r);
    }
    function fulfill(value) {
        resume("next", value);
    }
    function reject(value) {
        resume("throw", value);
    }
    function settle(f, v) {
        if (f(v), q.shift(), q.length) resume(q[0][0], q[0][1]);
    }
};
function createClient(options) {
    const { url, connectionParams, lazy = true, onNonLazyError = console.error, lazyCloseTimeout: lazyCloseTimeoutMs = 0, keepAlive = 0, disablePong, connectionAckWaitTimeout = 0, retryAttempts = 5, retryWait = async function randomisedExponentialBackoff(retries) {
        let retryDelay = 1000; // start with 1s delay
        for(let i = 0; i < retries; i++)retryDelay *= 2;
        await new Promise((resolve)=>setTimeout(resolve, retryDelay + // add random timeout from 300ms to 3s
            Math.floor(Math.random() * 2700 + 300)));
    }, shouldRetry = isLikeCloseEvent, isFatalConnectionProblem, on, webSocketImpl, /**
     * Generates a v4 UUID to be used as the ID using `Math`
     * as the random number generator. Supply your own generator
     * in case you need more uniqueness.
     *
     * Reference: https://gist.github.com/jed/982883
     */ generateID = function generateUUID() {
        return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, (c)=>{
            const r = Math.random() * 16 | 0, v = c == 'x' ? r : r & 0x3 | 0x8;
            return v.toString(16);
        });
    }, jsonMessageReplacer: replacer, jsonMessageReviver: reviver } = options;
    let ws;
    if (webSocketImpl) {
        if (!isWebSocket(webSocketImpl)) throw new Error('Invalid WebSocket implementation provided');
        ws = webSocketImpl;
    } else if (typeof WebSocket !== 'undefined') ws = WebSocket;
    else if (typeof global !== 'undefined') ws = global.WebSocket || // @ts-expect-error: Support more browsers
    global.MozWebSocket;
    else if (typeof window !== 'undefined') ws = window.WebSocket || // @ts-expect-error: Support more browsers
    window.MozWebSocket;
    if (!ws) throw new Error("WebSocket implementation missing; on Node you can `import WebSocket from 'ws';` and pass `webSocketImpl: WebSocket` to `createClient`");
    const WebSocketImpl = ws;
    // websocket status emitter, subscriptions are handled differently
    const emitter = (()=>{
        const message = (()=>{
            const listeners = {};
            return {
                on (id, listener) {
                    listeners[id] = listener;
                    return ()=>{
                        delete listeners[id];
                    };
                },
                emit (message) {
                    var _a;
                    if ('id' in message) (_a = listeners[message.id]) === null || _a === void 0 || _a.call(listeners, message);
                }
            };
        })();
        const listeners = {
            connecting: (on === null || on === void 0 ? void 0 : on.connecting) ? [
                on.connecting
            ] : [],
            opened: (on === null || on === void 0 ? void 0 : on.opened) ? [
                on.opened
            ] : [],
            connected: (on === null || on === void 0 ? void 0 : on.connected) ? [
                on.connected
            ] : [],
            ping: (on === null || on === void 0 ? void 0 : on.ping) ? [
                on.ping
            ] : [],
            pong: (on === null || on === void 0 ? void 0 : on.pong) ? [
                on.pong
            ] : [],
            message: (on === null || on === void 0 ? void 0 : on.message) ? [
                message.emit,
                on.message
            ] : [
                message.emit
            ],
            closed: (on === null || on === void 0 ? void 0 : on.closed) ? [
                on.closed
            ] : [],
            error: (on === null || on === void 0 ? void 0 : on.error) ? [
                on.error
            ] : []
        };
        return {
            onMessage: message.on,
            on (event, listener) {
                const l = listeners[event];
                l.push(listener);
                return ()=>{
                    l.splice(l.indexOf(listener), 1);
                };
            },
            emit (event, ...args) {
                // we copy the listeners so that unlistens dont "pull the rug under our feet"
                for (const listener of [
                    ...listeners[event]
                ])// @ts-expect-error: The args should fit
                listener(...args);
            }
        };
    })();
    // invokes the callback either when an error or closed event is emitted,
    // first one that gets called prevails, other emissions are ignored
    function errorOrClosed(cb) {
        const listening = [
            // errors are fatal and more critical than close events, throw them first
            emitter.on('error', (err)=>{
                listening.forEach((unlisten)=>unlisten());
                cb(err);
            }),
            // closes can be graceful and not fatal, throw them second (if error didnt throw)
            emitter.on('closed', (event)=>{
                listening.forEach((unlisten)=>unlisten());
                cb(event);
            })
        ];
    }
    let connecting, locks = 0, lazyCloseTimeout, retrying = false, retries = 0, disposed = false;
    async function connect() {
        // clear the lazy close timeout immediatelly so that close gets debounced
        // see: https://github.com/enisdenjo/graphql-ws/issues/388
        clearTimeout(lazyCloseTimeout);
        const [socket, throwOnClose] = await (connecting !== null && connecting !== void 0 ? connecting : connecting = new Promise((connected, denied)=>(async ()=>{
                if (retrying) {
                    await retryWait(retries);
                    // subscriptions might complete while waiting for retry
                    if (!locks) {
                        connecting = undefined;
                        return denied({
                            code: 1000,
                            reason: 'All Subscriptions Gone'
                        });
                    }
                    retries++;
                }
                emitter.emit('connecting', retrying);
                const socket = new WebSocketImpl(typeof url === 'function' ? await url() : url, (0, _commonMjs.GRAPHQL_TRANSPORT_WS_PROTOCOL));
                let connectionAckTimeout, queuedPing;
                function enqueuePing() {
                    if (isFinite(keepAlive) && keepAlive > 0) {
                        clearTimeout(queuedPing); // in case where a pong was received before a ping (this is valid behaviour)
                        queuedPing = setTimeout(()=>{
                            if (socket.readyState === WebSocketImpl.OPEN) {
                                socket.send((0, _commonMjs.stringifyMessage)({
                                    type: (0, _commonMjs.MessageType).Ping
                                }));
                                emitter.emit('ping', false, undefined);
                            }
                        }, keepAlive);
                    }
                }
                errorOrClosed((errOrEvent)=>{
                    connecting = undefined;
                    clearTimeout(connectionAckTimeout);
                    clearTimeout(queuedPing);
                    denied(errOrEvent);
                    if (errOrEvent instanceof TerminatedCloseEvent) {
                        socket.close(4499, 'Terminated'); // close event is artificial and emitted manually, see `Client.terminate()` below
                        socket.onerror = null;
                        socket.onclose = null;
                    }
                });
                socket.onerror = (err)=>emitter.emit('error', err);
                socket.onclose = (event)=>emitter.emit('closed', event);
                socket.onopen = async ()=>{
                    try {
                        emitter.emit('opened', socket);
                        const payload = typeof connectionParams === 'function' ? await connectionParams() : connectionParams;
                        // connectionParams might take too long causing the server to kick off the client
                        // the necessary error/close event is already reported - simply stop execution
                        if (socket.readyState !== WebSocketImpl.OPEN) return;
                        socket.send((0, _commonMjs.stringifyMessage)(payload ? {
                            type: (0, _commonMjs.MessageType).ConnectionInit,
                            payload
                        } : {
                            type: (0, _commonMjs.MessageType).ConnectionInit
                        }, replacer));
                        if (isFinite(connectionAckWaitTimeout) && connectionAckWaitTimeout > 0) connectionAckTimeout = setTimeout(()=>{
                            socket.close((0, _commonMjs.CloseCode).ConnectionAcknowledgementTimeout, 'Connection acknowledgement timeout');
                        }, connectionAckWaitTimeout);
                        enqueuePing(); // enqueue ping (noop if disabled)
                    } catch (err) {
                        emitter.emit('error', err);
                        socket.close((0, _commonMjs.CloseCode).InternalClientError, (0, _utilsMjs.limitCloseReason)(err instanceof Error ? err.message : new Error(err).message, 'Internal client error'));
                    }
                };
                let acknowledged = false;
                socket.onmessage = ({ data })=>{
                    try {
                        const message = (0, _commonMjs.parseMessage)(data, reviver);
                        emitter.emit('message', message);
                        if (message.type === 'ping' || message.type === 'pong') {
                            emitter.emit(message.type, true, message.payload); // received
                            if (message.type === 'pong') enqueuePing(); // enqueue next ping (noop if disabled)
                            else if (!disablePong) {
                                // respond with pong on ping
                                socket.send((0, _commonMjs.stringifyMessage)(message.payload ? {
                                    type: (0, _commonMjs.MessageType).Pong,
                                    payload: message.payload
                                } : {
                                    type: (0, _commonMjs.MessageType).Pong
                                }));
                                emitter.emit('pong', false, message.payload);
                            }
                            return; // ping and pongs can be received whenever
                        }
                        if (acknowledged) return; // already connected and acknowledged
                        if (message.type !== (0, _commonMjs.MessageType).ConnectionAck) throw new Error(`First message cannot be of type ${message.type}`);
                        clearTimeout(connectionAckTimeout);
                        acknowledged = true;
                        emitter.emit('connected', socket, message.payload, retrying); // connected = socket opened + acknowledged
                        retrying = false; // future lazy connects are not retries
                        retries = 0; // reset the retries on connect
                        connected([
                            socket,
                            new Promise((_, reject)=>errorOrClosed(reject))
                        ]);
                    } catch (err) {
                        socket.onmessage = null; // stop reading messages as soon as reading breaks once
                        emitter.emit('error', err);
                        socket.close((0, _commonMjs.CloseCode).BadResponse, (0, _utilsMjs.limitCloseReason)(err instanceof Error ? err.message : new Error(err).message, 'Bad response'));
                    }
                };
            })()));
        // if the provided socket is in a closing state, wait for the throw on close
        if (socket.readyState === WebSocketImpl.CLOSING) await throwOnClose;
        let release = ()=>{
        // releases this connection
        };
        const released = new Promise((resolve)=>release = resolve);
        return [
            socket,
            release,
            Promise.race([
                // wait for
                released.then(()=>{
                    if (!locks) {
                        // and if no more locks are present, complete the connection
                        const complete = ()=>socket.close(1000, 'Normal Closure');
                        if (isFinite(lazyCloseTimeoutMs) && lazyCloseTimeoutMs > 0) // if the keepalive is set, allow for the specified calmdown time and
                        // then complete if the socket is still open.
                        lazyCloseTimeout = setTimeout(()=>{
                            if (socket.readyState === WebSocketImpl.OPEN) complete();
                        }, lazyCloseTimeoutMs);
                        else // otherwise complete immediately
                        complete();
                    }
                }),
                // or
                throwOnClose
            ])
        ];
    }
    /**
     * Checks the `connect` problem and evaluates if the client should retry.
     */ function shouldRetryConnectOrThrow(errOrCloseEvent) {
        // some close codes are worth reporting immediately
        if (isLikeCloseEvent(errOrCloseEvent) && (isFatalInternalCloseCode(errOrCloseEvent.code) || [
            (0, _commonMjs.CloseCode).InternalServerError,
            (0, _commonMjs.CloseCode).InternalClientError,
            (0, _commonMjs.CloseCode).BadRequest,
            (0, _commonMjs.CloseCode).BadResponse,
            (0, _commonMjs.CloseCode).Unauthorized,
            // CloseCode.Forbidden, might grant access out after retry
            (0, _commonMjs.CloseCode).SubprotocolNotAcceptable,
            // CloseCode.ConnectionInitialisationTimeout, might not time out after retry
            // CloseCode.ConnectionAcknowledgementTimeout, might not time out after retry
            (0, _commonMjs.CloseCode).SubscriberAlreadyExists,
            (0, _commonMjs.CloseCode).TooManyInitialisationRequests
        ].includes(errOrCloseEvent.code))) throw errOrCloseEvent;
        // client was disposed, no retries should proceed regardless
        if (disposed) return false;
        // normal closure (possibly all subscriptions have completed)
        // if no locks were acquired in the meantime, shouldnt try again
        if (isLikeCloseEvent(errOrCloseEvent) && errOrCloseEvent.code === 1000) return locks > 0;
        // retries are not allowed or we tried to many times, report error
        if (!retryAttempts || retries >= retryAttempts) throw errOrCloseEvent;
        // throw non-retryable connection problems
        if (!shouldRetry(errOrCloseEvent)) throw errOrCloseEvent;
        // @deprecated throw fatal connection problems immediately
        if (isFatalConnectionProblem === null || isFatalConnectionProblem === void 0 ? void 0 : isFatalConnectionProblem(errOrCloseEvent)) throw errOrCloseEvent;
        // looks good, start retrying
        return retrying = true;
    }
    // in non-lazy (hot?) mode always hold one connection lock to persist the socket
    if (!lazy) (async ()=>{
        locks++;
        for(;;)try {
            const [, , throwOnClose] = await connect();
            await throwOnClose; // will always throw because releaser is not used
        } catch (errOrCloseEvent) {
            try {
                if (!shouldRetryConnectOrThrow(errOrCloseEvent)) return;
            } catch (errOrCloseEvent) {
                // report thrown error, no further retries
                return onNonLazyError === null || onNonLazyError === void 0 ? void 0 : onNonLazyError(errOrCloseEvent);
            }
        }
    })();
    function subscribe(payload, sink) {
        const id = generateID(payload);
        let done = false, errored = false, releaser = ()=>{
            // for handling completions before connect
            locks--;
            done = true;
        };
        (async ()=>{
            locks++;
            for(;;)try {
                const [socket, release, waitForReleaseOrThrowOnClose] = await connect();
                // if done while waiting for connect, release the connection lock right away
                if (done) return release();
                const unlisten = emitter.onMessage(id, (message)=>{
                    switch(message.type){
                        case (0, _commonMjs.MessageType).Next:
                            // eslint-disable-next-line @typescript-eslint/no-explicit-any -- payload will fit type
                            sink.next(message.payload);
                            return;
                        case (0, _commonMjs.MessageType).Error:
                            errored = true, done = true;
                            sink.error(message.payload);
                            releaser();
                            return;
                        case (0, _commonMjs.MessageType).Complete:
                            done = true;
                            releaser(); // release completes the sink
                            return;
                    }
                });
                socket.send((0, _commonMjs.stringifyMessage)({
                    id,
                    type: (0, _commonMjs.MessageType).Subscribe,
                    payload
                }, replacer));
                releaser = ()=>{
                    if (!done && socket.readyState === WebSocketImpl.OPEN) // if not completed already and socket is open, send complete message to server on release
                    socket.send((0, _commonMjs.stringifyMessage)({
                        id,
                        type: (0, _commonMjs.MessageType).Complete
                    }, replacer));
                    locks--;
                    done = true;
                    release();
                };
                // either the releaser will be called, connection completed and
                // the promise resolved or the socket closed and the promise rejected.
                // whatever happens though, we want to stop listening for messages
                await waitForReleaseOrThrowOnClose.finally(unlisten);
                return; // completed, shouldnt try again
            } catch (errOrCloseEvent) {
                if (!shouldRetryConnectOrThrow(errOrCloseEvent)) return;
            }
        })().then(()=>{
            // delivering either an error or a complete terminates the sequence
            if (!errored) sink.complete();
        }) // resolves on release or normal closure
        .catch((err)=>{
            sink.error(err);
        }); // rejects on close events and errors
        return ()=>{
            // dispose only of active subscriptions
            if (!done) releaser();
        };
    }
    return {
        on: emitter.on,
        subscribe,
        iterate (request) {
            const pending = [];
            const deferred = {
                done: false,
                error: null,
                resolve: ()=>{
                // noop
                }
            };
            const dispose = subscribe(request, {
                next (val) {
                    // eslint-disable-next-line @typescript-eslint/no-explicit-any -- payload will fit type
                    pending.push(val);
                    deferred.resolve();
                },
                error (err) {
                    deferred.done = true;
                    deferred.error = err;
                    deferred.resolve();
                },
                complete () {
                    deferred.done = true;
                    deferred.resolve();
                }
            });
            const iterator = function iterator() {
                return __asyncGenerator(this, arguments, function* iterator_1() {
                    for(;;){
                        if (!pending.length) // only wait if there are no pending messages available
                        yield __await(new Promise((resolve)=>deferred.resolve = resolve));
                        // first flush
                        while(pending.length)// eslint-disable-next-line @typescript-eslint/no-non-null-assertion
                        yield yield __await(pending.shift());
                        // then error
                        if (deferred.error) throw deferred.error;
                        // or complete
                        if (deferred.done) return yield __await(void 0);
                    }
                });
            }();
            iterator.throw = async (err)=>{
                if (!deferred.done) {
                    deferred.done = true;
                    deferred.error = err;
                    deferred.resolve();
                }
                return {
                    done: true,
                    value: undefined
                };
            };
            iterator.return = async ()=>{
                dispose();
                return {
                    done: true,
                    value: undefined
                };
            };
            return iterator;
        },
        async dispose () {
            disposed = true;
            if (connecting) {
                // if there is a connection, close it
                const [socket] = await connecting;
                socket.close(1000, 'Normal Closure');
            }
        },
        terminate () {
            if (connecting) // only if there is a connection
            emitter.emit('closed', new TerminatedCloseEvent());
        }
    };
}
class TerminatedCloseEvent extends Error {
    constructor(){
        super(...arguments);
        this.name = 'TerminatedCloseEvent';
        this.message = '4499: Terminated';
        this.code = 4499;
        this.reason = 'Terminated';
        this.wasClean = false;
    }
}
function isLikeCloseEvent(val) {
    return (0, _utilsMjs.isObject)(val) && 'code' in val && 'reason' in val;
}
function isFatalInternalCloseCode(code) {
    if ([
        1000,
        1001,
        1006,
        1005,
        1012,
        1013,
        1014
    ].includes(code)) return false;
    // all other internal errors are fatal
    return code >= 1000 && code <= 1999;
}
function isWebSocket(val) {
    return typeof val === 'function' && 'constructor' in val && 'CLOSED' in val && 'CLOSING' in val && 'CONNECTING' in val && 'OPEN' in val;
}

},{"./common.mjs":"hLPMI","./utils.mjs":"79Gt7","@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"hLPMI":[function(require,module,exports,__globalThis) {
/**
 *
 * common
 *
 */ var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "GRAPHQL_TRANSPORT_WS_PROTOCOL", ()=>GRAPHQL_TRANSPORT_WS_PROTOCOL);
parcelHelpers.export(exports, "DEPRECATED_GRAPHQL_WS_PROTOCOL", ()=>DEPRECATED_GRAPHQL_WS_PROTOCOL);
parcelHelpers.export(exports, "CloseCode", ()=>CloseCode);
parcelHelpers.export(exports, "MessageType", ()=>MessageType);
/**
 * Validates the message against the GraphQL over WebSocket Protocol.
 *
 * Invalid messages will throw descriptive errors.
 *
 * @category Common
 */ parcelHelpers.export(exports, "validateMessage", ()=>validateMessage);
/**
 * Checks if the provided value is a valid GraphQL over WebSocket message.
 *
 * @deprecated Use `validateMessage` instead.
 *
 * @category Common
 */ parcelHelpers.export(exports, "isMessage", ()=>isMessage);
/**
 * Parses the raw websocket message data to a valid message.
 *
 * @category Common
 */ parcelHelpers.export(exports, "parseMessage", ()=>parseMessage);
/**
 * Stringifies a valid message ready to be sent through the socket.
 *
 * @category Common
 */ parcelHelpers.export(exports, "stringifyMessage", ()=>stringifyMessage);
var _utilsMjs = require("./utils.mjs");
const GRAPHQL_TRANSPORT_WS_PROTOCOL = 'graphql-transport-ws';
const DEPRECATED_GRAPHQL_WS_PROTOCOL = 'graphql-ws';
var CloseCode;
(function(CloseCode) {
    CloseCode[CloseCode["InternalServerError"] = 4500] = "InternalServerError";
    CloseCode[CloseCode["InternalClientError"] = 4005] = "InternalClientError";
    CloseCode[CloseCode["BadRequest"] = 4400] = "BadRequest";
    CloseCode[CloseCode["BadResponse"] = 4004] = "BadResponse";
    /** Tried subscribing before connect ack */ CloseCode[CloseCode["Unauthorized"] = 4401] = "Unauthorized";
    CloseCode[CloseCode["Forbidden"] = 4403] = "Forbidden";
    CloseCode[CloseCode["SubprotocolNotAcceptable"] = 4406] = "SubprotocolNotAcceptable";
    CloseCode[CloseCode["ConnectionInitialisationTimeout"] = 4408] = "ConnectionInitialisationTimeout";
    CloseCode[CloseCode["ConnectionAcknowledgementTimeout"] = 4504] = "ConnectionAcknowledgementTimeout";
    /** Subscriber distinction is very important */ CloseCode[CloseCode["SubscriberAlreadyExists"] = 4409] = "SubscriberAlreadyExists";
    CloseCode[CloseCode["TooManyInitialisationRequests"] = 4429] = "TooManyInitialisationRequests";
})(CloseCode || (CloseCode = {}));
var MessageType;
(function(MessageType) {
    MessageType["ConnectionInit"] = "connection_init";
    MessageType["ConnectionAck"] = "connection_ack";
    MessageType["Ping"] = "ping";
    MessageType["Pong"] = "pong";
    MessageType["Subscribe"] = "subscribe";
    MessageType["Next"] = "next";
    MessageType["Error"] = "error";
    MessageType["Complete"] = "complete";
})(MessageType || (MessageType = {}));
function validateMessage(val) {
    if (!(0, _utilsMjs.isObject)(val)) throw new Error(`Message is expected to be an object, but got ${(0, _utilsMjs.extendedTypeof)(val)}`);
    if (!val.type) throw new Error(`Message is missing the 'type' property`);
    if (typeof val.type !== 'string') throw new Error(`Message is expects the 'type' property to be a string, but got ${(0, _utilsMjs.extendedTypeof)(val.type)}`);
    switch(val.type){
        case MessageType.ConnectionInit:
        case MessageType.ConnectionAck:
        case MessageType.Ping:
        case MessageType.Pong:
            if (val.payload != null && !(0, _utilsMjs.isObject)(val.payload)) throw new Error(`"${val.type}" message expects the 'payload' property to be an object or nullish or missing, but got "${val.payload}"`);
            break;
        case MessageType.Subscribe:
            if (typeof val.id !== 'string') throw new Error(`"${val.type}" message expects the 'id' property to be a string, but got ${(0, _utilsMjs.extendedTypeof)(val.id)}`);
            if (!val.id) throw new Error(`"${val.type}" message requires a non-empty 'id' property`);
            if (!(0, _utilsMjs.isObject)(val.payload)) throw new Error(`"${val.type}" message expects the 'payload' property to be an object, but got ${(0, _utilsMjs.extendedTypeof)(val.payload)}`);
            if (typeof val.payload.query !== 'string') throw new Error(`"${val.type}" message payload expects the 'query' property to be a string, but got ${(0, _utilsMjs.extendedTypeof)(val.payload.query)}`);
            if (val.payload.variables != null && !(0, _utilsMjs.isObject)(val.payload.variables)) throw new Error(`"${val.type}" message payload expects the 'variables' property to be a an object or nullish or missing, but got ${(0, _utilsMjs.extendedTypeof)(val.payload.variables)}`);
            if (val.payload.operationName != null && (0, _utilsMjs.extendedTypeof)(val.payload.operationName) !== 'string') throw new Error(`"${val.type}" message payload expects the 'operationName' property to be a string or nullish or missing, but got ${(0, _utilsMjs.extendedTypeof)(val.payload.operationName)}`);
            if (val.payload.extensions != null && !(0, _utilsMjs.isObject)(val.payload.extensions)) throw new Error(`"${val.type}" message payload expects the 'extensions' property to be a an object or nullish or missing, but got ${(0, _utilsMjs.extendedTypeof)(val.payload.extensions)}`);
            break;
        case MessageType.Next:
            if (typeof val.id !== 'string') throw new Error(`"${val.type}" message expects the 'id' property to be a string, but got ${(0, _utilsMjs.extendedTypeof)(val.id)}`);
            if (!val.id) throw new Error(`"${val.type}" message requires a non-empty 'id' property`);
            if (!(0, _utilsMjs.isObject)(val.payload)) throw new Error(`"${val.type}" message expects the 'payload' property to be an object, but got ${(0, _utilsMjs.extendedTypeof)(val.payload)}`);
            break;
        case MessageType.Error:
            if (typeof val.id !== 'string') throw new Error(`"${val.type}" message expects the 'id' property to be a string, but got ${(0, _utilsMjs.extendedTypeof)(val.id)}`);
            if (!val.id) throw new Error(`"${val.type}" message requires a non-empty 'id' property`);
            if (!(0, _utilsMjs.areGraphQLErrors)(val.payload)) throw new Error(`"${val.type}" message expects the 'payload' property to be an array of GraphQL errors, but got ${JSON.stringify(val.payload)}`);
            break;
        case MessageType.Complete:
            if (typeof val.id !== 'string') throw new Error(`"${val.type}" message expects the 'id' property to be a string, but got ${(0, _utilsMjs.extendedTypeof)(val.id)}`);
            if (!val.id) throw new Error(`"${val.type}" message requires a non-empty 'id' property`);
            break;
        default:
            throw new Error(`Invalid message 'type' property "${val.type}"`);
    }
    return val;
}
function isMessage(val) {
    try {
        validateMessage(val);
        return true;
    } catch (_a) {
        return false;
    }
}
function parseMessage(data, reviver) {
    return validateMessage(typeof data === 'string' ? JSON.parse(data, reviver) : data);
}
function stringifyMessage(msg, replacer) {
    validateMessage(msg);
    return JSON.stringify(msg, replacer);
}

},{"./utils.mjs":"79Gt7","@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"79Gt7":[function(require,module,exports,__globalThis) {
/** @private */ var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "extendedTypeof", ()=>extendedTypeof);
/** @private */ parcelHelpers.export(exports, "isObject", ()=>isObject);
/** @private */ parcelHelpers.export(exports, "isAsyncIterable", ()=>isAsyncIterable);
/** @private */ parcelHelpers.export(exports, "isAsyncGenerator", ()=>isAsyncGenerator);
/** @private */ parcelHelpers.export(exports, "areGraphQLErrors", ()=>areGraphQLErrors);
/**
 * Limits the WebSocket close event reason to not exceed a length of one frame.
 * Reference: https://datatracker.ietf.org/doc/html/rfc6455#section-5.2.
 *
 * @private
 */ parcelHelpers.export(exports, "limitCloseReason", ()=>limitCloseReason);
function extendedTypeof(val) {
    if (val === null) return 'null';
    if (Array.isArray(val)) return 'array';
    return typeof val;
}
function isObject(val) {
    return extendedTypeof(val) === 'object';
}
function isAsyncIterable(val) {
    return typeof Object(val)[Symbol.asyncIterator] === 'function';
}
function isAsyncGenerator(val) {
    return isObject(val) && typeof Object(val)[Symbol.asyncIterator] === 'function' && typeof val.return === 'function';
}
function areGraphQLErrors(obj) {
    return Array.isArray(obj) && // must be at least one error
    obj.length > 0 && // error has at least a message
    obj.every((ob)=>'message' in ob);
}
function limitCloseReason(reason, whenTooLong) {
    return reason.length < 124 ? reason : whenTooLong;
}

},{"@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"aK7ic":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "WS_CLIENT_KEEP_ALIVE", ()=>WS_CLIENT_KEEP_ALIVE);
parcelHelpers.export(exports, "WS_CLIENT_RETRIES", ()=>WS_CLIENT_RETRIES);
parcelHelpers.export(exports, "WS_CLOSE_ON_IDLE", ()=>WS_CLOSE_ON_IDLE);
const WS_CLIENT_KEEP_ALIVE = 580000; // 9m 40 - timeframe needed for UCT token refresh: https://developer.atlassian.com/platform/graphql-gateway/subscriptions/security/#long-lived-user-context-token
const WS_CLIENT_RETRIES = 100;
const WS_CLOSE_ON_IDLE = 300000; // 5m

},{"@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"eAgxD":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "isSSR", ()=>isSSR);
parcelHelpers.export(exports, "getAggSubscriptionEndpoint", ()=>getAggSubscriptionEndpoint);
const isSSR = ()=>{
    var _globalThis___SERVER__;
    return (_globalThis___SERVER__ = globalThis.__SERVER__) !== null && _globalThis___SERVER__ !== void 0 ? _globalThis___SERVER__ : false;
};
const getAggSubscriptionEndpoint = ()=>`${window.location.origin.replace('http', 'ws')}/gateway/api/graphql/subscriptions`;

},{"@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"iK0JS":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "getSinkError", ()=>getSinkError);
const getSinkError = (error)=>{
    let errorInfo;
    if (Array.isArray(error)) // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
    [errorInfo] = error;
    else if (error instanceof Error) errorInfo = error;
    else if (typeof error === 'object' && 'type' in error && error.type === 'close') // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
    errorInfo = new Error(`CloseEvent: ${error.reason}`);
    else if (typeof error === 'object' && 'type' in error && error.type === 'error') {
        // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
        const errorEvent = error;
        errorInfo = new Error(`ErrorEvent: "${errorEvent.error}"`);
    } else if (error instanceof Event) // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
    errorInfo = new Error(`Event: ${error.type}`);
    else errorInfo = new Error(`Unknown sink error: ${error}`);
    if (error instanceof Error && error.stack) errorInfo.stack = error.stack;
    return errorInfo;
};

},{"@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"dafjR":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "CLEAN_UP_TIMEOUT", ()=>CLEAN_UP_TIMEOUT);
parcelHelpers.export(exports, "startCaptureGraphQlErrors", ()=>startCaptureGraphQlErrors);
parcelHelpers.export(exports, "stopCaptureGraphQlErrors", ()=>stopCaptureGraphQlErrors);
parcelHelpers.export(exports, "captureErrors", ()=>captureErrors);
parcelHelpers.export(exports, "isUnauthenticated", ()=>isUnauthenticated);
parcelHelpers.export(exports, "isStepUpAuthError", ()=>isStepUpAuthError);
// eslint-disable-next-line @atlaskit/platform/prefer-crypto-random-uuid -- Use crypto.randomUUID instead
var _uuid = require("uuid");
const errorCollector = new Map();
const CLEAN_UP_TIMEOUT = 120000; // 2min
const scheduleCleanup = (key)=>{
    setTimeout(()=>{
        errorCollector.delete(key);
    }, CLEAN_UP_TIMEOUT);
};
const startCaptureGraphQlErrors = (key = (0, _uuid.v4)())=>{
    errorCollector.set(key, []);
    scheduleCleanup(key);
    return key;
};
const stopCaptureGraphQlErrors = (key)=>{
    const errors = errorCollector.get(key);
    errorCollector.delete(key);
    return errors || [];
};
const captureErrors = (errors, meta)=>{
    if (errors) errorCollector.forEach((value, key)=>{
        errorCollector.set(key, [
            ...value,
            {
                errors,
                meta
            }
        ]);
    });
};
const isUnauthenticated = (errors)=>{
    if (errors.length > 0) return errors.some((error)=>error.message.startsWith('Auth category: UNAUTHENTICATED'));
    return false;
};
const isStepUpAuthError = (errors)=>{
    var _stepUpError_extensions;
    const stepUpError = errors.find((error)=>{
        var _error_extensions, _error_extensions1;
        return error.message.startsWith('Step-up authentication is required.') && ((_error_extensions = error.extensions) === null || _error_extensions === void 0 ? void 0 : _error_extensions.statusCode) === 303 && ((_error_extensions1 = error.extensions) === null || _error_extensions1 === void 0 ? void 0 : _error_extensions1.stepUpUrl);
    });
    var _stepUpError_extensions_stepUpUrl;
    return {
        hasStepUpAuthError: !!stepUpError,
        stepUpUrl: (_stepUpError_extensions_stepUpUrl = stepUpError === null || stepUpError === void 0 ? void 0 : (_stepUpError_extensions = stepUpError.extensions) === null || _stepUpError_extensions === void 0 ? void 0 : _stepUpError_extensions.stepUpUrl) !== null && _stepUpError_extensions_stepUpUrl !== void 0 ? _stepUpError_extensions_stepUpUrl : undefined
    };
};

},{"uuid":"5elg8","@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"7ZNPA":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "getCacheKey", ()=>getCacheKey);
parcelHelpers.export(exports, "getQueryIDFromCacheKey", ()=>getQueryIDFromCacheKey);
/**
 * Query response cache that works across SSR. Extends on Relay's QueryResponse Cache:
 * https://github.com/facebook/relay/blob/main/packages/relay-runtime/network/RelayQueryResponseCache.js
 *
 * Can properly handle multiple requests of the same ID (Relay's Cache ID is based on query, not variables),
 * and includes a TTL and maximum cache size to further prevent stale data.
 */ parcelHelpers.export(exports, "SSRQueryResponseCache", ()=>SSRQueryResponseCache);
var _relayRuntime = require("relay-runtime");
function getCacheKey(queryID, variables) {
    return JSON.stringify((0, _relayRuntime.stableCopy)({
        queryID,
        variables
    }));
}
function getQueryIDFromCacheKey(cacheKey) {
    return JSON.parse(cacheKey).queryID;
}
class SSRQueryResponseCache extends (0, _relayRuntime.QueryResponseCache) {
    /**
	 * @deprecated only sets a single response; does not work well if requests use defer or stream.
	 *             use {@link appendWithMetadata} or, better still, use {@link "@atlassian/server-to-client-comms/server-dispatcher"}.
	 */ setWithMetadata(queryID, variables, payload, metadata) {
        this.requestMetadata.set(queryID, metadata);
        this.set(queryID, variables, payload);
    }
    /**
	 * Stores a GraphQLRepsonse along with metadata about the call.
	 * If called multiple times (such as when incremental payloads are received),
	 * will update the stored response to be an array of GraphQLSingularResponse objects,
	 * which Relay is happy to handle.
	 * @deprecated works, but does not work well if requests use defer or stream.
	 *             use {@link appendWithMetadata} or, better still, use {@link "@atlassian/server-to-client-comms/server-dispatcher"}.
	 */ appendWithMetadata(queryID, variables, payload, metadata) {
        this.requestMetadata.set(queryID, metadata);
        const currentResponse = this.get(queryID, variables);
        if (!currentResponse) this.set(queryID, variables, payload);
        else if (currentResponse instanceof Array) {
            const newResponse = [
                ...currentResponse
            ].concat(payload);
            this.set(queryID, variables, newResponse);
        } else {
            const newResponse = [
                currentResponse
            ].concat(payload);
            this.set(queryID, variables, newResponse);
        }
    }
    /**
	 * Deletes a request from the store, if found.
	 *
	 * IMPORTANT: Make sure DELETE method always has tests that include get/set
	 * to ensure our `getCacheKey` matches Relay's.
	 *
	 * @returns {boolean} indicating if an entry in the cache was deleted
	 */ delete(queryID, variables) {
        const cacheKey = getCacheKey(queryID, variables);
        // @ts-expect-error - TS2339 - Property '_responses' does not exist on type 'SSRQueryResponseCache'.
        return this._responses.delete(cacheKey);
    }
    serialize() {
        return {
            [this.cacheName]: {
                // @ts-expect-error - TS2322 - Type '{ [x: string]: { requestMetadata: [string, RequestMetadata][]; responses: unknown[]; }; }' is not assignable to type 'Partial<Record<string, [string, GraphQLResponse][]>>'.
                requestMetadata: Array.from(this.requestMetadata.entries()),
                // @ts-expect-error - TS2339 - Property '_responses' does not exist on type 'SSRQueryResponseCache'.
                responses: Array.from(this._responses.entries())
            }
        };
    }
    constructor({ cacheName, size, ttl, timeoutCallback }){
        var _window_SPA_STATE, _window, _window_SKELETON_NAVIGATION, _window1, _window___PLATFORM_SSR_AGG_CACHE__, _window2;
        super({
            size,
            ttl
        });
        const isServer = typeof window === 'undefined';
        const cachedData = isServer ? {} : ((_window = window) === null || _window === void 0 ? void 0 : (_window_SPA_STATE = _window.SPA_STATE) === null || _window_SPA_STATE === void 0 ? void 0 : _window_SPA_STATE[cacheName]) || ((_window1 = window) === null || _window1 === void 0 ? void 0 : (_window_SKELETON_NAVIGATION = _window1.SKELETON_NAVIGATION) === null || _window_SKELETON_NAVIGATION === void 0 ? void 0 : _window_SKELETON_NAVIGATION[cacheName]) || ((_window2 = window) === null || _window2 === void 0 ? void 0 : (_window___PLATFORM_SSR_AGG_CACHE__ = _window2.__PLATFORM_SSR_AGG_CACHE__) === null || _window___PLATFORM_SSR_AGG_CACHE__ === void 0 ? void 0 : _window___PLATFORM_SSR_AGG_CACHE__[cacheName]) || {};
        this.cacheName = cacheName;
        this.requestMetadata = new Map(cachedData.requestMetadata);
        // @ts-expect-error - TS2339 - Property '_responses' does not exist on type 'SSRQueryResponseCache'.
        this._responses = new Map(cachedData.responses);
        if (!isServer) setTimeout(()=>{
            // @ts-expect-error - TS2339 - Property '_responses' does not exist on type 'SSRQueryResponseCache'.
            timeoutCallback === null || timeoutCallback === void 0 ? void 0 : timeoutCallback(this._responses, this.requestMetadata);
            // cleanup leftover data to reduce unnecessary memory usage
            this.requestMetadata.clear();
            // @ts-expect-error - TS2339 - Property '_responses' does not exist on type 'SSRQueryResponseCache'.
            this._responses.clear();
        }, 60000 /* 1 minute */ );
    }
}

},{"relay-runtime":"2IxFR","@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"7U9xJ":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "AppSelector", ()=>AppSelector);
var _appSelectorUserDataFragmentGraphql = require("./__generated__/AppSelector_userDataFragment.graphql");
var _appSelectorUserDataFragmentGraphqlDefault = parcelHelpers.interopDefault(_appSelectorUserDataFragmentGraphql);
var _appSelectorQueryGraphql = require("./__generated__/AppSelectorQuery.graphql");
var _appSelectorQueryGraphqlDefault = parcelHelpers.interopDefault(_appSelectorQueryGraphql);
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _reactRelay = require("react-relay");
var _atlassianStudioCommon = require("@atlassian/atlassian-studio-common");
var _atlassianStudioEnvUtils = require("@atlassian/atlassian-studio-env-utils");
var _atlassianStudioRouting = require("@atlassian/atlassian-studio-routing");
var _atlassianStudioUiComponents = require("@atlassian/atlassian-studio-ui-components");
var _studioFoundationsFeatureGates = require("@atlassian/studio-foundations-feature-gates");
var _accountUtils = require("./common/utils/account-utils");
var _useWorkspaceContext = require("./hooks/use-workspace-context");
const LazyDevToolsDialogAndToggle = /*#__PURE__*/ (0, _react.lazy)(()=>require(/* webpackChunkName: "@atlaskit-internal_studio-foundations-feature-gates" */ "f812ad9bcf00604b").then((module)=>({
            default: module.DevToolsDialogAndToggle
        })));
const LazyLegacyAtlassianStudioApp = /*#__PURE__*/ (0, _react.lazy)(()=>require(/* webpackChunkName: "@atlaskit-internal_atlassian-studio" */ "9e685a14ce243d9a").then((module)=>({
            default: module.AtlassianStudioApp
        })));
const LazyStudioFoundationsApp = /*#__PURE__*/ (0, _react.lazy)(()=>require(/* webpackChunkName: "@atlaskit-internal_studio-foundations" */ "5fb967ad598ec230").then((module)=>({
            default: module.StudioFoundationsApp
        })));
const routerQueryReference = (0, _reactRelay.loadQuery)((0, _atlassianStudioCommon.RelayEnvironment), (0, _appSelectorQueryGraphqlDefault.default), {});
const isProd = (0, _atlassianStudioEnvUtils.getMappedEnv)() === 'production';
const AppSelector = ()=>{
    const data = (0, _reactRelay.usePreloadedQuery)((0, _appSelectorQueryGraphqlDefault.default), routerQueryReference);
    const userData = (0, _reactRelay.useFragment)((0, _appSelectorUserDataFragmentGraphqlDefault.default), data.me.user);
    const userAccountId = data.me.user.accountId;
    var _userData_email;
    const userEmail = (_userData_email = userData.email) !== null && _userData_email !== void 0 ? _userData_email : undefined;
    const isInternalUser = (0, _accountUtils.isAtlassianEmployee)(userEmail);
    const { initialized: fgPartlyInitialized, failReason: fgInitFailReason } = (0, _studioFoundationsFeatureGates.useInitialiseFeatureGatesClient)({
        atlassianAccountId: userAccountId
    }, (0, _studioFoundationsFeatureGates.featureGatesOptions), {
        isAtlassianEmployee: isInternalUser
    });
    // If initial feature-gate bootstrap fails, still resolve workspace context so workspace routes can
    // continue into the permanent v2 experience instead of falling back to the legacy app.
    const shouldResolveWorkspaceContext = fgPartlyInitialized || Boolean(fgInitFailReason);
    const urlContext = (0, _react.useMemo)(()=>shouldResolveWorkspaceContext ? (0, _atlassianStudioRouting.extractWorkspaceOrSiteIdFromPath)() : {
            workspaceId: undefined,
            siteId: undefined
        }, [
        shouldResolveWorkspaceContext
    ]);
    // Gather workspace context
    const workspaceContext = (0, _useWorkspaceContext.useWorkspaceContext)(urlContext.workspaceId, urlContext.siteId, userAccountId, shouldResolveWorkspaceContext);
    // @NOTE: if the feature gates are not yet initialized, and there is no
    // failure reason, then show the loading spinner
    // if they do fail, for some reason, just proceed so we dont block the user
    if (!fgPartlyInitialized && !fgInitFailReason) return /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _atlassianStudioUiComponents.PageMainContentLoadingLogo), {
        testId: "studio-foundations.app-selector.loading-logo",
        interactionName: "studio-foundations-app-selector"
    });
    // show loading while gathering workspace context
    if (!workspaceContext.isReady) return /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _atlassianStudioUiComponents.PageMainContentLoadingLogo), {
        testId: "studio-foundations.app-selector.loading-logo",
        interactionName: "studio-foundations-app-selector"
    });
    // set v2 flag based on workspace context. Note that redirect would've already happened if it was necessary.
    // if there's an error, workspaceContext.workspaces will be empty, so we'll fallback to v1
    const isV2Value = workspaceContext.workspaces.length > 0;
    var _urlContext_workspaceId;
    const workspaceIdToCache = (_urlContext_workspaceId = urlContext.workspaceId) !== null && _urlContext_workspaceId !== void 0 ? _urlContext_workspaceId : workspaceContext.workspaces[0];
    if (workspaceIdToCache) (0, _atlassianStudioRouting.setCachedWorkspaceId)(workspaceIdToCache);
    (0, _atlassianStudioRouting.setIsStudioV2)(isV2Value);
    var _data_notifications;
    // @NOTE: For now, all errors fallback to v1. When v1 is deprecated in the future,
    // we'll add error page handling here for critical errors.
    return /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _react.Fragment), null, (0, _atlassianStudioRouting.isStudioV2)() ? /*#__PURE__*/ (0, _reactDefault.default).createElement(LazyStudioFoundationsApp, {
        userDataFragment: data.me.user,
        notificationDataFragment: (_data_notifications = data.notifications) !== null && _data_notifications !== void 0 ? _data_notifications : undefined
    }) : /*#__PURE__*/ (0, _reactDefault.default).createElement(LazyLegacyAtlassianStudioApp, null), !isProd || isInternalUser ? /*#__PURE__*/ (0, _reactDefault.default).createElement(LazyDevToolsDialogAndToggle, null) : null);
};

},{"./__generated__/AppSelector_userDataFragment.graphql":"bVuHh","./__generated__/AppSelectorQuery.graphql":"lD2cK","react":"ltHCL","react-relay":"9HAyN","@atlassian/atlassian-studio-common":"7YPMV","@atlassian/atlassian-studio-env-utils":"lO9Ek","@atlassian/atlassian-studio-routing":"aRetS","@atlassian/atlassian-studio-ui-components":"k3dox","@atlassian/studio-foundations-feature-gates":"a6iyv","./common/utils/account-utils":"5Lh8K","./hooks/use-workspace-context":"bvTOU","f812ad9bcf00604b":"lVq1L","9e685a14ce243d9a":"6paP6","5fb967ad598ec230":"2Pirl","@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"bVuHh":[function(require,module,exports,__globalThis) {
/**
 * @generated SignedSource<<f06a742df5caaed670b100afc779cb60>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
const node = {
    "argumentDefinitions": [],
    "kind": "Fragment",
    "name": "AppSelector_userDataFragment",
    "selections": [
        {
            "kind": "InlineFragment",
            "selections": [
                {
                    "kind": "ScalarField",
                    "name": "email"
                }
            ],
            "type": "AtlassianAccountUser"
        }
    ],
    "type": "User",
    "abstractKey": "__isUser"
};
node.hash = "d8c04948a0582763e6387708a6adf3e3";
exports.default = node;

},{"@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"lD2cK":[function(require,module,exports,__globalThis) {
/**
 * @generated SignedSource<<8c734420d5f45dcc0e9dc54bf2790a93>>
 * @relayHash de89e852ff3db35aac942d9525fb999b
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID f0bf8a7e8a1289ba9ebe4945dc712c92a3504eb94455782f92239804db0692ac
var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
const node = function() {
    var v0 = {
        "kind": "ScalarField",
        "name": "accountId"
    };
    return {
        "fragment": {
            "argumentDefinitions": [],
            "kind": "Fragment",
            "name": "AppSelectorQuery",
            "selections": [
                {
                    "concreteType": "AuthenticationContext",
                    "kind": "LinkedField",
                    "name": "me",
                    "plural": false,
                    "selections": [
                        {
                            "kind": "RequiredField",
                            "field": {
                                "kind": "LinkedField",
                                "name": "user",
                                "plural": false,
                                "selections": [
                                    {
                                        "kind": "RequiredField",
                                        "field": v0 /*: any*/ ,
                                        "action": "THROW"
                                    },
                                    {
                                        "kind": "FragmentSpread",
                                        "name": "AppSelector_userDataFragment"
                                    },
                                    {
                                        "kind": "FragmentSpread",
                                        "name": "StudioFoundationsApp_AtlassianStudioFoundations_userDataFragment"
                                    }
                                ]
                            },
                            "action": "THROW"
                        }
                    ]
                },
                {
                    "concreteType": "InfluentsNotificationQuery",
                    "kind": "LinkedField",
                    "name": "notifications",
                    "plural": false,
                    "selections": [
                        {
                            "kind": "FragmentSpread",
                            "name": "StudioFoundationsApp_AtlassianStudioFoundations_notificationDataFragment"
                        }
                    ]
                }
            ],
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": [],
            "kind": "Operation",
            "name": "AppSelectorQuery",
            "selections": [
                {
                    "concreteType": "AuthenticationContext",
                    "kind": "LinkedField",
                    "name": "me",
                    "plural": false,
                    "selections": [
                        {
                            "kind": "LinkedField",
                            "name": "user",
                            "plural": false,
                            "selections": [
                                {
                                    "kind": "ScalarField",
                                    "name": "__typename"
                                },
                                v0 /*: any*/ ,
                                {
                                    "kind": "TypeDiscriminator",
                                    "abstractKey": "__isUser"
                                },
                                {
                                    "kind": "ScalarField",
                                    "name": "name"
                                },
                                {
                                    "kind": "ScalarField",
                                    "name": "picture"
                                },
                                {
                                    "kind": "ScalarField",
                                    "name": "id"
                                },
                                {
                                    "kind": "InlineFragment",
                                    "selections": [
                                        {
                                            "kind": "ScalarField",
                                            "name": "email"
                                        },
                                        {
                                            "kind": "ScalarField",
                                            "name": "locale"
                                        }
                                    ],
                                    "type": "AtlassianAccountUser"
                                }
                            ]
                        }
                    ]
                },
                {
                    "concreteType": "InfluentsNotificationQuery",
                    "kind": "LinkedField",
                    "name": "notifications",
                    "plural": false,
                    "selections": [
                        {
                            "kind": "ScalarField",
                            "name": "unseenNotificationCount"
                        }
                    ]
                }
            ]
        },
        "params": {
            "id": "f0bf8a7e8a1289ba9ebe4945dc712c92a3504eb94455782f92239804db0692ac",
            "metadata": {},
            "name": "AppSelectorQuery",
            "operationKind": "query",
            "text": null
        }
    };
}();
node.hash = "677d8755f796192524d92c2de849ffff";
exports.default = node;

},{"@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"7YPMV":[function(require,module,exports,__globalThis) {
/**
 * ------------------------------------------------------------------------------------------------
 *
 * WARNING:
 * Do not export anything new from this file
 * This package is going to be removed
 * https://hello.atlassian.net/wiki/spaces/agents/pages/5435743693/RFC-002+atlassian-studio+packages+reorganization
 *
 * ------------------------------------------------------------------------------------------------
 */ var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "SideNavMenuItem", ()=>(0, _navigationSystem.SideNavMenuItem));
parcelHelpers.export(exports, "preloadRouteComponent", ()=>(0, _navigationSystem.preloadRouteComponent));
parcelHelpers.export(exports, "replaceLastPathSegment", ()=>(0, _navigationSystem.replaceLastPathSegment));
parcelHelpers.export(exports, "excludeQueryParams", ()=>(0, _navigationSystem.excludeQueryParams));
parcelHelpers.export(exports, "usePathUtils", ()=>(0, _navigationSystem.usePathUtils));
parcelHelpers.export(exports, "RelayEnvironment", ()=>(0, _relayEnvironmentDefault.default));
parcelHelpers.export(exports, "createRelayResource", ()=>(0, _relay.createRelayResource));
parcelHelpers.export(exports, "useRelayResource", ()=>(0, _relay.useRelayResource));
parcelHelpers.export(exports, "LoadingSpinner", ()=>(0, _loadingSpinner.LoadingSpinner));
parcelHelpers.export(exports, "Picker", ()=>(0, _pickerDefault.default));
parcelHelpers.export(exports, "UnknownErrorPage", ()=>(0, _unknownErrorPage.UnknownErrorPage));
parcelHelpers.export(exports, "ErrorLayout", ()=>(0, _errorLayout.ErrorLayout));
parcelHelpers.export(exports, "UserContext", ()=>(0, _controllers.UserContext));
parcelHelpers.export(exports, "useUserContext", ()=>(0, _controllers.useUserContext));
parcelHelpers.export(exports, "TenantContext", ()=>(0, _controllers.TenantContext));
parcelHelpers.export(exports, "useTenantContext", ()=>(0, _controllers.useTenantContext));
parcelHelpers.export(exports, "createFetchMessagesForLocale", ()=>(0, _i18N.createFetchMessagesForLocale));
parcelHelpers.export(exports, "isValidUrl", ()=>(0, _utils.isValidUrl));
parcelHelpers.export(exports, "isEmptyString", ()=>(0, _utils.isEmptyString));
parcelHelpers.export(exports, "isValidString", ()=>(0, _utils.isValidString));
parcelHelpers.export(exports, "useSaHandoffTracker", ()=>(0, _useSaHandoffTracker.useSaHandoffTracker));
parcelHelpers.export(exports, "getConfig", ()=>(0, _config.getConfig));
parcelHelpers.export(exports, "useRovoSidebar", ()=>(0, _rovoSidebar.useRovoSidebar));
var _navigationSystem = require("./navigation-system");
var _relayEnvironment = require("./relay/RelayEnvironment");
var _relayEnvironmentDefault = parcelHelpers.interopDefault(_relayEnvironment);
var _relay = require("./relay");
var _loadingSpinner = require("./ui/loading-spinner");
var _picker = require("./ui/picker");
var _pickerDefault = parcelHelpers.interopDefault(_picker);
var _unknownErrorPage = require("./ui/unknown-error-page");
var _errorLayout = require("./ui/error-layout");
var _controllers = require("./controllers");
var _i18N = require("./i18n");
var _utils = require("./utils");
var _useSaHandoffTracker = require("./utils/use-sa-handoff-tracker");
var _config = require("./config");
var _rovoSidebar = require("./controllers/rovo-sidebar");

},{"./navigation-system":"5qGAl","./relay/RelayEnvironment":"6LZEK","./relay":"esRoT","./ui/loading-spinner":"e71r5","./ui/picker":"b0Dsv","./ui/unknown-error-page":"6z9tV","./ui/error-layout":"cQ547","./controllers":"6F7O9","./i18n":"dyHUN","./utils":"3NpOM","./utils/use-sa-handoff-tracker":"frqGt","./config":"72HEm","./controllers/rovo-sidebar":"hLtlk","@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"5qGAl":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "preloadRouteComponent", ()=>(0, _utils.preloadRouteComponent));
parcelHelpers.export(exports, "usePathUtils", ()=>(0, _utils.usePathUtils));
parcelHelpers.export(exports, "replaceLastPathSegment", ()=>(0, _utils.replaceLastPathSegment));
parcelHelpers.export(exports, "excludeQueryParams", ()=>(0, _utils.excludeQueryParams));
parcelHelpers.export(exports, "SideNavMenuItem", ()=>(0, _menuItem.SideNavMenuItem));
var _utils = require("./router/utils");
var _menuItem = require("./side-navigation/menu-item");

},{"./router/utils":"feodZ","./side-navigation/menu-item":"nTrUG","@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"feodZ":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "preloadRouteComponent", ()=>preloadRouteComponent);
parcelHelpers.export(exports, "replaceLastPathSegment", ()=>replaceLastPathSegment);
parcelHelpers.export(exports, "excludeQueryParams", ()=>excludeQueryParams);
parcelHelpers.export(exports, "usePathUtils", ()=>usePathUtils);
var _reactResourceRouterNext = require("react-resource-router-next");
const preloadRouteComponent = (route)=>{
    if (route.component && 'preload' in route.component && typeof route.component.preload === 'function') route.component.preload();
};
const replaceLastPathSegment = (property)=>{
    // Use the provided path or fallback to the current browser path
    const currentPath = window.location.pathname;
    const pathSegments = currentPath.split('/');
    // Replace the last segment with the new property
    pathSegments[pathSegments.length - 1] = property;
    // Join the segments back into a valid path
    return pathSegments.join('/');
};
const excludeQueryParams = (query, keysToExclude)=>{
    return Object.fromEntries(Object.entries(query).filter(([key])=>!keysToExclude.includes(key)).map(([key, value])=>[
            key,
            value
        ]));
};
const usePathUtils = ()=>{
    return {
        generatePath: (path, params)=>{
            return (0, _reactResourceRouterNext.generatePath)(path, params);
        },
        matchPath: (path, routePath)=>{
            return path === routePath;
        }
    };
};

},{"react-resource-router-next":"6gkfP","@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"nTrUG":[function(require,module,exports,__globalThis) {
/* index.tsx generated by @compiled/babel-plugin v0.39.1 */ var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "SideNavMenuItem", ()=>SideNavMenuItem);
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _reactMagneticDi = require("react-magnetic-di");
var _reactResourceRouterNext = require("react-resource-router-next");
var _compiled = require("@atlaskit/primitives/compiled");
var _linkMenuItem = require("@atlaskit/side-nav-items/link-menu-item");
var _atlassianStudioRouting = require("@atlassian/atlassian-studio-routing");
const boxStyles = {
    root: "_bozgutpp"
};
const slugify = (label)=>{
    // Cannot use `.replaceAll` due to the following error in pipelines:
    // Property 'replaceAll' does not exist on type 'string'. Do you need to change your target library? Try changing the 'lib' compiler option to 'es2021' or later.
    return label.trim().toLowerCase().split(' ').join('-');
};
const SideNavMenuItem = ({ item, onClick })=>{
    (0, _reactMagneticDi.di)((0, _reactResourceRouterNext.useRouter));
    const [routerStore, routerActions] = (0, _reactResourceRouterNext.useRouter)();
    const generatePath = (0, _atlassianStudioRouting.useGeneratePath)();
    const { transformRoute } = (0, _atlassianStudioRouting.useTransformStudioRoute)();
    const { label, Icon, route, matchRoutes, params, query, hashLink, isSubgroup, elemAfter, isDisabledOpacity } = item;
    const transformedMatchRoutes = matchRoutes.map((matchRoute)=>{
        const { route } = transformRoute(matchRoute);
        return route;
    });
    var _item_isSelected;
    const isSelected = (_item_isSelected = item.isSelected) !== null && _item_isSelected !== void 0 ? _item_isSelected : Boolean((0, _reactResourceRouterNext.matchRoute)(transformedMatchRoutes, routerStore.location.pathname, undefined));
    const queryString = new URLSearchParams(query).toString();
    const path = `${generatePath(route.path, params)}${queryString && `?${queryString}`}${hashLink ? `#${hashLink}` : ''}`;
    const handleClick = (0, _react.useCallback)((event, analyticsEvent)=>{
        onClick === null || onClick === void 0 ? void 0 : onClick(analyticsEvent);
        event.preventDefault();
        routerActions.push(path);
    }, [
        onClick,
        routerActions,
        path
    ]);
    const menuLinkItem = /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _linkMenuItem.LinkMenuItem), {
        testId: `side-navigation-menu-item-${slugify(label)}`,
        elemBefore: /*#__PURE__*/ (0, _reactDefault.default).createElement(Icon, {
            label: "",
            color: isDisabledOpacity ? "var(--ds-icon-disabled, #080F214A)" : 'currentColor'
        }),
        href: path,
        isSelected: isSelected,
        onClick: handleClick,
        elemAfter: elemAfter
    }, /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _compiled.Text), {
        color: isDisabledOpacity ? 'color.text.disabled' : 'inherit'
    }, label));
    return isSubgroup ? /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _compiled.Box), {
        xcss: boxStyles.root
    }, menuLinkItem) : menuLinkItem;
};

},{"react":"ltHCL","react-magnetic-di":"hCzc8","react-resource-router-next":"6gkfP","@atlaskit/primitives/compiled":"hDay7","@atlaskit/side-nav-items/link-menu-item":"0tz8b","@atlassian/atlassian-studio-routing":"aRetS","@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"0tz8b":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "LinkMenuItem", ()=>(0, _linkMenuItem.LinkMenuItem));
parcelHelpers.export(exports, "COLLAPSE_ELEM_BEFORE", ()=>(0, _menuItemSignals.COLLAPSE_ELEM_BEFORE));
var _linkMenuItem = require("../ui/menu-item/link-menu-item");
var _menuItemSignals = require("../ui/menu-item/menu-item-signals");

},{"../ui/menu-item/link-menu-item":"b5hWI","../ui/menu-item/menu-item-signals":false,"@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"b5hWI":[function(require,module,exports,__globalThis) {
/* link-menu-item.tsx generated by @compiled/babel-plugin v0.39.1 */ var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "LinkMenuItem", ()=>LinkMenuItem);
var _react = require("react");
var _forwardRefWithGeneric = require("@atlaskit/ds-lib/forward-ref-with-generic");
var _forwardRefWithGenericDefault = parcelHelpers.interopDefault(_forwardRefWithGeneric);
var _mergeRefs = require("@atlaskit/ds-lib/merge-refs");
var _mergeRefsDefault = parcelHelpers.interopDefault(_mergeRefs);
var _listItem = require("./list-item");
var _menuItem = require("./menu-item");
var _useScrollMenuItemIntoView = require("./use-scroll-menu-item-into-view");
const listItemStyles = {
    root: "_10m98stt"
};
const LinkMenuItemNoRef = ({ testId, actions, children, description, elemAfter, elemBefore, href, target, actionsOnHover, isSelected, onClick, interactionName, isContentTooltipDisabled, visualContentRef, listItemRef, isDragging, hasDragIndicator, dropIndicator }, forwardedRef)=>{
    const itemRef = (0, _react.useRef)(null);
    (0, _useScrollMenuItemIntoView.useScrollMenuItemIntoView)({
        elementRef: itemRef,
        isSelected: isSelected !== null && isSelected !== void 0 ? isSelected : false
    });
    const ref = (0, _react.useMemo)(()=>{
        return (0, _mergeRefsDefault.default)([
            itemRef,
            listItemRef !== null && listItemRef !== void 0 ? listItemRef : null
        ]);
    }, [
        itemRef,
        listItemRef
    ]);
    return /*#__PURE__*/ _react.createElement((0, _listItem.ListItem), {
        ref: ref,
        xcss: listItemStyles.root
    }, /*#__PURE__*/ _react.createElement((0, _menuItem.MenuItemBase), {
        testId: testId,
        description: description,
        actions: actions,
        elemAfter: elemAfter,
        // TODO Always use "open in new window" icon when `openInNewWindow` prop is true
        elemBefore: elemBefore,
        href: href,
        target: target,
        actionsOnHover: actionsOnHover,
        isSelected: isSelected,
        onClick: onClick,
        ref: forwardedRef,
        visualContentRef: visualContentRef,
        interactionName: interactionName,
        isContentTooltipDisabled: isContentTooltipDisabled,
        isDragging: isDragging,
        hasDragIndicator: hasDragIndicator,
        dropIndicator: dropIndicator
    }, children));
};
const LinkMenuItem = (0, _forwardRefWithGenericDefault.default)(LinkMenuItemNoRef);

},{"react":"ltHCL","@atlaskit/ds-lib/forward-ref-with-generic":"7Zbu3","@atlaskit/ds-lib/merge-refs":"doPwA","./list-item":"iYlAZ","./menu-item":"89wFe","./use-scroll-menu-item-into-view":"k2WnQ","@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"7Zbu3":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _react = require("react");
/**
 * An alias for `forwardRef` with enhanced typing to preserve generic prop types.
 */ exports.default = (0, _react.forwardRef);

},{"react":"ltHCL","@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"iYlAZ":[function(require,module,exports,__globalThis) {
/* list-item.tsx generated by @compiled/babel-plugin v0.39.1 */ var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "ListItem", ()=>ListItem);
var _react = require("react");
function _ListItem({ children, testId, xcss }, ref) {
    return /*#__PURE__*/ _react.createElement("div", {
        role: "listitem",
        ref: ref,
        className: xcss,
        "data-testid": testId
    }, children);
}
const ListItem = /*#__PURE__*/ (0, _react.forwardRef)(_ListItem);

},{"react":"ltHCL","@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"89wFe":[function(require,module,exports,__globalThis) {
/* menu-item.tsx generated by @compiled/babel-plugin v0.39.1 */ var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "nestedOpenPopupCSSSelector", ()=>nestedOpenPopupCSSSelector);
parcelHelpers.export(exports, "MenuItemBase", ()=>MenuItemBase);
var _objectSpread = require("@swc/helpers/_/_object_spread");
var _objectSpreadProps = require("@swc/helpers/_/_object_spread_props");
var _runtime = require("@compiled/react/runtime");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _react1 = require("@compiled/react");
var _avatar = require("@atlaskit/avatar");
var _forwardRefWithGeneric = require("@atlaskit/ds-lib/forward-ref-with-generic");
var _forwardRefWithGenericDefault = parcelHelpers.interopDefault(_forwardRefWithGeneric);
var _mergeRefs = require("@atlaskit/ds-lib/merge-refs");
var _mergeRefsDefault = parcelHelpers.interopDefault(_mergeRefs);
var _platformFeatureFlags = require("@atlaskit/platform-feature-flags");
var _compiled = require("@atlaskit/primitives/compiled");
var _tooltip = require("@atlaskit/tooltip");
var _tooltipDefault = parcelHelpers.interopDefault(_tooltip);
var _constants = require("./constants");
var _dragHandle = require("./drag-handle/drag-handle");
var _expandableMenuItemContext = require("./expandable-menu-item/expandable-menu-item-context");
var _flyoutMenuItemContext = require("./flyout-menu-item/flyout-menu-item-context");
var _menuItemSignals = require("./menu-item-signals");
function isTextClamped(element) {
    // Checking for vertical height rather than horizontal height.
    // When text is "clamped", it's technically being clamped vertically! 🤯
    return element.scrollHeight > element.clientHeight;
}
const defaultAvatarValues = {
    size: 'small'
};
// Stable reference for the anchor's text-decoration reset. Hoisted to module
// scope so it is not re-created on every render of every menu item — the
// inline literal `{ textDecoration: 'none' }` had identical content but a new
// identity each render, forcing the host element's `style` to reconcile
// unnecessarily. Gated behind `navx-4728-jira-stability-fixes`.
const anchorTextDecorationResetStyle = {
    textDecoration: 'none'
};
const elemAfterDisplayVar = '--elem-after-display';
const actionsOnHoverOpacityVar = '--actions-on-hover-opacity';
const actionsOnHoverWidthVar = '--actions-on-hover-width';
const actionsOnHoverPaddingInlineEndVar = '--actions-on-hover-padding';
const notchColorVar = '--notch-color';
// Note: this is also used in `drag-handle.tsx`
const dragHandleDisplayVar = '--drag-handle-display';
const dragCursorAnimation = null;
/**
 * ## 🤹 `position:relative`
 *
 * We need `position:relative` on an element that takes
 * up the full size of the interactive element so we
 * can correctly use `position:absolute` to place:
 * 1. the notch for links
 * 2. drop indicators for drag and drop
 * 3. a child of button / anchor to stretch it out to
 *    increase it's pressable area.
 *
 * ⛔️ We cannot add `position:relative` _only_ on the
 * button / anchor as that will cause sibling elements
 * to be rendered under the button / anchor when setting
 * a background color on the button / anchor.
 *
 * 📖 Note: `position:relative` elements are painted after
 * elements with `position:static` (the default)
 * https://drafts.csswg.org/css-position-4/#painting-order
 *
 * ⛔️ We cannot add `position:relative` to the container
 * element, as then the `:focus` ring styles on the
 * button / anchor can be cut off by the next sibling if it has
 * has a background color set (eg when selected)
 *
 * ✅ Add `position:relative` to all first level descendants
 * of the container element so that we don't impact DOM ordered
 * paint ordering within the item and the button / anchor focus
 * ring can still bleed over siblings
 *
 * 📖 We could use `> * { position: relative; }` on the container,
 * but that would violate our styling standard.
 */ const topLevelSiblingStyles = {
    root: "_kqswh2mm"
};
/**
 * All slots on the menu item (eg `elemBefore`) are rendered as siblings
 * of our main button / anchor element and they are visually placed on
 * top of the main button / anchor.
 *
 * 📖 This is done so that we don't nest interactive elements in our markup.
 *
 * ✅ This is great when element in the slot is an interactive element
 * as we don't want the main menu item button / anchor to be triggered
 * when interacting with the element in the slot.
 *
 * ⛔️ When the element in the slot is static content (eg an `<Icon>`) it will
 * prevent the main button / anchor (that is visually behind the element in
 * the slot) from being clicked. The element in the slot is a sibling of our
 * main button / anchor (not a child of it) so clicking on the element in the
 * slot will not bubble up to the button / anchor.
 *
 * 🚀 We set `pointer-events:none` on a slot if it does not contain and interactive
 * element so that static content in a slot does not prevent clicking on the main
 * button / anchor.
 */ const onTopOfButtonOrAnchorStyles = {
    root: "_18ukglyw"
};
const nestedOpenPopupCSSSelector = '&:has([aria-expanded="true"][aria-haspopup])';
const containerStyles = {
    root: "_2rko12b0 _vchhusvi _1e0c11p5 _yv0e7dup _2z05hkll _1lmcu4vt _1ul9t9kd _4t3iviql _4cvr1h6o _uiztglyw _syazazsu _1yyu1j28 _91ju1txw _uomdidpf _pmxpidpf _db80idpf _irr319i6 _t7p8kb7n _g4kikb7n _91nl1wug _ynyi1wug _iy5o1b66 _v4o21b66",
    rootMotion: "_v564hxmd _1ggl87vo",
    rootT26Shape: "_2rko1qi0",
    removeElemAfter: "_91juglyw",
    showHoverActions: "_uomdkb7n _pmxp1wug _db801b66",
    removeElemAfterOnHoverOrOpenNestedPopup: "_1mfcglyw _1sjuglyw",
    selected: "_bfhk15s3 _syaz6x5g _1yyujmqp _30l36x5g _irr3ufnl",
    selectedMotion: "_v5641rrn _1ggl87vo",
    disabled: "_syaz1gmx _bfhkn7od _irr3n7od _30l31gmx",
    hasDescription: "_4t3i1wto",
    dragging: "_tzy41ou4"
};
const nestedOpenPopupStyles = {
    root: "_1783kb7n _1d171wug _ligh1b66 _1fpr19i6",
    removeElemAfterOnHoverOrOpenNestedPopup: "_n3ixglyw",
    selected: "_1fprufnl"
};
const buttonOrAnchorStyles = {
    root: "_2rko12b0 _yyhyjvu9 _1ii7kb7n _1e0c11p5 _yv0enbh3 _2z05nbh3 _y4ti1b66 _bozg1b66 _1q511b66 _85i51b66 _bfhk1j28 _syazazsu _4cvr1h6o _y3gnv2br _14iu13ro",
    rootMotion: "_v564hxmd _1ggl87vo",
    rootT26Shape: "_2rko1qi0",
    selected: "_syaz6x5g _14iunozp",
    selectedMotion: "_v5641rrn _1ggl87vo",
    hasDragIndicator: "_1ifmglyw _1cykglyw _x0kw1txw _11om6b4r _7psyru3m _1uy01amc _bir2q7pw"
};
const extendButtonOrAnchorStyles = {
    root: "_1r04ze3t _kqswstnw"
};
const notchStyles = {
    root: "_kqswstnw _152t1ssb _1e02ze3t _1bsbyh40 _4t3i1crf _t9ec1i34 _bfhk1o0g"
};
const actionStyles = {
    root: "_zulp1b66 _nd5lbc26 _1reo15vq _18m915vq _1e0c1txw _4cvr1h6o _y4ti1b66 _1guo18uv _12s918uv"
};
const actionsOnHoverStyles = {
    root: "_nd5l16dh _zulp1b66 _1reo15vq _18m915vq _4cvr1h6o _1e0c1txw _tzy4pnc3 _1bsbty16 _y4tidria _1guo18uv _12s918uv"
};
const textStyles = {
    root: "_zulpv77o _1reo15vq _18m915vq _y4ti1b66 _bozg1b66 _1e0c1txw _2lx21bp4 _1ul91c9m _1guo18uv _12s918uv",
    noElemBeforeIndent: "_bozg12x7"
};
const elemBeforeStyles = {
    root: "_nd5l17zh _1reo15vq _18m915vq _1e0c1txw _1o9zidpf _1bsb1tcg _4t3i1tcg _4cvr1h6o _1bah1h6o _bozg1b66 _vchh1ntv _1guo18uv _12s918uv"
};
const elemAfterStyles = {
    root: "_nd5l16dh _1reo15vq _18m915vq _1e0c13yo _1o9zidpf _4t3i1tcg _4cvr1h6o _y4ti1b66 _1guo18uv _12s918uv"
};
/**
 * We are using a wrapping element for our interactive content
 * even though only the `Text` element is the only thing not using `position:absolute`
 *
 * Rationale:
 * - Super clear that everything inside the interactive content should be in a specific slot in the grid
 * - To work around a browser bug in Safari where it does not work well with `position:absolute`
 *   on a subgrid child.
 *   Safari bug: https://bugs.webkit.org/show_bug.cgi?id=292516
 */ const interactiveContentStyles = {
    root: "_nd5l19l3 _1e0c1txw _2lx21bp4 _ae4v1h6o"
};
function getTextColor({ isDisabled, isSelected }) {
    if (isDisabled) return 'color.text.disabled';
    if (isSelected) return 'color.text.selected';
    return 'color.text.subtle';
}
/**
 * This is the internal version of the component, to be passed into `forwardRef`.
 *
 * It contains a type argument `<T>`, to specify the type of the interactive element (`button` or `a`).
 * This can be inferred from the type of the `onClick` prop.
 */ const MenuItemBaseNoRef = ({ id, testId, actions, actionsOnHover, children, description, elemAfter, elemBefore, href, target, isDisabled, isSelected, onClick, ariaControls, ariaExpanded, ariaHasPopup, interactionName, isContentTooltipDisabled, visualContentRef, isDragging, hasDragIndicator, dropIndicator }, forwardedRef)=>{
    const level = (0, _expandableMenuItemContext.useLevel)();
    const setFlyoutMenuOpen = (0, _flyoutMenuItemContext.useSetFlyoutMenuOpen)();
    const isFlyoutMenuOpen = (0, _flyoutMenuItemContext.useFlyoutMenuOpen)();
    const isLink = typeof href !== 'undefined';
    const labelRef = (0, _react.useRef)(null);
    const descriptionRef = (0, _react.useRef)(null);
    const tooltipOnClick = (0, _react.useRef)(null);
    const handleClick = (0, _react.useCallback)((event, analyticsEvent)=>{
        var _tooltipOnClick_current;
        onClick === null || onClick === void 0 ? void 0 : onClick(event, analyticsEvent);
        // Toggle flyout menu open state when inside a flyout context provider
        setFlyoutMenuOpen(!isFlyoutMenuOpen);
        (_tooltipOnClick_current = tooltipOnClick.current) === null || _tooltipOnClick_current === void 0 ? void 0 : _tooltipOnClick_current.call(tooltipOnClick, event);
    }, [
        onClick,
        setFlyoutMenuOpen,
        isFlyoutMenuOpen
    ]);
    /**
   * Show the tooltip if _either_ label or description is truncated
   */ const canTooltipAppear = (0, _react.useCallback)(()=>{
        if (isContentTooltipDisabled) return false;
        // Show tooltip if _either_ label or description are clamped
        const label = labelRef.current;
        const description = descriptionRef.current;
        if (label && isTextClamped(label)) return true;
        return Boolean(description && isTextClamped(description));
    }, [
        isContentTooltipDisabled
    ]);
    // By default provide the spacing for `elemBefore` to have good
    // vertical alignment of labels and to give clear indentation between levels
    // in the side navigation (even when items don't use elemBefore).
    const showElemBefore = elemBefore !== (0, _menuItemSignals.COLLAPSE_ELEM_BEFORE);
    const interactiveElemContent = /*#__PURE__*/ (0, _reactDefault.default).createElement("div", {
        className: (0, _runtime.ax)([
            interactiveContentStyles.root
        ])
    }, /*#__PURE__*/ (0, _reactDefault.default).createElement("div", {
        // This extends the clickable area of nested menu items to the width
        // of the root level menu items, while being visually indented.
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values
        style: {
            insetInlineStart: `calc(-1 * ${level} * ${(0, _constants.expandableMenuItemIndentation)})`
        },
        "aria-hidden": "true",
        className: (0, _runtime.ax)([
            extendButtonOrAnchorStyles.root
        ])
    }), /*#__PURE__*/ (0, _reactDefault.default).createElement("div", {
        className: (0, _runtime.ax)([
            textStyles.root,
            !showElemBefore && textStyles.noElemBeforeIndent
        ])
    }, /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _compiled.Text), {
        weight: "medium",
        maxLines: 1,
        color: getTextColor({
            isDisabled,
            isSelected
        }),
        ref: labelRef
    }, children), description && /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _compiled.Text), {
        color: getTextColor({
            isDisabled,
            isSelected
        }),
        size: "small",
        maxLines: 1,
        ref: descriptionRef
    }, description)), hasDragIndicator ? /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _dragHandle.DragHandle), null) : null, dropIndicator);
    /**
   *  If the [expandable] menu item is expanded, show hover actions even when *not* hovered.
   *
   * Note: we also remove the `elemAfter` when showing `actionsOnHover`
   */ const showHoverActionsWhenNotHovered = Boolean(ariaExpanded && actionsOnHover);
    return /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _avatar.AvatarContext).Provider, {
        value: defaultAvatarValues
    }, /*#__PURE__*/ (0, _reactDefault.default).createElement("div", {
        ref: visualContentRef,
        "data-testid": testId ? `${testId}-container` : undefined,
        "data-selected": isSelected,
        className: (0, _runtime.ax)([
            containerStyles.root,
            (0, _platformFeatureFlags.fg)('platform-dst-motion-uplift-list-item') && containerStyles.rootMotion,
            nestedOpenPopupStyles.root,
            (0, _platformFeatureFlags.fg)('platform-dst-shape-theme-default') && containerStyles.rootT26Shape,
            isSelected && containerStyles.selected,
            isSelected && (0, _platformFeatureFlags.fg)('platform-dst-motion-uplift-list-item') && containerStyles.selectedMotion,
            isSelected && nestedOpenPopupStyles.selected,
            isDragging && containerStyles.dragging,
            description && containerStyles.hasDescription,
            showHoverActionsWhenNotHovered && containerStyles.showHoverActions,
            showHoverActionsWhenNotHovered && elemAfter && containerStyles.removeElemAfter,
            actionsOnHover && elemAfter && containerStyles.removeElemAfterOnHoverOrOpenNestedPopup,
            actionsOnHover && elemAfter && nestedOpenPopupStyles.removeElemAfterOnHoverOrOpenNestedPopup,
            isDisabled && containerStyles.disabled
        ])
    }, /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _tooltipDefault.default), {
        content: ()=>/*#__PURE__*/ (0, _reactDefault.default).createElement((0, _reactDefault.default).Fragment, null, /*#__PURE__*/ (0, _reactDefault.default).createElement("div", null, children), description ? /*#__PURE__*/ (0, _reactDefault.default).createElement("div", null, description) : null),
        position: "right-start",
        ignoreTooltipPointerEvents: true,
        hideTooltipOnMouseDown: true,
        // We don't need a duplicate hidden element containing tooltip content
        // as the content of the tooltip matches what is rendered for the menu item.
        isScreenReaderAnnouncementDisabled: true,
        canAppear: canTooltipAppear
    }, (tooltipProps)=>{
        // Putting the tooltip onClick into a ref.
        // This way we don't need to create a new `onClick` function on each
        // render (as we would need to merge `tooltipProps.onClick` and our `handleClick`)
        tooltipOnClick.current = tooltipProps.onClick;
        const sharedProps = (0, _objectSpreadProps._)((0, _objectSpread._)({}, tooltipProps), {
            'aria-controls': ariaControls,
            'aria-haspopup': ariaHasPopup,
            ref: (0, _mergeRefsDefault.default)([
                forwardedRef,
                tooltipProps.ref
            ]),
            id,
            testId,
            interactionName
        });
        return isLink ? /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _compiled.Anchor), (0, _objectSpreadProps._)((0, _objectSpread._)({}, sharedProps), {
            onClick: handleClick,
            xcss: (0, _react1.cx)(buttonOrAnchorStyles.root, (0, _platformFeatureFlags.fg)('platform-dst-motion-uplift-list-item') && buttonOrAnchorStyles.rootMotion, (0, _platformFeatureFlags.fg)('platform-dst-shape-theme-default') && buttonOrAnchorStyles.rootT26Shape, topLevelSiblingStyles.root, isSelected && buttonOrAnchorStyles.selected, isSelected && (0, _platformFeatureFlags.fg)('platform-dst-motion-uplift-list-item') && buttonOrAnchorStyles.selectedMotion, hasDragIndicator && buttonOrAnchorStyles.hasDragIndicator),
            // Needed to override Anchor style due to a compiled/emotion conflict
            // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop
            style: (0, _platformFeatureFlags.fg)('navx-4728-jira-stability-fixes') ? anchorTextDecorationResetStyle : {
                textDecoration: 'none'
            },
            "aria-current": isSelected ? 'page' : undefined,
            href: href,
            target: target,
            /**
           * For anchors we don't want to have the standard drag and drop behaviour.
           *
           * Thinking on the topic:
           *
           * - Anchors look visually similar to buttons in the sidenav
           * - Why should some menu items be natively draggable, while others are not?
           * - A user cannot know which menu items are "natively" draggable (ie anchors)
           * - If you wire up an anchor to be draggable using our standard affordances
           *   it will have a different preview experience to native anchor dragging.
           *
           * To promote consistency, all elements need to use the same visual affordances.
           *
           * Anchor elements will automatically attach URL information
           * to the native data store.
           *
           * When `hasDragIndicator` is `true` we are expecting consumers to register
           * the element as draggable through the `draggable()` Pragmatic drag and drop function.
           * The `draggable()` function will add `draggable="true"` to the element.
           */ draggable: hasDragIndicator ? undefined : false
        }), /*#__PURE__*/ (0, _reactDefault.default).createElement("div", {
            "aria-hidden": "true",
            className: (0, _runtime.ax)([
                notchStyles.root
            ])
        }), interactiveElemContent) : /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _compiled.Pressable), (0, _objectSpreadProps._)((0, _objectSpread._)({}, sharedProps), {
            onClick: handleClick,
            xcss: (0, _react1.cx)(buttonOrAnchorStyles.root, (0, _platformFeatureFlags.fg)('platform-dst-motion-uplift-list-item') && buttonOrAnchorStyles.rootMotion, (0, _platformFeatureFlags.fg)('platform-dst-shape-theme-default') && buttonOrAnchorStyles.rootT26Shape, topLevelSiblingStyles.root, isSelected && buttonOrAnchorStyles.selected, isSelected && (0, _platformFeatureFlags.fg)('platform-dst-motion-uplift-list-item') && buttonOrAnchorStyles.selectedMotion, hasDragIndicator && buttonOrAnchorStyles.hasDragIndicator),
            "aria-expanded": ariaExpanded,
            isDisabled: isDisabled
        }), interactiveElemContent);
    }), showElemBefore && /*#__PURE__*/ (0, _reactDefault.default).createElement("div", {
        className: (0, _runtime.ax)([
            elemBeforeStyles.root,
            topLevelSiblingStyles.root,
            onTopOfButtonOrAnchorStyles.root
        ])
    }, elemBefore), actionsOnHover && /*#__PURE__*/ (0, _reactDefault.default).createElement("div", {
        className: (0, _runtime.ax)([
            actionsOnHoverStyles.root
        ])
    }, actionsOnHover), elemAfter && /*#__PURE__*/ (0, _reactDefault.default).createElement("div", {
        className: (0, _runtime.ax)([
            elemAfterStyles.root,
            topLevelSiblingStyles.root,
            onTopOfButtonOrAnchorStyles.root
        ])
    }, elemAfter), actions && /*#__PURE__*/ (0, _reactDefault.default).createElement("div", {
        className: (0, _runtime.ax)([
            actionStyles.root,
            topLevelSiblingStyles.root,
            onTopOfButtonOrAnchorStyles.root
        ])
    }, actions)));
};
const MenuItemBase = (0, _forwardRefWithGenericDefault.default)(MenuItemBaseNoRef);

},{"@swc/helpers/_/_object_spread":"9gdrV","@swc/helpers/_/_object_spread_props":"kANqQ","@compiled/react/runtime":"d27Vo","react":"ltHCL","@compiled/react":"MfI9Z","@atlaskit/avatar":"eKhO0","@atlaskit/ds-lib/forward-ref-with-generic":"7Zbu3","@atlaskit/ds-lib/merge-refs":"doPwA","@atlaskit/platform-feature-flags":"8rD2i","@atlaskit/primitives/compiled":"hDay7","@atlaskit/tooltip":"7RyYv","./constants":"87Re1","./drag-handle/drag-handle":"avnrV","./expandable-menu-item/expandable-menu-item-context":"jqpKo","./flyout-menu-item/flyout-menu-item-context":"l8k9F","./menu-item-signals":"jT8vQ","@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"eKhO0":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>(0, _avatarDefault.default));
parcelHelpers.export(exports, "AvatarContent", ()=>(0, _avatarContent.AvatarContent));
parcelHelpers.export(exports, "AvatarItem", ()=>(0, _avatarItemDefault.default));
parcelHelpers.export(exports, "Presence", ()=>(0, _presenceDefault.default));
parcelHelpers.export(exports, "Status", ()=>(0, _statusDefault.default));
parcelHelpers.export(exports, "Skeleton", ()=>(0, _skeletonDefault.default));
parcelHelpers.export(exports, "getAppearanceForAppType", ()=>(0, _getAppearanceDefault.default));
parcelHelpers.export(exports, "AvatarContext", ()=>(0, _avatarContext.AvatarContext));
parcelHelpers.export(exports, "useAvatarContext", ()=>(0, _useAvatarContext.useAvatarContext));
parcelHelpers.export(exports, "BORDER_WIDTH", ()=>(0, _constants.BORDER_WIDTH));
parcelHelpers.export(exports, "ACTIVE_SCALE_FACTOR", ()=>(0, _constants.ACTIVE_SCALE_FACTOR));
parcelHelpers.export(exports, "AVATAR_SIZES", ()=>(0, _avatarSizes.AVATAR_SIZES));
parcelHelpers.export(exports, "AVATAR_RADIUS", ()=>(0, _avatarRadius.AVATAR_RADIUS));
var _avatar = require("./avatar");
var _avatarDefault = parcelHelpers.interopDefault(_avatar);
var _avatarContent = require("./avatar-content");
var _avatarItem = require("./avatar-item");
var _avatarItemDefault = parcelHelpers.interopDefault(_avatarItem);
var _presence = require("./presence");
var _presenceDefault = parcelHelpers.interopDefault(_presence);
var _status = require("./status");
var _statusDefault = parcelHelpers.interopDefault(_status);
var _skeleton = require("./skeleton");
var _skeletonDefault = parcelHelpers.interopDefault(_skeleton);
var _getAppearance = require("./get-appearance");
var _getAppearanceDefault = parcelHelpers.interopDefault(_getAppearance);
var _avatarContext = require("./avatar-context");
var _useAvatarContext = require("./use-avatar-context");
var _constants = require("./constants");
var _avatarSizes = require("./avatar-sizes");
var _avatarRadius = require("./avatar-radius");

},{"./avatar":"aKaVE","./avatar-content":"bvr6u","./avatar-item":"1k8pJ","./presence":false,"./status":false,"./skeleton":"jA3J3","./get-appearance":"17dJI","./avatar-context":"9d3fC","./use-avatar-context":false,"./constants":false,"./avatar-sizes":"jnv6X","./avatar-radius":false,"@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"aKaVE":[function(require,module,exports,__globalThis) {
/* avatar.tsx generated by @compiled/babel-plugin v0.39.1 */ var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _objectSpread = require("@swc/helpers/_/_object_spread");
var _react = require("react");
var _runtime = require("@compiled/react/runtime");
var _analyticsNext = require("@atlaskit/analytics-next");
var _useId = require("@atlaskit/ds-lib/use-id");
var _avatarContent = require("./avatar-content");
var _avatarImage = require("./internal/avatar-image");
var _avatarImageDefault = parcelHelpers.interopDefault(_avatarImage);
var _contentContext = require("./internal/content-context");
var _ensureIsInsideAvatarContext = require("./internal/ensure-is-inside-avatar-context");
var _getCustomElement = require("./internal/get-custom-element");
var _getCustomElementDefault = parcelHelpers.interopDefault(_getCustomElement);
var _presenceWrapper = require("./internal/presence-wrapper");
var _presenceWrapperDefault = parcelHelpers.interopDefault(_presenceWrapper);
var _statusWrapper = require("./internal/status-wrapper");
var _statusWrapperDefault = parcelHelpers.interopDefault(_statusWrapper);
var _useAvatarContext = require("./use-avatar-context");
const packageName = "@af/atlassian-studio";
const packageVersion = "0.16.1";
const containerStyles = null;
/**
 * __Avatar__
 *
 * An avatar is a visual representation of a user or entity.
 *
 * - [Examples](https://atlassian.design/components/avatar/examples)
 * - [Code](https://atlassian.design/components/avatar/code)
 * - [Usage](https://atlassian.design/components/avatar/usage)
 */ const Avatar = /*#__PURE__*/ (0, _react.forwardRef)(({ analyticsContext, appearance = 'circle', label, borderColor, children, href, isDisabled, name, onClick, presence, size: sizeProp, src, stackIndex, status, target, testId, as: AvatarContainer = 'div', isDecorative = false, imgLoading, 'aria-controls': ariaControls, 'aria-expanded': ariaExpanded, 'aria-haspopup': ariaHasPopup }, ref)=>{
    const { createAnalyticsEvent } = (0, _analyticsNext.useAnalyticsEvents)();
    const context = (0, _useAvatarContext.useAvatarContext)();
    const size = sizeProp || (context === null || context === void 0 ? void 0 : context.size) || 'medium';
    const customPresenceNode = /*#__PURE__*/ (0, _react.isValidElement)(presence) ? presence : null;
    const customStatusNode = /*#__PURE__*/ (0, _react.isValidElement)(status) ? status : null;
    const isValidIconSize = size !== 'xxlarge' && size !== 'xsmall';
    // Presence/status indicators are only defined for `IndicatorSizeType`
    // (small, medium, large, xlarge). Compute `indicatorSize` only for sizes
    // that support an indicator (`isValidIconSize`), so the value is
    // structurally guaranteed to be a valid `IndicatorSizeType` rather than
    // relying on the guard at each call site. The `UNSAFE_xsmall` (20px) size
    // reuses the `small` indicator sizing as its nearest supported neighbor;
    // unsupported sizes (`xsmall`/`xxlarge`) fall back to `small` and are never
    // actually rendered because `isPresence`/`isStatus` also guard on
    // `isValidIconSize`.
    const indicatorSize = !isValidIconSize ? 'small' : size === 'UNSAFE_xsmall' ? 'small' : size;
    const lastAnalytics = (0, _react.useRef)(analyticsContext);
    const labelId = (0, _useId.useId)();
    (0, _react.useEffect)(()=>{
        lastAnalytics.current = analyticsContext;
    }, [
        analyticsContext
    ]);
    const onClickHandler = (0, _react.useCallback)((event)=>{
        if (isDisabled || typeof onClick !== 'function') return;
        const analyticsEvent = createAnalyticsEvent({
            action: 'clicked',
            actionSubject: 'avatar',
            attributes: {
                componentName: 'avatar',
                packageName,
                packageVersion
            }
        });
        /**
     * To avoid wrapping this component in AnalyticsContext we manually
     * push the parent context's meta data into the context.
     */ const context = (0, _objectSpread._)({
            componentName: 'avatar',
            packageName,
            packageVersion
        }, lastAnalytics.current);
        analyticsEvent.context.push(context);
        /**
     * Replicating the logic in the `withAnalyticsEvents` HOC.
     */ const clone = analyticsEvent.clone();
        if (clone) clone.fire('atlaskit');
        onClick(event, analyticsEvent);
    }, [
        createAnalyticsEvent,
        isDisabled,
        onClick
    ]);
    const isPresence = isValidIconSize && presence && !status;
    const isStatus = isValidIconSize && status;
    // add presence or status to the label by default if presence and status are passed as a string
    // if status or presence are nodes this is not added to the label by default
    const defaultLabel = [
        name,
        isStatus && !customStatusNode && `(${status})`,
        isPresence && !customPresenceNode && `(${presence})`
    ].filter(Boolean).join(' ');
    const isInteractive = onClick || href || isDisabled || ariaHasPopup;
    const containerShouldBeImage = Boolean(!isInteractive && defaultLabel);
    return /*#__PURE__*/ _react.createElement((0, _ensureIsInsideAvatarContext.EnsureIsInsideAvatarContext).Provider, {
        value: true
    }, /*#__PURE__*/ _react.createElement(AvatarContainer, {
        "data-testid": testId,
        role: containerShouldBeImage ? 'img' : undefined,
        "aria-labelledby": containerShouldBeImage && !isDecorative ? labelId : undefined,
        style: {
            zIndex: stackIndex
        },
        className: (0, _runtime.ax)([
            "_12ji1r31 _1qu2glyw _12y3idpf _1e0c1o8l _kqswh2mm"
        ])
    }, /*#__PURE__*/ _react.createElement((0, _contentContext.AvatarContentContext).Provider, {
        value: {
            as: (0, _getCustomElementDefault.default)(isDisabled, href, onClick, ariaHasPopup),
            appearance,
            borderColor,
            href,
            isDisabled,
            label: label || defaultLabel,
            onClick: isInteractive ? onClickHandler : undefined,
            ref,
            size,
            stackIndex,
            target,
            testId: testId ? `${testId}--inner` : undefined,
            'aria-controls': ariaControls,
            'aria-expanded': ariaExpanded,
            'aria-haspopup': ariaHasPopup,
            avatarImage: /*#__PURE__*/ _react.createElement((0, _avatarImageDefault.default), {
                alt: !containerShouldBeImage && src ? name : undefined,
                src: src,
                appearance: appearance,
                size: size,
                testId: testId,
                imgLoading: imgLoading
            })
        }
    }, children || /*#__PURE__*/ _react.createElement((0, _avatarContent.AvatarContent), null)), isPresence && /*#__PURE__*/ _react.createElement((0, _presenceWrapperDefault.default), {
        appearance: appearance,
        size: indicatorSize,
        presence: typeof presence === 'string' ? presence : undefined,
        testId: testId
    }, customPresenceNode), isStatus && /*#__PURE__*/ _react.createElement((0, _statusWrapperDefault.default), {
        appearance: appearance,
        size: indicatorSize,
        borderColor: borderColor,
        status: typeof status === 'string' ? status : undefined,
        testId: testId
    }, customStatusNode), containerShouldBeImage ? /*#__PURE__*/ _react.createElement("span", {
        "data-testid": testId && `${testId}--label`,
        id: labelId,
        hidden: true
    }, defaultLabel) : undefined));
});
Avatar.displayName = 'Avatar';
exports.default = Avatar;

},{"@swc/helpers/_/_object_spread":"9gdrV","react":"ltHCL","@compiled/react/runtime":"d27Vo","@atlaskit/analytics-next":"6PLie","@atlaskit/ds-lib/use-id":"9jWCD","./avatar-content":"bvr6u","./internal/avatar-image":"3qvHg","./internal/content-context":"jxZKQ","./internal/ensure-is-inside-avatar-context":"15SRy","./internal/get-custom-element":"4ooOM","./internal/presence-wrapper":"2hk3o","./internal/status-wrapper":"bqvBe","./use-avatar-context":"b6fLj","@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"bvr6u":[function(require,module,exports,__globalThis) {
/* avatar-content.tsx generated by @compiled/babel-plugin v0.39.1 */ var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "AvatarContent", ()=>AvatarContent);
var _objectSpread = require("@swc/helpers/_/_object_spread");
var _objectSpreadProps = require("@swc/helpers/_/_object_spread_props");
var _react = require("react");
var _runtime = require("@compiled/react/runtime");
var _platformFeatureFlags = require("@atlaskit/platform-feature-flags");
var _contentContext = require("./internal/content-context");
var _useEnsureIsInsideAvatar = require("./internal/use-ensure-is-inside-avatar");
const boxShadowCssVar = '--avatar-box-shadow';
const bgColorCssVar = '--avatar-bg-color';
const styles = {
    root: "_19itglyw _12ji1r31 _1qu2glyw _12y31o36 _1reo15vq _18m915vq _v564ieh6 _1e0c1txw _kqswpfqs _4cvr1fhb _1bah1h6o _2lx21bp4 _80om1kw7 _6rthv77o _1pfhv77o _12l2v77o _ahbqv77o _85i5ze3t _1q51ze3t _y4tize3t _bozgze3t _t9ec1aqe _9v7aze3t _qc5o1p41 _z0ai1osq _18postnw _1hfk1j28 _aetrf705 _1peqidpf _11fnglyw _1ejjglyw _mizu1v1w _1ah3v77o _ra3xnqa1 _128mdkaa _4dave4h9",
    circle: "_2rko1qll _14mj1qll",
    square: "_2rkol0p1",
    positionRelative: "_kqswh2mm",
    disabled: "_80om13gf _1hfkvuon _1peq2wxo"
};
const unboundStyles = {
    rootCustomBorder: "_11q7cxp3",
    root: "_vchh1ntv _bfhkcxp3 _16qs1nhn",
    hexagonFocusContainer: "_1rjc1wgn _18zr1dm9 _1mou5h37 _195g1ksc _bfhk1j28 _mkrz1k6g _1o9o1v1w",
    hexagonBorderContainerCustomBorder: "_11q7cxp3",
    hexagonBorderContainer: "_1rjcf6hp _18zruxly _1mou18m8 _195gzwb8 _bfhkcxp3 _mkrz1kw7 _1o9ovuon",
    hexagon: "_2rkoidpf _mkrz1kw7 _16qsn7od _14mjidpf _1ejjn7od _128midpf _4davidpf",
    interactive: "_80omtlke _4tpu1f0r _ez1ykb7n _gcm1jer9 _eeh8kb7n _jlxit94y",
    interactiveMotion: "_v5641krm _1llweo6y"
};
const widthHeightMap = {
    xsmall: "_1bsb7vkz _4t3i7vkz",
    UNSAFE_xsmall: "_1bsbgktf _4t3igktf",
    small: "_1bsb1tcg _4t3i1tcg",
    medium: "_1bsbzwfg _4t3izwfg",
    large: "_1bsb1ylp _4t3i1ylp",
    xlarge: "_1bsb16xz _4t3i16xz",
    xxlarge: "_1bsb1qr7 _4t3i1qr7"
};
const AvatarContent = /*#__PURE__*/ (0, _react.forwardRef)(({ children }, ref)=>{
    (0, _useEnsureIsInsideAvatar.useEnsureIsInsideAvatar)();
    const { as: Container, appearance, avatarImage, borderColor = "var(--ds-surface, #FFFFFF)", href, isDisabled, label, onClick, ref: contextRef, tabIndex, target, testId, size, stackIndex, 'aria-controls': ariaControls, 'aria-expanded': ariaExpanded, 'aria-haspopup': ariaHasPopup } = (0, _react.useContext)((0, _contentContext.AvatarContentContext));
    const isInteractive = Boolean(onClick || href || isDisabled || ariaHasPopup);
    const renderedContent = /*#__PURE__*/ _react.createElement(Container, (0, _objectSpreadProps._)((0, _objectSpread._)({
        style: {
            [bgColorCssVar]: borderColor,
            [boxShadowCssVar]: `0 0 0 2px ${borderColor}`
        },
        ref: ref || contextRef,
        "aria-label": isInteractive ? label : undefined,
        "aria-controls": ariaControls,
        "aria-expanded": ariaExpanded,
        "aria-haspopup": ariaHasPopup,
        onClick: onClick,
        tabIndex: tabIndex,
        "data-testid": testId,
        disabled: isDisabled,
        type: Container === 'button' ? 'button' : undefined
    }, href && {
        href,
        target,
        rel: target === '_blank' ? 'noopener noreferrer' : undefined
    }), {
        className: (0, _runtime.ax)([
            unboundStyles.root,
            (0, _platformFeatureFlags.fg)('avatar-custom-border') && unboundStyles.rootCustomBorder,
            styles.root,
            appearance === 'square' && styles.square,
            appearance === 'circle' && styles.circle,
            appearance === 'hexagon' && unboundStyles.hexagon,
            widthHeightMap[size],
            stackIndex !== undefined && styles.positionRelative,
            isInteractive && !isDisabled && unboundStyles.interactive,
            isInteractive && !isDisabled && appearance !== 'hexagon' && (0, _platformFeatureFlags.fg)('platform-dst-motion-uplift') && unboundStyles.interactiveMotion,
            isDisabled && styles.disabled
        ])
    }), children || avatarImage);
    if (appearance !== 'hexagon') return renderedContent;
    // For a Hexagon Avatar in order to have hexagonal "border" and "outline", we have to
    // layer multiple elements and use their background colors to create the different layers.
    return /*#__PURE__*/ _react.createElement("div", {
        style: {
            [bgColorCssVar]: borderColor,
            [boxShadowCssVar]: `0 0 0 2px ${borderColor}`
        },
        "data-testid": testId ? `${testId}-hexagon-focus-container` : 'hexagon-focus-container',
        className: (0, _runtime.ax)([
            unboundStyles.hexagonFocusContainer,
            isInteractive && !isDisabled && (0, _platformFeatureFlags.fg)('platform-dst-motion-uplift') && unboundStyles.interactiveMotion
        ])
    }, /*#__PURE__*/ _react.createElement("div", {
        "data-testid": testId ? `${testId}-hexagon-border-container` : 'hexagon-border-container',
        className: (0, _runtime.ax)([
            unboundStyles.hexagonBorderContainer,
            (0, _platformFeatureFlags.fg)('avatar-custom-border') && unboundStyles.hexagonBorderContainerCustomBorder
        ])
    }, renderedContent));
});

},{"@swc/helpers/_/_object_spread":"9gdrV","@swc/helpers/_/_object_spread_props":"kANqQ","react":"ltHCL","@compiled/react/runtime":"d27Vo","@atlaskit/platform-feature-flags":"8rD2i","./internal/content-context":"jxZKQ","./internal/use-ensure-is-inside-avatar":"e6N5R","@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"jxZKQ":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "AvatarContentContext", ()=>AvatarContentContext);
var _react = require("react");
const defaultAvatarContentProps = {
    as: 'span',
    appearance: 'circle',
    avatarImage: null,
    ref: null,
    size: 'medium'
};
const AvatarContentContext = /*#__PURE__*/ (0, _react.createContext)(defaultAvatarContentProps);

},{"react":"ltHCL","@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"e6N5R":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "useEnsureIsInsideAvatar", ()=>useEnsureIsInsideAvatar);
var _react = require("react");
var _ensureIsInsideAvatarContext = require("./ensure-is-inside-avatar-context");
const useEnsureIsInsideAvatar = ()=>{
    const context = (0, _react.useContext)((0, _ensureIsInsideAvatarContext.EnsureIsInsideAvatarContext));
    if (!context) throw new Error('Avatar sub-components must be used within a Avatar component.');
};

},{"react":"ltHCL","./ensure-is-inside-avatar-context":"15SRy","@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"15SRy":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "EnsureIsInsideAvatarContext", ()=>EnsureIsInsideAvatarContext);
var _react = require("react");
const EnsureIsInsideAvatarContext = /*#__PURE__*/ (0, _react.createContext)(false);

},{"react":"ltHCL","@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"3qvHg":[function(require,module,exports,__globalThis) {
/* avatar-image.tsx generated by @compiled/babel-plugin v0.39.1 */ var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _react = require("react");
var _runtime = require("@compiled/react/runtime");
var _aiAgent = require("@atlaskit/icon/core/ai-agent");
var _aiAgentDefault = parcelHelpers.interopDefault(_aiAgent);
var _person = require("@atlaskit/icon/core/person");
var _personDefault = parcelHelpers.interopDefault(_person);
var _release = require("@atlaskit/icon/core/release");
var _releaseDefault = parcelHelpers.interopDefault(_release);
const styles = {
    image: "_16jlkb7n _1o9zkb7n _i0dl1osq _1e0c1txw _1bsb1osq _4t3i1osq",
    icon: "_1e0c1txw _1bsb1osq _4t3i1osq _bfhk7qp0",
    circle: "_2rko1rr0",
    hexagon: "_mkrz1k6g"
};
const borderRadiusMap = {
    xsmall: "_2rkolb4i",
    UNSAFE_xsmall: "_2rkolb4i",
    small: "_2rkolb4i",
    medium: "_2rko12b0",
    large: "_2rko12b0",
    xlarge: "_2rko1qi0",
    xxlarge: "_2rkopb1k"
};
const nestedSvgStylesMap = {
    xsmall: "_w8l57vkz _17527vkz",
    UNSAFE_xsmall: "_w8l5gktf _1752gktf",
    small: "_w8l51tcg _17521tcg",
    medium: "_w8l5zwfg _1752zwfg",
    large: "_w8l51ylp _17521ylp",
    xlarge: "_w8l516xz _175216xz",
    xxlarge: "_w8l51qr7 _17521qr7"
};
/**
 * __Avatar image__
 *
 * An avatar image is an internal component used to control the rendering phases of an image.
 */ const AvatarImage = ({ alt = '', src, appearance, size, testId, imgLoading })=>{
    const [hasImageErrored, setHasImageErrored] = (0, _react.useState)(false);
    // If src changes, reset state
    (0, _react.useEffect)(()=>{
        setHasImageErrored(false);
    }, [
        src
    ]);
    if (!src || hasImageErrored) {
        let renderedIcon;
        switch(appearance){
            case 'circle':
                renderedIcon = /*#__PURE__*/ _react.createElement((0, _personDefault.default), {
                    label: alt,
                    color: "var(--ds-icon-subtle, #505258)",
                    testId: testId && `${testId}--person`,
                    spacing: "spacious"
                });
                break;
            case 'hexagon':
                renderedIcon = /*#__PURE__*/ _react.createElement((0, _aiAgentDefault.default), {
                    label: alt,
                    color: "var(--ds-icon-subtle, #505258)",
                    testId: testId && `${testId}--agent`,
                    spacing: "spacious"
                });
                break;
            default:
            case 'square':
                renderedIcon = /*#__PURE__*/ _react.createElement((0, _releaseDefault.default), {
                    label: alt,
                    color: "var(--ds-icon-subtle, #505258)",
                    testId: testId && `${testId}--ship`,
                    spacing: "spacious"
                });
                break;
        }
        return /*#__PURE__*/ _react.createElement("span", {
            className: (0, _runtime.ax)([
                styles.icon,
                nestedSvgStylesMap[size]
            ])
        }, renderedIcon);
    }
    return /*#__PURE__*/ _react.createElement("img", {
        loading: imgLoading,
        src: src,
        alt: alt,
        "data-testid": testId && `${testId}--image`,
        onError: ()=>setHasImageErrored(true),
        "aria-hidden": !alt ? true : undefined,
        "data-vc": testId ? `${testId}--image` : 'avatar-image',
        "data-ssr-placeholder-ignored": true,
        className: (0, _runtime.ax)([
            styles.image,
            borderRadiusMap[size],
            appearance === 'circle' && styles.circle,
            appearance === 'hexagon' && styles.hexagon
        ])
    });
};
exports.default = AvatarImage;

},{"react":"ltHCL","@compiled/react/runtime":"d27Vo","@atlaskit/icon/core/ai-agent":"f6DTj","@atlaskit/icon/core/person":"bEXRT","@atlaskit/icon/core/release":"kXI1S","@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"f6DTj":[function(require,module,exports,__globalThis) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::e079be55658218810235742dfafa5bd4>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = void 0;
var _react = _interopRequireDefault(require("7ebc20c77ad55454"));
var _baseNew = _interopRequireDefault(require("9afb0616d65c7cf6"));
function _interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "AiAgent".
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Single purpose - Reserved for Rovo Agent.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const AiAgentIcon = (props)=>/*#__PURE__*/ _react.default.createElement(_baseNew.default, Object.assign({
        name: "AiAgentIcon",
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M6.971.493a2 2 0 0 1 2.058 0l5 3A2 2 0 0 1 15 5.208v5.584a2 2 0 0 1-.971 1.715l-5 3a2 2 0 0 1-2.058 0l-5-3A2 2 0 0 1 1 10.792V5.208a2 2 0 0 1 .971-1.715zm1.286 1.286a.5.5 0 0 0-.514 0l-5 3a.5.5 0 0 0-.243.429v5.584a.5.5 0 0 0 .243.429l1.098.66a4.25 4.25 0 1 1 8.318 0l1.098-.66a.5.5 0 0 0 .243-.429V5.208a.5.5 0 0 0-.243-.429zM8 8.25a2.75 2.75 0 1 0 0 5.5 2.75 2.75 0 0 0 0-5.5" clip-rule="evenodd"/>`
    }, props));
AiAgentIcon.displayName = 'AiAgentIcon';
var _default = exports.default = AiAgentIcon;

},{"7ebc20c77ad55454":"ltHCL","9afb0616d65c7cf6":"5XL7D"}],"bEXRT":[function(require,module,exports,__globalThis) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::fc4353a18034f564a0b3573d4163ea60>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = void 0;
var _react = _interopRequireDefault(require("af881f95b1f0534c"));
var _baseNew = _interopRequireDefault(require("816120b188e724cf"));
function _interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "Person".
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Single purpose - Known uses: representing a person or user, owner, contributor.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const PersonIcon = (props)=>/*#__PURE__*/ _react.default.createElement(_baseNew.default, Object.assign({
        name: "PersonIcon",
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M8 1.5a2.5 2.5 0 1 0 0 5 2.5 2.5 0 0 0 0-5M4 4a4 4 0 1 1 8 0 4 4 0 0 1-8 0m-2 9a3.75 3.75 0 0 1 3.75-3.75h4.5A3.75 3.75 0 0 1 14 13v2h-1.5v-2a2.25 2.25 0 0 0-2.25-2.25h-4.5A2.25 2.25 0 0 0 3.5 13v2H2z" clip-rule="evenodd"/>`
    }, props));
PersonIcon.displayName = 'PersonIcon';
var _default = exports.default = PersonIcon;

},{"af881f95b1f0534c":"ltHCL","816120b188e724cf":"5XL7D"}],"kXI1S":[function(require,module,exports,__globalThis) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::b5b008ccfed50bccf7a8bb78b89f8a48>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = void 0;
var _react = _interopRequireDefault(require("7903e6106ec1892c"));
var _baseNew = _interopRequireDefault(require("cc6e5890ee0b9365"));
function _interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "Release".
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Single purpose - Reserved for releases in Jira.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const ReleaseIcon = (props)=>/*#__PURE__*/ _react.default.createElement(_baseNew.default, Object.assign({
        name: "ReleaseIcon",
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M4 2h3v2h2a.75.75 0 0 1 .648.372L11.18 7h4.069a.75.75 0 0 1 .646 1.132l-2.887 4.886a2 2 0 0 1-1.722.982H2a2 2 0 0 1-2-2V7.75A.75.75 0 0 1 .75 7H2V4.75A.75.75 0 0 1 2.75 4H4zm-.5 5h5.944L8.57 5.5H3.5zm-2 1.5V12a.5.5 0 0 0 .5.5h9.287a.5.5 0 0 0 .43-.246L13.936 8.5z" clip-rule="evenodd"/>`
    }, props));
ReleaseIcon.displayName = 'ReleaseIcon';
var _default = exports.default = ReleaseIcon;

},{"7903e6106ec1892c":"ltHCL","cc6e5890ee0b9365":"5XL7D"}],"4ooOM":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
const getCustomElement = (isDisabled, href, onClick, ariaHasPopup)=>{
    if (href && !isDisabled) return 'a';
    if (onClick || isDisabled || ariaHasPopup) return 'button';
    return 'span';
};
exports.default = getCustomElement;

},{"@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"2hk3o":[function(require,module,exports,__globalThis) {
/* presence-wrapper.tsx generated by @compiled/babel-plugin v0.39.1 */ var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _react = require("react");
var _runtime = require("@compiled/react/runtime");
var _presence = require("../presence");
var _presenceDefault = parcelHelpers.interopDefault(_presence);
const styles = {
    root: "_kqswstnw _lcxvglyw"
};
const iconSizeMap = {
    small: "_4t3i1crf _1bsb1crf",
    medium: "_4t3idlk8 _1bsbdlk8",
    large: "_4t3io7ao _1bsbo7ao",
    xlarge: "_4t3if6fq _1bsbf6fq"
};
const circleIconOffsetMap = {
    small: "_94n5idpf _1xi2idpf",
    medium: "_94n5idpf _1xi2idpf",
    large: "_94n5t94y _1xi2t94y",
    xlarge: "_94n51v6z _1xi21v6z"
};
const squareIconOffsetMap = {
    root: "_94n5myb0 _1xi2myb0"
};
const hexagonIconOffsetMap = {
    small: "_94n51n1a _1xi21n1a",
    medium: "_94n51n1a _1xi21n1a",
    large: "_94n51y44 _1xi2myb0",
    xlarge: "_94n5l52n _1xi21lpd"
};
/**
 * __Presence wrapper__
 *
 * A presence wrapper is used internally to position presence ontop of the avatar.
 */ const PresenceWrapper = ({ size, appearance, children, borderColor, presence, testId })=>{
    return /*#__PURE__*/ _react.createElement("span", {
        "aria-hidden": "true",
        "data-testid": testId && `${testId}--presence`,
        className: (0, _runtime.ax)([
            styles.root,
            iconSizeMap[size],
            circleIconOffsetMap[size],
            appearance === 'square' && squareIconOffsetMap.root,
            appearance === 'hexagon' && hexagonIconOffsetMap[size]
        ])
    }, /*#__PURE__*/ _react.createElement((0, _presenceDefault.default), {
        borderColor: borderColor,
        presence: !children ? presence : undefined
    }, children));
};
exports.default = PresenceWrapper;

},{"react":"ltHCL","@compiled/react/runtime":"d27Vo","../presence":"d8Z6a","@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"d8Z6a":[function(require,module,exports,__globalThis) {
/* presence.tsx generated by @compiled/babel-plugin v0.39.1 */ var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _react = require("react");
var _iconWrapper = require("./internal/icon-wrapper");
var _iconWrapperDefault = parcelHelpers.interopDefault(_iconWrapper);
const BusyIndicator = /*#__PURE__*/ _react.createElement((0, _react.Fragment), null, /*#__PURE__*/ _react.createElement("circle", {
    fill: "var(--ds-icon-danger, #C9372C)",
    cx: "4",
    cy: "4",
    r: "4"
}), /*#__PURE__*/ _react.createElement("path", {
    fill: "var(--ds-surface-overlay, #FFFFFF)",
    d: "M3.3,1.9l2.8,2.8c0.2,0.2,0.2,0.5,0,0.7L5.4,6.1c-0.2,0.2-0.5,0.2-0.7,0L1.9,3.3c-0.2-0.2-0.2-0.5,0-0.7l0.7-0.7C2.8,1.7,3.1,1.7,3.3,1.9z"
}));
const FocusIndicator = /*#__PURE__*/ _react.createElement((0, _react.Fragment), null, /*#__PURE__*/ _react.createElement("path", {
    fill: "var(--ds-icon-discovery, #AF59E1)",
    d: "M4,8 C1.790861,8 0,6.209139 0,4 C0,1.790861 1.790861,0 4,0 C6.209139,0 8,1.790861 8,4 C8,6.209139 6.209139,8 4,8 Z M4,6.66666667 C5.47275933,6.66666667 6.66666667,5.47275933 6.66666667,4 C6.66666667,2.52724067 5.47275933,1.33333333 4,1.33333333 C2.52724067,1.33333333 1.33333333,2.52724067 1.33333333,4 C1.33333333,5.47275933 2.52724067,6.66666667 4,6.66666667 Z M4,5.33333333 C3.26362033,5.33333333 2.66666667,4.73637967 2.66666667,4 C2.66666667,3.26362033 3.26362033,2.66666667 4,2.66666667 C4.73637967,2.66666667 5.33333333,3.26362033 5.33333333,4 C5.33333333,4.73637967 4.73637967,5.33333333 4,5.33333333 Z"
}));
const OfflineIndicator = /*#__PURE__*/ _react.createElement((0, _react.Fragment), null, /*#__PURE__*/ _react.createElement("path", {
    fill: "var(--ds-text-subtlest, #6B6E76)",
    d: "M4,8 C6.209139,8 8,6.209139 8,4 C8,1.790861 6.209139,0 4,0 C1.790861,0 0,1.790861 0,4 C0,6.209139 1.790861,8 4,8 Z M4,6 C5.1045695,6 6,5.1045695 6,4 C6,2.8954305 5.1045695,2 4,2 C2.8954305,2 2,2.8954305 2,4 C2,5.1045695 2.8954305,6 4,6 Z"
}), /*#__PURE__*/ _react.createElement("path", {
    fill: "var(--ds-surface-overlay, #FFFFFF)",
    d: "M4,6 C5.1045695,6 6,5.1045695 6,4 C6,2.8954305 5.1045695,2 4,2 C2.8954305,2 2,2.8954305 2,4 C2,5.1045695 2.8954305,6 4,6 Z"
}));
const OnlineIndicator = /*#__PURE__*/ _react.createElement("circle", {
    fill: "var(--ds-icon-success, #6A9A23)",
    cx: "4",
    cy: "4",
    r: "4"
});
function getPresence(presence) {
    switch(presence){
        case 'busy':
            return BusyIndicator;
        case 'focus':
            return FocusIndicator;
        case 'offline':
            return OfflineIndicator;
        case 'online':
            return OnlineIndicator;
    }
}
/**
 * __Avatar presence__
 *
 * A presence shows an avatar’s availability.
 *
 * - [Examples](https://atlassian.design/components/avatar/avatar-presence/examples)
 * - [Code](https://atlassian.design/components/avatar/avatar-presence/code)
 * - [Usage](https://atlassian.design/components/avatar/avatar-presence/usage)
 */ const AvatarPresence = ({ borderColor, children, presence })=>/*#__PURE__*/ _react.createElement((0, _iconWrapperDefault.default), {
        bgColor: borderColor
    }, presence ? /*#__PURE__*/ _react.createElement("svg", {
        height: "100%",
        version: "1.1",
        viewBox: "0 0 8 8",
        width: "100%",
        xmlns: "http://www.w3.org/2000/svg"
    }, getPresence(presence)) : children);
exports.default = AvatarPresence;

},{"react":"ltHCL","./internal/icon-wrapper":"ieirN","@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"ieirN":[function(require,module,exports,__globalThis) {
/* icon-wrapper.tsx generated by @compiled/babel-plugin v0.39.1 */ var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _react = require("react");
var _runtime = require("@compiled/react/runtime");
const styles = {
    root: "_2rko1qll _1reo15vq _18m915vq _189e1dm9 _1dqonqa1 _1e0c1txw _vchhusvi _1bsb1osq _4t3i1osq _4cvr1h6o _ae4v1h6o _bfhk1bhr"
};
const unboundStyles = {
    root: "_1h6d1bhr"
};
/**
 * __Icon wrapper__
 *
 * An icon wrapper is used internally only.
 */ const IconWrapper = ({ bgColor, children })=>/*#__PURE__*/ _react.createElement("span", {
        role: "presentation",
        style: {
            borderColor: bgColor,
            backgroundColor: bgColor
        },
        className: (0, _runtime.ax)([
            styles.root,
            unboundStyles.root
        ])
    }, children);
exports.default = IconWrapper;

},{"react":"ltHCL","@compiled/react/runtime":"d27Vo","@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"bqvBe":[function(require,module,exports,__globalThis) {
/* status-wrapper.tsx generated by @compiled/babel-plugin v0.39.1 */ var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _react = require("react");
var _runtime = require("@compiled/react/runtime");
var _status = require("../status");
var _statusDefault = parcelHelpers.interopDefault(_status);
const styles = {
    root: "_kqswstnw"
};
const iconSizeMap = {
    small: "_4t3i1crf _1bsb1crf",
    medium: "_4t3idlk8 _1bsbdlk8",
    large: "_4t3io7ao _1bsbo7ao",
    xlarge: "_4t3if6fq _1bsbf6fq"
};
const circleIconOffsetMap = {
    small: "_rjxpidpf _152tidpf",
    medium: "_rjxpidpf _152tidpf",
    large: "_rjxpt94y _152tt94y",
    xlarge: "_rjxp1v6z _152t1v6z"
};
const squareIconOffsetMap = {
    root: "_rjxpidpf _152tidpf"
};
const hexagonIconOffsetMap = {
    small: "_rjxp1n1a _152t1n1a",
    medium: "_rjxp1n1a _152t1n1a",
    large: "_rjxpmyb0 _152t1y44",
    xlarge: "_rjxp1lpd _152tl52n"
};
/**
 * __Status wrapper__
 *
 * A status wrapper is used internally to position status on top of the avatar.
 */ const StatusWrapper = ({ size, status, appearance, borderColor, children, testId })=>{
    return /*#__PURE__*/ _react.createElement("span", {
        "aria-hidden": "true",
        "data-testid": testId && `${testId}--status`,
        className: (0, _runtime.ax)([
            styles.root,
            iconSizeMap[size],
            circleIconOffsetMap[size],
            appearance === 'square' && squareIconOffsetMap.root,
            appearance === 'hexagon' && hexagonIconOffsetMap[size]
        ])
    }, /*#__PURE__*/ _react.createElement((0, _statusDefault.default), {
        borderColor: borderColor,
        status: !children ? status : undefined
    }, children));
};
exports.default = StatusWrapper;

},{"react":"ltHCL","@compiled/react/runtime":"d27Vo","../status":"8YvnL","@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"8YvnL":[function(require,module,exports,__globalThis) {
/* status.tsx generated by @compiled/babel-plugin v0.39.1 */ var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _react = require("react");
var _iconWrapper = require("./internal/icon-wrapper");
var _iconWrapperDefault = parcelHelpers.interopDefault(_iconWrapper);
const ApprovedIndicator = /*#__PURE__*/ _react.createElement((0, _react.Fragment), null, /*#__PURE__*/ _react.createElement("circle", {
    fill: "var(--ds-icon-success, #6A9A23)",
    cx: "4",
    cy: "4",
    r: "4"
}), /*#__PURE__*/ _react.createElement("path", {
    fill: "var(--ds-surface-overlay, #FFFFFF)",
    d: "M2.47140452,3.52859548 C2.21105499,3.26824595 1.78894501,3.26824595 1.52859548,3.52859548 C1.26824595,3.78894501 1.26824595,4.21105499 1.52859548,4.47140452 L2.86192881,5.80473785 C3.12227834,6.06508738 3.54438833,6.06508738 3.80473785,5.80473785 L6.47140452,3.13807119 C6.73175405,2.87772166 6.73175405,2.45561167 6.47140452,2.19526215 C6.21105499,1.93491262 5.78894501,1.93491262 5.52859548,2.19526215 L3.33333333,4.39052429 L2.47140452,3.52859548 Z"
}));
const DeclinedIndicator = /*#__PURE__*/ _react.createElement((0, _react.Fragment), null, /*#__PURE__*/ _react.createElement("circle", {
    fill: "var(--ds-icon-danger, #C9372C)",
    cx: "4",
    cy: "4",
    r: "4"
}), /*#__PURE__*/ _react.createElement("path", {
    fill: "var(--ds-surface-overlay, #FFFFFF)",
    d: "M4.890661,4.0088336 L5.81806461,3.07802178 C6.06167933,2.83351177 6.06048933,2.43826992 5.81540668,2.19522442 C5.57032402,1.95217891 5.17415651,1.95336612 4.93054179,2.19787613 L4.00765946,3.12415007 L3.06906871,2.18377143 C2.82523777,1.93947602 2.42906937,1.93863765 2.18420182,2.18189887 C1.93933427,2.42516008 1.93849394,2.82040282 2.18232488,3.06469822 L3.12544091,4.00961077 L2.20275024,4.93569234 C1.95913552,5.18020236 1.96032551,5.5754442 2.20540817,5.81848971 C2.45049083,6.06153521 2.84665833,6.060348 3.09027306,5.81583799 L4.00844245,4.89429431 L4.9092123,5.79678001 C5.15304324,6.04107541 5.54921164,6.04191379 5.79407919,5.79865257 C6.03894674,5.55539135 6.03978708,5.16014862 5.79595614,4.91585321 L4.890661,4.0088336 Z"
}));
const LockedIndicator = /*#__PURE__*/ _react.createElement((0, _react.Fragment), null, /*#__PURE__*/ _react.createElement("circle", {
    fill: "var(--ds-text-subtlest, #6B6E76)",
    cx: "4",
    cy: "4",
    r: "4"
}), /*#__PURE__*/ _react.createElement("path", {
    fill: "var(--ds-surface-overlay, #FFFFFF)",
    d: "M4.13074827,1.21766493 L4.10368158,1.21766493 C3.36340745,1.21766493 2.76388015,1.80793503 2.76388015,2.5367787 L2.76388015,3.21632216 L3.44054754,3.21632216 L3.44054754,2.54344089 C3.44054754,2.17901906 3.74031119,1.88388401 4.11044825,1.88388401 L4.1239816,1.88388401 C4.49411866,1.88388401 4.79388232,2.17901906 4.79388232,2.54344089 L4.79388232,3.21632216 L5.47054971,3.21632216 L5.47054971,2.5367787 C5.47054971,1.80793503 4.8710224,1.21766493 4.13074827,1.21766493 M2.76388015,3.21632216 L3.44054754,3.21632216 L3.44054754,3.88254123 L2.76388015,3.88254123 L2.76388015,3.21632216 Z M4.79388232,3.21632216 L5.47054971,3.21632216 L5.47054971,3.88254123 L4.79388232,3.88254123 L4.79388232,3.21632216 Z M4.79401765,3.88254123 L3.44068287,3.88254123 L2.76401548,3.88254123 C2.39049508,3.88254123 2.08734809,4.18100738 2.08734809,4.54876031 L2.08734809,5.54808892 C2.08734809,6.10000287 2.53735205,6.54741753 3.09094491,6.54741753 L5.14375561,6.54741753 C5.69802683,6.54741753 6.14735243,6.10385072 6.14735243,5.54808892 L6.14735243,4.54876031 C6.14735243,4.18100738 5.84420544,3.88254123 5.47068504,3.88254123 L4.79401765,3.88254123 Z"
}));
const WarningIndicator = /*#__PURE__*/ _react.createElement((0, _react.Fragment), null, /*#__PURE__*/ _react.createElement("circle", {
    fill: "var(--ds-icon-warning, #E06C00)",
    cx: "4",
    cy: "4",
    r: "4"
}), /*#__PURE__*/ _react.createElement("path", {
    fill: "var(--ds-surface-overlay, #FFFFFF)",
    d: "M4,1.33333333 C4.36918944,1.33333333 4.66666667,1.63081056 4.66666667,2 L4.66666667,4 C4.66666667,4.36918944 4.36918944,4.66666667 4,4.66666667 C3.63081056,4.66666667 3.33333333,4.36918944 3.33333333,4 L3.33333333,2 C3.33333333,1.63081056 3.63081056,1.33333333 4,1.33333333 Z M4,5.33333333 C4.36918944,5.33333333 4.66666667,5.63081056 4.66666667,6 C4.66666667,6.36918944 4.36918944,6.66666667 4,6.66666667 C3.63081056,6.66666667 3.33333333,6.36918944 3.33333333,6 C3.33333333,5.63081056 3.63081056,5.33333333 4,5.33333333 Z"
}));
function getStatus(status) {
    switch(status){
        case 'approved':
            return ApprovedIndicator;
        case 'declined':
            return DeclinedIndicator;
        case 'locked':
            return LockedIndicator;
        case 'warning':
            return WarningIndicator;
    }
}
/**
 * __Avatar status__
 *
 * An avatar status shows contextual information, such as if someone approves or declines something.
 *
 * - [Examples](https://atlassian.design/components/avatar/avatar-status/examples)
 * - [Code](https://atlassian.design/components/avatar/avatar-status/code)
 */ const AvatarStatus = ({ borderColor, children, status })=>/*#__PURE__*/ _react.createElement((0, _iconWrapperDefault.default), {
        bgColor: borderColor
    }, status ? /*#__PURE__*/ _react.createElement("svg", {
        height: "100%",
        version: "1.1",
        viewBox: "0 0 8 8",
        width: "100%",
        xmlns: "http://www.w3.org/2000/svg"
    }, getStatus(status)) : children);
exports.default = AvatarStatus;

},{"react":"ltHCL","./internal/icon-wrapper":"ieirN","@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"b6fLj":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "useAvatarContext", ()=>useAvatarContext);
var _react = require("react");
var _avatarContext = require("./avatar-context");
const useAvatarContext = ()=>(0, _react.useContext)((0, _avatarContext.AvatarContext));

},{"react":"ltHCL","./avatar-context":"9d3fC","@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"9d3fC":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "AvatarContext", ()=>AvatarContext);
var _react = require("react");
const AvatarContext = /*#__PURE__*/ (0, _react.createContext)(undefined);

},{"react":"ltHCL","@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"1k8pJ":[function(require,module,exports,__globalThis) {
/* avatar-item.tsx generated by @compiled/babel-plugin v0.39.1 */ var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _objectSpread = require("@swc/helpers/_/_object_spread");
var _objectSpreadProps = require("@swc/helpers/_/_object_spread_props");
var _react = require("react");
var _runtime = require("@compiled/react/runtime");
var _platformFeatureFlags = require("@atlaskit/platform-feature-flags");
var _compiled = require("@atlaskit/primitives/compiled");
var _getCustomElement = require("./internal/get-custom-element");
var _getCustomElementDefault = parcelHelpers.interopDefault(_getCustomElement);
const bgColorCssVar = '--avatar-item-bg-color';
const styles = {
    root: "_2rkofajl _12ji1r31 _1qu2glyw _12y31o36 _4bfu1r31 _1hmsglyw _ajmmnqa1 _1h6d1j28 _1dqonqa1 _189e1dm9 _1e0c1txw _vchhusvi _1bsb1osq _4cvr1h6o _bfhk1g13 _syaz1kw7 _1wyb1kw7 _zg8l4jg8 _k48pi7a9 _vwz4kb7n _6rthze3t _1pfhze3t _12l2ze3t _ahbqze3t _85i51b66 _1q511b66 _y4ti1b66 _bozg1b66 _y3gn1e5h",
    rootDisabled: "_80om13gf _tzy42wxo _lcxvglyw",
    rootInteractive: "_nt751r31 _49pcglyw _1hvw1o36 _858u1v1w _9oik1r31 _1bnxglyw _jf4cnqa1 _irr31dpa _d0altlke _1di6fcek",
    avatarItem: "_16jlkb7n _1o9zkb7n _i0dl1osq _1ul9idpf _p12f1osq _vwz419ii _bozgu2gc",
    baseText: "_1e0c1ule _syazi7uo",
    truncation: "_1reo15vq _1bto1l2s _o5721q9c",
    secondaryTextLegacy: "_syaz1rpy _1wyb181o"
};
/**
 * __Avatar item__
 *
 * An avatar item is a wrapper that goes around an avatar when it's displayed alongside text, such as a name or status.
 *
 * - [Examples](https://atlassian.design/components/avatar/avatar-item/examples)
 * - [Code](https://atlassian.design/components/avatar/avatar-item/code)
 */ const AvatarItem = /*#__PURE__*/ (0, _react.forwardRef)(({ avatar, backgroundColor = 'transparent', isTruncationDisabled, href, isDisabled, onClick, primaryText, secondaryText, target, testId, label }, ref)=>{
    const Container = (0, _getCustomElementDefault.default)(isDisabled, href, onClick);
    const isInteractive = Boolean(onClick || href);
    return /*#__PURE__*/ _react.createElement(Container, (0, _objectSpreadProps._)((0, _objectSpread._)({
        style: {
            [bgColorCssVar]: backgroundColor
        },
        ref: ref,
        "aria-label": isInteractive ? label : undefined,
        onClick: onClick,
        disabled: isDisabled,
        "data-testid": testId ? `${testId}--itemInner` : undefined,
        type: Container === 'button' ? 'button' : undefined
    }, href && {
        href,
        target,
        rel: target === '_blank' ? 'noopener noreferrer' : undefined
    }), {
        className: (0, _runtime.ax)([
            styles.root,
            isInteractive && styles.rootInteractive,
            isDisabled && styles.rootDisabled
        ])
    }), avatar, /*#__PURE__*/ _react.createElement("div", {
        className: (0, _runtime.ax)([
            styles.avatarItem
        ])
    }, (0, _platformFeatureFlags.fg)('platform.design-system-team.avatar-item-font-size_830x6') ? /*#__PURE__*/ _react.createElement((0, _react.Fragment), null, /*#__PURE__*/ _react.createElement((0, _compiled.Text), {
        maxLines: isTruncationDisabled ? undefined : 1
    }, primaryText), /*#__PURE__*/ _react.createElement((0, _compiled.Text), {
        color: "color.text.subtlest",
        maxLines: isTruncationDisabled ? undefined : 1,
        size: "small"
    }, secondaryText)) : /*#__PURE__*/ _react.createElement((0, _react.Fragment), null, /*#__PURE__*/ _react.createElement("span", {
        className: (0, _runtime.ax)([
            styles.baseText,
            !isTruncationDisabled && styles.truncation
        ])
    }, primaryText), /*#__PURE__*/ _react.createElement("span", {
        className: (0, _runtime.ax)([
            styles.baseText,
            styles.secondaryTextLegacy,
            !isTruncationDisabled && styles.truncation
        ])
    }, secondaryText))));
});
AvatarItem.displayName = 'AvatarItem';
exports.default = AvatarItem;

},{"@swc/helpers/_/_object_spread":"9gdrV","@swc/helpers/_/_object_spread_props":"kANqQ","react":"ltHCL","@compiled/react/runtime":"d27Vo","@atlaskit/platform-feature-flags":"8rD2i","@atlaskit/primitives/compiled":"hDay7","./internal/get-custom-element":"4ooOM","@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"jA3J3":[function(require,module,exports,__globalThis) {
/* skeleton.tsx generated by @compiled/babel-plugin v0.39.1 */ var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _react = require("react");
var _runtime = require("@compiled/react/runtime");
const bgColorCssVar = '--avatar-skeleton-background-color';
const styles = {
    root: "_2rko1qll _189e1dm9 _1dqonqa1 _1h6d1j28 _1e0c1o8l _bfhk1r8p _tzy4nh7s",
    square: "_2rkol0p1",
    hexagon: "_mkrz1k6g",
    strongOpacity: "_tzy4clii"
};
const sizeStyles = {
    xsmall: "_1bsb7vkz _4t3i7vkz",
    UNSAFE_xsmall: "_1bsbgktf _4t3igktf",
    small: "_1bsb1tcg _4t3i1tcg",
    medium: "_1bsbzwfg _4t3izwfg",
    large: "_1bsb1ylp _4t3i1ylp",
    xlarge: "_1bsb16xz _4t3i16xz",
    xxlarge: "_1bsb1qr7 _4t3i1qr7"
};
/**
 * __Skeleton__
 *
 * A skeleton is the loading state for the avatar component.
 *
 * - [Examples](https://atlassian.design/components/avatar/avatar-skeleton/examples)
 * - [Code](https://atlassian.design/components/avatar/avatar-skeleton/code)
 */ const Skeleton = ({ size, appearance = 'circle', color, weight })=>{
    const avatarSize = size !== null && size !== void 0 ? size : 'medium';
    return /*#__PURE__*/ _react.createElement("div", {
        style: {
            [bgColorCssVar]: color !== null && color !== void 0 ? color : 'currentColor'
        },
        className: (0, _runtime.ax)([
            styles.root,
            sizeStyles[avatarSize],
            appearance === 'square' && styles.square,
            appearance === 'hexagon' && styles.hexagon,
            weight === 'strong' && styles.strongOpacity
        ])
    });
};
exports.default = Skeleton;

},{"react":"ltHCL","@compiled/react/runtime":"d27Vo","@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"17dJI":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
const getAppearanceForAppType = (appType)=>{
    switch(appType){
        case 'agent':
            return 'hexagon';
        case 'user':
        case 'system':
        default:
            return 'circle';
    }
};
exports.default = getAppearanceForAppType;

},{"@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"jnv6X":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "AVATAR_SIZES", ()=>AVATAR_SIZES);
const AVATAR_SIZES = {
    xsmall: 16,
    UNSAFE_xsmall: 20,
    small: 24,
    medium: 32,
    large: 40,
    xlarge: 96,
    xxlarge: 128
};

},{"@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"87Re1":[function(require,module,exports,__globalThis) {
/**
 * _Internally_ shared value for the menu item indentation. Used in:
 * - Expandable menu item content, to add padding for each expandable level
 * - The base menu item, to set the negative inset to extend the clickable area of nested menu items
 * to the root level menu items.
 *
 * Internal to the package only. Should not be exported from the package.
 *
 * Note: We're unable to use a token() call here, as Compiled complains about function calls in imported
 * values - it requires statically defined values only.
 *
 * @private
 * @internal
 */ var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "expandableMenuItemIndentation", ()=>expandableMenuItemIndentation);
const expandableMenuItemIndentation = '12px';

},{"@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"avnrV":[function(require,module,exports,__globalThis) {
/* drag-handle.tsx generated by @compiled/babel-plugin v0.39.1 */ var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "DragHandle", ()=>DragHandle);
var _react = require("react");
var _runtime = require("@compiled/react/runtime");
var _dragHandleVertical = require("@atlaskit/icon/core/drag-handle-vertical");
var _dragHandleVerticalDefault = parcelHelpers.interopDefault(_dragHandleVertical);
const styles = {
    root: "_syazazsu _1e0c1i3c _2lx21bp4 _1bah1h6o _kqswstnw _152tidpf _u7coidpf _1e02idpf _ahbqxmi2"
};
function DragHandle() {
    return /*#__PURE__*/ _react.createElement("div", {
        "aria-hidden": "true",
        className: (0, _runtime.ax)([
            styles.root
        ])
    }, /*#__PURE__*/ _react.createElement((0, _dragHandleVerticalDefault.default), {
        label: "",
        size: "small"
    }));
}

},{"react":"ltHCL","@compiled/react/runtime":"d27Vo","@atlaskit/icon/core/drag-handle-vertical":"h711R","@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"h711R":[function(require,module,exports,__globalThis) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::976c79b56a8fa85b795a69d54376c6cc>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = void 0;
var _react = _interopRequireDefault(require("d6194bdb80edf87f"));
var _baseNew = _interopRequireDefault(require("3256358d9f73908d"));
function _interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "DragHandleVertical".
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Reserved for dragging elements along a vertical axis.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const DragHandleVerticalIcon = (props)=>/*#__PURE__*/ _react.default.createElement(_baseNew.default, Object.assign({
        name: "DragHandleVerticalIcon",
        dangerouslySetGlyph: `<path fill="currentcolor" d="M7 2.75a1.75 1.75 0 1 1-3.5 0 1.75 1.75 0 0 1 3.5 0m5.5 0a1.75 1.75 0 1 1-3.5 0 1.75 1.75 0 0 1 3.5 0M7 8a1.75 1.75 0 1 1-3.5 0A1.75 1.75 0 0 1 7 8m5.5 0A1.75 1.75 0 1 1 9 8a1.75 1.75 0 0 1 3.5 0M7 13.25a1.75 1.75 0 1 1-3.5 0 1.75 1.75 0 0 1 3.5 0m5.5 0a1.75 1.75 0 1 1-3.5 0 1.75 1.75 0 0 1 3.5 0"/>`
    }, props));
DragHandleVerticalIcon.displayName = 'DragHandleVerticalIcon';
var _default = exports.default = DragHandleVerticalIcon;

},{"d6194bdb80edf87f":"ltHCL","3256358d9f73908d":"5XL7D"}],"jqpKo":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "AreAllAncestorsExpandedContext", ()=>AreAllAncestorsExpandedContext);
parcelHelpers.export(exports, "IsExpandedContext", ()=>IsExpandedContext);
parcelHelpers.export(exports, "SetIsExpandedContext", ()=>SetIsExpandedContext);
parcelHelpers.export(exports, "OnExpansionToggleContext", ()=>OnExpansionToggleContext);
parcelHelpers.export(exports, "LevelContext", ()=>LevelContext);
parcelHelpers.export(exports, "useIsExpanded", ()=>useIsExpanded);
parcelHelpers.export(exports, "useSetIsExpanded", ()=>useSetIsExpanded);
parcelHelpers.export(exports, "useOnExpansionToggle", ()=>useOnExpansionToggle);
parcelHelpers.export(exports, "useLevel", ()=>useLevel);
parcelHelpers.export(exports, "useAreAllAncestorsExpanded", ()=>useAreAllAncestorsExpanded);
var _react = require("react");
var _tinyInvariant = require("tiny-invariant");
var _tinyInvariantDefault = parcelHelpers.interopDefault(_tinyInvariant);
var _expandableMenuItemLevelContext = require("./expandable-menu-item-level-context");
const AreAllAncestorsExpandedContext = /*#__PURE__*/ (0, _react.createContext)(null);
const IsExpandedContext = /*#__PURE__*/ (0, _react.createContext)(null);
const SetIsExpandedContext = /*#__PURE__*/ (0, _react.createContext)(null);
const OnExpansionToggleContext = /*#__PURE__*/ (0, _react.createContext)(null);
const LevelContext = (0, _expandableMenuItemLevelContext.ExpandableMenuItemLevelContext);
const useIsExpanded = ()=>{
    const context = (0, _react.useContext)(IsExpandedContext);
    (0, _tinyInvariantDefault.default)(context !== null, 'useIsExpanded must be used within an ExpandableMenuItem');
    return context;
};
const useSetIsExpanded = ()=>{
    const context = (0, _react.useContext)(SetIsExpandedContext);
    (0, _tinyInvariantDefault.default)(context !== null, 'useSetIsExpanded must be used within an ExpandableMenuItem');
    return context;
};
const useOnExpansionToggle = ()=>(0, _react.useContext)(OnExpansionToggleContext);
const useLevel = ()=>(0, _react.useContext)(LevelContext);
const useAreAllAncestorsExpanded = ()=>{
    var _useContext;
    return (_useContext = (0, _react.useContext)(AreAllAncestorsExpandedContext)) !== null && _useContext !== void 0 ? _useContext : true;
};

},{"react":"ltHCL","tiny-invariant":"9VWeJ","./expandable-menu-item-level-context":"8q4Oh","@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"8q4Oh":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "ExpandableMenuItemLevelContext", ()=>ExpandableMenuItemLevelContext);
var _react = require("react");
const ExpandableMenuItemLevelContext = /*#__PURE__*/ (0, _react.createContext)(0);

},{"react":"ltHCL","@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"l8k9F":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "IsOpenContext", ()=>IsOpenContext);
parcelHelpers.export(exports, "SetIsOpenContext", ()=>SetIsOpenContext);
parcelHelpers.export(exports, "useFlyoutMenuOpen", ()=>useFlyoutMenuOpen);
parcelHelpers.export(exports, "useSetFlyoutMenuOpen", ()=>useSetFlyoutMenuOpen);
parcelHelpers.export(exports, "OnCloseContext", ()=>OnCloseContext);
parcelHelpers.export(exports, "TitleIdContext", ()=>TitleIdContext);
parcelHelpers.export(exports, "useTitleId", ()=>useTitleId);
parcelHelpers.export(exports, "TitleIdContextProvider", ()=>TitleIdContextProvider);
var _react = require("react");
var _noop = require("@atlaskit/ds-lib/noop");
var _noopDefault = parcelHelpers.interopDefault(_noop);
const IsOpenContext = /*#__PURE__*/ (0, _react.createContext)(false);
const SetIsOpenContext = /*#__PURE__*/ (0, _react.createContext)((0, _noopDefault.default));
const useFlyoutMenuOpen = ()=>(0, _react.useContext)(IsOpenContext);
const useSetFlyoutMenuOpen = ()=>(0, _react.useContext)(SetIsOpenContext);
const OnCloseContext = /*#__PURE__*/ (0, _react.createContext)({
    current: null
});
const TitleIdContext = /*#__PURE__*/ (0, _react.createContext)(undefined);
const useTitleId = ()=>(0, _react.useContext)(TitleIdContext);
const TitleIdContextProvider = TitleIdContext.Provider;

},{"react":"ltHCL","@atlaskit/ds-lib/noop":"faKzG","@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"jT8vQ":[function(require,module,exports,__globalThis) {
/**
 * A symbol to collapse the `elemBefore` slot.
 * This should be placed in the `elemBefore` prop of supported menu items.
 */ var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "COLLAPSE_ELEM_BEFORE", ()=>COLLAPSE_ELEM_BEFORE);
const COLLAPSE_ELEM_BEFORE = Symbol('collapse-elem-before');

},{"@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"k2WnQ":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
/**
 * Scrolls the element into view once it is selected, and once all its ancestors (expandable
 * parent menu items) are expanded.
 *
 * Once that has happened, we don't want to scroll it into view again until it has been unselected.
 * This is to prevent the menu item from being scrolled into view again if the user collapses a
 * parent and then expands it again, without changing what menu item is selected.
 */ parcelHelpers.export(exports, "useScrollMenuItemIntoView", ()=>useScrollMenuItemIntoView);
var _react = require("react");
var _tinyInvariant = require("tiny-invariant");
var _tinyInvariantDefault = parcelHelpers.interopDefault(_tinyInvariant);
var _expandableMenuItemContext = require("./expandable-menu-item/expandable-menu-item-context");
function scrollMenuItemIntoView(element) {
    var // JSDOM does not support scrollIntoView, so defensively using it (see https://github.com/jsdom/jsdom/issues/1695)
    _element_scrollIntoView;
    /**
	 * If [scrollIntoViewIfNeeded](https://developer.mozilla.org/en-US/docs/Web/API/Element/scrollIntoViewIfNeeded) is available,
	 * we are using it to scroll the element into view _in the center_ of the scroll container. Because it is a non-standard method
	 * and not available on all browsers (currently not supported in Firefox), we are using it for progressive enhancement.
	 *
	 * Otherwise, we are falling back to [scrollIntoView](https://developer.mozilla.org/en-US/docs/Web/API/Element/scrollIntoView).
	 */ const elementWithScrollMethod = element;
    if (typeof elementWithScrollMethod.scrollIntoViewIfNeeded === 'function') {
        elementWithScrollMethod.scrollIntoViewIfNeeded(true);
        return;
    }
    (_element_scrollIntoView = element.scrollIntoView) === null || _element_scrollIntoView === void 0 ? void 0 : _element_scrollIntoView.call(element, {
        // We are using `nearest` to prevent scrolling on user interaction when the menu item is already in view.
        block: 'nearest'
    });
}
function useScrollMenuItemIntoView({ elementRef, isSelected }) {
    const areAllAncestorsExpanded = (0, _expandableMenuItemContext.useAreAllAncestorsExpanded)();
    const waitingStateRef = (0, _react.useRef)({
        type: 'waiting-to-be-selected-and-all-ancestors-expanded'
    });
    (0, _react.useEffect)(()=>{
        if (waitingStateRef.current.type === 'waiting-to-be-selected-and-all-ancestors-expanded') {
            const shouldScroll = areAllAncestorsExpanded && isSelected;
            if (!shouldScroll) return;
            const element = elementRef.current;
            (0, _tinyInvariantDefault.default)(element, 'Element ref must be set');
            scrollMenuItemIntoView(element);
            // Now that we are scrolled the menu item into view, we need to wait for the menu item to
            // be unselected before checking again.
            waitingStateRef.current.type = 'waiting-to-be-unselected';
            return;
        }
        if (waitingStateRef.current.type === 'waiting-to-be-unselected') {
            if (!isSelected) waitingStateRef.current.type = 'waiting-to-be-selected-and-all-ancestors-expanded';
            return;
        }
    }, [
        areAllAncestorsExpanded,
        elementRef,
        isSelected
    ]);
}

},{"react":"ltHCL","tiny-invariant":"9VWeJ","./expandable-menu-item/expandable-menu-item-context":"jqpKo","@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"6LZEK":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _environment = require("@atlassian/relay-environment-provider/environment");
exports.default = (0, _environment.__INTERNAL_RELAY_ENVIRONMENT__DO_NOT_USE_THIS_DIRECTLY__);

},{"@atlassian/relay-environment-provider/environment":"30bzq","@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"esRoT":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "createRelayResource", ()=>createRelayResource);
parcelHelpers.export(exports, "useRelayResource", ()=>useRelayResource);
var _objectSpread = require("@swc/helpers/_/_object_spread");
var _reactRelay = require("react-relay");
var _reactResourceRouterNext = require("react-resource-router-next");
var _relayEnvironment = require("./RelayEnvironment");
var _relayEnvironmentDefault = parcelHelpers.interopDefault(_relayEnvironment);
function createCacheKey(query, variables) {
    const queryId = 'cacheID' in query.params ? query.params.cacheID : query.params.id;
    return `relay-${queryId}-${query.params.name}-${JSON.stringify(variables !== null && variables !== void 0 ? variables : {})}`;
}
const createRelayResource = ({ getQuery, params })=>(0, _reactResourceRouterNext.createResource)((0, _objectSpread._)({
        type: 'RELAY_RESOURCE_TYPE',
        getKey: (routerContext, customContext)=>{
            const { query, variables, cacheKey } = getQuery(routerContext, customContext);
            return cacheKey !== null && cacheKey !== void 0 ? cacheKey : createCacheKey(query, variables);
        },
        getData: (routerContext, customContext)=>{
            const { query, variables, options } = getQuery(routerContext, customContext);
            // @ts-expect-error this is expected because ResourceStoreContext is interface to identify how context is injected, but unfortunately the type is hardcoded to {}
            const customRelayEnvironment = customContext === null || customContext === void 0 ? void 0 : customContext.relayEnvironment;
            const queryReference = (0, _reactRelay.loadQuery)(customRelayEnvironment !== null && customRelayEnvironment !== void 0 ? customRelayEnvironment : (0, _relayEnvironmentDefault.default), query, variables !== null && variables !== void 0 ? variables : {}, options);
            return Promise.resolve(queryReference);
        }
    }, params));
const useRelayResource = (resource)=>{
    const { data: queryReference } = (0, _reactResourceRouterNext.useResource)(resource);
    return {
        queryReference
    };
};

},{"@swc/helpers/_/_object_spread":"9gdrV","react-relay":"9HAyN","react-resource-router-next":"6gkfP","./RelayEnvironment":"6LZEK","@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"e71r5":[function(require,module,exports,__globalThis) {
/* index.tsx generated by @compiled/babel-plugin v0.39.1 */ var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "LoadingSpinner", ()=>LoadingSpinner);
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _compiled = require("@atlaskit/primitives/compiled");
var _spinner = require("@atlaskit/spinner");
var _spinnerDefault = parcelHelpers.interopDefault(_spinner);
const styles = {
    loadingSpinnerStyles: "_4t3i1osq"
};
const LoadingSpinner = (props)=>{
    return /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _compiled.Stack), {
        grow: "fill",
        alignBlock: "center",
        alignInline: "center",
        xcss: styles.loadingSpinnerStyles
    }, /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _spinnerDefault.default), props));
};

},{"react":"ltHCL","@atlaskit/primitives/compiled":"hDay7","@atlaskit/spinner":"l22fT","@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"b0Dsv":[function(require,module,exports,__globalThis) {
/* index.tsx generated by @compiled/babel-plugin v0.39.1 */ var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _objectSpread = require("@swc/helpers/_/_object_spread");
var _objectSpreadProps = require("@swc/helpers/_/_object_spread_props");
var _runtime = require("@compiled/react/runtime");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _debounce = require("lodash/debounce");
var _debounceDefault = parcelHelpers.interopDefault(_debounce);
var _reactIntl = require("react-intl");
var _analyticsNext = require("@atlaskit/analytics-next");
var _featureGateJsClient = require("@atlaskit/feature-gate-js-client");
var _featureGateJsClientDefault = parcelHelpers.interopDefault(_featureGateJsClient);
var _compiled = require("@atlaskit/primitives/compiled");
var _select = require("@atlaskit/select");
var _selectDefault = parcelHelpers.interopDefault(_select);
var _spinner = require("@atlaskit/spinner");
var _spinnerDefault = parcelHelpers.interopDefault(_spinner);
var _analyticsBridge = require("@atlassian/analytics-bridge");
var _atlassianStudioObservability = require("@atlassian/atlassian-studio-observability");
var _messages = require("./messages");
var _messagesDefault = parcelHelpers.interopDefault(_messages);
var _useAsync = require("./use-async");
var _useAsyncDefault = parcelHelpers.interopDefault(_useAsync);
const styles = {
    optionTextWrapper: "_19bvv77o",
    customAvatarContainer: "_12ji1r31 _1qu2glyw _12y3idpf _1e0c1o8l _kqswh2mm",
    customAvatarImg: "_16jlkb7n _1o9zkb7n _i0dl1osq _1e0c1txw _1bsb1osq _4t3i1osq",
    selectMenu: "_1pbyb4wl"
};
const customAvatarInnerContainer = null;
const CustomAvatar = ({ src })=>/*#__PURE__*/ (0, _reactDefault.default).createElement((0, _compiled.Box), {
        as: "div",
        xcss: styles.customAvatarContainer
    }, /*#__PURE__*/ (0, _reactDefault.default).createElement("div", {
        className: (0, _runtime.ax)([
            "_19itglyw _12ji1r31 _1qu2glyw _12y31o36 _1reo15vq _18m915vq _v564ieh6 _2rko12b0 _1e0c1txw _vchh1ntv _kqswpfqs _1ar41fhb _4cvr1fhb _5i9v1h6o _1bah1h6o _2lx21bp4 _80om1kw7 _6rthv77o _1pfhv77o _12l2v77o _ahbqv77o _1bsbgktf _4t3igktf"
        ])
    }, /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _compiled.Box), {
        as: "img",
        src: src,
        xcss: styles.customAvatarImg,
        alt: ""
    })));
const CustomOption = (props)=>/*#__PURE__*/ (0, _reactDefault.default).createElement((0, _select.components).Option, props, /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _compiled.Inline), {
        alignBlock: "center",
        space: "space.025"
    }, /*#__PURE__*/ (0, _reactDefault.default).createElement(CustomAvatar, {
        src: props.data.iconUrl
    }), /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _compiled.Box), {
        xcss: styles.optionTextWrapper
    }, /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _compiled.Text), null, props.data.displayName))));
const CustomGroupHeading = (props)=>/*#__PURE__*/ (0, _reactDefault.default).createElement((0, _select.components).GroupHeading, props, /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _compiled.Text), {
        color: "color.text.subtle",
        weight: "bold",
        size: "small"
    }, props.data.label));
const CustomSingleValue = (props)=>/*#__PURE__*/ (0, _reactDefault.default).createElement((0, _select.components).SingleValue, props, /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _compiled.Inline), {
        alignBlock: "center",
        space: "space.025"
    }, /*#__PURE__*/ (0, _reactDefault.default).createElement(CustomAvatar, {
        src: props.data.iconUrl
    }), /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _compiled.Box), {
        xcss: styles.optionTextWrapper
    }, /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _compiled.Text), null, props.data.displayName))));
const Picker = ({ resolver, onChange, onError, cloudId, placeholder, idKey, postChange, actionSubjectId, menuPosition })=>{
    const { formatMessage } = (0, _reactIntl.useIntl)();
    const [errorText, setErrorText] = (0, _react.useState)();
    const [endCursor, setEndCursor] = (0, _react.useState)(undefined);
    const [searchValue, setSearchValue] = (0, _react.useState)('');
    const [allOptions, setAllOptions] = (0, _react.useState)([]);
    const cache = (0, _react.useRef)({});
    const { createAnalyticsEvent } = (0, _analyticsNext.useAnalyticsEvents)();
    const loadOptions = (0, _react.useCallback)(async (queryCursor)=>{
        // Don't want to mix up user search and pagination as they both use this callback
        if (actionSubjectId && queryCursor === undefined && searchValue) (0, _analyticsBridge.fireUIAnalytics)(createAnalyticsEvent({}), (0, _atlassianStudioObservability.getUIEventName)((0, _atlassianStudioObservability.UIActionSubject).PICKER, (0, _atlassianStudioObservability.Action).SEARCH), actionSubjectId, {
            searchTerm: searchValue
        });
        if (actionSubjectId && queryCursor) (0, _analyticsBridge.fireUIAnalytics)(createAnalyticsEvent({}), (0, _atlassianStudioObservability.getUIEventName)((0, _atlassianStudioObservability.UIActionSubject).PICKER, (0, _atlassianStudioObservability.Action).PAGINATE), actionSubjectId);
        try {
            let data = cache.current[searchValue];
            if (data && queryCursor !== data.queryEndCursor) resolver(cloudId, searchValue, queryCursor).then((newData)=>{
                cache.current[searchValue] = newData;
            }).catch((err)=>{
                throw err;
            });
            else {
                data = await resolver(cloudId, searchValue, queryCursor);
                cache.current[searchValue] = data;
            }
            const { starred, all, queryEndCursor } = data;
            setEndCursor(queryEndCursor);
            setAllOptions((prev)=>{
                if (queryCursor) return [
                    {
                        label: formatMessage((0, _messagesDefault.default).starred),
                        options: starred
                    },
                    {
                        label: formatMessage((0, _messagesDefault.default).all),
                        options: [
                            ...prev[1].options,
                            ...all
                        ]
                    }
                ];
                return [
                    {
                        label: formatMessage((0, _messagesDefault.default).starred),
                        options: starred
                    },
                    {
                        label: formatMessage((0, _messagesDefault.default).all),
                        options: all
                    }
                ];
            });
        } catch (e) {
            setErrorText(onError(e));
            setEndCursor(undefined);
        }
    }, [
        actionSubjectId,
        createAnalyticsEvent,
        searchValue,
        resolver,
        cloudId,
        formatMessage,
        onError
    ]);
    const optionsResponse = (0, _useAsyncDefault.default)(loadOptions);
    const [loading, setLoading] = (0, _react.useState)(false);
    const handleOnChange = (0, _react.useCallback)((newValue)=>{
        setErrorText(onChange(newValue));
        if (postChange) {
            setLoading(true);
            postChange(newValue).then(()=>setLoading(false)).catch((e)=>{
                setLoading(false);
                setErrorText(onError(e));
            });
        }
    }, [
        onChange,
        postChange,
        onError
    ]);
    const Group = (props)=>{
        const componentRef = (0, _react.useRef)(null);
        (0, _react.useEffect)(()=>{
            const observer = new IntersectionObserver(([entry])=>{
                if (entry.isIntersecting) loadOptions(endCursor);
            });
            if (componentRef.current !== null) // Start observing the element
            observer.observe(componentRef.current);
            return ()=>observer.disconnect();
        }, [
            componentRef
        ]);
        return /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _reactDefault.default).Fragment, null, /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _select.components).Group, props), props.data.label === formatMessage((0, _messagesDefault.default).all) && endCursor && /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _compiled.Flex), {
            justifyContent: "center"
        }, /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _spinnerDefault.default), {
            ref: componentRef
        })));
    };
    return /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _compiled.Stack), {
        testId: idKey,
        space: "space.050"
    }, /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _selectDefault.default), {
        filterOption: ()=>true,
        isLoading: optionsResponse.state === 'loading',
        options: optionsResponse.state === 'success' ? allOptions : [],
        placeholder: placeholder,
        components: {
            MenuPortal: (props)=>/*#__PURE__*/ (0, _reactDefault.default).createElement((0, _select.components).MenuPortal, (0, _objectSpreadProps._)((0, _objectSpread._)({}, props), {
                    xcss: styles.selectMenu
                })),
            SingleValue: CustomSingleValue,
            Option: CustomOption,
            GroupHeading: CustomGroupHeading,
            Group
        },
        onChange: handleOnChange,
        onInputChange: (0, _debounceDefault.default)((newValue)=>setSearchValue(newValue), 200),
        key: idKey,
        label: formatMessage((0, _featureGateJsClientDefault.default).getExperimentValue('project-terminology-refresh', 'isEnabled', false) ? (0, _messagesDefault.default).pickerLabelGalaxia : (0, _messagesDefault.default).pickerLabel),
        onMenuOpen: ()=>{
            if (actionSubjectId) (0, _analyticsBridge.fireUIAnalytics)(createAnalyticsEvent({}), (0, _atlassianStudioObservability.getUIEventName)((0, _atlassianStudioObservability.UIActionSubject).PICKER, (0, _atlassianStudioObservability.Action).OPENED), actionSubjectId);
        },
        menuPosition: menuPosition
    }), loading && /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _spinnerDefault.default), {
        size: "small"
    }), errorText);
};
exports.default = Picker;

},{"@swc/helpers/_/_object_spread":"9gdrV","@swc/helpers/_/_object_spread_props":"kANqQ","@compiled/react/runtime":"d27Vo","react":"ltHCL","lodash/debounce":"gdA7W","react-intl":"f41fF","@atlaskit/analytics-next":"6PLie","@atlaskit/feature-gate-js-client":"27dQF","@atlaskit/primitives/compiled":"hDay7","@atlaskit/select":"fHdYI","@atlaskit/spinner":"l22fT","@atlassian/analytics-bridge":"6YOyH","@atlassian/atlassian-studio-observability":"5cVsH","./messages":"fPVHh","./use-async":"cJ4zy","@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"gdA7W":[function(require,module,exports,__globalThis) {
var isObject = require("e337d617b5b03a8"), now = require("ba51d6fa7072fd81"), toNumber = require("b8c715f7da13be9e");
/** Error message constants. */ var FUNC_ERROR_TEXT = 'Expected a function';
/* Built-in method references for those with the same name as other `lodash` methods. */ var nativeMax = Math.max, nativeMin = Math.min;
/**
 * Creates a debounced function that delays invoking `func` until after `wait`
 * milliseconds have elapsed since the last time the debounced function was
 * invoked. The debounced function comes with a `cancel` method to cancel
 * delayed `func` invocations and a `flush` method to immediately invoke them.
 * Provide `options` to indicate whether `func` should be invoked on the
 * leading and/or trailing edge of the `wait` timeout. The `func` is invoked
 * with the last arguments provided to the debounced function. Subsequent
 * calls to the debounced function return the result of the last `func`
 * invocation.
 *
 * **Note:** If `leading` and `trailing` options are `true`, `func` is
 * invoked on the trailing edge of the timeout only if the debounced function
 * is invoked more than once during the `wait` timeout.
 *
 * If `wait` is `0` and `leading` is `false`, `func` invocation is deferred
 * until to the next tick, similar to `setTimeout` with a timeout of `0`.
 *
 * See [David Corbacho's article](https://css-tricks.com/debouncing-throttling-explained-examples/)
 * for details over the differences between `_.debounce` and `_.throttle`.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Function
 * @param {Function} func The function to debounce.
 * @param {number} [wait=0] The number of milliseconds to delay.
 * @param {Object} [options={}] The options object.
 * @param {boolean} [options.leading=false]
 *  Specify invoking on the leading edge of the timeout.
 * @param {number} [options.maxWait]
 *  The maximum time `func` is allowed to be delayed before it's invoked.
 * @param {boolean} [options.trailing=true]
 *  Specify invoking on the trailing edge of the timeout.
 * @returns {Function} Returns the new debounced function.
 * @example
 *
 * // Avoid costly calculations while the window size is in flux.
 * jQuery(window).on('resize', _.debounce(calculateLayout, 150));
 *
 * // Invoke `sendMail` when clicked, debouncing subsequent calls.
 * jQuery(element).on('click', _.debounce(sendMail, 300, {
 *   'leading': true,
 *   'trailing': false
 * }));
 *
 * // Ensure `batchLog` is invoked once after 1 second of debounced calls.
 * var debounced = _.debounce(batchLog, 250, { 'maxWait': 1000 });
 * var source = new EventSource('/stream');
 * jQuery(source).on('message', debounced);
 *
 * // Cancel the trailing debounced invocation.
 * jQuery(window).on('popstate', debounced.cancel);
 */ function debounce(func, wait, options) {
    var lastArgs, lastThis, maxWait, result, timerId, lastCallTime, lastInvokeTime = 0, leading = false, maxing = false, trailing = true;
    if (typeof func != 'function') throw new TypeError(FUNC_ERROR_TEXT);
    wait = toNumber(wait) || 0;
    if (isObject(options)) {
        leading = !!options.leading;
        maxing = 'maxWait' in options;
        maxWait = maxing ? nativeMax(toNumber(options.maxWait) || 0, wait) : maxWait;
        trailing = 'trailing' in options ? !!options.trailing : trailing;
    }
    function invokeFunc(time) {
        var args = lastArgs, thisArg = lastThis;
        lastArgs = lastThis = undefined;
        lastInvokeTime = time;
        result = func.apply(thisArg, args);
        return result;
    }
    function leadingEdge(time) {
        // Reset any `maxWait` timer.
        lastInvokeTime = time;
        // Start the timer for the trailing edge.
        if (typeof setTimeout !== 'undefined') timerId = setTimeout(timerExpired, wait);
        // Invoke the leading edge.
        return leading ? invokeFunc(time) : result;
    }
    function remainingWait(time) {
        var timeSinceLastCall = time - lastCallTime, timeSinceLastInvoke = time - lastInvokeTime, timeWaiting = wait - timeSinceLastCall;
        return maxing ? nativeMin(timeWaiting, maxWait - timeSinceLastInvoke) : timeWaiting;
    }
    function shouldInvoke(time) {
        var timeSinceLastCall = time - lastCallTime, timeSinceLastInvoke = time - lastInvokeTime;
        // Either this is the first call, activity has stopped and we're at the
        // trailing edge, the system time has gone backwards and we're treating
        // it as the trailing edge, or we've hit the `maxWait` limit.
        return lastCallTime === undefined || timeSinceLastCall >= wait || timeSinceLastCall < 0 || maxing && timeSinceLastInvoke >= maxWait;
    }
    function timerExpired() {
        var time = now();
        if (shouldInvoke(time)) return trailingEdge(time);
        // Restart the timer.
        timerId = setTimeout(timerExpired, remainingWait(time));
    }
    function trailingEdge(time) {
        timerId = undefined;
        // Only invoke if we have `lastArgs` which means `func` has been
        // debounced at least once.
        if (trailing && lastArgs) return invokeFunc(time);
        lastArgs = lastThis = undefined;
        return result;
    }
    function cancel() {
        if (timerId !== undefined) clearTimeout(timerId);
        lastInvokeTime = 0;
        lastArgs = lastCallTime = lastThis = timerId = undefined;
    }
    function flush() {
        return timerId === undefined ? result : trailingEdge(now());
    }
    function debounced() {
        var time = now(), isInvoking = shouldInvoke(time);
        lastArgs = arguments;
        lastThis = this;
        lastCallTime = time;
        if (isInvoking) {
            if (timerId === undefined) return leadingEdge(lastCallTime);
            if (maxing) {
                // Handle invocations in a tight loop.
                clearTimeout(timerId);
                timerId = setTimeout(timerExpired, wait);
                return invokeFunc(lastCallTime);
            }
        }
        if (timerId === undefined) timerId = setTimeout(timerExpired, wait);
        return result;
    }
    debounced.cancel = cancel;
    debounced.flush = flush;
    return debounced;
}
module.exports = debounce;

},{"e337d617b5b03a8":"cGl8g","ba51d6fa7072fd81":"jXMWY","b8c715f7da13be9e":"1esAR"}],"jXMWY":[function(require,module,exports,__globalThis) {
var root = require("337f80f0c035e121");
/**
 * Gets the timestamp of the number of milliseconds that have elapsed since
 * the Unix epoch (1 January 1970 00:00:00 UTC).
 *
 * @static
 * @memberOf _
 * @since 2.4.0
 * @category Date
 * @returns {number} Returns the timestamp.
 * @example
 *
 * _.defer(function(stamp) {
 *   console.log(_.now() - stamp);
 * }, _.now());
 * // => Logs the number of milliseconds it took for the deferred invocation.
 */ var now = function() {
    return root.Date.now();
};
module.exports = now;

},{"337f80f0c035e121":"J0J3B"}],"1esAR":[function(require,module,exports,__globalThis) {
var baseTrim = require("946437eaadbad32b"), isObject = require("322ead457b70ede7"), isSymbol = require("6182b60f88d2bc7e");
/** Used as references for various `Number` constants. */ var NAN = 0 / 0;
/** Used to detect bad signed hexadecimal string values. */ var reIsBadHex = /^[-+]0x[0-9a-f]+$/i;
/** Used to detect binary string values. */ var reIsBinary = /^0b[01]+$/i;
/** Used to detect octal string values. */ var reIsOctal = /^0o[0-7]+$/i;
/** Built-in method references without a dependency on `root`. */ var freeParseInt = parseInt;
/**
 * Converts `value` to a number.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to process.
 * @returns {number} Returns the number.
 * @example
 *
 * _.toNumber(3.2);
 * // => 3.2
 *
 * _.toNumber(Number.MIN_VALUE);
 * // => 5e-324
 *
 * _.toNumber(Infinity);
 * // => Infinity
 *
 * _.toNumber('3.2');
 * // => 3.2
 */ function toNumber(value) {
    if (typeof value == 'number') return value;
    if (isSymbol(value)) return NAN;
    if (isObject(value)) {
        var other = typeof value.valueOf == 'function' ? value.valueOf() : value;
        value = isObject(other) ? other + '' : other;
    }
    if (typeof value != 'string') return value === 0 ? value : +value;
    value = baseTrim(value);
    var isBinary = reIsBinary.test(value);
    return isBinary || reIsOctal.test(value) ? freeParseInt(value.slice(2), isBinary ? 2 : 8) : reIsBadHex.test(value) ? NAN : +value;
}
module.exports = toNumber;

},{"946437eaadbad32b":"4bZeX","322ead457b70ede7":"cGl8g","6182b60f88d2bc7e":"iaMVe"}],"4bZeX":[function(require,module,exports,__globalThis) {
var trimmedEndIndex = require("112583361aa4af76");
/** Used to match leading whitespace. */ var reTrimStart = /^\s+/;
/**
 * The base implementation of `_.trim`.
 *
 * @private
 * @param {string} string The string to trim.
 * @returns {string} Returns the trimmed string.
 */ function baseTrim(string) {
    return string ? string.slice(0, trimmedEndIndex(string) + 1).replace(reTrimStart, '') : string;
}
module.exports = baseTrim;

},{"112583361aa4af76":"8hAcp"}],"8hAcp":[function(require,module,exports,__globalThis) {
/** Used to match a single whitespace character. */ var reWhitespace = /\s/;
/**
 * Used by `_.trim` and `_.trimEnd` to get the index of the last non-whitespace
 * character of `string`.
 *
 * @private
 * @param {string} string The string to inspect.
 * @returns {number} Returns the index of the last non-whitespace character.
 */ function trimmedEndIndex(string) {
    var index = string.length;
    while(index-- && reWhitespace.test(string.charAt(index)));
    return index;
}
module.exports = trimmedEndIndex;

},{}],"fHdYI":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "components", ()=>(0, _reactSelect.components));
parcelHelpers.export(exports, "createFilter", ()=>(0, _reactSelect.createFilter));
parcelHelpers.export(exports, "mergeStyles", ()=>(0, _reactSelect.mergeStyles));
parcelHelpers.export(exports, "useAsync", ()=>(0, _useAsync.useAsync));
parcelHelpers.export(exports, "useCreatable", ()=>(0, _useCreatable.useCreatable));
parcelHelpers.export(exports, "CheckboxOption", ()=>(0, _checkboxOption.CheckboxOption));
parcelHelpers.export(exports, "RadioOption", ()=>(0, _radioOption.RadioOption));
parcelHelpers.export(exports, "default", ()=>(0, _selectDefault.default));
parcelHelpers.export(exports, "SelectWithoutAnalytics", ()=>(0, _select.SelectWithoutAnalytics));
parcelHelpers.export(exports, "AsyncSelect", ()=>(0, _asyncSelectDefault.default));
parcelHelpers.export(exports, "CreatableSelect", ()=>(0, _creatableSelectDefault.default));
parcelHelpers.export(exports, "AsyncCreatableSelect", ()=>(0, _asyncCreatableSelectDefault.default));
parcelHelpers.export(exports, "isOptionsGrouped", ()=>(0, _groupedOptionsAnnouncement.isOptionsGrouped));
parcelHelpers.export(exports, "CheckboxSelect", ()=>(0, _checkboxSelectDefault.default));
parcelHelpers.export(exports, "CountrySelect", ()=>(0, _countrySelectDefault.default));
parcelHelpers.export(exports, "RadioSelect", ()=>(0, _radioSelectDefault.default));
parcelHelpers.export(exports, "PopupSelect", ()=>(0, _popupSelectDefault.default));
var _reactSelect = require("./entry-points/react-select");
var _useAsync = require("./entry-points/use-async");
var _useCreatable = require("./entry-points/use-creatable");
var _checkboxOption = require("./components/checkbox-option");
var _radioOption = require("./components/radio-option");
var _select = require("./entry-points/select");
var _selectDefault = parcelHelpers.interopDefault(_select);
var _asyncSelect = require("./entry-points/async-select");
var _asyncSelectDefault = parcelHelpers.interopDefault(_asyncSelect);
var _creatableSelect = require("./entry-points/creatable-select");
var _creatableSelectDefault = parcelHelpers.interopDefault(_creatableSelect);
var _asyncCreatableSelect = require("./entry-points/async-creatable-select");
var _asyncCreatableSelectDefault = parcelHelpers.interopDefault(_asyncCreatableSelect);
var _groupedOptionsAnnouncement = require("./utils/grouped-options-announcement");
var _checkboxSelect = require("./checkbox-select");
var _checkboxSelectDefault = parcelHelpers.interopDefault(_checkboxSelect);
var _countrySelect = require("./country-select");
var _countrySelectDefault = parcelHelpers.interopDefault(_countrySelect);
var _radioSelect = require("./radio-select");
var _radioSelectDefault = parcelHelpers.interopDefault(_radioSelect);
var _popupSelect = require("./popup-select");
var _popupSelectDefault = parcelHelpers.interopDefault(_popupSelect);
 /**
 * Types not exported on the public API, didn't find usages in sourcegraph
 *
 * CreatableSelectProps,
 */ 
},{"./entry-points/react-select":"aodDR","./entry-points/use-async":false,"./entry-points/use-creatable":false,"./components/checkbox-option":"1DPMh","./components/radio-option":false,"./entry-points/select":"22Mwt","./entry-points/async-select":"9nPxS","./entry-points/creatable-select":"hbqN0","./entry-points/async-creatable-select":"3sluj","./utils/grouped-options-announcement":"7BMTy","./checkbox-select":"kXKpJ","./country-select":false,"./radio-select":"5IoCq","./popup-select":"MRq2B","@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"aodDR":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "components", ()=>(0, _reactSelect.components));
parcelHelpers.export(exports, "createFilter", ()=>(0, _reactSelect.createFilter));
parcelHelpers.export(exports, "mergeStyles", ()=>(0, _reactSelect.mergeStyles));
var _reactSelect = require("@atlaskit/react-select");

},{"@atlaskit/react-select":"1iF04","@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"1iF04":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>(0, _stateManagerDefault.default));
parcelHelpers.export(exports, "mergeStyles", ()=>(0, _styles.mergeStyles));
parcelHelpers.export(exports, "createFilter", ()=>(0, _filters.createFilter));
parcelHelpers.export(exports, "components", ()=>(0, _components.components));
parcelHelpers.export(exports, "useStateManager", ()=>(0, _useStateManagerDefault.default));
var _useStateManager = require("./use-state-manager");
var _useStateManagerDefault = parcelHelpers.interopDefault(_useStateManager);
var _stateManager = require("./state-manager");
var _stateManagerDefault = parcelHelpers.interopDefault(_stateManager);
var _styles = require("./styles");
var _filters = require("./filters");
var _components = require("./components");

},{"./use-state-manager":false,"./state-manager":false,"./styles":"e13u0","./filters":"2zLE8","./components":"9ys8n","@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"2tgTy":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>useStateManager);
var _objectSpread = require("@swc/helpers/_/_object_spread");
var _objectSpreadProps = require("@swc/helpers/_/_object_spread_props");
var _objectWithoutProperties = require("@swc/helpers/_/_object_without_properties");
var _react = require("react");
function useStateManager(_param) {
    var { defaultInputValue = '', defaultMenuIsOpen = false, defaultValue = null, inputValue: propsInputValue, menuIsOpen: propsMenuIsOpen, onChange: propsOnChange, onInputChange: propsOnInputChange, onMenuClose: propsOnMenuClose, onMenuOpen: propsOnMenuOpen, value: propsValue } = _param, restSelectProps = (0, _objectWithoutProperties._)(_param, [
        "defaultInputValue",
        "defaultMenuIsOpen",
        "defaultValue",
        "inputValue",
        "menuIsOpen",
        "onChange",
        "onInputChange",
        "onMenuClose",
        "onMenuOpen",
        "value"
    ]);
    const [stateInputValue, setStateInputValue] = (0, _react.useState)(propsInputValue !== undefined ? propsInputValue : defaultInputValue);
    const [stateMenuIsOpen, setStateMenuIsOpen] = (0, _react.useState)(propsMenuIsOpen !== undefined ? propsMenuIsOpen : defaultMenuIsOpen);
    const [stateValue, setStateValue] = (0, _react.useState)(propsValue !== undefined ? propsValue : defaultValue);
    const onChange = (0, _react.useCallback)((value, actionMeta)=>{
        if (typeof propsOnChange === 'function') propsOnChange(value, actionMeta);
        setStateValue(value);
    }, [
        propsOnChange
    ]);
    const onInputChange = (0, _react.useCallback)((value, actionMeta)=>{
        let newValue;
        if (typeof propsOnInputChange === 'function') newValue = propsOnInputChange(value, actionMeta);
        setStateInputValue(newValue !== undefined ? newValue : value);
    }, [
        propsOnInputChange
    ]);
    const onMenuOpen = (0, _react.useCallback)(()=>{
        if (typeof propsOnMenuOpen === 'function') propsOnMenuOpen();
        setStateMenuIsOpen(true);
    }, [
        propsOnMenuOpen
    ]);
    const onMenuClose = (0, _react.useCallback)(()=>{
        if (typeof propsOnMenuClose === 'function') propsOnMenuClose();
        setStateMenuIsOpen(false);
    }, [
        propsOnMenuClose
    ]);
    const inputValue = propsInputValue !== undefined ? propsInputValue : stateInputValue;
    const menuIsOpen = propsMenuIsOpen !== undefined ? propsMenuIsOpen : stateMenuIsOpen;
    const value = propsValue !== undefined ? propsValue : stateValue;
    //@ts-ignore react-select unsupported props
    return (0, _objectSpreadProps._)((0, _objectSpread._)({}, restSelectProps), {
        inputValue,
        menuIsOpen,
        onChange,
        onInputChange,
        onMenuClose,
        onMenuOpen,
        value
    });
}

},{"@swc/helpers/_/_object_spread":"9gdrV","@swc/helpers/_/_object_spread_props":"kANqQ","@swc/helpers/_/_object_without_properties":"6HqIM","react":"ltHCL","@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"e13u0":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
// Merge Utility
// Allows consumers to extend a base Select with additional styles
parcelHelpers.export(exports, "mergeStyles", ()=>mergeStyles);
var _objectSpread = require("@swc/helpers/_/_object_spread");
function mergeStyles(source, target = {}) {
    // initialize with source styles
    const styles = (0, _objectSpread._)({}, source);
    // massage in target styles
    Object.keys(target).forEach((keyAsString)=>{
        const key = keyAsString;
        if (source[key]) styles[key] = (rsCss, props)=>{
            return target[key](source[key](rsCss, props), props);
        };
        else styles[key] = target[key];
    });
    return styles;
}

},{"@swc/helpers/_/_object_spread":"9gdrV","@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"2zLE8":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "createFilter", ()=>createFilter);
var _objectSpread = require("@swc/helpers/_/_object_spread");
var _memoizeOne = require("memoize-one");
var _memoizeOneDefault = parcelHelpers.interopDefault(_memoizeOne);
var _diacritics = require("./diacritics");
const memoizedStripDiacriticsForInput = (0, _memoizeOneDefault.default)((0, _diacritics.stripDiacritics));
const trimString = (str)=>str.replace(/^\s+|\s+$/g, '');
const defaultStringify = (option)=>`${option.label} ${option.value}`;
const createFilter = (config)=>(option, rawInput)=>{
        if (option.data.__isNew__) return true;
        const { ignoreCase, ignoreAccents, stringify, trim, matchFrom } = (0, _objectSpread._)({
            ignoreCase: true,
            ignoreAccents: true,
            stringify: defaultStringify,
            trim: true,
            matchFrom: 'any'
        }, config);
        let input = trim ? trimString(rawInput) : rawInput;
        let candidate = trim ? trimString(stringify(option)) : stringify(option);
        if (ignoreCase) {
            input = input.toLowerCase();
            candidate = candidate.toLowerCase();
        }
        if (ignoreAccents) {
            input = memoizedStripDiacriticsForInput(input);
            candidate = (0, _diacritics.stripDiacritics)(candidate);
        }
        return matchFrom === 'start' ? candidate.substr(0, input.length) === input : candidate.indexOf(input) > -1;
    };

},{"@swc/helpers/_/_object_spread":"9gdrV","memoize-one":"5rJro","./diacritics":"lulbU","@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"lulbU":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "stripDiacritics", ()=>stripDiacritics);
const diacritics = [
    {
        base: 'A',
        letters: '\u0041\u24B6\uFF21\u00C0\u00C1\u00C2\u1EA6\u1EA4\u1EAA\u1EA8\u00C3\u0100\u0102\u1EB0\u1EAE\u1EB4\u1EB2\u0226\u01E0\u00C4\u01DE\u1EA2\u00C5\u01FA\u01CD\u0200\u0202\u1EA0\u1EAC\u1EB6\u1E00\u0104\u023A\u2C6F'
    },
    {
        base: 'AA',
        letters: '\uA732'
    },
    {
        base: 'AE',
        letters: '\u00C6\u01FC\u01E2'
    },
    {
        base: 'AO',
        letters: '\uA734'
    },
    {
        base: 'AU',
        letters: '\uA736'
    },
    {
        base: 'AV',
        letters: '\uA738\uA73A'
    },
    {
        base: 'AY',
        letters: '\uA73C'
    },
    {
        base: 'B',
        letters: '\u0042\u24B7\uFF22\u1E02\u1E04\u1E06\u0243\u0182\u0181'
    },
    {
        base: 'C',
        letters: '\u0043\u24B8\uFF23\u0106\u0108\u010A\u010C\u00C7\u1E08\u0187\u023B\uA73E'
    },
    {
        base: 'D',
        letters: '\u0044\u24B9\uFF24\u1E0A\u010E\u1E0C\u1E10\u1E12\u1E0E\u0110\u018B\u018A\u0189\uA779'
    },
    {
        base: 'DZ',
        letters: '\u01F1\u01C4'
    },
    {
        base: 'Dz',
        letters: '\u01F2\u01C5'
    },
    {
        base: 'E',
        letters: '\u0045\u24BA\uFF25\u00C8\u00C9\u00CA\u1EC0\u1EBE\u1EC4\u1EC2\u1EBC\u0112\u1E14\u1E16\u0114\u0116\u00CB\u1EBA\u011A\u0204\u0206\u1EB8\u1EC6\u0228\u1E1C\u0118\u1E18\u1E1A\u0190\u018E'
    },
    {
        base: 'F',
        letters: '\u0046\u24BB\uFF26\u1E1E\u0191\uA77B'
    },
    {
        base: 'G',
        letters: '\u0047\u24BC\uFF27\u01F4\u011C\u1E20\u011E\u0120\u01E6\u0122\u01E4\u0193\uA7A0\uA77D\uA77E'
    },
    {
        base: 'H',
        letters: '\u0048\u24BD\uFF28\u0124\u1E22\u1E26\u021E\u1E24\u1E28\u1E2A\u0126\u2C67\u2C75\uA78D'
    },
    {
        base: 'I',
        letters: '\u0049\u24BE\uFF29\u00CC\u00CD\u00CE\u0128\u012A\u012C\u0130\u00CF\u1E2E\u1EC8\u01CF\u0208\u020A\u1ECA\u012E\u1E2C\u0197'
    },
    {
        base: 'J',
        letters: '\u004A\u24BF\uFF2A\u0134\u0248'
    },
    {
        base: 'K',
        letters: '\u004B\u24C0\uFF2B\u1E30\u01E8\u1E32\u0136\u1E34\u0198\u2C69\uA740\uA742\uA744\uA7A2'
    },
    {
        base: 'L',
        letters: '\u004C\u24C1\uFF2C\u013F\u0139\u013D\u1E36\u1E38\u013B\u1E3C\u1E3A\u0141\u023D\u2C62\u2C60\uA748\uA746\uA780'
    },
    {
        base: 'LJ',
        letters: '\u01C7'
    },
    {
        base: 'Lj',
        letters: '\u01C8'
    },
    {
        base: 'M',
        letters: '\u004D\u24C2\uFF2D\u1E3E\u1E40\u1E42\u2C6E\u019C'
    },
    {
        base: 'N',
        letters: '\u004E\u24C3\uFF2E\u01F8\u0143\u00D1\u1E44\u0147\u1E46\u0145\u1E4A\u1E48\u0220\u019D\uA790\uA7A4'
    },
    {
        base: 'NJ',
        letters: '\u01CA'
    },
    {
        base: 'Nj',
        letters: '\u01CB'
    },
    {
        base: 'O',
        letters: '\u004F\u24C4\uFF2F\u00D2\u00D3\u00D4\u1ED2\u1ED0\u1ED6\u1ED4\u00D5\u1E4C\u022C\u1E4E\u014C\u1E50\u1E52\u014E\u022E\u0230\u00D6\u022A\u1ECE\u0150\u01D1\u020C\u020E\u01A0\u1EDC\u1EDA\u1EE0\u1EDE\u1EE2\u1ECC\u1ED8\u01EA\u01EC\u00D8\u01FE\u0186\u019F\uA74A\uA74C'
    },
    {
        base: 'OI',
        letters: '\u01A2'
    },
    {
        base: 'OO',
        letters: '\uA74E'
    },
    {
        base: 'OU',
        letters: '\u0222'
    },
    {
        base: 'P',
        letters: '\u0050\u24C5\uFF30\u1E54\u1E56\u01A4\u2C63\uA750\uA752\uA754'
    },
    {
        base: 'Q',
        letters: '\u0051\u24C6\uFF31\uA756\uA758\u024A'
    },
    {
        base: 'R',
        letters: '\u0052\u24C7\uFF32\u0154\u1E58\u0158\u0210\u0212\u1E5A\u1E5C\u0156\u1E5E\u024C\u2C64\uA75A\uA7A6\uA782'
    },
    {
        base: 'S',
        letters: '\u0053\u24C8\uFF33\u1E9E\u015A\u1E64\u015C\u1E60\u0160\u1E66\u1E62\u1E68\u0218\u015E\u2C7E\uA7A8\uA784'
    },
    {
        base: 'T',
        letters: '\u0054\u24C9\uFF34\u1E6A\u0164\u1E6C\u021A\u0162\u1E70\u1E6E\u0166\u01AC\u01AE\u023E\uA786'
    },
    {
        base: 'TZ',
        letters: '\uA728'
    },
    {
        base: 'U',
        letters: '\u0055\u24CA\uFF35\u00D9\u00DA\u00DB\u0168\u1E78\u016A\u1E7A\u016C\u00DC\u01DB\u01D7\u01D5\u01D9\u1EE6\u016E\u0170\u01D3\u0214\u0216\u01AF\u1EEA\u1EE8\u1EEE\u1EEC\u1EF0\u1EE4\u1E72\u0172\u1E76\u1E74\u0244'
    },
    {
        base: 'V',
        letters: '\u0056\u24CB\uFF36\u1E7C\u1E7E\u01B2\uA75E\u0245'
    },
    {
        base: 'VY',
        letters: '\uA760'
    },
    {
        base: 'W',
        letters: '\u0057\u24CC\uFF37\u1E80\u1E82\u0174\u1E86\u1E84\u1E88\u2C72'
    },
    {
        base: 'X',
        letters: '\u0058\u24CD\uFF38\u1E8A\u1E8C'
    },
    {
        base: 'Y',
        letters: '\u0059\u24CE\uFF39\u1EF2\u00DD\u0176\u1EF8\u0232\u1E8E\u0178\u1EF6\u1EF4\u01B3\u024E\u1EFE'
    },
    {
        base: 'Z',
        letters: '\u005A\u24CF\uFF3A\u0179\u1E90\u017B\u017D\u1E92\u1E94\u01B5\u0224\u2C7F\u2C6B\uA762'
    },
    {
        base: 'a',
        letters: '\u0061\u24D0\uFF41\u1E9A\u00E0\u00E1\u00E2\u1EA7\u1EA5\u1EAB\u1EA9\u00E3\u0101\u0103\u1EB1\u1EAF\u1EB5\u1EB3\u0227\u01E1\u00E4\u01DF\u1EA3\u00E5\u01FB\u01CE\u0201\u0203\u1EA1\u1EAD\u1EB7\u1E01\u0105\u2C65\u0250'
    },
    {
        base: 'aa',
        letters: '\uA733'
    },
    {
        base: 'ae',
        letters: '\u00E6\u01FD\u01E3'
    },
    {
        base: 'ao',
        letters: '\uA735'
    },
    {
        base: 'au',
        letters: '\uA737'
    },
    {
        base: 'av',
        letters: '\uA739\uA73B'
    },
    {
        base: 'ay',
        letters: '\uA73D'
    },
    {
        base: 'b',
        letters: '\u0062\u24D1\uFF42\u1E03\u1E05\u1E07\u0180\u0183\u0253'
    },
    {
        base: 'c',
        letters: '\u0063\u24D2\uFF43\u0107\u0109\u010B\u010D\u00E7\u1E09\u0188\u023C\uA73F\u2184'
    },
    {
        base: 'd',
        letters: '\u0064\u24D3\uFF44\u1E0B\u010F\u1E0D\u1E11\u1E13\u1E0F\u0111\u018C\u0256\u0257\uA77A'
    },
    {
        base: 'dz',
        letters: '\u01F3\u01C6'
    },
    {
        base: 'e',
        letters: '\u0065\u24D4\uFF45\u00E8\u00E9\u00EA\u1EC1\u1EBF\u1EC5\u1EC3\u1EBD\u0113\u1E15\u1E17\u0115\u0117\u00EB\u1EBB\u011B\u0205\u0207\u1EB9\u1EC7\u0229\u1E1D\u0119\u1E19\u1E1B\u0247\u025B\u01DD'
    },
    {
        base: 'f',
        letters: '\u0066\u24D5\uFF46\u1E1F\u0192\uA77C'
    },
    {
        base: 'g',
        letters: '\u0067\u24D6\uFF47\u01F5\u011D\u1E21\u011F\u0121\u01E7\u0123\u01E5\u0260\uA7A1\u1D79\uA77F'
    },
    {
        base: 'h',
        letters: '\u0068\u24D7\uFF48\u0125\u1E23\u1E27\u021F\u1E25\u1E29\u1E2B\u1E96\u0127\u2C68\u2C76\u0265'
    },
    {
        base: 'hv',
        letters: '\u0195'
    },
    {
        base: 'i',
        letters: '\u0069\u24D8\uFF49\u00EC\u00ED\u00EE\u0129\u012B\u012D\u00EF\u1E2F\u1EC9\u01D0\u0209\u020B\u1ECB\u012F\u1E2D\u0268\u0131'
    },
    {
        base: 'j',
        letters: '\u006A\u24D9\uFF4A\u0135\u01F0\u0249'
    },
    {
        base: 'k',
        letters: '\u006B\u24DA\uFF4B\u1E31\u01E9\u1E33\u0137\u1E35\u0199\u2C6A\uA741\uA743\uA745\uA7A3'
    },
    {
        base: 'l',
        letters: '\u006C\u24DB\uFF4C\u0140\u013A\u013E\u1E37\u1E39\u013C\u1E3D\u1E3B\u017F\u0142\u019A\u026B\u2C61\uA749\uA781\uA747'
    },
    {
        base: 'lj',
        letters: '\u01C9'
    },
    {
        base: 'm',
        letters: '\u006D\u24DC\uFF4D\u1E3F\u1E41\u1E43\u0271\u026F'
    },
    {
        base: 'n',
        letters: '\u006E\u24DD\uFF4E\u01F9\u0144\u00F1\u1E45\u0148\u1E47\u0146\u1E4B\u1E49\u019E\u0272\u0149\uA791\uA7A5'
    },
    {
        base: 'nj',
        letters: '\u01CC'
    },
    {
        base: 'o',
        letters: '\u006F\u24DE\uFF4F\u00F2\u00F3\u00F4\u1ED3\u1ED1\u1ED7\u1ED5\u00F5\u1E4D\u022D\u1E4F\u014D\u1E51\u1E53\u014F\u022F\u0231\u00F6\u022B\u1ECF\u0151\u01D2\u020D\u020F\u01A1\u1EDD\u1EDB\u1EE1\u1EDF\u1EE3\u1ECD\u1ED9\u01EB\u01ED\u00F8\u01FF\u0254\uA74B\uA74D\u0275'
    },
    {
        base: 'oi',
        letters: '\u01A3'
    },
    {
        base: 'ou',
        letters: '\u0223'
    },
    {
        base: 'oo',
        letters: '\uA74F'
    },
    {
        base: 'p',
        letters: '\u0070\u24DF\uFF50\u1E55\u1E57\u01A5\u1D7D\uA751\uA753\uA755'
    },
    {
        base: 'q',
        letters: '\u0071\u24E0\uFF51\u024B\uA757\uA759'
    },
    {
        base: 'r',
        letters: '\u0072\u24E1\uFF52\u0155\u1E59\u0159\u0211\u0213\u1E5B\u1E5D\u0157\u1E5F\u024D\u027D\uA75B\uA7A7\uA783'
    },
    {
        base: 's',
        letters: '\u0073\u24E2\uFF53\u00DF\u015B\u1E65\u015D\u1E61\u0161\u1E67\u1E63\u1E69\u0219\u015F\u023F\uA7A9\uA785\u1E9B'
    },
    {
        base: 't',
        letters: '\u0074\u24E3\uFF54\u1E6B\u1E97\u0165\u1E6D\u021B\u0163\u1E71\u1E6F\u0167\u01AD\u0288\u2C66\uA787'
    },
    {
        base: 'tz',
        letters: '\uA729'
    },
    {
        base: 'u',
        letters: '\u0075\u24E4\uFF55\u00F9\u00FA\u00FB\u0169\u1E79\u016B\u1E7B\u016D\u00FC\u01DC\u01D8\u01D6\u01DA\u1EE7\u016F\u0171\u01D4\u0215\u0217\u01B0\u1EEB\u1EE9\u1EEF\u1EED\u1EF1\u1EE5\u1E73\u0173\u1E77\u1E75\u0289'
    },
    {
        base: 'v',
        letters: '\u0076\u24E5\uFF56\u1E7D\u1E7F\u028B\uA75F\u028C'
    },
    {
        base: 'vy',
        letters: '\uA761'
    },
    {
        base: 'w',
        letters: '\u0077\u24E6\uFF57\u1E81\u1E83\u0175\u1E87\u1E85\u1E98\u1E89\u2C73'
    },
    {
        base: 'x',
        letters: '\u0078\u24E7\uFF58\u1E8B\u1E8D'
    },
    {
        base: 'y',
        letters: '\u0079\u24E8\uFF59\u1EF3\u00FD\u0177\u1EF9\u0233\u1E8F\u00FF\u1EF7\u1E99\u1EF5\u01B4\u024F\u1EFF'
    },
    {
        base: 'z',
        letters: '\u007A\u24E9\uFF5A\u017A\u1E91\u017C\u017E\u1E93\u1E95\u01B6\u0225\u0240\u2C6C\uA763'
    }
];
const anyDiacritic = new RegExp('[' + diacritics.map((d)=>d.letters).join('') + ']', 'g');
const diacriticToBase = {};
for(let i = 0; i < diacritics.length; i++){
    let diacritic = diacritics[i];
    for(let j = 0; j < diacritic.letters.length; j++)diacriticToBase[diacritic.letters[j]] = diacritic.base;
}
const stripDiacritics = (str)=>{
    return str.replace(anyDiacritic, (match)=>diacriticToBase[match]);
};

},{"@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"9ys8n":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "components", ()=>components);
parcelHelpers.export(exports, "defaultComponents", ()=>defaultComponents);
var _objectSpread = require("@swc/helpers/_/_object_spread");
var _indicatorsContainer = require("./containers/indicators-container");
var _multiValueContainer = require("./containers/multi-value-container");
var _selectContainer = require("./containers/select-container");
var _valueContainer = require("./containers/value-container");
var _control = require("./control");
var _controlDefault = parcelHelpers.interopDefault(_control);
var _group = require("./group");
var _groupDefault = parcelHelpers.interopDefault(_group);
var _groupHeading = require("./group-heading");
var _clearIndicator = require("./indicators/clear-indicator");
var _dropdownIndicator = require("./indicators/dropdown-indicator");
var _loadingIndicator = require("./indicators/loading-indicator");
var _input = require("./input");
var _inputDefault = parcelHelpers.interopDefault(_input);
var _menu = require("./menu");
var _menuDefault = parcelHelpers.interopDefault(_menu);
var _menuList = require("./menu-list");
var _menuLoadingMessage = require("./menu-loading-message");
var _menuNoOptionsMessage = require("./menu-no-options-message");
var _menuPortal = require("./menu-portal");
var _multiValue = require("./multi-value");
var _multiValueDefault = parcelHelpers.interopDefault(_multiValue);
var _multiValueLabel = require("./multi-value-label");
var _multiValueRemove = require("./multi-value-remove");
var _option = require("./option");
var _optionDefault = parcelHelpers.interopDefault(_option);
var _placeholder = require("./placeholder");
var _placeholderDefault = parcelHelpers.interopDefault(_placeholder);
var _singleValue = require("./single-value");
var _singleValueDefault = parcelHelpers.interopDefault(_singleValue);
const components = {
    ClearIndicator: (0, _clearIndicator.ClearIndicator),
    Control: (0, _controlDefault.default),
    DropdownIndicator: (0, _dropdownIndicator.DropdownIndicator),
    Group: (0, _groupDefault.default),
    GroupHeading: (0, _groupHeading.GroupHeading),
    IndicatorsContainer: (0, _indicatorsContainer.IndicatorsContainer),
    Input: (0, _inputDefault.default),
    LoadingIndicator: (0, _loadingIndicator.LoadingIndicator),
    Menu: (0, _menuDefault.default),
    MenuList: (0, _menuList.MenuList),
    MenuPortal: (0, _menuPortal.MenuPortal),
    LoadingMessage: (0, _menuLoadingMessage.LoadingMessage),
    NoOptionsMessage: (0, _menuNoOptionsMessage.NoOptionsMessage),
    MultiValue: (0, _multiValueDefault.default),
    MultiValueContainer: (0, _multiValueContainer.MultiValueContainer),
    MultiValueLabel: (0, _multiValueLabel.MultiValueLabel),
    MultiValueRemove: (0, _multiValueRemove.MultiValueRemove),
    Option: (0, _optionDefault.default),
    Placeholder: (0, _placeholderDefault.default),
    SelectContainer: (0, _selectContainer.SelectContainer),
    SingleValue: (0, _singleValueDefault.default),
    ValueContainer: (0, _valueContainer.ValueContainer)
};
const defaultComponents = (props)=>(0, _objectSpread._)({}, components, props.components);

},{"@swc/helpers/_/_object_spread":"9gdrV","./containers/indicators-container":"ghK9R","./containers/multi-value-container":"8AL71","./containers/select-container":"ieplb","./containers/value-container":"9aJlT","./control":"2zMkH","./group":"lKYeN","./group-heading":"iULjX","./indicators/clear-indicator":"1krOl","./indicators/dropdown-indicator":"fNgjh","./indicators/loading-indicator":"h3GVG","./input":"dwxDA","./menu":"2fWOR","./menu-list":"9uaha","./menu-loading-message":"lfqC2","./menu-no-options-message":"02CQU","./menu-portal":"d2rcK","./multi-value":"jUJeq","./multi-value-label":"jW74g","./multi-value-remove":"jmTod","./option":"8V13O","./placeholder":"asiRS","./single-value":"llmxj","@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"ghK9R":[function(require,module,exports,__globalThis) {
/* indicators-container.tsx generated by @compiled/babel-plugin v0.39.1 */ var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "IndicatorsContainer", ()=>IndicatorsContainer);
var _objectSpread = require("@swc/helpers/_/_object_spread");
var _objectSpreadProps = require("@swc/helpers/_/_object_spread_props");
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _runtime = require("@compiled/react/runtime");
var _react1 = require("@compiled/react");
var _getStyleProps = require("../../get-style-props");
const indicatorContainerStyles = null;
const IndicatorsContainer = (props)=>{
    const { children, innerProps, xcss } = props;
    const { css, className } = (0, _getStyleProps.getStyleProps)(props, 'indicatorsContainer', {
        indicators: true
    });
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", (0, _objectSpreadProps._)((0, _objectSpread._)({
        // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop
        style: css,
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop, @atlaskit/ui-styling-standard/local-cx-xcss, @compiled/local-cx-xcss
        className: (0, _runtime.ax)([
            "_1e0c1txw _4cvr1h6o _1o9zidpf _1wpz1fhb _y4ti1b66",
            (0, _react1.cx)(className, xcss, '-IndicatorsContainer')
        ])
    }, innerProps), {
        children: children
    }));
};

},{"@swc/helpers/_/_object_spread":"9gdrV","@swc/helpers/_/_object_spread_props":"kANqQ","react/jsx-runtime":"bGvcw","react":"ltHCL","@compiled/react/runtime":"d27Vo","@compiled/react":"MfI9Z","../../get-style-props":"lzdjl","@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"lzdjl":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "getStyleProps", ()=>getStyleProps);
const getStyleProps = (props, name, classNamesState)=>{
    const { cx, getStyles, getClassNames, className } = props;
    return {
        css: getStyles(name, props),
        className: cx(classNamesState !== null && classNamesState !== void 0 ? classNamesState : {}, getClassNames(name, props), className)
    };
};

},{"@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"8AL71":[function(require,module,exports,__globalThis) {
/* multi-value-container.tsx generated by @compiled/babel-plugin v0.39.1 */ var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "MultiValueContainer", ()=>MultiValueContainer);
var _objectSpread = require("@swc/helpers/_/_object_spread");
var _objectSpreadProps = require("@swc/helpers/_/_object_spread_props");
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _runtime = require("@compiled/react/runtime");
var _react1 = require("@compiled/react");
const multiValueStyles = {
    root: "_2rko12b0 _1h6d14je _1dqonqa1 _189ee4h9 _1e0c1txw _1ul9ze3t _1pfhv77o _12l2v77o _6rthv77o _ahbqv77o _bfhk1j9a _p12f1osq _syazi7uo _3yq3glyw",
    disabled: "_syaz1gmx _bfhki8nm",
    focused: "_syaz6x5g _bfhk15s3 _16qs1xv8 _1aewe4h9 _6up51j28 _1xdnnqa1"
};
const MultiValueContainer = ({ children, innerProps, isFocused, isDisabled, className, xcss })=>{
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", (0, _objectSpreadProps._)((0, _objectSpread._)({}, innerProps), {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop, @atlaskit/ui-styling-standard/local-cx-xcss, @compiled/local-cx-xcss
        className: (0, _runtime.ax)([
            multiValueStyles.root,
            isDisabled && multiValueStyles.disabled,
            isFocused && multiValueStyles.focused,
            (0, _react1.cx)(className, xcss, '-multiValue')
        ]),
        children: children
    }));
};

},{"@swc/helpers/_/_object_spread":"9gdrV","@swc/helpers/_/_object_spread_props":"kANqQ","react/jsx-runtime":"bGvcw","react":"ltHCL","@compiled/react/runtime":"d27Vo","@compiled/react":"MfI9Z","@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"ieplb":[function(require,module,exports,__globalThis) {
/* select-container.tsx generated by @compiled/babel-plugin v0.39.1 */ var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "SelectContainer", ()=>SelectContainer);
var _objectSpread = require("@swc/helpers/_/_object_spread");
var _objectSpreadProps = require("@swc/helpers/_/_object_spread_props");
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _runtime = require("@compiled/react/runtime");
var _react1 = require("@compiled/react");
var _getStyleProps = require("../../get-style-props");
const containerStyles = {
    default: "_11c81d4k _kqswh2mm _lcxv1rj4 _1tn2fhey",
    rtl: "_1eim1xrj",
    disabled: "_80om13gf"
};
const SelectContainer = (props)=>{
    const { children, innerProps, isDisabled, isRtl, xcss } = props;
    const { className, css } = (0, _getStyleProps.getStyleProps)(props, 'container', {
        '--is-disabled': isDisabled,
        '--is-rtl': isRtl
    });
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", (0, _objectSpreadProps._)((0, _objectSpread._)({
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop, @atlaskit/ui-styling-standard/local-cx-xcss, @compiled/local-cx-xcss
        className: (0, _runtime.ax)([
            containerStyles.default,
            isRtl && containerStyles.rtl,
            isDisabled && containerStyles.disabled,
            (0, _react1.cx)(className, xcss, '-container')
        ]),
        // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop
        style: css
    }, innerProps), {
        children: children
    }));
};

},{"@swc/helpers/_/_object_spread":"9gdrV","@swc/helpers/_/_object_spread_props":"kANqQ","react/jsx-runtime":"bGvcw","react":"ltHCL","@compiled/react/runtime":"d27Vo","@compiled/react":"MfI9Z","../../get-style-props":"lzdjl","@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"9aJlT":[function(require,module,exports,__globalThis) {
/* value-container.tsx generated by @compiled/babel-plugin v0.39.1 */ var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "ValueContainer", ()=>ValueContainer);
var _objectSpread = require("@swc/helpers/_/_object_spread");
var _objectSpreadProps = require("@swc/helpers/_/_object_spread_props");
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _runtime = require("@compiled/react/runtime");
var _react1 = require("@compiled/react");
var _platformFeatureFlags = require("@atlaskit/platform-feature-flags");
var _getStyleProps = require("../../get-style-props");
const valueContainerStyles = {
    default: "_16jlkb7n _1o9zkb7n _i0dlf1ug _1reo15vq _18m915vq _4cvr1h6o _1e0c11p5 _1n261g80 _8am5i4x0 _kqswh2mm _y4ti12x7 _bozg12x7",
    verticalPaddingStandard: "_1q51v77o _85i5v77o",
    verticalPaddingTagUpliftMulti: "_1q511b66 _85i51b66",
    verticalPaddingTagUpliftCompactMulti: "_1q51v77o _85i5v77o",
    verticalPaddingCompactNonUplift: "_1q51ze3t _85i5ze3t",
    flex: "_1e0c1txw",
    flexWithGap: "_zulp1b66 _1e0c1txw _1n261g80"
};
const ValueContainer = (props)=>{
    const { children, innerProps, isMulti, hasValue, isCompact, xcss, selectProps: { controlShouldRenderValue } } = props;
    const { css, className } = (0, _getStyleProps.getStyleProps)(props, 'valueContainer', {
        'value-container': true,
        'value-container--is-multi': isMulti,
        'value-container--has-value': hasValue
    });
    const ffTagUplifts = (0, _platformFeatureFlags.fg)('platform-dst-lozenge-tag-badge-visual-uplifts');
    const tagUpliftMultiVertical = ffTagUplifts && isMulti;
    const tagUpliftChipRow = ffTagUplifts && isMulti && hasValue && controlShouldRenderValue;
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", (0, _objectSpreadProps._)((0, _objectSpread._)({
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop, @atlaskit/ui-styling-standard/local-cx-xcss, @compiled/local-cx-xcss
        className: (0, _runtime.ax)([
            valueContainerStyles.default,
            tagUpliftMultiVertical && isCompact && valueContainerStyles.verticalPaddingTagUpliftCompactMulti,
            tagUpliftMultiVertical && !isCompact && valueContainerStyles.verticalPaddingTagUpliftMulti,
            !tagUpliftMultiVertical && !isCompact && valueContainerStyles.verticalPaddingStandard,
            !tagUpliftMultiVertical && isCompact && valueContainerStyles.verticalPaddingCompactNonUplift,
            isMulti && hasValue && controlShouldRenderValue && valueContainerStyles.flex,
            tagUpliftChipRow && valueContainerStyles.flexWithGap,
            (0, _react1.cx)(className, xcss, '-ValueContainer')
        ]),
        // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop
        style: css
    }, innerProps), {
        children: children
    }));
};

},{"@swc/helpers/_/_object_spread":"9gdrV","@swc/helpers/_/_object_spread_props":"kANqQ","react/jsx-runtime":"bGvcw","react":"ltHCL","@compiled/react/runtime":"d27Vo","@compiled/react":"MfI9Z","@atlaskit/platform-feature-flags":"8rD2i","../../get-style-props":"lzdjl","@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"2zMkH":[function(require,module,exports,__globalThis) {
/* control.tsx generated by @compiled/babel-plugin v0.39.1 */ /* eslint-disable @atlaskit/ui-styling-standard/no-unsafe-selectors */ var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _objectSpread = require("@swc/helpers/_/_object_spread");
var _objectSpreadProps = require("@swc/helpers/_/_object_spread_props");
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _runtime = require("@compiled/react/runtime");
var _react1 = require("@compiled/react");
var _platformFeatureFlags = require("@atlaskit/platform-feature-flags");
var _getStyleProps = require("../get-style-props");
const styles = {
    default: "_12ji1r31 _1qu2glyw _12y3idpf _2rkofajl _v564r5cv _1h6drsbi _1dqonqa1 _189ee4h9 _4cvr1h6o _80om73ad _1e0c1txw _1n261g80 _1bah1yb4 _kqswh2mm _bfhk1j9a _1tke1ylp _1q51ze3t _y4tize3t _85i5ze3t _bozgze3t _15peftgi _1ke8ftgi _jaboglyw _1u6luvb6 _4cvxrsbi _123byq51 _d0altlke _irr3l4ek _1ogl1caj",
    defaultT26Shape: "_2rko1qi0",
    compact: "_1tkezwfg",
    invalid: "_1h6d1bqt _16qsizbr _1u6lizbr _4cvx1bqt",
    focusedInvalid: "_16qsvyy1",
    disabled: "_1h6d187o _lcxvglyw _bfhk187o _1u6lfrlt",
    focused: "_1h6d1v1w _bfhkr01l _16qsvyy1 _1u6lvyy1 _4cvx1v1w _irr3r01l",
    subtle: "_1h6d1j28 _bfhk1j28 _1u6l3sij",
    subtleFocused: "_bfhkvuon",
    none: "_1h6d1j28 _bfhk1j28 _1u6l3sij _4cvx1j28 _irr31j28"
};
const Control = (props)=>{
    const { children, appearance, isCompact, isDisabled, isFocused, isInvalid, innerRef, innerProps, menuIsOpen, xcss } = props;
    const { css, className } = (0, _getStyleProps.getStyleProps)(props, 'control', {
        control: true,
        'control--is-disabled': isDisabled,
        'control--is-focused': isFocused,
        'control--menu-is-open': menuIsOpen
    });
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", (0, _objectSpreadProps._)((0, _objectSpread._)({
        ref: innerRef,
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop, @atlaskit/ui-styling-standard/local-cx-xcss, @compiled/local-cx-xcss
        className: (0, _runtime.ax)([
            styles.default,
            (0, _platformFeatureFlags.fg)('platform-dst-shape-theme-default') && styles.defaultT26Shape,
            isDisabled && styles.disabled,
            isInvalid && styles.invalid,
            isCompact && styles.compact,
            appearance === 'subtle' && styles.subtle,
            appearance === 'subtle' && isFocused && styles.subtleFocused,
            isFocused && styles.focused,
            appearance === 'none' && styles.none,
            (0, _react1.cx)(className, xcss, '-control')
        ]),
        // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop
        style: css
    }, innerProps), {
        "aria-disabled": (0, _platformFeatureFlags.fg)('platform_dst_select_disabled_a11y_fix') ? undefined : isDisabled || undefined,
        children: children
    }));
};
// eslint-disable-next-line @repo/internal/react/require-jsdoc
exports.default = Control;

},{"@swc/helpers/_/_object_spread":"9gdrV","@swc/helpers/_/_object_spread_props":"kANqQ","react/jsx-runtime":"bGvcw","react":"ltHCL","@compiled/react/runtime":"d27Vo","@compiled/react":"MfI9Z","@atlaskit/platform-feature-flags":"8rD2i","../get-style-props":"lzdjl","@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"lKYeN":[function(require,module,exports,__globalThis) {
/* group.tsx generated by @compiled/babel-plugin v0.39.1 */ var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _objectSpread = require("@swc/helpers/_/_object_spread");
var _objectSpreadProps = require("@swc/helpers/_/_object_spread_props");
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _runtime = require("@compiled/react/runtime");
var _react1 = require("@compiled/react");
var _getStyleProps = require("../get-style-props");
const styles = {
    root: "_85i5u2gc _1q51u2gc"
};
const Group = (props)=>{
    const { children, cx: builtinCX, getStyles, getClassNames, Heading, headingProps, innerProps, label, selectProps, xcss } = props;
    const { css, className } = (0, _getStyleProps.getStyleProps)(props, 'group', {
        group: true
    });
    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", (0, _objectSpreadProps._)((0, _objectSpread._)({
        // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop
        style: css
    }, innerProps), {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop, @atlaskit/ui-styling-standard/local-cx-xcss, @compiled/local-cx-xcss
        className: (0, _runtime.ax)([
            styles.root,
            (0, _react1.cx)(className, xcss, innerProps === null || innerProps === void 0 ? void 0 : innerProps.className, '-Group')
        ]),
        children: [
            label && /*#__PURE__*/ (0, _jsxRuntime.jsx)(Heading, (0, _objectSpreadProps._)((0, _objectSpread._)({}, headingProps), {
                selectProps: selectProps,
                getStyles: getStyles,
                getClassNames: getClassNames,
                cx: builtinCX,
                children: label
            })),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                children: children
            })
        ]
    }));
};
// eslint-disable-next-line @repo/internal/react/require-jsdoc
exports.default = Group;

},{"@swc/helpers/_/_object_spread":"9gdrV","@swc/helpers/_/_object_spread_props":"kANqQ","react/jsx-runtime":"bGvcw","react":"ltHCL","@compiled/react/runtime":"d27Vo","@compiled/react":"MfI9Z","../get-style-props":"lzdjl","@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"iULjX":[function(require,module,exports,__globalThis) {
/* group-heading.tsx generated by @compiled/babel-plugin v0.39.1 */ var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "GroupHeading", ()=>GroupHeading);
var _objectSpread = require("@swc/helpers/_/_object_spread");
var _objectWithoutProperties = require("@swc/helpers/_/_object_without_properties");
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _runtime = require("@compiled/react/runtime");
var _react1 = require("@compiled/react");
var _getStyleProps = require("../get-style-props");
var _cleanCommonProps = require("../internal/clean-common-props");
const headingStyles = null;
const GroupHeading = (props)=>{
    const { xcss } = props;
    const _cleanCommonProps1 = (0, _cleanCommonProps.cleanCommonProps)(props), { data } = _cleanCommonProps1, innerProps = (0, _objectWithoutProperties._)(_cleanCommonProps1, [
        "data"
    ]);
    const { css, className } = (0, _getStyleProps.getStyleProps)(props, 'groupHeading', {
        'group-heading': true
    });
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", (0, _objectSpread._)({
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop, @atlaskit/ui-styling-standard/local-cx-xcss, @compiled/local-cx-xcss
        className: (0, _runtime.ax)([
            "_11c8wadc _1e0c1ule _syazazsu _80om73ad _k48pwu06 _6rthpd1z _y4tiutpp _bozgutpp _1p1dglyw",
            (0, _react1.cx)(className, xcss, '-group')
        ]),
        // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop
        style: css
    }, innerProps));
};

},{"@swc/helpers/_/_object_spread":"9gdrV","@swc/helpers/_/_object_without_properties":"6HqIM","react/jsx-runtime":"bGvcw","react":"ltHCL","@compiled/react/runtime":"d27Vo","@compiled/react":"MfI9Z","../get-style-props":"lzdjl","../internal/clean-common-props":"lwqzK","@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"lwqzK":[function(require,module,exports,__globalThis) {
// Clean Common Props
// ==============================
var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "cleanCommonProps", ()=>cleanCommonProps);
var _objectSpread = require("@swc/helpers/_/_object_spread");
var _objectWithoutProperties = require("@swc/helpers/_/_object_without_properties");
const cleanCommonProps = (props)=>{
    //className
    const { className, clearValue, cx, xcss, getStyles, getClassNames, getValue, hasValue, isMulti, isRtl, options, selectOption, selectProps, setValue } = props, innerProps = (0, _objectWithoutProperties._)(props, [
        "className",
        "clearValue",
        "cx",
        "xcss",
        "getStyles",
        "getClassNames",
        "getValue",
        "hasValue",
        "isMulti",
        "isRtl",
        "options",
        "selectOption",
        "selectProps",
        "setValue"
    ]);
    return (0, _objectSpread._)({}, innerProps);
};

},{"@swc/helpers/_/_object_spread":"9gdrV","@swc/helpers/_/_object_without_properties":"6HqIM","@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"1krOl":[function(require,module,exports,__globalThis) {
/* clear-indicator.tsx generated by @compiled/babel-plugin v0.39.1 */ var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "ClearIndicator", ()=>ClearIndicator);
var _objectSpread = require("@swc/helpers/_/_object_spread");
var _objectSpreadProps = require("@swc/helpers/_/_object_spread_props");
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _runtime = require("@compiled/react/runtime");
var _react1 = require("@compiled/react");
var _crossCircle = require("@atlaskit/icon/core/cross-circle");
var _crossCircleDefault = parcelHelpers.interopDefault(_crossCircle);
var _compiled = require("@atlaskit/primitives/compiled");
var _getStyleProps = require("../../get-style-props");
const iconContainerStyles = {
    root: "_kkk2n7od _12ji1r31 _1qu219ly _12y31o36 _1e0c1txw _4cvr1h6o _1bah1h6o _1q51v77o _y4tiv77o _85i5v77o _bozgv77o"
};
const clearIndicatorStyles = {
    default: "_v564vrg3 _1e0c1txw _syaz1rpy _1q5112x7 _y4tiv77o _85i512x7 _bozgv77o _30l3azsu",
    compact: "_1q51idpf _85i5idpf"
};
const ClearIndicator = (props)=>{
    const { innerProps, clearControlLabel = 'clear', isCompact, xcss } = props;
    const { css, className } = (0, _getStyleProps.getStyleProps)(props, 'clearIndicator', {
        indicator: true,
        'clear-indicator': true
    });
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", (0, _objectSpreadProps._)((0, _objectSpread._)({
        // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop
        style: css,
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop, @atlaskit/ui-styling-standard/local-cx-xcss, @compiled/local-cx-xcss
        className: (0, _runtime.ax)([
            clearIndicatorStyles.default,
            isCompact && clearIndicatorStyles.compact,
            (0, _react1.cx)(className, xcss, '-indicatorContainer')
        ])
    }, innerProps), {
        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _compiled.Pressable), {
            xcss: iconContainerStyles.root,
            tabIndex: -1,
            "aria-label": clearControlLabel,
            children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _crossCircleDefault.default), {
                label: "",
                color: "currentColor",
                size: "small"
            })
        })
    }));
};

},{"@swc/helpers/_/_object_spread":"9gdrV","@swc/helpers/_/_object_spread_props":"kANqQ","react/jsx-runtime":"bGvcw","react":"ltHCL","@compiled/react/runtime":"d27Vo","@compiled/react":"MfI9Z","@atlaskit/icon/core/cross-circle":"cNkMc","@atlaskit/primitives/compiled":"hDay7","../../get-style-props":"lzdjl","@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"cNkMc":[function(require,module,exports,__globalThis) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::3eb90e0e095210547df6d71f04e27a56>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = void 0;
var _react = _interopRequireDefault(require("3c7710e95a7cf527"));
var _baseNew = _interopRequireDefault(require("49bed970a4f38626"));
function _interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "CrossCircle".
 * Category: multi-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Multi purpose - Known uses: clear text field, error status.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const CrossCircleIcon = (props)=>/*#__PURE__*/ _react.default.createElement(_baseNew.default, Object.assign({
        name: "CrossCircleIcon",
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M8 0a8 8 0 1 0 0 16A8 8 0 0 0 8 0m4.03 5.03L9.06 8l2.97 2.97-1.06 1.06L8 9.06l-2.97 2.97-1.06-1.06L6.94 8 3.97 5.03l1.06-1.06L8 6.94l2.97-2.97z" clip-rule="evenodd"/>`
    }, props));
CrossCircleIcon.displayName = 'CrossCircleIcon';
var _default = exports.default = CrossCircleIcon;

},{"3c7710e95a7cf527":"ltHCL","49bed970a4f38626":"5XL7D"}],"fNgjh":[function(require,module,exports,__globalThis) {
/* dropdown-indicator.tsx generated by @compiled/babel-plugin v0.39.1 */ var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "DropdownIndicator", ()=>DropdownIndicator);
var _objectSpread = require("@swc/helpers/_/_object_spread");
var _objectSpreadProps = require("@swc/helpers/_/_object_spread_props");
var _objectWithoutProperties = require("@swc/helpers/_/_object_without_properties");
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _runtime = require("@compiled/react/runtime");
var _react1 = require("@compiled/react");
var _chevronDown = require("@atlaskit/icon/core/chevron-down");
var _chevronDownDefault = parcelHelpers.interopDefault(_chevronDown);
var _platformFeatureFlags = require("@atlaskit/platform-feature-flags");
var _compiled = require("@atlaskit/primitives/compiled");
var _getStyleProps = require("../../get-style-props");
const dropdownWrapperStyles = {
    root: "_1q5112x7 _y4ti12x7 _85i512x7 _bozg12x7"
};
// Reset styles for the voice-control <Pressable> so the chevron renders
// pixel-identical to the gate-off icon-in-a-div. Uses @atlaskit/css cssMap
// (aliased as strictCssMap) because Pressable's xcss prop requires that type.
const voiceControlPressableStyles = {
    root: "_1rjcidpf _18zridpf _1mouidpf _195gidpf _bfhk1j28 _1e0c1txw _4cvr1h6o"
};
const dropdownStyles = {
    default: "_v564vrg3 _1e0c1txw _syazazsu _1q5112x7 _y4tiv77o _85i512x7 _bozgv77o _30l3azsu",
    compact: "_1q51idpf _85i5idpf",
    disabled: "_syaz1gmx"
};
const DropdownIndicator = (props)=>{
    const { innerProps = {}, children, isDisabled, isCompact, xcss } = props;
    const { css, className } = (0, _getStyleProps.getStyleProps)(props, 'dropdownIndicator', {
        indicator: true,
        'dropdown-indicator': true
    });
    const { 'aria-hidden': ariaHidden } = innerProps, restInnerProps = (0, _objectWithoutProperties._)(innerProps, [
        'aria-hidden'
    ]);
    const isVoiceControlAccessible = (0, _platformFeatureFlags.fg)('platform_dst_select_dropdown_voice_control');
    // Stable testid for the hoisted aria-hidden children wrapper (avoids parentElement in tests).
    const wrapperTestId = restInnerProps['data-testid'] ? `${restInnerProps['data-testid']}-children` : undefined;
    const voiceControlAccessibleIndicator = children ? /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
        "aria-hidden": ariaHidden,
        "data-testid": wrapperTestId,
        children: children
    }) : /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _compiled.Pressable), {
        tabIndex: -1,
        "aria-label": "toggle select menu",
        isDisabled: isDisabled,
        componentName: "DropdownIndicatorVoiceControl",
        xcss: voiceControlPressableStyles.root,
        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _compiled.Inline), {
            as: "span",
            xcss: dropdownWrapperStyles.root,
            children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _chevronDownDefault.default), {
                color: "currentColor",
                label: "open",
                size: "small"
            })
        })
    });
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", (0, _objectSpreadProps._)((0, _objectSpread._)({
        // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop
        style: css,
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop, @atlaskit/ui-styling-standard/local-cx-xcss, @compiled/local-cx-xcss
        className: (0, _runtime.ax)([
            dropdownStyles.default,
            isDisabled && dropdownStyles.disabled,
            isCompact && dropdownStyles.compact,
            (0, _react1.cx)(className, xcss, '-indicatorContainer')
        ])
    }, restInnerProps), {
        "aria-hidden": isVoiceControlAccessible ? undefined : ariaHidden,
        children: isVoiceControlAccessible ? voiceControlAccessibleIndicator : children !== null && children !== void 0 ? children : /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _compiled.Inline), {
            as: "span",
            xcss: dropdownWrapperStyles.root,
            children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _chevronDownDefault.default), {
                color: "currentColor",
                label: "open",
                size: "small"
            })
        })
    }));
};

},{"@swc/helpers/_/_object_spread":"9gdrV","@swc/helpers/_/_object_spread_props":"kANqQ","@swc/helpers/_/_object_without_properties":"6HqIM","react/jsx-runtime":"bGvcw","react":"ltHCL","@compiled/react/runtime":"d27Vo","@compiled/react":"MfI9Z","@atlaskit/icon/core/chevron-down":"ieg9F","@atlaskit/platform-feature-flags":"8rD2i","@atlaskit/primitives/compiled":"hDay7","../../get-style-props":"lzdjl","@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"h3GVG":[function(require,module,exports,__globalThis) {
/* loading-indicator.tsx generated by @compiled/babel-plugin v0.39.1 */ var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "LoadingIndicator", ()=>LoadingIndicator);
var _objectSpread = require("@swc/helpers/_/_object_spread");
var _objectSpreadProps = require("@swc/helpers/_/_object_spread_props");
var _objectWithoutProperties = require("@swc/helpers/_/_object_without_properties");
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _runtime = require("@compiled/react/runtime");
var _react1 = require("@compiled/react");
var _spinner = require("@atlaskit/spinner");
var _spinnerDefault = parcelHelpers.interopDefault(_spinner);
var _getStyleProps = require("../../get-style-props");
const loadingIndicatorStyles = {
    default: "_1q5112x7 _y4tiu2gc _85i512x7 _bozgu2gc",
    compact: "_1q51idpf _85i5idpf"
};
const LoadingIndicator = (_param)=>{
    var { innerProps, isRtl, size = 4, isCompact, xcss } = _param, restProps = (0, _objectWithoutProperties._)(_param, [
        "innerProps",
        "isRtl",
        "size",
        "isCompact",
        "xcss"
    ]);
    const { css, className } = (0, _getStyleProps.getStyleProps)((0, _objectSpreadProps._)((0, _objectSpread._)({}, restProps), {
        innerProps,
        isRtl,
        size
    }), 'loadingIndicator', {
        indicator: true,
        'loading-indicator': true
    });
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", (0, _objectSpreadProps._)((0, _objectSpread._)({
        // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop
        style: css,
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop, @atlaskit/ui-styling-standard/local-cx-xcss, @compiled/local-cx-xcss
        className: (0, _runtime.ax)([
            loadingIndicatorStyles.default,
            isCompact && loadingIndicatorStyles.compact,
            (0, _react1.cx)(className, xcss, '-loadingIndicator')
        ])
    }, innerProps), {
        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _spinnerDefault.default), {
            size: "small"
        })
    }));
};

},{"@swc/helpers/_/_object_spread":"9gdrV","@swc/helpers/_/_object_spread_props":"kANqQ","@swc/helpers/_/_object_without_properties":"6HqIM","react/jsx-runtime":"bGvcw","react":"ltHCL","@compiled/react/runtime":"d27Vo","@compiled/react":"MfI9Z","@atlaskit/spinner":"l22fT","../../get-style-props":"lzdjl","@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"dwxDA":[function(require,module,exports,__globalThis) {
/* input.tsx generated by @compiled/babel-plugin v0.39.1 */ var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _objectSpread = require("@swc/helpers/_/_object_spread");
var _objectWithoutProperties = require("@swc/helpers/_/_object_without_properties");
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _runtime = require("@compiled/react/runtime");
var _react1 = require("@compiled/react");
var _platformFeatureFlags = require("@atlaskit/platform-feature-flags");
var _getStyleProps = require("../get-style-props");
var _cleanCommonProps = require("../internal/clean-common-props");
const inputStylesOld = {
    root: "_16jlkb7n _1o9zkb7n _i0dl1wug _nd5l1sux _1mouv77o _195gv77o _1rjcv77o _1e0c1n7u _yv0e12qd _syazi7uo _j8d6idpf _1av2idpf _1doyidpf _pfztidpf _uoe3idpf _1recidpf _70xridpf _1k96idpf _eq43idpf _1h9u1kw7 _ckog1yjy _1x651r31 _1nn4glyw _1rzeidpf _1yd8yh40 _aetr11ps _uy7x15vq _1qjlqvpr",
    disabled: "_3um015vq",
    labellingFFStyles: "_11c8wadc _1mouze3t _195gze3t _1rjcze3t"
};
const inputStyles = {
    root: "_16jlkb7n _1o9zkb7n _i0dl1wug _nd5l1sux _1mouv77o _195gv77o _1rjcv77o _kqswh2mm _1e0c1txw _yv0e12qd _syazi7uo _j8d6idpf _1av2idpf _1doyidpf _pfztidpf _uoe3idpf _1recidpf _70xridpf _1k96idpf _eq43idpf _1h9u1kw7 _ckog1yjy _1x651r31 _1nn4glyw _1rzeidpf _1yd8yh40 _aetr11ps _uy7x15vq _1qjlqvpr",
    disabled: "_3um015vq",
    labellingFFStyles: "_11c8wadc _1mouze3t _195gze3t _1rjcze3t"
};
const nativeInputStylesOld = null;
const nativeInputStyles = null;
const hidden = null;
const Input = (props)=>{
    const { cx: builtinCX, value, xcss, isMulti } = props;
    const _cleanCommonProps1 = (0, _cleanCommonProps.cleanCommonProps)(props), { innerRef, isDisabled, isHidden, inputClassName, testId } = _cleanCommonProps1, innerProps = (0, _objectWithoutProperties._)(_cleanCommonProps1, [
        "innerRef",
        "isDisabled",
        "isHidden",
        "inputClassName",
        "testId"
    ]);
    const dataId = testId ? `${testId}-select--input` : null;
    const { css, className } = (0, _getStyleProps.getStyleProps)(props, 'input', {
        'input-container': true
    });
    const ffTagUplifts = (0, _platformFeatureFlags.fg)('platform-dst-lozenge-tag-badge-visual-uplifts');
    if ((0, _platformFeatureFlags.fg)('platform_fix_input_component_styling')) return /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop
        style: css,
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop, @atlaskit/ui-styling-standard/local-cx-xcss, @compiled/local-cx-xcss
        className: (0, _runtime.ax)([
            inputStyles.root,
            isMulti && ffTagUplifts && inputStyles.labellingFFStyles,
            isDisabled && inputStyles.disabled,
            (0, _react1.cx)(className, xcss, '-Input')
        ]),
        "data-value": value || '',
        "data-testid": dataId && `${dataId}-container`,
        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("input", (0, _objectSpread._)({
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop
            className: (0, _runtime.ax)([
                "_19pkidpf _2hwxidpf _otyridpf _18u0idpf _ca0qidpf _u5f3idpf _n3tdidpf _19bvidpf _1r04idpf _11q7idpf _19itidpf _11c81kw7 _nd5l1yjy _12ji1r31 _1qu2glyw _12y3idpf _1bsb1osq _1ul9yh40 _kqswstnw _syaz1kw7 _tzy4kb7n",
                isHidden && "_tzy4idpf",
                builtinCX({
                    input: true
                }, inputClassName, '-input')
            ]),
            ref: innerRef,
            disabled: isDisabled,
            "data-testid": dataId
        }, innerProps))
    });
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop
        style: css,
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop, @atlaskit/ui-styling-standard/local-cx-xcss, @compiled/local-cx-xcss
        className: (0, _runtime.ax)([
            inputStylesOld.root,
            isMulti && ffTagUplifts && inputStylesOld.labellingFFStyles,
            isDisabled && inputStylesOld.disabled,
            (0, _react1.cx)(className, xcss, '-Input')
        ]),
        "data-value": value || '',
        "data-testid": dataId && `${dataId}-container`,
        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("input", (0, _objectSpread._)({
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop
            className: (0, _runtime.ax)([
                "_19pkidpf _2hwxidpf _otyridpf _18u0idpf _ca0qidpf _u5f3idpf _n3tdidpf _19bvidpf _11q7idpf _19itidpf _11c81kw7 _nd5l1yjy _12ji1r31 _1qu2glyw _12y3idpf _1bsb1osq _1ul9yh40 _syaz1kw7 _tzy4kb7n",
                isHidden && "_tzy4idpf",
                builtinCX({
                    input: true
                }, inputClassName, '-input')
            ]),
            ref: innerRef,
            disabled: isDisabled,
            "data-testid": dataId
        }, innerProps))
    });
};
// eslint-disable-next-line @repo/internal/react/require-jsdoc
exports.default = Input;

},{"@swc/helpers/_/_object_spread":"9gdrV","@swc/helpers/_/_object_without_properties":"6HqIM","react/jsx-runtime":"bGvcw","react":"ltHCL","@compiled/react/runtime":"d27Vo","@compiled/react":"MfI9Z","@atlaskit/platform-feature-flags":"8rD2i","../get-style-props":"lzdjl","../internal/clean-common-props":"lwqzK","@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"2fWOR":[function(require,module,exports,__globalThis) {
/* menu.tsx generated by @compiled/babel-plugin v0.39.1 */ var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _objectSpread = require("@swc/helpers/_/_object_spread");
var _objectSpreadProps = require("@swc/helpers/_/_object_spread_props");
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _runtime = require("@compiled/react/runtime");
var _react1 = require("@compiled/react");
var _platformFeatureFlags = require("@atlaskit/platform-feature-flags");
var _getStyleProps = require("../get-style-props");
const menuStyles = {
    root: "_2rko12b0 _kqswstnw _1bsb1osq _1pbykb7n _6rthu2gc _1pfhu2gc _bfhk1bhr _16qs130s",
    rootT26Shape: "_2rko1mok",
    bottom: "_152t1osq",
    top: "_u7co1osq"
};
const Menu = (props)=>{
    const { children, innerRef, innerProps, placement = 'bottom', xcss } = props;
    const { css, className } = (0, _getStyleProps.getStyleProps)(props, 'menu', {
        menu: true
    });
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", (0, _objectSpreadProps._)((0, _objectSpread._)({
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop, @atlaskit/ui-styling-standard/local-cx-xcss, @compiled/local-cx-xcss
        className: (0, _runtime.ax)([
            menuStyles.root,
            menuStyles[placement],
            (0, _platformFeatureFlags.fg)('platform-dst-shape-theme-default') && menuStyles.rootT26Shape,
            (0, _react1.cx)(xcss, className, '-menu')
        ]),
        // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop
        style: css,
        ref: innerRef
    }, innerProps), {
        children: children
    }));
};
// eslint-disable-next-line @repo/internal/react/require-jsdoc
exports.default = Menu;

},{"@swc/helpers/_/_object_spread":"9gdrV","@swc/helpers/_/_object_spread_props":"kANqQ","react/jsx-runtime":"bGvcw","react":"ltHCL","@compiled/react/runtime":"d27Vo","@compiled/react":"MfI9Z","@atlaskit/platform-feature-flags":"8rD2i","../get-style-props":"lzdjl","@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"9uaha":[function(require,module,exports,__globalThis) {
/* menu-list.tsx generated by @compiled/babel-plugin v0.39.1 */ var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "MenuList", ()=>MenuList);
var _objectSpread = require("@swc/helpers/_/_object_spread");
var _objectSpreadProps = require("@swc/helpers/_/_object_spread_props");
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _runtime = require("@compiled/react/runtime");
var _react1 = require("@compiled/react");
var _getStyleProps = require("../get-style-props");
const menuListStyles = null;
const MenuList = (props)=>{
    const { children, innerProps, innerRef, isMulti, maxHeight, xcss } = props;
    const { css, className } = (0, _getStyleProps.getStyleProps)(props, 'menuList', {
        'menu-list': true,
        'menu-list--is-multi': isMulti
    });
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", (0, _objectSpreadProps._)((0, _objectSpread._)({
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop, @atlaskit/ui-styling-standard/local-cx-xcss, @compiled/local-cx-xcss
        className: (0, _runtime.ax)([
            "_kqswh2mm _18m91wug _85i5u2gc _1q51u2gc _8am5i4x0",
            (0, _react1.cx)(className, xcss, '-MenuList')
        ]),
        // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop
        style: (0, _objectSpreadProps._)((0, _objectSpread._)({}, css), {
            maxHeight: maxHeight
        }),
        ref: innerRef
    }, innerProps), {
        tabIndex: -1,
        children: children
    }));
};

},{"@swc/helpers/_/_object_spread":"9gdrV","@swc/helpers/_/_object_spread_props":"kANqQ","react/jsx-runtime":"bGvcw","react":"ltHCL","@compiled/react/runtime":"d27Vo","@compiled/react":"MfI9Z","../get-style-props":"lzdjl","@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"lfqC2":[function(require,module,exports,__globalThis) {
/* menu-loading-message.tsx generated by @compiled/babel-plugin v0.39.1 */ var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "LoadingMessage", ()=>LoadingMessage);
var _objectSpread = require("@swc/helpers/_/_object_spread");
var _objectSpreadProps = require("@swc/helpers/_/_object_spread_props");
var _objectWithoutProperties = require("@swc/helpers/_/_object_without_properties");
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _runtime = require("@compiled/react/runtime");
var _react1 = require("@compiled/react");
var _compiled = require("@atlaskit/primitives/compiled");
var _getStyleProps = require("../get-style-props");
const noticeStyles = null;
const LoadingMessage = (_param)=>{
    var { children = 'Loading...', innerProps, xcss } = _param, restProps = (0, _objectWithoutProperties._)(_param, [
        "children",
        "innerProps",
        "xcss"
    ]);
    const { css, className } = (0, _getStyleProps.getStyleProps)((0, _objectSpreadProps._)((0, _objectSpread._)({}, restProps), {
        children,
        innerProps
    }), 'loadingMessage', {
        'menu-notice': true,
        'menu-notice--loading': true
    });
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", (0, _objectSpreadProps._)((0, _objectSpread._)({
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop, @atlaskit/ui-styling-standard/local-cx-xcss, @compiled/local-cx-xcss
        className: (0, _runtime.ax)([
            "_85i5u2gc _1q51u2gc _y4tiutpp _bozgutpp _y3gn1h6o",
            (0, _react1.cx)(className, xcss, '-LoadingMessage')
        ]),
        // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop
        style: css
    }, innerProps), {
        // eslint-disable-next-line @atlassian/a11y/role-has-required-aria-props
        role: "option",
        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _compiled.Text), {
            color: "color.text.subtle",
            children: children
        })
    }));
};

},{"@swc/helpers/_/_object_spread":"9gdrV","@swc/helpers/_/_object_spread_props":"kANqQ","@swc/helpers/_/_object_without_properties":"6HqIM","react/jsx-runtime":"bGvcw","react":"ltHCL","@compiled/react/runtime":"d27Vo","@compiled/react":"MfI9Z","@atlaskit/primitives/compiled":"hDay7","../get-style-props":"lzdjl","@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"02CQU":[function(require,module,exports,__globalThis) {
/* menu-no-options-message.tsx generated by @compiled/babel-plugin v0.39.1 */ var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "NoOptionsMessage", ()=>NoOptionsMessage);
var _objectSpread = require("@swc/helpers/_/_object_spread");
var _objectSpreadProps = require("@swc/helpers/_/_object_spread_props");
var _objectWithoutProperties = require("@swc/helpers/_/_object_without_properties");
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _runtime = require("@compiled/react/runtime");
var _react1 = require("@compiled/react");
var _compiled = require("@atlaskit/primitives/compiled");
var _getStyleProps = require("../get-style-props");
const noticeStyles = null;
const NoOptionsMessage = (_param)=>{
    var { children = 'No options', innerProps, xcss } = _param, restProps = (0, _objectWithoutProperties._)(_param, [
        "children",
        "innerProps",
        "xcss"
    ]);
    const { css, className } = (0, _getStyleProps.getStyleProps)((0, _objectSpreadProps._)((0, _objectSpread._)({}, restProps), {
        children,
        innerProps
    }), 'noOptionsMessage', {
        'menu-notice': true,
        'menu-notice--no-options': true
    });
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", (0, _objectSpreadProps._)((0, _objectSpread._)({
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop, @atlaskit/ui-styling-standard/local-cx-xcss, @compiled/local-cx-xcss
        className: (0, _runtime.ax)([
            "_85i5u2gc _1q51u2gc _y4tiutpp _bozgutpp _y3gn1h6o",
            (0, _react1.cx)(className, xcss, '-NoOptionsMessage')
        ]),
        // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop
        style: css,
        // eslint-disable-next-line @atlassian/a11y/role-has-required-aria-props
        role: "option"
    }, innerProps), {
        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _compiled.Text), {
            color: "color.text.subtle",
            children: children
        })
    }));
};

},{"@swc/helpers/_/_object_spread":"9gdrV","@swc/helpers/_/_object_spread_props":"kANqQ","@swc/helpers/_/_object_without_properties":"6HqIM","react/jsx-runtime":"bGvcw","react":"ltHCL","@compiled/react/runtime":"d27Vo","@compiled/react":"MfI9Z","@atlaskit/primitives/compiled":"hDay7","../get-style-props":"lzdjl","@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"d2rcK":[function(require,module,exports,__globalThis) {
/* menu-portal.tsx generated by @compiled/babel-plugin v0.39.1 */ var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "MenuPortal", ()=>MenuPortal);
var _objectSpread = require("@swc/helpers/_/_object_spread");
var _objectSpreadProps = require("@swc/helpers/_/_object_spread_props");
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _runtime = require("@compiled/react/runtime");
var _react1 = require("@compiled/react");
var _dom = require("@floating-ui/dom");
var _reactDom = require("react-dom");
var _platformFeatureFlags = require("@atlaskit/platform-feature-flags");
var _getStyleProps = require("../get-style-props");
var _portalPlacementContext = require("../internal/portal-placement-context");
var _menuPortalTopLayer = require("./menu-portal-top-layer");
function getBoundingClientObj(element) {
    const rect = element.getBoundingClientRect();
    return {
        bottom: rect.bottom,
        height: rect.height,
        left: rect.left,
        right: rect.right,
        top: rect.top,
        width: rect.width
    };
}
const coercePlacement = (p)=>p === 'auto' ? 'bottom' : p;
const menuPortalStyles = {
    root: "_1pbykb7n _1e02a1vk _kqswcp1v _152t1nmo _1bsb1qxj"
};
// eslint-disable-next-line @repo/internal/react/require-jsdoc
function MenuPortalLegacy(props) {
    const { appendTo, children, controlElement, innerProps, menuPlacement, menuPosition, xcss } = props;
    const menuPortalRef = (0, _react.useRef)(null);
    const cleanupRef = (0, _react.useRef)(null);
    const [placement, setPortalPlacement] = (0, _react.useState)(coercePlacement(menuPlacement));
    const portalPlacementContext = (0, _react.useMemo)(()=>({
            setPortalPlacement
        }), []);
    const [computedPosition, setComputedPosition] = (0, _react.useState)(null);
    const updateComputedPosition = (0, _react.useCallback)(()=>{
        if (!controlElement) return;
        const rect = getBoundingClientObj(controlElement);
        const scrollDistance = menuPosition === 'fixed' ? 0 : window.pageYOffset;
        const offset = rect[placement] + scrollDistance;
        if (offset !== (computedPosition === null || computedPosition === void 0 ? void 0 : computedPosition.offset) || rect.left !== (computedPosition === null || computedPosition === void 0 ? void 0 : computedPosition.rect.left) || rect.width !== (computedPosition === null || computedPosition === void 0 ? void 0 : computedPosition.rect.width)) setComputedPosition({
            offset,
            rect
        });
    }, [
        controlElement,
        menuPosition,
        placement,
        computedPosition === null || computedPosition === void 0 ? void 0 : computedPosition.offset,
        computedPosition === null || computedPosition === void 0 ? void 0 : computedPosition.rect.left,
        computedPosition === null || computedPosition === void 0 ? void 0 : computedPosition.rect.width
    ]);
    (0, _react.useLayoutEffect)(()=>{
        updateComputedPosition();
    }, [
        updateComputedPosition
    ]);
    const runAutoUpdate = (0, _react.useCallback)(()=>{
        if (typeof cleanupRef.current === 'function') {
            cleanupRef.current();
            cleanupRef.current = null;
        }
        if (controlElement && menuPortalRef.current) cleanupRef.current = (0, _dom.autoUpdate)(controlElement, menuPortalRef.current, updateComputedPosition, {
            elementResize: 'ResizeObserver' in window
        });
    }, [
        controlElement,
        updateComputedPosition
    ]);
    (0, _react.useLayoutEffect)(()=>{
        runAutoUpdate();
    }, [
        runAutoUpdate
    ]);
    const setMenuPortalElement = (0, _react.useCallback)((menuPortalElement)=>{
        menuPortalRef.current = menuPortalElement;
        runAutoUpdate();
    }, [
        runAutoUpdate
    ]);
    // Legacy quirk: `computedPosition` is null until the layout effect runs,
    // so the first render returns null even with `defaultMenuIsOpen` set.
    // Synchronous observers (VR snapshots) see a one-frame "closed" state.
    // Left as-is; the top-layer path supersedes this and positions declaratively.
    if (!appendTo && menuPosition !== 'fixed' || !computedPosition) return null;
    const { css, className } = (0, _getStyleProps.getStyleProps)((0, _objectSpreadProps._)((0, _objectSpread._)({}, props), {
        offset: computedPosition.offset,
        position: menuPosition,
        rect: computedPosition.rect
    }), 'menuPortal', {
        'menu-portal': true
    });
    // same wrapper element whether fixed or portalled
    const menuWrapper = /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", (0, _objectSpreadProps._)((0, _objectSpread._)({
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop, @atlaskit/ui-styling-standard/local-cx-xcss, @compiled/local-cx-xcss
        className: (0, _runtime.ax)([
            menuPortalStyles.root,
            (0, _react1.cx)(className, xcss, '-MenuPortal')
        ]),
        ref: setMenuPortalElement,
        style: (0, _objectSpread._)({
            // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop
            '--menu-left': `${computedPosition.rect.left}px`,
            '--menu-position': menuPosition,
            '--menu-top': `${computedPosition.offset}px`,
            '--menu-width': `${computedPosition.rect.width}px`
        }, css)
    }, innerProps), {
        children: children
    }));
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _portalPlacementContext.PortalPlacementContext).Provider, {
        value: portalPlacementContext,
        children: appendTo ? /*#__PURE__*/ (0, _reactDom.createPortal)(menuWrapper, appendTo) : menuWrapper
    });
}
const MenuPortal = (props)=>{
    if ((0, _platformFeatureFlags.fg)('platform-dst-top-layer')) // eslint-disable-next-line @repo/internal/react/no-unsafe-spread-props
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _menuPortalTopLayer.MenuPortalTopLayer), (0, _objectSpread._)({}, props));
    // eslint-disable-next-line @repo/internal/react/no-unsafe-spread-props
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)(MenuPortalLegacy, (0, _objectSpread._)({}, props));
};

},{"@swc/helpers/_/_object_spread":"9gdrV","@swc/helpers/_/_object_spread_props":"kANqQ","react/jsx-runtime":"bGvcw","react":"ltHCL","@compiled/react/runtime":"d27Vo","@compiled/react":"MfI9Z","@floating-ui/dom":"3zrVe","react-dom":"7Lblg","@atlaskit/platform-feature-flags":"8rD2i","../get-style-props":"lzdjl","../internal/portal-placement-context":"bvI6u","./menu-portal-top-layer":"77ZgW","@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"3zrVe":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "getOverflowAncestors", ()=>(0, _dom.getOverflowAncestors));
parcelHelpers.export(exports, "arrow", ()=>arrow);
parcelHelpers.export(exports, "autoPlacement", ()=>autoPlacement);
parcelHelpers.export(exports, "autoUpdate", ()=>autoUpdate);
parcelHelpers.export(exports, "computePosition", ()=>computePosition);
parcelHelpers.export(exports, "detectOverflow", ()=>detectOverflow);
parcelHelpers.export(exports, "flip", ()=>flip);
parcelHelpers.export(exports, "hide", ()=>hide);
parcelHelpers.export(exports, "inline", ()=>inline);
parcelHelpers.export(exports, "limitShift", ()=>limitShift);
parcelHelpers.export(exports, "offset", ()=>offset);
parcelHelpers.export(exports, "platform", ()=>platform);
parcelHelpers.export(exports, "shift", ()=>shift);
parcelHelpers.export(exports, "size", ()=>size);
var _objectSpread = require("@swc/helpers/_/_object_spread");
var _objectSpreadProps = require("@swc/helpers/_/_object_spread_props");
var _core = require("@floating-ui/core");
var _utils = require("@floating-ui/utils");
var _dom = require("@floating-ui/utils/dom");
function getCssDimensions(element) {
    const css = (0, _dom.getComputedStyle)(element);
    // In testing environments, the `width` and `height` properties are empty
    // strings for SVG elements, returning NaN. Fallback to `0` in this case.
    let width = parseFloat(css.width) || 0;
    let height = parseFloat(css.height) || 0;
    const hasOffset = (0, _dom.isHTMLElement)(element);
    const offsetWidth = hasOffset ? element.offsetWidth : width;
    const offsetHeight = hasOffset ? element.offsetHeight : height;
    const shouldFallback = (0, _utils.round)(width) !== offsetWidth || (0, _utils.round)(height) !== offsetHeight;
    if (shouldFallback) {
        width = offsetWidth;
        height = offsetHeight;
    }
    return {
        width,
        height,
        $: shouldFallback
    };
}
function unwrapElement(element) {
    return !(0, _dom.isElement)(element) ? element.contextElement : element;
}
function getScale(element) {
    const domElement = unwrapElement(element);
    if (!(0, _dom.isHTMLElement)(domElement)) return (0, _utils.createCoords)(1);
    const rect = domElement.getBoundingClientRect();
    const { width, height, $ } = getCssDimensions(domElement);
    let x = ($ ? (0, _utils.round)(rect.width) : rect.width) / width;
    let y = ($ ? (0, _utils.round)(rect.height) : rect.height) / height;
    // 0, NaN, or Infinity should always fallback to 1.
    if (!x || !Number.isFinite(x)) x = 1;
    if (!y || !Number.isFinite(y)) y = 1;
    return {
        x,
        y
    };
}
const noOffsets = /*#__PURE__*/ (0, _utils.createCoords)(0);
function getVisualOffsets(element) {
    const win = (0, _dom.getWindow)(element);
    if (!(0, _dom.isWebKit)() || !win.visualViewport) return noOffsets;
    return {
        x: win.visualViewport.offsetLeft,
        y: win.visualViewport.offsetTop
    };
}
function shouldAddVisualOffsets(element, isFixed, floatingOffsetParent) {
    if (isFixed === void 0) isFixed = false;
    if (!floatingOffsetParent || isFixed && floatingOffsetParent !== (0, _dom.getWindow)(element)) return false;
    return isFixed;
}
function getBoundingClientRect(element, includeScale, isFixedStrategy, offsetParent) {
    if (includeScale === void 0) includeScale = false;
    if (isFixedStrategy === void 0) isFixedStrategy = false;
    const clientRect = element.getBoundingClientRect();
    const domElement = unwrapElement(element);
    let scale = (0, _utils.createCoords)(1);
    if (includeScale) {
        if (offsetParent) {
            if ((0, _dom.isElement)(offsetParent)) scale = getScale(offsetParent);
        } else scale = getScale(element);
    }
    const visualOffsets = shouldAddVisualOffsets(domElement, isFixedStrategy, offsetParent) ? getVisualOffsets(domElement) : (0, _utils.createCoords)(0);
    let x = (clientRect.left + visualOffsets.x) / scale.x;
    let y = (clientRect.top + visualOffsets.y) / scale.y;
    let width = clientRect.width / scale.x;
    let height = clientRect.height / scale.y;
    if (domElement) {
        const win = (0, _dom.getWindow)(domElement);
        const offsetWin = offsetParent && (0, _dom.isElement)(offsetParent) ? (0, _dom.getWindow)(offsetParent) : offsetParent;
        let currentWin = win;
        let currentIFrame = (0, _dom.getFrameElement)(currentWin);
        while(currentIFrame && offsetParent && offsetWin !== currentWin){
            const iframeScale = getScale(currentIFrame);
            const iframeRect = currentIFrame.getBoundingClientRect();
            const css = (0, _dom.getComputedStyle)(currentIFrame);
            const left = iframeRect.left + (currentIFrame.clientLeft + parseFloat(css.paddingLeft)) * iframeScale.x;
            const top = iframeRect.top + (currentIFrame.clientTop + parseFloat(css.paddingTop)) * iframeScale.y;
            x *= iframeScale.x;
            y *= iframeScale.y;
            width *= iframeScale.x;
            height *= iframeScale.y;
            x += left;
            y += top;
            currentWin = (0, _dom.getWindow)(currentIFrame);
            currentIFrame = (0, _dom.getFrameElement)(currentWin);
        }
    }
    return (0, _core.rectToClientRect)({
        width,
        height,
        x,
        y
    });
}
// If <html> has a CSS width greater than the viewport, then this will be
// incorrect for RTL.
function getWindowScrollBarX(element, rect) {
    const leftScroll = (0, _dom.getNodeScroll)(element).scrollLeft;
    if (!rect) return getBoundingClientRect((0, _dom.getDocumentElement)(element)).left + leftScroll;
    return rect.left + leftScroll;
}
function getHTMLOffset(documentElement, scroll) {
    const htmlRect = documentElement.getBoundingClientRect();
    const x = htmlRect.left + scroll.scrollLeft - getWindowScrollBarX(documentElement, htmlRect);
    const y = htmlRect.top + scroll.scrollTop;
    return {
        x,
        y
    };
}
function convertOffsetParentRelativeRectToViewportRelativeRect(_ref) {
    let { elements, rect, offsetParent, strategy } = _ref;
    const isFixed = strategy === 'fixed';
    const documentElement = (0, _dom.getDocumentElement)(offsetParent);
    const topLayer = elements ? (0, _dom.isTopLayer)(elements.floating) : false;
    if (offsetParent === documentElement || topLayer && isFixed) return rect;
    let scroll = {
        scrollLeft: 0,
        scrollTop: 0
    };
    let scale = (0, _utils.createCoords)(1);
    const offsets = (0, _utils.createCoords)(0);
    const isOffsetParentAnElement = (0, _dom.isHTMLElement)(offsetParent);
    if (isOffsetParentAnElement || !isOffsetParentAnElement && !isFixed) {
        if ((0, _dom.getNodeName)(offsetParent) !== 'body' || (0, _dom.isOverflowElement)(documentElement)) scroll = (0, _dom.getNodeScroll)(offsetParent);
        if (isOffsetParentAnElement) {
            const offsetRect = getBoundingClientRect(offsetParent);
            scale = getScale(offsetParent);
            offsets.x = offsetRect.x + offsetParent.clientLeft;
            offsets.y = offsetRect.y + offsetParent.clientTop;
        }
    }
    const htmlOffset = documentElement && !isOffsetParentAnElement && !isFixed ? getHTMLOffset(documentElement, scroll) : (0, _utils.createCoords)(0);
    return {
        width: rect.width * scale.x,
        height: rect.height * scale.y,
        x: rect.x * scale.x - scroll.scrollLeft * scale.x + offsets.x + htmlOffset.x,
        y: rect.y * scale.y - scroll.scrollTop * scale.y + offsets.y + htmlOffset.y
    };
}
function getClientRects(element) {
    return Array.from(element.getClientRects());
}
// Gets the entire size of the scrollable document area, even extending outside
// of the `<html>` and `<body>` rect bounds if horizontally scrollable.
function getDocumentRect(element) {
    const html = (0, _dom.getDocumentElement)(element);
    const scroll = (0, _dom.getNodeScroll)(element);
    const body = element.ownerDocument.body;
    const width = (0, _utils.max)(html.scrollWidth, html.clientWidth, body.scrollWidth, body.clientWidth);
    const height = (0, _utils.max)(html.scrollHeight, html.clientHeight, body.scrollHeight, body.clientHeight);
    let x = -scroll.scrollLeft + getWindowScrollBarX(element);
    const y = -scroll.scrollTop;
    if ((0, _dom.getComputedStyle)(body).direction === 'rtl') x += (0, _utils.max)(html.clientWidth, body.clientWidth) - width;
    return {
        width,
        height,
        x,
        y
    };
}
// Safety check: ensure the scrollbar space is reasonable in case this
// calculation is affected by unusual styles.
// Most scrollbars leave 15-18px of space.
const SCROLLBAR_MAX = 25;
function getViewportRect(element, strategy) {
    const win = (0, _dom.getWindow)(element);
    const html = (0, _dom.getDocumentElement)(element);
    const visualViewport = win.visualViewport;
    let width = html.clientWidth;
    let height = html.clientHeight;
    let x = 0;
    let y = 0;
    if (visualViewport) {
        width = visualViewport.width;
        height = visualViewport.height;
        const visualViewportBased = (0, _dom.isWebKit)();
        if (!visualViewportBased || visualViewportBased && strategy === 'fixed') {
            x = visualViewport.offsetLeft;
            y = visualViewport.offsetTop;
        }
    }
    const windowScrollbarX = getWindowScrollBarX(html);
    // <html> `overflow: hidden` + `scrollbar-gutter: stable` reduces the
    // visual width of the <html> but this is not considered in the size
    // of `html.clientWidth`.
    if (windowScrollbarX <= 0) {
        const doc = html.ownerDocument;
        const body = doc.body;
        const bodyStyles = getComputedStyle(body);
        const bodyMarginInline = doc.compatMode === 'CSS1Compat' ? parseFloat(bodyStyles.marginLeft) + parseFloat(bodyStyles.marginRight) || 0 : 0;
        const clippingStableScrollbarWidth = Math.abs(html.clientWidth - body.clientWidth - bodyMarginInline);
        if (clippingStableScrollbarWidth <= SCROLLBAR_MAX) width -= clippingStableScrollbarWidth;
    } else if (windowScrollbarX <= SCROLLBAR_MAX) // If the <body> scrollbar is on the left, the width needs to be extended
    // by the scrollbar amount so there isn't extra space on the right.
    width += windowScrollbarX;
    return {
        width,
        height,
        x,
        y
    };
}
// Returns the inner client rect, subtracting scrollbars if present.
function getInnerBoundingClientRect(element, strategy) {
    const clientRect = getBoundingClientRect(element, true, strategy === 'fixed');
    const top = clientRect.top + element.clientTop;
    const left = clientRect.left + element.clientLeft;
    const scale = (0, _dom.isHTMLElement)(element) ? getScale(element) : (0, _utils.createCoords)(1);
    const width = element.clientWidth * scale.x;
    const height = element.clientHeight * scale.y;
    const x = left * scale.x;
    const y = top * scale.y;
    return {
        width,
        height,
        x,
        y
    };
}
function getClientRectFromClippingAncestor(element, clippingAncestor, strategy) {
    let rect;
    if (clippingAncestor === 'viewport') rect = getViewportRect(element, strategy);
    else if (clippingAncestor === 'document') rect = getDocumentRect((0, _dom.getDocumentElement)(element));
    else if ((0, _dom.isElement)(clippingAncestor)) rect = getInnerBoundingClientRect(clippingAncestor, strategy);
    else {
        const visualOffsets = getVisualOffsets(element);
        rect = {
            x: clippingAncestor.x - visualOffsets.x,
            y: clippingAncestor.y - visualOffsets.y,
            width: clippingAncestor.width,
            height: clippingAncestor.height
        };
    }
    return (0, _core.rectToClientRect)(rect);
}
function hasFixedPositionAncestor(element, stopNode) {
    const parentNode = (0, _dom.getParentNode)(element);
    if (parentNode === stopNode || !(0, _dom.isElement)(parentNode) || (0, _dom.isLastTraversableNode)(parentNode)) return false;
    return (0, _dom.getComputedStyle)(parentNode).position === 'fixed' || hasFixedPositionAncestor(parentNode, stopNode);
}
// A "clipping ancestor" is an `overflow` element with the characteristic of
// clipping (or hiding) child elements. This returns all clipping ancestors
// of the given element up the tree.
function getClippingElementAncestors(element, cache) {
    const cachedResult = cache.get(element);
    if (cachedResult) return cachedResult;
    let result = (0, _dom.getOverflowAncestors)(element, [], false).filter((el)=>(0, _dom.isElement)(el) && (0, _dom.getNodeName)(el) !== 'body');
    let currentContainingBlockComputedStyle = null;
    const elementIsFixed = (0, _dom.getComputedStyle)(element).position === 'fixed';
    let currentNode = elementIsFixed ? (0, _dom.getParentNode)(element) : element;
    // https://developer.mozilla.org/en-US/docs/Web/CSS/Containing_block#identifying_the_containing_block
    while((0, _dom.isElement)(currentNode) && !(0, _dom.isLastTraversableNode)(currentNode)){
        const computedStyle = (0, _dom.getComputedStyle)(currentNode);
        const currentNodeIsContaining = (0, _dom.isContainingBlock)(currentNode);
        if (!currentNodeIsContaining && computedStyle.position === 'fixed') currentContainingBlockComputedStyle = null;
        const shouldDropCurrentNode = elementIsFixed ? !currentNodeIsContaining && !currentContainingBlockComputedStyle : !currentNodeIsContaining && computedStyle.position === 'static' && !!currentContainingBlockComputedStyle && (currentContainingBlockComputedStyle.position === 'absolute' || currentContainingBlockComputedStyle.position === 'fixed') || (0, _dom.isOverflowElement)(currentNode) && !currentNodeIsContaining && hasFixedPositionAncestor(element, currentNode);
        if (shouldDropCurrentNode) // Drop non-containing blocks.
        result = result.filter((ancestor)=>ancestor !== currentNode);
        else // Record last containing block for next iteration.
        currentContainingBlockComputedStyle = computedStyle;
        currentNode = (0, _dom.getParentNode)(currentNode);
    }
    cache.set(element, result);
    return result;
}
// Gets the maximum area that the element is visible in due to any number of
// clipping ancestors.
function getClippingRect(_ref) {
    let { element, boundary, rootBoundary, strategy } = _ref;
    const elementClippingAncestors = boundary === 'clippingAncestors' ? (0, _dom.isTopLayer)(element) ? [] : getClippingElementAncestors(element, this._c) : [].concat(boundary);
    const clippingAncestors = [
        ...elementClippingAncestors,
        rootBoundary
    ];
    const firstRect = getClientRectFromClippingAncestor(element, clippingAncestors[0], strategy);
    let top = firstRect.top;
    let right = firstRect.right;
    let bottom = firstRect.bottom;
    let left = firstRect.left;
    for(let i = 1; i < clippingAncestors.length; i++){
        const rect = getClientRectFromClippingAncestor(element, clippingAncestors[i], strategy);
        top = (0, _utils.max)(rect.top, top);
        right = (0, _utils.min)(rect.right, right);
        bottom = (0, _utils.min)(rect.bottom, bottom);
        left = (0, _utils.max)(rect.left, left);
    }
    return {
        width: right - left,
        height: bottom - top,
        x: left,
        y: top
    };
}
function getDimensions(element) {
    const { width, height } = getCssDimensions(element);
    return {
        width,
        height
    };
}
function getRectRelativeToOffsetParent(element, offsetParent, strategy) {
    const isOffsetParentAnElement = (0, _dom.isHTMLElement)(offsetParent);
    const documentElement = (0, _dom.getDocumentElement)(offsetParent);
    const isFixed = strategy === 'fixed';
    const rect = getBoundingClientRect(element, true, isFixed, offsetParent);
    let scroll = {
        scrollLeft: 0,
        scrollTop: 0
    };
    const offsets = (0, _utils.createCoords)(0);
    // If the <body> scrollbar appears on the left (e.g. RTL systems). Use
    // Firefox with layout.scrollbar.side = 3 in about:config to test this.
    function setLeftRTLScrollbarOffset() {
        offsets.x = getWindowScrollBarX(documentElement);
    }
    if (isOffsetParentAnElement || !isOffsetParentAnElement && !isFixed) {
        if ((0, _dom.getNodeName)(offsetParent) !== 'body' || (0, _dom.isOverflowElement)(documentElement)) scroll = (0, _dom.getNodeScroll)(offsetParent);
        if (isOffsetParentAnElement) {
            const offsetRect = getBoundingClientRect(offsetParent, true, isFixed, offsetParent);
            offsets.x = offsetRect.x + offsetParent.clientLeft;
            offsets.y = offsetRect.y + offsetParent.clientTop;
        } else if (documentElement) setLeftRTLScrollbarOffset();
    }
    if (isFixed && !isOffsetParentAnElement && documentElement) setLeftRTLScrollbarOffset();
    const htmlOffset = documentElement && !isOffsetParentAnElement && !isFixed ? getHTMLOffset(documentElement, scroll) : (0, _utils.createCoords)(0);
    const x = rect.left + scroll.scrollLeft - offsets.x - htmlOffset.x;
    const y = rect.top + scroll.scrollTop - offsets.y - htmlOffset.y;
    return {
        x,
        y,
        width: rect.width,
        height: rect.height
    };
}
function isStaticPositioned(element) {
    return (0, _dom.getComputedStyle)(element).position === 'static';
}
function getTrueOffsetParent(element, polyfill) {
    if (!(0, _dom.isHTMLElement)(element) || (0, _dom.getComputedStyle)(element).position === 'fixed') return null;
    if (polyfill) return polyfill(element);
    let rawOffsetParent = element.offsetParent;
    // Firefox returns the <html> element as the offsetParent if it's non-static,
    // while Chrome and Safari return the <body> element. The <body> element must
    // be used to perform the correct calculations even if the <html> element is
    // non-static.
    if ((0, _dom.getDocumentElement)(element) === rawOffsetParent) rawOffsetParent = rawOffsetParent.ownerDocument.body;
    return rawOffsetParent;
}
// Gets the closest ancestor positioned element. Handles some edge cases,
// such as table ancestors and cross browser bugs.
function getOffsetParent(element, polyfill) {
    const win = (0, _dom.getWindow)(element);
    if ((0, _dom.isTopLayer)(element)) return win;
    if (!(0, _dom.isHTMLElement)(element)) {
        let svgOffsetParent = (0, _dom.getParentNode)(element);
        while(svgOffsetParent && !(0, _dom.isLastTraversableNode)(svgOffsetParent)){
            if ((0, _dom.isElement)(svgOffsetParent) && !isStaticPositioned(svgOffsetParent)) return svgOffsetParent;
            svgOffsetParent = (0, _dom.getParentNode)(svgOffsetParent);
        }
        return win;
    }
    let offsetParent = getTrueOffsetParent(element, polyfill);
    while(offsetParent && (0, _dom.isTableElement)(offsetParent) && isStaticPositioned(offsetParent))offsetParent = getTrueOffsetParent(offsetParent, polyfill);
    if (offsetParent && (0, _dom.isLastTraversableNode)(offsetParent) && isStaticPositioned(offsetParent) && !(0, _dom.isContainingBlock)(offsetParent)) return win;
    return offsetParent || (0, _dom.getContainingBlock)(element) || win;
}
const getElementRects = async function(data) {
    const getOffsetParentFn = this.getOffsetParent || getOffsetParent;
    const getDimensionsFn = this.getDimensions;
    const floatingDimensions = await getDimensionsFn(data.floating);
    return {
        reference: getRectRelativeToOffsetParent(data.reference, await getOffsetParentFn(data.floating), data.strategy),
        floating: {
            x: 0,
            y: 0,
            width: floatingDimensions.width,
            height: floatingDimensions.height
        }
    };
};
function isRTL(element) {
    return (0, _dom.getComputedStyle)(element).direction === 'rtl';
}
const platform = {
    convertOffsetParentRelativeRectToViewportRelativeRect,
    getDocumentElement: (0, _dom.getDocumentElement),
    getClippingRect,
    getOffsetParent,
    getElementRects,
    getClientRects,
    getDimensions,
    getScale,
    isElement: (0, _dom.isElement),
    isRTL
};
function rectsAreEqual(a, b) {
    return a.x === b.x && a.y === b.y && a.width === b.width && a.height === b.height;
}
// https://samthor.au/2021/observing-dom/
function observeMove(element, onMove) {
    let io = null;
    let timeoutId;
    const root = (0, _dom.getDocumentElement)(element);
    function cleanup() {
        var _io;
        clearTimeout(timeoutId);
        (_io = io) == null || _io.disconnect();
        io = null;
    }
    function refresh(skip, threshold) {
        if (skip === void 0) skip = false;
        if (threshold === void 0) threshold = 1;
        cleanup();
        const elementRectForRootMargin = element.getBoundingClientRect();
        const { left, top, width, height } = elementRectForRootMargin;
        if (!skip) onMove();
        if (!width || !height) return;
        const insetTop = (0, _utils.floor)(top);
        const insetRight = (0, _utils.floor)(root.clientWidth - (left + width));
        const insetBottom = (0, _utils.floor)(root.clientHeight - (top + height));
        const insetLeft = (0, _utils.floor)(left);
        const rootMargin = -insetTop + "px " + -insetRight + "px " + -insetBottom + "px " + -insetLeft + "px";
        const options = {
            rootMargin,
            threshold: (0, _utils.max)(0, (0, _utils.min)(1, threshold)) || 1
        };
        let isFirstUpdate = true;
        function handleObserve(entries) {
            const ratio = entries[0].intersectionRatio;
            if (ratio !== threshold) {
                if (!isFirstUpdate) return refresh();
                if (!ratio) // If the reference is clipped, the ratio is 0. Throttle the refresh
                // to prevent an infinite loop of updates.
                timeoutId = setTimeout(()=>{
                    refresh(false, 1e-7);
                }, 1000);
                else refresh(false, ratio);
            }
            if (ratio === 1 && !rectsAreEqual(elementRectForRootMargin, element.getBoundingClientRect())) // It's possible that even though the ratio is reported as 1, the
            // element is not actually fully within the IntersectionObserver's root
            // area anymore. This can happen under performance constraints. This may
            // be a bug in the browser's IntersectionObserver implementation. To
            // work around this, we compare the element's bounding rect now with
            // what it was at the time we created the IntersectionObserver. If they
            // are not equal then the element moved, so we refresh.
            refresh();
            isFirstUpdate = false;
        }
        // Older browsers don't support a `document` as the root and will throw an
        // error.
        try {
            io = new IntersectionObserver(handleObserve, (0, _objectSpreadProps._)((0, _objectSpread._)({}, options), {
                // Handle <iframe>s
                root: root.ownerDocument
            }));
        } catch (_e) {
            io = new IntersectionObserver(handleObserve, options);
        }
        io.observe(element);
    }
    refresh(true);
    return cleanup;
}
/**
 * Automatically updates the position of the floating element when necessary.
 * Should only be called when the floating element is mounted on the DOM or
 * visible on the screen.
 * @returns cleanup function that should be invoked when the floating element is
 * removed from the DOM or hidden from the screen.
 * @see https://floating-ui.com/docs/autoUpdate
 */ function autoUpdate(reference, floating, update, options) {
    if (options === void 0) options = {};
    const { ancestorScroll = true, ancestorResize = true, elementResize = typeof ResizeObserver === 'function', layoutShift = typeof IntersectionObserver === 'function', animationFrame = false } = options;
    const referenceEl = unwrapElement(reference);
    const ancestors = ancestorScroll || ancestorResize ? [
        ...referenceEl ? (0, _dom.getOverflowAncestors)(referenceEl) : [],
        ...floating ? (0, _dom.getOverflowAncestors)(floating) : []
    ] : [];
    ancestors.forEach((ancestor)=>{
        ancestorScroll && ancestor.addEventListener('scroll', update, {
            passive: true
        });
        ancestorResize && ancestor.addEventListener('resize', update);
    });
    const cleanupIo = referenceEl && layoutShift ? observeMove(referenceEl, update) : null;
    let reobserveFrame = -1;
    let resizeObserver = null;
    if (elementResize) {
        resizeObserver = new ResizeObserver((_ref)=>{
            let [firstEntry] = _ref;
            if (firstEntry && firstEntry.target === referenceEl && resizeObserver && floating) {
                // Prevent update loops when using the `size` middleware.
                // https://github.com/floating-ui/floating-ui/issues/1740
                resizeObserver.unobserve(floating);
                cancelAnimationFrame(reobserveFrame);
                reobserveFrame = requestAnimationFrame(()=>{
                    var _resizeObserver;
                    (_resizeObserver = resizeObserver) == null || _resizeObserver.observe(floating);
                });
            }
            update();
        });
        if (referenceEl && !animationFrame) resizeObserver.observe(referenceEl);
        if (floating) resizeObserver.observe(floating);
    }
    let frameId;
    let prevRefRect = animationFrame ? getBoundingClientRect(reference) : null;
    if (animationFrame) frameLoop();
    function frameLoop() {
        const nextRefRect = getBoundingClientRect(reference);
        if (prevRefRect && !rectsAreEqual(prevRefRect, nextRefRect)) update();
        prevRefRect = nextRefRect;
        frameId = requestAnimationFrame(frameLoop);
    }
    update();
    return ()=>{
        var _resizeObserver2;
        ancestors.forEach((ancestor)=>{
            ancestorScroll && ancestor.removeEventListener('scroll', update);
            ancestorResize && ancestor.removeEventListener('resize', update);
        });
        cleanupIo == null || cleanupIo();
        (_resizeObserver2 = resizeObserver) == null || _resizeObserver2.disconnect();
        resizeObserver = null;
        if (animationFrame) cancelAnimationFrame(frameId);
    };
}
/**
 * Resolves with an object of overflow side offsets that determine how much the
 * element is overflowing a given clipping boundary on each side.
 * - positive = overflowing the boundary by that number of pixels
 * - negative = how many pixels left before it will overflow
 * - 0 = lies flush with the boundary
 * @see https://floating-ui.com/docs/detectOverflow
 */ const detectOverflow = (0, _core.detectOverflow);
/**
 * Modifies the placement by translating the floating element along the
 * specified axes.
 * A number (shorthand for `mainAxis` or distance), or an axes configuration
 * object may be passed.
 * @see https://floating-ui.com/docs/offset
 */ const offset = (0, _core.offset);
/**
 * Optimizes the visibility of the floating element by choosing the placement
 * that has the most space available automatically, without needing to specify a
 * preferred placement. Alternative to `flip`.
 * @see https://floating-ui.com/docs/autoPlacement
 */ const autoPlacement = (0, _core.autoPlacement);
/**
 * Optimizes the visibility of the floating element by shifting it in order to
 * keep it in view when it will overflow the clipping boundary.
 * @see https://floating-ui.com/docs/shift
 */ const shift = (0, _core.shift);
/**
 * Optimizes the visibility of the floating element by flipping the `placement`
 * in order to keep it in view when the preferred placement(s) will overflow the
 * clipping boundary. Alternative to `autoPlacement`.
 * @see https://floating-ui.com/docs/flip
 */ const flip = (0, _core.flip);
/**
 * Provides data that allows you to change the size of the floating element —
 * for instance, prevent it from overflowing the clipping boundary or match the
 * width of the reference element.
 * @see https://floating-ui.com/docs/size
 */ const size = (0, _core.size);
/**
 * Provides data to hide the floating element in applicable situations, such as
 * when it is not in the same clipping context as the reference element.
 * @see https://floating-ui.com/docs/hide
 */ const hide = (0, _core.hide);
/**
 * Provides data to position an inner element of the floating element so that it
 * appears centered to the reference element.
 * @see https://floating-ui.com/docs/arrow
 */ const arrow = (0, _core.arrow);
/**
 * Provides improved positioning for inline reference elements that can span
 * over multiple lines, such as hyperlinks or range selections.
 * @see https://floating-ui.com/docs/inline
 */ const inline = (0, _core.inline);
/**
 * Built-in `limiter` that will stop `shift()` at a certain point.
 */ const limitShift = (0, _core.limitShift);
/**
 * Computes the `x` and `y` coordinates that will place the floating element
 * next to a given reference element.
 */ const computePosition = (reference, floating, options)=>{
    // This caches the expensive `getClippingElementAncestors` function so that
    // multiple lifecycle resets re-use the same result. It only lives for a
    // single call. If other functions become expensive, we can add them as well.
    const cache = new Map();
    const mergedOptions = (0, _objectSpread._)({
        platform
    }, options);
    const platformWithCache = (0, _objectSpreadProps._)((0, _objectSpread._)({}, mergedOptions.platform), {
        _c: cache
    });
    return (0, _core.computePosition)(reference, floating, (0, _objectSpreadProps._)((0, _objectSpread._)({}, mergedOptions), {
        platform: platformWithCache
    }));
};

},{"@swc/helpers/_/_object_spread":"9gdrV","@swc/helpers/_/_object_spread_props":"kANqQ","@floating-ui/core":"kCpFa","@floating-ui/utils":"gVBaK","@floating-ui/utils/dom":"cDpKU","@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"kCpFa":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "rectToClientRect", ()=>(0, _utils.rectToClientRect));
parcelHelpers.export(exports, "arrow", ()=>arrow);
parcelHelpers.export(exports, "autoPlacement", ()=>autoPlacement);
parcelHelpers.export(exports, "computePosition", ()=>computePosition);
parcelHelpers.export(exports, "detectOverflow", ()=>detectOverflow);
parcelHelpers.export(exports, "flip", ()=>flip);
parcelHelpers.export(exports, "hide", ()=>hide);
parcelHelpers.export(exports, "inline", ()=>inline);
parcelHelpers.export(exports, "limitShift", ()=>limitShift);
parcelHelpers.export(exports, "offset", ()=>offset);
parcelHelpers.export(exports, "shift", ()=>shift);
parcelHelpers.export(exports, "size", ()=>size);
var _objectSpread = require("@swc/helpers/_/_object_spread");
var _objectSpreadProps = require("@swc/helpers/_/_object_spread_props");
var _objectWithoutProperties = require("@swc/helpers/_/_object_without_properties");
var _utils = require("@floating-ui/utils");
function computeCoordsFromPlacement(_ref, placement, rtl) {
    let { reference, floating } = _ref;
    const sideAxis = (0, _utils.getSideAxis)(placement);
    const alignmentAxis = (0, _utils.getAlignmentAxis)(placement);
    const alignLength = (0, _utils.getAxisLength)(alignmentAxis);
    const side = (0, _utils.getSide)(placement);
    const isVertical = sideAxis === 'y';
    const commonX = reference.x + reference.width / 2 - floating.width / 2;
    const commonY = reference.y + reference.height / 2 - floating.height / 2;
    const commonAlign = reference[alignLength] / 2 - floating[alignLength] / 2;
    let coords;
    switch(side){
        case 'top':
            coords = {
                x: commonX,
                y: reference.y - floating.height
            };
            break;
        case 'bottom':
            coords = {
                x: commonX,
                y: reference.y + reference.height
            };
            break;
        case 'right':
            coords = {
                x: reference.x + reference.width,
                y: commonY
            };
            break;
        case 'left':
            coords = {
                x: reference.x - floating.width,
                y: commonY
            };
            break;
        default:
            coords = {
                x: reference.x,
                y: reference.y
            };
    }
    switch((0, _utils.getAlignment)(placement)){
        case 'start':
            coords[alignmentAxis] -= commonAlign * (rtl && isVertical ? -1 : 1);
            break;
        case 'end':
            coords[alignmentAxis] += commonAlign * (rtl && isVertical ? -1 : 1);
            break;
    }
    return coords;
}
/**
 * Resolves with an object of overflow side offsets that determine how much the
 * element is overflowing a given clipping boundary on each side.
 * - positive = overflowing the boundary by that number of pixels
 * - negative = how many pixels left before it will overflow
 * - 0 = lies flush with the boundary
 * @see https://floating-ui.com/docs/detectOverflow
 */ async function detectOverflow(state, options) {
    var _await$platform$isEle;
    if (options === void 0) options = {};
    const { x, y, platform, rects, elements, strategy } = state;
    const { boundary = 'clippingAncestors', rootBoundary = 'viewport', elementContext = 'floating', altBoundary = false, padding = 0 } = (0, _utils.evaluate)(options, state);
    const paddingObject = (0, _utils.getPaddingObject)(padding);
    const altContext = elementContext === 'floating' ? 'reference' : 'floating';
    const element = elements[altBoundary ? altContext : elementContext];
    const clippingClientRect = (0, _utils.rectToClientRect)(await platform.getClippingRect({
        element: ((_await$platform$isEle = await (platform.isElement == null ? void 0 : platform.isElement(element))) != null ? _await$platform$isEle : true) ? element : element.contextElement || await (platform.getDocumentElement == null ? void 0 : platform.getDocumentElement(elements.floating)),
        boundary,
        rootBoundary,
        strategy
    }));
    const rect = elementContext === 'floating' ? {
        x,
        y,
        width: rects.floating.width,
        height: rects.floating.height
    } : rects.reference;
    const offsetParent = await (platform.getOffsetParent == null ? void 0 : platform.getOffsetParent(elements.floating));
    const offsetScale = await (platform.isElement == null ? void 0 : platform.isElement(offsetParent)) ? await (platform.getScale == null ? void 0 : platform.getScale(offsetParent)) || {
        x: 1,
        y: 1
    } : {
        x: 1,
        y: 1
    };
    const elementClientRect = (0, _utils.rectToClientRect)(platform.convertOffsetParentRelativeRectToViewportRelativeRect ? await platform.convertOffsetParentRelativeRectToViewportRelativeRect({
        elements,
        rect,
        offsetParent,
        strategy
    }) : rect);
    return {
        top: (clippingClientRect.top - elementClientRect.top + paddingObject.top) / offsetScale.y,
        bottom: (elementClientRect.bottom - clippingClientRect.bottom + paddingObject.bottom) / offsetScale.y,
        left: (clippingClientRect.left - elementClientRect.left + paddingObject.left) / offsetScale.x,
        right: (elementClientRect.right - clippingClientRect.right + paddingObject.right) / offsetScale.x
    };
}
// Maximum number of resets that can occur before bailing to avoid infinite reset loops.
const MAX_RESET_COUNT = 50;
/**
 * Computes the `x` and `y` coordinates that will place the floating element
 * next to a given reference element.
 *
 * This export does not have any `platform` interface logic. You will need to
 * write one for the platform you are using Floating UI with.
 */ const computePosition = async (reference, floating, config)=>{
    const { placement = 'bottom', strategy = 'absolute', middleware = [], platform } = config;
    const platformWithDetectOverflow = platform.detectOverflow ? platform : (0, _objectSpreadProps._)((0, _objectSpread._)({}, platform), {
        detectOverflow
    });
    const rtl = await (platform.isRTL == null ? void 0 : platform.isRTL(floating));
    let rects = await platform.getElementRects({
        reference,
        floating,
        strategy
    });
    let { x, y } = computeCoordsFromPlacement(rects, placement, rtl);
    let statefulPlacement = placement;
    let resetCount = 0;
    const middlewareData = {};
    for(let i = 0; i < middleware.length; i++){
        const currentMiddleware = middleware[i];
        if (!currentMiddleware) continue;
        const { name, fn } = currentMiddleware;
        const { x: nextX, y: nextY, data, reset } = await fn({
            x,
            y,
            initialPlacement: placement,
            placement: statefulPlacement,
            strategy,
            middlewareData,
            rects,
            platform: platformWithDetectOverflow,
            elements: {
                reference,
                floating
            }
        });
        x = nextX != null ? nextX : x;
        y = nextY != null ? nextY : y;
        middlewareData[name] = (0, _objectSpread._)({}, middlewareData[name], data);
        if (reset && resetCount < MAX_RESET_COUNT) {
            resetCount++;
            if (typeof reset === 'object') {
                if (reset.placement) statefulPlacement = reset.placement;
                if (reset.rects) rects = reset.rects === true ? await platform.getElementRects({
                    reference,
                    floating,
                    strategy
                }) : reset.rects;
                ({ x, y } = computeCoordsFromPlacement(rects, statefulPlacement, rtl));
            }
            i = -1;
        }
    }
    return {
        x,
        y,
        placement: statefulPlacement,
        strategy,
        middlewareData
    };
};
/**
 * Provides data to position an inner element of the floating element so that it
 * appears centered to the reference element.
 * @see https://floating-ui.com/docs/arrow
 */ const arrow = (options)=>({
        name: 'arrow',
        options,
        async fn (state) {
            const { x, y, placement, rects, platform, elements, middlewareData } = state;
            // Since `element` is required, we don't Partial<> the type.
            const { element, padding = 0 } = (0, _utils.evaluate)(options, state) || {};
            if (element == null) return {};
            const paddingObject = (0, _utils.getPaddingObject)(padding);
            const coords = {
                x,
                y
            };
            const axis = (0, _utils.getAlignmentAxis)(placement);
            const length = (0, _utils.getAxisLength)(axis);
            const arrowDimensions = await platform.getDimensions(element);
            const isYAxis = axis === 'y';
            const minProp = isYAxis ? 'top' : 'left';
            const maxProp = isYAxis ? 'bottom' : 'right';
            const clientProp = isYAxis ? 'clientHeight' : 'clientWidth';
            const endDiff = rects.reference[length] + rects.reference[axis] - coords[axis] - rects.floating[length];
            const startDiff = coords[axis] - rects.reference[axis];
            const arrowOffsetParent = await (platform.getOffsetParent == null ? void 0 : platform.getOffsetParent(element));
            let clientSize = arrowOffsetParent ? arrowOffsetParent[clientProp] : 0;
            // DOM platform can return `window` as the `offsetParent`.
            if (!clientSize || !await (platform.isElement == null ? void 0 : platform.isElement(arrowOffsetParent))) clientSize = elements.floating[clientProp] || rects.floating[length];
            const centerToReference = endDiff / 2 - startDiff / 2;
            // If the padding is large enough that it causes the arrow to no longer be
            // centered, modify the padding so that it is centered.
            const largestPossiblePadding = clientSize / 2 - arrowDimensions[length] / 2 - 1;
            const minPadding = (0, _utils.min)(paddingObject[minProp], largestPossiblePadding);
            const maxPadding = (0, _utils.min)(paddingObject[maxProp], largestPossiblePadding);
            // Make sure the arrow doesn't overflow the floating element if the center
            // point is outside the floating element's bounds.
            const min$1 = minPadding;
            const max = clientSize - arrowDimensions[length] - maxPadding;
            const center = clientSize / 2 - arrowDimensions[length] / 2 + centerToReference;
            const offset = (0, _utils.clamp)(min$1, center, max);
            // If the reference is small enough that the arrow's padding causes it to
            // to point to nothing for an aligned placement, adjust the offset of the
            // floating element itself. To ensure `shift()` continues to take action,
            // a single reset is performed when this is true.
            const shouldAddOffset = !middlewareData.arrow && (0, _utils.getAlignment)(placement) != null && center !== offset && rects.reference[length] / 2 - (center < min$1 ? minPadding : maxPadding) - arrowDimensions[length] / 2 < 0;
            const alignmentOffset = shouldAddOffset ? center < min$1 ? center - min$1 : center - max : 0;
            return {
                [axis]: coords[axis] + alignmentOffset,
                data: (0, _objectSpread._)({
                    [axis]: offset,
                    centerOffset: center - offset - alignmentOffset
                }, shouldAddOffset && {
                    alignmentOffset
                }),
                reset: shouldAddOffset
            };
        }
    });
function getPlacementList(alignment, autoAlignment, allowedPlacements) {
    const allowedPlacementsSortedByAlignment = alignment ? [
        ...allowedPlacements.filter((placement)=>(0, _utils.getAlignment)(placement) === alignment),
        ...allowedPlacements.filter((placement)=>(0, _utils.getAlignment)(placement) !== alignment)
    ] : allowedPlacements.filter((placement)=>(0, _utils.getSide)(placement) === placement);
    return allowedPlacementsSortedByAlignment.filter((placement)=>{
        if (alignment) return (0, _utils.getAlignment)(placement) === alignment || (autoAlignment ? (0, _utils.getOppositeAlignmentPlacement)(placement) !== placement : false);
        return true;
    });
}
/**
 * Optimizes the visibility of the floating element by choosing the placement
 * that has the most space available automatically, without needing to specify a
 * preferred placement. Alternative to `flip`.
 * @see https://floating-ui.com/docs/autoPlacement
 */ const autoPlacement = function(options) {
    if (options === void 0) options = {};
    return {
        name: 'autoPlacement',
        options,
        async fn (state) {
            var _middlewareData$autoP, _middlewareData$autoP2, _placementsThatFitOnE;
            const { rects, middlewareData, placement, platform, elements } = state;
            const _evaluate = (0, _utils.evaluate)(options, state), { crossAxis = false, alignment, allowedPlacements = (0, _utils.placements), autoAlignment = true } = _evaluate, detectOverflowOptions = (0, _objectWithoutProperties._)(_evaluate, [
                "crossAxis",
                "alignment",
                "allowedPlacements",
                "autoAlignment"
            ]);
            const placements$1 = alignment !== undefined || allowedPlacements === (0, _utils.placements) ? getPlacementList(alignment || null, autoAlignment, allowedPlacements) : allowedPlacements;
            const overflow = await platform.detectOverflow(state, detectOverflowOptions);
            const currentIndex = ((_middlewareData$autoP = middlewareData.autoPlacement) == null ? void 0 : _middlewareData$autoP.index) || 0;
            const currentPlacement = placements$1[currentIndex];
            if (currentPlacement == null) return {};
            const alignmentSides = (0, _utils.getAlignmentSides)(currentPlacement, rects, await (platform.isRTL == null ? void 0 : platform.isRTL(elements.floating)));
            // Make `computeCoords` start from the right place.
            if (placement !== currentPlacement) return {
                reset: {
                    placement: placements$1[0]
                }
            };
            const currentOverflows = [
                overflow[(0, _utils.getSide)(currentPlacement)],
                overflow[alignmentSides[0]],
                overflow[alignmentSides[1]]
            ];
            const allOverflows = [
                ...((_middlewareData$autoP2 = middlewareData.autoPlacement) == null ? void 0 : _middlewareData$autoP2.overflows) || [],
                {
                    placement: currentPlacement,
                    overflows: currentOverflows
                }
            ];
            const nextPlacement = placements$1[currentIndex + 1];
            // There are more placements to check.
            if (nextPlacement) return {
                data: {
                    index: currentIndex + 1,
                    overflows: allOverflows
                },
                reset: {
                    placement: nextPlacement
                }
            };
            const placementsSortedByMostSpace = allOverflows.map((d)=>{
                const alignment = (0, _utils.getAlignment)(d.placement);
                return [
                    d.placement,
                    alignment && crossAxis ? // Check along the mainAxis and main crossAxis side.
                    d.overflows.slice(0, 2).reduce((acc, v)=>acc + v, 0) : // Check only the mainAxis.
                    d.overflows[0],
                    d.overflows
                ];
            }).sort((a, b)=>a[1] - b[1]);
            const placementsThatFitOnEachSide = placementsSortedByMostSpace.filter((d)=>d[2].slice(0, // Aligned placements should not check their opposite crossAxis
                // side.
                (0, _utils.getAlignment)(d[0]) ? 2 : 3).every((v)=>v <= 0));
            const resetPlacement = ((_placementsThatFitOnE = placementsThatFitOnEachSide[0]) == null ? void 0 : _placementsThatFitOnE[0]) || placementsSortedByMostSpace[0][0];
            if (resetPlacement !== placement) return {
                data: {
                    index: currentIndex + 1,
                    overflows: allOverflows
                },
                reset: {
                    placement: resetPlacement
                }
            };
            return {};
        }
    };
};
/**
 * Optimizes the visibility of the floating element by flipping the `placement`
 * in order to keep it in view when the preferred placement(s) will overflow the
 * clipping boundary. Alternative to `autoPlacement`.
 * @see https://floating-ui.com/docs/flip
 */ const flip = function(options) {
    if (options === void 0) options = {};
    return {
        name: 'flip',
        options,
        async fn (state) {
            var _middlewareData$arrow, _middlewareData$flip;
            const { placement, middlewareData, rects, initialPlacement, platform, elements } = state;
            const _evaluate = (0, _utils.evaluate)(options, state), { mainAxis: checkMainAxis = true, crossAxis: checkCrossAxis = true, fallbackPlacements: specifiedFallbackPlacements, fallbackStrategy = 'bestFit', fallbackAxisSideDirection = 'none', flipAlignment = true } = _evaluate, detectOverflowOptions = (0, _objectWithoutProperties._)(_evaluate, [
                "mainAxis",
                "crossAxis",
                "fallbackPlacements",
                "fallbackStrategy",
                "fallbackAxisSideDirection",
                "flipAlignment"
            ]);
            // If a reset by the arrow was caused due to an alignment offset being
            // added, we should skip any logic now since `flip()` has already done its
            // work.
            // https://github.com/floating-ui/floating-ui/issues/2549#issuecomment-1719601643
            if ((_middlewareData$arrow = middlewareData.arrow) != null && _middlewareData$arrow.alignmentOffset) return {};
            const side = (0, _utils.getSide)(placement);
            const initialSideAxis = (0, _utils.getSideAxis)(initialPlacement);
            const isBasePlacement = (0, _utils.getSide)(initialPlacement) === initialPlacement;
            const rtl = await (platform.isRTL == null ? void 0 : platform.isRTL(elements.floating));
            const fallbackPlacements = specifiedFallbackPlacements || (isBasePlacement || !flipAlignment ? [
                (0, _utils.getOppositePlacement)(initialPlacement)
            ] : (0, _utils.getExpandedPlacements)(initialPlacement));
            const hasFallbackAxisSideDirection = fallbackAxisSideDirection !== 'none';
            if (!specifiedFallbackPlacements && hasFallbackAxisSideDirection) fallbackPlacements.push(...(0, _utils.getOppositeAxisPlacements)(initialPlacement, flipAlignment, fallbackAxisSideDirection, rtl));
            const placements = [
                initialPlacement,
                ...fallbackPlacements
            ];
            const overflow = await platform.detectOverflow(state, detectOverflowOptions);
            const overflows = [];
            let overflowsData = ((_middlewareData$flip = middlewareData.flip) == null ? void 0 : _middlewareData$flip.overflows) || [];
            if (checkMainAxis) overflows.push(overflow[side]);
            if (checkCrossAxis) {
                const sides = (0, _utils.getAlignmentSides)(placement, rects, rtl);
                overflows.push(overflow[sides[0]], overflow[sides[1]]);
            }
            overflowsData = [
                ...overflowsData,
                {
                    placement,
                    overflows
                }
            ];
            // One or more sides is overflowing.
            if (!overflows.every((side)=>side <= 0)) {
                var _middlewareData$flip2, _overflowsData$filter;
                const nextIndex = (((_middlewareData$flip2 = middlewareData.flip) == null ? void 0 : _middlewareData$flip2.index) || 0) + 1;
                const nextPlacement = placements[nextIndex];
                if (nextPlacement) {
                    const ignoreCrossAxisOverflow = checkCrossAxis === 'alignment' ? initialSideAxis !== (0, _utils.getSideAxis)(nextPlacement) : false;
                    if (!ignoreCrossAxisOverflow || // We leave the current main axis only if every placement on that axis
                    // overflows the main axis.
                    overflowsData.every((d)=>(0, _utils.getSideAxis)(d.placement) === initialSideAxis ? d.overflows[0] > 0 : true)) // Try next placement and re-run the lifecycle.
                    return {
                        data: {
                            index: nextIndex,
                            overflows: overflowsData
                        },
                        reset: {
                            placement: nextPlacement
                        }
                    };
                }
                // First, find the candidates that fit on the mainAxis side of overflow,
                // then find the placement that fits the best on the main crossAxis side.
                let resetPlacement = (_overflowsData$filter = overflowsData.filter((d)=>d.overflows[0] <= 0).sort((a, b)=>a.overflows[1] - b.overflows[1])[0]) == null ? void 0 : _overflowsData$filter.placement;
                // Otherwise fallback.
                if (!resetPlacement) switch(fallbackStrategy){
                    case 'bestFit':
                        {
                            var _overflowsData$filter2;
                            const placement = (_overflowsData$filter2 = overflowsData.filter((d)=>{
                                if (hasFallbackAxisSideDirection) {
                                    const currentSideAxis = (0, _utils.getSideAxis)(d.placement);
                                    return currentSideAxis === initialSideAxis || // Create a bias to the `y` side axis due to horizontal
                                    // reading directions favoring greater width.
                                    currentSideAxis === 'y';
                                }
                                return true;
                            }).map((d)=>[
                                    d.placement,
                                    d.overflows.filter((overflow)=>overflow > 0).reduce((acc, overflow)=>acc + overflow, 0)
                                ]).sort((a, b)=>a[1] - b[1])[0]) == null ? void 0 : _overflowsData$filter2[0];
                            if (placement) resetPlacement = placement;
                            break;
                        }
                    case 'initialPlacement':
                        resetPlacement = initialPlacement;
                        break;
                }
                if (placement !== resetPlacement) return {
                    reset: {
                        placement: resetPlacement
                    }
                };
            }
            return {};
        }
    };
};
function getSideOffsets(overflow, rect) {
    return {
        top: overflow.top - rect.height,
        right: overflow.right - rect.width,
        bottom: overflow.bottom - rect.height,
        left: overflow.left - rect.width
    };
}
function isAnySideFullyClipped(overflow) {
    return (0, _utils.sides).some((side)=>overflow[side] >= 0);
}
/**
 * Provides data to hide the floating element in applicable situations, such as
 * when it is not in the same clipping context as the reference element.
 * @see https://floating-ui.com/docs/hide
 */ const hide = function(options) {
    if (options === void 0) options = {};
    return {
        name: 'hide',
        options,
        async fn (state) {
            const { rects, platform } = state;
            const _evaluate = (0, _utils.evaluate)(options, state), { strategy = 'referenceHidden' } = _evaluate, detectOverflowOptions = (0, _objectWithoutProperties._)(_evaluate, [
                "strategy"
            ]);
            switch(strategy){
                case 'referenceHidden':
                    {
                        const overflow = await platform.detectOverflow(state, (0, _objectSpreadProps._)((0, _objectSpread._)({}, detectOverflowOptions), {
                            elementContext: 'reference'
                        }));
                        const offsets = getSideOffsets(overflow, rects.reference);
                        return {
                            data: {
                                referenceHiddenOffsets: offsets,
                                referenceHidden: isAnySideFullyClipped(offsets)
                            }
                        };
                    }
                case 'escaped':
                    {
                        const overflow = await platform.detectOverflow(state, (0, _objectSpreadProps._)((0, _objectSpread._)({}, detectOverflowOptions), {
                            altBoundary: true
                        }));
                        const offsets = getSideOffsets(overflow, rects.floating);
                        return {
                            data: {
                                escapedOffsets: offsets,
                                escaped: isAnySideFullyClipped(offsets)
                            }
                        };
                    }
                default:
                    return {};
            }
        }
    };
};
function getBoundingRect(rects) {
    const minX = (0, _utils.min)(...rects.map((rect)=>rect.left));
    const minY = (0, _utils.min)(...rects.map((rect)=>rect.top));
    const maxX = (0, _utils.max)(...rects.map((rect)=>rect.right));
    const maxY = (0, _utils.max)(...rects.map((rect)=>rect.bottom));
    return {
        x: minX,
        y: minY,
        width: maxX - minX,
        height: maxY - minY
    };
}
function getRectsByLine(rects) {
    const sortedRects = rects.slice().sort((a, b)=>a.y - b.y);
    const groups = [];
    let prevRect = null;
    for(let i = 0; i < sortedRects.length; i++){
        const rect = sortedRects[i];
        if (!prevRect || rect.y - prevRect.y > prevRect.height / 2) groups.push([
            rect
        ]);
        else groups[groups.length - 1].push(rect);
        prevRect = rect;
    }
    return groups.map((rect)=>(0, _utils.rectToClientRect)(getBoundingRect(rect)));
}
/**
 * Provides improved positioning for inline reference elements that can span
 * over multiple lines, such as hyperlinks or range selections.
 * @see https://floating-ui.com/docs/inline
 */ const inline = function(options) {
    if (options === void 0) options = {};
    return {
        name: 'inline',
        options,
        async fn (state) {
            const { placement, elements, rects, platform, strategy } = state;
            // A MouseEvent's client{X,Y} coords can be up to 2 pixels off a
            // ClientRect's bounds, despite the event listener being triggered. A
            // padding of 2 seems to handle this issue.
            const { padding = 2, x, y } = (0, _utils.evaluate)(options, state);
            const nativeClientRects = Array.from(await (platform.getClientRects == null ? void 0 : platform.getClientRects(elements.reference)) || []);
            const clientRects = getRectsByLine(nativeClientRects);
            const fallback = (0, _utils.rectToClientRect)(getBoundingRect(nativeClientRects));
            const paddingObject = (0, _utils.getPaddingObject)(padding);
            function getBoundingClientRect() {
                // There are two rects and they are disjoined.
                if (clientRects.length === 2 && clientRects[0].left > clientRects[1].right && x != null && y != null) // Find the first rect in which the point is fully inside.
                return clientRects.find((rect)=>x > rect.left - paddingObject.left && x < rect.right + paddingObject.right && y > rect.top - paddingObject.top && y < rect.bottom + paddingObject.bottom) || fallback;
                // There are 2 or more connected rects.
                if (clientRects.length >= 2) {
                    if ((0, _utils.getSideAxis)(placement) === 'y') {
                        const firstRect = clientRects[0];
                        const lastRect = clientRects[clientRects.length - 1];
                        const isTop = (0, _utils.getSide)(placement) === 'top';
                        const top = firstRect.top;
                        const bottom = lastRect.bottom;
                        const left = isTop ? firstRect.left : lastRect.left;
                        const right = isTop ? firstRect.right : lastRect.right;
                        const width = right - left;
                        const height = bottom - top;
                        return {
                            top,
                            bottom,
                            left,
                            right,
                            width,
                            height,
                            x: left,
                            y: top
                        };
                    }
                    const isLeftSide = (0, _utils.getSide)(placement) === 'left';
                    const maxRight = (0, _utils.max)(...clientRects.map((rect)=>rect.right));
                    const minLeft = (0, _utils.min)(...clientRects.map((rect)=>rect.left));
                    const measureRects = clientRects.filter((rect)=>isLeftSide ? rect.left === minLeft : rect.right === maxRight);
                    const top = measureRects[0].top;
                    const bottom = measureRects[measureRects.length - 1].bottom;
                    const left = minLeft;
                    const right = maxRight;
                    const width = right - left;
                    const height = bottom - top;
                    return {
                        top,
                        bottom,
                        left,
                        right,
                        width,
                        height,
                        x: left,
                        y: top
                    };
                }
                return fallback;
            }
            const resetRects = await platform.getElementRects({
                reference: {
                    getBoundingClientRect
                },
                floating: elements.floating,
                strategy
            });
            if (rects.reference.x !== resetRects.reference.x || rects.reference.y !== resetRects.reference.y || rects.reference.width !== resetRects.reference.width || rects.reference.height !== resetRects.reference.height) return {
                reset: {
                    rects: resetRects
                }
            };
            return {};
        }
    };
};
const originSides = /*#__PURE__*/ new Set([
    'left',
    'top'
]);
// For type backwards-compatibility, the `OffsetOptions` type was also
// Derivable.
async function convertValueToCoords(state, options) {
    const { placement, platform, elements } = state;
    const rtl = await (platform.isRTL == null ? void 0 : platform.isRTL(elements.floating));
    const side = (0, _utils.getSide)(placement);
    const alignment = (0, _utils.getAlignment)(placement);
    const isVertical = (0, _utils.getSideAxis)(placement) === 'y';
    const mainAxisMulti = originSides.has(side) ? -1 : 1;
    const crossAxisMulti = rtl && isVertical ? -1 : 1;
    const rawValue = (0, _utils.evaluate)(options, state);
    // eslint-disable-next-line prefer-const
    let { mainAxis, crossAxis, alignmentAxis } = typeof rawValue === 'number' ? {
        mainAxis: rawValue,
        crossAxis: 0,
        alignmentAxis: null
    } : {
        mainAxis: rawValue.mainAxis || 0,
        crossAxis: rawValue.crossAxis || 0,
        alignmentAxis: rawValue.alignmentAxis
    };
    if (alignment && typeof alignmentAxis === 'number') crossAxis = alignment === 'end' ? alignmentAxis * -1 : alignmentAxis;
    return isVertical ? {
        x: crossAxis * crossAxisMulti,
        y: mainAxis * mainAxisMulti
    } : {
        x: mainAxis * mainAxisMulti,
        y: crossAxis * crossAxisMulti
    };
}
/**
 * Modifies the placement by translating the floating element along the
 * specified axes.
 * A number (shorthand for `mainAxis` or distance), or an axes configuration
 * object may be passed.
 * @see https://floating-ui.com/docs/offset
 */ const offset = function(options) {
    if (options === void 0) options = 0;
    return {
        name: 'offset',
        options,
        async fn (state) {
            var _middlewareData$offse, _middlewareData$arrow;
            const { x, y, placement, middlewareData } = state;
            const diffCoords = await convertValueToCoords(state, options);
            // If the placement is the same and the arrow caused an alignment offset
            // then we don't need to change the positioning coordinates.
            if (placement === ((_middlewareData$offse = middlewareData.offset) == null ? void 0 : _middlewareData$offse.placement) && (_middlewareData$arrow = middlewareData.arrow) != null && _middlewareData$arrow.alignmentOffset) return {};
            return {
                x: x + diffCoords.x,
                y: y + diffCoords.y,
                data: (0, _objectSpreadProps._)((0, _objectSpread._)({}, diffCoords), {
                    placement
                })
            };
        }
    };
};
/**
 * Optimizes the visibility of the floating element by shifting it in order to
 * keep it in view when it will overflow the clipping boundary.
 * @see https://floating-ui.com/docs/shift
 */ const shift = function(options) {
    if (options === void 0) options = {};
    return {
        name: 'shift',
        options,
        async fn (state) {
            const { x, y, placement, platform } = state;
            const _evaluate = (0, _utils.evaluate)(options, state), { mainAxis: checkMainAxis = true, crossAxis: checkCrossAxis = false, limiter = {
                fn: (_ref)=>{
                    let { x, y } = _ref;
                    return {
                        x,
                        y
                    };
                }
            } } = _evaluate, detectOverflowOptions = (0, _objectWithoutProperties._)(_evaluate, [
                "mainAxis",
                "crossAxis",
                "limiter"
            ]);
            const coords = {
                x,
                y
            };
            const overflow = await platform.detectOverflow(state, detectOverflowOptions);
            const crossAxis = (0, _utils.getSideAxis)((0, _utils.getSide)(placement));
            const mainAxis = (0, _utils.getOppositeAxis)(crossAxis);
            let mainAxisCoord = coords[mainAxis];
            let crossAxisCoord = coords[crossAxis];
            if (checkMainAxis) {
                const minSide = mainAxis === 'y' ? 'top' : 'left';
                const maxSide = mainAxis === 'y' ? 'bottom' : 'right';
                const min = mainAxisCoord + overflow[minSide];
                const max = mainAxisCoord - overflow[maxSide];
                mainAxisCoord = (0, _utils.clamp)(min, mainAxisCoord, max);
            }
            if (checkCrossAxis) {
                const minSide = crossAxis === 'y' ? 'top' : 'left';
                const maxSide = crossAxis === 'y' ? 'bottom' : 'right';
                const min = crossAxisCoord + overflow[minSide];
                const max = crossAxisCoord - overflow[maxSide];
                crossAxisCoord = (0, _utils.clamp)(min, crossAxisCoord, max);
            }
            const limitedCoords = limiter.fn((0, _objectSpreadProps._)((0, _objectSpread._)({}, state), {
                [mainAxis]: mainAxisCoord,
                [crossAxis]: crossAxisCoord
            }));
            return (0, _objectSpreadProps._)((0, _objectSpread._)({}, limitedCoords), {
                data: {
                    x: limitedCoords.x - x,
                    y: limitedCoords.y - y,
                    enabled: {
                        [mainAxis]: checkMainAxis,
                        [crossAxis]: checkCrossAxis
                    }
                }
            });
        }
    };
};
/**
 * Built-in `limiter` that will stop `shift()` at a certain point.
 */ const limitShift = function(options) {
    if (options === void 0) options = {};
    return {
        options,
        fn (state) {
            const { x, y, placement, rects, middlewareData } = state;
            const { offset = 0, mainAxis: checkMainAxis = true, crossAxis: checkCrossAxis = true } = (0, _utils.evaluate)(options, state);
            const coords = {
                x,
                y
            };
            const crossAxis = (0, _utils.getSideAxis)(placement);
            const mainAxis = (0, _utils.getOppositeAxis)(crossAxis);
            let mainAxisCoord = coords[mainAxis];
            let crossAxisCoord = coords[crossAxis];
            const rawOffset = (0, _utils.evaluate)(offset, state);
            const computedOffset = typeof rawOffset === 'number' ? {
                mainAxis: rawOffset,
                crossAxis: 0
            } : (0, _objectSpread._)({
                mainAxis: 0,
                crossAxis: 0
            }, rawOffset);
            if (checkMainAxis) {
                const len = mainAxis === 'y' ? 'height' : 'width';
                const limitMin = rects.reference[mainAxis] - rects.floating[len] + computedOffset.mainAxis;
                const limitMax = rects.reference[mainAxis] + rects.reference[len] - computedOffset.mainAxis;
                if (mainAxisCoord < limitMin) mainAxisCoord = limitMin;
                else if (mainAxisCoord > limitMax) mainAxisCoord = limitMax;
            }
            if (checkCrossAxis) {
                var _middlewareData$offse, _middlewareData$offse2;
                const len = mainAxis === 'y' ? 'width' : 'height';
                const isOriginSide = originSides.has((0, _utils.getSide)(placement));
                const limitMin = rects.reference[crossAxis] - rects.floating[len] + (isOriginSide ? ((_middlewareData$offse = middlewareData.offset) == null ? void 0 : _middlewareData$offse[crossAxis]) || 0 : 0) + (isOriginSide ? 0 : computedOffset.crossAxis);
                const limitMax = rects.reference[crossAxis] + rects.reference[len] + (isOriginSide ? 0 : ((_middlewareData$offse2 = middlewareData.offset) == null ? void 0 : _middlewareData$offse2[crossAxis]) || 0) - (isOriginSide ? computedOffset.crossAxis : 0);
                if (crossAxisCoord < limitMin) crossAxisCoord = limitMin;
                else if (crossAxisCoord > limitMax) crossAxisCoord = limitMax;
            }
            return {
                [mainAxis]: mainAxisCoord,
                [crossAxis]: crossAxisCoord
            };
        }
    };
};
/**
 * Provides data that allows you to change the size of the floating element —
 * for instance, prevent it from overflowing the clipping boundary or match the
 * width of the reference element.
 * @see https://floating-ui.com/docs/size
 */ const size = function(options) {
    if (options === void 0) options = {};
    return {
        name: 'size',
        options,
        async fn (state) {
            var _state$middlewareData, _state$middlewareData2;
            const { placement, rects, platform, elements } = state;
            const _evaluate = (0, _utils.evaluate)(options, state), { apply = ()=>{} } = _evaluate, detectOverflowOptions = (0, _objectWithoutProperties._)(_evaluate, [
                "apply"
            ]);
            const overflow = await platform.detectOverflow(state, detectOverflowOptions);
            const side = (0, _utils.getSide)(placement);
            const alignment = (0, _utils.getAlignment)(placement);
            const isYAxis = (0, _utils.getSideAxis)(placement) === 'y';
            const { width, height } = rects.floating;
            let heightSide;
            let widthSide;
            if (side === 'top' || side === 'bottom') {
                heightSide = side;
                widthSide = alignment === (await (platform.isRTL == null ? void 0 : platform.isRTL(elements.floating)) ? 'start' : 'end') ? 'left' : 'right';
            } else {
                widthSide = side;
                heightSide = alignment === 'end' ? 'top' : 'bottom';
            }
            const maximumClippingHeight = height - overflow.top - overflow.bottom;
            const maximumClippingWidth = width - overflow.left - overflow.right;
            const overflowAvailableHeight = (0, _utils.min)(height - overflow[heightSide], maximumClippingHeight);
            const overflowAvailableWidth = (0, _utils.min)(width - overflow[widthSide], maximumClippingWidth);
            const noShift = !state.middlewareData.shift;
            let availableHeight = overflowAvailableHeight;
            let availableWidth = overflowAvailableWidth;
            if ((_state$middlewareData = state.middlewareData.shift) != null && _state$middlewareData.enabled.x) availableWidth = maximumClippingWidth;
            if ((_state$middlewareData2 = state.middlewareData.shift) != null && _state$middlewareData2.enabled.y) availableHeight = maximumClippingHeight;
            if (noShift && !alignment) {
                const xMin = (0, _utils.max)(overflow.left, 0);
                const xMax = (0, _utils.max)(overflow.right, 0);
                const yMin = (0, _utils.max)(overflow.top, 0);
                const yMax = (0, _utils.max)(overflow.bottom, 0);
                if (isYAxis) availableWidth = width - 2 * (xMin !== 0 || xMax !== 0 ? xMin + xMax : (0, _utils.max)(overflow.left, overflow.right));
                else availableHeight = height - 2 * (yMin !== 0 || yMax !== 0 ? yMin + yMax : (0, _utils.max)(overflow.top, overflow.bottom));
            }
            await apply((0, _objectSpreadProps._)((0, _objectSpread._)({}, state), {
                availableWidth,
                availableHeight
            }));
            const nextDimensions = await platform.getDimensions(elements.floating);
            if (width !== nextDimensions.width || height !== nextDimensions.height) return {
                reset: {
                    rects: true
                }
            };
            return {};
        }
    };
};

},{"@swc/helpers/_/_object_spread":"9gdrV","@swc/helpers/_/_object_spread_props":"kANqQ","@swc/helpers/_/_object_without_properties":"6HqIM","@floating-ui/utils":"gVBaK","@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"gVBaK":[function(require,module,exports,__globalThis) {
/**
 * Custom positioning reference element.
 * @see https://floating-ui.com/docs/virtual-elements
 */ var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "alignments", ()=>alignments);
parcelHelpers.export(exports, "clamp", ()=>clamp);
parcelHelpers.export(exports, "createCoords", ()=>createCoords);
parcelHelpers.export(exports, "evaluate", ()=>evaluate);
parcelHelpers.export(exports, "expandPaddingObject", ()=>expandPaddingObject);
parcelHelpers.export(exports, "floor", ()=>floor);
parcelHelpers.export(exports, "getAlignment", ()=>getAlignment);
parcelHelpers.export(exports, "getAlignmentAxis", ()=>getAlignmentAxis);
parcelHelpers.export(exports, "getAlignmentSides", ()=>getAlignmentSides);
parcelHelpers.export(exports, "getAxisLength", ()=>getAxisLength);
parcelHelpers.export(exports, "getExpandedPlacements", ()=>getExpandedPlacements);
parcelHelpers.export(exports, "getOppositeAlignmentPlacement", ()=>getOppositeAlignmentPlacement);
parcelHelpers.export(exports, "getOppositeAxis", ()=>getOppositeAxis);
parcelHelpers.export(exports, "getOppositeAxisPlacements", ()=>getOppositeAxisPlacements);
parcelHelpers.export(exports, "getOppositePlacement", ()=>getOppositePlacement);
parcelHelpers.export(exports, "getPaddingObject", ()=>getPaddingObject);
parcelHelpers.export(exports, "getSide", ()=>getSide);
parcelHelpers.export(exports, "getSideAxis", ()=>getSideAxis);
parcelHelpers.export(exports, "max", ()=>max);
parcelHelpers.export(exports, "min", ()=>min);
parcelHelpers.export(exports, "placements", ()=>placements);
parcelHelpers.export(exports, "rectToClientRect", ()=>rectToClientRect);
parcelHelpers.export(exports, "round", ()=>round);
parcelHelpers.export(exports, "sides", ()=>sides);
var _objectSpread = require("@swc/helpers/_/_object_spread");
const sides = [
    'top',
    'right',
    'bottom',
    'left'
];
const alignments = [
    'start',
    'end'
];
const placements = /*#__PURE__*/ sides.reduce((acc, side)=>acc.concat(side, side + "-" + alignments[0], side + "-" + alignments[1]), []);
const min = Math.min;
const max = Math.max;
const round = Math.round;
const floor = Math.floor;
const createCoords = (v)=>({
        x: v,
        y: v
    });
const oppositeSideMap = {
    left: 'right',
    right: 'left',
    bottom: 'top',
    top: 'bottom'
};
function clamp(start, value, end) {
    return max(start, min(value, end));
}
function evaluate(value, param) {
    return typeof value === 'function' ? value(param) : value;
}
function getSide(placement) {
    return placement.split('-')[0];
}
function getAlignment(placement) {
    return placement.split('-')[1];
}
function getOppositeAxis(axis) {
    return axis === 'x' ? 'y' : 'x';
}
function getAxisLength(axis) {
    return axis === 'y' ? 'height' : 'width';
}
function getSideAxis(placement) {
    const firstChar = placement[0];
    return firstChar === 't' || firstChar === 'b' ? 'y' : 'x';
}
function getAlignmentAxis(placement) {
    return getOppositeAxis(getSideAxis(placement));
}
function getAlignmentSides(placement, rects, rtl) {
    if (rtl === void 0) rtl = false;
    const alignment = getAlignment(placement);
    const alignmentAxis = getAlignmentAxis(placement);
    const length = getAxisLength(alignmentAxis);
    let mainAlignmentSide = alignmentAxis === 'x' ? alignment === (rtl ? 'end' : 'start') ? 'right' : 'left' : alignment === 'start' ? 'bottom' : 'top';
    if (rects.reference[length] > rects.floating[length]) mainAlignmentSide = getOppositePlacement(mainAlignmentSide);
    return [
        mainAlignmentSide,
        getOppositePlacement(mainAlignmentSide)
    ];
}
function getExpandedPlacements(placement) {
    const oppositePlacement = getOppositePlacement(placement);
    return [
        getOppositeAlignmentPlacement(placement),
        oppositePlacement,
        getOppositeAlignmentPlacement(oppositePlacement)
    ];
}
function getOppositeAlignmentPlacement(placement) {
    return placement.includes('start') ? placement.replace('start', 'end') : placement.replace('end', 'start');
}
const lrPlacement = [
    'left',
    'right'
];
const rlPlacement = [
    'right',
    'left'
];
const tbPlacement = [
    'top',
    'bottom'
];
const btPlacement = [
    'bottom',
    'top'
];
function getSideList(side, isStart, rtl) {
    switch(side){
        case 'top':
        case 'bottom':
            if (rtl) return isStart ? rlPlacement : lrPlacement;
            return isStart ? lrPlacement : rlPlacement;
        case 'left':
        case 'right':
            return isStart ? tbPlacement : btPlacement;
        default:
            return [];
    }
}
function getOppositeAxisPlacements(placement, flipAlignment, direction, rtl) {
    const alignment = getAlignment(placement);
    let list = getSideList(getSide(placement), direction === 'start', rtl);
    if (alignment) {
        list = list.map((side)=>side + "-" + alignment);
        if (flipAlignment) list = list.concat(list.map(getOppositeAlignmentPlacement));
    }
    return list;
}
function getOppositePlacement(placement) {
    const side = getSide(placement);
    return oppositeSideMap[side] + placement.slice(side.length);
}
function expandPaddingObject(padding) {
    return (0, _objectSpread._)({
        top: 0,
        right: 0,
        bottom: 0,
        left: 0
    }, padding);
}
function getPaddingObject(padding) {
    return typeof padding !== 'number' ? expandPaddingObject(padding) : {
        top: padding,
        right: padding,
        bottom: padding,
        left: padding
    };
}
function rectToClientRect(rect) {
    const { x, y, width, height } = rect;
    return {
        width,
        height,
        top: y,
        left: x,
        right: x + width,
        bottom: y + height,
        x,
        y
    };
}

},{"@swc/helpers/_/_object_spread":"9gdrV","@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"cDpKU":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "getComputedStyle", ()=>getComputedStyle);
parcelHelpers.export(exports, "getContainingBlock", ()=>getContainingBlock);
parcelHelpers.export(exports, "getDocumentElement", ()=>getDocumentElement);
parcelHelpers.export(exports, "getFrameElement", ()=>getFrameElement);
parcelHelpers.export(exports, "getNearestOverflowAncestor", ()=>getNearestOverflowAncestor);
parcelHelpers.export(exports, "getNodeName", ()=>getNodeName);
parcelHelpers.export(exports, "getNodeScroll", ()=>getNodeScroll);
parcelHelpers.export(exports, "getOverflowAncestors", ()=>getOverflowAncestors);
parcelHelpers.export(exports, "getParentNode", ()=>getParentNode);
parcelHelpers.export(exports, "getWindow", ()=>getWindow);
parcelHelpers.export(exports, "isContainingBlock", ()=>isContainingBlock);
parcelHelpers.export(exports, "isElement", ()=>isElement);
parcelHelpers.export(exports, "isHTMLElement", ()=>isHTMLElement);
parcelHelpers.export(exports, "isLastTraversableNode", ()=>isLastTraversableNode);
parcelHelpers.export(exports, "isNode", ()=>isNode);
parcelHelpers.export(exports, "isOverflowElement", ()=>isOverflowElement);
parcelHelpers.export(exports, "isShadowRoot", ()=>isShadowRoot);
parcelHelpers.export(exports, "isTableElement", ()=>isTableElement);
parcelHelpers.export(exports, "isTopLayer", ()=>isTopLayer);
parcelHelpers.export(exports, "isWebKit", ()=>isWebKit);
function hasWindow() {
    return typeof window !== 'undefined';
}
function getNodeName(node) {
    if (isNode(node)) return (node.nodeName || '').toLowerCase();
    // Mocked nodes in testing environments may not be instances of Node. By
    // returning `#document` an infinite loop won't occur.
    // https://github.com/floating-ui/floating-ui/issues/2317
    return '#document';
}
function getWindow(node) {
    var _node$ownerDocument;
    return (node == null || (_node$ownerDocument = node.ownerDocument) == null ? void 0 : _node$ownerDocument.defaultView) || window;
}
function getDocumentElement(node) {
    var _ref;
    return (_ref = (isNode(node) ? node.ownerDocument : node.document) || window.document) == null ? void 0 : _ref.documentElement;
}
function isNode(value) {
    if (!hasWindow()) return false;
    return value instanceof Node || value instanceof getWindow(value).Node;
}
function isElement(value) {
    if (!hasWindow()) return false;
    return value instanceof Element || value instanceof getWindow(value).Element;
}
function isHTMLElement(value) {
    if (!hasWindow()) return false;
    return value instanceof HTMLElement || value instanceof getWindow(value).HTMLElement;
}
function isShadowRoot(value) {
    if (!hasWindow() || typeof ShadowRoot === 'undefined') return false;
    return value instanceof ShadowRoot || value instanceof getWindow(value).ShadowRoot;
}
function isOverflowElement(element) {
    const { overflow, overflowX, overflowY, display } = getComputedStyle(element);
    return /auto|scroll|overlay|hidden|clip/.test(overflow + overflowY + overflowX) && display !== 'inline' && display !== 'contents';
}
function isTableElement(element) {
    return /^(table|td|th)$/.test(getNodeName(element));
}
function isTopLayer(element) {
    try {
        if (element.matches(':popover-open')) return true;
    } catch (_e) {
    // no-op
    }
    try {
        return element.matches(':modal');
    } catch (_e) {
        return false;
    }
}
const willChangeRe = /transform|translate|scale|rotate|perspective|filter/;
const containRe = /paint|layout|strict|content/;
const isNotNone = (value)=>!!value && value !== 'none';
let isWebKitValue;
function isContainingBlock(elementOrCss) {
    const css = isElement(elementOrCss) ? getComputedStyle(elementOrCss) : elementOrCss;
    // https://developer.mozilla.org/en-US/docs/Web/CSS/Containing_block#identifying_the_containing_block
    // https://drafts.csswg.org/css-transforms-2/#individual-transforms
    return isNotNone(css.transform) || isNotNone(css.translate) || isNotNone(css.scale) || isNotNone(css.rotate) || isNotNone(css.perspective) || !isWebKit() && (isNotNone(css.backdropFilter) || isNotNone(css.filter)) || willChangeRe.test(css.willChange || '') || containRe.test(css.contain || '');
}
function getContainingBlock(element) {
    let currentNode = getParentNode(element);
    while(isHTMLElement(currentNode) && !isLastTraversableNode(currentNode)){
        if (isContainingBlock(currentNode)) return currentNode;
        else if (isTopLayer(currentNode)) return null;
        currentNode = getParentNode(currentNode);
    }
    return null;
}
function isWebKit() {
    if (isWebKitValue == null) isWebKitValue = typeof CSS !== 'undefined' && CSS.supports && CSS.supports('-webkit-backdrop-filter', 'none');
    return isWebKitValue;
}
function isLastTraversableNode(node) {
    return /^(html|body|#document)$/.test(getNodeName(node));
}
function getComputedStyle(element) {
    return getWindow(element).getComputedStyle(element);
}
function getNodeScroll(element) {
    if (isElement(element)) return {
        scrollLeft: element.scrollLeft,
        scrollTop: element.scrollTop
    };
    return {
        scrollLeft: element.scrollX,
        scrollTop: element.scrollY
    };
}
function getParentNode(node) {
    if (getNodeName(node) === 'html') return node;
    const result = // Step into the shadow DOM of the parent of a slotted node.
    node.assignedSlot || // DOM Element detected.
    node.parentNode || // ShadowRoot detected.
    isShadowRoot(node) && node.host || // Fallback.
    getDocumentElement(node);
    return isShadowRoot(result) ? result.host : result;
}
function getNearestOverflowAncestor(node) {
    const parentNode = getParentNode(node);
    if (isLastTraversableNode(parentNode)) return node.ownerDocument ? node.ownerDocument.body : node.body;
    if (isHTMLElement(parentNode) && isOverflowElement(parentNode)) return parentNode;
    return getNearestOverflowAncestor(parentNode);
}
function getOverflowAncestors(node, list, traverseIframes) {
    var _node$ownerDocument2;
    if (list === void 0) list = [];
    if (traverseIframes === void 0) traverseIframes = true;
    const scrollableAncestor = getNearestOverflowAncestor(node);
    const isBody = scrollableAncestor === ((_node$ownerDocument2 = node.ownerDocument) == null ? void 0 : _node$ownerDocument2.body);
    const win = getWindow(scrollableAncestor);
    if (isBody) {
        const frameElement = getFrameElement(win);
        return list.concat(win, win.visualViewport || [], isOverflowElement(scrollableAncestor) ? scrollableAncestor : [], frameElement && traverseIframes ? getOverflowAncestors(frameElement) : []);
    } else return list.concat(scrollableAncestor, getOverflowAncestors(scrollableAncestor, [], traverseIframes));
}
function getFrameElement(win) {
    return win.parent && Object.getPrototypeOf(win.parent) ? win.frameElement : null;
}

},{"@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"bvI6u":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "PortalPlacementContext", ()=>PortalPlacementContext);
var _react = require("react");
const PortalPlacementContext = /*#__PURE__*/ (0, _react.createContext)(null);

},{"react":"ltHCL","@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"77ZgW":[function(require,module,exports,__globalThis) {
/* menu-portal-top-layer.tsx generated by @compiled/babel-plugin v0.39.1 */ var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
/**
 * Top-layer host for react-select's menu. Hands positioning, flip, and width
 * to `@atlaskit/top-layer`; ignores `appendTo` / `menuPortalTarget` /
 * `menuPosition`. The browser-dismiss handler is supplied internally by
 * `Select` via `MenuPortalCloseContext`.
 *
 * @example
 * ```tsx
 * <MenuPortalTopLayer controlElement={el} menuPlacement="bottom">
 *   <Menu />
 * </MenuPortalTopLayer>
 * ```
 */ parcelHelpers.export(exports, "MenuPortalTopLayer", ()=>MenuPortalTopLayer);
var _objectSpread = require("@swc/helpers/_/_object_spread");
var _objectSpreadProps = require("@swc/helpers/_/_object_spread_props");
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _runtime = require("@compiled/react/runtime");
var _react1 = require("@compiled/react");
var _openLayerObserver = require("@atlaskit/layering/experimental/open-layer-observer");
var _popover = require("@atlaskit/top-layer/popover");
var _useAnchorPosition = require("@atlaskit/top-layer/use-anchor-position");
var _useWidthFromAnchor = require("@atlaskit/top-layer/use-width-from-anchor");
var _getStyleProps = require("../get-style-props");
var _menuPortalCloseContext = require("../internal/menu-portal-close-context");
// `'auto'` falls through to `'end'`; top-layer's `position-try-fallbacks` flips it if needed.
function reactSelectEdgeToTopLayerEdge(menuPlacement) {
    return menuPlacement === 'top' ? 'start' : 'end';
}
const menuPortalStyles = {
    root: "_ofie1496"
};
function MenuPortalTopLayer(props) {
    const { children, controlElement, innerProps, menuPlacement, menuPosition, xcss } = props;
    // Select's "close the menu" callback, distinct from `Popover.onClose`.
    const closeSelect = (0, _react.useContext)((0, _menuPortalCloseContext.MenuPortalCloseContext));
    const popoverRef = (0, _react.useRef)(null);
    // Top-layer hooks need a RefObject; in-render mutation keeps it in sync
    // with the prop without an effect. The hooks re-read `.current` from
    // `isOpen`-keyed layout effects, so a stable ref identity is fine.
    const anchorRef = (0, _react.useRef)(null);
    anchorRef.current = controlElement;
    // `controlElement` is null on initial mount / SSR until `Select` mirrors
    // its ref into state. While null, every hook below no-ops to avoid DOM
    // reads or registering an unpositioned popover.
    const isAnchored = controlElement !== null;
    // `gap: 0` matches the legacy MenuPortal (no trigger-to-menu gap; the
    // menu root already declares its own `marginBlockStart`). Without this
    // override `useAnchorPosition`'s default 8px gap would diverge visually
    // from the legacy path.
    (0, _useAnchorPosition.useAnchorPosition)({
        anchorRef,
        popoverRef,
        placement: {
            axis: 'block',
            edge: reactSelectEdgeToTopLayerEdge(menuPlacement),
            offset: {
                gap: 0
            }
        },
        isOpen: isAnchored
    });
    (0, _useWidthFromAnchor.useWidthFromAnchor)({
        anchorRef,
        popoverRef,
        mode: 'match-anchor',
        isOpen: isAnchored
    });
    const handlePopoverClose = (0, _react.useCallback)(()=>{
        if (closeSelect) closeSelect();
    }, [
        closeSelect
    ]);
    // Explicit observer registration: the outer Popover is intentionally
    // roleless (see Popover comment below), so Popover cannot auto-register
    // from its role. This lets `closeLayers()` (Modal / Drawer) dismiss us.
    (0, _openLayerObserver.useNotifyOpenLayerObserver)({
        type: 'popup',
        isOpen: isAnchored,
        onClose: handlePopoverClose
    });
    // Top-layer owns positioning; zero offset/rect preserves the consumer
    // styles call shape.
    const { className } = (0, _getStyleProps.getStyleProps)((0, _objectSpreadProps._)((0, _objectSpread._)({}, props), {
        offset: 0,
        position: menuPosition,
        rect: {
            left: 0,
            width: 0
        }
    }), 'menuPortal', {
        'menu-portal': true
    });
    // Popover stays mounted and is driven by `isOpen` so its layout-effect
    // teardown (`hidePopover`, observer cleanup, position-hook style reset)
    // runs against a live element. Conditional render would skip that path.
    //
    // `mode="manual"` opts out of native light-dismiss: react-select already
    // owns outside-click and Escape via its own handlers, and the combobox
    // trigger lives in a separate DOM subtree that the spec algorithm cannot
    // see. Matches the pattern in `@atlaskit/datetime-picker`'s MenuTopLayer.
    //
    // The Popover host is intentionally roleless: the inner `MenuList`
    // keeps `role="listbox"` and the id referenced by `aria-controls`.
    // Putting the role on the outer host caused Playwright `toBeVisible`
    // and some SR hit-testing to treat it as hidden (zero bounding rect
    // while `styles.root` opts out of UA `[popover]` positioning).
    //
    // TODO: add open / close animation. Select unmounts MenuPortalTopLayer
    // the moment `menuIsOpen` flips false, so Popover's `animate` exit
    // transition never gets a frame. Needs keeping the portal mounted
    // through the exit (`onExitFinish`) on the Select side.
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _popover.Popover), {
        ref: popoverRef,
        mode: "manual",
        isOpen: isAnchored,
        onClose: handlePopoverClose,
        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", (0, _objectSpreadProps._)((0, _objectSpread._)({
            // `className` carries consumer `styles.menuPortal({...})` output,
            // `xcss` carries caller compiled atomic classes, and `-MenuPortal`
            // is a legacy selector hook kept for parity with MenuPortalLegacy.
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop, @atlaskit/ui-styling-standard/local-cx-xcss, @compiled/local-cx-xcss, @typescript-eslint/no-explicit-any
            className: (0, _runtime.ax)([
                menuPortalStyles.root,
                (0, _react1.cx)(className, xcss, '-MenuPortal')
            ])
        }, innerProps), {
            children: children
        }))
    });
}

},{"@swc/helpers/_/_object_spread":"9gdrV","@swc/helpers/_/_object_spread_props":"kANqQ","react/jsx-runtime":"bGvcw","react":"ltHCL","@compiled/react/runtime":"d27Vo","@compiled/react":"MfI9Z","@atlaskit/layering/experimental/open-layer-observer":"2Dqp9","@atlaskit/top-layer/popover":"hLw5z","@atlaskit/top-layer/use-anchor-position":"6ghLj","@atlaskit/top-layer/use-width-from-anchor":"geRT5","../get-style-props":"lzdjl","../internal/menu-portal-close-context":"2USlA","@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"2USlA":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "MenuPortalCloseContext", ()=>MenuPortalCloseContext);
var _react = require("react");
const MenuPortalCloseContext = /*#__PURE__*/ (0, _react.createContext)(undefined);

},{"react":"ltHCL","@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"jUJeq":[function(require,module,exports,__globalThis) {
/* multi-value.tsx generated by @compiled/babel-plugin v0.39.1 */ var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _objectSpread = require("@swc/helpers/_/_object_spread");
var _objectSpreadProps = require("@swc/helpers/_/_object_spread_props");
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _runtime = require("@compiled/react/runtime");
var _react1 = require("@compiled/react");
var _platformFeatureFlags = require("@atlaskit/platform-feature-flags");
var _tag = require("@atlaskit/tag");
var _tagDefault = parcelHelpers.interopDefault(_tag);
var _getStyleProps = require("../get-style-props");
var _useSelectGetStyles = require("../internal/use-select-get-styles");
var _multiValueContainer = require("./containers/multi-value-container");
var _multiValueLabel = require("./multi-value-label");
const multiValueTagWrapperStyles = {
    root: "_16jlidpf _1o9zkb7n _i0dl1wug _1mouze3t _195gze3t _4cvr1h6o _1e0c1txw _1ul9ze3t _zdxokb7n _v5ynkb7n _13lsf1ug _3pxh1h6o _d0dz1txw _1ouwze3t"
};
// Tag-like color styles
const tagLikeColorStyles = {
    gray: "_119bmsup",
    blue: "_119b18hp",
    green: "_119b5d2u",
    red: "_119bn9dc",
    yellow: "_119b1s7j",
    purple: "_119bluwt",
    lime: "_119b1m7d",
    magenta: "_119b132u",
    orange: "_119b1ip5",
    teal: "_119b131p"
};
const tagLikeBorderFilterStyles = null;
// Tag-like styles for custom content values (not plain text) when FF is on.
// Mirrors the TagNew component's visual appearance (padding, margins, sizing, colors).
// The container uses tag-like styling while Label/Remove sub-components are preserved
// so custom overrides (e.g. custom aria-labels, rendering objects as data) continue to work.
const multiValueTagLikeStyles = {
    root: "_1reo15vq _18m915vq _2rko12b0 _11c8wadc _1dqonqa1 _189ee4h9 _1mouze3t _195gze3t _1e0c116y _vchhusvi _kqswh2mm _4cvr1h6o _1wpz1h6o _1ul9ze3t _1o9zkb7n _p12ff6dh _4t3i1k92 _bfhksm61 _syazi7uo _80om73ad _3yq3glyw",
    labelWrapper: "_16jlkb7n _1o9zkb7n _i0dlf1ug _1reo15vq _18m915vq _11c8wadc _1e0c1txw _4cvr1h6o _1ul9ze3t _1tkeidpf _2a9v1kw7",
    disabled: "_syaz1gmx _bfhki8nm",
    focused: "_syaz6x5g _bfhk1dpa _16qs1xv8 _1aewe4h9 _6up51j28 _1xdnnqa1"
};
const getMultiValueLabelText = (children, data)=>{
    if (typeof children === 'string') return children;
    const label = data === null || data === void 0 ? void 0 : data.label;
    return typeof label === 'string' ? label : '';
};
const MultiValue = (props)=>{
    const { children, components, data, innerProps, isDisabled, isFocused, removeProps, selectProps, cropWithEllipsis } = props;
    const { Container, Label, Remove } = components;
    const labelText = getMultiValueLabelText(children, data);
    const isPlainLabel = typeof children === 'string';
    const ffTagUplifts = (0, _platformFeatureFlags.fg)('platform-dst-lozenge-tag-badge-visual-uplifts');
    const { css: containerCss, className: containerClassName } = (0, _getStyleProps.getStyleProps)(props, 'multiValue', {
        'multi-value': true,
        'multi-value--is-disabled': isDisabled
    });
    const { css: labelCss, className: labelClassName } = (0, _getStyleProps.getStyleProps)(props, 'multiValueLabel', {
        'multi-value__label': true
    });
    const { css: removeCss, className: removeClassName } = (0, _getStyleProps.getStyleProps)(props, 'multiValueRemove', {
        'multi-value__remove': true
    });
    const hasCustomLabel = Label !== (0, _multiValueLabel.MultiValueLabel);
    const hasCustomContainer = Container !== (0, _multiValueContainer.MultiValueContainer);
    const selectStyles = selectProps.styles;
    const hasCustomMultiValueStyles = Boolean((selectStyles === null || selectStyles === void 0 ? void 0 : selectStyles.multiValue) || (selectStyles === null || selectStyles === void 0 ? void 0 : selectStyles.multiValueLabel) || (selectStyles === null || selectStyles === void 0 ? void 0 : selectStyles.multiValueRemove));
    const selectClassNames = selectProps.classNames;
    const hasCustomMultiValueClassNames = Boolean((selectClassNames === null || selectClassNames === void 0 ? void 0 : selectClassNames.multiValue) || (selectClassNames === null || selectClassNames === void 0 ? void 0 : selectClassNames.multiValueLabel) || (selectClassNames === null || selectClassNames === void 0 ? void 0 : selectClassNames.multiValueRemove));
    // Detect if getStyles was overridden directly on this component instance (e.g. via the
    // components prop wrapper passing a custom getStyles). The context holds the original
    // Select instance's getStyles — a reference inequality means a custom override was passed.
    // When context is absent (e.g. in mocked/test contexts), assume no override.
    const selectGetStyles = (0, _useSelectGetStyles.useSelectGetStyles)();
    const hasOverriddenGetStyles = selectGetStyles !== undefined && props.getStyles !== selectGetStyles;
    const hasCustomContainerStyles = hasCustomMultiValueStyles || hasCustomMultiValueClassNames || hasOverriddenGetStyles;
    if (ffTagUplifts && isPlainLabel && !hasCustomLabel && !hasCustomContainer && !hasCustomContainerStyles) {
        const { elemBefore, color: tagColor } = data !== null && data !== void 0 ? data : {};
        return /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", (0, _objectSpreadProps._)((0, _objectSpread._)({}, innerProps), {
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop, @atlaskit/ui-styling-standard/local-cx-xcss, @compiled/local-cx-xcss
            className: (0, _runtime.ax)([
                multiValueTagWrapperStyles.root,
                (0, _react1.cx)(props.className, containerClassName, props.xcss, '-multiValue')
            ]),
            children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _tagDefault.default), {
                text: labelText,
                isRemovable: !isDisabled,
                removeButtonLabel: `${labelText}, remove`,
                onBeforeRemoveAction: ()=>{
                    var _removeProps_onClick;
                    (_removeProps_onClick = removeProps.onClick) === null || _removeProps_onClick === void 0 ? void 0 : _removeProps_onClick.call(removeProps, {});
                    return false;
                },
                color: tagColor !== null && tagColor !== void 0 ? tagColor : 'gray',
                elemBefore: elemBefore,
                hasMargin: false
            })
        }));
    }
    // FF on + custom content → tag-like path
    if (ffTagUplifts && !hasCustomContainer) {
        const colorKey = data === null || data === void 0 ? void 0 : data.color;
        return /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", (0, _objectSpreadProps._)((0, _objectSpread._)({
            "data-multi-value-tag-like": "true"
        }, innerProps), {
            // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- custom styles.multiValue overrides (e.g. colored borders) must be preserved
            style: containerCss,
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop, @atlaskit/ui-styling-standard/local-cx-xcss, @compiled/local-cx-xcss
            className: (0, _runtime.ax)([
                multiValueTagLikeStyles.root,
                tagLikeColorStyles.gray,
                colorKey === 'blue' && tagLikeColorStyles.blue,
                colorKey === 'green' && tagLikeColorStyles.green,
                colorKey === 'red' && tagLikeColorStyles.red,
                colorKey === 'yellow' && tagLikeColorStyles.yellow,
                colorKey === 'purple' && tagLikeColorStyles.purple,
                colorKey === 'lime' && tagLikeColorStyles.lime,
                colorKey === 'magenta' && tagLikeColorStyles.magenta,
                colorKey === 'orange' && tagLikeColorStyles.orange,
                colorKey === 'teal' && tagLikeColorStyles.teal,
                "_1h6dip4g",
                isDisabled && multiValueTagLikeStyles.disabled,
                isFocused && multiValueTagLikeStyles.focused,
                (0, _react1.cx)(props.className, containerClassName, props.xcss, '-multiValue')
            ]),
            children: [
                /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                    className: (0, _runtime.ax)([
                        multiValueTagLikeStyles.labelWrapper
                    ]),
                    children: /*#__PURE__*/ (0, _jsxRuntime.jsx)(Label, {
                        data: data,
                        innerProps: {
                            style: labelCss,
                            className: labelClassName
                        },
                        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop
                        className: labelClassName,
                        hasEllipsis: cropWithEllipsis || cropWithEllipsis === undefined,
                        selectProps: selectProps,
                        children: children
                    })
                }),
                /*#__PURE__*/ (0, _jsxRuntime.jsx)(Remove, {
                    data: data,
                    innerProps: (0, _objectSpread._)({
                        style: removeCss,
                        className: removeClassName,
                        role: 'button',
                        tabIndex: -1,
                        'aria-label': `${labelText || 'option'}, remove`
                    }, removeProps),
                    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop
                    className: removeClassName,
                    isDisabled: isDisabled,
                    selectProps: selectProps
                })
            ]
        }));
    }
    // FF off → default styles
    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)(Container, {
        data: data,
        innerProps: (0, _objectSpread._)({
            style: containerCss,
            className: containerClassName
        }, innerProps),
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop
        className: containerClassName,
        isFocused: isFocused,
        isDisabled: isDisabled,
        selectProps: selectProps,
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsx)(Label, {
                data: data,
                innerProps: {
                    style: labelCss,
                    className: labelClassName
                },
                // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop
                className: labelClassName,
                hasEllipsis: cropWithEllipsis || cropWithEllipsis === undefined,
                selectProps: selectProps,
                children: children
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)(Remove, {
                data: data,
                innerProps: (0, _objectSpread._)({
                    style: removeCss,
                    className: removeClassName,
                    role: 'button',
                    tabIndex: -1,
                    'aria-label': `${labelText || 'option'}, remove`
                }, removeProps),
                // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop
                className: removeClassName,
                isDisabled: isDisabled,
                selectProps: selectProps
            })
        ]
    });
};
// eslint-disable-next-line @repo/internal/react/require-jsdoc
exports.default = MultiValue;

},{"@swc/helpers/_/_object_spread":"9gdrV","@swc/helpers/_/_object_spread_props":"kANqQ","react/jsx-runtime":"bGvcw","react":"ltHCL","@compiled/react/runtime":"d27Vo","@compiled/react":"MfI9Z","@atlaskit/platform-feature-flags":"8rD2i","@atlaskit/tag":"a7Hv0","../get-style-props":"lzdjl","../internal/use-select-get-styles":"fav81","./containers/multi-value-container":"8AL71","./multi-value-label":"jW74g","@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"a7Hv0":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>(0, _tagDefault.default));
parcelHelpers.export(exports, "SimpleTag", ()=>(0, _tag.SimpleTag));
parcelHelpers.export(exports, "RemovableTag", ()=>(0, _tag.RemovableTag));
// Export new visual refresh components
parcelHelpers.export(exports, "AvatarTag", ()=>(0, _tagNew.AvatarTag));
parcelHelpers.export(exports, "TagDropdownTrigger", ()=>(0, _tagNew.TagDropdownTrigger));
var _tag = require("./tag");
var _tagDefault = parcelHelpers.interopDefault(_tag);
var _tagNew = require("./tag-new");

},{"./tag":"kRbLA","./tag-new":"31WyZ","@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"kRbLA":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "SimpleTag", ()=>(0, _simpleTagDefault.default));
parcelHelpers.export(exports, "default", ()=>(0, _removableTagDefault.default));
parcelHelpers.export(exports, "RemovableTag", ()=>(0, _removableTag.RemovableTag));
parcelHelpers.export(exports, "AvatarTag", ()=>(0, _avatarTagDefault.default));
var _simpleTag = require("./simple-tag");
var _simpleTagDefault = parcelHelpers.interopDefault(_simpleTag);
var _removableTag = require("./removable-tag");
var _removableTagDefault = parcelHelpers.interopDefault(_removableTag);
var _avatarTag = require("../tag-new/avatar-tag");
var _avatarTagDefault = parcelHelpers.interopDefault(_avatarTag);

},{"./simple-tag":"fErtR","./removable-tag":"3r7wP","../tag-new/avatar-tag":false,"@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"fErtR":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>(0, _simpleDefault.default));
var _simple = require("./internal/simple");
var _simpleDefault = parcelHelpers.interopDefault(_simple);

},{"./internal/simple":"iIKZL","@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"iIKZL":[function(require,module,exports,__globalThis) {
/* index.tsx generated by @compiled/babel-plugin v0.39.1 */ var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _objectSpread = require("@swc/helpers/_/_object_spread");
var _objectWithoutProperties = require("@swc/helpers/_/_object_without_properties");
var _react = require("react");
var _lozenge = require("@atlaskit/lozenge");
var _lozengeDefault = parcelHelpers.interopDefault(_lozenge);
var _platformFeatureFlags = require("@atlaskit/platform-feature-flags");
var _tagNew = require("../../../tag-new");
var _tagNewDefault = parcelHelpers.interopDefault(_tagNew);
var _colorMapping = require("../../../tag-new/color-mapping");
var _base = require("../shared/base");
var _baseDefault = parcelHelpers.interopDefault(_base);
var _before = require("../shared/before");
var _beforeDefault = parcelHelpers.interopDefault(_before);
var _colorToLozengeAppearance = require("../shared/color-to-lozenge-appearance");
var _content = require("../shared/content");
var _contentDefault = parcelHelpers.interopDefault(_content);
const SimpleTagComponent = /*#__PURE__*/ (0, _react.forwardRef)((_param, ref)=>{
    var { appearance, elemBefore = null, color = 'standard', href, testId, text = '', linkComponent, migration_fallback, maxWidth, swatchBefore, swatchBeforeLabel, swatchBeforeRole } = _param, rest = (0, _objectWithoutProperties._)(_param, [
        "appearance",
        "elemBefore",
        "color",
        "href",
        "testId",
        "text",
        "linkComponent",
        "migration_fallback",
        "maxWidth",
        "swatchBefore",
        "swatchBeforeLabel",
        "swatchBeforeRole"
    ]);
    // Handle migration_fallback: render Lozenge when flag is off and migration_fallback is 'lozenge'
    if (migration_fallback === 'lozenge' && !(0, _platformFeatureFlags.fg)('platform-dst-lozenge-tag-badge-visual-uplifts')) {
        const lozengeAppearance = (0, _colorToLozengeAppearance.getLozengeAppearance)(color);
        return /*#__PURE__*/ _react.createElement((0, _lozengeDefault.default), (0, _objectSpread._)({
            appearance: lozengeAppearance,
            isBold: false,
            testId: testId
        }, rest), text);
    }
    // Use new TagNew component behind feature flag
    if ((0, _platformFeatureFlags.fg)('platform-dst-lozenge-tag-badge-visual-uplifts')) {
        const newColor = (0, _colorMapping.colorMapping)[color || 'standard'];
        return /*#__PURE__*/ _react.createElement((0, _tagNewDefault.default), (0, _objectSpread._)({
            ref: ref,
            color: newColor,
            text: text,
            elemBefore: elemBefore,
            href: href,
            testId: testId,
            isRemovable: false,
            maxWidth: maxWidth,
            swatchBefore: swatchBefore
        }, (0, _platformFeatureFlags.fg)('parent-field-switcher-missing-info-image-text') ? {
            swatchBeforeLabel,
            swatchBeforeRole
        } : {}));
    }
    // Original implementation
    const content = /*#__PURE__*/ _react.createElement((0, _contentDefault.default), {
        elemBefore: elemBefore,
        isRemovable: false,
        text: text,
        color: color,
        href: href,
        linkComponent: linkComponent,
        testId: testId
    });
    return /*#__PURE__*/ _react.createElement((0, _baseDefault.default), {
        ref: ref,
        testId: testId,
        href: href,
        appearance: appearance,
        color: color,
        before: /*#__PURE__*/ _react.createElement((0, _beforeDefault.default), {
            elemBefore: elemBefore
        }),
        contentElement: content
    });
});
/**
 * __Simple tag__
 *
 * A tag labels UI objects for quick recognition and navigation.
 *
 * `SimpleTag` is the default form of a tag, where text is required. Tags with static text can be used as a flag or as a reference to an object or attribute.
 *
 * - [Examples](https://atlassian.design/components/tag/examples)
 * - [Code](https://atlassian.design/components/tag/code)
 * - [Usage](https://atlassian.design/components/tag/usage)
 *
 * @deprecated `SimpleTag` is deprecated. Use the default `Tag` export from
 * `@atlaskit/tag` with `isRemovable={false}` instead, e.g. `<Tag text="…" isRemovable={false} />`.
 */ const SimpleTag = /*#__PURE__*/ (0, _react.memo)(SimpleTagComponent);
exports.default = SimpleTag;

},{"@swc/helpers/_/_object_spread":"9gdrV","@swc/helpers/_/_object_without_properties":"6HqIM","react":"ltHCL","@atlaskit/lozenge":"jvjak","@atlaskit/platform-feature-flags":"8rD2i","../../../tag-new":"31WyZ","../../../tag-new/color-mapping":"9fPDi","../shared/base":"c8VVU","../shared/before":"2v0NC","../shared/color-to-lozenge-appearance":"fD0mu","../shared/content":"lkTOq","@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"jvjak":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>(0, _lozengeDefault.default));
parcelHelpers.export(exports, "LozengeDropdownTrigger", ()=>(0, _lozengeDropdownTriggerDefault.default));
var _lozenge = require("./lozenge");
var _lozengeDefault = parcelHelpers.interopDefault(_lozenge);
var _lozengeDropdownTrigger = require("./new/lozenge-dropdown-trigger");
var _lozengeDropdownTriggerDefault = parcelHelpers.interopDefault(_lozengeDropdownTrigger);

},{"./lozenge":"3LZDw","./new/lozenge-dropdown-trigger":"bKqAD","@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"3LZDw":[function(require,module,exports,__globalThis) {
/* lozenge.tsx generated by @compiled/babel-plugin v0.39.1 */ var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _react = require("react");
var _runtime = require("@compiled/react/runtime");
var _platformFeatureFlags = require("@atlaskit/platform-feature-flags");
var _lozenge = require("./new/lozenge");
var _lozengeDefault = parcelHelpers.interopDefault(_lozenge);
/**
 * TODO: We should be using our bounded `cssMap` here, but most of
 * these styles from the visual refresh are not in the Design System.
 */ const styles = {
    container: "_2rkofajl _1reo15vq _18m915vq _1e0c116y _vchhusvi _kqswpfqs _1kz6184x _bozg1b66 _y4ti1b66",
    containerSubtle: "_1cwg1n1a",
    text: "_1reo15vq _18m915vq _ect4ttxp _1wyb1skh _zg8l4jg8 _k48pwu06 _vwz47vkz _1bto1l2s _1p1dangw _o5721q9c",
    customLetterspacing: "_1dyz9vsi",
    'bg.bold.default': "_bfhk1fkg",
    'bg.bold.inprogress': "_bfhk1ymo",
    'bg.bold.moved': "_bfhkxmjf",
    'bg.bold.new': "_bfhkshej",
    'bg.bold.removed': "_bfhk1366",
    'bg.bold.success': "_bfhk3uhp",
    'bg.subtle.default': "_bfhksm61",
    'bg.subtle.inprogress': "_bfhksm61",
    'bg.subtle.moved': "_bfhksm61",
    'bg.subtle.new': "_bfhksm61",
    'bg.subtle.removed': "_bfhksm61",
    'bg.subtle.success': "_bfhksm61",
    'outline.subtle.default': "_12ji14je _1qu2nqa1 _12y3t94y",
    'outline.subtle.inprogress': "_12jiuisw _1qu2nqa1 _12y3t94y",
    'outline.subtle.moved': "_12jih727 _1qu2nqa1 _12y3t94y",
    'outline.subtle.new': "_12ji157s _1qu2nqa1 _12y3t94y",
    'outline.subtle.removed': "_12jia2c0 _1qu2nqa1 _12y3t94y",
    'outline.subtle.success': "_12jin0nx _1qu2nqa1 _12y3t94y",
    'text.subtle': "_syazi7uo",
    'text.bold': "_syazwwip"
};
const appearanceTypes = [
    'default',
    'inprogress',
    'moved',
    'new',
    'removed'
];
const newSemanticColors = [
    'success',
    'discovery',
    'warning',
    'danger',
    'information',
    'neutral'
];
const appearanceMapping = {
    neutral: 'default',
    default: 'default',
    information: 'inprogress',
    inprogress: 'inprogress',
    warning: 'moved',
    moved: 'moved',
    removed: 'removed',
    danger: 'removed',
    success: 'success',
    discovery: 'new',
    new: 'new'
};
/**
 * __Lozenge__
 *
 * A lozenge is a visual indicator used to highlight an item's status for quick recognition.
 *
 * - [Examples](https://atlassian.design/components/lozenge/examples)
 * - [Code](https://atlassian.design/components/lozenge/code)
 * - [Usage](https://atlassian.design/components/lozenge/usage)
 */ const LegacyLozenge = /*#__PURE__*/ (0, _react.memo)(({ children, testId, isBold = false, appearance = 'default', maxWidth = 200, style })=>{
    const appearanceStyle = isBold ? 'bold' : 'subtle';
    const appearanceType = (0, _react.useMemo)(()=>appearanceTypes.includes(appearance) || newSemanticColors.includes(appearance) ? appearanceMapping[appearance] : 'default', [
        appearance
    ]);
    const maxWidthValue = typeof maxWidth === 'string' ? maxWidth : `${maxWidth}px`;
    const maxWidthIsPc = typeof maxWidth === 'string' && /%$/.test(maxWidth);
    return /*#__PURE__*/ _react.createElement("span", {
        style: {
            backgroundColor: style === null || style === void 0 ? void 0 : style.backgroundColor,
            maxWidth: maxWidthIsPc ? maxWidth : '100%'
        },
        "data-testid": testId,
        className: (0, _runtime.ax)([
            styles.container,
            styles[`bg.${appearanceStyle}.${appearanceType}`],
            appearanceStyle === 'subtle' && styles[`outline.subtle.${appearanceType}`],
            appearanceStyle === 'subtle' && styles.containerSubtle
        ])
    }, /*#__PURE__*/ _react.createElement("span", {
        style: {
            color: style === null || style === void 0 ? void 0 : style.color,
            // to negate paddingInline specified on Box above
            maxWidth: maxWidthIsPc ? '100%' : `calc(${maxWidthValue} - ${"var(--ds-space-100, 8px)"})`
        },
        "data-testid": testId && `${testId}--text`,
        className: (0, _runtime.ax)([
            styles.text,
            (0, _platformFeatureFlags.fg)('platform-lozenge-custom-letterspacing') && styles.customLetterspacing,
            styles[`text.${appearanceStyle}`]
        ])
    }, children));
});
LegacyLozenge.displayName = 'Lozenge';
/**
 * Wrapper component that switches between old and new Lozenge based on feature flag
 */ const LozengeWrapper = /*#__PURE__*/ (0, _react.memo)((props)=>{
    if ((0, _platformFeatureFlags.fg)('platform-dst-lozenge-tag-badge-visual-uplifts')) return /*#__PURE__*/ _react.createElement((0, _lozengeDefault.default), props);
    return /*#__PURE__*/ _react.createElement(LegacyLozenge, props);
});
LozengeWrapper.displayName = 'Lozenge';
exports.default = LozengeWrapper;

},{"react":"ltHCL","@compiled/react/runtime":"d27Vo","@atlaskit/platform-feature-flags":"8rD2i","./new/lozenge":"l54Gd","@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"l54Gd":[function(require,module,exports,__globalThis) {
/* lozenge.tsx generated by @compiled/babel-plugin v0.39.1 */ var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _react = require("react");
var _lozengeBase = require("./lozenge-base");
var _lozengeBaseDefault = parcelHelpers.interopDefault(_lozengeBase);
/**
 * __Lozenge__
 *
 * A lozenge is a visual indicator used to highlight an item's status for quick recognition.
 *
 * - [Examples](https://atlassian.design/components/lozenge/examples)
 * - [Code](https://atlassian.design/components/lozenge/code)
 * - [Usage](https://atlassian.design/components/lozenge/usage)
 */ const Lozenge = ({ appearance = 'neutral', spacing = 'default', maxWidth = 200, style, testId, children, iconBefore, trailingMetric, trailingMetricAppearance })=>{
    const baseProps = {
        appearance,
        spacing,
        iconBefore,
        trailingMetric,
        trailingMetricAppearance,
        maxWidth,
        style,
        testId,
        children
    };
    return /*#__PURE__*/ _react.createElement((0, _lozengeBaseDefault.default), baseProps, children);
};
Lozenge.displayName = 'Lozenge';
exports.default = Lozenge;

},{"react":"ltHCL","./lozenge-base":"6GC68","@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"6GC68":[function(require,module,exports,__globalThis) {
/* lozenge-base.tsx generated by @compiled/babel-plugin v0.39.1 */ var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _objectSpread = require("@swc/helpers/_/_object_spread");
var _objectSpreadProps = require("@swc/helpers/_/_object_spread_props");
var _react = require("react");
var _runtime = require("@compiled/react/runtime");
var _new = require("@atlaskit/badge/new");
var _newDefault = parcelHelpers.interopDefault(_new);
var _css = require("@atlaskit/css");
var _chevronDown = require("@atlaskit/icon/core/chevron-down");
var _chevronDownDefault = parcelHelpers.interopDefault(_chevronDown);
var _resizing = require("@atlaskit/motion/resizing");
var _platformFeatureFlags = require("@atlaskit/platform-feature-flags");
// eslint-disable-next-line @atlaskit/design-system/no-emotion-primitives -- TODO: migrate to @atlaskit/primitives/compiled
var _pressable = require("@atlaskit/primitives/pressable");
var _pressableDefault = parcelHelpers.interopDefault(_pressable);
var _spinner = require("@atlaskit/spinner");
var _spinnerDefault = parcelHelpers.interopDefault(_spinner);
var _getThemeStyles = require("./get-theme-styles");
var _iconRenderer = require("./icon-renderer");
var _iconRendererDefault = parcelHelpers.interopDefault(_iconRenderer);
var _utils = require("./utils");
// Get the pressed background color for the selected lozenge dropdown trigger
const pressedBackgroundMapping = {
    success: "var(--ds-background-success-subtler-pressed, #B3DF72)",
    warning: "var(--ds-background-warning-subtler-pressed, #FBC828)",
    danger: "var(--ds-background-danger-subtler-pressed, #FD9891)",
    information: "var(--ds-background-information-subtler-pressed, #8FB8F6)",
    neutral: "var(--ds-background-neutral-pressed, #080F214A)",
    discovery: "var(--ds-background-discovery-subtler-pressed, #D8A0F7)",
    'accent-red': "var(--ds-background-accent-red-subtler-pressed, #FD9891)",
    'accent-orange': "var(--ds-background-accent-orange-subtler-pressed, #FBC828)",
    'accent-yellow': "var(--ds-background-accent-yellow-subtler-pressed, #EED12B)",
    'accent-lime': "var(--ds-background-accent-lime-subtler-pressed, #B3DF72)",
    'accent-green': "var(--ds-background-accent-green-subtler-pressed, #7EE2B8)",
    'accent-teal': "var(--ds-background-accent-teal-subtler-pressed, #9DD9EE)",
    'accent-blue': "var(--ds-background-accent-blue-subtler-pressed, #8FB8F6)",
    'accent-purple': "var(--ds-background-accent-purple-subtler-pressed, #D8A0F7)",
    'accent-magenta': "var(--ds-background-accent-magenta-subtler-pressed, #F797D2)",
    'accent-gray': "var(--ds-background-accent-gray-subtlest-pressed, #B7B9BE)"
};
const styles = {
    container: "_2rko12b0 _1reo15vq _18m915vq _189ee4h9 _1dqonqa1 _1h6d1j28 _kqswh2mm _1e0c116y _4cvr1h6o _vchhusvi _4t3i1k92 _1q51v77o _85i5v77o _bozg1b66 _y4ti1b66",
    motionContainer: "_k8m01rje _1oeci9qs _6fl41d08",
    containerSpacious: "_2rko1qi0 _1tkeviql _1q511b66 _85i51b66 _bozgutpp _y4tiutpp",
    containerBadgePadding: "_y4ti303w",
    text: "_11c8wadc _1reo15vq _18m915vq _o5721q9c",
    textEllipsis: "_1bto1l2s",
    textClip: "_1btozryt",
    textSpacious: "_11c8fhey _k48p1wq8",
    textSelected: "_syaz6x5g",
    loadingOverlay: "_1reo15vq _18m915vq _1e0c1txw _kqswstnw _4cvr1h6o _1bah1h6o _u7coze3t _152tze3t _rjxpze3t _1e02ze3t _lcxvglyw",
    metricBadgeWrapper: "_1e0c1txw",
    'semantic.success': "_3wu02gvx _bfhk14j0 _syaz1p1e",
    'semantic.warning': "_3wu01wfx _bfhk10f4 _syazmgs1",
    'semantic.danger': "_3wu01mzp _bfhk18wg _syaz1blx",
    'semantic.information': "_3wu0wn4u _bfhk8lbg _syaz1qd9",
    'semantic.neutral': "_3wu01l7x _bfhki8nm _syazi7uo",
    'semantic.discovery': "_3wu019v3 _bfhke670 _syaz1g72",
    'accent.red': "_3wu0n9dc _bfhk1rtt _syazhwvp",
    'accent.orange': "_3wu01ip5 _bfhk165s _syaz7i1p",
    'accent.yellow': "_3wu01s7j _bfhk1773 _syazekll",
    'accent.lime': "_3wu01m7d _bfhkz2ec _syaz1ik3",
    'accent.green': "_3wu05d2u _bfhk1wnw _syaz1y78",
    'accent.teal': "_3wu0131p _bfhk1a17 _syaz12v7",
    'accent.blue': "_3wu018hp _bfhk1dy8 _syaz1kyx",
    'accent.purple': "_3wu0luwt _bfhk1nm4 _syaz1mn1",
    'accent.magenta': "_3wu0132u _bfhkv9ra _syaz1qur",
    'accent.gray': "_3wu01l7x _bfhkysee _syaz1tmo",
    'interactive.semantic.success': "_irr31r82 _1di6d6jc",
    'interactive.semantic.warning': "_irr31yx4 _1di6bkku",
    'interactive.semantic.danger': "_irr370oi _1di6jkmi",
    'interactive.semantic.information': "_irr315aw _1di6ar1y",
    'interactive.semantic.neutral': "_irr3plhp _1di61gdz",
    'interactive.semantic.discovery': "_irr3rumk _1di65usi",
    'interactive.accent.red': "_irr3affd _1di61j5a",
    'interactive.accent.orange': "_irr31ei0 _1di6dpo3",
    'interactive.accent.yellow': "_irr31uw7 _1di61r9w",
    'interactive.accent.lime': "_irr31gf0 _1di62kxc",
    'interactive.accent.green': "_irr31e2h _1di6ybhx",
    'interactive.accent.teal': "_irr3kwwr _1di61jb0",
    'interactive.accent.blue': "_irr3815t _1di6rwxf",
    'interactive.accent.purple': "_irr3attl _1di63nfk",
    'interactive.accent.magenta': "_irr31axx _1di642ri",
    'interactive.accent.gray': "_irr3wejn _1di618ut",
    iconBorderFilter: "_1h6d74of",
    content: "_zulp1b66 _1e0c116y _4cvr1h6o",
    maxWidth: "_p12f1osq",
    contentSpacious: "_zulp12x7",
    loadingContent: "_tzy4idpf",
    containerBadgePressed: "_1axmtoke _17i7toke",
    containerBadgeNeutralAppearance: "_1ftrnkaw _1axmnkaw _17i7nkaw"
};
/**
 * __New Lozenge__
 *
 * A lozenge is a visual indicator used to highlight an item's status for quick recognition.
 * This is the updated version with the new North Star visual language.
 */ const LozengeBase = /*#__PURE__*/ (0, _react.memo)(/*#__PURE__*/ (0, _react.forwardRef)(({ children, testId, appearance, iconBefore, trailingMetric, trailingMetricAppearance, maxWidth = 200, spacing = 'default', isSelected, // for dropdown trigger
isLoading = false, // for dropdown trigger
onClick, // for dropdown trigger
style, analyticsContext, interactionName, 'aria-controls': ariaControls, 'aria-expanded': ariaExpanded, 'aria-haspopup': ariaHaspopup, 'aria-label': ariaLabel }, ref)=>{
    const [resizing, setResizing] = (0, _react.useState)(false);
    const onFinishMotion = ()=>setResizing(false);
    const resizingWidth = (0, _resizing.useResizing)({
        dimension: 'width',
        duration: "var(--ds-duration-medium, 200ms)",
        easing: "var(--ds-easing-inout-bold, cubic-bezier(0.4, 0, 0, 1))",
        onFinishMotion
    });
    const isInitialRender = (0, _react.useRef)(true);
    const isInteractive = typeof onClick === 'function';
    // Determine the effective color, with fallback logic for legacy appearances
    const resolvedColor = (0, _utils.resolveLozengeColor)(appearance) || 'neutral';
    const { category, key } = (0, _getThemeStyles.getThemeStyles)(resolvedColor);
    const colorStyleKey = `${category}.${key}`;
    const interactiveStyleKey = `interactive.${category}.${key}`;
    const maxWidthValue = typeof maxWidth === 'string' ? maxWidth : `${maxWidth}px`;
    const maxWidthIsPc = typeof maxWidth === 'string' && maxWidth.endsWith('%');
    const resolvedTrailingMetricAppearance = trailingMetricAppearance ? trailingMetricAppearance === 'inverse' ? 'inverse' : (0, _utils.resolveLozengeColor)(trailingMetricAppearance) : resolvedColor;
    // Map the resolved trailing metric appearance to a Badge appearance.
    // Semantic colors map to their new bold variants (e.g. successBold),
    // which provide sufficient color emphasis on top of the subtler
    // lozenge background. Accent colors and unknown values fall back to
    // the neutral appearance.
    const metricBadgeAppearance = (()=>{
        if (resolvedTrailingMetricAppearance === 'inverse') return 'inverse';
        if (resolvedTrailingMetricAppearance == null) return 'neutral';
        if (resolvedTrailingMetricAppearance.startsWith('accent-')) return 'neutral';
        switch(resolvedTrailingMetricAppearance){
            case 'success':
                return 'successBold';
            case 'warning':
                return 'warningBold';
            case 'danger':
                return 'dangerBold';
            case 'information':
                return 'informationBold';
            case 'discovery':
                return 'discoveryBold';
            case 'neutral':
            default:
                return 'neutral';
        }
    })();
    const commonStyleOverrides = {
        backgroundColor: style === null || style === void 0 ? void 0 : style.backgroundColor,
        // Constrain the container to the smaller of the explicit maxWidth and 100% of
        // the parent. Using min(...) means the lozenge never overflows its parent,
        // while still honouring the explicit maxWidth prop when the parent is wider.
        maxWidth: maxWidthIsPc ? maxWidth : `min(${maxWidthValue}, 100%)`
    };
    const hasTrailingMetric = trailingMetric != null && trailingMetric !== '';
    const childrenKey = typeof children === 'string' ? children : undefined;
    (0, _react.useLayoutEffect)(()=>{
        // Ignore initial render
        if (isInitialRender.current) {
            isInitialRender.current = false;
            return;
        }
        setResizing(true);
    }, [
        childrenKey
    ]);
    const enableMotionFG = (0, _platformFeatureFlags.fg)('platform-dst-motion-uplift');
    const innerContent = /*#__PURE__*/ _react.createElement("span", (0, _objectSpreadProps._)((0, _objectSpread._)({}, enableMotionFG ? resizingWidth : undefined), {
        className: (0, _runtime.ax)([
            styles.content,
            spacing === 'spacious' && styles.contentSpacious,
            isLoading && styles.loadingContent,
            // Constrain the content wrapper to its container so text truncation
            // works correctly within the flex layout, regardless of whether maxWidth
            // is a percentage, fixed value, or the parent container is narrower than
            // the explicit maxWidth.
            styles.maxWidth
        ])
    }), iconBefore && /*#__PURE__*/ _react.createElement((0, _iconRendererDefault.default), {
        size: spacing === 'spacious' ? 'medium' : 'small',
        icon: iconBefore,
        color: resolvedColor,
        testId: testId && `${testId}--icon`
    }), /*#__PURE__*/ _react.createElement("span", {
        style: {
            // The text fills 100% of the inner content wrapper. The container's
            // own max-width (set on the container via commonStyleOverrides) handles
            // the actual size constraint, so the text just needs to fill the available
            // space and truncate when it overflows.
            maxWidth: maxWidthIsPc ? '100%' : `calc(${maxWidthValue} - ${"var(--ds-space-100, 8px)"})`,
            color: style === null || style === void 0 ? void 0 : style.color
        },
        "data-testid": testId && `${testId}--text`,
        className: (0, _runtime.ax)([
            styles.text,
            enableMotionFG && resizing && !maxWidth ? styles.textClip : styles.textEllipsis,
            spacing === 'spacious' && styles.textSpacious
        ])
    }, children), hasTrailingMetric && !resolvedColor.startsWith('accent-') && /*#__PURE__*/ _react.createElement("span", {
        "data-lozenge-metric-wrapper": true,
        "data-testid": testId && `${testId}--metric`,
        className: (0, _runtime.ax)([
            styles.metricBadgeWrapper
        ])
    }, /*#__PURE__*/ _react.createElement((0, _newDefault.default), {
        appearance: metricBadgeAppearance
    }, trailingMetric)), isInteractive && /*#__PURE__*/ _react.createElement((0, _chevronDownDefault.default), {
        label: "",
        size: "small",
        color: 'currentColor',
        testId: testId && `${testId}--chevron`
    }));
    if (isInteractive) return /*#__PURE__*/ _react.createElement((0, _pressableDefault.default), (0, _objectSpread._)((0, _objectSpreadProps._)((0, _objectSpread._)({
        ref: ref,
        xcss: (0, _css.cx)(styles.container, (0, _platformFeatureFlags.fg)('platform-dst-motion-uplift') && styles.motionContainer, spacing === 'spacious' && styles.containerSpacious, !isSelected && styles.iconBorderFilter, styles[colorStyleKey], !isLoading && styles[interactiveStyleKey], hasTrailingMetric && styles.containerBadgePressed, hasTrailingMetric && resolvedTrailingMetricAppearance === 'neutral' && styles.containerBadgeNeutralAppearance)
    }, isLoading && {
        'aria-busy': true,
        'aria-disabled': true,
        isDisabled: true
    }), {
        "aria-label": isLoading ? 'Loading' : ariaLabel,
        "aria-controls": ariaControls,
        "aria-expanded": ariaExpanded,
        "aria-haspopup": ariaHaspopup,
        onClick: isLoading ? undefined : onClick,
        style: (0, _objectSpreadProps._)((0, _objectSpread._)({}, commonStyleOverrides), {
            // Specified because Pressable has a default border:none which overrides the border specified on the container
            // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop
            border: `solid ${"var(--ds-border-width, 1px)"} ${isSelected ? 'var(--border-color) !important' : 'transparent'}`,
            backgroundColor: isSelected ? pressedBackgroundMapping[resolvedColor] : undefined,
            cursor: isLoading ? 'progress' : 'pointer'
        }),
        testId: testId,
        analyticsContext: analyticsContext,
        interactionName: interactionName,
        componentName: "LozengeDropdownTrigger"
    }), isSelected && {
        'data-selected': 'true'
    }), innerContent, isLoading && /*#__PURE__*/ _react.createElement("span", {
        className: (0, _runtime.ax)([
            styles.loadingOverlay
        ])
    }, /*#__PURE__*/ _react.createElement((0, _spinnerDefault.default), {
        size: spacing === 'spacious' ? 'small' : 'xsmall',
        label: ", Loading",
        testId: testId ? `${testId}--loading-spinner` : undefined
    })));
    return /*#__PURE__*/ _react.createElement("span", {
        ref: ref,
        style: commonStyleOverrides,
        "data-testid": testId,
        className: (0, _runtime.ax)([
            styles.container,
            spacing === 'spacious' && styles.containerSpacious,
            spacing !== 'spacious' && hasTrailingMetric && styles.containerBadgePadding,
            styles[colorStyleKey],
            styles.iconBorderFilter,
            hasTrailingMetric && resolvedTrailingMetricAppearance === 'neutral' && styles.containerBadgeNeutralAppearance
        ])
    }, innerContent);
}));
exports.default = LozengeBase;

},{"@swc/helpers/_/_object_spread":"9gdrV","@swc/helpers/_/_object_spread_props":"kANqQ","react":"ltHCL","@compiled/react/runtime":"d27Vo","@atlaskit/badge/new":"jynnB","@atlaskit/css":"kMGms","@atlaskit/icon/core/chevron-down":"ieg9F","@atlaskit/motion/resizing":"5YLzp","@atlaskit/platform-feature-flags":"8rD2i","@atlaskit/primitives/pressable":"hb6DX","@atlaskit/spinner":"l22fT","./get-theme-styles":"eLVAh","./icon-renderer":"4cb4c","./utils":"fkZGz","@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"jynnB":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>(0, _badgeNewDefault.default));
var _badgeNew = require("../badge-new");
var _badgeNewDefault = parcelHelpers.interopDefault(_badgeNew);

},{"../badge-new":"3ineL","@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"5YLzp":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "Resizing", ()=>(0, _resizing.Resizing));
parcelHelpers.export(exports, "useResizing", ()=>(0, _useResizing.useResizing));
var _resizing = require("../resizing/resizing");
var _useResizing = require("../resizing/use-resizing");

},{"../resizing/resizing":false,"../resizing/use-resizing":"e3UMF","@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"e3UMF":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "useResizing", ()=>useResizing);
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _isReducedMotion = require("../utils/is-reduced-motion");
var _useElementRef = require("../utils/use-element-ref");
var _useLayoutEffect = require("../utils/use-layout-effect");
var _useRequestAnimationFrame = require("../utils/use-request-animation-frame");
var _useSetTimeout = require("../utils/use-set-timeout");
var _useSnapshotBeforeUpdate = require("../utils/use-snapshot-before-update");
/**
 * Parses a CSS time value (e.g. `"0.2s"` or `"200ms"`) and returns milliseconds.
 * Falls back to 0 if the value cannot be parsed.
 */ function parseCSSTimeToMs(value) {
    const parsed = parseFloat(value);
    if (Number.isNaN(parsed)) return 0;
    if (value.endsWith('ms')) return parsed;
    return parsed * 1000;
}
/**
 * Returns `true` if any of the dimension(s) being animated have changed
 * between the previous and next measurements.
 */ function hasDimensionChanged(dimension, prev, next) {
    if (dimension === 'width') return prev.width !== next.width;
    if (dimension === 'height') return prev.height !== next.height;
    return prev.width !== next.width || prev.height !== next.height;
}
/**
 * Returns the CSS `transition-property` / `will-change` value for the
 * given dimension(s).
 */ function getDimensionPropertyList(dimension) {
    if (dimension === 'both') return 'width, height';
    return dimension;
}
const useResizing = ({ dimension, duration, easing, onFinishMotion })=>{
    const prevDimensions = (0, _react.useRef)();
    const [element, setElementRef] = (0, _useElementRef.useElementRef)();
    const setTimeout = (0, _useSetTimeout.useSetTimeout)({
        cleanup: 'next-effect'
    });
    const requestAnimationFrame = (0, _useRequestAnimationFrame.useRequestAnimationFrame)();
    (0, _useSnapshotBeforeUpdate.useSnapshotBeforeUpdate)(()=>{
        if ((0, _isReducedMotion.isReducedMotion)() || !element) return;
        const rect = element.getBoundingClientRect();
        prevDimensions.current = {
            width: rect.width,
            height: rect.height
        };
    });
    (0, _useLayoutEffect.useLayoutEffect)(()=>{
        if ((0, _isReducedMotion.isReducedMotion)() || !element || !prevDimensions.current) return;
        // We might already be animating.
        // Because of that we need to expand to the destination dimensions first.
        element.setAttribute('style', '');
        const rect = element.getBoundingClientRect();
        const nextDimensions = {
            width: rect.width,
            height: rect.height
        };
        if (!hasDimensionChanged(dimension, prevDimensions.current, nextDimensions)) {
            onFinishMotion === null || onFinishMotion === void 0 ? void 0 : onFinishMotion();
            return;
        }
        const propertyList = getDimensionPropertyList(dimension);
        const newStyles = {
            willChange: propertyList,
            transitionProperty: propertyList,
            transitionDuration: duration,
            boxSizing: 'border-box',
            transitionTimingFunction: easing
        };
        if (dimension === 'width' || dimension === 'both') newStyles.width = `${prevDimensions.current.width}px`;
        if (dimension === 'height' || dimension === 'both') newStyles.height = `${prevDimensions.current.height}px`;
        Object.assign(element.style, newStyles);
        const resolvedDuration = parseCSSTimeToMs(getComputedStyle(element).transitionDuration);
        // We split this over two animation frames so the DOM has enough time to flush the changes.
        // We are deliberately not skipping this frame if another render happens - if we do the motion doesn't finish properly.
        requestAnimationFrame(()=>{
            requestAnimationFrame(()=>{
                if (!element) return;
                if (dimension === 'width' || dimension === 'both') element.style.width = `${nextDimensions.width}px`;
                if (dimension === 'height' || dimension === 'both') element.style.height = `${nextDimensions.height}px`;
                setTimeout(()=>{
                    if (!element) return;
                    element.setAttribute('style', '');
                    onFinishMotion === null || onFinishMotion === void 0 ? void 0 : onFinishMotion();
                }, resolvedDuration);
            });
        });
    });
    return {
        ref: setElementRef
    };
};

},{"react":"ltHCL","../utils/is-reduced-motion":"XfCCa","../utils/use-element-ref":"3UxZJ","../utils/use-layout-effect":"emFaL","../utils/use-request-animation-frame":"jYsxU","../utils/use-set-timeout":"hOeL0","../utils/use-snapshot-before-update":"im97U","@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"eLVAh":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "getThemeStyles", ()=>getThemeStyles);
const getThemeStyles = (resolvedColor)=>{
    const isAccent = resolvedColor.startsWith('accent-');
    const category = isAccent ? 'accent' : 'semantic';
    const key = isAccent ? resolvedColor.replace('accent-', '') : resolvedColor;
    return {
        category,
        key
    };
};

},{"@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"4cb4c":[function(require,module,exports,__globalThis) {
/* icon-renderer.tsx generated by @compiled/babel-plugin v0.39.1 */ var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _platformFeatureFlags = require("@atlaskit/platform-feature-flags");
var _compiled = require("@atlaskit/primitives/compiled");
// Map lozenge colors to appropriate icon colors.
//
// We intentionally use `color.text.*.bolder` tokens for icons across all
// colored lozenges (semantic + accent). Text tokens use higher-stop palette
// values (Color700+) which pass 3:1 contrast against subtler backgrounds in
// every interactive state — including pressed where icon Color600 fails for
// most hues. Using text tokens uniformly:
//   - avoids global changes to the `color.icon.*` token ramps
//   - keeps icon and text visually aligned in the lozenge
//   - guarantees ≥3:1 contrast across default/hover/pressed states
//
// Neutral lozenges use `color.text.subtle` to match the neutral text styling
// and remain consistent with their alpha-based backgrounds.
const getIconColor = (color)=>{
    switch(color){
        // Semantic
        case 'success':
            return "var(--ds-text-success, #4C6B1F)";
        case 'warning':
            return "var(--ds-text-warning, #9E4C00)";
        case 'danger':
            return "var(--ds-text-danger, #AE2E24)";
        case 'information':
            return "var(--ds-text-information, #1558BC)";
        case 'discovery':
            return "var(--ds-text-discovery, #803FA5)";
        case 'neutral':
            return "var(--ds-text-subtle, #505258)";
        // Accent
        case 'accent-red':
            return "var(--ds-text-accent-red, #AE2E24)";
        case 'accent-orange':
            return "var(--ds-text-accent-orange, #9E4C00)";
        case 'accent-yellow':
            return "var(--ds-text-accent-yellow, #7F5F01)";
        case 'accent-lime':
            return "var(--ds-text-accent-lime, #4C6B1F)";
        case 'accent-green':
            return "var(--ds-text-accent-green, #216E4E)";
        case 'accent-teal':
            return "var(--ds-text-accent-teal, #206A83)";
        case 'accent-blue':
            return "var(--ds-text-accent-blue, #1558BC)";
        case 'accent-purple':
            return "var(--ds-text-accent-purple, #803FA5)";
        case 'accent-magenta':
            return "var(--ds-text-accent-magenta, #943D73)";
        case 'accent-gray':
            return "var(--ds-text-subtle, #505258)";
        default:
            return "var(--ds-text-subtle, #505258)";
    }
};
const styles = {
    motion: "_k8m01ylx _1oeci9qs _6fl41d08"
}; /**
    * Icon renderer for lozenge components
    * Handles proper sizing and color theming for icons
    */ 
const IconRenderer = ({ icon: Icon, color, testId, size })=>{
    const iconColor = getIconColor(color);
    return (0, _platformFeatureFlags.fg)('platform-dst-motion-uplift') ? /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _compiled.Box), {
        xcss: styles.motion,
        style: {
            color: iconColor
        }
    }, /*#__PURE__*/ (0, _reactDefault.default).createElement(Icon, {
        label: "",
        size: size,
        testId: testId
    })) : // Cast required because the lozenge intentionally uses some
    // `color.text.*.bolder` tokens for icons that don't pass 3:1 contrast
    // at their default `color.icon.*` stop. The Icon component types only
    // accept `IconColor`, but text tokens are valid CSS color values and
    // render correctly at runtime.
    /*#__PURE__*/ (0, _reactDefault.default).createElement(Icon, {
        color: iconColor,
        label: "",
        size: size,
        testId: testId
    });
};
// eslint-disable-next-line @atlaskit/volt-strict-mode/no-multiple-exports
exports.default = IconRenderer;

},{"react":"ltHCL","@atlaskit/platform-feature-flags":"8rD2i","@atlaskit/primitives/compiled":"hDay7","@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"fkZGz":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "getThemeStyles", ()=>(0, _getThemeStyles.getThemeStyles));
parcelHelpers.export(exports, "resolveLozengeColor", ()=>resolveLozengeColor);
var _getThemeStyles = require("./get-theme-styles");
// Map legacy appearance to new color values
const legacyAppearanceMap = {
    default: 'neutral',
    removed: 'danger',
    inprogress: 'information',
    new: 'discovery',
    moved: 'warning'
};
const resolveLozengeColor = (appearance = 'neutral')=>{
    if (appearance.startsWith('accent-')) return appearance;
    var _legacyAppearanceMap_appearance;
    return (_legacyAppearanceMap_appearance = legacyAppearanceMap[appearance]) !== null && _legacyAppearanceMap_appearance !== void 0 ? _legacyAppearanceMap_appearance : appearance;
};

},{"./get-theme-styles":false,"@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"bKqAD":[function(require,module,exports,__globalThis) {
/* lozenge-dropdown-trigger.tsx generated by @compiled/babel-plugin v0.39.1 */ var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _objectSpread = require("@swc/helpers/_/_object_spread");
var _react = require("react");
var _noop = require("@atlaskit/ds-lib/noop");
var _noopDefault = parcelHelpers.interopDefault(_noop);
var _lozengeBase = require("./lozenge-base");
var _lozengeBaseDefault = parcelHelpers.interopDefault(_lozengeBase);
/**
 * __Lozenge Dropdown Trigger__
 *
 * An interactive lozenge component that acts as a dropdown trigger.
 * Built on LozengeBase with dropdown interaction patterns.
 *
 * - Supports all color variants from the lozenge
 * - Shows selected state with dedicated color tokens
 * - Includes a chevron icon on the right of the text
 * - Built for dropdown menu interactions
 * - Supports analytics events and UFO press interactions
 */ const LozengeDropdownTrigger = /*#__PURE__*/ (0, _react.memo)(/*#__PURE__*/ (0, _react.forwardRef)(({ children, testId, appearance = 'neutral', spacing = 'default', iconBefore, trailingMetric, trailingMetricAppearance, isSelected = false, isLoading = false, maxWidth = 200, onClick = (0, _noopDefault.default), style, analyticsContext, interactionName, 'aria-controls': ariaControls, 'aria-expanded': ariaExpanded, 'aria-haspopup': ariaHaspopup, 'aria-label': ariaLabel }, ref)=>{
    const baseProps = {
        appearance,
        spacing,
        iconBefore,
        trailingMetric,
        trailingMetricAppearance,
        isSelected,
        isLoading,
        maxWidth,
        style,
        testId,
        onClick,
        analyticsContext,
        interactionName,
        children,
        'aria-controls': ariaControls,
        'aria-expanded': ariaExpanded,
        'aria-haspopup': ariaHaspopup,
        'aria-label': ariaLabel
    };
    return /*#__PURE__*/ _react.createElement((0, _lozengeBaseDefault.default), (0, _objectSpread._)({
        ref: ref
    }, baseProps), children);
}));
LozengeDropdownTrigger.displayName = 'LozengeDropdownTrigger';
exports.default = LozengeDropdownTrigger;

},{"@swc/helpers/_/_object_spread":"9gdrV","react":"ltHCL","@atlaskit/ds-lib/noop":"faKzG","./lozenge-base":"6GC68","@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"31WyZ":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>(0, _tagNewDefault.default));
parcelHelpers.export(exports, "TagNew", ()=>(0, _tagNewDefault.default));
parcelHelpers.export(exports, "colorMapping", ()=>(0, _tagNew.colorMapping));
parcelHelpers.export(exports, "AvatarTag", ()=>(0, _avatarTagDefault.default));
parcelHelpers.export(exports, "TagDropdownTrigger", ()=>(0, _tagDropdownTriggerDefault.default));
var _tagNew = require("./tag-new");
var _tagNewDefault = parcelHelpers.interopDefault(_tagNew);
var _avatarTag = require("./avatar-tag");
var _avatarTagDefault = parcelHelpers.interopDefault(_avatarTag);
var _tagDropdownTrigger = require("./tag-dropdown-trigger");
var _tagDropdownTriggerDefault = parcelHelpers.interopDefault(_tagDropdownTrigger);

},{"./tag-new":"lvVHN","./avatar-tag":"hUteJ","./tag-dropdown-trigger":false,"@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"lvVHN":[function(require,module,exports,__globalThis) {
/* tag-new.tsx generated by @compiled/babel-plugin v0.39.1 */ var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "colorMapping", ()=>(0, _colorMapping.colorMapping));
parcelHelpers.export(exports, "TagDropdownTriggerComponent", ()=>TagDropdownTriggerComponent);
var _objectSpread = require("@swc/helpers/_/_object_spread");
var _objectSpreadProps = require("@swc/helpers/_/_object_spread_props");
var _objectWithoutProperties = require("@swc/helpers/_/_object_without_properties");
var _react = require("react");
var _runtime = require("@compiled/react/runtime");
var _react1 = require("@compiled/react");
var _chevronDown = require("@atlaskit/icon/core/chevron-down");
var _chevronDownDefault = parcelHelpers.interopDefault(_chevronDown);
var _platformFeatureFlags = require("@atlaskit/platform-feature-flags");
var _compiled = require("@atlaskit/primitives/compiled");
var _spinner = require("@atlaskit/spinner");
var _spinnerDefault = parcelHelpers.interopDefault(_spinner);
var _colorMapping = require("./color-mapping");
var _getTagText = require("./get-tag-text");
var _linkWrapper = require("./link-wrapper");
var _removableWrapper = require("./removable-wrapper");
var _swatchBefore = require("./swatch-before");
var _swatchBeforeDefault = parcelHelpers.interopDefault(_swatchBefore);
var _useButtonInteraction = require("./use-button-interaction");
var _useLink = require("./use-link");
var _useRemoveButton = require("./use-remove-button");
var _useTagRemoval = require("./use-tag-removal");
const styles = {
    baseStyles: "_zulp1b66 _2rko12b0 _11c8wadc _1dqonqa1 _189ee4h9 _1rjcv77o _18zr1mie _1mou1b66 _195g1b66 _1e0c116y _vchhusvi _1ul9idpf _p12ff6dh _4t3i1k92 _kqswh2mm _4cvr1h6o _80om73ad _bfhksm61",
    noMarginStyles: "_1mouze3t _195gze3t",
    removableStyles: "_zulp1b66",
    beforeStyles: "_4bfu1snc _1hmsagmp _ajmmvv82 _1e0c116y _4cvr1h6o _1o9zidpf _syaz125o",
    beforeStylesSelected: "_syazxl6c",
    textStyles: "_1reo15vq _18m915vq _1bto1l2s _o5721q9c _16jlkb7n _1ul9idpf _syazi7uo",
    textStylesSelected: "_syaz6x5g",
    afterStyles: "_1e0c1txw _4cvr1h6o _1o9zidpf _lcxv1wug _kqswh2mm",
    trailingMetric: "_2rkolb4i _11c8wadc _18zr1b66 _1rjcidpf _1e0c116y _vchhusvi _1ul91ejb _1bah1h6o _4cvr1h6o _1o9zidpf _1kz6184x _bfhk1w9g _syazi7uo",
    trailingMetricEndPadding: "_y4ti303w",
    focusRingStyles: "_1ygbdfik _1ah3v77o",
    childFocusRingStyles: "_1a37dfik _1cwgv77o",
    interactiveBaseStyles: "_80omtlke _1all1b66 _qsdj1r31 _17ncglyw _15hpnqa1 _1rg815vq _1yoo15vq _j8j91snc _1afaagmp _gdbt10yn _h5vp116y _1qxz1h6o _8zx0idpf _1km4jdj5 _wc1fagmp _9408jdj5 _usew1snc _ebtnagmp _uvk910yn _10nj1r31 _1xq0glyw _18x1nqa1 _2mpsagmp",
    interactiveHoverStyles: "_17501r31 _qrsc8stv _1wodnqa1 _irr31dpa _rlyhjdj5 _1di6fcek"
};
// For accent borders, we use the new color.border.accent.*.subtle tokens (Color300
// light / Color800 dark) which provide proper decorative-border colours
//
// Icons keep color.icon.accent.* in the default state (vibrant on the plain page
// background) and swap to color.text.accent.* in hovered/pressed states (where the
// Tag picks up a coloured background and needs guaranteed 3:1 icon contrast).
const colorStyles = {
    gray: "_119bmsup _1ib21diz _egnk1sqi _17x31sqi _ih6z7qp0",
    blue: "_119b18hp _1ib26txe _egnk16jw _17x316jw _ih6z1dy8",
    green: "_119b5d2u _1ib217hp _egnkh55r _17x3h55r _ih6z1wnw",
    red: "_119bn9dc _1ib2nbxb _egnk9lu1 _17x39lu1 _ih6z1rtt",
    yellow: "_119b1s7j _1ib21oqg _egnkfb2s _17x3fb2s _ih6z1773",
    purple: "_119bluwt _1ib2uq3u _egnkqmo9 _17x3qmo9 _ih6z1nm4",
    lime: "_119b1m7d _1ib28645 _egnk1tco _17x31tco _ih6zz2ec",
    magenta: "_119b132u _1ib2v8hk _egnk1s8m _17x31s8m _ih6zv9ra",
    orange: "_119b1ip5 _1ib21j6y _egnkp1lv _17x3p1lv _ih6z165s",
    teal: "_119b131p _1ib28uof _egnk17qg _17x317qg _ih6z1a17"
};
// Border + icon filter styles - base state.
// Borders use the new color.border.accent.*.subtle tokens directly.
// Icons use the color.icon.accent.* tokens directly in the default state.
const borderIconFilterStyles = {
    root: "_1h6dip4g _wi6h9ea2"
};
// Border + icon filter styles - interactive states (hover/pressed).
// Icons swap to the color.text.accent.* tokens for guaranteed 3:1 contrast
// against the coloured interactive backgrounds. Borders stay constant.
const borderIconInteractiveFilterStyles = {
    root: "_4cvxip4g _zqoiipvw _q4ztip4g _ba35u0j8"
};
const dropdownStyles = {
    interactive: "_irr31dpa _1di6fcek",
    selected: "_1h6dq98m _syaz6x5g _bfhk15s3 _irr3ufnl _1di6nozp",
    content: "_zulp1b66 _1reo15vq _18m915vq _1e0c116y _4cvr1h6o _16jlkb7n _1o9zkb7n _1ul9idpf",
    loadingContent: "_tzy4idpf",
    loadingOverlay: "_1reo15vq _18m915vq _1e0c1txw _kqswstnw _4cvr1h6o _1bah1h6o _u7coze3t _152tze3t _rjxpze3t _1e02ze3t _lcxvglyw"
};
/**
 * __TagNew__
 *
 * TagNew is the visual uplift implementation of Tag
 */ const TagNewComponent = /*#__PURE__*/ (0, _react.forwardRef)(function TagNew(_param, ref) {
    var { color = 'gray', text, elemBefore, href, linkComponent, isRemovable = true, removeButtonLabel, onBeforeRemoveAction, onAfterRemoveAction, testId, maxWidth, hasMargin = true, onClick, swatchBefore, swatchBeforeLabel, swatchBeforeRole, trailingMetric } = _param, other = (0, _objectWithoutProperties._)(_param, [
        "color",
        "text",
        "elemBefore",
        "href",
        "linkComponent",
        "isRemovable",
        "removeButtonLabel",
        "onBeforeRemoveAction",
        "onAfterRemoveAction",
        "testId",
        "maxWidth",
        "hasMargin",
        "onClick",
        "swatchBefore",
        "swatchBeforeLabel",
        "swatchBeforeRole",
        "trailingMetric"
    ]);
    const normalizedText = (0, _getTagText.getTagText)(text);
    const { status, handleRemoveRequest, onKeyPress, removingTag, showingTag } = (0, _useTagRemoval.useTagRemoval)(onBeforeRemoveAction);
    const onShrinkOutExitComplete = (0, _react.useCallback)(()=>{
        onAfterRemoveAction === null || onAfterRemoveAction === void 0 ? void 0 : onAfterRemoveAction(normalizedText);
    }, [
        normalizedText,
        onAfterRemoveAction
    ]);
    const { isLink, LinkComponent } = (0, _useLink.useLink)(href, linkComponent);
    const { isLinkHovered, isOverButton, isButtonFocused, isLinkFocused, buttonHandlers, linkHandlers } = (0, _useButtonInteraction.useButtonInteraction)();
    const removeButton = (0, _useRemoveButton.useRemoveButton)({
        isRemovable,
        tagText: normalizedText,
        removeButtonLabel,
        testId,
        handleRemoveRequest,
        removingTag,
        showingTag,
        onKeyPress,
        buttonHandlers
    });
    const tagContent = /*#__PURE__*/ _react.createElement("span", (0, _objectSpreadProps._)((0, _objectSpread._)({}, other), {
        ref: ref,
        "data-testid": testId,
        // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop
        style: maxWidth !== undefined ? {
            maxWidth
        } : undefined,
        className: (0, _runtime.ax)([
            styles.baseStyles,
            !hasMargin && styles.noMarginStyles,
            colorStyles[color],
            borderIconFilterStyles.root,
            isLink && styles.interactiveBaseStyles,
            isLink && styles.focusRingStyles,
            isLink && isLinkHovered && !isOverButton && borderIconInteractiveFilterStyles.root,
            isLink && isLinkHovered && !isOverButton && styles.interactiveHoverStyles,
            isRemovable && styles.removableStyles,
            isLinkFocused && !isButtonFocused && styles.childFocusRingStyles,
            !isRemovable && trailingMetric != null && trailingMetric !== '' && styles.trailingMetricEndPadding
        ])
    }), /*#__PURE__*/ _react.createElement((0, _linkWrapper.LinkWrapper), {
        isLink: isLink,
        href: href,
        LinkComponent: LinkComponent,
        testId: testId,
        linkHandlers: linkHandlers,
        onClick: onClick
    }, /*#__PURE__*/ _react.createElement((0, _swatchBeforeDefault.default), (0, _objectSpread._)({
        colorKey: color,
        swatchBefore: swatchBefore
    }, (0, _platformFeatureFlags.fg)('parent-field-switcher-missing-info-image-text') ? {
        swatchBeforeLabel,
        swatchBeforeRole
    } : {})), elemBefore && /*#__PURE__*/ _react.createElement("span", {
        className: (0, _runtime.ax)([
            styles.beforeStyles
        ])
    }, elemBefore), /*#__PURE__*/ _react.createElement("span", {
        "data-tag-text": true,
        className: (0, _runtime.ax)([
            styles.textStyles
        ])
    }, normalizedText), trailingMetric != null && trailingMetric !== '' && /*#__PURE__*/ _react.createElement("span", {
        "data-testid": testId && `${testId}--metric`,
        className: (0, _runtime.ax)([
            styles.trailingMetric
        ])
    }, trailingMetric)), removeButton && /*#__PURE__*/ _react.createElement("span", {
        className: (0, _runtime.ax)([
            styles.afterStyles
        ])
    }, removeButton));
    return /*#__PURE__*/ _react.createElement((0, _removableWrapper.RemovableWrapper), {
        isRemovable: isRemovable,
        status: status,
        onShrinkOutExitComplete: isRemovable ? onShrinkOutExitComplete : undefined
    }, tagContent);
});
const TagDropdownTriggerComponent = /*#__PURE__*/ (0, _react.forwardRef)(function TagDropdownTrigger(_param, ref) {
    var { color = 'gray', text, elemBefore, testId, maxWidth, hasMargin = true, onClick, isSelected = false, isLoading = false, analyticsContext: _analyticsContext, hasChevron = true, swatchBefore, swatchBeforeLabel, swatchBeforeRole, trailingMetric } = _param, other = (0, _objectWithoutProperties._)(_param, [
        "color",
        "text",
        "elemBefore",
        "testId",
        "maxWidth",
        "hasMargin",
        "onClick",
        "isSelected",
        "isLoading",
        "analyticsContext",
        "hasChevron",
        "swatchBefore",
        "swatchBeforeLabel",
        "swatchBeforeRole",
        "trailingMetric"
    ]);
    const resolvedColor = (0, _colorMapping.colorMapping)[color] || 'gray';
    return /*#__PURE__*/ _react.createElement((0, _compiled.Pressable), (0, _objectSpread._)((0, _objectSpreadProps._)((0, _objectSpread._)({
        ref: ref,
        // @ts-expect-error paddingInline is 0.1875rem
        // eslint-disable-next-line @compiled/no-suppress-xcss
        xcss: (0, _react1.cx)(styles.baseStyles, !hasMargin && styles.noMarginStyles, colorStyles[resolvedColor], borderIconFilterStyles.root, dropdownStyles.interactive, styles.focusRingStyles, borderIconInteractiveFilterStyles.root, isSelected && dropdownStyles.selected, // Reduce end padding when trailing metric is the last element (no chevron)
        !hasChevron && trailingMetric != null && trailingMetric !== '' && styles.trailingMetricEndPadding),
        onClick: isLoading ? undefined : onClick,
        style: {
            borderColor: isSelected ? "var(--ds-border-selected, #1868DB)" : undefined,
            cursor: isLoading ? 'progress' : 'pointer',
            maxWidth: maxWidth !== undefined ? maxWidth : undefined
        }
    }, isLoading && {
        'aria-busy': true,
        'aria-disabled': true,
        isDisabled: true
    }), {
        testId: testId
    }), other), /*#__PURE__*/ _react.createElement("span", {
        className: (0, _runtime.ax)([
            dropdownStyles.content,
            isLoading && dropdownStyles.loadingContent
        ])
    }, /*#__PURE__*/ _react.createElement((0, _swatchBeforeDefault.default), (0, _objectSpread._)({
        colorKey: resolvedColor,
        swatchBefore: swatchBefore
    }, (0, _platformFeatureFlags.fg)('parent-field-switcher-missing-info-image-text') ? {
        swatchBeforeLabel,
        swatchBeforeRole
    } : {})), elemBefore && /*#__PURE__*/ _react.createElement("span", {
        className: (0, _runtime.ax)([
            styles.beforeStyles,
            isSelected && styles.beforeStylesSelected
        ])
    }, elemBefore), /*#__PURE__*/ _react.createElement("span", {
        "data-tag-text": true,
        className: (0, _runtime.ax)([
            styles.textStyles,
            isSelected && styles.textStylesSelected
        ])
    }, (0, _getTagText.getTagText)(text)), trailingMetric != null && trailingMetric !== '' && /*#__PURE__*/ _react.createElement("span", {
        "data-testid": testId && `${testId}--metric`,
        className: (0, _runtime.ax)([
            styles.trailingMetric
        ])
    }, trailingMetric), hasChevron && /*#__PURE__*/ _react.createElement((0, _chevronDownDefault.default), {
        label: "",
        size: "small",
        color: 'currentColor',
        testId: testId && `${testId}--chevron`
    })), isLoading && /*#__PURE__*/ _react.createElement("span", {
        className: (0, _runtime.ax)([
            dropdownStyles.loadingOverlay
        ])
    }, /*#__PURE__*/ _react.createElement((0, _spinnerDefault.default), {
        size: 'xsmall',
        label: ", Loading",
        testId: testId ? `${testId}--loading-spinner` : undefined
    })));
});
/**
 * __Tag new__
 */ const TagNew = /*#__PURE__*/ (0, _react.memo)(TagNewComponent);
// eslint-disable-next-line @atlaskit/volt-strict-mode/no-multiple-exports
exports.default = TagNew;

},{"@swc/helpers/_/_object_spread":"9gdrV","@swc/helpers/_/_object_spread_props":"kANqQ","@swc/helpers/_/_object_without_properties":"6HqIM","react":"ltHCL","@compiled/react/runtime":"d27Vo","@compiled/react":"MfI9Z","@atlaskit/icon/core/chevron-down":"ieg9F","@atlaskit/platform-feature-flags":"8rD2i","@atlaskit/primitives/compiled":"hDay7","@atlaskit/spinner":"l22fT","./color-mapping":"9fPDi","./get-tag-text":"aHRvi","./link-wrapper":"6IX3u","./removable-wrapper":"6kFRE","./swatch-before":"iOljR","./use-button-interaction":"lJ9lQ","./use-link":"4z3Lk","./use-remove-button":"7Fvkg","./use-tag-removal":"74On1","@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"9fPDi":[function(require,module,exports,__globalThis) {
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "colorMapping", ()=>colorMapping);
const colorMapping = {
    standard: 'gray',
    grey: 'gray',
    blue: 'blue',
    green: 'green',
    red: 'red',
    yellow: 'yellow',
    purple: 'purple',
    lime: 'lime',
    magenta: 'magenta',
    orange: 'orange',
    teal: 'teal',
    // Light variants map to same as their non-light counterparts
    greyLight: 'gray',
    blueLight: 'blue',
    greenLight: 'green',
    redLight: 'red',
    yellowLight: 'yellow',
    purpleLight: 'purple',
    limeLight: 'lime',
    magentaLight: 'magenta',
    orangeLight: 'orange',
    tealLight: 'teal'
};

},{"@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"aHRvi":[function(require,module,exports,__globalThis) {
// Intentionally scoped to the UI-uplifted TagNew implementation.
var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "getTagText", ()=>getTagText);
const getTagText = (text)=>Array.isArray(text) ? text.join('') : text;

},{"@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"6IX3u":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
// Shared component for conditional link wrapping
parcelHelpers.export(exports, "LinkWrapper", ()=>LinkWrapper);
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
function LinkWrapper({ isLink, href, LinkComponent, testId, children, onClick, linkHandlers }) {
    if (isLink && href) return /*#__PURE__*/ (0, _reactDefault.default).createElement(LinkComponent, {
        href: href,
        testId: testId ? `${testId}--link` : undefined,
        onClick: onClick,
        onMouseEnter: linkHandlers === null || linkHandlers === void 0 ? void 0 : linkHandlers.onMouseEnter,
        onMouseLeave: linkHandlers === null || linkHandlers === void 0 ? void 0 : linkHandlers.onMouseLeave,
        onMouseDown: linkHandlers === null || linkHandlers === void 0 ? void 0 : linkHandlers.onMouseDown,
        onFocus: linkHandlers === null || linkHandlers === void 0 ? void 0 : linkHandlers.onFocus,
        onBlur: linkHandlers === null || linkHandlers === void 0 ? void 0 : linkHandlers.onBlur
    }, children);
    return /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _react.Fragment), null, children);
}

},{"react":"ltHCL","@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"6kFRE":[function(require,module,exports,__globalThis) {
/* removable-wrapper.tsx generated by @compiled/babel-plugin v0.39.1 */ /**
 * Shared utilities for TagNew and AvatarTag components.
 * Note: CSS styles cannot be shared due to Compiled CSS static analysis requirements.
 */ var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
// Shared component for motion wrapper
parcelHelpers.export(exports, "RemovableWrapper", ()=>RemovableWrapper);
var _react = require("react");
var _runtime = require("@compiled/react/runtime");
var _motion = require("@atlaskit/motion");
var _tagStatus = require("./tag-status");
/**
 * Stable key so ExitingPersistence can match this child across the remove transition
 * (see ShrinkOut + ExitingPersistence docs in @atlaskit/motion).
 */ const removableShrinkOutChildKey = 'atlaskit-tag-removable-shrink-out';
const motionWrapperStyles = null;
function RemovableWrapper({ isRemovable, status, onShrinkOutExitComplete, children }) {
    if (isRemovable) return /*#__PURE__*/ _react.createElement((0, _motion.ExitingPersistence), null, !(status === (0, _tagStatus.TagStatus).Removed) && /*#__PURE__*/ _react.createElement((0, _motion.ShrinkOut), {
        key: removableShrinkOutChildKey,
        onFinish: onShrinkOutExitComplete ? (phase)=>{
            if (phase === 'exiting') onShrinkOutExitComplete();
        } : undefined
    }, (motion)=>/*#__PURE__*/ _react.createElement("span", {
            ref: motion.ref,
            className: (0, _runtime.ax)([
                "_1e0c116y"
            ])
        }, children)));
    return children;
}

},{"react":"ltHCL","@compiled/react/runtime":"d27Vo","@atlaskit/motion":"eg70v","./tag-status":"jKlLq","@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"jKlLq":[function(require,module,exports,__globalThis) {
// Tag status enum
var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "TagStatus", ()=>TagStatus);
var TagStatus = /*#__PURE__*/ function(TagStatus) {
    TagStatus["Showing"] = "showing";
    TagStatus["Removing"] = "removing";
    TagStatus["Removed"] = "removed";
    return TagStatus;
}({});

},{"@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"iOljR":[function(require,module,exports,__globalThis) {
/* swatch-before.tsx generated by @compiled/babel-plugin v0.39.1 */ var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>SwatchBefore);
var _objectSpread = require("@swc/helpers/_/_object_spread");
var _objectSpreadProps = require("@swc/helpers/_/_object_spread_props");
var _react = require("react");
var _runtime = require("@compiled/react/runtime");
var _platformFeatureFlags = require("@atlaskit/platform-feature-flags");
const tagSwatchBeforeStyles = {
    swatch: "_2rkolb4i _1bsboqnp _4t3ioqnp _1o9zidpf"
};
const tagSwatchBeforeColorStyles = {
    gray: "_bfhk18j9",
    blue: "_bfhk115i",
    green: "_bfhk1rsu",
    red: "_bfhkkrt9",
    yellow: "_bfhk8y3s",
    purple: "_bfhk18ah",
    lime: "_bfhkbq5w",
    magenta: "_bfhk1mi6",
    orange: "_bfhk1kkj",
    teal: "_bfhktdv8"
};
function SwatchBefore({ colorKey, swatchBefore, swatchBeforeLabel, swatchBeforeRole }) {
    if (swatchBefore === undefined || swatchBefore === false) return null;
    if (swatchBefore === true) return /*#__PURE__*/ _react.createElement("span", (0, _objectSpreadProps._)((0, _objectSpread._)({}, swatchBeforeLabel && swatchBeforeRole && (0, _platformFeatureFlags.fg)('parent-field-switcher-missing-info-image-text') ? {
        'aria-label': swatchBeforeLabel,
        role: swatchBeforeRole
    } : {}), {
        className: (0, _runtime.ax)([
            tagSwatchBeforeStyles.swatch,
            tagSwatchBeforeColorStyles[colorKey]
        ])
    }));
    return /*#__PURE__*/ _react.createElement("span", (0, _objectSpreadProps._)((0, _objectSpread._)({}, swatchBeforeLabel && swatchBeforeRole && (0, _platformFeatureFlags.fg)('parent-field-switcher-missing-info-image-text') ? {
        'aria-label': swatchBeforeLabel,
        role: swatchBeforeRole
    } : {}), {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop
        style: {
            backgroundColor: swatchBefore
        },
        className: (0, _runtime.ax)([
            tagSwatchBeforeStyles.swatch
        ])
    }));
}

},{"@swc/helpers/_/_object_spread":"9gdrV","@swc/helpers/_/_object_spread_props":"kANqQ","react":"ltHCL","@compiled/react/runtime":"d27Vo","@atlaskit/platform-feature-flags":"8rD2i","@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"lJ9lQ":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
/**
 * Hook for tracking link/button hover/focus state (replaces CSS :has() selectors in this component)
 */ parcelHelpers.export(exports, "useButtonInteraction", ()=>useButtonInteraction);
var _react = require("react");
function useButtonInteraction() {
    const [isLinkHovered, setIsLinkHovered] = (0, _react.useState)(false);
    const [isOverButton, setIsOverButton] = (0, _react.useState)(false);
    const [isButtonFocused, setIsButtonFocused] = (0, _react.useState)(false);
    const [isLinkFocused, setIsLinkFocused] = (0, _react.useState)(false);
    // Track if last interaction was via mouse (to determine keyboard vs mouse focus)
    const hadMouseDownRef = (0, _react.useRef)(false);
    // Button handlers
    const buttonHandlers = (0, _react.useMemo)(()=>({
            onMouseEnter: ()=>setIsOverButton(true),
            onMouseLeave: ()=>setIsOverButton(false),
            onMouseDown: (e)=>{
                // Prevent the browser from moving focus to the remove button on mousedown.
                // Without this, parent composite widgets (e.g. Select) lose input focus when
                // the user clicks remove, triggering unwanted blur side-effects.
                e === null || e === void 0 ? void 0 : e.preventDefault();
                hadMouseDownRef.current = true;
            },
            onFocus: ()=>{
                // Only track keyboard focus for focus ring styles
                // If mousedown happened just before focus, it's mouse focus (not keyboard)
                if (!hadMouseDownRef.current) setIsButtonFocused(true);
                hadMouseDownRef.current = false;
            },
            onBlur: ()=>setIsButtonFocused(false)
        }), []);
    // Link handlers - includes hover tracking
    const linkHandlers = (0, _react.useMemo)(()=>({
            onMouseEnter: ()=>setIsLinkHovered(true),
            onMouseLeave: ()=>setIsLinkHovered(false),
            onMouseDown: ()=>{
                hadMouseDownRef.current = true;
            },
            onFocus: ()=>{
                // Only track keyboard focus for focus ring styles
                // If mousedown happened just before focus, it's mouse focus (not keyboard)
                if (!hadMouseDownRef.current) setIsLinkFocused(true);
                hadMouseDownRef.current = false;
            },
            onBlur: ()=>setIsLinkFocused(false)
        }), []);
    return {
        isLinkHovered,
        isOverButton,
        isButtonFocused,
        isLinkFocused,
        buttonHandlers,
        linkHandlers
    };
}

},{"react":"ltHCL","@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"4z3Lk":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
/**
 * Shared hook for link handling
 */ parcelHelpers.export(exports, "useLink", ()=>useLink);
var _link = require("@atlaskit/link");
var _linkDefault = parcelHelpers.interopDefault(_link);
function useLink(href, linkComponent) {
    const isLink = Boolean(href);
    const LinkComponent = linkComponent !== null && linkComponent !== void 0 ? linkComponent : (0, _linkDefault.default);
    return {
        isLink,
        LinkComponent
    };
}

},{"@atlaskit/link":"iFOrl","@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"iFOrl":[function(require,module,exports,__globalThis) {
// Ideally this file is not used directly. But rather, you go through the entry points
var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>(0, _linkDefault.default));
var _link = require("./components/link");
var _linkDefault = parcelHelpers.interopDefault(_link);

},{"./components/link":"7yygJ","@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"7yygJ":[function(require,module,exports,__globalThis) {
/* index.tsx generated by @compiled/babel-plugin v0.39.1 */ var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _objectSpread = require("@swc/helpers/_/_object_spread");
var _objectSpreadProps = require("@swc/helpers/_/_object_spread_props");
var _objectWithoutProperties = require("@swc/helpers/_/_object_without_properties");
var _react = require("react");
var _runtime = require("@compiled/react/runtime");
var _css = require("@atlaskit/css");
var _platformFeatureFlags = require("@atlaskit/platform-feature-flags");
var _compiled = require("@atlaskit/primitives/compiled");
const styles = {
    base: "_ect4ttxp",
    baseT26Shape: "_2rkolb4i",
    visitedLink: "_10531ra0 _1ien1ra0 _n0fx1ra0 _1vhv17z1",
    defaultAppearance: "_4bfu1r31 _1hms8stv _ajmmnqa1 _syaz13af _1a3b1r31 _4fpr8stv _5goinqa1 _f8pj13af _9oik1r31 _1bnxglyw _jf4cnqa1 _30l313af _1nrm1r31 _c2waglyw _1iohnqa1 _9h8h12zz",
    defaultAppearanceMotion: "_4bfu1r31 _1hms8stv _ajmmnqa1 _v564hxmd _syaz13af _1a3b1r31 _4fpr8stv _5goinqa1 _f8pj13af _9oik1j28 _1bnx8stv _jf4cnqa1 _30l313af _1nrm1j28 _c2wa8stv _1iohnqa1 _1ggl87vo _9h8h12zz",
    subtleAppearance: "_4bfu1r31 _1hmsglyw _ajmmnqa1 _syazazsu _1a3b1r31 _4fprglyw _5goinqa1 _f8pjazsu _9oik1r31 _1bnx8stv _jf4cnqa1 _30l3azsu _1nrm1r31 _c2wa8stv _1iohnqa1 _9h8hi7uo",
    subtleAppearanceMotion: "_4bfu1j28 _1hms8stv _ajmmnqa1 _v564hxmd _syazazsu _1a3b1j28 _4fpr8stv _5goinqa1 _f8pjazsu _9oik1r31 _1bnx8stv _jf4cnqa1 _30l3azsu _1nrm1r31 _c2wa8stv _1iohnqa1 _1ggl87vo _9h8hi7uo",
    inverseAppearance: "_4bfu1r31 _1hms8stv _ajmmnqa1 _syaz15cr _105315cr _1a3b1r31 _4fpr8stv _5goinqa1 _f8pj15cr _9oik1r31 _1bnxglyw _jf4cnqa1 _30l315cr _1nrm1r31 _c2waglyw _1iohnqa1 _9h8h15cr",
    inverseAppearanceMotion: "_4bfu1r31 _1hms8stv _ajmmnqa1 _v564hxmd _syaz15cr _105315cr _1a3b1r31 _4fpr8stv _5goinqa1 _f8pj15cr _9oik1j28 _1bnx8stv _jf4cnqa1 _30l315cr _1nrm1j28 _c2wa8stv _1iohnqa1 _1ggl87vo _9h8h15cr",
    iconWrapper: "_1e0c1nu9 _o5721q9c _s7n41q9y _kqswh2mm _152ttb3r"
};
const iconStyles = null;
const LinkWithoutRef = (_param, ref)=>{
    var { children, testId, appearance = 'default', newWindowLabel, target, // @ts-expect-error
    className: _preventedClassName, // @ts-expect-error
    style: _preventedStyle } = _param, htmlAttributes = (0, _objectWithoutProperties._)(_param, [
        "children",
        "testId",
        "appearance",
        "newWindowLabel",
        "target",
        "className",
        "style"
    ]);
    return /*#__PURE__*/ _react.createElement((0, _compiled.Anchor), (0, _objectSpreadProps._)((0, _objectSpread._)({}, htmlAttributes), {
        target: target,
        ref: ref,
        xcss: (0, _css.cx)(styles.base, (0, _platformFeatureFlags.fg)('platform-dst-shape-theme-default') && styles.baseT26Shape, appearance === 'default' && ((0, _platformFeatureFlags.fg)('platform-dst-motion-uplift-list-item') ? styles.defaultAppearanceMotion : styles.defaultAppearance), appearance === 'subtle' && ((0, _platformFeatureFlags.fg)('platform-dst-motion-uplift-list-item') ? styles.subtleAppearanceMotion : styles.subtleAppearance), appearance === 'inverse' && ((0, _platformFeatureFlags.fg)('platform-dst-motion-uplift-list-item') ? styles.inverseAppearanceMotion : styles.inverseAppearance), // Visited styles are not supported for inverse links due to contrast issues
        appearance !== 'inverse' && styles.visitedLink),
        testId: testId,
        componentName: "Link",
        newWindowLabel: newWindowLabel
    }), children, target === '_blank' && /*#__PURE__*/ _react.createElement((0, _compiled.Box), {
        as: "span",
        xcss: styles.iconWrapper,
        testId: testId && `${testId}__icon`
    }, "\uFEFF", /*#__PURE__*/ _react.createElement("svg", {
        width: "12",
        height: "12",
        viewBox: "0 0 12 12",
        fill: "none",
        className: (0, _runtime.ax)([
            "_1bsbgm0b _4t3igm0b _ahbqzjw7"
        ])
    }, /*#__PURE__*/ _react.createElement("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M0 1.82609C0 0.817938 0.817938 0 1.82609 0H3.91304V1.04348H1.82609C1.39424 1.04348 1.04348 1.39424 1.04348 1.82609V10.1739C1.04348 10.6058 1.39424 10.9565 1.82609 10.9565H10.1739C10.6058 10.9565 10.9565 10.6058 10.9565 10.1739V8.08696H12V10.1739C12 11.1821 11.1821 12 10.1739 12H1.82609C0.817938 12 0 11.1821 0 10.1739V1.82609ZM7.04348 0H12V4.95652H10.9565V1.78133L6.36893 6.36893L5.63107 5.63107L10.2187 1.04348H7.04348V0Z",
        fill: "currentColor"
    }))));
};
// Workarounds to support generic types with forwardRef
/**
 * __Link__
 *
 * A link is an inline text element that navigates to a new location when clicked.
 *
 * - [Examples](https://atlassian.design/components/primitives/link/examples)
 * - [Code](https://atlassian.design/components/primitives/link/code)
 * - [Usage](https://atlassian.design/components/primitives/link/usage)
 */ const Link = /*#__PURE__*/ (0, _react.forwardRef)(LinkWithoutRef);
exports.default = Link;

},{"@swc/helpers/_/_object_spread":"9gdrV","@swc/helpers/_/_object_spread_props":"kANqQ","@swc/helpers/_/_object_without_properties":"6HqIM","react":"ltHCL","@compiled/react/runtime":"d27Vo","@atlaskit/css":"kMGms","@atlaskit/platform-feature-flags":"8rD2i","@atlaskit/primitives/compiled":"hDay7","@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"7Fvkg":[function(require,module,exports,__globalThis) {
/**
 * Shared utilities for TagNew and AvatarTag components.
 * Note: CSS styles cannot be shared due to Compiled CSS static analysis requirements.
 */ var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
// Shared hook for remove button creation
// TODO: Fill in the hook {description}.
/**
 * {description}.
 */ parcelHelpers.export(exports, "useRemoveButton", ()=>useRemoveButton);
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _removeButton = require("../tag/internal/removable/remove-button");
var _removeButtonDefault = parcelHelpers.interopDefault(_removeButton);
function useRemoveButton({ isRemovable, tagText, removeButtonLabel, testId, handleRemoveRequest, removingTag, showingTag, onKeyPress, shape = 'default', buttonHandlers }) {
    const handleFocus = (0, _react.useCallback)(()=>{
        removingTag();
        buttonHandlers === null || buttonHandlers === void 0 ? void 0 : buttonHandlers.onFocus();
    }, [
        removingTag,
        buttonHandlers
    ]);
    const handleBlur = (0, _react.useCallback)(()=>{
        showingTag();
        buttonHandlers === null || buttonHandlers === void 0 ? void 0 : buttonHandlers.onBlur();
    }, [
        showingTag,
        buttonHandlers
    ]);
    return (0, _react.useMemo)(()=>{
        if (!isRemovable) return undefined;
        return /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _removeButtonDefault.default), {
            "aria-label": `${removeButtonLabel || 'Remove'} ${tagText}`,
            onClick: handleRemoveRequest,
            onFocus: handleFocus,
            onBlur: handleBlur,
            onKeyPress: onKeyPress,
            onMouseEnter: buttonHandlers === null || buttonHandlers === void 0 ? void 0 : buttonHandlers.onMouseEnter,
            onMouseLeave: buttonHandlers === null || buttonHandlers === void 0 ? void 0 : buttonHandlers.onMouseLeave,
            onMouseDown: buttonHandlers === null || buttonHandlers === void 0 ? void 0 : buttonHandlers.onMouseDown,
            testId: testId ? `close-button-${testId}` : undefined,
            shape: shape
        });
    }, [
        isRemovable,
        removeButtonLabel,
        tagText,
        handleRemoveRequest,
        handleFocus,
        handleBlur,
        onKeyPress,
        buttonHandlers,
        testId,
        shape
    ]);
}

},{"react":"ltHCL","../tag/internal/removable/remove-button":"dFzUP","@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"dFzUP":[function(require,module,exports,__globalThis) {
/* remove-button.tsx generated by @compiled/babel-plugin v0.39.1 */ var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _react = require("react");
var _css = require("@atlaskit/css");
var _cross = require("@atlaskit/icon/core/cross");
var _crossDefault = parcelHelpers.interopDefault(_cross);
var _platformFeatureFlags = require("@atlaskit/platform-feature-flags");
var _compiled = require("@atlaskit/primitives/compiled");
const removeButtonStyles = {
    root: "_19itglyw _2rkolb4i _195gze3t _1mouze3t _18zrze3t _1rjcze3t _1e0c1txw _4t3i1j6v _1bsb1j6v _rjxpze3t _4cvr1h6o _1bah1h6o _1wpz1h6o _r06hglyw _bfhksm61 _syazi7uo _80omtlke _lcxv1wug _ahbq1i6y _12l21i6y _1ah3idpf _irr31dpa _1di6fcek",
    circle: "_2rko1rr0 _1ah3idpf",
    focusRing: "_1ah3v77o",
    newIcon: "_rjxpv77o"
};
const RemoveButton = ({ 'aria-label': ariaLabel, onClick, onFocus, onBlur, onKeyPress, onMouseOver, onMouseOut, onMouseDown, onMouseUp, onMouseEnter, onMouseLeave, testId, shape = 'default' })=>{
    return /*#__PURE__*/ _react.createElement((0, _compiled.Pressable), {
        xcss: (0, _css.cx)(removeButtonStyles.root, shape === 'circle' && removeButtonStyles.circle, removeButtonStyles.newIcon, (0, _platformFeatureFlags.fg)('platform-dst-lozenge-tag-badge-visual-uplifts') && removeButtonStyles.focusRing),
        "aria-label": ariaLabel,
        onClick: onClick,
        onFocus: onFocus,
        onBlur: onBlur,
        onKeyPress: onKeyPress,
        onMouseOver: onMouseOver,
        onMouseOut: onMouseOut,
        onMouseDown: onMouseDown,
        onMouseUp: onMouseUp,
        onMouseEnter: onMouseEnter,
        onMouseLeave: onMouseLeave,
        testId: testId
    }, /*#__PURE__*/ _react.createElement((0, _crossDefault.default), {
        color: "currentColor",
        label: "",
        size: "small"
    }));
};
// eslint-disable-next-line @repo/internal/react/require-jsdoc
exports.default = RemoveButton;

},{"react":"ltHCL","@atlaskit/css":"kMGms","@atlaskit/icon/core/cross":"7mJX1","@atlaskit/platform-feature-flags":"8rD2i","@atlaskit/primitives/compiled":"hDay7","@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"74On1":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
/**
 * {description}.
 */ parcelHelpers.export(exports, "useTagRemoval", ()=>useTagRemoval);
var _react = require("react");
var _defaultBeforeRemoveAction = require("./default-before-remove-action");
var _tagStatus = require("./tag-status");
function useTagRemoval(onBeforeRemoveAction) {
    const [status, setStatus] = (0, _react.useState)((0, _tagStatus.TagStatus).Showing);
    const handleRemoveRequest = (0, _react.useCallback)(()=>{
        const beforeAction = onBeforeRemoveAction !== null && onBeforeRemoveAction !== void 0 ? onBeforeRemoveAction : (0, _defaultBeforeRemoveAction.defaultBeforeRemoveAction);
        if (beforeAction()) // Defer onAfterRemoveAction until ShrinkOut's onFinish so ExitingPersistence can run
        // the exit animation (e.g. in multi-select and user pickers).
        setStatus((0, _tagStatus.TagStatus).Removed);
    }, [
        onBeforeRemoveAction
    ]);
    const onKeyPress = (0, _react.useCallback)((e)=>{
        const spacebarOrEnter = e.key === ' ' || e.key === 'Enter';
        if (spacebarOrEnter) {
            e.stopPropagation();
            handleRemoveRequest();
        }
    }, [
        handleRemoveRequest
    ]);
    const removingTag = (0, _react.useCallback)(()=>setStatus((0, _tagStatus.TagStatus).Removing), []);
    const showingTag = (0, _react.useCallback)(()=>setStatus((0, _tagStatus.TagStatus).Showing), []);
    return {
        status,
        handleRemoveRequest,
        onKeyPress,
        removingTag,
        showingTag
    };
}

},{"react":"ltHCL","./default-before-remove-action":"k8emC","./tag-status":"jKlLq","@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"k8emC":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "defaultBeforeRemoveAction", ()=>defaultBeforeRemoveAction);
const defaultBeforeRemoveAction = ()=>true;

},{"@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"hUteJ":[function(require,module,exports,__globalThis) {
/* avatar-tag.tsx generated by @compiled/babel-plugin v0.39.1 */ var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _objectSpread = require("@swc/helpers/_/_object_spread");
var _objectSpreadProps = require("@swc/helpers/_/_object_spread_props");
var _objectWithoutProperties = require("@swc/helpers/_/_object_without_properties");
var _react = require("react");
var _runtime = require("@compiled/react/runtime");
var _statusVerified = require("@atlaskit/icon/core/status-verified");
var _statusVerifiedDefault = parcelHelpers.interopDefault(_statusVerified);
var _linkWrapper = require("./link-wrapper");
var _removableWrapper = require("./removable-wrapper");
var _useButtonInteraction = require("./use-button-interaction");
var _useLink = require("./use-link");
var _useRemoveButton = require("./use-remove-button");
var _useTagRemoval = require("./use-tag-removal");
const styles = {
    baseStyles: "_zulpv77o _2rko1rr0 _11c8wadc _1dqonqa1 _189ee4h9 _1rjcze3t _1mou1b66 _195g1b66 _1e0c116y _vchhusvi _1ul9idpf _p12ff6dh _4t3iv47k _kqswh2mm _4cvr1h6o _s7n4nkob _bfhksm61 _syazi7uo _80om73ad _y4tii2wt _bozgze3t",
    noMarginStyles: "_1mouze3t _195gze3t",
    otherBaseStyles: "_2rko12b0 _y4ti1b66",
    agentBaseStyles: "_2rko12b0 _y4ti1b66",
    removableStyles: "_y4ti1l7b _1ul98pqr",
    userRemovableStyles: "_y4ti1l7b _1ul98pqr",
    avatarStyles: "_4bfu1r31 _1hmsglyw _ajmmnqa1 _2rko1rr0 _1reo15vq _18m915vq _1e0c116y _4cvr1h6o _1o9zidpf _ahbq1n1a",
    otherAvatarStyles: "_2rko12b0",
    agentAvatarStyles: "_2rkoidpf",
    textStyles: "_1reo15vq _18m915vq _16jlkb7n _1o9zkb7n _i0dlf1ug _1bto1l2s _o5721q9c _1ul9idpf _syazi7uo",
    afterStyles: "_16jlidpf _1o9zidpf _i0dl1wug _1e0c1txw _4cvr1h6o _lcxv1wug _ahbqv77o _kqswh2mm",
    verifiedIconStyles: "_1e0c116y _4cvr1h6o _1o9zidpf _syaz6txe _ahbqt94y",
    focusRingStyles: "_1ygbdfik _1ah3v77o",
    childFocusRingStyles: "_1a37dfik _1cwgv77o",
    interactiveBaseStyles: "_80omtlke _7nm0v77o _59381r31 _yha2glyw _1nmznqa1 _1ufy15vq _turg15vq _jr6g1snc _1ymragmp _1y1s10yn _1hw7116y _6wji1h6o _1k6fidpf _43dsjdj5 _jwdiagmp _1cayjdj5 _102s1snc _yi8hagmp _h79h10yn _9m7f1r31 _w7swglyw _15a9nqa1 _jxlhagmp",
    interactiveHoverStyles: "_fs7a1r31 _1uxk8stv _12u8nqa1 _irr31dpa _oxk4jdj5 _1di6fcek"
};
/* eslint-disable @atlaskit/ui-styling-standard/no-nested-selectors, @atlaskit/ui-styling-standard/no-unsafe-selectors, @atlaskit/design-system/no-nested-styles, @atlaskit/ui-styling-standard/no-important-styles */ // Border color style - gray only for AvatarTag.
// Uses the new color.border.accent.gray.subtle token directly so no OKLCH/color-mix
// runtime transforms are needed.
const borderColorStyles = {
    root: "_119bmsup"
};
// Border filter styles - base state
const borderFilterStyles = {
    root: "_1h6dip4g"
};
/* eslint-enable @atlaskit/ui-styling-standard/no-nested-selectors, @atlaskit/ui-styling-standard/no-unsafe-selectors, @atlaskit/design-system/no-nested-styles, @atlaskit/ui-styling-standard/no-important-styles */ /**
 * __AvatarTag__
 *
 * AvatarTag is a specialized tag for representing people, teams/other entities, or agents with an avatar and name.
 * The visual appearance (round, square, or hexagonal) is determined by the `type` prop.
 */ const AvatarTagComponent = /*#__PURE__*/ (0, _react.forwardRef)(function AvatarTag(_param, ref) {
    var { text, type, avatar: AvatarComponent, href, linkComponent, isRemovable = true, removeButtonLabel, onBeforeRemoveAction, onAfterRemoveAction, testId, isVerified, // Shows verified icon for 'other' type tags
    maxWidth, hasMargin = true, onClick } = _param, other = (0, _objectWithoutProperties._)(_param, [
        "text",
        "type",
        "avatar",
        "href",
        "linkComponent",
        "isRemovable",
        "removeButtonLabel",
        "onBeforeRemoveAction",
        "onAfterRemoveAction",
        "testId",
        "isVerified",
        "maxWidth",
        "hasMargin",
        "onClick"
    ]);
    const { status, handleRemoveRequest, onKeyPress, removingTag, showingTag } = (0, _useTagRemoval.useTagRemoval)(onBeforeRemoveAction);
    const onShrinkOutExitComplete = (0, _react.useCallback)(()=>{
        onAfterRemoveAction === null || onAfterRemoveAction === void 0 ? void 0 : onAfterRemoveAction(text);
    }, [
        onAfterRemoveAction,
        text
    ]);
    const { isLink, LinkComponent } = (0, _useLink.useLink)(href, linkComponent);
    const { isLinkHovered, isOverButton, isButtonFocused, isLinkFocused, buttonHandlers, linkHandlers } = (0, _useButtonInteraction.useButtonInteraction)();
    // Determine styles based on type
    const isOtherType = type === 'other';
    const isAgentType = type === 'agent';
    const isUserType = type === 'user';
    // isVerified is only available for 'other' type
    const showVerified = isOtherType && isVerified;
    // Determine avatar appearance based on type
    const avatarAppearance = isUserType ? 'circle' : isAgentType ? 'hexagon' : 'square';
    // Determine remove button shape based on type
    const removeButtonShape = isUserType ? 'circle' : 'default';
    const removeButton = (0, _useRemoveButton.useRemoveButton)({
        isRemovable,
        tagText: text,
        removeButtonLabel,
        testId,
        handleRemoveRequest,
        removingTag,
        showingTag,
        onKeyPress,
        shape: removeButtonShape,
        buttonHandlers
    });
    // Render the avatar with controlled props, then clone so our props are applied
    const controlledProps = {
        size: 'xsmall',
        appearance: avatarAppearance,
        borderColor: 'transparent'
    };
    const AvatarComponentTyped = AvatarComponent;
    const rendered = /*#__PURE__*/ _react.createElement(AvatarComponentTyped, controlledProps);
    const avatarElement = // eslint-disable-next-line @repo/internal/react/no-clone-element
    /*#__PURE__*/ (0, _react.isValidElement)(rendered) ? /*#__PURE__*/ (0, _react.cloneElement)(rendered, controlledProps) : rendered;
    const tagContent = /*#__PURE__*/ _react.createElement("span", (0, _objectSpreadProps._)((0, _objectSpread._)({}, other), {
        ref: ref,
        "data-testid": testId,
        // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop
        style: maxWidth !== undefined ? {
            maxWidth
        } : undefined,
        className: (0, _runtime.ax)([
            styles.baseStyles,
            !hasMargin && styles.noMarginStyles,
            isOtherType && styles.otherBaseStyles,
            isAgentType && styles.agentBaseStyles,
            borderColorStyles.root,
            borderFilterStyles.root,
            isLink && styles.interactiveBaseStyles,
            isLink && styles.focusRingStyles,
            isLink && isLinkHovered && !isOverButton && styles.interactiveHoverStyles,
            isRemovable && !isUserType && styles.removableStyles,
            isRemovable && isUserType && styles.userRemovableStyles,
            isLinkFocused && !isButtonFocused && styles.childFocusRingStyles
        ])
    }), /*#__PURE__*/ _react.createElement((0, _linkWrapper.LinkWrapper), {
        isLink: isLink,
        href: href,
        LinkComponent: LinkComponent,
        testId: testId,
        linkHandlers: linkHandlers,
        onClick: onClick
    }, /*#__PURE__*/ _react.createElement("span", {
        className: (0, _runtime.ax)([
            styles.avatarStyles,
            isOtherType && styles.otherAvatarStyles,
            isAgentType && styles.agentAvatarStyles
        ])
    }, avatarElement), /*#__PURE__*/ _react.createElement("span", {
        "data-tag-text": true,
        className: (0, _runtime.ax)([
            styles.textStyles
        ])
    }, text)), showVerified && /*#__PURE__*/ _react.createElement("span", {
        className: (0, _runtime.ax)([
            styles.verifiedIconStyles
        ])
    }, /*#__PURE__*/ _react.createElement((0, _statusVerifiedDefault.default), {
        label: "Verified",
        size: "small"
    })), removeButton && /*#__PURE__*/ _react.createElement("span", {
        className: (0, _runtime.ax)([
            styles.afterStyles
        ])
    }, removeButton));
    return /*#__PURE__*/ _react.createElement((0, _removableWrapper.RemovableWrapper), {
        isRemovable: isRemovable,
        status: status,
        onShrinkOutExitComplete: isRemovable ? onShrinkOutExitComplete : undefined
    }, tagContent);
});
/**
 * __Avatar tag__
 */ const AvatarTag = /*#__PURE__*/ (0, _react.memo)(AvatarTagComponent);
exports.default = AvatarTag;

},{"@swc/helpers/_/_object_spread":"9gdrV","@swc/helpers/_/_object_spread_props":"kANqQ","@swc/helpers/_/_object_without_properties":"6HqIM","react":"ltHCL","@compiled/react/runtime":"d27Vo","@atlaskit/icon/core/status-verified":"bWzCn","./link-wrapper":"6IX3u","./removable-wrapper":"6kFRE","./use-button-interaction":"lJ9lQ","./use-link":"4z3Lk","./use-remove-button":"7Fvkg","./use-tag-removal":"74On1","@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"bWzCn":[function(require,module,exports,__globalThis) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::b50a6e4dd8b62d7d7bf2cfae0d8c6979>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = void 0;
var _react = _interopRequireDefault(require("b8823ec0f10d1f43"));
var _baseNew = _interopRequireDefault(require("aceb8e2217204dad"));
function _interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "StatusVerified".
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Reserved for representing verified content.
Filled status icons provide higher visual contrast draw attention to important information.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const StatusVerifiedIcon = (props)=>/*#__PURE__*/ _react.default.createElement(_baseNew.default, Object.assign({
        name: "StatusVerifiedIcon",
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M6.85.444a1.713 1.713 0 0 1 2.301 0L10.3 1.486a.2.2 0 0 0 .15.055L12 1.48a1.71 1.71 0 0 1 1.762 1.479l.21 1.537a.2.2 0 0 0 .081.139l1.226.95c.696.54.87 1.52.4 2.266l-.828 1.312a.2.2 0 0 0-.027.158l.328 1.516a1.713 1.713 0 0 1-1.151 1.993l-1.477.474a.2.2 0 0 0-.123.103l-.723 1.372a1.713 1.713 0 0 1-2.162.787l-1.435-.587a.2.2 0 0 0-.161 0l-1.436.587a1.713 1.713 0 0 1-2.162-.787l-.723-1.372a.22.22 0 0 0-.124-.103L2 12.83a1.713 1.713 0 0 1-1.15-1.993l.327-1.516a.2.2 0 0 0-.027-.158L.322 7.852a1.713 1.713 0 0 1 .4-2.266l1.225-.95a.2.2 0 0 0 .081-.14l.21-1.536a1.71 1.71 0 0 1 1.763-1.48l1.55.06a.2.2 0 0 0 .15-.055zm-.1 9.384L4.826 7.519l-1.152.961 2.5 3a.75.75 0 0 0 1.152 0l5-6-1.152-.96z" clip-rule="evenodd"/>`
    }, props));
StatusVerifiedIcon.displayName = 'StatusVerifiedIcon';
var _default = exports.default = StatusVerifiedIcon;

},{"b8823ec0f10d1f43":"ltHCL","aceb8e2217204dad":"5XL7D"}],"c8VVU":[function(require,module,exports,__globalThis) {
/* base.tsx generated by @compiled/babel-plugin v0.39.1 */ var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _objectSpread = require("@swc/helpers/_/_object_spread");
var _objectSpreadProps = require("@swc/helpers/_/_object_spread_props");
var _objectWithoutProperties = require("@swc/helpers/_/_object_without_properties");
var _runtime = require("@compiled/react/runtime");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
// Border colors - Hardcoded for Visual Refresh - to be removed with labelling system work
const borderColors = {
    standard: "_1h6d14je",
    blue: "_1h6duisw",
    red: "_1h6da2c0",
    yellow: "_1h6deh2r",
    green: "_1h6d18uw",
    teal: "_1h6d1ug6",
    purple: "_1h6d157s",
    lime: "_1h6dn0nx",
    magenta: "_1h6d1lf6",
    orange: "_1h6dh727",
    grey: "_1h6d14je",
    standardLink: "_1h6d14je",
    blueLight: "_1h6duisw",
    redLight: "_1h6da2c0",
    yellowLight: "_1h6deh2r",
    greenLight: "_1h6d18uw",
    tealLight: "_1h6d1ug6",
    purpleLight: "_1h6d157s",
    limeLight: "_1h6dn0nx",
    magentaLight: "_1h6d1lf6",
    orangeLight: "_1h6dh727",
    greyLight: "_1h6d14je"
};
const baseStyles = null;
const interactiveStyles = null;
const focusRingStyles = null;
const BaseTag = /*#__PURE__*/ (0, _reactDefault.default).forwardRef(function BaseTag(_param, ref) {
    var { before, contentElement, after, testId, style, color = 'standard', href, className } = _param, other = (0, _objectWithoutProperties._)(_param, [
        "before",
        "contentElement",
        "after",
        "testId",
        "style",
        "color",
        "href",
        "className"
    ]);
    const isLink = Boolean(href);
    const isRemovable = Boolean(after);
    const isInteractive = isLink || isRemovable;
    if (color === 'gray') // internally we use 'grey' for gray color so that we can make migration easier behind the ff (gray will work with and without ff now)
    color = 'grey';
    return /*#__PURE__*/ (0, _reactDefault.default).createElement("span", (0, _objectSpreadProps._)((0, _objectSpread._)({}, other), {
        ref: ref,
        style: (0, _objectSpread._)({}, style),
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
        className: (0, _runtime.ax)([
            "_zulp1b66 _2rko12b0 _1dqonqa1 _189ee4h9 _1mou1b66 _195g1b66 _18zr1b66 _1e0c116y _vchhusvi _1ul9idpf _4t3i1k92 _kqswh2mm _4cvr1h6o _bfhksm61 _syazi7uo _80om73ad",
            isInteractive && "_1e38dfik _7glxv77o",
            isLink && "_irr31dpa _1di6fcek",
            borderColors[color],
            className
        ]),
        "data-testid": testId
    }), before, contentElement, after);
});
// eslint-disable-next-line @repo/internal/react/require-jsdoc
exports.default = BaseTag;

},{"@swc/helpers/_/_object_spread":"9gdrV","@swc/helpers/_/_object_spread_props":"kANqQ","@swc/helpers/_/_object_without_properties":"6HqIM","@compiled/react/runtime":"d27Vo","react":"ltHCL","@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"2v0NC":[function(require,module,exports,__globalThis) {
/* before.tsx generated by @compiled/babel-plugin v0.39.1 */ var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _react = require("react");
var _runtime = require("@compiled/react/runtime");
const beforeElementStyles = null;
const Before = ({ elemBefore })=>elemBefore ? /*#__PURE__*/ _react.createElement("span", {
        className: (0, _runtime.ax)([
            "_1e0c1txw _4t3i1j6v _4cvr1h6o _1bah1h6o _152tze3t"
        ])
    }, elemBefore) : null;
// eslint-disable-next-line @repo/internal/react/require-jsdoc
exports.default = Before;

},{"react":"ltHCL","@compiled/react/runtime":"d27Vo","@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"fD0mu":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
/**
 * Gets the Lozenge appearance for a given Tag color.
 */ parcelHelpers.export(exports, "getLozengeAppearance", ()=>getLozengeAppearance);
/**
 * Maps Tag color values to Lozenge appearance values.
 * Used for migration_fallback rendering when feature flag is off.
 */ const colorToLozengeAppearanceMap = {
    gray: 'default',
    grey: 'default',
    lime: 'success',
    green: 'success',
    blue: 'inprogress',
    red: 'removed',
    purple: 'new',
    yellow: 'moved',
    orange: 'moved',
    magenta: 'new',
    teal: 'inprogress',
    grayLight: 'default',
    greyLight: 'default',
    limeLight: 'success',
    greenLight: 'success',
    blueLight: 'inprogress',
    redLight: 'removed',
    purpleLight: 'new',
    yellowLight: 'moved',
    orangeLight: 'moved',
    magentaLight: 'new',
    tealLight: 'inprogress'
};
function getLozengeAppearance(color) {
    return colorToLozengeAppearanceMap[color || 'gray'] || 'default';
}

},{"@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"lkTOq":[function(require,module,exports,__globalThis) {
/* content.tsx generated by @compiled/babel-plugin v0.39.1 */ var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _react = require("react");
var _runtime = require("@compiled/react/runtime");
var _getTagText = require("../../../tag-new/get-tag-text");
const baseStyles = null;
const linkStyles = null;
const hasAfterStyles = null;
const Content = ({ isRemovable = true, text = '', color = 'standard', href, linkComponent, testId })=>{
    const Link = linkComponent !== null && linkComponent !== void 0 ? linkComponent : 'a';
    const normalizedText = (0, _getTagText.getTagText)(text);
    if (href) return /*#__PURE__*/ _react.createElement(Link, {
        href: href,
        "data-color": color,
        "data-testid": testId ? `${testId}--link` : undefined,
        className: (0, _runtime.ax)([
            "_11c8fhey _1reo15vq _18m915vq _p12ff6dh _1bto1l2s _o5721q9c",
            "_4bfu1r31 _1hmsglyw _ajmmnqa1 _syazi7uo _lcxv1wug _nt751r31 _49pcglyw _1hvw1o36 _9oik1r31 _1bnx8stv _jf4cnqa1 _30l3i7uo _1nrm1r31 _c2wa8stv _1iohnqa1 _9h8hi7uo",
            isRemovable && "_p12f1lit"
        ])
    }, normalizedText);
    else return /*#__PURE__*/ _react.createElement("span", {
        className: (0, _runtime.ax)([
            "_11c8fhey _1reo15vq _18m915vq _p12ff6dh _1bto1l2s _o5721q9c",
            isRemovable && "_p12f1lit"
        ])
    }, normalizedText);
};
// eslint-disable-next-line @repo/internal/react/require-jsdoc
exports.default = Content;

},{"react":"ltHCL","@compiled/react/runtime":"d27Vo","../../../tag-new/get-tag-text":"aHRvi","@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"3r7wP":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>(0, _removableDefault.default));
parcelHelpers.export(exports, "RemovableTag", ()=>RemovableTag);
var _removable = require("./internal/removable");
var _removableDefault = parcelHelpers.interopDefault(_removable);
const RemovableTag = (0, _removableDefault.default);

},{"./internal/removable":"cxde2","@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"cxde2":[function(require,module,exports,__globalThis) {
/* index.tsx generated by @compiled/babel-plugin v0.39.1 */ var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _objectSpread = require("@swc/helpers/_/_object_spread");
var _objectWithoutProperties = require("@swc/helpers/_/_object_without_properties");
var _react = require("react");
var _runtime = require("@compiled/react/runtime");
var _analyticsNext = require("@atlaskit/analytics-next");
var _mergeRefs = require("@atlaskit/ds-lib/merge-refs");
var _mergeRefsDefault = parcelHelpers.interopDefault(_mergeRefs);
var _noop = require("@atlaskit/ds-lib/noop");
var _noopDefault = parcelHelpers.interopDefault(_noop);
var _lozenge = require("@atlaskit/lozenge");
var _lozengeDefault = parcelHelpers.interopDefault(_lozenge);
var _motion = require("@atlaskit/motion");
var _platformFeatureFlags = require("@atlaskit/platform-feature-flags");
var _tagNew = require("../../../tag-new");
var _tagNewDefault = parcelHelpers.interopDefault(_tagNew);
var _colorMapping = require("../../../tag-new/color-mapping");
var _getTagText = require("../../../tag-new/get-tag-text");
var _base = require("../shared/base");
var _baseDefault = parcelHelpers.interopDefault(_base);
var _before = require("../shared/before");
var _beforeDefault = parcelHelpers.interopDefault(_before);
var _colorToLozengeAppearance = require("../shared/color-to-lozenge-appearance");
var _content = require("../shared/content");
var _contentDefault = parcelHelpers.interopDefault(_content);
var _removeButton = require("./remove-button");
var _removeButtonDefault = parcelHelpers.interopDefault(_removeButton);
const textLinkCssVar = '--ds-ctl';
const textDefaultCssVar = '--ds-ct';
const textActiveCssVar = '--ds-ctp';
const backgroundHoverCssVar = '--ds-cbh';
const backgroundActiveCssVar = '--ds-cba';
var TagStatus = /*#__PURE__*/ function(TagStatus) {
    TagStatus["Showing"] = "showing";
    TagStatus["Removing"] = "removing";
    TagStatus["Removed"] = "removed";
    return TagStatus;
}(TagStatus || {});
const packageName = "@af/atlassian-studio";
const packageVersion = "0.16.1";
const defaultBeforeRemoveAction = ()=>true;
/**
 * These hide the focus ring for the tag when its remove button is focused,
 * preventing a double focus ring.
 */ const removingStyles = null;
const RemovableTagComponent = /*#__PURE__*/ (0, _react.forwardRef)((_param, ref)=>{
    var { appearance, elemBefore = null, isRemovable = true, text = '', color = 'standard', href, removeButtonLabel, testId, onBeforeRemoveAction = defaultBeforeRemoveAction, onAfterRemoveAction = (0, _noopDefault.default), linkComponent, migration_fallback, maxWidth, hasMargin = true, swatchBefore, swatchBeforeLabel, swatchBeforeRole } = _param, rest = (0, _objectWithoutProperties._)(_param, [
        "appearance",
        "elemBefore",
        "isRemovable",
        "text",
        "color",
        "href",
        "removeButtonLabel",
        "testId",
        "onBeforeRemoveAction",
        "onAfterRemoveAction",
        "linkComponent",
        "migration_fallback",
        "maxWidth",
        "hasMargin",
        "swatchBefore",
        "swatchBeforeLabel",
        "swatchBeforeRole"
    ]);
    const [status, setStatus] = (0, _react.useState)("showing");
    const [isHoverCloseButton, setIsHoverCloseButton] = (0, _react.useState)(false);
    const normalizedText = (0, _getTagText.getTagText)(text);
    const onAfterRemoveActionWithAnalytics = (0, _analyticsNext.useCallbackWithAnalytics)(onAfterRemoveAction, {
        action: 'removed',
        actionSubject: 'tag',
        attributes: {
            componentName: 'tag',
            packageName,
            packageVersion
        }
    }, 'atlaskit');
    const handleRemoveComplete = (0, _react.useCallback)(()=>{
        setStatus("removed");
    }, []);
    const handleRemoveRequest = (0, _react.useCallback)(()=>{
        if (onBeforeRemoveAction && onBeforeRemoveAction()) {
            onAfterRemoveActionWithAnalytics(normalizedText);
            handleRemoveComplete();
        }
    }, [
        handleRemoveComplete,
        normalizedText,
        onBeforeRemoveAction,
        onAfterRemoveActionWithAnalytics
    ]);
    const onKeyPress = (0, _react.useCallback)((e)=>{
        const spacebarOrEnter = e.key === ' ' || e.key === 'Enter';
        if (spacebarOrEnter) {
            e.stopPropagation();
            handleRemoveRequest();
        }
    }, [
        handleRemoveRequest
    ]);
    const removingTag = (0, _react.useCallback)(()=>setStatus("removing"), []);
    const showingTag = (0, _react.useCallback)(()=>setStatus("showing"), []);
    const handleMouseOver = (0, _react.useCallback)(()=>setIsHoverCloseButton(true), []);
    const handleMouseOut = (0, _react.useCallback)(()=>setIsHoverCloseButton(false), []);
    const removeButton = isRemovable ? /*#__PURE__*/ _react.createElement((0, _removeButtonDefault.default), {
        "aria-label": `${removeButtonLabel || 'Remove'} ${normalizedText}`,
        onClick: handleRemoveRequest,
        onFocus: removingTag,
        onBlur: showingTag,
        onKeyPress: onKeyPress,
        onMouseOver: handleMouseOver,
        onMouseOut: handleMouseOut,
        testId: `close-button-${testId}`
    }) : undefined;
    // Handle migration_fallback: render Lozenge when flag is off and migration_fallback is 'lozenge'
    if (migration_fallback === 'lozenge' && !(0, _platformFeatureFlags.fg)('platform-dst-lozenge-tag-badge-visual-uplifts')) {
        const lozengeAppearance = (0, _colorToLozengeAppearance.getLozengeAppearance)(color);
        return /*#__PURE__*/ _react.createElement((0, _lozengeDefault.default), (0, _objectSpread._)({
            appearance: lozengeAppearance,
            isBold: false,
            testId: testId
        }, rest), normalizedText);
    }
    // Use new TagNew component behind feature flag
    // TagNew handles its own animation internally via RemovableWrapper
    if ((0, _platformFeatureFlags.fg)('platform-dst-lozenge-tag-badge-visual-uplifts')) {
        const newColor = (0, _colorMapping.colorMapping)[color || 'standard'];
        return /*#__PURE__*/ _react.createElement((0, _tagNewDefault.default), (0, _objectSpread._)({
            ref: ref,
            color: newColor,
            text: normalizedText,
            elemBefore: elemBefore,
            href: href,
            testId: testId,
            isRemovable: isRemovable,
            removeButtonLabel: removeButtonLabel,
            onBeforeRemoveAction: onBeforeRemoveAction,
            onAfterRemoveAction: onAfterRemoveActionWithAnalytics,
            maxWidth: maxWidth,
            hasMargin: hasMargin,
            swatchBefore: swatchBefore
        }, (0, _platformFeatureFlags.fg)('parent-field-switcher-missing-info-image-text') ? {
            swatchBeforeLabel,
            swatchBeforeRole
        } : {}));
    }
    // Original implementation
    const content = /*#__PURE__*/ _react.createElement((0, _contentDefault.default), {
        elemBefore: elemBefore,
        isRemovable: isRemovable,
        text: normalizedText,
        color: color,
        href: href,
        linkComponent: linkComponent,
        testId: testId
    });
    const hoverCloseButtonColors = {
        backgroundColor: "var(--ds-background-neutral-subtle, #00000000)",
        // Tag background color on hover
        [backgroundHoverCssVar]: undefined,
        // Tag background color on press
        [backgroundActiveCssVar]: undefined,
        // The tag text on hover of remove button
        [textDefaultCssVar]: undefined,
        // 'elemBefore' text on press of remove button
        [textActiveCssVar]: undefined,
        // The tag link text on hover of remove button
        [textLinkCssVar]: undefined
    };
    return /*#__PURE__*/ _react.createElement((0, _motion.ExitingPersistence), null, !(status === "removed") && /*#__PURE__*/ _react.createElement((0, _motion.ShrinkOut), {
        key: "atlaskit-removable-tag-legacy-shrink-out",
        onFinish: handleRemoveComplete
    }, (motion)=>{
        return /*#__PURE__*/ _react.createElement((0, _baseDefault.default), {
            ref: (0, _mergeRefsDefault.default)([
                motion.ref,
                ref
            ]),
            appearance: appearance,
            color: color,
            testId: testId,
            // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
            style: isHoverCloseButton ? hoverCloseButtonColors : undefined,
            "data-removable": true,
            "data-removing": status === "removing",
            "data-ishoverclosebutton": isHoverCloseButton,
            href: href,
            before: /*#__PURE__*/ _react.createElement((0, _beforeDefault.default), {
                elemBefore: elemBefore
            }),
            contentElement: content,
            after: removeButton,
            className: (0, _runtime.ax)([
                status === "removing" && "_z30c1r31 _twwiglyw _1pka1o36 _bqhtfiwo"
            ])
        });
    }));
});
/**
 * __Removable tag__
 *
 * A tag labels UI objects for quick recognition and navigation.
 *
 * Once a tag has been removed, it cannot be re-rendered. Removable tags are visible in "edit" mode or in multi-select controls.
 *
 */ const RemovableTag = /*#__PURE__*/ (0, _react.memo)(RemovableTagComponent);
exports.default = RemovableTag;

},{"@swc/helpers/_/_object_spread":"9gdrV","@swc/helpers/_/_object_without_properties":"6HqIM","react":"ltHCL","@compiled/react/runtime":"d27Vo","@atlaskit/analytics-next":"6PLie","@atlaskit/ds-lib/merge-refs":"doPwA","@atlaskit/ds-lib/noop":"faKzG","@atlaskit/lozenge":"jvjak","@atlaskit/motion":"eg70v","@atlaskit/platform-feature-flags":"8rD2i","../../../tag-new":"31WyZ","../../../tag-new/color-mapping":"9fPDi","../../../tag-new/get-tag-text":"aHRvi","../shared/base":"c8VVU","../shared/before":"2v0NC","../shared/color-to-lozenge-appearance":"fD0mu","../shared/content":"lkTOq","./remove-button":"dFzUP","@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"fav81":[function(require,module,exports,__globalThis) {
/**
 * Hook to consume the SelectGetStylesContext.
 *
 * @internal — not part of the public API
 */ var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "useSelectGetStyles", ()=>useSelectGetStyles);
var _react = require("react");
var _selectGetStylesContext = require("./select-get-styles-context");
const useSelectGetStyles = ()=>(0, _react.useContext)((0, _selectGetStylesContext.SelectGetStylesContext));

},{"react":"ltHCL","./select-get-styles-context":"c3wCO","@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"c3wCO":[function(require,module,exports,__globalThis) {
/**
 * Internal context used to pass the original Select instance's getStyles function
 * down to components like MultiValue, without polluting the public CommonProps API.
 *
 * This allows MultiValue to detect whether getStyles has been overridden on a
 * component instance (e.g. via a custom component wrapper passing a different
 * getStyles prop), by comparing props.getStyles against the original.
 *
 * @internal — not part of the public API
 */ var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "SelectGetStylesContext", ()=>SelectGetStylesContext);
var _react = require("react");
const SelectGetStylesContext = /*#__PURE__*/ (0, _react.createContext)(undefined);

},{"react":"ltHCL","@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"jW74g":[function(require,module,exports,__globalThis) {
/* multi-value-label.tsx generated by @compiled/babel-plugin v0.39.1 */ var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "MultiValueLabel", ()=>MultiValueLabel);
var _objectSpread = require("@swc/helpers/_/_object_spread");
var _objectSpreadProps = require("@swc/helpers/_/_object_spread_props");
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _runtime = require("@compiled/react/runtime");
var _react1 = require("@compiled/react");
const multiValueLabelStyles = {
    root: "_1reo15vq _18m915vq _2rkolb4i _11c8fhey _o5721q9c _y4tiv77o _bozg1b66 _syaz1kw7",
    disabled: "_syaz1gmx",
    ellipsis: "_1bto1l2s"
};
const MultiValueLabel = ({ children, innerProps, isDisabled, hasEllipsis, className, xcss })=>{
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", (0, _objectSpreadProps._)((0, _objectSpread._)({}, innerProps), {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop, @atlaskit/ui-styling-standard/local-cx-xcss, @compiled/local-cx-xcss
        className: (0, _runtime.ax)([
            multiValueLabelStyles.root,
            isDisabled && multiValueLabelStyles.disabled,
            hasEllipsis && multiValueLabelStyles.ellipsis,
            (0, _react1.cx)(className, xcss, '-MultiValueLabel')
        ]),
        children: children
    }));
};

},{"@swc/helpers/_/_object_spread":"9gdrV","@swc/helpers/_/_object_spread_props":"kANqQ","react/jsx-runtime":"bGvcw","react":"ltHCL","@compiled/react/runtime":"d27Vo","@compiled/react":"MfI9Z","@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"jmTod":[function(require,module,exports,__globalThis) {
/* multi-value-remove.tsx generated by @compiled/babel-plugin v0.39.1 */ var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "MultiValueRemove", ()=>MultiValueRemove);
var _objectSpread = require("@swc/helpers/_/_object_spread");
var _objectSpreadProps = require("@swc/helpers/_/_object_spread_props");
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _runtime = require("@compiled/react/runtime");
var _react1 = require("@compiled/react");
var _cross = require("@atlaskit/icon/core/cross");
var _crossDefault = parcelHelpers.interopDefault(_cross);
const disabledStyles = null;
const enabledStyles = null;
const multiValueRemoveStyles = {
    focused: "_bfhkb1q9 _lswu6x5g",
    root: "_19itglyw _2rko12b0 _4cvr1h6o _1bah1h6o _1wpz1h6o _r06hglyw _bfhksm61 _syazi7uo _1e0c1txw _lswui7uo _1q51v77o _y4tiv77o _85i5v77o _bozgv77o _12l2v77o _1ah312gs _irr31dpa _13br1tmw _1di6fcek _i5f81tmw"
};
function MultiValueRemove({ isDisabled, isFocused, innerProps, className, xcss }) {
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", (0, _objectSpreadProps._)((0, _objectSpread._)({}, innerProps), {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop, @atlaskit/ui-styling-standard/local-cx-xcss, @compiled/local-cx-xcss
        className: (0, _runtime.ax)([
            multiValueRemoveStyles.root,
            isFocused && multiValueRemoveStyles.focused,
            (0, _react1.cx)(className, xcss, '-MultiValueRemove')
        ]),
        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
            "data-testid": isDisabled ? 'hide-clear-icon' : 'show-clear-icon',
            className: (0, _runtime.ax)([
                isDisabled && "_1e0cglyw",
                !isDisabled && "_1e0c1kw7"
            ]),
            children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _crossDefault.default), {
                label: "",
                color: "currentColor",
                size: "small"
            })
        })
    }));
}

},{"@swc/helpers/_/_object_spread":"9gdrV","@swc/helpers/_/_object_spread_props":"kANqQ","react/jsx-runtime":"bGvcw","react":"ltHCL","@compiled/react/runtime":"d27Vo","@compiled/react":"MfI9Z","@atlaskit/icon/core/cross":"7mJX1","@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"8V13O":[function(require,module,exports,__globalThis) {
/* option.tsx generated by @compiled/babel-plugin v0.39.1 */ var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _objectSpread = require("@swc/helpers/_/_object_spread");
var _objectSpreadProps = require("@swc/helpers/_/_object_spread_props");
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _runtime = require("@compiled/react/runtime");
var _react1 = require("@compiled/react");
var _platformFeatureFlags = require("@atlaskit/platform-feature-flags");
var _getStyleProps = require("../get-style-props");
const optionStyles = {
    root: "_1rjc12x7 _18zrutpp _syazi7uo _80om73ad _1e0c1ule _1wyb1kw7 _1bsb1osq _uiztglyw _18ql1j7p _1di6fcek",
    disabled: "_syaz1gmx _80om13gf _bfhk1j28 _16qsglyw _1di61j28 _112eglyw",
    focused: "_bfhk1dpa _16qs1x9r _112e5u6v",
    selected: "_syaz6x5g _bfhk15s3 _16qs1x9r _1di6nozp _112e5u6v",
    focusedSelected: "_bfhkufnl",
    motion: "_v564hxmd _1ggl87vo",
    motionSelected: "_v5641rrn"
};
const Option = (props)=>{
    const { children, isDisabled, isFocused, isSelected, innerRef, innerProps, xcss } = props;
    const { css, className } = (0, _getStyleProps.getStyleProps)(props, 'option', {
        option: true,
        'option--is-disabled': isDisabled,
        'option--is-focused': isFocused,
        'option--is-selected': isSelected
    });
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", (0, _objectSpreadProps._)((0, _objectSpread._)({
        // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop
        style: css,
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop, @atlaskit/ui-styling-standard/local-cx-xcss, @compiled/local-cx-xcss
        className: (0, _runtime.ax)([
            optionStyles.root,
            !isDisabled && !isSelected && (0, _platformFeatureFlags.fg)('platform-dst-motion-uplift-list-item') && optionStyles.motion,
            isFocused && optionStyles.focused,
            isSelected && optionStyles.selected,
            isFocused && isSelected && optionStyles.focusedSelected,
            !isDisabled && isSelected && (0, _platformFeatureFlags.fg)('platform-dst-motion-uplift-list-item') && optionStyles.motionSelected,
            isDisabled && optionStyles.disabled,
            (0, _react1.cx)(className, xcss, '-option')
        ]),
        ref: innerRef
    }, innerProps), {
        tabIndex: -1,
        children: children
    }));
};
// eslint-disable-next-line @repo/internal/react/require-jsdoc
exports.default = Option;

},{"@swc/helpers/_/_object_spread":"9gdrV","@swc/helpers/_/_object_spread_props":"kANqQ","react/jsx-runtime":"bGvcw","react":"ltHCL","@compiled/react/runtime":"d27Vo","@compiled/react":"MfI9Z","@atlaskit/platform-feature-flags":"8rD2i","../get-style-props":"lzdjl","@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"asiRS":[function(require,module,exports,__globalThis) {
/* placeholder.tsx generated by @compiled/babel-plugin v0.39.1 */ var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _objectSpread = require("@swc/helpers/_/_object_spread");
var _objectSpreadProps = require("@swc/helpers/_/_object_spread_props");
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _runtime = require("@compiled/react/runtime");
var _react1 = require("@compiled/react");
var _getStyleProps = require("../get-style-props");
const placeholderStyles = {
    root: "_nd5l1sux _1pfhidpf _12l2v77o _6rthidpf _ahbqv77o _syaz1rpy",
    disabled: "_syaz1gmx"
};
const Placeholder = (props)=>{
    const { children, innerProps, isDisabled, xcss } = props;
    const { css, className } = (0, _getStyleProps.getStyleProps)(props, 'placeholder', {
        placeholder: true
    });
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", (0, _objectSpreadProps._)((0, _objectSpread._)({
        // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop
        style: css,
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop, @atlaskit/ui-styling-standard/local-cx-xcss, @compiled/local-cx-xcss
        className: (0, _runtime.ax)([
            placeholderStyles.root,
            isDisabled && placeholderStyles.disabled,
            (0, _react1.cx)(className, xcss, '-placeholder')
        ])
    }, innerProps), {
        children: children
    }));
};
// eslint-disable-next-line @repo/internal/react/require-jsdoc
exports.default = Placeholder;

},{"@swc/helpers/_/_object_spread":"9gdrV","@swc/helpers/_/_object_spread_props":"kANqQ","react/jsx-runtime":"bGvcw","react":"ltHCL","@compiled/react/runtime":"d27Vo","@compiled/react":"MfI9Z","../get-style-props":"lzdjl","@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"llmxj":[function(require,module,exports,__globalThis) {
/* single-value.tsx generated by @compiled/babel-plugin v0.39.1 */ var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _objectSpread = require("@swc/helpers/_/_object_spread");
var _objectSpreadProps = require("@swc/helpers/_/_object_spread_props");
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _runtime = require("@compiled/react/runtime");
var _react1 = require("@compiled/react");
var _getStyleProps = require("../get-style-props");
const styles = {
    root: "_nd5l1sux _1reo15vq _18m915vq _p12f1osq _1bto1l2s _o5721q9c _1pfhidpf _12l2v77o _6rthidpf _ahbqv77o _syazi7uo",
    disalbed: "_syaz1gmx"
};
const SingleValue = (props)=>{
    const { children, isDisabled, innerProps, xcss } = props;
    const { css, className } = (0, _getStyleProps.getStyleProps)(props, 'singleValue', {
        'single-value': true,
        'single-value--is-disabled': isDisabled
    });
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", (0, _objectSpreadProps._)((0, _objectSpread._)({
        // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop
        style: css,
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop, @atlaskit/ui-styling-standard/local-cx-xcss, @compiled/local-cx-xcss
        className: (0, _runtime.ax)([
            styles.root,
            isDisabled && styles.disalbed,
            (0, _react1.cx)(className, xcss, '-singleValue')
        ])
    }, innerProps), {
        children: children
    }));
};
// eslint-disable-next-line @repo/internal/react/require-jsdoc
exports.default = SingleValue;

},{"@swc/helpers/_/_object_spread":"9gdrV","@swc/helpers/_/_object_spread_props":"kANqQ","react/jsx-runtime":"bGvcw","react":"ltHCL","@compiled/react/runtime":"d27Vo","@compiled/react":"MfI9Z","../get-style-props":"lzdjl","@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"1DPMh":[function(require,module,exports,__globalThis) {
/* checkbox-option.tsx generated by @compiled/babel-plugin v0.39.1 */ var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "CheckboxOption", ()=>CheckboxOption);
var _objectSpread = require("@swc/helpers/_/_object_spread");
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _runtime = require("@compiled/react/runtime");
var _controlOption = require("./control-option");
const svgStyles = null;
const CheckboxIcon = (props)=>{
    const { primaryColor, secondaryColor, label } = props;
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)("svg", {
        viewBox: "0 0 24 24",
        style: {
            color: primaryColor,
            fill: secondaryColor
        },
        "aria-label": label ? label : undefined,
        role: label ? 'img' : 'presentation',
        className: (0, _runtime.ax)([
            "_1reo15vq _18m915vq _1bsb1tcg _4t3i1tcg _lswuvuon _lcxvglyw"
        ]),
        children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)("g", {
            fillRule: "evenodd",
            children: [
                /*#__PURE__*/ (0, _jsxRuntime.jsx)("rect", {
                    x: "5.5",
                    y: "5.5",
                    width: "13",
                    height: "13",
                    rx: "1.5",
                    fill: "currentColor"
                }),
                /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                    fillRule: "evenodd",
                    clipRule: "evenodd",
                    d: "M16.3262 9.48011L15.1738 8.51984L10.75 13.8284L8.82616 11.5198L7.67383 12.4801L10.1738 15.4801C10.3163 15.6511 10.5274 15.75 10.75 15.75C10.9726 15.75 11.1837 15.6511 11.3262 15.4801L16.3262 9.48011Z",
                    fill: "inherit"
                })
            ]
        })
    });
};
const CheckboxOption = (props)=>/*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _controlOption.ControlOption), (0, _objectSpread._)({
        Icon: CheckboxIcon
    }, props));

},{"@swc/helpers/_/_object_spread":"9gdrV","react/jsx-runtime":"bGvcw","react":"ltHCL","@compiled/react/runtime":"d27Vo","./control-option":"dP428","@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"dP428":[function(require,module,exports,__globalThis) {
/* control-option.tsx generated by @compiled/babel-plugin v0.39.1 */ var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "ControlOption", ()=>ControlOption);
var _objectSpread = require("@swc/helpers/_/_object_spread");
var _objectSpreadProps = require("@swc/helpers/_/_object_spread_props");
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _runtime = require("@compiled/react/runtime");
var _platformFeatureFlags = require("@atlaskit/platform-feature-flags");
const optionStyles = {
    default: "_1e0c1txw _4cvr1h6o _1bsb1osq _uiztglyw _18ql1j7p _vchhusvi _85i51b66 _1q511b66 _bozgpxbi _y4tiutpp _bfhk1j28 _16qs1kw7 _syaz1kw7 _1di6fcek",
    focused: "_bfhk1dpa _16qsgkog _112e5u6v",
    disabled: "_syaz1gmx",
    motion: "_v564hxmd _1ggl87vo"
};
// the primary color represents the outer or background element
const getPrimaryColor = ({ isActive, isDisabled, isFocused, isSelected })=>{
    if (isDisabled) return "var(--ds-background-disabled, #0515240F)";
    else if (isSelected && isActive) return "var(--ds-background-selected-bold-pressed, #123263)";
    else if (isActive) return "var(--ds-background-selected-pressed, #8FB8F6)";
    else if (isFocused && isSelected) return "var(--ds-background-selected-bold-hovered, #1558BC)";
    else if (isFocused) return "var(--ds-surface, #FFFFFF)";
    else if (isSelected) return "var(--ds-background-selected-bold, #1868DB)";
    return "var(--ds-background-neutral, #0515240F)";
};
// the secondary color represents the radio dot or checkmark
const getSecondaryColor = ({ isDisabled, isSelected })=>{
    if (isDisabled && isSelected) return "var(--ds-text-disabled, #080F214A)";
    else if (!isSelected) return 'transparent';
    return "var(--ds-surface, #FFFFFF)";
};
const iconStyles = {
    inherit: "_1u9j1r31 _1gqp1r31",
    default: "_1u9j1ihb _1gqp1ihb"
};
const baseIconStyles = null;
const baseOptionStyles = null;
const ControlOption = (props)=>{
    const [isActive, setIsActive] = (0, _react.useState)(false);
    const onMouseDown = (0, _react.useCallback)(()=>setIsActive(true), []);
    const onMouseUp = (0, _react.useCallback)(()=>setIsActive(false), []);
    const { Icon, children, innerProps, innerRef, cx, className, isDisabled, isSelected, isFocused } = props;
    const classNames = (0, _react.useMemo)(()=>cx({
            option: true,
            'option--is-disabled': isDisabled,
            'option--is-focused': isFocused,
            'option--is-selected': isSelected
        }, className), [
        cx,
        isDisabled,
        isFocused,
        isSelected,
        className
    ]);
    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", (0, _objectSpreadProps._)((0, _objectSpread._)({
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop
        className: (0, _runtime.ax)([
            optionStyles.default,
            !isDisabled && (0, _platformFeatureFlags.fg)('platform-dst-motion-uplift-list-item') && optionStyles.motion,
            isFocused && optionStyles.focused,
            isDisabled && optionStyles.disabled,
            classNames
        ]),
        ref: innerRef,
        onMouseDown: onMouseDown,
        onMouseUp: onMouseUp,
        // eslint-disable-next-line @atlassian/a11y/mouse-events-have-key-events
        onMouseLeave: onMouseUp
    }, innerProps), {
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                className: (0, _runtime.ax)([
                    "_1e0c1txw _4cvr1h6o _1o9zidpf _y4ti1b66 _16cu892t _1xci892t _59qxe4h9 _8y3xe4h9",
                    isSelected || isActive || isDisabled ? iconStyles.inherit : iconStyles.default
                ]),
                children: !!Icon ? /*#__PURE__*/ (0, _jsxRuntime.jsx)(Icon, {
                    label: "",
                    primaryColor: getPrimaryColor({
                        isDisabled,
                        isSelected,
                        isFocused,
                        isActive
                    }),
                    secondaryColor: getSecondaryColor({
                        isDisabled,
                        isSelected
                    }),
                    isFacadeDisabled: true
                }) : null
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                className: (0, _runtime.ax)([
                    "_16jlkb7n _1reo15vq _1bto1l2s _o5721q9c"
                ]),
                children: children
            })
        ]
    }));
};

},{"@swc/helpers/_/_object_spread":"9gdrV","@swc/helpers/_/_object_spread_props":"kANqQ","react/jsx-runtime":"bGvcw","react":"ltHCL","@compiled/react/runtime":"d27Vo","@atlaskit/platform-feature-flags":"8rD2i","@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"d7Alx":[function(require,module,exports,__globalThis) {
/* radio-option.tsx generated by @compiled/babel-plugin v0.39.1 */ var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "RadioOption", ()=>RadioOption);
var _objectSpread = require("@swc/helpers/_/_object_spread");
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _runtime = require("@compiled/react/runtime");
var _controlOption = require("./control-option");
const svgStyles = null;
const RadioIcon = (props)=>{
    const { primaryColor, secondaryColor, label } = props;
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)("svg", {
        viewBox: "0 0 24 24",
        style: {
            color: primaryColor,
            fill: secondaryColor
        },
        "aria-label": label ? label : undefined,
        role: label ? 'img' : 'presentation',
        className: (0, _runtime.ax)([
            "_1reo15vq _18m915vq _1bsb1tcg _4t3i1tcg _lswuvuon _lcxvglyw"
        ]),
        children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)("g", {
            fillRule: "evenodd",
            children: [
                /*#__PURE__*/ (0, _jsxRuntime.jsx)("circle", {
                    cx: "12",
                    cy: "12",
                    r: "6.75",
                    fill: "currentColor",
                    strokeWidth: "1.5"
                }),
                /*#__PURE__*/ (0, _jsxRuntime.jsx)("circle", {
                    cx: "12",
                    cy: "12",
                    r: "3",
                    fill: "inherit"
                })
            ]
        })
    });
};
const RadioOption = (props)=>// TODO https://product-fabric.atlassian.net/browse/DSP-20769
    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _controlOption.ControlOption), (0, _objectSpread._)({
        Icon: RadioIcon
    }, props));

},{"@swc/helpers/_/_object_spread":"9gdrV","react/jsx-runtime":"bGvcw","react":"ltHCL","@compiled/react/runtime":"d27Vo","./control-option":"dP428","@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"22Mwt":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>(0, _selectDefault.default));
parcelHelpers.export(exports, "SelectWithoutAnalytics", ()=>(0, _selectWithoutAnalytics.SelectWithoutAnalytics));
var _select = require("../select");
var _selectDefault = parcelHelpers.interopDefault(_select);
var _selectWithoutAnalytics = require("../select-without-analytics");

},{"../select":"iPOlk","../select-without-analytics":"7INIV","@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"iPOlk":[function(require,module,exports,__globalThis) {
/* eslint-disable @repo/internal/react/require-jsdoc */ var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _analyticsNext = require("@atlaskit/analytics-next");
var _selectWithoutAnalytics = require("./select-without-analytics");
const packageName = "@af/atlassian-studio";
const packageVersion = "0.16.1";
const createAndFireEventOnAtlaskit = (0, _analyticsNext.createAndFireEvent)('atlaskit');
const Select = (0, _analyticsNext.withAnalyticsContext)({
    componentName: 'select',
    packageName,
    packageVersion
})((0, _analyticsNext.withAnalyticsEvents)({
    onChange: createAndFireEventOnAtlaskit({
        action: 'changed',
        actionSubject: 'option',
        attributes: {
            componentName: 'select',
            packageName,
            packageVersion
        }
    })
})((0, _selectWithoutAnalytics.SelectWithoutAnalytics)));
// eslint-disable-next-line @atlaskit/volt-strict-mode/no-multiple-exports
exports.default = Select;

},{"@atlaskit/analytics-next":"6PLie","./select-without-analytics":"7INIV","@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"7INIV":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "SelectWithoutAnalytics", ()=>SelectWithoutAnalytics);
var _async = require("@atlaskit/react-select/async");
var _asyncDefault = parcelHelpers.interopDefault(_async);
var _createSelect = require("./create-select");
var _createSelectDefault = parcelHelpers.interopDefault(_createSelect);
const SelectWithoutAnalytics = (0, _createSelectDefault.default)((0, _asyncDefault.default));

},{"@atlaskit/react-select/async":"8f4gg","./create-select":"9dP6S","@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"8f4gg":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "useAsync", ()=>(0, _useAsyncDefault.default));
parcelHelpers.export(exports, "default", ()=>(0, _asyncDefault.default));
var _useAsync = require("../use-async");
var _useAsyncDefault = parcelHelpers.interopDefault(_useAsync);
var _async = require("../async");
var _asyncDefault = parcelHelpers.interopDefault(_async);

},{"../use-async":false,"../async":"kWyDM","@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"fKgRX":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>useAsync);
var _objectSpread = require("@swc/helpers/_/_object_spread");
var _objectSpreadProps = require("@swc/helpers/_/_object_spread_props");
var _objectWithoutProperties = require("@swc/helpers/_/_object_without_properties");
var _react = require("react");
function handleInputChange(inputValue, actionMeta, onInputChange) {
    if (onInputChange) {
        const newValue = onInputChange(inputValue, actionMeta);
        if (typeof newValue === 'string') return newValue;
    }
    return inputValue;
}
function useAsync(_param) {
    var { defaultOptions: propsDefaultOptions = false, cacheOptions = false, loadOptions: propsLoadOptions, options: propsOptions, isLoading: propsIsLoading = false, onInputChange: propsOnInputChange, filterOption = null } = _param, restSelectProps = (0, _objectWithoutProperties._)(_param, [
        "defaultOptions",
        "cacheOptions",
        "loadOptions",
        "options",
        "isLoading",
        "onInputChange",
        "filterOption"
    ]);
    const { inputValue: propsInputValue } = restSelectProps;
    const lastRequest = (0, _react.useRef)(undefined);
    const mounted = (0, _react.useRef)(false);
    const [defaultOptions, setDefaultOptions] = (0, _react.useState)(Array.isArray(propsDefaultOptions) ? propsDefaultOptions : undefined);
    const [stateInputValue, setStateInputValue] = (0, _react.useState)(typeof propsInputValue !== 'undefined' ? propsInputValue : '');
    const [isLoading, setIsLoading] = (0, _react.useState)(propsDefaultOptions === true);
    const [loadedInputValue, setLoadedInputValue] = (0, _react.useState)(undefined);
    const [loadedOptions, setLoadedOptions] = (0, _react.useState)([]);
    const [passEmptyOptions, setPassEmptyOptions] = (0, _react.useState)(false);
    const [optionsCache, setOptionsCache] = (0, _react.useState)({});
    const [prevDefaultOptions, setPrevDefaultOptions] = (0, _react.useState)(undefined);
    const [prevCacheOptions, setPrevCacheOptions] = (0, _react.useState)(undefined);
    if (cacheOptions !== prevCacheOptions) {
        setOptionsCache({});
        setPrevCacheOptions(cacheOptions);
    }
    if (propsDefaultOptions !== prevDefaultOptions) {
        setDefaultOptions(Array.isArray(propsDefaultOptions) ? propsDefaultOptions : undefined);
        setPrevDefaultOptions(propsDefaultOptions);
    }
    (0, _react.useEffect)(()=>{
        mounted.current = true;
        return ()=>{
            mounted.current = false;
        };
    }, []);
    const loadOptions = (0, _react.useCallback)((inputValue, callback)=>{
        if (!propsLoadOptions) return callback();
        const loader = propsLoadOptions(inputValue, callback);
        if (loader && typeof loader.then === 'function') loader.then(callback, ()=>callback());
    }, [
        propsLoadOptions
    ]);
    (0, _react.useEffect)(()=>{
        if (propsDefaultOptions === true) loadOptions(stateInputValue, (options)=>{
            if (!mounted.current) return;
            setDefaultOptions(options || []);
            setIsLoading(!!lastRequest.current);
        });
    // NOTE: this effect is designed to only run when the component mounts,
    // so we don't want to include any hook dependencies
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
    const onInputChange = (0, _react.useCallback)((newValue, actionMeta)=>{
        const inputValue = handleInputChange(newValue, actionMeta, propsOnInputChange);
        if (!inputValue) {
            lastRequest.current = undefined;
            setStateInputValue('');
            setLoadedInputValue('');
            setLoadedOptions([]);
            setIsLoading(false);
            setPassEmptyOptions(false);
            return;
        }
        if (cacheOptions && optionsCache[inputValue]) {
            setStateInputValue(inputValue);
            setLoadedInputValue(inputValue);
            setLoadedOptions(optionsCache[inputValue]);
            setIsLoading(false);
            setPassEmptyOptions(false);
        } else {
            const request = lastRequest.current = {};
            setStateInputValue(inputValue);
            setIsLoading(true);
            setPassEmptyOptions(!loadedInputValue);
            loadOptions(inputValue, (options)=>{
                if (!mounted) return;
                if (request !== lastRequest.current) return;
                lastRequest.current = undefined;
                setIsLoading(false);
                setLoadedInputValue(inputValue);
                setLoadedOptions(options || []);
                setPassEmptyOptions(false);
                setOptionsCache(options ? (0, _objectSpreadProps._)((0, _objectSpread._)({}, optionsCache), {
                    [inputValue]: options
                }) : optionsCache);
            });
        }
    }, [
        cacheOptions,
        loadOptions,
        loadedInputValue,
        optionsCache,
        propsOnInputChange
    ]);
    const options = passEmptyOptions ? [] : stateInputValue && loadedInputValue ? loadedOptions : defaultOptions || [];
    return (0, _objectSpreadProps._)((0, _objectSpread._)({}, restSelectProps), {
        options,
        isLoading: isLoading || propsIsLoading,
        onInputChange,
        filterOption
    });
}

},{"@swc/helpers/_/_object_spread":"9gdrV","@swc/helpers/_/_object_spread_props":"kANqQ","@swc/helpers/_/_object_without_properties":"6HqIM","react":"ltHCL","@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"kWyDM":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _objectSpread = require("@swc/helpers/_/_object_spread");
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _select = require("./select");
var _selectDefault = parcelHelpers.interopDefault(_select);
var _useAsync = require("./use-async");
var _useAsyncDefault = parcelHelpers.interopDefault(_useAsync);
var _useStateManager = require("./use-state-manager");
var _useStateManagerDefault = parcelHelpers.interopDefault(_useStateManager);
const AsyncSelect = /*#__PURE__*/ (0, _react.forwardRef)(// eslint-disable-next-line @typescript-eslint/ban-ts-comment
// @ts-ignore: to unblock React 18.2.0 -> 18.3.1 version bump in Jira
(props, ref)=>{
    // when isAsync is true, options are not provided and async props are used, we will enable async
    const isAsyncEnabledInBaseSelect = props.isAsync && !props.options && (!!props.loadOptions || !!props.defaultOptions);
    const stateManagedProps = (0, _useAsyncDefault.default)(props);
    // when isAsync is falsy or isAsyncEnabledInBaseSelect is true, we use async props, otherwise we use base props
    let selectAsyncProps = !props.isAsync || isAsyncEnabledInBaseSelect ? stateManagedProps : props;
    const selectProps = (0, _useStateManagerDefault.default)(selectAsyncProps);
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _selectDefault.default), (0, _objectSpread._)({
        ref: ref
    }, selectProps));
});
// eslint-disable-next-line @repo/internal/react/require-jsdoc
exports.default = AsyncSelect;

},{"@swc/helpers/_/_object_spread":"9gdrV","react/jsx-runtime":"bGvcw","react":"ltHCL","./select":"6szgU","./use-async":"fKgRX","./use-state-manager":"2tgTy","@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"6szgU":[function(require,module,exports,__globalThis) {
/* select.tsx generated by @compiled/babel-plugin v0.39.1 */ var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "defaultProps", ()=>defaultProps);
// eslint-disable-next-line @repo/internal/react/no-class-components, @atlaskit/volt-strict-mode/no-multiple-exports
parcelHelpers.export(exports, "default", ()=>Select);
var _objectSpread = require("@swc/helpers/_/_object_spread");
var _objectSpreadProps = require("@swc/helpers/_/_object_spread_props");
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _runtime = require("@compiled/react/runtime");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _bindEventListener = require("bind-event-listener");
var _deviceCheck = require("@atlaskit/ds-lib/device-check");
var _isSafari = require("@atlaskit/ds-lib/is-safari");
var _noop = require("@atlaskit/ds-lib/noop");
var _noopDefault = parcelHelpers.interopDefault(_noop);
var _platformFeatureFlags = require("@atlaskit/platform-feature-flags");
var _builtins = require("./builtins");
var _components = require("./components");
var _dummyInput = require("./components/dummy-input");
var _dummyInputDefault = parcelHelpers.interopDefault(_dummyInput);
var _liveRegion = require("./components/live-region");
var _liveRegionDefault = parcelHelpers.interopDefault(_liveRegion);
var _menuPlacer = require("./components/menu-placer");
var _menuPlacerDefault = parcelHelpers.interopDefault(_menuPlacer);
var _filters = require("./filters");
var _classnames = require("./internal/classnames");
var _cleanValue = require("./internal/clean-value");
var _isDocumentEl = require("./internal/is-document-el");
var _menuPortalCloseContext = require("./internal/menu-portal-close-context");
var _multiValueAsValue = require("./internal/multi-value-as-value");
var _notifyOpenLayerObserver = require("./internal/notify-open-layer-observer");
var _requiredInput = require("./internal/required-input");
var _requiredInputDefault = parcelHelpers.interopDefault(_requiredInput);
var _scrollManager = require("./internal/scroll-manager");
var _scrollManagerDefault = parcelHelpers.interopDefault(_scrollManager);
var _scrollTo = require("./internal/scroll-to");
var _selectGetStylesContext = require("./internal/select-get-styles-context");
var _singleValueAsValue = require("./internal/single-value-as-value");
var _valueTernary = require("./internal/value-ternary");
const noop = (0, _noopDefault.default);
function notNullish(item) {
    return item != null;
}
function scrollIntoView(menuEl, focusedEl) {
    const menuRect = menuEl.getBoundingClientRect();
    const focusedRect = focusedEl.getBoundingClientRect();
    const overScroll = focusedEl.offsetHeight / 3;
    if (focusedRect.bottom + overScroll > menuRect.bottom) (0, _scrollTo.scrollTo)(menuEl, Math.min(focusedEl.offsetTop + focusedEl.clientHeight - menuEl.offsetHeight + overScroll, menuEl.scrollHeight));
    else if (focusedRect.top - overScroll < menuRect.top) (0, _scrollTo.scrollTo)(menuEl, Math.max(focusedEl.offsetTop - overScroll, 0));
}
function isMobileDevice() {
    try {
        return /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent);
    } catch (e) {
        return false;
    }
}
function isTouchCapable() {
    try {
        document.createEvent('TouchEvent');
        return true;
    } catch (e) {
        return false;
    }
}
/**
 * Filters out unsupported selectors (e.g., pseudo-classes, complex selectors) from a styles object.
 * @param styles - The styles object to filter.
 * @returns A new object containing only supported styles.
 */ const filterUnsupportedSelectors = (styles)=>{
    const unsupportedSelectors = [
        ':',
        // pseudo-classes/elements
        '[',
        // attribute selectors
        '>',
        // child combinator
        '+',
        // adjacent sibling combinator
        '~',
        // general sibling combinator
        ' ',
        // descendant combinator
        '*',
        // universal selector
        '#',
        // ID selector
        '.',
        // class selector
        '@',
        // at-rules
        '&',
        // parent selector
        '|',
        // namespace separator
        '^',
        // starts with
        '$',
        // ends with
        '=' // equals
    ];
    return Object.keys(styles).reduce((filteredStyles, key)=>{
        if (!unsupportedSelectors.some((selector)=>key.includes(selector))) filteredStyles[key] = styles[key];
        return filteredStyles;
    }, {});
};
const elemBeforeCSS = null;
const defaultProps = {
    backspaceRemovesValue: true,
    blurInputOnSelect: isTouchCapable(),
    captureMenuScroll: !isTouchCapable(),
    classNames: {},
    closeMenuOnSelect: true,
    closeMenuOnScroll: false,
    components: {},
    controlShouldRenderValue: true,
    escapeClearsValue: false,
    filterOption: (0, _filters.createFilter)(),
    formatGroupLabel: (0, _builtins.formatGroupLabel),
    getOptionLabel: (0, _builtins.getOptionLabel),
    getOptionValue: (0, _builtins.getOptionValue),
    isDisabled: false,
    isLoading: false,
    isMulti: false,
    isRtl: false,
    isSearchable: true,
    isOptionDisabled: (0, _builtins.isOptionDisabled),
    loadingMessage: ()=>'Loading...',
    maxMenuHeight: 300,
    minMenuHeight: 140,
    menuIsOpen: false,
    menuPlacement: 'bottom',
    menuPosition: 'absolute',
    menuShouldBlockScroll: false,
    menuShouldScrollIntoView: !isMobileDevice(),
    noOptionsMessage: ()=>'No options',
    openMenuOnFocus: false,
    openMenuOnClick: true,
    shouldPreventEscapePropagation: false,
    options: [],
    pageSize: 5,
    placeholder: 'Select...',
    screenReaderStatus: ({ count })=>`${count} result${count !== 1 ? 's' : ''} available`,
    styles: {},
    tabIndex: 0,
    tabSelectsValue: true,
    UNSAFE_is_experimental_generic: false
};
function toCategorizedOption(props, option, selectValue, index) {
    const isDisabled = isOptionDisabled(props, option, selectValue);
    const isSelected = isOptionSelected(props, option, selectValue);
    const label = getOptionLabel(props, option);
    const value = getOptionValue(props, option);
    return {
        type: 'option',
        data: option,
        isDisabled,
        isSelected,
        label,
        value,
        index
    };
}
function buildCategorizedOptions(props, selectValue) {
    return props.options.map((groupOrOption, groupOrOptionIndex)=>{
        //@ts-ignore
        if ('options' in groupOrOption) {
            const categorizedOptions = groupOrOption.options.map((option, optionIndex)=>toCategorizedOption(props, option, selectValue, optionIndex)).filter((categorizedOption)=>isFocusable(props, categorizedOption));
            return categorizedOptions.length > 0 ? {
                type: 'group',
                data: groupOrOption,
                options: categorizedOptions,
                index: groupOrOptionIndex
            } : undefined;
        }
        const categorizedOption = toCategorizedOption(props, groupOrOption, selectValue, groupOrOptionIndex);
        return isFocusable(props, categorizedOption) ? categorizedOption : undefined;
    }).filter(notNullish);
}
function buildFocusableOptionsFromCategorizedOptions(categorizedOptions) {
    return categorizedOptions.reduce((optionsAccumulator, categorizedOption)=>{
        if (categorizedOption.type === 'group') optionsAccumulator.push(...categorizedOption.options.map((option)=>option.data));
        else optionsAccumulator.push(categorizedOption.data);
        return optionsAccumulator;
    }, []);
}
function buildFocusableOptionsWithIds(categorizedOptions, optionId) {
    return categorizedOptions.reduce((optionsAccumulator, categorizedOption)=>{
        if (categorizedOption.type === 'group') optionsAccumulator.push(...categorizedOption.options.map((option)=>({
                data: option.data,
                id: `${optionId}-${categorizedOption.index}-${option.index}`
            })));
        else optionsAccumulator.push({
            data: categorizedOption.data,
            id: `${optionId}-${categorizedOption.index}`
        });
        return optionsAccumulator;
    }, []);
}
function buildFocusableOptions(props, selectValue) {
    return buildFocusableOptionsFromCategorizedOptions(buildCategorizedOptions(props, selectValue));
}
function isFocusable(props, categorizedOption) {
    const { inputValue = '' } = props;
    const { data, isSelected, label, value } = categorizedOption;
    return (!shouldHideSelectedOptions(props) || !isSelected) && filterOption(props, {
        label,
        value,
        data
    }, inputValue);
}
function getNextFocusedValue(state, nextSelectValue) {
    const { focusedValue, selectValue: lastSelectValue } = state;
    const lastFocusedIndex = lastSelectValue.indexOf(focusedValue);
    if (lastFocusedIndex > -1) {
        const nextFocusedIndex = nextSelectValue.indexOf(focusedValue);
        if (nextFocusedIndex > -1) // the focused value is still in the selectValue, return it
        return focusedValue;
        else if (lastFocusedIndex < nextSelectValue.length) // the focusedValue is not present in the next selectValue array by
        // reference, so return the new value at the same index
        return nextSelectValue[lastFocusedIndex];
    }
    return null;
}
function getNextFocusedOption(state, options) {
    const { focusedOption: lastFocusedOption } = state;
    return lastFocusedOption && options.indexOf(lastFocusedOption) > -1 ? lastFocusedOption : options[0];
}
const getFocusedOptionId = (focusableOptionsWithIds, focusedOption)=>{
    var _focusableOptionsWithIds_find;
    const focusedOptionId = (_focusableOptionsWithIds_find = focusableOptionsWithIds.find((option)=>option.data === focusedOption)) === null || _focusableOptionsWithIds_find === void 0 ? void 0 : _focusableOptionsWithIds_find.id;
    return focusedOptionId || null;
};
const getOptionLabel = (props, data)=>{
    return props.getOptionLabel(data);
};
const getOptionValue = (props, data)=>{
    return props.getOptionValue(data);
};
function isOptionDisabled(props, option, selectValue) {
    return typeof props.isOptionDisabled === 'function' ? props.isOptionDisabled(option, selectValue) : false;
}
function isOptionSelected(props, option, selectValue) {
    if (selectValue.indexOf(option) > -1) return true;
    if (typeof props.isOptionSelected === 'function') return props.isOptionSelected(option, selectValue);
    const candidate = getOptionValue(props, option);
    return selectValue.some((i)=>getOptionValue(props, i) === candidate);
}
function filterOption(props, option, inputValue) {
    return props.filterOption ? props.filterOption(option, inputValue) : true;
}
const shouldHideSelectedOptions = (props)=>{
    const { hideSelectedOptions, isMulti } = props;
    if (hideSelectedOptions === undefined) return isMulti;
    return hideSelectedOptions;
};
let instanceId = 1;
class Select extends (0, _react.Component) {
    static getDerivedStateFromProps(props, state) {
        const { prevProps, clearFocusValueOnUpdate, inputIsHiddenAfterUpdate, ariaSelection, isFocused, prevWasFocused, instancePrefix } = state;
        const { options, value, menuIsOpen, inputValue, isMulti } = props;
        const selectValue = (0, _cleanValue.cleanValue)(value);
        let newMenuOptionsState = {};
        if (prevProps && (value !== prevProps.value || options !== prevProps.options || menuIsOpen !== prevProps.menuIsOpen || inputValue !== prevProps.inputValue)) {
            const focusableOptions = menuIsOpen ? buildFocusableOptions(props, selectValue) : [];
            const focusableOptionsWithIds = menuIsOpen ? buildFocusableOptionsWithIds(buildCategorizedOptions(props, selectValue), `${instancePrefix}-option`) : [];
            const focusedValue = clearFocusValueOnUpdate ? getNextFocusedValue(state, selectValue) : null;
            const focusedOption = getNextFocusedOption(state, focusableOptions);
            const focusedOptionId = getFocusedOptionId(focusableOptionsWithIds, focusedOption);
            newMenuOptionsState = {
                selectValue,
                focusedOption,
                focusedOptionId,
                focusableOptionsWithIds,
                focusedValue,
                clearFocusValueOnUpdate: false
            };
        }
        // some updates should toggle the state of the input visibility
        const newInputIsHiddenState = inputIsHiddenAfterUpdate != null && props !== prevProps ? {
            inputIsHidden: inputIsHiddenAfterUpdate,
            inputIsHiddenAfterUpdate: undefined
        } : {};
        let newAriaSelection = ariaSelection;
        let hasKeptFocus = isFocused && prevWasFocused;
        if (isFocused && !hasKeptFocus) {
            // If `value` or `defaultValue` props are not empty then announce them
            // when the Select is initially focused
            newAriaSelection = {
                value: (0, _valueTernary.valueTernary)(isMulti, selectValue, selectValue[0] || null),
                options: selectValue,
                action: 'initial-input-focus'
            };
            hasKeptFocus = !prevWasFocused;
        }
        // If the 'initial-input-focus' action has been set already
        // then reset the ariaSelection to null
        if ((ariaSelection === null || ariaSelection === void 0 ? void 0 : ariaSelection.action) === 'initial-input-focus') newAriaSelection = null;
        return (0, _objectSpreadProps._)((0, _objectSpread._)({}, newMenuOptionsState, newInputIsHiddenState), {
            prevProps: props,
            ariaSelection: newAriaSelection,
            prevWasFocused: hasKeptFocus
        });
    }
    componentDidMount() {
        this.startListeningComposition();
        this.startListeningToTouch();
        if (this.props.closeMenuOnScroll && document && document.addEventListener) // Listen to all scroll events, and filter them out inside of 'onScroll'
        // eslint-disable-next-line @repo/internal/dom-events/no-unsafe-event-listeners
        document.addEventListener('scroll', this.onScroll, true);
        if (this.props.autoFocus) this.focusInput();
        // Scroll focusedOption into view if menuIsOpen is set on mount (e.g. defaultMenuIsOpen)
        if (this.props.menuIsOpen && this.state.focusedOption && this.menuListRef && this.focusedOptionRef) scrollIntoView(this.menuListRef, this.focusedOptionRef);
    }
    componentDidUpdate(prevProps) {
        const { isDisabled, menuIsOpen } = this.props;
        const { isFocused } = this.state;
        if (// ensure focus is restored correctly when the control becomes enabled
        isFocused && !isDisabled && prevProps.isDisabled || // ensure focus is on the Input when the menu opens
        isFocused && menuIsOpen && !prevProps.menuIsOpen) this.focusInput();
        if (isFocused && isDisabled && !prevProps.isDisabled) // ensure select state gets blurred in case Select is programmatically disabled while focused
        this.setState({
            isFocused: false
        }, this.onMenuClose);
        else if (!isFocused && !isDisabled && prevProps.isDisabled && this.inputRef === document.activeElement) // ensure select state gets focused in case Select is programatically re-enabled while focused (Firefox)
        this.setState({
            isFocused: true
        });
        // scroll the focused option into view if necessary
        if (this.menuListRef && this.focusedOptionRef && this.scrollToFocusedOptionOnUpdate) {
            scrollIntoView(this.menuListRef, this.focusedOptionRef);
            this.scrollToFocusedOptionOnUpdate = false;
        }
    }
    componentWillUnmount() {
        this.stopListeningComposition();
        this.stopListeningToTouch();
        this.cancelDeferredOpenMenu();
        // eslint-disable-next-line @repo/internal/dom-events/no-unsafe-event-listeners
        document.removeEventListener('scroll', this.onScroll, true);
    }
    // ==============================
    // Consumer Handlers
    // ==============================
    onMenuOpen() {
        this.props.onMenuOpen();
    }
    onMenuClose() {
        this.onInputChange('', {
            action: 'menu-close',
            prevInputValue: this.props.inputValue
        });
        this.props.onMenuClose();
    }
    onInputChange(newValue, actionMeta) {
        this.props.onInputChange(newValue, actionMeta);
    }
    // ==============================
    // Methods
    // ==============================
    focusInput() {
        if (!this.inputRef) return;
        this.inputRef.focus();
    }
    blurInput() {
        if (!this.inputRef) return;
        this.inputRef.blur();
    }
    /**
   * Whether to defer the menu open past the in-flight pointer gesture.
   * Any renderer that drives a `popover="auto"` element must, otherwise
   * the browser's light-dismiss runs on the matching `pointerup` and
   * closes the menu immediately. Today only the top-layer path needs it.
   */ shouldDeferOpenPastPointerUp() {
        return (0, _platformFeatureFlags.fg)('platform-dst-top-layer');
    }
    /**
   * Open the menu after the current pointer gesture, instead of
   * synchronously inside `mousedown`.
   *
   * On the top-layer path the menu is a `popover="auto"` element. The
   * browser captures the pointerdown target before the popover exists, so
   * opening synchronously gets immediately light-dismissed on pointerup
   * (and the matching `beforetoggle: closed` is not cancellable). Deferring
   * to the next `pointerup` avoids that.
   *
   * We listen for `pointerup` rather than `click` because `pointerup` is
   * the exact event the browser uses for light-dismiss (earliest safe
   * moment), always fires (`click` requires same down/up target), is hard
   * to lose to upstream `stopPropagation`, and is uniform across input
   * types. Off the top-layer path we open synchronously as before.
   */ openMenuAfterPointerUp(focusOption) {
        if (!this.shouldDeferOpenPastPointerUp()) {
            this.openMenu(focusOption);
            return;
        }
        // A second pointerdown can land before the queued pointerup if the
        // user releases and re-clicks very quickly. Replace any pending
        // deferred open with the latest one so we never stack listeners.
        this.cancelDeferredOpenMenu();
        const handlePointerUp = ()=>{
            this.deferredOpenMenuCleanup = null;
            this.openMenu(focusOption);
        };
        this.deferredOpenMenuCleanup = (0, _bindEventListener.bind)(document, {
            type: 'pointerup',
            listener: handlePointerUp,
            options: {
                capture: true,
                once: true
            }
        });
    }
    cancelDeferredOpenMenu() {
        if (this.deferredOpenMenuCleanup) {
            this.deferredOpenMenuCleanup();
            this.deferredOpenMenuCleanup = null;
        }
    }
    openMenu(focusOption) {
        const { selectValue, isFocused } = this.state;
        const focusableOptions = this.buildFocusableOptions();
        let openAtIndex = focusOption === 'first' ? 0 : focusableOptions.length - 1;
        if (!this.props.isMulti) {
            const selectedIndex = focusableOptions.indexOf(selectValue[0]);
            if (selectedIndex > -1) openAtIndex = selectedIndex;
        }
        const focusedOption = focusableOptions[openAtIndex];
        // only scroll if the menu isn't already open
        this.scrollToFocusedOptionOnUpdate = !(isFocused && this.menuListRef);
        this.setState({
            inputIsHiddenAfterUpdate: false,
            focusedValue: null,
            focusedOption: focusedOption,
            focusedOptionId: this.getFocusedOptionId(focusedOption)
        }, ()=>this.onMenuOpen());
        (0, _isSafari.isSafari)() && focusedOption && this.updateInputLabel(this.calculateInputLabel(focusedOption, openAtIndex));
    }
    updateInputLabel(inputLabel) {
        if (inputLabel) {
            var _this_inputRef;
            (_this_inputRef = this.inputRef) === null || _this_inputRef === void 0 ? void 0 : _this_inputRef.setAttribute('aria-label', inputLabel);
            setTimeout(()=>{
                var _this_inputRef, _this_inputRef1;
                const normalizedLabel = this.props['aria-label'] || this.props.label;
                if (normalizedLabel) (_this_inputRef = this.inputRef) === null || _this_inputRef === void 0 ? void 0 : _this_inputRef.setAttribute('aria-label', normalizedLabel);
                else (_this_inputRef1 = this.inputRef) === null || _this_inputRef1 === void 0 ? void 0 : _this_inputRef1.removeAttribute('aria-label');
            }, 500);
        }
    }
    calculateInputLabel(focusedOption, optionIndex) {
        const { options } = this.props;
        const isOptionsGrouped = options === null || options === void 0 ? void 0 : options.every((obj)=>typeof obj === 'object' && obj !== null && 'options' in obj);
        let inputLabel = this.getOptionLabel(focusedOption);
        const isOptionFocused = (option)=>{
            return this.getOptionLabel(option) === inputLabel;
        };
        const groupData = options === null || options === void 0 ? void 0 : options.find((option)=>{
            var _groupCandidate_options;
            const groupCandidate = option;
            var _groupCandidate_options_some;
            return (_groupCandidate_options_some = (_groupCandidate_options = groupCandidate.options) === null || _groupCandidate_options === void 0 ? void 0 : _groupCandidate_options.some(isOptionFocused)) !== null && _groupCandidate_options_some !== void 0 ? _groupCandidate_options_some : false;
        });
        if (isOptionsGrouped) {
            var _groupData_options_findIndex;
            const groupOptionIndex = (_groupData_options_findIndex = groupData === null || groupData === void 0 ? void 0 : groupData.options.findIndex(isOptionFocused)) !== null && _groupData_options_findIndex !== void 0 ? _groupData_options_findIndex : 0;
            const totalLength = options === null || options === void 0 ? void 0 : options.reduce((acc, currentGroup)=>{
                var _group_options;
                const group = currentGroup;
                acc += group === null || group === void 0 ? void 0 : (_group_options = group.options) === null || _group_options === void 0 ? void 0 : _group_options.length;
                return acc;
            }, 0);
            inputLabel = `${inputLabel}, ${groupData === null || groupData === void 0 ? void 0 : groupData.label} (${groupOptionIndex + 1} of ${totalLength})`;
        } else inputLabel = `${inputLabel} (${optionIndex + 1} of ${options === null || options === void 0 ? void 0 : options.length})`;
        return inputLabel;
    }
    focusValue(direction) {
        const { selectValue, focusedValue } = this.state;
        // Only multiselects support value focusing
        if (!this.props.isMulti) return;
        this.setState({
            focusedOption: null
        });
        let focusedIndex = selectValue.indexOf(focusedValue);
        if (!focusedValue) focusedIndex = -1;
        const lastIndex = selectValue.length - 1;
        let nextFocus = -1;
        if (!selectValue.length) return;
        switch(direction){
            case 'previous':
                if (focusedIndex === 0) // don't cycle from the start to the end
                nextFocus = 0;
                else if (focusedIndex === -1) // if nothing is focused, focus the last value first
                nextFocus = lastIndex;
                else nextFocus = focusedIndex - 1;
                break;
            case 'next':
                if (focusedIndex > -1 && focusedIndex < lastIndex) nextFocus = focusedIndex + 1;
                break;
        }
        this.setState({
            inputIsHidden: nextFocus !== -1,
            focusedValue: selectValue[nextFocus],
            focusedValueId: `${this.getElementId('selected-value')}-${nextFocus}-remove`,
            focusedOption: null,
            focusedOptionId: null
        });
    }
    focusOption(direction = 'first') {
        const { pageSize } = this.props;
        const { focusedOption } = this.state;
        const options = this.getFocusableOptions();
        if (!options.length) return;
        let nextFocus = 0; // handles 'first'
        let focusedIndex = options.indexOf(focusedOption);
        if (!focusedOption) focusedIndex = -1;
        if (direction === 'up') nextFocus = focusedIndex > 0 ? focusedIndex - 1 : options.length - 1;
        else if (direction === 'down') nextFocus = (focusedIndex + 1) % options.length;
        else if (direction === 'pageup') {
            nextFocus = focusedIndex - pageSize;
            if (nextFocus < 0) nextFocus = 0;
        } else if (direction === 'pagedown') {
            nextFocus = focusedIndex + pageSize;
            if (nextFocus > options.length - 1) nextFocus = options.length - 1;
        } else if (direction === 'last') nextFocus = options.length - 1;
        this.scrollToFocusedOptionOnUpdate = true;
        this.setState({
            focusedOption: options[nextFocus],
            focusedValue: null,
            focusedValueId: null,
            focusedOptionId: this.getFocusedOptionId(options[nextFocus])
        });
    }
    getCommonProps() {
        const { clearValue, cx, getStyles, getClassNames, getValue, selectOption, setValue, props } = this;
        const { isMulti, isRtl, options } = props;
        const hasValue = this.hasValue();
        return {
            clearValue,
            cx,
            getStyles,
            getClassNames,
            getValue,
            hasValue,
            isMulti,
            isRtl,
            options,
            selectOption,
            selectProps: props,
            setValue
        };
    }
    hasValue() {
        const { selectValue } = this.state;
        return selectValue.length > 0;
    }
    hasOptions() {
        return !!this.getFocusableOptions().length;
    }
    isClearable() {
        const { isClearable, isMulti } = this.props;
        // single select, by default, IS NOT clearable
        // multi select, by default, IS clearable
        if (isClearable === undefined) return isMulti;
        return isClearable;
    }
    isOptionDisabled(option, selectValue) {
        return isOptionDisabled(this.props, option, selectValue);
    }
    isOptionSelected(option, selectValue) {
        return isOptionSelected(this.props, option, selectValue);
    }
    filterOption(option, inputValue) {
        return filterOption(this.props, option, inputValue);
    }
    formatOptionLabel(data, context) {
        var _this_props_components;
        if (typeof this.props.formatOptionLabel === 'function') {
            const { inputValue } = this.props;
            const { selectValue } = this.state;
            return this.props.formatOptionLabel(data, {
                context,
                inputValue,
                selectValue
            });
        }
        // Auto-render elemBefore in dropdown menu only if formatOptionLabel is not provided
        // and no custom Option component is provided (custom Option components may already
        // render elemBefore themselves, causing it to appear twice)
        if (context === 'menu' && !this.props.formatOptionLabel && !((_this_props_components = this.props.components) === null || _this_props_components === void 0 ? void 0 : _this_props_components.Option) && (0, _platformFeatureFlags.fg)('platform-dst-lozenge-tag-badge-visual-uplifts')) {
            const elemBefore = data.elemBefore;
            if (elemBefore) {
                const label = this.getOptionLabel(data);
                return /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                    className: (0, _runtime.ax)([
                        "_zulpu2gc _1e0c1txw _4cvr1h6o"
                    ]),
                    children: [
                        elemBefore,
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                            children: label
                        })
                    ]
                });
            }
        }
        return this.getOptionLabel(data);
    }
    formatGroupLabel(data) {
        return this.props.formatGroupLabel(data);
    }
    calculateDescription() {
        const descriptionProp = this.props['aria-describedby'] || this.props.descriptionId;
        const { isMulti } = this.props;
        const hasValue = this.state.selectValue.length > 0;
        // Determine base description based on selection state
        const baseDescriptionId = hasValue ? isMulti ? '' : this.getElementId('single-value') : this.getElementId('placeholder');
        // Fast path for single select with no description prop
        if (!isMulti && !descriptionProp) return {
            'aria-describedby': baseDescriptionId
        };
        // Build the describedby string efficiently
        let describedBy = baseDescriptionId;
        // Add description prop if it exists
        if (descriptionProp) describedBy = describedBy ? `${descriptionProp} ${describedBy}` : descriptionProp;
        // For multi-select, always add multi-message ID
        if (isMulti) {
            const multiMessage = this.getElementId('multi-message');
            describedBy = describedBy ? `${describedBy} ${multiMessage}` : multiMessage;
        }
        return {
            'aria-describedby': describedBy
        };
    }
    // ==============================
    // Composition Handlers
    // ==============================
    startListeningComposition() {
        if (document && document.addEventListener) {
            // eslint-disable-next-line @repo/internal/dom-events/no-unsafe-event-listeners
            document.addEventListener('compositionstart', this.onCompositionStart, false);
            // eslint-disable-next-line @repo/internal/dom-events/no-unsafe-event-listeners
            document.addEventListener('compositionend', this.onCompositionEnd, false);
        }
    }
    stopListeningComposition() {
        if (document && document.removeEventListener) {
            // eslint-disable-next-line @repo/internal/dom-events/no-unsafe-event-listeners
            document.removeEventListener('compositionstart', this.onCompositionStart);
            // eslint-disable-next-line @repo/internal/dom-events/no-unsafe-event-listeners
            document.removeEventListener('compositionend', this.onCompositionEnd);
        }
    }
    // ==============================
    // Touch Handlers
    // ==============================
    startListeningToTouch() {
        if (document && document.addEventListener) {
            // eslint-disable-next-line @repo/internal/dom-events/no-unsafe-event-listeners
            document.addEventListener('touchstart', this.onTouchStart, false);
            // eslint-disable-next-line @repo/internal/dom-events/no-unsafe-event-listeners
            document.addEventListener('touchmove', this.onTouchMove, false);
            // eslint-disable-next-line @repo/internal/dom-events/no-unsafe-event-listeners
            document.addEventListener('touchend', this.onTouchEnd, false);
        }
    }
    stopListeningToTouch() {
        if (document && document.removeEventListener) {
            // eslint-disable-next-line @repo/internal/dom-events/no-unsafe-event-listeners
            document.removeEventListener('touchstart', this.onTouchStart);
            // eslint-disable-next-line @repo/internal/dom-events/no-unsafe-event-listeners
            document.removeEventListener('touchmove', this.onTouchMove);
            // eslint-disable-next-line @repo/internal/dom-events/no-unsafe-event-listeners
            document.removeEventListener('touchend', this.onTouchEnd);
        }
    }
    // ==============================
    // Renderers
    // ==============================
    renderInput() {
        const { form, inputId, inputValue, isDisabled, isInvalid, isRequired, isSearchable, label, labelId, menuIsOpen, required, tabIndex = 0, testId } = this.props;
        const { Input } = this.getComponents();
        const { inputIsHidden } = this.state;
        const { commonProps } = this;
        const id = inputId || this.getElementId('input');
        const isDisabledA11yFixEnabled = (0, _platformFeatureFlags.fg)('platform_dst_select_disabled_a11y_fix');
        // aria attributes makes the JSX "noisy", separated for clarity
        const ariaAttributes = (0, _objectSpread._)((0, _objectSpreadProps._)((0, _objectSpread._)({}, !this.props.isSearchable && (0, _platformFeatureFlags.fg)('platform_fix_autocomplete_aria_for_select') ? {} : {
            'aria-autocomplete': 'both'
        }), {
            'aria-errormessage': this.props['aria-errormessage'],
            'aria-expanded': menuIsOpen,
            // TODO: aria-haspopup is implied as listbox with role="combobox" and was deprecated for aria 1.2, we still might need to keep it for back compat
            'aria-haspopup': this.props['UNSAFE_is_experimental_generic'] ? 'dialog' : 'listbox',
            'aria-invalid': this.props['aria-invalid'] || isInvalid,
            'aria-label': this.props['aria-label'] || label,
            'aria-labelledby': this.props['aria-labelledby'] || labelId,
            'aria-required': required || isRequired,
            role: 'combobox',
            'aria-activedescendant': this.props['UNSAFE_is_experimental_generic'] ? undefined : this.state.focusedOptionId || this.state.focusedValueId || undefined
        }), menuIsOpen && {
            'aria-controls': this.getElementId('listbox')
        }, !isSearchable && !(0, _platformFeatureFlags.fg)('select_issearchable_aria-readonly_fix') && {
            'aria-readonly': true
        }, isDisabledA11yFixEnabled && {
            'aria-disabled': isDisabled || undefined
        }, this.calculateDescription());
        const effectiveTabIndex = isDisabledA11yFixEnabled && isDisabled ? -1 : tabIndex;
        if (!isSearchable) // use a dummy input to maintain focus/blur functionality
        return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _dummyInputDefault.default), (0, _objectSpread._)({
            id: id,
            innerRef: this.getInputRef,
            onBlur: this.onInputBlur,
            onChange: noop,
            onFocus: this.onInputFocus,
            disabled: isDisabled,
            tabIndex: effectiveTabIndex,
            inputMode: "none",
            form: form,
            value: "",
            "data-testid": testId && `${testId}-select--input`
        }, ariaAttributes));
        // NOTE: Don't add the `name` prop to this Input, `name` is already a prop on the hidden input element that has the value of the select.
        // Adding `name` to this Input will cause unexpected behavior.
        return /*#__PURE__*/ (0, _jsxRuntime.jsx)(Input, (0, _objectSpread._)((0, _objectSpreadProps._)((0, _objectSpread._)({}, commonProps), {
            autoCapitalize: "none",
            autoComplete: "off",
            autoCorrect: "off",
            id: id,
            testId: testId,
            innerRef: this.getInputRef,
            isDisabled: isDisabled,
            isHidden: inputIsHidden,
            onBlur: this.onInputBlur,
            onChange: this.handleInputChange,
            onFocus: this.onInputFocus,
            spellCheck: "false",
            tabIndex: effectiveTabIndex,
            form: form,
            type: "text",
            value: inputValue
        }), ariaAttributes));
    }
    renderPlaceholderOrValue() {
        const { MultiValue, MultiValueContainer, MultiValueLabel, MultiValueRemove, SingleValue, Placeholder } = this.getComponents();
        const { commonProps } = this;
        const { controlShouldRenderValue, isDisabled, isMulti, inputValue, placeholder, testId } = this.props;
        const { selectValue, focusedValue, isFocused } = this.state;
        if (!this.hasValue() || !controlShouldRenderValue) return inputValue ? null : /*#__PURE__*/ (0, _react.createElement)(Placeholder, (0, _objectSpreadProps._)((0, _objectSpread._)({}, commonProps), {
            key: "placeholder",
            isDisabled: isDisabled,
            isFocused: isFocused,
            innerProps: (0, _objectSpread._)({
                id: this.getElementId('placeholder')
            }, testId && {
                'data-testid': `${testId}-select--placeholder`
            })
        }), placeholder);
        if (isMulti) return selectValue.map((opt, index)=>{
            const isOptionFocused = opt === focusedValue;
            const key = `${this.getOptionLabel(opt)}-${this.getOptionValue(opt)}`;
            return /*#__PURE__*/ (0, _react.createElement)(MultiValue, (0, _objectSpreadProps._)((0, _objectSpread._)({}, commonProps), {
                components: {
                    Container: MultiValueContainer,
                    Label: MultiValueLabel,
                    Remove: MultiValueRemove
                },
                isFocused: isOptionFocused,
                isDisabled: isDisabled,
                key: key,
                index: index,
                removeProps: (0, _objectSpreadProps._)((0, _objectSpread._)({
                    onClick: ()=>this.removeValue(opt),
                    onTouchEnd: ()=>this.removeValue(opt),
                    onMouseDown: (e)=>{
                        e.preventDefault();
                    }
                }, testId && {
                    'data-testid': `${testId}-select--multivalue-${index}-remove`
                }), {
                    id: `${this.getElementId('selected-value')}-${index}-remove`
                }),
                data: opt,
                innerProps: (0, _objectSpreadProps._)((0, _objectSpread._)({}, testId && {
                    'data-testid': `${testId}-select--multivalue-${index}`
                }), {
                    id: `${this.getElementId('selected-value')}-${index}`
                })
            }), this.formatOptionLabel(opt, 'value'));
        });
        if (inputValue) return null;
        const singleValue = selectValue[0];
        return /*#__PURE__*/ (0, _jsxRuntime.jsx)(SingleValue, (0, _objectSpreadProps._)((0, _objectSpread._)({}, commonProps), {
            data: singleValue,
            isDisabled: isDisabled,
            innerProps: (0, _objectSpread._)({
                id: this.getElementId('single-value')
            }, isDisabled && (0, _platformFeatureFlags.fg)('platform_dst_select_disabled_a11y_fix') && {
                'aria-hidden': true
            }),
            children: this.formatOptionLabel(singleValue, 'value')
        }));
    }
    renderClearIndicator() {
        const { ClearIndicator } = this.getComponents();
        const { commonProps } = this;
        const { clearControlLabel, isDisabled, isLoading, spacing, testId } = this.props;
        const { isFocused } = this.state;
        if (!this.isClearable() || !ClearIndicator || isDisabled || !this.hasValue() || isLoading) return null;
        const innerProps = (0, _objectSpread._)({
            onMouseDown: this.onClearIndicatorMouseDown,
            onTouchEnd: this.onClearIndicatorTouchEnd
        }, testId && {
            'data-testid': `${testId}-select--clear-indicator`
        });
        const isCompact = spacing === 'compact';
        return /*#__PURE__*/ (0, _jsxRuntime.jsx)(ClearIndicator, (0, _objectSpreadProps._)((0, _objectSpread._)({
            clearControlLabel: clearControlLabel
        }, commonProps), {
            innerProps: innerProps,
            isFocused: isFocused,
            isCompact: isCompact
        }));
    }
    renderLoadingIndicator() {
        const { LoadingIndicator } = this.getComponents();
        const { commonProps } = this;
        const { isDisabled, isLoading, spacing, testId } = this.props;
        const { isFocused } = this.state;
        if (!LoadingIndicator || !isLoading) return null;
        const isCompact = spacing === 'compact';
        const innerProps = {
            'aria-hidden': 'true'
        };
        return /*#__PURE__*/ (0, _jsxRuntime.jsx)(LoadingIndicator, (0, _objectSpreadProps._)((0, _objectSpread._)({
            "data-testid": testId && `${testId}-select--loading-indicator`
        }, commonProps), {
            innerProps: innerProps,
            isDisabled: isDisabled,
            isFocused: isFocused,
            isCompact: isCompact
        }));
    }
    renderDropdownIndicator() {
        const { DropdownIndicator } = this.getComponents();
        if (!DropdownIndicator) return null;
        const { commonProps } = this;
        const { isDisabled, spacing, testId } = this.props;
        const { isFocused } = this.state;
        const isCompact = spacing === 'compact';
        const innerProps = (0, _objectSpread._)({
            onMouseDown: this.onDropdownIndicatorMouseDown,
            onTouchEnd: this.onDropdownIndicatorTouchEnd,
            // Always hidden: DropdownIndicator hoists aria-hidden onto consumer-supplied
            // children only, keeping the voice-control button visible to AT.
            'aria-hidden': 'true'
        }, testId && {
            'data-testid': `${testId}-select--dropdown-indicator`
        });
        return /*#__PURE__*/ (0, _jsxRuntime.jsx)(DropdownIndicator, (0, _objectSpreadProps._)((0, _objectSpread._)({}, commonProps), {
            innerProps: innerProps,
            isDisabled: isDisabled,
            isFocused: isFocused,
            isCompact: isCompact
        }));
    }
    renderMenu() {
        const { Group, GroupHeading, Menu, MenuList, MenuPortal, LoadingMessage, NoOptionsMessage, Option } = this.getComponents();
        const { commonProps } = this;
        const { focusedOption } = this.state;
        const { captureMenuScroll, inputValue, isLoading, loadingMessage, minMenuHeight, maxMenuHeight, menuIsOpen, menuPlacement, menuPosition, menuPortalTarget, menuShouldBlockScroll, menuShouldScrollIntoView, noOptionsMessage, onMenuScrollToTop, onMenuScrollToBottom, testId } = this.props;
        if (!menuIsOpen) return null;
        // TODO: Internal Option Type here
        const render = (props, id, headingId)=>{
            const { type, data, isDisabled, isSelected, label, value } = props;
            const isFocused = focusedOption === data;
            const onHover = isDisabled ? undefined : ()=>this.onOptionHover(data);
            const onSelect = isDisabled ? undefined : ()=>this.selectOption(data);
            const optionId = `${this.getElementId('option')}-${id}`;
            const innerProps = (0, _objectSpread._)({
                id: optionId,
                onClick: onSelect,
                onMouseMove: onHover,
                onMouseOver: onHover,
                role: this.props['UNSAFE_is_experimental_generic'] ? 'listitem' : 'option',
                'aria-selected': this.props['UNSAFE_is_experimental_generic'] ? undefined : isSelected,
                // We don't want aria-disabled if it's false. It's just noisy.
                'aria-disabled': !isDisabled ? undefined : isDisabled,
                'aria-describedby': headingId
            }, testId && {
                'data-testid': `${testId}-select--option-${id}`
            });
            return /*#__PURE__*/ (0, _react.createElement)(Option, (0, _objectSpreadProps._)((0, _objectSpread._)({}, commonProps), {
                innerProps: innerProps,
                data: data,
                isDisabled: isDisabled,
                isSelected: isSelected,
                key: optionId,
                label: label,
                type: type,
                value: value,
                isFocused: isFocused,
                innerRef: isFocused ? this.getFocusedOptionRef : undefined
            }), this.formatOptionLabel(props.data, 'menu'));
        };
        let menuUI;
        if (this.hasOptions()) {
            const items = this.getCategorizedOptions();
            menuUI = items.map((item)=>{
                if (item.type === 'group') {
                    const { data, options, index: groupIndex } = item;
                    const groupId = `${this.getElementId('group')}-${groupIndex}`;
                    const headingId = `${groupId}-heading`;
                    return /*#__PURE__*/ (0, _react.createElement)(Group, (0, _objectSpreadProps._)((0, _objectSpread._)({}, commonProps), {
                        key: groupId,
                        data: data,
                        options: options,
                        Heading: GroupHeading,
                        headingProps: (0, _objectSpread._)({
                            id: headingId,
                            data: item.data
                        }, testId && {
                            'data-testid': `${testId}-select--group-${groupIndex}-heading`
                        }),
                        label: this.formatGroupLabel(item.data)
                    }), item.options.map((option)=>render(option, `${groupIndex}-${option.index}`, headingId)));
                } else if (item.type === 'option') return render(item, `${item.index}`);
                return undefined;
            });
        } else if (isLoading) {
            const message = loadingMessage({
                inputValue
            });
            if (message === null) return null;
            menuUI = /*#__PURE__*/ (0, _jsxRuntime.jsx)(LoadingMessage, (0, _objectSpreadProps._)((0, _objectSpread._)({}, commonProps), {
                children: message
            }));
        } else {
            const message = noOptionsMessage({
                inputValue
            });
            if (message === null) return null;
            menuUI = /*#__PURE__*/ (0, _jsxRuntime.jsx)(NoOptionsMessage, (0, _objectSpreadProps._)((0, _objectSpread._)({}, commonProps), {
                innerProps: (0, _objectSpread._)({}, this.props['UNSAFE_is_experimental_generic'] && {
                    role: 'listitem'
                }, testId && {
                    'data-testid': `${testId}-select--no-options`
                }),
                children: message
            }));
        }
        const menuPlacementProps = {
            minMenuHeight,
            maxMenuHeight,
            menuPlacement,
            menuPosition,
            menuShouldScrollIntoView
        };
        const menuElement = /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _menuPlacerDefault.default), (0, _objectSpreadProps._)((0, _objectSpread._)({}, commonProps, menuPlacementProps), {
            children: ({ ref, placerProps: { placement, maxHeight } })=>/*#__PURE__*/ (0, _jsxRuntime.jsx)(Menu, (0, _objectSpreadProps._)((0, _objectSpread._)({}, commonProps, menuPlacementProps), {
                    innerRef: ref,
                    innerProps: (0, _objectSpread._)({
                        onMouseDown: this.onMenuMouseDown,
                        onMouseMove: this.onMenuMouseMove,
                        id: this.props.components.Menu ? this.getElementId('listbox') : undefined
                    }, testId && {
                        'data-testid': `${testId}-select--listbox-container`
                    }),
                    isLoading: isLoading,
                    placement: placement,
                    children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _scrollManagerDefault.default), {
                        captureEnabled: captureMenuScroll,
                        onTopArrive: onMenuScrollToTop,
                        onBottomArrive: onMenuScrollToBottom,
                        lockEnabled: menuShouldBlockScroll,
                        children: (scrollTargetRef)=>{
                            var _this_inputRef, _this_inputRef1;
                            return /*#__PURE__*/ (0, _jsxRuntime.jsx)(MenuList, (0, _objectSpreadProps._)((0, _objectSpread._)({}, commonProps), {
                                innerRef: (instance)=>{
                                    this.getMenuListRef(instance);
                                    scrollTargetRef(instance);
                                },
                                innerProps: (0, _objectSpread._)((0, _objectSpreadProps._)((0, _objectSpread._)({
                                    role: this.props['UNSAFE_is_experimental_generic'] ? 'dialog' : 'listbox'
                                }, this.props['UNSAFE_is_experimental_generic'] && {
                                    'aria-labelledby': ((_this_inputRef = this.inputRef) === null || _this_inputRef === void 0 ? void 0 : _this_inputRef.id) || this.getElementId('input')
                                }), {
                                    'aria-multiselectable': !commonProps.isMulti || this.props['UNSAFE_is_experimental_generic'] ? undefined : commonProps.isMulti,
                                    id: this.getElementId('listbox')
                                }), testId && {
                                    'data-testid': `${testId}-select--listbox`
                                }, (0, _isSafari.isSafari)() && !this.props['UNSAFE_is_experimental_generic'] && {
                                    'aria-describedby': ((_this_inputRef1 = this.inputRef) === null || _this_inputRef1 === void 0 ? void 0 : _this_inputRef1.id) || this.getElementId('input')
                                }),
                                isLoading: isLoading,
                                maxHeight: maxHeight,
                                focusedOption: focusedOption,
                                children: this.props['UNSAFE_is_experimental_generic'] ? /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                    role: "list",
                                    children: menuUI
                                }) : menuUI
                            }));
                        }
                    })
                }))
        }));
        // On the top-layer path the menu always portals (into the top layer)
        // regardless of consumer `menuPortalTarget` / `menuPosition`. Off the
        // flag we keep the legacy "portal only when needed" behaviour.
        const shouldPortal = (0, _platformFeatureFlags.fg)('platform-dst-top-layer') || menuPortalTarget || menuPosition === 'fixed';
        if (!shouldPortal) return menuElement;
        // Top-layer path needs the state mirror so MenuPortalTopLayer re-renders
        // when the anchor attaches; legacy path keeps the direct ref read.
        const controlElementForPortal = (0, _platformFeatureFlags.fg)('platform-dst-top-layer') ? this.state.controlElement : this.controlRef;
        const menuPortal = /*#__PURE__*/ (0, _jsxRuntime.jsx)(MenuPortal, (0, _objectSpreadProps._)((0, _objectSpread._)({}, commonProps), {
            appendTo: menuPortalTarget,
            controlElement: controlElementForPortal,
            menuPlacement: menuPlacement,
            menuPosition: menuPosition,
            children: menuElement
        }));
        // The Provider plumbs the close signal to MenuPortalTopLayer; not
        // needed on the legacy path.
        if (!(0, _platformFeatureFlags.fg)('platform-dst-top-layer')) return menuPortal;
        return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _menuPortalCloseContext.MenuPortalCloseContext).Provider, {
            value: this.handleOpenLayerObserverCloseSignal,
            children: menuPortal
        });
    }
    renderFormField() {
        const { delimiter, isDisabled, isMulti, required, name } = this.props;
        const { selectValue } = this.state;
        if (required && !this.hasValue() && !isDisabled) return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _requiredInputDefault.default), {
            name: name,
            onFocus: this.onValueInputFocus
        });
        if (!name || isDisabled) return;
        if (isMulti) {
            if (delimiter) {
                const value = selectValue.map((opt)=>this.getOptionValue(opt)).join(delimiter);
                return /*#__PURE__*/ (0, _jsxRuntime.jsx)("input", {
                    name: name,
                    type: "hidden",
                    value: value
                });
            } else {
                const input = selectValue.length > 0 ? selectValue.map((opt, i)=>/*#__PURE__*/ (0, _jsxRuntime.jsx)("input", {
                        name: name,
                        type: "hidden",
                        value: this.getOptionValue(opt)
                    }, `i-${i}`)) : /*#__PURE__*/ (0, _jsxRuntime.jsx)("input", {
                    name: name,
                    type: "hidden",
                    value: ""
                });
                return /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                    children: input
                });
            }
        } else {
            const value = selectValue[0] ? this.getOptionValue(selectValue[0]) : '';
            return /*#__PURE__*/ (0, _jsxRuntime.jsx)("input", {
                name: name,
                type: "hidden",
                value: value
            });
        }
    }
    renderLiveRegion() {
        const { commonProps } = this;
        const { ariaSelection, isFocused, selectValue } = this.state;
        const focusableOptions = this.getFocusableOptions();
        return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _liveRegionDefault.default), (0, _objectSpreadProps._)((0, _objectSpread._)({}, commonProps), {
            id: this.getElementId('live-region'),
            ariaSelection: ariaSelection,
            isFocused: isFocused,
            selectValue: selectValue,
            focusableOptions: focusableOptions
        }));
    }
    renderMultiselectMessage() {
        // In the future, when we actually support touch devices, we'll need to update this to not be keyboard specific.
        // Also, since this is rendered onscreen, it should be transtlated automatically.
        const msg = `, multiple selections available, ${this.state.selectValue.length ? 'Use left or right arrow keys to navigate selected items' : ''}`;
        return(// eslint-disable-next-line @atlaskit/design-system/use-primitives-text
        /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
            id: this.getElementId('multi-message'),
            hidden: true,
            children: msg
        }));
    }
    render() {
        const { Control, IndicatorsContainer, SelectContainer, ValueContainer } = this.getComponents();
        const { className, id, isDisabled, menuIsOpen, isInvalid, testId, appearance = 'default', spacing = 'default' } = this.props;
        const { isFocused } = this.state;
        const commonProps = this.commonProps = this.getCommonProps();
        const isCompact = spacing === 'compact';
        return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _selectGetStylesContext.SelectGetStylesContext).Provider, {
            value: this.getStyles,
            children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)(SelectContainer, (0, _objectSpreadProps._)((0, _objectSpread._)({}, commonProps), {
                // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop
                className: className,
                innerProps: (0, _objectSpread._)({
                    id: id,
                    onKeyDown: this.onKeyDown
                }, testId && {
                    'data-testid': testId && `${testId}-select--container`
                }),
                isDisabled: isDisabled,
                isFocused: isFocused,
                children: [
                    this.renderLiveRegion(),
                    commonProps.isMulti && this.renderMultiselectMessage(),
                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)(Control, (0, _objectSpreadProps._)((0, _objectSpread._)({}, commonProps), {
                        innerRef: this.getControlRef,
                        innerProps: (0, _objectSpread._)({
                            onMouseDown: this.onControlMouseDown,
                            onTouchEnd: this.onControlTouchEnd
                        }, testId && {
                            'data-testid': `${testId}-select--control`
                        }),
                        appearance: appearance,
                        isInvalid: isInvalid,
                        isDisabled: isDisabled,
                        isFocused: isFocused,
                        menuIsOpen: menuIsOpen,
                        isCompact: isCompact,
                        children: [
                            /*#__PURE__*/ (0, _jsxRuntime.jsxs)(ValueContainer, (0, _objectSpreadProps._)((0, _objectSpread._)({}, commonProps), {
                                isDisabled: isDisabled,
                                isCompact: isCompact,
                                innerProps: (0, _objectSpread._)({}, testId && {
                                    'data-testid': `${testId}-select--value-container`
                                }, commonProps.isMulti && commonProps.hasValue && !(0, _deviceCheck.isAppleDevice)() && {
                                    // Required to keep JAWS from popping out of forms mode when using LEFT/RIGHT arrow keys.
                                    // This is Jedi Master level ARIA and not taken lightly. Do not modify without consulting
                                    // DST Accessibility.
                                    role: 'application'
                                }),
                                children: [
                                    this.renderPlaceholderOrValue(),
                                    this.renderInput()
                                ]
                            })),
                            /*#__PURE__*/ (0, _jsxRuntime.jsxs)(IndicatorsContainer, (0, _objectSpreadProps._)((0, _objectSpread._)({}, commonProps), {
                                isDisabled: isDisabled,
                                innerProps: (0, _objectSpread._)({}, testId && {
                                    'data-testid': `${testId}-select--indicators-container`
                                }),
                                children: [
                                    this.renderClearIndicator(),
                                    this.renderLoadingIndicator(),
                                    this.renderDropdownIndicator()
                                ]
                            }))
                        ]
                    })),
                    this.renderMenu(),
                    this.renderFormField(),
                    !(0, _platformFeatureFlags.fg)('platform-dst-top-layer') && /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _notifyOpenLayerObserver.NotifyOpenLayerObserver), {
                        isOpen: this.props.menuIsOpen,
                        onClose: this.handleOpenLayerObserverCloseSignal
                    })
                ]
            }))
        });
    }
    // Lifecycle
    // ------------------------------
    constructor(props){
        super(props), this.state = {
            ariaSelection: null,
            focusedOption: null,
            focusedOptionId: null,
            focusableOptionsWithIds: [],
            focusedValue: null,
            focusedValueId: null,
            inputIsHidden: false,
            isFocused: false,
            selectValue: [],
            clearFocusValueOnUpdate: false,
            prevWasFocused: false,
            inputIsHiddenAfterUpdate: undefined,
            prevProps: undefined,
            instancePrefix: '',
            controlElement: null
        }, // Misc. Instance Properties
        // ------------------------------
        this.blockOptionHover = false, this.isComposing = false, this.initialTouchX = 0, this.initialTouchY = 0, this.openAfterFocus = false, this.scrollToFocusedOptionOnUpdate = false, // Cleanup for a pending document `pointerup` listener registered by
        // `openMenuAfterPointerUp`. See that method for the full rationale.
        this.deferredOpenMenuCleanup = null, // Refs
        // ------------------------------
        this.controlRef = null, this.getControlRef = (ref)=>{
            this.controlRef = ref;
            // Mirror the ref into state on the top-layer path so
            // `MenuPortalTopLayer`'s layout effects react to the anchor attaching.
            // Skip the null-ref (unmount) case: setState during unmount is unsafe
            // and the state is dropped with the instance anyway.
            if (ref === null) return;
            if (this.state.controlElement !== ref && (0, _platformFeatureFlags.fg)('platform-dst-top-layer')) this.setState({
                controlElement: ref
            });
        }, this.focusedOptionRef = null, this.getFocusedOptionRef = (ref)=>{
            this.focusedOptionRef = ref;
        }, this.menuListRef = null, this.getMenuListRef = (ref)=>{
            this.menuListRef = ref;
        }, this.inputRef = null, this.getInputRef = (ref)=>{
            this.inputRef = ref;
        }, // aliased for consumers
        this.focus = this.focusInput, this.blur = this.blurInput, this.onChange = (newValue, actionMeta)=>{
            const { onChange, name } = this.props;
            actionMeta.name = name;
            this.ariaOnChange(newValue, actionMeta);
            onChange(newValue, actionMeta);
        }, this.setValue = (newValue, action, option)=>{
            const { closeMenuOnSelect, isMulti, inputValue } = this.props;
            this.onInputChange('', {
                action: 'set-value',
                prevInputValue: inputValue
            });
            if (closeMenuOnSelect) {
                this.setState({
                    inputIsHiddenAfterUpdate: !isMulti
                });
                this.onMenuClose();
            }
            // when the select value should change, we should reset focusedValue
            this.setState({
                clearFocusValueOnUpdate: true
            });
            this.onChange(newValue, {
                action,
                option
            });
        }, this.selectOption = (newValue)=>{
            const { blurInputOnSelect, isMulti, name } = this.props;
            const { selectValue } = this.state;
            const deselected = isMulti && this.isOptionSelected(newValue, selectValue);
            const isDisabled = this.isOptionDisabled(newValue, selectValue);
            if (deselected) {
                const candidate = this.getOptionValue(newValue);
                this.setValue((0, _multiValueAsValue.multiValueAsValue)(selectValue.filter((i)=>this.getOptionValue(i) !== candidate)), 'deselect-option', newValue);
            } else if (!isDisabled) {
                // Select option if option is not disabled
                if (isMulti) this.setValue((0, _multiValueAsValue.multiValueAsValue)([
                    ...selectValue,
                    newValue
                ]), 'select-option', newValue);
                else this.setValue((0, _singleValueAsValue.singleValueAsValue)(newValue), 'select-option');
            } else {
                this.ariaOnChange((0, _singleValueAsValue.singleValueAsValue)(newValue), {
                    action: 'select-option',
                    option: newValue,
                    name
                });
                return;
            }
            if (blurInputOnSelect) this.blurInput();
        }, this.removeValue = (removedValue)=>{
            const { isMulti } = this.props;
            const { selectValue } = this.state;
            const candidate = this.getOptionValue(removedValue);
            const newValueArray = selectValue.filter((i)=>this.getOptionValue(i) !== candidate);
            const newValue = (0, _valueTernary.valueTernary)(isMulti, newValueArray, newValueArray[0] || null);
            this.onChange(newValue, {
                action: 'remove-value',
                removedValue
            });
            this.focusInput();
        }, this.clearValue = ()=>{
            const { selectValue } = this.state;
            this.onChange((0, _valueTernary.valueTernary)(this.props.isMulti, [], null), {
                action: 'clear',
                removedValues: selectValue
            });
        }, this.popValue = ()=>{
            const { isMulti } = this.props;
            const { selectValue } = this.state;
            const lastSelectedValue = selectValue[selectValue.length - 1];
            const newValueArray = selectValue.slice(0, selectValue.length - 1);
            const newValue = (0, _valueTernary.valueTernary)(isMulti, newValueArray, newValueArray[0] || null);
            this.onChange(newValue, {
                action: 'pop-value',
                removedValue: lastSelectedValue
            });
        }, // ==============================
        // Getters
        // ==============================
        this.getFocusedOptionId = (focusedOption)=>{
            return getFocusedOptionId(this.state.focusableOptionsWithIds, focusedOption);
        }, this.getFocusableOptionsWithIds = ()=>{
            return buildFocusableOptionsWithIds(buildCategorizedOptions(this.props, this.state.selectValue), this.getElementId('option'));
        }, this.getValue = ()=>this.state.selectValue, this.cx = (...args)=>(0, _classnames.classNames)(this.props.classNamePrefix, ...args), this.getOptionLabel = (data)=>{
            return getOptionLabel(this.props, data);
        }, this.getOptionValue = (data)=>{
            return getOptionValue(this.props, data);
        }, this.getStyles = (key, props)=>{
            const base = {
                boxSizing: 'border-box'
            };
            const custom = this.props.styles[key];
            if (custom) return filterUnsupportedSelectors(custom(base, props));
            return base;
        }, this.getClassNames = (key, props)=>{
            var _this_props_classNames_key, _this_props_classNames;
            return (_this_props_classNames_key = (_this_props_classNames = this.props.classNames)[key]) === null || _this_props_classNames_key === void 0 ? void 0 : _this_props_classNames_key.call(_this_props_classNames, props);
        }, this.getElementId = (element)=>{
            return `${this.state.instancePrefix}-${element}`;
        }, this.getComponents = ()=>{
            return (0, _components.defaultComponents)(this.props);
        }, this.buildCategorizedOptions = ()=>buildCategorizedOptions(this.props, this.state.selectValue), this.getCategorizedOptions = ()=>this.props.menuIsOpen ? this.buildCategorizedOptions() : [], this.buildFocusableOptions = ()=>buildFocusableOptionsFromCategorizedOptions(this.buildCategorizedOptions()), this.getFocusableOptions = ()=>this.props.menuIsOpen ? this.buildFocusableOptions() : [], // ==============================
        // Helpers
        // ==============================
        this.ariaOnChange = (value, actionMeta)=>{
            this.setState({
                ariaSelection: (0, _objectSpread._)({
                    value
                }, actionMeta)
            });
        }, // ==============================
        // Mouse Handlers
        // ==============================
        this.onMenuMouseDown = (event)=>{
            if (event.button !== 0) return;
            event.stopPropagation();
            event.preventDefault();
            this.focusInput();
        }, this.onMenuMouseMove = (_)=>{
            this.blockOptionHover = false;
        }, this.onControlMouseDown = (event)=>{
            // Event captured by dropdown indicator
            if (event.defaultPrevented) {
                var _this_controlRef;
                // react-dnd will fire preventDefault in mouseDown, which make select is not clickable.
                // temp workaround to check if select is within dnd, we don't do the early return.
                if (!((_this_controlRef = this.controlRef) === null || _this_controlRef === void 0 ? void 0 : _this_controlRef.closest('[data-rbd-draggable-context-id]'))) return;
            }
            const { openMenuOnClick } = this.props;
            if (!this.state.isFocused) {
                if (openMenuOnClick) this.openAfterFocus = true;
                this.focusInput();
            } else if (!this.props.menuIsOpen) {
                if (openMenuOnClick) this.openMenuAfterPointerUp('first');
            } else if (event.target.tagName !== 'INPUT' && event.target.tagName !== 'TEXTAREA') this.onMenuClose();
            if (event.target.tagName !== 'INPUT' && event.target.tagName !== 'TEXTAREA') event.preventDefault();
        }, this.onDropdownIndicatorMouseDown = (event)=>{
            // ignore mouse events that weren't triggered by the primary button
            if (event && event.type === 'mousedown' && event.button !== 0) return;
            if (this.props.isDisabled) return;
            const { isMulti, menuIsOpen } = this.props;
            this.focusInput();
            if (menuIsOpen) {
                this.setState({
                    inputIsHiddenAfterUpdate: !isMulti
                });
                this.onMenuClose();
            } else this.openMenuAfterPointerUp('first');
            event.preventDefault();
        }, this.onClearIndicatorMouseDown = (event)=>{
            // ignore mouse events that weren't triggered by the primary button
            if (event && event.type === 'mousedown' && event.button !== 0) return;
            this.clearValue();
            event.preventDefault();
            this.openAfterFocus = false;
            if (event.type === 'touchend') this.focusInput();
            else setTimeout(()=>this.focusInput());
        }, this.onScroll = (event)=>{
            if (typeof this.props.closeMenuOnScroll === 'boolean') {
                if (event.target instanceof HTMLElement && (0, _isDocumentEl.isDocumentElement)(event.target)) this.props.onMenuClose();
            } else if (typeof this.props.closeMenuOnScroll === 'function') {
                if (this.props.closeMenuOnScroll(event)) this.props.onMenuClose();
            }
        }, this.onCompositionStart = ()=>{
            this.isComposing = true;
        }, this.onCompositionEnd = ()=>{
            this.isComposing = false;
        }, this.onTouchStart = ({ touches })=>{
            const touch = touches && touches.item(0);
            if (!touch) return;
            this.initialTouchX = touch.clientX;
            this.initialTouchY = touch.clientY;
            this.userIsDragging = false;
        }, this.onTouchMove = ({ touches })=>{
            const touch = touches && touches.item(0);
            if (!touch) return;
            const deltaX = Math.abs(touch.clientX - this.initialTouchX);
            const deltaY = Math.abs(touch.clientY - this.initialTouchY);
            const moveThreshold = 5;
            this.userIsDragging = deltaX > moveThreshold || deltaY > moveThreshold;
        }, this.onTouchEnd = (event)=>{
            if (this.userIsDragging) return;
            // close the menu if the user taps outside
            // we're checking on event.target here instead of event.currentTarget, because we want to assert information
            // on events on child elements, not the document (which we've attached this handler to).
            if (this.controlRef && !this.controlRef.contains(event.target) && this.menuListRef && !this.menuListRef.contains(event.target)) this.blurInput();
            // reset move vars
            this.initialTouchX = 0;
            this.initialTouchY = 0;
        }, this.onControlTouchEnd = (event)=>{
            if (this.userIsDragging) return;
            this.onControlMouseDown(event);
        }, this.onClearIndicatorTouchEnd = (event)=>{
            if (this.userIsDragging) return;
            this.onClearIndicatorMouseDown(event);
        }, this.onDropdownIndicatorTouchEnd = (event)=>{
            if (this.userIsDragging) return;
            this.onDropdownIndicatorMouseDown(event);
        }, // ==============================
        // Focus Handlers
        // ==============================
        this.handleInputChange = (event)=>{
            const { inputValue: prevInputValue } = this.props;
            const inputValue = event.currentTarget.value;
            this.setState({
                inputIsHiddenAfterUpdate: false
            });
            this.onInputChange(inputValue, {
                action: 'input-change',
                prevInputValue
            });
            if (!this.props.menuIsOpen) this.onMenuOpen();
        }, this.onInputFocus = (event)=>{
            if (this.props.onFocus) this.props.onFocus(event);
            this.setState({
                inputIsHiddenAfterUpdate: false,
                isFocused: true
            });
            if (this.openAfterFocus || this.props.openMenuOnFocus) {
                // `openAfterFocus` always follows a pointer gesture, so defer past
                // pointerup. `openMenuOnFocus` alone can come from a keyboard tab
                // with no pointer gesture in flight, so open synchronously.
                if (this.openAfterFocus) this.openMenuAfterPointerUp('first');
                else this.openMenu('first');
            }
            this.openAfterFocus = false;
        }, this.onInputBlur = (event)=>{
            const { inputValue: prevInputValue } = this.props;
            if (this.menuListRef && this.menuListRef.contains(document.activeElement)) {
                this.inputRef.focus();
                return;
            }
            if (this.props.onBlur) this.props.onBlur(event);
            this.onInputChange('', {
                action: 'input-blur',
                prevInputValue
            });
            if ((0, _platformFeatureFlags.fg)('platform_dst_select_menu_close_on_blur')) // when fg is enabled, we only call onMenuClose when this.props.menuIsOpen is true.
            this.props.menuIsOpen && this.onMenuClose();
            else this.onMenuClose();
            this.setState({
                focusedValue: null,
                isFocused: false
            });
        }, this.onOptionHover = (focusedOption)=>{
            if (this.blockOptionHover || this.state.focusedOption === focusedOption) return;
            const options = this.getFocusableOptions();
            const focusedOptionIndex = options.indexOf(focusedOption);
            this.setState({
                focusedOption,
                focusedOptionId: focusedOptionIndex > -1 ? this.getFocusedOptionId(focusedOption) : null
            });
        }, this.shouldHideSelectedOptions = ()=>{
            return shouldHideSelectedOptions(this.props);
        }, // If the hidden input gets focus through form submit,
        // redirect focus to focusable input.
        this.onValueInputFocus = (e)=>{
            e.preventDefault();
            e.stopPropagation();
            this.focus();
        }, // ==============================
        // Keyboard Handlers
        // ==============================
        this.onKeyDown = (event)=>{
            const { isMulti, backspaceRemovesValue, escapeClearsValue, inputValue, isClearable, isDisabled, menuIsOpen, onKeyDown, tabSelectsValue, openMenuOnFocus, shouldPreventEscapePropagation } = this.props;
            const { focusedOption, focusedValue, selectValue } = this.state;
            if (isDisabled) return;
            if (typeof onKeyDown === 'function') {
                onKeyDown(event);
                if (event.defaultPrevented) return;
            }
            // Block option hover events when the user has just pressed a key
            this.blockOptionHover = true;
            switch(event.key){
                case 'ArrowLeft':
                    if (!isMulti || inputValue) return;
                    this.focusValue('previous');
                    break;
                case 'ArrowRight':
                    if (!isMulti || inputValue) return;
                    this.focusValue('next');
                    break;
                case 'Delete':
                case 'Backspace':
                    if (inputValue) return;
                    if (focusedValue) this.removeValue(focusedValue);
                    else {
                        if (!backspaceRemovesValue) return;
                        if (isMulti) this.popValue();
                        else if (isClearable) this.clearValue();
                    }
                    break;
                case 'Tab':
                    if (this.isComposing) return;
                    if (event.shiftKey || !menuIsOpen || !tabSelectsValue || !focusedOption || // don't capture the event if the menu opens on focus and the focused
                    // option is already selected; it breaks the flow of navigation
                    openMenuOnFocus && this.isOptionSelected(focusedOption, selectValue)) return;
                    this.selectOption(focusedOption);
                    break;
                case 'Enter':
                    if (event.keyCode === 229) break;
                    if (focusedValue) this.removeValue(focusedValue);
                    if (menuIsOpen) {
                        if (!focusedOption) return;
                        if (this.isComposing) return;
                        this.selectOption(focusedOption);
                        break;
                    }
                    return;
                case 'Escape':
                    if (menuIsOpen) {
                        this.setState({
                            inputIsHiddenAfterUpdate: false
                        });
                        this.onInputChange('', {
                            action: 'menu-close',
                            prevInputValue: inputValue
                        });
                        this.onMenuClose();
                        if (shouldPreventEscapePropagation && event.target instanceof HTMLElement) event.stopPropagation();
                    } else if (isClearable && escapeClearsValue) this.clearValue();
                    break;
                case ' ':
                    // space
                    if (inputValue) return;
                    if (!menuIsOpen) {
                        this.openMenu('first');
                        break;
                    }
                    if (!focusedOption) return;
                    this.selectOption(focusedOption);
                    break;
                case 'ArrowUp':
                    if (menuIsOpen) this.focusOption('up');
                    else this.openMenu('last');
                    break;
                case 'ArrowDown':
                    if (menuIsOpen) this.focusOption('down');
                    else this.openMenu('first');
                    break;
                case 'PageUp':
                    if (!menuIsOpen) return;
                    this.focusOption('pageup');
                    break;
                case 'PageDown':
                    if (!menuIsOpen) return;
                    this.focusOption('pagedown');
                    break;
                case 'Home':
                    if (!menuIsOpen) return;
                    this.focusOption('first');
                    break;
                case 'End':
                    if (!menuIsOpen) return;
                    this.focusOption('last');
                    break;
                default:
                    return;
            }
            event.preventDefault();
        }, this.handleOpenLayerObserverCloseSignal = ()=>{
            this.onMenuClose();
        };
        this.state.instancePrefix = 'react-select-' + (this.props.instanceId || ++instanceId);
        this.state.selectValue = (0, _cleanValue.cleanValue)(props.value);
        // Set focusedOption if menuIsOpen is set on init (e.g. defaultMenuIsOpen)
        if (props.menuIsOpen) {
            const focusableOptionsWithIds = this.getFocusableOptionsWithIds();
            const focusableOptions = this.buildFocusableOptions();
            const optionIndex = focusableOptions.indexOf(this.state.selectValue[0]);
            this.state.focusableOptionsWithIds = focusableOptionsWithIds;
            this.state.focusedOption = focusableOptions[optionIndex];
            this.state.focusedOptionId = getFocusedOptionId(focusableOptionsWithIds, focusableOptions[optionIndex]);
        }
    }
}
Select.defaultProps = defaultProps;

},{"@swc/helpers/_/_object_spread":"9gdrV","@swc/helpers/_/_object_spread_props":"kANqQ","react/jsx-runtime":"bGvcw","react":"ltHCL","@compiled/react/runtime":"d27Vo","bind-event-listener":"bjeUU","@atlaskit/ds-lib/device-check":"cKxaO","@atlaskit/ds-lib/is-safari":"kZLd6","@atlaskit/ds-lib/noop":"faKzG","@atlaskit/platform-feature-flags":"8rD2i","./builtins":"bdn6g","./components":"9ys8n","./components/dummy-input":"d4SHn","./components/live-region":"74mRn","./components/menu-placer":"6NzNr","./filters":"2zLE8","./internal/classnames":"2SKnP","./internal/clean-value":"e9zUf","./internal/is-document-el":"inWXg","./internal/menu-portal-close-context":"2USlA","./internal/multi-value-as-value":"4OZ1n","./internal/notify-open-layer-observer":"a63Ux","./internal/required-input":"jYwC6","./internal/scroll-manager":"12bov","./internal/scroll-to":"6MRkP","./internal/select-get-styles-context":"c3wCO","./internal/single-value-as-value":"g3Idb","./internal/value-ternary":"6u29O","@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"cKxaO":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "isAppleDevice", ()=>isAppleDevice);
function testPlatform(re) {
    var _window_navigator_userAgentData;
    return typeof window !== 'undefined' && window.navigator != null ? re.test(((_window_navigator_userAgentData = window.navigator['userAgentData']) === null || _window_navigator_userAgentData === void 0 ? void 0 : _window_navigator_userAgentData.platform) || window.navigator.platform) : false;
}
function isIPhone() {
    return testPlatform(/^iPhone/i);
}
function isIPad() {
    return testPlatform(/^iPad/i) || // iPadOS 13 lies and says it's a Mac, but we can distinguish by detecting touch support.
    isMac() && navigator.maxTouchPoints > 1;
}
function isMac() {
    return testPlatform(/^Mac/i);
}
function isIOS() {
    return isIPhone() || isIPad();
}
function isAppleDevice() {
    return isMac() || isIOS();
}

},{"@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"bdn6g":[function(require,module,exports,__globalThis) {
/* eslint-disable @repo/internal/fs/filename-pattern-match */ var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "formatGroupLabel", ()=>(0, _formatGroupLabel.formatGroupLabel));
parcelHelpers.export(exports, "getOptionLabel", ()=>(0, _getOptionLabel.getOptionLabel));
parcelHelpers.export(exports, "getOptionValue", ()=>(0, _getOptionValue.getOptionValue));
parcelHelpers.export(exports, "isOptionDisabled", ()=>(0, _isOptionDisabled.isOptionDisabled));
var _formatGroupLabel = require("./format-group-label");
var _getOptionLabel = require("./get-option-label");
var _getOptionValue = require("./get-option-value");
var _isOptionDisabled = require("./is-option-disabled");

},{"./format-group-label":"hv5z7","./get-option-label":"5jzRx","./get-option-value":"kRfM1","./is-option-disabled":"aE1Nq","@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"hv5z7":[function(require,module,exports,__globalThis) {
/* eslint-disable @repo/internal/fs/filename-pattern-match */ var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "formatGroupLabel", ()=>formatGroupLabel);
const formatGroupLabel = (group)=>group.label;

},{"@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"5jzRx":[function(require,module,exports,__globalThis) {
/* eslint-disable @repo/internal/fs/filename-pattern-match */ var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "getOptionLabel", ()=>getOptionLabel);
const getOptionLabel = (option)=>option.label;

},{"@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"kRfM1":[function(require,module,exports,__globalThis) {
/* eslint-disable @repo/internal/fs/filename-pattern-match */ var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "getOptionValue", ()=>getOptionValue);
const getOptionValue = (option)=>option.value;

},{"@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"aE1Nq":[function(require,module,exports,__globalThis) {
/* eslint-disable @repo/internal/fs/filename-pattern-match */ var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "isOptionDisabled", ()=>isOptionDisabled);
const isOptionDisabled = (option)=>!!option.isDisabled;

},{"@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"d4SHn":[function(require,module,exports,__globalThis) {
/* dummy-input.tsx generated by @compiled/babel-plugin v0.39.1 */ var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>DummyInput);
var _objectSpread = require("@swc/helpers/_/_object_spread");
var _objectWithoutProperties = require("@swc/helpers/_/_object_without_properties");
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _runtime = require("@compiled/react/runtime");
const removeProps = (propsObj, ...properties)=>{
    let propsMap = Object.entries(propsObj).filter(([key])=>!properties.includes(key));
    return propsMap.reduce((newProps, [key, val])=>{
        newProps[key] = val;
        return newProps;
    }, {});
};
const dummyInputStyles = null;
function DummyInput(_param) {
    var { innerRef } = _param, props = (0, _objectWithoutProperties._)(_param, [
        "innerRef"
    ]);
    // Remove animation props not meant for HTML elements
    const filteredProps = removeProps(props, 'onExited', 'in', 'enter', 'exit', 'appear');
    // eslint-disable-next-line  @atlaskit/ui-styling-standard/no-classname-prop
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)("input", (0, _objectSpread._)({
        ref: innerRef,
        className: (0, _runtime.ax)([
            "_ca0qidpf _u5f3idpf _n3tdidpf _19bvidpf _11q7idpf _19itidpf _nd5l1sux _12ji1r31 _1qu2glyw _12y3idpf _1bsbt94y _kqswh2mm _1n5d1j28 _syaz1j28 _1e02p1rm _tzy4idpf _t9ec1kuz",
            "-dummyInput"
        ])
    }, filteredProps));
}

},{"@swc/helpers/_/_object_spread":"9gdrV","@swc/helpers/_/_object_without_properties":"6HqIM","react/jsx-runtime":"bGvcw","react":"ltHCL","@compiled/react/runtime":"d27Vo","@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"74mRn":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _objectSpread = require("@swc/helpers/_/_object_spread");
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _accessibility = require("../accessibility");
var _a11YText = require("../internal/a11y-text");
var _a11YTextDefault = parcelHelpers.interopDefault(_a11YText);
const LiveRegion = (props)=>{
    const { ariaSelection, focusableOptions, isFocused, selectValue, selectProps, id } = props;
    const { ariaLiveMessages, getOptionLabel, inputValue, isOptionDisabled, menuIsOpen, options, screenReaderStatus, isLoading } = selectProps;
    const ariaLive = selectProps['aria-live'];
    // Update aria live message configuration when prop changes
    const messages = (0, _react.useMemo)(()=>(0, _objectSpread._)({}, (0, _accessibility.defaultAriaLiveMessages), ariaLiveMessages), [
        ariaLiveMessages
    ]);
    // Update aria live selected option when prop changes
    const ariaSelected = (0, _react.useMemo)(()=>{
        let message = '';
        if (menuIsOpen) // we don't need to have selected message when the menu is open
        return '';
        if (ariaSelection && messages.onChange) {
            const { option, options: selectedOptions, removedValue, removedValues, value } = ariaSelection;
            // select-option when !isMulti does not return option so we assume selected option is value
            const asOption = (val)=>!Array.isArray(val) ? val : null;
            // If there is just one item from the action then get its label
            const selected = removedValue || option || asOption(value);
            const label = selected ? getOptionLabel(selected) : '';
            // If there are multiple items from the action then return an array of labels
            const multiSelected = selectedOptions || removedValues || undefined;
            const labels = multiSelected ? multiSelected.map(getOptionLabel) : [];
            if (!label && !labels.length) // return empty string if no labels provided
            return '';
            const onChangeProps = (0, _objectSpread._)({
                // multiSelected items are usually items that have already been selected
                // or set by the user as a default value so we assume they are not disabled
                isDisabled: selected && isOptionDisabled(selected, selectValue),
                label,
                labels
            }, ariaSelection);
            message = messages.onChange(onChangeProps);
        }
        return message;
    }, [
        ariaSelection,
        messages,
        isOptionDisabled,
        selectValue,
        getOptionLabel,
        menuIsOpen
    ]);
    const ariaResults = (0, _react.useMemo)(()=>{
        let resultsMsg = '';
        if (isLoading) resultsMsg = 'Loading. ';
        if (menuIsOpen && options.length && !isLoading && messages.onFilter) {
            const resultsMessage = screenReaderStatus({
                count: focusableOptions.length
            });
            resultsMsg = messages.onFilter({
                inputValue,
                resultsMessage
            });
        }
        if (options && options.length === 0) resultsMsg = 'No options. ';
        return resultsMsg;
    }, [
        focusableOptions,
        inputValue,
        menuIsOpen,
        messages,
        options,
        screenReaderStatus,
        isLoading
    ]);
    const isInitialFocus = (ariaSelection === null || ariaSelection === void 0 ? void 0 : ariaSelection.action) === 'initial-input-focus';
    const ScreenReaderText = /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _react.Fragment), {
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                id: "aria-selection",
                children: ariaSelected
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                id: "aria-results",
                children: ariaResults
            })
        ]
    });
    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _react.Fragment), {
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _a11YTextDefault.default), {
                id: id,
                children: isInitialFocus && ScreenReaderText
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _a11YTextDefault.default), {
                "aria-live": ariaLive,
                role: "status",
                children: isFocused && !isInitialFocus && ScreenReaderText
            })
        ]
    });
};
// eslint-disable-next-line @repo/internal/react/require-jsdoc
exports.default = LiveRegion;

},{"@swc/helpers/_/_object_spread":"9gdrV","react/jsx-runtime":"bGvcw","react":"ltHCL","../accessibility":"gP7Yc","../internal/a11y-text":"b9Z1m","@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"gP7Yc":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "defaultAriaLiveMessages", ()=>defaultAriaLiveMessages);
const defaultAriaLiveMessages = {
    onChange: (props)=>{
        const { action, label = '', isDisabled } = props;
        switch(action){
            case 'deselect-option':
            case 'pop-value':
            case 'remove-value':
                return label.length ? `option ${label}, deselected` : '';
            case 'clear':
                return 'All selected options have been cleared.';
            case 'select-option':
                return label.length && !isDisabled ? `option ${label}, selected.` : '';
            default:
                return '';
        }
    },
    onFilter: (props)=>{
        const { inputValue, resultsMessage } = props;
        return inputValue ? `${resultsMessage} for search term ${inputValue}.` : '';
    }
};

},{"@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"b9Z1m":[function(require,module,exports,__globalThis) {
/* a11y-text.tsx generated by @compiled/babel-plugin v0.39.1 */ var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _objectSpread = require("@swc/helpers/_/_object_spread");
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _runtime = require("@compiled/react/runtime");
// Assistive text to describe visual elements. Hidden for sighted users.
const styles = null;
const A11yText = (props)=>/*#__PURE__*/ (0, _jsxRuntime.jsx)("span", (0, _objectSpread._)({
        // eslint-disable-next-line  @atlaskit/ui-styling-standard/no-classname-prop
        className: (0, _runtime.ax)([
            "_ca0qidpf _u5f3idpf _n3tdidpf _19bvidpf _19itidpf _1reo15vq _18m915vq _1bsbt94y _4t3it94y _kqswstnw _1pbydx66 _ogto7mnp _uiztglyw _o5721q9c",
            "-a11yText"
        ])
    }, props));
exports.default = A11yText;

},{"@swc/helpers/_/_object_spread":"9gdrV","react/jsx-runtime":"bGvcw","react":"ltHCL","@compiled/react/runtime":"d27Vo","@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"6NzNr":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _objectSpread = require("@swc/helpers/_/_object_spread");
var _objectSpreadProps = require("@swc/helpers/_/_object_spread_props");
var _react = require("react");
var _noop = require("@atlaskit/ds-lib/noop");
var _noopDefault = parcelHelpers.interopDefault(_noop);
var _platformFeatureFlags = require("@atlaskit/platform-feature-flags");
var _portalPlacementContext = require("../internal/portal-placement-context");
const noop = (0, _noopDefault.default);
function getScrollParent(element) {
    let style = getComputedStyle(element);
    const excludeStaticParent = style.position === 'absolute';
    const overflowRx = /(auto|scroll)/;
    if (style.position === 'fixed') return document.documentElement;
    for(let parent = element; parent = parent.parentElement;){
        style = getComputedStyle(parent);
        if (excludeStaticParent && style.position === 'static') continue;
        if (overflowRx.test(style.overflow + style.overflowY + style.overflowX)) return parent;
    }
    return document.documentElement;
}
function isDocumentElement(el) {
    return [
        document.documentElement,
        document.body,
        window
    ].indexOf(el) > -1;
}
function normalizedHeight(el) {
    if (isDocumentElement(el)) return window.innerHeight;
    return el.clientHeight;
}
function scrollTo(el, top) {
    // with a scroll distance, we perform scroll on the element
    if (isDocumentElement(el)) {
        window.scrollTo(0, top);
        return;
    }
    el.scrollTop = top;
}
function easeOutCubic(t, b, c, d) {
    return c * ((t = t / d - 1) * t * t + 1) + b;
}
function getScrollTop(el) {
    if (isDocumentElement(el)) return window.pageYOffset;
    return el.scrollTop;
}
function animatedScrollTo(element, to, duration = 200, callback = noop) {
    const start = getScrollTop(element);
    const change = to - start;
    const increment = 10;
    let currentTime = 0;
    function animateScroll() {
        currentTime += increment;
        const val = easeOutCubic(currentTime, start, change, duration);
        scrollTo(element, val);
        if (currentTime < duration) window.requestAnimationFrame(animateScroll);
        else callback(element);
    }
    animateScroll();
}
function getMenuPlacement({ maxHeight: preferredMaxHeight, menuEl, minHeight, placement: preferredPlacement, shouldScroll, isFixedPosition, controlHeight }) {
    const scrollParent = getScrollParent(menuEl);
    const defaultState = {
        placement: 'bottom',
        maxHeight: preferredMaxHeight
    };
    // something went wrong, return default state
    if (!menuEl || !menuEl.offsetParent) return defaultState;
    // we can't trust `scrollParent.scrollHeight` --> it may increase when
    // the menu is rendered
    const { height: scrollHeight } = scrollParent.getBoundingClientRect();
    const { bottom: menuBottom, height: menuHeight, top: menuTop } = menuEl.getBoundingClientRect();
    const { top: containerTop } = menuEl.offsetParent.getBoundingClientRect();
    const viewHeight = isFixedPosition ? window.innerHeight : normalizedHeight(scrollParent);
    const scrollTop = getScrollTop(scrollParent);
    const menuTopFromParent = menuTop;
    const marginBottom = parseInt(getComputedStyle(menuEl).marginBottom, 10);
    const marginTop = parseInt(getComputedStyle(menuEl).marginTop, 10);
    const viewSpaceAbove = containerTop - marginTop;
    const viewSpaceBelow = viewHeight - menuTopFromParent;
    const scrollSpaceAbove = viewSpaceAbove + scrollTop;
    const scrollSpaceBelow = scrollHeight - scrollTop - menuTopFromParent;
    const scrollDown = menuBottom - viewHeight + scrollTop + marginBottom;
    const scrollUp = scrollTop + menuTop - marginTop;
    const scrollDuration = 160;
    switch(preferredPlacement){
        case 'auto':
        case 'bottom':
            // 1: the menu will fit, do nothing
            if (viewSpaceBelow >= menuHeight) return {
                placement: 'bottom',
                maxHeight: preferredMaxHeight
            };
            // 2: the menu will fit, if scrolled
            if (scrollSpaceBelow >= menuHeight && !isFixedPosition) {
                if (shouldScroll) animatedScrollTo(scrollParent, scrollDown, scrollDuration);
                return {
                    placement: 'bottom',
                    maxHeight: preferredMaxHeight
                };
            }
            // 3: the menu will fit, if constrained
            if (!isFixedPosition && scrollSpaceBelow >= minHeight || isFixedPosition && viewSpaceBelow >= minHeight) {
                if (shouldScroll) animatedScrollTo(scrollParent, scrollDown, scrollDuration);
                // we want to provide as much of the menu as possible to the user,
                // so give them whatever is available below rather than the minHeight.
                const constrainedHeight = isFixedPosition ? viewSpaceBelow - marginBottom : scrollSpaceBelow - marginBottom;
                return {
                    placement: 'bottom',
                    maxHeight: constrainedHeight
                };
            }
            // 4. Forked beviour when there isn't enough space below
            // AUTO: flip the menu, render above
            if (preferredPlacement === 'auto' || isFixedPosition) {
                // may need to be constrained after flipping
                let constrainedHeight = preferredMaxHeight;
                const spaceAbove = isFixedPosition ? viewSpaceAbove : scrollSpaceAbove;
                if (spaceAbove >= minHeight) constrainedHeight = Math.min(spaceAbove - marginBottom - controlHeight, preferredMaxHeight);
                return {
                    placement: 'top',
                    maxHeight: constrainedHeight
                };
            }
            // BOTTOM: allow browser to increase scrollable area and immediately set scroll
            if (preferredPlacement === 'bottom') {
                if (shouldScroll) scrollTo(scrollParent, scrollDown);
                return {
                    placement: 'bottom',
                    maxHeight: preferredMaxHeight
                };
            }
            break;
        case 'top':
            // 1: the menu will fit, do nothing
            if (viewSpaceAbove >= menuHeight) return {
                placement: 'top',
                maxHeight: preferredMaxHeight
            };
            // 2: the menu will fit, if scrolled
            if (scrollSpaceAbove >= menuHeight && !isFixedPosition) {
                if (shouldScroll) animatedScrollTo(scrollParent, scrollUp, scrollDuration);
                return {
                    placement: 'top',
                    maxHeight: preferredMaxHeight
                };
            }
            // 3: the menu will fit, if constrained
            if (!isFixedPosition && scrollSpaceAbove >= minHeight || isFixedPosition && viewSpaceAbove >= minHeight) {
                let constrainedHeight = preferredMaxHeight;
                // we want to provide as much of the menu as possible to the user,
                // so give them whatever is available below rather than the minHeight.
                if (!isFixedPosition && scrollSpaceAbove >= minHeight || isFixedPosition && viewSpaceAbove >= minHeight) constrainedHeight = isFixedPosition ? viewSpaceAbove - marginTop : scrollSpaceAbove - marginTop;
                if (shouldScroll) animatedScrollTo(scrollParent, scrollUp, scrollDuration);
                return {
                    placement: 'top',
                    maxHeight: constrainedHeight
                };
            }
            // 4. not enough space, the browser WILL NOT increase scrollable area when
            // absolutely positioned element rendered above the viewport (only below).
            // Flip the menu, render below
            return {
                placement: 'bottom',
                maxHeight: preferredMaxHeight
            };
        default:
            throw new Error(`Invalid placement provided "${preferredPlacement}".`);
    }
    return defaultState;
}
const coercePlacement = (p)=>p === 'auto' ? 'bottom' : p;
// NOTE: internal only
// eslint-disable-next-line @repo/internal/react/require-jsdoc
// TODO: Fill in the component {description} and ensure links point to the correct {packageName} location.
// Remove links that the component does not have (such as usage). If there are no links remove them all.
/**
 * __Menu placer__
 *
 * A menu placer {description}.
 *
 * - [Examples](https://atlassian.design/components/{packageName}/examples)
 * - [Code](https://atlassian.design/components/{packageName}/code)
 * - [Usage](https://atlassian.design/components/{packageName}/usage)
 */ const MenuPlacer = (props)=>{
    const { children, minMenuHeight, maxMenuHeight, menuPlacement, menuPosition, menuShouldScrollIntoView } = props;
    const { setPortalPlacement } = (0, _react.useContext)((0, _portalPlacementContext.PortalPlacementContext)) || {};
    const ref = (0, _react.useRef)(null);
    const [maxHeight, setMaxHeight] = (0, _react.useState)(maxMenuHeight);
    const [placement, setPlacement] = (0, _react.useState)(null);
    // The minimum height of the control
    const controlHeight = 38;
    (0, _react.useLayoutEffect)(()=>{
        // When the menu is hosted in the browser top layer, positioning, flipping
        // and viewport-fit are all handled by `@atlaskit/top-layer`. The placer
        // becomes a pass-through that only forwards `maxMenuHeight` as a cap.
        if ((0, _platformFeatureFlags.fg)('platform-dst-top-layer')) return;
        const menuEl = ref.current;
        if (!menuEl) return;
        // DO NOT scroll if position is fixed
        const isFixedPosition = menuPosition === 'fixed';
        const shouldScroll = menuShouldScrollIntoView && !isFixedPosition;
        const state = getMenuPlacement({
            maxHeight: maxMenuHeight,
            menuEl,
            minHeight: minMenuHeight,
            placement: menuPlacement,
            shouldScroll,
            isFixedPosition,
            controlHeight
        });
        setMaxHeight(state.maxHeight);
        setPlacement(state.placement);
        setPortalPlacement === null || setPortalPlacement === void 0 ? void 0 : setPortalPlacement(state.placement);
    }, [
        maxMenuHeight,
        menuPlacement,
        menuPosition,
        menuShouldScrollIntoView,
        minMenuHeight,
        setPortalPlacement,
        controlHeight
    ]);
    return children({
        ref,
        placerProps: (0, _objectSpreadProps._)((0, _objectSpread._)({}, props), {
            placement: placement || coercePlacement(menuPlacement),
            maxHeight
        })
    });
};
exports.default = MenuPlacer;

},{"@swc/helpers/_/_object_spread":"9gdrV","@swc/helpers/_/_object_spread_props":"kANqQ","react":"ltHCL","@atlaskit/ds-lib/noop":"faKzG","@atlaskit/platform-feature-flags":"8rD2i","../internal/portal-placement-context":"bvI6u","@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"2SKnP":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "classNames", ()=>classNames);
/**
 * String representation of component state for styling with class names.
 *
 * Expects an array of strings OR a string/object pair:
 * - className(['comp', 'comp-arg', 'comp-arg-2'])
 * @returns 'react-select__comp react-select__comp-arg react-select__comp-arg-2'
 * - className('comp', { some: true, state: false })
 * @returns 'react-select__comp react-select__comp--some'
 */ function applyPrefixToName(prefix, name) {
    if (!name) return prefix;
    else if (name[0] === '-') return prefix + name;
    else return prefix + '__' + name;
}
function classNames(prefix, state, ...classNameList) {
    const arr = [
        ...classNameList
    ];
    if (state && prefix) {
        for(let key in state)if (state.hasOwnProperty(key) && state[key]) arr.push(`${applyPrefixToName(prefix, key)}`);
    }
    return arr.filter((i)=>i).map((i)=>String(i).trim()).join(' ');
}

},{"@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"e9zUf":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "cleanValue", ()=>cleanValue);
const cleanValue = (value)=>{
    if (Array.isArray(value)) return value.filter(Boolean);
    if (typeof value === 'object' && value !== null) return [
        value
    ];
    return [];
};

},{"@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"inWXg":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "isDocumentElement", ()=>isDocumentElement);
function isDocumentElement(el) {
    return [
        document.documentElement,
        document.body,
        window
    ].indexOf(el) > -1;
}

},{"@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"4OZ1n":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "multiValueAsValue", ()=>multiValueAsValue);
function multiValueAsValue(multiValue) {
    return multiValue;
}

},{"@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"a63Ux":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
/**
 * Functional component wrapper around `useNotifyOpenLayerObserver`.
 *
 * This is needed as Select is a class component, which cannot use hooks directly.
 */ parcelHelpers.export(exports, "NotifyOpenLayerObserver", ()=>NotifyOpenLayerObserver);
var _openLayerObserver = require("@atlaskit/layering/experimental/open-layer-observer");
function NotifyOpenLayerObserver({ isOpen, onClose }) {
    // @ts-ignore - hot-116676
    (0, _openLayerObserver.useNotifyOpenLayerObserver)({
        isOpen,
        onClose
    });
    return null;
}

},{"@atlaskit/layering/experimental/open-layer-observer":"2Dqp9","@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"jYwC6":[function(require,module,exports,__globalThis) {
/* required-input.tsx generated by @compiled/babel-plugin v0.39.1 */ var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _runtime = require("@compiled/react/runtime");
var _noop = require("@atlaskit/ds-lib/noop");
var _noopDefault = parcelHelpers.interopDefault(_noop);
const styles = null;
const RequiredInput = ({ name, onFocus })=>/*#__PURE__*/ (0, _jsxRuntime.jsx)("input", {
        required: true,
        name: name,
        tabIndex: -1,
        "aria-hidden": "true",
        // eslint-disable-next-line  @atlaskit/ui-styling-standard/no-classname-prop
        className: (0, _runtime.ax)([
            "_1bsb1osq _kqswstnw _u7coidpf _rjxpidpf _1e02idpf _tzy4idpf _lcxvglyw",
            "-requiredInput"
        ]),
        onFocus: onFocus,
        // Prevent `Switching from uncontrolled to controlled` error
        value: "",
        onChange: (0, _noopDefault.default)
    });
// eslint-disable-next-line @repo/internal/react/require-jsdoc
exports.default = RequiredInput;

},{"react/jsx-runtime":"bGvcw","react":"ltHCL","@compiled/react/runtime":"d27Vo","@atlaskit/ds-lib/noop":"faKzG","@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"12bov":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>ScrollManager);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _useScrollCapture = require("./use-scroll-capture");
var _useScrollCaptureDefault = parcelHelpers.interopDefault(_useScrollCapture);
var _useScrollLock = require("./use-scroll-lock");
var _useScrollLockDefault = parcelHelpers.interopDefault(_useScrollLock);
const blurSelectInput = (event)=>{
    const element = event.target;
    return element.ownerDocument.activeElement && element.ownerDocument.activeElement.blur();
};
function ScrollManager({ children, lockEnabled, captureEnabled = true, onBottomArrive, onBottomLeave, onTopArrive, onTopLeave }) {
    const setScrollCaptureTarget = (0, _useScrollCaptureDefault.default)({
        isEnabled: captureEnabled,
        onBottomArrive,
        onBottomLeave,
        onTopArrive,
        onTopLeave
    });
    const setScrollLockTarget = (0, _useScrollLockDefault.default)({
        isEnabled: lockEnabled
    });
    const targetRef = (element)=>{
        setScrollCaptureTarget(element);
        setScrollLockTarget(element);
    };
    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _react.Fragment), {
        children: [
            lockEnabled && // eslint-disable-next-line @atlassian/a11y/click-events-have-key-events, @atlassian/a11y/interactive-element-not-keyboard-focusable, @atlassian/a11y/no-static-element-interactions
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                onClick: blurSelectInput,
                style: {
                    // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop
                    position: 'fixed',
                    // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop
                    insetBlockEnd: 0,
                    // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop
                    insetBlockStart: 0,
                    // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop
                    insetInlineEnd: 0,
                    // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop
                    insetInlineStart: 0
                }
            }),
            children(targetRef)
        ]
    });
}

},{"react/jsx-runtime":"bGvcw","react":"ltHCL","./use-scroll-capture":"6hRAs","./use-scroll-lock":"dAYqz","@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"6hRAs":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>useScrollCapture);
var _react = require("react");
var _passiveEventDetector = require("./passive-event-detector");
const cancelScroll = (event)=>{
    if (event.cancelable) event.preventDefault();
    event.stopPropagation();
};
function useScrollCapture({ isEnabled, onBottomArrive, onBottomLeave, onTopArrive, onTopLeave }) {
    const isBottom = (0, _react.useRef)(false);
    const isTop = (0, _react.useRef)(false);
    const touchStart = (0, _react.useRef)(0);
    const scrollTarget = (0, _react.useRef)(null);
    const handleEventDelta = (0, _react.useCallback)((event, delta)=>{
        if (scrollTarget.current === null) return;
        const { scrollTop, scrollHeight, clientHeight } = scrollTarget.current;
        const target = scrollTarget.current;
        const isDeltaPositive = delta > 0;
        const availableScroll = scrollHeight - clientHeight - scrollTop;
        let shouldCancelScroll = false;
        // reset bottom/top flags
        if (availableScroll > delta && isBottom.current) {
            if (onBottomLeave) onBottomLeave(event);
            isBottom.current = false;
        }
        if (isDeltaPositive && isTop.current) {
            if (onTopLeave) onTopLeave(event);
            isTop.current = false;
        }
        // bottom limit
        if (isDeltaPositive && delta > availableScroll) {
            if (onBottomArrive && !isBottom.current) onBottomArrive(event);
            target.scrollTop = scrollHeight;
            shouldCancelScroll = true;
            isBottom.current = true;
        // top limit
        } else if (!isDeltaPositive && -delta > scrollTop) {
            if (onTopArrive && !isTop.current) onTopArrive(event);
            target.scrollTop = 0;
            shouldCancelScroll = true;
            isTop.current = true;
        }
        // cancel scroll
        if (shouldCancelScroll) cancelScroll(event);
    }, [
        onBottomArrive,
        onBottomLeave,
        onTopArrive,
        onTopLeave
    ]);
    const onWheel = (0, _react.useCallback)((event)=>{
        handleEventDelta(event, event.deltaY);
    }, [
        handleEventDelta
    ]);
    const onTouchStart = (0, _react.useCallback)((event)=>{
        // set touch start so we can calculate touchmove delta
        touchStart.current = event.changedTouches[0].clientY;
    }, []);
    const onTouchMove = (0, _react.useCallback)((event)=>{
        const deltaY = touchStart.current - event.changedTouches[0].clientY;
        handleEventDelta(event, deltaY);
    }, [
        handleEventDelta
    ]);
    const startListening = (0, _react.useCallback)((el)=>{
        // bail early if no element is available to attach to
        if (!el) return;
        const notPassive = (0, _passiveEventDetector.supportsPassiveEvents) ? {
            passive: false
        } : false;
        // eslint-disable-next-line @repo/internal/dom-events/no-unsafe-event-listeners
        el.addEventListener('wheel', onWheel, notPassive);
        // eslint-disable-next-line @repo/internal/dom-events/no-unsafe-event-listeners
        el.addEventListener('touchstart', onTouchStart, notPassive);
        // eslint-disable-next-line @repo/internal/dom-events/no-unsafe-event-listeners
        el.addEventListener('touchmove', onTouchMove, notPassive);
    }, [
        onTouchMove,
        onTouchStart,
        onWheel
    ]);
    const stopListening = (0, _react.useCallback)((el)=>{
        // bail early if no element is available to detach from
        if (!el) return;
        // eslint-disable-next-line @repo/internal/dom-events/no-unsafe-event-listeners
        el.removeEventListener('wheel', onWheel, false);
        // eslint-disable-next-line @repo/internal/dom-events/no-unsafe-event-listeners
        el.removeEventListener('touchstart', onTouchStart, false);
        // eslint-disable-next-line @repo/internal/dom-events/no-unsafe-event-listeners
        el.removeEventListener('touchmove', onTouchMove, false);
    }, [
        onTouchMove,
        onTouchStart,
        onWheel
    ]);
    (0, _react.useEffect)(()=>{
        if (!isEnabled) return;
        const element = scrollTarget.current;
        startListening(element);
        return ()=>{
            stopListening(element);
        };
    }, [
        isEnabled,
        startListening,
        stopListening
    ]);
    return (element)=>{
        scrollTarget.current = element;
    };
}

},{"react":"ltHCL","./passive-event-detector":"jkS5H","@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"jkS5H":[function(require,module,exports,__globalThis) {
// ==============================
// Passive Event Detector
// ==============================
var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "supportsPassiveEvents", ()=>supportsPassiveEvents);
var _noop = require("@atlaskit/ds-lib/noop");
var _noopDefault = parcelHelpers.interopDefault(_noop);
const noop = (0, _noopDefault.default);
// https://github.com/rafgraph/detect-it/blob/main/src/index.ts#L19-L36
let passiveOptionAccessed = false;
const options = {
    get passive () {
        return passiveOptionAccessed = true;
    }
};
// check for SSR
const w = typeof window !== 'undefined' ? window : {};
if (w.addEventListener && w.removeEventListener) {
    // eslint-disable-next-line @repo/internal/dom-events/no-unsafe-event-listeners
    w.addEventListener('p', noop, options);
    // eslint-disable-next-line @repo/internal/dom-events/no-unsafe-event-listeners
    w.removeEventListener('p', noop, false);
}
const supportsPassiveEvents = passiveOptionAccessed;

},{"@atlaskit/ds-lib/noop":"faKzG","@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"dAYqz":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>useScrollLock);
var _react = require("react");
const STYLE_KEYS = [
    'boxSizing',
    'height',
    'overflow',
    'paddingRight',
    'position'
];
const LOCK_STYLES = {
    boxSizing: 'border-box',
    overflow: 'hidden',
    position: 'relative',
    height: '100%'
};
function preventTouchMove(e) {
    e.preventDefault();
}
function allowTouchMove(e) {
    e.stopPropagation();
}
function preventInertiaScroll() {
    const top = this.scrollTop;
    const totalScroll = this.scrollHeight;
    const currentScroll = top + this.offsetHeight;
    if (top === 0) this.scrollTop = 1;
    else if (currentScroll === totalScroll) this.scrollTop = top - 1;
}
// `ontouchstart` check works on most browsers
// `maxTouchPoints` works on IE10/11 and Surface
function isTouchDevice() {
    return 'ontouchstart' in window || navigator.maxTouchPoints;
}
const canUseDOM = !!(typeof window !== 'undefined' && window.document && window.document.createElement);
let activeScrollLocks = 0;
const listenerOptions = {
    capture: false,
    passive: false
};
function useScrollLock({ isEnabled, accountForScrollbars = true }) {
    const originalStyles = (0, _react.useRef)({});
    const scrollTarget = (0, _react.useRef)(null);
    const addScrollLock = (0, _react.useCallback)((touchScrollTarget)=>{
        if (!canUseDOM) return;
        const target = document.body;
        const targetStyle = target && target.style;
        if (accountForScrollbars) // store any styles already applied to the body
        STYLE_KEYS.forEach((key)=>{
            const val = targetStyle && targetStyle[key];
            originalStyles.current[key] = val;
        });
        // apply the lock styles and padding if this is the first scroll lock
        if (accountForScrollbars && activeScrollLocks < 1) {
            const currentPadding = parseInt(originalStyles.current.paddingRight, 10) || 0;
            const clientWidth = document.body ? document.body.clientWidth : 0;
            const adjustedPadding = window.innerWidth - clientWidth + currentPadding || 0;
            Object.keys(LOCK_STYLES).forEach((key)=>{
                const val = LOCK_STYLES[key];
                if (targetStyle) targetStyle[key] = val;
            });
            if (targetStyle) targetStyle.paddingRight = `${adjustedPadding}px`;
        }
        // account for touch devices
        if (target && isTouchDevice()) {
            // Mobile Safari ignores { overflow: hidden } declaration on the body.
            // eslint-disable-next-line @repo/internal/dom-events/no-unsafe-event-listeners
            target.addEventListener('touchmove', preventTouchMove, listenerOptions);
            // Allow scroll on provided target
            if (touchScrollTarget) {
                // eslint-disable-next-line @repo/internal/dom-events/no-unsafe-event-listeners
                touchScrollTarget.addEventListener('touchstart', preventInertiaScroll, listenerOptions);
                // eslint-disable-next-line @repo/internal/dom-events/no-unsafe-event-listeners
                touchScrollTarget.addEventListener('touchmove', allowTouchMove, listenerOptions);
            }
        }
        // increment active scroll locks
        activeScrollLocks += 1;
    }, [
        accountForScrollbars
    ]);
    const removeScrollLock = (0, _react.useCallback)((touchScrollTarget)=>{
        if (!canUseDOM) return;
        const target = document.body;
        const targetStyle = target && target.style;
        // safely decrement active scroll locks
        activeScrollLocks = Math.max(activeScrollLocks - 1, 0);
        // reapply original body styles, if any
        if (accountForScrollbars && activeScrollLocks < 1) STYLE_KEYS.forEach((key)=>{
            const val = originalStyles.current[key];
            if (targetStyle) targetStyle[key] = val;
        });
        // remove touch listeners
        if (target && isTouchDevice()) {
            // eslint-disable-next-line @repo/internal/dom-events/no-unsafe-event-listeners
            target.removeEventListener('touchmove', preventTouchMove, listenerOptions);
            if (touchScrollTarget) {
                // eslint-disable-next-line @repo/internal/dom-events/no-unsafe-event-listeners
                touchScrollTarget.removeEventListener('touchstart', preventInertiaScroll, listenerOptions);
                // eslint-disable-next-line @repo/internal/dom-events/no-unsafe-event-listeners
                touchScrollTarget.removeEventListener('touchmove', allowTouchMove, listenerOptions);
            }
        }
    }, [
        accountForScrollbars
    ]);
    (0, _react.useEffect)(()=>{
        if (!isEnabled) return;
        const element = scrollTarget.current;
        addScrollLock(element);
        return ()=>{
            removeScrollLock(element);
        };
    }, [
        isEnabled,
        addScrollLock,
        removeScrollLock
    ]);
    return (element)=>{
        scrollTarget.current = element;
    };
}

},{"react":"ltHCL","@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"6MRkP":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "scrollTo", ()=>scrollTo);
var _isDocumentEl = require("./is-document-el");
function scrollTo(el, top) {
    // with a scroll distance, we perform scroll on the element
    if ((0, _isDocumentEl.isDocumentElement)(el)) {
        window.scrollTo(0, top);
        return;
    }
    el.scrollTop = top;
}

},{"./is-document-el":"inWXg","@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"g3Idb":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "singleValueAsValue", ()=>singleValueAsValue);
function singleValueAsValue(singleValue) {
    return singleValue;
}

},{"@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"6u29O":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "valueTernary", ()=>valueTernary);
function valueTernary(isMulti, multiValue, singleValue) {
    return isMulti ? multiValue : singleValue;
}

},{"@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"9dP6S":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>createSelect);
var _objectSpread = require("@swc/helpers/_/_object_spread");
var _objectSpreadProps = require("@swc/helpers/_/_object_spread_props");
var _objectWithoutProperties = require("@swc/helpers/_/_object_without_properties");
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
function createSelect(WrappedComponent) {
    const AtlaskitSelect = /*#__PURE__*/ (0, _react.forwardRef)(function AtlaskitSelect(props, forwardedRef) {
        const { ariaLiveMessages, isInvalid, onClickPreventDefault = true, tabSelectsValue = false, validationState = 'default' } = props, restProps = (0, _objectWithoutProperties._)(props, [
            "ariaLiveMessages",
            "isInvalid",
            "onClickPreventDefault",
            "tabSelectsValue",
            "validationState"
        ]);
        const internalSelectRef = (0, _react.useRef)(null);
        /**
		 * The following `useImperativeHandle` hook exists for the sake of backwards compatibility.
		 * This component used to be a class component which set the value of the `ref` prop to object with the properties and value as below.
		 * This has lead to slightly odd usage of refs with this component, e.g. `myRef.current.select.select.controlRef` instead of just `myRef.current.select.controlRef`
		 * In the next major release, this should removed and the ref should be passed directly to the wrapped component (given users have updated usage)
		 * More info https://stash.atlassian.com/projects/ATLASSIAN/repos/atlassian-frontend-monorepo/pull-requests/88021/overview
		 */ (0, _react.useImperativeHandle)(forwardedRef, ()=>({
                select: internalSelectRef.current,
                focus: ()=>{
                    var _internalSelectRef_current;
                    return (_internalSelectRef_current = internalSelectRef.current) === null || _internalSelectRef_current === void 0 ? void 0 : _internalSelectRef_current.focus();
                },
                blur: ()=>{
                    var _internalSelectRef_current;
                    return (_internalSelectRef_current = internalSelectRef.current) === null || _internalSelectRef_current === void 0 ? void 0 : _internalSelectRef_current.blur();
                }
            }), []);
        return /*#__PURE__*/ (0, _jsxRuntime.jsx)(WrappedComponent, (0, _objectSpreadProps._)((0, _objectSpread._)({
            ref: internalSelectRef,
            ariaLiveMessages: ariaLiveMessages,
            tabSelectsValue: tabSelectsValue,
            onClickPreventDefault: onClickPreventDefault,
            isInvalid: isInvalid || validationState === 'error'
        }, restProps), {
            // indicates react-select to be async by default using the base Select component
            // so that makers can pass all async props on the base select to async load options.
            isAsync: true
        }));
    });
    AtlaskitSelect.displayName = 'AtlaskitSelect';
    return AtlaskitSelect;
}

},{"@swc/helpers/_/_object_spread":"9gdrV","@swc/helpers/_/_object_spread_props":"kANqQ","@swc/helpers/_/_object_without_properties":"6HqIM","react/jsx-runtime":"bGvcw","react":"ltHCL","@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"9nPxS":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>(0, _asyncSelectDefault.default));
var _asyncSelect = require("../async-select");
var _asyncSelectDefault = parcelHelpers.interopDefault(_asyncSelect);

},{"../async-select":"6tq1p","@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"6tq1p":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _async = require("@atlaskit/react-select/async");
var _asyncDefault = parcelHelpers.interopDefault(_async);
var _createSelect = require("./create-select");
var _createSelectDefault = parcelHelpers.interopDefault(_createSelect);
const AsyncSelect = (0, _createSelectDefault.default)((0, _asyncDefault.default));
// eslint-disable-next-line @repo/internal/react/require-jsdoc
exports.default = AsyncSelect;

},{"@atlaskit/react-select/async":"8f4gg","./create-select":"9dP6S","@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"hbqN0":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>(0, _creatableSelectDefault.default));
var _creatableSelect = require("../creatable-select");
var _creatableSelectDefault = parcelHelpers.interopDefault(_creatableSelect);

},{"../creatable-select":"tNBwd","@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"tNBwd":[function(require,module,exports,__globalThis) {
/* eslint-disable @repo/internal/fs/filename-pattern-match */ var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _creatable = require("@atlaskit/react-select/creatable");
var _creatableDefault = parcelHelpers.interopDefault(_creatable);
var _createSelect = require("./create-select");
var _createSelectDefault = parcelHelpers.interopDefault(_createSelect);
const CreatableSelect = (0, _createSelectDefault.default)((0, _creatableDefault.default));
// eslint-disable-next-line @repo/internal/react/require-jsdoc
exports.default = CreatableSelect;

},{"@atlaskit/react-select/creatable":"ls9ut","./create-select":"9dP6S","@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"ls9ut":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "useCreatable", ()=>(0, _useCreatableDefault.default));
parcelHelpers.export(exports, "default", ()=>(0, _creatableDefault.default));
var _useCreatable = require("../use-creatable");
var _useCreatableDefault = parcelHelpers.interopDefault(_useCreatable);
var _creatable = require("../creatable");
var _creatableDefault = parcelHelpers.interopDefault(_creatable);

},{"../use-creatable":false,"../creatable":"crywn","@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"hagc6":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>useCreatable);
var _objectSpread = require("@swc/helpers/_/_object_spread");
var _objectSpreadProps = require("@swc/helpers/_/_object_spread_props");
var _objectWithoutProperties = require("@swc/helpers/_/_object_without_properties");
var _react = require("react");
var _builtins = require("./builtins");
var _cleanValue = require("./internal/clean-value");
var _valueTernary = require("./internal/value-ternary");
const compareOption = (inputValue = '', option, accessors)=>{
    const candidate = String(inputValue).toLowerCase();
    const optionValue = String(accessors.getOptionValue(option)).toLowerCase();
    const optionLabel = String(accessors.getOptionLabel(option)).toLowerCase();
    return optionValue === candidate || optionLabel === candidate;
};
const builtins = {
    formatCreateLabel: (inputValue)=>`Create "${inputValue}"`,
    isValidNewOption: (inputValue, selectValue, selectOptions, accessors)=>!(!inputValue || selectValue.some((option)=>compareOption(inputValue, option, accessors)) || selectOptions.some((option)=>compareOption(inputValue, option, accessors))),
    getNewOptionData: (inputValue, optionLabel)=>({
            label: optionLabel,
            value: inputValue,
            __isNew__: true
        })
};
function useCreatable(_param) {
    var { allowCreateWhileLoading = false, createOptionPosition = 'last', formatCreateLabel = builtins.formatCreateLabel, isValidNewOption = builtins.isValidNewOption, //@ts-ignore
    getNewOptionData = builtins.getNewOptionData, onCreateOption, options: propsOptions = [], onChange: propsOnChange } = _param, restSelectProps = (0, _objectWithoutProperties._)(_param, [
        "allowCreateWhileLoading",
        "createOptionPosition",
        "formatCreateLabel",
        "isValidNewOption",
        "getNewOptionData",
        "onCreateOption",
        "options",
        "onChange"
    ]);
    const { getOptionValue = (0, _builtins.getOptionValue), getOptionLabel = (0, _builtins.getOptionLabel), inputValue, isLoading, isMulti, value, name } = restSelectProps;
    const newOption = (0, _react.useMemo)(()=>isValidNewOption(inputValue, (0, _cleanValue.cleanValue)(value), propsOptions, {
            getOptionValue,
            getOptionLabel
        }) ? getNewOptionData(inputValue, formatCreateLabel(inputValue)) : undefined, [
        formatCreateLabel,
        getNewOptionData,
        getOptionLabel,
        getOptionValue,
        inputValue,
        isValidNewOption,
        propsOptions,
        value
    ]);
    const options = (0, _react.useMemo)(()=>(allowCreateWhileLoading || !isLoading) && newOption ? createOptionPosition === 'first' ? [
            newOption,
            ...propsOptions
        ] : [
            ...propsOptions,
            newOption
        ] : propsOptions, [
        allowCreateWhileLoading,
        createOptionPosition,
        isLoading,
        newOption,
        propsOptions
    ]);
    const onChange = (0, _react.useCallback)((newValue, actionMeta)=>{
        if (actionMeta.action !== 'select-option') return propsOnChange(newValue, actionMeta);
        const valueArray = Array.isArray(newValue) ? newValue : [
            newValue
        ];
        if (valueArray[valueArray.length - 1] === newOption) {
            if (onCreateOption) onCreateOption(inputValue);
            else {
                const newOptionData = getNewOptionData(inputValue, inputValue);
                const newActionMeta = {
                    action: 'create-option',
                    name,
                    option: newOptionData
                };
                propsOnChange((0, _valueTernary.valueTernary)(isMulti, [
                    ...(0, _cleanValue.cleanValue)(value),
                    newOptionData
                ], newOptionData), newActionMeta);
            }
            return;
        }
        propsOnChange(newValue, actionMeta);
    }, [
        getNewOptionData,
        inputValue,
        isMulti,
        name,
        newOption,
        onCreateOption,
        propsOnChange,
        value
    ]);
    return (0, _objectSpreadProps._)((0, _objectSpread._)({}, restSelectProps), {
        options,
        onChange
    });
}

},{"@swc/helpers/_/_object_spread":"9gdrV","@swc/helpers/_/_object_spread_props":"kANqQ","@swc/helpers/_/_object_without_properties":"6HqIM","react":"ltHCL","./builtins":"bdn6g","./internal/clean-value":"e9zUf","./internal/value-ternary":"6u29O","@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"crywn":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _objectSpread = require("@swc/helpers/_/_object_spread");
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _select = require("./select");
var _selectDefault = parcelHelpers.interopDefault(_select);
var _useCreatable = require("./use-creatable");
var _useCreatableDefault = parcelHelpers.interopDefault(_useCreatable);
var _useStateManager = require("./use-state-manager");
var _useStateManagerDefault = parcelHelpers.interopDefault(_useStateManager);
const CreatableSelect = /*#__PURE__*/ (0, _react.forwardRef)((props, ref)=>{
    const creatableProps = (0, _useStateManagerDefault.default)(props);
    const selectProps = (0, _useCreatableDefault.default)(creatableProps);
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _selectDefault.default), (0, _objectSpread._)({
        ref: ref
    }, selectProps));
});
// eslint-disable-next-line @repo/internal/react/require-jsdoc
exports.default = CreatableSelect;

},{"@swc/helpers/_/_object_spread":"9gdrV","react/jsx-runtime":"bGvcw","react":"ltHCL","./select":"6szgU","./use-creatable":"hagc6","./use-state-manager":"2tgTy","@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"3sluj":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>(0, _asyncCreatableSelectDefault.default));
var _asyncCreatableSelect = require("../async-creatable-select");
var _asyncCreatableSelectDefault = parcelHelpers.interopDefault(_asyncCreatableSelect);

},{"../async-creatable-select":"lOhmN","@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"lOhmN":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _asyncCreatable = require("@atlaskit/react-select/async-creatable");
var _asyncCreatableDefault = parcelHelpers.interopDefault(_asyncCreatable);
var _createSelect = require("./create-select");
var _createSelectDefault = parcelHelpers.interopDefault(_createSelect);
const AsyncCreatableSelect = (0, _createSelectDefault.default)((0, _asyncCreatableDefault.default));
// eslint-disable-next-line @repo/internal/react/require-jsdoc
exports.default = AsyncCreatableSelect;

},{"@atlaskit/react-select/async-creatable":"gFYGK","./create-select":"9dP6S","@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"gFYGK":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>(0, _asyncCreatableDefault.default));
var _asyncCreatable = require("../async-creatable");
var _asyncCreatableDefault = parcelHelpers.interopDefault(_asyncCreatable);

},{"../async-creatable":"32GyE","@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"32GyE":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _objectSpread = require("@swc/helpers/_/_object_spread");
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _select = require("./select");
var _selectDefault = parcelHelpers.interopDefault(_select);
var _useAsync = require("./use-async");
var _useAsyncDefault = parcelHelpers.interopDefault(_useAsync);
var _useCreatable = require("./use-creatable");
var _useCreatableDefault = parcelHelpers.interopDefault(_useCreatable);
var _useStateManager = require("./use-state-manager");
var _useStateManagerDefault = parcelHelpers.interopDefault(_useStateManager);
const AsyncCreatableSelect = /*#__PURE__*/ (0, _react.forwardRef)((props, ref)=>{
    const stateManagerProps = (0, _useAsyncDefault.default)(props);
    const creatableProps = (0, _useStateManagerDefault.default)(stateManagerProps);
    const selectProps = (0, _useCreatableDefault.default)(creatableProps);
    // @ts-ignore - TS2322: Complex generic type causing issues for help-center local consumption with TS 5.9.2
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _selectDefault.default), (0, _objectSpread._)({
        ref: ref
    }, selectProps));
});
// eslint-disable-next-line @repo/internal/react/require-jsdoc
exports.default = AsyncCreatableSelect;

},{"@swc/helpers/_/_object_spread":"9gdrV","react/jsx-runtime":"bGvcw","react":"ltHCL","./select":"6szgU","./use-async":"fKgRX","./use-creatable":"hagc6","./use-state-manager":"2tgTy","@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"7BMTy":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "isOptionsGrouped", ()=>isOptionsGrouped);
const isOptionsGrouped = (arr)=>{
    return arr === null || arr === void 0 ? void 0 : arr.every((obj)=>obj.hasOwnProperty('options'));
};

},{"@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"kXKpJ":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _objectSpread = require("@swc/helpers/_/_object_spread");
var _objectSpreadProps = require("@swc/helpers/_/_object_spread_props");
var _objectWithoutProperties = require("@swc/helpers/_/_object_without_properties");
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _checkboxOption = require("./components/checkbox-option");
var _select = require("./select");
var _selectDefault = parcelHelpers.interopDefault(_select);
const CheckboxSelectInternal = (_param)=>{
    var { components } = _param, props = (0, _objectWithoutProperties._)(_param, [
        "components"
    ]);
    const mergedComponents = (0, _react.useMemo)(()=>(0, _objectSpreadProps._)((0, _objectSpread._)({}, components), {
            Option: (0, _checkboxOption.CheckboxOption)
        }), [
        components
    ]);
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _selectDefault.default), (0, _objectSpreadProps._)((0, _objectSpread._)({
        closeMenuOnSelect: false,
        hideSelectedOptions: false,
        isMulti: true
    }, props), {
        components: mergedComponents
    }));
};
const CheckboxSelect = /*#__PURE__*/ (0, _reactDefault.default).memo(CheckboxSelectInternal);
// eslint-disable-next-line @repo/internal/react/require-jsdoc
exports.default = CheckboxSelect;

},{"@swc/helpers/_/_object_spread":"9gdrV","@swc/helpers/_/_object_spread_props":"kANqQ","@swc/helpers/_/_object_without_properties":"6HqIM","react/jsx-runtime":"bGvcw","react":"ltHCL","./components/checkbox-option":"1DPMh","./select":"iPOlk","@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"5IoCq":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _objectSpread = require("@swc/helpers/_/_object_spread");
var _objectSpreadProps = require("@swc/helpers/_/_object_spread_props");
var _objectWithoutProperties = require("@swc/helpers/_/_object_without_properties");
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _radioOption = require("./components/radio-option");
var _select = require("./select");
var _selectDefault = parcelHelpers.interopDefault(_select);
const RadioSelect = /*#__PURE__*/ (0, _reactDefault.default).memo((_param)=>{
    var { components } = _param, props = (0, _objectWithoutProperties._)(_param, [
        "components"
    ]);
    const mergedComponents = (0, _react.useMemo)(()=>(0, _objectSpreadProps._)((0, _objectSpread._)({}, components), {
            Option: (0, _radioOption.RadioOption)
        }), [
        components
    ]);
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _selectDefault.default), (0, _objectSpreadProps._)((0, _objectSpread._)({}, props), {
        isMulti: false,
        components: mergedComponents
    }));
});
// eslint-disable-next-line @repo/internal/react/require-jsdoc
exports.default = RadioSelect;

},{"@swc/helpers/_/_object_spread":"9gdrV","@swc/helpers/_/_object_spread_props":"kANqQ","@swc/helpers/_/_object_without_properties":"6HqIM","react/jsx-runtime":"bGvcw","react":"ltHCL","./components/radio-option":"d7Alx","./select":"iPOlk","@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"MRq2B":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>(0, _popupSelectDefault.default));
var _popupSelect = require("./popup-select");
var _popupSelectDefault = parcelHelpers.interopDefault(_popupSelect);

},{"./popup-select":"ktzlc","@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"ktzlc":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
// eslint-disable-next-line @repo/internal/react/no-class-components
parcelHelpers.export(exports, "default", ()=>PopupSelect);
var _objectSpread = require("@swc/helpers/_/_object_spread");
var _objectSpreadProps = require("@swc/helpers/_/_object_spread_props");
var _objectWithoutProperties = require("@swc/helpers/_/_object_without_properties");
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _bindEventListener = require("bind-event-listener");
var _reactDom = require("react-dom");
var _reactFocusLock = require("react-focus-lock");
var _reactFocusLockDefault = parcelHelpers.interopDefault(_reactFocusLock);
var _reactPopper = require("react-popper");
var _shallowEqual = require("shallow-equal");
var _idProvider = require("@atlaskit/ds-lib/id-provider");
var _platformFeatureFlags = require("@atlaskit/platform-feature-flags");
var _reactSelect = require("@atlaskit/react-select");
var _select = require("../select");
var _selectDefault = parcelHelpers.interopDefault(_select);
var _components = require("./components");
var _dummyControl = require("./dummy-control");
var _menuDialog = require("./menu-dialog");
var _notifyOpenLayerObserver = require("./notify-open-layer-observer");
var _popupSelectTopLayer = require("./popup-select-top-layer");
/**
 * Are we rendering on the client or server?
 */ const canUseDOM = ()=>Boolean(typeof window !== 'undefined' && window.document && window.document.createElement);
// ==============================
// Class
// ==============================
const modifiers = [
    {
        name: 'offset',
        options: {
            offset: [
                0,
                8
            ]
        }
    },
    {
        name: 'preventOverflow',
        enabled: true,
        options: {
            padding: 5,
            boundary: 'clippingParents',
            altAxis: true,
            altBoundary: true
        }
    }
];
const defaultPopperProps = {
    modifiers,
    placement: 'bottom-start'
};
const isEmpty = (obj)=>Object.keys(obj).length === 0;
class PopupSelect extends (0, _react.PureComponent) {
    static getDerivedStateFromProps(props, state) {
        const newState = {};
        // Merge consumer and default popper props
        const mergedPopperProps = (0, _objectSpread._)({}, defaultPopperProps, props.popperProps);
        if (!(0, _shallowEqual.shallowEqualObjects)(mergedPopperProps, state.mergedPopperProps)) newState.mergedPopperProps = mergedPopperProps;
        // Merge consumer and default components
        const mergedComponents = (0, _objectSpread._)({}, (0, _components.defaultComponents), props.components);
        if (!(0, _shallowEqual.shallowEqualObjects)(mergedComponents, state.mergedComponents)) newState.mergedComponents = mergedComponents;
        if (!isEmpty(newState)) return newState;
        return null;
    }
    componentDidMount() {
        if (typeof window === 'undefined') return;
        this.unbindWindowClick = (0, _bindEventListener.bind)(window, {
            type: 'click',
            listener: this.handleClick,
            options: {
                capture: true
            }
        });
    }
    componentWillUnmount() {
        var _this_unbindWindowClick, _this, _this_unbindWindowKeydown, _this1;
        if (typeof window === 'undefined') return;
        (_this_unbindWindowClick = (_this = this).unbindWindowClick) === null || _this_unbindWindowClick === void 0 ? void 0 : _this_unbindWindowClick.call(_this);
        this.unbindWindowClick = null;
        (_this_unbindWindowKeydown = (_this1 = this).unbindWindowKeydown) === null || _this_unbindWindowKeydown === void 0 ? void 0 : _this_unbindWindowKeydown.call(_this1);
        this.unbindWindowKeydown = null;
    }
    componentDidUpdate(prevProps) {
        const { isOpen } = this.props;
        if (prevProps.isOpen !== isOpen) {
            if (isOpen === true) this.open({
                controlOverride: true
            });
            else if (isOpen === false) this.close({
                controlOverride: true
            });
        }
    }
    render() {
        // Top-layer rendering path: native Popover API via @atlaskit/top-layer
        if ((0, _platformFeatureFlags.fg)('platform-dst-top-layer')) return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _popupSelectTopLayer.PopupSelectTopLayer), (0, _objectSpread._)({}, this.props));
        const { target } = this.props;
        const { isOpen } = this.state;
        return /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _reactPopper.Manager), {
            children: [
                /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _idProvider.IdProvider), {
                    postfix: "-popup-select",
                    children: ({ id })=>/*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _jsxRuntime.Fragment), {
                            children: [
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactPopper.Reference), {
                                    children: ({ ref })=>target && target({
                                            isOpen,
                                            onKeyDown: this.handleTargetKeyDown,
                                            ref: this.resolveTargetRef(ref),
                                            // Should technically be 'dialog' by default instead of 'true' via AriaAttributes, but will require further changes.
                                            // See go/DSP-22283
                                            'aria-haspopup': 'true',
                                            'aria-expanded': isOpen,
                                            'aria-controls': isOpen ? id : undefined
                                        })
                                }),
                                this.renderSelect(id)
                            ]
                        })
                }),
                /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _notifyOpenLayerObserver.NotifyOpenLayerObserver), {
                    isOpen: this.state.isOpen,
                    onClose: this.handleOpenLayerObserverCloseSignal
                })
            ]
        });
    }
    constructor(...args){
        var _this_defaultOpenState;
        super(...args), this.menuRef = null, this.selectRef = null, this.targetRef = null, this.unbindWindowClick = null, this.unbindWindowKeydown = null, this.defaultStyles = {
            groupHeading: (provided)=>(0, _objectSpreadProps._)((0, _objectSpread._)({}, provided), {
                    color: "var(--ds-text-subtlest, #6B6E76)"
                })
        }, this.isOpenControlled = this.props.isOpen !== undefined, this.defaultOpenState = this.isOpenControlled ? this.props.isOpen : this.props.defaultIsOpen, this.state = {
            focusLockEnabled: false,
            isOpen: (_this_defaultOpenState = this.defaultOpenState) !== null && _this_defaultOpenState !== void 0 ? _this_defaultOpenState : false,
            mergedComponents: (0, _components.defaultComponents),
            mergedPopperProps: defaultPopperProps
        }, // Event Handlers
        // ==============================
        this.handleTargetKeyDown = (event)=>{
            switch(event.key){
                case 'ArrowDown':
                    this.open();
                    break;
                default:
            }
        }, this.handleKeyDown = (event)=>{
            //We shouldn't close PopupSelect on tab event if there are custom interactive element.
            const tabEvent = event.key === 'Tab' && event.shiftKey || event.key === 'Tab';
            if (this.props.shouldCloseMenuOnTab && tabEvent) this.close();
            switch(event.key){
                case 'Escape':
                case 'Esc':
                    this.close();
                    if (this.props.shouldPreventEscapePropagation) event.stopPropagation();
                    break;
                default:
            }
            if (this.props.onKeyDown) /* @ts-ignore - updating type of event React.KeyboardEvent effects the unbindWindowsKeyDown listener. Check if this can be fixed once the component gets refactor to functional */ this.props.onKeyDown(event);
        }, this.handleClick = ({ target })=>{
            const { isOpen } = this.state;
            // appease flow
            if (!(target instanceof Element)) return;
            // NOTE: Why not use the <Blanket /> component to close?
            // We don't want to interupt the user's flow. Taking this approach allows
            // user to click "through" to other elements and close the popout.
            if (isOpen && this.menuRef && !this.menuRef.contains(target)) this.close();
            // open on target click -- we can't trust consumers to spread the onClick
            // property to the target
            if (!isOpen && this.targetRef && this.targetRef.contains(target)) this.open();
        }, this.handleSelectChange = (value, actionMeta)=>{
            const { closeMenuOnSelect, onChange } = this.props;
            if (closeMenuOnSelect && actionMeta.action !== 'clear') this.close();
            if (onChange) onChange(value, actionMeta);
        }, this.handleFirstPopperUpdate = ()=>{
            // When the popup opens it's focused into. Since the popup is inside a portal, it's position is
            // initially set to 0,0 - this causes the window scroll position to jump to the top. To prevent
            // this we defer enabling the focus-lock until after Popper has positioned the popup the first time.
            this.setState({
                focusLockEnabled: true
            });
        }, // Internal Lifecycle
        // ==============================
        /**
   * Opens the popup
   *
   * @param options.controlOverride  - Force the popup to open when it's open state is being controlled
   */ this.open = (options)=>{
            const { onOpen, onMenuOpen } = this.props;
            if (!(options === null || options === void 0 ? void 0 : options.controlOverride) && this.isOpenControlled) // Prevent popup opening if it's open state is already being controlled
            return;
            if (onOpen) onOpen();
            if (onMenuOpen) onMenuOpen();
            this.setState({
                isOpen: true
            }, ()=>{
                var _this_selectRef_select;
                if (this.selectRef) (_this_selectRef_select = this.selectRef.select) === null || _this_selectRef_select === void 0 ? void 0 : _this_selectRef_select.openMenu('first');
            });
            if (typeof window === 'undefined') return;
            this.unbindWindowKeydown = (0, _bindEventListener.bind)(window, {
                type: 'keydown',
                listener: this.handleKeyDown,
                options: {
                    capture: true
                }
            });
        }, /**
   * Closes the popup
   *
   * @param options.controlOverride  - Force the popup to close when it's open state is being controlled
   */ this.close = (options)=>{
            var _this_unbindWindowKeydown, _this;
            //@ts-ignore react-select unsupported props
            const { onClose, onMenuClose } = this.props;
            if (!(options === null || options === void 0 ? void 0 : options.controlOverride) && this.isOpenControlled) // Prevent popup closing if it's open state is already being controlled
            return;
            if (onClose) onClose();
            if (onMenuClose) onMenuClose();
            this.setState({
                isOpen: false
            });
            this.setState({
                focusLockEnabled: false
            });
            if (this.targetRef != null) this.targetRef.focus();
            if (typeof window === 'undefined') return;
            (_this_unbindWindowKeydown = (_this = this).unbindWindowKeydown) === null || _this_unbindWindowKeydown === void 0 ? void 0 : _this_unbindWindowKeydown.call(_this);
            this.unbindWindowKeydown = null;
        }, // Refs
        // ==============================
        this.resolveTargetRef = (popperRef)=>(ref)=>{
                // avoid thrashing fn calls
                if (!this.targetRef && popperRef && ref) {
                    this.targetRef = ref;
                    if (typeof popperRef === 'function') popperRef(ref);
                    else popperRef.current = ref;
                }
            }, this.resolveMenuRef = (popperRef)=>(ref)=>{
                this.menuRef = ref;
                if (typeof popperRef === 'function') popperRef(ref);
                else popperRef.current = ref;
            }, this.getSelectRef = (ref)=>{
            this.selectRef = ref;
        }, // Utils
        // ==============================
        // account for groups when counting options
        // this may need to be recursive, right now it just counts one level
        this.getItemCount = ()=>{
            const { options } = this.props;
            let count = 0;
            options.forEach((groupOrOption)=>{
                if (groupOrOption.options) groupOrOption.options.forEach(()=>count++);
                else count++;
            });
            return count;
        }, this.getMaxHeight = ()=>{
            var _this_selectRef_select;
            const { maxMenuHeight } = this.props;
            if (!this.selectRef) return maxMenuHeight;
            // subtract the control height to maintain consistency
            const showSearchControl = this.showSearchControl();
            const controlRef = (_this_selectRef_select = this.selectRef.select) === null || _this_selectRef_select === void 0 ? void 0 : _this_selectRef_select.controlRef;
            const offsetHeight = showSearchControl && controlRef ? controlRef.offsetHeight : 0;
            const maxHeight = maxMenuHeight - offsetHeight;
            return maxHeight;
        }, // if the threshold is exceeded, AND isSearchable is true, then display the search control
        this.showSearchControl = ()=>{
            const { searchThreshold, isSearchable } = this.props;
            return isSearchable && this.getItemCount() > searchThreshold;
        }, // Renderers
        // ==============================
        this.renderSelect = (id)=>{
            const _this_props = this.props, { footer, label, maxMenuWidth, minMenuWidth, placeholder, target: _target, testId, onMenuOpen: _onMenuOpen, onMenuClose: _onMenuClose } = _this_props, props = (0, _objectWithoutProperties._)(_this_props, [
                "footer",
                "label",
                "maxMenuWidth",
                "minMenuWidth",
                "placeholder",
                "target",
                "testId",
                "onMenuOpen",
                "onMenuClose"
            ]);
            const { focusLockEnabled, isOpen, mergedComponents, mergedPopperProps } = this.state;
            const showSearchControl = this.showSearchControl();
            const portalDestination = canUseDOM() ? document.body : null;
            if (!portalDestination || !isOpen) return null;
            const selectComponents = (0, _objectSpreadProps._)((0, _objectSpread._)({}, mergedComponents), {
                Control: showSearchControl ? mergedComponents.Control : (0, _dummyControl.DummyControl)
            });
            // @ts-ignore - TS7030: Not all code paths return a value - causing issues for help-center local consumption with TS 5.9.2
            const getLabel = ()=>{
                if (label) return label;
                else if (typeof placeholder === 'string') return placeholder;
                return undefined;
            };
            const popper = /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactPopper.Popper), (0, _objectSpreadProps._)((0, _objectSpread._)({}, mergedPopperProps), {
                onFirstUpdate: (state)=>{
                    var _mergedPopperProps_onFirstUpdate;
                    this.handleFirstPopperUpdate();
                    (_mergedPopperProps_onFirstUpdate = mergedPopperProps.onFirstUpdate) === null || _mergedPopperProps_onFirstUpdate === void 0 ? void 0 : _mergedPopperProps_onFirstUpdate.call(mergedPopperProps, state);
                },
                children: ({ placement, ref, style })=>/*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _menuDialog.MenuDialog), {
                        // There is not a limited amount of values for the widths, so they need to remain dynamic.
                        // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
                        style: (0, _objectSpreadProps._)((0, _objectSpread._)({}, style), {
                            maxWidth: maxMenuWidth,
                            minWidth: minMenuWidth
                        }),
                        "data-placement": placement,
                        id: id,
                        testId: testId,
                        ref: this.resolveMenuRef(ref),
                        children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _reactFocusLockDefault.default), {
                            disabled: !focusLockEnabled,
                            returnFocus: true,
                            children: [
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _selectDefault.default), (0, _objectSpreadProps._)((0, _objectSpread._)({
                                    label: getLabel(),
                                    backspaceRemovesValue: false,
                                    controlShouldRenderValue: false,
                                    isClearable: false,
                                    tabSelectsValue: false,
                                    menuIsOpen: true,
                                    placeholder: placeholder,
                                    ref: this.getSelectRef
                                }, props), {
                                    isSearchable: showSearchControl,
                                    styles: (0, _reactSelect.mergeStyles)(this.defaultStyles, props.styles || {}),
                                    maxMenuHeight: this.getMaxHeight(),
                                    components: selectComponents,
                                    onChange: this.handleSelectChange,
                                    testId: testId
                                })),
                                footer
                            ]
                        })
                    })
            }));
            return mergedPopperProps.strategy === 'fixed' ? popper : /*#__PURE__*/ (0, _reactDom.createPortal)(popper, portalDestination);
        }, this.handleOpenLayerObserverCloseSignal = ()=>{
            this.close();
        };
    }
}
PopupSelect.defaultProps = {
    closeMenuOnSelect: true,
    shouldCloseMenuOnTab: true,
    components: {},
    maxMenuHeight: 300,
    maxMenuWidth: 440,
    minMenuWidth: 220,
    popperProps: {},
    isSearchable: true,
    searchThreshold: 5,
    styles: {},
    options: []
};

},{"@swc/helpers/_/_object_spread":"9gdrV","@swc/helpers/_/_object_spread_props":"kANqQ","@swc/helpers/_/_object_without_properties":"6HqIM","react/jsx-runtime":"bGvcw","react":"ltHCL","bind-event-listener":"bjeUU","react-dom":"7Lblg","react-focus-lock":"1FqTV","react-popper":"bGSxp","shallow-equal":"cyugw","@atlaskit/ds-lib/id-provider":"8jtsV","@atlaskit/platform-feature-flags":"8rD2i","@atlaskit/react-select":"1iF04","../select":"iPOlk","./components":"cwsRW","./dummy-control":"7xr4O","./menu-dialog":"YEdyp","./notify-open-layer-observer":"dSvMn","./popup-select-top-layer":"8Eq2A","@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"1FqTV":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _combination = require("./Combination");
var _combinationDefault = parcelHelpers.interopDefault(_combination);
var _ui = require("./UI");
parcelHelpers.exportAll(_ui, exports);
exports.default = (0, _combinationDefault.default);

},{"./Combination":"8PJJO","./UI":false,"@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"8PJJO":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _objectWithoutPropertiesLoose = require("@babel/runtime/helpers/esm/objectWithoutPropertiesLoose");
var _objectWithoutPropertiesLooseDefault = parcelHelpers.interopDefault(_objectWithoutPropertiesLoose);
var _extends = require("@babel/runtime/helpers/esm/extends");
var _extendsDefault = parcelHelpers.interopDefault(_extends);
var _react = require("react");
var _lock = require("./Lock");
var _lockDefault = parcelHelpers.interopDefault(_lock);
var _trap = require("./Trap");
var _trapDefault = parcelHelpers.interopDefault(_trap);
var FocusLockCombination = /*#__PURE__*/ _react.forwardRef(function FocusLockUICombination(props, ref) {
    return /*#__PURE__*/ _react.createElement((0, _lockDefault.default), (0, _extendsDefault.default)({
        sideCar: (0, _trapDefault.default),
        ref: ref
    }, props));
});
var _ref = (0, _lockDefault.default).propTypes || {}, sideCar = _ref.sideCar, propTypes = (0, _objectWithoutPropertiesLooseDefault.default)(_ref, [
    "sideCar"
]);
FocusLockCombination.propTypes = {};
exports.default = FocusLockCombination;

},{"@babel/runtime/helpers/esm/objectWithoutPropertiesLoose":"5JG3D","@babel/runtime/helpers/esm/extends":"3LZYG","react":"ltHCL","./Lock":"crgQn","./Trap":"gpfpv","@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"crgQn":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _extends = require("@babel/runtime/helpers/esm/extends");
var _extendsDefault = parcelHelpers.interopDefault(_extends);
var _react = require("react");
var _propTypes = require("prop-types");
var _constants = require("focus-lock/constants");
var _useCallbackRef = require("use-callback-ref");
var _focusGuard = require("./FocusGuard");
var _medium = require("./medium");
var _scope = require("./scope");
var emptyArray = [];
var FocusLock = /*#__PURE__*/ _react.forwardRef(function FocusLockUI(props, parentRef) {
    var _extends2;
    var _React$useState = _react.useState(), realObserved = _React$useState[0], setObserved = _React$useState[1];
    var observed = _react.useRef();
    var isActive = _react.useRef(false);
    var originalFocusedElement = _react.useRef(null);
    var _React$useState2 = _react.useState({}), update = _React$useState2[1];
    var children = props.children, _props$disabled = props.disabled, disabled = _props$disabled === void 0 ? false : _props$disabled, _props$noFocusGuards = props.noFocusGuards, noFocusGuards = _props$noFocusGuards === void 0 ? false : _props$noFocusGuards, _props$persistentFocu = props.persistentFocus, persistentFocus = _props$persistentFocu === void 0 ? false : _props$persistentFocu, _props$crossFrame = props.crossFrame, crossFrame = _props$crossFrame === void 0 ? true : _props$crossFrame, _props$autoFocus = props.autoFocus, autoFocus = _props$autoFocus === void 0 ? true : _props$autoFocus, allowTextSelection = props.allowTextSelection, group = props.group, className = props.className, whiteList = props.whiteList, hasPositiveIndices = props.hasPositiveIndices, _props$shards = props.shards, shards = _props$shards === void 0 ? emptyArray : _props$shards, _props$as = props.as, Container = _props$as === void 0 ? 'div' : _props$as, _props$lockProps = props.lockProps, containerProps = _props$lockProps === void 0 ? {} : _props$lockProps, SideCar = props.sideCar, _props$returnFocus = props.returnFocus, shouldReturnFocus = _props$returnFocus === void 0 ? false : _props$returnFocus, focusOptions = props.focusOptions, onActivationCallback = props.onActivation, onDeactivationCallback = props.onDeactivation;
    var _React$useState3 = _react.useState({}), id = _React$useState3[0];
    var onActivation = _react.useCallback(function(_ref) {
        var captureFocusRestore = _ref.captureFocusRestore;
        if (!originalFocusedElement.current) {
            var _document;
            var activeElement = (_document = document) == null ? void 0 : _document.activeElement;
            originalFocusedElement.current = activeElement;
            if (activeElement !== document.body) originalFocusedElement.current = captureFocusRestore(activeElement);
        }
        if (observed.current && onActivationCallback) onActivationCallback(observed.current);
        isActive.current = true;
        update();
    }, [
        onActivationCallback
    ]);
    var onDeactivation = _react.useCallback(function() {
        isActive.current = false;
        if (onDeactivationCallback) onDeactivationCallback(observed.current);
        update();
    }, [
        onDeactivationCallback
    ]);
    var returnFocus = _react.useCallback(function(allowDefer) {
        var focusRestore = originalFocusedElement.current;
        if (focusRestore) {
            var returnFocusTo = (typeof focusRestore === 'function' ? focusRestore() : focusRestore) || document.body;
            var howToReturnFocus = typeof shouldReturnFocus === 'function' ? shouldReturnFocus(returnFocusTo) : shouldReturnFocus;
            if (howToReturnFocus) {
                var returnFocusOptions = typeof howToReturnFocus === 'object' ? howToReturnFocus : undefined;
                originalFocusedElement.current = null;
                if (allowDefer) Promise.resolve().then(function() {
                    return returnFocusTo.focus(returnFocusOptions);
                });
                else returnFocusTo.focus(returnFocusOptions);
            }
        }
    }, [
        shouldReturnFocus
    ]);
    var onFocus = _react.useCallback(function(event) {
        if (isActive.current) (0, _medium.mediumFocus).useMedium(event);
    }, []);
    var onBlur = (0, _medium.mediumBlur).useMedium;
    var setObserveNode = _react.useCallback(function(newObserved) {
        if (observed.current !== newObserved) {
            observed.current = newObserved;
            setObserved(newObserved);
        }
    }, []);
    var lockProps = (0, _extendsDefault.default)((_extends2 = {}, _extends2[_constants.FOCUS_DISABLED] = disabled && 'disabled', _extends2[_constants.FOCUS_GROUP] = group, _extends2), containerProps);
    var hasLeadingGuards = noFocusGuards !== true;
    var hasTailingGuards = hasLeadingGuards && noFocusGuards !== 'tail';
    var mergedRef = (0, _useCallbackRef.useMergeRefs)([
        parentRef,
        setObserveNode
    ]);
    var focusScopeValue = _react.useMemo(function() {
        return {
            observed: observed,
            shards: shards,
            enabled: !disabled,
            active: isActive.current
        };
    }, [
        disabled,
        isActive.current,
        shards,
        realObserved
    ]);
    return /*#__PURE__*/ _react.createElement(_react.Fragment, null, hasLeadingGuards && [
        /*#__PURE__*/ _react.createElement("div", {
            key: "guard-first",
            "data-focus-guard": true,
            tabIndex: disabled ? -1 : 0,
            style: (0, _focusGuard.hiddenGuard)
        }),
        hasPositiveIndices ? /*#__PURE__*/ _react.createElement("div", {
            key: "guard-nearest",
            "data-focus-guard": true,
            tabIndex: disabled ? -1 : 1,
            style: (0, _focusGuard.hiddenGuard)
        }) : null
    ], !disabled && /*#__PURE__*/ _react.createElement(SideCar, {
        id: id,
        sideCar: (0, _medium.mediumSidecar),
        observed: realObserved,
        disabled: disabled,
        persistentFocus: persistentFocus,
        crossFrame: crossFrame,
        autoFocus: autoFocus,
        whiteList: whiteList,
        shards: shards,
        onActivation: onActivation,
        onDeactivation: onDeactivation,
        returnFocus: returnFocus,
        focusOptions: focusOptions
    }), /*#__PURE__*/ _react.createElement(Container, (0, _extendsDefault.default)({
        ref: mergedRef
    }, lockProps, {
        className: className,
        onBlur: onBlur,
        onFocus: onFocus
    }), /*#__PURE__*/ _react.createElement((0, _scope.focusScope).Provider, {
        value: focusScopeValue
    }, children)), hasTailingGuards && /*#__PURE__*/ _react.createElement("div", {
        "data-focus-guard": true,
        tabIndex: disabled ? -1 : 0,
        style: (0, _focusGuard.hiddenGuard)
    }));
});
FocusLock.propTypes = {};
exports.default = FocusLock;

},{"@babel/runtime/helpers/esm/extends":"3LZYG","react":"ltHCL","prop-types":"3k3Jl","focus-lock/constants":"drTLK","use-callback-ref":"eIq7b","./FocusGuard":"1QfV3","./medium":"275di","./scope":"28GTX","@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"drTLK":[function(require,module,exports,__globalThis) {
/**
 * defines a focus group
 */ var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "FOCUS_GROUP", ()=>FOCUS_GROUP);
parcelHelpers.export(exports, "FOCUS_DISABLED", ()=>FOCUS_DISABLED);
parcelHelpers.export(exports, "FOCUS_ALLOW", ()=>FOCUS_ALLOW);
parcelHelpers.export(exports, "FOCUS_AUTO", ()=>FOCUS_AUTO);
parcelHelpers.export(exports, "FOCUS_NO_AUTOFOCUS", ()=>FOCUS_NO_AUTOFOCUS);
var FOCUS_GROUP = 'data-focus-lock';
var FOCUS_DISABLED = 'data-focus-lock-disabled';
var FOCUS_ALLOW = 'data-no-focus-lock';
var FOCUS_AUTO = 'data-autofocus-inside';
var FOCUS_NO_AUTOFOCUS = 'data-no-autofocus';

},{"@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"eIq7b":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "assignRef", ()=>(0, _assignRef.assignRef));
// callback ref
parcelHelpers.export(exports, "useCallbackRef", ()=>(0, _useRef.useCallbackRef));
parcelHelpers.export(exports, "createCallbackRef", ()=>(0, _createRef.createCallbackRef));
// merge ref
parcelHelpers.export(exports, "mergeRefs", ()=>(0, _mergeRef.mergeRefs));
parcelHelpers.export(exports, "useMergeRefs", ()=>(0, _useMergeRef.useMergeRefs));
// transform ref
parcelHelpers.export(exports, "useTransformRef", ()=>(0, _useTransformRef.useTransformRef));
parcelHelpers.export(exports, "transformRef", ()=>(0, _transformRef.transformRef));
// refToCallback
parcelHelpers.export(exports, "refToCallback", ()=>(0, _refToCallback.refToCallback));
parcelHelpers.export(exports, "useRefToCallback", ()=>(0, _refToCallback.useRefToCallback));
var _assignRef = require("./assignRef");
var _useRef = require("./useRef");
var _createRef = require("./createRef");
var _mergeRef = require("./mergeRef");
var _useMergeRef = require("./useMergeRef");
var _useTransformRef = require("./useTransformRef");
var _transformRef = require("./transformRef");
var _refToCallback = require("./refToCallback");

},{"./assignRef":false,"./useRef":false,"./createRef":false,"./mergeRef":"04pp4","./useMergeRef":"edamM","./useTransformRef":false,"./transformRef":false,"./refToCallback":false,"@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"8V88a":[function(require,module,exports,__globalThis) {
/**
 * Assigns a value for a given ref, no matter of the ref format
 * @param {RefObject} ref - a callback function or ref object
 * @param value - a new value
 *
 * @see https://github.com/theKashey/use-callback-ref#assignref
 * @example
 * const refObject = useRef();
 * const refFn = (ref) => {....}
 *
 * assignRef(refObject, "refValue");
 * assignRef(refFn, "refValue");
 */ var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "assignRef", ()=>assignRef);
function assignRef(ref, value) {
    if (typeof ref === 'function') ref(value);
    else if (ref) ref.current = value;
    return ref;
}

},{"@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"lVyKe":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
/**
 * creates a MutableRef with ref change callback
 * @param initialValue - initial ref value
 * @param {Function} callback - a callback to run when value changes
 *
 * @example
 * const ref = useCallbackRef(0, (newValue, oldValue) => console.log(oldValue, '->', newValue);
 * ref.current = 1;
 * // prints 0 -> 1
 *
 * @see https://reactjs.org/docs/hooks-reference.html#useref
 * @see https://github.com/theKashey/use-callback-ref#usecallbackref---to-replace-reactuseref
 * @returns {MutableRefObject}
 */ parcelHelpers.export(exports, "useCallbackRef", ()=>useCallbackRef);
var _react = require("react");
function useCallbackRef(initialValue, callback) {
    var ref = (0, _react.useState)(function() {
        return {
            // value
            value: initialValue,
            // last callback
            callback: callback,
            // "memoized" public interface
            facade: {
                get current () {
                    return ref.value;
                },
                set current (value){
                    var last = ref.value;
                    if (last !== value) {
                        ref.value = value;
                        ref.callback(value, last);
                    }
                }
            }
        };
    })[0];
    // update callback
    ref.callback = callback;
    return ref.facade;
}

},{"react":"ltHCL","@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"ihUvw":[function(require,module,exports,__globalThis) {
/**
 * creates a Ref object with on change callback
 * @param callback
 * @returns {RefObject}
 *
 * @see {@link useCallbackRef}
 * @see https://reactjs.org/docs/refs-and-the-dom.html#creating-refs
 */ var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "createCallbackRef", ()=>createCallbackRef);
function createCallbackRef(callback) {
    var current = null;
    return {
        get current () {
            return current;
        },
        set current (value){
            var last = current;
            if (last !== value) {
                current = value;
                callback(value, last);
            }
        }
    };
}

},{"@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"04pp4":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
/**
 * Merges two or more refs together providing a single interface to set their value
 * @param {RefObject|Ref} refs
 * @returns {MutableRefObject} - a new ref, which translates all changes to {refs}
 *
 * @see {@link useMergeRefs} to be used in ReactComponents
 * @example
 * const Component = React.forwardRef((props, ref) => {
 *   const ownRef = useRef();
 *   const domRef = mergeRefs([ref, ownRef]); // 👈 merge together
 *   return <div ref={domRef}>...</div>
 * }
 */ parcelHelpers.export(exports, "mergeRefs", ()=>mergeRefs);
var _assignRef = require("./assignRef");
var _createRef = require("./createRef");
function mergeRefs(refs) {
    return (0, _createRef.createCallbackRef)(function(newValue) {
        return refs.forEach(function(ref) {
            return (0, _assignRef.assignRef)(ref, newValue);
        });
    });
}

},{"./assignRef":"8V88a","./createRef":"ihUvw","@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"edamM":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
/**
 * Merges two or more refs together providing a single interface to set their value
 * @param {RefObject|Ref} refs
 * @returns {MutableRefObject} - a new ref, which translates all changes to {refs}
 *
 * @see {@link mergeRefs} a version without buit-in memoization
 * @see https://github.com/theKashey/use-callback-ref#usemergerefs
 * @example
 * const Component = React.forwardRef((props, ref) => {
 *   const ownRef = useRef();
 *   const domRef = useMergeRefs([ref, ownRef]); // 👈 merge together
 *   return <div ref={domRef}>...</div>
 * }
 */ parcelHelpers.export(exports, "useMergeRefs", ()=>useMergeRefs);
var _react = require("react");
var _assignRef = require("./assignRef");
var _useRef = require("./useRef");
var useIsomorphicLayoutEffect = typeof window !== 'undefined' ? _react.useLayoutEffect : _react.useEffect;
var currentValues = new WeakMap();
function useMergeRefs(refs, defaultValue) {
    var callbackRef = (0, _useRef.useCallbackRef)(defaultValue || null, function(newValue) {
        return refs.forEach(function(ref) {
            return (0, _assignRef.assignRef)(ref, newValue);
        });
    });
    // handle refs changes - added or removed
    useIsomorphicLayoutEffect(function() {
        var oldValue = currentValues.get(callbackRef);
        if (oldValue) {
            var prevRefs_1 = new Set(oldValue);
            var nextRefs_1 = new Set(refs);
            var current_1 = callbackRef.current;
            prevRefs_1.forEach(function(ref) {
                if (!nextRefs_1.has(ref)) (0, _assignRef.assignRef)(ref, null);
            });
            nextRefs_1.forEach(function(ref) {
                if (!prevRefs_1.has(ref)) (0, _assignRef.assignRef)(ref, current_1);
            });
        }
        currentValues.set(callbackRef, refs);
    }, [
        refs
    ]);
    return callbackRef;
}

},{"react":"ltHCL","./assignRef":"8V88a","./useRef":"lVyKe","@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"1QfV3":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "hiddenGuard", ()=>hiddenGuard);
var _react = require("react");
var _propTypes = require("prop-types");
var _propTypesDefault = parcelHelpers.interopDefault(_propTypes);
var hiddenGuard = {
    width: '1px',
    height: '0px',
    padding: 0,
    overflow: 'hidden',
    position: 'fixed',
    top: '1px',
    left: '1px'
};
var InFocusGuard = function InFocusGuard(_ref) {
    var _ref$children = _ref.children, children = _ref$children === void 0 ? null : _ref$children;
    return /*#__PURE__*/ _react.createElement(_react.Fragment, null, /*#__PURE__*/ _react.createElement("div", {
        key: "guard-first",
        "data-focus-guard": true,
        "data-focus-auto-guard": true,
        style: hiddenGuard
    }), children, children && /*#__PURE__*/ _react.createElement("div", {
        key: "guard-last",
        "data-focus-guard": true,
        "data-focus-auto-guard": true,
        style: hiddenGuard
    }));
};
InFocusGuard.propTypes = {};
exports.default = InFocusGuard;

},{"react":"ltHCL","prop-types":"3k3Jl","@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"275di":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "mediumFocus", ()=>mediumFocus);
parcelHelpers.export(exports, "mediumBlur", ()=>mediumBlur);
parcelHelpers.export(exports, "mediumEffect", ()=>mediumEffect);
parcelHelpers.export(exports, "mediumSidecar", ()=>mediumSidecar);
var _useSidecar = require("use-sidecar");
var mediumFocus = (0, _useSidecar.createMedium)({}, function(_ref) {
    var target = _ref.target, currentTarget = _ref.currentTarget;
    return {
        target: target,
        currentTarget: currentTarget
    };
});
var mediumBlur = (0, _useSidecar.createMedium)();
var mediumEffect = (0, _useSidecar.createMedium)();
var mediumSidecar = (0, _useSidecar.createSidecarMedium)({
    async: true,
    ssr: typeof document !== 'undefined'
});

},{"use-sidecar":"1J8Yv","@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"1J8Yv":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "sidecar", ()=>(0, _hoc.sidecar));
parcelHelpers.export(exports, "useSidecar", ()=>(0, _hook.useSidecar));
parcelHelpers.export(exports, "setConfig", ()=>(0, _config.setConfig));
parcelHelpers.export(exports, "createMedium", ()=>(0, _medium.createMedium));
parcelHelpers.export(exports, "createSidecarMedium", ()=>(0, _medium.createSidecarMedium));
parcelHelpers.export(exports, "renderCar", ()=>(0, _renderProp.renderCar));
parcelHelpers.export(exports, "exportSidecar", ()=>(0, _exports.exportSidecar));
var _hoc = require("./hoc");
var _hook = require("./hook");
var _config = require("./config");
var _medium = require("./medium");
var _renderProp = require("./renderProp");
var _exports = require("./exports");

},{"./hoc":false,"./hook":false,"./config":false,"./medium":"gOuaJ","./renderProp":false,"./exports":false,"@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"gOuaJ":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "createMedium", ()=>createMedium);
// eslint-disable-next-line @typescript-eslint/ban-types
parcelHelpers.export(exports, "createSidecarMedium", ()=>createSidecarMedium);
var _tslib = require("tslib");
function ItoI(a) {
    return a;
}
function innerCreateMedium(defaults, middleware) {
    if (middleware === void 0) middleware = ItoI;
    var buffer = [];
    var assigned = false;
    var medium = {
        read: function() {
            if (assigned) throw new Error('Sidecar: could not `read` from an `assigned` medium. `read` could be used only with `useMedium`.');
            if (buffer.length) return buffer[buffer.length - 1];
            return defaults;
        },
        useMedium: function(data) {
            var item = middleware(data, assigned);
            buffer.push(item);
            return function() {
                buffer = buffer.filter(function(x) {
                    return x !== item;
                });
            };
        },
        assignSyncMedium: function(cb) {
            assigned = true;
            while(buffer.length){
                var cbs = buffer;
                buffer = [];
                cbs.forEach(cb);
            }
            buffer = {
                push: function(x) {
                    return cb(x);
                },
                filter: function() {
                    return buffer;
                }
            };
        },
        assignMedium: function(cb) {
            assigned = true;
            var pendingQueue = [];
            if (buffer.length) {
                var cbs = buffer;
                buffer = [];
                cbs.forEach(cb);
                pendingQueue = buffer;
            }
            var executeQueue = function() {
                var cbs = pendingQueue;
                pendingQueue = [];
                cbs.forEach(cb);
            };
            var cycle = function() {
                return Promise.resolve().then(executeQueue);
            };
            cycle();
            buffer = {
                push: function(x) {
                    pendingQueue.push(x);
                    cycle();
                },
                filter: function(filter) {
                    pendingQueue = pendingQueue.filter(filter);
                    return buffer;
                }
            };
        }
    };
    return medium;
}
function createMedium(defaults, middleware) {
    if (middleware === void 0) middleware = ItoI;
    return innerCreateMedium(defaults, middleware);
}
function createSidecarMedium(options) {
    if (options === void 0) options = {};
    var medium = innerCreateMedium(null);
    medium.options = (0, _tslib.__assign)({
        async: true,
        ssr: false
    }, options);
    return medium;
}

},{"tslib":"6MhhU","@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"28GTX":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "focusScope", ()=>focusScope);
var _react = require("react");
var focusScope = /*#__PURE__*/ (0, _react.createContext)(undefined);

},{"react":"ltHCL","@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"gpfpv":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _react = require("react");
var _propTypes = require("prop-types");
var _propTypesDefault = parcelHelpers.interopDefault(_propTypes);
var _reactClientsideEffect = require("react-clientside-effect");
var _reactClientsideEffectDefault = parcelHelpers.interopDefault(_reactClientsideEffect);
var _focusLock = require("focus-lock");
var _util = require("./util");
var _medium = require("./medium");
var focusOnBody = function focusOnBody() {
    return document && document.activeElement === document.body;
};
var isFreeFocus = function isFreeFocus() {
    return focusOnBody() || (0, _focusLock.focusIsHidden)();
};
var lastActiveTrap = null;
var lastActiveFocus = null;
var lastPortaledElement = null;
var focusWasOutsideWindow = false;
var defaultWhitelist = function defaultWhitelist() {
    return true;
};
var focusWhitelisted = function focusWhitelisted(activeElement) {
    return (lastActiveTrap.whiteList || defaultWhitelist)(activeElement);
};
var recordPortal = function recordPortal(observerNode, portaledElement) {
    lastPortaledElement = {
        observerNode: observerNode,
        portaledElement: portaledElement
    };
};
var focusIsPortaledPair = function focusIsPortaledPair(element) {
    return lastPortaledElement && lastPortaledElement.portaledElement === element;
};
function autoGuard(startIndex, end, step, allNodes) {
    var lastGuard = null;
    var i = startIndex;
    do {
        var item = allNodes[i];
        if (item.guard) {
            if (item.node.dataset.focusAutoGuard) lastGuard = item;
        } else if (item.lockItem) {
            if (i !== startIndex) return;
            lastGuard = null;
        } else break;
    }while ((i += step) !== end);
    if (lastGuard) lastGuard.node.tabIndex = 0;
}
var focusWasOutside = function focusWasOutside(crossFrameOption) {
    if (crossFrameOption) return Boolean(focusWasOutsideWindow);
    return focusWasOutsideWindow === 'meanwhile';
};
var checkInHost = function checkInHost(check, el, boundary) {
    return el && (el.host === check && (!el.activeElement || boundary.contains(el.activeElement)) || el.parentNode && checkInHost(check, el.parentNode, boundary));
};
var withinHost = function withinHost(activeElement, workingArea) {
    return workingArea.some(function(area) {
        return checkInHost(activeElement, area, area);
    });
};
var activateTrap = function activateTrap() {
    var result = false;
    if (lastActiveTrap) {
        var _lastActiveTrap = lastActiveTrap, observed = _lastActiveTrap.observed, persistentFocus = _lastActiveTrap.persistentFocus, autoFocus = _lastActiveTrap.autoFocus, shards = _lastActiveTrap.shards, crossFrame = _lastActiveTrap.crossFrame, focusOptions = _lastActiveTrap.focusOptions;
        var workingNode = observed || lastPortaledElement && lastPortaledElement.portaledElement;
        var activeElement = document && document.activeElement;
        if (workingNode) {
            var workingArea = [
                workingNode
            ].concat(shards.map((0, _util.extractRef)).filter(Boolean));
            if (!activeElement || focusWhitelisted(activeElement)) {
                if (persistentFocus || focusWasOutside(crossFrame) || !isFreeFocus() || !lastActiveFocus && autoFocus) {
                    if (workingNode && !((0, _focusLock.focusInside)(workingArea) || activeElement && withinHost(activeElement, workingArea) || focusIsPortaledPair(activeElement, workingNode))) {
                        if (document && !lastActiveFocus && activeElement && !autoFocus) {
                            if (activeElement.blur) activeElement.blur();
                            document.body.focus();
                        } else {
                            result = (0, _focusLock.moveFocusInside)(workingArea, lastActiveFocus, {
                                focusOptions: focusOptions
                            });
                            lastPortaledElement = {};
                        }
                    }
                    focusWasOutsideWindow = false;
                    lastActiveFocus = document && document.activeElement;
                }
            }
            if (document && activeElement !== document.activeElement && document.querySelector('[data-focus-auto-guard]')) {
                var newActiveElement = document && document.activeElement;
                var allNodes = (0, _focusLock.expandFocusableNodes)(workingArea);
                var focusedIndex = allNodes.map(function(_ref) {
                    var node = _ref.node;
                    return node;
                }).indexOf(newActiveElement);
                if (focusedIndex > -1) {
                    allNodes.filter(function(_ref2) {
                        var guard = _ref2.guard, node = _ref2.node;
                        return guard && node.dataset.focusAutoGuard;
                    }).forEach(function(_ref3) {
                        var node = _ref3.node;
                        return node.removeAttribute('tabIndex');
                    });
                    autoGuard(focusedIndex, allNodes.length, 1, allNodes);
                    autoGuard(focusedIndex, -1, -1, allNodes);
                }
            }
        }
    }
    return result;
};
var onTrap = function onTrap(event) {
    if (activateTrap() && event) {
        event.stopPropagation();
        event.preventDefault();
    }
};
var onBlur = function onBlur() {
    return (0, _util.deferAction)(activateTrap);
};
var onFocus = function onFocus(event) {
    var source = event.target;
    var currentNode = event.currentTarget;
    if (!currentNode.contains(source)) recordPortal(currentNode, source);
};
var FocusWatcher = function FocusWatcher() {
    return null;
};
var FocusTrap = function FocusTrap(_ref4) {
    var children = _ref4.children;
    return /*#__PURE__*/ _react.createElement("div", {
        onBlur: onBlur,
        onFocus: onFocus
    }, children);
};
FocusTrap.propTypes = {};
var onWindowBlur = function onWindowBlur() {
    focusWasOutsideWindow = 'just';
    (0, _util.deferAction)(function() {
        focusWasOutsideWindow = 'meanwhile';
    });
};
var attachHandler = function attachHandler() {
    document.addEventListener('focusin', onTrap);
    document.addEventListener('focusout', onBlur);
    window.addEventListener('blur', onWindowBlur);
};
var detachHandler = function detachHandler() {
    document.removeEventListener('focusin', onTrap);
    document.removeEventListener('focusout', onBlur);
    window.removeEventListener('blur', onWindowBlur);
};
function reducePropsToState(propsList) {
    return propsList.filter(function(_ref5) {
        var disabled = _ref5.disabled;
        return !disabled;
    });
}
var focusLockAPI = {
    moveFocusInside: (0, _focusLock.moveFocusInside),
    focusInside: (0, _focusLock.focusInside),
    focusNextElement: (0, _focusLock.focusNextElement),
    focusPrevElement: (0, _focusLock.focusPrevElement),
    focusFirstElement: (0, _focusLock.focusFirstElement),
    focusLastElement: (0, _focusLock.focusLastElement),
    captureFocusRestore: (0, _focusLock.captureFocusRestore)
};
function handleStateChangeOnClient(traps) {
    var trap = traps.slice(-1)[0];
    if (trap && !lastActiveTrap) attachHandler();
    var lastTrap = lastActiveTrap;
    var sameTrap = lastTrap && trap && trap.id === lastTrap.id;
    lastActiveTrap = trap;
    if (lastTrap && !sameTrap) {
        lastTrap.onDeactivation();
        if (!traps.filter(function(_ref6) {
            var id = _ref6.id;
            return id === lastTrap.id;
        }).length) lastTrap.returnFocus(!trap);
    }
    if (trap) {
        lastActiveFocus = null;
        if (!sameTrap || lastTrap.observed !== trap.observed) trap.onActivation(focusLockAPI);
        activateTrap(true);
        (0, _util.deferAction)(activateTrap);
    } else {
        detachHandler();
        lastActiveFocus = null;
    }
}
(0, _medium.mediumFocus).assignSyncMedium(onFocus);
(0, _medium.mediumBlur).assignMedium(onBlur);
(0, _medium.mediumEffect).assignMedium(function(cb) {
    return cb(focusLockAPI);
});
exports.default = (0, _reactClientsideEffectDefault.default)(reducePropsToState, handleStateChangeOnClient)(FocusWatcher);

},{"react":"ltHCL","prop-types":"3k3Jl","react-clientside-effect":"2mo7T","focus-lock":"aqy59","./util":"2gE4f","./medium":"275di","@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"2mo7T":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _inheritsLoose = require("@babel/runtime/helpers/esm/inheritsLoose");
var _inheritsLooseDefault = parcelHelpers.interopDefault(_inheritsLoose);
var _defineProperty = require("@babel/runtime/helpers/esm/defineProperty");
var _definePropertyDefault = parcelHelpers.interopDefault(_defineProperty);
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
function withSideEffect(reducePropsToState, handleStateChangeOnClient) {
    function getDisplayName(WrappedComponent) {
        return WrappedComponent.displayName || WrappedComponent.name || 'Component';
    }
    return function wrap(WrappedComponent) {
        var mountedInstances = [];
        var state;
        function emitChange() {
            state = reducePropsToState(mountedInstances.map(function(instance) {
                return instance.props;
            }));
            handleStateChangeOnClient(state);
        }
        var SideEffect = /*#__PURE__*/ function(_PureComponent) {
            (0, _inheritsLooseDefault.default)(SideEffect, _PureComponent);
            function SideEffect() {
                return _PureComponent.apply(this, arguments) || this;
            }
            // Try to use displayName of wrapped component
            SideEffect.peek = function peek() {
                return state;
            };
            var _proto = SideEffect.prototype;
            _proto.componentDidMount = function componentDidMount() {
                mountedInstances.push(this);
                emitChange();
            };
            _proto.componentDidUpdate = function componentDidUpdate() {
                emitChange();
            };
            _proto.componentWillUnmount = function componentWillUnmount() {
                var index = mountedInstances.indexOf(this);
                mountedInstances.splice(index, 1);
                emitChange();
            };
            _proto.render = function render() {
                return /*#__PURE__*/ (0, _reactDefault.default).createElement(WrappedComponent, this.props);
            };
            return SideEffect;
        }((0, _react.PureComponent));
        (0, _definePropertyDefault.default)(SideEffect, "displayName", "SideEffect(" + getDisplayName(WrappedComponent) + ")");
        return SideEffect;
    };
}
exports.default = withSideEffect;

},{"@babel/runtime/helpers/esm/inheritsLoose":"7Jcdm","@babel/runtime/helpers/esm/defineProperty":"8oXwS","react":"ltHCL","@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"7Jcdm":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>_inheritsLoose);
var _setPrototypeOfJs = require("./setPrototypeOf.js");
var _setPrototypeOfJsDefault = parcelHelpers.interopDefault(_setPrototypeOfJs);
function _inheritsLoose(t, o) {
    t.prototype = Object.create(o.prototype), t.prototype.constructor = t, (0, _setPrototypeOfJsDefault.default)(t, o);
}

},{"./setPrototypeOf.js":"9pigx","@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"9pigx":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>_setPrototypeOf);
function _setPrototypeOf(t, e) {
    return _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function(t, e) {
        return t.__proto__ = e, t;
    }, _setPrototypeOf(t, e);
}

},{"@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"aqy59":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "constants", ()=>constants);
parcelHelpers.export(exports, "focusInside", ()=>//
    (0, _focusInside.focusInside));
parcelHelpers.export(exports, "focusIsHidden", ()=>(0, _focusIsHidden.focusIsHidden));
parcelHelpers.export(exports, "moveFocusInside", ()=>//
    (0, _moveFocusInside.moveFocusInside));
parcelHelpers.export(exports, "focusSolver", ()=>(0, _focusSolver.focusSolver));
parcelHelpers.export(exports, "expandFocusableNodes", ()=>//
    (0, _focusables.expandFocusableNodes));
parcelHelpers.export(exports, "getFocusableNodes", ()=>(0, _domutils.getFocusableNodes));
parcelHelpers.export(exports, "getTabbableNodes", ()=>(0, _domutils.getTabbableNodes));
parcelHelpers.export(exports, "focusNextElement", ()=>//
    (0, _sibling.focusNextElement));
parcelHelpers.export(exports, "focusPrevElement", ()=>(0, _sibling.focusPrevElement));
parcelHelpers.export(exports, "focusFirstElement", ()=>(0, _sibling.focusFirstElement));
parcelHelpers.export(exports, "focusLastElement", ()=>(0, _sibling.focusLastElement));
parcelHelpers.export(exports, "getRelativeFocusable", ()=>(0, _sibling.getRelativeFocusable));
parcelHelpers.export(exports, "captureFocusRestore", ()=>//
    (0, _returnFocus.captureFocusRestore));
var _constants = require("./constants");
var _focusInside = require("./focusInside");
var _focusIsHidden = require("./focusIsHidden");
var _focusSolver = require("./focusSolver");
var _focusables = require("./focusables");
var _moveFocusInside = require("./moveFocusInside");
var _returnFocus = require("./return-focus");
var _sibling = require("./sibling");
var _domutils = require("./utils/DOMutils");
/**
 * magic symbols to control focus behavior from DOM
 * see description of every particular one
 */ var constants = _constants;
/**
 * @deprecated - please use {@link moveFocusInside} named export
 */ var deprecated_default_moveFocusInside = (0, _moveFocusInside.moveFocusInside);
exports.default = deprecated_default_moveFocusInside; //

},{"./constants":"drTLK","./focusInside":"2DpxM","./focusIsHidden":"4xWun","./focusSolver":false,"./focusables":"dMfjS","./moveFocusInside":"baHNh","./return-focus":"d1oFU","./sibling":"h7jzm","./utils/DOMutils":"5u5g3","@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"2DpxM":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "focusInside", ()=>focusInside);
var _domutils = require("./utils/DOMutils");
var _allAffected = require("./utils/all-affected");
var _array = require("./utils/array");
var _getActiveElement = require("./utils/getActiveElement");
var focusInFrame = function(frame, activeElement) {
    return frame === activeElement;
};
var focusInsideIframe = function(topNode, activeElement) {
    return Boolean((0, _array.toArray)(topNode.querySelectorAll('iframe')).some(function(node) {
        return focusInFrame(node, activeElement);
    }));
};
var focusInside = function(topNode, activeElement) {
    // const activeElement = document && getActiveElement();
    if (activeElement === void 0) activeElement = (0, _getActiveElement.getActiveElement)((0, _array.getFirst)(topNode).ownerDocument);
    if (!activeElement || activeElement.dataset && activeElement.dataset.focusGuard) return false;
    return (0, _allAffected.getAllAffectedNodes)(topNode).some(function(node) {
        return (0, _domutils.contains)(node, activeElement) || focusInsideIframe(node, activeElement);
    });
};

},{"./utils/DOMutils":"5u5g3","./utils/all-affected":"9H4z3","./utils/array":"elZm4","./utils/getActiveElement":"3wPqm","@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"5u5g3":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "filterFocusable", ()=>filterFocusable);
parcelHelpers.export(exports, "filterAutoFocusable", ()=>filterAutoFocusable);
parcelHelpers.export(exports, "getTabbableNodes", ()=>getTabbableNodes);
parcelHelpers.export(exports, "getFocusableNodes", ()=>getFocusableNodes);
parcelHelpers.export(exports, "parentAutofocusables", ()=>parentAutofocusables);
parcelHelpers.export(exports, "contains", ()=>contains);
var _array = require("./array");
var _is = require("./is");
var _tabOrder = require("./tabOrder");
var _tabUtils = require("./tabUtils");
var filterFocusable = function(nodes, visibilityCache) {
    return (0, _array.toArray)(nodes).filter(function(node) {
        return (0, _is.isVisibleCached)(visibilityCache, node);
    }).filter(function(node) {
        return (0, _is.notHiddenInput)(node);
    });
};
var filterAutoFocusable = function(nodes, cache) {
    if (cache === void 0) cache = new Map();
    return (0, _array.toArray)(nodes).filter(function(node) {
        return (0, _is.isAutoFocusAllowedCached)(cache, node);
    });
};
var getTabbableNodes = function(topNodes, visibilityCache, withGuards) {
    return (0, _tabOrder.orderByTabIndex)(filterFocusable((0, _tabUtils.getFocusables)(topNodes, withGuards), visibilityCache), true, withGuards);
};
var getFocusableNodes = function(topNodes, visibilityCache) {
    return (0, _tabOrder.orderByTabIndex)(filterFocusable((0, _tabUtils.getFocusables)(topNodes), visibilityCache), false);
};
var parentAutofocusables = function(topNode, visibilityCache) {
    return filterFocusable((0, _tabUtils.getParentAutofocusables)(topNode), visibilityCache);
};
var contains = function(scope, element) {
    if (scope.shadowRoot) return contains(scope.shadowRoot, element);
    else {
        if (Object.getPrototypeOf(scope).contains !== undefined && Object.getPrototypeOf(scope).contains.call(scope, element)) return true;
        return (0, _array.toArray)(scope.children).some(function(child) {
            var _a;
            if (child instanceof HTMLIFrameElement) {
                var iframeBody = (_a = child.contentDocument) === null || _a === void 0 ? void 0 : _a.body;
                if (iframeBody) return contains(iframeBody, element);
                return false;
            }
            return contains(child, element);
        });
    }
};

},{"./array":"elZm4","./is":"a0hgY","./tabOrder":"gPAjj","./tabUtils":"5pdZb","@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"elZm4":[function(require,module,exports,__globalThis) {
/*
IE11 support
 */ var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "toArray", ()=>toArray);
parcelHelpers.export(exports, "asArray", ()=>asArray);
parcelHelpers.export(exports, "getFirst", ()=>getFirst);
var toArray = function(a) {
    var ret = Array(a.length);
    for(var i = 0; i < a.length; ++i)ret[i] = a[i];
    return ret;
};
var asArray = function(a) {
    return Array.isArray(a) ? a : [
        a
    ];
};
var getFirst = function(a) {
    return Array.isArray(a) ? a[0] : a;
};

},{"@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"a0hgY":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "isVisibleCached", ()=>isVisibleCached);
parcelHelpers.export(exports, "isAutoFocusAllowedCached", ()=>isAutoFocusAllowedCached);
parcelHelpers.export(exports, "getDataset", ()=>getDataset);
parcelHelpers.export(exports, "isHTMLButtonElement", ()=>isHTMLButtonElement);
parcelHelpers.export(exports, "isHTMLInputElement", ()=>isHTMLInputElement);
parcelHelpers.export(exports, "isRadioElement", ()=>isRadioElement);
parcelHelpers.export(exports, "notHiddenInput", ()=>notHiddenInput);
parcelHelpers.export(exports, "isAutoFocusAllowed", ()=>isAutoFocusAllowed);
parcelHelpers.export(exports, "isGuard", ()=>isGuard);
parcelHelpers.export(exports, "isNotAGuard", ()=>isNotAGuard);
parcelHelpers.export(exports, "isDefined", ()=>isDefined);
var _constants = require("../constants");
var isElementHidden = function(node) {
    // we can measure only "elements"
    // consider others as "visible"
    if (node.nodeType !== Node.ELEMENT_NODE) return false;
    var computedStyle = window.getComputedStyle(node, null);
    if (!computedStyle || !computedStyle.getPropertyValue) return false;
    return computedStyle.getPropertyValue('display') === 'none' || computedStyle.getPropertyValue('visibility') === 'hidden';
};
var getParentNode = function(node) {
    // DOCUMENT_FRAGMENT_NODE can also point on ShadowRoot. In this case .host will point on the next node
    return node.parentNode && node.parentNode.nodeType === Node.DOCUMENT_FRAGMENT_NODE ? node.parentNode.host : node.parentNode;
};
var isTopNode = function(node) {
    // @ts-ignore
    return node === document || node && node.nodeType === Node.DOCUMENT_NODE;
};
var isInert = function(node) {
    return node.hasAttribute('inert');
};
/**
 * @see https://github.com/testing-library/jest-dom/blob/main/src/to-be-visible.js
 */ var isVisibleUncached = function(node, checkParent) {
    return !node || isTopNode(node) || !isElementHidden(node) && !isInert(node) && checkParent(getParentNode(node));
};
var isVisibleCached = function(visibilityCache, node) {
    var cached = visibilityCache.get(node);
    if (cached !== undefined) return cached;
    var result = isVisibleUncached(node, isVisibleCached.bind(undefined, visibilityCache));
    visibilityCache.set(node, result);
    return result;
};
var isAutoFocusAllowedUncached = function(node, checkParent) {
    return node && !isTopNode(node) ? isAutoFocusAllowed(node) ? checkParent(getParentNode(node)) : false : true;
};
var isAutoFocusAllowedCached = function(cache, node) {
    var cached = cache.get(node);
    if (cached !== undefined) return cached;
    var result = isAutoFocusAllowedUncached(node, isAutoFocusAllowedCached.bind(undefined, cache));
    cache.set(node, result);
    return result;
};
var getDataset = function(node) {
    // @ts-ignore
    return node.dataset;
};
var isHTMLButtonElement = function(node) {
    return node.tagName === 'BUTTON';
};
var isHTMLInputElement = function(node) {
    return node.tagName === 'INPUT';
};
var isRadioElement = function(node) {
    return isHTMLInputElement(node) && node.type === 'radio';
};
var notHiddenInput = function(node) {
    return !((isHTMLInputElement(node) || isHTMLButtonElement(node)) && (node.type === 'hidden' || node.disabled));
};
var isAutoFocusAllowed = function(node) {
    var attribute = node.getAttribute((0, _constants.FOCUS_NO_AUTOFOCUS));
    return ![
        true,
        'true',
        ''
    ].includes(attribute);
};
var isGuard = function(node) {
    var _a;
    return Boolean(node && ((_a = getDataset(node)) === null || _a === void 0 ? void 0 : _a.focusGuard));
};
var isNotAGuard = function(node) {
    return !isGuard(node);
};
var isDefined = function(x) {
    return Boolean(x);
};

},{"../constants":"drTLK","@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"gPAjj":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "tabSort", ()=>tabSort);
parcelHelpers.export(exports, "orderByTabIndex", ()=>orderByTabIndex);
var _array = require("./array");
var tabSort = function(a, b) {
    var aTab = Math.max(0, a.tabIndex);
    var bTab = Math.max(0, b.tabIndex);
    var tabDiff = aTab - bTab;
    var indexDiff = a.index - b.index;
    if (tabDiff) {
        if (!aTab) return 1;
        if (!bTab) return -1;
    }
    return tabDiff || indexDiff;
};
var getTabIndex = function(node) {
    if (node.tabIndex < 0) {
        // all "focusable" elements are already preselected
        // but some might have implicit negative tabIndex
        // return 0 for <audio without tabIndex attribute - it is "tabbable"
        if (!node.hasAttribute('tabindex')) return 0;
    }
    return node.tabIndex;
};
var orderByTabIndex = function(nodes, filterNegative, keepGuards) {
    return (0, _array.toArray)(nodes).map(function(node, index) {
        var tabIndex = getTabIndex(node);
        return {
            node: node,
            index: index,
            tabIndex: keepGuards && tabIndex === -1 ? (node.dataset || {}).focusGuard ? 0 : -1 : tabIndex
        };
    }).filter(function(data) {
        return !filterNegative || data.tabIndex >= 0;
    }).sort(tabSort);
};

},{"./array":"elZm4","@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"5pdZb":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "getFocusables", ()=>getFocusables);
parcelHelpers.export(exports, "getParentAutofocusables", ()=>getParentAutofocusables);
var _constants = require("../constants");
var _array = require("./array");
var _tabbables = require("./tabbables");
var queryTabbables = (0, _tabbables.tabbables).join(',');
var queryGuardTabbables = "".concat(queryTabbables, ", [data-focus-guard]");
var getFocusablesWithShadowDom = function(parent, withGuards) {
    return (0, _array.toArray)((parent.shadowRoot || parent).children).reduce(function(acc, child) {
        return acc.concat(child.matches(withGuards ? queryGuardTabbables : queryTabbables) ? [
            child
        ] : [], getFocusablesWithShadowDom(child));
    }, []);
};
var getFocusablesWithIFrame = function(parent, withGuards) {
    var _a;
    // contentDocument of iframe will be null if current origin cannot access it
    if (parent instanceof HTMLIFrameElement && ((_a = parent.contentDocument) === null || _a === void 0 ? void 0 : _a.body)) return getFocusables([
        parent.contentDocument.body
    ], withGuards);
    return [
        parent
    ];
};
var getFocusables = function(parents, withGuards) {
    return parents.reduce(function(acc, parent) {
        var _a;
        var focusableWithShadowDom = getFocusablesWithShadowDom(parent, withGuards);
        var focusableWithIframes = (_a = []).concat.apply(_a, focusableWithShadowDom.map(function(node) {
            return getFocusablesWithIFrame(node, withGuards);
        }));
        return acc.concat(// add all tabbables inside and within shadow DOMs in DOM order
        focusableWithIframes, // add if node is tabbable itself
        parent.parentNode ? (0, _array.toArray)(parent.parentNode.querySelectorAll(queryTabbables)).filter(function(node) {
            return node === parent;
        }) : []);
    }, []);
};
var getParentAutofocusables = function(parent) {
    var parentFocus = parent.querySelectorAll("[".concat((0, _constants.FOCUS_AUTO), "]"));
    return (0, _array.toArray)(parentFocus).map(function(node) {
        return getFocusables([
            node
        ]);
    }).reduce(function(acc, nodes) {
        return acc.concat(nodes);
    }, []);
};

},{"../constants":"drTLK","./array":"elZm4","./tabbables":"4QTKk","@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"4QTKk":[function(require,module,exports,__globalThis) {
/**
 * list of the object to be considered as focusable
 */ var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "tabbables", ()=>tabbables);
var tabbables = [
    'button:enabled',
    'select:enabled',
    'textarea:enabled',
    'input:enabled',
    // elements with explicit roles will also use explicit tabindex
    // '[role="button"]',
    'a[href]',
    'area[href]',
    'summary',
    'iframe',
    'object',
    'embed',
    'audio[controls]',
    'video[controls]',
    '[tabindex]',
    '[contenteditable]',
    '[autofocus]'
];

},{"@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"9H4z3":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "getAllAffectedNodes", ()=>getAllAffectedNodes);
var _constants = require("../constants");
var _array = require("./array");
/**
 * in case of multiple nodes nested inside each other
 * keeps only top ones
 * this is O(nlogn)
 * @param nodes
 * @returns {*}
 */ var filterNested = function(nodes) {
    var contained = new Set();
    var l = nodes.length;
    for(var i = 0; i < l; i += 1)for(var j = i + 1; j < l; j += 1){
        var position = nodes[i].compareDocumentPosition(nodes[j]);
        /* eslint-disable no-bitwise */ if ((position & Node.DOCUMENT_POSITION_CONTAINED_BY) > 0) contained.add(j);
        if ((position & Node.DOCUMENT_POSITION_CONTAINS) > 0) contained.add(i);
    /* eslint-enable */ }
    return nodes.filter(function(_, index) {
        return !contained.has(index);
    });
};
/**
 * finds top most parent for a node
 * @param node
 * @returns {*}
 */ var getTopParent = function(node) {
    return node.parentNode ? getTopParent(node.parentNode) : node;
};
var getAllAffectedNodes = function(node) {
    var nodes = (0, _array.asArray)(node);
    return nodes.filter(Boolean).reduce(function(acc, currentNode) {
        var group = currentNode.getAttribute((0, _constants.FOCUS_GROUP));
        acc.push.apply(acc, group ? filterNested((0, _array.toArray)(getTopParent(currentNode).querySelectorAll("[".concat((0, _constants.FOCUS_GROUP), "=\"").concat(group, "\"]:not([").concat((0, _constants.FOCUS_DISABLED), "=\"disabled\"])")))) : [
            currentNode
        ]);
        return acc;
    }, []);
};

},{"../constants":"drTLK","./array":"elZm4","@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"3wPqm":[function(require,module,exports,__globalThis) {
/**
 * returns active element from document or from nested shadowdoms
 */ var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "getActiveElement", ()=>getActiveElement);
var _safe = require("./safe");
var getActiveElement = function(inDocument) {
    if (inDocument === void 0) inDocument = document;
    if (!inDocument || !inDocument.activeElement) return undefined;
    var activeElement = inDocument.activeElement;
    return activeElement.shadowRoot ? getActiveElement(activeElement.shadowRoot) : activeElement instanceof HTMLIFrameElement && (0, _safe.safeProbe)(function() {
        return activeElement.contentWindow.document;
    }) ? getActiveElement(activeElement.contentWindow.document) : activeElement;
};

},{"./safe":"bhrkR","@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"bhrkR":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "safeProbe", ()=>safeProbe);
var safeProbe = function(cb) {
    try {
        return cb();
    } catch (e) {
        return undefined;
    }
};

},{"@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"4xWun":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "focusIsHidden", ()=>focusIsHidden);
var _constants = require("./constants");
var _domutils = require("./utils/DOMutils");
var _array = require("./utils/array");
var _getActiveElement = require("./utils/getActiveElement");
var focusIsHidden = function(inDocument) {
    if (inDocument === void 0) inDocument = document;
    var activeElement = (0, _getActiveElement.getActiveElement)(inDocument);
    if (!activeElement) return false;
    // this does not support setting FOCUS_ALLOW within shadow dom
    return (0, _array.toArray)(inDocument.querySelectorAll("[".concat((0, _constants.FOCUS_ALLOW), "]"))).some(function(node) {
        return (0, _domutils.contains)(node, activeElement);
    });
};

},{"./constants":"drTLK","./utils/DOMutils":"5u5g3","./utils/array":"elZm4","./utils/getActiveElement":"3wPqm","@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"pKq9x":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "focusSolver", ()=>focusSolver);
var _solver = require("./solver");
var _domutils = require("./utils/DOMutils");
var _allAffected = require("./utils/all-affected");
var _array = require("./utils/array");
var _autoFocus = require("./utils/auto-focus");
var _getActiveElement = require("./utils/getActiveElement");
var _is = require("./utils/is");
var _parenting = require("./utils/parenting");
var reorderNodes = function(srcNodes, dstNodes) {
    var remap = new Map();
    // no Set(dstNodes) for IE11 :(
    dstNodes.forEach(function(entity) {
        return remap.set(entity.node, entity);
    });
    // remap to dstNodes
    return srcNodes.map(function(node) {
        return remap.get(node);
    }).filter((0, _is.isDefined));
};
var focusSolver = function(topNode, lastNode) {
    var activeElement = (0, _getActiveElement.getActiveElement)((0, _array.asArray)(topNode).length > 0 ? document : (0, _array.getFirst)(topNode).ownerDocument);
    var entries = (0, _allAffected.getAllAffectedNodes)(topNode).filter((0, _is.isNotAGuard));
    var commonParent = (0, _parenting.getTopCommonParent)(activeElement || topNode, topNode, entries);
    var visibilityCache = new Map();
    var anyFocusable = (0, _domutils.getFocusableNodes)(entries, visibilityCache);
    var innerElements = anyFocusable.filter(function(_a) {
        var node = _a.node;
        return (0, _is.isNotAGuard)(node);
    });
    if (!innerElements[0]) return undefined;
    var outerNodes = (0, _domutils.getFocusableNodes)([
        commonParent
    ], visibilityCache).map(function(_a) {
        var node = _a.node;
        return node;
    });
    var orderedInnerElements = reorderNodes(outerNodes, innerElements);
    // collect inner focusable and separately tabbables
    var innerFocusables = orderedInnerElements.map(function(_a) {
        var node = _a.node;
        return node;
    });
    var innerTabbable = orderedInnerElements.filter(function(_a) {
        var tabIndex = _a.tabIndex;
        return tabIndex >= 0;
    }).map(function(_a) {
        var node = _a.node;
        return node;
    });
    var newId = (0, _solver.newFocus)(innerFocusables, innerTabbable, outerNodes, activeElement, lastNode);
    if (newId === (0, _solver.NEW_FOCUS)) {
        var focusNode = // first try only tabbable, and the fallback to all focusable, as long as at least one element should be picked for focus
        (0, _autoFocus.pickAutofocus)(anyFocusable, innerTabbable, (0, _parenting.allParentAutofocusables)(entries, visibilityCache)) || (0, _autoFocus.pickAutofocus)(anyFocusable, innerFocusables, (0, _parenting.allParentAutofocusables)(entries, visibilityCache));
        if (focusNode) return {
            node: focusNode
        };
        else {
            console.warn('focus-lock: cannot find any node to move focus into');
            return undefined;
        }
    }
    if (newId === undefined) return newId;
    return orderedInnerElements[newId];
};

},{"./solver":"5MnbY","./utils/DOMutils":"5u5g3","./utils/all-affected":"9H4z3","./utils/array":"elZm4","./utils/auto-focus":"b8B7Q","./utils/getActiveElement":"3wPqm","./utils/is":"a0hgY","./utils/parenting":"aRl9T","@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"5MnbY":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "NEW_FOCUS", ()=>NEW_FOCUS);
parcelHelpers.export(exports, "newFocus", ()=>newFocus);
var _correctFocus = require("./utils/correctFocus");
var _firstFocus = require("./utils/firstFocus");
var _is = require("./utils/is");
var NEW_FOCUS = 'NEW_FOCUS';
var newFocus = function(innerNodes, innerTabbables, outerNodes, activeElement, lastNode) {
    var cnt = innerNodes.length;
    var firstFocus = innerNodes[0];
    var lastFocus = innerNodes[cnt - 1];
    var isOnGuard = (0, _is.isGuard)(activeElement);
    // focus is inside
    if (activeElement && innerNodes.indexOf(activeElement) >= 0) return undefined;
    var activeIndex = activeElement !== undefined ? outerNodes.indexOf(activeElement) : -1;
    var lastIndex = lastNode ? outerNodes.indexOf(lastNode) : activeIndex;
    var lastNodeInside = lastNode ? innerNodes.indexOf(lastNode) : -1;
    // no active focus (or focus is on the body)
    if (activeIndex === -1) {
        // known fallback
        if (lastNodeInside !== -1) return lastNodeInside;
        return NEW_FOCUS;
    }
    // new focus, nothing to calculate
    if (lastNodeInside === -1) return NEW_FOCUS;
    var indexDiff = activeIndex - lastIndex;
    var firstNodeIndex = outerNodes.indexOf(firstFocus);
    var lastNodeIndex = outerNodes.indexOf(lastFocus);
    var correctedNodes = (0, _correctFocus.correctNodes)(outerNodes);
    var currentFocusableIndex = activeElement !== undefined ? correctedNodes.indexOf(activeElement) : -1;
    var previousFocusableIndex = lastNode ? correctedNodes.indexOf(lastNode) : currentFocusableIndex;
    var tabbableNodes = correctedNodes.filter(function(node) {
        return node.tabIndex >= 0;
    });
    var currentTabbableIndex = activeElement !== undefined ? tabbableNodes.indexOf(activeElement) : -1;
    var previousTabbableIndex = lastNode ? tabbableNodes.indexOf(lastNode) : currentTabbableIndex;
    var focusIndexDiff = currentTabbableIndex >= 0 && previousTabbableIndex >= 0 ? previousTabbableIndex - currentTabbableIndex : previousFocusableIndex - currentFocusableIndex;
    // old focus
    if (!indexDiff && lastNodeInside >= 0) return lastNodeInside;
    // no tabbable elements, autofocus is not possible
    if (innerTabbables.length === 0) // an edge case with no tabbable elements
    // return the last focusable one
    // with some probability this will prevent focus from cycling across the lock, but there is no tabbale elements to cycle to
    return lastNodeInside;
    var returnFirstNode = (0, _firstFocus.pickFocusable)(innerNodes, innerTabbables[0]);
    var returnLastNode = (0, _firstFocus.pickFocusable)(innerNodes, innerTabbables[innerTabbables.length - 1]);
    // first element
    if (activeIndex <= firstNodeIndex && isOnGuard && Math.abs(indexDiff) > 1) return returnLastNode;
    // last element
    if (activeIndex >= lastNodeIndex && isOnGuard && Math.abs(indexDiff) > 1) return returnFirstNode;
    // jump out, but not on the guard
    if (indexDiff && Math.abs(focusIndexDiff) > 1) return lastNodeInside;
    // focus above lock
    if (activeIndex <= firstNodeIndex) return returnLastNode;
    // focus below lock
    if (activeIndex > lastNodeIndex) return returnFirstNode;
    // index is inside tab order, but outside Lock
    if (indexDiff) {
        if (Math.abs(indexDiff) > 1) return lastNodeInside;
        return (cnt + lastNodeInside + indexDiff) % cnt;
    }
    // do nothing
    return undefined;
};

},{"./utils/correctFocus":"aX9cy","./utils/firstFocus":"hjJVM","./utils/is":"a0hgY","@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"aX9cy":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "correctNode", ()=>correctNode);
parcelHelpers.export(exports, "correctNodes", ()=>correctNodes);
var _is = require("./is");
var findSelectedRadio = function(node, nodes) {
    return nodes.filter((0, _is.isRadioElement)).filter(function(el) {
        return el.name === node.name;
    }).filter(function(el) {
        return el.checked;
    })[0] || node;
};
var correctNode = function(node, nodes) {
    if ((0, _is.isRadioElement)(node) && node.name) return findSelectedRadio(node, nodes);
    return node;
};
var correctNodes = function(nodes) {
    // IE11 has no Set(array) constructor
    var resultSet = new Set();
    nodes.forEach(function(node) {
        return resultSet.add(correctNode(node, nodes));
    });
    // using filter to support IE11
    return nodes.filter(function(node) {
        return resultSet.has(node);
    });
};

},{"./is":"a0hgY","@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"hjJVM":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "pickFirstFocus", ()=>pickFirstFocus);
parcelHelpers.export(exports, "pickFocusable", ()=>pickFocusable);
var _correctFocus = require("./correctFocus");
var pickFirstFocus = function(nodes) {
    if (nodes[0] && nodes.length > 1) return (0, _correctFocus.correctNode)(nodes[0], nodes);
    return nodes[0];
};
var pickFocusable = function(nodes, node) {
    return nodes.indexOf((0, _correctFocus.correctNode)(node, nodes));
};

},{"./correctFocus":"aX9cy","@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"b8B7Q":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "pickAutofocus", ()=>pickAutofocus);
var _domutils = require("./DOMutils");
var _firstFocus = require("./firstFocus");
var _is = require("./is");
var findAutoFocused = function(autoFocusables) {
    return function(node) {
        var _a;
        var autofocus = (_a = (0, _is.getDataset)(node)) === null || _a === void 0 ? void 0 : _a.autofocus;
        return(// @ts-expect-error
        node.autofocus || //
        autofocus !== undefined && autofocus !== 'false' || //
        autoFocusables.indexOf(node) >= 0);
    };
};
var pickAutofocus = function(nodesIndexes, orderedNodes, groups) {
    var nodes = nodesIndexes.map(function(_a) {
        var node = _a.node;
        return node;
    });
    var autoFocusable = (0, _domutils.filterAutoFocusable)(nodes.filter(findAutoFocused(groups)));
    if (autoFocusable && autoFocusable.length) return (0, _firstFocus.pickFirstFocus)(autoFocusable);
    return (0, _firstFocus.pickFirstFocus)((0, _domutils.filterAutoFocusable)(orderedNodes));
};

},{"./DOMutils":"5u5g3","./firstFocus":"hjJVM","./is":"a0hgY","@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"aRl9T":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "getCommonParent", ()=>getCommonParent);
parcelHelpers.export(exports, "getTopCommonParent", ()=>getTopCommonParent);
parcelHelpers.export(exports, "allParentAutofocusables", ()=>allParentAutofocusables);
var _domutils = require("./DOMutils");
var _array = require("./array");
var getParents = function(node, parents) {
    if (parents === void 0) parents = [];
    parents.push(node);
    if (node.parentNode) getParents(node.parentNode.host || node.parentNode, parents);
    return parents;
};
var getCommonParent = function(nodeA, nodeB) {
    var parentsA = getParents(nodeA);
    var parentsB = getParents(nodeB);
    // tslint:disable-next-line:prefer-for-of
    for(var i = 0; i < parentsA.length; i += 1){
        var currentParent = parentsA[i];
        if (parentsB.indexOf(currentParent) >= 0) return currentParent;
    }
    return false;
};
var getTopCommonParent = function(baseActiveElement, leftEntry, rightEntries) {
    var activeElements = (0, _array.asArray)(baseActiveElement);
    var leftEntries = (0, _array.asArray)(leftEntry);
    var activeElement = activeElements[0];
    var topCommon = false;
    leftEntries.filter(Boolean).forEach(function(entry) {
        topCommon = getCommonParent(topCommon || entry, entry) || topCommon;
        rightEntries.filter(Boolean).forEach(function(subEntry) {
            var common = getCommonParent(activeElement, subEntry);
            if (common) {
                if (!topCommon || (0, _domutils.contains)(common, topCommon)) topCommon = common;
                else topCommon = getCommonParent(common, topCommon);
            }
        });
    });
    // TODO: add assert here?
    return topCommon;
};
var allParentAutofocusables = function(entries, visibilityCache) {
    return entries.reduce(function(acc, node) {
        return acc.concat((0, _domutils.parentAutofocusables)(node, visibilityCache));
    }, []);
};

},{"./DOMutils":"5u5g3","./array":"elZm4","@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"dMfjS":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "expandFocusableNodes", ()=>expandFocusableNodes);
var _allAffected = require("./utils/all-affected");
var _is = require("./utils/is");
var _parenting = require("./utils/parenting");
var _tabOrder = require("./utils/tabOrder");
var _tabUtils = require("./utils/tabUtils");
var expandFocusableNodes = function(topNode) {
    var entries = (0, _allAffected.getAllAffectedNodes)(topNode).filter((0, _is.isNotAGuard));
    var commonParent = (0, _parenting.getTopCommonParent)(topNode, topNode, entries);
    var outerNodes = (0, _tabOrder.orderByTabIndex)((0, _tabUtils.getFocusables)([
        commonParent
    ], true), true, true);
    var innerElements = (0, _tabUtils.getFocusables)(entries, false);
    return outerNodes.map(function(_a) {
        var node = _a.node, index = _a.index;
        return {
            node: node,
            index: index,
            lockItem: innerElements.indexOf(node) >= 0,
            guard: (0, _is.isGuard)(node)
        };
    });
};

},{"./utils/all-affected":"9H4z3","./utils/is":"a0hgY","./utils/parenting":"aRl9T","./utils/tabOrder":"gPAjj","./utils/tabUtils":"5pdZb","@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"baHNh":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "moveFocusInside", ()=>moveFocusInside);
var _commands = require("./commands");
var _focusSolver = require("./focusSolver");
var guardCount = 0;
var lockDisabled = false;
var moveFocusInside = function(topNode, lastNode, options) {
    if (options === void 0) options = {};
    var focusable = (0, _focusSolver.focusSolver)(topNode, lastNode);
    // global local side effect to countain recursive lock activation and resolve focus-fighting
    if (lockDisabled) return;
    if (focusable) {
        /** +FOCUS-FIGHTING prevention **/ if (guardCount > 2) {
            // we have recursive entered back the lock activation
            console.error("FocusLock: focus-fighting detected. Only one focus management system could be active. See https://github.com/theKashey/focus-lock/#focus-fighting");
            lockDisabled = true;
            setTimeout(function() {
                lockDisabled = false;
            }, 1);
            return;
        }
        guardCount++;
        (0, _commands.focusOn)(focusable.node, options.focusOptions);
        guardCount--;
    }
};

},{"./commands":"X1CaT","./focusSolver":"pKq9x","@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"X1CaT":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "focusOn", ()=>focusOn);
var focusOn = function(target, focusOptions) {
    if (!target) // not clear how, but is possible https://github.com/theKashey/focus-lock/issues/53
    return;
    if ('focus' in target) target.focus(focusOptions);
    if ('contentWindow' in target && target.contentWindow) target.contentWindow.focus();
};

},{"@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"d1oFU":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "recordElementLocation", ()=>recordElementLocation);
parcelHelpers.export(exports, "captureFocusRestore", ()=>captureFocusRestore);
var _domutils = require("./utils/DOMutils");
function weakRef(value) {
    if (!value) return null;
    // #68 Safari 14.1 dont have it yet
    // FIXME: remove in 2025
    if (typeof WeakRef === 'undefined') return function() {
        return value || null;
    };
    var w = value ? new WeakRef(value) : null;
    return function() {
        return (w === null || w === void 0 ? void 0 : w.deref()) || null;
    };
}
var recordElementLocation = function(element) {
    if (!element) return null;
    var stack = [];
    var currentElement = element;
    while(currentElement && currentElement !== document.body){
        stack.push({
            current: weakRef(currentElement),
            parent: weakRef(currentElement.parentElement),
            left: weakRef(currentElement.previousElementSibling),
            right: weakRef(currentElement.nextElementSibling)
        });
        currentElement = currentElement.parentElement;
    }
    return {
        element: weakRef(element),
        stack: stack,
        ownerDocument: element.ownerDocument
    };
};
var restoreFocusTo = function(location) {
    var _a, _b, _c, _d, _e;
    if (!location) return undefined;
    var stack = location.stack, ownerDocument = location.ownerDocument;
    var visibilityCache = new Map();
    for(var _i = 0, stack_1 = stack; _i < stack_1.length; _i++){
        var line = stack_1[_i];
        var parent_1 = (_a = line.parent) === null || _a === void 0 ? void 0 : _a.call(line);
        // is it still here?
        if (parent_1 && ownerDocument.contains(parent_1)) {
            var left = (_b = line.left) === null || _b === void 0 ? void 0 : _b.call(line);
            var savedCurrent = line.current();
            var current = parent_1.contains(savedCurrent) ? savedCurrent : undefined;
            var right = (_c = line.right) === null || _c === void 0 ? void 0 : _c.call(line);
            var focusables = (0, _domutils.getTabbableNodes)([
                parent_1
            ], visibilityCache);
            var aim = // that is element itself
            (_e = (_d = current !== null && current !== void 0 ? current : // or something in it's place
            left === null || left === void 0 ? void 0 : left.nextElementSibling) !== null && _d !== void 0 ? _d : // or somebody to the right, still close enough
            right) !== null && _e !== void 0 ? _e : // or somebody to the left, something?
            left;
            while(aim){
                for(var _f = 0, focusables_1 = focusables; _f < focusables_1.length; _f++){
                    var focusable = focusables_1[_f];
                    if (aim === null || aim === void 0 ? void 0 : aim.contains(focusable.node)) return focusable.node;
                }
                aim = aim.nextElementSibling;
            }
            if (focusables.length) // if parent contains a focusable - move there
            return focusables[0].node;
        }
    }
    // nothing matched
    return undefined;
};
var captureFocusRestore = function(targetElement) {
    var location = recordElementLocation(targetElement);
    return function() {
        return restoreFocusTo(location);
    };
};

},{"./utils/DOMutils":"5u5g3","@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"h7jzm":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "getRelativeFocusable", ()=>getRelativeFocusable);
parcelHelpers.export(exports, "focusNextElement", ()=>focusNextElement);
parcelHelpers.export(exports, "focusPrevElement", ()=>focusPrevElement);
parcelHelpers.export(exports, "focusFirstElement", ()=>focusFirstElement);
parcelHelpers.export(exports, "focusLastElement", ()=>focusLastElement);
var _commands = require("./commands");
var _domutils = require("./utils/DOMutils");
var _array = require("./utils/array");
var getRelativeFocusable = function(element, scope, useTabbables) {
    if (!element || !scope) {
        console.error('no element or scope given');
        return {};
    }
    var shards = (0, _array.asArray)(scope);
    if (shards.every(function(shard) {
        return !(0, _domutils.contains)(shard, element);
    })) {
        console.error('Active element is not contained in the scope');
        return {};
    }
    var focusables = useTabbables ? (0, _domutils.getTabbableNodes)(shards, new Map()) : (0, _domutils.getFocusableNodes)(shards, new Map());
    var current = focusables.findIndex(function(_a) {
        var node = _a.node;
        return node === element;
    });
    if (current === -1) // an edge case, when anchor element is not found
    return undefined;
    return {
        prev: focusables[current - 1],
        next: focusables[current + 1],
        first: focusables[0],
        last: focusables[focusables.length - 1]
    };
};
var getBoundary = function(shards, useTabbables) {
    var set = useTabbables ? (0, _domutils.getTabbableNodes)((0, _array.asArray)(shards), new Map()) : (0, _domutils.getFocusableNodes)((0, _array.asArray)(shards), new Map());
    return {
        first: set[0],
        last: set[set.length - 1]
    };
};
var defaultOptions = function(options) {
    return Object.assign({
        scope: document.body,
        cycle: true,
        onlyTabbable: true
    }, options);
};
var moveFocus = function(fromElement, options, cb) {
    if (options === void 0) options = {};
    var newOptions = defaultOptions(options);
    var solution = getRelativeFocusable(fromElement, newOptions.scope, newOptions.onlyTabbable);
    if (!solution) return;
    var target = cb(solution, newOptions.cycle);
    if (target) (0, _commands.focusOn)(target.node, newOptions.focusOptions);
};
var focusNextElement = function(fromElement, options) {
    if (options === void 0) options = {};
    moveFocus(fromElement, options, function(_a, cycle) {
        var next = _a.next, first = _a.first;
        return next || cycle && first;
    });
};
var focusPrevElement = function(fromElement, options) {
    if (options === void 0) options = {};
    moveFocus(fromElement, options, function(_a, cycle) {
        var prev = _a.prev, last = _a.last;
        return prev || cycle && last;
    });
};
var pickBoundary = function(scope, options, what) {
    var _a;
    var boundary = getBoundary(scope, (_a = options.onlyTabbable) !== null && _a !== void 0 ? _a : true);
    var node = boundary[what];
    if (node) (0, _commands.focusOn)(node.node, options.focusOptions);
};
var focusFirstElement = function(scope, options) {
    if (options === void 0) options = {};
    pickBoundary(scope, options, 'first');
};
var focusLastElement = function(scope, options) {
    if (options === void 0) options = {};
    pickBoundary(scope, options, 'last');
};

},{"./commands":"X1CaT","./utils/DOMutils":"5u5g3","./utils/array":"elZm4","@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"2gE4f":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "deferAction", ()=>deferAction);
parcelHelpers.export(exports, "inlineProp", ()=>inlineProp);
parcelHelpers.export(exports, "extractRef", ()=>extractRef);
function deferAction(action) {
    setTimeout(action, 1);
}
var inlineProp = function inlineProp(name, value) {
    var obj = {};
    obj[name] = value;
    return obj;
};
var extractRef = function extractRef(ref) {
    return ref && 'current' in ref ? ref.current : ref;
};

},{"@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"cyugw":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "shallowEqual", ()=>shallowEqual);
parcelHelpers.export(exports, "shallowEqualArrays", ()=>shallowEqualArrays);
parcelHelpers.export(exports, "shallowEqualObjects", ()=>shallowEqualObjects);
function shallowEqualArrays(arrA, arrB) {
    if (arrA === arrB) return true;
    if (!arrA || !arrB) return false;
    const len = arrA.length;
    if (arrB.length !== len) return false;
    for(let i = 0; i < len; i++){
        if (arrA[i] !== arrB[i]) return false;
    }
    return true;
}
function shallowEqualObjects(objA, objB) {
    if (objA === objB) return true;
    if (!objA || !objB) return false;
    const aKeys = Object.keys(objA);
    const bKeys = Object.keys(objB);
    const len = aKeys.length;
    if (bKeys.length !== len) return false;
    for(let i = 0; i < len; i++){
        const key = aKeys[i];
        if (objA[key] !== objB[key] || !Object.prototype.hasOwnProperty.call(objB, key)) return false;
    }
    return true;
}
function shallowEqual(a, b) {
    const aIsArr = Array.isArray(a);
    const bIsArr = Array.isArray(b);
    if (aIsArr !== bIsArr) return false;
    if (aIsArr && bIsArr) return shallowEqualArrays(a, b);
    return shallowEqualObjects(a, b);
}

},{"@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"8jtsV":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "IdProvider", ()=>IdProvider);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _useId = require("./use-id");
const IdProvider = /*#__PURE__*/ (0, _react.forwardRef)(({ children, postfix = '', prefix = '' }, ref)=>{
    const id = `${prefix}${(0, _useId.useId)()}${postfix}`;
    (0, _react.useEffect)(()=>{
        if (!ref) return;
        switch(typeof ref){
            case 'function':
                ref(id);
                break;
            case 'object':
                ref.current = id;
                break;
            default:
                throw new Error(`Unreachable case for unsupported type of ref "${typeof ref}"`);
        }
    }, [
        id,
        ref
    ]);
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _jsxRuntime.Fragment), {
        children: typeof children === 'function' ? children({
            id
        }) : children
    });
});

},{"react/jsx-runtime":"bGvcw","react":"ltHCL","./use-id":"9jWCD","@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"cwsRW":[function(require,module,exports,__globalThis) {
/* components.tsx generated by @compiled/babel-plugin v0.39.1 */ var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "defaultComponents", ()=>defaultComponents);
var _objectSpread = require("@swc/helpers/_/_object_spread");
var _objectSpreadProps = require("@swc/helpers/_/_object_spread_props");
var _objectWithoutProperties = require("@swc/helpers/_/_object_without_properties");
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _runtime = require("@compiled/react/runtime");
var _search = require("@atlaskit/icon/core/search");
var _searchDefault = parcelHelpers.interopDefault(_search);
var _reactSelect = require("@atlaskit/react-select");
// ==============================
// Custom Components
// ==============================
const dropdownStyles = null;
const DropdownIndicator = ()=>/*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
        className: (0, _runtime.ax)([
            "_1bsbzwfg _12l2v77o _y3gn1h6o"
        ]),
        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _searchDefault.default), {
            color: "currentColor",
            label: ""
        })
    });
const controlStyles = null;
const Control = (_param)=>{
    var { innerRef, innerProps } = _param, props = (0, _objectWithoutProperties._)(_param, [
        "innerRef",
        "innerProps"
    ]);
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
        ref: innerRef,
        className: (0, _runtime.ax)([
            "_85i51b66 _1q51u2gc _y4tiu2gc _bozgu2gc"
        ]),
        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactSelect.components).Control, (0, _objectSpreadProps._)((0, _objectSpread._)({}, props), {
            innerProps: innerProps
        }))
    });
};
// NOTE `props` intentionally omitted from `Fragment`
const Menu = ({ children, innerProps })=>/*#__PURE__*/ (0, _jsxRuntime.jsx)("div", (0, _objectSpreadProps._)((0, _objectSpread._)({}, innerProps), {
        children: children
    }));
const ClearIndicator = (props)=>// eslint-disable-next-line @repo/internal/react/no-unsafe-spread-props
    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactSelect.components).ClearIndicator, (0, _objectSpread._)({}, props));
const MultiValueRemove = (props)=>// eslint-disable-next-line @repo/internal/react/no-unsafe-spread-props
    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactSelect.components).MultiValueRemove, (0, _objectSpread._)({}, props));
const defaultComponents = {
    Control,
    DropdownIndicator,
    Menu,
    ClearIndicator,
    MultiValueRemove
};

},{"@swc/helpers/_/_object_spread":"9gdrV","@swc/helpers/_/_object_spread_props":"kANqQ","@swc/helpers/_/_object_without_properties":"6HqIM","react/jsx-runtime":"bGvcw","react":"ltHCL","@compiled/react/runtime":"d27Vo","@atlaskit/icon/core/search":"9Iw3d","@atlaskit/react-select":"1iF04","@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"9Iw3d":[function(require,module,exports,__globalThis) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::0ed30ba2fe598b1c691c4159780db191>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = void 0;
var _react = _interopRequireDefault(require("b96d4a1baac70622"));
var _baseNew = _interopRequireDefault(require("791747f249fbae56"));
function _interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "Search".
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Single purpose - Reserved for searching objects.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const SearchIcon = (props)=>/*#__PURE__*/ _react.default.createElement(_baseNew.default, Object.assign({
        name: "SearchIcon",
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M7 2.5a4.5 4.5 0 1 0 0 9 4.5 4.5 0 0 0 0-9M1 7a6 6 0 1 1 10.74 3.68l3.29 3.29-1.06 1.06-3.29-3.29A6 6 0 0 1 1 7" clip-rule="evenodd"/>`
    }, props));
SearchIcon.displayName = 'SearchIcon';
var _default = exports.default = SearchIcon;

},{"b96d4a1baac70622":"ltHCL","791747f249fbae56":"5XL7D"}],"7xr4O":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "DummyControl", ()=>DummyControl);
var _objectSpread = require("@swc/helpers/_/_object_spread");
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _reactSelect = require("@atlaskit/react-select");
var _visuallyHidden = require("@atlaskit/visually-hidden");
var _visuallyHiddenDefault = parcelHelpers.interopDefault(_visuallyHidden);
const DummyControl = (props)=>/*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _visuallyHiddenDefault.default), {
        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactSelect.components).Control, (0, _objectSpread._)({}, props))
    });

},{"@swc/helpers/_/_object_spread":"9gdrV","react/jsx-runtime":"bGvcw","react":"ltHCL","@atlaskit/react-select":"1iF04","@atlaskit/visually-hidden":"gKDx1","@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"YEdyp":[function(require,module,exports,__globalThis) {
/* menu-dialog.tsx generated by @compiled/babel-plugin v0.39.1 */ var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "MenuDialog", ()=>MenuDialog);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _runtime = require("@compiled/react/runtime");
var _platformFeatureFlags = require("@atlaskit/platform-feature-flags");
const menuDialogStyles = null;
const menuDialogStylesT26Shape = null;
const MenuDialog = /*#__PURE__*/ (0, _react.forwardRef)(({ children, id, style, testId }, ref)=>{
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
        ref: ref,
        style: style,
        id: id,
        "data-testid": testId && `${testId}--menu`,
        className: (0, _runtime.ax)([
            "_2rko12b0 _1pby16oo _bfhk1bhr _16qs130s",
            (0, _platformFeatureFlags.fg)('platform-dst-shape-theme-default') && "_2rko1mok"
        ]),
        children: children
    });
});

},{"react/jsx-runtime":"bGvcw","react":"ltHCL","@compiled/react/runtime":"d27Vo","@atlaskit/platform-feature-flags":"8rD2i","@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"dSvMn":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
/**
 * Functional component wrapper around `useNotifyOpenLayerObserver`.
 *
 * This is needed as PopupSelect is a class component, which cannot use hooks directly.
 *
 * Even though the internal `Select` component (used internally by `PopupSelect`) also registers with
 * the OpenLayerObserver, we are also registering `PopupSelect` as well, to allow the observer to close
 * the `PopupSelect`'s outer popup.
 *
 * This will technically count as 2 open layers, however the specific count is not important - the main
 * concern is that the observer can know if there are _any_ open layers (0, or 1+), and how to close them.
 */ parcelHelpers.export(exports, "NotifyOpenLayerObserver", ()=>NotifyOpenLayerObserver);
var _openLayerObserver = require("@atlaskit/layering/experimental/open-layer-observer");
function NotifyOpenLayerObserver({ isOpen, onClose }) {
    // @ts-ignore error TS2353: Object literal may only specify known properties, and &#39;onClose&#39; does not exist in type &#39;{ isOpen?: boolean | undefined; }&#39;.
    (0, _openLayerObserver.useNotifyOpenLayerObserver)({
        isOpen,
        onClose
    });
    return null;
}

},{"@atlaskit/layering/experimental/open-layer-observer":"2Dqp9","@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"8Eq2A":[function(require,module,exports,__globalThis) {
/* popup-select-top-layer.tsx generated by @compiled/babel-plugin v0.39.1 */ var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
/**
 * Top-layer implementation of PopupSelect.
 *
 * Replaces the legacy PopupSelect rendering pipeline
 * (react-popper + createPortal + react-focus-lock + @atlaskit/layering + z-index)
 * with the native Popover API + CSS Anchor Positioning via @atlaskit/top-layer.
 *
 * Gated behind the `platform-dst-top-layer` feature flag.
 */ parcelHelpers.export(exports, "PopupSelectTopLayer", ()=>PopupSelectTopLayer);
var _objectSpread = require("@swc/helpers/_/_object_spread");
var _objectSpreadProps = require("@swc/helpers/_/_object_spread_props");
var _objectWithoutProperties = require("@swc/helpers/_/_object_without_properties");
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _runtime = require("@compiled/react/runtime");
var _bindEventListener = require("bind-event-listener");
var _platformFeatureFlags = require("@atlaskit/platform-feature-flags");
var _reactSelect = require("@atlaskit/react-select");
var _placementMap = require("@atlaskit/top-layer/placement-map");
var _popover = require("@atlaskit/top-layer/popover");
var _popoverSurface = require("@atlaskit/top-layer/popover-surface");
var _useAnchorPosition = require("@atlaskit/top-layer/use-anchor-position");
var _usePopoverId = require("@atlaskit/top-layer/use-popover-id");
var _select = require("../select");
var _selectDefault = parcelHelpers.interopDefault(_select);
var _components = require("./components");
var _dummyControl = require("./dummy-control");
// Styles.
const menuDialogStyles = null;
const menuDialogStylesT26Shape = null;
function PopupSelectTopLayer(_param) {
    var { // PopupSelect-specific props.
    closeMenuOnSelect = true, shouldCloseMenuOnTab = true, footer, searchThreshold = 5, maxMenuWidth = 440, minMenuWidth = 220, maxMenuHeight = 300, target, label, placeholder, testId, isOpen: controlledIsOpen, defaultIsOpen, spacing: _spacing, options = [], isSearchable = true, components: consumerComponents, styles: consumerStyles, onChange, onKeyDown, // Lifecycle callbacks.
    // @ts-ignore react-select unsupported props
    onOpen, // @ts-ignore react-select unsupported props
    onClose, onMenuOpen, onMenuClose, // No-op props in top-layer path.
    // eslint-disable-next-line @typescript-eslint/no-unused-vars
    popperProps, // eslint-disable-next-line @typescript-eslint/no-unused-vars
    shouldPreventEscapePropagation: _shouldPreventEscapePropagation } = _param, selectProps = (0, _objectWithoutProperties._)(_param, [
        "closeMenuOnSelect",
        "shouldCloseMenuOnTab",
        "footer",
        "searchThreshold",
        "maxMenuWidth",
        "minMenuWidth",
        "maxMenuHeight",
        "target",
        "label",
        "placeholder",
        "testId",
        "isOpen",
        "defaultIsOpen",
        "spacing",
        "options",
        "isSearchable",
        "components",
        "styles",
        "onChange",
        "onKeyDown",
        "onOpen",
        "onClose",
        "onMenuOpen",
        "onMenuClose",
        "popperProps",
        "shouldPreventEscapePropagation"
    ]);
    // State.
    const isControlled = controlledIsOpen !== undefined;
    const [internalIsOpen, setInternalIsOpen] = (0, _react.useState)(isControlled ? Boolean(controlledIsOpen) : Boolean(defaultIsOpen));
    const isOpen = isControlled ? Boolean(controlledIsOpen) : internalIsOpen;
    const selectRef = (0, _react.useRef)(null);
    const triggerRef = (0, _react.useRef)(null);
    const popoverRef = (0, _react.useRef)(null);
    const popoverId = (0, _usePopoverId.usePopoverId)();
    var _popperProps_placement;
    // Placement.
    const legacyPlacement = (_popperProps_placement = popperProps === null || popperProps === void 0 ? void 0 : popperProps.placement) !== null && _popperProps_placement !== void 0 ? _popperProps_placement : 'bottom-start';
    // `popup-select` historically defaulted to an `[along, away] = [0, 8]` popper offset
    // modifier; consumers can override it via `popperProps.modifiers`. Honour both here so
    // the top-layer rendering matches the legacy popper output.
    const legacyOffset = (0, _react.useMemo)(()=>{
        var _modifiers_find_options, _modifiers_find;
        const modifiers = popperProps === null || popperProps === void 0 ? void 0 : popperProps.modifiers;
        const value = modifiers === null || modifiers === void 0 ? void 0 : (_modifiers_find = modifiers.find((modifier)=>(modifier === null || modifier === void 0 ? void 0 : modifier.name) === 'offset')) === null || _modifiers_find === void 0 ? void 0 : (_modifiers_find_options = _modifiers_find.options) === null || _modifiers_find_options === void 0 ? void 0 : _modifiers_find_options.offset;
        if (Array.isArray(value) && value.length === 2) return [
            Number(value[0]) || 0,
            Number(value[1]) || 0
        ];
        return [
            0,
            8
        ];
    }, [
        popperProps === null || popperProps === void 0 ? void 0 : popperProps.modifiers
    ]);
    const topLayerPlacement = (0, _react.useMemo)(()=>(0, _placementMap.fromLegacyPlacement)({
            legacy: legacyPlacement,
            offset: legacyOffset
        }), [
        legacyPlacement,
        legacyOffset
    ]);
    (0, _useAnchorPosition.useAnchorPosition)({
        anchorRef: triggerRef,
        popoverRef,
        placement: topLayerPlacement,
        isOpen
    });
    // Merged components.
    const mergedComponents = (0, _react.useMemo)(()=>(0, _objectSpread._)({}, (0, _components.defaultComponents), consumerComponents), [
        consumerComponents
    ]);
    // Default styles.
    const defaultStyles = (0, _react.useMemo)(()=>({
            groupHeading: (provided)=>(0, _objectSpreadProps._)((0, _objectSpread._)({}, provided), {
                    color: "var(--ds-text-subtlest, #6B6E76)"
                })
        }), []);
    // Utils.
    const getItemCount = (0, _react.useCallback)(()=>{
        return options.reduce((count, groupOrOption)=>{
            const group = groupOrOption;
            if (group.options) return count + group.options.length;
            return count + 1;
        }, 0);
    }, [
        options
    ]);
    const showSearchControl = isSearchable && getItemCount() > searchThreshold;
    const getMaxHeight = (0, _react.useCallback)(()=>{
        var _selectRef_current_select;
        if (!selectRef.current) return maxMenuHeight;
        const controlRef = (_selectRef_current_select = selectRef.current.select) === null || _selectRef_current_select === void 0 ? void 0 : _selectRef_current_select.controlRef;
        const offsetHeight = showSearchControl && controlRef ? controlRef.offsetHeight : 0;
        return maxMenuHeight - offsetHeight;
    }, [
        maxMenuHeight,
        showSearchControl
    ]);
    const getLabel = (0, _react.useCallback)(()=>{
        if (label) return label;
        if (typeof placeholder === 'string') return placeholder;
        return undefined;
    }, [
        label,
        placeholder
    ]);
    // Open / Close.
    const open = (0, _react.useCallback)(()=>{
        if (!isControlled) setInternalIsOpen(true);
        onOpen === null || onOpen === void 0 ? void 0 : onOpen();
        onMenuOpen === null || onMenuOpen === void 0 ? void 0 : onMenuOpen();
    }, [
        isControlled,
        onOpen,
        onMenuOpen
    ]);
    const close = (0, _react.useCallback)(()=>{
        if (!isControlled) setInternalIsOpen(false);
        onClose === null || onClose === void 0 ? void 0 : onClose();
        onMenuClose === null || onMenuClose === void 0 ? void 0 : onMenuClose();
    }, [
        isControlled,
        onClose,
        onMenuClose
    ]);
    // Sync controlled isOpen.
    (0, _react.useEffect)(()=>{
        if (!isControlled) return;
        if (controlledIsOpen) {
            onOpen === null || onOpen === void 0 ? void 0 : onOpen();
            onMenuOpen === null || onMenuOpen === void 0 ? void 0 : onMenuOpen();
        } else {
            onClose === null || onClose === void 0 ? void 0 : onClose();
            onMenuClose === null || onMenuClose === void 0 ? void 0 : onMenuClose();
        }
    // Only react to changes in the controlled value
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        controlledIsOpen
    ]);
    // Open the react-select menu when isOpen becomes true.
    (0, _react.useEffect)(()=>{
        var _selectRef_current_select;
        if (isOpen && selectRef.current) (_selectRef_current_select = selectRef.current.select) === null || _selectRef_current_select === void 0 ? void 0 : _selectRef_current_select.openMenu('first');
    }, [
        isOpen
    ]);
    // Event Handlers.
    const handleTargetKeyDown = (0, _react.useCallback)((event)=>{
        if (event.key === 'ArrowDown') open();
    }, [
        open
    ]);
    // Open the menu when the trigger is clicked. Mirrors the legacy
    // `PopupSelect` global-click listener: consumers are not required to
    // spread an `onClick`, so we walk up from the event target to the
    // trigger ref instead.
    (0, _react.useEffect)(()=>{
        if (typeof window === 'undefined') return;
        return (0, _bindEventListener.bind)(window, {
            type: 'click',
            listener: (event)=>{
                const target = event.target;
                if (!(target instanceof Element)) return;
                const trigger = triggerRef.current;
                if (!trigger || !trigger.contains(target)) return;
                if (isOpen) {
                    close();
                    return;
                }
                open();
            },
            options: {
                capture: true
            }
        });
    }, [
        isOpen,
        open,
        close
    ]);
    // Focus restoration on close is handled automatically by Popover
    // based on the content role (role="dialog" -> auto-restore).
    const handleOnClose = (0, _react.useCallback)(({ reason: _reason })=>{
        if (isControlled) {
            // For controlled mode, notify consumer but do not change internal state
            onClose === null || onClose === void 0 ? void 0 : onClose();
            onMenuClose === null || onMenuClose === void 0 ? void 0 : onMenuClose();
            return;
        }
        close();
    }, [
        close,
        isControlled,
        onClose,
        onMenuClose
    ]);
    const handleSelectChange = (0, _react.useCallback)((value, actionMeta)=>{
        if (closeMenuOnSelect && actionMeta.action !== 'clear') {
            var // Return focus to trigger after selection
            _triggerRef_current;
            close();
            (_triggerRef_current = triggerRef.current) === null || _triggerRef_current === void 0 ? void 0 : _triggerRef_current.focus();
        }
        onChange === null || onChange === void 0 ? void 0 : onChange(value, actionMeta);
    }, [
        closeMenuOnSelect,
        close,
        onChange
    ]);
    const handleKeyDown = (0, _react.useCallback)((event)=>{
        const tabEvent = event.key === 'Tab';
        if (shouldCloseMenuOnTab && tabEvent) {
            var _triggerRef_current;
            close();
            (_triggerRef_current = triggerRef.current) === null || _triggerRef_current === void 0 ? void 0 : _triggerRef_current.focus();
        }
        // Escape closes the menu and returns focus to the trigger.
        // The browser auto-restores focus on Escape, but we close
        // explicitly here so isOpen state stays in sync with the popover.
        if (event.key === 'Escape') {
            var _triggerRef_current1;
            close();
            (_triggerRef_current1 = triggerRef.current) === null || _triggerRef_current1 === void 0 ? void 0 : _triggerRef_current1.focus();
        }
        onKeyDown === null || onKeyDown === void 0 ? void 0 : onKeyDown(event);
    }, [
        shouldCloseMenuOnTab,
        close,
        onKeyDown
    ]);
    // Select components.
    // Type assertion needed because defaultComponents uses concrete OptionType/boolean
    // but Select expects the generic Option/IsMulti parameters. The components are
    // structurally compatible regardless of the generic parameters.
    const selectComponentsMerged = (0, _react.useMemo)(()=>(0, _objectSpreadProps._)((0, _objectSpread._)({}, mergedComponents), {
            Control: showSearchControl ? mergedComponents.Control : (0, _dummyControl.DummyControl),
            // Render react-select's menu inline; PopupSelectTopLayer's own
            // `Popover` is already the top-layer host. Otherwise the flag-on
            // `MenuPortalTopLayer` would nest a second popover.
            MenuPortal: ({ children })=>/*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _react.Fragment), {
                    children: children
                })
        }), [
        mergedComponents,
        showSearchControl
    ]);
    const getSelectRef = (0, _react.useCallback)((ref)=>{
        selectRef.current = ref;
    }, []);
    const triggerProps = {
        ref: (node)=>{
            triggerRef.current = node;
        },
        // No `onClick` on `triggerProps`: the trigger click is observed via
        // the capture-phase global `click` listener in the effect above,
        // matching the legacy `PopupSelect` contract for consumers that do
        // not spread `triggerProps` onto their target.
        onKeyDown: handleTargetKeyDown,
        // Maintain existing aria attribute format for backwards compatibility.
        // Should technically be 'dialog' instead of 'true', but preserving
        // legacy behavior. See go/DSP-22283
        'aria-haspopup': 'true',
        'aria-expanded': isOpen,
        // Always emit aria-controls referencing the controlled element.
        // Matches the behavior of `getAriaForTrigger` (see
        // `@atlaskit/top-layer/get-aria-for-trigger`) and aligns with the
        // WAI-ARIA spec recommendation.
        'aria-controls': popoverId,
        isOpen
    };
    var _getLabel;
    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _react.Fragment), {
        children: [
            target === null || target === void 0 ? void 0 : target(triggerProps),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _popover.Popover), {
                ref: popoverRef,
                id: popoverId,
                role: "dialog",
                label: (_getLabel = getLabel()) !== null && _getLabel !== void 0 ? _getLabel : 'Popup select',
                isOpen: isOpen,
                onClose: handleOnClose,
                animate: true,
                placement: topLayerPlacement,
                testId: testId && `${testId}--content`,
                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _popoverSurface.PopoverSurface), {
                    children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                        // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop
                        style: {
                            maxWidth: maxMenuWidth,
                            minWidth: minMenuWidth
                        },
                        "data-testid": testId && `${testId}--menu`,
                        className: (0, _runtime.ax)([
                            "_2rko12b0 _bfhk1bhr _16qs130s",
                            (0, _platformFeatureFlags.fg)('platform-dst-shape-theme-default') && "_2rko1mok"
                        ]),
                        children: [
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _selectDefault.default), (0, _objectSpreadProps._)((0, _objectSpread._)({
                                label: getLabel(),
                                backspaceRemovesValue: false,
                                controlShouldRenderValue: false,
                                isClearable: false,
                                tabSelectsValue: false,
                                menuIsOpen: true,
                                placeholder: placeholder,
                                ref: getSelectRef
                            }, selectProps), {
                                options: options,
                                isSearchable: showSearchControl,
                                styles: (0, _reactSelect.mergeStyles)(defaultStyles, consumerStyles || {}),
                                maxMenuHeight: getMaxHeight(),
                                components: selectComponentsMerged,
                                onChange: handleSelectChange,
                                onKeyDown: handleKeyDown,
                                testId: testId
                            })),
                            footer
                        ]
                    })
                })
            })
        ]
    });
}

},{"@swc/helpers/_/_object_spread":"9gdrV","@swc/helpers/_/_object_spread_props":"kANqQ","@swc/helpers/_/_object_without_properties":"6HqIM","react/jsx-runtime":"bGvcw","react":"ltHCL","@compiled/react/runtime":"d27Vo","bind-event-listener":"bjeUU","@atlaskit/platform-feature-flags":"8rD2i","@atlaskit/react-select":"1iF04","@atlaskit/top-layer/placement-map":"fBy31","@atlaskit/top-layer/popover":"hLw5z","@atlaskit/top-layer/popover-surface":"hQQQ8","@atlaskit/top-layer/use-anchor-position":"6ghLj","@atlaskit/top-layer/use-popover-id":"6C7Zl","../select":"iPOlk","./components":"cwsRW","./dummy-control":"7xr4O","@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"hQQQ8":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "PopoverSurface", ()=>(0, _popoverSurface.PopoverSurface));
var _popoverSurface = require("../popover-surface");

},{"../popover-surface":"8JrVa","@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"8JrVa":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "PopoverSurface", ()=>(0, _popoverSurface.PopoverSurface));
var _popoverSurface = require("./popover-surface");

},{"./popover-surface":"4Uoau","@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"4Uoau":[function(require,module,exports,__globalThis) {
/* popover-surface.tsx generated by @compiled/babel-plugin v0.39.1 */ var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
/**
 * Optional styled wrapper for popover content.
 *
 * Adds default visual styling (background, border-radius, box-shadow)
 * using design tokens.
 *
 * Presentational primitive - `children`-only by design. This component
 * intentionally exposes no `style`, `className`, `xcss`, `id`, or `ref`
 * props. If you need any of those, render your own wrapper element inside
 * `Popover` instead. `PopoverSurface` is the no-config "give me the default
 * ADS overlay look" surface, nothing more.
 */ parcelHelpers.export(exports, "PopoverSurface", ()=>PopoverSurface);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _runtime = require("@compiled/react/runtime");
const styles = {
    root: "_2rkofajl _1reo1wug _18m91wug _bfhk1bhr _16qs130s"
};
function PopoverSurface({ children }) {
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
        className: (0, _runtime.ax)([
            styles.root
        ]),
        children: children
    });
}

},{"react/jsx-runtime":"bGvcw","react":"ltHCL","@compiled/react/runtime":"d27Vo","@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"fPVHh":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _reactIntl = require("react-intl");
const _default_1 = (0, _reactIntl.defineMessages)({
    starred: {
        id: 'atlassian-studio-common.picker.starred',
        defaultMessage: 'Starred',
        description: 'Label for starred project/spaces in picker'
    },
    all: {
        id: 'atlassian-studio-common.picker.all',
        defaultMessage: 'All',
        description: 'Label for remaining project/spaces in picker'
    },
    pickerLabel: {
        id: 'atlassian-studio-common.picker.pickerLabel',
        defaultMessage: 'Jira projects and Confluence spaces search picker',
        description: 'Accessibility label for the picker search input'
    },
    pickerLabelGalaxia: {
        id: 'atlassian-studio-common.picker.pickerLabelGalaxia',
        defaultMessage: 'Jira and Confluence spaces search picker',
        description: 'Accessibility label for the picker search input'
    }
});
exports.default = _default_1;

},{"react-intl":"f41fF","@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"cJ4zy":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _react = require("react");
const useAsync = (asyncFunction)=>{
    const [state, setState] = (0, _react.useState)({
        state: 'loading',
        result: undefined,
        error: undefined
    });
    const executeAsyncFunc = (0, _react.useCallback)((isCurrent)=>{
        setState({
            state: 'loading',
            result: undefined,
            error: undefined
        });
        asyncFunction().then((result)=>{
            if (isCurrent.current) setState({
                state: 'success',
                result: result,
                error: undefined
            });
        }).catch((err)=>{
            if (isCurrent.current) setState({
                state: 'error',
                result: undefined,
                error: err
            });
        });
    }, [
        asyncFunction
    ]);
    (0, _react.useEffect)(()=>{
        const isCurrent = {
            current: true
        };
        executeAsyncFunc(isCurrent);
        return ()=>{
            isCurrent.current = false;
        };
    }, [
        executeAsyncFunc
    ]);
    return state;
};
exports.default = useAsync;

},{"react":"ltHCL","@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"6z9tV":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "UnknownErrorPage", ()=>UnknownErrorPage);
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _reactIntl = require("react-intl");
var _new = require("@atlaskit/button/new");
var _image = require("@atlaskit/image");
var _imageDefault = parcelHelpers.interopDefault(_image);
var _link = require("@atlaskit/link");
var _linkDefault = parcelHelpers.interopDefault(_link);
var _errorLayout = require("../error-layout");
var _unknownErrorSvg = require("./assets/UnknownError.svg");
var _unknownErrorSvgDefault = parcelHelpers.interopDefault(_unknownErrorSvg);
var _messages = require("./messages");
var _messagesDefault = parcelHelpers.interopDefault(_messages);
const UnknownErrorPage = ()=>{
    const { formatMessage } = (0, _reactIntl.useIntl)();
    return /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _errorLayout.ErrorLayout), {
        illustration: /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _imageDefault.default), {
            src: (0, _unknownErrorSvgDefault.default),
            alt: formatMessage((0, _messagesDefault.default).imageAlt)
        }),
        heading: formatMessage((0, _messagesDefault.default).heading),
        message: formatMessage((0, _messagesDefault.default).message, {
            Link: (chunks)=>/*#__PURE__*/ (0, _reactDefault.default).createElement((0, _linkDefault.default), {
                    href: "https://status.atlassian.com/"
                }, chunks)
        }),
        action: /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _new.LinkButton), {
            href: "https://status.atlassian.com/"
        }, formatMessage((0, _messagesDefault.default).action))
    });
};

},{"react":"ltHCL","react-intl":"f41fF","@atlaskit/button/new":"aXnNi","@atlaskit/image":"gZMaF","@atlaskit/link":"iFOrl","../error-layout":"cQ547","./assets/UnknownError.svg":"1XTwk","./messages":"hFXXJ","@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"gZMaF":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>(0, _imageDefault.default));
var _image = require("./ui/image");
var _imageDefault = parcelHelpers.interopDefault(_image);

},{"./ui/image":"cIsfH","@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"cIsfH":[function(require,module,exports,__globalThis) {
/* index.tsx generated by @compiled/babel-plugin v0.39.1 */ var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>Image);
var _objectSpread = require("@swc/helpers/_/_object_spread");
var _objectWithoutProperties = require("@swc/helpers/_/_object_without_properties");
var _react = require("react");
var _runtime = require("@compiled/react/runtime");
var _appProvider = require("@atlaskit/app-provider");
var _useThemeObserver = require("@atlaskit/tokens/use-theme-observer");
const baseImageStyles = null; /**
                               * __Image__
                               *
                               * This component can be used interchangeably with the native `img` element. It includes additional functionality, such as theme support.
                               *
                               * - [Examples](https://atlassian.design/components/image/examples)
                               * - [Code](https://atlassian.design/components/image/code)
                               * - [Usage](https://atlassian.design/components/image/usage)
                               */ 
function Image(_param) {
    var { src, srcDark, alt, testId, className } = _param, props = (0, _objectWithoutProperties._)(_param, [
        "src",
        "srcDark",
        "alt",
        "testId",
        "className"
    ]);
    const imgRef = (0, _react.useRef)(null);
    const providedColorMode = (0, _appProvider.UNSAFE_useColorModeForMigration)();
    const { colorMode: observedColorMode } = (0, _useThemeObserver.useThemeObserver)();
    const colorMode = providedColorMode || observedColorMode;
    (0, _react.useEffect)(()=>{
        if (imgRef === null || imgRef.current === null) return;
        if (srcDark && colorMode === 'dark') imgRef.current.src = srcDark;
        else if (src) imgRef.current.src = src;
    }, [
        src,
        srcDark,
        colorMode
    ]);
    return /*#__PURE__*/ _react.createElement("img", (0, _objectSpread._)({
        alt: alt,
        "data-testid": testId,
        src: src,
        className: (0, _runtime.ax)([
            "_p12f1osq _4t3i1wug",
            className
        ]),
        ref: imgRef
    }, props));
}

},{"@swc/helpers/_/_object_spread":"9gdrV","@swc/helpers/_/_object_without_properties":"6HqIM","react":"ltHCL","@compiled/react/runtime":"d27Vo","@atlaskit/app-provider":"hIy26","@atlaskit/tokens/use-theme-observer":"4S775","@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"cQ547":[function(require,module,exports,__globalThis) {
/* index.tsx generated by @compiled/babel-plugin v0.39.1 */ var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "ErrorLayout", ()=>ErrorLayout);
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _heading = require("@atlaskit/heading");
var _headingDefault = parcelHelpers.interopDefault(_heading);
var _compiled = require("@atlaskit/primitives/compiled");
const styles = {
    gridStyles: "_4t3i1osq",
    flexStyles: "_y3gn1h6o"
};
const ErrorLayout = ({ heading, message, action, illustration, testId })=>{
    return /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _compiled.Grid), {
        justifyContent: "center",
        xcss: styles.gridStyles,
        testId: testId
    }, /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _compiled.Flex), {
        direction: "column",
        justifyContent: "center",
        alignItems: "center",
        xcss: styles.flexStyles,
        gap: "space.100"
    }, illustration && /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _compiled.Box), null, illustration), /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _headingDefault.default), {
        size: "large"
    }, heading), message && /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _compiled.Text), {
        color: "color.text.subtle"
    }, message), action && /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _compiled.Box), null, action)));
};

},{"react":"ltHCL","@atlaskit/heading":"61ZQz","@atlaskit/primitives/compiled":"hDay7","@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"61ZQz":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>(0, _headingDefault.default));
parcelHelpers.export(exports, "HeadingContextProvider", ()=>(0, _headingContextDefault.default));
var _heading = require("./heading");
var _headingDefault = parcelHelpers.interopDefault(_heading);
var _headingContext = require("./heading-context");
var _headingContextDefault = parcelHelpers.interopDefault(_headingContext);

},{"./heading":"lmYfF","./heading-context":"503Vr","@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"lmYfF":[function(require,module,exports,__globalThis) {
/* heading.tsx generated by @compiled/babel-plugin v0.39.1 */ /* eslint-disable @atlaskit/ui-styling-standard/no-nested-selectors, @atlaskit/ui-styling-standard/no-unsafe-selectors */ var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _react = require("react");
var _runtime = require("@compiled/react/runtime");
// eslint-disable-next-line @atlaskit/design-system/no-emotion-primitives -- to be migrated to @atlaskit/primitives/compiled – go/akcss
var _primitives = require("@atlaskit/primitives");
var _compiled = require("@atlaskit/primitives/compiled");
var _useHeading = require("./use-heading");
var process = require("db624189d2114751");
const sizeTagMap = {
    xxlarge: 'h1',
    xlarge: 'h1',
    large: 'h2',
    medium: 'h3',
    small: 'h4',
    xsmall: 'h5',
    xxsmall: 'h6'
};
/**
 * Using '&&' here to increase specificity of Heading styles such that app styles like ".wiki-content h4" cannot override this component.
 */ const styles = {
    reset: "_dxsyidpf _1i144jg8 _nmk4glyw"
};
/**
 * Using '&&' here to increase specificity of Heading styles such that app styles like ".wiki-content h4" cannot override this component.
 */ const headingColorStyles = {
    'color.text': "_1w90i7uo",
    'color.text.inverse': "_1w9015cr",
    'color.text.warning.inverse': "_1w901yd3"
};
/**
 * Using '&&' here to increase specificity of Heading styles such that app styles like ".wiki-content h4" cannot override this component.
 */ const headingSizeStyles = {
    xxlarge: "_fqox1iff",
    xlarge: "_fqox12ln",
    large: "_fqox10sd",
    medium: "_fqox1af2",
    small: "_fqox1e3o",
    xsmall: "_fqox1qyo",
    xxsmall: "_fqoxi4vh"
};
/**
 * @codegenEnd
 */ const useColor = (colorProp)=>{
    const surface = (0, _compiled.UNSAFE_useSurface)();
    if (colorProp) return colorProp;
    if ((0, _primitives.UNSAFE_inverseColorMap).hasOwnProperty(surface)) return (0, _primitives.UNSAFE_inverseColorMap)[surface];
    return 'color.text';
};
/**
 * __Heading__
 *
 * Heading is a typography component used to display text in defined sizes and styles.
 *
 * @example
 *
 * ```jsx
 * <Heading size="xxlarge">Page title</Heading>
 * ```
 */ const Heading = /*#__PURE__*/ (0, _react.forwardRef)((props, ref)=>{
    const { children, size, id, testId, as, color: colorProp } = props;
    typeof process;
    const [hLevel, inferredElement] = (0, _useHeading.useHeading)(sizeTagMap[size]);
    const Component = as || inferredElement;
    const needsAriaRole = Component === 'div' && hLevel;
    const color = useColor(colorProp);
    return /*#__PURE__*/ _react.createElement(Component, {
        id: id,
        ref: ref,
        "data-testid": testId,
        role: needsAriaRole ? 'heading' : undefined,
        "aria-level": needsAriaRole ? hLevel : undefined,
        className: (0, _runtime.ax)([
            styles.reset,
            headingSizeStyles[size],
            headingColorStyles[color]
        ])
    }, children);
});
exports.default = Heading;

},{"db624189d2114751":"gNLf3","react":"ltHCL","@compiled/react/runtime":"d27Vo","@atlaskit/primitives":"3S6Im","@atlaskit/primitives/compiled":"hDay7","./use-heading":"f4mmx","@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"f4mmx":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "useHeading", ()=>useHeading);
var _useHeadingLevel = require("./use-heading-level");
const useHeading = (fallback)=>{
    const hLevel = (0, _useHeadingLevel.useHeadingLevel)();
    /**
	 * Order here is important, we for now apply
	 * 1. inferred a11y level (this only applies if context is present)
	 * 2. default final fallback
	 */ return [
        hLevel,
        hLevel && (hLevel > 6 ? 'div' : `h${hLevel}`) || fallback
    ];
};

},{"./use-heading-level":"jae6x","@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"jae6x":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "useHeadingLevel", ()=>useHeadingLevel);
var _react = require("react");
var _headingLevelContext = require("./heading-level-context");
const useHeadingLevel = ()=>{
    return (0, _react.useContext)((0, _headingLevelContext.HeadingLevelContext));
};

},{"react":"ltHCL","./heading-level-context":"2JCW6","@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"2JCW6":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "HeadingLevelContext", ()=>HeadingLevelContext);
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
const HeadingLevelContext = /*#__PURE__*/ (0, _react.createContext)(0);

},{"react":"ltHCL","@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"503Vr":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _headingLevelContext = require("./heading-level-context");
var _useHeadingLevel = require("./use-heading-level");
/**
 * __Heading level provider__
 *
 * The Heading level provider injects the heading level to all `Heading` components below it in the component tree.
 *
 * @example
 * ```tsx
 * // Will correctly infer the heading level
 * <HeadingContext value={1}>
 *  <Heading>H1</Heading>
 *  <HeadingContext>
 *    <Heading>H2</Heading>
 *  </HeadingContext>
 * </HeadingContext>
 * ```
 */ const HeadingLevelContextProvider = ({ children, value })=>{
    const parentHeadingLevel = (0, _useHeadingLevel.useHeadingLevel)();
    const headingLevel = parentHeadingLevel + 1;
    return /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _headingLevelContext.HeadingLevelContext).Provider, {
        value: value || headingLevel
    }, children);
};
exports.default = HeadingLevelContextProvider;

},{"react":"ltHCL","./heading-level-context":"2JCW6","./use-heading-level":"jae6x","@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"1XTwk":[function(require,module,exports,__globalThis) {
module.exports = require("baf025fc0fa74795").getBundleURL('h9uuF') + "UnknownError.8ba8ed09.svg" + "?" + Date.now();

},{"baf025fc0fa74795":"cZKtR"}],"cZKtR":[function(require,module,exports,__globalThis) {
"use strict";
const stackTraceUrlRegexp = /(https?|file|ftp|(chrome|moz|safari-web)-extension):\/\/[^)\n]+/g;
const bundleURL = {};
/**
 * Retrieves the cached bundle URL for a given identifier.
 * If the URL is not cached, it computes and stores it in the cache.
 *
 * @param {string} id - The identifier for the bundle.
 * @param {Error?} inputError - An error object to extract the stack trace from
 * (for testing purposes).
 * @returns {string} The URL of the bundle, without file name.
 */ function getBundleURLCached(id, inputError) {
    let value = bundleURL[id];
    if (!value) {
        value = getBundleURL(inputError);
        bundleURL[id] = value;
    }
    return value;
}
/** Get the URL without the filename (last / segment)
 *
 * @param {string} url
 * @returns {string} The URL with the file name removed
 */ function getBaseURL(url) {
    return url.slice(0, url.lastIndexOf('/')) + '/';
}
function getBundleURL(inputError) {
    try {
        throw inputError !== null && inputError !== void 0 ? inputError : new Error();
    } catch (err) {
        var matches = ('' + err.stack).match(stackTraceUrlRegexp);
        if (matches) // The first two stack frames will be this function and getBundleURLCached.
        // Use the 3rd one, which will be a runtime in the original bundle.
        return getBaseURL(matches[2]);
    }
    return '/';
}
/**
 * @param {string} url
 * @returns {string}
 */ function getOrigin(url) {
    return new URL(url).origin;
}
// TODO: convert this file to ESM once HMR issues are resolved
exports.getOrigin = getOrigin;
exports.getBundleURL = getBundleURLCached;
exports.getBaseURL = getBaseURL;

},{}],"hFXXJ":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _reactIntl = require("react-intl");
const _default_1 = (0, _reactIntl.defineMessages)({
    heading: {
        id: 'atlassian-studio-common.unknown-error-page.heading',
        defaultMessage: 'Something went wrong',
        description: 'Title for the generic error page'
    },
    message: {
        id: 'atlassian-studio-common.unknown-error-page.message',
        defaultMessage: 'Try again later or check <Link>status.atlassian.com</Link> for the latest updates.',
        description: 'Message for the generic error page'
    },
    imageAlt: {
        id: 'atlassian-studio-common.unknown-error-page.imageAlt',
        defaultMessage: 'unknown error illustration',
        description: 'Alt text for the unknown error'
    },
    action: {
        id: 'atlassian-studio-common.unknown-error-page.action',
        defaultMessage: 'View status page',
        description: 'text for the action view status page button'
    }
});
exports.default = _default_1;

},{"react-intl":"f41fF","@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"6F7O9":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "UserContext", ()=>(0, _userContext.UserContext));
parcelHelpers.export(exports, "useUserContext", ()=>(0, _userContext.useUserContext));
parcelHelpers.export(exports, "TenantContext", ()=>(0, _tenantContext.TenantContext));
parcelHelpers.export(exports, "useTenantContext", ()=>(0, _tenantContext.useTenantContext));
var _userContext = require("./user-context");
var _tenantContext = require("./tenant-context");

},{"./user-context":"4eygq","./tenant-context":"a94EF","@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"4eygq":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "UserContext", ()=>UserContext);
parcelHelpers.export(exports, "useUserContext", ()=>useUserContext);
var _react = require("react");
const UserContext = /*#__PURE__*/ (0, _react.createContext)({});
const useUserContext = ()=>{
    return (0, _react.useContext)(UserContext);
};

},{"react":"ltHCL","@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"a94EF":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "TenantContext", ()=>TenantContext);
parcelHelpers.export(exports, "useTenantContext", ()=>useTenantContext);
var _react = require("react");
const TenantContext = /*#__PURE__*/ (0, _react.createContext)({});
const useTenantContext = ()=>{
    return (0, _react.useContext)(TenantContext);
};

},{"react":"ltHCL","@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"dyHUN":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "createFetchMessagesForLocale", ()=>createFetchMessagesForLocale);
const createFetchMessagesForLocale = (asyncLanguages, defaultMessages)=>{
    return async (locale)=>{
        try {
            var _asyncLanguages_languageLocale;
            // Fallback to the generic locale if specified one is not found
            const languageLocale = locale in asyncLanguages ? locale : locale.split(/[-_]/)[0] || '';
            // Dynamic import of the locale file
            const localeMessages = await ((_asyncLanguages_languageLocale = asyncLanguages[languageLocale]) === null || _asyncLanguages_languageLocale === void 0 ? void 0 : _asyncLanguages_languageLocale.call(asyncLanguages));
            var _localeMessages_default;
            return (_localeMessages_default = localeMessages === null || localeMessages === void 0 ? void 0 : localeMessages.default) !== null && _localeMessages_default !== void 0 ? _localeMessages_default : defaultMessages;
        } catch (e) {
        // ignore
        }
        return defaultMessages;
    };
};

},{"@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"3NpOM":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "isValidUrl", ()=>(0, _urlUtils.isValidUrl));
parcelHelpers.export(exports, "isEmptyString", ()=>(0, _stringUtils.isEmptyString));
parcelHelpers.export(exports, "isValidString", ()=>(0, _stringUtils.isValidString));
var _urlUtils = require("./url-utils");
var _stringUtils = require("./string-utils");

},{"./url-utils":"lJhT6","./string-utils":"3TFVT","@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"lJhT6":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "isValidUrl", ()=>isValidUrl);
var _stringUtils = require("../string-utils");
const isValidUrl = (url)=>{
    if ((0, _stringUtils.isEmptyString)(url)) return false;
    try {
        const urlTest = new URL(url); // isEmptyString checks for null/undefined input
        return !(0, _stringUtils.isEmptyString)(urlTest.origin);
    } catch (_) {
        return false;
    }
};

},{"../string-utils":"3TFVT","@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"3TFVT":[function(require,module,exports,__globalThis) {
/** @private
 * @deprecated use `isValidString` instead, with typescript type assertion
 */ var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "isEmptyString", ()=>isEmptyString);
parcelHelpers.export(exports, "isValidString", ()=>isValidString);
const isEmptyString = (input)=>{
    if (!input) return true;
    if (input.length === 0) return true;
    if (input.replace(/\s/g, '').length === 0) return true;
    return false;
};
const isValidString = (input)=>{
    return typeof input === 'string' && input.trim().length > 0;
};

},{"@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"frqGt":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "useSaHandoffTracker", ()=>useSaHandoffTracker);
var _react = require("react");
var _reactMagneticDi = require("react-magnetic-di");
var _reactResourceRouterNext = require("react-resource-router-next");
var _analyticsNext = require("@atlaskit/analytics-next");
var _analyticsBridge = require("@atlassian/analytics-bridge");
// All ids that were already triggered. This is outside react lifecycle to ensure it's not reset on re-render, which could cause duplicate events.
const _ids = new Set();
const hasBeenTriggered = (id)=>{
    return _ids.has(id);
};
const markAsTriggered = (id)=>{
    _ids.add(id);
};
const useSaHandoffTracker = (handoffType)=>{
    (0, _reactMagneticDi.di)((0, _analyticsNext.useAnalyticsEvents), (0, _reactResourceRouterNext.useQueryParam));
    const [saHandoff, setSaHandoff] = (0, _reactResourceRouterNext.useQueryParam)('saHandoff');
    const { createAnalyticsEvent } = (0, _analyticsNext.useAnalyticsEvents)();
    (0, _react.useEffect)(()=>{
        if (!saHandoff || hasBeenTriggered(saHandoff)) return;
        // Mark as triggered straight away to prevent duplicates
        markAsTriggered(saHandoff);
        // Clear the query param after tracking to avoid duplicate events
        setSaHandoff(undefined, 'replace');
        // Fire analytics event for successful handoff landing
        (0, _analyticsBridge.fireTrackAnalytics)(createAnalyticsEvent({}), 'solutionArchitectHandoff success', {
            name: handoffType
        });
    }, [
        saHandoff,
        setSaHandoff,
        handoffType,
        createAnalyticsEvent
    ]);
};

},{"react":"ltHCL","react-magnetic-di":"hCzc8","react-resource-router-next":"6gkfP","@atlaskit/analytics-next":"6PLie","@atlassian/analytics-bridge":"6YOyH","@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"72HEm":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "getConfig", ()=>getConfig);
var _objectSpread = require("@swc/helpers/_/_object_spread");
var _atlassianStudioEnvUtils = require("@atlassian/atlassian-studio-env-utils");
const stagingConfig = {
    atlassianAccountUrl: 'https://id.stg.internal.atlassian.com',
    featureGateApiKey: '7df50500-1036-4fcf-ae85-af97d39a2552'
};
const environmentOverrides = {
    production: {
        atlassianAccountUrl: 'https://id.atlassian.com',
        featureGateApiKey: 'c2edd581-96af-4e93-9629-ea093862c6b9'
    }
};
function getConfig() {
    const env = (0, _atlassianStudioEnvUtils.getMappedEnv)();
    return (0, _objectSpread._)({
        env
    }, stagingConfig, environmentOverrides[env]);
}

},{"@swc/helpers/_/_object_spread":"9gdrV","@atlassian/atlassian-studio-env-utils":"lO9Ek","@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"hLtlk":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "useRovoSidebar", ()=>useRovoSidebar);
var _react = require("react");
var _bindEventListener = require("bind-event-listener");
var _browserStorageControls = require("@atlassian/browser-storage-controls");
var _constants = require("../../common/constants");
const subscribe = (callback)=>{
    return (0, _bindEventListener.bind)(window, {
        type: 'rovo-sidebar-state-changed',
        listener: callback
    });
};
// Get the current state from localStorage
const getSnapshot = ()=>{
    return (0, _browserStorageControls.AtlBrowserStorageLocal).getItem((0, _constants.LS_ROVO_SIDEBAR_STATE_KEY));
};
// Set the state in localStorage
const setSnapshot = (isOpen)=>{
    try {
        const value = {
            isOpen
        };
        (0, _browserStorageControls.AtlBrowserStorageLocal).setItem((0, _constants.LS_ROVO_SIDEBAR_STATE_KEY), JSON.stringify(value));
        window.dispatchEvent(new Event('rovo-sidebar-state-changed'));
    } catch (e) {
    // Silently fail
    }
};
const useRovoSidebar = ()=>{
    // eslint-disable-next-line @atlaskit/platform/ensure-use-sync-external-store-server-snapshot
    const store = (0, _react.useSyncExternalStore)(subscribe, getSnapshot);
    const { isOpen } = (0, _react.useMemo)(()=>{
        if (!store) return {
            isOpen: false
        };
        const parsed = JSON.parse(store);
        return parsed;
    }, [
        store
    ]);
    const close = (0, _react.useCallback)(()=>{
        setSnapshot(false);
    }, []);
    const toggle = (0, _react.useCallback)(()=>{
        setSnapshot(!isOpen);
    }, [
        isOpen
    ]);
    return {
        isOpen,
        close,
        toggle
    };
};

},{"react":"ltHCL","bind-event-listener":"bjeUU","@atlassian/browser-storage-controls":"2PJfP","../../common/constants":"6qZUO","@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"2PJfP":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "ConsentBanner", ()=>(0, _consentBanner.ConsentBanner));
parcelHelpers.export(exports, "PreferenceModal", ()=>(0, _preferenceModal.PreferenceModal));
parcelHelpers.export(exports, "setCookie", ()=>(0, _cookieControls.setCookie));
parcelHelpers.export(exports, "setStrictlyNecessaryCookie", ()=>(0, _cookieControls.setStrictlyNecessaryCookie));
parcelHelpers.export(exports, "getCookie", ()=>(0, _cookieControls.getCookie));
parcelHelpers.export(exports, "deleteCookie", ()=>(0, _cookieControls.deleteCookie));
parcelHelpers.export(exports, "initializeControls", ()=>(0, _cookieControls.initializeControls));
parcelHelpers.export(exports, "unpackUserPreferencesCookie", ()=>(0, _cookieControls.unpackUserPreferencesCookie));
parcelHelpers.export(exports, "checkThirdParty", ()=>(0, _thirdPartyControls.checkThirdParty));
parcelHelpers.export(exports, "shouldRenderBanner", ()=>(0, _bannerControls.shouldRenderBanner));
parcelHelpers.export(exports, "shouldRenderBannerPrefetched", ()=>(0, _bannerControls.shouldRenderBannerPrefetched));
parcelHelpers.export(exports, "getPreferences", ()=>(0, _getPreferences.getPreferences));
parcelHelpers.export(exports, "LEGACY_ATLASSIAN_GDPR_COOKIE_KEY", ()=>(0, _constants.LEGACY_ATLASSIAN_GDPR_COOKIE_KEY));
parcelHelpers.export(exports, "ATLASSIAN_CONSENT_COOKIE_KEY", ()=>(0, _constants.ATLASSIAN_CONSENT_COOKIE_KEY));
parcelHelpers.export(exports, "ATLASSIAN_SHOW_BANNER_COOKIE_KEY", ()=>(0, _constants.ATLASSIAN_SHOW_BANNER_COOKIE_KEY));
parcelHelpers.export(exports, "ATLASSIAN_CONSENT_FALLBACK_COOKIE_KEY", ()=>(0, _constants.ATLASSIAN_CONSENT_FALLBACK_COOKIE_KEY));
parcelHelpers.export(exports, "ATLASSIAN_CURRENT_LOCALE_COOKIE_KEY", ()=>(0, _constants.ATLASSIAN_CURRENT_LOCALE_COOKIE_KEY));
parcelHelpers.export(exports, "Status", ()=>(0, _types.Status));
parcelHelpers.export(exports, "PrefetchedPreferenceState", ()=>(0, _types1.PrefetchedPreferenceState));
parcelHelpers.export(exports, "AtlBrowserStorageSession", ()=>(0, _webStorageService.AtlBrowserStorageSession));
parcelHelpers.export(exports, "AtlBrowserStorageLocal", ()=>(0, _webStorageService.AtlBrowserStorageLocal));
parcelHelpers.export(exports, "PreferenceCategory", ()=>(0, _types1.PreferenceCategory));
parcelHelpers.export(exports, "serializeConsents", ()=>(0, _utils.serializeConsents));
parcelHelpers.export(exports, "AtlIndexedDb", ()=>(0, _indexedDbWrapperService.AtlIndexedDb));
parcelHelpers.export(exports, "atlIndexedDb", ()=>(0, _indexedDbWrapperService.atlIndexedDb));
parcelHelpers.export(exports, "getItemCategoryFromPassedCache", ()=>(0, _itemProcessing.getItemCategoryFromPassedCache));
parcelHelpers.export(exports, "getCategoryCacheUrlPerimeterSSR", ()=>(0, _constants1.getCategoryCacheUrlPerimeterSSR));
var _consentBanner = require("./ui/consent-banner");
var _preferenceModal = require("./ui/consent-banner/preference-modal");
var _cookieControls = require("./controllers/cookie-controls");
var _thirdPartyControls = require("./controllers/third-party-controls");
var _bannerControls = require("./controllers/banner-controls");
var _getPreferences = require("./controllers/preferences-controls/get-preferences");
var _constants = require("./constants");
var _types = require("./controllers/cookie-controls/set-cookie/types");
var _types1 = require("./types");
var _webStorageService = require("./services/web-storage-service");
var _utils = require("./services/consent-hub-service/utils");
var _indexedDbWrapperService = require("./services/indexed-db-wrapper-service");
var _itemProcessing = require("./common/utils/item-processing");
var _constants1 = require("./common/utils/load-storage-controls-data/constants");

},{"./ui/consent-banner":"cldUf","./ui/consent-banner/preference-modal":"hZAKY","./controllers/cookie-controls":"7HiHV","./controllers/third-party-controls":"8AQMZ","./controllers/banner-controls":"hPe36","./controllers/preferences-controls/get-preferences":"030sv","./constants":"9FHD5","./controllers/cookie-controls/set-cookie/types":"6jQmL","./types":"65Pa5","./services/web-storage-service":"d0pCe","./services/consent-hub-service/utils":"8vzek","./services/indexed-db-wrapper-service":"MZEJS","./common/utils/item-processing":"8zwf4","./common/utils/load-storage-controls-data/constants":"ivrci","@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"cldUf":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "ConsentBanner", ()=>ConsentBanner);
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _reactErrorBoundary = require("react-error-boundary");
var _flag = require("@atlaskit/flag");
var _platformFeatureFlags = require("@atlaskit/platform-feature-flags");
var _logger = require("../../common/utils/logger");
var _consentBannerImpl = require("./consent-banner-impl");
const ConsentBanner = (props)=>{
    if ((0, _platformFeatureFlags.fg)('platform_moonjelly_bsc_master_killswitch') || (0, _platformFeatureFlags.fg)('platform_moonjelly_bsc_ui_killswitch')) {
        const { onConsentBannerBailOut } = props;
        // eslint-disable-next-line react-hooks/rules-of-hooks
        (0, _react.useEffect)(()=>{
            onConsentBannerBailOut === null || onConsentBannerBailOut === void 0 ? void 0 : onConsentBannerBailOut();
        }, [
            onConsentBannerBailOut
        ]);
        // Don't render the consent banner if the killswitch is enabled
        return null;
    }
    return /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _reactErrorBoundary.ErrorBoundary), {
        FallbackComponent: ()=>/*#__PURE__*/ (0, _reactDefault.default).createElement("div", {
                "data-testid": "consent-banner-render-error"
            }),
        onError: (e)=>{
            (0, _logger.Logger).errorWithOperationalEvent({
                action: 'renderConsentBannerError',
                message: e.message || ''
            });
        }
    }, /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _flag.FlagsProvider), null, /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _consentBannerImpl.ConsentBannerImpl), props)));
};

},{"react":"ltHCL","react-error-boundary":"cC53c","@atlaskit/flag":"6pYSa","@atlaskit/platform-feature-flags":"8rD2i","../../common/utils/logger":"2Tk7J","./consent-banner-impl":"2SfNZ","@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"6pYSa":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>(0, _flagDefault.default));
parcelHelpers.export(exports, "AutoDismissFlag", ()=>(0, _autoDismissFlagDefault.default));
parcelHelpers.export(exports, "FlagGroup", ()=>(0, _flagGroupDefault.default));
parcelHelpers.export(exports, "useFlags", ()=>(0, _flagProvider.useFlags));
parcelHelpers.export(exports, "withFlagsProvider", ()=>(0, _flagProvider.withFlagsProvider));
parcelHelpers.export(exports, "FlagsProvider", ()=>(0, _flagProvider.FlagsProvider));
var _flag = require("./flag");
var _flagDefault = parcelHelpers.interopDefault(_flag);
var _autoDismissFlag = require("./auto-dismiss-flag");
var _autoDismissFlagDefault = parcelHelpers.interopDefault(_autoDismissFlag);
var _flagGroup = require("./flag-group");
var _flagGroupDefault = parcelHelpers.interopDefault(_flagGroup);
var _flagProvider = require("./flag-provider");

},{"./flag":"fa04G","./auto-dismiss-flag":"eESnJ","./flag-group":"eOFCp","./flag-provider":"ktl7J","@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"fa04G":[function(require,module,exports,__globalThis) {
/* flag.tsx generated by @compiled/babel-plugin v0.39.1 */ var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _objectSpread = require("@swc/helpers/_/_object_spread");
var _objectSpreadProps = require("@swc/helpers/_/_object_spread_props");
var _react = require("react");
var _runtime = require("@compiled/react/runtime");
var _usePlatformLeafEventHandler = require("@atlaskit/analytics-next/usePlatformLeafEventHandler");
var _css = require("@atlaskit/css");
var _noop = require("@atlaskit/ds-lib/noop");
var _noopDefault = parcelHelpers.interopDefault(_noop);
var _heading = require("@atlaskit/heading");
var _headingDefault = parcelHelpers.interopDefault(_heading);
var _platformFeatureFlags = require("@atlaskit/platform-feature-flags");
var _compiled = require("@atlaskit/primitives/compiled");
var _visuallyHidden = require("@atlaskit/visually-hidden");
var _visuallyHiddenDefault = parcelHelpers.interopDefault(_visuallyHidden);
var _constants = require("./constants");
var _flagActions = require("./flag-actions");
var _flagActionsDefault = parcelHelpers.interopDefault(_flagActions);
var _flagBackgroundColor = require("./flag-background-color");
var _flagIconColor = require("./flag-icon-color");
var _flagIconGlyph = require("./flag-icon-glyph");
var _flagTextColor = require("./flag-text-color");
var _flagTextColorToken = require("./flag-text-color-token");
var _internal = require("./internal");
var _useFlagGroup = require("./internal/use-flag-group");
const styles = {
    overflowWrap: "_1i4qfg65",
    flag: "_2rkofajl _1reo15vq _18m915vq _v564z97a _16qs130s _1pbyni7l _1bsb1osq",
    flagT26Shape: "_2rko1mok"
};
const CSS_VAR_ICON_COLOR = '--flag-icon-color';
const descriptionStyles = null;
const flagWrapperStyles = null;
const iconWrapperStyles = null;
const transitionStyles = null;
const analyticsAttributes = {
    componentName: 'flag',
    packageName: "@af/atlassian-studio",
    packageVersion: "0.16.1"
};
/**
 * __Flag__
 *
 * A flag is used for confirmations, alerts, and acknowledgments that require minimal user interaction,
 * often displayed using a flag group.
 *
 * - [Examples](https://atlassian.design/components/flag/examples)
 * - [Code](https://atlassian.design/components/flag/code)
 * - [Usage](https://atlassian.design/components/flag/usage)
 */ const Flag = (props)=>{
    const { actions = [], appearance = (0, _constants.DEFAULT_APPEARANCE), icon, title, description, linkComponent, onMouseOver, onFocus = (0, _noopDefault.default), onMouseOut, onBlur = (0, _noopDefault.default), onDismissed: onDismissedProp = (0, _noopDefault.default), testId, id, analyticsContext, delayAnnouncement, headingLevel = 2 } = props;
    const [isDelayToAnnounce, setIsDelayToAnnounce] = (0, _react.useState)(false);
    const { onDismissed: onDismissedFromFlagGroup, isDismissAllowed } = (0, _useFlagGroup.useFlagGroup)();
    const onDismissed = (0, _react.useCallback)((id, analyticsEvent)=>{
        onDismissedProp(id, analyticsEvent);
        onDismissedFromFlagGroup(id, analyticsEvent);
    }, [
        onDismissedProp,
        onDismissedFromFlagGroup
    ]);
    const [isExpanded, setIsExpanded] = (0, _react.useState)(false);
    const onDismissedAnalytics = (0, _usePlatformLeafEventHandler.usePlatformLeafEventHandler)((0, _objectSpread._)({
        fn: onDismissed,
        action: 'dismissed',
        analyticsData: analyticsContext
    }, analyticsAttributes));
    const isBold = appearance !== (0, _constants.DEFAULT_APPEARANCE);
    const toggleExpand = (0, _react.useCallback)(()=>{
        setIsExpanded((previous)=>!previous);
    }, []);
    const buttonActionCallback = (0, _react.useCallback)(()=>{
        if (isDismissAllowed) onDismissedAnalytics(id);
    }, [
        onDismissedAnalytics,
        id,
        isDismissAllowed
    ]);
    (0, _react.useEffect)(()=>{
        // If buttons are removed as a prop, update isExpanded to be false
        if (isBold && isExpanded && !description && !actions.length) setIsExpanded(false);
    }, [
        actions.length,
        description,
        isBold,
        isExpanded
    ]);
    (0, _react.useEffect)(()=>{
        if (!delayAnnouncement) return;
        setTimeout(()=>{
            setIsDelayToAnnounce(true);
        }, delayAnnouncement);
    }, [
        delayAnnouncement
    ]);
    const onFocusAnalytics = (0, _usePlatformLeafEventHandler.usePlatformLeafEventHandler)((0, _objectSpread._)({
        fn: onFocus,
        action: 'focused',
        analyticsData: analyticsContext
    }, analyticsAttributes));
    const onBlurAnalytics = (0, _usePlatformLeafEventHandler.usePlatformLeafEventHandler)((0, _objectSpread._)({
        fn: onBlur,
        action: 'blurred',
        analyticsData: analyticsContext
    }, analyticsAttributes));
    const autoDismissProps = {
        onMouseOver,
        onFocus: onFocusAnalytics,
        onMouseOut,
        onBlur: onBlurAnalytics
    };
    const textColor = (0, _flagTextColor.flagTextColor)[appearance];
    const iconColor = (0, _flagIconColor.flagIconColor)[appearance];
    const iconGlyph = (0, _flagIconGlyph.flagIconGlyph)[appearance];
    const isDismissable = isBold || isDismissAllowed;
    const shouldRenderGap = !isBold && (description || actions.length) || isExpanded;
    // when delayAnnouncement is available we will use a hidden content for announcement
    const delayedAnnouncement = delayAnnouncement ? /*#__PURE__*/ _react.createElement((0, _visuallyHiddenDefault.default), null, title, description) : undefined;
    // A11y improvement opportunity: all flags currently use role="alert" (assertive),
    // but non-critical flags (e.g. info, success) should use role="status" (polite)
    // to avoid interrupting screen reader users. See WCAG 4.1.3.
    return /*#__PURE__*/ _react.createElement("div", (0, _objectSpreadProps._)((0, _objectSpread._)({
        role: "alert",
        "data-testid": testId
    }, autoDismissProps), {
        className: (0, _runtime.ax)([
            "_1bsb1osq"
        ])
    }), /*#__PURE__*/ _react.createElement((0, _compiled.Box), {
        padding: "space.200",
        backgroundColor: (0, _flagBackgroundColor.flagBackgroundColor)[appearance],
        xcss: (0, _css.cx)(styles.flag, (0, _platformFeatureFlags.fg)('platform-dst-shape-theme-default') && styles.flagT26Shape)
    }, /*#__PURE__*/ _react.createElement((0, _compiled.Inline), {
        alignBlock: "start",
        space: "space.200"
    }, /*#__PURE__*/ _react.createElement("div", {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
        style: {
            [CSS_VAR_ICON_COLOR]: iconColor
        },
        "data-testid": testId && `${testId}-icon-container`,
        className: (0, _runtime.ax)([
            "_1e0c1txw _1ul91tcg _1tke1tcg _4cvr1h6o _1bah1h6o _1o9zidpf _syaz1jn0"
        ])
    }, icon || iconGlyph), /*#__PURE__*/ _react.createElement("span", {
        className: (0, _runtime.ax)([
            "_v5641hdc _1ul9idpf _16jlkb7n"
        ])
    }, /*#__PURE__*/ _react.createElement((0, _compiled.Stack), {
        space: shouldRenderGap ? 'space.100' : 'space.0'
    }, isDelayToAnnounce && delayedAnnouncement, /*#__PURE__*/ _react.createElement((0, _compiled.Inline), {
        alignBlock: "stretch",
        space: "space.100",
        spread: "space-between"
    }, /*#__PURE__*/ _react.createElement((0, _compiled.Box), {
        paddingBlockStart: "space.050",
        paddingBlockEnd: "space.025",
        xcss: styles.overflowWrap
    }, /*#__PURE__*/ _react.createElement((0, _headingDefault.default), {
        as: `h${headingLevel}`,
        size: "xsmall",
        color: textColor
    }, /*#__PURE__*/ _react.createElement("span", {
        /* if isDelayToAnnounce is true, we will hide the content form screen reader to avoid duplicate announcement */ "aria-hidden": isDelayToAnnounce
    }, title))), isDismissable ? !(isBold && !description && !actions.length) && /*#__PURE__*/ _react.createElement((0, _internal.DismissButton), {
        testId: testId,
        appearance: appearance,
        isBold: isBold,
        isExpanded: isExpanded,
        onClick: isBold ? toggleExpand : buttonActionCallback
    }) : null), /*#__PURE__*/ _react.createElement((0, _internal.Expander), {
        isExpanded: !isBold || isExpanded,
        testId: testId
    }, description && /*#__PURE__*/ _react.createElement("div", {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop, @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
        style: {
            color: (0, _flagTextColorToken.flagTextColorToken)[appearance]
        },
        "data-testid": testId && `${testId}-description`,
        /* if isDelayToAnnounce is true, we will hide the content form screen reader to avoid duplicate announcement */ "aria-hidden": isDelayToAnnounce,
        className: (0, _runtime.ax)([
            "_11c8fhey _1reo1wug _18m91wug _c71l53f4 _1i4qfg65"
        ])
    }, description), /*#__PURE__*/ _react.createElement((0, _flagActionsDefault.default), {
        actions: actions,
        appearance: appearance,
        linkComponent: linkComponent,
        testId: testId
    })))))));
};
exports.default = Flag;

},{"@swc/helpers/_/_object_spread":"9gdrV","@swc/helpers/_/_object_spread_props":"kANqQ","react":"ltHCL","@compiled/react/runtime":"d27Vo","@atlaskit/analytics-next/usePlatformLeafEventHandler":"dRWFk","@atlaskit/css":"kMGms","@atlaskit/ds-lib/noop":"faKzG","@atlaskit/heading":"61ZQz","@atlaskit/platform-feature-flags":"8rD2i","@atlaskit/primitives/compiled":"hDay7","@atlaskit/visually-hidden":"gKDx1","./constants":"fwCtB","./flag-actions":"ampB6","./flag-background-color":"1HU8V","./flag-icon-color":"hlmQ2","./flag-icon-glyph":"4VeCG","./flag-text-color":"fq3GJ","./flag-text-color-token":"9eY3U","./internal":"kAOny","./internal/use-flag-group":"3pZJa","@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"fwCtB":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "DEFAULT_APPEARANCE", ()=>DEFAULT_APPEARANCE);
const DEFAULT_APPEARANCE = 'normal';

},{"@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"ampB6":[function(require,module,exports,__globalThis) {
/* flag-actions.tsx generated by @compiled/babel-plugin v0.39.1 */ /* eslint-disable @atlaskit/design-system/no-nested-styles */ var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _react = require("react");
var _runtime = require("@compiled/react/runtime");
var _customThemeButton = require("@atlaskit/button/custom-theme-button");
var _customThemeButtonDefault = parcelHelpers.interopDefault(_customThemeButton);
var _compiled = require("@atlaskit/primitives/compiled");
var _actionTextColor = require("./action-text-color");
var _constants = require("./constants");
var _theme = require("./theme");
const buttonStyles = null;
const fontStyles = null;
const appearanceNormalButtonStyles = null;
const appearanceNormalActionsContainerStyles = null;
const FlagActions = (props)=>{
    const { appearance = (0, _constants.DEFAULT_APPEARANCE), actions = [], linkComponent, testId } = props;
    if (!actions.length) return null;
    const isBold = appearance !== (0, _constants.DEFAULT_APPEARANCE);
    return /*#__PURE__*/ _react.createElement("span", {
        className: (0, _runtime.ax)([
            !isBold && "_1g4l107e _y8dn107e",
            "_11c8fhey"
        ])
    }, /*#__PURE__*/ _react.createElement((0, _compiled.Inline), {
        space: "space.100",
        shouldWrap: true,
        alignBlock: "center",
        separator: isBold ? undefined : "\xb7",
        testId: testId && `${testId}-actions`
    }, actions.map((action, index)=>/*#__PURE__*/ _react.createElement((0, _customThemeButtonDefault.default), {
            onClick: action.onClick,
            href: action.href,
            target: action.target,
            appearance: isBold ? 'default' : 'link',
            component: linkComponent,
            spacing: "compact",
            testId: action.testId,
            key: index,
            style: {
                // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
                '--color': (0, _actionTextColor.actionTextColor)[appearance],
                // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
                '--bg-color': (0, _theme.actionBackgroundColor)[appearance].default,
                // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
                '--bg-color-hover': (0, _theme.actionBackgroundColor)[appearance].pressed,
                // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
                '--bg-color-active': (0, _theme.actionBackgroundColor)[appearance].active
            },
            className: (0, _runtime.ax)([
                "_nup91zz4 _u4iq1zz4 _1w901pkf _qkwg1pkf _12r21wq8 _il101wq8 _1ku2grf3 _1v8mgrf3 _gbuigrf3 _1dwvgrf3 _1bk61a66 _1wy61a66 _b3g31a66 _eqps1a66 _ow071r31 _1p6b1r31 _8dbm1r31 _77mc1r31 _17rj8stv _1p6m8stv _5kwq8stv _1pd88stv _1iqunqa1 _1ejunqa1 _b6ztnqa1 _1rsgnqa1 _u1mb14jz _10fu17w4",
                appearance === (0, _constants.DEFAULT_APPEARANCE) && "_1dltgrf3 _h03xgrf3 _w8sqgrf3 _1iysgrf3 _fjwrgrf3 _cwkngrf3 _1yxxgrf3 _z7cdgrf3"
            ])
        }, action.content))));
};
// eslint-disable-next-line @repo/internal/react/require-jsdoc
exports.default = FlagActions;

},{"react":"ltHCL","@compiled/react/runtime":"d27Vo","@atlaskit/button/custom-theme-button":"2K4Lr","@atlaskit/primitives/compiled":"hDay7","./action-text-color":"1os9d","./constants":"fwCtB","./theme":"iETVC","@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"2K4Lr":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "Theme", ()=>(0, _themeDefault.default));
parcelHelpers.export(exports, "default", ()=>(0, _customThemeButtonDefault.default));
var _theme = require("../old-button/custom-theme-button/theme");
var _themeDefault = parcelHelpers.interopDefault(_theme);
var _customThemeButton = require("../old-button/custom-theme-button/custom-theme-button");
var _customThemeButtonDefault = parcelHelpers.interopDefault(_customThemeButton);

},{"../old-button/custom-theme-button/theme":"ghHwC","../old-button/custom-theme-button/custom-theme-button":"gyLrp","@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"ghHwC":[function(require,module,exports,__globalThis) {
// eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled -- Ignored via go/DSP-18766
var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _components = require("@atlaskit/theme/components");
var _getCustomCss = require("./get-custom-css");
const Theme = (0, _components.createTheme)((themeProps)=>({
        buttonStyles: (0, _getCustomCss.getCustomCss)(themeProps),
        // No styles being applied directly to spinner by default
        // Keeping this for legacy compat. We could remove it, but given
        // that we are changing theme soon there is no point
        spinnerStyles: {}
    }));
// eslint-disable-next-line @repo/internal/react/require-jsdoc
exports.default = Theme;

},{"@atlaskit/theme/components":"b3xOw","./get-custom-css":"7SPMP","@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"b3xOw":[function(require,module,exports,__globalThis) {
/*
   This file will become the new index for theme once the codemod is mature enough.
   For now we're keeping the index file to avoid having to do a major change.
   Once the codemod is done and all the AK modules have been codeshifted, we delete index.js and rename this file to index + update all the imports
*/ var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "getTheme", ()=>(0, _getThemeDefault.default));
parcelHelpers.export(exports, "default", ()=>(0, _themeDefault.default));
parcelHelpers.export(exports, "createTheme", ()=>(0, _createTheme.createTheme));
var _getTheme = require("./utils/get-theme");
var _getThemeDefault = parcelHelpers.interopDefault(_getTheme);
var _theme = require("./components/theme");
var _themeDefault = parcelHelpers.interopDefault(_theme);
var _createTheme = require("./utils/create-theme");

},{"./utils/get-theme":false,"./components/theme":"jt2Qd","./utils/create-theme":"hGgSv","@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"jt2Qd":[function(require,module,exports,__globalThis) {
/* eslint-disable @atlaskit/volt-strict-mode/no-multiple-exports */ var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "useGlobalTheme", ()=>useTheme);
var _createTheme = require("../utils/create-theme");
// Create default global light theme
const dest = (0, _createTheme.createTheme)(()=>({
        mode: 'light'
    }));
const Provider = dest.Provider;
const Consumer = dest.Consumer;
const useTheme = dest.useTheme;
const Theme = {
    Provider,
    Consumer
};
// eslint-disable-next-line @repo/internal/react/require-jsdoc
exports.default = Theme;

},{"../utils/create-theme":"hGgSv","@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"hGgSv":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
/**
 * createTheme is used to create a set of Providers and Consumers for theming components.
 * - Takes a default theme function; this theme function gets a set of props, and returns tokens
 *  based on those props. An example of this default theme function is one that produces the standard
 *  appearance of the component
 * - Returns three things - a Provider that allow for additional themes to be applied, a Consumer
 *  that can get the current theme and fetch it, and a custom hook - useTheme which provides an alternate (although functionally the same) API
 *  to the Consumer.
 */ parcelHelpers.export(exports, "createTheme", ()=>createTheme);
var _objectWithoutProperties = require("@swc/helpers/_/_object_without_properties");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
function createTheme(defaultGetTokens) {
    const emptyThemeFn = (getTokens, props)=>getTokens(props);
    /**
	 * Internally, Theme uses React Context, with internal providers and consumers.
	 * The React Context passes only a function that gets props, and turns them into tokens. This
	 * function gets mixed as more Providers with their own themes are added. This mixed function
	 * is ultimately picked up by Consumers, which implement a context consumer internally to fetch
	 * the theme.
	 */ const ThemeContext = /*#__PURE__*/ (0, _react.createContext)(defaultGetTokens);
    function useTheme(themeProps) {
        const theme = (0, _react.useContext)(ThemeContext);
        const themeFn = theme || emptyThemeFn;
        const tokens = themeFn(themeProps);
        return tokens;
    }
    // The Theme Consumer takes a function as its child - this function takes tokens, and the
    // return value is generally a set of nodes with the tokens applied appropriately.
    function Consumer(props) {
        const { children } = props, themeProps = (0, _objectWithoutProperties._)(props, [
            "children"
        ]);
        // @ts-ignore See issue for more info: https://github.com/Microsoft/TypeScript/issues/10727
        // Argument of type 'Pick<ThemeProps & { children: (tokens: ThemeTokens) => ReactNode; }, Exclude<keyof ThemeProps, "children">>' is not assignable to parameter of type 'ThemeProps'.ts(2345)
        const tokens = useTheme(themeProps);
        // We add a fragment to ensure we don't break people upgrading.
        // Previously they may have been able to pass in undefined without things blowing up.
        return /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _reactDefault.default).Fragment, null, children(tokens));
    }
    /**
	 * The Theme Provider takes regular nodes as its children, but also takes a *theme function*
	 * - The theme function takes a set of props, as well as a function (getTokens) that can turn props into tokens.
	 * - The getTokens function isn't called immediately - instead the props are passed
	 *    through a mix of parent theming functions
	 * Children of this provider will receive this mixed theme
	 */ function Provider(props) {
        const themeFn = (0, _react.useContext)(ThemeContext);
        const valueFn = props.value || emptyThemeFn;
        const mixedFn = (0, _react.useCallback)((themeProps)=>valueFn(themeFn, themeProps), [
            themeFn,
            valueFn
        ]);
        return /*#__PURE__*/ (0, _reactDefault.default).createElement(ThemeContext.Provider, {
            value: mixedFn
        }, props.children);
    }
    return {
        Consumer,
        Provider,
        useTheme
    };
}

},{"@swc/helpers/_/_object_without_properties":"6HqIM","react":"ltHCL","@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"7SPMP":[function(require,module,exports,__globalThis) {
// eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled -- Ignored via go/DSP-18766
var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
// Mapping the new clean css back to the legacy theme format.
// The legacy theme format has all styles at the top level (no nested selectors)
// and uses `getSpecifiers()` to apply the style to all pseudo states
parcelHelpers.export(exports, "getCustomCss", ()=>getCustomCss);
var _objectSpread = require("@swc/helpers/_/_object_spread");
var _getCss = require("../shared/get-css");
const stateToSelectorMap = {
    focus: '&:focus',
    focusSelected: '&:focus',
    hover: '&:hover',
    active: '&:active',
    disabled: '&[disabled]'
};
function getCustomCss({ appearance = 'default', spacing = 'default', isSelected = false, shouldFitContainer = false, iconIsOnlyChild = false, isLoading = false, state }) {
    let result = (0, _getCss.getCss)({
        appearance,
        spacing,
        isSelected,
        shouldFitContainer,
        isOnlySingleIcon: iconIsOnlyChild
    });
    // we need to disable the default browser focus styles always
    // this is because we are not expressing that we can have two pseudo states at a time
    result.outline = 'none';
    // Pulling relevant styles up to the top level
    const selector = stateToSelectorMap[state];
    if (selector) result = (0, _objectSpread._)({}, result, result[selector]);
    if (isLoading) result = (0, _objectSpread._)({}, result, result['&[data-has-overlay="true"]']);
    // Delete all selectors and just keep root styles
    Object.keys(result).forEach((key)=>{
        // want to keep this one
        if (key === '&::-moz-focus-inner') return;
        // Not using .startsWith for ie11
        if (key.indexOf('&') === 0) delete result[key];
    });
    return result;
}

},{"@swc/helpers/_/_object_spread":"9gdrV","../shared/get-css":"dYJ2c","@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"gyLrp":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _objectSpread = require("@swc/helpers/_/_object_spread");
var _objectSpreadProps = require("@swc/helpers/_/_object_spread_props");
var _objectWithoutProperties = require("@swc/helpers/_/_object_without_properties");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _components = require("@atlaskit/theme/components");
var _componentsDefault = parcelHelpers.interopDefault(_components);
var _buttonBase = require("../shared/button-base");
var _buttonBaseDefault = parcelHelpers.interopDefault(_buttonBase);
var _getIsOnlySingleIcon = require("../shared/get-is-only-single-icon");
var _getIsOnlySingleIconDefault = parcelHelpers.interopDefault(_getIsOnlySingleIcon);
var _loadingSpinner = require("../shared/loading-spinner");
var _loadingSpinnerDefault = parcelHelpers.interopDefault(_loadingSpinner);
var _defaultThemeFn = require("./default-theme-fn");
var _getSpecifiers = require("./get-specifiers");
var _theme = require("./theme");
var _themeDefault = parcelHelpers.interopDefault(_theme);
function getInteractionState({ isDisabled = false, isActive = false, isFocus = false, isHover = false, isSelected = false, isLoading = false }) {
    if (isDisabled) return 'disabled';
    if (isSelected && isFocus) return 'focusSelected';
    if (isSelected) return 'selected';
    // not allowing active or focus style changes while loading
    if (!isLoading && isActive) return 'active';
    if (!isLoading && isHover) return 'hover';
    if (isFocus) return 'focus';
    return 'default';
}
const initial = {
    isHover: false,
    isActive: false,
    isFocus: false
};
/**
 * __Custom theme button__
 *
 * @deprecated Legacy buttons are deprecated and will be removed from `atlaskit/button` in an upcoming major release. Please use the new Button components from `@atlaskit/button/new`
 *
 * Please refer to the [migration guide](https://atlassian.design/components/button/button-legacy/migration-guide) for further details.
 *
 * A custom theme button. Avoid using this component. It exists for those already using custom theming, which is hard to use and has performance issues.
 *
 * - [Examples](https://atlassian.design/components/button/examples#custom-theme-button)
 */ const CustomThemeButton = /*#__PURE__*/ (0, _reactDefault.default).memo(/*#__PURE__*/ (0, _reactDefault.default).forwardRef(function CustomThemeButton(_param, ref) {
    var { // Calculate default props for use in custom themes
    appearance = 'default', autoFocus = false, isDisabled = false, isSelected = false, shouldFitContainer = false, spacing = 'default', isLoading = false, onMouseEnter: providedOnMouseEnter, onMouseLeave: providedOnMouseLeave, onMouseDown: providedOnMouseDown, onMouseUp: providedOnMouseUp, onFocus: providedOnFocus, onBlur: providedOnBlur, theme = (0, _defaultThemeFn.defaultThemeFn) } = _param, rest = (0, _objectWithoutProperties._)(_param, [
        "appearance",
        "autoFocus",
        "isDisabled",
        "isSelected",
        "shouldFitContainer",
        "spacing",
        "isLoading",
        "onMouseEnter",
        "onMouseLeave",
        "onMouseDown",
        "onMouseUp",
        "onFocus",
        "onBlur",
        "theme"
    ]);
    // TODO is there a nicer way to do this?
    // Add default props back into object for spreading
    const restProps = (0, _objectSpread._)({
        appearance,
        autoFocus,
        isDisabled,
        isSelected,
        shouldFitContainer,
        spacing
    }, rest);
    const [state, setState] = (0, _react.useState)(initial);
    const onMouseEnter = (0, _react.useCallback)((event)=>{
        setState((current)=>(0, _objectSpreadProps._)((0, _objectSpread._)({}, current), {
                isHover: true
            }));
        if (providedOnMouseEnter) providedOnMouseEnter(event);
    }, [
        providedOnMouseEnter
    ]);
    const onMouseLeave = (0, _react.useCallback)((event)=>{
        setState((current)=>(0, _objectSpreadProps._)((0, _objectSpread._)({}, current), {
                isHover: false,
                isActive: false
            }));
        if (providedOnMouseLeave) providedOnMouseLeave(event);
    }, [
        providedOnMouseLeave
    ]);
    const onMouseDown = (0, _react.useCallback)((event)=>{
        setState((current)=>(0, _objectSpreadProps._)((0, _objectSpread._)({}, current), {
                isActive: true
            }));
        if (providedOnMouseDown) providedOnMouseDown(event);
    }, [
        providedOnMouseDown
    ]);
    const onMouseUp = (0, _react.useCallback)((event)=>{
        setState((current)=>(0, _objectSpreadProps._)((0, _objectSpread._)({}, current), {
                isActive: false
            }));
        if (providedOnMouseUp) providedOnMouseUp(event);
    }, [
        providedOnMouseUp
    ]);
    const onFocus = (0, _react.useCallback)((event)=>{
        setState((current)=>(0, _objectSpreadProps._)((0, _objectSpread._)({}, current), {
                isFocus: true
            }));
        if (providedOnFocus) providedOnFocus(event);
    }, [
        providedOnFocus
    ]);
    const onBlur = (0, _react.useCallback)((event)=>{
        setState((current)=>(0, _objectSpreadProps._)((0, _objectSpread._)({}, current), {
                isFocus: false
            }));
        if (providedOnBlur) providedOnBlur(event);
    }, [
        providedOnBlur
    ]);
    return /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _themeDefault.default).Provider, {
        value: theme
    }, /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _componentsDefault.default).Consumer, null, ({ mode })=>/*#__PURE__*/ (0, _reactDefault.default).createElement((0, _themeDefault.default).Consumer, (0, _objectSpread._)({
            mode: mode,
            state: getInteractionState((0, _objectSpreadProps._)((0, _objectSpread._)({}, state), {
                isLoading,
                isSelected: restProps.isSelected,
                isDisabled: restProps.isDisabled
            })),
            iconIsOnlyChild: (0, _getIsOnlySingleIconDefault.default)(restProps),
            isLoading: isLoading
        }, restProps), ({ buttonStyles })=>/*#__PURE__*/ (0, _reactDefault.default).createElement((0, _buttonBaseDefault.default), (0, _objectSpreadProps._)((0, _objectSpread._)({}, restProps), {
                ref: ref,
                overlay: isLoading ? /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _loadingSpinnerDefault.default), restProps) : null,
                // No need to render aria-disabled when it is false
                "aria-disabled": isLoading || restProps['aria-disabled'],
                onMouseEnter: onMouseEnter,
                onMouseLeave: onMouseLeave,
                onMouseDown: onMouseDown,
                onMouseUp: onMouseUp,
                onFocus: onFocus,
                onBlur: onBlur,
                buttonCss: (0, _getSpecifiers.getSpecifiers)(buttonStyles)
            })))));
}));
// Tools including enzyme rely on components having a display name
CustomThemeButton.displayName = 'CustomThemeButton';
exports.default = CustomThemeButton;

},{"@swc/helpers/_/_object_spread":"9gdrV","@swc/helpers/_/_object_spread_props":"kANqQ","@swc/helpers/_/_object_without_properties":"6HqIM","react":"ltHCL","@atlaskit/theme/components":"b3xOw","../shared/button-base":"dsrZX","../shared/get-is-only-single-icon":"8YxN4","../shared/loading-spinner":"8emRB","./default-theme-fn":"ywZ9D","./get-specifiers":"5uxCl","./theme":"ghHwC","@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"8emRB":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>LoadingSpinner);
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _spinner = require("@atlaskit/spinner");
var _spinnerDefault = parcelHelpers.interopDefault(_spinner);
function getSpinnerAppearance({ appearance, isDisabled, isSelected }) {
    if (isDisabled) return 'inherit';
    if (isSelected) return 'invert';
    if (appearance === 'primary' || appearance === 'danger') return 'invert';
    return 'inherit';
}
function LoadingSpinner({ appearance, isDisabled, isSelected, spacing = 'default' }) {
    const size = spacing === 'default' ? 'medium' : 'small';
    return /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _spinnerDefault.default), {
        size: size,
        label: ", Loading",
        appearance: getSpinnerAppearance({
            appearance,
            isDisabled,
            isSelected
        })
    });
}

},{"react":"ltHCL","@atlaskit/spinner":"l22fT","@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"ywZ9D":[function(require,module,exports,__globalThis) {
// eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled -- Ignored via go/DSP-18766
var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "defaultThemeFn", ()=>defaultThemeFn);
function defaultThemeFn(current, values) {
    return current(values);
}

},{"@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"5uxCl":[function(require,module,exports,__globalThis) {
// eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled -- Ignored via go/DSP-18766
var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
// This styling approach works by generating a 'style' and applying with maximum specificity
// To do this we are overwriting all pseudo selectors
parcelHelpers.export(exports, "getSpecifiers", ()=>getSpecifiers);
function getSpecifiers(styles) {
    return {
        '&, &:hover, &:active, &:focus, &:focus-visible, &:visited, &:disabled, &[disabled]': styles
    };
}

},{"@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"1os9d":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "actionTextColor", ()=>actionTextColor);
const actionTextColor = {
    success: "var(--ds-text-inverse, #FFFFFF)",
    info: "var(--ds-text-inverse, #FFFFFF)",
    error: "var(--ds-text-inverse, #FFFFFF)",
    warning: "var(--ds-text-warning-inverse, #292A2E)",
    normal: "var(--ds-link, #1868DB)"
};

},{"@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"iETVC":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "flagBackgroundColor", ()=>(0, _flagBackgroundColor.flagBackgroundColor));
parcelHelpers.export(exports, "flagIconColor", ()=>(0, _flagIconColor.flagIconColor));
parcelHelpers.export(exports, "flagIconGlyph", ()=>(0, _flagIconGlyph.flagIconGlyph));
parcelHelpers.export(exports, "flagTextColor", ()=>(0, _flagTextColor.flagTextColor));
parcelHelpers.export(exports, "flagTextColorToken", ()=>(0, _flagTextColorToken.flagTextColorToken));
parcelHelpers.export(exports, "actionTextColor", ()=>(0, _actionTextColor.actionTextColor));
parcelHelpers.export(exports, "actionBackgroundColor", ()=>actionBackgroundColor);
var _flagBackgroundColor = require("./flag-background-color");
var _flagIconColor = require("./flag-icon-color");
var _flagIconGlyph = require("./flag-icon-glyph");
var _flagTextColor = require("./flag-text-color");
var _flagTextColorToken = require("./flag-text-color-token");
var _actionTextColor = require("./action-text-color");
const actionBackgroundColor = {
    success: {
        default: "var(--ds-background-inverse-subtle, #00000029)",
        active: "var(--ds-background-inverse-subtle-pressed, #00000052)",
        pressed: "var(--ds-background-inverse-subtle-hovered, #0000003D)"
    },
    info: {
        default: "var(--ds-background-inverse-subtle, #00000029)",
        active: "var(--ds-background-inverse-subtle-pressed, #00000052)",
        pressed: "var(--ds-background-inverse-subtle-hovered, #0000003D)"
    },
    error: {
        default: "var(--ds-background-inverse-subtle, #00000029)",
        active: "var(--ds-background-inverse-subtle-pressed, #00000052)",
        pressed: "var(--ds-background-inverse-subtle-hovered, #0000003D)"
    },
    warning: {
        default: "var(--ds-background-inverse-subtle, #00000029)",
        active: "var(--ds-background-inverse-subtle-pressed, #00000052)",
        pressed: "var(--ds-background-inverse-subtle-hovered, #0000003D)"
    },
    normal: {
        default: 'none',
        active: 'none',
        pressed: 'none'
    }
};

},{"./flag-background-color":false,"./flag-icon-color":false,"./flag-icon-glyph":false,"./flag-text-color":false,"./flag-text-color-token":false,"./action-text-color":false,"@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"1HU8V":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "flagBackgroundColor", ()=>flagBackgroundColor);
const flagBackgroundColor = {
    error: 'color.background.danger.bold',
    info: 'color.background.neutral.bold',
    normal: 'elevation.surface.overlay',
    success: 'color.background.success.bold',
    warning: 'color.background.warning.bold'
};

},{"@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"hlmQ2":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "flagIconColor", ()=>flagIconColor);
const flagIconColor = {
    error: "var(--ds-icon-inverse, #FFFFFF)",
    info: "var(--ds-icon-inverse, #FFFFFF)",
    normal: "var(--ds-icon-subtle, #505258)",
    success: "var(--ds-icon-inverse, #FFFFFF)",
    warning: "var(--ds-icon-warning-inverse, #292A2E)"
};

},{"@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"4VeCG":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "flagIconGlyph", ()=>flagIconGlyph);
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _statusError = require("@atlaskit/icon/core/status-error");
var _statusErrorDefault = parcelHelpers.interopDefault(_statusError);
var _statusInformation = require("@atlaskit/icon/core/status-information");
var _statusInformationDefault = parcelHelpers.interopDefault(_statusInformation);
var _statusSuccess = require("@atlaskit/icon/core/status-success");
var _statusSuccessDefault = parcelHelpers.interopDefault(_statusSuccess);
var _statusWarning = require("@atlaskit/icon/core/status-warning");
var _statusWarningDefault = parcelHelpers.interopDefault(_statusWarning);
const flagIconGlyph = {
    error: /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _statusErrorDefault.default), {
        label: ""
    }),
    info: /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _statusInformationDefault.default), {
        label: ""
    }),
    normal: /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _statusInformationDefault.default), {
        label: ""
    }),
    success: /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _statusSuccessDefault.default), {
        label: ""
    }),
    warning: /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _statusWarningDefault.default), {
        label: ""
    })
};

},{"react":"ltHCL","@atlaskit/icon/core/status-error":"lTP2w","@atlaskit/icon/core/status-information":"TXFt5","@atlaskit/icon/core/status-success":"lTMbW","@atlaskit/icon/core/status-warning":"6K5qa","@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"lTP2w":[function(require,module,exports,__globalThis) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::3f93f06e22108e36edaead143b4f646b>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = void 0;
var _react = _interopRequireDefault(require("78cd1fbfe5d8d68"));
var _baseNew = _interopRequireDefault(require("cb8823777afd8c9f"));
function _interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "StatusError".
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Reserved for error statuses and messaging.
Filled status icons provide higher visual contrast to draw attention to important information.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const StatusErrorIcon = (props)=>/*#__PURE__*/ _react.default.createElement(_baseNew.default, Object.assign({
        name: "StatusErrorIcon",
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M6.586.603a2 2 0 0 1 2.828 0l5.983 5.983a2 2 0 0 1 0 2.828l-5.983 5.982a2 2 0 0 1-2.828 0L.604 9.414a2 2 0 0 1 0-2.828zM8 10.25a1 1 0 1 0 0 2 1 1 0 0 0 0-2m-.75-6.5V9h1.5V3.75z" clip-rule="evenodd"/>`
    }, props));
StatusErrorIcon.displayName = 'StatusErrorIcon';
var _default = exports.default = StatusErrorIcon;

},{"78cd1fbfe5d8d68":"ltHCL","cb8823777afd8c9f":"5XL7D"}],"TXFt5":[function(require,module,exports,__globalThis) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::456639fbdc991aefe1af05acf697365d>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = void 0;
var _react = _interopRequireDefault(require("9590a2f470572984"));
var _baseNew = _interopRequireDefault(require("bf0a1ed32ee84570"));
function _interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "StatusInformation".
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Reserved for information statuses and messaging. 
Filled status icons provide higher visual contrast to draw attention to important information.
For information tooltips, use the unfilled 'information circle' icon.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const StatusInformationIcon = (props)=>/*#__PURE__*/ _react.default.createElement(_baseNew.default, Object.assign({
        name: "StatusInformationIcon",
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M8 0a8 8 0 1 1 0 16A8 8 0 0 1 8 0M6.5 6.75v1.5h.75v4.25h1.5v-5A.75.75 0 0 0 8 6.75zM8 3.5a1 1 0 1 0 0 2 1 1 0 0 0 0-2" clip-rule="evenodd"/>`
    }, props));
StatusInformationIcon.displayName = 'StatusInformationIcon';
var _default = exports.default = StatusInformationIcon;

},{"9590a2f470572984":"ltHCL","bf0a1ed32ee84570":"5XL7D"}],"lTMbW":[function(require,module,exports,__globalThis) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::174472a7e38932dc7a97866e0be8034a>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = void 0;
var _react = _interopRequireDefault(require("299a3834411c82c8"));
var _baseNew = _interopRequireDefault(require("92335475e581e66b"));
function _interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "StatusSuccess".
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Reserved for success statuses and messaging. Filled status icons provide higher visual contrast to draw attention to important information.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const StatusSuccessIcon = (props)=>/*#__PURE__*/ _react.default.createElement(_baseNew.default, Object.assign({
        name: "StatusSuccessIcon",
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M8 0a8 8 0 1 1 0 16A8 8 0 0 1 8 0M6.75 9.828 4.826 7.52l-1.152.96 2.5 3a.75.75 0 0 0 1.152 0l5-6-1.152-.96z" clip-rule="evenodd"/>`
    }, props));
StatusSuccessIcon.displayName = 'StatusSuccessIcon';
var _default = exports.default = StatusSuccessIcon;

},{"299a3834411c82c8":"ltHCL","92335475e581e66b":"5XL7D"}],"6K5qa":[function(require,module,exports,__globalThis) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::2ee7b3f114c675eea0f953c33a485bcf>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = void 0;
var _react = _interopRequireDefault(require("4dad168cf442b0de"));
var _baseNew = _interopRequireDefault(require("fcb25f231dc05ae1"));
function _interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "StatusWarning".
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Reserved for warning statuses.
Filled status icons provide higher visual contrast to draw attention to important information.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const StatusWarningIcon = (props)=>/*#__PURE__*/ _react.default.createElement(_baseNew.default, Object.assign({
        name: "StatusWarningIcon",
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M6.242 1.168c.756-1.395 2.76-1.395 3.516 0l5.9 10.878c.723 1.333-.242 2.953-1.758 2.953H2.1C.584 15-.38 13.38.342 12.046zM8 10.75a1 1 0 1 0 0 2.001 1 1 0 0 0 0-2M7.25 4.5v5h1.5v-5z" clip-rule="evenodd"/>`
    }, props));
StatusWarningIcon.displayName = 'StatusWarningIcon';
var _default = exports.default = StatusWarningIcon;

},{"4dad168cf442b0de":"ltHCL","fcb25f231dc05ae1":"5XL7D"}],"fq3GJ":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "flagTextColor", ()=>flagTextColor);
const flagTextColor = {
    error: 'color.text.inverse',
    info: 'color.text.inverse',
    normal: 'color.text',
    success: 'color.text.inverse',
    warning: 'color.text.warning.inverse'
};

},{"@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"9eY3U":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "flagTextColorToken", ()=>flagTextColorToken);
const flagTextColorToken = {
    error: "var(--ds-text-inverse, #FFFFFF)",
    info: "var(--ds-text-inverse, #FFFFFF)",
    normal: "var(--ds-text, #292A2E)",
    success: "var(--ds-text-inverse, #FFFFFF)",
    warning: "var(--ds-text-warning-inverse, #292A2E)"
};

},{"@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"kAOny":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "Expander", ()=>(0, _expanderDefault.default));
parcelHelpers.export(exports, "DismissButton", ()=>(0, _dismissButtonDefault.default));
var _expander = require("./expander");
var _expanderDefault = parcelHelpers.interopDefault(_expander);
var _dismissButton = require("./dismiss-button");
var _dismissButtonDefault = parcelHelpers.interopDefault(_dismissButton);

},{"./expander":"bWxr7","./dismiss-button":"dUXQo","@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"bWxr7":[function(require,module,exports,__globalThis) {
/* expander.tsx generated by @compiled/babel-plugin v0.39.1 */ var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _objectSpread = require("@swc/helpers/_/_object_spread");
var _react = require("react");
var _motion = require("@atlaskit/motion");
var _compiled = require("@atlaskit/primitives/compiled");
const styles = {
    expander: "_1bsb1osq",
    container: "_v5641xzp"
};
const Expander = ({ children, isExpanded, testId })=>{
    // Need to always render the ExpanderInternal otherwise the
    // reveal transition doesn't happen. We can't use CSS animation for
    // the the reveal because we don't know the height of the content.
    return /*#__PURE__*/ _react.createElement((0, _compiled.Box), {
        xcss: styles.expander,
        style: {
            maxHeight: isExpanded ? 150 : 0,
            // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
            flex: '1 1 100%',
            // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
            minWidth: 0
        },
        "aria-hidden": !isExpanded,
        testId: testId && `${testId}-expander`
    }, /*#__PURE__*/ _react.createElement((0, _motion.ExitingPersistence), {
        appear: true
    }, isExpanded && /*#__PURE__*/ _react.createElement((0, _motion.FadeIn), null, (props)=>/*#__PURE__*/ _react.createElement((0, _compiled.Box), (0, _objectSpread._)({
            xcss: styles.container
        }, props), /*#__PURE__*/ _react.createElement((0, _compiled.Stack), {
            space: "space.100"
        }, children)))));
};
// eslint-disable-next-line @repo/internal/react/require-jsdoc
exports.default = Expander;

},{"@swc/helpers/_/_object_spread":"9gdrV","react":"ltHCL","@atlaskit/motion":"eg70v","@atlaskit/primitives/compiled":"hDay7","@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"dUXQo":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _objectSpread = require("@swc/helpers/_/_object_spread");
var _objectSpreadProps = require("@swc/helpers/_/_object_spread_props");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _new = require("@atlaskit/button/new");
var _chevronDown = require("@atlaskit/icon/core/chevron-down");
var _chevronDownDefault = parcelHelpers.interopDefault(_chevronDown);
var _chevronUp = require("@atlaskit/icon/core/chevron-up");
var _chevronUpDefault = parcelHelpers.interopDefault(_chevronUp);
var _cross = require("@atlaskit/icon/core/cross");
var _crossDefault = parcelHelpers.interopDefault(_cross);
var _flagTextColorToken = require("../flag-text-color-token");
const DismissButtonComponent = ({ appearance, onClick, isBold, isExpanded, testId })=>{
    let ButtonIcon = (0, _crossDefault.default);
    let buttonLabel = 'Dismiss';
    let buttonTestId = testId && `${testId}-dismiss`;
    if (isBold) {
        ButtonIcon = isExpanded ? (0, _chevronUpDefault.default) : (0, _chevronDownDefault.default);
        buttonLabel = isExpanded ? 'Collapse' : 'Expand';
        buttonTestId = testId && `${testId}-toggle`;
    }
    return /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _new.IconButton), {
        icon: (iconProps)=>/*#__PURE__*/ (0, _reactDefault.default).createElement(ButtonIcon, (0, _objectSpreadProps._)((0, _objectSpread._)({}, iconProps), {
                size: "small",
                label: "",
                color: (0, _flagTextColorToken.flagTextColorToken)[appearance]
            })),
        appearance: "subtle",
        spacing: "compact",
        label: buttonLabel,
        onClick: onClick,
        "aria-expanded": isBold ? isExpanded : undefined,
        testId: buttonTestId
    });
};
const DismissButton = /*#__PURE__*/ (0, _react.memo)(DismissButtonComponent);
// eslint-disable-next-line @repo/internal/react/require-jsdoc
exports.default = DismissButton;

},{"@swc/helpers/_/_object_spread":"9gdrV","@swc/helpers/_/_object_spread_props":"kANqQ","react":"ltHCL","@atlaskit/button/new":"aXnNi","@atlaskit/icon/core/chevron-down":"ieg9F","@atlaskit/icon/core/chevron-up":"i5Pp9","@atlaskit/icon/core/cross":"7mJX1","../flag-text-color-token":"9eY3U","@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"3pZJa":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
// eslint-disable-next-line @repo/internal/react/require-jsdoc
parcelHelpers.export(exports, "useFlagGroup", ()=>useFlagGroup);
var _react = require("react");
var _flagGroupContext = require("./flag-group-context");
function useFlagGroup() {
    return (0, _react.useContext)((0, _flagGroupContext.FlagGroupContext));
}

},{"react":"ltHCL","./flag-group-context":"5xn6M","@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"5xn6M":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "FlagGroupContext", ()=>FlagGroupContext);
var _react = require("react");
var _defaultFlagGroupContext = require("./default-flag-group-context");
const FlagGroupContext = /*#__PURE__*/ (0, _react.createContext)((0, _defaultFlagGroupContext.defaultFlagGroupContext));

},{"react":"ltHCL","./default-flag-group-context":"eziTN","@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"eziTN":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "defaultFlagGroupContext", ()=>defaultFlagGroupContext);
var _noop = require("@atlaskit/ds-lib/noop");
var _noopDefault = parcelHelpers.interopDefault(_noop);
const defaultFlagGroupContext = {
    onDismissed: (0, _noopDefault.default),
    isDismissAllowed: false
};

},{"@atlaskit/ds-lib/noop":"faKzG","@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"eESnJ":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "AUTO_DISMISS_SECONDS", ()=>AUTO_DISMISS_SECONDS);
var _objectSpread = require("@swc/helpers/_/_object_spread");
var _objectSpreadProps = require("@swc/helpers/_/_object_spread_props");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _usePlatformLeafEventHandler = require("@atlaskit/analytics-next/usePlatformLeafEventHandler");
var _noop = require("@atlaskit/ds-lib/noop");
var _noopDefault = parcelHelpers.interopDefault(_noop);
var _flag = require("./flag");
var _flagDefault = parcelHelpers.interopDefault(_flag);
var _useFlagGroup = require("./internal/use-flag-group");
const packageName = "@af/atlassian-studio";
const packageVersion = "0.16.1";
const AUTO_DISMISS_SECONDS = 8;
/**
 * __Auto dismiss flag__
 *
 * An auto dismiss flag is dismissed automatically after eight seconds.
 *
 * - [Examples](https://atlassian.design/components/flag/auto-dismiss-flag/examples)
 * - [Code](https://atlassian.design/components/flag/auto-dismiss-flag/code)
 */ const AutoDismissFlag = (props)=>{
    const { id, analyticsContext, onDismissed: onDismissedProp = (0, _noopDefault.default), autoDismissSeconds = AUTO_DISMISS_SECONDS } = props;
    const autoDismissTimer = (0, _react.useRef)(null);
    const { onDismissed: onDismissedFromFlagGroup, isDismissAllowed } = (0, _useFlagGroup.useFlagGroup)();
    const onDismissed = (0, _react.useCallback)((id, analyticsEvent)=>{
        onDismissedProp(id, analyticsEvent);
        onDismissedFromFlagGroup(id, analyticsEvent);
    }, [
        onDismissedProp,
        onDismissedFromFlagGroup
    ]);
    const onDismissedAnalytics = (0, _usePlatformLeafEventHandler.usePlatformLeafEventHandler)({
        fn: onDismissed,
        action: 'dismissed',
        analyticsData: analyticsContext,
        componentName: 'flag',
        packageName,
        packageVersion
    });
    const isAutoDismissAllowed = isDismissAllowed && onDismissed;
    const dismissFlag = (0, _react.useCallback)(()=>{
        if (isAutoDismissAllowed) onDismissedAnalytics(id);
    }, [
        id,
        onDismissedAnalytics,
        isAutoDismissAllowed
    ]);
    const stopAutoDismissTimer = (0, _react.useCallback)(()=>{
        if (autoDismissTimer.current) {
            clearTimeout(autoDismissTimer.current);
            autoDismissTimer.current = null;
        }
    }, []);
    const startAutoDismissTimer = (0, _react.useCallback)(()=>{
        if (!isAutoDismissAllowed) return;
        stopAutoDismissTimer();
        autoDismissTimer.current = window.setTimeout(dismissFlag, autoDismissSeconds * 1000);
    }, [
        dismissFlag,
        stopAutoDismissTimer,
        isAutoDismissAllowed,
        autoDismissSeconds
    ]);
    (0, _react.useEffect)(()=>{
        startAutoDismissTimer();
        return stopAutoDismissTimer;
    }, [
        startAutoDismissTimer,
        stopAutoDismissTimer
    ]);
    return /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _flagDefault.default), (0, _objectSpreadProps._)((0, _objectSpread._)({}, props), {
        onMouseOver: stopAutoDismissTimer,
        onFocus: stopAutoDismissTimer,
        onMouseOut: startAutoDismissTimer,
        onBlur: startAutoDismissTimer
    }));
};
exports.default = AutoDismissFlag;

},{"@swc/helpers/_/_object_spread":"9gdrV","@swc/helpers/_/_object_spread_props":"kANqQ","react":"ltHCL","@atlaskit/analytics-next/usePlatformLeafEventHandler":"dRWFk","@atlaskit/ds-lib/noop":"faKzG","./flag":"fa04G","./internal/use-flag-group":"3pZJa","@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"eOFCp":[function(require,module,exports,__globalThis) {
/* flag-group.tsx generated by @compiled/babel-plugin v0.39.1 */ var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "flagWidth", ()=>flagWidth);
var _react = require("react");
var _runtime = require("@compiled/react/runtime");
var _bindEventListener = require("bind-event-listener");
var _analyticsNext = require("@atlaskit/analytics-next");
var _browserApis = require("@atlaskit/browser-apis");
var _css = require("@atlaskit/css");
var _noop = require("@atlaskit/ds-lib/noop");
var _noopDefault = parcelHelpers.interopDefault(_noop);
var _motion = require("@atlaskit/motion");
var _platformFeatureFlags = require("@atlaskit/platform-feature-flags");
var _portal = require("@atlaskit/portal");
var _portalDefault = parcelHelpers.interopDefault(_portal);
var _compiled = require("@atlaskit/primitives/compiled");
var _constants = require("@atlaskit/theme/constants");
var _popover = require("@atlaskit/top-layer/popover");
var _visuallyHidden = require("@atlaskit/visually-hidden");
var _visuallyHiddenDefault = parcelHelpers.interopDefault(_visuallyHidden);
var _defaultFlagGroupContext = require("./internal/default-flag-group-context");
var _flagGroupContext = require("./internal/flag-group-context");
const flagWidth = 400;
// transition: none is set on first-of-type to prevent a bug in Firefox
// that causes a broken transition
const groupStyles = {
    root: "_v5641b8g _1bsb1kdj _kqswstnw _u7coidpf _1eqkauwl",
    first: "_v564glyw _t9ec1ygq _1pbyqfx8",
    second: "_1pbyegat",
    nth: "_5sag5cps _t9ec1hw2",
    hidden: "_3um015vq"
};
// transition: none is set on first-of-type to prevent a bug in Firefox
// that causes a broken transition
const groupStylesNew = {
    root: "_v564t8bh _kqswstnw _u7coidpf _1bsb1kdj _1eqkauwl",
    first: "_t9ec1ygq _1pbyqfx8",
    second: "_t9ec1pi4 _1pbyegat",
    nth: "_t9ec15wd",
    hidden: "_3um015vq"
};
// Transform needed to push up while 1st flag is leaving
// Exiting time should match the exiting time of motion so is halved
const dismissAllowedStyles = null;
const flagGroupContainerStyles = null;
// When rendering in top layer, z-index is redundant (top layer stacks above everything).
// Override to avoid leaving an explicit z-index on the container.
const flagGroupContainerStylesTopLayer = null;
// cc_mohiti_flag_anchoring: update left inset from space.1000 (80px) to space.600 (48px)
// to match the bottom inset and produce a symmetric 48px × 48px anchor.
// The 80px left offset was a legacy artefact from the old left-rail nav sidebar.
// The mobile reset is mirrored from the base style so the override is self-contained
// and doesn't depend on @compiled's atomic CSS emit order at the ≤560px breakpoint.
const flagGroupContainerStylesSymmetric = null;
/**
 * __Flag group__
 *
 * A flag group is used to group a set of related flags, with entry and exit animations.
 *
 * - [Examples](https://atlassian.design/components/flag/flag-group/examples)
 * - [Code](https://atlassian.design/components/flag/flag-group/code)
 */ const FlagGroup = (props)=>{
    const { id, label = 'Flag notifications', labelTag: LabelTag = 'h2', shouldRenderToParent = false, children, onDismissed = (0, _noopDefault.default) } = props;
    const hasFlags = Array.isArray(children) ? children.length > 0 : Boolean(children);
    const dismissFlagContext = (0, _react.useMemo)(()=>({
            onDismissed: onDismissed,
            isDismissAllowed: true
        }), [
        onDismissed
    ]);
    // Keep a stable reference to the latest children, dismiss handler, and
    // analytics creator so the keydown listener never reads stale closures.
    const { createAnalyticsEvent } = (0, _analyticsNext.useAnalyticsEvents)();
    const latestRef = (0, _react.useRef)({
        children,
        onDismissed,
        createAnalyticsEvent
    });
    latestRef.current = {
        children,
        onDismissed,
        createAnalyticsEvent
    };
    // Accessibility (JRACLOUD-97876): allow keyboard-only and assistive
    // technology users to dismiss the topmost (and only dismissable) flag with
    // the Escape key, without having to tab through the entire page to reach
    // the dismiss button. Behaviour is gated behind a feature flag so it can
    // be rolled out and validated incrementally.
    (0, _react.useEffect)(()=>{
        if (!(0, _platformFeatureFlags.fg)('platform_dst_flag_keyboard_dismiss')) return;
        if (!hasFlags) return;
        const doc = (0, _browserApis.getDocument)();
        if (!doc) return;
        const timeoutIds = new Set();
        const unbind = (0, _bindEventListener.bind)(doc, {
            type: 'keydown',
            listener: (event)=>{
                var _firstFlag_props;
                if (event.key !== 'Escape' || event.defaultPrevented) return;
                const currentChildren = latestRef.current.children;
                const firstFlag = Array.isArray(currentChildren) ? currentChildren.find(Boolean) : currentChildren;
                if (!firstFlag || typeof firstFlag !== 'object') return;
                const id = (_firstFlag_props = firstFlag.props) === null || _firstFlag_props === void 0 ? void 0 : _firstFlag_props.id;
                if (id === undefined || id === null || id === '') return;
                const analyticsEvent = latestRef.current.createAnalyticsEvent({
                    action: 'dismissed',
                    actionSubject: 'flag',
                    attributes: {
                        dismissedVia: 'keyboardShortcut',
                        key: 'Escape'
                    }
                });
                const timeoutId = setTimeout(()=>{
                    var _latestRef_current_onDismissed, _latestRef_current;
                    timeoutIds.delete(timeoutId);
                    if (event.defaultPrevented) return;
                    event.preventDefault();
                    (_latestRef_current_onDismissed = (_latestRef_current = latestRef.current).onDismissed) === null || _latestRef_current_onDismissed === void 0 ? void 0 : _latestRef_current_onDismissed.call(_latestRef_current, id, analyticsEvent);
                });
                timeoutIds.add(timeoutId);
            },
            options: {
                capture: true
            }
        });
        return ()=>{
            unbind();
            timeoutIds.forEach(clearTimeout);
            timeoutIds.clear();
        };
    }, [
        hasFlags
    ]);
    const renderChildren = ()=>{
        return children && typeof children === 'object' ? (0, _react.Children).map(children, (flag, index)=>{
            const isDismissAllowed = index === 0;
            return (0, _platformFeatureFlags.fg)('platform-dst-motion-uplift') ? /*#__PURE__*/ _react.createElement((0, _compiled.Box), {
                xcss: (0, _css.cx)(groupStylesNew.root, index === 0 && groupStylesNew.first, index === 1 && groupStylesNew.second, index >= 2 && groupStylesNew.nth, index >= 3 && groupStylesNew.hidden),
                "data-vc-oob": true
            }, /*#__PURE__*/ _react.createElement((0, _motion.Motion), {
                enteringAnimation: "var(--ds-flag-enter, 250ms cubic-bezier(0, 0.4, 0, 1) SlideIn50PercentLeft, 250ms cubic-bezier(0, 0.4, 0, 1) FadeIn0to100)",
                exitingAnimation: "var(--ds-flag-exit, 200ms cubic-bezier(0.6, 0, 0.8, 0.6) SlideOut15PercentLeft, 200ms cubic-bezier(0.6, 0, 0.8, 0.6) FadeOut100to0)"
            }, /*#__PURE__*/ _react.createElement((0, _flagGroupContext.FlagGroupContext).Provider, {
                value: // Only the first flag should be able to be dismissed.
                isDismissAllowed ? dismissFlagContext : (0, _defaultFlagGroupContext.defaultFlagGroupContext)
            }, flag))) : /*#__PURE__*/ _react.createElement((0, _motion.SlideIn), {
                enterFrom: "left",
                fade: "inout",
                duration: "medium",
                animationTimingFunction: "ease-in"
            }, ({ className, ref })=>/*#__PURE__*/ _react.createElement("div", {
                    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
                    className: (0, _runtime.ax)([
                        groupStyles.root,
                        index === 0 && groupStyles.first,
                        index === 1 && groupStyles.second,
                        index >= 1 && groupStyles.nth,
                        index >= 2 && groupStyles.hidden,
                        isDismissAllowed && "_12a7luct",
                        className
                    ]),
                    ref: ref,
                    "data-vc-oob": true
                }, /*#__PURE__*/ _react.createElement((0, _flagGroupContext.FlagGroupContext).Provider, {
                    value: // Only the first flag should be able to be dismissed.
                    isDismissAllowed ? dismissFlagContext : (0, _defaultFlagGroupContext.defaultFlagGroupContext)
                }, flag)));
        }) : false;
    };
    const useTopLayer = (0, _platformFeatureFlags.fg)('platform-dst-top-layer');
    const useSymmetricAnchor = (0, _platformFeatureFlags.fg)('cc_mohiti_flag_anchoring');
    const isKeyboardDismissEnabled = (0, _platformFeatureFlags.fg)('platform_dst_flag_keyboard_dismiss');
    // When the keyboard dismiss shortcut is available, surface it to assistive
    // technology users via the existing visually-hidden landmark heading so they
    // know they can press Escape to dismiss the topmost flag.
    const screenReaderLabel = isKeyboardDismissEnabled ? `${label}. Press Escape to dismiss.` : label;
    const flags = /*#__PURE__*/ _react.createElement("div", {
        id: id,
        "data-vc-oob": true,
        className: (0, _runtime.ax)([
            "_kqsw1n9t _1pbyxejw _u7cooahv _1e021epz _1iafidpf _il0widpf",
            useTopLayer && "_1pby1wug",
            useSymmetricAnchor && "_1e02oahv _il0widpf"
        ])
    }, hasFlags ? /*#__PURE__*/ _react.createElement((0, _visuallyHiddenDefault.default), null, /*#__PURE__*/ _react.createElement(LabelTag, null, screenReaderLabel)) : null, /*#__PURE__*/ _react.createElement((0, _motion.ExitingPersistence), {
        appear: false
    }, renderChildren()));
    if (useTopLayer) return /*#__PURE__*/ _react.createElement((0, _popover.Popover), {
        mode: "manual",
        isOpen: true
    }, flags);
    return shouldRenderToParent ? flags : /*#__PURE__*/ _react.createElement((0, _portalDefault.default), {
        zIndex: (0, _constants.layers).flag()
    }, flags);
};
exports.default = FlagGroup;

},{"react":"ltHCL","@compiled/react/runtime":"d27Vo","bind-event-listener":"bjeUU","@atlaskit/analytics-next":"6PLie","@atlaskit/browser-apis":"1bRFZ","@atlaskit/css":"kMGms","@atlaskit/ds-lib/noop":"faKzG","@atlaskit/motion":"eg70v","@atlaskit/platform-feature-flags":"8rD2i","@atlaskit/portal":"jvgcC","@atlaskit/primitives/compiled":"hDay7","@atlaskit/theme/constants":"gxXsN","@atlaskit/top-layer/popover":"hLw5z","@atlaskit/visually-hidden":"gKDx1","./internal/default-flag-group-context":"eziTN","./internal/flag-group-context":"5xn6M","@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"ktl7J":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
/**
 * useFlags is used to access the `showFlags` function which can be used to programmatically display flags.
 * - [Examples](https://atlassian.design/components/flag/flags-provider/examples#using-showflags)
 */ parcelHelpers.export(exports, "useFlags", ()=>useFlags);
// eslint-disable-next-line @atlaskit/volt-strict-mode/no-multiple-exports
parcelHelpers.export(exports, "FlagsProvider", ()=>FlagsProvider);
parcelHelpers.export(exports, "withFlagsProvider", ()=>withFlagsProvider);
var _objectSpread = require("@swc/helpers/_/_object_spread");
var _objectSpreadProps = require("@swc/helpers/_/_object_spread_props");
var _objectWithoutProperties = require("@swc/helpers/_/_object_without_properties");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _autoDismissFlag = require("./auto-dismiss-flag");
var _autoDismissFlagDefault = parcelHelpers.interopDefault(_autoDismissFlag);
var _flag = require("./flag");
var _flagDefault = parcelHelpers.interopDefault(_flag);
var _flagGroup = require("./flag-group");
var _flagGroupDefault = parcelHelpers.interopDefault(_flagGroup);
const FlagContext = /*#__PURE__*/ (0, _reactDefault.default).createContext(null);
function useFlags() {
    const api = (0, _react.useContext)(FlagContext);
    if (api == null) throw new Error('Unable to find FlagProviderContext');
    return api;
}
const getUniqueId = (()=>{
    let count = 0;
    return ()=>`flag-provider-unique-id:${count++}`;
})();
function FlagsProvider({ children, shouldRenderToParent }) {
    const [flags, setFlags] = (0, _react.useState)([]);
    const removeFlag = (0, _react.useCallback)((id)=>{
        setFlags((current)=>{
            return current.slice(0).filter((flag)=>flag.id !== id);
        });
    }, []);
    const api = (0, _react.useMemo)(()=>({
            showFlag: function show(value) {
                const flag = (0, _objectSpreadProps._)((0, _objectSpread._)({}, value), {
                    id: value.id || getUniqueId()
                });
                setFlags((current)=>{
                    const index = current.findIndex((value)=>value.id === flag.id);
                    // If flag is not found add it
                    if (index === -1) return [
                        flag,
                        ...current
                    ];
                    // If flag already exists with the same id, then replace it
                    const shallow = [
                        ...current
                    ];
                    shallow[index] = flag;
                    return shallow;
                });
                return function dismiss() {
                    removeFlag(flag.id);
                };
            },
            hideFlag: removeFlag
        }), [
        removeFlag
    ]);
    return /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _reactDefault.default).Fragment, null, /*#__PURE__*/ (0, _reactDefault.default).createElement(FlagContext.Provider, {
        value: api
    }, children), /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _flagGroupDefault.default), {
        onDismissed: removeFlag,
        shouldRenderToParent: shouldRenderToParent
    }, flags.map((flag)=>{
        const { isAutoDismiss } = flag, restProps = (0, _objectWithoutProperties._)(flag, [
            "isAutoDismiss"
        ]);
        const FlagType = isAutoDismiss ? (0, _autoDismissFlagDefault.default) : (0, _flagDefault.default);
        return /*#__PURE__*/ (0, _reactDefault.default).createElement(FlagType, (0, _objectSpreadProps._)((0, _objectSpread._)({}, restProps), {
            key: flag.id
        }));
    })));
}
const withFlagsProvider = (fn)=>/*#__PURE__*/ (0, _reactDefault.default).createElement(FlagsProvider, null, fn());

},{"@swc/helpers/_/_object_spread":"9gdrV","@swc/helpers/_/_object_spread_props":"kANqQ","@swc/helpers/_/_object_without_properties":"6HqIM","react":"ltHCL","./auto-dismiss-flag":"eESnJ","./flag":"fa04G","./flag-group":"eOFCp","@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"2Tk7J":[function(require,module,exports,__globalThis) {
/* eslint-disable no-console */ var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "Logger", ()=>Logger);
var _objectSpread = require("@swc/helpers/_/_object_spread");
var _platformFeatureFlags = require("@atlaskit/platform-feature-flags");
var _analyticsClient = require("../analytics-client");
var _constants = require("./constants");
var _determineLogLevel = require("./determine-log-level");
var _errorEventThrottle = require("./error-event-throttle");
var _logLevel = require("./log-level");
const formatMetadata = (metadata)=>{
    if (!metadata) return '';
    // `LoggingMetadata` allows a bare string; emit it as-is rather than running it
    // through JSON.stringify, which would wrap it in extra quotes ("error-code" -> '"error-code"').
    return typeof metadata === 'string' ? metadata : JSON.stringify(metadata);
};
class Logger {
    // All console output below ERROR (info/warn/debug) is gated behind
    // `platform_moonjelly_bsc_warn_on_set_blocked` so this package's new logging stays dark until
    // the flag is enabled. ERROR output is intentionally always on (subject only to the log level).
    //
    // The log-level comparison is evaluated FIRST in each guard so that `fg` is never called at
    // module-load time: at the default ERROR level these methods short-circuit before reaching
    // `fg`, which keeps a plain `import` of this package from evaluating feature gates (the same
    // import-time concern handled in determine-log-level.ts).
    static info(message, metadata) {
        if ((0, _determineLogLevel.determineLogLevel)() >= (0, _logLevel.LogLevel).INFO && (0, _platformFeatureFlags.fg)('platform_moonjelly_bsc_warn_on_set_blocked')) console.info(`${(0, _constants.LOG_PREFIX)}: ${message}`, formatMetadata(metadata));
    }
    static warn(message, metadata) {
        if ((0, _determineLogLevel.determineLogLevel)() >= (0, _logLevel.LogLevel).WARN && (0, _platformFeatureFlags.fg)('platform_moonjelly_bsc_warn_on_set_blocked')) console.warn(`${(0, _constants.LOG_PREFIX)}: ${message}`, formatMetadata(metadata));
    }
    static error(message, metadata) {
        if ((0, _determineLogLevel.determineLogLevel)() >= (0, _logLevel.LogLevel).ERROR) console.error(`${(0, _constants.LOG_PREFIX)}: ${message}`, formatMetadata(metadata));
    }
    static debug(message, metadata) {
        if ((0, _determineLogLevel.determineLogLevel)() >= (0, _logLevel.LogLevel).DEBUG && (0, _platformFeatureFlags.fg)('platform_moonjelly_bsc_warn_on_set_blocked')) console.debug(`${(0, _constants.LOG_PREFIX)}: DEBUG ${message}`, formatMetadata(metadata));
    }
    /**
	 * Sends an unsampled operational event to backend telemetry and also emits the message via
	 * `Logger.error`. When `platform_bsc_throttle_error_events` is enabled the telemetry send is
	 * throttled per-action (see error-event-throttle); otherwise it is unconditional. The console
	 * output is always at ERROR level (subject to the resolved log level).
	 */ static errorWithOperationalEvent({ action, attributes = {}, message, metadata }) {
        try {
            // When the throttle gate is OFF the second operand is never evaluated, so no throttle
            // state is recorded and behaviour is unchanged. When ON, shouldSendErrorEvent records
            // the send and limits per-action volume.
            if (!(0, _platformFeatureFlags.fg)('platform_bsc_throttle_error_events') || (0, _errorEventThrottle.shouldSendErrorEvent)(action)) (0, _analyticsClient.sendUnsampledPackageOperationalEvent)({
                action,
                attributes: (0, _objectSpread._)({
                    error: message
                }, attributes)
            });
        } catch (e) {
            this.error(`Failed to send operational event on error: ${action}. ${e.message || ''}`);
        }
        this.error(message, metadata);
    }
}

},{"@swc/helpers/_/_object_spread":"9gdrV","@atlaskit/platform-feature-flags":"8rD2i","../analytics-client":"3Dqor","./constants":"hwbCh","./determine-log-level":"bAWK3","./error-event-throttle":"7Mt17","./log-level":"b7xxj","@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"3Dqor":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "getProductSubPath", ()=>getProductSubPath);
parcelHelpers.export(exports, "getContextualPageDetails", ()=>getContextualPageDetails);
parcelHelpers.export(exports, "getAnalyticsClient", ()=>getAnalyticsClient);
parcelHelpers.export(exports, "sendPackageOperationalEvent", ()=>sendPackageOperationalEvent);
/**
 * Sends an operational event directly without sampling. Use this for error events that should
 * always be sent (sampling ratio = 1) and to avoid potential recursive call chains that can
 * occur when sampling config is loaded asynchronously via the same error-reporting code path.
 */ parcelHelpers.export(exports, "sendUnsampledPackageOperationalEvent", ()=>sendUnsampledPackageOperationalEvent);
parcelHelpers.export(exports, "sendUIEvent", ()=>sendUIEvent);
parcelHelpers.export(exports, "sendScreenEvent", ()=>sendScreenEvent);
parcelHelpers.export(exports, "sendTrackEvent", ()=>sendTrackEvent);
var _objectSpread = require("@swc/helpers/_/_object_spread");
var _objectSpreadProps = require("@swc/helpers/_/_object_spread_props");
var _objectWithoutProperties = require("@swc/helpers/_/_object_without_properties");
var _analyticsWebClient = require("@atlassiansox/analytics-web-client");
var _analyticsWebClientDefault = parcelHelpers.interopDefault(_analyticsWebClient);
var _core = require("../bsc-global-state/core");
var _constants = require("../logger/constants");
var _packageInfo = require("../package-info");
var _withSampling = require("./with-sampling");
const getEnvironment = ()=>{
    const { hostname } = window.location;
    if (hostname.includes('.dev.') || hostname.includes('.stg.') || hostname.includes('.jira-dev.') || hostname.includes('.jira-stg.')) return (0, _analyticsWebClient.envType).STAGING;
    if (hostname.includes('localhost') || hostname.includes('ngrok') || hostname.includes('atlastunnel')) return (0, _analyticsWebClient.envType).DEV;
    return (0, _analyticsWebClient.envType).PROD;
};
const getProductSubPath = (path)=>{
    let subPath = '';
    if (!path) return subPath;
    const checkPath = (match)=>{
        return new RegExp(`^${match}(/|$)`).test(String(path));
    };
    if (checkPath('/wiki')) subPath = '/wiki';
    if (checkPath('/jira')) subPath = '/jira';
    if (checkPath('/compass')) subPath = '/compass';
    if (checkPath('/canvas')) subPath = '/canvas';
    if (checkPath('/servicedesk') || checkPath('/jira/servicedesk')) subPath = '/servicedesk';
    return subPath;
};
const getProductFromDomain = (domain)=>{
    if (domain === 'https://trello.com') return 'trello';
    return null;
};
const getContextualPageDetails = ()=>{
    const { origin, pathname } = window.location;
    const productPath = getProductSubPath(pathname);
    const domain = `${origin}${productPath}`;
    const product = getProductFromDomain(domain) || productPath.slice(1);
    return {
        domain: domain,
        product: product
    };
};
const decorateEventAttributes = (attributes)=>{
    var _getBscGlobalState_product;
    const { domain, product } = getContextualPageDetails();
    var _getBscGlobalState_product_toLowerCase;
    return (0, _objectSpread._)({
        packageName: (0, _packageInfo.packageName),
        packageVersion: (0, _packageInfo.packageVersion),
        domain,
        product: (_getBscGlobalState_product_toLowerCase = (_getBscGlobalState_product = (0, _core.getBscGlobalState)().product) === null || _getBscGlobalState_product === void 0 ? void 0 : _getBscGlobalState_product.toLowerCase()) !== null && _getBscGlobalState_product_toLowerCase !== void 0 ? _getBscGlobalState_product_toLowerCase : product
    }, attributes && attributes);
};
const getAnalyticsClient = (()=>{
    let instance;
    return ()=>{
        try {
            if (!instance && (0, _core.getBscGlobalState)().analyticsEnabled) {
                instance = new (0, _analyticsWebClientDefault.default)({
                    env: getEnvironment(),
                    product: 'atlassianCookies'
                }, {
                    // useLegacyUrl tells the analytics client to make calls directly to Global Analytics Service.
                    // When set to false, the client will use a stargate proxy for the current URL to send events
                    // to GAS. Said another way:
                    // true => events are sent to https://api-private.stg.atlassian.com/gasv3/api/v1/batch
                    // false => events are sent to <the current domain>/gasv3/api/v1/batch
                    //
                    // By default, this should be set to false.  If you need to validate that analytics events
                    // are being transmitted correctly in local dev, you can temporarily enable it since localhost
                    // won't be able to proxy to GAS via stargate.
                    useLegacyUrl: false,
                    disableCookiePersistence: true
                });
                if ((0, _core.getBscGlobalState)().cloudId) instance.setTenantInfo((0, _analyticsWebClient.tenantType).CLOUD_ID, (0, _core.getBscGlobalState)().cloudId);
                var _getBscGlobalState_userId;
                if ((0, _core.getBscGlobalState)().userId) instance.setUserInfo((0, _analyticsWebClient.userType).ATLASSIAN_ACCOUNT, (_getBscGlobalState_userId = (0, _core.getBscGlobalState)().userId) !== null && _getBscGlobalState_userId !== void 0 ? _getBscGlobalState_userId : '');
            }
        } catch (e) {
            // Log  errors thrown in constructor initialization for the AnalyticsWebClient
            // eslint-disable-next-line no-console
            console.error(`${(0, _constants.LOG_PREFIX)}: Failed to initialize AnalyticsWebClient. ${e}`);
        }
        if (!(0, _core.getBscGlobalState)().analyticsEnabled) return undefined;
        // Return the instance, even if it is undefined
        return instance;
    };
})();
function sendPackageOperationalEvent(properties) {
    (0, _withSampling.withAnalyticsEventSampling)(properties.action, ()=>{
        var _getAnalyticsClient;
        return (_getAnalyticsClient = getAnalyticsClient()) === null || _getAnalyticsClient === void 0 ? void 0 : _getAnalyticsClient.sendOperationalEvent({
            source: 'package',
            actionSubject: 'package',
            action: properties.action,
            attributes: decorateEventAttributes(properties.attributes)
        });
    });
}
function sendUnsampledPackageOperationalEvent(properties) {
    var _getAnalyticsClient;
    (_getAnalyticsClient = getAnalyticsClient()) === null || _getAnalyticsClient === void 0 ? void 0 : _getAnalyticsClient.sendOperationalEvent({
        source: 'package',
        actionSubject: 'package',
        action: properties.action,
        attributes: decorateEventAttributes(properties.attributes)
    });
}
function sendUIEvent(properties) {
    (0, _withSampling.withAnalyticsEventSampling)(properties.actionSubjectId, ()=>{
        var _getAnalyticsClient;
        return (_getAnalyticsClient = getAnalyticsClient()) === null || _getAnalyticsClient === void 0 ? void 0 : _getAnalyticsClient.sendUIEvent((0, _objectSpreadProps._)((0, _objectSpread._)({}, properties), {
            attributes: decorateEventAttributes(properties.attributes)
        }));
    });
}
function sendScreenEvent(properties) {
    (0, _withSampling.withAnalyticsEventSampling)(properties.name, ()=>{
        var _getAnalyticsClient;
        return (_getAnalyticsClient = getAnalyticsClient()) === null || _getAnalyticsClient === void 0 ? void 0 : _getAnalyticsClient.sendScreenEvent((0, _objectSpreadProps._)((0, _objectSpread._)({}, properties), {
            attributes: decorateEventAttributes(properties.attributes)
        }));
    });
}
function sendTrackEvent(properties) {
    const { onSent } = properties, eventProperties = (0, _objectWithoutProperties._)(properties, [
        "onSent"
    ]);
    (0, _withSampling.withAnalyticsEventSampling)(properties.actionSubject, ()=>{
        const client = getAnalyticsClient();
        if (!client) // No client means nothing was emitted, so we must not run onSent
        return;
        client.sendTrackEvent((0, _objectSpreadProps._)((0, _objectSpread._)({}, eventProperties), {
            attributes: decorateEventAttributes(properties.attributes)
        }));
        onSent === null || onSent === void 0 ? void 0 : onSent();
    });
}

},{"@swc/helpers/_/_object_spread":"9gdrV","@swc/helpers/_/_object_spread_props":"kANqQ","@swc/helpers/_/_object_without_properties":"6HqIM","@atlassiansox/analytics-web-client":"6RHYr","../bsc-global-state/core":"Lu8Q3","../logger/constants":"hwbCh","../package-info":"czxhD","./with-sampling":"dMtfh","@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"Lu8Q3":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "getBscGlobalState", ()=>getBscGlobalState);
parcelHelpers.export(exports, "testing_overrideGlobalState", ()=>testing_overrideGlobalState);
parcelHelpers.export(exports, "clearGlobalState", ()=>clearGlobalState);
parcelHelpers.export(exports, "__internalApplyInitialState", ()=>__internalApplyInitialState);
parcelHelpers.export(exports, "__internalGetHasInitialized", ()=>__internalGetHasInitialized);
parcelHelpers.export(exports, "__internalGetProductGlobalState", ()=>__internalGetProductGlobalState);
parcelHelpers.export(exports, "__internalGetWebStorageControlsEnabledGlobalState", ()=>__internalGetWebStorageControlsEnabledGlobalState);
parcelHelpers.export(exports, "__internalGetIndexedDbControlsEnabledGlobalState", ()=>__internalGetIndexedDbControlsEnabledGlobalState);
parcelHelpers.export(exports, "__internalGetDisableWebStorageConsentChecksGlobalState", ()=>__internalGetDisableWebStorageConsentChecksGlobalState);
parcelHelpers.export(exports, "__internalGetAllowUncategorizedCookiesInOverridesGlobalState", ()=>__internalGetAllowUncategorizedCookiesInOverridesGlobalState);
parcelHelpers.export(exports, "__internalGetAllowUncategorizedItemsInWebStorageOverridesGlobalState", ()=>__internalGetAllowUncategorizedItemsInWebStorageOverridesGlobalState);
parcelHelpers.export(exports, "__internalGetAllowUncategorizedItemsInIndexedDBOverridesGlobalState", ()=>__internalGetAllowUncategorizedItemsInIndexedDBOverridesGlobalState);
parcelHelpers.export(exports, "__internalGetShouldEnforceKeyGlobalState", ()=>__internalGetShouldEnforceKeyGlobalState);
parcelHelpers.export(exports, "__internalSetCacheLoadedDate", ()=>__internalSetCacheLoadedDate);
parcelHelpers.export(exports, "__internalGetDisableIndexedDbConsentChecksGlobalState", ()=>__internalGetDisableIndexedDbConsentChecksGlobalState);
var _types = require("../../../types");
var _determineLogLevel = require("../logger/determine-log-level");
let analyticsEnabledGlobalState;
let productGlobalState;
let perimeterGlobalState;
let webStorageControlsEnabledGlobalState;
let indexedDbControlsEnabledGlobalState;
let disableWebStorageConsentChecksGlobalState;
let localConsentModeGlobalState;
let packageLogLevelGlobalState;
let allowUncategorizedCookiesInOverridesGlobalState;
let allowUncategorizedItemsInWebStorageOverridesGlobalState;
let allowUncategorizedItemsInIndexedDBOverridesGlobalState;
let disableIndexedDbConsentChecksGlobalState;
let __UNSAFE_shouldEnforceKeyForRolloutGlobalState;
let userIdGlobalState;
let cloudIdGlobalState;
let hasInitialized = false;
let cacheLoadedDateGlobalState;
let cookiesCacheLoader;
let localStorageCacheLoader;
let sessionStorageCacheLoader;
let indexedDBCacheLoader;
let loadCache = async (storageType)=>{
    switch(storageType){
        case (0, _types.CategoryStorageType).Cookies:
            return await (cookiesCacheLoader === null || cookiesCacheLoader === void 0 ? void 0 : cookiesCacheLoader.loadStorageControlsData());
        case (0, _types.CategoryStorageType).LocalStorage:
            return await (localStorageCacheLoader === null || localStorageCacheLoader === void 0 ? void 0 : localStorageCacheLoader.loadStorageControlsData());
        case (0, _types.CategoryStorageType).SessionStorage:
            return await (sessionStorageCacheLoader === null || sessionStorageCacheLoader === void 0 ? void 0 : sessionStorageCacheLoader.loadStorageControlsData());
        case (0, _types.CategoryStorageType).IndexedDB:
            return await (indexedDBCacheLoader === null || indexedDBCacheLoader === void 0 ? void 0 : indexedDBCacheLoader.loadStorageControlsData());
        default:
            return undefined;
    }
};
let loadCacheMaybeSync = (storageType)=>{
    switch(storageType){
        case (0, _types.CategoryStorageType).Cookies:
            var _cookiesCacheLoader_getStorageControlsDataFromCache;
            return (_cookiesCacheLoader_getStorageControlsDataFromCache = cookiesCacheLoader === null || cookiesCacheLoader === void 0 ? void 0 : cookiesCacheLoader.getStorageControlsDataFromCache()) !== null && _cookiesCacheLoader_getStorageControlsDataFromCache !== void 0 ? _cookiesCacheLoader_getStorageControlsDataFromCache : cookiesCacheLoader === null || cookiesCacheLoader === void 0 ? void 0 : cookiesCacheLoader.loadStorageControlsData();
        case (0, _types.CategoryStorageType).LocalStorage:
            var _localStorageCacheLoader_getStorageControlsDataFromCache;
            return (_localStorageCacheLoader_getStorageControlsDataFromCache = localStorageCacheLoader === null || localStorageCacheLoader === void 0 ? void 0 : localStorageCacheLoader.getStorageControlsDataFromCache()) !== null && _localStorageCacheLoader_getStorageControlsDataFromCache !== void 0 ? _localStorageCacheLoader_getStorageControlsDataFromCache : localStorageCacheLoader === null || localStorageCacheLoader === void 0 ? void 0 : localStorageCacheLoader.loadStorageControlsData();
        case (0, _types.CategoryStorageType).SessionStorage:
            var _sessionStorageCacheLoader_getStorageControlsDataFromCache;
            return (_sessionStorageCacheLoader_getStorageControlsDataFromCache = sessionStorageCacheLoader === null || sessionStorageCacheLoader === void 0 ? void 0 : sessionStorageCacheLoader.getStorageControlsDataFromCache()) !== null && _sessionStorageCacheLoader_getStorageControlsDataFromCache !== void 0 ? _sessionStorageCacheLoader_getStorageControlsDataFromCache : sessionStorageCacheLoader === null || sessionStorageCacheLoader === void 0 ? void 0 : sessionStorageCacheLoader.loadStorageControlsData();
        case (0, _types.CategoryStorageType).IndexedDB:
            var _indexedDBCacheLoader_getStorageControlsDataFromCache;
            return (_indexedDBCacheLoader_getStorageControlsDataFromCache = indexedDBCacheLoader === null || indexedDBCacheLoader === void 0 ? void 0 : indexedDBCacheLoader.getStorageControlsDataFromCache()) !== null && _indexedDBCacheLoader_getStorageControlsDataFromCache !== void 0 ? _indexedDBCacheLoader_getStorageControlsDataFromCache : indexedDBCacheLoader === null || indexedDBCacheLoader === void 0 ? void 0 : indexedDBCacheLoader.loadStorageControlsData();
        default:
            return undefined;
    }
};
const getBscGlobalState = ()=>{
    return {
        analyticsEnabled: analyticsEnabledGlobalState !== null && analyticsEnabledGlobalState !== void 0 ? analyticsEnabledGlobalState : true,
        product: productGlobalState,
        perimeter: perimeterGlobalState,
        webStorageEnabled: webStorageControlsEnabledGlobalState !== null && webStorageControlsEnabledGlobalState !== void 0 ? webStorageControlsEnabledGlobalState : false,
        indexedDbEnabled: indexedDbControlsEnabledGlobalState !== null && indexedDbControlsEnabledGlobalState !== void 0 ? indexedDbControlsEnabledGlobalState : false,
        disableWebStorageConsentChecks: disableWebStorageConsentChecksGlobalState !== null && disableWebStorageConsentChecksGlobalState !== void 0 ? disableWebStorageConsentChecksGlobalState : false,
        localConsentMode: localConsentModeGlobalState !== null && localConsentModeGlobalState !== void 0 ? localConsentModeGlobalState : false,
        allowUncategorizedCookiesInOverrides: allowUncategorizedCookiesInOverridesGlobalState !== null && allowUncategorizedCookiesInOverridesGlobalState !== void 0 ? allowUncategorizedCookiesInOverridesGlobalState : false,
        allowUncategorizedItemsInWebStorageOverrides: allowUncategorizedItemsInWebStorageOverridesGlobalState !== null && allowUncategorizedItemsInWebStorageOverridesGlobalState !== void 0 ? allowUncategorizedItemsInWebStorageOverridesGlobalState : false,
        allowUncategorizedItemsInIndexedDBOverrides: allowUncategorizedItemsInIndexedDBOverridesGlobalState !== null && allowUncategorizedItemsInIndexedDBOverridesGlobalState !== void 0 ? allowUncategorizedItemsInIndexedDBOverridesGlobalState : false,
        disableIndexedDbConsentChecks: disableIndexedDbConsentChecksGlobalState !== null && disableIndexedDbConsentChecksGlobalState !== void 0 ? disableIndexedDbConsentChecksGlobalState : false,
        __UNSAFE_shouldEnforceKeyForRollout: __UNSAFE_shouldEnforceKeyForRolloutGlobalState,
        packageLogLevel: packageLogLevelGlobalState,
        cookiesCacheLoader,
        localStorageCacheLoader,
        sessionStorageCacheLoader,
        indexedDBCacheLoader,
        loadCache,
        loadCacheMaybeSync,
        hasInitialized,
        userId: userIdGlobalState,
        cloudId: cloudIdGlobalState,
        cacheLoadedDate: cacheLoadedDateGlobalState
    };
};
const testing_overrideGlobalState = ({ loadCache: overrideLoadCache, loadCacheMaybeSync: overrideLoadCacheMaybeSync, product: overrideProduct })=>{
    if (overrideLoadCache) loadCache = overrideLoadCache;
    if (overrideLoadCacheMaybeSync) loadCacheMaybeSync = overrideLoadCacheMaybeSync;
    if (overrideProduct) productGlobalState = overrideProduct;
};
const clearGlobalState = ()=>{
    analyticsEnabledGlobalState = undefined;
    productGlobalState = undefined;
    webStorageControlsEnabledGlobalState = undefined;
    indexedDbControlsEnabledGlobalState = undefined;
    disableWebStorageConsentChecksGlobalState = undefined;
    localConsentModeGlobalState = undefined;
    allowUncategorizedCookiesInOverridesGlobalState = undefined;
    allowUncategorizedItemsInWebStorageOverridesGlobalState = undefined;
    allowUncategorizedItemsInIndexedDBOverridesGlobalState = undefined;
    disableIndexedDbConsentChecksGlobalState = undefined;
    __UNSAFE_shouldEnforceKeyForRolloutGlobalState = undefined;
    userIdGlobalState = undefined;
    cloudIdGlobalState = undefined;
    packageLogLevelGlobalState = undefined;
    // Reset the resolved-log-level cache too, so a teardown that clears global state without a
    // following initializeGlobalState() can't bleed the previous request's level into the next.
    (0, _determineLogLevel.resetLogLevelCache)();
    cookiesCacheLoader = undefined;
    localStorageCacheLoader = undefined;
    sessionStorageCacheLoader = undefined;
    indexedDBCacheLoader = undefined;
    hasInitialized = false;
    cacheLoadedDateGlobalState = undefined;
};
function __internalApplyInitialState(updates) {
    if (updates.productGlobalState !== undefined) productGlobalState = updates.productGlobalState;
    if (updates.webStorageControlsEnabledGlobalState !== undefined) webStorageControlsEnabledGlobalState = updates.webStorageControlsEnabledGlobalState;
    if (updates.indexedDbControlsEnabledGlobalState !== undefined) indexedDbControlsEnabledGlobalState = updates.indexedDbControlsEnabledGlobalState;
    if (updates.disableWebStorageConsentChecksGlobalState !== undefined) disableWebStorageConsentChecksGlobalState = updates.disableWebStorageConsentChecksGlobalState;
    if (updates.allowUncategorizedCookiesInOverridesGlobalState !== undefined) allowUncategorizedCookiesInOverridesGlobalState = updates.allowUncategorizedCookiesInOverridesGlobalState;
    if (updates.allowUncategorizedItemsInWebStorageOverridesGlobalState !== undefined) allowUncategorizedItemsInWebStorageOverridesGlobalState = updates.allowUncategorizedItemsInWebStorageOverridesGlobalState;
    if (updates.allowUncategorizedItemsInIndexedDBOverridesGlobalState !== undefined) allowUncategorizedItemsInIndexedDBOverridesGlobalState = updates.allowUncategorizedItemsInIndexedDBOverridesGlobalState;
    if (updates.disableIndexedDbConsentChecksGlobalState !== undefined) disableIndexedDbConsentChecksGlobalState = updates.disableIndexedDbConsentChecksGlobalState;
    if (updates.__UNSAFE_shouldEnforceKeyForRolloutGlobalState !== undefined) __UNSAFE_shouldEnforceKeyForRolloutGlobalState = updates.__UNSAFE_shouldEnforceKeyForRolloutGlobalState;
    if (updates.localConsentModeGlobalState !== undefined) localConsentModeGlobalState = updates.localConsentModeGlobalState;
    if (updates.analyticsEnabledGlobalState !== undefined) analyticsEnabledGlobalState = updates.analyticsEnabledGlobalState;
    if (updates.perimeterGlobalState !== undefined) perimeterGlobalState = updates.perimeterGlobalState;
    if (updates.cookiesCacheLoader !== undefined) cookiesCacheLoader = updates.cookiesCacheLoader;
    if (updates.localStorageCacheLoader !== undefined) localStorageCacheLoader = updates.localStorageCacheLoader;
    if (updates.sessionStorageCacheLoader !== undefined) sessionStorageCacheLoader = updates.sessionStorageCacheLoader;
    if (updates.indexedDBCacheLoader !== undefined) indexedDBCacheLoader = updates.indexedDBCacheLoader;
    if (updates.packageLogLevelGlobalState !== undefined) packageLogLevelGlobalState = updates.packageLogLevelGlobalState;
    if (updates.hasInitialized !== undefined) hasInitialized = updates.hasInitialized;
    if (updates.cloudIdGlobalState !== undefined) cloudIdGlobalState = updates.cloudIdGlobalState;
    if (updates.userIdGlobalState !== undefined) userIdGlobalState = updates.userIdGlobalState;
}
function __internalGetHasInitialized() {
    return hasInitialized;
}
function __internalGetProductGlobalState() {
    return productGlobalState;
}
function __internalGetWebStorageControlsEnabledGlobalState() {
    return webStorageControlsEnabledGlobalState;
}
function __internalGetIndexedDbControlsEnabledGlobalState() {
    return indexedDbControlsEnabledGlobalState;
}
function __internalGetDisableWebStorageConsentChecksGlobalState() {
    return disableWebStorageConsentChecksGlobalState;
}
function __internalGetAllowUncategorizedCookiesInOverridesGlobalState() {
    return allowUncategorizedCookiesInOverridesGlobalState;
}
function __internalGetAllowUncategorizedItemsInWebStorageOverridesGlobalState() {
    return allowUncategorizedItemsInWebStorageOverridesGlobalState;
}
function __internalGetAllowUncategorizedItemsInIndexedDBOverridesGlobalState() {
    return allowUncategorizedItemsInIndexedDBOverridesGlobalState;
}
function __internalGetShouldEnforceKeyGlobalState() {
    return __UNSAFE_shouldEnforceKeyForRolloutGlobalState;
}
function __internalSetCacheLoadedDate(date) {
    if (cacheLoadedDateGlobalState === undefined) cacheLoadedDateGlobalState = date;
}
function __internalGetDisableIndexedDbConsentChecksGlobalState() {
    return disableIndexedDbConsentChecksGlobalState;
}

},{"../../../types":"65Pa5","../logger/determine-log-level":"bAWK3","@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"65Pa5":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "PreferenceCategory", ()=>PreferenceCategory);
parcelHelpers.export(exports, "ConsentPreferenceV2", ()=>ConsentPreferenceV2);
parcelHelpers.export(exports, "ContextualConsentProperty", ()=>ContextualConsentProperty);
parcelHelpers.export(exports, "CachedKeysDataPropertyLegacy", ()=>CachedKeysDataPropertyLegacy);
parcelHelpers.export(exports, "PrefetchedPreferenceState", ()=>PrefetchedPreferenceState);
parcelHelpers.export(exports, "CategoryStorageType", ()=>CategoryStorageType);
parcelHelpers.export(exports, "Status", ()=>Status);
parcelHelpers.export(exports, "BSC_PACKAGE_KILLSWITCHES", ()=>BSC_PACKAGE_KILLSWITCHES);
var PreferenceCategory = /*#__PURE__*/ function(PreferenceCategory) {
    PreferenceCategory["StrictlyNecessary"] = "STRICTLY_NECESSARY";
    PreferenceCategory["Functional"] = "FUNCTIONAL";
    PreferenceCategory["Marketing"] = "MARKETING";
    PreferenceCategory["Analytics"] = "ANALYTICS";
    PreferenceCategory["Unknown"] = "UNKNOWN";
    return PreferenceCategory;
}({});
var ConsentPreferenceV2 = /*#__PURE__*/ function(ConsentPreferenceV2) {
    ConsentPreferenceV2["ConsentDataUnavailable"] = "CONSENT_DATA_UNAVAILABLE";
    ConsentPreferenceV2["ConsentedUnderGDPR"] = "CONSENTS_SAVED_IN_GDPR_LOCALE";
    ConsentPreferenceV2["ConsentedUnderCPRA"] = "CONSENTS_SAVED_IN_CPRA_LOCALE";
    ConsentPreferenceV2["ConsentedUnderLGPD"] = "CONSENTS_SAVED_IN_LGPD_LOCALE";
    ConsentPreferenceV2["ConsentedUnderFADP"] = "CONSENTS_SAVED_IN_FADP_LOCALE";
    return ConsentPreferenceV2;
}({});
var ContextualConsentProperty = /*#__PURE__*/ function(ContextualConsentProperty) {
    ContextualConsentProperty["ConsentsAreDefault"] = "DEFAULT_CONSENTS";
    ContextualConsentProperty["UserIsAuthenticated"] = "USER_AUTHENTICATED";
    ContextualConsentProperty["ConsentDataUnavailable"] = "CONSENT_DATA_UNAVAILABLE";
    return ContextualConsentProperty;
}({});
var CachedKeysDataPropertyLegacy = /*#__PURE__*/ function(CachedKeysDataPropertyLegacy) {
    CachedKeysDataPropertyLegacy["LocalStorage"] = "localStorageKeys";
    CachedKeysDataPropertyLegacy["SessionStorage"] = "sessionStorageKeys";
    CachedKeysDataPropertyLegacy["Cookies"] = "keys";
    CachedKeysDataPropertyLegacy["ThirdParty"] = "thirdPartyKeys";
    return CachedKeysDataPropertyLegacy;
}({});
var PrefetchedPreferenceState = /*#__PURE__*/ function(PrefetchedPreferenceState) {
    PrefetchedPreferenceState[PrefetchedPreferenceState["INTERNAL"] = 0] = "INTERNAL";
    return PrefetchedPreferenceState;
}({});
var CategoryStorageType = /*#__PURE__*/ function(CategoryStorageType) {
    CategoryStorageType["Cookies"] = "Cookies";
    CategoryStorageType["LocalStorage"] = "LocalStorage";
    CategoryStorageType["SessionStorage"] = "SessionStorage";
    CategoryStorageType["IndexedDB"] = "IndexedDB";
    return CategoryStorageType;
}({});
var Status = /*#__PURE__*/ function(Status) {
    Status["SUCCESS"] = "SUCCESS";
    Status["BLOCKED"] = "BLOCKED";
    Status["FAILED"] = "FAILED";
    Status["ERROR"] = "ERROR";
    return Status;
}({});
var BSC_PACKAGE_KILLSWITCHES = /*#__PURE__*/ function(BSC_PACKAGE_KILLSWITCHES) {
    BSC_PACKAGE_KILLSWITCHES["MASTER_KILLSWITCH"] = "platform_moonjelly_bsc_master_killswitch";
    BSC_PACKAGE_KILLSWITCHES["UI_KILLSWITCH"] = "platform_moonjelly_bsc_ui_killswitch";
    BSC_PACKAGE_KILLSWITCHES["SSR_KILLSWITCH"] = "platform_moonjelly_bsc_ssr_killswitch";
    BSC_PACKAGE_KILLSWITCHES["WEB_STORAGE_KILLSWITCH"] = "platform_moonjelly_bsc_web_storage_killswitch";
    return BSC_PACKAGE_KILLSWITCHES;
}({});

},{"@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"bAWK3":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "determineLogLevel", ()=>determineLogLevel);
parcelHelpers.export(exports, "resetLogLevelCache", ()=>resetLogLevelCache);
var _jsCookie = require("js-cookie");
var _jsCookieDefault = parcelHelpers.interopDefault(_jsCookie);
var _platformFeatureFlags = require("@atlaskit/platform-feature-flags");
var _core = require("../bsc-global-state/core");
var _logLevel = require("./log-level");
/**
 * Returns the active log level for the BSC Logger, resolved from (in order):
 * developer cookie override, consumer init param, or `DEFAULT_LOG_LEVEL`.
 *
 * The first call resolves and caches; subsequent calls return the cached
 * value. `initializeGlobalState` invalidates the cache via
 * `resetLogLevelCache()` so an init that runs after the first Logger call
 * still picks up the consumer's `packageLogLevel`.
 *
 * SSR caveat: `cachedLogLevel` is a module-level singleton, so in a shared
 * Node module cache it persists across requests. Both `initializeGlobalState`
 * and `clearGlobalState` call `resetLogLevelCache()`, so per-request init and
 * teardown keep it correct — one request's resolved level cannot leak into the
 * next.
 */ let cachedLogLevel;
const determineLogLevel = ()=>{
    if (cachedLogLevel !== undefined) return cachedLogLevel;
    var _readDebugCookieOverride, _ref;
    cachedLogLevel = (_ref = (_readDebugCookieOverride = readDebugCookieOverride()) !== null && _readDebugCookieOverride !== void 0 ? _readDebugCookieOverride : readInitParamLogLevel()) !== null && _ref !== void 0 ? _ref : (0, _logLevel.DEFAULT_LOG_LEVEL);
    return cachedLogLevel;
};
const resetLogLevelCache = ()=>{
    cachedLogLevel = undefined;
};
/**
 * Returns `LogLevel.DEBUG` when the dev override is active (cookie set AND
 * the safety-net FF is enabled), else `null`. The FF gate lets us remotely
 * disable the cookie path if it ever misbehaves.
 *
 * The cookie is checked BEFORE the feature gate on purpose: `fg` is only ever
 * evaluated when the (rare, dev-only) `atl-bsc-debug-mode` cookie is present.
 * This keeps `Logger.*` calls — including ones that run at module-load time
 * (e.g. the AtlIndexedDb singleton) — from calling `fg` during a plain import.
 * Otherwise importing BSC crashes any consumer whose test mocks `fg` with a
 * not-yet-initialized factory variable ("Cannot access 'mockFg' before
 * initialization").
 */ const readDebugCookieOverride = ()=>{
    let debugCookieSet = false;
    try {
        debugCookieSet = (0, _jsCookieDefault.default).get('atl-bsc-debug-mode') === 'true';
    } catch (e) {
        // Cookie access can throw in sandboxed iframes / strict cookie policies.
        return null;
    }
    if (!debugCookieSet) return null;
    return (0, _platformFeatureFlags.fg)('platform_moonjelly_bsc_debug_mode') ? (0, _logLevel.LogLevel).DEBUG : null;
};
/**
 * Returns the LogLevel corresponding to the consumer's `packageLogLevel` init
 * param, or `null` if unset or unrecognized.
 */ const readInitParamLogLevel = ()=>{
    return (0, _logLevel.packageLogLevelStringToEnum)((0, _core.getBscGlobalState)().packageLogLevel);
};

},{"js-cookie":"brgOH","@atlaskit/platform-feature-flags":"8rD2i","../bsc-global-state/core":"Lu8Q3","./log-level":"b7xxj","@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"b7xxj":[function(require,module,exports,__globalThis) {
/**
 * Internal numeric log level. Higher = more verbose; a Logger method fires
 * when the resolved level is `>=` its own. Not exported from the package's
 * public entry — consumers use `PackageLogLevel` instead.
 */ var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "LogLevel", ()=>LogLevel);
parcelHelpers.export(exports, "DEFAULT_LOG_LEVEL", ()=>DEFAULT_LOG_LEVEL);
parcelHelpers.export(exports, "packageLogLevelStringToEnum", ()=>packageLogLevelStringToEnum);
var LogLevel = /*#__PURE__*/ function(LogLevel) {
    LogLevel[LogLevel["SILENT"] = 0] = "SILENT";
    LogLevel[LogLevel["ERROR"] = 1] = "ERROR";
    LogLevel[LogLevel["WARN"] = 2] = "WARN";
    LogLevel[LogLevel["INFO"] = 3] = "INFO";
    LogLevel[LogLevel["DEBUG"] = 4] = "DEBUG";
    return LogLevel;
}({});
const DEFAULT_LOG_LEVEL = 1;
const PACKAGE_LOG_LEVEL_BY_STRING = {
    silent: 0,
    error: 1,
    warn: 2,
    info: 3,
    debug: 4
};
const packageLogLevelStringToEnum = (value)=>{
    if (value === undefined) return null;
    var _PACKAGE_LOG_LEVEL_BY_STRING_value;
    return (_PACKAGE_LOG_LEVEL_BY_STRING_value = PACKAGE_LOG_LEVEL_BY_STRING[value]) !== null && _PACKAGE_LOG_LEVEL_BY_STRING_value !== void 0 ? _PACKAGE_LOG_LEVEL_BY_STRING_value : null;
};

},{"@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"hwbCh":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "LOG_PREFIX", ()=>LOG_PREFIX);
parcelHelpers.export(exports, "ERROR_EVENT_THROTTLE_INTERVAL_MS", ()=>ERROR_EVENT_THROTTLE_INTERVAL_MS);
parcelHelpers.export(exports, "ERROR_EVENT_MAX_PER_SESSION", ()=>ERROR_EVENT_MAX_PER_SESSION);
const LOG_PREFIX = '[browser-storage-controls]';
const ERROR_EVENT_THROTTLE_INTERVAL_MS = 5000; // min gap between sends of the same action
const ERROR_EVENT_MAX_PER_SESSION = 10; // hard cap per action per page load

},{"@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"czxhD":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "packageName", ()=>packageName);
parcelHelpers.export(exports, "packageVersion", ()=>packageVersion);
var _afatlassianstudio;
const packageName = (_afatlassianstudio = "@af/atlassian-studio") !== null && _afatlassianstudio !== void 0 ? _afatlassianstudio : '';
var _0161;
const packageVersion = (_0161 = "0.16.1") !== null && _0161 !== void 0 ? _0161 : '';

},{"@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"dMtfh":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "samplingDefaults", ()=>samplingDefaults);
parcelHelpers.export(exports, "getAnalyticsSamplingRatio", ()=>getAnalyticsSamplingRatio);
parcelHelpers.export(exports, "withSampling", ()=>withSampling);
parcelHelpers.export(exports, "withAnalyticsEventSampling", ()=>withAnalyticsEventSampling);
var _types = require("../../../../types");
var _core = require("../../bsc-global-state/core");
var _cachedSamplingConfig = require("../../cached-sampling-config");
var _isSsr = require("../../is-ssr");
const samplingDefaults = {
    usedGetCookie: 100000,
    usedGetCookieError: 1,
    usedSetCookie: 1000,
    usedSetCookieError: 1,
    usedSetStrictlyNecessaryCookie: 10000,
    usedSetStrictlyNecessaryCookieError: 1,
    usedDeleteCookie: 10,
    usedDeleteCookieError: 1,
    usedCheckThirdParty: 100000,
    checkThirdPartyError: 1,
    usedDocumentCookie: 100,
    usedDocumentCookieError: 1,
    initializeControlsError: 1,
    loadStorageControlsError: 1,
    updatePreferencesError: 1,
    fetchConsentPreferencesError: 1,
    saveConsentPreferencesError: 1,
    usedAtlBrowserStorageGetItem: 100,
    usedAtlBrowserStorageGetItemError: 1,
    usedAtlBrowserStorageSetItem: 100,
    usedAtlBrowserStorageSetItemError: 1,
    usedAtlBrowserStorageSetStrictlyNecessaryItem: 100,
    usedAtlBrowserStorageSetStrictlyNecessaryItemError: 1,
    indexDbSetRecordError: 1,
    usedCheckIfSetByPackageError: 1,
    renderConsentBannerError: 1,
    bannerAppearanceAfterDismissal: 1,
    usedAtlIndexedDBOpen: 100,
    usedAtlIndexedDBOpenError: 1,
    usedAtlIndexedDBOpenStrictlyNecessary: 100,
    usedAtlIndexedDBOpenStrictlyNecessaryError: 1,
    bscInitControlsParameters: 1000,
    setItemWithoutInit: 1000,
    uncategorizedWebStorageItemSet: 100,
    storageCleanupCategorized: 100,
    storageCleanupDeleted: 100,
    storageCleanupError: 1,
    cookieConsentPreferences: 1,
    cookieConsentModal: 1,
    cookieConsentBanner: 1,
    preferences: 1,
    onlyNecessary: 1,
    acceptAll: 1,
    cookiesTrackingNotice: 1,
    confirm: 1,
    performanceConsent: 1,
    functionalConsent: 1,
    targetingConsent: 1,
    cancel: 1,
    close: 1,
    background: 1
};
// This short-circuits finding a sampling ratio from the remote config. Useful for things like
// `loadStorageControlsError` which itself tries to log an event on error, causing an infinite
// recursion as each lookup fails, logging another event, etc.
const localOnlySamplingKeys = [
    'loadStorageControlsError'
];
async function loadSamplingConfig() {
    if ((0, _cachedSamplingConfig.cache).cachedSamplingConfig) return (0, _cachedSamplingConfig.cache).cachedSamplingConfig;
    if ((0, _isSsr.isSSR)()) return undefined;
    const { loadCache } = (0, _core.getBscGlobalState)();
    const controlsData = await loadCache((0, _types.CategoryStorageType).Cookies);
    const analyticsSamplingRatioConfigs = controlsData === null || controlsData === void 0 ? void 0 : controlsData.analyticsSamplingRatio;
    (0, _cachedSamplingConfig.cache).cachedSamplingConfig = analyticsSamplingRatioConfigs;
    return analyticsSamplingRatioConfigs;
}
async function getAnalyticsSamplingRatio(analyticsEventKey) {
    if (localOnlySamplingKeys.includes(analyticsEventKey)) return samplingDefaults[analyticsEventKey];
    const remoteSamplingConfig = await loadSamplingConfig();
    const samplingConfig = remoteSamplingConfig !== null && remoteSamplingConfig !== void 0 ? remoteSamplingConfig : samplingDefaults;
    const samplingRatio = (samplingConfig === null || samplingConfig === void 0 ? void 0 : samplingConfig[analyticsEventKey]) !== undefined ? samplingConfig[analyticsEventKey] : samplingDefaults[analyticsEventKey];
    return samplingRatio;
}
function withSampling(samplingRatio, cb) {
    /* Only run if rolling the samplingRatio-sized die lands on a 0
       ________
      /\       \
     /()\   ()  \
    /    \_______\
    \    /()     /
     \()/   ()  /
      \/_____()/
  */ const shouldRun = !Math.floor(Math.random() * samplingRatio);
    shouldRun && cb();
}
async function withAnalyticsEventSampling(analyticsEventKey, cb) {
    const ratio = await getAnalyticsSamplingRatio(analyticsEventKey);
    withSampling(ratio, cb);
}

},{"../../../../types":"65Pa5","../../bsc-global-state/core":"Lu8Q3","../../cached-sampling-config":"1Bc3d","../../is-ssr":"ciW3w","@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"1Bc3d":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "cache", ()=>cache);
var _cachedSamplingConfig = require("./cached-sampling-config");
const cache = new (0, _cachedSamplingConfig.CachedSamplingConfig)();

},{"./cached-sampling-config":"cTDLa","@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"cTDLa":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
// The categories.json file is already configured to be cached by the browser, but for this sampling
// config, it's even less important to manage stale values. Most BSC API interaction is done on
// application startup.  So we may as well cache this in memory once per app load and not retrieve
// it from local disk for each event emitted.
parcelHelpers.export(exports, "CachedSamplingConfig", ()=>CachedSamplingConfig);
class CachedSamplingConfig {
    get cachedSamplingConfig() {
        return this.cache;
    }
    set cachedSamplingConfig(value) {
        this.cache = value;
    }
}

},{"@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"ciW3w":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "isSSR", ()=>isSSR);
var _analyticsWebClient = require("@atlassiansox/analytics-web-client");
var _analyticsWebClientDefault = parcelHelpers.interopDefault(_analyticsWebClient);
var _platformFeatureFlags = require("@atlaskit/platform-feature-flags");
const isSSR = ()=>{
    const isMissingNecessaryBrowserUtils = typeof document === 'undefined' || typeof window === 'undefined' || !Document || !Document.prototype || !Object || !Object.defineProperty;
    const isMissingBooleanFF = !(0, _platformFeatureFlags.fg);
    const isMissingAnalyticsWebClient = !Boolean((0, _analyticsWebClientDefault.default));
    if (isMissingNecessaryBrowserUtils || isMissingBooleanFF || isMissingAnalyticsWebClient) return true;
    else return false;
};

},{"@atlassiansox/analytics-web-client":"6RHYr","@atlaskit/platform-feature-flags":"8rD2i","@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"7Mt17":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
/**
 * Returns true (and records the send) if an operational error event for `action` may be sent now;
 * returns false if it should be dropped. Throttling rules, applied independently per `action`:
 *  - at most one send per ERROR_EVENT_THROTTLE_INTERVAL_MS, and
 *  - at most ERROR_EVENT_MAX_PER_SESSION sends per page load.
 */ parcelHelpers.export(exports, "shouldSendErrorEvent", ()=>shouldSendErrorEvent);
// Test-only helper to reset the per-process throttle state between tests.
parcelHelpers.export(exports, "__resetErrorEventThrottleState", ()=>__resetErrorEventThrottleState);
var _constants = require("./constants");
// Per-process (per page load) throttle state, keyed by operational event action.
// Resets naturally on page reload because module state is re-initialised, which gives
// us the "per session" semantic for free (same pattern as bsc-global-state).
const throttleState = new Map();
function shouldSendErrorEvent(action) {
    const now = Date.now();
    const entry = throttleState.get(action);
    if (!entry) {
        // First occurrence of this action this session always sends.
        throttleState.set(action, {
            lastSentAt: now,
            sentCount: 1
        });
        return true;
    }
    if (entry.sentCount >= (0, _constants.ERROR_EVENT_MAX_PER_SESSION)) // Hard per-session cap reached — drop regardless of elapsed time.
    return false;
    if (now - entry.lastSentAt < (0, _constants.ERROR_EVENT_THROTTLE_INTERVAL_MS)) // Within the cooldown window since the last send for this action.
    return false;
    entry.lastSentAt = now;
    entry.sentCount += 1;
    return true;
}
function __resetErrorEventThrottleState() {
    throttleState.clear();
}

},{"./constants":"hwbCh","@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"2SfNZ":[function(require,module,exports,__globalThis) {
/* eslint-disable @atlassian/tangerine/import/no-parent-imports */ var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "ConsentBannerImpl", ()=>ConsentBannerImpl);
var _objectSpread = require("@swc/helpers/_/_object_spread");
var _objectSpreadProps = require("@swc/helpers/_/_object_spread_props");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _reactIntl = require("react-intl");
var _flag = require("@atlaskit/flag");
var _statusError = require("@atlaskit/icon/core/status-error");
var _statusErrorDefault = parcelHelpers.interopDefault(_statusError);
var _statusSuccess = require("@atlaskit/icon/core/status-success");
var _statusSuccessDefault = parcelHelpers.interopDefault(_statusSuccess);
var _platformFeatureFlags = require("@atlaskit/platform-feature-flags");
var _customData = require("@atlaskit/react-ufo/custom-data");
var _utils = require("../../../common/utils");
var _locale = require("../../../common/utils/locale");
var _logger = require("../../../common/utils/logger");
var _constants = require("../../../constants");
var _cookieControls = require("../../../controllers/cookie-controls");
var _updatePreferences = require("../../../controllers/preferences-controls/update-preferences");
var _messages = require("../messages");
var _preferenceModal = require("../preference-modal");
var _usePreferences = require("../preference-modal/use-preferences");
var _usePreferencesDefault = parcelHelpers.interopDefault(_usePreferences);
var _presentationalConsentBanner = require("../presentational-consent-banner");
var _useBannerVisibility = require("../use-banner-visibility");
var _useBannerVisibilityDefault = parcelHelpers.interopDefault(_useBannerVisibility);
const SuccessWithIntl = (0, _reactIntl.injectIntl)(({ intl })=>/*#__PURE__*/ (0, _reactDefault.default).createElement((0, _statusSuccessDefault.default), {
        color: "var(--ds-icon-success, #6A9A23)",
        label: intl.formatMessage({
            id: 'browser-storage-controls.consent-banner.toast.success',
            defaultMessage: 'Success',
            description: 'The text is shown as the title of a success toast notification that appears in the consent banner after the user successfully saves their cookie preferences.'
        }),
        spacing: (0, _platformFeatureFlags.fg)('eoc-visual-refresh-phase-two') ? 'spacious' : 'none'
    }));
const ErrorWithIntl = (0, _reactIntl.injectIntl)(({ intl })=>/*#__PURE__*/ (0, _reactDefault.default).createElement((0, _statusErrorDefault.default), {
        color: "var(--ds-icon-danger, #C9372C)",
        label: intl.formatMessage({
            id: 'browser-storage-controls.consent-banner.toast.error',
            defaultMessage: 'Error',
            description: 'The title for an error as a single word.'
        }),
        spacing: (0, _platformFeatureFlags.fg)('eoc-visual-refresh-phase-two') ? 'spacious' : 'none'
    }));
const errorToastProps = ()=>({
        icon: /*#__PURE__*/ (0, _reactDefault.default).createElement(ErrorWithIntl, null),
        appearance: 'normal'
    });
const successToastProps = ()=>({
        icon: /*#__PURE__*/ (0, _reactDefault.default).createElement(SuccessWithIntl, null),
        appearance: 'normal',
        isAutoDismiss: true
    });
const ConsentBannerImpl = ({ onShow, onHide, initialPreferences, minWidth = 400, product, onConsentBannerBailOut, analyticsEnabled = true, localConsentMode = false, newMinHeight, ssrOptions, perimeter = 'commercial' })=>{
    const firstRender = (0, _react.useRef)(true);
    (0, _react.useEffect)(()=>{
        if (!firstRender.current) return;
        // Send an operational event if the banner is shown after previously having
        // been dismissed. This will help prevent issues with the banner
        // inappropriately reappearing.
        const lastBannerDismissal = (0, _cookieControls.getCookie)((0, _constants.ATLASSIAN_BANNER_LAST_DISMISSED_TIME_COOKIE_KEY));
        if (lastBannerDismissal) {
            const timeSinceDismissal = Date.now() - new Date(Number.parseInt(lastBannerDismissal)).getTime();
            const lessThanOneHour = timeSinceDismissal < 3600000;
            const lessThanOneDay = timeSinceDismissal < 86400000;
            const lessThanOneWeek = timeSinceDismissal < 604800000;
            (0, _utils.sendPackageOperationalEvent)({
                action: 'bannerAppearanceAfterDismissal',
                attributes: {
                    timeSinceDismissal,
                    lessThanOneHour,
                    lessThanOneDay,
                    lessThanOneWeek
                }
            });
            (0, _cookieControls.deleteCookie)((0, _constants.ATLASSIAN_BANNER_LAST_DISMISSED_TIME_COOKIE_KEY));
        }
        firstRender.current = false;
    }, []);
    (0, _react.useEffect)(()=>{
        if ((0, _platformFeatureFlags.fg)('fedramp-consent-banner-perimeter-prop')) (0, _utils.initializeGlobalState)({
            analyticsEnabled,
            product,
            localConsentMode,
            perimeter
        });
        else (0, _utils.initializeGlobalState)({
            analyticsEnabled,
            product,
            localConsentMode
        });
    }, [
        analyticsEnabled,
        product,
        localConsentMode,
        perimeter
    ]);
    const [isPreferencesModalOpen, setIsPreferencesModalOpen] = (0, _react.useState)(false);
    const intl = (0, _reactIntl.useIntl)();
    const { showFlag } = (0, _flag.useFlags)();
    const { preferences, isPrefetchedPreferencesState, isInitialRender } = (0, _usePreferencesDefault.default)({
        initialPreferences
    });
    const { showBanner, setIsDismissed } = (0, _useBannerVisibilityDefault.default)({
        preferences,
        isPrefetchedPreferencesState,
        initialPreferences,
        isInitialRender,
        ssrOptions
    });
    const closePreferenceModal = (0, _react.useCallback)(()=>{
        setIsPreferencesModalOpen(false);
    }, [
        setIsPreferencesModalOpen
    ]);
    const onPreferenceModalSubmit = (0, _react.useCallback)(()=>{
        closePreferenceModal();
        setIsDismissed(true);
    }, [
        closePreferenceModal,
        setIsDismissed
    ]);
    const onClickPreferences = (0, _react.useCallback)(()=>{
        setIsPreferencesModalOpen(true);
        (0, _utils.sendUIEvent)({
            action: 'clicked',
            actionSubject: 'button',
            actionSubjectId: 'preferences',
            source: 'cookieConsentBanner'
        });
    }, []);
    const showSuccessFlag = (0, _react.useCallback)(()=>{
        if (localConsentMode) showFlag((0, _objectSpreadProps._)((0, _objectSpread._)({}, successToastProps()), {
            id: 'cookieConsentBanner',
            description: intl.formatMessage((0, _messages.i18n).successFlagDescriptionLocalOnly),
            title: intl.formatMessage((0, _messages.i18n).successFlagTitle)
        }));
        else showFlag((0, _objectSpreadProps._)((0, _objectSpread._)({}, successToastProps()), {
            id: 'cookieConsentBanner',
            description: intl.formatMessage((0, _messages.i18n).successFlagDescription),
            title: intl.formatMessage((0, _messages.i18n).successFlagTitle)
        }));
    }, [
        intl,
        localConsentMode,
        showFlag
    ]);
    const showErrorFlag = (0, _react.useCallback)(()=>{
        showFlag((0, _objectSpreadProps._)((0, _objectSpread._)({}, errorToastProps()), {
            id: 'cookieConsentBanner',
            description: intl.formatMessage((0, _messages.i18n).errorFlagDescription),
            title: intl.formatMessage((0, _messages.i18n).errorFlagTitle)
        }));
    }, [
        intl,
        showFlag
    ]);
    // Sets preferences to allow only Strictly Necessary cookies
    const onClickOnlyNecessary = (0, _react.useCallback)(async (displayedTextMap)=>{
        try {
            (0, _utils.sendUIEvent)({
                action: 'clicked',
                actionSubject: 'button',
                actionSubjectId: 'onlyNecessary',
                source: 'cookieConsentBanner'
            });
            await (0, _updatePreferences.updatePreferences)((0, _constants.ONLY_NECESSARY_PREFERENCES), displayedTextMap);
            (0, _utils.sendTrackEvent)({
                source: 'cookieConsentBanner',
                action: 'submitted',
                actionSubject: 'cookieConsentPreferences'
            });
            showSuccessFlag();
        } catch (e) {
            (0, _logger.Logger).errorWithOperationalEvent({
                action: 'updatePreferencesError',
                attributes: {
                    preferences: (0, _constants.ONLY_NECESSARY_PREFERENCES),
                    product
                },
                message: `Failed to update preferences from banner. ${e.message || ''}`
            });
            showErrorFlag();
        } finally{
            setIsDismissed(true);
        }
    }, [
        product,
        showErrorFlag,
        showSuccessFlag,
        setIsDismissed
    ]);
    // Sets preferences to allow all categories of cookies
    const onClickAcceptAll = (0, _react.useCallback)(async (displayedTextMap)=>{
        try {
            (0, _utils.sendUIEvent)({
                action: 'clicked',
                actionSubject: 'button',
                actionSubjectId: 'acceptAll',
                source: 'cookieConsentBanner'
            });
            await (0, _updatePreferences.updatePreferences)((0, _constants.ACCEPT_ALL_PREFERENCES), displayedTextMap);
            (0, _utils.sendTrackEvent)({
                source: 'cookieConsentBanner',
                action: 'submitted',
                actionSubject: 'cookieConsentPreferences'
            });
            showSuccessFlag();
        } catch (e) {
            (0, _logger.Logger).errorWithOperationalEvent({
                action: 'updatePreferencesError',
                attributes: {
                    preferences: (0, _constants.ACCEPT_ALL_PREFERENCES),
                    product
                },
                message: `Failed to update preferences from banner. ${e.message || ''}`
            });
            showErrorFlag();
        } finally{
            setIsDismissed(true);
        }
    }, [
        product,
        showErrorFlag,
        showSuccessFlag,
        setIsDismissed
    ]);
    const onClickTrackingNoticeLink = (0, _react.useCallback)(()=>{
        (0, _utils.sendUIEvent)({
            action: 'clicked',
            actionSubject: 'link',
            actionSubjectId: 'cookiesTrackingNotice',
            source: 'cookieConsentBanner'
        });
    }, []);
    // Call onShow/onHide as a side effect of showBanner changing, rather than
    // possibly having to call them in multiple places.
    (0, _react.useEffect)(()=>{
        if (showBanner) (0, _customData.addUFOCustomData)({
            isCookieConsentBannerDisplayed: true
        });
        if (showBanner) onShow === null || onShow === void 0 ? void 0 : onShow();
        else if (!showBanner) onHide === null || onHide === void 0 ? void 0 : onHide();
    }, [
        showBanner,
        onShow,
        onHide
    ]);
    (0, _react.useEffect)(()=>{
        // when banner is not visible and isPrefetchedPreferencesState is in "resolved" state
        if (!showBanner && isPrefetchedPreferencesState !== undefined) // report "banner decided not to show" to sync decision with other components
        onConsentBannerBailOut === null || onConsentBannerBailOut === void 0 ? void 0 : onConsentBannerBailOut();
    }, [
        showBanner,
        isPrefetchedPreferencesState,
        onConsentBannerBailOut
    ]);
    if (!showBanner) return null;
    return /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _flag.FlagsProvider), null, /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _locale.BSCIntlProvider), null, /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _presentationalConsentBanner.PresentationalConsentBanner), {
        onClickOnlyNecessary: onClickOnlyNecessary,
        onClickAcceptAll: onClickAcceptAll,
        onClickPreferences: onClickPreferences,
        onClickTrackingNoticeLink: onClickTrackingNoticeLink,
        minWidth: minWidth,
        newMinHeight: newMinHeight
    }), isPreferencesModalOpen && /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _preferenceModal.PreferenceModal), {
        onClose: closePreferenceModal,
        onSubmit: onPreferenceModalSubmit,
        showSuccessFlag: showSuccessFlag,
        showErrorFlag: showErrorFlag,
        shouldAddWrappers: false
    })));
};

},{"@swc/helpers/_/_object_spread":"9gdrV","@swc/helpers/_/_object_spread_props":"kANqQ","react":"ltHCL","react-intl":"f41fF","@atlaskit/flag":"6pYSa","@atlaskit/icon/core/status-error":"lTP2w","@atlaskit/icon/core/status-success":"lTMbW","@atlaskit/platform-feature-flags":"8rD2i","@atlaskit/react-ufo/custom-data":"1WsX0","../../../common/utils":"gnWyu","../../../common/utils/locale":"6PzbS","../../../common/utils/logger":"2Tk7J","../../../constants":"9FHD5","../../../controllers/cookie-controls":"7HiHV","../../../controllers/preferences-controls/update-preferences":"jMIew","../messages":"54Ai5","../preference-modal":"hZAKY","../preference-modal/use-preferences":"2gZ28","../presentational-consent-banner":"47Ppm","../use-banner-visibility":"R10Fm","@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"1WsX0":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>UFOCustomData);
// eslint-disable-next-line @atlaskit/volt-strict-mode/no-multiple-exports
parcelHelpers.export(exports, "addUFOCustomData", ()=>addUFOCustomData);
var _react = require("react");
var _interactionContext = require("../interaction-context");
var _interactionContextDefault = parcelHelpers.interopDefault(_interactionContext);
var _interactionIdContext = require("../interaction-id-context");
var _interactionMetrics = require("../interaction-metrics");
function UFOCustomData({ data }) {
    const interactionContext = (0, _react.useContext)((0, _interactionContextDefault.default));
    (0, _react.useMemo)(()=>{
        var _globalThis;
        if (!interactionContext) return;
        if (typeof ((_globalThis = globalThis) === null || _globalThis === void 0 ? void 0 : _globalThis.structuredClone) === 'function') interactionContext.addCustomData(globalThis.structuredClone(data));
        else interactionContext.addCustomData(data);
    }, [
        data,
        interactionContext
    ]);
    return null;
}
function addUFOCustomData(data) {
    var _globalThis;
    const interactionId = (0, _interactionIdContext.getInteractionId)();
    const currentInteractionId = interactionId.current;
    if (!currentInteractionId) return;
    if (typeof ((_globalThis = globalThis) === null || _globalThis === void 0 ? void 0 : _globalThis.structuredClone) === 'function') (0, _interactionMetrics.addCustomData)(currentInteractionId, [], globalThis.structuredClone(data));
    else (0, _interactionMetrics.addCustomData)(currentInteractionId, [], data);
}

},{"react":"ltHCL","../interaction-context":"cJnHa","../interaction-id-context":"eBW7s","../interaction-metrics":"j4w6h","@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"gnWyu":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "getProductSubPath", ()=>(0, _analyticsClient.getProductSubPath));
parcelHelpers.export(exports, "getAnalyticsClient", ()=>(0, _analyticsClient.getAnalyticsClient));
parcelHelpers.export(exports, "sendPackageOperationalEvent", ()=>(0, _analyticsClient.sendPackageOperationalEvent));
parcelHelpers.export(exports, "sendUIEvent", ()=>(0, _analyticsClient.sendUIEvent));
parcelHelpers.export(exports, "sendScreenEvent", ()=>(0, _analyticsClient.sendScreenEvent));
parcelHelpers.export(exports, "sendTrackEvent", ()=>(0, _analyticsClient.sendTrackEvent));
parcelHelpers.export(exports, "CacheLoader", ()=>(0, _loadStorageControlsData.CacheLoader));
parcelHelpers.export(exports, "initializeGlobalState", ()=>(0, _bscGlobalState.initializeGlobalState));
parcelHelpers.export(exports, "testing_overrideGlobalState", ()=>(0, _bscGlobalState.testing_overrideGlobalState));
parcelHelpers.export(exports, "getBscGlobalState", ()=>(0, _bscGlobalState.getBscGlobalState));
parcelHelpers.export(exports, "clearGlobalState", ()=>(0, _bscGlobalState.clearGlobalState));
parcelHelpers.export(exports, "getBitValueFromBool", ()=>(0, _helpers.getBitValueFromBool));
parcelHelpers.export(exports, "getBoolFromBitValue", ()=>(0, _helpers.getBoolFromBitValue));
parcelHelpers.export(exports, "withAnalyticsEventSampling", ()=>(0, _withSampling.withAnalyticsEventSampling));
parcelHelpers.export(exports, "withSampling", ()=>(0, _withSampling.withSampling));
parcelHelpers.export(exports, "isSSR", ()=>(0, _isSsr.isSSR));
parcelHelpers.export(exports, "Logger", ()=>(0, _logger.Logger));
var _analyticsClient = require("./analytics-client");
var _loadStorageControlsData = require("./load-storage-controls-data");
var _bscGlobalState = require("./bsc-global-state");
var _helpers = require("./helpers");
var _withSampling = require("./analytics-client/with-sampling");
var _isSsr = require("./is-ssr");
var _logger = require("./logger");

},{"./analytics-client":"3Dqor","./load-storage-controls-data":false,"./bsc-global-state":"i7ava","./helpers":"kWrwq","./analytics-client/with-sampling":false,"./is-ssr":"ciW3w","./logger":"2Tk7J","@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"e4S3J":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "getCategoryCacheUrlPerimeterLookup", ()=>(0, _constants.getCategoryCacheUrlPerimeterLookup));
parcelHelpers.export(exports, "getCommercialCategoryCacheUrlLookup", ()=>(0, _constants.getCommercialCategoryCacheUrlLookup));
parcelHelpers.export(exports, "CacheLoader", ()=>CacheLoader);
var _platformFeatureFlags = require("@atlaskit/platform-feature-flags");
var _ufo = require("@atlassian/ufo");
var _core = require("../bsc-global-state/core");
var _logger = require("../logger");
var _constants = require("./constants");
class CacheLoader {
    clearStorageControlsDataCache() {
        this.localResponseCache = undefined;
        this.localResponsePromiseCache = undefined;
        this.localResponseJsonPromiseCache = undefined;
    }
    /**
	 * Unpacks the response promise from the categories CDN
	 *
	 * errors if that request was unsuccessful, returns the categories data otherwise
	 *
	 */ async handleCategoriesResponse(responsePromise) {
        if (!responsePromise) throw new Error(`Failed to fetch Cookies Cache! Cached promise was undefined`);
        const response = await responsePromise;
        if (!response.ok) throw new Error(`Failed to fetch Cookies Cache! status: ${response.status}`);
        // Checks if we've already fired the response.json() promise
        this.localResponseJsonPromiseCache = this.localResponseJsonPromiseCache || (response === null || response === void 0 ? void 0 : response.json());
        return this.localResponseJsonPromiseCache;
    }
    getStorageControlsDataFromCache() {
        return this.localResponseCache;
    }
    async loadStorageControlsData() {
        const isFetchTrackingSampled = !Math.floor(Math.random() * 100);
        let fetchExperience = null;
        if (isFetchTrackingSampled) {
            fetchExperience = new (0, _ufo.UFOExperience)('browser-storage-controls-fetch-time', {
                type: (0, _ufo.ExperienceTypes).Load,
                performanceType: (0, _ufo.ExperiencePerformanceTypes).Custom,
                platform: {
                    component: 'browser-storage-controls'
                }
            });
            fetchExperience.start();
        }
        if (this.localResponseCache) {
            if (fetchExperience) fetchExperience.success();
            return this.localResponseCache;
        } else // Always use Prod CDN for prod/local/dev/staging environments, but stub the route for automation tests
        try {
            if (!this.localResponsePromiseCache) {
                (0, _logger.Logger).debug(`Loading cache ${this.cacheUrl}`);
                // invoke CDN and cache the promise
                this.localResponsePromiseCache = fetch(this.cacheUrl);
            }
            // unpack response
            this.localResponseCache = await this.handleCategoriesResponse(this.localResponsePromiseCache);
            if ((0, _platformFeatureFlags.fg)('platform_bsc_cache_load_date')) (0, _core.__internalSetCacheLoadedDate)(new Date().toISOString().slice(0, 10));
            if (fetchExperience) fetchExperience.success();
            return this.localResponseCache;
        } catch (e) {
            if (fetchExperience) fetchExperience.failure({
                metadata: {
                    error: String(e)
                }
            });
            (0, _logger.Logger).errorWithOperationalEvent({
                action: 'loadStorageControlsError',
                message: e.message || ''
            });
            this.clearStorageControlsDataCache();
        }
    }
    constructor(storageType, perimeter = 'commercial'){
        const useFlatFormat = (0, _platformFeatureFlags.fg)('platform_bsc_flat_pattern_file_structure');
        const cacheUrlLookup = (0, _constants.getCategoryCacheUrlPerimeterLookup)(useFlatFormat)[perimeter] || (0, _constants.getCommercialCategoryCacheUrlLookup)(useFlatFormat);
        this.cacheUrl = cacheUrlLookup[storageType];
    }
}

},{"@atlaskit/platform-feature-flags":"8rD2i","@atlassian/ufo":"lFju6","../bsc-global-state/core":"Lu8Q3","../logger":"2Tk7J","./constants":"ivrci","@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"lFju6":[function(require,module,exports,__globalThis) {
/**
 * We name this "external" for typedoc. The other internal modules are configured as entrypoints.
 * @module external
 */ var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "UFOExperienceState", ()=>(0, _ufoExperimental.UFOExperienceState));
parcelHelpers.export(exports, "UFOExperience", ()=>(0, _ufoExperimental.UFOExperience));
parcelHelpers.export(exports, "ConcurrentExperience", ()=>(0, _ufoExperimental.ConcurrentExperience));
parcelHelpers.export(exports, "ExperienceTypes", ()=>(0, _ufoExperimental.ExperienceTypes));
parcelHelpers.export(exports, "ExperiencePerformanceTypes", ()=>(0, _ufoExperimental.ExperiencePerformanceTypes));
parcelHelpers.export(exports, "GlobalPageLoadExperience", ()=>(0, _ufoExperimental.GlobalPageLoadExperience));
parcelHelpers.export(exports, "ufologger", ()=>(0, _ufoExperimental.ufologger));
parcelHelpers.export(exports, "untilAll", ()=>(0, _ufoExperimental.untilAll));
/**
 * @ignore this is exported explicitly by typedoc as its own module so don't parse it here
 */ parcelHelpers.export(exports, "payloadPublisher", ()=>(0, _core.payloadPublisher));
/**
 * @ignore this is exported explicitly by typedoc as its own module so don't parse it here
 */ parcelHelpers.export(exports, "TenantType", ()=>(0, _types.TenantType));
/**
 * @ignore this is exported explicitly by typedoc as its own module so don't parse it here
 */ parcelHelpers.export(exports, "ExperienceSuccess", ()=>(0, _react.ExperienceSuccess));
parcelHelpers.export(exports, "useUFOComponentExperience", ()=>(0, _react.useUFOComponentExperience));
var _ufoExperimental = require("./ufo-experimental");
var _core = require("./core");
var _types = require("./types");
var _react = require("./react");

},{"./ufo-experimental":"epp3P","./core":false,"./types":false,"./react":"9P07Z","@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"epp3P":[function(require,module,exports,__globalThis) {
/**
 * We name this "external" for typedoc. The other internal modules are configured as entrypoints.
 * @module external
 */ var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "UFOExperienceState", ()=>(0, _ufoExperimental.UFOExperienceState));
parcelHelpers.export(exports, "UFOExperience", ()=>(0, _ufoExperimental.UFOExperience));
parcelHelpers.export(exports, "ConcurrentExperience", ()=>(0, _ufoExperimental.ConcurrentExperience));
parcelHelpers.export(exports, "ExperienceTypes", ()=>(0, _ufoExperimental.ExperienceTypes));
parcelHelpers.export(exports, "ExperiencePerformanceTypes", ()=>(0, _ufoExperimental.ExperiencePerformanceTypes));
parcelHelpers.export(exports, "GlobalPageLoadExperience", ()=>(0, _ufoExperimental.GlobalPageLoadExperience));
parcelHelpers.export(exports, "ufologger", ()=>(0, _ufoExperimental.ufologger));
parcelHelpers.export(exports, "untilAll", ()=>(0, _ufoExperimental.untilAll));
var _ufoExperimental = require("@atlassian/ufo-experimental");

},{"@atlassian/ufo-experimental":"6L29C","@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"6L29C":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "UFOExperienceState", ()=>(0, _platformClient.UFOExperienceState));
parcelHelpers.export(exports, "UFOExperience", ()=>(0, _platformClient.UFOExperience));
parcelHelpers.export(exports, "ConcurrentExperience", ()=>(0, _platformClient.ConcurrentExperience));
parcelHelpers.export(exports, "perfNowOrTimestamp", ()=>(0, _platformClient.perfNowOrTimestamp));
parcelHelpers.export(exports, "ExperienceTypes", ()=>(0, _platformClient.ExperienceTypes));
parcelHelpers.export(exports, "ExperiencePerformanceTypes", ()=>(0, _platformClient.ExperiencePerformanceTypes));
parcelHelpers.export(exports, "GlobalPageLoadExperience", ()=>(0, _platformClient.GlobalPageLoadExperience));
parcelHelpers.export(exports, "ufolog", ()=>(0, _logger.ufolog));
parcelHelpers.export(exports, "ufologger", ()=>(0, _logger.ufologger));
parcelHelpers.export(exports, "ufowarn", ()=>(0, _logger.ufowarn));
parcelHelpers.export(exports, "getGlobalEventStream", ()=>(0, _globalStreamBuffer.getGlobalEventStream));
parcelHelpers.export(exports, "setGlobalEventStream", ()=>(0, _globalStreamBuffer.setGlobalEventStream));
parcelHelpers.export(exports, "experiencePayloadEvent", ()=>(0, _globalStreamBuffer.experiencePayloadEvent));
parcelHelpers.export(exports, "unsubscribeEvent", ()=>(0, _globalStreamBuffer.unsubscribeEvent));
parcelHelpers.export(exports, "subscribeEvent", ()=>(0, _globalStreamBuffer.subscribeEvent));
parcelHelpers.export(exports, "UFO_EXPERIMENTAL_BUILD_VERSION", ()=>(0, _buildVersion.UFO_EXPERIMENTAL_BUILD_VERSION));
parcelHelpers.export(exports, "visibilityChangeObserver", ()=>(0, _visibilityChangeObserver.visibilityChangeObserver));
parcelHelpers.export(exports, "untilAll", ()=>(0, _untilHelpers.untilAll));
parcelHelpers.export(exports, "useUFOExperience", ()=>(0, _useUFOExperience.useUFOExperience));
parcelHelpers.export(exports, "useUFOStreamingExperience", ()=>(0, _useUFOStreamingExperience.useUFOStreamingExperience));
var _platformClient = require("./platform-client");
var _logger = require("./logger");
var _globalStreamBuffer = require("./global-stream-buffer");
var _buildVersion = require("./buildVersion");
var _visibilityChangeObserver = require("./observer/visibility-change-observer");
var _untilHelpers = require("./platform-client/utils/until-helpers");
var _useUFOExperience = require("./platform-client/hooks/useUFOExperience");
var _useUFOStreamingExperience = require("./platform-client/hooks/useUFOStreamingExperience");

},{"./platform-client":"9ZMO1","./logger":false,"./global-stream-buffer":false,"./buildVersion":false,"./observer/visibility-change-observer":false,"./platform-client/utils/until-helpers":"9DUJ9","./platform-client/hooks/useUFOExperience":false,"./platform-client/hooks/useUFOStreamingExperience":false,"@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"9ZMO1":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "UFOExperienceState", ()=>(0, _core.UFOExperienceState));
parcelHelpers.export(exports, "UFOExperience", ()=>(0, _core.UFOExperience));
parcelHelpers.export(exports, "ConcurrentExperience", ()=>(0, _core.ConcurrentExperience));
parcelHelpers.export(exports, "ExperienceTypes", ()=>(0, _core.ExperienceTypes));
parcelHelpers.export(exports, "ExperiencePerformanceTypes", ()=>(0, _core.ExperiencePerformanceTypes));
parcelHelpers.export(exports, "GlobalPageLoadExperience", ()=>(0, _core.GlobalPageLoadExperience));
parcelHelpers.export(exports, "perfNowOrTimestamp", ()=>(0, _core.perfNowOrTimestamp));
parcelHelpers.export(exports, "useUFOExperience", ()=>(0, _useUFOExperience.useUFOExperience));
parcelHelpers.export(exports, "useUFOStreamingExperience", ()=>(0, _useUFOStreamingExperience.useUFOStreamingExperience));
var _core = require("./core");
var _useUFOExperience = require("./hooks/useUFOExperience");
var _useUFOStreamingExperience = require("./hooks/useUFOStreamingExperience");

},{"./core":"iLkiR","./hooks/useUFOExperience":false,"./hooks/useUFOStreamingExperience":false,"@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"iLkiR":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "ConcurrentExperience", ()=>(0, _concurrentExperience.ConcurrentExperience));
parcelHelpers.export(exports, "UFOExperience", ()=>(0, _experience.UFOExperience));
parcelHelpers.export(exports, "UFOExperienceState", ()=>(0, _experienceState.UFOExperienceState));
parcelHelpers.export(exports, "ExperienceTypes", ()=>(0, _experienceTypes.ExperienceTypes));
parcelHelpers.export(exports, "ExperiencePerformanceTypes", ()=>(0, _experienceTypes.ExperiencePerformanceTypes));
parcelHelpers.export(exports, "GlobalPageLoadExperience", ()=>(0, _globalPageLoadExperience.GlobalPageLoadExperience));
parcelHelpers.export(exports, "perfNowOrTimestamp", ()=>(0, _abstractExperience.perfNowOrTimestamp));
var _concurrentExperience = require("./experience/concurrent-experience");
var _experience = require("./experience/experience");
var _experienceState = require("./experience/experience-state");
var _experienceTypes = require("./experience/experience-types");
var _globalPageLoadExperience = require("./experience/global-page-load-experience");
var _abstractExperience = require("./experience/abstract-experience");

},{"./experience/concurrent-experience":"7M4b3","./experience/experience":"1hosT","./experience/experience-state":"7pIIM","./experience/experience-types":"jNixA","./experience/global-page-load-experience":"1M0WY","./experience/abstract-experience":false,"@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"7M4b3":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "ConcurrentExperience", ()=>ConcurrentExperience);
var _logger = require("../../../logger");
var _experience = require("./experience");
class ConcurrentExperience {
    getInstance(instanceId) {
        if (!this.instances[instanceId]) this.instances[instanceId] = new (0, _experience.UFOExperience)(this.experienceId, this.config, instanceId);
        return this.instances[instanceId];
    }
    release(instanceId) {
        (0, _logger.ufolog)('instanceId', instanceId);
        if (this.instances[instanceId]) this.instances[instanceId].abort();
        delete this.instances[instanceId];
    }
    constructor(experienceId, config){
        this.instances = {};
        this.experienceId = experienceId;
        this.config = config;
    }
}

},{"../../../logger":"6qQp4","./experience":"1hosT","@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"6qQp4":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "ufologger", ()=>ufologger);
parcelHelpers.export(exports, "ufolog", ()=>ufolog);
parcelHelpers.export(exports, "ufowarn", ()=>ufowarn);
class UFOLogger {
    log(...args) {
        // eslint-disable-next-line no-console
        this.enabled && console.log(UFOLogger.UFOprefix, ...args);
    }
    warn(...args) {
        // eslint-disable-next-line no-console
        this.enabled && console.warn(UFOLogger.UFOprefix, ...args);
    }
    enable() {
        this.enabled = true;
    }
    disable() {
        this.enabled = false;
    }
    constructor(){
        this.enabled = false;
    }
}
UFOLogger.UFOprefix = "[ufo\uD83D\uDEF8]";
const ufologger = new UFOLogger();
const ufolog = (...args)=>{
    ufologger.log(...args);
};
const ufowarn = (...args)=>{
    ufologger.warn(...args);
};

},{"@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"1hosT":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "UFOExperience", ()=>UFOExperience);
var _abstractExperience = require("./abstract-experience");
class UFOExperience extends (0, _abstractExperience.UFOAbstractExperience) {
}

},{"./abstract-experience":"cLvXX","@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"cLvXX":[function(require,module,exports,__globalThis) {
// eslint-disable-next-line @atlaskit/platform/prefer-crypto-random-uuid -- Use crypto.randomUUID instead
var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "perfNowOrTimestamp", ()=>perfNowOrTimestamp);
parcelHelpers.export(exports, "UFOAbstractExperience", ()=>UFOAbstractExperience);
var _objectSpread = require("@swc/helpers/_/_object_spread");
var _uuid = require("uuid");
var _platformFeatureFlags = require("@atlaskit/platform-feature-flags");
var _clearActiveTrace = require("@atlassian/trace-context/clearActiveTrace");
var _generateSpanId = require("@atlassian/trace-context/generateSpanId");
var _generateTraceId = require("@atlassian/trace-context/generateTraceId");
var _getActiveTrace = require("@atlassian/trace-context/getActiveTrace");
var _setActiveTrace = require("@atlassian/trace-context/setActiveTrace");
var _buildVersion = require("../../../buildVersion");
var _windowHelper = require("../../../common/utils/windowHelper");
var _globalStreamBuffer = require("../../../global-stream-buffer");
var _logger = require("../../../logger");
var _visibilityChangeObserver = require("../../../observer/visibility-change-observer");
var _types = require("../../../types");
var _roundPerfNow = require("../../utils/round-perf-now");
var _experienceState = require("./experience-state");
var _experienceStateTransitions = require("./experience-state-transitions");
var _experienceTypes = require("./experience-types");
const getPageVisibleState = ()=>{
    return !(0, _windowHelper.isWindowObjectAvailable)() || !window.document || window.document.visibilityState === 'visible' ? (0, _types.PageVisibleState).VISIBLE : (0, _types.PageVisibleState).HIDDEN;
};
const perfNowOrTimestamp = (timestamp)=>{
    if (timestamp !== undefined) return ~~timestamp;
    return (0, _roundPerfNow.roundPerfNow)();
};
class UFOAbstractExperience {
    async transition(newState, timestamp) {
        (0, _logger.ufolog)('async transition', this.id, this.state.id, newState.id);
        if ((0, _experienceStateTransitions.canTransition)(this.state, newState)) {
            (0, _logger.ufolog)(`TRANSITION: ${this.id} from ${this.state.id} to ${newState.id} successful`, this.state.final, !newState.final);
            if (newState === (0, _experienceState.UFOExperienceState).STARTED) this._reset();
            if (this.state.final && !newState.final) {
                this.metrics.startTime = perfNowOrTimestamp(timestamp);
                // eslint-disable-next-line @atlaskit/platform/prefer-crypto-random-uuid -- Use crypto.randomUUID instead
                this.uuid = (0, _uuid.v4)();
            }
            this.state = newState;
            if (newState.final) {
                this.metrics.endTime = perfNowOrTimestamp(timestamp);
                if (!this._isManualStateEnabled()) (0, _globalStreamBuffer.getGlobalEventStream)().push((0, _globalStreamBuffer.unsubscribeEvent)((0, _types.SUBSCRIBE_ALL), this.handleDoneBind));
                this.stopTrace();
                const data = await this.exportData();
                (0, _logger.ufolog)('this.parent', this.parent);
                (0, _globalStreamBuffer.getGlobalEventStream)().push((0, _globalStreamBuffer.experiencePayloadEvent)(data));
            }
            return true;
        }
        (0, _logger.ufolog)(`TRANSITION: ${this.id} from ${this.state.id} to ${newState.id} unsuccessful`);
        (0, _logger.ufowarn)(`transition of ${this.id} from ${this.state} to ${newState} is not possible`);
        return false;
    }
    async start(startTime) {
        const transitionSuccessful = await this.transition((0, _experienceState.UFOExperienceState).STARTED, startTime);
        if (transitionSuccessful) {
            this.pageVisibleState = getPageVisibleState();
            (0, _visibilityChangeObserver.visibilityChangeObserver).subscribe(this.setPageVisibleStateToMixed);
            if (!this._isManualStateEnabled()) {
                (0, _logger.ufolog)('subscribed', this.id);
                (0, _globalStreamBuffer.getGlobalEventStream)().push((0, _globalStreamBuffer.subscribeEvent)((0, _types.SUBSCRIBE_ALL), this.handleDoneBind));
            }
            this.startTrace(this.id);
        }
    }
    mark(name, timestamp) {
        if (name !== (0, _types.FMP_MARK) && name !== (0, _types.INLINE_RESPONSE_MARK)) this._mark(name, timestamp);
        else (0, _logger.ufowarn)('please use markFMP or markInlineResponse for specialised marks');
    }
    _mark(name, timestamp) {
        this.metrics.marks.push({
            name,
            time: perfNowOrTimestamp(timestamp)
        });
        this.transition((0, _experienceState.UFOExperienceState).IN_PROGRESS);
    }
    markFMP(timestamp) {
        this._mark((0, _types.FMP_MARK), timestamp);
    }
    markInlineResponse(timestamp) {
        this._mark((0, _types.INLINE_RESPONSE_MARK), timestamp);
    }
    startTrace(experienceId) {
        if ((0, _platformFeatureFlags.fg)('ufo_v1_tracing')) {
            let traceContext = (0, _getActiveTrace.getActiveTrace)();
            if (!traceContext) {
                traceContext = {
                    traceId: (0, _generateTraceId.generateTraceId)(),
                    spanId: (0, _generateSpanId.generateSpanId)()
                };
                (0, _setActiveTrace.setActiveTrace)(traceContext.traceId, traceContext.spanId, 'ufo_v1.' + experienceId);
            }
            this.traceContext = traceContext;
        }
    }
    stopTrace() {
        if ((0, _platformFeatureFlags.fg)('ufo_v1_tracing')) (0, _clearActiveTrace.clearActiveTrace)();
    }
    _isManualStateEnabled() {
        return this.until === null;
    }
    _validateManualState() {
        if (!this._isManualStateEnabled()) {
            (0, _logger.ufowarn)('manual change of state not allowed as "until" is defined');
            return false;
        }
        return true;
    }
    switchToEndState(state, config) {
        if (!(config === null || config === void 0 ? void 0 : config.force) && !this._validateManualState()) return null;
        if (config === null || config === void 0 ? void 0 : config.metadata) this.addMetadata(config.metadata);
        (0, _visibilityChangeObserver.visibilityChangeObserver).unsubscribe(this.setPageVisibleStateToMixed);
        return this.transition(state);
    }
    async success(config) {
        return this.switchToEndState((0, _experienceState.UFOExperienceState).SUCCEEDED, config);
    }
    async failure(config) {
        return this.switchToEndState((0, _experienceState.UFOExperienceState).FAILED, config);
    }
    async abort(config) {
        return this.switchToEndState((0, _experienceState.UFOExperienceState).ABORTED, config);
    }
    addMetadata(data) {
        Object.assign(this.metadata, data);
    }
    _handleDoneExperience(data) {
        (0, _logger.ufolog)('_handleDoneExperience in', this.id, data.state, data, this._until);
        if (data.state.final) {
            if (this._until !== null) {
                const { done, state } = this._until(data);
                if (done && !this.state.final) this.transition(state);
            }
        }
    }
    async getId() {
        return this.id;
    }
    async exportData() {
        return (0, _objectSpread._)({
            id: await this.getId(),
            uuid: this.uuid,
            type: this.type,
            schemaVersion: (0, _buildVersion.UFO_EXPERIMENTAL_BUILD_VERSION) || 'unknown',
            performanceType: this.performanceType,
            category: this.category,
            state: this.state,
            metadata: (0, _objectSpread._)({}, this.metadata),
            metrics: (0, _objectSpread._)({}, this.metrics),
            children: [
                ...this.childExperiences
            ],
            result: {
                success: !!this.state.success,
                startTime: this.metrics.startTime,
                duration: (this.metrics.endTime || 0) - (this.metrics.startTime || 0)
            },
            platform: this.config.platform || null,
            pageVisibleState: this.pageVisibleState,
            featureFlags: this.featureFlags,
            isSSROutputAsFMP: this.isSSROutputAsFMP,
            timings: this.timings,
            explicitTimings: this.explicitTimings,
            performanceConfig: this.performanceConfig
        }, (0, _platformFeatureFlags.fg)('ufo_v1_tracing') ? {
            traceContext: this.traceContext
        } : {});
    }
    _reset() {
        this.parent = null;
        this.metadata = {};
        this.onDoneCallbacks = [];
        this.childExperiences = [];
        this.metrics = {
            startTime: null,
            endTime: null,
            marks: []
        };
        this.traceContext = null;
        this._until = this.until ? this.until() : null;
    }
    constructor(id, config, instanceId = null){
        this.state = (0, _experienceState.UFOExperienceState).NOT_STARTED;
        this.instanceId = null; // for concurrent
        this.parent = null;
        this.category = null;
        this.metadata = {};
        this.onDoneCallbacks = [];
        this.childExperiences = [];
        this.explicitTimings = {};
        // @todo move to page load experience when proper classes/inheritance prepared
        this.isSSROutputAsFMP = false;
        this.uuid = null;
        this._until = null;
        this.traceContext = null;
        this.metrics = {
            startTime: null,
            endTime: null,
            marks: []
        };
        this.performanceConfig = {};
        this.setPageVisibleStateToMixed = ()=>{
            this.pageVisibleState = (0, _types.PageVisibleState).MIXED;
            (0, _visibilityChangeObserver.visibilityChangeObserver).unsubscribe(this.setPageVisibleStateToMixed);
        };
        this.id = id;
        this.category = (config === null || config === void 0 ? void 0 : config.category) || null;
        this.until = (config === null || config === void 0 ? void 0 : config.until) || null;
        this.instanceId = instanceId;
        this.handleDoneBind = this._handleDoneExperience.bind(this);
        this.type = config.type;
        this.performanceType = config.performanceType;
        this.performanceConfig = config.performanceConfig || {};
        this.config = config;
        this.pageVisibleState = getPageVisibleState();
        this.featureFlags = config.featureFlags || [];
        this.timings = config.timings || [];
        if (config.performanceType === (0, _experienceTypes.ExperiencePerformanceTypes).PageLoad || config.performanceType === (0, _experienceTypes.ExperiencePerformanceTypes).PageSegmentLoad) this.isSSROutputAsFMP = config.isSSROutputAsFMP || false;
    }
}

},{"@swc/helpers/_/_object_spread":"9gdrV","uuid":"5elg8","@atlaskit/platform-feature-flags":"8rD2i","@atlassian/trace-context/clearActiveTrace":"4ufBD","@atlassian/trace-context/generateSpanId":"lOE8q","@atlassian/trace-context/generateTraceId":"BU7ky","@atlassian/trace-context/getActiveTrace":"gw6Nd","@atlassian/trace-context/setActiveTrace":"kPcbU","../../../buildVersion":"esGOf","../../../common/utils/windowHelper":"fHMCt","../../../global-stream-buffer":"3fAsm","../../../logger":"6qQp4","../../../observer/visibility-change-observer":"gVa99","../../../types":"lI21G","../../utils/round-perf-now":"kPp0Q","./experience-state":"7pIIM","./experience-state-transitions":"hLq91","./experience-types":"jNixA","@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"4ufBD":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
/**
 * Clears the active trace context.
 * This should be called when a trace is complete to ensure the context
 * doesn't leak into subsequent operations.
 *
 * @example
 * ```typescript
 * clearActiveTrace();
 * ```
 */ parcelHelpers.export(exports, "clearActiveTrace", ()=>clearActiveTrace);
var _state = require("./state");
function clearActiveTrace() {
    (0, _state.state).context = null;
}

},{"./state":"8VOUD","@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"8VOUD":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "state", ()=>state);
const state = {
    context: null
};

},{"@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"lOE8q":[function(require,module,exports,__globalThis) {
/**
 * Generates a random 16-character hexadecimal span ID.
 * This is used for creating new span IDs in distributed tracing.
 *
 * @returns A 16-character hexadecimal string
 *
 * @example
 * ```typescript
 * const spanId = generateSpanId(); // e.g., "84a67a1b3ceccf27"
 * ```
 */ var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "generateSpanId", ()=>generateSpanId);
function generateSpanId() {
    return Array.from(new Array(16), ()=>Math.floor(Math.random() * 16).toString(16)).join('');
}

},{"@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"BU7ky":[function(require,module,exports,__globalThis) {
/**
 * Generates a random 32-character hexadecimal trace ID.
 * This is used for creating new trace IDs in distributed tracing.
 *
 * @returns A 32-character hexadecimal string
 *
 * @example
 * ```typescript
 * const traceId = generateTraceId(); // e.g., "9ad3407c1a7d484b86847e7226e566d3"
 * ```
 */ var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "generateTraceId", ()=>generateTraceId);
function generateTraceId() {
    return Array.from(new Array(32), ()=>Math.floor(Math.random() * 16).toString(16)).join('');
}

},{"@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"gw6Nd":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
/**
 * Gets the currently active trace context.
 * Returns undefined if no trace context is currently active.
 *
 * @returns The active trace context, or null if none is set
 *
 * @example
 * ```typescript
 * const trace = getActiveTrace();
 * if (trace) {
 *   console.log(`Trace ID: ${trace.traceId}, Span ID: ${trace.spanId}`);
 * }
 * ```
 */ parcelHelpers.export(exports, "getActiveTrace", ()=>getActiveTrace);
var _state = require("./state");
function getActiveTrace() {
    return (0, _state.state).context;
}

},{"./state":"8VOUD","@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"kPcbU":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
/**
 * Sets the active trace context.
 * This function should be called when starting a new trace to establish
 * the trace context that will be propagated to downstream operations.
 *
 * @param traceId - The trace ID to set
 * @param spanId - The span ID to set
 * @param source - The calling package/experience/what-have-you. EG 'jira.fe.backlog.create-issue_bm3'
 *
 * @example
 * ```typescript
 * setActiveTrace('9ad3407c1a7d484b86847e7226e566d3', '84a67a1b3ceccf27', 'bm3_jira.fe.inline-result.backlog.issue-create');
 * ```
 */ parcelHelpers.export(exports, "setActiveTrace", ()=>setActiveTrace);
var _analyticsWebClient = require("@atlassiansox/analytics-web-client");
var _analyticsWebClientDefault = parcelHelpers.interopDefault(_analyticsWebClient);
var _getEnvironment = require("./getEnvironment");
var _state = require("./state");
const getAnalyticsClient = (()=>{
    let instance;
    return ()=>{
        if (!instance) {
            const env = (0, _getEnvironment.getEnvironment)();
            instance = new (0, _analyticsWebClientDefault.default)({
                env,
                product: 'observability'
            });
        }
        return instance;
    };
})();
function setActiveTrace(traceId, spanId, source) {
    // If trace context has already been set, there has been an experience collision
    // Don't update the trace context.
    if ((0, _state.state).context !== null) getAnalyticsClient().sendOperationalEvent({
        source,
        action: 'setActiveTrace',
        actionSubject: 'traceContext',
        attributes: {
            currentContext: (0, _state.state).context,
            incomingContext: {
                traceId,
                spanId
            },
            status: 'collision'
        },
        tags: [
            'observability'
        ]
    });
    else (0, _state.state).context = {
        traceId,
        spanId
    };
}

},{"@atlassiansox/analytics-web-client":"6RHYr","./getEnvironment":"lN8pZ","./state":"8VOUD","@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"lN8pZ":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "getEnvironment", ()=>getEnvironment);
var _analyticsWebClient = require("@atlassiansox/analytics-web-client");
function getEnvironment() {
    // Gaurd for running in the browser - if SSR (somehow) just return prod
    if (typeof window === 'undefined') return (0, _analyticsWebClient.envType).PROD;
    const { hostname } = window.location;
    if (hostname === 'localhost' || hostname === '127.0.0.1') return (0, _analyticsWebClient.envType).LOCAL;
    if (hostname.includes('.dev.')) return (0, _analyticsWebClient.envType).STAGING;
    if (hostname.includes('.stg.')) return (0, _analyticsWebClient.envType).STAGING;
    return (0, _analyticsWebClient.envType).PROD;
}

},{"@atlassiansox/analytics-web-client":"6RHYr","@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"esGOf":[function(require,module,exports,__globalThis) {
// temp solution until we can get it automated
var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "UFO_EXPERIMENTAL_BUILD_VERSION", ()=>UFO_EXPERIMENTAL_BUILD_VERSION);
const UFO_EXPERIMENTAL_BUILD_VERSION = '0.1.5';

},{"@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"fHMCt":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "isWindowObjectAvailable", ()=>isWindowObjectAvailable);
const isWindowObjectAvailable = ()=>{
    return typeof window !== 'undefined';
};

},{"@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"3fAsm":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "getGlobalEventStream", ()=>getGlobalEventStream);
parcelHelpers.export(exports, "setGlobalEventStream", ()=>setGlobalEventStream);
parcelHelpers.export(exports, "subscribeEvent", ()=>subscribeEvent);
parcelHelpers.export(exports, "unsubscribeEvent", ()=>unsubscribeEvent);
parcelHelpers.export(exports, "experiencePayloadEvent", ()=>experiencePayloadEvent);
var _logger = require("../logger");
var _types = require("../types");
const MAX_EARLY_QUEUE_LENGTH = 250;
const getGlobalEventStream = ()=>{
    if (!globalThis.__UFO_GLOBAL_EVENT_STREAM__) {
        const earlyStream = (()=>{
            const stream = [];
            return {
                __buffer_only__: true,
                push: (event)=>{
                    if (stream.length < MAX_EARLY_QUEUE_LENGTH) stream.push(event);
                },
                getStream: ()=>stream
            };
        })();
        globalThis.__UFO_GLOBAL_EVENT_STREAM__ = earlyStream;
    }
    return globalThis.__UFO_GLOBAL_EVENT_STREAM__;
};
const setGlobalEventStream = (eventStream)=>{
    var _globalThis___UFO_GLOBAL_EVENT_STREAM__, _globalThis___UFO_GLOBAL_EVENT_STREAM__1;
    if (globalThis.__UFO_GLOBAL_EVENT_STREAM__ && !((_globalThis___UFO_GLOBAL_EVENT_STREAM__ = globalThis.__UFO_GLOBAL_EVENT_STREAM__) === null || _globalThis___UFO_GLOBAL_EVENT_STREAM__ === void 0 ? void 0 : _globalThis___UFO_GLOBAL_EVENT_STREAM__.__buffer_only__)) {
        (0, _logger.ufowarn)('Global Event Stream already initialised. Ignoring new event stream setup');
        return;
    }
    if ((_globalThis___UFO_GLOBAL_EVENT_STREAM__1 = globalThis.__UFO_GLOBAL_EVENT_STREAM__) === null || _globalThis___UFO_GLOBAL_EVENT_STREAM__1 === void 0 ? void 0 : _globalThis___UFO_GLOBAL_EVENT_STREAM__1.__buffer_only__) globalThis.__UFO_GLOBAL_EVENT_STREAM__.getStream().forEach(eventStream.push.bind(eventStream));
    globalThis.__UFO_GLOBAL_EVENT_STREAM__ = eventStream;
};
const subscribeEvent = (experienceId, callback)=>{
    return {
        type: (0, _types.UFOGlobalEventStreamEventType).SUBSCRIBE,
        payload: {
            experienceId,
            callback
        }
    };
};
const unsubscribeEvent = (experienceId, callback)=>{
    return {
        type: (0, _types.UFOGlobalEventStreamEventType).UNSUBSCRIBE,
        payload: {
            experienceId,
            callback
        }
    };
};
const experiencePayloadEvent = (data)=>{
    return {
        type: (0, _types.UFOGlobalEventStreamEventType).EXPERIENCE_PAYLOAD,
        payload: data
    };
};

},{"../logger":"6qQp4","../types":"lI21G","@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"lI21G":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "UFOGlobalEventStreamEventType", ()=>UFOGlobalEventStreamEventType);
parcelHelpers.export(exports, "PageVisibleState", ()=>PageVisibleState);
parcelHelpers.export(exports, "PageLoadMetrics", ()=>PageLoadMetrics);
parcelHelpers.export(exports, "PageSegmentLoadMetrics", ()=>PageSegmentLoadMetrics);
parcelHelpers.export(exports, "InteractionMetrics", ()=>InteractionMetrics);
parcelHelpers.export(exports, "CustomMetrics", ()=>CustomMetrics);
parcelHelpers.export(exports, "SUBSCRIBE_ALL", ()=>SUBSCRIBE_ALL);
parcelHelpers.export(exports, "FMP_MARK", ()=>FMP_MARK);
parcelHelpers.export(exports, "INLINE_RESPONSE_MARK", ()=>INLINE_RESPONSE_MARK);
var UFOGlobalEventStreamEventType = /*#__PURE__*/ function(UFOGlobalEventStreamEventType) {
    UFOGlobalEventStreamEventType[UFOGlobalEventStreamEventType["EXPERIENCE_PAYLOAD"] = 0] = "EXPERIENCE_PAYLOAD";
    UFOGlobalEventStreamEventType[UFOGlobalEventStreamEventType["SUBSCRIBE"] = 1] = "SUBSCRIBE";
    UFOGlobalEventStreamEventType[UFOGlobalEventStreamEventType["UNSUBSCRIBE"] = 2] = "UNSUBSCRIBE";
    return UFOGlobalEventStreamEventType;
}({});
var PageVisibleState = /*#__PURE__*/ function(PageVisibleState) {
    PageVisibleState["VISIBLE"] = "visible";
    PageVisibleState["HIDDEN"] = "hidden";
    PageVisibleState["MIXED"] = "mixed";
    return PageVisibleState;
}({});
var PageLoadMetrics = /*#__PURE__*/ function(PageLoadMetrics) {
    PageLoadMetrics["fmp"] = "fmp";
    PageLoadMetrics["tti"] = "tti";
    return PageLoadMetrics;
}({});
var PageSegmentLoadMetrics = /*#__PURE__*/ function(PageSegmentLoadMetrics) {
    PageSegmentLoadMetrics["fmp"] = "fmp";
    PageSegmentLoadMetrics["tti"] = "tti";
    return PageSegmentLoadMetrics;
}({});
var InteractionMetrics = /*#__PURE__*/ function(InteractionMetrics) {
    InteractionMetrics["response"] = "response";
    InteractionMetrics["result"] = "result";
    return InteractionMetrics;
}({});
var CustomMetrics = /*#__PURE__*/ function(CustomMetrics) {
    CustomMetrics["duration"] = "duration";
    return CustomMetrics;
}({});
const SUBSCRIBE_ALL = '__SUBSCRIBE_ALL__';
const FMP_MARK = 'fmp';
const INLINE_RESPONSE_MARK = 'inline-response';

},{"@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"gVa99":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "visibilityChangeObserver", ()=>visibilityChangeObserver);
var _windowHelper = require("../common/utils/windowHelper");
class VisibilityChangeObserver {
    start() {
        if (this.started) return;
        this.started = true;
        document.addEventListener('visibilitychange', this.broadcast);
        /**
		 * According to https://developer.mozilla.org/en-US/docs/Web/API/Document/visibilitychange_event
		 * Safari doesn’t fire visibilitychange as expected when the value of the visibilityState property transitions to hidden;
		 * so for that case, you need to also include code to listen for the pagehide event.
		 */ if ((0, _windowHelper.isWindowObjectAvailable)()) window.addEventListener('pagehide', this.broadcast);
    }
    subscribe(callback) {
        this.observers.push(callback);
    }
    unsubscribe(callback) {
        this.observers = this.observers.filter((fn)=>fn !== callback);
    }
    constructor(){
        this.started = false;
        this.observers = [];
        this.broadcast = ()=>{
            this.observers.forEach((fn)=>fn());
            this.observers = [];
        };
    }
}
const visibilityChangeObserver = new VisibilityChangeObserver();

},{"../common/utils/windowHelper":"fHMCt","@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"kPp0Q":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "roundPerfNow", ()=>roundPerfNow);
const roundPerfNow = ()=>~~performance.now();

},{"@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"7pIIM":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "UFOExperienceState", ()=>UFOExperienceState);
const UFOExperienceState = {
    NOT_STARTED: {
        id: 'NOT_STARTED',
        final: true
    },
    STARTED: {
        id: 'STARTED'
    },
    IN_PROGRESS: {
        id: 'IN_PROGRESS'
    },
    BLOCKED: {
        id: 'BLOCKED'
    },
    RECOVERED: {
        id: 'RECOVERED'
    },
    SUCCEEDED: {
        id: 'SUCCEEDED',
        final: true,
        success: true
    },
    SUCCEEDED_WAITING_FOR_DEPS: {
        id: 'SUCCEEDED_WAITING_FOR_DEPS'
    },
    FAILED: {
        id: 'FAILED',
        final: true
    },
    ABORTED: {
        id: 'ABORTED',
        final: true
    }
};

},{"@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"hLq91":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "canTransition", ()=>canTransition);
var _experienceState = require("./experience-state");
const UFOStateAvailableTransitions = {
    [(0, _experienceState.UFOExperienceState).NOT_STARTED.id]: [
        (0, _experienceState.UFOExperienceState).STARTED.id
    ],
    [(0, _experienceState.UFOExperienceState).STARTED.id]: [
        (0, _experienceState.UFOExperienceState).IN_PROGRESS.id,
        (0, _experienceState.UFOExperienceState).BLOCKED.id,
        (0, _experienceState.UFOExperienceState).SUCCEEDED.id,
        (0, _experienceState.UFOExperienceState).SUCCEEDED_WAITING_FOR_DEPS.id,
        (0, _experienceState.UFOExperienceState).FAILED.id,
        (0, _experienceState.UFOExperienceState).ABORTED.id
    ],
    [(0, _experienceState.UFOExperienceState).IN_PROGRESS.id]: [
        (0, _experienceState.UFOExperienceState).BLOCKED.id,
        (0, _experienceState.UFOExperienceState).SUCCEEDED.id,
        (0, _experienceState.UFOExperienceState).SUCCEEDED_WAITING_FOR_DEPS.id,
        (0, _experienceState.UFOExperienceState).FAILED.id,
        (0, _experienceState.UFOExperienceState).ABORTED.id
    ],
    [(0, _experienceState.UFOExperienceState).BLOCKED.id]: [
        (0, _experienceState.UFOExperienceState).RECOVERED.id,
        (0, _experienceState.UFOExperienceState).ABORTED.id
    ],
    [(0, _experienceState.UFOExperienceState).RECOVERED.id]: [
        (0, _experienceState.UFOExperienceState).STARTED.id,
        (0, _experienceState.UFOExperienceState).SUCCEEDED.id,
        (0, _experienceState.UFOExperienceState).SUCCEEDED_WAITING_FOR_DEPS.id,
        (0, _experienceState.UFOExperienceState).FAILED.id,
        (0, _experienceState.UFOExperienceState).ABORTED.id
    ],
    [(0, _experienceState.UFOExperienceState).SUCCEEDED.id]: [
        (0, _experienceState.UFOExperienceState).STARTED.id
    ],
    [(0, _experienceState.UFOExperienceState).SUCCEEDED_WAITING_FOR_DEPS.id]: [
        (0, _experienceState.UFOExperienceState).SUCCEEDED.id,
        (0, _experienceState.UFOExperienceState).FAILED.id,
        (0, _experienceState.UFOExperienceState).ABORTED.id
    ],
    [(0, _experienceState.UFOExperienceState).FAILED.id]: [
        (0, _experienceState.UFOExperienceState).STARTED.id
    ],
    [(0, _experienceState.UFOExperienceState).ABORTED.id]: [
        (0, _experienceState.UFOExperienceState).STARTED.id
    ]
};
const canTransition = (state1, state2)=>{
    return UFOStateAvailableTransitions[state1.id] && UFOStateAvailableTransitions[state1.id].includes(state2.id);
};

},{"./experience-state":"7pIIM","@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"jNixA":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "ExperienceTypes", ()=>ExperienceTypes);
parcelHelpers.export(exports, "ExperiencePerformanceTypes", ()=>ExperiencePerformanceTypes);
var ExperienceTypes = /*#__PURE__*/ function(ExperienceTypes) {
    ExperienceTypes["Load"] = "load";
    ExperienceTypes["Experience"] = "experience";
    ExperienceTypes["Operation"] = "operation";
    return ExperienceTypes;
}({});
var ExperiencePerformanceTypes = /*#__PURE__*/ function(ExperiencePerformanceTypes) {
    ExperiencePerformanceTypes["PageLoad"] = "page-load";
    ExperiencePerformanceTypes["PageSegmentLoad"] = "page-segment-load";
    ExperiencePerformanceTypes["InlineResult"] = "inline-result";
    ExperiencePerformanceTypes["Custom"] = "custom";
    return ExperiencePerformanceTypes;
}({});

},{"@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"1M0WY":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "GlobalPageLoadExperience", ()=>GlobalPageLoadExperience);
var _objectSpread = require("@swc/helpers/_/_object_spread");
var _objectSpreadProps = require("@swc/helpers/_/_object_spread_props");
var _untilHelpers = require("../../utils/until-helpers");
var _abstractExperience = require("./abstract-experience");
var _experienceTypes = require("./experience-types");
var _pageSegmentExperienceTypes = require("./page-segment-experience-types");
class UFOGlobalPageLoadExperience extends (0, _abstractExperience.UFOAbstractExperience) {
    startPageLoad(id, initial = false, startTime) {
        const result = super.start(initial ? 0 : (0, _abstractExperience.perfNowOrTimestamp)(startTime));
        this.setPageLoadId(id);
        this.initial = initial;
        return result;
    }
    updateConfig(config) {
        Object.assign(this.config, config);
    }
    setPageLoadId(id) {
        this.loadingPageLoadId = id;
    }
    async getId() {
        return this.loadingPageLoadId;
    }
    async exportData() {
        const data = await super.exportData();
        return (0, _objectSpreadProps._)((0, _objectSpread._)({}, data), {
            initial: this.initial
        });
    }
    constructor(...args){
        super(...args), this.loadingPageLoadId = 'UNKNOWN', this.type = (0, _experienceTypes.ExperienceTypes).Load, this.performanceType = (0, _experienceTypes.ExperiencePerformanceTypes).PageLoad, this.initial = true;
    }
}
const GlobalPageLoadExperience = new UFOGlobalPageLoadExperience('UFO_GLOBAL_PAGE_LOAD', {
    type: (0, _experienceTypes.ExperienceTypes).Load,
    performanceType: (0, _experienceTypes.ExperiencePerformanceTypes).PageLoad,
    // this should come from global config
    until: (0, _untilHelpers.untilAll)([
        {
            category: (0, _pageSegmentExperienceTypes.PageSegmentExperienceTypes).PRODUCT
        }
    ])
});

},{"@swc/helpers/_/_object_spread":"9gdrV","@swc/helpers/_/_object_spread_props":"kANqQ","../../utils/until-helpers":"9DUJ9","./abstract-experience":"cLvXX","./experience-types":"jNixA","./page-segment-experience-types":"5ZHiA","@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"9DUJ9":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "untilAll", ()=>untilAll);
var _logger = require("../../logger");
var _core = require("../core");
const isUntilExperience = (until)=>{
    return until.experience !== undefined;
};
const isUntilCategory = (until)=>{
    return until.category !== undefined;
};
const untilAll = (deps)=>()=>{
        const notMet = [
            ...deps
        ];
        return (data)=>{
            if (notMet.length > 0) {
                const doneIndexes = notMet.reduce((acc, dep, i)=>{
                    // validation logic
                    if (isUntilExperience(dep) && dep.experience.uuid === data.uuid) acc.push(i);
                    else if (isUntilCategory(dep) && dep.category === data.category) acc.push(i);
                    return acc;
                }, []);
                const priorityStateFound = data.state === (0, _core.UFOExperienceState).ABORTED || data.state === (0, _core.UFOExperienceState).FAILED;
                if (priorityStateFound && doneIndexes.length > 0) {
                    notMet.length = 0;
                    return {
                        done: true,
                        state: data.state
                    };
                }
                doneIndexes.reverse().forEach((i)=>{
                    notMet.splice(i, 1);
                });
                (0, _logger.ufolog)('untilAll deps left:', notMet.length, notMet);
                if (notMet.length === 0) return {
                    done: true,
                    state: (0, _core.UFOExperienceState).SUCCEEDED
                };
            }
            return {
                done: false
            };
        };
    };

},{"../../logger":"6qQp4","../core":"iLkiR","@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"5ZHiA":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "PageSegmentExperienceTypes", ()=>PageSegmentExperienceTypes);
const PageSegmentExperienceTypes = {
    NAVIGATION: 'NAVIGATION',
    PRODUCT: 'PRODUCT',
    COMPONENT: 'COMPONENT'
};

},{"@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"9P07Z":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "useUFOComponentExperience", ()=>(0, _useComponentExperience.useUFOComponentExperience));
parcelHelpers.export(exports, "ExperienceSuccess", ()=>(0, _experienceSuccess.ExperienceSuccess));
var _useComponentExperience = require("./use-component-experience");
var _experienceSuccess = require("./experience-success");

},{"./use-component-experience":"3Zmau","./experience-success":false,"@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"3Zmau":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "useUFOComponentExperience", ()=>useUFOComponentExperience);
var _react = require("react");
const useConstructor = (callback)=>{
    const hasBeenFired = (0, _react.useRef)(false);
    if (!hasBeenFired.current) {
        callback();
        hasBeenFired.current = true;
    }
    return null;
};
const useUFOComponentExperience = (experience)=>{
    (0, _react.useEffect)(()=>{
        return ()=>{
            experience.abort();
        };
    // we want this cleanup to only happen on unmount so this is a legit use of empty array
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
    useConstructor(()=>experience.start());
    return null;
};

},{"react":"ltHCL","@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"ivrci":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "Sources", ()=>Sources);
parcelHelpers.export(exports, "FileType", ()=>FileType);
parcelHelpers.export(exports, "getCommercialCategoryCacheUrlLookup", ()=>getCommercialCategoryCacheUrlLookup);
parcelHelpers.export(exports, "getCategoryCacheUrlPerimeterLookup", ()=>getCategoryCacheUrlPerimeterLookup);
parcelHelpers.export(exports, "getCategoryCacheUrlPerimeterSSR", ()=>getCategoryCacheUrlPerimeterSSR);
var _platformFeatureFlags = require("@atlaskit/platform-feature-flags");
var _types = require("../../../types");
var Sources = /*#__PURE__*/ function(Sources) {
    Sources["BIFROST"] = "bifrost";
    Sources["CLOUDFRONT_S3"] = "cloudfrontS3";
    return Sources;
}({});
var FileType = /*#__PURE__*/ function(FileType) {
    FileType["COOKIE"] = "COOKIE";
    FileType["LOCAL_STORAGE"] = "LOCAL_STORAGE";
    FileType["SESSION_STORAGE"] = "SESSION_STORAGE";
    FileType["INDEXED_DB"] = "INDEXED_DB";
    return FileType;
}({});
const generateResourcePath = (perimeter, storageType, useFlatFormat = false)=>{
    const baseBifrostCommercialPath = 'https://atlassian-cookies.prod-east.frontend.public.atl-paas.net/';
    const baseBifrostFedrampPath = 'https://atlassian-cookies.frontend.cdn.atlassian-us-gov-mod.com/';
    const fileName = useFlatFormat ? `categories_v2_${storageType}.json` : `categories_${storageType}.json`;
    switch(perimeter){
        case 'fedramp-moderate':
            return `${baseBifrostFedrampPath}${fileName}`;
        case 'commercial':
            return `${baseBifrostCommercialPath}${fileName}`;
        default:
            return `${baseBifrostCommercialPath}${fileName}`;
    }
};
const getCommercialCategoryCacheUrlLookup = (useFlatFormat = false)=>{
    return {
        [(0, _types.CategoryStorageType).Cookies]: generateResourcePath('commercial', "COOKIE", useFlatFormat),
        [(0, _types.CategoryStorageType).LocalStorage]: generateResourcePath('commercial', "LOCAL_STORAGE", useFlatFormat),
        [(0, _types.CategoryStorageType).SessionStorage]: generateResourcePath('commercial', "SESSION_STORAGE", useFlatFormat),
        [(0, _types.CategoryStorageType).IndexedDB]: generateResourcePath('commercial', "INDEXED_DB", useFlatFormat)
    };
};
const getCategoryCacheUrlPerimeterLookup = (useFlatFormat = false)=>{
    return {
        commercial: getCommercialCategoryCacheUrlLookup(useFlatFormat),
        'fedramp-moderate': {
            [(0, _types.CategoryStorageType).Cookies]: generateResourcePath('fedramp-moderate', "COOKIE", useFlatFormat),
            [(0, _types.CategoryStorageType).LocalStorage]: generateResourcePath('fedramp-moderate', "LOCAL_STORAGE", useFlatFormat),
            [(0, _types.CategoryStorageType).SessionStorage]: generateResourcePath('fedramp-moderate', "SESSION_STORAGE", useFlatFormat),
            [(0, _types.CategoryStorageType).IndexedDB]: generateResourcePath('fedramp-moderate', "INDEXED_DB", useFlatFormat)
        }
    };
};
const getCategoryCacheUrlPerimeterSSR = (source, perimeter, storageType)=>{
    const useFlatFormat = (0, _platformFeatureFlags.fg)('platform_bsc_flat_pattern_file_structure');
    return generateResourcePath(perimeter, storageType, useFlatFormat);
};

},{"@atlaskit/platform-feature-flags":"8rD2i","../../../types":"65Pa5","@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"i7ava":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "clearGlobalState", ()=>(0, _core.clearGlobalState));
parcelHelpers.export(exports, "getBscGlobalState", ()=>(0, _core.getBscGlobalState));
parcelHelpers.export(exports, "testing_overrideGlobalState", ()=>(0, _core.testing_overrideGlobalState));
parcelHelpers.export(exports, "__internalSetCacheLoadedDate", ()=>(0, _core.__internalSetCacheLoadedDate));
parcelHelpers.export(exports, "initializeGlobalState", ()=>(0, _initializeGlobalState.initializeGlobalState));
var _core = require("./core");
var _initializeGlobalState = require("./initialize-global-state");

},{"./core":"Lu8Q3","./initialize-global-state":"a7Myl","@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"a7Myl":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "initializeGlobalState", ()=>initializeGlobalState);
var _frontendFeatureEncoding = require("@atlassiansox/frontend-feature-encoding");
var _platformFeatureFlags = require("@atlaskit/platform-feature-flags");
var _types = require("../../../types");
var _loadStorageControlsData = require("../load-storage-controls-data");
var _logger = require("../logger");
var _determineLogLevel = require("../logger/determine-log-level");
var _core = require("./core");
const initializeGlobalState = ({ webStorageEnabled, indexedDbEnabled, disableWebStorageConsentChecks, packageLogLevel, allowUncategorizedCookiesInOverrides, allowUncategorizedItemsInWebStorageOverrides, allowUncategorizedItemsInIndexedDBOverrides, disableIndexedDbConsentChecks, __UNSAFE_shouldEnforceKeyForRollout, localConsentMode = false, product = 'all', perimeter = 'commercial', analyticsEnabled = true, userId, cloudId, overrideOnceParams = false } = {})=>{
    (0, _logger.Logger).debug('Initialize global state invoked');
    const productGlobalState = (0, _core.__internalGetProductGlobalState)();
    // If the app provides a value for product only in one place,
    // we want that value to be sticky and to override the default if necessary
    if ((!productGlobalState || productGlobalState == null || productGlobalState === 'all') && product) (0, _core.__internalApplyInitialState)({
        productGlobalState: product
    });
    // Treating webStorageEnabled, indexedDbEnabled, and allowUncategorizedCookiesInOverrides differently
    // because they are only passed through initializeControls and
    // we don't want it to be defaulted to false via a call from the ConsentBanner
    const webStorageControlsEnabledGlobalState = (0, _core.__internalGetWebStorageControlsEnabledGlobalState)();
    if (webStorageEnabled !== undefined && webStorageControlsEnabledGlobalState === undefined) (0, _core.__internalApplyInitialState)({
        webStorageControlsEnabledGlobalState: webStorageEnabled && !(0, _platformFeatureFlags.fg)('platform_moonjelly_bsc_master_killswitch') && !(0, _platformFeatureFlags.fg)('platform_moonjelly_bsc_web_storage_killswitch')
    });
    const indexedDbControlsEnabledGlobalState = (0, _core.__internalGetIndexedDbControlsEnabledGlobalState)();
    if (indexedDbEnabled !== undefined && indexedDbControlsEnabledGlobalState === undefined) (0, _core.__internalApplyInitialState)({
        indexedDbControlsEnabledGlobalState: indexedDbEnabled && !(0, _platformFeatureFlags.fg)('platform_moonjelly_bsc_master_killswitch') && !(0, _platformFeatureFlags.fg)('platform_moonjelly_bsc_web_storage_killswitch')
    });
    // `disableWebStorageConsentChecks` is sticky like the other controls flags above and
    // mirrors the behaviour of `disableIndexedDbConsentChecks`. When the caller does not
    // explicitly pass a value, the global state is left undefined and the public getter
    // (`getBscGlobalState`) reports `false` by default. It only takes effect when the
    // matching `webStorageEnabled` is `true` — see the consumer in `initializeControls`.
    const disableWebStorageConsentChecksGlobalState = (0, _core.__internalGetDisableWebStorageConsentChecksGlobalState)();
    if (disableWebStorageConsentChecks !== undefined && disableWebStorageConsentChecksGlobalState === undefined) (0, _core.__internalApplyInitialState)({
        disableWebStorageConsentChecksGlobalState: disableWebStorageConsentChecks
    });
    const allowUncategorizedCookiesInOverridesGlobalState = (0, _core.__internalGetAllowUncategorizedCookiesInOverridesGlobalState)();
    if (allowUncategorizedCookiesInOverrides !== undefined && allowUncategorizedCookiesInOverridesGlobalState === undefined) (0, _core.__internalApplyInitialState)({
        allowUncategorizedCookiesInOverridesGlobalState: allowUncategorizedCookiesInOverrides
    });
    // `allowUncategorizedItemsInWebStorageOverrides` is the web-storage-only counterpart to
    // `allowUncategorizedCookiesInOverrides`. It is sticky in the same way, and only takes
    // effect when web-storage controls are enabled. It does not affect cookies.
    const allowUncategorizedItemsInWebStorageOverridesGlobalState = (0, _core.__internalGetAllowUncategorizedItemsInWebStorageOverridesGlobalState)();
    if (allowUncategorizedItemsInWebStorageOverrides !== undefined && allowUncategorizedItemsInWebStorageOverridesGlobalState === undefined) (0, _core.__internalApplyInitialState)({
        allowUncategorizedItemsInWebStorageOverridesGlobalState: allowUncategorizedItemsInWebStorageOverrides
    });
    // `allowUncategorizedItemsInIndexedDBOverrides` is the IDB-only counterpart to
    // `allowUncategorizedItemsInWebStorageOverrides`. It is sticky in the same way, and only
    // takes effect when IndexedDB controls are enabled. It does not affect cookies or web storage.
    const allowUncategorizedItemsInIndexedDBOverridesGlobalState = (0, _core.__internalGetAllowUncategorizedItemsInIndexedDBOverridesGlobalState)();
    if (allowUncategorizedItemsInIndexedDBOverrides !== undefined && allowUncategorizedItemsInIndexedDBOverridesGlobalState === undefined) (0, _core.__internalApplyInitialState)({
        allowUncategorizedItemsInIndexedDBOverridesGlobalState: allowUncategorizedItemsInIndexedDBOverrides
    });
    const disableIndexedDbConsentChecksGlobalState = (0, _core.__internalGetDisableIndexedDbConsentChecksGlobalState)();
    if (disableIndexedDbConsentChecks !== undefined && disableIndexedDbConsentChecksGlobalState === undefined) (0, _core.__internalApplyInitialState)({
        disableIndexedDbConsentChecksGlobalState: disableIndexedDbConsentChecks
    });
    // Sticky on first set, mirroring the consent-check flags above.
    const __UNSAFE_shouldEnforceKeyForRolloutGlobalState = (0, _core.__internalGetShouldEnforceKeyGlobalState)();
    if (__UNSAFE_shouldEnforceKeyForRollout !== undefined && __UNSAFE_shouldEnforceKeyForRolloutGlobalState === undefined) (0, _core.__internalApplyInitialState)({
        __UNSAFE_shouldEnforceKeyForRolloutGlobalState: __UNSAFE_shouldEnforceKeyForRollout
    });
    // All other state can only be initialized once and is defaulted if not passed on the first initialization.
    // overrideOnceParams allows a subsequent call (e.g. from initializeControls) to bypass this guard
    // and re-apply these parameters, correcting values that were defaulted by an earlier accidental call
    // (e.g. from ConsentBannerImpl before initializeControls has run).
    // This behaviour is gated behind the fedramp-consent-banner-perimeter-prop feature flag.
    if ((0, _core.__internalGetHasInitialized)() && !(overrideOnceParams && (0, _platformFeatureFlags.fg)('fedramp-consent-banner-perimeter-prop'))) return;
    // Force local consent mode when ConsentHub is not enabled because ConsentHub is
    // not hydrated in the perimeter as of this comment
    const localConsentModeGlobalState = localConsentMode || !(0, _frontendFeatureEncoding.isFeatureEnabled)('consent-platform', 'consenthub');
    const cookiesCacheLoader = new (0, _loadStorageControlsData.CacheLoader)((0, _types.CategoryStorageType).Cookies, perimeter);
    const localStorageCacheLoader = new (0, _loadStorageControlsData.CacheLoader)((0, _types.CategoryStorageType).LocalStorage, perimeter);
    const sessionStorageCacheLoader = new (0, _loadStorageControlsData.CacheLoader)((0, _types.CategoryStorageType).SessionStorage, perimeter);
    const indexedDBCacheLoader = new (0, _loadStorageControlsData.CacheLoader)((0, _types.CategoryStorageType).IndexedDB, perimeter);
    const updates = {
        localConsentModeGlobalState,
        analyticsEnabledGlobalState: analyticsEnabled,
        perimeterGlobalState: perimeter,
        cookiesCacheLoader,
        localStorageCacheLoader,
        sessionStorageCacheLoader,
        indexedDBCacheLoader,
        packageLogLevelGlobalState: packageLogLevel,
        hasInitialized: true
    };
    if (cloudId) updates.cloudIdGlobalState = cloudId;
    if (userId) updates.userIdGlobalState = userId;
    (0, _core.__internalApplyInitialState)(updates);
    // Invalidate the resolved Logger level so any callers that triggered an
    // early `Logger.*` call before init pick up the new `packageLogLevel`.
    (0, _determineLogLevel.resetLogLevelCache)();
};

},{"@atlassiansox/frontend-feature-encoding":"diVt0","@atlaskit/platform-feature-flags":"8rD2i","../../../types":"65Pa5","../load-storage-controls-data":"e4S3J","../logger":"2Tk7J","../logger/determine-log-level":"bAWK3","./core":"Lu8Q3","@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"kWrwq":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "getBitValueFromBool", ()=>getBitValueFromBool);
parcelHelpers.export(exports, "getBoolFromBitValue", ()=>getBoolFromBitValue);
const getBitValueFromBool = (value)=>{
    return Number(value).toString();
};
const getBoolFromBitValue = (bitValue)=>{
    if (bitValue) return !!Number(bitValue);
};

},{"@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"6PzbS":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "fetchMessagesForLocale", ()=>(0, _fetchMessagesForLocale.fetchMessagesForLocale));
parcelHelpers.export(exports, "BSCIntlProvider", ()=>(0, _bscIntlProvider.BSCIntlProvider));
var _fetchMessagesForLocale = require("./fetch-messages-for-locale");
var _bscIntlProvider = require("./bsc-intl-provider");

},{"./fetch-messages-for-locale":false,"./bsc-intl-provider":"5dk32","@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"cPNWM":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "fetchMessagesForLocale", ()=>fetchMessagesForLocale);
parcelHelpers.export(exports, "defaultLocale", ()=>(0, _enDefault.default));
var _en = require("../../../i18n/en");
var _enDefault = parcelHelpers.interopDefault(_en);
const locales = {
    cs: ()=>require(/* webpackChunkName: "@atlaskit-internal_@atlassian/browser-storage-controls-i18n-cs" */ "5e6dde74ce246e90"),
    da: ()=>require(/* webpackChunkName: "@atlaskit-internal_@atlassian/browser-storage-controls-i18n-da" */ "5c13b8524f222706"),
    de: ()=>require(/* webpackChunkName: "@atlaskit-internal_@atlassian/browser-storage-controls-i18n-de" */ "55daf00e4080ac85"),
    'en-GB': ()=>require(/* webpackChunkName: "@atlaskit-internal_@atlassian/browser-storage-controls-i18n-en_GB" */ "259c23d7122b6428"),
    'en-ZZ': ()=>require(/* webpackChunkName: "@atlaskit-internal_@atlassian/browser-storage-controls-i18n-en_ZZ" */ "a8d124a838bf38ea"),
    en: ()=>require(/* webpackChunkName: "@atlaskit-internal_@atlassian/browser-storage-controls-i18n-en" */ "995d54983c825cae"),
    es: ()=>require(/* webpackChunkName: "@atlaskit-internal_@atlassian/browser-storage-controls-i18n-es" */ "cd16a3124209d750"),
    fi: ()=>require(/* webpackChunkName: "@atlaskit-internal_@atlassian/browser-storage-controls-i18n-fi" */ "dc574781bf43cfd1"),
    fr: ()=>require(/* webpackChunkName: "@atlaskit-internal_@atlassian/browser-storage-controls-i18n-fr" */ "7be3449e55e45423"),
    hu: ()=>require(/* webpackChunkName: "@atlaskit-internal_@atlassian/browser-storage-controls-i18n-hu" */ "d345ec0284cf0a89"),
    it: ()=>require(/* webpackChunkName: "@atlaskit-internal_@atlassian/browser-storage-controls-i18n-it" */ "27dd41d1a6e7ce95"),
    ja: ()=>require(/* webpackChunkName: "@atlaskit-internal_@atlassian/browser-storage-controls-i18n-ja" */ "3685ee9f0ba96a46"),
    ko: ()=>require(/* webpackChunkName: "@atlaskit-internal_@atlassian/browser-storage-controls-i18n-ko" */ "f1b97e36549ca1c3"),
    nb: ()=>require(/* webpackChunkName: "@atlaskit-internal_@atlassian/browser-storage-controls-i18n-nb" */ "82fb1370df183f1c"),
    nl: ()=>require(/* webpackChunkName: "@atlaskit-internal_@atlassian/browser-storage-controls-i18n-nl" */ "297737fbf8f10af7"),
    pl: ()=>require(/* webpackChunkName: "@atlaskit-internal_@atlassian/browser-storage-controls-i18n-pl" */ "a7867ab817b2a9cf"),
    'pt-BR': ()=>require(/* webpackChunkName: "@atlaskit-internal_@atlassian/browser-storage-controls-i18n-pt_BR" */ "5c8bf7d9e2db12ae"),
    ru: ()=>require(/* webpackChunkName: "@atlaskit-internal_@atlassian/browser-storage-controls-i18n-ru" */ "eccaaa67ea31d724"),
    sl: ()=>require(/* webpackChunkName: "@atlaskit-internal_@atlassian/browser-storage-controls-i18n-ru" */ "ea3db2e1ab5ed030"),
    sr_RS: ()=>require(/* webpackChunkName: "@atlaskit-internal_@atlassian/browser-storage-controls-i18n-ru" */ "a134740bf4df46b7"),
    sr_YR: ()=>require(/* webpackChunkName: "@atlaskit-internal_@atlassian/browser-storage-controls-i18n-ru" */ "7b63e96a27fefb93"),
    sv: ()=>require(/* webpackChunkName: "@atlaskit-internal_@atlassian/browser-storage-controls-i18n-sv" */ "63bee00012899425"),
    th: ()=>require(/* webpackChunkName: "@atlaskit-internal_@atlassian/browser-storage-controls-i18n-th" */ "6a6ad33d434c5a40"),
    tr: ()=>require(/* webpackChunkName: "@atlaskit-internal_@atlassian/browser-storage-controls-i18n-tr" */ "b5a8026ab495549c"),
    uk: ()=>require(/* webpackChunkName: "@atlaskit-internal_@atlassian/browser-storage-controls-i18n-uk" */ "becc1c0cf1848b63"),
    vi: ()=>require(/* webpackChunkName: "@atlaskit-internal_@atlassian/browser-storage-controls-i18n-vi" */ "5b8b4ec52a7e1893"),
    zh_TW: ()=>require(/* webpackChunkName: "@atlaskit-internal_@atlassian/browser-storage-controls-i18n-zh_TW" */ "9ff5db57e5b764f9"),
    zh: ()=>require(/* webpackChunkName: "@atlaskit-internal_@atlassian/browser-storage-controls-i18n-zh" */ "4f075d39a534bfe6")
};
const fetchMessagesForLocale = async (locale)=>{
    try {
        const messages = await locales[locale]();
        return messages.default;
    } catch (e) {
    // ignore
    }
    try {
        const parentLocale = locale.split(/[-_]/)[0];
        const messages = await locales[parentLocale]();
        return messages.default;
    } catch (e) {
    // ignore
    }
};

},{"../../../i18n/en":"5Whm0","5e6dde74ce246e90":"7YsBX","5c13b8524f222706":"310Qz","55daf00e4080ac85":"8mmoL","259c23d7122b6428":"eIg39","a8d124a838bf38ea":"7pnMD","995d54983c825cae":"gz7k4","cd16a3124209d750":"lgYj3","dc574781bf43cfd1":"7MGEn","7be3449e55e45423":"gzSLz","d345ec0284cf0a89":"d7FN7","27dd41d1a6e7ce95":"53e24","3685ee9f0ba96a46":"8HpkG","f1b97e36549ca1c3":"gpnWU","82fb1370df183f1c":"eNN5N","297737fbf8f10af7":"KsLa1","a7867ab817b2a9cf":"36kiH","5c8bf7d9e2db12ae":"jHnRJ","eccaaa67ea31d724":"ePDIN","ea3db2e1ab5ed030":"3qpDO","a134740bf4df46b7":"iKPsL","7b63e96a27fefb93":"3xLV1","63bee00012899425":"03xe4","6a6ad33d434c5a40":"3dleV","b5a8026ab495549c":"59dnB","becc1c0cf1848b63":"1CXgZ","5b8b4ec52a7e1893":"Cb6Qt","9ff5db57e5b764f9":"d6bUp","4f075d39a534bfe6":"Qajny","@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"5Whm0":[function(require,module,exports,__globalThis) {
/* prettier-ignore */ /**
 * NOTE:
 *
 * This file is automatically generated by Traduki 2.0.
 * DO NOT CHANGE IT BY HAND or your changes will be lost.
 */ var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _en = require("@atlassian/afm-i18n-platform-policy-platform-browser-storage-controls/i18n/en");
var _enDefault = parcelHelpers.interopDefault(_en);
exports.default = (0, _enDefault.default);

},{"@atlassian/afm-i18n-platform-policy-platform-browser-storage-controls/i18n/en":"dAxoZ","@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"dAxoZ":[function(require,module,exports,__globalThis) {
/* prettier-ignore */ /**
 * NOTE:
 *
 * This file is automatically generated by Traduki 2.0.
 * DO NOT CHANGE IT BY HAND or your changes will be lost.
 */ //
var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
exports.default = {
    'browser-storage-controls.consent-banner-modal.analytical.description.101024': 'Measures usage to improve product performance.',
    'browser-storage-controls.consent-banner-modal.analytical.description.101024-appify': 'Measures usage to improve app performance.',
    'browser-storage-controls.consent-banner-modal.analytical.option.082624': 'Allow analytical cookies',
    'browser-storage-controls.consent-banner-modal.cancel.button': 'Cancel',
    'browser-storage-controls.consent-banner-modal.confirm.button': 'Confirm',
    'browser-storage-controls.consent-banner-modal.functional.description.082624': 'Provides enhanced functionality and personalization.',
    'browser-storage-controls.consent-banner-modal.functional.option.082624': 'Allow functional cookies',
    'browser-storage-controls.consent-banner-modal.marketing.description.082624': 'Used for targeted advertising.',
    'browser-storage-controls.consent-banner-modal.marketing.option.082624': 'Allow marketing cookies',
    'browser-storage-controls.consent-banner-modal.strict.description.082624': "Atlassian tracks <bold>strictly necessary</bold> cookies that are essential for our products to function, so you can't adjust these. These cookies don't store personally identifiable information or track browsing habits.",
    'browser-storage-controls.consent-banner-modal.strict.description.082624-appify': "Atlassian tracks <bold>strictly necessary</bold> cookies that are essential for our apps to function, so you can't adjust these. These cookies don't store personally identifiable information or track browsing habits.",
    'browser-storage-controls.consent-banner-modal.summary.description.082624': 'Because we value your privacy, you can select which cookies you allow. {link}',
    'browser-storage-controls.consent-banner-modal.title': 'Cookie preferences',
    'browser-storage-controls.consent-banner-modal.tracking.link.082624': 'Review our cookies and tracking notice',
    'browser-storage-controls.consent-banner.accept-all.button': 'Accept all',
    'browser-storage-controls.consent-banner.cookies-description.text': 'Atlassian uses cookies to improve your browsing experience, perform analytics and research, and conduct advertising. Accept all cookies to indicate that you agree to our use of cookies on your device. {linkToCookiesTrackingNotice}',
    'browser-storage-controls.consent-banner.cookies-description.text.no.link': 'Atlassian uses cookies to improve your browsing experience, perform analytics and research, and conduct advertising. Accept all cookies to indicate that you agree to our use of cookies on your device.',
    'browser-storage-controls.consent-banner.cookies-tracking-notice.text.101024': 'Atlassian cookies and tracking notice',
    'browser-storage-controls.consent-banner.error-flag.description': 'Try again in a few minutes.',
    'browser-storage-controls.consent-banner.error-flag.title': "We're unable to update the policy",
    'browser-storage-controls.consent-banner.only-necessary.button': 'Only necessary',
    'browser-storage-controls.consent-banner.preferences.button': 'Preferences',
    'browser-storage-controls.consent-banner.success-flag.description': 'You can change this at any time in your Atlassian account.',
    'browser-storage-controls.consent-banner.success-flag.description-local-only': 'Your preferences will only affect this site.',
    'browser-storage-controls.consent-banner.success-flag.title': 'Cookie preferences saved',
    'browser-storage-controls.consent-banner.toast.error': 'Error',
    'browser-storage-controls.consent-banner.toast.success': 'Success'
};

},{"@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"7YsBX":[function(require,module,exports,__globalThis) {
module.exports = require("5586eb6081fc4c14")(require("c512fdeb7551f1c").resolve("iaIH4")).then(()=>module.bundle.root('ePskK'));

},{"5586eb6081fc4c14":"hkfCW","c512fdeb7551f1c":"l4T2r"}],"310Qz":[function(require,module,exports,__globalThis) {
module.exports = require("b1f03c37d2cc56c3")(require("9a9acabcc0d019ec").resolve("3kPL1")).then(()=>module.bundle.root('5CH6y'));

},{"b1f03c37d2cc56c3":"hkfCW","9a9acabcc0d019ec":"l4T2r"}],"8mmoL":[function(require,module,exports,__globalThis) {
module.exports = require("3a83fafca41b8332")(require("7260a968ace6acab").resolve("2swhw")).then(()=>module.bundle.root('cF3OG'));

},{"3a83fafca41b8332":"hkfCW","7260a968ace6acab":"l4T2r"}],"eIg39":[function(require,module,exports,__globalThis) {
module.exports = require("ad4f714f6df9111d")(require("943ddde09165e50f").resolve("2zYuT")).then(()=>module.bundle.root('kdQrS'));

},{"ad4f714f6df9111d":"hkfCW","943ddde09165e50f":"l4T2r"}],"7pnMD":[function(require,module,exports,__globalThis) {
module.exports = require("274366e68e4d8a70")(require("4cd7935f710227a5").resolve("4nIWO")).then(()=>module.bundle.root('2r8L6'));

},{"274366e68e4d8a70":"hkfCW","4cd7935f710227a5":"l4T2r"}],"gz7k4":[function(require,module,exports,__globalThis) {
module.exports = Promise.resolve(module.bundle.root("5Whm0"));

},{}],"lgYj3":[function(require,module,exports,__globalThis) {
module.exports = require("c9e93314692bab8c")(require("d400edf326f69951").resolve("2c8Qy")).then(()=>module.bundle.root('3qt2k'));

},{"c9e93314692bab8c":"hkfCW","d400edf326f69951":"l4T2r"}],"7MGEn":[function(require,module,exports,__globalThis) {
module.exports = require("d169ddb38cbbc2c0")(require("94bdf52976900eba").resolve("hal3j")).then(()=>module.bundle.root('ehYJt'));

},{"d169ddb38cbbc2c0":"hkfCW","94bdf52976900eba":"l4T2r"}],"gzSLz":[function(require,module,exports,__globalThis) {
module.exports = require("bd07f16dd095b74f")(require("b602b6ad65962ced").resolve("6G4Hy")).then(()=>module.bundle.root('iJWo9'));

},{"bd07f16dd095b74f":"hkfCW","b602b6ad65962ced":"l4T2r"}],"d7FN7":[function(require,module,exports,__globalThis) {
module.exports = require("f26d9dadc82680fa")(require("9ac1b6e451e36d17").resolve("93XCP")).then(()=>module.bundle.root('iWz64'));

},{"f26d9dadc82680fa":"hkfCW","9ac1b6e451e36d17":"l4T2r"}],"53e24":[function(require,module,exports,__globalThis) {
module.exports = require("6080f8cff8b8ce91")(require("4d87c1cf39b79dca").resolve("7ge5b")).then(()=>module.bundle.root('2SL8O'));

},{"6080f8cff8b8ce91":"hkfCW","4d87c1cf39b79dca":"l4T2r"}],"8HpkG":[function(require,module,exports,__globalThis) {
module.exports = require("9766c1af2c4de21d")(require("41d96d7d483a14f9").resolve("fiYDp")).then(()=>module.bundle.root('58fOI'));

},{"9766c1af2c4de21d":"hkfCW","41d96d7d483a14f9":"l4T2r"}],"gpnWU":[function(require,module,exports,__globalThis) {
module.exports = require("941de7612dc30cf2")(require("9d5804810e158f2").resolve("jHpYi")).then(()=>module.bundle.root('5y3XC'));

},{"941de7612dc30cf2":"hkfCW","9d5804810e158f2":"l4T2r"}],"eNN5N":[function(require,module,exports,__globalThis) {
module.exports = require("5639bd77a0872d16")(require("b066ab690769f069").resolve("bK7Sc")).then(()=>module.bundle.root('i69LO'));

},{"5639bd77a0872d16":"hkfCW","b066ab690769f069":"l4T2r"}],"KsLa1":[function(require,module,exports,__globalThis) {
module.exports = require("7791fbc5176fbc27")(require("e53d18436ccf85b9").resolve("5thKH")).then(()=>module.bundle.root('7hwnl'));

},{"7791fbc5176fbc27":"hkfCW","e53d18436ccf85b9":"l4T2r"}],"36kiH":[function(require,module,exports,__globalThis) {
module.exports = require("88a7f18e46988eea")(require("998488efd1da6f6b").resolve("kFmKj")).then(()=>module.bundle.root('a53Gz'));

},{"88a7f18e46988eea":"hkfCW","998488efd1da6f6b":"l4T2r"}],"jHnRJ":[function(require,module,exports,__globalThis) {
module.exports = require("579b31f0e3f89f5a")(require("a8a3190417f19694").resolve("2y14J")).then(()=>module.bundle.root('8Zsd2'));

},{"579b31f0e3f89f5a":"hkfCW","a8a3190417f19694":"l4T2r"}],"ePDIN":[function(require,module,exports,__globalThis) {
module.exports = require("8bcc5edeb38e73a4")(require("fc061011c05744b9").resolve("joUo3")).then(()=>module.bundle.root('7BZCB'));

},{"8bcc5edeb38e73a4":"hkfCW","fc061011c05744b9":"l4T2r"}],"3qpDO":[function(require,module,exports,__globalThis) {
module.exports = require("5b17c108ddfa7920")(require("d46a942a75fbd102").resolve("89n9e")).then(()=>module.bundle.root('82lrY'));

},{"5b17c108ddfa7920":"hkfCW","d46a942a75fbd102":"l4T2r"}],"iKPsL":[function(require,module,exports,__globalThis) {
module.exports = require("e0efd66ba0f88666")(require("9968d5069a58470d").resolve("a3sIR")).then(()=>module.bundle.root('aIXWM'));

},{"e0efd66ba0f88666":"hkfCW","9968d5069a58470d":"l4T2r"}],"3xLV1":[function(require,module,exports,__globalThis) {
module.exports = require("9018730d1117c377")(require("43224af629f736f5").resolve("1QW45")).then(()=>module.bundle.root('jiHtJ'));

},{"9018730d1117c377":"hkfCW","43224af629f736f5":"l4T2r"}],"03xe4":[function(require,module,exports,__globalThis) {
module.exports = require("4d26f044cb6227c")(require("1de26f6fd1a0cf16").resolve("hSSKC")).then(()=>module.bundle.root('k7Kks'));

},{"4d26f044cb6227c":"hkfCW","1de26f6fd1a0cf16":"l4T2r"}],"3dleV":[function(require,module,exports,__globalThis) {
module.exports = require("5e5adaf3e7332312")(require("43334d599c0c3ba0").resolve("4J9xq")).then(()=>module.bundle.root('lgxs5'));

},{"5e5adaf3e7332312":"hkfCW","43334d599c0c3ba0":"l4T2r"}],"59dnB":[function(require,module,exports,__globalThis) {
module.exports = require("dbc8020d51933d76")(require("4b9fe3905799a4ab").resolve("5MYS6")).then(()=>module.bundle.root('h2eyo'));

},{"dbc8020d51933d76":"hkfCW","4b9fe3905799a4ab":"l4T2r"}],"1CXgZ":[function(require,module,exports,__globalThis) {
module.exports = require("a8fa431420fcebdb")(require("316550be8dccd0fd").resolve("7Hn72")).then(()=>module.bundle.root('cvpiW'));

},{"a8fa431420fcebdb":"hkfCW","316550be8dccd0fd":"l4T2r"}],"Cb6Qt":[function(require,module,exports,__globalThis) {
module.exports = require("8a2e35ac0df88d9f")(require("20b4b95a22f14a1e").resolve("fdcZ3")).then(()=>module.bundle.root('205ls'));

},{"8a2e35ac0df88d9f":"hkfCW","20b4b95a22f14a1e":"l4T2r"}],"d6bUp":[function(require,module,exports,__globalThis) {
module.exports = require("33af138d2ff8bf76")(require("2b2dbb95f980b882").resolve("bbjmy")).then(()=>module.bundle.root('gIpsK'));

},{"33af138d2ff8bf76":"hkfCW","2b2dbb95f980b882":"l4T2r"}],"Qajny":[function(require,module,exports,__globalThis) {
module.exports = require("abef2692acc265f7")(require("41ff51b3cb6aa3ee").resolve("9gvOi")).then(()=>module.bundle.root('6mqKb'));

},{"abef2692acc265f7":"hkfCW","41ff51b3cb6aa3ee":"l4T2r"}],"5dk32":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "BSCIntlProvider", ()=>BSCIntlProvider);
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _intlMessagesProvider = require("@atlaskit/intl-messages-provider");
var _fetchMessagesForLocale = require("./fetch-messages-for-locale");
const BSCIntlProvider = ({ children })=>{
    return /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _intlMessagesProvider.IntlMessagesProvider), {
        defaultMessages: (0, _fetchMessagesForLocale.defaultLocale),
        loaderFn: (0, _fetchMessagesForLocale.fetchMessagesForLocale)
    }, children);
};

},{"react":"ltHCL","@atlaskit/intl-messages-provider":"3aUDY","./fetch-messages-for-locale":"cPNWM","@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"3aUDY":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "IntlMessagesProvider", ()=>(0, _indexDefault.default));
var _index = require("./ui/index");
var _indexDefault = parcelHelpers.interopDefault(_index);

},{"./ui/index":"8nnju","@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"8nnju":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>(0, _mainDefault.default));
var _main = require("./main");
var _mainDefault = parcelHelpers.interopDefault(_main);

},{"./main":"6yJgF","@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"6yJgF":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>IntlMessagesProvider);
var _objectSpread = require("@swc/helpers/_/_object_spread");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _reactIntl = require("react-intl");
var _useMessages = require("../services/use-messages");
var _useSafeIntl = require("../services/use-safe-intl");
function IntlMessagesProvider({ loaderFn, children, defaultMessages }) {
    const intl = (0, _useSafeIntl.useSafeIntl)();
    const messages = (0, _useMessages.useMessages)(intl.locale, loaderFn);
    /**
	 * IntlProvider does not inherit from upstream IntlProviders,
	 * we lookup messages in the Intl context (via useSafeIntl) and pass them downstream
	 * This prevents the missing messages error.
	 */ const mergedMessages = (0, _react.useMemo)(()=>{
        return (0, _objectSpread._)({}, defaultMessages, intl.messages, messages);
    }, [
        intl.messages,
        messages,
        defaultMessages
    ]);
    return /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _reactIntl.IntlProvider), {
        defaultLocale: "en",
        locale: intl.locale,
        onError: intl.onError,
        messages: mergedMessages
    }, children);
}

},{"@swc/helpers/_/_object_spread":"9gdrV","react":"ltHCL","react-intl":"f41fF","../services/use-messages":"gNxFP","../services/use-safe-intl":"2AFze","@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"gNxFP":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "useMessages", ()=>useMessages);
var _react = require("react");
var _constants = require("../../common/constants");
function useMessages(locale, loaderFn) {
    const [localeState, setLocaleState] = (0, _react.useState)((0, _constants.DEFAULT_LOCALE_STATE));
    const loadedLocaleRef = (0, _react.useRef)(localeState.locale);
    (0, _react.useEffect)(()=>{
        // Skip if we already have messages for this locale
        if (locale === loadedLocaleRef.current) return;
        let current = true;
        loaderFn(locale).then((messages)=>{
            if (current) {
                loadedLocaleRef.current = locale;
                setLocaleState({
                    locale,
                    messages: messages !== null && messages !== void 0 ? messages : {}
                });
            }
        }, (error)=>{
            // Handle or log error appropriately
            console.error('Failed to load i18n messages via intl-messages-provider', error);
        });
        return ()=>{
            current = false;
        };
    }, [
        loaderFn,
        locale
    ]);
    return localeState.messages;
}

},{"react":"ltHCL","../../common/constants":"6jwl2","@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"6jwl2":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "DEFAULT_LOCALE_STATE", ()=>DEFAULT_LOCALE_STATE);
const DEFAULT_LOCALE_STATE = {
    locale: 'en-US',
    messages: undefined
};

},{"@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"2AFze":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "useSafeIntl", ()=>useSafeIntl);
var _react = require("react");
var _reactIntl = require("react-intl");
var _constants = require("../../common/constants");
// Prevents memory leaks
const cache = (0, _reactIntl.createIntlCache)();
const useSafeIntl = ()=>{
    const context = (0, _react.useContext)((0, _reactIntl.IntlContext));
    if (!context) return (0, _reactIntl.createIntl)((0, _constants.DEFAULT_LOCALE_STATE), cache);
    return context;
};

},{"react":"ltHCL","react-intl":"f41fF","../../common/constants":"6jwl2","@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"9FHD5":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "LEGACY_ATLASSIAN_GDPR_COOKIE_KEY", ()=>LEGACY_ATLASSIAN_GDPR_COOKIE_KEY);
parcelHelpers.export(exports, "ATLASSIAN_CONSENT_COOKIE_KEY", ()=>ATLASSIAN_CONSENT_COOKIE_KEY);
parcelHelpers.export(exports, "ATLASSIAN_SHOW_BANNER_COOKIE_KEY", ()=>ATLASSIAN_SHOW_BANNER_COOKIE_KEY);
parcelHelpers.export(exports, "ATLASSIAN_CURRENT_LOCALE_COOKIE_KEY", ()=>ATLASSIAN_CURRENT_LOCALE_COOKIE_KEY);
parcelHelpers.export(exports, "ATLASSIAN_CONSENT_FALLBACK_COOKIE_KEY", ()=>ATLASSIAN_CONSENT_FALLBACK_COOKIE_KEY);
parcelHelpers.export(exports, "TESTING_TOKEN_OVERRIDE_COOKIE_KEY", ()=>TESTING_TOKEN_OVERRIDE_COOKIE_KEY);
parcelHelpers.export(exports, "ATLASSIAN_BANNER_LAST_DISMISSED_TIME_COOKIE_KEY", ()=>ATLASSIAN_BANNER_LAST_DISMISSED_TIME_COOKIE_KEY);
parcelHelpers.export(exports, "ACCEPT_ALL_PREFERENCES", ()=>ACCEPT_ALL_PREFERENCES);
parcelHelpers.export(exports, "ONLY_NECESSARY_PREFERENCES", ()=>ONLY_NECESSARY_PREFERENCES);
parcelHelpers.export(exports, "DEFAULT_PREFERENCES", ()=>DEFAULT_PREFERENCES);
parcelHelpers.export(exports, "V001_SCHEMA_KEY", ()=>V001_SCHEMA_KEY);
parcelHelpers.export(exports, "V002_SCHEMA_KEY", ()=>V002_SCHEMA_KEY);
parcelHelpers.export(exports, "V003_SCHEMA_KEY", ()=>V003_SCHEMA_KEY);
var _objectSpread = require("@swc/helpers/_/_object_spread");
var _objectSpreadProps = require("@swc/helpers/_/_object_spread_props");
var _types = require("./types");
const LEGACY_ATLASSIAN_GDPR_COOKIE_KEY = 'atl-gdpr-consent';
const ATLASSIAN_CONSENT_COOKIE_KEY = 'atl-bsc-consent-token';
const ATLASSIAN_SHOW_BANNER_COOKIE_KEY = 'atl-bsc-show-banner';
const ATLASSIAN_CURRENT_LOCALE_COOKIE_KEY = 'atl-bsc-current-locale';
const ATLASSIAN_CONSENT_FALLBACK_COOKIE_KEY = 'atl-bsc-consent-token-fallback';
const TESTING_TOKEN_OVERRIDE_COOKIE_KEY = 'atl-testing-consents';
const ATLASSIAN_BANNER_LAST_DISMISSED_TIME_COOKIE_KEY = 'atl-bsc-banner-dismissed-time';
const ACCEPT_ALL_PREFERENCES = {
    [(0, _types.PreferenceCategory).StrictlyNecessary]: true,
    [(0, _types.PreferenceCategory).Functional]: true,
    [(0, _types.PreferenceCategory).Marketing]: true,
    [(0, _types.PreferenceCategory).Analytics]: true,
    [(0, _types.PreferenceCategory).Unknown]: true
};
const ONLY_NECESSARY_PREFERENCES = {
    [(0, _types.PreferenceCategory).StrictlyNecessary]: true,
    [(0, _types.PreferenceCategory).Functional]: false,
    [(0, _types.PreferenceCategory).Marketing]: false,
    [(0, _types.PreferenceCategory).Analytics]: false,
    [(0, _types.PreferenceCategory).Unknown]: false
};
const DEFAULT_PREFERENCES = (0, _objectSpreadProps._)((0, _objectSpread._)({}, ONLY_NECESSARY_PREFERENCES), {
    [(0, _types.ContextualConsentProperty).ConsentsAreDefault]: true,
    [(0, _types.ContextualConsentProperty).UserIsAuthenticated]: false,
    [(0, _types.ContextualConsentProperty).ConsentDataUnavailable]: true
});
const V001_SCHEMA_KEY = '001';
const V002_SCHEMA_KEY = '002';
const V003_SCHEMA_KEY = '003';

},{"@swc/helpers/_/_object_spread":"9gdrV","@swc/helpers/_/_object_spread_props":"kANqQ","./types":"65Pa5","@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"7HiHV":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "deleteCookie", ()=>(0, _deleteCookie.deleteCookie));
parcelHelpers.export(exports, "getCookie", ()=>(0, _getCookie.getCookie));
parcelHelpers.export(exports, "setCookie", ()=>(0, _setCookie.setCookie));
parcelHelpers.export(exports, "setStrictlyNecessaryCookie", ()=>(0, _setStrictlyNecessaryCookie.setStrictlyNecessaryCookie));
parcelHelpers.export(exports, "packUserPreferences", ()=>(0, _transformer.packUserPreferences));
parcelHelpers.export(exports, "unpackUserPreferencesCookie", ()=>(0, _transformer.unpackUserPreferencesCookie));
parcelHelpers.export(exports, "initializeControls", ()=>(0, _initializeControls.initializeControls));
var _deleteCookie = require("./delete-cookie");
var _getCookie = require("./get-cookie");
var _initializeControls = require("./initialize-controls");
var _setCookie = require("./set-cookie");
var _setStrictlyNecessaryCookie = require("./set-strictly-necessary-cookie");
var _transformer = require("./transformer");

},{"./delete-cookie":"3d8Bf","./get-cookie":"VS0K5","./initialize-controls":"7EKgM","./set-cookie":"2fr8b","./set-strictly-necessary-cookie":"dUkaQ","./transformer":"hcsh1","@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"3d8Bf":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "deleteCookie", ()=>deleteCookie);
var _jsCookie = require("js-cookie");
var _jsCookieDefault = parcelHelpers.interopDefault(_jsCookie);
var _platformFeatureFlags = require("@atlaskit/platform-feature-flags");
var _utils = require("../../../common/utils");
var _logger = require("../../../common/utils/logger");
const deleteCookie = (key, attributes)=>{
    if ((0, _platformFeatureFlags.fg)('platform_moonjelly_bsc_master_killswitch')) // Delete the cookie without package operational events
    // when master killswitch is enabled
    (0, _jsCookieDefault.default).remove(key, attributes);
    else try {
        (0, _utils.sendPackageOperationalEvent)({
            action: 'usedDeleteCookie',
            attributes: {
                cookieKey: key
            }
        });
        (0, _jsCookieDefault.default).remove(key, attributes);
    } catch (e) {
        (0, _logger.Logger).errorWithOperationalEvent({
            action: 'usedDeleteCookieError',
            attributes: {
                cookieKey: key
            },
            message: `Failed to use delete cookie. ${e.message || ''}`
        });
    }
};

},{"js-cookie":"brgOH","@atlaskit/platform-feature-flags":"8rD2i","../../../common/utils":"gnWyu","../../../common/utils/logger":"2Tk7J","@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"VS0K5":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "getCookie", ()=>getCookie);
var _jsCookie = require("js-cookie");
var _jsCookieDefault = parcelHelpers.interopDefault(_jsCookie);
var _platformFeatureFlags = require("@atlaskit/platform-feature-flags");
var _utils = require("../../../common/utils");
var _logger = require("../../../common/utils/logger");
function getCookie(key) {
    if ((0, _platformFeatureFlags.fg)('platform_moonjelly_bsc_master_killswitch')) // Get the cookie without package operational events
    // when master killswitch is enabled
    return key ? (0, _jsCookieDefault.default).get(key) : (0, _jsCookieDefault.default).get();
    try {
        (0, _utils.sendPackageOperationalEvent)({
            action: 'usedGetCookie',
            attributes: {
                cookieKey: key
            }
        });
        return key ? (0, _jsCookieDefault.default).get(key) : (0, _jsCookieDefault.default).get();
    } catch (e) {
        (0, _logger.Logger).errorWithOperationalEvent({
            action: 'usedGetCookieError',
            attributes: {
                cookieKey: key
            },
            message: `Failed to use get cookie. ${e.message || ''}`
        });
    }
}

},{"js-cookie":"brgOH","@atlaskit/platform-feature-flags":"8rD2i","../../../common/utils":"gnWyu","../../../common/utils/logger":"2Tk7J","@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"7EKgM":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "initializeControls", ()=>initializeControls);
parcelHelpers.export(exports, "createDocumentCookiePassthrough", ()=>(0, _createDocumentCookiePassthrough.createDocumentCookiePassthrough));
parcelHelpers.export(exports, "createIndexedDBPassthrough", ()=>(0, _createIndexedDbPassthrough.createIndexedDBPassthrough));
parcelHelpers.export(exports, "createWebStoragePassthrough", ()=>(0, _createWebStoragePassthrough.createWebStoragePassthrough));
var _objectSpread = require("@swc/helpers/_/_object_spread");
var _objectSpreadProps = require("@swc/helpers/_/_object_spread_props");
var _platformFeatureFlags = require("@atlaskit/platform-feature-flags");
var _utils = require("../../../common/utils");
var _bscGlobalState = require("../../../common/utils/bsc-global-state");
var _webStorageService = require("../../../services/web-storage-service");
var _cleanupStorage = require("../cleanup-storage");
var _createDocumentCookiePassthrough = require("./create-document-cookie-passthrough");
var _createIndexedDbPassthrough = require("./create-indexed-db-passthrough");
var _createWebStoragePassthrough = require("./create-web-storage-passthrough");
const initializeControls = async (args = {
    analyticsEnabled: true
})=>{
    if ((0, _platformFeatureFlags.fg)('platform_moonjelly_bsc_master_killswitch')) return undefined;
    let initResult;
    try {
        (0, _utils.Logger).debug('initializeControls invoked');
        if ((0, _platformFeatureFlags.fg)('fedramp-consent-banner-perimeter-prop')) (0, _bscGlobalState.initializeGlobalState)((0, _objectSpreadProps._)((0, _objectSpread._)({}, args), {
            overrideOnceParams: true
        }));
        else (0, _bscGlobalState.initializeGlobalState)(args);
        if ((0, _utils.isSSR)()) return undefined;
        if ((0, _platformFeatureFlags.fg)('platform_bsc_initialize_controls_analytics')) (0, _utils.sendPackageOperationalEvent)({
            action: 'bscInitControlsParameters',
            attributes: {
                product: args.product,
                analyticsEnabled: args.analyticsEnabled,
                flagEnabled: args.flagEnabled,
                webStorageEnabled: args.webStorageEnabled,
                indexedDbEnabled: args.indexedDbEnabled,
                disableWebStorageConsentChecks: args.disableWebStorageConsentChecks,
                disableIndexedDbConsentChecks: args.disableIndexedDbConsentChecks,
                allowUncategorizedCookiesInOverrides: args.allowUncategorizedCookiesInOverrides,
                allowUncategorizedItemsInWebStorageOverrides: args.allowUncategorizedItemsInWebStorageOverrides,
                allowUncategorizedItemsInIndexedDBOverrides: args.allowUncategorizedItemsInIndexedDBOverrides,
                perimeter: args.perimeter,
                hasShouldEnforceKeyCallback: !!args.__UNSAFE_shouldEnforceKeyForRollout
            }
        });
        // Ensures that the AWC is constructed before overwriting any native methods.
        const analyticsWebClientInstance = (0, _utils.getAnalyticsClient)();
        // If AWC is not initialized, it will be undefined
        const isAnalyticsInitialized = !!analyticsWebClientInstance;
        if (args.analyticsEnabled && !isAnalyticsInitialized) throw new Error(`Failed to initialize AnalyticsWebClient. Analytics logging will not be set for native method overrides.`);
        await (0, _createDocumentCookiePassthrough.createDocumentCookiePassthrough)();
        const isWebStorageControlsEnabled = (0, _bscGlobalState.getBscGlobalState)().webStorageEnabled;
        if (isWebStorageControlsEnabled) {
            await (0, _createWebStoragePassthrough.createWebStoragePassthrough)((0, _webStorageService.WebStorageType).LocalStorage);
            await (0, _createWebStoragePassthrough.createWebStoragePassthrough)((0, _webStorageService.WebStorageType).SessionStorage);
        }
        const isIndexedDbEnabled = (0, _bscGlobalState.getBscGlobalState)().indexedDbEnabled;
        if (isIndexedDbEnabled) {
            var _getBscGlobalState_disableIndexedDbConsentChecks;
            const disableIndexedDbConsentChecks = (_getBscGlobalState_disableIndexedDbConsentChecks = (0, _bscGlobalState.getBscGlobalState)().disableIndexedDbConsentChecks) !== null && _getBscGlobalState_disableIndexedDbConsentChecks !== void 0 ? _getBscGlobalState_disableIndexedDbConsentChecks : false;
            if ((0, _platformFeatureFlags.fg)('jfp-magma-selective-storage-enforcement')) {
                const __UNSAFE_shouldEnforceKeyForRollout = (0, _bscGlobalState.getBscGlobalState)().__UNSAFE_shouldEnforceKeyForRollout;
                // `__UNSAFE_shouldEnforceKeyForRollout` needs the consent-checking override installed to do
                // per-key re-enforcement at call time.
                await (0, _createIndexedDbPassthrough.createIndexedDBPassthrough)({
                    performConsentChecks: !disableIndexedDbConsentChecks || __UNSAFE_shouldEnforceKeyForRollout !== undefined
                });
            } else await (0, _createIndexedDbPassthrough.createIndexedDBPassthrough)({
                performConsentChecks: !disableIndexedDbConsentChecks
            });
        }
        (0, _utils.Logger).debug('initializeControls finished');
        if ((0, _platformFeatureFlags.fg)('platform_bsc_cleanup_revoked_storage')) {
            const storageCleanupPromise = (0, _cleanupStorage.cleanupStorage)();
            initResult = Object.assign(initResult !== null && initResult !== void 0 ? initResult : {}, {
                storageCleanupPromise
            });
        }
    } catch (e) {
        (0, _utils.Logger).errorWithOperationalEvent({
            action: 'initializeControlsError',
            message: `Failed to initialize browser storage controls. ${e.message || ''}`
        });
    }
    return initResult;
};

},{"@swc/helpers/_/_object_spread":"9gdrV","@swc/helpers/_/_object_spread_props":"kANqQ","@atlaskit/platform-feature-flags":"8rD2i","../../../common/utils":"gnWyu","../../../common/utils/bsc-global-state":"i7ava","../../../services/web-storage-service":"d0pCe","../cleanup-storage":"32cX9","./create-document-cookie-passthrough":"jQuSQ","./create-indexed-db-passthrough":"4pzNo","./create-web-storage-passthrough":"3jY2c","@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"d0pCe":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "findStorageTarget", ()=>findStorageTarget);
parcelHelpers.export(exports, "AtlBrowserStorage", ()=>AtlBrowserStorage);
parcelHelpers.export(exports, "AtlBrowserStorageSession", ()=>AtlBrowserStorageSession);
parcelHelpers.export(exports, "AtlBrowserStorageLocal", ()=>AtlBrowserStorageLocal);
parcelHelpers.export(exports, "WebStorageType", ()=>(0, _types1.WebStorageType));
var _platformFeatureFlags = require("@atlaskit/platform-feature-flags");
var _utils = require("../../common/utils");
var _logger = require("../../common/utils/logger");
var _types = require("../../types");
var _indexedDbService = require("../indexed-db-service");
var _types1 = require("./types");
var _utils1 = require("./utils");
class AtlBrowserStorage {
    get isWebStorageEnabled() {
        // Note: outside of user configuration, webStorageEnabled is also feature gated by
        // 1. platform_moonjelly_bsc_master_killswitch
        // 2. platform_moonjelly_bsc_web_storage_killswitch
        if ((0, _utils.getBscGlobalState)().webStorageEnabled) return true;
        (0, _logger.Logger).debug('WebStorage config is disabled, cannot proceed.');
        return false;
    }
    // Core API
    getItem(key) {
        if (!this.isWebStorageEnabled) return this.storage.getItem(key);
        if (!this.isAvailable) {
            // If our storage hasn't been enabled, short-circuit because we can't use the native utility
            (0, _logger.Logger).warn(`${this.storageType} is unavailable. Failed to get item ${key}`);
            return null;
        }
        const retrievedItem = (0, _utils1.getStorageItem)(key, this.storageType, this.storage);
        return retrievedItem;
    }
    async setItem(key, value) {
        if (!this.isWebStorageEnabled) {
            this.storage.setItem(key, value);
            return {
                status: (0, _types.Status).SUCCESS
            };
        }
        if (!this.isAvailable) {
            // If our storage hasn't been enabled, short-circuit because we can't use the native utility
            (0, _logger.Logger).warn(`${this.storageType} is unavailable. Failed to set item ${key}`);
            return {
                status: (0, _types.Status).ERROR,
                error: new Error(`${this.storageType} is unavailable. Failed to set item ${key}`)
            };
        }
        const globalStateProduct = (0, _utils.getBscGlobalState)().product;
        const wasInitialized = (0, _utils.getBscGlobalState)().hasInitialized;
        // IMPORTANT: do not await above this line - if you do it will cause reading after writing to not return the new value until the microtask queue is drained, instead of just those that need to wait for remote fetch.
        const itemSetResult = await (0, _utils1.setStorageItem)(key, value, this.storageType, globalStateProduct, this.storage);
        if (!wasInitialized && (0, _platformFeatureFlags.fg)('platform_bsc_initialize_controls_analytics')) (0, _utils.sendPackageOperationalEvent)({
            action: 'setItemWithoutInit',
            attributes: {
                itemKey: key,
                storageType: this.storageType
            }
        });
        if (itemSetResult.status === (0, _types.Status).SUCCESS) (0, _logger.Logger).debug(`Successfully set item ${key} with value ${value}`);
        else if (itemSetResult.status === (0, _types.Status).BLOCKED) {
            // Only an actual block is described as "blocked" — errors are surfaced (and logged)
            // upstream in setStorageItem's catch blocks via Logger.errorWithOperationalEvent.
            (0, _logger.Logger).debug(`Blocked setting item ${key}`);
            const productSuffix = globalStateProduct ? ` for product "${globalStateProduct}"` : '';
            if (itemSetResult.blockedItemCategory === null) // Async path with confirmed cause: key is not registered.
            (0, _logger.Logger).warn(`${this.storageType}.setItem('${key}', ...) was blocked${productSuffix}` + `: '${key}' is not registered in the BSC data store. Add it to the data store before calling this API.`);
            else if (itemSetResult.blockedItemCategory === undefined) // MaybeSync path: cause not available. State only what we know.
            (0, _logger.Logger).warn(`${this.storageType}.setItem('${key}', ...) was blocked${productSuffix}.`);
        }
        return itemSetResult;
    }
    setStrictlyNecessaryItem(key, value) {
        if (!this.isWebStorageEnabled) {
            this.storage.setItem(key, value);
            return;
        }
        if (!this.isAvailable) {
            // If our storage hasn't been enabled, short-circuit because we can't use the native utility
            (0, _logger.Logger).warn(`${this.storageType} is unavailable. Failed to set strictly necessary item ${key}`);
            return;
        }
        const itemSetStatus = (0, _utils1.setStrictlyNecessaryStorageItem)(key, value, this.storageType, this.storage);
        if (!(0, _utils.getBscGlobalState)().hasInitialized && (0, _platformFeatureFlags.fg)('platform_bsc_initialize_controls_analytics')) (0, _utils.sendPackageOperationalEvent)({
            action: 'setItemWithoutInit',
            attributes: {
                itemKey: key,
                storageType: this.storageType
            }
        });
        (0, _logger.Logger).debug(`${itemSetStatus === (0, _types.Status).SUCCESS ? 'Successfully' : 'Failed to'} set strictly necessary item ${key} with value ${value}`);
    }
    // Native Utilities
    removeItem(key) {
        if (!this.isAvailable) {
            // If our storage hasn't been enabled, short-circuit because we can't use the native utility
            (0, _logger.Logger).warn(`${this.storageType} is unavailable. Failed to remove item ${key}`);
            return;
        }
        this.storage.removeItem(key);
    }
    key(index) {
        if (!this.isAvailable) return null;
        return this.storage.key(index);
    }
    length() {
        if (!this.isAvailable) return 0;
        return this.storage.length;
    }
    clear() {
        if (!this.isAvailable) return;
        this.storage.clear();
    }
    // Utilities
    isStorageAvailable() {
        if ((0, _utils.isSSR)()) return false;
        try {
            const x = '__storage_test__';
            this.storage.setItem(x, x);
            this.storage.removeItem(x);
            return true;
        } catch (e) {
            return e instanceof DOMException && // everything except Firefox
            (e.code === 22 || // Firefox
            e.code === 1014 || // test name field too, because code might not be present
            // everything except Firefox
            e.name === 'QuotaExceededError' || // Firefox
            e.name === 'NS_ERROR_DOM_QUOTA_REACHED') && // acknowledge QuotaExceededError only if there's something already stored
            this.storage && this.storage.length !== 0;
        }
    }
    constructor(storage, storageType){
        this.isAvailable = false;
        this.checkIfSetByPackage = async ({ itemKey, isSetCallback = ()=>{}, isNotSetCallback = ()=>{} })=>{
            // As IDB is asynchronous in nature, when this in invoked, we need to rely on the callbacks
            // to actually do something with the result.
            try {
                const record = await (0, _indexedDbService.BSCIndexedDB).getRecord(itemKey);
                if (record) {
                    isSetCallback();
                    return true;
                } else {
                    isNotSetCallback();
                    return false;
                }
            } catch (e) {
                // If it fails to pull from IDB, we can't validate that it's been set by our package or not, so log the error
                // and assume it hasn't been set by our package. This will only impact our analytics correctness.
                (0, _logger.Logger).errorWithOperationalEvent({
                    action: 'usedCheckIfSetByPackageError',
                    message: `IDB lookup failed to check if item was set by package. ${e.message || ''}`,
                    attributes: {
                        itemKey
                    }
                });
                isNotSetCallback();
                return false;
            }
        };
        this.storage = storage;
        this.storageType = storageType;
        this.isAvailable = this.isStorageAvailable();
    }
}
const AtlBrowserStorageLocal = new AtlBrowserStorage(// eslint-disable-next-line @atlaskit/platform/no-direct-web-storage-usage -- existing usage
globalThis.localStorage, (0, _types1.WebStorageType).LocalStorage);
const AtlBrowserStorageSession = new AtlBrowserStorage(// eslint-disable-next-line @atlaskit/platform/no-direct-web-storage-usage -- existing usage
globalThis.sessionStorage, (0, _types1.WebStorageType).SessionStorage);
const findStorageTarget = (type)=>{
    return ({
        [(0, _types1.WebStorageType).LocalStorage]: AtlBrowserStorageLocal,
        [(0, _types1.WebStorageType).SessionStorage]: AtlBrowserStorageSession
    })[type];
};

},{"@atlaskit/platform-feature-flags":"8rD2i","../../common/utils":"gnWyu","../../common/utils/logger":"2Tk7J","../../types":"65Pa5","../indexed-db-service":"1A0ES","./types":"1dILA","./utils":"5ncRa","@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"1A0ES":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "BSCIndexedDB", ()=>BSCIndexedDB);
parcelHelpers.export(exports, "IndexedDBService", ()=>IndexedDBService);
var _utils = require("../../common/utils");
var _logger = require("../../common/utils/logger");
class IndexedDBService {
    async boot() {
        if (!this.isAvailable) {
            (0, _logger.Logger).warn('IndexedDB is not available');
            return;
        }
        if (this.isBooted) // Short circuit if we've already booted once
        return;
        // Only boot once, even if we've been called numerous times sequentially
        if (!this.bootUpPromiseCache) {
            this.bootUpPromiseCache = this.openDB();
            try {
                await this.bootUpPromiseCache;
                this.isBooted = true;
            } catch (e) {
                this.isBooted = false;
                (0, _logger.Logger).warn('Error booting up IndexedDB.');
                throw e;
            }
        }
    }
    getIsDBAvailable() {
        return !(0, _utils.isSSR)() && !!window.indexedDB;
    }
    async openDB() {
        const openPromise = new Promise((resolve, reject)=>{
            let request = indexedDB.open(this.dbName, 2);
            request.onerror = this.onConnectionErrorHandler(reject);
            request.onsuccess = this.onConnectionSuccessHandler(request, resolve);
            request.onupgradeneeded = this.onConnectionUpgradeNeededHandler(request);
        });
        const timeoutPromise = new Promise((_, reject)=>{
            setTimeout(()=>{
                reject(new Error(`IndexedDB open timed out after ${IndexedDBService.OPEN_DB_TIMEOUT_MS}ms`));
            }, IndexedDBService.OPEN_DB_TIMEOUT_MS);
        });
        return Promise.race([
            openPromise,
            timeoutPromise
        ]);
    }
    async getRecord(recordKey) {
        try {
            if (!this.isBooted) await this.boot();
            if (!this.db) {
                (0, _utils.sendPackageOperationalEvent)({
                    action: 'indexDbSetRecordError',
                    attributes: {
                        recordKey
                    }
                });
                return Promise.resolve({
                    atlSetItem: '',
                    id: recordKey
                }); // return empty AtlIndexedDBItem object to exit code
            }
            let fetchTransaction = this.db.transaction([
                this.storeName
            ]);
            let recordStore = fetchTransaction.objectStore(this.storeName);
            const fetchedRecord = new Promise((resolve, reject)=>{
                let request = recordStore.get(recordKey);
                request.onerror = this.onGetRecordErrorHandler(reject);
                request.onsuccess = this.onGetRecordSuccessHandler(request, resolve);
            });
            return fetchedRecord;
        } catch (e) {
            (0, _logger.Logger).error(`Error fetching record from database. ${e.message || ''}`);
            throw e;
        }
    }
    async setRecord(recordKey) {
        try {
            if (!this.isBooted) await this.boot();
            if (!this.db) {
                (0, _utils.sendPackageOperationalEvent)({
                    action: 'indexDbSetRecordError',
                    attributes: {
                        recordKey
                    }
                });
                Promise.resolve(); // return void promise to exit code and not pass a null record
            }
            const setRecord = new Promise((resolve, reject)=>{
                let setTransaction = this.db.transaction([
                    this.storeName
                ], 'readwrite');
                let objectStore = setTransaction.objectStore(this.storeName);
                const newAtlRecord = {
                    atlSetItem: 'SET-BY-PACKAGE',
                    id: recordKey
                };
                let request = objectStore.put(newAtlRecord);
                request.onerror = this.onSetRecordErrorHandler(reject);
                request.onsuccess = this.onSetRecordSuccessHandler(resolve);
            });
            return setRecord;
        } catch (e) {
            (0, _logger.Logger).warn(`Error setting record in database. ${e.message || ''}`);
            throw e;
        }
    }
    constructor(dbName, storeName){
        this.db = null;
        this.isBooted = false;
        this.isAvailable = false;
        this.onConnectionErrorHandler = (reject)=>(event)=>{
                (0, _logger.Logger).warn('Error opening database.');
                reject(event);
            };
        this.onConnectionSuccessHandler = (connection, resolve)=>()=>{
                this.db = connection.result;
                resolve();
            };
        this.onConnectionUpgradeNeededHandler = (request)=>()=>{
                this.db = request.result;
                this.db.createObjectStore(this.storeName, {
                    keyPath: 'id'
                });
            };
        this.onGetRecordErrorHandler = (reject)=>()=>{
                const getErrorMessage = `Failed to perform a get transaction on IndexedDB: ${this.dbName} + ${this.storeName}`;
                (0, _logger.Logger).warn(getErrorMessage);
                reject(getErrorMessage);
            };
        this.onGetRecordSuccessHandler = (getRequest, resolve)=>()=>{
                resolve(getRequest.result);
            };
        this.onSetRecordErrorHandler = (reject)=>()=>{
                const errorMessage = `Failed to perform a set transaction on IndexedDB: ${this.dbName} + ${this.storeName}`;
                (0, _logger.Logger).warn(errorMessage);
                reject(errorMessage);
            };
        this.onSetRecordSuccessHandler = (resolve)=>()=>{
                resolve();
            };
        this.dbName = dbName;
        this.storeName = storeName;
        this.isAvailable = this.getIsDBAvailable();
        this.isBooted = false;
        this.bootUpPromiseCache = null;
    }
}
IndexedDBService.OPEN_DB_TIMEOUT_MS = 3000;
const BSCIndexedDB = new IndexedDBService('BSCIndexedDB', 'InternalStorageKeys');

},{"../../common/utils":"gnWyu","../../common/utils/logger":"2Tk7J","@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"1dILA":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "WebStorageType", ()=>WebStorageType);
var WebStorageType = /*#__PURE__*/ function(WebStorageType) {
    WebStorageType["LocalStorage"] = "LocalStorage";
    WebStorageType["SessionStorage"] = "SessionStorage";
    return WebStorageType;
}({});

},{"@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"5ncRa":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "getStorageItem", ()=>(0, _getStorageItem.getStorageItem));
parcelHelpers.export(exports, "setStorageItem", ()=>(0, _setStorageItem.setStorageItem));
parcelHelpers.export(exports, "setStrictlyNecessaryStorageItem", ()=>(0, _setStrictlyNecessaryStorageItem.setStrictlyNecessaryStorageItem));
var _getStorageItem = require("./get-storage-item");
var _setStorageItem = require("./set-storage-item");
var _setStrictlyNecessaryStorageItem = require("./set-strictly-necessary-storage-item");

},{"./get-storage-item":"2230Y","./set-storage-item":"cTF1j","./set-strictly-necessary-storage-item":"bAkzo","@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"2230Y":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "getStorageItem", ()=>getStorageItem);
var _utils = require("../../../common/utils");
var _logger = require("../../../common/utils/logger");
const getStorageItem = (itemKey, storageType, browserStorage)=>{
    const eventAttributes = {
        itemKey,
        storageType
    };
    try {
        (0, _utils.sendPackageOperationalEvent)({
            action: 'usedAtlBrowserStorageGetItem',
            attributes: eventAttributes
        });
        return browserStorage.getItem(itemKey);
    } catch (e) {
        (0, _logger.Logger).errorWithOperationalEvent({
            action: 'usedAtlBrowserStorageGetItemError',
            attributes: eventAttributes,
            message: `Failed to get ${storageType} item. ${e.message || ''}`
        });
        return null;
    }
};

},{"../../../common/utils":"gnWyu","../../../common/utils/logger":"2Tk7J","@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"cTF1j":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "setStorageItem", ()=>setStorageItem);
var _objectSpread = require("@swc/helpers/_/_object_spread");
var _objectSpreadProps = require("@swc/helpers/_/_object_spread_props");
var _platformFeatureFlags = require("@atlaskit/platform-feature-flags");
var _utils = require("../../../common/utils");
var _itemProcessing = require("../../../common/utils/item-processing");
var _types = require("../../../types");
var _itemKeyCacheService = require("../../item-key-cache-service");
var _types1 = require("../types");
var _reportSetItemError = require("./report-set-item-error");
const isPromise = (value)=>value != null && typeof value.then === 'function';
const setStorageItem = async (itemKey, value, storageType, productName, browserStorage)=>{
    const categoryStorageType = storageType === (0, _types1.WebStorageType).LocalStorage ? (0, _types.CategoryStorageType).LocalStorage : (0, _types.CategoryStorageType).SessionStorage;
    var _getBscGlobalState_disableWebStorageConsentChecks;
    // `disableWebStorageConsentChecks` skips the consent pipeline (analytics-only),
    // but `__UNSAFE_shouldEnforceKeyForRollout(key, type) === true` re-enables enforcement for this key.
    let disableWebStorageConsentChecks = (_getBscGlobalState_disableWebStorageConsentChecks = (0, _utils.getBscGlobalState)().disableWebStorageConsentChecks) !== null && _getBscGlobalState_disableWebStorageConsentChecks !== void 0 ? _getBscGlobalState_disableWebStorageConsentChecks : false;
    if ((0, _platformFeatureFlags.fg)('jfp-magma-selective-storage-enforcement')) {
        const __UNSAFE_shouldEnforceKeyForRollout = (0, _utils.getBscGlobalState)().__UNSAFE_shouldEnforceKeyForRollout;
        const enforceThisKey = (__UNSAFE_shouldEnforceKeyForRollout === null || __UNSAFE_shouldEnforceKeyForRollout === void 0 ? void 0 : __UNSAFE_shouldEnforceKeyForRollout(itemKey, categoryStorageType)) === true;
        var _getBscGlobalState_disableWebStorageConsentChecks1;
        disableWebStorageConsentChecks = ((_getBscGlobalState_disableWebStorageConsentChecks1 = (0, _utils.getBscGlobalState)().disableWebStorageConsentChecks) !== null && _getBscGlobalState_disableWebStorageConsentChecks1 !== void 0 ? _getBscGlobalState_disableWebStorageConsentChecks1 : false) && !enforceThisKey;
    }
    if (disableWebStorageConsentChecks) {
        const eventAttributes = {
            itemKey,
            storageType,
            consentChecksDisabled: true
        };
        try {
            // note: at the time of writing, this doesn't actually do anything because browserStorage.setItem calls the original setItem, not the overridden one.
            // see this thread for more information: https://atlassian.slack.com/archives/C05U6KCDNQJ/p1778585948364219
            (0, _itemKeyCacheService.ItemKeyCache).markSetByPackage(categoryStorageType, itemKey);
            browserStorage.setItem(itemKey, value);
        } catch (e) {
            (0, _reportSetItemError.reportSetItemError)({
                message: `${storageType} failed to setItem with consent checks disabled. ${e.message || ''}`,
                attributes: eventAttributes,
                error: e
            });
            return {
                status: (0, _types.Status).ERROR,
                error: e
            };
        }
        let wasAsync = true;
        try {
            let shouldSetItem;
            const shouldSetItemOrPromise = (0, _itemProcessing.isProcessingAllowedByPreferencesMaybeSync)({
                itemKey,
                storageType: categoryStorageType,
                productName
            });
            if (isPromise(shouldSetItemOrPromise)) shouldSetItem = await shouldSetItemOrPromise;
            else {
                wasAsync = false;
                shouldSetItem = shouldSetItemOrPromise;
            }
            (0, _utils.sendPackageOperationalEvent)({
                action: 'usedAtlBrowserStorageSetItem',
                attributes: (0, _objectSpreadProps._)((0, _objectSpread._)({}, eventAttributes), {
                    wasRejected: !shouldSetItem,
                    wasAsync
                })
            });
        } catch (e) {
            (0, _reportSetItemError.reportSetItemError)({
                attributes: (0, _objectSpreadProps._)((0, _objectSpread._)({}, eventAttributes), {
                    wasAsync
                }),
                message: `Failed to emit analytics for setStorageItem with consent checks disabled. ${e.message || ''}`,
                error: e
            });
        }
        return {
            status: (0, _types.Status).SUCCESS
        };
    }
    // user belongs to an org that opted into cookies management and we should respect their preferences
    let shouldSetItem;
    let wasAsync = true;
    const shouldSetItemOrPromise = (0, _itemProcessing.isProcessingAllowedByPreferencesMaybeSync)({
        itemKey,
        storageType: categoryStorageType,
        productName
    });
    if (isPromise(shouldSetItemOrPromise)) shouldSetItem = await shouldSetItemOrPromise;
    else {
        wasAsync = false;
        shouldSetItem = shouldSetItemOrPromise;
    }
    // The synchronous preference check surfaces no block reason:
    // `isProcessingAllowedByPreferencesMaybeSync` takes no blockedCallback, so we cannot tell
    // "key not registered in the allow-list" from "blocked by user consent" here. The BLOCKED
    // result therefore carries `blockedItemCategory: undefined` ("reason unknown"), which the
    // caller reads as such and answers with a terse "was blocked" warning.
    const eventAttributes = {
        wasRejected: !shouldSetItem,
        itemKey,
        storageType,
        consentChecksDisabled: false,
        wasAsync
    };
    try {
        (0, _utils.sendPackageOperationalEvent)({
            action: 'usedAtlBrowserStorageSetItem',
            attributes: eventAttributes
        });
        if (shouldSetItem) {
            // note: at the time of writing, this doesn't actually do anything because browserStorage.setItem calls the original setItem, not the overridden one.
            // see this thread for more information: https://atlassian.slack.com/archives/C05U6KCDNQJ/p1778585948364219
            (0, _itemKeyCacheService.ItemKeyCache).markSetByPackage(categoryStorageType, itemKey);
            browserStorage.setItem(itemKey, value);
            return {
                status: (0, _types.Status).SUCCESS
            };
        } else return {
            status: (0, _types.Status).BLOCKED,
            blockedItemCategory: undefined
        };
    } catch (e) {
        (0, _reportSetItemError.reportSetItemError)({
            attributes: eventAttributes,
            message: `Failed to set ${storageType} item. ${e.message || ''}`,
            error: e
        });
        return {
            status: (0, _types.Status).ERROR,
            error: e
        };
    }
};

},{"@swc/helpers/_/_object_spread":"9gdrV","@swc/helpers/_/_object_spread_props":"kANqQ","@atlaskit/platform-feature-flags":"8rD2i","../../../common/utils":"gnWyu","../../../common/utils/item-processing":"8zwf4","../../../types":"65Pa5","../../item-key-cache-service":"4UZqe","../types":"1dILA","./report-set-item-error":"3TCEn","@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"8zwf4":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "findStartsWithPatternMatch", ()=>findStartsWithPatternMatch);
parcelHelpers.export(exports, "findRegExpPatternMatch", ()=>findRegExpPatternMatch);
parcelHelpers.export(exports, "findEndsWithPatternMatch", ()=>findEndsWithPatternMatch);
parcelHelpers.export(exports, "findStartsWithFlatPatternMatch", ()=>findStartsWithFlatPatternMatch);
parcelHelpers.export(exports, "findStartsWithLongestPatternMatch", ()=>findStartsWithLongestPatternMatch);
parcelHelpers.export(exports, "findEndsWithLongestPatternMatch", ()=>findEndsWithLongestPatternMatch);
parcelHelpers.export(exports, "findEndsWithFlatPatternMatch", ()=>findEndsWithFlatPatternMatch);
parcelHelpers.export(exports, "getItemCategoryFromPassedCache", ()=>getItemCategoryFromPassedCache);
parcelHelpers.export(exports, "getItemCategory", ()=>getItemCategory);
parcelHelpers.export(exports, "getItemCategoryMaybeSync", ()=>getItemCategoryMaybeSync);
parcelHelpers.export(exports, "isProcessingAllowedByPreferencesMaybeSync", ()=>isProcessingAllowedByPreferencesMaybeSync);
parcelHelpers.export(exports, "isProcessingAllowedByPreferences", ()=>isProcessingAllowedByPreferences);
parcelHelpers.export(exports, "isProcessingAllowedByPreferencesWithCategory", ()=>isProcessingAllowedByPreferencesWithCategory);
var _objectSpread = require("@swc/helpers/_/_object_spread");
var _platformFeatureFlags = require("@atlaskit/platform-feature-flags");
var _getPreferences = require("../../../controllers/preferences-controls/get-preferences");
var _types = require("../../../types");
var _core = require("../bsc-global-state/core");
var _logger = require("../logger");
/**
 * WeakMap cache for precompiled RegExp objects, keyed by the raw regExp product map.
 * This ensures RegExp strings are compiled at most once per unique cache object.
 */ const compiledRegExpCache = new WeakMap();
const compileRegExpPatterns = (rawPatterns)=>{
    if (compiledRegExpCache.has(rawPatterns)) return compiledRegExpCache.get(rawPatterns);
    const compiled = [];
    for (const [regexString, category] of Object.entries(rawPatterns))try {
        compiled.push({
            regexp: new RegExp(regexString),
            category
        });
    } catch (e) {
        (0, _logger.Logger).warn(`BSC: Invalid RegExp pattern "${regexString}" in storage controls cache \u{2014} skipping.`);
    }
    compiledRegExpCache.set(rawPatterns, compiled);
    return compiled;
};
const findStartsWithPatternMatch = (itemKey, startsWith)=>{
    // Setup initial pattern step and position
    let currentStep = startsWith;
    let position = 0;
    // Iterate through item key symbol by symbol
    while(position < itemKey.length){
        // The value of item character at the position
        const currentStepValue = currentStep[itemKey[position]];
        // If there is no match for item symbol in cache, this means there is no
        // pattern match for the item key
        if (currentStepValue === undefined) return null;
        // If current step value is a number, this means we reached the end of the pattern
        // and should return category number
        if (typeof currentStepValue === 'number') return currentStepValue;
        // Continue to going through pattern
        currentStep = currentStepValue;
        position++;
    }
    // No pattern match - all patterns longer or shorter than item key
    return null;
};
const findRegExpPatternMatch = (itemKey, compiledPatterns)=>{
    for (const { regexp, category } of compiledPatterns){
        if (regexp.test(itemKey)) return category;
    }
    return null;
};
const findEndsWithPatternMatch = (itemKey, endsWith)=>{
    // Return category number if str is found in the trie, otherwise return undefined
    const trieSearch = (str)=>{
        let currentStep = endsWith;
        let foundString = '';
        let terminalNumber;
        for(let i = 0; i < str.length; i++){
            const char = str[i];
            currentStep = currentStep[char];
            if (currentStep === undefined) break;
            foundString += char;
            if (typeof currentStep === 'number') {
                terminalNumber = currentStep;
                break;
            }
        }
        if (foundString === str) // Trie contained the complete string
        return terminalNumber;
        else // Trie did not contain the complete string
        return undefined;
    };
    let position = 0;
    // Iterate through item key symbol by symbol
    while(position < itemKey.length){
        const remainderMatch = trieSearch(itemKey.slice(position));
        if (remainderMatch !== undefined) return remainderMatch;
        position++;
    }
    return null;
};
const findStartsWithFlatPatternMatch = (itemKey, startsWith)=>{
    for (const prefix of Object.keys(startsWith)){
        if (itemKey.startsWith(prefix)) return startsWith[prefix];
    }
    return null;
};
const findStartsWithLongestPatternMatch = (itemKey, startsWith)=>{
    let best = null;
    for (const prefix of Object.keys(startsWith)){
        if (itemKey.startsWith(prefix)) {
            if (best === null || prefix.length > best.length) best = {
                category: startsWith[prefix],
                length: prefix.length
            };
        }
    }
    return best;
};
const findEndsWithLongestPatternMatch = (itemKey, endsWith)=>{
    let best = null;
    for (const suffix of Object.keys(endsWith)){
        if (itemKey.endsWith(suffix)) {
            if (best === null || suffix.length > best.length) best = {
                category: endsWith[suffix],
                length: suffix.length
            };
        }
    }
    return best;
};
const findEndsWithFlatPatternMatch = (itemKey, endsWith)=>{
    for (const suffix of Object.keys(endsWith)){
        if (itemKey.endsWith(suffix)) return endsWith[suffix];
    }
    return null;
};
const getItemCategoryFromPassedCache = (itemKey, storageControlsData, productName)=>{
    const downcasedProduct = productName === null || productName === void 0 ? void 0 : productName.toLowerCase();
    let itemCategoryNumber = null;
    const { categories, patterns } = storageControlsData;
    let productKeys = (0, _objectSpread._)({}, storageControlsData['keys']['all'], downcasedProduct ? storageControlsData['keys'][downcasedProduct] : {});
    const productStartsWithPatterns = (0, _objectSpread._)({}, patterns.startsWith['all'], downcasedProduct ? patterns.startsWith[downcasedProduct] : {});
    const productEndsWithPatterns = (0, _objectSpread._)({}, patterns.endsWith['all'], downcasedProduct ? patterns.endsWith[downcasedProduct] : {});
    // Find direct match in keys
    if (Object.keys(productKeys).includes(itemKey)) itemCategoryNumber = productKeys[itemKey];
    else if ((0, _platformFeatureFlags.fg)('platform_bsc_flat_pattern_file_structure')) {
        if ((0, _platformFeatureFlags.fg)('platform_bsc_longest_pattern_match_wins')) {
            // Longest-match-wins flat path
            const swMatch = findStartsWithLongestPatternMatch(itemKey, productStartsWithPatterns);
            if (swMatch !== null) itemCategoryNumber = swMatch.category;
            else {
                const ewMatch = findEndsWithLongestPatternMatch(itemKey, productEndsWithPatterns);
                if (ewMatch !== null) itemCategoryNumber = ewMatch.category;
            }
        } else {
            // First-match flat path (COOK-435)
            itemCategoryNumber = findStartsWithFlatPatternMatch(itemKey, productStartsWithPatterns);
            if (itemCategoryNumber === null) itemCategoryNumber = findEndsWithFlatPatternMatch(itemKey, productEndsWithPatterns);
        }
        // 3. RegExp fallback for both flat paths
        if (itemCategoryNumber === null && (0, _platformFeatureFlags.fg)('platform_moonjelly_bsc_regexp_pattern_matching')) {
            var _patterns_regexp, _patterns_regexp1;
            const rawRegExpPatterns = (0, _objectSpread._)({}, (_patterns_regexp = patterns.regexp) === null || _patterns_regexp === void 0 ? void 0 : _patterns_regexp['all'], downcasedProduct ? (_patterns_regexp1 = patterns.regexp) === null || _patterns_regexp1 === void 0 ? void 0 : _patterns_regexp1[downcasedProduct] : {});
            const compiledPatterns = compileRegExpPatterns(rawRegExpPatterns);
            itemCategoryNumber = findRegExpPatternMatch(itemKey, compiledPatterns);
        }
    } else {
        // Legacy trie matching path. When platform_bsc_lookup_product_then_all_pattern_tries
        // is ON we search the product trie first and fall back to the 'all' trie;
        // a merged trie is unsafe because a shared first character silently
        // drops the entire 'all' subtree under it (HOT-303432).
        if ((0, _platformFeatureFlags.fg)('platform_bsc_lookup_product_then_all_pattern_tries')) {
            const productStartsWith = downcasedProduct ? patterns.startsWith[downcasedProduct] : undefined;
            const productEndsWith = downcasedProduct ? patterns.endsWith[downcasedProduct] : undefined;
            const allStartsWith = patterns.startsWith['all'];
            const allEndsWith = patterns.endsWith['all'];
            if (productStartsWith) itemCategoryNumber = findStartsWithPatternMatch(itemKey, productStartsWith);
            if (itemCategoryNumber === null && allStartsWith) itemCategoryNumber = findStartsWithPatternMatch(itemKey, allStartsWith);
            if (itemCategoryNumber === null && productEndsWith) itemCategoryNumber = findEndsWithPatternMatch(itemKey, productEndsWith);
            if (itemCategoryNumber === null && allEndsWith) itemCategoryNumber = findEndsWithPatternMatch(itemKey, allEndsWith);
        } else {
            itemCategoryNumber = findStartsWithPatternMatch(itemKey, productStartsWithPatterns);
            if (itemCategoryNumber === null) itemCategoryNumber = findEndsWithPatternMatch(itemKey, productEndsWithPatterns);
        }
        if (itemCategoryNumber === null && (0, _platformFeatureFlags.fg)('platform_moonjelly_bsc_regexp_pattern_matching')) {
            var _patterns_regexp2, _patterns_regexp3;
            const rawRegExpPatterns = (0, _objectSpread._)({}, (_patterns_regexp2 = patterns.regexp) === null || _patterns_regexp2 === void 0 ? void 0 : _patterns_regexp2['all'], downcasedProduct ? (_patterns_regexp3 = patterns.regexp) === null || _patterns_regexp3 === void 0 ? void 0 : _patterns_regexp3[downcasedProduct] : {});
            const compiledPatterns = compileRegExpPatterns(rawRegExpPatterns);
            itemCategoryNumber = findRegExpPatternMatch(itemKey, compiledPatterns);
        }
    }
    const numToCategoryMap = {
        [categories.STRICTLY_NECESSARY]: (0, _types.PreferenceCategory).StrictlyNecessary,
        [categories.FUNCTIONAL]: (0, _types.PreferenceCategory).Functional,
        [categories.ANALYTICS]: (0, _types.PreferenceCategory).Analytics,
        [categories.MARKETING]: (0, _types.PreferenceCategory).Marketing,
        [categories.UNKNOWN]: (0, _types.PreferenceCategory).Unknown
    };
    return itemCategoryNumber !== null ? numToCategoryMap[itemCategoryNumber] : null;
};
const getItemCategory = async (itemKey, storageType, productName)=>{
    const storageControlsData = await (0, _core.getBscGlobalState)().loadCache(storageType);
    if (!storageControlsData) return null;
    else return getItemCategoryFromPassedCache(itemKey, storageControlsData, productName);
};
const isPromise = (value)=>value != null && typeof value.then === 'function';
const getItemCategoryMaybeSync = (itemKey, storageType, productName)=>{
    const storageControlsDataOrPromise = (0, _core.getBscGlobalState)().loadCacheMaybeSync(storageType);
    if (isPromise(storageControlsDataOrPromise)) return storageControlsDataOrPromise.then((storageControlsData)=>{
        if (!storageControlsData) return null;
        else return getItemCategoryFromPassedCache(itemKey, storageControlsData, productName);
    });
    if (!storageControlsDataOrPromise) return null;
    else return getItemCategoryFromPassedCache(itemKey, storageControlsDataOrPromise, productName);
};
function isProcessingAllowedForCategoryAndPreferenceSync(category, preferences) {
    if (!!preferences) {
        if (!!category) return preferences[category];
    }
    return false;
}
/**
 * Given an item category and a promise or object of user preferences, determines whether the item can be set.
 * It avoids only returns a promise if we need the preference data to determine the result, otherwise it returns synchronously.
 *
 * DO NOT CONVERT THIS FUNCTION TO ASYNC - as async functions always return a promise, breaking read-after-write consistency for clients that have already loaded the cache.
 */ function isProcessingAllowedForCategoryMaybeSync(itemCategory, preferencesOrPromise) {
    if (itemCategory === (0, _types.PreferenceCategory).StrictlyNecessary) return {
        itemCategory,
        shouldProcessItem: true
    };
    if (isPromise(preferencesOrPromise)) return preferencesOrPromise.then((prefs)=>{
        return {
            itemCategory,
            shouldProcessItem: isProcessingAllowedForCategoryAndPreferenceSync(itemCategory, prefs)
        };
    });
    else return {
        itemCategory,
        shouldProcessItem: isProcessingAllowedForCategoryAndPreferenceSync(itemCategory, preferencesOrPromise)
    };
}
const getProcessingAllowedByPreferencesAndCategoryMaybeSync = ({ itemKey, storageType, productName })=>{
    // start fetching both promises upfront, so they can resolve in parallel if needed
    const itemCategoryOrPromise = getItemCategoryMaybeSync(itemKey, storageType, productName);
    const preferencesOrPromise = (0, _getPreferences.getPreferencesMaybeSync)();
    if (isPromise(itemCategoryOrPromise)) return itemCategoryOrPromise.then((category)=>isProcessingAllowedForCategoryMaybeSync(category, preferencesOrPromise));
    else return isProcessingAllowedForCategoryMaybeSync(itemCategoryOrPromise, preferencesOrPromise);
};
const isProcessingAllowedByPreferencesMaybeSync = ({ itemKey, storageType, productName })=>{
    const categoryAndPreferenceOrPromise = getProcessingAllowedByPreferencesAndCategoryMaybeSync({
        itemKey,
        storageType,
        productName
    });
    if (isPromise(categoryAndPreferenceOrPromise)) return categoryAndPreferenceOrPromise.then(({ shouldProcessItem })=>shouldProcessItem);
    else return categoryAndPreferenceOrPromise.shouldProcessItem;
};
const isProcessingAllowedByPreferences = async ({ itemKey, allowedCallback = ()=>{}, blockedCallback = ()=>{}, storageType, productName })=>{
    let shouldProcessItem;
    let itemCategory = null;
    let wasAsync = true;
    let categoryAndPreferenceOrPromise = getProcessingAllowedByPreferencesAndCategoryMaybeSync({
        itemKey,
        storageType,
        productName
    });
    if (isPromise(categoryAndPreferenceOrPromise)) // this should be the only await in the function.
    ({ shouldProcessItem, itemCategory } = await categoryAndPreferenceOrPromise);
    else {
        wasAsync = false;
        ({ shouldProcessItem, itemCategory } = categoryAndPreferenceOrPromise);
    }
    if (shouldProcessItem) allowedCallback === null || allowedCallback === void 0 ? void 0 : allowedCallback({
        wasAsync
    });
    else blockedCallback === null || blockedCallback === void 0 ? void 0 : blockedCallback({
        itemHasCategory: itemCategory != null,
        itemCategory,
        wasAsync
    });
    return shouldProcessItem;
};
const isProcessingAllowedByPreferencesWithCategory = async ({ itemKey, storageType, productName })=>{
    const categoryAndPreferenceOrPromise = getProcessingAllowedByPreferencesAndCategoryMaybeSync({
        itemKey,
        storageType,
        productName
    });
    let shouldProcessItem;
    let itemCategory;
    if (isPromise(categoryAndPreferenceOrPromise)) ({ shouldProcessItem, itemCategory } = await categoryAndPreferenceOrPromise);
    else ({ shouldProcessItem, itemCategory } = categoryAndPreferenceOrPromise);
    return {
        isAllowed: shouldProcessItem,
        itemCategory
    };
};

},{"@swc/helpers/_/_object_spread":"9gdrV","@atlaskit/platform-feature-flags":"8rD2i","../../../controllers/preferences-controls/get-preferences":"030sv","../../../types":"65Pa5","../bsc-global-state/core":"Lu8Q3","../logger":"2Tk7J","@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"030sv":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "getPreferences", ()=>getPreferences);
// Avoids unnecessary async/await when preferences are stored in cookies
parcelHelpers.export(exports, "getPreferencesMaybeSync", ()=>getPreferencesMaybeSync);
var _utils = require("../../../common/utils");
var _constants = require("../../../constants");
var _getConsentToken = require("../../cookie-controls/get-consent-token");
var _getCookie = require("../../cookie-controls/get-cookie");
var _transformer = require("../../cookie-controls/transformer");
async function getPreferences() {
    // when localConsentMode is on, don't make calls to ConsentHub
    if ((0, _utils.getBscGlobalState)().localConsentMode) {
        const packedPrefs = (0, _getCookie.getCookie)((0, _constants.LEGACY_ATLASSIAN_GDPR_COOKIE_KEY));
        if (!packedPrefs) return undefined;
        return (0, _transformer.unpackUserPreferencesCookie)(packedPrefs);
    } else {
        let packedLocalPrefs = (0, _getCookie.getCookie)((0, _constants.ATLASSIAN_CONSENT_COOKIE_KEY));
        if (!packedLocalPrefs) {
            const consentToken = await (0, _getConsentToken.getConsentToken)();
            if ((0, _utils.isSSR)() && consentToken) window.__COOKIE_CONSENT_PREFERENCES__ = Object.assign(window.__COOKIE_CONSENT_PREFERENCES__ || {}, {
                consentToken
            });
            return consentToken ? (0, _transformer.unpackUserPreferencesCookie)(consentToken) : undefined;
        }
        return (0, _transformer.unpackUserPreferencesCookie)(packedLocalPrefs);
    }
}
function getPreferencesMaybeSync() {
    // when localConsentMode is on, don't make calls to ConsentHub
    if ((0, _utils.getBscGlobalState)().localConsentMode) {
        const packedPrefs = (0, _getCookie.getCookie)((0, _constants.LEGACY_ATLASSIAN_GDPR_COOKIE_KEY));
        if (!packedPrefs) return undefined;
        return (0, _transformer.unpackUserPreferencesCookie)(packedPrefs);
    } else {
        let packedLocalPrefs = (0, _getCookie.getCookie)((0, _constants.ATLASSIAN_CONSENT_COOKIE_KEY));
        if (!packedLocalPrefs) return (0, _getConsentToken.getConsentToken)().then((consentToken)=>{
            if ((0, _utils.isSSR)() && consentToken) window.__COOKIE_CONSENT_PREFERENCES__ = Object.assign(window.__COOKIE_CONSENT_PREFERENCES__ || {}, {
                consentToken
            });
            return consentToken ? (0, _transformer.unpackUserPreferencesCookie)(consentToken) : undefined;
        });
        else return (0, _transformer.unpackUserPreferencesCookie)(packedLocalPrefs);
    }
}

},{"../../../common/utils":"gnWyu","../../../constants":"9FHD5","../../cookie-controls/get-consent-token":"c2VYF","../../cookie-controls/get-cookie":"VS0K5","../../cookie-controls/transformer":"hcsh1","@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"c2VYF":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "getConsentToken", ()=>getConsentToken);
var _constants = require("../../../constants");
var _getCookie = require("../get-cookie");
var _overrideWithTestingCookies = require("../override-with-testing-cookies");
var _setRequiredConsentCookies = require("../set-required-consent-cookies");
var _utils = require("./utils");
/**
 * Module-level cache of the in-flight ConsentHub fetch promise.
 * Cleared as soon as the promise settles (resolved or rejected).
 *
 * Without this, N concurrent callers that all find the consent cookie absent
 * would each independently fire a fetch to ConsentHub, causing a request
 * fan-out on every page load where multiple components call getPreferences()
 * simultaneously.
 */ let inFlightConsentToken = null;
const _getConsentToken = async ()=>{
    const fallbackConsentToken = (0, _getCookie.getCookie)((0, _constants.ATLASSIAN_CONSENT_FALLBACK_COOKIE_KEY));
    const consentData = await (0, _utils.getValidConsentData)(fallbackConsentToken);
    if (consentData) {
        const { consentToken, consentTimestamp } = consentData;
        /*** TESTING OVERRIDES ***/ const potentiallyOverriddenConsentToken = (0, _overrideWithTestingCookies.overrideConsentTokenForLiveTesting)(consentToken);
        const testingConsentOverride = (0, _getCookie.getCookie)((0, _constants.TESTING_TOKEN_OVERRIDE_COOKIE_KEY));
        const hasTestingConsents = !!(testingConsentOverride || testingConsentOverride === '');
        if (hasTestingConsents) {
            // If testing, set the cookies accordingly so we can test with any overridden token data.
            (0, _setRequiredConsentCookies.setShouldShowBannerCookie)(potentiallyOverriddenConsentToken);
            (0, _setRequiredConsentCookies.setConsentTokenCookie)(potentiallyOverriddenConsentToken);
            // Unfortunately, if you've previously saved to ConsentHub, that data will always resolve, so to simulate ConsentHub
            // being down, or the token data being bunk/invalid, we must set the testing token to an empty string. This will
            // return undefined here and skip any unpacking of the token. Otherwise, it will use the overridden token value.
            return potentiallyOverriddenConsentToken === '' ? undefined : potentiallyOverriddenConsentToken;
        }
        // At this point, all data should be valid and overridden for testing as needed, so set those cookies!
        (0, _setRequiredConsentCookies.setRequiredConsentCookies)(potentiallyOverriddenConsentToken, consentTimestamp);
        return consentToken;
    }
    return undefined;
};
const getConsentToken = ()=>{
    // N concurrent callers share a single in-flight promise so only one ConsentHub fetch
    // fires per page load regardless of how many components call getPreferences() simultaneously.
    if (inFlightConsentToken) return inFlightConsentToken;
    inFlightConsentToken = _getConsentToken().finally(()=>{
        inFlightConsentToken = null;
    });
    return inFlightConsentToken;
};

},{"../../../constants":"9FHD5","../get-cookie":"VS0K5","../override-with-testing-cookies":"bmKDG","../set-required-consent-cookies":"j36f0","./utils":"4efx5","@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"bmKDG":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "overrideConsentTokenForLiveTesting", ()=>overrideConsentTokenForLiveTesting);
var _constants = require("../../../constants");
var _getCookie = require("../get-cookie");
const overrideConsentTokenForLiveTesting = (genuineConsentToken)=>{
    // The existence of this cookie will make it look like fetched ConsentHub data is missing
    // You can set it to undefined yourself/empty string, or an actual default value.
    const tokenOverride = (0, _getCookie.getCookie)((0, _constants.TESTING_TOKEN_OVERRIDE_COOKIE_KEY));
    // Note: Clear this cookie out of your browser when you're done testing empty data sets
    // Or you'll be stuck seeing the banner and never actually consenting on the UI
    return tokenOverride || genuineConsentToken;
};

},{"../../../constants":"9FHD5","../get-cookie":"VS0K5","@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"j36f0":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "getRandomizedConsentCookieLifetimeMinutes", ()=>getRandomizedConsentCookieLifetimeMinutes);
parcelHelpers.export(exports, "setConsentTokenCookie", ()=>setConsentTokenCookie);
parcelHelpers.export(exports, "setConsentTokenFallbackCookie", ()=>setConsentTokenFallbackCookie);
parcelHelpers.export(exports, "setShouldShowBannerCookie", ()=>setShouldShowBannerCookie);
parcelHelpers.export(exports, "setRequiredConsentCookies", ()=>setRequiredConsentCookies);
var _platformFeatureFlags = require("@atlaskit/platform-feature-flags");
var _utils = require("../../../common/utils");
var _constants = require("../../../constants");
var _getBannerVisibility = require("../../banner-controls/get-banner-visibility");
var _setStrictlyNecessaryCookie = require("../set-strictly-necessary-cookie");
const LEGACY_CONSENT_COOKIE_LIFETIME_MINUTES = 10;
const MIN_RANDOMIZED_CONSENT_COOKIE_LIFETIME_MINUTES = 50;
const MAX_RANDOMIZED_CONSENT_COOKIE_LIFETIME_MINUTES = 70;
const getRandomizedConsentCookieLifetimeMinutes = ()=>{
    // Random offset is 0-20 minutes inclusive, so the final lifetime spreads across 50-70 minutes.
    const randomizedOffsetMinutes = Math.floor(Math.random() * (MAX_RANDOMIZED_CONSENT_COOKIE_LIFETIME_MINUTES - MIN_RANDOMIZED_CONSENT_COOKIE_LIFETIME_MINUTES + 1));
    // Spread cookie expiration times to smooth traffic spikes to ConsentHub.
    return MIN_RANDOMIZED_CONSENT_COOKIE_LIFETIME_MINUTES + randomizedOffsetMinutes;
};
// Pick once per module load so both required consent cookies share the same spread-out expiry.
const RANDOMIZED_CONSENT_COOKIE_LIFETIME_MINUTES = getRandomizedConsentCookieLifetimeMinutes();
const getRequiredConsentCookieExpiryDate = ()=>{
    const expiryDate = new Date();
    const lifetimeInMinutes = (0, _platformFeatureFlags.fg)('platform_bsc_cookie_lifetime') ? RANDOMIZED_CONSENT_COOKIE_LIFETIME_MINUTES : LEGACY_CONSENT_COOKIE_LIFETIME_MINUTES;
    expiryDate.setTime(expiryDate.getTime() + lifetimeInMinutes * 60000);
    return expiryDate;
};
const setConsentTokenCookie = (consentToken)=>{
    (0, _setStrictlyNecessaryCookie.setStrictlyNecessaryCookie)((0, _constants.ATLASSIAN_CONSENT_COOKIE_KEY), consentToken, {
        expires: getRequiredConsentCookieExpiryDate(),
        path: '/'
    });
    (0, _utils.Logger).debug(`Set Consent Token ${(0, _constants.ATLASSIAN_CONSENT_COOKIE_KEY)} ${consentToken}`);
};
const setConsentTokenFallbackCookie = (consentToken)=>{
    const inOneYear = new Date();
    inOneYear.setFullYear(inOneYear.getFullYear() + 1);
    (0, _setStrictlyNecessaryCookie.setStrictlyNecessaryCookie)((0, _constants.ATLASSIAN_CONSENT_FALLBACK_COOKIE_KEY), consentToken, {
        expires: inOneYear,
        path: '/'
    });
    (0, _utils.Logger).debug(`set fallback consent token: ${(0, _constants.ATLASSIAN_CONSENT_FALLBACK_COOKIE_KEY)} ${consentToken}`);
};
const setShouldShowBannerCookie = (consentToken, consentTimestamp)=>{
    // Since we have no good way to reference this as a global state object, we want to precompute and store the
    // banner visibility in a temporary, session-scope cookie (same expiry as the other cookies), which we can
    // lookup in the UI as needed
    const bannerVisibility = (0, _getBannerVisibility.getBannerVisibility)({
        consentToken,
        consentTimestamp
    });
    const shouldShowBanner = (0, _utils.getBitValueFromBool)(!!bannerVisibility);
    (0, _setStrictlyNecessaryCookie.setStrictlyNecessaryCookie)((0, _constants.ATLASSIAN_SHOW_BANNER_COOKIE_KEY), shouldShowBanner, {
        expires: getRequiredConsentCookieExpiryDate(),
        path: '/'
    });
    (0, _utils.Logger).debug(`set shouldShowBannerCookie: ${(0, _constants.ATLASSIAN_SHOW_BANNER_COOKIE_KEY)} ${shouldShowBanner}`);
};
const setRequiredConsentCookies = (consentToken, consentTimestamps)=>{
    setConsentTokenCookie(consentToken);
    setShouldShowBannerCookie(consentToken, consentTimestamps);
};

},{"@atlaskit/platform-feature-flags":"8rD2i","../../../common/utils":"gnWyu","../../../constants":"9FHD5","../../banner-controls/get-banner-visibility":"bByh5","../set-strictly-necessary-cookie":"dUkaQ","@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"bByh5":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "getBannerVisibility", ()=>getBannerVisibility);
var _jsCookie = require("js-cookie");
var _jsCookieDefault = parcelHelpers.interopDefault(_jsCookie);
var _utils = require("../../../common/utils");
var _helpers = require("../../../common/utils/helpers");
var _constants = require("../../../constants");
var _utils1 = require("../../../services/consent-hub-service/utils");
var _getCookie = require("../../cookie-controls/get-cookie");
var _transformer = require("../../cookie-controls/transformer");
const getUserIsAuthenticatedBit = (consentToken)=>{
    const { isV002 } = (0, _transformer.checkTokenVersionValidity)(consentToken);
    let userIsAuthenticatedBit = consentToken[8]; // V3 position
    if (isV002) {
        // Schema has changed in V3, V2 had this bit in a different position. Logged out users will have this bit set to 1
        const legacyV2ConsentDataUnavailableBit = consentToken[7];
        // We can backfill the UserIsAuthenticated bit by flipping the bit value. If ConsentHub was unavailable, that means they were logged out.
        userIsAuthenticatedBit = legacyV2ConsentDataUnavailableBit === '1' ? '0' : '1';
    }
    return userIsAuthenticatedBit;
};
const shouldShowBannerForLoggedOutDefaultToken = (fallbackConsentToken)=>{
    // Logged out + default consents + fallback: we have a discrepancy where ConsentHub is down/unavailable, or they're just logged out,
    // but the user has actually consented previously (which essentially the only way to save to the fallback to begin with)
    if (fallbackConsentToken) {
        const fallbackUserIsAuthenticatedBit = getUserIsAuthenticatedBit(fallbackConsentToken);
        const isLoggedOutFallbackConsents = !(0, _helpers.getBoolFromBitValue)(fallbackUserIsAuthenticatedBit);
        const fallbackTokenHasGenuineConsents = !(0, _utils1.checkIfTokenIsDefault)(fallbackConsentToken);
        const localOnlyUsersHasGenuineConsents = isLoggedOutFallbackConsents && fallbackTokenHasGenuineConsents;
        // If the fallback is from a logged out consent (localOnlyConsent), they're currently
        // logged out and also saved while logged out, so don't show the banner
        if (localOnlyUsersHasGenuineConsents) return !fallbackTokenHasGenuineConsents;
        const loggedOutUserPreviouslyConsentedWhileLoggedIn = !isLoggedOutFallbackConsents && fallbackTokenHasGenuineConsents;
        if (loggedOutUserPreviouslyConsentedWhileLoggedIn) // Or if it is from a logged in consent, and they've consented somewhere (they must have)
        // then we should not show the banner, as their consents aren't "stale", we're just in a situation
        // where the original token has expired so they get a default set, but we should hide the banner
        return false;
    }
    // Defaults consents + unauthed + missing a fallback, show the banner, as they haven't consented in the past year
    return true;
};
const shouldShowBannerForLoggedOutUser = ({ consentToken, fallbackConsentToken })=>{
    const tokenIsADefaultConsent = !!(0, _utils1.checkIfTokenIsDefault)(consentToken);
    // Handle default token flow
    if (tokenIsADefaultConsent) return shouldShowBannerForLoggedOutDefaultToken(fallbackConsentToken);
    // Handle genuine token flow
    // If they're a legacy/V2 user who hasn't consented, this will have checked the V3 "is default" bit to note they've consented or not
    const localOnlyUserHasConsented = (0, _utils1.hasLegacyV2TokenConsentedPreviously)(consentToken) || !tokenIsADefaultConsent;
    if (localOnlyUserHasConsented) // LocalOnly users will never have a timestamp to validate against since they can't talk to ConsentHub
    // Existence of fallback consents means they've consented in the past year and do not have stale consents, do not show banner
    return fallbackConsentToken ? false : true;
    // This case should never be hit: if it's not a default, but they haven't consented... what is it? Add a catch-all "show banner"
    return true;
};
const shouldShowBannerForLoggedInDefaultToken = (fallbackConsentToken)=>{
    // Defaults + fallback + logged in, but they consented while they were previously logged out:
    if (fallbackConsentToken) {
        const fallbackUserIsAuthenticatedBit = getUserIsAuthenticatedBit(fallbackConsentToken);
        const isLoggedOutFallbackConsents = !(0, _helpers.getBoolFromBitValue)(fallbackUserIsAuthenticatedBit);
        const fallbackTokenHasGenuineConsents = !(0, _utils1.checkIfTokenIsDefault)(fallbackConsentToken);
        if (fallbackTokenHasGenuineConsents) {
            // Defaults + logged in user + consented <1yr ago, but while logged out
            if (isLoggedOutFallbackConsents) /*
        They've consented, and thus stored a fallback while logged out (fallback's CH bit is 1),
        then fetched from CH but get empty data (since they couldn't save to CH on their initial "save"), which sets authed consent defaults (bit 0)

        UX Problem:
        Since they have genuinely consented within the past year, the ideal UX would be to not show the banner...
        But if we do not re-prompt here in an effort to recapture their consents, the opportunity for them/us to actually get consents in the DB
        is infrequent (either via Account Privacy Page or once this fallback expires in a year).

        Example:
        While logged out, they consent in Trello, so we store the unauthed fallback token, then log in on Trello. If we hide the banner when the
        fallback exists, if that user later goes to Confluence's cookie domain (where they have no fallback), it would show the banner
        because they have no stored consents on CH, and no fallback in that domain, but are logged in. Repeat for every new domain...

        We could be fancy and save under the hood for them if they have a fallback, but to ensure we don't copy stale/different consents saved in a fallback
        to ConsentHub on their behalf, we should just re-prompt them for consents now that they're logged in. This way, they will actually
        persist their choices, and when loading other domains/products, there will be a Source of Truth to reference and not show the banner.

        Ultimately, this feels like the more "correct" way to handle this situation, as the cost of showing the banner again to officially capture
        consents feels lower than the potential cost of relying on fallbacks in all situations/across all domains for this user for the next whole year

        Result: Show the banner again and hope we officially recapture consents this time around
      */ return true;
            // Defaults + logged in user + consented <1yr ago, but while logged in
            // This scenario shouldn't happen, or if it does, it's in a phase where we haven't fetched preferences
            // yet, so hide the banner for now
            return false;
        }
        // Default token + default fallback (authed or unauthed) mean we've likely stored this
        // fallback from SSR's initialPreferences flow in. Fallbacks should not be saved with defaults intentionally
        // But sometimes we copy an existing token to the fallback via SSR flow, so let's treat this
        // as an bunk fallback, and show the banner as they haven't consented
        return true;
    }
    // Default consent token + logged in user + no fallback = they haven't consented in the past year, show banner
    return true;
};
const shouldShowBannerForLoggedInUser = ({ consentToken, consentTimestamp, fallbackConsentToken })=>{
    // Handle default token flow
    const tokenIsADefaultConsent = !!(0, _utils1.checkIfTokenIsDefault)(consentToken);
    if (tokenIsADefaultConsent) return shouldShowBannerForLoggedInDefaultToken(fallbackConsentToken);
    // Handle genuine token flow
    if (consentTimestamp) {
        // If the user has genuine consents, and a timestamp, check if they're stale (> 1yr old), show the banner if they're stale
        const showBannerIfStale = (0, _utils1.checkIfConsentsAreStale)(consentTimestamp);
        return showBannerIfStale;
    }
    // Genuine consents + no timestamp— we're in a situation where we've been passed cached cookie data instead of CH response data,
    // so the only way to determine staleness is through the absence of the fallback.
    // Technically, we could assume since they've consented recently, we don't have to show the banner here but... to be safe we should
    return fallbackConsentToken ? false : true;
};
const getBannerVisibility = ({ consentToken, consentTimestamp, fallbackConsentToken: fallbackConsents }, ssrOptions)=>{
    // Consent tokens are either a set of defaults, or genuine (persisted to the remote, or saved in an entire local-only flow via fallbacks).
    // the deciding factor is whether or not your consents are stale/fresh, either via the existence/absence of a fallback (a.k.a consented within a year or not)
    // or if the ConsentHub response data of a user's consent has a timestamp that is older than a year
    // Detect if js-cookie has been replaced with SSR-safe version (Confluence only)
    const isJsCookieSSRSafe = typeof (0, _jsCookieDefault.default).__SSR_INITIALIZE_COOKIES__ === 'function';
    // Jira passes getCookie explicitly via ssrOptions - it works on both SSR and CSR.
    const ssrFriendlyGetCookie = ssrOptions === null || ssrOptions === void 0 ? void 0 : ssrOptions.getCookie;
    let fallbackConsentToken;
    if (ssrFriendlyGetCookie) fallbackConsentToken = fallbackConsents || ssrFriendlyGetCookie((0, _constants.ATLASSIAN_CONSENT_FALLBACK_COOKIE_KEY));
    else fallbackConsentToken = (0, _utils.isSSR)() ? fallbackConsents || (isJsCookieSSRSafe ? (0, _getCookie.getCookie)((0, _constants.ATLASSIAN_CONSENT_FALLBACK_COOKIE_KEY)) : undefined) : fallbackConsents || (0, _getCookie.getCookie)((0, _constants.ATLASSIAN_CONSENT_FALLBACK_COOKIE_KEY));
    let userIsAuthenticatedBit = getUserIsAuthenticatedBit(consentToken);
    const isLoggedOutConsentToken = !(0, _helpers.getBoolFromBitValue)(userIsAuthenticatedBit);
    let isBannerVisible = true; // By default, show the banner to every user
    // Unauthed/logged out user flow, should never receive a timestamp because logged out users can't communicate to ConsentHub
    if (isLoggedOutConsentToken) isBannerVisible = shouldShowBannerForLoggedOutUser({
        consentToken,
        fallbackConsentToken
    });
    else // Authed/logged in user flow
    isBannerVisible = shouldShowBannerForLoggedInUser({
        consentToken,
        fallbackConsentToken,
        consentTimestamp
    });
    return isBannerVisible;
};

},{"js-cookie":"brgOH","../../../common/utils":"gnWyu","../../../common/utils/helpers":"kWrwq","../../../constants":"9FHD5","../../../services/consent-hub-service/utils":"8vzek","../../cookie-controls/get-cookie":"VS0K5","../../cookie-controls/transformer":"hcsh1","@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"8vzek":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "hasLegacyV2TokenConsentedPreviously", ()=>hasLegacyV2TokenConsentedPreviously);
parcelHelpers.export(exports, "checkIfTokenIsDefault", ()=>checkIfTokenIsDefault);
parcelHelpers.export(exports, "getDefaultBits", ()=>getDefaultBits);
parcelHelpers.export(exports, "getSavedConsentBits", ()=>getSavedConsentBits);
parcelHelpers.export(exports, "serializeConsents", ()=>serializeConsents);
parcelHelpers.export(exports, "deserializeConsents", ()=>deserializeConsents);
parcelHelpers.export(exports, "getConsentTimestamp", ()=>getConsentTimestamp);
parcelHelpers.export(exports, "checkIfConsentsAreStale", ()=>checkIfConsentsAreStale);
parcelHelpers.export(exports, "hasPrefetchedDataConsents", ()=>hasPrefetchedDataConsents);
parcelHelpers.export(exports, "StatusCodeError", ()=>StatusCodeError);
var _helpers = require("../../common/utils/helpers");
var _constants = require("../../constants");
// eslint-disable-next-line @atlassian/tangerine/import/no-restricted-paths
var _getCookie = require("../../controllers/cookie-controls/get-cookie");
var _types = require("../../types");
var _types1 = require("./types");
const isLegacyGeoTargetingV2Token = (consentToken)=>{
    const version = consentToken[0] + consentToken[1] + consentToken[2];
    const isV2Schema = version === (0, _constants.V002_SCHEMA_KEY);
    return isV2Schema;
};
const isLegacyV1Token = (consentToken)=>{
    const version = consentToken[0] + consentToken[1] + consentToken[2];
    const isV1Schema = version === (0, _constants.V001_SCHEMA_KEY);
    return isV1Schema;
};
const hasLegacyV2TokenConsentedPreviously = (consentToken)=>{
    if (isLegacyGeoTargetingV2Token(consentToken)) {
        // If we're looking at a V2 token and they have ANY saved 'consentedUnderXX' bits,
        // we know it must be a set of valid consents instead of defaults
        const consentedUnderGDPR = consentToken[8] === '1';
        const consentedUnderCPRA = consentToken[9] === '1';
        const consentedUnderLGPD = consentToken[10] === '1';
        const consentedUnderFADP = consentToken[11] === '1';
        const hasConsentedPreviously = consentedUnderGDPR || consentedUnderCPRA || consentedUnderLGPD || consentedUnderFADP;
        return hasConsentedPreviously;
    }
    return false;
};
const checkIfTokenIsDefault = (consentToken)=>{
    const isLegacyV1ConsentToken = isLegacyV1Token(consentToken);
    const isLegacyV2ConsentToken = isLegacyGeoTargetingV2Token(consentToken);
    if (isLegacyV1ConsentToken) // We only add a legacy `atl-gdpr-consents` cookie if a user has consented,
    // so if we see a V1 token, we know it must be a set of valid consents
    // instead of default consents
    return false;
    if (isLegacyV2ConsentToken) {
        const legacyTokenHasConsents = hasLegacyV2TokenConsentedPreviously(consentToken);
        return !legacyTokenHasConsents;
    }
    // Check 'isDefaultConsentBit' bit for V003 Schema tokens
    const isDefaultTokenV3 = (0, _helpers.getBoolFromBitValue)(consentToken[7]);
    return isDefaultTokenV3;
};
const getDefaultBits = (consentsUnavailable)=>{
    const version = (0, _constants.V003_SCHEMA_KEY);
    // DEFAULT_PREFERENCES now has the default boolean baked into it, so we don't need to set it here
    const serializedBits = Object.entries((0, _constants.DEFAULT_PREFERENCES)).reduce((acc, [key, val])=>{
        // Skip the STRICTLY_NECESSARY as it's always allowed
        if (key === (0, _types.PreferenceCategory).StrictlyNecessary) return acc;
        if (key === (0, _types.ContextualConsentProperty).UserIsAuthenticated) {
            // If consents are missing when setting these defaults, the user will be logged out,
            // so pack this info into the consent token bits
            const userIsAuthed = !consentsUnavailable;
            return acc + (0, _helpers.getBitValueFromBool)(userIsAuthed);
        }
        if (key === (0, _types.ContextualConsentProperty).ConsentDataUnavailable) // If consents are missing when setting these defaults, the user will be logged out,
        // so pack this info into the consent token bits
        return acc + (0, _helpers.getBitValueFromBool)(!!consentsUnavailable);
        return acc + (0, _helpers.getBitValueFromBool)(val);
    }, '');
    return `${version}${serializedBits}`;
};
const getSavedConsentBits = (consents)=>{
    var _consents_find, _consents_find1, _consents_find2, _consents_find3;
    const version = (0, _constants.V003_SCHEMA_KEY);
    // As 'strictlyNecessaryConsent' would always be allowed, we don't store it in the cookie or use ConsentHub
    const functionalConsent = (0, _helpers.getBitValueFromBool)(!!((_consents_find = consents.find((key)=>key.key === (0, _types1.ConsentHubKey).Functional)) === null || _consents_find === void 0 ? void 0 : _consents_find.granted));
    const analyticsConsent = (0, _helpers.getBitValueFromBool)(!!((_consents_find1 = consents.find((key)=>key.key === (0, _types1.ConsentHubKey).Analytics)) === null || _consents_find1 === void 0 ? void 0 : _consents_find1.granted));
    const marketingConsent = (0, _helpers.getBitValueFromBool)(!!((_consents_find2 = consents.find((key)=>key.key === (0, _types1.ConsentHubKey).Marketing)) === null || _consents_find2 === void 0 ? void 0 : _consents_find2.granted));
    const unknownConsent = (0, _helpers.getBitValueFromBool)(!!((_consents_find3 = consents.find((key)=>key.key === (0, _types1.ConsentHubKey).Unknown)) === null || _consents_find3 === void 0 ? void 0 : _consents_find3.granted));
    // As these consents were returned from the server, ConsentHub is obviously available, they're logged in, and aren't defaults
    const isDefaultToken = 0;
    const userIsAuthenticated = 1;
    const consentHubDataUnavailable = 0;
    return [
        version,
        functionalConsent,
        analyticsConsent,
        marketingConsent,
        unknownConsent,
        isDefaultToken,
        userIsAuthenticated,
        consentHubDataUnavailable
    ].join('');
};
const serializeConsents = ({ consents })=>{
    if (!consents) {
        // When generating consents for an unauthenticated user, use the fallback token if it exists
        // This circumvents us setting defaults for them if their token has expired, but they have consented previously
        const existingFallbackToken = (0, _getCookie.getCookie)((0, _constants.ATLASSIAN_CONSENT_FALLBACK_COOKIE_KEY));
        if (existingFallbackToken) return existingFallbackToken;
        // User is unauthed, will only use local consenting, consent data will also be unavailable
        return getDefaultBits(true); // e.g. 0030000101
    } else if (consents.length === 0) // User is authed but has no consents in the system, so use defaults in the interim, consentData must be available
    return getDefaultBits(); // e.g. 0030000110
    else // User is authed and has consents in the system
    return getSavedConsentBits(consents); // e.g. 0030110110
};
const deserializeConsents = (unpackedUserPreferences, displayedTextMap)=>{
    const validConsentHubCookieConsents = [
        (0, _types.PreferenceCategory).StrictlyNecessary,
        (0, _types.PreferenceCategory).Functional,
        (0, _types.PreferenceCategory).Analytics,
        (0, _types.PreferenceCategory).Marketing,
        (0, _types.PreferenceCategory).Unknown
    ];
    const consentKeyMap = {
        [(0, _types.PreferenceCategory).StrictlyNecessary]: (0, _types1.ConsentHubKey).StrictlyNecessary,
        [(0, _types.PreferenceCategory).Functional]: (0, _types1.ConsentHubKey).Functional,
        [(0, _types.PreferenceCategory).Analytics]: (0, _types1.ConsentHubKey).Analytics,
        [(0, _types.PreferenceCategory).Marketing]: (0, _types1.ConsentHubKey).Marketing,
        [(0, _types.PreferenceCategory).Unknown]: (0, _types1.ConsentHubKey).Unknown
    };
    const consentRecords = validConsentHubCookieConsents.map((consentKey)=>{
        const key = consentKeyMap[consentKey];
        return {
            key,
            granted: !!unpackedUserPreferences[consentKey],
            gatheredTs: new Date().toISOString(),
            displayedText: displayedTextMap[consentKey]
        };
    });
    return consentRecords;
};
const getConsentTimestamp = ({ consents })=>{
    if (consents && consents.length) {
        // As consents can be updated individually, we need to find the most recent timestamp to use as "most recent consent"
        const timestamps = consents.map((consent)=>{
            return new Date(consent.updatedTs).getTime();
        });
        const maxTimestamp = Math.max(...timestamps);
        const mostRecentConsentTimestamp = new Date(maxTimestamp).toISOString();
        return mostRecentConsentTimestamp;
    }
};
const checkIfConsentsAreStale = (consentTimestamp)=>{
    // Privacy has determined that we should re-prompt users for consent if they haven't
    // consented in over a year regardless, because they're legally stale/expired
    let consentedOverAYearAgo = false;
    if (consentTimestamp) {
        const oneYearAgo = new Date();
        oneYearAgo.setFullYear(oneYearAgo.getFullYear() - 1);
        consentedOverAYearAgo = new Date(consentTimestamp) < oneYearAgo;
    }
    return consentedOverAYearAgo;
};
const hasPrefetchedDataConsents = (preferences)=>{
    if (!preferences) return false;
    const prefetchedToken = 'consentToken' in preferences && preferences.consentToken;
    const prefetchedTokenIsDefault = checkIfTokenIsDefault(prefetchedToken || '');
    const hasLegitConsentToken = prefetchedToken && !prefetchedTokenIsDefault;
    const prefetchedConsents = 'consents' in preferences && preferences.consents;
    const hasLegitConsents = prefetchedConsents && Array.isArray(prefetchedConsents) && prefetchedConsents.length > 0;
    return Boolean(hasLegitConsentToken || hasLegitConsents);
};
class StatusCodeError extends Error {
    constructor(message, status){
        super(message);
        this.status = status;
        Object.setPrototypeOf(this, StatusCodeError.prototype);
        // Captures the stack trace (for environments that support it)
        if (Error.captureStackTrace) Error.captureStackTrace(this, StatusCodeError);
        this.name = 'StatusCodeError';
    }
}

},{"../../common/utils/helpers":"kWrwq","../../constants":"9FHD5","../../controllers/cookie-controls/get-cookie":"VS0K5","../../types":"65Pa5","./types":"fzH6h","@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"fzH6h":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "ConsentHubKey", ()=>ConsentHubKey);
var ConsentHubKey = /*#__PURE__*/ function(ConsentHubKey) {
    ConsentHubKey["StrictlyNecessary"] = "strictlyNecessaryCookies";
    ConsentHubKey["Functional"] = "functionalCookies";
    ConsentHubKey["Analytics"] = "performanceCookies";
    ConsentHubKey["Marketing"] = "targetingCookies";
    ConsentHubKey["Unknown"] = "unknownCookies";
    return ConsentHubKey;
}({});

},{"@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"hcsh1":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "checkTokenVersionValidity", ()=>checkTokenVersionValidity);
parcelHelpers.export(exports, "packUserPreferences", ()=>packUserPreferences);
parcelHelpers.export(exports, "unpackUserPreferencesCookie", ()=>unpackUserPreferencesCookie);
parcelHelpers.export(exports, "initialPreferencesAreMissing", ()=>initialPreferencesAreMissing);
parcelHelpers.export(exports, "initializePreferencesData", ()=>initializePreferencesData);
var _objectSpread = require("@swc/helpers/_/_object_spread");
var _objectSpreadProps = require("@swc/helpers/_/_object_spread_props");
var _utils = require("../../../common/utils");
var _helpers = require("../../../common/utils/helpers");
var _constants = require("../../../constants");
var _utils1 = require("../../../services/consent-hub-service/utils");
var _types = require("../../../types");
const checkTokenVersionValidity = (consentToken)=>{
    // A token can technically be bad data (alphanumeric instead of binary) but we should fail gracefully if so
    if (consentToken.length < 3) // Wrong format, no version
    return {
        isValid: false,
        isV001: false,
        isV002: false,
        isV003: false
    };
    const version = consentToken[0] + consentToken[1] + consentToken[2];
    const isV001 = version === (0, _constants.V001_SCHEMA_KEY) && consentToken.length === 7;
    const isV002 = version === (0, _constants.V002_SCHEMA_KEY) && consentToken.length === 12;
    const isV003 = version === (0, _constants.V003_SCHEMA_KEY) && consentToken.length === 10;
    // We support version 001, 002, 003 only
    const isSupportedVersion = [
        (0, _constants.V001_SCHEMA_KEY),
        (0, _constants.V002_SCHEMA_KEY),
        (0, _constants.V003_SCHEMA_KEY)
    ].includes(version);
    const isValid = isSupportedVersion && (isV001 || isV002 || isV003);
    return {
        isValid,
        isV001,
        isV002,
        isV003
    };
};
/* Schema Version 001:
---------------------------------------------------
  - Format 0000000
  - 001 (schema version 3 digits)
  - 0/1 (1 digit, FUNCTIONAL cookies disabled/enabled)
  - 0/1 (1 digit, ANALYTICS cookies disabled/enabled)
  - 0/1 (1 digit, MARKETING cookies disabled/enabled)
  - 0/1 (1 digit, UNKNOWN cookies disabled/enabled)
*/ const packPrefsVersion001 = (userPreferences)=>{
    const version = (0, _constants.V001_SCHEMA_KEY);
    return [
        version,
        (0, _helpers.getBitValueFromBool)(userPreferences.FUNCTIONAL),
        (0, _helpers.getBitValueFromBool)(userPreferences.ANALYTICS),
        (0, _helpers.getBitValueFromBool)(userPreferences.MARKETING),
        (0, _helpers.getBitValueFromBool)(userPreferences.UNKNOWN)
    ].join('');
};
const unpackPrefsVersion001 = (userPreferencesCookie)=>{
    if (userPreferencesCookie.length !== 7) // Wrong length for version 001
    return;
    return {
        [(0, _types.PreferenceCategory).StrictlyNecessary]: true,
        [(0, _types.PreferenceCategory).Functional]: userPreferencesCookie[3] === '1',
        [(0, _types.PreferenceCategory).Analytics]: userPreferencesCookie[4] === '1',
        [(0, _types.PreferenceCategory).Marketing]: userPreferencesCookie[5] === '1',
        [(0, _types.PreferenceCategory).Unknown]: userPreferencesCookie[6] === '1'
    };
};
/* Schema Version 002 ***** DEPRECATED *****
---------------------------------------------------
  - Format 000000000000
  - 002 (schema version, 3 digits)
  - 0/1 (1 digit, FUNCTIONAL cookies - disabled/enabled)
  - 0/1 (1 digit, ANALYTICS cookies - disabled/enabled)
  - 0/1 (1 digit, MARKETING cookies - disabled/enabled)
  - 0/1 (1 digit, UNKNOWN cookies - disabled/enabled)
  - 0/1 (1 digit, consent records are unavailable from ConsentHub (logged out) - yes/no)
  - 0/1 (1 digit, consents saved while in GDPR locale (Europe) - yes/no)
  - 0/1 (1 digit, consents saved while in CPRA locale (CPRA will act as 'all USA' bucket) - yes/no)
  - 0/1 (1 digit, consents saved while in LGPD locale (Brazil) - yes/no)
  - 0/1 (1 digit, consents saved while in FADP locale (Switzerland) - yes/no)
*/ const packPrefsVersion002 = (userPreferences)=>{
    // As we want to slowly kill off any V002 preferences, if we're provided one for some reason
    // internally convert it to a V003 preference to drop contextual GeoIP details
    const version = (0, _constants.V003_SCHEMA_KEY);
    const hasConsentedPreviously = userPreferences[(0, _types.ConsentPreferenceV2).ConsentedUnderGDPR] || userPreferences[(0, _types.ConsentPreferenceV2).ConsentedUnderCPRA] || userPreferences[(0, _types.ConsentPreferenceV2).ConsentedUnderLGPD] || userPreferences[(0, _types.ConsentPreferenceV2).ConsentedUnderFADP];
    const isDefaultConsentBit = !hasConsentedPreviously;
    // As we've broken out authentication insights/context from "ConsentDataUnavailable" bit in V3,
    // and it does not exist, we will backfill the value based on the previous bit state
    const existingConsentDataUnavailableBit = userPreferences[(0, _types.ContextualConsentProperty).ConsentDataUnavailable];
    const userIsAuthenticatedBit = !existingConsentDataUnavailableBit;
    return [
        version,
        (0, _helpers.getBitValueFromBool)(userPreferences[(0, _types.PreferenceCategory).Functional]),
        (0, _helpers.getBitValueFromBool)(userPreferences[(0, _types.PreferenceCategory).Analytics]),
        (0, _helpers.getBitValueFromBool)(userPreferences[(0, _types.PreferenceCategory).Marketing]),
        (0, _helpers.getBitValueFromBool)(userPreferences[(0, _types.PreferenceCategory).Unknown]),
        (0, _helpers.getBitValueFromBool)(isDefaultConsentBit),
        (0, _helpers.getBitValueFromBool)(userIsAuthenticatedBit),
        (0, _helpers.getBitValueFromBool)(existingConsentDataUnavailableBit)
    ].join('');
};
const unpackPrefsVersion002 = (userPreferencesCookie)=>{
    // If the provided V002 token has consented anywhere, we'll drop the contextual GeoIP bits and
    // convert it to a V003 schema
    const isADefaultConsentToken = (0, _utils1.checkIfTokenIsDefault)(userPreferencesCookie);
    // Backfill the value based on the previous "ConsentDataUnavailable" bit state as we've broken this contextual info out
    const consentDataUnavailable = userPreferencesCookie[7] === '1';
    const userIsDeemedAuthenticated = !consentDataUnavailable;
    return (0, _objectSpreadProps._)((0, _objectSpread._)({}, unpackPrefsVersion003(userPreferencesCookie)), {
        [(0, _types.ContextualConsentProperty).ConsentsAreDefault]: !!isADefaultConsentToken,
        [(0, _types.ContextualConsentProperty).UserIsAuthenticated]: userIsDeemedAuthenticated,
        [(0, _types.ContextualConsentProperty).ConsentDataUnavailable]: consentDataUnavailable
    });
};
/* Schema Version 003
---------------------------------------------------
  - Format 0000000000
  - 003 (schema version, 3 digits)
  - 0/1 (1 digit, FUNCTIONAL cookies - disabled/enabled)
  - 0/1 (1 digit, ANALYTICS cookies - disabled/enabled)
  - 0/1 (1 digit, MARKETING cookies - disabled/enabled)
  - 0/1 (1 digit, UNKNOWN cookies - disabled/enabled)
  - 0/1 (1 digit, Consent token in a default state, user has yet to consent) - no/yes)
  - 0/1 (1 digit, User is authenticated, did not 401 during save) - no/yes)
  - 0/1 (1 digit, ConsentHub records are unavailable (CH is down, errored while saving, etc) - no/yes)
*/ const packPrefsVersion003 = (userPreferences)=>{
    const version = (0, _constants.V003_SCHEMA_KEY);
    return [
        version,
        (0, _helpers.getBitValueFromBool)(userPreferences[(0, _types.PreferenceCategory).Functional]),
        (0, _helpers.getBitValueFromBool)(userPreferences[(0, _types.PreferenceCategory).Analytics]),
        (0, _helpers.getBitValueFromBool)(userPreferences[(0, _types.PreferenceCategory).Marketing]),
        (0, _helpers.getBitValueFromBool)(userPreferences[(0, _types.PreferenceCategory).Unknown]),
        (0, _helpers.getBitValueFromBool)(userPreferences[(0, _types.ContextualConsentProperty).ConsentsAreDefault]),
        (0, _helpers.getBitValueFromBool)(userPreferences[(0, _types.ContextualConsentProperty).UserIsAuthenticated]),
        (0, _helpers.getBitValueFromBool)(userPreferences[(0, _types.ContextualConsentProperty).ConsentDataUnavailable])
    ].join('');
};
const unpackPrefsVersion003 = (userPreferencesCookie)=>{
    return {
        [(0, _types.PreferenceCategory).StrictlyNecessary]: true,
        [(0, _types.PreferenceCategory).Functional]: userPreferencesCookie[3] === '1',
        [(0, _types.PreferenceCategory).Analytics]: userPreferencesCookie[4] === '1',
        [(0, _types.PreferenceCategory).Marketing]: userPreferencesCookie[5] === '1',
        [(0, _types.PreferenceCategory).Unknown]: userPreferencesCookie[6] === '1',
        [(0, _types.ContextualConsentProperty).ConsentsAreDefault]: userPreferencesCookie[7] === '1',
        [(0, _types.ContextualConsentProperty).UserIsAuthenticated]: userPreferencesCookie[8] === '1',
        [(0, _types.ContextualConsentProperty).ConsentDataUnavailable]: userPreferencesCookie[9] === '1'
    };
};
const V002SpecificBitKeys = [
    (0, _types.ContextualConsentProperty).ConsentDataUnavailable,
    (0, _types.ConsentPreferenceV2).ConsentedUnderGDPR,
    (0, _types.ConsentPreferenceV2).ConsentedUnderCPRA,
    (0, _types.ConsentPreferenceV2).ConsentedUnderLGPD,
    (0, _types.ConsentPreferenceV2).ConsentedUnderFADP
];
const V003SpecificBitKeys = [
    (0, _types.ContextualConsentProperty).ConsentsAreDefault,
    (0, _types.ContextualConsentProperty).UserIsAuthenticated,
    (0, _types.ContextualConsentProperty).ConsentDataUnavailable
];
function packUserPreferences(userPreferences) {
    if ((0, _utils.getBscGlobalState)().localConsentMode) return packPrefsVersion001(userPreferences);
    const isV002 = V002SpecificBitKeys.every((key)=>key in userPreferences);
    if (isV002) // As V002 is deprecated, if we've been provided V002 set of "legacy" prefs, internally
    // convert them to V003 to drop the unnecessary contextual details
    return packPrefsVersion002(userPreferences);
    const isV003 = V003SpecificBitKeys.every((key)=>key in userPreferences);
    if (isV003) return packPrefsVersion003(userPreferences);
    // Fallback to V001
    return packPrefsVersion001(userPreferences);
}
function unpackUserPreferencesCookie(userPreferencesCookie) {
    if ((0, _utils.getBscGlobalState)().localConsentMode) {
        if (userPreferencesCookie.length < 3) // Wrong format, no version
        return;
        const version = userPreferencesCookie[0] + userPreferencesCookie[1] + userPreferencesCookie[2];
        if (version === (0, _constants.V001_SCHEMA_KEY)) return unpackPrefsVersion001(userPreferencesCookie);
        return;
    }
    const { isValid, isV001, isV002, isV003 } = checkTokenVersionValidity(userPreferencesCookie);
    if (!isValid) // We support version 001, 002, 003 only
    return;
    if (isV001) return unpackPrefsVersion001(userPreferencesCookie);
    if (isV002) // Deprecated, so this will unpack to 003 to drop the contextual GeoIP bits
    return unpackPrefsVersion002(userPreferencesCookie);
    if (isV003) return unpackPrefsVersion003(userPreferencesCookie);
}
const initialPreferencesAreMissing = (initialPreferences)=>{
    if (!initialPreferences) return true;
    const prefExistButAreEmpty = Object.keys(initialPreferences).length === 0;
    return prefExistButAreEmpty;
};
const initializePreferencesData = (initialPreferences)=>{
    if (initialPreferences !== (0, _types.PrefetchedPreferenceState).INTERNAL) {
        if (initialPreferencesAreMissing(initialPreferences)) // Failsafe handling: Consumer failed to provide data even though they have prefetched, so we need to fetch again
        // This may occur if a consumer's prefetch requests fails, or if they fail to implement the system correctly
        return {
            prefs: undefined,
            isPrefetchedPrefsInternalState: true
        };
        // If initialPreferences is not INTERNAL on first render, we have been provided a pre-fetched
        // value, which means we don't need to make a fetch to storage or ConsentHub to get it.
        // If that preference is defined, we persist it to our local cookie set
        // If the data is a ConsentHubResponse/PrefetchedConsentCookieData, we'll need to transform it properly before consumption
        const consentToken = initialPreferences && 'consentToken' in initialPreferences && initialPreferences.consentToken;
        if (consentToken) {
            // We already have a consent cookie that was passed in, let's not override it by setting it again
            const unpackedExistingPrefs = unpackUserPreferencesCookie(consentToken);
            return {
                prefs: unpackedExistingPrefs,
                isPrefetchedPrefsInternalState: !Boolean(unpackedExistingPrefs)
            };
        }
        // This type guard protects the below casting of ConsentHubResponse ensuring we have the correct shape
        if (initialPreferences && 'consents' in initialPreferences) {
            const serializedPrefetchedConsentToken = (0, _utils1.serializeConsents)(initialPreferences);
            const unpackedPrefetchedPrefs = unpackUserPreferencesCookie(serializedPrefetchedConsentToken);
            return {
                prefs: unpackedPrefetchedPrefs,
                isPrefetchedPrefsInternalState: !Boolean(unpackedPrefetchedPrefs)
            };
        }
    }
    // If we've fallen into this, EMPTY implies we have no data at all
    // INTERNAL implies we still need to fetch new data, so trigger a refetch
    if (initialPreferences === (0, _types.PrefetchedPreferenceState).INTERNAL) return {
        prefs: undefined,
        isPrefetchedPrefsInternalState: true
    };
    return {
        prefs: undefined,
        isPrefetchedPrefsInternalState: false
    };
};

},{"@swc/helpers/_/_object_spread":"9gdrV","@swc/helpers/_/_object_spread_props":"kANqQ","../../../common/utils":"gnWyu","../../../common/utils/helpers":"kWrwq","../../../constants":"9FHD5","../../../services/consent-hub-service/utils":"8vzek","../../../types":"65Pa5","@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"dUkaQ":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "setStrictlyNecessaryCookie", ()=>setStrictlyNecessaryCookie);
var _objectSpread = require("@swc/helpers/_/_object_spread");
var _objectSpreadProps = require("@swc/helpers/_/_object_spread_props");
var _jsCookie = require("js-cookie");
var _jsCookieDefault = parcelHelpers.interopDefault(_jsCookie);
var _platformFeatureFlags = require("@atlaskit/platform-feature-flags");
var _utils = require("../../../common/utils");
var _logger = require("../../../common/utils/logger");
const setStrictlyNecessaryCookie = (key, value, attributes)=>{
    if ((0, _platformFeatureFlags.fg)('platform_moonjelly_bsc_master_killswitch')) // Set the cookie without package operational events
    // when master killswitch is enabled
    (0, _jsCookieDefault.default).set(key, value, (0, _objectSpreadProps._)((0, _objectSpread._)({}, attributes), {
        'atl-set-cookie': true
    }));
    else try {
        if (!(0, _utils.getBscGlobalState)().hasInitialized && (0, _platformFeatureFlags.fg)('platform_bsc_initialize_controls_analytics')) (0, _utils.sendPackageOperationalEvent)({
            action: 'setItemWithoutInit',
            attributes: {
                itemKey: key,
                storageType: 'Cookie'
            }
        });
        (0, _utils.sendPackageOperationalEvent)({
            action: 'usedSetStrictlyNecessaryCookie',
            attributes: {
                cookieKey: key
            }
        });
        (0, _jsCookieDefault.default).set(key, value, (0, _objectSpreadProps._)((0, _objectSpread._)({}, attributes), {
            'atl-set-cookie': true
        }));
    } catch (e) {
        (0, _logger.Logger).errorWithOperationalEvent({
            action: 'usedSetStrictlyNecessaryCookieError',
            attributes: {
                cookieKey: key
            },
            message: `Failed to use set strictly necessary cookie. ${e.message || ''}`
        });
    }
};

},{"@swc/helpers/_/_object_spread":"9gdrV","@swc/helpers/_/_object_spread_props":"kANqQ","js-cookie":"brgOH","@atlaskit/platform-feature-flags":"8rD2i","../../../common/utils":"gnWyu","../../../common/utils/logger":"2Tk7J","@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"4efx5":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "getValidConsentData", ()=>getValidConsentData);
var _constants = require("../../../constants");
var _consentHubService = require("../../../services/consent-hub-service");
var _transformer = require("../transformer");
const getValidConsentData = async (fallbackConsentToken)=>{
    // Fetches preferences from ConsentHub and returns serialized token data if possible
    const consentData = await (0, _consentHubService.fetchConsentPreferences)();
    let { consentToken, consentTimestamp, consentHubInaccessible } = consentData;
    let { isValid } = (0, _transformer.checkTokenVersionValidity)(consentToken);
    if (isValid && consentHubInaccessible) {
        if (fallbackConsentToken) // `consentHubInaccessible`: ConsentHub request failed (e.g. service is down/bad request/etc). Attempt to use
        // any previously set consents in the interim if we have them.
        consentToken = fallbackConsentToken;
        else {
            const version = (0, _constants.V003_SCHEMA_KEY);
            const consents = consentToken.slice(3, 7);
            // V003 BSC bits set to reflect default consent token status, authenticated user status,
            // and unavailable consentHub records status)
            const serviceBits = '111';
            // Temporary: Sets a default token with V003 properties
            // when ConsentHub is inaccessible and there is not fallback token. This
            // will ensure the banner isn't shown when ConsentHub is down.
            consentToken = `${version}${consents}${serviceBits}`;
        }
    }
    return isValid ? {
        consentToken,
        consentTimestamp
    } : undefined;
};

},{"../../../constants":"9FHD5","../../../services/consent-hub-service":"8HdyV","../transformer":"hcsh1","@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"8HdyV":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "buildConsentPreferences", ()=>buildConsentPreferences);
parcelHelpers.export(exports, "fetchConsentPreferences", ()=>fetchConsentPreferences);
parcelHelpers.export(exports, "saveConsentPreferences", ()=>saveConsentPreferences);
var _objectSpread = require("@swc/helpers/_/_object_spread");
var _platformFeatureFlags = require("@atlaskit/platform-feature-flags");
var _utils = require("../../common/utils");
var _utils1 = require("./utils");
const BASE_CONSENTS_URL = '/gateway/api/consenthub/session';
const POST_CONSENTS_URL = `${BASE_CONSENTS_URL}/user`;
const GET_CONSENTS_URL = `${POST_CONSENTS_URL}/consents/cookies`;
const getConsentHubHeaders = ()=>(0, _objectSpread._)({
        'Content-Type': 'application/json'
    }, (0, _platformFeatureFlags.fg)('platform_bsc_consent_hub_x_origin') ? {
        'X-Request-Origin': 'bsc'
    } : {});
const buildConsentPreferences = (consentData)=>{
    if (consentData) {
        const serializedConsents = (0, _utils1.serializeConsents)(consentData);
        const consentTimestamp = (0, _utils1.getConsentTimestamp)(consentData);
        return {
            consentToken: serializedConsents,
            consentTimestamp
        };
    }
    // Without consent data (due to server failure or unauthenticated user), set defaults illustrating that absence
    return {
        consentToken: (0, _utils1.serializeConsents)({}),
        consentHubInaccessible: true
    };
};
const fetchConsentPreferences = async ()=>{
    const { origin } = window.location;
    const getFromConsentHubURL = `${origin}${GET_CONSENTS_URL}`;
    try {
        const response = await fetch(getFromConsentHubURL, {
            method: 'GET',
            headers: getConsentHubHeaders()
        });
        if (!response.ok) throw new Error(`Failed to fetch preferences from ConsentHub with status: ${response.status}`);
        const consentData = await response.json();
        return buildConsentPreferences(consentData);
    } catch (err) {
        (0, _utils.Logger).errorWithOperationalEvent({
            action: 'fetchConsentPreferencesError',
            message: err.message || ''
        });
        return buildConsentPreferences();
    }
};
const buildConsentRequestBody = (unpackedUserPreferences, displayedTextMap)=>{
    const { origin, pathname } = window.location;
    const deserializedConsents = (0, _utils1.deserializeConsents)(unpackedUserPreferences, displayedTextMap);
    // Type guard here so TS knows we're working with ConsentPreferenceV003
    const action = 'CONSENT_DATA_UNAVAILABLE' in unpackedUserPreferences && unpackedUserPreferences.CONSENT_DATA_UNAVAILABLE ? 'FORM_FILL' : 'UPDATE_PREFERENCES';
    const consentRequestBody = {
        action,
        consents: deserializedConsents,
        formUrl: `${origin}${pathname}`,
        locale: 'UNKNOWN',
        site: 'atlassian',
        source: 'COOKIE_PREFERENCES'
    };
    return JSON.stringify(consentRequestBody);
};
const saveConsentPreferences = async (unpackedUserPreferences, displayedTextMap)=>{
    const saveToConsentHubURL = `${window.location.origin}${POST_CONSENTS_URL}`;
    try {
        const response = await fetch(saveToConsentHubURL, {
            method: 'POST',
            headers: getConsentHubHeaders(),
            body: buildConsentRequestBody(unpackedUserPreferences, displayedTextMap)
        });
        // Saving is an async API (we don't know if the save succeeds) so returns 202 Accepted.
        // 401 = User is unauthenticated
        // 5xx = ConsentHub is unavailable
        if (!response.ok || response.status !== 202 && response.status !== 200) {
            const errMsg = `Failed to save preferences to ConsentHub with status: ${response.status}`;
            const errWithStatusCode = new (0, _utils1.StatusCodeError)(errMsg, response.status);
            throw errWithStatusCode;
        }
    } catch (err) {
        (0, _utils.Logger).errorWithOperationalEvent({
            action: 'saveConsentPreferencesError',
            message: err.message || ''
        });
        // Re-throw to any encapsulating logic, a la `setConsentToken()`
        throw err;
    }
};

},{"@swc/helpers/_/_object_spread":"9gdrV","@atlaskit/platform-feature-flags":"8rD2i","../../common/utils":"gnWyu","./utils":"8vzek","@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"4UZqe":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "ItemKeyCache", ()=>ItemKeyCache);
var _types = require("../../types");
class ItemKeyCacheService {
    markSetByPackage(storageType, itemKey) {
        this.cache[storageType].add(itemKey);
    }
    wasSetByPackage(storageType, itemKey) {
        return this.cache[storageType].has(itemKey);
    }
    constructor(){
        this.cache = Object.fromEntries(Object.keys((0, _types.CategoryStorageType)).map((storageType)=>{
            return [
                storageType,
                new Set()
            ];
        }));
    }
}
const ItemKeyCache = new ItemKeyCacheService();

},{"../../types":"65Pa5","@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"3TCEn":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "reportSetItemError", ()=>reportSetItemError);
var _platformFeatureFlags = require("@atlaskit/platform-feature-flags");
var _logger = require("../../../common/utils/logger");
/**
 * Identifies browser "quota exceeded" storage failures across the cross-browser variants (per MDN's
 * `Storage.setItem` exceptions): modern browsers throw a `DOMException` named `QuotaExceededError`;
 * legacy WebKit/Blink expose the numeric `code === 22` (`QUOTA_EXCEEDED_ERR`); Firefox historically
 * throws `NS_ERROR_DOM_QUOTA_REACHED` with `code === 1014`.
 */ const isQuotaExceededError = (error)=>{
    if (!error || typeof error !== 'object') return false;
    const { name, code } = error;
    return name === 'QuotaExceededError' || name === 'NS_ERROR_DOM_QUOTA_REACHED' || code === 22 || code === 1014;
};
const reportSetItemError = ({ message, attributes, error })=>{
    if (isQuotaExceededError(error) && (0, _platformFeatureFlags.fg)('platform_bsc_filter_quota_exceeded_set_item_errors')) {
        (0, _logger.Logger).error(message);
        return;
    }
    (0, _logger.Logger).errorWithOperationalEvent({
        action: 'usedAtlBrowserStorageSetItemError',
        message,
        attributes
    });
};

},{"@atlaskit/platform-feature-flags":"8rD2i","../../../common/utils/logger":"2Tk7J","@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"bAkzo":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "setStrictlyNecessaryStorageItem", ()=>setStrictlyNecessaryStorageItem);
var _utils = require("../../../common/utils");
var _logger = require("../../../common/utils/logger");
var _types = require("../../../types");
var _itemKeyCacheService = require("../../item-key-cache-service");
var _types1 = require("../types");
const setStrictlyNecessaryStorageItem = (itemKey, value, storageType, browserStorage)=>{
    const eventAttributes = {
        itemKey,
        storageType
    };
    try {
        (0, _utils.sendPackageOperationalEvent)({
            action: 'usedAtlBrowserStorageSetStrictlyNecessaryItem',
            attributes: eventAttributes
        });
        // note: at the time of writing, this doesn't actually do anything because browserStorage.setItem calls the original setItem, not the overridden one.
        // see this thread for more information: https://atlassian.slack.com/archives/C05U6KCDNQJ/p1778585948364219
        (0, _itemKeyCacheService.ItemKeyCache).markSetByPackage(storageType === (0, _types1.WebStorageType).LocalStorage ? (0, _types.CategoryStorageType).LocalStorage : (0, _types.CategoryStorageType).SessionStorage, itemKey);
        browserStorage.setItem(itemKey, value);
        return (0, _types.Status).SUCCESS;
    } catch (e) {
        (0, _logger.Logger).errorWithOperationalEvent({
            action: 'usedAtlBrowserStorageSetStrictlyNecessaryItemError',
            attributes: eventAttributes,
            message: `Failed to set strictly necessary ${storageType} item. ${e.message || ''}`
        });
        return (0, _types.Status).FAILED;
    }
};

},{"../../../common/utils":"gnWyu","../../../common/utils/logger":"2Tk7J","../../../types":"65Pa5","../../item-key-cache-service":"4UZqe","../types":"1dILA","@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"32cX9":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "REVOKED_COUNT_CEILING", ()=>REVOKED_COUNT_CEILING);
parcelHelpers.export(exports, "cleanupStorage", ()=>cleanupStorage);
var _jsCookie = require("js-cookie");
var _jsCookieDefault = parcelHelpers.interopDefault(_jsCookie);
var _platformFeatureFlags = require("@atlaskit/platform-feature-flags");
var _utils = require("../../../common/utils");
var _itemProcessing = require("../../../common/utils/item-processing");
var _webStorageService = require("../../../services/web-storage-service");
var _types = require("../../../types");
var _getPreferences = require("../../preferences-controls/get-preferences");
var _deleteCookie = require("../delete-cookie");
function isCategoryRevoked({ category, preferences }) {
    if (category === (0, _types.PreferenceCategory).StrictlyNecessary) return false;
    if (!preferences) return false;
    return !preferences[category];
}
function yieldToMain() {
    return new Promise((resolve)=>setTimeout(resolve, 0));
}
const ITEMS_PER_YIELD = 50;
const ENUMERATION_LIMIT = 500;
// Higher per-run enumeration limit, rolled out behind platform_bsc_increase_enumeration_limit so it
// can be reverted via flag (no deploy) if the larger sweep proves costly. Yielding to the main
// thread every ITEMS_PER_YIELD items is independent of the limit, so the loop stays cooperative at
// either value.
const INCREASED_ENUMERATION_LIMIT = 10000;
const REVOKED_COUNT_CEILING = 1000;
async function cleanupStorage() {
    try {
        const cleanupStartTime = performance.now();
        const globalState = (0, _utils.getBscGlobalState)();
        const preferences = await (0, _getPreferences.getPreferences)();
        const localStorage = (0, _webStorageService.findStorageTarget)((0, _webStorageService.WebStorageType).LocalStorage);
        const sessionStorage = (0, _webStorageService.findStorageTarget)((0, _webStorageService.WebStorageType).SessionStorage);
        const idb = window.indexedDB;
        const productName = globalState.product;
        const [localStorageCache, sessionStorageCache, cookieCache, indexedDBCache] = await Promise.all([
            globalState.loadCache((0, _types.CategoryStorageType).LocalStorage),
            globalState.loadCache((0, _types.CategoryStorageType).SessionStorage),
            globalState.loadCache((0, _types.CategoryStorageType).Cookies),
            globalState.loadCache((0, _types.CategoryStorageType).IndexedDB)
        ]);
        const revokedItems = [];
        const uncategorizedItems = [];
        let hitEnumerationLimit = false;
        let itemsProcessed = 0;
        let deletionCount = 0;
        const enumerationLimit = (0, _platformFeatureFlags.fg)('platform_bsc_increase_enumeration_limit') ? INCREASED_ENUMERATION_LIMIT : ENUMERATION_LIMIT;
        // localStorage
        const shouldDeleteWebStorage = !globalState.disableWebStorageConsentChecks && globalState.webStorageEnabled;
        if (localStorageCache) // eslint-disable-next-line @atlaskit/platform/no-direct-web-storage-usage -- existing usage
        for(let i = 0; i < localStorage.length(); i++){
            if (itemsProcessed >= enumerationLimit) {
                hitEnumerationLimit = true;
                break;
            }
            if ((itemsProcessed + 1) % ITEMS_PER_YIELD === 0) await yieldToMain();
            // eslint-disable-next-line @atlaskit/platform/no-direct-web-storage-usage -- existing usage
            const key = localStorage.key(i);
            if (key === null) continue;
            const category = (0, _itemProcessing.getItemCategoryFromPassedCache)(key, localStorageCache, productName);
            if (category === null || category === (0, _types.PreferenceCategory).Unknown) uncategorizedItems.push({
                key,
                storageType: 'localStorage'
            });
            else if (isCategoryRevoked({
                category,
                preferences
            })) {
                revokedItems.push({
                    key,
                    storageType: 'localStorage',
                    category
                });
                if (shouldDeleteWebStorage && (0, _platformFeatureFlags.fg)('platform_bsc_cleanup_revoked_storage_live_delete')) {
                    // eslint-disable-next-line @atlaskit/platform/no-direct-web-storage-usage -- existing usage
                    localStorage.removeItem(key);
                    i--; // removing an item shifts later ones; use same index for the next iteration
                    deletionCount++;
                }
            }
            itemsProcessed++;
        }
        // sessionStorage
        if (!hitEnumerationLimit && sessionStorageCache) // eslint-disable-next-line @atlaskit/platform/no-direct-web-storage-usage -- existing usage
        for(let i = 0; i < sessionStorage.length(); i++){
            if (itemsProcessed >= enumerationLimit) {
                hitEnumerationLimit = true;
                break;
            }
            if ((itemsProcessed + 1) % ITEMS_PER_YIELD === 0) await yieldToMain();
            // eslint-disable-next-line @atlaskit/platform/no-direct-web-storage-usage -- existing usage
            const key = sessionStorage.key(i);
            if (key === null) continue;
            const category = (0, _itemProcessing.getItemCategoryFromPassedCache)(key, sessionStorageCache, productName);
            if (category === null || category === (0, _types.PreferenceCategory).Unknown) uncategorizedItems.push({
                key,
                storageType: 'sessionStorage'
            });
            else if (isCategoryRevoked({
                category,
                preferences
            })) {
                revokedItems.push({
                    key,
                    storageType: 'sessionStorage',
                    category
                });
                if (shouldDeleteWebStorage && (0, _platformFeatureFlags.fg)('platform_bsc_cleanup_revoked_storage_live_delete')) {
                    // eslint-disable-next-line @atlaskit/platform/no-direct-web-storage-usage -- existing usage
                    sessionStorage.removeItem(key);
                    i--; // removing an item shifts later ones; use same index for the next iteration
                    deletionCount++;
                }
            }
            itemsProcessed++;
        }
        // cookies
        if (!hitEnumerationLimit && cookieCache) for (const key of Object.keys((0, _jsCookieDefault.default).get())){
            if (itemsProcessed >= enumerationLimit) {
                hitEnumerationLimit = true;
                break;
            }
            if ((itemsProcessed + 1) % ITEMS_PER_YIELD === 0) await yieldToMain();
            const category = (0, _itemProcessing.getItemCategoryFromPassedCache)(key, cookieCache, productName);
            if (category === null || category === (0, _types.PreferenceCategory).Unknown) uncategorizedItems.push({
                key,
                storageType: 'cookie'
            });
            else if (isCategoryRevoked({
                category,
                preferences
            })) {
                revokedItems.push({
                    key,
                    storageType: 'cookie',
                    category
                });
                // There's no corresponding `shouldDeleteWebStorage` for cookies as they have no reporting-only mode.
                if ((0, _platformFeatureFlags.fg)('platform_bsc_cleanup_revoked_storage_live_delete')) {
                    (0, _deleteCookie.deleteCookie)(key);
                    deletionCount++;
                }
            }
            itemsProcessed++;
        }
        // IndexedDB
        const shouldDeleteIdb = !globalState.disableIndexedDbConsentChecks && globalState.indexedDbEnabled;
        if (!hitEnumerationLimit && indexedDBCache && typeof (idb === null || idb === void 0 ? void 0 : idb.databases) === 'function') try {
            const dbs = await idb.databases();
            for (const db of dbs){
                if (itemsProcessed >= enumerationLimit) {
                    hitEnumerationLimit = true;
                    break;
                }
                if ((itemsProcessed + 1) % ITEMS_PER_YIELD === 0) await yieldToMain();
                const name = db.name;
                if (name === undefined) continue;
                const category = (0, _itemProcessing.getItemCategoryFromPassedCache)(name, indexedDBCache, productName);
                if (category === null || category === (0, _types.PreferenceCategory).Unknown) uncategorizedItems.push({
                    key: name,
                    storageType: 'indexedDB'
                });
                else if (isCategoryRevoked({
                    category,
                    preferences
                })) {
                    revokedItems.push({
                        key: name,
                        storageType: 'indexedDB',
                        category
                    });
                    if (shouldDeleteIdb && (0, _platformFeatureFlags.fg)('platform_bsc_cleanup_revoked_storage_live_delete')) {
                        const request = idb.deleteDatabase(name);
                        request.onerror = ()=>{
                            var _request_error;
                            var _request_error_message;
                            (0, _utils.Logger).warn(`cleanupStorage: failed to delete IndexedDB "${name}": ${(_request_error_message = (_request_error = request.error) === null || _request_error === void 0 ? void 0 : _request_error.message) !== null && _request_error_message !== void 0 ? _request_error_message : ''}`);
                        };
                        deletionCount++;
                    }
                }
                itemsProcessed++;
            }
        } catch (e) {
        // idb.databases() unavailable or threw — skip IDB entirely
        }
        if (deletionCount > 0) (0, _utils.sendPackageOperationalEvent)({
            action: 'storageCleanupDeleted',
            attributes: {
                deletedCount: deletionCount
            }
        });
        (0, _utils.sendPackageOperationalEvent)({
            action: 'storageCleanupCategorized',
            attributes: {
                durationMs: Math.round(performance.now() - cleanupStartTime),
                deletionMode: (0, _platformFeatureFlags.fg)('platform_bsc_cleanup_revoked_storage_live_delete') ? 'live' : 'dry-run',
                revokedCount: revokedItems.length,
                revokedItems: revokedItems.map(({ storageType, key, category })=>`${storageType} ${key} ${category}`),
                uncategorizedCount: uncategorizedItems.length,
                uncategorizedItems: uncategorizedItems.map(({ storageType, key })=>`${storageType} ${key}`),
                hitEnumerationLimit,
                hitRevokedCountCeiling: (0, _platformFeatureFlags.fg)('platform_bsc_increase_enumeration_limit') && revokedItems.length > REVOKED_COUNT_CEILING
            }
        });
        return {
            deletionMode: (0, _platformFeatureFlags.fg)('platform_bsc_cleanup_revoked_storage_live_delete') ? 'live' : 'dry-run',
            revokedItems,
            uncategorizedItems,
            hitEnumerationLimit
        };
    } catch (error) {
        var _error_message;
        (0, _utils.Logger).errorWithOperationalEvent({
            action: 'storageCleanupError',
            message: `cleanupStorage failed: ${(_error_message = error === null || error === void 0 ? void 0 : error.message) !== null && _error_message !== void 0 ? _error_message : 'no message'}`
        });
        return {
            deletionMode: (0, _platformFeatureFlags.fg)('platform_bsc_cleanup_revoked_storage_live_delete') ? 'live' : 'dry-run',
            revokedItems: [],
            uncategorizedItems: [],
            hitEnumerationLimit: false
        };
    }
}

},{"js-cookie":"brgOH","@atlaskit/platform-feature-flags":"8rD2i","../../../common/utils":"gnWyu","../../../common/utils/item-processing":"8zwf4","../../../services/web-storage-service":"d0pCe","../../../types":"65Pa5","../../preferences-controls/get-preferences":"030sv","../delete-cookie":"3d8Bf","@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"jQuSQ":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "createDocumentCookiePassthrough", ()=>createDocumentCookiePassthrough);
var _logger = require("../../../../common/utils/logger");
var _setCookieOverride = require("../set-cookie-override");
const createDocumentCookiePassthrough = async ()=>{
    const documentCookieProperty = Object.getOwnPropertyDescriptor(Document.prototype, 'cookie');
    const originalSetter = documentCookieProperty === null || documentCookieProperty === void 0 ? void 0 : documentCookieProperty.set;
    const originalGetter = documentCookieProperty === null || documentCookieProperty === void 0 ? void 0 : documentCookieProperty.get;
    if (!originalSetter || !originalGetter) {
        (0, _logger.Logger).warn('No document.cookie capabilities found');
        return;
    }
    // Override document.cookie setter
    Object.defineProperty(document, 'cookie', {
        get: originalGetter,
        set: (0, _setCookieOverride.getSetCookieOverride)(originalSetter),
        configurable: true
    });
};

},{"../../../../common/utils/logger":"2Tk7J","../set-cookie-override":"fChPD","@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"fChPD":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "getSetCookieOverride", ()=>getSetCookieOverride);
var _objectSpread = require("@swc/helpers/_/_object_spread");
var _platformFeatureFlags = require("@atlaskit/platform-feature-flags");
var _utils = require("../../../../common/utils");
var _analyticsClient = require("../../../../common/utils/analytics-client");
var _itemProcessing = require("../../../../common/utils/item-processing");
var _logger = require("../../../../common/utils/logger");
var _uncategorizedItemReportCache = require("../../../../services/uncategorized-item-report-cache");
var _types = require("../../../../types");
const getSetCookieOverride = (originalSetter)=>(originalCookieValue)=>{
        const cookieSetByPackage = originalCookieValue.includes('atl-set-cookie');
        if (cookieSetByPackage) try {
            // Controls have already been run, passthrough as usual
            return originalSetter.apply(document, [
                originalCookieValue
            ]);
        } catch (e) {
            (0, _logger.Logger).errorWithOperationalEvent({
                action: 'usedDocumentCookieError',
                message: `document.cookie setter failed to set cookie set by package. ${e.message || ''}`,
                attributes: {
                    outsidePackage: false
                }
            });
        }
        try {
            // Raw cookies and query params can contain sensitive PII/UGC we can't store, so we want to
            // strip that out before we log it out to our analytics client.
            const sanitizedCookieKey = originalCookieValue.slice(0, originalCookieValue.indexOf('=')) || '';
            (0, _utils.sendPackageOperationalEvent)({
                action: 'usedDocumentCookie',
                attributes: {
                    cookieKey: sanitizedCookieKey,
                    outsidePackage: !cookieSetByPackage
                }
            });
            try {
                const productName = (0, _utils.getBscGlobalState)().product;
                // Attempt to set a known cookie that was set from outside the package
                (0, _itemProcessing.isProcessingAllowedByPreferences)({
                    itemKey: sanitizedCookieKey,
                    allowedCallback: ()=>{
                        return originalSetter.apply(document, [
                            originalCookieValue
                        ]);
                    },
                    blockedCallback: ({ itemHasCategory, itemCategory })=>{
                        var _getBscGlobalState_cacheLoadedDate;
                        if (!itemHasCategory && (0, _uncategorizedItemReportCache.shouldReportUncategorizedItemSet)((0, _types.CategoryStorageType).Cookies, sanitizedCookieKey)) (0, _analyticsClient.sendTrackEvent)({
                            source: 'package',
                            action: 'package',
                            actionSubject: 'uncategorizedWebStorageItemSet',
                            attributes: (0, _objectSpread._)({
                                storageType: (0, _types.CategoryStorageType).Cookies,
                                productName,
                                originalItemKey: sanitizedCookieKey,
                                itemCategory: itemCategory !== null && itemCategory !== void 0 ? itemCategory : null
                            }, (0, _platformFeatureFlags.fg)('platform_bsc_cache_load_date') && {
                                cacheLoadedDate: (_getBscGlobalState_cacheLoadedDate = (0, _utils.getBscGlobalState)().cacheLoadedDate) !== null && _getBscGlobalState_cacheLoadedDate !== void 0 ? _getBscGlobalState_cacheLoadedDate : null
                            }),
                            onSent: (0, _uncategorizedItemReportCache.uncategorizedItemSetOnSent)((0, _types.CategoryStorageType).Cookies, sanitizedCookieKey)
                        });
                        const { allowUncategorizedCookiesInOverrides } = (0, _utils.getBscGlobalState)();
                        if (allowUncategorizedCookiesInOverrides && !itemHasCategory) return originalSetter.apply(document, [
                            originalCookieValue
                        ]);
                        else {
                            if (!itemHasCategory) (0, _logger.Logger).warn(`document.cookie setter for '${sanitizedCookieKey}' was blocked` + `${productName ? ` for product "${productName}"` : ''}` + `: '${sanitizedCookieKey}' is not registered in the BSC data store. Add it to the data store before calling this API.`);
                            return;
                        }
                    },
                    storageType: (0, _types.CategoryStorageType).Cookies,
                    productName
                });
            } catch (e) {
                (0, _logger.Logger).errorWithOperationalEvent({
                    action: 'usedDocumentCookieError',
                    message: `Failed to set cookie. ${e.message || ''}`,
                    attributes: {
                        cookieKey: sanitizedCookieKey
                    }
                });
            }
        } catch (e) {
            (0, _logger.Logger).errorWithOperationalEvent({
                action: 'usedDocumentCookieError',
                message: `Failed to send document.cookie setter event. ${e.message || ''}`
            });
        }
    };

},{"@swc/helpers/_/_object_spread":"9gdrV","@atlaskit/platform-feature-flags":"8rD2i","../../../../common/utils":"gnWyu","../../../../common/utils/analytics-client":"3Dqor","../../../../common/utils/item-processing":"8zwf4","../../../../common/utils/logger":"2Tk7J","../../../../services/uncategorized-item-report-cache":"jMbZW","../../../../types":"65Pa5","@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"jMbZW":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
// Test-only helper to reset the per-process cache between tests.
parcelHelpers.export(exports, "__resetUncategorizedItemReportCache", ()=>__resetUncategorizedItemReportCache);
/**
 * Whether an `uncategorizedWebStorageItemSet` event should be emitted for this key. Called at the
 * event fire sites before `sendTrackEvent`. When the dedup gate is on, returns false once the key
 * has already been reported this session (suppressing duplicates); when the gate is off it always
 * returns true (unchanged behaviour) without touching the cache.
 */ parcelHelpers.export(exports, "shouldReportUncategorizedItemSet", ()=>shouldReportUncategorizedItemSet);
/**
 * Returns the `onSent` callback for `sendTrackEvent`, which marks the key as reported only when the
 * event actually sends (passes sampling). This "mark on send" means a key whose event was dropped
 * by sampling can still emit on a later write, so frequently-set keys are reliably reported once
 * rather than lost to sampling. Returns undefined when the dedup gate is off (no marking).
 */ parcelHelpers.export(exports, "uncategorizedItemSetOnSent", ()=>uncategorizedItemSetOnSent);
var _platformFeatureFlags = require("@atlaskit/platform-feature-flags");
/**
 * Tracks which uncategorized storage-item keys have already emitted an
 * `uncategorizedWebStorageItemSet` track event this session, so repeated writes
 * of the same unknown key don't emit duplicate events.
 *
 * State is module-level (per page load), which gives us the "per session"
 * semantic for free — it resets naturally on reload. Same pattern as
 * `ItemKeyCache` (item-key-cache-service) and the logger error-event throttle.
 *
 * Keys are scoped by storage type so the same key name in different storage
 * types (e.g. a cookie and a localStorage item both named `foo`) remain
 * distinct reportable signals.
 */ class UncategorizedItemReportCacheService {
    compositeKey(storageType, itemKey) {
        return `${storageType}::${itemKey}`;
    }
    markReported(storageType, itemKey) {
        this.reportedKeys.add(this.compositeKey(storageType, itemKey));
    }
    wasReported(storageType, itemKey) {
        return this.reportedKeys.has(this.compositeKey(storageType, itemKey));
    }
    // Test-only helper to reset the per-process cache between tests.
    __reset() {
        this.reportedKeys.clear();
    }
    constructor(){
        this.reportedKeys = new Set();
    }
}
let cacheInstance;
/**
 * Lazily creates the cache on first use. The dedup helpers only call this after confirming the
 * dedup gate is on, so when the gate is off the cache is never instantiated.
 */ function getCache() {
    if (!cacheInstance) cacheInstance = new UncategorizedItemReportCacheService();
    return cacheInstance;
}
function __resetUncategorizedItemReportCache() {
    cacheInstance = undefined;
}
function shouldReportUncategorizedItemSet(storageType, itemKey) {
    if (!(0, _platformFeatureFlags.fg)('platform_bsc_dedup_uncategorized_items')) return true;
    return !getCache().wasReported(storageType, itemKey);
}
function uncategorizedItemSetOnSent(storageType, itemKey) {
    if (!(0, _platformFeatureFlags.fg)('platform_bsc_dedup_uncategorized_items')) return undefined;
    return ()=>getCache().markReported(storageType, itemKey);
}

},{"@atlaskit/platform-feature-flags":"8rD2i","@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"4pzNo":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "createIndexedDBPassthrough", ()=>createIndexedDBPassthrough);
var _logger = require("../../../../common/utils/logger");
var _indexedDbOpenOverride = require("../indexed-db-open-override");
const createIndexedDBPassthrough = async (config)=>{
    const indexedDB = window.indexedDB;
    if (!indexedDB) {
        (0, _logger.Logger).warn('No IndexedDB capabilities found');
        return;
    }
    if (typeof indexedDB.open !== 'function') {
        (0, _logger.Logger).warn('IndexedDB.open is not a function');
        return;
    }
    try {
        const originalOpen = indexedDB.open.bind(indexedDB);
        (0, _logger.Logger).debug(`Installing IndexedDB override ${config.performConsentChecks ? 'with' : 'without'} consent checks`);
        // Use Object.defineProperty for better browser compatibility and consistency
        // with other passthrough implementations (document.cookie, localStorage/sessionStorage)
        Object.defineProperty(indexedDB, 'open', {
            value: config.performConsentChecks ? (0, _indexedDbOpenOverride.getIndexedDBOpenOverride)(originalOpen) : (0, _indexedDbOpenOverride.getIndexedDBOpenOverrideEventOnly)(originalOpen),
            writable: true,
            configurable: true
        });
        (0, _logger.Logger).debug('IndexedDB open override installed');
    } catch (e) {
        (0, _logger.Logger).error(`Failed to install IndexedDB open override. ${e.message || ''}`);
    }
};

},{"../../../../common/utils/logger":"2Tk7J","../indexed-db-open-override":"cdKFO","@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"cdKFO":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "getIndexedDBOpenOverrideEventOnly", ()=>getIndexedDBOpenOverrideEventOnly);
parcelHelpers.export(exports, "getIndexedDBOpenOverride", ()=>getIndexedDBOpenOverride);
var _objectSpread = require("@swc/helpers/_/_object_spread");
var _objectSpreadProps = require("@swc/helpers/_/_object_spread_props");
var _platformFeatureFlags = require("@atlaskit/platform-feature-flags");
var _utils = require("../../../../common/utils");
var _itemProcessing = require("../../../../common/utils/item-processing");
var _logger = require("../../../../common/utils/logger");
var _idbOpenRequestWrapper = require("../../../../services/indexed-db-wrapper-service/idb-open-request-wrapper");
var _utils1 = require("../../../../services/indexed-db-wrapper-service/utils");
var _itemKeyCacheService = require("../../../../services/item-key-cache-service");
var _types = require("../../../../types");
// DatabaseBlockedError extends DOMException in browser environments, but DOMException is not
// available in SSR/Node.js, which causes import errors. We conditionally extend DOMException
// only when it is available, falling back to a plain Error in SSR — the same pattern used
// for IDBOpenDBRequestWrapper.
let DatabaseBlockedError;
if (typeof DOMException !== 'undefined') DatabaseBlockedError = class DatabaseBlockedError extends DOMException {
};
else DatabaseBlockedError = class DatabaseBlockedError extends Error {
    constructor(message, name = 'DatabaseBlockedError'){
        super(message), this.name = name;
    }
};
const checkAndSendAnalyticsEvent = async (eventDetails)=>{
    const wasSetByPackage = (0, _itemKeyCacheService.ItemKeyCache).wasSetByPackage((0, _types.CategoryStorageType).IndexedDB, eventDetails.databaseName);
    const productName = (0, _utils.getBscGlobalState)().product;
    const itemCategory = await (0, _itemProcessing.getItemCategory)(eventDetails.databaseName, (0, _types.CategoryStorageType).IndexedDB, productName);
    const isStrictlyNecessary = itemCategory === (0, _types.PreferenceCategory).StrictlyNecessary;
    if (!isStrictlyNecessary && !wasSetByPackage) {
        const categoryAttribute = (0, _platformFeatureFlags.fg)('platform_bsc_add_category_to_idb_open_events') ? {
            itemCategory: itemCategory !== null && itemCategory !== void 0 ? itemCategory : (0, _types.PreferenceCategory).Unknown
        } : {};
        const attributes = (0, _objectSpread._)((0, _objectSpreadProps._)((0, _objectSpread._)({}, eventDetails), {
            productName,
            outsidePackage: true
        }), categoryAttribute);
        // Send analytics event for uncategorized IndexedDB usage
        (0, _utils.sendPackageOperationalEvent)({
            action: 'usedAtlIndexedDBOpen',
            attributes
        });
    }
};
const checkIfAllowed = async (dbName)=>{
    if (!(0, _utils1.isValidDBName)(dbName)) {
        const error = new Error('Invalid database name: must be a non-empty string');
        (0, _logger.Logger).errorWithOperationalEvent({
            action: 'usedAtlIndexedDBOpenError',
            attributes: {
                dbName
            },
            message: `IndexedDB open failed: ${error.message}`
        });
        throw error;
    }
    const productName = (0, _utils.getBscGlobalState)().product;
    return (0, _itemProcessing.isProcessingAllowedByPreferences)({
        itemKey: dbName,
        storageType: (0, _types.CategoryStorageType).IndexedDB,
        productName
    });
};
const checkIfAllowedWithCategory = async (dbName)=>{
    if (!(0, _utils1.isValidDBName)(dbName)) {
        const error = new Error('Invalid database name: must be a non-empty string');
        (0, _logger.Logger).errorWithOperationalEvent({
            action: 'usedAtlIndexedDBOpenError',
            attributes: {
                dbName
            },
            message: `IndexedDB open failed: ${error.message}`
        });
        throw error;
    }
    const productName = (0, _utils.getBscGlobalState)().product;
    const { isAllowed, itemCategory } = await (0, _itemProcessing.isProcessingAllowedByPreferencesWithCategory)({
        itemKey: dbName,
        storageType: (0, _types.CategoryStorageType).IndexedDB,
        productName
    });
    return {
        isAllowed,
        itemCategory
    };
};
const getIndexedDBOpenOverrideEventOnly = (originalOpen)=>(databaseName, version)=>{
        checkAndSendAnalyticsEvent({
            databaseName
        }).catch((e)=>{
            (0, _logger.Logger).error(`Failed to send IndexedDB open event. ${e.message || ''}`);
        });
        // Always allow the operation to proceed (we're only tracking usage)
        return originalOpen(databaseName, version);
    };
const getIndexedDBOpenOverride = (originalOpen)=>(databaseName, version)=>{
        const wasSetByPackage = (0, _itemKeyCacheService.ItemKeyCache).wasSetByPackage((0, _types.CategoryStorageType).IndexedDB, databaseName);
        if (wasSetByPackage) return originalOpen(databaseName, version);
        if ((0, _platformFeatureFlags.fg)('jfp-magma-selective-storage-enforcement')) {
            var _globalState___UNSAFE_shouldEnforceKeyForRollout;
            // Per-key opt-out: when `disableIndexedDbConsentChecks` is on, `__UNSAFE_shouldEnforceKeyForRollout`
            // can re-enable enforcement for this database name; otherwise fall back to
            // analytics-only behaviour.
            const globalState = (0, _utils.getBscGlobalState)();
            const enforceThisKey = ((_globalState___UNSAFE_shouldEnforceKeyForRollout = globalState.__UNSAFE_shouldEnforceKeyForRollout) === null || _globalState___UNSAFE_shouldEnforceKeyForRollout === void 0 ? void 0 : _globalState___UNSAFE_shouldEnforceKeyForRollout.call(globalState, databaseName, (0, _types.CategoryStorageType).IndexedDB)) === true;
            var _globalState_disableIndexedDbConsentChecks;
            const disableIndexedDbConsentChecks = ((_globalState_disableIndexedDbConsentChecks = globalState.disableIndexedDbConsentChecks) !== null && _globalState_disableIndexedDbConsentChecks !== void 0 ? _globalState_disableIndexedDbConsentChecks : false) && !enforceThisKey;
            if (disableIndexedDbConsentChecks) {
                checkAndSendAnalyticsEvent({
                    databaseName
                }).catch((e)=>{
                    (0, _logger.Logger).error(`Failed to send IndexedDB open event. ${e.message || ''}`);
                });
                return originalOpen(databaseName, version);
            }
        }
        (0, _logger.Logger).debug(`IndexedDB operation: overridden open on database \"${databaseName}\"`, {
            version: String(version !== null && version !== void 0 ? version : 'unspecified')
        });
        const requestWrapper = (0, _idbOpenRequestWrapper.createIDBOpenDBRequestWrapper)();
        // We need category information when either the category analytics gate or the uncategorized
        // passthrough gate is on so that we can distinguish "uncategorized" from "user-denied".
        // `fg(...)` is evaluated inline (not stored in a variable) so gate cleanup stays a simple
        // grep-and-delete. The uncategorized-override config is read once here into a local.
        const allowUncategorizedOverride = (0, _platformFeatureFlags.fg)('platform_bsc_allow_uncategorized_idb_overrides') && !!(0, _utils.getBscGlobalState)().allowUncategorizedItemsInIndexedDBOverrides;
        const needsCategoryInfo = (0, _platformFeatureFlags.fg)('platform_bsc_add_category_to_idb_open_events') || allowUncategorizedOverride;
        const allowedPromise = needsCategoryInfo ? checkIfAllowedWithCategory(databaseName).then(({ isAllowed, itemCategory })=>({
                isAllowed,
                itemCategory: itemCategory !== null && itemCategory !== void 0 ? itemCategory : (0, _types.PreferenceCategory).Unknown,
                categoryAttribute: (0, _platformFeatureFlags.fg)('platform_bsc_add_category_to_idb_open_events') ? {
                    itemCategory: itemCategory !== null && itemCategory !== void 0 ? itemCategory : (0, _types.PreferenceCategory).Unknown
                } : {}
            })) : checkIfAllowed(databaseName).then((isAllowed)=>({
                isAllowed,
                itemCategory: null,
                categoryAttribute: {}
            }));
        allowedPromise.then(({ isAllowed, itemCategory, categoryAttribute })=>{
            // When `allowUncategorizedItemsInIndexedDBOverrides` is enabled, databases that have
            // no known category (null/Unknown) are allowed through instead of being blocked. This
            // is a rollout-safety valve — only uncategorized DBs are affected; DBs that are
            // categorized but user-denied are still blocked regardless of this flag.
            const isUncategorized = itemCategory == null || itemCategory === (0, _types.PreferenceCategory).Unknown;
            const resolvedIsAllowed = isAllowed || allowUncategorizedOverride && isUncategorized;
            (0, _utils.sendPackageOperationalEvent)({
                action: 'usedAtlIndexedDBOpen',
                attributes: (0, _objectSpread._)({
                    databaseName,
                    wasRejected: !resolvedIsAllowed,
                    outsidePackage: true
                }, categoryAttribute)
            });
            if (resolvedIsAllowed) {
                (0, _logger.Logger).debug(`IndexedDB operation: override on database \"${databaseName}\" was ALLOWED`, {
                    version: String(version !== null && version !== void 0 ? version : 'unspecified')
                });
                const actualRequest = originalOpen(databaseName, version);
                requestWrapper.wrapRequest(actualRequest);
            } else {
                (0, _logger.Logger).debug(`IndexedDB operation: override on database \"${databaseName}\" was REJECTED`, {
                    version: String(version !== null && version !== void 0 ? version : 'unspecified')
                });
                const error = new DatabaseBlockedError('The database was blocked by consent preferences', 'storageItemBlocked');
                const errorEvent = new ErrorEvent('error', {
                    message: error.message,
                    error
                });
                requestWrapper.setError(error);
                requestWrapper.dispatchEvent(errorEvent);
            }
        }).catch((e)=>{
            const errorMessage = e instanceof Error ? e.message : String(e);
            (0, _logger.Logger).debug(`IndexedDB operation: override on database \"${databaseName}\" ERROR: ${errorMessage}`, {
                version: String(version !== null && version !== void 0 ? version : 'unspecified')
            });
            (0, _logger.Logger).errorWithOperationalEvent({
                action: 'usedAtlIndexedDBOpenError',
                attributes: {
                    databaseName,
                    outsidePackage: true
                },
                message: `IndexedDB open failed during preference check: ${errorMessage}`
            });
            const errorEvent = new ErrorEvent('error', {
                message: errorMessage,
                error: e
            });
            requestWrapper.dispatchEvent(errorEvent);
        });
        return requestWrapper;
    };

},{"@swc/helpers/_/_object_spread":"9gdrV","@swc/helpers/_/_object_spread_props":"kANqQ","@atlaskit/platform-feature-flags":"8rD2i","../../../../common/utils":"gnWyu","../../../../common/utils/item-processing":"8zwf4","../../../../common/utils/logger":"2Tk7J","../../../../services/indexed-db-wrapper-service/idb-open-request-wrapper":"iPrOZ","../../../../services/indexed-db-wrapper-service/utils":"aFAAe","../../../../services/item-key-cache-service":"4UZqe","../../../../types":"65Pa5","@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"iPrOZ":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
/**
 * Factory function to create an IDBOpenDBRequest wrapper.
 * In SSR environments, returns a minimal no-op implementation.
 * In browser environments, returns the full EventTarget-based implementation.
 */ parcelHelpers.export(exports, "createIDBOpenDBRequestWrapper", ()=>createIDBOpenDBRequestWrapper);
parcelHelpers.export(exports, "IDBOpenDBRequestWrapper", ()=>IDBOpenDBRequestWrapper);
var _bindEventListener = require("bind-event-listener");
var _isSsr = require("../../../common/utils/is-ssr");
var _utils = require("./utils");
// Store the browser implementation class here - defined conditionally below
let BrowserImpl;
/**
 * Browser-only implementation that extends EventTarget.
 * Only defined in browser environments where EventTarget is available.
 * This conditional definition prevents "EventTarget is not defined" errors in SSR.
 */ if (typeof EventTarget !== 'undefined') // Define the class inside this block so it's never parsed in SSR
BrowserImpl = class IDBOpenDBRequestWrapperImpl extends EventTarget {
    // Implementing IDBRequest readonly properties with getters
    get error() {
        var _this__wrappedRequest;
        var _this__wrappedRequest_error;
        return (_this__wrappedRequest_error = (_this__wrappedRequest = this._wrappedRequest) === null || _this__wrappedRequest === void 0 ? void 0 : _this__wrappedRequest.error) !== null && _this__wrappedRequest_error !== void 0 ? _this__wrappedRequest_error : this._error;
    }
    get result() {
        var _this__wrappedRequest;
        var _this__wrappedRequest_result;
        return (_this__wrappedRequest_result = (_this__wrappedRequest = this._wrappedRequest) === null || _this__wrappedRequest === void 0 ? void 0 : _this__wrappedRequest.result) !== null && _this__wrappedRequest_result !== void 0 ? _this__wrappedRequest_result : this._result;
    }
    get readyState() {
        var _this__wrappedRequest;
        var _this__wrappedRequest_readyState;
        return (_this__wrappedRequest_readyState = (_this__wrappedRequest = this._wrappedRequest) === null || _this__wrappedRequest === void 0 ? void 0 : _this__wrappedRequest.readyState) !== null && _this__wrappedRequest_readyState !== void 0 ? _this__wrappedRequest_readyState : this._readyState;
    }
    get source() {
        var _this__wrappedRequest;
        var _this__wrappedRequest_source;
        return (_this__wrappedRequest_source = (_this__wrappedRequest = this._wrappedRequest) === null || _this__wrappedRequest === void 0 ? void 0 : _this__wrappedRequest.source) !== null && _this__wrappedRequest_source !== void 0 ? _this__wrappedRequest_source : this._source;
    }
    get transaction() {
        var _this__wrappedRequest;
        var _this__wrappedRequest_transaction;
        return (_this__wrappedRequest_transaction = (_this__wrappedRequest = this._wrappedRequest) === null || _this__wrappedRequest === void 0 ? void 0 : _this__wrappedRequest.transaction) !== null && _this__wrappedRequest_transaction !== void 0 ? _this__wrappedRequest_transaction : this._transaction;
    }
    /**
		 * Wrap an existing IDBOpenDBRequest to proxy its events to this wrapper.
		 * Once wrapped, all property getters will delegate to the wrapped request,
		 * and all events from the wrapped request will be re-dispatched on this wrapper.
		 *
		 * @param request - The real IDBOpenDBRequest to wrap
		 */ wrapRequest(request) {
        if (this._wrappedRequest) throw new Error('This IDBOpenDBRequestWrapper is already wrapping another request');
        this._wrappedRequest = request;
        // Proxy all events from the wrapped request to this wrapper using bindAll
        this._unbindEventListeners = (0, _bindEventListener.bindAll)(request, [
            {
                type: 'success',
                listener: (e)=>{
                    this.dispatchEvent(new Event('success', e));
                }
            },
            {
                type: 'error',
                listener: (e)=>{
                    this.dispatchEvent(new Event('error', e));
                }
            },
            {
                type: 'blocked',
                listener: (e)=>{
                    const versionChangeEvent = new IDBVersionChangeEvent('blocked', e);
                    this.dispatchEvent(versionChangeEvent);
                }
            },
            {
                type: 'upgradeneeded',
                listener: (e)=>{
                    const versionChangeEvent = new IDBVersionChangeEvent('upgradeneeded', e);
                    this.dispatchEvent(versionChangeEvent);
                }
            }
        ]);
    }
    /**
		 * Check if this mock is wrapping a real request
		 */ isWrapping() {
        return this._wrappedRequest !== null;
    }
    /**
		 * Get the wrapped request (if any)
		 */ getWrappedRequest() {
        return this._wrappedRequest;
    }
    /**
		 * Unbind all event listeners attached to the wrapped request.
		 * Should be called when the wrapper is no longer needed.
		 */ unbind() {
        if (this._unbindEventListeners) {
            this._unbindEventListeners();
            this._unbindEventListeners = null;
        }
        this._wrappedRequest = null;
    }
    /**
		 * Set the error property (normally readonly)
		 * Only works when not wrapping another request
		 */ setError(error) {
        if (this._wrappedRequest) throw new Error('Cannot set error on a wrapping IDBOpenDBRequestWrapper');
        this._error = error;
    }
    /**
		 * Set the result property (normally readonly)
		 * Only works when not wrapping another request
		 */ setResult(result) {
        if (this._wrappedRequest) throw new Error('Cannot set result on a wrapping IDBOpenDBRequestWrapper');
        this._result = result;
    }
    /**
		 * Set the readyState property (normally readonly)
		 * Only works when not wrapping another request
		 */ setReadyState(state) {
        if (this._wrappedRequest) throw new Error('Cannot set readyState on a wrapping IDBOpenDBRequestWrapper');
        this._readyState = state;
    }
    /**
		 * Set the source property (normally readonly)
		 * Only works when not wrapping another request
		 */ setSource(source) {
        if (this._wrappedRequest) throw new Error('Cannot set source on a wrapping IDBOpenDBRequestWrapper');
        this._source = source;
    }
    /**
		 * Set the transaction property (normally readonly)
		 * Only works when not wrapping another request
		 */ setTransaction(transaction) {
        if (this._wrappedRequest) throw new Error('Cannot set transaction on a wrapping IDBOpenDBRequestWrapper');
        this._transaction = transaction;
    }
    /**
		 * Override dispatchEvent to also call the corresponding event handler if set
		 */ dispatchEvent(event) {
        const result = super.dispatchEvent(event);
        // Call the appropriate event handler if it exists
        switch(event.type){
            case 'error':
                if (this.onerror) this.onerror.call(this, event);
                break;
            case 'success':
                if (this.onsuccess) this.onsuccess.call(this, event);
                break;
            case 'blocked':
                if (this.onblocked) this.onblocked.call(this, event);
                break;
            case 'upgradeneeded':
                if (this.onupgradeneeded) this.onupgradeneeded.call(this, event);
                break;
        }
        return result;
    }
    constructor(...args){
        super(...args), this._error = null, this._result = null, this._readyState = 'pending', this._source = null, this._transaction = null, this._wrappedRequest = null, this._unbindEventListeners = null, // Event handler properties (can be set directly by consumers)
        this.onerror = null, this.onsuccess = null, this.onblocked = null, this.onupgradeneeded = null;
    }
};
function createIDBOpenDBRequestWrapper() {
    if ((0, _isSsr.isSSR)() || typeof EventTarget === 'undefined' || !BrowserImpl) return new (0, _utils.IDBOpenDBRequestNoOp)();
    return new BrowserImpl();
}
const IDBOpenDBRequestWrapper = BrowserImpl;

},{"bind-event-listener":"bjeUU","../../../common/utils/is-ssr":"ciW3w","./utils":"mzvHO","@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"mzvHO":[function(require,module,exports,__globalThis) {
/**
 * Minimal no-op implementation for SSR environments.
 * Provides the IDBOpenDBRequest interface without relying on EventTarget.
 * This class does not extend EventTarget, making it safe to instantiate in Node.js.
 */ var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "IDBOpenDBRequestNoOp", ()=>IDBOpenDBRequestNoOp);
class IDBOpenDBRequestNoOp {
    get error() {
        return this._error;
    }
    get result() {
        return this._result;
    }
    get readyState() {
        return this._readyState;
    }
    get source() {
        return this._source;
    }
    get transaction() {
        return this._transaction;
    }
    // No-op event methods for SSR
    addEventListener() {}
    removeEventListener() {}
    dispatchEvent() {
        return false;
    }
    // Wrapper-specific methods that shouldn't be called in SSR but are part of the interface
    wrapRequest() {
        throw new Error('IDBOpenDBRequestWrapper cannot wrap requests in SSR environment');
    }
    isWrapping() {
        return false;
    }
    getWrappedRequest() {
        return null;
    }
    unbind() {}
    setError(error) {
        this._error = error;
    }
    setResult(result) {
        this._result = result;
    }
    setReadyState(state) {
        this._readyState = state;
    }
    setSource(source) {
        this._source = source;
    }
    setTransaction(transaction) {
        this._transaction = transaction;
    }
    constructor(){
        this._error = null;
        this._result = null;
        this._readyState = 'pending';
        this._source = null;
        this._transaction = null;
        this.onerror = null;
        this.onsuccess = null;
        this.onblocked = null;
        this.onupgradeneeded = null;
    }
}

},{"@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"aFAAe":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
/**
 * Checks if IndexedDB is available in the current environment
 * @param enableSSRCheck - Whether to check for SSR environment (default: true)
 * @param enableFeatureFlagCheck - Whether to check feature flags and global state (default: true)
 * @returns DbAvailabilityResult with availability status, reason, and bypassImplementation flag
 *
 * When IndexedDB controls are disabled via global state (which includes killswitch checks),
 * returns available: true with bypassImplementation: true, indicating that the wrapped
 * implementation should be bypassed in favor of direct browser behavior.
 */ parcelHelpers.export(exports, "checkDBAvailability", ()=>checkDBAvailability);
/**
 * Validates database name format
 * @param dbName - The database name to validate
 * @returns true if valid, false otherwise
 */ parcelHelpers.export(exports, "isValidDBName", ()=>isValidDBName);
/**
 * Validates version number
 * @param version - The version number to validate
 * @returns true if valid, false otherwise
 */ parcelHelpers.export(exports, "isValidVersion", ()=>isValidVersion);
var _utils = require("../../common/utils");
function checkDBAvailability(enableSSRCheck = true, enableFeatureFlagCheck = true) {
    // Check if running in SSR environment
    if (enableSSRCheck && (0, _utils.isSSR)()) return {
        available: false,
        reason: 'IndexedDB is not available in SSR environment'
    };
    if (!globalThis.indexedDB) return {
        available: false,
        reason: 'IndexedDB is not supported in this browser'
    };
    if (enableFeatureFlagCheck) {
        const globalState = (0, _utils.getBscGlobalState)();
        if (globalState.indexedDbEnabled === false) return {
            available: true,
            reason: 'Using native IndexedDB: IndexedDB controls are disabled',
            bypassImplementation: true
        };
    }
    return {
        available: true
    };
}
function isValidDBName(dbName) {
    // Database name should not be empty and should be a string
    return typeof dbName === 'string' && dbName.trim().length > 0;
}
function isValidVersion(version) {
    // Version should be undefined or a positive integer
    if (version === undefined) return true;
    return Number.isInteger(version) && version > 0;
}

},{"../../common/utils":"gnWyu","@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"3jY2c":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "createWebStoragePassthrough", ()=>createWebStoragePassthrough);
var _logger = require("../../../../common/utils/logger");
var _indexedDbService = require("../../../../services/indexed-db-service");
var _webStorageService = require("../../../../services/web-storage-service");
var _setItemOverride = require("../set-item-override");
const createWebStoragePassthrough = async (storageType)=>{
    const bscStorage = (0, _webStorageService.findStorageTarget)(storageType);
    if (!bscStorage.isAvailable) {
        (0, _logger.Logger).warn(`No ${storageType} capabilities found`);
        return;
    }
    if (!(0, _indexedDbService.BSCIndexedDB).isAvailable) {
        (0, _logger.Logger).warn('IndexedDB is not available');
        return;
    }
    if (!(0, _indexedDbService.BSCIndexedDB).isBooted) try {
        await (0, _indexedDbService.BSCIndexedDB).boot();
    } catch (e) {
        (0, _logger.Logger).warn('IndexedDB boot failed, proceeding without IDB tracking');
    }
    const originalSetItem = bscStorage.storage.setItem;
    // As we cannot use Object.defineProperty(window[storageType], 'setItem', ...implementation)
    // we have to override the entire utility with our own edition of the webStorage class
    const overriddenStorageClass = {
        clear: bscStorage.clear.bind(bscStorage),
        key: bscStorage.key.bind(bscStorage),
        length: bscStorage.length.bind(bscStorage),
        removeItem: bscStorage.removeItem.bind(bscStorage),
        getItem: bscStorage.getItem.bind(bscStorage),
        setItem: (0, _setItemOverride.setItemOverride)(bscStorage, originalSetItem, storageType)
    };
    const caseSensitiveStorageType = storageType === (0, _webStorageService.WebStorageType).LocalStorage ? 'localStorage' : 'sessionStorage';
    Object.defineProperty(window, caseSensitiveStorageType, {
        value: overriddenStorageClass,
        writable: true,
        configurable: true
    });
};

},{"../../../../common/utils/logger":"2Tk7J","../../../../services/indexed-db-service":"1A0ES","../../../../services/web-storage-service":"d0pCe","../set-item-override":"aWp6v","@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"aWp6v":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "setItemOverride", ()=>setItemOverride);
var _objectSpread = require("@swc/helpers/_/_object_spread");
var _platformFeatureFlags = require("@atlaskit/platform-feature-flags");
var _utils = require("../../../../common/utils");
var _analyticsClient = require("../../../../common/utils/analytics-client");
var _itemProcessing = require("../../../../common/utils/item-processing");
var _logger = require("../../../../common/utils/logger");
var _itemKeyCacheService = require("../../../../services/item-key-cache-service");
var _uncategorizedItemReportCache = require("../../../../services/uncategorized-item-report-cache");
var _webStorageService = require("../../../../services/web-storage-service");
var _reportSetItemError = require("../../../../services/web-storage-service/utils/report-set-item-error");
var _types = require("../../../../types");
const setItemOverride = (bscStorage, originalSetItem, storageType)=>(originalItemKey, originalItemValue)=>{
        const categoryStorageType = storageType === (0, _webStorageService.WebStorageType).LocalStorage ? (0, _types.CategoryStorageType).LocalStorage : (0, _types.CategoryStorageType).SessionStorage;
        const storageContext = bscStorage.storage;
        let itemSetByPackage = false;
        itemSetByPackage = (0, _itemKeyCacheService.ItemKeyCache).wasSetByPackage(categoryStorageType, originalItemKey);
        var _getBscGlobalState_disableWebStorageConsentChecks;
        // `disableWebStorageConsentChecks` is read from the package global state so the
        // behaviour stays consistent with other consent-check flags (rather than being
        // threaded through props/options on every call site). When set, the override
        // always passes through to the underlying storage and only emits analytics
        // events — `AtlBrowserStorage` behaviour is preserved.
        let disableWebStorageConsentChecks = (_getBscGlobalState_disableWebStorageConsentChecks = (0, _utils.getBscGlobalState)().disableWebStorageConsentChecks) !== null && _getBscGlobalState_disableWebStorageConsentChecks !== void 0 ? _getBscGlobalState_disableWebStorageConsentChecks : false;
        if ((0, _platformFeatureFlags.fg)('jfp-magma-selective-storage-enforcement')) {
            // `disableWebStorageConsentChecks` skips the consent pipeline (analytics-only),
            // but `__UNSAFE_shouldEnforceKeyForRollout(key, type) === true` re-enables enforcement for this key.
            const categoryStorageType = storageType === (0, _webStorageService.WebStorageType).LocalStorage ? (0, _types.CategoryStorageType).LocalStorage : (0, _types.CategoryStorageType).SessionStorage;
            const __UNSAFE_shouldEnforceKeyForRollout = (0, _utils.getBscGlobalState)().__UNSAFE_shouldEnforceKeyForRollout;
            const enforceThisKey = (__UNSAFE_shouldEnforceKeyForRollout === null || __UNSAFE_shouldEnforceKeyForRollout === void 0 ? void 0 : __UNSAFE_shouldEnforceKeyForRollout(originalItemKey, categoryStorageType)) === true;
            var _getBscGlobalState_disableWebStorageConsentChecks1;
            disableWebStorageConsentChecks = ((_getBscGlobalState_disableWebStorageConsentChecks1 = (0, _utils.getBscGlobalState)().disableWebStorageConsentChecks) !== null && _getBscGlobalState_disableWebStorageConsentChecks1 !== void 0 ? _getBscGlobalState_disableWebStorageConsentChecks1 : false) && !enforceThisKey;
        }
        if (disableWebStorageConsentChecks) {
            try {
                (0, _itemKeyCacheService.ItemKeyCache).markSetByPackage(categoryStorageType, originalItemKey);
                originalSetItem.apply(storageContext, [
                    originalItemKey,
                    originalItemValue
                ]);
            } catch (e) {
                (0, _reportSetItemError.reportSetItemError)({
                    message: `${storageType} failed to setItem with consent checks disabled. ${e.message || ''}`,
                    attributes: {
                        outsidePackage: !itemSetByPackage,
                        storageType,
                        consentChecksDisabled: true
                    },
                    error: e
                });
            }
            let wasCheckAsync = true;
            try {
                const productName = (0, _utils.getBscGlobalState)().product;
                const { allowUncategorizedCookiesInOverrides, allowUncategorizedItemsInWebStorageOverrides } = (0, _utils.getBscGlobalState)();
                // trigger the callbacks to emit analytics events but do nothing with the result.
                (0, _itemProcessing.isProcessingAllowedByPreferences)({
                    itemKey: originalItemKey,
                    allowedCallback: ({ wasAsync })=>{
                        wasCheckAsync = wasAsync;
                        (0, _utils.sendPackageOperationalEvent)({
                            action: 'usedAtlBrowserStorageSetItem',
                            attributes: {
                                itemKey: originalItemKey,
                                outsidePackage: !itemSetByPackage,
                                storageType,
                                wasAsync,
                                consentChecksDisabled: true
                            }
                        });
                    },
                    blockedCallback: ({ itemHasCategory, itemCategory, wasAsync })=>{
                        wasCheckAsync = wasAsync;
                        (0, _utils.sendPackageOperationalEvent)({
                            action: 'usedAtlBrowserStorageSetItem',
                            attributes: {
                                itemKey: originalItemKey,
                                outsidePackage: !itemSetByPackage,
                                storageType,
                                wasAsync,
                                consentChecksDisabled: true
                            }
                        });
                        var _getBscGlobalState_cacheLoadedDate;
                        if (!itemHasCategory && (0, _uncategorizedItemReportCache.shouldReportUncategorizedItemSet)(categoryStorageType, originalItemKey)) (0, _analyticsClient.sendTrackEvent)({
                            source: 'package',
                            action: 'package',
                            actionSubject: 'uncategorizedWebStorageItemSet',
                            attributes: (0, _objectSpread._)({
                                storageType,
                                productName,
                                originalItemKey,
                                itemCategory: itemCategory !== null && itemCategory !== void 0 ? itemCategory : null,
                                allowUncategorizedCookiesInOverrides,
                                allowUncategorizedItemsInWebStorageOverrides,
                                consentChecksDisabled: true,
                                wasAsync
                            }, (0, _platformFeatureFlags.fg)('platform_bsc_cache_load_date') && {
                                cacheLoadedDate: (_getBscGlobalState_cacheLoadedDate = (0, _utils.getBscGlobalState)().cacheLoadedDate) !== null && _getBscGlobalState_cacheLoadedDate !== void 0 ? _getBscGlobalState_cacheLoadedDate : null
                            }),
                            onSent: (0, _uncategorizedItemReportCache.uncategorizedItemSetOnSent)(categoryStorageType, originalItemKey)
                        });
                    },
                    storageType: categoryStorageType,
                    productName
                });
            } catch (e) {
                (0, _reportSetItemError.reportSetItemError)({
                    message: `Failed to emit analytics with consent checks disabled. ${e.message || ''}`,
                    attributes: {
                        itemKey: originalItemKey,
                        storageType,
                        consentChecksDisabled: true,
                        wasAsync: wasCheckAsync
                    },
                    error: e
                });
            }
            return;
        }
        if (itemSetByPackage) try {
            // Controls have already been run, passthrough as usual
            return originalSetItem.apply(storageContext, [
                originalItemKey,
                originalItemValue
            ]);
        } catch (e) {
            (0, _reportSetItemError.reportSetItemError)({
                message: `${storageType} failed to setItem. ${e.message || ''}`,
                attributes: {
                    outsidePackage: false,
                    storageType
                },
                error: e
            });
        }
        try {
            let wasCheckAsync = true;
            try {
                const productName = (0, _utils.getBscGlobalState)().product;
                // Attempt to set a known item key that was set from outside the package
                (0, _itemProcessing.isProcessingAllowedByPreferences)({
                    itemKey: originalItemKey,
                    allowedCallback: ({ wasAsync })=>{
                        wasCheckAsync = wasAsync;
                        (0, _utils.sendPackageOperationalEvent)({
                            action: 'usedAtlBrowserStorageSetItem',
                            attributes: {
                                itemKey: originalItemKey,
                                outsidePackage: !itemSetByPackage,
                                storageType,
                                wasAsync
                            }
                        });
                        originalSetItem.apply(storageContext, [
                            originalItemKey,
                            originalItemValue
                        ]);
                    },
                    blockedCallback: ({ itemHasCategory, itemCategory, wasAsync })=>{
                        wasCheckAsync = wasAsync;
                        (0, _utils.sendPackageOperationalEvent)({
                            action: 'usedAtlBrowserStorageSetItem',
                            attributes: {
                                itemKey: originalItemKey,
                                outsidePackage: !itemSetByPackage,
                                storageType,
                                wasAsync
                            }
                        });
                        var _getBscGlobalState_cacheLoadedDate;
                        if (!itemHasCategory && (0, _uncategorizedItemReportCache.shouldReportUncategorizedItemSet)(categoryStorageType, originalItemKey)) (0, _analyticsClient.sendTrackEvent)({
                            source: 'package',
                            action: 'package',
                            actionSubject: 'uncategorizedWebStorageItemSet',
                            attributes: (0, _objectSpread._)({
                                storageType,
                                productName,
                                originalItemKey,
                                itemCategory: itemCategory !== null && itemCategory !== void 0 ? itemCategory : null,
                                wasAsync
                            }, (0, _platformFeatureFlags.fg)('platform_bsc_cache_load_date') && {
                                cacheLoadedDate: (_getBscGlobalState_cacheLoadedDate = (0, _utils.getBscGlobalState)().cacheLoadedDate) !== null && _getBscGlobalState_cacheLoadedDate !== void 0 ? _getBscGlobalState_cacheLoadedDate : null
                            }),
                            onSent: (0, _uncategorizedItemReportCache.uncategorizedItemSetOnSent)(categoryStorageType, originalItemKey)
                        });
                        const { allowUncategorizedCookiesInOverrides, allowUncategorizedItemsInWebStorageOverrides } = (0, _utils.getBscGlobalState)();
                        // allowUncategorizedCookiesInOverrides impacts both web storage and cookies due to historical reasons
                        const allowUncategorized = allowUncategorizedCookiesInOverrides || allowUncategorizedItemsInWebStorageOverrides;
                        if (allowUncategorized && !itemHasCategory) originalSetItem.apply(storageContext, [
                            originalItemKey,
                            originalItemValue
                        ]);
                        else {
                            if (!itemHasCategory) (0, _logger.Logger).warn(`${storageType}.setItem('${originalItemKey}', ...) was blocked` + `${productName ? ` for product "${productName}"` : ''}` + `: '${originalItemKey}' is not registered in the BSC data store. Add it to the data store before calling this API.`);
                            return;
                        }
                    },
                    storageType: categoryStorageType,
                    productName
                });
            } catch (e) {
                (0, _reportSetItemError.reportSetItemError)({
                    message: `Failed to set item. ${e.message || ''}`,
                    attributes: {
                        itemKey: originalItemKey,
                        storageType,
                        wasAsync: wasCheckAsync
                    },
                    error: e
                });
            }
        } catch (e) {
            (0, _reportSetItemError.reportSetItemError)({
                message: `Failed to send ${storageType} setter event. ${e.message || ''}`,
                error: e
            });
        }
    };

},{"@swc/helpers/_/_object_spread":"9gdrV","@atlaskit/platform-feature-flags":"8rD2i","../../../../common/utils":"gnWyu","../../../../common/utils/analytics-client":"3Dqor","../../../../common/utils/item-processing":"8zwf4","../../../../common/utils/logger":"2Tk7J","../../../../services/item-key-cache-service":"4UZqe","../../../../services/uncategorized-item-report-cache":"jMbZW","../../../../services/web-storage-service":"d0pCe","../../../../services/web-storage-service/utils/report-set-item-error":"3TCEn","../../../../types":"65Pa5","@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"2fr8b":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "setCookie", ()=>setCookie);
var _objectSpread = require("@swc/helpers/_/_object_spread");
var _objectSpreadProps = require("@swc/helpers/_/_object_spread_props");
var _jsCookie = require("js-cookie");
var _jsCookieDefault = parcelHelpers.interopDefault(_jsCookie);
var _platformFeatureFlags = require("@atlaskit/platform-feature-flags");
var _utils = require("../../../common/utils");
var _itemProcessing = require("../../../common/utils/item-processing");
var _logger = require("../../../common/utils/logger");
var _types = require("../../../types");
const setCookie = async (key, value, attributes)=>{
    if ((0, _platformFeatureFlags.fg)('platform_moonjelly_bsc_master_killswitch')) {
        // Set the cookie without checking user preferences
        // when master killswitch is enabled
        (0, _jsCookieDefault.default).set(key, value, (0, _objectSpreadProps._)((0, _objectSpread._)({}, attributes), {
            'atl-set-cookie': true
        }));
        return (0, _types.Status).SUCCESS;
    }
    // user belongs to an org that opted into cookies management and we should respect their preferences
    const productName = (0, _utils.getBscGlobalState)().product;
    const wasInitialized = (0, _utils.getBscGlobalState)().hasInitialized;
    // Flag enabled, user belongs to an org that opted into cookies management and we should respect their preferences
    let blockedCookieItemCategory;
    const shouldSetCookie = await (0, _itemProcessing.isProcessingAllowedByPreferences)({
        itemKey: key,
        storageType: (0, _types.CategoryStorageType).Cookies,
        productName,
        blockedCallback: ({ itemCategory })=>{
            blockedCookieItemCategory = itemCategory;
        }
    });
    const eventAttributes = {
        wasRejected: !shouldSetCookie,
        cookieKey: key
    };
    try {
        (0, _utils.sendPackageOperationalEvent)({
            action: 'usedSetCookie',
            attributes: eventAttributes
        });
        if (!wasInitialized && (0, _platformFeatureFlags.fg)('platform_bsc_initialize_controls_analytics')) (0, _utils.sendPackageOperationalEvent)({
            action: 'setItemWithoutInit',
            attributes: {
                itemKey: key,
                storageType: 'Cookie'
            }
        });
        if (shouldSetCookie) {
            (0, _jsCookieDefault.default).set(key, value, (0, _objectSpreadProps._)((0, _objectSpread._)({}, attributes), {
                'atl-set-cookie': true
            }));
            return (0, _types.Status).SUCCESS;
        } else {
            if (blockedCookieItemCategory === null) (0, _logger.Logger).warn(`setCookie('${key}', ...) was blocked` + `${productName ? ` for product "${productName}"` : ''}` + `: '${key}' is not registered in the BSC data store. Add it to the data store before calling this API.`);
            return (0, _types.Status).BLOCKED;
        }
    } catch (e) {
        (0, _logger.Logger).errorWithOperationalEvent({
            action: 'usedSetCookieError',
            attributes: eventAttributes,
            message: `Failed to use set cookie. ${e.message || ''}`
        });
        return (0, _types.Status).BLOCKED;
    }
};

},{"@swc/helpers/_/_object_spread":"9gdrV","@swc/helpers/_/_object_spread_props":"kANqQ","js-cookie":"brgOH","@atlaskit/platform-feature-flags":"8rD2i","../../../common/utils":"gnWyu","../../../common/utils/item-processing":"8zwf4","../../../common/utils/logger":"2Tk7J","../../../types":"65Pa5","@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"jMIew":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "updatePreferences", ()=>updatePreferences);
var _utils = require("../../../common/utils");
var _constants = require("../../../constants");
var _types = require("../../../types");
var _setConsentToken = require("../../cookie-controls/set-consent-token");
var _setStrictlyNecessaryCookie = require("../../cookie-controls/set-strictly-necessary-cookie");
var _transformer = require("../../cookie-controls/transformer");
const emptyDisplayedTextMap = {
    [(0, _types.PreferenceCategory).Analytics]: '',
    [(0, _types.PreferenceCategory).Functional]: '',
    [(0, _types.PreferenceCategory).Marketing]: '',
    [(0, _types.PreferenceCategory).StrictlyNecessary]: '',
    [(0, _types.PreferenceCategory).Unknown]: ''
};
async function updatePreferences(preferences, displayedTextMap = emptyDisplayedTextMap, usingPrefetchedData) {
    if ((0, _utils.getBscGlobalState)().localConsentMode) {
        const packedPrefs = (0, _transformer.packUserPreferences)(preferences);
        (0, _setStrictlyNecessaryCookie.setStrictlyNecessaryCookie)((0, _constants.LEGACY_ATLASSIAN_GDPR_COOKIE_KEY), packedPrefs, {
            expires: 365,
            path: '/'
        });
    } else await (0, _setConsentToken.setConsentToken)(preferences, displayedTextMap, usingPrefetchedData);
}

},{"../../../common/utils":"gnWyu","../../../constants":"9FHD5","../../../types":"65Pa5","../../cookie-controls/set-consent-token":"1NIhm","../../cookie-controls/set-strictly-necessary-cookie":"dUkaQ","../../cookie-controls/transformer":"hcsh1","@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"1NIhm":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "createConsentTokenCookies", ()=>createConsentTokenCookies);
parcelHelpers.export(exports, "createErrorDrivenTokens", ()=>createErrorDrivenTokens);
parcelHelpers.export(exports, "setConsentToken", ()=>setConsentToken);
var _objectSpread = require("@swc/helpers/_/_object_spread");
var _objectSpreadProps = require("@swc/helpers/_/_object_spread_props");
var _utils = require("../../../common/utils");
var _consentHubService = require("../../../services/consent-hub-service");
var _utils1 = require("../../../services/consent-hub-service/utils");
var _types = require("../../../types");
var _setRequiredConsentCookies = require("../set-required-consent-cookies");
var _transformer = require("../transformer");
var _utils2 = require("./utils");
const createConsentTokenCookies = (mergedPrefs, usingPrefetchedData)=>{
    // If platform_moonjelly_bsc_fallback_token_audit feature gate is on,
    // use new fallback consent token logic
    // On a successful save, transform the prefs object into a formatted consentToken bit string
    // Then store the new token in a 10min-expiry consent cookie and a 1yr-expiry fallback cookie
    const consentToken = (0, _transformer.packUserPreferences)(mergedPrefs);
    // Check if the token is prefetched and set to default.
    if (usingPrefetchedData && (0, _utils1.checkIfTokenIsDefault)(consentToken)) return;
    if (usingPrefetchedData) (0, _utils2.onlySetFallbackIfDifferent)(consentToken);
    else (0, _setRequiredConsentCookies.setConsentTokenFallbackCookie)(consentToken);
    (0, _setRequiredConsentCookies.setConsentTokenCookie)(consentToken);
    (0, _setRequiredConsentCookies.setShouldShowBannerCookie)(consentToken);
};
const createErrorDrivenTokens = (err, mergedPrefs)=>{
    const errorDueToUnauthenticatedRequest = err instanceof (0, _utils1.StatusCodeError) && err.status === 401;
    const errorDueToConsentHubBeingInaccessible = err instanceof (0, _utils1.StatusCodeError) && err.status >= 500 && err.status < 600; // Any 5xx error
    // Indicates the user is genuinely logged out instead of ConsentHub being inaccessible
    // If we dont explicitly 401, defer to the previous auth state
    const updatedAuthState = errorDueToUnauthenticatedRequest ? !errorDueToUnauthenticatedRequest : !!mergedPrefs[(0, _types.ContextualConsentProperty).UserIsAuthenticated];
    const consentToken = (0, _transformer.packUserPreferences)((0, _objectSpreadProps._)((0, _objectSpread._)({}, mergedPrefs), {
        [(0, _types.ContextualConsentProperty).UserIsAuthenticated]: updatedAuthState,
        [(0, _types.ContextualConsentProperty).ConsentDataUnavailable]: errorDueToConsentHubBeingInaccessible
    }));
    if (errorDueToUnauthenticatedRequest) {
        // When the failure is derived from a local-only/unauthenticated user, we need to also set the consent token
        // Otherwise, we will never actually adhere to their consents, as they'll continue to receive default every time we attempt to unsuccessfully fetch their prefs
        (0, _utils.Logger).error(`User is unauthenticated. ${err.message}`);
        (0, _utils2.onlySetFallbackIfDifferent)(consentToken);
        (0, _setRequiredConsentCookies.setConsentTokenCookie)(consentToken);
        (0, _setRequiredConsentCookies.setShouldShowBannerCookie)(consentToken);
        return;
    }
    // When there's an actual failure, we only store data in the fallbackConsentToken cookie
    // This allows us to still track consents when ConsentHub is down > 10 minute expiry
    // But do _not_ set a consentToken cookie so we attempt to re-request from ConsentHub on sequential loads
    // This circumvents an issue of a user thinking they saved consents to CH, but when we request them later,
    // CH has no record of them, and they get shown the banner again
    (0, _utils.Logger).error('Token failed to save');
    (0, _utils2.onlySetFallbackIfDifferent)(consentToken);
    (0, _setRequiredConsentCookies.setShouldShowBannerCookie)(consentToken);
};
const setConsentToken = async (updatedPreferences, displayedTextMap, usingPrefetchedData)=>{
    const mergedPrefs = (0, _utils2.mergeConsentUpdates)(updatedPreferences, usingPrefetchedData);
    try {
        if (!usingPrefetchedData) // Attempts to save the newly updated preferences object
        // Can only be saved when a user is logged in, so this error will be caught if unauthed
        await (0, _consentHubService.saveConsentPreferences)(mergedPrefs, displayedTextMap);
        createConsentTokenCookies(mergedPrefs, usingPrefetchedData);
    } catch (err) {
        // If we fail to save to ConsentHub, it could be due to ConsentHub being down, the user being unauthenticated/local-only,
        // or an exception somewhere in the stack. Ensure we pack that information into the token where applicable.
        createErrorDrivenTokens(err, mergedPrefs);
    }
};

},{"@swc/helpers/_/_object_spread":"9gdrV","@swc/helpers/_/_object_spread_props":"kANqQ","../../../common/utils":"gnWyu","../../../services/consent-hub-service":"8HdyV","../../../services/consent-hub-service/utils":"8vzek","../../../types":"65Pa5","../set-required-consent-cookies":"j36f0","../transformer":"hcsh1","./utils":"a1DCd","@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"a1DCd":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "mergeConsentUpdates", ()=>mergeConsentUpdates);
parcelHelpers.export(exports, "onlySetFallbackIfDifferent", ()=>onlySetFallbackIfDifferent);
var _objectSpread = require("@swc/helpers/_/_object_spread");
var _constants = require("../../../constants");
var _types = require("../../../types");
var _getCookie = require("../get-cookie");
var _setRequiredConsentCookies = require("../set-required-consent-cookies");
var _transformer = require("../transformer");
const pruneLegacyProperties = (updatedPreferences)=>{
    // Strips any possible V002/legacy properties from the preferences by excluding everything but the core prefs
    return {
        [(0, _types.PreferenceCategory).StrictlyNecessary]: updatedPreferences[(0, _types.PreferenceCategory).StrictlyNecessary],
        [(0, _types.PreferenceCategory).Functional]: updatedPreferences[(0, _types.PreferenceCategory).Functional],
        [(0, _types.PreferenceCategory).Analytics]: updatedPreferences[(0, _types.PreferenceCategory).Analytics],
        [(0, _types.PreferenceCategory).Marketing]: updatedPreferences[(0, _types.PreferenceCategory).Marketing],
        [(0, _types.PreferenceCategory).Unknown]: updatedPreferences[(0, _types.PreferenceCategory).Unknown]
    };
};
const setContextualConsentProperties = (consentPreferences, usingPrefetchedData)=>{
    // When merging during this phase, retain the "unauthed/authed" context of the preferences
    const existingUserAuthenticatedState = consentPreferences === null || consentPreferences === void 0 ? void 0 : consentPreferences[(0, _types.ContextualConsentProperty).UserIsAuthenticated];
    const existingConsentHubUnavailableState = !!(consentPreferences === null || consentPreferences === void 0 ? void 0 : consentPreferences[(0, _types.ContextualConsentProperty).ConsentDataUnavailable]);
    // When processing a legacy token, UserIsAuthenticated will be missing, so we need to backfill it with context from ConsentHubUnavailable
    const existingOrBackfilledAuthState = existingUserAuthenticatedState === undefined ? !existingConsentHubUnavailableState : existingUserAuthenticatedState;
    // Overwriting this flag while merging here gets us into a situation where a prefetched/cached, default cookie is just being set in the system,
    // but we mark the consents as "genuine", when they haven't actually been saved.
    // Doing this would have negative downstream effects, as we invoke logic dependent on if a token is a default or not
    const existingDefaultState = !!(consentPreferences === null || consentPreferences === void 0 ? void 0 : consentPreferences[(0, _types.ContextualConsentProperty).ConsentsAreDefault]);
    const consentsAreDefault = usingPrefetchedData ? existingDefaultState : false;
    return {
        [(0, _types.ContextualConsentProperty).ConsentsAreDefault]: consentsAreDefault,
        [(0, _types.ContextualConsentProperty).UserIsAuthenticated]: existingOrBackfilledAuthState,
        [(0, _types.ContextualConsentProperty).ConsentDataUnavailable]: existingConsentHubUnavailableState
    };
};
const mergeConsentUpdates = (updatedPreferences, usingPrefetchedData)=>{
    // DEFAULT_PREFERENCES now gives us "CH unavailable" and "is default" bits
    const existingPrefs = (0, _getCookie.getCookie)((0, _constants.ATLASSIAN_CONSENT_COOKIE_KEY));
    if (existingPrefs) {
        // Unpacking a V2 should now result in a V3 token anyway, but ensure we have proper bits
        const unpackedExistingPrefs = (0, _transformer.unpackUserPreferencesCookie)(existingPrefs);
        // Capture any missed options (shouldn't have any if we have existing consent token), and
        // ensure we write the bit dictating that these consents are no longer defaults since they're being saved
        if (unpackedExistingPrefs) return (0, _objectSpread._)({}, (0, _constants.DEFAULT_PREFERENCES), unpackedExistingPrefs, pruneLegacyProperties(updatedPreferences), setContextualConsentProperties(unpackedExistingPrefs, usingPrefetchedData));
        return (0, _objectSpread._)({}, (0, _constants.DEFAULT_PREFERENCES), pruneLegacyProperties(updatedPreferences));
    }
    // If we don't have existing prefs, this is likely a first time save for this domain
    // Ensure we note this is a successful, genuine set of prefs by updating the contextual properties as needed
    return (0, _objectSpread._)({}, (0, _constants.DEFAULT_PREFERENCES), pruneLegacyProperties(updatedPreferences), setContextualConsentProperties(updatedPreferences, usingPrefetchedData));
};
const onlySetFallbackIfDifferent = (consentToken)=>{
    // Diff the token we're trying to set vs. any existing fallback, and only set a new fallback if the value has changed.
    // A difference would mean the user made a change since their original fallback was stored and we should update.
    // Otherwise, we would be unintentionally overriding the "1 year" expiration date the fallback token tracks.
    const existingFallbackToken = (0, _getCookie.getCookie)((0, _constants.ATLASSIAN_CONSENT_FALLBACK_COOKIE_KEY));
    const tokenDiffersFromOldFallback = existingFallbackToken !== consentToken;
    if (!existingFallbackToken || tokenDiffersFromOldFallback) (0, _setRequiredConsentCookies.setConsentTokenFallbackCookie)(consentToken);
};

},{"@swc/helpers/_/_object_spread":"9gdrV","../../../constants":"9FHD5","../../../types":"65Pa5","../get-cookie":"VS0K5","../set-required-consent-cookies":"j36f0","../transformer":"hcsh1","@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"54Ai5":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "i18n", ()=>i18n);
var _reactIntl = require("react-intl");
const i18n = (0, _reactIntl.defineMessages)({
    preferencesBtn: {
        id: 'browser-storage-controls.consent-banner.preferences.button',
        defaultMessage: 'Preferences',
        description: 'Preferences button that opens consent modal dialog.'
    },
    onlyNecessaryBtn: {
        id: 'browser-storage-controls.consent-banner.only-necessary.button',
        defaultMessage: 'Only necessary',
        description: 'Only necessary button that saves user preferences - only necessary cookies.'
    },
    acceptAllBtn: {
        id: 'browser-storage-controls.consent-banner.accept-all.button',
        defaultMessage: 'Accept all',
        description: 'Accept all button that saves user preferences - accepts all cookies.'
    },
    cookiesTrackingNotice: {
        id: 'browser-storage-controls.consent-banner.cookies-tracking-notice.text.101024',
        defaultMessage: 'Atlassian cookies and tracking notice',
        description: 'Link that leads to Atlassian cookies/tracking legal notice text on Atlassian website.'
    },
    useCookiesDescription: {
        id: 'browser-storage-controls.consent-banner.cookies-description.text',
        defaultMessage: 'Atlassian uses cookies to improve your browsing experience, perform analytics and research, and conduct advertising. Accept all cookies to indicate that you agree to our use of cookies on your device. {linkToCookiesTrackingNotice}',
        description: 'Description that explains Atlassian cookie controls and how it is used.'
    },
    useCookiesDescriptionNoLink: {
        id: 'browser-storage-controls.consent-banner.cookies-description.text.no.link',
        defaultMessage: 'Atlassian uses cookies to improve your browsing experience, perform analytics and research, and conduct advertising. Accept all cookies to indicate that you agree to our use of cookies on your device.',
        description: 'Description that explains Atlassian cookie controls and how it is used.'
    },
    successFlagTitle: {
        id: 'browser-storage-controls.consent-banner.success-flag.title',
        defaultMessage: 'Cookie preferences saved',
        description: 'Title for the success flag shown when cookie preferences are saved initially.'
    },
    successFlagDescription: {
        id: 'browser-storage-controls.consent-banner.success-flag.description',
        defaultMessage: 'You can change this at any time in your Atlassian account.',
        description: 'Description for the success flag shown when cookie preferences are saved initially.'
    },
    successFlagDescriptionLocalOnly: {
        id: 'browser-storage-controls.consent-banner.success-flag.description-local-only',
        defaultMessage: 'Your preferences will only affect this site.',
        description: 'Description for the success flag shown when cookie preferences are saved locally, meaning that those preferences will only affect the current domain.'
    },
    errorFlagTitle: {
        id: 'browser-storage-controls.consent-banner.error-flag.title',
        defaultMessage: "We're unable to update the policy",
        description: 'Title for the error flag shown when cookie preferences are not saved.'
    },
    errorFlagDescription: {
        id: 'browser-storage-controls.consent-banner.error-flag.description',
        defaultMessage: 'Try again in a few minutes.',
        description: 'Description for the error flag shown when cookie preferences are not saved.'
    }
});

},{"react-intl":"f41fF","@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"hZAKY":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "PreferenceModal", ()=>PreferenceModal);
parcelHelpers.export(exports, "PreferenceModalImpl", ()=>PreferenceModalImpl);
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _flag = require("@atlaskit/flag");
var _platformFeatureFlags = require("@atlaskit/platform-feature-flags");
var _analyticsClient = require("../../../common/utils/analytics-client");
var _locale = require("../../../common/utils/locale");
var _logger = require("../../../common/utils/logger");
var _constants = require("../../../constants");
var _updatePreferences = require("../../../controllers/preferences-controls/update-preferences");
var _presentationalPreferenceModal = require("./presentational-preference-modal");
var _usePreferences = require("./use-preferences");
var _usePreferencesDefault = parcelHelpers.interopDefault(_usePreferences);
const PreferenceModal = (props)=>{
    if ((0, _platformFeatureFlags.fg)('platform_moonjelly_bsc_master_killswitch') || (0, _platformFeatureFlags.fg)('platform_moonjelly_bsc_ui_killswitch')) // Don't render the preference modal if the killswitch is enabled
    return null;
    return /*#__PURE__*/ (0, _reactDefault.default).createElement(PreferenceModalImpl, props);
};
const PreferenceModalImpl = ({ onClose, onSubmit, showSuccessFlag, showErrorFlag, shouldAddWrappers = true })=>{
    const [isModalOpen, setIsModalOpen] = (0, _react.useState)(true);
    const isEventSent = (0, _react.useRef)(false);
    (0, _react.useEffect)(()=>{
        if (!isEventSent.current) {
            (0, _analyticsClient.sendScreenEvent)({
                name: 'cookieConsentModal'
            });
            isEventSent.current = true;
        }
    }, [
        isEventSent
    ]);
    const { preferences, setPreferencesData } = (0, _usePreferencesDefault.default)({});
    // If we don't have preferences, set default preferences
    // for modal interactions
    if (!preferences) setPreferencesData({
        prefs: (0, _constants.ONLY_NECESSARY_PREFERENCES),
        isPrefetchedPrefsInternalState: false
    });
    const handleOnSubmit = (0, _react.useCallback)(async (displayedTextMap)=>{
        if (preferences) {
            const selectedPreferences = preferences;
            (0, _analyticsClient.sendUIEvent)({
                action: 'clicked',
                actionSubject: 'button',
                actionSubjectId: 'confirm',
                source: 'cookieConsentModal'
            });
            try {
                await (0, _updatePreferences.updatePreferences)(selectedPreferences, displayedTextMap);
                (0, _analyticsClient.sendTrackEvent)({
                    source: 'cookieConsentModal',
                    action: 'submitted',
                    actionSubject: 'cookieConsentPreferences'
                });
                showSuccessFlag === null || showSuccessFlag === void 0 ? void 0 : showSuccessFlag();
            } catch (e) {
                (0, _logger.Logger).errorWithOperationalEvent({
                    action: 'updatePreferencesError',
                    attributes: {
                        preferences: selectedPreferences
                    },
                    message: `Failed to update preferences from modal. ${e.message || ''}`
                });
                showErrorFlag === null || showErrorFlag === void 0 ? void 0 : showErrorFlag();
            }
            setIsModalOpen(false);
            onSubmit === null || onSubmit === void 0 ? void 0 : onSubmit();
        } else // Preferences have reached an invalid state, show error flag
        showErrorFlag === null || showErrorFlag === void 0 ? void 0 : showErrorFlag();
    }, [
        preferences,
        onSubmit,
        showSuccessFlag,
        showErrorFlag
    ]);
    const modalContent = /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _presentationalPreferenceModal.PresentationalPreferenceModal), {
        onSubmit: handleOnSubmit,
        onClose: onClose,
        setIsOpen: setIsModalOpen,
        preferences: preferences !== null && preferences !== void 0 ? preferences : (0, _constants.ONLY_NECESSARY_PREFERENCES),
        setPreferencesData: setPreferencesData
    });
    if (!isModalOpen) return null;
    return /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _reactDefault.default).Fragment, null, shouldAddWrappers ? /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _flag.FlagsProvider), null, /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _locale.BSCIntlProvider), null, modalContent)) : modalContent);
};

},{"react":"ltHCL","@atlaskit/flag":"6pYSa","@atlaskit/platform-feature-flags":"8rD2i","../../../common/utils/analytics-client":"3Dqor","../../../common/utils/locale":"6PzbS","../../../common/utils/logger":"2Tk7J","../../../constants":"9FHD5","../../../controllers/preferences-controls/update-preferences":"jMIew","./presentational-preference-modal":"lbN82","./use-preferences":"2gZ28","@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"lbN82":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "PresentationalPreferenceModal", ()=>PresentationalPreferenceModal);
var _objectSpread = require("@swc/helpers/_/_object_spread");
var _objectSpreadProps = require("@swc/helpers/_/_object_spread_props");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _reactIntl = require("react-intl");
var _button = require("@atlaskit/button");
var _buttonDefault = parcelHelpers.interopDefault(_button);
var _form = require("@atlaskit/form");
var _formDefault = parcelHelpers.interopDefault(_form);
var _heading = require("@atlaskit/heading");
var _headingDefault = parcelHelpers.interopDefault(_heading);
var _modalDialog = require("@atlaskit/modal-dialog");
var _modalDialogDefault = parcelHelpers.interopDefault(_modalDialog);
var _platformFeatureFlags = require("@atlaskit/platform-feature-flags");
// eslint-disable-next-line @atlaskit/design-system/no-emotion-primitives -- to be migrated to @atlaskit/primitives/compiled – go/akcss
var _primitives = require("@atlaskit/primitives");
var _analyticsClient = require("../../../../common/utils/analytics-client");
var _constants = require("../../../../services/consent-hub-service/constants");
var _types = require("../../../../types");
var _cookieCategorySection = require("./cookie-category-section");
var _messages = require("./messages");
const categoryNameStyles = (0, _primitives.xcss)({
    fontWeight: 'font.weight.bold'
});
const customHeaderStyles = (0, _primitives.xcss)({
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
    flexDirection: 'row-reverse'
});
const extractTextFromReactNode = (node)=>{
    if (typeof node === 'string') return node;
    if (typeof node === 'number') return String(node);
    if (Array.isArray(node)) return node.map(extractTextFromReactNode).join('');
    if (/*#__PURE__*/ (0, _reactDefault.default).isValidElement(node)) {
        if (node.props.children) return extractTextFromReactNode(node.props.children);
    }
    return '';
};
const getDefaultText = (intl)=>{
    const link = intl.formatMessage((0, _messages.i18n).trackingLink);
    const defaultSummaryDescriptionDisplayedText = intl.formatMessage((0, _messages.i18n).summaryDescription, {
        link
    });
    const defaultStrictDescriptionDisplayedTextNode = intl.formatMessage((0, _platformFeatureFlags.fg)('product-terminology-refresh') ? (0, _messages.i18n).strictDescriptionAppify : (0, _messages.i18n).strictDescription, {
        bold: (msg)=>msg
    });
    // ReactIntl requires interpolated values to be passed in, and this particular string requires a <bold> modifier.
    // Unfortunately, this converts the above formatted message to a ReactNode but ConsentHub needs strings for `displayedText`,
    // thus, we have to render to a static HTML string first and sanitize the result
    const defaultStrictDescriptionDisplayedText = extractTextFromReactNode(defaultStrictDescriptionDisplayedTextNode);
    let defaultDisplayedText = `${defaultSummaryDescriptionDisplayedText}. ${defaultStrictDescriptionDisplayedText}`;
    const sanitizedText = defaultDisplayedText.replace(/&#x27;/g, "'");
    return sanitizedText;
};
const getCookieCategories = (intl)=>{
    const cookieCategoriesToTranslate = [
        {
            // Tracks Functional related cookies like preferences
            category: (0, _types.PreferenceCategory).Functional,
            title: (0, _messages.i18n).functionalOption,
            description: (0, _messages.i18n).functionalOptionDescription
        },
        {
            // Tracks Performance related cookies like analytics
            category: (0, _types.PreferenceCategory).Analytics,
            title: (0, _messages.i18n).analyticalOption,
            description: (0, _platformFeatureFlags.fg)('product-terminology-refresh') ? (0, _messages.i18n).analyticalOptionDescriptionAppify : (0, _messages.i18n).analyticalOptionDescription
        },
        {
            // Tracks Targeting related cookies like marketing and advertising
            category: (0, _types.PreferenceCategory).Marketing,
            title: (0, _messages.i18n).marketingOption,
            description: (0, _messages.i18n).marketingOptionDescription
        }
    ];
    // We'll use this mapping to send the `displayedText` for each checkbox when saving to ConsentHub
    const displayedTextMap = (0, _constants.CONSENT_DISPLAYED_TEXT_ITEMS).reduce((translatedTextMap, category)=>{
        // Set the description as the default for all items (including items with checkboxes in the UI)
        // and we'll override as needed. Prefs that are not visually displayed in the UI anymore will use this default.
        translatedTextMap[category] = getDefaultText(intl);
        return translatedTextMap;
    }, {});
    const checkboxes = cookieCategoriesToTranslate.map(({ category, title, description })=>{
        const translatedTitle = intl.formatMessage(title);
        const translatedDescription = intl.formatMessage(description);
        // If we are showing individual checkboxes, use that description for auditing purposes
        displayedTextMap[category] = translatedDescription;
        return {
            category,
            titleElement: /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _primitives.Box), {
                xcss: categoryNameStyles
            }, translatedTitle),
            descriptionElement: /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _primitives.Box), null, translatedDescription),
            titleString: title.defaultMessage
        };
    });
    return {
        checkboxes,
        displayedTextMap
    };
};
const noop = ()=>{};
const CustomHeader = ({ onClose })=>{
    const { titleId } = (0, _modalDialog.useModal)();
    return /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _primitives.Box), {
        xcss: customHeaderStyles,
        padding: "space.300"
    }, /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _modalDialog.CloseButton), {
        onClick: onClose,
        testId: "close-modal-button"
    }), /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _headingDefault.default), {
        as: "h1",
        size: "medium",
        id: titleId
    }, /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _reactIntl.FormattedMessage), (0, _messages.i18n).title)));
};
const PresentationalPreferenceModal = ({ preferences, setPreferencesData = noop, onSubmit = noop, onClose = noop, setIsOpen = noop })=>{
    const intl = (0, _reactIntl.useIntl)();
    const onCloseModal = (0, _react.useCallback)(()=>{
        setIsOpen(false);
        onClose();
    }, [
        setIsOpen,
        onClose
    ]);
    const onClickCancel = (0, _react.useCallback)(()=>{
        onCloseModal();
        (0, _analyticsClient.sendUIEvent)({
            action: 'clicked',
            actionSubject: 'button',
            actionSubjectId: 'cancel',
            source: 'cookieConsentModal'
        });
    }, [
        onCloseModal
    ]);
    const onClickClose = (0, _react.useCallback)(()=>{
        onCloseModal();
        (0, _analyticsClient.sendUIEvent)({
            action: 'clicked',
            actionSubject: 'button',
            actionSubjectId: 'close',
            source: 'cookieConsentModal'
        });
    }, [
        onCloseModal
    ]);
    const onClickBackground = (0, _react.useCallback)(()=>{
        onCloseModal();
        (0, _analyticsClient.sendUIEvent)({
            action: 'clicked',
            actionSubject: 'area',
            actionSubjectId: 'background',
            source: 'cookieConsentModal'
        });
    }, [
        onCloseModal
    ]);
    const onClickTrackingNoticeLink = (0, _react.useCallback)(()=>{
        (0, _analyticsClient.sendUIEvent)({
            action: 'clicked',
            actionSubject: 'link',
            actionSubjectId: 'cookiesTrackingNotice',
            source: 'cookieConsentModal'
        });
    }, []);
    const cookieCategories = (0, _react.useMemo)(()=>{
        return getCookieCategories(intl);
    }, [
        intl
    ]);
    const handleSubmission = (0, _react.useCallback)(()=>{
        const { displayedTextMap } = cookieCategories;
        onSubmit(displayedTextMap);
    }, [
        onSubmit,
        cookieCategories
    ]);
    return /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _modalDialog.ModalTransition), null, /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _modalDialogDefault.default), {
        onClose: onClickBackground
    }, (0, _platformFeatureFlags.fg)('platform-design_system_team-form_conversion') ? /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _formDefault.default), {
        onSubmit: handleSubmission
    }, /*#__PURE__*/ (0, _reactDefault.default).createElement(CustomHeader, {
        onClose: onClickClose
    }), /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _modalDialog.ModalBody), null, /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _primitives.Box), null, /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _reactIntl.FormattedMessage), (0, _objectSpreadProps._)((0, _objectSpread._)({}, (0, _messages.i18n).summaryDescription), {
        values: {
            link: /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _primitives.Anchor), {
                href: "https://www.atlassian.com/legal/cookies#cookies-and-other-tracking-technologies",
                target: "_blank",
                onClick: onClickTrackingNoticeLink
            }, /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _reactIntl.FormattedMessage), (0, _messages.i18n).trackingLink))
        },
        tagName: 'p'
    })), /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _reactIntl.FormattedMessage), (0, _objectSpreadProps._)((0, _objectSpread._)({}, (0, _platformFeatureFlags.fg)('product-terminology-refresh') ? (0, _messages.i18n).strictDescriptionAppify : (0, _messages.i18n).strictDescription), {
        values: {
            bold: (msg)=>/*#__PURE__*/ (0, _reactDefault.default).createElement((0, _primitives.Text), {
                    weight: "bold"
                }, msg)
        },
        tagName: 'p'
    }))), cookieCategories.checkboxes.map(({ category, titleElement, titleString, descriptionElement: description }, index)=>{
        var _ref;
        return /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _primitives.Stack), {
            key: index
        }, /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _cookieCategorySection.CookieCategorySection), {
            category: category,
            titleElement: titleElement,
            titleString: titleString,
            descriptionElement: description,
            isChecked: (_ref = preferences && preferences[category]) !== null && _ref !== void 0 ? _ref : false,
            setPreferencesData: setPreferencesData
        }));
    })), /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _modalDialog.ModalFooter), null, /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _buttonDefault.default), {
        appearance: "subtle",
        onClick: onClickCancel,
        testId: "consent-preference-cancel"
    }, /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _reactIntl.FormattedMessage), (0, _messages.i18n).cancelBtn)), /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _buttonDefault.default), {
        type: "submit",
        appearance: "primary",
        onClick: handleSubmission,
        testId: "consent-preference-confirm"
    }, /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _reactIntl.FormattedMessage), (0, _messages.i18n).confirmBtn)))) : /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _formDefault.default), {
        onSubmit: handleSubmission
    }, ({ formProps })=>/*#__PURE__*/ (0, _reactDefault.default).createElement("form", formProps, /*#__PURE__*/ (0, _reactDefault.default).createElement(CustomHeader, {
            onClose: onClickClose
        }), /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _modalDialog.ModalBody), null, /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _primitives.Box), null, /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _reactIntl.FormattedMessage), (0, _objectSpreadProps._)((0, _objectSpread._)({}, (0, _messages.i18n).summaryDescription), {
            values: {
                link: /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _primitives.Anchor), {
                    href: "https://www.atlassian.com/legal/cookies#cookies-and-other-tracking-technologies",
                    target: "_blank",
                    onClick: onClickTrackingNoticeLink
                }, /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _reactIntl.FormattedMessage), (0, _messages.i18n).trackingLink))
            },
            tagName: 'p'
        })), /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _reactIntl.FormattedMessage), (0, _objectSpreadProps._)((0, _objectSpread._)({}, (0, _platformFeatureFlags.fg)('product-terminology-refresh') ? (0, _messages.i18n).strictDescriptionAppify : (0, _messages.i18n).strictDescription), {
            values: {
                bold: (msg)=>/*#__PURE__*/ (0, _reactDefault.default).createElement((0, _primitives.Text), {
                        weight: "bold"
                    }, msg)
            },
            tagName: 'p'
        }))), cookieCategories.checkboxes.map(({ category, titleElement, titleString, descriptionElement: description }, index)=>{
            var _ref;
            return /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _primitives.Stack), {
                key: index
            }, /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _cookieCategorySection.CookieCategorySection), {
                category: category,
                titleElement: titleElement,
                titleString: titleString,
                descriptionElement: description,
                isChecked: (_ref = preferences && preferences[category]) !== null && _ref !== void 0 ? _ref : false,
                setPreferencesData: setPreferencesData
            }));
        })), /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _modalDialog.ModalFooter), null, /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _buttonDefault.default), {
            appearance: "subtle",
            onClick: onClickCancel,
            testId: "consent-preference-cancel"
        }, /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _reactIntl.FormattedMessage), (0, _messages.i18n).cancelBtn)), /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _buttonDefault.default), {
            type: "submit",
            appearance: "primary",
            onClick: handleSubmission,
            testId: "consent-preference-confirm"
        }, /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _reactIntl.FormattedMessage), (0, _messages.i18n).confirmBtn)))))));
};

},{"@swc/helpers/_/_object_spread":"9gdrV","@swc/helpers/_/_object_spread_props":"kANqQ","react":"ltHCL","react-intl":"f41fF","@atlaskit/button":"5XKYL","@atlaskit/form":"31Srh","@atlaskit/heading":"61ZQz","@atlaskit/modal-dialog":"eJQED","@atlaskit/platform-feature-flags":"8rD2i","@atlaskit/primitives":"3S6Im","../../../../common/utils/analytics-client":"3Dqor","../../../../services/consent-hub-service/constants":"UUVLf","../../../../types":"65Pa5","./cookie-category-section":"fBvQL","./messages":"cywKi","@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"5XKYL":[function(require,module,exports,__globalThis) {
// Ideally this file is not used directly. But rather, you go through the entry points
var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>(0, _buttonDefault.default));
parcelHelpers.export(exports, "LoadingButton", ()=>(0, _loadingButtonDefault.default));
parcelHelpers.export(exports, "CustomThemeButton", ()=>(0, _customThemeButtonDefault.default));
parcelHelpers.export(exports, "Theme", ()=>(0, _themeDefault.default));
parcelHelpers.export(exports, "ButtonGroup", ()=>(0, _buttonGroupDefault.default));
var _button = require("./old-button/button");
var _buttonDefault = parcelHelpers.interopDefault(_button);
var _loadingButton = require("./old-button/loading-button");
var _loadingButtonDefault = parcelHelpers.interopDefault(_loadingButton);
var _customThemeButton = require("./old-button/custom-theme-button/custom-theme-button");
var _customThemeButtonDefault = parcelHelpers.interopDefault(_customThemeButton);
var _theme = require("./old-button/custom-theme-button/theme");
var _themeDefault = parcelHelpers.interopDefault(_theme);
var _buttonGroup = require("./containers/button-group");
var _buttonGroupDefault = parcelHelpers.interopDefault(_buttonGroup);

},{"./old-button/button":"6FFoe","./old-button/loading-button":"l2z5N","./old-button/custom-theme-button/custom-theme-button":false,"./old-button/custom-theme-button/theme":false,"./containers/button-group":"7iBuz","@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"l2z5N":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _objectSpread = require("@swc/helpers/_/_object_spread");
var _objectSpreadProps = require("@swc/helpers/_/_object_spread_props");
var _objectWithoutProperties = require("@swc/helpers/_/_object_without_properties");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _button = require("./button");
var _buttonDefault = parcelHelpers.interopDefault(_button);
var _loadingSpinner = require("./shared/loading-spinner");
var _loadingSpinnerDefault = parcelHelpers.interopDefault(_loadingSpinner);
/**
 * __Loading button__
 *
 * @deprecated Legacy loading buttons are deprecated and will be removed from `atlaskit/button` in an upcoming major release. Please use the new Button components from `@atlaskit/button/new` with the `isLoading` prop.
 *
 * Please refer to the [migration guide](https://atlassian.design/components/button/button-legacy/migration-guide) for further details.
 *
 * A small wrapper around Button that allows you to show an @atlaskit/spinner as an overlay on the button when you set an isLoading prop to true.
 *
 * - [Examples](https://atlassian.design/components/button/examples#loading-button)
 */ const LoadingButton = /*#__PURE__*/ (0, _reactDefault.default).forwardRef(function LoadingButton(_param, ref) {
    var { appearance, isDisabled, isSelected, isLoading = false, spacing } = _param, rest = (0, _objectWithoutProperties._)(_param, [
        "appearance",
        "isDisabled",
        "isSelected",
        "isLoading",
        "spacing"
    ]);
    // Button already has React.memo, so just leaning on that
    return /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _buttonDefault.default), (0, _objectSpreadProps._)((0, _objectSpread._)({}, rest), {
        ref: ref,
        appearance: appearance,
        // No need to render aria-disabled when it is false
        "aria-disabled": isLoading || undefined,
        isDisabled: isDisabled,
        isSelected: isSelected,
        overlay: isLoading ? /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _loadingSpinnerDefault.default), {
            spacing: spacing,
            appearance: appearance,
            isDisabled: isDisabled,
            isSelected: isSelected
        }) : null,
        spacing: spacing
    }));
});
// Tools including enzyme rely on components having a display name
LoadingButton.displayName = 'LoadingButton';
exports.default = LoadingButton;

},{"@swc/helpers/_/_object_spread":"9gdrV","@swc/helpers/_/_object_spread_props":"kANqQ","@swc/helpers/_/_object_without_properties":"6HqIM","react":"ltHCL","./button":"6FFoe","./shared/loading-spinner":"8emRB","@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"7iBuz":[function(require,module,exports,__globalThis) {
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>ButtonGroup);
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
// eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled -- Ignored via go/DSP-18766
var _react1 = require("@emotion/react");
const buttonGroupStyles = (0, _react1.css)({
    display: 'inline-flex',
    gap: "var(--ds-space-050, 4px)",
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
    '> *': {
        flex: '1 0 auto'
    }
});
function ButtonGroup({ children, testId, label, titleId }) {
    return /*#__PURE__*/ (0, _react1.jsx)("div", {
        css: buttonGroupStyles,
        "data-testid": testId,
        role: "group",
        "aria-label": label,
        "aria-labelledby": titleId
    }, (0, _reactDefault.default).Children.map((0, _reactDefault.default).Children.toArray(children), (child, idx)=>{
        if (!child) return null;
        return /*#__PURE__*/ (0, _react1.jsx)((0, _react.Fragment), {
            key: idx
        }, child);
    }));
}

},{"react":"ltHCL","@emotion/react":"cCAhJ","@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"31Srh":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>(0, _formDefault.default));
parcelHelpers.export(exports, "FormHeader", ()=>(0, _formHeaderDefault.default));
parcelHelpers.export(exports, "FormFooter", ()=>(0, _formFooterDefault.default));
parcelHelpers.export(exports, "FormSection", ()=>(0, _formSectionDefault.default));
parcelHelpers.export(exports, "Field", ()=>(0, _fieldDefault.default));
parcelHelpers.export(exports, "CheckboxField", ()=>(0, _checkboxFieldDefault.default));
parcelHelpers.export(exports, "RangeField", ()=>(0, _rangeFieldDefault.default));
parcelHelpers.export(exports, "Label", ()=>(0, _label.Label));
parcelHelpers.export(exports, "Legend", ()=>(0, _legend.Legend));
parcelHelpers.export(exports, "HelperMessage", ()=>(0, _helperMessage.HelperMessage));
parcelHelpers.export(exports, "ErrorMessage", ()=>(0, _errorMessage.ErrorMessage));
parcelHelpers.export(exports, "MessageWrapper", ()=>(0, _messageWrapper.MessageWrapper));
parcelHelpers.export(exports, "ValidMessage", ()=>(0, _validMessage.ValidMessage));
parcelHelpers.export(exports, "Fieldset", ()=>(0, _fieldsetDefault.default));
parcelHelpers.export(exports, "RequiredAsterisk", ()=>(0, _requiredAsteriskDefault.default));
parcelHelpers.export(exports, "useFormState", ()=>(0, _useFormState.useFormState));
parcelHelpers.export(exports, "CharacterCounterField", ()=>(0, _characterCounterFieldDefault.default));
parcelHelpers.export(exports, "CharacterCounter", ()=>(0, _characterCounterDefault.default));
var _form = require("./form");
var _formDefault = parcelHelpers.interopDefault(_form);
var _formHeader = require("./form-header");
var _formHeaderDefault = parcelHelpers.interopDefault(_formHeader);
var _formFooter = require("./form-footer");
var _formFooterDefault = parcelHelpers.interopDefault(_formFooter);
var _formSection = require("./form-section");
var _formSectionDefault = parcelHelpers.interopDefault(_formSection);
var _field = require("./field");
var _fieldDefault = parcelHelpers.interopDefault(_field);
var _checkboxField = require("./checkbox-field");
var _checkboxFieldDefault = parcelHelpers.interopDefault(_checkboxField);
var _rangeField = require("./range-field");
var _rangeFieldDefault = parcelHelpers.interopDefault(_rangeField);
var _label = require("./label");
var _legend = require("./legend");
var _helperMessage = require("./helper-message");
var _errorMessage = require("./error-message");
var _messageWrapper = require("./message-wrapper");
var _validMessage = require("./valid-message");
var _fieldset = require("./fieldset");
var _fieldsetDefault = parcelHelpers.interopDefault(_fieldset);
var _requiredAsterisk = require("./required-asterisk");
var _requiredAsteriskDefault = parcelHelpers.interopDefault(_requiredAsterisk);
var _useFormState = require("./use-form-state");
var _characterCounterField = require("./character-counter-field");
var _characterCounterFieldDefault = parcelHelpers.interopDefault(_characterCounterField);
var _characterCounter = require("./character-counter");
var _characterCounterDefault = parcelHelpers.interopDefault(_characterCounter);

},{"./form":"iaEOd","./form-header":"jbn0F","./form-footer":"bQXjr","./form-section":"4ox1F","./field":"a8nMl","./checkbox-field":"fC3Io","./range-field":"etI9Q","./label":"38kbd","./legend":"bVWbz","./helper-message":"eO3vl","./error-message":"bmGz5","./message-wrapper":"98niQ","./valid-message":"dN2X3","./fieldset":"caM6S","./required-asterisk":"eAd3H","./use-form-state":"iuqqB","./character-counter-field":"1XR69","./character-counter":"8afE4","@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"iaEOd":[function(require,module,exports,__globalThis) {
/* form.tsx generated by @compiled/babel-plugin v0.39.1 */ var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _objectSpread = require("@swc/helpers/_/_object_spread");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _finalForm = require("final-form");
var _finalFormFocus = require("final-form-focus");
var _finalFormFocusDefault = parcelHelpers.interopDefault(_finalFormFocus);
var _set = require("lodash/set");
var _setDefault = parcelHelpers.interopDefault(_set);
var _forwardRefWithGeneric = require("@atlaskit/ds-lib/forward-ref-with-generic");
var _forwardRefWithGenericDefault = parcelHelpers.interopDefault(_forwardRefWithGeneric);
var _mergeRefs = require("@atlaskit/ds-lib/merge-refs");
var _mergeRefsDefault = parcelHelpers.interopDefault(_mergeRefs);
var _formContext = require("./form-context");
var _isDisabledContext = require("./is-disabled-context");
var _utils = require("./utils");
const FormBase = (props, ref)=>{
    const { autocomplete, formProps: userProvidedFormProps, id, label, labelId, name, noValidate, onSubmit, testId, xcss } = props;
    const formRef = (0, _react.useRef)(null);
    const onSubmitRef = (0, _react.useRef)(onSubmit);
    onSubmitRef.current = onSubmit;
    const [form] = (0, _react.useState)(()=>{
        // Types here would break the existing API
        const finalForm = (0, _finalForm.createForm)({
            onSubmit: (...args)=>onSubmitRef.current(...args),
            destroyOnUnregister: true,
            initialValues: {},
            mutators: {
                setDefaultValue: ([name, defaultValue], state)=>{
                    if (state.formState.initialValues) {
                        const initialValues = state.formState.initialValues;
                        const values = state.formState.values;
                        const value = name && typeof defaultValue === 'function' ? defaultValue(initialValues[name]) : defaultValue;
                        (0, _setDefault.default)(initialValues, name, value);
                        (0, _setDefault.default)(values, name, value);
                    }
                }
            }
        });
        (0, _finalFormFocusDefault.default)(()=>formRef.current ? Array.from(formRef.current.querySelectorAll('input')) : [], (0, _utils.getFirstErrorField))(finalForm);
        return finalForm;
    });
    const [state, setState] = (0, _react.useState)({
        dirty: false,
        submitting: false
    });
    (0, _react.useEffect)(()=>{
        const unsubscribe = form.subscribe(({ dirty, submitting })=>{
            setState({
                dirty,
                submitting
            });
        }, {
            dirty: true,
            submitting: true
        });
        return unsubscribe;
    }, [
        form
    ]);
    const registerField = (0, _react.useCallback)((name, defaultValue, subscriber, subscription, config)=>{
        form.pauseValidation();
        const unsubscribe = form.registerField(name, subscriber, subscription, config);
        form.mutators.setDefaultValue(name, defaultValue);
        form.resumeValidation();
        return unsubscribe;
    }, [
        form
    ]);
    const handleSubmit = (e)=>{
        if (e) e.preventDefault();
        form.submit();
    };
    const handleReset = (initialValues)=>{
        form.reset(initialValues);
    };
    const handleKeyDown = (e)=>{
        if (e.key === 'Enter' && (e.ctrlKey || e.metaKey) && formRef.current) {
            const submitButton = formRef.current.querySelector('button:not([type]), button[type="submit"], input[type="submit"]');
            if (submitButton) submitButton.click();
            e.preventDefault();
        }
    };
    const { isDisabled = false, children } = props;
    const { dirty, submitting } = state;
    /**
   * This method is needed in FormContext to use it on the field level
   * to check the current value of the field in case of the component re-mounting.
   */ const getCurrentValue = (0, _react.useCallback)((name)=>{
        const formState = form.getState();
        return (formState === null || formState === void 0 ? void 0 : formState.values[name]) || undefined;
    }, [
        form
    ]);
    const FormContextValue = (0, _react.useMemo)(()=>{
        return {
            registerField,
            getCurrentValue,
            subscribe: form.subscribe
        };
    }, [
        registerField,
        getCurrentValue,
        form.subscribe
    ]);
    const conditionalFormProps = {
        autocomplete,
        className: xcss,
        id,
        'aria-label': label,
        'aria-labelledby': labelId,
        name,
        noValidate,
        'data-testid': testId
    };
    // Abstracting so we can use the same for both rendering patterns
    const formProps = {
        onKeyDown: handleKeyDown,
        onSubmit: handleSubmit,
        ref: ref ? (0, _mergeRefsDefault.default)([
            ref,
            formRef
        ]) : formRef
    };
    // We don't want to add undefined values to the component
    Object.keys(conditionalFormProps).forEach((attr)=>{
        if (conditionalFormProps[attr] !== undefined) formProps[attr] = conditionalFormProps[attr];
    });
    const childrenContent = (()=>{
        if (typeof children === 'function') {
            const result = children.length > 0 ? children({
                formProps,
                dirty,
                reset: handleReset,
                submitting,
                disabled: isDisabled,
                getState: ()=>form.getState(),
                getValues: ()=>form.getState().values,
                setFieldValue: form.change,
                resetFieldState: form.resetFieldState
            }) : children();
            return result === undefined ? null : result;
        } else return /*#__PURE__*/ (0, _reactDefault.default).createElement("form", (0, _objectSpread._)({}, formProps, userProvidedFormProps), children);
    })();
    return /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _formContext.FormContext).Provider, {
        value: FormContextValue
    }, /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _isDisabledContext.IsDisabledContext).Provider, {
        value: isDisabled
    }, childrenContent));
};
/**
 * __Form__
 *
 * A form allows users to input information.
 *
 * - [Examples](https://atlassian.design/components/form/examples)
 * - [Code](https://atlassian.design/components/form/code)
 * - [Usage](https://atlassian.design/components/form/usage)
 */ const Form = (0, _forwardRefWithGenericDefault.default)(FormBase);
// eslint-disable-next-line @atlaskit/volt-strict-mode/no-multiple-exports
exports.default = Form;

},{"@swc/helpers/_/_object_spread":"9gdrV","react":"ltHCL","final-form":"gSo5N","final-form-focus":"jAbkv","lodash/set":"lT2WR","@atlaskit/ds-lib/forward-ref-with-generic":"7Zbu3","@atlaskit/ds-lib/merge-refs":"doPwA","./form-context":"53rSg","./is-disabled-context":"4JBgy","./utils":"6D2qc","@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"gSo5N":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "ARRAY_ERROR", ()=>ARRAY_ERROR);
parcelHelpers.export(exports, "FORM_ERROR", ()=>FORM_ERROR);
parcelHelpers.export(exports, "configOptions", ()=>configOptions);
parcelHelpers.export(exports, "createForm", ()=>createForm);
parcelHelpers.export(exports, "fieldSubscriptionItems", ()=>fieldSubscriptionItems);
parcelHelpers.export(exports, "formSubscriptionItems", ()=>formSubscriptionItems);
parcelHelpers.export(exports, "getIn", ()=>getIn);
parcelHelpers.export(exports, "setIn", ()=>setIn);
parcelHelpers.export(exports, "version", ()=>version);
var _extends = require("@babel/runtime/helpers/esm/extends");
var _extendsDefault = parcelHelpers.interopDefault(_extends);
var _objectWithoutPropertiesLoose = require("@babel/runtime/helpers/esm/objectWithoutPropertiesLoose");
var _objectWithoutPropertiesLooseDefault = parcelHelpers.interopDefault(_objectWithoutPropertiesLoose);
//      
var charCodeOfDot = ".".charCodeAt(0);
var reEscapeChar = /\\(\\)?/g;
var rePropName = RegExp(// Match anything that isn't a dot or bracket.
"[^.[\\]]+|\\[(?:([^\"'][^[]*)|([\"'])((?:(?!\\2)[^\\\\]|\\\\.)*?)\\2)\\]|(?=(?:\\.|\\[\\])(?:\\.|\\[\\]|$))", "g");
/**
 * Converts `string` to a property path array.
 *
 * @private
 * @param {string} string The string to convert.
 * @returns {Array} Returns the property path array.
 */ var stringToPath = function stringToPath(string) {
    var result = [];
    if (string.charCodeAt(0) === charCodeOfDot) result.push("");
    string.replace(rePropName, function(match, expression, quote, subString) {
        var key = match;
        if (quote) key = subString.replace(reEscapeChar, "$1");
        else if (expression) key = expression.trim();
        result.push(key);
    });
    return result;
};
var keysCache = {};
var keysRegex = /[.[\]]+/;
var toPath = function toPath(key) {
    if (key === null || key === undefined || !key.length) return [];
    if (typeof key !== "string") throw new Error("toPath() expects a string");
    if (keysCache[key] == null) {
        /**
     * The following patch fixes issue 456, introduced since v4.20.3:
     *
     * Before v4.20.3, i.e. in v4.20.2, a `key` like 'choices[]' would map to ['choices']
     * (e.g. an array of choices used where 'choices[]' is name attribute of an input of type checkbox).
     *
     * Since v4.20.3, a `key` like 'choices[]' would map to ['choices', ''] which is wrong and breaks
     * this kind of inputs e.g. in React.
     *
     * v4.20.3 introduced an unwanted breaking change, this patch fixes it, see the issue at the link below.
     *
     * @see https://github.com/final-form/final-form/issues/456
     */ if (key.endsWith("[]")) // v4.20.2 (a `key` like 'choices[]' should map to ['choices'], which is fine).
        keysCache[key] = key.split(keysRegex).filter(Boolean);
        else // v4.20.3 (a `key` like 'choices[]' maps to ['choices', ''], which breaks applications relying on inputs like `<input type="checkbox" name="choices[]" />`).
        keysCache[key] = stringToPath(key);
    }
    return keysCache[key];
};
//      
var getIn = function getIn(state, complexKey) {
    // Intentionally using iteration rather than recursion
    var path = toPath(complexKey);
    var current = state;
    for(var i = 0; i < path.length; i++){
        var key = path[i];
        if (current === undefined || current === null || typeof current !== "object" || Array.isArray(current) && isNaN(key)) return undefined;
        current = current[key];
    }
    return current;
};
function _toPropertyKey(arg) {
    var key = _toPrimitive(arg, "string");
    return typeof key === "symbol" ? key : String(key);
}
function _toPrimitive(input, hint) {
    if (typeof input !== "object" || input === null) return input;
    var prim = input[Symbol.toPrimitive];
    if (prim !== undefined) {
        var res = prim.call(input, hint || "default");
        if (typeof res !== "object") return res;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return (hint === "string" ? String : Number)(input);
}
var setInRecursor = function setInRecursor(current, index, path, value1, destroyArrays) {
    if (index >= path.length) // end of recursion
    return value1;
    var key = path[index];
    // determine type of key
    if (isNaN(key)) {
        var _extends2;
        // object set
        if (current === undefined || current === null) {
            var _ref;
            // recurse
            var _result = setInRecursor(undefined, index + 1, path, value1, destroyArrays);
            // delete or create an object
            return _result === undefined ? undefined : (_ref = {}, _ref[key] = _result, _ref);
        }
        if (Array.isArray(current)) throw new Error("Cannot set a non-numeric property on an array");
        // current exists, so make a copy of all its values, and add/update the new one
        var _result2 = setInRecursor(current[key], index + 1, path, value1, destroyArrays);
        if (_result2 === undefined) {
            var numKeys = Object.keys(current).length;
            if (current[key] === undefined && numKeys === 0) // object was already empty
            return undefined;
            if (current[key] !== undefined && numKeys <= 1) {
                // only key we had was the one we are deleting
                if (!isNaN(path[index - 1]) && !destroyArrays) // we are in an array, so return an empty object
                return {};
                else return undefined;
            }
            current[key];
            var _final = (0, _objectWithoutPropertiesLooseDefault.default)(current, [
                key
            ].map(_toPropertyKey));
            return _final;
        }
        // set result in key
        return (0, _extendsDefault.default)({}, current, (_extends2 = {}, _extends2[key] = _result2, _extends2));
    }
    // array set
    var numericKey = Number(key);
    if (current === undefined || current === null) {
        // recurse
        var _result3 = setInRecursor(undefined, index + 1, path, value1, destroyArrays);
        // if nothing returned, delete it
        if (_result3 === undefined) return undefined;
        // create an array
        var _array = [];
        _array[numericKey] = _result3;
        return _array;
    }
    if (!Array.isArray(current)) throw new Error("Cannot set a numeric property on an object");
    // recurse
    var existingValue = current[numericKey];
    var result = setInRecursor(existingValue, index + 1, path, value1, destroyArrays);
    // current exists, so make a copy of all its values, and add/update the new one
    var array = [].concat(current);
    if (destroyArrays && result === undefined) {
        array.splice(numericKey, 1);
        if (array.length === 0) return undefined;
    } else array[numericKey] = result;
    return array;
};
var setIn = function setIn(state, key, value1, destroyArrays) {
    if (destroyArrays === void 0) destroyArrays = false;
    if (state === undefined || state === null) throw new Error("Cannot call setIn() with " + String(state) + " state");
    if (key === undefined || key === null) throw new Error("Cannot call setIn() with " + String(key) + " key");
    // Recursive function needs to accept and return State, but public API should
    // only deal with Objects
    return setInRecursor(state, 0, toPath(key), value1, destroyArrays);
};
var FORM_ERROR = "FINAL_FORM/form-error";
var ARRAY_ERROR = "FINAL_FORM/array-error";
//      
/**
 * Converts internal field state to published field state
 */ function publishFieldState(formState, field) {
    var errors = formState.errors, initialValues = formState.initialValues, lastSubmittedValues = formState.lastSubmittedValues, submitErrors = formState.submitErrors, submitFailed = formState.submitFailed, submitSucceeded = formState.submitSucceeded, submitting = formState.submitting, values = formState.values;
    var active = field.active, blur = field.blur, change = field.change, data = field.data, focus = field.focus, modified = field.modified, modifiedSinceLastSubmit = field.modifiedSinceLastSubmit, name = field.name, touched = field.touched, validating = field.validating, visited = field.visited;
    var value1 = getIn(values, name);
    var error = getIn(errors, name);
    if (error && error[ARRAY_ERROR]) error = error[ARRAY_ERROR];
    var submitError = submitErrors && getIn(submitErrors, name);
    var initial = initialValues && getIn(initialValues, name);
    var pristine = field.isEqual(initial, value1);
    var dirtySinceLastSubmit = !!(lastSubmittedValues && !field.isEqual(getIn(lastSubmittedValues, name), value1));
    var valid = !error && !submitError;
    return {
        active: active,
        blur: blur,
        change: change,
        data: data,
        dirty: !pristine,
        dirtySinceLastSubmit: dirtySinceLastSubmit,
        error: error,
        focus: focus,
        initial: initial,
        invalid: !valid,
        length: Array.isArray(value1) ? value1.length : undefined,
        modified: modified,
        modifiedSinceLastSubmit: modifiedSinceLastSubmit,
        name: name,
        pristine: pristine,
        submitError: submitError,
        submitFailed: submitFailed,
        submitSucceeded: submitSucceeded,
        submitting: submitting,
        touched: touched,
        valid: valid,
        value: value1,
        visited: visited,
        validating: validating
    };
}
//      
var fieldSubscriptionItems = [
    "active",
    "data",
    "dirty",
    "dirtySinceLastSubmit",
    "error",
    "initial",
    "invalid",
    "length",
    "modified",
    "modifiedSinceLastSubmit",
    "pristine",
    "submitError",
    "submitFailed",
    "submitSucceeded",
    "submitting",
    "touched",
    "valid",
    "value",
    "visited",
    "validating"
];
//      
var shallowEqual = function shallowEqual(a, b) {
    if (a === b) return true;
    if (typeof a !== "object" || !a || typeof b !== "object" || !b) return false;
    var keysA = Object.keys(a);
    var keysB = Object.keys(b);
    if (keysA.length !== keysB.length) return false;
    var bHasOwnProperty = Object.prototype.hasOwnProperty.bind(b);
    for(var idx = 0; idx < keysA.length; idx++){
        var key = keysA[idx];
        if (!bHasOwnProperty(key) || a[key] !== b[key]) return false;
    }
    return true;
};
//      
function subscriptionFilter(dest, src, previous, subscription, keys, shallowEqualKeys) {
    var different = false;
    keys.forEach(function(key) {
        if (subscription[key]) {
            dest[key] = src[key];
            if (!previous || (~shallowEqualKeys.indexOf(key) ? !shallowEqual(src[key], previous[key]) : src[key] !== previous[key])) different = true;
        }
    });
    return different;
}
//      
var shallowEqualKeys$1 = [
    "data"
];
/**
 * Filters items in a FieldState based on a FieldSubscription
 */ var filterFieldState = function filterFieldState(state, previousState, subscription, force) {
    var result = {
        blur: state.blur,
        change: state.change,
        focus: state.focus,
        name: state.name
    };
    var different = subscriptionFilter(result, state, previousState, subscription, fieldSubscriptionItems, shallowEqualKeys$1) || !previousState;
    return different || force ? result : undefined;
};
//      
var formSubscriptionItems = [
    "active",
    "dirty",
    "dirtyFields",
    "dirtyFieldsSinceLastSubmit",
    "dirtySinceLastSubmit",
    "error",
    "errors",
    "hasSubmitErrors",
    "hasValidationErrors",
    "initialValues",
    "invalid",
    "modified",
    "modifiedSinceLastSubmit",
    "pristine",
    "submitting",
    "submitError",
    "submitErrors",
    "submitFailed",
    "submitSucceeded",
    "touched",
    "valid",
    "validating",
    "values",
    "visited"
];
//      
var shallowEqualKeys = [
    "touched",
    "visited"
];
/**
 * Filters items in a FormState based on a FormSubscription
 */ function filterFormState(state, previousState, subscription, force) {
    var result = {};
    var different = subscriptionFilter(result, state, previousState, subscription, formSubscriptionItems, shallowEqualKeys) || !previousState;
    return different || force ? result : undefined;
}
//      
var memoize = function memoize(fn) {
    var lastArgs;
    var lastResult;
    return function() {
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        if (!lastArgs || args.length !== lastArgs.length || args.some(function(arg, index) {
            return !shallowEqual(lastArgs[index], arg);
        })) {
            lastArgs = args;
            lastResult = fn.apply(void 0, args);
        }
        return lastResult;
    };
};
var isPromise = function(obj) {
    return !!obj && (typeof obj === "object" || typeof obj === "function") && typeof obj.then === "function";
};
var version = "4.20.10";
var configOptions = [
    "debug",
    "initialValues",
    "keepDirtyOnReinitialize",
    "mutators",
    "onSubmit",
    "validate",
    "validateOnBlur"
];
var tripleEquals = function tripleEquals(a, b) {
    return a === b;
};
var hasAnyError = function hasAnyError(errors) {
    return Object.keys(errors).some(function(key) {
        var value1 = errors[key];
        if (value1 && typeof value1 === "object" && !(value1 instanceof Error)) return hasAnyError(value1);
        return typeof value1 !== "undefined";
    });
};
function convertToExternalFormState(_ref) {
    var active = _ref.active, dirtySinceLastSubmit = _ref.dirtySinceLastSubmit, modifiedSinceLastSubmit = _ref.modifiedSinceLastSubmit, error = _ref.error, errors = _ref.errors, initialValues = _ref.initialValues, pristine = _ref.pristine, submitting = _ref.submitting, submitFailed = _ref.submitFailed, submitSucceeded = _ref.submitSucceeded, submitError = _ref.submitError, submitErrors = _ref.submitErrors, valid = _ref.valid, validating = _ref.validating, values = _ref.values;
    return {
        active: active,
        dirty: !pristine,
        dirtySinceLastSubmit: dirtySinceLastSubmit,
        modifiedSinceLastSubmit: modifiedSinceLastSubmit,
        error: error,
        errors: errors,
        hasSubmitErrors: !!(submitError || submitErrors && hasAnyError(submitErrors)),
        hasValidationErrors: !!(error || hasAnyError(errors)),
        invalid: !valid,
        initialValues: initialValues,
        pristine: pristine,
        submitting: submitting,
        submitFailed: submitFailed,
        submitSucceeded: submitSucceeded,
        submitError: submitError,
        submitErrors: submitErrors,
        valid: valid,
        validating: validating > 0,
        values: values
    };
}
function notifySubscriber(subscriber, subscription, state, lastState, filter, force) {
    var notification = filter(state, lastState, subscription, force);
    if (notification) {
        subscriber(notification);
        return true;
    }
    return false;
}
function notify(_ref2, state, lastState, filter, force) {
    var entries = _ref2.entries;
    Object.keys(entries).forEach(function(key) {
        var entry = entries[Number(key)];
        // istanbul ignore next
        if (entry) {
            var subscription = entry.subscription, subscriber = entry.subscriber, notified = entry.notified;
            if (notifySubscriber(subscriber, subscription, state, lastState, filter, force || !notified)) entry.notified = true;
        }
    });
}
function createForm(config) {
    if (!config) throw new Error("No config specified");
    var debug = config.debug, destroyOnUnregister = config.destroyOnUnregister, keepDirtyOnReinitialize = config.keepDirtyOnReinitialize, initialValues = config.initialValues, mutators = config.mutators, onSubmit = config.onSubmit, validate = config.validate, validateOnBlur = config.validateOnBlur;
    if (!onSubmit) throw new Error("No onSubmit function specified");
    var state = {
        subscribers: {
            index: 0,
            entries: {}
        },
        fieldSubscribers: {},
        fields: {},
        formState: {
            asyncErrors: {},
            dirtySinceLastSubmit: false,
            modifiedSinceLastSubmit: false,
            errors: {},
            initialValues: initialValues && (0, _extendsDefault.default)({}, initialValues),
            invalid: false,
            pristine: true,
            submitting: false,
            submitFailed: false,
            submitSucceeded: false,
            resetWhileSubmitting: false,
            valid: true,
            validating: 0,
            values: initialValues ? (0, _extendsDefault.default)({}, initialValues) : {}
        },
        lastFormState: undefined
    };
    var inBatch = 0;
    var validationPaused = false;
    var validationBlocked = false;
    var preventNotificationWhileValidationPaused = false;
    var nextAsyncValidationKey = 0;
    var asyncValidationPromises = {};
    var clearAsyncValidationPromise = function clearAsyncValidationPromise(key) {
        return function(result) {
            delete asyncValidationPromises[key];
            return result;
        };
    };
    var changeValue = function changeValue(state, name, mutate) {
        var before = getIn(state.formState.values, name);
        var after = mutate(before);
        state.formState.values = setIn(state.formState.values, name, after) || {};
    };
    var renameField = function renameField(state, from, to) {
        if (state.fields[from]) {
            var _extends2, _extends3;
            state.fields = (0, _extendsDefault.default)({}, state.fields, (_extends2 = {}, _extends2[to] = (0, _extendsDefault.default)({}, state.fields[from], {
                name: to,
                // rebind event handlers
                blur: function blur() {
                    return api.blur(to);
                },
                change: function change(value1) {
                    return api.change(to, value1);
                },
                focus: function focus() {
                    return api.focus(to);
                },
                lastFieldState: undefined
            }), _extends2));
            delete state.fields[from];
            state.fieldSubscribers = (0, _extendsDefault.default)({}, state.fieldSubscribers, (_extends3 = {}, _extends3[to] = state.fieldSubscribers[from], _extends3));
            delete state.fieldSubscribers[from];
            var value1 = getIn(state.formState.values, from);
            state.formState.values = setIn(state.formState.values, from, undefined) || {};
            state.formState.values = setIn(state.formState.values, to, value1);
            delete state.lastFormState;
        }
    };
    // bind state to mutators
    var getMutatorApi = function getMutatorApi(key) {
        return function() {
            // istanbul ignore next
            if (mutators) {
                // ^^ causes branch coverage warning, but needed to appease the Flow gods
                var mutatableState = {
                    formState: state.formState,
                    fields: state.fields,
                    fieldSubscribers: state.fieldSubscribers,
                    lastFormState: state.lastFormState
                };
                for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
                var returnValue = mutators[key](args, mutatableState, {
                    changeValue: changeValue,
                    getIn: getIn,
                    renameField: renameField,
                    resetFieldState: api.resetFieldState,
                    setIn: setIn,
                    shallowEqual: shallowEqual
                });
                state.formState = mutatableState.formState;
                state.fields = mutatableState.fields;
                state.fieldSubscribers = mutatableState.fieldSubscribers;
                state.lastFormState = mutatableState.lastFormState;
                runValidation(undefined, function() {
                    notifyFieldListeners();
                    notifyFormListeners();
                });
                return returnValue;
            }
        };
    };
    var mutatorsApi = mutators ? Object.keys(mutators).reduce(function(result, key) {
        result[key] = getMutatorApi(key);
        return result;
    }, {}) : {};
    var runRecordLevelValidation = function runRecordLevelValidation(setErrors) {
        var promises = [];
        if (validate) {
            var errorsOrPromise = validate((0, _extendsDefault.default)({}, state.formState.values)); // clone to avoid writing
            if (isPromise(errorsOrPromise)) promises.push(errorsOrPromise.then(function(errors) {
                return setErrors(errors, true);
            }));
            else setErrors(errorsOrPromise, false);
        }
        return promises;
    };
    var getValidators = function getValidators(field) {
        return Object.keys(field.validators).reduce(function(result, index) {
            var validator = field.validators[Number(index)]();
            if (validator) result.push(validator);
            return result;
        }, []);
    };
    var runFieldLevelValidation = function runFieldLevelValidation(field, setError) {
        var promises = [];
        var validators = getValidators(field);
        if (validators.length) {
            var error;
            validators.forEach(function(validator) {
                var errorOrPromise = validator(getIn(state.formState.values, field.name), state.formState.values, validator.length === 0 || validator.length === 3 ? publishFieldState(state.formState, state.fields[field.name]) : undefined);
                if (errorOrPromise && isPromise(errorOrPromise)) {
                    field.validating = true;
                    var promise = errorOrPromise.then(function(error) {
                        if (state.fields[field.name]) {
                            state.fields[field.name].validating = false;
                            setError(error);
                        }
                    }); // errors must be resolved, not rejected
                    promises.push(promise);
                } else if (!error) // first registered validator wins
                error = errorOrPromise;
            });
            setError(error);
        }
        return promises;
    };
    var runValidation = function runValidation(fieldChanged, callback) {
        if (validationPaused) {
            validationBlocked = true;
            callback();
            return;
        }
        var fields = state.fields, formState = state.formState;
        var safeFields = (0, _extendsDefault.default)({}, fields);
        var fieldKeys = Object.keys(safeFields);
        if (!validate && !fieldKeys.some(function(key) {
            return getValidators(safeFields[key]).length;
        })) {
            callback();
            return; // no validation rules
        }
        // pare down field keys to actually validate
        var limitedFieldLevelValidation = false;
        if (fieldChanged) {
            var changedField = safeFields[fieldChanged];
            if (changedField) {
                var validateFields = changedField.validateFields;
                if (validateFields) {
                    limitedFieldLevelValidation = true;
                    fieldKeys = validateFields.length ? validateFields.concat(fieldChanged) : [
                        fieldChanged
                    ];
                }
            }
        }
        var recordLevelErrors = {};
        var asyncRecordLevelErrors = {};
        var fieldLevelErrors = {};
        var promises = [].concat(runRecordLevelValidation(function(errors, wasAsync) {
            if (wasAsync) asyncRecordLevelErrors = errors || {};
            else recordLevelErrors = errors || {};
        }), fieldKeys.reduce(function(result, name) {
            return result.concat(runFieldLevelValidation(fields[name], function(error) {
                fieldLevelErrors[name] = error;
            }));
        }, []));
        var hasAsyncValidations = promises.length > 0;
        var asyncValidationPromiseKey = ++nextAsyncValidationKey;
        var promise = Promise.all(promises).then(clearAsyncValidationPromise(asyncValidationPromiseKey));
        // backwards-compat: add promise to submit-blocking promises iff there are any promises to await
        if (hasAsyncValidations) asyncValidationPromises[asyncValidationPromiseKey] = promise;
        var processErrors = function processErrors(afterAsync) {
            var merged = (0, _extendsDefault.default)({}, limitedFieldLevelValidation ? formState.errors : {}, recordLevelErrors, afterAsync ? asyncRecordLevelErrors // new async errors
             : formState.asyncErrors);
            var forEachError = function forEachError(fn) {
                fieldKeys.forEach(function(name) {
                    if (fields[name]) {
                        // make sure field is still registered
                        // field-level errors take precedent over record-level errors
                        var recordLevelError = getIn(recordLevelErrors, name);
                        var errorFromParent = getIn(merged, name);
                        var hasFieldLevelValidation = getValidators(safeFields[name]).length;
                        var fieldLevelError = fieldLevelErrors[name];
                        fn(name, hasFieldLevelValidation && fieldLevelError || validate && recordLevelError || (!recordLevelError && !limitedFieldLevelValidation ? errorFromParent : undefined));
                    }
                });
            };
            forEachError(function(name, error) {
                merged = setIn(merged, name, error) || {};
            });
            forEachError(function(name, error) {
                if (error && error[ARRAY_ERROR]) {
                    var existing = getIn(merged, name);
                    var copy = [].concat(existing);
                    copy[ARRAY_ERROR] = error[ARRAY_ERROR];
                    merged = setIn(merged, name, copy);
                }
            });
            if (!shallowEqual(formState.errors, merged)) formState.errors = merged;
            if (afterAsync) formState.asyncErrors = asyncRecordLevelErrors;
            formState.error = recordLevelErrors[FORM_ERROR];
        };
        if (hasAsyncValidations) {
            // async validations are running, ensure validating is true before notifying
            state.formState.validating++;
            callback();
        }
        // process sync errors
        processErrors(false);
        // sync errors have been set. notify listeners while we wait for others
        callback();
        if (hasAsyncValidations) {
            var afterPromise = function afterPromise() {
                state.formState.validating--;
                callback();
                // field async validation may affect formState validating
                // so force notifyFormListeners if validating is still 0 after callback finished
                // and lastFormState validating is true
                if (state.formState.validating === 0 && state.lastFormState.validating) notifyFormListeners();
            };
            promise.then(function() {
                if (nextAsyncValidationKey > asyncValidationPromiseKey) // if this async validator has been superseded by another, ignore its results
                return;
                processErrors(true);
            }).then(afterPromise, afterPromise);
        }
    };
    var notifyFieldListeners = function notifyFieldListeners(name) {
        if (inBatch) return;
        var fields = state.fields, fieldSubscribers = state.fieldSubscribers, formState = state.formState;
        var safeFields = (0, _extendsDefault.default)({}, fields);
        var notifyField = function notifyField(name) {
            var field = safeFields[name];
            var fieldState = publishFieldState(formState, field);
            var lastFieldState = field.lastFieldState;
            field.lastFieldState = fieldState;
            var fieldSubscriber = fieldSubscribers[name];
            if (fieldSubscriber) notify(fieldSubscriber, fieldState, lastFieldState, filterFieldState, lastFieldState === undefined);
        };
        if (name) notifyField(name);
        else Object.keys(safeFields).forEach(notifyField);
    };
    var markAllFieldsTouched = function markAllFieldsTouched() {
        Object.keys(state.fields).forEach(function(key) {
            state.fields[key].touched = true;
        });
    };
    var hasSyncErrors = function hasSyncErrors() {
        return !!(state.formState.error || hasAnyError(state.formState.errors));
    };
    var calculateNextFormState = function calculateNextFormState() {
        var fields = state.fields, formState = state.formState, lastFormState = state.lastFormState;
        var safeFields = (0, _extendsDefault.default)({}, fields);
        var safeFieldKeys = Object.keys(safeFields);
        // calculate dirty/pristine
        var foundDirty = false;
        var dirtyFields = safeFieldKeys.reduce(function(result, key) {
            var dirty = !safeFields[key].isEqual(getIn(formState.values, key), getIn(formState.initialValues || {}, key));
            if (dirty) {
                foundDirty = true;
                result[key] = true;
            }
            return result;
        }, {});
        var dirtyFieldsSinceLastSubmit = safeFieldKeys.reduce(function(result, key) {
            // istanbul ignore next
            var nonNullLastSubmittedValues = formState.lastSubmittedValues || {}; // || {} is for flow, but causes branch coverage complaint
            if (!safeFields[key].isEqual(getIn(formState.values, key), getIn(nonNullLastSubmittedValues, key))) result[key] = true;
            return result;
        }, {});
        formState.pristine = !foundDirty;
        formState.dirtySinceLastSubmit = !!(formState.lastSubmittedValues && Object.values(dirtyFieldsSinceLastSubmit).some(function(value1) {
            return value1;
        }));
        formState.modifiedSinceLastSubmit = !!(formState.lastSubmittedValues && // Object.values would treat values as mixed (facebook/flow#2221)
        Object.keys(safeFields).some(function(value1) {
            return safeFields[value1].modifiedSinceLastSubmit;
        }));
        formState.valid = !formState.error && !formState.submitError && !hasAnyError(formState.errors) && !(formState.submitErrors && hasAnyError(formState.submitErrors));
        var nextFormState = convertToExternalFormState(formState);
        var _safeFieldKeys$reduce = safeFieldKeys.reduce(function(result, key) {
            result.modified[key] = safeFields[key].modified;
            result.touched[key] = safeFields[key].touched;
            result.visited[key] = safeFields[key].visited;
            return result;
        }, {
            modified: {},
            touched: {},
            visited: {}
        }), modified = _safeFieldKeys$reduce.modified, touched = _safeFieldKeys$reduce.touched, visited = _safeFieldKeys$reduce.visited;
        nextFormState.dirtyFields = lastFormState && shallowEqual(lastFormState.dirtyFields, dirtyFields) ? lastFormState.dirtyFields : dirtyFields;
        nextFormState.dirtyFieldsSinceLastSubmit = lastFormState && shallowEqual(lastFormState.dirtyFieldsSinceLastSubmit, dirtyFieldsSinceLastSubmit) ? lastFormState.dirtyFieldsSinceLastSubmit : dirtyFieldsSinceLastSubmit;
        nextFormState.modified = lastFormState && shallowEqual(lastFormState.modified, modified) ? lastFormState.modified : modified;
        nextFormState.touched = lastFormState && shallowEqual(lastFormState.touched, touched) ? lastFormState.touched : touched;
        nextFormState.visited = lastFormState && shallowEqual(lastFormState.visited, visited) ? lastFormState.visited : visited;
        return lastFormState && shallowEqual(lastFormState, nextFormState) ? lastFormState : nextFormState;
    };
    var callDebug = function callDebug() {
        return debug && true && debug(calculateNextFormState(), Object.keys(state.fields).reduce(function(result, key) {
            result[key] = state.fields[key];
            return result;
        }, {}));
    };
    var notifying = false;
    var scheduleNotification = false;
    var notifyFormListeners = function notifyFormListeners() {
        if (notifying) scheduleNotification = true;
        else {
            notifying = true;
            callDebug();
            if (!inBatch && !(validationPaused && preventNotificationWhileValidationPaused)) {
                var lastFormState = state.lastFormState;
                var nextFormState = calculateNextFormState();
                if (nextFormState !== lastFormState) {
                    state.lastFormState = nextFormState;
                    notify(state.subscribers, nextFormState, lastFormState, filterFormState);
                }
            }
            notifying = false;
            if (scheduleNotification) {
                scheduleNotification = false;
                notifyFormListeners();
            }
        }
    };
    var beforeSubmit = function beforeSubmit() {
        return Object.keys(state.fields).some(function(name) {
            return state.fields[name].beforeSubmit && state.fields[name].beforeSubmit() === false;
        });
    };
    var afterSubmit = function afterSubmit() {
        return Object.keys(state.fields).forEach(function(name) {
            return state.fields[name].afterSubmit && state.fields[name].afterSubmit();
        });
    };
    var resetModifiedAfterSubmit = function resetModifiedAfterSubmit() {
        return Object.keys(state.fields).forEach(function(key) {
            return state.fields[key].modifiedSinceLastSubmit = false;
        });
    };
    // generate initial errors
    runValidation(undefined, function() {
        notifyFormListeners();
    });
    var api = {
        batch: function batch(fn) {
            inBatch++;
            fn();
            inBatch--;
            notifyFieldListeners();
            notifyFormListeners();
        },
        blur: function blur(name) {
            var fields = state.fields, formState = state.formState;
            var previous = fields[name];
            if (previous) {
                // can only blur registered fields
                delete formState.active;
                fields[name] = (0, _extendsDefault.default)({}, previous, {
                    active: false,
                    touched: true
                });
                if (validateOnBlur) runValidation(name, function() {
                    notifyFieldListeners();
                    notifyFormListeners();
                });
                else {
                    notifyFieldListeners();
                    notifyFormListeners();
                }
            }
        },
        change: function change(name, value1) {
            var fields = state.fields, formState = state.formState;
            if (getIn(formState.values, name) !== value1) {
                changeValue(state, name, function() {
                    return value1;
                });
                var previous = fields[name];
                if (previous) // only track modified for registered fields
                fields[name] = (0, _extendsDefault.default)({}, previous, {
                    modified: true,
                    modifiedSinceLastSubmit: !!formState.lastSubmittedValues
                });
                if (validateOnBlur) {
                    notifyFieldListeners();
                    notifyFormListeners();
                } else runValidation(name, function() {
                    notifyFieldListeners();
                    notifyFormListeners();
                });
            }
        },
        get destroyOnUnregister () {
            return !!destroyOnUnregister;
        },
        set destroyOnUnregister (value){
            destroyOnUnregister = value;
        },
        focus: function focus(name) {
            var field = state.fields[name];
            if (field && !field.active) {
                state.formState.active = name;
                field.active = true;
                field.visited = true;
                notifyFieldListeners();
                notifyFormListeners();
            }
        },
        mutators: mutatorsApi,
        getFieldState: function getFieldState(name) {
            var field = state.fields[name];
            return field && field.lastFieldState;
        },
        getRegisteredFields: function getRegisteredFields() {
            return Object.keys(state.fields);
        },
        getState: function getState() {
            return calculateNextFormState();
        },
        initialize: function initialize(data) {
            var fields = state.fields, formState = state.formState;
            var safeFields = (0, _extendsDefault.default)({}, fields);
            var values = typeof data === "function" ? data(formState.values) : data;
            if (!keepDirtyOnReinitialize) formState.values = values;
            /**
       * Hello, inquisitive code reader! Thanks for taking the time to dig in!
       *
       * The following code is the way it is to allow for non-registered deep
       * field values to be set via initialize()
       */ // save dirty values
            var savedDirtyValues = keepDirtyOnReinitialize ? Object.keys(safeFields).reduce(function(result, key) {
                var field = safeFields[key];
                var pristine = field.isEqual(getIn(formState.values, key), getIn(formState.initialValues || {}, key));
                if (!pristine) result[key] = getIn(formState.values, key);
                return result;
            }, {}) : {};
            // update initalValues and values
            formState.initialValues = values;
            formState.values = values;
            // restore the dirty values
            Object.keys(savedDirtyValues).forEach(function(key) {
                formState.values = setIn(formState.values, key, savedDirtyValues[key]) || {};
            });
            runValidation(undefined, function() {
                notifyFieldListeners();
                notifyFormListeners();
            });
        },
        isValidationPaused: function isValidationPaused() {
            return validationPaused;
        },
        pauseValidation: function pauseValidation(preventNotification) {
            if (preventNotification === void 0) preventNotification = true;
            validationPaused = true;
            preventNotificationWhileValidationPaused = preventNotification;
        },
        registerField: function registerField(name, subscriber, subscription, fieldConfig) {
            if (subscription === void 0) subscription = {};
            if (!state.fieldSubscribers[name]) state.fieldSubscribers[name] = {
                index: 0,
                entries: {}
            };
            var index = state.fieldSubscribers[name].index++;
            // save field subscriber callback
            state.fieldSubscribers[name].entries[index] = {
                subscriber: memoize(subscriber),
                subscription: subscription,
                notified: false
            };
            // create initial field state if not exists
            var field = state.fields[name] || {
                active: false,
                afterSubmit: fieldConfig && fieldConfig.afterSubmit,
                beforeSubmit: fieldConfig && fieldConfig.beforeSubmit,
                data: fieldConfig && fieldConfig.data || {},
                isEqual: fieldConfig && fieldConfig.isEqual || tripleEquals,
                lastFieldState: undefined,
                modified: false,
                modifiedSinceLastSubmit: false,
                name: name,
                touched: false,
                valid: true,
                validateFields: fieldConfig && fieldConfig.validateFields,
                validators: {},
                validating: false,
                visited: false
            };
            // Mutators can create a field in order to keep the field states
            // We must update this field when registerField is called afterwards
            field.blur = field.blur || function() {
                return api.blur(name);
            };
            field.change = field.change || function(value1) {
                return api.change(name, value1);
            };
            field.focus = field.focus || function() {
                return api.focus(name);
            };
            state.fields[name] = field;
            var haveValidator = false;
            var silent = fieldConfig && fieldConfig.silent;
            var notify = function notify() {
                if (silent && state.fields[name]) notifyFieldListeners(name);
                else {
                    notifyFormListeners();
                    notifyFieldListeners();
                }
            };
            if (fieldConfig) {
                haveValidator = !!(fieldConfig.getValidator && fieldConfig.getValidator());
                if (fieldConfig.getValidator) state.fields[name].validators[index] = fieldConfig.getValidator;
                var noValueInFormState = getIn(state.formState.values, name) === undefined;
                if (fieldConfig.initialValue !== undefined && (noValueInFormState || getIn(state.formState.values, name) === getIn(state.formState.initialValues, name))) {
                    state.formState.initialValues = setIn(state.formState.initialValues || {}, name, fieldConfig.initialValue);
                    state.formState.values = setIn(state.formState.values, name, fieldConfig.initialValue);
                    runValidation(undefined, notify);
                }
                // only use defaultValue if we don't yet have any value for this field
                if (fieldConfig.defaultValue !== undefined && fieldConfig.initialValue === undefined && getIn(state.formState.initialValues, name) === undefined && noValueInFormState) state.formState.values = setIn(state.formState.values, name, fieldConfig.defaultValue);
            }
            if (haveValidator) runValidation(undefined, notify);
            else notify();
            return function() {
                var validatorRemoved = false;
                // istanbul ignore next
                if (state.fields[name]) {
                    // state.fields[name] may have been removed by a mutator
                    validatorRemoved = !!(state.fields[name].validators[index] && state.fields[name].validators[index]());
                    delete state.fields[name].validators[index];
                }
                var hasFieldSubscribers = !!state.fieldSubscribers[name];
                if (hasFieldSubscribers) // state.fieldSubscribers[name] may have been removed by a mutator
                delete state.fieldSubscribers[name].entries[index];
                var lastOne = hasFieldSubscribers && !Object.keys(state.fieldSubscribers[name].entries).length;
                if (lastOne) {
                    delete state.fieldSubscribers[name];
                    delete state.fields[name];
                    if (validatorRemoved) state.formState.errors = setIn(state.formState.errors, name, undefined) || {};
                    if (destroyOnUnregister) state.formState.values = setIn(state.formState.values, name, undefined, true) || {};
                }
                if (!silent) {
                    if (validatorRemoved) runValidation(undefined, function() {
                        notifyFormListeners();
                        notifyFieldListeners();
                    });
                    else if (lastOne) // values or errors may have changed
                    notifyFormListeners();
                }
            };
        },
        reset: function reset(initialValues) {
            if (initialValues === void 0) initialValues = state.formState.initialValues;
            if (state.formState.submitting) state.formState.resetWhileSubmitting = true;
            state.formState.submitFailed = false;
            state.formState.submitSucceeded = false;
            delete state.formState.submitError;
            delete state.formState.submitErrors;
            delete state.formState.lastSubmittedValues;
            api.initialize(initialValues || {});
        },
        /**
     * Resets all field flags (e.g. touched, visited, etc.) to their initial state
     */ resetFieldState: function resetFieldState(name) {
            state.fields[name] = (0, _extendsDefault.default)({}, state.fields[name], {
                active: false,
                lastFieldState: undefined,
                modified: false,
                touched: false,
                valid: true,
                validating: false,
                visited: false
            });
            runValidation(undefined, function() {
                notifyFieldListeners();
                notifyFormListeners();
            });
        },
        /**
     * Returns the form to a clean slate; that is:
     * - Clear all values
     * - Resets all fields to their initial state
     */ restart: function restart(initialValues) {
            if (initialValues === void 0) initialValues = state.formState.initialValues;
            api.batch(function() {
                for(var name in state.fields){
                    api.resetFieldState(name);
                    state.fields[name] = (0, _extendsDefault.default)({}, state.fields[name], {
                        active: false,
                        lastFieldState: undefined,
                        modified: false,
                        modifiedSinceLastSubmit: false,
                        touched: false,
                        valid: true,
                        validating: false,
                        visited: false
                    });
                }
                api.reset(initialValues);
            });
        },
        resumeValidation: function resumeValidation() {
            validationPaused = false;
            preventNotificationWhileValidationPaused = false;
            if (validationBlocked) // validation was attempted while it was paused, so run it now
            runValidation(undefined, function() {
                notifyFieldListeners();
                notifyFormListeners();
            });
            validationBlocked = false;
        },
        setConfig: function setConfig(name, value1) {
            switch(name){
                case "debug":
                    debug = value1;
                    break;
                case "destroyOnUnregister":
                    destroyOnUnregister = value1;
                    break;
                case "initialValues":
                    api.initialize(value1);
                    break;
                case "keepDirtyOnReinitialize":
                    keepDirtyOnReinitialize = value1;
                    break;
                case "mutators":
                    mutators = value1;
                    if (value1) {
                        Object.keys(mutatorsApi).forEach(function(key) {
                            if (!(key in value1)) delete mutatorsApi[key];
                        });
                        Object.keys(value1).forEach(function(key) {
                            mutatorsApi[key] = getMutatorApi(key);
                        });
                    } else Object.keys(mutatorsApi).forEach(function(key) {
                        delete mutatorsApi[key];
                    });
                    break;
                case "onSubmit":
                    onSubmit = value1;
                    break;
                case "validate":
                    validate = value1;
                    runValidation(undefined, function() {
                        notifyFieldListeners();
                        notifyFormListeners();
                    });
                    break;
                case "validateOnBlur":
                    validateOnBlur = value1;
                    break;
                default:
                    throw new Error("Unrecognised option " + name);
            }
        },
        submit: function submit() {
            var formState = state.formState;
            if (formState.submitting) return;
            delete formState.submitErrors;
            delete formState.submitError;
            formState.lastSubmittedValues = (0, _extendsDefault.default)({}, formState.values);
            if (hasSyncErrors()) {
                markAllFieldsTouched();
                resetModifiedAfterSubmit();
                state.formState.submitFailed = true;
                notifyFormListeners();
                notifyFieldListeners();
                return; // no submit for you!!
            }
            var asyncValidationPromisesKeys = Object.keys(asyncValidationPromises);
            if (asyncValidationPromisesKeys.length) {
                // still waiting on async validation to complete...
                Promise.all(asyncValidationPromisesKeys.map(function(key) {
                    return asyncValidationPromises[Number(key)];
                })).then(api.submit, console.error);
                return;
            }
            var submitIsBlocked = beforeSubmit();
            if (submitIsBlocked) return;
            var resolvePromise;
            var completeCalled = false;
            var complete = function complete(errors) {
                formState.submitting = false;
                var resetWhileSubmitting = formState.resetWhileSubmitting;
                if (resetWhileSubmitting) formState.resetWhileSubmitting = false;
                if (errors && hasAnyError(errors)) {
                    formState.submitFailed = true;
                    formState.submitSucceeded = false;
                    formState.submitErrors = errors;
                    formState.submitError = errors[FORM_ERROR];
                    markAllFieldsTouched();
                } else {
                    if (!resetWhileSubmitting) {
                        formState.submitFailed = false;
                        formState.submitSucceeded = true;
                    }
                    afterSubmit();
                }
                notifyFormListeners();
                notifyFieldListeners();
                completeCalled = true;
                if (resolvePromise) resolvePromise(errors);
                return errors;
            };
            formState.submitting = true;
            formState.submitFailed = false;
            formState.submitSucceeded = false;
            formState.lastSubmittedValues = (0, _extendsDefault.default)({}, formState.values);
            resetModifiedAfterSubmit();
            // onSubmit is either sync, callback or async with a Promise
            var result = onSubmit(formState.values, api, complete);
            if (!completeCalled) {
                if (result && isPromise(result)) {
                    // onSubmit is async with a Promise
                    notifyFormListeners(); // let everyone know we are submitting
                    notifyFieldListeners(); // notify fields also
                    return result.then(complete, function(error) {
                        complete();
                        throw error;
                    });
                } else if (onSubmit.length >= 3) {
                    // must be async, so we should return a Promise
                    notifyFormListeners(); // let everyone know we are submitting
                    notifyFieldListeners(); // notify fields also
                    return new Promise(function(resolve) {
                        resolvePromise = resolve;
                    });
                } else // onSubmit is sync
                complete(result);
            }
        },
        subscribe: function subscribe(subscriber, subscription) {
            if (!subscriber) throw new Error("No callback given.");
            if (!subscription) throw new Error("No subscription provided. What values do you want to listen to?");
            var memoized = memoize(subscriber);
            var subscribers = state.subscribers;
            var index = subscribers.index++;
            subscribers.entries[index] = {
                subscriber: memoized,
                subscription: subscription,
                notified: false
            };
            var nextFormState = calculateNextFormState();
            notifySubscriber(memoized, subscription, nextFormState, nextFormState, filterFormState, true);
            return function() {
                delete subscribers.entries[index];
            };
        }
    };
    return api;
}

},{"@babel/runtime/helpers/esm/extends":"3LZYG","@babel/runtime/helpers/esm/objectWithoutPropertiesLoose":"5JG3D","@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"jAbkv":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "getFormInputs", ()=>getFormInputs);
var _finalForm = require("final-form");
//      
/**
 * Predicate to identify inputs that can have focus() called on them
 */ var isFocusableInput = function isFocusableInput(wtf) {
    return !!(wtf && typeof wtf.focus === 'function');
};
//      
/**
 * Gets all the inputs inside all forms on the page
 */ var getAllInputs = function getAllInputs() {
    if (typeof document === 'undefined') return [];
    return Array.prototype.slice.call(document.forms).reduce(function(accumulator, form) {
        return accumulator.concat(Array.prototype.slice.call(form).filter(isFocusableInput));
    }, []);
};
//      
/**
 * Finds the input by looking if the name attribute path is existing in the errors object
 */ var findInput = function findInput(inputs, errors) {
    return inputs.find(function(input) {
        return input.name && (0, _finalForm.getIn)(errors, input.name);
    });
};
//      
var noop = function noop() {};
var createDecorator = function createDecorator(getInputs, findInput$$1) {
    return function(form) {
        var focusOnFirstError = function focusOnFirstError(errors) {
            if (!getInputs) getInputs = getAllInputs;
            if (!findInput$$1) findInput$$1 = findInput;
            var firstInput = findInput$$1(getInputs(), errors);
            if (firstInput) firstInput.focus();
        }; // Save original submit function
        var originalSubmit = form.submit; // Subscribe to errors, and keep a local copy of them
        var state = {};
        var unsubscribe = form.subscribe(function(nextState) {
            state = nextState;
        }, {
            errors: true,
            submitErrors: true
        }); // What to do after submit
        var afterSubmit = function afterSubmit() {
            var _state = state, errors = _state.errors, submitErrors = _state.submitErrors;
            if (errors && Object.keys(errors).length) focusOnFirstError(errors);
            else if (submitErrors && Object.keys(submitErrors).length) focusOnFirstError(submitErrors);
        }; // Rewrite submit function
        form.submit = function() {
            var result = originalSubmit.call(form);
            if (result && typeof result.then === 'function') // async
            result.then(afterSubmit, noop);
            else // sync
            afterSubmit();
            return result;
        };
        return function() {
            unsubscribe();
            form.submit = originalSubmit;
        };
    };
};
//      
/**
 * Generates a function to get all the inputs in a form with the specified name
 */ var getFormInputs = function getFormInputs(name) {
    return function() {
        if (typeof document === 'undefined') return [];
         // $FlowFixMe
        var form = document.forms[name];
        return form && form.length ? Array.prototype.slice.call(form).filter(isFocusableInput) : []; // cast cheat to get from HTMLFormElement children to FocusableInput
    };
};
//
exports.default = createDecorator;

},{"final-form":"gSo5N","@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"lT2WR":[function(require,module,exports,__globalThis) {
var baseSet = require("a28205848a34d70");
/**
 * Sets the value at `path` of `object`. If a portion of `path` doesn't exist,
 * it's created. Arrays are created for missing index properties while objects
 * are created for all other missing properties. Use `_.setWith` to customize
 * `path` creation.
 *
 * **Note:** This method mutates `object`.
 *
 * @static
 * @memberOf _
 * @since 3.7.0
 * @category Object
 * @param {Object} object The object to modify.
 * @param {Array|string} path The path of the property to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns `object`.
 * @example
 *
 * var object = { 'a': [{ 'b': { 'c': 3 } }] };
 *
 * _.set(object, 'a[0].b.c', 4);
 * console.log(object.a[0].b.c);
 * // => 4
 *
 * _.set(object, ['x', '0', 'y', 'z'], 5);
 * console.log(object.x[0].y.z);
 * // => 5
 */ function set(object, path, value) {
    return object == null ? object : baseSet(object, path, value);
}
module.exports = set;

},{"a28205848a34d70":"117LL"}],"53rSg":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "FormContext", ()=>FormContext);
var _react = require("react");
const FormContext = /*#__PURE__*/ (0, _react.createContext)({
    registerField: function() {
        return ()=>{};
    },
    getCurrentValue: ()=>undefined,
    subscribe: function() {
        return ()=>{};
    }
});

},{"react":"ltHCL","@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"4JBgy":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "IsDisabledContext", ()=>IsDisabledContext);
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
const IsDisabledContext = /*#__PURE__*/ (0, _react.createContext)(false);

},{"react":"ltHCL","@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"6D2qc":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "getFirstErrorField", ()=>getFirstErrorField);
var _finalForm = require("final-form");
const getFirstErrorField = (inputs, errors)=>{
    // Guaranteed to be of type HTMLInputElement[] due to getInputs function overrided in createDecorator
    let htmlInputs = inputs;
    return htmlInputs.find(function(input) {
        // If input is hidden, do not focus
        if (input.type === 'hidden') return false;
        // If input ID matches the error, focus
        if (input.id && (0, _finalForm.getIn)(errors, input.id)) return true;
        // Default to base behavior
        return input.name && (0, _finalForm.getIn)(errors, input.name);
    });
};

},{"final-form":"gSo5N","@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"jbn0F":[function(require,module,exports,__globalThis) {
/* form-header.tsx generated by @compiled/babel-plugin v0.39.1 */ var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _react = require("react");
var _runtime = require("@compiled/react/runtime");
var _heading = require("@atlaskit/heading");
var _headingDefault = parcelHelpers.interopDefault(_heading);
const formHeaderContentStyles = null;
const formHeaderDescriptionStyles = null;
/**
 * __Form header__.
 *
 * A form header contains the form component's heading and subheadings. This provides the correct padding
 * and styling for it.
 *
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/form/docs/layout)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/form/docs/layout)
 * - [Usage](https://atlaskit.atlassian.com/packages/design-system/form/docs/layout).
 */ const FormHeader = ({ children, description, title })=>{
    return /*#__PURE__*/ _react.createElement("div", null, title && /*#__PURE__*/ _react.createElement((0, _headingDefault.default), {
        size: "large"
    }, title), description && /*#__PURE__*/ _react.createElement("div", {
        className: (0, _runtime.ax)([
            "_1pfhu2gc"
        ])
    }, description), children && /*#__PURE__*/ _react.createElement("div", {
        className: (0, _runtime.ax)([
            "_1ul91osq _1pfhu2gc"
        ])
    }, children));
};
exports.default = FormHeader;

},{"react":"ltHCL","@compiled/react/runtime":"d27Vo","@atlaskit/heading":"61ZQz","@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"bQXjr":[function(require,module,exports,__globalThis) {
/* form-footer.tsx generated by @compiled/babel-plugin v0.39.1 */ var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>FormFooter);
var _react = require("react");
var _runtime = require("@compiled/react/runtime");
const formFooterWrapperStyles = null;
const justifyContentStyles = null;
function FormFooter({ align = 'end', children }) {
    return /*#__PURE__*/ _react.createElement("footer", {
        className: (0, _runtime.ax)([
            "_1e0c1txw _1bahesu3 _1pfh1ejb",
            align === 'start' && "_1bah1y6m"
        ])
    }, children);
}

},{"react":"ltHCL","@compiled/react/runtime":"d27Vo","@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"4ox1F":[function(require,module,exports,__globalThis) {
/* form-section.tsx generated by @compiled/babel-plugin v0.39.1 */ var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _react = require("react");
var _runtime = require("@compiled/react/runtime");
var _heading = require("@atlaskit/heading");
var _headingDefault = parcelHelpers.interopDefault(_heading);
const formSectionDescriptionStyles = null;
const formSectionWrapperStyles = null;
const FormSectionWrapper = ({ children })=>{
    return /*#__PURE__*/ _react.createElement("div", {
        className: (0, _runtime.ax)([
            "_1pfh1ejb"
        ])
    }, children);
};
const FormSectionDescription = ({ children })=>{
    return /*#__PURE__*/ _react.createElement("div", {
        className: (0, _runtime.ax)([
            "_1pfhu2gc"
        ])
    }, children);
};
/**
 * __Form section__.
 *
 * A form section is used to define a section of a form layout. This contains a section title, content
 * and a description of the section.
 *
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/form/docs/layout)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/form/docs/layout)
 * - [Usage](https://atlaskit.atlassian.com/packages/design-system/form/docs/layout).
 */ const FormSection = ({ children, description, title })=>{
    return /*#__PURE__*/ _react.createElement(FormSectionWrapper, null, title && /*#__PURE__*/ _react.createElement((0, _headingDefault.default), {
        size: "medium"
    }, title), description && /*#__PURE__*/ _react.createElement(FormSectionDescription, null, description), children);
};
exports.default = FormSection;

},{"react":"ltHCL","@compiled/react/runtime":"d27Vo","@atlaskit/heading":"61ZQz","@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"a8nMl":[function(require,module,exports,__globalThis) {
/* field.tsx generated by @compiled/babel-plugin v0.39.1 */ var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>Field);
var _objectSpread = require("@swc/helpers/_/_object_spread");
var _objectSpreadProps = require("@swc/helpers/_/_object_spread_props");
var _runtime = require("@compiled/react/runtime");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _useId = require("@atlaskit/ds-lib/use-id");
var _errorMessage = require("./error-message");
var _fieldIdContext = require("./field-id-context");
var _formContext = require("./form-context");
var _helperMessage = require("./helper-message");
var _isDisabledContext = require("./is-disabled-context");
var _label = require("./label");
var _messageWrapper = require("./message-wrapper");
var _requiredAsterisk = require("./required-asterisk");
var _requiredAsteriskDefault = parcelHelpers.interopDefault(_requiredAsterisk);
var _validMessage = require("./valid-message");
const fieldWrapperStyles = null;
function isEvent(event) {
    return Boolean(event && event.target);
}
function isFunction(x) {
    return typeof x === 'function';
}
function usePreviousRef(current) {
    const ref = (0, _react.useRef)(current);
    // will be updated on the next render
    (0, _react.useEffect)(()=>{
        ref.current = current;
    });
    // return the existing current (pre render)
    return ref;
}
function isShallowEqual(previousValue, currentValue) {
    if (previousValue === currentValue) return true;
    // not checking functions
    if (typeof previousValue === 'function' && typeof currentValue === 'function') return true;
    if (Array.isArray(previousValue) && Array.isArray(currentValue)) return JSON.stringify(previousValue) === JSON.stringify(currentValue);
    if (typeof previousValue === 'object' && typeof currentValue === 'object') return JSON.stringify(previousValue) === JSON.stringify(currentValue);
    return false;
}
function Field(props) {
    const { children = ()=>null, component } = props;
    const { registerField, getCurrentValue } = (0, _react.useContext)((0, _formContext.FormContext));
    const isDisabled = (0, _react.useContext)((0, _isDisabledContext.IsDisabledContext)) || props.isDisabled || false;
    const defaultValue = isFunction(props.defaultValue) ? props.defaultValue() : props.defaultValue;
    const latestPropsRef = usePreviousRef(props);
    /**
   * HACK: defaultValue can potentially be an array or object which cannot be
   * passed directly into a `useEffect` dependency array, since it will trigger
   * the hook every time.
   */ const isDefaultValueChanged = !isShallowEqual(latestPropsRef.current.defaultValue, props.defaultValue);
    var _getCurrentValue;
    const [state, setState] = (0, _react.useState)({
        fieldProps: {
            onChange: ()=>{},
            onBlur: ()=>{},
            onFocus: ()=>{},
            /* Previously, defaultValue was being set as undefined in Field.defaultProps, which
       * effectively made it an optional prop to external consumers of Field. However the
       * prop types defined defaultValue as required, so inside the component it was not
       * valid for defaultValue to be undefined. We need to suppress the error
       * after changing defaultValue to explicitly be an optional prop.
       * If default value has changed we are using new default value.
       * Otherwise we need to check if we already have value for this field
       * (because we are using changing key prop to re-run field level validation, and that
       * cause the component re-mounting) to not override the actual value with the default value.
       */ // @ts-ignore
            value: isDefaultValueChanged ? defaultValue : (_getCurrentValue = getCurrentValue(props.name)) !== null && _getCurrentValue !== void 0 ? _getCurrentValue : defaultValue
        },
        error: undefined,
        valid: false,
        meta: {
            dirty: false,
            dirtySinceLastSubmit: false,
            touched: false,
            valid: false,
            validating: false,
            submitting: false,
            submitFailed: false,
            error: undefined,
            submitError: undefined
        }
    });
    const latestStateRef = usePreviousRef(state);
    (0, _react.useEffect)(()=>{
        function fieldStateToMeta(value = {}) {
            return {
                dirty: value.dirty || false,
                dirtySinceLastSubmit: value.dirtySinceLastSubmit || false,
                touched: value.touched || false,
                valid: value.valid || false,
                submitting: value.submitting || false,
                submitFailed: value.submitFailed || false,
                error: value.error,
                submitError: value.submitError,
                validating: !!value.validating
            };
        }
        const unregister = registerField(latestPropsRef.current.name, /**
     * Similar as for setting initial state value.
     * Additionally we are checking if the default value is a function,
     * it is used in checkbox fields, where fields with same name and
     * defaultIsChecked should create array of values. In this situation we can't
     * override the default value on re-registering, but also we don't need to change
     * the key prop to re-run validation.
     */ // @ts-ignore
        isDefaultValueChanged || // @ts-ignore
        isFunction(latestPropsRef.current.defaultValue) ? latestPropsRef.current.defaultValue : latestStateRef.current.fieldProps.value, (fieldState)=>{
            /**
       * Do not update dirtySinceLastSubmit until submission has finished.
       */ const modifiedDirtySinceLastSubmit = fieldState.submitting ? latestStateRef.current.meta.dirtySinceLastSubmit : fieldState.dirtySinceLastSubmit;
            /**
       * Do not update submitFailed until submission has finished.
       */ const modifiedSubmitFailed = fieldState.submitting ? latestStateRef.current.meta.submitFailed : fieldState.submitFailed;
            /**
       * Do not use submitError if the value has changed.
       */ const modifiedSubmitError = modifiedDirtySinceLastSubmit && latestPropsRef.current.validate ? undefined : fieldState.submitError;
            const modifiedError = modifiedSubmitError || (fieldState.touched || fieldState.dirty) && fieldState.error;
            /**
       * If there has been a submit error, then use logic in modifiedError to determine validity,
       * so we can determine when there is a submit error which we do not want to display
       * because the value has been changed.
       */ const modifiedValid = modifiedSubmitFailed ? modifiedError === undefined : fieldState.valid;
            function getTransform(eventOrValue, currentValue) {
                if (latestPropsRef.current.transform) return latestPropsRef.current.transform(eventOrValue, currentValue);
                if (isEvent(eventOrValue)) {
                    const { currentTarget } = eventOrValue;
                    if (currentTarget.type === 'checkbox') {
                        if (currentTarget.checked) return currentTarget.value || true;
                        return currentTarget.value ? undefined : false;
                    } else if (currentTarget) return currentTarget.value;
                    return;
                } else return eventOrValue;
            }
            setState({
                fieldProps: {
                    onChange: (e)=>{
                        fieldState.change(getTransform(e, fieldState.value));
                    },
                    onBlur: fieldState.blur,
                    onFocus: fieldState.focus,
                    value: fieldState.value
                },
                error: modifiedError || undefined,
                /**
         * The following parameters are optionally typed in final-form to indicate that not all parameters need
         * to be subscribed to. We cast them as booleans (using || false), since this is what they are semantically.
         */ valid: modifiedValid || false,
                meta: fieldStateToMeta(fieldState)
            });
        }, {
            dirty: true,
            dirtySinceLastSubmit: true,
            touched: true,
            valid: true,
            submitting: true,
            submitFailed: true,
            value: true,
            error: true,
            submitError: true,
            validating: true
        }, {
            getValidator: ()=>function validate(value, formState, fieldState) {
                    const supplied = latestPropsRef.current.validate;
                    if (supplied && fieldState) return supplied(value, formState, fieldStateToMeta(fieldState));
                }
        });
        return unregister;
    }, [
        latestPropsRef,
        latestStateRef,
        registerField,
        props.name,
        props.isRequired,
        isDefaultValueChanged
    ]);
    const uid = (0, _useId.useId)();
    const fieldId = (0, _react.useMemo)(()=>{
        return props.id ? props.id : `${props.name}-${uid}`;
    }, [
        props.id,
        props.name,
        uid
    ]);
    const getDescribedBy = ()=>{
        let value = '';
        if (state.error) value += `${fieldId}-error `;
        if (state.valid) value += `${fieldId}-valid `;
        return `${value}${fieldId}-helper`;
    };
    const extendedFieldProps = (0, _objectSpreadProps._)((0, _objectSpread._)({}, state.fieldProps), {
        name: props.name,
        isDisabled,
        isInvalid: Boolean(state.error),
        isRequired: Boolean(props.isRequired),
        'aria-required': String(Boolean(props.isRequired)),
        'aria-invalid': state.error ? 'true' : 'false',
        'aria-describedby': getDescribedBy(),
        'aria-labelledby': `${fieldId}-label`,
        id: fieldId
    });
    return /*#__PURE__*/ (0, _reactDefault.default).createElement("div", {
        "data-testid": props.testId,
        className: (0, _runtime.ax)([
            "_1pfhu2gc"
        ])
    }, props.label && /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _label.Label), {
        htmlFor: fieldId,
        id: `${fieldId}-label`,
        testId: props.testId && `${props.testId}--label`
    }, props.label, props.isRequired && /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _requiredAsteriskDefault.default), null), props.elementAfterLabel), /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _fieldIdContext.FieldId).Provider, {
        value: fieldId
    }, component ? /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _reactDefault.default).Fragment, null, component({
        fieldProps: extendedFieldProps
    }), /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _messageWrapper.MessageWrapper), null, props.helperMessage && /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _helperMessage.HelperMessage), null, props.helperMessage), state.error && /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _errorMessage.ErrorMessage), null, props.errorMessage || state.error), state.meta.touched && state.valid && props.validMessage && /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _validMessage.ValidMessage), null, props.validMessage))) : children({
        fieldProps: extendedFieldProps,
        error: state.error,
        valid: state.valid,
        meta: state.meta
    })));
}

},{"@swc/helpers/_/_object_spread":"9gdrV","@swc/helpers/_/_object_spread_props":"kANqQ","@compiled/react/runtime":"d27Vo","react":"ltHCL","@atlaskit/ds-lib/use-id":"9jWCD","./error-message":"bmGz5","./field-id-context":"3XYZM","./form-context":"53rSg","./helper-message":"eO3vl","./is-disabled-context":"4JBgy","./label":"38kbd","./message-wrapper":"98niQ","./required-asterisk":"eAd3H","./valid-message":"dN2X3","@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"bmGz5":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "ErrorMessage", ()=>ErrorMessage);
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _fieldIdContext = require("./field-id-context");
var _message = require("./message");
var _messageDefault = parcelHelpers.interopDefault(_message);
const ErrorMessage = ({ children, testId })=>/*#__PURE__*/ (0, _reactDefault.default).createElement((0, _fieldIdContext.FieldId).Consumer, null, (fieldId)=>/*#__PURE__*/ (0, _reactDefault.default).createElement((0, _messageDefault.default), {
            appearance: "error",
            fieldId: fieldId ? `${fieldId}-error` : undefined,
            testId: testId
        }, children));

},{"react":"ltHCL","./field-id-context":"3XYZM","./message":"4J0Oy","@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"3XYZM":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "FieldId", ()=>FieldId);
var _react = require("react");
const FieldId = /*#__PURE__*/ (0, _react.createContext)(undefined);

},{"react":"ltHCL","@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"4J0Oy":[function(require,module,exports,__globalThis) {
/* message.tsx generated by @compiled/babel-plugin v0.39.1 */ var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _react = require("react");
var _runtime = require("@compiled/react/runtime");
var _statusError = require("@atlaskit/icon/core/status-error");
var _statusErrorDefault = parcelHelpers.interopDefault(_statusError);
var _statusSuccess = require("@atlaskit/icon/core/status-success");
var _statusSuccessDefault = parcelHelpers.interopDefault(_statusSuccess);
var _messageContext = require("./message-context");
const messageStyles = null;
const messageAppearanceStyles = {
    default: "_syaz1rpy",
    error: "_syaz1tmw",
    valid: "_syazgsak"
};
const iconWrapperStyles = {
    root: "_1e0c1txw _4t3i7vkz _4cvr1h6o"
};
const IconWrapper = ({ children })=>/*#__PURE__*/ _react.createElement("span", {
        className: (0, _runtime.ax)([
            iconWrapperStyles.root
        ])
    }, children);
const messageIcons = {
    error: /*#__PURE__*/ _react.createElement((0, _statusErrorDefault.default), {
        color: "currentColor",
        label: "error",
        size: "small"
    }),
    valid: /*#__PURE__*/ _react.createElement((0, _statusSuccessDefault.default), {
        color: "currentColor",
        label: "success",
        size: "small"
    })
};
/**
 * __Message__
 *
 * A message component for displaying messages in a form.
 */ const Message = ({ children, appearance = 'default', fieldId, testId })=>{
    const icon = messageIcons[appearance];
    const messageRef = (0, _react.useRef)(null);
    const [hasMessageWrapper, setHasMessageWrapper] = (0, _react.useState)(false);
    const { isWrapper } = (0, _react.useContext)((0, _messageContext.MessageWrapperContext));
    (0, _react.useEffect)(()=>{
        if (messageRef.current) setHasMessageWrapper(isWrapper);
    }, [
        isWrapper
    ]);
    /**
   * The wrapping span is necessary to preserve spaces between children.
   * Otherwise the flex layout of the message will remove any whitespace
   * between children.
   *
   * If the child is just a string, this is not required and we can use one
   * less DOM element.
   */ const content = typeof children === 'string' ? children : /*#__PURE__*/ _react.createElement("span", null, children);
    return /*#__PURE__*/ _react.createElement("div", {
        "data-testid": testId,
        id: fieldId,
        ref: messageRef,
        // For backwards compatability, if there is a wrapper, aria-live is not needed
        "aria-live": !hasMessageWrapper ? 'polite' : undefined,
        className: (0, _runtime.ax)([
            "_zulp12x7 _11c8wadc _1e0c1txw _1bah1q9y _1pfh1b66",
            messageAppearanceStyles[appearance]
        ])
    }, icon && /*#__PURE__*/ _react.createElement(IconWrapper, null, icon), content);
};
exports.default = Message;

},{"react":"ltHCL","@compiled/react/runtime":"d27Vo","@atlaskit/icon/core/status-error":"lTP2w","@atlaskit/icon/core/status-success":"lTMbW","./message-context":"juMje","@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"juMje":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "MessageWrapperContext", ()=>MessageWrapperContext);
var _react = require("react");
const MessageWrapperContext = /*#__PURE__*/ (0, _react.createContext)({
    isWrapper: false
});

},{"react":"ltHCL","@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"eO3vl":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "HelperMessage", ()=>HelperMessage);
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _fieldIdContext = require("./field-id-context");
var _message = require("./message");
var _messageDefault = parcelHelpers.interopDefault(_message);
const HelperMessage = ({ children, testId })=>/*#__PURE__*/ (0, _reactDefault.default).createElement((0, _fieldIdContext.FieldId).Consumer, null, (fieldId)=>/*#__PURE__*/ (0, _reactDefault.default).createElement((0, _messageDefault.default), {
            fieldId: fieldId ? `${fieldId}-helper` : undefined,
            testId: testId
        }, children));

},{"react":"ltHCL","./field-id-context":"3XYZM","./message":"4J0Oy","@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"38kbd":[function(require,module,exports,__globalThis) {
/* label.tsx generated by @compiled/babel-plugin v0.39.1 */ var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "Label", ()=>Label);
var _react = require("react");
var _runtime = require("@compiled/react/runtime");
const fieldsetLabelStyles = null;
const Label = ({ children, htmlFor, id, testId })=>/*#__PURE__*/ _react.createElement("label", {
        id: id,
        htmlFor: htmlFor,
        "data-testid": testId,
        className: (0, _runtime.ax)([
            "_11c8wadc _1e0c1o8l _syazazsu _k48pwu06 _6rth1b66 _1pfhze3t"
        ])
    }, children);

},{"react":"ltHCL","@compiled/react/runtime":"d27Vo","@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"98niQ":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "MessageWrapper", ()=>MessageWrapper);
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _messageContext = require("./message-context");
const MessageWrapper = ({ children })=>{
    const contextValue = {
        isWrapper: true
    };
    return /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _messageContext.MessageWrapperContext).Provider, {
        value: contextValue
    }, /*#__PURE__*/ (0, _reactDefault.default).createElement("div", {
        "aria-live": "polite",
        "data-testid": "message-wrapper"
    }, children));
};

},{"react":"ltHCL","./message-context":"juMje","@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"eAd3H":[function(require,module,exports,__globalThis) {
/* required-asterisk.tsx generated by @compiled/babel-plugin v0.39.1 */ var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>RequiredAsterisk);
var _react = require("react");
var _runtime = require("@compiled/react/runtime");
const requiredIndicatorStyles = null;
function RequiredAsterisk() {
    return /*#__PURE__*/ _react.createElement("span", {
        "aria-hidden": "true",
        title: "required",
        className: (0, _runtime.ax)([
            "_syaz1tmw _ect4ttxp _bozgv77o"
        ])
    }, "*");
}

},{"react":"ltHCL","@compiled/react/runtime":"d27Vo","@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"dN2X3":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "ValidMessage", ()=>ValidMessage);
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _fieldIdContext = require("./field-id-context");
var _message = require("./message");
var _messageDefault = parcelHelpers.interopDefault(_message);
const ValidMessage = ({ children, testId })=>/*#__PURE__*/ (0, _reactDefault.default).createElement((0, _fieldIdContext.FieldId).Consumer, null, (fieldId)=>/*#__PURE__*/ (0, _reactDefault.default).createElement((0, _messageDefault.default), {
            appearance: "valid",
            fieldId: fieldId ? `${fieldId}-valid` : undefined,
            testId: testId
        }, children));

},{"react":"ltHCL","./field-id-context":"3XYZM","./message":"4J0Oy","@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"fC3Io":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _objectSpread = require("@swc/helpers/_/_object_spread");
var _objectSpreadProps = require("@swc/helpers/_/_object_spread_props");
var _objectWithoutProperties = require("@swc/helpers/_/_object_without_properties");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _field = require("./field");
var _fieldDefault = parcelHelpers.interopDefault(_field);
/**
 * __Checkbox field__
 *
 * A checkbox field is a form field that lets users select an item. Users can check or uncheck the checkbox.
 *
 * - [Examples] https://atlaskit.atlassian.com/packages/design-system/form/docs/fields#checkboxfield-reference
 * - [Code] https://atlaskit.atlassian.com/packages/design-system/form/docs/fields#checkboxfield-reference
 * - [Usage] https://atlaskit.atlassian.com/packages/design-system/form/docs/fields#checkboxfield-reference
 */ const CheckboxField = ({ children, defaultIsChecked = false, isDisabled, isRequired, label, name, value })=>{
    // Maintains a memoised list of the default values
    const defaultValue = (0, _react.useCallback)((currentValue = [])=>defaultIsChecked && value !== undefined ? [
            ...currentValue,
            value
        ] : currentValue, [
        value,
        defaultIsChecked
    ]);
    return value !== undefined ? /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _fieldDefault.default), {
        defaultValue: defaultValue,
        isDisabled: isDisabled,
        isRequired: isRequired,
        label: label,
        name: name,
        transform: (event, currentValue)=>!Array.isArray(event) && event.currentTarget.checked && currentValue ? [
                ...currentValue,
                value
            ] : currentValue.filter((v)=>v !== value)
    }, (_param)=>{
        var { fieldProps: { value: fieldValue, onChange } } = _param, otherFieldProps = (0, _objectWithoutProperties._)(_param.fieldProps, [
            "value",
            "onChange"
        ]), others = (0, _objectWithoutProperties._)(_param, [
            "fieldProps"
        ]);
        return children((0, _objectSpread._)({
            fieldProps: (0, _objectSpreadProps._)((0, _objectSpread._)({}, otherFieldProps), {
                // Setting to any because it's typed weirdly at the field level
                onChange: (v)=>onChange(v),
                isChecked: !!fieldValue.find((v)=>v === value),
                value
            })
        }, others));
    }) : /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _fieldDefault.default), {
        defaultValue: defaultIsChecked,
        isDisabled: isDisabled,
        isRequired: isRequired,
        label: label,
        name: name,
        transform: (event)=>typeof event === 'boolean' ? event : event.currentTarget.checked
    }, (_param)=>{
        var { fieldProps: { value: fieldValue, onChange } } = _param, otherFieldProps = (0, _objectWithoutProperties._)(_param.fieldProps, [
            "value",
            "onChange"
        ]), others = (0, _objectWithoutProperties._)(_param, [
            "fieldProps"
        ]);
        return children((0, _objectSpread._)({
            fieldProps: (0, _objectSpreadProps._)((0, _objectSpread._)({}, otherFieldProps), {
                // Setting to any because it's typed weirdly at the field level
                onChange: (v)=>onChange(v),
                isChecked: fieldValue,
                value
            })
        }, others));
    });
};
exports.default = CheckboxField;

},{"@swc/helpers/_/_object_spread":"9gdrV","@swc/helpers/_/_object_spread_props":"kANqQ","@swc/helpers/_/_object_without_properties":"6HqIM","react":"ltHCL","./field":"a8nMl","@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"etI9Q":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _objectSpread = require("@swc/helpers/_/_object_spread");
var _objectWithoutProperties = require("@swc/helpers/_/_object_without_properties");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _field = require("./field");
var _fieldDefault = parcelHelpers.interopDefault(_field);
/**
 * __Range field__
 *
 * A range field is where a user can submit a range input as a part of a form.
 *
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/form/docs/fields#rangefield-reference)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/form/docs/fields#rangefield-reference)
 * - [Usage](https://atlaskit.atlassian.com/packages/design-system/form/docs/fields#rangefield-reference)
 */ const RangeField = ({ children, defaultValue, id, isDisabled, label, name })=>/*#__PURE__*/ (0, _reactDefault.default).createElement((0, _fieldDefault.default), {
        defaultValue: defaultValue,
        id: id,
        isDisabled: isDisabled,
        label: label,
        name: name,
        transform: Number
    }, (_param)=>{
        var { fieldProps: { isInvalid, isRequired } } = _param, fieldProps = (0, _objectWithoutProperties._)(_param.fieldProps, [
            "isInvalid",
            "isRequired"
        ]), rest = (0, _objectWithoutProperties._)(_param, [
            "fieldProps"
        ]);
        return(// isInvalid and isRequired are specifically invalid for range inputs
        children((0, _objectSpread._)({
            fieldProps
        }, rest)));
    });
exports.default = RangeField;

},{"@swc/helpers/_/_object_spread":"9gdrV","@swc/helpers/_/_object_without_properties":"6HqIM","react":"ltHCL","./field":"a8nMl","@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"bVWbz":[function(require,module,exports,__globalThis) {
/* legend.tsx generated by @compiled/babel-plugin v0.39.1 */ var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "Legend", ()=>Legend);
var _react = require("react");
var _runtime = require("@compiled/react/runtime");
const fieldsetLabelStyles = null;
const Legend = ({ children })=>{
    return /*#__PURE__*/ _react.createElement("legend", {
        className: (0, _runtime.ax)([
            "_11c8wadc _1e0c1o8l _syazazsu _k48pwu06 _6rth1b66 _1pfhze3t"
        ])
    }, children);
};

},{"react":"ltHCL","@compiled/react/runtime":"d27Vo","@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"caM6S":[function(require,module,exports,__globalThis) {
/* fieldset.tsx generated by @compiled/babel-plugin v0.39.1 */ var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _react = require("react");
var _runtime = require("@compiled/react/runtime");
var _legend = require("./legend");
const fieldSetStyles = null;
/**
 * __Fieldset__
 *
 * A fieldset groups a number of fields together. For example, when multiple CheckboxFields share the same name,
 * a fieldset can be used to group them together. This makes the form more accessible.
 *
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/form/docs/fields)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/form/docs/fields)
 * - [Usage](https://atlaskit.atlassian.com/packages/design-system/form/docs/fields)
 */ const Fieldset = ({ children, legend })=>{
    return /*#__PURE__*/ _react.createElement("fieldset", {
        className: (0, _runtime.ax)([
            "_1pfhu2gc"
        ])
    }, legend && /*#__PURE__*/ _react.createElement((0, _legend.Legend), null, legend), children);
};
exports.default = Fieldset;

},{"react":"ltHCL","@compiled/react/runtime":"d27Vo","./legend":"bVWbz","@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"iuqqB":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "useFormState", ()=>useFormState);
var _react = require("react");
var _formContext = require("./form-context");
// Constantized to avoid a new object reference built every call
const defaultSubscriptionConfig = {
    values: true
};
/**
 * Build a simple hash for a given subscription object for use in a `useMemo` dependencies array.
 * This is because `{ values: true } !== { values: true }`, but `'values:true|' === 'values:true|'`
 *
 * @example { values: true, dirty: false } => 'values:true|dirty:false|'
 */ const getSubscriptionHash = (subscriptionConfig)=>{
    let hash = '';
    for(const key in subscriptionConfig)if (subscriptionConfig.hasOwnProperty(key)) hash += `${key}:${subscriptionConfig[key]}|`;
    return hash;
};
const useFormState = (subscriptionConfig = defaultSubscriptionConfig)=>{
    const { subscribe } = (0, _react.useContext)((0, _formContext.FormContext));
    const [state, setState] = (0, _react.useState)();
    /**
	 * A hash for us to shallow compare the subscriptionConfig object to react to shallow changes, but avoid referential changes.
	 * We avoid computing the hash if the subscription config has referential equality altogether.
	 */ const subscriptionConfigHash = (0, _react.useMemo)(()=>getSubscriptionHash(subscriptionConfig), [
        subscriptionConfig
    ]);
    /**
	 * Return a memoized version of the subscription config to only react to shallow changes, not referential changes.
	 * Eg. calling `useFormState({ values: true })` twice will result in two different objects by reference, but not by shallow comparison.
	 * This will ensure we don't re-subscribe to the form state when the subscription config is the same.
	 */ const config = (0, _react.useMemo)(()=>subscriptionConfig, // eslint-disable-next-line react-hooks/exhaustive-deps -- intentionally controlled with a hash to have an explicit shallow comparison
    [
        subscriptionConfigHash
    ]);
    (0, _react.useEffect)(()=>{
        const unsubscribe = subscribe((formState)=>{
            setState(formState);
        }, config);
        return ()=>unsubscribe();
    }, [
        subscribe,
        config
    ]);
    return state;
};

},{"react":"ltHCL","./form-context":"53rSg","@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"1XR69":[function(require,module,exports,__globalThis) {
/* character-counter-field.tsx generated by @compiled/babel-plugin v0.39.1 */ var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>CharacterCounterField);
var _objectSpread = require("@swc/helpers/_/_object_spread");
var _objectSpreadProps = require("@swc/helpers/_/_object_spread_props");
var _react = require("react");
var _runtime = require("@compiled/react/runtime");
var _characterCounter = require("./character-counter");
var _characterCounterDefault = parcelHelpers.interopDefault(_characterCounter);
var _errorMessage = require("./error-message");
var _field = require("./field");
var _fieldDefault = parcelHelpers.interopDefault(_field);
var _helperMessage = require("./helper-message");
var _messageWrapper = require("./message-wrapper");
// Override label specific margin block end to fix double spacing issue
const fieldWrapperStyles = {
    root: "_14uxze3t"
};
// Override helper message margins to fix inconsistent spacing issue
const helperMessageWrapperStyles = {
    root: "_6rth1b66 _6ul5ze3t"
};
function CharacterCounterField({ maxCharacters, minCharacters, children, validate: userValidate, overMaximumMessage, underMaximumMessage, underMinimumMessage, helperMessage, defaultValue, id, isRequired, isDisabled, label, elementAfterLabel, name, testId }) {
    // Default validation function for character limits
    // __TOO_SHORT__ and __TOO_LONG__ are default error codes recognised by the CharacterCounter component
    const validateCharacterCount = (value)=>{
        const stringValue = String(value || '');
        const length = stringValue.length;
        // Check minimum length
        if (minCharacters !== undefined && length < minCharacters) return '__TOO_SHORT__';
        // Check maximum length
        if (maxCharacters !== undefined && length > maxCharacters) return '__TOO_LONG__';
        return undefined;
    };
    // Combine user validation and character validation
    // Any user defined validation takes priority over character validation
    // If there is no user defined validation for character limits e.g. used maxLength prior to CharacterCounterField,
    // use the default error codes and display the appropriate error message
    const combinedValidate = (value, formState, fieldState)=>{
        // First run character validation
        const characterError = validateCharacterCount(value);
        // Then run user's custom validation if provided
        const userError = userValidate === null || userValidate === void 0 ? void 0 : userValidate(value, formState, fieldState);
        // If user validation returns a promise, handle it
        if (userError instanceof Promise) return userError.then((error)=>{
            // User error takes priority over character validation
            return error || characterError;
        });
        // User error takes priority over character validation
        return userError || characterError;
    };
    return /*#__PURE__*/ _react.createElement("div", {
        className: (0, _runtime.ax)([
            fieldWrapperStyles.root
        ])
    }, /*#__PURE__*/ _react.createElement((0, _fieldDefault.default), {
        defaultValue: defaultValue,
        id: id,
        isRequired: isRequired,
        isDisabled: isDisabled,
        label: label,
        elementAfterLabel: elementAfterLabel,
        name: name,
        testId: testId,
        validate: combinedValidate
    }, ({ fieldProps: extendedFieldProps, error, valid, meta })=>{
        // Determine if error is a character count violation (handled by CharacterCounter)
        // or an external validation error (needs ErrorMessage)
        const isCharacterCountViolation = error === '__TOO_SHORT__' || error === '__TOO_LONG__';
        const showExternalError = error && !isCharacterCountViolation;
        const showCharacterCounter = (maxCharacters !== undefined || minCharacters !== undefined) && !showExternalError;
        // Extend aria-describedby to reference the appropriate message component
        const fieldPropsWithCounter = (0, _objectSpreadProps._)((0, _objectSpread._)({}, extendedFieldProps), {
            'aria-describedby': showCharacterCounter ? `${extendedFieldProps['aria-describedby']} ${extendedFieldProps.id}-character-counter`.trim() : extendedFieldProps['aria-describedby']
        });
        return /*#__PURE__*/ _react.createElement((0, _react.Fragment), null, /*#__PURE__*/ _react.createElement((0, _messageWrapper.MessageWrapper), null, helperMessage && /*#__PURE__*/ _react.createElement("div", {
            className: (0, _runtime.ax)([
                helperMessageWrapperStyles.root
            ])
        }, /*#__PURE__*/ _react.createElement((0, _helperMessage.HelperMessage), {
            testId: `${testId}-helper`
        }, helperMessage))), children({
            fieldProps: fieldPropsWithCounter,
            error,
            valid,
            meta
        }), /*#__PURE__*/ _react.createElement((0, _messageWrapper.MessageWrapper), null, showExternalError && /*#__PURE__*/ _react.createElement((0, _errorMessage.ErrorMessage), {
            testId: `${testId}-error`
        }, error)), showCharacterCounter && /*#__PURE__*/ _react.createElement((0, _characterCounterDefault.default), {
            maxCharacters: maxCharacters,
            minCharacters: minCharacters,
            currentValue: String(extendedFieldProps.value || ''),
            shouldShowAsError: isCharacterCountViolation,
            overMaximumMessage: overMaximumMessage,
            underMaximumMessage: underMaximumMessage,
            underMinimumMessage: underMinimumMessage,
            testId: `${testId}-character-counter`
        }));
    }));
}

},{"@swc/helpers/_/_object_spread":"9gdrV","@swc/helpers/_/_object_spread_props":"kANqQ","react":"ltHCL","@compiled/react/runtime":"d27Vo","./character-counter":"8afE4","./error-message":"bmGz5","./field":"a8nMl","./helper-message":"eO3vl","./message-wrapper":"98niQ","@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"8afE4":[function(require,module,exports,__globalThis) {
/* character-counter.tsx generated by @compiled/babel-plugin v0.39.1 */ var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _react = require("react");
var _runtime = require("@compiled/react/runtime");
var _statusError = require("@atlaskit/icon/core/status-error");
var _statusErrorDefault = parcelHelpers.interopDefault(_statusError);
var _compiled = require("@atlaskit/primitives/compiled");
var _visuallyHidden = require("@atlaskit/visually-hidden");
var _visuallyHiddenDefault = parcelHelpers.interopDefault(_visuallyHidden);
var _fieldIdContext = require("./field-id-context");
// Extracted styles for character counter message container
const messageContainerStyles = {
    root: "_11c8wadc _syaz1tmw _1pfh1b66"
};
// Extracted styles for error icon wrapper, need to use css to override the default height
const errorIconWrapperStyles = null;
// Error icon with wrapper for character count violations
const ErrorIconWithWrapper = ()=>/*#__PURE__*/ _react.createElement("span", {
        className: (0, _runtime.ax)([
            "_1e0c1txw _4t3i7vkz _4cvr1h6o"
        ])
    }, /*#__PURE__*/ _react.createElement((0, _statusErrorDefault.default), {
        label: "error",
        size: "small"
    }));
// Helper to pluralise "character(s)"
const pluralize = (count)=>`character${count !== 1 ? 's' : ''}`;
/**
 * __Character Counter__
 *
 * A character counter component that displays remaining characters for text input.
 * Displays messages for over or under the maximum or minimum character limits.
 */ const CharacterCounter = ({ maxCharacters, minCharacters, currentValue, overMaximumMessage, underMaximumMessage, underMinimumMessage, shouldShowAsError = true, inputId, testId })=>{
    const [announcementText, setAnnouncementText] = (0, _react.useState)('');
    const debounceTimeoutRef = (0, _react.useRef)(null);
    // Resolve the field ID from context (form use) or inputId prop (standalone use)
    const contextFieldId = (0, _react.useContext)((0, _fieldIdContext.FieldId));
    const resolvedFieldId = contextFieldId || inputId;
    const currentLength = (currentValue === null || currentValue === void 0 ? void 0 : currentValue.length) || 0;
    // Check if character count violates limits
    const isTooShort = minCharacters !== undefined && currentLength < minCharacters;
    const isTooLong = maxCharacters !== undefined && currentLength > maxCharacters;
    // Determine what to display based on the current value, the maximum and minimum character limits, and any custom messages
    const getMessage = ()=>{
        // Below minimum so show custom message or default
        if (isTooShort) {
            const needed = minCharacters - currentLength;
            return underMinimumMessage || `${needed} more ${pluralize(needed)} needed`;
        }
        // Over maximum so show custom message or default
        if (isTooLong) {
            const over = currentLength - maxCharacters;
            return overMaximumMessage || `${over} ${pluralize(over)} too many`;
        }
        // Within limits - show remaining count (if max is defined)
        if (maxCharacters) {
            const remaining = maxCharacters - currentLength;
            return underMaximumMessage || `${remaining} ${pluralize(remaining)} remaining`;
        }
        // No message to show (min only limit satisfied)
        return null;
    };
    const displayText = getMessage();
    // Determine if the current character count violates limits
    const displayAsError = (isTooShort || isTooLong) && shouldShowAsError;
    // Debounce screen reader announcements so that it only reads the message when it input has settled
    (0, _react.useEffect)(()=>{
        // Debounce by 1 second to avoid announcing every keystroke
        debounceTimeoutRef.current = setTimeout(()=>{
            setAnnouncementText(displayText || '');
        }, 1000);
        // Cleanup function clears the timeout when displayText changes or component unmounts
        return ()=>{
            clearTimeout(debounceTimeoutRef.current);
        };
    }, [
        displayText
    ]);
    // Don't render if there's no message to display (min only limit satisfied)
    if (!displayText) return null;
    return /*#__PURE__*/ _react.createElement((0, _compiled.Flex), {
        testId: testId
    }, /*#__PURE__*/ _react.createElement((0, _compiled.Flex), {
        gap: "space.075",
        xcss: messageContainerStyles.root
    }, displayAsError && /*#__PURE__*/ _react.createElement(ErrorIconWithWrapper, null), /*#__PURE__*/ _react.createElement((0, _compiled.Text), {
        color: displayAsError ? 'color.text.danger' : 'color.text.subtlest',
        size: "small",
        id: resolvedFieldId ? `${resolvedFieldId}-character-counter` : undefined
    }, displayText)), /*#__PURE__*/ _react.createElement((0, _visuallyHiddenDefault.default), null, /*#__PURE__*/ _react.createElement("div", {
        "aria-live": "polite"
    }, announcementText)));
};
exports.default = CharacterCounter;

},{"react":"ltHCL","@compiled/react/runtime":"d27Vo","@atlaskit/icon/core/status-error":"lTP2w","@atlaskit/primitives/compiled":"hDay7","@atlaskit/visually-hidden":"gKDx1","./field-id-context":"3XYZM","@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"eJQED":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>(0, _modalDialogDefault.default));
parcelHelpers.export(exports, "ModalTransition", ()=>(0, _modalTransitionDefault.default));
parcelHelpers.export(exports, "ModalHeader", ()=>(0, _modalHeaderDefault.default));
parcelHelpers.export(exports, "ModalTitle", ()=>(0, _modalTitleDefault.default));
parcelHelpers.export(exports, "ModalBody", ()=>(0, _modalBodyDefault.default));
parcelHelpers.export(exports, "ModalFooter", ()=>(0, _modalFooterDefault.default));
parcelHelpers.export(exports, "CloseButton", ()=>(0, _closeButton.CloseButton));
parcelHelpers.export(exports, "useModal", ()=>(0, _hooks.useModal));
var _modalDialog = require("./modal-dialog");
var _modalDialogDefault = parcelHelpers.interopDefault(_modalDialog);
var _modalTransition = require("./modal-transition");
var _modalTransitionDefault = parcelHelpers.interopDefault(_modalTransition);
var _modalHeader = require("./modal-header");
var _modalHeaderDefault = parcelHelpers.interopDefault(_modalHeader);
var _modalTitle = require("./modal-title");
var _modalTitleDefault = parcelHelpers.interopDefault(_modalTitle);
var _modalBody = require("./modal-body");
var _modalBodyDefault = parcelHelpers.interopDefault(_modalBody);
var _modalFooter = require("./modal-footer");
var _modalFooterDefault = parcelHelpers.interopDefault(_modalFooter);
var _closeButton = require("./close-button");
var _hooks = require("./hooks");

},{"./modal-dialog":"bvhe0","./modal-transition":"l7b47","./modal-header":"dyNqj","./modal-title":"eC6uv","./modal-body":"k0iNO","./modal-footer":"f6ee3","./close-button":"hDn5d","./hooks":"eTlVq","@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"bvhe0":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _objectSpread = require("@swc/helpers/_/_object_spread");
var _objectSpreadProps = require("@swc/helpers/_/_object_spread_props");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _modalWrapper = require("./internal/components/modal-wrapper");
var _modalWrapperDefault = parcelHelpers.interopDefault(_modalWrapper);
/**
 * __Modal wrapper__
 *
 * A modal wrapper displays content that requires user interaction, in a layer above the page.
 * This component is primary container for other modal components.
 *
 * - [Examples](https://atlassian.design/components/modal-dialog/examples)
 * - [Code](https://atlassian.design/components/modal-dialog/code)
 * - [Usage](https://atlassian.design/components/modal-dialog/usage)
 */ const ModalWrapper = /*#__PURE__*/ (0, _react.forwardRef)((props, ref)=>{
    // eslint-disable-next-line @repo/internal/react/no-unsafe-spread-props
    return /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _modalWrapperDefault.default), (0, _objectSpreadProps._)((0, _objectSpread._)({}, props), {
        isFullScreen: false,
        ref: ref
    }));
});
ModalWrapper.displayName = 'ModalWrapper';
// eslint-disable-next-line @repo/internal/react/require-jsdoc
exports.default = ModalWrapper;

},{"@swc/helpers/_/_object_spread":"9gdrV","@swc/helpers/_/_object_spread_props":"kANqQ","react":"ltHCL","./internal/components/modal-wrapper":"jeYO6","@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"jeYO6":[function(require,module,exports,__globalThis) {
/* modal-wrapper.tsx generated by @compiled/babel-plugin v0.39.1 */ var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _objectSpread = require("@swc/helpers/_/_object_spread");
var _objectSpreadProps = require("@swc/helpers/_/_object_spread_props");
var _react = require("react");
var _runtime = require("@compiled/react/runtime");
var _reactFocusLock = require("react-focus-lock");
var _reactFocusLockDefault = parcelHelpers.interopDefault(_reactFocusLock);
var _reactScrolllock = require("react-scrolllock");
var _reactScrolllockDefault = parcelHelpers.interopDefault(_reactScrolllock);
var _analyticsNext = require("@atlaskit/analytics-next");
var _blanket = require("@atlaskit/blanket");
var _blanketDefault = parcelHelpers.interopDefault(_blanket);
var _noop = require("@atlaskit/ds-lib/noop");
var _noopDefault = parcelHelpers.interopDefault(_noop);
var _useAutoFocus = require("@atlaskit/ds-lib/use-auto-focus");
var _useAutoFocusDefault = parcelHelpers.interopDefault(_useAutoFocus);
var _useId = require("@atlaskit/ds-lib/use-id");
var _layering = require("@atlaskit/layering");
var _openLayerObserver = require("@atlaskit/layering/experimental/open-layer-observer");
var _motion = require("@atlaskit/motion");
var _exitingPersistence = require("@atlaskit/motion/exiting-persistence");
var _fadeIn = require("@atlaskit/motion/fade-in");
var _fadeInDefault = parcelHelpers.interopDefault(_fadeIn);
var _platformFeatureFlags = require("@atlaskit/platform-feature-flags");
var _portal = require("@atlaskit/portal");
var _portalDefault = parcelHelpers.interopDefault(_portal);
var _combine = require("@atlaskit/pragmatic-drag-and-drop/combine");
var _constants = require("@atlaskit/theme/constants");
var _dialog = require("@atlaskit/top-layer/dialog");
var _dialogScrollLock = require("@atlaskit/top-layer/dialog-scroll-lock");
var _context = require("../context");
var _useModalStack = require("../hooks/use-modal-stack");
var _useModalStackDefault = parcelHelpers.interopDefault(_useModalStack);
var _usePreventProgrammaticScroll = require("../hooks/use-prevent-programmatic-scroll");
var _usePreventProgrammaticScrollDefault = parcelHelpers.interopDefault(_usePreventProgrammaticScroll);
var _element = require("../pragmatic-drag-and-drop/disable-dragging-to-cross-origin-iframes/element");
var _external = require("../pragmatic-drag-and-drop/disable-dragging-to-cross-origin-iframes/external");
var _textSelection = require("../pragmatic-drag-and-drop/disable-dragging-to-cross-origin-iframes/text-selection");
var _dialogHeight = require("./dialog-height");
var _dialogWidth = require("./dialog-width");
var _modalDialog = require("./modal-dialog");
var _modalDialogDefault = parcelHelpers.interopDefault(_modalDialog);
const fillScreenStyles = null; // Visual styles for modal content inside native <dialog>.
// Uses cssMap (not css) to avoid triggering no-nested-styles lint rule.
const LOCAL_CURRENT_SURFACE_CSS_VAR = '--ds-elevation-surface-current';
const topLayerStyles = {
    content: "_1e0c1txw _4t3i1osq _2lx21bp4 _bfhk1bhr _syazi7uo _1q1l1bhr _lcxv1wug _1mq81kw7 _m01u1kw7 _1dg11kw7 _mizu1v1w _1ah3dkaa _ra3xnqa1 _128mdkaa _zg7p130s",
    borderRadius: "_epkxfajl",
    borderRadiusT26: "_epkxpb1k"
}; // Scroll-mode styles for the content div.
// Height overrides use ID-scoped <style> (see dialogPositionStyles) because
// Compiled atomic classes have specificity (0,1,0) (increaseSpecificity is disabled).
// The doubled-ID selector (#id#id > div) at (2,0,1) reliably wins.
// Only non-height properties needing the && boost remain here.
const topLayerBodyScrollStyles = null;
const topLayerViewportScrollStyles = null;
const allowlistElements = (element, callback)=>{
    // Allow focus outside modal when AUI dialog is visible
    // eslint-disable-next-line @atlaskit/platform/no-direct-document-usage -- legacy FocusLock allowlist
    if (Boolean(document.querySelector('.aui-blanket:not([hidden])'))) return false;
     // Optional callback to let consumers exclude elements from focus lock
    if (typeof callback === 'function') return callback(element);
    return true;
};
const InternalModalWrapper = /*#__PURE__*/ (0, _react.forwardRef)((props, ref)=>{
    const { autoFocus, focusLockAllowlist, shouldCloseOnEscapePress = true, shouldCloseOnOverlayClick = true, shouldScrollInViewport = false, shouldReturnFocus = true, stackIndex: stackIndexOverride, onClose: providedOnClose, onStackChange = (0, _noopDefault.default), isBlanketHidden, children, height, width, onCloseComplete, onOpenComplete, label, testId, isFullScreen, UNSAFE_shouldDisableMotionUplift = false } = props;
    const calculatedStackIndex = (0, _useModalStackDefault.default)({
        onStackChange
    });
    const stackIndex = stackIndexOverride || calculatedStackIndex;
    const isForeground = stackIndex === 0; // If no ref is provided, autofocus on first element
    const autoFocusLock = !(typeof autoFocus === 'object');
    const onCloseHandler = (0, _analyticsNext.usePlatformLeafEventHandler)({
        fn: providedOnClose || (0, _noopDefault.default),
        action: 'closed',
        componentName: 'modalDialog',
        packageName: "@af/atlassian-studio",
        packageVersion: "0.16.1"
    });
    const onBlanketClicked = (0, _react.useCallback)((e)=>{
        if (shouldCloseOnOverlayClick) onCloseHandler(e);
    }, [
        shouldCloseOnOverlayClick,
        onCloseHandler
    ]); // Stable callback to avoid re-renders when focusLockAllowlist is not provided.
    const allowListCallback = (0, _react.useCallback)((element)=>allowlistElements(element, focusLockAllowlist), [
        focusLockAllowlist
    ]); // Called outside the feature-flag branch to keep hook order stable.
    // Legacy path: FadeIn calls onFinish. Top-layer path: called directly.
    const { isExiting, onFinish: onExitFinish } = (0, _exitingPersistence.useExitingPersistence)(); // Prevent background scroll (top-layer path uses DialogScrollLock instead).
    // Safe conditional hook: feature flags are resolved once at startup.
    if (!(0, _platformFeatureFlags.fg)('platform-dst-top-layer')) // eslint-disable-next-line react-hooks/rules-of-hooks
    (0, _usePreventProgrammaticScrollDefault.default)();
     // On the top-layer path, the Dialog primitive registers with the observer
    // directly, so we skip registration here to avoid double-counting.
    // Safe conditional hook: feature flags are resolved once at startup.
    if (!(0, _platformFeatureFlags.fg)('platform-dst-top-layer')) // eslint-disable-next-line react-hooks/rules-of-hooks
    (0, _openLayerObserver.useNotifyOpenLayerObserver)({
        type: 'modal',
        // Always open — modal is conditionally rendered when visible.
        isOpen: true,
        // No-op: no current use case for programmatic close via OpenLayerObserver.
        onClose: (0, _noopDefault.default)
    });
     /**
     * Top-layer path (platform-dst-top-layer).
     *
     * Replaces Portal, FocusLock, ScrollLock, Blanket, Positioner, and z-index
     * management with native <dialog> via @atlaskit/top-layer/dialog.
     *
     * Key decisions:
     * - Animation: CSS transitions via @starting-style / allow-discrete.
     * - Close gating: onDialogClose only forwards allowed reasons
     *   (see notes/guides/dialog-close-flow.md).
     * - onClose event param: undefined - consumers should use close reason.
     * - Focus restoration: native <dialog> behavior replaces react-focus-lock's
     *   returnFocus (see accessibility-criteria.md).
     */ 
    if ((0, _platformFeatureFlags.fg)('platform-dst-top-layer')) {
        // Native <dialog> always restores focus on close - no opt-out via shouldReturnFocus.
        const defaultTestId = testId || 'modal-dialog'; // eslint-disable-next-line react-hooks/rules-of-hooks
        const id = (0, _useId.useId)();
        const titleId = `modal-dialog-title-${id}`; // Content container ref - used for onOpenComplete/onCloseComplete callbacks.
        // eslint-disable-next-line react-hooks/rules-of-hooks
        const contentRef = (0, _react.useRef)(null); // Cache last content element for onCloseComplete after children unmount
        // (with reduced motion, contentRef clears before onExitFinish fires).
        // eslint-disable-next-line react-hooks/rules-of-hooks
        const lastContentElRef = (0, _react.useRef)(null);
        if (contentRef.current) lastContentElRef.current = contentRef.current;
         // Native <dialog> ref - needed for ExitingPersistence to call dialog.close().
        // eslint-disable-next-line react-hooks/rules-of-hooks
        const dialogRef = (0, _react.useRef)(null); // eslint-disable-next-line react-hooks/rules-of-hooks
        const modalDialogContext = (0, _react.useMemo)(()=>({
                testId: defaultTestId,
                titleId,
                onClose: onCloseHandler,
                hasProvidedOnClose: Boolean(providedOnClose),
                isFullScreen: isFullScreen !== null && isFullScreen !== void 0 ? isFullScreen : false
            }), [
            defaultTestId,
            titleId,
            onCloseHandler,
            providedOnClose,
            isFullScreen
        ]); // Only forward close when the reason is allowed by props.
        // Passes a synthetic event to satisfy the KeyboardOrMouseEvent contract.
        // eslint-disable-next-line react-hooks/rules-of-hooks
        const onDialogClose = (0, _react.useCallback)(({ reason })=>{
            if (reason === 'escape' && shouldCloseOnEscapePress) onCloseHandler((0, _dialog.createCloseEvent)({
                reason
            }));
            if (reason === 'overlay-click' && shouldCloseOnOverlayClick) onCloseHandler((0, _dialog.createCloseEvent)({
                reason
            }));
        }, [
            onCloseHandler,
            shouldCloseOnEscapePress,
            shouldCloseOnOverlayClick
        ]); // ExitingPersistence: isExiting → isOpen={false} → Dialog exit animation →
        // onExitFinish → onCloseComplete + unmount.
        // eslint-disable-next-line react-hooks/rules-of-hooks
        const handleDialogExitFinish = (0, _react.useCallback)(()=>{
            var _contentRef_current;
            const el = (_contentRef_current = contentRef.current) !== null && _contentRef_current !== void 0 ? _contentRef_current : lastContentElRef.current;
            if (onCloseComplete && el) onCloseComplete(el);
            lastContentElRef.current = null;
            onExitFinish === null || onExitFinish === void 0 ? void 0 : onExitFinish();
        }, [
            onExitFinish,
            onCloseComplete
        ]); // Fire onOpenComplete after mount.
        // eslint-disable-next-line react-hooks/rules-of-hooks
        (0, _react.useEffect)(()=>{
            if (onOpenComplete && contentRef.current) onOpenComplete(contentRef.current, true);
             // eslint-disable-next-line react-hooks/exhaustive-deps
        }, []); // Honor `shouldReturnFocus={ref}` on unmount.
        // Native <dialog>.close() restores focus to the trigger that opened it,
        // but the consumer asked for focus to go to a specific element instead.
        // Run this in an unmount cleanup so it fires after dialog.close()
        // (which fires in the Dialog's effect cleanup).
        // eslint-disable-next-line react-hooks/rules-of-hooks
        const shouldReturnFocusRef = (0, _react.useRef)(shouldReturnFocus);
        shouldReturnFocusRef.current = shouldReturnFocus; // eslint-disable-next-line react-hooks/rules-of-hooks
        (0, _react.useEffect)(()=>{
            return ()=>{
                const target = shouldReturnFocusRef.current;
                if (typeof target === 'object' && target.current) target.current.focus();
            };
        }, []); // Focus a ref-targeted element after mount (when autoFocus is a ref).
        // When true, native <dialog>.showModal() handles focus automatically.
        // eslint-disable-next-line react-hooks/rules-of-hooks
        (0, _useAutoFocusDefault.default)(typeof autoFocus === 'object' ? autoFocus : undefined, typeof autoFocus === 'object'); // Chrome cross-origin iframe DnD workaround (crbug.com/362301053)
        // eslint-disable-next-line react-hooks/rules-of-hooks
        (0, _react.useEffect)(()=>{
            return (0, _combine.combine)((0, _element.disableDraggingToCrossOriginIFramesForElement)(), (0, _textSelection.disableDraggingToCrossOriginIFramesForTextSelection)(), (0, _external.disableDraggingToCrossOriginIFramesForExternal)());
        }, []); // Responsive layout via ID-scoped <style> (same pattern as Dialog's hideBackdrop).
        // ID selector beats Compiled atomic classes without !important and supports @media.
        const namedWidth = (0, _dialogWidth.dialogWidth)(width !== null && width !== void 0 ? width : 'medium');
        const dialogId = `modal-dialog-${id}`;
        const escapedDialogId = CSS.escape(dialogId); // Percentage widths need special handling in the top layer.
        // In legacy, the percentage resolved against the Positioner's max-width
        // (100vw - 120px). In the top layer, the <dialog>'s containing block is the
        // viewport (100vw), so a raw percentage would produce a wider modal.
        // Transform e.g. '42%' → 'calc(42 * (100vw - 120px) / 100)' to match legacy.
        const resolvedWidth = namedWidth.endsWith('%') ? `calc(${parseFloat(namedWidth)} * (100vw - 120px) / 100)` : namedWidth;
        const dialogStyle = isFullScreen ? {
            width: '100vw',
            height: '100vh',
            margin: '0'
        } : {
            width: `min(${resolvedWidth}, 100vw)`
        }; // Shift stacked background modals down by space.100 (8px) per level.
        if (stackIndex > 0) dialogStyle['transform'] = `translateY(calc(${stackIndex}px * ${"var(--ds-space-100, 8px)"}))`;
         // Mobile: viewport fill. Desktop (≥ 30rem): gutter margins, auto height.
        // Content-div height set via #id > div to beat Compiled's atomic specificity.
        const desktopMargin = shouldScrollInViewport ? '60px auto' : '60px auto auto';
        const resolvedHeight = (0, _dialogHeight.dialogHeight)(height); // Body-scroll: specified height or auto. Viewport-scroll: uses min-height.
        const desktopContentHeight = shouldScrollInViewport ? 'auto' : resolvedHeight;
        const desktopContentMinHeight = shouldScrollInViewport ? resolvedHeight : 'auto'; // Viewport-scroll: the legacy Positioner was a fixed 100vh container that
        // scrolled internally, so the modal section could fill (100vh - 60px top gutter).
        // In the top layer the <dialog> sizes to content with height:auto, so we need
        // an explicit min-height to ensure the dialog stretches to the same visible area.
        const desktopDialogMinHeight = shouldScrollInViewport ? 'min-height:calc(100vh - 60px);' : ''; // Doubled-ID selector (#id#id > div) at specificity (2,0,1) beats
        // Compiled atomic classes at (0,1,0) (increaseSpecificity is disabled).
        const dialogPositionStyles = isFullScreen ? '' : // Mobile: edge-to-edge. Desktop (≥ 30rem): 60px gutters, max-width.
        `#${escapedDialogId}#${escapedDialogId}{margin:0;height:100vh}#${escapedDialogId}#${escapedDialogId}>div{height:100%}@media(min-width:30rem){#${escapedDialogId}#${escapedDialogId}{margin:${desktopMargin};height:auto;${desktopDialogMinHeight}max-width:calc(100vw - 120px)}#${escapedDialogId}#${escapedDialogId}>div{height:${desktopContentHeight};min-height:${desktopContentMinHeight}}}`;
        return /*#__PURE__*/ _react.createElement((0, _dialog.Dialog), (0, _objectSpreadProps._)((0, _objectSpread._)({
            ref: dialogRef,
            id: dialogId,
            onClose: onDialogClose,
            onExitFinish: handleDialogExitFinish,
            animate: !isFullScreen,
            isOpen: !isExiting,
            shouldHideBackdrop: stackIndex > 0 || Boolean(isBlanketHidden)
        }, label ? {
            label
        } : {
            labelledBy: titleId
        }), {
            testId: defaultTestId,
            style: dialogStyle
        }), /*#__PURE__*/ _react.createElement((0, _dialogScrollLock.DialogScrollLock), {
            isOpen: true
        }), dialogPositionStyles && // eslint-disable-next-line @atlaskit/ui-styling-standard/no-global-styles
        /*#__PURE__*/ _react.createElement("style", null, dialogPositionStyles), /*#__PURE__*/ _react.createElement("div", {
            ref: contentRef,
            className: (0, _runtime.ax)([
                topLayerStyles.content,
                !isFullScreen && topLayerStyles.borderRadius,
                !isFullScreen && (0, _platformFeatureFlags.fg)('platform-dst-shape-theme-default') && topLayerStyles.borderRadiusT26,
                !isFullScreen && !shouldScrollInViewport && "_bolhzwhf",
                !isFullScreen && shouldScrollInViewport && "_1tke1kxc _c71lglyw"
            ])
        }, /*#__PURE__*/ _react.createElement((0, _context.ModalContext).Provider, {
            value: modalDialogContext
        }, /*#__PURE__*/ _react.createElement((0, _context.ScrollContext).Provider, {
            value: shouldScrollInViewport
        }, children))));
    }
    const modalDialogWithBlanket = /*#__PURE__*/ _react.createElement((0, _blanketDefault.default), {
        isTinted: !isBlanketHidden,
        onBlanketClicked: onBlanketClicked,
        testId: testId && `${testId}--blanket`
    }, /*#__PURE__*/ _react.createElement((0, _modalDialogDefault.default), {
        testId: testId,
        label: label,
        autoFocus: autoFocus,
        stackIndex: stackIndex,
        onClose: onCloseHandler,
        shouldCloseOnEscapePress: shouldCloseOnEscapePress && isForeground,
        shouldScrollInViewport: shouldScrollInViewport,
        height: height,
        width: width,
        onCloseComplete: onCloseComplete,
        onOpenComplete: onOpenComplete,
        hasProvidedOnClose: Boolean(providedOnClose),
        isFullScreen: isFullScreen,
        UNSAFE_shouldDisableMotionUplift: UNSAFE_shouldDisableMotionUplift,
        ref: ref
    }, children));
    let returnFocus = true;
    let onDeactivation = (0, _noopDefault.default);
    if ('boolean' === typeof shouldReturnFocus) returnFocus = shouldReturnFocus;
    else onDeactivation = ()=>{
        window.setTimeout(()=>{
            var _shouldReturnFocus_current;
            (_shouldReturnFocus_current = shouldReturnFocus.current) === null || _shouldReturnFocus_current === void 0 ? void 0 : _shouldReturnFocus_current.focus();
        }, 0);
    };
    return /*#__PURE__*/ _react.createElement((0, _layering.Layering), {
        isDisabled: false
    }, /*#__PURE__*/ _react.createElement((0, _portalDefault.default), {
        zIndex: (0, _constants.layers).modal()
    }, !UNSAFE_shouldDisableMotionUplift && (0, _platformFeatureFlags.fg)('platform-dst-motion-uplift-modal') ? /*#__PURE__*/ _react.createElement((0, _motion.Motion), {
        enteringAnimation: "var(--ds-blanket-enter, 250ms cubic-bezier(0.4, 0, 0, 1) FadeIn0to100)",
        exitingAnimation: "var(--ds-blanket-exit, 200ms cubic-bezier(0.6, 0, 0.8, 0.6) FadeOut100to0)"
    }, /*#__PURE__*/ _react.createElement("div", {
        "aria-hidden": !isForeground,
        className: (0, _runtime.ax)([
            "_1bsbauwl _4t3i1kxc _kqsw1n9t _152tze3t _1e02ze3t _18m91wug _8am5i4x0"
        ])
    }, /*#__PURE__*/ _react.createElement((0, _reactFocusLockDefault.default), {
        autoFocus: autoFocusLock,
        returnFocus: returnFocus,
        onDeactivation: onDeactivation,
        whiteList: allowListCallback
    }, /*#__PURE__*/ _react.createElement((0, _reactScrolllockDefault.default), null), shouldScrollInViewport ? /*#__PURE__*/ _react.createElement((0, _reactScrolllock.TouchScrollable), null, modalDialogWithBlanket) : modalDialogWithBlanket))) : /*#__PURE__*/ _react.createElement((0, _fadeInDefault.default), null, (fadeInProps)=>/*#__PURE__*/ _react.createElement("div", (0, _objectSpreadProps._)((0, _objectSpread._)({}, fadeInProps), {
            className: (0, _runtime.ax)([
                "_1bsbauwl _4t3i1kxc _kqsw1n9t _152tze3t _1e02ze3t _18m91wug _8am5i4x0",
                fadeInProps.className
            ]),
            "aria-hidden": !isForeground
        }), /*#__PURE__*/ _react.createElement((0, _reactFocusLockDefault.default), {
            autoFocus: autoFocusLock,
            returnFocus: returnFocus,
            onDeactivation: onDeactivation,
            whiteList: allowListCallback
        }, /*#__PURE__*/ _react.createElement((0, _reactScrolllockDefault.default), null), shouldScrollInViewport ? /*#__PURE__*/ _react.createElement((0, _reactScrolllock.TouchScrollable), null, modalDialogWithBlanket) : modalDialogWithBlanket)))));
});
// eslint-disable-next-line @repo/internal/react/require-jsdoc
exports.default = InternalModalWrapper;

},{"@swc/helpers/_/_object_spread":"9gdrV","@swc/helpers/_/_object_spread_props":"kANqQ","react":"ltHCL","@compiled/react/runtime":"d27Vo","react-focus-lock":"1FqTV","react-scrolllock":"iBy4G","@atlaskit/analytics-next":"6PLie","@atlaskit/blanket":"i4tgS","@atlaskit/ds-lib/noop":"faKzG","@atlaskit/ds-lib/use-auto-focus":"cDep4","@atlaskit/ds-lib/use-id":"9jWCD","@atlaskit/layering":"8Owg8","@atlaskit/layering/experimental/open-layer-observer":"2Dqp9","@atlaskit/motion":"eg70v","@atlaskit/motion/exiting-persistence":"ldMDz","@atlaskit/motion/fade-in":"5xcOv","@atlaskit/platform-feature-flags":"8rD2i","@atlaskit/portal":"jvgcC","@atlaskit/pragmatic-drag-and-drop/combine":"b8cay","@atlaskit/theme/constants":"gxXsN","@atlaskit/top-layer/dialog":"dafcv","@atlaskit/top-layer/dialog-scroll-lock":"a32OZ","../context":"bBIbK","../hooks/use-modal-stack":"9OYNX","../hooks/use-prevent-programmatic-scroll":"22qTD","../pragmatic-drag-and-drop/disable-dragging-to-cross-origin-iframes/element":"c5Im8","../pragmatic-drag-and-drop/disable-dragging-to-cross-origin-iframes/external":"EPoqu","../pragmatic-drag-and-drop/disable-dragging-to-cross-origin-iframes/text-selection":"h9Beu","./dialog-height":"6L608","./dialog-width":"4zto0","./modal-dialog":"fk5M1","@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"iBy4G":[function(require,module,exports,__globalThis) {
'use strict';
Object.defineProperty(exports, "__esModule", {
    value: true
});
var _ScrollLock = require("c9d108485449cab6");
Object.defineProperty(exports, 'default', {
    enumerable: true,
    get: function get() {
        return _interopRequireDefault(_ScrollLock).default;
    }
});
var _TouchScrollable = require("4f073b15a78b9f38");
Object.defineProperty(exports, 'TouchScrollable', {
    enumerable: true,
    get: function get() {
        return _TouchScrollable.TouchScrollable;
    }
});
function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}

},{"c9d108485449cab6":"2m9Mf","4f073b15a78b9f38":"fBrOL"}],"2m9Mf":[function(require,module,exports,__globalThis) {
'use strict';
Object.defineProperty(exports, "__esModule", {
    value: true
});
var _createClass = function() {
    function defineProperties(target, props) {
        for(var i = 0; i < props.length; i++){
            var descriptor = props[i];
            descriptor.enumerable = descriptor.enumerable || false;
            descriptor.configurable = true;
            if ("value" in descriptor) descriptor.writable = true;
            Object.defineProperty(target, descriptor.key, descriptor);
        }
    }
    return function(Constructor, protoProps, staticProps) {
        if (protoProps) defineProperties(Constructor.prototype, protoProps);
        if (staticProps) defineProperties(Constructor, staticProps);
        return Constructor;
    };
}();
var _react = require("4212636c361ae747");
var _react2 = _interopRequireDefault(_react);
var _exenv = require("25c719b7c60d2573");
var _TouchScrollable = require("d70815e65c0f0aed");
var _withLockSheet = require("d885418bbbe2e405");
var _withLockSheet2 = _interopRequireDefault(_withLockSheet);
var _withTouchListeners = require("7047119e6b70f1f2");
var _withTouchListeners2 = _interopRequireDefault(_withTouchListeners);
var _utils = require("bbe7fdfd1f1d5fac");
function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function _classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
}
function _possibleConstructorReturn(self, call) {
    if (!self) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    return call && (typeof call === "object" || typeof call === "function") ? call : self;
}
function _inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
    subClass.prototype = Object.create(superClass && superClass.prototype, {
        constructor: {
            value: subClass,
            enumerable: false,
            writable: true,
            configurable: true
        }
    });
    if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
}
var ScrollLock = function(_PureComponent) {
    _inherits(ScrollLock, _PureComponent);
    function ScrollLock() {
        _classCallCheck(this, ScrollLock);
        return _possibleConstructorReturn(this, (ScrollLock.__proto__ || Object.getPrototypeOf(ScrollLock)).apply(this, arguments));
    }
    _createClass(ScrollLock, [
        {
            key: 'componentDidMount',
            value: function componentDidMount() {
                if (!_exenv.canUseDOM) return;
                this.initialHeight = window.innerHeight;
            }
        },
        {
            key: 'componentWillUnmount',
            value: function componentWillUnmount() {
                var offset = window.innerHeight - this.initialHeight;
                // adjust scroll if the window has been resized since the lock was engaged
                // e.g. mobile safari dynamic chrome heights
                if (offset) window.scrollTo(0, window.pageYOffset + offset);
                // reset the initial height in case this scroll lock is used again
                this.initialHeight = window.innerHeight;
            }
        },
        {
            key: 'render',
            value: function render() {
                var children = this.props.children;
                return children ? _react2.default.createElement(_TouchScrollable.TouchScrollable, null, children) : null;
            }
        }
    ]);
    return ScrollLock;
}(_react.PureComponent);
// attach the stylesheet and inject styles on [un]mount
var compose = (0, _utils.pipe)(_withTouchListeners2.default, _withLockSheet2.default);
var SheetLock = compose(ScrollLock);
// toggle the lock based on `isActive` prop
var LockToggle = function LockToggle(props) {
    return props.isActive ? _react2.default.createElement(SheetLock, props) : props.children;
};
LockToggle.defaultProps = {
    accountForScrollbars: true,
    children: null,
    isActive: true
};
exports.default = LockToggle;

},{"4212636c361ae747":"ltHCL","25c719b7c60d2573":"9G3Tv","d70815e65c0f0aed":"fBrOL","d885418bbbe2e405":"lf7Dn","7047119e6b70f1f2":"fLXG7","bbe7fdfd1f1d5fac":"2dFFR"}],"9G3Tv":[function(require,module,exports,__globalThis) {
/*!
  Copyright (c) 2015 Jed Watson.
  Based on code that is Copyright 2013-2015, Facebook, Inc.
  All rights reserved.
*/ /* global define */ (function() {
    'use strict';
    var canUseDOM = !!(typeof window !== 'undefined' && window.document && window.document.createElement);
    var ExecutionEnvironment = {
        canUseDOM: canUseDOM,
        canUseWorkers: typeof Worker !== 'undefined',
        canUseEventListeners: canUseDOM && !!(window.addEventListener || window.attachEvent),
        canUseViewport: canUseDOM && !!window.screen
    };
    if (typeof define === 'function' && typeof define.amd === 'object' && define.amd) define(function() {
        return ExecutionEnvironment;
    });
    else if (module.exports) module.exports = ExecutionEnvironment;
    else window.ExecutionEnvironment = ExecutionEnvironment;
})();

},{}],"fBrOL":[function(require,module,exports,__globalThis) {
'use strict';
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.TouchScrollable = undefined;
var _extends = Object.assign || function(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i];
        for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
    }
    return target;
};
var _createClass = function() {
    function defineProperties(target, props) {
        for(var i = 0; i < props.length; i++){
            var descriptor = props[i];
            descriptor.enumerable = descriptor.enumerable || false;
            descriptor.configurable = true;
            if ("value" in descriptor) descriptor.writable = true;
            Object.defineProperty(target, descriptor.key, descriptor);
        }
    }
    return function(Constructor, protoProps, staticProps) {
        if (protoProps) defineProperties(Constructor.prototype, protoProps);
        if (staticProps) defineProperties(Constructor, staticProps);
        return Constructor;
    };
}();
var _react = require("755e63adcd77fb16");
var _exenv = require("9846e6385a7469a3");
var _utils = require("6445da016a994d4d");
function _objectWithoutProperties(obj, keys) {
    var target = {};
    for(var i in obj){
        if (keys.indexOf(i) >= 0) continue;
        if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;
        target[i] = obj[i];
    }
    return target;
}
function _classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
}
function _possibleConstructorReturn(self, call) {
    if (!self) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    return call && (typeof call === "object" || typeof call === "function") ? call : self;
}
function _inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
    subClass.prototype = Object.create(superClass && superClass.prototype, {
        constructor: {
            value: subClass,
            enumerable: false,
            writable: true,
            configurable: true
        }
    });
    if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
}
var TouchScrollable = exports.TouchScrollable = function(_PureComponent) {
    _inherits(TouchScrollable, _PureComponent);
    function TouchScrollable() {
        var _ref;
        var _temp, _this, _ret;
        _classCallCheck(this, TouchScrollable);
        for(var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = TouchScrollable.__proto__ || Object.getPrototypeOf(TouchScrollable)).call.apply(_ref, [
            this
        ].concat(args))), _this), _this.getScrollableArea = function(ref) {
            _this.scrollableArea = ref;
        }, _temp), _possibleConstructorReturn(_this, _ret);
    }
    _createClass(TouchScrollable, [
        {
            key: 'componentDidMount',
            value: function componentDidMount() {
                if (!_exenv.canUseEventListeners) return;
                this.scrollableArea.addEventListener('touchstart', _utils.preventInertiaScroll, _utils.listenerOptions);
                this.scrollableArea.addEventListener('touchmove', _utils.allowTouchMove, _utils.listenerOptions);
            }
        },
        {
            key: 'componentWillUnmount',
            value: function componentWillUnmount() {
                if (!_exenv.canUseEventListeners) return;
                this.scrollableArea.removeEventListener('touchstart', _utils.preventInertiaScroll, _utils.listenerOptions);
                this.scrollableArea.removeEventListener('touchmove', _utils.allowTouchMove, _utils.listenerOptions);
            }
        },
        {
            key: 'render',
            value: function render() {
                var _props = this.props, children = _props.children, rest = _objectWithoutProperties(_props, [
                    'children'
                ]);
                return typeof children === 'function' ? children(this.getScrollableArea) : (0, _react.cloneElement)(children, _extends({
                    ref: this.getScrollableArea
                }, rest));
            }
        }
    ]);
    return TouchScrollable;
}(_react.PureComponent);

},{"755e63adcd77fb16":"ltHCL","9846e6385a7469a3":"9G3Tv","6445da016a994d4d":"2dFFR"}],"2dFFR":[function(require,module,exports,__globalThis) {
'use strict';
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.pipe = exports.listenerOptions = undefined;
exports.preventTouchMove = preventTouchMove;
exports.allowTouchMove = allowTouchMove;
exports.preventInertiaScroll = preventInertiaScroll;
exports.isTouchDevice = isTouchDevice;
exports.camelToKebab = camelToKebab;
exports.parse = parse;
exports.getPadding = getPadding;
exports.getWindowHeight = getWindowHeight;
exports.getDocumentHeight = getDocumentHeight;
exports.makeStyleTag = makeStyleTag;
exports.injectStyles = injectStyles;
exports.insertStyleTag = insertStyleTag;
var _exenv = require("b4cb8ee42bf2dcad");
var listenerOptions = exports.listenerOptions = {
    capture: false,
    passive: false
};
// ==============================
// Touch Helpers
// ==============================
function preventTouchMove(e) {
    e.preventDefault();
    return false;
}
function allowTouchMove(e) {
    var target = e.currentTarget;
    if (target.scrollHeight > target.clientHeight) {
        e.stopPropagation();
        return true;
    }
    e.preventDefault();
    return false;
}
function preventInertiaScroll() {
    var top = this.scrollTop;
    var totalScroll = this.scrollHeight;
    var currentScroll = top + this.offsetHeight;
    if (top === 0) this.scrollTop = 1;
    else if (currentScroll === totalScroll) this.scrollTop = top - 1;
}
// `ontouchstart` check works on most browsers
// `maxTouchPoints` works on IE10/11 and Surface
function isTouchDevice() {
    if (!_exenv.canUseDOM) return false;
    return 'ontouchstart' in window || navigator.maxTouchPoints;
}
// ==============================
// Misc.
// ==============================
function camelToKebab(str) {
    return str.replace(/([a-z])([A-Z])/g, '$1-$2').toLowerCase();
}
function parse(val) {
    return isNaN(val) ? val : val + 'px';
}
// Take a list of functions and return a function that applies the list of
// functions from left to right
var pipeFns = function pipeFns(a, b) {
    return function() {
        return b(a.apply(undefined, arguments));
    };
};
var pipe = exports.pipe = function pipe() {
    for(var _len = arguments.length, fns = Array(_len), _key = 0; _key < _len; _key++)fns[_key] = arguments[_key];
    return fns.reduce(pipeFns);
};
// ==============================
// Document Helpers
// ==============================
function getPadding() {
    if (!_exenv.canUseDOM) return 0;
    var paddingRight = parseInt(window.getComputedStyle(document.body).paddingRight, 10);
    var scrollbarWidth = window.innerWidth - document.documentElement.clientWidth;
    return paddingRight + scrollbarWidth;
}
function getWindowHeight() {
    var multiplier = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 1;
    if (_exenv.canUseDOM) return window.innerHeight * multiplier;
}
function getDocumentHeight() {
    if (_exenv.canUseDOM) return document.body.clientHeight;
}
// ==============================
// Style Sheets
// ==============================
function makeStyleTag() {
    if (!_exenv.canUseDOM) return;
    var tag = document.createElement('style');
    tag.type = 'text/css';
    tag.setAttribute('data-react-scrolllock', '');
    return tag;
}
function injectStyles(tag, css) {
    if (!_exenv.canUseDOM) return;
    if (tag.styleSheet) tag.styleSheet.cssText = css;
    else tag.appendChild(document.createTextNode(css));
}
function insertStyleTag(tag) {
    if (!_exenv.canUseDOM) return;
    var head = document.head || document.getElementsByTagName('head')[0];
    head.appendChild(tag);
}

},{"b4cb8ee42bf2dcad":"9G3Tv"}],"lf7Dn":[function(require,module,exports,__globalThis) {
'use strict';
Object.defineProperty(exports, "__esModule", {
    value: true
});
var _createClass = function() {
    function defineProperties(target, props) {
        for(var i = 0; i < props.length; i++){
            var descriptor = props[i];
            descriptor.enumerable = descriptor.enumerable || false;
            descriptor.configurable = true;
            if ("value" in descriptor) descriptor.writable = true;
            Object.defineProperty(target, descriptor.key, descriptor);
        }
    }
    return function(Constructor, protoProps, staticProps) {
        if (protoProps) defineProperties(Constructor.prototype, protoProps);
        if (staticProps) defineProperties(Constructor, staticProps);
        return Constructor;
    };
}();
exports.default = withLockSheet;
var _react = require("737cf936330fc708");
var _react2 = _interopRequireDefault(_react);
var _utils = require("acba1fa2f92d654f");
function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function _classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
}
function _possibleConstructorReturn(self, call) {
    if (!self) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    return call && (typeof call === "object" || typeof call === "function") ? call : self;
}
function _inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
    subClass.prototype = Object.create(superClass && superClass.prototype, {
        constructor: {
            value: subClass,
            enumerable: false,
            writable: true,
            configurable: true
        }
    });
    if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
}
function withLockSheet(WrappedComponent) {
    return function(_PureComponent) {
        _inherits(SheetProvider, _PureComponent);
        function SheetProvider() {
            var _ref;
            var _temp, _this, _ret;
            _classCallCheck(this, SheetProvider);
            for(var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
            return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = SheetProvider.__proto__ || Object.getPrototypeOf(SheetProvider)).call.apply(_ref, [
                this
            ].concat(args))), _this), _this.addSheet = function() {
                var styles = _this.getStyles();
                var sheet = (0, _utils.makeStyleTag)();
                if (!sheet) return;
                (0, _utils.injectStyles)(sheet, styles);
                (0, _utils.insertStyleTag)(sheet);
                _this.sheet = sheet;
            }, _this.getStyles = function() {
                var accountForScrollbars = _this.props.accountForScrollbars;
                var height = (0, _utils.getDocumentHeight)();
                var paddingRight = accountForScrollbars ? (0, _utils.getPadding)() : null;
                var styles = 'body {\n        box-sizing: border-box !important;\n        overflow: hidden !important;\n        position: relative !important;\n        ' + (height ? 'height: ' + height + 'px !important;' : '') + '\n        ' + (paddingRight ? 'padding-right: ' + paddingRight + 'px !important;' : '') + '\n      }';
                return styles;
            }, _temp), _possibleConstructorReturn(_this, _ret);
        }
        _createClass(SheetProvider, [
            {
                key: 'componentDidMount',
                value: function componentDidMount() {
                    this.addSheet();
                }
            },
            {
                key: 'removeSheet',
                value: function removeSheet() {
                    if (!this.sheet || !this.sheet.parentNode || typeof this.sheet.parentNode.removeChild !== 'function') return;
                    // $FlowFixMe
                    this.sheet.parentNode.removeChild(this.sheet);
                    this.sheet = null;
                }
            },
            {
                key: 'componentWillUnmount',
                value: function componentWillUnmount() {
                    this.removeSheet();
                }
            },
            {
                key: 'render',
                value: function render() {
                    return _react2.default.createElement(WrappedComponent, this.props);
                }
            }
        ]);
        return SheetProvider;
    }(_react.PureComponent);
}

},{"737cf936330fc708":"ltHCL","acba1fa2f92d654f":"2dFFR"}],"fLXG7":[function(require,module,exports,__globalThis) {
'use strict';
Object.defineProperty(exports, "__esModule", {
    value: true
});
var _createClass = function() {
    function defineProperties(target, props) {
        for(var i = 0; i < props.length; i++){
            var descriptor = props[i];
            descriptor.enumerable = descriptor.enumerable || false;
            descriptor.configurable = true;
            if ("value" in descriptor) descriptor.writable = true;
            Object.defineProperty(target, descriptor.key, descriptor);
        }
    }
    return function(Constructor, protoProps, staticProps) {
        if (protoProps) defineProperties(Constructor.prototype, protoProps);
        if (staticProps) defineProperties(Constructor, staticProps);
        return Constructor;
    };
}();
exports.default = withTouchListeners;
var _react = require("aa6594585f6f1c7");
var _react2 = _interopRequireDefault(_react);
var _exenv = require("ea84623b51c95046");
var _utils = require("5a42eda247af6766");
function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function _classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
}
function _possibleConstructorReturn(self, call) {
    if (!self) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    return call && (typeof call === "object" || typeof call === "function") ? call : self;
}
function _inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
    subClass.prototype = Object.create(superClass && superClass.prototype, {
        constructor: {
            value: subClass,
            enumerable: false,
            writable: true,
            configurable: true
        }
    });
    if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
}
// Mobile Safari ignores { overflow: hidden } declaration on the body,
// so we have to prevent touchmove events via JS
function withTouchListeners(WrappedComponent) {
    return function(_PureComponent) {
        _inherits(TouchProvider, _PureComponent);
        function TouchProvider() {
            _classCallCheck(this, TouchProvider);
            return _possibleConstructorReturn(this, (TouchProvider.__proto__ || Object.getPrototypeOf(TouchProvider)).apply(this, arguments));
        }
        _createClass(TouchProvider, [
            {
                key: 'componentDidMount',
                value: function componentDidMount() {
                    if (!_exenv.canUseDOM || !(0, _utils.isTouchDevice)()) return;
                    document.addEventListener('touchmove', _utils.preventTouchMove, _utils.listenerOptions);
                }
            },
            {
                key: 'componentWillUnmount',
                value: function componentWillUnmount() {
                    if (!_exenv.canUseDOM || !(0, _utils.isTouchDevice)()) return;
                    document.removeEventListener('touchmove', _utils.preventTouchMove, _utils.listenerOptions);
                }
            },
            {
                key: 'render',
                value: function render() {
                    return _react2.default.createElement(WrappedComponent, this.props);
                }
            }
        ]);
        return TouchProvider;
    }(_react.PureComponent);
}

},{"aa6594585f6f1c7":"ltHCL","ea84623b51c95046":"9G3Tv","5a42eda247af6766":"2dFFR"}],"i4tgS":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>(0, _blanketDefault.default));
var _blanket = require("./blanket");
var _blanketDefault = parcelHelpers.interopDefault(_blanket);

},{"./blanket":"gfd3m","@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"gfd3m":[function(require,module,exports,__globalThis) {
/* blanket.tsx generated by @compiled/babel-plugin v0.39.1 */ var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _objectSpread = require("@swc/helpers/_/_object_spread");
var _react = require("react");
var _runtime = require("@compiled/react/runtime");
var _usePlatformLeafEventHandler = require("@atlaskit/analytics-next/usePlatformLeafEventHandler");
var _noop = require("@atlaskit/ds-lib/noop");
var _noopDefault = parcelHelpers.interopDefault(_noop);
const packageName = "@af/atlassian-studio";
const packageVersion = "0.16.1";
const analyticsAttributes = {
    componentName: 'blanket',
    packageName,
    packageVersion
};
const baseStyles = null;
const shouldAllowClickThroughStyles = null;
const invisibleStyles = null;
/**
 * __Blanket__
 *
 * A Blanket provides the overlay layer for components such as a modal dialog or a tooltip
 *
 * - [Examples](https://atlaskit.atlassian.com/examples/design-system/blanket/basic-usage)
 */ const Blanket = /*#__PURE__*/ (0, _react.memo)(/*#__PURE__*/ (0, _react.forwardRef)(function Blanket({ shouldAllowClickThrough = false, isTinted = false, onBlanketClicked = (0, _noopDefault.default), testId, children, analyticsContext }, ref) {
    const mouseDownTarget = (0, _react.useRef)(null);
    const onBlanketClickedWithAnalytics = (0, _usePlatformLeafEventHandler.usePlatformLeafEventHandler)((0, _objectSpread._)({
        fn: onBlanketClicked,
        action: 'clicked',
        analyticsData: analyticsContext
    }, analyticsAttributes));
    const blanketClickOutsideChildren = (0, _react.useCallback)((e)=>e.currentTarget === e.target && mouseDownTarget.current === e.target ? onBlanketClickedWithAnalytics(e) : undefined, [
        onBlanketClickedWithAnalytics
    ]);
    const onClick = shouldAllowClickThrough ? undefined : blanketClickOutsideChildren;
    const onMouseDown = (0, _react.useCallback)((e)=>{
        mouseDownTarget.current = e.target;
    }, []);
    return /*#__PURE__*/ _react.createElement("div", {
        role: "presentation",
        onClick: onClick,
        onMouseDown: onMouseDown,
        "data-testid": testId,
        ref: ref,
        className: (0, _runtime.ax)([
            "_1r04idpf _kqsw1n9t _1pbybfng _bfhk1i5c _18m91wug _lcxv1wug",
            shouldAllowClickThrough && "_lcxvglyw",
            !isTinted && "_bfhk1j28"
        ])
    }, children);
}));
Blanket.displayName = 'Blanket';
exports.default = Blanket;

},{"@swc/helpers/_/_object_spread":"9gdrV","react":"ltHCL","@compiled/react/runtime":"d27Vo","@atlaskit/analytics-next/usePlatformLeafEventHandler":"dRWFk","@atlaskit/ds-lib/noop":"faKzG","@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"8Owg8":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "Layering", ()=>(0, _layering.Layering));
parcelHelpers.export(exports, "useCloseOnEscapePress", ()=>(0, _useCloseOnEscapePress.useCloseOnEscapePress));
parcelHelpers.export(exports, "useLayering", ()=>(0, _useLayering.useLayering));
var _layering = require("./components/layering");
var _useCloseOnEscapePress = require("./hooks/use-close-on-escape-press");
var _useLayering = require("./hooks/use-layering");

},{"./components/layering":"6HScL","./hooks/use-close-on-escape-press":"h3eg4","./hooks/use-layering":"1agky","@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"6HScL":[function(require,module,exports,__globalThis) {
/* eslint-disable @repo/internal/react/require-jsdoc */ var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "Layering", ()=>Layering);
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _layerNode = require("../classes/layer-node");
var _levelContext = require("./level-context");
var _levelNodeContext = require("./level-node-context");
var _rootNodeContext = require("./root-node-context");
const LevelProvider = ({ children, currentLevel, node: levelNode })=>{
    (0, _react.useEffect)(()=>{
        const levelNodeSafe = levelNode.current;
        const parentNode = levelNodeSafe.parent;
        parentNode === null || parentNode === void 0 ? void 0 : parentNode.addChild(levelNodeSafe);
        return ()=>{
            parentNode === null || parentNode === void 0 ? void 0 : parentNode.removeChild(levelNodeSafe);
        };
    }, [
        levelNode
    ]);
    return /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _levelContext.LevelContext).Provider, {
        value: currentLevel
    }, /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _levelNodeContext.LevelNodeContext).Provider, {
        value: levelNode
    }, children));
};
const Layering = ({ children, isDisabled = true })=>{
    const currentLevel = (0, _react.useContext)((0, _levelContext.LevelContext));
    const parentNode = (0, _react.useContext)((0, _levelNodeContext.LevelNodeContext));
    // eslint-disable-next-line  @repo/internal/react/disallow-unstable-values
    const newNode = (0, _react.useRef)(new (0, _layerNode.LayerNode)(Math.random().toString(36), parentNode.current));
    if (isDisabled) return /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _reactDefault.default).Fragment, null, children);
    const isNested = currentLevel > 0;
    const content = /*#__PURE__*/ (0, _reactDefault.default).createElement(LevelProvider, {
        currentLevel: currentLevel + 1,
        node: newNode
    }, children);
    return isNested ? content : /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _rootNodeContext.RootNodeContext).Provider, {
        value: newNode
    }, content);
};

},{"react":"ltHCL","../classes/layer-node":"7Agzv","./level-context":"B6IvZ","./level-node-context":"5AHjB","./root-node-context":"iilYP","@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"7Agzv":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "LayerNode", ()=>LayerNode);
class LayerNode {
    addChild(node) {
        this.childNodes.push(node);
    }
    removeChild(node) {
        this.childNodes = this.childNodes.filter((child)=>child.id !== node.id);
    }
    getLevel() {
        if (!this.parent) return 1;
        return this.parent.getLevel() + 1;
    }
    getHeight() {
        if (this.childNodes.length === 0) return 1;
        return Math.max(...this.childNodes.map((child)=>child.getHeight())) + 1;
    }
    constructor(id, parent){
        this.id = id;
        this.childNodes = [];
        this.parent = parent;
    }
}

},{"@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"B6IvZ":[function(require,module,exports,__globalThis) {
/* eslint-disable @repo/internal/react/require-jsdoc */ var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "LevelContext", ()=>LevelContext);
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
const LevelContext = /*#__PURE__*/ (0, _react.createContext)(0);

},{"react":"ltHCL","@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"5AHjB":[function(require,module,exports,__globalThis) {
/* eslint-disable @repo/internal/react/require-jsdoc */ var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "LevelNodeContext", ()=>LevelNodeContext);
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
const LevelNodeContext = /*#__PURE__*/ (0, _react.createContext)({
    current: null
});

},{"react":"ltHCL","@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"iilYP":[function(require,module,exports,__globalThis) {
/* eslint-disable @repo/internal/react/require-jsdoc */ var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "RootNodeContext", ()=>RootNodeContext);
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
const RootNodeContext = /*#__PURE__*/ (0, _react.createContext)({
    current: null
});

},{"react":"ltHCL","@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"h3eg4":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
/**
 * Calls back when the escape key is pressed.
 * To be used exclusively for closing layered components.
 * Use the `isDisabled` argument to ignore closing events.
 *
 * ```js
 * useCloseOnEscapePress({
 *   onClose: () => {},
 *   isDisabled: false,
 * });
 * ```
 */ parcelHelpers.export(exports, "useCloseOnEscapePress", ()=>useCloseOnEscapePress);
var _react = require("react");
var _bindEventListener = require("bind-event-listener");
var _useLayering = require("./use-layering");
const ESCAPE = 'Escape';
function useCloseOnEscapePress({ onClose, isDisabled }) {
    const escapePressed = (0, _react.useRef)(false);
    const { isLayerDisabled } = (0, _useLayering.useLayering)();
    const onKeyDown = (0, _react.useCallback)((e)=>{
        const isDisabledLayer = isLayerDisabled();
        if (isDisabled || escapePressed.current || e.key !== ESCAPE || isDisabledLayer) // We're either already handling the key down event or it's not escape or disabled.
        // Bail early!
        return;
        escapePressed.current = true;
        onClose(e);
    }, [
        onClose,
        isDisabled,
        isLayerDisabled
    ]);
    const onKeyUp = (0, _react.useCallback)(()=>{
        escapePressed.current = false;
    }, []);
    (0, _react.useEffect)(()=>{
        return (0, _bindEventListener.bindAll)(window, [
            {
                type: 'keydown',
                listener: onKeyDown
            },
            {
                type: 'keyup',
                listener: onKeyUp
            }
        ], {
            capture: false
        });
    }, [
        onKeyDown,
        onKeyUp
    ]);
}

},{"react":"ltHCL","bind-event-listener":"bjeUU","./use-layering":"1agky","@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"1agky":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
/**
 *
 * Layering hook to get layering info like the current level, the top level of the given component
 *
 */ parcelHelpers.export(exports, "useLayering", ()=>useLayering);
var _react = require("react");
var _levelContext = require("../components/level-context");
var _levelNodeContext = require("../components/level-node-context");
var _rootNodeContext = require("../components/root-node-context");
function useLayering() {
    const currentLevel = (0, _react.useContext)((0, _levelContext.LevelContext));
    const layerNode = (0, _react.useContext)((0, _levelNodeContext.LevelNodeContext));
    const rootNode = (0, _react.useContext)((0, _rootNodeContext.RootNodeContext));
    const isLayerDisabled = (0, _react.useCallback)(()=>{
        // This is an impossible case, added for type safety
        if (!(layerNode === null || layerNode === void 0 ? void 0 : layerNode.current) || !(rootNode === null || rootNode === void 0 ? void 0 : rootNode.current)) return false;
        return layerNode.current.getLevel() < rootNode.current.getHeight();
    }, [
        layerNode,
        rootNode
    ]);
    const getTopLevel = (0, _react.useCallback)(()=>(rootNode === null || rootNode === void 0 ? void 0 : rootNode.current) ? rootNode.current.getHeight() : null, [
        rootNode
    ]);
    return {
        currentLevel,
        isLayerDisabled,
        getTopLevel
    };
}

},{"react":"ltHCL","../components/level-context":"B6IvZ","../components/level-node-context":"5AHjB","../components/root-node-context":"iilYP","@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"ldMDz":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "useExitingPersistence", ()=>(0, _exitingPersistence.useExitingPersistence));
parcelHelpers.export(exports, "default", ()=>(0, _exitingPersistenceDefault.default));
var _exitingPersistence = require("../entering/exiting-persistence");
var _exitingPersistenceDefault = parcelHelpers.interopDefault(_exitingPersistence);

},{"../entering/exiting-persistence":"9OFRq","@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"5xcOv":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>(0, _fadeInDefault.default));
var _fadeIn = require("../entering/fade-in");
var _fadeInDefault = parcelHelpers.interopDefault(_fadeIn);

},{"../entering/fade-in":"bW9cF","@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"b8cay":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "combine", ()=>(0, _combine.combine));
var _combine = require("../public-utils/combine");

},{"../public-utils/combine":"crrjo","@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"crrjo":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
/** Create a new combined function that will call all the provided functions */ parcelHelpers.export(exports, "combine", ()=>combine);
function combine(...fns) {
    return function cleanup() {
        fns.forEach((fn)=>fn());
    };
}

},{"@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"dafcv":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "createCloseEvent", ()=>(0, _dialog.createCloseEvent));
parcelHelpers.export(exports, "Dialog", ()=>(0, _dialog.Dialog));
var _dialog = require("../dialog");

},{"../dialog":"ka6lc","@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"ka6lc":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "createCloseEvent", ()=>(0, _createCloseEvent.createCloseEvent));
parcelHelpers.export(exports, "Dialog", ()=>(0, _dialogContent.Dialog));
var _createCloseEvent = require("./create-close-event");
var _dialogContent = require("./dialog-content");

},{"./create-close-event":"2YCBE","./dialog-content":"9OwX9","@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"2YCBE":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
/**
 * Creates a synthetic DOM event from a `TDialogCloseReason`.
 *
 * Useful when bridging the Dialog primitive's `onClose({ reason })` callback
 * to a legacy API that expects a `KeyboardEvent` or `MouseEvent` - for example,
 * `@atlaskit/modal-dialog`'s `onClose(event, analyticsEvent)` contract.
 *
 * - `'escape'` → `KeyboardEvent('keydown', { key: 'Escape' })`
 * - `'overlay-click'` → `MouseEvent('click')`
 *
 * @example
 * ```tsx
 * import { createCloseEvent, type TDialogCloseReason } from '@atlaskit/top-layer/dialog';
 *
 * function onDialogClose({ reason }: { reason: TDialogCloseReason }) {
 *   legacyOnClose(createCloseEvent({ reason }));
 * }
 * ```
 */ parcelHelpers.export(exports, "createCloseEvent", ()=>createCloseEvent);
function createCloseEvent({ reason }) {
    if (reason === 'escape') return new KeyboardEvent('keydown', {
        key: 'Escape',
        bubbles: true
    });
    return new MouseEvent('click', {
        bubbles: true,
        cancelable: true
    });
}

},{"@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"9OwX9":[function(require,module,exports,__globalThis) {
/* dialog-content.tsx generated by @compiled/babel-plugin v0.39.1 */ var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "Dialog", ()=>Dialog);
var _jsxRuntime = require("react/jsx-runtime");
var _runtime = require("@compiled/react/runtime");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _bindEventListener = require("bind-event-listener");
var _mergeRefs = require("@atlaskit/ds-lib/merge-refs");
var _mergeRefsDefault = parcelHelpers.interopDefault(_mergeRefs);
var _noop = require("@atlaskit/ds-lib/noop");
var _noopDefault = parcelHelpers.interopDefault(_noop);
var _openLayerObserver = require("@atlaskit/layering/experimental/open-layer-observer");
var _useAnimatedVisibility = require("../internal/use-animated-visibility");
var _useFocusWrap = require("../internal/use-focus-wrap");
var _useSafariEscapeFix = require("../internal/use-safari-escape-fix");
// These animation styles use the non-strict Compiled cssMap because they rely
// on `@starting-style`, `[open]`, and `allow-discrete`. Keep them in this
// component so the Compiled transform can statically extract every referenced
// style.
const dialogAnimationStyles = {
    root: "_k8m011k7 _1oeci9qs _1s9z1a5r _1fsl1mzy _1oil1d08",
    motion: "_y44vgeqi _1o51q7pw _1iu47kvq _1i0neoah"
};
const styles = {
    dialog: "_19itglyw _19pk1wug _2hwx1wug _otyr1wug _18u01wug _1q51ze3t _y4tize3t _85i5ze3t _bozgze3t _p12fglyw _c71lglyw _bfhk1j28 _bl8aglyw _156y147i _10aiglyw _aeld147i"
};
const backdropStyles = {
    root: "_1ltk1i5c",
    hidden: "_1ltk1j28",
    motion: "_1m5e1op4 _1jhdq7pw _njwk11k7 _yhpqi9qs _1fyf1a5r _vhgsxbuz _1rsueoah _l57nglyw _1sbq147i _19awglyw _1i6z147i"
};
const Dialog = /*#__PURE__*/ (0, _react.forwardRef)(function Dialog({ children, isOpen, onClose, onEnterFinish, onExitFinish, animate = false, xcss: consumerXcss, style, testId, id: providedId, label, labelledBy, shouldHideBackdrop }, ref) {
    const generatedId = (0, _react.useId)();
    const dialogId = providedId !== null && providedId !== void 0 ? providedId : generatedId;
    const ownRef = (0, _react.useRef)(null);
    const combinedRef = (0, _mergeRefsDefault.default)([
        ownRef,
        ref
    ]);
    const { phase, preset } = (0, _useAnimatedVisibility.useAnimatedVisibility)({
        isOpen,
        animationKind: 'dialog',
        animate,
        elementRef: ownRef,
        onEnterFinish,
        onExitFinish
    });
    // True while the host element is mounted (any phase except `closed`).
    // Used as a dep so listener-rebind effects re-attach after a remount.
    const isVisible = phase !== 'closed';
    // Native `<dialog>.showModal()` traps focus but wraps through `<body>` at
    // the boundary (A → B → C → body → A). This hook intercepts Tab to wrap
    // directly (A → B → C → A), matching the WAI-ARIA APG pattern. Passing
    // `phase` keeps the listener attached through the animated-exit window
    // (WCAG 2.4.3 Focus Order regression guard).
    (0, _useFocusWrap.useFocusWrap)({
        elementRef: ownRef,
        role: 'dialog',
        phase
    });
    // Notify the open layer observer so app-coordination features
    // (open-count subscriptions) work with top-layer dialogs.
    (0, _openLayerObserver.useNotifyOpenLayerObserver)({
        type: 'modal',
        isOpen,
        // No-op: no current use case for programmatic close via OpenLayerObserver.
        onClose: (0, _noopDefault.default)
    });
    (0, _react.useLayoutEffect)(()=>{
        const dialog = ownRef.current;
        if (!dialog) return;
        if (isOpen) {
            if (!dialog.open) dialog.showModal();
            return ()=>{
                if (dialog.open) dialog.close();
            };
        }
        if (dialog.open) dialog.close();
    }, [
        isOpen
    ]);
    // Safari bug: escape closes open dialog and popovers, rather than just innermost popover
    // See notes/decisions/safari-escape-nested-popover-in-dialog.md
    const { shouldIgnoreEscape } = (0, _useSafariEscapeFix.useSafariEscapeFix)({
        dialogRef: ownRef,
        isVisible
    });
    // Handle native Escape (cancel event)
    const handleCancel = (0, _react.useCallback)((event)=>{
        // Only handle a cancel targeting THIS dialog. Native `cancel` does not
        // bubble, but React's synthetic event bubbles up the component tree, so
        // for nested dialogs (one rendered inside another's DOM subtree) the
        // inner dialog's Escape would otherwise also fire an ancestor dialog's
        // handler and close it too. Mirrors the backdrop-click target guard below.
        if (event.target !== event.currentTarget) return;
        event.preventDefault();
        // Spurious Safari `cancel`: the keydown snapshot saw an open child
        // popover, so this Escape belongs to that popover (light-dismissed
        // natively). Keep the dialog open instead of forwarding to `onClose`.
        if (shouldIgnoreEscape()) return;
        onClose({
            reason: 'escape'
        });
    }, [
        onClose,
        shouldIgnoreEscape
    ]);
    // Handle backdrop click
    // Attached via bind-event-listener rather than a React prop so we avoid
    // a11y lint suppressions on the <dialog> element.
    // Keyboard dismiss is already handled natively (Escape → onCancel above).
    // `isVisible` is in deps so the listener re-binds to the new <dialog>
    // element after a host unmount / remount cycle.
    (0, _react.useEffect)(()=>{
        const dialog = ownRef.current;
        if (!dialog) return;
        return (0, _bindEventListener.bind)(dialog, {
            type: 'click',
            listener (event) {
                if (event.target === event.currentTarget) onClose({
                    reason: 'overlay-click'
                });
            }
        });
    }, [
        onClose,
        isVisible
    ]);
    // Unmount the `<dialog>` once exit completes so it does not leave an
    // empty `role="dialog"` element in the accessibility tree. On the next
    // open the element remounts and the `[isOpen]` and `[onClose, isVisible]`
    // effects re-run against the fresh element.
    if (!isVisible) return null;
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)("dialog", {
        ref: combinedRef,
        id: dialogId,
        // `aria-modal` is intentionally NOT set: native `<dialog>.showModal()`
        // already conveys modal semantics to assistive tech, and double-
        // declaring it forecloses non-modal use cases (consumers calling
        // `.show()` would still appear modal). Modern AT (NVDA / JAWS /
        // VoiceOver) infer modality from the platform accessibility API.
        "aria-label": label,
        "aria-labelledby": label ? undefined : labelledBy,
        style: style,
        onCancel: handleCancel,
        "data-testid": testId,
        className: (0, _runtime.ax)([
            styles.dialog,
            shouldHideBackdrop ? backdropStyles.hidden : backdropStyles.root,
            preset && backdropStyles.motion,
            preset && dialogAnimationStyles.root,
            preset && dialogAnimationStyles.motion,
            consumerXcss
        ]),
        children: children
    });
});

},{"react/jsx-runtime":"bGvcw","@compiled/react/runtime":"d27Vo","react":"ltHCL","bind-event-listener":"bjeUU","@atlaskit/ds-lib/merge-refs":"doPwA","@atlaskit/ds-lib/noop":"faKzG","@atlaskit/layering/experimental/open-layer-observer":"2Dqp9","../internal/use-animated-visibility":"akb4B","../internal/use-focus-wrap":"7XjZG","../internal/use-safari-escape-fix":"iP4fq","@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"iP4fq":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
/**
 * Safari-only guard: WebKit fires dialog `cancel` on Escape even when a child
 * `auto`/`hint` popover consumed it, closing the dialog too.
 * See notes/decisions/safari-escape-nested-popover-in-dialog.md
 */ parcelHelpers.export(exports, "useSafariEscapeFix", ()=>useSafariEscapeFix);
var _react = require("react");
var _bindEventListener = require("bind-event-listener");
var _isSafari = require("@atlaskit/ds-lib/is-safari");
function useSafariEscapeFix({ dialogRef, isVisible }) {
    const childPopoverOpenAtEscapeRef = (0, _react.useRef)(false);
    (0, _react.useEffect)(()=>{
        if (!(0, _isSafari.isSafari)()) return;
        const dialog = dialogRef.current;
        if (!dialog) return;
        // Bind to `document`, not the dialog: on Safari focus can be on `<body>`
        // (buttons are not focused on click), where a dialog-scoped listener would
        // never fire. The query below stays scoped to this dialog's subtree.
        return (0, _bindEventListener.bind)(document, {
            type: 'keydown',
            listener (event) {
                if (event.key !== 'Escape') return;
                try {
                    childPopoverOpenAtEscapeRef.current = Boolean(dialog.querySelector('[popover="auto"]:popover-open, [popover="hint"]:popover-open'));
                } catch (e) {
                    // `:popover-open` is unsupported in some environments (e.g. jsdom);
                    // treat as "no child popover" so a plain Escape still closes the dialog.
                    childPopoverOpenAtEscapeRef.current = false;
                }
            },
            options: {
                capture: true
            }
        });
    }, [
        dialogRef,
        isVisible
    ]);
    const api = (0, _react.useMemo)(()=>{
        return {
            shouldIgnoreEscape () {
                if (childPopoverOpenAtEscapeRef.current) {
                    childPopoverOpenAtEscapeRef.current = false;
                    return true;
                }
                return false;
            }
        };
    }, []);
    return api;
}

},{"react":"ltHCL","bind-event-listener":"bjeUU","@atlaskit/ds-lib/is-safari":"kZLd6","@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"a32OZ":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "DialogScrollLock", ()=>(0, _dialogScrollLock.DialogScrollLock));
var _dialogScrollLock = require("../dialog-scroll-lock");

},{"../dialog-scroll-lock":"ekCFW","@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"ekCFW":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
/**
 * __DialogScrollLock__
 *
 * Prevents background page scrolling while a dialog is open. Designed to be
 * rendered inside a `Dialog` and given the same `isOpen` value.
 *
 * Native `<dialog>.showModal()` makes background content _inert_ (not
 * focusable/clickable), but does **not** prevent scroll events from reaching
 * the document body. This component fills that gap by setting
 * `overflow: hidden` on `document.body` while `isOpen` is `true`.
 *
 * The lock is driven by `isOpen` rather than by mount/unmount so that release
 * happens synchronously in the same commit that flips `isOpen` to `false`.
 * Relying on unmount alone was racy: `Dialog` defers the unmount of its
 * children until the host element's close/toggle event fires, which can be
 * after a consumer or test observes the dialog as hidden, leading to a
 * stale `overflow: hidden` window.
 *
 * @example
 * ```tsx
 * import { Dialog } from '@atlaskit/top-layer/dialog';
 * import { DialogScrollLock } from '@atlaskit/top-layer/dialog-scroll-lock';
 *
 * <Dialog isOpen={isOpen} onClose={onClose}>
 *   <DialogScrollLock isOpen={isOpen} />
 *   {children}
 * </Dialog>
 * ```
 */ parcelHelpers.export(exports, "DialogScrollLock", ()=>DialogScrollLock);
var _react = require("react");
var _browserApis = require("@atlaskit/browser-apis");
function DialogScrollLock({ isOpen }) {
    (0, _react.useLayoutEffect)(()=>{
        var _getDocument;
        if (!isOpen) return;
        const body = (_getDocument = (0, _browserApis.getDocument)()) === null || _getDocument === void 0 ? void 0 : _getDocument.body;
        if (!body) return;
        const previousOverflow = body.style.overflow;
        body.style.overflow = 'hidden';
        return ()=>{
            body.style.overflow = previousOverflow;
        };
    }, [
        isOpen
    ]);
    return null;
}

},{"react":"ltHCL","@atlaskit/browser-apis":"1bRFZ","@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"bBIbK":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "ScrollContext", ()=>(0, _scrollContext.ScrollContext));
parcelHelpers.export(exports, "ModalContext", ()=>ModalContext);
var _react = require("react");
var _scrollContext = require("./scroll-context");
const ModalContext = /*#__PURE__*/ (0, _react.createContext)(null);

},{"react":"ltHCL","./scroll-context":"5KEhV","@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"5KEhV":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "ScrollContext", ()=>ScrollContext);
var _react = require("react");
const ScrollContext = /*#__PURE__*/ (0, _react.createContext)(null);

},{"react":"ltHCL","@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"9OYNX":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>useModalStack);
var _react = require("react");
var _useLazyCallback = require("@atlaskit/ds-lib/use-lazy-callback");
var _useLazyCallbackDefault = parcelHelpers.interopDefault(_useLazyCallback);
var _usePreviousValue = require("@atlaskit/ds-lib/use-previous-value");
var _usePreviousValueDefault = parcelHelpers.interopDefault(_usePreviousValue);
var _useStateRef = require("@atlaskit/ds-lib/use-state-ref");
var _useStateRefDefault = parcelHelpers.interopDefault(_useStateRef);
var _exitingPersistence = require("@atlaskit/motion/exiting-persistence");
/**
 *  ________________________________________________
 * | MAJOR VERSIONS WILL NOT KNOW ABOUT EACH OTHER! |
 *  ------------------------------------------------
 *
 * An array which holds references to all currently open modal dialogs.
 * This will only work for modal dialogs of the same major version,
 * as the reference will be different between them.
 *
 * E.g. V11 won't know about any from V12.
 */ const modalStackRegister = [];
function useModalStack({ onStackChange }) {
    const { isExiting } = (0, _exitingPersistence.useExitingPersistence)();
    const [stackIndexRef, setStackIndex] = (0, _useStateRefDefault.default)(0);
    const currentStackIndex = stackIndexRef.current;
    const previousStackIndex = (0, _usePreviousValueDefault.default)(stackIndexRef.current);
    // We want to ensure this function **never changes** during the lifecycle of this component.
    // This is why it's assigned to a ref and not in a useMemo/useCallback.
    const updateStack = (0, _useLazyCallbackDefault.default)(()=>{
        const newStackIndex = modalStackRegister.indexOf(updateStack);
        // We access the stack index ref instead of state because this closure will always only
        // have the initial state and not any of the later values.
        if (stackIndexRef.current !== newStackIndex) {
            setStackIndex(newStackIndex);
            stackIndexRef.current = newStackIndex;
        }
    });
    (0, _react.useEffect)(()=>{
        const currentStackIndex = modalStackRegister.indexOf(updateStack);
        if (!isExiting && currentStackIndex === -1) // We are opening the modal dialog.
        // Add ourselves to the modal stack register!
        modalStackRegister.unshift(updateStack);
        if (isExiting && currentStackIndex !== -1) // We are closing the modal dialog using a wrapping modal transition component.
        // Remove ourselves from the modal stack register!
        // NOTE: Modal dialogs that don't have a wrapping modal transition component won't flow through here!
        // For that scenario we cleanup when the component unmounts.
        modalStackRegister.splice(currentStackIndex, 1);
        // Fire all registered modal dialogs to update their position in the stack.
        modalStackRegister.forEach((cb)=>cb());
    }, [
        updateStack,
        isExiting
    ]);
    (0, _react.useEffect)(()=>()=>{
            // Final cleanup just in case this modal dialog did not have a wrapping modal transition.
            const currentStackIndex = modalStackRegister.indexOf(updateStack);
            if (currentStackIndex !== -1) {
                modalStackRegister.splice(currentStackIndex, 1);
                modalStackRegister.forEach((cb)=>cb());
            }
        }, [
        updateStack
    ]);
    (0, _react.useEffect)(()=>{
        if (previousStackIndex === undefined) // Initial case that we don't need to notify about.
        return;
        if (previousStackIndex !== currentStackIndex) onStackChange(currentStackIndex);
    }, [
        onStackChange,
        previousStackIndex,
        currentStackIndex
    ]);
    return currentStackIndex;
}

},{"react":"ltHCL","@atlaskit/ds-lib/use-lazy-callback":"k76pc","@atlaskit/ds-lib/use-previous-value":"lbsYm","@atlaskit/ds-lib/use-state-ref":"apHA7","@atlaskit/motion/exiting-persistence":"ldMDz","@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"k76pc":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>useLazyCallback);
var _useLazyRef = require("./use-lazy-ref");
var _useLazyRefDefault = parcelHelpers.interopDefault(_useLazyRef);
function useLazyCallback(callback) {
    const ref = (0, _useLazyRefDefault.default)(()=>callback);
    return ref.current;
}

},{"./use-lazy-ref":"7rWe7","@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"7rWe7":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>useLazyRef);
var _react = require("react");
const uniqueReferencedValue = {};
function useLazyRef(initializer) {
    const ref = (0, _react.useRef)(uniqueReferencedValue);
    if (ref.current === uniqueReferencedValue) ref.current = initializer();
    return ref;
}

},{"react":"ltHCL","@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"lbsYm":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>usePreviousValue);
var _react = require("react");
function usePreviousValue(value) {
    const ref = (0, _react.useRef)();
    (0, _react.useEffect)(()=>{
        ref.current = value;
    }, [
        value
    ]);
    return ref.current;
}

},{"react":"ltHCL","@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"apHA7":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>useStateRef);
var _react = require("react");
function useStateRef(initialState) {
    const [value, setValue] = (0, _react.useState)(initialState);
    const valueRef = (0, _react.useRef)(value);
    valueRef.current = value;
    return [
        valueRef,
        setValue
    ];
}

},{"react":"ltHCL","@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"22qTD":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>usePreventProgrammaticScroll);
var _react = require("react");
var _bindEventListener = require("bind-event-listener");
/**
 * Returns how far the body is scrolled from the top of the viewport.
 *
 *   ____
 * ||____|| <-- overflow
 *  |    |  <-- viewport
 *  |____|
 *
 * Scroll distance is the height of overflow outside the viewport.
 */ function getScrollDistance() {
    var _document_documentElement, _document_body;
    return window.pageYOffset || ((_document_documentElement = document.documentElement) === null || _document_documentElement === void 0 ? void 0 : _document_documentElement.scrollTop) || ((_document_body = document.body) === null || _document_body === void 0 ? void 0 : _document_body.scrollTop) || 0;
}
function usePreventProgrammaticScroll() {
    const [scrollTopOffset, setScrollTopOffset] = (0, _react.useState)(0);
    (0, _react.useLayoutEffect)(()=>{
        setScrollTopOffset(getScrollDistance());
    }, []);
    const onWindowScroll = (0, _react.useCallback)(()=>{
        if (getScrollDistance() !== scrollTopOffset) window.scrollTo(window.pageXOffset, scrollTopOffset);
    }, [
        scrollTopOffset
    ]);
    (0, _react.useEffect)(()=>{
        return (0, _bindEventListener.bind)(window, {
            type: 'scroll',
            listener: onWindowScroll
        });
    }, [
        onWindowScroll
    ]);
    return scrollTopOffset;
}

},{"react":"ltHCL","bind-event-listener":"bjeUU","@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"c5Im8":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "disableDraggingToCrossOriginIFramesForElement", ()=>disableDraggingToCrossOriginIFramesForElement);
var _bindEventListener = require("bind-event-listener");
var _combine = require("@atlaskit/pragmatic-drag-and-drop/combine");
var _adapter = require("@atlaskit/pragmatic-drag-and-drop/element/adapter");
var _makeFixForAdapter = require("./make-fix-for-adapter");
function watchForInteractionEnd({ stop }) {
    let isDragging = false;
    function stopIfNotDragging() {
        if (isDragging) return;
        stop();
    }
    const unbindEvents = (0, _bindEventListener.bindAll)(window, [
        {
            // Another interaction is starting, this fix should be removed.
            type: 'pointerdown',
            listener: stop
        },
        {
            // The user did not start a drag
            type: 'pointerup',
            listener: stopIfNotDragging
        },
        {
            // if a "dragstart" occurs and the flag is not set,
            // then a drag has not started.
            // Note: could not use "pointercancel" as it is not
            // published in Safari
            // → https://bugs.webkit.org/show_bug.cgi?id=222632
            type: 'dragstart',
            listener: stopIfNotDragging,
            // Need to come after the element adapter
            options: {
                capture: false
            }
        }
    ], {
        // Listening in the capture phase to increase resilience
        // against events being stopped.
        capture: true,
        // Being super clear these should only run once
        once: true
    });
    const unbindMonitor = (0, _adapter.monitorForElements)({
        onGenerateDragPreview () {
            isDragging = true;
        },
        onDrop () {
            isDragging = false;
            stop();
        }
    });
    return (0, _combine.combine)(unbindEvents, unbindMonitor);
}
function watchForInteractionStart({ start }) {
    return (0, _bindEventListener.bind)(window, {
        // Note: Using "mousedown" rather than "pointerdown" due to a Safari bug.
        // Safari not publish a "pointerdown" on the interaction after a drag
        // → https://bugs.webkit.org/show_bug.cgi?id=279749
        type: 'mousedown',
        listener (event) {
            // Only starting if pressing down inside a draggable element
            // At this point, we are not sure which if:
            // 1. a text selection drag is starting
            // 2. a draggable managed by pdnd is going to be dragged
            // 3. a draggable not managed by pdnd is going to be dragged
            // 4. The user will be dragging anything at all (might be doing a click)
            if (event.target instanceof HTMLElement && event.target.closest('[draggable="true"]')) start();
        }
    });
}
const api = (0, _makeFixForAdapter.makeFixForAdapter)({
    watchForInteractionStart,
    watchForInteractionEnd
});
function disableDraggingToCrossOriginIFramesForElement() {
    return api.registerUsage();
}

},{"bind-event-listener":"bjeUU","@atlaskit/pragmatic-drag-and-drop/combine":"b8cay","@atlaskit/pragmatic-drag-and-drop/element/adapter":"9uGkT","./make-fix-for-adapter":"kiAKj","@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"9uGkT":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "draggable", ()=>(0, _elementAdapter.draggable));
parcelHelpers.export(exports, "dropTargetForElements", ()=>(0, _elementAdapter.dropTargetForElements));
parcelHelpers.export(exports, "monitorForElements", ()=>(0, _elementAdapter.monitorForElements));
var _elementAdapter = require("../../adapter/element-adapter");

},{"../../adapter/element-adapter":"jgDqZ","@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"jgDqZ":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "dropTargetForElements", ()=>dropTargetForElements);
parcelHelpers.export(exports, "monitorForElements", ()=>monitorForElements);
// eslint-disable-next-line @atlaskit/volt-strict-mode/no-multiple-exports
parcelHelpers.export(exports, "draggable", ()=>draggable);
var _bindEventListener = require("bind-event-listener");
var _getElementFromPointWithoutHoneyPot = require("../honey-pot-fix/get-element-from-point-without-honey-pot");
var _makeHoneyPotFix = require("../honey-pot-fix/make-honey-pot-fix");
var _makeAdapter = require("../make-adapter/make-adapter");
var _combine = require("../public-utils/combine");
var _once = require("../public-utils/once");
var _addAttribute = require("../util/add-attribute");
var _android = require("../util/android");
var _getInput = require("../util/get-input");
var _textMediaType = require("../util/media-types/text-media-type");
var _urlMediaType = require("../util/media-types/url-media-type");
var _elementAdapterNativeDataKey = require("./element-adapter-native-data-key");
const draggableRegistry = new WeakMap();
function addToRegistry(args) {
    draggableRegistry.set(args.element, args);
    return function cleanup() {
        draggableRegistry.delete(args.element);
    };
}
const honeyPotFix = (0, _makeHoneyPotFix.makeHoneyPotFix)();
const adapter = (0, _makeAdapter.makeAdapter)({
    typeKey: 'element',
    defaultDropEffect: 'move',
    mount (api) {
        /**  Binding event listeners the `document` rather than `window` so that
		 * this adapter always gets preference over the text adapter.
		 * `document` is the first `EventTarget` under `window`
		 * https://twitter.com/alexandereardon/status/1604658588311465985
		 */ return (0, _combine.combine)(honeyPotFix.bindEvents(), (0, _bindEventListener.bind)(document, {
            type: 'dragstart',
            listener (event) {
                var _entry_getInitialDataForExternal, _entry_getInitialData;
                if (!api.canStart(event)) return;
                // If the "dragstart" event is cancelled, then a drag won't start
                // There will be no further drag operation events (eg no "dragend" event)
                if (event.defaultPrevented) return;
                // Technically `dataTransfer` can be `null` according to the types
                // But that behaviour does not seem to appear in the spec.
                // If there is not `dataTransfer`, we can assume something is wrong and not
                // start a drag
                if (!event.dataTransfer) return;
                // the closest parent that is a draggable element will be marked as
                // the `event.target` for the event
                const target = event.target;
                // this source is only for elements
                // Note: only HTMLElements can have the "draggable" attribute
                if (!(target instanceof HTMLElement)) return;
                // see if the thing being dragged is owned by us
                const entry = draggableRegistry.get(target);
                // no matching element found
                // → dragging an element with `draggable="true"` that is not controlled by us
                if (!entry) return;
                /**
					 * A text selection drag _can_ have the `draggable` element be
					 * the `event.target` if the user is dragging the text selection
					 * from the `draggable`.
					 *
					 * To know if the `draggable` is being dragged, we look at whether any
					 * `"text/plain"` data is being dragged. If it is, then a text selection
					 * drag is occurring.
					 *
					 * This behaviour has been validated on:
					 *
					 * - Chrome@128 on Android@14
					 * - Chrome@128 on iOS@17.6.1
					 * - Chrome@128 on Windows@11
					 * - Chrome@128 on MacOS@14.6.1
					 * - Firefox@129 on Windows@11 (not possible for user to select text in a draggable)
					 * - Firefox@129 on MacOS@14.6.1 (not possible for user to select text in a draggable)
					 *
					 * Note: Could usually just use: `event.dataTransfer.types.includes(textMediaType)`
					 * but unfortunately ProseMirror is always setting `""` as the dragged text
					 *
					 * Note: Unfortunately editor is (heavily) leaning on the current functionality today
					 * and unwinding it will be a decent amount of effort. So for now, a text selection
					 * where the `event.target` is a `draggable` element will still trigger the
					 * element adapter.
					 *
					 * // Future state:
					 * if(event.dataTransfer.getData(textMediaType)) {
					 * 	return;
					 * }
					 *
					 */ const input = (0, _getInput.getInput)(event);
                var _entry_dragHandle;
                const feedback = {
                    element: entry.element,
                    dragHandle: (_entry_dragHandle = entry.dragHandle) !== null && _entry_dragHandle !== void 0 ? _entry_dragHandle : null,
                    input
                };
                // Check: does the draggable want to allow dragging?
                if (entry.canDrag && !entry.canDrag(feedback)) {
                    // cancel drag operation if we cannot drag
                    event.preventDefault();
                    return;
                }
                // Check: is there a drag handle and is the user using it?
                if (entry.dragHandle) {
                    // technically don't need this util, but just being
                    // consistent with how we look up what is under the users
                    // cursor.
                    const over = (0, _getElementFromPointWithoutHoneyPot.getElementFromPointWithoutHoneypot)({
                        x: input.clientX,
                        y: input.clientY
                    });
                    // if we are not dragging from the drag handle (or something inside the drag handle)
                    // then we will cancel the active drag
                    if (!entry.dragHandle.contains(over)) {
                        event.preventDefault();
                        return;
                    }
                }
                var _entry_getInitialDataForExternal1;
                /**
					 *  **Goal**
					 *  Pass information to other applications
					 *
					 * **Approach**
					 *  Put data into the native data store
					 *
					 *  **What about the native adapter?**
					 *  When the element adapter puts native data into the native data store
					 *  the native adapter is not triggered in the current window,
					 *  but a native adapter in an external window _can_ be triggered
					 *
					 *  **Why bake this into core?**
					 *  This functionality could be pulled out and exposed inside of
					 *  `onGenerateDragPreview`. But decided to make it a part of the
					 *  base API as it felt like a common enough use case and ended
					 *  up being a similar amount of code to include this function as
					 *  it was to expose the hook for it
					 */ const nativeData = (_entry_getInitialDataForExternal1 = (_entry_getInitialDataForExternal = entry.getInitialDataForExternal) === null || _entry_getInitialDataForExternal === void 0 ? void 0 : _entry_getInitialDataForExternal.call(entry, feedback)) !== null && _entry_getInitialDataForExternal1 !== void 0 ? _entry_getInitialDataForExternal1 : null;
                if (nativeData) for (const [key, data] of Object.entries(nativeData))event.dataTransfer.setData(key, data !== null && data !== void 0 ? data : '');
                /**
					 *  📱 For Android devices, a drag operation will not start unless
					 * "text/plain" or "text/uri-list" data exists in the native data store
					 * https://twitter.com/alexandereardon/status/1732189803754713424
					 *
					 * Tested on:
					 * Device: Google Pixel 5
					 * Android version: 14 (November 5, 2023)
					 * Chrome version: 120.0
					 */ if ((0, _android.isAndroid)() && !event.dataTransfer.types.includes((0, _textMediaType.textMediaType)) && !event.dataTransfer.types.includes((0, _urlMediaType.URLMediaType))) event.dataTransfer.setData((0, _textMediaType.textMediaType), (0, _android.androidFallbackText));
                /**
					 * 1. Must set any media type for `iOS15` to work
					 * 2. We are also doing adding data so that the native adapter
					 * can know that the element adapter has handled this drag
					 *
					 * We used to wrap this `setData()` in a `try/catch` for Firefox,
					 * but it looks like that was not needed.
					 *
					 * Tested using: https://codesandbox.io/s/checking-firefox-throw-behaviour-on-dragstart-qt8h4f
					 *
					 * - ✅ Firefox@70.0 (Oct 2019) on macOS Sonoma
					 * - ✅ Firefox@70.0 (Oct 2019) on macOS Big Sur
					 * - ✅ Firefox@70.0 (Oct 2019) on Windows 10
					 *
					 * // just checking a few more combinations to be super safe
					 *
					 * - ✅ Chrome@78 (Oct 2019) on macOS Big Sur
					 * - ✅ Chrome@78 (Oct 2019) on Windows 10
					 * - ✅ Safari@14.1 on macOS Big Sur
					 */ event.dataTransfer.setData((0, _elementAdapterNativeDataKey.elementAdapterNativeDataKey), '');
                var _entry_dragHandle1, _entry_getInitialData1;
                const payload = {
                    element: entry.element,
                    dragHandle: (_entry_dragHandle1 = entry.dragHandle) !== null && _entry_dragHandle1 !== void 0 ? _entry_dragHandle1 : null,
                    data: (_entry_getInitialData1 = (_entry_getInitialData = entry.getInitialData) === null || _entry_getInitialData === void 0 ? void 0 : _entry_getInitialData.call(entry, feedback)) !== null && _entry_getInitialData1 !== void 0 ? _entry_getInitialData1 : {}
                };
                const dragType = {
                    type: 'element',
                    payload,
                    startedFrom: 'internal'
                };
                api.start({
                    event,
                    dragType
                });
            }
        }));
    },
    dispatchEventToSource: ({ eventName, payload })=>{
        var // During a drag operation, a draggable can be:
        // - remounted with different functions
        // - removed completely
        // So we need to get the latest entry from the registry in order
        // to call the latest event functions
        _draggableRegistry_get_eventName, _draggableRegistry_get;
        (_draggableRegistry_get = draggableRegistry.get(payload.source.element)) === null || _draggableRegistry_get === void 0 ? void 0 : (_draggableRegistry_get_eventName = _draggableRegistry_get[eventName]) === null || _draggableRegistry_get_eventName === void 0 ? void 0 : _draggableRegistry_get_eventName.call(_draggableRegistry_get, // I cannot seem to get the types right here.
        // TS doesn't seem to like that one event can need `nativeSetDragImage`
        // @ts-expect-error
        payload);
    },
    onPostDispatch: honeyPotFix.getOnPostDispatch()
});
const dropTargetForElements = adapter.dropTarget;
const monitorForElements = adapter.monitor;
function draggable(args) {
    const cleanup = (0, _combine.combine)(// making the draggable register the adapter rather than drop targets
    // this is because you *must* have a draggable element to start a drag
    // but you _might_ not have any drop targets immediately
    // (You might create drop targets async)
    adapter.registerUsage(), addToRegistry(args), (0, _addAttribute.addAttribute)(args.element, {
        attribute: 'draggable',
        value: 'true'
    }));
    // Wrapping in `once` to prevent unexpected side effects if consumers call
    // the clean up function multiple times.
    return (0, _once.once)(cleanup);
}

},{"bind-event-listener":"bjeUU","../honey-pot-fix/get-element-from-point-without-honey-pot":"wrUOA","../honey-pot-fix/make-honey-pot-fix":"fxhWx","../make-adapter/make-adapter":"hBkue","../public-utils/combine":"crrjo","../public-utils/once":"qagbq","../util/add-attribute":"cjZLv","../util/android":"b4W1Q","../util/get-input":"6VCD0","../util/media-types/text-media-type":"lxg8d","../util/media-types/url-media-type":"8nngE","./element-adapter-native-data-key":"8X0Gb","@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"wrUOA":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "getElementFromPointWithoutHoneypot", ()=>getElementFromPointWithoutHoneypot);
var _isHoneyPotElement = require("./is-honey-pot-element");
function getElementFromPointWithoutHoneypot(client) {
    // eslint-disable-next-line no-restricted-syntax
    const [top, second] = document.elementsFromPoint(client.x, client.y);
    if (!top) return null;
    if ((0, _isHoneyPotElement.isHoneyPotElement)(top)) return second !== null && second !== void 0 ? second : null;
    return top;
}

},{"./is-honey-pot-element":"hLRwJ","@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"hLRwJ":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "isHoneyPotElement", ()=>isHoneyPotElement);
var _honeyPotDataAttribute = require("./honey-pot-data-attribute");
function isHoneyPotElement(target) {
    return target instanceof Element && target.hasAttribute((0, _honeyPotDataAttribute.honeyPotDataAttribute));
}

},{"./honey-pot-data-attribute":"a3bfE","@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"a3bfE":[function(require,module,exports,__globalThis) {
// pulling this into a separate file so adapter(s) that don't
// need the honey pot can pay as little as possible for it.
var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "honeyPotDataAttribute", ()=>honeyPotDataAttribute);
const honeyPotDataAttribute = 'data-pdnd-honey-pot';

},{"@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"fxhWx":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "makeHoneyPotFix", ()=>makeHoneyPotFix);
var _objectSpread = require("@swc/helpers/_/_object_spread");
var _objectSpreadProps = require("@swc/helpers/_/_object_spread_props");
var _bindEventListener = require("bind-event-listener");
var _maxZIndex = require("../util/max-z-index");
var _popoverResetStyles = require("../util/popover-reset-styles");
var _supportsPopover = require("../util/supports-popover");
var _honeyPotDataAttribute = require("./honey-pot-data-attribute");
const honeyPotSize = 2;
const halfHoneyPotSize = honeyPotSize / 2;
/**
 * `clientX` and `clientY` can be in sub pixels (eg `2.332`)
 * However, browser hitbox testing is commonly do to the closest pixel.
 *
 * → https://issues.chromium.org/issues/40940531
 *
 * To be sure that the honey pot will be over the `client` position,
 * we `.floor()` `clientX` and`clientY` and then make it `2px` in size.
 **/ function floorToClosestPixel(point) {
    return {
        x: Math.floor(point.x),
        y: Math.floor(point.y)
    };
}
/**
 * We want to make sure the honey pot sits around the users position.
 * This seemed to be the most resilient while testing.
 */ function pullBackByHalfHoneyPotSize(point) {
    return {
        x: point.x - halfHoneyPotSize,
        y: point.y - halfHoneyPotSize
    };
}
/**
 * Prevent the honey pot from changing the window size.
 * This is super unlikely to occur, but just being safe.
 */ function preventGoingBackwardsOffScreen(point) {
    return {
        x: Math.max(point.x, 0),
        y: Math.max(point.y, 0)
    };
}
/**
 * Prevent the honey pot from changing the window size.
 * This is super unlikely to occur, but just being safe.
 */ function preventGoingForwardsOffScreen(point) {
    return {
        x: Math.min(point.x, window.innerWidth - honeyPotSize),
        y: Math.min(point.y, window.innerHeight - honeyPotSize)
    };
}
/**
 * Create a `2x2` `DOMRect` around the `client` position
 */ function getHoneyPotRectFor({ client }) {
    const point = preventGoingForwardsOffScreen(preventGoingBackwardsOffScreen(pullBackByHalfHoneyPotSize(floorToClosestPixel(client))));
    // When debugging, it is helpful to
    // make this element a bit bigger
    return DOMRect.fromRect({
        x: point.x,
        y: point.y,
        width: honeyPotSize,
        height: honeyPotSize
    });
}
function getRectStyles({ clientRect }) {
    return {
        left: `${clientRect.left}px`,
        top: `${clientRect.top}px`,
        width: `${clientRect.width}px`,
        height: `${clientRect.height}px`
    };
}
function isWithin({ client, clientRect }) {
    return(// is within horizontal bounds
    client.x >= clientRect.x && client.x <= clientRect.x + clientRect.width && // is within vertical bounds
    client.y >= clientRect.y && client.y <= clientRect.y + clientRect.height);
}
/**
 * The honey pot fix is designed to get around a painful bug in all browsers.
 *
 * [Overview](https://www.youtube.com/watch?v=udE9qbFTeQg)
 *
 * **Background**
 *
 * When a drag starts, browsers incorrectly think that the users pointer is
 * still depressed where the drag started. Any element that goes under this position
 * will be entered into, causing `"mouseenter"` events and `":hover"` styles to be applied.
 *
 * _This is a violation of the spec_
 *
 * > "From the moment that the user agent is to initiate the drag-and-drop operation,
 * > until the end 	of the drag-and-drop operation, device input events
 * > (e.g. mouse and keyboard events) must be suppressed."
 * >
 * > - https://html.spec.whatwg.org/multipage/dnd.html#drag-and-drop-processing-model
 *
 * _Some impacts_
 *
 * - `":hover"` styles being applied where they shouldn't (looks messy)
 * - components such as tooltips responding to `"mouseenter"` can show during a drag,
 *   and on an element the user isn't even over
 *
 * Bug: https://issues.chromium.org/issues/41129937
 *
 * **Honey pot fix**
 *
 * 1. Create an element where the browser thinks the depressed pointer is
 *    to absorb the incorrect pointer events
 * 2. Remove that element when it is no longer needed
 */ function mountHoneyPot({ initial }) {
    const element = document.createElement('div');
    element.setAttribute((0, _honeyPotDataAttribute.honeyPotDataAttribute), 'true');
    // Using popover="manual" to place the element in the browser's top layer.
    // This ensures the honey pot is visually on top of everything else,
    // including elements using z-index and other stacking contexts.
    // "manual" means no light dismiss — we manage the lifecycle ourselves.
    // Falls back to position:fixed + maxZIndex when the popover API is not available.
    if ((0, _supportsPopover.supportsPopover)()) element.setAttribute('popover', 'manual');
    // can shift during the drag thanks to Firefox
    let clientRect = getHoneyPotRectFor({
        client: initial
    });
    Object.assign(element.style, (0, _objectSpread._)((0, _objectSpreadProps._)((0, _objectSpread._)({
        position: 'fixed'
    }, (0, _supportsPopover.supportsPopover)() ? // needs to be overridden by our top / left values
    (0, _popoverResetStyles.popoverResetUserAgentStyles) : {
        // Fallback: using maximum possible z-index so that this element
        // will always be on top of other positioned content.
        zIndex: (0, _maxZIndex.maxZIndex)
    }), {
        // Setting a background color explicitly to avoid any inherited styles.
        // Looks like this could be `opacity: 0`, but worried that _might_
        // cause the element to be ignored on some platforms.
        // When debugging, set backgroundColor to something like "red".
        backgroundColor: 'transparent',
        // Being explicit to avoid inheriting styles
        padding: 0,
        margin: 0,
        boxSizing: 'border-box',
        // We want this element to absorb pointer events,
        // it's kind of the whole point 😉
        pointerEvents: 'auto'
    }), getRectStyles({
        clientRect
    })));
    document.body.appendChild(element);
    if ((0, _supportsPopover.supportsPopover)()) element.showPopover();
    /**
	 *  🦊 In firefox we can get `"pointermove"` events after the drag
	 * has started, which is a spec violation.
	 * The final `"pointermove"` will reveal where the "depressed" position
	 * is for our honey pot fix.
	 */ const unbindPointerMove = (0, _bindEventListener.bind)(window, {
        type: 'pointermove',
        listener (event) {
            const client = {
                x: event.clientX,
                y: event.clientY
            };
            clientRect = getHoneyPotRectFor({
                client
            });
            Object.assign(element.style, getRectStyles({
                clientRect
            }));
        },
        // using capture so we are less likely to be impacted by event stopping
        options: {
            capture: true
        }
    });
    return function finish({ current }) {
        // Don't need this any more
        unbindPointerMove();
        // If the user is hover the honey pot, we remove it
        // so that the user can continue to interact with the page normally.
        if (isWithin({
            client: current,
            clientRect
        })) {
            element.remove();
            return;
        }
        function cleanup() {
            unbindPostDragEvents();
            element.remove();
        }
        const unbindPostDragEvents = (0, _bindEventListener.bindAll)(window, [
            {
                type: 'pointerdown',
                listener: cleanup
            },
            {
                type: 'pointermove',
                listener: cleanup
            },
            {
                type: 'focusin',
                listener: cleanup
            },
            {
                type: 'focusout',
                listener: cleanup
            },
            // a 'pointerdown' should happen before 'dragstart', but just being super safe
            {
                type: 'dragstart',
                listener: cleanup
            },
            // if the user has dragged something out of the window
            // and then is dragging something back into the window
            // the first events we will see are "dragenter" (and then "dragover").
            // So if we see any of these we need to clear the post drag fix.
            {
                type: 'dragenter',
                listener: cleanup
            },
            {
                type: 'dragover',
                listener: cleanup
            }
        ], {
            // Using `capture` so less likely to be impacted by other code stopping events
            capture: true
        });
    };
}
function makeHoneyPotFix() {
    let latestPointerMove = null;
    function bindEvents() {
        // For sanity, only collecting this value from when events are first bound.
        // This prevents the case where a super old "pointermove" could be used
        // from a prior interaction.
        latestPointerMove = null;
        return (0, _bindEventListener.bind)(window, {
            type: 'pointermove',
            listener (event) {
                latestPointerMove = {
                    x: event.clientX,
                    y: event.clientY
                };
            },
            // listening for pointer move in capture phase
            // so we are less likely to be impacted by events being stopped.
            options: {
                capture: true
            }
        });
    }
    function getOnPostDispatch() {
        let finish = null;
        return function onPostEvent({ eventName, payload }) {
            // We are adding the honey pot `onDragStart` so we don't
            // impact the creation of the native drag preview.
            if (eventName === 'onDragStart') {
                const { input } = payload.location.initial;
                // Sometimes there will be no latest "pointermove" (eg iOS).
                // In which case, we use the start position of the drag.
                const initial = latestPointerMove !== null && latestPointerMove !== void 0 ? latestPointerMove : {
                    x: input.clientX,
                    y: input.clientY
                };
                // Don't need to defensively call `finish()` as `onDrop` from
                // one interaction is guaranteed to be called before `onDragStart`
                // of the next.
                finish = mountHoneyPot({
                    initial
                });
            }
            if (eventName === 'onDrop') {
                const { input } = payload.location.current;
                finish === null || finish === void 0 ? void 0 : finish({
                    current: {
                        x: input.clientX,
                        y: input.clientY
                    }
                });
                finish = null;
                // this interaction is finished, we want to use
                // the latest "pointermove" for each interaction
                latestPointerMove = null;
            }
        };
    }
    return {
        bindEvents,
        getOnPostDispatch
    };
}

},{"@swc/helpers/_/_object_spread":"9gdrV","@swc/helpers/_/_object_spread_props":"kANqQ","bind-event-listener":"bjeUU","../util/max-z-index":"29DVz","../util/popover-reset-styles":"ia2IK","../util/supports-popover":"erFEE","./honey-pot-data-attribute":"a3bfE","@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"29DVz":[function(require,module,exports,__globalThis) {
// Maximum possible z-index
// https://stackoverflow.com/questions/491052/minimum-and-maximum-value-of-z-index
var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "maxZIndex", ()=>maxZIndex);
const maxZIndex = 2147483647;

},{"@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"ia2IK":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "popoverResetUserAgentStyles", ()=>popoverResetUserAgentStyles);
const popoverResetUserAgentStyles = {
    inset: 'unset',
    border: 'none',
    padding: 0,
    margin: 0,
    overflow: 'visible',
    color: 'inherit',
    background: 'transparent',
    width: 'auto',
    height: 'auto'
};

},{"@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"erFEE":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "supportsPopover", ()=>supportsPopover);
var _once = require("../public-utils/once");
const supportsPopover = (0, _once.once)(function supportsPopover() {
    return typeof HTMLElement !== 'undefined' && typeof HTMLElement.prototype.showPopover === 'function';
});

},{"../public-utils/once":"qagbq","@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"qagbq":[function(require,module,exports,__globalThis) {
/** Provide a function that you only ever want to be called a single time */ var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "once", ()=>once);
function once(fn) {
    let cache = null;
    return function wrapped(...args) {
        if (!cache) {
            const result = fn.apply(this, args);
            cache = {
                result: result
            };
        }
        return cache.result;
    };
}

},{"@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"hBkue":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "makeAdapter", ()=>makeAdapter);
var _lifecycleManager = require("../ledger/lifecycle-manager");
var _usageLedger = require("../ledger/usage-ledger");
var _makeDropTarget = require("./make-drop-target");
var _makeMonitor = require("./make-monitor");
function makeAdapter({ typeKey, mount, dispatchEventToSource, onPostDispatch, defaultDropEffect }) {
    const monitorAPI = (0, _makeMonitor.makeMonitor)();
    const dropTargetAPI = (0, _makeDropTarget.makeDropTarget)({
        typeKey,
        defaultDropEffect
    });
    function dispatchEvent(args) {
        // 1. forward the event to source
        dispatchEventToSource === null || dispatchEventToSource === void 0 ? void 0 : dispatchEventToSource(args);
        // 2. forward the event to relevant dropTargets
        dropTargetAPI.dispatchEvent(args);
        // 3. forward event to monitors
        monitorAPI.dispatchEvent(args);
        // 4. post consumer dispatch (used for honey pot fix)
        onPostDispatch === null || onPostDispatch === void 0 ? void 0 : onPostDispatch(args);
    }
    function start({ event, dragType }) {
        (0, _lifecycleManager.lifecycle).start({
            event,
            dragType,
            getDropTargetsOver: dropTargetAPI.getIsOver,
            dispatchEvent
        });
    }
    function registerUsage() {
        function mountAdapter() {
            const api = {
                canStart: (0, _lifecycleManager.lifecycle).canStart,
                start
            };
            return mount(api);
        }
        return (0, _usageLedger.register)({
            typeKey,
            mount: mountAdapter
        });
    }
    return {
        registerUsage,
        dropTarget: dropTargetAPI.dropTargetForConsumers,
        monitor: monitorAPI.monitorForConsumers
    };
}

},{"../ledger/lifecycle-manager":"4VNZx","../ledger/usage-ledger":"d1yti","./make-drop-target":"1zwUb","./make-monitor":"k012V","@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"4VNZx":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "lifecycle", ()=>lifecycle);
var _bindEventListener = require("bind-event-listener");
var _getElementFromPointWithoutHoneyPot = require("../honey-pot-fix/get-element-from-point-without-honey-pot");
var _isHoneyPotElement = require("../honey-pot-fix/is-honey-pot-element");
var _isLeavingWindow = require("../util/changing-window/is-leaving-window");
var _detectBrokenDrag = require("../util/detect-broken-drag");
var _getInput = require("../util/get-input");
var _dispatchConsumerEvent = require("./dispatch-consumer-event");
const globalState = {
    isActive: false
};
function canStart() {
    return !globalState.isActive;
}
function getNativeSetDragImage(event) {
    if (event.dataTransfer) // need to use `.bind` as `setDragImage` is required
    // to be run with `event.dataTransfer` as the "this" context
    return event.dataTransfer.setDragImage.bind(event.dataTransfer);
    return null;
}
function hasHierarchyChanged({ current, next }) {
    if (current.length !== next.length) return true;
    // not checking stickiness, data or dropEffect,
    // just whether the hierarchy has changed
    for(let i = 0; i < current.length; i++){
        if (current[i].element !== next[i].element) return true;
    }
    return false;
}
function start({ event, dragType, getDropTargetsOver, dispatchEvent }) {
    if (!canStart()) return;
    const initial = getStartLocation({
        event,
        dragType,
        getDropTargetsOver
    });
    globalState.isActive = true;
    const state = {
        current: initial
    };
    // Setting initial drop effect for the drag
    setDropEffectOnEvent({
        event,
        current: initial.dropTargets
    });
    const dispatch = (0, _dispatchConsumerEvent.makeDispatch)({
        source: dragType.payload,
        dispatchEvent,
        initial
    });
    function updateState(next) {
        // only looking at whether hierarchy has changed to determine whether something as 'changed'
        const hasChanged = hasHierarchyChanged({
            current: state.current.dropTargets,
            next: next.dropTargets
        });
        // Always updating the state to include latest data, dropEffect and stickiness
        // Only updating consumers if the hierarchy has changed in some way
        // Consumers can get the latest data by using `onDrag`
        state.current = next;
        if (hasChanged) dispatch.dragUpdate({
            current: state.current
        });
    }
    function onUpdateEvent(event) {
        const input = (0, _getInput.getInput)(event);
        // If we are over the honey pot, we need to get the element
        // that the user would have been over if not for the honey pot
        const target = (0, _isHoneyPotElement.isHoneyPotElement)(event.target) ? (0, _getElementFromPointWithoutHoneyPot.getElementFromPointWithoutHoneypot)({
            x: input.clientX,
            y: input.clientY
        }) : event.target;
        const nextDropTargets = getDropTargetsOver({
            target,
            input,
            source: dragType.payload,
            current: state.current.dropTargets
        });
        if (nextDropTargets.length) {
            // 🩸 must call `event.preventDefault()` to allow a browser drop to occur
            event.preventDefault();
            setDropEffectOnEvent({
                event,
                current: nextDropTargets
            });
        }
        updateState({
            dropTargets: nextDropTargets,
            input
        });
    }
    function cancel() {
        // The spec behaviour is that when a drag is cancelled, or when dropping on no drop targets,
        // a "dragleave" event is fired on the active drop target before a "dragend" event.
        // We are replicating that behaviour in `cancel` if there are any active drop targets to
        // ensure consistent behaviour.
        //
        // Note: When cancelling, or dropping on no drop targets, a "dragleave" event
        // will have already cleared the dropTargets to `[]` (as that particular "dragleave" has a `relatedTarget` of `null`)
        if (state.current.dropTargets.length) updateState({
            dropTargets: [],
            input: state.current.input
        });
        dispatch.drop({
            current: state.current,
            updatedSourcePayload: null
        });
        finish();
    }
    function finish() {
        globalState.isActive = false;
        unbindEvents();
    }
    const unbindEvents = (0, _bindEventListener.bindAll)(window, [
        {
            // 👋 Note: we are repurposing the `dragover` event as our `drag` event
            // this is because firefox does not publish pointer coordinates during
            // a `drag` event, but does for every other type of drag event
            // `dragover` fires on all elements that are being dragged over
            // Because we are binding to `window` - our `dragover` is effectively the same as a `drag`
            // 🦊😤
            type: 'dragover',
            listener (event) {
                // We need to regularly calculate the drop targets in order to allow:
                //  - dynamic `canDrop()` checks
                //  - rapid updating `getData()` calls to attach data in response to user input (eg for edge detection)
                // Sadly we cannot schedule inspecting changes resulting from this event
                // we need to be able to conditionally cancel the event with `event.preventDefault()`
                // to enable the correct native drop experience.
                // 1. check to see if anything has changed
                onUpdateEvent(event);
                // 2. let consumers know a move has occurred
                // This will include the latest 'input' values
                dispatch.drag({
                    current: state.current
                });
            }
        },
        {
            type: 'dragenter',
            listener: onUpdateEvent
        },
        {
            type: 'dragleave',
            listener (event) {
                if (!(0, _isLeavingWindow.isLeavingWindow)({
                    dragLeave: event
                })) return;
                /**
					 * At this point we don't know if a drag is being cancelled,
					 * or if a drag is leaving the `window`.
					 *
					 * Both have:
					 *   1. "dragleave" (with `relatedTarget: null`)
					 *   2. "dragend" (a "dragend" can occur when outside the `window`)
					 *
					 * **Clearing drop targets**
					 *
					 * For either case we are clearing the the drop targets
					 *
					 * - cancelling: we clear drop targets in `"dragend"` anyway
					 * - leaving the `window`: we clear the drop targets (to clear stickiness)
					 *
					 * **Leaving the window and finishing the drag**
					 *
					 * _internal drags_
					 *
					 * - The drag continues when the user is outside the `window`
					 *   and can resume if the user drags back over the `window`,
					 *   or end when the user drops in an external `window`.
					 * - We will get a `"dragend"`, or we can listen for other
					 *   events to determine the drag is finished when the user re-enters the `window`).
					 *
					 * _external drags_
					 *
					 * - We conclude the drag operation.
					 * - We have no idea if the user will drag back over the `window`,
					 *   or if the drag ends elsewhere.
					 * - We will create a new drag if the user re-enters the `window`.
					 *
					 * **Not updating `input`**
					 *
					 * 🐛 Bug[Chrome] the final `"dragleave"` has default input values (eg `clientX == 0`)
					 * Workaround: intentionally not updating `input` in "dragleave"
					 * rather than the users current input values
					 * - [Conversation](https://twitter.com/alexandereardon/status/1642697633864241152)
					 * - [Bug](https://bugs.chromium.org/p/chromium/issues/detail?id=1429937)
					 **/ updateState({
                    input: state.current.input,
                    dropTargets: []
                });
                if (dragType.startedFrom === 'external') cancel();
            }
        },
        {
            // A "drop" can only happen if the browser allowed the drop
            type: 'drop',
            listener (event) {
                // Capture the final input.
                // We are capturing the final `input` for the
                // most accurate honey pot experience
                state.current = {
                    dropTargets: state.current.dropTargets,
                    input: (0, _getInput.getInput)(event)
                };
                /** If there are no drop targets, then we will get
					 * a "drop" event if:
					 * - `preventUnhandled()` is being used
					 * - there is an unmanaged drop target (eg another library)
					 * In these cases, it's up to the consumer
					 * to handle the drop if it's not over one of our drop targets
					 * - `preventUnhandled()` will cancel the "drop"
					 * - unmanaged drop targets can handle the "drop" how they want to
					 * We won't call `event.preventDefault()` in this call path */ if (!state.current.dropTargets.length) {
                    cancel();
                    return;
                }
                event.preventDefault();
                // applying the latest drop effect to the event
                setDropEffectOnEvent({
                    event,
                    current: state.current.dropTargets
                });
                dispatch.drop({
                    current: state.current,
                    // When dropping something native, we need to extract the latest
                    // `.items` from the "drop" event as it is now accessible
                    updatedSourcePayload: dragType.type === 'external' ? dragType.getDropPayload(event) : null
                });
                finish();
            }
        },
        {
            // "dragend" fires when on the drag source (eg a draggable element)
            // when the drag is finished.
            // "dragend" will fire after "drop" (if there was a successful drop)
            // "dragend" does not fire if the draggable source has been removed during the drag
            // or for external drag sources (eg files)
            // This "dragend" listener will not fire if there was a successful drop
            // as we will have already removed the event listener
            type: 'dragend',
            listener (event) {
                // In firefox, the position of the "dragend" event can
                // be a bit different to the last "dragover" event.
                // Updating the input so we can get the best possible
                // information for the honey pot.
                state.current = {
                    dropTargets: state.current.dropTargets,
                    input: (0, _getInput.getInput)(event)
                };
                cancel();
            }
        },
        ...(0, _detectBrokenDrag.getBindingsForBrokenDrags)({
            onDragEnd: cancel
        })
    ], // Once we have started a managed drag operation it is important that we see / own all drag events
    // We got one adoption bug pop up where some code was stopping (`event.stopPropagation()`)
    // all "drop" events in the bubble phase on the `document.body`.
    // This meant that we never saw the "drop" event.
    {
        capture: true
    });
    dispatch.start({
        nativeSetDragImage: getNativeSetDragImage(event)
    });
}
function setDropEffectOnEvent({ event, current }) {
    var _current_;
    // setting the `dropEffect` to be the innerMost drop targets dropEffect
    const innerMost = (_current_ = current[0]) === null || _current_ === void 0 ? void 0 : _current_.dropEffect;
    if (innerMost != null && event.dataTransfer) event.dataTransfer.dropEffect = innerMost;
}
function getStartLocation({ event, dragType, getDropTargetsOver }) {
    const input = (0, _getInput.getInput)(event);
    // When dragging from outside of the browser,
    // the drag is not being sourced from any local drop targets
    if (dragType.startedFrom === 'external') return {
        input,
        dropTargets: []
    };
    const dropTargets = getDropTargetsOver({
        input,
        source: dragType.payload,
        target: event.target,
        current: []
    });
    return {
        input,
        dropTargets
    };
}
const lifecycle = {
    canStart,
    start
};

},{"bind-event-listener":"bjeUU","../honey-pot-fix/get-element-from-point-without-honey-pot":"wrUOA","../honey-pot-fix/is-honey-pot-element":"hLRwJ","../util/changing-window/is-leaving-window":"9P9Dv","../util/detect-broken-drag":"lnhQK","../util/get-input":"6VCD0","./dispatch-consumer-event":"9FvZx","@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"9P9Dv":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "isLeavingWindow", ()=>isLeavingWindow);
var _isFirefox = require("../is-firefox");
var _isSafari = require("../is-safari");
var _countEventsForSafari = require("./count-events-for-safari");
var _isFromAnotherWindow = require("./is-from-another-window");
function isLeavingWindow({ dragLeave }) {
    const { type, relatedTarget } = dragLeave;
    if (type !== 'dragleave') return false;
    if ((0, _isSafari.isSafari)()) return (0, _countEventsForSafari.isLeavingWindowInSafari)({
        dragLeave
    });
    // Standard check: if going to `null` we are leaving the `window`
    if (relatedTarget == null) return true;
    /**
	 * 🦊 Exception: `iframe` in Firefox (`125.0`)
	 *
	 * Case 1: parent `window` → child `iframe`
	 * `dragLeave.relatedTarget` is element _inside_ the child `iframe`
	 * (foreign element)
	 *
	 * Case 2: child `iframe` → parent `window`
	 * `dragLeave.relatedTarget` is the `iframe` in the parent `window`
	 * (foreign element)
	 */ if ((0, _isFirefox.isFirefox)()) return (0, _isFromAnotherWindow.isFromAnotherWindow)(relatedTarget);
    /**
	 * 🌏 Exception: `iframe` in Chrome (`124.0`)
	 *
	 * Case 1: parent `window` → child `iframe`
	 * `dragLeave.relatedTarget` is the `iframe` in the parent `window`
	 *
	 * Case 2: child `iframe` → parent `window`
	 * `dragLeave.relatedTarget` is `null` *(standard check)*
	 */ // Case 2
    // Using `instanceof` check as the element will be in the same `window`
    return relatedTarget instanceof HTMLIFrameElement;
}

},{"../is-firefox":"RFJAG","../is-safari":"aK4YW","./count-events-for-safari":"bJiiQ","./is-from-another-window":"fDcoq","@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"RFJAG":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "isFirefox", ()=>isFirefox);
var _once = require("../public-utils/once");
const isFirefox = (0, _once.once)(function isFirefox() {
    return navigator.userAgent.includes('Firefox');
});

},{"../public-utils/once":"qagbq","@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"aK4YW":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "isSafari", ()=>isSafari);
var _once = require("../public-utils/once");
const isSafari = (0, _once.once)(function isSafari() {
    const { userAgent } = navigator;
    return userAgent.includes('AppleWebKit') && !userAgent.includes('Chrome');
});

},{"../public-utils/once":"qagbq","@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"bJiiQ":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "isEnteringWindowInSafari", ()=>isEnteringWindowInSafari);
// eslint-disable-next-line @atlaskit/volt-strict-mode/no-multiple-exports
parcelHelpers.export(exports, "isLeavingWindowInSafari", ()=>isLeavingWindowInSafari);
var _bindEventListener = require("bind-event-listener");
var _isSafari = require("../is-safari");
/* For "dragenter" events, the browser should set `relatedTarget` to the previous element.
 * For external drag operations, our first "dragenter" event should have a `event.relatedTarget` of `null`.
 *
 *  Unfortunately in Safari `event.relatedTarget` is *always* set to `null`
 *  Safari bug: https://bugs.webkit.org/show_bug.cgi?id=242627
 *  To work around this we count "dragenter" and "dragleave" events */ // Using symbols for event properties so we don't clash with
// anything on the `event` object
const symbols = {
    isLeavingWindow: Symbol('leaving'),
    isEnteringWindow: Symbol('entering')
};
function isEnteringWindowInSafari({ dragEnter }) {
    if (!(0, _isSafari.isSafari)()) return false;
    return dragEnter.hasOwnProperty(symbols.isEnteringWindow);
}
function isLeavingWindowInSafari({ dragLeave }) {
    if (!(0, _isSafari.isSafari)()) return false;
    return dragLeave.hasOwnProperty(symbols.isLeavingWindow);
}
(function fixSafari() {
    // Don't do anything when server side rendering
    if (typeof window === 'undefined') return;
    if (!(0, _isSafari.isSafari)()) return;
    function getInitialState() {
        return {
            enterCount: 0,
            isOverWindow: false
        };
    }
    let state = getInitialState();
    function resetState() {
        state = getInitialState();
    }
    // These event listeners are bound _forever_ and _never_ removed
    // We don't bother cleaning up these event listeners (for now)
    // as this workaround is only for Safari
    // This is how the event count works:
    //
    // lift (+1 enterCount)
    // - dragstart(draggable) [enterCount: 0]
    // - dragenter(draggable) [enterCount: 1]
    // leaving draggable (+0 enterCount)
    // - dragenter(document.body) [enterCount: 2]
    // - dragleave(draggable) [enterCount: 1]
    // leaving window (-1 enterCount)
    // - dragleave(document.body) [enterCount: 0] {leaving the window}
    // Things to note:
    // - dragenter and dragleave bubble
    // - the first dragenter when entering a window might not be on `window`
    //   - it could be on an element that is pressed up against the window
    //   - (so we cannot rely on `event.target` values)
    (0, _bindEventListener.bindAll)(window, [
        {
            type: 'dragstart',
            listener: ()=>{
                state.enterCount = 0;
                // drag start occurs in the source window
                state.isOverWindow = true;
            // When a drag first starts it will also trigger a "dragenter" on the draggable element
            }
        },
        {
            type: 'drop',
            listener: resetState
        },
        {
            type: 'dragend',
            listener: resetState
        },
        {
            type: 'dragenter',
            listener: (event)=>{
                if (!state.isOverWindow && state.enterCount === 0) // Patching the `event` object
                // The `event` object is shared with all event listeners for the event
                event[symbols.isEnteringWindow] = true;
                state.isOverWindow = true;
                state.enterCount++;
            }
        },
        {
            type: 'dragleave',
            listener: (event)=>{
                state.enterCount--;
                if (state.isOverWindow && state.enterCount === 0) {
                    // Patching the `event` object as it is shared with all event listeners
                    // The `event` object is shared with all event listeners for the event
                    event[symbols.isLeavingWindow] = true;
                    state.isOverWindow = false;
                }
            }
        }
    ], // using `capture: true` so that adding event listeners
    // in bubble phase will have the correct symbols
    {
        capture: true
    });
})();

},{"bind-event-listener":"bjeUU","../is-safari":"aK4YW","@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"fDcoq":[function(require,module,exports,__globalThis) {
/**
 * Does the `EventTarget` look like a `Node` based on "duck typing".
 *
 * Helpful when the `Node` might be outside of the current document
 * so we cannot to an `target instanceof Node` check.
 */ var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
/**
 * Is an `EventTarget` a `Node` from another `window`?
 */ parcelHelpers.export(exports, "isFromAnotherWindow", ()=>isFromAnotherWindow);
function isNodeLike(target) {
    return 'nodeName' in target;
}
function isFromAnotherWindow(eventTarget) {
    return isNodeLike(eventTarget) && eventTarget.ownerDocument !== document;
}

},{"@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"lnhQK":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "getBindingsForBrokenDrags", ()=>getBindingsForBrokenDrags);
function getBindingsForBrokenDrags({ onDragEnd }) {
    return [
        // ## Detecting drag ending for removed draggables
        //
        // If a draggable element is removed during a drag and the user drops:
        // 1. if over a valid drop target: we get a "drop" event to know the drag is finished
        // 2. if not over a valid drop target (or cancelled): we get nothing
        // The "dragend" event will not fire on the source draggable if it has been
        // removed from the DOM.
        // So we need to figure out if a drag operation has finished by looking at other events
        // We can do this by looking at other events
        // ### First detection: "pointermove" events
        // 1. "pointermove" events cannot fire during a drag and drop operation
        // according to the spec. So if we get a "pointermove" it means that
        // the drag and drop operations has finished. So if we get a "pointermove"
        // we know that the drag is over
        // 2. 🦊😤 Drag and drop operations are _supposed_ to suppress
        // other pointer events. However, firefox will allow a few
        // pointer event to get through after a drag starts.
        // The most I've seen is 3
        {
            type: 'pointermove',
            listener: (()=>{
                let callCount = 0;
                return function listener() {
                    // Using 20 as it is far bigger than the most observed (3)
                    if (callCount < 20) {
                        callCount++;
                        return;
                    }
                    onDragEnd();
                };
            })()
        },
        // ### Second detection: "pointerdown" events
        // If we receive this event then we know that a drag operation has finished
        // and potentially another one is about to start.
        // Note: `pointerdown` fires on all browsers / platforms before "dragstart"
        {
            type: 'pointerdown',
            listener: onDragEnd
        }
    ];
}

},{"@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"6VCD0":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "getInput", ()=>getInput);
function getInput(event) {
    return {
        altKey: event.altKey,
        button: event.button,
        buttons: event.buttons,
        ctrlKey: event.ctrlKey,
        metaKey: event.metaKey,
        shiftKey: event.shiftKey,
        clientX: event.clientX,
        clientY: event.clientY,
        pageX: event.pageX,
        pageY: event.pageY
    };
}

},{"@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"9FvZx":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "makeDispatch", ()=>makeDispatch);
var _rafSchd = require("raf-schd");
var _rafSchdDefault = parcelHelpers.interopDefault(_rafSchd);
const scheduleOnDrag = (0, _rafSchdDefault.default)((fn)=>fn());
const dragStart = (()=>{
    let scheduled = null;
    function schedule(fn) {
        const frameId = requestAnimationFrame(()=>{
            scheduled = null;
            fn();
        });
        scheduled = {
            frameId: frameId,
            fn
        };
    }
    function flush() {
        if (scheduled) {
            cancelAnimationFrame(scheduled.frameId);
            scheduled.fn();
            scheduled = null;
        }
    }
    return {
        schedule,
        flush
    };
})();
function makeDispatch({ source, initial, dispatchEvent }) {
    let previous = {
        dropTargets: []
    };
    function safeDispatch(args) {
        dispatchEvent(args);
        previous = {
            dropTargets: args.payload.location.current.dropTargets
        };
    }
    const dispatch = {
        start ({ nativeSetDragImage }) {
            // Ensuring that both `onGenerateDragPreview` and `onDragStart` get the same location.
            // We do this so that `previous` is`[]` in `onDragStart` (which is logical)
            const location = {
                current: initial,
                previous,
                initial
            };
            // a `onGenerateDragPreview` does _not_ add another entry for `previous`
            // onDragPreview
            safeDispatch({
                eventName: 'onGenerateDragPreview',
                payload: {
                    source,
                    location,
                    nativeSetDragImage
                }
            });
            dragStart.schedule(()=>{
                safeDispatch({
                    eventName: 'onDragStart',
                    payload: {
                        source,
                        location
                    }
                });
            });
        },
        dragUpdate ({ current }) {
            dragStart.flush();
            scheduleOnDrag.cancel();
            safeDispatch({
                eventName: 'onDropTargetChange',
                payload: {
                    source,
                    location: {
                        initial,
                        previous,
                        current
                    }
                }
            });
        },
        drag ({ current }) {
            scheduleOnDrag(()=>{
                dragStart.flush();
                const location = {
                    initial,
                    previous,
                    current
                };
                safeDispatch({
                    eventName: 'onDrag',
                    payload: {
                        source,
                        location
                    }
                });
            });
        },
        drop ({ current, updatedSourcePayload }) {
            dragStart.flush();
            scheduleOnDrag.cancel();
            safeDispatch({
                eventName: 'onDrop',
                payload: {
                    source: updatedSourcePayload !== null && updatedSourcePayload !== void 0 ? updatedSourcePayload : source,
                    location: {
                        current,
                        previous,
                        initial
                    }
                }
            });
        }
    };
    return dispatch;
}

},{"raf-schd":"oiTmD","@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"d1yti":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "register", ()=>register);
const ledger = new Map();
function registerUsage({ typeKey, mount }) {
    const entry = ledger.get(typeKey);
    if (entry) {
        entry.usageCount++;
        return entry;
    }
    const initial = {
        typeKey,
        unmount: mount(),
        usageCount: 1
    };
    ledger.set(typeKey, initial);
    return initial;
}
function register(args) {
    const entry = registerUsage(args);
    return function unregister() {
        entry.usageCount--;
        if (entry.usageCount > 0) return;
        // Only a single usage left, remove it
        entry.unmount();
        ledger.delete(args.typeKey);
    };
}

},{"@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"1zwUb":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "makeDropTarget", ()=>makeDropTarget);
var _objectSpread = require("@swc/helpers/_/_object_spread");
var _objectSpreadProps = require("@swc/helpers/_/_object_spread_props");
var _combine = require("../public-utils/combine");
var _once = require("../public-utils/once");
var _addAttribute = require("../util/add-attribute");
function copyReverse(array) {
    return array.slice(0).reverse();
}
function makeDropTarget({ typeKey, defaultDropEffect }) {
    const registry = new WeakMap();
    const dropTargetDataAtt = `data-drop-target-for-${typeKey}`;
    const dropTargetSelector = `[${dropTargetDataAtt}]`;
    function addToRegistry(args) {
        registry.set(args.element, args);
        return ()=>registry.delete(args.element);
    }
    function dropTargetForConsumers(args) {
        const cleanup = (0, _combine.combine)((0, _addAttribute.addAttribute)(args.element, {
            attribute: dropTargetDataAtt,
            value: 'true'
        }), addToRegistry(args));
        // Wrapping in `once` to prevent unexpected side effects if consumers call
        // the clean up function multiple times.
        return (0, _once.once)(cleanup);
    }
    function getActualDropTargets({ source, target, input, result = [] }) {
        var _args_getData, _args_getDropEffect;
        if (target == null) return result;
        if (!(target instanceof Element)) {
            // For "text-selection" drags, the original `target`
            // is not an `Element`, so we need to start looking from
            // the parent element
            if (target instanceof Node) return getActualDropTargets({
                source,
                target: target.parentElement,
                input,
                result
            });
            // not sure what we are working with,
            // so we can exit.
            return result;
        }
        const closest = target.closest(dropTargetSelector);
        // Cannot find anything else
        if (closest == null) return result;
        const args = registry.get(closest);
        // error: something had a dropTargetSelector but we could not
        // find a match. For now, failing silently
        if (args == null) return result;
        const feedback = {
            input,
            source,
            element: args.element
        };
        // if dropping is not allowed, skip this drop target
        // and continue looking up the DOM tree
        if (args.canDrop && !args.canDrop(feedback)) return getActualDropTargets({
            source,
            target: args.element.parentElement,
            input,
            result
        });
        var _args_getData1;
        // calculate our new record
        const data = (_args_getData1 = (_args_getData = args.getData) === null || _args_getData === void 0 ? void 0 : _args_getData.call(args, feedback)) !== null && _args_getData1 !== void 0 ? _args_getData1 : {};
        var _args_getDropEffect1;
        const dropEffect = (_args_getDropEffect1 = (_args_getDropEffect = args.getDropEffect) === null || _args_getDropEffect === void 0 ? void 0 : _args_getDropEffect.call(args, feedback)) !== null && _args_getDropEffect1 !== void 0 ? _args_getDropEffect1 : defaultDropEffect;
        const record = {
            data,
            element: args.element,
            dropEffect,
            // we are collecting _actual_ drop targets, so these are
            // being applied _not_ due to stickiness
            isActiveDueToStickiness: false
        };
        return getActualDropTargets({
            source,
            target: args.element.parentElement,
            input,
            // Using bubble ordering. Same ordering as `event.getPath()`
            result: [
                ...result,
                record
            ]
        });
    }
    function notifyCurrent({ eventName, payload }) {
        for (const record of payload.location.current.dropTargets){
            var _entry_eventName;
            const entry = registry.get(record.element);
            const args = (0, _objectSpreadProps._)((0, _objectSpread._)({}, payload), {
                self: record
            });
            entry === null || entry === void 0 ? void 0 : (_entry_eventName = entry[eventName]) === null || _entry_eventName === void 0 ? void 0 : _entry_eventName.call(entry, // I cannot seem to get the types right here.
            // TS doesn't seem to like that one event can need `nativeSetDragImage`
            // @ts-expect-error
            args);
        }
    }
    const actions = {
        onGenerateDragPreview: notifyCurrent,
        onDrag: notifyCurrent,
        onDragStart: notifyCurrent,
        onDrop: notifyCurrent,
        onDropTargetChange: ({ payload })=>{
            const isCurrent = new Set(payload.location.current.dropTargets.map((record)=>record.element));
            const visited = new Set();
            for (const record of payload.location.previous.dropTargets){
                var _entry_onDropTargetChange, _entry_onDragLeave;
                visited.add(record.element);
                const entry = registry.get(record.element);
                const isOver = isCurrent.has(record.element);
                const args = (0, _objectSpreadProps._)((0, _objectSpread._)({}, payload), {
                    self: record
                });
                entry === null || entry === void 0 ? void 0 : (_entry_onDropTargetChange = entry.onDropTargetChange) === null || _entry_onDropTargetChange === void 0 ? void 0 : _entry_onDropTargetChange.call(entry, args);
                // if we cannot find the drop target in the current array, then it has been left
                if (!isOver) entry === null || entry === void 0 ? void 0 : (_entry_onDragLeave = entry.onDragLeave) === null || _entry_onDragLeave === void 0 ? void 0 : _entry_onDragLeave.call(entry, args);
            }
            for (const record of payload.location.current.dropTargets){
                var _entry_onDropTargetChange1, _entry_onDragEnter;
                // already published an update to this drop target
                if (visited.has(record.element)) continue;
                // at this point we have a new drop target that is being entered into
                const args = (0, _objectSpreadProps._)((0, _objectSpread._)({}, payload), {
                    self: record
                });
                const entry = registry.get(record.element);
                entry === null || entry === void 0 ? void 0 : (_entry_onDropTargetChange1 = entry.onDropTargetChange) === null || _entry_onDropTargetChange1 === void 0 ? void 0 : _entry_onDropTargetChange1.call(entry, args);
                entry === null || entry === void 0 ? void 0 : (_entry_onDragEnter = entry.onDragEnter) === null || _entry_onDragEnter === void 0 ? void 0 : _entry_onDragEnter.call(entry, args);
            }
        }
    };
    function dispatchEvent(args) {
        actions[args.eventName](args);
    }
    function getIsOver({ source, target, input, current }) {
        const actual = getActualDropTargets({
            source,
            target,
            input
        });
        // stickiness is only relevant when we have less
        // drop targets than we did before
        if (actual.length >= current.length) return actual;
        // less 'actual' drop targets than before,
        // we need to see if 'stickiness' applies
        // An old drop target will continue to be dropped on if:
        // 1. it has the same parent
        // 2. nothing exists in it's previous index
        const lastCaptureOrdered = copyReverse(current);
        const actualCaptureOrdered = copyReverse(actual);
        const resultCaptureOrdered = [];
        for(let index = 0; index < lastCaptureOrdered.length; index++){
            var _argsForLast_getIsSticky;
            const last = lastCaptureOrdered[index];
            const fresh = actualCaptureOrdered[index];
            // if a record is in the new index -> use that
            // it will have the latest data + dropEffect
            if (fresh != null) {
                resultCaptureOrdered.push(fresh);
                continue;
            }
            // At this point we have no drop target in the old spot
            // Check to see if we can use a previous sticky drop target
            // The "parent" is the one inside of `resultCaptureOrdered`
            // (the parent might be a drop target that was sticky)
            const parent = resultCaptureOrdered[index - 1];
            const lastParent = lastCaptureOrdered[index - 1];
            // Stickiness is based on parent relationships, so if the parent relationship has change
            // then we can stop our search
            if ((parent === null || parent === void 0 ? void 0 : parent.element) !== (lastParent === null || lastParent === void 0 ? void 0 : lastParent.element)) break;
            // We need to check whether the old drop target can still be dropped on
            const argsForLast = registry.get(last.element);
            // We cannot drop on a drop target that is no longer mounted
            if (!argsForLast) break;
            const feedback = {
                input,
                source,
                element: argsForLast.element
            };
            // We cannot drop on a drop target that no longer allows being dropped on
            if (argsForLast.canDrop && !argsForLast.canDrop(feedback)) break;
            // We cannot drop on a drop target that is no longer sticky
            if (!((_argsForLast_getIsSticky = argsForLast.getIsSticky) === null || _argsForLast_getIsSticky === void 0 ? void 0 : _argsForLast_getIsSticky.call(argsForLast, feedback))) break;
            // Note: intentionally not recollecting `getData()` or `getDropEffect()`
            // Previous values for `data` and `dropEffect` will be borrowed
            // This is to prevent things like the 'closest edge' changing when
            // no longer over a drop target.
            // We could change our mind on this behaviour in the future
            resultCaptureOrdered.push((0, _objectSpreadProps._)((0, _objectSpread._)({}, last), {
                // making it clear to consumers this drop target is active due to stickiness
                isActiveDueToStickiness: true
            }));
        }
        // return bubble ordered result
        return copyReverse(resultCaptureOrdered);
    }
    return {
        dropTargetForConsumers,
        getIsOver,
        dispatchEvent
    };
}

},{"@swc/helpers/_/_object_spread":"9gdrV","@swc/helpers/_/_object_spread_props":"kANqQ","../public-utils/combine":"crrjo","../public-utils/once":"qagbq","../util/add-attribute":"cjZLv","@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"cjZLv":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "addAttribute", ()=>addAttribute);
function addAttribute(element, { attribute, value }) {
    element.setAttribute(attribute, value);
    return ()=>element.removeAttribute(attribute);
}

},{"@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"k012V":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "makeMonitor", ()=>makeMonitor);
var _objectSpread = require("@swc/helpers/_/_object_spread");
var _once = require("../public-utils/once");
function makeMonitor() {
    const registry = new Set();
    let dragging = null;
    function tryAddToActive(monitor) {
        if (!dragging) return;
        // Monitor is allowed to monitor events if:
        // 1. It has no `canMonitor` function (default is that a monitor can listen to everything)
        // 2. `canMonitor` returns true
        if (!monitor.canMonitor || monitor.canMonitor(dragging.canMonitorArgs)) dragging.active.add(monitor);
    }
    function monitorForConsumers(args) {
        // We are giving each `args` a new reference so that you
        // can create multiple monitors with the same `args`.
        const entry = (0, _objectSpread._)({}, args);
        registry.add(entry);
        // if there is an active drag we need to see if this new monitor is relevant
        tryAddToActive(entry);
        function cleanup() {
            registry.delete(entry);
            // We need to stop publishing events during a drag to this monitor!
            if (dragging) dragging.active.delete(entry);
        }
        // Wrapping in `once` to prevent unexpected side effects if consumers call
        // the clean up function multiple times.
        return (0, _once.once)(cleanup);
    }
    function dispatchEvent({ eventName, payload }) {
        var // @ts-expect-error: I cannot get this type working!
        _monitor_eventName;
        if (eventName === 'onGenerateDragPreview') {
            dragging = {
                canMonitorArgs: {
                    initial: payload.location.initial,
                    source: payload.source
                },
                active: new Set()
            };
            for (const monitor of registry)tryAddToActive(monitor);
        }
        // This should never happen.
        if (!dragging) return;
        // Creating an array from the set _before_ iterating
        // This is so that monitors added during the current event will not be called.
        // This behaviour matches native EventTargets where an event listener
        // cannot add another event listener during an active event to the same
        // event target in the same event (for us we have a single global event target)
        const active = Array.from(dragging.active);
        for (const monitor of active)// A monitor can be removed by another monitor during an event.
        // We need to check that the monitor is still registered before calling it
        if (dragging.active.has(monitor)) (_monitor_eventName = monitor[eventName]) === null || _monitor_eventName === void 0 ? void 0 : _monitor_eventName.call(monitor, payload);
        if (eventName === 'onDrop') {
            dragging.active.clear();
            dragging = null;
        }
    }
    return {
        dispatchEvent,
        monitorForConsumers
    };
}

},{"@swc/helpers/_/_object_spread":"9gdrV","../public-utils/once":"qagbq","@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"b4W1Q":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "isAndroid", ()=>isAndroid);
parcelHelpers.export(exports, "androidFallbackText", ()=>androidFallbackText);
var _once = require("../public-utils/once");
const isAndroid = (0, _once.once)(function isAndroid() {
    return navigator.userAgent.toLocaleLowerCase().includes('android');
});
const androidFallbackText = 'pdnd:android-fallback';

},{"../public-utils/once":"qagbq","@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"lxg8d":[function(require,module,exports,__globalThis) {
// Why we put the media types in their own files:
//
// - we are not putting them all in one file as not all adapters need all types
// - we are not putting them in the external helpers as some things just need the
//   types and not the external functions code
var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "textMediaType", ()=>textMediaType);
const textMediaType = 'text/plain';

},{"@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"8nngE":[function(require,module,exports,__globalThis) {
// Why we put the media types in their own files:
//
// - we are not putting them all in one file as not all adapters need all types
// - we are not putting them in the external helpers as some things just need the
//   types and not the external functions code
var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "URLMediaType", ()=>URLMediaType);
const URLMediaType = 'text/uri-list';

},{"@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"8X0Gb":[function(require,module,exports,__globalThis) {
/**
 * This key has been pulled into a separate module
 * so that the external adapter does not need to import
 * the element adapter
 */ var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "elementAdapterNativeDataKey", ()=>elementAdapterNativeDataKey);
const elementAdapterNativeDataKey = 'application/vnd.pdnd';

},{"@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"kiAKj":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "makeFixForAdapter", ()=>makeFixForAdapter);
var _combine = require("@atlaskit/pragmatic-drag-and-drop/combine");
/**
 * Set a `style` property on a `HTMLElement`
 *
 * @returns a `cleanup` function to restore the `style` property to it's original state
 */ function setStyle(el, { property, rule, priority = '' }) {
    const originalValue = el.style.getPropertyValue(property);
    const originalPriority = el.style.getPropertyPriority(property);
    el.style.setProperty(property, rule, priority);
    return function cleanup() {
        el.style.setProperty(property, originalValue, originalPriority);
    };
}
function hasSameOrigin(href1, href2) {
    let url1;
    let url2;
    try {
        url1 = new URL(href1);
        url2 = new URL(href2);
    } catch (e) {
        // failed to parse a href
        return false;
    }
    // https://developer.mozilla.org/en-US/docs/Web/Security/Same-origin_policy
    return url1.protocol === url2.protocol && url1.host === url2.host && url1.port === url2.port;
}
function isIframeOnAnotherDomain(iframe) {
    /**
	 * iframe with contents defined inline. Runs on the current origin.
	 * `<iframe srcdoc="<!doctype html><body>Hello</body>" />`
	 */ if (iframe.srcdoc) return false;
    /**
	 * iframe with contents defined inline. Runs on the current origin.
	 * `<iframe src={`data:text/html;charset=utf-8,${encodeURI('<!doctype html><body>Hello</body>')}`} />`
	 */ if (iframe.src.startsWith('data:')) return false;
    return !hasSameOrigin(window.location.href, iframe.src);
}
const registry = new Map();
function applyFix(watchForEndOfInteraction) {
    const iframes = Array.from(document.querySelectorAll('iframe')).filter(isIframeOnAnotherDomain);
    const cleanups = iframes.map((iframe)=>{
        let entry = registry.get(iframe);
        if (!entry) {
            entry = {
                reset: setStyle(iframe, {
                    property: 'pointer-events',
                    rule: 'none',
                    priority: 'important'
                }),
                count: 1
            };
            registry.set(iframe, entry);
        } else // pointer-events:none already applied to the iframe
        // increment how many things requested the fix
        entry.count++;
        return function cleanup() {
            entry.count--;
            if (entry.count < 1) {
                entry.reset();
                registry.delete(iframe);
            }
        };
    });
    function stop() {
        cleanupWatcher();
        (0, _combine.combine)(...cleanups)();
    }
    const cleanupWatcher = watchForEndOfInteraction({
        stop
    });
}
function makeFixForAdapter({ watchForInteractionStart, watchForInteractionEnd }) {
    let registrationCount = 0;
    let stopWatchingInteractionStart = null;
    function start() {
        applyFix(watchForInteractionEnd);
    }
    function registerUsage() {
        if (registrationCount === 0) stopWatchingInteractionStart = watchForInteractionStart({
            start
        });
        registrationCount++;
        return function unregisterUsage() {
            registrationCount--;
            if (registrationCount !== 0) return;
            stopWatchingInteractionStart === null || stopWatchingInteractionStart === void 0 ? void 0 : stopWatchingInteractionStart();
            stopWatchingInteractionStart = null;
        };
    }
    return {
        registerUsage
    };
}

},{"@atlaskit/pragmatic-drag-and-drop/combine":"b8cay","@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"EPoqu":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "disableDraggingToCrossOriginIFramesForExternal", ()=>disableDraggingToCrossOriginIFramesForExternal);
var _adapter = require("@atlaskit/pragmatic-drag-and-drop/external/adapter");
var _makeFixForAdapter = require("./make-fix-for-adapter");
function watchForInteractionStart({ start }) {
    return (0, _adapter.monitorForExternal)({
        onDragStart () {
            start();
        }
    });
}
function watchForInteractionEnd({ stop }) {
    return (0, _adapter.monitorForExternal)({
        onDrop () {
            stop();
        }
    });
}
const api = (0, _makeFixForAdapter.makeFixForAdapter)({
    watchForInteractionStart,
    watchForInteractionEnd
});
function disableDraggingToCrossOriginIFramesForExternal() {
    return api.registerUsage();
}

},{"@atlaskit/pragmatic-drag-and-drop/external/adapter":"90x56","./make-fix-for-adapter":"kiAKj","@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"90x56":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "monitorForExternal", ()=>(0, _externalAdapter.monitorForExternal));
parcelHelpers.export(exports, "dropTargetForExternal", ()=>(0, _externalAdapter.dropTargetForExternal));
var _externalAdapter = require("../../adapter/external-adapter");

},{"../../adapter/external-adapter":"8irFv","@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"8irFv":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "isAnAvailableType", ()=>isAnAvailableType);
// eslint-disable-next-line @atlaskit/volt-strict-mode/no-multiple-exports
parcelHelpers.export(exports, "getAvailableTypes", ()=>getAvailableTypes);
// eslint-disable-next-line @atlaskit/volt-strict-mode/no-multiple-exports
parcelHelpers.export(exports, "getAvailableItems", ()=>getAvailableItems);
// eslint-disable-next-line @atlaskit/volt-strict-mode/no-multiple-exports
parcelHelpers.export(exports, "dropTargetForExternal", ()=>dropTargetForExternal);
// eslint-disable-next-line @atlaskit/volt-strict-mode/no-multiple-exports
parcelHelpers.export(exports, "monitorForExternal", ()=>monitorForExternal);
var _bindEventListener = require("bind-event-listener");
var _makeAdapter = require("../make-adapter/make-adapter");
var _android = require("../util/android");
var _isEnteringWindow = require("../util/changing-window/is-entering-window");
var _detectBrokenDrag = require("../util/detect-broken-drag");
var _textMediaType = require("../util/media-types/text-media-type");
var _elementAdapterNativeDataKey = require("./element-adapter-native-data-key");
function isAnAvailableType({ type, value }) {
    // We don't want to expose our private elementAdapter key / value
    if (type === (0, _elementAdapterNativeDataKey.elementAdapterNativeDataKey)) return false;
    // Not exposing "text/plain" if it contains the android fallback text
    // We _could_ add an `isAndroid()` check, but it's probably safest
    // to trim this data out, regardless of what OS we see it on.
    if (type === (0, _textMediaType.textMediaType) && value === (0, _android.androidFallbackText)) return false;
    return true;
}
function getAvailableTypes(transfer) {
    return Array.from(transfer.types).filter((type)=>isAnAvailableType({
            type,
            value: transfer.getData(type)
        }));
}
function getAvailableItems(dataTransfer) {
    // item.kind is 'string' | 'file'
    // For 'string' item.type is the mimeType (eg 'text/plain')
    // For 'file' item.type is the file type (eg 'image/jpg')
    return Array.from(dataTransfer.items).filter((item)=>item.kind === 'file' || isAnAvailableType({
            type: item.type,
            value: dataTransfer.getData(item.type)
        }));
}
let didDragStartLocally = false;
const adapter = (0, _makeAdapter.makeAdapter)({
    typeKey: 'external',
    // for external drags, we are generally making a copy of something that is being dragged
    defaultDropEffect: 'copy',
    mount (api) {
        // Binding to the `window` so that the element adapter
        // has a chance to get in first on the`document`.
        // We are giving preference to the element adapter.
        return (0, _bindEventListener.bind)(window, {
            type: 'dragenter',
            listener (event) {
                // drag operation was started within the document, it won't be an "external" drag
                if (didDragStartLocally) return;
                // Note: not checking if event was cancelled (`event.defaultPrevented`) as
                // cancelling a "dragenter" accepts the drag operation (not prevent it)
                // Something has gone wrong with our drag event
                if (!event.dataTransfer) return;
                if (!api.canStart(event)) return;
                if (!(0, _isEnteringWindow.isEnteringWindow)({
                    dragEnter: event
                })) return;
                // Note: not checking types for `elementAdapterNativeDataKey` as we expect to see that
                // key when pdnd started the drag in another document
                const types = getAvailableTypes(event.dataTransfer);
                if (!types.length) return;
                const locked = {
                    types,
                    items: [],
                    getStringData: ()=>null
                };
                api.start({
                    event,
                    dragType: {
                        type: 'external',
                        startedFrom: 'external',
                        payload: locked,
                        getDropPayload (event) {
                            // this would be a platform error
                            // trying to handle it gracefully rather than throwing (for now)
                            if (!event.dataTransfer) return locked;
                            const items = getAvailableItems(event.dataTransfer);
                            // need to use `.bind` as `getData` is required
                            // to be run with `event.dataTransfer` as the "this" context
                            const nativeGetData = event.dataTransfer.getData.bind(event.dataTransfer);
                            return {
                                types,
                                items,
                                // return `null` if there is no result, otherwise string
                                getStringData (mediaType) {
                                    // not dragging the requested type
                                    // return `null` (no result)
                                    if (!types.includes(mediaType)) return null;
                                    // nativeGetData will return `""` when there is no value,
                                    // but at this point we know we will only get explicitly set
                                    // values back as we have checked the `types`.
                                    // `""` can be an explicitly set value.
                                    const value = nativeGetData(mediaType);
                                    // not exposing data for unavailable types
                                    if (!isAnAvailableType({
                                        type: mediaType,
                                        value
                                    })) return null;
                                    return value;
                                }
                            };
                        }
                    }
                });
            }
        });
    }
});
function dropTargetForExternal(args) {
    // not removing unused events, just leaning on the type system
    return adapter.dropTarget(args);
}
function monitorForExternal(args) {
    // not removing unused events, just leaning on the type system
    return adapter.monitor(args);
}
(function startup() {
    // server side rendering check
    if (typeof window === 'undefined') return;
    // A shared single usage registration as we want to capture
    // all external drag operations, even if there are no drop targets
    // on the page yet
    adapter.registerUsage();
    // independent of pdnd, we need to keep track of
    // all drag operations so that we can know if a drag operation
    // has started locally
    const idle = {
        type: 'idle'
    };
    let state = idle;
    function clear() {
        if (state.type !== 'dragging') return;
        didDragStartLocally = false;
        state.cleanup();
        state = idle;
    }
    function bindEndEvents() {
        return (0, _bindEventListener.bindAll)(window, [
            {
                type: 'dragend',
                listener: clear
            },
            ...(0, _detectBrokenDrag.getBindingsForBrokenDrags)({
                onDragEnd: clear
            })
        ], // we want to make sure we get all the events,
        // and this helps avoid not seeing events when folks stop
        // them later on the event path
        {
            capture: true
        });
    }
    // we always keep this event listener active
    (0, _bindEventListener.bind)(window, {
        type: 'dragstart',
        listener () {
            // something bad has happened if this is true!
            if (state.type !== 'idle') return;
            // set our global flag
            didDragStartLocally = true;
            state = {
                type: 'dragging',
                cleanup: bindEndEvents()
            };
        },
        // binding in the capture phase so these listeners are called
        // before our listeners in the adapters `mount` function
        options: {
            capture: true
        }
    });
})();

},{"bind-event-listener":"bjeUU","../make-adapter/make-adapter":"hBkue","../util/android":"b4W1Q","../util/changing-window/is-entering-window":"bC8Tb","../util/detect-broken-drag":"lnhQK","../util/media-types/text-media-type":"lxg8d","./element-adapter-native-data-key":"8X0Gb","@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"bC8Tb":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "isEnteringWindow", ()=>isEnteringWindow);
var _isFirefox = require("../is-firefox");
var _isSafari = require("../is-safari");
var _countEventsForSafari = require("./count-events-for-safari");
var _isFromAnotherWindow = require("./is-from-another-window");
function isEnteringWindow({ dragEnter }) {
    const { type, relatedTarget } = dragEnter;
    if (type !== 'dragenter') return false;
    if ((0, _isSafari.isSafari)()) return (0, _countEventsForSafari.isEnteringWindowInSafari)({
        dragEnter
    });
    // standard check
    if (relatedTarget == null) return true;
    /**
	 * 🦊 Exception: `iframe` in Firefox (`125.0`)
	 *
	 * Case 1: parent `window` → child `iframe`
	 * `relatedTarget` is the `iframe` element in the parent `window`
	 * (foreign element)
	 *
	 * Case 2: child `iframe` → parent `window`
	 * `relatedTarget` is an element inside the child `iframe`
	 * (foreign element)
	 */ if ((0, _isFirefox.isFirefox)()) return (0, _isFromAnotherWindow.isFromAnotherWindow)(relatedTarget);
    /**
	 * 🌏 Exception: `iframe` in Chrome (`124.0`)
	 *
	 * Case 1: parent `window` → child `iframe`
	 * `relatedTarget` is `null` *(standard check)*
	 *
	 * Case 2: child `iframe` → parent `window`
	 * `relatedTarget` is the `iframe` element in the parent `window`
	 */ // Case 2
    // Using `instanceof` check as the element will be in the same `window`
    return relatedTarget instanceof HTMLIFrameElement;
}

},{"../is-firefox":"RFJAG","../is-safari":"aK4YW","./count-events-for-safari":"bJiiQ","./is-from-another-window":"fDcoq","@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"h9Beu":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "disableDraggingToCrossOriginIFramesForTextSelection", ()=>disableDraggingToCrossOriginIFramesForTextSelection);
var _bindEventListener = require("bind-event-listener");
var _combine = require("@atlaskit/pragmatic-drag-and-drop/combine");
var _adapter = require("@atlaskit/pragmatic-drag-and-drop/text-selection/adapter");
var _makeFixForAdapter = require("./make-fix-for-adapter");
function watchForInteractionEnd({ stop }) {
    let isDragging = false;
    function stopIfNotDragging() {
        if (isDragging) return;
        stop();
    }
    let frameId = null;
    const unbindEvents = (0, _bindEventListener.bindAll)(window, [
        {
            // User is starting another interaction
            type: 'pointerdown',
            listener: stop
        },
        {
            // User did not start a drag.
            // "pointerdown" won't be fired if a drag started
            type: 'pointerup',
            listener: stopIfNotDragging
        },
        {
            type: 'dragstart',
            listener () {
                /**
					 * The pdnd `onDragStart()` fires in the frame after "dragstart"
					 * So we are delaying our isDragging check to give a chance
					 * for `onDragStart()` to set the value correctly.
					 *
					 * Note: could not use "pointercancel" as it is not
					 * published in Safari → https://bugs.webkit.org/show_bug.cgi?id=222632
					 */ frameId = requestAnimationFrame(()=>{
                    frameId = null;
                    stopIfNotDragging();
                });
            },
            // need to schedule our frame after the text-selection
            // adapter queues it's `onDragStart` frame.
            options: {
                capture: false
            }
        }
    ], {
        // Listening in the capture phase to increase resilience
        // against events being stopped.
        capture: true,
        // being super clear these should only run once
        once: true
    });
    const unbindMonitor = (0, _adapter.monitorForTextSelection)({
        onDragStart () {
            isDragging = true;
        },
        onDrop () {
            isDragging = false;
            stop();
        }
    });
    return (0, _combine.combine)(unbindEvents, unbindMonitor, function abortFrame() {
        if (frameId != null) cancelAnimationFrame(frameId);
    });
}
function watchForInteractionStart({ start }) {
    return (0, _bindEventListener.bind)(window, {
        // Note: Using "mousedown" rather than "pointerdown" due to a Safari bug.
        // Safari not publish a "pointerdown" on the interaction after a drag
        // → https://bugs.webkit.org/show_bug.cgi?id=279749
        type: 'mousedown',
        listener () {
            // A text selection drag will only start when there is
            // an active text selection.
            const selection = window.getSelection();
            // No selection object found
            if (!selection) return;
            // `isCollapsed` is "true" if there is currently no selected text
            if (selection.isCollapsed) return;
            start();
        }
    });
}
const api = (0, _makeFixForAdapter.makeFixForAdapter)({
    watchForInteractionStart,
    watchForInteractionEnd
});
function disableDraggingToCrossOriginIFramesForTextSelection() {
    return api.registerUsage();
}

},{"bind-event-listener":"bjeUU","@atlaskit/pragmatic-drag-and-drop/combine":"b8cay","@atlaskit/pragmatic-drag-and-drop/text-selection/adapter":"km0EJ","./make-fix-for-adapter":"kiAKj","@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"km0EJ":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "monitorForTextSelection", ()=>(0, _textSelectionAdapter.monitorForTextSelection));
parcelHelpers.export(exports, "dropTargetForTextSelection", ()=>(0, _textSelectionAdapter.dropTargetForTextSelection));
var _textSelectionAdapter = require("../../adapter/text-selection-adapter");

},{"../../adapter/text-selection-adapter":"TXW1L","@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"TXW1L":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "dropTargetForTextSelection", ()=>dropTargetForTextSelection);
// eslint-disable-next-line @atlaskit/volt-strict-mode/no-multiple-exports
parcelHelpers.export(exports, "monitorForTextSelection", ()=>monitorForTextSelection);
var _bindEventListener = require("bind-event-listener");
var _makeHoneyPotFix = require("../honey-pot-fix/make-honey-pot-fix");
var _makeAdapter = require("../make-adapter/make-adapter");
var _combine = require("../public-utils/combine");
var _isSafari = require("../util/is-safari");
var _htmlMediaType = require("../util/media-types/html-media-type");
var _textMediaType = require("../util/media-types/text-media-type");
var _elementAdapterNativeDataKey = require("./element-adapter-native-data-key");
function findTextNode(event) {
    var _event_dataTransfer;
    // Standard: the `event.target` should be the closest `Text` node.
    if (event.target instanceof Text) return event.target;
    // Structuring things this way so that if Safari fixes their bug
    // then the standard check will start working
    if (!(0, _isSafari.isSafari)()) return null;
    /**
	 * According to the spec, `event.target` should be the `Text` node that
	 * the drag started from when dragging a text selection.
	 *
	 * → https://html.spec.whatwg.org/multipage/dnd.html#drag-and-drop-processing-model
	 *
	 * However, in Safari the closest `HTMLElement` is returned.
	 * So we need to figure out if text is dragging ourselves.
	 *
	 * → https://bugs.webkit.org/show_bug.cgi?id=268959
	 */ if (!(event.target instanceof HTMLElement)) return null;
    // Unlikely that this particular drag is a text selection drag
    if (event.target.draggable) return null;
    // if the drag contains no text data, then not dragging selected text
    // return `null` if there is no dataTransfer, or if `getData()` returns ""
    if (!((_event_dataTransfer = event.dataTransfer) === null || _event_dataTransfer === void 0 ? void 0 : _event_dataTransfer.getData((0, _textMediaType.textMediaType)))) return null;
    /**
	 * Grab the first Text node and use that.
	 * Only doing a single level search as that is all we need for this bug.
	 */ const text = Array.from(event.target.childNodes).find((node)=>node.nodeType === Node.TEXT_NODE);
    return text !== null && text !== void 0 ? text : null;
}
const honeyPotFix = (0, _makeHoneyPotFix.makeHoneyPotFix)();
const adapter = (0, _makeAdapter.makeAdapter)({
    typeKey: 'text-selection',
    // for text selection, we will usually be making a copy of the text
    defaultDropEffect: 'copy',
    mount (api) {
        // Binding to the `window` so that the element adapter has a
        // chance to get in first on the `document`.
        // We are giving preference to the element adapter.
        return (0, _combine.combine)(honeyPotFix.bindEvents(), (0, _bindEventListener.bind)(window, {
            type: 'dragstart',
            listener (event) {
                // If the "dragstart" event is cancelled, then a drag won't start
                // There will be no further drag operation events (eg no "dragend" event)
                if (event.defaultPrevented) return;
                // Something has gone wrong with our drag event
                if (!event.dataTransfer) return;
                // Drag is being handled by the element adapter
                if (event.dataTransfer.types.includes((0, _elementAdapterNativeDataKey.elementAdapterNativeDataKey))) return;
                // Something else is handling this drag
                if (!api.canStart(event)) return;
                // no text being dragged
                if (!event.dataTransfer.types.includes((0, _textMediaType.textMediaType))) return;
                const target = findTextNode(event);
                // could not find `Text` node that is being dragged from
                if (!target) return;
                const payload = {
                    // The `Text` node that is the `target` is the `Text` node
                    // that the user started the drag from.
                    // The full text being dragged can be looked up from the `dataTransfer`.
                    target,
                    plain: event.dataTransfer.getData((0, _textMediaType.textMediaType)),
                    HTML: event.dataTransfer.getData((0, _htmlMediaType.HTMLMediaType))
                };
                api.start({
                    event,
                    dragType: {
                        type: 'text-selection',
                        startedFrom: 'internal',
                        payload
                    }
                });
            }
        }));
    },
    onPostDispatch: honeyPotFix.getOnPostDispatch()
});
function dropTargetForTextSelection(args) {
    // note: not removing `onGenerateDragPreview`; just leaning on the type system
    return adapter.dropTarget(args);
}
// A shared single usage registration as any text can be dragged at any time
(function register() {
    // server side rendering check
    if (typeof window === 'undefined') return;
    adapter.registerUsage();
})();
function monitorForTextSelection(args) {
    // note: not removing `onGenerateDragPreview`; just leaning on the type system
    return adapter.monitor(args);
}

},{"bind-event-listener":"bjeUU","../honey-pot-fix/make-honey-pot-fix":"fxhWx","../make-adapter/make-adapter":"hBkue","../public-utils/combine":"crrjo","../util/is-safari":"aK4YW","../util/media-types/html-media-type":"3PK9A","../util/media-types/text-media-type":"lxg8d","./element-adapter-native-data-key":"8X0Gb","@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"3PK9A":[function(require,module,exports,__globalThis) {
// Why we put the media types in their own files:
//
// - we are not putting them all in one file as not all adapters need all types
// - we are not putting them in the external helpers as some things just need the
//   types and not the external functions code
var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "HTMLMediaType", ()=>HTMLMediaType);
const HTMLMediaType = 'text/html';

},{"@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"6L608":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "dialogHeight", ()=>dialogHeight);
const dialogHeight = (input)=>{
    if (!input) return 'auto';
    return typeof input === 'number' ? `${input}px` : input;
};

},{"@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"4zto0":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "dialogWidth", ()=>dialogWidth);
var _width = require("../width");
const dialogWidth = (input)=>{
    if (!input) return 'auto';
    const isWidthName = (0, _width.width).values.indexOf(input.toString()) !== -1;
    const widthName = isWidthName && input;
    if (widthName) return `${(0, _width.width).widths[widthName]}px`;
    return typeof input === 'number' ? `${input}px` : input;
};

},{"../width":"ciFjI","@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"ciFjI":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "width", ()=>width);
const width = {
    values: [
        'small',
        'medium',
        'large',
        'x-large'
    ],
    widths: {
        small: 400,
        medium: 600,
        large: 800,
        'x-large': 968
    },
    defaultValue: 'medium'
};

},{"@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"fk5M1":[function(require,module,exports,__globalThis) {
/* modal-dialog.tsx generated by @compiled/babel-plugin v0.39.1 */ var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "dialogWidth", ()=>(0, _dialogWidth.dialogWidth));
parcelHelpers.export(exports, "dialogHeight", ()=>(0, _dialogHeight.dialogHeight));
var _objectSpread = require("@swc/helpers/_/_object_spread");
var _objectSpreadProps = require("@swc/helpers/_/_object_spread_props");
var _react = require("react");
var _runtime = require("@compiled/react/runtime");
var _css = require("@atlaskit/css");
var _mergeRefs = require("@atlaskit/ds-lib/merge-refs");
var _mergeRefsDefault = parcelHelpers.interopDefault(_mergeRefs);
var _useAutoFocus = require("@atlaskit/ds-lib/use-auto-focus");
var _useAutoFocusDefault = parcelHelpers.interopDefault(_useAutoFocus);
var _useId = require("@atlaskit/ds-lib/use-id");
var _layering = require("@atlaskit/layering");
var _motion = require("@atlaskit/motion");
var _fadeIn = require("@atlaskit/motion/fade-in");
var _fadeInDefault = parcelHelpers.interopDefault(_fadeIn);
var _platformFeatureFlags = require("@atlaskit/platform-feature-flags");
var _combine = require("@atlaskit/pragmatic-drag-and-drop/combine");
var _context = require("../context");
var _useOnMotionFinish = require("../hooks/use-on-motion-finish");
var _useOnMotionFinishDefault = parcelHelpers.interopDefault(_useOnMotionFinish);
var _element = require("../pragmatic-drag-and-drop/disable-dragging-to-cross-origin-iframes/element");
var _external = require("../pragmatic-drag-and-drop/disable-dragging-to-cross-origin-iframes/external");
var _textSelection = require("../pragmatic-drag-and-drop/disable-dragging-to-cross-origin-iframes/text-selection");
var _scrollContext = require("../scroll-context");
var _dialogHeight = require("./dialog-height");
var _dialogWidth = require("./dialog-width");
var _positioner = require("./positioner");
var _positionerDefault = parcelHelpers.interopDefault(_positioner);
const LOCAL_CURRENT_SURFACE_CSS_VAR = '--ds-elevation-surface-current';
const dialogStyles = {
    root: "_16jlidpf _1o9zkb7n _i0dl1wug _1e0c1txw _1bsb1osq _p12fauwl _4t3i1osq _1tkeidpf _c71l1kxc _2lx21bp4 _bfhk1bhr _syazi7uo _1q1l1bhr _lcxv1wug _1mq81kw7 _m01u1kw7 _1dg11kw7 _mizu1v1w _1ah3dkaa _ra3xnqa1 _128mdkaa _1cvmnqa1 _4davt94y _we1i1kw7 _zg7p130s _yakv1kw7 _4lht1kw7 _1xlt6m9r",
    borderRadius: "_epkxfajl",
    borderRadiusT26Shape: "_epkxpb1k",
    motion: "_c71l1kw7 _p12f1kw7 _1e0c1txw _1jyk1jm9 _1if81osq",
    rootMotion: "_yakv1wug _4lht1wug",
    fullscreen: "_1jyk1osq"
};
const viewportScrollStyles = null;
const bodyScrollStyles = null;
const ModalDialog = /*#__PURE__*/ (0, _react.forwardRef)((props, ref)=>{
    const { width = 'medium', shouldScrollInViewport = false, shouldCloseOnEscapePress, autoFocus, stackIndex, onClose, onCloseComplete, onOpenComplete, height, hasProvidedOnClose, children, label, testId, isFullScreen = false, UNSAFE_shouldDisableMotionUplift = false } = props;
    const id = (0, _useId.useId)();
    const titleId = `modal-dialog-title-${id}`;
    const defaultTestId = testId || 'modal-dialog';
    (0, _react.useEffect)(()=>{
        // Modal dialogs can appear on top of iframe elements that are on another domain.
        // There is a Chrome bug where drag and drop in an element on top of a cross domain
        // iframe is not working. We are applying the workaround for this bug in modal so
        // that consumers of our modal don't have to worry about this bug and are free to
        // create whatever drag and drop experience they like inside a modal
        //
        // Chrome bug: https://issues.chromium.org/issues/362301053
        return (0, _combine.combine)((0, _element.disableDraggingToCrossOriginIFramesForElement)(), (0, _textSelection.disableDraggingToCrossOriginIFramesForTextSelection)(), (0, _external.disableDraggingToCrossOriginIFramesForExternal)());
    }, []);
    (0, _useAutoFocusDefault.default)(autoFocus, // When a user supplies  a ref to focus we enable this hook
    typeof autoFocus === 'object');
    const [motionRef, onMotionFinish] = (0, _useOnMotionFinishDefault.default)({
        onOpenComplete,
        onCloseComplete
    });
    const modalDialogContext = (0, _react.useMemo)(()=>({
            testId: defaultTestId,
            titleId,
            onClose,
            hasProvidedOnClose,
            isFullScreen
        }), [
        defaultTestId,
        titleId,
        onClose,
        hasProvidedOnClose,
        isFullScreen
    ]);
    (0, _layering.useCloseOnEscapePress)({
        onClose,
        isDisabled: !shouldCloseOnEscapePress
    });
    const { currentLevel } = (0, _layering.useLayering)();
    return /*#__PURE__*/ _react.createElement((0, _positionerDefault.default), {
        stackIndex: stackIndex,
        shouldScrollInViewport: shouldScrollInViewport,
        testId: defaultTestId,
        isFullScreen: isFullScreen
    }, /*#__PURE__*/ _react.createElement((0, _context.ModalContext).Provider, {
        value: modalDialogContext
    }, /*#__PURE__*/ _react.createElement((0, _scrollContext.ScrollContext).Provider, {
        value: shouldScrollInViewport
    }, !UNSAFE_shouldDisableMotionUplift && (0, _platformFeatureFlags.fg)('platform-dst-motion-uplift-modal') ? /*#__PURE__*/ _react.createElement((0, _motion.Motion), {
        enteringAnimation: "var(--ds-modal-enter, 250ms cubic-bezier(0.4, 0, 0, 1) ScaleIn95to100)",
        exitingAnimation: "var(--ds-modal-exit, 200ms cubic-bezier(0.6, 0, 0.8, 0.6) ScaleOut100to95)",
        onFinish: onMotionFinish,
        xcss: (0, _css.cx)(dialogStyles.motion, isFullScreen && dialogStyles.fullscreen),
        style: {
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
            '--modal-dialog-width': (0, _dialogWidth.dialogWidth)(width),
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
            '--modal-dialog-height': (0, _dialogHeight.dialogHeight)(height)
        }
    }, /*#__PURE__*/ _react.createElement("section", {
        "aria-label": label,
        ref: (0, _mergeRefsDefault.default)([
            motionRef,
            ref
        ]),
        style: {
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
            '--modal-dialog-width': (0, _dialogWidth.dialogWidth)(width),
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
            '--modal-dialog-height': (0, _dialogHeight.dialogHeight)(height)
        },
        role: "dialog",
        "aria-labelledby": label ? undefined : titleId,
        "data-testid": defaultTestId,
        "data-modal-stack": stackIndex,
        tabIndex: -1,
        "aria-modal": true,
        "data-ds--level": currentLevel,
        className: (0, _runtime.ax)([
            dialogStyles.root,
            dialogStyles.rootMotion,
            !isFullScreen && dialogStyles.borderRadius,
            !isFullScreen && (0, _platformFeatureFlags.fg)('platform-dst-shape-theme-default') && dialogStyles.borderRadiusT26Shape,
            shouldScrollInViewport ? "_1tke1kxc _c71lglyw _8kn617ks" : "_cbiz17ks _bolh1kw7"
        ])
    }, children)) : /*#__PURE__*/ _react.createElement((0, _fadeInDefault.default /**
                           * We don't want a 'slide in' for the full screen modals.
                           */ ), {
        entranceDirection: isFullScreen ? undefined : 'bottom',
        onFinish: onMotionFinish
    }, (bottomFadeInProps)=>/*#__PURE__*/ _react.createElement("section", (0, _objectSpreadProps._)((0, _objectSpread._)({}, bottomFadeInProps), {
            "aria-label": label,
            ref: (0, _mergeRefsDefault.default)([
                bottomFadeInProps.ref,
                motionRef,
                ref
            ]),
            style: {
                // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
                '--modal-dialog-width': (0, _dialogWidth.dialogWidth)(width),
                // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
                '--modal-dialog-height': (0, _dialogHeight.dialogHeight)(height)
            },
            className: (0, _runtime.ax)([
                dialogStyles.root,
                !isFullScreen && dialogStyles.borderRadius,
                !isFullScreen && (0, _platformFeatureFlags.fg)('platform-dst-shape-theme-default') && dialogStyles.borderRadiusT26Shape,
                shouldScrollInViewport ? "_1tke1kxc _c71lglyw _8kn617ks" : "_cbiz17ks _bolh1kw7",
                bottomFadeInProps.className
            ]),
            role: "dialog",
            "aria-labelledby": label ? undefined : titleId,
            "data-testid": defaultTestId,
            "data-modal-stack": stackIndex,
            tabIndex: -1,
            "aria-modal": true,
            "data-ds--level": currentLevel
        }), children)))));
}); // eslint-disable-next-line @repo/internal/react/require-jsdoc, @atlaskit/volt-strict-mode/no-multiple-exports
exports.default = ModalDialog;

},{"@swc/helpers/_/_object_spread":"9gdrV","@swc/helpers/_/_object_spread_props":"kANqQ","react":"ltHCL","@compiled/react/runtime":"d27Vo","@atlaskit/css":"kMGms","@atlaskit/ds-lib/merge-refs":"doPwA","@atlaskit/ds-lib/use-auto-focus":"cDep4","@atlaskit/ds-lib/use-id":"9jWCD","@atlaskit/layering":"8Owg8","@atlaskit/motion":"eg70v","@atlaskit/motion/fade-in":"5xcOv","@atlaskit/platform-feature-flags":"8rD2i","@atlaskit/pragmatic-drag-and-drop/combine":"b8cay","../context":"bBIbK","../hooks/use-on-motion-finish":"f4Kyr","../pragmatic-drag-and-drop/disable-dragging-to-cross-origin-iframes/element":"c5Im8","../pragmatic-drag-and-drop/disable-dragging-to-cross-origin-iframes/external":"EPoqu","../pragmatic-drag-and-drop/disable-dragging-to-cross-origin-iframes/text-selection":"h9Beu","../scroll-context":"5KEhV","./dialog-height":"6L608","./dialog-width":"4zto0","./positioner":"5Xv6x","@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"f4Kyr":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>useOnMotionFinish);
var _react = require("react");
function useOnMotionFinish({ onOpenComplete, onCloseComplete }) {
    const motionRef = (0, _react.useRef)(null);
    const onMotionFinish = (0, _react.useCallback)((state)=>{
        if (state === 'entering' && onOpenComplete) onOpenComplete(motionRef.current, true);
        if (state === 'exiting' && onCloseComplete) onCloseComplete(motionRef.current);
    }, [
        onOpenComplete,
        onCloseComplete
    ]);
    return [
        motionRef,
        onMotionFinish
    ];
}

},{"react":"ltHCL","@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"5Xv6x":[function(require,module,exports,__globalThis) {
/* positioner.tsx generated by @compiled/babel-plugin v0.39.1 */ var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _react = require("react");
var _runtime = require("@compiled/react/runtime");
var _curves = require("@atlaskit/motion/curves");
var _durations = require("@atlaskit/motion/durations");
// Flex and min-content are set to constrain the height of the body and support multi-column scrolling experiences
const positionerStyles = null;
const stackStyles = {
    stackTransition: "_k8m01e03 _1bumglyw _sedtglyw",
    stackTransform: "_t9ec1b95",
    stackIdle: "_t9ecglyw"
};
// Hardcoded pixels are based off a 60px base gutter
const scrollStyles = {
    viewport: "_4t3i1wug _kqswh2mm _1f6n1wqb _1eot1wug _eoawglyw",
    body: "_we1i18uh _e8uozwhf _y1k5stnw _5ee41nf8 _1urridpf _1juqidpf _yakv1wug _4lht1wug _eoawglyw",
    fullScreen: ""
};
function getScrollBehavior({ isFullScreen, shouldScrollInViewport }) {
    if (isFullScreen) return 'fullScreen';
    if (shouldScrollInViewport) return 'viewport';
    return 'body';
}
const Positioner = (props)=>{
    const { children, stackIndex, shouldScrollInViewport, testId, isFullScreen } = props;
    const scrollBehavior = getScrollBehavior({
        isFullScreen,
        shouldScrollInViewport
    });
    return /*#__PURE__*/ _react.createElement("div", {
        style: {
            '--modal-dialog-translate-y': `calc(${stackIndex}px * ${"var(--ds-space-100, 8px)"})`,
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
            transitionDuration: `${(0, _durations.durations).medium}ms`,
            // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop
            transitionTimingFunction: (0, _curves.easeInOut)
        },
        "data-testid": testId && `${testId}--positioner`,
        className: (0, _runtime.ax)([
            "_1e0c1txw _1bsb1osq _p12f1osq _4t3i1osq _kqsw1n9t _1pby16oo _2lx21bp4 _152tidpf _1e02idpf",
            stackStyles.stackTransition,
            stackIndex > 0 ? stackStyles.stackTransform : stackStyles.stackIdle,
            scrollStyles[scrollBehavior]
        ])
    }, children);
};
// eslint-disable-next-line @repo/internal/react/require-jsdoc
exports.default = Positioner;

},{"react":"ltHCL","@compiled/react/runtime":"d27Vo","@atlaskit/motion/curves":"2VzAD","@atlaskit/motion/durations":"8Uw9N","@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"2VzAD":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "easeIn", ()=>(0, _curves.easeIn));
parcelHelpers.export(exports, "easeIn40Out", ()=>(0, _curves.easeIn40Out));
parcelHelpers.export(exports, "easeIn60Out", ()=>(0, _curves.easeIn60Out));
parcelHelpers.export(exports, "easeIn80Out", ()=>(0, _curves.easeIn80Out));
parcelHelpers.export(exports, "easeInOut", ()=>(0, _curves.easeInOut));
parcelHelpers.export(exports, "easeOut", ()=>(0, _curves.easeOut));
parcelHelpers.export(exports, "linear", ()=>(0, _curves.linear));
var _curves = require("../utils/curves");

},{"../utils/curves":"7J7Ar","@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"8Uw9N":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "durationStep", ()=>(0, _durations.durationStep));
parcelHelpers.export(exports, "durations", ()=>(0, _durations.durations));
parcelHelpers.export(exports, "exitingDurations", ()=>(0, _exitingDurations.exitingDurations));
var _durations = require("../utils/durations");
var _exitingDurations = require("../utils/exiting-durations");

},{"../utils/durations":"3tpdK","../utils/exiting-durations":false,"@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"l7b47":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _exitingPersistence = require("@atlaskit/motion/exiting-persistence");
var _exitingPersistenceDefault = parcelHelpers.interopDefault(_exitingPersistence);
/**
 * __Modal transition__
 *
 * A modal transition wraps a modal to provide a fluid transition upon opening and closing.
 *
 * - [Examples](https://atlassian.design/components/modal-dialog/examples)
 * - [Code](https://atlassian.design/components/modal-dialog/code)
 * - [Usage](https://atlassian.design/components/modal-dialog/usage)
 */ const ModalTransition = (props)=>{
    var //Checking if children are undefined to prevent potential runtime errors in React 17
    _props_children;
    return /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _exitingPersistenceDefault.default), {
        appear: true
    }, (_props_children = props.children) !== null && _props_children !== void 0 ? _props_children : null);
};
exports.default = ModalTransition;

},{"react":"ltHCL","@atlaskit/motion/exiting-persistence":"ldMDz","@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"dyNqj":[function(require,module,exports,__globalThis) {
/* modal-header.tsx generated by @compiled/babel-plugin v0.39.1 */ var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _runtime = require("@compiled/react/runtime");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _compiled = require("@atlaskit/primitives/compiled");
var _closeButton = require("./close-button");
var _hooks = require("./hooks");
const styles = {
    header: "_18zr1ejb _1e0c1txw _kqswh2mm _4cvr1h6o _1bah1yb4 _6rth1i6y _85i5pxbi _1q511ejb",
    flex: "_2lx21sbv _1bsb1osq",
    titleContainer: "_1ul9idpf"
};
/**
 * __Modal header__
 *
 * A modal header contains the title of the modal and can contain other React elements such as a close button.
 *
 * - [Examples](https://atlassian.design/components/modal-dialog/examples#modal-header)
 * - [Code](https://atlassian.design/components/modal-dialog/code#modal-header-props)
 * - [Usage](https://atlassian.design/components/modal-dialog/usage)
 */ const ModalHeader = (props)=>{
    const { children, testId: userDefinedTestId, hasCloseButton = false } = props;
    const { hasProvidedOnClose, onClose, testId: modalTestId } = (0, _hooks.useModal)();
    const testId = userDefinedTestId || modalTestId && `${modalTestId}--header`;
    // Only show if an onClose was provided for the modal dialog
    const shouldShowCloseButton = hasCloseButton && hasProvidedOnClose && onClose;
    return /*#__PURE__*/ (0, _reactDefault.default).createElement("div", {
        "data-testid": testId,
        className: (0, _runtime.ax)([
            styles.header
        ])
    }, shouldShowCloseButton ? /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _compiled.Flex), {
        gap: "space.200",
        justifyContent: "space-between",
        xcss: styles.flex
    }, /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _compiled.Flex), {
        justifyContent: "end"
    }, /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _closeButton.CloseButton), {
        onClick: onClose,
        testId: modalTestId
    })), /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _compiled.Flex), {
        justifyContent: "start",
        alignItems: "center",
        xcss: styles.titleContainer
    }, children)) : children);
};
exports.default = ModalHeader;

},{"@compiled/react/runtime":"d27Vo","react":"ltHCL","@atlaskit/primitives/compiled":"hDay7","./close-button":"hDn5d","./hooks":"eTlVq","@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"hDn5d":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "CloseButton", ()=>CloseButton);
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _new = require("@atlaskit/button/new");
var _cross = require("@atlaskit/icon/core/cross");
var _crossDefault = parcelHelpers.interopDefault(_cross);
const CloseButton = ({ label, onBlur, onClick, testId })=>/*#__PURE__*/ (0, _reactDefault.default).createElement((0, _new.IconButton), {
        testId: testId && `${testId}--close-button`,
        appearance: "subtle",
        icon: (0, _crossDefault.default),
        label: label || 'Close Modal',
        onBlur: onBlur,
        onClick: onClick
    });

},{"react":"ltHCL","@atlaskit/button/new":"aXnNi","@atlaskit/icon/core/cross":"7mJX1","@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"eTlVq":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "useModal", ()=>useModal);
var _react = require("react");
var _context = require("./internal/context");
const useModal = ()=>{
    const modalContext = (0, _react.useContext)((0, _context.ModalContext));
    if (modalContext == null) throw Error("@atlaskit/modal-dialog: Modal context unavailable \u2013 this component needs to be a child of ModalDialog.");
    return modalContext;
};

},{"react":"ltHCL","./internal/context":"bBIbK","@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"eC6uv":[function(require,module,exports,__globalThis) {
/* modal-title.tsx generated by @compiled/babel-plugin v0.39.1 */ var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _react = require("react");
var _runtime = require("@compiled/react/runtime");
var _statusError = require("@atlaskit/icon/core/status-error");
var _statusErrorDefault = parcelHelpers.interopDefault(_statusError);
var _statusWarning = require("@atlaskit/icon/core/status-warning");
var _statusWarningDefault = parcelHelpers.interopDefault(_statusWarning);
var _hooks = require("./hooks");
const iconColor = {
    danger: "var(--ds-icon-danger, #C9372C)",
    warning: "var(--ds-icon-warning, #E06C00)"
};
const iconStyles = null;
const titleStyles = null;
const textStyles = null;
const truncatedTextStyles = null;
const TitleIcon = ({ appearance })=>{
    const Icon = appearance === 'danger' ? (0, _statusErrorDefault.default) : (0, _statusWarningDefault.default);
    return /*#__PURE__*/ _react.createElement("span", {
        className: (0, _runtime.ax)([
            "_16jlidpf _1o9zidpf _i0dl1wug _syaz1kw7 _1wyb1kw7 _zg8l1kw7 _k48p1kw7 _1dyz1kw7 _vwz41kw7"
        ])
    }, /*#__PURE__*/ _react.createElement(Icon, {
        label: appearance,
        color: iconColor[appearance],
        spacing: "spacious"
    }));
};
/**
 * __Modal title__
 *
 * A modal title is used to display a title within a modal.
 *
 * - [Examples](https://atlassian.design/components/modal-dialog/examples)
 * - [Code](https://atlassian.design/components/modal-dialog/code)
 * - [Usage](https://atlassian.design/components/modal-dialog/usage)
 */ const ModalTitle = (props)=>{
    const { appearance, children, isMultiline = true, testId: userDefinedTestId } = props;
    const { titleId, testId: modalTestId } = (0, _hooks.useModal)();
    const testId = userDefinedTestId || modalTestId && `${modalTestId}--title`;
    return /*#__PURE__*/ _react.createElement("h1", {
        "data-testid": testId,
        className: (0, _runtime.ax)([
            "_zulpu2gc _11c81af2 _1e0c1txw _1ul9idpf _6rthze3t _1pfhze3t _12l2ze3t _ahbqze3t"
        ])
    }, appearance && /*#__PURE__*/ _react.createElement(TitleIcon, {
        appearance: appearance
    }), /*#__PURE__*/ _react.createElement("span", {
        id: titleId,
        "data-testid": testId && `${testId}-text`,
        className: (0, _runtime.ax)([
            "_16jlkb7n _1o9zkb7n _i0dl1wug _11c81af2 _1ul9idpf _slp31hna",
            !isMultiline && "_1reo15vq _18m915vq _1bto1l2s _o5721q9c"
        ])
    }, children));
};
exports.default = ModalTitle;

},{"react":"ltHCL","@compiled/react/runtime":"d27Vo","@atlaskit/icon/core/status-error":"lTP2w","@atlaskit/icon/core/status-warning":"6K5qa","./hooks":"eTlVq","@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"k0iNO":[function(require,module,exports,__globalThis) {
/* modal-body.tsx generated by @compiled/babel-plugin v0.39.1 */ var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _runtime = require("@compiled/react/runtime");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _reactScrolllock = require("react-scrolllock");
var _hooks = require("./hooks");
var _scrollContainer = require("./internal/components/scroll-container");
var _scrollContainerDefault = parcelHelpers.interopDefault(_scrollContainer);
var _useScroll = require("./internal/hooks/use-scroll");
var _useScrollDefault = parcelHelpers.interopDefault(_useScroll);
const styles = {
    root: "_16jlkb7n _1o9zkb7n _i0dl1wug _11c8fhey",
    paddingBlock: "_1rjcv77o",
    paddingInline: "_18zr1ejb"
};
/**
 * __Modal body__
 *
 * A modal body is used to display the main content of a modal.
 *
 * - [Examples](https://atlassian.design/components/modal-dialog/examples)
 * - [Code](https://atlassian.design/components/modal-dialog/code#modal-body-props)
 * - [Usage](https://atlassian.design/components/modal-dialog/usage)
 */ const ModalBody = (props)=>{
    const { children, testId: userDefinedTestId, hasInlinePadding = true } = props;
    const { testId: modalTestId } = (0, _hooks.useModal)();
    const shouldScrollInViewport = (0, _useScrollDefault.default)();
    const testId = userDefinedTestId || modalTestId && `${modalTestId}--body`;
    return shouldScrollInViewport ? /*#__PURE__*/ (0, _reactDefault.default).createElement("div", {
        "data-testid": testId,
        className: (0, _runtime.ax)([
            styles.root,
            hasInlinePadding && styles.paddingInline
        ])
    }, children) : /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _reactScrolllock.TouchScrollable), null, /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _scrollContainerDefault.default), {
        testId: userDefinedTestId || modalTestId
    }, /*#__PURE__*/ (0, _reactDefault.default).createElement("div", {
        "data-testid": testId,
        className: (0, _runtime.ax)([
            styles.root,
            /**
       * Adding block padding for scroll keylines, which are only shown when the scrolling
       * is on the container.
       */ styles.paddingBlock,
            hasInlinePadding && styles.paddingInline
        ])
    }, children)));
};
exports.default = ModalBody;

},{"@compiled/react/runtime":"d27Vo","react":"ltHCL","react-scrolllock":"iBy4G","./hooks":"eTlVq","./internal/components/scroll-container":"i1EqD","./internal/hooks/use-scroll":"jmrRy","@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"i1EqD":[function(require,module,exports,__globalThis) {
/* scroll-container.tsx generated by @compiled/babel-plugin v0.39.1 */ var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _bindEventListener = require("bind-event-listener");
var _rafSchd = require("raf-schd");
var _rafSchdDefault = parcelHelpers.interopDefault(_rafSchd);
var _css = require("@atlaskit/css");
var _mergeRefs = require("@atlaskit/ds-lib/merge-refs");
var _mergeRefsDefault = parcelHelpers.interopDefault(_mergeRefs);
var _noop = require("@atlaskit/ds-lib/noop");
var _noopDefault = parcelHelpers.interopDefault(_noop);
var _useLazyCallback = require("@atlaskit/ds-lib/use-lazy-callback");
var _useLazyCallbackDefault = parcelHelpers.interopDefault(_useLazyCallback);
var _compiled = require("@atlaskit/primitives/compiled");
const keylineColor = "var(--ds-border, #0B120E24)";
const styles = {
    base: "_kkes1kw7 _1e0c1kw7 _2lx21kw7 _16jlkb7n _6rthze3t _1pfhze3t _12l2ze3t _ahbqze3t _1reo15vq _18m91wug _1jykn7od _wzg61wug",
    topKeyline: "_mqm2ia51",
    bottomKeyline: "_179ria51"
};
const keylineHeight = 1;
/**
 * A container that shows top and bottom keylines when the
 * content overflows into the scrollable element.
 */ const ScrollContainer = /*#__PURE__*/ (0, _react.forwardRef)(({ testId, children }, ref)=>{
    const scrollableRef = (0, _react.useRef)(null);
    const [showTopKeyline, setTopKeyline] = (0, _react.useState)(false);
    const [showBottomKeyline, setBottomKeyline] = (0, _react.useState)(false);
    const [showContentFocus, setContentFocus] = (0, _react.useState)(false);
    // Schedule a content focus on the target element
    // WARNING: In theory, `target` may not be available when `rafSchedule` hits in concurrent rendering
    (0, _react.useEffect)(()=>{
        const schedule = (0, _rafSchdDefault.default)(()=>{
            const target = scrollableRef.current;
            target && setContentFocus(target.scrollHeight > target.clientHeight);
        });
        schedule();
    }, [
        scrollableRef
    ]);
    const setLazyKeylines = (0, _useLazyCallbackDefault.default)((0, _rafSchdDefault.default)(()=>{
        const target = scrollableRef.current;
        if (target) {
            const scrollableDistance = target.scrollHeight - target.clientHeight;
            if (target.previousElementSibling) setTopKeyline(target.scrollTop > keylineHeight);
            if (target.nextElementSibling) setBottomKeyline(target.scrollTop <= scrollableDistance - keylineHeight);
        }
    }));
    // On load (and scroll/resize events), we set "keylines"
    // these border the content to indicate scrollability when content underflows the header or footer
    (0, _react.useEffect)(()=>{
        const target = scrollableRef.current;
        setLazyKeylines();
        const unbindWindowEvent = (0, _bindEventListener.bind)(window, {
            type: 'resize',
            listener: setLazyKeylines
        });
        const unbindTargetEvent = target ? (0, _bindEventListener.bind)(target, {
            type: 'scroll',
            listener: setLazyKeylines
        }) : (0, _noopDefault.default);
        return ()=>{
            unbindWindowEvent();
            unbindTargetEvent();
        };
    }, [
        setLazyKeylines
    ]);
    return /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _compiled.Focusable), {
        as: "div",
        isInset: true,
        // tabindex is allowed here so that keyboard users can scroll content
        tabIndex: showContentFocus ? 0 : undefined,
        role: showContentFocus ? 'region' : undefined,
        "aria-label": showContentFocus ? 'Scrollable content' : undefined,
        testId: testId && `${testId}--scrollable`,
        ref: (0, _mergeRefsDefault.default)([
            ref,
            scrollableRef
        ]),
        xcss: (0, _css.cx)(styles.base, showTopKeyline && styles.topKeyline, showBottomKeyline && styles.bottomKeyline)
    }, children);
});
ScrollContainer.displayName = 'ScrollContainer';
exports.default = ScrollContainer;

},{"react":"ltHCL","bind-event-listener":"bjeUU","raf-schd":"oiTmD","@atlaskit/css":"kMGms","@atlaskit/ds-lib/merge-refs":"doPwA","@atlaskit/ds-lib/noop":"faKzG","@atlaskit/ds-lib/use-lazy-callback":"k76pc","@atlaskit/primitives/compiled":"hDay7","@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"jmrRy":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>useScroll);
var _react = require("react");
var _scrollContext = require("../scroll-context");
function useScroll() {
    const shouldScrollInViewport = (0, _react.useContext)((0, _scrollContext.ScrollContext));
    if (shouldScrollInViewport == null) throw Error("@atlaskit/modal-dialog: Scroll context unavailable \u2013 this component needs to be a child of ModalDialog.");
    return shouldScrollInViewport;
}

},{"react":"ltHCL","../scroll-context":"5KEhV","@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"f6ee3":[function(require,module,exports,__globalThis) {
/* modal-footer.tsx generated by @compiled/babel-plugin v0.39.1 */ var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _react = require("react");
var _runtime = require("@compiled/react/runtime");
var _hooks = require("./hooks");
const footerStyles = null;
/**
 * __Modal footer__
 *
 * A modal footer often contains a primary action and the ability to cancel and close the dialog, though can contain any React element.
 *
 * - [Examples](https://atlassian.design/components/modal-dialog/examples#modal-footer)
 * - [Code](https://atlassian.design/components/modal-dialog/code#modal-footer-props)
 * - [Usage](https://atlassian.design/components/modal-dialog/usage)
 */ const ModalFooter = (props)=>{
    const { children, testId: userDefinedTestId } = props;
    const { testId: modalTestId } = (0, _hooks.useModal)();
    const testId = userDefinedTestId || modalTestId && `${modalTestId}--footer`;
    return /*#__PURE__*/ _react.createElement("div", {
        "data-testid": testId,
        className: (0, _runtime.ax)([
            "_zulpu2gc _18zr1ejb _1e0c1txw _kqswh2mm _4cvr1h6o _1bahesu3 _1pfh1i6y _85i51ejb _1q51pxbi"
        ])
    }, children);
};
exports.default = ModalFooter;

},{"react":"ltHCL","@compiled/react/runtime":"d27Vo","./hooks":"eTlVq","@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"UUVLf":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "CONSENT_DISPLAYED_TEXT_ITEMS", ()=>CONSENT_DISPLAYED_TEXT_ITEMS);
var _types = require("../../types");
const CONSENT_DISPLAYED_TEXT_ITEMS = [
    (0, _types.PreferenceCategory).Analytics,
    (0, _types.PreferenceCategory).Functional,
    (0, _types.PreferenceCategory).Marketing,
    (0, _types.PreferenceCategory).StrictlyNecessary,
    (0, _types.PreferenceCategory).Unknown
];

},{"../../types":"65Pa5","@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"fBvQL":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "CookieCategorySection", ()=>CookieCategorySection);
var _objectSpread = require("@swc/helpers/_/_object_spread");
var _objectSpreadProps = require("@swc/helpers/_/_object_spread_props");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _checkbox = require("@atlaskit/checkbox");
var _checkboxDefault = parcelHelpers.interopDefault(_checkbox);
// eslint-disable-next-line @atlaskit/design-system/no-emotion-primitives -- to be migrated to @atlaskit/primitives/compiled – go/akcss
var _primitives = require("@atlaskit/primitives");
var _analyticsClient = require("../../../../../common/utils/analytics-client");
var _types = require("../../../../../types");
const tmpTrelloClassNameOverride = 'atl-bsc-preference-modal-checkbox';
// Styles
const categoryBoxStyles = (0, _primitives.xcss)({
    paddingBlockStart: 'space.200'
});
const categoryDescriptionStyles = (0, _primitives.xcss)({
    paddingInlineStart: 'space.300',
    marginInlineStart: 'space.050'
});
// We don't bother tracking unknown checkbox toggles
const categoryToEventSubjectMap = {
    [(0, _types.PreferenceCategory).Analytics]: 'performanceConsent',
    [(0, _types.PreferenceCategory).Functional]: 'functionalConsent',
    [(0, _types.PreferenceCategory).Marketing]: 'targetingConsent',
    [(0, _types.PreferenceCategory).Unknown]: null,
    [(0, _types.PreferenceCategory).StrictlyNecessary]: null
};
const categoryToTestIdMap = {
    [(0, _types.PreferenceCategory).StrictlyNecessary]: null,
    [(0, _types.PreferenceCategory).Analytics]: 'analytics',
    [(0, _types.PreferenceCategory).Functional]: 'functional',
    [(0, _types.PreferenceCategory).Marketing]: 'marketing',
    [(0, _types.PreferenceCategory).Unknown]: null
};
const CookieCategorySection = ({ category, titleElement, titleString, descriptionElement, isChecked, setPreferencesData })=>{
    const onCheckboxChange = (0, _react.useCallback)(()=>{
        // Don't alter cookies that are strictly necessary
        if (category === (0, _types.PreferenceCategory).StrictlyNecessary) return;
        setPreferencesData((prevPrefsData)=>{
            const isSelected = prevPrefsData.prefs && !prevPrefsData.prefs[category];
            const actionSubjectId = categoryToEventSubjectMap[category];
            if (actionSubjectId) (0, _analyticsClient.sendUIEvent)({
                actionSubjectId,
                action: 'clicked',
                actionSubject: 'checkbox',
                source: 'cookieConsentModal',
                attributes: {
                    isSelected
                }
            });
            return (0, _objectSpreadProps._)((0, _objectSpread._)({}, prevPrefsData), {
                prefs: (0, _objectSpreadProps._)((0, _objectSpread._)({}, prevPrefsData.prefs), {
                    [category]: isSelected
                })
            });
        });
    }, [
        category,
        setPreferencesData
    ]);
    const descriptionId = `consent-preference-${categoryToTestIdMap[category]}-description`;
    return /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _primitives.Box), {
        xcss: categoryBoxStyles
    }, /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _checkboxDefault.default), {
        // eslint-disable-next-line @atlaskit/design-system/no-unsafe-style-overrides, @atlaskit/ui-styling-standard/no-classname-prop
        className: `${tmpTrelloClassNameOverride}`,
        isChecked: isChecked,
        value: isChecked.toString(),
        onChange: onCheckboxChange,
        label: titleElement,
        name: `${titleString}`,
        testId: `consent-preference-${categoryToTestIdMap[category]}`,
        "aria-describedby": descriptionId
    }), /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _primitives.Box), {
        xcss: categoryDescriptionStyles,
        id: descriptionId
    }, /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _primitives.Text), {
        size: "small",
        color: "color.text.subtle"
    }, descriptionElement)));
};

},{"@swc/helpers/_/_object_spread":"9gdrV","@swc/helpers/_/_object_spread_props":"kANqQ","react":"ltHCL","@atlaskit/checkbox":"60CgZ","@atlaskit/primitives":"3S6Im","../../../../../common/utils/analytics-client":"3Dqor","../../../../../types":"65Pa5","@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"60CgZ":[function(require,module,exports,__globalThis) {
// This allows you to import Checkbox as a default or named export
var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>(0, _checkboxDefault.default));
parcelHelpers.export(exports, "Checkbox", ()=>(0, _checkboxDefault.default));
var _checkbox = require("./checkbox");
var _checkboxDefault = parcelHelpers.interopDefault(_checkbox);

},{"./checkbox":"lzSQb","@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"lzSQb":[function(require,module,exports,__globalThis) {
/* checkbox.tsx generated by @compiled/babel-plugin v0.39.1 */ var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _objectSpread = require("@swc/helpers/_/_object_spread");
var _objectSpreadProps = require("@swc/helpers/_/_object_spread_props");
var _objectWithoutProperties = require("@swc/helpers/_/_object_without_properties");
var _react = require("react");
var _runtime = require("@compiled/react/runtime");
var _usePlatformLeafEventHandler = require("@atlaskit/analytics-next/usePlatformLeafEventHandler");
var _mergeRefs = require("@atlaskit/ds-lib/merge-refs");
var _mergeRefsDefault = parcelHelpers.interopDefault(_mergeRefs);
var _checkboxIcon = require("./internal/checkbox-icon");
var _checkboxIconDefault = parcelHelpers.interopDefault(_checkboxIcon);
var _label = require("./internal/label");
var _labelDefault = parcelHelpers.interopDefault(_label);
var _labelText = require("./internal/label-text");
var _labelTextDefault = parcelHelpers.interopDefault(_labelText);
var _requiredIndicator = require("./internal/required-indicator");
var _requiredIndicatorDefault = parcelHelpers.interopDefault(_requiredIndicator);
/**
 * The input is visually hidden but remains in the DOM for accessibility.
 * State-based styling is handled by the Label component using CSS custom properties
 * that cascade to the CheckboxIcon, avoiding nested sibling selectors.
 */ const checkboxStyles = {
    root: "_19itglyw _nd5lfibj _12ji1r31 _1qu2glyw _12y31o36 _1bsb1osq _4t3i1osq _r06hglyw _6rthze3t _1pfhze3t _12l2ze3t _ahbqze3t _tzy4idpf"
};
/**
 * __Checkbox__
 *
 * A checkbox an input control that allows a user to select one or more options from a number of choices.
 *
 * - [Examples](https://atlassian.design/components/checkbox/examples)
 * - [Code](https://atlassian.design/components/checkbox/code)
 * - [Usage](https://atlassian.design/components/checkbox/usage)
 */ const Checkbox = /*#__PURE__*/ (0, _react.memo)(/*#__PURE__*/ (0, _react.forwardRef)(function Checkbox(_param, ref) {
    var { isChecked: isCheckedProp, isDisabled = false, isInvalid = false, defaultChecked = false, isIndeterminate = false, onChange: onChangeProps, analyticsContext, label, name, value, isRequired, testId, xcss, className } = _param, rest = (0, _objectWithoutProperties._)(_param, [
        "isChecked",
        "isDisabled",
        "isInvalid",
        "defaultChecked",
        "isIndeterminate",
        "onChange",
        "analyticsContext",
        "label",
        "name",
        "value",
        "isRequired",
        "testId",
        "xcss",
        "className"
    ]);
    const [isCheckedState, setIsCheckedState] = (0, _react.useState)(isCheckedProp !== undefined ? isCheckedProp : defaultChecked);
    const onChange = (0, _react.useCallback)((e, analyticsEvent)=>{
        setIsCheckedState(e.target.checked);
        if (onChangeProps) onChangeProps(e, analyticsEvent);
    }, [
        onChangeProps
    ]);
    const onChangeAnalytics = (0, _usePlatformLeafEventHandler.usePlatformLeafEventHandler)({
        fn: onChange,
        action: 'changed',
        analyticsData: analyticsContext,
        componentName: 'checkbox',
        packageName: "@af/atlassian-studio",
        packageVersion: "0.16.1"
    });
    const internalRef = (0, _react.useRef)(null);
    const mergedRefs = (0, _mergeRefsDefault.default)([
        internalRef,
        ref
    ]);
    // Use isChecked from the state if it is controlled
    const isChecked = isCheckedProp === undefined ? isCheckedState : isCheckedProp;
    (0, _react.useEffect)(()=>{
        if (internalRef.current) internalRef.current.indeterminate = isIndeterminate;
    }, [
        isIndeterminate
    ]);
    return /*#__PURE__*/ _react.createElement((0, _labelDefault.default), {
        isDisabled: isDisabled,
        isChecked: isChecked,
        isIndeterminate: isIndeterminate,
        isInvalid: isInvalid,
        label: label,
        id: rest.id ? `${rest.id}-label` : undefined,
        testId: testId && `${testId}--checkbox-label`,
        // Currently the rule hasn't been updated to enable "allowed" dynamic pass-throughs.
        // When there is more usage of this pattern we'll update the lint rule.
        xcss: xcss
    }, /*#__PURE__*/ _react.createElement("input", (0, _objectSpreadProps._)((0, _objectSpread._)({
        // It is necessary only for Safari. It allows to render focus styles.
        tabIndex: 0
    }, rest), {
        type: "checkbox",
        ref: mergedRefs,
        disabled: isDisabled,
        checked: isChecked,
        value: value,
        name: name,
        required: isRequired,
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop
        className: (0, _runtime.ax)([
            checkboxStyles.root,
            className
        ]),
        onChange: onChangeAnalytics,
        "aria-invalid": isInvalid ? 'true' : undefined,
        "data-testid": testId && `${testId}--hidden-checkbox`,
        "data-invalid": isInvalid ? 'true' : undefined
    })), /*#__PURE__*/ _react.createElement((0, _checkboxIconDefault.default), {
        isIndeterminate: isIndeterminate,
        isChecked: isChecked
    }), label && /*#__PURE__*/ _react.createElement((0, _labelTextDefault.default), null, label, isRequired && /*#__PURE__*/ _react.createElement((0, _requiredIndicatorDefault.default), null)));
}));
Checkbox.displayName = 'Checkbox';
exports.default = Checkbox;

},{"@swc/helpers/_/_object_spread":"9gdrV","@swc/helpers/_/_object_spread_props":"kANqQ","@swc/helpers/_/_object_without_properties":"6HqIM","react":"ltHCL","@compiled/react/runtime":"d27Vo","@atlaskit/analytics-next/usePlatformLeafEventHandler":"dRWFk","@atlaskit/ds-lib/merge-refs":"doPwA","./internal/checkbox-icon":"388d5","./internal/label":"aQHLM","./internal/label-text":"eHv5W","./internal/required-indicator":"9o9ib","@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"388d5":[function(require,module,exports,__globalThis) {
/* checkbox-icon.tsx generated by @compiled/babel-plugin v0.39.1 */ var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _react = require("react");
var _runtime = require("@compiled/react/runtime");
/**
 * Styles for the checkbox icon.
 * CSS custom properties for colors are set by the parent Label element
 * and consumed directly in these styles.
 */ const svgStyles = {
    root: "_nd5lfibj _1reo15vq _18m915vq _v5641mn3 _2rko12b0 _1a3742bt _lcxvglyw _syazmov0 _lswu1kgh _1cwg1i6y",
    rect: "_v56411so _1snbe4h9 _1s17hteq"
};
function getIcon(isIndeterminate, isChecked) {
    if (isIndeterminate) return /*#__PURE__*/ _react.createElement("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M7.75 12.75H16.25V11.25H7.75V12.75Z",
        fill: "inherit"
    });
    if (isChecked) return /*#__PURE__*/ _react.createElement("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M16.3262 9.48011L15.1738 8.51984L10.75 13.8284L8.82616 11.5198L7.67383 12.4801L10.1738 15.4801C10.3163 15.6511 10.5274 15.75 10.75 15.75C10.9726 15.75 11.1837 15.6511 11.3262 15.4801L16.3262 9.48011Z",
        fill: "inherit"
    });
    // No icon
    return null;
}
/**
 * __Checkbox icon__
 *
 * A checkbox icon is the visual representation of checkbox state,
 * which is shown instead of the native input.
 *
 * @internal
 */ const CheckboxIcon = /*#__PURE__*/ (0, _react.memo)(({ isIndeterminate, isChecked })=>{
    const icon = (0, _react.useMemo)(()=>getIcon(isIndeterminate, isChecked), [
        isIndeterminate,
        isChecked
    ]);
    return /*#__PURE__*/ _react.createElement("svg", {
        width: 24,
        height: 24,
        viewBox: "0 0 24 24",
        role: "presentation",
        className: (0, _runtime.ax)([
            svgStyles.root
        ])
    }, /*#__PURE__*/ _react.createElement("g", {
        fillRule: "evenodd"
    }, /*#__PURE__*/ _react.createElement("rect", {
        fill: "currentColor",
        x: "5.5",
        y: "5.5",
        width: "13",
        height: "13",
        rx: "1.5",
        className: (0, _runtime.ax)([
            svgStyles.rect
        ])
    }), icon));
});
exports.default = CheckboxIcon;

},{"react":"ltHCL","@compiled/react/runtime":"d27Vo","@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"aQHLM":[function(require,module,exports,__globalThis) {
/* label.tsx generated by @compiled/babel-plugin v0.39.1 */ var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>Label);
var _react = require("react");
var _runtime = require("@compiled/react/runtime");
/**
 * Base state styles with CSS custom properties.
 * Pseudo-selectors (:hover, :focus-within, :active) on the label element
 * update CSS variables that cascade to the CheckboxIcon.
 * This avoids nested sibling selectors.
 *
 * Uses `css` over `cssMap` to work around a bug in Compiled types when
 * using CSS variables in pseudo-selectors.
 */ const baseStyles = null;
const textLabelLayoutStyles = null;
// Checked/Indeterminate state
const checkedStyles = null;
// Invalid state - must override hover/active to maintain red border
const invalidStyles = null;
// Disabled state - must override hover/active to maintain disabled appearance
const disabledStyles = null;
// Disabled + Checked/Indeterminate
const disabledCheckedStyles = null;
function Label({ children, isDisabled, isChecked, isIndeterminate, isInvalid, testId, label, id, xcss }) {
    return /*#__PURE__*/ _react.createElement("label", {
        className: (0, _runtime.ax)([
            "_11c8fhey _1e0c11p5 _1ejihkll _umai184x _1qwn1j9a _f0grrsbi _1c53glyw _1e9d1j28 _syazi7uo _80om73ad _ljcgdfik _1vj5l4ek _dh4gr01l _cz1u1l7x _jom5wc43 _1s071onz _106f1onz",
            label && "_zulp1nu5 _yv0ey09t",
            (isChecked || isIndeterminate) && "_1qwnjmqp _f0grjmqp _1e9d5w2r _1vj51q28 _q29q1q28 _dh4gr01l _cz1u1l7x _zoo95w2r _jom5wc43 _1s071onz _106f1onz",
            isInvalid && "_f0gr1bqt _q29q1bqt _cz1u1bqt _1s07gir2",
            isDisabled && "_1qwn187o _f0gr187o _syaz1gmx _80om13gf _1vj5187o _q29q187o _dh4g187o _cz1u187o _jom5wc43 _1s0718qt _106f18qt",
            isDisabled && (isChecked || isIndeterminate) && "_1e9d2sac _9js12sac _zoo92sac",
            xcss
        ]),
        "data-testid": testId,
        "data-disabled": isDisabled || undefined,
        id: id
    }, children);
}

},{"react":"ltHCL","@compiled/react/runtime":"d27Vo","@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"eHv5W":[function(require,module,exports,__globalThis) {
/* label-text.tsx generated by @compiled/babel-plugin v0.39.1 */ var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>LabelText);
var _react = require("react");
var _runtime = require("@compiled/react/runtime");
const labelTextStyles = null;
function LabelText({ children }) {
    return /*#__PURE__*/ _react.createElement("span", {
        className: (0, _runtime.ax)([
            "_nd5l11ig _1wpz1h6o"
        ])
    }, children);
}

},{"react":"ltHCL","@compiled/react/runtime":"d27Vo","@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"9o9ib":[function(require,module,exports,__globalThis) {
/* required-indicator.tsx generated by @compiled/babel-plugin v0.39.1 */ var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>RequiredIndicator);
var _react = require("react");
var _runtime = require("@compiled/react/runtime");
const requiredIndicatorStyles = null;
function RequiredIndicator() {
    return /*#__PURE__*/ _react.createElement("span", {
        "aria-hidden": true,
        className: (0, _runtime.ax)([
            "_syaz1tmw _bozgv77o"
        ])
    }, "*");
}

},{"react":"ltHCL","@compiled/react/runtime":"d27Vo","@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"cywKi":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "i18n", ()=>i18n);
var _reactIntl = require("react-intl");
const i18n = (0, _reactIntl.defineMessages)({
    title: {
        id: 'browser-storage-controls.consent-banner-modal.title',
        defaultMessage: 'Cookie preferences',
        description: 'The text is shown as the heading at the top of the cookie preferences modal dialog, which allows users to manage and configure their browser cookie and storage settings.'
    },
    summaryDescription: {
        id: 'browser-storage-controls.consent-banner-modal.summary.description.082624',
        defaultMessage: 'Because we value your privacy, you can select which cookies you allow. {link}',
        description: 'Cookie preferences modal dialog summary description.'
    },
    strictDescription: {
        id: 'browser-storage-controls.consent-banner-modal.strict.description.082624',
        defaultMessage: "Atlassian tracks <bold>strictly necessary</bold> cookies that are essential for our products to function, so you can't adjust these. These cookies don't store personally identifiable information or track browsing habits.",
        description: 'Cookie preferences modal strict description.'
    },
    confirmBtn: {
        id: 'browser-storage-controls.consent-banner-modal.confirm.button',
        defaultMessage: 'Confirm',
        description: 'Cookie preferences modal dialog confirm button.'
    },
    cancelBtn: {
        id: 'browser-storage-controls.consent-banner-modal.cancel.button',
        defaultMessage: 'Cancel',
        description: 'Cookie preferences modal dialog cancel button.'
    },
    trackingLink: {
        id: 'browser-storage-controls.consent-banner-modal.tracking.link.082624',
        defaultMessage: 'Review our cookies and tracking notice',
        description: 'Cookie preferences modal link to tracking notice page.'
    },
    functionalOption: {
        id: 'browser-storage-controls.consent-banner-modal.functional.option.082624',
        defaultMessage: 'Allow functional cookies',
        description: 'Cookie preferences modal functional option.'
    },
    functionalOptionDescription: {
        id: 'browser-storage-controls.consent-banner-modal.functional.description.082624',
        defaultMessage: 'Provides enhanced functionality and personalization.',
        description: 'Cookie preferences modal functional option description.'
    },
    analyticalOption: {
        id: 'browser-storage-controls.consent-banner-modal.analytical.option.082624',
        defaultMessage: 'Allow analytical cookies',
        description: 'Cookie preferences modal analytical option.'
    },
    analyticalOptionDescription: {
        id: 'browser-storage-controls.consent-banner-modal.analytical.description.101024',
        defaultMessage: 'Measures usage to improve product performance.',
        description: 'Cookie preferences modal analytical option description.'
    },
    marketingOption: {
        id: 'browser-storage-controls.consent-banner-modal.marketing.option.082624',
        defaultMessage: 'Allow marketing cookies',
        description: 'Cookie preferences modal marketing option.'
    },
    marketingOptionDescription: {
        id: 'browser-storage-controls.consent-banner-modal.marketing.description.082624',
        defaultMessage: 'Used for targeted advertising.',
        description: 'Cookie preferences modal marketing option description.'
    },
    strictDescriptionAppify: {
        id: 'browser-storage-controls.consent-banner-modal.strict.description.082624-appify',
        defaultMessage: "Atlassian tracks <bold>strictly necessary</bold> cookies that are essential for our apps to function, so you can't adjust these. These cookies don't store personally identifiable information or track browsing habits.",
        description: 'Cookie preferences modal strict description.'
    },
    analyticalOptionDescriptionAppify: {
        id: 'browser-storage-controls.consent-banner-modal.analytical.description.101024-appify',
        defaultMessage: 'Measures usage to improve app performance.',
        description: 'Cookie preferences modal analytical option description.'
    }
});

},{"react-intl":"f41fF","@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"2gZ28":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _react = require("react");
var _transformer = require("../../../../controllers/cookie-controls/transformer");
var _getPreferences = require("../../../../controllers/preferences-controls//get-preferences");
var _updatePreferences = require("../../../../controllers/preferences-controls//update-preferences");
/**
 * This function is responsible for loading the user's preferences from storage, and setting the state accordingly.
 * If the user's preferences are not found in storage, the default preferences will be used.
 */ const loadStoredPreferences = async ({ setPreferencesData: setPreferencesData, isInitialRender })=>{
    const prefs = await (0, _getPreferences.getPreferences)();
    // If something has gone wrong during this `get` process (invalid token, failed request, etc.)
    // these preferences will be undefined and we'll need to show the banner as we're in an unknown state
    setPreferencesData({
        prefs,
        isPrefetchedPrefsInternalState: Boolean(prefs)
    });
    // Set the initialRender flag to false so we can skip logic in banner rendering
    if (isInitialRender) isInitialRender.current = false;
};
/**
 * This hook is responsible for handling any initially provided preference data, and/or fetching missing preference
 * data from ConsentHub. It will then set the appropriate cookies and state for the user's preferences to be used
 * throughout the application.

 * @param (optional) initialPreferences - Any initially provided preferences from consuming applications (used for SSR)
 * @returns (object) {
 * 	preferences - The current state of the user's preferences after fetching/transforming/setting cookies
 *	isPrefetchedPreferencesState - A boolean that indicates if we are in a prefetched internal state
 *	setPreferencesData - Setter function to update the preferences state
 *	isInitialRender - A boolean that indicates if this is the first render of the component
 * }
 */ const usePreferences = ({ initialPreferences })=>{
    /**
	 * isInitialRender is used to ensure consistent banner visibility by addressing potential mismatches that occur
	 *  during the initial render. Without this flag, the application might incorrectly display a banner based on
	 * incomplete or missing preference data. During the rehydration process, this initial render triggers
	 * the useMemo and useEffect hooks which means that initialPreferences may be undefined due to the asynchronous
	 * nature of setting props. This can lead to discrepancies in banner visibility between the SSR state
	 * and the client-rendered state.
	 */ const isInitialRender = (0, _react.useRef)(true);
    const prefetchedPreferencesData = (0, _react.useRef)(initialPreferences);
    const [preferencesData, setPreferencesData] = (0, _react.useState)((0, _transformer.initializePreferencesData)(initialPreferences));
    (0, _react.useEffect)(()=>{
        const { prefs: unpackedPrefetchedPrefs, isPrefetchedPrefsInternalState } = (0, _transformer.initializePreferencesData)(prefetchedPreferencesData.current);
        if (!isPrefetchedPrefsInternalState && unpackedPrefetchedPrefs) // With a valid set of prefs, set them on the cookies, but don't save to ConsentHub
        (0, _updatePreferences.updatePreferences)(unpackedPrefetchedPrefs, undefined, true);
        // On initial render, this will either set the proper preferences in state + required cookies based on the
        // prefetched data, or fetch all of that data from ConsentHub and then set appropriate cookies + state.
        loadStoredPreferences({
            setPreferencesData,
            isInitialRender
        });
    }, [
        isInitialRender
    ]);
    return {
        preferences: preferencesData === null || preferencesData === void 0 ? void 0 : preferencesData.prefs,
        isPrefetchedPreferencesState: preferencesData === null || preferencesData === void 0 ? void 0 : preferencesData.isPrefetchedPrefsInternalState,
        setPreferencesData,
        isInitialRender: isInitialRender.current
    };
};
exports.default = usePreferences;

},{"react":"ltHCL","../../../../controllers/cookie-controls/transformer":"hcsh1","../../../../controllers/preferences-controls//get-preferences":"030sv","../../../../controllers/preferences-controls//update-preferences":"jMIew","@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"47Ppm":[function(require,module,exports,__globalThis) {
/* eslint-disable @atlassian/tangerine/import/no-parent-imports */ var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "PresentationalConsentBanner", ()=>PresentationalConsentBanner);
var _objectSpread = require("@swc/helpers/_/_object_spread");
var _objectSpreadProps = require("@swc/helpers/_/_object_spread_props");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _reactIntl = require("react-intl");
var _new = require("@atlaskit/button/new");
var _newDefault = parcelHelpers.interopDefault(_new);
var _checkMark = require("@atlaskit/icon/core/check-mark");
var _checkMarkDefault = parcelHelpers.interopDefault(_checkMark);
// eslint-disable-next-line @atlaskit/design-system/no-emotion-primitives -- to be migrated to @atlaskit/primitives/compiled – go/akcss
var _primitives = require("@atlaskit/primitives");
// eslint-disable-next-line @atlaskit/design-system/no-emotion-primitives -- TODO: migrate to @atlaskit/primitives/compiled
var _responsive = require("@atlaskit/primitives/responsive");
var _tooltip = require("@atlaskit/tooltip");
var _tooltipDefault = parcelHelpers.interopDefault(_tooltip);
var _constants = require("../../../services/consent-hub-service/constants");
var _messages = require("../messages");
const boxStylesPurpleWithMinHeight = (0, _primitives.xcss)({
    padding: 'space.200',
    backgroundColor: 'color.background.discovery',
    borderStyle: 'solid',
    borderWidth: 'border.width',
    borderColor: 'color.border',
    overflowY: 'hidden',
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'center'
});
const noticeContainerStyles = (0, _primitives.xcss)({
    flexDirection: 'row',
    alignItems: 'center',
    gap: 'space.200'
});
const inlineWrapperStylesStaticHeight = (0, _primitives.xcss)({
    // Small & Medium viewport defaults
    gap: 'space.100',
    flexDirection: 'column',
    alignItems: 'flex-start',
    paddingTop: 'space.200',
    paddingBottom: 'space.200',
    [(0, _responsive.media).above.md]: {
        gap: 'space.300',
        flexDirection: 'row',
        alignItems: 'center'
    }
});
const buttonContainerStylesStaticHeight = (0, _primitives.xcss)({
    minWidth: 'fit-content',
    display: 'flex',
    alignItems: 'center',
    flexDirection: 'row-reverse',
    flexWrap: 'wrap-reverse',
    justifyContent: 'start',
    [(0, _responsive.media).above.md]: {
        marginLeft: 'auto',
        flexWrap: 'nowrap',
        flexDirection: 'row'
    }
});
const truncatedTextStyles = (0, _primitives.xcss)({
    overflow: 'hidden',
    display: '-webkit-box',
    WebkitBoxOrient: 'vertical',
    WebkitLineClamp: 1,
    flex: '0 1 auto'
});
const linkNoTruncateStyles = (0, _primitives.xcss)({
    flex: '0 0 auto',
    whiteSpace: 'nowrap'
});
const smallMediumScreenContainerStyles = (0, _primitives.xcss)({
    display: 'flex',
    flexDirection: 'row',
    flexWrap: 'wrap',
    gap: 'space.050',
    alignItems: 'baseline',
    [(0, _responsive.media).above.md]: {
        display: 'none'
    }
});
const largeScreenContainerStyles = (0, _primitives.xcss)({
    display: 'none',
    [(0, _responsive.media).above.md]: {
        display: 'block'
    }
});
const noop = ()=>{};
const getDisplayedTextMap = (intl)=>{
    // We'll use this mapping to send the `displayedText` for each checkbox when saving to ConsentHub
    const displayedTextMap = (0, _constants.CONSENT_DISPLAYED_TEXT_ITEMS).reduce((translatedTextMap, category)=>{
        const linkToCookiesTrackingNotice = intl.formatMessage((0, _messages.i18n).cookiesTrackingNotice);
        const bannerDescription = intl.formatMessage((0, _messages.i18n).useCookiesDescription, {
            linkToCookiesTrackingNotice
        });
        // Set this for all items (including items with checkboxes in the UI), we'll override as needed below
        // for things like strictlyNecessary/acceptAll
        translatedTextMap[category] = bannerDescription;
        return translatedTextMap;
    }, {});
    return displayedTextMap;
};
const updateDisplayedTextMap = (intl, displayTextMap, isOnlyNecessary)=>{
    const updatedDisplayedTextMap = (0, _objectSpread._)({}, displayTextMap);
    // Use description as message to translate
    const onlyNecessaryContent = intl.formatMessage((0, _messages.i18n).onlyNecessaryBtn);
    const acceptAllContent = intl.formatMessage((0, _messages.i18n).acceptAllBtn);
    // For additional auditing content, append the description related to the button when pressed
    Object.keys(updatedDisplayedTextMap).forEach((key)=>{
        const preferenceCategory = key;
        const additionalContent = isOnlyNecessary ? onlyNecessaryContent : acceptAllContent;
        const textContent = updatedDisplayedTextMap[preferenceCategory];
        updatedDisplayedTextMap[preferenceCategory] = `${additionalContent} \u{2014} ${textContent}`;
    });
    return updatedDisplayedTextMap;
};
const PresentationalConsentBanner = ({ onClickOnlyNecessary = noop, onClickAcceptAll = noop, onClickPreferences = noop, onClickTrackingNoticeLink = noop, minWidth = 400, newMinHeight = 105 })=>{
    const intl = (0, _reactIntl.useIntl)();
    const displayedTextMap = (0, _react.useMemo)(()=>{
        return getDisplayedTextMap(intl);
    }, [
        intl
    ]);
    const handleOnlyNecessaryClick = (0, _react.useCallback)(()=>{
        const displayedTextOnlyNecessaryMap = updateDisplayedTextMap(intl, displayedTextMap, true);
        onClickOnlyNecessary(displayedTextOnlyNecessaryMap);
    }, [
        onClickOnlyNecessary,
        intl,
        displayedTextMap
    ]);
    const handleAcceptAllClick = (0, _react.useCallback)(()=>{
        const displayedTextAcceptAllMap = updateDisplayedTextMap(intl, displayedTextMap);
        onClickAcceptAll(displayedTextAcceptAllMap);
    }, [
        onClickAcceptAll,
        intl,
        displayedTextMap
    ]);
    return /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _primitives.Box), {
        role: "dialog",
        "aria-labelledby": "cookiesTrackingNoticeLink",
        xcss: boxStylesPurpleWithMinHeight,
        style: {
            minWidth: `${minWidth}px`,
            // If you are updating the minHeight, please also update the MIN_BANNER_HEIGHT in confluence/next/packages/cookies-consent-banner/src/useCookiesConsentBanner.ts
            minHeight: `${newMinHeight}px`,
            height: `${newMinHeight}px`
        }
    }, /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _primitives.Inline), {
        xcss: inlineWrapperStylesStaticHeight
    }, /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _primitives.Inline), {
        xcss: noticeContainerStyles
    }, /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _reactDefault.default).Fragment, null, /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _primitives.Inline), {
        xcss: smallMediumScreenContainerStyles
    }, /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _tooltipDefault.default), {
        content: /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _reactIntl.FormattedMessage), (0, _messages.i18n).useCookiesDescriptionNoLink),
        position: "top"
    }, /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _primitives.Inline), {
        xcss: truncatedTextStyles
    }, /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _reactIntl.FormattedMessage), (0, _objectSpreadProps._)((0, _objectSpread._)({}, (0, _messages.i18n).useCookiesDescriptionNoLink), {
        tagName: "span"
    })))), /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _primitives.Anchor), {
        id: "cookiesTrackingNoticeLink",
        href: "https://www.atlassian.com/legal/cookies",
        target: "_blank",
        onClick: onClickTrackingNoticeLink,
        xcss: linkNoTruncateStyles
    }, /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _reactIntl.FormattedMessage), (0, _messages.i18n).cookiesTrackingNotice))), /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _primitives.Box), {
        xcss: largeScreenContainerStyles
    }, /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _reactIntl.FormattedMessage), (0, _objectSpreadProps._)((0, _objectSpread._)({}, (0, _messages.i18n).useCookiesDescription), {
        tagName: "span",
        values: {
            linkToCookiesTrackingNotice: /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _primitives.Anchor), {
                id: "cookiesTrackingNoticeLink",
                href: "https://www.atlassian.com/legal/cookies",
                target: "_blank",
                onClick: onClickTrackingNoticeLink
            }, /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _reactIntl.FormattedMessage), (0, _messages.i18n).cookiesTrackingNotice))
        }
    }))))), /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _primitives.Inline), {
        space: "space.100",
        xcss: buttonContainerStylesStaticHeight
    }, /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _newDefault.default), {
        testId: "preferences-button",
        appearance: "subtle",
        onClick: onClickPreferences
    }, /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _reactIntl.FormattedMessage), (0, _messages.i18n).preferencesBtn)), /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _newDefault.default), {
        testId: "only-necessary-button",
        onClick: handleOnlyNecessaryClick
    }, /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _reactIntl.FormattedMessage), (0, _messages.i18n).onlyNecessaryBtn)), /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _newDefault.default), {
        testId: "accept-all-button",
        iconBefore: (0, _checkMarkDefault.default),
        onClick: handleAcceptAllClick
    }, /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _reactIntl.FormattedMessage), (0, _messages.i18n).acceptAllBtn)))));
};

},{"@swc/helpers/_/_object_spread":"9gdrV","@swc/helpers/_/_object_spread_props":"kANqQ","react":"ltHCL","react-intl":"f41fF","@atlaskit/button/new":"aXnNi","@atlaskit/icon/core/check-mark":"iwzAF","@atlaskit/primitives":"3S6Im","@atlaskit/primitives/responsive":"9Ve4N","@atlaskit/tooltip":"7RyYv","../../../services/consent-hub-service/constants":"UUVLf","../messages":"54Ai5","@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"iwzAF":[function(require,module,exports,__globalThis) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::bcf60af7e41b379d3a36d6fe455c57ca>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = void 0;
var _react = _interopRequireDefault(require("676bd6fa8b9865ff"));
var _baseNew = _interopRequireDefault(require("281f1e9247d25eaf"));
function _interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "CheckMark".
 * Category: multi-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Multi purpose - Known uses: table cells, checkboxes.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const CheckMarkIcon = (props)=>/*#__PURE__*/ _react.default.createElement(_baseNew.default, Object.assign({
        name: "CheckMarkIcon",
        dangerouslySetGlyph: `<path fill="currentcolor" d="m13.959 3.97-7.25 9a.75.75 0 0 1-1.163.007l-3.5-4.25 1.158-.954 2.914 3.539 6.673-8.283z"/>`
    }, props));
CheckMarkIcon.displayName = 'CheckMarkIcon';
var _default = exports.default = CheckMarkIcon;

},{"676bd6fa8b9865ff":"ltHCL","281f1e9247d25eaf":"5XL7D"}],"R10Fm":[function(require,module,exports,__globalThis) {
/* eslint-disable @atlassian/tangerine/import/no-parent-imports */ var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "calculateBannerStateViaBit", ()=>calculateBannerStateViaBit);
parcelHelpers.export(exports, "getShowBanner", ()=>getShowBanner);
var _react = require("react");
var _platformFeatureFlags = require("@atlaskit/platform-feature-flags");
var _utils = require("../../../common/utils");
var _isSsr = require("../../../common/utils/is-ssr");
var _constants = require("../../../constants");
var _shouldBannerRenderPrefetched = require("../../../controllers/banner-controls/should-banner-render-prefetched");
var _cookieControls = require("../../../controllers/cookie-controls");
var _getCookie = require("../../../controllers/cookie-controls/get-cookie");
var _transformer = require("../../../controllers/cookie-controls/transformer");
var _utils1 = require("../../../services/consent-hub-service/utils");
var _types = require("../../../types");
/**
 * @private
 * @deprecated Legacy SSR banner visibility check that doesn't consider fallbackConsentToken.
 * Kept only as the feature-gate-off fallback for 'platform_moonjelly_bsc_ssr_banner_flash_fix'.
 * Will be removed once the gate is fully rolled out.
 */ const shouldShowBannerInSSRContextLegacy = (initialPreferences)=>{
    if (!initialPreferences || initialPreferences === (0, _types.PrefetchedPreferenceState).INTERNAL || (0, _transformer.initialPreferencesAreMissing)(initialPreferences)) return true;
    return !(0, _utils1.hasPrefetchedDataConsents)(initialPreferences);
};
const calculateBannerStateViaBit = (isInitialRender, initialPreferences, ssrOptions)=>{
    // We don't have a great way to handle dealing with consent timestamps right here, as we have no global state/store, so we have to precompute
    // banner visibility state when we fetch consents, and store it in a cookie to be read later, here.
    const shouldShowBannerBit = (ssrOptions === null || ssrOptions === void 0 ? void 0 : ssrOptions.getCookie) ? ssrOptions.getCookie((0, _constants.ATLASSIAN_SHOW_BANNER_COOKIE_KEY)) : (0, _getCookie.getCookie)((0, _constants.ATLASSIAN_SHOW_BANNER_COOKIE_KEY));
    const inFlowWhereBannerStateIsUnknown = initialPreferences && isInitialRender && shouldShowBannerBit === undefined;
    var _ssrOptions_isSSR;
    if (((_ssrOptions_isSSR = ssrOptions === null || ssrOptions === void 0 ? void 0 : ssrOptions.isSSR) !== null && _ssrOptions_isSSR !== void 0 ? _ssrOptions_isSSR : (0, _isSsr.isSSR)()) || inFlowWhereBannerStateIsUnknown) {
        // When coming from SSR, this hook will only execute once and won't update later
        // Instead, if we're on the server, have initial preference data with valid consents, don't render
        // On later checks (rehydration), this will always fail and skip to the normal rendering logic
        // Once we're rehydrating, if have been provided initial prefs (from SSR), on the "first render", the banner cookie may still be missing.
        // Due to React lifecycle where this useMemo is executing prior to the useEffect in the usePreferences hook, which sets the core cookies.
        // We should give this flow the same treatment as rendering in an SSR context to match the behavior of the SSR flow to reduce any potential UX flicker.
        if (initialPreferences === (0, _types.PrefetchedPreferenceState).INTERNAL) // If we're in the "fetch internally" state, we have no prefetched data and we can't determine
        // if the user has consented or not yet since we need to fetch, so show the banner
        return true;
        if ((0, _platformFeatureFlags.fg)('platform_moonjelly_bsc_ssr_banner_flash_fix')) // shouldRenderBannerPrefetched is the single source of truth for SSR/hydration banner visibility.
        // It is used here and by all external consumers (e.g. useCookiesConsentBanner) to guarantee
        // consistent decisions, including correct handling of fallbackConsentToken.
        //
        // Cast: PrefetchedConsentPreferenceData is a narrower type than PrefetchedConsentPreferences —
        // it excludes PrefetchedPreferenceState (handled above) but is otherwise compatible at this call site.
        return (0, _shouldBannerRenderPrefetched.shouldRenderBannerPrefetched)(initialPreferences, ssrOptions);
        // Legacy path: uses hasPrefetchedDataConsents which doesn't consider fallbackConsentToken.
        // This path will be removed once the feature gate is fully rolled out.
        return shouldShowBannerInSSRContextLegacy(initialPreferences);
    }
    const shouldShowBanner = shouldShowBannerBit ? !!Number(shouldShowBannerBit) : false;
    return shouldShowBanner;
};
/**
 * This hook is responsible for determining whether or not the consent banner should be shown based on the user's
 * preferences and the current state of the banner cookie, as well as if the we're rendering from an SSR context.
 *
 * @param preferences - The current state of the user's preferences
 * @param initialPreferences - Any initially provided preferences from consuming applications (used for SSR)
 * @param isInitialRender - A boolean to track if this is the "first" render of the component
 * @param isPrefetchedPreferencesState - A boolean that indicates if are fetching consents internally to our component
 * @returns showBanner - Whether or not the banner should be shown
 * @returns setIsDismissed - Setter function to update the dismissed state of the banner
 */ const useBannerVisibility = ({ preferences, initialPreferences, isInitialRender, isPrefetchedPreferencesState, ssrOptions })=>{
    const isEventSent = (0, _react.useRef)(false);
    const [isDismissed, setIsDismissedProp] = (0, _react.useState)(false);
    const setIsDismissed = (isDismissed)=>{
        if (isDismissed) (0, _cookieControls.setStrictlyNecessaryCookie)((0, _constants.ATLASSIAN_BANNER_LAST_DISMISSED_TIME_COOKIE_KEY), Date.now().toString(), {
            path: '/'
        });
        setIsDismissedProp(isDismissed);
    };
    const showBanner = (0, _react.useMemo)(()=>{
        return getShowBanner({
            preferences,
            initialPreferences,
            isInitialRender,
            isPrefetchedPreferencesState,
            isDismissed,
            ssrOptions
        });
    }, [
        isInitialRender,
        initialPreferences,
        isPrefetchedPreferencesState,
        preferences,
        isDismissed,
        ssrOptions
    ]);
    (0, _react.useEffect)(()=>{
        if (!isEventSent.current && showBanner) {
            (0, _utils.sendScreenEvent)({
                name: 'cookieConsentBanner'
            });
            isEventSent.current = true;
        }
    }, [
        isEventSent,
        showBanner
    ]);
    return {
        showBanner,
        setIsDismissed
    };
};
const getShowBanner = ({ preferences, initialPreferences, isInitialRender, isPrefetchedPreferencesState, isDismissed, ssrOptions })=>{
    if ((0, _utils.getBscGlobalState)().localConsentMode) {
        // In V1, we only checked based on the existence of the preferences
        const prefsMissing = !preferences;
        var _ssrOptions_isSSR;
        if ((_ssrOptions_isSSR = ssrOptions === null || ssrOptions === void 0 ? void 0 : ssrOptions.isSSR) !== null && _ssrOptions_isSSR !== void 0 ? _ssrOptions_isSSR : (0, _isSsr.isSSR)()) // This logic will execute normally in V2, but for now, as SSR prefetching has not been implemented completely
        // just hide the banner if we're missing the data (always will be in SSR-context) and let the UI handle it on rehydration
        return !prefsMissing && !isDismissed;
        return prefsMissing && !isDismissed;
    }
    const shouldShowBanner = calculateBannerStateViaBit(isInitialRender, initialPreferences, ssrOptions);
    const unknownPreferences = !isPrefetchedPreferencesState && !preferences;
    return (unknownPreferences || shouldShowBanner) && !isDismissed;
};
exports.default = useBannerVisibility;

},{"react":"ltHCL","@atlaskit/platform-feature-flags":"8rD2i","../../../common/utils":"gnWyu","../../../common/utils/is-ssr":"ciW3w","../../../constants":"9FHD5","../../../controllers/banner-controls/should-banner-render-prefetched":"9ZYdd","../../../controllers/cookie-controls":"7HiHV","../../../controllers/cookie-controls/get-cookie":"VS0K5","../../../controllers/cookie-controls/transformer":"hcsh1","../../../services/consent-hub-service/utils":"8vzek","../../../types":"65Pa5","@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"9ZYdd":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "shouldRenderBannerPrefetched", ()=>shouldRenderBannerPrefetched);
var _platformFeatureFlags = require("@atlaskit/platform-feature-flags");
var _consentHubService = require("../../../services/consent-hub-service");
var _utils = require("../../../services/consent-hub-service/utils");
var _transformer = require("../../cookie-controls/transformer");
var _getBannerVisibility = require("../get-banner-visibility");
const shouldRenderBannerPrefetched = (prefetchedPreferencesData, ssrOptions)=>{
    if ((0, _platformFeatureFlags.fg)('platform_moonjelly_bsc_ssr_killswitch')) // If the bsc ssr killswitch is enabled, we should not show the banner
    // in SSR context
    return false;
    if (!prefetchedPreferencesData) // If prefetched prefs are missing (presumably SSR prefetching failed), but are still trying to compute
    // banner state, we have no info to calculate from so, we need to show the banner to be compliant
    return true;
    if ('consentToken' in prefetchedPreferencesData) {
        // We've been given cached cookie data, validate it before use.
        // If invalid, we can't determine anything, show the banner for compliance sake
        const { isValid } = (0, _transformer.checkTokenVersionValidity)(prefetchedPreferencesData.consentToken);
        return isValid ? (0, _getBannerVisibility.getBannerVisibility)(prefetchedPreferencesData, ssrOptions) : true;
    }
    // We've been given ConsentHub response data
    // Check if we have consents via prefetched data
    // to prevent mismatches where space is reserved but UI doesn't render
    const prefetchedDataHasConsents = (0, _utils.hasPrefetchedDataConsents)(prefetchedPreferencesData);
    if (prefetchedDataHasConsents) return false;
    // Format it appropriately and use getBannerVisibility for proper staleness/fallback checks
    const consentPrefsData = (0, _consentHubService.buildConsentPreferences)(prefetchedPreferencesData);
    return (0, _getBannerVisibility.getBannerVisibility)(consentPrefsData, ssrOptions);
};

},{"@atlaskit/platform-feature-flags":"8rD2i","../../../services/consent-hub-service":"8HdyV","../../../services/consent-hub-service/utils":"8vzek","../../cookie-controls/transformer":"hcsh1","../get-banner-visibility":"bByh5","@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"8AQMZ":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "checkThirdParty", ()=>(0, _checkThirdParty.checkThirdParty));
parcelHelpers.export(exports, "isThirdPartyAllowed", ()=>(0, _thirdPartyVerification.isThirdPartyAllowed));
var _checkThirdParty = require("./check-third-party");
var _thirdPartyVerification = require("./third-party-verification");

},{"./check-third-party":"4S6Hi","./third-party-verification":false,"@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"4S6Hi":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "checkThirdParty", ()=>checkThirdParty);
var _utils = require("../../../common/utils");
var _logger = require("../../../common/utils/logger");
var _thirdPartyVerification = require("../third-party-verification");
const checkThirdParty = async (thirdParty, onAllowed, onDenied)=>{
    try {
        const isAllowed = await (0, _thirdPartyVerification.isThirdPartyAllowed)(thirdParty);
        (0, _utils.sendPackageOperationalEvent)({
            action: 'usedCheckThirdParty',
            attributes: {
                wasRejected: !isAllowed,
                thirdParty
            }
        });
        return isAllowed ? onAllowed() : onDenied === null || onDenied === void 0 ? void 0 : onDenied();
    } catch (e) {
        (0, _logger.Logger).errorWithOperationalEvent({
            action: 'checkThirdPartyError',
            attributes: {
                wasRejected: true,
                thirdParty
            },
            message: `Failed to use check third party. ${e.message || ''}`
        });
    }
};

},{"../../../common/utils":"gnWyu","../../../common/utils/logger":"2Tk7J","../third-party-verification":"9ksoT","@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"9ksoT":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "isThirdPartyAllowed", ()=>isThirdPartyAllowed);
var _core = require("../../../common/utils/bsc-global-state/core");
var _types = require("../../../types");
var _getPreferences = require("../../preferences-controls/get-preferences");
const isThirdPartyAllowed = async (thirdParty)=>{
    /*
    If third party has no category or data doesn't resolve, deny.
    If third party is StrictlyNecessary, allow unconditionally.
    If no preferences are stored for any other category, deny.
    If third party has a category, check preferences and allow/deny.
  */ const { loadCache } = (0, _core.getBscGlobalState)();
    const storageControlsData = await loadCache((0, _types.CategoryStorageType).Cookies);
    let thirdPartyCategory = null;
    if (storageControlsData) {
        const { thirdPartyKeys, categories } = storageControlsData;
        const thirdPartyCategoryNumber = thirdPartyKeys[thirdParty];
        const numToCategoryMap = {
            [categories.STRICTLY_NECESSARY]: (0, _types.PreferenceCategory).StrictlyNecessary,
            [categories.FUNCTIONAL]: (0, _types.PreferenceCategory).Functional,
            [categories.ANALYTICS]: (0, _types.PreferenceCategory).Analytics,
            [categories.MARKETING]: (0, _types.PreferenceCategory).Marketing,
            [categories.UNKNOWN]: (0, _types.PreferenceCategory).Unknown
        };
        thirdPartyCategory = thirdPartyCategoryNumber !== null ? numToCategoryMap[thirdPartyCategoryNumber] : null;
    }
    // StrictlyNecessary items are always allowed regardless of stored preferences,
    // matching the behaviour of isProcessingAllowedByPreferences.
    if (thirdPartyCategory === (0, _types.PreferenceCategory).StrictlyNecessary) return true;
    // No preferences stored — deny all non-strictly-necessary third parties.
    const preferences = await (0, _getPreferences.getPreferences)();
    if (!preferences) return false;
    // Check the user's stored preference for this category.
    let isAllowedByPreferences = false;
    if (thirdPartyCategory) isAllowedByPreferences = preferences[thirdPartyCategory];
    return isAllowedByPreferences;
};

},{"../../../common/utils/bsc-global-state/core":"Lu8Q3","../../../types":"65Pa5","../../preferences-controls/get-preferences":"030sv","@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"hPe36":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "getBannerVisibility", ()=>(0, _getBannerVisibility.getBannerVisibility));
parcelHelpers.export(exports, "shouldRenderBanner", ()=>(0, _shouldBannerRender.shouldRenderBanner));
parcelHelpers.export(exports, "shouldRenderBannerPrefetched", ()=>(0, _shouldBannerRenderPrefetched.shouldRenderBannerPrefetched));
var _getBannerVisibility = require("./get-banner-visibility");
var _shouldBannerRender = require("./should-banner-render");
var _shouldBannerRenderPrefetched = require("./should-banner-render-prefetched");

},{"./get-banner-visibility":false,"./should-banner-render":"YymGL","./should-banner-render-prefetched":"9ZYdd","@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"YymGL":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "shouldRenderBanner", ()=>shouldRenderBanner);
var _helpers = require("../../../common/utils/helpers");
var _logger = require("../../../common/utils/logger");
var _constants = require("../../../constants");
var _utils = require("../../cookie-controls/get-consent-token/utils");
var _getCookie = require("../../cookie-controls/get-cookie");
var _setRequiredConsentCookies = require("../../cookie-controls/set-required-consent-cookies");
var _transformer = require("../../cookie-controls/transformer");
const shouldRenderBanner = async ()=>{
    const fallbackConsentToken = (0, _getCookie.getCookie)((0, _constants.ATLASSIAN_CONSENT_FALLBACK_COOKIE_KEY));
    const consentToken = (0, _getCookie.getCookie)((0, _constants.ATLASSIAN_CONSENT_COOKIE_KEY)) || '';
    const cachedShouldShowBanner = (0, _helpers.getBoolFromBitValue)((0, _getCookie.getCookie)((0, _constants.ATLASSIAN_SHOW_BANNER_COOKIE_KEY)));
    if (cachedShouldShowBanner) {
        (0, _logger.Logger).debug(`shouldRenderBanner: Rendering banner becaue of show banner cookie ${(0, _constants.ATLASSIAN_SHOW_BANNER_COOKIE_KEY)}`);
        /* Once consents are made in a live environment, this function will return false 98% of the time
      making it nearly impossible to test. This check gives us the capability to force showing the banner for testing.
      ... However, we are introducing a potential discrepancy issue in the future for some adopters where this
      cache bit check may be out of sync/inaccurate, but we're okay with that for now. */ return true;
    }
    const noCachedCookies = !consentToken;
    const validCachedConsentToken = (0, _transformer.checkTokenVersionValidity)(consentToken).isValid;
    const consentData = noCachedCookies ? await (0, _utils.getValidConsentData)(fallbackConsentToken) : {
        consentToken,
        fallbackConsentToken
    };
    if (!consentData || !noCachedCookies && !validCachedConsentToken) {
        (0, _logger.Logger).debug('shouldRenderBanner: Rendered banner because no consent data found');
        // No consent data: the token value we fetched was deemed invalid for some reason, show the banner for compliance
        return true;
    }
    (0, _setRequiredConsentCookies.setRequiredConsentCookies)(consentData.consentToken, consentData.consentTimestamp);
    const shouldShowBanner = (0, _helpers.getBoolFromBitValue)((0, _getCookie.getCookie)((0, _constants.ATLASSIAN_SHOW_BANNER_COOKIE_KEY)));
    (0, _logger.Logger).debug(`shouldShowBanner: render computed based on ATLASSIAN_SHOW_BANNER_COOKIE_KEY after setting consents: ${shouldShowBanner}`);
    return !!shouldShowBanner;
};

},{"../../../common/utils/helpers":"kWrwq","../../../common/utils/logger":"2Tk7J","../../../constants":"9FHD5","../../cookie-controls/get-consent-token/utils":"4efx5","../../cookie-controls/get-cookie":"VS0K5","../../cookie-controls/set-required-consent-cookies":"j36f0","../../cookie-controls/transformer":"hcsh1","@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"6jQmL":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "Status", ()=>Status);
var Status = /*#__PURE__*/ function(Status) {
    Status["SUCCESS"] = "SUCCESS";
    Status["BLOCKED"] = "BLOCKED";
    Status["FAILED"] = "FAILED";
    return Status;
}({});

},{"@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"MZEJS":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "checkDBAvailability", ()=>(0, _utils1.checkDBAvailability));
parcelHelpers.export(exports, "isValidDBName", ()=>(0, _utils1.isValidDBName));
parcelHelpers.export(exports, "isValidVersion", ()=>(0, _utils1.isValidVersion));
parcelHelpers.export(exports, "isIndexedDbDatabaseAllowed", ()=>isIndexedDbDatabaseAllowed);
parcelHelpers.export(exports, "atlIndexedDb", ()=>atlIndexedDb);
parcelHelpers.export(exports, "AtlIndexedDb", ()=>AtlIndexedDb);
var _objectSpread = require("@swc/helpers/_/_object_spread");
var _platformFeatureFlags = require("@atlaskit/platform-feature-flags");
var _utils = require("../../common/utils");
var _itemProcessing = require("../../common/utils/item-processing");
var _logger = require("../../common/utils/logger");
var _types = require("../../types");
var _itemKeyCacheService = require("../item-key-cache-service");
var _idbOpenRequestWrapper = require("./idb-open-request-wrapper");
var _utils1 = require("./utils");
const isIndexedDbDatabaseAllowed = async (dbName)=>{
    const availability = (0, _utils1.checkDBAvailability)();
    if (availability.bypassImplementation) // Fallback to allowing if it bypassed for any reason (support disabled, killswitch, etc)
    return true;
    let isAllowed;
    let resolvedItemCategory;
    if ((0, _platformFeatureFlags.fg)('platform_bsc_add_category_to_idb_open_events')) ({ isAllowed, itemCategory: resolvedItemCategory } = await (0, _itemProcessing.isProcessingAllowedByPreferencesWithCategory)({
        itemKey: dbName,
        storageType: (0, _types.CategoryStorageType).IndexedDB
    }));
    else isAllowed = await (0, _itemProcessing.isProcessingAllowedByPreferences)({
        itemKey: dbName,
        storageType: (0, _types.CategoryStorageType).IndexedDB
    });
    const categoryAttribute = resolvedItemCategory !== undefined ? {
        itemCategory: resolvedItemCategory !== null && resolvedItemCategory !== void 0 ? resolvedItemCategory : (0, _types.PreferenceCategory).Unknown
    } : {};
    (0, _utils.sendPackageOperationalEvent)({
        action: 'usedAtlIndexedDBOpen',
        attributes: (0, _objectSpread._)({
            databaseName: dbName,
            wasRejected: !isAllowed
        }, categoryAttribute)
    });
    return isAllowed;
};
/**
 * AtlIndexedDb is a wrapper around the IDBFactory interface that provides
 * additional checks before opening the database, such as:
 * - SSR environment detection
 * - Feature flag checks
 * - Input validation
 * - Error logging
 *
 * When bypass mode is active, this wrapper skips special validation and delegates
 * directly to the configured IDBFactory, allowing the application to fall back to default
 * browser behavior.
 *
 * This class implements the IDBFactory interface and delegates all methods to the wrapped
 * IDBFactory instance.
 */ class AtlIndexedDb {
    getIsAvailable() {
        return this.isAvailable;
    }
    getIsBypassingImplementation() {
        return this.bypassImplementation;
    }
    /**
	 * Opens a database connection with additional validation and checks
	 * @param dbName - The name of the database to open
	 * @param version - Optional version number for the database
	 * @returns An IDBOpenDBRequest (use with event handlers or wrap in Promise for async/await)
	 * @throws Error if database name is invalid, IndexedDB is not available (unless bypass mode is active), or the wrapped IDBFactory throws an error
	 *
	 * When bypass mode is active, validation is skipped and the wrapped IDBFactory is used directly.
	 */ open(dbName, version) {
        (0, _logger.Logger).debug(`IndexedDB operation: open on database \"${dbName}\"`, {
            version: String(version !== null && version !== void 0 ? version : 'unspecified')
        });
        if (!(0, _utils.getBscGlobalState)().hasInitialized && (0, _platformFeatureFlags.fg)('platform_bsc_initialize_controls_analytics')) (0, _utils.sendPackageOperationalEvent)({
            action: 'setItemWithoutInit',
            attributes: {
                itemKey: dbName,
                storageType: 'IndexedDB'
            }
        });
        // If bypass mode is active, skip implementation and use wrapped IDBFactory directly
        if (this.bypassImplementation) return this.config.idbFactory.open(dbName, version);
        if (!(0, _utils1.isValidDBName)(dbName)) {
            const error = new Error('Invalid database name: must be a non-empty string');
            (0, _logger.Logger).errorWithOperationalEvent({
                action: 'usedAtlIndexedDBOpenError',
                attributes: {
                    databaseName: dbName
                },
                message: `IndexedDB open failed: ${error.message}`
            });
            throw error;
        }
        if (!(0, _utils1.isValidVersion)(version)) {
            const error = new Error('Invalid version: must be a positive integer or undefined');
            (0, _logger.Logger).errorWithOperationalEvent({
                action: 'usedAtlIndexedDBOpenError',
                attributes: {
                    databaseName: dbName
                },
                message: `IndexedDB open failed: ${error.message}`
            });
            throw error;
        }
        const availabilityCheck = (0, _utils1.checkDBAvailability)(this.config.enableSSRCheck, this.config.enableFeatureFlagCheck);
        if (!availabilityCheck.available) {
            if (this.config.noOpWhenUnavailable) // In some runtimes (SSR/service worker), consumers still want to import a shared
            // instance without having to guard every call.
            return (0, _idbOpenRequestWrapper.createIDBOpenDBRequestWrapper)();
            const error = new Error(`Cannot open database: ${availabilityCheck.reason || 'IndexedDB is not available'}`);
            (0, _logger.Logger).errorWithOperationalEvent({
                action: 'usedAtlIndexedDBOpenError',
                attributes: {
                    databaseName: dbName
                },
                message: `IndexedDB open failed: ${error.message}`
            });
            throw error;
        }
        const requestWrapper = (0, _idbOpenRequestWrapper.createIDBOpenDBRequestWrapper)();
        const globalState = (0, _utils.getBscGlobalState)();
        const productName = globalState.product;
        var _globalState_disableIndexedDbConsentChecks;
        let disableIndexedDbConsentChecks = (_globalState_disableIndexedDbConsentChecks = globalState.disableIndexedDbConsentChecks) !== null && _globalState_disableIndexedDbConsentChecks !== void 0 ? _globalState_disableIndexedDbConsentChecks : false;
        if ((0, _platformFeatureFlags.fg)('jfp-magma-selective-storage-enforcement')) {
            var _globalState___UNSAFE_shouldEnforceKeyForRollout;
            const enforceThisKey = ((_globalState___UNSAFE_shouldEnforceKeyForRollout = globalState.__UNSAFE_shouldEnforceKeyForRollout) === null || _globalState___UNSAFE_shouldEnforceKeyForRollout === void 0 ? void 0 : _globalState___UNSAFE_shouldEnforceKeyForRollout.call(globalState, dbName, (0, _types.CategoryStorageType).IndexedDB)) === true;
            var _globalState_disableIndexedDbConsentChecks1;
            disableIndexedDbConsentChecks = ((_globalState_disableIndexedDbConsentChecks1 = globalState.disableIndexedDbConsentChecks) !== null && _globalState_disableIndexedDbConsentChecks1 !== void 0 ? _globalState_disableIndexedDbConsentChecks1 : false) && !enforceThisKey;
        }
        if (disableIndexedDbConsentChecks) {
            // Consent checks are disabled for rollout testing — send analytics but always allow
            if ((0, _platformFeatureFlags.fg)('platform_bsc_add_category_to_idb_open_events')) (0, _itemProcessing.getItemCategory)(dbName, (0, _types.CategoryStorageType).IndexedDB, productName).then((itemCategory)=>{
                (0, _utils.sendPackageOperationalEvent)({
                    action: 'usedAtlIndexedDBOpen',
                    attributes: {
                        databaseName: dbName,
                        wasRejected: false,
                        consentChecksDisabled: true,
                        itemCategory: itemCategory !== null && itemCategory !== void 0 ? itemCategory : (0, _types.PreferenceCategory).Unknown
                    }
                });
            }).catch((e)=>{
                const errorMessage = e instanceof Error ? e.message : String(e);
                (0, _logger.Logger).errorWithOperationalEvent({
                    action: 'usedAtlIndexedDBOpenError',
                    attributes: {
                        databaseName: dbName
                    },
                    message: `IndexedDB open failed: ${errorMessage}`
                });
            });
            else (0, _utils.sendPackageOperationalEvent)({
                action: 'usedAtlIndexedDBOpen',
                attributes: {
                    databaseName: dbName,
                    wasRejected: false,
                    consentChecksDisabled: true
                }
            });
            (0, _itemKeyCacheService.ItemKeyCache).markSetByPackage((0, _types.CategoryStorageType).IndexedDB, dbName);
            const actualRequest = this.config.idbFactory.open(dbName, version);
            requestWrapper.wrapRequest(actualRequest);
            return requestWrapper;
        }
        ((0, _platformFeatureFlags.fg)('platform_bsc_add_category_to_idb_open_events') ? (0, _itemProcessing.isProcessingAllowedByPreferencesWithCategory)({
            itemKey: dbName,
            storageType: (0, _types.CategoryStorageType).IndexedDB,
            productName
        }).then(({ isAllowed, itemCategory })=>{
            const categoryAttribute = {
                itemCategory: itemCategory !== null && itemCategory !== void 0 ? itemCategory : (0, _types.PreferenceCategory).Unknown
            };
            if (isAllowed) {
                (0, _itemKeyCacheService.ItemKeyCache).markSetByPackage((0, _types.CategoryStorageType).IndexedDB, dbName);
                (0, _utils.sendPackageOperationalEvent)({
                    action: 'usedAtlIndexedDBOpen',
                    attributes: (0, _objectSpread._)({
                        databaseName: dbName,
                        wasRejected: false
                    }, categoryAttribute)
                });
                const actualRequest = this.config.idbFactory.open(dbName, version);
                // Wrap the actual request to forward all events
                requestWrapper.wrapRequest(actualRequest);
            } else {
                (0, _utils.sendPackageOperationalEvent)({
                    action: 'usedAtlIndexedDBOpen',
                    attributes: (0, _objectSpread._)({
                        databaseName: dbName,
                        wasRejected: true
                    }, categoryAttribute)
                });
                if (itemCategory === null) (0, _logger.Logger).warn(`indexedDB.open('${dbName}') was blocked` + `${productName ? ` for product "${productName}"` : ''}` + `: '${dbName}' is not registered in the BSC data store. Add it to the data store before calling this API.`);
                const blockedEvent = new Event('storageItemBlocked');
                requestWrapper.dispatchEvent(blockedEvent);
            }
        }) : (0, _itemProcessing.isProcessingAllowedByPreferences)({
            itemKey: dbName,
            storageType: (0, _types.CategoryStorageType).IndexedDB,
            productName,
            allowedCallback: ()=>{
                (0, _itemKeyCacheService.ItemKeyCache).markSetByPackage((0, _types.CategoryStorageType).IndexedDB, dbName);
                (0, _utils.sendPackageOperationalEvent)({
                    action: 'usedAtlIndexedDBOpen',
                    attributes: {
                        databaseName: dbName,
                        wasRejected: false
                    }
                });
                const actualRequest = this.config.idbFactory.open(dbName, version);
                // Wrap the actual request to forward all events
                requestWrapper.wrapRequest(actualRequest);
            },
            blockedCallback: ({ itemCategory: blockedItemCategory })=>{
                (0, _utils.sendPackageOperationalEvent)({
                    action: 'usedAtlIndexedDBOpen',
                    attributes: {
                        databaseName: dbName,
                        wasRejected: true
                    }
                });
                if (blockedItemCategory === null) (0, _logger.Logger).warn(`indexedDB.open('${dbName}') was blocked` + `${productName ? ` for product "${productName}"` : ''}` + `: '${dbName}' is not registered in the BSC data store. Add it to the data store before calling this API.`);
                const blockedEvent = new Event('storageItemBlocked');
                requestWrapper.dispatchEvent(blockedEvent);
            }
        }).then(()=>{
        // Handled by callbacks above
        })).catch((e)=>{
            const errorMessage = e instanceof Error ? e.message : String(e);
            (0, _logger.Logger).errorWithOperationalEvent({
                action: 'usedAtlIndexedDBOpenError',
                attributes: {
                    databaseName: dbName
                },
                message: `IndexedDB open failed during preference check: ${errorMessage}`
            });
            const errorEvent = new ErrorEvent('error', {
                message: errorMessage
            });
            requestWrapper.dispatchEvent(errorEvent);
        });
        return requestWrapper;
    }
    /**
	 * Opens a database connection without checking user consent preferences.
	 * This method should ONLY be used for strictly necessary databases that are critical
	 * for application functionality and do not require user consent.
	 *
	 * @param dbName - The name of the database to open
	 * @param version - Optional version number for the database
	 * @returns An IDBOpenDBRequest
	 * @throws Error if database name is invalid, IndexedDB is not available, or the wrapped IDBFactory throws an error
	 *
	 * This method performs validation and availability checks but bypasses consent enforcement.
	 */ openStrictlyNecessary(dbName, version) {
        (0, _logger.Logger).debug(`IndexedDB operation: openStrictlyNecessary on database \"${dbName}\"`, {
            version: String(version !== null && version !== void 0 ? version : 'unspecified')
        });
        if (!(0, _utils.getBscGlobalState)().hasInitialized && (0, _platformFeatureFlags.fg)('platform_bsc_initialize_controls_analytics')) (0, _utils.sendPackageOperationalEvent)({
            action: 'setItemWithoutInit',
            attributes: {
                itemKey: dbName,
                storageType: 'IndexedDB'
            }
        });
        if (!(0, _utils1.isValidDBName)(dbName)) {
            const error = new Error('Invalid database name: must be a non-empty string');
            (0, _logger.Logger).errorWithOperationalEvent({
                action: 'usedAtlIndexedDBOpenStrictlyNecessaryError',
                attributes: {
                    databaseName: dbName
                },
                message: `IndexedDB openStrictlyNecessary failed: ${error.message}`
            });
            throw error;
        }
        if (!(0, _utils1.isValidVersion)(version)) {
            const error = new Error('Invalid version: must be a positive integer or undefined');
            (0, _logger.Logger).errorWithOperationalEvent({
                action: 'usedAtlIndexedDBOpenStrictlyNecessaryError',
                attributes: {
                    databaseName: dbName
                },
                message: `IndexedDB openStrictlyNecessary failed: ${error.message}`
            });
            throw error;
        }
        const availabilityCheck = (0, _utils1.checkDBAvailability)(this.config.enableSSRCheck, this.config.enableFeatureFlagCheck);
        if (!availabilityCheck.available) {
            if (this.config.noOpWhenUnavailable) return (0, _idbOpenRequestWrapper.createIDBOpenDBRequestWrapper)();
            const error = new Error(`Cannot open database: ${availabilityCheck.reason || 'IndexedDB is not available'}`);
            (0, _logger.Logger).errorWithOperationalEvent({
                action: 'usedAtlIndexedDBOpenStrictlyNecessaryError',
                attributes: {
                    databaseName: dbName
                },
                message: `IndexedDB openStrictlyNecessary failed: ${error.message}`
            });
            throw error;
        }
        try {
            (0, _utils.sendPackageOperationalEvent)({
                action: 'usedAtlIndexedDBOpenStrictlyNecessary',
                attributes: {
                    databaseName: dbName
                }
            });
        } catch (e) {
            // Don't fail the operation if event sending fails
            const errorMessage = e instanceof Error ? e.message : String(e);
            (0, _logger.Logger).warn(`Failed to send operational event for openStrictlyNecessary: ${errorMessage}`);
        }
        return this.config.idbFactory.open(dbName, version);
    }
    /**
	 * Deletes a database by delegating directly to the wrapped IDBFactory instance.
	 * @param dbName - The name of the database to delete
	 * @returns An IDBOpenDBRequest
	 */ deleteDatabase(dbName) {
        if (!this.getIsAvailable() && this.config.noOpWhenUnavailable) return (0, _idbOpenRequestWrapper.createIDBOpenDBRequestWrapper)();
        return this.config.idbFactory.deleteDatabase(dbName);
    }
    /**
	 * Gets a list of available databases by delegating directly to the wrapped IDBFactory instance.
	 * @returns A promise that resolves to a list of database info objects
	 */ async databases() {
        if (this.config.idbFactory.databases && typeof this.config.idbFactory.databases === 'function') return await this.config.idbFactory.databases();
        return [];
    }
    /**
	 * Compares two values for use as IndexedDB keys by delegating to the wrapped IDBFactory instance.
	 * @param first - The first value to compare
	 * @param second - The second value to compare
	 * @returns A negative, zero, or positive value depending on the comparison result
	 */ cmp(first, second) {
        return this.config.idbFactory.cmp(first, second);
    }
    constructor(config){
        var _config_enableSSRCheck, _config_enableFeatureFlagCheck, _config_noOpWhenUnavailable, _config_idbFactory;
        this.config = {
            enableSSRCheck: (_config_enableSSRCheck = config === null || config === void 0 ? void 0 : config.enableSSRCheck) !== null && _config_enableSSRCheck !== void 0 ? _config_enableSSRCheck : true,
            enableFeatureFlagCheck: (_config_enableFeatureFlagCheck = config === null || config === void 0 ? void 0 : config.enableFeatureFlagCheck) !== null && _config_enableFeatureFlagCheck !== void 0 ? _config_enableFeatureFlagCheck : true,
            noOpWhenUnavailable: (_config_noOpWhenUnavailable = config === null || config === void 0 ? void 0 : config.noOpWhenUnavailable) !== null && _config_noOpWhenUnavailable !== void 0 ? _config_noOpWhenUnavailable : false,
            idbFactory: (_config_idbFactory = config === null || config === void 0 ? void 0 : config.idbFactory) !== null && _config_idbFactory !== void 0 ? _config_idbFactory : globalThis.indexedDB
        };
        // Perform initial availability check
        const availabilityCheck = (0, _utils1.checkDBAvailability)(this.config.enableSSRCheck, this.config.enableFeatureFlagCheck);
        this.isAvailable = availabilityCheck.available;
        var _availabilityCheck_bypassImplementation;
        this.bypassImplementation = (_availabilityCheck_bypassImplementation = availabilityCheck.bypassImplementation) !== null && _availabilityCheck_bypassImplementation !== void 0 ? _availabilityCheck_bypassImplementation : false;
        if (!this.isAvailable) {
            if (this.config.noOpWhenUnavailable) (0, _logger.Logger).debug(`AtlIndexedDb unavailable (no-op mode): ${availabilityCheck.reason}`);
            else (0, _logger.Logger).warn(`AtlIndexedDb initialization warning: ${availabilityCheck.reason}`);
        } else if (this.bypassImplementation) (0, _logger.Logger).debug(`AtlIndexedDb bypassing implementation: ${availabilityCheck.reason}`);
    }
}
const atlIndexedDb = new AtlIndexedDb({
    noOpWhenUnavailable: true
});

},{"@swc/helpers/_/_object_spread":"9gdrV","@atlaskit/platform-feature-flags":"8rD2i","../../common/utils":"gnWyu","../../common/utils/item-processing":"8zwf4","../../common/utils/logger":"2Tk7J","../../types":"65Pa5","../item-key-cache-service":"4UZqe","./idb-open-request-wrapper":"iPrOZ","./utils":"aFAAe","@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"6qZUO":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "LS_ROVO_SIDEBAR_STATE_KEY", ()=>LS_ROVO_SIDEBAR_STATE_KEY);
const LS_ROVO_SIDEBAR_STATE_KEY = 'rovo-sidebar-state';

},{"@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"a6iyv":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "useInitialiseFeatureGatesClient", ()=>(0, _useInitialiseFeatureGatesClient.useInitialiseFeatureGatesClient));
parcelHelpers.export(exports, "featureGatesOptions", ()=>(0, _useInitialiseFeatureGatesClient.featureGatesOptions));
parcelHelpers.export(exports, "DevToolsDialogAndToggle", ()=>(0, _devToolsModal.DevToolsDialogAndToggle));
parcelHelpers.export(exports, "studioFg", ()=>(0, _persistance.studioFg));
parcelHelpers.export(exports, "overrideGate", ()=>(0, _persistance.overrideGate));
parcelHelpers.export(exports, "clearGateOverride", ()=>(0, _persistance.clearGateOverride));
parcelHelpers.export(exports, "clearAllOverrides", ()=>(0, _persistance.clearAllOverrides));
parcelHelpers.export(exports, "updateUser", ()=>(0, _updateUser.updateUser));
parcelHelpers.export(exports, "useDynamicPromptFGOverride", ()=>(0, _useDynamicPromptFgOverride.useDynamicPromptFGOverride));
var _useInitialiseFeatureGatesClient = require("./common/use-initialise-feature-gates-client");
var _devToolsModal = require("./ui/dev-tools-modal");
var _persistance = require("./common/persistance");
var _updateUser = require("./common/update-user");
var _useDynamicPromptFgOverride = require("./common/hooks/use-dynamic-prompt-fg-override");

},{"./common/use-initialise-feature-gates-client":"lJALp","./ui/dev-tools-modal":"28jJZ","./common/persistance":"ajVwM","./common/update-user":"2Qg7Q","./common/hooks/use-dynamic-prompt-fg-override":"6LqZs","@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"lJALp":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "featureGatesOptions", ()=>featureGatesOptions);
parcelHelpers.export(exports, "useInitialiseFeatureGatesClient", ()=>useInitialiseFeatureGatesClient);
var _react = require("react");
var _reactMagneticDi = require("react-magnetic-di");
var _featureGateJsClient = require("@atlaskit/feature-gate-js-client");
var _featureGateJsClientDefault = parcelHelpers.interopDefault(_featureGateJsClient);
var _platformFeatureFlags = require("@atlaskit/platform-feature-flags");
var _atlassianStudioCommon = require("@atlassian/atlassian-studio-common");
var _atlassianStudioEnvUtils = require("@atlassian/atlassian-studio-env-utils");
var _atlassianStudioObservability = require("@atlassian/atlassian-studio-observability");
var _persistance = require("../persistance");
const isProd = (0, _atlassianStudioEnvUtils.getMappedEnv)() === 'production';
const featureGatesOptions = {
    apiKey: (0, _atlassianStudioCommon.getConfig)().featureGateApiKey,
    environment: isProd ? (0, _featureGateJsClient.FeatureGateEnvironment).Production : (0, _featureGateJsClient.FeatureGateEnvironment).Staging,
    targetApp: 'atlassian-studio_web',
    perimeter: (0, _featureGateJsClient.PerimeterType).COMMERCIAL
};
const useInitialiseFeatureGatesClient = (identifiers, clientOptions, customAttributes)=>{
    (0, _reactMagneticDi.di)((0, _persistance.initCacheFromLocalStorage), (0, _platformFeatureFlags.setBooleanFeatureFlagResolver), (0, _atlassianStudioObservability.logException));
    const [initialized, setInitialized] = (0, _react.useState)(false);
    const [failReason, setFailReason] = (0, _react.useState)(null);
    const initialize = (0, _react.useCallback)(async ()=>{
        // check if supplied identifiers are all valid
        // if they are not, return early, do not initialize
        const validIdentifiers = Object.entries(identifiers).length === 0 ? false : Object.entries(identifiers).every(([_key, value])=>Boolean(value));
        // @NOTE: if any of the identifiers are invalid, do not bother initializing
        if (!validIdentifiers) return;
        try {
            await (0, _featureGateJsClientDefault.default).initialize(clientOptions, identifiers, customAttributes);
            await (0, _featureGateJsClientDefault.default).waitUntilInitializeCompleted();
            // @NOTE: prime the local-overides in-memory cache from ls-cache just once in here:
            (0, _persistance.initCacheFromLocalStorage)();
            // @NOTE: patch fg() from "@atlaskit/platform-feature-flags",
            // to use the new persisted feature gate value system
            (0, _platformFeatureFlags.setBooleanFeatureFlagResolver)((0, _persistance.studioFg));
            setInitialized(true);
            setFailReason(null);
        } catch (error) {
            (0, _atlassianStudioObservability.logException)(error, {
                identifiers
            });
            // eslint-disable-next-line no-console
            console.error("\uD83D\uDEA8 Error initializing feature gates:", error);
            if (error instanceof Error) setFailReason(error.message);
        }
    }, [
        identifiers,
        clientOptions,
        customAttributes
    ]);
    (0, _react.useEffect)(()=>{
        if (!initialized) initialize();
    }, [
        initialize,
        initialized
    ]);
    return {
        initialized,
        failReason
    };
};

},{"react":"ltHCL","react-magnetic-di":"hCzc8","@atlaskit/feature-gate-js-client":"27dQF","@atlaskit/platform-feature-flags":"8rD2i","@atlassian/atlassian-studio-common":"7YPMV","@atlassian/atlassian-studio-env-utils":"lO9Ek","@atlassian/atlassian-studio-observability":"5cVsH","../persistance":"ajVwM","@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"ajVwM":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "getOverridesFromCache", ()=>getOverridesFromCache);
parcelHelpers.export(exports, "parseStoredOverrides", ()=>parseStoredOverrides);
parcelHelpers.export(exports, "overrideGate", ()=>overrideGate);
parcelHelpers.export(exports, "clearGateOverride", ()=>clearGateOverride);
parcelHelpers.export(exports, "clearAllOverrides", ()=>clearAllOverrides);
parcelHelpers.export(exports, "setOverrides", ()=>setOverrides);
parcelHelpers.export(exports, "studioFg", ()=>studioFg);
parcelHelpers.export(exports, "initCacheFromLocalStorage", ()=>initCacheFromLocalStorage);
var _objectSpread = require("@swc/helpers/_/_object_spread");
var _featureGateJsClient = require("@atlaskit/feature-gate-js-client");
var _featureGateJsClientDefault = parcelHelpers.interopDefault(_featureGateJsClient);
var _constants = require("../constants");
const INITIAL_OVERRIDES = {
    gates: {},
    configs: {},
    layers: {}
};
let cachedOverrides = (0, _objectSpread._)({}, INITIAL_OVERRIDES);
const getLocalStorage = ()=>{
    try {
        // eslint-disable-next-line no-restricted-properties -- dev-tools FG override storage; must bypass BSC to avoid the circular dependency where BSC's behaviour is itself controlled by these gates.
        return window.localStorage;
    } catch (e) {
        return null;
    }
};
const getOverridesFromCache = ()=>{
    return (0, _objectSpread._)({}, cachedOverrides);
};
const parseStoredOverrides = ()=>{
    const storage = getLocalStorage();
    if (!storage) return (0, _objectSpread._)({}, INITIAL_OVERRIDES);
    try {
        const stored = storage.getItem((0, _constants.OVERRIDES_KEY));
        if (!stored) return (0, _objectSpread._)({}, INITIAL_OVERRIDES);
        return JSON.parse(stored);
    } catch (e) {
        return (0, _objectSpread._)({}, INITIAL_OVERRIDES);
    }
};
const saveOverrides = (overrides)=>{
    const storage = getLocalStorage();
    if (!storage) return;
    try {
        storage.setItem((0, _constants.OVERRIDES_KEY), JSON.stringify(overrides));
        cachedOverrides = (0, _objectSpread._)({}, overrides);
    } catch (e) {
    // Ignore storage errors
    }
};
const overrideGate = (name, value)=>{
    const currentOverrides = getOverridesFromCache();
    currentOverrides.gates[name] = value;
    saveOverrides(currentOverrides);
};
const clearGateOverride = (name)=>{
    const currentOverrides = getOverridesFromCache();
    delete currentOverrides.gates[name];
    saveOverrides(currentOverrides);
};
const clearAllOverrides = ()=>{
    const storage = getLocalStorage();
    if (!storage) return;
    try {
        storage.removeItem((0, _constants.OVERRIDES_KEY));
        cachedOverrides = (0, _objectSpread._)({}, INITIAL_OVERRIDES);
    } catch (e) {
    // Ignore storage errors
    }
};
const setOverrides = (overrides)=>{
    const currentOverrides = getOverridesFromCache();
    const mergedOverrides = {
        gates: (0, _objectSpread._)({}, currentOverrides.gates, overrides.gates),
        configs: (0, _objectSpread._)({}, currentOverrides.configs, overrides.configs),
        layers: (0, _objectSpread._)({}, currentOverrides.layers, overrides.layers)
    };
    saveOverrides(mergedOverrides);
};
const studioFg = (gateKey)=>{
    const currentOverrides = getOverridesFromCache();
    if (gateKey in currentOverrides.gates) return currentOverrides.gates[gateKey];
    // @NOTE: we need to eslint-disable here, because we have already done:
    // setBooleanFeatureFlagResolver(studioFg) - which will result in an infinite
    // loop, if we use fg() here
    // eslint-disable-next-line @atlaskit/platform/use-recommended-utils
    return (0, _featureGateJsClientDefault.default).checkGate(gateKey);
};
const initCacheFromLocalStorage = ()=>{
    const currentOverrides = parseStoredOverrides();
    cachedOverrides = (0, _objectSpread._)({}, currentOverrides);
};

},{"@swc/helpers/_/_object_spread":"9gdrV","@atlaskit/feature-gate-js-client":"27dQF","../constants":"jPCNk","@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"jPCNk":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "OVERRIDES_KEY", ()=>OVERRIDES_KEY);
const LS_PREFIX = 'ATLASSIAN-STUDIO-';
const OVERRIDES_KEY = `${LS_PREFIX}local-overrides`;

},{"@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"28jJZ":[function(require,module,exports,__globalThis) {
/* index.tsx generated by @compiled/babel-plugin v0.39.1 */ var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "DevToolsDialogAndToggle", ()=>DevToolsDialogAndToggle);
var _objectSpread = require("@swc/helpers/_/_object_spread");
var _objectSpreadProps = require("@swc/helpers/_/_object_spread_props");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _new = require("@atlaskit/button/new");
var _newDefault = parcelHelpers.interopDefault(_new);
var _flask = require("@atlaskit/icon/core/flask");
var _flaskDefault = parcelHelpers.interopDefault(_flask);
var _modalDialog = require("@atlaskit/modal-dialog");
var _modalDialogDefault = parcelHelpers.interopDefault(_modalDialog);
var _compiled = require("@atlaskit/primitives/compiled");
var _statsigLocalOverrides = require("./statsig-local-overrides");
const styles = {
    buttonWrapper: "_kqsw1n9t _94n5pxbi _1ltvpxbi _1pbyb4wl"
};
const DevToolsDialogAndToggle = ()=>{
    const [isOpen, setIsOpen] = (0, _react.useState)(false);
    return /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _reactDefault.default).Fragment, null, /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _compiled.Box), {
        xcss: styles.buttonWrapper
    }, /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _newDefault.default), {
        onClick: ()=>setIsOpen(!isOpen),
        appearance: "warning",
        iconBefore: (iconProps)=>/*#__PURE__*/ (0, _reactDefault.default).createElement((0, _flaskDefault.default), (0, _objectSpreadProps._)((0, _objectSpread._)({}, iconProps), {
                label: "Dev Tools"
            }))
    }, "Dev Tools")), /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _modalDialog.ModalTransition), null, isOpen && /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _modalDialogDefault.default), {
        onClose: ()=>setIsOpen(false),
        width: "720px"
    }, /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _modalDialog.ModalHeader), {
        hasCloseButton: true
    }, /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _modalDialog.ModalTitle), null, /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _compiled.Inline), {
        alignInline: "center",
        space: "space.100"
    }, /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _flaskDefault.default), {
        label: "Dev Tools",
        color: "var(--ds-icon-warning, #E06C00)"
    }), " Studio Dev Tools"))), /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _modalDialog.ModalBody), null, /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _statsigLocalOverrides.StatsigLocalOverridesTab), null)))));
};

},{"@swc/helpers/_/_object_spread":"9gdrV","@swc/helpers/_/_object_spread_props":"kANqQ","react":"ltHCL","@atlaskit/button/new":"aXnNi","@atlaskit/icon/core/flask":"6vVhv","@atlaskit/modal-dialog":"eJQED","@atlaskit/primitives/compiled":"hDay7","./statsig-local-overrides":"4tZzM","@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"6vVhv":[function(require,module,exports,__globalThis) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::3cc999648c0f38dff9696ef9958035f9>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = void 0;
var _react = _interopRequireDefault(require("40fa5664ee8e224"));
var _baseNew = _interopRequireDefault(require("6cb9d33fc6d8cb9c"));
function _interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "Flask".
 * Category: multi-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Multi purpose - Known uses: labs in Jira.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const FlaskIcon = (props)=>/*#__PURE__*/ _react.default.createElement(_baseNew.default, Object.assign({
        name: "FlaskIcon",
        dangerouslySetGlyph: `<path fill="currentcolor" d="M11.25 1v1.5h-.75v1.36l3.283 8.413A2 2 0 0 1 11.92 15H4.08a2 2 0 0 1-1.863-2.727L5.5 3.859V2.5h-.75V1zM3.614 12.818a.5.5 0 0 0 .466.682h7.84a.5.5 0 0 0 .466-.682L10.896 9H5.103zM7 4a.8.8 0 0 1-.052.272L5.69 7.5h4.621L9.052 4.272A.8.8 0 0 1 9 4V2.5H7z"/>`
    }, props));
FlaskIcon.displayName = 'FlaskIcon';
var _default = exports.default = FlaskIcon;

},{"40fa5664ee8e224":"ltHCL","6cb9d33fc6d8cb9c":"5XL7D"}],"4tZzM":[function(require,module,exports,__globalThis) {
/* index.tsx generated by @compiled/babel-plugin v0.39.1 */ var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "StatsigLocalOverridesTab", ()=>StatsigLocalOverridesTab);
var _objectSpread = require("@swc/helpers/_/_object_spread");
var _objectSpreadProps = require("@swc/helpers/_/_object_spread_props");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _new = require("@atlaskit/button/new");
var _newDefault = parcelHelpers.interopDefault(_new);
var _code = require("@atlaskit/code");
var _dynamicTable = require("@atlaskit/dynamic-table");
var _dynamicTableDefault = parcelHelpers.interopDefault(_dynamicTable);
var _heading = require("@atlaskit/heading");
var _headingDefault = parcelHelpers.interopDefault(_heading);
var _platformFeatureFlags = require("@atlaskit/platform-feature-flags");
var _compiled = require("@atlaskit/primitives/compiled");
var _textarea = require("@atlaskit/textarea");
var _textareaDefault = parcelHelpers.interopDefault(_textarea);
var _tooltip = require("@atlaskit/tooltip");
var _tooltipDefault = parcelHelpers.interopDefault(_tooltip);
var _persistance = require("../../../common/persistance");
var _addOverride = require("../add-override");
var _dynamicPromptFgInput = require("../dynamic-prompt-fg-input");
var _studioAppSwitcherToggle = require("../studio-app-switcher-toggle");
var _templatingUtils = require("../utils/templating-utils");
const styles = {
    toggleTextarea: "_1rjcutpp",
    inputInstructionText: "_otyrutpp",
    descriptionText: "_19pkutpp",
    emptyView: "_n3tdpxbi _19pkxmi2",
    divider: "_uwhke4h9 _15a5nqa1 _1i531l7x _19pkpxbi _2hwxidpf _otyrpxbi _18u0idpf",
    inputContainer: "_1bsb1osq _otyrutpp _19pkutpp",
    buttonContainer: "_zulputpp _19pkutpp _otyrutpp",
    statsigTabContainer: "_19pku2gc _otyru2gc _2hwxidpf _18u0idpf _1bsb1osq",
    dynamicPromptFGInputContainer: "_19pkutpp _otyrutpp"
};
const textAreaStyles = {
    marginBottom: "var(--ds-space-150, 12px)",
    fontFamily: "var(--ds-font-family-code, \"Atlassian Mono\", ui-monospace, Menlo, \"Segoe UI Mono\", \"Ubuntu Mono\", monospace)"
};
const codeStyles = {
    display: 'inline',
    backgroundColor: "var(--ds-background-accent-gray-subtlest, #F0F1F2)",
    padding: "var(--ds-space-025, 2px)",
    borderRadius: "var(--ds-radius-small, 4px)"
};
const StatsigLocalOverridesTab = ()=>{
    const [overrides, setOverrides] = (0, _react.useState)((0, _persistance.getOverridesFromCache)());
    const [isCopied, setIsCopied] = (0, _react.useState)(false);
    const [jsonInput, setJsonInput] = (0, _react.useState)(()=>JSON.stringify((0, _persistance.getOverridesFromCache)(), null, 2));
    const [isTextareaCollapsed, setIsTextareaCollapsed] = (0, _react.useState)(true);
    const [isJsonValid, setIsJsonValid] = (0, _react.useState)(true);
    const updateOverrides = (0, _react.useCallback)(()=>{
        const newOverrides = (0, _persistance.getOverridesFromCache)();
        setOverrides((0, _objectSpread._)({}, newOverrides));
        setJsonInput(JSON.stringify(newOverrides, null, 2));
    }, []);
    const rows = (0, _react.useMemo)(()=>(0, _templatingUtils.getRows)(overrides, updateOverrides), [
        overrides,
        updateOverrides
    ]);
    const resetAll = (0, _react.useCallback)(()=>{
        if (window.confirm('Are you sure you want to remove all overrides?')) {
            (0, _persistance.clearAllOverrides)();
            updateOverrides();
        }
    }, [
        updateOverrides
    ]);
    const copy = (0, _react.useCallback)(()=>{
        const allData = JSON.stringify(overrides, null, 2);
        navigator.clipboard.writeText(allData).then(()=>{
            setIsCopied(true);
            setTimeout(()=>setIsCopied(false), 3000);
        });
    }, [
        overrides
    ]);
    const replaceAll = (0, _react.useCallback)(()=>{
        if (jsonInput && isJsonValid) try {
            const newOverrides = JSON.parse(jsonInput);
            (0, _persistance.clearAllOverrides)();
            (0, _persistance.setOverrides)(newOverrides);
            updateOverrides();
        } catch (e) {
            alert('Invalid JSON');
        }
    }, [
        jsonInput,
        isJsonValid,
        updateOverrides
    ]);
    const toggleTextarea = (0, _react.useCallback)(()=>{
        setIsTextareaCollapsed((prev)=>!prev);
    }, []);
    const onChangeValidation = (0, _react.useCallback)((event)=>{
        const inputValue = event.target.value;
        setJsonInput(inputValue);
        try {
            JSON.parse(inputValue);
            setIsJsonValid(true);
        } catch (e) {
            setIsJsonValid(false);
        }
    }, []);
    return /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _compiled.Box), {
        xcss: styles.statsigTabContainer
    }, /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _headingDefault.default), {
        size: "small",
        as: "h3"
    }, "Statsig local gate overrides"), /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _compiled.Box), {
        xcss: styles.descriptionText
    }, /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _compiled.Text), null, "Set local overrides for your Statsig gates below. Rerender your component to see the changes.", /*#__PURE__*/ (0, _reactDefault.default).createElement("br", null), /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _compiled.Text), {
        weight: "bold"
    }, "Note"), ": Local overrides will only apply to flags checked with the util function:", ' ', /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _code.Code), {
        size: 12,
        // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop
        style: codeStyles
    }, "studioFg('GATE_KEY')"), ".", /*#__PURE__*/ (0, _reactDefault.default).createElement("br", null), /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _compiled.Text), {
        weight: "bold"
    }, "Note"), ": Overrides in SSR stage only work in dev/staging environments and Hello.", /*#__PURE__*/ (0, _reactDefault.default).createElement("br", null), /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _compiled.Text), {
        weight: "bold"
    }, "Tip"), ": You can also set overrides via the", ' ', /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _compiled.Anchor), {
        href: "https://console.statsig.com/LqivKg6ADZZaGczRfBKfX/home",
        target: "_blank",
        rel: "noopener noreferrer"
    }, "Statsig console"), "."), /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _compiled.Inline), {
        xcss: styles.buttonContainer,
        testId: "button-container"
    }, /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _tooltipDefault.default), {
        content: "Clear all current feature gates and experiments overrides",
        position: "top"
    }, (tooltipProps)=>/*#__PURE__*/ (0, _reactDefault.default).createElement((0, _newDefault.default), (0, _objectSpreadProps._)((0, _objectSpread._)({}, tooltipProps), {
            appearance: "danger",
            isDisabled: Object.keys(overrides.gates).length === 0,
            onClick: resetAll
        }), "Remove all")), /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _tooltipDefault.default), {
        content: "Copy the JSON representation of all current feature gates and experiment overrides",
        position: "top"
    }, (tooltipProps)=>/*#__PURE__*/ (0, _reactDefault.default).createElement((0, _newDefault.default), (0, _objectSpreadProps._)((0, _objectSpread._)({}, tooltipProps), {
            appearance: "primary",
            isDisabled: Object.keys(overrides.gates).length === 0,
            onClick: copy
        }), isCopied ? 'Copied!' : 'Copy all')))), /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _dynamicTableDefault.default), {
        head: (0, _templatingUtils.TABLE_COLUMN_HEADINGS),
        rows: rows,
        emptyView: /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _compiled.Box), {
            xcss: styles.emptyView,
            testId: "no-overrides"
        }, /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _compiled.Text), {
            size: "small"
        }, "No overrides currently active"))
    }), /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _addOverride.AddOverride), {
        updateOverrides: updateOverrides
    }), /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _compiled.Box), {
        xcss: styles.divider
    }), /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _headingDefault.default), {
        size: "small",
        as: "h4"
    }, "Overrides in JSON format"), /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _compiled.Box), {
        xcss: styles.inputContainer
    }, !isTextareaCollapsed && /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _react.Fragment), null, /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _compiled.Box), {
        as: "p",
        xcss: styles.inputInstructionText
    }, 'Below shows the current JSON representation of the above feature gates and experiment overrides. You can modify this JSON and click "Apply (Put)" to update all overrides.'), !isJsonValid && /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _compiled.Text), {
        size: "small",
        color: "color.text.danger"
    }, "Invalid JSON format"), /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _textareaDefault.default), {
        name: "Overrides in JSON format",
        value: jsonInput,
        onChange: onChangeValidation,
        placeholder: "Paste JSON data here",
        style: (0, _objectSpreadProps._)((0, _objectSpread._)({}, textAreaStyles), {
            borderColor: isJsonValid ? 'initial' : 'red'
        })
    }), /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _tooltipDefault.default), {
        content: "Clear all current overrides and import the provided JSON",
        position: "top"
    }, (tooltipProps)=>/*#__PURE__*/ (0, _reactDefault.default).createElement((0, _newDefault.default), (0, _objectSpreadProps._)((0, _objectSpread._)({}, tooltipProps), {
            appearance: "primary",
            onClick: replaceAll,
            isDisabled: !isJsonValid
        }), "Apply (Put)"))), /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _compiled.Box), {
        xcss: styles.toggleTextarea
    }, /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _newDefault.default), {
        onClick: toggleTextarea
    }, isTextareaCollapsed ? "\u2193 Expand" : "\u2191 Collapse", " raw config in JSON"))), (0, _platformFeatureFlags.fg)('use-studio-dynamic-prompt-fg') && /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _reactDefault.default).Fragment, null, /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _compiled.Box), {
        xcss: styles.divider
    }), /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _headingDefault.default), {
        size: "small",
        as: "h4"
    }, "Dynamic Prompt FG"), /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _compiled.Box), {
        xcss: styles.dynamicPromptFGInputContainer
    }, /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _dynamicPromptFgInput.DynamicPromptFGInput), null))), /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _reactDefault.default).Fragment, null, /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _compiled.Box), {
        xcss: styles.divider
    }), /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _studioAppSwitcherToggle.StudioAppSwitcherToggle), {
        updateOverrides: updateOverrides
    })));
};

},{"@swc/helpers/_/_object_spread":"9gdrV","@swc/helpers/_/_object_spread_props":"kANqQ","react":"ltHCL","@atlaskit/button/new":"aXnNi","@atlaskit/code":"erLzu","@atlaskit/dynamic-table":"gVBKw","@atlaskit/heading":"61ZQz","@atlaskit/platform-feature-flags":"8rD2i","@atlaskit/primitives/compiled":"hDay7","@atlaskit/textarea":"dtb2r","@atlaskit/tooltip":"7RyYv","../../../common/persistance":"ajVwM","../add-override":"6BZyw","../dynamic-prompt-fg-input":"aiBCG","../studio-app-switcher-toggle":"uaLzV","../utils/templating-utils":"e4X6n","@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"erLzu":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "Code", ()=>(0, _codeDefault.default));
parcelHelpers.export(exports, "CodeBlock", ()=>(0, _codeBlockDefault.default));
parcelHelpers.export(exports, "SUPPORTED_LANGUAGES", ()=>(0, _constants.SUPPORTED_LANGUAGES));
var _code = require("./code");
var _codeDefault = parcelHelpers.interopDefault(_code);
var _codeBlock = require("./code-block");
var _codeBlockDefault = parcelHelpers.interopDefault(_codeBlock);
var _constants = require("./constants");

},{"./code":"wDFLs","./code-block":"25fkv","./constants":false,"@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"wDFLs":[function(require,module,exports,__globalThis) {
/* code.tsx generated by @compiled/babel-plugin v0.39.1 */ var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _objectSpread = require("@swc/helpers/_/_object_spread");
var _objectSpreadProps = require("@swc/helpers/_/_object_spread_props");
var _objectWithoutProperties = require("@swc/helpers/_/_object_without_properties");
var _runtime = require("@compiled/react/runtime");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _bidiWarning = require("./bidi-warning");
var _bidiWarningDefault = parcelHelpers.interopDefault(_bidiWarning);
var _bidiWarningDecorator = require("./bidi-warning/bidi-warning-decorator");
var _bidiWarningDecoratorDefault = parcelHelpers.interopDefault(_bidiWarningDecorator);
const styles = {
    base: "_ca0qyh40 _u5f3m5ip _n3tdyh40 _19bvm5ip _2rkofajl _11c819w5 _1reo1wug _18m91wug _1dqoglyw _1e0c1nu9 _bfhk187e _16d9qvcn _syazi7uo _vwz41kw7 _1i4q1hna _o5721jtm"
};
/**
 * __Code__
 *
 * Code highlights short strings of code snippets inline with body text.
 *
 * - [Examples](https://atlassian.design/components/code/examples)
 * - [Code](https://atlassian.design/components/code/code)
 * - [Usage](https://atlassian.design/components/code/usage)
 */ const Code = /*#__PURE__*/ (0, _react.memo)(/*#__PURE__*/ (0, _react.forwardRef)(function Code(_param, ref) {
    var { testId } = _param, props = (0, _objectWithoutProperties._)(_param, [
        "testId"
    ]);
    const { children, codeBidiWarnings = true, hasBidiWarnings, codeBidiWarningLabel, codeBidiWarningTooltipEnabled = true, isBidiWarningTooltipEnabled } = props, otherProps = (0, _objectWithoutProperties._)(props, [
        "children",
        "codeBidiWarnings",
        "hasBidiWarnings",
        "codeBidiWarningLabel",
        "codeBidiWarningTooltipEnabled",
        "isBidiWarningTooltipEnabled"
    ]);
    // Use new props if provided, otherwise fall back to deprecated props
    const shouldShowBidiWarnings = hasBidiWarnings !== undefined ? hasBidiWarnings : codeBidiWarnings;
    const shouldEnableTooltip = isBidiWarningTooltipEnabled !== undefined ? isBidiWarningTooltipEnabled : codeBidiWarningTooltipEnabled;
    const decoratedChildren = shouldShowBidiWarnings ? /*#__PURE__*/ (0, _reactDefault.default).createElement(RenderCodeChildrenWithBidiWarnings, {
        codeBidiWarningLabel: codeBidiWarningLabel,
        codeBidiWarningTooltipEnabled: shouldEnableTooltip
    }, children) : children;
    return /*#__PURE__*/ (0, _reactDefault.default).createElement("code", (0, _objectSpreadProps._)((0, _objectSpread._)({
        ref: ref,
        "data-testid": testId
    }, otherProps), {
        className: (0, _runtime.ax)([
            styles.base
        ])
    }), decoratedChildren);
}));
function RenderCodeChildrenWithBidiWarnings({ children, codeBidiWarningLabel, codeBidiWarningTooltipEnabled }) {
    const replacedChildren = (0, _reactDefault.default).Children.map(children, (childNode)=>{
        if (typeof childNode === 'string') {
            const decorated = (0, _bidiWarningDecoratorDefault.default)(childNode, ({ bidiCharacter, index })=>/*#__PURE__*/ (0, _reactDefault.default).createElement((0, _bidiWarningDefault.default), {
                    bidiCharacter: bidiCharacter,
                    key: index,
                    label: codeBidiWarningLabel,
                    tooltipEnabled: codeBidiWarningTooltipEnabled
                }));
            return decorated;
        }
        if (isReactElement(childNode) && childNode.props.children) {
            // eslint-disable-next-line @repo/internal/react/no-clone-element
            const newChildNode = /*#__PURE__*/ (0, _reactDefault.default).cloneElement(childNode, {
                children: /*#__PURE__*/ (0, _reactDefault.default).createElement(RenderCodeChildrenWithBidiWarnings, {
                    codeBidiWarningLabel: codeBidiWarningLabel,
                    codeBidiWarningTooltipEnabled: codeBidiWarningTooltipEnabled
                }, childNode.props.children)
            });
            return newChildNode;
        }
        return childNode;
    });
    return /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _reactDefault.default).Fragment, null, replacedChildren);
}
function isReactElement(child) {
    return !!child.type;
}
Code.displayName = 'Code';
exports.default = Code;

},{"@swc/helpers/_/_object_spread":"9gdrV","@swc/helpers/_/_object_spread_props":"kANqQ","@swc/helpers/_/_object_without_properties":"6HqIM","@compiled/react/runtime":"d27Vo","react":"ltHCL","./bidi-warning":"6YkSP","./bidi-warning/bidi-warning-decorator":"aBQPo","@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"6YkSP":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>(0, _uiDefault.default));
var _ui = require("./ui");
var _uiDefault = parcelHelpers.interopDefault(_ui);

},{"./ui":"5T4mI","@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"5T4mI":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>BidiWarning);
var _objectSpread = require("@swc/helpers/_/_object_spread");
var _objectSpreadProps = require("@swc/helpers/_/_object_spread_props");
var _objectWithoutProperties = require("@swc/helpers/_/_object_without_properties");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _tooltip = require("@atlaskit/tooltip");
var _tooltipDefault = parcelHelpers.interopDefault(_tooltip);
var _styled = require("./styled");
function BidiWarning({ testId, bidiCharacter, skipChildren, shouldSkipChildren, tooltipEnabled, isTooltipEnabled, label = 'Bidirectional characters change the order that text is rendered. This could be used to obscure malicious code.' }) {
    // Use new props if provided, otherwise fall back to deprecated props
    const shouldEnableTooltip = isTooltipEnabled !== undefined ? isTooltipEnabled : tooltipEnabled;
    const shouldSkip = shouldSkipChildren !== undefined ? shouldSkipChildren : skipChildren;
    if (shouldEnableTooltip) return(// Following patches, this should be updated to use the render props signature which will provide aria attributes.
    // Note: this should be tested, as initial testing did not see attributes work with current tooltip implementation.
    // @ts-ignore: [PIT-1685] Fails in post-office due to backwards incompatibility issue with React 18
    /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _tooltipDefault.default), {
        content: label,
        tag: CustomizedTagWithRef
    }, /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _styled.Decorator), {
        testId: testId,
        bidiCharacter: bidiCharacter
    }, shouldSkip ? null : bidiCharacter)));
    return /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _styled.Decorator), {
        testId: testId,
        bidiCharacter: bidiCharacter
    }, shouldSkip ? null : bidiCharacter);
}
const CustomizedTagWithRef = /*#__PURE__*/ (0, _reactDefault.default).forwardRef((props, ref)=>{
    const { children } = props, rest = (0, _objectWithoutProperties._)(props, [
        "children"
    ]);
    return /*#__PURE__*/ (0, _reactDefault.default).createElement("span", (0, _objectSpreadProps._)((0, _objectSpread._)({}, rest), {
        ref: ref
    }), children);
});

},{"@swc/helpers/_/_object_spread":"9gdrV","@swc/helpers/_/_object_spread_props":"kANqQ","@swc/helpers/_/_object_without_properties":"6HqIM","react":"ltHCL","@atlaskit/tooltip":"7RyYv","./styled":"7yLKN","@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"7yLKN":[function(require,module,exports,__globalThis) {
/* styled.tsx generated by @compiled/babel-plugin v0.39.1 */ var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "Decorator", ()=>Decorator);
var _react = require("react");
var _runtime = require("@compiled/react/runtime");
var _visuallyHidden = require("@atlaskit/visually-hidden");
var _visuallyHiddenDefault = parcelHelpers.interopDefault(_visuallyHidden);
const decoration = {
    root: "_kqswh2mm _szplfhey _dsq41wug _1xyt1b66 _123w1b66 _15nnze3t _rxygze3t _1a354jg8 _1j6rzzfg _1uakf6fq _1kt9y7el _is061xn9 _1rus1917 _1cfcvrvc _24gj1h6o _19o61h6o _cfu1116y _1rba1xn9 _1xqc19zu"
};
function Decorator({ bidiCharacter, children, testId }) {
    const bidiCharacterCode = getBidiCharacterCode(bidiCharacter);
    return /*#__PURE__*/ _react.createElement((0, _react.Fragment), null, /*#__PURE__*/ _react.createElement("span", {
        "data-testid": testId,
        "data-bidi-character-code": bidiCharacterCode,
        // This is set to true so that the content is not read out by
        // screen readers as the content includes angle brackets for
        // visual decoration purposes.
        // We use a visually hidden `mark` element below for screen readers
        "aria-hidden": "true",
        className: (0, _runtime.ax)([
            decoration.root
        ])
    }, children), /*#__PURE__*/ _react.createElement((0, _visuallyHiddenDefault.default), {
        testId: testId && `${testId}--visually-hidden`
    }, /*#__PURE__*/ _react.createElement("mark", null, bidiCharacterCode)));
}
function getBidiCharacterCode(bidiCharacter) {
    var _bidiCharacter_codePointAt;
    const bidiCharacterCode = (_bidiCharacter_codePointAt = bidiCharacter.codePointAt(0)) === null || _bidiCharacter_codePointAt === void 0 ? void 0 : _bidiCharacter_codePointAt.toString(16);
    return `U+${bidiCharacterCode}`;
}

},{"react":"ltHCL","@compiled/react/runtime":"d27Vo","@atlaskit/visually-hidden":"gKDx1","@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"aBQPo":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "bidiCharacterRegex", ()=>(0, _bidiCharacterRegex.bidiCharacterRegex));
parcelHelpers.export(exports, "default", ()=>codeBidiWarningDecorator);
var _bidiCharacterRegex = require("./bidi-character-regex");
function codeBidiWarningDecorator(originalText, decorate) {
    const matches = [
        ...originalText.matchAll((0, _bidiCharacterRegex.bidiCharacterRegex))
    ];
    if (matches.length === 0) // No matches encountered, so we return the originalText value
    return originalText;
    let children = [];
    let mappedTo = 0;
    for (const match of matches){
        if (mappedTo !== match.index) // There were unmatched characters prior to this match which haven't been
        // mapped to the children.
        // Add them as plain text.
        children.push(originalText.substring(mappedTo, match.index));
        children.push(decorate({
            bidiCharacter: match[0],
            index: match.index
        }));
        // While index is guaranteed to be present, it needs to be asserted due
        // to a limitation of typescripts regex handling
        //
        // https://github.com/microsoft/TypeScript/issues/36788
        // Decorate bidi character
        mappedTo = match.index + match[0].length;
    }
    if (mappedTo !== originalText.length) // There is text following the final match, which needs to be mapped
    // to the children.
    // Added as plain text.
    children.push(originalText.substring(mappedTo, originalText.length));
    // return the mapped children with decorated bidi characters
    return children;
}

},{"./bidi-character-regex":"zTOCB","@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"zTOCB":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "bidiCharacterRegex", ()=>bidiCharacterRegex);
const bidiCharacterRegex = /[\u202A-\u202E\u2066-\u2069]/g;

},{"@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"25fkv":[function(require,module,exports,__globalThis) {
/* code-block.tsx generated by @compiled/babel-plugin v0.39.1 */ /* eslint-disable @atlaskit/ui-styling-standard/no-unsafe-selectors */ /* eslint-disable @atlaskit/ui-styling-standard/no-nested-selectors */ var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _react = require("react");
var _runtime = require("@compiled/react/runtime");
var _bindEventListener = require("bind-event-listener");
var _rafSchd = require("raf-schd");
var _rafSchdDefault = parcelHelpers.interopDefault(_rafSchd);
var _platformFeatureFlags = require("@atlaskit/platform-feature-flags");
var _useHighlight = require("./internal/hooks/use-highlight");
var _styles = require("./internal/theme/styles");
var _getNormalizedLanguage = require("./internal/utils/get-normalized-language");
var _syntaxHighlighter = require("./syntax-highlighter");
var _syntaxHighlighterDefault = parcelHelpers.interopDefault(_syntaxHighlighter);
const getCodeBlockStyles = {
    rootT26Shape: "_2rko1mok",
    root: "_11c819w5 _2rko12b0 _1dqoglyw _1e0c1txw _vwz4gktf _1reo1wug _o572qvpr _1eimjvyg _bfhk187e _syazi7uo _1ozdn7od _7xinn7od _t7aun7od _r28du2gc _tajqu2gc _1ohiu2gc _m802u2gc _i6ntu2gc _1w2xu2gc _1hmyegat _vblregat _vbulegat _196q1xv3 _1vbw1xv3 _1v9c1xv3 _1srnt0uh _18r6myb0 _vyvc1n1a _1d4j1y44 _1f8gstnw _1pzyb3bt _ra6gsb9t _13cdh2mm _1pp0126e _zvy9f705 _qcxof705 _qzn01a66 _j0l11wug _1weckb7n _1na21hna _vsnzgrf3 _x7c815vq _lh0y15vq _1m3815vq _qk1e15vq _12l6ysn8 _uga3ysn8 _mx8b7mnp _1kr87mnp _xo19t94y _1bemt94y _nalpstnw _151dstnw _1exb1q9c _1hgu1q9c _1mgnt94y _nhket94y _h909i8nm _scgayz1z _ipl81e17 _40uk1l04 _i81p1a66 _1gx21e5h _1ls0df4r _vm2c1rh5 _12ok1rh5 _1ls01ule _rude1ule _1q16glyw _1io6glyw _juomusic _lcwuusic _pyovu2gc _ccm6u2gc _1ascu2gc _1yuau2gc _xr0w1a66 _4io21a66 _euyxusvi _cahfusvi _zhnuidpf _1amdidpf _mbgc124n _bu7z124n _131n1giz _gy101giz _1wfuwrk5 _16kzwrk5 _9kk3wu06 _cjus1w1g _9k2r1m30 _nhmw1m30 _yl021m30 _eihtd5cb _t9zbd5cb _mqok1w1g _3hsg1w1g _i7ngn7od _9wu1fb2s _1xcoh55r _1t36i7uo _137bh55r _1k7di7uo _97li16jw _12nh9lu1 _1g0517qg _i2igqmo9 _326zi7uo _113p1rpy _1n6t16jw _tgu817qg _1k4716jw _g0lxi7uo _ys4e1rpy _7gp8h55r _1yvqqmo9 _1vwwqmo9 _1rjuqmo9 _1v0lh55r _wmyy17qg _748n17qg _1mfn17qg _1d7e17qg _p2vr17qg _19o6qmo9 _kxov17qg _1np517qg _m2f517qg _1b9t16jw _1tq616jw _1rd216jw _1pbk16jw _k3li16jw _13zt1rpy _2g12fb2s _k86bqmo9 _b5iy1rpy _gti31rpy _1f0g16jw _9d3e17qg _qdia16jw _72uv16jw",
    showLineNumbers: "_1707efft _1i3h1txw _16noidpf _h4fuidpf _pp6yidpf _1g4tidpf _11wmidpf _1bx8idpf",
    dontShowLineNumbers: "_1i3h1ule _16nou2gc _h4fuu2gc _pp6yu2gc _1g4tu2gc _11wmu2gc _1bx8u2gc",
    shouldWrapLongLines: "_13dgkb7n",
    dontWrapLongLines: "_13dgkb7n"
};
/**
 * __Code block__
 *
 * A code block highlights an entire block of code and keeps the formatting.
 *
 * - [Examples](https://atlassian.design/components/code/code-block/examples)
 * - [Code](https://atlassian.design/components/code/code-block/code)
 * - [Usage](https://atlassian.design/components/code/code-block/usage)
 */ const CodeBlock = /*#__PURE__*/ (0, _react.memo)(function CodeBlock({ showLineNumbers = true, shouldShowLineNumbers, firstLineNumber = 1, language: providedLanguage = 'text', highlight = '', highlightedStartText = 'Highlight start', highlightedEndText = 'Highlight end', testId, text, codeBidiWarnings = true, hasBidiWarnings, codeBidiWarningLabel, codeBidiWarningTooltipEnabled = true, isBidiWarningTooltipEnabled, shouldWrapLongLines = false, label = 'Scrollable content' }) {
    const scrollableRef = (0, _react.useRef)(null);
    const [showContentFocus, setShowContentFocus] = (0, _react.useState)(false);
    // Use children if provided, otherwise fall back to deprecated text prop
    const numLines = (text || '').split('\n').length + (firstLineNumber > 0 ? firstLineNumber : 1) - 1;
    const lineNumberWidth = numLines ? (0, _styles.getLineNumWidth)(numLines) : 0;
    // Use new props if provided, otherwise fall back to deprecated props
    const shouldShowLineNumbersValue = shouldShowLineNumbers !== undefined ? shouldShowLineNumbers : showLineNumbers;
    const shouldShowBidiWarnings = hasBidiWarnings !== undefined ? hasBidiWarnings : codeBidiWarnings;
    const shouldEnableTooltip = isBidiWarningTooltipEnabled !== undefined ? isBidiWarningTooltipEnabled : codeBidiWarningTooltipEnabled;
    // Schedule a content focus on the target element
    // WARNING: In theory, `target` may not be available when `rafSchedule` hits in concurrent rendering
    (0, _react.useEffect)(()=>{
        const schedule = (0, _rafSchdDefault.default)(()=>{
            const target = scrollableRef.current;
            target && setShowContentFocus(target.scrollWidth > target.clientWidth);
        });
        schedule();
        const unbindWindowEvent = (0, _bindEventListener.bind)(window, {
            type: 'resize',
            listener: schedule
        });
        return unbindWindowEvent;
    }, [
        scrollableRef
    ]);
    const { getHighlightStyles, highlightedLines } = (0, _useHighlight.useHighlightLines)({
        highlight,
        testId
    });
    const getLineProps = (0, _react.useCallback)((line)=>getHighlightStyles(line, highlightedLines), [
        getHighlightStyles,
        highlightedLines
    ]);
    const language = (0, _react.useMemo)(()=>(0, _getNormalizedLanguage.normalizeLanguage)(providedLanguage), [
        providedLanguage
    ]);
    // https://product-fabric.atlassian.net/browse/DST-2472
    const languageToUse = text ? language : 'text';
    return /*#__PURE__*/ _react.createElement((0, _syntaxHighlighterDefault.default), {
        "data-code-lang": language,
        "data-ds--code--code-block": "",
        testId: testId,
        language: languageToUse,
        style: {
            '--ads-code-line-number-width': `calc(${lineNumberWidth} + 16px)`,
            '--ads-highlighted-start-text': highlightedStartText,
            '--ads-highlighted-end-text': highlightedEndText
        },
        showLineNumbers: shouldShowLineNumbersValue,
        firstLineNumber: firstLineNumber,
        lineProps: getLineProps,
        // shouldCreateParentElementForLines is needed to pass down props to each line.
        // This is necessary for both line highlighting and testId's, as each of
        // these rely on a data attribute being passed down to lines.
        shouldCreateParentElementForLines: highlight.length > 0 || !!testId,
        shouldWrapLongLines: shouldWrapLongLines,
        codeBidiWarnings: shouldShowBidiWarnings,
        codeBidiWarningLabel: codeBidiWarningLabel,
        codeBidiWarningTooltipEnabled: shouldEnableTooltip,
        text: text,
        tabIndex: showContentFocus ? '0' : undefined,
        "aria-label": showContentFocus ? label : undefined,
        role: showContentFocus ? 'region' : undefined,
        scrollRef: scrollableRef,
        className: (0, _runtime.ax)([
            getCodeBlockStyles.root,
            (0, _platformFeatureFlags.fg)('platform-dst-shape-theme-default') && getCodeBlockStyles.rootT26Shape,
            shouldWrapLongLines ? getCodeBlockStyles.shouldWrapLongLines : getCodeBlockStyles.dontWrapLongLines,
            shouldShowLineNumbersValue ? getCodeBlockStyles.showLineNumbers : getCodeBlockStyles.dontShowLineNumbers
        ])
    });
});
exports.default = CodeBlock;

},{"react":"ltHCL","@compiled/react/runtime":"d27Vo","bind-event-listener":"bjeUU","raf-schd":"oiTmD","@atlaskit/platform-feature-flags":"8rD2i","./internal/hooks/use-highlight":"2hGdn","./internal/theme/styles":"cGENO","./internal/utils/get-normalized-language":"4md95","./syntax-highlighter":"iSIcr","@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"2hGdn":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "useHighlightLines", ()=>useHighlightLines);
var _objectSpread = require("@swc/helpers/_/_object_spread");
var _react = require("react");
const DEFAULT_LINE_EL_ATTR_OBJ = {
    'data-ds--code--row': ''
};
const getLineStyleObject = (lineNumber, testId)=>{
    return testId ? (0, _objectSpread._)({
        'data-testid': `${testId}-line-${lineNumber}`
    }, DEFAULT_LINE_EL_ATTR_OBJ) : DEFAULT_LINE_EL_ATTR_OBJ;
};
const useHighlightLines = ({ highlight = '', testId })=>{
    const highlightedLines = (0, _react.useMemo)(()=>{
        if (!highlight) return [];
        return highlight.split(',').map((num)=>{
            if (num.indexOf('-') > 0) {
                // We found a line group, e.g. 1-3
                const [from, to] = num.split('-').map(Number)// Sort by lowest value first, highest value last.
                .sort((a, b)=>a - b);
                return Array(to + 1).fill(undefined).map((_, index)=>index).slice(from, to + 1);
            }
            return Number(num);
        }).reduce((acc, val)=>acc.concat(val), []) || [];
    }, [
        highlight
    ]);
    const getHighlightStyles = (0, _react.useCallback)((lineNumber, highlightedLines)=>{
        if (!highlight || highlightedLines.length === 0) return getLineStyleObject(lineNumber, testId);
        if (highlightedLines.includes(lineNumber)) {
            const highlightedDataAttrObj = {
                'data-ds--code--row--highlight': ''
            };
            return (0, _objectSpread._)({}, highlightedDataAttrObj, getLineStyleObject(lineNumber, testId));
        }
        return getLineStyleObject(lineNumber, testId);
    }, [
        highlight,
        testId
    ]);
    return {
        getHighlightStyles,
        highlightedLines
    };
};

},{"@swc/helpers/_/_object_spread":"9gdrV","react":"ltHCL","@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"cGENO":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "getLineNumWidth", ()=>getLineNumWidth);
const getLineNumWidth = (numLines)=>{
    return !numLines ? '1ch' : `${numLines.toFixed(0).length}ch`;
};

},{"@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"4md95":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "normalizeLanguage", ()=>normalizeLanguage);
var _memoizeOne = require("memoize-one");
var _memoizeOneDefault = parcelHelpers.interopDefault(_memoizeOne);
var _constants = require("../../constants");
const normalizeLanguage = (0, _memoizeOneDefault.default)((language)=>{
    if (!language) return '';
    const match = (0, _constants.SUPPORTED_LANGUAGES).find((val)=>{
        return val.name === language || val.alias.includes(language);
    });
    // Fallback to plain monospaced text if language passed but not supported
    return match ? match.value : 'text';
});

},{"memoize-one":"5rJro","../../constants":"aLhUC","@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"aLhUC":[function(require,module,exports,__globalThis) {
// The full list of languages that can potentially be supported is found in
// https://prismjs.com/#supported-languages
var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "CODE_BLOCK_SELECTOR", ()=>(0, _constants.CODE_BLOCK_SELECTOR));
parcelHelpers.export(exports, "SUPPORTED_LANGUAGES", ()=>SUPPORTED_LANGUAGES);
var _constants = require("./internal/theme/constants");
const SUPPORTED_LANGUAGES = [
    {
        name: 'PHP',
        alias: [
            'php',
            'php3',
            'php4',
            'php5'
        ],
        value: 'php'
    },
    {
        name: 'Java',
        alias: [
            'java'
        ],
        value: 'java'
    },
    {
        name: 'CSharp',
        alias: [
            'csharp',
            'c#'
        ],
        value: 'cs'
    },
    {
        name: 'Python',
        alias: [
            'python',
            'py'
        ],
        value: 'python'
    },
    {
        name: 'JavaScript',
        alias: [
            'javascript',
            'js'
        ],
        value: 'javascript'
    },
    {
        name: 'Html',
        alias: [
            'html'
        ],
        value: 'xml'
    },
    {
        name: 'C++',
        alias: [
            'c++',
            'cpp',
            'clike'
        ],
        value: 'cpp'
    },
    {
        name: 'Ruby',
        alias: [
            'ruby',
            'rb',
            'duby'
        ],
        value: 'ruby'
    },
    {
        name: 'Objective-C',
        alias: [
            'objective-c',
            'objectivec',
            'obj-c',
            'objc'
        ],
        value: 'objectivec'
    },
    {
        name: 'C',
        alias: [
            'c'
        ],
        value: 'cpp'
    },
    {
        name: 'Swift',
        alias: [
            'swift'
        ],
        value: 'swift'
    },
    {
        name: 'TeX',
        alias: [
            'tex',
            'latex'
        ],
        value: 'tex'
    },
    {
        name: 'Shell',
        alias: [
            'shell',
            'bash',
            'sh',
            'ksh',
            'zsh'
        ],
        value: 'shell'
    },
    {
        name: 'Scala',
        alias: [
            'scala'
        ],
        value: 'scala'
    },
    {
        name: 'Go',
        alias: [
            'go'
        ],
        value: 'go'
    },
    {
        name: 'ActionScript',
        alias: [
            'actionscript',
            'actionscript3',
            'as'
        ],
        value: 'actionscript'
    },
    {
        name: 'ColdFusion',
        alias: [
            'coldfusion'
        ],
        value: 'xml'
    },
    {
        name: 'JavaFX',
        alias: [
            'javafx',
            'jfx'
        ],
        value: 'java'
    },
    {
        name: 'VbNet',
        alias: [
            'vbnet',
            'vb.net',
            'vfp',
            'clipper',
            'xbase'
        ],
        value: 'vbnet'
    },
    {
        name: 'JSON',
        alias: [
            'json'
        ],
        value: 'json'
    },
    {
        name: 'MATLAB',
        alias: [
            'matlab'
        ],
        value: 'matlab'
    },
    {
        name: 'Groovy',
        alias: [
            'groovy'
        ],
        value: 'groovy'
    },
    {
        name: 'SQL',
        alias: [
            'sql',
            'postgresql',
            'postgres',
            'plpgsql',
            'psql',
            'postgresql-console',
            'postgres-console',
            'tsql',
            't-sql',
            'mysql',
            'sqlite'
        ],
        value: 'sql'
    },
    {
        name: 'R',
        alias: [
            'r'
        ],
        value: 'r'
    },
    {
        name: 'Perl',
        alias: [
            'perl',
            'pl'
        ],
        value: 'perl'
    },
    {
        name: 'Lua',
        alias: [
            'lua'
        ],
        value: 'lua'
    },
    {
        name: 'Pascal',
        alias: [
            'pas',
            'pascal',
            'objectpascal',
            'delphi'
        ],
        value: 'pascal'
    },
    {
        name: 'XML',
        alias: [
            'xml'
        ],
        value: 'xml'
    },
    {
        name: 'TypeScript',
        alias: [
            'typescript',
            'ts'
        ],
        value: 'typescript'
    },
    {
        name: 'CoffeeScript',
        alias: [
            'coffeescript',
            'coffee-script',
            'coffee'
        ],
        value: 'coffeescript'
    },
    {
        name: 'Haskell',
        alias: [
            'haskell',
            'hs'
        ],
        value: 'haskell'
    },
    {
        name: 'Puppet',
        alias: [
            'puppet'
        ],
        value: 'puppet'
    },
    {
        name: 'Arduino',
        alias: [
            'arduino'
        ],
        value: 'arduino'
    },
    {
        name: 'Fortran',
        alias: [
            'fortran'
        ],
        value: 'fortran'
    },
    {
        name: 'Erlang',
        alias: [
            'erlang',
            'erl'
        ],
        value: 'erlang'
    },
    {
        name: 'PowerShell',
        alias: [
            'powershell',
            'posh',
            'ps1',
            'psm1'
        ],
        value: 'powershell'
    },
    {
        name: 'Haxe',
        alias: [
            'haxe',
            'hx',
            'hxsl'
        ],
        value: 'haxe'
    },
    {
        name: 'Elixir',
        alias: [
            'elixir',
            'ex',
            'exs'
        ],
        value: 'elixir'
    },
    {
        name: 'Verilog',
        alias: [
            'verilog',
            'v'
        ],
        value: 'verilog'
    },
    {
        name: 'Rust',
        alias: [
            'rust'
        ],
        value: 'rust'
    },
    {
        name: 'VHDL',
        alias: [
            'vhdl'
        ],
        value: 'vhdl'
    },
    {
        name: 'Sass',
        alias: [
            'sass'
        ],
        value: 'less'
    },
    {
        name: 'OCaml',
        alias: [
            'ocaml'
        ],
        value: 'ocaml'
    },
    {
        name: 'Dart',
        alias: [
            'dart'
        ],
        value: 'dart'
    },
    {
        name: 'CSS',
        alias: [
            'css'
        ],
        value: 'css'
    },
    {
        name: 'reStructuredText',
        alias: [
            'restructuredtext',
            'rst',
            'rest'
        ],
        value: 'rest'
    },
    {
        name: 'Kotlin',
        alias: [
            'kotlin'
        ],
        value: 'kotlin'
    },
    {
        name: 'D',
        alias: [
            'd'
        ],
        value: 'd'
    },
    {
        name: 'Octave',
        alias: [
            'octave'
        ],
        value: 'matlab'
    },
    {
        name: 'QML',
        alias: [
            'qbs',
            'qml'
        ],
        value: 'qml'
    },
    {
        name: 'Prolog',
        alias: [
            'prolog'
        ],
        value: 'prolog'
    },
    {
        name: 'FoxPro',
        alias: [
            'foxpro',
            'purebasic'
        ],
        value: 'purebasic'
    },
    {
        name: 'Scheme',
        alias: [
            'scheme',
            'scm'
        ],
        value: 'scheme'
    },
    {
        name: 'CUDA',
        alias: [
            'cuda',
            'cu'
        ],
        value: 'cpp'
    },
    {
        name: 'Julia',
        alias: [
            'julia',
            'jl'
        ],
        value: 'julia'
    },
    {
        name: 'Racket',
        alias: [
            'racket',
            'rkt'
        ],
        value: 'lisp'
    },
    {
        name: 'Ada',
        alias: [
            'ada',
            'ada95',
            'ada2005'
        ],
        value: 'ada'
    },
    {
        name: 'Tcl',
        alias: [
            'tcl'
        ],
        value: 'tcl'
    },
    {
        name: 'Mathematica',
        alias: [
            'mathematica',
            'mma',
            'nb'
        ],
        value: 'mathematica'
    },
    {
        name: 'Autoit',
        alias: [
            'autoit'
        ],
        value: 'autoit'
    },
    {
        name: 'StandardML',
        alias: [
            'standardmL',
            'sml',
            'standardml'
        ],
        value: 'sml'
    },
    {
        name: 'Objective-J',
        alias: [
            'objective-j',
            'objectivej',
            'obj-j',
            'objj'
        ],
        value: 'objectivec'
    },
    {
        name: 'Smalltalk',
        alias: [
            'smalltalk',
            'squeak',
            'st'
        ],
        value: 'smalltalk'
    },
    {
        name: 'Vala',
        alias: [
            'vala',
            'vapi'
        ],
        value: 'vala'
    },
    {
        name: 'LiveScript',
        alias: [
            'livescript',
            'live-script'
        ],
        value: 'livescript'
    },
    {
        name: 'XQuery',
        alias: [
            'xquery',
            'xqy',
            'xq',
            'xql',
            'xqm'
        ],
        value: 'xquery'
    },
    {
        name: 'PlainText',
        alias: [
            'text',
            'plaintext'
        ],
        value: 'text'
    },
    {
        name: 'Yaml',
        alias: [
            'yaml',
            'yml'
        ],
        value: 'yaml'
    },
    {
        name: 'GraphQL',
        alias: [
            'graphql'
        ],
        value: 'graphql'
    },
    {
        name: 'AppleScript',
        alias: [
            'applescript'
        ],
        value: 'applescript'
    },
    {
        name: 'Clojure',
        alias: [
            'clojure'
        ],
        value: 'clojure'
    },
    {
        name: 'Diff',
        alias: [
            'diff'
        ],
        value: 'diff'
    },
    {
        name: 'VisualBasic',
        alias: [
            'visualbasic'
        ],
        value: 'visual-basic'
    },
    {
        name: 'JSX',
        alias: [
            'jsx'
        ],
        value: 'jsx'
    },
    {
        name: 'TSX',
        alias: [
            'tsx'
        ],
        value: 'tsx'
    },
    {
        name: 'SplunkSPL',
        alias: [
            'splunk-spl'
        ],
        value: 'splunk-spl'
    },
    {
        name: 'Dockerfile',
        alias: [
            'docker',
            'dockerfile'
        ],
        value: 'dockerfile'
    },
    {
        name: 'HCL',
        alias: [
            'hcl',
            'terraform'
        ],
        value: 'hcl'
    },
    {
        name: 'NGINX',
        alias: [
            'nginx'
        ],
        value: 'nginx'
    },
    {
        name: 'Protocol Buffers',
        alias: [
            'protobuf',
            'proto'
        ],
        value: 'protobuf'
    },
    {
        name: 'TOML',
        alias: [
            'toml'
        ],
        value: 'toml'
    },
    {
        name: 'Handlebars',
        alias: [
            'handlebars',
            'mustache'
        ],
        value: 'handlebars'
    },
    {
        name: 'Gherkin',
        alias: [
            'gherkin',
            'cucumber'
        ],
        value: 'gherkin'
    },
    {
        name: 'ABAP',
        alias: [
            'abap'
        ],
        value: 'abap'
    },
    {
        name: 'Markdown',
        alias: [
            'markdown'
        ],
        value: 'markdown'
    }
];

},{"./internal/theme/constants":false,"@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"iSIcr":[function(require,module,exports,__globalThis) {
/**
 * Original library: https://github.com/react-syntax-highlighter/react-syntax-highlighter
 * All modifications by Atlassian
 */ /**
 * MIT License
 *
 * Copyright (c) 2019 Conor Hastings
 *
 * Permission is hereby granted, free of charge, to any person obtaining a copy
 * of this software and associated documentation files (the "Software"), to deal
 * in the Software without restriction, including without limitation the rights
 * to use, copy, modify, merge, publish, distribute, sublicense, and/or sell
 * copies of the Software, and to permit persons to whom the Software is
 * furnished to do so, subject to the following conditions:
 *
 * The above copyright notice and this permission notice shall be included in all
 * copies or substantial portions of the Software.
 *
 * THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
 * IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
 * FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
 * AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
 * LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM,
 * OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN THE
 * SOFTWARE.
 */ /**
 * __Syntax Highlighter__
 *
 * A syntax highlighter based on top of [refractor](https://github.com/wooorm/refractor).
 * @atlaskit/code uses this under-the-hood, but it is not intended for public consumption.
 * You should be using @atlaskit/code directly.
 */ var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _async = require("./async");
var _asyncDefault = parcelHelpers.interopDefault(_async);
exports.default = (0, _asyncDefault.default);

},{"./async":"6CALG","@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"6CALG":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _objectSpread = require("@swc/helpers/_/_object_spread");
var _objectSpreadProps = require("@swc/helpers/_/_object_spread_props");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _highlight = require("./lib/highlight");
var _highlightDefault = parcelHelpers.interopDefault(_highlight);
// Uses the loader method of async bundling
// Instantiates highligher as a singleton, loading refractor only once per page (refractor/prism are singleton modules)
const generator = (options)=>{
    const { loader } = options;
    // eslint-disable-next-line @repo/internal/react/no-class-components
    class AsyncHighlighter extends (0, _reactDefault.default).PureComponent {
        // Useful in tests
        static preload() {
            return AsyncHighlighter.loadAstGenerator();
        }
        static loadAstGenerator() {
            AsyncHighlighter.astGeneratorPromise = loader().then((astGenerator)=>{
                AsyncHighlighter.astGenerator = astGenerator;
                return astGenerator;
            });
            return AsyncHighlighter.astGeneratorPromise;
        }
        componentDidMount() {
            if (!AsyncHighlighter.astGeneratorPromise) AsyncHighlighter.loadAstGenerator();
            if (!AsyncHighlighter.astGenerator && AsyncHighlighter.astGeneratorPromise) AsyncHighlighter.astGeneratorPromise.then(()=>{
                this.forceUpdate();
            });
        }
        render() {
            return /*#__PURE__*/ (0, _reactDefault.default).createElement(AsyncHighlighter.highlightInstance, (0, _objectSpreadProps._)((0, _objectSpread._)({}, this.props), {
                astGenerator: AsyncHighlighter.astGenerator
            }));
        }
    }
    AsyncHighlighter.astGenerator = null;
    AsyncHighlighter.highlightInstance = (0, _highlightDefault.default);
    return AsyncHighlighter;
};
const asyncGenerator = generator({
    loader: ()=>require(/* webpackChunkName: "@atlaskit-internal_refractor-import" */ "7a27f48cd6cb2fa5").then((module)=>{
            // Webpack 3 returns module.exports as default as module, but webpack 4 returns module.exports as module.default
            return module.default || module;
        })
});
exports.default = asyncGenerator;

},{"@swc/helpers/_/_object_spread":"9gdrV","@swc/helpers/_/_object_spread_props":"kANqQ","react":"ltHCL","./lib/highlight":"7QjdE","7a27f48cd6cb2fa5":"d3ULJ","@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"7QjdE":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _objectSpread = require("@swc/helpers/_/_object_spread");
var _objectSpreadProps = require("@swc/helpers/_/_object_spread_props");
var _objectWithoutProperties = require("@swc/helpers/_/_object_without_properties");
var _react = require("react");
var _process = require("./process");
var _processDefault = parcelHelpers.interopDefault(_process);
var _reactRenderer = require("./react-renderer");
var _reactRendererDefault = parcelHelpers.interopDefault(_reactRenderer);
/**
 * Takes in a code string and (in the default behaviour):
 * - Uses refractor to turn it into a tree structure with highlighting metadata
 * - Collapses this tree into lines for a renderer
 * - Passes these lines to a React renderer
 *
 * In future, the final step could have a custom renderer.
 */ const Highlight = /*#__PURE__*/ (0, _react.memo)(function Highlight(_param) {
    var { language = 'text', testId, text = '', codeTagProps = {
        className: `language-${language}`
    }, showLineNumbers = false, firstLineNumber = 1, shouldCreateParentElementForLines = false, shouldWrapLongLines = false, lineProps = {}, codeBidiWarnings, codeBidiWarningLabel, codeBidiWarningTooltipEnabled, astGenerator = null } = _param, rest = (0, _objectWithoutProperties._)(_param, [
        "language",
        "testId",
        "text",
        "codeTagProps",
        "showLineNumbers",
        "firstLineNumber",
        "shouldCreateParentElementForLines",
        "shouldWrapLongLines",
        "lineProps",
        "codeBidiWarnings",
        "codeBidiWarningLabel",
        "codeBidiWarningTooltipEnabled",
        "astGenerator"
    ]);
    // TODO maybe we call this code or text everywhere; for now we match the API in
    // @atlaskit/codeblock
    const code = text;
    const generatorClassName = 'prismjs';
    const containerProps = (0, _objectSpreadProps._)((0, _objectSpread._)({}, rest), {
        ref: rest.scrollRef,
        'data-testid': testId,
        className: rest.className ? `${generatorClassName} ${rest.className}` : generatorClassName
    });
    if (containerProps.hasOwnProperty('scrollRef')) delete containerProps['scrollRef'];
    if (shouldWrapLongLines) codeTagProps.style = {
        whiteSpace: 'pre-wrap',
        wordBreak: 'break-word'
    };
    else codeTagProps.style = {
        whiteSpace: 'pre'
    };
    const codeBidiWarningConfig = {
        codeBidiWarnings,
        codeBidiWarningLabel,
        codeBidiWarningTooltipEnabled
    };
    // Tree + logic into rows
    const rows = (0, _processDefault.default)({
        astGenerator,
        code,
        language,
        shouldCreateParentElementForLines: shouldCreateParentElementForLines || !!shouldWrapLongLines,
        lineProps,
        showLineNumbers,
        firstLineNumber
    });
    // Rows + logic into a renderer
    return (0, _reactRendererDefault.default)({
        containerProps,
        codeTagProps,
        rows,
        codeBidiWarningConfig
    });
});
exports.default = Highlight;

},{"@swc/helpers/_/_object_spread":"9gdrV","@swc/helpers/_/_object_spread_props":"kANqQ","@swc/helpers/_/_object_without_properties":"6HqIM","react":"ltHCL","./process":"cF7cR","./react-renderer":"6FkJV","@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"cF7cR":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>processLines);
var _createLine = require("./create-line");
var _createLineDefault = parcelHelpers.interopDefault(_createLine);
var _createLineElement = require("./create-line-element");
var _createLineElementDefault = parcelHelpers.interopDefault(_createLineElement);
var _flattenCodeTree = require("./flatten-code-tree");
var _flattenCodeTreeDefault = parcelHelpers.interopDefault(_flattenCodeTree);
var _getCodeTree = require("./get-code-tree");
var _getCodeTreeDefault = parcelHelpers.interopDefault(_getCodeTree);
const newLineRegex = /\n/g;
function getNewLines(str) {
    return str.match(newLineRegex);
}
function processLines({ astGenerator, code, language, shouldCreateParentElementForLines, lineProps, showLineNumbers, firstLineNumber = 1 }) {
    const codeTree = (0, _getCodeTreeDefault.default)(language, code, astGenerator);
    const startingLineNumber = firstLineNumber > 0 ? firstLineNumber : 1;
    const createLine = (0, _createLineDefault.default)(lineProps, shouldCreateParentElementForLines, showLineNumbers);
    const newTree = [];
    let lastLineBreakIndex = -1;
    let index = 0;
    // Seems odd we flatten the tree immediately - what work could we do on it more performantly than on the lines?
    const tree = (0, _flattenCodeTreeDefault.default)(codeTree);
    while(index < tree.length){
        const testNode = tree[index];
        if (testNode.type === 'text') {
            index++;
            continue;
        }
        const node = testNode;
        const firstChildNode = node.children[0];
        if (firstChildNode.type === 'text') {
            const { value } = firstChildNode;
            const newLines = getNewLines(value);
            if (newLines) {
                const splitValue = value.split('\n');
                splitValue.forEach((text, i)=>{
                    const lineNumber = newTree.length + startingLineNumber;
                    const newChild = {
                        type: 'text',
                        value: `${text}\n`
                    };
                    // if it's the first line
                    if (i === 0) {
                        const children = tree.slice(lastLineBreakIndex + 1, index).concat((0, _createLineElementDefault.default)({
                            children: [
                                newChild
                            ],
                            className: node.properties.className,
                            lineNumber
                        }));
                        const line = createLine(children, lineNumber);
                        newTree.push(line);
                    // if it's the last line
                    } else if (i === splitValue.length - 1) {
                        const nextNode = tree[index + 1];
                        const stringChild = nextNode && nextNode.children && nextNode.children[0];
                        // Similar to newChild above, but no newline
                        const lastLineInPreviousSpan = {
                            type: 'text',
                            value: `${text}`
                        };
                        if (stringChild) {
                            const newElem = (0, _createLineElementDefault.default)({
                                children: [
                                    lastLineInPreviousSpan
                                ],
                                className: node.properties.className,
                                lineNumber
                            });
                            tree.splice(index + 1, 0, newElem);
                        } else {
                            const children = [
                                lastLineInPreviousSpan
                            ];
                            const line = createLine(children, lineNumber, node.properties.className);
                            newTree.push(line);
                        }
                    // if it's neither the first nor the last line
                    } else {
                        const children = [
                            newChild
                        ];
                        const line = createLine(children, lineNumber, node.properties.className);
                        newTree.push(line);
                    }
                });
                lastLineBreakIndex = index;
            }
        }
        index++;
    }
    if (lastLineBreakIndex !== tree.length - 1) {
        const children = tree.slice(lastLineBreakIndex + 1, tree.length);
        if (children && children.length) {
            const lineNumber = newTree.length + startingLineNumber;
            const line = createLine(children, lineNumber);
            newTree.push(line);
        }
    }
    if (shouldCreateParentElementForLines) return newTree;
    // If shouldCreateParentElementForLines was off, we still have a tree structure we need to flatten
    // We have (RefractorNode | RefractorNode[])[] but need RefractorNode[]
    // This seems like a code smell to review
    return newTree.flat(1);
}

},{"./create-line":"9DLQ3","./create-line-element":"eCGvP","./flatten-code-tree":"67JaE","./get-code-tree":"jNlMW","@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"9DLQ3":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _createLineElement = require("./create-line-element");
var _createLineElementDefault = parcelHelpers.interopDefault(_createLineElement);
var _getInlineLineNumber = require("./get-inline-line-number");
var _getInlineLineNumberDefault = parcelHelpers.interopDefault(_getInlineLineNumber);
function createLineGenerator(lineProps, shouldCreateParentElementForLines, showLineNumbers) {
    return (children, lineNumber, className = [])=>{
        // Needed for more complex line creation
        if (shouldCreateParentElementForLines || className.length > 0) return (0, _createLineElementDefault.default)({
            children,
            lineNumber,
            showLineNumbers,
            lineProps,
            className
        });
        else {
            // Simple line creation without the bells and whistles
            if (showLineNumbers && lineNumber) children.unshift((0, _getInlineLineNumberDefault.default)(lineNumber));
            return children;
        }
    };
}
exports.default = createLineGenerator;

},{"./create-line-element":"eCGvP","./get-inline-line-number":"lmrhh","@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"eCGvP":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>createLineElement);
var _objectSpread = require("@swc/helpers/_/_object_spread");
var _objectSpreadProps = require("@swc/helpers/_/_object_spread_props");
var _getInlineLineNumber = require("./get-inline-line-number");
var _getInlineLineNumberDefault = parcelHelpers.interopDefault(_getInlineLineNumber);
function createLineElement({ children, lineNumber, showLineNumbers, shouldShowLineNumbers, lineProps = {}, className = [] }) {
    // Use new prop if provided, otherwise fall back to deprecated prop
    const shouldShowLineNumbersValue = shouldShowLineNumbers !== undefined ? shouldShowLineNumbers : showLineNumbers;
    const propsPassedInFromCodeBlock = typeof lineProps === 'function' ? lineProps(lineNumber) : lineProps;
    const properties = (0, _objectSpreadProps._)((0, _objectSpread._)({}, propsPassedInFromCodeBlock), {
        className
    });
    let currentChildren = children;
    if (lineNumber && shouldShowLineNumbersValue) {
        // When syntax highlighting is NOT turned on, the entire LOC is just a single
        // child. We can then happily create the line number and the LOC as siblings...
        if (currentChildren.length === 1) currentChildren = [
            (0, _getInlineLineNumberDefault.default)(lineNumber),
            ...currentChildren
        ];
        else // ... However, when syntax highlighting IS on, a span is created for each
        // tokenised node in the AST (eg. <span>import</span><span>React</span>).
        // When shouldWrapLongLines is true, the row becomes `display: flex` and
        // forces all its children to be equal height. This can be a source of
        // visual bugs where a LOC is broken up weirdly into segments.
        //
        //  +---------------------------------------+
        //  | row                                   |
        //  |  +----+ +-------+ +--------+ +------+ |
        //  |  |line| |key    | |keywords| |key   | |
        //  |  |no. | |word   | |        | |word  | |
        //  |  |    | |       | |        | |      | |
        //  |  +----+ +-------+ +--------+ +------+ |
        //  +---------------------------------------+
        //
        // Nesting the children one layer deeper (i.e. creating an extra span)
        // ensures that the line number and the ENTIRE line of code are aligned by
        // the parent flexbox (the row).
        //
        //  +---------------------------------------------+
        //  | row                                         |
        //  | +----+  +--------------------------------+  |
        //  | |line|  | extra span we are creating     |  |
        //  | |no. |  |  +-------+ +--------+ +------+ |  |
        //  | |    |  |  |key    | |keywords| |key   | |  |
        //  | |    |  |  |word   | |        | |word  | |  |
        //  | |    |  |  |       | |        | |      | |  |
        //  | |    |  |  +-------+ +--------+ +------+ |  |
        //  | +----+  +--------------------------------+  |
        //  +---------------------------------------------+
        //
        currentChildren = [
            (0, _getInlineLineNumberDefault.default)(lineNumber),
            {
                type: 'element',
                tagName: 'span',
                properties: {
                    className: []
                },
                children: currentChildren
            }
        ];
    }
    return {
        type: 'element',
        tagName: 'span',
        properties,
        children: currentChildren
    };
}

},{"@swc/helpers/_/_object_spread":"9gdrV","@swc/helpers/_/_object_spread_props":"kANqQ","./get-inline-line-number":"lmrhh","@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"lmrhh":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>getInlineLineNumber);
function getInlineLineNumber(lineNumber) {
    return {
        type: 'element',
        tagName: 'span',
        properties: {
            key: `line-number--${lineNumber}`,
            className: [
                'comment',
                'linenumber',
                'ds-line-number'
            ],
            // We're placing the lineNumber in a data-attr on an empty span (hence the
            // empty children array below). This allows CodeBlock to use CSS to
            // generate the content in a pseudo-element, which is a fix for a bug
            // where line numbers were being copied (CSS content can't be copied)
            // https://product-fabric.atlassian.net/browse/DSP-2729
            'data-ds--line-number': lineNumber
        },
        children: []
    };
}

},{"@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"67JaE":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>flattenCodeTree);
var _platformFeatureFlags = require("@atlaskit/platform-feature-flags");
var _createLineElement = require("./create-line-element");
var _createLineElementDefault = parcelHelpers.interopDefault(_createLineElement);
function flattenCodeTree(tree, offset = 0, className = []) {
    let newTree = [];
    for(let i = 0; i < tree.length; i++){
        const node = tree[i];
        if (node.type === 'text') newTree.push((0, _createLineElementDefault.default)({
            children: [
                node
            ],
            lineNumber: offset,
            className
        }));
        else if (node.children) {
            // If this node is a re-highlighted fenced code-block wrapper (added by
            // rehighlightFencedBlocks in get-code-tree.tsx), reset the accumulated
            // class list instead of concatenating onto ancestors.  Without this,
            // every token inside the fenced block inherits all ancestor classes
            // (e.g. "token code token code-block language-jsx token plain-text").
            const nodeClasses = node.properties.className || [];
            const isCodeBlock = (0, _platformFeatureFlags.fg)('platform-code-highlight-markdown-safe') && nodeClasses.includes('code-block');
            // When entering a re-highlighted fenced code-block wrapper, reset the
            // accumulated ancestor classes to empty so children only carry their
            // own token classes (not the full ancestor chain).
            const classNames = isCodeBlock ? [] : className.concat(nodeClasses);
            flattenCodeTree(node.children, offset + 1, classNames).forEach((i)=>newTree.push(i));
        }
    }
    return newTree;
}

},{"@atlaskit/platform-feature-flags":"8rD2i","./create-line-element":"eCGvP","@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"jNlMW":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>getCodeTree);
var _objectSpread = require("@swc/helpers/_/_object_spread");
var _objectSpreadProps = require("@swc/helpers/_/_object_spread_props");
var _platformFeatureFlags = require("@atlaskit/platform-feature-flags");
/**
 * Extract the plain text content from a list of RefractorNodes.
 */ function extractText(nodes) {
    return nodes.map((n)=>{
        if (n.type === 'text') return n.value;
        return n.children ? extractText(n.children) : '';
    }).join('');
}
/**
 * Walk the safe-highlighted AST and, for every fenced code block (a `token code`
 * span), replace the raw text child with a properly highlighted `token code-block
 * language-{lang}` span so that inner tokens carry the correct classes.
 */ function rehighlightFencedBlocks(nodes, astGenerator) {
    const refractorLike = astGenerator;
    return nodes.map((node)=>{
        var _node_properties;
        if (node.type !== 'element') return node;
        var _node_properties_className;
        const classes = (_node_properties_className = (_node_properties = node.properties) === null || _node_properties === void 0 ? void 0 : _node_properties.className) !== null && _node_properties_className !== void 0 ? _node_properties_className : [];
        const isCodeToken = classes.includes('token') && classes.includes('code');
        var _node_children;
        if (!isCodeToken || !node.children) return (0, _objectSpreadProps._)((0, _objectSpread._)({}, node), {
            children: rehighlightFencedBlocks((_node_children = node.children) !== null && _node_children !== void 0 ? _node_children : [], astGenerator)
        });
        // Find the code-language child to determine which sub-language to use.
        const langNode = node.children.find((c)=>{
            var _c_properties_className, _c_properties;
            return c.type === 'element' && ((_c_properties = c.properties) === null || _c_properties === void 0 ? void 0 : (_c_properties_className = _c_properties.className) === null || _c_properties_className === void 0 ? void 0 : _c_properties_className.includes('code-language'));
        });
        var _langNode_children;
        const subLang = langNode && langNode.type === 'element' ? extractText((_langNode_children = langNode.children) !== null && _langNode_children !== void 0 ? _langNode_children : []).trim() : null;
        // Find the raw text child that holds the fenced block content (after the
        // opening ``` line and before the closing ```).
        const children = node.children.map((child)=>{
            var _refractorLike_languages;
            // This is the raw code content
            // eslint-disable-next-line @repo/internal/react/no-children-properties-access
            const rawContent = 'value' in child ? child.value : undefined;
            if (!subLang || !rawContent) return child;
            // Only re-highlight when the sub-language is registered with refractor to
            // avoid an uncaught exception.
            const isRegistered = typeof refractorLike.registered === 'function' ? refractorLike.registered(subLang) : Boolean((_refractorLike_languages = refractorLike.languages) === null || _refractorLike_languages === void 0 ? void 0 : _refractorLike_languages[subLang]);
            if (!isRegistered) return child;
            let highlighted;
            try {
                highlighted = astGenerator.highlight(rawContent, subLang);
            } catch (e) {
                return child;
            }
            // Wrap in a `token code-block language-{lang}` span to match what the
            // normal (non-safe) markdown highlight would produce.
            const codeBlockNode = {
                type: 'element',
                tagName: 'span',
                properties: {
                    className: [
                        'token',
                        'code-block',
                        `language-${subLang}`
                    ]
                },
                children: highlighted
            };
            return codeBlockNode;
        });
        return (0, _objectSpreadProps._)((0, _objectSpread._)({}, node), {
            children
        });
    });
}
function highlightMarkdownSafely(code, astGenerator) {
    var _refractorLike_languages_markdown, _refractorLike_languages;
    const refractorLike = astGenerator;
    const markdownCodeToken = (_refractorLike_languages = refractorLike.languages) === null || _refractorLike_languages === void 0 ? void 0 : (_refractorLike_languages_markdown = _refractorLike_languages.markdown) === null || _refractorLike_languages_markdown === void 0 ? void 0 : _refractorLike_languages_markdown.code;
    const fencedToken = Array.isArray(markdownCodeToken) ? markdownCodeToken[1] : undefined;
    const originalInside = fencedToken === null || fencedToken === void 0 ? void 0 : fencedToken.inside;
    const canDisableEmbeddedCodeBlock = originalInside && 'code-block' in originalInside;
    if (canDisableEmbeddedCodeBlock) {
        const patchedInside = (0, _objectSpread._)({}, originalInside);
        delete patchedInside['code-block'];
        fencedToken.inside = patchedInside;
    }
    let result;
    try {
        result = astGenerator.highlight(code, 'markdown');
    } finally{
        if (canDisableEmbeddedCodeBlock) fencedToken.inside = originalInside;
    }
    // Re-highlight inner fenced code blocks so tokens carry proper classes.
    return rehighlightFencedBlocks(result, astGenerator);
}
function getCodeTree(language, code, astGenerator) {
    if (language === 'text' || !astGenerator) return [
        {
            type: 'text',
            value: code
        }
    ];
    try {
        if (language === 'markdown' && (0, _platformFeatureFlags.fg)('platform-code-highlight-markdown-safe')) return highlightMarkdownSafely(code, astGenerator);
        return astGenerator.highlight(code, language);
    } catch (e) {
        return [
            {
                type: 'text',
                value: code
            }
        ];
    }
}

},{"@swc/helpers/_/_object_spread":"9gdrV","@swc/helpers/_/_object_spread_props":"kANqQ","@atlaskit/platform-feature-flags":"8rD2i","@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"6FkJV":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>ReactRenderer);
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _createElement = require("./create-element");
var _createElementDefault = parcelHelpers.interopDefault(_createElement);
function ReactRenderer({ containerProps, codeTagProps, rows, codeBidiWarningConfig }) {
    const renderedRows = rows.map((node, i)=>(0, _createElementDefault.default)({
            node,
            codeBidiWarningConfig,
            key: `code-segment${i}`
        }));
    return /*#__PURE__*/ (0, _reactDefault.default).createElement("span", containerProps, /*#__PURE__*/ (0, _reactDefault.default).createElement("code", codeTagProps, renderedRows));
}

},{"react":"ltHCL","./create-element":"5ECmT","@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"5ECmT":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>createElement);
var _objectSpread = require("@swc/helpers/_/_object_spread");
var _objectSpreadProps = require("@swc/helpers/_/_object_spread_props");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _bidiWarning = require("../../../bidi-warning");
var _bidiWarningDefault = parcelHelpers.interopDefault(_bidiWarning);
var _bidiWarningDecorator = require("../../../bidi-warning/bidi-warning-decorator");
var _bidiWarningDecoratorDefault = parcelHelpers.interopDefault(_bidiWarningDecorator);
var _createChildren = require("./create-children");
var _createChildrenDefault = parcelHelpers.interopDefault(_createChildren);
function createClassNameString(classNames) {
    return classNames ? classNames.join(' ') : '';
}
function createElement({ node, codeBidiWarningConfig, key }) {
    if (node.type === 'text') {
        const { value } = node;
        // occasionally a numeric value is passed when the type is text
        const textValue = `${value}`;
        if (codeBidiWarningConfig.codeBidiWarnings) {
            const decorated = (0, _bidiWarningDecoratorDefault.default)(textValue, ({ bidiCharacter, index })=>/*#__PURE__*/ (0, _reactDefault.default).createElement((0, _bidiWarningDefault.default), {
                    bidiCharacter: bidiCharacter,
                    key: index,
                    label: codeBidiWarningConfig.codeBidiWarningLabel,
                    isTooltipEnabled: codeBidiWarningConfig.codeBidiWarningTooltipEnabled
                }));
            return decorated;
        }
        return textValue;
    } else {
        const { properties, tagName } = node;
        const childrenCreator = (0, _createChildrenDefault.default)(codeBidiWarningConfig);
        const props = (0, _objectSpreadProps._)((0, _objectSpread._)({}, properties), {
            className: createClassNameString(properties.className)
        });
        const children = childrenCreator(node.children);
        return /*#__PURE__*/ (0, _reactDefault.default).createElement(tagName, (0, _objectSpread._)({
            key
        }, props), children);
    }
}

},{"@swc/helpers/_/_object_spread":"9gdrV","@swc/helpers/_/_object_spread_props":"kANqQ","react":"ltHCL","../../../bidi-warning":"6YkSP","../../../bidi-warning/bidi-warning-decorator":"aBQPo","./create-children":"8HBhg","@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"8HBhg":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>createChildren);
var _createElement = require("./create-element");
var _createElementDefault = parcelHelpers.interopDefault(_createElement);
function createChildren(codeBidiWarningConfig) {
    let childrenCount = 0;
    return (children)=>{
        childrenCount += 1;
        return children.map((child, i)=>(0, _createElementDefault.default)({
                node: child,
                codeBidiWarningConfig,
                key: `code-segment-${childrenCount}-${i}`
            }));
    };
}

},{"./create-element":"5ECmT","@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"d3ULJ":[function(require,module,exports,__globalThis) {
module.exports = require("6c400c09db41cd1c")(require("16aa49e381850527").resolve("8gYtm")).then(()=>module.bundle.root('9TZDk'));

},{"6c400c09db41cd1c":"hkfCW","16aa49e381850527":"l4T2r"}],"gVBKw":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>(0, _statefulDefault.default));
parcelHelpers.export(exports, "DynamicTableStateless", ()=>(0, _statelessDefault.default));
var _stateful = require("./components/stateful");
var _statefulDefault = parcelHelpers.interopDefault(_stateful);
var _stateless = require("./components/stateless");
var _statelessDefault = parcelHelpers.interopDefault(_stateless);

},{"./components/stateful":"65CPD","./components/stateless":"hjDcs","@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"65CPD":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
/**
 * __Dynamic Table__
 *
 * A table displays rows of data with built-in pagination, sorting, and re-ordering functionality.
 *
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/dynamic-table)
 * - [Code](https://bitbucket.org/atlassian/atlassian-frontend/packages/design-system/dynamic-table)
 *
 * @example
 * ```jsx
 * import DynamicTable from '@atlaskit/dynamic-table';
 *
 * export default function TableUncontrolled() {
 *  return (
 *   <DynamicTable
 *    head={head}
 *    rows={rows}
 *    rowsPerPage={10}
 *    defaultPage={1}
 *    loadingSpinnerSize="large"
 *    isLoading={false}
 *   />
 *  );
 * }
 * ```
 */ // eslint-disable-next-line @repo/internal/react/no-class-components
parcelHelpers.export(exports, "default", ()=>DynamicTable);
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _noop = require("@atlaskit/ds-lib/noop");
var _noopDefault = parcelHelpers.interopDefault(_noop);
var _reorderRows = require("../internal/reorder-rows");
var _stateless = require("./stateless");
var _statelessDefault = parcelHelpers.interopDefault(_stateless);
class DynamicTable extends (0, _reactDefault.default).Component {
    UNSAFE_componentWillReceiveProps(newProps) {
        const sortKey = newProps.sortKey || this.state.sortKey;
        const sortOrder = newProps.sortOrder || this.state.sortOrder;
        const page = newProps.page || this.state.page;
        this.setState({
            page,
            sortKey,
            sortOrder,
            rows: newProps.rows
        });
    }
    render() {
        const { page, sortKey, sortOrder, rows } = this.state;
        const { caption, emptyView, head, highlightedRowIndex, loadingSpinnerSize, isLoading, loadingLabel, isFixedSize, isRankable, isRankingDisabled, rowsPerPage, paginationi18n, onRankStart, onPageRowsUpdate, testId, label } = this.props;
        return /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _statelessDefault.default), {
            paginationi18n: paginationi18n,
            caption: caption,
            emptyView: emptyView,
            head: head,
            highlightedRowIndex: highlightedRowIndex,
            loadingSpinnerSize: loadingSpinnerSize,
            isLoading: isLoading,
            loadingLabel: loadingLabel,
            isFixedSize: isFixedSize,
            onSetPage: this.onSetPageHandler,
            onSort: this.onSortHandler,
            page: page,
            rows: rows,
            rowsPerPage: rowsPerPage,
            sortKey: sortKey,
            sortOrder: sortOrder,
            isRankable: isRankable,
            isRankingDisabled: isRankingDisabled,
            onRankEnd: this.onRankEndHandler,
            onRankStart: onRankStart,
            onPageRowsUpdate: onPageRowsUpdate,
            testId: testId,
            label: label
        });
    }
    constructor(...args){
        super(...args), this.state = {
            page: this.props.defaultPage,
            sortKey: this.props.defaultSortKey,
            sortOrder: this.props.defaultSortOrder,
            rows: this.props.rows
        }, this.onSetPageHandler = (page, analyticsEvent)=>{
            const { onSetPage } = this.props;
            if (onSetPage) {
                onSetPage(page, analyticsEvent);
                this.setState({
                    page
                });
            }
        }, this.onSortHandler = ({ key, item, sortOrder }, analyticsEvent)=>{
            const { onSort } = this.props;
            if (onSort) {
                onSort({
                    key,
                    item,
                    sortOrder
                }, analyticsEvent);
                this.setState({
                    sortKey: key,
                    sortOrder
                });
            }
        }, this.onRankEndIfExistsHandler = (params)=>{
            if (this.props.onRankEnd) this.props.onRankEnd(params);
        }, this.onRankEndHandler = (params)=>{
            const { destination } = params;
            const { rows, page } = this.state;
            const { rowsPerPage } = this.props;
            if (!destination || !rows) {
                this.onRankEndIfExistsHandler(params);
                return;
            }
            const reordered = (0, _reorderRows.reorderRows)(params, rows, page, rowsPerPage);
            this.setState({
                rows: reordered
            });
            this.onRankEndIfExistsHandler(params);
        };
    }
}
DynamicTable.defaultProps = {
    defaultPage: 1,
    isLoading: false,
    isFixedSize: false,
    isRankable: false,
    onSetPage: (0, _noopDefault.default),
    onSort: (0, _noopDefault.default),
    rowsPerPage: Infinity
};

},{"react":"ltHCL","@atlaskit/ds-lib/noop":"faKzG","../internal/reorder-rows":"4KEu3","./stateless":"hjDcs","@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"4KEu3":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "reorderRows", ()=>reorderRows);
var _computeIndex = require("./compute-index");
const reorderRows = (rankEnd, rows, page = 1, rowsPerPage)=>{
    const { destination, sourceIndex } = rankEnd;
    if (!destination) return rows;
    const fromIndex = (0, _computeIndex.computeIndex)(sourceIndex, page, rowsPerPage);
    const toIndex = (0, _computeIndex.computeIndex)(destination.index, page, rowsPerPage);
    const reordered = rows.slice();
    const [removed] = reordered.splice(fromIndex, 1);
    reordered.splice(toIndex, 0, removed);
    return reordered;
};

},{"./compute-index":"2ZS9x","@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"2ZS9x":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "computeIndex", ()=>computeIndex);
const computeIndex = (index, page, rowsPerPage)=>{
    const itemOnPreviousPages = rowsPerPage && isFinite(rowsPerPage) ? (page - 1) * rowsPerPage : 0;
    return index + itemOnPreviousPages;
};

},{"@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"hjDcs":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _objectSpread = require("@swc/helpers/_/_object_spread");
var _objectSpreadProps = require("@swc/helpers/_/_object_spread_props");
var _objectWithoutProperties = require("@swc/helpers/_/_object_without_properties");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _analyticsNext = require("@atlaskit/analytics-next");
var _noop = require("@atlaskit/ds-lib/noop");
var _noopDefault = parcelHelpers.interopDefault(_noop);
var _assertIsSortable = require("../internal/assert-is-sortable");
var _getPageRows = require("../internal/get-page-rows");
var _validateSortKey = require("../internal/validate-sort-key");
var _caption = require("../styled/caption");
var _emptyViewContainer = require("../styled/empty-view-container");
var _emptyViewWithFixedHeight = require("../styled/empty-view-with-fixed-height");
var _paginationWrapper = require("../styled/pagination-wrapper");
var _table = require("../styled/table");
var _body = require("./body");
var _bodyDefault = parcelHelpers.interopDefault(_body);
var _errorBoundary = require("./error-boundary");
var _loadingContainer = require("./loading-container");
var _loadingContainerDefault = parcelHelpers.interopDefault(_loadingContainer);
var _loadingContainerAdvanced = require("./loading-container-advanced");
var _loadingContainerAdvancedDefault = parcelHelpers.interopDefault(_loadingContainerAdvanced);
var _managedPagination = require("./managed-pagination");
var _managedPaginationDefault = parcelHelpers.interopDefault(_managedPagination);
var _tableHead = require("./table-head");
var _tableHeadDefault = parcelHelpers.interopDefault(_tableHead);
function toggleSortOrder(currentSortOrder) {
    switch(currentSortOrder){
        case 'DESC':
            return 'ASC';
        case 'ASC':
            return 'DESC';
        default:
            return currentSortOrder;
    }
}
const DynamicTable = ({ caption, head, highlightedRowIndex, rows, sortKey, sortOrder, loadingLabel, onPageRowsUpdate, testId, totalRows: passedDownTotalRows, label, isLoading = false, isFixedSize = false, rowsPerPage = Infinity, onSetPage = (0, _noopDefault.default), onSort: providedOnSort = (0, _noopDefault.default), page = 1, emptyView, isRankable = false, isRankingDisabled = false, onRankStart = (0, _noopDefault.default), onRankEnd: providedOnRankEnd = (0, _noopDefault.default), loadingSpinnerSize, paginationi18n = {
    prev: 'Previous Page',
    next: 'Next Page',
    label: 'Pagination',
    pageLabel: 'Page'
} })=>{
    const [isRanking, setIsRanking] = (0, _react.useState)(false);
    const tableBodyRef = (0, _react.useRef)(null);
    const onSort = (0, _analyticsNext.usePlatformLeafEventHandler)({
        fn: providedOnSort,
        action: 'sorted',
        componentName: 'dynamicTable',
        packageName: "@af/atlassian-studio",
        packageVersion: "0.16.1"
    });
    const onRankEnd = (0, _analyticsNext.usePlatformLeafEventHandler)({
        fn: providedOnRankEnd,
        action: 'ranked',
        componentName: 'dynamicTable',
        packageName: "@af/atlassian-studio",
        packageVersion: "0.16.1"
    });
    (0, _react.useEffect)(()=>{
        (0, _validateSortKey.validateSortKey)(sortKey, head);
        (0, _assertIsSortable.assertIsSortable)(head);
    }, [
        sortKey,
        head
    ]);
    const onSortHandler = (item)=>()=>{
            const { key } = item;
            if (!key) return;
            if (onSort && isRankable && key === sortKey && sortOrder === 'DESC') {
                onSort({
                    key: null,
                    sortOrder: null,
                    item
                });
                return;
            }
            const sortOrderFormatted = key !== sortKey ? 'ASC' : toggleSortOrder(sortOrder);
            if (onSort) onSort({
                key,
                item,
                sortOrder: sortOrderFormatted
            });
        };
    const onSetPageHandler = (page, event)=>{
        onSetPage(page, event);
    };
    const onRankStartHandler = (params)=>{
        setIsRanking(true);
        onRankStart(params);
    };
    const onRankEndHandler = (params)=>{
        setIsRanking(false);
        onRankEnd(params);
    };
    const getSpinnerSize = ()=>{
        if (loadingSpinnerSize) return loadingSpinnerSize;
        return (0, _getPageRows.getPageRows)(rows || [], page, rowsPerPage).length > 2 ? 'large' : 'small';
    };
    const renderEmptyBody = ()=>{
        if (isLoading) return /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _emptyViewWithFixedHeight.EmptyViewWithFixedHeight), {
            testId: testId
        });
        return emptyView && /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _emptyViewContainer.EmptyViewContainer), {
            testId: testId
        }, emptyView);
    };
    const rowsLength = rows && rows.length;
    let totalPages;
    // set a flag to denote the dynamic table might get only one page of data
    // for paginated data
    let isTotalPagesControlledExternally = false;
    if (passedDownTotalRows && Number.isInteger(passedDownTotalRows) && rowsPerPage && rowsLength && rowsLength <= passedDownTotalRows) {
        /**
		 * If total number of rows / records have been passed down as prop
		 * Then table is being fed paginated data from server or other sources
		 * In this case, we want to respect information passed down by server or external source
		 * Rather than relying on our computation based on number of rows
		 */ totalPages = Math.ceil(passedDownTotalRows / rowsPerPage);
        isTotalPagesControlledExternally = true;
    } else totalPages = rowsLength && rowsPerPage ? Math.ceil(rowsLength / rowsPerPage) : 0;
    totalPages = totalPages < 1 ? 1 : totalPages;
    const getPageNumber = page > totalPages ? totalPages : page; // page! required, because typescript can't yet see defaultProps to know that this won't be undefined
    const rowsExist = !!rowsLength;
    const spinnerSize = getSpinnerSize();
    const emptyBody = renderEmptyBody();
    return /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _reactDefault.default).Fragment, null, /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _loadingContainerAdvancedDefault.default), {
        isLoading: isLoading && rowsExist,
        spinnerSize: spinnerSize,
        targetRef: ()=>tableBodyRef.current,
        testId: testId,
        loadingLabel: loadingLabel
    }, /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _table.Table), {
        isFixedSize: isFixedSize,
        "aria-label": label,
        hasDataRow: rowsExist,
        testId: testId,
        isLoading: isLoading
    }, !!caption && /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _caption.Caption), null, caption), head && /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _tableHeadDefault.default), {
        head: head,
        onSort: onSortHandler,
        sortKey: sortKey,
        sortOrder: sortOrder,
        isRanking: isRanking,
        isRankable: isRankable,
        testId: testId
    }), rowsExist && /*#__PURE__*/ (0, _reactDefault.default).createElement(TableBody, {
        ref: tableBodyRef,
        highlightedRowIndex: highlightedRowIndex,
        rows: rows,
        head: head,
        sortKey: sortKey,
        sortOrder: sortOrder,
        rowsPerPage: rowsPerPage,
        page: getPageNumber,
        isFixedSize: isFixedSize || false,
        onPageRowsUpdate: onPageRowsUpdate,
        isTotalPagesControlledExternally: isTotalPagesControlledExternally,
        testId: testId,
        isRankable: isRankable,
        isRanking: isRanking,
        onRankStart: onRankStartHandler,
        onRankEnd: onRankEndHandler,
        isRankingDisabled: isRankingDisabled || isLoading || false
    }))), totalPages <= 1 ? null : /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _paginationWrapper.PaginationWrapper), {
        testId: testId
    }, /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _managedPaginationDefault.default), {
        value: getPageNumber,
        onChange: onSetPageHandler,
        total: totalPages,
        i18n: paginationi18n,
        isDisabled: isLoading,
        testId: testId
    })), !rowsExist && emptyBody && /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _loadingContainerDefault.default), {
        isLoading: isLoading,
        spinnerSize: "large",
        testId: testId,
        loadingLabel: loadingLabel
    }, emptyBody));
};
const RankableTableBody = /*#__PURE__*/ (0, _react.lazy)(()=>require(/* webpackChunkName: '@atlaskit-internal_dynamic-table' */ "77cb07a641f2afc9"));
const TableBody = /*#__PURE__*/ (0, _react.forwardRef)(function TableBody(_param, ref) {
    var { isRankable = false, isRanking, onRankStart, onRankEnd, isRankingDisabled } = _param, bodyProps = (0, _objectWithoutProperties._)(_param, [
        "isRankable",
        "isRanking",
        "onRankStart",
        "onRankEnd",
        "isRankingDisabled"
    ]);
    const canRank = isRankable && !bodyProps.sortKey;
    /**
	 * React 16 does not support SSR for lazy components,
	 * so we avoid rendering the `Suspense` on the server.
	 */ const [canRenderRankable, setCanRenderRankable] = (0, _react.useState)(false);
    (0, _react.useEffect)(()=>{
        if (canRank) setCanRenderRankable(true);
    }, [
        canRank
    ]);
    const nonRankableBody = /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _bodyDefault.default), (0, _objectSpread._)({
        ref: ref
    }, bodyProps));
    return canRank && canRenderRankable ? /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _errorBoundary.ErrorBoundary), {
        fallback: nonRankableBody
    }, /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _react.Suspense), {
        fallback: nonRankableBody
    }, /*#__PURE__*/ (0, _reactDefault.default).createElement(RankableTableBody, (0, _objectSpreadProps._)((0, _objectSpread._)({
        ref: ref
    }, bodyProps), {
        isRanking: isRanking,
        onRankStart: onRankStart,
        onRankEnd: onRankEnd,
        isRankingDisabled: isRankingDisabled
    })))) : nonRankableBody;
});
// eslint-disable-next-line @repo/internal/react/require-jsdoc
exports.default = DynamicTable;

},{"@swc/helpers/_/_object_spread":"9gdrV","@swc/helpers/_/_object_spread_props":"kANqQ","@swc/helpers/_/_object_without_properties":"6HqIM","react":"ltHCL","@atlaskit/analytics-next":"6PLie","@atlaskit/ds-lib/noop":"faKzG","../internal/assert-is-sortable":"63oX8","../internal/get-page-rows":"i6DNC","../internal/validate-sort-key":"7ohMc","../styled/caption":"aaWvw","../styled/empty-view-container":"3SxjH","../styled/empty-view-with-fixed-height":"cjloK","../styled/pagination-wrapper":"4X3EN","../styled/table":"33quB","./body":"bCSdF","./error-boundary":"8z0oo","./loading-container":"amSDd","./loading-container-advanced":"5DudN","./managed-pagination":"eQJsU","./table-head":"iaURY","77cb07a641f2afc9":"el40d","@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"63oX8":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "assertIsSortable", ()=>assertIsSortable);
const assertIsSortable = (head)=>{
    if (!head || !head.cells) return;
    head.cells.forEach((cell)=>{
        if (cell.isSortable && !cell.key) try {
            throw Error("isSortable can't be set to true, if the 'key' prop is missing.");
        } catch (e) {
            // eslint-disable-next-line no-console
            console.error(e);
        }
    });
};

},{"@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"i6DNC":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "getPageRows", ()=>getPageRows);
const getPageRows = (allRows, pageNumber, rowsPerPage)=>{
    if (!pageNumber || !rowsPerPage || !allRows.length) return [];
    return allRows.slice((pageNumber - 1) * rowsPerPage, pageNumber * rowsPerPage);
};

},{"@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"7ohMc":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "validateSortKey", ()=>validateSortKey);
const validateSortKey = (sortKey, head)=>{
    if (!sortKey) return;
    const headHasKey = head && head.cells.map((cell)=>cell.key).includes(sortKey);
    if (!headHasKey) try {
        throw Error(`Cell with ${sortKey} key not found in head.`);
    } catch (e) {
        // eslint-disable-next-line no-console
        console.error(e);
    }
};

},{"@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"aaWvw":[function(require,module,exports,__globalThis) {
/* caption.tsx generated by @compiled/babel-plugin v0.39.1 */ /* eslint-disable @repo/internal/react/require-jsdoc */ var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "Caption", ()=>Caption);
var _react = require("react");
var _runtime = require("@compiled/react/runtime");
const captionStyles = null;
const Caption = ({ children })=>/*#__PURE__*/ _react.createElement("caption", {
        className: (0, _runtime.ax)([
            "_11c81af2 _6rthu2gc _1pfh1ejb _m6k41e03"
        ])
    }, children);

},{"react":"ltHCL","@compiled/react/runtime":"d27Vo","@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"3SxjH":[function(require,module,exports,__globalThis) {
/* empty-view-container.tsx generated by @compiled/babel-plugin v0.39.1 */ /* eslint-disable @repo/internal/react/require-jsdoc */ var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "EmptyViewContainer", ()=>EmptyViewContainer);
var _react = require("react");
var _runtime = require("@compiled/react/runtime");
const emptyViewContainerStyles = null;
const EmptyViewContainer = (props)=>{
    const { children, testId } = props;
    return /*#__PURE__*/ _react.createElement("div", {
        "data-testid": testId && `${testId}--empty-view-container`,
        className: (0, _runtime.ax)([
            "_19pk1wug _2hwx1wug _otyr1wug _18u01wug _ca0q19bv _u5f319bv _n3td19bv _19bv19bv _1bsb1ssb _y3gn1h6o"
        ])
    }, children);
};

},{"react":"ltHCL","@compiled/react/runtime":"d27Vo","@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"cjloK":[function(require,module,exports,__globalThis) {
/* empty-view-with-fixed-height.tsx generated by @compiled/babel-plugin v0.39.1 */ /* eslint-disable @repo/internal/react/require-jsdoc */ var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "EmptyViewWithFixedHeight", ()=>EmptyViewWithFixedHeight);
var _react = require("react");
var _runtime = require("@compiled/react/runtime");
const fixedHeightStyles = null;
const EmptyViewWithFixedHeight = ({ children, testId })=>/*#__PURE__*/ _react.createElement("div", {
        "data-testid": testId && `${testId}--empty-view-with-fixed-height`,
        className: (0, _runtime.ax)([
            "_4t3i1jdh"
        ])
    }, children);

},{"react":"ltHCL","@compiled/react/runtime":"d27Vo","@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"4X3EN":[function(require,module,exports,__globalThis) {
/* pagination-wrapper.tsx generated by @compiled/babel-plugin v0.39.1 */ /* eslint-disable @repo/internal/react/require-jsdoc */ var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "PaginationWrapper", ()=>PaginationWrapper);
var _react = require("react");
var _runtime = require("@compiled/react/runtime");
const paginationWrapperStyles = null;
const PaginationWrapper = ({ children, testId })=>/*#__PURE__*/ _react.createElement("div", {
        "data-testid": testId && `${testId}--pagination--container`,
        className: (0, _runtime.ax)([
            "_1e0c1txw _1bah1h6o"
        ])
    }, children);

},{"react":"ltHCL","@compiled/react/runtime":"d27Vo","@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"33quB":[function(require,module,exports,__globalThis) {
/* table.tsx generated by @compiled/babel-plugin v0.39.1 */ /* eslint-disable @repo/internal/react/require-jsdoc */ var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "Table", ()=>Table);
var _objectSpread = require("@swc/helpers/_/_object_spread");
var _objectSpreadProps = require("@swc/helpers/_/_object_spread_props");
var _objectWithoutProperties = require("@swc/helpers/_/_object_without_properties");
var _react = require("react");
var _runtime = require("@compiled/react/runtime");
const fixedSizeTableStyles = null;
const tableStyles = null;
const bodyBorder = null;
const Table = /*#__PURE__*/ (0, _react.forwardRef)((_param, ref)=>{
    var { isFixedSize, hasDataRow, children, testId, isLoading } = _param, rest = (0, _objectWithoutProperties._)(_param, [
        "isFixedSize",
        "hasDataRow",
        "children",
        "testId",
        "isLoading"
    ]);
    return /*#__PURE__*/ _react.createElement("table", (0, _objectSpreadProps._)((0, _objectSpread._)({
        inert: isLoading ? '' : undefined,
        style: {
            // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
            '--local-dynamic-table-hover-bg': "var(--ds-background-neutral-subtle-hovered, #0515240F)",
            // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
            '--local-dynamic-table-highlighted-bg': "var(--ds-background-selected, #E9F2FE)",
            // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
            '--local-dynamic-table-hover-highlighted-bg': "var(--ds-background-selected-hovered, #CFE1FD)",
            // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
            '--local-dynamic-table-row-focus-outline': "var(--ds-border-focused, #4688EC)"
        },
        ref: ref
    }, rest), {
        "data-testid": testId && `${testId}--table`,
        className: (0, _runtime.ax)([
            "_1bsb1osq _yq5hus1c _btyzidpf _ect4ttxp",
            isFixedSize && "_1kqm1n9t",
            hasDataRow && "_179r1uh4"
        ])
    }), children);
});

},{"@swc/helpers/_/_object_spread":"9gdrV","@swc/helpers/_/_object_spread_props":"kANqQ","@swc/helpers/_/_object_without_properties":"6HqIM","react":"ltHCL","@compiled/react/runtime":"d27Vo","@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"bCSdF":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _objectSpread = require("@swc/helpers/_/_object_spread");
var _objectSpreadProps = require("@swc/helpers/_/_object_spread_props");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _withSortedPageRows = require("../hoc/with-sorted-page-rows");
var _withSortedPageRowsDefault = parcelHelpers.interopDefault(_withSortedPageRows);
var _tableRow = require("./table-row");
var _tableRowDefault = parcelHelpers.interopDefault(_tableRow);
// eslint-disable-next-line @repo/internal/react/no-class-components
class BodyComponent extends (0, _reactDefault.default).Component {
    render() {
        const { pageRows, head, isFixedSize, highlightedRowIndex, testId, forwardedRef } = this.props;
        return /*#__PURE__*/ (0, _reactDefault.default).createElement("tbody", {
            "data-testid": testId && `${testId}--body`,
            ref: forwardedRef
        }, pageRows.map((row, rowIndex)=>/*#__PURE__*/ (0, _reactDefault.default).createElement((0, _tableRowDefault.default), {
                head: head,
                isFixedSize: isFixedSize,
                key: row.key || rowIndex,
                row: row,
                isHighlighted: row.isHighlighted || !!highlightedRowIndex && (typeof highlightedRowIndex === 'number' ? highlightedRowIndex === rowIndex : highlightedRowIndex.indexOf(rowIndex) > -1),
                testId: testId
            })));
    }
}
const Body = (0, _withSortedPageRowsDefault.default)(/*#__PURE__*/ (0, _reactDefault.default).forwardRef((props, ref)=>{
    return /*#__PURE__*/ (0, _reactDefault.default).createElement(BodyComponent, (0, _objectSpreadProps._)((0, _objectSpread._)({}, props), {
        forwardedRef: ref
    }));
}));
// eslint-disable-next-line @repo/internal/react/require-jsdoc
exports.default = Body;

},{"@swc/helpers/_/_object_spread":"9gdrV","@swc/helpers/_/_object_spread_props":"kANqQ","react":"ltHCL","../hoc/with-sorted-page-rows":"3Il0m","./table-row":"8T7Qg","@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"3Il0m":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>withSortedPageRows);
var _objectSpread = require("@swc/helpers/_/_object_spread");
var _objectSpreadProps = require("@swc/helpers/_/_object_spread_props");
var _objectWithoutProperties = require("@swc/helpers/_/_object_without_properties");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _getPageRows = require("../internal/get-page-rows");
var _validateSortKey = require("../internal/validate-sort-key");
const getSortingCellValue = (cells, head, sortKey)=>{
    for(let i = 0; i < cells.length; i++){
        var _head_cells_i, _cells_i;
        if (head.cells[i] && ((_head_cells_i = head.cells[i]) === null || _head_cells_i === void 0 ? void 0 : _head_cells_i.key) === sortKey) return (_cells_i = cells[i]) === null || _cells_i === void 0 ? void 0 : _cells_i.key;
    }
    return undefined;
};
// sort all rows based on sort key and order
const getSortedRows = (head, rows, sortKey, sortOrder)=>{
    if (!sortKey || !head) return rows;
    if (!rows) return [];
    const modifier = sortOrder === 'ASC' ? 1 : -1;
    // Re-initialising an I18n Collator on every sort is performance intensive, thus constructed outside
    const collator = new Intl.Collator(undefined, {
        numeric: true,
        sensitivity: 'accent'
    });
    // Get copy of rows to avoid sorting prop in place
    const sortableRows = Array.from(rows);
    // Reorder rows in table based on sorting cell value
    // Algorithm will sort numerics or strings, but not both
    return sortableRows.sort((a, b)=>{
        const valA = getSortingCellValue(a.cells, head, sortKey);
        const valB = getSortingCellValue(b.cells, head, sortKey);
        if (valA === undefined || valB === undefined) return modifier;
        if (typeof valA !== typeof valB) {
            // numbers are always grouped higher in the sort
            if (typeof valA === 'number') return -1;
            if (typeof valB === 'number') return 1;
            // strings are grouped next
            if (typeof valA === 'string') return -1;
            if (typeof valB === 'string') return 1;
        }
        if (typeof valA === 'string' && typeof valB === 'string') return modifier * collator.compare(valA, valB);
        if (!valA && valA !== 0 || valA < valB) return -modifier;
        if (!valB && valB !== 0 || valA > valB) return modifier;
        if (valA === valB) return 0;
        return 1;
    });
};
function withSortedPageRows(WrappedComponent) {
    // eslint-disable-next-line @repo/internal/react/no-class-components
    class WithSortedPageRows extends (0, _reactDefault.default).Component {
        static getDerivedStateFromProps(props, state) {
            const { rows, head, sortKey, sortOrder, page, rowsPerPage, isTotalPagesControlledExternally } = props;
            (0, _validateSortKey.validateSortKey)(sortKey, head);
            let sortedRows;
            let pageRows;
            if (isTotalPagesControlledExternally) {
                sortedRows = rows;
                pageRows = rows;
            } else {
                sortedRows = getSortedRows(head, rows, sortKey, sortOrder) || [];
                pageRows = (0, _getPageRows.getPageRows)(sortedRows, page, rowsPerPage);
            }
            return (0, _objectSpreadProps._)((0, _objectSpread._)({}, state), {
                pageRows
            });
        }
        componentDidMount() {
            this.props.onPageRowsUpdate && this.props.onPageRowsUpdate(this.state.pageRows);
        }
        componentDidUpdate(_prevProps, prevState) {
            if (this.props.onPageRowsUpdate && this.state.pageRows !== prevState.pageRows) this.props.onPageRowsUpdate(this.state.pageRows);
        }
        render() {
            const _this_props = this.props, { rows, head, sortKey, sortOrder, rowsPerPage, page, forwardedRef } = _this_props, restProps = (0, _objectWithoutProperties._)(_this_props, [
                "rows",
                "head",
                "sortKey",
                "sortOrder",
                "rowsPerPage",
                "page",
                "forwardedRef"
            ]);
            return /*#__PURE__*/ (0, _reactDefault.default).createElement(WrappedComponent, (0, _objectSpreadProps._)((0, _objectSpread._)({
                //@ts-expect-error TODO Fix legit TypeScript 3.9.6 improved inference error
                pageRows: this.state.pageRows,
                head: head
            }, restProps), {
                ref: forwardedRef
            }));
        }
        constructor(...args){
            super(...args), this.state = {
                pageRows: []
            };
        }
    }
    return /*#__PURE__*/ (0, _reactDefault.default).forwardRef((props, ref)=>{
        // eslint-disable-next-line @typescript-eslint/ban-ts-comment
        // @ts-ignore: to unblock React 18.2.0 -> 18.3.1 version bump in Jira
        return /*#__PURE__*/ (0, _reactDefault.default).createElement(WithSortedPageRows, (0, _objectSpreadProps._)((0, _objectSpread._)({}, props), {
            forwardedRef: ref
        }));
    });
}

},{"@swc/helpers/_/_object_spread":"9gdrV","@swc/helpers/_/_object_spread_props":"kANqQ","@swc/helpers/_/_object_without_properties":"6HqIM","react":"ltHCL","../internal/get-page-rows":"i6DNC","../internal/validate-sort-key":"7ohMc","@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"8T7Qg":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _objectSpread = require("@swc/helpers/_/_object_spread");
var _objectSpreadProps = require("@swc/helpers/_/_object_spread_props");
var _objectWithoutProperties = require("@swc/helpers/_/_object_without_properties");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _tableCell = require("../styled/table-cell");
var _tableRow = require("../styled/table-row");
const Row = ({ row, head, testId, isFixedSize, isHighlighted })=>{
    const { cells } = row, restRowProps = (0, _objectWithoutProperties._)(row, [
        "cells"
    ]);
    return /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _tableRow.TableBodyRow), (0, _objectSpreadProps._)((0, _objectSpread._)((0, _objectSpreadProps._)((0, _objectSpread._)({}, restRowProps), {
        isHighlighted: isHighlighted
    }), isHighlighted ? {
        'data-ts--dynamic-table--table-row--highlighted': true
    } : null), {
        testId: row.testId || testId && `${testId}--row-${restRowProps.key}`
    }), cells.map((cell, cellIndex)=>{
        const { content, testId: cellTestId } = cell, restCellProps = (0, _objectWithoutProperties._)(cell, [
            "content",
            "testId"
        ]);
        const { shouldTruncate, width } = (head || {
            cells: []
        }).cells[cellIndex] || {};
        return /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _tableCell.TableBodyCell), (0, _objectSpreadProps._)((0, _objectSpread._)({
            "data-testid": cellTestId || testId && `${testId}--cell-${cellIndex}`
        }, restCellProps), {
            isFixedSize: isFixedSize,
            key: cellIndex,
            shouldTruncate: shouldTruncate,
            width: width
        }), content);
    }));
};
// eslint-disable-next-line @repo/internal/react/require-jsdoc
exports.default = Row;

},{"@swc/helpers/_/_object_spread":"9gdrV","@swc/helpers/_/_object_spread_props":"kANqQ","@swc/helpers/_/_object_without_properties":"6HqIM","react":"ltHCL","../styled/table-cell":"2AqNs","../styled/table-row":"gFnaA","@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"2AqNs":[function(require,module,exports,__globalThis) {
/* table-cell.tsx generated by @compiled/babel-plugin v0.39.1 */ var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "TableBodyCell", ()=>TableBodyCell);
var _objectSpread = require("@swc/helpers/_/_object_spread");
var _objectWithoutProperties = require("@swc/helpers/_/_object_without_properties");
var _react = require("react");
var _runtime = require("@compiled/react/runtime");
var _constants = require("./constants");
const fixedSizeTruncateStyles = null;
const overflowTruncateStyles = null;
const truncationWidthStyles = null;
const cellStyles = null;
const TableBodyCell = (_param)=>{
    var { width, isFixedSize, shouldTruncate, innerRef } = _param, props = (0, _objectWithoutProperties._)(_param, [
        "width",
        "isFixedSize",
        "shouldTruncate",
        "innerRef"
    ]);
    return /*#__PURE__*/ _react.createElement("td", (0, _objectSpread._)({
        // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop, @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
        style: (0, _constants.getTruncationStyleVars)({
            width
        }),
        // HOC withDimensions complains about the types but it is working fine
        // @ts-ignore
        ref: innerRef,
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop
        className: (0, _runtime.ax)([
            "_1bsb8a2a",
            isFixedSize && shouldTruncate && "_1bto1l2s _o5721q9c",
            isFixedSize && "_1reo15vq _18m915vq",
            "_19itglyw _85i51b66 _1q511b66 _y4tiu2gc _bozgu2gc _y3gn1e5h _1s37ze3t _uupyze3t",
            props.className
        ])
    }, props));
};

},{"@swc/helpers/_/_object_spread":"9gdrV","@swc/helpers/_/_object_without_properties":"6HqIM","react":"ltHCL","@compiled/react/runtime":"d27Vo","./constants":"bL6Bn","@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"bL6Bn":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "getTruncationStyleVars", ()=>getTruncationStyleVars);
const CSS_VAR_WIDTH = '--local-dynamic-table-width';
const getTruncationStyleVars = ({ width })=>typeof width !== 'undefined' ? {
        [CSS_VAR_WIDTH]: `${width}%`
    } : undefined;

},{"@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"gFnaA":[function(require,module,exports,__globalThis) {
/* table-row.tsx generated by @compiled/babel-plugin v0.39.1 */ var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "TableBodyRow", ()=>TableBodyRow);
var _objectSpread = require("@swc/helpers/_/_object_spread");
var _objectSpreadProps = require("@swc/helpers/_/_object_spread_props");
var _objectWithoutProperties = require("@swc/helpers/_/_object_without_properties");
var _react = require("react");
var _runtime = require("@compiled/react/runtime");
const rowStyles = null;
const rowBackgroundStyles = null;
const rowHighlightedBackgroundStyles = null;
const TableBodyRow = /*#__PURE__*/ (0, _react.forwardRef)((_param, ref)=>{
    var { isHighlighted, children, style, testId, className } = _param, rest = (0, _objectWithoutProperties._)(_param, [
        "isHighlighted",
        "children",
        "style",
        "testId",
        "className"
    ]);
    return /*#__PURE__*/ _react.createElement("tr", (0, _objectSpreadProps._)((0, _objectSpread._)({
        style: style,
        /**
   * We rely on this `className` for the `RankableTableBodyRow` to apply extra styles.
   * With Compiled it needs to be statically analyzable. It does not get applied via spread props.
   */ // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop
        className: (0, _runtime.ax)([
            "_bfhksm61 _1ygbdfik _1ah312gs",
            isHighlighted ? "_bfhk15s3 _irr3ufnl" : "_irr31dpa",
            className
        ])
    }, rest), {
        ref: ref,
        "data-testid": testId
    }), children);
});

},{"@swc/helpers/_/_object_spread":"9gdrV","@swc/helpers/_/_object_spread_props":"kANqQ","@swc/helpers/_/_object_without_properties":"6HqIM","react":"ltHCL","@compiled/react/runtime":"d27Vo","@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"8z0oo":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
// eslint-disable-next-line @repo/internal/react/no-class-components
parcelHelpers.export(exports, "ErrorBoundary", ()=>ErrorBoundary);
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
class ErrorBoundary extends (0, _reactDefault.default).Component {
    static getDerivedStateFromError() {
        // Update state so the next render will show the fallback UI.
        return {
            hasError: true
        };
    }
    render() {
        if (this.state.hasError) // You can render any custom fallback UI
        return this.props.fallback;
        return this.props.children;
    }
    constructor(props){
        super(props);
        this.state = {
            hasError: false
        };
    }
}

},{"react":"ltHCL","@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"amSDd":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
// eslint-disable-next-line @repo/internal/react/no-class-components
parcelHelpers.export(exports, "default", ()=>LoadingContainer);
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _spinner = require("@atlaskit/spinner");
var _spinnerDefault = parcelHelpers.interopDefault(_spinner);
var _container = require("../styled/container");
var _contentsContainer = require("../styled/contents-container");
var _spinnerContainer = require("../styled/spinner-container");
class LoadingContainer extends (0, _reactDefault.default).Component {
    render() {
        const { children, isLoading, spinnerSize, contentsOpacity, testId, loadingLabel } = this.props;
        return /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _container.Container), {
            testId: testId
        }, !isLoading ? children : /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _contentsContainer.ContentsContainer), {
            contentsOpacity: contentsOpacity,
            testId: testId
        }, children), isLoading && /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _spinnerContainer.SpinnerContainer), {
            testId: testId
        }, /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _spinnerDefault.default), {
            size: spinnerSize,
            testId: testId && `${testId}--loadingSpinner`,
            label: loadingLabel
        })));
    }
}
LoadingContainer.defaultProps = {
    isLoading: true,
    spinnerSize: 'large',
    contentsOpacity: 0.22,
    loadingLabel: 'Loading table'
};

},{"react":"ltHCL","@atlaskit/spinner":"l22fT","../styled/container":"hxbtJ","../styled/contents-container":"3NXPl","../styled/spinner-container":"dPDMo","@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"hxbtJ":[function(require,module,exports,__globalThis) {
/* container.tsx generated by @compiled/babel-plugin v0.39.1 */ /* eslint-disable @repo/internal/react/require-jsdoc */ var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "Container", ()=>Container);
var _react = require("react");
var _runtime = require("@compiled/react/runtime");
const containerStyles = null;
const Container = ({ children, testId })=>/*#__PURE__*/ _react.createElement("div", {
        "data-testid": testId && `${testId}--container`,
        className: (0, _runtime.ax)([
            "_kqswh2mm"
        ])
    }, children);

},{"react":"ltHCL","@compiled/react/runtime":"d27Vo","@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"3NXPl":[function(require,module,exports,__globalThis) {
/* contents-container.tsx generated by @compiled/babel-plugin v0.39.1 */ /* eslint-disable @repo/internal/react/require-jsdoc */ var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "ContentsContainer", ()=>ContentsContainer);
var _react = require("react");
var _runtime = require("@compiled/react/runtime");
const CSS_VAR_CONTENTS_OPACITY = '--contents-opacity';
const contentsContainerStyles = null;
const ContentsContainer = ({ children, contentsOpacity, testId })=>/*#__PURE__*/ _react.createElement("div", {
        style: {
            [CSS_VAR_CONTENTS_OPACITY]: contentsOpacity
        },
        "data-testid": testId && `${testId}--contents--container`,
        className: (0, _runtime.ax)([
            "_tzy4saf5 _lcxvglyw"
        ])
    }, children);

},{"react":"ltHCL","@compiled/react/runtime":"d27Vo","@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"dPDMo":[function(require,module,exports,__globalThis) {
/* spinner-container.tsx generated by @compiled/babel-plugin v0.39.1 */ /* eslint-disable @repo/internal/react/require-jsdoc */ var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "SpinnerContainer", ()=>SpinnerContainer);
var _react = require("react");
var _runtime = require("@compiled/react/runtime");
const spinnerContainerStyles = null;
const SpinnerContainer = ({ children, testId })=>/*#__PURE__*/ _react.createElement("div", {
        "data-testid": testId && `${testId}--spinner--container`,
        className: (0, _runtime.ax)([
            "_1r04idpf _1e0c1txw _kqswstnw _4cvr1h6o _1bah1h6o"
        ])
    }, children);

},{"react":"ltHCL","@compiled/react/runtime":"d27Vo","@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"5DudN":[function(require,module,exports,__globalThis) {
/* loading-container-advanced.tsx generated by @compiled/babel-plugin v0.39.1 */ /* eslint-disable @repo/internal/dom-events/no-unsafe-event-listeners */ /* eslint-disable @repo/internal/react/require-jsdoc */ var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
// eslint-disable-next-line @repo/internal/react/no-class-components
parcelHelpers.export(exports, "default", ()=>LoadingContainerAdvanced);
var _objectSpread = require("@swc/helpers/_/_object_spread");
var _objectSpreadProps = require("@swc/helpers/_/_object_spread_props");
var _objectWithoutProperties = require("@swc/helpers/_/_object_without_properties");
var _runtime = require("@compiled/react/runtime");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _spinner = require("@atlaskit/spinner");
var _spinnerDefault = parcelHelpers.interopDefault(_spinner);
const containerStyles = null;
const Container = /*#__PURE__*/ (0, _react.forwardRef)((props, ref)=>{
    const { children, testId } = props, rest = (0, _objectWithoutProperties._)(props, [
        "children",
        "testId"
    ]);
    return /*#__PURE__*/ (0, _reactDefault.default).createElement("div", (0, _objectSpreadProps._)((0, _objectSpread._)({}, rest), {
        "data-testid": testId,
        ref: ref,
        className: (0, _runtime.ax)([
            "_kqswh2mm _6rth1ejb"
        ])
    }), children);
});
const spinnerBackdropStyles = null;
const SpinnerBackdrop = ({ children, testId })=>/*#__PURE__*/ (0, _reactDefault.default).createElement("div", {
        "data-testid": testId && `${testId}--spinner-backdrop`,
        className: (0, _runtime.ax)([
            "_1r04idpf _1e0c1txw _kqswstnw _4cvr1h6o _1bah1h6o _lcxvglyw"
        ])
    }, children);
const spinnerContainerStyles = null;
const SpinnerContainer = /*#__PURE__*/ (0, _react.forwardRef)(({ children }, ref)=>/*#__PURE__*/ (0, _reactDefault.default).createElement("div", {
        ref: ref,
        className: (0, _runtime.ax)([
            "_kqswh2mm _152tidpf"
        ])
    }, children));
class LoadingContainerAdvanced extends (0, _reactDefault.default).Component {
    attachListeners() {
        window.addEventListener('scroll', this.handleScroll);
        window.addEventListener('resize', this.handleResize);
    }
    detachListeners() {
        window.removeEventListener('scroll', this.handleScroll);
        window.removeEventListener('resize', this.handleResize);
    }
    updateSpinnerPosition() {
        var _this_spinnerRef, _this_containerRef;
        const viewportHeight = window.innerHeight;
        const targetNode = this.getTargetNode();
        const spinnerNode = (_this_spinnerRef = this.spinnerRef) === null || _this_spinnerRef === void 0 ? void 0 : _this_spinnerRef.current;
        if (!targetNode || typeof targetNode.getBoundingClientRect !== 'function' || !spinnerNode) return;
        const targetRect = targetNode.getBoundingClientRect();
        const spinnerRect = spinnerNode.getBoundingClientRect();
        const spinnerHeight = spinnerRect.height;
        const isInViewport = this.isVerticallyVisible(targetRect, viewportHeight);
        const { top, bottom, height } = targetRect;
        if (isInViewport) {
            // The spinner may follow the element only if there is enough space:
            // Let's say the element can fit at least three spinners (vertically)
            const canFollow = height >= spinnerHeight * 3;
            if (canFollow && !this.isFullyVerticallyVisible(targetRect, viewportHeight)) {
                if (top >= 0) {
                    // Only the head of the element is visible
                    const viewportSpaceTakenByElement = viewportHeight - top;
                    const diff = viewportSpaceTakenByElement / 2 + top - spinnerHeight / 2;
                    const y = viewportSpaceTakenByElement < spinnerHeight * 3 ? top + spinnerHeight : diff;
                    this.translateSpinner(spinnerNode, y, true);
                } else if (top < 0 && bottom > viewportHeight) {
                    // The element takes all viewport, nor its head nor tail are visible
                    const y = viewportHeight / 2 - spinnerHeight / 2;
                    this.translateSpinner(spinnerNode, y, true);
                } else {
                    // Only the tail of the element is visible
                    const diff = bottom / 2 - spinnerHeight / 2;
                    const y = diff < spinnerHeight ? diff - (spinnerHeight - diff) : diff;
                    this.translateSpinner(spinnerNode, y, true);
                }
                return;
            }
        } else {
            // If both the element and the spinner are off screen - quit
            if (!this.isVerticallyVisible(spinnerRect, viewportHeight)) return;
        }
        // Three options here:
        // 1) the element is fully visible
        // 2) the element is too small for the spinner to follow
        // 3) the spinner might still be visible while the element isn't
        const containerNode = (_this_containerRef = this.containerRef) === null || _this_containerRef === void 0 ? void 0 : _this_containerRef.current;
        if (containerNode && typeof containerNode.getBoundingClientRect === 'function') {
            const thisTop = containerNode.getBoundingClientRect().top;
            const y = (top - thisTop) / 2;
            this.translateSpinner(spinnerNode, y, false);
        }
    }
    render() {
        const { children, isLoading, spinnerSize, testId, loadingLabel } = this.props;
        return /*#__PURE__*/ (0, _reactDefault.default).createElement(Container, {
            testId: testId && `${testId}--loading--container--advanced`,
            ref: this.containerRef
        }, children, isLoading && /*#__PURE__*/ (0, _reactDefault.default).createElement(SpinnerBackdrop, {
            testId: testId
        }, /*#__PURE__*/ (0, _reactDefault.default).createElement(SpinnerContainer, {
            ref: this.spinnerRef
        }, /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _spinnerDefault.default), {
            size: spinnerSize,
            testId: testId && `${testId}--loadingSpinner`,
            label: loadingLabel
        }))));
    }
    constructor(...args){
        super(...args), this.spinnerRef = /*#__PURE__*/ (0, _reactDefault.default).createRef(), this.containerRef = /*#__PURE__*/ (0, _reactDefault.default).createRef(), this.componentDidMount = ()=>{
            if (this.props.isLoading && this.hasTargetNode()) {
                this.attachListeners();
                this.updateTargetAppearance();
                this.updateSpinnerPosition();
            }
        }, this.UNSAFE_componentWillReceiveProps = (nextProps)=>{
            if (!nextProps.isLoading || !this.hasTargetNode(nextProps)) this.detachListeners();
            else if (!this.props.isLoading) this.attachListeners();
        }, this.componentDidUpdate = ()=>{
            if (this.hasTargetNode()) {
                this.updateTargetAppearance();
                if (this.props.isLoading) this.updateSpinnerPosition();
            }
        }, this.componentWillUnmount = ()=>{
            this.detachListeners();
        }, this.getTargetNode = (nextProps = this.props)=>{
            const { targetRef } = nextProps;
            const target = targetRef === null || targetRef === void 0 ? void 0 : targetRef();
            return target || this.containerRef.current;
        }, this.hasTargetNode = (nextProps)=>!!this.getTargetNode(nextProps), this.isVerticallyVisible = (elementRect, viewportHeight)=>{
            const { top, bottom } = elementRect;
            if (bottom <= 0) return false;
            return top < viewportHeight;
        }, this.isFullyVerticallyVisible = (elementRect, viewportHeight)=>{
            const { top, bottom } = elementRect;
            return top >= 0 && bottom <= viewportHeight;
        }, this.handleResize = ()=>{
            this.updateSpinnerPosition();
        }, this.handleScroll = ()=>{
            this.updateSpinnerPosition();
        }, this.translateSpinner = (spinnerNode, transformY, isFixed)=>{
            spinnerNode.style.position = isFixed ? 'fixed' : '';
            spinnerNode.style.transform = transformY !== 0 ? `translate3d(0, ${transformY}px, 0)` : '';
        }, this.updateTargetAppearance = ()=>{
            const targetNode = this.getTargetNode();
            const { isLoading, contentsOpacity } = this.props;
            if (targetNode && targetNode.style && typeof targetNode.style === 'object') {
                targetNode.style.pointerEvents = isLoading ? 'none' : '';
                targetNode.style.opacity = isLoading ? contentsOpacity.toString() : '';
            }
        };
    }
}
LoadingContainerAdvanced.defaultProps = {
    isLoading: true,
    spinnerSize: 'large',
    contentsOpacity: "var(--ds-opacity-loading, 0.2)",
    loadingLabel: 'Loading table'
};

},{"@swc/helpers/_/_object_spread":"9gdrV","@swc/helpers/_/_object_spread_props":"kANqQ","@swc/helpers/_/_object_without_properties":"6HqIM","@compiled/react/runtime":"d27Vo","react":"ltHCL","@atlaskit/spinner":"l22fT","@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"eQJsU":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
// eslint-disable-next-line @repo/internal/react/no-class-components
parcelHelpers.export(exports, "default", ()=>ManagedPagination);
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _pagination = require("@atlaskit/pagination");
var _paginationDefault = parcelHelpers.interopDefault(_pagination);
class ManagedPagination extends (0, _reactDefault.default).Component {
    render() {
        const { total, value = 1, i18n, testId, isDisabled } = this.props;
        const pages = [
            ...Array(total)
        ].map((_, index)=>index + 1);
        // Pagination accepts array now thus selectedIndex starts with 0
        // So, we are substracting value by one thus not breaking dynamic table
        const selectedIndex = value - 1;
        return /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _paginationDefault.default), {
            selectedIndex: selectedIndex,
            isDisabled: isDisabled,
            label: i18n === null || i18n === void 0 ? void 0 : i18n.label,
            nextLabel: i18n === null || i18n === void 0 ? void 0 : i18n.next,
            previousLabel: i18n === null || i18n === void 0 ? void 0 : i18n.prev,
            pageLabel: i18n === null || i18n === void 0 ? void 0 : i18n.pageLabel,
            onChange: this.onChange,
            pages: pages,
            testId: testId && `${testId}--pagination`
        });
    }
    constructor(...args){
        super(...args), this.onChange = (_event, newValue, analyticsEvent)=>{
            this.props.onChange(newValue, analyticsEvent);
        };
    }
}

},{"react":"ltHCL","@atlaskit/pagination":"jL7K3","@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"iaURY":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _objectSpread = require("@swc/helpers/_/_object_spread");
var _objectSpreadProps = require("@swc/helpers/_/_object_spread_props");
var _objectWithoutProperties = require("@swc/helpers/_/_object_without_properties");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _validateSortKey = require("../internal/validate-sort-key");
var _head = require("../styled/head");
var _tableHeadCell = require("./rankable/table-head-cell");
var _tableHeadCellDefault = parcelHelpers.interopDefault(_tableHeadCell);
var _tableHeadCell1 = require("./table-head-cell");
var _tableHeadCellDefault1 = parcelHelpers.interopDefault(_tableHeadCell1);
// eslint-disable-next-line @repo/internal/react/no-class-components
class TableHead extends (0, _reactDefault.default).Component {
    UNSAFE_componentWillMount() {
        (0, _validateSortKey.validateSortKey)(this.props.sortKey, this.props.head);
    }
    UNSAFE_componentWillReceiveProps(nextProps) {
        if (this.props.sortKey !== nextProps.sortKey || this.props.head !== nextProps.head) (0, _validateSortKey.validateSortKey)(nextProps.sortKey, nextProps.head);
    }
    render() {
        const { head, sortKey, sortOrder, isFixedSize, onSort, isRanking, isRankable, testId } = this.props;
        const { activeSortButtonId } = this.state;
        if (!head) return null;
        const HeadCellComponent = isRankable ? (0, _tableHeadCellDefault.default) : (0, _tableHeadCellDefault1.default);
        // TODO: Remove `rest` props and use only what is explicitly in the API.
        // Some tests use this to pass in onClick and other stuff within the `head`
        // variable here, but considering it's not in the API, it should probably
        // be removed.
        const { cells } = head, rest = (0, _objectWithoutProperties._)(head, [
            "cells"
        ]);
        return /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _head.Head), (0, _objectSpreadProps._)((0, _objectSpread._)({}, rest), {
            isRanking: isRanking,
            testId: testId && `${testId}--head`
        }), /*#__PURE__*/ (0, _reactDefault.default).createElement("tr", null, cells.map((cell, index)=>{
            const { ascendingSortTooltip, buttonAriaRoleDescription, colSpan, content, descendingSortTooltip, isIconOnlyHeader, isSortable, key, shouldTruncate, testId: cellTestId, width } = cell, restCellProps = (0, _objectWithoutProperties._)(cell, [
                "ascendingSortTooltip",
                "buttonAriaRoleDescription",
                "colSpan",
                "content",
                "descendingSortTooltip",
                "isIconOnlyHeader",
                "isSortable",
                "key",
                "shouldTruncate",
                "testId",
                "width"
            ]);
            const headCellId = `head-cell-${index}`;
            const handleClick = ()=>{
                this.setState({
                    activeSortButtonId: headCellId
                });
                if (isSortable) onSort(cell)();
            };
            return /*#__PURE__*/ (0, _reactDefault.default).createElement(HeadCellComponent, (0, _objectSpread._)({
                colSpan: colSpan,
                content: content,
                isFixedSize: isFixedSize,
                isIconOnlyHeader: isIconOnlyHeader,
                isSortable: !!isSortable,
                isRanking: isRanking,
                key: key || index,
                headCellId: headCellId,
                activeSortButtonId: activeSortButtonId,
                onClick: handleClick,
                testId: cellTestId || testId,
                shouldTruncate: shouldTruncate,
                sortOrder: key === sortKey ? sortOrder : undefined,
                width: width,
                ascendingSortTooltip: ascendingSortTooltip,
                descendingSortTooltip: descendingSortTooltip,
                buttonAriaRoleDescription: buttonAriaRoleDescription
            }, restCellProps));
        })));
    }
    constructor(props){
        super(props);
        this.state = {
            activeSortButtonId: null
        };
    }
}
// eslint-disable-next-line @repo/internal/react/require-jsdoc
exports.default = TableHead;

},{"@swc/helpers/_/_object_spread":"9gdrV","@swc/helpers/_/_object_spread_props":"kANqQ","@swc/helpers/_/_object_without_properties":"6HqIM","react":"ltHCL","../internal/validate-sort-key":"7ohMc","../styled/head":"98j1v","./rankable/table-head-cell":"h8dac","./table-head-cell":"l6kzm","@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"98j1v":[function(require,module,exports,__globalThis) {
/* head.tsx generated by @compiled/babel-plugin v0.39.1 */ /* eslint-disable @repo/internal/react/require-jsdoc */ var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "Head", ()=>Head);
var _objectSpread = require("@swc/helpers/_/_object_spread");
var _objectSpreadProps = require("@swc/helpers/_/_object_spread_props");
var _objectWithoutProperties = require("@swc/helpers/_/_object_without_properties");
var _react = require("react");
var _runtime = require("@compiled/react/runtime");
const rankingStyles = null;
const headStyles = null;
const Head = (_param)=>{
    var { isRanking, testId } = _param, props = (0, _objectWithoutProperties._)(_param, [
        "isRanking",
        "testId"
    ]);
    return /*#__PURE__*/ _react.createElement("thead", (0, _objectSpreadProps._)((0, _objectSpread._)({
        "data-testid": testId
    }, props), {
        className: (0, _runtime.ax)([
            "_179rglyw",
            isRanking && "_1e0c1ule"
        ])
    }));
};

},{"@swc/helpers/_/_object_spread":"9gdrV","@swc/helpers/_/_object_spread_props":"kANqQ","@swc/helpers/_/_object_without_properties":"6HqIM","react":"ltHCL","@compiled/react/runtime":"d27Vo","@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"h8dac":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _objectSpread = require("@swc/helpers/_/_object_spread");
var _objectWithoutProperties = require("@swc/helpers/_/_object_without_properties");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _withDimensions = require("../../hoc/with-dimensions");
var _withDimensionsDefault = parcelHelpers.interopDefault(_withDimensions);
var _inlineStylesIfRanking = require("../../internal/inline-styles-if-ranking");
var _tableHeadCell = require("../table-head-cell");
var _tableHeadCellDefault = parcelHelpers.interopDefault(_tableHeadCell);
// eslint-disable-next-line @repo/internal/react/no-class-components
class RankableTableHeadCellComponent extends (0, _reactDefault.default).Component {
    render() {
        const _this_props = this.props, { isRanking, refHeight, refWidth } = _this_props, restProps = (0, _objectWithoutProperties._)(_this_props, [
            "isRanking",
            "refHeight",
            "refWidth"
        ]);
        const inlineStyles = (0, _inlineStylesIfRanking.inlineStylesIfRanking)(isRanking, refWidth);
        return /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _tableHeadCellDefault.default), (0, _objectSpread._)({
            inlineStyles: inlineStyles
        }, restProps));
    }
}
const RankableTableHeadCell = (0, _withDimensionsDefault.default)(RankableTableHeadCellComponent);
// eslint-disable-next-line @repo/internal/react/require-jsdoc
exports.default = RankableTableHeadCell;

},{"@swc/helpers/_/_object_spread":"9gdrV","@swc/helpers/_/_object_without_properties":"6HqIM","react":"ltHCL","../../hoc/with-dimensions":"gzYRa","../../internal/inline-styles-if-ranking":"hQ13I","../table-head-cell":"l6kzm","@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"gzYRa":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>withDimensions);
var _objectSpread = require("@swc/helpers/_/_object_spread");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
function withDimensions(WrappedComponent) {
    return class WithDimensions extends (0, _reactDefault.default).Component {
        UNSAFE_componentWillReceiveProps(nextProps) {
            const wasRanking = this.props.isRanking;
            const willRanking = nextProps.isRanking;
            if (willRanking && !wasRanking) this.updateDimensions();
        }
        render() {
            const { refWidth, refHeight } = this.state;
            return /*#__PURE__*/ (0, _reactDefault.default).createElement(WrappedComponent, (0, _objectSpread._)({
                //@ts-expect-error TODO Fix legit TypeScript 3.9.6 improved inference error
                refWidth: refWidth,
                //@ts-expect-error TODO Fix legit TypeScript 3.9.6 improved inference error
                refHeight: refHeight,
                innerRef: this.innerRef
            }, this.props));
        }
        constructor(...args){
            super(...args), this.state = {
                refWidth: 0,
                refHeight: 0
            }, this.innerRef = (ref)=>{
                if (ref && !this.props.isRanking) this.ref = ref;
            }, this.updateDimensions = ()=>{
                if (!this.ref) return;
                const clientRect = this.ref.getBoundingClientRect();
                const { width } = clientRect;
                const { height } = clientRect;
                if (width !== this.state.refWidth || height !== this.state.refHeight) this.setState({
                    refWidth: width,
                    refHeight: height
                });
            };
        }
    };
}

},{"@swc/helpers/_/_object_spread":"9gdrV","react":"ltHCL","@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"hQ13I":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "inlineStylesIfRanking", ()=>inlineStylesIfRanking);
const inlineStylesIfRanking = (isRanking, width, height)=>{
    if (!isRanking) return {};
    if (height) return {
        width,
        height
    };
    return {
        width
    };
};

},{"@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"l6kzm":[function(require,module,exports,__globalThis) {
/* table-head-cell.tsx generated by @compiled/babel-plugin v0.39.1 */ /* eslint-disable @atlaskit/design-system/no-physical-properties */ var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _objectSpread = require("@swc/helpers/_/_object_spread");
var _objectSpreadProps = require("@swc/helpers/_/_object_spread_props");
var _objectWithoutProperties = require("@swc/helpers/_/_object_without_properties");
var _runtime = require("@compiled/react/runtime");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _arrowDown = require("@atlaskit/icon/core/arrow-down");
var _arrowDownDefault = parcelHelpers.interopDefault(_arrowDown);
var _arrowUp = require("@atlaskit/icon/core/arrow-up");
var _arrowUpDefault = parcelHelpers.interopDefault(_arrowUp);
var _compiled = require("@atlaskit/primitives/compiled");
var _tooltip = require("@atlaskit/tooltip");
var _tooltipDefault = parcelHelpers.interopDefault(_tooltip);
var _headCell = require("../styled/head-cell");
const styles = {
    buttonWrapper: "_1e0c1txw _bfhk1j28 _4cvr1h6o _ca0qze3t _u5f3ze3t _n3tdze3t _19bvze3t _d0altlke",
    sortIconHiddenWrapper: "_1e0c1txw _tzy4idpf _bfhk1j28 _ca0q1b66 _u5f31b66 _n3td1b66 _19bv1b66 _1h7hkb7n",
    sortIconVisibleWrapper: "_1e0c1txw _tzy4kb7n _bfhk1j28 _ca0q1b66 _u5f31b66 _n3td1b66 _19bv1b66",
    hideIconHeaderWrapper: "_tzy4idpf _18u010v4",
    visibleHeaderWrapper: "_tzy4kb7n _u5f31b66"
};
const headCellStyles = {
    headCellContainer: "_1e0c1txw _4cvr1h6o",
    text: "_11c8wadc _syazazsu _k48pwu06"
};
const TableHeadCell = (_param)=>{
    var { content, inlineStyles, testId, isRanking, innerRef, isSortable, sortOrder, onClick, headCellId, activeSortButtonId, ascendingSortTooltip = 'Sort ascending', descendingSortTooltip = 'Sort descending', buttonAriaRoleDescription = 'Sort button', isIconOnlyHeader } = _param, rest = (0, _objectWithoutProperties._)(_param, [
        "content",
        "inlineStyles",
        "testId",
        "isRanking",
        "innerRef",
        "isSortable",
        "sortOrder",
        "onClick",
        "headCellId",
        "activeSortButtonId",
        "ascendingSortTooltip",
        "descendingSortTooltip",
        "buttonAriaRoleDescription",
        "isIconOnlyHeader"
    ]);
    const [isHovered, setIsHovered] = (0, _react.useState)(false);
    const [isFocused, setIsFocused] = (0, _react.useState)(false);
    const isActive = headCellId === activeSortButtonId || sortOrder !== undefined;
    const isSortIconVisible = isHovered || isActive || isFocused;
    const isVisibleIconOnlyHeader = isSortIconVisible && isIconOnlyHeader;
    const shouldRenderSortIcon = !isIconOnlyHeader || isSortIconVisible || isIconOnlyHeader && !isFocused;
    const handleFocus = (0, _react.useCallback)(()=>{
        setIsFocused === null || setIsFocused === void 0 ? void 0 : setIsFocused(true);
    }, [
        setIsFocused
    ]);
    const handleBlur = (0, _react.useCallback)(()=>{
        setIsFocused === null || setIsFocused === void 0 ? void 0 : setIsFocused(false);
    }, [
        setIsFocused
    ]);
    const handleMouseEnter = (0, _react.useCallback)(()=>{
        setIsHovered(true);
    }, [
        setIsHovered
    ]);
    const handleMouseLeave = (0, _react.useCallback)(()=>{
        setIsHovered(false);
    }, [
        setIsHovered
    ]);
    const visuallyRefreshedButton = /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _compiled.Box), {
        xcss: headCellStyles.headCellContainer,
        onMouseEnter: handleMouseEnter,
        onMouseLeave: handleMouseLeave,
        onFocus: handleFocus,
        onBlur: handleBlur
    }, /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _tooltipDefault.default), {
        content: sortOrder === 'ASC' ? ascendingSortTooltip : descendingSortTooltip
    }, /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _compiled.Pressable), {
        onClick: onClick,
        xcss: styles.buttonWrapper,
        "aria-roledescription": buttonAriaRoleDescription
    }, /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _compiled.Flex), {
        xcss: isVisibleIconOnlyHeader ? styles.hideIconHeaderWrapper : styles.visibleHeaderWrapper
    }, /*#__PURE__*/ (0, _reactDefault.default).createElement("span", {
        className: (0, _runtime.ax)([
            headCellStyles.text
        ])
    }, content)), shouldRenderSortIcon && /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _compiled.Flex), {
        xcss: isSortIconVisible ? styles.sortIconVisibleWrapper : styles.sortIconHiddenWrapper
    }, sortOrder === 'ASC' ? /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _arrowUpDefault.default), {
        label: "",
        color: "var(--ds-text-subtle, #505258)",
        testId: testId && `${testId}--up--icon`
    }) : /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _arrowDownDefault.default), {
        label: "",
        color: "var(--ds-text-subtle, #505258)",
        testId: testId && `${testId}--down--icon`
    })))));
    return /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _headCell.HeadCell), (0, _objectSpreadProps._)((0, _objectSpread._)({
        // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
        style: inlineStyles,
        testId: testId && `${testId}--head--cell`,
        ref: typeof innerRef !== 'string' ? innerRef : null
    }, rest), {
        isSortable: isSortable,
        sortOrder: sortOrder
    }), isSortable ? visuallyRefreshedButton : content);
};
// eslint-disable-next-line @repo/internal/react/require-jsdoc
exports.default = TableHeadCell;

},{"@swc/helpers/_/_object_spread":"9gdrV","@swc/helpers/_/_object_spread_props":"kANqQ","@swc/helpers/_/_object_without_properties":"6HqIM","@compiled/react/runtime":"d27Vo","react":"ltHCL","@atlaskit/icon/core/arrow-down":"1ItQx","@atlaskit/icon/core/arrow-up":"kK2kA","@atlaskit/primitives/compiled":"hDay7","@atlaskit/tooltip":"7RyYv","../styled/head-cell":"jN2E1","@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"jN2E1":[function(require,module,exports,__globalThis) {
/* head-cell.tsx generated by @compiled/babel-plugin v0.39.1 */ /* eslint-disable @repo/internal/react/require-jsdoc */ var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "HeadCell", ()=>HeadCell);
var _objectSpread = require("@swc/helpers/_/_object_spread");
var _objectSpreadProps = require("@swc/helpers/_/_object_spread_props");
var _objectWithoutProperties = require("@swc/helpers/_/_object_without_properties");
var _react = require("react");
var _runtime = require("@compiled/react/runtime");
var _constants = require("./constants");
const CSS_VAR_TEXT_COLOR = '--local-dynamic-table-text-color';
const overflowTruncateStyles = null;
const truncationWidthStyles = null;
const fixedSizeTruncateStyles = null;
const cellStyles = null;
const headCellBaseStyles = null;
const HeadCell = /*#__PURE__*/ (0, _react.forwardRef)((_param, ref)=>{
    var { width, children, isSortable, sortOrder, isFixedSize, shouldTruncate, onClick, style, testId } = _param, rest = (0, _objectWithoutProperties._)(_param, [
        "width",
        "children",
        "isSortable",
        "sortOrder",
        "isFixedSize",
        "shouldTruncate",
        "onClick",
        "style",
        "testId"
    ]);
    const mergedStyles = (0, _objectSpreadProps._)((0, _objectSpread._)({}, style, width && (0, _constants.getTruncationStyleVars)({
        width
    })), {
        [CSS_VAR_TEXT_COLOR]: "var(--ds-text-subtlest, #6B6E76)"
    });
    const isASC = sortOrder === 'ASC';
    const isDESC = sortOrder === 'DESC';
    const getFormattedSortOrder = ()=>{
        if (isASC) return 'ascending';
        else if (isDESC) return 'descending';
        return;
    };
    // If there is no content in the cell, it should be rendered as an empty `td`, not a `th`.
    // https://dequeuniversity.com/rules/axe/4.7/empty-table-header
    const Component = children ? 'th' : 'td';
    return /*#__PURE__*/ _react.createElement(Component, (0, _objectSpreadProps._)((0, _objectSpread._)({
        "aria-sort": getFormattedSortOrder(),
        // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
        style: mergedStyles,
        onClick: undefined,
        ref: ref,
        "data-testid": testId
    }, rest), {
        className: (0, _runtime.ax)([
            "_izbqglyw _h7alglyw _85i51b66 _1q511b66 _y4tiu2gc _bozgu2gc _y3gn1e5h _1s37ze3t _uupyze3t",
            "_11c8wadc _179r1uh4 _mqm2glyw _kqswh2mm _syazazsu _k48pwu06 _y3gn1e5h _s7n4nkob _1ygbd0i9",
            "_1bsb8a2a",
            isFixedSize && shouldTruncate && "_1bto1l2s _o5721q9c",
            isFixedSize && "_1reo15vq _18m915vq"
        ])
    }), children);
});

},{"@swc/helpers/_/_object_spread":"9gdrV","@swc/helpers/_/_object_spread_props":"kANqQ","@swc/helpers/_/_object_without_properties":"6HqIM","react":"ltHCL","@compiled/react/runtime":"d27Vo","./constants":"bL6Bn","@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"el40d":[function(require,module,exports,__globalThis) {
module.exports = Promise.all([
    require("444bc2854f1ada70")(require("e4e25c9e414ba5f5").resolve("9kMTz")),
    require("444bc2854f1ada70")(require("e4e25c9e414ba5f5").resolve("3rXnz"))
]).then(()=>module.bundle.root('acPUg'));

},{"444bc2854f1ada70":"hkfCW","e4e25c9e414ba5f5":"l4T2r"}],"dtb2r":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>(0, _textAreaDefault.default));
var _textArea = require("./text-area");
var _textAreaDefault = parcelHelpers.interopDefault(_textArea);

},{"./text-area":"hgIsx","@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"hgIsx":[function(require,module,exports,__globalThis) {
/* text-area.tsx generated by @compiled/babel-plugin v0.39.1 */ var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _objectSpread = require("@swc/helpers/_/_object_spread");
var _objectSpreadProps = require("@swc/helpers/_/_object_spread_props");
var _objectWithoutProperties = require("@swc/helpers/_/_object_without_properties");
var _runtime = require("@compiled/react/runtime");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _analyticsNext = require("@atlaskit/analytics-next");
var _platformFeatureFlags = require("@atlaskit/platform-feature-flags");
const packageName = "@af/atlassian-studio";
const packageVersion = "0.16.1";
const analyticsParams = {
    componentName: 'textArea',
    packageName,
    packageVersion
};
const lineHeightBase = 20;
const lineHeightCompact = 16;
const compactVerticalPadding = 2;
const verticalPadding = 6;
const transitionDuration = '0.2s';
const borderWidth = 2;
const baseStyles = null;
const baseStylesT26Shape = null;
const appearanceStyles = {
    standard: "_1dqonqa1 _kp82rsbi _1ltx1j9a _1bqsbk0g _z1pv187o _19wtrsbi _12yml4ek _1l02v77o _11zpv77o _141f1v6z _daj71v6z _olc612x7 _14ji12x7 _7ba01v6z _1kod1v6z _858u1v1w _jomrr01l _7ehivyy1 _186j1v1w _qu18187o",
    subtle: "_1dqonqa1 _kp821j28 _1ltx1j28 _19wtrsbi _12yml4ek _1l02v77o _11zpv77o _141f1v6z _daj71v6z _olc612x7 _14ji12x7 _1kod1v6z _7ba01v6z _858u1v1w _jomrr01l _7ehivyy1",
    none: "_1dqoglyw _kp821j28 _1ltx1j28 _19wt1j28 _12ym1j28 _1l02v77o _daj712x7 _11zpv77o _141f12x7 _olc612x7 _1kod12x7 _14ji12x7 _7ba012x7 _858u1j28 _jomr1j28 _7ehi3sij"
};
// iOS Safari automatically zooms into form inputs on focus when the font size is less than 16px.
// To prevent this zoom behaviour on mobile devices, the textarea uses font.body.large (16px) by default,
// then switches to the smaller font.body on screens wider than 30rem (desktop).
// @see: https://medium.com/@rares.popescu/2-ways-to-avoid-the-automatic-zoom-in-on-input-fields-8a71479e542e
const fontStyles = {
    default: "_11c81d4k _1tn2fhey",
    monospace: "_11c81d4k _ect4zzfg _1tn2fhey _14md1vhz"
};
const resizeStyles = {
    horizontal: "_14zg1e08",
    vertical: "_14zg1e54",
    auto: "_14zg1hrf",
    smart: "_14zgglyw",
    none: "_14zgglyw"
};
const setSmartHeight = (el)=>{
    // Always reset height to auto before calculating new height
    el.style.height = 'auto';
    const borderHeight = borderWidth;
    const paddingBoxHeight = el.scrollHeight;
    const borderBoxHeight = paddingBoxHeight + borderHeight * 2;
    el.style.height = `${borderBoxHeight}px`;
};
const InnerTextArea = /*#__PURE__*/ (0, _react.forwardRef)((props, ref)=>{
    const ourRef = (0, _react.useRef)(null);
    const { resize = 'smart', appearance = 'standard', isCompact = false, isRequired = false, isReadOnly = false, isDisabled = false, isInvalid = false, isMonospaced = false, minimumRows = 2, testId, maxHeight = '50vh', onBlur, onFocus, onChange, value, style } = props, rest = (0, _objectWithoutProperties._)(props, [
        "resize",
        "appearance",
        "isCompact",
        "isRequired",
        "isReadOnly",
        "isDisabled",
        "isInvalid",
        "isMonospaced",
        "minimumRows",
        "testId",
        "maxHeight",
        "onBlur",
        "onFocus",
        "onChange",
        "value",
        "style"
    ]);
    const borderHeight = (0, _react.useMemo)(()=>appearance === 'none' ? 2 : 1, [
        appearance
    ]);
    (0, _react.useEffect)(()=>{
        const el = ourRef.current;
        if (resize === 'smart' && el) setSmartHeight(el);
    }, [
        resize,
        value
    ]);
    const onBlurWithAnalytics = (0, _analyticsNext.usePlatformLeafEventHandler)((0, _objectSpread._)({
        fn: (event)=>{
            onBlur && onBlur(event);
        },
        action: 'blurred'
    }, analyticsParams));
    const onFocusWithAnalytics = (0, _analyticsNext.usePlatformLeafEventHandler)((0, _objectSpread._)({
        fn: (event)=>{
            onFocus && onFocus(event);
        },
        action: 'focused'
    }, analyticsParams));
    const getTextAreaRef = (elementRef)=>{
        ourRef.current = elementRef;
        if (ref && typeof ref === 'object') // @ts-ignore
        ref.current = elementRef;
        if (ref && typeof ref === 'function') ref(elementRef);
    };
    const handleOnChange = (0, _react.useCallback)((e)=>{
        const el = ourRef.current;
        if (resize === 'smart' && el) setSmartHeight(el);
        onChange && onChange(e);
    }, [
        onChange,
        resize
    ]);
    const controlProps = {
        'data-invalid': isInvalid ? isInvalid : undefined,
        'data-compact': isCompact ? isCompact : undefined,
        'data-testid': testId ? testId : undefined
    };
    const compactMinHeightStyles = null;
    return /*#__PURE__*/ (0, _reactDefault.default).createElement("textarea", (0, _objectSpreadProps._)((0, _objectSpread._)((0, _objectSpreadProps._)((0, _objectSpread._)({}, controlProps), {
        value: value,
        disabled: isDisabled,
        readOnly: isReadOnly,
        required: isRequired,
        ref: getTextAreaRef,
        onChange: handleOnChange,
        onBlur: onBlurWithAnalytics,
        onFocus: onFocusWithAnalytics,
        rows: minimumRows
    }), rest), {
        className: (0, _runtime.ax)([
            "_19pkidpf _2hwxidpf _otyridpf _18u0idpf _16jlkb7n _1o9zkb7n _i0dl1osq _2rkofajl _11c8fhey _12ji1r31 _1qu2glyw _12y31o36 _1reo1wug _18m91wug _v564r5cv _189ee4h9 _1e0c1ule _vchhusvi _1bsb1osq _1ul9idpf _p12f1osq _kqswh2mm _syazi7uo _slp31hna _153g1bqt _usy41j9a _1a2sizbr _vbqb1gmx _j5dh13gf _cfjqkb7n _k3o7n7od _1goxglyw _13xeglyw _1fra1bqt _ibjdl4ek _6zpvizbr _19k0187o _1idr1rpy _1lep1gmx _nmhq1fiz _1n388sxn _1luh1v1w _ndzbr01l _1vj0vyy1",
            (0, _platformFeatureFlags.fg)('platform-dst-shape-theme-default') && "_2rko1qi0",
            appearanceStyles[appearance],
            fontStyles[isMonospaced ? 'monospace' : 'default'],
            resizeStyles[resize],
            "_uzq71i7i _16lwuel1"
        ]),
        style: (0, _objectSpreadProps._)((0, _objectSpread._)({}, style), {
            maxHeight,
            "--_6ny3x7": (0, _runtime.ix)(lineHeightCompact * minimumRows + compactVerticalPadding * 2 + borderHeight * 2, "px"),
            "--_eorxnz": (0, _runtime.ix)(lineHeightBase * minimumRows + verticalPadding * 2 + borderHeight * 2, "px")
        })
    }));
});
/**
 * __Text area__
 *
 * A text area lets users enter long form text which spans over multiple lines.
 *
 * - [Examples](https://atlassian.design/components/textarea/examples)
 * - [Code](https://atlassian.design/components/textarea/code)
 * - [Usage](https://atlassian.design/components/textarea/usage)
 */ const TextArea = /*#__PURE__*/ (0, _react.memo)(/*#__PURE__*/ (0, _react.forwardRef)(function TextArea(props, ref) {
    return /*#__PURE__*/ (0, _reactDefault.default).createElement(InnerTextArea, (0, _objectSpread._)({
        ref: ref
    }, props));
}));
TextArea.displayName = 'TextArea';
exports.default = TextArea;

},{"@swc/helpers/_/_object_spread":"9gdrV","@swc/helpers/_/_object_spread_props":"kANqQ","@swc/helpers/_/_object_without_properties":"6HqIM","@compiled/react/runtime":"d27Vo","react":"ltHCL","@atlaskit/analytics-next":"6PLie","@atlaskit/platform-feature-flags":"8rD2i","@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"6BZyw":[function(require,module,exports,__globalThis) {
/* index.tsx generated by @compiled/babel-plugin v0.39.1 */ var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "AddOverride", ()=>AddOverride);
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _new = require("@atlaskit/button/new");
var _newDefault = parcelHelpers.interopDefault(_new);
var _compiled = require("@atlaskit/primitives/compiled");
var _textfield = require("@atlaskit/textfield");
var _textfieldDefault = parcelHelpers.interopDefault(_textfield);
var _toggle = require("@atlaskit/toggle");
var _toggleDefault = parcelHelpers.interopDefault(_toggle);
var _persistance = require("../../../common/persistance");
const styles = {
    container: "_1e0c11p5 _yv0enj3y _gy1pu2gc _4cvr1h6o",
    toggleWrapper: "_10fp1h6o"
};
const AddOverride = ({ updateOverrides })=>{
    const [name, setName] = (0, _react.useState)('');
    const [value, setValue] = (0, _react.useState)(true);
    const onAddClick = (0, _react.useCallback)(()=>{
        (0, _persistance.overrideGate)(name.trim(), value);
        setValue(true);
        setName('');
        updateOverrides();
    }, [
        name,
        updateOverrides,
        value
    ]);
    return /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _compiled.Box), {
        xcss: styles.container
    }, /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _textfieldDefault.default), {
        id: "name-textfield",
        label: "Name",
        placeholder: `your_gate_name`,
        onChange: (e)=>setName(e.currentTarget.value),
        value: name
    }), /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _compiled.Box), {
        xcss: styles.toggleWrapper
    }, /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _toggleDefault.default), {
        id: "gate-toggle",
        isChecked: value,
        onChange: (e)=>setValue(e.target.checked)
    })), /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _newDefault.default), {
        onClick: onAddClick
    }, "Add"));
};

},{"react":"ltHCL","@atlaskit/button/new":"aXnNi","@atlaskit/primitives/compiled":"hDay7","@atlaskit/textfield":"kUxJE","@atlaskit/toggle":"gXZqw","../../../common/persistance":"ajVwM","@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"kUxJE":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>(0, _textFieldDefault.default));
var _textField = require("./text-field");
var _textFieldDefault = parcelHelpers.interopDefault(_textField);

},{"./text-field":"hpvqh","@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"hpvqh":[function(require,module,exports,__globalThis) {
/* text-field.tsx generated by @compiled/babel-plugin v0.39.1 */ var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _objectSpread = require("@swc/helpers/_/_object_spread");
var _objectSpreadProps = require("@swc/helpers/_/_object_spread_props");
var _objectWithoutProperties = require("@swc/helpers/_/_object_without_properties");
var _runtime = require("@compiled/react/runtime");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _analyticsNext = require("@atlaskit/analytics-next");
var _platformFeatureFlags = require("@atlaskit/platform-feature-flags");
const containerMedia = {
    invalid: "_msj6gir2",
    disabled: "_6up518qt"
};
const inputMediaDisabled = null;
const analyticsParams = {
    componentName: 'textField',
    packageName: "@af/atlassian-studio",
    packageVersion: "0.16.1"
};
const disabledStyle = {
    standard: "_1h6d187o _bfhk187o _syaz1gmx _80om13gf",
    subtle: "_1h6d1j28 _bfhk1j28 _syaz1gmx _80om13gf",
    none: "_1h6d1j28 _bfhk1j28 _syaz1gmx _80om13gf"
};
const invalidStyle = null;
const focusWithinStyle = {
    standard: "_1p9x1v1w _qao9r01l _q433vyy1",
    subtle: "_1p9x1v1w _qao9r01l _q433vyy1",
    none: "_1p9x1j28 _qao91j28 _q4333sij"
};
const hoverStyle = {
    standard: "_4cvxrsbi _irr3l4ek",
    subtle: "_4cvxrsbi _irr3l4ek",
    none: "_4cvx1j28 _irr31j28"
};
const getContainerTextBgAndBorderColor = {
    standard: "_1h6drsbi _1dqonqa1 _syazi7uo _80om1kdv _bfhk1j9a _msj6gir2",
    subtle: "_1h6d1j28 _1dqonqa1 _syazi7uo _80om1kdv _16hg1j28 _msj6gir2",
    none: "_1h6d1j28 _1dqoglyw _syazi7uo _80om1kdv _16hg1j28 _msj6gir2"
};
const widthMap = {
    xsmall: 80,
    small: 160,
    medium: 240,
    large: 320,
    xlarge: 480
};
const getMaxWidth = (width)=>!width ? `100%` : width in widthMap ? `${widthMap[width]}px` : `${+width}px`;
const containerStyleAppearance = {
    standard: "_1dqonqa1 _1q51e4h9 _85i5e4h9 _bozgidpf _y4tiidpf",
    subtle: "_1dqonqa1 _1q51e4h9 _85i5e4h9 _bozgidpf _y4tiidpf",
    none: "_1dqoglyw"
};
const containerStyles = null;
const containerStylesT26Shape = null;
const inputDisabledStyle = null;
const inputCompactStyle = null;
const inputMonospacedStyle = null;
// iOS Safari automatically zooms into form inputs on focus when the font size is less than 16px.
// To prevent this zoom behaviour on mobile devices, the textfield uses font.body.large (16px) by default,
// then switches to the smaller font.body on screens wider than 30rem (desktop).
// @see: https://medium.com/@rares.popescu/2-ways-to-avoid-the-automatic-zoom-in-on-input-fields-8a71479e542e
const inputStyle = null;
/**
 * __Textfield__
 *
 * A text field is an input that allows a user to write or edit text.
 *
 * - [Examples](https://atlassian.design/components/textfield/examples)
 * - [Code](https://atlassian.design/components/textfield/code)
 * - [Usage](https://atlassian.design/components/textfield/usage)
 */ const Textfield = /*#__PURE__*/ (0, _react.forwardRef)((props, ref)=>{
    const { appearance = 'standard', className, elemAfterInput, elemBeforeInput, isCompact = false, isDisabled = false, isInvalid = false, isMonospaced = false, isReadOnly = false, isRequired = false, name, onBlur, onChange, onFocus, onMouseDown, placeholder, testId, width } = props, spreadProps = (0, _objectWithoutProperties._)(props, [
        "appearance",
        "className",
        "elemAfterInput",
        "elemBeforeInput",
        "isCompact",
        "isDisabled",
        "isInvalid",
        "isMonospaced",
        "isReadOnly",
        "isRequired",
        "name",
        "onBlur",
        "onChange",
        "onFocus",
        "onMouseDown",
        "placeholder",
        "testId",
        "width"
    ]);
    const inputRef = (0, _react.useRef)(null);
    const handleOnFocus = (0, _analyticsNext.usePlatformLeafEventHandler)((0, _objectSpread._)({
        fn: (event)=>{
            onFocus && onFocus(event);
        },
        action: 'focused'
    }, analyticsParams));
    const handleOnBlur = (0, _analyticsNext.usePlatformLeafEventHandler)((0, _objectSpread._)({
        fn: (event)=>{
            onBlur && onBlur(event);
        },
        action: 'blurred'
    }, analyticsParams));
    const handleOnMouseDown = (0, _react.useCallback)((event)=>{
        // Running e.preventDefault() on the INPUT prevents double click behaviour
        // Sadly we needed this cast as the target type is being correctly set
        const target = event.target;
        if (target.tagName !== 'INPUT') event.preventDefault();
        if (inputRef && inputRef.current && !isDisabled && document.activeElement !== inputRef.current) inputRef.current.focus();
        onMouseDown && onMouseDown(event);
    }, [
        onMouseDown,
        isDisabled
    ]);
    const setInputRef = (0, _react.useCallback)((inputElement)=>{
        inputRef.current = inputElement;
        if (!ref) return;
        if (typeof ref === 'object') ref.current = inputElement;
        if (typeof ref === 'function') ref(inputElement);
    }, [
        ref
    ]);
    return /*#__PURE__*/ (0, _reactDefault.default).createElement("div", {
        role: "presentation",
        "data-disabled": isDisabled ? isDisabled : undefined,
        "data-invalid": isInvalid ? isInvalid : undefined,
        "data-ds--text-field--container": true,
        "data-testid": testId && `${testId}-container`,
        onMouseDown: handleOnMouseDown,
        style: {
            maxWidth: `${getMaxWidth(width)}`
        },
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
        className: (0, _runtime.ax)([
            "_16jlkb7n _1o9zkb7n _i0dl1osq _11c8fhey _1reo15vq _18m915vq _v564r5cv _189ee4h9 _1e0c1txw _vchhusvi _4cvr1h6o _1bah1yb4 _lcxv1wug _s7n4jp4b _slp31hna _1tnqfajl",
            (0, _platformFeatureFlags.fg)('platform-dst-shape-theme-default') && "_1tnq1qi0",
            getContainerTextBgAndBorderColor[appearance],
            containerStyleAppearance[appearance],
            !isDisabled && focusWithinStyle[appearance],
            !isDisabled && hoverStyle[appearance],
            isDisabled && containerMedia.disabled,
            isDisabled && disabledStyle[appearance],
            isInvalid && containerMedia.invalid,
            isInvalid && "_1h6d1bqt _4cvx1bqt _16qsizbr _1dbzizbr _uk1sr01l",
            className
        ])
    }, elemBeforeInput, /*#__PURE__*/ (0, _reactDefault.default).createElement("input", (0, _objectSpreadProps._)((0, _objectSpread._)({}, spreadProps), {
        "aria-invalid": isInvalid ? isInvalid : undefined,
        // TODO: When removing legacy theming fix this.
        "data-compact": isCompact ? isCompact : undefined,
        "data-ds--text-field--input": true,
        "data-monospaced": isMonospaced ? isMonospaced : undefined,
        "data-testid": testId,
        disabled: isDisabled,
        name: name,
        onBlur: handleOnBlur,
        onChange: onChange,
        onFocus: handleOnFocus,
        placeholder: placeholder,
        readOnly: isReadOnly,
        ref: setInputRef,
        required: isRequired,
        className: (0, _runtime.ax)([
            "_19itidpf _11c81d4k _12ji1r31 _1qu2glyw _12y31o36 _vchhusvi _1bsb1osq _1ul9idpf _bfhk1j28 _syaz1kw7 _80om1kw7 _14ji12x7 _olc612x7 _1kod12x7 _7ba012x7 _1goxglyw _13xeglyw _1n7e1l2s _1idr1rpy _1tn2fhey _l9oiu2gc _549yu2gc _1h5w12x7 _124212x7",
            isMonospaced && "_ect4zzfg _14mdzzfg",
            isCompact && "_11zpv77o _1l02v77o _daj712x7 _141f12x7 _1srd1b66 _oi9h1b66 _1e3012x7 _1txv12x7",
            isDisabled && "_syaz1gmx _1idr1gmx",
            isDisabled && "_1fnx18qt"
        ])
    })), elemAfterInput);
});
exports.default = Textfield;

},{"@swc/helpers/_/_object_spread":"9gdrV","@swc/helpers/_/_object_spread_props":"kANqQ","@swc/helpers/_/_object_without_properties":"6HqIM","@compiled/react/runtime":"d27Vo","react":"ltHCL","@atlaskit/analytics-next":"6PLie","@atlaskit/platform-feature-flags":"8rD2i","@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"gXZqw":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>(0, _toggleDefault.default));
var _toggle = require("./toggle");
var _toggleDefault = parcelHelpers.interopDefault(_toggle);

},{"./toggle":"7mg58","@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"7mg58":[function(require,module,exports,__globalThis) {
/* toggle.tsx generated by @compiled/babel-plugin v0.39.1 */ var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _objectSpread = require("@swc/helpers/_/_object_spread");
var _runtime = require("@compiled/react/runtime");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _analyticsNext = require("@atlaskit/analytics-next");
var _noop = require("@atlaskit/ds-lib/noop");
var _noopDefault = parcelHelpers.interopDefault(_noop);
var _useId = require("@atlaskit/ds-lib/use-id");
var _checkMark = require("@atlaskit/icon/core/check-mark");
var _checkMarkDefault = parcelHelpers.interopDefault(_checkMark);
var _cross = require("@atlaskit/icon/core/cross");
var _crossDefault = parcelHelpers.interopDefault(_cross);
var _spinner = require("@atlaskit/spinner");
var _spinnerDefault = parcelHelpers.interopDefault(_spinner);
var _visuallyHidden = require("@atlaskit/visually-hidden");
var _visuallyHiddenDefault = parcelHelpers.interopDefault(_visuallyHidden);
var _iconContainer = require("./icon-container");
var _iconContainerDefault = parcelHelpers.interopDefault(_iconContainer);
const LOADING_LABEL = ', Loading';
const baseStyles = null;
const sizeStyles = {
    regular: "_2rko1rr0 _4t3ipxbi _1bsbxy5q _kfgtutpp _1mp41crf",
    large: "_2rko1rr0 _4t3iv47k _1bsb1jfw _kfgtpxbi _1mp47vkz"
};
/**
 * Slider knob translate transforms per size, applied when checked.
 */ const checkedSliderStyles = {
    regular: "_7dwz1fbe",
    large: "_7dwzw12q"
};
/**
 * Applied when the toggle is checked
 */ const checkedStyles = null;
/**
 * Applied when the toggle is checked and not disabled.
 */ const checkedHoveredStyles = null;
/**
 * Applied when the toggle is unchecked and not disabled.
 */ const uncheckedHoveredStyles = null;
/**
 * Applied when the toggle is disabled.
 */ const disabledStyles = null;
const inputStyles = null;
const noop = (0, _noopDefault.default);
const analyticsAttributes = {
    componentName: 'toggle',
    packageName: "@af/atlassian-studio",
    packageVersion: "0.16.1"
};
/**
 * __Toggle__
 *
 * A toggle is used to view or switch between enabled or disabled states.
 *
 * - [Examples](https://atlassian.design/components/toggle/examples)
 * - [Code](https://atlassian.design/components/toggle/code)
 * - [Usage](https://atlassian.design/components/toggle/usage)
 */ const Toggle = /*#__PURE__*/ (0, _react.memo)(/*#__PURE__*/ (0, _react.forwardRef)((props, ref)=>{
    const { defaultChecked = false, isDisabled = false, onBlur: providedOnBlur = noop, onChange: providedChange = noop, onFocus: providedFocus = noop, size = 'regular', name = '', value = '', isChecked, isLoading, analyticsContext, id, testId, label, descriptionId } = props;
    const isControlled = typeof isChecked === 'undefined';
    const [checked, setChecked] = (0, _react.useState)(defaultChecked);
    const loadingLabelId = (0, _useId.useId)();
    const handleBlur = (0, _analyticsNext.usePlatformLeafEventHandler)((0, _objectSpread._)({
        fn: providedOnBlur,
        action: 'blur',
        analyticsData: analyticsContext
    }, analyticsAttributes));
    const handleFocus = (0, _analyticsNext.usePlatformLeafEventHandler)((0, _objectSpread._)({
        fn: providedFocus,
        action: 'focus',
        analyticsData: analyticsContext
    }, analyticsAttributes));
    const handleChange = (0, _analyticsNext.usePlatformLeafEventHandler)((0, _objectSpread._)({
        fn: (event, analyticsEvent)=>{
            if (isControlled) setChecked((checked)=>!checked);
            return providedChange(event, analyticsEvent);
        },
        action: 'change',
        analyticsData: analyticsContext
    }, analyticsAttributes));
    const shouldChecked = isControlled ? checked : isChecked;
    const labelId = (0, _useId.useId)();
    return /*#__PURE__*/ (0, _reactDefault.default).createElement("label", {
        "data-testid": testId,
        className: (0, _runtime.ax)([
            "_1h6d1j28 _1dqonqa1 _189e1dm9 _1e0c1o8l _vchh1ntv _kqswh2mm _1y1m1ntv _bfhk1aqn _syaz5w2r _80omtlke _6rthv77o _1pfhv77o _12l2v77o _ahbqv77o _85i5v77o _1q51v77o _y4tiv77o _bozgv77o _1oeci9qs _k8m01e03 _6fl4574g _rfx31qll _1cs8stnw _1rus5w2r _1kt9b3bt _1fkr1y44 _z5wt1y44 _1cg6i9qs _qs2z1e03 _mlfe574g _1ys41v1w _ju3ddkaa _16rslghj _i5ec1w7i",
            sizeStyles[size],
            shouldChecked && "_bfhkkcmj",
            shouldChecked && checkedSliderStyles[size],
            !isDisabled && shouldChecked && "_irr3y7x8",
            !isDisabled && !shouldChecked && "_irr31ibz",
            isDisabled && "_bfhk187o _syaz2sac _80om13gf"
        ])
    }, label ? /*#__PURE__*/ (0, _reactDefault.default).createElement("span", {
        id: labelId,
        hidden: true
    }, isLoading ? `${label}${LOADING_LABEL}` : label) : null, /*#__PURE__*/ (0, _reactDefault.default).createElement("input", {
        ref: ref,
        checked: shouldChecked,
        disabled: isDisabled,
        id: id,
        name: name,
        onBlur: handleBlur,
        onChange: handleChange,
        onFocus: handleFocus,
        type: "checkbox",
        value: value,
        "data-testid": testId && `${testId}--input`,
        "aria-labelledby": isLoading && label ? `${labelId} ${loadingLabelId}` : label ? labelId : undefined,
        "aria-describedby": descriptionId,
        className: (0, _runtime.ax)([
            "_19pkidpf _2hwxidpf _otyridpf _18u0idpf _ca0qidpf _u5f3idpf _n3tdidpf _19bvidpf _19itglyw _tzy4idpf _nt751snc _49pcagmp _1hvw10yn"
        ])
    }), /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _iconContainerDefault.default), {
        size: size,
        isHidden: !shouldChecked,
        position: "left"
    }, isLoading && shouldChecked ? /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _spinnerDefault.default), {
        size: "xsmall",
        appearance: "invert"
    }) : /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _checkMarkDefault.default), {
        label: "",
        color: "currentColor",
        testId: testId && `${testId}--toggle-check-icon`,
        size: "small"
    })), /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _iconContainerDefault.default), {
        size: size,
        isHidden: shouldChecked,
        position: "right"
    }, isLoading && !shouldChecked ? /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _spinnerDefault.default), {
        size: "xsmall",
        appearance: "invert"
    }) : /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _crossDefault.default), {
        label: "",
        color: "currentColor",
        testId: testId && `${testId}--toggle-cross-icon`,
        size: "small"
    })), isLoading && !label && /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _visuallyHiddenDefault.default), {
        id: loadingLabelId
    }, LOADING_LABEL));
}));
Toggle.displayName = 'Toggle';
exports.default = Toggle;

},{"@swc/helpers/_/_object_spread":"9gdrV","@compiled/react/runtime":"d27Vo","react":"ltHCL","@atlaskit/analytics-next":"6PLie","@atlaskit/ds-lib/noop":"faKzG","@atlaskit/ds-lib/use-id":"9jWCD","@atlaskit/icon/core/check-mark":"iwzAF","@atlaskit/icon/core/cross":"7mJX1","@atlaskit/spinner":"l22fT","@atlaskit/visually-hidden":"gKDx1","./icon-container":"gaRfB","@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"gaRfB":[function(require,module,exports,__globalThis) {
/* icon-container.tsx generated by @compiled/babel-plugin v0.39.1 */ var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _react = require("react");
var _css = require("@atlaskit/css");
var _compiled = require("@atlaskit/primitives/compiled");
const styles = {
    iconContainer: "_v5641hrg _1e0c116y _4cvr1h6o _1bah1h6o _kqswstnw _152tv77o",
    iconContainerRegular: "_1bsb7vkz _4t3i7vkz",
    iconContainerLarge: "_1bsbgktf _4t3igktf",
    hidden: "_tzy4idpf",
    left: "_1e021l7b",
    right: "_rjxp1l7b"
};
/**
 * __Icon container__
 *
 * Positions a toggle's check and close icons.
 */ const IconContainer = ({ children, size, isHidden, position })=>{
    return /*#__PURE__*/ _react.createElement((0, _compiled.Box), {
        as: "span",
        xcss: (0, _css.cx)(styles.iconContainer, isHidden && styles.hidden, size === 'regular' && styles.iconContainerRegular, size === 'large' && styles.iconContainerLarge, position === 'left' && styles.left, position === 'right' && styles.right)
    }, children);
};
exports.default = IconContainer;

},{"react":"ltHCL","@atlaskit/css":"kMGms","@atlaskit/primitives/compiled":"hDay7","@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"aiBCG":[function(require,module,exports,__globalThis) {
/* index.tsx generated by @compiled/babel-plugin v0.39.1 */ var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "DynamicPromptFGInput", ()=>DynamicPromptFGInput);
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _new = require("@atlaskit/button/new");
var _newDefault = parcelHelpers.interopDefault(_new);
var _compiled = require("@atlaskit/primitives/compiled");
var _textfield = require("@atlaskit/textfield");
var _textfieldDefault = parcelHelpers.interopDefault(_textfield);
var _useDynamicPromptFgOverride = require("../../../common/hooks/use-dynamic-prompt-fg-override");
const styles = {
    container: "_1e0c11p5 _yv0e14jc _gy1pu2gc _4cvr1h6o"
};
const DynamicPromptFGInput = ()=>{
    const { fgNameFromStore, saveFgNameToStore } = (0, _useDynamicPromptFgOverride.useDynamicPromptFGOverride)();
    const [fgName, setFgName] = (0, _react.useState)(fgNameFromStore !== null && fgNameFromStore !== void 0 ? fgNameFromStore : '');
    return /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _compiled.Box), {
        xcss: styles.container
    }, /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _textfieldDefault.default), {
        placeholder: "Feature gate to use as X-Evaluation-Feature-Flag header in the chat stream request",
        value: fgName,
        onChange: (e)=>setFgName(e.currentTarget.value)
    }), /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _newDefault.default), {
        onClick: ()=>saveFgNameToStore(fgName)
    }, "Save"));
};

},{"react":"ltHCL","@atlaskit/button/new":"aXnNi","@atlaskit/primitives/compiled":"hDay7","@atlaskit/textfield":"kUxJE","../../../common/hooks/use-dynamic-prompt-fg-override":"6LqZs","@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"6LqZs":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "useDynamicPromptFGOverride", ()=>useDynamicPromptFGOverride);
var _react = require("react");
var _bindEventListener = require("bind-event-listener");
const EVENT_TYPE = 'dynamic-prompt-fg-changed';
const STORAGE_KEY = 'atlassian-studio-dynamic-prompt-fg';
const subscribe = (callback)=>{
    return (0, _bindEventListener.bind)(window, {
        type: EVENT_TYPE,
        listener: callback
    });
};
// Get the current state from localStorage
const getSnapshot = ()=>{
    // eslint-disable-next-line no-restricted-globals -- dev-tools FG override storage; must bypass BSC to avoid the circular dependency where BSC's behaviour is itself controlled by these gates.
    return localStorage.getItem(STORAGE_KEY);
};
// Set the state in localStorage
const saveFgNameToStore = (value)=>{
    try {
        // eslint-disable-next-line no-restricted-globals -- dev-tools FG override storage; must bypass BSC to avoid the circular dependency where BSC's behaviour is itself controlled by these gates.
        localStorage.setItem(STORAGE_KEY, value);
        window.dispatchEvent(new Event(EVENT_TYPE));
    } catch (e) {
    // Silently fail
    }
};
const useDynamicPromptFGOverride = ()=>{
    // eslint-disable-next-line @atlaskit/platform/ensure-use-sync-external-store-server-snapshot
    const fgNameFromStore = (0, _react.useSyncExternalStore)(subscribe, getSnapshot);
    return {
        fgNameFromStore,
        saveFgNameToStore
    };
};

},{"react":"ltHCL","bind-event-listener":"bjeUU","@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"uaLzV":[function(require,module,exports,__globalThis) {
/* index.tsx generated by @compiled/babel-plugin v0.39.1 */ var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "StudioAppSwitcherToggle", ()=>StudioAppSwitcherToggle);
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _heading = require("@atlaskit/heading");
var _headingDefault = parcelHelpers.interopDefault(_heading);
var _compiled = require("@atlaskit/primitives/compiled");
var _toggle = require("@atlaskit/toggle");
var _toggleDefault = parcelHelpers.interopDefault(_toggle);
var _persistance = require("../../../common/persistance");
const styles = {
    appSwitcherToggleContainer: "_19pkutpp _otyrutpp"
};
const StudioAppSwitcherToggle = ({ updateOverrides })=>{
    const [isStudioAppV1, setIsStudioAppV1] = (0, _react.useState)((0, _persistance.studioFg)('toggle-studio-v1'));
    const onStudioAppV1Change = (0, _react.useCallback)(()=>{
        (0, _persistance.overrideGate)('toggle-studio-v1', !isStudioAppV1);
        setIsStudioAppV1(!isStudioAppV1);
        updateOverrides();
    }, [
        isStudioAppV1,
        updateOverrides
    ]);
    return /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _reactDefault.default).Fragment, null, /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _headingDefault.default), {
        size: "small",
        as: "h4"
    }, "Toggle Studio V1"), /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _compiled.Box), {
        xcss: styles.appSwitcherToggleContainer
    }, /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _toggleDefault.default), {
        label: "Enable Studio App V1",
        isChecked: isStudioAppV1,
        onChange: onStudioAppV1Change
    })));
};

},{"react":"ltHCL","@atlaskit/heading":"61ZQz","@atlaskit/primitives/compiled":"hDay7","@atlaskit/toggle":"gXZqw","../../../common/persistance":"ajVwM","@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"e4X6n":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "TABLE_COLUMN_HEADINGS", ()=>TABLE_COLUMN_HEADINGS);
parcelHelpers.export(exports, "getRows", ()=>getRows);
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _toggle = require("@atlaskit/toggle");
var _toggleDefault = parcelHelpers.interopDefault(_toggle);
var _persistance = require("../../../../common/persistance");
var _deleteButton = require("../../delete-button");
const TABLE_COLUMN_HEADINGS = {
    cells: [
        {
            key: 'entity',
            content: 'Entity',
            isSortable: true
        },
        {
            key: 'name',
            content: 'Name',
            isSortable: true,
            shouldTruncate: false
        },
        {
            key: 'value',
            content: 'Value',
            isSortable: true
        },
        {
            key: 'actions',
            content: 'Actions'
        }
    ]
};
const getRows = (overrides, updateOverrides)=>{
    const rows = [];
    Object.entries(overrides.gates).forEach(([name, value])=>{
        rows.push({
            key: `row-gate-${name}`,
            cells: [
                {
                    key: 'entity-gate',
                    content: 'Gate'
                },
                {
                    key: name,
                    content: name
                },
                {
                    key: `value-${JSON.stringify(value)}`,
                    content: /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _toggleDefault.default), {
                        isChecked: value,
                        onChange: (event)=>{
                            const newValue = event.target.checked;
                            (0, _persistance.overrideGate)(name, newValue);
                            updateOverrides();
                        }
                    })
                },
                {
                    key: `action-${name}`,
                    content: /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _deleteButton.DeleteButton), {
                        onClick: ()=>{
                            (0, _persistance.clearGateOverride)(name);
                            updateOverrides();
                        }
                    })
                }
            ]
        });
    });
    return rows;
};

},{"react":"ltHCL","@atlaskit/toggle":"gXZqw","../../../../common/persistance":"ajVwM","../../delete-button":"jNHE2","@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"jNHE2":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "DeleteButton", ()=>DeleteButton);
var _objectSpread = require("@swc/helpers/_/_object_spread");
var _objectSpreadProps = require("@swc/helpers/_/_object_spread_props");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _new = require("@atlaskit/button/new");
var _newDefault = parcelHelpers.interopDefault(_new);
var _delete = require("@atlaskit/icon/core/delete");
var _deleteDefault = parcelHelpers.interopDefault(_delete);
const DeleteButton = ({ onClick })=>/*#__PURE__*/ (0, _reactDefault.default).createElement((0, _newDefault.default), {
        appearance: "subtle",
        iconBefore: (iconProps)=>/*#__PURE__*/ (0, _reactDefault.default).createElement((0, _deleteDefault.default), (0, _objectSpreadProps._)((0, _objectSpread._)({}, iconProps), {
                label: "clear gate override"
            })),
        onClick: onClick
    }, "Delete");

},{"@swc/helpers/_/_object_spread":"9gdrV","@swc/helpers/_/_object_spread_props":"kANqQ","react":"ltHCL","@atlaskit/button/new":"aXnNi","@atlaskit/icon/core/delete":"eoflW","@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"eoflW":[function(require,module,exports,__globalThis) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::4f8e09626672d9215bf80d7cf3a8d93a>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = void 0;
var _react = _interopRequireDefault(require("b59c85534021a416"));
var _baseNew = _interopRequireDefault(require("4ea072630f24934c"));
function _interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "Delete".
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Single purpose - Reserved for removing or deleting an object.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const DeleteIcon = (props)=>/*#__PURE__*/ _react.default.createElement(_baseNew.default, Object.assign({
        name: "DeleteIcon",
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M5 .75A.75.75 0 0 1 5.75 0h4.5a.75.75 0 0 1 .75.75V2.5h3.5V4h-1v10a2 2 0 0 1-2 2h-7a2 2 0 0 1-2-2V4h-1V2.5H5zM6.5 2.5h3v-1h-3zM4 4v10a.5.5 0 0 0 .5.5h7a.5.5 0 0 0 .5-.5V4zm1.75 9V5.5h1.5V13zm3 0V5.5h1.5V13z" clip-rule="evenodd"/>`
    }, props));
DeleteIcon.displayName = 'DeleteIcon';
var _default = exports.default = DeleteIcon;

},{"b59c85534021a416":"ltHCL","4ea072630f24934c":"5XL7D"}],"2Qg7Q":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "updateUser", ()=>updateUser);
var _featureGateJsClient = require("@atlaskit/feature-gate-js-client");
var _featureGateJsClientDefault = parcelHelpers.interopDefault(_featureGateJsClient);
var _atlassianStudioObservability = require("@atlassian/atlassian-studio-observability");
var _useInitialiseFeatureGatesClient = require("../use-initialise-feature-gates-client");
async function updateUser({ atlassianAccountId, atlassianOrgId, tenantId, workspaceId }, customAttributes) {
    const identifiers = {
        atlassianAccountId
    };
    if (atlassianOrgId) identifiers.atlassianOrgId = atlassianOrgId;
    if (tenantId) identifiers.tenantId = tenantId;
    if (workspaceId) {
        identifiers.studioWorkspaceId = workspaceId;
        // @TODO: Remove this when safe to do so (eg no Studio workspaceId targeted gates are left using `miscellaneousId`)
        identifiers.miscellaneousId = workspaceId;
    }
    try {
        await (0, _featureGateJsClientDefault.default).updateUser((0, _useInitialiseFeatureGatesClient.featureGatesOptions), identifiers, customAttributes);
    } catch (error) {
        (0, _atlassianStudioObservability.logException)(error, {
            identifiers,
            tag: 'FeatureGates.updateUser'
        });
    }
}

},{"@atlaskit/feature-gate-js-client":"27dQF","@atlassian/atlassian-studio-observability":"5cVsH","../use-initialise-feature-gates-client":"lJALp","@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"5Lh8K":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "isAtlassianEmployee", ()=>isAtlassianEmployee);
const isAtlassianEmployee = (email)=>{
    if (!email) return false;
    return email.toLowerCase().endsWith('@atlassian.com');
};

},{"@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"bvTOU":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "getWorkspaceContextQueryKey", ()=>getWorkspaceContextQueryKey);
parcelHelpers.export(exports, "useWorkspaceContext", ()=>useWorkspaceContext);
var _reactQuery = require("@tanstack/react-query");
var _reactMagneticDi = require("react-magnetic-di");
var _reactRelay = require("react-relay");
var _atlassianStudioObservability = require("@atlassian/atlassian-studio-observability");
var _services = require("../../services");
const getWorkspaceContextQueryKey = (workspaceId, siteId, atlassianAccountId)=>{
    const parts = [
        'workspace-context'
    ];
    if (workspaceId) parts.push(workspaceId);
    if (siteId) parts.push(siteId);
    parts.push(atlassianAccountId);
    return parts;
};
/**
 * Fetches workspace context based on workspace and site IDs.
 *
 * @param queryClient - React Query client for fetching data
 * @param workspaceId - The workspace ID from URL (optional)
 * @param siteId - The site ID from URL (optional)
 * @param atlassianAccountId
 * @returns Promise resolving to WorkspaceContext
 */ async function fetchWorkspaceContext(queryClient, environment, workspaceId, siteId, atlassianAccountId) {
    if (workspaceId) // Scenario 1: v2 url with workspace id
    // Assume URL workspace ID is valid
    return {
        workspaces: [
            workspaceId
        ],
        isReady: true,
        error: undefined
    };
    else if (siteId) {
        // Scenario 2: v1 url with site id
        // this returns an empty string for now
        const workspaceResponse = await queryClient.fetchQuery({
            queryKey: (0, _services.getWorkspaceIdBySiteIdQueryKey)(siteId),
            queryFn: ()=>(0, _services.getWorkspaceIdBySiteId)(siteId),
            staleTime: Infinity
        });
        const workspaceId = workspaceResponse.id;
        return {
            workspaces: workspaceId ? [
                workspaceId
            ] : [],
            isReady: true
        };
    } else {
        // Scenario 3: Root URL (no workspaceId, no siteId)
        try {
            const recentWorkspace = await queryClient.fetchQuery({
                queryKey: (0, _services.getRecentWorkspaceForUserQueryKey)(atlassianAccountId),
                queryFn: ()=>(0, _services.getRecentWorkspaceForUser)(environment, queryClient),
                staleTime: Infinity
            });
            if (recentWorkspace) return {
                workspaces: [
                    recentWorkspace
                ],
                isReady: true,
                error: undefined
            };
        } catch (error) {
            (0, _atlassianStudioObservability.logException)(error, {
                loggerName: 'studio-workspace-context',
                teamName: 'studio'
            });
        }
        const allWorkspacesResponse = await queryClient.fetchQuery({
            queryKey: (0, _services.getAvailableUnitAwareWorkspacesQueryKey)(),
            queryFn: ()=>(0, _services.fetchAvailableUnitAwareWorkspaces)(),
            staleTime: Infinity
        });
        const allAvailableWorkspaces = Object.values(allWorkspacesResponse).filter(Boolean);
        return {
            workspaces: allAvailableWorkspaces,
            isReady: true,
            error: undefined
        };
    }
}
const useWorkspaceContext = (workspaceId, siteId, atlassianAccountId, isFeatureGateInitialized = false)=>{
    (0, _reactMagneticDi.di)((0, _reactQuery.useQuery), (0, _reactQuery.useQueryClient), (0, _reactRelay.useRelayEnvironment), (0, _services.getWorkspaceIdBySiteId), (0, _services.getRecentWorkspaceForUser), (0, _services.fetchAvailableUnitAwareWorkspaces), (0, _atlassianStudioObservability.logException));
    const queryClient = (0, _reactQuery.useQueryClient)();
    const environment = (0, _reactRelay.useRelayEnvironment)();
    const { data, isLoading, error, isFetching } = (0, _reactQuery.useQuery)({
        queryKey: getWorkspaceContextQueryKey(workspaceId, siteId, atlassianAccountId),
        queryFn: ()=>fetchWorkspaceContext(queryClient, environment, workspaceId, siteId, atlassianAccountId),
        enabled: isFeatureGateInitialized,
        staleTime: Infinity
    });
    // error state (will fallback to v1 for now)
    if (error) return {
        workspaces: [],
        isReady: true,
        error: error instanceof Error ? error : new Error(String(error))
    };
    // loading state
    if (!isFeatureGateInitialized || isLoading || isFetching || !data) return {
        workspaces: [],
        isReady: false,
        error: undefined
    };
    return data;
};

},{"@tanstack/react-query":"buDng","react-magnetic-di":"hCzc8","react-relay":"9HAyN","@atlassian/atlassian-studio-observability":"5cVsH","../../services":"fzyVM","@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"fzyVM":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "fetchOrgContextData", ()=>fetchOrgContextData);
parcelHelpers.export(exports, "orgContextQueryOptions", ()=>orgContextQueryOptions);
parcelHelpers.export(exports, "fetchAvailableOrgs", ()=>fetchAvailableOrgs);
parcelHelpers.export(exports, "fetchAvailableWorkspaces", ()=>fetchAvailableWorkspaces);
parcelHelpers.export(exports, "fetchAvailableUnitAwareWorkspaces", ()=>fetchAvailableUnitAwareWorkspaces);
parcelHelpers.export(exports, "getOrgContextQueryKey", ()=>getOrgContextQueryKey);
parcelHelpers.export(exports, "getAvailableOrgsQueryKey", ()=>getAvailableOrgsQueryKey);
parcelHelpers.export(exports, "getAvailableWorkspacesQueryKey", ()=>getAvailableWorkspacesQueryKey);
parcelHelpers.export(exports, "getAvailableUnitAwareWorkspacesQueryKey", ()=>getAvailableUnitAwareWorkspacesQueryKey);
parcelHelpers.export(exports, "getWorkspaceIdBySiteIdQueryKey", ()=>getWorkspaceIdBySiteIdQueryKey);
parcelHelpers.export(exports, "getRecentWorkspaceForUserQueryKey", ()=>getRecentWorkspaceForUserQueryKey);
parcelHelpers.export(exports, "fetchSpaceBySpaceId", ()=>fetchSpaceBySpaceId);
parcelHelpers.export(exports, "getSpaceQueryKey", ()=>getSpaceQueryKey);
parcelHelpers.export(exports, "getSpaceQueryOptions", ()=>getSpaceQueryOptions);
parcelHelpers.export(exports, "fetchSpacesApi", ()=>fetchSpacesApi);
parcelHelpers.export(exports, "getSpacesInfiniteQueryKey", ()=>getSpacesInfiniteQueryKey);
parcelHelpers.export(exports, "getSpacesInfiniteQueryOptions", ()=>getSpacesInfiniteQueryOptions);
parcelHelpers.export(exports, "createSpace", ()=>createSpace);
parcelHelpers.export(exports, "getSpacesQueryKey", ()=>getSpacesQueryKey);
parcelHelpers.export(exports, "getWorkspaceIdBySiteId", ()=>getWorkspaceIdBySiteId);
parcelHelpers.export(exports, "getRecentWorkspaceForUser", ()=>getRecentWorkspaceForUser);
parcelHelpers.export(exports, "permissionResponse", ()=>permissionResponse);
parcelHelpers.export(exports, "searchGroups", ()=>searchGroups);
parcelHelpers.export(exports, "searchWorkspaceUsers", ()=>searchWorkspaceUsers);
parcelHelpers.export(exports, "getGroupsQueryKey", ()=>getGroupsQueryKey);
parcelHelpers.export(exports, "getGroupsQueryOptions", ()=>getGroupsQueryOptions);
parcelHelpers.export(exports, "submitAssignment", ()=>submitAssignment);
parcelHelpers.export(exports, "deleteAssignment", ()=>deleteAssignment);
parcelHelpers.export(exports, "assignRoleToPrincipal", ()=>assignRoleToPrincipal);
parcelHelpers.export(exports, "deleteRoleFromPrincipal", ()=>deleteRoleFromPrincipal);
var _servicesRecentActivityForWorkspaceSelectionQueryGraphql = require("./__generated__/services_RecentActivityForWorkspaceSelectionQuery.graphql");
var _servicesRecentActivityForWorkspaceSelectionQueryGraphqlDefault = parcelHelpers.interopDefault(_servicesRecentActivityForWorkspaceSelectionQueryGraphql);
var _reactQuery = require("@tanstack/react-query");
var _reactResourceRouterNext = require("react-resource-router-next");
var _relayRuntime = require("relay-runtime");
var _platformFeatureFlags = require("@atlaskit/platform-feature-flags");
var _atlassianStudioObservability = require("@atlassian/atlassian-studio-observability");
const fetchOrgContextData = async (workspaceId)=>{
    const response = await fetch(`/gateway/studio/workspace/${workspaceId}/api/studio/workspace/context`);
    if (!response.ok) throw new Error('Failed to fetch studio workspace context data');
    return response.json();
};
const orgContextQueryOptions = (workspaceId)=>(0, _reactQuery.queryOptions)({
        queryKey: getOrgContextQueryKey(workspaceId),
        queryFn: ()=>fetchOrgContextData(workspaceId),
        enabled: !!workspaceId,
        staleTime: Infinity
    });
const fetchAvailableOrgs = async ()=>{
    const response = await fetch('/gateway/api/app-switcher/api/available-products?source=studio');
    if (!response.ok) throw new Error('Failed to fetch available organisations');
    return response.json();
};
const fetchAvailableWorkspaces = async (uniqueOrgs)=>{
    const response = await fetch('/gateway/studio/api/studio/organization/workspace', {
        method: 'POST',
        headers: {
            'Content-Type': 'application/json'
        },
        body: uniqueOrgs.length > 0 ? JSON.stringify(uniqueOrgs.map((org)=>org.id)) : undefined
    });
    if (!response.ok) throw new Error('Failed to fetch available workspaces');
    return response.json();
};
const fetchAvailableUnitAwareWorkspaces = async ()=>{
    const response = await fetch('/gateway/studio/api/studio/collaborationcontext/workspace', {
        // @NOTE: This is a POST, because the API still supports the ability to supply a
        // list of CC's/Units in the request body. For now, we do not need this functionality though.
        method: 'POST',
        headers: {
            'Content-Type': 'application/json'
        }
    });
    if (!response.ok) throw new Error('Failed to fetch available workspaces');
    return response.json();
};
const getOrgContextQueryKey = (workspaceId)=>[
        'org-context',
        workspaceId
    ];
const getAvailableOrgsQueryKey = ()=>[
        'app-switcher-api-available-products'
    ];
const getAvailableWorkspacesQueryKey = (uniqueOrgs)=>{
    const queryKey = [
        'studio-BE-available-workspaces',
        ...uniqueOrgs.map((org)=>org.id)
    ];
    return queryKey;
};
const getAvailableUnitAwareWorkspacesQueryKey = ()=>{
    return [
        'studio-BE-available-unit-aware-workspaces'
    ];
};
const getWorkspaceIdBySiteIdQueryKey = (siteId)=>[
        'workspace-id-by-site-id',
        siteId
    ];
const getRecentWorkspaceForUserQueryKey = (atlassianAccountId)=>[
        'recent-workspace-for-user',
        atlassianAccountId
    ];
const fetchSpaceBySpaceId = async (workspaceId, spaceId)=>{
    const response = await fetch(`/gateway/studio/workspace/${workspaceId}/api/studio/spaces/${spaceId}`);
    if (!response.ok) throw new Error('Failed to fetch space by space id');
    return response.json();
};
const getSpaceQueryKey = (workspaceId, spaceId)=>[
        'space',
        workspaceId,
        spaceId
    ];
const getSpaceQueryOptions = (workspaceId, spaceId)=>(0, _reactQuery.queryOptions)({
        queryKey: getSpaceQueryKey(workspaceId, spaceId),
        queryFn: ()=>fetchSpaceBySpaceId(workspaceId, spaceId),
        enabled: Boolean(workspaceId) && Boolean(spaceId),
        staleTime: Infinity
    });
const fetchSpacesApi = async (workspaceId, opts, errorMessage)=>{
    const params = new URLSearchParams();
    if (opts === null || opts === void 0 ? void 0 : opts.query) params.set('query', opts.query);
    if (opts === null || opts === void 0 ? void 0 : opts.after) params.set('after', opts.after);
    const response = await fetch(`/gateway/studio/workspace/${workspaceId}/api/studio/spaces?${params.toString()}`);
    if (!response.ok) throw new Error(errorMessage);
    return response.json();
};
const getSpacesInfiniteQueryKey = (workspaceId, search)=>[
        'spaces-infinite',
        workspaceId,
        search || ''
    ];
const getSpacesInfiniteQueryOptions = (workspaceId, search)=>(0, _reactQuery.infiniteQueryOptions)({
        queryKey: getSpacesInfiniteQueryKey(workspaceId, search),
        queryFn: ({ pageParam })=>{
            var _pageParam_cursor;
            return fetchSpacesApi(workspaceId, {
                query: search,
                after: (_pageParam_cursor = pageParam === null || pageParam === void 0 ? void 0 : pageParam.cursor) !== null && _pageParam_cursor !== void 0 ? _pageParam_cursor : null
            }, 'Failed to fetch spaces');
        },
        initialPageParam: null,
        getNextPageParam: (lastPage)=>{
            if (!lastPage.hasNext || !lastPage.nextCursor) return null;
            return {
                cursor: lastPage.nextCursor,
                search
            };
        },
        staleTime: Infinity
    });
const createSpace = async (workspaceId, data)=>{
    const response = await fetch(`/gateway/studio/workspace/${workspaceId}/api/studio/spaces`, {
        method: 'POST',
        headers: {
            'Content-Type': 'application/json'
        },
        body: JSON.stringify(data)
    });
    if (!response.ok) throw new Error(`Failed to create space: ${response.status} ${response.statusText}`);
    return response.json();
};
const getSpacesQueryKey = (workspaceId)=>[
        'spaces',
        workspaceId
    ];
const getWorkspaceIdBySiteId = async (siteId)=>{
    const response = await fetch(`/gateway/studio/api/studio/site/${siteId}/workspace`);
    if (!response.ok && response.status !== 404) {
        const error = new Error('Failed to fetch workspace ID by site ID');
        (0, _atlassianStudioObservability.logException)(error, {
            loggerName: 'studio-workspace-context',
            teamName: 'studio'
        });
        throw error;
    }
    // 404 is returned when there are no v2 workspaces for the site
    if (response.status === 404) {
        (0, _atlassianStudioObservability.logException)(new Error('Could not find workspace ID for site ID'), {
            loggerName: 'studio-workspace-context',
            teamName: 'studio'
        });
        return {
            id: undefined
        };
    }
    return response.json();
};
const getRecentWorkspaceForUser = async (environment, queryClient)=>{
    var _data_activity_myActivity_all_edges__node_object, _data_activity_myActivity_all_edges__node, _data_activity_myActivity_all_edges_, _data_activity_myActivity_all_edges, _data_activity_myActivity_all, _data_activity_myActivity, _data_activity;
    const data = await (0, _relayRuntime.fetchQuery)(environment, (0, _servicesRecentActivityForWorkspaceSelectionQueryGraphqlDefault.default), {}).toPromise();
    // @NOTE: ariId formatting is something like: ari:cloud:studio::workspace/7d965d21-0e28-43d6-90f1-60b0df1431a0
    const ariId = data === null || data === void 0 ? void 0 : (_data_activity = data.activity) === null || _data_activity === void 0 ? void 0 : (_data_activity_myActivity = _data_activity.myActivity) === null || _data_activity_myActivity === void 0 ? void 0 : (_data_activity_myActivity_all = _data_activity_myActivity.all) === null || _data_activity_myActivity_all === void 0 ? void 0 : (_data_activity_myActivity_all_edges = _data_activity_myActivity_all.edges) === null || _data_activity_myActivity_all_edges === void 0 ? void 0 : (_data_activity_myActivity_all_edges_ = _data_activity_myActivity_all_edges[0]) === null || _data_activity_myActivity_all_edges_ === void 0 ? void 0 : (_data_activity_myActivity_all_edges__node = _data_activity_myActivity_all_edges_.node) === null || _data_activity_myActivity_all_edges__node === void 0 ? void 0 : (_data_activity_myActivity_all_edges__node_object = _data_activity_myActivity_all_edges__node.object) === null || _data_activity_myActivity_all_edges__node_object === void 0 ? void 0 : _data_activity_myActivity_all_edges__node_object.id;
    if (!ariId) return undefined;
    // If there is no slash in the ariId, we probably wont recognise it's format,
    // so we should not use it, and simply return undefined
    const parsedWorkspaceId = (ariId === null || ariId === void 0 ? void 0 : ariId.includes('/')) ? ariId.split('/').pop() : ariId;
    if (!parsedWorkspaceId) return undefined;
    const allWorkspacesResponse = await queryClient.fetchQuery({
        queryKey: getAvailableUnitAwareWorkspacesQueryKey(),
        queryFn: ()=>fetchAvailableUnitAwareWorkspaces(),
        staleTime: Infinity
    });
    const allAvailableWorkspaces = Object.values(allWorkspacesResponse).filter(Boolean);
    const isRecentWorkspaceAvailable = Object.values(allAvailableWorkspaces).includes(parsedWorkspaceId);
    return isRecentWorkspaceAvailable ? parsedWorkspaceId : undefined;
};
const permissionResponse = (0, _reactResourceRouterNext.createResource)({
    type: 'PERMISSION',
    getKey: (routerContext)=>{
        const workspaceId = routerContext.match.params.workspaceId;
        const { searchQuery, roleIds } = routerContext.query;
        return `permissions-${workspaceId}-${searchQuery || ''}-${roleIds || ''}`;
    },
    getData: async (routerContext)=>{
        var // Filter out AGENT_CREATOR roles for now as they are not supported yet
        _responseBody_roles;
        const workspaceId = routerContext.match.params.workspaceId;
        if (!workspaceId) return {
            assignments: [],
            roles: []
        };
        const url = new URL(`/gateway/studio/workspace/${workspaceId}/api/studio/workspace/permissions/roles`, window.location.origin);
        if ((0, _platformFeatureFlags.fg)('studio-settings-support-search')) {
            const { searchQuery, roleIds } = routerContext.query;
            if (searchQuery) url.searchParams.set('query', searchQuery);
            if (roleIds) url.searchParams.set('roleIds', roleIds);
        }
        const permissionsResponse = await fetch(url.toString());
        if (!permissionsResponse.ok) throw new Error('Failed to fetch permissions');
        const responseBody = await permissionsResponse.json();
        var _responseBody_assignments;
        const assignments = (_responseBody_assignments = responseBody === null || responseBody === void 0 ? void 0 : responseBody.assignments) !== null && _responseBody_assignments !== void 0 ? _responseBody_assignments : [];
        var _responseBody_roles_filter;
        return {
            assignments,
            roles: (_responseBody_roles_filter = responseBody === null || responseBody === void 0 ? void 0 : (_responseBody_roles = responseBody.roles) === null || _responseBody_roles === void 0 ? void 0 : _responseBody_roles.filter((role)=>role.roleType !== 'AGENT_CREATOR')) !== null && _responseBody_roles_filter !== void 0 ? _responseBody_roles_filter : []
        };
    },
    isBrowserOnly: true
});
const searchGroups = async (workspaceId, request)=>{
    let response;
    if ((0, _platformFeatureFlags.fg)('asf-1393-users-list-studio')) {
        // New GET endpoint (no CSRF) used by the AddPrincipalModal search flow
        const params = new URLSearchParams();
        if (request.nameContains) params.set('name', request.nameContains);
        response = await fetch(`/gateway/studio/workspace/${workspaceId}/api/studio/group/search?${params.toString()}`);
    } else // Legacy POST behaviour - preserved for backwards-compat when FG is off.
    // Remove this `else` branch as part of `asf-1393-users-list-studio`.
    response = await fetch(`/gateway/studio/workspace/${workspaceId}/api/studio/group/search`, {
        method: 'POST',
        headers: {
            'Content-Type': 'application/json'
        },
        body: JSON.stringify(request)
    });
    if (!response.ok) throw new Error('Failed to search groups');
    return response.json();
};
const searchWorkspaceUsers = async (workspaceId, name)=>{
    // FG-off branch preserves the pre-existing query shape so any caller that runs
    // while the flag is off (none today, but defensively safe) gets the legacy behaviour.
    // Remove the FG-off branch as part of `asf-1393-users-list-studio`.
    const params = new URLSearchParams((0, _platformFeatureFlags.fg)('asf-1393-users-list-studio') ? {
        requireStudioAccess: 'false',
        accountTypes: 'atlassian'
    } : {
        requireStudioAccess: 'true'
    });
    if (name) params.set('name', name);
    const response = await fetch(`/gateway/studio/workspace/${workspaceId}/api/studio/user/search?${params.toString()}`);
    if (!response.ok) return [];
    return response.json();
};
const getGroupsQueryKey = (workspaceId, nameContains)=>[
        'groups-search',
        workspaceId,
        nameContains || ''
    ];
const getGroupsQueryOptions = (workspaceId, nameContains = '')=>(0, _reactQuery.queryOptions)({
        queryKey: getGroupsQueryKey(workspaceId, nameContains),
        queryFn: ()=>searchGroups(workspaceId, {
                nameContains
            }),
        enabled: Boolean(workspaceId),
        staleTime: Infinity
    });
const submitAssignment = async (workspaceId, data)=>{
    const response = await fetch(`/gateway/studio/workspace/${workspaceId}/api/studio/workspace/permissions/roles`, {
        method: 'POST',
        headers: {
            'Content-Type': 'application/json'
        },
        body: JSON.stringify(data)
    });
    if (!response.ok) throw new Error('Failed to submit assignment');
};
const deleteAssignment = async (workspaceId, data)=>{
    const response = await fetch(`/gateway/studio/workspace/${workspaceId}/api/studio/workspace/permissions/roles`, {
        method: 'DELETE',
        headers: {
            'Content-Type': 'application/json'
        },
        body: JSON.stringify(data)
    });
    if (!response.ok) throw new Error('Failed to delete assignment');
};
const assignRoleToPrincipal = async (workspaceId, data)=>{
    const response = await fetch(`/gateway/studio/workspace/${workspaceId}/api/studio/workspace/permissions/role`, {
        method: 'POST',
        headers: {
            'Content-Type': 'application/json'
        },
        body: JSON.stringify(data)
    });
    if (!response.ok) throw new Error('Failed to assign role to principal');
};
const deleteRoleFromPrincipal = async (workspaceId, data)=>{
    const response = await fetch(`/gateway/studio/workspace/${workspaceId}/api/studio/workspace/permissions/role`, {
        method: 'DELETE',
        headers: {
            'Content-Type': 'application/json'
        },
        body: JSON.stringify(data)
    });
    if (!response.ok) throw new Error('Failed to delete role from principal');
};

},{"./__generated__/services_RecentActivityForWorkspaceSelectionQuery.graphql":"4XpgH","@tanstack/react-query":"buDng","react-resource-router-next":"6gkfP","relay-runtime":"2IxFR","@atlaskit/platform-feature-flags":"8rD2i","@atlassian/atlassian-studio-observability":"5cVsH","@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"4XpgH":[function(require,module,exports,__globalThis) {
/**
 * @generated SignedSource<<fb113dcdfdb69fc2d4ae718ce6b4b875>>
 * @relayHash 7e3d02fab38b521e409ded4959d21ed7
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 9d32ef547f6134b32fb58783a144faec06915ec944ac999e7c6346b80ca7e138
var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
const node = function() {
    var v0 = [
        {
            "kind": "Literal",
            "name": "filter",
            "value": {
                "arguments": {
                    "eventTypes": [
                        "viewed"
                    ],
                    "objectTypes": [
                        "workspace"
                    ],
                    "products": [
                        "studio"
                    ]
                }
            }
        },
        {
            "kind": "Literal",
            "name": "first",
            "value": 1
        }
    ], v1 = {
        "kind": "ScalarField",
        "name": "id"
    }, v2 = {
        "concreteType": "ActivityObject",
        "kind": "LinkedField",
        "name": "object",
        "plural": false,
        "selections": [
            v1 /*: any*/ ,
            {
                "kind": "ScalarField",
                "name": "type"
            },
            {
                "kind": "ScalarField",
                "name": "product"
            },
            {
                "kind": "ScalarField",
                "name": "rootContainerId"
            }
        ]
    }, v3 = {
        "kind": "ScalarField",
        "name": "eventType"
    }, v4 = {
        "kind": "ScalarField",
        "name": "timestamp"
    };
    return {
        "fragment": {
            "argumentDefinitions": [],
            "kind": "Fragment",
            "name": "services_RecentActivityForWorkspaceSelectionQuery",
            "selections": [
                {
                    "concreteType": "Activity",
                    "kind": "LinkedField",
                    "name": "activity",
                    "plural": false,
                    "selections": [
                        {
                            "concreteType": "MyActivity",
                            "kind": "LinkedField",
                            "name": "myActivity",
                            "plural": false,
                            "selections": [
                                {
                                    "args": v0 /*: any*/ ,
                                    "concreteType": "ActivityConnection",
                                    "kind": "LinkedField",
                                    "name": "all",
                                    "plural": false,
                                    "selections": [
                                        {
                                            "concreteType": "ActivityItemEdge",
                                            "kind": "LinkedField",
                                            "name": "edges",
                                            "plural": true,
                                            "selections": [
                                                {
                                                    "concreteType": "ActivityNode",
                                                    "kind": "LinkedField",
                                                    "name": "node",
                                                    "plural": false,
                                                    "selections": [
                                                        v2 /*: any*/ ,
                                                        {
                                                            "concreteType": "ActivityEvent",
                                                            "kind": "LinkedField",
                                                            "name": "event",
                                                            "plural": false,
                                                            "selections": [
                                                                v3 /*: any*/ ,
                                                                v4 /*: any*/ 
                                                            ]
                                                        }
                                                    ]
                                                }
                                            ]
                                        }
                                    ],
                                    "storageKey": "all(filter:{\"arguments\":{\"eventTypes\":[\"viewed\"],\"objectTypes\":[\"workspace\"],\"products\":[\"studio\"]}},first:1)"
                                }
                            ]
                        }
                    ]
                }
            ],
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": [],
            "kind": "Operation",
            "name": "services_RecentActivityForWorkspaceSelectionQuery",
            "selections": [
                {
                    "concreteType": "Activity",
                    "kind": "LinkedField",
                    "name": "activity",
                    "plural": false,
                    "selections": [
                        {
                            "concreteType": "MyActivity",
                            "kind": "LinkedField",
                            "name": "myActivity",
                            "plural": false,
                            "selections": [
                                {
                                    "args": v0 /*: any*/ ,
                                    "concreteType": "ActivityConnection",
                                    "kind": "LinkedField",
                                    "name": "all",
                                    "plural": false,
                                    "selections": [
                                        {
                                            "concreteType": "ActivityItemEdge",
                                            "kind": "LinkedField",
                                            "name": "edges",
                                            "plural": true,
                                            "selections": [
                                                {
                                                    "concreteType": "ActivityNode",
                                                    "kind": "LinkedField",
                                                    "name": "node",
                                                    "plural": false,
                                                    "selections": [
                                                        v2 /*: any*/ ,
                                                        {
                                                            "concreteType": "ActivityEvent",
                                                            "kind": "LinkedField",
                                                            "name": "event",
                                                            "plural": false,
                                                            "selections": [
                                                                v3 /*: any*/ ,
                                                                v4 /*: any*/ ,
                                                                v1 /*: any*/ 
                                                            ]
                                                        },
                                                        v1 /*: any*/ 
                                                    ]
                                                }
                                            ]
                                        }
                                    ],
                                    "storageKey": "all(filter:{\"arguments\":{\"eventTypes\":[\"viewed\"],\"objectTypes\":[\"workspace\"],\"products\":[\"studio\"]}},first:1)"
                                }
                            ]
                        }
                    ]
                }
            ]
        },
        "params": {
            "id": "9d32ef547f6134b32fb58783a144faec06915ec944ac999e7c6346b80ca7e138",
            "metadata": {},
            "name": "services_RecentActivityForWorkspaceSelectionQuery",
            "operationKind": "query",
            "text": null
        }
    };
}();
node.hash = "21cfcbc672a7549ea88841f36e12688e";
exports.default = node;

},{"@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"lVq1L":[function(require,module,exports,__globalThis) {
module.exports = Promise.resolve(module.bundle.root("a6iyv"));

},{}],"6paP6":[function(require,module,exports,__globalThis) {
module.exports = Promise.all([
    require("39fc6edf8a59d9ed")(require("a2c201f8e252028f").resolve("7oLOu")),
    require("39fc6edf8a59d9ed")(require("a2c201f8e252028f").resolve("l6puZ")),
    require("39fc6edf8a59d9ed")(require("a2c201f8e252028f").resolve("jj74M")),
    require("39fc6edf8a59d9ed")(require("a2c201f8e252028f").resolve("b5yzo")),
    require("39fc6edf8a59d9ed")(require("a2c201f8e252028f").resolve("9cMBe")),
    require("39fc6edf8a59d9ed")(require("a2c201f8e252028f").resolve("lWkU3")),
    require("39fc6edf8a59d9ed")(require("a2c201f8e252028f").resolve("kbRh9")),
    require("39fc6edf8a59d9ed")(require("a2c201f8e252028f").resolve("lWc2w")),
    require("39fc6edf8a59d9ed")(require("a2c201f8e252028f").resolve("6l22C")),
    require("39fc6edf8a59d9ed")(require("a2c201f8e252028f").resolve("ga8sS")),
    require("39fc6edf8a59d9ed")(require("a2c201f8e252028f").resolve("1LowY")),
    require("39fc6edf8a59d9ed")(require("a2c201f8e252028f").resolve("6YAjW")),
    require("39fc6edf8a59d9ed")(require("a2c201f8e252028f").resolve("eHhkU"))
]).then(()=>module.bundle.root('7AwLn'));

},{"39fc6edf8a59d9ed":"hkfCW","a2c201f8e252028f":"l4T2r"}],"2Pirl":[function(require,module,exports,__globalThis) {
module.exports = Promise.all([
    require("90befab89d8bb4bf")(require("61c2540378667df0").resolve("2tnWd")),
    require("90befab89d8bb4bf")(require("61c2540378667df0").resolve("lSfDc")),
    require("90befab89d8bb4bf")(require("61c2540378667df0").resolve("kv0LZ")),
    require("90befab89d8bb4bf")(require("61c2540378667df0").resolve("6A8QF")),
    require("90befab89d8bb4bf")(require("61c2540378667df0").resolve("6AUJV")),
    require("90befab89d8bb4bf")(require("61c2540378667df0").resolve("cmrFU")),
    require("90befab89d8bb4bf")(require("61c2540378667df0").resolve("9cFxl")),
    require("90befab89d8bb4bf")(require("61c2540378667df0").resolve("79rNP")),
    require("90befab89d8bb4bf")(require("61c2540378667df0").resolve("iSzBJ")),
    require("90befab89d8bb4bf")(require("61c2540378667df0").resolve("2eUjX")),
    require("90befab89d8bb4bf")(require("61c2540378667df0").resolve("2BdrX")),
    require("90befab89d8bb4bf")(require("61c2540378667df0").resolve("80qhx")),
    require("90befab89d8bb4bf")(require("61c2540378667df0").resolve("jm9Ts")),
    require("90befab89d8bb4bf")(require("61c2540378667df0").resolve("4RGl5")),
    require("90befab89d8bb4bf")(require("61c2540378667df0").resolve("1W1cw")),
    require("90befab89d8bb4bf")(require("61c2540378667df0").resolve("jkOmj")),
    require("90befab89d8bb4bf")(require("61c2540378667df0").resolve("k1hio")),
    require("90befab89d8bb4bf")(require("61c2540378667df0").resolve("3Fi4E")),
    require("90befab89d8bb4bf")(require("61c2540378667df0").resolve("c1DPx")),
    require("90befab89d8bb4bf")(require("61c2540378667df0").resolve("kAqrh")),
    require("90befab89d8bb4bf")(require("61c2540378667df0").resolve("h1fAd")),
    require("90befab89d8bb4bf")(require("61c2540378667df0").resolve("1LowY")),
    require("90befab89d8bb4bf")(require("61c2540378667df0").resolve("6YAjW")),
    require("90befab89d8bb4bf")(require("61c2540378667df0").resolve("bhgoc"))
]).then(()=>module.bundle.root('g4apA'));

},{"90befab89d8bb4bf":"hkfCW","61c2540378667df0":"l4T2r"}],"37MGn":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "buildStudioAccountSyncLoginUrl", ()=>buildStudioAccountSyncLoginUrl);
parcelHelpers.export(exports, "redirectToLogin", ()=>redirectToLogin);
var _atlassianStudioCommon = require("@atlassian/atlassian-studio-common");
const buildStudioAccountSyncLoginUrl = (currentPageHref, loginHintEmail)=>{
    // Delete login_hint from the continue URL to avoid infinite loop.
    const continueUrl = new URL(currentPageHref);
    continueUrl.searchParams.delete('login_hint');
    const identityBaseUrl = (0, _atlassianStudioCommon.getConfig)().atlassianAccountUrl;
    // Set up the login URL parameters for syncing the account.
    const params = new URLSearchParams();
    params.set('application', 'studio');
    params.set('continue', continueUrl.toString());
    params.set('prompt', 'none');
    params.set('login_hint', loginHintEmail.trim());
    return `${identityBaseUrl}/login?${params.toString()}`;
};
const redirectToLogin = ()=>{
    const href = window.location.href;
    const loginUrl = `${(0, _atlassianStudioCommon.getConfig)().atlassianAccountUrl}/login?continue=${encodeURIComponent(href)}`;
    window.location.href = loginUrl;
};

},{"@atlassian/atlassian-studio-common":"7YPMV","@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"2rLHj":[function() {},{}],"259XF":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "AppWrapper", ()=>AppWrapper);
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _relayEnvironmentProvider = require("@atlassian/relay-environment-provider");
function AppWrapper({ children }) {
    return /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _relayEnvironmentProvider.RelayEnvironmentProvider), null, children);
}

},{"react":"ltHCL","@atlassian/relay-environment-provider":"5UJMi","@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"la54k":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
/**
 * Component for setting up ADS theme styles in the client.
 *
 * If the app is rendered inside the SSR shell, some of these styles are already included.
 * For static apps, these styles need to be added on the client side.
 */ parcelHelpers.export(exports, "ADSGlobalStyles", ()=>ADSGlobalStyles);
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _cssReset = require("@atlaskit/css-reset");
var _cssResetDefault = parcelHelpers.interopDefault(_cssReset);
var _setGlobalTheme = require("@atlaskit/tokens/set-global-theme");
var _theme = require("./configs/theme");
function ADSGlobalStyles({ children, isStatic }) {
    (0, _react.useEffect)(()=>{
        (0, _setGlobalTheme.setGlobalTheme)((0, _theme.defaultTheme));
    }, []);
    (0, _react.useEffect)(()=>{
        if (isStatic) {
            // Inject static fallback app reset styles into the <head />.
            const styleElement = document.createElement('style');
            styleElement.id = 'ads-reset-styles';
            styleElement.textContent = (0, _cssResetDefault.default);
            document.head.appendChild(styleElement);
            return ()=>{
                document.head.removeChild(styleElement);
            };
        }
    }, [
        isStatic
    ]);
    return /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _reactDefault.default).Fragment, null, children);
}

},{"react":"ltHCL","@atlaskit/css-reset":"fTTMQ","@atlaskit/tokens/set-global-theme":"5oVM0","./configs/theme":"ghEiL","@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"fTTMQ":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _base = require("./base");
var _baseDefault = parcelHelpers.interopDefault(_base);
var _browserFixes = require("./browser-fixes");
var _browserFixesDefault = parcelHelpers.interopDefault(_browserFixes);
var _reset = require("./reset");
var _resetDefault = parcelHelpers.interopDefault(_reset);
var _tables = require("./tables");
var _tablesDefault = parcelHelpers.interopDefault(_tables);
var _utils = require("./utils");
var _utilsDefault = parcelHelpers.interopDefault(_utils);
const styleSheet = `
${(0, _resetDefault.default)}
${(0, _baseDefault.default)}
${(0, _tablesDefault.default)}
${(0, _browserFixesDefault.default)}
${(0, _utilsDefault.default)}
`;
exports.default = styleSheet;

},{"./base":"g8Rza","./browser-fixes":"hJiu2","./reset":"7FX3c","./tables":"3Kfzf","./utils":"h78ue","@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"g8Rza":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _evaluateInner = require("./utils/evaluate-inner");
var _evaluateInnerDefault = parcelHelpers.interopDefault(_evaluateInner);
let _ = (t)=>t, t;
const fontFamily = `-apple-system, BlinkMacSystemFont, 'Segoe UI', 'Roboto', 'Oxygen', 'Ubuntu', 'Fira Sans', 'Droid Sans', 'Helvetica Neue', sans-serif`;
const codeFontFamily = `ui-monospace, Menlo, "Segoe UI Mono", "Ubuntu Mono", monospace`;
/* TODO body line height should be 1.25rem */ const _default_1 = (0, _evaluateInnerDefault.default)(t || (t = _`
  body,
  html {
    height: 100%;
    width: 100%;
  }

  body,
	[data-subtree-theme] {
		background-color: ${0};
		color: ${0};
		font: ${0};
	}

	body {
		-ms-overflow-style: -ms-autohiding-scrollbar;
		text-decoration-skip-ink: auto;
	}

  /* Default margins */
  p,
  ul,
  ol,
  dl,
  h1,
  h2,
  h3,
  h4,
  h5,
  h6,
  blockquote,
  pre,
  form,
  table {
    margin: ${0} 0 0 0;
  }

  /* Links */
  a {
    color: ${0};
    text-decoration: none;
  }
  a:hover {
    color: ${0};
    text-decoration: underline;
  }
  a:active {
    color: ${0};
  }
  a:focus-visible {
    outline: ${0} solid ${0};
    outline-offset: ${0};
  }
  @supports not selector(*:focus-visible) {
    a:focus {
      outline: ${0} solid ${0};
      outline-offset: ${0};
    }
  }
  /* Headings */
  h1 {
    font: ${0};
    color: ${0};
    margin-top: ${0};
  }
  h2 {
    font: ${0};
    color: ${0};
    margin-top: ${0};
  }
  h3 {
    font: ${0};
    color: ${0};
    margin-top: 28px;
  }
  h4 {
    font: ${0};
    color: ${0};
    margin-top: ${0};
  }
  h5 {
    font: ${0};
    color: ${0};
    margin-top: ${0};
  }
  h6 {
    font: ${0};
    color: ${0};
    margin-top: ${0};
    text-transform: uppercase;
  }

  /* Lists */
  ul,
  ol,
  dl {
    padding-left: ${0};
  }

  dd,
  dd + dt,
  li + li {
    margin-top: ${0};
  }

  ul ul:not(:first-child),
	ul style:first-child ~ * + ul,
  ol ul:not(:first-child),
	ol style:first-child ~ * + ul,
  ul ol:not(:first-child),
	ul style:first-child ~ * + ol,
  ol ol:not(:first-child),
	ol style:first-child ~ * + ol {
    margin-top: ${0};
  }

  /* remove top margin for first element */
  p:first-child,
  style:first-child + p,
  ul:first-child,
  style:first-child + ul,
  ol:first-child,
  style:first-child + ol,
  dl:first-child,
  style:first-child + dl,
  h1:first-child,
  style:first-child + h1,
  h2:first-child,
  style:first-child + h2,
  h3:first-child,
  style:first-child + h3,
  h4:first-child,
  style:first-child + h4,
  h5:first-child,
  style:first-child + h5,
  h6:first-child,
  style:first-child + h6,
  blockquote:first-child,
  style:first-child + blockquote,
  pre:first-child,
  style:first-child + pre,
  form:first-child,
  style:first-child + form,
  table:first-child,
  style:first-child + table {
    margin-top: 0;
  }

  /* Quotes */
  blockquote,
  q {
    color: inherit;
  }
  blockquote {
    border: none;
    padding-left: ${0};
  }
  [dir='rtl'] blockquote {
    padding-left: 0;
    padding-right: ${0};
  }

  blockquote::before,
  q::before {
    content: '\\201C';
  }

  blockquote::after,
  q::after {
    content: '\\201D';
  }

  blockquote::before {
    float: left;
    /* to keep the quotes left of any child elements like blockquote > p */
    margin-left: -1em;
    text-align: right;
    width: 1em;
  }
  [dir='rtl'] blockquote::before {
    float: right;
    margin-right: -1em;
    text-align: left;
  }

  blockquote > :last-child {
    display: inline-block; /* so the quotes added via pseudos follow it immediately. */
  }

  /* Other typographical elements */
  small {
    font: ${0};
  }

  code,
  kbd {
    font-family: ${0};
  }

  var,
  address,
  dfn,
  cite {
    font-style: italic;
  }

  abbr {
    border-bottom: ${0} ${0} dotted;
    cursor: help;
  }

  @supports (color-scheme: dark) and (color-scheme: light) {
    [data-color-mode="light"] {
      color-scheme: light;
    }
    [data-color-mode="dark"] {
      color-scheme: dark;
    }
  }
`), "var(--ds-surface, #fff)", "var(--ds-text, #172B4D)", `var(--ds-font-body, ${`normal 400 14px/1.42857142857143 ${fontFamily}`})`, "var(--ds-space-150, 12px)", "var(--ds-link, #0052CC)", "var(--ds-link, #0065FF)", "var(--ds-link-pressed, #0747A6)", "var(--ds-border-width-focused, 2px)", "var(--ds-border-focused, #2684FF)", "var(--ds-space-025, 2px)", "var(--ds-border-width-focused, 2px)", "var(--ds-border-focused, #4C9AFF)", "var(--ds-space-025, 2px)", `var(--ds-font-heading-xlarge, ${`600 2.0714285714285716em/1.103448275862069 ${fontFamily}`})`, "var(--ds-text, #292A2E)", "var(--ds-space-500, 40px)", `var(--ds-font-heading-large, ${`500 1.7142857142857142em/1.1666666666666667 ${fontFamily}`})`, "var(--ds-text, #292A2E)", "var(--ds-space-500, 40px)", `var(--ds-font-heading-medium, ${`500 1.4285714285714286em/1.2 ${fontFamily}`})`, "var(--ds-text, #292A2E)", `var(--ds-font-heading-small, ${`600 1.1428571428571428em/1.25 ${fontFamily}`})`, "var(--ds-text, #292A2E)", "var(--ds-space-300, 24px)", `var(--ds-font-heading-xsmall, ${`600 1em/1.1428571428571428 ${fontFamily}`})`, "var(--ds-text, #292A2E)", "var(--ds-space-200, 16px)", `var(--ds-font-heading-xxsmall, ${`600 0.8571428571428571em/1.3333333333333333 ${fontFamily}`})`, "var(--ds-text, #292A2E)", "var(--ds-space-250, 20px)", "var(--ds-space-500, 40px)", "var(--ds-space-050, 4px)", "var(--ds-space-050, 4px)", "var(--ds-space-500, 40px)", "var(--ds-space-500, 40px)", `var(--ds-font-body-small, ${`normal 400 11px/16px ${fontFamily}`})`, `var(--ds-font-family-code, ${`${codeFontFamily}`})`, "var(--ds-border-width, 1px)", "var(--ds-border, #ccc)");
exports.default = _default_1;

},{"./utils/evaluate-inner":"9glkl","@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"9glkl":[function(require,module,exports,__globalThis) {
/**
 * The below code is inspired by the css function in styled components
 * https://github.com/styled-components/styled-components/blob/master/packages/styled-components/src/types.js
 */ var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>evaluateInner);
function evaluateInner(styles, ...interpolations) {
    return flatten(interleave(styles, interpolations)).join('');
}
function interleave(strings, interpolations) {
    const result = [
        strings[0]
    ];
    for(let i = 0; i < interpolations.length; i++)result.push(interpolations[i], strings[i + 1]);
    return result;
}
function flatten(chunks, executionContext = {
    theme: {
        __ATLASKIT_THEME__: {
            mode: 'light'
        }
    }
}) {
    return chunks.reduce((ruleSet, chunk)=>{
        /* Remove falsey values */ if (chunk === undefined || chunk === null || chunk === false || chunk === '') return ruleSet;
        /* Flatten ruleSet */ if (Array.isArray(chunk)) {
            ruleSet.push(...flatten(chunk, executionContext));
            return ruleSet;
        }
        /* Either execute or defer the function */ if (typeof chunk === 'function') {
            if (executionContext) {
                const nextChunk = chunk(executionContext);
                ruleSet.push(...flatten([
                    nextChunk
                ], executionContext));
            } else ruleSet.push(chunk);
            return ruleSet;
        }
        // TODO: Fix bug in lint rule, this shouldn't be an error!
        ruleSet.push(isPlainObject(chunk) ? objToCss(chunk) : chunk.toString());
        return ruleSet;
    }, []);
}
function isPlainObject(x) {
    // TODO: Fix bug in lint rule, this shouldn't be an error!
    return typeof x === 'object' && x.constructor === Object;
}
function hyphenate(value) {
    const uppercasePattern = /([A-Z])/g;
    return value.replace(uppercasePattern, '-$1').toLowerCase();
}
function objToCss(obj, prevKey) {
    const css = Object.keys(obj).filter((key)=>{
        const chunk = obj[key];
        return chunk !== undefined && chunk !== null && chunk !== false && chunk !== '';
    }).map((key)=>{
        if (isPlainObject(obj[key])) return objToCss(obj[key], key);
        return `${hyphenate(key)}: ${obj[key]};`;
    }).join(' ');
    return prevKey ? `${prevKey} {
    ${css}
  }` : css;
}

},{"@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"hJiu2":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _evaluateInner = require("./utils/evaluate-inner");
var _evaluateInnerDefault = parcelHelpers.interopDefault(_evaluateInner);
let _ = (t)=>t, t;
const _default_1 = (0, _evaluateInnerDefault.default)(t || (t = _`
  /* IE11 and some older browsers don't support these elements yet and treat them as display: inline; */
  article,
  aside,
  details,
  figcaption,
  figure,
  footer,
  header,
  hgroup,
  main,
  menu,
  nav,
  section {
    display: block;
  }

  /* Suppress the ugly broken image styling in Firefox */
  @-moz-document url-prefix() {
    img {
      font-size: 0;
    }
    img:-moz-broken {
      font-size: inherit;
    }
  }

/*
  Chrome 83.0.4103.61 introduced a new user-agent style that broke all buttons for us. This default override reverts it.
  chrome user agent added this => font: 400 13.3333px Arial;
*/
button {
  font-family: inherit;
}
`));
exports.default = _default_1;

},{"./utils/evaluate-inner":"9glkl","@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"7FX3c":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _evaluateInner = require("./utils/evaluate-inner");
var _evaluateInnerDefault = parcelHelpers.interopDefault(_evaluateInner);
let _ = (t)=>t, t;
const _default_1 = (0, _evaluateInnerDefault.default)(t || (t = _`
  html,
  body,
  p,
  div,
  h1,
  h2,
  h3,
  h4,
  h5,
  h6,
  ul,
  ol,
  dl,
  img,
  pre,
  form,
  fieldset {
    margin: 0;
    padding: 0;
  }
  img,
  fieldset {
    border: 0;
  }
`));
exports.default = _default_1;

},{"./utils/evaluate-inner":"9glkl","@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"3Kfzf":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _evaluateInner = require("./utils/evaluate-inner");
var _evaluateInnerDefault = parcelHelpers.interopDefault(_evaluateInner);
let _ = (t)=>t, t;
const _default_1 = (0, _evaluateInnerDefault.default)(t || (t = _`
  table {
    border-collapse: collapse;
    width: 100%;
  }

  thead,
  tbody,
  tfoot {
    border-bottom: ${0} solid ${0};
  }

  td,
  th {
    border: none;
    padding: ${0} ${0};
    text-align: left;
  }

  th {
    vertical-align: top;
  }

  td:first-child,
	style:first-child + td,
  th:first-child,
	style:first-child + th {
    padding-left: 0;
  }

  td:last-child,
  th:last-child {
    padding-right: 0;
  }

  caption {
    font: ${0};
    letter-spacing: -0.008em;
    color: ${0};
    margin-top: 28px;
    margin-bottom: ${0};
    text-align: left;
  }
`), "var(--ds-border-width-selected, 2px)", "var(--ds-border, #DFE1E6)", "var(--ds-space-050, 4px)", "var(--ds-space-100, 8px)", "var(--ds-font-heading-medium, 500 1.4285714285714286em/1.2 ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, \"Helvetica Neue\", sans-serif)", "var(--ds-text, #292A2E)", "var(--ds-space-100, 8px)");
exports.default = _default_1;

},{"./utils/evaluate-inner":"9glkl","@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"h78ue":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _evaluateInner = require("./utils/evaluate-inner");
var _evaluateInnerDefault = parcelHelpers.interopDefault(_evaluateInner);
let _ = (t)=>t, t;
const _default_1 = (0, _evaluateInnerDefault.default)(t || (t = _`
  .assistive {
    border: 0 !important;
    clip: rect(1px, 1px, 1px, 1px) !important;
    height: 1px !important;
    overflow: hidden !important;
    padding: 0 !important;
    position: absolute !important;
    width: 1px !important;
    white-space: nowrap !important;
  }
`));
exports.default = _default_1;

},{"./utils/evaluate-inner":"9glkl","@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}],"ghEiL":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "defaultTheme", ()=>defaultTheme);
const defaultTheme = {
    colorMode: 'auto',
    dark: 'dark',
    light: 'light',
    spacing: 'spacing',
    typography: 'typography'
};

},{"@atlaspack/transformer-js/src/esmodule-helpers.js":"6QcHb"}]},["ji5m3","6hUoe"], "6hUoe", "parcelRequire3730")

//# sourceMappingURL=index.ca818e0e.js.map
